var kct = Object.defineProperty;
var Gct = (t, e, n) => e in t ? kct(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var Sr = (t, e, n) => (Gct(t, typeof e != "symbol" ? e + "" : e, n), n), Az = (t, e, n) => {
  if (!e.has(t))
    throw TypeError("Cannot " + n);
};
var Lo = (t, e, n) => (Az(t, e, "read from private field"), n ? n.call(t) : e.get(t)), bl = (t, e, n) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, n);
}, XA = (t, e, n, r) => (Az(t, e, "write to private field"), r ? r.call(t, n) : e.set(t, n), n);
var lz = (t, e, n) => (Az(t, e, "access private method"), n);
import * as le from "react";
import St, { Children as D3e, isValidElement as uD, cloneElement as D_, useReducer as T3e, useRef as Zr, useDebugValue as Uct, useEffect as Mn, useLayoutEffect as nse, createContext as Hct, createElement as yS, useContext as tT, useMemo as dt, useCallback as Qn, useState as mn, forwardRef as CE, useImperativeHandle as rse, PureComponent as ise, Component as N3e, Suspense as L3e } from "react";
import * as Ed from "react-dom";
import Sf from "react-dom";
function $ct(t, e) {
  for (var n = 0; n < e.length; n++) {
    const r = e[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const i in r)
        if (i !== "default" && !(i in t)) {
          const o = Object.getOwnPropertyDescriptor(r, i);
          o && Object.defineProperty(t, i, o.get ? o : {
            enumerable: !0,
            get: () => r[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
}
const Gn = {
  DESCRIPTION: "description",
  STATUS: "status",
  SCATTERPLOT: "scatterplot",
  SPATIAL: "spatial",
  SPATIAL_BETA: "spatialBeta",
  HEATMAP: "heatmap",
  LAYER_CONTROLLER: "layerController",
  LAYER_CONTROLLER_BETA: "layerControllerBeta",
  GENOMIC_PROFILES: "genomicProfiles",
  GATING: "gating",
  FEATURE_LIST: "featureList",
  OBS_SETS: "obsSets",
  OBS_SET_SIZES: "obsSetSizes",
  OBS_SET_FEATURE_VALUE_DISTRIBUTION: "obsSetFeatureValueDistribution",
  FEATURE_VALUE_HISTOGRAM: "featureValueHistogram"
}, tn = {
  OBS_LABELS: "obsLabels",
  OBS_EMBEDDING: "obsEmbedding",
  OBS_FEATURE_MATRIX: "obsFeatureMatrix",
  OBS_SETS: "obsSets",
  FEATURE_LABELS: "featureLabels",
  IMAGE: "image",
  OBS_SEGMENTATIONS: "obsSegmentations",
  NEIGHBORHOODS: "neighborhoods",
  GENOMIC_PROFILES: "genomic-profiles",
  OBS_SPOTS: "obsSpots",
  OBS_POINTS: "obsPoints",
  OBS_LOCATIONS: "obsLocations"
}, Ft = {
  // Joint file types
  ANNDATA_ZARR: "anndata.zarr",
  SPATIALDATA_ZARR: "spatialdata.zarr",
  // Atomic file types
  OBS_EMBEDDING_CSV: "obsEmbedding.csv",
  OBS_SPOTS_CSV: "obsSpots.csv",
  OBS_POINTS_CSV: "obsPoints.csv",
  OBS_LOCATIONS_CSV: "obsLocations.csv",
  OBS_LABELS_CSV: "obsLabels.csv",
  FEATURE_LABELS_CSV: "featureLabels.csv",
  OBS_FEATURE_MATRIX_CSV: "obsFeatureMatrix.csv",
  OBS_SEGMENTATIONS_JSON: "obsSegmentations.json",
  OBS_SETS_CSV: "obsSets.csv",
  OBS_SETS_JSON: "obsSets.json",
  // OME-Zarr
  IMAGE_OME_ZARR: "image.ome-zarr",
  OBS_SEGMENTATIONS_OME_ZARR: "obsSegmentations.ome-zarr",
  // AnnData
  OBS_FEATURE_MATRIX_ANNDATA_ZARR: "obsFeatureMatrix.anndata.zarr",
  OBS_SETS_ANNDATA_ZARR: "obsSets.anndata.zarr",
  OBS_EMBEDDING_ANNDATA_ZARR: "obsEmbedding.anndata.zarr",
  OBS_SPOTS_ANNDATA_ZARR: "obsSpots.anndata.zarr",
  OBS_POINTS_ANNDATA_ZARR: "obsPoints.anndata.zarr",
  OBS_LOCATIONS_ANNDATA_ZARR: "obsLocations.anndata.zarr",
  OBS_SEGMENTATIONS_ANNDATA_ZARR: "obsSegmentations.anndata.zarr",
  OBS_LABELS_ANNDATA_ZARR: "obsLabels.anndata.zarr",
  FEATURE_LABELS_ANNDATA_ZARR: "featureLabels.anndata.zarr",
  // SpatialData
  IMAGE_SPATIALDATA_ZARR: "image.spatialdata.zarr",
  LABELS_SPATIALDATA_ZARR: "labels.spatialdata.zarr",
  SHAPES_SPATIALDATA_ZARR: "shapes.spatialdata.zarr",
  OBS_FEATURE_MATRIX_SPATIALDATA_ZARR: "obsFeatureMatrix.spatialdata.zarr",
  OBS_SETS_SPATIALDATA_ZARR: "obsSets.spatialdata.zarr",
  OBS_SPOTS_SPATIALDATA_ZARR: "obsSpots.spatialdata.zarr",
  // TODO:
  // OBS_POINTS_SPATIALDATA_ZARR: 'obsPoints.spatialdata.zarr',
  // OBS_LOCATIONS_SPATIALDATA_ZARR: 'obsLocations.spatialdata.zarr',
  // MuData
  OBS_FEATURE_MATRIX_MUDATA_ZARR: "obsFeatureMatrix.mudata.zarr",
  OBS_SETS_MUDATA_ZARR: "obsSets.mudata.zarr",
  OBS_EMBEDDING_MUDATA_ZARR: "obsEmbedding.mudata.zarr",
  OBS_SPOTS_MUDATA_ZARR: "obsSpots.mudata.zarr",
  OBS_POINTS_MUDATA_ZARR: "obsPoints.mudata.zarr",
  OBS_LOCATIONS_MUDATA_ZARR: "obsLocations.mudata.zarr",
  OBS_SEGMENTATIONS_MUDATA_ZARR: "obsSegmentations.mudata.zarr",
  OBS_LABELS_MUDATA_ZARR: "obsLabels.mudata.zarr",
  FEATURE_LABELS_MUDATA_ZARR: "featureLabels.mudata.zarr",
  GENOMIC_PROFILES_ZARR: "genomic-profiles.zarr",
  NEIGHBORHOODS_JSON: "neighborhoods.json",
  // OME-TIFF
  IMAGE_OME_TIFF: "image.ome-tiff",
  OBS_SEGMENTATIONS_OME_TIFF: "obsSegmentations.ome-tiff",
  // New file types to support old file types:
  // - cells.json
  OBS_EMBEDDING_CELLS_JSON: "obsEmbedding.cells.json",
  OBS_SEGMENTATIONS_CELLS_JSON: "obsSegmentations.cells.json",
  OBS_LOCATIONS_CELLS_JSON: "obsLocations.cells.json",
  OBS_LABELS_CELLS_JSON: "obsLabels.cells.json",
  // - cell-sets.json
  OBS_SETS_CELL_SETS_JSON: "obsSets.cell-sets.json",
  // - genes.json
  OBS_FEATURE_MATRIX_GENES_JSON: "obsFeatureMatrix.genes.json",
  // - clusters.json
  OBS_FEATURE_MATRIX_CLUSTERS_JSON: "obsFeatureMatrix.clusters.json",
  // - expression-matrix.zarr
  OBS_FEATURE_MATRIX_EXPRESSION_MATRIX_ZARR: "obsFeatureMatrix.expression-matrix.zarr",
  // - raster.json
  IMAGE_RASTER_JSON: "image.raster.json",
  OBS_SEGMENTATIONS_RASTER_JSON: "obsSegmentations.raster.json",
  // - molecules.json
  OBS_LOCATIONS_MOLECULES_JSON: "obsLocations.molecules.json",
  OBS_LABELS_MOLECULES_JSON: "obsLabels.molecules.json",
  // Legacy joint file types
  CELLS_JSON: "cells.json",
  CELL_SETS_JSON: "cell-sets.json",
  ANNDATA_CELL_SETS_ZARR: "anndata-cell-sets.zarr",
  ANNDATA_CELLS_ZARR: "anndata-cells.zarr",
  EXPRESSION_MATRIX_ZARR: "expression-matrix.zarr",
  MOLECULES_JSON: "molecules.json",
  RASTER_JSON: "raster.json",
  RASTER_OME_ZARR: "raster.ome-zarr",
  CLUSTERS_JSON: "clusters.json",
  GENES_JSON: "genes.json",
  ANNDATA_EXPRESSION_MATRIX_ZARR: "anndata-expression-matrix.zarr"
}, re = {
  META_COORDINATION_SCOPES: "metaCoordinationScopes",
  META_COORDINATION_SCOPES_BY: "metaCoordinationScopesBy",
  DATASET: "dataset",
  // Entity types
  OBS_TYPE: "obsType",
  FEATURE_TYPE: "featureType",
  FEATURE_VALUE_TYPE: "featureValueType",
  OBS_LABELS_TYPE: "obsLabelsType",
  // Other types
  EMBEDDING_TYPE: "embeddingType",
  EMBEDDING_ZOOM: "embeddingZoom",
  EMBEDDING_ROTATION: "embeddingRotation",
  EMBEDDING_TARGET_X: "embeddingTargetX",
  EMBEDDING_TARGET_Y: "embeddingTargetY",
  EMBEDDING_TARGET_Z: "embeddingTargetZ",
  EMBEDDING_OBS_SET_POLYGONS_VISIBLE: "embeddingObsSetPolygonsVisible",
  EMBEDDING_OBS_SET_LABELS_VISIBLE: "embeddingObsSetLabelsVisible",
  EMBEDDING_OBS_SET_LABEL_SIZE: "embeddingObsSetLabelSize",
  EMBEDDING_OBS_RADIUS: "embeddingObsRadius",
  EMBEDDING_OBS_RADIUS_MODE: "embeddingObsRadiusMode",
  EMBEDDING_OBS_OPACITY: "embeddingObsOpacity",
  EMBEDDING_OBS_OPACITY_MODE: "embeddingObsOpacityMode",
  SPATIAL_ZOOM: "spatialZoom",
  SPATIAL_ROTATION: "spatialRotation",
  SPATIAL_TARGET_X: "spatialTargetX",
  SPATIAL_TARGET_Y: "spatialTargetY",
  SPATIAL_TARGET_Z: "spatialTargetZ",
  SPATIAL_TARGET_T: "spatialTargetT",
  SPATIAL_ROTATION_X: "spatialRotationX",
  SPATIAL_ROTATION_Y: "spatialRotationY",
  SPATIAL_ROTATION_Z: "spatialRotationZ",
  SPATIAL_ROTATION_ORBIT: "spatialRotationOrbit",
  SPATIAL_ORBIT_AXIS: "spatialOrbitAxis",
  SPATIAL_AXIS_FIXED: "spatialAxisFixed",
  HEATMAP_ZOOM_X: "heatmapZoomX",
  HEATMAP_ZOOM_Y: "heatmapZoomY",
  HEATMAP_TARGET_X: "heatmapTargetX",
  HEATMAP_TARGET_Y: "heatmapTargetY",
  OBS_FILTER: "obsFilter",
  OBS_HIGHLIGHT: "obsHighlight",
  OBS_SET_SELECTION: "obsSetSelection",
  OBS_SET_HIGHLIGHT: "obsSetHighlight",
  OBS_SET_EXPANSION: "obsSetExpansion",
  OBS_SET_COLOR: "obsSetColor",
  FEATURE_FILTER: "featureFilter",
  FEATURE_HIGHLIGHT: "featureHighlight",
  FEATURE_SELECTION: "featureSelection",
  FEATURE_VALUE_COLORMAP: "featureValueColormap",
  FEATURE_VALUE_TRANSFORM: "featureValueTransform",
  FEATURE_VALUE_COLORMAP_RANGE: "featureValueColormapRange",
  OBS_COLOR_ENCODING: "obsColorEncoding",
  SPATIAL_IMAGE_LAYER: "spatialImageLayer",
  SPATIAL_SEGMENTATION_LAYER: "spatialSegmentationLayer",
  SPATIAL_POINT_LAYER: "spatialPointLayer",
  SPATIAL_NEIGHBORHOOD_LAYER: "spatialNeighborhoodLayer",
  GENOMIC_ZOOM_X: "genomicZoomX",
  GENOMIC_ZOOM_Y: "genomicZoomY",
  GENOMIC_TARGET_X: "genomicTargetX",
  GENOMIC_TARGET_Y: "genomicTargetY",
  ADDITIONAL_OBS_SETS: "additionalObsSets",
  // TODO: use obsHighlight rather than moleculeHighlight.
  MOLECULE_HIGHLIGHT: "moleculeHighlight",
  GATING_FEATURE_SELECTION_X: "gatingFeatureSelectionX",
  GATING_FEATURE_SELECTION_Y: "gatingFeatureSelectionY",
  FEATURE_VALUE_TRANSFORM_COEFFICIENT: "featureValueTransformCoefficient",
  TOOLTIPS_VISIBLE: "tooltipsVisible",
  FILE_UID: "fileUid",
  IMAGE_LAYER: "imageLayer",
  IMAGE_CHANNEL: "imageChannel",
  SEGMENTATION_LAYER: "segmentationLayer",
  SEGMENTATION_CHANNEL: "segmentationChannel",
  SPATIAL_TARGET_C: "spatialTargetC",
  SPATIAL_LAYER_VISIBLE: "spatialLayerVisible",
  SPATIAL_LAYER_OPACITY: "spatialLayerOpacity",
  SPATIAL_LAYER_COLORMAP: "spatialLayerColormap",
  SPATIAL_LAYER_TRANSPARENT_COLOR: "spatialLayerTransparentColor",
  SPATIAL_LAYER_MODEL_MATRIX: "spatialLayerModelMatrix",
  SPATIAL_SEGMENTATION_FILLED: "spatialSegmentationFilled",
  SPATIAL_SEGMENTATION_STROKE_WIDTH: "spatialSegmentationStrokeWidth",
  SPATIAL_CHANNEL_COLOR: "spatialChannelColor",
  SPATIAL_CHANNEL_VISIBLE: "spatialChannelVisible",
  SPATIAL_CHANNEL_OPACITY: "spatialChannelOpacity",
  SPATIAL_CHANNEL_WINDOW: "spatialChannelWindow",
  PHOTOMETRIC_INTERPRETATION: "photometricInterpretation",
  // For 3D volume rendering
  SPATIAL_RENDERING_MODE: "spatialRenderingMode",
  VOLUMETRIC_RENDERING_ALGORITHM: "volumetricRenderingAlgorithm",
  SPATIAL_TARGET_RESOLUTION: "spatialTargetResolution",
  // For clipping plane sliders
  SPATIAL_SLICE_X: "spatialSliceX",
  SPATIAL_SLICE_Y: "spatialSliceY",
  SPATIAL_SLICE_Z: "spatialSliceZ",
  // For spatial spot and point layers
  SPOT_LAYER: "spotLayer",
  POINT_LAYER: "pointLayer",
  SPATIAL_SPOT_RADIUS: "spatialSpotRadius",
  SPATIAL_SPOT_FILLED: "spatialSpotFilled",
  SPATIAL_SPOT_STROKE_WIDTH: "spatialSpotStrokeWidth",
  SPATIAL_LAYER_COLOR: "spatialLayerColor",
  PIXEL_HIGHLIGHT: "pixelHighlight",
  TOOLTIP_CROSSHAIRS_VISIBLE: "tooltipCrosshairsVisible",
  LEGEND_VISIBLE: "legendVisible",
  SPATIAL_CHANNEL_LABELS_VISIBLE: "spatialChannelLabelsVisible",
  SPATIAL_CHANNEL_LABELS_ORIENTATION: "spatialChannelLabelsOrientation",
  SPATIAL_CHANNEL_LABEL_SIZE: "spatialChannelLabelSize"
}, Ra = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error"
}, qct = {
  [tn.OBS_SEGMENTATIONS]: [
    re.FILE_UID,
    re.OBS_TYPE
  ],
  [tn.OBS_EMBEDDING]: [
    re.OBS_TYPE,
    re.EMBEDDING_TYPE
  ],
  [tn.OBS_SPOTS]: [
    re.OBS_TYPE
  ],
  [tn.OBS_POINTS]: [
    re.OBS_TYPE
  ],
  [tn.OBS_LOCATIONS]: [
    re.OBS_TYPE
  ],
  [tn.OBS_LABELS]: [
    re.OBS_TYPE,
    re.OBS_LABELS_TYPE
  ],
  [tn.FEATURE_LABELS]: [
    re.FEATURE_TYPE
  ],
  [tn.OBS_SETS]: [
    re.OBS_TYPE
  ],
  [tn.OBS_FEATURE_MATRIX]: [
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE
  ],
  [tn.GENOMIC_PROFILES]: [],
  [tn.IMAGE]: [
    re.FILE_UID
  ],
  [tn.NEIGHBORHOODS]: []
}, jct = [
  re.HEATMAP_ZOOM_X,
  re.HEATMAP_ZOOM_Y,
  re.HEATMAP_TARGET_X,
  re.HEATMAP_TARGET_Y,
  re.EMBEDDING_ZOOM,
  re.EMBEDDING_TARGET_X,
  re.EMBEDDING_TARGET_Y,
  re.EMBEDDING_TARGET_Z,
  re.EMBEDDING_OBS_SET_POLYGONS_VISIBLE,
  re.EMBEDDING_OBS_SET_LABELS_VISIBLE,
  re.EMBEDDING_OBS_SET_LABEL_SIZE,
  re.EMBEDDING_OBS_RADIUS,
  re.EMBEDDING_OBS_OPACITY
], ea = {
  [Gn.SCATTERPLOT]: [
    re.DATASET,
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE,
    re.OBS_LABELS_TYPE,
    re.EMBEDDING_TYPE,
    re.EMBEDDING_ZOOM,
    re.EMBEDDING_ROTATION,
    re.EMBEDDING_TARGET_X,
    re.EMBEDDING_TARGET_Y,
    re.EMBEDDING_TARGET_Z,
    re.EMBEDDING_OBS_SET_POLYGONS_VISIBLE,
    re.EMBEDDING_OBS_SET_LABELS_VISIBLE,
    re.EMBEDDING_OBS_SET_LABEL_SIZE,
    re.EMBEDDING_OBS_RADIUS,
    re.EMBEDDING_OBS_RADIUS_MODE,
    re.EMBEDDING_OBS_OPACITY,
    re.EMBEDDING_OBS_OPACITY_MODE,
    re.OBS_FILTER,
    re.OBS_HIGHLIGHT,
    re.OBS_SET_SELECTION,
    re.OBS_SET_HIGHLIGHT,
    re.OBS_SET_COLOR,
    re.FEATURE_HIGHLIGHT,
    re.FEATURE_SELECTION,
    re.FEATURE_VALUE_COLORMAP,
    re.FEATURE_VALUE_COLORMAP_RANGE,
    re.OBS_COLOR_ENCODING,
    re.ADDITIONAL_OBS_SETS,
    re.TOOLTIPS_VISIBLE
  ],
  [Gn.GATING]: [
    re.DATASET,
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE,
    re.EMBEDDING_TYPE,
    re.EMBEDDING_ZOOM,
    re.EMBEDDING_ROTATION,
    re.EMBEDDING_TARGET_X,
    re.EMBEDDING_TARGET_Y,
    re.EMBEDDING_TARGET_Z,
    re.EMBEDDING_OBS_SET_POLYGONS_VISIBLE,
    re.EMBEDDING_OBS_SET_LABELS_VISIBLE,
    re.EMBEDDING_OBS_SET_LABEL_SIZE,
    re.EMBEDDING_OBS_RADIUS,
    re.EMBEDDING_OBS_RADIUS_MODE,
    re.EMBEDDING_OBS_OPACITY,
    re.EMBEDDING_OBS_OPACITY_MODE,
    re.OBS_FILTER,
    re.OBS_HIGHLIGHT,
    re.OBS_SET_SELECTION,
    re.OBS_SET_HIGHLIGHT,
    re.OBS_SET_COLOR,
    re.FEATURE_HIGHLIGHT,
    re.FEATURE_SELECTION,
    re.FEATURE_VALUE_COLORMAP,
    re.FEATURE_VALUE_COLORMAP_RANGE,
    re.OBS_COLOR_ENCODING,
    re.ADDITIONAL_OBS_SETS,
    re.FEATURE_VALUE_TRANSFORM,
    re.FEATURE_VALUE_TRANSFORM_COEFFICIENT,
    re.GATING_FEATURE_SELECTION_X,
    re.GATING_FEATURE_SELECTION_Y
  ],
  [Gn.SPATIAL]: [
    re.DATASET,
    re.OBS_TYPE,
    re.OBS_LABELS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE,
    re.SPATIAL_ZOOM,
    re.SPATIAL_ROTATION,
    re.SPATIAL_IMAGE_LAYER,
    re.SPATIAL_SEGMENTATION_LAYER,
    re.SPATIAL_POINT_LAYER,
    re.SPATIAL_NEIGHBORHOOD_LAYER,
    re.SPATIAL_TARGET_X,
    re.SPATIAL_TARGET_Y,
    re.SPATIAL_TARGET_Z,
    re.SPATIAL_ROTATION_X,
    re.SPATIAL_ROTATION_Y,
    re.SPATIAL_ROTATION_Z,
    re.SPATIAL_ROTATION_ORBIT,
    re.SPATIAL_ORBIT_AXIS,
    re.SPATIAL_AXIS_FIXED,
    re.OBS_FILTER,
    re.OBS_HIGHLIGHT,
    re.OBS_SET_SELECTION,
    re.OBS_SET_HIGHLIGHT,
    re.OBS_SET_COLOR,
    re.FEATURE_HIGHLIGHT,
    re.FEATURE_SELECTION,
    re.FEATURE_VALUE_COLORMAP,
    re.FEATURE_VALUE_COLORMAP_RANGE,
    re.OBS_COLOR_ENCODING,
    re.ADDITIONAL_OBS_SETS,
    re.MOLECULE_HIGHLIGHT,
    re.TOOLTIPS_VISIBLE
  ],
  [Gn.SPATIAL_BETA]: [
    re.META_COORDINATION_SCOPES,
    re.META_COORDINATION_SCOPES_BY,
    re.DATASET,
    re.OBS_TYPE,
    re.OBS_LABELS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE,
    re.SPATIAL_ZOOM,
    re.SPATIAL_ROTATION,
    re.SPATIAL_POINT_LAYER,
    re.SPATIAL_NEIGHBORHOOD_LAYER,
    re.SPATIAL_TARGET_X,
    re.SPATIAL_TARGET_Y,
    re.SPATIAL_TARGET_Z,
    re.SPATIAL_TARGET_T,
    re.SPATIAL_ROTATION_X,
    re.SPATIAL_ROTATION_Y,
    re.SPATIAL_ROTATION_Z,
    re.SPATIAL_ROTATION_ORBIT,
    re.SPATIAL_ORBIT_AXIS,
    re.SPATIAL_AXIS_FIXED,
    re.OBS_FILTER,
    re.OBS_HIGHLIGHT,
    re.OBS_SET_SELECTION,
    re.OBS_SET_HIGHLIGHT,
    re.OBS_SET_COLOR,
    re.FEATURE_HIGHLIGHT,
    re.FEATURE_SELECTION,
    re.FEATURE_VALUE_COLORMAP,
    re.FEATURE_VALUE_COLORMAP_RANGE,
    re.OBS_COLOR_ENCODING,
    re.ADDITIONAL_OBS_SETS,
    re.MOLECULE_HIGHLIGHT,
    re.TOOLTIPS_VISIBLE,
    re.FILE_UID,
    re.SPATIAL_TARGET_C,
    re.SPATIAL_LAYER_VISIBLE,
    re.SPATIAL_LAYER_OPACITY,
    re.SPATIAL_LAYER_COLORMAP,
    re.SPATIAL_LAYER_TRANSPARENT_COLOR,
    re.SPATIAL_LAYER_MODEL_MATRIX,
    re.SPATIAL_CHANNEL_COLOR,
    re.SPATIAL_SEGMENTATION_FILLED,
    re.SPATIAL_SEGMENTATION_STROKE_WIDTH,
    re.IMAGE_LAYER,
    re.SEGMENTATION_LAYER,
    re.IMAGE_CHANNEL,
    re.SEGMENTATION_CHANNEL,
    re.SPATIAL_CHANNEL_VISIBLE,
    re.SPATIAL_CHANNEL_OPACITY,
    re.SPATIAL_CHANNEL_WINDOW,
    re.SPATIAL_RENDERING_MODE,
    re.VOLUMETRIC_RENDERING_ALGORITHM,
    re.SPATIAL_TARGET_RESOLUTION,
    re.SPATIAL_SLICE_X,
    re.SPATIAL_SLICE_Y,
    re.SPATIAL_SLICE_Z,
    re.SPOT_LAYER,
    re.POINT_LAYER,
    re.SPATIAL_SPOT_RADIUS,
    re.SPATIAL_SPOT_FILLED,
    re.SPATIAL_SPOT_STROKE_WIDTH,
    re.SPATIAL_LAYER_COLOR,
    re.PIXEL_HIGHLIGHT,
    re.TOOLTIP_CROSSHAIRS_VISIBLE,
    re.LEGEND_VISIBLE,
    re.SPATIAL_CHANNEL_LABELS_VISIBLE,
    re.SPATIAL_CHANNEL_LABELS_ORIENTATION,
    re.SPATIAL_CHANNEL_LABEL_SIZE
  ],
  [Gn.HEATMAP]: [
    re.DATASET,
    re.OBS_TYPE,
    re.OBS_LABELS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE,
    re.HEATMAP_ZOOM_X,
    re.HEATMAP_ZOOM_Y,
    re.HEATMAP_TARGET_X,
    re.HEATMAP_TARGET_Y,
    re.OBS_FILTER,
    re.OBS_HIGHLIGHT,
    re.OBS_SET_SELECTION,
    re.OBS_SET_HIGHLIGHT,
    re.OBS_SET_COLOR,
    re.FEATURE_FILTER,
    re.FEATURE_HIGHLIGHT,
    re.FEATURE_SELECTION,
    re.FEATURE_VALUE_COLORMAP,
    re.FEATURE_VALUE_COLORMAP_RANGE,
    re.OBS_COLOR_ENCODING,
    re.ADDITIONAL_OBS_SETS,
    re.TOOLTIPS_VISIBLE
  ],
  [Gn.OBS_SETS]: [
    re.DATASET,
    re.OBS_TYPE,
    re.OBS_SET_SELECTION,
    re.OBS_SET_EXPANSION,
    re.OBS_SET_HIGHLIGHT,
    re.OBS_SET_COLOR,
    re.OBS_COLOR_ENCODING,
    re.ADDITIONAL_OBS_SETS,
    re.FEATURE_SELECTION
  ],
  [Gn.OBS_SET_SIZES]: [
    re.DATASET,
    re.OBS_TYPE,
    re.OBS_SET_SELECTION,
    re.OBS_SET_EXPANSION,
    re.OBS_SET_HIGHLIGHT,
    re.OBS_SET_COLOR,
    re.ADDITIONAL_OBS_SETS
  ],
  [Gn.STATUS]: [
    re.DATASET,
    re.OBS_HIGHLIGHT,
    re.FEATURE_HIGHLIGHT,
    re.OBS_SET_HIGHLIGHT,
    re.MOLECULE_HIGHLIGHT
  ],
  [Gn.FEATURE_LIST]: [
    re.DATASET,
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE,
    re.FEATURE_FILTER,
    re.FEATURE_HIGHLIGHT,
    re.FEATURE_SELECTION,
    re.OBS_COLOR_ENCODING,
    re.OBS_SET_SELECTION
  ],
  [Gn.OBS_SET_FEATURE_VALUE_DISTRIBUTION]: [
    re.DATASET,
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE,
    re.FEATURE_SELECTION,
    re.FEATURE_VALUE_TRANSFORM,
    re.FEATURE_VALUE_TRANSFORM_COEFFICIENT,
    re.OBS_SET_SELECTION,
    re.OBS_SET_HIGHLIGHT,
    re.OBS_SET_COLOR,
    re.ADDITIONAL_OBS_SETS
  ],
  [Gn.FEATURE_VALUE_HISTOGRAM]: [
    re.DATASET,
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE,
    re.FEATURE_SELECTION,
    re.ADDITIONAL_OBS_SETS,
    re.OBS_SET_COLOR,
    re.OBS_COLOR_ENCODING,
    re.OBS_SET_SELECTION
  ],
  [Gn.LAYER_CONTROLLER]: [
    re.DATASET,
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE,
    re.SPATIAL_IMAGE_LAYER,
    re.SPATIAL_SEGMENTATION_LAYER,
    re.SPATIAL_POINT_LAYER,
    re.SPATIAL_NEIGHBORHOOD_LAYER,
    re.SPATIAL_ZOOM,
    re.SPATIAL_TARGET_X,
    re.SPATIAL_TARGET_Y,
    re.SPATIAL_TARGET_Z,
    re.SPATIAL_ROTATION_X,
    re.SPATIAL_ROTATION_Y,
    re.SPATIAL_ROTATION_Z,
    re.SPATIAL_ROTATION_ORBIT,
    re.SPATIAL_ORBIT_AXIS
  ],
  [Gn.LAYER_CONTROLLER_BETA]: [
    re.META_COORDINATION_SCOPES,
    re.META_COORDINATION_SCOPES_BY,
    re.DATASET,
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE,
    re.SPATIAL_POINT_LAYER,
    re.SPATIAL_NEIGHBORHOOD_LAYER,
    re.SPATIAL_ZOOM,
    re.SPATIAL_TARGET_X,
    re.SPATIAL_TARGET_Y,
    re.SPATIAL_TARGET_Z,
    re.SPATIAL_TARGET_T,
    re.SPATIAL_ROTATION_X,
    re.SPATIAL_ROTATION_Y,
    re.SPATIAL_ROTATION_Z,
    re.SPATIAL_ROTATION_ORBIT,
    re.SPATIAL_ORBIT_AXIS,
    re.FILE_UID,
    re.SPATIAL_TARGET_C,
    re.SPATIAL_LAYER_VISIBLE,
    re.SPATIAL_LAYER_OPACITY,
    re.SPATIAL_LAYER_COLORMAP,
    re.SPATIAL_LAYER_TRANSPARENT_COLOR,
    re.SPATIAL_LAYER_MODEL_MATRIX,
    re.SPATIAL_CHANNEL_COLOR,
    re.SPATIAL_SEGMENTATION_FILLED,
    re.SPATIAL_SEGMENTATION_STROKE_WIDTH,
    re.IMAGE_CHANNEL,
    re.IMAGE_LAYER,
    re.SEGMENTATION_CHANNEL,
    re.SEGMENTATION_LAYER,
    re.SPATIAL_CHANNEL_VISIBLE,
    re.SPATIAL_CHANNEL_OPACITY,
    re.SPATIAL_CHANNEL_WINDOW,
    re.PHOTOMETRIC_INTERPRETATION,
    re.SPATIAL_RENDERING_MODE,
    re.VOLUMETRIC_RENDERING_ALGORITHM,
    re.SPATIAL_TARGET_RESOLUTION,
    re.SPATIAL_SLICE_X,
    re.SPATIAL_SLICE_Y,
    re.SPATIAL_SLICE_Z,
    re.SPOT_LAYER,
    re.POINT_LAYER,
    re.SPATIAL_SPOT_RADIUS,
    re.SPATIAL_SPOT_FILLED,
    re.SPATIAL_SPOT_STROKE_WIDTH,
    re.SPATIAL_LAYER_COLOR,
    re.OBS_COLOR_ENCODING,
    re.FEATURE_VALUE_COLORMAP,
    re.FEATURE_VALUE_COLORMAP_RANGE,
    re.FEATURE_SELECTION,
    re.TOOLTIPS_VISIBLE,
    re.TOOLTIP_CROSSHAIRS_VISIBLE,
    re.LEGEND_VISIBLE,
    re.SPATIAL_CHANNEL_LABELS_VISIBLE,
    re.SPATIAL_CHANNEL_LABELS_ORIENTATION,
    re.SPATIAL_CHANNEL_LABEL_SIZE
  ],
  [Gn.GENOMIC_PROFILES]: [
    re.DATASET,
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE,
    re.GENOMIC_ZOOM_X,
    re.GENOMIC_ZOOM_Y,
    re.GENOMIC_TARGET_X,
    re.GENOMIC_TARGET_Y,
    re.FEATURE_FILTER,
    re.FEATURE_HIGHLIGHT,
    re.FEATURE_SELECTION,
    re.OBS_SET_SELECTION,
    re.OBS_SET_HIGHLIGHT,
    re.OBS_SET_COLOR,
    re.ADDITIONAL_OBS_SETS
  ],
  [Gn.DESCRIPTION]: [
    re.DATASET,
    re.SPATIAL_IMAGE_LAYER
  ],
  higlass: [
    re.DATASET,
    re.GENOMIC_ZOOM_X,
    re.GENOMIC_ZOOM_Y,
    re.GENOMIC_TARGET_X,
    re.GENOMIC_TARGET_Y,
    re.FEATURE_FILTER,
    re.FEATURE_HIGHLIGHT,
    re.FEATURE_SELECTION
  ]
}, Yct = "This file is autogenerated by .changeset/post-changelog.mjs.", zct = "3.3.4", Vct = "2024-01-28", Jct = "changeset-release/main", Kct = "3b0bc6a0", Wct = {
  note: Yct,
  version: zct,
  date: Vct,
  branch: Jct,
  hash: Kct
}, Xct = {
  GENES: [
    "genes",
    "This view type was renamed to featureList in schema version 1.0.15."
  ],
  CELL_SETS: [
    "cellSets",
    "This view type was renamed to obsSets in schema version 1.0.15."
  ],
  CELL_SET_SIZES: [
    "cellSetSizes",
    "This view type was renamed to obsSetSizes in schema version 1.0.15."
  ],
  CELL_SET_EXPRESSION: [
    "cellSetExpression",
    "This view type was renamed to obsSetFeatureValueDistribution in schema version 1.0.15."
  ],
  EXPRESSION_HISTOGRAM: [
    "expressionHistogram",
    "This view type was renamed to featureValueHistogram in schema version 1.0.15."
  ]
}, Zct = {
  CELLS: [
    "cells",
    "This data type was removed. Associated file types were re-implemented as joint file types. See obsEmbedding instead."
  ],
  CELL_SETS: [
    "cell-sets",
    "This data type was removed. Associated file types were re-implemented as joint file types. See obsSets instead."
  ],
  EXPRESSION_MATRIX: [
    "expression-matrix",
    "This data type was removed. Associated file types were re-implemented as joint file types. See obsFeatureMatrix instead."
  ],
  MOLECULES: [
    "molecules",
    "This data type was removed. Associated file types were re-implemented as joint file types. See obsLocations instead."
  ],
  RASTER: [
    "raster",
    "This data type was removed. Associated file types were re-implemented as joint file types. See image and obsSegmentations instead."
  ]
}, eut = {};
function Ss(t, e) {
  return [
    `This coordination type was changed to ${t} in view config schema version ${e}`,
    e,
    t
  ];
}
const tk = {
  SPATIAL_LAYERS: [
    "spatialLayers",
    "This coordination type was split into multiple coordination types in view config schema version 1.0.1",
    "1.0.1",
    "multiple"
    // Not used for spatialLayers (since it was split into multiple).
  ],
  // Spatial layers
  SPATIAL_RASTER_LAYERS: [
    "spatialRasterLayers",
    ...Ss("spatialImageLayer", "1.0.11")
  ],
  SPATIAL_CELLS_LAYER: [
    "spatialCellsLayer",
    ...Ss("spatialSegmentationLayer", "1.0.11")
  ],
  SPATIAL_MOLECULES_LAYER: [
    "spatialMoleculesLayer",
    ...Ss("spatialPointLayer", "1.0.11")
  ],
  SPATIAL_NEIGHBORHOODS_LAYER: [
    "spatialNeighborhoodsLayer",
    ...Ss("spatialNeighborhoodLayer", "1.0.11")
  ],
  // Cell -> Obs
  EMBEDDING_CELL_SET_POLYGONS_VISIBLE: [
    "embeddingCellSetPolygonsVisible",
    ...Ss("embeddingObsSetPolygonsVisible", "1.0.11")
  ],
  EMBEDDING_CELL_SET_LABELS_VISIBLE: [
    "embeddingCellSetLabelsVisible",
    ...Ss("embeddingObsSetLabelsVisible", "1.0.11")
  ],
  EMBEDDING_CELL_SET_LABEL_SIZE: [
    "embeddingCellSetLabelSize",
    ...Ss("embeddingObsSetLabelSize", "1.0.11")
  ],
  EMBEDDING_CELL_RADIUS: [
    "embeddingCellRadius",
    ...Ss("embeddingObsRadius", "1.0.11")
  ],
  EMBEDDING_CELL_RADIUS_MODE: [
    "embeddingCellRadiusMode",
    ...Ss("embeddingObsRadiusMode", "1.0.11")
  ],
  EMBEDDING_CELL_OPACITY: [
    "embeddingCellOpacity",
    ...Ss("embeddingObsOpacity", "1.0.11")
  ],
  EMBEDDING_CELL_OPACITY_MODE: [
    "embeddingCellOpacityMode",
    ...Ss("embeddingObsOpacityMode", "1.0.11")
  ],
  CELL_FILTER: [
    "cellFilter",
    ...Ss("obsFilter", "1.0.11")
  ],
  CELL_HIGHLIGHT: [
    "cellHighlight",
    ...Ss("obsHighlight", "1.0.11")
  ],
  CELL_SET_SELECTION: [
    "cellSetSelection",
    ...Ss("obsSetSelection", "1.0.11")
  ],
  CELL_SET_HIGHLIGHT: [
    "cellSetHighlight",
    ...Ss("obsSetHighlight", "1.0.11")
  ],
  CELL_SET_COLOR: [
    "cellSetColor",
    ...Ss("obsSetColor", "1.0.11")
  ],
  CELL_COLOR_ENCODING: [
    "cellColorEncoding",
    ...Ss("obsColorEncoding", "1.0.11")
  ],
  ADDITIONAL_CELL_SETS: [
    "additionalCellSets",
    ...Ss("additionalObsSets", "1.0.11")
  ],
  // Gene -> Feature
  GENE_FILTER: [
    "geneFilter",
    ...Ss("featureFilter", "1.0.11")
  ],
  GENE_HIGHLIGHT: [
    "geneHighlight",
    ...Ss("featureHighlight", "1.0.11")
  ],
  GENE_SELECTION: [
    "geneSelection",
    ...Ss("featureSelection", "1.0.11")
  ],
  GENE_EXPRESSION_COLORMAP: [
    "geneExpressionColormap",
    ...Ss("featureValueColormap", "1.0.11")
  ],
  GENE_EXPRESSION_TRANSFORM: [
    "geneExpressionTransform",
    ...Ss("featureValueTransform", "1.0.11")
  ],
  GENE_EXPRESSION_COLORMAP_RANGE: [
    "geneExpressionColormapRange",
    ...Ss("featureValueColormapRange", "1.0.11")
  ]
};
function W6(t, e) {
  const n = {
    get(i, o) {
      return Object.keys(e).includes(o) ? (console.warn(`Notice about the constant mapping ${o}: '${e[o][0]}':
${e[o][1]}`), e[o]) : i[o];
    }
  };
  return new Proxy(t, n);
}
const cLr = W6(Gn, Xct), uLr = W6(tn, Zct), fLr = W6(Ft, eut), gLr = W6(re, tk);
var ei = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ko(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Fs(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      if (this instanceof r) {
        var i = [null];
        i.push.apply(i, arguments);
        var o = Function.bind.apply(e, i);
        return new o();
      }
      return e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
function M3e(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var O3e = { exports: {} };
(function(t, e) {
  (function(n, r) {
    typeof M3e == "function" ? t.exports = r() : n.pluralize = r();
  })(ei, function() {
    var n = [], r = [], i = {}, o = {}, s = {};
    function a(I) {
      return typeof I == "string" ? new RegExp("^" + I + "$", "i") : I;
    }
    function A(I, m) {
      return I === m ? m : I === I.toLowerCase() ? m.toLowerCase() : I === I.toUpperCase() ? m.toUpperCase() : I[0] === I[0].toUpperCase() ? m.charAt(0).toUpperCase() + m.substr(1).toLowerCase() : m.toLowerCase();
    }
    function l(I, m) {
      return I.replace(/\$(\d{1,2})/g, function(C, y) {
        return m[y] || "";
      });
    }
    function c(I, m) {
      return I.replace(m[0], function(C, y) {
        var v = l(m[1], arguments);
        return A(C === "" ? I[y - 1] : C, v);
      });
    }
    function u(I, m, C) {
      if (!I.length || i.hasOwnProperty(I))
        return m;
      for (var y = C.length; y--; ) {
        var v = C[y];
        if (v[0].test(m))
          return c(m, v);
      }
      return m;
    }
    function f(I, m, C) {
      return function(y) {
        var v = y.toLowerCase();
        return m.hasOwnProperty(v) ? A(y, v) : I.hasOwnProperty(v) ? A(y, I[v]) : u(v, y, C);
      };
    }
    function h(I, m, C, y) {
      return function(v) {
        var b = v.toLowerCase();
        return m.hasOwnProperty(b) ? !0 : I.hasOwnProperty(b) ? !1 : u(b, b, C) === b;
      };
    }
    function d(I, m, C) {
      var y = m === 1 ? d.singular(I) : d.plural(I);
      return (C ? m + " " : "") + y;
    }
    return d.plural = f(
      s,
      o,
      n
    ), d.isPlural = h(
      s,
      o,
      n
    ), d.singular = f(
      o,
      s,
      r
    ), d.isSingular = h(
      o,
      s,
      r
    ), d.addPluralRule = function(I, m) {
      n.push([a(I), m]);
    }, d.addSingularRule = function(I, m) {
      r.push([a(I), m]);
    }, d.addUncountableRule = function(I) {
      if (typeof I == "string") {
        i[I.toLowerCase()] = !0;
        return;
      }
      d.addPluralRule(I, "$0"), d.addSingularRule(I, "$0");
    }, d.addIrregularRule = function(I, m) {
      m = m.toLowerCase(), I = I.toLowerCase(), s[I] = m, o[m] = I;
    }, [
      // Pronouns.
      ["I", "we"],
      ["me", "us"],
      ["he", "they"],
      ["she", "they"],
      ["them", "them"],
      ["myself", "ourselves"],
      ["yourself", "yourselves"],
      ["itself", "themselves"],
      ["herself", "themselves"],
      ["himself", "themselves"],
      ["themself", "themselves"],
      ["is", "are"],
      ["was", "were"],
      ["has", "have"],
      ["this", "these"],
      ["that", "those"],
      // Words ending in with a consonant and `o`.
      ["echo", "echoes"],
      ["dingo", "dingoes"],
      ["volcano", "volcanoes"],
      ["tornado", "tornadoes"],
      ["torpedo", "torpedoes"],
      // Ends with `us`.
      ["genus", "genera"],
      ["viscus", "viscera"],
      // Ends with `ma`.
      ["stigma", "stigmata"],
      ["stoma", "stomata"],
      ["dogma", "dogmata"],
      ["lemma", "lemmata"],
      ["schema", "schemata"],
      ["anathema", "anathemata"],
      // Other irregular rules.
      ["ox", "oxen"],
      ["axe", "axes"],
      ["die", "dice"],
      ["yes", "yeses"],
      ["foot", "feet"],
      ["eave", "eaves"],
      ["goose", "geese"],
      ["tooth", "teeth"],
      ["quiz", "quizzes"],
      ["human", "humans"],
      ["proof", "proofs"],
      ["carve", "carves"],
      ["valve", "valves"],
      ["looey", "looies"],
      ["thief", "thieves"],
      ["groove", "grooves"],
      ["pickaxe", "pickaxes"],
      ["passerby", "passersby"]
    ].forEach(function(I) {
      return d.addIrregularRule(I[0], I[1]);
    }), [
      [/s?$/i, "s"],
      [/[^\u0000-\u007F]$/i, "$0"],
      [/([^aeiou]ese)$/i, "$1"],
      [/(ax|test)is$/i, "$1es"],
      [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
      [/(e[mn]u)s?$/i, "$1s"],
      [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
      [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"],
      [/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
      [/(seraph|cherub)(?:im)?$/i, "$1im"],
      [/(her|at|gr)o$/i, "$1oes"],
      [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"],
      [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"],
      [/sis$/i, "ses"],
      [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
      [/([^aeiouy]|qu)y$/i, "$1ies"],
      [/([^ch][ieo][ln])ey$/i, "$1ies"],
      [/(x|ch|ss|sh|zz)$/i, "$1es"],
      [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
      [/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
      [/(pe)(?:rson|ople)$/i, "$1ople"],
      [/(child)(?:ren)?$/i, "$1ren"],
      [/eaux$/i, "$0"],
      [/m[ae]n$/i, "men"],
      ["thou", "you"]
    ].forEach(function(I) {
      return d.addPluralRule(I[0], I[1]);
    }), [
      [/s$/i, ""],
      [/(ss)$/i, "$1"],
      [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
      [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
      [/ies$/i, "y"],
      [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"],
      [/\b(mon|smil)ies$/i, "$1ey"],
      [/\b((?:tit)?m|l)ice$/i, "$1ouse"],
      [/(seraph|cherub)im$/i, "$1"],
      [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"],
      [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"],
      [/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
      [/(test)(?:is|es)$/i, "$1is"],
      [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"],
      [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"],
      [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"],
      [/(alumn|alg|vertebr)ae$/i, "$1a"],
      [/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
      [/(matr|append)ices$/i, "$1ix"],
      [/(pe)(rson|ople)$/i, "$1rson"],
      [/(child)ren$/i, "$1"],
      [/(eau)x?$/i, "$1"],
      [/men$/i, "man"]
    ].forEach(function(I) {
      return d.addSingularRule(I[0], I[1]);
    }), [
      // Singular words with no plurals.
      "adulthood",
      "advice",
      "agenda",
      "aid",
      "aircraft",
      "alcohol",
      "ammo",
      "analytics",
      "anime",
      "athletics",
      "audio",
      "bison",
      "blood",
      "bream",
      "buffalo",
      "butter",
      "carp",
      "cash",
      "chassis",
      "chess",
      "clothing",
      "cod",
      "commerce",
      "cooperation",
      "corps",
      "debris",
      "diabetes",
      "digestion",
      "elk",
      "energy",
      "equipment",
      "excretion",
      "expertise",
      "firmware",
      "flounder",
      "fun",
      "gallows",
      "garbage",
      "graffiti",
      "hardware",
      "headquarters",
      "health",
      "herpes",
      "highjinks",
      "homework",
      "housework",
      "information",
      "jeans",
      "justice",
      "kudos",
      "labour",
      "literature",
      "machinery",
      "mackerel",
      "mail",
      "media",
      "mews",
      "moose",
      "music",
      "mud",
      "manga",
      "news",
      "only",
      "personnel",
      "pike",
      "plankton",
      "pliers",
      "police",
      "pollution",
      "premises",
      "rain",
      "research",
      "rice",
      "salmon",
      "scissors",
      "series",
      "sewage",
      "shambles",
      "shrimp",
      "software",
      "species",
      "staff",
      "swine",
      "tennis",
      "traffic",
      "transportation",
      "trout",
      "tuna",
      "wealth",
      "welfare",
      "whiting",
      "wildebeest",
      "wildlife",
      "you",
      /pok[eé]mon$/i,
      // Regexes.
      /[^aeiou]ese$/i,
      // "chinese", "japanese"
      /deer$/i,
      // "deer", "reindeer"
      /fish$/i,
      // "fish", "blowfish", "angelfish"
      /measles$/i,
      /o[iu]s$/i,
      // "carnivorous"
      /pox$/i,
      // "chickpox", "smallpox"
      /sheep$/i
    ].forEach(d.addUncountableRule), d;
  });
})(O3e);
var tut = O3e.exports;
const ose = /* @__PURE__ */ ko(tut);
ose.addPluralRule("glomerulus", "glomeruli");
ose.addPluralRule("interstitium", "interstitia");
function ji(t) {
  return [...t].reduce((e, { 0: n, 1: r }) => Object.assign(e, { [n]: r }), {});
}
function fI(t) {
  return new Intl.NumberFormat("en-US").format(t);
}
function Ci(t) {
  return t ? t.charAt(0).toUpperCase() + t.slice(1) : "";
}
function Bf(t, e = null) {
  return ose(t, e);
}
function _me(t) {
  return t.reduce((e, n) => e.length > n.length ? e : n);
}
function ql(t) {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", n = [0];
  function r() {
    const o = [];
    n.forEach((a) => {
      o.unshift(e[a]);
    });
    let s = !0;
    for (let a = 0; a < n.length; a++)
      if (++n[a] >= e.length)
        n[a] = 0;
      else {
        s = !1;
        break;
      }
    return s && n.push(0), o.join("");
  }
  let i;
  do
    i = r();
  while (t.includes(i));
  return i;
}
function F3e(t) {
  return (e) => {
    let n = 0, r;
    do
      r = `${t}${n}`, n += 1;
    while (e.includes(r));
    return r;
  };
}
function P3e(t, e) {
  return `init_${t}_${e}_`;
}
function hLr(t, e, n = null) {
  return `${P3e(t, e)}${n === null ? 0 : n}`;
}
const nut = [50, 50, 50], rut = [200, 200, 200];
function da(t) {
  return t === "dark" ? nut : rut;
}
const Gv = [
  [68, 119, 170],
  [136, 204, 238],
  [68, 170, 153],
  [17, 119, 51],
  [153, 153, 51],
  [221, 204, 119],
  [204, 102, 119],
  [136, 34, 85],
  [170, 68, 153]
], Y0 = [
  [0, 0, 255],
  [0, 255, 0],
  [255, 0, 255],
  [255, 255, 0],
  [0, 255, 255],
  [255, 255, 255],
  [255, 128, 0],
  [255, 0, 0]
], iut = [
  [0, 0, 0],
  [228, 158, 37],
  [91, 181, 231],
  [22, 157, 116],
  [239, 226, 82],
  [16, 115, 176],
  [211, 94, 26],
  [202, 122, 166]
], k3e = [
  "viridis",
  "greys",
  "magma",
  "jet",
  "hot",
  "bone",
  "copper",
  "summer",
  "density",
  "inferno"
], out = { webgl2: !0 };
function sut(t) {
  return (e) => console.warn(`${t} updateCellsHover: ${e.cellId}`);
}
function aut(t) {
  return (e) => console.warn(`${t} updateGenesHover: ${e.geneId}`);
}
function Aut(t) {
  return (e) => console.warn(`${t} updateTracksHover: ${e}`);
}
function lut(t) {
  return (e) => console.warn(`${t} updateViewInfo: ${e}`);
}
function cut(t) {
  const e = new ArrayBuffer(t.buffer.byteLength), n = new Uint8Array(e);
  return n.set(t), n;
}
function G3e(t, e = 2) {
  if (t === 0)
    return "0 Bytes";
  const n = 1024, r = e < 0 ? 0 : e, i = ["Bytes", "KB", "MB", "GB"], o = Math.floor(Math.log(t) / Math.log(n));
  return `${parseFloat((t / Math.pow(n, o)).toFixed(r))} ${i[o]}`;
}
const LX = [
  { name: "None", value: null },
  { name: "Log", value: "log1p" },
  { name: "ArcSinh", value: "arcsinh" }
];
function U3e(t, e) {
  let n;
  switch (t) {
    case "log1p":
      n = (r) => Math.log(1 + r * e);
      break;
    case "arcsinh":
      n = (r) => Math.asinh(r * e);
      break;
    default:
      n = (r) => r;
  }
  return n;
}
const uut = typeof navigator < "u" ? navigator.hardwareConcurrency || 4 : 1;
class fut {
  /**
   * @constructor
   * @param {object} Worker The worker class to be used for processing.
   */
  constructor(e) {
    Sr(this, "workers");
    Sr(this, "idleWorkers");
    Sr(this, "waitQueue");
    this.workers = [], this.idleWorkers = [], this.waitQueue = [];
    for (let n = 0; n < uut; ++n) {
      const r = e();
      this.workers.push(r), this.idleWorkers.push(r);
    }
  }
  // eslint-disable-next-line class-methods-use-this
  async process() {
    throw new Error('Pool needs to implement "process" method');
  }
  async waitForWorker() {
    const e = this.idleWorkers.pop();
    if (e)
      return e;
    const n = {}, r = new Promise((i) => {
      n.resolve = i;
    });
    return this.waitQueue.push(n), r;
  }
  async finishTask(e) {
    const n = this.waitQueue.pop();
    n && n.resolve ? n.resolve(e) : this.idleWorkers.push(e);
  }
  destroy() {
    for (let e = 0; e < this.workers.length; ++e)
      this.workers[e].terminate();
  }
}
class gut {
  /**
   * Construct a new file definition instance.
   * @param {string} url The URL to the file.
   * @param {string} dataType The type of data contained in the file.
   * @param {string} fileType The file type.
   * @param {object|array|null} options An optional object or array
   * which may provide additional parameters to the loader class
   * corresponding to the specified fileType.
   */
  constructor(e, n, r, i) {
    this.file = {
      url: e,
      fileType: n,
      ...r ? { coordinationValues: r } : {},
      ...i ? { options: i } : {}
    };
  }
  /**
   * @returns {object} This dataset file as a JSON object.
   */
  toJSON() {
    return this.file;
  }
}
class hut {
  /**
   * Construct a new dataset definition instance.
   * @param {string} uid The unique ID for the dataset.
   * @param {string} name The name of the dataset.
   * @param {string} description A description for the dataset.
   */
  constructor(e, n, r) {
    this.dataset = {
      uid: e,
      name: n,
      description: r,
      files: []
    };
  }
  /**
   * Add a file definition to the dataset.
   * @param {object} params An object with named arguments.
   * @param {string|undefined} params.url The URL to the file.
   * @param {string} params.fileType The file type.
   * @param {object|undefined} params.coordinationValues The coordination values.
   * @param {object|array|undefined} params.options An optional object or array
   * which may provide additional parameters to the loader class
   * corresponding to the specified fileType.
   * @returns {VitessceConfigDataset} This, to allow chaining.
   */
  addFile(e, ...n) {
    let r, i, o, s;
    if (n.length > 0) {
      r = e;
      let a;
      n.length === 2 ? [a, i] = n : n.length === 3 && ([a, i, s] = n);
    } else if (typeof e == "object")
      ({
        url: r,
        fileType: i,
        options: s,
        coordinationValues: o
      } = e);
    else
      throw new Error("Expected addFile argument to be an object.");
    return this.dataset.files.push(new gut(r, i, o, s)), this;
  }
  /**
   * @returns {object} This dataset as a JSON object.
   */
  toJSON() {
    return {
      ...this.dataset,
      files: this.dataset.files.map((e) => e.toJSON())
    };
  }
}
function H3e(t, e, n) {
  function r(i, o, s, a) {
    Array.isArray(a) ? (n[i] = {
      ...n[i] || {},
      [s]: {
        ...n[i]?.[s] || {},
        [o.cScope]: a.map((A) => A.scope.cScope)
      }
    }, a.forEach((A) => {
      A.children && Object.entries(A.children).forEach(([l, c]) => r(s, A.scope, l, c));
    })) : (n[i] = {
      ...n[i] || {},
      [s]: {
        ...n[i]?.[s] || {},
        [o.cScope]: a.scope.cScope
      }
    }, a.children && Object.entries(a.children).forEach(([A, l]) => r(s, a.scope, A, l)));
  }
  return Object.entries(t).forEach(([i, o]) => {
    Array.isArray(o) ? (e[i] = o.map((s) => s.scope.cScope), o.forEach((s) => {
      s.children && Object.entries(s.children).forEach(([a, A]) => r(i, s.scope, a, A));
    })) : (e[i] = o.scope.cScope, o.children && Object.entries(o.children).forEach(([s, a]) => r(i, o.scope, s, a)));
  }), [e, n];
}
class cz {
  /**
   * Construct a new view instance.
   * @param {string} component The name of the Vitessce component type.
   * @param {object} coordinationScopes A mapping from coordination type
   * names to coordination scope names.
   * @param {number} x The x-coordinate of the view in the layout.
   * @param {number} y The y-coordinate of the view in the layout.
   * @param {number} w The width of the view in the layout.
   * @param {number} h The height of the view in the layout.
   */
  constructor(e, n, r, i, o, s) {
    this.view = {
      component: e,
      coordinationScopes: n,
      coordinationScopesBy: void 0,
      x: r,
      y: i,
      w: o,
      h: s
    };
  }
  /**
   * Attach coordination scopes to this view.
   * @param  {...VitessceConfigCoordinationScope} args A variable number of
   * coordination scope instances.
   * @returns {VitessceConfigView} This, to allow chaining.
   */
  useCoordination(...e) {
    return e.forEach((r) => {
      this.view.coordinationScopes[r.cType] = r.cScope;
    }), this;
  }
  /**
   * Attach potentially multi-level coordination scopes to this view.
   * @param {object} scopes A value returned by `VitessceConfig.addCoordinationByObject`.
   * Not intended to be a manually-constructed object.
   * @returns {VitessceConfigView} This, to allow chaining.
   */
  useCoordinationByObject(e) {
    this.view.coordinationScopes || (this.view.coordinationScopes = {}), this.view.coordinationScopesBy || (this.view.coordinationScopesBy = {});
    const [n, r] = H3e(e, this.view.coordinationScopes, this.view.coordinationScopesBy);
    return this.view.coordinationScopes = n, this.view.coordinationScopesBy = r, this;
  }
  /**
   * Attach meta coordination scopes to this view.
   * @param {VitessceConfigMetaCoordinationScope} metaScope A meta coordination scope instance.
   * @returns {VitessceConfigView} This, to allow chaining.
   */
  useMetaCoordination(e) {
    return this.view.coordinationScopes || (this.view.coordinationScopes = {}), this.view.coordinationScopes[re.META_COORDINATION_SCOPES] = [
      ...this.view.coordinationScopes[re.META_COORDINATION_SCOPES] || [],
      e.metaScope.cScope
    ], this.view.coordinationScopes[re.META_COORDINATION_SCOPES_BY] = [
      ...this.view.coordinationScopes[re.META_COORDINATION_SCOPES_BY] || [],
      e.metaByScope.cScope
    ], this;
  }
  /**
    * Set the x, y, w, h values for this view.
    * @param {number} x The x-coordinate of the view in the layout.
    * @param {number} y The y-coordinate of the view in the layout.
    * @param {number} w The width of the view in the layout.
    * @param {number} h The height of the view in the layout.
    * @returns {VitessceConfigView} This, to allow chaining.
    */
  setXYWH(e, n, r, i) {
    return this.view.x = e, this.view.y = n, this.view.w = r, this.view.h = i, this;
  }
  /**
   * Set props for this view.
   * @returns {VitessceConfigView} This, to allow chaining.
   */
  setProps(e) {
    return this.view.props = {
      ...this.view.props || {},
      ...e
    }, this;
  }
  /**
   * @returns {object} This view as a JSON object.
   */
  toJSON() {
    return this.view;
  }
}
class $3e {
  constructor(e) {
    this.views = e;
  }
}
class q3e {
  constructor(e) {
    this.views = e;
  }
}
function dLr(...t) {
  return new $3e(t);
}
function pLr(...t) {
  return new q3e(t);
}
class j3e {
  constructor(e) {
    this.value = e, this.cachedValue = null;
  }
  setCached(e) {
    this.cachedValue = e;
  }
  getCached() {
    return this.cachedValue;
  }
  isCached() {
    return this.cachedValue !== null;
  }
}
function dA(t) {
  return new j3e(t);
}
class o_ {
  /**
   * Construct a new coordination scope instance.
   * @param {string} cType The coordination type for this coordination scope.
   * @param {string} cScope The name of the coordination scope.
   * @param {[any]} cValue Optional. The coordination value of the coordination scope.
   */
  constructor(e, n, r = null) {
    this.cType = e, this.cScope = n, this.cValue = r;
  }
  /**
   * Set the coordination value of the coordination scope.
   * @param {any} cValue The value to set.
   * @returns {VitessceConfigCoordinationScope} This, to allow chaining.
   */
  setValue(e) {
    return this.cValue = e, this;
  }
}
class dut {
  /**
   * Construct a new coordination scope instance.
   * @param {string} metaScope The name of the coordination scope for metaCoordinationScopes.
   * @param {string} metaByScope The name of the coordination scope for metaCoordinationScopesBy.
   */
  constructor(e, n) {
    this.metaScope = new o_(re.META_COORDINATION_SCOPES, e), this.metaByScope = new o_(re.META_COORDINATION_SCOPES_BY, n);
  }
  /**
   * Attach coordination scopes to this meta scope.
   * @param  {...VitessceConfigCoordinationScope} args A variable number of
   * coordination scope instances.
   * @returns {VitessceConfigMetaCoordinationScope} This, to allow chaining.
   */
  useCoordination(...e) {
    const n = e, r = this.metaScope.cValue;
    return n.forEach((i) => {
      r[i.cType] = i.cScope;
    }), this.metaScope.setValue(r), this;
  }
  /**
   * Attach potentially multi-level coordination scopes to this meta coordination
   * scope instance.
   * @param {object} scopes A value returned by `VitessceConfig.addCoordinationByObject`.
   * Not intended to be a manually-constructed object.
   * @returns {VitessceConfigView} This, to allow chaining.
   */
  useCoordinationByObject(e) {
    this.metaScope.cValue || this.metaScope.setValue({}), this.metaByScope.cValue || this.metaByScope.setValue({});
    const [n, r] = H3e(e, this.metaScope.cValue, this.metaByScope.cValue);
    return this.metaScope.setValue(n), this.metaByScope.setValue(r), this;
  }
}
class X6 {
  /**
   * Construct a new view config instance.
   * @param {object} params An object with named arguments.
   * @param {string} params.schemaVersion The view config schema version. Required.
   * @param {string} params.name A name for the config. Optional.
   * @param {string|undefined} params.description A description for the config. Optional.
   */
  constructor(e, ...n) {
    let r, i, o;
    if (typeof e == "string") {
      if (o = "1.0.7", r = e || "", n.length === 1)
        [i] = n;
      else if (n.length > 1)
        throw new Error("Expected only one VitessceConfig constructor argument.");
    } else if (typeof e == "object") {
      if ({ schemaVersion: o, name: r, description: i } = e, !r)
        throw new Error("Expected params.name argument in VitessceConfig constructor");
      if (!o)
        throw new Error("Expected params.schemaVersion argument in VitessceConfig constructor");
    } else
      throw new Error("Expected VitessceConfig constructor argument to be an object.");
    this.config = {
      version: o,
      name: r,
      description: i,
      datasets: [],
      coordinationSpace: {},
      layout: [],
      initStrategy: "auto"
    }, this.getNextScope = ql;
  }
  /**
   * Add a new dataset to the config.
   * @param {string} name A name for the dataset. Optional.
   * @param {string} description A description for the dataset. Optional.
   * @param {object} options Extra parameters to be used internally. Optional.
   * @param {string} options.uid Override the automatically-generated dataset ID.
   * Intended for internal usage by the VitessceConfig.fromJSON code.
   * @returns {VitessceConfigDataset} A new dataset instance.
   */
  addDataset(e = void 0, n = void 0, r = void 0) {
    const { uid: i } = r || {}, o = this.config.datasets.map((l) => l.dataset.uid), s = i || this.getNextScope(o), a = new hut(s, e, n);
    this.config.datasets.push(a);
    const [A] = this.addCoordination(re.DATASET);
    return A.setValue(s), a;
  }
  /**
   * Add a new view to the config.
   * @param {VitessceConfigDataset} dataset The dataset instance which defines the data
   * that will be displayed in the view.
   * @param {string} component A component name, such as "scatterplot" or "spatial".
   * @param {object} options Extra options for the component.
   * @param {number} options.x The x-coordinate for the view in the grid layout.
   * @param {number} options.y The y-coordinate for the view in the grid layout.
   * @param {number} options.w The width for the view in the grid layout.
   * @param {number} options.h The height for the view in the grid layout.
   * @param {number} options.mapping A convenience parameter for setting the EMBEDDING_TYPE
   * coordination value. Only applicable if the component is "scatterplot".
   * @returns {VitessceConfigView} A new view instance.
   */
  addView(e, n, r) {
    const { x: i = 0, y: o = 0, w: s = 1, h: a = 1, mapping: A = null } = r || {}, l = this.config.coordinationSpace[re.DATASET] ? Object.entries(this.config.coordinationSpace[re.DATASET]).filter(([h, d]) => d.cValue === e.dataset.uid).map(([h]) => h) : [];
    let c;
    if (l.length === 1)
      [c] = l;
    else
      throw new Error("No coordination scope matching the dataset parameter could be found in the coordination space.");
    const u = {
      [re.DATASET]: c
    }, f = new cz(n, u, i, o, s, a);
    if (A) {
      const [h] = this.addCoordination(re.EMBEDDING_TYPE);
      h.setValue(A), f.useCoordination(h);
    }
    return this.config.layout.push(f), f;
  }
  /**
   * Get an array of new coordination scope instances corresponding to coordination types
   * of interest.
   * @param {...string} args A variable number of coordination type names.
   * @returns {VitessceConfigCoordinationScope[]} An array of coordination scope instances.
   */
  addCoordination(...e) {
    const n = e, r = [];
    return n.forEach((i) => {
      const o = this.config.coordinationSpace[i] ? Object.keys(this.config.coordinationSpace[i]) : [], s = new o_(i, this.getNextScope(o));
      this.config.coordinationSpace[s.cType] || (this.config.coordinationSpace[s.cType] = {}), this.config.coordinationSpace[s.cType][s.cScope] = s, r.push(s);
    }), r;
  }
  /**
   * Initialize a new meta coordination scope in the coordination space,
   * and get a reference to it in the form of a meta coordination scope instance.
   * @returns {VitessceConfigMetaCoordinationScope} A new meta coordination scope instance.
   */
  addMetaCoordination() {
    const e = this.config.coordinationSpace[re.META_COORDINATION_SCOPES] ? Object.keys(this.config.coordinationSpace[re.META_COORDINATION_SCOPES]) : [], n = this.config.coordinationSpace[re.META_COORDINATION_SCOPES_BY] ? Object.keys(this.config.coordinationSpace[re.META_COORDINATION_SCOPES_BY]) : [], r = new dut(this.getNextScope(e), this.getNextScope(n));
    return this.config.coordinationSpace[re.META_COORDINATION_SCOPES] || (this.config.coordinationSpace[re.META_COORDINATION_SCOPES] = {}), this.config.coordinationSpace[re.META_COORDINATION_SCOPES_BY] || (this.config.coordinationSpace[re.META_COORDINATION_SCOPES_BY] = {}), this.config.coordinationSpace[re.META_COORDINATION_SCOPES][r.metaScope.cScope] = r.metaScope, this.config.coordinationSpace[re.META_COORDINATION_SCOPES_BY][r.metaByScope.cScope] = r.metaByScope, r;
  }
  /**
   * Set up the initial values for multi-level coordination in the coordination space.
   * Get a reference to these values to pass to the `useCoordinationByObject` method
   * of either view or meta coordination scope instances.
   * @param {object} input A (potentially nested) object with coordination types as keys
   * and values being either the initial coordination value, a `VitessceConfigCoordinationScope`
   * instance, or a `CoordinationLevel` instance.
   * The CL function takes an array of objects as its argument, and returns a CoordinationLevel
   * instance, to support nesting.
   * @returns {object} A (potentially nested) object with coordination types as keys and values
   * being either { scope }, { scope, children }, or an array of these. Not intended to be
   * manipulated before being passed to a `useCoordinationByObject` function.
   */
  addCoordinationByObject(e) {
    const n = (i) => {
      const o = {};
      return i === null || Object.entries(i).forEach(([s, a]) => {
        if (a instanceof j3e) {
          const A = a.value;
          if (a.isCached())
            o[s] = a.getCached();
          else if (Array.isArray(A)) {
            const l = A.map((c) => {
              const [u] = this.addCoordination(s);
              return u.setValue("__dummy__"), {
                scope: u,
                children: n(c)
              };
            });
            a.setCached(l), o[s] = l;
          } else {
            const l = A, [c] = this.addCoordination(s);
            c.setValue("__dummy__");
            const u = {
              scope: c,
              children: n(l)
            };
            a.setCached(u), o[s] = u;
          }
        } else {
          const A = a;
          if (A instanceof o_)
            o[s] = { scope: A };
          else {
            const [l] = this.addCoordination(s);
            l.setValue(A), o[s] = { scope: l };
          }
        }
      }), o;
    };
    return n(e);
  }
  /**
   * A convenience function for setting up new coordination scopes across a set of views.
   * @param {VitessceConfigView[]} views An array of view objects to link together.
   * @param {string[]} cTypes The coordination types on which to coordinate the views.
   * @param {any[]} cValues Initial values corresponding to each coordination type.
   * Should have the same length as the cTypes array. Optional.
   * @returns {VitessceConfig} This, to allow chaining.
   */
  linkViews(e, n, r = null) {
    const i = this.addCoordination(...n);
    return e.forEach((o) => {
      i.forEach((s) => {
        o.useCoordination(s);
      });
    }), Array.isArray(r) && r.length === n.length && i.forEach((o, s) => {
      o.setValue(r[s]);
    }), this;
  }
  /**
   * A convenience function for setting up multi-level and meta-coordination scopes
   * across a set of views.
   * @param {VitessceConfigView[]} views An array of view objects to link together.
   * @param {object} input A (potentially nested) object with coordination types as keys
   * and values being either the initial coordination value, a `VitessceConfigCoordinationScope`
   * instance, or a `CoordinationLevel` instance.
   * The CL function takes an array of objects as its argument, and returns a CoordinationLevel
   * instance, to support nesting.
   * @param {object|null} options
   * @param {bool} options.meta Should meta-coordination be used? Optional.
   * By default, true.
   * @param {string|null} options.scopePrefix A prefix to add to all
   * coordination scope names. Optional.
   * @returns {VitessceConfig} This, to allow chaining.
   */
  linkViewsByObject(e, n, r = null) {
    const { meta: i = !0, scopePrefix: o = null } = r || {};
    o && (this.getNextScope = F3e(o));
    const s = this.addCoordinationByObject(n);
    if (i) {
      const a = this.addMetaCoordination();
      a.useCoordinationByObject(s), e.forEach((A) => {
        A.useMetaCoordination(a);
      });
    } else
      e.forEach((a) => {
        a.useCoordinationByObject(s);
      });
    return o && (this.getNextScope = ql), this;
  }
  /**
   * Set the value for a coordination scope.
   * If a coordination object for the coordination type does not yet exist
   * in the coordination space, it will be created.
   * @param {string} cType The coordination type.
   * @param {string} cScope The coordination scope.
   * @param {any} cValue The initial value for the coordination scope.
   * @returns {VitessceConfigCoordinationScope} A coordination scope instance.
   */
  setCoordinationValue(e, n, r) {
    const i = new o_(e, n, r);
    return this.config.coordinationSpace[i.cType] || (this.config.coordinationSpace[i.cType] = {}), this.config.coordinationSpace[i.cType][i.cScope] = i, i;
  }
  /**
   * Set the layout of views.
   * @param {VitessceConfigView|VitessceConfigViewHConcat|VitessceConfigViewVConcat} viewConcat A
   * view or a concatenation of views.
   * @returns {VitessceConfig} This, to allow chaining.
   */
  layout(e) {
    function n(r, i, o, s, a) {
      const A = o - i, l = a - s;
      if (r instanceof cz)
        r.setXYWH(i, s, A, l);
      else if (r instanceof $3e) {
        const { views: c } = r, u = c.length;
        c.forEach((f, h) => {
          n(f, i + A / u * h, i + A / u * (h + 1), s, a);
        });
      } else if (r instanceof q3e) {
        const { views: c } = r, u = c.length;
        c.forEach((f, h) => {
          n(f, i, o, s + l / u * h, s + l / u * (h + 1));
        });
      }
    }
    return n(e, 0, 12, 0, 12), this;
  }
  /**
   * Convert this instance to a JSON object that can be passed to the Vitessce component.
   * @returns {object} The view config as a JSON object.
   */
  toJSON() {
    return {
      ...this.config,
      datasets: this.config.datasets.map((e) => e.toJSON()),
      coordinationSpace: ji(Object.entries(this.config.coordinationSpace).map(([e, n]) => [
        e,
        ji(Object.entries(n).map(([r, i]) => [
          r,
          i.cValue
        ]))
      ])),
      layout: this.config.layout.map((e) => e.toJSON())
    };
  }
  /**
   * Create a VitessceConfig instance from an existing view config, to enable
   * manipulation with the JavaScript API.
   * @param {object} config An existing Vitessce view config as a JSON object.
   * @returns {VitessceConfig} A new config instance, with values set to match
   * the config parameter.
   */
  static fromJSON(e) {
    const { name: n, description: r, version: i } = e, o = new X6({ schemaVersion: i, name: n, description: r });
    return e.datasets.forEach((s) => {
      const a = o.addDataset(s.name, s.description, { uid: s.uid });
      s.files.forEach((A) => {
        a.addFile({
          url: A.url,
          fileType: A.fileType,
          coordinationValues: A.coordinationValues,
          options: A.options
        });
      });
    }), Object.keys(e.coordinationSpace).forEach((s) => {
      if (s !== re.DATASET) {
        const a = e.coordinationSpace[s];
        o.config.coordinationSpace[s] = {}, Object.entries(a).forEach(([A, l]) => {
          const c = new o_(s, A);
          c.setValue(l), o.config.coordinationSpace[s][A] = c;
        });
      }
    }), e.layout.forEach((s) => {
      const a = new cz(s.component, s.coordinationScopes, s.x, s.y, s.w, s.h);
      o.config.layout.push(a);
    }), o;
  }
}
function put(t, e) {
  const n = new X6({ schemaVersion: "1.0.16", name: "__dummy__" });
  n.getNextScope = F3e(e);
  const r = n.addDataset("__dummy__"), i = n.addView(r, "__dummy__");
  n.linkViewsByObject([i], t, { meta: !0 });
  const o = n.toJSON(), { coordinationSpace: s } = o, { coordinationScopes: a } = o.layout[0], { coordinationScopesBy: A } = o.layout[0];
  return {
    coordinationSpace: s,
    coordinationScopes: a,
    coordinationScopesBy: A
  };
}
const Sme = {
  obsSets: { x: 4, y: 0, w: 4, h: 4 },
  obsSetSizes: { x: 8, y: 0, w: 4, h: 4 },
  scatterplot: { x: 0, y: 0, w: 4, h: 4 },
  heatmap: { x: 0, y: 4, w: 8, h: 4 },
  featureList: { x: 8, y: 4, w: 4, h: 4 }
}, Qme = {
  obsSets: { x: 10, y: 6, w: 2, h: 6 },
  obsSetSizes: { x: 8, y: 1, w: 4, h: 6 },
  scatterplot: { x: 0, y: 0, w: 8, h: 12 },
  featureList: { x: 8, y: 6, w: 2, h: 6 }
}, Iut = {
  scatterplot: { x: 0, y: 0, w: 3, h: 4 },
  spatial: { x: 3, y: 0, w: 5, h: 4 },
  obsSets: { x: 8, y: 0, w: 4, h: 2 },
  featureList: { x: 8, y: 0, w: 4, h: 2 },
  heatmap: { x: 0, y: 4, w: 6, h: 4 },
  obsSetFeatureValueDistribution: { x: 6, y: 4, w: 6, h: 4 }
}, mut = {
  spatial: { x: 0, y: 0, w: 6, h: 6 },
  heatmap: { x: 0, y: 6, w: 8, h: 6 },
  layerController: { x: 8, y: 6, w: 4, h: 6 },
  obsSets: { x: 9, y: 0, w: 3, h: 6 },
  featureList: { x: 6, y: 0, w: 3, h: 6 }
}, Cut = {
  spatial: { x: 0, y: 0, w: 8, h: 12 },
  layerController: { x: 8, y: 0, w: 4, h: 7 },
  description: { x: 8, y: 9, w: 4, h: 5 }
}, wme = {
  views: {},
  coordinationValues: {}
}, Eut = {
  "No hints are available. Generate config with no hints.": wme,
  Basic: wme,
  "Transcriptomics / scRNA-seq (with heatmap)": {
    views: Sme
  },
  "Transcriptomics / scRNA-seq (without heatmap)": {
    views: Qme
  },
  "Spatial transcriptomics (with polygon cell segmentations)": {
    views: Iut
  },
  "Chromatin accessibility / scATAC-seq (with heatmap)": {
    views: Sme,
    coordinationValues: {
      featureType: "peak"
    }
  },
  "Chromatin accessibility / scATAC-seq (without heatmap)": {
    views: Qme,
    coordinationValues: {
      featureType: "peak"
    }
  },
  "Spatial transcriptomics (with histology image and polygon cell segmentations)": {
    views: mut,
    coordinationSpaceRequired: !0
  },
  Image: {
    views: Cut
  }
}, yut = {
  "AnnData-Zarr": [
    "Basic",
    "Transcriptomics / scRNA-seq (with heatmap)",
    "Transcriptomics / scRNA-seq (without heatmap)",
    "Spatial transcriptomics (with polygon cell segmentations)",
    "Chromatin accessibility / scATAC-seq (with heatmap)",
    "Chromatin accessibility / scATAC-seq (without heatmap)"
  ],
  "OME-TIFF": [
    "Basic",
    "Image"
  ],
  "AnnData-Zarr,OME-TIFF": [
    "Basic",
    "Spatial transcriptomics (with histology image and polygon cell segmentations)"
  ]
}, sse = (t, e) => {
  const n = Object.keys(t.views);
  if (n.length === 0)
    return e;
  const r = [];
  if (n.forEach((i) => {
    const o = e.find((s) => s[0] === i);
    o && r.push(o);
  }), r.length === 0)
    throw new Error("No views found that are compatible with the supplied dataset URLs and hint.");
  return r;
};
class ase {
  async composeViewsConfig() {
    throw new Error("The composeViewsConfig() method has not been implemented.");
  }
  async composeFileConfig() {
    throw new Error("The composeFileConfig() method has not been implemented.");
  }
}
class vut extends ase {
  constructor(e) {
    super(), this.fileUrl = e, this.fileType = Ft.RASTER_JSON, this.fileName = e.split("/").at(-1);
  }
  async composeViewsConfig(e) {
    return sse(e, [["description"], ["spatial"], ["layerController"]]);
  }
  async composeFileConfig() {
    return {
      fileType: this.fileType,
      options: {
        images: [
          {
            metadata: {
              isBitmask: !1
            },
            name: this.fileName,
            type: "ome-tiff",
            url: this.fileUrl
          }
        ],
        schemaVersion: "0.0.2",
        usePhysicalSizeScaling: !1
      }
    };
  }
}
class But extends ase {
  constructor(e) {
    super(), this.fileUrl = e, this.fileType = Ft.RASTER_OME_ZARR, this.fileName = e.split("/").at(-1);
  }
  async composeViewsConfig(e) {
    return sse(e, [["description"], ["spatial"], ["layerController"]]);
  }
  async composeFileConfig() {
    return {
      fileType: this.fileType,
      type: "raster",
      url: this.fileUrl
    };
  }
}
class MX extends ase {
  constructor(e) {
    super(), this.fileUrl = e, this.fileType = Ft.ANNDATA_ZARR, this.fileName = e.split("/").at(-1), this.metadataSummary = {};
  }
  async composeFileConfig() {
    this.metadataSummary = await this.setMetadataSummary();
    const e = {
      obsEmbedding: [],
      obsFeatureMatrix: {
        path: "X"
      }
    };
    this.metadataSummary.obsm.forEach((r) => {
      r.toLowerCase().includes("obsm/x_segmentations") && (e.obsSegmentations = { path: r }), r.toLowerCase().includes("obsm/x_spatial") && (e.obsLocations = { path: r }), r.toLowerCase().includes("obsm/x_umap") && e.obsEmbedding.push({ path: r, embeddingType: "UMAP" }), r.toLowerCase().includes("obsm/x_tsne") && e.obsEmbedding.push({ path: r, embeddingType: "t-SNE" }), r.toLowerCase().includes("obsm/x_pca") && e.obsEmbedding.push({ path: r, embeddingType: "PCA" });
    });
    const n = [
      "cluster",
      "clusters",
      "subcluster",
      "cell_type",
      "celltype",
      "leiden",
      "louvain",
      "disease",
      "organism",
      "self_reported_ethnicity",
      "tissue",
      "sex"
    ];
    return this.metadataSummary.obs.forEach((r) => {
      n.forEach((i) => {
        r.toLowerCase() === ["obs", i].join("/") && ("obsSets" in e ? e.obsSets[0].path.push(r) : e.obsSets = [
          {
            name: "Cell Type",
            path: [r]
          }
        ]);
      });
    }), e.obsSets = e.obsSets?.map((r) => r.path.length === 1 ? {
      ...r,
      path: r.path[0]
    } : r), {
      options: e,
      fileType: this.fileType,
      url: this.fileUrl,
      coordinationValues: {
        obsType: "cell",
        featureType: "gene",
        featureValueType: "expression"
      }
    };
  }
  async composeViewsConfig(e) {
    this.metadataSummary = await this.setMetadataSummary();
    const n = [];
    return this.metadataSummary.obs.filter((o) => o.toLowerCase().includes("cluster") || o.toLowerCase().includes("cell_type") || o.toLowerCase().includes("celltype")).length > 0 && n.push(["obsSets"]), this.metadataSummary.obsm.forEach((o) => {
      o.toLowerCase().includes("obsm/x_umap") && n.push(["scatterplot", { mapping: "UMAP" }]), o.toLowerCase().includes("obsm/x_tsne") && n.push(["scatterplot", { mapping: "t-SNE" }]), o.toLowerCase().includes("obsm/x_pca") && n.push(["scatterplot", { mapping: "PCA" }]), o.toLowerCase().includes("obsm/x_segmentations") && n.push(["layerController"]), o.toLowerCase().includes("obsm/x_spatial") && n.push(["spatial"]);
    }), n.push(["obsSetSizes"]), n.push(["obsSetFeatureValueDistribution"]), this.metadataSummary.X && (n.push(["heatmap"]), n.push(["featureList"])), sse(e, n);
  }
  async setMetadataSummaryWithZmetadata(e) {
    const n = await e.json();
    if (!n.metadata)
      throw new Error("Could not generate config: .zmetadata file is not valid.");
    const r = Object.keys(n.metadata).filter((A) => A.startsWith("obsm/X_")).map((A) => A.split("/.zarray")[0]), i = Object.keys(n.metadata).filter((A) => A.startsWith("obs/")).map((A) => A.split("/.za")[0]);
    function o(A) {
      return A.sort().filter((l, c, u) => !c || l !== u[c - 1]);
    }
    const s = o(i), a = Object.keys(n.metadata).filter((A) => A.startsWith("X"));
    return {
      // Array of keys in obsm that are found by the fetches above
      obsm: r,
      // Array of keys in obs that are found by the fetches above
      obs: s,
      // Boolean indicating whether the X array was found by the fetches above
      X: a.length > 0
    };
  }
  async setMetadataSummaryWithoutZmetadata() {
    const e = [
      "/obsm/X_pca/.zarray",
      "/obsm/X_umap/.zarray",
      "/obsm/X_tsne/.zarray",
      "/obsm/X_spatial/.zarray",
      "/obsm/X_segmentations/.zarray",
      "/obs/.zattrs",
      "/X/.zarray",
      "/X/data/.zarray"
      // for https://s3.amazonaws.com/vitessce-data/0.0.33/main/human-lymph-node-10x-visium/human_lymph_node_10x_visium.h5ad.zarr
    ], n = (l) => {
      const c = `${this.fileUrl}/`.length, u = l.length - 8;
      return l.substring(c, u);
    }, r = e.map((l) => fetch(`${this.fileUrl}${l}`)), o = (await Promise.all(r)).filter((l) => l.ok), s = {
      // Array of keys in obsm that are found by the fetches above
      obsm: [],
      // Array of keys in obs that are found by the fetches above
      obs: [],
      // Boolean indicating whether the X array was found by the fetches above
      X: !1
    }, a = o.find((l) => l.url === `${this.fileUrl}/obs/.zattrs`), A = (l) => Object.keys(l).includes("column-order") && Object.keys(l).includes("encoding-version") && Object.keys(l).includes("encoding-type") && l["encoding-type"] === "dataframe" && (l["encoding-version"] === "0.1.0" || l["encoding-version"] === "0.2.0");
    if (a) {
      const l = await a.json();
      if (A(l))
        l["column-order"].forEach((c) => s.obs.push(`obs/${c}`));
      else
        throw new Error("Could not generate config: /obs/.zattrs file is not valid.");
    }
    return o.forEach((l) => {
      if (l.url.startsWith(`${this.fileUrl}/obsm`)) {
        const c = n(l.url);
        c && s.obsm.push(c);
      } else
        l.url.startsWith(`${this.fileUrl}/X`) && (s.X = !0);
    }), s;
  }
  async setMetadataSummary() {
    if (Object.keys(this.metadataSummary).length > 0)
      return this.metadataSummary;
    const e = ".zmetadata", n = [this.fileUrl, e].join("/");
    return fetch(n).then((r) => {
      if (r.ok)
        return this.setMetadataSummaryWithZmetadata(r);
      if (r.status === 404)
        return this.setMetadataSummaryWithoutZmetadata();
      throw new Error(`Could not generate config: ${r.statusText}`);
    }).catch((r) => {
      throw new Error(`Could not generate config for URL ${this.fileUrl}: ${r}`);
    });
  }
}
const but = [
  {
    extensions: [".ome.tif", ".ome.tiff", ".ome.tf2", ".ome.tf8"],
    class: vut,
    name: "OME-TIFF"
  },
  {
    extensions: [".h5ad.zarr", ".adata.zarr", ".anndata.zarr"],
    class: MX,
    name: "AnnData-Zarr"
  },
  {
    extensions: ["ome.zarr"],
    class: But,
    name: "OME-Zarr"
  }
];
function _ut(t) {
  const e = Math.ceil(Math.sqrt(t)), n = Math.ceil(t / e), r = 12 / n, i = 12 / e, o = [];
  for (let s = 0; s < t; s++) {
    const a = Math.floor(s / n), l = s % n * r, c = a * i;
    o.push([
      Math.floor(l),
      Math.floor(c),
      // Ensure width/height is at least 1.
      Math.max(1, Math.floor(r)),
      Math.max(1, Math.floor(i))
    ]);
  }
  return o;
}
const Y3e = {
  radius: 65,
  stroked: !0,
  visible: !0,
  opacity: 1
};
function Sut(t, e) {
  const [n, r, i, o, s] = e.addCoordination(re.SPATIAL_SEGMENTATION_LAYER, re.SPATIAL_IMAGE_LAYER, re.SPATIAL_ZOOM, re.SPATIAL_TARGET_X, re.SPATIAL_TARGET_Y);
  n.setValue(Y3e), r.setValue([
    {
      type: "raster",
      index: 0,
      colormap: null,
      transparentColor: null,
      opacity: 1,
      domainType: "Min/Max",
      channels: [
        {
          selection: {
            c: 0
          },
          color: [
            255,
            0,
            0
          ],
          visible: !0,
          slider: [
            0,
            255
          ]
        },
        {
          selection: {
            c: 1
          },
          color: [
            0,
            255,
            0
          ],
          visible: !0,
          slider: [
            0,
            255
          ]
        },
        {
          selection: {
            c: 2
          },
          color: [
            0,
            0,
            255
          ],
          visible: !0,
          slider: [
            0,
            255
          ]
        }
      ]
    }
  ]), t.forEach((a) => {
    (a.view.component === "spatial" || a.view.component === "layerController") && (a.useCoordination(r), a.useCoordination(n), a.useCoordination(i), a.useCoordination(o), a.useCoordination(s));
  });
}
function z3e(t) {
  const e = but.find((n) => n.extensions.filter((r) => t.endsWith(r)).length === 1);
  if (!e)
    throw new Error("One or more of the URLs provided point to unsupported file types.");
  return e;
}
async function Qut(t, e, n, r) {
  let i;
  try {
    i = z3e(t).class;
  } catch (u) {
    return Promise.reject(u);
  }
  const o = new i(t);
  let s, a;
  try {
    s = await o.composeFileConfig(), a = await o.composeViewsConfig(r);
  } catch (u) {
    return console.error(u), Promise.reject(u);
  }
  n.addFile(s);
  let A = !1, l = !1;
  const c = [];
  return a.forEach((u) => {
    const f = e.addView(n, ...u);
    u[0] === "layerController" && (A = f), u[0] === "spatial" && (l = f), u[0] === "layerController" && f.setProps({
      disable3d: [],
      disableChannelsIfRgbDetected: !0
    }), u[0] === "heatmap" && o instanceof MX && f.setProps({ transpose: !0 }), c.push(f);
  }), A && l && o instanceof MX && e.linkViews([l, A], [
    re.SPATIAL_SEGMENTATION_LAYER
  ], [Y3e]), c;
}
function ILr(t) {
  const e = {};
  t.forEach((r) => {
    const i = z3e(r);
    i.name === "OME-Zarr" ? e["OME-TIFF"] = !0 : e[i.name] = !0;
  });
  const n = Object.keys(e).sort().join(",");
  return yut?.[n] || [];
}
async function mLr(t, e = null) {
  const n = new X6({
    schemaVersion: "1.0.15",
    name: "An automatically generated config. Adjust values and add layout components if needed.",
    description: "Populate with text relevant to this visualisation."
  }), r = [], i = n.addDataset("An automatically generated view config for dataset. Adjust values and add layout components if needed."), o = e ? Eut?.[e] : { views: {} };
  if (!o)
    throw new Error(`Hints config not found for the supplied hint: ${e}.`);
  const s = Object.keys(o?.views)?.length > 0;
  return t.forEach((a) => {
    r.push(Qut(a, n, i, o));
  }), Promise.all(r).then((a) => {
    const A = a.flat();
    if (o?.coordinationSpaceRequired && Sut(A, n), s)
      A.forEach((l) => {
        const c = Object.values(o.views[l.view.component]);
        l.setXYWH(...c);
      });
    else {
      const l = _ut(A.length);
      for (let c = 0; c < A.length; c++)
        A[c].setXYWH(...l[c]);
    }
    return n.toJSON();
  });
}
var V3e = { exports: {} }, Z6 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wut = St, xut = Symbol.for("react.element"), Rut = Symbol.for("react.fragment"), Dut = Object.prototype.hasOwnProperty, Tut = wut.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, Nut = { key: !0, ref: !0, __self: !0, __source: !0 };
function J3e(t, e, n) {
  var r, i = {}, o = null, s = null;
  n !== void 0 && (o = "" + n), e.key !== void 0 && (o = "" + e.key), e.ref !== void 0 && (s = e.ref);
  for (r in e)
    Dut.call(e, r) && !Nut.hasOwnProperty(r) && (i[r] = e[r]);
  if (t && t.defaultProps)
    for (r in e = t.defaultProps, e)
      i[r] === void 0 && (i[r] = e[r]);
  return { $$typeof: xut, type: t, key: o, ref: s, props: i, _owner: Tut.current };
}
Z6.Fragment = Rut;
Z6.jsx = J3e;
Z6.jsxs = J3e;
V3e.exports = Z6;
var ne = V3e.exports, Lut = {
  black: "#000",
  white: "#fff"
};
const nT = Lut;
var Mut = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
};
const nk = Mut;
var Out = {
  50: "#fce4ec",
  100: "#f8bbd0",
  200: "#f48fb1",
  300: "#f06292",
  400: "#ec407a",
  500: "#e91e63",
  600: "#d81b60",
  700: "#c2185b",
  800: "#ad1457",
  900: "#880e4f",
  A100: "#ff80ab",
  A200: "#ff4081",
  A400: "#f50057",
  A700: "#c51162"
};
const rk = Out;
var Fut = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
};
const Put = Fut;
var kut = {
  50: "#ede7f6",
  100: "#d1c4e9",
  200: "#b39ddb",
  300: "#9575cd",
  400: "#7e57c2",
  500: "#673ab7",
  600: "#5e35b1",
  700: "#512da8",
  800: "#4527a0",
  900: "#311b92",
  A100: "#b388ff",
  A200: "#7c4dff",
  A400: "#651fff",
  A700: "#6200ea"
};
const Gut = kut;
var Uut = {
  50: "#e8eaf6",
  100: "#c5cae9",
  200: "#9fa8da",
  300: "#7986cb",
  400: "#5c6bc0",
  500: "#3f51b5",
  600: "#3949ab",
  700: "#303f9f",
  800: "#283593",
  900: "#1a237e",
  A100: "#8c9eff",
  A200: "#536dfe",
  A400: "#3d5afe",
  A700: "#304ffe"
};
const ik = Uut;
var Hut = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
};
const ok = Hut;
var $ut = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
};
const qut = $ut;
var jut = {
  50: "#e0f7fa",
  100: "#b2ebf2",
  200: "#80deea",
  300: "#4dd0e1",
  400: "#26c6da",
  500: "#00bcd4",
  600: "#00acc1",
  700: "#0097a7",
  800: "#00838f",
  900: "#006064",
  A100: "#84ffff",
  A200: "#18ffff",
  A400: "#00e5ff",
  A700: "#00b8d4"
};
const Yut = jut;
var zut = {
  50: "#e0f2f1",
  100: "#b2dfdb",
  200: "#80cbc4",
  300: "#4db6ac",
  400: "#26a69a",
  500: "#009688",
  600: "#00897b",
  700: "#00796b",
  800: "#00695c",
  900: "#004d40",
  A100: "#a7ffeb",
  A200: "#64ffda",
  A400: "#1de9b6",
  A700: "#00bfa5"
};
const Vut = zut;
var Jut = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
const sk = Jut;
var Kut = {
  50: "#f1f8e9",
  100: "#dcedc8",
  200: "#c5e1a5",
  300: "#aed581",
  400: "#9ccc65",
  500: "#8bc34a",
  600: "#7cb342",
  700: "#689f38",
  800: "#558b2f",
  900: "#33691e",
  A100: "#ccff90",
  A200: "#b2ff59",
  A400: "#76ff03",
  A700: "#64dd17"
};
const Wut = Kut;
var Xut = {
  50: "#f9fbe7",
  100: "#f0f4c3",
  200: "#e6ee9c",
  300: "#dce775",
  400: "#d4e157",
  500: "#cddc39",
  600: "#c0ca33",
  700: "#afb42b",
  800: "#9e9d24",
  900: "#827717",
  A100: "#f4ff81",
  A200: "#eeff41",
  A400: "#c6ff00",
  A700: "#aeea00"
};
const Zut = Xut;
var eft = {
  50: "#fffde7",
  100: "#fff9c4",
  200: "#fff59d",
  300: "#fff176",
  400: "#ffee58",
  500: "#ffeb3b",
  600: "#fdd835",
  700: "#fbc02d",
  800: "#f9a825",
  900: "#f57f17",
  A100: "#ffff8d",
  A200: "#ffff00",
  A400: "#ffea00",
  A700: "#ffd600"
};
const tft = eft;
var nft = {
  50: "#fff8e1",
  100: "#ffecb3",
  200: "#ffe082",
  300: "#ffd54f",
  400: "#ffca28",
  500: "#ffc107",
  600: "#ffb300",
  700: "#ffa000",
  800: "#ff8f00",
  900: "#ff6f00",
  A100: "#ffe57f",
  A200: "#ffd740",
  A400: "#ffc400",
  A700: "#ffab00"
};
const rft = nft;
var ift = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
};
const ak = ift;
var oft = {
  50: "#fbe9e7",
  100: "#ffccbc",
  200: "#ffab91",
  300: "#ff8a65",
  400: "#ff7043",
  500: "#ff5722",
  600: "#f4511e",
  700: "#e64a19",
  800: "#d84315",
  900: "#bf360c",
  A100: "#ff9e80",
  A200: "#ff6e40",
  A400: "#ff3d00",
  A700: "#dd2c00"
};
const sft = oft;
var aft = {
  50: "#efebe9",
  100: "#d7ccc8",
  200: "#bcaaa4",
  300: "#a1887f",
  400: "#8d6e63",
  500: "#795548",
  600: "#6d4c41",
  700: "#5d4037",
  800: "#4e342e",
  900: "#3e2723",
  A100: "#d7ccc8",
  A200: "#bcaaa4",
  A400: "#8d6e63",
  A700: "#5d4037"
};
const Aft = aft;
var lft = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#d5d5d5",
  A200: "#aaaaaa",
  A400: "#303030",
  A700: "#616161"
};
const eH = lft;
var cft = {
  50: "#eceff1",
  100: "#cfd8dc",
  200: "#b0bec5",
  300: "#90a4ae",
  400: "#78909c",
  500: "#607d8b",
  600: "#546e7a",
  700: "#455a64",
  800: "#37474f",
  900: "#263238",
  A100: "#cfd8dc",
  A200: "#b0bec5",
  A400: "#78909c",
  A700: "#455a64"
};
const uft = cft, fft = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  amber: rft,
  blue: ok,
  blueGrey: uft,
  brown: Aft,
  common: nT,
  cyan: Yut,
  deepOrange: sft,
  deepPurple: Gut,
  green: sk,
  grey: eH,
  indigo: ik,
  lightBlue: qut,
  lightGreen: Wut,
  lime: Zut,
  orange: ak,
  pink: rk,
  purple: Put,
  red: nk,
  teal: Vut,
  yellow: tft
}, Symbol.toStringTag, { value: "Module" }));
function Ns() {
  return Ns = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Ns.apply(this, arguments);
}
function Og(t) {
  "@babel/helpers - typeof";
  return Og = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Og(t);
}
function uz(t) {
  return t && Og(t) === "object" && t.constructor === Object;
}
function Uv(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    clone: !0
  }, r = n.clone ? Ns({}, t) : t;
  return uz(t) && uz(e) && Object.keys(e).forEach(function(i) {
    i !== "__proto__" && (uz(e[i]) && i in t ? r[i] = Uv(t[i], e[i], n) : r[i] = e[i]);
  }), r;
}
var K3e = { exports: {} }, gft = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", hft = gft, dft = hft;
function W3e() {
}
function X3e() {
}
X3e.resetWarningCache = W3e;
var pft = function() {
  function t(r, i, o, s, a, A) {
    if (A !== dft) {
      var l = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw l.name = "Invariant Violation", l;
    }
  }
  t.isRequired = t;
  function e() {
    return t;
  }
  var n = {
    array: t,
    bigint: t,
    bool: t,
    func: t,
    number: t,
    object: t,
    string: t,
    symbol: t,
    any: t,
    arrayOf: e,
    element: t,
    elementType: t,
    instanceOf: e,
    node: t,
    objectOf: e,
    oneOf: e,
    oneOfType: e,
    shape: e,
    exact: e,
    checkPropTypes: X3e,
    resetWarningCache: W3e
  };
  return n.PropTypes = n, n;
};
K3e.exports = pft();
var Ja = K3e.exports;
const ut = /* @__PURE__ */ ko(Ja);
function Ift(t, e) {
  if (Og(t) !== "object" || t === null)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (Og(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Z3e(t) {
  var e = Ift(t, "string");
  return Og(e) === "symbol" ? e : String(e);
}
function ae(t, e, n) {
  return e = Z3e(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function vS(t) {
  for (var e = "https://mui.com/production-error/?code=" + t, n = 1; n < arguments.length; n += 1)
    e += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified Material-UI error #" + t + "; visit " + e + " for the full message.";
}
var es = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tH = 60103, nH = 60106, nL = 60107, rL = 60108, iL = 60114, oL = 60109, sL = 60110, aL = 60112, AL = 60113, Ase = 60120, lL = 60115, cL = 60116, eke = 60121, tke = 60122, nke = 60117, rke = 60129, ike = 60131;
if (typeof Symbol == "function" && Symbol.for) {
  var ZA = Symbol.for;
  tH = ZA("react.element"), nH = ZA("react.portal"), nL = ZA("react.fragment"), rL = ZA("react.strict_mode"), iL = ZA("react.profiler"), oL = ZA("react.provider"), sL = ZA("react.context"), aL = ZA("react.forward_ref"), AL = ZA("react.suspense"), Ase = ZA("react.suspense_list"), lL = ZA("react.memo"), cL = ZA("react.lazy"), eke = ZA("react.block"), tke = ZA("react.server.block"), nke = ZA("react.fundamental"), rke = ZA("react.debug_trace_mode"), ike = ZA("react.legacy_hidden");
}
function yd(t) {
  if (typeof t == "object" && t !== null) {
    var e = t.$$typeof;
    switch (e) {
      case tH:
        switch (t = t.type, t) {
          case nL:
          case iL:
          case rL:
          case AL:
          case Ase:
            return t;
          default:
            switch (t = t && t.$$typeof, t) {
              case sL:
              case aL:
              case cL:
              case lL:
              case oL:
                return t;
              default:
                return e;
            }
        }
      case nH:
        return e;
    }
  }
}
var mft = oL, Cft = tH, Eft = aL, yft = nL, vft = cL, Bft = lL, bft = nH, _ft = iL, Sft = rL, Qft = AL;
es.ContextConsumer = sL;
es.ContextProvider = mft;
es.Element = Cft;
es.ForwardRef = Eft;
es.Fragment = yft;
es.Lazy = vft;
es.Memo = Bft;
es.Portal = bft;
es.Profiler = _ft;
es.StrictMode = Sft;
es.Suspense = Qft;
es.isAsyncMode = function() {
  return !1;
};
es.isConcurrentMode = function() {
  return !1;
};
es.isContextConsumer = function(t) {
  return yd(t) === sL;
};
es.isContextProvider = function(t) {
  return yd(t) === oL;
};
es.isElement = function(t) {
  return typeof t == "object" && t !== null && t.$$typeof === tH;
};
es.isForwardRef = function(t) {
  return yd(t) === aL;
};
es.isFragment = function(t) {
  return yd(t) === nL;
};
es.isLazy = function(t) {
  return yd(t) === cL;
};
es.isMemo = function(t) {
  return yd(t) === lL;
};
es.isPortal = function(t) {
  return yd(t) === nH;
};
es.isProfiler = function(t) {
  return yd(t) === iL;
};
es.isStrictMode = function(t) {
  return yd(t) === rL;
};
es.isSuspense = function(t) {
  return yd(t) === AL;
};
es.isValidElementType = function(t) {
  return typeof t == "string" || typeof t == "function" || t === nL || t === iL || t === rke || t === rL || t === AL || t === Ase || t === ike || typeof t == "object" && t !== null && (t.$$typeof === cL || t.$$typeof === lL || t.$$typeof === oL || t.$$typeof === sL || t.$$typeof === aL || t.$$typeof === nke || t.$$typeof === eke || t[0] === tke);
};
es.typeOf = yd;
function lse(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return Math.min(Math.max(e, t), n);
}
function wft(t) {
  t = t.substr(1);
  var e = new RegExp(".{1,".concat(t.length >= 6 ? 2 : 1, "}"), "g"), n = t.match(e);
  return n && n[0].length === 1 && (n = n.map(function(r) {
    return r + r;
  })), n ? "rgb".concat(n.length === 4 ? "a" : "", "(").concat(n.map(function(r, i) {
    return i < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3;
  }).join(", "), ")") : "";
}
function xft(t) {
  t = Hv(t);
  var e = t, n = e.values, r = n[0], i = n[1] / 100, o = n[2] / 100, s = i * Math.min(o, 1 - o), a = function(u) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (u + r / 30) % 12;
    return o - s * Math.max(Math.min(f - 3, 9 - f, 1), -1);
  }, A = "rgb", l = [Math.round(a(0) * 255), Math.round(a(8) * 255), Math.round(a(4) * 255)];
  return t.type === "hsla" && (A += "a", l.push(n[3])), rH({
    type: A,
    values: l
  });
}
function Hv(t) {
  if (t.type)
    return t;
  if (t.charAt(0) === "#")
    return Hv(wft(t));
  var e = t.indexOf("("), n = t.substring(0, e);
  if (["rgb", "rgba", "hsl", "hsla"].indexOf(n) === -1)
    throw new Error(vS(3, t));
  var r = t.substring(e + 1, t.length - 1).split(",");
  return r = r.map(function(i) {
    return parseFloat(i);
  }), {
    type: n,
    values: r
  };
}
function rH(t) {
  var e = t.type, n = t.values;
  return e.indexOf("rgb") !== -1 ? n = n.map(function(r, i) {
    return i < 3 ? parseInt(r, 10) : r;
  }) : e.indexOf("hsl") !== -1 && (n[1] = "".concat(n[1], "%"), n[2] = "".concat(n[2], "%")), "".concat(e, "(").concat(n.join(", "), ")");
}
function Rft(t, e) {
  var n = xme(t), r = xme(e);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function xme(t) {
  t = Hv(t);
  var e = t.type === "hsl" ? Hv(xft(t)).values : t.values;
  return e = e.map(function(n) {
    return n /= 255, n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
  }), Number((0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2]).toFixed(3));
}
function xa(t, e) {
  return t = Hv(t), e = lse(e), (t.type === "rgb" || t.type === "hsl") && (t.type += "a"), t.values[3] = e, rH(t);
}
function cse(t, e) {
  if (t = Hv(t), e = lse(e), t.type.indexOf("hsl") !== -1)
    t.values[2] *= 1 - e;
  else if (t.type.indexOf("rgb") !== -1)
    for (var n = 0; n < 3; n += 1)
      t.values[n] *= 1 - e;
  return rH(t);
}
function use(t, e) {
  if (t = Hv(t), e = lse(e), t.type.indexOf("hsl") !== -1)
    t.values[2] += (100 - t.values[2]) * e;
  else if (t.type.indexOf("rgb") !== -1)
    for (var n = 0; n < 3; n += 1)
      t.values[n] += (255 - t.values[n]) * e;
  return rH(t);
}
function mo(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function fse(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
function Rn(t, e) {
  if (t == null)
    return {};
  var n = fse(t, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (i = 0; i < o.length; i++)
      r = o[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function at() {
  return at = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, at.apply(this, arguments);
}
var ym = ["xs", "sm", "md", "lg", "xl"];
function Dft(t) {
  var e = t.values, n = e === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : e, r = t.unit, i = r === void 0 ? "px" : r, o = t.step, s = o === void 0 ? 5 : o, a = Rn(t, ["values", "unit", "step"]);
  function A(h) {
    var d = typeof n[h] == "number" ? n[h] : h;
    return "@media (min-width:".concat(d).concat(i, ")");
  }
  function l(h) {
    var d = ym.indexOf(h) + 1, I = n[ym[d]];
    if (d === ym.length)
      return A("xs");
    var m = typeof I == "number" && d > 0 ? I : h;
    return "@media (max-width:".concat(m - s / 100).concat(i, ")");
  }
  function c(h, d) {
    var I = ym.indexOf(d);
    return I === ym.length - 1 ? A(h) : "@media (min-width:".concat(typeof n[h] == "number" ? n[h] : h).concat(i, ") and ") + "(max-width:".concat((I !== -1 && typeof n[ym[I + 1]] == "number" ? n[ym[I + 1]] : d) - s / 100).concat(i, ")");
  }
  function u(h) {
    return c(h, h);
  }
  function f(h) {
    return n[h];
  }
  return at({
    keys: ym,
    values: n,
    up: A,
    down: l,
    between: c,
    only: u,
    width: f
  }, a);
}
function Tft(t, e, n) {
  var r;
  return at({
    gutters: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return console.warn(["Material-UI: theme.mixins.gutters() is deprecated.", "You can use the source of the mixin directly:", `
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
      `].join(`
`)), at({
        paddingLeft: e(2),
        paddingRight: e(2)
      }, o, mo({}, t.up("sm"), at({
        paddingLeft: e(3),
        paddingRight: e(3)
      }, o[t.up("sm")])));
    },
    toolbar: (r = {
      minHeight: 56
    }, mo(r, "".concat(t.up("xs"), " and (orientation: landscape)"), {
      minHeight: 48
    }), mo(r, t.up("sm"), {
      minHeight: 64
    }), r)
  }, n);
}
var Rme = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.54)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)",
    // Text hints.
    hint: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: nT.white,
    default: eH[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, fz = {
  text: {
    primary: nT.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    hint: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: eH[800],
    default: "#303030"
  },
  action: {
    active: nT.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function Dme(t, e, n, r) {
  var i = r.light || r, o = r.dark || r * 1.5;
  t[e] || (t.hasOwnProperty(n) ? t[e] = t[n] : e === "light" ? t.light = use(t.main, i) : e === "dark" && (t.dark = cse(t.main, o)));
}
function Nft(t) {
  var e = t.primary, n = e === void 0 ? {
    light: ik[300],
    main: ik[500],
    dark: ik[700]
  } : e, r = t.secondary, i = r === void 0 ? {
    light: rk.A200,
    main: rk.A400,
    dark: rk.A700
  } : r, o = t.error, s = o === void 0 ? {
    light: nk[300],
    main: nk[500],
    dark: nk[700]
  } : o, a = t.warning, A = a === void 0 ? {
    light: ak[300],
    main: ak[500],
    dark: ak[700]
  } : a, l = t.info, c = l === void 0 ? {
    light: ok[300],
    main: ok[500],
    dark: ok[700]
  } : l, u = t.success, f = u === void 0 ? {
    light: sk[300],
    main: sk[500],
    dark: sk[700]
  } : u, h = t.type, d = h === void 0 ? "light" : h, I = t.contrastThreshold, m = I === void 0 ? 3 : I, C = t.tonalOffset, y = C === void 0 ? 0.2 : C, v = Rn(t, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
  function b(M) {
    var O = Rft(M, fz.text.primary) >= m ? fz.text.primary : Rme.text.primary;
    return O;
  }
  var Q = function(O) {
    var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, N = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 300, k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 700;
    if (O = at({}, O), !O.main && O[L] && (O.main = O[L]), !O.main)
      throw new Error(vS(4, L));
    if (typeof O.main != "string")
      throw new Error(vS(5, JSON.stringify(O.main)));
    return Dme(O, "light", N, y), Dme(O, "dark", k, y), O.contrastText || (O.contrastText = b(O.main)), O;
  }, w = {
    dark: fz,
    light: Rme
  }, R = Uv(at({
    // A collection of common colors.
    common: nT,
    // The palette type, can be light or dark.
    type: d,
    // The colors used to represent primary interface elements for a user.
    primary: Q(n),
    // The colors used to represent secondary interface elements for a user.
    secondary: Q(i, "A400", "A200", "A700"),
    // The colors used to represent interface elements that the user should be made aware of.
    error: Q(s),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: Q(A),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: Q(c),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: Q(f),
    // The grey colors.
    grey: eH,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: m,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: b,
    // Generate a rich color object.
    augmentColor: Q,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: y
  }, w[d]), v);
  return R;
}
function oke(t) {
  return Math.round(t * 1e5) / 1e5;
}
function Lft(t) {
  return oke(t);
}
var Tme = {
  textTransform: "uppercase"
}, Nme = '"Roboto", "Helvetica", "Arial", sans-serif';
function Mft(t, e) {
  var n = typeof e == "function" ? e(t) : e, r = n.fontFamily, i = r === void 0 ? Nme : r, o = n.fontSize, s = o === void 0 ? 14 : o, a = n.fontWeightLight, A = a === void 0 ? 300 : a, l = n.fontWeightRegular, c = l === void 0 ? 400 : l, u = n.fontWeightMedium, f = u === void 0 ? 500 : u, h = n.fontWeightBold, d = h === void 0 ? 700 : h, I = n.htmlFontSize, m = I === void 0 ? 16 : I, C = n.allVariants, y = n.pxToRem, v = Rn(n, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]), b = s / 14, Q = y || function(M) {
    return "".concat(M / m * b, "rem");
  }, w = function(O, L, N, k, $) {
    return at({
      fontFamily: i,
      fontWeight: O,
      fontSize: Q(L),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: N
    }, i === Nme ? {
      letterSpacing: "".concat(oke(k / L), "em")
    } : {}, $, C);
  }, R = {
    h1: w(A, 96, 1.167, -1.5),
    h2: w(A, 60, 1.2, -0.5),
    h3: w(c, 48, 1.167, 0),
    h4: w(c, 34, 1.235, 0.25),
    h5: w(c, 24, 1.334, 0),
    h6: w(f, 20, 1.6, 0.15),
    subtitle1: w(c, 16, 1.75, 0.15),
    subtitle2: w(f, 14, 1.57, 0.1),
    body1: w(c, 16, 1.5, 0.15),
    body2: w(c, 14, 1.43, 0.15),
    button: w(f, 14, 1.75, 0.4, Tme),
    caption: w(c, 12, 1.66, 0.4),
    overline: w(c, 12, 2.66, 1, Tme)
  };
  return Uv(at({
    htmlFontSize: m,
    pxToRem: Q,
    round: Lft,
    // TODO v5: remove
    fontFamily: i,
    fontSize: s,
    fontWeightLight: A,
    fontWeightRegular: c,
    fontWeightMedium: f,
    fontWeightBold: d
  }, R), v, {
    clone: !1
    // No need to clone deep
  });
}
var Oft = 0.2, Fft = 0.14, Pft = 0.12;
function Qs() {
  return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(Oft, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(Fft, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(Pft, ")")].join(",");
}
var kft = ["none", Qs(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Qs(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Qs(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Qs(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Qs(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Qs(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Qs(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Qs(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Qs(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Qs(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Qs(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Qs(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Qs(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Qs(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Qs(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Qs(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Qs(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Qs(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Qs(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Qs(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Qs(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Qs(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Qs(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Qs(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
const Gft = kft;
var Uft = {
  borderRadius: 4
};
const Hft = Uft;
function OX(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function $ft(t) {
  if (Array.isArray(t))
    return OX(t);
}
function ske(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function gse(t, e) {
  if (t) {
    if (typeof t == "string")
      return OX(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return OX(t, e);
  }
}
function qft() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iH(t) {
  return $ft(t) || ske(t) || gse(t) || qft();
}
function rT(t) {
  "@babel/helpers - typeof";
  return rT = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, rT(t);
}
function I4(t, e) {
  return e ? Uv(t, e, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : t;
}
var jft = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
}, Lme = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: function(e) {
    return "@media (min-width:".concat(jft[e], "px)");
  }
};
function ake(t, e, n) {
  if (Array.isArray(e)) {
    var r = t.theme.breakpoints || Lme;
    return e.reduce(function(s, a, A) {
      return s[r.up(r.keys[A])] = n(e[A]), s;
    }, {});
  }
  if (rT(e) === "object") {
    var i = t.theme.breakpoints || Lme;
    return Object.keys(e).reduce(function(s, a) {
      return s[i.up(a)] = n(e[a]), s;
    }, {});
  }
  var o = n(e);
  return o;
}
function Mme(t, e) {
  return !e || typeof e != "string" ? null : e.split(".").reduce(function(n, r) {
    return n && n[r] ? n[r] : null;
  }, t);
}
function Un(t) {
  var e = t.prop, n = t.cssProperty, r = n === void 0 ? t.prop : n, i = t.themeKey, o = t.transform, s = function(A) {
    if (A[e] == null)
      return null;
    var l = A[e], c = A.theme, u = Mme(c, i) || {}, f = function(d) {
      var I;
      return typeof u == "function" ? I = u(d) : Array.isArray(u) ? I = u[d] || d : (I = Mme(u, d) || d, o && (I = o(I))), r === !1 ? I : mo({}, r, I);
    };
    return ake(A, l, f);
  };
  return s.propTypes = {}, s.filterProps = [e], s;
}
function HI() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  var r = function(o) {
    return e.reduce(function(s, a) {
      var A = a(o);
      return A ? I4(s, A) : s;
    }, {});
  };
  return r.propTypes = {}, r.filterProps = e.reduce(function(i, o) {
    return i.concat(o.filterProps);
  }, []), r;
}
function uL(t) {
  return typeof t != "number" ? t : "".concat(t, "px solid");
}
var Yft = Un({
  prop: "border",
  themeKey: "borders",
  transform: uL
}), zft = Un({
  prop: "borderTop",
  themeKey: "borders",
  transform: uL
}), Vft = Un({
  prop: "borderRight",
  themeKey: "borders",
  transform: uL
}), Jft = Un({
  prop: "borderBottom",
  themeKey: "borders",
  transform: uL
}), Kft = Un({
  prop: "borderLeft",
  themeKey: "borders",
  transform: uL
}), Wft = Un({
  prop: "borderColor",
  themeKey: "palette"
}), Xft = Un({
  prop: "borderRadius",
  themeKey: "shape"
}), Zft = HI(Yft, zft, Vft, Jft, Kft, Wft, Xft);
const egt = Zft;
function Ome(t, e) {
  var n = {};
  return Object.keys(t).forEach(function(r) {
    e.indexOf(r) === -1 && (n[r] = t[r]);
  }), n;
}
function tgt(t) {
  var e = function(r) {
    var i = t(r);
    return r.css ? at({}, I4(i, t(at({
      theme: r.theme
    }, r.css))), Ome(r.css, [t.filterProps])) : r.sx ? at({}, I4(i, t(at({
      theme: r.theme
    }, r.sx))), Ome(r.sx, [t.filterProps])) : i;
  };
  return e.propTypes = {}, e.filterProps = ["css", "sx"].concat(iH(t.filterProps)), e;
}
var ngt = Un({
  prop: "displayPrint",
  cssProperty: !1,
  transform: function(e) {
    return {
      "@media print": {
        display: e
      }
    };
  }
}), rgt = Un({
  prop: "display"
}), igt = Un({
  prop: "overflow"
}), ogt = Un({
  prop: "textOverflow"
}), sgt = Un({
  prop: "visibility"
}), agt = Un({
  prop: "whiteSpace"
});
const Agt = HI(ngt, rgt, igt, ogt, sgt, agt);
var lgt = Un({
  prop: "flexBasis"
}), cgt = Un({
  prop: "flexDirection"
}), ugt = Un({
  prop: "flexWrap"
}), fgt = Un({
  prop: "justifyContent"
}), ggt = Un({
  prop: "alignItems"
}), hgt = Un({
  prop: "alignContent"
}), dgt = Un({
  prop: "order"
}), pgt = Un({
  prop: "flex"
}), Igt = Un({
  prop: "flexGrow"
}), mgt = Un({
  prop: "flexShrink"
}), Cgt = Un({
  prop: "alignSelf"
}), Egt = Un({
  prop: "justifyItems"
}), ygt = Un({
  prop: "justifySelf"
}), vgt = HI(lgt, cgt, ugt, fgt, ggt, hgt, dgt, pgt, Igt, mgt, Cgt, Egt, ygt);
const Bgt = vgt;
var bgt = Un({
  prop: "gridGap"
}), _gt = Un({
  prop: "gridColumnGap"
}), Sgt = Un({
  prop: "gridRowGap"
}), Qgt = Un({
  prop: "gridColumn"
}), wgt = Un({
  prop: "gridRow"
}), xgt = Un({
  prop: "gridAutoFlow"
}), Rgt = Un({
  prop: "gridAutoColumns"
}), Dgt = Un({
  prop: "gridAutoRows"
}), Tgt = Un({
  prop: "gridTemplateColumns"
}), Ngt = Un({
  prop: "gridTemplateRows"
}), Lgt = Un({
  prop: "gridTemplateAreas"
}), Mgt = Un({
  prop: "gridArea"
}), Ogt = HI(bgt, _gt, Sgt, Qgt, wgt, xgt, Rgt, Dgt, Tgt, Ngt, Lgt, Mgt);
const Fgt = Ogt;
var Pgt = Un({
  prop: "color",
  themeKey: "palette"
}), kgt = Un({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette"
}), Ggt = HI(Pgt, kgt);
const Ugt = Ggt;
var Hgt = Un({
  prop: "position"
}), $gt = Un({
  prop: "zIndex",
  themeKey: "zIndex"
}), qgt = Un({
  prop: "top"
}), jgt = Un({
  prop: "right"
}), Ygt = Un({
  prop: "bottom"
}), zgt = Un({
  prop: "left"
});
const Vgt = HI(Hgt, $gt, qgt, jgt, Ygt, zgt);
var Jgt = Un({
  prop: "boxShadow",
  themeKey: "shadows"
});
const Kgt = Jgt;
function EE(t) {
  return t <= 1 ? "".concat(t * 100, "%") : t;
}
var Wgt = Un({
  prop: "width",
  transform: EE
}), Xgt = Un({
  prop: "maxWidth",
  transform: EE
}), Zgt = Un({
  prop: "minWidth",
  transform: EE
}), eht = Un({
  prop: "height",
  transform: EE
}), tht = Un({
  prop: "maxHeight",
  transform: EE
}), nht = Un({
  prop: "minHeight",
  transform: EE
});
Un({
  prop: "size",
  cssProperty: "width",
  transform: EE
});
Un({
  prop: "size",
  cssProperty: "height",
  transform: EE
});
var rht = Un({
  prop: "boxSizing"
}), iht = HI(Wgt, Xgt, Zgt, eht, tht, nht, rht);
const oht = iht;
function Ake(t) {
  if (Array.isArray(t))
    return t;
}
function sht(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, s, a;
    try {
      for (n = n.call(t); !(i = (s = n.next()).done) && (r.push(s.value), !(e && r.length === e)); i = !0)
        ;
    } catch (A) {
      o = !0, a = A;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o)
          throw a;
      }
    }
    return r;
  }
}
function lke() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yE(t, e) {
  return Ake(t) || sht(t, e) || gse(t, e) || lke();
}
function aht(t) {
  var e = {};
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var Aht = {
  m: "margin",
  p: "padding"
}, lht = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, Fme = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, cht = aht(function(t) {
  if (t.length > 2)
    if (Fme[t])
      t = Fme[t];
    else
      return [t];
  var e = t.split(""), n = yE(e, 2), r = n[0], i = n[1], o = Aht[r], s = lht[i] || "";
  return Array.isArray(s) ? s.map(function(a) {
    return o + a;
  }) : [o + s];
}), cke = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];
function uke(t) {
  var e = t.spacing || 8;
  return typeof e == "number" ? function(n) {
    return e * n;
  } : Array.isArray(e) ? function(n) {
    return e[n];
  } : typeof e == "function" ? e : function() {
  };
}
function uht(t, e) {
  if (typeof e == "string" || e == null)
    return e;
  var n = Math.abs(e), r = t(n);
  return e >= 0 ? r : typeof r == "number" ? -r : "-".concat(r);
}
function fht(t, e) {
  return function(n) {
    return t.reduce(function(r, i) {
      return r[i] = uht(e, n), r;
    }, {});
  };
}
function hse(t) {
  var e = t.theme, n = uke(e);
  return Object.keys(t).map(function(r) {
    if (cke.indexOf(r) === -1)
      return null;
    var i = cht(r), o = fht(i, n), s = t[r];
    return ake(t, s, o);
  }).reduce(I4, {});
}
hse.propTypes = {};
hse.filterProps = cke;
var ght = Un({
  prop: "fontFamily",
  themeKey: "typography"
}), hht = Un({
  prop: "fontSize",
  themeKey: "typography"
}), dht = Un({
  prop: "fontStyle",
  themeKey: "typography"
}), pht = Un({
  prop: "fontWeight",
  themeKey: "typography"
}), Iht = Un({
  prop: "letterSpacing"
}), mht = Un({
  prop: "lineHeight"
}), Cht = Un({
  prop: "textAlign"
}), Eht = HI(ght, hht, dht, pht, Iht, mht, Cht);
const yht = Eht;
function vht() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
  if (t.mui)
    return t;
  var e = uke({
    spacing: t
  }), n = function() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return o.length === 0 ? e(1) : o.length === 1 ? e(o[0]) : o.map(function(a) {
      if (typeof a == "string")
        return a;
      var A = e(a);
      return typeof A == "number" ? "".concat(A, "px") : A;
    }).join(" ");
  };
  return Object.defineProperty(n, "unit", {
    get: function() {
      return t;
    }
  }), n.mui = !0, n;
}
var Pme = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, iT = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function kme(t) {
  return "".concat(Math.round(t), "ms");
}
const Bht = {
  easing: Pme,
  duration: iT,
  create: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["all"], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.duration, i = r === void 0 ? iT.standard : r, o = n.easing, s = o === void 0 ? Pme.easeInOut : o, a = n.delay, A = a === void 0 ? 0 : a;
    return Rn(n, ["duration", "easing", "delay"]), (Array.isArray(e) ? e : [e]).map(function(l) {
      return "".concat(l, " ").concat(typeof i == "string" ? i : kme(i), " ").concat(s, " ").concat(typeof A == "string" ? A : kme(A));
    }).join(",");
  },
  getAutoHeightDuration: function(e) {
    if (!e)
      return 0;
    var n = e / 36;
    return Math.round((4 + 15 * Math.pow(n, 0.25) + n / 5) * 10);
  }
};
var bht = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
const fke = bht;
function FX() {
  for (var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.breakpoints, n = e === void 0 ? {} : e, r = t.mixins, i = r === void 0 ? {} : r, o = t.palette, s = o === void 0 ? {} : o, a = t.spacing, A = t.typography, l = A === void 0 ? {} : A, c = Rn(t, ["breakpoints", "mixins", "palette", "spacing", "typography"]), u = Nft(s), f = Dft(n), h = vht(a), d = Uv({
    breakpoints: f,
    direction: "ltr",
    mixins: Tft(f, h, i),
    overrides: {},
    // Inject custom styles
    palette: u,
    props: {},
    // Provide default props
    shadows: Gft,
    typography: Mft(u, l),
    spacing: h,
    shape: Hft,
    transitions: Bht,
    zIndex: fke
  }, c), I = arguments.length, m = new Array(I > 1 ? I - 1 : 0), C = 1; C < I; C++)
    m[C - 1] = arguments[C];
  return d = m.reduce(function(y, v) {
    return Uv(y, v);
  }, d), d;
}
var _ht = typeof Symbol == "function" && Symbol.for;
const gke = _ht ? Symbol.for("mui.nested") : "__THEME_NESTED__";
var Sht = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function Qht() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.disableGlobal, n = e === void 0 ? !1 : e, r = t.productionPrefix, i = r === void 0 ? "jss" : r, o = t.seed, s = o === void 0 ? "" : o, a = s === "" ? "" : "".concat(s, "-"), A = 0, l = function() {
    return A += 1, A;
  };
  return function(c, u) {
    var f = u.options.name;
    if (f && f.indexOf("Mui") === 0 && !u.options.link && !n) {
      if (Sht.indexOf(c.key) !== -1)
        return "Mui-".concat(c.key);
      var h = "".concat(a).concat(f, "-").concat(c.key);
      return !u.options.theme[gke] || s !== "" ? h : "".concat(h, "-").concat(l());
    }
    return "".concat(a).concat(i).concat(l());
  };
}
function hke(t) {
  var e = t.theme, n = t.name, r = t.props;
  if (!e || !e.props || !e.props[n])
    return r;
  var i = e.props[n], o;
  for (o in i)
    r[o] === void 0 && (r[o] = i[o]);
  return r;
}
var Gme = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
  return typeof t;
} : function(t) {
  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
}, fL = (typeof window > "u" ? "undefined" : Gme(window)) === "object" && (typeof document > "u" ? "undefined" : Gme(document)) === "object" && document.nodeType === 9;
function Ume(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, Z3e(r.key), r);
  }
}
function oH(t, e, n) {
  return e && Ume(t.prototype, e), n && Ume(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function m4(t, e) {
  return m4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, m4(t, e);
}
function dke(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, m4(t, e);
}
function C4(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function pke(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
var wht = {}.constructor;
function PX(t) {
  if (t == null || typeof t != "object")
    return t;
  if (Array.isArray(t))
    return t.map(PX);
  if (t.constructor !== wht)
    return t;
  var e = {};
  for (var n in t)
    e[n] = PX(t[n]);
  return e;
}
function dse(t, e, n) {
  t === void 0 && (t = "unnamed");
  var r = n.jss, i = PX(e), o = r.plugins.onCreateRule(t, i, n);
  return o || (t[0], null);
}
var Hme = function(e, n) {
  for (var r = "", i = 0; i < e.length && e[i] !== "!important"; i++)
    r && (r += n), r += e[i];
  return r;
}, Ev = function(e) {
  if (!Array.isArray(e))
    return e;
  var n = "";
  if (Array.isArray(e[0]))
    for (var r = 0; r < e.length && e[r] !== "!important"; r++)
      n && (n += ", "), n += Hme(e[r], " ");
  else
    n = Hme(e, ", ");
  return e[e.length - 1] === "!important" && (n += " !important"), n;
};
function zQ(t) {
  return t && t.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function kx(t, e) {
  for (var n = "", r = 0; r < e; r++)
    n += "  ";
  return n + t;
}
function oT(t, e, n) {
  n === void 0 && (n = {});
  var r = "";
  if (!e)
    return r;
  var i = n, o = i.indent, s = o === void 0 ? 0 : o, a = e.fallbacks;
  n.format === !1 && (s = -1 / 0);
  var A = zQ(n), l = A.linebreak, c = A.space;
  if (t && s++, a)
    if (Array.isArray(a))
      for (var u = 0; u < a.length; u++) {
        var f = a[u];
        for (var h in f) {
          var d = f[h];
          d != null && (r && (r += l), r += kx(h + ":" + c + Ev(d) + ";", s));
        }
      }
    else
      for (var I in a) {
        var m = a[I];
        m != null && (r && (r += l), r += kx(I + ":" + c + Ev(m) + ";", s));
      }
  for (var C in e) {
    var y = e[C];
    y != null && C !== "fallbacks" && (r && (r += l), r += kx(C + ":" + c + Ev(y) + ";", s));
  }
  return !r && !n.allowEmpty || !t ? r : (s--, r && (r = "" + l + r + l), kx("" + t + c + "{" + r, s) + kx("}", s));
}
var xht = /([[\].#*$><+~=|^:(),"'`\s])/g, $me = typeof CSS < "u" && CSS.escape, pse = function(t) {
  return $me ? $me(t) : t.replace(xht, "\\$1");
}, Ike = /* @__PURE__ */ function() {
  function t(n, r, i) {
    this.type = "style", this.isProcessed = !1;
    var o = i.sheet, s = i.Renderer;
    this.key = n, this.options = i, this.style = r, o ? this.renderer = o.renderer : s && (this.renderer = new s());
  }
  var e = t.prototype;
  return e.prop = function(r, i, o) {
    if (i === void 0)
      return this.style[r];
    var s = o ? o.force : !1;
    if (!s && this.style[r] === i)
      return this;
    var a = i;
    (!o || o.process !== !1) && (a = this.options.jss.plugins.onChangeValue(i, r, this));
    var A = a == null || a === !1, l = r in this.style;
    if (A && !l && !s)
      return this;
    var c = A && l;
    if (c ? delete this.style[r] : this.style[r] = a, this.renderable && this.renderer)
      return c ? this.renderer.removeProperty(this.renderable, r) : this.renderer.setProperty(this.renderable, r, a), this;
    var u = this.options.sheet;
    return u && u.attached, this;
  }, t;
}(), kX = /* @__PURE__ */ function(t) {
  dke(e, t);
  function e(r, i, o) {
    var s;
    s = t.call(this, r, i, o) || this;
    var a = o.selector, A = o.scoped, l = o.sheet, c = o.generateId;
    return a ? s.selectorText = a : A !== !1 && (s.id = c(C4(C4(s)), l), s.selectorText = "." + pse(s.id)), s;
  }
  var n = e.prototype;
  return n.applyTo = function(i) {
    var o = this.renderer;
    if (o) {
      var s = this.toJSON();
      for (var a in s)
        o.setProperty(i, a, s[a]);
    }
    return this;
  }, n.toJSON = function() {
    var i = {};
    for (var o in this.style) {
      var s = this.style[o];
      typeof s != "object" ? i[o] = s : Array.isArray(s) && (i[o] = Ev(s));
    }
    return i;
  }, n.toString = function(i) {
    var o = this.options.sheet, s = o ? o.options.link : !1, a = s ? Ns({}, i, {
      allowEmpty: !0
    }) : i;
    return oT(this.selectorText, this.style, a);
  }, oH(e, [{
    key: "selector",
    set: function(i) {
      if (i !== this.selectorText) {
        this.selectorText = i;
        var o = this.renderer, s = this.renderable;
        if (!(!s || !o)) {
          var a = o.setSelector(s, i);
          a || o.replaceRule(s, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), e;
}(Ike), Rht = {
  onCreateRule: function(e, n, r) {
    return e[0] === "@" || r.parent && r.parent.type === "keyframes" ? null : new kX(e, n, r);
  }
}, gz = {
  indent: 1,
  children: !0
}, Dht = /@([\w-]+)/, Tht = /* @__PURE__ */ function() {
  function t(n, r, i) {
    this.type = "conditional", this.isProcessed = !1, this.key = n;
    var o = n.match(Dht);
    this.at = o ? o[1] : "unknown", this.query = i.name || "@" + this.at, this.options = i, this.rules = new sH(Ns({}, i, {
      parent: this
    }));
    for (var s in r)
      this.rules.add(s, r[s]);
    this.rules.process();
  }
  var e = t.prototype;
  return e.getRule = function(r) {
    return this.rules.get(r);
  }, e.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, e.addRule = function(r, i, o) {
    var s = this.rules.add(r, i, o);
    return s ? (this.options.jss.plugins.onProcessRule(s), s) : null;
  }, e.replaceRule = function(r, i, o) {
    var s = this.rules.replace(r, i, o);
    return s && this.options.jss.plugins.onProcessRule(s), s;
  }, e.toString = function(r) {
    r === void 0 && (r = gz);
    var i = zQ(r), o = i.linebreak;
    if (r.indent == null && (r.indent = gz.indent), r.children == null && (r.children = gz.children), r.children === !1)
      return this.query + " {}";
    var s = this.rules.toString(r);
    return s ? this.query + " {" + o + s + o + "}" : "";
  }, t;
}(), Nht = /@media|@supports\s+/, Lht = {
  onCreateRule: function(e, n, r) {
    return Nht.test(e) ? new Tht(e, n, r) : null;
  }
}, hz = {
  indent: 1,
  children: !0
}, Mht = /@keyframes\s+([\w-]+)/, GX = /* @__PURE__ */ function() {
  function t(n, r, i) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var o = n.match(Mht);
    o && o[1] ? this.name = o[1] : this.name = "noname", this.key = this.type + "-" + this.name, this.options = i;
    var s = i.scoped, a = i.sheet, A = i.generateId;
    this.id = s === !1 ? this.name : pse(A(this, a)), this.rules = new sH(Ns({}, i, {
      parent: this
    }));
    for (var l in r)
      this.rules.add(l, r[l], Ns({}, i, {
        parent: this
      }));
    this.rules.process();
  }
  var e = t.prototype;
  return e.toString = function(r) {
    r === void 0 && (r = hz);
    var i = zQ(r), o = i.linebreak;
    if (r.indent == null && (r.indent = hz.indent), r.children == null && (r.children = hz.children), r.children === !1)
      return this.at + " " + this.id + " {}";
    var s = this.rules.toString(r);
    return s && (s = "" + o + s + o), this.at + " " + this.id + " {" + s + "}";
  }, t;
}(), Oht = /@keyframes\s+/, Fht = /\$([\w-]+)/g, UX = function(e, n) {
  return typeof e == "string" ? e.replace(Fht, function(r, i) {
    return i in n ? n[i] : r;
  }) : e;
}, qme = function(e, n, r) {
  var i = e[n], o = UX(i, r);
  o !== i && (e[n] = o);
}, Pht = {
  onCreateRule: function(e, n, r) {
    return typeof e == "string" && Oht.test(e) ? new GX(e, n, r) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(e, n, r) {
    return n.type !== "style" || !r || ("animation-name" in e && qme(e, "animation-name", r.keyframes), "animation" in e && qme(e, "animation", r.keyframes)), e;
  },
  onChangeValue: function(e, n, r) {
    var i = r.options.sheet;
    if (!i)
      return e;
    switch (n) {
      case "animation":
        return UX(e, i.keyframes);
      case "animation-name":
        return UX(e, i.keyframes);
      default:
        return e;
    }
  }
}, kht = /* @__PURE__ */ function(t) {
  dke(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var n = e.prototype;
  return n.toString = function(i) {
    var o = this.options.sheet, s = o ? o.options.link : !1, a = s ? Ns({}, i, {
      allowEmpty: !0
    }) : i;
    return oT(this.key, this.style, a);
  }, e;
}(Ike), Ght = {
  onCreateRule: function(e, n, r) {
    return r.parent && r.parent.type === "keyframes" ? new kht(e, n, r) : null;
  }
}, Uht = /* @__PURE__ */ function() {
  function t(n, r, i) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = n, this.style = r, this.options = i;
  }
  var e = t.prototype;
  return e.toString = function(r) {
    var i = zQ(r), o = i.linebreak;
    if (Array.isArray(this.style)) {
      for (var s = "", a = 0; a < this.style.length; a++)
        s += oT(this.at, this.style[a]), this.style[a + 1] && (s += o);
      return s;
    }
    return oT(this.at, this.style, r);
  }, t;
}(), Hht = /@font-face/, $ht = {
  onCreateRule: function(e, n, r) {
    return Hht.test(e) ? new Uht(e, n, r) : null;
  }
}, qht = /* @__PURE__ */ function() {
  function t(n, r, i) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = n, this.style = r, this.options = i;
  }
  var e = t.prototype;
  return e.toString = function(r) {
    return oT(this.key, this.style, r);
  }, t;
}(), jht = {
  onCreateRule: function(e, n, r) {
    return e === "@viewport" || e === "@-ms-viewport" ? new qht(e, n, r) : null;
  }
}, Yht = /* @__PURE__ */ function() {
  function t(n, r, i) {
    this.type = "simple", this.isProcessed = !1, this.key = n, this.value = r, this.options = i;
  }
  var e = t.prototype;
  return e.toString = function(r) {
    if (Array.isArray(this.value)) {
      for (var i = "", o = 0; o < this.value.length; o++)
        i += this.key + " " + this.value[o] + ";", this.value[o + 1] && (i += `
`);
      return i;
    }
    return this.key + " " + this.value + ";";
  }, t;
}(), zht = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, Vht = {
  onCreateRule: function(e, n, r) {
    return e in zht ? new Yht(e, n, r) : null;
  }
}, jme = [Rht, Lht, Pht, Ght, $ht, jht, Vht], Jht = {
  process: !0
}, Yme = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, sH = /* @__PURE__ */ function() {
  function t(n) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = n, this.classes = n.classes, this.keyframes = n.keyframes;
  }
  var e = t.prototype;
  return e.add = function(r, i, o) {
    var s = this.options, a = s.parent, A = s.sheet, l = s.jss, c = s.Renderer, u = s.generateId, f = s.scoped, h = Ns({
      classes: this.classes,
      parent: a,
      sheet: A,
      jss: l,
      Renderer: c,
      generateId: u,
      scoped: f,
      name: r,
      keyframes: this.keyframes,
      selector: void 0
    }, o), d = r;
    r in this.raw && (d = r + "-d" + this.counter++), this.raw[d] = i, d in this.classes && (h.selector = "." + pse(this.classes[d]));
    var I = dse(d, i, h);
    if (!I)
      return null;
    this.register(I);
    var m = h.index === void 0 ? this.index.length : h.index;
    return this.index.splice(m, 0, I), I;
  }, e.replace = function(r, i, o) {
    var s = this.get(r), a = this.index.indexOf(s);
    s && this.remove(s);
    var A = o;
    return a !== -1 && (A = Ns({}, o, {
      index: a
    })), this.add(r, i, A);
  }, e.get = function(r) {
    return this.map[r];
  }, e.remove = function(r) {
    this.unregister(r), delete this.raw[r.key], this.index.splice(this.index.indexOf(r), 1);
  }, e.indexOf = function(r) {
    return this.index.indexOf(r);
  }, e.process = function() {
    var r = this.options.jss.plugins;
    this.index.slice(0).forEach(r.onProcessRule, r);
  }, e.register = function(r) {
    this.map[r.key] = r, r instanceof kX ? (this.map[r.selector] = r, r.id && (this.classes[r.key] = r.id)) : r instanceof GX && this.keyframes && (this.keyframes[r.name] = r.id);
  }, e.unregister = function(r) {
    delete this.map[r.key], r instanceof kX ? (delete this.map[r.selector], delete this.classes[r.key]) : r instanceof GX && delete this.keyframes[r.name];
  }, e.update = function() {
    var r, i, o;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (r = arguments.length <= 0 ? void 0 : arguments[0], i = arguments.length <= 1 ? void 0 : arguments[1], o = arguments.length <= 2 ? void 0 : arguments[2]) : (i = arguments.length <= 0 ? void 0 : arguments[0], o = arguments.length <= 1 ? void 0 : arguments[1], r = null), r)
      this.updateOne(this.get(r), i, o);
    else
      for (var s = 0; s < this.index.length; s++)
        this.updateOne(this.index[s], i, o);
  }, e.updateOne = function(r, i, o) {
    o === void 0 && (o = Jht);
    var s = this.options, a = s.jss.plugins, A = s.sheet;
    if (r.rules instanceof t) {
      r.rules.update(i, o);
      return;
    }
    var l = r.style;
    if (a.onUpdate(i, r, A, o), o.process && l && l !== r.style) {
      a.onProcessStyle(r.style, r, A);
      for (var c in r.style) {
        var u = r.style[c], f = l[c];
        u !== f && r.prop(c, u, Yme);
      }
      for (var h in l) {
        var d = r.style[h], I = l[h];
        d == null && d !== I && r.prop(h, null, Yme);
      }
    }
  }, e.toString = function(r) {
    for (var i = "", o = this.options.sheet, s = o ? o.options.link : !1, a = zQ(r), A = a.linebreak, l = 0; l < this.index.length; l++) {
      var c = this.index[l], u = c.toString(r);
      !u && !s || (i && (i += A), i += u);
    }
    return i;
  }, t;
}(), mke = /* @__PURE__ */ function() {
  function t(n, r) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = Ns({}, r, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), r.Renderer && (this.renderer = new r.Renderer(this)), this.rules = new sH(this.options);
    for (var i in n)
      this.rules.add(i, n[i]);
    this.rules.process();
  }
  var e = t.prototype;
  return e.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, e.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, e.addRule = function(r, i, o) {
    var s = this.queue;
    this.attached && !s && (this.queue = []);
    var a = this.rules.add(r, i, o);
    return a ? (this.options.jss.plugins.onProcessRule(a), this.attached ? (this.deployed && (s ? s.push(a) : (this.insertRule(a), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), a) : (this.deployed = !1, a)) : null;
  }, e.replaceRule = function(r, i, o) {
    var s = this.rules.get(r);
    if (!s)
      return this.addRule(r, i, o);
    var a = this.rules.replace(r, i, o);
    return a && this.options.jss.plugins.onProcessRule(a), this.attached ? (this.deployed && this.renderer && (a ? s.renderable && this.renderer.replaceRule(s.renderable, a) : this.renderer.deleteRule(s)), a) : (this.deployed = !1, a);
  }, e.insertRule = function(r) {
    this.renderer && this.renderer.insertRule(r);
  }, e.addRules = function(r, i) {
    var o = [];
    for (var s in r) {
      var a = this.addRule(s, r[s], i);
      a && o.push(a);
    }
    return o;
  }, e.getRule = function(r) {
    return this.rules.get(r);
  }, e.deleteRule = function(r) {
    var i = typeof r == "object" ? r : this.rules.get(r);
    return !i || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !i.renderable ? !1 : (this.rules.remove(i), this.attached && i.renderable && this.renderer ? this.renderer.deleteRule(i.renderable) : !0);
  }, e.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, e.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, e.update = function() {
    var r;
    return (r = this.rules).update.apply(r, arguments), this;
  }, e.updateOne = function(r, i, o) {
    return this.rules.updateOne(r, i, o), this;
  }, e.toString = function(r) {
    return this.rules.toString(r);
  }, t;
}(), Kht = /* @__PURE__ */ function() {
  function t() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var e = t.prototype;
  return e.onCreateRule = function(r, i, o) {
    for (var s = 0; s < this.registry.onCreateRule.length; s++) {
      var a = this.registry.onCreateRule[s](r, i, o);
      if (a)
        return a;
    }
    return null;
  }, e.onProcessRule = function(r) {
    if (!r.isProcessed) {
      for (var i = r.options.sheet, o = 0; o < this.registry.onProcessRule.length; o++)
        this.registry.onProcessRule[o](r, i);
      r.style && this.onProcessStyle(r.style, r, i), r.isProcessed = !0;
    }
  }, e.onProcessStyle = function(r, i, o) {
    for (var s = 0; s < this.registry.onProcessStyle.length; s++)
      i.style = this.registry.onProcessStyle[s](i.style, i, o);
  }, e.onProcessSheet = function(r) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++)
      this.registry.onProcessSheet[i](r);
  }, e.onUpdate = function(r, i, o, s) {
    for (var a = 0; a < this.registry.onUpdate.length; a++)
      this.registry.onUpdate[a](r, i, o, s);
  }, e.onChangeValue = function(r, i, o) {
    for (var s = r, a = 0; a < this.registry.onChangeValue.length; a++)
      s = this.registry.onChangeValue[a](s, i, o);
    return s;
  }, e.use = function(r, i) {
    i === void 0 && (i = {
      queue: "external"
    });
    var o = this.plugins[i.queue];
    o.indexOf(r) === -1 && (o.push(r), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(s, a) {
      for (var A in a)
        A in s && s[A].push(a[A]);
      return s;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, t;
}(), Wht = /* @__PURE__ */ function() {
  function t() {
    this.registry = [];
  }
  var e = t.prototype;
  return e.add = function(r) {
    var i = this.registry, o = r.options.index;
    if (i.indexOf(r) === -1) {
      if (i.length === 0 || o >= this.index) {
        i.push(r);
        return;
      }
      for (var s = 0; s < i.length; s++)
        if (i[s].options.index > o) {
          i.splice(s, 0, r);
          return;
        }
    }
  }, e.reset = function() {
    this.registry = [];
  }, e.remove = function(r) {
    var i = this.registry.indexOf(r);
    this.registry.splice(i, 1);
  }, e.toString = function(r) {
    for (var i = r === void 0 ? {} : r, o = i.attached, s = pke(i, ["attached"]), a = zQ(s), A = a.linebreak, l = "", c = 0; c < this.registry.length; c++) {
      var u = this.registry[c];
      o != null && u.attached !== o || (l && (l += A), l += u.toString(s));
    }
    return l;
  }, oH(t, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), t;
}(), fD = new Wht(), HX = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), $X = "2f1acc6c3a606b082e5eef5e54414ffb";
HX[$X] == null && (HX[$X] = 0);
var zme = HX[$X]++, Vme = function(e) {
  e === void 0 && (e = {});
  var n = 0, r = function(o, s) {
    n += 1;
    var a = "", A = "";
    return s && (s.options.classNamePrefix && (A = s.options.classNamePrefix), s.options.jss.id != null && (a = String(s.options.jss.id))), e.minify ? "" + (A || "c") + zme + a + n : A + o.key + "-" + zme + (a ? "-" + a : "") + "-" + n;
  };
  return r;
}, Cke = function(e) {
  var n;
  return function() {
    return n || (n = e()), n;
  };
}, Xht = function(e, n) {
  try {
    return e.attributeStyleMap ? e.attributeStyleMap.get(n) : e.style.getPropertyValue(n);
  } catch {
    return "";
  }
}, Zht = function(e, n, r) {
  try {
    var i = r;
    if (Array.isArray(r) && (i = Ev(r)), e.attributeStyleMap)
      e.attributeStyleMap.set(n, i);
    else {
      var o = i ? i.indexOf("!important") : -1, s = o > -1 ? i.substr(0, o - 1) : i;
      e.style.setProperty(n, s, o > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, edt = function(e, n) {
  try {
    e.attributeStyleMap ? e.attributeStyleMap.delete(n) : e.style.removeProperty(n);
  } catch {
  }
}, tdt = function(e, n) {
  return e.selectorText = n, e.selectorText === n;
}, Eke = Cke(function() {
  return document.querySelector("head");
});
function ndt(t, e) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    if (r.attached && r.options.index > e.index && r.options.insertionPoint === e.insertionPoint)
      return r;
  }
  return null;
}
function rdt(t, e) {
  for (var n = t.length - 1; n >= 0; n--) {
    var r = t[n];
    if (r.attached && r.options.insertionPoint === e.insertionPoint)
      return r;
  }
  return null;
}
function idt(t) {
  for (var e = Eke(), n = 0; n < e.childNodes.length; n++) {
    var r = e.childNodes[n];
    if (r.nodeType === 8 && r.nodeValue.trim() === t)
      return r;
  }
  return null;
}
function odt(t) {
  var e = fD.registry;
  if (e.length > 0) {
    var n = ndt(e, t);
    if (n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element
      };
    if (n = rdt(e, t), n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element.nextSibling
      };
  }
  var r = t.insertionPoint;
  if (r && typeof r == "string") {
    var i = idt(r);
    if (i)
      return {
        parent: i.parentNode,
        node: i.nextSibling
      };
  }
  return !1;
}
function sdt(t, e) {
  var n = e.insertionPoint, r = odt(e);
  if (r !== !1 && r.parent) {
    r.parent.insertBefore(t, r.node);
    return;
  }
  if (n && typeof n.nodeType == "number") {
    var i = n, o = i.parentNode;
    o && o.insertBefore(t, i.nextSibling);
    return;
  }
  Eke().appendChild(t);
}
var adt = Cke(function() {
  var t = document.querySelector('meta[property="csp-nonce"]');
  return t ? t.getAttribute("content") : null;
}), Jme = function(e, n, r) {
  try {
    "insertRule" in e ? e.insertRule(n, r) : "appendRule" in e && e.appendRule(n);
  } catch {
    return !1;
  }
  return e.cssRules[r];
}, Kme = function(e, n) {
  var r = e.cssRules.length;
  return n === void 0 || n > r ? r : n;
}, Adt = function() {
  var e = document.createElement("style");
  return e.textContent = `
`, e;
}, ldt = /* @__PURE__ */ function() {
  function t(n) {
    this.getPropertyValue = Xht, this.setProperty = Zht, this.removeProperty = edt, this.setSelector = tdt, this.hasInsertedRules = !1, this.cssRules = [], n && fD.add(n), this.sheet = n;
    var r = this.sheet ? this.sheet.options : {}, i = r.media, o = r.meta, s = r.element;
    this.element = s || Adt(), this.element.setAttribute("data-jss", ""), i && this.element.setAttribute("media", i), o && this.element.setAttribute("data-meta", o);
    var a = adt();
    a && this.element.setAttribute("nonce", a);
  }
  var e = t.prototype;
  return e.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      sdt(this.element, this.sheet.options);
      var r = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && r && (this.hasInsertedRules = !1, this.deploy());
    }
  }, e.detach = function() {
    if (this.sheet) {
      var r = this.element.parentNode;
      r && r.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, e.deploy = function() {
    var r = this.sheet;
    if (r) {
      if (r.options.link) {
        this.insertRules(r.rules);
        return;
      }
      this.element.textContent = `
` + r.toString() + `
`;
    }
  }, e.insertRules = function(r, i) {
    for (var o = 0; o < r.index.length; o++)
      this.insertRule(r.index[o], o, i);
  }, e.insertRule = function(r, i, o) {
    if (o === void 0 && (o = this.element.sheet), r.rules) {
      var s = r, a = o;
      if (r.type === "conditional" || r.type === "keyframes") {
        var A = Kme(o, i);
        if (a = Jme(o, s.toString({
          children: !1
        }), A), a === !1)
          return !1;
        this.refCssRule(r, A, a);
      }
      return this.insertRules(s.rules, a), a;
    }
    var l = r.toString();
    if (!l)
      return !1;
    var c = Kme(o, i), u = Jme(o, l, c);
    return u === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(r, c, u), u);
  }, e.refCssRule = function(r, i, o) {
    r.renderable = o, r.options.parent instanceof mke && this.cssRules.splice(i, 0, o);
  }, e.deleteRule = function(r) {
    var i = this.element.sheet, o = this.indexOf(r);
    return o === -1 ? !1 : (i.deleteRule(o), this.cssRules.splice(o, 1), !0);
  }, e.indexOf = function(r) {
    return this.cssRules.indexOf(r);
  }, e.replaceRule = function(r, i) {
    var o = this.indexOf(r);
    return o === -1 ? !1 : (this.element.sheet.deleteRule(o), this.cssRules.splice(o, 1), this.insertRule(i, o));
  }, e.getRules = function() {
    return this.element.sheet.cssRules;
  }, t;
}(), cdt = 0, udt = /* @__PURE__ */ function() {
  function t(n) {
    this.id = cdt++, this.version = "10.9.2", this.plugins = new Kht(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: Vme,
      Renderer: fL ? ldt : null,
      plugins: []
    }, this.generateId = Vme({
      minify: !1
    });
    for (var r = 0; r < jme.length; r++)
      this.plugins.use(jme[r], {
        queue: "internal"
      });
    this.setup(n);
  }
  var e = t.prototype;
  return e.setup = function(r) {
    return r === void 0 && (r = {}), r.createGenerateId && (this.options.createGenerateId = r.createGenerateId), r.id && (this.options.id = Ns({}, this.options.id, r.id)), (r.createGenerateId || r.id) && (this.generateId = this.options.createGenerateId(this.options.id)), r.insertionPoint != null && (this.options.insertionPoint = r.insertionPoint), "Renderer" in r && (this.options.Renderer = r.Renderer), r.plugins && this.use.apply(this, r.plugins), this;
  }, e.createStyleSheet = function(r, i) {
    i === void 0 && (i = {});
    var o = i, s = o.index;
    typeof s != "number" && (s = fD.index === 0 ? 0 : fD.index + 1);
    var a = new mke(r, Ns({}, i, {
      jss: this,
      generateId: i.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: s
    }));
    return this.plugins.onProcessSheet(a), a;
  }, e.removeStyleSheet = function(r) {
    return r.detach(), fD.remove(r), this;
  }, e.createRule = function(r, i, o) {
    if (i === void 0 && (i = {}), o === void 0 && (o = {}), typeof r == "object")
      return this.createRule(void 0, r, i);
    var s = Ns({}, o, {
      name: r,
      jss: this,
      Renderer: this.options.Renderer
    });
    s.generateId || (s.generateId = this.generateId), s.classes || (s.classes = {}), s.keyframes || (s.keyframes = {});
    var a = dse(r, i, s);
    return a && this.plugins.onProcessRule(a), a;
  }, e.use = function() {
    for (var r = this, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return o.forEach(function(a) {
      r.plugins.use(a);
    }), this;
  }, t;
}(), Ise = function(e) {
  return new udt(e);
}, mse = typeof CSS == "object" && CSS != null && "number" in CSS;
function yke(t) {
  var e = null;
  for (var n in t) {
    var r = t[n], i = typeof r;
    if (i === "function")
      e || (e = {}), e[n] = r;
    else if (i === "object" && r !== null && !Array.isArray(r)) {
      var o = yke(r);
      o && (e || (e = {}), e[n] = o);
    }
  }
  return e;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
Ise();
var vke = Date.now(), dz = "fnValues" + vke, pz = "fnStyle" + ++vke, fdt = function() {
  return {
    onCreateRule: function(n, r, i) {
      if (typeof r != "function")
        return null;
      var o = dse(n, {}, i);
      return o[pz] = r, o;
    },
    onProcessStyle: function(n, r) {
      if (dz in r || pz in r)
        return n;
      var i = {};
      for (var o in n) {
        var s = n[o];
        typeof s == "function" && (delete n[o], i[o] = s);
      }
      return r[dz] = i, n;
    },
    onUpdate: function(n, r, i, o) {
      var s = r, a = s[pz];
      a && (s.style = a(n) || {});
      var A = s[dz];
      if (A)
        for (var l in A)
          s.prop(l, A[l](n), o);
    }
  };
};
const gdt = fdt;
var bC = "@global", qX = "@global ", hdt = /* @__PURE__ */ function() {
  function t(n, r, i) {
    this.type = "global", this.at = bC, this.isProcessed = !1, this.key = n, this.options = i, this.rules = new sH(at({}, i, {
      parent: this
    }));
    for (var o in r)
      this.rules.add(o, r[o]);
    this.rules.process();
  }
  var e = t.prototype;
  return e.getRule = function(r) {
    return this.rules.get(r);
  }, e.addRule = function(r, i, o) {
    var s = this.rules.add(r, i, o);
    return s && this.options.jss.plugins.onProcessRule(s), s;
  }, e.replaceRule = function(r, i, o) {
    var s = this.rules.replace(r, i, o);
    return s && this.options.jss.plugins.onProcessRule(s), s;
  }, e.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, e.toString = function(r) {
    return this.rules.toString(r);
  }, t;
}(), ddt = /* @__PURE__ */ function() {
  function t(n, r, i) {
    this.type = "global", this.at = bC, this.isProcessed = !1, this.key = n, this.options = i;
    var o = n.substr(qX.length);
    this.rule = i.jss.createRule(o, r, at({}, i, {
      parent: this
    }));
  }
  var e = t.prototype;
  return e.toString = function(r) {
    return this.rule ? this.rule.toString(r) : "";
  }, t;
}(), pdt = /\s*,\s*/g;
function Bke(t, e) {
  for (var n = t.split(pdt), r = "", i = 0; i < n.length; i++)
    r += e + " " + n[i].trim(), n[i + 1] && (r += ", ");
  return r;
}
function Idt(t, e) {
  var n = t.options, r = t.style, i = r ? r[bC] : null;
  if (i) {
    for (var o in i)
      e.addRule(o, i[o], at({}, n, {
        selector: Bke(o, t.selector)
      }));
    delete r[bC];
  }
}
function mdt(t, e) {
  var n = t.options, r = t.style;
  for (var i in r)
    if (!(i[0] !== "@" || i.substr(0, bC.length) !== bC)) {
      var o = Bke(i.substr(bC.length), t.selector);
      e.addRule(o, r[i], at({}, n, {
        selector: o
      })), delete r[i];
    }
}
function Cdt() {
  function t(n, r, i) {
    if (!n)
      return null;
    if (n === bC)
      return new hdt(n, r, i);
    if (n[0] === "@" && n.substr(0, qX.length) === qX)
      return new ddt(n, r, i);
    var o = i.parent;
    return o && (o.type === "global" || o.options.parent && o.options.parent.type === "global") && (i.scoped = !1), !i.selector && i.scoped === !1 && (i.selector = n), null;
  }
  function e(n, r) {
    n.type !== "style" || !r || (Idt(n, r), mdt(n, r));
  }
  return {
    onCreateRule: t,
    onProcessRule: e
  };
}
var Wme = /\s*,\s*/g, Edt = /&/g, ydt = /\$([\w-]+)/g;
function vdt() {
  function t(i, o) {
    return function(s, a) {
      var A = i.getRule(a) || o && o.getRule(a);
      return A ? A.selector : a;
    };
  }
  function e(i, o) {
    for (var s = o.split(Wme), a = i.split(Wme), A = "", l = 0; l < s.length; l++)
      for (var c = s[l], u = 0; u < a.length; u++) {
        var f = a[u];
        A && (A += ", "), A += f.indexOf("&") !== -1 ? f.replace(Edt, c) : c + " " + f;
      }
    return A;
  }
  function n(i, o, s) {
    if (s)
      return Ns({}, s, {
        index: s.index + 1
      });
    var a = i.options.nestingLevel;
    a = a === void 0 ? 1 : a + 1;
    var A = Ns({}, i.options, {
      nestingLevel: a,
      index: o.indexOf(i) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete A.name, A;
  }
  function r(i, o, s) {
    if (o.type !== "style")
      return i;
    var a = o, A = a.options.parent, l, c;
    for (var u in i) {
      var f = u.indexOf("&") !== -1, h = u[0] === "@";
      if (!(!f && !h)) {
        if (l = n(a, A, l), f) {
          var d = e(u, a.selector);
          c || (c = t(A, s)), d = d.replace(ydt, c);
          var I = a.key + "-" + u;
          "replaceRule" in A ? A.replaceRule(I, i[u], Ns({}, l, {
            selector: d
          })) : A.addRule(I, i[u], Ns({}, l, {
            selector: d
          }));
        } else
          h && A.addRule(u, {}, l).addRule(a.key, i[u], {
            selector: a.selector
          });
        delete i[u];
      }
    }
    return i;
  }
  return {
    onProcessStyle: r
  };
}
var Bdt = /[A-Z]/g, bdt = /^ms-/, Iz = {};
function _dt(t) {
  return "-" + t.toLowerCase();
}
function bke(t) {
  if (Iz.hasOwnProperty(t))
    return Iz[t];
  var e = t.replace(Bdt, _dt);
  return Iz[t] = bdt.test(e) ? "-" + e : e;
}
function E4(t) {
  var e = {};
  for (var n in t) {
    var r = n.indexOf("--") === 0 ? n : bke(n);
    e[r] = t[n];
  }
  return t.fallbacks && (Array.isArray(t.fallbacks) ? e.fallbacks = t.fallbacks.map(E4) : e.fallbacks = E4(t.fallbacks)), e;
}
function Sdt() {
  function t(n) {
    if (Array.isArray(n)) {
      for (var r = 0; r < n.length; r++)
        n[r] = E4(n[r]);
      return n;
    }
    return E4(n);
  }
  function e(n, r, i) {
    if (r.indexOf("--") === 0)
      return n;
    var o = bke(r);
    return r === o ? n : (i.prop(o, n), null);
  }
  return {
    onProcessStyle: t,
    onChangeValue: e
  };
}
var Tt = mse && CSS ? CSS.px : "px", ZO = mse && CSS ? CSS.ms : "ms", Y1 = mse && CSS ? CSS.percent : "%", Qdt = {
  // Animation properties
  "animation-delay": ZO,
  "animation-duration": ZO,
  // Background properties
  "background-position": Tt,
  "background-position-x": Tt,
  "background-position-y": Tt,
  "background-size": Tt,
  // Border Properties
  border: Tt,
  "border-bottom": Tt,
  "border-bottom-left-radius": Tt,
  "border-bottom-right-radius": Tt,
  "border-bottom-width": Tt,
  "border-left": Tt,
  "border-left-width": Tt,
  "border-radius": Tt,
  "border-right": Tt,
  "border-right-width": Tt,
  "border-top": Tt,
  "border-top-left-radius": Tt,
  "border-top-right-radius": Tt,
  "border-top-width": Tt,
  "border-width": Tt,
  "border-block": Tt,
  "border-block-end": Tt,
  "border-block-end-width": Tt,
  "border-block-start": Tt,
  "border-block-start-width": Tt,
  "border-block-width": Tt,
  "border-inline": Tt,
  "border-inline-end": Tt,
  "border-inline-end-width": Tt,
  "border-inline-start": Tt,
  "border-inline-start-width": Tt,
  "border-inline-width": Tt,
  "border-start-start-radius": Tt,
  "border-start-end-radius": Tt,
  "border-end-start-radius": Tt,
  "border-end-end-radius": Tt,
  // Margin properties
  margin: Tt,
  "margin-bottom": Tt,
  "margin-left": Tt,
  "margin-right": Tt,
  "margin-top": Tt,
  "margin-block": Tt,
  "margin-block-end": Tt,
  "margin-block-start": Tt,
  "margin-inline": Tt,
  "margin-inline-end": Tt,
  "margin-inline-start": Tt,
  // Padding properties
  padding: Tt,
  "padding-bottom": Tt,
  "padding-left": Tt,
  "padding-right": Tt,
  "padding-top": Tt,
  "padding-block": Tt,
  "padding-block-end": Tt,
  "padding-block-start": Tt,
  "padding-inline": Tt,
  "padding-inline-end": Tt,
  "padding-inline-start": Tt,
  // Mask properties
  "mask-position-x": Tt,
  "mask-position-y": Tt,
  "mask-size": Tt,
  // Width and height properties
  height: Tt,
  width: Tt,
  "min-height": Tt,
  "max-height": Tt,
  "min-width": Tt,
  "max-width": Tt,
  // Position properties
  bottom: Tt,
  left: Tt,
  top: Tt,
  right: Tt,
  inset: Tt,
  "inset-block": Tt,
  "inset-block-end": Tt,
  "inset-block-start": Tt,
  "inset-inline": Tt,
  "inset-inline-end": Tt,
  "inset-inline-start": Tt,
  // Shadow properties
  "box-shadow": Tt,
  "text-shadow": Tt,
  // Column properties
  "column-gap": Tt,
  "column-rule": Tt,
  "column-rule-width": Tt,
  "column-width": Tt,
  // Font and text properties
  "font-size": Tt,
  "font-size-delta": Tt,
  "letter-spacing": Tt,
  "text-decoration-thickness": Tt,
  "text-indent": Tt,
  "text-stroke": Tt,
  "text-stroke-width": Tt,
  "word-spacing": Tt,
  // Motion properties
  motion: Tt,
  "motion-offset": Tt,
  // Outline properties
  outline: Tt,
  "outline-offset": Tt,
  "outline-width": Tt,
  // Perspective properties
  perspective: Tt,
  "perspective-origin-x": Y1,
  "perspective-origin-y": Y1,
  // Transform properties
  "transform-origin": Y1,
  "transform-origin-x": Y1,
  "transform-origin-y": Y1,
  "transform-origin-z": Y1,
  // Transition properties
  "transition-delay": ZO,
  "transition-duration": ZO,
  // Alignment properties
  "vertical-align": Tt,
  "flex-basis": Tt,
  // Some random properties
  "shape-margin": Tt,
  size: Tt,
  gap: Tt,
  // Grid properties
  grid: Tt,
  "grid-gap": Tt,
  "row-gap": Tt,
  "grid-row-gap": Tt,
  "grid-column-gap": Tt,
  "grid-template-rows": Tt,
  "grid-template-columns": Tt,
  "grid-auto-rows": Tt,
  "grid-auto-columns": Tt,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": Tt,
  "box-shadow-y": Tt,
  "box-shadow-blur": Tt,
  "box-shadow-spread": Tt,
  "font-line-height": Tt,
  "text-shadow-x": Tt,
  "text-shadow-y": Tt,
  "text-shadow-blur": Tt
};
function _ke(t) {
  var e = /(-[a-z])/g, n = function(s) {
    return s[1].toUpperCase();
  }, r = {};
  for (var i in t)
    r[i] = t[i], r[i.replace(e, n)] = t[i];
  return r;
}
var wdt = _ke(Qdt);
function gD(t, e, n) {
  if (e == null)
    return e;
  if (Array.isArray(e))
    for (var r = 0; r < e.length; r++)
      e[r] = gD(t, e[r], n);
  else if (typeof e == "object")
    if (t === "fallbacks")
      for (var i in e)
        e[i] = gD(i, e[i], n);
    else
      for (var o in e)
        e[o] = gD(t + "-" + o, e[o], n);
  else if (typeof e == "number" && isNaN(e) === !1) {
    var s = n[t] || wdt[t];
    return s && !(e === 0 && s === Tt) ? typeof s == "function" ? s(e).toString() : "" + e + s : e.toString();
  }
  return e;
}
function xdt(t) {
  t === void 0 && (t = {});
  var e = _ke(t);
  function n(i, o) {
    if (o.type !== "style")
      return i;
    for (var s in i)
      i[s] = gD(s, i[s], e);
    return i;
  }
  function r(i, o) {
    return gD(o, i, e);
  }
  return {
    onProcessStyle: n,
    onChangeValue: r
  };
}
function jX(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function Rdt(t) {
  if (Array.isArray(t))
    return jX(t);
}
function Ddt(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function Ske(t, e) {
  if (t) {
    if (typeof t == "string")
      return jX(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return jX(t, e);
  }
}
function Tdt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ndt(t) {
  return Rdt(t) || Ddt(t) || Ske(t) || Tdt();
}
var uR = "", YX = "", Qke = "", wke = "", Ldt = fL && "ontouchstart" in document.documentElement;
if (fL) {
  var mz = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, Mdt = document.createElement("p"), Cz = Mdt.style, Odt = "Transform";
  for (var Ez in mz)
    if (Ez + Odt in Cz) {
      uR = Ez, YX = mz[Ez];
      break;
    }
  uR === "Webkit" && "msHyphens" in Cz && (uR = "ms", YX = mz.ms, wke = "edge"), uR === "Webkit" && "-apple-trailing-word" in Cz && (Qke = "apple");
}
var ti = {
  js: uR,
  css: YX,
  vendor: Qke,
  browser: wke,
  isTouch: Ldt
};
function Fdt(t) {
  return t[1] === "-" || ti.js === "ms" ? t : "@" + ti.css + "keyframes" + t.substr(10);
}
var Pdt = {
  noPrefill: ["appearance"],
  supportedProperty: function(e) {
    return e !== "appearance" ? !1 : ti.js === "ms" ? "-webkit-" + e : ti.css + e;
  }
}, kdt = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(e) {
    return e !== "color-adjust" ? !1 : ti.js === "Webkit" ? ti.css + "print-" + e : e;
  }
}, Gdt = /[-\s]+(.)?/g;
function Udt(t, e) {
  return e ? e.toUpperCase() : "";
}
function Cse(t) {
  return t.replace(Gdt, Udt);
}
function $C(t) {
  return Cse("-" + t);
}
var Hdt = {
  noPrefill: ["mask"],
  supportedProperty: function(e, n) {
    if (!/^mask/.test(e))
      return !1;
    if (ti.js === "Webkit") {
      var r = "mask-image";
      if (Cse(r) in n)
        return e;
      if (ti.js + $C(r) in n)
        return ti.css + e;
    }
    return e;
  }
}, $dt = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(e) {
    return e !== "text-orientation" ? !1 : ti.vendor === "apple" && !ti.isTouch ? ti.css + e : e;
  }
}, qdt = {
  noPrefill: ["transform"],
  supportedProperty: function(e, n, r) {
    return e !== "transform" ? !1 : r.transform ? e : ti.css + e;
  }
}, jdt = {
  noPrefill: ["transition"],
  supportedProperty: function(e, n, r) {
    return e !== "transition" ? !1 : r.transition ? e : ti.css + e;
  }
}, Ydt = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(e) {
    return e !== "writing-mode" ? !1 : ti.js === "Webkit" || ti.js === "ms" && ti.browser !== "edge" ? ti.css + e : e;
  }
}, zdt = {
  noPrefill: ["user-select"],
  supportedProperty: function(e) {
    return e !== "user-select" ? !1 : ti.js === "Moz" || ti.js === "ms" || ti.vendor === "apple" ? ti.css + e : e;
  }
}, Vdt = {
  supportedProperty: function(e, n) {
    if (!/^break-/.test(e))
      return !1;
    if (ti.js === "Webkit") {
      var r = "WebkitColumn" + $C(e);
      return r in n ? ti.css + "column-" + e : !1;
    }
    if (ti.js === "Moz") {
      var i = "page" + $C(e);
      return i in n ? "page-" + e : !1;
    }
    return !1;
  }
}, Jdt = {
  supportedProperty: function(e, n) {
    if (!/^(border|margin|padding)-inline/.test(e))
      return !1;
    if (ti.js === "Moz")
      return e;
    var r = e.replace("-inline", "");
    return ti.js + $C(r) in n ? ti.css + r : !1;
  }
}, Kdt = {
  supportedProperty: function(e, n) {
    return Cse(e) in n ? e : !1;
  }
}, Wdt = {
  supportedProperty: function(e, n) {
    var r = $C(e);
    return e[0] === "-" || e[0] === "-" && e[1] === "-" ? e : ti.js + r in n ? ti.css + e : ti.js !== "Webkit" && "Webkit" + r in n ? "-webkit-" + e : !1;
  }
}, Xdt = {
  supportedProperty: function(e) {
    return e.substring(0, 11) !== "scroll-snap" ? !1 : ti.js === "ms" ? "" + ti.css + e : e;
  }
}, Zdt = {
  supportedProperty: function(e) {
    return e !== "overscroll-behavior" ? !1 : ti.js === "ms" ? ti.css + "scroll-chaining" : e;
  }
}, ept = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, tpt = {
  supportedProperty: function(e, n) {
    var r = ept[e];
    return r && ti.js + $C(r) in n ? ti.css + r : !1;
  }
}, xke = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, npt = Object.keys(xke), rpt = function(e) {
  return ti.css + e;
}, ipt = {
  supportedProperty: function(e, n, r) {
    var i = r.multiple;
    if (npt.indexOf(e) > -1) {
      var o = xke[e];
      if (!Array.isArray(o))
        return ti.js + $C(o) in n ? ti.css + o : !1;
      if (!i)
        return !1;
      for (var s = 0; s < o.length; s++)
        if (!(ti.js + $C(o[0]) in n))
          return !1;
      return o.map(rpt);
    }
    return !1;
  }
}, Rke = [Pdt, kdt, Hdt, $dt, qdt, jdt, Ydt, zdt, Vdt, Jdt, Kdt, Wdt, Xdt, Zdt, tpt, ipt], Xme = Rke.filter(function(t) {
  return t.supportedProperty;
}).map(function(t) {
  return t.supportedProperty;
}), opt = Rke.filter(function(t) {
  return t.noPrefill;
}).reduce(function(t, e) {
  return t.push.apply(t, Ndt(e.noPrefill)), t;
}, []), fR, zy = {};
if (fL) {
  fR = document.createElement("p");
  var yz = window.getComputedStyle(document.documentElement, "");
  for (var vz in yz)
    isNaN(vz) || (zy[yz[vz]] = yz[vz]);
  opt.forEach(function(t) {
    return delete zy[t];
  });
}
function zX(t, e) {
  if (e === void 0 && (e = {}), !fR)
    return t;
  if (zy[t] != null)
    return zy[t];
  (t === "transition" || t === "transform") && (e[t] = t in fR.style);
  for (var n = 0; n < Xme.length && (zy[t] = Xme[n](t, fR.style, e), !zy[t]); n++)
    ;
  try {
    fR.style[t] = "";
  } catch {
    return !1;
  }
  return zy[t];
}
var z1 = {}, spt = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, apt = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, km;
function Apt(t, e, n) {
  if (e === "var")
    return "var";
  if (e === "all")
    return "all";
  if (n === "all")
    return ", all";
  var r = e ? zX(e) : ", " + zX(n);
  return r || e || n;
}
fL && (km = document.createElement("p"));
function Zme(t, e) {
  var n = e;
  if (!km || t === "content")
    return e;
  if (typeof n != "string" || !isNaN(parseInt(n, 10)))
    return n;
  var r = t + n;
  if (z1[r] != null)
    return z1[r];
  try {
    km.style[t] = n;
  } catch {
    return z1[r] = !1, !1;
  }
  if (spt[t])
    n = n.replace(apt, Apt);
  else if (km.style[t] === "" && (n = ti.css + n, n === "-ms-flex" && (km.style[t] = "-ms-flexbox"), km.style[t] = n, km.style[t] === ""))
    return z1[r] = !1, !1;
  return km.style[t] = "", z1[r] = n, z1[r];
}
function lpt() {
  function t(i) {
    if (i.type === "keyframes") {
      var o = i;
      o.at = Fdt(o.at);
    }
  }
  function e(i) {
    for (var o in i) {
      var s = i[o];
      if (o === "fallbacks" && Array.isArray(s)) {
        i[o] = s.map(e);
        continue;
      }
      var a = !1, A = zX(o);
      A && A !== o && (a = !0);
      var l = !1, c = Zme(A, Ev(s));
      c && c !== s && (l = !0), (a || l) && (a && delete i[o], i[A || o] = c || s);
    }
    return i;
  }
  function n(i, o) {
    return o.type !== "style" ? i : e(i);
  }
  function r(i, o) {
    return Zme(o, Ev(i)) || i;
  }
  return {
    onProcessRule: t,
    onProcessStyle: n,
    onChangeValue: r
  };
}
function cpt() {
  var t = function(n, r) {
    return n.length === r.length ? n > r ? 1 : -1 : n.length - r.length;
  };
  return {
    onProcessStyle: function(n, r) {
      if (r.type !== "style")
        return n;
      for (var i = {}, o = Object.keys(n).sort(t), s = 0; s < o.length; s++)
        i[o[s]] = n[o[s]];
      return i;
    }
  };
}
function Dke() {
  return {
    plugins: [
      gdt(),
      Cdt(),
      vdt(),
      Sdt(),
      xdt(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window > "u" ? null : lpt(),
      cpt()
    ]
  };
}
function Ese() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.baseClasses, n = t.newClasses;
  if (t.Component, !n)
    return e;
  var r = at({}, e);
  return Object.keys(n).forEach(function(i) {
    n[i] && (r[i] = "".concat(e[i], " ").concat(n[i]));
  }), r;
}
var upt = {
  set: function(e, n, r, i) {
    var o = e.get(n);
    o || (o = /* @__PURE__ */ new Map(), e.set(n, o)), o.set(r, i);
  },
  get: function(e, n, r) {
    var i = e.get(n);
    return i ? i.get(r) : void 0;
  },
  delete: function(e, n, r) {
    var i = e.get(n);
    i.delete(r);
  }
};
const s_ = upt;
var fpt = St.createContext(null);
const Tke = fpt;
function VQ() {
  var t = St.useContext(Tke);
  return t;
}
var gpt = Ise(Dke()), hpt = Qht(), dpt = /* @__PURE__ */ new Map(), ppt = {
  disableGeneration: !1,
  generateClassName: hpt,
  jss: gpt,
  sheetsCache: null,
  sheetsManager: dpt,
  sheetsRegistry: null
}, VX = St.createContext(ppt), eF;
function eCe(t) {
  var e = t.children, n = t.injectFirst, r = n === void 0 ? !1 : n, i = t.disableGeneration, o = i === void 0 ? !1 : i, s = Rn(t, ["children", "injectFirst", "disableGeneration"]), a = St.useContext(VX), A = at({}, a, {
    disableGeneration: o
  }, s);
  if (!A.jss.options.insertionPoint && r && typeof window < "u") {
    if (!eF) {
      var l = document.head;
      eF = document.createComment("mui-inject-first"), l.insertBefore(eF, l.firstChild);
    }
    A.jss = Ise({
      plugins: Dke().plugins,
      insertionPoint: eF
    });
  }
  return /* @__PURE__ */ St.createElement(VX.Provider, {
    value: A
  }, e);
}
var tCe = -1e9;
function Ipt() {
  return tCe += 1, tCe;
}
var mpt = {};
const Cpt = mpt;
function Ept(t) {
  var e = typeof t == "function";
  return {
    create: function(r, i) {
      var o;
      try {
        o = e ? t(r) : t;
      } catch (A) {
        throw A;
      }
      if (!i || !r.overrides || !r.overrides[i])
        return o;
      var s = r.overrides[i], a = at({}, o);
      return Object.keys(s).forEach(function(A) {
        a[A] = Uv(a[A], s[A]);
      }), a;
    },
    options: {}
  };
}
function ypt(t, e, n) {
  var r = t.state, i = t.stylesOptions;
  if (i.disableGeneration)
    return e || {};
  r.cacheClasses || (r.cacheClasses = {
    // Cache for the finalized classes value.
    value: null,
    // Cache for the last used classes prop pointer.
    lastProp: null,
    // Cache for the last used rendered classes pointer.
    lastJSS: {}
  });
  var o = !1;
  return r.classes !== r.cacheClasses.lastJSS && (r.cacheClasses.lastJSS = r.classes, o = !0), e !== r.cacheClasses.lastProp && (r.cacheClasses.lastProp = e, o = !0), o && (r.cacheClasses.value = Ese({
    baseClasses: r.cacheClasses.lastJSS,
    newClasses: e,
    Component: n
  })), r.cacheClasses.value;
}
function vpt(t, e) {
  var n = t.state, r = t.theme, i = t.stylesOptions, o = t.stylesCreator, s = t.name;
  if (!i.disableGeneration) {
    var a = s_.get(i.sheetsManager, o, r);
    a || (a = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    }, s_.set(i.sheetsManager, o, r, a));
    var A = at({}, o.options, i, {
      theme: r,
      flip: typeof i.flip == "boolean" ? i.flip : r.direction === "rtl"
    });
    A.generateId = A.serverGenerateClassName || A.generateClassName;
    var l = i.sheetsRegistry;
    if (a.refs === 0) {
      var c;
      i.sheetsCache && (c = s_.get(i.sheetsCache, o, r));
      var u = o.create(r, s);
      c || (c = i.jss.createStyleSheet(u, at({
        link: !1
      }, A)), c.attach(), i.sheetsCache && s_.set(i.sheetsCache, o, r, c)), l && l.add(c), a.staticSheet = c, a.dynamicStyles = yke(u);
    }
    if (a.dynamicStyles) {
      var f = i.jss.createStyleSheet(a.dynamicStyles, at({
        link: !0
      }, A));
      f.update(e), f.attach(), n.dynamicSheet = f, n.classes = Ese({
        baseClasses: a.staticSheet.classes,
        newClasses: f.classes
      }), l && l.add(f);
    } else
      n.classes = a.staticSheet.classes;
    a.refs += 1;
  }
}
function Bpt(t, e) {
  var n = t.state;
  n.dynamicSheet && n.dynamicSheet.update(e);
}
function bpt(t) {
  var e = t.state, n = t.theme, r = t.stylesOptions, i = t.stylesCreator;
  if (!r.disableGeneration) {
    var o = s_.get(r.sheetsManager, i, n);
    o.refs -= 1;
    var s = r.sheetsRegistry;
    o.refs === 0 && (s_.delete(r.sheetsManager, i, n), r.jss.removeStyleSheet(o.staticSheet), s && s.remove(o.staticSheet)), e.dynamicSheet && (r.jss.removeStyleSheet(e.dynamicSheet), s && s.remove(e.dynamicSheet));
  }
}
function _pt(t, e) {
  var n = St.useRef([]), r, i = St.useMemo(function() {
    return {};
  }, e);
  n.current !== i && (n.current = i, r = t()), St.useEffect(
    function() {
      return function() {
        r && r();
      };
    },
    [i]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function yse(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.name, r = e.classNamePrefix, i = e.Component, o = e.defaultTheme, s = o === void 0 ? Cpt : o, a = Rn(e, ["name", "classNamePrefix", "Component", "defaultTheme"]), A = Ept(t), l = n || r || "makeStyles";
  A.options = {
    index: Ipt(),
    name: n,
    meta: l,
    classNamePrefix: l
  };
  var c = function() {
    var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, h = VQ() || s, d = at({}, St.useContext(VX), a), I = St.useRef(), m = St.useRef();
    _pt(function() {
      var y = {
        name: n,
        state: {},
        stylesCreator: A,
        stylesOptions: d,
        theme: h
      };
      return vpt(y, f), m.current = !1, I.current = y, function() {
        bpt(y);
      };
    }, [h, A]), St.useEffect(function() {
      m.current && Bpt(I.current, f), m.current = !0;
    });
    var C = ypt(I.current, f.classes, i);
    return C;
  };
  return c;
}
function Spt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function nCe(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Qpt(t, e, n) {
  return e && nCe(t.prototype, e), n && nCe(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function Nke(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number")
    r += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (n = Nke(t[e])) && (r && (r += " "), r += n);
    else
      for (e in t)
        t[e] && (r && (r += " "), r += e);
  return r;
}
function Xt() {
  for (var t, e, n = 0, r = ""; n < arguments.length; )
    (t = arguments[n++]) && (e = Nke(t)) && (r && (r += " "), r += e);
  return r;
}
const wpt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: Xt,
  default: Xt
}, Symbol.toStringTag, { value: "Module" }));
var Lke = { exports: {} }, Ro = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var HA = typeof Symbol == "function" && Symbol.for, vse = HA ? Symbol.for("react.element") : 60103, Bse = HA ? Symbol.for("react.portal") : 60106, aH = HA ? Symbol.for("react.fragment") : 60107, AH = HA ? Symbol.for("react.strict_mode") : 60108, lH = HA ? Symbol.for("react.profiler") : 60114, cH = HA ? Symbol.for("react.provider") : 60109, uH = HA ? Symbol.for("react.context") : 60110, bse = HA ? Symbol.for("react.async_mode") : 60111, fH = HA ? Symbol.for("react.concurrent_mode") : 60111, gH = HA ? Symbol.for("react.forward_ref") : 60112, hH = HA ? Symbol.for("react.suspense") : 60113, xpt = HA ? Symbol.for("react.suspense_list") : 60120, dH = HA ? Symbol.for("react.memo") : 60115, pH = HA ? Symbol.for("react.lazy") : 60116, Rpt = HA ? Symbol.for("react.block") : 60121, Dpt = HA ? Symbol.for("react.fundamental") : 60117, Tpt = HA ? Symbol.for("react.responder") : 60118, Npt = HA ? Symbol.for("react.scope") : 60119;
function jf(t) {
  if (typeof t == "object" && t !== null) {
    var e = t.$$typeof;
    switch (e) {
      case vse:
        switch (t = t.type, t) {
          case bse:
          case fH:
          case aH:
          case lH:
          case AH:
          case hH:
            return t;
          default:
            switch (t = t && t.$$typeof, t) {
              case uH:
              case gH:
              case pH:
              case dH:
              case cH:
                return t;
              default:
                return e;
            }
        }
      case Bse:
        return e;
    }
  }
}
function Mke(t) {
  return jf(t) === fH;
}
Ro.AsyncMode = bse;
Ro.ConcurrentMode = fH;
Ro.ContextConsumer = uH;
Ro.ContextProvider = cH;
Ro.Element = vse;
Ro.ForwardRef = gH;
Ro.Fragment = aH;
Ro.Lazy = pH;
Ro.Memo = dH;
Ro.Portal = Bse;
Ro.Profiler = lH;
Ro.StrictMode = AH;
Ro.Suspense = hH;
Ro.isAsyncMode = function(t) {
  return Mke(t) || jf(t) === bse;
};
Ro.isConcurrentMode = Mke;
Ro.isContextConsumer = function(t) {
  return jf(t) === uH;
};
Ro.isContextProvider = function(t) {
  return jf(t) === cH;
};
Ro.isElement = function(t) {
  return typeof t == "object" && t !== null && t.$$typeof === vse;
};
Ro.isForwardRef = function(t) {
  return jf(t) === gH;
};
Ro.isFragment = function(t) {
  return jf(t) === aH;
};
Ro.isLazy = function(t) {
  return jf(t) === pH;
};
Ro.isMemo = function(t) {
  return jf(t) === dH;
};
Ro.isPortal = function(t) {
  return jf(t) === Bse;
};
Ro.isProfiler = function(t) {
  return jf(t) === lH;
};
Ro.isStrictMode = function(t) {
  return jf(t) === AH;
};
Ro.isSuspense = function(t) {
  return jf(t) === hH;
};
Ro.isValidElementType = function(t) {
  return typeof t == "string" || typeof t == "function" || t === aH || t === fH || t === lH || t === AH || t === hH || t === xpt || typeof t == "object" && t !== null && (t.$$typeof === pH || t.$$typeof === dH || t.$$typeof === cH || t.$$typeof === uH || t.$$typeof === gH || t.$$typeof === Dpt || t.$$typeof === Tpt || t.$$typeof === Npt || t.$$typeof === Rpt);
};
Ro.typeOf = jf;
Lke.exports = Ro;
var _se = Lke.exports, Sse = _se, Lpt = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Mpt = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Opt = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Oke = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Qse = {};
Qse[Sse.ForwardRef] = Opt;
Qse[Sse.Memo] = Oke;
function rCe(t) {
  return Sse.isMemo(t) ? Oke : Qse[t.$$typeof] || Lpt;
}
var Fpt = Object.defineProperty, Ppt = Object.getOwnPropertyNames, iCe = Object.getOwnPropertySymbols, kpt = Object.getOwnPropertyDescriptor, Gpt = Object.getPrototypeOf, oCe = Object.prototype;
function Fke(t, e, n) {
  if (typeof e != "string") {
    if (oCe) {
      var r = Gpt(e);
      r && r !== oCe && Fke(t, r, n);
    }
    var i = Ppt(e);
    iCe && (i = i.concat(iCe(e)));
    for (var o = rCe(t), s = rCe(e), a = 0; a < i.length; ++a) {
      var A = i[a];
      if (!Mpt[A] && !(n && n[A]) && !(s && s[A]) && !(o && o[A])) {
        var l = kpt(e, A);
        try {
          Fpt(t, A, l);
        } catch {
        }
      }
    }
  }
  return t;
}
var Upt = Fke;
const Pke = /* @__PURE__ */ ko(Upt);
function Hpt(t, e) {
  var n = {};
  return Object.keys(t).forEach(function(r) {
    e.indexOf(r) === -1 && (n[r] = t[r]);
  }), n;
}
function $pt(t) {
  var e = function(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = i.name, s = Rn(i, ["name"]), a = o, A = typeof r == "function" ? function(f) {
      return {
        root: function(d) {
          return r(at({
            theme: f
          }, d));
        }
      };
    } : {
      root: r
    }, l = yse(A, at({
      Component: t,
      name: o || t.displayName,
      classNamePrefix: a
    }, s)), c;
    r.filterProps && (c = r.filterProps, delete r.filterProps), r.propTypes && (r.propTypes, delete r.propTypes);
    var u = /* @__PURE__ */ St.forwardRef(function(h, d) {
      var I = h.children, m = h.className, C = h.clone, y = h.component, v = Rn(h, ["children", "className", "clone", "component"]), b = l(h), Q = Xt(b.root, m), w = v;
      if (c && (w = Hpt(w, c)), C)
        return /* @__PURE__ */ St.cloneElement(I, at({
          className: Xt(I.props.className, Q)
        }, w));
      if (typeof I == "function")
        return I(at({
          className: Q
        }, w));
      var R = y || t;
      return /* @__PURE__ */ St.createElement(R, at({
        ref: d,
        className: Q
      }, w), I);
    });
    return Pke(u, t), u;
  };
  return e;
}
function qpt(t, e) {
  if (typeof e == "function") {
    var n = e(t);
    return n;
  }
  return at({}, t, e);
}
function sCe(t) {
  var e = t.children, n = t.theme, r = VQ(), i = St.useMemo(function() {
    var o = r === null ? n : qpt(r, n);
    return o != null && (o[gke] = r !== null), o;
  }, [n, r]);
  return /* @__PURE__ */ St.createElement(Tke.Provider, {
    value: i
  }, e);
}
var jpt = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(r) {
    var i = n.defaultTheme, o = n.withTheme, s = o === void 0 ? !1 : o, a = n.name, A = Rn(n, ["defaultTheme", "withTheme", "name"]), l = a, c = yse(e, at({
      defaultTheme: i,
      Component: r,
      name: a || r.displayName,
      classNamePrefix: l
    }, A)), u = /* @__PURE__ */ St.forwardRef(function(h, d) {
      h.classes;
      var I = h.innerRef, m = Rn(h, ["classes", "innerRef"]), C = c(at({}, r.defaultProps, h)), y, v = m;
      return (typeof a == "string" || s) && (y = VQ() || i, a && (v = hke({
        theme: y,
        name: a,
        props: m
      })), s && !v.theme && (v.theme = y)), /* @__PURE__ */ St.createElement(r, at({
        ref: I || d,
        classes: C
      }, v));
    });
    return Pke(u, r), u;
  };
};
const Ypt = jpt;
function zpt(t) {
  return t;
}
var Vpt = FX();
const IH = Vpt;
function kr(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return yse(t, at({
    defaultTheme: IH
  }, e));
}
var Jpt = function(e) {
  var n = $pt(e);
  return function(r, i) {
    return n(r, at({
      defaultTheme: IH
    }, i));
  };
};
const Kpt = Jpt;
function GB() {
  var t = VQ() || IH;
  return t;
}
function Lr(t, e) {
  return Ypt(t, at({
    defaultTheme: IH
  }, e));
}
function io(t) {
  if (typeof t != "string")
    throw new Error(vS(7));
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function sT() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return e.reduce(function(r, i) {
    return i == null ? r : function() {
      for (var s = arguments.length, a = new Array(s), A = 0; A < s; A++)
        a[A] = arguments[A];
      r.apply(this, a), i.apply(this, a);
    };
  }, function() {
  });
}
var Wpt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: "currentColor",
      flexShrink: 0,
      fontSize: e.typography.pxToRem(24),
      transition: e.transitions.create("fill", {
        duration: e.transitions.duration.shorter
      })
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: e.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: e.palette.secondary.main
    },
    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: e.palette.action.active
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: e.palette.error.main
    },
    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: e.palette.action.disabled
    },
    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: "inherit"
    },
    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: e.typography.pxToRem(20)
    },
    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: e.typography.pxToRem(35)
    }
  };
}, kke = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.classes, o = e.className, s = e.color, a = s === void 0 ? "inherit" : s, A = e.component, l = A === void 0 ? "svg" : A, c = e.fontSize, u = c === void 0 ? "medium" : c, f = e.htmlColor, h = e.titleAccess, d = e.viewBox, I = d === void 0 ? "0 0 24 24" : d, m = Rn(e, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
  return /* @__PURE__ */ le.createElement(l, at({
    className: Xt(i.root, o, a !== "inherit" && i["color".concat(io(a))], u !== "default" && u !== "medium" && i["fontSize".concat(io(u))]),
    focusable: "false",
    viewBox: I,
    color: f,
    "aria-hidden": h ? void 0 : !0,
    role: h ? "img" : void 0,
    ref: n
  }, m), r, h ? /* @__PURE__ */ le.createElement("title", null, h) : null);
});
kke.muiName = "SvgIcon";
const aCe = Lr(Wpt, {
  name: "MuiSvgIcon"
})(kke);
function Na(t, e) {
  var n = function(i, o) {
    return /* @__PURE__ */ St.createElement(aCe, at({
      ref: o
    }, i), t);
  };
  return n.muiName = aCe.muiName, /* @__PURE__ */ St.memo(/* @__PURE__ */ St.forwardRef(n));
}
function aT(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 166, n;
  function r() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    var a = this, A = function() {
      t.apply(a, o);
    };
    clearTimeout(n), n = setTimeout(A, e);
  }
  return r.clear = function() {
    clearTimeout(n);
  }, r;
}
function Ak(t, e) {
  return /* @__PURE__ */ le.isValidElement(t) && e.indexOf(t.type.muiName) !== -1;
}
function zl(t) {
  return t && t.ownerDocument || document;
}
function wse(t) {
  var e = zl(t);
  return e.defaultView || window;
}
function BS(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
function mH(t) {
  var e = t.controlled, n = t.default;
  t.name, t.state;
  var r = le.useRef(e !== void 0), i = r.current, o = le.useState(n), s = o[0], a = o[1], A = i ? e : s, l = le.useCallback(function(c) {
    i || a(c);
  }, []);
  return [A, l];
}
var Xpt = typeof window < "u" ? le.useLayoutEffect : le.useEffect;
function Ua(t) {
  var e = le.useRef(t);
  return Xpt(function() {
    e.current = t;
  }), le.useCallback(function() {
    return e.current.apply(void 0, arguments);
  }, []);
}
function Ms(t, e) {
  return le.useMemo(function() {
    return t == null && e == null ? null : function(n) {
      BS(t, n), BS(e, n);
    };
  }, [t, e]);
}
var CH = !0, JX = !1, ACe = null, Zpt = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function e0t(t) {
  var e = t.type, n = t.tagName;
  return !!(n === "INPUT" && Zpt[e] && !t.readOnly || n === "TEXTAREA" && !t.readOnly || t.isContentEditable);
}
function t0t(t) {
  t.metaKey || t.altKey || t.ctrlKey || (CH = !0);
}
function Bz() {
  CH = !1;
}
function n0t() {
  this.visibilityState === "hidden" && JX && (CH = !0);
}
function r0t(t) {
  t.addEventListener("keydown", t0t, !0), t.addEventListener("mousedown", Bz, !0), t.addEventListener("pointerdown", Bz, !0), t.addEventListener("touchstart", Bz, !0), t.addEventListener("visibilitychange", n0t, !0);
}
function i0t(t) {
  var e = t.target;
  try {
    return e.matches(":focus-visible");
  } catch {
  }
  return CH || e0t(e);
}
function o0t() {
  JX = !0, window.clearTimeout(ACe), ACe = window.setTimeout(function() {
    JX = !1;
  }, 100);
}
function xse() {
  var t = le.useCallback(function(e) {
    var n = Ed.findDOMNode(e);
    n != null && r0t(n.ownerDocument);
  }, []);
  return {
    isFocusVisible: i0t,
    onBlurVisible: o0t,
    ref: t
  };
}
function s0t(t) {
  return Ake(t) || ske(t) || gse(t) || lke();
}
function KX(t, e) {
  return KX = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, KX(t, e);
}
function Gke(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, KX(t, e);
}
const lCe = {
  disabled: !1
}, y4 = St.createContext(null);
var a0t = function(e) {
  return e.scrollTop;
}, gR = "unmounted", Oy = "exited", Fy = "entering", Hb = "entered", WX = "exiting", $I = /* @__PURE__ */ function(t) {
  Gke(e, t);
  function e(r, i) {
    var o;
    o = t.call(this, r, i) || this;
    var s = i, a = s && !s.isMounting ? r.enter : r.appear, A;
    return o.appearStatus = null, r.in ? a ? (A = Oy, o.appearStatus = Fy) : A = Hb : r.unmountOnExit || r.mountOnEnter ? A = gR : A = Oy, o.state = {
      status: A
    }, o.nextCallback = null, o;
  }
  e.getDerivedStateFromProps = function(i, o) {
    var s = i.in;
    return s && o.status === gR ? {
      status: Oy
    } : null;
  };
  var n = e.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(i) {
    var o = null;
    if (i !== this.props) {
      var s = this.state.status;
      this.props.in ? s !== Fy && s !== Hb && (o = Fy) : (s === Fy || s === Hb) && (o = WX);
    }
    this.updateStatus(!1, o);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var i = this.props.timeout, o, s, a;
    return o = s = a = i, i != null && typeof i != "number" && (o = i.exit, s = i.enter, a = i.appear !== void 0 ? i.appear : s), {
      exit: o,
      enter: s,
      appear: a
    };
  }, n.updateStatus = function(i, o) {
    if (i === void 0 && (i = !1), o !== null)
      if (this.cancelNextCallback(), o === Fy) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var s = this.props.nodeRef ? this.props.nodeRef.current : Sf.findDOMNode(this);
          s && a0t(s);
        }
        this.performEnter(i);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === Oy && this.setState({
        status: gR
      });
  }, n.performEnter = function(i) {
    var o = this, s = this.props.enter, a = this.context ? this.context.isMounting : i, A = this.props.nodeRef ? [a] : [Sf.findDOMNode(this), a], l = A[0], c = A[1], u = this.getTimeouts(), f = a ? u.appear : u.enter;
    if (!i && !s || lCe.disabled) {
      this.safeSetState({
        status: Hb
      }, function() {
        o.props.onEntered(l);
      });
      return;
    }
    this.props.onEnter(l, c), this.safeSetState({
      status: Fy
    }, function() {
      o.props.onEntering(l, c), o.onTransitionEnd(f, function() {
        o.safeSetState({
          status: Hb
        }, function() {
          o.props.onEntered(l, c);
        });
      });
    });
  }, n.performExit = function() {
    var i = this, o = this.props.exit, s = this.getTimeouts(), a = this.props.nodeRef ? void 0 : Sf.findDOMNode(this);
    if (!o || lCe.disabled) {
      this.safeSetState({
        status: Oy
      }, function() {
        i.props.onExited(a);
      });
      return;
    }
    this.props.onExit(a), this.safeSetState({
      status: WX
    }, function() {
      i.props.onExiting(a), i.onTransitionEnd(s.exit, function() {
        i.safeSetState({
          status: Oy
        }, function() {
          i.props.onExited(a);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(i, o) {
    o = this.setNextCallback(o), this.setState(i, o);
  }, n.setNextCallback = function(i) {
    var o = this, s = !0;
    return this.nextCallback = function(a) {
      s && (s = !1, o.nextCallback = null, i(a));
    }, this.nextCallback.cancel = function() {
      s = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(i, o) {
    this.setNextCallback(o);
    var s = this.props.nodeRef ? this.props.nodeRef.current : Sf.findDOMNode(this), a = i == null && !this.props.addEndListener;
    if (!s || a) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var A = this.props.nodeRef ? [this.nextCallback] : [s, this.nextCallback], l = A[0], c = A[1];
      this.props.addEndListener(l, c);
    }
    i != null && setTimeout(this.nextCallback, i);
  }, n.render = function() {
    var i = this.state.status;
    if (i === gR)
      return null;
    var o = this.props, s = o.children;
    o.in, o.mountOnEnter, o.unmountOnExit, o.appear, o.enter, o.exit, o.timeout, o.addEndListener, o.onEnter, o.onEntering, o.onEntered, o.onExit, o.onExiting, o.onExited, o.nodeRef;
    var a = fse(o, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ St.createElement(y4.Provider, {
        value: null
      }, typeof s == "function" ? s(i, a) : St.cloneElement(St.Children.only(s), a))
    );
  }, e;
}(St.Component);
$I.contextType = y4;
$I.propTypes = {};
function V1() {
}
$I.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: V1,
  onEntering: V1,
  onEntered: V1,
  onExit: V1,
  onExiting: V1,
  onExited: V1
};
$I.UNMOUNTED = gR;
$I.EXITED = Oy;
$I.ENTERING = Fy;
$I.ENTERED = Hb;
$I.EXITING = WX;
const Rse = $I;
function A0t(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Dse(t, e) {
  var n = function(o) {
    return e && uD(o) ? e(o) : o;
  }, r = /* @__PURE__ */ Object.create(null);
  return t && D3e.map(t, function(i) {
    return i;
  }).forEach(function(i) {
    r[i.key] = n(i);
  }), r;
}
function l0t(t, e) {
  t = t || {}, e = e || {};
  function n(c) {
    return c in e ? e[c] : t[c];
  }
  var r = /* @__PURE__ */ Object.create(null), i = [];
  for (var o in t)
    o in e ? i.length && (r[o] = i, i = []) : i.push(o);
  var s, a = {};
  for (var A in e) {
    if (r[A])
      for (s = 0; s < r[A].length; s++) {
        var l = r[A][s];
        a[r[A][s]] = n(l);
      }
    a[A] = n(A);
  }
  for (s = 0; s < i.length; s++)
    a[i[s]] = n(i[s]);
  return a;
}
function rv(t, e, n) {
  return n[e] != null ? n[e] : t.props[e];
}
function c0t(t, e) {
  return Dse(t.children, function(n) {
    return D_(n, {
      onExited: e.bind(null, n),
      in: !0,
      appear: rv(n, "appear", t),
      enter: rv(n, "enter", t),
      exit: rv(n, "exit", t)
    });
  });
}
function u0t(t, e, n) {
  var r = Dse(t.children), i = l0t(e, r);
  return Object.keys(i).forEach(function(o) {
    var s = i[o];
    if (uD(s)) {
      var a = o in e, A = o in r, l = e[o], c = uD(l) && !l.props.in;
      A && (!a || c) ? i[o] = D_(s, {
        onExited: n.bind(null, s),
        in: !0,
        exit: rv(s, "exit", t),
        enter: rv(s, "enter", t)
      }) : !A && a && !c ? i[o] = D_(s, {
        in: !1
      }) : A && a && uD(l) && (i[o] = D_(s, {
        onExited: n.bind(null, s),
        in: l.props.in,
        exit: rv(s, "exit", t),
        enter: rv(s, "enter", t)
      }));
    }
  }), i;
}
var f0t = Object.values || function(t) {
  return Object.keys(t).map(function(e) {
    return t[e];
  });
}, g0t = {
  component: "div",
  childFactory: function(e) {
    return e;
  }
}, Tse = /* @__PURE__ */ function(t) {
  Gke(e, t);
  function e(r, i) {
    var o;
    o = t.call(this, r, i) || this;
    var s = o.handleExited.bind(A0t(o));
    return o.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, o;
  }
  var n = e.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, e.getDerivedStateFromProps = function(i, o) {
    var s = o.children, a = o.handleExited, A = o.firstRender;
    return {
      children: A ? c0t(i, a) : u0t(i, s, a),
      firstRender: !1
    };
  }, n.handleExited = function(i, o) {
    var s = Dse(this.props.children);
    i.key in s || (i.props.onExited && i.props.onExited(o), this.mounted && this.setState(function(a) {
      var A = at({}, a.children);
      return delete A[i.key], {
        children: A
      };
    }));
  }, n.render = function() {
    var i = this.props, o = i.component, s = i.childFactory, a = fse(i, ["component", "childFactory"]), A = this.state.contextValue, l = f0t(this.state.children).map(s);
    return delete a.appear, delete a.enter, delete a.exit, o === null ? /* @__PURE__ */ St.createElement(y4.Provider, {
      value: A
    }, l) : /* @__PURE__ */ St.createElement(y4.Provider, {
      value: A
    }, /* @__PURE__ */ St.createElement(o, a, l));
  }, e;
}(St.Component);
Tse.propTypes = {};
Tse.defaultProps = g0t;
const h0t = Tse;
var Uke = function(e) {
  return e.scrollTop;
};
function bS(t, e) {
  var n = t.timeout, r = t.style, i = r === void 0 ? {} : r;
  return {
    duration: i.transitionDuration || typeof n == "number" ? n : n[e.mode] || 0,
    delay: i.transitionDelay
  };
}
var d0t = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 0,
      overflow: "hidden",
      transition: e.transitions.create("height")
    },
    /* Styles applied to the root element when the transition has entered. */
    entered: {
      height: "auto",
      overflow: "visible"
    },
    /* Styles applied to the root element when the transition has exited and `collapsedSize` != 0px. */
    hidden: {
      visibility: "hidden"
    },
    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: "flex"
    },
    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: "100%"
    }
  };
}, Hke = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.classes, o = e.className, s = e.collapsedHeight, a = e.collapsedSize, A = a === void 0 ? "0px" : a, l = e.component, c = l === void 0 ? "div" : l, u = e.disableStrictModeCompat, f = u === void 0 ? !1 : u, h = e.in, d = e.onEnter, I = e.onEntered, m = e.onEntering, C = e.onExit, y = e.onExited, v = e.onExiting, b = e.style, Q = e.timeout, w = Q === void 0 ? iT.standard : Q, R = e.TransitionComponent, M = R === void 0 ? Rse : R, O = Rn(e, ["children", "classes", "className", "collapsedHeight", "collapsedSize", "component", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]), L = GB(), N = le.useRef(), k = le.useRef(null), $ = le.useRef(), U = typeof (s || A) == "number" ? "".concat(s || A, "px") : s || A;
  le.useEffect(function() {
    return function() {
      clearTimeout(N.current);
    };
  }, []);
  var X = L.unstable_strictMode && !f, K = le.useRef(null), z = Ms(n, X ? K : void 0), Y = function(Qe) {
    return function(xe, Se) {
      if (Qe) {
        var De = X ? [K.current, xe] : [xe, Se], Ue = yE(De, 2), Te = Ue[0], se = Ue[1];
        se === void 0 ? Qe(Te) : Qe(Te, se);
      }
    };
  }, V = Y(function(Ie, Qe) {
    Ie.style.height = U, d && d(Ie, Qe);
  }), Z = Y(function(Ie, Qe) {
    var xe = k.current ? k.current.clientHeight : 0, Se = bS({
      style: b,
      timeout: w
    }, {
      mode: "enter"
    }), De = Se.duration;
    if (w === "auto") {
      var Ue = L.transitions.getAutoHeightDuration(xe);
      Ie.style.transitionDuration = "".concat(Ue, "ms"), $.current = Ue;
    } else
      Ie.style.transitionDuration = typeof De == "string" ? De : "".concat(De, "ms");
    Ie.style.height = "".concat(xe, "px"), m && m(Ie, Qe);
  }), ce = Y(function(Ie, Qe) {
    Ie.style.height = "auto", I && I(Ie, Qe);
  }), ee = Y(function(Ie) {
    var Qe = k.current ? k.current.clientHeight : 0;
    Ie.style.height = "".concat(Qe, "px"), C && C(Ie);
  }), pe = Y(y), Ce = Y(function(Ie) {
    var Qe = k.current ? k.current.clientHeight : 0, xe = bS({
      style: b,
      timeout: w
    }, {
      mode: "exit"
    }), Se = xe.duration;
    if (w === "auto") {
      var De = L.transitions.getAutoHeightDuration(Qe);
      Ie.style.transitionDuration = "".concat(De, "ms"), $.current = De;
    } else
      Ie.style.transitionDuration = typeof Se == "string" ? Se : "".concat(Se, "ms");
    Ie.style.height = U, v && v(Ie);
  }), Be = function(Qe, xe) {
    var Se = X ? Qe : xe;
    w === "auto" && (N.current = setTimeout(Se, $.current || 0));
  };
  return /* @__PURE__ */ le.createElement(M, at({
    in: h,
    onEnter: V,
    onEntered: ce,
    onEntering: Z,
    onExit: ee,
    onExited: pe,
    onExiting: Ce,
    addEndListener: Be,
    nodeRef: X ? K : void 0,
    timeout: w === "auto" ? null : w
  }, O), function(Ie, Qe) {
    return /* @__PURE__ */ le.createElement(c, at({
      className: Xt(i.root, i.container, o, {
        entered: i.entered,
        exited: !h && U === "0px" && i.hidden
      }[Ie]),
      style: at({
        minHeight: U
      }, b),
      ref: z
    }, Qe), /* @__PURE__ */ le.createElement("div", {
      className: i.wrapper,
      ref: k
    }, /* @__PURE__ */ le.createElement("div", {
      className: i.wrapperInner
    }, r)));
  });
});
Hke.muiSupportAuto = !0;
const p0t = Lr(d0t, {
  name: "MuiCollapse"
})(Hke);
var I0t = function(e) {
  var n = {};
  return e.shadows.forEach(function(r, i) {
    n["elevation".concat(i)] = {
      boxShadow: r
    };
  }), at({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: e.palette.background.paper,
      color: e.palette.text.primary,
      transition: e.transitions.create("box-shadow")
    },
    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: e.shape.borderRadius
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(e.palette.divider)
    }
  }, n);
}, m0t = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.component, s = o === void 0 ? "div" : o, a = e.square, A = a === void 0 ? !1 : a, l = e.elevation, c = l === void 0 ? 1 : l, u = e.variant, f = u === void 0 ? "elevation" : u, h = Rn(e, ["classes", "className", "component", "square", "elevation", "variant"]);
  return /* @__PURE__ */ le.createElement(s, at({
    className: Xt(r.root, i, f === "outlined" ? r.outlined : r["elevation".concat(c)], !A && r.rounded),
    ref: n
  }, h));
});
const r0 = Lr(I0t, {
  name: "MuiPaper"
})(m0t);
var C0t = le.createContext({});
const $ke = C0t;
var E0t = function(e) {
  var n = {
    duration: e.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      transition: e.transitions.create(["margin"], n),
      "&:before": {
        position: "absolute",
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: e.palette.divider,
        transition: e.transitions.create(["opacity", "background-color"], n)
      },
      "&:first-child": {
        "&:before": {
          display: "none"
        }
      },
      "&$expanded": {
        margin: "16px 0",
        "&:first-child": {
          marginTop: 0
        },
        "&:last-child": {
          marginBottom: 0
        },
        "&:before": {
          opacity: 0
        }
      },
      "&$expanded + &": {
        "&:before": {
          display: "none"
        }
      },
      "&$disabled": {
        backgroundColor: e.palette.action.disabledBackground
      }
    },
    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      "&:first-child": {
        borderTopLeftRadius: e.shape.borderRadius,
        borderTopRightRadius: e.shape.borderRadius
      },
      "&:last-child": {
        borderBottomLeftRadius: e.shape.borderRadius,
        borderBottomRightRadius: e.shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },
    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
}, y0t = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.classes, o = e.className, s = e.defaultExpanded, a = s === void 0 ? !1 : s, A = e.disabled, l = A === void 0 ? !1 : A, c = e.expanded, u = e.onChange, f = e.square, h = f === void 0 ? !1 : f, d = e.TransitionComponent, I = d === void 0 ? p0t : d, m = e.TransitionProps, C = Rn(e, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]), y = mH({
    controlled: c,
    default: a,
    name: "Accordion",
    state: "expanded"
  }), v = yE(y, 2), b = v[0], Q = v[1], w = le.useCallback(function(k) {
    Q(!b), u && u(k, !b);
  }, [b, u, Q]), R = le.Children.toArray(r), M = s0t(R), O = M[0], L = M.slice(1), N = le.useMemo(function() {
    return {
      expanded: b,
      disabled: l,
      toggle: w
    };
  }, [b, l, w]);
  return /* @__PURE__ */ le.createElement(r0, at({
    className: Xt(i.root, o, b && i.expanded, l && i.disabled, !h && i.rounded),
    ref: n,
    square: h
  }, C), /* @__PURE__ */ le.createElement($ke.Provider, {
    value: N
  }, O), /* @__PURE__ */ le.createElement(I, at({
    in: b,
    timeout: "auto"
  }, m), /* @__PURE__ */ le.createElement("div", {
    "aria-labelledby": O.props.id,
    id: O.props["aria-controls"],
    role: "region"
  }, L)));
});
const v0t = Lr(E0t, {
  name: "MuiAccordion"
})(y0t);
var B0t = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "flex",
      padding: e.spacing(1, 2, 2)
    }
  };
}, b0t = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = Rn(e, ["classes", "className"]);
  return /* @__PURE__ */ le.createElement("div", at({
    className: Xt(r.root, i),
    ref: n
  }, o));
});
const _0t = Lr(B0t, {
  name: "MuiAccordionDetails"
})(b0t);
var S0t = typeof window > "u" ? le.useEffect : le.useLayoutEffect;
function Q0t(t) {
  var e = t.classes, n = t.pulsate, r = n === void 0 ? !1 : n, i = t.rippleX, o = t.rippleY, s = t.rippleSize, a = t.in, A = t.onExited, l = A === void 0 ? function() {
  } : A, c = t.timeout, u = le.useState(!1), f = u[0], h = u[1], d = Xt(e.ripple, e.rippleVisible, r && e.ripplePulsate), I = {
    width: s,
    height: s,
    top: -(s / 2) + o,
    left: -(s / 2) + i
  }, m = Xt(e.child, f && e.childLeaving, r && e.childPulsate), C = Ua(l);
  return S0t(function() {
    if (!a) {
      h(!0);
      var y = setTimeout(C, c);
      return function() {
        clearTimeout(y);
      };
    }
  }, [C, a, c]), /* @__PURE__ */ le.createElement("span", {
    className: d,
    style: I
  }, /* @__PURE__ */ le.createElement("span", {
    className: m
  }));
}
var XX = 550, w0t = 80, x0t = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: "hidden",
      pointerEvents: "none",
      position: "absolute",
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: "inherit"
    },
    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: "absolute"
    },
    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: "scale(1)",
      animation: "$enter ".concat(XX, "ms ").concat(e.transitions.easing.easeInOut)
    },
    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(e.transitions.duration.shorter, "ms")
    },
    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: "block",
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      backgroundColor: "currentColor"
    },
    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(XX, "ms ").concat(e.transitions.easing.easeInOut)
    },
    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: "absolute",
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(e.transitions.easing.easeInOut, " 200ms infinite")
    },
    "@keyframes enter": {
      "0%": {
        transform: "scale(0)",
        opacity: 0.1
      },
      "100%": {
        transform: "scale(1)",
        opacity: 0.3
      }
    },
    "@keyframes exit": {
      "0%": {
        opacity: 1
      },
      "100%": {
        opacity: 0
      }
    },
    "@keyframes pulsate": {
      "0%": {
        transform: "scale(1)"
      },
      "50%": {
        transform: "scale(0.92)"
      },
      "100%": {
        transform: "scale(1)"
      }
    }
  };
}, R0t = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.center, i = r === void 0 ? !1 : r, o = e.classes, s = e.className, a = Rn(e, ["center", "classes", "className"]), A = le.useState([]), l = A[0], c = A[1], u = le.useRef(0), f = le.useRef(null);
  le.useEffect(function() {
    f.current && (f.current(), f.current = null);
  }, [l]);
  var h = le.useRef(!1), d = le.useRef(null), I = le.useRef(null), m = le.useRef(null);
  le.useEffect(function() {
    return function() {
      clearTimeout(d.current);
    };
  }, []);
  var C = le.useCallback(function(Q) {
    var w = Q.pulsate, R = Q.rippleX, M = Q.rippleY, O = Q.rippleSize, L = Q.cb;
    c(function(N) {
      return [].concat(iH(N), [/* @__PURE__ */ le.createElement(Q0t, {
        key: u.current,
        classes: o,
        timeout: XX,
        pulsate: w,
        rippleX: R,
        rippleY: M,
        rippleSize: O
      })]);
    }), u.current += 1, f.current = L;
  }, [o]), y = le.useCallback(function() {
    var Q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, R = arguments.length > 2 ? arguments[2] : void 0, M = w.pulsate, O = M === void 0 ? !1 : M, L = w.center, N = L === void 0 ? i || w.pulsate : L, k = w.fakeElement, $ = k === void 0 ? !1 : k;
    if (Q.type === "mousedown" && h.current) {
      h.current = !1;
      return;
    }
    Q.type === "touchstart" && (h.current = !0);
    var U = $ ? null : m.current, X = U ? U.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }, K, z, Y;
    if (N || Q.clientX === 0 && Q.clientY === 0 || !Q.clientX && !Q.touches)
      K = Math.round(X.width / 2), z = Math.round(X.height / 2);
    else {
      var V = Q.touches ? Q.touches[0] : Q, Z = V.clientX, ce = V.clientY;
      K = Math.round(Z - X.left), z = Math.round(ce - X.top);
    }
    if (N)
      Y = Math.sqrt((2 * Math.pow(X.width, 2) + Math.pow(X.height, 2)) / 3), Y % 2 === 0 && (Y += 1);
    else {
      var ee = Math.max(Math.abs((U ? U.clientWidth : 0) - K), K) * 2 + 2, pe = Math.max(Math.abs((U ? U.clientHeight : 0) - z), z) * 2 + 2;
      Y = Math.sqrt(Math.pow(ee, 2) + Math.pow(pe, 2));
    }
    Q.touches ? I.current === null && (I.current = function() {
      C({
        pulsate: O,
        rippleX: K,
        rippleY: z,
        rippleSize: Y,
        cb: R
      });
    }, d.current = setTimeout(function() {
      I.current && (I.current(), I.current = null);
    }, w0t)) : C({
      pulsate: O,
      rippleX: K,
      rippleY: z,
      rippleSize: Y,
      cb: R
    });
  }, [i, C]), v = le.useCallback(function() {
    y({}, {
      pulsate: !0
    });
  }, [y]), b = le.useCallback(function(Q, w) {
    if (clearTimeout(d.current), Q.type === "touchend" && I.current) {
      Q.persist(), I.current(), I.current = null, d.current = setTimeout(function() {
        b(Q, w);
      });
      return;
    }
    I.current = null, c(function(R) {
      return R.length > 0 ? R.slice(1) : R;
    }), f.current = w;
  }, []);
  return le.useImperativeHandle(n, function() {
    return {
      pulsate: v,
      start: y,
      stop: b
    };
  }, [v, y, b]), /* @__PURE__ */ le.createElement("span", at({
    className: Xt(o.root, s),
    ref: m
  }, a), /* @__PURE__ */ le.createElement(h0t, {
    component: null,
    exit: !0
  }, l));
});
const D0t = Lr(x0t, {
  flip: !1,
  name: "MuiTouchRipple"
})(/* @__PURE__ */ le.memo(R0t));
var T0t = {
  /* Styles applied to the root element. */
  root: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    "-moz-appearance": "none",
    // Reset
    "-webkit-appearance": "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
      borderStyle: "none"
      // Remove Firefox dotted outline.
    },
    "&$disabled": {
      pointerEvents: "none",
      // Disable link interactions
      cursor: "default"
    },
    "@media print": {
      colorAdjust: "exact"
    }
  },
  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},
  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
}, N0t = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.action, i = e.buttonRef, o = e.centerRipple, s = o === void 0 ? !1 : o, a = e.children, A = e.classes, l = e.className, c = e.component, u = c === void 0 ? "button" : c, f = e.disabled, h = f === void 0 ? !1 : f, d = e.disableRipple, I = d === void 0 ? !1 : d, m = e.disableTouchRipple, C = m === void 0 ? !1 : m, y = e.focusRipple, v = y === void 0 ? !1 : y, b = e.focusVisibleClassName, Q = e.onBlur, w = e.onClick, R = e.onFocus, M = e.onFocusVisible, O = e.onKeyDown, L = e.onKeyUp, N = e.onMouseDown, k = e.onMouseLeave, $ = e.onMouseUp, U = e.onTouchEnd, X = e.onTouchMove, K = e.onTouchStart, z = e.onDragLeave, Y = e.tabIndex, V = Y === void 0 ? 0 : Y, Z = e.TouchRippleProps, ce = e.type, ee = ce === void 0 ? "button" : ce, pe = Rn(e, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]), Ce = le.useRef(null);
  function Be() {
    return Ed.findDOMNode(Ce.current);
  }
  var Ie = le.useRef(null), Qe = le.useState(!1), xe = Qe[0], Se = Qe[1];
  h && xe && Se(!1);
  var De = xse(), Ue = De.isFocusVisible, Te = De.onBlurVisible, se = De.ref;
  le.useImperativeHandle(r, function() {
    return {
      focusVisible: function() {
        Se(!0), Ce.current.focus();
      }
    };
  }, []), le.useEffect(function() {
    xe && v && !I && Ie.current.pulsate();
  }, [I, v, xe]);
  function fe(lt, Ht) {
    var vt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : C;
    return Ua(function(It) {
      Ht && Ht(It);
      var un = vt;
      return !un && Ie.current && Ie.current[lt](It), !0;
    });
  }
  var W = fe("start", N), ge = fe("stop", z), _e = fe("stop", $), Re = fe("stop", function(lt) {
    xe && lt.preventDefault(), k && k(lt);
  }), Ee = fe("start", K), oe = fe("stop", U), ie = fe("stop", X), Ae = fe("stop", function(lt) {
    xe && (Te(lt), Se(!1)), Q && Q(lt);
  }, !1), de = Ua(function(lt) {
    Ce.current || (Ce.current = lt.currentTarget), Ue(lt) && (Se(!0), M && M(lt)), R && R(lt);
  }), we = function() {
    var Ht = Be();
    return u && u !== "button" && !(Ht.tagName === "A" && Ht.href);
  }, Pe = le.useRef(!1), qe = Ua(function(lt) {
    v && !Pe.current && xe && Ie.current && lt.key === " " && (Pe.current = !0, lt.persist(), Ie.current.stop(lt, function() {
      Ie.current.start(lt);
    })), lt.target === lt.currentTarget && we() && lt.key === " " && lt.preventDefault(), O && O(lt), lt.target === lt.currentTarget && we() && lt.key === "Enter" && !h && (lt.preventDefault(), w && w(lt));
  }), ke = Ua(function(lt) {
    v && lt.key === " " && Ie.current && xe && !lt.defaultPrevented && (Pe.current = !1, lt.persist(), Ie.current.stop(lt, function() {
      Ie.current.pulsate(lt);
    })), L && L(lt), w && lt.target === lt.currentTarget && we() && lt.key === " " && !lt.defaultPrevented && w(lt);
  }), Xe = u;
  Xe === "button" && pe.href && (Xe = "a");
  var rt = {};
  Xe === "button" ? (rt.type = ee, rt.disabled = h) : ((Xe !== "a" || !pe.href) && (rt.role = "button"), rt["aria-disabled"] = h);
  var it = Ms(i, n), ht = Ms(se, Ce), mt = Ms(it, ht), _t = le.useState(!1), Ct = _t[0], zt = _t[1];
  le.useEffect(function() {
    zt(!0);
  }, []);
  var jt = Ct && !I && !h;
  return /* @__PURE__ */ le.createElement(Xe, at({
    className: Xt(A.root, l, xe && [A.focusVisible, b], h && A.disabled),
    onBlur: Ae,
    onClick: w,
    onFocus: de,
    onKeyDown: qe,
    onKeyUp: ke,
    onMouseDown: W,
    onMouseLeave: Re,
    onMouseUp: _e,
    onDragLeave: ge,
    onTouchEnd: oe,
    onTouchMove: ie,
    onTouchStart: Ee,
    ref: mt,
    tabIndex: h ? -1 : V
  }, rt, pe), a, jt ? (
    /* TouchRipple is only needed client-side, x2 boost on the server. */
    /* @__PURE__ */ le.createElement(D0t, at({
      ref: Ie,
      center: s
    }, Z))
  ) : null);
});
const JQ = Lr(T0t, {
  name: "MuiButtonBase"
})(N0t);
var L0t = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: "center",
      flex: "0 0 auto",
      fontSize: e.typography.pxToRem(24),
      padding: 12,
      borderRadius: "50%",
      overflow: "visible",
      // Explicitly set the default value to solve a bug on IE 11.
      color: e.palette.action.active,
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        backgroundColor: xa(e.palette.action.active, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        backgroundColor: "transparent",
        color: e.palette.action.disabled
      }
    },
    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      "$sizeSmall&": {
        marginLeft: -3
      }
    },
    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      "$sizeSmall&": {
        marginRight: -3
      }
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: e.palette.primary.main,
      "&:hover": {
        backgroundColor: xa(e.palette.primary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: e.palette.secondary.main,
      "&:hover": {
        backgroundColor: xa(e.palette.secondary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: e.typography.pxToRem(18)
    },
    /* Styles applied to the children container element. */
    label: {
      width: "100%",
      display: "flex",
      alignItems: "inherit",
      justifyContent: "inherit"
    }
  };
}, M0t = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.edge, i = r === void 0 ? !1 : r, o = e.children, s = e.classes, a = e.className, A = e.color, l = A === void 0 ? "default" : A, c = e.disabled, u = c === void 0 ? !1 : c, f = e.disableFocusRipple, h = f === void 0 ? !1 : f, d = e.size, I = d === void 0 ? "medium" : d, m = Rn(e, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
  return /* @__PURE__ */ le.createElement(JQ, at({
    className: Xt(s.root, a, l !== "default" && s["color".concat(io(l))], u && s.disabled, I === "small" && s["size".concat(io(I))], {
      start: s.edgeStart,
      end: s.edgeEnd
    }[i]),
    centerRipple: !0,
    focusRipple: !h,
    disabled: u,
    ref: n
  }, m), /* @__PURE__ */ le.createElement("span", {
    className: s.label
  }, o));
});
const KQ = Lr(L0t, {
  name: "MuiIconButton"
})(M0t);
var O0t = function(e) {
  var n = {
    duration: e.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: "flex",
      minHeight: 8 * 6,
      transition: e.transitions.create(["min-height", "background-color"], n),
      padding: e.spacing(0, 2),
      "&:hover:not($disabled)": {
        cursor: "pointer"
      },
      "&$expanded": {
        minHeight: 64
      },
      "&$focused, &$focusVisible": {
        backgroundColor: e.palette.action.focus
      },
      "&$disabled": {
        opacity: e.palette.action.disabledOpacity
      }
    },
    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},
    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focused: {},
    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the children wrapper element. */
    content: {
      display: "flex",
      flexGrow: 1,
      transition: e.transitions.create(["margin"], n),
      margin: "12px 0",
      "&$expanded": {
        margin: "20px 0"
      }
    },
    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: "rotate(0deg)",
      transition: e.transitions.create("transform", n),
      "&:hover": {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: "transparent"
      },
      "&$expanded": {
        transform: "rotate(180deg)"
      }
    }
  };
}, F0t = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.classes, o = e.className, s = e.expandIcon, a = e.focusVisibleClassName, A = e.IconButtonProps, l = A === void 0 ? {} : A, c = e.onClick, u = Rn(e, ["children", "classes", "className", "expandIcon", "focusVisibleClassName", "IconButtonProps", "onClick"]), f = le.useContext($ke), h = f.disabled, d = h === void 0 ? !1 : h, I = f.expanded, m = f.toggle, C = function(v) {
    m && m(v), c && c(v);
  };
  return /* @__PURE__ */ le.createElement(JQ, at({
    focusRipple: !1,
    disableRipple: !0,
    disabled: d,
    component: "div",
    "aria-expanded": I,
    className: Xt(i.root, o, d && i.disabled, I && i.expanded),
    focusVisibleClassName: Xt(i.focusVisible, i.focused, a),
    onClick: C,
    ref: n
  }, u), /* @__PURE__ */ le.createElement("div", {
    className: Xt(i.content, I && i.expanded)
  }, r), s && /* @__PURE__ */ le.createElement(KQ, at({
    className: Xt(i.expandIcon, I && i.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": !0
  }, l), s));
});
const P0t = Lr(O0t, {
  name: "MuiAccordionSummary"
})(F0t);
var k0t = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, G0t = {
  enter: iT.enteringScreen,
  exit: iT.leavingScreen
}, U0t = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.disableStrictModeCompat, o = i === void 0 ? !1 : i, s = e.in, a = e.onEnter, A = e.onEntered, l = e.onEntering, c = e.onExit, u = e.onExited, f = e.onExiting, h = e.style, d = e.TransitionComponent, I = d === void 0 ? Rse : d, m = e.timeout, C = m === void 0 ? G0t : m, y = Rn(e, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]), v = GB(), b = v.unstable_strictMode && !o, Q = le.useRef(null), w = Ms(r.ref, n), R = Ms(b ? Q : void 0, w), M = function(K) {
    return function(z, Y) {
      if (K) {
        var V = b ? [Q.current, z] : [z, Y], Z = yE(V, 2), ce = Z[0], ee = Z[1];
        ee === void 0 ? K(ce) : K(ce, ee);
      }
    };
  }, O = M(l), L = M(function(X, K) {
    Uke(X);
    var z = bS({
      style: h,
      timeout: C
    }, {
      mode: "enter"
    });
    X.style.webkitTransition = v.transitions.create("opacity", z), X.style.transition = v.transitions.create("opacity", z), a && a(X, K);
  }), N = M(A), k = M(f), $ = M(function(X) {
    var K = bS({
      style: h,
      timeout: C
    }, {
      mode: "exit"
    });
    X.style.webkitTransition = v.transitions.create("opacity", K), X.style.transition = v.transitions.create("opacity", K), c && c(X);
  }), U = M(u);
  return /* @__PURE__ */ le.createElement(I, at({
    appear: !0,
    in: s,
    nodeRef: b ? Q : void 0,
    onEnter: L,
    onEntered: N,
    onEntering: O,
    onExit: $,
    onExited: U,
    onExiting: k,
    timeout: C
  }, y), function(X, K) {
    return /* @__PURE__ */ le.cloneElement(r, at({
      style: at({
        opacity: 0,
        visibility: X === "exited" && !s ? "hidden" : void 0
      }, k0t[X], h, r.props.style),
      ref: R
    }, K));
  });
});
const H0t = U0t;
var $0t = tgt(HI(egt, Agt, Bgt, Fgt, Vgt, Ugt, Kgt, oht, hse, yht)), q0t = Kpt("div")($0t, {
  name: "MuiBox"
});
const j0t = q0t;
var Y0t = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },
    /* Styles applied to the root element if `variant="body2"`. */
    body2: e.typography.body2,
    /* Styles applied to the root element if `variant="body1"`. */
    body1: e.typography.body1,
    /* Styles applied to the root element if `variant="caption"`. */
    caption: e.typography.caption,
    /* Styles applied to the root element if `variant="button"`. */
    button: e.typography.button,
    /* Styles applied to the root element if `variant="h1"`. */
    h1: e.typography.h1,
    /* Styles applied to the root element if `variant="h2"`. */
    h2: e.typography.h2,
    /* Styles applied to the root element if `variant="h3"`. */
    h3: e.typography.h3,
    /* Styles applied to the root element if `variant="h4"`. */
    h4: e.typography.h4,
    /* Styles applied to the root element if `variant="h5"`. */
    h5: e.typography.h5,
    /* Styles applied to the root element if `variant="h6"`. */
    h6: e.typography.h6,
    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: e.typography.subtitle1,
    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: e.typography.subtitle2,
    /* Styles applied to the root element if `variant="overline"`. */
    overline: e.typography.overline,
    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: "absolute",
      height: 1,
      width: 1,
      overflow: "hidden"
    },
    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: "left"
    },
    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: "center"
    },
    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: "right"
    },
    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: "justify"
    },
    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: "0.35em"
    },
    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: e.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: e.palette.secondary.main
    },
    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: e.palette.text.primary
    },
    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: e.palette.text.secondary
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: e.palette.error.main
    },
    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: "inline"
    },
    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: "block"
    }
  };
}, cCe = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p"
}, z0t = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.align, i = r === void 0 ? "inherit" : r, o = e.classes, s = e.className, a = e.color, A = a === void 0 ? "initial" : a, l = e.component, c = e.display, u = c === void 0 ? "initial" : c, f = e.gutterBottom, h = f === void 0 ? !1 : f, d = e.noWrap, I = d === void 0 ? !1 : d, m = e.paragraph, C = m === void 0 ? !1 : m, y = e.variant, v = y === void 0 ? "body1" : y, b = e.variantMapping, Q = b === void 0 ? cCe : b, w = Rn(e, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]), R = l || (C ? "p" : Q[v] || cCe[v]) || "span";
  return /* @__PURE__ */ le.createElement(R, at({
    className: Xt(o.root, s, v !== "inherit" && o[v], A !== "initial" && o["color".concat(io(A))], I && o.noWrap, h && o.gutterBottom, C && o.paragraph, i !== "inherit" && o["align".concat(io(i))], u !== "initial" && o["display".concat(io(u))]),
    ref: n
  }, w));
});
const Mu = Lr(Y0t, {
  name: "MuiTypography"
})(z0t);
var V0t = function(e) {
  return {
    /* Styles applied to the root element. */
    root: at({}, e.typography.button, {
      boxSizing: "border-box",
      minWidth: 64,
      padding: "6px 16px",
      borderRadius: e.shape.borderRadius,
      color: e.palette.text.primary,
      transition: e.transitions.create(["background-color", "box-shadow", "border"], {
        duration: e.transitions.duration.short
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: xa(e.palette.text.primary, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        },
        "&$disabled": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        color: e.palette.action.disabled
      }
    }),
    /* Styles applied to the span element that wraps the children. */
    label: {
      width: "100%",
      // Ensure the correct width for iOS Safari
      display: "inherit",
      alignItems: "inherit",
      justifyContent: "inherit"
    },
    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: "6px 8px"
    },
    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: e.palette.primary.main,
      "&:hover": {
        backgroundColor: xa(e.palette.primary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: e.palette.secondary.main,
      "&:hover": {
        backgroundColor: xa(e.palette.secondary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: "5px 15px",
      border: "1px solid ".concat(e.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
      "&$disabled": {
        border: "1px solid ".concat(e.palette.action.disabledBackground)
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: e.palette.primary.main,
      border: "1px solid ".concat(xa(e.palette.primary.main, 0.5)),
      "&:hover": {
        border: "1px solid ".concat(e.palette.primary.main),
        backgroundColor: xa(e.palette.primary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: e.palette.secondary.main,
      border: "1px solid ".concat(xa(e.palette.secondary.main, 0.5)),
      "&:hover": {
        border: "1px solid ".concat(e.palette.secondary.main),
        backgroundColor: xa(e.palette.secondary.main, e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        border: "1px solid ".concat(e.palette.action.disabled)
      }
    },
    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: e.palette.getContrastText(e.palette.grey[300]),
      backgroundColor: e.palette.grey[300],
      boxShadow: e.shadows[2],
      "&:hover": {
        backgroundColor: e.palette.grey.A100,
        boxShadow: e.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          boxShadow: e.shadows[2],
          backgroundColor: e.palette.grey[300]
        },
        "&$disabled": {
          backgroundColor: e.palette.action.disabledBackground
        }
      },
      "&$focusVisible": {
        boxShadow: e.shadows[6]
      },
      "&:active": {
        boxShadow: e.shadows[8]
      },
      "&$disabled": {
        color: e.palette.action.disabled,
        boxShadow: e.shadows[0],
        backgroundColor: e.palette.action.disabledBackground
      }
    },
    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: e.palette.primary.contrastText,
      backgroundColor: e.palette.primary.main,
      "&:hover": {
        backgroundColor: e.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: e.palette.primary.main
        }
      }
    },
    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: e.palette.secondary.contrastText,
      backgroundColor: e.palette.secondary.main,
      "&:hover": {
        backgroundColor: e.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: e.palette.secondary.main
        }
      }
    },
    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none"
      },
      "&$focusVisible": {
        boxShadow: "none"
      },
      "&:active": {
        boxShadow: "none"
      },
      "&$disabled": {
        boxShadow: "none"
      }
    },
    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit",
      borderColor: "currentColor"
    },
    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: "4px 5px",
      fontSize: e.typography.pxToRem(13)
    },
    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: "8px 11px",
      fontSize: e.typography.pxToRem(15)
    },
    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: "3px 9px",
      fontSize: e.typography.pxToRem(13)
    },
    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: "7px 21px",
      fontSize: e.typography.pxToRem(15)
    },
    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: "4px 10px",
      fontSize: e.typography.pxToRem(13)
    },
    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: "8px 22px",
      fontSize: e.typography.pxToRem(15)
    },
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},
    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: "100%"
    },
    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: "inherit",
      marginRight: 8,
      marginLeft: -4,
      "&$iconSizeSmall": {
        marginLeft: -2
      }
    },
    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: "inherit",
      marginRight: -4,
      marginLeft: 8,
      "&$iconSizeSmall": {
        marginRight: -2
      }
    },
    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      "& > *:first-child": {
        fontSize: 18
      }
    },
    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      "& > *:first-child": {
        fontSize: 20
      }
    },
    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      "& > *:first-child": {
        fontSize: 22
      }
    }
  };
}, J0t = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.classes, o = e.className, s = e.color, a = s === void 0 ? "default" : s, A = e.component, l = A === void 0 ? "button" : A, c = e.disabled, u = c === void 0 ? !1 : c, f = e.disableElevation, h = f === void 0 ? !1 : f, d = e.disableFocusRipple, I = d === void 0 ? !1 : d, m = e.endIcon, C = e.focusVisibleClassName, y = e.fullWidth, v = y === void 0 ? !1 : y, b = e.size, Q = b === void 0 ? "medium" : b, w = e.startIcon, R = e.type, M = R === void 0 ? "button" : R, O = e.variant, L = O === void 0 ? "text" : O, N = Rn(e, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]), k = w && /* @__PURE__ */ le.createElement("span", {
    className: Xt(i.startIcon, i["iconSize".concat(io(Q))])
  }, w), $ = m && /* @__PURE__ */ le.createElement("span", {
    className: Xt(i.endIcon, i["iconSize".concat(io(Q))])
  }, m);
  return /* @__PURE__ */ le.createElement(JQ, at({
    className: Xt(i.root, i[L], o, a === "inherit" ? i.colorInherit : a !== "default" && i["".concat(L).concat(io(a))], Q !== "medium" && [i["".concat(L, "Size").concat(io(Q))], i["size".concat(io(Q))]], h && i.disableElevation, u && i.disabled, v && i.fullWidth),
    component: l,
    disabled: u,
    focusRipple: !I,
    focusVisibleClassName: Xt(i.focusVisible, C),
    ref: n,
    type: M
  }, N), /* @__PURE__ */ le.createElement("span", {
    className: i.label
  }, k, r, $));
});
const Dp = Lr(V0t, {
  name: "MuiButton"
})(J0t);
var qke = le.createContext();
function K0t() {
  return le.useContext(qke);
}
const Nse = qke;
function UB() {
  return le.useContext(Nse);
}
var W0t = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
}, X0t = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.autoFocus, i = e.checked, o = e.checkedIcon, s = e.classes, a = e.className, A = e.defaultChecked, l = e.disabled, c = e.icon, u = e.id, f = e.inputProps, h = e.inputRef, d = e.name, I = e.onBlur, m = e.onChange, C = e.onFocus, y = e.readOnly, v = e.required, b = e.tabIndex, Q = e.type, w = e.value, R = Rn(e, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]), M = mH({
    controlled: i,
    default: !!A,
    name: "SwitchBase",
    state: "checked"
  }), O = yE(M, 2), L = O[0], N = O[1], k = UB(), $ = function(V) {
    C && C(V), k && k.onFocus && k.onFocus(V);
  }, U = function(V) {
    I && I(V), k && k.onBlur && k.onBlur(V);
  }, X = function(V) {
    var Z = V.target.checked;
    N(Z), m && m(V, Z);
  }, K = l;
  k && typeof K > "u" && (K = k.disabled);
  var z = Q === "checkbox" || Q === "radio";
  return /* @__PURE__ */ le.createElement(KQ, at({
    component: "span",
    className: Xt(s.root, a, L && s.checked, K && s.disabled),
    disabled: K,
    tabIndex: null,
    role: void 0,
    onFocus: $,
    onBlur: U,
    ref: n
  }, R), /* @__PURE__ */ le.createElement("input", at({
    autoFocus: r,
    checked: i,
    defaultChecked: A,
    className: s.input,
    disabled: K,
    id: z && u,
    name: d,
    onChange: X,
    readOnly: y,
    ref: h,
    required: v,
    tabIndex: b,
    type: Q,
    value: w
  }, f)), L ? o : c);
});
const jke = Lr(W0t, {
  name: "PrivateSwitchBase"
})(X0t), Z0t = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
})), eIt = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
})), tIt = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}));
var nIt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: e.palette.text.secondary
    },
    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
    indeterminate: {},
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      "&$checked": {
        color: e.palette.primary.main,
        "&:hover": {
          backgroundColor: xa(e.palette.primary.main, e.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        }
      },
      "&$disabled": {
        color: e.palette.action.disabled
      }
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      "&$checked": {
        color: e.palette.secondary.main,
        "&:hover": {
          backgroundColor: xa(e.palette.secondary.main, e.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        }
      },
      "&$disabled": {
        color: e.palette.action.disabled
      }
    }
  };
}, rIt = /* @__PURE__ */ le.createElement(eIt, null), iIt = /* @__PURE__ */ le.createElement(Z0t, null), oIt = /* @__PURE__ */ le.createElement(tIt, null), sIt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.checkedIcon, i = r === void 0 ? rIt : r, o = e.classes, s = e.color, a = s === void 0 ? "secondary" : s, A = e.icon, l = A === void 0 ? iIt : A, c = e.indeterminate, u = c === void 0 ? !1 : c, f = e.indeterminateIcon, h = f === void 0 ? oIt : f, d = e.inputProps, I = e.size, m = I === void 0 ? "medium" : I, C = Rn(e, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]), y = u ? h : l, v = u ? h : i;
  return /* @__PURE__ */ le.createElement(jke, at({
    type: "checkbox",
    classes: {
      root: Xt(o.root, o["color".concat(io(a))], u && o.indeterminate),
      checked: o.checked,
      disabled: o.disabled
    },
    color: a,
    inputProps: at({
      "data-indeterminate": u
    }, d),
    icon: /* @__PURE__ */ le.cloneElement(y, {
      fontSize: y.props.fontSize === void 0 && m === "small" ? m : y.props.fontSize
    }),
    checkedIcon: /* @__PURE__ */ le.cloneElement(v, {
      fontSize: v.props.fontSize === void 0 && m === "small" ? m : v.props.fontSize
    }),
    ref: n
  }, C));
});
const ds = Lr(nIt, {
  name: "MuiCheckbox"
})(sIt);
var vm = 44, aIt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "inline-block"
    },
    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: e.transitions.create("transform")
    },
    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: "$circular-rotate 1.4s linear infinite"
    },
    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: e.transitions.create("transform")
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: e.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: e.palette.secondary.main
    },
    /* Styles applied to the `svg` element. */
    svg: {
      display: "block"
      // Keeps the progress centered
    },
    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: "currentColor"
      // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',
    },
    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: e.transitions.create("stroke-dashoffset")
    },
    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: "$circular-dash 1.4s ease-in-out infinite",
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: "0px"
      // Add the unit to fix a Edge 16 and below bug.
    },
    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: e.transitions.create("stroke-dashoffset")
    },
    "@keyframes circular-rotate": {
      "0%": {
        // Fix IE 11 wobbly
        transformOrigin: "50% 50%"
      },
      "100%": {
        transform: "rotate(360deg)"
      }
    },
    "@keyframes circular-dash": {
      "0%": {
        strokeDasharray: "1px, 200px",
        strokeDashoffset: "0px"
      },
      "50%": {
        strokeDasharray: "100px, 200px",
        strokeDashoffset: "-15px"
      },
      "100%": {
        strokeDasharray: "100px, 200px",
        strokeDashoffset: "-125px"
      }
    },
    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: "none"
    }
  };
}, AIt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.color, s = o === void 0 ? "primary" : o, a = e.disableShrink, A = a === void 0 ? !1 : a, l = e.size, c = l === void 0 ? 40 : l, u = e.style, f = e.thickness, h = f === void 0 ? 3.6 : f, d = e.value, I = d === void 0 ? 0 : d, m = e.variant, C = m === void 0 ? "indeterminate" : m, y = Rn(e, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]), v = {}, b = {}, Q = {};
  if (C === "determinate" || C === "static") {
    var w = 2 * Math.PI * ((vm - h) / 2);
    v.strokeDasharray = w.toFixed(3), Q["aria-valuenow"] = Math.round(I), v.strokeDashoffset = "".concat(((100 - I) / 100 * w).toFixed(3), "px"), b.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ le.createElement("div", at({
    className: Xt(r.root, i, s !== "inherit" && r["color".concat(io(s))], {
      determinate: r.determinate,
      indeterminate: r.indeterminate,
      static: r.static
    }[C]),
    style: at({
      width: c,
      height: c
    }, b, u),
    ref: n,
    role: "progressbar"
  }, Q, y), /* @__PURE__ */ le.createElement("svg", {
    className: r.svg,
    viewBox: "".concat(vm / 2, " ").concat(vm / 2, " ").concat(vm, " ").concat(vm)
  }, /* @__PURE__ */ le.createElement("circle", {
    className: Xt(r.circle, A && r.circleDisableShrink, {
      determinate: r.circleDeterminate,
      indeterminate: r.circleIndeterminate,
      static: r.circleStatic
    }[C]),
    style: v,
    cx: vm,
    cy: vm,
    r: (vm - h) / 2,
    fill: "none",
    strokeWidth: h
  })));
});
const lIt = Lr(aIt, {
  name: "MuiCircularProgress",
  flip: !1
})(AIt);
function uCe(t) {
  return t.substring(2).toLowerCase();
}
function cIt(t) {
  return document.documentElement.clientWidth < t.clientX || document.documentElement.clientHeight < t.clientY;
}
function uIt(t) {
  var e = t.children, n = t.disableReactTree, r = n === void 0 ? !1 : n, i = t.mouseEvent, o = i === void 0 ? "onClick" : i, s = t.onClickAway, a = t.touchEvent, A = a === void 0 ? "onTouchEnd" : a, l = le.useRef(!1), c = le.useRef(null), u = le.useRef(!1), f = le.useRef(!1);
  le.useEffect(function() {
    return setTimeout(function() {
      u.current = !0;
    }, 0), function() {
      u.current = !1;
    };
  }, []);
  var h = le.useCallback(function(y) {
    c.current = Ed.findDOMNode(y);
  }, []), d = Ms(e.ref, h), I = Ua(function(y) {
    var v = f.current;
    if (f.current = !1, !(!u.current || !c.current || cIt(y))) {
      if (l.current) {
        l.current = !1;
        return;
      }
      var b;
      if (y.composedPath)
        b = y.composedPath().indexOf(c.current) > -1;
      else {
        var Q = zl(c.current);
        b = !Q.documentElement.contains(y.target) || c.current.contains(y.target);
      }
      !b && (r || !v) && s(y);
    }
  }), m = function(v) {
    return function(b) {
      f.current = !0;
      var Q = e.props[v];
      Q && Q(b);
    };
  }, C = {
    ref: d
  };
  return A !== !1 && (C[A] = m(A)), le.useEffect(function() {
    if (A !== !1) {
      var y = uCe(A), v = zl(c.current), b = function() {
        l.current = !0;
      };
      return v.addEventListener(y, I), v.addEventListener("touchmove", b), function() {
        v.removeEventListener(y, I), v.removeEventListener("touchmove", b);
      };
    }
  }, [I, A]), o !== !1 && (C[o] = m(o)), le.useEffect(function() {
    if (o !== !1) {
      var y = uCe(o), v = zl(c.current);
      return v.addEventListener(y, I), function() {
        v.removeEventListener(y, I);
      };
    }
  }, [I, o]), /* @__PURE__ */ le.createElement(le.Fragment, null, /* @__PURE__ */ le.cloneElement(e, C));
}
function fIt(t) {
  return t = typeof t == "function" ? t() : t, Ed.findDOMNode(t);
}
var bz = typeof window < "u" ? le.useLayoutEffect : le.useEffect, gIt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.container, o = e.disablePortal, s = o === void 0 ? !1 : o, a = e.onRendered, A = le.useState(null), l = A[0], c = A[1], u = Ms(/* @__PURE__ */ le.isValidElement(r) ? r.ref : null, n);
  return bz(function() {
    s || c(fIt(i) || document.body);
  }, [i, s]), bz(function() {
    if (l && !s)
      return BS(n, l), function() {
        BS(n, null);
      };
  }, [n, l, s]), bz(function() {
    a && (l || s) && a();
  }, [a, l, s]), s ? /* @__PURE__ */ le.isValidElement(r) ? /* @__PURE__ */ le.cloneElement(r, {
    ref: u
  }) : r : l && /* @__PURE__ */ Ed.createPortal(r, l);
});
const Yke = gIt;
function zke() {
  var t = document.createElement("div");
  t.style.width = "99px", t.style.height = "99px", t.style.position = "absolute", t.style.top = "-9999px", t.style.overflow = "scroll", document.body.appendChild(t);
  var e = t.offsetWidth - t.clientWidth;
  return document.body.removeChild(t), e;
}
function hIt(t) {
  var e = zl(t);
  return e.body === t ? wse(e).innerWidth > e.documentElement.clientWidth : t.scrollHeight > t.clientHeight;
}
function hD(t, e) {
  e ? t.setAttribute("aria-hidden", "true") : t.removeAttribute("aria-hidden");
}
function fCe(t) {
  return parseInt(window.getComputedStyle(t)["padding-right"], 10) || 0;
}
function gCe(t, e, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], i = arguments.length > 4 ? arguments[4] : void 0, o = [e, n].concat(iH(r)), s = ["TEMPLATE", "SCRIPT", "STYLE"];
  [].forEach.call(t.children, function(a) {
    a.nodeType === 1 && o.indexOf(a) === -1 && s.indexOf(a.tagName) === -1 && hD(a, i);
  });
}
function _z(t, e) {
  var n = -1;
  return t.some(function(r, i) {
    return e(r) ? (n = i, !0) : !1;
  }), n;
}
function dIt(t, e) {
  var n = [], r = [], i = t.container, o;
  if (!e.disableScrollLock) {
    if (hIt(i)) {
      var s = zke();
      n.push({
        value: i.style.paddingRight,
        key: "padding-right",
        el: i
      }), i.style["padding-right"] = "".concat(fCe(i) + s, "px"), o = zl(i).querySelectorAll(".mui-fixed"), [].forEach.call(o, function(c) {
        r.push(c.style.paddingRight), c.style.paddingRight = "".concat(fCe(c) + s, "px");
      });
    }
    var a = i.parentElement, A = a.nodeName === "HTML" && window.getComputedStyle(a)["overflow-y"] === "scroll" ? a : i;
    n.push({
      value: A.style.overflow,
      key: "overflow",
      el: A
    }), A.style.overflow = "hidden";
  }
  var l = function() {
    o && [].forEach.call(o, function(u, f) {
      r[f] ? u.style.paddingRight = r[f] : u.style.removeProperty("padding-right");
    }), n.forEach(function(u) {
      var f = u.value, h = u.el, d = u.key;
      f ? h.style.setProperty(d, f) : h.style.removeProperty(d);
    });
  };
  return l;
}
function pIt(t) {
  var e = [];
  return [].forEach.call(t.children, function(n) {
    n.getAttribute && n.getAttribute("aria-hidden") === "true" && e.push(n);
  }), e;
}
var IIt = /* @__PURE__ */ function() {
  function t() {
    Spt(this, t), this.modals = [], this.containers = [];
  }
  return Qpt(t, [{
    key: "add",
    value: function(n, r) {
      var i = this.modals.indexOf(n);
      if (i !== -1)
        return i;
      i = this.modals.length, this.modals.push(n), n.modalRef && hD(n.modalRef, !1);
      var o = pIt(r);
      gCe(r, n.mountNode, n.modalRef, o, !0);
      var s = _z(this.containers, function(a) {
        return a.container === r;
      });
      return s !== -1 ? (this.containers[s].modals.push(n), i) : (this.containers.push({
        modals: [n],
        container: r,
        restore: null,
        hiddenSiblingNodes: o
      }), i);
    }
  }, {
    key: "mount",
    value: function(n, r) {
      var i = _z(this.containers, function(s) {
        return s.modals.indexOf(n) !== -1;
      }), o = this.containers[i];
      o.restore || (o.restore = dIt(o, r));
    }
  }, {
    key: "remove",
    value: function(n) {
      var r = this.modals.indexOf(n);
      if (r === -1)
        return r;
      var i = _z(this.containers, function(a) {
        return a.modals.indexOf(n) !== -1;
      }), o = this.containers[i];
      if (o.modals.splice(o.modals.indexOf(n), 1), this.modals.splice(r, 1), o.modals.length === 0)
        o.restore && o.restore(), n.modalRef && hD(n.modalRef, !0), gCe(o.container, n.mountNode, n.modalRef, o.hiddenSiblingNodes, !1), this.containers.splice(i, 1);
      else {
        var s = o.modals[o.modals.length - 1];
        s.modalRef && hD(s.modalRef, !1);
      }
      return r;
    }
  }, {
    key: "isTopModal",
    value: function(n) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === n;
    }
  }]), t;
}();
function mIt(t) {
  var e = t.children, n = t.disableAutoFocus, r = n === void 0 ? !1 : n, i = t.disableEnforceFocus, o = i === void 0 ? !1 : i, s = t.disableRestoreFocus, a = s === void 0 ? !1 : s, A = t.getDoc, l = t.isEnabled, c = t.open, u = le.useRef(), f = le.useRef(null), h = le.useRef(null), d = le.useRef(), I = le.useRef(null), m = le.useCallback(function(v) {
    I.current = Ed.findDOMNode(v);
  }, []), C = Ms(e.ref, m), y = le.useRef();
  return le.useEffect(function() {
    y.current = c;
  }, [c]), !y.current && c && typeof window < "u" && (d.current = A().activeElement), le.useEffect(function() {
    if (c) {
      var v = zl(I.current);
      !r && I.current && !I.current.contains(v.activeElement) && (I.current.hasAttribute("tabIndex") || I.current.setAttribute("tabIndex", -1), I.current.focus());
      var b = function() {
        var M = I.current;
        if (M !== null) {
          if (!v.hasFocus() || o || !l() || u.current) {
            u.current = !1;
            return;
          }
          I.current && !I.current.contains(v.activeElement) && I.current.focus();
        }
      }, Q = function(M) {
        o || !l() || M.keyCode !== 9 || v.activeElement === I.current && (u.current = !0, M.shiftKey ? h.current.focus() : f.current.focus());
      };
      v.addEventListener("focus", b, !0), v.addEventListener("keydown", Q, !0);
      var w = setInterval(function() {
        b();
      }, 50);
      return function() {
        clearInterval(w), v.removeEventListener("focus", b, !0), v.removeEventListener("keydown", Q, !0), a || (d.current && d.current.focus && d.current.focus(), d.current = null);
      };
    }
  }, [r, o, a, l, c]), /* @__PURE__ */ le.createElement(le.Fragment, null, /* @__PURE__ */ le.createElement("div", {
    tabIndex: 0,
    ref: f,
    "data-test": "sentinelStart"
  }), /* @__PURE__ */ le.cloneElement(e, {
    ref: C
  }), /* @__PURE__ */ le.createElement("div", {
    tabIndex: 0,
    ref: h,
    "data-test": "sentinelEnd"
  }));
}
var hCe = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: "fixed",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    WebkitTapHighlightColor: "transparent"
  },
  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: "transparent"
  }
}, CIt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.invisible, i = r === void 0 ? !1 : r, o = e.open, s = Rn(e, ["invisible", "open"]);
  return o ? /* @__PURE__ */ le.createElement("div", at({
    "aria-hidden": !0,
    ref: n
  }, s, {
    style: at({}, hCe.root, i ? hCe.invisible : {}, s.style)
  })) : null;
});
const EIt = CIt;
function yIt(t) {
  return t = typeof t == "function" ? t() : t, Ed.findDOMNode(t);
}
function vIt(t) {
  return t.children ? t.children.props.hasOwnProperty("in") : !1;
}
var BIt = new IIt(), bIt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "fixed",
      zIndex: e.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },
    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: "hidden"
    }
  };
}, _It = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = VQ(), i = hke({
    name: "MuiModal",
    props: at({}, e),
    theme: r
  }), o = i.BackdropComponent, s = o === void 0 ? EIt : o, a = i.BackdropProps, A = i.children, l = i.closeAfterTransition, c = l === void 0 ? !1 : l, u = i.container, f = i.disableAutoFocus, h = f === void 0 ? !1 : f, d = i.disableBackdropClick, I = d === void 0 ? !1 : d, m = i.disableEnforceFocus, C = m === void 0 ? !1 : m, y = i.disableEscapeKeyDown, v = y === void 0 ? !1 : y, b = i.disablePortal, Q = b === void 0 ? !1 : b, w = i.disableRestoreFocus, R = w === void 0 ? !1 : w, M = i.disableScrollLock, O = M === void 0 ? !1 : M, L = i.hideBackdrop, N = L === void 0 ? !1 : L, k = i.keepMounted, $ = k === void 0 ? !1 : k, U = i.manager, X = U === void 0 ? BIt : U, K = i.onBackdropClick, z = i.onClose, Y = i.onEscapeKeyDown, V = i.onRendered, Z = i.open, ce = Rn(i, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]), ee = le.useState(!0), pe = ee[0], Ce = ee[1], Be = le.useRef({}), Ie = le.useRef(null), Qe = le.useRef(null), xe = Ms(Qe, n), Se = vIt(i), De = function() {
    return zl(Ie.current);
  }, Ue = function() {
    return Be.current.modalRef = Qe.current, Be.current.mountNode = Ie.current, Be.current;
  }, Te = function() {
    X.mount(Ue(), {
      disableScrollLock: O
    }), Qe.current.scrollTop = 0;
  }, se = Ua(function() {
    var de = yIt(u) || De().body;
    X.add(Ue(), de), Qe.current && Te();
  }), fe = le.useCallback(function() {
    return X.isTopModal(Ue());
  }, [X]), W = Ua(function(de) {
    Ie.current = de, de && (V && V(), Z && fe() ? Te() : hD(Qe.current, !0));
  }), ge = le.useCallback(function() {
    X.remove(Ue());
  }, [X]);
  if (le.useEffect(function() {
    return function() {
      ge();
    };
  }, [ge]), le.useEffect(function() {
    Z ? se() : (!Se || !c) && ge();
  }, [Z, ge, Se, c, se]), !$ && !Z && (!Se || pe))
    return null;
  var _e = function() {
    Ce(!1);
  }, Re = function() {
    Ce(!0), c && ge();
  }, Ee = function(we) {
    we.target === we.currentTarget && (K && K(we), !I && z && z(we, "backdropClick"));
  }, oe = function(we) {
    we.key !== "Escape" || !fe() || (Y && Y(we), v || (we.stopPropagation(), z && z(we, "escapeKeyDown")));
  }, ie = bIt(r || {
    zIndex: fke
  }), Ae = {};
  return A.props.tabIndex === void 0 && (Ae.tabIndex = A.props.tabIndex || "-1"), Se && (Ae.onEnter = sT(_e, A.props.onEnter), Ae.onExited = sT(Re, A.props.onExited)), /* @__PURE__ */ le.createElement(Yke, {
    ref: W,
    container: u,
    disablePortal: Q
  }, /* @__PURE__ */ le.createElement("div", at({
    ref: xe,
    onKeyDown: oe,
    role: "presentation"
  }, ce, {
    style: at({}, ie.root, !Z && pe ? ie.hidden : {}, ce.style)
  }), N ? null : /* @__PURE__ */ le.createElement(s, at({
    open: Z,
    onClick: Ee
  }, a)), /* @__PURE__ */ le.createElement(mIt, {
    disableEnforceFocus: C,
    disableAutoFocus: h,
    disableRestoreFocus: R,
    getDoc: De,
    isEnabled: fe,
    open: Z
  }, /* @__PURE__ */ le.cloneElement(A, Ae))));
});
const SIt = _It;
function WQ(t) {
  var e = t.props, n = t.states, r = t.muiFormControl;
  return n.reduce(function(i, o) {
    return i[o] = e[o], r && typeof e[o] > "u" && (i[o] = r[o]), i;
  }, {});
}
function tF(t, e) {
  return parseInt(t[e], 10) || 0;
}
var QIt = typeof window < "u" ? le.useLayoutEffect : le.useEffect, wIt = {
  /* Styles applied to the shadow textarea element. */
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
}, xIt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.onChange, i = e.rows, o = e.rowsMax, s = e.rowsMin, a = e.maxRows, A = e.minRows, l = A === void 0 ? 1 : A, c = e.style, u = e.value, f = Rn(e, ["onChange", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "style", "value"]), h = a || o, d = i || s || l, I = le.useRef(u != null), m = I.current, C = le.useRef(null), y = Ms(n, C), v = le.useRef(null), b = le.useRef(0), Q = le.useState({}), w = Q[0], R = Q[1], M = le.useCallback(function() {
    var L = C.current, N = window.getComputedStyle(L), k = v.current;
    k.style.width = N.width, k.value = L.value || e.placeholder || "x", k.value.slice(-1) === `
` && (k.value += " ");
    var $ = N["box-sizing"], U = tF(N, "padding-bottom") + tF(N, "padding-top"), X = tF(N, "border-bottom-width") + tF(N, "border-top-width"), K = k.scrollHeight - U;
    k.value = "x";
    var z = k.scrollHeight - U, Y = K;
    d && (Y = Math.max(Number(d) * z, Y)), h && (Y = Math.min(Number(h) * z, Y)), Y = Math.max(Y, z);
    var V = Y + ($ === "border-box" ? U + X : 0), Z = Math.abs(Y - K) <= 1;
    R(function(ce) {
      return b.current < 20 && (V > 0 && Math.abs((ce.outerHeightStyle || 0) - V) > 1 || ce.overflow !== Z) ? (b.current += 1, {
        overflow: Z,
        outerHeightStyle: V
      }) : ce;
    });
  }, [h, d, e.placeholder]);
  le.useEffect(function() {
    var L = aT(function() {
      b.current = 0, M();
    });
    return window.addEventListener("resize", L), function() {
      L.clear(), window.removeEventListener("resize", L);
    };
  }, [M]), QIt(function() {
    M();
  }), le.useEffect(function() {
    b.current = 0;
  }, [u]);
  var O = function(N) {
    b.current = 0, m || M(), r && r(N);
  };
  return /* @__PURE__ */ le.createElement(le.Fragment, null, /* @__PURE__ */ le.createElement("textarea", at({
    value: u,
    onChange: O,
    ref: y,
    rows: d,
    style: at({
      height: w.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: w.overflow ? "hidden" : null
    }, c)
  }, f)), /* @__PURE__ */ le.createElement("textarea", {
    "aria-hidden": !0,
    className: e.className,
    readOnly: !0,
    ref: v,
    tabIndex: -1,
    style: at({}, wIt.shadow, c)
  }));
});
const RIt = xIt;
function dCe(t) {
  return t != null && !(Array.isArray(t) && t.length === 0);
}
function Lse(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return t && (dCe(t.value) && t.value !== "" || e && dCe(t.defaultValue) && t.defaultValue !== "");
}
function DIt(t) {
  return t.startAdornment;
}
var TIt = function(e) {
  var n = e.palette.type === "light", r = {
    color: "currentColor",
    opacity: n ? 0.42 : 0.5,
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, i = {
    opacity: "0 !important"
  }, o = {
    opacity: n ? 0.42 : 0.5
  };
  return {
    "@global": {
      "@keyframes mui-auto-fill": {},
      "@keyframes mui-auto-fill-cancel": {}
    },
    /* Styles applied to the root element. */
    root: at({}, e.typography.body1, {
      color: e.palette.text.primary,
      lineHeight: "1.1876em",
      // Reset (19px), match the native input line-height
      boxSizing: "border-box",
      // Prevent padding issue with fullWidth.
      position: "relative",
      cursor: "text",
      display: "inline-flex",
      alignItems: "center",
      "&$disabled": {
        color: e.palette.text.disabled,
        cursor: "default"
      }
    }),
    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},
    /* Styles applied to the root element if the component is focused. */
    focused: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},
    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      "&$marginDense": {
        paddingTop: 4 - 1
      }
    },
    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {},
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: "100%"
    },
    /* Styles applied to the `input` element. */
    input: {
      font: "inherit",
      letterSpacing: "inherit",
      color: "currentColor",
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: "content-box",
      background: "none",
      height: "1.1876em",
      // Reset (19px), match the native input line-height
      margin: 0,
      // Reset for Safari
      WebkitTapHighlightColor: "transparent",
      display: "block",
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: "100%",
      // Fix IE 11 width issue
      animationName: "mui-auto-fill-cancel",
      animationDuration: "10ms",
      "&::-webkit-input-placeholder": r,
      "&::-moz-placeholder": r,
      // Firefox 19+
      "&:-ms-input-placeholder": r,
      // IE 11
      "&::-ms-input-placeholder": r,
      // Edge
      "&:focus": {
        outline: 0
      },
      // Reset Firefox invalid required input style
      "&:invalid": {
        boxShadow: "none"
      },
      "&::-webkit-search-decoration": {
        // Remove the padding when type=search.
        "-webkit-appearance": "none"
      },
      // Show and hide the placeholder logic
      "label[data-shrink=false] + $formControl &": {
        "&::-webkit-input-placeholder": i,
        "&::-moz-placeholder": i,
        // Firefox 19+
        "&:-ms-input-placeholder": i,
        // IE 11
        "&::-ms-input-placeholder": i,
        // Edge
        "&:focus::-webkit-input-placeholder": o,
        "&:focus::-moz-placeholder": o,
        // Firefox 19+
        "&:focus:-ms-input-placeholder": o,
        // IE 11
        "&:focus::-ms-input-placeholder": o
        // Edge
      },
      "&$disabled": {
        opacity: 1
        // Reset iOS opacity
      },
      "&:-webkit-autofill": {
        animationDuration: "5000s",
        animationName: "mui-auto-fill"
      }
    },
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      height: "auto",
      resize: "none",
      padding: 0
    },
    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      "-moz-appearance": "textfield",
      "-webkit-appearance": "textfield"
    },
    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},
    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {},
    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
    inputHiddenLabel: {}
  };
}, NIt = typeof window > "u" ? le.useEffect : le.useLayoutEffect, LIt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e["aria-describedby"], i = e.autoComplete, o = e.autoFocus, s = e.classes, a = e.className;
  e.color;
  var A = e.defaultValue, l = e.disabled, c = e.endAdornment;
  e.error;
  var u = e.fullWidth, f = u === void 0 ? !1 : u, h = e.id, d = e.inputComponent, I = d === void 0 ? "input" : d, m = e.inputProps, C = m === void 0 ? {} : m, y = e.inputRef;
  e.margin;
  var v = e.multiline, b = v === void 0 ? !1 : v, Q = e.name, w = e.onBlur, R = e.onChange, M = e.onClick, O = e.onFocus, L = e.onKeyDown, N = e.onKeyUp, k = e.placeholder, $ = e.readOnly, U = e.renderSuffix, X = e.rows, K = e.rowsMax, z = e.rowsMin, Y = e.maxRows, V = e.minRows, Z = e.startAdornment, ce = e.type, ee = ce === void 0 ? "text" : ce, pe = e.value, Ce = Rn(e, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "startAdornment", "type", "value"]), Be = C.value != null ? C.value : pe, Ie = le.useRef(Be != null), Qe = Ie.current, xe = le.useRef(), Se = le.useCallback(function(Xe) {
  }, []), De = Ms(C.ref, Se), Ue = Ms(y, De), Te = Ms(xe, Ue), se = le.useState(!1), fe = se[0], W = se[1], ge = K0t(), _e = WQ({
    props: e,
    muiFormControl: ge,
    states: ["color", "disabled", "error", "hiddenLabel", "margin", "required", "filled"]
  });
  _e.focused = ge ? ge.focused : fe, le.useEffect(function() {
    !ge && l && fe && (W(!1), w && w());
  }, [ge, l, fe, w]);
  var Re = ge && ge.onFilled, Ee = ge && ge.onEmpty, oe = le.useCallback(function(Xe) {
    Lse(Xe) ? Re && Re() : Ee && Ee();
  }, [Re, Ee]);
  NIt(function() {
    Qe && oe({
      value: Be
    });
  }, [Be, oe, Qe]);
  var ie = function(rt) {
    if (_e.disabled) {
      rt.stopPropagation();
      return;
    }
    O && O(rt), C.onFocus && C.onFocus(rt), ge && ge.onFocus ? ge.onFocus(rt) : W(!0);
  }, Ae = function(rt) {
    w && w(rt), C.onBlur && C.onBlur(rt), ge && ge.onBlur ? ge.onBlur(rt) : W(!1);
  }, de = function(rt) {
    if (!Qe) {
      var it = rt.target || xe.current;
      if (it == null)
        throw new Error(vS(1));
      oe({
        value: it.value
      });
    }
    for (var ht = arguments.length, mt = new Array(ht > 1 ? ht - 1 : 0), _t = 1; _t < ht; _t++)
      mt[_t - 1] = arguments[_t];
    C.onChange && C.onChange.apply(C, [rt].concat(mt)), R && R.apply(void 0, [rt].concat(mt));
  };
  le.useEffect(function() {
    oe(xe.current);
  }, []);
  var we = function(rt) {
    xe.current && rt.currentTarget === rt.target && xe.current.focus(), M && M(rt);
  }, Pe = I, qe = at({}, C, {
    ref: Te
  });
  typeof Pe != "string" ? qe = at({
    // Rename ref to inputRef as we don't know the
    // provided `inputComponent` structure.
    inputRef: Te,
    type: ee
  }, qe, {
    ref: null
  }) : b ? X && !Y && !V && !K && !z ? Pe = "textarea" : (qe = at({
    minRows: X || V,
    rowsMax: K,
    maxRows: Y
  }, qe), Pe = RIt) : qe = at({
    type: ee
  }, qe);
  var ke = function(rt) {
    oe(rt.animationName === "mui-auto-fill-cancel" ? xe.current : {
      value: "x"
    });
  };
  return le.useEffect(function() {
    ge && ge.setAdornedStart(!!Z);
  }, [ge, Z]), /* @__PURE__ */ le.createElement("div", at({
    className: Xt(s.root, s["color".concat(io(_e.color || "primary"))], a, _e.disabled && s.disabled, _e.error && s.error, f && s.fullWidth, _e.focused && s.focused, ge && s.formControl, b && s.multiline, Z && s.adornedStart, c && s.adornedEnd, _e.margin === "dense" && s.marginDense),
    onClick: we,
    ref: n
  }, Ce), Z, /* @__PURE__ */ le.createElement(Nse.Provider, {
    value: null
  }, /* @__PURE__ */ le.createElement(Pe, at({
    "aria-invalid": _e.error,
    "aria-describedby": r,
    autoComplete: i,
    autoFocus: o,
    defaultValue: A,
    disabled: _e.disabled,
    id: h,
    onAnimationStart: ke,
    name: Q,
    placeholder: k,
    readOnly: $,
    required: _e.required,
    rows: X,
    value: Be,
    onKeyDown: L,
    onKeyUp: N
  }, qe, {
    className: Xt(s.input, C.className, _e.disabled && s.disabled, b && s.inputMultiline, _e.hiddenLabel && s.inputHiddenLabel, Z && s.inputAdornedStart, c && s.inputAdornedEnd, ee === "search" && s.inputTypeSearch, _e.margin === "dense" && s.inputMarginDense),
    onBlur: Ae,
    onChange: de,
    onFocus: ie
  }))), c, U ? U(at({}, _e, {
    startAdornment: Z
  })) : null);
});
const Mse = Lr(TIt, {
  name: "MuiInputBase"
})(LIt);
var MIt = function(e) {
  var n = e.palette.type === "light", r = n ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", i = n ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      backgroundColor: i,
      borderTopLeftRadius: e.shape.borderRadius,
      borderTopRightRadius: e.shape.borderRadius,
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      "&:hover": {
        backgroundColor: n ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: i
        }
      },
      "&$focused": {
        backgroundColor: n ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"
      },
      "&$disabled": {
        backgroundColor: n ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
      }
    },
    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      "&$underline:after": {
        borderBottomColor: e.palette.secondary.main
      }
    },
    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      "&:after": {
        borderBottom: "2px solid ".concat(e.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: "absolute",
        right: 0,
        transform: "scaleX(0)",
        transition: e.transitions.create("transform", {
          duration: e.transitions.duration.shorter,
          easing: e.transitions.easing.easeOut
        }),
        pointerEvents: "none"
        // Transparent to the hover style.
      },
      "&$focused:after": {
        transform: "scaleX(1)"
      },
      "&$error:after": {
        borderBottomColor: e.palette.error.main,
        transform: "scaleX(1)"
        // error is always underlined in red
      },
      "&:before": {
        borderBottom: "1px solid ".concat(r),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: "absolute",
        right: 0,
        transition: e.transitions.create("border-bottom-color", {
          duration: e.transitions.duration.shorter
        }),
        pointerEvents: "none"
        // Transparent to the hover style.
      },
      "&:hover:before": {
        borderBottom: "1px solid ".concat(e.palette.text.primary)
      },
      "&$disabled:before": {
        borderBottomStyle: "dotted"
      }
    },
    /* Pseudo-class applied to the root element if the component is focused. */
    focused: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },
    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "27px 12px 10px",
      "&$marginDense": {
        paddingTop: 23,
        paddingBottom: 6
      }
    },
    /* Styles applied to the `input` element. */
    input: {
      padding: "27px 12px 10px",
      "&:-webkit-autofill": {
        WebkitBoxShadow: e.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
        WebkitTextFillColor: e.palette.type === "light" ? null : "#fff",
        caretColor: e.palette.type === "light" ? null : "#fff",
        borderTopLeftRadius: "inherit",
        borderTopRightRadius: "inherit"
      }
    },
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 23,
      paddingBottom: 6
    },
    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
    inputHiddenLabel: {
      paddingTop: 18,
      paddingBottom: 19,
      "&$inputMarginDense": {
        paddingTop: 10,
        paddingBottom: 11
      }
    },
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },
    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },
    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
}, Vke = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.disableUnderline, i = e.classes, o = e.fullWidth, s = o === void 0 ? !1 : o, a = e.inputComponent, A = a === void 0 ? "input" : a, l = e.multiline, c = l === void 0 ? !1 : l, u = e.type, f = u === void 0 ? "text" : u, h = Rn(e, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
  return /* @__PURE__ */ le.createElement(Mse, at({
    classes: at({}, i, {
      root: Xt(i.root, !r && i.underline),
      underline: null
    }),
    fullWidth: s,
    inputComponent: A,
    multiline: c,
    ref: n,
    type: f
  }, h));
});
Vke.muiName = "Input";
const Jke = Lr(MIt, {
  name: "MuiFilledInput"
})(Vke);
var OIt = {
  /* Styles applied to the root element. */
  root: {
    display: "inline-flex",
    flexDirection: "column",
    position: "relative",
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: "top"
    // Fix alignment issue on Safari.
  },
  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },
  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },
  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: "100%"
  }
}, FIt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.classes, o = e.className, s = e.color, a = s === void 0 ? "primary" : s, A = e.component, l = A === void 0 ? "div" : A, c = e.disabled, u = c === void 0 ? !1 : c, f = e.error, h = f === void 0 ? !1 : f, d = e.fullWidth, I = d === void 0 ? !1 : d, m = e.focused, C = e.hiddenLabel, y = C === void 0 ? !1 : C, v = e.margin, b = v === void 0 ? "none" : v, Q = e.required, w = Q === void 0 ? !1 : Q, R = e.size, M = e.variant, O = M === void 0 ? "standard" : M, L = Rn(e, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]), N = le.useState(function() {
    var Be = !1;
    return r && le.Children.forEach(r, function(Ie) {
      if (Ak(Ie, ["Input", "Select"])) {
        var Qe = Ak(Ie, ["Select"]) ? Ie.props.input : Ie;
        Qe && DIt(Qe.props) && (Be = !0);
      }
    }), Be;
  }), k = N[0], $ = N[1], U = le.useState(function() {
    var Be = !1;
    return r && le.Children.forEach(r, function(Ie) {
      Ak(Ie, ["Input", "Select"]) && Lse(Ie.props, !0) && (Be = !0);
    }), Be;
  }), X = U[0], K = U[1], z = le.useState(!1), Y = z[0], V = z[1], Z = m !== void 0 ? m : Y;
  u && Z && V(!1);
  var ce, ee = le.useCallback(function() {
    K(!0);
  }, []), pe = le.useCallback(function() {
    K(!1);
  }, []), Ce = {
    adornedStart: k,
    setAdornedStart: $,
    color: a,
    disabled: u,
    error: h,
    filled: X,
    focused: Z,
    fullWidth: I,
    hiddenLabel: y,
    margin: (R === "small" ? "dense" : void 0) || b,
    onBlur: function() {
      V(!1);
    },
    onEmpty: pe,
    onFilled: ee,
    onFocus: function() {
      V(!0);
    },
    registerEffect: ce,
    required: w,
    variant: O
  };
  return /* @__PURE__ */ le.createElement(Nse.Provider, {
    value: Ce
  }, /* @__PURE__ */ le.createElement(l, at({
    className: Xt(i.root, o, b !== "none" && i["margin".concat(io(b))], I && i.fullWidth),
    ref: n
  }, L), r));
});
const Kke = Lr(OIt, {
  name: "MuiFormControl"
})(FIt);
var PIt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "inline-flex",
      alignItems: "center",
      cursor: "pointer",
      // For correct alignment with the text.
      verticalAlign: "middle",
      WebkitTapHighlightColor: "transparent",
      marginLeft: -11,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      "&$disabled": {
        cursor: "default"
      }
    },
    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: "row-reverse",
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -11
    },
    /* Styles applied to the root element if `labelPlacement="top"`. */
    labelPlacementTop: {
      flexDirection: "column-reverse",
      marginLeft: 16
    },
    /* Styles applied to the root element if `labelPlacement="bottom"`. */
    labelPlacementBottom: {
      flexDirection: "column",
      marginLeft: 16
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the label's Typography component. */
    label: {
      "&$disabled": {
        color: e.palette.text.disabled
      }
    }
  };
}, kIt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  e.checked;
  var r = e.classes, i = e.className, o = e.control, s = e.disabled;
  e.inputRef;
  var a = e.label, A = e.labelPlacement, l = A === void 0 ? "end" : A;
  e.name, e.onChange, e.value;
  var c = Rn(e, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]), u = UB(), f = s;
  typeof f > "u" && typeof o.props.disabled < "u" && (f = o.props.disabled), typeof f > "u" && u && (f = u.disabled);
  var h = {
    disabled: f
  };
  return ["checked", "name", "onChange", "value", "inputRef"].forEach(function(d) {
    typeof o.props[d] > "u" && typeof e[d] < "u" && (h[d] = e[d]);
  }), /* @__PURE__ */ le.createElement("label", at({
    className: Xt(r.root, i, l !== "end" && r["labelPlacement".concat(io(l))], f && r.disabled),
    ref: n
  }, c), /* @__PURE__ */ le.cloneElement(o, h), /* @__PURE__ */ le.createElement(Mu, {
    component: "span",
    className: Xt(r.label, f && r.disabled)
  }, a));
});
const GIt = Lr(PIt, {
  name: "MuiFormControlLabel"
})(kIt);
var UIt = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap"
  },
  /* Styles applied to the root element if `row={true}`. */
  row: {
    flexDirection: "row"
  }
}, HIt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.row, s = o === void 0 ? !1 : o, a = Rn(e, ["classes", "className", "row"]);
  return /* @__PURE__ */ le.createElement("div", at({
    className: Xt(r.root, i, s && r.row),
    ref: n
  }, a));
});
const $It = Lr(UIt, {
  name: "MuiFormGroup"
})(HIt);
var qIt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: at({
      color: e.palette.text.secondary
    }, e.typography.caption, {
      textAlign: "left",
      marginTop: 3,
      margin: 0,
      "&$disabled": {
        color: e.palette.text.disabled
      },
      "&$error": {
        color: e.palette.error.main
      }
    }),
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },
    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      marginLeft: 14,
      marginRight: 14
    },
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},
    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {}
  };
}, jIt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.classes, o = e.className, s = e.component, a = s === void 0 ? "p" : s;
  e.disabled, e.error, e.filled, e.focused, e.margin, e.required, e.variant;
  var A = Rn(e, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]), l = UB(), c = WQ({
    props: e,
    muiFormControl: l,
    states: ["variant", "margin", "disabled", "error", "filled", "focused", "required"]
  });
  return /* @__PURE__ */ le.createElement(a, at({
    className: Xt(i.root, (c.variant === "filled" || c.variant === "outlined") && i.contained, o, c.disabled && i.disabled, c.error && i.error, c.filled && i.filled, c.focused && i.focused, c.required && i.required, c.margin === "dense" && i.marginDense),
    ref: n
  }, A), r === " " ? (
    // eslint-disable-next-line react/no-danger
    /* @__PURE__ */ le.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: "&#8203;"
      }
    })
  ) : r);
});
const YIt = Lr(qIt, {
  name: "MuiFormHelperText"
})(jIt);
var zIt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: at({
      color: e.palette.text.secondary
    }, e.typography.body1, {
      lineHeight: 1,
      padding: 0,
      "&$focused": {
        color: e.palette.primary.main
      },
      "&$disabled": {
        color: e.palette.text.disabled
      },
      "&$error": {
        color: e.palette.error.main
      }
    }),
    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      "&$focused": {
        color: e.palette.secondary.main
      }
    },
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},
    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},
    /* Styles applied to the asterisk element. */
    asterisk: {
      "&$error": {
        color: e.palette.error.main
      }
    }
  };
}, VIt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.classes, o = e.className;
  e.color;
  var s = e.component, a = s === void 0 ? "label" : s;
  e.disabled, e.error, e.filled, e.focused, e.required;
  var A = Rn(e, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]), l = UB(), c = WQ({
    props: e,
    muiFormControl: l,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  });
  return /* @__PURE__ */ le.createElement(a, at({
    className: Xt(i.root, i["color".concat(io(c.color || "primary"))], o, c.disabled && i.disabled, c.error && i.error, c.filled && i.filled, c.focused && i.focused, c.required && i.required),
    ref: n
  }, A), r, c.required && /* @__PURE__ */ le.createElement("span", {
    "aria-hidden": !0,
    className: Xt(i.asterisk, c.error && i.error)
  }, " ", "*"));
});
const JIt = Lr(zIt, {
  name: "MuiFormLabel"
})(VIt);
var KIt = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], WIt = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
function XIt(t, e, n) {
  var r = {};
  WIt.forEach(function(i) {
    var o = "grid-".concat(n, "-").concat(i);
    if (i === !0) {
      r[o] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
      return;
    }
    if (i === "auto") {
      r[o] = {
        flexBasis: "auto",
        flexGrow: 0,
        maxWidth: "none"
      };
      return;
    }
    var s = "".concat(Math.round(i / 12 * 1e8) / 1e6, "%");
    r[o] = {
      flexBasis: s,
      flexGrow: 0,
      maxWidth: s
    };
  }), n === "xs" ? at(t, r) : t[e.breakpoints.up(n)] = r;
}
function Sz(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, n = parseFloat(t);
  return "".concat(n / e).concat(String(t).replace(String(n), "") || "px");
}
function ZIt(t, e) {
  var n = {};
  return KIt.forEach(function(r) {
    var i = t.spacing(r);
    i !== 0 && (n["spacing-".concat(e, "-").concat(r)] = {
      margin: "-".concat(Sz(i, 2)),
      width: "calc(100% + ".concat(Sz(i), ")"),
      "& > $item": {
        padding: Sz(i, 2)
      }
    });
  }), n;
}
var emt = function(e) {
  return at({
    /* Styles applied to the root element. */
    root: {},
    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: "border-box",
      display: "flex",
      flexWrap: "wrap",
      width: "100%"
    },
    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: "border-box",
      margin: "0"
      // For instance, it's useful when used with a `figure` element.
    },
    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },
    /* Styles applied to the root element if `direction="column"`. */
    "direction-xs-column": {
      flexDirection: "column"
    },
    /* Styles applied to the root element if `direction="column-reverse"`. */
    "direction-xs-column-reverse": {
      flexDirection: "column-reverse"
    },
    /* Styles applied to the root element if `direction="row-reverse"`. */
    "direction-xs-row-reverse": {
      flexDirection: "row-reverse"
    },
    /* Styles applied to the root element if `wrap="nowrap"`. */
    "wrap-xs-nowrap": {
      flexWrap: "nowrap"
    },
    /* Styles applied to the root element if `wrap="reverse"`. */
    "wrap-xs-wrap-reverse": {
      flexWrap: "wrap-reverse"
    },
    /* Styles applied to the root element if `alignItems="center"`. */
    "align-items-xs-center": {
      alignItems: "center"
    },
    /* Styles applied to the root element if `alignItems="flex-start"`. */
    "align-items-xs-flex-start": {
      alignItems: "flex-start"
    },
    /* Styles applied to the root element if `alignItems="flex-end"`. */
    "align-items-xs-flex-end": {
      alignItems: "flex-end"
    },
    /* Styles applied to the root element if `alignItems="baseline"`. */
    "align-items-xs-baseline": {
      alignItems: "baseline"
    },
    /* Styles applied to the root element if `alignContent="center"`. */
    "align-content-xs-center": {
      alignContent: "center"
    },
    /* Styles applied to the root element if `alignContent="flex-start"`. */
    "align-content-xs-flex-start": {
      alignContent: "flex-start"
    },
    /* Styles applied to the root element if `alignContent="flex-end"`. */
    "align-content-xs-flex-end": {
      alignContent: "flex-end"
    },
    /* Styles applied to the root element if `alignContent="space-between"`. */
    "align-content-xs-space-between": {
      alignContent: "space-between"
    },
    /* Styles applied to the root element if `alignContent="space-around"`. */
    "align-content-xs-space-around": {
      alignContent: "space-around"
    },
    /* Styles applied to the root element if `justifyContent="center"`. */
    "justify-content-xs-center": {
      justifyContent: "center"
    },
    /* Styles applied to the root element if `justifyContent="flex-end"`. */
    "justify-content-xs-flex-end": {
      justifyContent: "flex-end"
    },
    /* Styles applied to the root element if `justifyContent="space-between"`. */
    "justify-content-xs-space-between": {
      justifyContent: "space-between"
    },
    /* Styles applied to the root element if `justifyContent="space-around"`. */
    "justify-content-xs-space-around": {
      justifyContent: "space-around"
    },
    /* Styles applied to the root element if `justifyContent="space-evenly"`. */
    "justify-content-xs-space-evenly": {
      justifyContent: "space-evenly"
    }
  }, ZIt(e, "xs"), e.breakpoints.keys.reduce(function(n, r) {
    return XIt(n, e, r), n;
  }, {}));
}, tmt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.alignContent, i = r === void 0 ? "stretch" : r, o = e.alignItems, s = o === void 0 ? "stretch" : o, a = e.classes, A = e.className, l = e.component, c = l === void 0 ? "div" : l, u = e.container, f = u === void 0 ? !1 : u, h = e.direction, d = h === void 0 ? "row" : h, I = e.item, m = I === void 0 ? !1 : I, C = e.justify, y = e.justifyContent, v = y === void 0 ? "flex-start" : y, b = e.lg, Q = b === void 0 ? !1 : b, w = e.md, R = w === void 0 ? !1 : w, M = e.sm, O = M === void 0 ? !1 : M, L = e.spacing, N = L === void 0 ? 0 : L, k = e.wrap, $ = k === void 0 ? "wrap" : k, U = e.xl, X = U === void 0 ? !1 : U, K = e.xs, z = K === void 0 ? !1 : K, Y = e.zeroMinWidth, V = Y === void 0 ? !1 : Y, Z = Rn(e, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "justifyContent", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]), ce = Xt(a.root, A, f && [a.container, N !== 0 && a["spacing-xs-".concat(String(N))]], m && a.item, V && a.zeroMinWidth, d !== "row" && a["direction-xs-".concat(String(d))], $ !== "wrap" && a["wrap-xs-".concat(String($))], s !== "stretch" && a["align-items-xs-".concat(String(s))], i !== "stretch" && a["align-content-xs-".concat(String(i))], (C || v) !== "flex-start" && a["justify-content-xs-".concat(String(C || v))], z !== !1 && a["grid-xs-".concat(String(z))], O !== !1 && a["grid-sm-".concat(String(O))], R !== !1 && a["grid-md-".concat(String(R))], Q !== !1 && a["grid-lg-".concat(String(Q))], X !== !1 && a["grid-xl-".concat(String(X))]);
  return /* @__PURE__ */ le.createElement(c, at({
    className: ce,
    ref: n
  }, Z));
}), nmt = Lr(emt, {
  name: "MuiGrid"
})(tmt);
const cn = nmt;
function ZX(t) {
  return "scale(".concat(t, ", ").concat(Math.pow(t, 2), ")");
}
var rmt = {
  entering: {
    opacity: 1,
    transform: ZX(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Wke = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.disableStrictModeCompat, o = i === void 0 ? !1 : i, s = e.in, a = e.onEnter, A = e.onEntered, l = e.onEntering, c = e.onExit, u = e.onExited, f = e.onExiting, h = e.style, d = e.timeout, I = d === void 0 ? "auto" : d, m = e.TransitionComponent, C = m === void 0 ? Rse : m, y = Rn(e, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]), v = le.useRef(), b = le.useRef(), Q = GB(), w = Q.unstable_strictMode && !o, R = le.useRef(null), M = Ms(r.ref, n), O = Ms(w ? R : void 0, M), L = function(V) {
    return function(Z, ce) {
      if (V) {
        var ee = w ? [R.current, Z] : [Z, ce], pe = yE(ee, 2), Ce = pe[0], Be = pe[1];
        Be === void 0 ? V(Ce) : V(Ce, Be);
      }
    };
  }, N = L(l), k = L(function(Y, V) {
    Uke(Y);
    var Z = bS({
      style: h,
      timeout: I
    }, {
      mode: "enter"
    }), ce = Z.duration, ee = Z.delay, pe;
    I === "auto" ? (pe = Q.transitions.getAutoHeightDuration(Y.clientHeight), b.current = pe) : pe = ce, Y.style.transition = [Q.transitions.create("opacity", {
      duration: pe,
      delay: ee
    }), Q.transitions.create("transform", {
      duration: pe * 0.666,
      delay: ee
    })].join(","), a && a(Y, V);
  }), $ = L(A), U = L(f), X = L(function(Y) {
    var V = bS({
      style: h,
      timeout: I
    }, {
      mode: "exit"
    }), Z = V.duration, ce = V.delay, ee;
    I === "auto" ? (ee = Q.transitions.getAutoHeightDuration(Y.clientHeight), b.current = ee) : ee = Z, Y.style.transition = [Q.transitions.create("opacity", {
      duration: ee,
      delay: ce
    }), Q.transitions.create("transform", {
      duration: ee * 0.666,
      delay: ce || ee * 0.333
    })].join(","), Y.style.opacity = "0", Y.style.transform = ZX(0.75), c && c(Y);
  }), K = L(u), z = function(V, Z) {
    var ce = w ? V : Z;
    I === "auto" && (v.current = setTimeout(ce, b.current || 0));
  };
  return le.useEffect(function() {
    return function() {
      clearTimeout(v.current);
    };
  }, []), /* @__PURE__ */ le.createElement(C, at({
    appear: !0,
    in: s,
    nodeRef: w ? R : void 0,
    onEnter: k,
    onEntered: $,
    onEntering: N,
    onExit: X,
    onExited: K,
    onExiting: U,
    addEndListener: z,
    timeout: I === "auto" ? null : I
  }, y), function(Y, V) {
    return /* @__PURE__ */ le.cloneElement(r, at({
      style: at({
        opacity: 0,
        transform: ZX(0.75),
        visibility: Y === "exited" && !s ? "hidden" : void 0
      }, rmt[Y], h, r.props.style),
      ref: O
    }, V));
  });
});
Wke.muiSupportAuto = !0;
const imt = Wke;
var omt = function(e) {
  var n = e.palette.type === "light", r = n ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative"
    },
    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      "label + &": {
        marginTop: 16
      }
    },
    /* Styles applied to the root element if the component is focused. */
    focused: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      "&$underline:after": {
        borderBottomColor: e.palette.secondary.main
      }
    },
    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      "&:after": {
        borderBottom: "2px solid ".concat(e.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: "absolute",
        right: 0,
        transform: "scaleX(0)",
        transition: e.transitions.create("transform", {
          duration: e.transitions.duration.shorter,
          easing: e.transitions.easing.easeOut
        }),
        pointerEvents: "none"
        // Transparent to the hover style.
      },
      "&$focused:after": {
        transform: "scaleX(1)"
      },
      "&$error:after": {
        borderBottomColor: e.palette.error.main,
        transform: "scaleX(1)"
        // error is always underlined in red
      },
      "&:before": {
        borderBottom: "1px solid ".concat(r),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: "absolute",
        right: 0,
        transition: e.transitions.create("border-bottom-color", {
          duration: e.transitions.duration.shorter
        }),
        pointerEvents: "none"
        // Transparent to the hover style.
      },
      "&:hover:not($disabled):before": {
        borderBottom: "2px solid ".concat(e.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          borderBottom: "1px solid ".concat(r)
        }
      },
      "&$disabled:before": {
        borderBottomStyle: "dotted"
      }
    },
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},
    /* Styles applied to the `input` element. */
    input: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},
    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
}, Xke = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.disableUnderline, i = e.classes, o = e.fullWidth, s = o === void 0 ? !1 : o, a = e.inputComponent, A = a === void 0 ? "input" : a, l = e.multiline, c = l === void 0 ? !1 : l, u = e.type, f = u === void 0 ? "text" : u, h = Rn(e, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
  return /* @__PURE__ */ le.createElement(Mse, at({
    classes: at({}, i, {
      root: Xt(i.root, !r && i.underline),
      underline: null
    }),
    fullWidth: s,
    inputComponent: A,
    multiline: c,
    ref: n,
    type: f
  }, h));
});
Xke.muiName = "Input";
const Ose = Lr(omt, {
  name: "MuiInput"
})(Xke);
var smt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "block",
      transformOrigin: "top left"
    },
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},
    /* Pseudo-class applied to the asterisk element. */
    asterisk: {},
    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 24px) scale(1)"
    },
    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: "translate(0, 21px) scale(1)"
    },
    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: "translate(0, 1.5px) scale(0.75)",
      transformOrigin: "top left"
    },
    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: e.transitions.create(["color", "transform"], {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      })
    },
    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 20px) scale(1)",
      "&$marginDense": {
        transform: "translate(12px, 17px) scale(1)"
      },
      "&$shrink": {
        transform: "translate(12px, 10px) scale(0.75)",
        "&$marginDense": {
          transform: "translate(12px, 7px) scale(0.75)"
        }
      }
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 20px) scale(1)",
      "&$marginDense": {
        transform: "translate(14px, 12px) scale(1)"
      },
      "&$shrink": {
        transform: "translate(14px, -6px) scale(0.75)"
      }
    }
  };
}, amt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.disableAnimation, s = o === void 0 ? !1 : o;
  e.margin;
  var a = e.shrink;
  e.variant;
  var A = Rn(e, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]), l = UB(), c = a;
  typeof c > "u" && l && (c = l.filled || l.focused || l.adornedStart);
  var u = WQ({
    props: e,
    muiFormControl: l,
    states: ["margin", "variant"]
  });
  return /* @__PURE__ */ le.createElement(JIt, at({
    "data-shrink": c,
    className: Xt(r.root, i, l && r.formControl, !s && r.animated, c && r.shrink, u.margin === "dense" && r.marginDense, {
      filled: r.filled,
      outlined: r.outlined
    }[u.variant]),
    classes: {
      focused: r.focused,
      disabled: r.disabled,
      error: r.error,
      required: r.required,
      asterisk: r.asterisk
    },
    ref: n
  }, A));
});
const EH = Lr(smt, {
  name: "MuiInputLabel"
})(amt);
var Amt = {
  /* Styles applied to the root element. */
  root: {},
  /* Styles applied to the root element if `underline="none"`. */
  underlineNone: {
    textDecoration: "none"
  },
  /* Styles applied to the root element if `underline="hover"`. */
  underlineHover: {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  /* Styles applied to the root element if `underline="always"`. */
  underlineAlways: {
    textDecoration: "underline"
  },
  // Same reset as ButtonBase.root
  /* Styles applied to the root element if `component="button"`. */
  button: {
    position: "relative",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    "-moz-appearance": "none",
    // Reset
    "-webkit-appearance": "none",
    // Reset
    "&::-moz-focus-inner": {
      borderStyle: "none"
      // Remove Firefox dotted outline.
    },
    "&$focusVisible": {
      outline: "auto"
    }
  },
  /* Pseudo-class applied to the root element if the link is keyboard focused. */
  focusVisible: {}
}, lmt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.color, s = o === void 0 ? "primary" : o, a = e.component, A = a === void 0 ? "a" : a, l = e.onBlur, c = e.onFocus, u = e.TypographyClasses, f = e.underline, h = f === void 0 ? "hover" : f, d = e.variant, I = d === void 0 ? "inherit" : d, m = Rn(e, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]), C = xse(), y = C.isFocusVisible, v = C.onBlurVisible, b = C.ref, Q = le.useState(!1), w = Q[0], R = Q[1], M = Ms(n, b), O = function(k) {
    w && (v(), R(!1)), l && l(k);
  }, L = function(k) {
    y(k) && R(!0), c && c(k);
  };
  return /* @__PURE__ */ le.createElement(Mu, at({
    className: Xt(r.root, r["underline".concat(io(h))], i, w && r.focusVisible, A === "button" && r.button),
    classes: u,
    color: s,
    component: A,
    onBlur: O,
    onFocus: L,
    ref: M,
    variant: I
  }, m));
});
const cmt = Lr(Amt, {
  name: "MuiLink"
})(lmt);
var umt = le.createContext({});
const lk = umt;
var fmt = {
  /* Styles applied to the root element. */
  root: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "relative"
  },
  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },
  /* Styles applied to the root element if dense. */
  dense: {},
  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
}, gmt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.classes, o = e.className, s = e.component, a = s === void 0 ? "ul" : s, A = e.dense, l = A === void 0 ? !1 : A, c = e.disablePadding, u = c === void 0 ? !1 : c, f = e.subheader, h = Rn(e, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]), d = le.useMemo(function() {
    return {
      dense: l
    };
  }, [l]);
  return /* @__PURE__ */ le.createElement(lk.Provider, {
    value: d
  }, /* @__PURE__ */ le.createElement(a, at({
    className: Xt(i.root, o, l && i.dense, !u && i.padding, f && i.subheader),
    ref: n
  }, h), f, r));
});
const hmt = Lr(fmt, {
  name: "MuiList"
})(gmt);
var dmt = function(e) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      position: "relative",
      textDecoration: "none",
      width: "100%",
      boxSizing: "border-box",
      textAlign: "left",
      paddingTop: 8,
      paddingBottom: 8,
      "&$focusVisible": {
        backgroundColor: e.palette.action.selected
      },
      "&$selected, &$selected:hover": {
        backgroundColor: e.palette.action.selected
      },
      "&$disabled": {
        opacity: 0.5
      }
    },
    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: "relative"
    },
    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},
    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },
    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: "flex-start"
    },
    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(e.palette.divider),
      backgroundClip: "padding-box"
    },
    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },
    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: e.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },
    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
}, pmt = typeof window > "u" ? le.useEffect : le.useLayoutEffect, Imt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.alignItems, i = r === void 0 ? "center" : r, o = e.autoFocus, s = o === void 0 ? !1 : o, a = e.button, A = a === void 0 ? !1 : a, l = e.children, c = e.classes, u = e.className, f = e.component, h = e.ContainerComponent, d = h === void 0 ? "li" : h, I = e.ContainerProps;
  I = I === void 0 ? {} : I;
  var m = I.className, C = Rn(I, ["className"]), y = e.dense, v = y === void 0 ? !1 : y, b = e.disabled, Q = b === void 0 ? !1 : b, w = e.disableGutters, R = w === void 0 ? !1 : w, M = e.divider, O = M === void 0 ? !1 : M, L = e.focusVisibleClassName, N = e.selected, k = N === void 0 ? !1 : N, $ = Rn(e, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]), U = le.useContext(lk), X = {
    dense: v || U.dense || !1,
    alignItems: i
  }, K = le.useRef(null);
  pmt(function() {
    s && K.current && K.current.focus();
  }, [s]);
  var z = le.Children.toArray(l), Y = z.length && Ak(z[z.length - 1], ["ListItemSecondaryAction"]), V = le.useCallback(function(pe) {
    K.current = Ed.findDOMNode(pe);
  }, []), Z = Ms(V, n), ce = at({
    className: Xt(c.root, u, X.dense && c.dense, !R && c.gutters, O && c.divider, Q && c.disabled, A && c.button, i !== "center" && c.alignItemsFlexStart, Y && c.secondaryAction, k && c.selected),
    disabled: Q
  }, $), ee = f || "li";
  return A && (ce.component = f || "div", ce.focusVisibleClassName = Xt(c.focusVisible, L), ee = JQ), Y ? (ee = !ce.component && !f ? "div" : ee, d === "li" && (ee === "li" ? ee = "div" : ce.component === "li" && (ce.component = "div")), /* @__PURE__ */ le.createElement(lk.Provider, {
    value: X
  }, /* @__PURE__ */ le.createElement(d, at({
    className: Xt(c.container, m),
    ref: Z
  }, C), /* @__PURE__ */ le.createElement(ee, ce, z), z.pop()))) : /* @__PURE__ */ le.createElement(lk.Provider, {
    value: X
  }, /* @__PURE__ */ le.createElement(ee, at({
    ref: Z
  }, ce), z));
});
const mmt = Lr(dmt, {
  name: "MuiListItem"
})(Imt);
function pCe(t, e) {
  var n = 0;
  return typeof e == "number" ? n = e : e === "center" ? n = t.height / 2 : e === "bottom" && (n = t.height), n;
}
function ICe(t, e) {
  var n = 0;
  return typeof e == "number" ? n = e : e === "center" ? n = t.width / 2 : e === "right" && (n = t.width), n;
}
function mCe(t) {
  return [t.horizontal, t.vertical].map(function(e) {
    return typeof e == "number" ? "".concat(e, "px") : e;
  }).join(" ");
}
function Cmt(t, e) {
  for (var n = e, r = 0; n && n !== t; )
    n = n.parentElement, r += n.scrollTop;
  return r;
}
function Qz(t) {
  return typeof t == "function" ? t() : t;
}
var Emt = {
  /* Styles applied to the root element. */
  root: {},
  /* Styles applied to the `Paper` component. */
  paper: {
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
}, ymt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.action, i = e.anchorEl, o = e.anchorOrigin, s = o === void 0 ? {
    vertical: "top",
    horizontal: "left"
  } : o, a = e.anchorPosition, A = e.anchorReference, l = A === void 0 ? "anchorEl" : A, c = e.children, u = e.classes, f = e.className, h = e.container, d = e.elevation, I = d === void 0 ? 8 : d, m = e.getContentAnchorEl, C = e.marginThreshold, y = C === void 0 ? 16 : C, v = e.onEnter, b = e.onEntered, Q = e.onEntering, w = e.onExit, R = e.onExited, M = e.onExiting, O = e.open, L = e.PaperProps, N = L === void 0 ? {} : L, k = e.transformOrigin, $ = k === void 0 ? {
    vertical: "top",
    horizontal: "left"
  } : k, U = e.TransitionComponent, X = U === void 0 ? imt : U, K = e.transitionDuration, z = K === void 0 ? "auto" : K, Y = e.TransitionProps, V = Y === void 0 ? {} : Y, Z = Rn(e, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]), ce = le.useRef(), ee = le.useCallback(function(Ue) {
    if (l === "anchorPosition")
      return a;
    var Te = Qz(i), se = Te && Te.nodeType === 1 ? Te : zl(ce.current).body, fe = se.getBoundingClientRect(), W = Ue === 0 ? s.vertical : "center";
    return {
      top: fe.top + pCe(fe, W),
      left: fe.left + ICe(fe, s.horizontal)
    };
  }, [i, s.horizontal, s.vertical, a, l]), pe = le.useCallback(function(Ue) {
    var Te = 0;
    if (m && l === "anchorEl") {
      var se = m(Ue);
      if (se && Ue.contains(se)) {
        var fe = Cmt(Ue, se);
        Te = se.offsetTop + se.clientHeight / 2 - fe || 0;
      }
    }
    return Te;
  }, [s.vertical, l, m]), Ce = le.useCallback(function(Ue) {
    var Te = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return {
      vertical: pCe(Ue, $.vertical) + Te,
      horizontal: ICe(Ue, $.horizontal)
    };
  }, [$.horizontal, $.vertical]), Be = le.useCallback(function(Ue) {
    var Te = pe(Ue), se = {
      width: Ue.offsetWidth,
      height: Ue.offsetHeight
    }, fe = Ce(se, Te);
    if (l === "none")
      return {
        top: null,
        left: null,
        transformOrigin: mCe(fe)
      };
    var W = ee(Te), ge = W.top - fe.vertical, _e = W.left - fe.horizontal, Re = ge + se.height, Ee = _e + se.width, oe = wse(Qz(i)), ie = oe.innerHeight - y, Ae = oe.innerWidth - y;
    if (ge < y) {
      var de = ge - y;
      ge -= de, fe.vertical += de;
    } else if (Re > ie) {
      var we = Re - ie;
      ge -= we, fe.vertical += we;
    }
    if (_e < y) {
      var Pe = _e - y;
      _e -= Pe, fe.horizontal += Pe;
    } else if (Ee > Ae) {
      var qe = Ee - Ae;
      _e -= qe, fe.horizontal += qe;
    }
    return {
      top: "".concat(Math.round(ge), "px"),
      left: "".concat(Math.round(_e), "px"),
      transformOrigin: mCe(fe)
    };
  }, [i, l, ee, pe, Ce, y]), Ie = le.useCallback(function() {
    var Ue = ce.current;
    if (Ue) {
      var Te = Be(Ue);
      Te.top !== null && (Ue.style.top = Te.top), Te.left !== null && (Ue.style.left = Te.left), Ue.style.transformOrigin = Te.transformOrigin;
    }
  }, [Be]), Qe = function(Te, se) {
    Q && Q(Te, se), Ie();
  }, xe = le.useCallback(function(Ue) {
    ce.current = Ed.findDOMNode(Ue);
  }, []);
  le.useEffect(function() {
    O && Ie();
  }), le.useImperativeHandle(r, function() {
    return O ? {
      updatePosition: function() {
        Ie();
      }
    } : null;
  }, [O, Ie]), le.useEffect(function() {
    if (O) {
      var Ue = aT(function() {
        Ie();
      });
      return window.addEventListener("resize", Ue), function() {
        Ue.clear(), window.removeEventListener("resize", Ue);
      };
    }
  }, [O, Ie]);
  var Se = z;
  z === "auto" && !X.muiSupportAuto && (Se = void 0);
  var De = h || (i ? zl(Qz(i)).body : void 0);
  return /* @__PURE__ */ le.createElement(SIt, at({
    container: De,
    open: O,
    ref: n,
    BackdropProps: {
      invisible: !0
    },
    className: Xt(u.root, f)
  }, Z), /* @__PURE__ */ le.createElement(X, at({
    appear: !0,
    in: O,
    onEnter: v,
    onEntered: b,
    onExit: w,
    onExited: R,
    onExiting: M,
    timeout: Se
  }, V, {
    onEntering: sT(Qe, V.onEntering)
  }), /* @__PURE__ */ le.createElement(r0, at({
    elevation: I,
    ref: xe
  }, N, {
    className: Xt(u.paper, N.className)
  }), c)));
});
const vmt = Lr(Emt, {
  name: "MuiPopover"
})(ymt);
function wz(t, e, n) {
  return t === e ? t.firstChild : e && e.nextElementSibling ? e.nextElementSibling : n ? null : t.firstChild;
}
function CCe(t, e, n) {
  return t === e ? n ? t.firstChild : t.lastChild : e && e.previousElementSibling ? e.previousElementSibling : n ? null : t.lastChild;
}
function Zke(t, e) {
  if (e === void 0)
    return !0;
  var n = t.innerText;
  return n === void 0 && (n = t.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : e.repeating ? n[0] === e.keys[0] : n.indexOf(e.keys.join("")) === 0;
}
function Gx(t, e, n, r, i, o) {
  for (var s = !1, a = i(t, e, e ? n : !1); a; ) {
    if (a === t.firstChild) {
      if (s)
        return;
      s = !0;
    }
    var A = r ? !1 : a.disabled || a.getAttribute("aria-disabled") === "true";
    if (!a.hasAttribute("tabindex") || !Zke(a, o) || A)
      a = i(t, a, n);
    else {
      a.focus();
      return;
    }
  }
}
var Bmt = typeof window > "u" ? le.useEffect : le.useLayoutEffect, bmt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.actions, i = e.autoFocus, o = i === void 0 ? !1 : i, s = e.autoFocusItem, a = s === void 0 ? !1 : s, A = e.children, l = e.className, c = e.disabledItemsFocusable, u = c === void 0 ? !1 : c, f = e.disableListWrap, h = f === void 0 ? !1 : f, d = e.onKeyDown, I = e.variant, m = I === void 0 ? "selectedMenu" : I, C = Rn(e, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]), y = le.useRef(null), v = le.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Bmt(function() {
    o && y.current.focus();
  }, [o]), le.useImperativeHandle(r, function() {
    return {
      adjustStyleForScrollbar: function(L, N) {
        var k = !y.current.style.width;
        if (L.clientHeight < y.current.clientHeight && k) {
          var $ = "".concat(zke(), "px");
          y.current.style[N.direction === "rtl" ? "paddingLeft" : "paddingRight"] = $, y.current.style.width = "calc(100% + ".concat($, ")");
        }
        return y.current;
      }
    };
  }, []);
  var b = function(L) {
    var N = y.current, k = L.key, $ = zl(N).activeElement;
    if (k === "ArrowDown")
      L.preventDefault(), Gx(N, $, h, u, wz);
    else if (k === "ArrowUp")
      L.preventDefault(), Gx(N, $, h, u, CCe);
    else if (k === "Home")
      L.preventDefault(), Gx(N, null, h, u, wz);
    else if (k === "End")
      L.preventDefault(), Gx(N, null, h, u, CCe);
    else if (k.length === 1) {
      var U = v.current, X = k.toLowerCase(), K = performance.now();
      U.keys.length > 0 && (K - U.lastTime > 500 ? (U.keys = [], U.repeating = !0, U.previousKeyMatched = !0) : U.repeating && X !== U.keys[0] && (U.repeating = !1)), U.lastTime = K, U.keys.push(X);
      var z = $ && !U.repeating && Zke($, U);
      U.previousKeyMatched && (z || Gx(N, $, !1, u, wz, U)) ? L.preventDefault() : U.previousKeyMatched = !1;
    }
    d && d(L);
  }, Q = le.useCallback(function(O) {
    y.current = Ed.findDOMNode(O);
  }, []), w = Ms(Q, n), R = -1;
  le.Children.forEach(A, function(O, L) {
    /* @__PURE__ */ le.isValidElement(O) && (O.props.disabled || (m === "selectedMenu" && O.props.selected || R === -1) && (R = L));
  });
  var M = le.Children.map(A, function(O, L) {
    if (L === R) {
      var N = {};
      return a && (N.autoFocus = !0), O.props.tabIndex === void 0 && m === "selectedMenu" && (N.tabIndex = 0), /* @__PURE__ */ le.cloneElement(O, N);
    }
    return O;
  });
  return /* @__PURE__ */ le.createElement(hmt, at({
    role: "menu",
    ref: w,
    className: l,
    onKeyDown: b,
    tabIndex: o ? 0 : -1
  }, C), M);
});
const eGe = bmt;
var ECe = {
  vertical: "top",
  horizontal: "right"
}, yCe = {
  vertical: "top",
  horizontal: "left"
}, _mt = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: "touch"
  },
  /* Styles applied to the `List` component via `MenuList`. */
  list: {
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
}, Smt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.autoFocus, i = r === void 0 ? !0 : r, o = e.children, s = e.classes, a = e.disableAutoFocusItem, A = a === void 0 ? !1 : a, l = e.MenuListProps, c = l === void 0 ? {} : l, u = e.onClose, f = e.onEntering, h = e.open, d = e.PaperProps, I = d === void 0 ? {} : d, m = e.PopoverClasses, C = e.transitionDuration, y = C === void 0 ? "auto" : C, v = e.TransitionProps;
  v = v === void 0 ? {} : v;
  var b = v.onEntering, Q = Rn(v, ["onEntering"]), w = e.variant, R = w === void 0 ? "selectedMenu" : w, M = Rn(e, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"]), O = GB(), L = i && !A && h, N = le.useRef(null), k = le.useRef(null), $ = function() {
    return k.current;
  }, U = function(V, Z) {
    N.current && N.current.adjustStyleForScrollbar(V, O), f && f(V, Z), b && b(V, Z);
  }, X = function(V) {
    V.key === "Tab" && (V.preventDefault(), u && u(V, "tabKeyDown"));
  }, K = -1;
  le.Children.map(o, function(Y, V) {
    /* @__PURE__ */ le.isValidElement(Y) && (Y.props.disabled || (R !== "menu" && Y.props.selected || K === -1) && (K = V));
  });
  var z = le.Children.map(o, function(Y, V) {
    return V === K ? /* @__PURE__ */ le.cloneElement(Y, {
      ref: function(ce) {
        k.current = Ed.findDOMNode(ce), BS(Y.ref, ce);
      }
    }) : Y;
  });
  return /* @__PURE__ */ le.createElement(vmt, at({
    getContentAnchorEl: $,
    classes: m,
    onClose: u,
    TransitionProps: at({
      onEntering: U
    }, Q),
    anchorOrigin: O.direction === "rtl" ? ECe : yCe,
    transformOrigin: O.direction === "rtl" ? ECe : yCe,
    PaperProps: at({}, I, {
      classes: at({}, I.classes, {
        root: s.paper
      })
    }),
    open: h,
    ref: n,
    transitionDuration: y
  }, M), /* @__PURE__ */ le.createElement(eGe, at({
    onKeyDown: X,
    actions: N,
    autoFocus: i && (K === -1 || A),
    autoFocusItem: L,
    variant: R
  }, c, {
    className: Xt(s.list, c.className)
  }), z));
});
const Qmt = Lr(_mt, {
  name: "MuiMenu"
})(Smt);
var wmt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: at({}, e.typography.body1, mo({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: "border-box",
      width: "auto",
      overflow: "hidden",
      whiteSpace: "nowrap"
    }, e.breakpoints.up("sm"), {
      minHeight: "auto"
    })),
    // TODO v5: remove
    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},
    /* Styles applied to the root element if `selected={true}`. */
    selected: {},
    /* Styles applied to the root element if dense. */
    dense: at({}, e.typography.body2, {
      minHeight: "auto"
    })
  };
}, xmt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.component, s = o === void 0 ? "li" : o, a = e.disableGutters, A = a === void 0 ? !1 : a, l = e.ListItemClasses, c = e.role, u = c === void 0 ? "menuitem" : c, f = e.selected, h = e.tabIndex, d = Rn(e, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]), I;
  return e.disabled || (I = h !== void 0 ? h : -1), /* @__PURE__ */ le.createElement(mmt, at({
    button: !0,
    role: u,
    tabIndex: I,
    component: s,
    selected: f,
    disableGutters: A,
    classes: at({
      dense: r.dense
    }, l),
    className: Xt(r.root, i, f && r.selected, !A && r.gutters),
    ref: n
  }, d));
});
const mi = Lr(wmt, {
  name: "MuiMenuItem"
})(xmt);
var Rmt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.disabled, s = e.IconComponent, a = e.inputRef, A = e.variant, l = A === void 0 ? "standard" : A, c = Rn(e, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
  return /* @__PURE__ */ le.createElement(le.Fragment, null, /* @__PURE__ */ le.createElement("select", at({
    className: Xt(
      r.root,
      // TODO v5: merge root and select
      r.select,
      r[l],
      i,
      o && r.disabled
    ),
    disabled: o,
    ref: a || n
  }, c)), e.multiple ? null : /* @__PURE__ */ le.createElement(s, {
    className: Xt(r.icon, r["icon".concat(io(l))], o && r.disabled)
  }));
});
const tGe = Rmt, nGe = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M7 10l5 5 5-5z"
}));
var rGe = function(e) {
  return {
    /* Styles applied to the select component `root` class. */
    root: {},
    /* Styles applied to the select component `select` class. */
    select: {
      "-moz-appearance": "none",
      // Reset
      "-webkit-appearance": "none",
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: "none",
      borderRadius: 0,
      // Reset
      minWidth: 16,
      // So it doesn't collapse.
      cursor: "pointer",
      "&:focus": {
        // Show that it's not an text input
        backgroundColor: e.palette.type === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
        borderRadius: 0
        // Reset Chrome style
      },
      // Remove IE 11 arrow
      "&::-ms-expand": {
        display: "none"
      },
      "&$disabled": {
        cursor: "default"
      },
      "&[multiple]": {
        height: "auto"
      },
      "&:not([multiple]) option, &:not([multiple]) optgroup": {
        backgroundColor: e.palette.background.paper
      },
      "&&": {
        paddingRight: 24
      }
    },
    /* Styles applied to the select component if `variant="filled"`. */
    filled: {
      "&&": {
        paddingRight: 32
      }
    },
    /* Styles applied to the select component if `variant="outlined"`. */
    outlined: {
      borderRadius: e.shape.borderRadius,
      "&&": {
        paddingRight: 32
      }
    },
    /* Styles applied to the select component `selectMenu` class. */
    selectMenu: {
      height: "auto",
      // Resets for multpile select with chips
      minHeight: "1.1876em",
      // Required for select\text-field height consistency
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    /* Pseudo-class applied to the select component `disabled` class. */
    disabled: {},
    /* Styles applied to the icon component. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input and to support wrapping tags..
      position: "absolute",
      right: 0,
      top: "calc(50% - 12px)",
      // Center vertically
      pointerEvents: "none",
      // Don't block pointer events on the select under the icon.
      color: e.palette.action.active,
      "&$disabled": {
        color: e.palette.action.disabled
      }
    },
    /* Styles applied to the icon component if the popup is open. */
    iconOpen: {
      transform: "rotate(180deg)"
    },
    /* Styles applied to the icon component if `variant="filled"`. */
    iconFilled: {
      right: 7
    },
    /* Styles applied to the icon component if `variant="outlined"`. */
    iconOutlined: {
      right: 7
    },
    /* Styles applied to the underlying native input component. */
    nativeInput: {
      bottom: 0,
      left: 0,
      position: "absolute",
      opacity: 0,
      pointerEvents: "none",
      width: "100%"
    }
  };
}, Dmt = /* @__PURE__ */ le.createElement(Ose, null), iGe = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.children, i = e.classes, o = e.IconComponent, s = o === void 0 ? nGe : o, a = e.input, A = a === void 0 ? Dmt : a, l = e.inputProps;
  e.variant;
  var c = Rn(e, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]), u = UB(), f = WQ({
    props: e,
    muiFormControl: u,
    states: ["variant"]
  });
  return /* @__PURE__ */ le.cloneElement(A, at({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: tGe,
    inputProps: at({
      children: r,
      classes: i,
      IconComponent: s,
      variant: f.variant,
      type: void 0
    }, l, A ? A.props.inputProps : {}),
    ref: n
  }, c));
});
iGe.muiName = "Select";
Lr(rGe, {
  name: "MuiNativeSelect"
})(iGe);
var Tmt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "absolute",
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: "0 8px",
      pointerEvents: "none",
      borderRadius: "inherit",
      borderStyle: "solid",
      borderWidth: 1,
      overflow: "hidden"
    },
    /* Styles applied to the legend element when `labelWidth` is provided. */
    legend: {
      textAlign: "left",
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    },
    /* Styles applied to the legend element. */
    legendLabelled: {
      display: "block",
      width: "auto",
      textAlign: "left",
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block"
      }
    },
    /* Styles applied to the legend element is notched. */
    legendNotched: {
      maxWidth: 1e3,
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  };
}, Nmt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  e.children;
  var r = e.classes, i = e.className, o = e.label, s = e.labelWidth, a = e.notched, A = e.style, l = Rn(e, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]), c = GB(), u = c.direction === "rtl" ? "right" : "left";
  if (o !== void 0)
    return /* @__PURE__ */ le.createElement("fieldset", at({
      "aria-hidden": !0,
      className: Xt(r.root, i),
      ref: n,
      style: A
    }, l), /* @__PURE__ */ le.createElement("legend", {
      className: Xt(r.legendLabelled, a && r.legendNotched)
    }, o ? /* @__PURE__ */ le.createElement("span", null, o) : /* @__PURE__ */ le.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: "&#8203;"
      }
    })));
  var f = s > 0 ? s * 0.75 + 8 : 0.01;
  return /* @__PURE__ */ le.createElement("fieldset", at({
    "aria-hidden": !0,
    style: at(mo({}, "padding".concat(io(u)), 8), A),
    className: Xt(r.root, i),
    ref: n
  }, l), /* @__PURE__ */ le.createElement("legend", {
    className: r.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: a ? f : 0.01
    }
  }, /* @__PURE__ */ le.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: "&#8203;"
    }
  })));
});
const Lmt = Lr(Tmt, {
  name: "PrivateNotchedOutline"
})(Nmt);
var Mmt = function(e) {
  var n = e.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      borderRadius: e.shape.borderRadius,
      "&:hover $notchedOutline": {
        borderColor: e.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        "&:hover $notchedOutline": {
          borderColor: n
        }
      },
      "&$focused $notchedOutline": {
        borderColor: e.palette.primary.main,
        borderWidth: 2
      },
      "&$error $notchedOutline": {
        borderColor: e.palette.error.main
      },
      "&$disabled $notchedOutline": {
        borderColor: e.palette.action.disabled
      }
    },
    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      "&$focused $notchedOutline": {
        borderColor: e.palette.secondary.main
      }
    },
    /* Styles applied to the root element if the component is focused. */
    focused: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },
    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "18.5px 14px",
      "&$marginDense": {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },
    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
      borderColor: n
    },
    /* Styles applied to the `input` element. */
    input: {
      padding: "18.5px 14px",
      "&:-webkit-autofill": {
        WebkitBoxShadow: e.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
        WebkitTextFillColor: e.palette.type === "light" ? null : "#fff",
        caretColor: e.palette.type === "light" ? null : "#fff",
        borderRadius: "inherit"
      }
    },
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },
    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },
    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
}, oGe = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.fullWidth, o = i === void 0 ? !1 : i, s = e.inputComponent, a = s === void 0 ? "input" : s, A = e.label, l = e.labelWidth, c = l === void 0 ? 0 : l, u = e.multiline, f = u === void 0 ? !1 : u, h = e.notched, d = e.type, I = d === void 0 ? "text" : d, m = Rn(e, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);
  return /* @__PURE__ */ le.createElement(Mse, at({
    renderSuffix: function(y) {
      return /* @__PURE__ */ le.createElement(Lmt, {
        className: r.notchedOutline,
        label: A,
        labelWidth: c,
        notched: typeof h < "u" ? h : !!(y.startAdornment || y.filled || y.focused)
      });
    },
    classes: at({}, r, {
      root: Xt(r.root, r.underline),
      notchedOutline: null
    }),
    fullWidth: o,
    inputComponent: a,
    multiline: f,
    ref: n,
    type: I
  }, m));
});
oGe.muiName = "Input";
const sGe = Lr(Mmt, {
  name: "MuiOutlinedInput"
})(oGe);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var gL = typeof window < "u" && typeof document < "u" && typeof navigator < "u", Omt = function() {
  for (var t = ["Edge", "Trident", "Firefox"], e = 0; e < t.length; e += 1)
    if (gL && navigator.userAgent.indexOf(t[e]) >= 0)
      return 1;
  return 0;
}();
function Fmt(t) {
  var e = !1;
  return function() {
    e || (e = !0, window.Promise.resolve().then(function() {
      e = !1, t();
    }));
  };
}
function Pmt(t) {
  var e = !1;
  return function() {
    e || (e = !0, setTimeout(function() {
      e = !1, t();
    }, Omt));
  };
}
var kmt = gL && window.Promise, Gmt = kmt ? Fmt : Pmt;
function aGe(t) {
  var e = {};
  return t && e.toString.call(t) === "[object Function]";
}
function HB(t, e) {
  if (t.nodeType !== 1)
    return [];
  var n = t.ownerDocument.defaultView, r = n.getComputedStyle(t, null);
  return e ? r[e] : r;
}
function Fse(t) {
  return t.nodeName === "HTML" ? t : t.parentNode || t.host;
}
function hL(t) {
  if (!t)
    return document.body;
  switch (t.nodeName) {
    case "HTML":
    case "BODY":
      return t.ownerDocument.body;
    case "#document":
      return t.body;
  }
  var e = HB(t), n = e.overflow, r = e.overflowX, i = e.overflowY;
  return /(auto|scroll|overlay)/.test(n + i + r) ? t : hL(Fse(t));
}
function AGe(t) {
  return t && t.referenceNode ? t.referenceNode : t;
}
var vCe = gL && !!(window.MSInputMethodContext && document.documentMode), BCe = gL && /MSIE 10/.test(navigator.userAgent);
function XQ(t) {
  return t === 11 ? vCe : t === 10 ? BCe : vCe || BCe;
}
function _S(t) {
  if (!t)
    return document.documentElement;
  for (var e = XQ(10) ? document.body : null, n = t.offsetParent || null; n === e && t.nextElementSibling; )
    n = (t = t.nextElementSibling).offsetParent;
  var r = n && n.nodeName;
  return !r || r === "BODY" || r === "HTML" ? t ? t.ownerDocument.documentElement : document.documentElement : ["TH", "TD", "TABLE"].indexOf(n.nodeName) !== -1 && HB(n, "position") === "static" ? _S(n) : n;
}
function Umt(t) {
  var e = t.nodeName;
  return e === "BODY" ? !1 : e === "HTML" || _S(t.firstElementChild) === t;
}
function eZ(t) {
  return t.parentNode !== null ? eZ(t.parentNode) : t;
}
function v4(t, e) {
  if (!t || !t.nodeType || !e || !e.nodeType)
    return document.documentElement;
  var n = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING, r = n ? t : e, i = n ? e : t, o = document.createRange();
  o.setStart(r, 0), o.setEnd(i, 0);
  var s = o.commonAncestorContainer;
  if (t !== s && e !== s || r.contains(i))
    return Umt(s) ? s : _S(s);
  var a = eZ(t);
  return a.host ? v4(a.host, e) : v4(t, eZ(e).host);
}
function SS(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top", n = e === "top" ? "scrollTop" : "scrollLeft", r = t.nodeName;
  if (r === "BODY" || r === "HTML") {
    var i = t.ownerDocument.documentElement, o = t.ownerDocument.scrollingElement || i;
    return o[n];
  }
  return t[n];
}
function Hmt(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = SS(e, "top"), i = SS(e, "left"), o = n ? -1 : 1;
  return t.top += r * o, t.bottom += r * o, t.left += i * o, t.right += i * o, t;
}
function bCe(t, e) {
  var n = e === "x" ? "Left" : "Top", r = n === "Left" ? "Right" : "Bottom";
  return parseFloat(t["border" + n + "Width"]) + parseFloat(t["border" + r + "Width"]);
}
function _Ce(t, e, n, r) {
  return Math.max(e["offset" + t], e["scroll" + t], n["client" + t], n["offset" + t], n["scroll" + t], XQ(10) ? parseInt(n["offset" + t]) + parseInt(r["margin" + (t === "Height" ? "Top" : "Left")]) + parseInt(r["margin" + (t === "Height" ? "Bottom" : "Right")]) : 0);
}
function lGe(t) {
  var e = t.body, n = t.documentElement, r = XQ(10) && getComputedStyle(n);
  return {
    height: _Ce("Height", e, n, r),
    width: _Ce("Width", e, n, r)
  };
}
var $mt = function(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}, qmt = function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}(), QS = function(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}, Bg = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
};
function qC(t) {
  return Bg({}, t, {
    right: t.left + t.width,
    bottom: t.top + t.height
  });
}
function tZ(t) {
  var e = {};
  try {
    if (XQ(10)) {
      e = t.getBoundingClientRect();
      var n = SS(t, "top"), r = SS(t, "left");
      e.top += n, e.left += r, e.bottom += n, e.right += r;
    } else
      e = t.getBoundingClientRect();
  } catch {
  }
  var i = {
    left: e.left,
    top: e.top,
    width: e.right - e.left,
    height: e.bottom - e.top
  }, o = t.nodeName === "HTML" ? lGe(t.ownerDocument) : {}, s = o.width || t.clientWidth || i.width, a = o.height || t.clientHeight || i.height, A = t.offsetWidth - s, l = t.offsetHeight - a;
  if (A || l) {
    var c = HB(t);
    A -= bCe(c, "x"), l -= bCe(c, "y"), i.width -= A, i.height -= l;
  }
  return qC(i);
}
function Pse(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = XQ(10), i = e.nodeName === "HTML", o = tZ(t), s = tZ(e), a = hL(t), A = HB(e), l = parseFloat(A.borderTopWidth), c = parseFloat(A.borderLeftWidth);
  n && i && (s.top = Math.max(s.top, 0), s.left = Math.max(s.left, 0));
  var u = qC({
    top: o.top - s.top - l,
    left: o.left - s.left - c,
    width: o.width,
    height: o.height
  });
  if (u.marginTop = 0, u.marginLeft = 0, !r && i) {
    var f = parseFloat(A.marginTop), h = parseFloat(A.marginLeft);
    u.top -= l - f, u.bottom -= l - f, u.left -= c - h, u.right -= c - h, u.marginTop = f, u.marginLeft = h;
  }
  return (r && !n ? e.contains(a) : e === a && a.nodeName !== "BODY") && (u = Hmt(u, e)), u;
}
function jmt(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = t.ownerDocument.documentElement, r = Pse(t, n), i = Math.max(n.clientWidth, window.innerWidth || 0), o = Math.max(n.clientHeight, window.innerHeight || 0), s = e ? 0 : SS(n), a = e ? 0 : SS(n, "left"), A = {
    top: s - r.top + r.marginTop,
    left: a - r.left + r.marginLeft,
    width: i,
    height: o
  };
  return qC(A);
}
function cGe(t) {
  var e = t.nodeName;
  if (e === "BODY" || e === "HTML")
    return !1;
  if (HB(t, "position") === "fixed")
    return !0;
  var n = Fse(t);
  return n ? cGe(n) : !1;
}
function uGe(t) {
  if (!t || !t.parentElement || XQ())
    return document.documentElement;
  for (var e = t.parentElement; e && HB(e, "transform") === "none"; )
    e = e.parentElement;
  return e || document.documentElement;
}
function kse(t, e, n, r) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, o = { top: 0, left: 0 }, s = i ? uGe(t) : v4(t, AGe(e));
  if (r === "viewport")
    o = jmt(s, i);
  else {
    var a = void 0;
    r === "scrollParent" ? (a = hL(Fse(e)), a.nodeName === "BODY" && (a = t.ownerDocument.documentElement)) : r === "window" ? a = t.ownerDocument.documentElement : a = r;
    var A = Pse(a, s, i);
    if (a.nodeName === "HTML" && !cGe(s)) {
      var l = lGe(t.ownerDocument), c = l.height, u = l.width;
      o.top += A.top - A.marginTop, o.bottom = c + A.top, o.left += A.left - A.marginLeft, o.right = u + A.left;
    } else
      o = A;
  }
  n = n || 0;
  var f = typeof n == "number";
  return o.left += f ? n : n.left || 0, o.top += f ? n : n.top || 0, o.right -= f ? n : n.right || 0, o.bottom -= f ? n : n.bottom || 0, o;
}
function Ymt(t) {
  var e = t.width, n = t.height;
  return e * n;
}
function fGe(t, e, n, r, i) {
  var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (t.indexOf("auto") === -1)
    return t;
  var s = kse(n, r, o, i), a = {
    top: {
      width: s.width,
      height: e.top - s.top
    },
    right: {
      width: s.right - e.right,
      height: s.height
    },
    bottom: {
      width: s.width,
      height: s.bottom - e.bottom
    },
    left: {
      width: e.left - s.left,
      height: s.height
    }
  }, A = Object.keys(a).map(function(f) {
    return Bg({
      key: f
    }, a[f], {
      area: Ymt(a[f])
    });
  }).sort(function(f, h) {
    return h.area - f.area;
  }), l = A.filter(function(f) {
    var h = f.width, d = f.height;
    return h >= n.clientWidth && d >= n.clientHeight;
  }), c = l.length > 0 ? l[0].key : A[0].key, u = t.split("-")[1];
  return c + (u ? "-" + u : "");
}
function gGe(t, e, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, i = r ? uGe(e) : v4(e, AGe(n));
  return Pse(n, i, r);
}
function hGe(t) {
  var e = t.ownerDocument.defaultView, n = e.getComputedStyle(t), r = parseFloat(n.marginTop || 0) + parseFloat(n.marginBottom || 0), i = parseFloat(n.marginLeft || 0) + parseFloat(n.marginRight || 0), o = {
    width: t.offsetWidth + i,
    height: t.offsetHeight + r
  };
  return o;
}
function B4(t) {
  var e = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return t.replace(/left|right|bottom|top/g, function(n) {
    return e[n];
  });
}
function dGe(t, e, n) {
  n = n.split("-")[0];
  var r = hGe(t), i = {
    width: r.width,
    height: r.height
  }, o = ["right", "left"].indexOf(n) !== -1, s = o ? "top" : "left", a = o ? "left" : "top", A = o ? "height" : "width", l = o ? "width" : "height";
  return i[s] = e[s] + e[A] / 2 - r[A] / 2, n === a ? i[a] = e[a] - r[l] : i[a] = e[B4(a)], i;
}
function dL(t, e) {
  return Array.prototype.find ? t.find(e) : t.filter(e)[0];
}
function zmt(t, e, n) {
  if (Array.prototype.findIndex)
    return t.findIndex(function(i) {
      return i[e] === n;
    });
  var r = dL(t, function(i) {
    return i[e] === n;
  });
  return t.indexOf(r);
}
function pGe(t, e, n) {
  var r = n === void 0 ? t : t.slice(0, zmt(t, "name", n));
  return r.forEach(function(i) {
    i.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    var o = i.function || i.fn;
    i.enabled && aGe(o) && (e.offsets.popper = qC(e.offsets.popper), e.offsets.reference = qC(e.offsets.reference), e = o(e, i));
  }), e;
}
function Vmt() {
  if (!this.state.isDestroyed) {
    var t = {
      instance: this,
      styles: {},
      arrowStyles: {},
      attributes: {},
      flipped: !1,
      offsets: {}
    };
    t.offsets.reference = gGe(this.state, this.popper, this.reference, this.options.positionFixed), t.placement = fGe(this.options.placement, t.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), t.originalPlacement = t.placement, t.positionFixed = this.options.positionFixed, t.offsets.popper = dGe(this.popper, t.offsets.reference, t.placement), t.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", t = pGe(this.modifiers, t), this.state.isCreated ? this.options.onUpdate(t) : (this.state.isCreated = !0, this.options.onCreate(t));
  }
}
function IGe(t, e) {
  return t.some(function(n) {
    var r = n.name, i = n.enabled;
    return i && r === e;
  });
}
function Gse(t) {
  for (var e = [!1, "ms", "Webkit", "Moz", "O"], n = t.charAt(0).toUpperCase() + t.slice(1), r = 0; r < e.length; r++) {
    var i = e[r], o = i ? "" + i + n : t;
    if (typeof document.body.style[o] < "u")
      return o;
  }
  return null;
}
function Jmt() {
  return this.state.isDestroyed = !0, IGe(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[Gse("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
}
function mGe(t) {
  var e = t.ownerDocument;
  return e ? e.defaultView : window;
}
function CGe(t, e, n, r) {
  var i = t.nodeName === "BODY", o = i ? t.ownerDocument.defaultView : t;
  o.addEventListener(e, n, { passive: !0 }), i || CGe(hL(o.parentNode), e, n, r), r.push(o);
}
function Kmt(t, e, n, r) {
  n.updateBound = r, mGe(t).addEventListener("resize", n.updateBound, { passive: !0 });
  var i = hL(t);
  return CGe(i, "scroll", n.updateBound, n.scrollParents), n.scrollElement = i, n.eventsEnabled = !0, n;
}
function Wmt() {
  this.state.eventsEnabled || (this.state = Kmt(this.reference, this.options, this.state, this.scheduleUpdate));
}
function Xmt(t, e) {
  return mGe(t).removeEventListener("resize", e.updateBound), e.scrollParents.forEach(function(n) {
    n.removeEventListener("scroll", e.updateBound);
  }), e.updateBound = null, e.scrollParents = [], e.scrollElement = null, e.eventsEnabled = !1, e;
}
function Zmt() {
  this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = Xmt(this.reference, this.state));
}
function Use(t) {
  return t !== "" && !isNaN(parseFloat(t)) && isFinite(t);
}
function nZ(t, e) {
  Object.keys(e).forEach(function(n) {
    var r = "";
    ["width", "height", "top", "right", "bottom", "left"].indexOf(n) !== -1 && Use(e[n]) && (r = "px"), t.style[n] = e[n] + r;
  });
}
function eCt(t, e) {
  Object.keys(e).forEach(function(n) {
    var r = e[n];
    r !== !1 ? t.setAttribute(n, e[n]) : t.removeAttribute(n);
  });
}
function tCt(t) {
  return nZ(t.instance.popper, t.styles), eCt(t.instance.popper, t.attributes), t.arrowElement && Object.keys(t.arrowStyles).length && nZ(t.arrowElement, t.arrowStyles), t;
}
function nCt(t, e, n, r, i) {
  var o = gGe(i, e, t, n.positionFixed), s = fGe(n.placement, o, e, t, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
  return e.setAttribute("x-placement", s), nZ(e, { position: n.positionFixed ? "fixed" : "absolute" }), n;
}
function rCt(t, e) {
  var n = t.offsets, r = n.popper, i = n.reference, o = Math.round, s = Math.floor, a = function(C) {
    return C;
  }, A = o(i.width), l = o(r.width), c = ["left", "right"].indexOf(t.placement) !== -1, u = t.placement.indexOf("-") !== -1, f = A % 2 === l % 2, h = A % 2 === 1 && l % 2 === 1, d = e ? c || u || f ? o : s : a, I = e ? o : a;
  return {
    left: d(h && !u && e ? r.left - 1 : r.left),
    top: I(r.top),
    bottom: I(r.bottom),
    right: d(r.right)
  };
}
var iCt = gL && /Firefox/i.test(navigator.userAgent);
function oCt(t, e) {
  var n = e.x, r = e.y, i = t.offsets.popper, o = dL(t.instance.modifiers, function(v) {
    return v.name === "applyStyle";
  }).gpuAcceleration;
  o !== void 0 && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  var s = o !== void 0 ? o : e.gpuAcceleration, a = _S(t.instance.popper), A = tZ(a), l = {
    position: i.position
  }, c = rCt(t, window.devicePixelRatio < 2 || !iCt), u = n === "bottom" ? "top" : "bottom", f = r === "right" ? "left" : "right", h = Gse("transform"), d = void 0, I = void 0;
  if (u === "bottom" ? a.nodeName === "HTML" ? I = -a.clientHeight + c.bottom : I = -A.height + c.bottom : I = c.top, f === "right" ? a.nodeName === "HTML" ? d = -a.clientWidth + c.right : d = -A.width + c.right : d = c.left, s && h)
    l[h] = "translate3d(" + d + "px, " + I + "px, 0)", l[u] = 0, l[f] = 0, l.willChange = "transform";
  else {
    var m = u === "bottom" ? -1 : 1, C = f === "right" ? -1 : 1;
    l[u] = I * m, l[f] = d * C, l.willChange = u + ", " + f;
  }
  var y = {
    "x-placement": t.placement
  };
  return t.attributes = Bg({}, y, t.attributes), t.styles = Bg({}, l, t.styles), t.arrowStyles = Bg({}, t.offsets.arrow, t.arrowStyles), t;
}
function EGe(t, e, n) {
  var r = dL(t, function(a) {
    var A = a.name;
    return A === e;
  }), i = !!r && t.some(function(a) {
    return a.name === n && a.enabled && a.order < r.order;
  });
  if (!i) {
    var o = "`" + e + "`", s = "`" + n + "`";
    console.warn(s + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!");
  }
  return i;
}
function sCt(t, e) {
  var n;
  if (!EGe(t.instance.modifiers, "arrow", "keepTogether"))
    return t;
  var r = e.element;
  if (typeof r == "string") {
    if (r = t.instance.popper.querySelector(r), !r)
      return t;
  } else if (!t.instance.popper.contains(r))
    return console.warn("WARNING: `arrow.element` must be child of its popper element!"), t;
  var i = t.placement.split("-")[0], o = t.offsets, s = o.popper, a = o.reference, A = ["left", "right"].indexOf(i) !== -1, l = A ? "height" : "width", c = A ? "Top" : "Left", u = c.toLowerCase(), f = A ? "left" : "top", h = A ? "bottom" : "right", d = hGe(r)[l];
  a[h] - d < s[u] && (t.offsets.popper[u] -= s[u] - (a[h] - d)), a[u] + d > s[h] && (t.offsets.popper[u] += a[u] + d - s[h]), t.offsets.popper = qC(t.offsets.popper);
  var I = a[u] + a[l] / 2 - d / 2, m = HB(t.instance.popper), C = parseFloat(m["margin" + c]), y = parseFloat(m["border" + c + "Width"]), v = I - t.offsets.popper[u] - C - y;
  return v = Math.max(Math.min(s[l] - d, v), 0), t.arrowElement = r, t.offsets.arrow = (n = {}, QS(n, u, Math.round(v)), QS(n, f, ""), n), t;
}
function aCt(t) {
  return t === "end" ? "start" : t === "start" ? "end" : t;
}
var yGe = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], xz = yGe.slice(3);
function SCe(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = xz.indexOf(t), r = xz.slice(n + 1).concat(xz.slice(0, n));
  return e ? r.reverse() : r;
}
var Rz = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function ACt(t, e) {
  if (IGe(t.instance.modifiers, "inner") || t.flipped && t.placement === t.originalPlacement)
    return t;
  var n = kse(t.instance.popper, t.instance.reference, e.padding, e.boundariesElement, t.positionFixed), r = t.placement.split("-")[0], i = B4(r), o = t.placement.split("-")[1] || "", s = [];
  switch (e.behavior) {
    case Rz.FLIP:
      s = [r, i];
      break;
    case Rz.CLOCKWISE:
      s = SCe(r);
      break;
    case Rz.COUNTERCLOCKWISE:
      s = SCe(r, !0);
      break;
    default:
      s = e.behavior;
  }
  return s.forEach(function(a, A) {
    if (r !== a || s.length === A + 1)
      return t;
    r = t.placement.split("-")[0], i = B4(r);
    var l = t.offsets.popper, c = t.offsets.reference, u = Math.floor, f = r === "left" && u(l.right) > u(c.left) || r === "right" && u(l.left) < u(c.right) || r === "top" && u(l.bottom) > u(c.top) || r === "bottom" && u(l.top) < u(c.bottom), h = u(l.left) < u(n.left), d = u(l.right) > u(n.right), I = u(l.top) < u(n.top), m = u(l.bottom) > u(n.bottom), C = r === "left" && h || r === "right" && d || r === "top" && I || r === "bottom" && m, y = ["top", "bottom"].indexOf(r) !== -1, v = !!e.flipVariations && (y && o === "start" && h || y && o === "end" && d || !y && o === "start" && I || !y && o === "end" && m), b = !!e.flipVariationsByContent && (y && o === "start" && d || y && o === "end" && h || !y && o === "start" && m || !y && o === "end" && I), Q = v || b;
    (f || C || Q) && (t.flipped = !0, (f || C) && (r = s[A + 1]), Q && (o = aCt(o)), t.placement = r + (o ? "-" + o : ""), t.offsets.popper = Bg({}, t.offsets.popper, dGe(t.instance.popper, t.offsets.reference, t.placement)), t = pGe(t.instance.modifiers, t, "flip"));
  }), t;
}
function lCt(t) {
  var e = t.offsets, n = e.popper, r = e.reference, i = t.placement.split("-")[0], o = Math.floor, s = ["top", "bottom"].indexOf(i) !== -1, a = s ? "right" : "bottom", A = s ? "left" : "top", l = s ? "width" : "height";
  return n[a] < o(r[A]) && (t.offsets.popper[A] = o(r[A]) - n[l]), n[A] > o(r[a]) && (t.offsets.popper[A] = o(r[a])), t;
}
function cCt(t, e, n, r) {
  var i = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), o = +i[1], s = i[2];
  if (!o)
    return t;
  if (s.indexOf("%") === 0) {
    var a = void 0;
    switch (s) {
      case "%p":
        a = n;
        break;
      case "%":
      case "%r":
      default:
        a = r;
    }
    var A = qC(a);
    return A[e] / 100 * o;
  } else if (s === "vh" || s === "vw") {
    var l = void 0;
    return s === "vh" ? l = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : l = Math.max(document.documentElement.clientWidth, window.innerWidth || 0), l / 100 * o;
  } else
    return o;
}
function uCt(t, e, n, r) {
  var i = [0, 0], o = ["right", "left"].indexOf(r) !== -1, s = t.split(/(\+|\-)/).map(function(c) {
    return c.trim();
  }), a = s.indexOf(dL(s, function(c) {
    return c.search(/,|\s/) !== -1;
  }));
  s[a] && s[a].indexOf(",") === -1 && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  var A = /\s*,\s*|\s+/, l = a !== -1 ? [s.slice(0, a).concat([s[a].split(A)[0]]), [s[a].split(A)[1]].concat(s.slice(a + 1))] : [s];
  return l = l.map(function(c, u) {
    var f = (u === 1 ? !o : o) ? "height" : "width", h = !1;
    return c.reduce(function(d, I) {
      return d[d.length - 1] === "" && ["+", "-"].indexOf(I) !== -1 ? (d[d.length - 1] = I, h = !0, d) : h ? (d[d.length - 1] += I, h = !1, d) : d.concat(I);
    }, []).map(function(d) {
      return cCt(d, f, e, n);
    });
  }), l.forEach(function(c, u) {
    c.forEach(function(f, h) {
      Use(f) && (i[u] += f * (c[h - 1] === "-" ? -1 : 1));
    });
  }), i;
}
function fCt(t, e) {
  var n = e.offset, r = t.placement, i = t.offsets, o = i.popper, s = i.reference, a = r.split("-")[0], A = void 0;
  return Use(+n) ? A = [+n, 0] : A = uCt(n, o, s, a), a === "left" ? (o.top += A[0], o.left -= A[1]) : a === "right" ? (o.top += A[0], o.left += A[1]) : a === "top" ? (o.left += A[0], o.top -= A[1]) : a === "bottom" && (o.left += A[0], o.top += A[1]), t.popper = o, t;
}
function gCt(t, e) {
  var n = e.boundariesElement || _S(t.instance.popper);
  t.instance.reference === n && (n = _S(n));
  var r = Gse("transform"), i = t.instance.popper.style, o = i.top, s = i.left, a = i[r];
  i.top = "", i.left = "", i[r] = "";
  var A = kse(t.instance.popper, t.instance.reference, e.padding, n, t.positionFixed);
  i.top = o, i.left = s, i[r] = a, e.boundaries = A;
  var l = e.priority, c = t.offsets.popper, u = {
    primary: function(h) {
      var d = c[h];
      return c[h] < A[h] && !e.escapeWithReference && (d = Math.max(c[h], A[h])), QS({}, h, d);
    },
    secondary: function(h) {
      var d = h === "right" ? "left" : "top", I = c[d];
      return c[h] > A[h] && !e.escapeWithReference && (I = Math.min(c[d], A[h] - (h === "right" ? c.width : c.height))), QS({}, d, I);
    }
  };
  return l.forEach(function(f) {
    var h = ["left", "top"].indexOf(f) !== -1 ? "primary" : "secondary";
    c = Bg({}, c, u[h](f));
  }), t.offsets.popper = c, t;
}
function hCt(t) {
  var e = t.placement, n = e.split("-")[0], r = e.split("-")[1];
  if (r) {
    var i = t.offsets, o = i.reference, s = i.popper, a = ["bottom", "top"].indexOf(n) !== -1, A = a ? "left" : "top", l = a ? "width" : "height", c = {
      start: QS({}, A, o[A]),
      end: QS({}, A, o[A] + o[l] - s[l])
    };
    t.offsets.popper = Bg({}, s, c[r]);
  }
  return t;
}
function dCt(t) {
  if (!EGe(t.instance.modifiers, "hide", "preventOverflow"))
    return t;
  var e = t.offsets.reference, n = dL(t.instance.modifiers, function(r) {
    return r.name === "preventOverflow";
  }).boundaries;
  if (e.bottom < n.top || e.left > n.right || e.top > n.bottom || e.right < n.left) {
    if (t.hide === !0)
      return t;
    t.hide = !0, t.attributes["x-out-of-boundaries"] = "";
  } else {
    if (t.hide === !1)
      return t;
    t.hide = !1, t.attributes["x-out-of-boundaries"] = !1;
  }
  return t;
}
function pCt(t) {
  var e = t.placement, n = e.split("-")[0], r = t.offsets, i = r.popper, o = r.reference, s = ["left", "right"].indexOf(n) !== -1, a = ["top", "left"].indexOf(n) === -1;
  return i[s ? "left" : "top"] = o[n] - (a ? i[s ? "width" : "height"] : 0), t.placement = B4(e), t.offsets.popper = qC(i), t;
}
var ICt = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: hCt
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: fCt,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: gCt,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: lCt
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: sCt,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: ACt,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: !1,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: !1
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: !1,
    /** @prop {ModifierFn} */
    fn: pCt
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: dCt
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: oCt,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: !0,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: !0,
    /** @prop {ModifierFn} */
    fn: tCt,
    /** @prop {Function} */
    onLoad: nCt,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
}, mCt = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: !1,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: !0,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: !1,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: ICt
}, yH = function() {
  function t(e, n) {
    var r = this, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    $mt(this, t), this.scheduleUpdate = function() {
      return requestAnimationFrame(r.update);
    }, this.update = Gmt(this.update.bind(this)), this.options = Bg({}, t.Defaults, i), this.state = {
      isDestroyed: !1,
      isCreated: !1,
      scrollParents: []
    }, this.reference = e && e.jquery ? e[0] : e, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(Bg({}, t.Defaults.modifiers, i.modifiers)).forEach(function(s) {
      r.options.modifiers[s] = Bg({}, t.Defaults.modifiers[s] || {}, i.modifiers ? i.modifiers[s] : {});
    }), this.modifiers = Object.keys(this.options.modifiers).map(function(s) {
      return Bg({
        name: s
      }, r.options.modifiers[s]);
    }).sort(function(s, a) {
      return s.order - a.order;
    }), this.modifiers.forEach(function(s) {
      s.enabled && aGe(s.onLoad) && s.onLoad(r.reference, r.popper, r.options, s, r.state);
    }), this.update();
    var o = this.options.eventsEnabled;
    o && this.enableEventListeners(), this.state.eventsEnabled = o;
  }
  return qmt(t, [{
    key: "update",
    value: function() {
      return Vmt.call(this);
    }
  }, {
    key: "destroy",
    value: function() {
      return Jmt.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function() {
      return Wmt.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function() {
      return Zmt.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]), t;
}();
yH.Utils = (typeof window < "u" ? window : global).PopperUtils;
yH.placements = yGe;
yH.Defaults = mCt;
const CCt = yH;
function ECt(t, e) {
  var n = e && e.direction || "ltr";
  if (n === "ltr")
    return t;
  switch (t) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return t;
  }
}
function QCe(t) {
  return typeof t == "function" ? t() : t;
}
var yCt = typeof window < "u" ? le.useLayoutEffect : le.useEffect, vCt = {}, BCt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.anchorEl, i = e.children, o = e.container, s = e.disablePortal, a = s === void 0 ? !1 : s, A = e.keepMounted, l = A === void 0 ? !1 : A, c = e.modifiers, u = e.open, f = e.placement, h = f === void 0 ? "bottom" : f, d = e.popperOptions, I = d === void 0 ? vCt : d, m = e.popperRef, C = e.style, y = e.transition, v = y === void 0 ? !1 : y, b = Rn(e, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]), Q = le.useRef(null), w = Ms(Q, n), R = le.useRef(null), M = Ms(R, m), O = le.useRef(M);
  yCt(function() {
    O.current = M;
  }, [M]), le.useImperativeHandle(m, function() {
    return R.current;
  }, []);
  var L = le.useState(!0), N = L[0], k = L[1], $ = VQ(), U = ECt(h, $), X = le.useState(U), K = X[0], z = X[1];
  le.useEffect(function() {
    R.current && R.current.update();
  });
  var Y = le.useCallback(function() {
    if (!(!Q.current || !r || !u)) {
      R.current && (R.current.destroy(), O.current(null));
      var Ce = function(Qe) {
        z(Qe.placement);
      };
      QCe(r);
      var Be = new CCt(QCe(r), Q.current, at({
        placement: U
      }, I, {
        modifiers: at({}, a ? {} : {
          // It's using scrollParent by default, we can use the viewport when using a portal.
          preventOverflow: {
            boundariesElement: "window"
          }
        }, c, I.modifiers),
        // We could have been using a custom modifier like react-popper is doing.
        // But it seems this is the best public API for this use case.
        onCreate: sT(Ce, I.onCreate),
        onUpdate: sT(Ce, I.onUpdate)
      }));
      O.current(Be);
    }
  }, [r, a, c, u, U, I]), V = le.useCallback(function(Ce) {
    BS(w, Ce), Y();
  }, [w, Y]), Z = function() {
    k(!1);
  }, ce = function() {
    R.current && (R.current.destroy(), O.current(null));
  }, ee = function() {
    k(!0), ce();
  };
  if (le.useEffect(function() {
    return function() {
      ce();
    };
  }, []), le.useEffect(function() {
    !u && !v && ce();
  }, [u, v]), !l && !u && (!v || N))
    return null;
  var pe = {
    placement: K
  };
  return v && (pe.TransitionProps = {
    in: u,
    onEnter: Z,
    onExited: ee
  }), /* @__PURE__ */ le.createElement(Yke, {
    disablePortal: a,
    container: o
  }, /* @__PURE__ */ le.createElement("div", at({
    ref: V,
    role: "tooltip"
  }, b, {
    style: at({
      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
      position: "fixed",
      // Fix Popper.js display issue
      top: 0,
      left: 0,
      display: !u && l && !v ? "none" : null
    }, C)
  }), typeof i == "function" ? i(pe) : i));
});
const vGe = BCt;
function wCe(t, e) {
  return rT(e) === "object" && e !== null ? t === e : String(t) === String(e);
}
function bCt(t) {
  return t == null || typeof t == "string" && !t.trim();
}
var _Ct = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e["aria-label"], i = e.autoFocus, o = e.autoWidth, s = e.children, a = e.classes, A = e.className, l = e.defaultValue, c = e.disabled, u = e.displayEmpty, f = e.IconComponent, h = e.inputRef, d = e.labelId, I = e.MenuProps, m = I === void 0 ? {} : I, C = e.multiple, y = e.name, v = e.onBlur, b = e.onChange, Q = e.onClose, w = e.onFocus, R = e.onOpen, M = e.open, O = e.readOnly, L = e.renderValue, N = e.SelectDisplayProps, k = N === void 0 ? {} : N, $ = e.tabIndex;
  e.type;
  var U = e.value, X = e.variant, K = X === void 0 ? "standard" : X, z = Rn(e, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]), Y = mH({
    controlled: U,
    default: l,
    name: "Select"
  }), V = yE(Y, 2), Z = V[0], ce = V[1], ee = le.useRef(null), pe = le.useState(null), Ce = pe[0], Be = pe[1], Ie = le.useRef(M != null), Qe = Ie.current, xe = le.useState(), Se = xe[0], De = xe[1], Ue = le.useState(!1), Te = Ue[0], se = Ue[1], fe = Ms(n, h);
  le.useImperativeHandle(fe, function() {
    return {
      focus: function() {
        Ce.focus();
      },
      node: ee.current,
      value: Z
    };
  }, [Ce, Z]), le.useEffect(function() {
    i && Ce && Ce.focus();
  }, [i, Ce]), le.useEffect(function() {
    if (Ce) {
      var mt = zl(Ce).getElementById(d);
      if (mt) {
        var _t = function() {
          getSelection().isCollapsed && Ce.focus();
        };
        return mt.addEventListener("click", _t), function() {
          mt.removeEventListener("click", _t);
        };
      }
    }
  }, [d, Ce]);
  var W = function(_t, Ct) {
    _t ? R && R(Ct) : Q && Q(Ct), Qe || (De(o ? null : Ce.clientWidth), se(_t));
  }, ge = function(_t) {
    _t.button === 0 && (_t.preventDefault(), Ce.focus(), W(!0, _t));
  }, _e = function(_t) {
    W(!1, _t);
  }, Re = le.Children.toArray(s), Ee = function(_t) {
    var Ct = Re.map(function(jt) {
      return jt.props.value;
    }).indexOf(_t.target.value);
    if (Ct !== -1) {
      var zt = Re[Ct];
      ce(zt.props.value), b && b(_t, zt);
    }
  }, oe = function(_t) {
    return function(Ct) {
      C || W(!1, Ct);
      var zt;
      if (C) {
        zt = Array.isArray(Z) ? Z.slice() : [];
        var jt = Z.indexOf(_t.props.value);
        jt === -1 ? zt.push(_t.props.value) : zt.splice(jt, 1);
      } else
        zt = _t.props.value;
      _t.props.onClick && _t.props.onClick(Ct), Z !== zt && (ce(zt), b && (Ct.persist(), Object.defineProperty(Ct, "target", {
        writable: !0,
        value: {
          value: zt,
          name: y
        }
      }), b(Ct, _t)));
    };
  }, ie = function(_t) {
    if (!O) {
      var Ct = [
        " ",
        "ArrowUp",
        "ArrowDown",
        // The native select doesn't respond to enter on MacOS, but it's recommended by
        // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
        "Enter"
      ];
      Ct.indexOf(_t.key) !== -1 && (_t.preventDefault(), W(!0, _t));
    }
  }, Ae = Ce !== null && (Qe ? M : Te), de = function(_t) {
    !Ae && v && (_t.persist(), Object.defineProperty(_t, "target", {
      writable: !0,
      value: {
        value: Z,
        name: y
      }
    }), v(_t));
  };
  delete z["aria-invalid"];
  var we, Pe, qe = [], ke = !1;
  (Lse({
    value: Z
  }) || u) && (L ? we = L(Z) : ke = !0);
  var Xe = Re.map(function(mt) {
    if (!/* @__PURE__ */ le.isValidElement(mt))
      return null;
    var _t;
    if (C) {
      if (!Array.isArray(Z))
        throw new Error(vS(2));
      _t = Z.some(function(Ct) {
        return wCe(Ct, mt.props.value);
      }), _t && ke && qe.push(mt.props.children);
    } else
      _t = wCe(Z, mt.props.value), _t && ke && (Pe = mt.props.children);
    return /* @__PURE__ */ le.cloneElement(mt, {
      "aria-selected": _t ? "true" : void 0,
      onClick: oe(mt),
      onKeyUp: function(zt) {
        zt.key === " " && zt.preventDefault(), mt.props.onKeyUp && mt.props.onKeyUp(zt);
      },
      role: "option",
      selected: _t,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": mt.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  ke && (we = C ? qe.join(", ") : Pe);
  var rt = Se;
  !o && Qe && Ce && (rt = Ce.clientWidth);
  var it;
  typeof $ < "u" ? it = $ : it = c ? null : 0;
  var ht = k.id || (y ? "mui-component-select-".concat(y) : void 0);
  return /* @__PURE__ */ le.createElement(le.Fragment, null, /* @__PURE__ */ le.createElement("div", at({
    className: Xt(
      a.root,
      // TODO v5: merge root and select
      a.select,
      a.selectMenu,
      a[K],
      A,
      c && a.disabled
    ),
    ref: Be,
    tabIndex: it,
    role: "button",
    "aria-disabled": c ? "true" : void 0,
    "aria-expanded": Ae ? "true" : void 0,
    "aria-haspopup": "listbox",
    "aria-label": r,
    "aria-labelledby": [d, ht].filter(Boolean).join(" ") || void 0,
    onKeyDown: ie,
    onMouseDown: c || O ? null : ge,
    onBlur: de,
    onFocus: w
  }, k, {
    // The id is required for proper a11y
    id: ht
  }), bCt(we) ? (
    // eslint-disable-next-line react/no-danger
    /* @__PURE__ */ le.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: "&#8203;"
      }
    })
  ) : we), /* @__PURE__ */ le.createElement("input", at({
    value: Array.isArray(Z) ? Z.join(",") : Z,
    name: y,
    ref: ee,
    "aria-hidden": !0,
    onChange: Ee,
    tabIndex: -1,
    className: a.nativeInput,
    autoFocus: i
  }, z)), /* @__PURE__ */ le.createElement(f, {
    className: Xt(a.icon, a["icon".concat(io(K))], Ae && a.iconOpen, c && a.disabled)
  }), /* @__PURE__ */ le.createElement(Qmt, at({
    id: "menu-".concat(y || ""),
    anchorEl: Ce,
    open: Ae,
    onClose: _e
  }, m, {
    MenuListProps: at({
      "aria-labelledby": d,
      role: "listbox",
      disableListWrap: !0
    }, m.MenuListProps),
    PaperProps: at({}, m.PaperProps, {
      style: at({
        minWidth: rt
      }, m.PaperProps != null ? m.PaperProps.style : null)
    })
  }), Xe));
});
const SCt = _Ct;
var QCt = rGe, wCt = /* @__PURE__ */ le.createElement(Ose, null), xCt = /* @__PURE__ */ le.createElement(Jke, null), BGe = /* @__PURE__ */ le.forwardRef(function t(e, n) {
  var r = e.autoWidth, i = r === void 0 ? !1 : r, o = e.children, s = e.classes, a = e.displayEmpty, A = a === void 0 ? !1 : a, l = e.IconComponent, c = l === void 0 ? nGe : l, u = e.id, f = e.input, h = e.inputProps, d = e.label, I = e.labelId, m = e.labelWidth, C = m === void 0 ? 0 : m, y = e.MenuProps, v = e.multiple, b = v === void 0 ? !1 : v, Q = e.native, w = Q === void 0 ? !1 : Q, R = e.onClose, M = e.onOpen, O = e.open, L = e.renderValue, N = e.SelectDisplayProps, k = e.variant, $ = k === void 0 ? "standard" : k, U = Rn(e, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]), X = w ? tGe : SCt, K = UB(), z = WQ({
    props: e,
    muiFormControl: K,
    states: ["variant"]
  }), Y = z.variant || $, V = f || {
    standard: wCt,
    outlined: /* @__PURE__ */ le.createElement(sGe, {
      label: d,
      labelWidth: C
    }),
    filled: xCt
  }[Y];
  return /* @__PURE__ */ le.cloneElement(V, at({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: X,
    inputProps: at({
      children: o,
      IconComponent: c,
      variant: Y,
      type: void 0,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple: b
    }, w ? {
      id: u
    } : {
      autoWidth: i,
      displayEmpty: A,
      labelId: I,
      MenuProps: y,
      onClose: R,
      onOpen: M,
      open: O,
      renderValue: L,
      SelectDisplayProps: at({
        id: u
      }, N)
    }, h, {
      classes: h ? Ese({
        baseClasses: s,
        newClasses: h.classes,
        Component: t
      }) : s
    }, f ? f.props.inputProps : {}),
    ref: n
  }, U));
});
BGe.muiName = "Select";
const il = Lr(QCt, {
  name: "MuiSelect"
})(BGe);
var RCt = function(e) {
  return {
    thumb: {
      "&$open": {
        "& $offset": {
          transform: "scale(1) translateY(-10px)"
        }
      }
    },
    open: {},
    offset: at({
      zIndex: 1
    }, e.typography.body2, {
      fontSize: e.typography.pxToRem(12),
      lineHeight: 1.2,
      transition: e.transitions.create(["transform"], {
        duration: e.transitions.duration.shortest
      }),
      top: -34,
      transformOrigin: "bottom center",
      transform: "scale(0)",
      position: "absolute"
    }),
    circle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 32,
      height: 32,
      borderRadius: "50% 50% 50% 0",
      backgroundColor: "currentColor",
      transform: "rotate(-45deg)"
    },
    label: {
      color: e.palette.primary.contrastText,
      transform: "rotate(45deg)"
    }
  };
};
function DCt(t) {
  var e = t.children, n = t.classes, r = t.className, i = t.open, o = t.value, s = t.valueLabelDisplay;
  return s === "off" ? e : /* @__PURE__ */ le.cloneElement(e, {
    className: Xt(e.props.className, (i || s === "on") && n.open, n.thumb)
  }, /* @__PURE__ */ le.createElement("span", {
    className: Xt(n.offset, r)
  }, /* @__PURE__ */ le.createElement("span", {
    className: n.circle
  }, /* @__PURE__ */ le.createElement("span", {
    className: n.label
  }, o))));
}
const TCt = Lr(RCt, {
  name: "PrivateValueLabel"
})(DCt);
function Dz(t, e) {
  return t - e;
}
function Tz(t, e, n) {
  return Math.min(Math.max(e, t), n);
}
function xCe(t, e) {
  var n = t.reduce(function(i, o, s) {
    var a = Math.abs(e - o);
    return i === null || a < i.distance || a === i.distance ? {
      distance: a,
      index: s
    } : i;
  }, null), r = n.index;
  return r;
}
function nF(t, e) {
  if (e.current !== void 0 && t.changedTouches) {
    for (var n = 0; n < t.changedTouches.length; n += 1) {
      var r = t.changedTouches[n];
      if (r.identifier === e.current)
        return {
          x: r.clientX,
          y: r.clientY
        };
    }
    return !1;
  }
  return {
    x: t.clientX,
    y: t.clientY
  };
}
function rF(t, e, n) {
  return (t - e) * 100 / (n - e);
}
function NCt(t, e, n) {
  return (n - e) * t + e;
}
function LCt(t) {
  if (Math.abs(t) < 1) {
    var e = t.toExponential().split("e-"), n = e[0].split(".")[1];
    return (n ? n.length : 0) + parseInt(e[1], 10);
  }
  var r = t.toString().split(".")[1];
  return r ? r.length : 0;
}
function RCe(t, e, n) {
  var r = Math.round((t - n) / e) * e + n;
  return Number(r.toFixed(LCt(e)));
}
function DCe(t) {
  var e = t.values, n = t.source, r = t.newValue, i = t.index;
  if (e[i] === r)
    return n;
  var o = e.slice();
  return o[i] = r, o;
}
function iF(t) {
  var e = t.sliderRef, n = t.activeIndex, r = t.setActive;
  (!e.current.contains(document.activeElement) || Number(document.activeElement.getAttribute("data-index")) !== n) && e.current.querySelector('[role="slider"][data-index="'.concat(n, '"]')).focus(), r && r(n);
}
var oF = {
  horizontal: {
    offset: function(e) {
      return {
        left: "".concat(e, "%")
      };
    },
    leap: function(e) {
      return {
        width: "".concat(e, "%")
      };
    }
  },
  "horizontal-reverse": {
    offset: function(e) {
      return {
        right: "".concat(e, "%")
      };
    },
    leap: function(e) {
      return {
        width: "".concat(e, "%")
      };
    }
  },
  vertical: {
    offset: function(e) {
      return {
        bottom: "".concat(e, "%")
      };
    },
    leap: function(e) {
      return {
        height: "".concat(e, "%")
      };
    }
  }
}, TCe = function(e) {
  return e;
}, MCt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 2,
      width: "100%",
      boxSizing: "content-box",
      padding: "13px 0",
      display: "inline-block",
      position: "relative",
      cursor: "pointer",
      touchAction: "none",
      color: e.palette.primary.main,
      WebkitTapHighlightColor: "transparent",
      "&$disabled": {
        pointerEvents: "none",
        cursor: "default",
        color: e.palette.grey[400]
      },
      "&$vertical": {
        width: 2,
        height: "100%",
        padding: "0 13px"
      },
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "20px 0",
        "&$vertical": {
          padding: "0 20px"
        }
      },
      "@media print": {
        colorAdjust: "exact"
      }
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      // TODO v5: move the style here
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: e.palette.secondary.main
    },
    /* Styles applied to the root element if `marks` is provided with at least one label. */
    marked: {
      marginBottom: 20,
      "&$vertical": {
        marginBottom: "auto",
        marginRight: 20
      }
    },
    /* Pseudo-class applied to the root element if `orientation="vertical"`. */
    vertical: {},
    /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the rail element. */
    rail: {
      display: "block",
      position: "absolute",
      width: "100%",
      height: 2,
      borderRadius: 1,
      backgroundColor: "currentColor",
      opacity: 0.38,
      "$vertical &": {
        height: "100%",
        width: 2
      }
    },
    /* Styles applied to the track element. */
    track: {
      display: "block",
      position: "absolute",
      height: 2,
      borderRadius: 1,
      backgroundColor: "currentColor",
      "$vertical &": {
        width: 2
      }
    },
    /* Styles applied to the track element if `track={false}`. */
    trackFalse: {
      "& $track": {
        display: "none"
      }
    },
    /* Styles applied to the track element if `track="inverted"`. */
    trackInverted: {
      "& $track": {
        backgroundColor: (
          // Same logic as the LinearProgress track color
          e.palette.type === "light" ? use(e.palette.primary.main, 0.62) : cse(e.palette.primary.main, 0.5)
        )
      },
      "& $rail": {
        opacity: 1
      }
    },
    /* Styles applied to the thumb element. */
    thumb: {
      position: "absolute",
      width: 12,
      height: 12,
      marginLeft: -6,
      marginTop: -5,
      boxSizing: "border-box",
      borderRadius: "50%",
      outline: 0,
      backgroundColor: "currentColor",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: e.transitions.create(["box-shadow"], {
        duration: e.transitions.duration.shortest
      }),
      "&::after": {
        position: "absolute",
        content: '""',
        borderRadius: "50%",
        // reach 42px hit target (2 * 15 + thumb diameter)
        left: -15,
        top: -15,
        right: -15,
        bottom: -15
      },
      "&$focusVisible,&:hover": {
        boxShadow: "0px 0px 0px 8px ".concat(xa(e.palette.primary.main, 0.16)),
        "@media (hover: none)": {
          boxShadow: "none"
        }
      },
      "&$active": {
        boxShadow: "0px 0px 0px 14px ".concat(xa(e.palette.primary.main, 0.16))
      },
      "&$disabled": {
        width: 8,
        height: 8,
        marginLeft: -4,
        marginTop: -3,
        "&:hover": {
          boxShadow: "none"
        }
      },
      "$vertical &": {
        marginLeft: -5,
        marginBottom: -6
      },
      "$vertical &$disabled": {
        marginLeft: -3,
        marginBottom: -4
      }
    },
    /* Styles applied to the thumb element if `color="primary"`. */
    thumbColorPrimary: {
      // TODO v5: move the style here
    },
    /* Styles applied to the thumb element if `color="secondary"`. */
    thumbColorSecondary: {
      "&$focusVisible,&:hover": {
        boxShadow: "0px 0px 0px 8px ".concat(xa(e.palette.secondary.main, 0.16))
      },
      "&$active": {
        boxShadow: "0px 0px 0px 14px ".concat(xa(e.palette.secondary.main, 0.16))
      }
    },
    /* Pseudo-class applied to the thumb element if it's active. */
    active: {},
    /* Pseudo-class applied to the thumb element if keyboard focused. */
    focusVisible: {},
    /* Styles applied to the thumb label element. */
    valueLabel: {
      // IE 11 centering bug, to remove from the customization demos once no longer supported
      left: "calc(-50% - 4px)"
    },
    /* Styles applied to the mark element. */
    mark: {
      position: "absolute",
      width: 2,
      height: 2,
      borderRadius: 1,
      backgroundColor: "currentColor"
    },
    /* Styles applied to the mark element if active (depending on the value). */
    markActive: {
      backgroundColor: e.palette.background.paper,
      opacity: 0.8
    },
    /* Styles applied to the mark label element. */
    markLabel: at({}, e.typography.body2, {
      color: e.palette.text.secondary,
      position: "absolute",
      top: 26,
      transform: "translateX(-50%)",
      whiteSpace: "nowrap",
      "$vertical &": {
        top: "auto",
        left: 26,
        transform: "translateY(50%)"
      },
      "@media (pointer: coarse)": {
        top: 40,
        "$vertical &": {
          left: 31
        }
      }
    }),
    /* Styles applied to the mark label element if active (depending on the value). */
    markLabelActive: {
      color: e.palette.text.primary
    }
  };
}, OCt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e["aria-label"], i = e["aria-labelledby"], o = e["aria-valuetext"], s = e.classes, a = e.className, A = e.color, l = A === void 0 ? "primary" : A, c = e.component, u = c === void 0 ? "span" : c, f = e.defaultValue, h = e.disabled, d = h === void 0 ? !1 : h, I = e.getAriaLabel, m = e.getAriaValueText, C = e.marks, y = C === void 0 ? !1 : C, v = e.max, b = v === void 0 ? 100 : v, Q = e.min, w = Q === void 0 ? 0 : Q, R = e.name, M = e.onChange, O = e.onChangeCommitted, L = e.onMouseDown, N = e.orientation, k = N === void 0 ? "horizontal" : N, $ = e.scale, U = $ === void 0 ? TCe : $, X = e.step, K = X === void 0 ? 1 : X, z = e.ThumbComponent, Y = z === void 0 ? "span" : z, V = e.track, Z = V === void 0 ? "normal" : V, ce = e.value, ee = e.ValueLabelComponent, pe = ee === void 0 ? TCt : ee, Ce = e.valueLabelDisplay, Be = Ce === void 0 ? "off" : Ce, Ie = e.valueLabelFormat, Qe = Ie === void 0 ? TCe : Ie, xe = Rn(e, ["aria-label", "aria-labelledby", "aria-valuetext", "classes", "className", "color", "component", "defaultValue", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "scale", "step", "ThumbComponent", "track", "value", "ValueLabelComponent", "valueLabelDisplay", "valueLabelFormat"]), Se = GB(), De = le.useRef(), Ue = le.useState(-1), Te = Ue[0], se = Ue[1], fe = le.useState(-1), W = fe[0], ge = fe[1], _e = mH({
    controlled: ce,
    default: f,
    name: "Slider"
  }), Re = yE(_e, 2), Ee = Re[0], oe = Re[1], ie = Array.isArray(Ee), Ae = ie ? Ee.slice().sort(Dz) : [Ee];
  Ae = Ae.map(function(Ot) {
    return Tz(Ot, w, b);
  });
  var de = y === !0 && K !== null ? iH(Array(Math.floor((b - w) / K) + 1)).map(function(Ot, yn) {
    return {
      value: w + K * yn
    };
  }) : y || [], we = xse(), Pe = we.isFocusVisible, qe = we.onBlurVisible, ke = we.ref, Xe = le.useState(-1), rt = Xe[0], it = Xe[1], ht = le.useRef(), mt = Ms(ke, ht), _t = Ms(n, mt), Ct = Ua(function(Ot) {
    var yn = Number(Ot.currentTarget.getAttribute("data-index"));
    Pe(Ot) && it(yn), ge(yn);
  }), zt = Ua(function() {
    rt !== -1 && (it(-1), qe()), ge(-1);
  }), jt = Ua(function(Ot) {
    var yn = Number(Ot.currentTarget.getAttribute("data-index"));
    ge(yn);
  }), lt = Ua(function() {
    ge(-1);
  }), Ht = Se.direction === "rtl", vt = Ua(function(Ot) {
    var yn = Number(Ot.currentTarget.getAttribute("data-index")), Fn = Ae[yn], xn = (b - w) / 10, vn = de.map(function(ye) {
      return ye.value;
    }), nt = vn.indexOf(Fn), st, xt = Ht ? "ArrowLeft" : "ArrowRight", Me = Ht ? "ArrowRight" : "ArrowLeft";
    switch (Ot.key) {
      case "Home":
        st = w;
        break;
      case "End":
        st = b;
        break;
      case "PageUp":
        K && (st = Fn + xn);
        break;
      case "PageDown":
        K && (st = Fn - xn);
        break;
      case xt:
      case "ArrowUp":
        K ? st = Fn + K : st = vn[nt + 1] || vn[vn.length - 1];
        break;
      case Me:
      case "ArrowDown":
        K ? st = Fn - K : st = vn[nt - 1] || vn[0];
        break;
      default:
        return;
    }
    if (Ot.preventDefault(), K && (st = RCe(st, K, w)), st = Tz(st, w, b), ie) {
      var _ = st;
      st = DCe({
        values: Ae,
        source: Ee,
        newValue: st,
        index: yn
      }).sort(Dz), iF({
        sliderRef: ht,
        activeIndex: st.indexOf(_)
      });
    }
    oe(st), it(yn), M && M(Ot, st), O && O(Ot, st);
  }), It = le.useRef(), un = k;
  Ht && k !== "vertical" && (un += "-reverse");
  var hn = function(yn) {
    var Fn = yn.finger, xn = yn.move, vn = xn === void 0 ? !1 : xn, nt = yn.values, st = yn.source, xt = ht.current, Me = xt.getBoundingClientRect(), _ = Me.width, ye = Me.height, He = Me.bottom, ze = Me.left, tt;
    un.indexOf("vertical") === 0 ? tt = (He - Fn.y) / ye : tt = (Fn.x - ze) / _, un.indexOf("-reverse") !== -1 && (tt = 1 - tt);
    var At;
    if (At = NCt(tt, w, b), K)
      At = RCe(At, K, w);
    else {
      var pt = de.map(function(rn) {
        return rn.value;
      }), Bt = xCe(pt, At);
      At = pt[Bt];
    }
    At = Tz(At, w, b);
    var Rt = 0;
    if (ie) {
      vn ? Rt = It.current : Rt = xCe(nt, At);
      var Lt = At;
      At = DCe({
        values: nt,
        source: st,
        newValue: At,
        index: Rt
      }).sort(Dz), Rt = At.indexOf(Lt), It.current = Rt;
    }
    return {
      newValue: At,
      activeIndex: Rt
    };
  }, We = Ua(function(Ot) {
    var yn = nF(Ot, De);
    if (yn) {
      var Fn = hn({
        finger: yn,
        move: !0,
        values: Ae,
        source: Ee
      }), xn = Fn.newValue, vn = Fn.activeIndex;
      iF({
        sliderRef: ht,
        activeIndex: vn,
        setActive: se
      }), oe(xn), M && M(Ot, xn);
    }
  }), En = Ua(function(Ot) {
    var yn = nF(Ot, De);
    if (yn) {
      var Fn = hn({
        finger: yn,
        values: Ae,
        source: Ee
      }), xn = Fn.newValue;
      se(-1), Ot.type === "touchend" && ge(-1), O && O(Ot, xn), De.current = void 0;
      var vn = zl(ht.current);
      vn.removeEventListener("mousemove", We), vn.removeEventListener("mouseup", En), vn.removeEventListener("touchmove", We), vn.removeEventListener("touchend", En);
    }
  }), qn = Ua(function(Ot) {
    Ot.preventDefault();
    var yn = Ot.changedTouches[0];
    yn != null && (De.current = yn.identifier);
    var Fn = nF(Ot, De), xn = hn({
      finger: Fn,
      values: Ae,
      source: Ee
    }), vn = xn.newValue, nt = xn.activeIndex;
    iF({
      sliderRef: ht,
      activeIndex: nt,
      setActive: se
    }), oe(vn), M && M(Ot, vn);
    var st = zl(ht.current);
    st.addEventListener("touchmove", We), st.addEventListener("touchend", En);
  });
  le.useEffect(function() {
    var Ot = ht.current;
    Ot.addEventListener("touchstart", qn);
    var yn = zl(Ot);
    return function() {
      Ot.removeEventListener("touchstart", qn), yn.removeEventListener("mousemove", We), yn.removeEventListener("mouseup", En), yn.removeEventListener("touchmove", We), yn.removeEventListener("touchend", En);
    };
  }, [En, We, qn]);
  var Pt = Ua(function(Ot) {
    L && L(Ot), Ot.preventDefault();
    var yn = nF(Ot, De), Fn = hn({
      finger: yn,
      values: Ae,
      source: Ee
    }), xn = Fn.newValue, vn = Fn.activeIndex;
    iF({
      sliderRef: ht,
      activeIndex: vn,
      setActive: se
    }), oe(xn), M && M(Ot, xn);
    var nt = zl(ht.current);
    nt.addEventListener("mousemove", We), nt.addEventListener("mouseup", En);
  }), dr = rF(ie ? Ae[0] : w, w, b), yr = rF(Ae[Ae.length - 1], w, b) - dr, jn = at({}, oF[un].offset(dr), oF[un].leap(yr));
  return /* @__PURE__ */ le.createElement(u, at({
    ref: _t,
    className: Xt(s.root, s["color".concat(io(l))], a, d && s.disabled, de.length > 0 && de.some(function(Ot) {
      return Ot.label;
    }) && s.marked, Z === !1 && s.trackFalse, k === "vertical" && s.vertical, Z === "inverted" && s.trackInverted),
    onMouseDown: Pt
  }, xe), /* @__PURE__ */ le.createElement("span", {
    className: s.rail
  }), /* @__PURE__ */ le.createElement("span", {
    className: s.track,
    style: jn
  }), /* @__PURE__ */ le.createElement("input", {
    value: Ae.join(","),
    name: R,
    type: "hidden"
  }), de.map(function(Ot, yn) {
    var Fn = rF(Ot.value, w, b), xn = oF[un].offset(Fn), vn;
    return Z === !1 ? vn = Ae.indexOf(Ot.value) !== -1 : vn = Z === "normal" && (ie ? Ot.value >= Ae[0] && Ot.value <= Ae[Ae.length - 1] : Ot.value <= Ae[0]) || Z === "inverted" && (ie ? Ot.value <= Ae[0] || Ot.value >= Ae[Ae.length - 1] : Ot.value >= Ae[0]), /* @__PURE__ */ le.createElement(le.Fragment, {
      key: Ot.value
    }, /* @__PURE__ */ le.createElement("span", {
      style: xn,
      "data-index": yn,
      className: Xt(s.mark, vn && s.markActive)
    }), Ot.label != null ? /* @__PURE__ */ le.createElement("span", {
      "aria-hidden": !0,
      "data-index": yn,
      style: xn,
      className: Xt(s.markLabel, vn && s.markLabelActive)
    }, Ot.label) : null);
  }), Ae.map(function(Ot, yn) {
    var Fn = rF(Ot, w, b), xn = oF[un].offset(Fn);
    return /* @__PURE__ */ le.createElement(pe, {
      key: yn,
      valueLabelFormat: Qe,
      valueLabelDisplay: Be,
      className: s.valueLabel,
      value: typeof Qe == "function" ? Qe(U(Ot), yn) : Qe,
      index: yn,
      open: W === yn || Te === yn || Be === "on",
      disabled: d
    }, /* @__PURE__ */ le.createElement(Y, {
      className: Xt(s.thumb, s["thumbColor".concat(io(l))], Te === yn && s.active, d && s.disabled, rt === yn && s.focusVisible),
      tabIndex: d ? null : 0,
      role: "slider",
      style: xn,
      "data-index": yn,
      "aria-label": I ? I(yn) : r,
      "aria-labelledby": i,
      "aria-orientation": k,
      "aria-valuemax": U(b),
      "aria-valuemin": U(w),
      "aria-valuenow": U(Ot),
      "aria-valuetext": m ? m(U(Ot), yn) : o,
      onKeyDown: vt,
      onFocus: Ct,
      onBlur: zt,
      onMouseOver: jt,
      onMouseLeave: lt
    }));
  }));
});
const ps = Lr(MCt, {
  name: "MuiSlider"
})(OCt);
var FCt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "inline-flex",
      width: 34 + 12 * 2,
      height: 14 + 12 * 2,
      overflow: "hidden",
      padding: 12,
      boxSizing: "border-box",
      position: "relative",
      flexShrink: 0,
      zIndex: 0,
      // Reset the stacking context.
      verticalAlign: "middle",
      // For correct alignment with the text.
      "@media print": {
        colorAdjust: "exact"
      }
    },
    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -8
    },
    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -8
    },
    /* Styles applied to the internal `SwitchBase` component's `root` class. */
    switchBase: {
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 1,
      // Render above the focus ripple.
      color: e.palette.type === "light" ? e.palette.grey[50] : e.palette.grey[400],
      transition: e.transitions.create(["left", "transform"], {
        duration: e.transitions.duration.shortest
      }),
      "&$checked": {
        transform: "translateX(20px)"
      },
      "&$disabled": {
        color: e.palette.type === "light" ? e.palette.grey[400] : e.palette.grey[800]
      },
      "&$checked + $track": {
        opacity: 0.5
      },
      "&$disabled + $track": {
        opacity: e.palette.type === "light" ? 0.12 : 0.1
      }
    },
    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
    colorPrimary: {
      "&$checked": {
        color: e.palette.primary.main,
        "&:hover": {
          backgroundColor: xa(e.palette.primary.main, e.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        }
      },
      "&$disabled": {
        color: e.palette.type === "light" ? e.palette.grey[400] : e.palette.grey[800]
      },
      "&$checked + $track": {
        backgroundColor: e.palette.primary.main
      },
      "&$disabled + $track": {
        backgroundColor: e.palette.type === "light" ? e.palette.common.black : e.palette.common.white
      }
    },
    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
    colorSecondary: {
      "&$checked": {
        color: e.palette.secondary.main,
        "&:hover": {
          backgroundColor: xa(e.palette.secondary.main, e.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        }
      },
      "&$disabled": {
        color: e.palette.type === "light" ? e.palette.grey[400] : e.palette.grey[800]
      },
      "&$checked + $track": {
        backgroundColor: e.palette.secondary.main
      },
      "&$disabled + $track": {
        backgroundColor: e.palette.type === "light" ? e.palette.common.black : e.palette.common.white
      }
    },
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      width: 40,
      height: 24,
      padding: 7,
      "& $thumb": {
        width: 16,
        height: 16
      },
      "& $switchBase": {
        padding: 4,
        "&$checked": {
          transform: "translateX(16px)"
        }
      }
    },
    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
    checked: {},
    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
    disabled: {},
    /* Styles applied to the internal SwitchBase component's input element. */
    input: {
      left: "-100%",
      width: "300%"
    },
    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
    thumb: {
      boxShadow: e.shadows[1],
      backgroundColor: "currentColor",
      width: 20,
      height: 20,
      borderRadius: "50%"
    },
    /* Styles applied to the track element. */
    track: {
      height: "100%",
      width: "100%",
      borderRadius: 14 / 2,
      zIndex: -1,
      transition: e.transitions.create(["opacity", "background-color"], {
        duration: e.transitions.duration.shortest
      }),
      backgroundColor: e.palette.type === "light" ? e.palette.common.black : e.palette.common.white,
      opacity: e.palette.type === "light" ? 0.38 : 0.3
    }
  };
}, PCt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.color, s = o === void 0 ? "secondary" : o, a = e.edge, A = a === void 0 ? !1 : a, l = e.size, c = l === void 0 ? "medium" : l, u = Rn(e, ["classes", "className", "color", "edge", "size"]), f = /* @__PURE__ */ le.createElement("span", {
    className: r.thumb
  });
  return /* @__PURE__ */ le.createElement("span", {
    className: Xt(r.root, i, {
      start: r.edgeStart,
      end: r.edgeEnd
    }[A], c === "small" && r["size".concat(io(c))])
  }, /* @__PURE__ */ le.createElement(jke, at({
    type: "checkbox",
    icon: f,
    checkedIcon: f,
    classes: {
      root: Xt(r.switchBase, r["color".concat(io(s))]),
      input: r.input,
      checked: r.checked,
      disabled: r.disabled
    },
    ref: n
  }, u)), /* @__PURE__ */ le.createElement("span", {
    className: r.track
  }));
});
const kCt = Lr(FCt, {
  name: "MuiSwitch"
})(PCt);
var GCt = function(e) {
  var n;
  return {
    /* Styles applied to the root element. */
    root: at({}, e.typography.button, (n = {
      maxWidth: 264,
      minWidth: 72,
      position: "relative",
      boxSizing: "border-box",
      minHeight: 48,
      flexShrink: 0,
      padding: "6px 12px"
    }, mo(n, e.breakpoints.up("sm"), {
      padding: "6px 24px"
    }), mo(n, "overflow", "hidden"), mo(n, "whiteSpace", "normal"), mo(n, "textAlign", "center"), mo(n, e.breakpoints.up("sm"), {
      minWidth: 160
    }), n)),
    /* Styles applied to the root element if both `icon` and `label` are provided. */
    labelIcon: {
      minHeight: 72,
      paddingTop: 9,
      "& $wrapper > *:first-child": {
        marginBottom: 6
      }
    },
    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */
    textColorInherit: {
      color: "inherit",
      opacity: 0.7,
      "&$selected": {
        opacity: 1
      },
      "&$disabled": {
        opacity: 0.5
      }
    },
    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */
    textColorPrimary: {
      color: e.palette.text.secondary,
      "&$selected": {
        color: e.palette.primary.main
      },
      "&$disabled": {
        color: e.palette.text.disabled
      }
    },
    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */
    textColorSecondary: {
      color: e.palette.text.secondary,
      "&$selected": {
        color: e.palette.secondary.main
      },
      "&$disabled": {
        color: e.palette.text.disabled
      }
    },
    /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */
    selected: {},
    /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
    disabled: {},
    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
    fullWidth: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: "none"
    },
    /* Styles applied to the root element if `wrapped={true}`. */
    wrapped: {
      fontSize: e.typography.pxToRem(12),
      lineHeight: 1.5
    },
    /* Styles applied to the `icon` and `label`'s wrapper element. */
    wrapper: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      flexDirection: "column"
    }
  };
}, UCt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.disabled, s = o === void 0 ? !1 : o, a = e.disableFocusRipple, A = a === void 0 ? !1 : a, l = e.fullWidth, c = e.icon, u = e.indicator, f = e.label, h = e.onChange, d = e.onClick, I = e.onFocus, m = e.selected, C = e.selectionFollowsFocus, y = e.textColor, v = y === void 0 ? "inherit" : y, b = e.value, Q = e.wrapped, w = Q === void 0 ? !1 : Q, R = Rn(e, ["classes", "className", "disabled", "disableFocusRipple", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"]), M = function(N) {
    h && h(N, b), d && d(N);
  }, O = function(N) {
    C && !m && h && h(N, b), I && I(N);
  };
  return /* @__PURE__ */ le.createElement(JQ, at({
    focusRipple: !A,
    className: Xt(r.root, r["textColor".concat(io(v))], i, s && r.disabled, m && r.selected, f && c && r.labelIcon, l && r.fullWidth, w && r.wrapped),
    ref: n,
    role: "tab",
    "aria-selected": m,
    disabled: s,
    onClick: M,
    onFocus: O,
    tabIndex: m ? 0 : -1
  }, R), /* @__PURE__ */ le.createElement("span", {
    className: r.wrapper
  }, c, f), u);
});
const NCe = Lr(GCt, {
  name: "MuiTab"
})(UCt);
var HCt = le.createContext();
const bGe = HCt;
var $Ct = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "table",
      width: "100%",
      borderCollapse: "collapse",
      borderSpacing: 0,
      "& caption": at({}, e.typography.body2, {
        padding: e.spacing(2),
        color: e.palette.text.secondary,
        textAlign: "left",
        captionSide: "bottom"
      })
    },
    /* Styles applied to the root element if `stickyHeader={true}`. */
    stickyHeader: {
      borderCollapse: "separate"
    }
  };
}, LCe = "table", qCt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.component, s = o === void 0 ? LCe : o, a = e.padding, A = a === void 0 ? "normal" : a, l = e.size, c = l === void 0 ? "medium" : l, u = e.stickyHeader, f = u === void 0 ? !1 : u, h = Rn(e, ["classes", "className", "component", "padding", "size", "stickyHeader"]), d = le.useMemo(function() {
    return {
      padding: A,
      size: c,
      stickyHeader: f
    };
  }, [A, c, f]);
  return /* @__PURE__ */ le.createElement(bGe.Provider, {
    value: d
  }, /* @__PURE__ */ le.createElement(s, at({
    role: s === LCe ? null : "table",
    ref: n,
    className: Xt(r.root, i, f && r.stickyHeader)
  }, h)));
});
const jCt = Lr($Ct, {
  name: "MuiTable"
})(qCt);
var YCt = le.createContext();
const Hse = YCt;
var zCt = {
  /* Styles applied to the root element. */
  root: {
    display: "table-row-group"
  }
}, VCt = {
  variant: "body"
}, MCe = "tbody", JCt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.component, s = o === void 0 ? MCe : o, a = Rn(e, ["classes", "className", "component"]);
  return /* @__PURE__ */ le.createElement(Hse.Provider, {
    value: VCt
  }, /* @__PURE__ */ le.createElement(s, at({
    className: Xt(r.root, i),
    ref: n,
    role: s === MCe ? null : "rowgroup"
  }, a)));
});
const KCt = Lr(zCt, {
  name: "MuiTableBody"
})(JCt);
var WCt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: at({}, e.typography.body2, {
      display: "table-cell",
      verticalAlign: "inherit",
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: `1px solid
    `.concat(e.palette.type === "light" ? use(xa(e.palette.divider, 1), 0.88) : cse(xa(e.palette.divider, 1), 0.68)),
      textAlign: "left",
      padding: 16
    }),
    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: e.palette.text.primary,
      lineHeight: e.typography.pxToRem(24),
      fontWeight: e.typography.fontWeightMedium
    },
    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: e.palette.text.primary
    },
    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      color: e.palette.text.secondary,
      lineHeight: e.typography.pxToRem(21),
      fontSize: e.typography.pxToRem(12)
    },
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: "6px 24px 6px 16px",
      "&:last-child": {
        paddingRight: 16
      },
      "&$paddingCheckbox": {
        width: 24,
        // prevent the checkbox column from growing
        padding: "0 12px 0 16px",
        "&:last-child": {
          paddingLeft: 12,
          paddingRight: 16
        },
        "& > *": {
          padding: 0
        }
      }
    },
    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      width: 48,
      // prevent the checkbox column from growing
      padding: "0 0 0 4px",
      "&:last-child": {
        paddingLeft: 0,
        paddingRight: 4
      }
    },
    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      "&:last-child": {
        padding: 0
      }
    },
    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: "left"
    },
    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: "center"
    },
    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: "right",
      flexDirection: "row-reverse"
    },
    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: "justify"
    },
    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
    stickyHeader: {
      position: "sticky",
      top: 0,
      left: 0,
      zIndex: 2,
      backgroundColor: e.palette.background.default
    }
  };
}, XCt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.align, i = r === void 0 ? "inherit" : r, o = e.classes, s = e.className, a = e.component, A = e.padding, l = e.scope, c = e.size, u = e.sortDirection, f = e.variant, h = Rn(e, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]), d = le.useContext(bGe), I = le.useContext(Hse), m = I && I.variant === "head", C, y;
  a ? (y = a, C = m ? "columnheader" : "cell") : y = m ? "th" : "td";
  var v = l;
  !v && m && (v = "col");
  var b = A || (d && d.padding ? d.padding : "normal"), Q = c || (d && d.size ? d.size : "medium"), w = f || I && I.variant, R = null;
  return u && (R = u === "asc" ? "ascending" : "descending"), /* @__PURE__ */ le.createElement(y, at({
    ref: n,
    className: Xt(o.root, o[w], s, i !== "inherit" && o["align".concat(io(i))], b !== "normal" && o["padding".concat(io(b))], Q !== "medium" && o["size".concat(io(Q))], w === "head" && d && d.stickyHeader && o.stickyHeader),
    "aria-sort": R,
    role: C,
    scope: v
  }, h));
});
const br = Lr(WCt, {
  name: "MuiTableCell"
})(XCt);
var ZCt = {
  /* Styles applied to the root element. */
  root: {
    width: "100%",
    overflowX: "auto"
  }
}, eEt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.component, s = o === void 0 ? "div" : o, a = Rn(e, ["classes", "className", "component"]);
  return /* @__PURE__ */ le.createElement(s, at({
    ref: n,
    className: Xt(r.root, i)
  }, a));
});
const tEt = Lr(ZCt, {
  name: "MuiTableContainer"
})(eEt), nEt = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
})), rEt = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}));
var iEt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: "inherit",
      display: "table-row",
      verticalAlign: "middle",
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      "&$hover:hover": {
        backgroundColor: e.palette.action.hover
      },
      "&$selected, &$selected:hover": {
        backgroundColor: xa(e.palette.secondary.main, e.palette.action.selectedOpacity)
      }
    },
    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},
    /* Pseudo-class applied to the root element if `hover={true}`. */
    hover: {},
    /* Styles applied to the root element if table variant="head". */
    head: {},
    /* Styles applied to the root element if table variant="footer". */
    footer: {}
  };
}, OCe = "tr", oEt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.component, s = o === void 0 ? OCe : o, a = e.hover, A = a === void 0 ? !1 : a, l = e.selected, c = l === void 0 ? !1 : l, u = Rn(e, ["classes", "className", "component", "hover", "selected"]), f = le.useContext(Hse);
  return /* @__PURE__ */ le.createElement(s, at({
    ref: n,
    className: Xt(r.root, i, f && {
      head: r.head,
      footer: r.footer
    }[f.variant], A && r.hover, c && r.selected),
    role: s === OCe ? null : "row"
  }, u));
});
const Ko = Lr(iEt, {
  name: "MuiTableRow"
})(oEt);
var J1;
function _Ge() {
  if (J1)
    return J1;
  var t = document.createElement("div"), e = document.createElement("div");
  return e.style.width = "10px", e.style.height = "1px", t.appendChild(e), t.dir = "rtl", t.style.fontSize = "14px", t.style.width = "4px", t.style.height = "1px", t.style.position = "absolute", t.style.top = "-1000px", t.style.overflow = "scroll", document.body.appendChild(t), J1 = "reverse", t.scrollLeft > 0 ? J1 = "default" : (t.scrollLeft = 1, t.scrollLeft === 0 && (J1 = "negative")), document.body.removeChild(t), J1;
}
function FCe(t, e) {
  var n = t.scrollLeft;
  if (e !== "rtl")
    return n;
  var r = _Ge();
  switch (r) {
    case "negative":
      return t.scrollWidth - t.clientWidth + n;
    case "reverse":
      return t.scrollWidth - t.clientWidth - n;
    default:
      return n;
  }
}
function sEt(t) {
  return (1 + Math.sin(Math.PI * t - Math.PI / 2)) / 2;
}
function aEt(t, e, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {
  }, o = r.ease, s = o === void 0 ? sEt : o, a = r.duration, A = a === void 0 ? 300 : a, l = null, c = e[t], u = !1, f = function() {
    u = !0;
  }, h = function d(I) {
    if (u) {
      i(new Error("Animation cancelled"));
      return;
    }
    l === null && (l = I);
    var m = Math.min(1, (I - l) / A);
    if (e[t] = s(m) * (n - c) + c, m >= 1) {
      requestAnimationFrame(function() {
        i(null);
      });
      return;
    }
    requestAnimationFrame(d);
  };
  return c === n ? (i(new Error("Element already at target position")), f) : (requestAnimationFrame(h), f);
}
var AEt = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function lEt(t) {
  var e = t.onChange, n = Rn(t, ["onChange"]), r = le.useRef(), i = le.useRef(null), o = function() {
    r.current = i.current.offsetHeight - i.current.clientHeight;
  };
  return le.useEffect(function() {
    var s = aT(function() {
      var a = r.current;
      o(), a !== r.current && e(r.current);
    });
    return window.addEventListener("resize", s), function() {
      s.clear(), window.removeEventListener("resize", s);
    };
  }, [e]), le.useEffect(function() {
    o(), e(r.current);
  }, [e]), /* @__PURE__ */ le.createElement("div", at({
    style: AEt,
    ref: i
  }, n));
}
var cEt = function(e) {
  return {
    root: {
      position: "absolute",
      height: 2,
      bottom: 0,
      width: "100%",
      transition: e.transitions.create()
    },
    colorPrimary: {
      backgroundColor: e.palette.primary.main
    },
    colorSecondary: {
      backgroundColor: e.palette.secondary.main
    },
    vertical: {
      height: "100%",
      width: 2,
      right: 0
    }
  };
}, uEt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.color, s = e.orientation, a = Rn(e, ["classes", "className", "color", "orientation"]);
  return /* @__PURE__ */ le.createElement("span", at({
    className: Xt(r.root, r["color".concat(io(o))], i, s === "vertical" && r.vertical),
    ref: n
  }, a));
});
const fEt = Lr(cEt, {
  name: "PrivateTabIndicator"
})(uEt);
var gEt = {
  /* Styles applied to the root element. */
  root: {
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    "&$disabled": {
      opacity: 0
    }
  },
  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    width: "100%",
    height: 40,
    "& svg": {
      transform: "rotate(90deg)"
    }
  },
  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {}
}, hEt = /* @__PURE__ */ le.createElement(nEt, {
  fontSize: "small"
}), dEt = /* @__PURE__ */ le.createElement(rEt, {
  fontSize: "small"
}), pEt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.classes, i = e.className, o = e.direction, s = e.orientation, a = e.disabled, A = Rn(e, ["classes", "className", "direction", "orientation", "disabled"]);
  return /* @__PURE__ */ le.createElement(JQ, at({
    component: "div",
    className: Xt(r.root, i, a && r.disabled, s === "vertical" && r.vertical),
    ref: n,
    role: null,
    tabIndex: null
  }, A), o === "left" ? hEt : dEt);
});
const IEt = Lr(gEt, {
  name: "MuiTabScrollButton"
})(pEt);
var mEt = function(e) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: "hidden",
      minHeight: 48,
      WebkitOverflowScrolling: "touch",
      // Add iOS momentum scrolling.
      display: "flex"
    },
    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      flexDirection: "column"
    },
    /* Styles applied to the flex container element. */
    flexContainer: {
      display: "flex"
    },
    /* Styles applied to the flex container element if `orientation="vertical"`. */
    flexContainerVertical: {
      flexDirection: "column"
    },
    /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
    centered: {
      justifyContent: "center"
    },
    /* Styles applied to the tablist element. */
    scroller: {
      position: "relative",
      display: "inline-block",
      flex: "1 1 auto",
      whiteSpace: "nowrap"
    },
    /* Styles applied to the tablist element if `!variant="scrollable"`. */
    fixed: {
      overflowX: "hidden",
      width: "100%"
    },
    /* Styles applied to the tablist element if `variant="scrollable"`. */
    scrollable: {
      overflowX: "scroll",
      // Hide dimensionless scrollbar on MacOS
      scrollbarWidth: "none",
      // Firefox
      "&::-webkit-scrollbar": {
        display: "none"
        // Safari + Chrome
      }
    },
    /* Styles applied to the `ScrollButtonComponent` component. */
    scrollButtons: {},
    /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
    scrollButtonsDesktop: mo({}, e.breakpoints.down("xs"), {
      display: "none"
    }),
    /* Styles applied to the `TabIndicator` component. */
    indicator: {}
  };
}, CEt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e["aria-label"], i = e["aria-labelledby"], o = e.action, s = e.centered, a = s === void 0 ? !1 : s, A = e.children, l = e.classes, c = e.className, u = e.component, f = u === void 0 ? "div" : u, h = e.indicatorColor, d = h === void 0 ? "secondary" : h, I = e.onChange, m = e.orientation, C = m === void 0 ? "horizontal" : m, y = e.ScrollButtonComponent, v = y === void 0 ? IEt : y, b = e.scrollButtons, Q = b === void 0 ? "auto" : b, w = e.selectionFollowsFocus, R = e.TabIndicatorProps, M = R === void 0 ? {} : R, O = e.TabScrollButtonProps, L = e.textColor, N = L === void 0 ? "inherit" : L, k = e.value, $ = e.variant, U = $ === void 0 ? "standard" : $, X = Rn(e, ["aria-label", "aria-labelledby", "action", "centered", "children", "classes", "className", "component", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant"]), K = GB(), z = U === "scrollable", Y = K.direction === "rtl", V = C === "vertical", Z = V ? "scrollTop" : "scrollLeft", ce = V ? "top" : "left", ee = V ? "bottom" : "right", pe = V ? "clientHeight" : "clientWidth", Ce = V ? "height" : "width", Be = le.useState(!1), Ie = Be[0], Qe = Be[1], xe = le.useState({}), Se = xe[0], De = xe[1], Ue = le.useState({
    start: !1,
    end: !1
  }), Te = Ue[0], se = Ue[1], fe = le.useState({
    overflow: "hidden",
    marginBottom: null
  }), W = fe[0], ge = fe[1], _e = /* @__PURE__ */ new Map(), Re = le.useRef(null), Ee = le.useRef(null), oe = function() {
    var lt = Re.current, Ht;
    if (lt) {
      var vt = lt.getBoundingClientRect();
      Ht = {
        clientWidth: lt.clientWidth,
        scrollLeft: lt.scrollLeft,
        scrollTop: lt.scrollTop,
        scrollLeftNormalized: FCe(lt, K.direction),
        scrollWidth: lt.scrollWidth,
        top: vt.top,
        bottom: vt.bottom,
        left: vt.left,
        right: vt.right
      };
    }
    var It;
    if (lt && k !== !1) {
      var un = Ee.current.children;
      if (un.length > 0) {
        var hn = un[_e.get(k)];
        It = hn ? hn.getBoundingClientRect() : null;
      }
    }
    return {
      tabsMeta: Ht,
      tabMeta: It
    };
  }, ie = Ua(function() {
    var jt, lt = oe(), Ht = lt.tabsMeta, vt = lt.tabMeta, It = 0;
    if (vt && Ht)
      if (V)
        It = vt.top - Ht.top + Ht.scrollTop;
      else {
        var un = Y ? Ht.scrollLeftNormalized + Ht.clientWidth - Ht.scrollWidth : Ht.scrollLeft;
        It = vt.left - Ht.left + un;
      }
    var hn = (jt = {}, mo(jt, ce, It), mo(jt, Ce, vt ? vt[Ce] : 0), jt);
    if (isNaN(Se[ce]) || isNaN(Se[Ce]))
      De(hn);
    else {
      var We = Math.abs(Se[ce] - hn[ce]), En = Math.abs(Se[Ce] - hn[Ce]);
      (We >= 1 || En >= 1) && De(hn);
    }
  }), Ae = function(lt) {
    aEt(Z, Re.current, lt);
  }, de = function(lt) {
    var Ht = Re.current[Z];
    V ? Ht += lt : (Ht += lt * (Y ? -1 : 1), Ht *= Y && _Ge() === "reverse" ? -1 : 1), Ae(Ht);
  }, we = function() {
    de(-Re.current[pe]);
  }, Pe = function() {
    de(Re.current[pe]);
  }, qe = le.useCallback(function(jt) {
    ge({
      overflow: null,
      marginBottom: -jt
    });
  }, []), ke = function() {
    var lt = {};
    lt.scrollbarSizeListener = z ? /* @__PURE__ */ le.createElement(lEt, {
      className: l.scrollable,
      onChange: qe
    }) : null;
    var Ht = Te.start || Te.end, vt = z && (Q === "auto" && Ht || Q === "desktop" || Q === "on");
    return lt.scrollButtonStart = vt ? /* @__PURE__ */ le.createElement(v, at({
      orientation: C,
      direction: Y ? "right" : "left",
      onClick: we,
      disabled: !Te.start,
      className: Xt(l.scrollButtons, Q !== "on" && l.scrollButtonsDesktop)
    }, O)) : null, lt.scrollButtonEnd = vt ? /* @__PURE__ */ le.createElement(v, at({
      orientation: C,
      direction: Y ? "left" : "right",
      onClick: Pe,
      disabled: !Te.end,
      className: Xt(l.scrollButtons, Q !== "on" && l.scrollButtonsDesktop)
    }, O)) : null, lt;
  }, Xe = Ua(function() {
    var jt = oe(), lt = jt.tabsMeta, Ht = jt.tabMeta;
    if (!(!Ht || !lt)) {
      if (Ht[ce] < lt[ce]) {
        var vt = lt[Z] + (Ht[ce] - lt[ce]);
        Ae(vt);
      } else if (Ht[ee] > lt[ee]) {
        var It = lt[Z] + (Ht[ee] - lt[ee]);
        Ae(It);
      }
    }
  }), rt = Ua(function() {
    if (z && Q !== "off") {
      var jt = Re.current, lt = jt.scrollTop, Ht = jt.scrollHeight, vt = jt.clientHeight, It = jt.scrollWidth, un = jt.clientWidth, hn, We;
      if (V)
        hn = lt > 1, We = lt < Ht - vt - 1;
      else {
        var En = FCe(Re.current, K.direction);
        hn = Y ? En < It - un - 1 : En > 1, We = Y ? En > 1 : En < It - un - 1;
      }
      (hn !== Te.start || We !== Te.end) && se({
        start: hn,
        end: We
      });
    }
  });
  le.useEffect(function() {
    var jt = aT(function() {
      ie(), rt();
    }), lt = wse(Re.current);
    return lt.addEventListener("resize", jt), function() {
      jt.clear(), lt.removeEventListener("resize", jt);
    };
  }, [ie, rt]);
  var it = le.useCallback(aT(function() {
    rt();
  }));
  le.useEffect(function() {
    return function() {
      it.clear();
    };
  }, [it]), le.useEffect(function() {
    Qe(!0);
  }, []), le.useEffect(function() {
    ie(), rt();
  }), le.useEffect(function() {
    Xe();
  }, [Xe, Se]), le.useImperativeHandle(o, function() {
    return {
      updateIndicator: ie,
      updateScrollButtons: rt
    };
  }, [ie, rt]);
  var ht = /* @__PURE__ */ le.createElement(fEt, at({
    className: l.indicator,
    orientation: C,
    color: d
  }, M, {
    style: at({}, Se, M.style)
  })), mt = 0, _t = le.Children.map(A, function(jt) {
    if (!/* @__PURE__ */ le.isValidElement(jt))
      return null;
    var lt = jt.props.value === void 0 ? mt : jt.props.value;
    _e.set(lt, mt);
    var Ht = lt === k;
    return mt += 1, /* @__PURE__ */ le.cloneElement(jt, {
      fullWidth: U === "fullWidth",
      indicator: Ht && !Ie && ht,
      selected: Ht,
      selectionFollowsFocus: w,
      onChange: I,
      textColor: N,
      value: lt
    });
  }), Ct = function(lt) {
    var Ht = lt.target, vt = Ht.getAttribute("role");
    if (vt === "tab") {
      var It = null, un = C !== "vertical" ? "ArrowLeft" : "ArrowUp", hn = C !== "vertical" ? "ArrowRight" : "ArrowDown";
      switch (C !== "vertical" && K.direction === "rtl" && (un = "ArrowRight", hn = "ArrowLeft"), lt.key) {
        case un:
          It = Ht.previousElementSibling || Ee.current.lastChild;
          break;
        case hn:
          It = Ht.nextElementSibling || Ee.current.firstChild;
          break;
        case "Home":
          It = Ee.current.firstChild;
          break;
        case "End":
          It = Ee.current.lastChild;
          break;
      }
      It !== null && (It.focus(), lt.preventDefault());
    }
  }, zt = ke();
  return /* @__PURE__ */ le.createElement(f, at({
    className: Xt(l.root, c, V && l.vertical),
    ref: n
  }, X), zt.scrollButtonStart, zt.scrollbarSizeListener, /* @__PURE__ */ le.createElement("div", {
    className: Xt(l.scroller, z ? l.scrollable : l.fixed),
    style: W,
    ref: Re,
    onScroll: it
  }, /* @__PURE__ */ le.createElement("div", {
    "aria-label": r,
    "aria-labelledby": i,
    className: Xt(l.flexContainer, V && l.flexContainerVertical, a && !z && l.centered),
    onKeyDown: Ct,
    ref: Ee,
    role: "tablist"
  }, _t), Ie && ht), zt.scrollButtonEnd);
});
const EEt = Lr(mEt, {
  name: "MuiTabs"
})(CEt);
var yEt = {
  standard: Ose,
  filled: Jke,
  outlined: sGe
}, vEt = {
  /* Styles applied to the root element. */
  root: {}
}, BEt = /* @__PURE__ */ le.forwardRef(function(e, n) {
  var r = e.autoComplete, i = e.autoFocus, o = i === void 0 ? !1 : i, s = e.children, a = e.classes, A = e.className, l = e.color, c = l === void 0 ? "primary" : l, u = e.defaultValue, f = e.disabled, h = f === void 0 ? !1 : f, d = e.error, I = d === void 0 ? !1 : d, m = e.FormHelperTextProps, C = e.fullWidth, y = C === void 0 ? !1 : C, v = e.helperText, b = e.hiddenLabel, Q = e.id, w = e.InputLabelProps, R = e.inputProps, M = e.InputProps, O = e.inputRef, L = e.label, N = e.multiline, k = N === void 0 ? !1 : N, $ = e.name, U = e.onBlur, X = e.onChange, K = e.onFocus, z = e.placeholder, Y = e.required, V = Y === void 0 ? !1 : Y, Z = e.rows, ce = e.rowsMax, ee = e.maxRows, pe = e.minRows, Ce = e.select, Be = Ce === void 0 ? !1 : Ce, Ie = e.SelectProps, Qe = e.type, xe = e.value, Se = e.variant, De = Se === void 0 ? "standard" : Se, Ue = Rn(e, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "maxRows", "minRows", "select", "SelectProps", "type", "value", "variant"]), Te = {};
  if (De === "outlined" && (w && typeof w.shrink < "u" && (Te.notched = w.shrink), L)) {
    var se, fe = (se = w?.required) !== null && se !== void 0 ? se : V;
    Te.label = /* @__PURE__ */ le.createElement(le.Fragment, null, L, fe && " *");
  }
  Be && ((!Ie || !Ie.native) && (Te.id = void 0), Te["aria-describedby"] = void 0);
  var W = v && Q ? "".concat(Q, "-helper-text") : void 0, ge = L && Q ? "".concat(Q, "-label") : void 0, _e = yEt[De], Re = /* @__PURE__ */ le.createElement(_e, at({
    "aria-describedby": W,
    autoComplete: r,
    autoFocus: o,
    defaultValue: u,
    fullWidth: y,
    multiline: k,
    name: $,
    rows: Z,
    rowsMax: ce,
    maxRows: ee,
    minRows: pe,
    type: Qe,
    value: xe,
    id: Q,
    inputRef: O,
    onBlur: U,
    onChange: X,
    onFocus: K,
    placeholder: z,
    inputProps: R
  }, Te, M));
  return /* @__PURE__ */ le.createElement(Kke, at({
    className: Xt(a.root, A),
    disabled: h,
    error: I,
    fullWidth: y,
    hiddenLabel: b,
    ref: n,
    required: V,
    color: c,
    variant: De
  }, Ue), L && /* @__PURE__ */ le.createElement(EH, at({
    htmlFor: Q,
    id: ge
  }, w), L), Be ? /* @__PURE__ */ le.createElement(il, at({
    "aria-describedby": W,
    id: Q,
    labelId: ge,
    value: xe,
    input: Re
  }, Ie), s) : Re, v && /* @__PURE__ */ le.createElement(YIt, at({
    id: W
  }, m), v));
});
const SGe = Lr(vEt, {
  name: "MuiTextField"
})(BEt);
class ZQ {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    const n = {
      listener: e
    };
    return this.listeners.add(n), this.onSubscribe(), () => {
      this.listeners.delete(n), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const AT = typeof window > "u" || "Deno" in window;
function ug() {
}
function bEt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function rZ(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function PCe(t, e) {
  return t.filter((n) => !e.includes(n));
}
function _Et(t, e, n) {
  const r = t.slice(0);
  return r[e] = n, r;
}
function QGe(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function hR(t, e, n) {
  return vH(t) ? typeof e == "function" ? {
    ...n,
    queryKey: t,
    queryFn: e
  } : {
    ...e,
    queryKey: t
  } : t;
}
function jm(t, e, n) {
  return vH(t) ? [{
    ...e,
    queryKey: t
  }, n] : [t || {}, e];
}
function kCe(t, e) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: i,
    predicate: o,
    queryKey: s,
    stale: a
  } = t;
  if (vH(s)) {
    if (r) {
      if (e.queryHash !== $se(s, e.options))
        return !1;
    } else if (!b4(e.queryKey, s))
      return !1;
  }
  if (n !== "all") {
    const A = e.isActive();
    if (n === "active" && !A || n === "inactive" && A)
      return !1;
  }
  return !(typeof a == "boolean" && e.isStale() !== a || typeof i < "u" && i !== e.state.fetchStatus || o && !o(e));
}
function GCe(t, e) {
  const {
    exact: n,
    fetching: r,
    predicate: i,
    mutationKey: o
  } = t;
  if (vH(o)) {
    if (!e.options.mutationKey)
      return !1;
    if (n) {
      if (iv(e.options.mutationKey) !== iv(o))
        return !1;
    } else if (!b4(e.options.mutationKey, o))
      return !1;
  }
  return !(typeof r == "boolean" && e.state.status === "loading" !== r || i && !i(e));
}
function $se(t, e) {
  return (e?.queryKeyHashFn || iv)(t);
}
function iv(t) {
  return JSON.stringify(t, (e, n) => iZ(n) ? Object.keys(n).sort().reduce((r, i) => (r[i] = n[i], r), {}) : n);
}
function b4(t, e) {
  return wGe(t, e);
}
function wGe(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((n) => !wGe(t[n], e[n])) : !1;
}
function xGe(t, e) {
  if (t === e)
    return t;
  const n = HCe(t) && HCe(e);
  if (n || iZ(t) && iZ(e)) {
    const r = n ? t.length : Object.keys(t).length, i = n ? e : Object.keys(e), o = i.length, s = n ? [] : {};
    let a = 0;
    for (let A = 0; A < o; A++) {
      const l = n ? A : i[A];
      s[l] = xGe(t[l], e[l]), s[l] === t[l] && a++;
    }
    return r === o && a === r ? t : s;
  }
  return e;
}
function UCe(t, e) {
  if (t && !e || e && !t)
    return !1;
  for (const n in t)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function HCe(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function iZ(t) {
  if (!$Ce(t))
    return !1;
  const e = t.constructor;
  if (typeof e > "u")
    return !0;
  const n = e.prototype;
  return !(!$Ce(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function $Ce(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function vH(t) {
  return Array.isArray(t);
}
function RGe(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function qCe(t) {
  RGe(0).then(t);
}
function SEt() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function oZ(t, e, n) {
  return n.isDataEqual != null && n.isDataEqual(t, e) ? t : typeof n.structuralSharing == "function" ? n.structuralSharing(t, e) : n.structuralSharing !== !1 ? xGe(t, e) : e;
}
class QEt extends ZQ {
  constructor() {
    super(), this.setup = (e) => {
      if (!AT && window.addEventListener) {
        const n = () => e();
        return window.addEventListener("visibilitychange", n, !1), window.addEventListener("focus", n, !1), () => {
          window.removeEventListener("visibilitychange", n), window.removeEventListener("focus", n);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var n;
    this.setup = e, (n = this.cleanup) == null || n.call(this), this.cleanup = e((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    });
  }
  setFocused(e) {
    this.focused = e, e && this.onFocus();
  }
  onFocus() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const _4 = new QEt(), jCe = ["online", "offline"];
class wEt extends ZQ {
  constructor() {
    super(), this.setup = (e) => {
      if (!AT && window.addEventListener) {
        const n = () => e();
        return jCe.forEach((r) => {
          window.addEventListener(r, n, !1);
        }), () => {
          jCe.forEach((r) => {
            window.removeEventListener(r, n);
          });
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var n;
    this.setup = e, (n = this.cleanup) == null || n.call(this), this.cleanup = e((r) => {
      typeof r == "boolean" ? this.setOnline(r) : this.onOnline();
    });
  }
  setOnline(e) {
    this.online = e, e && this.onOnline();
  }
  onOnline() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const S4 = new wEt();
function xEt(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function BH(t) {
  return (t ?? "online") === "online" ? S4.isOnline() : !0;
}
class DGe {
  constructor(e) {
    this.revert = e?.revert, this.silent = e?.silent;
  }
}
function ck(t) {
  return t instanceof DGe;
}
function TGe(t) {
  let e = !1, n = 0, r = !1, i, o, s;
  const a = new Promise((m, C) => {
    o = m, s = C;
  }), A = (m) => {
    r || (h(new DGe(m)), t.abort == null || t.abort());
  }, l = () => {
    e = !0;
  }, c = () => {
    e = !1;
  }, u = () => !_4.isFocused() || t.networkMode !== "always" && !S4.isOnline(), f = (m) => {
    r || (r = !0, t.onSuccess == null || t.onSuccess(m), i?.(), o(m));
  }, h = (m) => {
    r || (r = !0, t.onError == null || t.onError(m), i?.(), s(m));
  }, d = () => new Promise((m) => {
    i = (C) => {
      const y = r || !u();
      return y && m(C), y;
    }, t.onPause == null || t.onPause();
  }).then(() => {
    i = void 0, r || t.onContinue == null || t.onContinue();
  }), I = () => {
    if (r)
      return;
    let m;
    try {
      m = t.fn();
    } catch (C) {
      m = Promise.reject(C);
    }
    Promise.resolve(m).then(f).catch((C) => {
      var y, v;
      if (r)
        return;
      const b = (y = t.retry) != null ? y : 3, Q = (v = t.retryDelay) != null ? v : xEt, w = typeof Q == "function" ? Q(n, C) : Q, R = b === !0 || typeof b == "number" && n < b || typeof b == "function" && b(n, C);
      if (e || !R) {
        h(C);
        return;
      }
      n++, t.onFail == null || t.onFail(n, C), RGe(w).then(() => {
        if (u())
          return d();
      }).then(() => {
        e ? h(C) : I();
      });
    });
  };
  return BH(t.networkMode) ? I() : d().then(I), {
    promise: a,
    cancel: A,
    continue: () => i?.() ? a : Promise.resolve(),
    cancelRetry: l,
    continueRetry: c
  };
}
const qse = console;
function REt() {
  let t = [], e = 0, n = (c) => {
    c();
  }, r = (c) => {
    c();
  };
  const i = (c) => {
    let u;
    e++;
    try {
      u = c();
    } finally {
      e--, e || a();
    }
    return u;
  }, o = (c) => {
    e ? t.push(c) : qCe(() => {
      n(c);
    });
  }, s = (c) => (...u) => {
    o(() => {
      c(...u);
    });
  }, a = () => {
    const c = t;
    t = [], c.length && qCe(() => {
      r(() => {
        c.forEach((u) => {
          n(u);
        });
      });
    });
  };
  return {
    batch: i,
    batchCalls: s,
    schedule: o,
    setNotifyFunction: (c) => {
      n = c;
    },
    setBatchNotifyFunction: (c) => {
      r = c;
    }
  };
}
const Ks = REt();
class NGe {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), rZ(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(e) {
    this.cacheTime = Math.max(this.cacheTime || 0, e ?? (AT ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
let DEt = class extends NGe {
  constructor(e) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.cache = e.cache, this.logger = e.logger || qse, this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.initialState = e.state || TEt(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(e, n) {
    const r = oZ(this.state.data, e, this.options);
    return this.dispatch({
      data: r,
      type: "success",
      dataUpdatedAt: n?.updatedAt,
      manual: n?.manual
    }), r;
  }
  setState(e, n) {
    this.dispatch({
      type: "setState",
      state: e,
      setStateOptions: n
    });
  }
  cancel(e) {
    var n;
    const r = this.promise;
    return (n = this.retryer) == null || n.cancel(e), r ? r.then(ug).catch(ug) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((e) => e.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((e) => e.getCurrentResult().isStale);
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !QGe(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var e;
    const n = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    n && n.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  onOnline() {
    var e;
    const n = this.observers.find((r) => r.shouldFetchOnReconnect());
    n && n.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((n) => n !== e), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: e
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(e, n) {
    var r, i;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && n != null && n.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var o;
        return (o = this.retryer) == null || o.continueRetry(), this.promise;
      }
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const h = this.observers.find((d) => d.options.queryFn);
      h && this.setOptions(h.options);
    }
    Array.isArray(this.options.queryKey);
    const s = SEt(), a = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, A = (h) => {
      Object.defineProperty(h, "signal", {
        enumerable: !0,
        get: () => {
          if (s)
            return this.abortSignalConsumed = !0, s.signal;
        }
      });
    };
    A(a);
    const l = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(a)) : Promise.reject("Missing queryFn"), c = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: l
    };
    if (A(c), (r = this.options.behavior) == null || r.onFetch(c), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((i = c.fetchOptions) == null ? void 0 : i.meta)) {
      var u;
      this.dispatch({
        type: "fetch",
        meta: (u = c.fetchOptions) == null ? void 0 : u.meta
      });
    }
    const f = (h) => {
      if (ck(h) && h.silent || this.dispatch({
        type: "error",
        error: h
      }), !ck(h)) {
        var d, I, m, C;
        (d = (I = this.cache.config).onError) == null || d.call(I, h, this), (m = (C = this.cache.config).onSettled) == null || m.call(C, this.state.data, h, this);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = TGe({
      fn: c.fetchFn,
      abort: s?.abort.bind(s),
      onSuccess: (h) => {
        var d, I, m, C;
        if (typeof h > "u") {
          f(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(h), (d = (I = this.cache.config).onSuccess) == null || d.call(I, h, this), (m = (C = this.cache.config).onSettled) == null || m.call(C, h, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: f,
      onFail: (h, d) => {
        this.dispatch({
          type: "failed",
          failureCount: h,
          error: d
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: c.options.retry,
      retryDelay: c.options.retryDelay,
      networkMode: c.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(e) {
    const n = (r) => {
      var i, o;
      switch (e.type) {
        case "failed":
          return {
            ...r,
            fetchFailureCount: e.failureCount,
            fetchFailureReason: e.error
          };
        case "pause":
          return {
            ...r,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...r,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...r,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (i = e.meta) != null ? i : null,
            fetchStatus: BH(this.options.networkMode) ? "fetching" : "paused",
            ...!r.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...r,
            data: e.data,
            dataUpdateCount: r.dataUpdateCount + 1,
            dataUpdatedAt: (o = e.dataUpdatedAt) != null ? o : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!e.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const s = e.error;
          return ck(s) && s.revert && this.revertState ? {
            ...this.revertState
          } : {
            ...r,
            error: s,
            errorUpdateCount: r.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: r.fetchFailureCount + 1,
            fetchFailureReason: s,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...r,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...r,
            ...e.state
          };
      }
    };
    this.state = n(this.state), Ks.batch(() => {
      this.observers.forEach((r) => {
        r.onQueryUpdate(e);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: e
      });
    });
  }
};
function TEt(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, n = typeof e < "u", r = n ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class NEt extends ZQ {
  constructor(e) {
    super(), this.config = e || {}, this.queries = [], this.queriesMap = {};
  }
  build(e, n, r) {
    var i;
    const o = n.queryKey, s = (i = n.queryHash) != null ? i : $se(o, n);
    let a = this.get(s);
    return a || (a = new DEt({
      cache: this,
      logger: e.getLogger(),
      queryKey: o,
      queryHash: s,
      options: e.defaultQueryOptions(n),
      state: r,
      defaultOptions: e.getQueryDefaults(o)
    }), this.add(a)), a;
  }
  add(e) {
    this.queriesMap[e.queryHash] || (this.queriesMap[e.queryHash] = e, this.queries.push(e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const n = this.queriesMap[e.queryHash];
    n && (e.destroy(), this.queries = this.queries.filter((r) => r !== e), n === e && delete this.queriesMap[e.queryHash], this.notify({
      type: "removed",
      query: e
    }));
  }
  clear() {
    Ks.batch(() => {
      this.queries.forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.queriesMap[e];
  }
  getAll() {
    return this.queries;
  }
  find(e, n) {
    const [r] = jm(e, n);
    return typeof r.exact > "u" && (r.exact = !0), this.queries.find((i) => kCe(r, i));
  }
  findAll(e, n) {
    const [r] = jm(e, n);
    return Object.keys(r).length > 0 ? this.queries.filter((i) => kCe(r, i)) : this.queries;
  }
  notify(e) {
    Ks.batch(() => {
      this.listeners.forEach(({
        listener: n
      }) => {
        n(e);
      });
    });
  }
  onFocus() {
    Ks.batch(() => {
      this.queries.forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    Ks.batch(() => {
      this.queries.forEach((e) => {
        e.onOnline();
      });
    });
  }
}
class LEt extends NGe {
  constructor(e) {
    super(), this.defaultOptions = e.defaultOptions, this.mutationId = e.mutationId, this.mutationCache = e.mutationCache, this.logger = e.logger || qse, this.observers = [], this.state = e.state || MEt(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(e) {
    this.dispatch({
      type: "setState",
      state: e
    });
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers = this.observers.filter((n) => n !== e), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var e, n;
    return (e = (n = this.retryer) == null ? void 0 : n.continue()) != null ? e : this.execute();
  }
  async execute() {
    const e = () => {
      var R;
      return this.retryer = TGe({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (M, O) => {
          this.dispatch({
            type: "failed",
            failureCount: M,
            error: O
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (R = this.options.retry) != null ? R : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, n = this.state.status === "loading";
    try {
      var r, i, o, s, a, A, l, c;
      if (!n) {
        var u, f, h, d;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((u = (f = this.mutationCache.config).onMutate) == null ? void 0 : u.call(f, this.state.variables, this));
        const M = await ((h = (d = this.options).onMutate) == null ? void 0 : h.call(d, this.state.variables));
        M !== this.state.context && this.dispatch({
          type: "loading",
          context: M,
          variables: this.state.variables
        });
      }
      const R = await e();
      return await ((r = (i = this.mutationCache.config).onSuccess) == null ? void 0 : r.call(i, R, this.state.variables, this.state.context, this)), await ((o = (s = this.options).onSuccess) == null ? void 0 : o.call(s, R, this.state.variables, this.state.context)), await ((a = (A = this.mutationCache.config).onSettled) == null ? void 0 : a.call(A, R, null, this.state.variables, this.state.context, this)), await ((l = (c = this.options).onSettled) == null ? void 0 : l.call(c, R, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: R
      }), R;
    } catch (R) {
      try {
        var I, m, C, y, v, b, Q, w;
        throw await ((I = (m = this.mutationCache.config).onError) == null ? void 0 : I.call(m, R, this.state.variables, this.state.context, this)), await ((C = (y = this.options).onError) == null ? void 0 : C.call(y, R, this.state.variables, this.state.context)), await ((v = (b = this.mutationCache.config).onSettled) == null ? void 0 : v.call(b, void 0, R, this.state.variables, this.state.context, this)), await ((Q = (w = this.options).onSettled) == null ? void 0 : Q.call(w, void 0, R, this.state.variables, this.state.context)), R;
      } finally {
        this.dispatch({
          type: "error",
          error: R
        });
      }
    }
  }
  dispatch(e) {
    const n = (r) => {
      switch (e.type) {
        case "failed":
          return {
            ...r,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case "pause":
          return {
            ...r,
            isPaused: !0
          };
        case "continue":
          return {
            ...r,
            isPaused: !1
          };
        case "loading":
          return {
            ...r,
            context: e.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !BH(this.options.networkMode),
            status: "loading",
            variables: e.variables
          };
        case "success":
          return {
            ...r,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...r,
            data: void 0,
            error: e.error,
            failureCount: r.failureCount + 1,
            failureReason: e.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...r,
            ...e.state
          };
      }
    };
    this.state = n(this.state), Ks.batch(() => {
      this.observers.forEach((r) => {
        r.onMutationUpdate(e);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: e
      });
    });
  }
}
function MEt() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class OEt extends ZQ {
  constructor(e) {
    super(), this.config = e || {}, this.mutations = [], this.mutationId = 0;
  }
  build(e, n, r) {
    const i = new LEt({
      mutationCache: this,
      logger: e.getLogger(),
      mutationId: ++this.mutationId,
      options: e.defaultMutationOptions(n),
      state: r,
      defaultOptions: n.mutationKey ? e.getMutationDefaults(n.mutationKey) : void 0
    });
    return this.add(i), i;
  }
  add(e) {
    this.mutations.push(e), this.notify({
      type: "added",
      mutation: e
    });
  }
  remove(e) {
    this.mutations = this.mutations.filter((n) => n !== e), this.notify({
      type: "removed",
      mutation: e
    });
  }
  clear() {
    Ks.batch(() => {
      this.mutations.forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(e) {
    return typeof e.exact > "u" && (e.exact = !0), this.mutations.find((n) => GCe(e, n));
  }
  findAll(e) {
    return this.mutations.filter((n) => GCe(e, n));
  }
  notify(e) {
    Ks.batch(() => {
      this.listeners.forEach(({
        listener: n
      }) => {
        n(e);
      });
    });
  }
  resumePausedMutations() {
    var e;
    return this.resuming = ((e = this.resuming) != null ? e : Promise.resolve()).then(() => {
      const n = this.mutations.filter((r) => r.state.isPaused);
      return Ks.batch(() => n.reduce((r, i) => r.then(() => i.continue().catch(ug)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function FEt() {
  return {
    onFetch: (t) => {
      t.fetchFn = () => {
        var e, n, r, i, o, s;
        const a = (e = t.fetchOptions) == null || (n = e.meta) == null ? void 0 : n.refetchPage, A = (r = t.fetchOptions) == null || (i = r.meta) == null ? void 0 : i.fetchMore, l = A?.pageParam, c = A?.direction === "forward", u = A?.direction === "backward", f = ((o = t.state.data) == null ? void 0 : o.pages) || [], h = ((s = t.state.data) == null ? void 0 : s.pageParams) || [];
        let d = h, I = !1;
        const m = (w) => {
          Object.defineProperty(w, "signal", {
            enumerable: !0,
            get: () => {
              var R;
              if ((R = t.signal) != null && R.aborted)
                I = !0;
              else {
                var M;
                (M = t.signal) == null || M.addEventListener("abort", () => {
                  I = !0;
                });
              }
              return t.signal;
            }
          });
        }, C = t.options.queryFn || (() => Promise.reject("Missing queryFn")), y = (w, R, M, O) => (d = O ? [R, ...d] : [...d, R], O ? [M, ...w] : [...w, M]), v = (w, R, M, O) => {
          if (I)
            return Promise.reject("Cancelled");
          if (typeof M > "u" && !R && w.length)
            return Promise.resolve(w);
          const L = {
            queryKey: t.queryKey,
            pageParam: M,
            meta: t.options.meta
          };
          m(L);
          const N = C(L);
          return Promise.resolve(N).then(($) => y(w, M, $, O));
        };
        let b;
        if (!f.length)
          b = v([]);
        else if (c) {
          const w = typeof l < "u", R = w ? l : YCe(t.options, f);
          b = v(f, w, R);
        } else if (u) {
          const w = typeof l < "u", R = w ? l : PEt(t.options, f);
          b = v(f, w, R, !0);
        } else {
          d = [];
          const w = typeof t.options.getNextPageParam > "u";
          b = (a && f[0] ? a(f[0], 0, f) : !0) ? v([], w, h[0]) : Promise.resolve(y([], h[0], f[0]));
          for (let M = 1; M < f.length; M++)
            b = b.then((O) => {
              if (a && f[M] ? a(f[M], M, f) : !0) {
                const N = w ? h[M] : YCe(t.options, O);
                return v(O, w, N);
              }
              return Promise.resolve(y(O, h[M], f[M]));
            });
        }
        return b.then((w) => ({
          pages: w,
          pageParams: d
        }));
      };
    }
  };
}
function YCe(t, e) {
  return t.getNextPageParam == null ? void 0 : t.getNextPageParam(e[e.length - 1], e);
}
function PEt(t, e) {
  return t.getPreviousPageParam == null ? void 0 : t.getPreviousPageParam(e[0], e);
}
class kEt {
  constructor(e = {}) {
    this.queryCache = e.queryCache || new NEt(), this.mutationCache = e.mutationCache || new OEt(), this.logger = e.logger || qse, this.defaultOptions = e.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0;
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = _4.subscribe(() => {
      _4.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = S4.subscribe(() => {
      S4.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var e, n;
    this.mountCount--, this.mountCount === 0 && ((e = this.unsubscribeFocus) == null || e.call(this), this.unsubscribeFocus = void 0, (n = this.unsubscribeOnline) == null || n.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(e, n) {
    const [r] = jm(e, n);
    return r.fetchStatus = "fetching", this.queryCache.findAll(r).length;
  }
  isMutating(e) {
    return this.mutationCache.findAll({
      ...e,
      fetching: !0
    }).length;
  }
  getQueryData(e, n) {
    var r;
    return (r = this.queryCache.find(e, n)) == null ? void 0 : r.state.data;
  }
  ensureQueryData(e, n, r) {
    const i = hR(e, n, r), o = this.getQueryData(i.queryKey);
    return o ? Promise.resolve(o) : this.fetchQuery(i);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({
      queryKey: n,
      state: r
    }) => {
      const i = r.data;
      return [n, i];
    });
  }
  setQueryData(e, n, r) {
    const i = this.queryCache.find(e), o = i?.state.data, s = bEt(n, o);
    if (typeof s > "u")
      return;
    const a = hR(e), A = this.defaultQueryOptions(a);
    return this.queryCache.build(this, A).setData(s, {
      ...r,
      manual: !0
    });
  }
  setQueriesData(e, n, r) {
    return Ks.batch(() => this.getQueryCache().findAll(e).map(({
      queryKey: i
    }) => [i, this.setQueryData(i, n, r)]));
  }
  getQueryState(e, n) {
    var r;
    return (r = this.queryCache.find(e, n)) == null ? void 0 : r.state;
  }
  removeQueries(e, n) {
    const [r] = jm(e, n), i = this.queryCache;
    Ks.batch(() => {
      i.findAll(r).forEach((o) => {
        i.remove(o);
      });
    });
  }
  resetQueries(e, n, r) {
    const [i, o] = jm(e, n, r), s = this.queryCache, a = {
      type: "active",
      ...i
    };
    return Ks.batch(() => (s.findAll(i).forEach((A) => {
      A.reset();
    }), this.refetchQueries(a, o)));
  }
  cancelQueries(e, n, r) {
    const [i, o = {}] = jm(e, n, r);
    typeof o.revert > "u" && (o.revert = !0);
    const s = Ks.batch(() => this.queryCache.findAll(i).map((a) => a.cancel(o)));
    return Promise.all(s).then(ug).catch(ug);
  }
  invalidateQueries(e, n, r) {
    const [i, o] = jm(e, n, r);
    return Ks.batch(() => {
      var s, a;
      if (this.queryCache.findAll(i).forEach((l) => {
        l.invalidate();
      }), i.refetchType === "none")
        return Promise.resolve();
      const A = {
        ...i,
        type: (s = (a = i.refetchType) != null ? a : i.type) != null ? s : "active"
      };
      return this.refetchQueries(A, o);
    });
  }
  refetchQueries(e, n, r) {
    const [i, o] = jm(e, n, r), s = Ks.batch(() => this.queryCache.findAll(i).filter((A) => !A.isDisabled()).map((A) => {
      var l;
      return A.fetch(void 0, {
        ...o,
        cancelRefetch: (l = o?.cancelRefetch) != null ? l : !0,
        meta: {
          refetchPage: i.refetchPage
        }
      });
    }));
    let a = Promise.all(s).then(ug);
    return o != null && o.throwOnError || (a = a.catch(ug)), a;
  }
  fetchQuery(e, n, r) {
    const i = hR(e, n, r), o = this.defaultQueryOptions(i);
    typeof o.retry > "u" && (o.retry = !1);
    const s = this.queryCache.build(this, o);
    return s.isStaleByTime(o.staleTime) ? s.fetch(o) : Promise.resolve(s.state.data);
  }
  prefetchQuery(e, n, r) {
    return this.fetchQuery(e, n, r).then(ug).catch(ug);
  }
  fetchInfiniteQuery(e, n, r) {
    const i = hR(e, n, r);
    return i.behavior = FEt(), this.fetchQuery(i);
  }
  prefetchInfiniteQuery(e, n, r) {
    return this.fetchInfiniteQuery(e, n, r).then(ug).catch(ug);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(e) {
    this.defaultOptions = e;
  }
  setQueryDefaults(e, n) {
    const r = this.queryDefaults.find((i) => iv(e) === iv(i.queryKey));
    r ? r.defaultOptions = n : this.queryDefaults.push({
      queryKey: e,
      defaultOptions: n
    });
  }
  getQueryDefaults(e) {
    if (!e)
      return;
    const n = this.queryDefaults.find((r) => b4(e, r.queryKey));
    return n?.defaultOptions;
  }
  setMutationDefaults(e, n) {
    const r = this.mutationDefaults.find((i) => iv(e) === iv(i.mutationKey));
    r ? r.defaultOptions = n : this.mutationDefaults.push({
      mutationKey: e,
      defaultOptions: n
    });
  }
  getMutationDefaults(e) {
    if (!e)
      return;
    const n = this.mutationDefaults.find((r) => b4(e, r.mutationKey));
    return n?.defaultOptions;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const n = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(e?.queryKey),
      ...e,
      _defaulted: !0
    };
    return !n.queryHash && n.queryKey && (n.queryHash = $se(n.queryKey, n)), typeof n.refetchOnReconnect > "u" && (n.refetchOnReconnect = n.networkMode !== "always"), typeof n.useErrorBoundary > "u" && (n.useErrorBoundary = !!n.suspense), n;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(e?.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class LGe extends ZQ {
  constructor(e, n) {
    super(), this.client = e, this.options = n, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.currentQuery.addObserver(this), zCe(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return sZ(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return sZ(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(e, n) {
    const r = this.options, i = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(e), UCe(r, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = r.queryKey), this.updateQuery();
    const o = this.hasListeners();
    o && VCe(this.currentQuery, i, this.options, r) && this.executeFetch(), this.updateResult(n), o && (this.currentQuery !== i || this.options.enabled !== r.enabled || this.options.staleTime !== r.staleTime) && this.updateStaleTimeout();
    const s = this.computeRefetchInterval();
    o && (this.currentQuery !== i || this.options.enabled !== r.enabled || s !== this.currentRefetchInterval) && this.updateRefetchInterval(s);
  }
  getOptimisticResult(e) {
    const n = this.client.getQueryCache().build(this.client, e);
    return this.createResult(n, e);
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(e) {
    const n = {};
    return Object.keys(e).forEach((r) => {
      Object.defineProperty(n, r, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add(r), e[r])
      });
    }), n;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage: e,
    ...n
  } = {}) {
    return this.fetch({
      ...n,
      meta: {
        refetchPage: e
      }
    });
  }
  fetchOptimistic(e) {
    const n = this.client.defaultQueryOptions(e), r = this.client.getQueryCache().build(this.client, n);
    return r.isFetchingOptimistic = !0, r.fetch().then(() => this.createResult(r, n));
  }
  fetch(e) {
    var n;
    return this.executeFetch({
      ...e,
      cancelRefetch: (n = e.cancelRefetch) != null ? n : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(e) {
    this.updateQuery();
    let n = this.currentQuery.fetch(this.options, e);
    return e != null && e.throwOnError || (n = n.catch(ug)), n;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), AT || this.currentResult.isStale || !rZ(this.options.staleTime))
      return;
    const n = QGe(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, n);
  }
  computeRefetchInterval() {
    var e;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (e = this.options.refetchInterval) != null ? e : !1;
  }
  updateRefetchInterval(e) {
    this.clearRefetchInterval(), this.currentRefetchInterval = e, !(AT || this.options.enabled === !1 || !rZ(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || _4.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(e, n) {
    const r = this.currentQuery, i = this.options, o = this.currentResult, s = this.currentResultState, a = this.currentResultOptions, A = e !== r, l = A ? e.state : this.currentQueryInitialState, c = A ? this.currentResult : this.previousQueryResult, {
      state: u
    } = e;
    let {
      dataUpdatedAt: f,
      error: h,
      errorUpdatedAt: d,
      fetchStatus: I,
      status: m
    } = u, C = !1, y = !1, v;
    if (n._optimisticResults) {
      const M = this.hasListeners(), O = !M && zCe(e, n), L = M && VCe(e, r, n, i);
      (O || L) && (I = BH(e.options.networkMode) ? "fetching" : "paused", f || (m = "loading")), n._optimisticResults === "isRestoring" && (I = "idle");
    }
    if (n.keepPreviousData && !u.dataUpdatedAt && c != null && c.isSuccess && m !== "error")
      v = c.data, f = c.dataUpdatedAt, m = c.status, C = !0;
    else if (n.select && typeof u.data < "u")
      if (o && u.data === s?.data && n.select === this.selectFn)
        v = this.selectResult;
      else
        try {
          this.selectFn = n.select, v = n.select(u.data), v = oZ(o?.data, v, n), this.selectResult = v, this.selectError = null;
        } catch (M) {
          this.selectError = M;
        }
    else
      v = u.data;
    if (typeof n.placeholderData < "u" && typeof v > "u" && m === "loading") {
      let M;
      if (o != null && o.isPlaceholderData && n.placeholderData === a?.placeholderData)
        M = o.data;
      else if (M = typeof n.placeholderData == "function" ? n.placeholderData() : n.placeholderData, n.select && typeof M < "u")
        try {
          M = n.select(M), this.selectError = null;
        } catch (O) {
          this.selectError = O;
        }
      typeof M < "u" && (m = "success", v = oZ(o?.data, M, n), y = !0);
    }
    this.selectError && (h = this.selectError, v = this.selectResult, d = Date.now(), m = "error");
    const b = I === "fetching", Q = m === "loading", w = m === "error";
    return {
      status: m,
      fetchStatus: I,
      isLoading: Q,
      isSuccess: m === "success",
      isError: w,
      isInitialLoading: Q && b,
      data: v,
      dataUpdatedAt: f,
      error: h,
      errorUpdatedAt: d,
      failureCount: u.fetchFailureCount,
      failureReason: u.fetchFailureReason,
      errorUpdateCount: u.errorUpdateCount,
      isFetched: u.dataUpdateCount > 0 || u.errorUpdateCount > 0,
      isFetchedAfterMount: u.dataUpdateCount > l.dataUpdateCount || u.errorUpdateCount > l.errorUpdateCount,
      isFetching: b,
      isRefetching: b && !Q,
      isLoadingError: w && u.dataUpdatedAt === 0,
      isPaused: I === "paused",
      isPlaceholderData: y,
      isPreviousData: C,
      isRefetchError: w && u.dataUpdatedAt !== 0,
      isStale: jse(e, n),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(e) {
    const n = this.currentResult, r = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, UCe(r, n))
      return;
    this.currentResult = r;
    const i = {
      cache: !0
    }, o = () => {
      if (!n)
        return !0;
      const {
        notifyOnChangeProps: s
      } = this.options;
      if (s === "all" || !s && !this.trackedProps.size)
        return !0;
      const a = new Set(s ?? this.trackedProps);
      return this.options.useErrorBoundary && a.add("error"), Object.keys(this.currentResult).some((A) => {
        const l = A;
        return this.currentResult[l] !== n[l] && a.has(l);
      });
    };
    e?.listeners !== !1 && o() && (i.listeners = !0), this.notify({
      ...i,
      ...e
    });
  }
  updateQuery() {
    const e = this.client.getQueryCache().build(this.client, this.options);
    if (e === this.currentQuery)
      return;
    const n = this.currentQuery;
    this.currentQuery = e, this.currentQueryInitialState = e.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (n?.removeObserver(this), e.addObserver(this));
  }
  onQueryUpdate(e) {
    const n = {};
    e.type === "success" ? n.onSuccess = !e.manual : e.type === "error" && !ck(e.error) && (n.onError = !0), this.updateResult(n), this.hasListeners() && this.updateTimers();
  }
  notify(e) {
    Ks.batch(() => {
      if (e.onSuccess) {
        var n, r, i, o;
        (n = (r = this.options).onSuccess) == null || n.call(r, this.currentResult.data), (i = (o = this.options).onSettled) == null || i.call(o, this.currentResult.data, null);
      } else if (e.onError) {
        var s, a, A, l;
        (s = (a = this.options).onError) == null || s.call(a, this.currentResult.error), (A = (l = this.options).onSettled) == null || A.call(l, void 0, this.currentResult.error);
      }
      e.listeners && this.listeners.forEach(({
        listener: c
      }) => {
        c(this.currentResult);
      }), e.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function GEt(t, e) {
  return e.enabled !== !1 && !t.state.dataUpdatedAt && !(t.state.status === "error" && e.retryOnMount === !1);
}
function zCe(t, e) {
  return GEt(t, e) || t.state.dataUpdatedAt > 0 && sZ(t, e, e.refetchOnMount);
}
function sZ(t, e, n) {
  if (e.enabled !== !1) {
    const r = typeof n == "function" ? n(t) : n;
    return r === "always" || r !== !1 && jse(t, e);
  }
  return !1;
}
function VCe(t, e, n, r) {
  return n.enabled !== !1 && (t !== e || r.enabled === !1) && (!n.suspense || t.state.status !== "error") && jse(t, n);
}
function jse(t, e) {
  return t.isStaleByTime(e.staleTime);
}
class UEt extends ZQ {
  constructor(e, n) {
    super(), this.client = e, this.queries = [], this.result = [], this.observers = [], this.observersMap = {}, n && this.setQueries(n);
  }
  onSubscribe() {
    this.listeners.size === 1 && this.observers.forEach((e) => {
      e.subscribe((n) => {
        this.onUpdate(e, n);
      });
    });
  }
  onUnsubscribe() {
    this.listeners.size || this.destroy();
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.observers.forEach((e) => {
      e.destroy();
    });
  }
  setQueries(e, n) {
    this.queries = e, Ks.batch(() => {
      const r = this.observers, i = this.findMatchingObservers(this.queries);
      i.forEach((l) => l.observer.setOptions(l.defaultedQueryOptions, n));
      const o = i.map((l) => l.observer), s = Object.fromEntries(o.map((l) => [l.options.queryHash, l])), a = o.map((l) => l.getCurrentResult()), A = o.some((l, c) => l !== r[c]);
      r.length === o.length && !A || (this.observers = o, this.observersMap = s, this.result = a, this.hasListeners() && (PCe(r, o).forEach((l) => {
        l.destroy();
      }), PCe(o, r).forEach((l) => {
        l.subscribe((c) => {
          this.onUpdate(l, c);
        });
      }), this.notify()));
    });
  }
  getCurrentResult() {
    return this.result;
  }
  getQueries() {
    return this.observers.map((e) => e.getCurrentQuery());
  }
  getObservers() {
    return this.observers;
  }
  getOptimisticResult(e) {
    return this.findMatchingObservers(e).map((n) => n.observer.getOptimisticResult(n.defaultedQueryOptions));
  }
  findMatchingObservers(e) {
    const n = this.observers, r = new Map(n.map((h) => [h.options.queryHash, h])), i = e.map((h) => this.client.defaultQueryOptions(h)), o = i.flatMap((h) => {
      const d = r.get(h.queryHash);
      return d != null ? [{
        defaultedQueryOptions: h,
        observer: d
      }] : [];
    }), s = new Set(o.map((h) => h.defaultedQueryOptions.queryHash)), a = i.filter((h) => !s.has(h.queryHash)), A = new Set(o.map((h) => h.observer)), l = n.filter((h) => !A.has(h)), c = (h) => {
      const d = this.client.defaultQueryOptions(h), I = this.observersMap[d.queryHash];
      return I ?? new LGe(this.client, d);
    }, u = a.map((h, d) => {
      if (h.keepPreviousData) {
        const I = l[d];
        if (I !== void 0)
          return {
            defaultedQueryOptions: h,
            observer: I
          };
      }
      return {
        defaultedQueryOptions: h,
        observer: c(h)
      };
    }), f = (h, d) => i.indexOf(h.defaultedQueryOptions) - i.indexOf(d.defaultedQueryOptions);
    return o.concat(u).sort(f);
  }
  onUpdate(e, n) {
    const r = this.observers.indexOf(e);
    r !== -1 && (this.result = _Et(this.result, r, n), this.notify());
  }
  notify() {
    Ks.batch(() => {
      this.listeners.forEach(({
        listener: e
      }) => {
        e(this.result);
      });
    });
  }
}
var MGe = { exports: {} }, OGe = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wS = St;
function HEt(t, e) {
  return t === e && (t !== 0 || 1 / t === 1 / e) || t !== t && e !== e;
}
var $Et = typeof Object.is == "function" ? Object.is : HEt, qEt = wS.useState, jEt = wS.useEffect, YEt = wS.useLayoutEffect, zEt = wS.useDebugValue;
function VEt(t, e) {
  var n = e(), r = qEt({ inst: { value: n, getSnapshot: e } }), i = r[0].inst, o = r[1];
  return YEt(function() {
    i.value = n, i.getSnapshot = e, Nz(i) && o({ inst: i });
  }, [t, n, e]), jEt(function() {
    return Nz(i) && o({ inst: i }), t(function() {
      Nz(i) && o({ inst: i });
    });
  }, [t]), zEt(n), n;
}
function Nz(t) {
  var e = t.getSnapshot;
  t = t.value;
  try {
    var n = e();
    return !$Et(t, n);
  } catch {
    return !0;
  }
}
function JEt(t, e) {
  return e();
}
var KEt = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? JEt : VEt;
OGe.useSyncExternalStore = wS.useSyncExternalStore !== void 0 ? wS.useSyncExternalStore : KEt;
MGe.exports = OGe;
var WEt = MGe.exports;
const FGe = WEt.useSyncExternalStore, JCe = /* @__PURE__ */ le.createContext(void 0), PGe = /* @__PURE__ */ le.createContext(!1);
function kGe(t, e) {
  return t || (e && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = JCe), window.ReactQueryClientContext) : JCe);
}
const GGe = ({
  context: t
} = {}) => {
  const e = le.useContext(kGe(t, le.useContext(PGe)));
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, XEt = ({
  client: t,
  children: e,
  context: n,
  contextSharing: r = !1
}) => {
  le.useEffect(() => (t.mount(), () => {
    t.unmount();
  }), [t]);
  const i = kGe(n, r);
  return /* @__PURE__ */ le.createElement(PGe.Provider, {
    value: !n && r
  }, /* @__PURE__ */ le.createElement(i.Provider, {
    value: t
  }, e));
}, UGe = /* @__PURE__ */ le.createContext(!1), HGe = () => le.useContext(UGe);
UGe.Provider;
function ZEt() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t
  };
}
const eyt = /* @__PURE__ */ le.createContext(ZEt()), $Ge = () => le.useContext(eyt);
function tyt(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
const qGe = (t, e) => {
  (t.suspense || t.useErrorBoundary) && (e.isReset() || (t.retryOnMount = !1));
}, jGe = (t) => {
  le.useEffect(() => {
    t.clearReset();
  }, [t]);
}, YGe = ({
  result: t,
  errorResetBoundary: e,
  useErrorBoundary: n,
  query: r
}) => t.isError && !e.isReset() && !t.isFetching && tyt(n, [t.error, r]), zGe = (t) => {
  t.suspense && typeof t.staleTime != "number" && (t.staleTime = 1e3);
}, VGe = (t, e) => t.isLoading && t.isFetching && !e, aZ = (t, e, n) => t?.suspense && VGe(e, n), AZ = (t, e, n) => e.fetchOptimistic(t).then(({
  data: r
}) => {
  t.onSuccess == null || t.onSuccess(r), t.onSettled == null || t.onSettled(r, null);
}).catch((r) => {
  n.clearReset(), t.onError == null || t.onError(r), t.onSettled == null || t.onSettled(void 0, r);
});
function pL({
  queries: t,
  context: e
}) {
  const n = GGe({
    context: e
  }), r = HGe(), i = $Ge(), o = le.useMemo(() => t.map((f) => {
    const h = n.defaultQueryOptions(f);
    return h._optimisticResults = r ? "isRestoring" : "optimistic", h;
  }), [t, n, r]);
  o.forEach((f) => {
    zGe(f), qGe(f, i);
  }), jGe(i);
  const [s] = le.useState(() => new UEt(n, o)), a = s.getOptimisticResult(o);
  FGe(le.useCallback((f) => r ? () => {
  } : s.subscribe(Ks.batchCalls(f)), [s, r]), () => s.getCurrentResult(), () => s.getCurrentResult()), le.useEffect(() => {
    s.setQueries(o, {
      listeners: !1
    });
  }, [o, s]);
  const l = a.some((f, h) => aZ(o[h], f, r)) ? a.flatMap((f, h) => {
    const d = o[h], I = s.getObservers()[h];
    if (d && I) {
      if (aZ(d, f, r))
        return AZ(d, I, i);
      VGe(f, r) && AZ(d, I, i);
    }
    return [];
  }) : [];
  if (l.length > 0)
    throw Promise.all(l);
  const c = s.getQueries(), u = a.find((f, h) => {
    var d, I;
    return YGe({
      result: f,
      errorResetBoundary: i,
      useErrorBoundary: (d = (I = o[h]) == null ? void 0 : I.useErrorBoundary) != null ? d : !1,
      query: c[h]
    });
  });
  if (u != null && u.error)
    throw u.error;
  return a;
}
function nyt(t, e) {
  const n = GGe({
    context: t.context
  }), r = HGe(), i = $Ge(), o = n.defaultQueryOptions(t);
  o._optimisticResults = r ? "isRestoring" : "optimistic", o.onError && (o.onError = Ks.batchCalls(o.onError)), o.onSuccess && (o.onSuccess = Ks.batchCalls(o.onSuccess)), o.onSettled && (o.onSettled = Ks.batchCalls(o.onSettled)), zGe(o), qGe(o, i), jGe(i);
  const [s] = le.useState(() => new e(n, o)), a = s.getOptimisticResult(o);
  if (FGe(le.useCallback((A) => {
    const l = r ? () => {
    } : s.subscribe(Ks.batchCalls(A));
    return s.updateResult(), l;
  }, [s, r]), () => s.getCurrentResult(), () => s.getCurrentResult()), le.useEffect(() => {
    s.setOptions(o, {
      listeners: !1
    });
  }, [o, s]), aZ(o, a, r))
    throw AZ(o, s, i);
  if (YGe({
    result: a,
    errorResetBoundary: i,
    useErrorBoundary: o.useErrorBoundary,
    query: s.getCurrentQuery()
  }))
    throw a.error;
  return o.notifyOnChangeProps ? a : s.trackResult(a);
}
function Yse(t, e, n) {
  const r = hR(t, e, n);
  return nyt(r, LGe);
}
var ryt = typeof global == "object" && global && global.Object === Object && global;
const JGe = ryt;
var iyt = typeof self == "object" && self && self.Object === Object && self, oyt = JGe || iyt || Function("return this")();
const vd = oyt;
var syt = vd.Symbol;
const Fg = syt;
var KGe = Object.prototype, ayt = KGe.hasOwnProperty, Ayt = KGe.toString, Ux = Fg ? Fg.toStringTag : void 0;
function lyt(t) {
  var e = ayt.call(t, Ux), n = t[Ux];
  try {
    t[Ux] = void 0;
    var r = !0;
  } catch {
  }
  var i = Ayt.call(t);
  return r && (e ? t[Ux] = n : delete t[Ux]), i;
}
var cyt = Object.prototype, uyt = cyt.toString;
function fyt(t) {
  return uyt.call(t);
}
var gyt = "[object Null]", hyt = "[object Undefined]", KCe = Fg ? Fg.toStringTag : void 0;
function ew(t) {
  return t == null ? t === void 0 ? hyt : gyt : KCe && KCe in Object(t) ? lyt(t) : fyt(t);
}
function SI(t) {
  return t != null && typeof t == "object";
}
var dyt = "[object Symbol]";
function bH(t) {
  return typeof t == "symbol" || SI(t) && ew(t) == dyt;
}
function WGe(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = Array(r); ++n < r; )
    i[n] = e(t[n], n, t);
  return i;
}
var pyt = Array.isArray;
const Pg = pyt;
var Iyt = 1 / 0, WCe = Fg ? Fg.prototype : void 0, XCe = WCe ? WCe.toString : void 0;
function XGe(t) {
  if (typeof t == "string")
    return t;
  if (Pg(t))
    return WGe(t, XGe) + "";
  if (bH(t))
    return XCe ? XCe.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -Iyt ? "-0" : e;
}
var myt = /\s/;
function Cyt(t) {
  for (var e = t.length; e-- && myt.test(t.charAt(e)); )
    ;
  return e;
}
var Eyt = /^\s+/;
function yyt(t) {
  return t && t.slice(0, Cyt(t) + 1).replace(Eyt, "");
}
function kg(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var ZCe = 0 / 0, vyt = /^[-+]0x[0-9a-f]+$/i, Byt = /^0b[01]+$/i, byt = /^0o[0-7]+$/i, _yt = parseInt;
function T_(t) {
  if (typeof t == "number")
    return t;
  if (bH(t))
    return ZCe;
  if (kg(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = kg(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = yyt(t);
  var n = Byt.test(t);
  return n || byt.test(t) ? _yt(t.slice(2), n ? 2 : 8) : vyt.test(t) ? ZCe : +t;
}
var eEe = 1 / 0, Syt = 17976931348623157e292;
function Lz(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = T_(t), t === eEe || t === -eEe) {
    var e = t < 0 ? -1 : 1;
    return e * Syt;
  }
  return t === t ? t : 0;
}
function _H(t) {
  return t;
}
var Qyt = "[object AsyncFunction]", wyt = "[object Function]", xyt = "[object GeneratorFunction]", Ryt = "[object Proxy]";
function ZGe(t) {
  if (!kg(t))
    return !1;
  var e = ew(t);
  return e == wyt || e == xyt || e == Qyt || e == Ryt;
}
var Dyt = vd["__core-js_shared__"];
const Mz = Dyt;
var tEe = function() {
  var t = /[^.]+$/.exec(Mz && Mz.keys && Mz.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function Tyt(t) {
  return !!tEe && tEe in t;
}
var Nyt = Function.prototype, Lyt = Nyt.toString;
function $B(t) {
  if (t != null) {
    try {
      return Lyt.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var Myt = /[\\^$.*+?()[\]{}|]/g, Oyt = /^\[object .+?Constructor\]$/, Fyt = Function.prototype, Pyt = Object.prototype, kyt = Fyt.toString, Gyt = Pyt.hasOwnProperty, Uyt = RegExp(
  "^" + kyt.call(Gyt).replace(Myt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Hyt(t) {
  if (!kg(t) || Tyt(t))
    return !1;
  var e = ZGe(t) ? Uyt : Oyt;
  return e.test($B(t));
}
function $yt(t, e) {
  return t?.[e];
}
function qB(t, e) {
  var n = $yt(t, e);
  return Hyt(n) ? n : void 0;
}
var qyt = qB(vd, "WeakMap");
const lZ = qyt;
var nEe = Object.create, jyt = function() {
  function t() {
  }
  return function(e) {
    if (!kg(e))
      return {};
    if (nEe)
      return nEe(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}();
const Yyt = jyt;
function zyt(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
function Vyt() {
}
function Jyt(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var Kyt = 800, Wyt = 16, Xyt = Date.now;
function Zyt(t) {
  var e = 0, n = 0;
  return function() {
    var r = Xyt(), i = Wyt - (r - n);
    if (n = r, i > 0) {
      if (++e >= Kyt)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
function evt(t) {
  return function() {
    return t;
  };
}
var tvt = function() {
  try {
    var t = qB(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
const Q4 = tvt;
var nvt = Q4 ? function(t, e) {
  return Q4(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: evt(e),
    writable: !0
  });
} : _H;
const rvt = nvt;
var ivt = Zyt(rvt);
const e4e = ivt;
function ovt(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
function svt(t, e, n, r) {
  for (var i = t.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i; )
    if (e(t[o], o, t))
      return o;
  return -1;
}
function avt(t) {
  return t !== t;
}
function Avt(t, e, n) {
  for (var r = n - 1, i = t.length; ++r < i; )
    if (t[r] === e)
      return r;
  return -1;
}
function lvt(t, e, n) {
  return e === e ? Avt(t, e, n) : svt(t, avt, n);
}
function t4e(t, e) {
  var n = t == null ? 0 : t.length;
  return !!n && lvt(t, e, 0) > -1;
}
var cvt = 9007199254740991, uvt = /^(?:0|[1-9]\d*)$/;
function SH(t, e) {
  var n = typeof t;
  return e = e ?? cvt, !!e && (n == "number" || n != "symbol" && uvt.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function n4e(t, e, n) {
  e == "__proto__" && Q4 ? Q4(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
function QH(t, e) {
  return t === e || t !== t && e !== e;
}
var fvt = Object.prototype, gvt = fvt.hasOwnProperty;
function zse(t, e, n) {
  var r = t[e];
  (!(gvt.call(t, e) && QH(r, n)) || n === void 0 && !(e in t)) && n4e(t, e, n);
}
function wH(t, e, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, s = e.length; ++o < s; ) {
    var a = e[o], A = r ? r(n[a], t[a], a, n, t) : void 0;
    A === void 0 && (A = t[a]), i ? n4e(n, a, A) : zse(n, a, A);
  }
  return n;
}
var rEe = Math.max;
function r4e(t, e, n) {
  return e = rEe(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var r = arguments, i = -1, o = rEe(r.length - e, 0), s = Array(o); ++i < o; )
      s[i] = r[e + i];
    i = -1;
    for (var a = Array(e + 1); ++i < e; )
      a[i] = r[i];
    return a[e] = n(s), zyt(t, this, a);
  };
}
function i4e(t, e) {
  return e4e(r4e(t, e, _H), t + "");
}
var hvt = 9007199254740991;
function Vse(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= hvt;
}
function IL(t) {
  return t != null && Vse(t.length) && !ZGe(t);
}
function o4e(t, e, n) {
  if (!kg(n))
    return !1;
  var r = typeof e;
  return (r == "number" ? IL(n) && SH(e, n.length) : r == "string" && e in n) ? QH(n[e], t) : !1;
}
var dvt = Object.prototype;
function Jse(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || dvt;
  return t === n;
}
function pvt(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var Ivt = "[object Arguments]";
function iEe(t) {
  return SI(t) && ew(t) == Ivt;
}
var s4e = Object.prototype, mvt = s4e.hasOwnProperty, Cvt = s4e.propertyIsEnumerable, Evt = iEe(function() {
  return arguments;
}()) ? iEe : function(t) {
  return SI(t) && mvt.call(t, "callee") && !Cvt.call(t, "callee");
};
const Kse = Evt;
function yvt() {
  return !1;
}
var a4e = typeof exports == "object" && exports && !exports.nodeType && exports, oEe = a4e && typeof module == "object" && module && !module.nodeType && module, vvt = oEe && oEe.exports === a4e, sEe = vvt ? vd.Buffer : void 0, Bvt = sEe ? sEe.isBuffer : void 0, bvt = Bvt || yvt;
const w4 = bvt;
var _vt = "[object Arguments]", Svt = "[object Array]", Qvt = "[object Boolean]", wvt = "[object Date]", xvt = "[object Error]", Rvt = "[object Function]", Dvt = "[object Map]", Tvt = "[object Number]", Nvt = "[object Object]", Lvt = "[object RegExp]", Mvt = "[object Set]", Ovt = "[object String]", Fvt = "[object WeakMap]", Pvt = "[object ArrayBuffer]", kvt = "[object DataView]", Gvt = "[object Float32Array]", Uvt = "[object Float64Array]", Hvt = "[object Int8Array]", $vt = "[object Int16Array]", qvt = "[object Int32Array]", jvt = "[object Uint8Array]", Yvt = "[object Uint8ClampedArray]", zvt = "[object Uint16Array]", Vvt = "[object Uint32Array]", as = {};
as[Gvt] = as[Uvt] = as[Hvt] = as[$vt] = as[qvt] = as[jvt] = as[Yvt] = as[zvt] = as[Vvt] = !0;
as[_vt] = as[Svt] = as[Pvt] = as[Qvt] = as[kvt] = as[wvt] = as[xvt] = as[Rvt] = as[Dvt] = as[Tvt] = as[Nvt] = as[Lvt] = as[Mvt] = as[Ovt] = as[Fvt] = !1;
function Jvt(t) {
  return SI(t) && Vse(t.length) && !!as[ew(t)];
}
function xH(t) {
  return function(e) {
    return t(e);
  };
}
var A4e = typeof exports == "object" && exports && !exports.nodeType && exports, dD = A4e && typeof module == "object" && module && !module.nodeType && module, Kvt = dD && dD.exports === A4e, Oz = Kvt && JGe.process, Wvt = function() {
  try {
    var t = dD && dD.require && dD.require("util").types;
    return t || Oz && Oz.binding && Oz.binding("util");
  } catch {
  }
}();
const xS = Wvt;
var aEe = xS && xS.isTypedArray, Xvt = aEe ? xH(aEe) : Jvt;
const l4e = Xvt;
var Zvt = Object.prototype, eBt = Zvt.hasOwnProperty;
function c4e(t, e) {
  var n = Pg(t), r = !n && Kse(t), i = !n && !r && w4(t), o = !n && !r && !i && l4e(t), s = n || r || i || o, a = s ? pvt(t.length, String) : [], A = a.length;
  for (var l in t)
    (e || eBt.call(t, l)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    SH(l, A))) && a.push(l);
  return a;
}
function u4e(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var tBt = u4e(Object.keys, Object);
const nBt = tBt;
var rBt = Object.prototype, iBt = rBt.hasOwnProperty;
function oBt(t) {
  if (!Jse(t))
    return nBt(t);
  var e = [];
  for (var n in Object(t))
    iBt.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
function mL(t) {
  return IL(t) ? c4e(t) : oBt(t);
}
function sBt(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var aBt = Object.prototype, ABt = aBt.hasOwnProperty;
function lBt(t) {
  if (!kg(t))
    return sBt(t);
  var e = Jse(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !ABt.call(t, r)) || n.push(r);
  return n;
}
function Wse(t) {
  return IL(t) ? c4e(t, !0) : lBt(t);
}
var cBt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, uBt = /^\w*$/;
function Xse(t, e) {
  if (Pg(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || bH(t) ? !0 : uBt.test(t) || !cBt.test(t) || e != null && t in Object(e);
}
var fBt = qB(Object, "create");
const lT = fBt;
function gBt() {
  this.__data__ = lT ? lT(null) : {}, this.size = 0;
}
function hBt(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var dBt = "__lodash_hash_undefined__", pBt = Object.prototype, IBt = pBt.hasOwnProperty;
function mBt(t) {
  var e = this.__data__;
  if (lT) {
    var n = e[t];
    return n === dBt ? void 0 : n;
  }
  return IBt.call(e, t) ? e[t] : void 0;
}
var CBt = Object.prototype, EBt = CBt.hasOwnProperty;
function yBt(t) {
  var e = this.__data__;
  return lT ? e[t] !== void 0 : EBt.call(e, t);
}
var vBt = "__lodash_hash_undefined__";
function BBt(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = lT && e === void 0 ? vBt : e, this;
}
function $v(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
$v.prototype.clear = gBt;
$v.prototype.delete = hBt;
$v.prototype.get = mBt;
$v.prototype.has = yBt;
$v.prototype.set = BBt;
function bBt() {
  this.__data__ = [], this.size = 0;
}
function RH(t, e) {
  for (var n = t.length; n--; )
    if (QH(t[n][0], e))
      return n;
  return -1;
}
var _Bt = Array.prototype, SBt = _Bt.splice;
function QBt(t) {
  var e = this.__data__, n = RH(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : SBt.call(e, n, 1), --this.size, !0;
}
function wBt(t) {
  var e = this.__data__, n = RH(e, t);
  return n < 0 ? void 0 : e[n][1];
}
function xBt(t) {
  return RH(this.__data__, t) > -1;
}
function RBt(t, e) {
  var n = this.__data__, r = RH(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
function qI(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
qI.prototype.clear = bBt;
qI.prototype.delete = QBt;
qI.prototype.get = wBt;
qI.prototype.has = xBt;
qI.prototype.set = RBt;
var DBt = qB(vd, "Map");
const cT = DBt;
function TBt() {
  this.size = 0, this.__data__ = {
    hash: new $v(),
    map: new (cT || qI)(),
    string: new $v()
  };
}
function NBt(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function DH(t, e) {
  var n = t.__data__;
  return NBt(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
function LBt(t) {
  var e = DH(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function MBt(t) {
  return DH(this, t).get(t);
}
function OBt(t) {
  return DH(this, t).has(t);
}
function FBt(t, e) {
  var n = DH(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
function jI(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
jI.prototype.clear = TBt;
jI.prototype.delete = LBt;
jI.prototype.get = MBt;
jI.prototype.has = OBt;
jI.prototype.set = FBt;
var PBt = "Expected a function";
function Zse(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(PBt);
  var n = function() {
    var r = arguments, i = e ? e.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var s = t.apply(this, r);
    return n.cache = o.set(i, s) || o, s;
  };
  return n.cache = new (Zse.Cache || jI)(), n;
}
Zse.Cache = jI;
var kBt = 500;
function GBt(t) {
  var e = Zse(t, function(r) {
    return n.size === kBt && n.clear(), r;
  }), n = e.cache;
  return e;
}
var UBt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, HBt = /\\(\\)?/g, $Bt = GBt(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(UBt, function(n, r, i, o) {
    e.push(i ? o.replace(HBt, "$1") : r || n);
  }), e;
});
const qBt = $Bt;
function jBt(t) {
  return t == null ? "" : XGe(t);
}
function TH(t, e) {
  return Pg(t) ? t : Xse(t, e) ? [t] : qBt(jBt(t));
}
var YBt = 1 / 0;
function CL(t) {
  if (typeof t == "string" || bH(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -YBt ? "-0" : e;
}
function eae(t, e) {
  e = TH(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[CL(e[n++])];
  return n && n == r ? t : void 0;
}
function zBt(t, e, n) {
  var r = t == null ? void 0 : eae(t, e);
  return r === void 0 ? n : r;
}
function tae(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
var AEe = Fg ? Fg.isConcatSpreadable : void 0;
function VBt(t) {
  return Pg(t) || Kse(t) || !!(AEe && t && t[AEe]);
}
function NH(t, e, n, r, i) {
  var o = -1, s = t.length;
  for (n || (n = VBt), i || (i = []); ++o < s; ) {
    var a = t[o];
    e > 0 && n(a) ? e > 1 ? NH(a, e - 1, n, r, i) : tae(i, a) : r || (i[i.length] = a);
  }
  return i;
}
function JBt(t) {
  var e = t == null ? 0 : t.length;
  return e ? NH(t, 1) : [];
}
function KBt(t) {
  return e4e(r4e(t, void 0, JBt), t + "");
}
var WBt = u4e(Object.getPrototypeOf, Object);
const f4e = WBt;
function XBt(t, e, n) {
  return t === t && (n !== void 0 && (t = t <= n ? t : n), e !== void 0 && (t = t >= e ? t : e)), t;
}
function Su(t, e, n) {
  return n === void 0 && (n = e, e = void 0), n !== void 0 && (n = T_(n), n = n === n ? n : 0), e !== void 0 && (e = T_(e), e = e === e ? e : 0), XBt(T_(t), e, n);
}
function ZBt() {
  this.__data__ = new qI(), this.size = 0;
}
function e1t(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
function t1t(t) {
  return this.__data__.get(t);
}
function n1t(t) {
  return this.__data__.has(t);
}
var r1t = 200;
function i1t(t, e) {
  var n = this.__data__;
  if (n instanceof qI) {
    var r = n.__data__;
    if (!cT || r.length < r1t - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new jI(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
function Tp(t) {
  var e = this.__data__ = new qI(t);
  this.size = e.size;
}
Tp.prototype.clear = ZBt;
Tp.prototype.delete = e1t;
Tp.prototype.get = t1t;
Tp.prototype.has = n1t;
Tp.prototype.set = i1t;
function o1t(t, e) {
  return t && wH(e, mL(e), t);
}
function s1t(t, e) {
  return t && wH(e, Wse(e), t);
}
var g4e = typeof exports == "object" && exports && !exports.nodeType && exports, lEe = g4e && typeof module == "object" && module && !module.nodeType && module, a1t = lEe && lEe.exports === g4e, cEe = a1t ? vd.Buffer : void 0, uEe = cEe ? cEe.allocUnsafe : void 0;
function A1t(t, e) {
  if (e)
    return t.slice();
  var n = t.length, r = uEe ? uEe(n) : new t.constructor(n);
  return t.copy(r), r;
}
function l1t(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, o = []; ++n < r; ) {
    var s = t[n];
    e(s, n, t) && (o[i++] = s);
  }
  return o;
}
function h4e() {
  return [];
}
var c1t = Object.prototype, u1t = c1t.propertyIsEnumerable, fEe = Object.getOwnPropertySymbols, f1t = fEe ? function(t) {
  return t == null ? [] : (t = Object(t), l1t(fEe(t), function(e) {
    return u1t.call(t, e);
  }));
} : h4e;
const nae = f1t;
function g1t(t, e) {
  return wH(t, nae(t), e);
}
var h1t = Object.getOwnPropertySymbols, d1t = h1t ? function(t) {
  for (var e = []; t; )
    tae(e, nae(t)), t = f4e(t);
  return e;
} : h4e;
const d4e = d1t;
function p1t(t, e) {
  return wH(t, d4e(t), e);
}
function p4e(t, e, n) {
  var r = e(t);
  return Pg(t) ? r : tae(r, n(t));
}
function cZ(t) {
  return p4e(t, mL, nae);
}
function I1t(t) {
  return p4e(t, Wse, d4e);
}
var m1t = qB(vd, "DataView");
const uZ = m1t;
var C1t = qB(vd, "Promise");
const fZ = C1t;
var E1t = qB(vd, "Set");
const N_ = E1t;
var gEe = "[object Map]", y1t = "[object Object]", hEe = "[object Promise]", dEe = "[object Set]", pEe = "[object WeakMap]", IEe = "[object DataView]", v1t = $B(uZ), B1t = $B(cT), b1t = $B(fZ), _1t = $B(N_), S1t = $B(lZ), Py = ew;
(uZ && Py(new uZ(new ArrayBuffer(1))) != IEe || cT && Py(new cT()) != gEe || fZ && Py(fZ.resolve()) != hEe || N_ && Py(new N_()) != dEe || lZ && Py(new lZ()) != pEe) && (Py = function(t) {
  var e = ew(t), n = e == y1t ? t.constructor : void 0, r = n ? $B(n) : "";
  if (r)
    switch (r) {
      case v1t:
        return IEe;
      case B1t:
        return gEe;
      case b1t:
        return hEe;
      case _1t:
        return dEe;
      case S1t:
        return pEe;
    }
  return e;
});
const uT = Py;
var Q1t = Object.prototype, w1t = Q1t.hasOwnProperty;
function x1t(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && w1t.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var R1t = vd.Uint8Array;
const x4 = R1t;
function rae(t) {
  var e = new t.constructor(t.byteLength);
  return new x4(e).set(new x4(t)), e;
}
function D1t(t, e) {
  var n = e ? rae(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var T1t = /\w*$/;
function N1t(t) {
  var e = new t.constructor(t.source, T1t.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var mEe = Fg ? Fg.prototype : void 0, CEe = mEe ? mEe.valueOf : void 0;
function L1t(t) {
  return CEe ? Object(CEe.call(t)) : {};
}
function M1t(t, e) {
  var n = e ? rae(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var O1t = "[object Boolean]", F1t = "[object Date]", P1t = "[object Map]", k1t = "[object Number]", G1t = "[object RegExp]", U1t = "[object Set]", H1t = "[object String]", $1t = "[object Symbol]", q1t = "[object ArrayBuffer]", j1t = "[object DataView]", Y1t = "[object Float32Array]", z1t = "[object Float64Array]", V1t = "[object Int8Array]", J1t = "[object Int16Array]", K1t = "[object Int32Array]", W1t = "[object Uint8Array]", X1t = "[object Uint8ClampedArray]", Z1t = "[object Uint16Array]", ebt = "[object Uint32Array]";
function tbt(t, e, n) {
  var r = t.constructor;
  switch (e) {
    case q1t:
      return rae(t);
    case O1t:
    case F1t:
      return new r(+t);
    case j1t:
      return D1t(t, n);
    case Y1t:
    case z1t:
    case V1t:
    case J1t:
    case K1t:
    case W1t:
    case X1t:
    case Z1t:
    case ebt:
      return M1t(t, n);
    case P1t:
      return new r();
    case k1t:
    case H1t:
      return new r(t);
    case G1t:
      return N1t(t);
    case U1t:
      return new r();
    case $1t:
      return L1t(t);
  }
}
function nbt(t) {
  return typeof t.constructor == "function" && !Jse(t) ? Yyt(f4e(t)) : {};
}
var rbt = "[object Map]";
function ibt(t) {
  return SI(t) && uT(t) == rbt;
}
var EEe = xS && xS.isMap, obt = EEe ? xH(EEe) : ibt;
const sbt = obt;
var abt = "[object Set]";
function Abt(t) {
  return SI(t) && uT(t) == abt;
}
var yEe = xS && xS.isSet, lbt = yEe ? xH(yEe) : Abt;
const cbt = lbt;
var ubt = 1, fbt = 2, gbt = 4, I4e = "[object Arguments]", hbt = "[object Array]", dbt = "[object Boolean]", pbt = "[object Date]", Ibt = "[object Error]", m4e = "[object Function]", mbt = "[object GeneratorFunction]", Cbt = "[object Map]", Ebt = "[object Number]", C4e = "[object Object]", ybt = "[object RegExp]", vbt = "[object Set]", Bbt = "[object String]", bbt = "[object Symbol]", _bt = "[object WeakMap]", Sbt = "[object ArrayBuffer]", Qbt = "[object DataView]", wbt = "[object Float32Array]", xbt = "[object Float64Array]", Rbt = "[object Int8Array]", Dbt = "[object Int16Array]", Tbt = "[object Int32Array]", Nbt = "[object Uint8Array]", Lbt = "[object Uint8ClampedArray]", Mbt = "[object Uint16Array]", Obt = "[object Uint32Array]", Vo = {};
Vo[I4e] = Vo[hbt] = Vo[Sbt] = Vo[Qbt] = Vo[dbt] = Vo[pbt] = Vo[wbt] = Vo[xbt] = Vo[Rbt] = Vo[Dbt] = Vo[Tbt] = Vo[Cbt] = Vo[Ebt] = Vo[C4e] = Vo[ybt] = Vo[vbt] = Vo[Bbt] = Vo[bbt] = Vo[Nbt] = Vo[Lbt] = Vo[Mbt] = Vo[Obt] = !0;
Vo[Ibt] = Vo[m4e] = Vo[_bt] = !1;
function uk(t, e, n, r, i, o) {
  var s, a = e & ubt, A = e & fbt, l = e & gbt;
  if (n && (s = i ? n(t, r, i, o) : n(t)), s !== void 0)
    return s;
  if (!kg(t))
    return t;
  var c = Pg(t);
  if (c) {
    if (s = x1t(t), !a)
      return Jyt(t, s);
  } else {
    var u = uT(t), f = u == m4e || u == mbt;
    if (w4(t))
      return A1t(t, a);
    if (u == C4e || u == I4e || f && !i) {
      if (s = A || f ? {} : nbt(t), !a)
        return A ? p1t(t, s1t(s, t)) : g1t(t, o1t(s, t));
    } else {
      if (!Vo[u])
        return i ? t : {};
      s = tbt(t, u, a);
    }
  }
  o || (o = new Tp());
  var h = o.get(t);
  if (h)
    return h;
  o.set(t, s), cbt(t) ? t.forEach(function(m) {
    s.add(uk(m, e, n, m, t, o));
  }) : sbt(t) && t.forEach(function(m, C) {
    s.set(C, uk(m, e, n, C, t, o));
  });
  var d = l ? A ? I1t : cZ : A ? Wse : mL, I = c ? void 0 : d(t);
  return ovt(I || t, function(m, C) {
    I && (C = m, m = t[C]), zse(s, C, uk(m, e, n, C, t, o));
  }), s;
}
var Fbt = 1, Pbt = 4;
function $A(t) {
  return uk(t, Fbt | Pbt);
}
var kbt = "__lodash_hash_undefined__";
function Gbt(t) {
  return this.__data__.set(t, kbt), this;
}
function Ubt(t) {
  return this.__data__.has(t);
}
function RS(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new jI(); ++e < n; )
    this.add(t[e]);
}
RS.prototype.add = RS.prototype.push = Gbt;
RS.prototype.has = Ubt;
function Hbt(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
function iae(t, e) {
  return t.has(e);
}
var $bt = 1, qbt = 2;
function E4e(t, e, n, r, i, o) {
  var s = n & $bt, a = t.length, A = e.length;
  if (a != A && !(s && A > a))
    return !1;
  var l = o.get(t), c = o.get(e);
  if (l && c)
    return l == e && c == t;
  var u = -1, f = !0, h = n & qbt ? new RS() : void 0;
  for (o.set(t, e), o.set(e, t); ++u < a; ) {
    var d = t[u], I = e[u];
    if (r)
      var m = s ? r(I, d, u, e, t, o) : r(d, I, u, t, e, o);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!Hbt(e, function(C, y) {
        if (!iae(h, y) && (d === C || i(d, C, n, r, o)))
          return h.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(d === I || i(d, I, n, r, o))) {
      f = !1;
      break;
    }
  }
  return o.delete(t), o.delete(e), f;
}
function jbt(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, i) {
    n[++e] = [i, r];
  }), n;
}
function oae(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var Ybt = 1, zbt = 2, Vbt = "[object Boolean]", Jbt = "[object Date]", Kbt = "[object Error]", Wbt = "[object Map]", Xbt = "[object Number]", Zbt = "[object RegExp]", e_t = "[object Set]", t_t = "[object String]", n_t = "[object Symbol]", r_t = "[object ArrayBuffer]", i_t = "[object DataView]", vEe = Fg ? Fg.prototype : void 0, Fz = vEe ? vEe.valueOf : void 0;
function o_t(t, e, n, r, i, o, s) {
  switch (n) {
    case i_t:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case r_t:
      return !(t.byteLength != e.byteLength || !o(new x4(t), new x4(e)));
    case Vbt:
    case Jbt:
    case Xbt:
      return QH(+t, +e);
    case Kbt:
      return t.name == e.name && t.message == e.message;
    case Zbt:
    case t_t:
      return t == e + "";
    case Wbt:
      var a = jbt;
    case e_t:
      var A = r & Ybt;
      if (a || (a = oae), t.size != e.size && !A)
        return !1;
      var l = s.get(t);
      if (l)
        return l == e;
      r |= zbt, s.set(t, e);
      var c = E4e(a(t), a(e), r, i, o, s);
      return s.delete(t), c;
    case n_t:
      if (Fz)
        return Fz.call(t) == Fz.call(e);
  }
  return !1;
}
var s_t = 1, a_t = Object.prototype, A_t = a_t.hasOwnProperty;
function l_t(t, e, n, r, i, o) {
  var s = n & s_t, a = cZ(t), A = a.length, l = cZ(e), c = l.length;
  if (A != c && !s)
    return !1;
  for (var u = A; u--; ) {
    var f = a[u];
    if (!(s ? f in e : A_t.call(e, f)))
      return !1;
  }
  var h = o.get(t), d = o.get(e);
  if (h && d)
    return h == e && d == t;
  var I = !0;
  o.set(t, e), o.set(e, t);
  for (var m = s; ++u < A; ) {
    f = a[u];
    var C = t[f], y = e[f];
    if (r)
      var v = s ? r(y, C, f, e, t, o) : r(C, y, f, t, e, o);
    if (!(v === void 0 ? C === y || i(C, y, n, r, o) : v)) {
      I = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (I && !m) {
    var b = t.constructor, Q = e.constructor;
    b != Q && "constructor" in t && "constructor" in e && !(typeof b == "function" && b instanceof b && typeof Q == "function" && Q instanceof Q) && (I = !1);
  }
  return o.delete(t), o.delete(e), I;
}
var c_t = 1, BEe = "[object Arguments]", bEe = "[object Array]", sF = "[object Object]", u_t = Object.prototype, _Ee = u_t.hasOwnProperty;
function f_t(t, e, n, r, i, o) {
  var s = Pg(t), a = Pg(e), A = s ? bEe : uT(t), l = a ? bEe : uT(e);
  A = A == BEe ? sF : A, l = l == BEe ? sF : l;
  var c = A == sF, u = l == sF, f = A == l;
  if (f && w4(t)) {
    if (!w4(e))
      return !1;
    s = !0, c = !1;
  }
  if (f && !c)
    return o || (o = new Tp()), s || l4e(t) ? E4e(t, e, n, r, i, o) : o_t(t, e, A, n, r, i, o);
  if (!(n & c_t)) {
    var h = c && _Ee.call(t, "__wrapped__"), d = u && _Ee.call(e, "__wrapped__");
    if (h || d) {
      var I = h ? t.value() : t, m = d ? e.value() : e;
      return o || (o = new Tp()), i(I, m, n, r, o);
    }
  }
  return f ? (o || (o = new Tp()), l_t(t, e, n, r, i, o)) : !1;
}
function LH(t, e, n, r, i) {
  return t === e ? !0 : t == null || e == null || !SI(t) && !SI(e) ? t !== t && e !== e : f_t(t, e, n, r, LH, i);
}
var g_t = 1, h_t = 2;
function y4e(t, e, n, r) {
  var i = n.length, o = i, s = !r;
  if (t == null)
    return !o;
  for (t = Object(t); i--; ) {
    var a = n[i];
    if (s && a[2] ? a[1] !== t[a[0]] : !(a[0] in t))
      return !1;
  }
  for (; ++i < o; ) {
    a = n[i];
    var A = a[0], l = t[A], c = a[1];
    if (s && a[2]) {
      if (l === void 0 && !(A in t))
        return !1;
    } else {
      var u = new Tp();
      if (r)
        var f = r(l, c, A, t, e, u);
      if (!(f === void 0 ? LH(c, l, g_t | h_t, r, u) : f))
        return !1;
    }
  }
  return !0;
}
function v4e(t) {
  return t === t && !kg(t);
}
function B4e(t) {
  for (var e = mL(t), n = e.length; n--; ) {
    var r = e[n], i = t[r];
    e[n] = [r, i, v4e(i)];
  }
  return e;
}
function b4e(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
function d_t(t) {
  var e = B4e(t);
  return e.length == 1 && e[0][2] ? b4e(e[0][0], e[0][1]) : function(n) {
    return n === t || y4e(n, t, e);
  };
}
function p_t(t, e) {
  return t != null && e in Object(t);
}
function I_t(t, e, n) {
  e = TH(e, t);
  for (var r = -1, i = e.length, o = !1; ++r < i; ) {
    var s = CL(e[r]);
    if (!(o = t != null && n(t, s)))
      break;
    t = t[s];
  }
  return o || ++r != i ? o : (i = t == null ? 0 : t.length, !!i && Vse(i) && SH(s, i) && (Pg(t) || Kse(t)));
}
function _4e(t, e) {
  return t != null && I_t(t, e, p_t);
}
var m_t = 1, C_t = 2;
function E_t(t, e) {
  return Xse(t) && v4e(e) ? b4e(CL(t), e) : function(n) {
    var r = zBt(n, t);
    return r === void 0 && r === e ? _4e(n, t) : LH(e, r, m_t | C_t);
  };
}
function y_t(t) {
  return function(e) {
    return e?.[t];
  };
}
function v_t(t) {
  return function(e) {
    return eae(e, t);
  };
}
function B_t(t) {
  return Xse(t) ? y_t(CL(t)) : v_t(t);
}
function b_t(t) {
  return typeof t == "function" ? t : t == null ? _H : typeof t == "object" ? Pg(t) ? E_t(t[0], t[1]) : d_t(t) : B_t(t);
}
function __t(t) {
  return function(e, n, r) {
    for (var i = -1, o = Object(e), s = r(e), a = s.length; a--; ) {
      var A = s[t ? a : ++i];
      if (n(o[A], A, o) === !1)
        break;
    }
    return e;
  };
}
var S_t = __t();
const Q_t = S_t;
function w_t(t, e) {
  return t && Q_t(t, e, mL);
}
function x_t(t, e) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!IL(n))
      return t(n, r);
    for (var i = n.length, o = e ? i : -1, s = Object(n); (e ? o-- : ++o < i) && r(s[o], o, s) !== !1; )
      ;
    return n;
  };
}
var R_t = x_t(w_t);
const D_t = R_t;
var T_t = function() {
  return vd.Date.now();
};
const Pz = T_t;
var N_t = "Expected a function", L_t = Math.max, M_t = Math.min;
function Bd(t, e, n) {
  var r, i, o, s, a, A, l = 0, c = !1, u = !1, f = !0;
  if (typeof t != "function")
    throw new TypeError(N_t);
  e = T_(e) || 0, kg(n) && (c = !!n.leading, u = "maxWait" in n, o = u ? L_t(T_(n.maxWait) || 0, e) : o, f = "trailing" in n ? !!n.trailing : f);
  function h(w) {
    var R = r, M = i;
    return r = i = void 0, l = w, s = t.apply(M, R), s;
  }
  function d(w) {
    return l = w, a = setTimeout(C, e), c ? h(w) : s;
  }
  function I(w) {
    var R = w - A, M = w - l, O = e - R;
    return u ? M_t(O, o - M) : O;
  }
  function m(w) {
    var R = w - A, M = w - l;
    return A === void 0 || R >= e || R < 0 || u && M >= o;
  }
  function C() {
    var w = Pz();
    if (m(w))
      return y(w);
    a = setTimeout(C, I(w));
  }
  function y(w) {
    return a = void 0, f && r ? h(w) : (r = i = void 0, s);
  }
  function v() {
    a !== void 0 && clearTimeout(a), l = 0, r = A = i = a = void 0;
  }
  function b() {
    return a === void 0 ? s : y(Pz());
  }
  function Q() {
    var w = Pz(), R = m(w);
    if (r = arguments, i = this, A = w, R) {
      if (a === void 0)
        return d(A);
      if (u)
        return clearTimeout(a), a = setTimeout(C, e), h(A);
    }
    return a === void 0 && (a = setTimeout(C, e)), s;
  }
  return Q.cancel = v, Q.flush = b, Q;
}
function gZ(t) {
  return SI(t) && IL(t);
}
function S4e(t, e, n) {
  for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
    if (n(e, t[r]))
      return !0;
  return !1;
}
var O_t = 200;
function F_t(t, e, n, r) {
  var i = -1, o = t4e, s = !0, a = t.length, A = [], l = e.length;
  if (!a)
    return A;
  n && (e = WGe(e, xH(n))), r ? (o = S4e, s = !1) : e.length >= O_t && (o = iae, s = !1, e = new RS(e));
  e:
    for (; ++i < a; ) {
      var c = t[i], u = n == null ? c : n(c);
      if (c = r || c !== 0 ? c : 0, s && u === u) {
        for (var f = l; f--; )
          if (e[f] === u)
            continue e;
        A.push(c);
      } else
        o(e, u, r) || A.push(c);
    }
  return A;
}
var P_t = i4e(function(t, e) {
  return gZ(t) ? F_t(t, NH(e, 1, gZ, !0)) : [];
});
const k_t = P_t;
function G_t(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (!e(t[n], n, t))
      return !1;
  return !0;
}
function U_t(t, e) {
  var n = !0;
  return D_t(t, function(r, i, o) {
    return n = !!e(r, i, o), n;
  }), n;
}
function Q4e(t, e, n) {
  var r = Pg(t) ? G_t : U_t;
  return n && o4e(t, e, n) && (e = void 0), r(t, b_t(e));
}
function gr(t, e) {
  return LH(t, e);
}
function H_t(t, e) {
  return t === e || y4e(t, e, B4e(e));
}
function sae(t) {
  return t == null;
}
function $_t(t, e) {
  for (var n, r = -1, i = t.length; ++r < i; ) {
    var o = e(t[r]);
    o !== void 0 && (n = n === void 0 ? o : n + o);
  }
  return n;
}
function q_t(t, e, n, r) {
  if (!kg(t))
    return t;
  e = TH(e, t);
  for (var i = -1, o = e.length, s = o - 1, a = t; a != null && ++i < o; ) {
    var A = CL(e[i]), l = n;
    if (A === "__proto__" || A === "constructor" || A === "prototype")
      return t;
    if (i != s) {
      var c = a[A];
      l = r ? r(c, A, a) : void 0, l === void 0 && (l = kg(c) ? c : SH(e[i + 1]) ? [] : {});
    }
    zse(a, A, l), a = a[A];
  }
  return t;
}
function j_t(t, e, n) {
  for (var r = -1, i = e.length, o = {}; ++r < i; ) {
    var s = e[r], a = eae(t, s);
    n(a, s) && q_t(o, TH(s, t), a);
  }
  return o;
}
function Y_t(t, e) {
  return j_t(t, e, function(n, r) {
    return _4e(t, r);
  });
}
var z_t = KBt(function(t, e) {
  return t == null ? {} : Y_t(t, e);
});
const V_t = z_t;
var J_t = Math.ceil, K_t = Math.max;
function W_t(t, e, n, r) {
  for (var i = -1, o = K_t(J_t((e - t) / (n || 1)), 0), s = Array(o); o--; )
    s[r ? o : ++i] = t, t += n;
  return s;
}
function X_t(t) {
  return function(e, n, r) {
    return r && typeof r != "number" && o4e(e, n, r) && (n = r = void 0), e = Lz(e), n === void 0 ? (n = e, e = 0) : n = Lz(n), r = r === void 0 ? e < n ? 1 : -1 : Lz(r), W_t(e, n, r, t);
  };
}
var Z_t = X_t();
const oA = Z_t;
function w4e(t) {
  return t && t.length ? $_t(t, _H) : 0;
}
var eSt = 1 / 0, tSt = N_ && 1 / oae(new N_([, -0]))[1] == eSt ? function(t) {
  return new N_(t);
} : Vyt;
const nSt = tSt;
var rSt = 200;
function iSt(t, e, n) {
  var r = -1, i = t4e, o = t.length, s = !0, a = [], A = a;
  if (n)
    s = !1, i = S4e;
  else if (o >= rSt) {
    var l = e ? null : nSt(t);
    if (l)
      return oae(l);
    s = !1, i = iae, A = new RS();
  } else
    A = e ? [] : a;
  e:
    for (; ++r < o; ) {
      var c = t[r], u = e ? e(c) : c;
      if (c = n || c !== 0 ? c : 0, s && u === u) {
        for (var f = A.length; f--; )
          if (A[f] === u)
            continue e;
        e && A.push(u), a.push(c);
      } else
        i(A, u, n) || (A !== a && A.push(u), a.push(c));
    }
  return a;
}
var oSt = i4e(function(t) {
  return iSt(NH(t, 1, gZ, !0));
});
const sSt = oSt;
var $i;
(function(t) {
  t.assertEqual = (i) => i;
  function e(i) {
  }
  t.assertIs = e;
  function n(i) {
    throw new Error();
  }
  t.assertNever = n, t.arrayToEnum = (i) => {
    const o = {};
    for (const s of i)
      o[s] = s;
    return o;
  }, t.getValidEnumValues = (i) => {
    const o = t.objectKeys(i).filter((a) => typeof i[i[a]] != "number"), s = {};
    for (const a of o)
      s[a] = i[a];
    return t.objectValues(s);
  }, t.objectValues = (i) => t.objectKeys(i).map(function(o) {
    return i[o];
  }), t.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const o = [];
    for (const s in i)
      Object.prototype.hasOwnProperty.call(i, s) && o.push(s);
    return o;
  }, t.find = (i, o) => {
    for (const s of i)
      if (o(s))
        return s;
  }, t.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function r(i, o = " | ") {
    return i.map((s) => typeof s == "string" ? `'${s}'` : s).join(o);
  }
  t.joinValues = r, t.jsonStringifyReplacer = (i, o) => typeof o == "bigint" ? o.toString() : o;
})($i || ($i = {}));
var hZ;
(function(t) {
  t.mergeShapes = (e, n) => ({
    ...e,
    ...n
    // second overwrites first
  });
})(hZ || (hZ = {}));
const Tn = $i.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), eC = (t) => {
  switch (typeof t) {
    case "undefined":
      return Tn.undefined;
    case "string":
      return Tn.string;
    case "number":
      return isNaN(t) ? Tn.nan : Tn.number;
    case "boolean":
      return Tn.boolean;
    case "function":
      return Tn.function;
    case "bigint":
      return Tn.bigint;
    case "symbol":
      return Tn.symbol;
    case "object":
      return Array.isArray(t) ? Tn.array : t === null ? Tn.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? Tn.promise : typeof Map < "u" && t instanceof Map ? Tn.map : typeof Set < "u" && t instanceof Set ? Tn.set : typeof Date < "u" && t instanceof Date ? Tn.date : Tn.object;
    default:
      return Tn.unknown;
  }
}, ln = $i.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), aSt = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class ed extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const n = e || function(o) {
      return o.message;
    }, r = { _errors: [] }, i = (o) => {
      for (const s of o.issues)
        if (s.code === "invalid_union")
          s.unionErrors.map(i);
        else if (s.code === "invalid_return_type")
          i(s.returnTypeError);
        else if (s.code === "invalid_arguments")
          i(s.argumentsError);
        else if (s.path.length === 0)
          r._errors.push(n(s));
        else {
          let a = r, A = 0;
          for (; A < s.path.length; ) {
            const l = s.path[A];
            A === s.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(n(s))) : a[l] = a[l] || { _errors: [] }, a = a[l], A++;
          }
        }
    };
    return i(this), r;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, $i.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, r = [];
    for (const i of this.issues)
      i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(e(i))) : r.push(e(i));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
ed.create = (t) => new ed(t);
const fT = (t, e) => {
  let n;
  switch (t.code) {
    case ln.invalid_type:
      t.received === Tn.undefined ? n = "Required" : n = `Expected ${t.expected}, received ${t.received}`;
      break;
    case ln.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, $i.jsonStringifyReplacer)}`;
      break;
    case ln.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${$i.joinValues(t.keys, ", ")}`;
      break;
    case ln.invalid_union:
      n = "Invalid input";
      break;
    case ln.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${$i.joinValues(t.options)}`;
      break;
    case ln.invalid_enum_value:
      n = `Invalid enum value. Expected ${$i.joinValues(t.options)}, received '${t.received}'`;
      break;
    case ln.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case ln.invalid_return_type:
      n = "Invalid function return type";
      break;
    case ln.invalid_date:
      n = "Invalid date";
      break;
    case ln.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : $i.assertNever(t.validation) : t.validation !== "regex" ? n = `Invalid ${t.validation}` : n = "Invalid";
      break;
    case ln.too_small:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : n = "Invalid input";
      break;
    case ln.too_big:
      t.type === "array" ? n = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? n = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? n = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? n = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : n = "Invalid input";
      break;
    case ln.custom:
      n = "Invalid input";
      break;
    case ln.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case ln.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case ln.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, $i.assertNever(t);
  }
  return { message: n };
};
let x4e = fT;
function ASt(t) {
  x4e = t;
}
function R4() {
  return x4e;
}
const D4 = (t) => {
  const { data: e, path: n, errorMaps: r, issueData: i } = t, o = [...n, ...i.path || []], s = {
    ...i,
    path: o
  };
  let a = "";
  const A = r.filter((l) => !!l).slice().reverse();
  for (const l of A)
    a = l(s, { data: e, defaultError: a }).message;
  return {
    ...i,
    path: o,
    message: i.message || a
  };
}, lSt = [];
function Ln(t, e) {
  const n = D4({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      R4(),
      fT
      // then global default map
    ].filter((r) => !!r)
  });
  t.common.issues.push(n);
}
class ic {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const r = [];
    for (const i of n) {
      if (i.status === "aborted")
        return Yr;
      i.status === "dirty" && e.dirty(), r.push(i.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, n) {
    const r = [];
    for (const i of n)
      r.push({
        key: await i.key,
        value: await i.value
      });
    return ic.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, n) {
    const r = {};
    for (const i of n) {
      const { key: o, value: s } = i;
      if (o.status === "aborted" || s.status === "aborted")
        return Yr;
      o.status === "dirty" && e.dirty(), s.status === "dirty" && e.dirty(), (typeof s.value < "u" || i.alwaysSet) && (r[o.value] = s.value);
    }
    return { status: e.value, value: r };
  }
}
const Yr = Object.freeze({
  status: "aborted"
}), R4e = (t) => ({ status: "dirty", value: t }), Vc = (t) => ({ status: "valid", value: t }), dZ = (t) => t.status === "aborted", pZ = (t) => t.status === "dirty", T4 = (t) => t.status === "valid", N4 = (t) => typeof Promise < "u" && t instanceof Promise;
var Cr;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e?.message;
})(Cr || (Cr = {}));
class Up {
  constructor(e, n, r, i) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = r, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const SEe = (t, e) => {
  if (T4(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new ed(t.common.issues);
      return this._error = n, this._error;
    }
  };
};
function si(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: n, required_error: r, description: i } = t;
  if (e && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: i } : { errorMap: (s, a) => s.code !== "invalid_type" ? { message: a.defaultError } : typeof a.data > "u" ? { message: r ?? a.defaultError } : { message: n ?? a.defaultError }, description: i };
}
class gi {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return eC(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || {
      common: e.parent.common,
      data: e.data,
      parsedType: eC(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new ic(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: eC(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if (N4(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const r = this.safeParse(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, n) {
    var r;
    const i = {
      common: {
        issues: [],
        async: (r = n?.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: n?.errorMap
      },
      path: n?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: eC(e)
    }, o = this._parseSync({ data: e, path: i.path, parent: i });
    return SEe(i, o);
  }
  async parseAsync(e, n) {
    const r = await this.safeParseAsync(e, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n?.errorMap,
        async: !0
      },
      path: n?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: eC(e)
    }, i = this._parse({ data: e, path: r.path, parent: r }), o = await (N4(i) ? i : Promise.resolve(i));
    return SEe(r, o);
  }
  refine(e, n) {
    const r = (i) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(i) : n;
    return this._refinement((i, o) => {
      const s = e(i), a = () => o.addIssue({
        code: ln.custom,
        ...r(i)
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then((A) => A ? !0 : (a(), !1)) : s ? !0 : (a(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((r, i) => e(r) ? !0 : (i.addIssue(typeof n == "function" ? n(r, i) : n), !1));
  }
  _refinement(e) {
    return new ld({
      schema: this,
      typeName: Dr.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return gI.create(this, this._def);
  }
  nullable() {
    return Yv.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return td.create(this, this._def);
  }
  promise() {
    return TS.create(this, this._def);
  }
  or(e) {
    return pT.create([this, e], this._def);
  }
  and(e) {
    return IT.create(this, e, this._def);
  }
  transform(e) {
    return new ld({
      ...si(this._def),
      schema: this,
      typeName: Dr.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new vT({
      ...si(this._def),
      innerType: this,
      defaultValue: n,
      typeName: Dr.ZodDefault
    });
  }
  brand() {
    return new T4e({
      typeName: Dr.ZodBranded,
      type: this,
      ...si(this._def)
    });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new F4({
      ...si(this._def),
      innerType: this,
      catchValue: n,
      typeName: Dr.ZodCatch
    });
  }
  describe(e) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return EL.create(this, e);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const cSt = /^c[^\s-]{8,}$/i, uSt = /^[a-z][a-z0-9]*$/, fSt = /[0-9A-HJKMNP-TV-Z]{26}/, gSt = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i, hSt = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/, dSt = /^(\p{Extended_Pictographic}|\p{Emoji_Component})+$/u, pSt = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, ISt = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, mSt = (t) => t.precision ? t.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}Z$`) : t.precision === 0 ? t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function CSt(t, e) {
  return !!((e === "v4" || !e) && pSt.test(t) || (e === "v6" || !e) && ISt.test(t));
}
class $h extends gi {
  constructor() {
    super(...arguments), this._regex = (e, n, r) => this.refinement((i) => e.test(i), {
      validation: n,
      code: ln.invalid_string,
      ...Cr.errToObj(r)
    }), this.nonempty = (e) => this.min(1, Cr.errToObj(e)), this.trim = () => new $h({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    }), this.toLowerCase = () => new $h({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }), this.toUpperCase = () => new $h({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== Tn.string) {
      const o = this._getOrReturnCtx(e);
      return Ln(
        o,
        {
          code: ln.invalid_type,
          expected: Tn.string,
          received: o.parsedType
        }
        //
      ), Yr;
    }
    const r = new ic();
    let i;
    for (const o of this._def.checks)
      if (o.kind === "min")
        e.data.length < o.value && (i = this._getOrReturnCtx(e, i), Ln(i, {
          code: ln.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), r.dirty());
      else if (o.kind === "max")
        e.data.length > o.value && (i = this._getOrReturnCtx(e, i), Ln(i, {
          code: ln.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), r.dirty());
      else if (o.kind === "length") {
        const s = e.data.length > o.value, a = e.data.length < o.value;
        (s || a) && (i = this._getOrReturnCtx(e, i), s ? Ln(i, {
          code: ln.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }) : a && Ln(i, {
          code: ln.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }), r.dirty());
      } else if (o.kind === "email")
        hSt.test(e.data) || (i = this._getOrReturnCtx(e, i), Ln(i, {
          validation: "email",
          code: ln.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "emoji")
        dSt.test(e.data) || (i = this._getOrReturnCtx(e, i), Ln(i, {
          validation: "emoji",
          code: ln.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "uuid")
        gSt.test(e.data) || (i = this._getOrReturnCtx(e, i), Ln(i, {
          validation: "uuid",
          code: ln.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "cuid")
        cSt.test(e.data) || (i = this._getOrReturnCtx(e, i), Ln(i, {
          validation: "cuid",
          code: ln.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "cuid2")
        uSt.test(e.data) || (i = this._getOrReturnCtx(e, i), Ln(i, {
          validation: "cuid2",
          code: ln.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "ulid")
        fSt.test(e.data) || (i = this._getOrReturnCtx(e, i), Ln(i, {
          validation: "ulid",
          code: ln.invalid_string,
          message: o.message
        }), r.dirty());
      else if (o.kind === "url")
        try {
          new URL(e.data);
        } catch {
          i = this._getOrReturnCtx(e, i), Ln(i, {
            validation: "url",
            code: ln.invalid_string,
            message: o.message
          }), r.dirty();
        }
      else
        o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(e.data) || (i = this._getOrReturnCtx(e, i), Ln(i, {
          validation: "regex",
          code: ln.invalid_string,
          message: o.message
        }), r.dirty())) : o.kind === "trim" ? e.data = e.data.trim() : o.kind === "includes" ? e.data.includes(o.value, o.position) || (i = this._getOrReturnCtx(e, i), Ln(i, {
          code: ln.invalid_string,
          validation: { includes: o.value, position: o.position },
          message: o.message
        }), r.dirty()) : o.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : o.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : o.kind === "startsWith" ? e.data.startsWith(o.value) || (i = this._getOrReturnCtx(e, i), Ln(i, {
          code: ln.invalid_string,
          validation: { startsWith: o.value },
          message: o.message
        }), r.dirty()) : o.kind === "endsWith" ? e.data.endsWith(o.value) || (i = this._getOrReturnCtx(e, i), Ln(i, {
          code: ln.invalid_string,
          validation: { endsWith: o.value },
          message: o.message
        }), r.dirty()) : o.kind === "datetime" ? mSt(o).test(e.data) || (i = this._getOrReturnCtx(e, i), Ln(i, {
          code: ln.invalid_string,
          validation: "datetime",
          message: o.message
        }), r.dirty()) : o.kind === "ip" ? CSt(e.data, o.version) || (i = this._getOrReturnCtx(e, i), Ln(i, {
          validation: "ip",
          code: ln.invalid_string,
          message: o.message
        }), r.dirty()) : $i.assertNever(o);
    return { status: r.value, value: e.data };
  }
  _addCheck(e) {
    return new $h({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...Cr.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...Cr.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...Cr.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...Cr.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...Cr.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...Cr.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...Cr.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...Cr.errToObj(e) });
  }
  datetime(e) {
    var n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: (n = e?.offset) !== null && n !== void 0 ? n : !1,
      ...Cr.errToObj(e?.message)
    });
  }
  regex(e, n) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...Cr.errToObj(n)
    });
  }
  includes(e, n) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: n?.position,
      ...Cr.errToObj(n?.message)
    });
  }
  startsWith(e, n) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...Cr.errToObj(n)
    });
  }
  endsWith(e, n) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...Cr.errToObj(n)
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...Cr.errToObj(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...Cr.errToObj(n)
    });
  }
  length(e, n) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...Cr.errToObj(n)
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
$h.create = (t) => {
  var e;
  return new $h({
    checks: [],
    typeName: Dr.ZodString,
    coerce: (e = t?.coerce) !== null && e !== void 0 ? e : !1,
    ...si(t)
  });
};
function ESt(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, i = n > r ? n : r, o = parseInt(t.toFixed(i).replace(".", "")), s = parseInt(e.toFixed(i).replace(".", ""));
  return o % s / Math.pow(10, i);
}
class jC extends gi {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== Tn.number) {
      const o = this._getOrReturnCtx(e);
      return Ln(o, {
        code: ln.invalid_type,
        expected: Tn.number,
        received: o.parsedType
      }), Yr;
    }
    let r;
    const i = new ic();
    for (const o of this._def.checks)
      o.kind === "int" ? $i.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), Ln(r, {
        code: ln.invalid_type,
        expected: "integer",
        received: "float",
        message: o.message
      }), i.dirty()) : o.kind === "min" ? (o.inclusive ? e.data < o.value : e.data <= o.value) && (r = this._getOrReturnCtx(e, r), Ln(r, {
        code: ln.too_small,
        minimum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), i.dirty()) : o.kind === "max" ? (o.inclusive ? e.data > o.value : e.data >= o.value) && (r = this._getOrReturnCtx(e, r), Ln(r, {
        code: ln.too_big,
        maximum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), i.dirty()) : o.kind === "multipleOf" ? ESt(e.data, o.value) !== 0 && (r = this._getOrReturnCtx(e, r), Ln(r, {
        code: ln.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), i.dirty()) : o.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), Ln(r, {
        code: ln.not_finite,
        message: o.message
      }), i.dirty()) : $i.assertNever(o);
    return { status: i.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, Cr.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, Cr.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, Cr.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, Cr.toString(n));
  }
  setLimit(e, n, r, i) {
    return new jC({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: Cr.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new jC({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: Cr.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Cr.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Cr.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Cr.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Cr.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Cr.toString(n)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: Cr.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Cr.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Cr.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && $i.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
jC.create = (t) => new jC({
  checks: [],
  typeName: Dr.ZodNumber,
  coerce: t?.coerce || !1,
  ...si(t)
});
class YC extends gi {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== Tn.bigint) {
      const o = this._getOrReturnCtx(e);
      return Ln(o, {
        code: ln.invalid_type,
        expected: Tn.bigint,
        received: o.parsedType
      }), Yr;
    }
    let r;
    const i = new ic();
    for (const o of this._def.checks)
      o.kind === "min" ? (o.inclusive ? e.data < o.value : e.data <= o.value) && (r = this._getOrReturnCtx(e, r), Ln(r, {
        code: ln.too_small,
        type: "bigint",
        minimum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), i.dirty()) : o.kind === "max" ? (o.inclusive ? e.data > o.value : e.data >= o.value) && (r = this._getOrReturnCtx(e, r), Ln(r, {
        code: ln.too_big,
        type: "bigint",
        maximum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), i.dirty()) : o.kind === "multipleOf" ? e.data % o.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), Ln(r, {
        code: ln.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), i.dirty()) : $i.assertNever(o);
    return { status: i.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, Cr.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, Cr.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, Cr.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, Cr.toString(n));
  }
  setLimit(e, n, r, i) {
    return new YC({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: n,
          inclusive: r,
          message: Cr.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new YC({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Cr.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Cr.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Cr.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Cr.toString(e)
    });
  }
  multipleOf(e, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Cr.toString(n)
    });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
YC.create = (t) => {
  var e;
  return new YC({
    checks: [],
    typeName: Dr.ZodBigInt,
    coerce: (e = t?.coerce) !== null && e !== void 0 ? e : !1,
    ...si(t)
  });
};
class gT extends gi {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== Tn.boolean) {
      const r = this._getOrReturnCtx(e);
      return Ln(r, {
        code: ln.invalid_type,
        expected: Tn.boolean,
        received: r.parsedType
      }), Yr;
    }
    return Vc(e.data);
  }
}
gT.create = (t) => new gT({
  typeName: Dr.ZodBoolean,
  coerce: t?.coerce || !1,
  ...si(t)
});
class qv extends gi {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== Tn.date) {
      const o = this._getOrReturnCtx(e);
      return Ln(o, {
        code: ln.invalid_type,
        expected: Tn.date,
        received: o.parsedType
      }), Yr;
    }
    if (isNaN(e.data.getTime())) {
      const o = this._getOrReturnCtx(e);
      return Ln(o, {
        code: ln.invalid_date
      }), Yr;
    }
    const r = new ic();
    let i;
    for (const o of this._def.checks)
      o.kind === "min" ? e.data.getTime() < o.value && (i = this._getOrReturnCtx(e, i), Ln(i, {
        code: ln.too_small,
        message: o.message,
        inclusive: !0,
        exact: !1,
        minimum: o.value,
        type: "date"
      }), r.dirty()) : o.kind === "max" ? e.data.getTime() > o.value && (i = this._getOrReturnCtx(e, i), Ln(i, {
        code: ln.too_big,
        message: o.message,
        inclusive: !0,
        exact: !1,
        maximum: o.value,
        type: "date"
      }), r.dirty()) : $i.assertNever(o);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new qv({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, n) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: Cr.toString(n)
    });
  }
  max(e, n) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: Cr.toString(n)
    });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks)
      n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
qv.create = (t) => new qv({
  checks: [],
  coerce: t?.coerce || !1,
  typeName: Dr.ZodDate,
  ...si(t)
});
class L4 extends gi {
  _parse(e) {
    if (this._getType(e) !== Tn.symbol) {
      const r = this._getOrReturnCtx(e);
      return Ln(r, {
        code: ln.invalid_type,
        expected: Tn.symbol,
        received: r.parsedType
      }), Yr;
    }
    return Vc(e.data);
  }
}
L4.create = (t) => new L4({
  typeName: Dr.ZodSymbol,
  ...si(t)
});
class hT extends gi {
  _parse(e) {
    if (this._getType(e) !== Tn.undefined) {
      const r = this._getOrReturnCtx(e);
      return Ln(r, {
        code: ln.invalid_type,
        expected: Tn.undefined,
        received: r.parsedType
      }), Yr;
    }
    return Vc(e.data);
  }
}
hT.create = (t) => new hT({
  typeName: Dr.ZodUndefined,
  ...si(t)
});
class dT extends gi {
  _parse(e) {
    if (this._getType(e) !== Tn.null) {
      const r = this._getOrReturnCtx(e);
      return Ln(r, {
        code: ln.invalid_type,
        expected: Tn.null,
        received: r.parsedType
      }), Yr;
    }
    return Vc(e.data);
  }
}
dT.create = (t) => new dT({
  typeName: Dr.ZodNull,
  ...si(t)
});
class DS extends gi {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Vc(e.data);
  }
}
DS.create = (t) => new DS({
  typeName: Dr.ZodAny,
  ...si(t)
});
class yv extends gi {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Vc(e.data);
  }
}
yv.create = (t) => new yv({
  typeName: Dr.ZodUnknown,
  ...si(t)
});
class QI extends gi {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return Ln(n, {
      code: ln.invalid_type,
      expected: Tn.never,
      received: n.parsedType
    }), Yr;
  }
}
QI.create = (t) => new QI({
  typeName: Dr.ZodNever,
  ...si(t)
});
class M4 extends gi {
  _parse(e) {
    if (this._getType(e) !== Tn.undefined) {
      const r = this._getOrReturnCtx(e);
      return Ln(r, {
        code: ln.invalid_type,
        expected: Tn.void,
        received: r.parsedType
      }), Yr;
    }
    return Vc(e.data);
  }
}
M4.create = (t) => new M4({
  typeName: Dr.ZodVoid,
  ...si(t)
});
class td extends gi {
  _parse(e) {
    const { ctx: n, status: r } = this._processInputParams(e), i = this._def;
    if (n.parsedType !== Tn.array)
      return Ln(n, {
        code: ln.invalid_type,
        expected: Tn.array,
        received: n.parsedType
      }), Yr;
    if (i.exactLength !== null) {
      const s = n.data.length > i.exactLength.value, a = n.data.length < i.exactLength.value;
      (s || a) && (Ln(n, {
        code: s ? ln.too_big : ln.too_small,
        minimum: a ? i.exactLength.value : void 0,
        maximum: s ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), r.dirty());
    }
    if (i.minLength !== null && n.data.length < i.minLength.value && (Ln(n, {
      code: ln.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), r.dirty()), i.maxLength !== null && n.data.length > i.maxLength.value && (Ln(n, {
      code: ln.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((s, a) => i.type._parseAsync(new Up(n, s, n.path, a)))).then((s) => ic.mergeArray(r, s));
    const o = [...n.data].map((s, a) => i.type._parseSync(new Up(n, s, n.path, a)));
    return ic.mergeArray(r, o);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new td({
      ...this._def,
      minLength: { value: e, message: Cr.toString(n) }
    });
  }
  max(e, n) {
    return new td({
      ...this._def,
      maxLength: { value: e, message: Cr.toString(n) }
    });
  }
  length(e, n) {
    return new td({
      ...this._def,
      exactLength: { value: e, message: Cr.toString(n) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
td.create = (t, e) => new td({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Dr.ZodArray,
  ...si(e)
});
function $b(t) {
  if (t instanceof Js) {
    const e = {};
    for (const n in t.shape) {
      const r = t.shape[n];
      e[n] = gI.create($b(r));
    }
    return new Js({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof td ? new td({
      ...t._def,
      type: $b(t.element)
    }) : t instanceof gI ? gI.create($b(t.unwrap())) : t instanceof Yv ? Yv.create($b(t.unwrap())) : t instanceof Hp ? Hp.create(t.items.map((e) => $b(e))) : t;
}
class Js extends gi {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), n = $i.objectKeys(e);
    return this._cached = { shape: e, keys: n };
  }
  _parse(e) {
    if (this._getType(e) !== Tn.object) {
      const l = this._getOrReturnCtx(e);
      return Ln(l, {
        code: ln.invalid_type,
        expected: Tn.object,
        received: l.parsedType
      }), Yr;
    }
    const { status: r, ctx: i } = this._processInputParams(e), { shape: o, keys: s } = this._getCached(), a = [];
    if (!(this._def.catchall instanceof QI && this._def.unknownKeys === "strip"))
      for (const l in i.data)
        s.includes(l) || a.push(l);
    const A = [];
    for (const l of s) {
      const c = o[l], u = i.data[l];
      A.push({
        key: { status: "valid", value: l },
        value: c._parse(new Up(i, u, i.path, l)),
        alwaysSet: l in i.data
      });
    }
    if (this._def.catchall instanceof QI) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const c of a)
          A.push({
            key: { status: "valid", value: c },
            value: { status: "valid", value: i.data[c] }
          });
      else if (l === "strict")
        a.length > 0 && (Ln(i, {
          code: ln.unrecognized_keys,
          keys: a
        }), r.dirty());
      else if (l !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const c of a) {
        const u = i.data[c];
        A.push({
          key: { status: "valid", value: c },
          value: l._parse(
            new Up(i, u, i.path, c)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: c in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const c of A) {
        const u = await c.key;
        l.push({
          key: u,
          value: await c.value,
          alwaysSet: c.alwaysSet
        });
      }
      return l;
    }).then((l) => ic.mergeObjectSync(r, l)) : ic.mergeObjectSync(r, A);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return Cr.errToObj, new Js({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (n, r) => {
          var i, o, s, a;
          const A = (s = (o = (i = this._def).errorMap) === null || o === void 0 ? void 0 : o.call(i, n, r).message) !== null && s !== void 0 ? s : r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (a = Cr.errToObj(e).message) !== null && a !== void 0 ? a : A
          } : {
            message: A
          };
        }
      } : {}
    });
  }
  strip() {
    return new Js({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Js({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Js({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Js({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: Dr.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Js({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const n = {};
    return $i.objectKeys(e).forEach((r) => {
      e[r] && this.shape[r] && (n[r] = this.shape[r]);
    }), new Js({
      ...this._def,
      shape: () => n
    });
  }
  omit(e) {
    const n = {};
    return $i.objectKeys(this.shape).forEach((r) => {
      e[r] || (n[r] = this.shape[r]);
    }), new Js({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return $b(this);
  }
  partial(e) {
    const n = {};
    return $i.objectKeys(this.shape).forEach((r) => {
      const i = this.shape[r];
      e && !e[r] ? n[r] = i : n[r] = i.optional();
    }), new Js({
      ...this._def,
      shape: () => n
    });
  }
  required(e) {
    const n = {};
    return $i.objectKeys(this.shape).forEach((r) => {
      if (e && !e[r])
        n[r] = this.shape[r];
      else {
        let o = this.shape[r];
        for (; o instanceof gI; )
          o = o._def.innerType;
        n[r] = o;
      }
    }), new Js({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return D4e($i.objectKeys(this.shape));
  }
}
Js.create = (t, e) => new Js({
  shape: () => t,
  unknownKeys: "strip",
  catchall: QI.create(),
  typeName: Dr.ZodObject,
  ...si(e)
});
Js.strictCreate = (t, e) => new Js({
  shape: () => t,
  unknownKeys: "strict",
  catchall: QI.create(),
  typeName: Dr.ZodObject,
  ...si(e)
});
Js.lazycreate = (t, e) => new Js({
  shape: t,
  unknownKeys: "strip",
  catchall: QI.create(),
  typeName: Dr.ZodObject,
  ...si(e)
});
class pT extends gi {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = this._def.options;
    function i(o) {
      for (const a of o)
        if (a.result.status === "valid")
          return a.result;
      for (const a of o)
        if (a.result.status === "dirty")
          return n.common.issues.push(...a.ctx.common.issues), a.result;
      const s = o.map((a) => new ed(a.ctx.common.issues));
      return Ln(n, {
        code: ln.invalid_union,
        unionErrors: s
      }), Yr;
    }
    if (n.common.async)
      return Promise.all(r.map(async (o) => {
        const s = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await o._parseAsync({
            data: n.data,
            path: n.path,
            parent: s
          }),
          ctx: s
        };
      })).then(i);
    {
      let o;
      const s = [];
      for (const A of r) {
        const l = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, c = A._parseSync({
          data: n.data,
          path: n.path,
          parent: l
        });
        if (c.status === "valid")
          return c;
        c.status === "dirty" && !o && (o = { result: c, ctx: l }), l.common.issues.length && s.push(l.common.issues);
      }
      if (o)
        return n.common.issues.push(...o.ctx.common.issues), o.result;
      const a = s.map((A) => new ed(A));
      return Ln(n, {
        code: ln.invalid_union,
        unionErrors: a
      }), Yr;
    }
  }
  get options() {
    return this._def.options;
  }
}
pT.create = (t, e) => new pT({
  options: t,
  typeName: Dr.ZodUnion,
  ...si(e)
});
const fk = (t) => t instanceof CT ? fk(t.schema) : t instanceof ld ? fk(t.innerType()) : t instanceof ET ? [t.value] : t instanceof zC ? t.options : t instanceof yT ? Object.keys(t.enum) : t instanceof vT ? fk(t._def.innerType) : t instanceof hT ? [void 0] : t instanceof dT ? [null] : null;
class MH extends gi {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Tn.object)
      return Ln(n, {
        code: ln.invalid_type,
        expected: Tn.object,
        received: n.parsedType
      }), Yr;
    const r = this.discriminator, i = n.data[r], o = this.optionsMap.get(i);
    return o ? n.common.async ? o._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : o._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (Ln(n, {
      code: ln.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), Yr);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, n, r) {
    const i = /* @__PURE__ */ new Map();
    for (const o of n) {
      const s = fk(o.shape[e]);
      if (!s)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const a of s) {
        if (i.has(a))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(a)}`);
        i.set(a, o);
      }
    }
    return new MH({
      typeName: Dr.ZodDiscriminatedUnion,
      discriminator: e,
      options: n,
      optionsMap: i,
      ...si(r)
    });
  }
}
function IZ(t, e) {
  const n = eC(t), r = eC(e);
  if (t === e)
    return { valid: !0, data: t };
  if (n === Tn.object && r === Tn.object) {
    const i = $i.objectKeys(e), o = $i.objectKeys(t).filter((a) => i.indexOf(a) !== -1), s = { ...t, ...e };
    for (const a of o) {
      const A = IZ(t[a], e[a]);
      if (!A.valid)
        return { valid: !1 };
      s[a] = A.data;
    }
    return { valid: !0, data: s };
  } else if (n === Tn.array && r === Tn.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const i = [];
    for (let o = 0; o < t.length; o++) {
      const s = t[o], a = e[o], A = IZ(s, a);
      if (!A.valid)
        return { valid: !1 };
      i.push(A.data);
    }
    return { valid: !0, data: i };
  } else
    return n === Tn.date && r === Tn.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class IT extends gi {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), i = (o, s) => {
      if (dZ(o) || dZ(s))
        return Yr;
      const a = IZ(o.value, s.value);
      return a.valid ? ((pZ(o) || pZ(s)) && n.dirty(), { status: n.value, value: a.data }) : (Ln(r, {
        code: ln.invalid_intersection_types
      }), Yr);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([o, s]) => i(o, s)) : i(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
IT.create = (t, e, n) => new IT({
  left: t,
  right: e,
  typeName: Dr.ZodIntersection,
  ...si(n)
});
class Hp extends gi {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Tn.array)
      return Ln(r, {
        code: ln.invalid_type,
        expected: Tn.array,
        received: r.parsedType
      }), Yr;
    if (r.data.length < this._def.items.length)
      return Ln(r, {
        code: ln.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Yr;
    !this._def.rest && r.data.length > this._def.items.length && (Ln(r, {
      code: ln.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const o = [...r.data].map((s, a) => {
      const A = this._def.items[a] || this._def.rest;
      return A ? A._parse(new Up(r, s, r.path, a)) : null;
    }).filter((s) => !!s);
    return r.common.async ? Promise.all(o).then((s) => ic.mergeArray(n, s)) : ic.mergeArray(n, o);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Hp({
      ...this._def,
      rest: e
    });
  }
}
Hp.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Hp({
    items: t,
    typeName: Dr.ZodTuple,
    rest: null,
    ...si(e)
  });
};
class mT extends gi {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Tn.object)
      return Ln(r, {
        code: ln.invalid_type,
        expected: Tn.object,
        received: r.parsedType
      }), Yr;
    const i = [], o = this._def.keyType, s = this._def.valueType;
    for (const a in r.data)
      i.push({
        key: o._parse(new Up(r, a, r.path, a)),
        value: s._parse(new Up(r, r.data[a], r.path, a))
      });
    return r.common.async ? ic.mergeObjectAsync(n, i) : ic.mergeObjectSync(n, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, r) {
    return n instanceof gi ? new mT({
      keyType: e,
      valueType: n,
      typeName: Dr.ZodRecord,
      ...si(r)
    }) : new mT({
      keyType: $h.create(),
      valueType: e,
      typeName: Dr.ZodRecord,
      ...si(n)
    });
  }
}
class O4 extends gi {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Tn.map)
      return Ln(r, {
        code: ln.invalid_type,
        expected: Tn.map,
        received: r.parsedType
      }), Yr;
    const i = this._def.keyType, o = this._def.valueType, s = [...r.data.entries()].map(([a, A], l) => ({
      key: i._parse(new Up(r, a, r.path, [l, "key"])),
      value: o._parse(new Up(r, A, r.path, [l, "value"]))
    }));
    if (r.common.async) {
      const a = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const A of s) {
          const l = await A.key, c = await A.value;
          if (l.status === "aborted" || c.status === "aborted")
            return Yr;
          (l.status === "dirty" || c.status === "dirty") && n.dirty(), a.set(l.value, c.value);
        }
        return { status: n.value, value: a };
      });
    } else {
      const a = /* @__PURE__ */ new Map();
      for (const A of s) {
        const l = A.key, c = A.value;
        if (l.status === "aborted" || c.status === "aborted")
          return Yr;
        (l.status === "dirty" || c.status === "dirty") && n.dirty(), a.set(l.value, c.value);
      }
      return { status: n.value, value: a };
    }
  }
}
O4.create = (t, e, n) => new O4({
  valueType: e,
  keyType: t,
  typeName: Dr.ZodMap,
  ...si(n)
});
class jv extends gi {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Tn.set)
      return Ln(r, {
        code: ln.invalid_type,
        expected: Tn.set,
        received: r.parsedType
      }), Yr;
    const i = this._def;
    i.minSize !== null && r.data.size < i.minSize.value && (Ln(r, {
      code: ln.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), n.dirty()), i.maxSize !== null && r.data.size > i.maxSize.value && (Ln(r, {
      code: ln.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), n.dirty());
    const o = this._def.valueType;
    function s(A) {
      const l = /* @__PURE__ */ new Set();
      for (const c of A) {
        if (c.status === "aborted")
          return Yr;
        c.status === "dirty" && n.dirty(), l.add(c.value);
      }
      return { status: n.value, value: l };
    }
    const a = [...r.data.values()].map((A, l) => o._parse(new Up(r, A, r.path, l)));
    return r.common.async ? Promise.all(a).then((A) => s(A)) : s(a);
  }
  min(e, n) {
    return new jv({
      ...this._def,
      minSize: { value: e, message: Cr.toString(n) }
    });
  }
  max(e, n) {
    return new jv({
      ...this._def,
      maxSize: { value: e, message: Cr.toString(n) }
    });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
jv.create = (t, e) => new jv({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: Dr.ZodSet,
  ...si(e)
});
class L_ extends gi {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Tn.function)
      return Ln(n, {
        code: ln.invalid_type,
        expected: Tn.function,
        received: n.parsedType
      }), Yr;
    function r(a, A) {
      return D4({
        data: a,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          R4(),
          fT
        ].filter((l) => !!l),
        issueData: {
          code: ln.invalid_arguments,
          argumentsError: A
        }
      });
    }
    function i(a, A) {
      return D4({
        data: a,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          R4(),
          fT
        ].filter((l) => !!l),
        issueData: {
          code: ln.invalid_return_type,
          returnTypeError: A
        }
      });
    }
    const o = { errorMap: n.common.contextualErrorMap }, s = n.data;
    return this._def.returns instanceof TS ? Vc(async (...a) => {
      const A = new ed([]), l = await this._def.args.parseAsync(a, o).catch((f) => {
        throw A.addIssue(r(a, f)), A;
      }), c = await s(...l);
      return await this._def.returns._def.type.parseAsync(c, o).catch((f) => {
        throw A.addIssue(i(c, f)), A;
      });
    }) : Vc((...a) => {
      const A = this._def.args.safeParse(a, o);
      if (!A.success)
        throw new ed([r(a, A.error)]);
      const l = s(...A.data), c = this._def.returns.safeParse(l, o);
      if (!c.success)
        throw new ed([i(l, c.error)]);
      return c.data;
    });
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new L_({
      ...this._def,
      args: Hp.create(e).rest(yv.create())
    });
  }
  returns(e) {
    return new L_({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, n, r) {
    return new L_({
      args: e || Hp.create([]).rest(yv.create()),
      returns: n || yv.create(),
      typeName: Dr.ZodFunction,
      ...si(r)
    });
  }
}
class CT extends gi {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
CT.create = (t, e) => new CT({
  getter: t,
  typeName: Dr.ZodLazy,
  ...si(e)
});
class ET extends gi {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return Ln(n, {
        received: n.data,
        code: ln.invalid_literal,
        expected: this._def.value
      }), Yr;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
ET.create = (t, e) => new ET({
  value: t,
  typeName: Dr.ZodLiteral,
  ...si(e)
});
function D4e(t, e) {
  return new zC({
    values: t,
    typeName: Dr.ZodEnum,
    ...si(e)
  });
}
class zC extends gi {
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return Ln(n, {
        expected: $i.joinValues(r),
        received: n.parsedType,
        code: ln.invalid_type
      }), Yr;
    }
    if (this._def.values.indexOf(e.data) === -1) {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return Ln(n, {
        received: n.data,
        code: ln.invalid_enum_value,
        options: r
      }), Yr;
    }
    return Vc(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values)
      e[n] = n;
    return e;
  }
  extract(e) {
    return zC.create(e);
  }
  exclude(e) {
    return zC.create(this.options.filter((n) => !e.includes(n)));
  }
}
zC.create = D4e;
class yT extends gi {
  _parse(e) {
    const n = $i.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== Tn.string && r.parsedType !== Tn.number) {
      const i = $i.objectValues(n);
      return Ln(r, {
        expected: $i.joinValues(i),
        received: r.parsedType,
        code: ln.invalid_type
      }), Yr;
    }
    if (n.indexOf(e.data) === -1) {
      const i = $i.objectValues(n);
      return Ln(r, {
        received: r.data,
        code: ln.invalid_enum_value,
        options: i
      }), Yr;
    }
    return Vc(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
yT.create = (t, e) => new yT({
  values: t,
  typeName: Dr.ZodNativeEnum,
  ...si(e)
});
class TS extends gi {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Tn.promise && n.common.async === !1)
      return Ln(n, {
        code: ln.invalid_type,
        expected: Tn.promise,
        received: n.parsedType
      }), Yr;
    const r = n.parsedType === Tn.promise ? n.data : Promise.resolve(n.data);
    return Vc(r.then((i) => this._def.type.parseAsync(i, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
TS.create = (t, e) => new TS({
  type: t,
  typeName: Dr.ZodPromise,
  ...si(e)
});
class ld extends gi {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Dr.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), i = this._def.effect || null;
    if (i.type === "preprocess") {
      const s = i.transform(r.data);
      return r.common.async ? Promise.resolve(s).then((a) => this._def.schema._parseAsync({
        data: a,
        path: r.path,
        parent: r
      })) : this._def.schema._parseSync({
        data: s,
        path: r.path,
        parent: r
      });
    }
    const o = {
      addIssue: (s) => {
        Ln(r, s), s.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (o.addIssue = o.addIssue.bind(o), i.type === "refinement") {
      const s = (a) => {
        const A = i.refinement(a, o);
        if (r.common.async)
          return Promise.resolve(A);
        if (A instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return a;
      };
      if (r.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? Yr : (a.status === "dirty" && n.dirty(), s(a.value), { status: n.value, value: a.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((a) => a.status === "aborted" ? Yr : (a.status === "dirty" && n.dirty(), s(a.value).then(() => ({ status: n.value, value: a.value }))));
    }
    if (i.type === "transform")
      if (r.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!T4(s))
          return s;
        const a = i.transform(s.value, o);
        if (a instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: a };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((s) => T4(s) ? Promise.resolve(i.transform(s.value, o)).then((a) => ({ status: n.value, value: a })) : s);
    $i.assertNever(i);
  }
}
ld.create = (t, e, n) => new ld({
  schema: t,
  typeName: Dr.ZodEffects,
  effect: e,
  ...si(n)
});
ld.createWithPreprocess = (t, e, n) => new ld({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: Dr.ZodEffects,
  ...si(n)
});
class gI extends gi {
  _parse(e) {
    return this._getType(e) === Tn.undefined ? Vc(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
gI.create = (t, e) => new gI({
  innerType: t,
  typeName: Dr.ZodOptional,
  ...si(e)
});
class Yv extends gi {
  _parse(e) {
    return this._getType(e) === Tn.null ? Vc(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Yv.create = (t, e) => new Yv({
  innerType: t,
  typeName: Dr.ZodNullable,
  ...si(e)
});
class vT extends gi {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let r = n.data;
    return n.parsedType === Tn.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
vT.create = (t, e) => new vT({
  innerType: t,
  typeName: Dr.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...si(e)
});
class F4 extends gi {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return N4(i) ? i.then((o) => ({
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new ed(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new ed(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
F4.create = (t, e) => new F4({
  innerType: t,
  typeName: Dr.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...si(e)
});
class P4 extends gi {
  _parse(e) {
    if (this._getType(e) !== Tn.nan) {
      const r = this._getOrReturnCtx(e);
      return Ln(r, {
        code: ln.invalid_type,
        expected: Tn.nan,
        received: r.parsedType
      }), Yr;
    }
    return { status: "valid", value: e.data };
  }
}
P4.create = (t) => new P4({
  typeName: Dr.ZodNaN,
  ...si(t)
});
const ySt = Symbol("zod_brand");
class T4e extends gi {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class EL extends gi {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const o = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return o.status === "aborted" ? Yr : o.status === "dirty" ? (n.dirty(), R4e(o.value)) : this._def.out._parseAsync({
          data: o.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return i.status === "aborted" ? Yr : i.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, n) {
    return new EL({
      in: e,
      out: n,
      typeName: Dr.ZodPipeline
    });
  }
}
const N4e = (t, e = {}, n) => t ? DS.create().superRefine((r, i) => {
  var o, s;
  if (!t(r)) {
    const a = typeof e == "function" ? e(r) : typeof e == "string" ? { message: e } : e, A = (s = (o = a.fatal) !== null && o !== void 0 ? o : n) !== null && s !== void 0 ? s : !0, l = typeof a == "string" ? { message: a } : a;
    i.addIssue({ code: "custom", ...l, fatal: A });
  }
}) : DS.create(), vSt = {
  object: Js.lazycreate
};
var Dr;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline";
})(Dr || (Dr = {}));
const BSt = (t, e = {
  message: `Input not instance of ${t.name}`
}) => N4e((n) => n instanceof t, e), L4e = $h.create, M4e = jC.create, bSt = P4.create, _St = YC.create, O4e = gT.create, SSt = qv.create, QSt = L4.create, wSt = hT.create, xSt = dT.create, RSt = DS.create, DSt = yv.create, TSt = QI.create, NSt = M4.create, LSt = td.create, MSt = Js.create, OSt = Js.strictCreate, FSt = pT.create, PSt = MH.create, kSt = IT.create, GSt = Hp.create, USt = mT.create, HSt = O4.create, $St = jv.create, qSt = L_.create, jSt = CT.create, YSt = ET.create, zSt = zC.create, VSt = yT.create, JSt = TS.create, QEe = ld.create, KSt = gI.create, WSt = Yv.create, XSt = ld.createWithPreprocess, ZSt = EL.create, eQt = () => L4e().optional(), tQt = () => M4e().optional(), nQt = () => O4e().optional(), rQt = {
  string: (t) => $h.create({ ...t, coerce: !0 }),
  number: (t) => jC.create({ ...t, coerce: !0 }),
  boolean: (t) => gT.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => YC.create({ ...t, coerce: !0 }),
  date: (t) => qv.create({ ...t, coerce: !0 })
}, iQt = Yr;
var me = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: fT,
  setErrorMap: ASt,
  getErrorMap: R4,
  makeIssue: D4,
  EMPTY_PATH: lSt,
  addIssueToContext: Ln,
  ParseStatus: ic,
  INVALID: Yr,
  DIRTY: R4e,
  OK: Vc,
  isAborted: dZ,
  isDirty: pZ,
  isValid: T4,
  isAsync: N4,
  get util() {
    return $i;
  },
  get objectUtil() {
    return hZ;
  },
  ZodParsedType: Tn,
  getParsedType: eC,
  ZodType: gi,
  ZodString: $h,
  ZodNumber: jC,
  ZodBigInt: YC,
  ZodBoolean: gT,
  ZodDate: qv,
  ZodSymbol: L4,
  ZodUndefined: hT,
  ZodNull: dT,
  ZodAny: DS,
  ZodUnknown: yv,
  ZodNever: QI,
  ZodVoid: M4,
  ZodArray: td,
  ZodObject: Js,
  ZodUnion: pT,
  ZodDiscriminatedUnion: MH,
  ZodIntersection: IT,
  ZodTuple: Hp,
  ZodRecord: mT,
  ZodMap: O4,
  ZodSet: jv,
  ZodFunction: L_,
  ZodLazy: CT,
  ZodLiteral: ET,
  ZodEnum: zC,
  ZodNativeEnum: yT,
  ZodPromise: TS,
  ZodEffects: ld,
  ZodTransformer: ld,
  ZodOptional: gI,
  ZodNullable: Yv,
  ZodDefault: vT,
  ZodCatch: F4,
  ZodNaN: P4,
  BRAND: ySt,
  ZodBranded: T4e,
  ZodPipeline: EL,
  custom: N4e,
  Schema: gi,
  ZodSchema: gi,
  late: vSt,
  get ZodFirstPartyTypeKind() {
    return Dr;
  },
  coerce: rQt,
  any: RSt,
  array: LSt,
  bigint: _St,
  boolean: O4e,
  date: SSt,
  discriminatedUnion: PSt,
  effect: QEe,
  enum: zSt,
  function: qSt,
  instanceof: BSt,
  intersection: kSt,
  lazy: jSt,
  literal: YSt,
  map: HSt,
  nan: bSt,
  nativeEnum: VSt,
  never: TSt,
  null: xSt,
  nullable: WSt,
  number: M4e,
  object: MSt,
  oboolean: nQt,
  onumber: tQt,
  optional: KSt,
  ostring: eQt,
  pipeline: ZSt,
  preprocess: XSt,
  promise: JSt,
  record: USt,
  set: $St,
  strictObject: OSt,
  string: L4e,
  symbol: QSt,
  transformer: QEe,
  tuple: GSt,
  undefined: wSt,
  union: FSt,
  unknown: DSt,
  void: NSt,
  NEVER: iQt,
  ZodIssueCode: ln,
  quotelessJson: aSt,
  ZodError: ed
});
const mZ = me.string(), F4e = me.string(), oQt = me.union([
  me.string(),
  me.array(me.string())
]), P4e = oQt, k4e = me.record(mZ, P4e), G4e = me.record(mZ, me.record(mZ, me.record(F4e, P4e))), aae = me.array(me.number()).length(3), OH = me.object({
  name: me.string(),
  color: aae.optional()
}), sQt = OH.extend({
  set: me.array(me.string())
}), U4e = OH.extend({
  children: me.lazy(() => me.array(me.union([U4e, sQt])))
}), aQt = me.object({
  version: me.literal("0.1.2"),
  tree: me.array(U4e)
}), AQt = OH.extend({
  set: me.array(me.tuple([me.string(), me.number().nullable()]))
}), H4e = OH.extend({
  children: me.lazy(() => me.array(me.union([H4e, AQt])))
}), lQt = me.object({
  version: me.literal("0.1.3"),
  tree: me.array(H4e)
});
function $4e(t, e, n, r, i = null) {
  let o;
  return i ? o = [...i] : o = [t.name], e(t, o) ? (r.push(o), n(t, o)) : "children" in t ? {
    ...t,
    children: t.children.map((s) => $4e(s, e, n, r, o.concat([s.name])))
  } : t;
}
const FH = me.union([lQt, aQt]).transform((t) => t.version === "0.1.3" ? t : {
  ...t,
  version: "0.1.3",
  tree: t.tree.map((e) => $4e(e, (n) => !("children" in n) && Array.isArray(n.set), (n) => ({ ...n, set: n.set.map((r) => [r, null]) }), []))
}), cQt = me.array(me.object({
  groupName: me.string(),
  setName: me.string(),
  setColor: aae.optional(),
  obsId: me.string(),
  predictionScore: me.number().nullable().optional()
})), aF = me.array(me.string()), PH = me.object({
  method: me.string().optional(),
  headers: me.record(me.any()).optional(),
  body: me.string().optional(),
  mode: me.string().optional(),
  credentials: me.string().optional(),
  cache: me.string().optional(),
  redirect: me.string().optional(),
  referrer: me.string().optional(),
  integrity: me.string().optional()
}), q4e = me.string(), j4e = me.boolean().optional(), Y4e = me.string().optional(), uQt = me.object({
  version: me.literal("0.1.0"),
  name: q4e,
  public: j4e,
  description: Y4e,
  layers: me.array(me.object({
    name: me.string(),
    type: me.string(),
    fileType: me.string(),
    url: me.string()
  })),
  staticLayout: me.array(me.object({
    component: me.string(),
    props: me.record(me.any()).optional(),
    x: me.number().int(),
    y: me.number().int(),
    w: me.number().int().optional(),
    h: me.number().int().optional()
  }))
}), z4e = me.any(), fQt = me.object({}).catchall(me.record(F4e, me.any())), gQt = me.enum(["none", "auto"]), hQt = me.array(me.object({
  component: me.string(),
  props: me.record(me.any()).optional(),
  x: me.number().int(),
  y: me.number().int(),
  w: me.number().int().optional(),
  h: me.number().int().optional(),
  coordinationScopes: me.record(me.string()).optional()
})), dQt = me.array(me.object({
  uid: me.string(),
  name: me.string().optional(),
  description: me.string().optional(),
  files: me.array(me.object({
    name: me.string().optional(),
    fileType: me.string(),
    url: me.string().optional(),
    options: z4e.optional(),
    requestInit: PH.optional()
  }))
})), bd = me.object({
  version: me.literal("1.0.0"),
  name: q4e,
  public: j4e,
  description: Y4e,
  datasets: dQt,
  coordinationSpace: fQt.optional(),
  layout: hQt,
  initStrategy: gQt
}), pQt = bd.extend({
  version: me.literal("1.0.1")
}), IQt = bd.extend({
  version: me.literal("1.0.2")
}), mQt = bd.extend({
  version: me.literal("1.0.3")
}), CQt = bd.extend({
  version: me.literal("1.0.4")
}), EQt = bd.extend({
  version: me.literal("1.0.5")
}), yQt = bd.extend({
  version: me.literal("1.0.6")
}), vQt = bd.extend({
  version: me.literal("1.0.7")
}), V4e = me.record(me.union([
  me.string(),
  me.array(me.string()),
  me.record(me.string())
])), BQt = me.array(me.object({
  component: me.string(),
  props: me.record(me.any()).optional(),
  x: me.number().int(),
  y: me.number().int(),
  w: me.number().int().optional(),
  h: me.number().int().optional(),
  // New: can be one of
  // - coordinationType: string
  // - dataset: string[]
  // - coordinationType: { datasetA: string, datasetB: string }
  coordinationScopes: V4e.optional()
})), Aae = bd.extend({
  version: me.literal("1.0.8"),
  layout: BQt
}), bQt = Aae.extend({
  version: me.literal("1.0.9")
}), _Qt = me.array(me.object({
  // New: uid property allowed.
  uid: me.string().optional(),
  component: me.string(),
  props: me.record(me.any()).optional(),
  x: me.number().int(),
  y: me.number().int(),
  w: me.number().int().optional(),
  h: me.number().int().optional(),
  coordinationScopes: V4e.optional()
})), kH = Aae.extend({
  version: me.literal("1.0.10"),
  layout: _Qt
}), SQt = kH.extend({
  version: me.literal("1.0.11")
}), QQt = kH.extend({
  version: me.literal("1.0.12")
}), wQt = me.object({
  name: me.string().optional(),
  fileType: me.string(),
  url: me.string().optional(),
  options: z4e.optional(),
  requestInit: PH.optional(),
  // New: file def can have coordinationValues.
  coordinationValues: me.record(me.string()).optional()
}), xQt = me.array(me.object({
  uid: me.string(),
  name: me.string().optional(),
  description: me.string().optional(),
  files: me.array(wQt)
})), GH = kH.extend({
  version: me.literal("1.0.13"),
  datasets: xQt
}), RQt = GH.extend({
  version: me.literal("1.0.14")
}), DQt = GH.extend({
  version: me.literal("1.0.15")
}), TQt = GH.extend({
  version: me.literal("1.0.16"),
  uid: me.string().optional(),
  layout: me.array(me.object({
    uid: me.string().optional(),
    component: me.string(),
    props: me.record(me.any()).optional(),
    x: me.number().int(),
    y: me.number().int(),
    w: me.number().int().optional(),
    h: me.number().int().optional(),
    // Updates coordinationScopes and coordinationScopesBy
    coordinationScopes: k4e.optional(),
    coordinationScopesBy: G4e.optional()
  }))
});
let AF;
const NQt = new Uint8Array(16);
function LQt() {
  if (!AF && (AF = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !AF))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return AF(NQt);
}
const nl = [];
for (let t = 0; t < 256; ++t)
  nl.push((t + 256).toString(16).slice(1));
function MQt(t, e = 0) {
  return (nl[t[e + 0]] + nl[t[e + 1]] + nl[t[e + 2]] + nl[t[e + 3]] + "-" + nl[t[e + 4]] + nl[t[e + 5]] + "-" + nl[t[e + 6]] + nl[t[e + 7]] + "-" + nl[t[e + 8]] + nl[t[e + 9]] + "-" + nl[t[e + 10]] + nl[t[e + 11]] + nl[t[e + 12]] + nl[t[e + 13]] + nl[t[e + 14]] + nl[t[e + 15]]).toLowerCase();
}
const OQt = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), wEe = {
  randomUUID: OQt
};
function BT(t, e, n) {
  if (wEe.randomUUID && !e && !t)
    return wEe.randomUUID();
  t = t || {};
  const r = t.random || (t.rng || LQt)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, e) {
    n = n || 0;
    for (let i = 0; i < 16; ++i)
      e[n + i] = r[i];
    return e;
  }
  return MQt(r);
}
bd.shape.coordinationSpace.unwrap();
bd.shape.layout.element.shape.coordinationScopes.unwrap();
function xEe(t, e, n) {
  const r = Object.keys(n[`${t}Zoom`]), i = Object.keys(n[`${t}TargetX`]), o = Object.keys(n[`${t}TargetY`]), s = ql(r), a = ql(i), A = ql(o), { zoom: l, target: [c, u] } = e;
  return n[`${t}Zoom`][s] = l, n[`${t}TargetX`][a] = c, n[`${t}TargetY`][A] = u, {
    [`${t}Zoom`]: s,
    [`${t}TargetX`]: a,
    [`${t}TargetY`]: A
  };
}
function FQt(t, e = null) {
  const n = {
    embeddingType: {},
    embeddingZoom: {},
    embeddingTargetX: {},
    embeddingTargetY: {},
    spatialZoom: {},
    spatialTargetX: {},
    spatialTargetY: {}
  }, r = [];
  t.staticLayout.forEach((a) => {
    let A = {
      ...a,
      coordinationScopes: {}
    };
    if (a.component === "scatterplot" && (a.props?.mapping && typeof a.props.mapping == "string" && (n.embeddingType[a.props.mapping] = a.props.mapping, A = {
      ...A,
      coordinationScopes: {
        ...A.coordinationScopes,
        embeddingType: a.props.mapping
      }
    }), a.props?.view)) {
      const l = xEe("embedding", a.props.view, n);
      A = {
        ...A,
        coordinationScopes: {
          ...A.coordinationScopes,
          ...l
        }
      };
    }
    if (a.component === "spatial" && a?.props?.view) {
      const l = xEe("spatial", a.props.view, n);
      A = {
        ...A,
        coordinationScopes: {
          ...A.coordinationScopes,
          ...l
        }
      };
    }
    r.push(A);
  });
  const i = r.find((a) => a.component === "layerController"), o = r.find((a) => a.component === "spatial");
  i && o && "coordinationScopes" in o && (i.coordinationScopes = o.coordinationScopes);
  const s = e || BT();
  return {
    version: "1.0.0",
    name: t.name,
    description: t.description,
    public: t.public,
    datasets: [
      {
        uid: s,
        name: s,
        files: t.layers.map((a) => ({
          fileType: a.fileType,
          url: a.url
        }))
      }
    ],
    initStrategy: "auto",
    coordinationSpace: n,
    layout: r
  };
}
function PQt(t) {
  const e = $A(t), { coordinationSpace: n } = e;
  function r(o, s) {
    const a = o === "raster";
    s[`spatial${Ci(o)}Layer${a ? "s" : ""}`] = {}, Object.entries(s.spatialLayers).forEach(([A, l]) => {
      if (Array.isArray(l) && l.find((c) => c.type === o)) {
        const c = l.filter((u) => u.type === o).map((u) => {
          const f = { ...u };
          return delete f.type, f;
        });
        s[`spatial${Ci(o)}Layer${a ? "s" : ""}`][A] = a ? c : c[0];
      } else
        s[`spatial${Ci(o)}Layer${a ? "s" : ""}`][A] = null;
    });
  }
  n && "spatialLayers" in n && (r("raster", n), r("cells", n), r("molecules", n), r("neighborhoods", n), delete n.spatialLayers);
  const i = e.layout.map((o) => {
    const s = { ...o };
    function a(A, l) {
      const c = A === "raster";
      (["spatial", "layerController"].includes(s.component) || s.component === "description" && c) && (l[`spatial${Ci(A)}Layer${c ? "s" : ""}`] = l.spatialLayers);
    }
    return s.coordinationScopes && s.coordinationScopes.spatialLayers && (a("raster", s.coordinationScopes), a("cells", s.coordinationScopes), a("molecules", s.coordinationScopes), a("neighborhoods", s.coordinationScopes), delete s.coordinationScopes.spatialLayers), s;
  });
  return {
    ...e,
    coordinationSpace: n,
    layout: i,
    version: "1.0.1"
  };
}
function kQt(t) {
  const e = t.layout.map((r) => {
    const i = { ...r };
    return i.component === "layerController" && (i.props = {
      ...i.props,
      globalDisable3d: !0
    }), i;
  }), n = $A(t);
  return Object.keys(n?.coordinationSpace?.spatialRasterLayers || {}).forEach((r) => {
    n.coordinationSpace?.spatialRasterLayers?.[r] && n.coordinationSpace.spatialRasterLayers[r].forEach((i, o) => {
      n.coordinationSpace && (n.coordinationSpace.spatialRasterLayers[r][o].type = ["bitmask", "raster"].includes(i.type) ? i.type : "raster");
    });
  }), {
    ...n,
    layout: e,
    version: "1.0.2"
  };
}
function GQt(t) {
  const e = t.layout.map((r) => {
    const i = { ...r };
    return i.component === "layerController" && (i.props = {
      ...i.props,
      disableChannelsIfRgbDetected: !0
    }), i;
  });
  return {
    ...$A(t),
    layout: e,
    version: "1.0.3"
  };
}
function UQt(t) {
  return {
    ...$A(t),
    version: "1.0.4"
  };
}
function HQt(t) {
  return {
    ...$A(t),
    version: "1.0.5"
  };
}
function $Qt(t) {
  return {
    ...$A(t),
    version: "1.0.6"
  };
}
function qQt(t) {
  return {
    ...$A(t),
    version: "1.0.7"
  };
}
function jQt(t) {
  return {
    ...$A(t),
    version: "1.0.8"
  };
}
function YQt(t) {
  return {
    ...$A(t),
    version: "1.0.9"
  };
}
function zQt(t) {
  return {
    ...$A(t),
    version: "1.0.10"
  };
}
function VQt(t) {
  const e = { ...t.coordinationSpace }, n = {
    // Spatial layer types
    spatialRasterLayers: "spatialImageLayer",
    spatialCellsLayer: "spatialSegmentationLayer",
    spatialMoleculesLayer: "spatialPointLayer",
    spatialNeighborhoodsLayer: "spatialNeighborhoodLayer",
    // Other types
    cellFilter: "obsFilter",
    cellHighlight: "obsHighlight",
    cellSelection: "obsSelection",
    cellSetSelection: "obsSetSelection",
    cellSetHighlight: "obsSetHighlight",
    cellSetColor: "obsSetColor",
    geneFilter: "featureFilter",
    geneHighlight: "featureHighlight",
    geneSelection: "featureSelection",
    geneExpressionColormap: "featureValueColormap",
    geneExpressionColormapRange: "featureValueColormapRange",
    cellColorEncoding: "obsColorEncoding",
    additionalCellSets: "additionalObsSets",
    embeddingCellSetPolygonsVisible: "embeddingObsSetPolygonsVisible",
    embeddingCellSetLabelsVisible: "embeddingObsSetLabelsVisible",
    embeddingCellSetLabelSize: "embeddingObsSetLabelSize",
    embeddingCellRadius: "embeddingObsRadius",
    embeddingCellRadiusMode: "embeddingObsRadiusMode",
    embeddingCellOpacity: "embeddingObsOpacity",
    embeddingCellOpacityMode: "embeddingObsOpacityMode"
  };
  Object.entries(n).forEach(([i, o]) => {
    e[i] && (e[o] = e[i], delete e[i]);
  });
  const r = t.layout.map((i) => {
    const o = { ...i }, { coordinationScopes: s = {} } = o;
    return Object.entries(n).forEach(([a, A]) => {
      s[a] && (s[A] = s[a], delete s[a]);
    }), {
      ...o,
      coordinationScopes: s
    };
  });
  return {
    ...t,
    coordinationSpace: e,
    layout: r,
    version: "1.0.11"
  };
}
function JQt(t) {
  const e = $A(t), { datasets: n, coordinationSpace: r } = e;
  if (r?.embeddingType) {
    const i = Object.values(r.embeddingType);
    n.forEach((o, s) => {
      const { files: a } = o;
      a.forEach((A, l) => {
        const { fileType: c } = A;
        c === "cells.json" && (n[s].files[l].options = {
          embeddingTypes: i
        });
      });
    });
  }
  return {
    ...e,
    datasets: n,
    version: "1.0.12"
  };
}
function KQt(t) {
  const e = $A(t), { datasets: n, coordinationSpace: r, layout: i } = e, o = r || {}, s = {};
  n.forEach((l) => {
    const { files: c, uid: u } = l;
    c.forEach((f) => {
      const { fileType: h, options: d } = f;
      if (h === "anndata-cells.zarr" && d && "factors" in d && Array.isArray(d.factors)) {
        const I = [];
        d.factors.forEach((m) => {
          const C = ql(Object.keys(r?.obsLabelsType || {}));
          o.obsLabelsType = {
            ...o.obsLabelsType,
            // Need to remove the obs/ prefix.
            [C]: m.split("/").at(-1)
          }, I.push(C);
        }), s[u] = I;
      }
    });
  });
  function a(l) {
    return l.coordinationScopes?.dataset && typeof l.coordinationScopes?.dataset == "string" ? o.dataset[l.coordinationScopes.dataset] : n.length > 0 ? n[0].uid : null;
  }
  const A = i.map((l) => {
    const c = a(l);
    if (typeof c == "string") {
      const u = s[c];
      if (u)
        return {
          ...l,
          coordinationScopes: {
            ...l.coordinationScopes,
            obsLabelsType: u
          }
        };
    }
    return l;
  });
  return {
    ...e,
    coordinationSpace: o,
    layout: A,
    version: "1.0.13"
  };
}
function WQt(t) {
  return {
    ...$A(t),
    version: "1.0.14"
  };
}
function XQt(t) {
  const e = $A(t), { layout: n } = e, r = {
    genes: "featureList",
    cellSets: "obsSets",
    cellSetSizes: "obsSetSizes",
    cellSetExpression: "obsSetFeatureValueDistribution",
    expressionHistogram: "featureValueHistogram"
  }, i = n.map((s) => r[s.component] ? {
    ...s,
    component: r[s.component]
  } : s), o = {
    variablesLabelOverride: "featureType",
    observationsLabelOverride: "obsType"
  };
  return i.forEach((s) => {
    Object.entries(o).forEach(([a, A]) => {
      s.props?.[a] && console.warn(`Warning: the '${a}' prop on the ${s.component} view is deprecated. Please use the '${A}' coordination type instead.`);
    });
  }), {
    ...e,
    version: "1.0.15",
    layout: i
  };
}
function ZQt(t) {
  const e = $A(t), { layout: n } = e, r = n.map((i) => {
    const { coordinationScopes: o } = i, s = {};
    if (o?.dataset && Array.isArray(o.dataset)) {
      const a = {
        dataset: {}
      };
      return Object.entries(o).forEach(([A, l]) => {
        !Array.isArray(l) && typeof l == "object" ? (A === "dataset" && console.error("Expected coordinationScopes.dataset value to be either string or string[], but got object."), a.dataset[A] = l) : (Array.isArray(l) || typeof l == "string") && (s[A] = l);
      }), {
        ...i,
        coordinationScopes: s,
        coordinationScopesBy: a
      };
    }
    return o && Object.entries(o).forEach(([a, A]) => {
      (Array.isArray(A) || typeof A == "string") && (s[a] = A);
    }), {
      ...i,
      coordinationScopes: s
    };
  });
  return {
    ...e,
    layout: r,
    version: "1.0.16"
  };
}
const vv = TQt, dR = [
  [uQt, FQt],
  [bd, PQt],
  [pQt, kQt],
  [IQt, GQt],
  [mQt, UQt],
  [CQt, HQt],
  [EQt, $Qt],
  [yQt, qQt],
  [vQt, jQt],
  [Aae, YQt],
  [bQt, zQt],
  [kH, VQt],
  [SQt, JQt],
  [QQt, KQt],
  [GH, WQt],
  [RQt, XQt],
  [DQt, ZQt]
];
var CZ = { exports: {} };
const ewt = "2.0.0", twt = 256, nwt = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991, rwt = 16;
var UH = {
  SEMVER_SPEC_VERSION: ewt,
  MAX_LENGTH: twt,
  MAX_SAFE_INTEGER: nwt,
  MAX_SAFE_COMPONENT_LENGTH: rwt
};
const iwt = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...t) => console.error("SEMVER", ...t) : () => {
};
var HH = iwt;
(function(t, e) {
  const { MAX_SAFE_COMPONENT_LENGTH: n } = UH, r = HH;
  e = t.exports = {};
  const i = e.re = [], o = e.src = [], s = e.t = {};
  let a = 0;
  const A = (l, c, u) => {
    const f = a++;
    r(l, f, c), s[l] = f, o[f] = c, i[f] = new RegExp(c, u ? "g" : void 0);
  };
  A("NUMERICIDENTIFIER", "0|[1-9]\\d*"), A("NUMERICIDENTIFIERLOOSE", "[0-9]+"), A("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), A("MAINVERSION", `(${o[s.NUMERICIDENTIFIER]})\\.(${o[s.NUMERICIDENTIFIER]})\\.(${o[s.NUMERICIDENTIFIER]})`), A("MAINVERSIONLOOSE", `(${o[s.NUMERICIDENTIFIERLOOSE]})\\.(${o[s.NUMERICIDENTIFIERLOOSE]})\\.(${o[s.NUMERICIDENTIFIERLOOSE]})`), A("PRERELEASEIDENTIFIER", `(?:${o[s.NUMERICIDENTIFIER]}|${o[s.NONNUMERICIDENTIFIER]})`), A("PRERELEASEIDENTIFIERLOOSE", `(?:${o[s.NUMERICIDENTIFIERLOOSE]}|${o[s.NONNUMERICIDENTIFIER]})`), A("PRERELEASE", `(?:-(${o[s.PRERELEASEIDENTIFIER]}(?:\\.${o[s.PRERELEASEIDENTIFIER]})*))`), A("PRERELEASELOOSE", `(?:-?(${o[s.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${o[s.PRERELEASEIDENTIFIERLOOSE]})*))`), A("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), A("BUILD", `(?:\\+(${o[s.BUILDIDENTIFIER]}(?:\\.${o[s.BUILDIDENTIFIER]})*))`), A("FULLPLAIN", `v?${o[s.MAINVERSION]}${o[s.PRERELEASE]}?${o[s.BUILD]}?`), A("FULL", `^${o[s.FULLPLAIN]}$`), A("LOOSEPLAIN", `[v=\\s]*${o[s.MAINVERSIONLOOSE]}${o[s.PRERELEASELOOSE]}?${o[s.BUILD]}?`), A("LOOSE", `^${o[s.LOOSEPLAIN]}$`), A("GTLT", "((?:<|>)?=?)"), A("XRANGEIDENTIFIERLOOSE", `${o[s.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), A("XRANGEIDENTIFIER", `${o[s.NUMERICIDENTIFIER]}|x|X|\\*`), A("XRANGEPLAIN", `[v=\\s]*(${o[s.XRANGEIDENTIFIER]})(?:\\.(${o[s.XRANGEIDENTIFIER]})(?:\\.(${o[s.XRANGEIDENTIFIER]})(?:${o[s.PRERELEASE]})?${o[s.BUILD]}?)?)?`), A("XRANGEPLAINLOOSE", `[v=\\s]*(${o[s.XRANGEIDENTIFIERLOOSE]})(?:\\.(${o[s.XRANGEIDENTIFIERLOOSE]})(?:\\.(${o[s.XRANGEIDENTIFIERLOOSE]})(?:${o[s.PRERELEASELOOSE]})?${o[s.BUILD]}?)?)?`), A("XRANGE", `^${o[s.GTLT]}\\s*${o[s.XRANGEPLAIN]}$`), A("XRANGELOOSE", `^${o[s.GTLT]}\\s*${o[s.XRANGEPLAINLOOSE]}$`), A("COERCE", `(^|[^\\d])(\\d{1,${n}})(?:\\.(\\d{1,${n}}))?(?:\\.(\\d{1,${n}}))?(?:$|[^\\d])`), A("COERCERTL", o[s.COERCE], !0), A("LONETILDE", "(?:~>?)"), A("TILDETRIM", `(\\s*)${o[s.LONETILDE]}\\s+`, !0), e.tildeTrimReplace = "$1~", A("TILDE", `^${o[s.LONETILDE]}${o[s.XRANGEPLAIN]}$`), A("TILDELOOSE", `^${o[s.LONETILDE]}${o[s.XRANGEPLAINLOOSE]}$`), A("LONECARET", "(?:\\^)"), A("CARETTRIM", `(\\s*)${o[s.LONECARET]}\\s+`, !0), e.caretTrimReplace = "$1^", A("CARET", `^${o[s.LONECARET]}${o[s.XRANGEPLAIN]}$`), A("CARETLOOSE", `^${o[s.LONECARET]}${o[s.XRANGEPLAINLOOSE]}$`), A("COMPARATORLOOSE", `^${o[s.GTLT]}\\s*(${o[s.LOOSEPLAIN]})$|^$`), A("COMPARATOR", `^${o[s.GTLT]}\\s*(${o[s.FULLPLAIN]})$|^$`), A("COMPARATORTRIM", `(\\s*)${o[s.GTLT]}\\s*(${o[s.LOOSEPLAIN]}|${o[s.XRANGEPLAIN]})`, !0), e.comparatorTrimReplace = "$1$2$3", A("HYPHENRANGE", `^\\s*(${o[s.XRANGEPLAIN]})\\s+-\\s+(${o[s.XRANGEPLAIN]})\\s*$`), A("HYPHENRANGELOOSE", `^\\s*(${o[s.XRANGEPLAINLOOSE]})\\s+-\\s+(${o[s.XRANGEPLAINLOOSE]})\\s*$`), A("STAR", "(<|>)?=?\\s*\\*"), A("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), A("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(CZ, CZ.exports);
var tw = CZ.exports;
const owt = ["includePrerelease", "loose", "rtl"], swt = (t) => t ? typeof t != "object" ? { loose: !0 } : owt.filter((e) => t[e]).reduce((e, n) => (e[n] = !0, e), {}) : {};
var $H = swt;
const REe = /^[0-9]+$/, J4e = (t, e) => {
  const n = REe.test(t), r = REe.test(e);
  return n && r && (t = +t, e = +e), t === e ? 0 : n && !r ? -1 : r && !n ? 1 : t < e ? -1 : 1;
}, awt = (t, e) => J4e(e, t);
var K4e = {
  compareIdentifiers: J4e,
  rcompareIdentifiers: awt
};
const lF = HH, { MAX_LENGTH: DEe, MAX_SAFE_INTEGER: cF } = UH, { re: TEe, t: NEe } = tw, Awt = $H, { compareIdentifiers: K1 } = K4e;
let lwt = class ip {
  constructor(e, n) {
    if (n = Awt(n), e instanceof ip) {
      if (e.loose === !!n.loose && e.includePrerelease === !!n.includePrerelease)
        return e;
      e = e.version;
    } else if (typeof e != "string")
      throw new TypeError(`Invalid Version: ${e}`);
    if (e.length > DEe)
      throw new TypeError(
        `version is longer than ${DEe} characters`
      );
    lF("SemVer", e, n), this.options = n, this.loose = !!n.loose, this.includePrerelease = !!n.includePrerelease;
    const r = e.trim().match(n.loose ? TEe[NEe.LOOSE] : TEe[NEe.FULL]);
    if (!r)
      throw new TypeError(`Invalid Version: ${e}`);
    if (this.raw = e, this.major = +r[1], this.minor = +r[2], this.patch = +r[3], this.major > cF || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > cF || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > cF || this.patch < 0)
      throw new TypeError("Invalid patch version");
    r[4] ? this.prerelease = r[4].split(".").map((i) => {
      if (/^[0-9]+$/.test(i)) {
        const o = +i;
        if (o >= 0 && o < cF)
          return o;
      }
      return i;
    }) : this.prerelease = [], this.build = r[5] ? r[5].split(".") : [], this.format();
  }
  format() {
    return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
  }
  toString() {
    return this.version;
  }
  compare(e) {
    if (lF("SemVer.compare", this.version, this.options, e), !(e instanceof ip)) {
      if (typeof e == "string" && e === this.version)
        return 0;
      e = new ip(e, this.options);
    }
    return e.version === this.version ? 0 : this.compareMain(e) || this.comparePre(e);
  }
  compareMain(e) {
    return e instanceof ip || (e = new ip(e, this.options)), K1(this.major, e.major) || K1(this.minor, e.minor) || K1(this.patch, e.patch);
  }
  comparePre(e) {
    if (e instanceof ip || (e = new ip(e, this.options)), this.prerelease.length && !e.prerelease.length)
      return -1;
    if (!this.prerelease.length && e.prerelease.length)
      return 1;
    if (!this.prerelease.length && !e.prerelease.length)
      return 0;
    let n = 0;
    do {
      const r = this.prerelease[n], i = e.prerelease[n];
      if (lF("prerelease compare", n, r, i), r === void 0 && i === void 0)
        return 0;
      if (i === void 0)
        return 1;
      if (r === void 0)
        return -1;
      if (r === i)
        continue;
      return K1(r, i);
    } while (++n);
  }
  compareBuild(e) {
    e instanceof ip || (e = new ip(e, this.options));
    let n = 0;
    do {
      const r = this.build[n], i = e.build[n];
      if (lF("prerelease compare", n, r, i), r === void 0 && i === void 0)
        return 0;
      if (i === void 0)
        return 1;
      if (r === void 0)
        return -1;
      if (r === i)
        continue;
      return K1(r, i);
    } while (++n);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(e, n) {
    switch (e) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", n);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", n);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", n), this.inc("pre", n);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", n), this.inc("pre", n);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre":
        if (this.prerelease.length === 0)
          this.prerelease = [0];
        else {
          let r = this.prerelease.length;
          for (; --r >= 0; )
            typeof this.prerelease[r] == "number" && (this.prerelease[r]++, r = -2);
          r === -1 && this.prerelease.push(0);
        }
        n && (K1(this.prerelease[0], n) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [n, 0]) : this.prerelease = [n, 0]);
        break;
      default:
        throw new Error(`invalid increment argument: ${e}`);
    }
    return this.format(), this.raw = this.version, this;
  }
};
var Zc = lwt;
const { MAX_LENGTH: cwt } = UH, { re: LEe, t: MEe } = tw, OEe = Zc, uwt = $H, fwt = (t, e) => {
  if (e = uwt(e), t instanceof OEe)
    return t;
  if (typeof t != "string" || t.length > cwt || !(e.loose ? LEe[MEe.LOOSE] : LEe[MEe.FULL]).test(t))
    return null;
  try {
    return new OEe(t, e);
  } catch {
    return null;
  }
};
var nw = fwt;
const gwt = nw, hwt = (t, e) => {
  const n = gwt(t, e);
  return n ? n.version : null;
};
var dwt = hwt;
const pwt = nw, Iwt = (t, e) => {
  const n = pwt(t.trim().replace(/^[=v]+/, ""), e);
  return n ? n.version : null;
};
var mwt = Iwt;
const FEe = Zc, Cwt = (t, e, n, r) => {
  typeof n == "string" && (r = n, n = void 0);
  try {
    return new FEe(
      t instanceof FEe ? t.version : t,
      n
    ).inc(e, r).version;
  } catch {
    return null;
  }
};
var Ewt = Cwt;
const PEe = Zc, ywt = (t, e, n) => new PEe(t, n).compare(new PEe(e, n));
var _d = ywt;
const vwt = _d, Bwt = (t, e, n) => vwt(t, e, n) === 0;
var lae = Bwt;
const kEe = nw, bwt = lae, _wt = (t, e) => {
  if (bwt(t, e))
    return null;
  {
    const n = kEe(t), r = kEe(e), i = n.prerelease.length || r.prerelease.length, o = i ? "pre" : "", s = i ? "prerelease" : "";
    for (const a in n)
      if ((a === "major" || a === "minor" || a === "patch") && n[a] !== r[a])
        return o + a;
    return s;
  }
};
var Swt = _wt;
const Qwt = Zc, wwt = (t, e) => new Qwt(t, e).major;
var xwt = wwt;
const Rwt = Zc, Dwt = (t, e) => new Rwt(t, e).minor;
var Twt = Dwt;
const Nwt = Zc, Lwt = (t, e) => new Nwt(t, e).patch;
var Mwt = Lwt;
const Owt = nw, Fwt = (t, e) => {
  const n = Owt(t, e);
  return n && n.prerelease.length ? n.prerelease : null;
};
var Pwt = Fwt;
const kwt = _d, Gwt = (t, e, n) => kwt(e, t, n);
var Uwt = Gwt;
const Hwt = _d, $wt = (t, e) => Hwt(t, e, !0);
var qwt = $wt;
const GEe = Zc, jwt = (t, e, n) => {
  const r = new GEe(t, n), i = new GEe(e, n);
  return r.compare(i) || r.compareBuild(i);
};
var cae = jwt;
const Ywt = cae, zwt = (t, e) => t.sort((n, r) => Ywt(n, r, e));
var Vwt = zwt;
const Jwt = cae, Kwt = (t, e) => t.sort((n, r) => Jwt(r, n, e));
var Wwt = Kwt;
const Xwt = _d, Zwt = (t, e, n) => Xwt(t, e, n) > 0;
var qH = Zwt;
const ext = _d, txt = (t, e, n) => ext(t, e, n) < 0;
var uae = txt;
const nxt = _d, rxt = (t, e, n) => nxt(t, e, n) !== 0;
var W4e = rxt;
const ixt = _d, oxt = (t, e, n) => ixt(t, e, n) >= 0;
var fae = oxt;
const sxt = _d, axt = (t, e, n) => sxt(t, e, n) <= 0;
var gae = axt;
const Axt = lae, lxt = W4e, cxt = qH, uxt = fae, fxt = uae, gxt = gae, hxt = (t, e, n, r) => {
  switch (e) {
    case "===":
      return typeof t == "object" && (t = t.version), typeof n == "object" && (n = n.version), t === n;
    case "!==":
      return typeof t == "object" && (t = t.version), typeof n == "object" && (n = n.version), t !== n;
    case "":
    case "=":
    case "==":
      return Axt(t, n, r);
    case "!=":
      return lxt(t, n, r);
    case ">":
      return cxt(t, n, r);
    case ">=":
      return uxt(t, n, r);
    case "<":
      return fxt(t, n, r);
    case "<=":
      return gxt(t, n, r);
    default:
      throw new TypeError(`Invalid operator: ${e}`);
  }
};
var X4e = hxt;
const dxt = Zc, pxt = nw, { re: uF, t: fF } = tw, Ixt = (t, e) => {
  if (t instanceof dxt)
    return t;
  if (typeof t == "number" && (t = String(t)), typeof t != "string")
    return null;
  e = e || {};
  let n = null;
  if (!e.rtl)
    n = t.match(uF[fF.COERCE]);
  else {
    let r;
    for (; (r = uF[fF.COERCERTL].exec(t)) && (!n || n.index + n[0].length !== t.length); )
      (!n || r.index + r[0].length !== n.index + n[0].length) && (n = r), uF[fF.COERCERTL].lastIndex = r.index + r[1].length + r[2].length;
    uF[fF.COERCERTL].lastIndex = -1;
  }
  return n === null ? null : pxt(`${n[2]}.${n[3] || "0"}.${n[4] || "0"}`, e);
};
var mxt = Ixt, kz, UEe;
function Cxt() {
  return UEe || (UEe = 1, kz = function(t) {
    t.prototype[Symbol.iterator] = function* () {
      for (let e = this.head; e; e = e.next)
        yield e.value;
    };
  }), kz;
}
var Ext = Yi;
Yi.Node = zv;
Yi.create = Yi;
function Yi(t) {
  var e = this;
  if (e instanceof Yi || (e = new Yi()), e.tail = null, e.head = null, e.length = 0, t && typeof t.forEach == "function")
    t.forEach(function(i) {
      e.push(i);
    });
  else if (arguments.length > 0)
    for (var n = 0, r = arguments.length; n < r; n++)
      e.push(arguments[n]);
  return e;
}
Yi.prototype.removeNode = function(t) {
  if (t.list !== this)
    throw new Error("removing node which does not belong to this list");
  var e = t.next, n = t.prev;
  return e && (e.prev = n), n && (n.next = e), t === this.head && (this.head = e), t === this.tail && (this.tail = n), t.list.length--, t.next = null, t.prev = null, t.list = null, e;
};
Yi.prototype.unshiftNode = function(t) {
  if (t !== this.head) {
    t.list && t.list.removeNode(t);
    var e = this.head;
    t.list = this, t.next = e, e && (e.prev = t), this.head = t, this.tail || (this.tail = t), this.length++;
  }
};
Yi.prototype.pushNode = function(t) {
  if (t !== this.tail) {
    t.list && t.list.removeNode(t);
    var e = this.tail;
    t.list = this, t.prev = e, e && (e.next = t), this.tail = t, this.head || (this.head = t), this.length++;
  }
};
Yi.prototype.push = function() {
  for (var t = 0, e = arguments.length; t < e; t++)
    vxt(this, arguments[t]);
  return this.length;
};
Yi.prototype.unshift = function() {
  for (var t = 0, e = arguments.length; t < e; t++)
    Bxt(this, arguments[t]);
  return this.length;
};
Yi.prototype.pop = function() {
  if (this.tail) {
    var t = this.tail.value;
    return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, t;
  }
};
Yi.prototype.shift = function() {
  if (this.head) {
    var t = this.head.value;
    return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, t;
  }
};
Yi.prototype.forEach = function(t, e) {
  e = e || this;
  for (var n = this.head, r = 0; n !== null; r++)
    t.call(e, n.value, r, this), n = n.next;
};
Yi.prototype.forEachReverse = function(t, e) {
  e = e || this;
  for (var n = this.tail, r = this.length - 1; n !== null; r--)
    t.call(e, n.value, r, this), n = n.prev;
};
Yi.prototype.get = function(t) {
  for (var e = 0, n = this.head; n !== null && e < t; e++)
    n = n.next;
  if (e === t && n !== null)
    return n.value;
};
Yi.prototype.getReverse = function(t) {
  for (var e = 0, n = this.tail; n !== null && e < t; e++)
    n = n.prev;
  if (e === t && n !== null)
    return n.value;
};
Yi.prototype.map = function(t, e) {
  e = e || this;
  for (var n = new Yi(), r = this.head; r !== null; )
    n.push(t.call(e, r.value, this)), r = r.next;
  return n;
};
Yi.prototype.mapReverse = function(t, e) {
  e = e || this;
  for (var n = new Yi(), r = this.tail; r !== null; )
    n.push(t.call(e, r.value, this)), r = r.prev;
  return n;
};
Yi.prototype.reduce = function(t, e) {
  var n, r = this.head;
  if (arguments.length > 1)
    n = e;
  else if (this.head)
    r = this.head.next, n = this.head.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var i = 0; r !== null; i++)
    n = t(n, r.value, i), r = r.next;
  return n;
};
Yi.prototype.reduceReverse = function(t, e) {
  var n, r = this.tail;
  if (arguments.length > 1)
    n = e;
  else if (this.tail)
    r = this.tail.prev, n = this.tail.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var i = this.length - 1; r !== null; i--)
    n = t(n, r.value, i), r = r.prev;
  return n;
};
Yi.prototype.toArray = function() {
  for (var t = new Array(this.length), e = 0, n = this.head; n !== null; e++)
    t[e] = n.value, n = n.next;
  return t;
};
Yi.prototype.toArrayReverse = function() {
  for (var t = new Array(this.length), e = 0, n = this.tail; n !== null; e++)
    t[e] = n.value, n = n.prev;
  return t;
};
Yi.prototype.slice = function(t, e) {
  e = e || this.length, e < 0 && (e += this.length), t = t || 0, t < 0 && (t += this.length);
  var n = new Yi();
  if (e < t || e < 0)
    return n;
  t < 0 && (t = 0), e > this.length && (e = this.length);
  for (var r = 0, i = this.head; i !== null && r < t; r++)
    i = i.next;
  for (; i !== null && r < e; r++, i = i.next)
    n.push(i.value);
  return n;
};
Yi.prototype.sliceReverse = function(t, e) {
  e = e || this.length, e < 0 && (e += this.length), t = t || 0, t < 0 && (t += this.length);
  var n = new Yi();
  if (e < t || e < 0)
    return n;
  t < 0 && (t = 0), e > this.length && (e = this.length);
  for (var r = this.length, i = this.tail; i !== null && r > e; r--)
    i = i.prev;
  for (; i !== null && r > t; r--, i = i.prev)
    n.push(i.value);
  return n;
};
Yi.prototype.splice = function(t, e, ...n) {
  t > this.length && (t = this.length - 1), t < 0 && (t = this.length + t);
  for (var r = 0, i = this.head; i !== null && r < t; r++)
    i = i.next;
  for (var o = [], r = 0; i && r < e; r++)
    o.push(i.value), i = this.removeNode(i);
  i === null && (i = this.tail), i !== this.head && i !== this.tail && (i = i.prev);
  for (var r = 0; r < n.length; r++)
    i = yxt(this, i, n[r]);
  return o;
};
Yi.prototype.reverse = function() {
  for (var t = this.head, e = this.tail, n = t; n !== null; n = n.prev) {
    var r = n.prev;
    n.prev = n.next, n.next = r;
  }
  return this.head = e, this.tail = t, this;
};
function yxt(t, e, n) {
  var r = e === t.head ? new zv(n, null, e, t) : new zv(n, e, e.next, t);
  return r.next === null && (t.tail = r), r.prev === null && (t.head = r), t.length++, r;
}
function vxt(t, e) {
  t.tail = new zv(e, t.tail, null, t), t.head || (t.head = t.tail), t.length++;
}
function Bxt(t, e) {
  t.head = new zv(e, null, t.head, t), t.tail || (t.tail = t.head), t.length++;
}
function zv(t, e, n, r) {
  if (!(this instanceof zv))
    return new zv(t, e, n, r);
  this.list = r, this.value = t, e ? (e.next = this, this.prev = e) : this.prev = null, n ? (n.prev = this, this.next = n) : this.next = null;
}
try {
  Cxt()(Yi);
} catch {
}
const bxt = Ext, Vy = Symbol("max"), z0 = Symbol("length"), W1 = Symbol("lengthCalculator"), pD = Symbol("allowStale"), ov = Symbol("maxAge"), $0 = Symbol("dispose"), HEe = Symbol("noDisposeOnSet"), _A = Symbol("lruList"), Sh = Symbol("cache"), Z4e = Symbol("updateAgeOnGet"), Gz = () => 1;
let _xt = class {
  constructor(e) {
    if (typeof e == "number" && (e = { max: e }), e || (e = {}), e.max && (typeof e.max != "number" || e.max < 0))
      throw new TypeError("max must be a non-negative number");
    this[Vy] = e.max || 1 / 0;
    const n = e.length || Gz;
    if (this[W1] = typeof n != "function" ? Gz : n, this[pD] = e.stale || !1, e.maxAge && typeof e.maxAge != "number")
      throw new TypeError("maxAge must be a number");
    this[ov] = e.maxAge || 0, this[$0] = e.dispose, this[HEe] = e.noDisposeOnSet || !1, this[Z4e] = e.updateAgeOnGet || !1, this.reset();
  }
  // resize the cache when the max changes.
  set max(e) {
    if (typeof e != "number" || e < 0)
      throw new TypeError("max must be a non-negative number");
    this[Vy] = e || 1 / 0, Hx(this);
  }
  get max() {
    return this[Vy];
  }
  set allowStale(e) {
    this[pD] = !!e;
  }
  get allowStale() {
    return this[pD];
  }
  set maxAge(e) {
    if (typeof e != "number")
      throw new TypeError("maxAge must be a non-negative number");
    this[ov] = e, Hx(this);
  }
  get maxAge() {
    return this[ov];
  }
  // resize the cache when the lengthCalculator changes.
  set lengthCalculator(e) {
    typeof e != "function" && (e = Gz), e !== this[W1] && (this[W1] = e, this[z0] = 0, this[_A].forEach((n) => {
      n.length = this[W1](n.value, n.key), this[z0] += n.length;
    })), Hx(this);
  }
  get lengthCalculator() {
    return this[W1];
  }
  get length() {
    return this[z0];
  }
  get itemCount() {
    return this[_A].length;
  }
  rforEach(e, n) {
    n = n || this;
    for (let r = this[_A].tail; r !== null; ) {
      const i = r.prev;
      $Ee(this, e, r, n), r = i;
    }
  }
  forEach(e, n) {
    n = n || this;
    for (let r = this[_A].head; r !== null; ) {
      const i = r.next;
      $Ee(this, e, r, n), r = i;
    }
  }
  keys() {
    return this[_A].toArray().map((e) => e.key);
  }
  values() {
    return this[_A].toArray().map((e) => e.value);
  }
  reset() {
    this[$0] && this[_A] && this[_A].length && this[_A].forEach((e) => this[$0](e.key, e.value)), this[Sh] = /* @__PURE__ */ new Map(), this[_A] = new bxt(), this[z0] = 0;
  }
  dump() {
    return this[_A].map((e) => k4(this, e) ? !1 : {
      k: e.key,
      v: e.value,
      e: e.now + (e.maxAge || 0)
    }).toArray().filter((e) => e);
  }
  dumpLru() {
    return this[_A];
  }
  set(e, n, r) {
    if (r = r || this[ov], r && typeof r != "number")
      throw new TypeError("maxAge must be a number");
    const i = r ? Date.now() : 0, o = this[W1](n, e);
    if (this[Sh].has(e)) {
      if (o > this[Vy])
        return M_(this, this[Sh].get(e)), !1;
      const A = this[Sh].get(e).value;
      return this[$0] && (this[HEe] || this[$0](e, A.value)), A.now = i, A.maxAge = r, A.value = n, this[z0] += o - A.length, A.length = o, this.get(e), Hx(this), !0;
    }
    const s = new Sxt(e, n, o, i, r);
    return s.length > this[Vy] ? (this[$0] && this[$0](e, n), !1) : (this[z0] += s.length, this[_A].unshift(s), this[Sh].set(e, this[_A].head), Hx(this), !0);
  }
  has(e) {
    if (!this[Sh].has(e))
      return !1;
    const n = this[Sh].get(e).value;
    return !k4(this, n);
  }
  get(e) {
    return Uz(this, e, !0);
  }
  peek(e) {
    return Uz(this, e, !1);
  }
  pop() {
    const e = this[_A].tail;
    return e ? (M_(this, e), e.value) : null;
  }
  del(e) {
    M_(this, this[Sh].get(e));
  }
  load(e) {
    this.reset();
    const n = Date.now();
    for (let r = e.length - 1; r >= 0; r--) {
      const i = e[r], o = i.e || 0;
      if (o === 0)
        this.set(i.k, i.v);
      else {
        const s = o - n;
        s > 0 && this.set(i.k, i.v, s);
      }
    }
  }
  prune() {
    this[Sh].forEach((e, n) => Uz(this, n, !1));
  }
};
const Uz = (t, e, n) => {
  const r = t[Sh].get(e);
  if (r) {
    const i = r.value;
    if (k4(t, i)) {
      if (M_(t, r), !t[pD])
        return;
    } else
      n && (t[Z4e] && (r.value.now = Date.now()), t[_A].unshiftNode(r));
    return i.value;
  }
}, k4 = (t, e) => {
  if (!e || !e.maxAge && !t[ov])
    return !1;
  const n = Date.now() - e.now;
  return e.maxAge ? n > e.maxAge : t[ov] && n > t[ov];
}, Hx = (t) => {
  if (t[z0] > t[Vy])
    for (let e = t[_A].tail; t[z0] > t[Vy] && e !== null; ) {
      const n = e.prev;
      M_(t, e), e = n;
    }
}, M_ = (t, e) => {
  if (e) {
    const n = e.value;
    t[$0] && t[$0](n.key, n.value), t[z0] -= n.length, t[Sh].delete(n.key), t[_A].removeNode(e);
  }
};
let Sxt = class {
  constructor(e, n, r, i, o) {
    this.key = e, this.value = n, this.length = r, this.now = i, this.maxAge = o || 0;
  }
};
const $Ee = (t, e, n, r) => {
  let i = n.value;
  k4(t, i) && (M_(t, n), t[pD] || (i = void 0)), i && e.call(r, i.value, i.key, t);
};
var Qxt = _xt, Hz, qEe;
function Sd() {
  if (qEe)
    return Hz;
  qEe = 1;
  class t {
    constructor(k, $) {
      if ($ = r($), k instanceof t)
        return k.loose === !!$.loose && k.includePrerelease === !!$.includePrerelease ? k : new t(k.raw, $);
      if (k instanceof i)
        return this.raw = k.value, this.set = [[k]], this.format(), this;
      if (this.options = $, this.loose = !!$.loose, this.includePrerelease = !!$.includePrerelease, this.raw = k, this.set = k.split("||").map((U) => this.parseRange(U.trim())).filter((U) => U.length), !this.set.length)
        throw new TypeError(`Invalid SemVer Range: ${k}`);
      if (this.set.length > 1) {
        const U = this.set[0];
        if (this.set = this.set.filter((X) => !f(X[0])), this.set.length === 0)
          this.set = [U];
        else if (this.set.length > 1) {
          for (const X of this.set)
            if (X.length === 1 && h(X[0])) {
              this.set = [X];
              break;
            }
        }
      }
      this.format();
    }
    format() {
      return this.range = this.set.map((k) => k.join(" ").trim()).join("||").trim(), this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(k) {
      k = k.trim();
      const U = `parseRange:${Object.keys(this.options).join(",")}:${k}`, X = n.get(U);
      if (X)
        return X;
      const K = this.options.loose, z = K ? a[A.HYPHENRANGELOOSE] : a[A.HYPHENRANGE];
      k = k.replace(z, O(this.options.includePrerelease)), o("hyphen replace", k), k = k.replace(a[A.COMPARATORTRIM], l), o("comparator trim", k), k = k.replace(a[A.TILDETRIM], c), k = k.replace(a[A.CARETTRIM], u), k = k.split(/\s+/).join(" ");
      let Y = k.split(" ").map((ee) => I(ee, this.options)).join(" ").split(/\s+/).map((ee) => M(ee, this.options));
      K && (Y = Y.filter((ee) => (o("loose invalid filter", ee, this.options), !!ee.match(a[A.COMPARATORLOOSE])))), o("range list", Y);
      const V = /* @__PURE__ */ new Map(), Z = Y.map((ee) => new i(ee, this.options));
      for (const ee of Z) {
        if (f(ee))
          return [ee];
        V.set(ee.value, ee);
      }
      V.size > 1 && V.has("") && V.delete("");
      const ce = [...V.values()];
      return n.set(U, ce), ce;
    }
    intersects(k, $) {
      if (!(k instanceof t))
        throw new TypeError("a Range is required");
      return this.set.some((U) => d(U, $) && k.set.some((X) => d(X, $) && U.every((K) => X.every((z) => K.intersects(z, $)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(k) {
      if (!k)
        return !1;
      if (typeof k == "string")
        try {
          k = new s(k, this.options);
        } catch {
          return !1;
        }
      for (let $ = 0; $ < this.set.length; $++)
        if (L(this.set[$], k, this.options))
          return !0;
      return !1;
    }
  }
  Hz = t;
  const e = Qxt, n = new e({ max: 1e3 }), r = $H, i = jH(), o = HH, s = Zc, {
    re: a,
    t: A,
    comparatorTrimReplace: l,
    tildeTrimReplace: c,
    caretTrimReplace: u
  } = tw, f = (N) => N.value === "<0.0.0-0", h = (N) => N.value === "", d = (N, k) => {
    let $ = !0;
    const U = N.slice();
    let X = U.pop();
    for (; $ && U.length; )
      $ = U.every((K) => X.intersects(K, k)), X = U.pop();
    return $;
  }, I = (N, k) => (o("comp", N, k), N = v(N, k), o("caret", N), N = C(N, k), o("tildes", N), N = Q(N, k), o("xrange", N), N = R(N, k), o("stars", N), N), m = (N) => !N || N.toLowerCase() === "x" || N === "*", C = (N, k) => N.trim().split(/\s+/).map(($) => y($, k)).join(" "), y = (N, k) => {
    const $ = k.loose ? a[A.TILDELOOSE] : a[A.TILDE];
    return N.replace($, (U, X, K, z, Y) => {
      o("tilde", N, U, X, K, z, Y);
      let V;
      return m(X) ? V = "" : m(K) ? V = `>=${X}.0.0 <${+X + 1}.0.0-0` : m(z) ? V = `>=${X}.${K}.0 <${X}.${+K + 1}.0-0` : Y ? (o("replaceTilde pr", Y), V = `>=${X}.${K}.${z}-${Y} <${X}.${+K + 1}.0-0`) : V = `>=${X}.${K}.${z} <${X}.${+K + 1}.0-0`, o("tilde return", V), V;
    });
  }, v = (N, k) => N.trim().split(/\s+/).map(($) => b($, k)).join(" "), b = (N, k) => {
    o("caret", N, k);
    const $ = k.loose ? a[A.CARETLOOSE] : a[A.CARET], U = k.includePrerelease ? "-0" : "";
    return N.replace($, (X, K, z, Y, V) => {
      o("caret", N, X, K, z, Y, V);
      let Z;
      return m(K) ? Z = "" : m(z) ? Z = `>=${K}.0.0${U} <${+K + 1}.0.0-0` : m(Y) ? K === "0" ? Z = `>=${K}.${z}.0${U} <${K}.${+z + 1}.0-0` : Z = `>=${K}.${z}.0${U} <${+K + 1}.0.0-0` : V ? (o("replaceCaret pr", V), K === "0" ? z === "0" ? Z = `>=${K}.${z}.${Y}-${V} <${K}.${z}.${+Y + 1}-0` : Z = `>=${K}.${z}.${Y}-${V} <${K}.${+z + 1}.0-0` : Z = `>=${K}.${z}.${Y}-${V} <${+K + 1}.0.0-0`) : (o("no pr"), K === "0" ? z === "0" ? Z = `>=${K}.${z}.${Y}${U} <${K}.${z}.${+Y + 1}-0` : Z = `>=${K}.${z}.${Y}${U} <${K}.${+z + 1}.0-0` : Z = `>=${K}.${z}.${Y} <${+K + 1}.0.0-0`), o("caret return", Z), Z;
    });
  }, Q = (N, k) => (o("replaceXRanges", N, k), N.split(/\s+/).map(($) => w($, k)).join(" ")), w = (N, k) => {
    N = N.trim();
    const $ = k.loose ? a[A.XRANGELOOSE] : a[A.XRANGE];
    return N.replace($, (U, X, K, z, Y, V) => {
      o("xRange", N, U, X, K, z, Y, V);
      const Z = m(K), ce = Z || m(z), ee = ce || m(Y), pe = ee;
      return X === "=" && pe && (X = ""), V = k.includePrerelease ? "-0" : "", Z ? X === ">" || X === "<" ? U = "<0.0.0-0" : U = "*" : X && pe ? (ce && (z = 0), Y = 0, X === ">" ? (X = ">=", ce ? (K = +K + 1, z = 0, Y = 0) : (z = +z + 1, Y = 0)) : X === "<=" && (X = "<", ce ? K = +K + 1 : z = +z + 1), X === "<" && (V = "-0"), U = `${X + K}.${z}.${Y}${V}`) : ce ? U = `>=${K}.0.0${V} <${+K + 1}.0.0-0` : ee && (U = `>=${K}.${z}.0${V} <${K}.${+z + 1}.0-0`), o("xRange return", U), U;
    });
  }, R = (N, k) => (o("replaceStars", N, k), N.trim().replace(a[A.STAR], "")), M = (N, k) => (o("replaceGTE0", N, k), N.trim().replace(a[k.includePrerelease ? A.GTE0PRE : A.GTE0], "")), O = (N) => (k, $, U, X, K, z, Y, V, Z, ce, ee, pe, Ce) => (m(U) ? $ = "" : m(X) ? $ = `>=${U}.0.0${N ? "-0" : ""}` : m(K) ? $ = `>=${U}.${X}.0${N ? "-0" : ""}` : z ? $ = `>=${$}` : $ = `>=${$}${N ? "-0" : ""}`, m(Z) ? V = "" : m(ce) ? V = `<${+Z + 1}.0.0-0` : m(ee) ? V = `<${Z}.${+ce + 1}.0-0` : pe ? V = `<=${Z}.${ce}.${ee}-${pe}` : N ? V = `<${Z}.${ce}.${+ee + 1}-0` : V = `<=${V}`, `${$} ${V}`.trim()), L = (N, k, $) => {
    for (let U = 0; U < N.length; U++)
      if (!N[U].test(k))
        return !1;
    if (k.prerelease.length && !$.includePrerelease) {
      for (let U = 0; U < N.length; U++)
        if (o(N[U].semver), N[U].semver !== i.ANY && N[U].semver.prerelease.length > 0) {
          const X = N[U].semver;
          if (X.major === k.major && X.minor === k.minor && X.patch === k.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return Hz;
}
var $z, jEe;
function jH() {
  if (jEe)
    return $z;
  jEe = 1;
  const t = Symbol("SemVer ANY");
  class e {
    static get ANY() {
      return t;
    }
    constructor(c, u) {
      if (u = n(u), c instanceof e) {
        if (c.loose === !!u.loose)
          return c;
        c = c.value;
      }
      s("comparator", c, u), this.options = u, this.loose = !!u.loose, this.parse(c), this.semver === t ? this.value = "" : this.value = this.operator + this.semver.version, s("comp", this);
    }
    parse(c) {
      const u = this.options.loose ? r[i.COMPARATORLOOSE] : r[i.COMPARATOR], f = c.match(u);
      if (!f)
        throw new TypeError(`Invalid comparator: ${c}`);
      this.operator = f[1] !== void 0 ? f[1] : "", this.operator === "=" && (this.operator = ""), f[2] ? this.semver = new a(f[2], this.options.loose) : this.semver = t;
    }
    toString() {
      return this.value;
    }
    test(c) {
      if (s("Comparator.test", c, this.options.loose), this.semver === t || c === t)
        return !0;
      if (typeof c == "string")
        try {
          c = new a(c, this.options);
        } catch {
          return !1;
        }
      return o(c, this.operator, this.semver, this.options);
    }
    intersects(c, u) {
      if (!(c instanceof e))
        throw new TypeError("a Comparator is required");
      if ((!u || typeof u != "object") && (u = {
        loose: !!u,
        includePrerelease: !1
      }), this.operator === "")
        return this.value === "" ? !0 : new A(c.value, u).test(this.value);
      if (c.operator === "")
        return c.value === "" ? !0 : new A(this.value, u).test(c.semver);
      const f = (this.operator === ">=" || this.operator === ">") && (c.operator === ">=" || c.operator === ">"), h = (this.operator === "<=" || this.operator === "<") && (c.operator === "<=" || c.operator === "<"), d = this.semver.version === c.semver.version, I = (this.operator === ">=" || this.operator === "<=") && (c.operator === ">=" || c.operator === "<="), m = o(this.semver, "<", c.semver, u) && (this.operator === ">=" || this.operator === ">") && (c.operator === "<=" || c.operator === "<"), C = o(this.semver, ">", c.semver, u) && (this.operator === "<=" || this.operator === "<") && (c.operator === ">=" || c.operator === ">");
      return f || h || d && I || m || C;
    }
  }
  $z = e;
  const n = $H, { re: r, t: i } = tw, o = X4e, s = HH, a = Zc, A = Sd();
  return $z;
}
const wxt = Sd(), xxt = (t, e, n) => {
  try {
    e = new wxt(e, n);
  } catch {
    return !1;
  }
  return e.test(t);
};
var YH = xxt;
const Rxt = Sd(), Dxt = (t, e) => new Rxt(t, e).set.map((n) => n.map((r) => r.value).join(" ").trim().split(" "));
var Txt = Dxt;
const Nxt = Zc, Lxt = Sd(), Mxt = (t, e, n) => {
  let r = null, i = null, o = null;
  try {
    o = new Lxt(e, n);
  } catch {
    return null;
  }
  return t.forEach((s) => {
    o.test(s) && (!r || i.compare(s) === -1) && (r = s, i = new Nxt(r, n));
  }), r;
};
var Oxt = Mxt;
const Fxt = Zc, Pxt = Sd(), kxt = (t, e, n) => {
  let r = null, i = null, o = null;
  try {
    o = new Pxt(e, n);
  } catch {
    return null;
  }
  return t.forEach((s) => {
    o.test(s) && (!r || i.compare(s) === 1) && (r = s, i = new Fxt(r, n));
  }), r;
};
var Gxt = kxt;
const qz = Zc, Uxt = Sd(), YEe = qH, Hxt = (t, e) => {
  t = new Uxt(t, e);
  let n = new qz("0.0.0");
  if (t.test(n) || (n = new qz("0.0.0-0"), t.test(n)))
    return n;
  n = null;
  for (let r = 0; r < t.set.length; ++r) {
    const i = t.set[r];
    let o = null;
    i.forEach((s) => {
      const a = new qz(s.semver.version);
      switch (s.operator) {
        case ">":
          a.prerelease.length === 0 ? a.patch++ : a.prerelease.push(0), a.raw = a.format();
        case "":
        case ">=":
          (!o || YEe(a, o)) && (o = a);
          break;
        case "<":
        case "<=":
          break;
        default:
          throw new Error(`Unexpected operation: ${s.operator}`);
      }
    }), o && (!n || YEe(n, o)) && (n = o);
  }
  return n && t.test(n) ? n : null;
};
var $xt = Hxt;
const qxt = Sd(), jxt = (t, e) => {
  try {
    return new qxt(t, e).range || "*";
  } catch {
    return null;
  }
};
var Yxt = jxt;
const zxt = Zc, eUe = jH(), { ANY: Vxt } = eUe, Jxt = Sd(), Kxt = YH, zEe = qH, VEe = uae, Wxt = gae, Xxt = fae, Zxt = (t, e, n, r) => {
  t = new zxt(t, r), e = new Jxt(e, r);
  let i, o, s, a, A;
  switch (n) {
    case ">":
      i = zEe, o = Wxt, s = VEe, a = ">", A = ">=";
      break;
    case "<":
      i = VEe, o = Xxt, s = zEe, a = "<", A = "<=";
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }
  if (Kxt(t, e, r))
    return !1;
  for (let l = 0; l < e.set.length; ++l) {
    const c = e.set[l];
    let u = null, f = null;
    if (c.forEach((h) => {
      h.semver === Vxt && (h = new eUe(">=0.0.0")), u = u || h, f = f || h, i(h.semver, u.semver, r) ? u = h : s(h.semver, f.semver, r) && (f = h);
    }), u.operator === a || u.operator === A || (!f.operator || f.operator === a) && o(t, f.semver))
      return !1;
    if (f.operator === A && s(t, f.semver))
      return !1;
  }
  return !0;
};
var hae = Zxt;
const e2t = hae, t2t = (t, e, n) => e2t(t, e, ">", n);
var n2t = t2t;
const r2t = hae, i2t = (t, e, n) => r2t(t, e, "<", n);
var o2t = i2t;
const JEe = Sd(), s2t = (t, e, n) => (t = new JEe(t, n), e = new JEe(e, n), t.intersects(e));
var a2t = s2t;
const A2t = YH, l2t = _d;
var c2t = (t, e, n) => {
  const r = [];
  let i = null, o = null;
  const s = t.sort((c, u) => l2t(c, u, n));
  for (const c of s)
    A2t(c, e, n) ? (o = c, i || (i = c)) : (o && r.push([i, o]), o = null, i = null);
  i && r.push([i, null]);
  const a = [];
  for (const [c, u] of r)
    c === u ? a.push(c) : !u && c === s[0] ? a.push("*") : u ? c === s[0] ? a.push(`<=${u}`) : a.push(`${c} - ${u}`) : a.push(`>=${c}`);
  const A = a.join(" || "), l = typeof e.raw == "string" ? e.raw : String(e);
  return A.length < l.length ? A : e;
};
const KEe = Sd(), gk = jH(), { ANY: jz } = gk, $x = YH, dae = _d, u2t = (t, e, n = {}) => {
  if (t === e)
    return !0;
  t = new KEe(t, n), e = new KEe(e, n);
  let r = !1;
  e:
    for (const i of t.set) {
      for (const o of e.set) {
        const s = f2t(i, o, n);
        if (r = r || s !== null, s)
          continue e;
      }
      if (r)
        return !1;
    }
  return !0;
}, f2t = (t, e, n) => {
  if (t === e)
    return !0;
  if (t.length === 1 && t[0].semver === jz) {
    if (e.length === 1 && e[0].semver === jz)
      return !0;
    n.includePrerelease ? t = [new gk(">=0.0.0-0")] : t = [new gk(">=0.0.0")];
  }
  if (e.length === 1 && e[0].semver === jz) {
    if (n.includePrerelease)
      return !0;
    e = [new gk(">=0.0.0")];
  }
  const r = /* @__PURE__ */ new Set();
  let i, o;
  for (const h of t)
    h.operator === ">" || h.operator === ">=" ? i = WEe(i, h, n) : h.operator === "<" || h.operator === "<=" ? o = XEe(o, h, n) : r.add(h.semver);
  if (r.size > 1)
    return null;
  let s;
  if (i && o) {
    if (s = dae(i.semver, o.semver, n), s > 0)
      return null;
    if (s === 0 && (i.operator !== ">=" || o.operator !== "<="))
      return null;
  }
  for (const h of r) {
    if (i && !$x(h, String(i), n) || o && !$x(h, String(o), n))
      return null;
    for (const d of e)
      if (!$x(h, String(d), n))
        return !1;
    return !0;
  }
  let a, A, l, c, u = o && !n.includePrerelease && o.semver.prerelease.length ? o.semver : !1, f = i && !n.includePrerelease && i.semver.prerelease.length ? i.semver : !1;
  u && u.prerelease.length === 1 && o.operator === "<" && u.prerelease[0] === 0 && (u = !1);
  for (const h of e) {
    if (c = c || h.operator === ">" || h.operator === ">=", l = l || h.operator === "<" || h.operator === "<=", i) {
      if (f && h.semver.prerelease && h.semver.prerelease.length && h.semver.major === f.major && h.semver.minor === f.minor && h.semver.patch === f.patch && (f = !1), h.operator === ">" || h.operator === ">=") {
        if (a = WEe(i, h, n), a === h && a !== i)
          return !1;
      } else if (i.operator === ">=" && !$x(i.semver, String(h), n))
        return !1;
    }
    if (o) {
      if (u && h.semver.prerelease && h.semver.prerelease.length && h.semver.major === u.major && h.semver.minor === u.minor && h.semver.patch === u.patch && (u = !1), h.operator === "<" || h.operator === "<=") {
        if (A = XEe(o, h, n), A === h && A !== o)
          return !1;
      } else if (o.operator === "<=" && !$x(o.semver, String(h), n))
        return !1;
    }
    if (!h.operator && (o || i) && s !== 0)
      return !1;
  }
  return !(i && l && !o && s !== 0 || o && c && !i && s !== 0 || f || u);
}, WEe = (t, e, n) => {
  if (!t)
    return e;
  const r = dae(t.semver, e.semver, n);
  return r > 0 ? t : r < 0 || e.operator === ">" && t.operator === ">=" ? e : t;
}, XEe = (t, e, n) => {
  if (!t)
    return e;
  const r = dae(t.semver, e.semver, n);
  return r < 0 ? t : r > 0 || e.operator === "<" && t.operator === "<=" ? e : t;
};
var g2t = u2t;
const Yz = tw, h2t = UH, d2t = Zc, ZEe = K4e, p2t = nw, I2t = dwt, m2t = mwt, C2t = Ewt, E2t = Swt, y2t = xwt, v2t = Twt, B2t = Mwt, b2t = Pwt, _2t = _d, S2t = Uwt, Q2t = qwt, w2t = cae, x2t = Vwt, R2t = Wwt, D2t = qH, T2t = uae, N2t = lae, L2t = W4e, M2t = fae, O2t = gae, F2t = X4e, P2t = mxt, k2t = jH(), G2t = Sd(), U2t = YH, H2t = Txt, $2t = Oxt, q2t = Gxt, j2t = $xt, Y2t = Yxt, z2t = hae, V2t = n2t, J2t = o2t, K2t = a2t, W2t = c2t, X2t = g2t;
var Z2t = {
  parse: p2t,
  valid: I2t,
  clean: m2t,
  inc: C2t,
  diff: E2t,
  major: y2t,
  minor: v2t,
  patch: B2t,
  prerelease: b2t,
  compare: _2t,
  rcompare: S2t,
  compareLoose: Q2t,
  compareBuild: w2t,
  sort: x2t,
  rsort: R2t,
  gt: D2t,
  lt: T2t,
  eq: N2t,
  neq: L2t,
  gte: M2t,
  lte: O2t,
  cmp: F2t,
  coerce: P2t,
  Comparator: k2t,
  Range: G2t,
  satisfies: U2t,
  toComparators: H2t,
  maxSatisfying: $2t,
  minSatisfying: q2t,
  minVersion: j2t,
  validRange: Y2t,
  outside: z2t,
  gtr: V2t,
  ltr: J2t,
  intersects: K2t,
  simplifyRange: W2t,
  subset: X2t,
  SemVer: d2t,
  re: Yz.re,
  src: Yz.src,
  tokens: Yz.t,
  SEMVER_SPEC_VERSION: h2t.SEMVER_SPEC_VERSION,
  compareIdentifiers: ZEe.compareIdentifiers,
  rcompareIdentifiers: ZEe.rcompareIdentifiers
};
function pae(t) {
  return t.shape.version._def.value;
}
({
  ...ji(dR.map(([t]) => [pae(t), t])),
  // eslint-disable-next-line no-underscore-dangle
  [vv.shape.version._def.value]: 0
});
function eRt(t, e) {
  if ("version" in t) {
    const n = t?.version;
    Object.entries(tk).filter(([i, o]) => Z2t.gte(n, o[2])).map(([i]) => i).forEach((i) => {
      const o = tk[i][3], s = tk[i][0];
      "coordinationSpace" in t && typeof t.coordinationSpace == "object" && t.coordinationSpace !== null && s in t.coordinationSpace && e.addIssue({
        code: me.ZodIssueCode.custom,
        message: `The coordination type ${s} was changed to ${o} in view config schema version ${n}`,
        path: ["coordinationSpace", s]
      });
    });
  }
}
function tRt(t, e = null) {
  if (t?.version === vv.shape.version.value)
    return vv.parse(t);
  const n = dR.map(([r]) => pae(r));
  if (n.includes(t?.version)) {
    const r = n.indexOf(t.version);
    let i = dR[r][0];
    return dR.slice(r, dR.length).forEach((o) => {
      i = i.superRefine(eRt).transform((s) => {
        const a = o[1](s);
        return typeof e == "function" && e(s, a), a;
      });
    }), i = i.pipe(vv), i.parse(t);
  }
  throw typeof t == "object" && !("version" in t) ? new Error("Missing version") : new Error("Config version was not recognized");
}
function nRt(t) {
  return t.length === 0 ? me.null() : t.length === 1 ? me.literal(t[0]) : me.enum([t[0], ...t.slice(1, t.length)]);
}
function rRt(t, e) {
  return me.object({
    fileType: me.literal(t),
    options: e.optional(),
    url: me.string().optional(),
    requestInit: PH.describe("The properties of this object correspond to the parameters of the JavaScript fetch() function.").optional(),
    coordinationValues: me.record(me.string()).describe("Keys are coordination types. Values are coordination values. Used for matching views to files.").optional()
  });
}
function iRt(t) {
  return t.length === 0 ? me.null() : t.length === 1 ? t[0] : me.discriminatedUnion("fileType", [
    t[0],
    t[1],
    ...t.slice(2, t.length)
  ]);
}
function oRt(t, e, n, r) {
  const i = [...t, ...e].map((s) => rRt(s.name, s.optionsSchema)), o = iRt(i);
  return me.object({
    // eslint-disable-next-line no-underscore-dangle
    version: me.literal(pae(vv)).describe("The schema version for the view config."),
    uid: me.string().optional(),
    name: me.string(),
    public: me.boolean().optional(),
    description: me.string().optional(),
    datasets: me.array(me.object({
      uid: me.string(),
      name: me.string().optional(),
      description: me.string().optional(),
      files: me.array(o)
    })).describe("The datasets array defines groups of files, where the files within each dataset reference the same entities (cells, genes, cell sets, etc)."),
    // Merge with coordination type schemas.
    coordinationSpace: me.object(
      // Wrap each value schema in z.record()
      ji(n.map((s) => [
        s.name,
        me.record(
          // For now, assume the key type is string (though it would be
          // slightly nicer if we could use the coordinationScopeName schema here).
          // Once https://github.com/colinhacks/zod/issues/2746 gets resolved
          // then we can try that approach again, but it should not be a big deal.
          s.valueSchema.optional()
        ).optional()
      ]))
    ).strict().describe("The coordination space stores the values for each scope of each coordination object.").optional(),
    layout: me.array(me.object({
      uid: me.string().describe("A unique identifier for the view, to refer to it in getter and setter functions in object-oriented contexts.").optional(),
      component: nRt(r.map((s) => s.name)).describe("Specify a component using a name defined in the component registry."),
      props: me.record(me.any()).describe("Extra prop values for the component.").optional(),
      x: me.number().int(),
      y: me.number().int(),
      w: me.number().int().optional(),
      h: me.number().int().optional(),
      coordinationScopes: k4e.optional(),
      coordinationScopesBy: G4e.optional()
    })).describe("The layout array defines the views, or components, rendered in the grid."),
    initStrategy: me.enum(["none", "auto"]).describe("The initialization strategy determines how missing coordination objects and coordination scope mappings are initially filled in.")
  });
}
const sRt = me.object({
  name: me.string(),
  url: me.string(),
  type: me.string(),
  metadata: me.object({
    dimensions: me.array(me.object({
      field: me.string(),
      type: me.enum(["quantitative", "nominal", "ordinal", "temporal"]),
      values: me.array(me.string()).nullable()
    })).optional(),
    isPyramid: me.boolean().optional(),
    transform: me.union([
      me.object({
        scale: me.number(),
        translate: me.object({
          y: me.number(),
          x: me.number()
        })
      }),
      me.object({
        matrix: me.array(me.number()).length(16)
      })
    ]).optional(),
    isBitmask: me.boolean().optional(),
    omeTiffOffsetsUrl: me.string().optional()
  }).optional(),
  requestInit: PH.optional()
}), bT = me.object({
  schemaVersion: me.literal("0.0.2"),
  usePhysicalSizeScaling: me.boolean().optional(),
  renderLayers: me.array(me.string()).optional(),
  images: me.array(sRt)
}), Iae = me.object({
  path: me.string()
}), zH = me.object({
  path: me.string(),
  dims: me.array(me.number()).optional()
}), aRt = me.object({
  path: me.string(),
  obsLabelsType: me.string()
}), ARt = me.object({
  path: me.string(),
  featureLabelsType: me.string()
}), lRt = me.object({
  path: me.string(),
  dims: me.array(me.number()).optional(),
  embeddingType: me.string()
}), tUe = Iae, nUe = Iae, mae = me.object({
  path: me.string(),
  featureFilterPath: me.string().optional().describe("If the feature index should be filtered, put a boolean column here (analogous to the previous geneFilter option). e.g., var/in_obsm_X_small_matrix"),
  initialFeatureFilterPath: me.string().optional().describe("If only a subset of the matrix should be loaded initially, put a boolean column along the feature axis here (analogous to the previous matrixGeneFilter option). e.g., var/highly_variable")
}), Cae = me.array(me.object({
  name: me.string().describe("The display name for the set, like 'Cell Type' or 'Louvain.'"),
  path: me.union([
    me.string().describe("The location in the AnnData store for the set, like 'obs/louvain' or 'obs/celltype.'"),
    me.array(me.string()).describe("An array of locations in the AnnData store for a hierarchy of set names, from coarse to fine levels.")
  ]),
  scorePath: me.string().optional().describe("The location in the AnnData store for the set confidence scores, like 'obs/celltype_prediction_score.'")
})), cRt = zH, uRt = zH, VH = zH, rUe = zH, iUe = Iae, oUe = me.array(me.union([
  me.object({
    type: me.literal("identity")
  }),
  me.object({
    type: me.literal("translation"),
    translation: me.array(me.number())
  }),
  me.object({
    type: me.literal("scale"),
    scale: me.array(me.number())
  })
])), sUe = me.object({
  offsetsUrl: me.string().optional(),
  coordinateTransformations: oUe.optional()
}), fRt = sUe.extend({
  obsTypesFromChannelNames: me.boolean().optional()
}), Eae = me.object({
  coordinateTransformations: oUe.optional()
}), gRt = Eae.extend({
  obsTypesFromChannelNames: me.boolean().optional()
}), aUe = Eae.extend({
  path: me.string()
}), EZ = me.object({
  // TODO: should this also extend the imageOmeZarrSchema?
  // TODO: should this be renamed labelsSpatialdataSchema?
  // TODO: support obsTypesFromChannelNames?
  path: me.string()
});
me.object({
  path: me.string()
});
const AUe = me.object({
  path: me.string(),
  tablePath: me.string().optional().describe("The path to a table which annotates the spots. If available but not specified, the spot identifiers may not be aligned with associated tabular data as expected.")
}), lUe = mae.extend({
  region: me.string().describe("The name of a region to use to filter instances (i.e., rows) in the table").optional()
}), cUe = me.object({
  region: me.string().describe("The name of a region to use to filter instances (i.e., rows) in the table").optional(),
  tablePath: me.string().optional().describe("The path to a table which contains the index for the set values."),
  obsSets: Cae
}), eye = rUe, tye = VH, nye = VH, rye = VH, iye = iUe, oye = Cae, sye = mae, aye = tUe, Aye = nUe, hRt = me.object({
  obsIndex: me.string(),
  obsEmbedding: me.array(me.string()).length(2)
  // TODO: support 3D?
}), dRt = me.object({
  obsIndex: me.string(),
  obsSpots: me.array(me.string()).length(2)
  // TODO: support 3D?
}), pRt = me.object({
  obsIndex: me.string(),
  obsPoints: me.array(me.string()).length(3)
}), IRt = me.object({
  obsIndex: me.string(),
  obsLocations: me.array(me.string()).length(2)
  // TODO: support 3D?
}), mRt = me.object({
  obsIndex: me.string(),
  obsLabels: me.string()
}), CRt = me.object({
  featureIndex: me.string(),
  featureLabels: me.string()
}), ERt = me.object({
  obsIndex: me.string(),
  obsSets: me.array(me.object({
    name: me.string(),
    column: me.union([
      me.string(),
      me.array(me.string())
    ]),
    scoreColumn: me.string().optional()
  }))
}), yRt = me.object({
  obsLabels: me.union([
    tUe,
    me.array(aRt)
  ]),
  featureLabels: me.union([
    nUe,
    me.array(ARt)
  ]),
  obsFeatureMatrix: mae,
  obsSets: Cae,
  obsSpots: cRt,
  obsPoints: uRt,
  obsLocations: VH,
  obsSegmentations: iUe,
  obsEmbedding: me.union([
    rUe,
    me.array(lRt)
  ])
}).partial(), vRt = me.object({
  // TODO: should `image` be a special schema
  // to allow specifying fileUid (like for embeddingType)?
  image: aUe,
  // TODO: should this be a special schema
  // to allow specifying fileUid (like for embeddingType)?
  labels: EZ,
  obsFeatureMatrix: lUe,
  obsSpots: AUe,
  // TODO: obsPoints
  // TODO: obsLocations
  obsSets: cUe
}).partial(), BRt = me.object({
  obsLabelsTypes: me.array(me.string()).optional(),
  embeddingTypes: me.array(me.string()).optional()
}).optional(), bRt = me.object({
  xy: me.string().optional(),
  poly: me.string().optional(),
  factors: me.array(me.string()).optional(),
  mappings: me.record(me.object({
    key: me.string(),
    dims: me.array(me.number()).length(2)
  })).optional()
}), _Rt = me.array(me.object({
  groupName: me.string(),
  setName: me.union([
    me.string(),
    me.array(me.string())
  ]),
  scoreName: me.string().optional()
})), SRt = me.object({
  matrix: me.string(),
  geneFilter: me.string().optional(),
  matrixGeneFilter: me.string().optional(),
  geneAlias: me.string().optional()
}), lye = me.array(me.object({
  channels: me.array(me.object({
    color: me.array(me.number()).describe("The color to use when rendering this channel under the null colormap.").optional(),
    selection: me.record(me.any()).describe("Determines the channel selection, e.g. some Z and time slice."),
    slider: me.array(me.number()).describe("Determines the range for color mapping.").optional(),
    visible: me.boolean().describe("Determines whether this channel of the layer will be rendered in the spatial component.").optional()
  }).strict()),
  colormap: me.string().nullable(),
  transparentColor: me.array(me.number().describe("One of R G or B (0 - 255).")).length(3).describe("Determines the color to be set to opacity 0").nullable().optional(),
  index: me.number().describe("The index of the layer among the array of layers available in the image file."),
  opacity: me.number(),
  modelMatrix: me.array(me.number()).length(16).describe("transformation matrix for this layer").optional(),
  domainType: me.enum(["Full", "Min/Max"]).describe("Determines the extent of the channel slider input element in the layer controller.").optional(),
  resolution: me.number().describe("Resolution of 3D volumetric rendering").optional(),
  xSlice: me.array(me.any()).length(2).describe("Slice bounds").nullable().optional(),
  renderingMode: me.string().describe("Rendering mode of 3D volumetric rendering").optional(),
  ySlice: me.array(me.any()).length(2).describe("Slice bounds").nullable().optional(),
  zSlice: me.array(me.any()).length(2).describe("Slice bounds").nullable().optional(),
  type: me.enum(["raster", "bitmask"]).optional(),
  use3d: me.boolean().optional(),
  visible: me.boolean().describe("Determines whether this entire layer will be rendered in the spatial component.").optional()
}).strict().describe("The properties of this object are the rendering settings for the raster layer.")), QRt = me.object({
  visible: me.boolean(),
  stroked: me.boolean(),
  radius: me.number(),
  opacity: me.number()
}), wRt = me.object({
  visible: me.boolean()
}), xRt = me.object({
  visible: me.boolean(),
  radius: me.number(),
  opacity: me.number()
}), { grey: gF } = fft, cye = {
  white: "#FFFFFF",
  grayLight: "#D3D3D3",
  grayMid: "#808080",
  grayDark: "#555555",
  black: "#000000",
  grayDarkL5: "rgb(98, 98, 98)",
  grayDarkD15: "rgb(47, 47, 47)",
  grayMidL10: "rgb(154, 154, 154)",
  grayLightL10: "rgb(237, 237, 237)"
  // lighten(map-get($global-colors, "gray-light"), 10%);
}, uye = {
  // Use px instead of rem, so that sizing is consistent despite the root element font-size.
  // Reference: https://github.com/mui/material-ui/blob/627c08fc/src/styles/createTypography.js
  typography: {
    pxToRem: (t) => `${t}px`,
    display4: {
      fontSize: "112px"
    },
    display3: {
      fontSize: "56px"
    },
    display2: {
      fontSize: "45px"
    },
    display1: {
      fontSize: "34px"
    },
    headline: {
      fontSize: "24px"
    },
    title: {
      fontSize: "21px"
    },
    subheading: {
      fontSize: "16px"
    },
    body2: {
      fontSize: "14px"
    },
    body1: {
      fontSize: "14px"
    },
    caption: {
      fontSize: "12px"
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: !0
    }
  }
}, fye = {
  dark: FX({
    palette: {
      type: "dark",
      primary: gF,
      secondary: gF,
      primaryBackground: "#222222",
      primaryBackgroundHighlight: "#000000",
      primaryBackgroundInput: "#D3D3D3",
      primaryBackgroundDim: "#333333",
      primaryBackgroundLight: "#757575",
      primaryForeground: "#D3D3D3",
      primaryForegroundL5: "rgb(224, 224, 224)",
      primaryForegroundL10: "rgb(237, 237, 237)",
      primaryForegroundD15: "rgb(173, 173, 173)",
      primaryForegroundDim: "#000000",
      primaryForegroundActive: "#9bb7d6",
      secondaryBackground: "#000000",
      secondaryBackgroundDim: "#444444",
      secondaryForeground: "#D3D3D3",
      gridLayoutBackground: "#333333",
      cardBorder: "rgba(0, 0, 0, 0.125)",
      tooltipText: "#FFFFFF",
      ...cye
    },
    ...uye
  }),
  light: FX({
    palette: {
      type: "light",
      primary: gF,
      secondary: gF,
      primaryBackground: "#F1F1F1",
      primaryBackgroundHighlight: "#FFFFFF",
      primaryBackgroundInput: "#FFFFFF",
      primaryBackgroundDim: "#8A8A8A",
      primaryBackgroundLight: "#e0e0e0",
      primaryForeground: "#333333",
      primaryForegroundL5: "rgb(64, 64, 64)",
      primaryForegroundL10: "rgb(77, 77, 77)",
      primaryForegroundD15: "rgb(13, 13, 13)",
      primaryForegroundDim: "#808080",
      primaryForegroundActive: "#0074D9",
      secondaryBackground: "#F1F1F1",
      secondaryBackgroundDim: "#C0C0C0",
      secondaryForeground: "#222222",
      gridLayoutBackground: "#FFFFFF",
      cardBorder: "rgba(241, 241, 241, 0.125)",
      tooltipText: "rgba(0, 0, 0, 0.87)",
      ...cye
    },
    ...uye
  })
};
function RRt(t) {
  let e;
  const n = /* @__PURE__ */ new Set(), r = (l, c) => {
    const u = typeof l == "function" ? l(e) : l;
    if (u !== e) {
      const f = e;
      e = c ? u : Object.assign({}, e, u), n.forEach((h) => h(e, f));
    }
  }, i = () => e, o = (l, c = i, u = Object.is) => {
    console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
    let f = c(e);
    function h() {
      const d = c(e);
      if (!u(f, d)) {
        const I = f;
        l(f = d, I);
      }
    }
    return n.add(h), () => n.delete(h);
  }, A = { setState: r, getState: i, subscribe: (l, c, u) => c || u ? o(l, c, u) : (n.add(l), () => n.delete(l)), destroy: () => n.clear() };
  return e = t(r, i, A), A;
}
const DRt = typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent), gye = DRt ? Mn : nse;
function rw(t) {
  const e = typeof t == "function" ? RRt(t) : t, n = (r = e.getState, i = Object.is) => {
    const [, o] = T3e((m) => m + 1, 0), s = e.getState(), a = Zr(s), A = Zr(r), l = Zr(i), c = Zr(!1), u = Zr();
    u.current === void 0 && (u.current = r(s));
    let f, h = !1;
    (a.current !== s || A.current !== r || l.current !== i || c.current) && (f = r(s), h = !i(u.current, f)), gye(() => {
      h && (u.current = f), a.current = s, A.current = r, l.current = i, c.current = !1;
    });
    const d = Zr(s);
    gye(() => {
      const m = () => {
        try {
          const y = e.getState(), v = A.current(y);
          l.current(u.current, v) || (a.current = y, u.current = v, o());
        } catch {
          c.current = !0, o();
        }
      }, C = e.subscribe(m);
      return e.getState() !== d.current && m(), C;
    }, []);
    const I = h ? f : u.current;
    return Uct(I), I;
  };
  return Object.assign(n, e), n[Symbol.iterator] = function() {
    console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
    const r = [n, e];
    return {
      next() {
        const i = r.length <= 0;
        return { value: r.shift(), done: i };
      }
    };
  }, n;
}
function uUe() {
  const t = Hct(void 0);
  return {
    Provider: ({
      initialStore: i,
      createStore: o,
      children: s
    }) => {
      const a = Zr();
      return a.current || (i && (console.warn("Provider initialStore is deprecated and will be removed in the next version."), o || (o = () => i)), a.current = o()), yS(t.Provider, { value: a.current }, s);
    },
    useStore: (i, o = Object.is) => {
      const s = tT(t);
      if (!s)
        throw new Error("Seems like you have not used zustand provider as an ancestor.");
      return s(i, o);
    },
    useStoreApi: () => {
      const i = tT(t);
      if (!i)
        throw new Error("Seems like you have not used zustand provider as an ancestor.");
      return dt(() => ({
        getState: i.getState,
        setState: i.setState,
        subscribe: i.subscribe,
        destroy: i.destroy
      }), [i]);
    }
  };
}
function $p(t, e) {
  if (Object.is(t, e))
    return !0;
  if (typeof t != "object" || t === null || typeof e != "object" || e === null)
    return !1;
  const n = Object.keys(t);
  if (n.length !== Object.keys(e).length)
    return !1;
  for (let r = 0; r < n.length; r++)
    if (!Object.prototype.hasOwnProperty.call(e, n[r]) || !Object.is(t[n[r]], e[n[r]]))
      return !1;
  return !0;
}
function fUe(t, e, n) {
  let r;
  if (e) {
    const i = t[re.META_COORDINATION_SCOPES], o = e[re.META_COORDINATION_SCOPES];
    i && o && (Array.isArray(i) ? i : [i]).forEach((a) => {
      o[a]?.[n] && (r = a);
    });
  }
  return r;
}
function gUe(t, e, n, r, i) {
  let o;
  if (e) {
    const s = t[re.META_COORDINATION_SCOPES_BY], a = e[re.META_COORDINATION_SCOPES_BY];
    a && s && (Array.isArray(s) ? s : [s]).forEach((l) => {
      a[l]?.[n]?.[r]?.[i] && (o = l);
    });
  }
  return o;
}
function TRt(t, e, n, r) {
  const i = r[re.META_COORDINATION_SCOPES], o = r[re.META_COORDINATION_SCOPES_BY];
  let s = i, a = o;
  const A = gUe(t, r, re.IMAGE_LAYER, re.IMAGE_CHANNEL, e), l = fUe(t, r, re.IMAGE_CHANNEL), c = !!A, f = (c ? o?.[A]?.[re.IMAGE_LAYER]?.[re.IMAGE_CHANNEL]?.[e] : i?.[l]?.[re.IMAGE_CHANNEL]).filter((h) => h !== n);
  return c ? a = {
    ...o,
    [A]: {
      ...o?.[A],
      [re.IMAGE_LAYER]: {
        ...o?.[A]?.[re.IMAGE_LAYER],
        [re.IMAGE_CHANNEL]: {
          ...o?.[A]?.[re.IMAGE_LAYER]?.[re.IMAGE_CHANNEL],
          [e]: f
        }
      }
    }
  } : s = {
    ...i,
    [l]: {
      ...i?.[l],
      [re.IMAGE_CHANNEL]: f
    }
  }, {
    ...r,
    [re.META_COORDINATION_SCOPES]: s,
    [re.META_COORDINATION_SCOPES_BY]: a
  };
}
function NRt(t, e, n) {
  const r = n[re.META_COORDINATION_SCOPES], i = n[re.META_COORDINATION_SCOPES_BY];
  let o = r, s = i;
  const a = gUe(t, n, re.IMAGE_LAYER, re.IMAGE_CHANNEL, e), A = fUe(t, n, re.IMAGE_CHANNEL), l = !!a, c = l ? i?.[a]?.[re.IMAGE_LAYER]?.[re.IMAGE_CHANNEL]?.[e] : r?.[A]?.[re.IMAGE_CHANNEL], u = Object.keys(n[re.IMAGE_CHANNEL] || {}), f = ql(u), h = [...c, f];
  let d = n;
  const I = ql(Object.keys(n[re.SPATIAL_TARGET_C] || {})), m = ql(Object.keys(n[re.SPATIAL_CHANNEL_COLOR] || {})), C = ql(Object.keys(n[re.SPATIAL_CHANNEL_WINDOW] || {})), y = ql(Object.keys(n[re.SPATIAL_CHANNEL_VISIBLE] || {})), v = ql(Object.keys(n[re.SPATIAL_CHANNEL_OPACITY] || {}));
  return d = {
    ...n,
    [re.IMAGE_CHANNEL]: {
      ...n[re.IMAGE_CHANNEL],
      [f]: "__dummy__"
    },
    [re.SPATIAL_TARGET_C]: {
      ...n[re.SPATIAL_TARGET_C],
      [I]: 0
      // TODO: Use the default values for each coordination type.
    },
    [re.SPATIAL_CHANNEL_COLOR]: {
      ...n[re.SPATIAL_CHANNEL_COLOR],
      [m]: [255, 255, 255]
    },
    [re.SPATIAL_CHANNEL_WINDOW]: {
      ...n[re.SPATIAL_CHANNEL_WINDOW],
      [C]: [0, 255]
    },
    [re.SPATIAL_CHANNEL_VISIBLE]: {
      ...n[re.SPATIAL_CHANNEL_VISIBLE],
      [y]: !0
    },
    [re.SPATIAL_CHANNEL_OPACITY]: {
      ...n[re.SPATIAL_CHANNEL_OPACITY],
      [v]: 1
    }
  }, l ? s = {
    ...i,
    [a]: {
      ...i?.[a],
      [re.IMAGE_LAYER]: {
        ...i?.[a]?.[re.IMAGE_LAYER],
        [re.IMAGE_CHANNEL]: {
          ...i?.[a]?.[re.IMAGE_LAYER]?.[re.IMAGE_CHANNEL],
          [e]: h
        }
      },
      [re.IMAGE_CHANNEL]: {
        ...i?.[a]?.[re.IMAGE_CHANNEL],
        [re.SPATIAL_TARGET_C]: {
          ...i?.[a]?.[re.IMAGE_CHANNEL]?.[re.SPATIAL_TARGET_C],
          [f]: I
        },
        [re.SPATIAL_CHANNEL_COLOR]: {
          ...i?.[a]?.[re.IMAGE_CHANNEL]?.[re.SPATIAL_CHANNEL_COLOR],
          [f]: m
        },
        [re.SPATIAL_CHANNEL_WINDOW]: {
          ...i?.[a]?.[re.IMAGE_CHANNEL]?.[re.SPATIAL_CHANNEL_WINDOW],
          [f]: C
        },
        [re.SPATIAL_CHANNEL_VISIBLE]: {
          ...i?.[a]?.[re.IMAGE_CHANNEL]?.[re.SPATIAL_CHANNEL_VISIBLE],
          [f]: y
        },
        [re.SPATIAL_CHANNEL_OPACITY]: {
          ...i?.[a]?.[re.IMAGE_CHANNEL]?.[re.SPATIAL_CHANNEL_OPACITY],
          [f]: v
        }
      }
    }
  } : (o = {
    ...r,
    [A]: {
      ...r?.[A],
      [re.IMAGE_CHANNEL]: h
    }
  }, s = {
    ...i,
    [A]: {
      ...i?.[A],
      [re.IMAGE_CHANNEL]: {
        ...i?.[A]?.[re.IMAGE_CHANNEL],
        [re.SPATIAL_TARGET_C]: {
          ...i?.[A]?.[re.IMAGE_CHANNEL]?.[re.SPATIAL_TARGET_C],
          [f]: I
        },
        [re.SPATIAL_CHANNEL_COLOR]: {
          ...i?.[A]?.[re.IMAGE_CHANNEL]?.[re.SPATIAL_CHANNEL_COLOR],
          [f]: m
        },
        [re.SPATIAL_CHANNEL_WINDOW]: {
          ...i?.[A]?.[re.IMAGE_CHANNEL]?.[re.SPATIAL_CHANNEL_WINDOW],
          [f]: C
        },
        [re.SPATIAL_CHANNEL_VISIBLE]: {
          ...i?.[A]?.[re.IMAGE_CHANNEL]?.[re.SPATIAL_CHANNEL_VISIBLE],
          [f]: y
        },
        [re.SPATIAL_CHANNEL_OPACITY]: {
          ...i?.[A]?.[re.IMAGE_CHANNEL]?.[re.SPATIAL_CHANNEL_OPACITY],
          [f]: v
        }
      }
    }
  }), {
    ...d,
    [re.META_COORDINATION_SCOPES]: o,
    [re.META_COORDINATION_SCOPES_BY]: s
  };
}
const { Provider: LRt, useStore: MRt, useStoreApi: ORt } = uUe(), FRt = LRt, Ya = MRt, hUe = ORt, { Provider: PRt, useStore: kRt } = uUe(), GRt = PRt, hye = kRt;
function URt(t, e) {
  let n = { ...t };
  if (e) {
    const r = t[re.META_COORDINATION_SCOPES];
    r && e && (Array.isArray(r) ? r : [r]).forEach((o) => {
      let s = n;
      const a = e[o] || {};
      Object.entries(a).forEach(([A, l]) => {
        s = {
          ...s,
          [A]: l
        };
      }), n = s;
    });
  }
  return n;
}
function HRt(t, e, n) {
  let r = { ...e };
  if (n) {
    const i = t[re.META_COORDINATION_SCOPES_BY];
    n && i && (Array.isArray(i) ? i : [i]).forEach((s) => {
      let a = r;
      const A = n[s] || {};
      Object.entries(A).forEach(([l, c]) => {
        Object.entries(c).forEach(([u, f]) => {
          Object.entries(f).forEach(([h, d]) => {
            a = {
              ...a,
              [l]: {
                ...a?.[l] || {},
                [u]: {
                  ...a?.[l]?.[u] || {},
                  [h]: d
                }
              }
            };
          });
        });
      }), r = a;
    });
  }
  return r;
}
function hI(t, e) {
  return e[t];
}
function dUe(t, e, n, r, i) {
  const o = r[t], s = i?.[e]?.[t];
  return s && s[n] ? s[n] : o;
}
const dye = (t, e) => rw((n) => ({
  // State:
  // The viewConfig is an object which must conform to the schema
  // found in src/schemas/config.schema.json.
  viewConfig: e,
  // Store the initial config so that its values can be used for resetting.
  initialViewConfig: $A(e),
  // The loaders object is a mapping from dataset ID to
  // data type to loader object instance.
  loaders: t,
  // Reducer functions which update the state
  // (although technically also part of state):
  setViewConfig: (r) => n({ viewConfig: r, initialViewConfig: r }),
  setLoaders: (r) => n({ loaders: r }),
  setCoordinationValue: ({ parameter: r, value: i, coordinationScopes: o, byType: s, typeScope: a, coordinationScopesBy: A }) => n((l) => {
    const { coordinationSpace: c } = l.viewConfig;
    let u;
    return s ? (u = dUe(r, s, a, o, A), u || (u = hI(r, o))) : u = hI(r, o), {
      viewConfig: {
        ...l.viewConfig,
        coordinationSpace: {
          ...c,
          [r]: {
            ...c[r],
            [u]: i
          }
        }
      }
    };
  }),
  mergeCoordination: (r, i, o) => n((s) => {
    const { coordinationSpace: a, layout: A } = s.viewConfig, { coordinationSpace: l, coordinationScopes: c } = put(r, i);
    return Object.entries(l).forEach(([f, h]) => {
      f === re.META_COORDINATION_SCOPES ? Object.entries(h).forEach(([d, I]) => {
        a[f] = {
          ...a[f],
          [d]: {
            ...I,
            ...a[f]?.[d] || {}
          }
        };
      }) : f === re.META_COORDINATION_SCOPES_BY ? Object.entries(h).forEach(([d, I]) => {
        Object.entries(I).forEach(([m, C]) => {
          Object.entries(C).forEach(([y, v]) => {
            a[f] = {
              ...a[f],
              [d]: {
                ...a[f]?.[d] || {},
                [m]: {
                  ...a[f]?.[d]?.[m] || {},
                  [y]: {
                    ...v,
                    ...a[f]?.[d]?.[m]?.[y] || {}
                  }
                }
              }
            };
          });
        });
      }) : a[f] = {
        ...h,
        // Existing coordination values should be preserved,
        // so that user-defined values take precedence over auto-initialization values.
        ...a[f] || {}
      };
    }), {
      viewConfig: {
        ...s.viewConfig,
        coordinationSpace: {
          ...a
        },
        layout: A.map((f) => f.uid === o ? {
          ...f,
          coordinationScopes: {
            ...f.coordinationScopes,
            [re.META_COORDINATION_SCOPES]: [
              ...c[re.META_COORDINATION_SCOPES] || [],
              ...f.coordinationScopes[re.META_COORDINATION_SCOPES] || []
            ],
            [re.META_COORDINATION_SCOPES_BY]: [
              ...c[re.META_COORDINATION_SCOPES_BY] || [],
              ...f.coordinationScopes[re.META_COORDINATION_SCOPES_BY] || []
            ]
          }
        } : f)
      }
    };
  }),
  removeImageChannelInMetaCoordinationScopes: (r, i, o) => n((s) => {
    const { coordinationSpace: a } = s.viewConfig;
    return {
      viewConfig: {
        ...s.viewConfig,
        coordinationSpace: TRt(r, i, o, a)
      }
    };
  }),
  addImageChannelInMetaCoordinationScopes: (r, i) => n((o) => {
    const { coordinationSpace: s } = o.viewConfig;
    return {
      viewConfig: {
        ...o.viewConfig,
        coordinationSpace: NRt(r, i, s)
      }
    };
  }),
  removeComponent: (r) => n((i) => {
    const o = i.viewConfig.layout.filter((s) => s.uid !== r);
    return {
      viewConfig: {
        ...i.viewConfig,
        layout: o
      }
    };
  }),
  changeLayout: (r) => n((i) => {
    const o = i.viewConfig.layout.slice().map((s) => ({
      ...s,
      ...r[s.uid]
    }));
    return {
      viewConfig: {
        ...i.viewConfig,
        layout: o
      }
    };
  })
})), pUe = (t, e, n) => Ya((r) => r.viewConfig.layout.filter((i) => i.component === t).filter((i) => e.every((o) => i.coordinationScopes[o] === n[o]))), $Rt = () => rw((t) => ({
  auxiliaryStore: null,
  setCoordinationValue: ({ parameter: e, scope: n, value: r }) => t((i) => ({
    auxiliaryStore: {
      ...i.auxiliaryStore,
      [e]: {
        [n]: r
      }
    }
  }))
})), IUe = rw((t) => ({
  // Components may need to know if they are the "hover source"
  // for tooltip interactions. This value should be a unique
  // component ID, such as its index in the view config layout.
  componentHover: null,
  setComponentHover: (e) => t({ componentHover: e })
})), mUe = rw((t) => ({
  // Want a global state to collect warning messages
  // that occur anywhere in the app.
  warning: null,
  setWarning: (e) => t({ warning: e })
})), CUe = rw((t) => ({
  // The viewInfo object is a mapping from
  // component IDs to component view info objects.
  // Each view info object must have a project() function.
  viewInfo: {},
  setComponentViewInfo: (e, n) => t((r) => ({
    viewInfo: {
      ...r.viewInfo,
      [e]: n
    }
  }))
})), EUe = rw((t) => ({
  resizeCount: {},
  incrementResizeCount: () => t((e) => ({
    resizeCount: e.resizeCount + 1
  }))
}));
function yae(t, e) {
  return Ya((r) => {
    const { coordinationSpace: i } = r.initialViewConfig;
    return ji(t.map((o) => {
      if (i && i[o]) {
        const s = i[o][e[o]];
        return [o, s];
      }
      return [o, void 0];
    }));
  }, $p);
}
function uc(t, e) {
  const n = Ya((o) => o.setCoordinationValue), r = Ya((o) => {
    const { coordinationSpace: s } = o.viewConfig;
    return ji(t.map((a) => {
      if (s) {
        const A = hI(a, e);
        if (s && s[a]) {
          const l = s[a][A];
          return [a, l];
        }
      }
      return [a, void 0];
    }));
  }, $p), i = dt(() => ji(t.map((o) => [`set${Ci(o)}`, (A) => n({
    parameter: o,
    coordinationScopes: e,
    value: A
  })])), [t, e]);
  return [r, i];
}
function G4(t, e) {
  const n = hI(t, e), r = Ya((o) => {
    const { coordinationSpace: s } = o.viewConfig;
    return s?.[t];
  }, $p);
  return dt(() => (Array.isArray(n) ? n : [n]).filter((s) => r ? r[s] !== null : !1), [t, e, n, r]);
}
function U4(t, e, n, r) {
  const i = hI(e, n), o = Ya((a) => {
    const { coordinationSpace: A } = a.viewConfig;
    return A?.[t];
  }, $p), s = Ya((a) => {
    const { coordinationSpace: A } = a.viewConfig;
    return A?.[e];
  }, $p);
  return dt(() => {
    if (i && r?.[e]?.[t]) {
      const A = (Array.isArray(i) ? i : [i]).filter((l) => s ? s[l] !== null : !1);
      return [A, ji(A.map((l) => {
        const c = r[e][t][l], f = (Array.isArray(c) ? c : [c]).filter((h) => o ? o[h] !== null : !1);
        return [l, f];
      }))];
    }
    if (i && !r?.[e]?.[t] && n?.[t]) {
      const A = (Array.isArray(i) ? i : [i]).filter((l) => s ? s[l] !== null : !1);
      return [A, ji(A.map((l) => {
        const c = n?.[t], f = (Array.isArray(c) ? c : [c]).filter((h) => o ? o[h] !== null : !1);
        return [l, f];
      }))];
    }
    return [[], {}];
  }, [t, e, i, n, r, o, s]);
}
function qRt(t, e) {
  const n = hI(t, e);
  return Ya((i) => {
    const { coordinationSpace: o } = i.viewConfig, s = Array.isArray(n) ? n : [n];
    return ji(s.map((a) => {
      if (o && o[t]) {
        const A = o[t][a];
        return [a, A];
      }
      return [a, void 0];
    }).filter(([a, A]) => A !== void 0));
  }, $p);
}
function TA(t, e, n, r) {
  const i = Ya((A) => A.setCoordinationValue), o = Ya((A) => {
    const { coordinationSpace: l } = A.viewConfig;
    return t.map((c) => l[c]);
  }, $p), s = dt(() => {
    const A = hI(r, e);
    if (A) {
      const l = Array.isArray(A) ? A : [A];
      return ji(l.map((c) => {
        const u = ji(t.map((f, h) => {
          if (o[h]) {
            const d = o[h], I = dUe(f, r, c, e, n);
            if (I) {
              const y = d[I];
              return [f, y];
            }
            const m = hI(f, e), C = d[m];
            return [f, C];
          }
          return [f, void 0];
        }));
        return [c, u];
      }));
    }
    return {};
  }, [r, e, n, o]), a = dt(() => {
    const A = hI(r, e);
    if (A) {
      const l = Array.isArray(A) ? A : [A];
      return ji(l.map((c) => {
        const u = ji(t.map((f) => [`set${Ci(f)}`, (I) => i({
          parameter: f,
          byType: r,
          typeScope: c,
          coordinationScopes: e,
          coordinationScopesBy: n,
          value: I
        })]));
        return [c, u];
      }));
    }
    return {};
  }, [e]);
  return [s, a];
}
function yUe(t) {
  const e = Ya((r) => {
    const { coordinationSpace: i } = r.viewConfig;
    return i?.[re.META_COORDINATION_SCOPES];
  }, $p);
  return dt(() => {
    const r = URt(t, e);
    return delete r[re.META_COORDINATION_SCOPES], r;
  }, [t, e]);
}
function vUe(t, e) {
  const n = Ya((i) => {
    const { coordinationSpace: o } = i.viewConfig;
    return o?.[re.META_COORDINATION_SCOPES_BY];
  }, $p);
  return dt(() => HRt(t, e, n), [t, e, n]);
}
function wI(t, e, n, r, i) {
  const o = dt(() => n?.[r]?.[i] ? {
    ...e,
    [i]: Object.values(n[r][i]).flat()
  } : e?.[i] && Array.isArray(e[i]) ? {
    ...e,
    [i]: e[i]
  } : { [i]: [] }, [n, r, i]), [s, a] = TA(t, o, n, i), A = dt(() => {
    const c = {};
    return n?.[r]?.[i] ? Object.entries(n[r][i]).forEach(([u, f]) => {
      c[u] = {}, f.forEach((h) => {
        c[u][h] = s[h];
      });
    }) : e?.[i] && Array.isArray(e[i]) && e[r].forEach((f) => {
      c[f] = s;
    }), c;
  }, [s]), l = dt(() => {
    const c = {};
    return n?.[r]?.[i] ? Object.entries(n[r][i]).forEach(([u, f]) => {
      c[u] = {}, f.forEach((h) => {
        c[u][h] = a[h];
      });
    }) : e?.[i] && Array.isArray(e[i]) && e[r].forEach((f) => {
      c[f] = a;
    }), c;
  }, [a]);
  return [A, l];
}
const BUe = {
  spatialImageLayer: ["imageLayerCallbacks", "areLoadingImageChannels"],
  spatialSegmentationLayer: ["segmentationLayerCallbacks", "areLoadingSegmentationChannels"]
}, jRt = (t) => {
  const e = {};
  return Object.keys(t).forEach((n) => {
    (BUe[n] || []).forEach((i) => {
      e[i || n] = t[n];
    });
  }), e;
}, YRt = (t) => t.map((e) => BUe[e]).filter(Boolean).flat();
function vae(t, e) {
  const n = hye((a) => a.setCoordinationValue), r = jRt(e), i = YRt(t), o = hye((a) => {
    const { auxiliaryStore: A } = a;
    return ji(i.map((l) => {
      if (A && A[l]) {
        const c = A[l][r[l]];
        return [l, c];
      }
      return [l, void 0];
    }));
  }, $p), s = dt(() => ji(i.map((a) => [`set${Ci(a)}`, (c) => n({
    parameter: a,
    scope: r[a],
    value: c
  })])), [t, e]);
  return [o, s];
}
function eu() {
  return Ya((t) => t.loaders);
}
function iw(t, e, n, r) {
  if (!t[e])
    return null;
  const i = t[e].loaders[n];
  if (!i)
    return null;
  const s = Array.from(i.keys()).find((a) => H_t(a, r));
  return s ? i.get(s) : null;
}
function zRt(t, e, n, r) {
  return dt(() => iw(t, e, n, r), [t, e, n, r]);
}
function VRt() {
  return Ya((t) => t.viewConfig?.layout);
}
function JRt() {
  return Ya((t) => t.removeComponent);
}
function KRt() {
  return Ya((t) => t.removeImageChannelInMetaCoordinationScopes);
}
function WRt() {
  return Ya((t) => t.addImageChannelInMetaCoordinationScopes);
}
function XRt() {
  return Ya((t) => t.changeLayout);
}
function ZRt() {
  return Ya((t) => t.setLoaders);
}
function bUe() {
  return Ya((t) => t.mergeCoordination);
}
function eDt(t) {
  return Zr(t.getState().setViewConfig).current;
}
function JH() {
  return IUe((t) => t.componentHover);
}
function yL() {
  return IUe((t) => t.setComponentHover);
}
function _Ue() {
  return mUe((t) => t.warning);
}
function vE() {
  return mUe((t) => t.setWarning);
}
function KH(t) {
  return CUe(Qn((e) => e.viewInfo[t], [t]));
}
function vL(t) {
  const e = Zr(CUe.getState().setComponentViewInfo);
  return Qn((r) => e.current(t, r), [t]);
}
function SUe() {
  return EUe((t) => t.resizeCount);
}
function Bae() {
  return EUe((t) => t.incrementResizeCount);
}
const tDt = "tooltip-ancestor", WH = "vitessce-container";
var QUe = { exports: {} }, BL = {};
function nDt() {
  this.__data__ = [], this.size = 0;
}
var rDt = nDt;
function iDt(t, e) {
  return t === e || t !== t && e !== e;
}
var wUe = iDt, oDt = wUe;
function sDt(t, e) {
  for (var n = t.length; n--; )
    if (oDt(t[n][0], e))
      return n;
  return -1;
}
var XH = sDt, aDt = XH, ADt = Array.prototype, lDt = ADt.splice;
function cDt(t) {
  var e = this.__data__, n = aDt(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : lDt.call(e, n, 1), --this.size, !0;
}
var uDt = cDt, fDt = XH;
function gDt(t) {
  var e = this.__data__, n = fDt(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var hDt = gDt, dDt = XH;
function pDt(t) {
  return dDt(this.__data__, t) > -1;
}
var IDt = pDt, mDt = XH;
function CDt(t, e) {
  var n = this.__data__, r = mDt(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
var EDt = CDt, yDt = rDt, vDt = uDt, BDt = hDt, bDt = IDt, _Dt = EDt;
function ow(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
ow.prototype.clear = yDt;
ow.prototype.delete = vDt;
ow.prototype.get = BDt;
ow.prototype.has = bDt;
ow.prototype.set = _Dt;
var ZH = ow, SDt = ZH;
function QDt() {
  this.__data__ = new SDt(), this.size = 0;
}
var wDt = QDt;
function xDt(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var RDt = xDt;
function DDt(t) {
  return this.__data__.get(t);
}
var TDt = DDt;
function NDt(t) {
  return this.__data__.has(t);
}
var LDt = NDt, MDt = typeof ei == "object" && ei && ei.Object === Object && ei, xUe = MDt, ODt = xUe, FDt = typeof self == "object" && self && self.Object === Object && self, PDt = ODt || FDt || Function("return this")(), YI = PDt, kDt = YI, GDt = kDt.Symbol, bae = GDt, pye = bae, RUe = Object.prototype, UDt = RUe.hasOwnProperty, HDt = RUe.toString, qx = pye ? pye.toStringTag : void 0;
function $Dt(t) {
  var e = UDt.call(t, qx), n = t[qx];
  try {
    t[qx] = void 0;
    var r = !0;
  } catch {
  }
  var i = HDt.call(t);
  return r && (e ? t[qx] = n : delete t[qx]), i;
}
var qDt = $Dt, jDt = Object.prototype, YDt = jDt.toString;
function zDt(t) {
  return YDt.call(t);
}
var VDt = zDt, Iye = bae, JDt = qDt, KDt = VDt, WDt = "[object Null]", XDt = "[object Undefined]", mye = Iye ? Iye.toStringTag : void 0;
function ZDt(t) {
  return t == null ? t === void 0 ? XDt : WDt : mye && mye in Object(t) ? JDt(t) : KDt(t);
}
var e9 = ZDt;
function eTt(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var DUe = eTt, tTt = e9, nTt = DUe, rTt = "[object AsyncFunction]", iTt = "[object Function]", oTt = "[object GeneratorFunction]", sTt = "[object Proxy]";
function aTt(t) {
  if (!nTt(t))
    return !1;
  var e = tTt(t);
  return e == iTt || e == oTt || e == rTt || e == sTt;
}
var TUe = aTt, ATt = YI, lTt = ATt["__core-js_shared__"], cTt = lTt, zz = cTt, Cye = function() {
  var t = /[^.]+$/.exec(zz && zz.keys && zz.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function uTt(t) {
  return !!Cye && Cye in t;
}
var fTt = uTt, gTt = Function.prototype, hTt = gTt.toString;
function dTt(t) {
  if (t != null) {
    try {
      return hTt.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var NUe = dTt, pTt = TUe, ITt = fTt, mTt = DUe, CTt = NUe, ETt = /[\\^$.*+?()[\]{}|]/g, yTt = /^\[object .+?Constructor\]$/, vTt = Function.prototype, BTt = Object.prototype, bTt = vTt.toString, _Tt = BTt.hasOwnProperty, STt = RegExp(
  "^" + bTt.call(_Tt).replace(ETt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function QTt(t) {
  if (!mTt(t) || ITt(t))
    return !1;
  var e = pTt(t) ? STt : yTt;
  return e.test(CTt(t));
}
var wTt = QTt;
function xTt(t, e) {
  return t?.[e];
}
var RTt = xTt, DTt = wTt, TTt = RTt;
function NTt(t, e) {
  var n = TTt(t, e);
  return DTt(n) ? n : void 0;
}
var sw = NTt, LTt = sw, MTt = YI, OTt = LTt(MTt, "Map"), _ae = OTt, FTt = sw, PTt = FTt(Object, "create"), t9 = PTt, Eye = t9;
function kTt() {
  this.__data__ = Eye ? Eye(null) : {}, this.size = 0;
}
var GTt = kTt;
function UTt(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var HTt = UTt, $Tt = t9, qTt = "__lodash_hash_undefined__", jTt = Object.prototype, YTt = jTt.hasOwnProperty;
function zTt(t) {
  var e = this.__data__;
  if ($Tt) {
    var n = e[t];
    return n === qTt ? void 0 : n;
  }
  return YTt.call(e, t) ? e[t] : void 0;
}
var VTt = zTt, JTt = t9, KTt = Object.prototype, WTt = KTt.hasOwnProperty;
function XTt(t) {
  var e = this.__data__;
  return JTt ? e[t] !== void 0 : WTt.call(e, t);
}
var ZTt = XTt, eNt = t9, tNt = "__lodash_hash_undefined__";
function nNt(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = eNt && e === void 0 ? tNt : e, this;
}
var rNt = nNt, iNt = GTt, oNt = HTt, sNt = VTt, aNt = ZTt, ANt = rNt;
function aw(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
aw.prototype.clear = iNt;
aw.prototype.delete = oNt;
aw.prototype.get = sNt;
aw.prototype.has = aNt;
aw.prototype.set = ANt;
var lNt = aw, yye = lNt, cNt = ZH, uNt = _ae;
function fNt() {
  this.size = 0, this.__data__ = {
    hash: new yye(),
    map: new (uNt || cNt)(),
    string: new yye()
  };
}
var gNt = fNt;
function hNt(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var dNt = hNt, pNt = dNt;
function INt(t, e) {
  var n = t.__data__;
  return pNt(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var n9 = INt, mNt = n9;
function CNt(t) {
  var e = mNt(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var ENt = CNt, yNt = n9;
function vNt(t) {
  return yNt(this, t).get(t);
}
var BNt = vNt, bNt = n9;
function _Nt(t) {
  return bNt(this, t).has(t);
}
var SNt = _Nt, QNt = n9;
function wNt(t, e) {
  var n = QNt(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
var xNt = wNt, RNt = gNt, DNt = ENt, TNt = BNt, NNt = SNt, LNt = xNt;
function Aw(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Aw.prototype.clear = RNt;
Aw.prototype.delete = DNt;
Aw.prototype.get = TNt;
Aw.prototype.has = NNt;
Aw.prototype.set = LNt;
var LUe = Aw, MNt = ZH, ONt = _ae, FNt = LUe, PNt = 200;
function kNt(t, e) {
  var n = this.__data__;
  if (n instanceof MNt) {
    var r = n.__data__;
    if (!ONt || r.length < PNt - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new FNt(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
var GNt = kNt, UNt = ZH, HNt = wDt, $Nt = RDt, qNt = TDt, jNt = LDt, YNt = GNt;
function lw(t) {
  var e = this.__data__ = new UNt(t);
  this.size = e.size;
}
lw.prototype.clear = HNt;
lw.prototype.delete = $Nt;
lw.prototype.get = qNt;
lw.prototype.has = jNt;
lw.prototype.set = YNt;
var zNt = lw, VNt = "__lodash_hash_undefined__";
function JNt(t) {
  return this.__data__.set(t, VNt), this;
}
var KNt = JNt;
function WNt(t) {
  return this.__data__.has(t);
}
var XNt = WNt, ZNt = LUe, eLt = KNt, tLt = XNt;
function H4(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new ZNt(); ++e < n; )
    this.add(t[e]);
}
H4.prototype.add = H4.prototype.push = eLt;
H4.prototype.has = tLt;
var nLt = H4;
function rLt(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
var iLt = rLt;
function oLt(t, e) {
  return t.has(e);
}
var sLt = oLt, aLt = nLt, ALt = iLt, lLt = sLt, cLt = 1, uLt = 2;
function fLt(t, e, n, r, i, o) {
  var s = n & cLt, a = t.length, A = e.length;
  if (a != A && !(s && A > a))
    return !1;
  var l = o.get(t), c = o.get(e);
  if (l && c)
    return l == e && c == t;
  var u = -1, f = !0, h = n & uLt ? new aLt() : void 0;
  for (o.set(t, e), o.set(e, t); ++u < a; ) {
    var d = t[u], I = e[u];
    if (r)
      var m = s ? r(I, d, u, e, t, o) : r(d, I, u, t, e, o);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!ALt(e, function(C, y) {
        if (!lLt(h, y) && (d === C || i(d, C, n, r, o)))
          return h.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(d === I || i(d, I, n, r, o))) {
      f = !1;
      break;
    }
  }
  return o.delete(t), o.delete(e), f;
}
var MUe = fLt, gLt = YI, hLt = gLt.Uint8Array, dLt = hLt;
function pLt(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, i) {
    n[++e] = [i, r];
  }), n;
}
var ILt = pLt;
function mLt(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var CLt = mLt, vye = bae, Bye = dLt, ELt = wUe, yLt = MUe, vLt = ILt, BLt = CLt, bLt = 1, _Lt = 2, SLt = "[object Boolean]", QLt = "[object Date]", wLt = "[object Error]", xLt = "[object Map]", RLt = "[object Number]", DLt = "[object RegExp]", TLt = "[object Set]", NLt = "[object String]", LLt = "[object Symbol]", MLt = "[object ArrayBuffer]", OLt = "[object DataView]", bye = vye ? vye.prototype : void 0, Vz = bye ? bye.valueOf : void 0;
function FLt(t, e, n, r, i, o, s) {
  switch (n) {
    case OLt:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case MLt:
      return !(t.byteLength != e.byteLength || !o(new Bye(t), new Bye(e)));
    case SLt:
    case QLt:
    case RLt:
      return ELt(+t, +e);
    case wLt:
      return t.name == e.name && t.message == e.message;
    case DLt:
    case NLt:
      return t == e + "";
    case xLt:
      var a = vLt;
    case TLt:
      var A = r & bLt;
      if (a || (a = BLt), t.size != e.size && !A)
        return !1;
      var l = s.get(t);
      if (l)
        return l == e;
      r |= _Lt, s.set(t, e);
      var c = yLt(a(t), a(e), r, i, o, s);
      return s.delete(t), c;
    case LLt:
      if (Vz)
        return Vz.call(t) == Vz.call(e);
  }
  return !1;
}
var PLt = FLt;
function kLt(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
var GLt = kLt, ULt = Array.isArray, Sae = ULt, HLt = GLt, $Lt = Sae;
function qLt(t, e, n) {
  var r = e(t);
  return $Lt(t) ? r : HLt(r, n(t));
}
var jLt = qLt;
function YLt(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, o = []; ++n < r; ) {
    var s = t[n];
    e(s, n, t) && (o[i++] = s);
  }
  return o;
}
var zLt = YLt;
function VLt() {
  return [];
}
var JLt = VLt, KLt = zLt, WLt = JLt, XLt = Object.prototype, ZLt = XLt.propertyIsEnumerable, _ye = Object.getOwnPropertySymbols, eMt = _ye ? function(t) {
  return t == null ? [] : (t = Object(t), KLt(_ye(t), function(e) {
    return ZLt.call(t, e);
  }));
} : WLt, tMt = eMt;
function nMt(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var rMt = nMt;
function iMt(t) {
  return t != null && typeof t == "object";
}
var r9 = iMt, oMt = e9, sMt = r9, aMt = "[object Arguments]";
function AMt(t) {
  return sMt(t) && oMt(t) == aMt;
}
var lMt = AMt, Sye = lMt, cMt = r9, OUe = Object.prototype, uMt = OUe.hasOwnProperty, fMt = OUe.propertyIsEnumerable, gMt = Sye(function() {
  return arguments;
}()) ? Sye : function(t) {
  return cMt(t) && uMt.call(t, "callee") && !fMt.call(t, "callee");
}, hMt = gMt, $4 = { exports: {} };
function dMt() {
  return !1;
}
var pMt = dMt;
$4.exports;
(function(t, e) {
  var n = YI, r = pMt, i = e && !e.nodeType && e, o = i && !0 && t && !t.nodeType && t, s = o && o.exports === i, a = s ? n.Buffer : void 0, A = a ? a.isBuffer : void 0, l = A || r;
  t.exports = l;
})($4, $4.exports);
var FUe = $4.exports, IMt = 9007199254740991, mMt = /^(?:0|[1-9]\d*)$/;
function CMt(t, e) {
  var n = typeof t;
  return e = e ?? IMt, !!e && (n == "number" || n != "symbol" && mMt.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var EMt = CMt, yMt = 9007199254740991;
function vMt(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= yMt;
}
var PUe = vMt, BMt = e9, bMt = PUe, _Mt = r9, SMt = "[object Arguments]", QMt = "[object Array]", wMt = "[object Boolean]", xMt = "[object Date]", RMt = "[object Error]", DMt = "[object Function]", TMt = "[object Map]", NMt = "[object Number]", LMt = "[object Object]", MMt = "[object RegExp]", OMt = "[object Set]", FMt = "[object String]", PMt = "[object WeakMap]", kMt = "[object ArrayBuffer]", GMt = "[object DataView]", UMt = "[object Float32Array]", HMt = "[object Float64Array]", $Mt = "[object Int8Array]", qMt = "[object Int16Array]", jMt = "[object Int32Array]", YMt = "[object Uint8Array]", zMt = "[object Uint8ClampedArray]", VMt = "[object Uint16Array]", JMt = "[object Uint32Array]", As = {};
As[UMt] = As[HMt] = As[$Mt] = As[qMt] = As[jMt] = As[YMt] = As[zMt] = As[VMt] = As[JMt] = !0;
As[SMt] = As[QMt] = As[kMt] = As[wMt] = As[GMt] = As[xMt] = As[RMt] = As[DMt] = As[TMt] = As[NMt] = As[LMt] = As[MMt] = As[OMt] = As[FMt] = As[PMt] = !1;
function KMt(t) {
  return _Mt(t) && bMt(t.length) && !!As[BMt(t)];
}
var WMt = KMt;
function XMt(t) {
  return function(e) {
    return t(e);
  };
}
var ZMt = XMt, q4 = { exports: {} };
q4.exports;
(function(t, e) {
  var n = xUe, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, o = i && i.exports === r, s = o && n.process, a = function() {
    try {
      var A = i && i.require && i.require("util").types;
      return A || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  t.exports = a;
})(q4, q4.exports);
var eOt = q4.exports, tOt = WMt, nOt = ZMt, Qye = eOt, wye = Qye && Qye.isTypedArray, rOt = wye ? nOt(wye) : tOt, kUe = rOt, iOt = rMt, oOt = hMt, sOt = Sae, aOt = FUe, AOt = EMt, lOt = kUe, cOt = Object.prototype, uOt = cOt.hasOwnProperty;
function fOt(t, e) {
  var n = sOt(t), r = !n && oOt(t), i = !n && !r && aOt(t), o = !n && !r && !i && lOt(t), s = n || r || i || o, a = s ? iOt(t.length, String) : [], A = a.length;
  for (var l in t)
    (e || uOt.call(t, l)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    AOt(l, A))) && a.push(l);
  return a;
}
var gOt = fOt, hOt = Object.prototype;
function dOt(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || hOt;
  return t === n;
}
var pOt = dOt;
function IOt(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var mOt = IOt, COt = mOt, EOt = COt(Object.keys, Object), yOt = EOt, vOt = pOt, BOt = yOt, bOt = Object.prototype, _Ot = bOt.hasOwnProperty;
function SOt(t) {
  if (!vOt(t))
    return BOt(t);
  var e = [];
  for (var n in Object(t))
    _Ot.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var QOt = SOt, wOt = TUe, xOt = PUe;
function ROt(t) {
  return t != null && xOt(t.length) && !wOt(t);
}
var DOt = ROt, TOt = gOt, NOt = QOt, LOt = DOt;
function MOt(t) {
  return LOt(t) ? TOt(t) : NOt(t);
}
var OOt = MOt, FOt = jLt, POt = tMt, kOt = OOt;
function GOt(t) {
  return FOt(t, kOt, POt);
}
var UOt = GOt, xye = UOt, HOt = 1, $Ot = Object.prototype, qOt = $Ot.hasOwnProperty;
function jOt(t, e, n, r, i, o) {
  var s = n & HOt, a = xye(t), A = a.length, l = xye(e), c = l.length;
  if (A != c && !s)
    return !1;
  for (var u = A; u--; ) {
    var f = a[u];
    if (!(s ? f in e : qOt.call(e, f)))
      return !1;
  }
  var h = o.get(t), d = o.get(e);
  if (h && d)
    return h == e && d == t;
  var I = !0;
  o.set(t, e), o.set(e, t);
  for (var m = s; ++u < A; ) {
    f = a[u];
    var C = t[f], y = e[f];
    if (r)
      var v = s ? r(y, C, f, e, t, o) : r(C, y, f, t, e, o);
    if (!(v === void 0 ? C === y || i(C, y, n, r, o) : v)) {
      I = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (I && !m) {
    var b = t.constructor, Q = e.constructor;
    b != Q && "constructor" in t && "constructor" in e && !(typeof b == "function" && b instanceof b && typeof Q == "function" && Q instanceof Q) && (I = !1);
  }
  return o.delete(t), o.delete(e), I;
}
var YOt = jOt, zOt = sw, VOt = YI, JOt = zOt(VOt, "DataView"), KOt = JOt, WOt = sw, XOt = YI, ZOt = WOt(XOt, "Promise"), eFt = ZOt, tFt = sw, nFt = YI, rFt = tFt(nFt, "Set"), iFt = rFt, oFt = sw, sFt = YI, aFt = oFt(sFt, "WeakMap"), AFt = aFt, yZ = KOt, vZ = _ae, BZ = eFt, bZ = iFt, _Z = AFt, GUe = e9, cw = NUe, Rye = "[object Map]", lFt = "[object Object]", Dye = "[object Promise]", Tye = "[object Set]", Nye = "[object WeakMap]", Lye = "[object DataView]", cFt = cw(yZ), uFt = cw(vZ), fFt = cw(BZ), gFt = cw(bZ), hFt = cw(_Z), ky = GUe;
(yZ && ky(new yZ(new ArrayBuffer(1))) != Lye || vZ && ky(new vZ()) != Rye || BZ && ky(BZ.resolve()) != Dye || bZ && ky(new bZ()) != Tye || _Z && ky(new _Z()) != Nye) && (ky = function(t) {
  var e = GUe(t), n = e == lFt ? t.constructor : void 0, r = n ? cw(n) : "";
  if (r)
    switch (r) {
      case cFt:
        return Lye;
      case uFt:
        return Rye;
      case fFt:
        return Dye;
      case gFt:
        return Tye;
      case hFt:
        return Nye;
    }
  return e;
});
var dFt = ky, Jz = zNt, pFt = MUe, IFt = PLt, mFt = YOt, Mye = dFt, Oye = Sae, Fye = FUe, CFt = kUe, EFt = 1, Pye = "[object Arguments]", kye = "[object Array]", hF = "[object Object]", yFt = Object.prototype, Gye = yFt.hasOwnProperty;
function vFt(t, e, n, r, i, o) {
  var s = Oye(t), a = Oye(e), A = s ? kye : Mye(t), l = a ? kye : Mye(e);
  A = A == Pye ? hF : A, l = l == Pye ? hF : l;
  var c = A == hF, u = l == hF, f = A == l;
  if (f && Fye(t)) {
    if (!Fye(e))
      return !1;
    s = !0, c = !1;
  }
  if (f && !c)
    return o || (o = new Jz()), s || CFt(t) ? pFt(t, e, n, r, i, o) : IFt(t, e, A, n, r, i, o);
  if (!(n & EFt)) {
    var h = c && Gye.call(t, "__wrapped__"), d = u && Gye.call(e, "__wrapped__");
    if (h || d) {
      var I = h ? t.value() : t, m = d ? e.value() : e;
      return o || (o = new Jz()), i(I, m, n, r, o);
    }
  }
  return f ? (o || (o = new Jz()), mFt(t, e, n, r, i, o)) : !1;
}
var BFt = vFt, bFt = BFt, Uye = r9;
function UUe(t, e, n, r, i) {
  return t === e ? !0 : t == null || e == null || !Uye(t) && !Uye(e) ? t !== t && e !== e : bFt(t, e, n, r, UUe, i);
}
var _Ft = UUe, SFt = _Ft;
function QFt(t, e) {
  return SFt(t, e);
}
var i9 = QFt;
const wFt = /* @__PURE__ */ ko(i9), jB = /* @__PURE__ */ Fs(wpt);
var pi = {}, xFt = function(e, n, r) {
  return e === n ? !0 : e.className === n.className && r(e.style, n.style) && e.width === n.width && e.autoSize === n.autoSize && e.cols === n.cols && e.draggableCancel === n.draggableCancel && e.draggableHandle === n.draggableHandle && r(e.verticalCompact, n.verticalCompact) && r(e.compactType, n.compactType) && r(e.layout, n.layout) && r(e.margin, n.margin) && r(e.containerPadding, n.containerPadding) && e.rowHeight === n.rowHeight && e.maxRows === n.maxRows && e.isBounded === n.isBounded && e.isDraggable === n.isDraggable && e.isResizable === n.isResizable && e.allowOverlap === n.allowOverlap && e.preventCollision === n.preventCollision && e.useCSSTransforms === n.useCSSTransforms && e.transformScale === n.transformScale && e.isDroppable === n.isDroppable && r(e.resizeHandles, n.resizeHandles) && r(e.resizeHandle, n.resizeHandle) && e.onLayoutChange === n.onLayoutChange && e.onDragStart === n.onDragStart && e.onDrag === n.onDrag && e.onDragStop === n.onDragStop && e.onResizeStart === n.onResizeStart && e.onResize === n.onResize && e.onResizeStop === n.onResizeStop && e.onDrop === n.onDrop && r(e.droppingItem, n.droppingItem) && r(e.innerRef, n.innerRef);
};
Object.defineProperty(pi, "__esModule", {
  value: !0
});
pi.bottom = Qae;
pi.childrenEqual = NFt;
pi.cloneLayout = $Ue;
pi.cloneLayoutItem = Bv;
pi.collides = o9;
pi.compact = jUe;
pi.compactItem = YUe;
pi.compactType = HFt;
pi.correctBounds = zUe;
pi.fastPositionEqual = MFt;
pi.fastRGLPropsEqual = void 0;
pi.getAllCollisions = VUe;
pi.getFirstCollision = O_;
pi.getLayoutItem = wae;
pi.getStatics = xae;
pi.modifyLayout = qUe;
pi.moveElement = wZ;
pi.moveElementAwayFromCollision = xZ;
pi.noop = void 0;
pi.perc = FFt;
pi.setTopLeft = kFt;
pi.setTransform = PFt;
pi.sortLayoutItems = Rae;
pi.sortLayoutItemsByColRow = KUe;
pi.sortLayoutItemsByRowCol = JUe;
pi.synchronizeLayoutWithChildren = GFt;
pi.validateLayout = UFt;
pi.withLayoutItem = TFt;
var RFt = HUe(i9), SZ = HUe(St);
function HUe(t) {
  return t && t.__esModule ? t : { default: t };
}
function Hye(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $ye(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Hye(Object(n), !0).forEach(function(r) {
      DFt(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Hye(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function DFt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Qae(t) {
  for (var e = 0, n, r = 0, i = t.length; r < i; r++)
    n = t[r].y + t[r].h, n > e && (e = n);
  return e;
}
function $Ue(t) {
  for (var e = Array(t.length), n = 0, r = t.length; n < r; n++)
    e[n] = Bv(t[n]);
  return e;
}
function qUe(t, e) {
  for (var n = Array(t.length), r = 0, i = t.length; r < i; r++)
    e.i === t[r].i ? n[r] = e : n[r] = t[r];
  return n;
}
function TFt(t, e, n) {
  var r = wae(t, e);
  return r ? (r = n(Bv(r)), t = qUe(t, r), [t, r]) : [t, null];
}
function Bv(t) {
  return {
    w: t.w,
    h: t.h,
    x: t.x,
    y: t.y,
    i: t.i,
    minW: t.minW,
    maxW: t.maxW,
    minH: t.minH,
    maxH: t.maxH,
    moved: !!t.moved,
    static: !!t.static,
    // These can be null/undefined
    isDraggable: t.isDraggable,
    isResizable: t.isResizable,
    resizeHandles: t.resizeHandles,
    isBounded: t.isBounded
  };
}
function NFt(t, e) {
  return (0, RFt.default)(SZ.default.Children.map(t, function(n) {
    return n?.key;
  }), SZ.default.Children.map(e, function(n) {
    return n?.key;
  }));
}
var LFt = xFt;
pi.fastRGLPropsEqual = LFt;
function MFt(t, e) {
  return t.left === e.left && t.top === e.top && t.width === e.width && t.height === e.height;
}
function o9(t, e) {
  return !(t.i === e.i || t.x + t.w <= e.x || t.x >= e.x + e.w || t.y + t.h <= e.y || t.y >= e.y + e.h);
}
function jUe(t, e, n) {
  for (var r = xae(t), i = Rae(t, e), o = Array(t.length), s = 0, a = i.length; s < a; s++) {
    var A = Bv(i[s]);
    A.static || (A = YUe(r, A, e, n, i), r.push(A)), o[t.indexOf(i[s])] = A, A.moved = !1;
  }
  return o;
}
var OFt = {
  x: "w",
  y: "h"
};
function QZ(t, e, n, r) {
  var i = OFt[r];
  e[r] += 1;
  for (var o = t.map(function(A) {
    return A.i;
  }).indexOf(e.i), s = o + 1; s < t.length; s++) {
    var a = t[s];
    if (!a.static) {
      if (a.y > e.y + e.h)
        break;
      o9(e, a) && QZ(t, a, n + e[i], r);
    }
  }
  e[r] = n;
}
function YUe(t, e, n, r, i) {
  var o = n === "vertical", s = n === "horizontal";
  if (o)
    for (e.y = Math.min(Qae(t), e.y); e.y > 0 && !O_(t, e); )
      e.y--;
  else if (s)
    for (; e.x > 0 && !O_(t, e); )
      e.x--;
  for (var a; a = O_(t, e); )
    s ? QZ(i, e, a.x + a.w, "x") : QZ(i, e, a.y + a.h, "y"), s && e.x + e.w > r && (e.x = r - e.w, e.y++);
  return e.y = Math.max(e.y, 0), e.x = Math.max(e.x, 0), e;
}
function zUe(t, e) {
  for (var n = xae(t), r = 0, i = t.length; r < i; r++) {
    var o = t[r];
    if (o.x + o.w > e.cols && (o.x = e.cols - o.w), o.x < 0 && (o.x = 0, o.w = e.cols), !o.static)
      n.push(o);
    else
      for (; O_(n, o); )
        o.y++;
  }
  return t;
}
function wae(t, e) {
  for (var n = 0, r = t.length; n < r; n++)
    if (t[n].i === e)
      return t[n];
}
function O_(t, e) {
  for (var n = 0, r = t.length; n < r; n++)
    if (o9(t[n], e))
      return t[n];
}
function VUe(t, e) {
  return t.filter(function(n) {
    return o9(n, e);
  });
}
function xae(t) {
  return t.filter(function(e) {
    return e.static;
  });
}
function wZ(t, e, n, r, i, o, s, a, A) {
  if (e.static && e.isDraggable !== !0 || e.y === r && e.x === n)
    return t;
  "Moving element ".concat(e.i, " to [").concat(String(n), ",").concat(String(r), "] from [").concat(e.x, ",").concat(e.y, "]");
  var l = e.x, c = e.y;
  typeof n == "number" && (e.x = n), typeof r == "number" && (e.y = r), e.moved = !0;
  var u = Rae(t, s), f = s === "vertical" && typeof r == "number" ? c >= r : s === "horizontal" && typeof n == "number" ? l >= n : !1;
  f && (u = u.reverse());
  var h = VUe(u, e), d = h.length > 0;
  if (d && A)
    return $Ue(t);
  if (d && o)
    return "Collision prevented on ".concat(e.i, ", reverting."), e.x = l, e.y = c, e.moved = !1, t;
  for (var I = 0, m = h.length; I < m; I++) {
    var C = h[I];
    "Resolving collision between ".concat(e.i, " at [").concat(e.x, ",").concat(e.y, "] and ").concat(C.i, " at [").concat(C.x, ",").concat(C.y, "]"), !C.moved && (C.static ? t = xZ(t, C, e, i, s) : t = xZ(t, e, C, i, s));
  }
  return t;
}
function xZ(t, e, n, r, i, o) {
  var s = i === "horizontal", a = i !== "horizontal", A = e.static;
  if (r) {
    r = !1;
    var l = {
      x: s ? Math.max(e.x - n.w, 0) : n.x,
      y: a ? Math.max(e.y - n.h, 0) : n.y,
      w: n.w,
      h: n.h,
      i: "-1"
    };
    if (!O_(t, l))
      return "Doing reverse collision on ".concat(n.i, " up to [").concat(l.x, ",").concat(l.y, "]."), wZ(t, n, s ? l.x : void 0, a ? l.y : void 0, r, A, i);
  }
  return wZ(t, n, s ? n.x + 1 : void 0, a ? n.y + 1 : void 0, r, A, i);
}
function FFt(t) {
  return t * 100 + "%";
}
function PFt(t) {
  var e = t.top, n = t.left, r = t.width, i = t.height, o = "translate(".concat(n, "px,").concat(e, "px)");
  return {
    transform: o,
    WebkitTransform: o,
    MozTransform: o,
    msTransform: o,
    OTransform: o,
    width: "".concat(r, "px"),
    height: "".concat(i, "px"),
    position: "absolute"
  };
}
function kFt(t) {
  var e = t.top, n = t.left, r = t.width, i = t.height;
  return {
    top: "".concat(e, "px"),
    left: "".concat(n, "px"),
    width: "".concat(r, "px"),
    height: "".concat(i, "px"),
    position: "absolute"
  };
}
function Rae(t, e) {
  return e === "horizontal" ? KUe(t) : e === "vertical" ? JUe(t) : t;
}
function JUe(t) {
  return t.slice(0).sort(function(e, n) {
    return e.y > n.y || e.y === n.y && e.x > n.x ? 1 : e.y === n.y && e.x === n.x ? 0 : -1;
  });
}
function KUe(t) {
  return t.slice(0).sort(function(e, n) {
    return e.x > n.x || e.x === n.x && e.y > n.y ? 1 : -1;
  });
}
function GFt(t, e, n, r, i) {
  t = t || [];
  var o = [];
  SZ.default.Children.forEach(e, function(a) {
    if (a?.key != null) {
      var A = wae(t, String(a.key));
      if (A)
        o.push(Bv(A));
      else {
        var l = a.props["data-grid"] || a.props._grid;
        l ? o.push(Bv($ye($ye({}, l), {}, {
          i: a.key
        }))) : o.push(Bv({
          w: 1,
          h: 1,
          x: 0,
          y: Qae(o),
          i: String(a.key)
        }));
      }
    }
  });
  var s = zUe(o, {
    cols: n
  });
  return i ? s : jUe(s, r, n);
}
function UFt(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Layout", n = ["x", "y", "w", "h"];
  if (!Array.isArray(t))
    throw new Error(e + " must be an array!");
  for (var r = 0, i = t.length; r < i; r++)
    for (var o = t[r], s = 0; s < n.length; s++)
      if (typeof o[n[s]] != "number")
        throw new Error("ReactGridLayout: " + e + "[" + r + "]." + n[s] + " must be a number!");
}
function HFt(t) {
  var e = t || {}, n = e.verticalCompact, r = e.compactType;
  return n === !1 ? null : r;
}
var $Ft = function() {
};
pi.noop = $Ft;
var zI = {};
Object.defineProperty(zI, "__esModule", {
  value: !0
});
zI.calcGridColWidth = s9;
zI.calcGridItemPosition = qFt;
zI.calcGridItemWHPx = RZ;
zI.calcWH = YFt;
zI.calcXY = jFt;
zI.clamp = _T;
function s9(t) {
  var e = t.margin, n = t.containerPadding, r = t.containerWidth, i = t.cols;
  return (r - e[0] * (i - 1) - n[0] * 2) / i;
}
function RZ(t, e, n) {
  return Number.isFinite(t) ? Math.round(e * t + Math.max(0, t - 1) * n) : t;
}
function qFt(t, e, n, r, i, o) {
  var s = t.margin, a = t.containerPadding, A = t.rowHeight, l = s9(t), c = {};
  return o && o.resizing ? (c.width = Math.round(o.resizing.width), c.height = Math.round(o.resizing.height)) : (c.width = RZ(r, l, s[0]), c.height = RZ(i, A, s[1])), o && o.dragging ? (c.top = Math.round(o.dragging.top), c.left = Math.round(o.dragging.left)) : (c.top = Math.round((A + s[1]) * n + a[1]), c.left = Math.round((l + s[0]) * e + a[0])), c;
}
function jFt(t, e, n, r, i) {
  var o = t.margin, s = t.cols, a = t.rowHeight, A = t.maxRows, l = s9(t), c = Math.round((n - o[0]) / (l + o[0])), u = Math.round((e - o[1]) / (a + o[1]));
  return c = _T(c, 0, s - r), u = _T(u, 0, A - i), {
    x: c,
    y: u
  };
}
function YFt(t, e, n, r, i) {
  var o = t.margin, s = t.maxRows, a = t.cols, A = t.rowHeight, l = s9(t), c = Math.round((e + o[0]) / (l + o[0])), u = Math.round((n + o[1]) / (A + o[1]));
  return c = _T(c, 0, a - r), u = _T(u, 0, s - i), {
    w: c,
    h: u
  };
}
function _T(t, e, n) {
  return Math.max(Math.min(t, n), e);
}
var a9 = {}, A9 = { exports: {} }, WUe = {}, Ia = {}, i0 = {};
Object.defineProperty(i0, "__esModule", {
  value: !0
});
i0.dontSetMe = WFt;
i0.findInArray = zFt;
i0.int = KFt;
i0.isFunction = VFt;
i0.isNum = JFt;
function zFt(t, e) {
  for (var n = 0, r = t.length; n < r; n++)
    if (e.apply(e, [t[n], n, t]))
      return t[n];
}
function VFt(t) {
  return typeof t == "function" || Object.prototype.toString.call(t) === "[object Function]";
}
function JFt(t) {
  return typeof t == "number" && !isNaN(t);
}
function KFt(t) {
  return parseInt(t, 10);
}
function WFt(t, e, n) {
  if (t[e])
    return new Error("Invalid prop ".concat(e, " passed to ").concat(n, " - do not set this, set it on the child."));
}
var YB = {};
Object.defineProperty(YB, "__esModule", {
  value: !0
});
YB.browserPrefixToKey = ZUe;
YB.browserPrefixToStyle = XFt;
YB.default = void 0;
YB.getPrefix = XUe;
var Kz = ["Moz", "Webkit", "O", "ms"];
function XUe() {
  var t, e, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window > "u")
    return "";
  var r = (t = window.document) === null || t === void 0 || (e = t.documentElement) === null || e === void 0 ? void 0 : e.style;
  if (!r || n in r)
    return "";
  for (var i = 0; i < Kz.length; i++)
    if (ZUe(n, Kz[i]) in r)
      return Kz[i];
  return "";
}
function ZUe(t, e) {
  return e ? "".concat(e).concat(ZFt(t)) : t;
}
function XFt(t, e) {
  return e ? "-".concat(e.toLowerCase(), "-").concat(t) : t;
}
function ZFt(t) {
  for (var e = "", n = !0, r = 0; r < t.length; r++)
    n ? (e += t[r].toUpperCase(), n = !1) : t[r] === "-" ? n = !0 : e += t[r];
  return e;
}
var ePt = XUe();
YB.default = ePt;
function DZ(t) {
  "@babel/helpers - typeof";
  return DZ = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, DZ(t);
}
Object.defineProperty(Ia, "__esModule", {
  value: !0
});
Ia.addClassName = i8e;
Ia.addEvent = rPt;
Ia.addUserSelectStyles = hPt;
Ia.createCSSTransform = cPt;
Ia.createSVGTransform = uPt;
Ia.getTouch = fPt;
Ia.getTouchIdentifier = gPt;
Ia.getTranslation = Dae;
Ia.innerHeight = aPt;
Ia.innerWidth = APt;
Ia.matchesSelector = r8e;
Ia.matchesSelectorAndParentsTo = nPt;
Ia.offsetXYFromParent = lPt;
Ia.outerHeight = oPt;
Ia.outerWidth = sPt;
Ia.removeClassName = o8e;
Ia.removeEvent = iPt;
Ia.removeUserSelectStyles = dPt;
var Tf = i0, qye = tPt(YB);
function e8e(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (e8e = function(i) {
    return i ? n : e;
  })(t);
}
function tPt(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || DZ(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = e8e(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in t)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(t, o)) {
      var s = i ? Object.getOwnPropertyDescriptor(t, o) : null;
      s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = t[o];
    }
  return r.default = t, n && n.set(t, r), r;
}
function jye(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function t8e(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? jye(Object(n), !0).forEach(function(r) {
      n8e(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : jye(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function n8e(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var dF = "";
function r8e(t, e) {
  return dF || (dF = (0, Tf.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(n) {
    return (0, Tf.isFunction)(t[n]);
  })), (0, Tf.isFunction)(t[dF]) ? t[dF](e) : !1;
}
function nPt(t, e, n) {
  var r = t;
  do {
    if (r8e(r, e))
      return !0;
    if (r === n)
      return !1;
    r = r.parentNode;
  } while (r);
  return !1;
}
function rPt(t, e, n, r) {
  if (t) {
    var i = t8e({
      capture: !0
    }, r);
    t.addEventListener ? t.addEventListener(e, n, i) : t.attachEvent ? t.attachEvent("on" + e, n) : t["on" + e] = n;
  }
}
function iPt(t, e, n, r) {
  if (t) {
    var i = t8e({
      capture: !0
    }, r);
    t.removeEventListener ? t.removeEventListener(e, n, i) : t.detachEvent ? t.detachEvent("on" + e, n) : t["on" + e] = null;
  }
}
function oPt(t) {
  var e = t.clientHeight, n = t.ownerDocument.defaultView.getComputedStyle(t);
  return e += (0, Tf.int)(n.borderTopWidth), e += (0, Tf.int)(n.borderBottomWidth), e;
}
function sPt(t) {
  var e = t.clientWidth, n = t.ownerDocument.defaultView.getComputedStyle(t);
  return e += (0, Tf.int)(n.borderLeftWidth), e += (0, Tf.int)(n.borderRightWidth), e;
}
function aPt(t) {
  var e = t.clientHeight, n = t.ownerDocument.defaultView.getComputedStyle(t);
  return e -= (0, Tf.int)(n.paddingTop), e -= (0, Tf.int)(n.paddingBottom), e;
}
function APt(t) {
  var e = t.clientWidth, n = t.ownerDocument.defaultView.getComputedStyle(t);
  return e -= (0, Tf.int)(n.paddingLeft), e -= (0, Tf.int)(n.paddingRight), e;
}
function lPt(t, e, n) {
  var r = e === e.ownerDocument.body, i = r ? {
    left: 0,
    top: 0
  } : e.getBoundingClientRect(), o = (t.clientX + e.scrollLeft - i.left) / n, s = (t.clientY + e.scrollTop - i.top) / n;
  return {
    x: o,
    y: s
  };
}
function cPt(t, e) {
  var n = Dae(t, e, "px");
  return n8e({}, (0, qye.browserPrefixToKey)("transform", qye.default), n);
}
function uPt(t, e) {
  var n = Dae(t, e, "");
  return n;
}
function Dae(t, e, n) {
  var r = t.x, i = t.y, o = "translate(".concat(r).concat(n, ",").concat(i).concat(n, ")");
  if (e) {
    var s = "".concat(typeof e.x == "string" ? e.x : e.x + n), a = "".concat(typeof e.y == "string" ? e.y : e.y + n);
    o = "translate(".concat(s, ", ").concat(a, ")") + o;
  }
  return o;
}
function fPt(t, e) {
  return t.targetTouches && (0, Tf.findInArray)(t.targetTouches, function(n) {
    return e === n.identifier;
  }) || t.changedTouches && (0, Tf.findInArray)(t.changedTouches, function(n) {
    return e === n.identifier;
  });
}
function gPt(t) {
  if (t.targetTouches && t.targetTouches[0])
    return t.targetTouches[0].identifier;
  if (t.changedTouches && t.changedTouches[0])
    return t.changedTouches[0].identifier;
}
function hPt(t) {
  if (t) {
    var e = t.getElementById("react-draggable-style-el");
    e || (e = t.createElement("style"), e.type = "text/css", e.id = "react-draggable-style-el", e.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, e.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, t.getElementsByTagName("head")[0].appendChild(e)), t.body && i8e(t.body, "react-draggable-transparent-selection");
  }
}
function dPt(t) {
  if (t)
    try {
      if (t.body && o8e(t.body, "react-draggable-transparent-selection"), t.selection)
        t.selection.empty();
      else {
        var e = (t.defaultView || window).getSelection();
        e && e.type !== "Caret" && e.removeAllRanges();
      }
    } catch {
    }
}
function i8e(t, e) {
  t.classList ? t.classList.add(e) : t.className.match(new RegExp("(?:^|\\s)".concat(e, "(?!\\S)"))) || (t.className += " ".concat(e));
}
function o8e(t, e) {
  t.classList ? t.classList.remove(e) : t.className = t.className.replace(new RegExp("(?:^|\\s)".concat(e, "(?!\\S)"), "g"), "");
}
var o0 = {};
Object.defineProperty(o0, "__esModule", {
  value: !0
});
o0.canDragX = mPt;
o0.canDragY = CPt;
o0.createCoreData = yPt;
o0.createDraggableData = vPt;
o0.getBoundPosition = pPt;
o0.getControlPosition = EPt;
o0.snapToGrid = IPt;
var gf = i0, a_ = Ia;
function pPt(t, e, n) {
  if (!t.props.bounds)
    return [e, n];
  var r = t.props.bounds;
  r = typeof r == "string" ? r : BPt(r);
  var i = Tae(t);
  if (typeof r == "string") {
    var o = i.ownerDocument, s = o.defaultView, a;
    if (r === "parent" ? a = i.parentNode : a = o.querySelector(r), !(a instanceof s.HTMLElement))
      throw new Error('Bounds selector "' + r + '" could not find an element.');
    var A = a, l = s.getComputedStyle(i), c = s.getComputedStyle(A);
    r = {
      left: -i.offsetLeft + (0, gf.int)(c.paddingLeft) + (0, gf.int)(l.marginLeft),
      top: -i.offsetTop + (0, gf.int)(c.paddingTop) + (0, gf.int)(l.marginTop),
      right: (0, a_.innerWidth)(A) - (0, a_.outerWidth)(i) - i.offsetLeft + (0, gf.int)(c.paddingRight) - (0, gf.int)(l.marginRight),
      bottom: (0, a_.innerHeight)(A) - (0, a_.outerHeight)(i) - i.offsetTop + (0, gf.int)(c.paddingBottom) - (0, gf.int)(l.marginBottom)
    };
  }
  return (0, gf.isNum)(r.right) && (e = Math.min(e, r.right)), (0, gf.isNum)(r.bottom) && (n = Math.min(n, r.bottom)), (0, gf.isNum)(r.left) && (e = Math.max(e, r.left)), (0, gf.isNum)(r.top) && (n = Math.max(n, r.top)), [e, n];
}
function IPt(t, e, n) {
  var r = Math.round(e / t[0]) * t[0], i = Math.round(n / t[1]) * t[1];
  return [r, i];
}
function mPt(t) {
  return t.props.axis === "both" || t.props.axis === "x";
}
function CPt(t) {
  return t.props.axis === "both" || t.props.axis === "y";
}
function EPt(t, e, n) {
  var r = typeof e == "number" ? (0, a_.getTouch)(t, e) : null;
  if (typeof e == "number" && !r)
    return null;
  var i = Tae(n), o = n.props.offsetParent || i.offsetParent || i.ownerDocument.body;
  return (0, a_.offsetXYFromParent)(r || t, o, n.props.scale);
}
function yPt(t, e, n) {
  var r = t.state, i = !(0, gf.isNum)(r.lastX), o = Tae(t);
  return i ? {
    node: o,
    deltaX: 0,
    deltaY: 0,
    lastX: e,
    lastY: n,
    x: e,
    y: n
  } : {
    node: o,
    deltaX: e - r.lastX,
    deltaY: n - r.lastY,
    lastX: r.lastX,
    lastY: r.lastY,
    x: e,
    y: n
  };
}
function vPt(t, e) {
  var n = t.props.scale;
  return {
    node: e.node,
    x: t.state.x + e.deltaX / n,
    y: t.state.y + e.deltaY / n,
    deltaX: e.deltaX / n,
    deltaY: e.deltaY / n,
    lastX: t.state.x,
    lastY: t.state.y
  };
}
function BPt(t) {
  return {
    left: t.left,
    top: t.top,
    right: t.right,
    bottom: t.bottom
  };
}
function Tae(t) {
  var e = t.findDOMNode();
  if (!e)
    throw new Error("<DraggableCore>: Unmounted during event!");
  return e;
}
var l9 = {}, c9 = {};
Object.defineProperty(c9, "__esModule", {
  value: !0
});
c9.default = bPt;
function bPt() {
}
function j4(t) {
  "@babel/helpers - typeof";
  return j4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, j4(t);
}
Object.defineProperty(l9, "__esModule", {
  value: !0
});
l9.default = void 0;
var Wz = SPt(St), of = Nae(Ja), _Pt = Nae(Sf), _l = Ia, Bm = o0, Xz = i0, jx = Nae(c9);
function Nae(t) {
  return t && t.__esModule ? t : { default: t };
}
function s8e(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (s8e = function(i) {
    return i ? n : e;
  })(t);
}
function SPt(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || j4(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = s8e(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in t)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(t, o)) {
      var s = i ? Object.getOwnPropertyDescriptor(t, o) : null;
      s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = t[o];
    }
  return r.default = t, n && n.set(t, r), r;
}
function Yye(t, e) {
  return RPt(t) || xPt(t, e) || wPt(t, e) || QPt();
}
function QPt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wPt(t, e) {
  if (t) {
    if (typeof t == "string")
      return zye(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return zye(t, e);
  }
}
function zye(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function xPt(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, s, a;
    try {
      for (n = n.call(t); !(i = (s = n.next()).done) && (r.push(s.value), !(e && r.length === e)); i = !0)
        ;
    } catch (A) {
      o = !0, a = A;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o)
          throw a;
      }
    }
    return r;
  }
}
function RPt(t) {
  if (Array.isArray(t))
    return t;
}
function DPt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Vye(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function TPt(t, e, n) {
  return e && Vye(t.prototype, e), n && Vye(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function NPt(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && TZ(t, e);
}
function TZ(t, e) {
  return TZ = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, TZ(t, e);
}
function LPt(t) {
  var e = OPt();
  return function() {
    var r = Y4(t), i;
    if (e) {
      var o = Y4(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return MPt(this, i);
  };
}
function MPt(t, e) {
  if (e && (j4(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ll(t);
}
function Ll(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function OPt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Y4(t) {
  return Y4 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Y4(t);
}
function Ag(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Bh = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
}, bm = Bh.mouse, u9 = /* @__PURE__ */ function(t) {
  NPt(n, t);
  var e = LPt(n);
  function n() {
    var r;
    DPt(this, n);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)), Ag(Ll(r), "state", {
      dragging: !1,
      // Used while dragging to determine deltas.
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: null
    }), Ag(Ll(r), "mounted", !1), Ag(Ll(r), "handleDragStart", function(a) {
      if (r.props.onMouseDown(a), !r.props.allowAnyClick && typeof a.button == "number" && a.button !== 0)
        return !1;
      var A = r.findDOMNode();
      if (!A || !A.ownerDocument || !A.ownerDocument.body)
        throw new Error("<DraggableCore> not mounted on DragStart!");
      var l = A.ownerDocument;
      if (!(r.props.disabled || !(a.target instanceof l.defaultView.Node) || r.props.handle && !(0, _l.matchesSelectorAndParentsTo)(a.target, r.props.handle, A) || r.props.cancel && (0, _l.matchesSelectorAndParentsTo)(a.target, r.props.cancel, A))) {
        a.type === "touchstart" && a.preventDefault();
        var c = (0, _l.getTouchIdentifier)(a);
        r.setState({
          touchIdentifier: c
        });
        var u = (0, Bm.getControlPosition)(a, c, Ll(r));
        if (u != null) {
          var f = u.x, h = u.y, d = (0, Bm.createCoreData)(Ll(r), f, h);
          (0, jx.default)("DraggableCore: handleDragStart: %j", d), (0, jx.default)("calling", r.props.onStart);
          var I = r.props.onStart(a, d);
          I === !1 || r.mounted === !1 || (r.props.enableUserSelectHack && (0, _l.addUserSelectStyles)(l), r.setState({
            dragging: !0,
            lastX: f,
            lastY: h
          }), (0, _l.addEvent)(l, bm.move, r.handleDrag), (0, _l.addEvent)(l, bm.stop, r.handleDragStop));
        }
      }
    }), Ag(Ll(r), "handleDrag", function(a) {
      var A = (0, Bm.getControlPosition)(a, r.state.touchIdentifier, Ll(r));
      if (A != null) {
        var l = A.x, c = A.y;
        if (Array.isArray(r.props.grid)) {
          var u = l - r.state.lastX, f = c - r.state.lastY, h = (0, Bm.snapToGrid)(r.props.grid, u, f), d = Yye(h, 2);
          if (u = d[0], f = d[1], !u && !f)
            return;
          l = r.state.lastX + u, c = r.state.lastY + f;
        }
        var I = (0, Bm.createCoreData)(Ll(r), l, c);
        (0, jx.default)("DraggableCore: handleDrag: %j", I);
        var m = r.props.onDrag(a, I);
        if (m === !1 || r.mounted === !1) {
          try {
            r.handleDragStop(new MouseEvent("mouseup"));
          } catch {
            var C = document.createEvent("MouseEvents");
            C.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), r.handleDragStop(C);
          }
          return;
        }
        r.setState({
          lastX: l,
          lastY: c
        });
      }
    }), Ag(Ll(r), "handleDragStop", function(a) {
      if (r.state.dragging) {
        var A = (0, Bm.getControlPosition)(a, r.state.touchIdentifier, Ll(r));
        if (A != null) {
          var l = A.x, c = A.y;
          if (Array.isArray(r.props.grid)) {
            var u = l - r.state.lastX || 0, f = c - r.state.lastY || 0, h = (0, Bm.snapToGrid)(r.props.grid, u, f), d = Yye(h, 2);
            u = d[0], f = d[1], l = r.state.lastX + u, c = r.state.lastY + f;
          }
          var I = (0, Bm.createCoreData)(Ll(r), l, c), m = r.props.onStop(a, I);
          if (m === !1 || r.mounted === !1)
            return !1;
          var C = r.findDOMNode();
          C && r.props.enableUserSelectHack && (0, _l.removeUserSelectStyles)(C.ownerDocument), (0, jx.default)("DraggableCore: handleDragStop: %j", I), r.setState({
            dragging: !1,
            lastX: NaN,
            lastY: NaN
          }), C && ((0, jx.default)("DraggableCore: Removing handlers"), (0, _l.removeEvent)(C.ownerDocument, bm.move, r.handleDrag), (0, _l.removeEvent)(C.ownerDocument, bm.stop, r.handleDragStop));
        }
      }
    }), Ag(Ll(r), "onMouseDown", function(a) {
      return bm = Bh.mouse, r.handleDragStart(a);
    }), Ag(Ll(r), "onMouseUp", function(a) {
      return bm = Bh.mouse, r.handleDragStop(a);
    }), Ag(Ll(r), "onTouchStart", function(a) {
      return bm = Bh.touch, r.handleDragStart(a);
    }), Ag(Ll(r), "onTouchEnd", function(a) {
      return bm = Bh.touch, r.handleDragStop(a);
    }), r;
  }
  return TPt(n, [{
    key: "componentDidMount",
    value: function() {
      this.mounted = !0;
      var i = this.findDOMNode();
      i && (0, _l.addEvent)(i, Bh.touch.start, this.onTouchStart, {
        passive: !1
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var i = this.findDOMNode();
      if (i) {
        var o = i.ownerDocument;
        (0, _l.removeEvent)(o, Bh.mouse.move, this.handleDrag), (0, _l.removeEvent)(o, Bh.touch.move, this.handleDrag), (0, _l.removeEvent)(o, Bh.mouse.stop, this.handleDragStop), (0, _l.removeEvent)(o, Bh.touch.stop, this.handleDragStop), (0, _l.removeEvent)(i, Bh.touch.start, this.onTouchStart, {
          passive: !1
        }), this.props.enableUserSelectHack && (0, _l.removeUserSelectStyles)(o);
      }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
  }, {
    key: "findDOMNode",
    value: function() {
      var i, o, s;
      return (i = this.props) !== null && i !== void 0 && i.nodeRef ? (o = this.props) === null || o === void 0 || (s = o.nodeRef) === null || s === void 0 ? void 0 : s.current : _Pt.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ Wz.cloneElement(Wz.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  }]), n;
}(Wz.Component);
l9.default = u9;
Ag(u9, "displayName", "DraggableCore");
Ag(u9, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: of.default.bool,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: of.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: of.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function(e, n) {
    if (e[n] && e[n].nodeType !== 1)
      throw new Error("Draggable's offsetParent must be a DOM Node.");
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: of.default.arrayOf(of.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: of.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: of.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: of.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: of.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: of.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: of.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: of.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: of.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: Xz.dontSetMe,
  style: Xz.dontSetMe,
  transform: Xz.dontSetMe
});
Ag(u9, "defaultProps", {
  allowAnyClick: !1,
  // by default only accept left click
  disabled: !1,
  enableUserSelectHack: !0,
  onStart: function() {
  },
  onDrag: function() {
  },
  onStop: function() {
  },
  onMouseDown: function() {
  },
  scale: 1
});
(function(t) {
  function e(ee) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(pe) {
      return typeof pe;
    } : function(pe) {
      return pe && typeof Symbol == "function" && pe.constructor === Symbol && pe !== Symbol.prototype ? "symbol" : typeof pe;
    }, e(ee);
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "DraggableCore", {
    enumerable: !0,
    get: function() {
      return l.default;
    }
  }), t.default = void 0;
  var n = d(St), r = f(Ja), i = f(Sf), o = f(jB), s = Ia, a = o0, A = i0, l = f(l9), c = f(c9), u = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];
  function f(ee) {
    return ee && ee.__esModule ? ee : { default: ee };
  }
  function h(ee) {
    if (typeof WeakMap != "function")
      return null;
    var pe = /* @__PURE__ */ new WeakMap(), Ce = /* @__PURE__ */ new WeakMap();
    return (h = function(Ie) {
      return Ie ? Ce : pe;
    })(ee);
  }
  function d(ee, pe) {
    if (!pe && ee && ee.__esModule)
      return ee;
    if (ee === null || e(ee) !== "object" && typeof ee != "function")
      return { default: ee };
    var Ce = h(pe);
    if (Ce && Ce.has(ee))
      return Ce.get(ee);
    var Be = {}, Ie = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var Qe in ee)
      if (Qe !== "default" && Object.prototype.hasOwnProperty.call(ee, Qe)) {
        var xe = Ie ? Object.getOwnPropertyDescriptor(ee, Qe) : null;
        xe && (xe.get || xe.set) ? Object.defineProperty(Be, Qe, xe) : Be[Qe] = ee[Qe];
      }
    return Be.default = ee, Ce && Ce.set(ee, Be), Be;
  }
  function I() {
    return I = Object.assign || function(ee) {
      for (var pe = 1; pe < arguments.length; pe++) {
        var Ce = arguments[pe];
        for (var Be in Ce)
          Object.prototype.hasOwnProperty.call(Ce, Be) && (ee[Be] = Ce[Be]);
      }
      return ee;
    }, I.apply(this, arguments);
  }
  function m(ee, pe) {
    if (ee == null)
      return {};
    var Ce = C(ee, pe), Be, Ie;
    if (Object.getOwnPropertySymbols) {
      var Qe = Object.getOwnPropertySymbols(ee);
      for (Ie = 0; Ie < Qe.length; Ie++)
        Be = Qe[Ie], !(pe.indexOf(Be) >= 0) && Object.prototype.propertyIsEnumerable.call(ee, Be) && (Ce[Be] = ee[Be]);
    }
    return Ce;
  }
  function C(ee, pe) {
    if (ee == null)
      return {};
    var Ce = {}, Be = Object.keys(ee), Ie, Qe;
    for (Qe = 0; Qe < Be.length; Qe++)
      Ie = Be[Qe], !(pe.indexOf(Ie) >= 0) && (Ce[Ie] = ee[Ie]);
    return Ce;
  }
  function y(ee, pe) {
    var Ce = Object.keys(ee);
    if (Object.getOwnPropertySymbols) {
      var Be = Object.getOwnPropertySymbols(ee);
      pe && (Be = Be.filter(function(Ie) {
        return Object.getOwnPropertyDescriptor(ee, Ie).enumerable;
      })), Ce.push.apply(Ce, Be);
    }
    return Ce;
  }
  function v(ee) {
    for (var pe = 1; pe < arguments.length; pe++) {
      var Ce = arguments[pe] != null ? arguments[pe] : {};
      pe % 2 ? y(Object(Ce), !0).forEach(function(Be) {
        Z(ee, Be, Ce[Be]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ee, Object.getOwnPropertyDescriptors(Ce)) : y(Object(Ce)).forEach(function(Be) {
        Object.defineProperty(ee, Be, Object.getOwnPropertyDescriptor(Ce, Be));
      });
    }
    return ee;
  }
  function b(ee, pe) {
    return O(ee) || M(ee, pe) || w(ee, pe) || Q();
  }
  function Q() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function w(ee, pe) {
    if (ee) {
      if (typeof ee == "string")
        return R(ee, pe);
      var Ce = Object.prototype.toString.call(ee).slice(8, -1);
      if (Ce === "Object" && ee.constructor && (Ce = ee.constructor.name), Ce === "Map" || Ce === "Set")
        return Array.from(ee);
      if (Ce === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ce))
        return R(ee, pe);
    }
  }
  function R(ee, pe) {
    (pe == null || pe > ee.length) && (pe = ee.length);
    for (var Ce = 0, Be = new Array(pe); Ce < pe; Ce++)
      Be[Ce] = ee[Ce];
    return Be;
  }
  function M(ee, pe) {
    var Ce = ee == null ? null : typeof Symbol < "u" && ee[Symbol.iterator] || ee["@@iterator"];
    if (Ce != null) {
      var Be = [], Ie = !0, Qe = !1, xe, Se;
      try {
        for (Ce = Ce.call(ee); !(Ie = (xe = Ce.next()).done) && (Be.push(xe.value), !(pe && Be.length === pe)); Ie = !0)
          ;
      } catch (De) {
        Qe = !0, Se = De;
      } finally {
        try {
          !Ie && Ce.return != null && Ce.return();
        } finally {
          if (Qe)
            throw Se;
        }
      }
      return Be;
    }
  }
  function O(ee) {
    if (Array.isArray(ee))
      return ee;
  }
  function L(ee, pe) {
    if (!(ee instanceof pe))
      throw new TypeError("Cannot call a class as a function");
  }
  function N(ee, pe) {
    for (var Ce = 0; Ce < pe.length; Ce++) {
      var Be = pe[Ce];
      Be.enumerable = Be.enumerable || !1, Be.configurable = !0, "value" in Be && (Be.writable = !0), Object.defineProperty(ee, Be.key, Be);
    }
  }
  function k(ee, pe, Ce) {
    return pe && N(ee.prototype, pe), Ce && N(ee, Ce), Object.defineProperty(ee, "prototype", { writable: !1 }), ee;
  }
  function $(ee, pe) {
    if (typeof pe != "function" && pe !== null)
      throw new TypeError("Super expression must either be null or a function");
    ee.prototype = Object.create(pe && pe.prototype, { constructor: { value: ee, writable: !0, configurable: !0 } }), Object.defineProperty(ee, "prototype", { writable: !1 }), pe && U(ee, pe);
  }
  function U(ee, pe) {
    return U = Object.setPrototypeOf || function(Be, Ie) {
      return Be.__proto__ = Ie, Be;
    }, U(ee, pe);
  }
  function X(ee) {
    var pe = Y();
    return function() {
      var Be = V(ee), Ie;
      if (pe) {
        var Qe = V(this).constructor;
        Ie = Reflect.construct(Be, arguments, Qe);
      } else
        Ie = Be.apply(this, arguments);
      return K(this, Ie);
    };
  }
  function K(ee, pe) {
    if (pe && (e(pe) === "object" || typeof pe == "function"))
      return pe;
    if (pe !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return z(ee);
  }
  function z(ee) {
    if (ee === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return ee;
  }
  function Y() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function V(ee) {
    return V = Object.setPrototypeOf ? Object.getPrototypeOf : function(Ce) {
      return Ce.__proto__ || Object.getPrototypeOf(Ce);
    }, V(ee);
  }
  function Z(ee, pe, Ce) {
    return pe in ee ? Object.defineProperty(ee, pe, { value: Ce, enumerable: !0, configurable: !0, writable: !0 }) : ee[pe] = Ce, ee;
  }
  var ce = /* @__PURE__ */ function(ee) {
    $(Ce, ee);
    var pe = X(Ce);
    function Ce(Be) {
      var Ie;
      return L(this, Ce), Ie = pe.call(this, Be), Z(z(Ie), "onDragStart", function(Qe, xe) {
        (0, c.default)("Draggable: onDragStart: %j", xe);
        var Se = Ie.props.onStart(Qe, (0, a.createDraggableData)(z(Ie), xe));
        if (Se === !1)
          return !1;
        Ie.setState({
          dragging: !0,
          dragged: !0
        });
      }), Z(z(Ie), "onDrag", function(Qe, xe) {
        if (!Ie.state.dragging)
          return !1;
        (0, c.default)("Draggable: onDrag: %j", xe);
        var Se = (0, a.createDraggableData)(z(Ie), xe), De = {
          x: Se.x,
          y: Se.y
        };
        if (Ie.props.bounds) {
          var Ue = De.x, Te = De.y;
          De.x += Ie.state.slackX, De.y += Ie.state.slackY;
          var se = (0, a.getBoundPosition)(z(Ie), De.x, De.y), fe = b(se, 2), W = fe[0], ge = fe[1];
          De.x = W, De.y = ge, De.slackX = Ie.state.slackX + (Ue - De.x), De.slackY = Ie.state.slackY + (Te - De.y), Se.x = De.x, Se.y = De.y, Se.deltaX = De.x - Ie.state.x, Se.deltaY = De.y - Ie.state.y;
        }
        var _e = Ie.props.onDrag(Qe, Se);
        if (_e === !1)
          return !1;
        Ie.setState(De);
      }), Z(z(Ie), "onDragStop", function(Qe, xe) {
        if (!Ie.state.dragging)
          return !1;
        var Se = Ie.props.onStop(Qe, (0, a.createDraggableData)(z(Ie), xe));
        if (Se === !1)
          return !1;
        (0, c.default)("Draggable: onDragStop: %j", xe);
        var De = {
          dragging: !1,
          slackX: 0,
          slackY: 0
        }, Ue = !!Ie.props.position;
        if (Ue) {
          var Te = Ie.props.position, se = Te.x, fe = Te.y;
          De.x = se, De.y = fe;
        }
        Ie.setState(De);
      }), Ie.state = {
        // Whether or not we are currently dragging.
        dragging: !1,
        // Whether or not we have been dragged before.
        dragged: !1,
        // Current transform x and y.
        x: Be.position ? Be.position.x : Be.defaultPosition.x,
        y: Be.position ? Be.position.y : Be.defaultPosition.y,
        prevPropsPosition: v({}, Be.position),
        // Used for compensating for out-of-bounds drags
        slackX: 0,
        slackY: 0,
        // Can only determine if SVG after mounting
        isElementSVG: !1
      }, Be.position && !(Be.onDrag || Be.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element."), Ie;
    }
    return k(Ce, [{
      key: "componentDidMount",
      value: function() {
        typeof window.SVGElement < "u" && this.findDOMNode() instanceof window.SVGElement && this.setState({
          isElementSVG: !0
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.setState({
          dragging: !1
        });
      }
      // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
      // the underlying DOM node ourselves. See the README for more information.
    }, {
      key: "findDOMNode",
      value: function() {
        var Ie, Qe, xe;
        return (Ie = (Qe = this.props) === null || Qe === void 0 || (xe = Qe.nodeRef) === null || xe === void 0 ? void 0 : xe.current) !== null && Ie !== void 0 ? Ie : i.default.findDOMNode(this);
      }
    }, {
      key: "render",
      value: function() {
        var Ie, Qe = this.props;
        Qe.axis, Qe.bounds;
        var xe = Qe.children, Se = Qe.defaultPosition, De = Qe.defaultClassName, Ue = Qe.defaultClassNameDragging, Te = Qe.defaultClassNameDragged, se = Qe.position, fe = Qe.positionOffset;
        Qe.scale;
        var W = m(Qe, u), ge = {}, _e = null, Re = !!se, Ee = !Re || this.state.dragging, oe = se || Se, ie = {
          // Set left if horizontal drag is enabled
          x: (0, a.canDragX)(this) && Ee ? this.state.x : oe.x,
          // Set top if vertical drag is enabled
          y: (0, a.canDragY)(this) && Ee ? this.state.y : oe.y
        };
        this.state.isElementSVG ? _e = (0, s.createSVGTransform)(ie, fe) : ge = (0, s.createCSSTransform)(ie, fe);
        var Ae = (0, o.default)(xe.props.className || "", De, (Ie = {}, Z(Ie, Ue, this.state.dragging), Z(Ie, Te, this.state.dragged), Ie));
        return /* @__PURE__ */ n.createElement(l.default, I({}, W, {
          onStart: this.onDragStart,
          onDrag: this.onDrag,
          onStop: this.onDragStop
        }), /* @__PURE__ */ n.cloneElement(n.Children.only(xe), {
          className: Ae,
          style: v(v({}, xe.props.style), ge),
          transform: _e
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: (
        // React 16.3+
        // Arity (props, state)
        function(Ie, Qe) {
          var xe = Ie.position, Se = Qe.prevPropsPosition;
          return xe && (!Se || xe.x !== Se.x || xe.y !== Se.y) ? ((0, c.default)("Draggable: getDerivedStateFromProps %j", {
            position: xe,
            prevPropsPosition: Se
          }), {
            x: xe.x,
            y: xe.y,
            prevPropsPosition: v({}, xe)
          }) : null;
        }
      )
    }]), Ce;
  }(n.Component);
  t.default = ce, Z(ce, "displayName", "Draggable"), Z(ce, "propTypes", v(v({}, l.default.propTypes), {}, {
    /**
     * `axis` determines which axis the draggable can move.
     *
     *  Note that all callbacks will still return data as normal. This only
     *  controls flushing to the DOM.
     *
     * 'both' allows movement horizontally and vertically.
     * 'x' limits movement to horizontal axis.
     * 'y' limits movement to vertical axis.
     * 'none' limits all movement.
     *
     * Defaults to 'both'.
     */
    axis: r.default.oneOf(["both", "x", "y", "none"]),
    /**
     * `bounds` determines the range of movement available to the element.
     * Available values are:
     *
     * 'parent' restricts movement within the Draggable's parent node.
     *
     * Alternatively, pass an object with the following properties, all of which are optional:
     *
     * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
     *
     * All values are in px.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable bounds={{right: 300, bottom: 300}}>
     *              <div>Content</div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    bounds: r.default.oneOfType([r.default.shape({
      left: r.default.number,
      right: r.default.number,
      top: r.default.number,
      bottom: r.default.number
    }), r.default.string, r.default.oneOf([!1])]),
    defaultClassName: r.default.string,
    defaultClassNameDragging: r.default.string,
    defaultClassNameDragged: r.default.string,
    /**
     * `defaultPosition` specifies the x and y that the dragged item should start at
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable defaultPosition={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    defaultPosition: r.default.shape({
      x: r.default.number,
      y: r.default.number
    }),
    positionOffset: r.default.shape({
      x: r.default.oneOfType([r.default.number, r.default.string]),
      y: r.default.oneOfType([r.default.number, r.default.string])
    }),
    /**
     * `position`, if present, defines the current position of the element.
     *
     *  This is similar to how form elements in React work - if no `position` is supplied, the component
     *  is uncontrolled.
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable position={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    position: r.default.shape({
      x: r.default.number,
      y: r.default.number
    }),
    /**
     * These properties should be defined on the child, not here.
     */
    className: A.dontSetMe,
    style: A.dontSetMe,
    transform: A.dontSetMe
  })), Z(ce, "defaultProps", v(v({}, l.default.defaultProps), {}, {
    axis: "both",
    bounds: !1,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  }));
})(WUe);
var a8e = WUe, A8e = a8e.default, FPt = a8e.DraggableCore;
A9.exports = A8e;
A9.exports.default = A8e;
A9.exports.DraggableCore = FPt;
var l8e = A9.exports, f9 = { exports: {} }, bL = {}, Lae = {};
Lae.__esModule = !0;
Lae.cloneElement = UPt;
var PPt = kPt(St);
function kPt(t) {
  return t && t.__esModule ? t : { default: t };
}
function Jye(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Kye(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Jye(Object(n), !0).forEach(function(r) {
      GPt(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Jye(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function GPt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function UPt(t, e) {
  return e.style && t.props.style && (e.style = Kye(Kye({}, t.props.style), e.style)), e.className && t.props.className && (e.className = t.props.className + " " + e.className), /* @__PURE__ */ PPt.default.cloneElement(t, e);
}
var _L = {};
_L.__esModule = !0;
_L.resizableProps = void 0;
var di = HPt(Ja);
function HPt(t) {
  return t && t.__esModule ? t : { default: t };
}
var $Pt = {
  /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */
  axis: di.default.oneOf(["both", "x", "y", "none"]),
  className: di.default.string,
  /*
  * Require that one and only one child be present.
  * */
  children: di.default.element.isRequired,
  /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */
  draggableOpts: di.default.shape({
    allowAnyClick: di.default.bool,
    cancel: di.default.string,
    children: di.default.node,
    disabled: di.default.bool,
    enableUserSelectHack: di.default.bool,
    offsetParent: di.default.node,
    grid: di.default.arrayOf(di.default.number),
    handle: di.default.string,
    nodeRef: di.default.object,
    onStart: di.default.func,
    onDrag: di.default.func,
    onStop: di.default.func,
    onMouseDown: di.default.func,
    scale: di.default.number
  }),
  /*
  * Initial height
  * */
  height: di.default.number.isRequired,
  /*
  * Customize cursor resize handle
  * */
  handle: di.default.oneOfType([di.default.node, di.default.func]),
  /*
  * If you change this, be sure to update your css
  * */
  handleSize: di.default.arrayOf(di.default.number),
  lockAspectRatio: di.default.bool,
  /*
  * Max X & Y measure
  * */
  maxConstraints: di.default.arrayOf(di.default.number),
  /*
  * Min X & Y measure
  * */
  minConstraints: di.default.arrayOf(di.default.number),
  /*
  * Called on stop resize event
  * */
  onResizeStop: di.default.func,
  /*
  * Called on start resize event
  * */
  onResizeStart: di.default.func,
  /*
  * Called on resize event
  * */
  onResize: di.default.func,
  /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */
  resizeHandles: di.default.arrayOf(di.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"])),
  /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */
  transformScale: di.default.number,
  /*
   * Initial width
   */
  width: di.default.number.isRequired
};
_L.resizableProps = $Pt;
bL.__esModule = !0;
bL.default = void 0;
var Yx = VPt(St), qPt = l8e, jPt = Lae, YPt = _L, zPt = ["children", "className", "draggableOpts", "width", "height", "handle", "handleSize", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "resizeHandles", "transformScale"];
function c8e(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (c8e = function(i) {
    return i ? n : e;
  })(t);
}
function VPt(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || typeof t != "object" && typeof t != "function")
    return { default: t };
  var n = c8e(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in t)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(t, o)) {
      var s = i ? Object.getOwnPropertyDescriptor(t, o) : null;
      s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = t[o];
    }
  return r.default = t, n && n.set(t, r), r;
}
function NZ() {
  return NZ = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, NZ.apply(this, arguments);
}
function JPt(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
function Wye(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Zz(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Wye(Object(n), !0).forEach(function(r) {
      KPt(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Wye(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function KPt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function WPt(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, LZ(t, e);
}
function LZ(t, e) {
  return LZ = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, LZ(t, e);
}
var Mae = /* @__PURE__ */ function(t) {
  WPt(e, t);
  function e() {
    for (var r, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(o)) || this, r.handleRefs = {}, r.lastHandleRect = null, r.slack = null, r;
  }
  var n = e.prototype;
  return n.componentWillUnmount = function() {
    this.resetData();
  }, n.resetData = function() {
    this.lastHandleRect = this.slack = null;
  }, n.runConstraints = function(i, o) {
    var s = this.props, a = s.minConstraints, A = s.maxConstraints, l = s.lockAspectRatio;
    if (!a && !A && !l)
      return [i, o];
    if (l) {
      var c = this.props.width / this.props.height, u = i - this.props.width, f = o - this.props.height;
      Math.abs(u) > Math.abs(f * c) ? o = i / c : i = o * c;
    }
    var h = i, d = o, I = this.slack || [0, 0], m = I[0], C = I[1];
    return i += m, o += C, a && (i = Math.max(a[0], i), o = Math.max(a[1], o)), A && (i = Math.min(A[0], i), o = Math.min(A[1], o)), this.slack = [m + (h - i), C + (d - o)], [i, o];
  }, n.resizeHandler = function(i, o) {
    var s = this;
    return function(a, A) {
      var l = A.node, c = A.deltaX, u = A.deltaY;
      i === "onResizeStart" && s.resetData();
      var f = (s.props.axis === "both" || s.props.axis === "x") && o !== "n" && o !== "s", h = (s.props.axis === "both" || s.props.axis === "y") && o !== "e" && o !== "w";
      if (!(!f && !h)) {
        var d = o[0], I = o[o.length - 1], m = l.getBoundingClientRect();
        if (s.lastHandleRect != null) {
          if (I === "w") {
            var C = m.left - s.lastHandleRect.left;
            c += C;
          }
          if (d === "n") {
            var y = m.top - s.lastHandleRect.top;
            u += y;
          }
        }
        s.lastHandleRect = m, I === "w" && (c = -c), d === "n" && (u = -u);
        var v = s.props.width + (f ? c / s.props.transformScale : 0), b = s.props.height + (h ? u / s.props.transformScale : 0), Q = s.runConstraints(v, b);
        v = Q[0], b = Q[1];
        var w = v !== s.props.width || b !== s.props.height, R = typeof s.props[i] == "function" ? s.props[i] : null, M = i === "onResize" && !w;
        R && !M && (a.persist == null || a.persist(), R(a, {
          node: l,
          size: {
            width: v,
            height: b
          },
          handle: o
        })), i === "onResizeStop" && s.resetData();
      }
    };
  }, n.renderResizeHandle = function(i, o) {
    var s = this.props.handle;
    if (!s)
      return /* @__PURE__ */ Yx.createElement("span", {
        className: "react-resizable-handle react-resizable-handle-" + i,
        ref: o
      });
    if (typeof s == "function")
      return s(i, o);
    var a = typeof s.type == "string", A = Zz({
      ref: o
    }, a ? {} : {
      handleAxis: i
    });
    return /* @__PURE__ */ Yx.cloneElement(s, A);
  }, n.render = function() {
    var i = this, o = this.props, s = o.children, a = o.className, A = o.draggableOpts;
    o.width, o.height, o.handle, o.handleSize, o.lockAspectRatio, o.axis, o.minConstraints, o.maxConstraints, o.onResize, o.onResizeStop, o.onResizeStart;
    var l = o.resizeHandles;
    o.transformScale;
    var c = JPt(o, zPt);
    return (0, jPt.cloneElement)(s, Zz(Zz({}, c), {}, {
      className: (a ? a + " " : "") + "react-resizable",
      children: [].concat(s.props.children, l.map(function(u) {
        var f, h = (f = i.handleRefs[u]) != null ? f : i.handleRefs[u] = /* @__PURE__ */ Yx.createRef();
        return /* @__PURE__ */ Yx.createElement(qPt.DraggableCore, NZ({}, A, {
          nodeRef: h,
          key: "resizableHandle-" + u,
          onStop: i.resizeHandler("onResizeStop", u),
          onStart: i.resizeHandler("onResizeStart", u),
          onDrag: i.resizeHandler("onResize", u)
        }), i.renderResizeHandle(u, h));
      }))
    }));
  }, e;
}(Yx.Component);
bL.default = Mae;
Mae.propTypes = YPt.resizableProps;
Mae.defaultProps = {
  axis: "both",
  handleSize: [20, 20],
  lockAspectRatio: !1,
  minConstraints: [20, 20],
  maxConstraints: [1 / 0, 1 / 0],
  resizeHandles: ["se"],
  transformScale: 1
};
var g9 = {};
g9.__esModule = !0;
g9.default = void 0;
var e7 = n3t(St), XPt = u8e(Ja), ZPt = u8e(bL), e3t = _L, t3t = ["handle", "handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio", "axis", "width", "height", "resizeHandles", "style", "transformScale"];
function u8e(t) {
  return t && t.__esModule ? t : { default: t };
}
function f8e(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (f8e = function(i) {
    return i ? n : e;
  })(t);
}
function n3t(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || typeof t != "object" && typeof t != "function")
    return { default: t };
  var n = f8e(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in t)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(t, o)) {
      var s = i ? Object.getOwnPropertyDescriptor(t, o) : null;
      s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = t[o];
    }
  return r.default = t, n && n.set(t, r), r;
}
function MZ() {
  return MZ = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, MZ.apply(this, arguments);
}
function Xye(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function z4(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Xye(Object(n), !0).forEach(function(r) {
      r3t(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Xye(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function r3t(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function i3t(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
function o3t(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, OZ(t, e);
}
function OZ(t, e) {
  return OZ = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, OZ(t, e);
}
var g8e = /* @__PURE__ */ function(t) {
  o3t(e, t);
  function e() {
    for (var r, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(o)) || this, r.state = {
      width: r.props.width,
      height: r.props.height,
      propsWidth: r.props.width,
      propsHeight: r.props.height
    }, r.onResize = function(a, A) {
      var l = A.size;
      r.props.onResize ? (a.persist == null || a.persist(), r.setState(l, function() {
        return r.props.onResize && r.props.onResize(a, A);
      })) : r.setState(l);
    }, r;
  }
  e.getDerivedStateFromProps = function(i, o) {
    return o.propsWidth !== i.width || o.propsHeight !== i.height ? {
      width: i.width,
      height: i.height,
      propsWidth: i.width,
      propsHeight: i.height
    } : null;
  };
  var n = e.prototype;
  return n.render = function() {
    var i = this.props, o = i.handle, s = i.handleSize;
    i.onResize;
    var a = i.onResizeStart, A = i.onResizeStop, l = i.draggableOpts, c = i.minConstraints, u = i.maxConstraints, f = i.lockAspectRatio, h = i.axis;
    i.width, i.height;
    var d = i.resizeHandles, I = i.style, m = i.transformScale, C = i3t(i, t3t);
    return /* @__PURE__ */ e7.createElement(ZPt.default, {
      axis: h,
      draggableOpts: l,
      handle: o,
      handleSize: s,
      height: this.state.height,
      lockAspectRatio: f,
      maxConstraints: u,
      minConstraints: c,
      onResizeStart: a,
      onResize: this.onResize,
      onResizeStop: A,
      resizeHandles: d,
      transformScale: m,
      width: this.state.width
    }, /* @__PURE__ */ e7.createElement("div", MZ({}, C, {
      style: z4(z4({}, I), {}, {
        width: this.state.width + "px",
        height: this.state.height + "px"
      })
    })));
  }, e;
}(e7.Component);
g9.default = g8e;
g8e.propTypes = z4(z4({}, e3t.resizableProps), {}, {
  children: XPt.default.element
});
f9.exports = function() {
  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};
f9.exports.Resizable = bL.default;
f9.exports.ResizableBox = g9.default;
var s3t = f9.exports, dI = {};
Object.defineProperty(dI, "__esModule", {
  value: !0
});
dI.resizeHandleType = dI.resizeHandleAxesType = dI.default = void 0;
var Ai = h8e(Ja), a3t = h8e(St);
function h8e(t) {
  return t && t.__esModule ? t : { default: t };
}
var d8e = Ai.default.arrayOf(Ai.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"]));
dI.resizeHandleAxesType = d8e;
var p8e = Ai.default.oneOfType([Ai.default.node, Ai.default.func]);
dI.resizeHandleType = p8e;
var A3t = {
  //
  // Basic props
  //
  className: Ai.default.string,
  style: Ai.default.object,
  // This can be set explicitly. If it is not set, it will automatically
  // be set to the container width. Note that resizes will *not* cause this to adjust.
  // If you need that behavior, use WidthProvider.
  width: Ai.default.number,
  // If true, the container height swells and contracts to fit contents
  autoSize: Ai.default.bool,
  // # of cols.
  cols: Ai.default.number,
  // A selector that will not be draggable.
  draggableCancel: Ai.default.string,
  // A selector for the draggable handler
  draggableHandle: Ai.default.string,
  // Deprecated
  verticalCompact: function(e) {
    e.verticalCompact;
  },
  // Choose vertical or hotizontal compaction
  compactType: Ai.default.oneOf(["vertical", "horizontal"]),
  // layout is an array of object with the format:
  // {x: Number, y: Number, w: Number, h: Number, i: String}
  layout: function(e) {
    var n = e.layout;
    n !== void 0 && pi.validateLayout(n, "layout");
  },
  //
  // Grid Dimensions
  //
  // Margin between items [x, y] in px
  margin: Ai.default.arrayOf(Ai.default.number),
  // Padding inside the container [x, y] in px
  containerPadding: Ai.default.arrayOf(Ai.default.number),
  // Rows have a static height, but you can change this based on breakpoints if you like
  rowHeight: Ai.default.number,
  // Default Infinity, but you can specify a max here if you like.
  // Note that this isn't fully fleshed out and won't error if you specify a layout that
  // extends beyond the row capacity. It will, however, not allow users to drag/resize
  // an item past the barrier. They can push items beyond the barrier, though.
  // Intentionally not documented for this reason.
  maxRows: Ai.default.number,
  //
  // Flags
  //
  isBounded: Ai.default.bool,
  isDraggable: Ai.default.bool,
  isResizable: Ai.default.bool,
  // If true, grid can be placed one over the other.
  allowOverlap: Ai.default.bool,
  // If true, grid items won't change position when being dragged over.
  preventCollision: Ai.default.bool,
  // Use CSS transforms instead of top/left
  useCSSTransforms: Ai.default.bool,
  // parent layout transform scale
  transformScale: Ai.default.number,
  // If true, an external element can trigger onDrop callback with a specific grid position as a parameter
  isDroppable: Ai.default.bool,
  // Resize handle options
  resizeHandles: d8e,
  resizeHandle: p8e,
  //
  // Callbacks
  //
  // Callback so you can save the layout. Calls after each drag & resize stops.
  onLayoutChange: Ai.default.func,
  // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
  // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
  onDragStart: Ai.default.func,
  // Calls on each drag movement.
  onDrag: Ai.default.func,
  // Calls when drag is complete.
  onDragStop: Ai.default.func,
  //Calls when resize starts.
  onResizeStart: Ai.default.func,
  // Calls when resize movement happens.
  onResize: Ai.default.func,
  // Calls when resize is complete.
  onResizeStop: Ai.default.func,
  // Calls when some element is dropped.
  onDrop: Ai.default.func,
  //
  // Other validations
  //
  droppingItem: Ai.default.shape({
    i: Ai.default.string.isRequired,
    w: Ai.default.number.isRequired,
    h: Ai.default.number.isRequired
  }),
  // Children must not have duplicate keys.
  children: function(e, n) {
    var r = e[n], i = {};
    a3t.default.Children.forEach(r, function(o) {
      if (o?.key != null) {
        if (i[o.key])
          throw new Error('Duplicate child key "' + o.key + '" found! This will cause problems in ReactGridLayout.');
        i[o.key] = !0;
      }
    });
  },
  // Optional ref for getting a reference for the wrapping div.
  innerRef: Ai.default.any
};
dI.default = A3t;
function FZ(t) {
  "@babel/helpers - typeof";
  return FZ = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, FZ(t);
}
Object.defineProperty(a9, "__esModule", {
  value: !0
});
a9.default = void 0;
var X1 = Oae(St), eo = Oae(Ja), l3t = l8e, c3t = s3t, zx = pi, el = zI, Zye = dI, u3t = Oae(jB);
function Oae(t) {
  return t && t.__esModule ? t : { default: t };
}
function eve(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function t7(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? eve(Object(n), !0).forEach(function(r) {
      Rh(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : eve(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function f3t(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function tve(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function g3t(t, e, n) {
  return e && tve(t.prototype, e), n && tve(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function h3t(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && PZ(t, e);
}
function PZ(t, e) {
  return PZ = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, PZ(t, e);
}
function d3t(t) {
  var e = I3t();
  return function() {
    var r = V4(t), i;
    if (e) {
      var o = V4(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return p3t(this, i);
  };
}
function p3t(t, e) {
  if (e && (FZ(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return sg(t);
}
function sg(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function I3t() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function V4(t) {
  return V4 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, V4(t);
}
function Rh(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Fae = /* @__PURE__ */ function(t) {
  h3t(n, t);
  var e = d3t(n);
  function n() {
    var r;
    f3t(this, n);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)), Rh(sg(r), "state", {
      resizing: null,
      dragging: null,
      className: ""
    }), Rh(sg(r), "elementRef", /* @__PURE__ */ X1.default.createRef()), Rh(sg(r), "onDragStart", function(a, A) {
      var l = A.node, c = r.props, u = c.onDragStart, f = c.transformScale;
      if (u) {
        var h = {
          top: 0,
          left: 0
        }, d = l.offsetParent;
        if (d) {
          var I = d.getBoundingClientRect(), m = l.getBoundingClientRect(), C = m.left / f, y = I.left / f, v = m.top / f, b = I.top / f;
          h.left = C - y + d.scrollLeft, h.top = v - b + d.scrollTop, r.setState({
            dragging: h
          });
          var Q = (0, el.calcXY)(r.getPositionParams(), h.top, h.left, r.props.w, r.props.h), w = Q.x, R = Q.y;
          return u.call(sg(r), r.props.i, w, R, {
            e: a,
            node: l,
            newPosition: h
          });
        }
      }
    }), Rh(sg(r), "onDrag", function(a, A) {
      var l = A.node, c = A.deltaX, u = A.deltaY, f = r.props.onDrag;
      if (f) {
        if (!r.state.dragging)
          throw new Error("onDrag called before onDragStart.");
        var h = r.state.dragging.top + u, d = r.state.dragging.left + c, I = r.props, m = I.isBounded, C = I.i, y = I.w, v = I.h, b = I.containerWidth, Q = r.getPositionParams();
        if (m) {
          var w = l.offsetParent;
          if (w) {
            var R = r.props, M = R.margin, O = R.rowHeight, L = w.clientHeight - (0, el.calcGridItemWHPx)(v, O, M[1]);
            h = (0, el.clamp)(h, 0, L);
            var N = (0, el.calcGridColWidth)(Q), k = b - (0, el.calcGridItemWHPx)(y, N, M[0]);
            d = (0, el.clamp)(d, 0, k);
          }
        }
        var $ = {
          top: h,
          left: d
        };
        r.setState({
          dragging: $
        });
        var U = (0, el.calcXY)(Q, h, d, y, v), X = U.x, K = U.y;
        return f.call(sg(r), C, X, K, {
          e: a,
          node: l,
          newPosition: $
        });
      }
    }), Rh(sg(r), "onDragStop", function(a, A) {
      var l = A.node, c = r.props.onDragStop;
      if (c) {
        if (!r.state.dragging)
          throw new Error("onDragEnd called before onDragStart.");
        var u = r.props, f = u.w, h = u.h, d = u.i, I = r.state.dragging, m = I.left, C = I.top, y = {
          top: C,
          left: m
        };
        r.setState({
          dragging: null
        });
        var v = (0, el.calcXY)(r.getPositionParams(), C, m, f, h), b = v.x, Q = v.y;
        return c.call(sg(r), d, b, Q, {
          e: a,
          node: l,
          newPosition: y
        });
      }
    }), Rh(sg(r), "onResizeStop", function(a, A) {
      r.onResizeHandler(a, A, "onResizeStop");
    }), Rh(sg(r), "onResizeStart", function(a, A) {
      r.onResizeHandler(a, A, "onResizeStart");
    }), Rh(sg(r), "onResize", function(a, A) {
      r.onResizeHandler(a, A, "onResize");
    }), r;
  }
  return g3t(n, [{
    key: "shouldComponentUpdate",
    value: function(i, o) {
      if (this.props.children !== i.children || this.props.droppingPosition !== i.droppingPosition)
        return !0;
      var s = (0, el.calcGridItemPosition)(this.getPositionParams(this.props), this.props.x, this.props.y, this.props.w, this.props.h, this.state), a = (0, el.calcGridItemPosition)(this.getPositionParams(i), i.x, i.y, i.w, i.h, o);
      return !(0, zx.fastPositionEqual)(s, a) || this.props.useCSSTransforms !== i.useCSSTransforms;
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.moveDroppingItem({});
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      this.moveDroppingItem(i);
    }
    // When a droppingPosition is present, this means we should fire a move event, as if we had moved
    // this element by `x, y` pixels.
  }, {
    key: "moveDroppingItem",
    value: function(i) {
      var o = this.props.droppingPosition;
      if (o) {
        var s = this.elementRef.current;
        if (s) {
          var a = i.droppingPosition || {
            left: 0,
            top: 0
          }, A = this.state.dragging, l = A && o.left !== a.left || o.top !== a.top;
          if (!A)
            this.onDragStart(o.e, {
              node: s,
              deltaX: o.left,
              deltaY: o.top
            });
          else if (l) {
            var c = o.left - A.left, u = o.top - A.top;
            this.onDrag(o.e, {
              node: s,
              deltaX: c,
              deltaY: u
            });
          }
        }
      }
    }
  }, {
    key: "getPositionParams",
    value: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
      return {
        cols: i.cols,
        containerPadding: i.containerPadding,
        containerWidth: i.containerWidth,
        margin: i.margin,
        maxRows: i.maxRows,
        rowHeight: i.rowHeight
      };
    }
    /**
     * This is where we set the grid item's absolute placement. It gets a little tricky because we want to do it
     * well when server rendering, and the only way to do that properly is to use percentage width/left because
     * we don't know exactly what the browser viewport is.
     * Unfortunately, CSS Transforms, which are great for performance, break in this instance because a percentage
     * left is relative to the item itself, not its container! So we cannot use them on the server rendering pass.
     *
     * @param  {Object} pos Position object with width, height, left, top.
     * @return {Object}     Style object.
     */
  }, {
    key: "createStyle",
    value: function(i) {
      var o = this.props, s = o.usePercentages, a = o.containerWidth, A = o.useCSSTransforms, l;
      return A ? l = (0, zx.setTransform)(i) : (l = (0, zx.setTopLeft)(i), s && (l.left = (0, zx.perc)(i.left / a), l.width = (0, zx.perc)(i.width / a))), l;
    }
    /**
     * Mix a Draggable instance into a child.
     * @param  {Element} child    Child element.
     * @return {Element}          Child wrapped in Draggable.
     */
  }, {
    key: "mixinDraggable",
    value: function(i, o) {
      return /* @__PURE__ */ X1.default.createElement(l3t.DraggableCore, {
        disabled: !o,
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop,
        handle: this.props.handle,
        cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : ""),
        scale: this.props.transformScale,
        nodeRef: this.elementRef
      }, i);
    }
    /**
     * Mix a Resizable instance into a child.
     * @param  {Element} child    Child element.
     * @param  {Object} position  Position object (pixel values)
     * @return {Element}          Child wrapped in Resizable.
     */
  }, {
    key: "mixinResizable",
    value: function(i, o, s) {
      var a = this.props, A = a.cols, l = a.x, c = a.minW, u = a.minH, f = a.maxW, h = a.maxH, d = a.transformScale, I = a.resizeHandles, m = a.resizeHandle, C = this.getPositionParams(), y = (0, el.calcGridItemPosition)(C, 0, 0, A - l, 0).width, v = (0, el.calcGridItemPosition)(C, 0, 0, c, u), b = (0, el.calcGridItemPosition)(C, 0, 0, f, h), Q = [v.width, v.height], w = [Math.min(b.width, y), Math.min(b.height, 1 / 0)];
      return /* @__PURE__ */ X1.default.createElement(
        c3t.Resizable,
        {
          draggableOpts: {
            disabled: !s
          },
          className: s ? void 0 : "react-resizable-hide",
          width: o.width,
          height: o.height,
          minConstraints: Q,
          maxConstraints: w,
          onResizeStop: this.onResizeStop,
          onResizeStart: this.onResizeStart,
          onResize: this.onResize,
          transformScale: d,
          resizeHandles: I,
          handle: m
        },
        i
      );
    }
    /**
     * onDragStart event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */
  }, {
    key: "onResizeHandler",
    value: (
      /**
       * Wrapper around drag events to provide more useful data.
       * All drag events call the function with the given handler name,
       * with the signature (index, x, y).
       *
       * @param  {String} handlerName Handler name to wrap.
       * @return {Function}           Handler function.
       */
      function(i, o, s) {
        var a = o.node, A = o.size, l = this.props[s];
        if (l) {
          var c = this.props, u = c.cols, f = c.x, h = c.y, d = c.i, I = c.maxH, m = c.minH, C = this.props, y = C.minW, v = C.maxW, b = (0, el.calcWH)(this.getPositionParams(), A.width, A.height, f, h), Q = b.w, w = b.h;
          y = Math.max(y, 1), v = Math.min(v, u - f), Q = (0, el.clamp)(Q, y, v), w = (0, el.clamp)(w, m, I), this.setState({
            resizing: s === "onResizeStop" ? null : A
          }), l.call(this, d, Q, w, {
            e: i,
            node: a,
            size: A
          });
        }
      }
    )
  }, {
    key: "render",
    value: function() {
      var i = this.props, o = i.x, s = i.y, a = i.w, A = i.h, l = i.isDraggable, c = i.isResizable, u = i.droppingPosition, f = i.useCSSTransforms, h = (0, el.calcGridItemPosition)(this.getPositionParams(), o, s, a, A, this.state), d = X1.default.Children.only(this.props.children), I = /* @__PURE__ */ X1.default.cloneElement(d, {
        ref: this.elementRef,
        className: (0, u3t.default)("react-grid-item", d.props.className, this.props.className, {
          static: this.props.static,
          resizing: !!this.state.resizing,
          "react-draggable": l,
          "react-draggable-dragging": !!this.state.dragging,
          dropping: !!u,
          cssTransforms: f
        }),
        // We can set the width and height on the child, but unfortunately we can't set the position.
        style: t7(t7(t7({}, this.props.style), d.props.style), this.createStyle(h))
      });
      return I = this.mixinResizable(I, h, c), I = this.mixinDraggable(I, l), I;
    }
  }]), n;
}(X1.default.Component);
a9.default = Fae;
Rh(Fae, "propTypes", {
  // Children must be only a single element
  children: eo.default.element,
  // General grid attributes
  cols: eo.default.number.isRequired,
  containerWidth: eo.default.number.isRequired,
  rowHeight: eo.default.number.isRequired,
  margin: eo.default.array.isRequired,
  maxRows: eo.default.number.isRequired,
  containerPadding: eo.default.array.isRequired,
  // These are all in grid units
  x: eo.default.number.isRequired,
  y: eo.default.number.isRequired,
  w: eo.default.number.isRequired,
  h: eo.default.number.isRequired,
  // All optional
  minW: function(e, n) {
    var r = e[n];
    if (typeof r != "number")
      return new Error("minWidth not Number");
    if (r > e.w || r > e.maxW)
      return new Error("minWidth larger than item width/maxWidth");
  },
  maxW: function(e, n) {
    var r = e[n];
    if (typeof r != "number")
      return new Error("maxWidth not Number");
    if (r < e.w || r < e.minW)
      return new Error("maxWidth smaller than item width/minWidth");
  },
  minH: function(e, n) {
    var r = e[n];
    if (typeof r != "number")
      return new Error("minHeight not Number");
    if (r > e.h || r > e.maxH)
      return new Error("minHeight larger than item height/maxHeight");
  },
  maxH: function(e, n) {
    var r = e[n];
    if (typeof r != "number")
      return new Error("maxHeight not Number");
    if (r < e.h || r < e.minH)
      return new Error("maxHeight smaller than item height/minHeight");
  },
  // ID is nice to have for callbacks
  i: eo.default.string.isRequired,
  // Resize handle options
  resizeHandles: Zye.resizeHandleAxesType,
  resizeHandle: Zye.resizeHandleType,
  // Functions
  onDragStop: eo.default.func,
  onDragStart: eo.default.func,
  onDrag: eo.default.func,
  onResizeStop: eo.default.func,
  onResizeStart: eo.default.func,
  onResize: eo.default.func,
  // Flags
  isDraggable: eo.default.bool.isRequired,
  isResizable: eo.default.bool.isRequired,
  isBounded: eo.default.bool.isRequired,
  static: eo.default.bool,
  // Use CSS transforms instead of top/left
  useCSSTransforms: eo.default.bool.isRequired,
  transformScale: eo.default.number,
  // Others
  className: eo.default.string,
  // Selector for draggable handle
  handle: eo.default.string,
  // Selector for draggable cancel (see react-draggable)
  cancel: eo.default.string,
  // Current position of a dropping element
  droppingPosition: eo.default.shape({
    e: eo.default.object.isRequired,
    left: eo.default.number.isRequired,
    top: eo.default.number.isRequired
  })
});
Rh(Fae, "defaultProps", {
  className: "",
  cancel: "",
  handle: "",
  minH: 1,
  minW: 1,
  maxH: 1 / 0,
  maxW: 1 / 0,
  transformScale: 1
});
function J4(t) {
  "@babel/helpers - typeof";
  return J4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, J4(t);
}
Object.defineProperty(BL, "__esModule", {
  value: !0
});
BL.default = void 0;
var ly = y3t(St), n7 = h9(i9), m3t = h9(jB), qr = pi, C3t = zI, nve = h9(a9), E3t = h9(dI);
function h9(t) {
  return t && t.__esModule ? t : { default: t };
}
function I8e(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (I8e = function(i) {
    return i ? n : e;
  })(t);
}
function y3t(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || J4(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = I8e(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in t)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(t, o)) {
      var s = i ? Object.getOwnPropertyDescriptor(t, o) : null;
      s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = t[o];
    }
  return r.default = t, n && n.set(t, r), r;
}
function v3t(t) {
  return _3t(t) || b3t(t) || m8e(t) || B3t();
}
function B3t() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function b3t(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function _3t(t) {
  if (Array.isArray(t))
    return kZ(t);
}
function rve(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function cy(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? rve(Object(n), !0).forEach(function(r) {
      rl(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : rve(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function S3t(t, e) {
  return x3t(t) || w3t(t, e) || m8e(t, e) || Q3t();
}
function Q3t() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function m8e(t, e) {
  if (t) {
    if (typeof t == "string")
      return kZ(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return kZ(t, e);
  }
}
function kZ(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function w3t(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, s, a;
    try {
      for (n = n.call(t); !(i = (s = n.next()).done) && (r.push(s.value), !(e && r.length === e)); i = !0)
        ;
    } catch (A) {
      o = !0, a = A;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o)
          throw a;
      }
    }
    return r;
  }
}
function x3t(t) {
  if (Array.isArray(t))
    return t;
}
function R3t(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ive(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function D3t(t, e, n) {
  return e && ive(t.prototype, e), n && ive(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function T3t(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && GZ(t, e);
}
function GZ(t, e) {
  return GZ = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, GZ(t, e);
}
function N3t(t) {
  var e = M3t();
  return function() {
    var r = K4(t), i;
    if (e) {
      var o = K4(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return L3t(this, i);
  };
}
function L3t(t, e) {
  if (e && (J4(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return hu(t);
}
function hu(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function M3t() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function K4(t) {
  return K4 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, K4(t);
}
function rl(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var ove = "react-grid-layout", C8e = !1;
try {
  C8e = /firefox/i.test(navigator.userAgent);
} catch {
}
var d9 = /* @__PURE__ */ function(t) {
  T3t(n, t);
  var e = N3t(n);
  function n() {
    var r;
    R3t(this, n);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)), rl(hu(r), "state", {
      activeDrag: null,
      layout: (0, qr.synchronizeLayoutWithChildren)(
        r.props.layout,
        r.props.children,
        r.props.cols,
        // Legacy support for verticalCompact: false
        (0, qr.compactType)(r.props),
        r.props.allowOverlap
      ),
      mounted: !1,
      oldDragItem: null,
      oldLayout: null,
      oldResizeItem: null,
      droppingDOMNode: null,
      children: []
    }), rl(hu(r), "dragEnterCounter", 0), rl(hu(r), "onDragStart", function(a, A, l, c) {
      var u = c.e, f = c.node, h = r.state.layout, d = (0, qr.getLayoutItem)(h, a);
      if (d)
        return r.setState({
          oldDragItem: (0, qr.cloneLayoutItem)(d),
          oldLayout: h
        }), r.props.onDragStart(h, d, d, null, u, f);
    }), rl(hu(r), "onDrag", function(a, A, l, c) {
      var u = c.e, f = c.node, h = r.state.oldDragItem, d = r.state.layout, I = r.props, m = I.cols, C = I.allowOverlap, y = I.preventCollision, v = (0, qr.getLayoutItem)(d, a);
      if (v) {
        var b = {
          w: v.w,
          h: v.h,
          x: v.x,
          y: v.y,
          placeholder: !0,
          i: a
        }, Q = !0;
        d = (0, qr.moveElement)(d, v, A, l, Q, y, (0, qr.compactType)(r.props), m, C), r.props.onDrag(d, h, v, b, u, f), r.setState({
          layout: C ? d : (0, qr.compact)(d, (0, qr.compactType)(r.props), m),
          activeDrag: b
        });
      }
    }), rl(hu(r), "onDragStop", function(a, A, l, c) {
      var u = c.e, f = c.node;
      if (r.state.activeDrag) {
        var h = r.state.oldDragItem, d = r.state.layout, I = r.props, m = I.cols, C = I.preventCollision, y = I.allowOverlap, v = (0, qr.getLayoutItem)(d, a);
        if (v) {
          var b = !0;
          d = (0, qr.moveElement)(d, v, A, l, b, C, (0, qr.compactType)(r.props), m, y), r.props.onDragStop(d, h, v, null, u, f);
          var Q = y ? d : (0, qr.compact)(d, (0, qr.compactType)(r.props), m), w = r.state.oldLayout;
          r.setState({
            activeDrag: null,
            layout: Q,
            oldDragItem: null,
            oldLayout: null
          }), r.onLayoutMaybeChanged(Q, w);
        }
      }
    }), rl(hu(r), "onResizeStart", function(a, A, l, c) {
      var u = c.e, f = c.node, h = r.state.layout, d = (0, qr.getLayoutItem)(h, a);
      d && (r.setState({
        oldResizeItem: (0, qr.cloneLayoutItem)(d),
        oldLayout: r.state.layout
      }), r.props.onResizeStart(h, d, d, null, u, f));
    }), rl(hu(r), "onResize", function(a, A, l, c) {
      var u = c.e, f = c.node, h = r.state, d = h.layout, I = h.oldResizeItem, m = r.props, C = m.cols, y = m.preventCollision, v = m.allowOverlap, b = (0, qr.withLayoutItem)(d, a, function(O) {
        var L;
        if (y && !v) {
          var N = (0, qr.getAllCollisions)(d, cy(cy({}, O), {}, {
            w: A,
            h: l
          })).filter(function(U) {
            return U.i !== O.i;
          });
          if (L = N.length > 0, L) {
            var k = 1 / 0, $ = 1 / 0;
            N.forEach(function(U) {
              U.x > O.x && (k = Math.min(k, U.x)), U.y > O.y && ($ = Math.min($, U.y));
            }), Number.isFinite(k) && (O.w = k - O.x), Number.isFinite($) && (O.h = $ - O.y);
          }
        }
        return L || (O.w = A, O.h = l), O;
      }), Q = S3t(b, 2), w = Q[0], R = Q[1];
      if (R) {
        var M = {
          w: R.w,
          h: R.h,
          x: R.x,
          y: R.y,
          static: !0,
          i: a
        };
        r.props.onResize(w, I, R, M, u, f), r.setState({
          layout: v ? w : (0, qr.compact)(w, (0, qr.compactType)(r.props), C),
          activeDrag: M
        });
      }
    }), rl(hu(r), "onResizeStop", function(a, A, l, c) {
      var u = c.e, f = c.node, h = r.state, d = h.layout, I = h.oldResizeItem, m = r.props, C = m.cols, y = m.allowOverlap, v = (0, qr.getLayoutItem)(d, a);
      r.props.onResizeStop(d, I, v, null, u, f);
      var b = y ? d : (0, qr.compact)(d, (0, qr.compactType)(r.props), C), Q = r.state.oldLayout;
      r.setState({
        activeDrag: null,
        layout: b,
        oldResizeItem: null,
        oldLayout: null
      }), r.onLayoutMaybeChanged(b, Q);
    }), rl(hu(r), "onDragOver", function(a) {
      var A;
      if (a.preventDefault(), a.stopPropagation(), C8e && // $FlowIgnore can't figure this out
      !((A = a.nativeEvent.target) !== null && A !== void 0 && A.classList.contains(ove)))
        return !1;
      var l = r.props, c = l.droppingItem, u = l.onDropDragOver, f = l.margin, h = l.cols, d = l.rowHeight, I = l.maxRows, m = l.width, C = l.containerPadding, y = l.transformScale, v = u?.(a);
      if (v === !1)
        return r.state.droppingDOMNode && r.removeDroppingPlaceholder(), !1;
      var b = cy(cy({}, c), v), Q = r.state.layout, w = a.nativeEvent, R = w.layerX, M = w.layerY, O = {
        left: R / y,
        top: M / y,
        e: a
      };
      if (r.state.droppingDOMNode) {
        if (r.state.droppingPosition) {
          var k = r.state.droppingPosition, $ = k.left, U = k.top, X = $ != R || U != M;
          X && r.setState({
            droppingPosition: O
          });
        }
      } else {
        var L = {
          cols: h,
          margin: f,
          maxRows: I,
          rowHeight: d,
          containerWidth: m,
          containerPadding: C || f
        }, N = (0, C3t.calcXY)(L, M, R, b.w, b.h);
        r.setState({
          droppingDOMNode: /* @__PURE__ */ ly.createElement("div", {
            key: b.i
          }),
          droppingPosition: O,
          layout: [].concat(v3t(Q), [cy(cy({}, b), {}, {
            x: N.x,
            y: N.y,
            static: !1,
            isDraggable: !0
          })])
        });
      }
    }), rl(hu(r), "removeDroppingPlaceholder", function() {
      var a = r.props, A = a.droppingItem, l = a.cols, c = r.state.layout, u = (0, qr.compact)(c.filter(function(f) {
        return f.i !== A.i;
      }), (0, qr.compactType)(r.props), l);
      r.setState({
        layout: u,
        droppingDOMNode: null,
        activeDrag: null,
        droppingPosition: void 0
      });
    }), rl(hu(r), "onDragLeave", function(a) {
      a.preventDefault(), a.stopPropagation(), r.dragEnterCounter--, r.dragEnterCounter === 0 && r.removeDroppingPlaceholder();
    }), rl(hu(r), "onDragEnter", function(a) {
      a.preventDefault(), a.stopPropagation(), r.dragEnterCounter++;
    }), rl(hu(r), "onDrop", function(a) {
      a.preventDefault(), a.stopPropagation();
      var A = r.props.droppingItem, l = r.state.layout, c = l.find(function(u) {
        return u.i === A.i;
      });
      r.dragEnterCounter = 0, r.removeDroppingPlaceholder(), r.props.onDrop(l, c, a);
    }), r;
  }
  return D3t(n, [{
    key: "componentDidMount",
    value: function() {
      this.setState({
        mounted: !0
      }), this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function(i, o) {
      return (
        // NOTE: this is almost always unequal. Therefore the only way to get better performance
        // from SCU is if the user intentionally memoizes children. If they do, and they can
        // handle changes properly, performance will increase.
        this.props.children !== i.children || !(0, qr.fastRGLPropsEqual)(this.props, i, n7.default) || this.state.activeDrag !== o.activeDrag || this.state.mounted !== o.mounted || this.state.droppingPosition !== o.droppingPosition
      );
    }
  }, {
    key: "componentDidUpdate",
    value: function(i, o) {
      if (!this.state.activeDrag) {
        var s = this.state.layout, a = o.layout;
        this.onLayoutMaybeChanged(s, a);
      }
    }
    /**
     * Calculates a pixel value for the container.
     * @return {String} Container height in pixels.
     */
  }, {
    key: "containerHeight",
    value: function() {
      if (this.props.autoSize) {
        var i = (0, qr.bottom)(this.state.layout), o = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
        return i * this.props.rowHeight + (i - 1) * this.props.margin[1] + o * 2 + "px";
      }
    }
    /**
     * When dragging starts
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */
  }, {
    key: "onLayoutMaybeChanged",
    value: function(i, o) {
      o || (o = this.state.layout), (0, n7.default)(o, i) || this.props.onLayoutChange(i);
    }
  }, {
    key: "placeholder",
    value: (
      /**
       * Create a placeholder object.
       * @return {Element} Placeholder div.
       */
      function() {
        var i = this.state.activeDrag;
        if (!i)
          return null;
        var o = this.props, s = o.width, a = o.cols, A = o.margin, l = o.containerPadding, c = o.rowHeight, u = o.maxRows, f = o.useCSSTransforms, h = o.transformScale;
        return /* @__PURE__ */ ly.createElement(nve.default, {
          w: i.w,
          h: i.h,
          x: i.x,
          y: i.y,
          i: i.i,
          className: "react-grid-placeholder",
          containerWidth: s,
          cols: a,
          margin: A,
          containerPadding: l || A,
          maxRows: u,
          rowHeight: c,
          isDraggable: !1,
          isResizable: !1,
          isBounded: !1,
          useCSSTransforms: f,
          transformScale: h
        }, /* @__PURE__ */ ly.createElement("div", null));
      }
    )
    /**
     * Given a grid item, set its style attributes & surround in a <Draggable>.
     * @param  {Element} child React element.
     * @return {Element}       Element wrapped in draggable and properly placed.
     */
  }, {
    key: "processGridItem",
    value: function(i, o) {
      if (!(!i || !i.key)) {
        var s = (0, qr.getLayoutItem)(this.state.layout, String(i.key));
        if (!s)
          return null;
        var a = this.props, A = a.width, l = a.cols, c = a.margin, u = a.containerPadding, f = a.rowHeight, h = a.maxRows, d = a.isDraggable, I = a.isResizable, m = a.isBounded, C = a.useCSSTransforms, y = a.transformScale, v = a.draggableCancel, b = a.draggableHandle, Q = a.resizeHandles, w = a.resizeHandle, R = this.state, M = R.mounted, O = R.droppingPosition, L = typeof s.isDraggable == "boolean" ? s.isDraggable : !s.static && d, N = typeof s.isResizable == "boolean" ? s.isResizable : !s.static && I, k = s.resizeHandles || Q, $ = L && m && s.isBounded !== !1;
        return /* @__PURE__ */ ly.createElement(nve.default, {
          containerWidth: A,
          cols: l,
          margin: c,
          containerPadding: u || c,
          maxRows: h,
          rowHeight: f,
          cancel: v,
          handle: b,
          onDragStop: this.onDragStop,
          onDragStart: this.onDragStart,
          onDrag: this.onDrag,
          onResizeStart: this.onResizeStart,
          onResize: this.onResize,
          onResizeStop: this.onResizeStop,
          isDraggable: L,
          isResizable: N,
          isBounded: $,
          useCSSTransforms: C && M,
          usePercentages: !M,
          transformScale: y,
          w: s.w,
          h: s.h,
          x: s.x,
          y: s.y,
          i: s.i,
          minH: s.minH,
          minW: s.minW,
          maxH: s.maxH,
          maxW: s.maxW,
          static: s.static,
          droppingPosition: o ? O : void 0,
          resizeHandles: k,
          resizeHandle: w
        }, i);
      }
    }
    // Called while dragging an element. Part of browser native drag/drop API.
    // Native event target might be the layout itself, or an element within the layout.
  }, {
    key: "render",
    value: function() {
      var i = this, o = this.props, s = o.className, a = o.style, A = o.isDroppable, l = o.innerRef, c = (0, m3t.default)(ove, s), u = cy({
        height: this.containerHeight()
      }, a);
      return /* @__PURE__ */ ly.createElement("div", {
        ref: l,
        className: c,
        style: u,
        onDrop: A ? this.onDrop : qr.noop,
        onDragLeave: A ? this.onDragLeave : qr.noop,
        onDragEnter: A ? this.onDragEnter : qr.noop,
        onDragOver: A ? this.onDragOver : qr.noop
      }, ly.Children.map(this.props.children, function(f) {
        return i.processGridItem(f);
      }), A && this.state.droppingDOMNode && this.processGridItem(this.state.droppingDOMNode, !0), this.placeholder());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, o) {
      var s;
      if (o.activeDrag)
        return null;
      if (!(0, n7.default)(i.layout, o.propsLayout) || i.compactType !== o.compactType ? s = i.layout : (0, qr.childrenEqual)(i.children, o.children) || (s = o.layout), s) {
        var a = (0, qr.synchronizeLayoutWithChildren)(s, i.children, i.cols, (0, qr.compactType)(i), i.allowOverlap);
        return {
          layout: a,
          // We need to save these props to state for using
          // getDerivedStateFromProps instead of componentDidMount (in which we would get extra rerender)
          compactType: i.compactType,
          children: i.children,
          propsLayout: i.layout
        };
      }
      return null;
    }
  }]), n;
}(ly.Component);
BL.default = d9;
rl(d9, "displayName", "ReactGridLayout");
rl(d9, "propTypes", E3t.default);
rl(d9, "defaultProps", {
  autoSize: !0,
  cols: 12,
  className: "",
  style: {},
  draggableHandle: "",
  draggableCancel: "",
  containerPadding: null,
  rowHeight: 150,
  maxRows: 1 / 0,
  // infinite vertical growth
  layout: [],
  margin: [10, 10],
  isBounded: !1,
  isDraggable: !0,
  isResizable: !0,
  allowOverlap: !1,
  isDroppable: !1,
  useCSSTransforms: !0,
  transformScale: 1,
  verticalCompact: !0,
  compactType: "vertical",
  preventCollision: !1,
  droppingItem: {
    i: "__dropping-elem__",
    h: 1,
    w: 1
  },
  resizeHandles: ["se"],
  onLayoutChange: qr.noop,
  onDragStart: qr.noop,
  onDrag: qr.noop,
  onDragStop: qr.noop,
  onResizeStart: qr.noop,
  onResize: qr.noop,
  onResizeStop: qr.noop,
  onDrop: qr.noop,
  onDropDragOver: qr.noop
});
var p9 = {}, zB = {};
Object.defineProperty(zB, "__esModule", {
  value: !0
});
zB.findOrGenerateResponsiveLayout = P3t;
zB.getBreakpointFromWidth = O3t;
zB.getColsFromBreakpoint = F3t;
zB.sortBreakpoints = Pae;
var pF = pi;
function O3t(t, e) {
  for (var n = Pae(t), r = n[0], i = 1, o = n.length; i < o; i++) {
    var s = n[i];
    e > t[s] && (r = s);
  }
  return r;
}
function F3t(t, e) {
  if (!e[t])
    throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + t + " is missing!");
  return e[t];
}
function P3t(t, e, n, r, i, o) {
  if (t[n])
    return (0, pF.cloneLayout)(t[n]);
  for (var s = t[r], a = Pae(e), A = a.slice(a.indexOf(n)), l = 0, c = A.length; l < c; l++) {
    var u = A[l];
    if (t[u]) {
      s = t[u];
      break;
    }
  }
  return s = (0, pF.cloneLayout)(s || []), (0, pF.compact)((0, pF.correctBounds)(s, {
    cols: i
  }), o, i);
}
function Pae(t) {
  var e = Object.keys(t);
  return e.sort(function(n, r) {
    return t[n] - t[r];
  });
}
function W4(t) {
  "@babel/helpers - typeof";
  return W4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, W4(t);
}
Object.defineProperty(p9, "__esModule", {
  value: !0
});
p9.default = void 0;
var sve = U3t(St), lu = kae(Ja), r7 = kae(i9), F_ = pi, uy = zB, k3t = kae(BL), G3t = ["breakpoint", "breakpoints", "cols", "layouts", "margin", "containerPadding", "onBreakpointChange", "onLayoutChange", "onWidthChange"];
function kae(t) {
  return t && t.__esModule ? t : { default: t };
}
function E8e(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (E8e = function(i) {
    return i ? n : e;
  })(t);
}
function U3t(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || W4(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = E8e(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in t)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(t, o)) {
      var s = i ? Object.getOwnPropertyDescriptor(t, o) : null;
      s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = t[o];
    }
  return r.default = t, n && n.set(t, r), r;
}
function UZ() {
  return UZ = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, UZ.apply(this, arguments);
}
function H3t(t, e) {
  if (t == null)
    return {};
  var n = $3t(t, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (i = 0; i < o.length; i++)
      r = o[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function $3t(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
function ave(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function i7(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ave(Object(n), !0).forEach(function(r) {
      P_(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ave(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function q3t(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ave(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function j3t(t, e, n) {
  return e && Ave(t.prototype, e), n && Ave(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Y3t(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && HZ(t, e);
}
function HZ(t, e) {
  return HZ = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, HZ(t, e);
}
function z3t(t) {
  var e = J3t();
  return function() {
    var r = X4(t), i;
    if (e) {
      var o = X4(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return V3t(this, i);
  };
}
function V3t(t, e) {
  if (e && (W4(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return $Z(t);
}
function $Z(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function J3t() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function X4(t) {
  return X4 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, X4(t);
}
function P_(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var lve = function(e) {
  return Object.prototype.toString.call(e);
};
function IF(t, e) {
  return t == null ? null : Array.isArray(t) ? t : t[e];
}
var Gae = /* @__PURE__ */ function(t) {
  Y3t(n, t);
  var e = z3t(n);
  function n() {
    var r;
    q3t(this, n);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)), P_($Z(r), "state", r.generateInitialState()), P_($Z(r), "onLayoutChange", function(a) {
      r.props.onLayoutChange(a, i7(i7({}, r.props.layouts), {}, P_({}, r.state.breakpoint, a)));
    }), r;
  }
  return j3t(n, [{
    key: "generateInitialState",
    value: function() {
      var i = this.props, o = i.width, s = i.breakpoints, a = i.layouts, A = i.cols, l = (0, uy.getBreakpointFromWidth)(s, o), c = (0, uy.getColsFromBreakpoint)(l, A), u = this.props.verticalCompact === !1 ? null : this.props.compactType, f = (0, uy.findOrGenerateResponsiveLayout)(a, s, l, l, c, u);
      return {
        layout: f,
        breakpoint: l,
        cols: c
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      (this.props.width != i.width || this.props.breakpoint !== i.breakpoint || !(0, r7.default)(this.props.breakpoints, i.breakpoints) || !(0, r7.default)(this.props.cols, i.cols)) && this.onWidthChange(i);
    }
    // wrap layouts so we do not need to pass layouts to child
  }, {
    key: "onWidthChange",
    value: (
      /**
       * When the width changes work through breakpoints and reset state with the new width & breakpoint.
       * Width changes are necessary to figure out the widget widths.
       */
      function(i) {
        var o = this.props, s = o.breakpoints, a = o.cols, A = o.layouts, l = o.compactType, c = this.props.breakpoint || (0, uy.getBreakpointFromWidth)(this.props.breakpoints, this.props.width), u = this.state.breakpoint, f = (0, uy.getColsFromBreakpoint)(c, a), h = i7({}, A);
        if (u !== c || i.breakpoints !== s || i.cols !== a) {
          u in h || (h[u] = (0, F_.cloneLayout)(this.state.layout));
          var d = (0, uy.findOrGenerateResponsiveLayout)(h, s, c, u, f, l);
          d = (0, F_.synchronizeLayoutWithChildren)(d, this.props.children, f, l, this.props.allowOverlap), h[c] = d, this.props.onLayoutChange(d, h), this.props.onBreakpointChange(c, f), this.setState({
            breakpoint: c,
            layout: d,
            cols: f
          });
        }
        var I = IF(this.props.margin, c), m = IF(this.props.containerPadding, c);
        this.props.onWidthChange(this.props.width, I, f, m);
      }
    )
  }, {
    key: "render",
    value: function() {
      var i = this.props;
      i.breakpoint, i.breakpoints, i.cols, i.layouts;
      var o = i.margin, s = i.containerPadding;
      i.onBreakpointChange, i.onLayoutChange, i.onWidthChange;
      var a = H3t(i, G3t);
      return /* @__PURE__ */ sve.createElement(k3t.default, UZ({}, a, {
        // $FlowIgnore should allow nullable here due to DefaultProps
        margin: IF(o, this.state.breakpoint),
        containerPadding: IF(s, this.state.breakpoint),
        onLayoutChange: this.onLayoutChange,
        layout: this.state.layout,
        cols: this.state.cols
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, o) {
      if (!(0, r7.default)(i.layouts, o.layouts)) {
        var s = o.breakpoint, a = o.cols, A = (0, uy.findOrGenerateResponsiveLayout)(i.layouts, i.breakpoints, s, s, a, i.compactType);
        return {
          layout: A,
          layouts: i.layouts
        };
      }
      return null;
    }
  }]), n;
}(sve.Component);
p9.default = Gae;
P_(Gae, "propTypes", {
  //
  // Basic props
  //
  // Optional, but if you are managing width yourself you may want to set the breakpoint
  // yourself as well.
  breakpoint: lu.default.string,
  // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
  breakpoints: lu.default.object,
  allowOverlap: lu.default.bool,
  // # of cols. This is a breakpoint -> cols map
  cols: lu.default.object,
  // # of margin. This is a breakpoint -> margin map
  // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
  // Margin between items [x, y] in px
  // e.g. [10, 10]
  margin: lu.default.oneOfType([lu.default.array, lu.default.object]),
  // # of containerPadding. This is a breakpoint -> containerPadding map
  // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
  // Padding inside the container [x, y] in px
  // e.g. [10, 10]
  containerPadding: lu.default.oneOfType([lu.default.array, lu.default.object]),
  // layouts is an object mapping breakpoints to layouts.
  // e.g. {lg: Layout, md: Layout, ...}
  layouts: function(e, n) {
    if (lve(e[n]) !== "[object Object]")
      throw new Error("Layout property must be an object. Received: " + lve(e[n]));
    Object.keys(e[n]).forEach(function(r) {
      if (!(r in e.breakpoints))
        throw new Error("Each key in layouts must align with a key in breakpoints.");
      (0, F_.validateLayout)(e.layouts[r], "layouts." + r);
    });
  },
  // The width of this component.
  // Required in this propTypes stanza because generateInitialState() will fail without it.
  width: lu.default.number.isRequired,
  //
  // Callbacks
  //
  // Calls back with breakpoint and new # cols
  onBreakpointChange: lu.default.func,
  // Callback so you can save the layout.
  // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
  onLayoutChange: lu.default.func,
  // Calls back with (containerWidth, margin, cols, containerPadding)
  onWidthChange: lu.default.func
});
P_(Gae, "defaultProps", {
  breakpoints: {
    lg: 1200,
    md: 996,
    sm: 768,
    xs: 480,
    xxs: 0
  },
  cols: {
    lg: 12,
    md: 10,
    sm: 6,
    xs: 4,
    xxs: 2
  },
  containerPadding: {
    lg: null,
    md: null,
    sm: null,
    xs: null,
    xxs: null
  },
  layouts: {},
  margin: [10, 10],
  allowOverlap: !1,
  onBreakpointChange: F_.noop,
  onLayoutChange: F_.noop,
  onWidthChange: F_.noop
});
var Uae = {};
function Z4(t) {
  "@babel/helpers - typeof";
  return Z4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Z4(t);
}
Object.defineProperty(Uae, "__esModule", {
  value: !0
});
Uae.default = lkt;
var mF = Z3t(St), K3t = y8e(Ja), W3t = y8e(jB), X3t = ["measureBeforeMount"];
function y8e(t) {
  return t && t.__esModule ? t : { default: t };
}
function v8e(t) {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (v8e = function(i) {
    return i ? n : e;
  })(t);
}
function Z3t(t, e) {
  if (!e && t && t.__esModule)
    return t;
  if (t === null || Z4(t) !== "object" && typeof t != "function")
    return { default: t };
  var n = v8e(e);
  if (n && n.has(t))
    return n.get(t);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in t)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(t, o)) {
      var s = i ? Object.getOwnPropertyDescriptor(t, o) : null;
      s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = t[o];
    }
  return r.default = t, n && n.set(t, r), r;
}
function qZ() {
  return qZ = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, qZ.apply(this, arguments);
}
function ekt(t, e) {
  if (t == null)
    return {};
  var n = tkt(t, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (i = 0; i < o.length; i++)
      r = o[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function tkt(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
function nkt(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function cve(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function rkt(t, e, n) {
  return e && cve(t.prototype, e), n && cve(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function ikt(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && jZ(t, e);
}
function jZ(t, e) {
  return jZ = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, jZ(t, e);
}
function okt(t) {
  var e = akt();
  return function() {
    var r = eU(t), i;
    if (e) {
      var o = eU(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return skt(this, i);
  };
}
function skt(t, e) {
  if (e && (Z4(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return pR(t);
}
function pR(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function akt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function eU(t) {
  return eU = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, eU(t);
}
function Z1(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Akt = "react-grid-layout";
function lkt(t) {
  var e;
  return e = /* @__PURE__ */ function(n) {
    ikt(i, n);
    var r = okt(i);
    function i() {
      var o;
      nkt(this, i);
      for (var s = arguments.length, a = new Array(s), A = 0; A < s; A++)
        a[A] = arguments[A];
      return o = r.call.apply(r, [this].concat(a)), Z1(pR(o), "state", {
        width: 1280
      }), Z1(pR(o), "elementRef", /* @__PURE__ */ mF.createRef()), Z1(pR(o), "mounted", !1), Z1(pR(o), "onWindowResize", function() {
        if (o.mounted) {
          var l = o.elementRef.current;
          l instanceof HTMLElement && l.offsetWidth && o.setState({
            width: l.offsetWidth
          });
        }
      }), o;
    }
    return rkt(i, [{
      key: "componentDidMount",
      value: function() {
        this.mounted = !0, window.addEventListener("resize", this.onWindowResize), this.onWindowResize();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.mounted = !1, window.removeEventListener("resize", this.onWindowResize);
      }
    }, {
      key: "render",
      value: function() {
        var s = this.props, a = s.measureBeforeMount, A = ekt(s, X3t);
        return a && !this.mounted ? /* @__PURE__ */ mF.createElement("div", {
          className: (0, W3t.default)(this.props.className, Akt),
          style: this.props.style,
          ref: this.elementRef
        }) : /* @__PURE__ */ mF.createElement(t, qZ({
          innerRef: this.elementRef
        }, A, this.state));
      }
    }]), i;
  }(mF.Component), Z1(e, "defaultProps", {
    measureBeforeMount: !1
  }), Z1(e, "propTypes", {
    // If true, will not render children until mounted. Useful for getting the exact width before
    // rendering, to prevent any unsightly resizing.
    measureBeforeMount: K3t.default.bool
  }), e;
}
(function(t) {
  t.exports = BL.default, t.exports.utils = pi, t.exports.Responsive = p9.default, t.exports.Responsive.utils = zB, t.exports.WidthProvider = Uae.default;
})(QUe);
var uve = QUe.exports;
function ckt(t) {
  return t.reduce((e, n) => e + n, 0);
}
function fve(t, e) {
  const n = [];
  for (let r = 0; r < t.length; r++)
    n.push(t[r + 1] - t[r]);
  return Object.entries(e).map(([r, i]) => ({
    i: r,
    y: i.y,
    h: i.h || 1,
    x: t[i.x],
    w: ckt(n.slice(i.x, i.x + (i.w || 1)))
  }));
}
function gve(t) {
  return Math.max(...Object.values(t).map((e) => Math.max(...e.map((n) => n.y + n.h))));
}
function ukt(t) {
  const e = {}, n = {}, r = {}, i = {}, o = {};
  if (("components" in t ? t.components : t).forEach((s) => {
    const a = s.uid;
    i[a] = {
      uid: s.uid,
      component: s.component,
      props: s.props || {},
      coordinationScopes: s.coordinationScopes || {},
      coordinationScopesBy: s.coordinationScopesBy || {}
    }, o[a] = {
      id: a,
      x: s.x,
      y: s.y,
      w: s.w,
      h: s.h
    };
  }), "components" in t)
    Object.entries(t.columns).forEach(([s, a]) => {
      e[s] = a[a.length - 1], n[s] = fve(a, o), r[s] = s;
    });
  else {
    const s = "ID";
    e[s] = 12, n[s] = fve(oA(12 + 1), o), r[s] = 1e3;
  }
  return {
    cols: e,
    layouts: n,
    breakpoints: r,
    components: i
  };
}
const fkt = uve.WidthProvider(uve.Responsive);
class gkt extends fkt {
  componentDidUpdate(e) {
    this.props.height !== e.height && this.onWindowResize();
  }
}
function B8e(t) {
  const { layout: e, viewTypes: n, padding: r, margin: i, draggableHandle: o, onResize: s, onResizeStop: a, rowHeight: A, theme: l, height: c, onRemoveComponent: u, onLayoutChange: f, isBounded: h } = t, d = Qn((K) => {
    if (Array.isArray(n)) {
      const z = n.find((Y) => Y.name === K);
      if (z)
        return z.component;
    }
    return () => null;
  }, [n]), I = `.${o}`, { cols: m, layouts: C, breakpoints: y, components: v } = dt(() => ukt(e), [e]), b = dt(() => [r, r], [r]), Q = dt(() => [i, i], [i]), w = gve(C), R = ne.jsx("style", { children: `
        ${I} {
          cursor: grab;
        }
        ${I}:active {
          cursor: grabbing;
        }
     ` }), [M, O] = mn(null), [L, N] = mn(C), k = Qn((K) => {
    if (K.length === Object.entries(v).length) {
      const z = {};
      K.forEach((Y) => {
        const V = Y.i, Z = v[V];
        if (Z) {
          const ce = {
            x: Y.x,
            y: Y.y,
            w: Y.w,
            h: Y.h
          }, ee = {
            x: Z.x,
            y: Z.y,
            w: Z.w,
            h: Z.h
          };
          gr(ce, ee) || (z[V] = ce);
        }
      }), Object.keys(z).length > 0 && f(z);
    }
  }, [v, f]), $ = Qn((K, z) => {
    O(z), setTimeout(() => {
      !h || gve({ ID: K }) <= w ? (k(K), N(z)) : k(L), O(null);
    }, 50);
  }, [h, L, w, k]), U = Qn(() => {
    N(C);
  }, [C]), X = dt(() => Object.values(v).map((K) => {
    const z = d(K.component), Y = () => {
      u(K.uid);
    };
    return ne.jsx("div", { children: ne.jsx(z, { ...K.props, uuid: K.uid, coordinationScopes: K.coordinationScopes, coordinationScopesBy: K.coordinationScopesBy, theme: l, removeGridComponent: Y }) }, K.uid);
  }), [v, d, u, l]);
  return C && v && y && m && ne.jsxs(ne.Fragment, { children: [R, ne.jsx(gkt, { className: "layout", cols: m, layouts: M || C, breakpoints: y, height: c, rowHeight: A || (window.innerHeight - 2 * r - (w - 1) * Q) / w, containerPadding: b, margin: Q, draggableHandle: I, onLayoutChange: $, isBounded: h, onResizeStart: U, onDragStart: U, onResize: s, onResizeStop: a, children: X })] });
}
B8e.defaultProps = {
  padding: 10,
  margin: 10
};
let YZ = class extends Map {
  constructor(e, n = S8e) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), e != null)
      for (const [r, i] of e)
        this.set(r, i);
  }
  get(e) {
    return super.get(zZ(this, e));
  }
  has(e) {
    return super.has(zZ(this, e));
  }
  set(e, n) {
    return super.set(b8e(this, e), n);
  }
  delete(e) {
    return super.delete(_8e(this, e));
  }
};
class tU extends Set {
  constructor(e, n = S8e) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), e != null)
      for (const r of e)
        this.add(r);
  }
  has(e) {
    return super.has(zZ(this, e));
  }
  add(e) {
    return super.add(b8e(this, e));
  }
  delete(e) {
    return super.delete(_8e(this, e));
  }
}
function zZ({ _intern: t, _key: e }, n) {
  const r = e(n);
  return t.has(r) ? t.get(r) : n;
}
function b8e({ _intern: t, _key: e }, n) {
  const r = e(n);
  return t.has(r) ? t.get(r) : (t.set(r, n), n);
}
function _8e({ _intern: t, _key: e }, n) {
  const r = e(n);
  return t.has(r) && (n = t.get(r), t.delete(r)), n;
}
function S8e(t) {
  return t !== null && typeof t == "object" ? t.valueOf() : t;
}
function hkt(t, e) {
  if (Array.isArray(e)) {
    const n = e.find((r) => r.name === t);
    if (n)
      return n.getSourceAndLoader();
  }
  return [null, null];
}
function dkt(t, e) {
  if (Array.isArray(e)) {
    const n = e.find((r) => r.name === t);
    if (n)
      return n.dataType;
  }
  return null;
}
function pkt(t) {
  let e = 0, n;
  for (let r = 0, i = t.length; r < i; r++)
    n = t[r].y + t[r].h, n > e && (e = n);
  return e;
}
function Ikt(t, e, n, r) {
  return (t - 2 * r - (e - 1) * n) / e;
}
function mkt(t, e, n, r, i) {
  const [o, s] = mn(n), [a, A] = mn(e), l = Zr();
  return Mn(() => {
    const c = pkt(t.layout), u = Ikt(o, c, r, i);
    A(u);
  }, [o, t, r, i]), Mn(() => {
    n != null && s(n);
  }, [n]), Mn(() => {
    if (n != null)
      return () => {
      };
    function c() {
      if (!l.current)
        return;
      const u = l.current.getBoundingClientRect();
      s(u.height);
    }
    return window.addEventListener("resize", c), c(), () => {
      window.removeEventListener("resize", c);
    };
  }, [l, n]), [a, l];
}
function Ckt(t, e, n, r, i) {
  const o = qct[e].filter((A) => Object.keys(i).includes(A) && !Object.keys(t).includes(A)), a = {
    ...V_t(i, o),
    // The user-provided values should take precedence.
    ...t
  };
  return gr(t, a) || console.warn(`Using coordination value defaults for file type ${n} in dataset ${r}
Before: ${JSON.stringify(t)}
After: ${JSON.stringify(a)}`), a;
}
function Q8e(t, e, n, r, i) {
  const o = {}, s = new YZ([], JSON.stringify), a = ji(r.map((A) => [A.name, A.defaultValue]));
  return t.forEach((A) => {
    const l = {
      name: A.name,
      description: A.description || e,
      loaders: {}
    };
    A.files.forEach((c) => {
      const { url: u, options: f, requestInit: h, fileType: d, coordinationValues: I = {} } = c, m = dkt(d, n), C = Ckt(I, m, d, A.uid, a), [y, v] = hkt(d, n), b = u || JSON.stringify(f), Q = y.prototype.constructor.name, w = [b, Q];
      s.has(w) || s.set(w, new y({
        url: u,
        requestInit: h,
        // Optionally, pass a Zarrita store to the data source,
        // if one was mapped to this URL.
        store: i?.[u]
      }));
      const R = new v(s.get(w), c);
      l.loaders[m] ? l.loaders[m].set(C, R) : l.loaders[m] = new YZ([
        [C, R]
      ], JSON.stringify);
    }), o[A.uid] = l;
  }), o;
}
function Hae(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function $ae(t) {
  let e = t, n = t;
  t.length === 1 && (e = (s, a) => t(s) - a, n = Ekt(t));
  function r(s, a, A, l) {
    for (A == null && (A = 0), l == null && (l = s.length); A < l; ) {
      const c = A + l >>> 1;
      n(s[c], a) < 0 ? A = c + 1 : l = c;
    }
    return A;
  }
  function i(s, a, A, l) {
    for (A == null && (A = 0), l == null && (l = s.length); A < l; ) {
      const c = A + l >>> 1;
      n(s[c], a) > 0 ? l = c : A = c + 1;
    }
    return A;
  }
  function o(s, a, A, l) {
    A == null && (A = 0), l == null && (l = s.length);
    const c = r(s, a, A, l - 1);
    return c > A && e(s[c - 1], a) > -e(s[c], a) ? c - 1 : c;
  }
  return { left: r, center: o, right: i };
}
function Ekt(t) {
  return (e, n) => Hae(t(e), n);
}
function w8e(t) {
  return t === null ? NaN : +t;
}
const ykt = $ae(Hae), vkt = ykt.right;
$ae(w8e).center;
const SL = vkt;
function fa(t, e) {
  let n, r;
  if (e === void 0)
    for (const i of t)
      i != null && (n === void 0 ? i >= i && (n = r = i) : (n > i && (n = i), r < i && (r = i)));
  else {
    let i = -1;
    for (let o of t)
      (o = e(o, ++i, t)) != null && (n === void 0 ? o >= o && (n = r = o) : (n > o && (n = o), r < o && (r = o)));
  }
  return [n, r];
}
let jc = class {
  constructor() {
    this._partials = new Float64Array(32), this._n = 0;
  }
  add(e) {
    const n = this._partials;
    let r = 0;
    for (let i = 0; i < this._n && i < 32; i++) {
      const o = n[i], s = e + o, a = Math.abs(e) < Math.abs(o) ? e - (s - o) : o - (s - e);
      a && (n[r++] = a), e = s;
    }
    return n[r] = e, this._n = r + 1, this;
  }
  valueOf() {
    const e = this._partials;
    let n = this._n, r, i, o, s = 0;
    if (n > 0) {
      for (s = e[--n]; n > 0 && (r = s, i = e[--n], s = r + i, o = i - (s - r), !o); )
        ;
      n > 0 && (o < 0 && e[n - 1] < 0 || o > 0 && e[n - 1] > 0) && (i = o * 2, r = s + i, i == r - s && (s = r));
    }
    return s;
  }
};
class hve extends Map {
  constructor(e, n = _kt) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), e != null)
      for (const [r, i] of e)
        this.set(r, i);
  }
  get(e) {
    return super.get(dve(this, e));
  }
  has(e) {
    return super.has(dve(this, e));
  }
  set(e, n) {
    return super.set(Bkt(this, e), n);
  }
  delete(e) {
    return super.delete(bkt(this, e));
  }
}
function dve({ _intern: t, _key: e }, n) {
  const r = e(n);
  return t.has(r) ? t.get(r) : n;
}
function Bkt({ _intern: t, _key: e }, n) {
  const r = e(n);
  return t.has(r) ? t.get(r) : (t.set(r, n), n);
}
function bkt({ _intern: t, _key: e }, n) {
  const r = e(n);
  return t.has(r) && (n = t.get(n), t.delete(r)), n;
}
function _kt(t) {
  return t !== null && typeof t == "object" ? t.valueOf() : t;
}
var VZ = Math.sqrt(50), JZ = Math.sqrt(10), KZ = Math.sqrt(2);
function nU(t, e, n) {
  var r, i = -1, o, s, a;
  if (e = +e, t = +t, n = +n, t === e && n > 0)
    return [t];
  if ((r = e < t) && (o = t, t = e, e = o), (a = qae(t, e, n)) === 0 || !isFinite(a))
    return [];
  if (a > 0) {
    let A = Math.round(t / a), l = Math.round(e / a);
    for (A * a < t && ++A, l * a > e && --l, s = new Array(o = l - A + 1); ++i < o; )
      s[i] = (A + i) * a;
  } else {
    a = -a;
    let A = Math.round(t * a), l = Math.round(e * a);
    for (A / a < t && ++A, l / a > e && --l, s = new Array(o = l - A + 1); ++i < o; )
      s[i] = (A + i) / a;
  }
  return r && s.reverse(), s;
}
function qae(t, e, n) {
  var r = (e - t) / Math.max(0, n), i = Math.floor(Math.log(r) / Math.LN10), o = r / Math.pow(10, i);
  return i >= 0 ? (o >= VZ ? 10 : o >= JZ ? 5 : o >= KZ ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (o >= VZ ? 10 : o >= JZ ? 5 : o >= KZ ? 2 : 1);
}
function rU(t, e, n) {
  var r = Math.abs(e - t) / Math.max(0, n), i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)), o = r / i;
  return o >= VZ ? i *= 10 : o >= JZ ? i *= 5 : o >= KZ && (i *= 2), e < t ? -i : i;
}
function pve(t, e) {
  let n;
  if (e === void 0)
    for (const r of t)
      r != null && (n < r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let i of t)
      (i = e(i, ++r, t)) != null && (n < i || n === void 0 && i >= i) && (n = i);
  }
  return n;
}
function Skt(t, e, n = w8e) {
  if (r = t.length) {
    if ((e = +e) <= 0 || r < 2)
      return +n(t[0], 0, t);
    if (e >= 1)
      return +n(t[r - 1], r - 1, t);
    var r, i = (r - 1) * e, o = Math.floor(i), s = +n(t[o], o, t), a = +n(t[o + 1], o + 1, t);
    return s + (a - s) * (i - o);
  }
}
function* Qkt(t) {
  for (const e of t)
    yield* e;
}
function x8e(t) {
  return Array.from(Qkt(t));
}
function A_(t, e, n) {
  t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((e - t) / n)) | 0, o = new Array(i); ++r < i; )
    o[r] = t + r * n;
  return o;
}
function R8e(t, e) {
  let n = 0;
  if (e === void 0)
    for (let r of t)
      (r = +r) && (n += r);
  else {
    let r = -1;
    for (let i of t)
      (i = +e(i, ++r, t)) && (n += i);
  }
  return n;
}
function Ive() {
  const { innerWidth: t, innerHeight: e } = window;
  return {
    width: t,
    height: e
  };
}
function jae(t) {
  return Qn(() => t.current ? t.current.closest(`.${WH}`) : null, [t]);
}
function D8e() {
  const [t, e] = mn(Ive());
  return Mn(() => {
    function n() {
      e(Ive());
    }
    const r = Bd(n, 100, { trailing: !0 });
    return window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, []), t;
}
function uw() {
  const t = Zr(), [e, n] = mn(), [r, i] = mn(), o = SUe(), s = Bae();
  return Mn(() => {
    function a() {
      s();
    }
    const A = Bd(a, 100, { trailing: !0 });
    return window.addEventListener("resize", A), a(), () => {
      window.removeEventListener("resize", A);
    };
  }, [s]), Mn(() => {
    if (!t.current)
      return;
    const A = t.current.getBoundingClientRect();
    n(A.height), i(A.width);
  }, [o]), [r, e, t];
}
function QL() {
  const t = Zr(), [e, n] = mn(), [r, i] = mn(), o = SUe(), s = Bae();
  return Mn(() => {
    function a() {
      s();
    }
    const A = Bd(a, 100, { trailing: !0 });
    return window.addEventListener("resize", A), a(), () => {
      window.removeEventListener("resize", A);
    };
  }, [s]), Mn(() => {
    if (!t.current)
      return;
    const { canvas: a } = t.current.deck, A = a.getBoundingClientRect();
    n(A.height), i(A.width);
  }, [o]), [r, e, t];
}
function Jc(t) {
  return dt(() => Q4e(t, (e) => e !== Ra.LOADING), t);
}
function Qd(t) {
  return dt(
    () => t.filter((n) => Array.isArray(n)).flat().filter((n, r, i) => {
      const o = i.findIndex((s) => s && n && s.name === n.name);
      return r === o;
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
function Yae(t) {
  const [e, n] = mn(), [r, i] = mn();
  return Mn(() => {
    function o() {
      if (t.current) {
        const { clientHeight: a, clientWidth: A } = t.current.closest(`.${WH}`);
        i(A), n(a);
      }
    }
    const s = Bd(o, 100, { trailing: !0 });
    return window.addEventListener("resize", s), o(), () => {
      window.removeEventListener("resize", s);
    };
  }, [t]), [r, e];
}
function wkt({ obsFeatureMatrix: t }) {
  return dt(() => {
    if (t && t.data) {
      const e = fa(t.data), [n, r] = e, i = 255 / (r - n);
      return [{ data: new Uint8Array(t.data.map((s) => Math.floor((s - n) * i))) }, e];
    }
    return [null, null];
  }, [t]);
}
function zae(t) {
  return dt(() => {
    if (t && t[0]) {
      const e = t.map((r) => fa(r));
      return [t.map((r, i) => {
        const [o, s] = e[i], a = 255 / (s - o);
        return new Uint8Array(r.map((A) => Math.floor((A - o) * a)));
      }), e];
    }
    return [null, null];
  }, [t]);
}
function Vae({ instanceObsIndex: t, matrixObsIndex: e, expressionData: n }) {
  const r = dt(() => {
    if (t && e) {
      const o = new Map(e.map((s, a) => [s, a]));
      return t.map((s) => o.get(s));
    }
    return null;
  }, [t, e]);
  return Qn((o, { index: s }) => {
    if (r && n && n[0]) {
      const a = r[s];
      return n[0][a];
    }
    return 0;
  }, [r, n]);
}
function xkt(t) {
  return Qn((e) => e ? t?.get(e) || [] : [], [t]);
}
function Jae(t, e, n, r) {
  return Qn((i) => {
    if (i) {
      const o = r?.get(i) || [];
      return {
        [`${Ci(t)} ID`]: i,
        ...ji(o.flatMap((s) => s.slice(1).map((a, A) => [
          `${s[0]}${s.length > 2 ? ` L${A + 1}` : ""}`,
          a
        ]))),
        ...ji(Object.entries(e).map(([s, a]) => [
          a,
          n?.[s]?.obsLabels?.[
            // TODO: Maybe all loaders that return obsIndex should also return an obsIndexMap
            // with keys: obsId, values: obsIdx
            // which would avoid the indexOf calls.
            n?.[s]?.obsIndex?.indexOf(i)
          ]
        ]).filter(([s]) => !!s))
      };
    }
    return null;
  }, [t, e, n, r]);
}
const Rkt = kr((t) => ({
  vitessceContainer: {
    position: "relative",
    margin: "0",
    textAlign: "left",
    backgroundColor: t.palette.gridLayoutBackground,
    "& div": {
      fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "1.5",
      textAlign: "left"
    },
    "& p": {
      marginTop: "0",
      marginBottom: "16px"
    },
    "& *, ::after, ::before": {
      boxSizing: "border-box"
    },
    // Manually converted styles from 'react-grid-layout/css/styles.css',
    // using https://cssinjs.org/jss-plugin-global/?v=v10.9.2
    // so that no CSS or SCSS import is required.
    "@global .react-grid-layout": {
      transition: "height 200ms ease",
      // Custom
      height: "auto",
      position: "absolute",
      width: "100%"
    },
    "@global .react-grid-item": {
      transition: "all 200ms ease",
      transitionProperty: "left, top",
      // Custom
      flexDirection: "column!important",
      display: "flex!important",
      /* So the resize handle position looks correct: */
      paddingRight: "10px"
    },
    "@global .react-grid-item img": {
      pointerEvents: "none",
      userSelect: "none"
    },
    "@global .react-grid-item.cssTransforms": {
      transitionProperty: "transform"
    },
    "@global .react-grid-item.resizing": {
      zIndex: "1",
      willChange: "width, height"
    },
    "@global .react-grid-item.react-draggable-dragging": {
      transition: "none",
      zIndex: "3",
      willChange: "transform"
    },
    "@global .react-grid-item.dropping": {
      visibility: "hidden"
    },
    "@global .react-grid-item.react-grid-placeholder": {
      background: "red",
      opacity: "0.2",
      transitionDuration: "100ms",
      zIndex: "2",
      userSelect: "none"
    },
    "@global .react-grid-item > .react-resizable-handle": {
      position: "absolute",
      width: "20px",
      height: "20px"
    },
    "@global .react-grid-item > .react-resizable-handle::after": {
      content: '""',
      position: "absolute",
      right: "3px",
      bottom: "3px",
      width: "5px",
      height: "5px",
      borderRight: "2px solid rgba(0, 0, 0, 0.4)",
      borderBottom: "2px solid rgba(0, 0, 0, 0.4)"
    },
    "@global .react-resizable-hide > .react-resizable-handle": {
      display: "none"
    },
    "@global .react-grid-item > .react-resizable-handle.react-resizable-handle-sw": {
      bottom: "0",
      left: "0",
      cursor: "sw-resize",
      transform: "rotate(90deg)"
    },
    "@global .react-grid-item > .react-resizable-handle.react-resizable-handle-se": {
      bottom: "0",
      right: "0",
      cursor: "se-resize"
    },
    "@global .react-grid-item > .react-resizable-handle.react-resizable-handle-nw": {
      top: "0",
      left: "0",
      cursor: "nw-resize",
      transform: "rotate(180deg)"
    },
    "@global .react-grid-item > .react-resizable-handle.react-resizable-handle-ne": {
      top: "0",
      right: "0",
      cursor: "ne-resize",
      transform: "rotate(270deg)"
    },
    "@global .react-grid-item > .react-resizable-handle.react-resizable-handle-w": {
      top: "50%",
      marginTop: "-10px",
      cursor: "ew-resize",
      left: "0",
      transform: "rotate(135deg)"
    },
    "@global .react-grid-item > .react-resizable-handle.react-resizable-handle-e": {
      top: "50%",
      marginTop: "-10px",
      cursor: "ew-resize",
      right: "0",
      transform: "rotate(315deg)"
    },
    "@global .react-grid-item > .react-resizable-handle.react-resizable-handle-n": {
      left: "50%",
      marginLeft: "-10px",
      cursor: "ns-resize",
      top: "0",
      transform: "rotate(225deg)"
    },
    "@global .react-grid-item > .react-resizable-handle.react-resizable-handle-s": {
      left: "50%",
      marginLeft: "-10px",
      cursor: "ns-resize",
      bottom: "0",
      transform: "rotate(45deg)"
    },
    // Manually converted styles from 'react-resizable/css/styles.css',
    "@global .react-resizable": {
      position: "relative"
    },
    "@global .react-resizable-handle": {
      position: "absolute",
      width: "20px",
      height: "20px",
      backgroundRepeat: "no-repeat",
      backgroundOrigin: "content-box",
      boxSizing: "border-box",
      backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+')",
      backgroundPosition: "bottom right",
      padding: "0 3px 3px 0"
    },
    "@global .react-resizable-handle-sw": {
      bottom: "0",
      left: "0",
      cursor: "sw-resize",
      transform: "rotate(90deg)"
    },
    "@global .react-resizable-handle-se": {
      bottom: "0",
      right: "0",
      cursor: "se-resize"
    },
    "@global .react-resizable-handle-nw": {
      top: "0",
      left: "0",
      cursor: "nw-resize",
      transform: "rotate(180deg)"
    },
    "@global .react-resizable-handle-ne": {
      top: "0",
      right: "0",
      cursor: "ne-resize",
      transform: "rotate(270deg)"
    },
    "@global .react-resizable-handle-w": {
      top: "50%",
      marginTop: "-10px",
      cursor: "ew-resize",
      left: "0",
      transform: "rotate(135deg)"
    },
    "@global .react-resizable-handle-e": {
      top: "50%",
      marginTop: "-10px",
      cursor: "ew-resize",
      right: "0",
      transform: "rotate(315deg)"
    },
    "@global .react-resizable-handle-n": {
      left: "50%",
      marginLeft: "-10px",
      cursor: "ns-resize",
      top: "0",
      transform: "rotate(225deg)"
    },
    "@global .react-resizable-handle-s": {
      left: "50%",
      marginLeft: "-10px",
      cursor: "ns-resize",
      bottom: "0",
      transform: "rotate(45deg)"
    },
    // Custom
    "@global .react-draggable-transparent-selection .react-grid-item": {
      /* These styles prevent text selection during resize drag interactions.
        The react-draggable-transparent-selection class is added to the body
        element during resizing and removed after resizing has finished.
        Not part of mixin because acts outside of .vitessce-container. */
      userSelect: "none !important"
    }
  }
})), T8e = kr((t) => ({
  title: {
    color: t.palette.primaryForeground,
    overflowX: "hidden",
    display: "flex",
    flexDirection: "row",
    flexShrink: "0"
  },
  titleLeft: {
    flexShrink: "1",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  titleInfo: {
    width: "100%",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    fontSize: "80% !important",
    opacity: ".8",
    padding: "0 4px",
    justifyContent: "center",
    lineHeight: "25px !important",
    flexShrink: "1",
    textAlign: "right !important"
  },
  titleButtons: {
    display: "flex",
    flexDirection: "row",
    flexGrow: "1",
    flexShrink: "0",
    justifyContent: "right",
    "& div": {
      display: "inline-block"
    }
  },
  card: {
    border: `1px solid ${t.palette.cardBorder}`,
    flex: "1 1 auto",
    minHeight: "1px",
    padding: "12px",
    marginTop: "8px",
    marginBottom: "8px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    backgroundClip: "border-box",
    borderRadius: "4px"
  },
  noScrollCard: {
    backgroundColor: t.palette.secondaryBackground,
    color: t.palette.secondaryForeground
  },
  scrollCard: {
    backgroundColor: t.palette.primaryBackground,
    color: t.palette.primaryForeground,
    "& a": {
      color: t.palette.primaryForegroundActive
    },
    overflowY: "auto"
  },
  spatialCard: {
    backgroundColor: t.palette.black,
    color: t.palette.white,
    "& a": {
      color: t.palette.white
    }
  }
}));
function Dkt(t) {
  const e = t.filter((n) => n !== void 0);
  return e.length === 0 ? "" : e.length === 1 ? e[0] : `${t.slice(0, -1).join(", ")} and ${t.slice(-1)}`;
}
const Tkt = /* @__PURE__ */ new Map([
  [Gn.DESCRIPTION, "description"],
  [Gn.STATUS, "status view for debugging"],
  [Gn.SCATTERPLOT, "scatterplot with embeddings"],
  [Gn.SPATIAL, "spatial view"],
  [Gn.SPATIAL_BETA, "spatial view"],
  [Gn.HEATMAP, "cell by gene heatmap"],
  [Gn.LAYER_CONTROLLER, "layer controller"],
  [Gn.LAYER_CONTROLLER_BETA, "layer controller"],
  [Gn.GENOMIC_PROFILES, "genome browser tracks with bar plots"],
  [Gn.GATING, "scatterplot of gated gene expression data"],
  [Gn.FEATURE_LIST, "interactive list of features"],
  [Gn.OBS_SETS, "list of potential observation sets"],
  [Gn.OBS_SET_SIZES, "sizes of selected observation sets"],
  [Gn.OBS_SET_FEATURE_VALUE_DISTRIBUTION, "violin plot with values"],
  [Gn.FEATURE_VALUE_HISTOGRAM, "distribution of values"]
]);
function Nkt(t) {
  const e = t.layout.map((r) => r.component);
  return `Vitessce grid with ${e.length} views, including ${Dkt(e.map((r) => Tkt.get(r) || "plugin view"))}.`;
}
const mve = 10, Cve = 5;
function Lkt(t) {
  const { success: e, configKey: n, rowHeight: r, config: i, theme: o, height: s, isBounded: a, viewTypes: A, fileTypes: l, coordinationTypes: c, stores: u } = t, [f, h] = mkt(i, r, s, Cve, mve), d = Bae(), [I] = Yae(h), m = Rkt(), C = T8e(), y = dt(() => Nkt(i), [n]);
  Mn(() => {
    d();
  }, [f, d]);
  const v = hUe(), b = eDt(v), Q = ZRt(), w = JRt(), R = XRt(), M = VRt(), O = Qn((L) => {
    I > 0 && R(L);
  }, [R, I]);
  return Mn(() => {
    let L = null, N = null;
    e && (L = Q8e(i.datasets, i.description, l, c, u), N = i), b(N), Q(L);
  }, [e, n]), ne.jsx("div", { ref: h, className: Xt(WH, m.vitessceContainer), role: "group", "aria-label": y, children: M ? ne.jsx(B8e, { role: "group", layout: M, height: s, rowHeight: f, theme: o, viewTypes: A, draggableHandle: C.title, margin: Cve, padding: mve, onRemoveComponent: w, onLayoutChange: O, isBounded: a, onResize: d, onResizeStop: d }) : null });
}
const Mkt = kr((t) => ({
  warningLayout: {
    backgroundColor: t.palette.gridLayoutBackground,
    position: "absolute",
    width: "100%",
    height: "100vh"
  },
  containerFluid: {
    width: "100%",
    padding: "15px",
    marginRight: "auto",
    marginLeft: "auto",
    boxSizing: "border-box",
    display: "flex"
  },
  row: {
    flexGrow: "1"
  },
  warningCard: {
    border: `1px solid ${t.palette.cardBorder}`,
    flex: "1 1 auto",
    minHeight: "1px",
    padding: "12px",
    marginTop: "8px",
    marginBottom: "8px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    backgroundClip: "border-box",
    borderRadius: "4px",
    backgroundColor: t.palette.primaryBackground,
    color: t.palette.primaryForeground
  }
}));
function Okt(t) {
  const { title: e, preformatted: n, unformatted: r } = t, i = Mkt();
  return ne.jsx("div", { className: WH, children: ne.jsx("div", { className: Xt(i.warningLayout, i.containerFluid), children: ne.jsx("div", { className: i.row, children: ne.jsxs("div", { className: i.warningCard, children: [ne.jsx("h1", { children: e }), n ? ne.jsx("pre", { children: n }) : null, ne.jsx("p", { children: r })] }) }) }) });
}
function Fkt(t, e) {
  try {
    e.parse(t);
  } catch (n) {
    console.error(n);
  }
}
function Pkt(t) {
  const { onWarn: e, onConfigChange: n, onLoaderChange: r, validateOnConfigChange: i, pluginSpecificConfigSchema: o } = t, s = _Ue(), a = eu(), A = hUe();
  return Mn(() => A.subscribe(
    // The function to run on each publish.
    (l) => {
      i && l && Fkt(l, o), n && l && n(l);
    },
    // The function to specify which part of the store
    // we want to subscribe to.
    (l) => l.viewConfig
  ), [n, i, A, o]), Mn(() => {
    e && s && e(s);
  }, [s, e]), Mn(() => {
    r && a && r(a);
  }, [a, r]), null;
}
function hk(t, e) {
  console.groupCollapsed(`🚄 VitS (${Wct.version}) ${e}`), console.info(`data:,${JSON.stringify(t)}`), console.info(JSON.stringify(t, null, 2)), console.groupEnd();
}
function N8e(t, e) {
  const n = Object.keys(t?.coordinationSpace?.[e] || {}), r = t.layout.map((i) => i.coordinationScopes?.[e]);
  return Array.from(/* @__PURE__ */ new Set([...n, ...r]));
}
function kkt(t, e, n, r) {
  const i = ji(r.map((a) => [a.name, a.coordinationTypes])), o = ql(N8e(t, e));
  return {
    ...t,
    coordinationSpace: {
      ...t.coordinationSpace,
      [e]: {
        ...t?.coordinationSpace?.[e],
        // Add the new scope name and value to the coordination space.
        [o]: n
      }
    },
    layout: t.layout.map((a) => ({
      ...a,
      coordinationScopes: {
        ...a.coordinationScopes,
        // Only set the coordination scope if this component uses this coordination type,
        // and the component is missing a coordination scope for this coordination type.
        ...i[a.component].includes(e) && !a.coordinationScopes?.[e] ? {
          // Only set the new scope name if the scope name
          // for this component and coordination type is currently undefined.
          [e]: o
        } : {}
      }
    }))
  };
}
function Gkt(t, e, n, r) {
  const i = ji(r.map((a) => [a.name, a.coordinationTypes])), o = {
    ...t,
    layout: [...t.layout]
  }, s = {};
  return o.layout.forEach((a, A) => {
    if (i[a.component].includes(e) && !a.coordinationScopes?.[e]) {
      const l = ql([
        ...N8e(t, e),
        ...Object.keys(s)
      ]);
      s[l] = n, o.layout[A] = {
        ...a,
        coordinationScopes: {
          ...a.coordinationScopes,
          [e]: l
        }
      };
    }
  }), o.coordinationSpace = {
    ...o.coordinationSpace,
    [e]: {
      ...o.coordinationSpace[e],
      // Add the new scope name and value to the coordination space.
      ...s
    }
  }, o;
}
function Ukt(t, e, n) {
  let r = t;
  const { layout: i, datasets: o } = r, s = ji(n.map((l) => [l.name, l.coordinationTypes])), a = ji(e.map((l) => [l.name, l.defaultValue]));
  return e.map((l) => l.name).forEach((l) => {
    if (!i.every((u) => !s[u.component].includes(l) || u.coordinationScopes?.[l])) {
      let u = a[l];
      l === "dataset" && o.length >= 1 && (u = o[0].uid), jct.includes(l) ? r = Gkt(r, l, u, n) : r = kkt(r, l, u, n);
    }
  }), r;
}
function Hkt(t) {
  const { uid: e, layout: n } = t, r = n.map((o) => o.uid);
  n.forEach((o, s) => {
    if (!o.uid) {
      const a = ql(r);
      n[s].uid = a, r.push(a);
    }
  });
  const i = e || ql([]);
  return {
    ...t,
    uid: i,
    layout: n
  };
}
function $kt(t, e) {
  const n = ji(e.map((o) => [o.name, o.expandFunction])), { datasets: r } = t, i = $A(r);
  return r.forEach((o, s) => {
    const { files: a = [] } = o;
    let A = [];
    a.forEach((l) => {
      const { fileType: c } = l, u = n[c];
      if (u && typeof u == "function") {
        const f = u(l);
        A = A.concat(f);
      } else
        A.push(l);
    }), i[s].files = A;
  }), {
    ...t,
    datasets: i
  };
}
function qkt(t, e, n, r) {
  let i = $A(t);
  return i.initStrategy === "auto" && (i = Ukt(t, n, r)), i = $kt(i, e), Hkt(i);
}
const jkt = [
  "checked",
  "disabled",
  "error",
  "focused",
  "focusVisible",
  "required",
  "expanded",
  "selected"
], Ykt = "vit-";
function zkt(t) {
  return (e, n) => {
    const { name: r, link: i, classNamePrefix: o } = n.options, { key: s } = e, a = t ? `${t}-` : Ykt;
    return r && r.indexOf("Mui") === 0 && !i ? jkt.indexOf(s) !== -1 ? `Mui-${s}` : `${a}${r}-${s}` : o ? `${a}${o}-${s}` : `${a}${s}`;
  };
}
function Vkt(t) {
  const { config: e, stores: n, rowHeight: r, height: i, theme: o, onWarn: s, onConfigChange: a, onLoaderChange: A, validateConfig: l = !0, validateOnConfigChange: c = !1, isBounded: u = !1, uid: f = null, viewTypes: h, fileTypes: d, jointFileTypes: I, coordinationTypes: m, warning: C } = t, y = dt(() => h || [], [h]), v = dt(() => d || [], [d]), b = dt(() => I || [], [I]), Q = dt(() => m || [], [m]), w = dt(() => zkt(f), [f]), R = e?.version, M = dt(() => e?.uid ? e.uid : JSON.stringify(e), [e]), O = dt(() => oRt(v, b, Q, y), [y, v, b, Q]), [L, N] = dt(() => {
    if (C)
      return [C, !1];
    if (hk(e, "input view config"), !l)
      return [e, !0];
    const U = vv.safeParse(e);
    if (U.success) {
      const X = U.data;
      hk(X, "parsed view config");
      const K = O.safeParse(X);
      if (K.success)
        try {
          const z = K.data, Y = qkt(z, b, Q, y);
          return hk(Y, "initialized view config"), [Y, !0];
        } catch (z) {
          return [
            {
              title: "Config initialization failed.",
              unformatted: z.message
            },
            !1
          ];
        }
      return [
        {
          title: "Config validation failed on second pass.",
          unformatted: K.error.message
        },
        !1
      ];
    }
    return [{
      title: "Config validation failed on first pass.",
      unformatted: U.error.message
    }, U.success];
  }, [M, R, O, C]), k = dt(() => new kEt({
    // Reference: https://tanstack.com/query/latest/docs/react/guides/window-focus-refetching
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: !1,
        retry: 2
      }
    }
  }), [M]);
  Mn(() => {
    N && !gr(L, e) && a && a(L);
  }, [N, M, L, a]);
  const $ = Qn(() => {
    if (N) {
      const U = Q8e(L.datasets, L.description, v, Q, n);
      return dye(U, L);
    }
    return dye(null, null);
  }, [N, M]);
  return N ? ne.jsx(eCe, { generateClassName: w, children: ne.jsx(sCe, { theme: fye[o], children: ne.jsx(XEt, { client: k, children: ne.jsx(FRt, { createStore: $, children: ne.jsxs(GRt, { createStore: $Rt, children: [ne.jsx(Lkt, { success: N, configKey: M, viewTypes: y, fileTypes: v, coordinationTypes: Q, config: L, rowHeight: r, height: i, theme: o, isBounded: u, stores: n }), ne.jsx(Pkt, { onWarn: s, onConfigChange: a, onLoaderChange: A, validateOnConfigChange: c, pluginSpecificConfigSchema: O })] }) }, M) }) }) }) : ne.jsx(eCe, { generateClassName: w, children: ne.jsx(sCe, { theme: fye[o], children: ne.jsx(Okt, { ...L }) }) });
}
const Kae = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
})), L8e = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M7 10l5 5 5-5z"
})), M8e = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M7 14l5-5 5 5z"
})), Jkt = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
})), Kkt = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
})), Wkt = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
})), Xkt = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
})), O8e = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
})), Zkt = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
})), eGt = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
})), fw = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), tGt = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
})), nGt = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
})), wL = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
})), xL = Na(/* @__PURE__ */ le.createElement("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
})), rGt = kr(() => ({
  loadingIndicatorBackdrop: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: "1040",
    width: "100%",
    height: "100%",
    borderRadius: "4px",
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  },
  loadingIndicatorContainer: {
    display: "grid",
    placeItems: "center",
    position: "absolute",
    width: "100%",
    height: "100%"
  },
  visuallyHidden: {
    position: "absolute",
    height: "1px",
    width: "1px",
    overflow: "hidden",
    clip: "rect(1px, 1px, 1px, 1px)",
    whiteSpace: "nowrap"
  }
}));
function iGt() {
  const t = rGt();
  return ne.jsx("div", { className: t.loadingIndicatorBackdrop, children: ne.jsxs("div", { className: t.loadingIndicatorContainer, role: "status", "aria-live": "polite", children: [ne.jsx(lIt, {}), ne.jsx("span", { className: t.visuallyHidden, children: "Loading..." })] }) });
}
const oGt = kr(() => ({
  paper: {
    maxHeight: 200,
    overflow: "auto"
  },
  container: {
    position: "relative",
    left: 0,
    top: 0
  }
}));
function s0(t) {
  const { buttonIcon: e, open: n, setOpen: r, children: i, buttonClassName: o, placement: s = "bottom-end", withPaper: a = !0, containerClassName: A, "aria-label": l } = t, c = oGt(), u = Zr(), f = () => {
    r((m) => !m);
  }, h = () => {
    r(!1);
  }, d = n ? "v-popover-menu" : void 0, I = jae(u);
  return ne.jsxs("div", { ref: u, className: Xt(c.container, A), children: [ne.jsx(KQ, { "aria-describedby": d, onClick: f, onTouchEnd: f, size: "small", className: o, "aria-label": l, children: e }), ne.jsx(vGe, { id: d, open: n, anchorEl: u && u.current, container: I, onClose: h, placement: s, transition: !0, children: ({ TransitionProps: m }) => ne.jsx(uIt, { onClickAway: h, children: ne.jsx(H0t, { ...m, timeout: 100, children: a ? ne.jsx(r0, { elevation: 4, className: c.paper, children: ne.jsx(eGe, { children: i }) }) : i }) }) })] });
}
const Wae = kr((t) => ({
  iconButton: {
    border: "none",
    marginLeft: 0,
    background: "none",
    color: t.palette.primaryForeground,
    paddingLeft: "0.25em",
    paddingRight: "0.25em",
    borderRadius: "2px",
    "&:hover": {
      backgroundColor: t.palette.primaryBackgroundLight
    },
    "&:first-child": {
      marginLeft: "0.25em"
    },
    "&:last-child": {
      marginRight: "0.25em"
    },
    "& svg": {
      width: "0.7em",
      height: "0.7em",
      verticalAlign: "middle",
      overflow: "visible"
    }
  },
  downloadLink: {
    color: t.palette.primaryForeground
  }
}));
function sGt({ open: t }) {
  return ne.jsxs(ne.Fragment, { children: [ne.jsx(nGt, {}), t ? ne.jsx(M8e, {}) : ne.jsx(L8e, {})] });
}
function aGt(t) {
  const { options: e } = t, [n, r] = mn(!1), i = Wae(), o = dt(() => ne.jsx(sGt, { open: n }), [n]);
  return e ? ne.jsx(s0, { open: n, setOpen: r, buttonIcon: o, buttonClassName: i.iconButton, placement: "bottom-end", "aria-label": "Open plot options menu", children: e }) : null;
}
function AGt({ open: t }) {
  return ne.jsxs(ne.Fragment, { children: [ne.jsx(Wkt, {}), t ? ne.jsx(M8e, {}) : ne.jsx(L8e, {})] });
}
function lGt(t) {
  const { urls: e } = t, [n, r] = mn(!1), i = Wae(), o = dt(() => ne.jsx(AGt, { open: n }), [n]);
  return e && e.length ? ne.jsx(s0, { open: n, setOpen: r, buttonIcon: o, buttonClassName: i.iconButton, placement: "bottom-end", "aria-label": "Open download options menu", children: e.map(({ url: s, name: a }) => ne.jsx(mi, { dense: !0, "aria-label": `Click to download ${a}`, children: ne.jsxs(cmt, { underline: "always", href: s, target: "_blank", rel: "noopener", className: i.downloadLink, children: ["Download ", a] }) }, `${s}_${a}`)) }) : null;
}
function cGt(t) {
  const { removeGridComponent: e } = t, n = Wae();
  return ne.jsx(KQ, { onClick: e, size: "small", className: n.iconButton, title: "close", "aria-label": "Close panel button", children: ne.jsx(Kkt, {}) });
}
function fc(t) {
  const { title: e, info: n, children: r, isScroll: i, isSpatial: o, removeGridComponent: s, urls: a, isReady: A, options: l, closeButtonVisible: c = !0, downloadButtonVisible: u = !0 } = t, f = T8e();
  return (
    // d-flex without wrapping div is not always full height; I don't understand the root cause.
    ne.jsxs(ne.Fragment, { children: [ne.jsxs("div", { className: f.title, role: "banner", children: [ne.jsx("div", { className: f.titleLeft, role: "heading", "aria-level": "1", children: e }), ne.jsx("div", { className: f.titleInfo, title: n, role: "note", children: n }), ne.jsxs("div", { className: f.titleButtons, role: "toolbar", "aria-label": "Plot options and controls", children: [ne.jsx(aGt, { options: l }), u ? ne.jsx(lGt, { urls: a }) : null, c ? ne.jsx(cGt, { removeGridComponent: s }) : null] })] }), ne.jsxs("div", { className: Xt(tDt, f.card, {
      [f.scrollCard]: i,
      [f.spatialCard]: o,
      [f.noScrollCard]: !i && !o
    }), "aria-busy": !A, role: "main", children: [!A && ne.jsx(iGt, {}), r] })] })
  );
}
class Ei {
  constructor(e) {
    this.message = e;
  }
  // eslint-disable-next-line class-methods-use-this
  warnInConsole() {
    throw new Error("The warnInConsole() method has not been implemented.");
  }
}
class uGt extends Ei {
  constructor(e, n, r, i) {
    super(`Error while validating ${e}.`), this.name = "LoaderValidationError", this.datasetType = e, this.datasetFileType = n, this.datasetUrl = r, this.reason = i;
  }
  warnInConsole() {
    const { datasetType: e, datasetUrl: n, reason: r } = this;
    console.warn(`${e} from ${n}: validation failed`, JSON.stringify(r, null, 2));
  }
}
class RL extends Ei {
  constructor(e, n, r, i) {
    super(`Error: unable to find matching ${r} file in dataset ${n}.`), this.name = "LoaderNotFoundError", this.loaders = e, this.dataset = n, this.fileType = r, this.viewCoordinationValues = i;
  }
  warnInConsole() {
    const { loaders: e, viewCoordinationValues: n } = this;
    console.warn(
      // eslint-disable-next-line prefer-template
      `Expected to match on { ${Object.entries(n).map(([r, i]) => r + ": " + i).join(", ")} }`,
      e
    );
  }
}
class iU extends Ei {
  constructor(e, n, r) {
    super(`${e} Error HTTP Status fetching from ${n}`), this.source = e, this.url = n, this.headers = r;
  }
  warnInConsole() {
    const { source: e, url: n, headers: r } = this;
    console.warn(`${e} failed to fetch from ${n} with headers ${JSON.stringify(r)}`);
  }
}
function gw(t, e) {
  e(t.message), console.warn(t.message), console.error(t.stack), t instanceof Ei && t.warnInConsole();
}
function F8e(t, e, n) {
  !t || !e || Object.entries(t).forEach(([r, i]) => {
    const o = `set${Ci(r)}`, s = e[o];
    (n && n[r]) === null && s && s(i);
  });
}
async function Xae(t) {
  const { placeholderObject: e, loaders: n } = t.meta, [r, i, o, s] = t.queryKey, a = iw(n, r, i, o);
  if (a) {
    const A = await a.load();
    if (!A)
      return e;
    const { data: l, url: c, coordinationValues: u } = A, f = (Array.isArray(c) ? c : [{ url: c, name: i }]).filter((h) => h.url);
    return { data: l, coordinationValues: u, urls: f };
  }
  if (s)
    throw new RL(n, r, i, o);
  return { data: e };
}
function a0(t, e, n, r, i, o, s) {
  const a = vE(), A = dt(() => ({}), []), l = Yse({
    // TODO: only enable when loaders has been initialized?
    structuralSharing: !1,
    placeholderData: A,
    // Include the hook name in the queryKey to prevent the case in which an identical queryKey
    // in a different hook would cause an accidental cache hit.
    // Note: same key structure/suffix as
    // useDataTypeMulti() and getQueryKeyScopeTuplesAux()
    // for shared caching.
    queryKey: [n, t, s, r, "useDataType"],
    // Query function should return an object
    // { data, dataKey } where dataKey is the loaded gene selection.
    queryFn: Xae,
    meta: { loaders: e, placeholderObject: A }
  }), { data: c, status: u, isFetching: f, error: h } = l, d = c?.data || A, I = c?.coordinationValues, m = c?.urls;
  Mn(() => {
    F8e(I, i, o);
  }, [I]), Mn(() => {
    h && gw(h, a);
  }, [h, a]);
  const C = f ? Ra.LOADING : u;
  return [d, C, m];
}
function hw(t, e, n, r, i, o, s, a, A) {
  const l = dt(() => ({}), []), c = vE(), u = s ? Object.entries(s) : [], f = pL({
    // eslint-disable-next-line no-unused-vars
    queries: u.map(([v, b]) => ({
      structuralSharing: !1,
      placeholderData: l,
      // Query key should match useDataType for shared cacheing
      // and correctness of dataQueryFn.
      // Note: same key structure/suffix as
      // useDataType() and getQueryKeyScopeTuplesAux()
      // for shared caching.
      queryKey: [n, t, b, r, "useDataType"],
      // Query function should return an object
      // { data, dataKey } where dataKey is the loaded gene selection.
      queryFn: Xae,
      meta: { loaders: e, placeholderObject: l }
    }))
  }), h = f.some((v) => v.isFetching), d = f.some((v) => v.isError), I = h ? Ra.LOADING : d ? Ra.ERROR : Ra.SUCCESS, m = I === Ra.SUCCESS;
  Mn(() => {
    f.filter((v) => !!v.data?.coordinationValues).forEach((v) => {
      const { coordinationValues: b } = v.data;
      a ? a(
        b,
        // Auto-generate based on the dataset and data type.
        P3e(n, t),
        A
      ) : F8e(b, i, o);
    });
  }, [m]), Mn(() => {
    f.map((v) => v.error).filter((v) => !!v).forEach((v) => {
      gw(v, c);
    });
  }, [d, c]);
  const C = dt(() => ji(u.map(([v], b) => [v, f[b].data?.data])), [s, I]), y = dt(() => ji(u.map(([v], b) => [v, f[b].data?.urls])), [f]);
  return [C, I, y];
}
function CF(t, e, n, r) {
  return zRt(t, e, n, r) !== null;
}
function fGt(t, e) {
  const [n, r] = mn();
  return Mn(() => {
    t[e] && (t[e].description ? r(t[e].description) : r(null));
  }, [t, e]), [n];
}
function gGt(t, e, n, r, i, o) {
  return a0(tn.OBS_EMBEDDING, t, e, n, r, i, o);
}
function WZ(t, e, n, r, i, o) {
  return a0(tn.OBS_LOCATIONS, t, e, n, r, i, o);
}
function hGt(t, e, n, r, i, o) {
  return a0(tn.OBS_LABELS, t, e, n, r, i, o);
}
function P8e(t, e, n, r, i, o) {
  return a0(tn.OBS_SEGMENTATIONS, t, e, n, r, i, o);
}
function VB(t, e, n, r, i, o) {
  return a0(tn.OBS_SETS, t, e, n, r, i, o);
}
function k8e(t, e, n, r, i, o) {
  return a0(tn.OBS_FEATURE_MATRIX, t, e, n, r, i, o);
}
function DL(t, e, n, r, i, o) {
  return a0(tn.FEATURE_LABELS, t, e, n, r, i, o);
}
function Zae(t, e, n, r, i, o) {
  return a0(tn.IMAGE, t, e, n, r, i, o);
}
function dGt(t, e, n, r, i, o) {
  return a0(tn.GENOMIC_PROFILES, t, e, n, r, i, o);
}
function pGt(t, e, n, r, i, o) {
  return a0(tn.NEIGHBORHOODS, t, e, n, r, i, o);
}
function bv(t, e, n, r, i) {
  const o = vE(), s = pL({
    queries: r?.map((h) => ({
      structuralSharing: !1,
      placeholderData: null,
      queryKey: [e, tn.OBS_FEATURE_MATRIX, i, h, "useFeatureSelection"],
      // Query function should return an object
      // { data, dataKey } where dataKey is the loaded gene selection.
      queryFn: async (d) => {
        const I = iw(d.meta.loaders, d.queryKey[0], d.queryKey[1], d.queryKey[2]);
        if (I) {
          if (typeof I.loadGeneSelection == "function") {
            const L = await I.loadGeneSelection({ selection: [h] });
            if (!L)
              return null;
            const { data: N } = L;
            return { data: N[0], dataKey: h };
          }
          const C = await I.load();
          if (!C)
            return null;
          const { data: y } = C, { obsIndex: v, featureIndex: b, obsFeatureMatrix: Q } = y, w = b.indexOf(h), R = b.length, M = v.length, O = new Float32Array(M);
          for (let L = 0; L < M; L += 1)
            O[L] = Q.data[L * R + w];
          return { data: O, dataKey: h };
        }
        if (n)
          throw new RL(t, e, tn.OBS_FEATURE_MATRIX, i);
        return { data: null, dataKey: null };
      },
      meta: { loaders: t }
    })) || []
  }), a = s.some((h) => h.isFetching), A = s.some((h) => h.isError), l = a ? Ra.LOADING : A ? Ra.ERROR : Ra.SUCCESS, c = l === Ra.SUCCESS, u = c ? s.map((h) => h.data?.data || null) : null, f = c ? s.map((h) => h.data?.dataKey || null) : null;
  return Mn(() => {
    s.map((h) => h.error).filter((h) => !!h).forEach((h) => {
      gw(h, o);
    });
  }, [A, o]), [u, f, l];
}
function TL(t, e, n, r) {
  const i = vE(), o = dt(() => ({}), []), s = Yse({
    // TODO: only enable once `loaders` is available?
    structuralSharing: !1,
    placeholderData: o,
    // Include the hook name in the queryKey to prevent the case in which an identical queryKey
    // in a different hook would cause an accidental cache hit.
    // Note: this uses the same key structure/suffix as
    // getMatrixIndicesQueryKeyScopeTuplesAux for shared caching.
    queryKey: [e, tn.OBS_FEATURE_MATRIX, r, n, "useObsFeatureMatrixIndices"],
    // Query function should return an object
    // { data, dataKey } where dataKey is the loaded gene selection.
    // TODO: use TypeScript to type the return value?
    queryFn: async (d) => {
      const I = iw(d.meta.loaders, d.queryKey[0], d.queryKey[1], d.queryKey[2]);
      if (I) {
        if (typeof I.loadAttrs == "function") {
          const b = await I.loadAttrs();
          if (!b)
            return o;
          const { data: Q, url: w } = b;
          return {
            data: {
              obsIndex: Q.rows,
              featureIndex: Q.cols
            },
            urls: w ? [{ url: w, name: tn.OBS_FEATURE_MATRIX }] : null
          };
        }
        const C = await I.load();
        if (!C)
          return o;
        const { data: y, url: v } = C;
        return {
          data: {
            obsIndex: y.obsIndex,
            featureIndex: y.featureIndex
          },
          urls: [{ url: v, name: tn.OBS_FEATURE_MATRIX }]
        };
      }
      if (n)
        throw new RL(t, e, tn.OBS_FEATURE_MATRIX, r);
      return { data: o, dataKey: null };
    },
    meta: { loaders: t }
  }), { data: a, status: A, isFetching: l, error: c } = s, u = a?.data || o, f = l ? Ra.LOADING : A, h = a?.urls;
  return Mn(() => {
    c && i(c.message);
  }, [c, i]), [u, f, h];
}
function G8e(t, e, n, r, i, o) {
  const s = TA([
    re.OBS_TYPE
  ], t, e, re.POINT_LAYER), a = dt(
    () => s[0],
    // imageCoordination reference changes each render,
    // use coordinationScopes and coordinationScopesBy which are
    // indirect dependencies here.
    [t, e]
  ), [A, l, c] = hw(tn.OBS_POINTS, n, r, !1, {}, {}, a, i, o);
  return [A, l, c];
}
function U8e(t, e, n, r, i, o) {
  const s = TA([
    re.OBS_TYPE
  ], t, e, re.SPOT_LAYER), a = dt(
    () => s[0],
    // imageCoordination reference changes each render,
    // use coordinationScopes and coordinationScopesBy which are
    // indirect dependencies here.
    [t, e]
  ), [A, l, c] = hw(tn.OBS_SPOTS, n, r, !1, {}, {}, a, i, o);
  return [A, l, c];
}
function IGt(t, e, n, r) {
  const i = TA([
    re.OBS_TYPE
  ], t, e, re.SPOT_LAYER), o = dt(
    () => i[0],
    // imageCoordination reference changes each render,
    // use coordinationScopes and coordinationScopesBy which are
    // indirect dependencies here.
    [t, e]
  ), [s, a, A] = hw(tn.OBS_SETS, n, r, !1, {}, {}, o);
  return [s, a, A];
}
function eAe(t, e, n, r) {
  const i = qRt(re.OBS_LABELS_TYPE, t), o = dt(() => ji(Object.entries(i).map(([l, c]) => [
    l,
    { obsLabelsType: c, obsType: e }
  ])), [i, e]), [s, a, A] = hw(tn.OBS_LABELS, n, r, !1, {}, {}, o);
  return [i, s, a, A];
}
function H8e(t, e, n, r, i, o) {
  const s = TA([
    re.FILE_UID
  ], t, e, re.SEGMENTATION_LAYER), a = dt(
    () => s[0],
    // imageCoordination reference changes each render,
    // use coordinationScopes and coordinationScopesBy which are
    // indirect dependencies here.
    [t, e]
  ), [A, l, c] = hw(tn.OBS_SEGMENTATIONS, n, r, !1, {}, {}, a, i, o);
  return [A, l, c];
}
function $8e(t, e, n, r, i, o) {
  const s = TA([
    re.FILE_UID
  ], t, e, re.IMAGE_LAYER), a = dt(
    () => s[0],
    // imageCoordination reference changes each render,
    // use coordinationScopes and coordinationScopesBy which are
    // indirect dependencies here.
    [t, e]
  ), [A, l, c] = hw(tn.IMAGE, n, r, !1, {}, {}, a, i, o);
  return [A, l, c];
}
function q8e(t, e, n, r, i, o, s, a, A) {
  return n === 0 ? a?.map((l, c) => [
    // queryKey:
    // TODO: use same key suffix as useFeatureSelection for shared caching?
    [r, i, A, l, o, "useFeatureSelectionMultiLevel"],
    // scope info (for rolling up later)
    { levelScopes: s, featureIndex: c, numFeatures: a.length }
  ]) || [] : Object.entries(a)?.flatMap(([l, c]) => q8e(t, e, n - 1, r, i, o, [...s, l], c, A?.[l])) || [];
}
function mGt(t, e, n, r, i, o) {
  return q8e(t, e, n, r, i, o, [], t, e);
}
function j8e(t, e, n, r, i, o, s) {
  return e === 0 ? [[
    // queryKey:
    // Note: this uses the same key structure/suffix as
    // useObsFeatureMatrixIndices for shared caching.
    [n, r, s, i, "useObsFeatureMatrixIndices"],
    // scope info (for rolling up later)
    { levelScopes: o }
  ]] : Object.entries(s)?.flatMap(([a, A]) => j8e(t, e - 1, n, r, i, [...o, a], A)) || [];
}
function CGt(t, e, n, r, i) {
  return j8e(t, e, n, r, i, [], t);
}
function Y8e(t, e, n, r, i, o, s) {
  return e === 0 ? [[
    // queryKey:
    // Note: same key structure/suffix as
    // useDataType() and useDataTypeMulti()
    // for shared caching.
    [n, r, s, i, "useDataType"],
    // scope info (for rolling up later)
    { levelScopes: o }
  ]] : Object.entries(s)?.flatMap(([a, A]) => Y8e(t, e - 1, n, r, i, [...o, a], A)) || [];
}
function EGt(t, e, n, r, i) {
  return Y8e(t, e, n, r, i, [], t);
}
function z8e(t, e, n, r) {
  const i = t[r], o = t.length - r;
  return o === 0 ? e : (e[i] || (o === 1 ? e[i] = n() : e[i] = {}), z8e(t, e[i], n, r + 1));
}
function V8e(t, e, n) {
  return z8e(t, e, n, 0);
}
function EF(t, e) {
  const n = {};
  return t.forEach(([r, { levelScopes: i, featureIndex: o, numFeatures: s }], a) => {
    const l = V8e(i, n, () => new Array(s));
    l[o] = e?.[a];
  }), n;
}
function J8e(t, e) {
  const n = {};
  return t.forEach(([r, { levelScopes: i }], o) => {
    const a = V8e(i, n, () => ({}));
    Object.entries(e?.[o] || {}).forEach(([A, l]) => {
      a[A] = l;
    });
  }), n;
}
async function yGt(t) {
  const { loaders: e } = t.meta, [n, r, i, o, s] = t.queryKey, a = iw(e, n, r, i);
  if (a) {
    if (typeof a.loadGeneSelection == "function") {
      const R = await a.loadGeneSelection({ selection: [o] });
      if (!R)
        return null;
      const { data: M } = R, O = M[0], L = fa(O), [N, k] = L, $ = 255 / (k - N), U = new Uint8Array(O.map((X) => Math.floor((X - N) * $)));
      return {
        data: O,
        normData: U,
        dataExtent: L,
        dataKey: o
      };
    }
    const l = await a.load();
    if (!l)
      return null;
    const { data: c } = l, { obsIndex: u, featureIndex: f, obsFeatureMatrix: h } = c, d = f.indexOf(o), I = f.length, m = u.length, C = new Float32Array(m);
    for (let R = 0; R < m; R += 1)
      C[R] = h.data[R * I + d];
    const y = fa(C), [v, b] = y, Q = 255 / (b - v), w = new Uint8Array(C.map((R) => Math.floor((R - v) * Q)));
    return {
      data: C,
      normData: w,
      dataExtent: y,
      dataKey: o
    };
  }
  if (s)
    throw new RL(e, n, r, i);
  return { data: null, dataKey: null };
}
function K8e(t, e, n, r, i, o) {
  const s = vE(), a = dt(() => mGt(i, r, o, e, tn.OBS_FEATURE_MATRIX, n), [i, r, o, e]), A = pL({
    queries: a.map(([b]) => ({
      structuralSharing: !1,
      placeholderData: null,
      queryKey: b,
      queryFn: yGt,
      meta: { loaders: t }
    }))
  }), l = A.some((b) => b.isFetching), c = A.some((b) => b.isError), u = l ? Ra.LOADING : c ? Ra.ERROR : Ra.SUCCESS, f = A.map((b) => b.data?.data || null), h = A.map((b) => b.data?.dataKey || null), d = A.map((b) => b.data?.dataExtent || null), I = A.map((b) => b.data?.normData || null);
  Mn(() => {
    A.map((b) => b.error).filter((b) => !!b).forEach((b) => {
      gw(b, s);
    });
  }, [c, s]);
  const [m, C, y, v] = dt(() => {
    const b = EF(a, f), Q = EF(a, h), w = EF(a, d), R = EF(a, I);
    return [b, Q, w, R];
  }, [A.reduce((b, Q) => b + Q.dataUpdatedAt, 0), a]);
  return [m, C, y, v, u];
}
async function vGt(t) {
  const { loaders: e } = t.meta, [n, r, i, o] = t.queryKey, s = iw(e, n, r, i);
  if (s) {
    if (typeof s.loadAttrs == "function") {
      const c = await s.loadAttrs();
      if (!c)
        return null;
      const { data: u } = c;
      return {
        data: {
          obsIndex: u.rows,
          featureIndex: u.cols
        }
      };
    }
    const A = await s.load();
    if (!A)
      return null;
    const { data: l } = A;
    return {
      data: {
        obsIndex: l.obsIndex,
        featureIndex: l.featureIndex
      }
    };
  }
  if (o)
    throw new RL(e, n, r, i);
  return { data: null, dataKey: null };
}
function W8e(t, e, n, r, i) {
  const o = vE(), s = dt(() => CGt(r, i, e, tn.OBS_FEATURE_MATRIX, n), [r, i, e]), a = pL({
    queries: s.map(([h]) => ({
      structuralSharing: !1,
      placeholderData: null,
      queryKey: h,
      queryFn: vGt,
      meta: { loaders: t }
    }))
  }), A = a.some((h) => h.isFetching), l = a.some((h) => h.isError), c = A ? Ra.LOADING : l ? Ra.ERROR : Ra.SUCCESS, u = a.map((h) => h.data?.data || null);
  return Mn(() => {
    a.map((h) => h.error).filter((h) => !!h).forEach((h) => {
      gw(h, o);
    });
  }, [l, o]), [dt(() => J8e(s, u), [a.reduce((h, d) => h + d.dataUpdatedAt, 0), s]), c];
}
function tAe(t, e, n, r, i, o) {
  const s = vE(), a = dt(() => EGt(r, i, e, o, n), [r, i, e]), A = pL({
    queries: a.map(([d]) => ({
      structuralSharing: !1,
      placeholderData: null,
      queryKey: d,
      queryFn: Xae,
      meta: { loaders: t }
    }))
  }), l = A.some((d) => d.isFetching), c = A.some((d) => d.isError), u = l ? Ra.LOADING : c ? Ra.ERROR : Ra.SUCCESS, f = A.map((d) => d.data?.data || null);
  return Mn(() => {
    A.map((d) => d.error).filter((d) => !!d).forEach((d) => {
      gw(d, s);
    });
  }, [c, s]), [dt(() => J8e(a, f), [A.reduce((d, I) => d + I.dataUpdatedAt, 0), a]), u];
}
function BGt(t, e, n, r, i) {
  return tAe(t, e, n, r, i, tn.OBS_LOCATIONS);
}
function bGt(t, e, n, r, i) {
  return tAe(t, e, n, r, i, tn.OBS_SETS);
}
function _Gt(t, e, n, r, i) {
  return tAe(t, e, n, r, i, tn.OBS_LABELS);
}
function SGt(t, e, n, r) {
  const i = wI([
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE
  ], t, e, re.SEGMENTATION_LAYER, re.SEGMENTATION_CHANNEL), o = wI([
    re.FEATURE_SELECTION
  ], t, e, re.SEGMENTATION_LAYER, re.SEGMENTATION_CHANNEL), s = dt(
    () => i[0],
    // imageCoordination reference changes each render,
    // use coordinationScopes and coordinationScopesBy which are
    // indirect dependencies here.
    [t, e]
  ), a = Object.values(o[0] || {}).flatMap((d) => Object.values(d).map((I) => I.featureSelection)), A = dt(
    () => ji(Object.entries(o[0]).map(([d, I]) => [
      d,
      ji(Object.entries(I).map(([m, C]) => [m, C.featureSelection]))
    ])),
    // Need to execute this more frequently, whenever the featureSelections update.
    [
      t,
      e,
      // We need to ensure there are always the same number of
      // entries in the full dependency array.
      JSON.stringify(a.length > 0 ? a : [null])
    ]
  ), [l, c, u, f, h] = K8e(n, r, !1, s, A, 2);
  return [l, c, u, f, h];
}
function QGt(t, e, n, r) {
  const i = TA([
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE
  ], t, e, re.SPOT_LAYER), o = TA([
    re.FEATURE_SELECTION
  ], t, e, re.SPOT_LAYER), s = dt(
    () => i[0],
    // imageCoordination reference changes each render,
    // use coordinationScopes and coordinationScopesBy which are
    // indirect dependencies here.
    [t, e]
  ), a = dt(
    () => ji(Object.entries(o[0]).map(([h, d]) => [
      h,
      d.featureSelection
    ])),
    // Need to execute this more frequently, whenever the featureSelections update.
    [
      t,
      e,
      ...Object.values(o[0] || {}).flatMap((h) => h.featureSelection)
    ]
  ), [A, l, c, u, f] = K8e(n, r, !1, s, a, 1);
  return [A, l, c, u, f];
}
function wGt(t, e, n, r) {
  const i = wI([
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE
  ], t, e, re.SEGMENTATION_LAYER, re.SEGMENTATION_CHANNEL), o = dt(
    () => i[0],
    // imageCoordination reference changes each render,
    // use coordinationScopes and coordinationScopesBy which are
    // indirect dependencies here.
    [t, e]
  ), [s, a] = W8e(n, r, !1, o, 2);
  return [s, a];
}
function xGt(t, e, n, r) {
  const i = TA([
    re.OBS_TYPE,
    re.FEATURE_TYPE,
    re.FEATURE_VALUE_TYPE
  ], t, e, re.SPOT_LAYER), o = dt(
    () => i[0],
    // imageCoordination reference changes each render,
    // use coordinationScopes and coordinationScopesBy which are
    // indirect dependencies here.
    [t, e]
  ), [s, a] = W8e(n, r, !1, o, 1);
  return [s, a];
}
function RGt(t, e, n, r) {
  const i = TA([
    re.OBS_TYPE,
    re.OBS_LABELS_TYPE
  ], t, e, re.POINT_LAYER), o = dt(
    () => i[0],
    // imageCoordination reference changes each render,
    // use coordinationScopes and coordinationScopesBy which are
    // indirect dependencies here.
    [t, e]
  ), [s, a] = _Gt(n, r, !1, o, 1);
  return [s, a];
}
function DGt(t, e, n, r) {
  const i = wI([
    re.OBS_TYPE
  ], t, e, re.SEGMENTATION_LAYER, re.SEGMENTATION_CHANNEL), o = dt(
    () => i[0],
    // imageCoordination reference changes each render,
    // use coordinationScopes and coordinationScopesBy which are
    // indirect dependencies here.
    [t, e]
  ), [s, a] = BGt(n, r, !1, o, 2);
  return [s, a];
}
function TGt(t, e, n, r) {
  const i = wI([
    re.OBS_TYPE
  ], t, e, re.SEGMENTATION_LAYER, re.SEGMENTATION_CHANNEL), o = dt(
    () => i[0],
    // imageCoordination reference changes each render,
    // use coordinationScopes and coordinationScopesBy which are
    // indirect dependencies here.
    [t, e]
  ), [s, a] = bGt(n, r, !1, o, 2);
  return [s, a];
}
class NGt {
  constructor({ type: e, fileType: n, url: r, requestInit: i, options: o, coordinationValues: s }) {
    this.fileType = n, this.type = e, this.url = r, this.requestInit = i, this.options = o, this.coordinationValues = s;
  }
  // eslint-disable-next-line class-methods-use-this
  load() {
    return Promise.resolve(!0);
  }
}
class gc extends NGt {
  constructor(e, n) {
    super(n), this.dataSource = e;
  }
}
class Si {
  /**
   * @param {*} data
   * @param {object[]|string|null} url Single URL or array of { url, name } objects.
   * @param {object} coordinationValues
   */
  constructor(e, n, r = null) {
    this.data = e, this.url = n, this.coordinationValues = r;
  }
}
const oU = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, X8e = /* @__PURE__ */ St.createContext(oU), LGt = /* @__PURE__ */ St.createContext(!1);
let MGt = !!(typeof window < "u" && window.document && window.document.createElement), o7 = /* @__PURE__ */ new WeakMap();
function OGt(t = !1) {
  let e = tT(X8e), n = Zr(null);
  if (n.current === null && !t) {
    var r, i;
    let o = (r = St.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || r === void 0 || (i = r.ReactCurrentOwner) === null || i === void 0 ? void 0 : i.current;
    if (o) {
      let s = o7.get(o);
      s == null ? o7.set(o, {
        id: e.current,
        state: o.memoizedState
      }) : o.memoizedState !== s.state && (e.current = s.id, o7.delete(o));
    }
    n.current = ++e.current;
  }
  return n.current;
}
function FGt(t) {
  let e = tT(X8e);
  e === oU && !MGt && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = OGt(!!t), r = `react-aria${e.prefix}`;
  return t || `${r}-${n}`;
}
function PGt(t) {
  let e = St.useId(), [n] = mn($Gt()), r = n ? "react-aria" : `react-aria${oU.prefix}`;
  return t || `${r}-${e}`;
}
const kGt = typeof St.useId == "function" ? PGt : FGt;
function GGt() {
  return !1;
}
function UGt() {
  return !0;
}
function HGt(t) {
  return () => {
  };
}
function $Gt() {
  return typeof St.useSyncExternalStore == "function" ? St.useSyncExternalStore(HGt, GGt, UGt) : tT(LGt);
}
const qGt = typeof document < "u" ? St.useLayoutEffect : () => {
};
let Eve = /* @__PURE__ */ new Map();
function Jr(t) {
  let [e, n] = mn(t), r = Zr(null), i = kGt(e), o = Qn((s) => {
    r.current = s;
  }, []);
  return Eve.set(i, o), qGt(() => {
    let s = i;
    return () => {
      Eve.delete(s);
    };
  }, [
    i
  ]), Mn(() => {
    let s = r.current;
    s && (r.current = null, n(s));
  }), i;
}
let Vx = /* @__PURE__ */ new Map(), yve = /* @__PURE__ */ new Set();
function vve() {
  if (typeof window > "u")
    return;
  let t = (n) => {
    let r = Vx.get(n.target);
    r || (r = /* @__PURE__ */ new Set(), Vx.set(n.target, r), n.target.addEventListener("transitioncancel", e)), r.add(n.propertyName);
  }, e = (n) => {
    let r = Vx.get(n.target);
    if (r && (r.delete(n.propertyName), r.size === 0 && (n.target.removeEventListener("transitioncancel", e), Vx.delete(n.target)), Vx.size === 0)) {
      for (let i of yve)
        i();
      yve.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", e);
}
typeof document < "u" && (document.readyState !== "loading" ? vve() : document.addEventListener("DOMContentLoaded", vve));
const VI = kr((t) => ({
  box: {
    boxSizing: "border-box"
  },
  checkbox: {
    padding: "3px",
    color: t.palette.primaryForeground,
    "&:checked": {
      color: t.palette.primaryForeground
    },
    "& input": {
      height: "100%"
    }
  },
  slider: {
    color: t.palette.primaryForeground,
    minWidth: "60px",
    padding: "10px 0 10px 0"
  },
  sliderValueLabel: {
    "& span": {
      "& span": {
        color: t.palette.primaryBackground
      }
    }
  },
  tableContainer: {
    overflow: "hidden",
    overflowX: "hidden !important"
  },
  labelCell: {
    padding: "2px 8px 2px 16px"
  },
  inputCell: {
    padding: "2px 16px 2px 8px",
    overflow: "visible"
  },
  select: {
    "& select": {
      fontSize: "14px"
    }
  },
  optionSelectRoot: {
    padding: 0,
    height: "auto"
  }
}));
function nd(t) {
  const { classes: e = {} } = t, n = VI();
  return ne.jsx(il, { native: !0, disableUnderline: !0, ...t, classes: {
    root: n.optionSelectRoot,
    ...e
  }, "aria-label": "Select an option" });
}
function Z8e(t) {
  const { observationsLabel: e, cellColorEncoding: n, setCellColorEncoding: r } = t, i = VI(), o = Jr(), s = Ci(e);
  function a(A) {
    r(A.target.value);
  }
  return ne.jsxs(Ko, { children: [ne.jsx(br, { className: i.labelCell, variant: "head", scope: "row", children: ne.jsxs("label", { htmlFor: `cell-color-encoding-select-${o}`, children: [s, " Color Encoding"] }) }), ne.jsx(br, { className: i.inputCell, variant: "body", children: ne.jsxs(nd, { className: i.select, value: n, onChange: a, inputProps: {
    id: `cell-color-encoding-select-${o}`
  }, children: [ne.jsx("option", { value: "cellSetSelection", children: "Cell Sets" }), ne.jsx("option", { value: "geneSelection", children: "Gene Expression" })] }) })] });
}
function NL(t) {
  const { children: e } = t, n = VI();
  return ne.jsx(j0t, { className: n.box, children: ne.jsx(tEt, { className: n.tableContainer, children: ne.jsx(jCt, { className: n.table, size: "small", "aria-label": "Menu of options available for the view", children: ne.jsx(KCt, { children: e }) }) }) });
}
class jGt {
  constructor(e, n, r) {
    Sr(this, "name");
    Sr(this, "component");
    Sr(this, "coordinationTypes");
    this.name = e, this.component = n, this.coordinationTypes = r;
  }
}
class YGt {
  constructor(e, n, r, i, o) {
    Sr(this, "name");
    Sr(this, "dataType");
    Sr(this, "dataLoaderClass");
    Sr(this, "dataSourceClass");
    Sr(this, "optionsSchema");
    this.name = e, this.dataType = n, this.dataLoaderClass = r, this.dataSourceClass = i, this.optionsSchema = o;
  }
  getSourceAndLoader() {
    return [this.dataSourceClass, this.dataLoaderClass];
  }
}
class sf {
  constructor(e, n, r) {
    Sr(this, "name");
    Sr(this, "expandFunction");
    Sr(this, "optionsSchema");
    this.name = e, this.expandFunction = n, this.optionsSchema = r;
  }
}
class Jt {
  constructor(e, n, r) {
    Sr(this, "name");
    Sr(this, "defaultValue");
    Sr(this, "valueSchema");
    this.name = e, this.defaultValue = n, this.valueSchema = r;
  }
}
const zGt = kr((t) => ({
  description: {
    "& p, details, table": {
      fontSize: "80%",
      opacity: "0.8"
    },
    "& details": {
      marginBottom: "6px"
    },
    "& summary": {
      // TODO(monorepo): lighten color by 10%
      borderBottom: `1px solid ${t.palette.primaryBackground}`,
      cursor: "pointer"
    }
  },
  metadataContainer: {
    paddingLeft: "14px",
    "& table": {
      width: "100%",
      "& td, th": {
        outline: "none",
        padding: "2px 2px",
        maxWidth: "0",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "50%"
      },
      "& tr:nth-child(even)": {
        // TODO(monorepo): lighten color by 5%
        backgroundColor: `1px solid ${t.palette.primaryBackground}`
      }
    }
  }
}));
function VGt(t) {
  const { description: e, metadata: n } = t, r = zGt();
  return ne.jsxs("div", { className: r.description, children: [ne.jsx("p", { children: e }), n && Array.from(n.entries()).map(([i, { name: o, metadata: s }]) => s && Object.entries(s).length > 0 ? ne.jsxs("details", { children: [ne.jsx("summary", { children: o }), ne.jsx("div", { className: r.metadataContainer, children: ne.jsx("table", { children: ne.jsx("tbody", { children: Object.entries(s).map(([a, A]) => ne.jsxs("tr", { children: [ne.jsx("th", { title: a, children: a }), ne.jsx("td", { title: A, children: A })] }, a)) }) }) })] }, i) : null)] });
}
function JGt(t) {
  const { coordinationScopes: e, description: n, removeGridComponent: r, theme: i, title: o = "Description", closeButtonVisible: s } = t, a = eu(), [{ dataset: A, spatialImageLayer: l }] = uc(ea[Gn.DESCRIPTION], e), [c] = fGt(a, A), [{ image: u }, f] = Zae(a, A, !1, {}, {}, {}), { loaders: h = [], meta: d = [] } = u || {}, I = Jc([f]), m = dt(() => {
    const C = /* @__PURE__ */ new Map();
    return l && l.length > 0 && d && h && l.forEach((y) => {
      if (d[y.index]) {
        const { format: v } = h[y.index].metadata;
        C.set(`${y.index}`, {
          name: d[y.index].name,
          metadata: v && v()
        });
      }
    }), C;
  }, [l, d, h]);
  return ne.jsx(fc, { title: o, closeButtonVisible: s, removeGridComponent: r, isScroll: !0, theme: i, isReady: I, children: ne.jsx(VGt, { description: n || c, metadata: m }) });
}
var Ml = 63710088e-1, nAe = {
  centimeters: Ml * 100,
  centimetres: Ml * 100,
  degrees: Ml / 111325,
  feet: Ml * 3.28084,
  inches: Ml * 39.37,
  kilometers: Ml / 1e3,
  kilometres: Ml / 1e3,
  meters: Ml,
  metres: Ml,
  miles: Ml / 1609.344,
  millimeters: Ml * 1e3,
  millimetres: Ml * 1e3,
  nauticalmiles: Ml / 1852,
  radians: 1,
  yards: Ml * 1.0936
}, KGt = {
  centimeters: 100,
  centimetres: 100,
  degrees: 1 / 111325,
  feet: 3.28084,
  inches: 39.37,
  kilometers: 1 / 1e3,
  kilometres: 1 / 1e3,
  meters: 1,
  metres: 1,
  miles: 1 / 1609.344,
  millimeters: 1e3,
  millimetres: 1e3,
  nauticalmiles: 1 / 1852,
  radians: 1 / Ml,
  yards: 1.0936133
}, XZ = {
  acres: 247105e-9,
  centimeters: 1e4,
  centimetres: 1e4,
  feet: 10.763910417,
  hectares: 1e-4,
  inches: 1550.003100006,
  kilometers: 1e-6,
  kilometres: 1e-6,
  meters: 1,
  metres: 1,
  miles: 386e-9,
  millimeters: 1e6,
  millimetres: 1e6,
  yards: 1.195990046
};
function Gg(t, e, n) {
  n === void 0 && (n = {});
  var r = { type: "Feature" };
  return (n.id === 0 || n.id) && (r.id = n.id), n.bbox && (r.bbox = n.bbox), r.properties = e || {}, r.geometry = t, r;
}
function WGt(t, e, n) {
  switch (t) {
    case "Point":
      return jl(e).geometry;
    case "LineString":
      return bg(e).geometry;
    case "Polygon":
      return ST(e).geometry;
    case "MultiPoint":
      return t5e(e).geometry;
    case "MultiLineString":
      return e5e(e).geometry;
    case "MultiPolygon":
      return n5e(e).geometry;
    default:
      throw new Error(t + " is invalid");
  }
}
function jl(t, e, n) {
  if (n === void 0 && (n = {}), !t)
    throw new Error("coordinates is required");
  if (!Array.isArray(t))
    throw new Error("coordinates must be an Array");
  if (t.length < 2)
    throw new Error("coordinates must be at least 2 numbers long");
  if (!NS(t[0]) || !NS(t[1]))
    throw new Error("coordinates must contain numbers");
  var r = {
    type: "Point",
    coordinates: t
  };
  return Gg(r, e, n);
}
function XGt(t, e, n) {
  return n === void 0 && (n = {}), xI(t.map(function(r) {
    return jl(r, e);
  }), n);
}
function ST(t, e, n) {
  n === void 0 && (n = {});
  for (var r = 0, i = t; r < i.length; r++) {
    var o = i[r];
    if (o.length < 4)
      throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
    for (var s = 0; s < o[o.length - 1].length; s++)
      if (o[o.length - 1][s] !== o[0][s])
        throw new Error("First and last Position are not equivalent.");
  }
  var a = {
    type: "Polygon",
    coordinates: t
  };
  return Gg(a, e, n);
}
function ZGt(t, e, n) {
  return n === void 0 && (n = {}), xI(t.map(function(r) {
    return ST(r, e);
  }), n);
}
function bg(t, e, n) {
  if (n === void 0 && (n = {}), t.length < 2)
    throw new Error("coordinates must be an array of two or more positions");
  var r = {
    type: "LineString",
    coordinates: t
  };
  return Gg(r, e, n);
}
function e4t(t, e, n) {
  return n === void 0 && (n = {}), xI(t.map(function(r) {
    return bg(r, e);
  }), n);
}
function xI(t, e) {
  e === void 0 && (e = {});
  var n = { type: "FeatureCollection" };
  return e.id && (n.id = e.id), e.bbox && (n.bbox = e.bbox), n.features = t, n;
}
function e5e(t, e, n) {
  n === void 0 && (n = {});
  var r = {
    type: "MultiLineString",
    coordinates: t
  };
  return Gg(r, e, n);
}
function t5e(t, e, n) {
  n === void 0 && (n = {});
  var r = {
    type: "MultiPoint",
    coordinates: t
  };
  return Gg(r, e, n);
}
function n5e(t, e, n) {
  n === void 0 && (n = {});
  var r = {
    type: "MultiPolygon",
    coordinates: t
  };
  return Gg(r, e, n);
}
function t4t(t, e, n) {
  n === void 0 && (n = {});
  var r = {
    type: "GeometryCollection",
    geometries: t
  };
  return Gg(r, e, n);
}
function n4t(t, e) {
  if (e === void 0 && (e = 0), e && !(e >= 0))
    throw new Error("precision must be a positive number");
  var n = Math.pow(10, e || 0);
  return Math.round(t * n) / n;
}
function r5e(t, e) {
  e === void 0 && (e = "kilometers");
  var n = nAe[e];
  if (!n)
    throw new Error(e + " units is invalid");
  return t * n;
}
function rAe(t, e) {
  e === void 0 && (e = "kilometers");
  var n = nAe[e];
  if (!n)
    throw new Error(e + " units is invalid");
  return t / n;
}
function r4t(t, e) {
  return i5e(rAe(t, e));
}
function i4t(t) {
  var e = t % 360;
  return e < 0 && (e += 360), e;
}
function i5e(t) {
  var e = t % (2 * Math.PI);
  return e * 180 / Math.PI;
}
function o4t(t) {
  var e = t % 360;
  return e * Math.PI / 180;
}
function s4t(t, e, n) {
  if (e === void 0 && (e = "kilometers"), n === void 0 && (n = "kilometers"), !(t >= 0))
    throw new Error("length must be a positive number");
  return r5e(rAe(t, e), n);
}
function a4t(t, e, n) {
  if (e === void 0 && (e = "meters"), n === void 0 && (n = "kilometers"), !(t >= 0))
    throw new Error("area must be a positive number");
  var r = XZ[e];
  if (!r)
    throw new Error("invalid original units");
  var i = XZ[n];
  if (!i)
    throw new Error("invalid final units");
  return t / r * i;
}
function NS(t) {
  return !isNaN(t) && t !== null && !Array.isArray(t);
}
function I9(t) {
  return !!t && t.constructor === Object;
}
function A4t(t) {
  if (!t)
    throw new Error("bbox is required");
  if (!Array.isArray(t))
    throw new Error("bbox must be an Array");
  if (t.length !== 4 && t.length !== 6)
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  t.forEach(function(e) {
    if (!NS(e))
      throw new Error("bbox must only contain numbers");
  });
}
function l4t(t) {
  if (!t)
    throw new Error("id is required");
  if (["string", "number"].indexOf(typeof t) === -1)
    throw new Error("id must be a number or a string");
}
const c4t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  areaFactors: XZ,
  bearingToAzimuth: i4t,
  convertArea: a4t,
  convertLength: s4t,
  degreesToRadians: o4t,
  earthRadius: Ml,
  factors: nAe,
  feature: Gg,
  featureCollection: xI,
  geometry: WGt,
  geometryCollection: t4t,
  isNumber: NS,
  isObject: I9,
  lengthToDegrees: r4t,
  lengthToRadians: rAe,
  lineString: bg,
  lineStrings: e4t,
  multiLineString: e5e,
  multiPoint: t5e,
  multiPolygon: n5e,
  point: jl,
  points: XGt,
  polygon: ST,
  polygons: ZGt,
  radiansToDegrees: i5e,
  radiansToLength: r5e,
  round: n4t,
  unitsFactors: KGt,
  validateBBox: A4t,
  validateId: l4t
}, Symbol.toStringTag, { value: "Module" }));
function JB(t, e, n) {
  if (t !== null)
    for (var r, i, o, s, a, A, l, c = 0, u = 0, f, h = t.type, d = h === "FeatureCollection", I = h === "Feature", m = d ? t.features.length : 1, C = 0; C < m; C++) {
      l = d ? t.features[C].geometry : I ? t.geometry : t, f = l ? l.type === "GeometryCollection" : !1, a = f ? l.geometries.length : 1;
      for (var y = 0; y < a; y++) {
        var v = 0, b = 0;
        if (s = f ? l.geometries[y] : l, s !== null) {
          A = s.coordinates;
          var Q = s.type;
          switch (c = n && (Q === "Polygon" || Q === "MultiPolygon") ? 1 : 0, Q) {
            case null:
              break;
            case "Point":
              if (e(
                A,
                u,
                C,
                v,
                b
              ) === !1)
                return !1;
              u++, v++;
              break;
            case "LineString":
            case "MultiPoint":
              for (r = 0; r < A.length; r++) {
                if (e(
                  A[r],
                  u,
                  C,
                  v,
                  b
                ) === !1)
                  return !1;
                u++, Q === "MultiPoint" && v++;
              }
              Q === "LineString" && v++;
              break;
            case "Polygon":
            case "MultiLineString":
              for (r = 0; r < A.length; r++) {
                for (i = 0; i < A[r].length - c; i++) {
                  if (e(
                    A[r][i],
                    u,
                    C,
                    v,
                    b
                  ) === !1)
                    return !1;
                  u++;
                }
                Q === "MultiLineString" && v++, Q === "Polygon" && b++;
              }
              Q === "Polygon" && v++;
              break;
            case "MultiPolygon":
              for (r = 0; r < A.length; r++) {
                for (b = 0, i = 0; i < A[r].length; i++) {
                  for (o = 0; o < A[r][i].length - c; o++) {
                    if (e(
                      A[r][i][o],
                      u,
                      C,
                      v,
                      b
                    ) === !1)
                      return !1;
                    u++;
                  }
                  b++;
                }
                v++;
              }
              break;
            case "GeometryCollection":
              for (r = 0; r < s.geometries.length; r++)
                if (JB(s.geometries[r], e, n) === !1)
                  return !1;
              break;
            default:
              throw new Error("Unknown Geometry Type");
          }
        }
      }
    }
}
function u4t(t, e, n, r) {
  var i = n;
  return JB(
    t,
    function(o, s, a, A, l) {
      s === 0 && n === void 0 ? i = o : i = e(
        i,
        o,
        s,
        a,
        A,
        l
      );
    },
    r
  ), i;
}
function o5e(t, e) {
  var n;
  switch (t.type) {
    case "FeatureCollection":
      for (n = 0; n < t.features.length && e(t.features[n].properties, n) !== !1; n++)
        ;
      break;
    case "Feature":
      e(t.properties, 0);
      break;
  }
}
function f4t(t, e, n) {
  var r = n;
  return o5e(t, function(i, o) {
    o === 0 && n === void 0 ? r = i : r = e(r, i, o);
  }), r;
}
function QT(t, e) {
  if (t.type === "Feature")
    e(t, 0);
  else if (t.type === "FeatureCollection")
    for (var n = 0; n < t.features.length && e(t.features[n], n) !== !1; n++)
      ;
}
function g4t(t, e, n) {
  var r = n;
  return QT(t, function(i, o) {
    o === 0 && n === void 0 ? r = i : r = e(r, i, o);
  }), r;
}
function h4t(t) {
  var e = [];
  return JB(t, function(n) {
    e.push(n);
  }), e;
}
function iAe(t, e) {
  var n, r, i, o, s, a, A, l, c, u, f = 0, h = t.type === "FeatureCollection", d = t.type === "Feature", I = h ? t.features.length : 1;
  for (n = 0; n < I; n++) {
    for (a = h ? t.features[n].geometry : d ? t.geometry : t, l = h ? t.features[n].properties : d ? t.properties : {}, c = h ? t.features[n].bbox : d ? t.bbox : void 0, u = h ? t.features[n].id : d ? t.id : void 0, A = a ? a.type === "GeometryCollection" : !1, s = A ? a.geometries.length : 1, i = 0; i < s; i++) {
      if (o = A ? a.geometries[i] : a, o === null) {
        if (e(
          null,
          f,
          l,
          c,
          u
        ) === !1)
          return !1;
        continue;
      }
      switch (o.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (e(
            o,
            f,
            l,
            c,
            u
          ) === !1)
            return !1;
          break;
        }
        case "GeometryCollection": {
          for (r = 0; r < o.geometries.length; r++)
            if (e(
              o.geometries[r],
              f,
              l,
              c,
              u
            ) === !1)
              return !1;
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    f++;
  }
}
function d4t(t, e, n) {
  var r = n;
  return iAe(
    t,
    function(i, o, s, a, A) {
      o === 0 && n === void 0 ? r = i : r = e(
        r,
        i,
        o,
        s,
        a,
        A
      );
    }
  ), r;
}
function dw(t, e) {
  iAe(t, function(n, r, i, o, s) {
    var a = n === null ? null : n.type;
    switch (a) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        return e(
          Gg(n, i, { bbox: o, id: s }),
          r,
          0
        ) === !1 ? !1 : void 0;
    }
    var A;
    switch (a) {
      case "MultiPoint":
        A = "Point";
        break;
      case "MultiLineString":
        A = "LineString";
        break;
      case "MultiPolygon":
        A = "Polygon";
        break;
    }
    for (var l = 0; l < n.coordinates.length; l++) {
      var c = n.coordinates[l], u = {
        type: A,
        coordinates: c
      };
      if (e(Gg(u, i), r, l) === !1)
        return !1;
    }
  });
}
function p4t(t, e, n) {
  var r = n;
  return dw(
    t,
    function(i, o, s) {
      o === 0 && s === 0 && n === void 0 ? r = i : r = e(
        r,
        i,
        o,
        s
      );
    }
  ), r;
}
function sv(t, e) {
  dw(t, function(n, r, i) {
    var o = 0;
    if (n.geometry) {
      var s = n.geometry.type;
      if (!(s === "Point" || s === "MultiPoint")) {
        var a, A = 0, l = 0, c = 0;
        if (JB(
          n,
          function(u, f, h, d, I) {
            if (a === void 0 || r > A || d > l || I > c) {
              a = u, A = r, l = d, c = I, o = 0;
              return;
            }
            var m = bg(
              [a, u],
              n.properties
            );
            if (e(
              m,
              r,
              i,
              I,
              o
            ) === !1)
              return !1;
            o++, a = u;
          }
        ) === !1)
          return !1;
      }
    }
  });
}
function I4t(t, e, n) {
  var r = n, i = !1;
  return sv(
    t,
    function(o, s, a, A, l) {
      i === !1 && n === void 0 ? r = o : r = e(
        r,
        o,
        s,
        a,
        A,
        l
      ), i = !0;
    }
  ), r;
}
function s5e(t, e) {
  if (!t)
    throw new Error("geojson is required");
  dw(t, function(n, r, i) {
    if (n.geometry !== null) {
      var o = n.geometry.type, s = n.geometry.coordinates;
      switch (o) {
        case "LineString":
          if (e(n, r, i, 0, 0) === !1)
            return !1;
          break;
        case "Polygon":
          for (var a = 0; a < s.length; a++)
            if (e(
              bg(s[a], n.properties),
              r,
              i,
              a
            ) === !1)
              return !1;
          break;
      }
    }
  });
}
function m4t(t, e, n) {
  var r = n;
  return s5e(
    t,
    function(i, o, s, a) {
      o === 0 && n === void 0 ? r = i : r = e(
        r,
        i,
        o,
        s,
        a
      );
    }
  ), r;
}
function C4t(t, e) {
  if (e = e || {}, !I9(e))
    throw new Error("options is invalid");
  var n = e.featureIndex || 0, r = e.multiFeatureIndex || 0, i = e.geometryIndex || 0, o = e.segmentIndex || 0, s = e.properties, a;
  switch (t.type) {
    case "FeatureCollection":
      n < 0 && (n = t.features.length + n), s = s || t.features[n].properties, a = t.features[n].geometry;
      break;
    case "Feature":
      s = s || t.properties, a = t.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      a = t;
      break;
    default:
      throw new Error("geojson is invalid");
  }
  if (a === null)
    return null;
  var A = a.coordinates;
  switch (a.type) {
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
      return o < 0 && (o = A.length + o - 1), bg(
        [A[o], A[o + 1]],
        s,
        e
      );
    case "Polygon":
      return i < 0 && (i = A.length + i), o < 0 && (o = A[i].length + o - 1), bg(
        [
          A[i][o],
          A[i][o + 1]
        ],
        s,
        e
      );
    case "MultiLineString":
      return r < 0 && (r = A.length + r), o < 0 && (o = A[r].length + o - 1), bg(
        [
          A[r][o],
          A[r][o + 1]
        ],
        s,
        e
      );
    case "MultiPolygon":
      return r < 0 && (r = A.length + r), i < 0 && (i = A[r].length + i), o < 0 && (o = A[r][i].length - o - 1), bg(
        [
          A[r][i][o],
          A[r][i][o + 1]
        ],
        s,
        e
      );
  }
  throw new Error("geojson is invalid");
}
function E4t(t, e) {
  if (e = e || {}, !I9(e))
    throw new Error("options is invalid");
  var n = e.featureIndex || 0, r = e.multiFeatureIndex || 0, i = e.geometryIndex || 0, o = e.coordIndex || 0, s = e.properties, a;
  switch (t.type) {
    case "FeatureCollection":
      n < 0 && (n = t.features.length + n), s = s || t.features[n].properties, a = t.features[n].geometry;
      break;
    case "Feature":
      s = s || t.properties, a = t.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      a = t;
      break;
    default:
      throw new Error("geojson is invalid");
  }
  if (a === null)
    return null;
  var A = a.coordinates;
  switch (a.type) {
    case "Point":
      return jl(A, s, e);
    case "MultiPoint":
      return r < 0 && (r = A.length + r), jl(A[r], s, e);
    case "LineString":
      return o < 0 && (o = A.length + o), jl(A[o], s, e);
    case "Polygon":
      return i < 0 && (i = A.length + i), o < 0 && (o = A[i].length + o), jl(A[i][o], s, e);
    case "MultiLineString":
      return r < 0 && (r = A.length + r), o < 0 && (o = A[r].length + o), jl(A[r][o], s, e);
    case "MultiPolygon":
      return r < 0 && (r = A.length + r), i < 0 && (i = A[r].length + i), o < 0 && (o = A[r][i].length - o), jl(
        A[r][i][o],
        s,
        e
      );
  }
  throw new Error("geojson is invalid");
}
const y4t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  coordAll: h4t,
  coordEach: JB,
  coordReduce: u4t,
  featureEach: QT,
  featureReduce: g4t,
  findPoint: E4t,
  findSegment: C4t,
  flattenEach: dw,
  flattenReduce: p4t,
  geomEach: iAe,
  geomReduce: d4t,
  lineEach: s5e,
  lineReduce: m4t,
  propEach: o5e,
  propReduce: f4t,
  segmentEach: sv,
  segmentReduce: I4t
}, Symbol.toStringTag, { value: "Module" }));
function v4t(t, e) {
  e === void 0 && (e = {});
  var n = 0, r = 0, i = 0;
  return JB(t, function(o) {
    n += o[0], r += o[1], i++;
  }, !0), jl([n / i, r / i], e.properties);
}
var oAe = { exports: {} }, a5e = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ei, function() {
    function n(y, v, b, Q, w) {
      (function R(M, O, L, N, k) {
        for (; N > L; ) {
          if (N - L > 600) {
            var $ = N - L + 1, U = O - L + 1, X = Math.log($), K = 0.5 * Math.exp(2 * X / 3), z = 0.5 * Math.sqrt(X * K * ($ - K) / $) * (U - $ / 2 < 0 ? -1 : 1), Y = Math.max(L, Math.floor(O - U * K / $ + z)), V = Math.min(N, Math.floor(O + ($ - U) * K / $ + z));
            R(M, O, Y, V, k);
          }
          var Z = M[O], ce = L, ee = N;
          for (r(M, L, O), k(M[N], Z) > 0 && r(M, L, N); ce < ee; ) {
            for (r(M, ce, ee), ce++, ee--; k(M[ce], Z) < 0; )
              ce++;
            for (; k(M[ee], Z) > 0; )
              ee--;
          }
          k(M[L], Z) === 0 ? r(M, L, ee) : r(M, ++ee, N), ee <= O && (L = ee + 1), O <= ee && (N = ee - 1);
        }
      })(y, v, b || 0, Q || y.length - 1, w || i);
    }
    function r(y, v, b) {
      var Q = y[v];
      y[v] = y[b], y[b] = Q;
    }
    function i(y, v) {
      return y < v ? -1 : y > v ? 1 : 0;
    }
    var o = function(y) {
      y === void 0 && (y = 9), this._maxEntries = Math.max(4, y), this._minEntries = Math.max(2, Math.ceil(0.4 * this._maxEntries)), this.clear();
    };
    function s(y, v, b) {
      if (!b)
        return v.indexOf(y);
      for (var Q = 0; Q < v.length; Q++)
        if (b(y, v[Q]))
          return Q;
      return -1;
    }
    function a(y, v) {
      A(y, 0, y.children.length, v, y);
    }
    function A(y, v, b, Q, w) {
      w || (w = m(null)), w.minX = 1 / 0, w.minY = 1 / 0, w.maxX = -1 / 0, w.maxY = -1 / 0;
      for (var R = v; R < b; R++) {
        var M = y.children[R];
        l(w, y.leaf ? Q(M) : M);
      }
      return w;
    }
    function l(y, v) {
      return y.minX = Math.min(y.minX, v.minX), y.minY = Math.min(y.minY, v.minY), y.maxX = Math.max(y.maxX, v.maxX), y.maxY = Math.max(y.maxY, v.maxY), y;
    }
    function c(y, v) {
      return y.minX - v.minX;
    }
    function u(y, v) {
      return y.minY - v.minY;
    }
    function f(y) {
      return (y.maxX - y.minX) * (y.maxY - y.minY);
    }
    function h(y) {
      return y.maxX - y.minX + (y.maxY - y.minY);
    }
    function d(y, v) {
      return y.minX <= v.minX && y.minY <= v.minY && v.maxX <= y.maxX && v.maxY <= y.maxY;
    }
    function I(y, v) {
      return v.minX <= y.maxX && v.minY <= y.maxY && v.maxX >= y.minX && v.maxY >= y.minY;
    }
    function m(y) {
      return { children: y, height: 1, leaf: !0, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
    }
    function C(y, v, b, Q, w) {
      for (var R = [v, b]; R.length; )
        if (!((b = R.pop()) - (v = R.pop()) <= Q)) {
          var M = v + Math.ceil((b - v) / Q / 2) * Q;
          n(y, M, v, b, w), R.push(v, M, M, b);
        }
    }
    return o.prototype.all = function() {
      return this._all(this.data, []);
    }, o.prototype.search = function(y) {
      var v = this.data, b = [];
      if (!I(y, v))
        return b;
      for (var Q = this.toBBox, w = []; v; ) {
        for (var R = 0; R < v.children.length; R++) {
          var M = v.children[R], O = v.leaf ? Q(M) : M;
          I(y, O) && (v.leaf ? b.push(M) : d(y, O) ? this._all(M, b) : w.push(M));
        }
        v = w.pop();
      }
      return b;
    }, o.prototype.collides = function(y) {
      var v = this.data;
      if (!I(y, v))
        return !1;
      for (var b = []; v; ) {
        for (var Q = 0; Q < v.children.length; Q++) {
          var w = v.children[Q], R = v.leaf ? this.toBBox(w) : w;
          if (I(y, R)) {
            if (v.leaf || d(y, R))
              return !0;
            b.push(w);
          }
        }
        v = b.pop();
      }
      return !1;
    }, o.prototype.load = function(y) {
      if (!y || !y.length)
        return this;
      if (y.length < this._minEntries) {
        for (var v = 0; v < y.length; v++)
          this.insert(y[v]);
        return this;
      }
      var b = this._build(y.slice(), 0, y.length - 1, 0);
      if (this.data.children.length)
        if (this.data.height === b.height)
          this._splitRoot(this.data, b);
        else {
          if (this.data.height < b.height) {
            var Q = this.data;
            this.data = b, b = Q;
          }
          this._insert(b, this.data.height - b.height - 1, !0);
        }
      else
        this.data = b;
      return this;
    }, o.prototype.insert = function(y) {
      return y && this._insert(y, this.data.height - 1), this;
    }, o.prototype.clear = function() {
      return this.data = m([]), this;
    }, o.prototype.remove = function(y, v) {
      if (!y)
        return this;
      for (var b, Q, w, R = this.data, M = this.toBBox(y), O = [], L = []; R || O.length; ) {
        if (R || (R = O.pop(), Q = O[O.length - 1], b = L.pop(), w = !0), R.leaf) {
          var N = s(y, R.children, v);
          if (N !== -1)
            return R.children.splice(N, 1), O.push(R), this._condense(O), this;
        }
        w || R.leaf || !d(R, M) ? Q ? (b++, R = Q.children[b], w = !1) : R = null : (O.push(R), L.push(b), b = 0, Q = R, R = R.children[0]);
      }
      return this;
    }, o.prototype.toBBox = function(y) {
      return y;
    }, o.prototype.compareMinX = function(y, v) {
      return y.minX - v.minX;
    }, o.prototype.compareMinY = function(y, v) {
      return y.minY - v.minY;
    }, o.prototype.toJSON = function() {
      return this.data;
    }, o.prototype.fromJSON = function(y) {
      return this.data = y, this;
    }, o.prototype._all = function(y, v) {
      for (var b = []; y; )
        y.leaf ? v.push.apply(v, y.children) : b.push.apply(b, y.children), y = b.pop();
      return v;
    }, o.prototype._build = function(y, v, b, Q) {
      var w, R = b - v + 1, M = this._maxEntries;
      if (R <= M)
        return a(w = m(y.slice(v, b + 1)), this.toBBox), w;
      Q || (Q = Math.ceil(Math.log(R) / Math.log(M)), M = Math.ceil(R / Math.pow(M, Q - 1))), (w = m([])).leaf = !1, w.height = Q;
      var O = Math.ceil(R / M), L = O * Math.ceil(Math.sqrt(M));
      C(y, v, b, L, this.compareMinX);
      for (var N = v; N <= b; N += L) {
        var k = Math.min(N + L - 1, b);
        C(y, N, k, O, this.compareMinY);
        for (var $ = N; $ <= k; $ += O) {
          var U = Math.min($ + O - 1, k);
          w.children.push(this._build(y, $, U, Q - 1));
        }
      }
      return a(w, this.toBBox), w;
    }, o.prototype._chooseSubtree = function(y, v, b, Q) {
      for (; Q.push(v), !v.leaf && Q.length - 1 !== b; ) {
        for (var w = 1 / 0, R = 1 / 0, M = void 0, O = 0; O < v.children.length; O++) {
          var L = v.children[O], N = f(L), k = ($ = y, U = L, (Math.max(U.maxX, $.maxX) - Math.min(U.minX, $.minX)) * (Math.max(U.maxY, $.maxY) - Math.min(U.minY, $.minY)) - N);
          k < R ? (R = k, w = N < w ? N : w, M = L) : k === R && N < w && (w = N, M = L);
        }
        v = M || v.children[0];
      }
      var $, U;
      return v;
    }, o.prototype._insert = function(y, v, b) {
      var Q = b ? y : this.toBBox(y), w = [], R = this._chooseSubtree(Q, this.data, v, w);
      for (R.children.push(y), l(R, Q); v >= 0 && w[v].children.length > this._maxEntries; )
        this._split(w, v), v--;
      this._adjustParentBBoxes(Q, w, v);
    }, o.prototype._split = function(y, v) {
      var b = y[v], Q = b.children.length, w = this._minEntries;
      this._chooseSplitAxis(b, w, Q);
      var R = this._chooseSplitIndex(b, w, Q), M = m(b.children.splice(R, b.children.length - R));
      M.height = b.height, M.leaf = b.leaf, a(b, this.toBBox), a(M, this.toBBox), v ? y[v - 1].children.push(M) : this._splitRoot(b, M);
    }, o.prototype._splitRoot = function(y, v) {
      this.data = m([y, v]), this.data.height = y.height + 1, this.data.leaf = !1, a(this.data, this.toBBox);
    }, o.prototype._chooseSplitIndex = function(y, v, b) {
      for (var Q, w, R, M, O, L, N, k = 1 / 0, $ = 1 / 0, U = v; U <= b - v; U++) {
        var X = A(y, 0, U, this.toBBox), K = A(y, U, b, this.toBBox), z = (w = X, R = K, M = void 0, O = void 0, L = void 0, N = void 0, M = Math.max(w.minX, R.minX), O = Math.max(w.minY, R.minY), L = Math.min(w.maxX, R.maxX), N = Math.min(w.maxY, R.maxY), Math.max(0, L - M) * Math.max(0, N - O)), Y = f(X) + f(K);
        z < k ? (k = z, Q = U, $ = Y < $ ? Y : $) : z === k && Y < $ && ($ = Y, Q = U);
      }
      return Q || b - v;
    }, o.prototype._chooseSplitAxis = function(y, v, b) {
      var Q = y.leaf ? this.compareMinX : c, w = y.leaf ? this.compareMinY : u;
      this._allDistMargin(y, v, b, Q) < this._allDistMargin(y, v, b, w) && y.children.sort(Q);
    }, o.prototype._allDistMargin = function(y, v, b, Q) {
      y.children.sort(Q);
      for (var w = this.toBBox, R = A(y, 0, v, w), M = A(y, b - v, b, w), O = h(R) + h(M), L = v; L < b - v; L++) {
        var N = y.children[L];
        l(R, y.leaf ? w(N) : N), O += h(R);
      }
      for (var k = b - v - 1; k >= v; k--) {
        var $ = y.children[k];
        l(M, y.leaf ? w($) : $), O += h(M);
      }
      return O;
    }, o.prototype._adjustParentBBoxes = function(y, v, b) {
      for (var Q = b; Q >= 0; Q--)
        l(v[Q], y);
    }, o.prototype._condense = function(y) {
      for (var v = y.length - 1, b = void 0; v >= 0; v--)
        y[v].children.length === 0 ? v > 0 ? (b = y[v - 1].children).splice(b.indexOf(y[v]), 1) : this.clear() : a(y[v], this.toBBox);
    }, o;
  });
})(a5e);
var A5e = a5e.exports;
class B4t {
  constructor(e = [], n = b4t) {
    if (this.data = e, this.length = this.data.length, this.compare = n, this.length > 0)
      for (let r = (this.length >> 1) - 1; r >= 0; r--)
        this._down(r);
  }
  push(e) {
    this.data.push(e), this.length++, this._up(this.length - 1);
  }
  pop() {
    if (this.length === 0)
      return;
    const e = this.data[0], n = this.data.pop();
    return this.length--, this.length > 0 && (this.data[0] = n, this._down(0)), e;
  }
  peek() {
    return this.data[0];
  }
  _up(e) {
    const { data: n, compare: r } = this, i = n[e];
    for (; e > 0; ) {
      const o = e - 1 >> 1, s = n[o];
      if (r(i, s) >= 0)
        break;
      n[e] = s, e = o;
    }
    n[e] = i;
  }
  _down(e) {
    const { data: n, compare: r } = this, i = this.length >> 1, o = n[e];
    for (; e < i; ) {
      let s = (e << 1) + 1, a = n[s];
      const A = s + 1;
      if (A < this.length && r(n[A], a) < 0 && (s = A, a = n[A]), r(a, o) >= 0)
        break;
      n[e] = a, e = s;
    }
    n[e] = o;
  }
}
function b4t(t, e) {
  return t < e ? -1 : t > e ? 1 : 0;
}
const _4t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: B4t
}, Symbol.toStringTag, { value: "Module" })), S4t = /* @__PURE__ */ Fs(_4t);
var m9 = { exports: {} }, Q4t = function(e, n, r, i) {
  var o = e[0], s = e[1], a = !1;
  r === void 0 && (r = 0), i === void 0 && (i = n.length);
  for (var A = (i - r) / 2, l = 0, c = A - 1; l < A; c = l++) {
    var u = n[r + l * 2 + 0], f = n[r + l * 2 + 1], h = n[r + c * 2 + 0], d = n[r + c * 2 + 1], I = f > s != d > s && o < (h - u) * (s - f) / (d - f) + u;
    I && (a = !a);
  }
  return a;
}, w4t = function(e, n, r, i) {
  var o = e[0], s = e[1], a = !1;
  r === void 0 && (r = 0), i === void 0 && (i = n.length);
  for (var A = i - r, l = 0, c = A - 1; l < A; c = l++) {
    var u = n[l + r][0], f = n[l + r][1], h = n[c + r][0], d = n[c + r][1], I = f > s != d > s && o < (h - u) * (s - f) / (d - f) + u;
    I && (a = !a);
  }
  return a;
}, l5e = Q4t, c5e = w4t;
m9.exports = function(e, n, r, i) {
  return n.length > 0 && Array.isArray(n[0]) ? c5e(e, n, r, i) : l5e(e, n, r, i);
};
m9.exports.nested = c5e;
m9.exports.flat = l5e;
var x4t = m9.exports, ZZ = { exports: {} };
(function(t, e) {
  (function(n, r) {
    r(e);
  })(ei, function(n) {
    const i = 33306690738754706e-32;
    function o(I, m, C, y, v) {
      let b, Q, w, R, M = m[0], O = y[0], L = 0, N = 0;
      O > M == O > -M ? (b = M, M = m[++L]) : (b = O, O = y[++N]);
      let k = 0;
      if (L < I && N < C)
        for (O > M == O > -M ? (w = b - ((Q = M + b) - M), M = m[++L]) : (w = b - ((Q = O + b) - O), O = y[++N]), b = Q, w !== 0 && (v[k++] = w); L < I && N < C; )
          O > M == O > -M ? (w = b - ((Q = b + M) - (R = Q - b)) + (M - R), M = m[++L]) : (w = b - ((Q = b + O) - (R = Q - b)) + (O - R), O = y[++N]), b = Q, w !== 0 && (v[k++] = w);
      for (; L < I; )
        w = b - ((Q = b + M) - (R = Q - b)) + (M - R), M = m[++L], b = Q, w !== 0 && (v[k++] = w);
      for (; N < C; )
        w = b - ((Q = b + O) - (R = Q - b)) + (O - R), O = y[++N], b = Q, w !== 0 && (v[k++] = w);
      return b === 0 && k !== 0 || (v[k++] = b), k;
    }
    function s(I) {
      return new Float64Array(I);
    }
    const a = 33306690738754716e-32, A = 22204460492503146e-32, l = 11093356479670487e-47, c = s(4), u = s(8), f = s(12), h = s(16), d = s(4);
    n.orient2d = function(I, m, C, y, v, b) {
      const Q = (m - b) * (C - v), w = (I - v) * (y - b), R = Q - w;
      if (Q === 0 || w === 0 || Q > 0 != w > 0)
        return R;
      const M = Math.abs(Q + w);
      return Math.abs(R) >= a * M ? R : -function(O, L, N, k, $, U, X) {
        let K, z, Y, V, Z, ce, ee, pe, Ce, Be, Ie, Qe, xe, Se, De, Ue, Te, se;
        const fe = O - $, W = N - $, ge = L - U, _e = k - U;
        Z = (De = (pe = fe - (ee = (ce = 134217729 * fe) - (ce - fe))) * (Be = _e - (Ce = (ce = 134217729 * _e) - (ce - _e))) - ((Se = fe * _e) - ee * Ce - pe * Ce - ee * Be)) - (Ie = De - (Te = (pe = ge - (ee = (ce = 134217729 * ge) - (ce - ge))) * (Be = W - (Ce = (ce = 134217729 * W) - (ce - W))) - ((Ue = ge * W) - ee * Ce - pe * Ce - ee * Be))), c[0] = De - (Ie + Z) + (Z - Te), Z = (xe = Se - ((Qe = Se + Ie) - (Z = Qe - Se)) + (Ie - Z)) - (Ie = xe - Ue), c[1] = xe - (Ie + Z) + (Z - Ue), Z = (se = Qe + Ie) - Qe, c[2] = Qe - (se - Z) + (Ie - Z), c[3] = se;
        let Re = function(de, we) {
          let Pe = we[0];
          for (let qe = 1; qe < de; qe++)
            Pe += we[qe];
          return Pe;
        }(4, c), Ee = A * X;
        if (Re >= Ee || -Re >= Ee || (K = O - (fe + (Z = O - fe)) + (Z - $), Y = N - (W + (Z = N - W)) + (Z - $), z = L - (ge + (Z = L - ge)) + (Z - U), V = k - (_e + (Z = k - _e)) + (Z - U), K === 0 && z === 0 && Y === 0 && V === 0) || (Ee = l * X + i * Math.abs(Re), (Re += fe * V + _e * K - (ge * Y + W * z)) >= Ee || -Re >= Ee))
          return Re;
        Z = (De = (pe = K - (ee = (ce = 134217729 * K) - (ce - K))) * (Be = _e - (Ce = (ce = 134217729 * _e) - (ce - _e))) - ((Se = K * _e) - ee * Ce - pe * Ce - ee * Be)) - (Ie = De - (Te = (pe = z - (ee = (ce = 134217729 * z) - (ce - z))) * (Be = W - (Ce = (ce = 134217729 * W) - (ce - W))) - ((Ue = z * W) - ee * Ce - pe * Ce - ee * Be))), d[0] = De - (Ie + Z) + (Z - Te), Z = (xe = Se - ((Qe = Se + Ie) - (Z = Qe - Se)) + (Ie - Z)) - (Ie = xe - Ue), d[1] = xe - (Ie + Z) + (Z - Ue), Z = (se = Qe + Ie) - Qe, d[2] = Qe - (se - Z) + (Ie - Z), d[3] = se;
        const oe = o(4, c, 4, d, u);
        Z = (De = (pe = fe - (ee = (ce = 134217729 * fe) - (ce - fe))) * (Be = V - (Ce = (ce = 134217729 * V) - (ce - V))) - ((Se = fe * V) - ee * Ce - pe * Ce - ee * Be)) - (Ie = De - (Te = (pe = ge - (ee = (ce = 134217729 * ge) - (ce - ge))) * (Be = Y - (Ce = (ce = 134217729 * Y) - (ce - Y))) - ((Ue = ge * Y) - ee * Ce - pe * Ce - ee * Be))), d[0] = De - (Ie + Z) + (Z - Te), Z = (xe = Se - ((Qe = Se + Ie) - (Z = Qe - Se)) + (Ie - Z)) - (Ie = xe - Ue), d[1] = xe - (Ie + Z) + (Z - Ue), Z = (se = Qe + Ie) - Qe, d[2] = Qe - (se - Z) + (Ie - Z), d[3] = se;
        const ie = o(oe, u, 4, d, f);
        Z = (De = (pe = K - (ee = (ce = 134217729 * K) - (ce - K))) * (Be = V - (Ce = (ce = 134217729 * V) - (ce - V))) - ((Se = K * V) - ee * Ce - pe * Ce - ee * Be)) - (Ie = De - (Te = (pe = z - (ee = (ce = 134217729 * z) - (ce - z))) * (Be = Y - (Ce = (ce = 134217729 * Y) - (ce - Y))) - ((Ue = z * Y) - ee * Ce - pe * Ce - ee * Be))), d[0] = De - (Ie + Z) + (Z - Te), Z = (xe = Se - ((Qe = Se + Ie) - (Z = Qe - Se)) + (Ie - Z)) - (Ie = xe - Ue), d[1] = xe - (Ie + Z) + (Z - Ue), Z = (se = Qe + Ie) - Qe, d[2] = Qe - (se - Z) + (Ie - Z), d[3] = se;
        const Ae = o(ie, f, 4, d, h);
        return h[Ae - 1];
      }(I, m, C, y, v, b, M);
    }, n.orient2dfast = function(I, m, C, y, v, b) {
      return (m - b) * (C - v) - (I - v) * (y - b);
    }, Object.defineProperty(n, "__esModule", { value: !0 });
  });
})(ZZ, ZZ.exports);
var R4t = ZZ.exports, Bve = A5e, dk = S4t, D4t = x4t, T4t = R4t.orient2d;
dk.default && (dk = dk.default);
oAe.exports = u5e;
oAe.exports.default = u5e;
function u5e(t, e, n) {
  e = Math.max(0, e === void 0 ? 2 : e), n = n || 0;
  var r = F4t(t), i = new Bve(16);
  i.toBBox = function(y) {
    return {
      minX: y[0],
      minY: y[1],
      maxX: y[0],
      maxY: y[1]
    };
  }, i.compareMinX = function(y, v) {
    return y[0] - v[0];
  }, i.compareMinY = function(y, v) {
    return y[1] - v[1];
  }, i.load(t);
  for (var o = [], s = 0, a; s < r.length; s++) {
    var A = r[s];
    i.remove(A), a = Sve(A, a), o.push(a);
  }
  var l = new Bve(16);
  for (s = 0; s < o.length; s++)
    l.insert(s7(o[s]));
  for (var c = e * e, u = n * n; o.length; ) {
    var f = o.shift(), h = f.p, d = f.next.p, I = a7(h, d);
    if (!(I < u)) {
      var m = I / c;
      A = N4t(i, f.prev.p, h, d, f.next.next.p, m, l), A && Math.min(a7(A, h), a7(A, d)) <= m && (o.push(f), o.push(Sve(A, f)), i.remove(A), l.remove(f), l.insert(s7(f)), l.insert(s7(f.next)));
    }
  }
  f = a;
  var C = [];
  do
    C.push(f.p), f = f.next;
  while (f !== a);
  return C.push(f.p), C;
}
function N4t(t, e, n, r, i, o, s) {
  for (var a = new dk([], L4t), A = t.data; A; ) {
    for (var l = 0; l < A.children.length; l++) {
      var c = A.children[l], u = A.leaf ? A7(c, n, r) : M4t(n, r, c);
      u > o || a.push({
        node: c,
        dist: u
      });
    }
    for (; a.length && !a.peek().node.children; ) {
      var f = a.pop(), h = f.node, d = A7(h, e, n), I = A7(h, r, i);
      if (f.dist < d && f.dist < I && _ve(n, h, s) && _ve(r, h, s))
        return h;
    }
    A = a.pop(), A && (A = A.node);
  }
  return null;
}
function L4t(t, e) {
  return t.dist - e.dist;
}
function M4t(t, e, n) {
  if (bve(t, n) || bve(e, n))
    return 0;
  var r = yF(t[0], t[1], e[0], e[1], n.minX, n.minY, n.maxX, n.minY);
  if (r === 0)
    return 0;
  var i = yF(t[0], t[1], e[0], e[1], n.minX, n.minY, n.minX, n.maxY);
  if (i === 0)
    return 0;
  var o = yF(t[0], t[1], e[0], e[1], n.maxX, n.minY, n.maxX, n.maxY);
  if (o === 0)
    return 0;
  var s = yF(t[0], t[1], e[0], e[1], n.minX, n.maxY, n.maxX, n.maxY);
  return s === 0 ? 0 : Math.min(r, i, o, s);
}
function bve(t, e) {
  return t[0] >= e.minX && t[0] <= e.maxX && t[1] >= e.minY && t[1] <= e.maxY;
}
function _ve(t, e, n) {
  for (var r = Math.min(t[0], e[0]), i = Math.min(t[1], e[1]), o = Math.max(t[0], e[0]), s = Math.max(t[1], e[1]), a = n.search({ minX: r, minY: i, maxX: o, maxY: s }), A = 0; A < a.length; A++)
    if (O4t(a[A].p, a[A].next.p, t, e))
      return !1;
  return !0;
}
function l_(t, e, n) {
  return T4t(t[0], t[1], e[0], e[1], n[0], n[1]);
}
function O4t(t, e, n, r) {
  return t !== r && e !== n && l_(t, e, n) > 0 != l_(t, e, r) > 0 && l_(n, r, t) > 0 != l_(n, r, e) > 0;
}
function s7(t) {
  var e = t.p, n = t.next.p;
  return t.minX = Math.min(e[0], n[0]), t.minY = Math.min(e[1], n[1]), t.maxX = Math.max(e[0], n[0]), t.maxY = Math.max(e[1], n[1]), t;
}
function F4t(t) {
  for (var e = t[0], n = t[0], r = t[0], i = t[0], o = 0; o < t.length; o++) {
    var s = t[o];
    s[0] < e[0] && (e = s), s[0] > r[0] && (r = s), s[1] < n[1] && (n = s), s[1] > i[1] && (i = s);
  }
  var a = [e, n, r, i], A = a.slice();
  for (o = 0; o < t.length; o++)
    D4t(t[o], a) || A.push(t[o]);
  return k4t(A);
}
function Sve(t, e) {
  var n = {
    p: t,
    prev: null,
    next: null,
    minX: 0,
    minY: 0,
    maxX: 0,
    maxY: 0
  };
  return e ? (n.next = e.next, n.prev = e, e.next.prev = n, e.next = n) : (n.prev = n, n.next = n), n;
}
function a7(t, e) {
  var n = t[0] - e[0], r = t[1] - e[1];
  return n * n + r * r;
}
function A7(t, e, n) {
  var r = e[0], i = e[1], o = n[0] - r, s = n[1] - i;
  if (o !== 0 || s !== 0) {
    var a = ((t[0] - r) * o + (t[1] - i) * s) / (o * o + s * s);
    a > 1 ? (r = n[0], i = n[1]) : a > 0 && (r += o * a, i += s * a);
  }
  return o = t[0] - r, s = t[1] - i, o * o + s * s;
}
function yF(t, e, n, r, i, o, s, a) {
  var A = n - t, l = r - e, c = s - i, u = a - o, f = t - i, h = e - o, d = A * A + l * l, I = A * c + l * u, m = c * c + u * u, C = A * f + l * h, y = c * f + u * h, v = d * m - I * I, b, Q, w, R, M = v, O = v;
  v === 0 ? (Q = 0, M = 1, R = y, O = m) : (Q = I * y - m * C, R = d * y - I * C, Q < 0 ? (Q = 0, R = y, O = m) : Q > M && (Q = M, R = y + I, O = m)), R < 0 ? (R = 0, -C < 0 ? Q = 0 : -C > d ? Q = M : (Q = -C, M = d)) : R > O && (R = O, -C + I < 0 ? Q = 0 : -C + I > d ? Q = M : (Q = -C + I, M = d)), b = Q === 0 ? 0 : Q / M, w = R === 0 ? 0 : R / O;
  var L = (1 - b) * t + b * n, N = (1 - b) * e + b * r, k = (1 - w) * i + w * s, $ = (1 - w) * o + w * a, U = k - L, X = $ - N;
  return U * U + X * X;
}
function P4t(t, e) {
  return t[0] === e[0] ? t[1] - e[1] : t[0] - e[0];
}
function k4t(t) {
  t.sort(P4t);
  for (var e = [], n = 0; n < t.length; n++) {
    for (; e.length >= 2 && l_(e[e.length - 2], e[e.length - 1], t[n]) <= 0; )
      e.pop();
    e.push(t[n]);
  }
  for (var r = [], i = t.length - 1; i >= 0; i--) {
    for (; r.length >= 2 && l_(r[r.length - 2], r[r.length - 1], t[i]) <= 0; )
      r.pop();
    r.push(t[i]);
  }
  return r.pop(), e.pop(), e.concat(r);
}
var G4t = oAe.exports;
const U4t = /* @__PURE__ */ ko(G4t), Qve = "json", f5e = "application/json", H4t = "csv", g5e = "text/csv", h5e = ",", d5e = "NA", lg = "obs", Vv = {
  latestVersion: "0.1.3",
  schema: FH
}, $4t = {
  schema: cQt
};
var p5e = { exports: {} };
(function(t) {
  (function(e) {
    var n = /^\s+/, r = /\s+$/, i = 0, o = e.round, s = e.min, a = e.max, A = e.random;
    function l(se, fe) {
      if (se = se || "", fe = fe || {}, se instanceof l)
        return se;
      if (!(this instanceof l))
        return new l(se, fe);
      var W = c(se);
      this._originalInput = se, this._r = W.r, this._g = W.g, this._b = W.b, this._a = W.a, this._roundA = o(100 * this._a) / 100, this._format = fe.format || W.format, this._gradientType = fe.gradientType, this._r < 1 && (this._r = o(this._r)), this._g < 1 && (this._g = o(this._g)), this._b < 1 && (this._b = o(this._b)), this._ok = W.ok, this._tc_id = i++;
    }
    l.prototype = {
      isDark: function() {
        return this.getBrightness() < 128;
      },
      isLight: function() {
        return !this.isDark();
      },
      isValid: function() {
        return this._ok;
      },
      getOriginalInput: function() {
        return this._originalInput;
      },
      getFormat: function() {
        return this._format;
      },
      getAlpha: function() {
        return this._a;
      },
      getBrightness: function() {
        var se = this.toRgb();
        return (se.r * 299 + se.g * 587 + se.b * 114) / 1e3;
      },
      getLuminance: function() {
        var se = this.toRgb(), fe, W, ge, _e, Re, Ee;
        return fe = se.r / 255, W = se.g / 255, ge = se.b / 255, fe <= 0.03928 ? _e = fe / 12.92 : _e = e.pow((fe + 0.055) / 1.055, 2.4), W <= 0.03928 ? Re = W / 12.92 : Re = e.pow((W + 0.055) / 1.055, 2.4), ge <= 0.03928 ? Ee = ge / 12.92 : Ee = e.pow((ge + 0.055) / 1.055, 2.4), 0.2126 * _e + 0.7152 * Re + 0.0722 * Ee;
      },
      setAlpha: function(se) {
        return this._a = V(se), this._roundA = o(100 * this._a) / 100, this;
      },
      toHsv: function() {
        var se = d(this._r, this._g, this._b);
        return { h: se.h * 360, s: se.s, v: se.v, a: this._a };
      },
      toHsvString: function() {
        var se = d(this._r, this._g, this._b), fe = o(se.h * 360), W = o(se.s * 100), ge = o(se.v * 100);
        return this._a == 1 ? "hsv(" + fe + ", " + W + "%, " + ge + "%)" : "hsva(" + fe + ", " + W + "%, " + ge + "%, " + this._roundA + ")";
      },
      toHsl: function() {
        var se = f(this._r, this._g, this._b);
        return { h: se.h * 360, s: se.s, l: se.l, a: this._a };
      },
      toHslString: function() {
        var se = f(this._r, this._g, this._b), fe = o(se.h * 360), W = o(se.s * 100), ge = o(se.l * 100);
        return this._a == 1 ? "hsl(" + fe + ", " + W + "%, " + ge + "%)" : "hsla(" + fe + ", " + W + "%, " + ge + "%, " + this._roundA + ")";
      },
      toHex: function(se) {
        return m(this._r, this._g, this._b, se);
      },
      toHexString: function(se) {
        return "#" + this.toHex(se);
      },
      toHex8: function(se) {
        return C(this._r, this._g, this._b, this._a, se);
      },
      toHex8String: function(se) {
        return "#" + this.toHex8(se);
      },
      toRgb: function() {
        return { r: o(this._r), g: o(this._g), b: o(this._b), a: this._a };
      },
      toRgbString: function() {
        return this._a == 1 ? "rgb(" + o(this._r) + ", " + o(this._g) + ", " + o(this._b) + ")" : "rgba(" + o(this._r) + ", " + o(this._g) + ", " + o(this._b) + ", " + this._roundA + ")";
      },
      toPercentageRgb: function() {
        return { r: o(Z(this._r, 255) * 100) + "%", g: o(Z(this._g, 255) * 100) + "%", b: o(Z(this._b, 255) * 100) + "%", a: this._a };
      },
      toPercentageRgbString: function() {
        return this._a == 1 ? "rgb(" + o(Z(this._r, 255) * 100) + "%, " + o(Z(this._g, 255) * 100) + "%, " + o(Z(this._b, 255) * 100) + "%)" : "rgba(" + o(Z(this._r, 255) * 100) + "%, " + o(Z(this._g, 255) * 100) + "%, " + o(Z(this._b, 255) * 100) + "%, " + this._roundA + ")";
      },
      toName: function() {
        return this._a === 0 ? "transparent" : this._a < 1 ? !1 : z[m(this._r, this._g, this._b, !0)] || !1;
      },
      toFilter: function(se) {
        var fe = "#" + y(this._r, this._g, this._b, this._a), W = fe, ge = this._gradientType ? "GradientType = 1, " : "";
        if (se) {
          var _e = l(se);
          W = "#" + y(_e._r, _e._g, _e._b, _e._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + ge + "startColorstr=" + fe + ",endColorstr=" + W + ")";
      },
      toString: function(se) {
        var fe = !!se;
        se = se || this._format;
        var W = !1, ge = this._a < 1 && this._a >= 0, _e = !fe && ge && (se === "hex" || se === "hex6" || se === "hex3" || se === "hex4" || se === "hex8" || se === "name");
        return _e ? se === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (se === "rgb" && (W = this.toRgbString()), se === "prgb" && (W = this.toPercentageRgbString()), (se === "hex" || se === "hex6") && (W = this.toHexString()), se === "hex3" && (W = this.toHexString(!0)), se === "hex4" && (W = this.toHex8String(!0)), se === "hex8" && (W = this.toHex8String()), se === "name" && (W = this.toName()), se === "hsl" && (W = this.toHslString()), se === "hsv" && (W = this.toHsvString()), W || this.toHexString());
      },
      clone: function() {
        return l(this.toString());
      },
      _applyModification: function(se, fe) {
        var W = se.apply(null, [this].concat([].slice.call(fe)));
        return this._r = W._r, this._g = W._g, this._b = W._b, this.setAlpha(W._a), this;
      },
      lighten: function() {
        return this._applyModification(w, arguments);
      },
      brighten: function() {
        return this._applyModification(R, arguments);
      },
      darken: function() {
        return this._applyModification(M, arguments);
      },
      desaturate: function() {
        return this._applyModification(v, arguments);
      },
      saturate: function() {
        return this._applyModification(b, arguments);
      },
      greyscale: function() {
        return this._applyModification(Q, arguments);
      },
      spin: function() {
        return this._applyModification(O, arguments);
      },
      _applyCombination: function(se, fe) {
        return se.apply(null, [this].concat([].slice.call(fe)));
      },
      analogous: function() {
        return this._applyCombination(U, arguments);
      },
      complement: function() {
        return this._applyCombination(L, arguments);
      },
      monochromatic: function() {
        return this._applyCombination(X, arguments);
      },
      splitcomplement: function() {
        return this._applyCombination($, arguments);
      },
      triad: function() {
        return this._applyCombination(N, arguments);
      },
      tetrad: function() {
        return this._applyCombination(k, arguments);
      }
    }, l.fromRatio = function(se, fe) {
      if (typeof se == "object") {
        var W = {};
        for (var ge in se)
          se.hasOwnProperty(ge) && (ge === "a" ? W[ge] = se[ge] : W[ge] = Ie(se[ge]));
        se = W;
      }
      return l(se, fe);
    };
    function c(se) {
      var fe = { r: 0, g: 0, b: 0 }, W = 1, ge = null, _e = null, Re = null, Ee = !1, oe = !1;
      return typeof se == "string" && (se = Ue(se)), typeof se == "object" && (De(se.r) && De(se.g) && De(se.b) ? (fe = u(se.r, se.g, se.b), Ee = !0, oe = String(se.r).substr(-1) === "%" ? "prgb" : "rgb") : De(se.h) && De(se.s) && De(se.v) ? (ge = Ie(se.s), _e = Ie(se.v), fe = I(se.h, ge, _e), Ee = !0, oe = "hsv") : De(se.h) && De(se.s) && De(se.l) && (ge = Ie(se.s), Re = Ie(se.l), fe = h(se.h, ge, Re), Ee = !0, oe = "hsl"), se.hasOwnProperty("a") && (W = se.a)), W = V(W), {
        ok: Ee,
        format: se.format || oe,
        r: s(255, a(fe.r, 0)),
        g: s(255, a(fe.g, 0)),
        b: s(255, a(fe.b, 0)),
        a: W
      };
    }
    function u(se, fe, W) {
      return {
        r: Z(se, 255) * 255,
        g: Z(fe, 255) * 255,
        b: Z(W, 255) * 255
      };
    }
    function f(se, fe, W) {
      se = Z(se, 255), fe = Z(fe, 255), W = Z(W, 255);
      var ge = a(se, fe, W), _e = s(se, fe, W), Re, Ee, oe = (ge + _e) / 2;
      if (ge == _e)
        Re = Ee = 0;
      else {
        var ie = ge - _e;
        switch (Ee = oe > 0.5 ? ie / (2 - ge - _e) : ie / (ge + _e), ge) {
          case se:
            Re = (fe - W) / ie + (fe < W ? 6 : 0);
            break;
          case fe:
            Re = (W - se) / ie + 2;
            break;
          case W:
            Re = (se - fe) / ie + 4;
            break;
        }
        Re /= 6;
      }
      return { h: Re, s: Ee, l: oe };
    }
    function h(se, fe, W) {
      var ge, _e, Re;
      se = Z(se, 360), fe = Z(fe, 100), W = Z(W, 100);
      function Ee(Ae, de, we) {
        return we < 0 && (we += 1), we > 1 && (we -= 1), we < 1 / 6 ? Ae + (de - Ae) * 6 * we : we < 1 / 2 ? de : we < 2 / 3 ? Ae + (de - Ae) * (2 / 3 - we) * 6 : Ae;
      }
      if (fe === 0)
        ge = _e = Re = W;
      else {
        var oe = W < 0.5 ? W * (1 + fe) : W + fe - W * fe, ie = 2 * W - oe;
        ge = Ee(ie, oe, se + 1 / 3), _e = Ee(ie, oe, se), Re = Ee(ie, oe, se - 1 / 3);
      }
      return { r: ge * 255, g: _e * 255, b: Re * 255 };
    }
    function d(se, fe, W) {
      se = Z(se, 255), fe = Z(fe, 255), W = Z(W, 255);
      var ge = a(se, fe, W), _e = s(se, fe, W), Re, Ee, oe = ge, ie = ge - _e;
      if (Ee = ge === 0 ? 0 : ie / ge, ge == _e)
        Re = 0;
      else {
        switch (ge) {
          case se:
            Re = (fe - W) / ie + (fe < W ? 6 : 0);
            break;
          case fe:
            Re = (W - se) / ie + 2;
            break;
          case W:
            Re = (se - fe) / ie + 4;
            break;
        }
        Re /= 6;
      }
      return { h: Re, s: Ee, v: oe };
    }
    function I(se, fe, W) {
      se = Z(se, 360) * 6, fe = Z(fe, 100), W = Z(W, 100);
      var ge = e.floor(se), _e = se - ge, Re = W * (1 - fe), Ee = W * (1 - _e * fe), oe = W * (1 - (1 - _e) * fe), ie = ge % 6, Ae = [W, Ee, Re, Re, oe, W][ie], de = [oe, W, W, Ee, Re, Re][ie], we = [Re, Re, oe, W, W, Ee][ie];
      return { r: Ae * 255, g: de * 255, b: we * 255 };
    }
    function m(se, fe, W, ge) {
      var _e = [
        Be(o(se).toString(16)),
        Be(o(fe).toString(16)),
        Be(o(W).toString(16))
      ];
      return ge && _e[0].charAt(0) == _e[0].charAt(1) && _e[1].charAt(0) == _e[1].charAt(1) && _e[2].charAt(0) == _e[2].charAt(1) ? _e[0].charAt(0) + _e[1].charAt(0) + _e[2].charAt(0) : _e.join("");
    }
    function C(se, fe, W, ge, _e) {
      var Re = [
        Be(o(se).toString(16)),
        Be(o(fe).toString(16)),
        Be(o(W).toString(16)),
        Be(Qe(ge))
      ];
      return _e && Re[0].charAt(0) == Re[0].charAt(1) && Re[1].charAt(0) == Re[1].charAt(1) && Re[2].charAt(0) == Re[2].charAt(1) && Re[3].charAt(0) == Re[3].charAt(1) ? Re[0].charAt(0) + Re[1].charAt(0) + Re[2].charAt(0) + Re[3].charAt(0) : Re.join("");
    }
    function y(se, fe, W, ge) {
      var _e = [
        Be(Qe(ge)),
        Be(o(se).toString(16)),
        Be(o(fe).toString(16)),
        Be(o(W).toString(16))
      ];
      return _e.join("");
    }
    l.equals = function(se, fe) {
      return !se || !fe ? !1 : l(se).toRgbString() == l(fe).toRgbString();
    }, l.random = function() {
      return l.fromRatio({
        r: A(),
        g: A(),
        b: A()
      });
    };
    function v(se, fe) {
      fe = fe === 0 ? 0 : fe || 10;
      var W = l(se).toHsl();
      return W.s -= fe / 100, W.s = ce(W.s), l(W);
    }
    function b(se, fe) {
      fe = fe === 0 ? 0 : fe || 10;
      var W = l(se).toHsl();
      return W.s += fe / 100, W.s = ce(W.s), l(W);
    }
    function Q(se) {
      return l(se).desaturate(100);
    }
    function w(se, fe) {
      fe = fe === 0 ? 0 : fe || 10;
      var W = l(se).toHsl();
      return W.l += fe / 100, W.l = ce(W.l), l(W);
    }
    function R(se, fe) {
      fe = fe === 0 ? 0 : fe || 10;
      var W = l(se).toRgb();
      return W.r = a(0, s(255, W.r - o(255 * -(fe / 100)))), W.g = a(0, s(255, W.g - o(255 * -(fe / 100)))), W.b = a(0, s(255, W.b - o(255 * -(fe / 100)))), l(W);
    }
    function M(se, fe) {
      fe = fe === 0 ? 0 : fe || 10;
      var W = l(se).toHsl();
      return W.l -= fe / 100, W.l = ce(W.l), l(W);
    }
    function O(se, fe) {
      var W = l(se).toHsl(), ge = (W.h + fe) % 360;
      return W.h = ge < 0 ? 360 + ge : ge, l(W);
    }
    function L(se) {
      var fe = l(se).toHsl();
      return fe.h = (fe.h + 180) % 360, l(fe);
    }
    function N(se) {
      var fe = l(se).toHsl(), W = fe.h;
      return [
        l(se),
        l({ h: (W + 120) % 360, s: fe.s, l: fe.l }),
        l({ h: (W + 240) % 360, s: fe.s, l: fe.l })
      ];
    }
    function k(se) {
      var fe = l(se).toHsl(), W = fe.h;
      return [
        l(se),
        l({ h: (W + 90) % 360, s: fe.s, l: fe.l }),
        l({ h: (W + 180) % 360, s: fe.s, l: fe.l }),
        l({ h: (W + 270) % 360, s: fe.s, l: fe.l })
      ];
    }
    function $(se) {
      var fe = l(se).toHsl(), W = fe.h;
      return [
        l(se),
        l({ h: (W + 72) % 360, s: fe.s, l: fe.l }),
        l({ h: (W + 216) % 360, s: fe.s, l: fe.l })
      ];
    }
    function U(se, fe, W) {
      fe = fe || 6, W = W || 30;
      var ge = l(se).toHsl(), _e = 360 / W, Re = [l(se)];
      for (ge.h = (ge.h - (_e * fe >> 1) + 720) % 360; --fe; )
        ge.h = (ge.h + _e) % 360, Re.push(l(ge));
      return Re;
    }
    function X(se, fe) {
      fe = fe || 6;
      for (var W = l(se).toHsv(), ge = W.h, _e = W.s, Re = W.v, Ee = [], oe = 1 / fe; fe--; )
        Ee.push(l({ h: ge, s: _e, v: Re })), Re = (Re + oe) % 1;
      return Ee;
    }
    l.mix = function(se, fe, W) {
      W = W === 0 ? 0 : W || 50;
      var ge = l(se).toRgb(), _e = l(fe).toRgb(), Re = W / 100, Ee = {
        r: (_e.r - ge.r) * Re + ge.r,
        g: (_e.g - ge.g) * Re + ge.g,
        b: (_e.b - ge.b) * Re + ge.b,
        a: (_e.a - ge.a) * Re + ge.a
      };
      return l(Ee);
    }, l.readability = function(se, fe) {
      var W = l(se), ge = l(fe);
      return (e.max(W.getLuminance(), ge.getLuminance()) + 0.05) / (e.min(W.getLuminance(), ge.getLuminance()) + 0.05);
    }, l.isReadable = function(se, fe, W) {
      var ge = l.readability(se, fe), _e, Re;
      switch (Re = !1, _e = Te(W), _e.level + _e.size) {
        case "AAsmall":
        case "AAAlarge":
          Re = ge >= 4.5;
          break;
        case "AAlarge":
          Re = ge >= 3;
          break;
        case "AAAsmall":
          Re = ge >= 7;
          break;
      }
      return Re;
    }, l.mostReadable = function(se, fe, W) {
      var ge = null, _e = 0, Re, Ee, oe, ie;
      W = W || {}, Ee = W.includeFallbackColors, oe = W.level, ie = W.size;
      for (var Ae = 0; Ae < fe.length; Ae++)
        Re = l.readability(se, fe[Ae]), Re > _e && (_e = Re, ge = l(fe[Ae]));
      return l.isReadable(se, ge, { level: oe, size: ie }) || !Ee ? ge : (W.includeFallbackColors = !1, l.mostReadable(se, ["#fff", "#000"], W));
    };
    var K = l.names = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "0ff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "00f",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      burntsienna: "ea7e5d",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "0ff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "f0f",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    }, z = l.hexNames = Y(K);
    function Y(se) {
      var fe = {};
      for (var W in se)
        se.hasOwnProperty(W) && (fe[se[W]] = W);
      return fe;
    }
    function V(se) {
      return se = parseFloat(se), (isNaN(se) || se < 0 || se > 1) && (se = 1), se;
    }
    function Z(se, fe) {
      pe(se) && (se = "100%");
      var W = Ce(se);
      return se = s(fe, a(0, parseFloat(se))), W && (se = parseInt(se * fe, 10) / 100), e.abs(se - fe) < 1e-6 ? 1 : se % fe / parseFloat(fe);
    }
    function ce(se) {
      return s(1, a(0, se));
    }
    function ee(se) {
      return parseInt(se, 16);
    }
    function pe(se) {
      return typeof se == "string" && se.indexOf(".") != -1 && parseFloat(se) === 1;
    }
    function Ce(se) {
      return typeof se == "string" && se.indexOf("%") != -1;
    }
    function Be(se) {
      return se.length == 1 ? "0" + se : "" + se;
    }
    function Ie(se) {
      return se <= 1 && (se = se * 100 + "%"), se;
    }
    function Qe(se) {
      return e.round(parseFloat(se) * 255).toString(16);
    }
    function xe(se) {
      return ee(se) / 255;
    }
    var Se = function() {
      var se = "[-\\+]?\\d+%?", fe = "[-\\+]?\\d*\\.\\d+%?", W = "(?:" + fe + ")|(?:" + se + ")", ge = "[\\s|\\(]+(" + W + ")[,|\\s]+(" + W + ")[,|\\s]+(" + W + ")\\s*\\)?", _e = "[\\s|\\(]+(" + W + ")[,|\\s]+(" + W + ")[,|\\s]+(" + W + ")[,|\\s]+(" + W + ")\\s*\\)?";
      return {
        CSS_UNIT: new RegExp(W),
        rgb: new RegExp("rgb" + ge),
        rgba: new RegExp("rgba" + _e),
        hsl: new RegExp("hsl" + ge),
        hsla: new RegExp("hsla" + _e),
        hsv: new RegExp("hsv" + ge),
        hsva: new RegExp("hsva" + _e),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
      };
    }();
    function De(se) {
      return !!Se.CSS_UNIT.exec(se);
    }
    function Ue(se) {
      se = se.replace(n, "").replace(r, "").toLowerCase();
      var fe = !1;
      if (K[se])
        se = K[se], fe = !0;
      else if (se == "transparent")
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
      var W;
      return (W = Se.rgb.exec(se)) ? { r: W[1], g: W[2], b: W[3] } : (W = Se.rgba.exec(se)) ? { r: W[1], g: W[2], b: W[3], a: W[4] } : (W = Se.hsl.exec(se)) ? { h: W[1], s: W[2], l: W[3] } : (W = Se.hsla.exec(se)) ? { h: W[1], s: W[2], l: W[3], a: W[4] } : (W = Se.hsv.exec(se)) ? { h: W[1], s: W[2], v: W[3] } : (W = Se.hsva.exec(se)) ? { h: W[1], s: W[2], v: W[3], a: W[4] } : (W = Se.hex8.exec(se)) ? {
        r: ee(W[1]),
        g: ee(W[2]),
        b: ee(W[3]),
        a: xe(W[4]),
        format: fe ? "name" : "hex8"
      } : (W = Se.hex6.exec(se)) ? {
        r: ee(W[1]),
        g: ee(W[2]),
        b: ee(W[3]),
        format: fe ? "name" : "hex"
      } : (W = Se.hex4.exec(se)) ? {
        r: ee(W[1] + "" + W[1]),
        g: ee(W[2] + "" + W[2]),
        b: ee(W[3] + "" + W[3]),
        a: xe(W[4] + "" + W[4]),
        format: fe ? "name" : "hex8"
      } : (W = Se.hex3.exec(se)) ? {
        r: ee(W[1] + "" + W[1]),
        g: ee(W[2] + "" + W[2]),
        b: ee(W[3] + "" + W[3]),
        format: fe ? "name" : "hex"
      } : !1;
    }
    function Te(se) {
      var fe, W;
      return se = se || { level: "AA", size: "small" }, fe = (se.level || "AA").toUpperCase(), W = (se.size || "small").toLowerCase(), fe !== "AA" && fe !== "AAA" && (fe = "AA"), W !== "small" && W !== "large" && (W = "small"), { level: fe, size: W };
    }
    t.exports ? t.exports = l : window.tinycolor = l;
  })(Math);
})(p5e);
var q4t = p5e.exports;
const I5e = /* @__PURE__ */ ko(q4t);
function C9(t, e, n) {
  t.key === e && (t.preventDefault(), n());
}
function Qu(t) {
  return I5e({ r: t[0], g: t[1], b: t[2] }).toHexString();
}
function j4t(t) {
  const e = I5e(t).toRgb();
  return [e.r, e.g, e.b];
}
function m5e(t) {
  return t === 0 ? "Color by hierarchy" : t <= 2 ? `Color by ${((n) => "sub".repeat(n))(t - 1)}cluster` : `Color by cluster level ${t}`;
}
function qb(t, e) {
  return t.length <= e.length ? gr(t, e.slice(0, t.length)) : !1;
}
function l7(t, e, n) {
  return qb(t, e) ? [...n, ...e.slice(n.length)] : e;
}
const jb = "___";
function k_(t) {
  return t.join(jb);
}
function C5e(t, e, n) {
  let r = 1;
  if (t)
    for (; t.find((i) => i.name.includes(`${e}${r}`)); )
      r++;
  return `${e}${r}${n}`;
}
function pI(t, e, n, r, i, o, s, a = "Selection ", A = "") {
  const l = "My Selections", c = e?.tree.find((I) => I.name === l), u = {
    version: Vv.latestVersion,
    datatype: lg,
    tree: [...e ? e.tree : []]
  }, f = C5e(c?.children, a, A);
  let h = 0;
  c ? (h = c.children.length, c.children.push({
    name: f,
    set: t.map((I) => [I, null])
  })) : u.tree.push({
    name: l,
    children: [
      {
        name: f,
        set: t.map((I) => [I, null])
      }
    ]
  }), i(u);
  const d = ["My Selections", f];
  o([
    ...n || [],
    {
      path: d,
      color: Gv[h % Gv.length]
    }
  ]), r([d]), s("cellSetSelection");
}
function RI(t, e) {
  return {
    version: Vv.latestVersion,
    datatype: lg,
    tree: [
      ...t ? t.tree : [],
      ...e ? e.tree : []
    ]
  };
}
function Y4t(t, e) {
  const [n, r] = t;
  return e.filter((o) => o.value >= n && o.value <= r).map((o) => o.cellId);
}
function z4t() {
  return BT();
}
function wd(t) {
  return t ? t.children ? t.children.flatMap((e) => wd(e)) : t.set || [] : [];
}
function LL(t, e = 0) {
  if (!t.children)
    return e;
  const n = e + 1, r = t.children.map((i) => LL(i, n));
  return Math.max(...r, n);
}
function E5e(t) {
  return t ? t.children ? t.children.reduce((e, n) => e + E5e(n), 0) : t.set?.length || 0 : 0;
}
function y5e(t, e, n) {
  const r = e[n];
  if (t.name === r) {
    if (n === e.length - 1)
      return t;
    if (t.children) {
      const i = t.children.map((o) => y5e(o, e, n + 1)).filter(Boolean);
      if (i.length === 1)
        return i[0];
    }
  }
  return null;
}
function kc(t, e) {
  const n = t.tree.map((r) => y5e(r, e, 0)).filter(Boolean);
  return n.length === 1 ? n[0] : null;
}
function v5e(t, e, n, r, i) {
  let o;
  return i ? o = [...i] : o = [t.name], e(t, o) ? (r.push(o), n(t, o)) : t.children ? {
    ...t,
    children: t.children.map((s) => v5e(s, e, n, r, o.concat([s.name])))
  } : t;
}
function B5e(t, e, n, r, i) {
  let o;
  i ? o = [...i] : o = [t.name];
  let s = t;
  return e(t, o) && (r.push(o), s = n(t, o)), t.children ? {
    ...s,
    children: s.children.map((a) => B5e(a, e, n, r, o.concat([a.name])))
  } : s;
}
function b5e(t, e) {
  return {
    ...t,
    children: [...t.children, e]
  };
}
function V4t(t, e) {
  return {
    ...t,
    children: [e, ...t.children]
  };
}
function J4t(t, e, n) {
  const r = Array.from(t.children);
  return r.splice(n, 0, e), {
    ...t,
    children: r
  };
}
function _5e(t, e) {
  const r = e.map((i) => kc(t, i)).map((i) => wd(i).map(([o]) => o));
  return r.reduce((i, o) => i.concat(o.filter((s) => !i.includes(s))), r[0] || []);
}
function K4t(t, e) {
  const r = e.map((i) => kc(t, i)).map((i) => wd(i).map(([o]) => o));
  return r.reduce((i, o) => o.filter((s) => i.includes(s)), r[0] || []);
}
function W4t(t, e, n) {
  const r = _5e(t, e);
  return n.filter((i) => !r.includes(i));
}
function E9(t, e, n, r = !1) {
  return t.children ? e === 0 ? [[...n, t.name]] : t.children.flatMap((i) => E9(i, e - 1, [...n, t.name], r)).filter(Boolean) : r ? [[...n, t.name]] : null;
}
function X4t(t, e) {
  return {
    version: Vv.latestVersion,
    datatype: e,
    tree: t.tree
  };
}
function wve(t, e, n, r, i) {
  const o = kc(t, e), s = B5e(o, () => !0, (A, l) => {
    const c = r?.find((u) => gr(u.path, l))?.color ?? da(i);
    return {
      ...A,
      color: c.slice(0, 3)
    };
  }, []), a = {
    ...t,
    tree: [s]
  };
  return {
    treeToExport: X4t(a, n),
    nodeName: o.name
  };
}
function Z4t(t, e) {
  const n = kc(t, e);
  return { setToExport: wd(n), nodeName: n.name };
}
function eee(t) {
  return {
    version: Vv.latestVersion,
    datatype: t,
    tree: []
  };
}
function eUt(t, e, n) {
  const r = e.length - 1;
  return {
    title: t.name,
    nodeKey: k_(e),
    path: e,
    size: E5e(t),
    color: n?.find((i) => gr(i.path, e))?.color,
    level: r,
    isLeaf: (!t.children || t.children.length === 0) && !!t.set,
    height: LL(t)
  };
}
function tUt(t, e, n = [128, 128, 128]) {
  return [
    (t[0] - n[0]) * e + n[0],
    (t[1] - n[1]) * e + n[1],
    (t[2] - n[2]) * e + n[2]
  ];
}
function nUt(t, e, n, r) {
  let i = [];
  return e.forEach((o) => {
    const s = kc(t, o);
    if (s) {
      const a = wd(s), A = n?.find((l) => gr(l.path, o))?.color || da(r);
      i = [
        ...i,
        ...a.map(([l, c]) => [
          l,
          sae(c) ? A : tUt(A, c)
        ])
      ];
    }
  }), new Map(i);
}
function rUt(t, e, n) {
  let r = [];
  return e?.forEach((i) => {
    const o = kc(t, i);
    if (o) {
      const s = wd(o), a = n?.findIndex((A) => gr(A.path, i));
      r = [
        ...r,
        ...s.map(([A]) => [
          A,
          a
        ])
      ];
    }
  }), new Map(r);
}
function iUt(t, e, n, r) {
  let i = [];
  for (let o = 0; o < e.length; o += 1) {
    const s = e[o], a = kc(t, s);
    if (a) {
      const A = wd(a), l = n?.find((c) => gr(c.path, s))?.color || da(r);
      i = i.concat(A.map(([c]) => ({
        obsId: c,
        name: a.name,
        color: l
      })));
    }
  }
  return i;
}
function oUt(t, e, n, r, i, o) {
  const s = new Map(e.map((A, l) => [A, l])), a = [];
  return r.forEach((A) => {
    const l = kc(t, A);
    if (l) {
      const c = wd(l), u = i?.find((h) => gr(h.path, A))?.color || da(o), f = c.map(([h]) => {
        const d = s.get(h);
        return [
          n.data[0][d],
          -n.data[1][d]
        ];
      }).filter((h) => h.every((d) => typeof d == "number"));
      if (f.length > 2) {
        const h = xI(f.map(jl)), I = U4t(f, 1 / 0);
        if (I) {
          const m = v4t(h).geometry.coordinates;
          a.push({
            path: A,
            name: A[A.length - 1],
            hull: I,
            color: u,
            centroid: m
          });
        }
      }
    }
  }), a;
}
function S5e(t, e, n, r, i) {
  const o = [], s = (a, A) => A.some((l) => gr(l, a));
  return e.forEach((a) => {
    const A = kc(t, a);
    if (A) {
      const l = wd(A), c = r?.find((f) => gr(f.path, a))?.color || da(i), u = {
        key: z4t(),
        name: A.name,
        size: l.length,
        color: c,
        setNamePath: a,
        // used by the CellSetSizesPlot to determine if the bar should be grayed out
        isGrayedOut: !0
      };
      s(a, n) && (u.isGrayedOut = !1), o.push(u);
    }
  }), o;
}
function tee(t, e, n) {
  return gr([...e, t.name], n) ? null : t.children ? {
    ...t,
    children: t.children.map((r) => tee(r, [...e, t.name], n)).filter(Boolean)
  } : t;
}
function sUt(t, e) {
  let n = null;
  return t && t.tree.forEach((r) => {
    const i = [r.name], o = LL(r);
    oA(o).forEach((s) => {
      const a = s + 1, A = E9(r, a, [], !0);
      gr(A, e) && (n = { levelZeroPath: i, levelIndex: a });
    });
  }), n;
}
function aUt(t, e) {
  const n = [], r = [];
  let i = !1;
  function o(a, A) {
    n.push([...A, a.name]), a.children && a.children.forEach((l) => o(l, [...A, a.name]));
  }
  t.tree.forEach((a) => o(a, []));
  function s(a, A) {
    r.push([...A, a.name]), a.children && a.children.forEach((l) => o(l, [...A, a.name]));
  }
  return e.tree.forEach((a) => s(a, [])), r.forEach((a) => {
    n.find((A) => gr(A, a)) && (i = !0);
  }), i;
}
function y9(t, e) {
  const n = [...e || []], r = t.tree.map((o) => Array.from({
    length: LL(o) + 1
    // Need to add one because its an array.
  }).fill(0));
  function i(o, s, a, A) {
    const l = r[A][a], c = [...s, o.name];
    if (!n.find((f) => gr(f.path, c))) {
      const f = o.color ? o.color : Gv[l % Gv.length];
      n.push({
        path: c,
        color: f
      });
    }
    r[A][a] += 1, o.children && o.children.forEach((f) => i(f, c, a + 1, A));
  }
  return t.tree.forEach((o, s) => i(o, [], 0, s)), n;
}
function Q5e(t) {
  const { obsIndex: e, obsEmbedding: n, cellSets: r, cellSetSelection: i, cellSetColor: o, theme: s } = t;
  return i && i.length > 0 && r && e && n ? oUt(r, e, n, i, o, s) : [];
}
function sAe(t) {
  const e = /* @__PURE__ */ new Map();
  return t && t.tree.forEach((n) => {
    const r = LL(n);
    oA(r).forEach((i) => {
      const o = i + 1;
      E9(n, o, [], !0).forEach((a) => {
        const A = kc(t, a);
        A && !A.children && wd(A).forEach(([c]) => {
          e.has(c) ? e.get(c).push(a) : e.set(c, [a]);
        });
      });
    });
  }), e;
}
function w5e(t, e = [], n = []) {
  return t.children && t.children.forEach((r) => {
    const i = [...e, r.name];
    n.push(i), w5e(r, i, n);
  }), n;
}
function nee(t, e, n) {
  if (Array.isArray(t)) {
    let r = null, i = 0;
    if (t.forEach((o) => {
      o.filter((a, A) => a === e[A]).length === (n ? o.length : e.length) && o.length > i && (r = o, i = o.length);
    }), i > 0)
      return r;
    if (n)
      return [];
  }
  return [];
}
function AUt(t, e) {
  let n = 0, r = [];
  return e.forEach((i) => {
    const o = nee(t, i, !1);
    o.length > n && (n = o.length, r = i);
  }), r;
}
function lUt(t, e, n, r) {
  const i = w5e({ children: t.tree }), o = (s, a) => s?.some((A) => gr(A, a));
  return i.filter((s) => {
    if (o(n, s))
      return !1;
    if (!o(r, s)) {
      if (nee(r, s, !1).length > s.length)
        return !1;
      if (n) {
        if (n.length === 0 && s.length > 2)
          return !1;
        const a = nee(n, s, !0);
        if (n.length > 0 && a.length + 1 < s.length)
          return !1;
      }
    }
    return s[0] === e[0];
  });
}
function cUt(t, e) {
  const n = t.filter((o) => !e.find((s) => gr(s, o))), r = e.filter((o) => !t.find((s) => gr(o, s)));
  return n.length === 0 && r.length === 0 ? null : (r.length > 0 ? r[0] : n[0]).slice(0, -1);
}
var xve = {}, c7 = {}, u7 = 34, Jx = 10, f7 = 13;
function x5e(t) {
  return new Function("d", "return {" + t.map(function(e, n) {
    return JSON.stringify(e) + ": d[" + n + '] || ""';
  }).join(",") + "}");
}
function uUt(t, e) {
  var n = x5e(t);
  return function(r, i) {
    return e(n(r), i, t);
  };
}
function Rve(t) {
  var e = /* @__PURE__ */ Object.create(null), n = [];
  return t.forEach(function(r) {
    for (var i in r)
      i in e || n.push(e[i] = i);
  }), n;
}
function du(t, e) {
  var n = t + "", r = n.length;
  return r < e ? new Array(e - r + 1).join(0) + n : n;
}
function fUt(t) {
  return t < 0 ? "-" + du(-t, 6) : t > 9999 ? "+" + du(t, 6) : du(t, 4);
}
function gUt(t) {
  var e = t.getUTCHours(), n = t.getUTCMinutes(), r = t.getUTCSeconds(), i = t.getUTCMilliseconds();
  return isNaN(t) ? "Invalid Date" : fUt(t.getUTCFullYear()) + "-" + du(t.getUTCMonth() + 1, 2) + "-" + du(t.getUTCDate(), 2) + (i ? "T" + du(e, 2) + ":" + du(n, 2) + ":" + du(r, 2) + "." + du(i, 3) + "Z" : r ? "T" + du(e, 2) + ":" + du(n, 2) + ":" + du(r, 2) + "Z" : n || e ? "T" + du(e, 2) + ":" + du(n, 2) + "Z" : "");
}
function R5e(t) {
  var e = new RegExp('["' + t + `
\r]`), n = t.charCodeAt(0);
  function r(u, f) {
    var h, d, I = i(u, function(m, C) {
      if (h)
        return h(m, C - 1);
      d = m, h = f ? uUt(m, f) : x5e(m);
    });
    return I.columns = d || [], I;
  }
  function i(u, f) {
    var h = [], d = u.length, I = 0, m = 0, C, y = d <= 0, v = !1;
    u.charCodeAt(d - 1) === Jx && --d, u.charCodeAt(d - 1) === f7 && --d;
    function b() {
      if (y)
        return c7;
      if (v)
        return v = !1, xve;
      var w, R = I, M;
      if (u.charCodeAt(R) === u7) {
        for (; I++ < d && u.charCodeAt(I) !== u7 || u.charCodeAt(++I) === u7; )
          ;
        return (w = I) >= d ? y = !0 : (M = u.charCodeAt(I++)) === Jx ? v = !0 : M === f7 && (v = !0, u.charCodeAt(I) === Jx && ++I), u.slice(R + 1, w - 1).replace(/""/g, '"');
      }
      for (; I < d; ) {
        if ((M = u.charCodeAt(w = I++)) === Jx)
          v = !0;
        else if (M === f7)
          v = !0, u.charCodeAt(I) === Jx && ++I;
        else if (M !== n)
          continue;
        return u.slice(R, w);
      }
      return y = !0, u.slice(R, d);
    }
    for (; (C = b()) !== c7; ) {
      for (var Q = []; C !== xve && C !== c7; )
        Q.push(C), C = b();
      f && (Q = f(Q, m++)) == null || h.push(Q);
    }
    return h;
  }
  function o(u, f) {
    return u.map(function(h) {
      return f.map(function(d) {
        return c(h[d]);
      }).join(t);
    });
  }
  function s(u, f) {
    return f == null && (f = Rve(u)), [f.map(c).join(t)].concat(o(u, f)).join(`
`);
  }
  function a(u, f) {
    return f == null && (f = Rve(u)), o(u, f).join(`
`);
  }
  function A(u) {
    return u.map(l).join(`
`);
  }
  function l(u) {
    return u.map(c).join(t);
  }
  function c(u) {
    return u == null ? "" : u instanceof Date ? gUt(u) : e.test(u += "") ? '"' + u.replace(/"/g, '""') + '"' : u;
  }
  return {
    parse: r,
    parseRows: i,
    format: s,
    formatBody: a,
    formatRows: A,
    formatRow: l,
    formatValue: c
  };
}
var hUt = R5e(","), dUt = hUt.parse, ree = { exports: {} };
(function(t, e) {
  (function(n, r) {
    r(e);
  })(ei, function(n) {
    var r;
    function i() {
    }
    i.prototype = /* @__PURE__ */ Object.create(null);
    function o() {
      o.init.call(this);
    }
    o.EventEmitter = o, o.usingDomains = !1, o.prototype.domain = void 0, o.prototype._events = void 0, o.prototype._maxListeners = void 0, o.defaultMaxListeners = 10, o.init = function() {
      this.domain = null, o.usingDomains && r.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new i(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, o.prototype.setMaxListeners = function(F) {
      if (typeof F != "number" || F < 0 || isNaN(F))
        throw new TypeError('"n" argument must be a positive number');
      return this._maxListeners = F, this;
    };
    function s(G) {
      return G._maxListeners === void 0 ? o.defaultMaxListeners : G._maxListeners;
    }
    o.prototype.getMaxListeners = function() {
      return s(this);
    };
    function a(G, F, q) {
      if (F)
        G.call(q);
      else
        for (var ue = G.length, be = C(G, ue), Oe = 0; Oe < ue; ++Oe)
          be[Oe].call(q);
    }
    function A(G, F, q, ue) {
      if (F)
        G.call(q, ue);
      else
        for (var be = G.length, Oe = C(G, be), Ge = 0; Ge < be; ++Ge)
          Oe[Ge].call(q, ue);
    }
    function l(G, F, q, ue, be) {
      if (F)
        G.call(q, ue, be);
      else
        for (var Oe = G.length, Ge = C(G, Oe), ft = 0; ft < Oe; ++ft)
          Ge[ft].call(q, ue, be);
    }
    function c(G, F, q, ue, be, Oe) {
      if (F)
        G.call(q, ue, be, Oe);
      else
        for (var Ge = G.length, ft = C(G, Ge), Dt = 0; Dt < Ge; ++Dt)
          ft[Dt].call(q, ue, be, Oe);
    }
    function u(G, F, q, ue) {
      if (F)
        G.apply(q, ue);
      else
        for (var be = G.length, Oe = C(G, be), Ge = 0; Ge < be; ++Ge)
          Oe[Ge].apply(q, ue);
    }
    o.prototype.emit = function(F) {
      var q, ue, be, Oe, Ge, ft, Dt, Bn = F === "error";
      if (ft = this._events, ft)
        Bn = Bn && ft.error == null;
      else if (!Bn)
        return !1;
      if (Dt = this.domain, Bn) {
        if (q = arguments[1], Dt)
          q || (q = new Error('Uncaught, unspecified "error" event')), q.domainEmitter = this, q.domain = Dt, q.domainThrown = !1, Dt.emit("error", q);
        else {
          if (q instanceof Error)
            throw q;
          var Pn = new Error('Uncaught, unspecified "error" event. (' + q + ")");
          throw Pn.context = q, Pn;
        }
        return !1;
      }
      if (ue = ft[F], !ue)
        return !1;
      var ur = typeof ue == "function";
      switch (be = arguments.length, be) {
        case 1:
          a(ue, ur, this);
          break;
        case 2:
          A(ue, ur, this, arguments[1]);
          break;
        case 3:
          l(ue, ur, this, arguments[1], arguments[2]);
          break;
        case 4:
          c(ue, ur, this, arguments[1], arguments[2], arguments[3]);
          break;
        default:
          for (Oe = new Array(be - 1), Ge = 1; Ge < be; Ge++)
            Oe[Ge - 1] = arguments[Ge];
          u(ue, ur, this, Oe);
      }
      return !0;
    };
    function f(G, F, q, ue) {
      var be, Oe, Ge;
      if (typeof q != "function")
        throw new TypeError('"listener" argument must be a function');
      if (Oe = G._events, Oe ? (Oe.newListener && (G.emit(
        "newListener",
        F,
        q.listener ? q.listener : q
      ), Oe = G._events), Ge = Oe[F]) : (Oe = G._events = new i(), G._eventsCount = 0), !Ge)
        Ge = Oe[F] = q, ++G._eventsCount;
      else if (typeof Ge == "function" ? Ge = Oe[F] = ue ? [q, Ge] : [Ge, q] : ue ? Ge.unshift(q) : Ge.push(q), !Ge.warned && (be = s(G), be && be > 0 && Ge.length > be)) {
        Ge.warned = !0;
        var ft = new Error("Possible EventEmitter memory leak detected. " + Ge.length + " " + F + " listeners added. Use emitter.setMaxListeners() to increase limit");
        ft.name = "MaxListenersExceededWarning", ft.emitter = G, ft.type = F, ft.count = Ge.length, h(ft);
      }
      return G;
    }
    function h(G) {
      typeof console.warn == "function" ? console.warn(G) : console.log(G);
    }
    o.prototype.addListener = function(F, q) {
      return f(this, F, q, !1);
    }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(F, q) {
      return f(this, F, q, !0);
    };
    function d(G, F, q) {
      var ue = !1;
      function be() {
        G.removeListener(F, be), ue || (ue = !0, q.apply(G, arguments));
      }
      return be.listener = q, be;
    }
    o.prototype.once = function(F, q) {
      if (typeof q != "function")
        throw new TypeError('"listener" argument must be a function');
      return this.on(F, d(this, F, q)), this;
    }, o.prototype.prependOnceListener = function(F, q) {
      if (typeof q != "function")
        throw new TypeError('"listener" argument must be a function');
      return this.prependListener(F, d(this, F, q)), this;
    }, o.prototype.removeListener = function(F, q) {
      var ue, be, Oe, Ge, ft;
      if (typeof q != "function")
        throw new TypeError('"listener" argument must be a function');
      if (be = this._events, !be)
        return this;
      if (ue = be[F], !ue)
        return this;
      if (ue === q || ue.listener && ue.listener === q)
        --this._eventsCount === 0 ? this._events = new i() : (delete be[F], be.removeListener && this.emit("removeListener", F, ue.listener || q));
      else if (typeof ue != "function") {
        for (Oe = -1, Ge = ue.length; Ge-- > 0; )
          if (ue[Ge] === q || ue[Ge].listener && ue[Ge].listener === q) {
            ft = ue[Ge].listener, Oe = Ge;
            break;
          }
        if (Oe < 0)
          return this;
        if (ue.length === 1) {
          if (ue[0] = void 0, --this._eventsCount === 0)
            return this._events = new i(), this;
          delete be[F];
        } else
          m(ue, Oe);
        be.removeListener && this.emit("removeListener", F, ft || q);
      }
      return this;
    }, o.prototype.removeAllListeners = function(F) {
      var q, ue;
      if (ue = this._events, !ue)
        return this;
      if (!ue.removeListener)
        return arguments.length === 0 ? (this._events = new i(), this._eventsCount = 0) : ue[F] && (--this._eventsCount === 0 ? this._events = new i() : delete ue[F]), this;
      if (arguments.length === 0) {
        for (var be = Object.keys(ue), Oe = 0, Ge; Oe < be.length; ++Oe)
          Ge = be[Oe], Ge !== "removeListener" && this.removeAllListeners(Ge);
        return this.removeAllListeners("removeListener"), this._events = new i(), this._eventsCount = 0, this;
      }
      if (q = ue[F], typeof q == "function")
        this.removeListener(F, q);
      else if (q)
        do
          this.removeListener(F, q[q.length - 1]);
        while (q[0]);
      return this;
    }, o.prototype.listeners = function(F) {
      var q, ue, be = this._events;
      return be ? (q = be[F], q ? typeof q == "function" ? ue = [q.listener || q] : ue = y(q) : ue = []) : ue = [], ue;
    }, o.listenerCount = function(G, F) {
      return typeof G.listenerCount == "function" ? G.listenerCount(F) : I.call(G, F);
    }, o.prototype.listenerCount = I;
    function I(G) {
      var F = this._events;
      if (F) {
        var q = F[G];
        if (typeof q == "function")
          return 1;
        if (q)
          return q.length;
      }
      return 0;
    }
    o.prototype.eventNames = function() {
      return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
    };
    function m(G, F) {
      for (var q = F, ue = q + 1, be = G.length; ue < be; q += 1, ue += 1)
        G[q] = G[ue];
      G.pop();
    }
    function C(G, F) {
      for (var q = new Array(F); F--; )
        q[F] = G[F];
      return q;
    }
    function y(G) {
      for (var F = new Array(G.length), q = 0; q < F.length; ++q)
        F[q] = G[q].listener || G[q];
      return F;
    }
    var v = typeof ei < "u" ? ei : typeof self < "u" ? self : typeof window < "u" ? window : {}, b = [], Q = [], w = typeof Uint8Array < "u" ? Uint8Array : Array, R = !1;
    function M() {
      R = !0;
      for (var G = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", F = 0, q = G.length; F < q; ++F)
        b[F] = G[F], Q[G.charCodeAt(F)] = F;
      Q["-".charCodeAt(0)] = 62, Q["_".charCodeAt(0)] = 63;
    }
    function O(G) {
      R || M();
      var F, q, ue, be, Oe, Ge, ft = G.length;
      if (ft % 4 > 0)
        throw new Error("Invalid string. Length must be a multiple of 4");
      Oe = G[ft - 2] === "=" ? 2 : G[ft - 1] === "=" ? 1 : 0, Ge = new w(ft * 3 / 4 - Oe), ue = Oe > 0 ? ft - 4 : ft;
      var Dt = 0;
      for (F = 0, q = 0; F < ue; F += 4, q += 3)
        be = Q[G.charCodeAt(F)] << 18 | Q[G.charCodeAt(F + 1)] << 12 | Q[G.charCodeAt(F + 2)] << 6 | Q[G.charCodeAt(F + 3)], Ge[Dt++] = be >> 16 & 255, Ge[Dt++] = be >> 8 & 255, Ge[Dt++] = be & 255;
      return Oe === 2 ? (be = Q[G.charCodeAt(F)] << 2 | Q[G.charCodeAt(F + 1)] >> 4, Ge[Dt++] = be & 255) : Oe === 1 && (be = Q[G.charCodeAt(F)] << 10 | Q[G.charCodeAt(F + 1)] << 4 | Q[G.charCodeAt(F + 2)] >> 2, Ge[Dt++] = be >> 8 & 255, Ge[Dt++] = be & 255), Ge;
    }
    function L(G) {
      return b[G >> 18 & 63] + b[G >> 12 & 63] + b[G >> 6 & 63] + b[G & 63];
    }
    function N(G, F, q) {
      for (var ue, be = [], Oe = F; Oe < q; Oe += 3)
        ue = (G[Oe] << 16) + (G[Oe + 1] << 8) + G[Oe + 2], be.push(L(ue));
      return be.join("");
    }
    function k(G) {
      R || M();
      for (var F, q = G.length, ue = q % 3, be = "", Oe = [], Ge = 16383, ft = 0, Dt = q - ue; ft < Dt; ft += Ge)
        Oe.push(N(G, ft, ft + Ge > Dt ? Dt : ft + Ge));
      return ue === 1 ? (F = G[q - 1], be += b[F >> 2], be += b[F << 4 & 63], be += "==") : ue === 2 && (F = (G[q - 2] << 8) + G[q - 1], be += b[F >> 10], be += b[F >> 4 & 63], be += b[F << 2 & 63], be += "="), Oe.push(be), Oe.join("");
    }
    function $(G, F, q, ue, be) {
      var Oe, Ge, ft = be * 8 - ue - 1, Dt = (1 << ft) - 1, Bn = Dt >> 1, Pn = -7, ur = q ? be - 1 : 0, _s = q ? -1 : 1, bo = G[F + ur];
      for (ur += _s, Oe = bo & (1 << -Pn) - 1, bo >>= -Pn, Pn += ft; Pn > 0; Oe = Oe * 256 + G[F + ur], ur += _s, Pn -= 8)
        ;
      for (Ge = Oe & (1 << -Pn) - 1, Oe >>= -Pn, Pn += ue; Pn > 0; Ge = Ge * 256 + G[F + ur], ur += _s, Pn -= 8)
        ;
      if (Oe === 0)
        Oe = 1 - Bn;
      else {
        if (Oe === Dt)
          return Ge ? NaN : (bo ? -1 : 1) * (1 / 0);
        Ge = Ge + Math.pow(2, ue), Oe = Oe - Bn;
      }
      return (bo ? -1 : 1) * Ge * Math.pow(2, Oe - ue);
    }
    function U(G, F, q, ue, be, Oe) {
      var Ge, ft, Dt, Bn = Oe * 8 - be - 1, Pn = (1 << Bn) - 1, ur = Pn >> 1, _s = be === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, bo = ue ? 0 : Oe - 1, Yd = ue ? 1 : -1, Px = F < 0 || F === 0 && 1 / F < 0 ? 1 : 0;
      for (F = Math.abs(F), isNaN(F) || F === 1 / 0 ? (ft = isNaN(F) ? 1 : 0, Ge = Pn) : (Ge = Math.floor(Math.log(F) / Math.LN2), F * (Dt = Math.pow(2, -Ge)) < 1 && (Ge--, Dt *= 2), Ge + ur >= 1 ? F += _s / Dt : F += _s * Math.pow(2, 1 - ur), F * Dt >= 2 && (Ge++, Dt /= 2), Ge + ur >= Pn ? (ft = 0, Ge = Pn) : Ge + ur >= 1 ? (ft = (F * Dt - 1) * Math.pow(2, be), Ge = Ge + ur) : (ft = F * Math.pow(2, ur - 1) * Math.pow(2, be), Ge = 0)); be >= 8; G[q + bo] = ft & 255, bo += Yd, ft /= 256, be -= 8)
        ;
      for (Ge = Ge << be | ft, Bn += be; Bn > 0; G[q + bo] = Ge & 255, bo += Yd, Ge /= 256, Bn -= 8)
        ;
      G[q + bo - Yd] |= Px * 128;
    }
    var X = {}.toString, K = Array.isArray || function(G) {
      return X.call(G) == "[object Array]";
    }, z = 50;
    Z.TYPED_ARRAY_SUPPORT = v.TYPED_ARRAY_SUPPORT !== void 0 ? v.TYPED_ARRAY_SUPPORT : !0;
    function Y() {
      return Z.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
    }
    function V(G, F) {
      if (Y() < F)
        throw new RangeError("Invalid typed array length");
      return Z.TYPED_ARRAY_SUPPORT ? (G = new Uint8Array(F), G.__proto__ = Z.prototype) : (G === null && (G = new Z(F)), G.length = F), G;
    }
    function Z(G, F, q) {
      if (!Z.TYPED_ARRAY_SUPPORT && !(this instanceof Z))
        return new Z(G, F, q);
      if (typeof G == "number") {
        if (typeof F == "string")
          throw new Error(
            "If encoding is specified then the first argument must be a string"
          );
        return Ce(this, G);
      }
      return ce(this, G, F, q);
    }
    Z.poolSize = 8192, Z._augment = function(G) {
      return G.__proto__ = Z.prototype, G;
    };
    function ce(G, F, q, ue) {
      if (typeof F == "number")
        throw new TypeError('"value" argument must not be a number');
      return typeof ArrayBuffer < "u" && F instanceof ArrayBuffer ? Qe(G, F, q, ue) : typeof F == "string" ? Be(G, F, q) : xe(G, F);
    }
    Z.from = function(G, F, q) {
      return ce(null, G, F, q);
    }, Z.TYPED_ARRAY_SUPPORT && (Z.prototype.__proto__ = Uint8Array.prototype, Z.__proto__ = Uint8Array);
    function ee(G) {
      if (typeof G != "number")
        throw new TypeError('"size" argument must be a number');
      if (G < 0)
        throw new RangeError('"size" argument must not be negative');
    }
    function pe(G, F, q, ue) {
      return ee(F), F <= 0 ? V(G, F) : q !== void 0 ? typeof ue == "string" ? V(G, F).fill(q, ue) : V(G, F).fill(q) : V(G, F);
    }
    Z.alloc = function(G, F, q) {
      return pe(null, G, F, q);
    };
    function Ce(G, F) {
      if (ee(F), G = V(G, F < 0 ? 0 : Se(F) | 0), !Z.TYPED_ARRAY_SUPPORT)
        for (var q = 0; q < F; ++q)
          G[q] = 0;
      return G;
    }
    Z.allocUnsafe = function(G) {
      return Ce(null, G);
    }, Z.allocUnsafeSlow = function(G) {
      return Ce(null, G);
    };
    function Be(G, F, q) {
      if ((typeof q != "string" || q === "") && (q = "utf8"), !Z.isEncoding(q))
        throw new TypeError('"encoding" must be a valid string encoding');
      var ue = Ue(F, q) | 0;
      G = V(G, ue);
      var be = G.write(F, q);
      return be !== ue && (G = G.slice(0, be)), G;
    }
    function Ie(G, F) {
      var q = F.length < 0 ? 0 : Se(F.length) | 0;
      G = V(G, q);
      for (var ue = 0; ue < q; ue += 1)
        G[ue] = F[ue] & 255;
      return G;
    }
    function Qe(G, F, q, ue) {
      if (F.byteLength, q < 0 || F.byteLength < q)
        throw new RangeError("'offset' is out of bounds");
      if (F.byteLength < q + (ue || 0))
        throw new RangeError("'length' is out of bounds");
      return q === void 0 && ue === void 0 ? F = new Uint8Array(F) : ue === void 0 ? F = new Uint8Array(F, q) : F = new Uint8Array(F, q, ue), Z.TYPED_ARRAY_SUPPORT ? (G = F, G.__proto__ = Z.prototype) : G = Ie(G, F), G;
    }
    function xe(G, F) {
      if (De(F)) {
        var q = Se(F.length) | 0;
        return G = V(G, q), G.length === 0 || F.copy(G, 0, 0, q), G;
      }
      if (F) {
        if (typeof ArrayBuffer < "u" && F.buffer instanceof ArrayBuffer || "length" in F)
          return typeof F.length != "number" || Pt(F.length) ? V(G, 0) : Ie(G, F);
        if (F.type === "Buffer" && K(F.data))
          return Ie(G, F.data);
      }
      throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
    }
    function Se(G) {
      if (G >= Y())
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + Y().toString(16) + " bytes");
      return G | 0;
    }
    Z.isBuffer = dr;
    function De(G) {
      return !!(G != null && G._isBuffer);
    }
    Z.compare = function(F, q) {
      if (!De(F) || !De(q))
        throw new TypeError("Arguments must be Buffers");
      if (F === q)
        return 0;
      for (var ue = F.length, be = q.length, Oe = 0, Ge = Math.min(ue, be); Oe < Ge; ++Oe)
        if (F[Oe] !== q[Oe]) {
          ue = F[Oe], be = q[Oe];
          break;
        }
      return ue < be ? -1 : be < ue ? 1 : 0;
    }, Z.isEncoding = function(F) {
      switch (String(F).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, Z.concat = function(F, q) {
      if (!K(F))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (F.length === 0)
        return Z.alloc(0);
      var ue;
      if (q === void 0)
        for (q = 0, ue = 0; ue < F.length; ++ue)
          q += F[ue].length;
      var be = Z.allocUnsafe(q), Oe = 0;
      for (ue = 0; ue < F.length; ++ue) {
        var Ge = F[ue];
        if (!De(Ge))
          throw new TypeError('"list" argument must be an Array of Buffers');
        Ge.copy(be, Oe), Oe += Ge.length;
      }
      return be;
    };
    function Ue(G, F) {
      if (De(G))
        return G.length;
      if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(G) || G instanceof ArrayBuffer))
        return G.byteLength;
      typeof G != "string" && (G = "" + G);
      var q = G.length;
      if (q === 0)
        return 0;
      for (var ue = !1; ; )
        switch (F) {
          case "ascii":
          case "latin1":
          case "binary":
            return q;
          case "utf8":
          case "utf-8":
          case void 0:
            return un(G).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return q * 2;
          case "hex":
            return q >>> 1;
          case "base64":
            return En(G).length;
          default:
            if (ue)
              return un(G).length;
            F = ("" + F).toLowerCase(), ue = !0;
        }
    }
    Z.byteLength = Ue;
    function Te(G, F, q) {
      var ue = !1;
      if ((F === void 0 || F < 0) && (F = 0), F > this.length || ((q === void 0 || q > this.length) && (q = this.length), q <= 0) || (q >>>= 0, F >>>= 0, q <= F))
        return "";
      for (G || (G = "utf8"); ; )
        switch (G) {
          case "hex":
            return Xe(this, F, q);
          case "utf8":
          case "utf-8":
            return de(this, F, q);
          case "ascii":
            return qe(this, F, q);
          case "latin1":
          case "binary":
            return ke(this, F, q);
          case "base64":
            return Ae(this, F, q);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return rt(this, F, q);
          default:
            if (ue)
              throw new TypeError("Unknown encoding: " + G);
            G = (G + "").toLowerCase(), ue = !0;
        }
    }
    Z.prototype._isBuffer = !0;
    function se(G, F, q) {
      var ue = G[F];
      G[F] = G[q], G[q] = ue;
    }
    Z.prototype.swap16 = function() {
      var F = this.length;
      if (F % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var q = 0; q < F; q += 2)
        se(this, q, q + 1);
      return this;
    }, Z.prototype.swap32 = function() {
      var F = this.length;
      if (F % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var q = 0; q < F; q += 4)
        se(this, q, q + 3), se(this, q + 1, q + 2);
      return this;
    }, Z.prototype.swap64 = function() {
      var F = this.length;
      if (F % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var q = 0; q < F; q += 8)
        se(this, q, q + 7), se(this, q + 1, q + 6), se(this, q + 2, q + 5), se(this, q + 3, q + 4);
      return this;
    }, Z.prototype.toString = function() {
      var F = this.length | 0;
      return F === 0 ? "" : arguments.length === 0 ? de(this, 0, F) : Te.apply(this, arguments);
    }, Z.prototype.equals = function(F) {
      if (!De(F))
        throw new TypeError("Argument must be a Buffer");
      return this === F ? !0 : Z.compare(this, F) === 0;
    }, Z.prototype.inspect = function() {
      var F = "", q = z;
      return this.length > 0 && (F = this.toString("hex", 0, q).match(/.{2}/g).join(" "), this.length > q && (F += " ... ")), "<Buffer " + F + ">";
    }, Z.prototype.compare = function(F, q, ue, be, Oe) {
      if (!De(F))
        throw new TypeError("Argument must be a Buffer");
      if (q === void 0 && (q = 0), ue === void 0 && (ue = F ? F.length : 0), be === void 0 && (be = 0), Oe === void 0 && (Oe = this.length), q < 0 || ue > F.length || be < 0 || Oe > this.length)
        throw new RangeError("out of range index");
      if (be >= Oe && q >= ue)
        return 0;
      if (be >= Oe)
        return -1;
      if (q >= ue)
        return 1;
      if (q >>>= 0, ue >>>= 0, be >>>= 0, Oe >>>= 0, this === F)
        return 0;
      for (var Ge = Oe - be, ft = ue - q, Dt = Math.min(Ge, ft), Bn = this.slice(be, Oe), Pn = F.slice(q, ue), ur = 0; ur < Dt; ++ur)
        if (Bn[ur] !== Pn[ur]) {
          Ge = Bn[ur], ft = Pn[ur];
          break;
        }
      return Ge < ft ? -1 : ft < Ge ? 1 : 0;
    };
    function fe(G, F, q, ue, be) {
      if (G.length === 0)
        return -1;
      if (typeof q == "string" ? (ue = q, q = 0) : q > 2147483647 ? q = 2147483647 : q < -2147483648 && (q = -2147483648), q = +q, isNaN(q) && (q = be ? 0 : G.length - 1), q < 0 && (q = G.length + q), q >= G.length) {
        if (be)
          return -1;
        q = G.length - 1;
      } else if (q < 0)
        if (be)
          q = 0;
        else
          return -1;
      if (typeof F == "string" && (F = Z.from(F, ue)), De(F))
        return F.length === 0 ? -1 : W(G, F, q, ue, be);
      if (typeof F == "number")
        return F = F & 255, Z.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? be ? Uint8Array.prototype.indexOf.call(G, F, q) : Uint8Array.prototype.lastIndexOf.call(G, F, q) : W(G, [F], q, ue, be);
      throw new TypeError("val must be string, number or Buffer");
    }
    function W(G, F, q, ue, be) {
      var Oe = 1, Ge = G.length, ft = F.length;
      if (ue !== void 0 && (ue = String(ue).toLowerCase(), ue === "ucs2" || ue === "ucs-2" || ue === "utf16le" || ue === "utf-16le")) {
        if (G.length < 2 || F.length < 2)
          return -1;
        Oe = 2, Ge /= 2, ft /= 2, q /= 2;
      }
      function Dt(bo, Yd) {
        return Oe === 1 ? bo[Yd] : bo.readUInt16BE(Yd * Oe);
      }
      var Bn;
      if (be) {
        var Pn = -1;
        for (Bn = q; Bn < Ge; Bn++)
          if (Dt(G, Bn) === Dt(F, Pn === -1 ? 0 : Bn - Pn)) {
            if (Pn === -1 && (Pn = Bn), Bn - Pn + 1 === ft)
              return Pn * Oe;
          } else
            Pn !== -1 && (Bn -= Bn - Pn), Pn = -1;
      } else
        for (q + ft > Ge && (q = Ge - ft), Bn = q; Bn >= 0; Bn--) {
          for (var ur = !0, _s = 0; _s < ft; _s++)
            if (Dt(G, Bn + _s) !== Dt(F, _s)) {
              ur = !1;
              break;
            }
          if (ur)
            return Bn;
        }
      return -1;
    }
    Z.prototype.includes = function(F, q, ue) {
      return this.indexOf(F, q, ue) !== -1;
    }, Z.prototype.indexOf = function(F, q, ue) {
      return fe(this, F, q, ue, !0);
    }, Z.prototype.lastIndexOf = function(F, q, ue) {
      return fe(this, F, q, ue, !1);
    };
    function ge(G, F, q, ue) {
      q = Number(q) || 0;
      var be = G.length - q;
      ue ? (ue = Number(ue), ue > be && (ue = be)) : ue = be;
      var Oe = F.length;
      if (Oe % 2 !== 0)
        throw new TypeError("Invalid hex string");
      ue > Oe / 2 && (ue = Oe / 2);
      for (var Ge = 0; Ge < ue; ++Ge) {
        var ft = parseInt(F.substr(Ge * 2, 2), 16);
        if (isNaN(ft))
          return Ge;
        G[q + Ge] = ft;
      }
      return Ge;
    }
    function _e(G, F, q, ue) {
      return qn(un(F, G.length - q), G, q, ue);
    }
    function Re(G, F, q, ue) {
      return qn(hn(F), G, q, ue);
    }
    function Ee(G, F, q, ue) {
      return Re(G, F, q, ue);
    }
    function oe(G, F, q, ue) {
      return qn(En(F), G, q, ue);
    }
    function ie(G, F, q, ue) {
      return qn(We(F, G.length - q), G, q, ue);
    }
    Z.prototype.write = function(F, q, ue, be) {
      if (q === void 0)
        be = "utf8", ue = this.length, q = 0;
      else if (ue === void 0 && typeof q == "string")
        be = q, ue = this.length, q = 0;
      else if (isFinite(q))
        q = q | 0, isFinite(ue) ? (ue = ue | 0, be === void 0 && (be = "utf8")) : (be = ue, ue = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var Oe = this.length - q;
      if ((ue === void 0 || ue > Oe) && (ue = Oe), F.length > 0 && (ue < 0 || q < 0) || q > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      be || (be = "utf8");
      for (var Ge = !1; ; )
        switch (be) {
          case "hex":
            return ge(this, F, q, ue);
          case "utf8":
          case "utf-8":
            return _e(this, F, q, ue);
          case "ascii":
            return Re(this, F, q, ue);
          case "latin1":
          case "binary":
            return Ee(this, F, q, ue);
          case "base64":
            return oe(this, F, q, ue);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ie(this, F, q, ue);
          default:
            if (Ge)
              throw new TypeError("Unknown encoding: " + be);
            be = ("" + be).toLowerCase(), Ge = !0;
        }
    }, Z.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function Ae(G, F, q) {
      return F === 0 && q === G.length ? k(G) : k(G.slice(F, q));
    }
    function de(G, F, q) {
      q = Math.min(G.length, q);
      for (var ue = [], be = F; be < q; ) {
        var Oe = G[be], Ge = null, ft = Oe > 239 ? 4 : Oe > 223 ? 3 : Oe > 191 ? 2 : 1;
        if (be + ft <= q) {
          var Dt, Bn, Pn, ur;
          switch (ft) {
            case 1:
              Oe < 128 && (Ge = Oe);
              break;
            case 2:
              Dt = G[be + 1], (Dt & 192) === 128 && (ur = (Oe & 31) << 6 | Dt & 63, ur > 127 && (Ge = ur));
              break;
            case 3:
              Dt = G[be + 1], Bn = G[be + 2], (Dt & 192) === 128 && (Bn & 192) === 128 && (ur = (Oe & 15) << 12 | (Dt & 63) << 6 | Bn & 63, ur > 2047 && (ur < 55296 || ur > 57343) && (Ge = ur));
              break;
            case 4:
              Dt = G[be + 1], Bn = G[be + 2], Pn = G[be + 3], (Dt & 192) === 128 && (Bn & 192) === 128 && (Pn & 192) === 128 && (ur = (Oe & 15) << 18 | (Dt & 63) << 12 | (Bn & 63) << 6 | Pn & 63, ur > 65535 && ur < 1114112 && (Ge = ur));
          }
        }
        Ge === null ? (Ge = 65533, ft = 1) : Ge > 65535 && (Ge -= 65536, ue.push(Ge >>> 10 & 1023 | 55296), Ge = 56320 | Ge & 1023), ue.push(Ge), be += ft;
      }
      return Pe(ue);
    }
    var we = 4096;
    function Pe(G) {
      var F = G.length;
      if (F <= we)
        return String.fromCharCode.apply(String, G);
      for (var q = "", ue = 0; ue < F; )
        q += String.fromCharCode.apply(
          String,
          G.slice(ue, ue += we)
        );
      return q;
    }
    function qe(G, F, q) {
      var ue = "";
      q = Math.min(G.length, q);
      for (var be = F; be < q; ++be)
        ue += String.fromCharCode(G[be] & 127);
      return ue;
    }
    function ke(G, F, q) {
      var ue = "";
      q = Math.min(G.length, q);
      for (var be = F; be < q; ++be)
        ue += String.fromCharCode(G[be]);
      return ue;
    }
    function Xe(G, F, q) {
      var ue = G.length;
      (!F || F < 0) && (F = 0), (!q || q < 0 || q > ue) && (q = ue);
      for (var be = "", Oe = F; Oe < q; ++Oe)
        be += It(G[Oe]);
      return be;
    }
    function rt(G, F, q) {
      for (var ue = G.slice(F, q), be = "", Oe = 0; Oe < ue.length; Oe += 2)
        be += String.fromCharCode(ue[Oe] + ue[Oe + 1] * 256);
      return be;
    }
    Z.prototype.slice = function(F, q) {
      var ue = this.length;
      F = ~~F, q = q === void 0 ? ue : ~~q, F < 0 ? (F += ue, F < 0 && (F = 0)) : F > ue && (F = ue), q < 0 ? (q += ue, q < 0 && (q = 0)) : q > ue && (q = ue), q < F && (q = F);
      var be;
      if (Z.TYPED_ARRAY_SUPPORT)
        be = this.subarray(F, q), be.__proto__ = Z.prototype;
      else {
        var Oe = q - F;
        be = new Z(Oe, void 0);
        for (var Ge = 0; Ge < Oe; ++Ge)
          be[Ge] = this[Ge + F];
      }
      return be;
    };
    function it(G, F, q) {
      if (G % 1 !== 0 || G < 0)
        throw new RangeError("offset is not uint");
      if (G + F > q)
        throw new RangeError("Trying to access beyond buffer length");
    }
    Z.prototype.readUIntLE = function(F, q, ue) {
      F = F | 0, q = q | 0, ue || it(F, q, this.length);
      for (var be = this[F], Oe = 1, Ge = 0; ++Ge < q && (Oe *= 256); )
        be += this[F + Ge] * Oe;
      return be;
    }, Z.prototype.readUIntBE = function(F, q, ue) {
      F = F | 0, q = q | 0, ue || it(F, q, this.length);
      for (var be = this[F + --q], Oe = 1; q > 0 && (Oe *= 256); )
        be += this[F + --q] * Oe;
      return be;
    }, Z.prototype.readUInt8 = function(F, q) {
      return q || it(F, 1, this.length), this[F];
    }, Z.prototype.readUInt16LE = function(F, q) {
      return q || it(F, 2, this.length), this[F] | this[F + 1] << 8;
    }, Z.prototype.readUInt16BE = function(F, q) {
      return q || it(F, 2, this.length), this[F] << 8 | this[F + 1];
    }, Z.prototype.readUInt32LE = function(F, q) {
      return q || it(F, 4, this.length), (this[F] | this[F + 1] << 8 | this[F + 2] << 16) + this[F + 3] * 16777216;
    }, Z.prototype.readUInt32BE = function(F, q) {
      return q || it(F, 4, this.length), this[F] * 16777216 + (this[F + 1] << 16 | this[F + 2] << 8 | this[F + 3]);
    }, Z.prototype.readIntLE = function(F, q, ue) {
      F = F | 0, q = q | 0, ue || it(F, q, this.length);
      for (var be = this[F], Oe = 1, Ge = 0; ++Ge < q && (Oe *= 256); )
        be += this[F + Ge] * Oe;
      return Oe *= 128, be >= Oe && (be -= Math.pow(2, 8 * q)), be;
    }, Z.prototype.readIntBE = function(F, q, ue) {
      F = F | 0, q = q | 0, ue || it(F, q, this.length);
      for (var be = q, Oe = 1, Ge = this[F + --be]; be > 0 && (Oe *= 256); )
        Ge += this[F + --be] * Oe;
      return Oe *= 128, Ge >= Oe && (Ge -= Math.pow(2, 8 * q)), Ge;
    }, Z.prototype.readInt8 = function(F, q) {
      return q || it(F, 1, this.length), this[F] & 128 ? (255 - this[F] + 1) * -1 : this[F];
    }, Z.prototype.readInt16LE = function(F, q) {
      q || it(F, 2, this.length);
      var ue = this[F] | this[F + 1] << 8;
      return ue & 32768 ? ue | 4294901760 : ue;
    }, Z.prototype.readInt16BE = function(F, q) {
      q || it(F, 2, this.length);
      var ue = this[F + 1] | this[F] << 8;
      return ue & 32768 ? ue | 4294901760 : ue;
    }, Z.prototype.readInt32LE = function(F, q) {
      return q || it(F, 4, this.length), this[F] | this[F + 1] << 8 | this[F + 2] << 16 | this[F + 3] << 24;
    }, Z.prototype.readInt32BE = function(F, q) {
      return q || it(F, 4, this.length), this[F] << 24 | this[F + 1] << 16 | this[F + 2] << 8 | this[F + 3];
    }, Z.prototype.readFloatLE = function(F, q) {
      return q || it(F, 4, this.length), $(this, F, !0, 23, 4);
    }, Z.prototype.readFloatBE = function(F, q) {
      return q || it(F, 4, this.length), $(this, F, !1, 23, 4);
    }, Z.prototype.readDoubleLE = function(F, q) {
      return q || it(F, 8, this.length), $(this, F, !0, 52, 8);
    }, Z.prototype.readDoubleBE = function(F, q) {
      return q || it(F, 8, this.length), $(this, F, !1, 52, 8);
    };
    function ht(G, F, q, ue, be, Oe) {
      if (!De(G))
        throw new TypeError('"buffer" argument must be a Buffer instance');
      if (F > be || F < Oe)
        throw new RangeError('"value" argument is out of bounds');
      if (q + ue > G.length)
        throw new RangeError("Index out of range");
    }
    Z.prototype.writeUIntLE = function(F, q, ue, be) {
      if (F = +F, q = q | 0, ue = ue | 0, !be) {
        var Oe = Math.pow(2, 8 * ue) - 1;
        ht(this, F, q, ue, Oe, 0);
      }
      var Ge = 1, ft = 0;
      for (this[q] = F & 255; ++ft < ue && (Ge *= 256); )
        this[q + ft] = F / Ge & 255;
      return q + ue;
    }, Z.prototype.writeUIntBE = function(F, q, ue, be) {
      if (F = +F, q = q | 0, ue = ue | 0, !be) {
        var Oe = Math.pow(2, 8 * ue) - 1;
        ht(this, F, q, ue, Oe, 0);
      }
      var Ge = ue - 1, ft = 1;
      for (this[q + Ge] = F & 255; --Ge >= 0 && (ft *= 256); )
        this[q + Ge] = F / ft & 255;
      return q + ue;
    }, Z.prototype.writeUInt8 = function(F, q, ue) {
      return F = +F, q = q | 0, ue || ht(this, F, q, 1, 255, 0), Z.TYPED_ARRAY_SUPPORT || (F = Math.floor(F)), this[q] = F & 255, q + 1;
    };
    function mt(G, F, q, ue) {
      F < 0 && (F = 65535 + F + 1);
      for (var be = 0, Oe = Math.min(G.length - q, 2); be < Oe; ++be)
        G[q + be] = (F & 255 << 8 * (ue ? be : 1 - be)) >>> (ue ? be : 1 - be) * 8;
    }
    Z.prototype.writeUInt16LE = function(F, q, ue) {
      return F = +F, q = q | 0, ue || ht(this, F, q, 2, 65535, 0), Z.TYPED_ARRAY_SUPPORT ? (this[q] = F & 255, this[q + 1] = F >>> 8) : mt(this, F, q, !0), q + 2;
    }, Z.prototype.writeUInt16BE = function(F, q, ue) {
      return F = +F, q = q | 0, ue || ht(this, F, q, 2, 65535, 0), Z.TYPED_ARRAY_SUPPORT ? (this[q] = F >>> 8, this[q + 1] = F & 255) : mt(this, F, q, !1), q + 2;
    };
    function _t(G, F, q, ue) {
      F < 0 && (F = 4294967295 + F + 1);
      for (var be = 0, Oe = Math.min(G.length - q, 4); be < Oe; ++be)
        G[q + be] = F >>> (ue ? be : 3 - be) * 8 & 255;
    }
    Z.prototype.writeUInt32LE = function(F, q, ue) {
      return F = +F, q = q | 0, ue || ht(this, F, q, 4, 4294967295, 0), Z.TYPED_ARRAY_SUPPORT ? (this[q + 3] = F >>> 24, this[q + 2] = F >>> 16, this[q + 1] = F >>> 8, this[q] = F & 255) : _t(this, F, q, !0), q + 4;
    }, Z.prototype.writeUInt32BE = function(F, q, ue) {
      return F = +F, q = q | 0, ue || ht(this, F, q, 4, 4294967295, 0), Z.TYPED_ARRAY_SUPPORT ? (this[q] = F >>> 24, this[q + 1] = F >>> 16, this[q + 2] = F >>> 8, this[q + 3] = F & 255) : _t(this, F, q, !1), q + 4;
    }, Z.prototype.writeIntLE = function(F, q, ue, be) {
      if (F = +F, q = q | 0, !be) {
        var Oe = Math.pow(2, 8 * ue - 1);
        ht(this, F, q, ue, Oe - 1, -Oe);
      }
      var Ge = 0, ft = 1, Dt = 0;
      for (this[q] = F & 255; ++Ge < ue && (ft *= 256); )
        F < 0 && Dt === 0 && this[q + Ge - 1] !== 0 && (Dt = 1), this[q + Ge] = (F / ft >> 0) - Dt & 255;
      return q + ue;
    }, Z.prototype.writeIntBE = function(F, q, ue, be) {
      if (F = +F, q = q | 0, !be) {
        var Oe = Math.pow(2, 8 * ue - 1);
        ht(this, F, q, ue, Oe - 1, -Oe);
      }
      var Ge = ue - 1, ft = 1, Dt = 0;
      for (this[q + Ge] = F & 255; --Ge >= 0 && (ft *= 256); )
        F < 0 && Dt === 0 && this[q + Ge + 1] !== 0 && (Dt = 1), this[q + Ge] = (F / ft >> 0) - Dt & 255;
      return q + ue;
    }, Z.prototype.writeInt8 = function(F, q, ue) {
      return F = +F, q = q | 0, ue || ht(this, F, q, 1, 127, -128), Z.TYPED_ARRAY_SUPPORT || (F = Math.floor(F)), F < 0 && (F = 255 + F + 1), this[q] = F & 255, q + 1;
    }, Z.prototype.writeInt16LE = function(F, q, ue) {
      return F = +F, q = q | 0, ue || ht(this, F, q, 2, 32767, -32768), Z.TYPED_ARRAY_SUPPORT ? (this[q] = F & 255, this[q + 1] = F >>> 8) : mt(this, F, q, !0), q + 2;
    }, Z.prototype.writeInt16BE = function(F, q, ue) {
      return F = +F, q = q | 0, ue || ht(this, F, q, 2, 32767, -32768), Z.TYPED_ARRAY_SUPPORT ? (this[q] = F >>> 8, this[q + 1] = F & 255) : mt(this, F, q, !1), q + 2;
    }, Z.prototype.writeInt32LE = function(F, q, ue) {
      return F = +F, q = q | 0, ue || ht(this, F, q, 4, 2147483647, -2147483648), Z.TYPED_ARRAY_SUPPORT ? (this[q] = F & 255, this[q + 1] = F >>> 8, this[q + 2] = F >>> 16, this[q + 3] = F >>> 24) : _t(this, F, q, !0), q + 4;
    }, Z.prototype.writeInt32BE = function(F, q, ue) {
      return F = +F, q = q | 0, ue || ht(this, F, q, 4, 2147483647, -2147483648), F < 0 && (F = 4294967295 + F + 1), Z.TYPED_ARRAY_SUPPORT ? (this[q] = F >>> 24, this[q + 1] = F >>> 16, this[q + 2] = F >>> 8, this[q + 3] = F & 255) : _t(this, F, q, !1), q + 4;
    };
    function Ct(G, F, q, ue, be, Oe) {
      if (q + ue > G.length)
        throw new RangeError("Index out of range");
      if (q < 0)
        throw new RangeError("Index out of range");
    }
    function zt(G, F, q, ue, be) {
      return be || Ct(G, F, q, 4), U(G, F, q, ue, 23, 4), q + 4;
    }
    Z.prototype.writeFloatLE = function(F, q, ue) {
      return zt(this, F, q, !0, ue);
    }, Z.prototype.writeFloatBE = function(F, q, ue) {
      return zt(this, F, q, !1, ue);
    };
    function jt(G, F, q, ue, be) {
      return be || Ct(G, F, q, 8), U(G, F, q, ue, 52, 8), q + 8;
    }
    Z.prototype.writeDoubleLE = function(F, q, ue) {
      return jt(this, F, q, !0, ue);
    }, Z.prototype.writeDoubleBE = function(F, q, ue) {
      return jt(this, F, q, !1, ue);
    }, Z.prototype.copy = function(F, q, ue, be) {
      if (ue || (ue = 0), !be && be !== 0 && (be = this.length), q >= F.length && (q = F.length), q || (q = 0), be > 0 && be < ue && (be = ue), be === ue || F.length === 0 || this.length === 0)
        return 0;
      if (q < 0)
        throw new RangeError("targetStart out of bounds");
      if (ue < 0 || ue >= this.length)
        throw new RangeError("sourceStart out of bounds");
      if (be < 0)
        throw new RangeError("sourceEnd out of bounds");
      be > this.length && (be = this.length), F.length - q < be - ue && (be = F.length - q + ue);
      var Oe = be - ue, Ge;
      if (this === F && ue < q && q < be)
        for (Ge = Oe - 1; Ge >= 0; --Ge)
          F[Ge + q] = this[Ge + ue];
      else if (Oe < 1e3 || !Z.TYPED_ARRAY_SUPPORT)
        for (Ge = 0; Ge < Oe; ++Ge)
          F[Ge + q] = this[Ge + ue];
      else
        Uint8Array.prototype.set.call(
          F,
          this.subarray(ue, ue + Oe),
          q
        );
      return Oe;
    }, Z.prototype.fill = function(F, q, ue, be) {
      if (typeof F == "string") {
        if (typeof q == "string" ? (be = q, q = 0, ue = this.length) : typeof ue == "string" && (be = ue, ue = this.length), F.length === 1) {
          var Oe = F.charCodeAt(0);
          Oe < 256 && (F = Oe);
        }
        if (be !== void 0 && typeof be != "string")
          throw new TypeError("encoding must be a string");
        if (typeof be == "string" && !Z.isEncoding(be))
          throw new TypeError("Unknown encoding: " + be);
      } else
        typeof F == "number" && (F = F & 255);
      if (q < 0 || this.length < q || this.length < ue)
        throw new RangeError("Out of range index");
      if (ue <= q)
        return this;
      q = q >>> 0, ue = ue === void 0 ? this.length : ue >>> 0, F || (F = 0);
      var Ge;
      if (typeof F == "number")
        for (Ge = q; Ge < ue; ++Ge)
          this[Ge] = F;
      else {
        var ft = De(F) ? F : un(new Z(F, be).toString()), Dt = ft.length;
        for (Ge = 0; Ge < ue - q; ++Ge)
          this[Ge + q] = ft[Ge % Dt];
      }
      return this;
    };
    var lt = /[^+\/0-9A-Za-z-_]/g;
    function Ht(G) {
      if (G = vt(G).replace(lt, ""), G.length < 2)
        return "";
      for (; G.length % 4 !== 0; )
        G = G + "=";
      return G;
    }
    function vt(G) {
      return G.trim ? G.trim() : G.replace(/^\s+|\s+$/g, "");
    }
    function It(G) {
      return G < 16 ? "0" + G.toString(16) : G.toString(16);
    }
    function un(G, F) {
      F = F || 1 / 0;
      for (var q, ue = G.length, be = null, Oe = [], Ge = 0; Ge < ue; ++Ge) {
        if (q = G.charCodeAt(Ge), q > 55295 && q < 57344) {
          if (!be) {
            if (q > 56319) {
              (F -= 3) > -1 && Oe.push(239, 191, 189);
              continue;
            } else if (Ge + 1 === ue) {
              (F -= 3) > -1 && Oe.push(239, 191, 189);
              continue;
            }
            be = q;
            continue;
          }
          if (q < 56320) {
            (F -= 3) > -1 && Oe.push(239, 191, 189), be = q;
            continue;
          }
          q = (be - 55296 << 10 | q - 56320) + 65536;
        } else
          be && (F -= 3) > -1 && Oe.push(239, 191, 189);
        if (be = null, q < 128) {
          if ((F -= 1) < 0)
            break;
          Oe.push(q);
        } else if (q < 2048) {
          if ((F -= 2) < 0)
            break;
          Oe.push(
            q >> 6 | 192,
            q & 63 | 128
          );
        } else if (q < 65536) {
          if ((F -= 3) < 0)
            break;
          Oe.push(
            q >> 12 | 224,
            q >> 6 & 63 | 128,
            q & 63 | 128
          );
        } else if (q < 1114112) {
          if ((F -= 4) < 0)
            break;
          Oe.push(
            q >> 18 | 240,
            q >> 12 & 63 | 128,
            q >> 6 & 63 | 128,
            q & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return Oe;
    }
    function hn(G) {
      for (var F = [], q = 0; q < G.length; ++q)
        F.push(G.charCodeAt(q) & 255);
      return F;
    }
    function We(G, F) {
      for (var q, ue, be, Oe = [], Ge = 0; Ge < G.length && !((F -= 2) < 0); ++Ge)
        q = G.charCodeAt(Ge), ue = q >> 8, be = q % 256, Oe.push(be), Oe.push(ue);
      return Oe;
    }
    function En(G) {
      return O(Ht(G));
    }
    function qn(G, F, q, ue) {
      for (var be = 0; be < ue && !(be + q >= F.length || be >= G.length); ++be)
        F[be + q] = G[be];
      return be;
    }
    function Pt(G) {
      return G !== G;
    }
    function dr(G) {
      return G != null && (!!G._isBuffer || yr(G) || jn(G));
    }
    function yr(G) {
      return !!G.constructor && typeof G.constructor.isBuffer == "function" && G.constructor.isBuffer(G);
    }
    function jn(G) {
      return typeof G.readFloatLE == "function" && typeof G.slice == "function" && yr(G.slice(0, 0));
    }
    function Ot() {
      throw new Error("setTimeout has not been defined");
    }
    function yn() {
      throw new Error("clearTimeout has not been defined");
    }
    var Fn = Ot, xn = yn;
    typeof v.setTimeout == "function" && (Fn = setTimeout), typeof v.clearTimeout == "function" && (xn = clearTimeout);
    function vn(G) {
      if (Fn === setTimeout)
        return setTimeout(G, 0);
      if ((Fn === Ot || !Fn) && setTimeout)
        return Fn = setTimeout, setTimeout(G, 0);
      try {
        return Fn(G, 0);
      } catch {
        try {
          return Fn.call(null, G, 0);
        } catch {
          return Fn.call(this, G, 0);
        }
      }
    }
    function nt(G) {
      if (xn === clearTimeout)
        return clearTimeout(G);
      if ((xn === yn || !xn) && clearTimeout)
        return xn = clearTimeout, clearTimeout(G);
      try {
        return xn(G);
      } catch {
        try {
          return xn.call(null, G);
        } catch {
          return xn.call(this, G);
        }
      }
    }
    var st = [], xt = !1, Me, _ = -1;
    function ye() {
      !xt || !Me || (xt = !1, Me.length ? st = Me.concat(st) : _ = -1, st.length && He());
    }
    function He() {
      if (!xt) {
        var G = vn(ye);
        xt = !0;
        for (var F = st.length; F; ) {
          for (Me = st, st = []; ++_ < F; )
            Me && Me[_].run();
          _ = -1, F = st.length;
        }
        Me = null, xt = !1, nt(G);
      }
    }
    function ze(G) {
      var F = new Array(arguments.length - 1);
      if (arguments.length > 1)
        for (var q = 1; q < arguments.length; q++)
          F[q - 1] = arguments[q];
      st.push(new tt(G, F)), st.length === 1 && !xt && vn(He);
    }
    function tt(G, F) {
      this.fun = G, this.array = F;
    }
    tt.prototype.run = function() {
      this.fun.apply(null, this.array);
    };
    var At = v.performance || {};
    At.now || At.mozNow || At.msNow || At.oNow || At.webkitNow;
    var pt;
    typeof Object.create == "function" ? pt = function(F, q) {
      F.super_ = q, F.prototype = Object.create(q.prototype, {
        constructor: {
          value: F,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : pt = function(F, q) {
      F.super_ = q;
      var ue = function() {
      };
      ue.prototype = q.prototype, F.prototype = new ue(), F.prototype.constructor = F;
    };
    var Bt = pt, Rt = /%[sdj%]/g;
    function Lt(G) {
      if (!Wn(G)) {
        for (var F = [], q = 0; q < arguments.length; q++)
          F.push(Sn(arguments[q]));
        return F.join(" ");
      }
      for (var q = 1, ue = arguments, be = ue.length, Oe = String(G).replace(Rt, function(ft) {
        if (ft === "%%")
          return "%";
        if (q >= be)
          return ft;
        switch (ft) {
          case "%s":
            return String(ue[q++]);
          case "%d":
            return Number(ue[q++]);
          case "%j":
            try {
              return JSON.stringify(ue[q++]);
            } catch {
              return "[Circular]";
            }
          default:
            return ft;
        }
      }), Ge = ue[q]; q < be; Ge = ue[++q])
        $e(Ge) || !hc(Ge) ? Oe += " " + Ge : Oe += " " + Sn(Ge);
      return Oe;
    }
    function rn(G, F) {
      if (Is(v.process))
        return function() {
          return rn(G, F).apply(this, arguments);
        };
      var q = !1;
      function ue() {
        return q || (console.error(F), q = !0), G.apply(this, arguments);
      }
      return ue;
    }
    var Wr = {}, pr;
    function Vt(G) {
      if (Is(pr) && (pr = ""), G = G.toUpperCase(), !Wr[G])
        if (new RegExp("\\b" + G + "\\b", "i").test(pr)) {
          var F = 0;
          Wr[G] = function() {
            var q = Lt.apply(null, arguments);
            console.error("%s %d: %s", G, F, q);
          };
        } else
          Wr[G] = function() {
          };
      return Wr[G];
    }
    function Sn(G, F) {
      var q = {
        seen: [],
        stylize: vr
      };
      return arguments.length >= 3 && (q.depth = arguments[2]), arguments.length >= 4 && (q.colors = arguments[3]), Mr(F) ? q.showHidden = F : F && Ki(q, F), Is(q.showHidden) && (q.showHidden = !1), Is(q.depth) && (q.depth = 2), Is(q.colors) && (q.colors = !1), Is(q.customInspect) && (q.customInspect = !0), q.colors && (q.stylize = kn), $t(q, G, q.depth);
    }
    Sn.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, Sn.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function kn(G, F) {
      var q = Sn.styles[F];
      return q ? "\x1B[" + Sn.colors[q][0] + "m" + G + "\x1B[" + Sn.colors[q][1] + "m" : G;
    }
    function vr(G, F) {
      return G;
    }
    function Tr(G) {
      var F = {};
      return G.forEach(function(q, ue) {
        F[q] = !0;
      }), F;
    }
    function $t(G, F, q) {
      if (G.customInspect && F && dc(F.inspect) && // Filter out the util module, it's inspect function is special
      F.inspect !== Sn && // Also filter out any prototype objects using the circular check.
      !(F.constructor && F.constructor.prototype === F)) {
        var ue = F.inspect(q, G);
        return Wn(ue) || (ue = $t(G, ue, q)), ue;
      }
      var be = Ye(G, F);
      if (be)
        return be;
      var Oe = Object.keys(F), Ge = Tr(Oe);
      if (G.showHidden && (Oe = Object.getOwnPropertyNames(F)), ml(F) && (Oe.indexOf("message") >= 0 || Oe.indexOf("description") >= 0))
        return en(F);
      if (Oe.length === 0) {
        if (dc(F)) {
          var ft = F.name ? ": " + F.name : "";
          return G.stylize("[Function" + ft + "]", "special");
        }
        if (Ao(F))
          return G.stylize(RegExp.prototype.toString.call(F), "regexp");
        if (or(F))
          return G.stylize(Date.prototype.toString.call(F), "date");
        if (ml(F))
          return en(F);
      }
      var Dt = "", Bn = !1, Pn = ["{", "}"];
      if (mr(F) && (Bn = !0, Pn = ["[", "]"]), dc(F)) {
        var ur = F.name ? ": " + F.name : "";
        Dt = " [Function" + ur + "]";
      }
      if (Ao(F) && (Dt = " " + RegExp.prototype.toString.call(F)), or(F) && (Dt = " " + Date.prototype.toUTCString.call(F)), ml(F) && (Dt = " " + en(F)), Oe.length === 0 && (!Bn || F.length == 0))
        return Pn[0] + Dt + Pn[1];
      if (q < 0)
        return Ao(F) ? G.stylize(RegExp.prototype.toString.call(F), "regexp") : G.stylize("[Object]", "special");
      G.seen.push(F);
      var _s;
      return Bn ? _s = Ir(G, F, q, Ge, Oe) : _s = Oe.map(function(bo) {
        return zr(G, F, q, Ge, bo, Bn);
      }), G.seen.pop(), In(_s, Dt, Pn);
    }
    function Ye(G, F) {
      if (Is(F))
        return G.stylize("undefined", "undefined");
      if (Wn(F)) {
        var q = "'" + JSON.stringify(F).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return G.stylize(q, "string");
      }
      if (Ps(F))
        return G.stylize("" + F, "number");
      if (Mr(F))
        return G.stylize("" + F, "boolean");
      if ($e(F))
        return G.stylize("null", "null");
    }
    function en(G) {
      return "[" + Error.prototype.toString.call(G) + "]";
    }
    function Ir(G, F, q, ue, be) {
      for (var Oe = [], Ge = 0, ft = F.length; Ge < ft; ++Ge)
        Ne(F, String(Ge)) ? Oe.push(zr(
          G,
          F,
          q,
          ue,
          String(Ge),
          !0
        )) : Oe.push("");
      return be.forEach(function(Dt) {
        Dt.match(/^\d+$/) || Oe.push(zr(
          G,
          F,
          q,
          ue,
          Dt,
          !0
        ));
      }), Oe;
    }
    function zr(G, F, q, ue, be, Oe) {
      var Ge, ft, Dt;
      if (Dt = Object.getOwnPropertyDescriptor(F, be) || { value: F[be] }, Dt.get ? Dt.set ? ft = G.stylize("[Getter/Setter]", "special") : ft = G.stylize("[Getter]", "special") : Dt.set && (ft = G.stylize("[Setter]", "special")), Ne(ue, be) || (Ge = "[" + be + "]"), ft || (G.seen.indexOf(Dt.value) < 0 ? ($e(q) ? ft = $t(G, Dt.value, null) : ft = $t(G, Dt.value, q - 1), ft.indexOf(`
`) > -1 && (Oe ? ft = ft.split(`
`).map(function(Bn) {
        return "  " + Bn;
      }).join(`
`).substr(2) : ft = `
` + ft.split(`
`).map(function(Bn) {
        return "   " + Bn;
      }).join(`
`))) : ft = G.stylize("[Circular]", "special")), Is(Ge)) {
        if (Oe && be.match(/^\d+$/))
          return ft;
        Ge = JSON.stringify("" + be), Ge.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Ge = Ge.substr(1, Ge.length - 2), Ge = G.stylize(Ge, "name")) : (Ge = Ge.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), Ge = G.stylize(Ge, "string"));
      }
      return Ge + ": " + ft;
    }
    function In(G, F, q) {
      var ue = G.reduce(function(be, Oe) {
        return Oe.indexOf(`
`) >= 0, be + Oe.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return ue > 60 ? q[0] + (F === "" ? "" : F + `
 `) + " " + G.join(`,
  `) + " " + q[1] : q[0] + F + " " + G.join(", ") + " " + q[1];
    }
    function mr(G) {
      return Array.isArray(G);
    }
    function Mr(G) {
      return typeof G == "boolean";
    }
    function $e(G) {
      return G === null;
    }
    function Ps(G) {
      return typeof G == "number";
    }
    function Wn(G) {
      return typeof G == "string";
    }
    function Is(G) {
      return G === void 0;
    }
    function Ao(G) {
      return hc(G) && Wa(G) === "[object RegExp]";
    }
    function hc(G) {
      return typeof G == "object" && G !== null;
    }
    function or(G) {
      return hc(G) && Wa(G) === "[object Date]";
    }
    function ml(G) {
      return hc(G) && (Wa(G) === "[object Error]" || G instanceof Error);
    }
    function dc(G) {
      return typeof G == "function";
    }
    function Wa(G) {
      return Object.prototype.toString.call(G);
    }
    function Ki(G, F) {
      if (!F || !hc(F))
        return G;
      for (var q = Object.keys(F), ue = q.length; ue--; )
        G[q[ue]] = F[q[ue]];
      return G;
    }
    function Ne(G, F) {
      return Object.prototype.hasOwnProperty.call(G, F);
    }
    function Fe() {
      this.head = null, this.tail = null, this.length = 0;
    }
    Fe.prototype.push = function(G) {
      var F = { data: G, next: null };
      this.length > 0 ? this.tail.next = F : this.head = F, this.tail = F, ++this.length;
    }, Fe.prototype.unshift = function(G) {
      var F = { data: G, next: this.head };
      this.length === 0 && (this.tail = F), this.head = F, ++this.length;
    }, Fe.prototype.shift = function() {
      if (this.length !== 0) {
        var G = this.head.data;
        return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, G;
      }
    }, Fe.prototype.clear = function() {
      this.head = this.tail = null, this.length = 0;
    }, Fe.prototype.join = function(G) {
      if (this.length === 0)
        return "";
      for (var F = this.head, q = "" + F.data; F = F.next; )
        q += G + F.data;
      return q;
    }, Fe.prototype.concat = function(G) {
      if (this.length === 0)
        return Z.alloc(0);
      if (this.length === 1)
        return this.head.data;
      for (var F = Z.allocUnsafe(G >>> 0), q = this.head, ue = 0; q; )
        q.data.copy(F, ue), ue += q.data.length, q = q.next;
      return F;
    };
    var Ze = Z.isEncoding || function(G) {
      switch (G && G.toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
          return !0;
        default:
          return !1;
      }
    };
    function Ve(G) {
      if (G && !Ze(G))
        throw new Error("Unknown encoding: " + G);
    }
    function Mt(G) {
      switch (this.encoding = (G || "utf8").toLowerCase().replace(/[-_]/, ""), Ve(G), this.encoding) {
        case "utf8":
          this.surrogateSize = 3;
          break;
        case "ucs2":
        case "utf16le":
          this.surrogateSize = 2, this.detectIncompleteChar = lr;
          break;
        case "base64":
          this.surrogateSize = 3, this.detectIncompleteChar = lo;
          break;
        default:
          this.write = An;
          return;
      }
      this.charBuffer = new Z(6), this.charReceived = 0, this.charLength = 0;
    }
    Mt.prototype.write = function(G) {
      for (var F = ""; this.charLength; ) {
        var q = G.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : G.length;
        if (G.copy(this.charBuffer, this.charReceived, 0, q), this.charReceived += q, this.charReceived < this.charLength)
          return "";
        G = G.slice(q, G.length), F = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
        var be = F.charCodeAt(F.length - 1);
        if (be >= 55296 && be <= 56319) {
          this.charLength += this.surrogateSize, F = "";
          continue;
        }
        if (this.charReceived = this.charLength = 0, G.length === 0)
          return F;
        break;
      }
      this.detectIncompleteChar(G);
      var ue = G.length;
      this.charLength && (G.copy(this.charBuffer, 0, G.length - this.charReceived, ue), ue -= this.charReceived), F += G.toString(this.encoding, 0, ue);
      var ue = F.length - 1, be = F.charCodeAt(ue);
      if (be >= 55296 && be <= 56319) {
        var Oe = this.surrogateSize;
        return this.charLength += Oe, this.charReceived += Oe, this.charBuffer.copy(this.charBuffer, Oe, 0, Oe), G.copy(this.charBuffer, 0, 0, Oe), F.substring(0, ue);
      }
      return F;
    }, Mt.prototype.detectIncompleteChar = function(G) {
      for (var F = G.length >= 3 ? 3 : G.length; F > 0; F--) {
        var q = G[G.length - F];
        if (F == 1 && q >> 5 == 6) {
          this.charLength = 2;
          break;
        }
        if (F <= 2 && q >> 4 == 14) {
          this.charLength = 3;
          break;
        }
        if (F <= 3 && q >> 3 == 30) {
          this.charLength = 4;
          break;
        }
      }
      this.charReceived = F;
    }, Mt.prototype.end = function(G) {
      var F = "";
      if (G && G.length && (F = this.write(G)), this.charReceived) {
        var q = this.charReceived, ue = this.charBuffer, be = this.encoding;
        F += ue.slice(0, q).toString(be);
      }
      return F;
    };
    function An(G) {
      return G.toString(this.encoding);
    }
    function lr(G) {
      this.charReceived = G.length % 2, this.charLength = this.charReceived ? 2 : 0;
    }
    function lo(G) {
      this.charReceived = G.length % 3, this.charLength = this.charReceived ? 3 : 0;
    }
    To.ReadableState = Wi;
    var nn = Vt("stream");
    Bt(To, o);
    function Xn(G, F, q) {
      if (typeof G.prependListener == "function")
        return G.prependListener(F, q);
      !G._events || !G._events[F] ? G.on(F, q) : Array.isArray(G._events[F]) ? G._events[F].unshift(q) : G._events[F] = [q, G._events[F]];
    }
    function Zn(G, F) {
      return G.listeners(F).length;
    }
    function Wi(G, F) {
      G = G || {}, this.objectMode = !!G.objectMode, F instanceof Ca && (this.objectMode = this.objectMode || !!G.readableObjectMode);
      var q = G.highWaterMark, ue = this.objectMode ? 16 : 16 * 1024;
      this.highWaterMark = q || q === 0 ? q : ue, this.highWaterMark = ~~this.highWaterMark, this.buffer = new Fe(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.defaultEncoding = G.defaultEncoding || "utf8", this.ranOut = !1, this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, G.encoding && (this.decoder = new Mt(G.encoding), this.encoding = G.encoding);
    }
    function To(G) {
      if (!(this instanceof To))
        return new To(G);
      this._readableState = new Wi(G, this), this.readable = !0, G && typeof G.read == "function" && (this._read = G.read), o.call(this);
    }
    To.prototype.push = function(G, F) {
      var q = this._readableState;
      return !q.objectMode && typeof G == "string" && (F = F || q.defaultEncoding, F !== q.encoding && (G = Z.from(G, F), F = "")), pm(this, q, G, F, !1);
    }, To.prototype.unshift = function(G) {
      var F = this._readableState;
      return pm(this, F, G, "", !0);
    }, To.prototype.isPaused = function() {
      return this._readableState.flowing === !1;
    };
    function pm(G, F, q, ue, be) {
      var Oe = nh(F, q);
      if (Oe)
        G.emit("error", Oe);
      else if (q === null)
        F.reading = !1, ns(G, F);
      else if (F.objectMode || q && q.length > 0)
        if (F.ended && !be) {
          var Ge = new Error("stream.push() after EOF");
          G.emit("error", Ge);
        } else if (F.endEmitted && be) {
          var ft = new Error("stream.unshift() after end event");
          G.emit("error", ft);
        } else {
          var Dt;
          F.decoder && !be && !ue && (q = F.decoder.write(q), Dt = !F.objectMode && q.length === 0), be || (F.reading = !1), Dt || (F.flowing && F.length === 0 && !F.sync ? (G.emit("data", q), G.read(0)) : (F.length += F.objectMode ? 1 : q.length, be ? F.buffer.unshift(q) : F.buffer.push(q), F.needReadable && pc(G))), Li(G, F);
        }
      else
        be || (F.reading = !1);
      return na(F);
    }
    function na(G) {
      return !G.ended && (G.needReadable || G.length < G.highWaterMark || G.length === 0);
    }
    To.prototype.setEncoding = function(G) {
      return this._readableState.decoder = new Mt(G), this._readableState.encoding = G, this;
    };
    var Cl = 8388608;
    function La(G) {
      return G >= Cl ? G = Cl : (G--, G |= G >>> 1, G |= G >>> 2, G |= G >>> 4, G |= G >>> 8, G |= G >>> 16, G++), G;
    }
    function ai(G, F) {
      return G <= 0 || F.length === 0 && F.ended ? 0 : F.objectMode ? 1 : G !== G ? F.flowing && F.length ? F.buffer.head.data.length : F.length : (G > F.highWaterMark && (F.highWaterMark = La(G)), G <= F.length ? G : F.ended ? F.length : (F.needReadable = !0, 0));
    }
    To.prototype.read = function(G) {
      nn("read", G), G = parseInt(G, 10);
      var F = this._readableState, q = G;
      if (G !== 0 && (F.emittedReadable = !1), G === 0 && F.needReadable && (F.length >= F.highWaterMark || F.ended))
        return nn("read: emitReadable", F.length, F.ended), F.length === 0 && F.ended ? uo(this) : pc(this), null;
      if (G = ai(G, F), G === 0 && F.ended)
        return F.length === 0 && uo(this), null;
      var ue = F.needReadable;
      nn("need readable", ue), (F.length === 0 || F.length - G < F.highWaterMark) && (ue = !0, nn("length less than watermark", ue)), F.ended || F.reading ? (ue = !1, nn("reading or ended", ue)) : ue && (nn("do read"), F.reading = !0, F.sync = !0, F.length === 0 && (F.needReadable = !0), this._read(F.highWaterMark), F.sync = !1, F.reading || (G = ai(q, F)));
      var be;
      return G > 0 ? be = Mi(G, F) : be = null, be === null ? (F.needReadable = !0, G = 0) : F.length -= G, F.length === 0 && (F.ended || (F.needReadable = !0), q !== G && F.ended && uo(this)), be !== null && this.emit("data", be), be;
    };
    function nh(G, F) {
      var q = null;
      return !dr(F) && typeof F != "string" && F !== null && F !== void 0 && !G.objectMode && (q = new TypeError("Invalid non-string/buffer chunk")), q;
    }
    function ns(G, F) {
      if (!F.ended) {
        if (F.decoder) {
          var q = F.decoder.end();
          q && q.length && (F.buffer.push(q), F.length += F.objectMode ? 1 : q.length);
        }
        F.ended = !0, pc(G);
      }
    }
    function pc(G) {
      var F = G._readableState;
      F.needReadable = !1, F.emittedReadable || (nn("emitReadable", F.flowing), F.emittedReadable = !0, F.sync ? ze(Ic, G) : Ic(G));
    }
    function Ic(G) {
      nn("emit readable"), G.emit("readable"), ms(G);
    }
    function Li(G, F) {
      F.readingMore || (F.readingMore = !0, ze(ks, G, F));
    }
    function ks(G, F) {
      for (var q = F.length; !F.reading && !F.flowing && !F.ended && F.length < F.highWaterMark && (nn("maybeReadMore read 0"), G.read(0), q !== F.length); )
        q = F.length;
      F.readingMore = !1;
    }
    To.prototype._read = function(G) {
      this.emit("error", new Error("not implemented"));
    }, To.prototype.pipe = function(G, F) {
      var q = this, ue = this._readableState;
      switch (ue.pipesCount) {
        case 0:
          ue.pipes = G;
          break;
        case 1:
          ue.pipes = [ue.pipes, G];
          break;
        default:
          ue.pipes.push(G);
          break;
      }
      ue.pipesCount += 1, nn("pipe count=%d opts=%j", ue.pipesCount, F);
      var be = !F || F.end !== !1, Oe = be ? ft : Pn;
      ue.endEmitted ? ze(Oe) : q.once("end", Oe), G.on("unpipe", Ge);
      function Ge(j1) {
        nn("onunpipe"), j1 === q && Pn();
      }
      function ft() {
        nn("onend"), G.end();
      }
      var Dt = Vu(q);
      G.on("drain", Dt);
      var Bn = !1;
      function Pn() {
        nn("cleanup"), G.removeListener("close", Yd), G.removeListener("finish", Px), G.removeListener("drain", Dt), G.removeListener("error", bo), G.removeListener("unpipe", Ge), q.removeListener("end", ft), q.removeListener("end", Pn), q.removeListener("data", _s), Bn = !0, ue.awaitDrain && (!G._writableState || G._writableState.needDrain) && Dt();
      }
      var ur = !1;
      q.on("data", _s);
      function _s(j1) {
        nn("ondata"), ur = !1;
        var Pct = G.write(j1);
        Pct === !1 && !ur && ((ue.pipesCount === 1 && ue.pipes === G || ue.pipesCount > 1 && Kf(ue.pipes, G) !== -1) && !Bn && (nn("false write response, pause", q._readableState.awaitDrain), q._readableState.awaitDrain++, ur = !0), q.pause());
      }
      function bo(j1) {
        nn("onerror", j1), az(), G.removeListener("error", bo), Zn(G, "error") === 0 && G.emit("error", j1);
      }
      Xn(G, "error", bo);
      function Yd() {
        G.removeListener("finish", Px), az();
      }
      G.once("close", Yd);
      function Px() {
        nn("onfinish"), G.removeListener("close", Yd), az();
      }
      G.once("finish", Px);
      function az() {
        nn("unpipe"), q.unpipe(G);
      }
      return G.emit("pipe", q), ue.flowing || (nn("pipe resume"), q.resume()), G;
    };
    function Vu(G) {
      return function() {
        var F = G._readableState;
        nn("pipeOnDrain", F.awaitDrain), F.awaitDrain && F.awaitDrain--, F.awaitDrain === 0 && G.listeners("data").length && (F.flowing = !0, ms(G));
      };
    }
    To.prototype.unpipe = function(G) {
      var F = this._readableState;
      if (F.pipesCount === 0)
        return this;
      if (F.pipesCount === 1)
        return G && G !== F.pipes ? this : (G || (G = F.pipes), F.pipes = null, F.pipesCount = 0, F.flowing = !1, G && G.emit("unpipe", this), this);
      if (!G) {
        var q = F.pipes, ue = F.pipesCount;
        F.pipes = null, F.pipesCount = 0, F.flowing = !1;
        for (var be = 0; be < ue; be++)
          q[be].emit("unpipe", this);
        return this;
      }
      var Oe = Kf(F.pipes, G);
      return Oe === -1 ? this : (F.pipes.splice(Oe, 1), F.pipesCount -= 1, F.pipesCount === 1 && (F.pipes = F.pipes[0]), G.emit("unpipe", this), this);
    }, To.prototype.on = function(G, F) {
      var q = o.prototype.on.call(this, G, F);
      if (G === "data")
        this._readableState.flowing !== !1 && this.resume();
      else if (G === "readable") {
        var ue = this._readableState;
        !ue.endEmitted && !ue.readableListening && (ue.readableListening = ue.needReadable = !0, ue.emittedReadable = !1, ue.reading ? ue.length && pc(this) : ze(zn, this));
      }
      return q;
    }, To.prototype.addListener = To.prototype.on;
    function zn(G) {
      nn("readable nexttick read 0"), G.read(0);
    }
    To.prototype.resume = function() {
      var G = this._readableState;
      return G.flowing || (nn("resume"), G.flowing = !0, Gr(this, G)), this;
    };
    function Gr(G, F) {
      F.resumeScheduled || (F.resumeScheduled = !0, ze(_r, G, F));
    }
    function _r(G, F) {
      F.reading || (nn("resume read 0"), G.read(0)), F.resumeScheduled = !1, F.awaitDrain = 0, G.emit("resume"), ms(G), F.flowing && !F.reading && G.read(0);
    }
    To.prototype.pause = function() {
      return nn("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (nn("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
    };
    function ms(G) {
      var F = G._readableState;
      for (nn("flow", F.flowing); F.flowing && G.read() !== null; )
        ;
    }
    To.prototype.wrap = function(G) {
      var F = this._readableState, q = !1, ue = this;
      G.on("end", function() {
        if (nn("wrapped end"), F.decoder && !F.ended) {
          var Ge = F.decoder.end();
          Ge && Ge.length && ue.push(Ge);
        }
        ue.push(null);
      }), G.on("data", function(Ge) {
        if (nn("wrapped data"), F.decoder && (Ge = F.decoder.write(Ge)), !(F.objectMode && Ge == null) && !(!F.objectMode && (!Ge || !Ge.length))) {
          var ft = ue.push(Ge);
          ft || (q = !0, G.pause());
        }
      });
      for (var be in G)
        this[be] === void 0 && typeof G[be] == "function" && (this[be] = function(Ge) {
          return function() {
            return G[Ge].apply(G, arguments);
          };
        }(be));
      var Oe = ["error", "close", "destroy", "pause", "resume"];
      return F1(Oe, function(Ge) {
        G.on(Ge, ue.emit.bind(ue, Ge));
      }), ue._read = function(Ge) {
        nn("wrapped _read", Ge), q && (q = !1, G.resume());
      }, ue;
    }, To._fromList = Mi;
    function Mi(G, F) {
      if (F.length === 0)
        return null;
      var q;
      return F.objectMode ? q = F.buffer.shift() : !G || G >= F.length ? (F.decoder ? q = F.buffer.join("") : F.buffer.length === 1 ? q = F.buffer.head.data : q = F.buffer.concat(F.length), F.buffer.clear()) : q = mc(G, F.buffer, F.decoder), q;
    }
    function mc(G, F, q) {
      var ue;
      return G < F.head.data.length ? (ue = F.head.data.slice(0, G), F.head.data = F.head.data.slice(G)) : G === F.head.data.length ? ue = F.shift() : ue = q ? EA(G, F) : co(G, F), ue;
    }
    function EA(G, F) {
      var q = F.head, ue = 1, be = q.data;
      for (G -= be.length; q = q.next; ) {
        var Oe = q.data, Ge = G > Oe.length ? Oe.length : G;
        if (Ge === Oe.length ? be += Oe : be += Oe.slice(0, G), G -= Ge, G === 0) {
          Ge === Oe.length ? (++ue, q.next ? F.head = q.next : F.head = F.tail = null) : (F.head = q, q.data = Oe.slice(Ge));
          break;
        }
        ++ue;
      }
      return F.length -= ue, be;
    }
    function co(G, F) {
      var q = Z.allocUnsafe(G), ue = F.head, be = 1;
      for (ue.data.copy(q), G -= ue.data.length; ue = ue.next; ) {
        var Oe = ue.data, Ge = G > Oe.length ? Oe.length : G;
        if (Oe.copy(q, q.length - G, 0, Ge), G -= Ge, G === 0) {
          Ge === Oe.length ? (++be, ue.next ? F.head = ue.next : F.head = F.tail = null) : (F.head = ue, ue.data = Oe.slice(Ge));
          break;
        }
        ++be;
      }
      return F.length -= be, q;
    }
    function uo(G) {
      var F = G._readableState;
      if (F.length > 0)
        throw new Error('"endReadable()" called on non-empty stream');
      F.endEmitted || (F.ended = !0, ze(ou, F, G));
    }
    function ou(G, F) {
      !G.endEmitted && G.length === 0 && (G.endEmitted = !0, F.readable = !1, F.emit("end"));
    }
    function F1(G, F) {
      for (var q = 0, ue = G.length; q < ue; q++)
        F(G[q], q);
    }
    function Kf(G, F) {
      for (var q = 0, ue = G.length; q < ue; q++)
        if (G[q] === F)
          return q;
      return -1;
    }
    yo.WritableState = fo, Bt(yo, o);
    function S0() {
    }
    function Wf(G, F, q) {
      this.chunk = G, this.encoding = F, this.callback = q, this.next = null;
    }
    function fo(G, F) {
      Object.defineProperty(this, "buffer", {
        get: rn(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")
      }), G = G || {}, this.objectMode = !!G.objectMode, F instanceof Ca && (this.objectMode = this.objectMode || !!G.writableObjectMode);
      var q = G.highWaterMark, ue = this.objectMode ? 16 : 16 * 1024;
      this.highWaterMark = q || q === 0 ? q : ue, this.highWaterMark = ~~this.highWaterMark, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1;
      var be = G.decodeStrings === !1;
      this.decodeStrings = !be, this.defaultEncoding = G.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(Oe) {
        w0(F, Oe);
      }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new yl(this);
    }
    fo.prototype.getBuffer = function() {
      for (var F = this.bufferedRequest, q = []; F; )
        q.push(F), F = F.next;
      return q;
    };
    function yo(G) {
      if (!(this instanceof yo) && !(this instanceof Ca))
        return new yo(G);
      this._writableState = new fo(G, this), this.writable = !0, G && (typeof G.write == "function" && (this._write = G.write), typeof G.writev == "function" && (this._writev = G.writev)), o.call(this);
    }
    yo.prototype.pipe = function() {
      this.emit("error", new Error("Cannot pipe, not readable"));
    };
    function Gs(G, F) {
      var q = new Error("write after end");
      G.emit("error", q), ze(F, q);
    }
    function Ju(G, F, q, ue) {
      var be = !0, Oe = !1;
      return q === null ? Oe = new TypeError("May not write null values to stream") : !Z.isBuffer(q) && typeof q != "string" && q !== void 0 && !F.objectMode && (Oe = new TypeError("Invalid non-string/buffer chunk")), Oe && (G.emit("error", Oe), ze(ue, Oe), be = !1), be;
    }
    yo.prototype.write = function(G, F, q) {
      var ue = this._writableState, be = !1;
      return typeof F == "function" && (q = F, F = null), Z.isBuffer(G) ? F = "buffer" : F || (F = ue.defaultEncoding), typeof q != "function" && (q = S0), ue.ended ? Gs(this, q) : Ju(this, ue, G, q) && (ue.pendingcb++, be = Q0(this, ue, G, F, q)), be;
    }, yo.prototype.cork = function() {
      var G = this._writableState;
      G.corked++;
    }, yo.prototype.uncork = function() {
      var G = this._writableState;
      G.corked && (G.corked--, !G.writing && !G.corked && !G.finished && !G.bufferProcessing && G.bufferedRequest && su(this, G));
    }, yo.prototype.setDefaultEncoding = function(F) {
      if (typeof F == "string" && (F = F.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((F + "").toLowerCase()) > -1))
        throw new TypeError("Unknown encoding: " + F);
      return this._writableState.defaultEncoding = F, this;
    };
    function Cc(G, F, q) {
      return !G.objectMode && G.decodeStrings !== !1 && typeof F == "string" && (F = Z.from(F, q)), F;
    }
    function Q0(G, F, q, ue, be) {
      q = Cc(F, q, ue), Z.isBuffer(q) && (ue = "buffer");
      var Oe = F.objectMode ? 1 : q.length;
      F.length += Oe;
      var Ge = F.length < F.highWaterMark;
      if (Ge || (F.needDrain = !0), F.writing || F.corked) {
        var ft = F.lastBufferedRequest;
        F.lastBufferedRequest = new Wf(q, ue, be), ft ? ft.next = F.lastBufferedRequest : F.bufferedRequest = F.lastBufferedRequest, F.bufferedRequestCount += 1;
      } else
        ki(G, F, !1, Oe, q, ue, be);
      return Ge;
    }
    function ki(G, F, q, ue, be, Oe, Ge) {
      F.writelen = ue, F.writecb = Ge, F.writing = !0, F.sync = !0, q ? G._writev(be, F.onwrite) : G._write(be, Oe, F.onwrite), F.sync = !1;
    }
    function Dn(G, F, q, ue, be) {
      --F.pendingcb, q ? ze(be, ue) : be(ue), G._writableState.errorEmitted = !0, G.emit("error", ue);
    }
    function P1(G) {
      G.writing = !1, G.writecb = null, G.length -= G.writelen, G.writelen = 0;
    }
    function w0(G, F) {
      var q = G._writableState, ue = q.sync, be = q.writecb;
      if (P1(q), F)
        Dn(G, q, ue, F, be);
      else {
        var Oe = rh(q);
        !Oe && !q.corked && !q.bufferProcessing && q.bufferedRequest && su(G, q), ue ? ze(rs, G, q, Oe, be) : rs(G, q, Oe, be);
      }
    }
    function rs(G, F, q, ue) {
      q || El(G, F), F.pendingcb--, ue(), ny(G, F);
    }
    function El(G, F) {
      F.length === 0 && F.needDrain && (F.needDrain = !1, G.emit("drain"));
    }
    function su(G, F) {
      F.bufferProcessing = !0;
      var q = F.bufferedRequest;
      if (G._writev && q && q.next) {
        var ue = F.bufferedRequestCount, be = new Array(ue), Oe = F.corkedRequestsFree;
        Oe.entry = q;
        for (var Ge = 0; q; )
          be[Ge] = q, q = q.next, Ge += 1;
        ki(G, F, !0, F.length, be, "", Oe.finish), F.pendingcb++, F.lastBufferedRequest = null, Oe.next ? (F.corkedRequestsFree = Oe.next, Oe.next = null) : F.corkedRequestsFree = new yl(F);
      } else {
        for (; q; ) {
          var ft = q.chunk, Dt = q.encoding, Bn = q.callback, Pn = F.objectMode ? 1 : ft.length;
          if (ki(G, F, !1, Pn, ft, Dt, Bn), q = q.next, F.writing)
            break;
        }
        q === null && (F.lastBufferedRequest = null);
      }
      F.bufferedRequestCount = 0, F.bufferedRequest = q, F.bufferProcessing = !1;
    }
    yo.prototype._write = function(G, F, q) {
      q(new Error("not implemented"));
    }, yo.prototype._writev = null, yo.prototype.end = function(G, F, q) {
      var ue = this._writableState;
      typeof G == "function" ? (q = G, G = null, F = null) : typeof F == "function" && (q = F, F = null), G != null && this.write(G, F), ue.corked && (ue.corked = 1, this.uncork()), !ue.ending && !ue.finished && Xr(this, ue, q);
    };
    function rh(G) {
      return G.ending && G.length === 0 && G.bufferedRequest === null && !G.finished && !G.writing;
    }
    function Ku(G, F) {
      F.prefinished || (F.prefinished = !0, G.emit("prefinish"));
    }
    function ny(G, F) {
      var q = rh(F);
      return q && (F.pendingcb === 0 ? (Ku(G, F), F.finished = !0, G.emit("finish")) : Ku(G, F)), q;
    }
    function Xr(G, F, q) {
      F.ending = !0, ny(G, F), q && (F.finished ? ze(q) : G.once("finish", q)), F.ended = !0, G.writable = !1;
    }
    function yl(G) {
      var F = this;
      this.next = null, this.entry = null, this.finish = function(q) {
        var ue = F.entry;
        for (F.entry = null; ue; ) {
          var be = ue.callback;
          G.pendingcb--, be(q), ue = ue.next;
        }
        G.corkedRequestsFree ? G.corkedRequestsFree.next = F : G.corkedRequestsFree = F;
      };
    }
    Bt(Ca, To);
    for (var yi = Object.keys(yo.prototype), vl = 0; vl < yi.length; vl++) {
      var ma = yi[vl];
      Ca.prototype[ma] || (Ca.prototype[ma] = yo.prototype[ma]);
    }
    function Ca(G) {
      if (!(this instanceof Ca))
        return new Ca(G);
      To.call(this, G), yo.call(this, G), G && G.readable === !1 && (this.readable = !1), G && G.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, G && G.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", Ur);
    }
    function Ur() {
      this.allowHalfOpen || this._writableState.ended || ze(ih, this);
    }
    function ih(G) {
      G.end();
    }
    Bt(go, Ca);
    function Oi(G) {
      this.afterTransform = function(F, q) {
        return x0(G, F, q);
      }, this.needTransform = !1, this.transforming = !1, this.writecb = null, this.writechunk = null, this.writeencoding = null;
    }
    function x0(G, F, q) {
      var ue = G._transformState;
      ue.transforming = !1;
      var be = ue.writecb;
      if (!be)
        return G.emit("error", new Error("no writecb in Transform class"));
      ue.writechunk = null, ue.writecb = null, q != null && G.push(q), be(F);
      var Oe = G._readableState;
      Oe.reading = !1, (Oe.needReadable || Oe.length < Oe.highWaterMark) && G._read(Oe.highWaterMark);
    }
    function go(G) {
      if (!(this instanceof go))
        return new go(G);
      Ca.call(this, G), this._transformState = new Oi(this);
      var F = this;
      this._readableState.needReadable = !0, this._readableState.sync = !1, G && (typeof G.transform == "function" && (this._transform = G.transform), typeof G.flush == "function" && (this._flush = G.flush)), this.once("prefinish", function() {
        typeof this._flush == "function" ? this._flush(function(q) {
          Xf(F, q);
        }) : Xf(F);
      });
    }
    go.prototype.push = function(G, F) {
      return this._transformState.needTransform = !1, Ca.prototype.push.call(this, G, F);
    }, go.prototype._transform = function(G, F, q) {
      throw new Error("Not implemented");
    }, go.prototype._write = function(G, F, q) {
      var ue = this._transformState;
      if (ue.writecb = q, ue.writechunk = G, ue.writeencoding = F, !ue.transforming) {
        var be = this._readableState;
        (ue.needTransform || be.needReadable || be.length < be.highWaterMark) && this._read(be.highWaterMark);
      }
    }, go.prototype._read = function(G) {
      var F = this._transformState;
      F.writechunk !== null && F.writecb && !F.transforming ? (F.transforming = !0, this._transform(F.writechunk, F.writeencoding, F.afterTransform)) : F.needTransform = !0;
    };
    function Xf(G, F) {
      if (F)
        return G.emit("error", F);
      var q = G._writableState, ue = G._transformState;
      if (q.length)
        throw new Error("Calling transform done when ws.length != 0");
      if (ue.transforming)
        throw new Error("Calling transform done when still transforming");
      return G.push(null);
    }
    Bt(Hd, go);
    function Hd(G) {
      if (!(this instanceof Hd))
        return new Hd(G);
      go.call(this, G);
    }
    Hd.prototype._transform = function(G, F, q) {
      q(null, G);
    }, Bt(Us, o), Us.Readable = To, Us.Writable = yo, Us.Duplex = Ca, Us.Transform = go, Us.PassThrough = Hd, Us.Stream = Us;
    function Us() {
      o.call(this);
    }
    Us.prototype.pipe = function(G, F) {
      var q = this;
      function ue(Pn) {
        G.writable && G.write(Pn) === !1 && q.pause && q.pause();
      }
      q.on("data", ue);
      function be() {
        q.readable && q.resume && q.resume();
      }
      G.on("drain", be), !G._isStdio && (!F || F.end !== !1) && (q.on("end", Ge), q.on("close", ft));
      var Oe = !1;
      function Ge() {
        Oe || (Oe = !0, G.end());
      }
      function ft() {
        Oe || (Oe = !0, typeof G.destroy == "function" && G.destroy());
      }
      function Dt(Pn) {
        if (Bn(), o.listenerCount(this, "error") === 0)
          throw Pn;
      }
      q.on("error", Dt), G.on("error", Dt);
      function Bn() {
        q.removeListener("data", ue), G.removeListener("drain", be), q.removeListener("end", Ge), q.removeListener("close", ft), q.removeListener("error", Dt), G.removeListener("error", Dt), q.removeListener("end", Bn), q.removeListener("close", Bn), G.removeListener("close", Bn);
      }
      return q.on("end", Bn), q.on("close", Bn), G.on("close", Bn), G.emit("pipe", q), G;
    };
    function cr(G) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? cr = function(F) {
        return typeof F;
      } : cr = function(F) {
        return F && typeof Symbol == "function" && F.constructor === Symbol && F !== Symbol.prototype ? "symbol" : typeof F;
      }, cr(G);
    }
    function Ea(G, F) {
      if (!(G instanceof F))
        throw new TypeError("Cannot call a class as a function");
    }
    function oh(G, F) {
      for (var q = 0; q < F.length; q++) {
        var ue = F[q];
        ue.enumerable = ue.enumerable || !1, ue.configurable = !0, "value" in ue && (ue.writable = !0), Object.defineProperty(G, ue.key, ue);
      }
    }
    function yA(G, F, q) {
      return F && oh(G.prototype, F), q && oh(G, q), G;
    }
    function ra(G, F, q) {
      return F in G ? Object.defineProperty(G, F, {
        value: q,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : G[F] = q, G;
    }
    function Cs(G) {
      for (var F = 1; F < arguments.length; F++) {
        var q = arguments[F] != null ? arguments[F] : {}, ue = Object.keys(q);
        typeof Object.getOwnPropertySymbols == "function" && (ue = ue.concat(Object.getOwnPropertySymbols(q).filter(function(be) {
          return Object.getOwnPropertyDescriptor(q, be).enumerable;
        }))), ue.forEach(function(be) {
          ra(G, be, q[be]);
        });
      }
      return G;
    }
    function k1(G, F) {
      if (typeof F != "function" && F !== null)
        throw new TypeError("Super expression must either be null or a function");
      G.prototype = Object.create(F && F.prototype, {
        constructor: {
          value: G,
          writable: !0,
          configurable: !0
        }
      }), F && Bl(G, F);
    }
    function R0(G) {
      return R0 = Object.setPrototypeOf ? Object.getPrototypeOf : function(q) {
        return q.__proto__ || Object.getPrototypeOf(q);
      }, R0(G);
    }
    function Bl(G, F) {
      return Bl = Object.setPrototypeOf || function(ue, be) {
        return ue.__proto__ = be, ue;
      }, Bl(G, F);
    }
    function vA(G) {
      if (G === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return G;
    }
    function Ec(G, F) {
      return F && (typeof F == "object" || typeof F == "function") ? F : vA(G);
    }
    function Ma(G) {
      return Zf(G) || yc(G) || G1();
    }
    function vo(G) {
      return Fi(G) || yc(G) || Es();
    }
    function Fi(G) {
      if (Array.isArray(G)) {
        for (var F = 0, q = new Array(G.length); F < G.length; F++)
          q[F] = G[F];
        return q;
      }
    }
    function Zf(G) {
      if (Array.isArray(G))
        return G;
    }
    function yc(G) {
      if (Symbol.iterator in Object(G) || Object.prototype.toString.call(G) === "[object Arguments]")
        return Array.from(G);
    }
    function Es() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }
    function G1() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
    var sh;
    function vi() {
      if (typeof sh > "u") {
        var G = new ArrayBuffer(2), F = new Uint8Array(G), q = new Uint16Array(G);
        if (F[0] = 1, F[1] = 2, q[0] === 258)
          sh = "BE";
        else if (q[0] === 513)
          sh = "LE";
        else
          throw new Error("unable to figure out endianess");
      }
      return sh;
    }
    function vc() {
      return typeof v.location < "u" ? v.location.hostname : "";
    }
    function Hs() {
      return [];
    }
    function U1() {
      return 0;
    }
    function $s() {
      return Number.MAX_VALUE;
    }
    function H1() {
      return Number.MAX_VALUE;
    }
    function Oa() {
      return [];
    }
    function ah() {
      return "Browser";
    }
    function Im() {
      return typeof v.navigator < "u" ? v.navigator.appVersion : "";
    }
    function $d() {
    }
    function JA() {
    }
    function ia() {
      return "/tmp";
    }
    var ys = ia, Ah = `
`, oa = {
      EOL: Ah,
      tmpdir: ys,
      tmpDir: ia,
      networkInterfaces: $d,
      getNetworkInterfaces: JA,
      release: Im,
      type: ah,
      cpus: Oa,
      totalmem: H1,
      freemem: $s,
      uptime: U1,
      loadavg: Hs,
      hostname: vc,
      endianness: vi
    }, Fa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof ei < "u" ? ei : typeof self < "u" ? self : {}, Wu = "Expected a function", mm = "__lodash_hash_undefined__", eg = 1 / 0, Xu = "[object Function]", au = "[object GeneratorFunction]", vs = "[object Symbol]", KA = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, is = /^\w*$/, $1 = /^\./, Zu = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, lh = /[\\^$.*+?()[\]{}|]/g, os = /\\(\\)?/g, Bs = /^\[object .+?Constructor\]$/, bs = typeof Fa == "object" && Fa && Fa.Object === Object && Fa, Xa = typeof self == "object" && self && self.Object === Object && self, D0 = bs || Xa || Function("return this")();
    function ch(G, F) {
      return G?.[F];
    }
    function ef(G) {
      var F = !1;
      if (G != null && typeof G.toString != "function")
        try {
          F = !!(G + "");
        } catch {
        }
      return F;
    }
    var Pa = Array.prototype, ry = Function.prototype, No = Object.prototype, qd = D0["__core-js_shared__"], Za = function() {
      var G = /[^.]+$/.exec(qd && qd.keys && qd.keys.IE_PROTO || "");
      return G ? "Symbol(src)_1." + G : "";
    }(), Yo = ry.toString, eA = No.hasOwnProperty, tf = No.toString, uh = RegExp(
      "^" + Yo.call(eA).replace(lh, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), WA = D0.Symbol, fh = Pa.splice, ya = Yt(D0, "Map"), tA = Yt(Object, "create"), ho = WA ? WA.prototype : void 0, iy = ho ? ho.toString : void 0;
    function nf(G) {
      var F = -1, q = G ? G.length : 0;
      for (this.clear(); ++F < q; ) {
        var ue = G[F];
        this.set(ue[0], ue[1]);
      }
    }
    function qs() {
      this.__data__ = tA ? tA(null) : {};
    }
    function Gi(G) {
      return this.has(G) && delete this.__data__[G];
    }
    function oy(G) {
      var F = this.__data__;
      if (tA) {
        var q = F[G];
        return q === mm ? void 0 : q;
      }
      return eA.call(F, G) ? F[G] : void 0;
    }
    function gh(G) {
      var F = this.__data__;
      return tA ? F[G] !== void 0 : eA.call(F, G);
    }
    function rf(G, F) {
      var q = this.__data__;
      return q[G] = tA && F === void 0 ? mm : F, this;
    }
    nf.prototype.clear = qs, nf.prototype.delete = Gi, nf.prototype.get = oy, nf.prototype.has = gh, nf.prototype.set = rf;
    function Xi(G) {
      var F = -1, q = G ? G.length : 0;
      for (this.clear(); ++F < q; ) {
        var ue = G[F];
        this.set(ue[0], ue[1]);
      }
    }
    function js() {
      this.__data__ = [];
    }
    function jd(G) {
      var F = this.__data__, q = bA(F, G);
      if (q < 0)
        return !1;
      var ue = F.length - 1;
      return q == ue ? F.pop() : fh.call(F, q, 1), !0;
    }
    function va(G) {
      var F = this.__data__, q = bA(F, G);
      return q < 0 ? void 0 : F[q][1];
    }
    function sy(G) {
      return bA(this.__data__, G) > -1;
    }
    function Cm(G, F) {
      var q = this.__data__, ue = bA(q, G);
      return ue < 0 ? q.push([G, F]) : q[ue][1] = F, this;
    }
    Xi.prototype.clear = js, Xi.prototype.delete = jd, Xi.prototype.get = va, Xi.prototype.has = sy, Xi.prototype.set = Cm;
    function po(G) {
      var F = -1, q = G ? G.length : 0;
      for (this.clear(); ++F < q; ) {
        var ue = G[F];
        this.set(ue[0], ue[1]);
      }
    }
    function Fx() {
      this.__data__ = {
        hash: new nf(),
        map: new (ya || Xi)(),
        string: new nf()
      };
    }
    function Bc(G) {
      return ka(this, G).delete(G);
    }
    function T0(G) {
      return ka(this, G).get(G);
    }
    function BA(G) {
      return ka(this, G).has(G);
    }
    function Or(G, F) {
      return ka(this, G).set(G, F), this;
    }
    po.prototype.clear = Fx, po.prototype.delete = Bc, po.prototype.get = T0, po.prototype.has = BA, po.prototype.set = Or;
    function bA(G, F) {
      for (var q = G.length; q--; )
        if (S(G[q][0], F))
          return q;
      return -1;
    }
    function bc(G, F) {
      F = gn(F, G) ? [F] : ay(F);
      for (var q = 0, ue = F.length; G != null && q < ue; )
        G = G[Ys(F[q++])];
      return q && q == ue ? G : void 0;
    }
    function Au(G) {
      if (!P(G) || _c(G))
        return !1;
      var F = T(G) || ef(G) ? uh : Bs;
      return F.test(ph(G));
    }
    function hh(G) {
      if (typeof G == "string")
        return G;
      if (J(G))
        return iy ? iy.call(G) : "";
      var F = G + "";
      return F == "0" && 1 / G == -eg ? "-0" : F;
    }
    function ay(G) {
      return x(G) ? G : Vn(G);
    }
    function ka(G, F) {
      var q = G.__data__;
      return dh(F) ? q[typeof F == "string" ? "string" : "hash"] : q.map;
    }
    function Yt(G, F) {
      var q = ch(G, F);
      return Au(q) ? q : void 0;
    }
    function gn(G, F) {
      if (x(G))
        return !1;
      var q = typeof G;
      return q == "number" || q == "symbol" || q == "boolean" || G == null || J(G) ? !0 : is.test(G) || !KA.test(G) || F != null && G in Object(F);
    }
    function dh(G) {
      var F = typeof G;
      return F == "string" || F == "number" || F == "symbol" || F == "boolean" ? G !== "__proto__" : G === null;
    }
    function _c(G) {
      return !!Za && Za in G;
    }
    var Vn = Ba(function(G) {
      G = g(G);
      var F = [];
      return $1.test(G) && F.push(""), G.replace(Zu, function(q, ue, be, Oe) {
        F.push(be ? Oe.replace(os, "$1") : ue || q);
      }), F;
    });
    function Ys(G) {
      if (typeof G == "string" || J(G))
        return G;
      var F = G + "";
      return F == "0" && 1 / G == -eg ? "-0" : F;
    }
    function ph(G) {
      if (G != null) {
        try {
          return Yo.call(G);
        } catch {
        }
        try {
          return G + "";
        } catch {
        }
      }
      return "";
    }
    function Ba(G, F) {
      if (typeof G != "function" || F && typeof F != "function")
        throw new TypeError(Wu);
      var q = function() {
        var ue = arguments, be = F ? F.apply(this, ue) : ue[0], Oe = q.cache;
        if (Oe.has(be))
          return Oe.get(be);
        var Ge = G.apply(this, ue);
        return q.cache = Oe.set(be, Ge), Ge;
      };
      return q.cache = new (Ba.Cache || po)(), q;
    }
    Ba.Cache = po;
    function S(G, F) {
      return G === F || G !== G && F !== F;
    }
    var x = Array.isArray;
    function T(G) {
      var F = P(G) ? tf.call(G) : "";
      return F == Xu || F == au;
    }
    function P(G) {
      var F = typeof G;
      return !!G && (F == "object" || F == "function");
    }
    function H(G) {
      return !!G && typeof G == "object";
    }
    function J(G) {
      return typeof G == "symbol" || H(G) && tf.call(G) == vs;
    }
    function g(G) {
      return G == null ? "" : hh(G);
    }
    function p(G, F, q) {
      var ue = G == null ? void 0 : bc(G, F);
      return ue === void 0 ? q : ue;
    }
    var E = p;
    function B(G, F, q) {
      return G[F] === void 0 ? q : G[F];
    }
    function D(G, F, q) {
      var ue = Array.isArray(F) ? F : F.split("."), be = Ma(ue), Oe = be[0], Ge = be.slice(1);
      return Cs({}, G, ra({}, Oe, ue.length > 1 ? D(G[Oe] || {}, Ge, q) : q));
    }
    function j(G, F) {
      var q = Array.isArray(F) ? F : F.split("."), ue = Ma(q), be = ue[0], Oe = ue.slice(1);
      return cr(G[be]) !== "object" ? G : q.length === 1 ? Object.keys(G).filter(function(Ge) {
        return Ge !== be;
      }).reduce(function(Ge, ft) {
        return Object.assign(Ge, ra({}, ft, G[ft]));
      }, {}) : Object.keys(G).reduce(function(Ge, ft) {
        return Cs({}, Ge, ra({}, ft, ft !== be ? G[ft] : j(G[be], Oe)));
      }, {});
    }
    function te(G, F) {
      try {
        return G.push.apply(G, vo(F)), G;
      } catch {
        return G.concat(F);
      }
    }
    function he(G, F) {
      var q = !0;
      return G.reduce(function(ue, be) {
        return be == null && (be = ""), q ? (q = !1, "".concat(be)) : "".concat(ue).concat(F).concat(be);
      }, "");
    }
    var ve = {
      getProp: B,
      setProp: D,
      unsetProp: j,
      fastJoin: he,
      flattenReducer: te
    }, Le = ve.getProp, Je = ve.fastJoin, et = ve.flattenReducer, Ke = /* @__PURE__ */ function() {
      function G(F) {
        Ea(this, G), this.opts = this.preprocessOpts(F);
      }
      return yA(G, [{
        key: "preprocessOpts",
        value: function(q) {
          var ue = Object.assign({}, q);
          return ue.transforms = Array.isArray(ue.transforms) ? ue.transforms : ue.transforms ? [ue.transforms] : [], ue.delimiter = ue.delimiter || ",", ue.eol = ue.eol || oa.EOL, ue.quote = typeof ue.quote == "string" ? ue.quote : '"', ue.escapedQuote = typeof ue.escapedQuote == "string" ? ue.escapedQuote : "".concat(ue.quote).concat(ue.quote), ue.header = ue.header !== !1, ue.includeEmptyRows = ue.includeEmptyRows || !1, ue.withBOM = ue.withBOM || !1, ue;
        }
        /**
         * Check and normalize the fields configuration.
         *
         * @param {(string|object)[]} fields Fields configuration provided by the user
         * or inferred from the data
         * @returns {object[]} preprocessed FieldsInfo array
         */
      }, {
        key: "preprocessFieldsInfo",
        value: function(q) {
          var ue = this;
          return q.map(function(be) {
            if (typeof be == "string")
              return {
                label: be,
                value: be.includes(".") || be.includes("[") ? function(Dt) {
                  return E(Dt, be, ue.opts.defaultValue);
                } : function(Dt) {
                  return Le(Dt, be, ue.opts.defaultValue);
                }
              };
            if (cr(be) === "object") {
              var Oe = "default" in be ? be.default : ue.opts.defaultValue;
              if (typeof be.value == "string")
                return {
                  label: be.label || be.value,
                  value: be.value.includes(".") || be.value.includes("[") ? function(Dt) {
                    return E(Dt, be.value, Oe);
                  } : function(Dt) {
                    return Le(Dt, be.value, Oe);
                  }
                };
              if (typeof be.value == "function") {
                var Ge = be.label || be.value.name || "", ft = {
                  label: Ge,
                  default: Oe
                };
                return {
                  label: Ge,
                  value: function(Bn) {
                    var Pn = be.value(Bn, ft);
                    return Pn ?? Oe;
                  }
                };
              }
            }
            throw new Error("Invalid field info option. " + JSON.stringify(be));
          });
        }
        /**
         * Create the title row with all the provided fields as column headings
         *
         * @returns {String} titles as a string
         */
      }, {
        key: "getHeader",
        value: function() {
          var q = this;
          return Je(this.opts.fields.map(function(ue) {
            return q.processValue(ue.label);
          }), this.opts.delimiter);
        }
        /**
         * Preprocess each object according to the given transforms (unwind, flatten, etc.).
         * @param {Object} row JSON object to be converted in a CSV row
         */
      }, {
        key: "preprocessRow",
        value: function(q) {
          return this.opts.transforms.reduce(function(ue, be) {
            return ue.map(function(Oe) {
              return be(Oe);
            }).reduce(et, []);
          }, [q]);
        }
        /**
         * Create the content of a specific CSV row
         *
         * @param {Object} row JSON object to be converted in a CSV row
         * @returns {String} CSV string (row)
         */
      }, {
        key: "processRow",
        value: function(q) {
          var ue = this;
          if (q) {
            var be = this.opts.fields.map(function(Oe) {
              return ue.processCell(q, Oe);
            });
            if (!(!this.opts.includeEmptyRows && be.every(function(Oe) {
              return Oe === void 0;
            })))
              return Je(be, this.opts.delimiter);
          }
        }
        /**
         * Create the content of a specfic CSV row cell
         *
         * @param {Object} row JSON object representing the  CSV row that the cell belongs to
         * @param {FieldInfo} fieldInfo Details of the field to process to be a CSV cell
         * @returns {String} CSV string (cell)
         */
      }, {
        key: "processCell",
        value: function(q, ue) {
          return this.processValue(ue.value(q));
        }
        /**
         * Create the content of a specfic CSV row cell
         *
         * @param {Any} value Value to be included in a CSV cell
         * @returns {String} Value stringified and processed
         */
      }, {
        key: "processValue",
        value: function(q) {
          if (q != null) {
            var ue = cr(q);
            if (ue !== "boolean" && ue !== "number" && ue !== "string") {
              if (q = JSON.stringify(q), q === void 0)
                return;
              q[0] === '"' && (q = q.replace(/^"(.+)"$/, "$1"));
            }
            return typeof q == "string" && (this.opts.excelStrings ? (q.includes(this.opts.quote) && (q = q.replace(new RegExp(this.opts.quote, "g"), "".concat(this.opts.escapedQuote).concat(this.opts.escapedQuote))), q = '"=""'.concat(q, '"""')) : (q.includes(this.opts.quote) && (q = q.replace(new RegExp(this.opts.quote, "g"), this.opts.escapedQuote)), q = "".concat(this.opts.quote).concat(q).concat(this.opts.quote))), q;
          }
        }
      }]), G;
    }(), ot = Ke, je = ve.fastJoin, Et = ve.flattenReducer, Gt = /* @__PURE__ */ function(G) {
      k1(F, G);
      function F(q) {
        var ue;
        return Ea(this, F), ue = Ec(this, R0(F).call(this, q)), ue.opts.fields && (ue.opts.fields = ue.preprocessFieldsInfo(ue.opts.fields)), ue;
      }
      return yA(F, [{
        key: "parse",
        value: function(ue) {
          var be = this.preprocessData(ue);
          this.opts.fields || (this.opts.fields = be.reduce(function(Dt, Bn) {
            return Object.keys(Bn).forEach(function(Pn) {
              Dt.includes(Pn) || Dt.push(Pn);
            }), Dt;
          }, []), this.opts.fields = this.preprocessFieldsInfo(this.opts.fields));
          var Oe = this.opts.header ? this.getHeader() : "", Ge = this.processData(be), ft = (this.opts.withBOM ? "\uFEFF" : "") + Oe + (Oe && Ge ? this.opts.eol : "") + Ge;
          return ft;
        }
        /**
         * Preprocess the data according to the give opts (unwind, flatten, etc.)
          and calculate the fields and field names if they are not provided.
         *
         * @param {Array|Object} data Array or object to be converted to CSV
         */
      }, {
        key: "preprocessData",
        value: function(ue) {
          var be = this, Oe = Array.isArray(ue) ? ue : [ue];
          if (!this.opts.fields && (Oe.length === 0 || cr(Oe[0]) !== "object"))
            throw new Error('Data should not be empty or the "fields" option should be included');
          return this.opts.transforms.length === 0 ? Oe : Oe.map(function(Ge) {
            return be.preprocessRow(Ge);
          }).reduce(Et, []);
        }
        /**
         * Create the content row by row below the header
         *
         * @param {Array} data Array of JSON objects to be converted to CSV
         * @returns {String} CSV string (body)
         */
      }, {
        key: "processData",
        value: function(ue) {
          var be = this;
          return je(
            ue.map(function(Oe) {
              return be.processRow(Oe);
            }).filter(function(Oe) {
              return Oe;
            }),
            // Filter empty rows
            this.opts.eol
          );
        }
      }]), F;
    }(ot), kt = Gt, bt = {}, Yn = bt.LEFT_BRACE = 1, Hr = bt.RIGHT_BRACE = 2, li = bt.LEFT_BRACKET = 3, Ui = bt.RIGHT_BRACKET = 4, hi = bt.COLON = 5, Zi = bt.COMMA = 6, Bo = bt.TRUE = 7, xr = bt.FALSE = 8, XIe = bt.NULL = 9, VO = bt.STRING = 10, ZIe = bt.NUMBER = 11, Ay = bt.START = 17, eme = bt.STOP = 18, tme = bt.TRUE1 = 33, nme = bt.TRUE2 = 34, rme = bt.TRUE3 = 35, ime = bt.FALSE1 = 49, ome = bt.FALSE2 = 50, sme = bt.FALSE3 = 51, ame = bt.FALSE4 = 52, Ame = bt.NULL1 = 65, lme = bt.NULL2 = 66, cme = bt.NULL3 = 67, ume = bt.NUMBER1 = 81, iz = bt.NUMBER3 = 83, Ih = bt.STRING1 = 97, fme = bt.STRING2 = 98, gme = bt.STRING3 = 99, Ict = bt.STRING4 = 100, mct = bt.STRING5 = 101, hme = bt.STRING6 = 102, q1 = bt.VALUE = 113, oz = bt.KEY = 114, JO = bt.OBJECT = 129, KO = bt.ARRAY = 130, Cct = "\\".charCodeAt(0), Ect = "/".charCodeAt(0), yct = "\b".charCodeAt(0), vct = "\f".charCodeAt(0), Bct = `
`.charCodeAt(0), bct = "\r".charCodeAt(0), _ct = "	".charCodeAt(0), WO = 64 * 1024;
    function Em() {
      this.tState = Ay, this.value = void 0, this.string = void 0, this.stringBuffer = Z.alloc ? Z.alloc(WO) : new Z(WO), this.stringBufferOffset = 0, this.unicode = void 0, this.highSurrogate = void 0, this.key = void 0, this.mode = void 0, this.stack = [], this.state = q1, this.bytes_remaining = 0, this.bytes_in_sequence = 0, this.temp_buffs = { 2: new Z(2), 3: new Z(3), 4: new Z(4) }, this.offset = -1;
    }
    Em.toknam = function(G) {
      for (var F = Object.keys(bt), q = 0, ue = F.length; q < ue; q++) {
        var be = F[q];
        if (bt[be] === G)
          return be;
      }
      return G && "0x" + G.toString(16);
    };
    var tg = Em.prototype;
    tg.onError = function(G) {
      throw G;
    }, tg.charError = function(G, F) {
      this.tState = eme, this.onError(new Error("Unexpected " + JSON.stringify(String.fromCharCode(G[F])) + " at position " + F + " in state " + Em.toknam(this.tState)));
    }, tg.appendStringChar = function(G) {
      this.stringBufferOffset >= WO && (this.string += this.stringBuffer.toString("utf8"), this.stringBufferOffset = 0), this.stringBuffer[this.stringBufferOffset++] = G;
    }, tg.appendStringBuf = function(G, F, q) {
      var ue = G.length;
      typeof F == "number" && (typeof q == "number" ? q < 0 ? ue = G.length - F + q : ue = q - F : ue = G.length - F), ue < 0 && (ue = 0), this.stringBufferOffset + ue > WO && (this.string += this.stringBuffer.toString("utf8", 0, this.stringBufferOffset), this.stringBufferOffset = 0), G.copy(this.stringBuffer, this.stringBufferOffset, F, q), this.stringBufferOffset += ue;
    }, tg.write = function(G) {
      typeof G == "string" && (G = new Z(G));
      for (var F, q = 0, ue = G.length; q < ue; q++)
        if (this.tState === Ay) {
          if (F = G[q], this.offset++, F === 123)
            this.onToken(Yn, "{");
          else if (F === 125)
            this.onToken(Hr, "}");
          else if (F === 91)
            this.onToken(li, "[");
          else if (F === 93)
            this.onToken(Ui, "]");
          else if (F === 58)
            this.onToken(hi, ":");
          else if (F === 44)
            this.onToken(Zi, ",");
          else if (F === 116)
            this.tState = tme;
          else if (F === 102)
            this.tState = ime;
          else if (F === 110)
            this.tState = Ame;
          else if (F === 34)
            this.string = "", this.stringBufferOffset = 0, this.tState = Ih;
          else if (F === 45)
            this.string = "-", this.tState = ume;
          else if (F >= 48 && F < 64)
            this.string = String.fromCharCode(F), this.tState = iz;
          else if (!(F === 32 || F === 9 || F === 10 || F === 13))
            return this.charError(G, q);
        } else if (this.tState === Ih)
          if (F = G[q], this.bytes_remaining > 0) {
            for (var be = 0; be < this.bytes_remaining; be++)
              this.temp_buffs[this.bytes_in_sequence][this.bytes_in_sequence - this.bytes_remaining + be] = G[be];
            this.appendStringBuf(this.temp_buffs[this.bytes_in_sequence]), this.bytes_in_sequence = this.bytes_remaining = 0, q = q + be - 1;
          } else if (this.bytes_remaining === 0 && F >= 128) {
            if (F <= 193 || F > 244)
              return this.onError(new Error("Invalid UTF-8 character at position " + q + " in state " + Em.toknam(this.tState)));
            if (F >= 194 && F <= 223 && (this.bytes_in_sequence = 2), F >= 224 && F <= 239 && (this.bytes_in_sequence = 3), F >= 240 && F <= 244 && (this.bytes_in_sequence = 4), this.bytes_in_sequence + q > G.length) {
              for (var Oe = 0; Oe <= G.length - 1 - q; Oe++)
                this.temp_buffs[this.bytes_in_sequence][Oe] = G[q + Oe];
              this.bytes_remaining = q + this.bytes_in_sequence - G.length, q = G.length - 1;
            } else
              this.appendStringBuf(G, q, q + this.bytes_in_sequence), q = q + this.bytes_in_sequence - 1;
          } else if (F === 34)
            this.tState = Ay, this.string += this.stringBuffer.toString("utf8", 0, this.stringBufferOffset), this.stringBufferOffset = 0, this.onToken(VO, this.string), this.offset += Z.byteLength(this.string, "utf8") + 1, this.string = void 0;
          else if (F === 92)
            this.tState = fme;
          else if (F >= 32)
            this.appendStringChar(F);
          else
            return this.charError(G, q);
        else if (this.tState === fme)
          if (F = G[q], F === 34)
            this.appendStringChar(F), this.tState = Ih;
          else if (F === 92)
            this.appendStringChar(Cct), this.tState = Ih;
          else if (F === 47)
            this.appendStringChar(Ect), this.tState = Ih;
          else if (F === 98)
            this.appendStringChar(yct), this.tState = Ih;
          else if (F === 102)
            this.appendStringChar(vct), this.tState = Ih;
          else if (F === 110)
            this.appendStringChar(Bct), this.tState = Ih;
          else if (F === 114)
            this.appendStringChar(bct), this.tState = Ih;
          else if (F === 116)
            this.appendStringChar(_ct), this.tState = Ih;
          else if (F === 117)
            this.unicode = "", this.tState = gme;
          else
            return this.charError(G, q);
        else if (this.tState === gme || this.tState === Ict || this.tState === mct || this.tState === hme)
          if (F = G[q], F >= 48 && F < 64 || F > 64 && F <= 70 || F > 96 && F <= 102) {
            if (this.unicode += String.fromCharCode(F), this.tState++ === hme) {
              var Ge = parseInt(this.unicode, 16);
              this.unicode = void 0, this.highSurrogate !== void 0 && Ge >= 56320 && Ge < 57343 + 1 ? (this.appendStringBuf(new Z(String.fromCharCode(this.highSurrogate, Ge))), this.highSurrogate = void 0) : this.highSurrogate === void 0 && Ge >= 55296 && Ge < 56319 + 1 ? this.highSurrogate = Ge : (this.highSurrogate !== void 0 && (this.appendStringBuf(new Z(String.fromCharCode(this.highSurrogate))), this.highSurrogate = void 0), this.appendStringBuf(new Z(String.fromCharCode(Ge)))), this.tState = Ih;
            }
          } else
            return this.charError(G, q);
        else if (this.tState === ume || this.tState === iz)
          switch (F = G[q], F) {
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
            case 46:
            case 101:
            case 69:
            case 43:
            case 45:
              this.string += String.fromCharCode(F), this.tState = iz;
              break;
            default:
              this.tState = Ay;
              var ft = Number(this.string);
              if (isNaN(ft))
                return this.charError(G, q);
              this.string.match(/[0-9]+/) == this.string && ft.toString() != this.string ? this.onToken(VO, this.string) : this.onToken(ZIe, ft), this.offset += this.string.length - 1, this.string = void 0, q--;
              break;
          }
        else if (this.tState === tme)
          if (G[q] === 114)
            this.tState = nme;
          else
            return this.charError(G, q);
        else if (this.tState === nme)
          if (G[q] === 117)
            this.tState = rme;
          else
            return this.charError(G, q);
        else if (this.tState === rme)
          if (G[q] === 101)
            this.tState = Ay, this.onToken(Bo, !0), this.offset += 3;
          else
            return this.charError(G, q);
        else if (this.tState === ime)
          if (G[q] === 97)
            this.tState = ome;
          else
            return this.charError(G, q);
        else if (this.tState === ome)
          if (G[q] === 108)
            this.tState = sme;
          else
            return this.charError(G, q);
        else if (this.tState === sme)
          if (G[q] === 115)
            this.tState = ame;
          else
            return this.charError(G, q);
        else if (this.tState === ame)
          if (G[q] === 101)
            this.tState = Ay, this.onToken(xr, !1), this.offset += 4;
          else
            return this.charError(G, q);
        else if (this.tState === Ame)
          if (G[q] === 117)
            this.tState = lme;
          else
            return this.charError(G, q);
        else if (this.tState === lme)
          if (G[q] === 108)
            this.tState = cme;
          else
            return this.charError(G, q);
        else if (this.tState === cme)
          if (G[q] === 108)
            this.tState = Ay, this.onToken(XIe, null), this.offset += 3;
          else
            return this.charError(G, q);
    }, tg.onToken = function(G, F) {
    }, tg.parseError = function(G, F) {
      this.tState = eme, this.onError(new Error("Unexpected " + Em.toknam(G) + (F ? "(" + JSON.stringify(F) + ")" : "") + " in state " + Em.toknam(this.state)));
    }, tg.push = function() {
      this.stack.push({ value: this.value, key: this.key, mode: this.mode });
    }, tg.pop = function() {
      var G = this.value, F = this.stack.pop();
      this.value = F.value, this.key = F.key, this.mode = F.mode, this.emit(G), this.mode || (this.state = q1);
    }, tg.emit = function(G) {
      this.mode && (this.state = Zi), this.onValue(G);
    }, tg.onValue = function(G) {
    }, tg.onToken = function(G, F) {
      if (this.state === q1)
        if (G === VO || G === ZIe || G === Bo || G === xr || G === XIe)
          this.value && (this.value[this.key] = F), this.emit(F);
        else if (G === Yn)
          this.push(), this.value ? this.value = this.value[this.key] = {} : this.value = {}, this.key = void 0, this.state = oz, this.mode = JO;
        else if (G === li)
          this.push(), this.value ? this.value = this.value[this.key] = [] : this.value = [], this.key = 0, this.mode = KO, this.state = q1;
        else if (G === Hr)
          if (this.mode === JO)
            this.pop();
          else
            return this.parseError(G, F);
        else if (G === Ui)
          if (this.mode === KO)
            this.pop();
          else
            return this.parseError(G, F);
        else
          return this.parseError(G, F);
      else if (this.state === oz)
        if (G === VO)
          this.key = F, this.state = hi;
        else if (G === Hr)
          this.pop();
        else
          return this.parseError(G, F);
      else if (this.state === hi)
        if (G === hi)
          this.state = q1;
        else
          return this.parseError(G, F);
      else if (this.state === Zi)
        if (G === Zi)
          this.mode === KO ? (this.key++, this.state = q1) : this.mode === JO && (this.state = oz);
        else if (G === Ui && this.mode === KO || G === Hr && this.mode === JO)
          this.pop();
        else
          return this.parseError(G, F);
      else
        return this.parseError(G, F);
    }, Em.C = bt;
    var XO = Em, Sct = Us.Transform, Qct = /* @__PURE__ */ function(G) {
      k1(F, G);
      function F(q, ue) {
        var be;
        return Ea(this, F), be = Ec(this, R0(F).call(this, ue)), Object.getOwnPropertyNames(ot.prototype).forEach(function(Oe) {
          return be[Oe] = ot.prototype[Oe];
        }), be.opts = be.preprocessOpts(q), be._data = "", be._hasWritten = !1, be._readableState.objectMode ? be.initObjectModeParse() : be.opts.ndjson ? be.initNDJSONParse() : be.initJSONParser(), be.opts.withBOM && be.push("\uFEFF"), be.opts.fields && (be.opts.fields = be.preprocessFieldsInfo(be.opts.fields), be.pushHeader()), be;
      }
      return yA(F, [{
        key: "initObjectModeParse",
        value: function() {
          var ue = this;
          this.parser = {
            write: function(Oe) {
              ue.pushLine(Oe);
            },
            getPendingData: function() {
            }
          };
        }
        /**
         * Init the transform with a parser to process NDJSON data.
         * It maintains a buffer of received data, parses each line
         * as JSON and send it to `pushLine for processing.
         */
      }, {
        key: "initNDJSONParse",
        value: function() {
          var ue = this;
          this.parser = {
            _data: "",
            write: function(Oe) {
              this._data += Oe.toString();
              var Ge = this._data.split(`
`).map(function(Dt) {
                return Dt.trim();
              }).filter(function(Dt) {
                return Dt !== "";
              }), ft = !1;
              Ge.forEach(function(Dt, Bn) {
                try {
                  ue.pushLine(JSON.parse(Dt));
                } catch (Pn) {
                  Bn === Ge.length - 1 ? ft = !0 : (Pn.message = "Invalid JSON (".concat(Dt, ")"), ue.emit("error", Pn));
                }
              }), this._data = ft ? this._data.slice(this._data.lastIndexOf(`
`)) : "";
            },
            getPendingData: function() {
              return this._data;
            }
          };
        }
        /**
         * Init the transform with a parser to process JSON data.
         * It maintains a buffer of received data, parses each as JSON 
         * item if the data is an array or the data itself otherwise
         * and send it to `pushLine` for processing.
         */
      }, {
        key: "initJSONParser",
        value: function() {
          var ue = this;
          this.parser = new XO(), this.parser.onValue = function(be) {
            this.stack.length === this.depthToEmit && ue.pushLine(be);
          }, this.parser._onToken = this.parser.onToken, this.parser.onToken = function(be, Oe) {
            ue.parser._onToken(be, Oe), this.stack.length === 0 && !ue.opts.fields && this.mode !== XO.C.ARRAY && this.mode !== XO.C.OBJECT && this.onError(new Error('Data should not be empty or the "fields" option should be included')), this.stack.length === 1 && (this.depthToEmit === void 0 && (this.depthToEmit = this.mode === XO.C.ARRAY ? 1 : 0), this.depthToEmit !== 0 && this.stack.length === 1 && (this.value = void 0));
          }, this.parser.getPendingData = function() {
            return this.value;
          }, this.parser.onError = function(be) {
            be.message.includes("Unexpected") && (be.message = "Invalid JSON (".concat(be.message, ")")), ue.emit("error", be);
          };
        }
        /**
         * Main function that send data to the parse to be processed.
         *
         * @param {Buffer} chunk Incoming data
         * @param {String} encoding Encoding of the incoming data. Defaults to 'utf8'
         * @param {Function} done Called when the proceesing of the supplied chunk is done
         */
      }, {
        key: "_transform",
        value: function(ue, be, Oe) {
          this.parser.write(ue), Oe();
        }
      }, {
        key: "_flush",
        value: function(ue) {
          this.parser.getPendingData() && ue(new Error("Invalid data received from stdin", this.parser.getPendingData())), ue();
        }
        /**
         * Generate the csv header and pushes it downstream.
         */
      }, {
        key: "pushHeader",
        value: function() {
          if (this.opts.header) {
            var ue = this.getHeader();
            this.emit("header", ue), this.push(ue), this._hasWritten = !0;
          }
        }
        /**
         * Transforms an incoming json data to csv and pushes it downstream.
         *
         * @param {Object} data JSON object to be converted in a CSV row
         */
      }, {
        key: "pushLine",
        value: function(ue) {
          var be = this, Oe = this.preprocessRow(ue);
          this._hasWritten || (this.opts.fields = this.opts.fields || this.preprocessFieldsInfo(Object.keys(Oe[0])), this.pushHeader()), Oe.forEach(function(Ge) {
            var ft = be.processRow(Ge, be.opts);
            ft !== void 0 && (be.emit("line", ft), be.push(be._hasWritten ? be.opts.eol + ft : ft), be._hasWritten = !0);
          });
        }
      }]), F;
    }(Sct), dme = Qct, wct = Us.Transform, xct = ve.fastJoin, Rct = /* @__PURE__ */ function() {
      function G(F, q) {
        Ea(this, G), this.input = new wct(q), this.input._read = function() {
        }, this.transform = new dme(F, q), this.processor = this.input.pipe(this.transform);
      }
      return yA(G, [{
        key: "fromInput",
        value: function(q) {
          if (this._input)
            throw new Error("Async parser already has an input.");
          return this._input = q, this.input = this._input.pipe(this.processor), this;
        }
      }, {
        key: "throughTransform",
        value: function(q) {
          if (this._output)
            throw new Error("Can't add transforms once an output has been added.");
          return this.processor = this.processor.pipe(q), this;
        }
      }, {
        key: "toOutput",
        value: function(q) {
          if (this._output)
            throw new Error("Async parser already has an output.");
          return this._output = q, this.processor = this.processor.pipe(q), this;
        }
      }, {
        key: "promise",
        value: function() {
          var q = this, ue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
          return new Promise(function(be, Oe) {
            if (!ue) {
              q.processor.on("finish", function() {
                return be();
              }).on("error", function(ft) {
                return Oe(ft);
              });
              return;
            }
            var Ge = [];
            q.processor.on("data", function(ft) {
              return Ge.push(ft.toString());
            }).on("finish", function() {
              return be(xct(Ge, ""));
            }).on("error", function(ft) {
              return Oe(ft);
            });
          });
        }
      }]), G;
    }(), pme = Rct;
    function Dct() {
      var G = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, F = G.objects, q = F === void 0 ? !0 : F, ue = G.arrays, be = ue === void 0 ? !1 : ue, Oe = G.separator, Ge = Oe === void 0 ? "." : Oe;
      function ft(Dt, Bn, Pn) {
        return Object.keys(Dt).forEach(function(ur) {
          var _s = Pn ? "".concat(Pn).concat(Ge).concat(ur) : ur, bo = Dt[ur];
          if (q && cr(bo) === "object" && bo !== null && !Array.isArray(bo) && Object.prototype.toString.call(bo.toJSON) !== "[object Function]" && Object.keys(bo).length) {
            ft(bo, Bn, _s);
            return;
          }
          if (be && Array.isArray(bo)) {
            ft(bo, Bn, _s);
            return;
          }
          Bn[_s] = bo;
        }), Bn;
      }
      return function(Dt) {
        return ft(Dt, {});
      };
    }
    var Tct = Dct, Nct = ve.setProp, Lct = ve.unsetProp, Ime = ve.flattenReducer;
    function sz(G, F) {
      return Object.keys(G).reduce(function(q, ue) {
        var be = F ? "".concat(F, ".").concat(ue) : ue, Oe = G[ue];
        return cr(Oe) === "object" && Oe !== null && !Array.isArray(Oe) && Object.prototype.toString.call(Oe.toJSON) !== "[object Function]" && Object.keys(Oe).length ? q = q.concat(sz(Oe, be)) : Array.isArray(Oe) && (q.push(be), q = q.concat(Oe.map(function(Ge) {
          return sz(Ge, be);
        }).reduce(Ime, []).filter(function(Ge, ft, Dt) {
          return Dt.indexOf(Ge) !== ft;
        }))), q;
      }, []);
    }
    function Mct() {
      var G = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, F = G.paths, q = F === void 0 ? void 0 : F, ue = G.blankOut, be = ue === void 0 ? !1 : ue;
      function Oe(Ge, ft) {
        return Ge.map(function(Dt) {
          var Bn = E(Dt, ft);
          return Array.isArray(Bn) ? Bn.length ? Bn.map(function(Pn, ur) {
            var _s = be && ur > 0 ? {} : Dt;
            return Nct(_s, ft, Pn);
          }) : Lct(Dt, ft) : Dt;
        }).reduce(Ime, []);
      }
      return q = Array.isArray(q) ? q : q ? [q] : void 0, function(Ge) {
        return (q || sz(Ge)).reduce(Oe, [Ge]);
      };
    }
    var Oct = Mct, mme = Us.Readable, Cme = kt, Eme = pme, yme = dme, vme = function(F, q) {
      return new kt(q).parse(F);
    }, Bme = function(F, q, ue) {
      try {
        F instanceof mme || (ue = Object.assign({}, ue, {
          objectMode: !0
        }));
        var be = new pme(q, ue), Oe = be.promise();
        return Array.isArray(F) ? (F.forEach(function(Ge) {
          return be.input.push(Ge);
        }), be.input.push(null)) : F instanceof mme ? be.fromInput(F) : (be.input.push(F), be.input.push(null)), Oe;
      } catch (Ge) {
        return Promise.reject(Ge);
      }
    }, bme = {
      flatten: Tct,
      unwind: Oct
    }, Fct = {
      Parser: Cme,
      AsyncParser: Eme,
      Transform: yme,
      parse: vme,
      parseAsync: Bme,
      transforms: bme
    };
    n.AsyncParser = Eme, n.Parser = Cme, n.Transform = yme, n.default = Fct, n.parse = vme, n.parseAsync = Bme, n.transforms = bme, Object.defineProperty(n, "__esModule", { value: !0 });
  });
})(ree, ree.exports);
var pUt = ree.exports;
function aAe(t, e) {
  const n = Vv.schema, r = Vv.latestVersion, i = n.safeParse(t);
  if (!i.success) {
    const a = JSON.stringify(i.error.message, null, 2);
    throw new Error(`Tree validation failed: ${a}`);
  }
  const s = t.version !== r;
  return [i.data, s];
}
function IUt(t, e, n) {
  let r = JSON.parse(t);
  return [r] = aAe(r), r;
}
function mUt(t, e, n) {
  const i = R5e(h5e).parse(t, (A) => ({
    groupName: A.groupName,
    setName: A.setName,
    setColor: A.setColor ? j4t(A.setColor) : da(n),
    obsId: A.obsId,
    predictionScore: sae(A.predictionScore) || A.predictionScore === d5e ? null : +A.predictionScore
  })), s = $4t.schema.safeParse(i);
  if (s.success) {
    const A = s.data, l = {
      version: Vv.latestVersion,
      tree: []
    };
    return Array.from(new Set(A.map((u) => u.groupName))).forEach((u) => {
      const f = {
        name: u,
        children: []
      }, h = A.filter((I) => I.groupName === u);
      Array.from(new Set(h.map((I) => I.setName))).forEach((I) => {
        const m = h.filter((v) => v.setName === I), { setColor: C } = m[0], y = {
          name: I,
          color: C,
          set: m.map((v) => [v.obsId, v.predictionScore])
        };
        f.children.push(y);
      }), l.tree.push(f);
    }), l;
  } else {
    const A = JSON.stringify(s.error.message, null, 2);
    throw new Error(`Import validation failed: ${A}`);
  }
}
function Dve(t) {
  const e = JSON.stringify(t);
  return `data:${f5e};charset=utf-8,${encodeURIComponent(e)}`;
}
function CUt(t) {
  const e = [];
  t.tree.forEach((o) => {
    o.children.forEach((s) => {
      s.set && s.set.forEach(([a, A]) => {
        e.push({
          groupName: o.name,
          setName: s.name,
          setColor: Qu(s.color),
          obsId: a,
          predictionScore: sae(A) ? d5e : A
        });
      });
    });
  });
  const r = new pUt.Parser({
    fields: ["groupName", "setName", "setColor", "obsId", "predictionScore"],
    delimiter: h5e
  }).parse(e);
  return `data:${g5e};charset=utf-8,${encodeURIComponent(r)}`;
}
function g7(t, e) {
  const n = document.createElement("a");
  n.setAttribute("href", t), n.setAttribute("download", e), document.body.appendChild(n), n.click(), n.remove();
}
function D5e(t, e) {
  const [n, r, i] = t, o = eee(lg);
  return r.forEach((s, a) => {
    const { name: A } = e[a];
    let l = {
      name: A,
      children: []
    };
    if (s.length > 0 && Array.isArray(s[0])) {
      const c = new YZ([], JSON.stringify);
      n[a].forEach((I, m) => {
        const C = s.map((y) => y[m]);
        c.has(C) ? c.get(C).push([I, null]) : c.set(C, [[I, null]]);
      });
      const u = Array.from(c.keys()), f = (I) => Array.from(new Set(I.map((C) => C[0]))).sort((C, y) => C.localeCompare(y)), h = (I, m, C) => {
        const y = C.length === 0, v = {
          name: m
        };
        if (y)
          v.set = c.get([...I, m]);
        else if (C.length === 1 && m === C[0][C[0].length - 1])
          v.set = c.get([...I, m, ...C[0]]);
        else {
          const Q = f(C);
          v.children = Q.map((w) => h([...I, m], w, C.filter((R) => R[0] === w).map((R) => R.slice(1)).filter((R) => R.length > 0)));
        }
        return v;
      }, d = f(u).map((I) => h([], I, u.filter((m) => m[0] === I).map((m) => m.slice(1))));
      l.children = d;
    } else {
      const c = Array.from(new Set(s)).sort(), u = {};
      c.forEach((f) => u[f] = { name: f, set: [] }), i[a] ? s.forEach((f, h) => u[f].set.push([n[a][h], i[a][h]])) : s.forEach((f, h) => u[f].set.push([n[a][h], null])), Object.values(u).forEach(
        // eslint-disable-next-line no-return-assign
        (f) => l = b5e(l, f)
      );
    }
    o.tree.push(l);
  }), o;
}
const EUt = [[103, 0, 31], [178, 24, 43], [214, 96, 77], [244, 165, 130], [253, 219, 199], [247, 247, 247], [209, 229, 240], [146, 197, 222], [67, 147, 195], [33, 102, 172], [5, 48, 97]], yUt = [[13, 8, 135], [16, 7, 136], [19, 7, 137], [22, 7, 138], [25, 6, 140], [27, 6, 141], [29, 6, 142], [32, 6, 143], [34, 6, 144], [36, 6, 145], [38, 5, 145], [40, 5, 146], [42, 5, 147], [44, 5, 148], [46, 5, 149], [47, 5, 150], [49, 5, 151], [51, 5, 151], [53, 4, 152], [55, 4, 153], [56, 4, 154], [58, 4, 154], [60, 4, 155], [62, 4, 156], [63, 4, 156], [65, 4, 157], [67, 3, 158], [68, 3, 158], [70, 3, 159], [72, 3, 159], [73, 3, 160], [75, 3, 161], [76, 2, 161], [78, 2, 162], [80, 2, 162], [81, 2, 163], [83, 2, 163], [85, 2, 164], [86, 1, 164], [88, 1, 164], [89, 1, 165], [91, 1, 165], [92, 1, 166], [94, 1, 166], [96, 1, 166], [97, 0, 167], [99, 0, 167], [100, 0, 167], [102, 0, 167], [103, 0, 168], [105, 0, 168], [106, 0, 168], [108, 0, 168], [110, 0, 168], [111, 0, 168], [113, 0, 168], [114, 1, 168], [116, 1, 168], [117, 1, 168], [119, 1, 168], [120, 1, 168], [122, 2, 168], [123, 2, 168], [125, 3, 168], [126, 3, 168], [128, 4, 168], [129, 4, 167], [131, 5, 167], [132, 5, 167], [134, 6, 166], [135, 7, 166], [136, 8, 166], [138, 9, 165], [139, 10, 165], [141, 11, 165], [142, 12, 164], [143, 13, 164], [145, 14, 163], [146, 15, 163], [148, 16, 162], [149, 17, 161], [150, 19, 161], [152, 20, 160], [153, 21, 159], [154, 22, 159], [156, 23, 158], [157, 24, 157], [158, 25, 157], [160, 26, 156], [161, 27, 155], [162, 29, 154], [163, 30, 154], [165, 31, 153], [166, 32, 152], [167, 33, 151], [168, 34, 150], [170, 35, 149], [171, 36, 148], [172, 38, 148], [173, 39, 147], [174, 40, 146], [176, 41, 145], [177, 42, 144], [178, 43, 143], [179, 44, 142], [180, 46, 141], [181, 47, 140], [182, 48, 139], [183, 49, 138], [184, 50, 137], [186, 51, 136], [187, 52, 136], [188, 53, 135], [189, 55, 134], [190, 56, 133], [191, 57, 132], [192, 58, 131], [193, 59, 130], [194, 60, 129], [195, 61, 128], [196, 62, 127], [197, 64, 126], [198, 65, 125], [199, 66, 124], [200, 67, 123], [201, 68, 122], [202, 69, 122], [203, 70, 121], [204, 71, 120], [204, 73, 119], [205, 74, 118], [206, 75, 117], [207, 76, 116], [208, 77, 115], [209, 78, 114], [210, 79, 113], [211, 81, 113], [212, 82, 112], [213, 83, 111], [213, 84, 110], [214, 85, 109], [215, 86, 108], [216, 87, 107], [217, 88, 106], [218, 90, 106], [218, 91, 105], [219, 92, 104], [220, 93, 103], [221, 94, 102], [222, 95, 101], [222, 97, 100], [223, 98, 99], [224, 99, 99], [225, 100, 98], [226, 101, 97], [226, 102, 96], [227, 104, 95], [228, 105, 94], [229, 106, 93], [229, 107, 93], [230, 108, 92], [231, 110, 91], [231, 111, 90], [232, 112, 89], [233, 113, 88], [233, 114, 87], [234, 116, 87], [235, 117, 86], [235, 118, 85], [236, 119, 84], [237, 121, 83], [237, 122, 82], [238, 123, 81], [239, 124, 81], [239, 126, 80], [240, 127, 79], [240, 128, 78], [241, 129, 77], [241, 131, 76], [242, 132, 75], [243, 133, 75], [243, 135, 74], [244, 136, 73], [244, 137, 72], [245, 139, 71], [245, 140, 70], [246, 141, 69], [246, 143, 68], [247, 144, 68], [247, 145, 67], [247, 147, 66], [248, 148, 65], [248, 149, 64], [249, 151, 63], [249, 152, 62], [249, 154, 62], [250, 155, 61], [250, 156, 60], [250, 158, 59], [251, 159, 58], [251, 161, 57], [251, 162, 56], [252, 163, 56], [252, 165, 55], [252, 166, 54], [252, 168, 53], [252, 169, 52], [253, 171, 51], [253, 172, 51], [253, 174, 50], [253, 175, 49], [253, 177, 48], [253, 178, 47], [253, 180, 47], [253, 181, 46], [254, 183, 45], [254, 184, 44], [254, 186, 44], [254, 187, 43], [254, 189, 42], [254, 190, 42], [254, 192, 41], [253, 194, 41], [253, 195, 40], [253, 197, 39], [253, 198, 39], [253, 200, 39], [253, 202, 38], [253, 203, 38], [252, 205, 37], [252, 206, 37], [252, 208, 37], [252, 210, 37], [251, 211, 36], [251, 213, 36], [251, 215, 36], [250, 216, 36], [250, 218, 36], [249, 220, 36], [249, 221, 37], [248, 223, 37], [248, 225, 37], [247, 226, 37], [247, 228, 37], [246, 230, 38], [246, 232, 38], [245, 233, 38], [245, 235, 39], [244, 237, 39], [243, 238, 39], [243, 240, 39], [242, 242, 39], [241, 244, 38], [241, 245, 37], [240, 247, 36], [240, 249, 33]];
function vUt(t) {
  return (e) => {
    const n = e.length, r = new Array(n), i = new Array(n), o = new Array(n);
    let s, a;
    for (s = 0; s < n; ++s)
      a = [e[s][0], e[s][1], e[s][2]], r[s] = a[0] || 0, i[s] = a[1] || 0, o[s] = a[2] || 0;
    const A = t(r), l = t(i), c = t(o);
    return (u) => [A(u), l(u), c(u)];
  };
}
function BUt(t) {
  function e(r, i, o, s, a) {
    const A = r * r, l = A * r;
    return ((1 - 3 * r + 3 * A - l) * i + (4 - 6 * A + 3 * l) * o + (1 + 3 * r + 3 * A - 3 * l) * s + l * a) / 6;
  }
  const n = t.length - 1;
  return (r) => {
    const i = r <= 0 ? r = 0 : r >= 1 ? (r = 1, n - 1) : Math.floor(r * n), o = t[i], s = t[i + 1], a = i > 0 ? t[i - 1] : 2 * o - s, A = i < n - 1 ? t[i + 2] : 2 * s - o;
    return e((r - i / n) * n, a, o, s, A);
  };
}
const bUt = vUt(BUt);
function _Ut(t) {
  const e = t.length;
  return (n) => t[Math.max(0, Math.min(e - 1, Math.floor(n * e)))];
}
bUt(EUt);
_Ut(yUt);
function ML(t) {
  const { cellSets: e, cellSetSelection: n, cellSetColor: r, obsIndex: i, theme: o } = t;
  return n && e ? nUt(
    e,
    n,
    r,
    o
    /* as string */
  ) : i && o ? new Map(i.map((s) => [s, da(o)])) : /* @__PURE__ */ new Map();
}
var T5e = { exports: {} }, SUt = T5e.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
typeof __g == "number" && (__g = SUt);
var KB = T5e.exports, N5e = { exports: {} }, QUt = N5e.exports = { version: "2.6.12" };
typeof __e == "number" && (__e = QUt);
var BE = N5e.exports, wUt = function(t) {
  if (typeof t != "function")
    throw TypeError(t + " is not a function!");
  return t;
}, xUt = wUt, L5e = function(t, e, n) {
  if (xUt(t), e === void 0)
    return t;
  switch (n) {
    case 1:
      return function(r) {
        return t.call(e, r);
      };
    case 2:
      return function(r, i) {
        return t.call(e, r, i);
      };
    case 3:
      return function(r, i, o) {
        return t.call(e, r, i, o);
      };
  }
  return function() {
    return t.apply(e, arguments);
  };
}, bE = {}, pw = function(t) {
  return typeof t == "object" ? t !== null : typeof t == "function";
}, RUt = pw, OL = function(t) {
  if (!RUt(t))
    throw TypeError(t + " is not an object!");
  return t;
}, FL = function(t) {
  try {
    return !!t();
  } catch {
    return !0;
  }
}, _E = !FL(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), h7, Tve;
function M5e() {
  if (Tve)
    return h7;
  Tve = 1;
  var t = pw, e = KB.document, n = t(e) && t(e.createElement);
  return h7 = function(r) {
    return n ? e.createElement(r) : {};
  }, h7;
}
var O5e = !_E && !FL(function() {
  return Object.defineProperty(M5e()("div"), "a", { get: function() {
    return 7;
  } }).a != 7;
}), vF = pw, AAe = function(t, e) {
  if (!vF(t))
    return t;
  var n, r;
  if (e && typeof (n = t.toString) == "function" && !vF(r = n.call(t)) || typeof (n = t.valueOf) == "function" && !vF(r = n.call(t)) || !e && typeof (n = t.toString) == "function" && !vF(r = n.call(t)))
    return r;
  throw TypeError("Can't convert object to primitive value");
}, Nve = OL, DUt = O5e, TUt = AAe, NUt = Object.defineProperty;
bE.f = _E ? Object.defineProperty : function(e, n, r) {
  if (Nve(e), n = TUt(n, !0), Nve(r), DUt)
    try {
      return NUt(e, n, r);
    } catch {
    }
  if ("get" in r || "set" in r)
    throw TypeError("Accessors not supported!");
  return "value" in r && (e[n] = r.value), e;
};
var v9 = function(t, e) {
  return {
    enumerable: !(t & 1),
    configurable: !(t & 2),
    writable: !(t & 4),
    value: e
  };
}, LUt = bE, MUt = v9, Iw = _E ? function(t, e, n) {
  return LUt.f(t, e, MUt(1, n));
} : function(t, e, n) {
  return t[e] = n, t;
}, OUt = {}.hasOwnProperty, WB = function(t, e) {
  return OUt.call(t, e);
}, BF = KB, d7 = BE, Lve = L5e, FUt = Iw, PUt = WB, bF = "prototype", kl = function(t, e, n) {
  var r = t & kl.F, i = t & kl.G, o = t & kl.S, s = t & kl.P, a = t & kl.B, A = t & kl.W, l = i ? d7 : d7[e] || (d7[e] = {}), c = l[bF], u = i ? BF : o ? BF[e] : (BF[e] || {})[bF], f, h, d;
  i && (n = e);
  for (f in n)
    h = !r && u && u[f] !== void 0, !(h && PUt(l, f)) && (d = h ? u[f] : n[f], l[f] = i && typeof u[f] != "function" ? n[f] : a && h ? Lve(d, BF) : A && u[f] == d ? function(I) {
      var m = function(C, y, v) {
        if (this instanceof I) {
          switch (arguments.length) {
            case 0:
              return new I();
            case 1:
              return new I(C);
            case 2:
              return new I(C, y);
          }
          return new I(C, y, v);
        }
        return I.apply(this, arguments);
      };
      return m[bF] = I[bF], m;
    }(d) : s && typeof d == "function" ? Lve(Function.call, d) : d, s && ((l.virtual || (l.virtual = {}))[f] = d, t & kl.R && c && !c[f] && FUt(c, f, d)));
};
kl.F = 1;
kl.G = 2;
kl.S = 4;
kl.P = 8;
kl.B = 16;
kl.W = 32;
kl.U = 64;
kl.R = 128;
var mw = kl, kUt = {}.toString, F5e = function(t) {
  return kUt.call(t).slice(8, -1);
}, p7, Mve;
function P5e() {
  if (Mve)
    return p7;
  Mve = 1;
  var t = F5e;
  return p7 = Object("z").propertyIsEnumerable(0) ? Object : function(e) {
    return t(e) == "String" ? e.split("") : Object(e);
  }, p7;
}
var lAe = function(t) {
  if (t == null)
    throw TypeError("Can't call method on  " + t);
  return t;
}, GUt = P5e(), UUt = lAe, Cw = function(t) {
  return GUt(UUt(t));
}, HUt = Math.ceil, $Ut = Math.floor, cAe = function(t) {
  return isNaN(t = +t) ? 0 : (t > 0 ? $Ut : HUt)(t);
}, qUt = cAe, jUt = Math.min, YUt = function(t) {
  return t > 0 ? jUt(qUt(t), 9007199254740991) : 0;
}, zUt = cAe, VUt = Math.max, JUt = Math.min, KUt = function(t, e) {
  return t = zUt(t), t < 0 ? VUt(t + e, 0) : JUt(t, e);
}, WUt = Cw, XUt = YUt, ZUt = KUt, e8t = function(t) {
  return function(e, n, r) {
    var i = WUt(e), o = XUt(i.length), s = ZUt(r, o), a;
    if (t && n != n) {
      for (; o > s; )
        if (a = i[s++], a != a)
          return !0;
    } else
      for (; o > s; s++)
        if ((t || s in i) && i[s] === n)
          return t || s || 0;
    return !t && -1;
  };
}, k5e = { exports: {} }, t8t = !0, n8t = BE, Ove = KB, Fve = "__core-js_shared__", Pve = Ove[Fve] || (Ove[Fve] = {});
(k5e.exports = function(t, e) {
  return Pve[t] || (Pve[t] = e !== void 0 ? e : {});
})("versions", []).push({
  version: n8t.version,
  mode: "pure",
  copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
});
var uAe = k5e.exports, r8t = 0, i8t = Math.random(), B9 = function(t) {
  return "Symbol(".concat(t === void 0 ? "" : t, ")_", (++r8t + i8t).toString(36));
}, kve = uAe("keys"), o8t = B9, fAe = function(t) {
  return kve[t] || (kve[t] = o8t(t));
}, Gve = WB, s8t = Cw, a8t = e8t(!1), A8t = fAe("IE_PROTO"), G5e = function(t, e) {
  var n = s8t(t), r = 0, i = [], o;
  for (o in n)
    o != A8t && Gve(n, o) && i.push(o);
  for (; e.length > r; )
    Gve(n, o = e[r++]) && (~a8t(i, o) || i.push(o));
  return i;
}, gAe = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","), l8t = G5e, c8t = gAe, b9 = Object.keys || function(e) {
  return l8t(e, c8t);
}, _9 = {};
_9.f = Object.getOwnPropertySymbols;
var I7 = {}, Uve;
function S9() {
  return Uve || (Uve = 1, I7.f = {}.propertyIsEnumerable), I7;
}
var u8t = lAe, hAe = function(t) {
  return Object(u8t(t));
}, m7, Hve;
function f8t() {
  if (Hve)
    return m7;
  Hve = 1;
  var t = _E, e = b9, n = _9, r = S9(), i = hAe, o = P5e(), s = Object.assign;
  return m7 = !s || FL(function() {
    var a = {}, A = {}, l = Symbol(), c = "abcdefghijklmnopqrst";
    return a[l] = 7, c.split("").forEach(function(u) {
      A[u] = u;
    }), s({}, a)[l] != 7 || Object.keys(s({}, A)).join("") != c;
  }) ? function(A, l) {
    for (var c = i(A), u = arguments.length, f = 1, h = n.f, d = r.f; u > f; )
      for (var I = o(arguments[f++]), m = h ? e(I).concat(h(I)) : e(I), C = m.length, y = 0, v; C > y; )
        v = m[y++], (!t || d.call(I, v)) && (c[v] = I[v]);
    return c;
  } : s, m7;
}
var C7 = mw;
C7(C7.S + C7.F, "Object", { assign: f8t() });
var g8t = BE.Object.assign, h8t = { default: g8t, __esModule: !0 }, d8t = h8t, p8t = I8t(d8t);
function I8t(t) {
  return t && t.__esModule ? t : { default: t };
}
var Cu = p8t.default || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, E7 = mw;
E7(E7.S + E7.F * !_E, "Object", { defineProperty: bE.f });
var m8t = BE.Object, C8t = function(e, n, r) {
  return m8t.defineProperty(e, n, r);
}, U5e = { default: C8t, __esModule: !0 }, E8t = U5e, y8t = v8t(E8t);
function v8t(t) {
  return t && t.__esModule ? t : { default: t };
}
var Iu = function(t, e, n) {
  return e in t ? (0, y8t.default)(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}, dAe = function(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}, B8t = U5e, b8t = _8t(B8t);
function _8t(t) {
  return t && t.__esModule ? t : { default: t };
}
var pAe = function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), (0, b8t.default)(e, i.key, i);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}(), Q9 = {}, S8t = cAe, Q8t = lAe, w8t = function(t) {
  return function(e, n) {
    var r = String(Q8t(e)), i = S8t(n), o = r.length, s, a;
    return i < 0 || i >= o ? t ? "" : void 0 : (s = r.charCodeAt(i), s < 55296 || s > 56319 || i + 1 === o || (a = r.charCodeAt(i + 1)) < 56320 || a > 57343 ? t ? r.charAt(i) : s : t ? r.slice(i, i + 2) : (s - 55296 << 10) + (a - 56320) + 65536);
  };
}, H5e = Iw, IAe = {}, x8t = bE, R8t = OL, D8t = b9, T8t = _E ? Object.defineProperties : function(e, n) {
  R8t(e);
  for (var r = D8t(n), i = r.length, o = 0, s; i > o; )
    x8t.f(e, s = r[o++], n[s]);
  return e;
}, y7, $ve;
function N8t() {
  if ($ve)
    return y7;
  $ve = 1;
  var t = KB.document;
  return y7 = t && t.documentElement, y7;
}
var L8t = OL, M8t = T8t, qve = gAe, O8t = fAe("IE_PROTO"), v7 = function() {
}, iee = "prototype", pk = function() {
  var t = M5e()("iframe"), e = qve.length, n = "<", r = ">", i;
  for (t.style.display = "none", N8t().appendChild(t), t.src = "javascript:", i = t.contentWindow.document, i.open(), i.write(n + "script" + r + "document.F=Object" + n + "/script" + r), i.close(), pk = i.F; e--; )
    delete pk[iee][qve[e]];
  return pk();
}, mAe = Object.create || function(e, n) {
  var r;
  return e !== null ? (v7[iee] = L8t(e), r = new v7(), v7[iee] = null, r[O8t] = e) : r = pk(), n === void 0 ? r : M8t(r, n);
}, $5e = { exports: {} }, oee = uAe("wks"), F8t = B9, see = KB.Symbol, jve = typeof see == "function", P8t = $5e.exports = function(t) {
  return oee[t] || (oee[t] = jve && see[t] || (jve ? see : F8t)("Symbol." + t));
};
P8t.store = oee;
var Ew = $5e.exports, k8t = bE.f, G8t = WB, Yve = Ew("toStringTag"), CAe = function(t, e, n) {
  t && !G8t(t = n ? t : t.prototype, Yve) && k8t(t, Yve, { configurable: !0, value: e });
}, U8t = mAe, H8t = v9, $8t = CAe, q5e = {};
Iw(q5e, Ew("iterator"), function() {
  return this;
});
var q8t = function(t, e, n) {
  t.prototype = U8t(q5e, { next: H8t(1, n) }), $8t(t, e + " Iterator");
}, j8t = WB, Y8t = hAe, zve = fAe("IE_PROTO"), z8t = Object.prototype, V8t = Object.getPrototypeOf || function(t) {
  return t = Y8t(t), j8t(t, zve) ? t[zve] : typeof t.constructor == "function" && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? z8t : null;
}, B7 = mw, J8t = H5e, K8t = Iw, Vve = IAe, W8t = q8t, X8t = CAe, Z8t = V8t, b7 = Ew("iterator"), _7 = !([].keys && "next" in [].keys()), e5t = "@@iterator", Jve = "keys", _F = "values", t5t = function() {
  return this;
}, j5e = function(t, e, n, r, i, o, s) {
  W8t(n, e, r);
  var a = function(v) {
    if (!_7 && v in u)
      return u[v];
    switch (v) {
      case Jve:
        return function() {
          return new n(this, v);
        };
      case _F:
        return function() {
          return new n(this, v);
        };
    }
    return function() {
      return new n(this, v);
    };
  }, A = e + " Iterator", l = i == _F, c = !1, u = t.prototype, f = u[b7] || u[e5t] || i && u[i], h = f || a(i), d = i ? l ? a("entries") : h : void 0, I = e == "Array" && u.entries || f, m, C, y;
  if (I && (y = Z8t(I.call(new t())), y !== Object.prototype && y.next && X8t(y, A, !0)), l && f && f.name !== _F && (c = !0, h = function() {
    return f.call(this);
  }), s && (_7 || c || !u[b7]) && K8t(u, b7, h), Vve[e] = h, Vve[A] = t5t, i)
    if (m = {
      values: l ? h : a(_F),
      keys: o ? h : a(Jve),
      entries: d
    }, s)
      for (C in m)
        C in u || J8t(u, C, m[C]);
    else
      B7(B7.P + B7.F * (_7 || c), e, m);
  return m;
}, n5t = w8t(!0);
j5e(String, "String", function(t) {
  this._t = String(t), this._i = 0;
}, function() {
  var t = this._t, e = this._i, n;
  return e >= t.length ? { value: void 0, done: !0 } : (n = n5t(t, e), this._i += n.length, { value: n, done: !1 });
});
var r5t = function(t, e) {
  return { value: e, done: !!t };
}, SF = r5t, Kve = IAe, i5t = Cw;
j5e(Array, "Array", function(t, e) {
  this._t = i5t(t), this._i = 0, this._k = e;
}, function() {
  var t = this._t, e = this._k, n = this._i++;
  return !t || n >= t.length ? (this._t = void 0, SF(1)) : e == "keys" ? SF(0, n) : e == "values" ? SF(0, t[n]) : SF(0, [n, t[n]]);
}, "values");
Kve.Arguments = Kve.Array;
var o5t = KB, s5t = Iw, Wve = IAe, Xve = Ew("toStringTag"), Zve = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(",");
for (var S7 = 0; S7 < Zve.length; S7++) {
  var Q7 = Zve[S7], eBe = o5t[Q7], w7 = eBe && eBe.prototype;
  w7 && !w7[Xve] && s5t(w7, Xve, Q7), Wve[Q7] = Wve.Array;
}
var w9 = {};
w9.f = Ew;
var a5t = w9.f("iterator"), A5t = { default: a5t, __esModule: !0 }, Y5e = { exports: {} }, Jv = B9("meta"), l5t = pw, EAe = WB, c5t = bE.f, u5t = 0, x9 = Object.isExtensible || function() {
  return !0;
}, f5t = !FL(function() {
  return x9(Object.preventExtensions({}));
}), yAe = function(t) {
  c5t(t, Jv, { value: {
    i: "O" + ++u5t,
    // object ID
    w: {}
    // weak collections IDs
  } });
}, g5t = function(t, e) {
  if (!l5t(t))
    return typeof t == "symbol" ? t : (typeof t == "string" ? "S" : "P") + t;
  if (!EAe(t, Jv)) {
    if (!x9(t))
      return "F";
    if (!e)
      return "E";
    yAe(t);
  }
  return t[Jv].i;
}, h5t = function(t, e) {
  if (!EAe(t, Jv)) {
    if (!x9(t))
      return !0;
    if (!e)
      return !1;
    yAe(t);
  }
  return t[Jv].w;
}, d5t = function(t) {
  return f5t && p5t.NEED && x9(t) && !EAe(t, Jv) && yAe(t), t;
}, p5t = Y5e.exports = {
  KEY: Jv,
  NEED: !1,
  fastKey: g5t,
  getWeak: h5t,
  onFreeze: d5t
}, I5t = Y5e.exports, tBe = BE, m5t = w9, C5t = bE.f, vAe = function(t) {
  var e = tBe.Symbol || (tBe.Symbol = {});
  t.charAt(0) != "_" && !(t in e) && C5t(e, t, { value: m5t.f(t) });
}, E5t = b9, y5t = _9, v5t = S9(), B5t = function(t) {
  var e = E5t(t), n = y5t.f;
  if (n)
    for (var r = n(t), i = v5t.f, o = 0, s; r.length > o; )
      i.call(t, s = r[o++]) && e.push(s);
  return e;
}, b5t = F5e, _5t = Array.isArray || function(e) {
  return b5t(e) == "Array";
}, z5e = {}, BAe = {}, S5t = G5e, Q5t = gAe.concat("length", "prototype");
BAe.f = Object.getOwnPropertyNames || function(e) {
  return S5t(e, Q5t);
};
var w5t = Cw, V5e = BAe.f, x5t = {}.toString, J5e = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], R5t = function(t) {
  try {
    return V5e(t);
  } catch {
    return J5e.slice();
  }
};
z5e.f = function(e) {
  return J5e && x5t.call(e) == "[object Window]" ? R5t(e) : V5e(w5t(e));
};
var bAe = {}, D5t = S9(), T5t = v9, N5t = Cw, L5t = AAe, M5t = WB, O5t = O5e, nBe = Object.getOwnPropertyDescriptor;
bAe.f = _E ? nBe : function(e, n) {
  if (e = N5t(e), n = L5t(n, !0), O5t)
    try {
      return nBe(e, n);
    } catch {
    }
  if (M5t(e, n))
    return T5t(!D5t.f.call(e, n), e[n]);
};
var R9 = KB, RA = WB, aee = _E, Vl = mw, rBe = H5e, F5t = I5t.KEY, _Ae = FL, SAe = uAe, QAe = CAe, P5t = B9, PL = Ew, k5t = w9, G5t = vAe, U5t = B5t, H5t = _5t, Aee = OL, $5t = pw, q5t = hAe, D9 = Cw, wAe = AAe, lee = v9, wT = mAe, K5e = z5e, W5e = bAe, T9 = _9, X5e = bE, j5t = b9, Z5e = W5e.f, Jy = X5e.f, e6e = K5e.f, Ru = R9.Symbol, sU = R9.JSON, QF = sU && sU.stringify, _C = "prototype", Eu = PL("_hidden"), iBe = PL("toPrimitive"), Y5t = {}.propertyIsEnumerable, Kx = SAe("symbol-registry"), DI = SAe("symbols"), kL = SAe("op-symbols"), _g = Object[_C], yw = typeof Ru == "function" && !!T9.f, x7 = R9.QObject, cee = !x7 || !x7[_C] || !x7[_C].findChild, uee = aee && _Ae(function() {
  return wT(Jy({}, "a", {
    get: function() {
      return Jy(this, "a", { value: 7 }).a;
    }
  })).a != 7;
}) ? function(t, e, n) {
  var r = Z5e(_g, e);
  r && delete _g[e], Jy(t, e, n), r && t !== _g && Jy(_g, e, r);
} : Jy, oBe = function(t) {
  var e = DI[t] = wT(Ru[_C]);
  return e._k = t, e;
}, fee = yw && typeof Ru.iterator == "symbol" ? function(t) {
  return typeof t == "symbol";
} : function(t) {
  return t instanceof Ru;
}, N9 = function(e, n, r) {
  return e === _g && N9(kL, n, r), Aee(e), n = wAe(n, !0), Aee(r), RA(DI, n) ? (r.enumerable ? (RA(e, Eu) && e[Eu][n] && (e[Eu][n] = !1), r = wT(r, { enumerable: lee(0, !1) })) : (RA(e, Eu) || Jy(e, Eu, lee(1, {})), e[Eu][n] = !0), uee(e, n, r)) : Jy(e, n, r);
}, t6e = function(e, n) {
  Aee(e);
  for (var r = U5t(n = D9(n)), i = 0, o = r.length, s; o > i; )
    N9(e, s = r[i++], n[s]);
  return e;
}, z5t = function(e, n) {
  return n === void 0 ? wT(e) : t6e(wT(e), n);
}, sBe = function(e) {
  var n = Y5t.call(this, e = wAe(e, !0));
  return this === _g && RA(DI, e) && !RA(kL, e) ? !1 : n || !RA(this, e) || !RA(DI, e) || RA(this, Eu) && this[Eu][e] ? n : !0;
}, n6e = function(e, n) {
  if (e = D9(e), n = wAe(n, !0), !(e === _g && RA(DI, n) && !RA(kL, n))) {
    var r = Z5e(e, n);
    return r && RA(DI, n) && !(RA(e, Eu) && e[Eu][n]) && (r.enumerable = !0), r;
  }
}, r6e = function(e) {
  for (var n = e6e(D9(e)), r = [], i = 0, o; n.length > i; )
    !RA(DI, o = n[i++]) && o != Eu && o != F5t && r.push(o);
  return r;
}, i6e = function(e) {
  for (var n = e === _g, r = e6e(n ? kL : D9(e)), i = [], o = 0, s; r.length > o; )
    RA(DI, s = r[o++]) && (!n || RA(_g, s)) && i.push(DI[s]);
  return i;
};
yw || (Ru = function() {
  if (this instanceof Ru)
    throw TypeError("Symbol is not a constructor!");
  var e = P5t(arguments.length > 0 ? arguments[0] : void 0), n = function(r) {
    this === _g && n.call(kL, r), RA(this, Eu) && RA(this[Eu], e) && (this[Eu][e] = !1), uee(this, e, lee(1, r));
  };
  return aee && cee && uee(_g, e, { configurable: !0, set: n }), oBe(e);
}, rBe(Ru[_C], "toString", function() {
  return this._k;
}), W5e.f = n6e, X5e.f = N9, BAe.f = K5e.f = r6e, S9().f = sBe, T9.f = i6e, aee && !t8t && rBe(_g, "propertyIsEnumerable", sBe), k5t.f = function(t) {
  return oBe(PL(t));
});
Vl(Vl.G + Vl.W + Vl.F * !yw, { Symbol: Ru });
for (var aBe = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(",")
), ABe = 0; aBe.length > ABe; )
  PL(aBe[ABe++]);
for (var lBe = j5t(PL.store), cBe = 0; lBe.length > cBe; )
  G5t(lBe[cBe++]);
Vl(Vl.S + Vl.F * !yw, "Symbol", {
  // 19.4.2.1 Symbol.for(key)
  for: function(t) {
    return RA(Kx, t += "") ? Kx[t] : Kx[t] = Ru(t);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function(e) {
    if (!fee(e))
      throw TypeError(e + " is not a symbol!");
    for (var n in Kx)
      if (Kx[n] === e)
        return n;
  },
  useSetter: function() {
    cee = !0;
  },
  useSimple: function() {
    cee = !1;
  }
});
Vl(Vl.S + Vl.F * !yw, "Object", {
  // 19.1.2.2 Object.create(O [, Properties])
  create: z5t,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: N9,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: t6e,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: n6e,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: r6e,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: i6e
});
var V5t = _Ae(function() {
  T9.f(1);
});
Vl(Vl.S + Vl.F * V5t, "Object", {
  getOwnPropertySymbols: function(e) {
    return T9.f(q5t(e));
  }
});
sU && Vl(Vl.S + Vl.F * (!yw || _Ae(function() {
  var t = Ru();
  return QF([t]) != "[null]" || QF({ a: t }) != "{}" || QF(Object(t)) != "{}";
})), "JSON", {
  stringify: function(e) {
    for (var n = [e], r = 1, i, o; arguments.length > r; )
      n.push(arguments[r++]);
    if (o = i = n[1], !(!$5t(i) && e === void 0 || fee(e)))
      return H5t(i) || (i = function(s, a) {
        if (typeof o == "function" && (a = o.call(this, s, a)), !fee(a))
          return a;
      }), n[1] = i, QF.apply(sU, n);
  }
});
Ru[_C][iBe] || Iw(Ru[_C], iBe, Ru[_C].valueOf);
QAe(Ru, "Symbol");
QAe(Math, "Math", !0);
QAe(R9.JSON, "JSON", !0);
vAe("asyncIterator");
vAe("observable");
var J5t = BE.Symbol, K5t = { default: J5t, __esModule: !0 };
Q9.__esModule = !0;
var W5t = A5t, o6e = s6e(W5t), X5t = K5t, oC = s6e(X5t), R7 = typeof oC.default == "function" && typeof o6e.default == "symbol" ? function(t) {
  return typeof t;
} : function(t) {
  return t && typeof oC.default == "function" && t.constructor === oC.default && t !== oC.default.prototype ? "symbol" : typeof t;
};
function s6e(t) {
  return t && t.__esModule ? t : { default: t };
}
Q9.default = typeof oC.default == "function" && R7(o6e.default) === "symbol" ? function(t) {
  return typeof t > "u" ? "undefined" : R7(t);
} : function(t) {
  return t && typeof oC.default == "function" && t.constructor === oC.default && t !== oC.default.prototype ? "symbol" : typeof t > "u" ? "undefined" : R7(t);
};
var Z5t = Q9, e6t = t6t(Z5t);
function t6t(t) {
  return t && t.__esModule ? t : { default: t };
}
var xAe = function(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && ((typeof e > "u" ? "undefined" : (0, e6t.default)(e)) === "object" || typeof e == "function") ? e : t;
}, D7, uBe;
function n6t() {
  if (uBe)
    return D7;
  uBe = 1;
  var t = pw, e = OL, n = function(r, i) {
    if (e(r), !t(i) && i !== null)
      throw TypeError(i + ": can't set as prototype!");
  };
  return D7 = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? (
      // eslint-disable-line
      function(r, i, o) {
        try {
          o = L5e(Function.call, bAe.f(Object.prototype, "__proto__").set, 2), o(r, []), i = !(r instanceof Array);
        } catch {
          i = !0;
        }
        return function(a, A) {
          return n(a, A), i ? a.__proto__ = A : o(a, A), a;
        };
      }({}, !1)
    ) : void 0),
    check: n
  }, D7;
}
var fBe = mw;
fBe(fBe.S, "Object", { setPrototypeOf: n6t().set });
var r6t = BE.Object.setPrototypeOf, i6t = { default: r6t, __esModule: !0 }, gBe = mw;
gBe(gBe.S, "Object", { create: mAe });
var o6t = BE.Object, s6t = function(e, n) {
  return o6t.create(e, n);
}, a6t = { default: s6t, __esModule: !0 }, A6t = i6t, hBe = RAe(A6t), l6t = a6t, c6t = RAe(l6t), u6t = Q9, f6t = RAe(u6t);
function RAe(t) {
  return t && t.__esModule ? t : { default: t };
}
var DAe = function(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + (typeof e > "u" ? "undefined" : (0, f6t.default)(e)));
  t.prototype = (0, c6t.default)(e && e.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), e && (hBe.default ? (0, hBe.default)(t, e) : t.__proto__ = e);
}, a6e = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var s = typeof o;
          if (s === "string" || s === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var a = n.apply(null, o);
              a && r.push(a);
            }
          } else if (s === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              r.push(o.toString());
              continue;
            }
            for (var A in o)
              e.call(o, A) && o[A] && r.push(A);
          }
        }
      }
      return r.join(" ");
    }
    t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
  })();
})(a6e);
var g6t = a6e.exports;
const Gl = /* @__PURE__ */ ko(g6t);
var h6t = function() {
}, d6t = h6t;
const xT = /* @__PURE__ */ ko(d6t);
function LS(t) {
  var e = [];
  return St.Children.forEach(t, function(n) {
    n != null && (Array.isArray(n) ? e = e.concat(LS(n)) : _se.isFragment(n) && n.props ? e = e.concat(LS(n.props.children)) : e.push(n));
  }), e;
}
function A6e() {
  var t = this.constructor.getDerivedStateFromProps(this.props, this.state);
  t != null && this.setState(t);
}
function l6e(t) {
  function e(n) {
    var r = this.constructor.getDerivedStateFromProps(t, n);
    return r ?? null;
  }
  this.setState(e.bind(this));
}
function c6e(t, e) {
  try {
    var n = this.props, r = this.state;
    this.props = t, this.state = e, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      n,
      r
    );
  } finally {
    this.props = n, this.state = r;
  }
}
A6e.__suppressDeprecationWarning = !0;
l6e.__suppressDeprecationWarning = !0;
c6e.__suppressDeprecationWarning = !0;
function L9(t) {
  var e = t.prototype;
  if (!e || !e.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof t.getDerivedStateFromProps != "function" && typeof e.getSnapshotBeforeUpdate != "function")
    return t;
  var n = null, r = null, i = null;
  if (typeof e.componentWillMount == "function" ? n = "componentWillMount" : typeof e.UNSAFE_componentWillMount == "function" && (n = "UNSAFE_componentWillMount"), typeof e.componentWillReceiveProps == "function" ? r = "componentWillReceiveProps" : typeof e.UNSAFE_componentWillReceiveProps == "function" && (r = "UNSAFE_componentWillReceiveProps"), typeof e.componentWillUpdate == "function" ? i = "componentWillUpdate" : typeof e.UNSAFE_componentWillUpdate == "function" && (i = "UNSAFE_componentWillUpdate"), n !== null || r !== null || i !== null) {
    var o = t.displayName || t.name, s = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + o + " uses " + s + " but also contains the following legacy lifecycles:" + (n !== null ? `
  ` + n : "") + (r !== null ? `
  ` + r : "") + (i !== null ? `
  ` + i : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof t.getDerivedStateFromProps == "function" && (e.componentWillMount = A6e, e.componentWillReceiveProps = l6e), typeof e.getSnapshotBeforeUpdate == "function") {
    if (typeof e.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    e.componentWillUpdate = c6e;
    var a = e.componentDidUpdate;
    e.componentDidUpdate = function(l, c, u) {
      var f = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : u;
      a.call(this, l, c, f);
    };
  }
  return t;
}
const p6t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: L9
}, Symbol.toStringTag, { value: "Module" }));
var u6e = {
  rcTree: ut.shape({
    root: ut.object,
    prefixCls: ut.string,
    selectable: ut.bool,
    showIcon: ut.bool,
    icon: ut.oneOfType([ut.node, ut.func]),
    draggable: ut.bool,
    checkable: ut.oneOfType([ut.bool, ut.node]),
    checkStrictly: ut.bool,
    disabled: ut.bool,
    openTransitionName: ut.string,
    openAnimation: ut.oneOfType([ut.string, ut.object]),
    loadData: ut.func,
    filterTreeNode: ut.func,
    renderTreeNode: ut.func,
    isKeyChecked: ut.func,
    onNodeClick: ut.func,
    onNodeDoubleClick: ut.func,
    onNodeExpand: ut.func,
    onNodeSelect: ut.func,
    onNodeCheck: ut.func,
    onNodeMouseEnter: ut.func,
    onNodeMouseLeave: ut.func,
    onNodeContextMenu: ut.func,
    onNodeDragStart: ut.func,
    onNodeDragEnter: ut.func,
    onNodeDragOver: ut.func,
    onNodeDragLeave: ut.func,
    onNodeDragEnd: ut.func,
    onNodeDrop: ut.func
    // TODO: Remove this
    // onBatchNodeCheck: PropTypes.func,
    // onCheckConductFinished: PropTypes.func,
    // Tree will store the entities when the treeNode refresh.
    // User can pass the func to add more info to customize the additional info.
    // processTreeEntity: PropTypes.func,
  })
}, f6e = Cu({}, u6e, {
  rcTreeNode: ut.shape({
    onUpCheckConduct: ut.func
  })
}), g6e = function(t, e) {
  var n = {};
  for (var r in t)
    e.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
  return n;
};
function I6t(t) {
  return t instanceof HTMLElement ? t : Sf.findDOMNode(t);
}
var M9 = { exports: {} }, IR = { exports: {} };
(function() {
  var t, e, n, r, i, o;
  typeof performance < "u" && performance !== null && performance.now ? IR.exports = function() {
    return performance.now();
  } : typeof process < "u" && process !== null && process.hrtime ? (IR.exports = function() {
    return (t() - i) / 1e6;
  }, e = process.hrtime, t = function() {
    var s;
    return s = e(), s[0] * 1e9 + s[1];
  }, r = t(), o = process.uptime() * 1e9, i = r - o) : Date.now ? (IR.exports = function() {
    return Date.now() - n;
  }, n = Date.now()) : (IR.exports = function() {
    return (/* @__PURE__ */ new Date()).getTime() - n;
  }, n = (/* @__PURE__ */ new Date()).getTime());
}).call(ei);
var m6t = IR.exports, C6t = m6t, II = typeof window > "u" ? ei : window, wF = ["moz", "webkit"], G_ = "AnimationFrame", MS = II["request" + G_], RT = II["cancel" + G_] || II["cancelRequest" + G_];
for (var Wx = 0; !MS && Wx < wF.length; Wx++)
  MS = II[wF[Wx] + "Request" + G_], RT = II[wF[Wx] + "Cancel" + G_] || II[wF[Wx] + "CancelRequest" + G_];
if (!MS || !RT) {
  var T7 = 0, dBe = 0, fy = [], E6t = 1e3 / 60;
  MS = function(t) {
    if (fy.length === 0) {
      var e = C6t(), n = Math.max(0, E6t - (e - T7));
      T7 = n + e, setTimeout(function() {
        var r = fy.slice(0);
        fy.length = 0;
        for (var i = 0; i < r.length; i++)
          if (!r[i].cancelled)
            try {
              r[i].callback(T7);
            } catch (o) {
              setTimeout(function() {
                throw o;
              }, 0);
            }
      }, Math.round(n));
    }
    return fy.push({
      handle: ++dBe,
      callback: t,
      cancelled: !1
    }), dBe;
  }, RT = function(t) {
    for (var e = 0; e < fy.length; e++)
      fy[e].handle === t && (fy[e].cancelled = !0);
  };
}
M9.exports = function(t) {
  return MS.call(II, t);
};
M9.exports.cancel = function() {
  RT.apply(II, arguments);
};
M9.exports.polyfill = function(t) {
  t || (t = II), t.requestAnimationFrame = MS, t.cancelAnimationFrame = RT;
};
var y6t = M9.exports;
const pBe = /* @__PURE__ */ ko(y6t);
var h6e = !!(typeof window < "u" && window.document && window.document.createElement);
function IBe(t, e) {
  var n = {};
  return n[t.toLowerCase()] = e.toLowerCase(), n["Webkit" + t] = "webkit" + e, n["Moz" + t] = "moz" + e, n["ms" + t] = "MS" + e, n["O" + t] = "o" + e.toLowerCase(), n;
}
function v6t(t, e) {
  var n = {
    animationend: IBe("Animation", "AnimationEnd"),
    transitionend: IBe("Transition", "TransitionEnd")
  };
  return t && ("AnimationEvent" in e || delete n.animationend.animation, "TransitionEvent" in e || delete n.transitionend.transition), n;
}
var B6t = v6t(h6e, typeof window < "u" ? window : {}), d6e = {};
h6e && (d6e = document.createElement("div").style);
var xF = {};
function p6e(t) {
  if (xF[t])
    return xF[t];
  var e = B6t[t];
  if (e)
    for (var n = Object.keys(e), r = n.length, i = 0; i < r; i += 1) {
      var o = n[i];
      if (Object.prototype.hasOwnProperty.call(e, o) && o in d6e)
        return xF[t] = e[o], xF[t];
    }
  return "";
}
var gee = p6e("animationend"), hee = p6e("transitionend"), b6t = !!(gee && hee);
function mBe(t, e) {
  if (!t)
    return null;
  if (typeof t == "object") {
    var n = e.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return t[n];
  }
  return t + "-" + e;
}
var _m = "none", Xx = "appear", Zx = "enter", e2 = "leave", _6t = {
  eventProps: ut.object,
  // Internal usage. Only pass by CSSMotionList
  visible: ut.bool,
  children: ut.func,
  motionName: ut.oneOfType([ut.string, ut.object]),
  motionAppear: ut.bool,
  motionEnter: ut.bool,
  motionLeave: ut.bool,
  motionLeaveImmediately: ut.bool,
  // Trigger leave motion immediately
  motionDeadline: ut.number,
  removeOnLeave: ut.bool,
  leavedClassName: ut.string,
  onAppearStart: ut.func,
  onAppearActive: ut.func,
  onAppearEnd: ut.func,
  onEnterStart: ut.func,
  onEnterActive: ut.func,
  onEnterEnd: ut.func,
  onLeaveStart: ut.func,
  onLeaveActive: ut.func,
  onLeaveEnd: ut.func
};
function S6t(t) {
  var e = t, n = !!St.forwardRef;
  typeof t == "object" && (e = t.transitionSupport, n = "forwardRef" in t ? t.forwardRef : n);
  function r(o) {
    return !!(o.motionName && e);
  }
  var i = function(o) {
    DAe(s, o);
    function s() {
      dAe(this, s);
      var a = xAe(this, (s.__proto__ || Object.getPrototypeOf(s)).call(this));
      return a.onDomUpdate = function() {
        var A = a.state, l = A.status, c = A.newStatus, u = a.props, f = u.onAppearStart, h = u.onEnterStart, d = u.onLeaveStart, I = u.onAppearActive, m = u.onEnterActive, C = u.onLeaveActive, y = u.motionAppear, v = u.motionEnter, b = u.motionLeave;
        if (r(a.props)) {
          var Q = a.getElement();
          a.$cacheEle !== Q && (a.removeEventListener(a.$cacheEle), a.addEventListener(Q), a.$cacheEle = Q), c && l === Xx && y ? a.updateStatus(f, null, null, function() {
            a.updateActiveStatus(I, Xx);
          }) : c && l === Zx && v ? a.updateStatus(h, null, null, function() {
            a.updateActiveStatus(m, Zx);
          }) : c && l === e2 && b && a.updateStatus(d, null, null, function() {
            a.updateActiveStatus(C, e2);
          });
        }
      }, a.onMotionEnd = function(A) {
        var l = a.state, c = l.status, u = l.statusActive, f = a.props, h = f.onAppearEnd, d = f.onEnterEnd, I = f.onLeaveEnd;
        c === Xx && u ? a.updateStatus(h, { status: _m }, A) : c === Zx && u ? a.updateStatus(d, { status: _m }, A) : c === e2 && u && a.updateStatus(I, { status: _m }, A);
      }, a.setNodeRef = function(A) {
        var l = a.props.internalRef;
        a.node = A, typeof l == "function" ? l(A) : l && "current" in l && (l.current = A);
      }, a.getElement = function() {
        try {
          return I6t(a.node || a);
        } catch {
          return a.$cacheEle;
        }
      }, a.addEventListener = function(A) {
        A && (A.addEventListener(hee, a.onMotionEnd), A.addEventListener(gee, a.onMotionEnd));
      }, a.removeEventListener = function(A) {
        A && (A.removeEventListener(hee, a.onMotionEnd), A.removeEventListener(gee, a.onMotionEnd));
      }, a.updateStatus = function(A, l, c, u) {
        var f = A ? A(a.getElement(), c) : null;
        if (!(f === !1 || a._destroyed)) {
          var h = void 0;
          u && (h = function() {
            a.nextFrame(u);
          }), a.setState(Cu({
            statusStyle: typeof f == "object" ? f : null,
            newStatus: !1
          }, l), h);
        }
      }, a.updateActiveStatus = function(A, l) {
        a.nextFrame(function() {
          var c = a.state.status;
          if (c === l) {
            var u = a.props.motionDeadline;
            a.updateStatus(A, { statusActive: !0 }), u > 0 && setTimeout(function() {
              a.onMotionEnd({
                deadline: !0
              });
            }, u);
          }
        });
      }, a.nextFrame = function(A) {
        a.cancelNextFrame(), a.raf = pBe(A);
      }, a.cancelNextFrame = function() {
        a.raf && (pBe.cancel(a.raf), a.raf = null);
      }, a.state = {
        status: _m,
        statusActive: !1,
        newStatus: !1,
        statusStyle: null
      }, a.$cacheEle = null, a.node = null, a.raf = null, a;
    }
    return pAe(s, [{
      key: "componentDidMount",
      value: function() {
        this.onDomUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        this.onDomUpdate();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this._destroyed = !0, this.removeEventListener(this.$cacheEle), this.cancelNextFrame();
      }
    }, {
      key: "render",
      value: function() {
        var A, l = this.state, c = l.status, u = l.statusActive, f = l.statusStyle, h = this.props, d = h.children, I = h.motionName, m = h.visible, C = h.removeOnLeave, y = h.leavedClassName, v = h.eventProps;
        return d ? c === _m || !r(this.props) ? m ? d(Cu({}, v), this.setNodeRef) : C ? null : d(Cu({}, v, { className: y }), this.setNodeRef) : d(Cu({}, v, {
          className: Gl((A = {}, Iu(A, mBe(I, c), c !== _m), Iu(A, mBe(I, c + "-active"), c !== _m && u), Iu(A, I, typeof I == "string"), A)),
          style: f
        }), this.setNodeRef) : null;
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(A, l) {
        var c = l.prevProps, u = l.status;
        if (!r(A))
          return {};
        var f = A.visible, h = A.motionAppear, d = A.motionEnter, I = A.motionLeave, m = A.motionLeaveImmediately, C = {
          prevProps: A
        };
        return (u === Xx && !h || u === Zx && !d || u === e2 && !I) && (C.status = _m, C.statusActive = !1, C.newStatus = !1), !c && f && h && (C.status = Xx, C.statusActive = !1, C.newStatus = !0), c && !c.visible && f && d && (C.status = Zx, C.statusActive = !1, C.newStatus = !0), (c && c.visible && !f && I || !c && m && !f && I) && (C.status = e2, C.statusActive = !1, C.newStatus = !0), C;
      }
    }]), s;
  }(St.Component);
  return i.propTypes = Cu({}, _6t, {
    internalRef: ut.oneOfType([ut.object, ut.func])
  }), i.defaultProps = {
    visible: !0,
    motionEnter: !0,
    motionAppear: !0,
    motionLeave: !0,
    removeOnLeave: !0
  }, L9(i), n ? St.forwardRef(function(o, s) {
    return St.createElement(i, Cu({ internalRef: s }, o));
  }) : i;
}
const Q6t = S6t(b6t);
var CBe = "open", EBe = "close", w6t = "---", JI = function(t) {
  DAe(e, t);
  function e(n) {
    dAe(this, e);
    var r = xAe(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, n));
    return x6t.call(r), r.state = {
      dragNodeHighlight: !1
    }, r;
  }
  return pAe(e, [{
    key: "getChildContext",
    value: function() {
      return Cu({}, this.context, {
        rcTreeNode: {
          // onUpCheckConduct: this.onUpCheckConduct,
        }
      });
    }
    // Isomorphic needn't load data in server side
  }, {
    key: "componentDidMount",
    value: function() {
      var r = this.props.eventKey, i = this.context.rcTree.registerTreeNode;
      this.syncLoadData(this.props), i(r, this);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.syncLoadData(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      var r = this.props.eventKey, i = this.context.rcTree.registerTreeNode;
      i(r, null);
    }
    // Disabled item still can be switch
    // Drag usage
  }, {
    key: "isSelectable",
    value: function() {
      var r = this.props.selectable, i = this.context.rcTree.selectable;
      return typeof r == "boolean" ? r : i;
    }
    // Load data to avoid default expanded tree without data
    // Switcher
    // Checkbox
    // Icon + Title
    // Children list wrapped with `Animation`
  }, {
    key: "render",
    value: function() {
      var r, i = this.props.loading, o = this.props, s = o.className, a = o.style, A = o.dragOver, l = o.dragOverGapTop, c = o.dragOverGapBottom, u = o.isLeaf, f = o.expanded, h = o.selected, d = o.checked, I = o.halfChecked, m = g6e(o, ["className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "expanded", "selected", "checked", "halfChecked"]), C = this.context.rcTree, y = C.prefixCls, v = C.filterTreeNode, b = C.draggable, Q = this.isDisabled(), w = TAe(m);
      return St.createElement(
        "li",
        Cu({
          className: Gl(s, (r = {}, Iu(r, y + "-treenode-disabled", Q), Iu(r, y + "-treenode-switcher-" + (f ? "open" : "close"), !u), Iu(r, y + "-treenode-checkbox-checked", d), Iu(r, y + "-treenode-checkbox-indeterminate", I), Iu(r, y + "-treenode-selected", h), Iu(r, y + "-treenode-loading", i), Iu(r, "drag-over", !Q && A), Iu(r, "drag-over-gap-top", !Q && l), Iu(r, "drag-over-gap-bottom", !Q && c), Iu(r, "filter-node", v && v(this)), r)),
          style: a,
          role: "treeitem",
          onDragEnter: b ? this.onDragEnter : void 0,
          onDragOver: b ? this.onDragOver : void 0,
          onDragLeave: b ? this.onDragLeave : void 0,
          onDrop: b ? this.onDrop : void 0,
          onDragEnd: b ? this.onDragEnd : void 0
        }, w),
        this.renderSwitcher(),
        this.renderCheckbox(),
        this.renderSelector(),
        this.renderChildren()
      );
    }
  }]), e;
}(St.Component);
JI.propTypes = {
  eventKey: ut.string,
  // Pass by parent `cloneElement`
  prefixCls: ut.string,
  className: ut.string,
  style: ut.object,
  root: ut.object,
  onSelect: ut.func,
  // By parent
  expanded: ut.bool,
  selected: ut.bool,
  checked: ut.bool,
  loaded: ut.bool,
  loading: ut.bool,
  halfChecked: ut.bool,
  children: ut.node,
  title: ut.node,
  pos: ut.string,
  dragOver: ut.bool,
  dragOverGapTop: ut.bool,
  dragOverGapBottom: ut.bool,
  // By user
  isLeaf: ut.bool,
  checkable: ut.bool,
  selectable: ut.bool,
  disabled: ut.bool,
  disableCheckbox: ut.bool,
  icon: ut.oneOfType([ut.node, ut.func]),
  switcherIcon: ut.oneOfType([ut.node, ut.func])
};
JI.contextTypes = f6e;
JI.childContextTypes = f6e;
JI.defaultProps = {
  title: w6t
};
var x6t = function() {
  var e = this;
  this.onSelectorClick = function(n) {
    var r = e.context.rcTree.onNodeClick;
    r(n, e), e.isSelectable() ? e.onSelect(n) : e.onCheck(n);
  }, this.onSelectorDoubleClick = function(n) {
    var r = e.context.rcTree.onNodeDoubleClick;
    r(n, e);
  }, this.onSelect = function(n) {
    if (!e.isDisabled()) {
      var r = e.context.rcTree.onNodeSelect;
      n.preventDefault(), r(n, e);
    }
  }, this.onCheck = function(n) {
    if (!e.isDisabled()) {
      var r = e.props, i = r.disableCheckbox, o = r.checked, s = e.context.rcTree.onNodeCheck;
      if (!(!e.isCheckable() || i)) {
        n.preventDefault();
        var a = !o;
        s(n, e, a);
      }
    }
  }, this.onMouseEnter = function(n) {
    var r = e.context.rcTree.onNodeMouseEnter;
    r(n, e);
  }, this.onMouseLeave = function(n) {
    var r = e.context.rcTree.onNodeMouseLeave;
    r(n, e);
  }, this.onContextMenu = function(n) {
    var r = e.context.rcTree.onNodeContextMenu;
    r(n, e);
  }, this.onDragStart = function(n) {
    var r = e.context.rcTree.onNodeDragStart;
    n.stopPropagation(), e.setState({
      dragNodeHighlight: !0
    }), r(n, e);
    try {
      n.dataTransfer.setData("text/plain", "");
    } catch {
    }
  }, this.onDragEnter = function(n) {
    var r = e.context.rcTree.onNodeDragEnter;
    n.preventDefault(), n.stopPropagation(), r(n, e);
  }, this.onDragOver = function(n) {
    var r = e.context.rcTree.onNodeDragOver;
    n.preventDefault(), n.stopPropagation(), r(n, e);
  }, this.onDragLeave = function(n) {
    var r = e.context.rcTree.onNodeDragLeave;
    n.stopPropagation(), r(n, e);
  }, this.onDragEnd = function(n) {
    var r = e.context.rcTree.onNodeDragEnd;
    n.stopPropagation(), e.setState({
      dragNodeHighlight: !1
    }), r(n, e);
  }, this.onDrop = function(n) {
    var r = e.context.rcTree.onNodeDrop;
    n.preventDefault(), n.stopPropagation(), e.setState({
      dragNodeHighlight: !1
    }), r(n, e);
  }, this.onExpand = function(n) {
    var r = e.context.rcTree.onNodeExpand;
    r(n, e);
  }, this.setSelectHandle = function(n) {
    e.selectHandle = n;
  }, this.getNodeChildren = function() {
    var n = e.props.children, r = LS(n).filter(function(o) {
      return o;
    }), i = C6e(r);
    return r.length !== i.length && I6e(), i;
  }, this.getNodeState = function() {
    var n = e.props.expanded;
    return e.isLeaf() ? null : n ? CBe : EBe;
  }, this.isLeaf = function() {
    var n = e.props, r = n.isLeaf, i = n.loaded, o = e.context.rcTree.loadData, s = e.getNodeChildren().length !== 0;
    return r === !1 ? !1 : r || !o && !s || o && i && !s;
  }, this.isDisabled = function() {
    var n = e.props.disabled, r = e.context.rcTree.disabled;
    return n === !1 ? !1 : !!(r || n);
  }, this.isCheckable = function() {
    var n = e.props.checkable, r = e.context.rcTree.checkable;
    return !r || n === !1 ? !1 : r;
  }, this.syncLoadData = function(n) {
    var r = n.expanded, i = n.loading, o = n.loaded, s = e.context.rcTree, a = s.loadData, A = s.onNodeLoad;
    if (!i && a && r && !e.isLeaf()) {
      var l = e.getNodeChildren().length !== 0;
      !l && !o && A(e);
    }
  }, this.renderSwitcher = function() {
    var n = e.props, r = n.expanded, i = n.switcherIcon, o = e.context.rcTree, s = o.prefixCls, a = o.switcherIcon, A = i || a;
    if (e.isLeaf())
      return St.createElement(
        "span",
        { className: Gl(s + "-switcher", s + "-switcher-noop") },
        typeof A == "function" ? A(Cu({}, e.props, { isLeaf: !0 })) : A
      );
    var l = Gl(s + "-switcher", s + "-switcher_" + (r ? CBe : EBe));
    return St.createElement(
      "span",
      { onClick: e.onExpand, className: l },
      typeof A == "function" ? A(Cu({}, e.props, { isLeaf: !1 })) : A
    );
  }, this.renderCheckbox = function() {
    var n = e.props, r = n.checked, i = n.halfChecked, o = n.disableCheckbox, s = e.context.rcTree.prefixCls, a = e.isDisabled(), A = e.isCheckable();
    if (!A)
      return null;
    var l = typeof A != "boolean" ? A : null;
    return St.createElement(
      "span",
      {
        className: Gl(s + "-checkbox", r && s + "-checkbox-checked", !r && i && s + "-checkbox-indeterminate", (a || o) && s + "-checkbox-disabled"),
        onClick: e.onCheck
      },
      l
    );
  }, this.renderIcon = function() {
    var n = e.props.loading, r = e.context.rcTree.prefixCls;
    return St.createElement("span", {
      className: Gl(r + "-iconEle", r + "-icon__" + (e.getNodeState() || "docu"), n && r + "-icon_loading")
    });
  }, this.renderSelector = function() {
    var n = e.state.dragNodeHighlight, r = e.props, i = r.title, o = r.selected, s = r.icon, a = r.loading, A = e.context.rcTree, l = A.prefixCls, c = A.showIcon, u = A.icon, f = A.draggable, h = A.loadData, d = e.isDisabled(), I = l + "-node-content-wrapper", m = void 0;
    if (c) {
      var C = s || u;
      m = C ? St.createElement(
        "span",
        {
          className: Gl(l + "-iconEle", l + "-icon__customize")
        },
        typeof C == "function" ? St.createElement(C, Cu({}, e.props)) : C
      ) : e.renderIcon();
    } else
      h && a && (m = e.renderIcon());
    var y = St.createElement(
      "span",
      { className: l + "-title" },
      i
    );
    return St.createElement(
      "span",
      {
        ref: e.setSelectHandle,
        title: typeof i == "string" ? i : "",
        className: Gl("" + I, I + "-" + (e.getNodeState() || "normal"), !d && (o || n) && l + "-node-selected", !d && f && "draggable"),
        draggable: !d && f || void 0,
        "aria-grabbed": !d && f || void 0,
        onMouseEnter: e.onMouseEnter,
        onMouseLeave: e.onMouseLeave,
        onContextMenu: e.onContextMenu,
        onClick: e.onSelectorClick,
        onDoubleClick: e.onSelectorDoubleClick,
        onDragStart: f ? e.onDragStart : void 0
      },
      m,
      y
    );
  }, this.renderChildren = function() {
    var n = e.props, r = n.expanded, i = n.pos, o = e.context.rcTree, s = o.prefixCls, a = o.motion, A = o.renderTreeNode, l = e.getNodeChildren();
    return l.length === 0 ? null : St.createElement(
      Q6t,
      Cu({ visible: r }, a),
      function(c) {
        var u = c.style, f = c.className;
        return St.createElement(
          "ul",
          {
            className: Gl(f, s + "-child-tree", r && s + "-child-tree-open"),
            style: u,
            "data-expanded": r,
            role: "group"
          },
          y6e(l, function(h, d) {
            return A(h, d, i);
          })
        );
      }
    );
  };
};
JI.isTreeNode = 1;
L9(JI);
var R6t = 0.25, D6t = 2, yBe = !1;
function I6e() {
  yBe || (yBe = !0, xT(!1, "Tree only accept TreeNode as children."));
}
function eb(t, e) {
  var n = t.slice(), r = n.indexOf(e);
  return r >= 0 && n.splice(r, 1), n;
}
function tb(t, e) {
  var n = t.slice();
  return n.indexOf(e) === -1 && n.push(e), n;
}
function T6t(t) {
  return t.split("-");
}
function m6e(t, e) {
  return t + "-" + e;
}
function N6t(t) {
  return t && t.type && t.type.isTreeNode;
}
function C6e(t) {
  return LS(t).filter(N6t);
}
function Yb(t) {
  var e = t.props || {}, n = e.disabled, r = e.disableCheckbox;
  return !!(n || r);
}
function E6e(t, e) {
  function n(r, i, o) {
    var s = r ? r.props.children : t, a = r ? m6e(o.pos, i) : 0, A = C6e(s);
    if (r) {
      var l = {
        node: r,
        index: i,
        pos: a,
        key: r.key || a,
        parentPos: o.node ? o.pos : null
      };
      e(l);
    }
    D3e.forEach(A, function(c, u) {
      n(c, u, { node: r, pos: a });
    });
  }
  n(null);
}
function y6e(t, e) {
  var n = LS(t).map(e);
  return n.length === 1 ? n[0] : n;
}
function L6t(t, e) {
  var n = e.props, r = n.eventKey, i = n.pos, o = [];
  return E6e(t, function(s) {
    var a = s.key;
    o.push(a);
  }), o.push(r || i), o;
}
function vBe(t, e) {
  var n = t.clientY, r = e.selectHandle.getBoundingClientRect(), i = r.top, o = r.bottom, s = r.height, a = Math.max(s * R6t, D6t);
  return n <= i + a ? -1 : n >= o - a ? 1 : 0;
}
function BBe(t, e) {
  if (t) {
    var n = e.multiple;
    return n ? t.slice() : t.length ? [t[0]] : t;
  }
}
function bBe(t) {
  return t && t.map(function(e) {
    return String(e);
  });
}
var M6t = function(e) {
  return e;
};
function v6e(t, e) {
  if (!t)
    return [];
  var n = e || {}, r = n.processProps, i = r === void 0 ? M6t : r, o = Array.isArray(t) ? t : [t];
  return o.map(function(s) {
    var a = s.children, A = g6e(s, ["children"]), l = v6e(a, e);
    return St.createElement(
      JI,
      i(A),
      l
    );
  });
}
function O6t(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.initWrapper, r = e.processEntity, i = e.onProcessFinished, o = {}, s = {}, a = {
    posEntities: o,
    keyEntities: s
  };
  return n && (a = n(a) || a), E6e(t, function(A) {
    var l = A.node, c = A.index, u = A.pos, f = A.key, h = A.parentPos, d = { node: l, index: c, key: f, pos: u };
    o[u] = d, s[f] = d, d.parent = o[h], d.parent && (d.parent.children = d.parent.children || [], d.parent.children.push(d)), r && r(d, a);
  }), i && i(a), a;
}
function N7(t) {
  if (!t)
    return null;
  var e = void 0;
  if (Array.isArray(t))
    e = {
      checkedKeys: t,
      halfCheckedKeys: void 0
    };
  else if (typeof t == "object")
    e = {
      checkedKeys: t.checked || void 0,
      halfCheckedKeys: t.halfChecked || void 0
    };
  else
    return xT(!1, "`checkedKeys` is not an array or an object"), null;
  return e.checkedKeys = bBe(e.checkedKeys), e.halfCheckedKeys = bBe(e.halfCheckedKeys), e;
}
function _Be(t, e, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = {}, o = {};
  (r.checkedKeys || []).forEach(function(u) {
    i[u] = !0;
  }), (r.halfCheckedKeys || []).forEach(function(u) {
    o[u] = !0;
  });
  function s(u) {
    if (i[u] !== e) {
      var f = n[u];
      if (f) {
        var h = f.children, d = f.parent, I = f.node;
        if (!Yb(I)) {
          var m = !0, C = !1;
          (h || []).filter(function(y) {
            return !Yb(y.node);
          }).forEach(function(y) {
            var v = y.key, b = i[v], Q = o[v];
            (b || Q) && (C = !0), b || (m = !1);
          }), e ? i[u] = m : i[u] = !1, o[u] = C, d && s(d.key);
        }
      }
    }
  }
  function a(u) {
    if (i[u] !== e) {
      var f = n[u];
      if (f) {
        var h = f.children, d = f.node;
        Yb(d) || (i[u] = e, (h || []).forEach(function(I) {
          a(I.key);
        }));
      }
    }
  }
  function A(u) {
    var f = n[u];
    if (!f) {
      xT(!1, "'" + u + "' does not exist in the tree.");
      return;
    }
    var h = f.children, d = f.parent, I = f.node;
    i[u] = e, !Yb(I) && ((h || []).filter(function(m) {
      return !Yb(m.node);
    }).forEach(function(m) {
      a(m.key);
    }), d && s(d.key));
  }
  (t || []).forEach(function(u) {
    A(u);
  });
  var l = [], c = [];
  return Object.keys(i).forEach(function(u) {
    i[u] && l.push(u);
  }), Object.keys(o).forEach(function(u) {
    !i[u] && o[u] && c.push(u);
  }), {
    checkedKeys: l,
    halfCheckedKeys: c
  };
}
function SBe(t, e) {
  var n = {};
  function r(i) {
    if (!n[i]) {
      var o = e[i];
      if (o) {
        n[i] = !0;
        var s = o.parent, a = o.node;
        Yb(a) || s && r(s.key);
      }
    }
  }
  return (t || []).forEach(function(i) {
    r(i);
  }), Object.keys(n);
}
function TAe(t) {
  return Object.keys(t).reduce(function(e, n) {
    return (n.substr(0, 5) === "data-" || n.substr(0, 5) === "aria-") && (e[n] = t[n]), e;
  }, {});
}
var vw = function(t) {
  DAe(e, t);
  function e(n) {
    dAe(this, e);
    var r = xAe(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, n));
    return r.onNodeDragStart = function(i, o) {
      var s = r.state.expandedKeys, a = r.props.onDragStart, A = o.props, l = A.eventKey, c = A.children;
      r.dragNode = o, r.setState({
        dragNodesKeys: L6t(c, o),
        expandedKeys: eb(s, l)
      }), a && a({ event: i, node: o });
    }, r.onNodeDragEnter = function(i, o) {
      var s = r.state.expandedKeys, a = r.props.onDragEnter, A = o.props, l = A.pos, c = A.eventKey;
      if (r.dragNode) {
        var u = vBe(i, o);
        if (r.dragNode.props.eventKey === c && u === 0) {
          r.setState({
            dragOverNodeKey: "",
            dropPosition: null
          });
          return;
        }
        setTimeout(function() {
          r.setState({
            dragOverNodeKey: c,
            dropPosition: u
          }), r.delayedDragEnterLogic || (r.delayedDragEnterLogic = {}), Object.keys(r.delayedDragEnterLogic).forEach(function(f) {
            clearTimeout(r.delayedDragEnterLogic[f]);
          }), r.delayedDragEnterLogic[l] = setTimeout(function() {
            var f = tb(s, c);
            "expandedKeys" in r.props || r.setState({
              expandedKeys: f
            }), a && a({ event: i, node: o, expandedKeys: f });
          }, 400);
        }, 0);
      }
    }, r.onNodeDragOver = function(i, o) {
      var s = r.props.onDragOver, a = o.props.eventKey;
      if (r.dragNode && a === r.state.dragOverNodeKey) {
        var A = vBe(i, o);
        if (A === r.state.dropPosition)
          return;
        r.setState({
          dropPosition: A
        });
      }
      s && s({ event: i, node: o });
    }, r.onNodeDragLeave = function(i, o) {
      var s = r.props.onDragLeave;
      r.setState({
        dragOverNodeKey: ""
      }), s && s({ event: i, node: o });
    }, r.onNodeDragEnd = function(i, o) {
      var s = r.props.onDragEnd;
      r.setState({
        dragOverNodeKey: ""
      }), s && s({ event: i, node: o }), r.dragNode = null;
    }, r.onNodeDrop = function(i, o) {
      var s = r.state, a = s.dragNodesKeys, A = a === void 0 ? [] : a, l = s.dropPosition, c = r.props.onDrop, u = o.props, f = u.eventKey, h = u.pos;
      if (r.setState({
        dragOverNodeKey: ""
      }), A.indexOf(f) !== -1) {
        xT(!1, "Can not drop to dragNode(include it's children node)");
        return;
      }
      var d = T6t(h), I = {
        event: i,
        node: o,
        dragNode: r.dragNode,
        dragNodesKeys: A.slice(),
        dropPosition: l + Number(d[d.length - 1])
      };
      l !== 0 && (I.dropToGap = !0), c && c(I), r.dragNode = null;
    }, r.onNodeClick = function(i, o) {
      var s = r.props.onClick;
      s && s(i, o);
    }, r.onNodeDoubleClick = function(i, o) {
      var s = r.props.onDoubleClick;
      s && s(i, o);
    }, r.onNodeSelect = function(i, o) {
      var s = r.state.selectedKeys, a = r.state.keyEntities, A = r.props, l = A.onSelect, c = A.multiple, u = o.props, f = u.selected, h = u.eventKey, d = !f;
      d ? c ? s = tb(s, h) : s = [h] : s = eb(s, h);
      var I = s.map(function(C) {
        var y = a[C];
        return y ? y.node : null;
      }).filter(function(C) {
        return C;
      });
      if (r.setUncontrolledState({ selectedKeys: s }), l) {
        var m = {
          event: "select",
          selected: d,
          node: o,
          selectedNodes: I,
          nativeEvent: i.nativeEvent
        };
        l(s, m);
      }
    }, r.onNodeCheck = function(i, o, s) {
      var a = r.state, A = a.keyEntities, l = a.checkedKeys, c = a.halfCheckedKeys, u = r.props, f = u.checkStrictly, h = u.onCheck, d = o.props.eventKey, I = void 0, m = {
        event: "check",
        node: o,
        checked: s,
        nativeEvent: i.nativeEvent
      };
      if (f) {
        var C = s ? tb(l, d) : eb(l, d), y = eb(c, d);
        I = { checked: C, halfChecked: y }, m.checkedNodes = C.map(function(w) {
          return A[w];
        }).filter(function(w) {
          return w;
        }).map(function(w) {
          return w.node;
        }), r.setUncontrolledState({ checkedKeys: C });
      } else {
        var v = _Be([d], s, A, {
          checkedKeys: l,
          halfCheckedKeys: c
        }), b = v.checkedKeys, Q = v.halfCheckedKeys;
        I = b, m.checkedNodes = [], m.checkedNodesPositions = [], m.halfCheckedKeys = Q, b.forEach(function(w) {
          var R = A[w];
          if (R) {
            var M = R.node, O = R.pos;
            m.checkedNodes.push(M), m.checkedNodesPositions.push({ node: M, pos: O });
          }
        }), r.setUncontrolledState({
          checkedKeys: b,
          halfCheckedKeys: Q
        });
      }
      h && h(I, m);
    }, r.onNodeLoad = function(i) {
      return new Promise(function(o) {
        r.setState(function(s) {
          var a = s.loadedKeys, A = a === void 0 ? [] : a, l = s.loadingKeys, c = l === void 0 ? [] : l, u = r.props, f = u.loadData, h = u.onLoad, d = i.props.eventKey;
          if (!f || A.indexOf(d) !== -1 || c.indexOf(d) !== -1)
            return {};
          var I = f(i);
          return I.then(function() {
            var m = tb(r.state.loadedKeys, d), C = eb(r.state.loadingKeys, d);
            if (h) {
              var y = {
                event: "load",
                node: i
              };
              h(m, y);
            }
            r.setUncontrolledState({
              loadedKeys: m
            }), r.setState({
              loadingKeys: C
            }), o();
          }), {
            loadingKeys: tb(c, d)
          };
        });
      });
    }, r.onNodeExpand = function(i, o) {
      var s = r.state.expandedKeys, a = r.props, A = a.onExpand, l = a.loadData, c = o.props, u = c.eventKey, f = c.expanded, h = s.indexOf(u), d = !f;
      if (xT(f && h !== -1 || !f && h === -1, "Expand state not sync with index check"), d ? s = tb(s, u) : s = eb(s, u), r.setUncontrolledState({ expandedKeys: s }), A && A(s, {
        node: o,
        expanded: d,
        nativeEvent: i.nativeEvent
      }), d && l) {
        var I = r.onNodeLoad(o);
        return I ? I.then(function() {
          r.setUncontrolledState({ expandedKeys: s });
        }) : null;
      }
      return null;
    }, r.onNodeMouseEnter = function(i, o) {
      var s = r.props.onMouseEnter;
      s && s({ event: i, node: o });
    }, r.onNodeMouseLeave = function(i, o) {
      var s = r.props.onMouseLeave;
      s && s({ event: i, node: o });
    }, r.onNodeContextMenu = function(i, o) {
      var s = r.props.onRightClick;
      s && (i.preventDefault(), s({ event: i, node: o }));
    }, r.setUncontrolledState = function(i) {
      var o = !1, s = {};
      Object.keys(i).forEach(function(a) {
        a in r.props || (o = !0, s[a] = i[a]);
      }), o && r.setState(s);
    }, r.registerTreeNode = function(i, o) {
      o ? r.domTreeNodes[i] = o : delete r.domTreeNodes[i];
    }, r.isKeyChecked = function(i) {
      var o = r.state.checkedKeys, s = o === void 0 ? [] : o;
      return s.indexOf(i) !== -1;
    }, r.renderTreeNode = function(i, o) {
      var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = r.state, A = a.keyEntities, l = a.expandedKeys, c = l === void 0 ? [] : l, u = a.selectedKeys, f = u === void 0 ? [] : u, h = a.halfCheckedKeys, d = h === void 0 ? [] : h, I = a.loadedKeys, m = I === void 0 ? [] : I, C = a.loadingKeys, y = C === void 0 ? [] : C, v = a.dragOverNodeKey, b = a.dropPosition, Q = m6e(s, o), w = i.key || Q;
      return A[w] ? St.cloneElement(i, {
        key: w,
        eventKey: w,
        expanded: c.indexOf(w) !== -1,
        selected: f.indexOf(w) !== -1,
        loaded: m.indexOf(w) !== -1,
        loading: y.indexOf(w) !== -1,
        checked: r.isKeyChecked(w),
        halfChecked: d.indexOf(w) !== -1,
        pos: Q,
        // [Legacy] Drag props
        dragOver: v === w && b === 0,
        dragOverGapTop: v === w && b === -1,
        dragOverGapBottom: v === w && b === 1
      }) : (I6e(), null);
    }, r.state = {
      // TODO: Remove this eslint
      posEntities: {},
      // eslint-disable-line react/no-unused-state
      keyEntities: {},
      selectedKeys: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      loadedKeys: [],
      loadingKeys: [],
      treeNode: []
    }, r.domTreeNodes = {}, r;
  }
  return pAe(e, [{
    key: "getChildContext",
    value: function() {
      var r = this.props, i = r.prefixCls, o = r.selectable, s = r.showIcon, a = r.icon, A = r.draggable, l = r.checkable, c = r.checkStrictly, u = r.disabled, f = r.loadData, h = r.filterTreeNode, d = r.motion, I = r.switcherIcon;
      return {
        rcTree: {
          // root: this,
          prefixCls: i,
          selectable: o,
          showIcon: s,
          icon: a,
          switcherIcon: I,
          draggable: A,
          checkable: l,
          checkStrictly: c,
          disabled: u,
          motion: d,
          loadData: f,
          filterTreeNode: h,
          renderTreeNode: this.renderTreeNode,
          isKeyChecked: this.isKeyChecked,
          onNodeClick: this.onNodeClick,
          onNodeDoubleClick: this.onNodeDoubleClick,
          onNodeExpand: this.onNodeExpand,
          onNodeSelect: this.onNodeSelect,
          onNodeCheck: this.onNodeCheck,
          onNodeLoad: this.onNodeLoad,
          onNodeMouseEnter: this.onNodeMouseEnter,
          onNodeMouseLeave: this.onNodeMouseLeave,
          onNodeContextMenu: this.onNodeContextMenu,
          onNodeDragStart: this.onNodeDragStart,
          onNodeDragEnter: this.onNodeDragEnter,
          onNodeDragOver: this.onNodeDragOver,
          onNodeDragLeave: this.onNodeDragLeave,
          onNodeDragEnd: this.onNodeDragEnd,
          onNodeDrop: this.onNodeDrop,
          registerTreeNode: this.registerTreeNode
        }
      };
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.state.treeNode, o = this.props, s = o.prefixCls, a = o.className, A = o.focusable, l = o.style, c = o.showLine, u = o.tabIndex, f = u === void 0 ? 0 : u, h = TAe(this.props);
      return A && (h.tabIndex = f, h.onKeyDown = this.onKeyDown), St.createElement(
        "ul",
        Cu({}, h, {
          className: Gl(s, a, Iu({}, s + "-show-line", c)),
          style: l,
          role: "tree",
          unselectable: "on"
        }),
        y6e(i, function(d, I) {
          return r.renderTreeNode(d, I);
        })
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      var o = i.prevProps, s = {
        prevProps: r
      };
      function a(y) {
        return !o && y in r || o && o[y] !== r[y];
      }
      var A = null;
      if (a("treeData") ? A = v6e(r.treeData) : a("children") && (A = LS(r.children)), A) {
        s.treeNode = A;
        var l = O6t(A);
        s.posEntities = l.posEntities, s.keyEntities = l.keyEntities;
      }
      var c = s.keyEntities || i.keyEntities;
      if (a("expandedKeys") || o && a("autoExpandParent") ? s.expandedKeys = r.autoExpandParent || !o && r.defaultExpandParent ? SBe(r.expandedKeys, c) : r.expandedKeys : !o && r.defaultExpandAll ? s.expandedKeys = Object.keys(c) : !o && r.defaultExpandedKeys && (s.expandedKeys = r.autoExpandParent || r.defaultExpandParent ? SBe(r.defaultExpandedKeys, c) : r.defaultExpandedKeys), r.selectable && (a("selectedKeys") ? s.selectedKeys = BBe(r.selectedKeys, r) : !o && r.defaultSelectedKeys && (s.selectedKeys = BBe(r.defaultSelectedKeys, r))), r.checkable) {
        var u = void 0;
        if (a("checkedKeys") ? u = N7(r.checkedKeys) || {} : !o && r.defaultCheckedKeys ? u = N7(r.defaultCheckedKeys) || {} : A && (u = N7(r.checkedKeys) || {
          checkedKeys: i.checkedKeys,
          halfCheckedKeys: i.halfCheckedKeys
        }), u) {
          var f = u, h = f.checkedKeys, d = h === void 0 ? [] : h, I = f.halfCheckedKeys, m = I === void 0 ? [] : I;
          if (!r.checkStrictly) {
            var C = _Be(d, !0, c);
            d = C.checkedKeys, m = C.halfCheckedKeys;
          }
          s.checkedKeys = d, s.halfCheckedKeys = m;
        }
      }
      return a("loadedKeys") && (s.loadedKeys = r.loadedKeys), s;
    }
    /**
     * [Legacy] Select handler is less small than node,
     * so that this will trigger when drag enter node or select handler.
     * This is a little tricky if customize css without padding.
     * Better for use mouse move event to refresh drag state.
     * But let's just keep it to avoid event trigger logic change.
     */
    /**
     * Only update the value which is not in props
     */
    /**
     * [Legacy] Original logic use `key` as tracking clue.
     * We have to use `cloneElement` to pass `key`.
     */
  }]), e;
}(St.Component);
vw.propTypes = {
  prefixCls: ut.string,
  className: ut.string,
  style: ut.object,
  tabIndex: ut.oneOfType([ut.string, ut.number]),
  children: ut.any,
  treeData: ut.array,
  // Generate treeNode by children
  showLine: ut.bool,
  showIcon: ut.bool,
  icon: ut.oneOfType([ut.node, ut.func]),
  focusable: ut.bool,
  selectable: ut.bool,
  disabled: ut.bool,
  multiple: ut.bool,
  checkable: ut.oneOfType([ut.bool, ut.node]),
  checkStrictly: ut.bool,
  draggable: ut.bool,
  defaultExpandParent: ut.bool,
  autoExpandParent: ut.bool,
  defaultExpandAll: ut.bool,
  defaultExpandedKeys: ut.arrayOf(ut.string),
  expandedKeys: ut.arrayOf(ut.string),
  defaultCheckedKeys: ut.arrayOf(ut.string),
  checkedKeys: ut.oneOfType([ut.arrayOf(ut.oneOfType([ut.string, ut.number])), ut.object]),
  defaultSelectedKeys: ut.arrayOf(ut.string),
  selectedKeys: ut.arrayOf(ut.string),
  onClick: ut.func,
  onDoubleClick: ut.func,
  onExpand: ut.func,
  onCheck: ut.func,
  onSelect: ut.func,
  onLoad: ut.func,
  loadData: ut.func,
  loadedKeys: ut.arrayOf(ut.string),
  onMouseEnter: ut.func,
  onMouseLeave: ut.func,
  onRightClick: ut.func,
  onDragStart: ut.func,
  onDragEnter: ut.func,
  onDragOver: ut.func,
  onDragLeave: ut.func,
  onDragEnd: ut.func,
  onDrop: ut.func,
  filterTreeNode: ut.func,
  motion: ut.object,
  switcherIcon: ut.oneOfType([ut.node, ut.func])
};
vw.childContextTypes = u6e;
vw.defaultProps = {
  prefixCls: "rc-tree",
  showLine: !1,
  showIcon: !0,
  selectable: !0,
  multiple: !1,
  checkable: !1,
  disabled: !1,
  checkStrictly: !1,
  draggable: !1,
  defaultExpandParent: !0,
  autoExpandParent: !1,
  defaultExpandAll: !1,
  defaultExpandedKeys: [],
  defaultCheckedKeys: [],
  defaultSelectedKeys: []
};
L9(vw);
vw.TreeNode = JI;
const aU = St.forwardRef((t, e) => {
  const { prefixCls: n, className: r, showIcon: i, blockNode: o, children: s, checkable: a } = t;
  return s?.length > 0 ? ne.jsx(vw, { itemHeight: 32, ref: e, ...t, className: Xt(r, {
    [`${n}-icon-hide`]: !i,
    [`${n}-block-node`]: o
  }), checkable: a && ne.jsx("span", { className: `${n}-checkbox-inner` }), checkStrictly: !1, children: s }) : null;
});
aU.displayName = "Tree";
aU.defaultProps = {
  virtual: !1,
  checkable: !1,
  showIcon: !1,
  blockNode: !0,
  prefixCls: "rc-tree"
};
const F6t = (t) => /* @__PURE__ */ le.createElement("svg", { viewBox: "0 0 16.433999 10.234", height: 12, width: 18, role: "img", ...t }, /* @__PURE__ */ le.createElement("g", { transform: "translate(0.117,-2.883)" }, /* @__PURE__ */ le.createElement("path", { d: "m 11.467471,11.811278 c 0.198237,-0.322177 0.508,-1.011333 0.653661,-1.454255 0.659343,-2.0049141 0.44323,-4.2620847 -0.577734,-6.0340822 l -0.168844,-0.2930481 0.105744,0.017887 c 0.759902,0.1285441 1.368762,0.3699553 1.856675,0.7361658 1.988296,1.4923476 2.192477,4.3353549 0.434717,6.0529895 -0.641216,0.626581 -1.299647,0.94683 -2.294136,1.115833 l -0.108488,0.01844 z M 4.3162122,11.919169 C 1.9278944,11.487872 0.46692382,9.0323123 1.234873,6.7401372 1.5621727,5.763213 2.2610593,4.9489746 3.1840041,4.4693005 3.5978035,4.2542401 3.9427842,4.145371 4.5197023,4.0477802 L 4.6254464,4.0298927 4.4571836,4.3223069 C 3.4332707,6.1017061 3.2180432,8.3476022 3.878868,10.357023 c 0.1458466,0.443487 0.4554716,1.132155 0.6542959,1.455285 0.054471,0.08853 0.087814,0.159599 0.074096,0.157937 -0.013718,-0.0017 -0.1446898,-0.02465 -0.2910477,-0.05108 z M 5.0000001,3 C 2.2,3 0,5.2 0,8 c 0,2.8 2.2,5 5.0000001,5 0.6,0 1.1,-0.1 1.6,-0.3 C 5.3000001,11.6 4.5,9.7999998 4.5,8 4.5,6.2 5.3000001,4.5 6.6000001,3.3 c -0.5,-0.2 -1,-0.3 -1.6,-0.3 z M 4.65,4.02 C 3.92,5.17 3.51,6.54 3.51,8 c 0,1.4599998 0.42,2.83 1.14,3.98 C 2.61,11.8 1.01,10.08 1.01,8 1.01,5.92 2.61,4.2 4.65,4.02 Z M 8,4 C 6.8,4.9 6,6.4 6,8 6,9.6 6.8,11.1 8,12 9.2,11.1 10,9.7 10,8 10,6.3 9.2,4.9 8,4 Z m 3,-1 c 2.8,0 5,2.2 5,5 0,2.8 -2.2,5 -5,5 C 10.4,13 9.9,12.9 9.4,12.7 10.7,11.6 11.5,9.8 11.5,8 11.5,6.2 10.7,4.5 9.4,3.3 9.9,3.1 10.4,3 11,3 Z m 0.35,1.02 c 0.73,1.15 1.14,2.52 1.14,3.98 0,1.46 -0.42,2.83 -1.14,3.98 2.04,-0.18 3.64,-1.9 3.64,-3.98 0,-2.08 -1.6,-3.8 -3.64,-3.98 z", style: {
  strokeWidth: 0.234,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
} }))), P6t = (t) => /* @__PURE__ */ le.createElement("svg", { width: 18, height: 12, viewBox: "0 0 16 10", role: "img", ...t }, /* @__PURE__ */ le.createElement("g", { transform: "translate(0,-3)" }, /* @__PURE__ */ le.createElement("path", { d: "M 5.0000001,3 C 2.2,3 0,5.2 0,8 c 0,2.8 2.2,5 5.0000001,5 0.6,0 1.1,-0.1 1.6,-0.3 C 5.3000001,11.6 4.5,9.7999998 4.5,8 4.5,6.2 5.3000001,4.5 6.6000001,3.3 c -0.5,-0.2 -1,-0.3 -1.6,-0.3 z M 4.65,4.02 C 3.92,5.17 3.51,6.54 3.51,8 c 0,1.4599998 0.42,2.83 1.14,3.98 C 2.61,11.8 1.01,10.08 1.01,8 1.01,5.92 2.61,4.2 4.65,4.02 Z M 8,4 C 6.8,4.9 6,6.4 6,8 6,9.6 6.8,11.1 8,12 9.2,11.1 10,9.7 10,8 10,6.3 9.2,4.9 8,4 Z m 3,-1 c 2.8,0 5,2.2 5,5 0,2.8 -2.2,5 -5,5 C 10.4,13 9.9,12.9 9.4,12.7 10.7,11.6 11.5,9.8 11.5,8 11.5,6.2 10.7,4.5 9.4,3.3 9.9,3.1 10.4,3 11,3 Z m 0.35,1.02 c 0.73,1.15 1.14,2.52 1.14,3.98 0,1.46 -0.42,2.83 -1.14,3.98 2.04,-0.18 3.64,-1.9 3.64,-3.98 0,-2.08 -1.6,-3.8 -3.64,-3.98 z", style: {
  strokeWidth: 0.234,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
} }))), k6t = (t) => /* @__PURE__ */ le.createElement("svg", { id: "svg14", viewBox: "0 0 25.3804963846 16", height: 16, width: 25.3804963846, role: "img", ...t }, /* @__PURE__ */ le.createElement("defs", null, /* @__PURE__ */ le.createElement("mask", { id: "union-mask", x: 0, y: 0, width: 25.3804963846, height: 16 }, /* @__PURE__ */ le.createElement("rect", { x: "5%", width: "90%", height: "100%", fill: "white" }), /* @__PURE__ */ le.createElement("g", { transform: "translate(4.69,0)" }, /* @__PURE__ */ le.createElement("path", { d: "m 11.467471,11.811278 c 0.198237,-0.322177 0.508,-1.011333 0.653661,-1.454255 0.659343,-2.0049141 0.44323,-4.2620847 -0.577734,-6.0340822 l -0.168844,-0.2930481 0.105744,0.017887 c 0.759902,0.1285441 1.368762,0.3699553 1.856675,0.7361658 1.988296,1.4923476 2.192477,4.3353549 0.434717,6.0529895 -0.641216,0.626581 -1.299647,0.94683 -2.294136,1.115833 l -0.108488,0.01844 z M 4.3162122,11.919169 C 1.9278944,11.487872 0.46692382,9.0323123 1.234873,6.7401372 1.5621727,5.763213 2.2610593,4.9489746 3.1840041,4.4693005 3.5978035,4.2542401 3.9427842,4.145371 4.5197023,4.0477802 L 4.6254464,4.0298927 4.4571836,4.3223069 C 3.4332707,6.1017061 3.2180432,8.3476022 3.878868,10.357023 c 0.1458466,0.443487 0.4554716,1.132155 0.6542959,1.455285 0.054471,0.08853 0.087814,0.159599 0.074096,0.157937 -0.013718,-0.0017 -0.1446898,-0.02465 -0.2910477,-0.05108 z M 5.0000001,3 C 2.2,3 0,5.2 0,8 c 0,2.8 2.2,5 5.0000001,5 0.6,0 1.1,-0.1 1.6,-0.3 C 5.3000001,11.6 4.5,9.7999998 4.5,8 4.5,6.2 5.3000001,4.5 6.6000001,3.3 c -0.5,-0.2 -1,-0.3 -1.6,-0.3 z M 4.65,4.02 C 3.92,5.17 3.51,6.54 3.51,8 c 0,1.4599998 0.42,2.83 1.14,3.98 C 2.61,11.8 1.01,10.08 1.01,8 1.01,5.92 2.61,4.2 4.65,4.02 Z M 8,4 C 6.8,4.9 6,6.4 6,8 6,9.6 6.8,11.1 8,12 9.2,11.1 10,9.7 10,8 10,6.3 9.2,4.9 8,4 Z m 3,-1 c 2.8,0 5,2.2 5,5 0,2.8 -2.2,5 -5,5 C 10.4,13 9.9,12.9 9.4,12.7 10.7,11.6 11.5,9.8 11.5,8 11.5,6.2 10.7,4.5 9.4,3.3 9.9,3.1 10.4,3 11,3 Z m 0.35,1.02 c 0.73,1.15 1.14,2.52 1.14,3.98 0,1.46 -0.42,2.83 -1.14,3.98 2.04,-0.18 3.64,-1.9 3.64,-3.98 0,-2.08 -1.6,-3.8 -3.64,-3.98 z", style: {
  strokeWidth: 0.234,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
}, fill: "black" })))), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("rect", { x: 0, y: 0, width: 25.3804963846, height: 16, mask: "url(#union-mask)" }))), G6t = (t) => /* @__PURE__ */ le.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", role: "img", ...t }, /* @__PURE__ */ le.createElement("path", { d: "M12 18c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0-9c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0-9c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3z" })), U6t = (t) => /* @__PURE__ */ le.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", role: "img", ...t }, /* @__PURE__ */ le.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" }), /* @__PURE__ */ le.createElement("path", { d: "M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z" })), H6t = (t) => /* @__PURE__ */ le.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 24, height: 24, viewBox: "0 0 24 24", role: "img", ...t }, /* @__PURE__ */ le.createElement("g", { transform: "translate(0,3)" }, /* @__PURE__ */ le.createElement("path", { style: {
  strokeWidth: 0.343565
}, d: "M 23.942314,4.6958443 C 23.446206,1.8868581 19.727461,0 14.687364,0 13.437819,0 12.150138,0.11543779 10.859708,0.34287772 4.1629423,1.5250844 -0.58168816,5.2884937 0.05768601,8.911385 c 0.25355086,1.439193 1.35605049,2.63583 3.04638949,3.461072 -0.2569865,0.387198 -0.4074679,0.826617 -0.4074679,1.29524 0,1.337498 1.1863293,2.457176 2.7639791,2.728248 l -1.3615475,2.333149 c -0.1576963,0.271073 -0.066308,0.61876 0.2047647,0.776457 0.090014,0.05291 0.1886171,0.07799 0.2858459,0.07799 0.1951448,0 0.3851362,-0.100665 0.4912977,-0.281723 l 1.6803757,-2.88148 C 8.41868,16.20561 9.6895264,15.063601 9.6998333,13.683844 c 6.872e-4,-0.0055 0.00137,-0.01065 0.00137,-0.01615 0,-0.02336 -0.00344,-0.04569 -0.00481,-0.06837 1.1292977,-0.0213 2.2847067,-0.130211 3.4435507,-0.334975 6.69711,-1.181863 11.44174,-4.9456164 10.802366,-8.5685077 z M 3.83312,13.667353 c 0,-0.30749 0.1281497,-0.59849 0.3470005,-0.848261 0.1219655,0.04295 0.2456489,0.08383 0.3717372,0.123339 l 1.2234344,2.352045 C 4.6865351,15.149835 3.83312,14.46408 3.83312,13.667353 Z M 7.0141869,15.216144 6.0223152,13.309702 5.4008064,12.114097 c 0.121622,-0.03161 0.2477103,-0.05634 0.3772342,-0.07387 0.1367388,-0.0189 0.2772568,-0.02886 0.420867,-0.02886 0.5067581,0 0.980534,0.11956 1.3701366,0.317454 0.5696305,0.289968 0.9554538,0.750345 0.9904974,1.262944 0.00137,0.02542 0.0055,0.05016 0.0055,0.07593 0,0.698124 -0.6562089,1.310356 -1.5508518,1.548447 z m 5.9185921,-3.126441 c -1.217251,0.214728 -2.429691,0.323982 -3.6060571,0.324669 -0.5765018,-0.911821 -1.7614569,-1.53917 -3.1278143,-1.53917 -0.4717146,0 -0.921441,0.07593 -1.332001,0.211292 -0.3061162,0.100665 -0.5878394,0.237403 -0.8427645,0.39991 C 2.4598914,10.828133 1.4360682,9.8579062 1.2319907,8.7035283 0.72660678,5.8381974 5.2307418,2.5475333 11.067221,1.5175259 c 1.222061,-0.2161023 2.439998,-0.3246688 3.620143,-0.3246688 4.371863,0 7.694479,1.5250844 8.080645,3.7101568 0.505041,2.8653309 -3.998751,6.1566821 -9.83523,7.1866891 z", id: "path10" }))), $6t = (t) => /* @__PURE__ */ le.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", x: "0px", y: "0px", role: "img", ...t }, /* @__PURE__ */ le.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9999 16.4H8.81085L6.62526 18.4381L7.53584 19.4146L3.97778 19.9979L4.80785 16.4892L5.67046 17.4142L7.99994 15.242V15V7.00001H6.69994L7.99994 5.05V5H8.03327L8.69994 4L9.36661 5H9.39994V5.05L10.6999 7.00001H9.39994V15H16.9999V13.7L19.9999 15.7L16.9999 17.7V16.4Z", fill: "black" })), q6t = (t) => /* @__PURE__ */ le.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 700 550", role: "img", ...t }, /* @__PURE__ */ le.createElement("path", { d: "m105 35h350v52.5h35v-70c0-4.6406-1.8438-9.0938-5.125-12.375s-7.7344-5.125-12.375-5.125h-385c-4.6406 0-9.0938 1.8438-12.375 5.125s-5.125 7.7344-5.125 12.375v385c0 4.6406 1.8438 9.0938 5.125 12.375s7.7344 5.125 12.375 5.125h70v-35h-52.5z" }), /* @__PURE__ */ le.createElement("path", { d: "m420 140c-55.695 0-109.11 22.125-148.49 61.508-39.383 39.383-61.508 92.797-61.508 148.49s22.125 109.11 61.508 148.49c39.383 39.383 92.797 61.508 148.49 61.508s109.11-22.125 148.49-61.508c39.383-39.383 61.508-92.797 61.508-148.49s-22.125-109.11-61.508-148.49c-39.383-39.383-92.797-61.508-148.49-61.508zm0 385c-46.414 0-90.926-18.438-123.74-51.258-32.82-32.816-51.258-77.328-51.258-123.74s18.438-90.926 51.258-123.74c32.816-32.82 77.328-51.258 123.74-51.258s90.926 18.438 123.74 51.258c32.82 32.816 51.258 77.328 51.258 123.74 0 30.719-8.0859 60.898-23.445 87.5-15.359 26.602-37.453 48.695-64.055 64.055-26.602 15.359-56.781 23.445-87.5 23.445z" })), j6t = (t) => /* @__PURE__ */ le.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 32 32", enableBackground: "new 0 0 32 32", xmlSpace: "preserve", role: "img", ...t }, /* @__PURE__ */ le.createElement("g", { display: "none" }, /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 7.377, cy: 25.044, r: 6.956 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 24.646, cy: 25.044, r: 6.956 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 7.354, cy: 6.956, r: 6.956 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 24.623, cy: 6.956, r: 6.956 })))), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M7.377,19.087c3.284,0,5.956,2.672,5.956,5.956S10.661,31,7.377,31S1.42,28.328,1.42,25.044S4.092,19.087,7.377,19.087      M7.377,18.087c-3.842,0-6.956,3.115-6.956,6.956C0.42,28.885,3.535,32,7.377,32s6.956-3.115,6.956-6.956     C14.333,21.202,11.219,18.087,7.377,18.087L7.377,18.087z" })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M24.646,19.087c3.284,0,5.956,2.672,5.956,5.956S27.931,31,24.646,31s-5.956-2.672-5.956-5.956     S21.362,19.087,24.646,19.087 M24.646,18.087c-3.842,0-6.956,3.115-6.956,6.956c0,3.842,3.115,6.956,6.956,6.956     c3.842,0,6.956-3.115,6.956-6.956C31.603,21.202,28.488,18.087,24.646,18.087L24.646,18.087z" })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M7.354,1c3.284,0,5.956,2.672,5.956,5.956c0,3.284-2.672,5.956-5.956,5.956s-5.956-2.672-5.956-5.956     C1.397,3.672,4.069,1,7.354,1 M7.354,0C3.512,0,0.397,3.115,0.397,6.956c0,3.842,3.115,6.956,6.956,6.956     c3.842,0,6.956-3.115,6.956-6.956C14.31,3.115,11.196,0,7.354,0L7.354,0z" })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M24.623,1c3.284,0,5.956,2.672,5.956,5.956c0,3.284-2.672,5.956-5.956,5.956s-5.956-2.672-5.956-5.956     C18.667,3.672,21.339,1,24.623,1 M24.623,0c-3.842,0-6.956,3.115-6.956,6.956c0,3.842,3.115,6.956,6.956,6.956     s6.956-3.115,6.956-6.956C31.58,3.115,28.465,0,24.623,0L24.623,0z" })))), /* @__PURE__ */ le.createElement("g", { display: "none" }, /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 7.377, cy: 25.044, r: 6.457 }), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M7.377,19.087c3.284,0,5.956,2.672,5.956,5.956S10.661,31,7.377,31S1.42,28.328,1.42,25.044S4.092,19.087,7.377,19.087      M7.377,18.087c-3.842,0-6.956,3.115-6.956,6.956C0.42,28.885,3.535,32,7.377,32s6.956-3.115,6.956-6.956     C14.333,21.202,11.219,18.087,7.377,18.087L7.377,18.087z" }))), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 24.646, cy: 25.044, r: 6.457 }), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { fill: "#000000", d: "M24.646,19.087c3.284,0,5.956,2.672,5.956,5.956S27.931,31,24.646,31s-5.956-2.672-5.956-5.956     S21.362,19.087,24.646,19.087 M24.646,18.087c-3.842,0-6.956,3.115-6.956,6.956c0,3.842,3.115,6.956,6.956,6.956     c3.842,0,6.956-3.115,6.956-6.956C31.603,21.202,28.488,18.087,24.646,18.087L24.646,18.087z" }))), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 7.354, cy: 6.957, r: 6.457 }), /* @__PURE__ */ le.createElement("path", { fill: "#000000", d: "M7.354,1c3.284,0,5.956,2.672,5.956,5.956c0,3.284-2.672,5.956-5.956,5.956s-5.956-2.672-5.956-5.956    C1.397,3.672,4.069,1,7.354,1 M7.354,0C3.512,0,0.397,3.115,0.397,6.956c0,3.842,3.115,6.956,6.956,6.956    c3.842,0,6.956-3.115,6.956-6.956C14.31,3.115,11.196,0,7.354,0L7.354,0z" })), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 24.623, cy: 6.957, r: 6.457 }), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M24.623,1c3.284,0,5.956,2.672,5.956,5.956c0,3.284-2.672,5.956-5.956,5.956s-5.956-2.672-5.956-5.956     C18.667,3.672,21.339,1,24.623,1 M24.623,0c-3.842,0-6.956,3.115-6.956,6.956c0,3.842,3.115,6.956,6.956,6.956     s6.956-3.115,6.956-6.956C31.58,3.115,28.465,0,24.623,0L24.623,0z" })))), /* @__PURE__ */ le.createElement("g", { display: "none" }, /* @__PURE__ */ le.createElement("circle", { display: "inline", fill: "#000000", cx: 7.377, cy: 25.044, r: 6.956 }), /* @__PURE__ */ le.createElement("circle", { display: "inline", fill: "#000000", cx: 24.646, cy: 25.044, r: 6.956 }), /* @__PURE__ */ le.createElement("circle", { display: "inline", fill: "#000000", cx: 7.354, cy: 6.956, r: 6.956 }), /* @__PURE__ */ le.createElement("circle", { display: "inline", fill: "#000000", cx: 24.623, cy: 6.956, r: 6.956 }))), Y6t = (t) => /* @__PURE__ */ le.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 32 32", enableBackground: "new 0 0 32 32", xmlSpace: "preserve", role: "img", ...t }, /* @__PURE__ */ le.createElement("g", { display: "none" }, /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 4.469, cy: 4.164, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { cx: 16, cy: 4.164, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 27.531, cy: 4.164, r: 4.164 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { cx: 4.469, cy: 16, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 16, cy: 16, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { cx: 27.531, cy: 16, r: 4.164 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 4.469, cy: 27.836, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { cx: 16, cy: 27.836, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 27.531, cy: 27.836, r: 4.164 })))), /* @__PURE__ */ le.createElement("g", { display: "none" }, /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("path", { fill: "#000000", d: "M4.469,1c1.744,0,3.164,1.419,3.164,3.164S6.214,7.327,4.469,7.327S1.306,5.908,1.306,4.164    S2.725,1,4.469,1 M4.469,0c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164c2.3,0,4.164-1.864,4.164-4.164    C8.633,1.864,6.769,0,4.469,0L4.469,0z" })), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("path", { fill: "#000000", d: "M16,1c1.744,0,3.164,1.419,3.164,3.164S17.744,7.327,16,7.327s-3.164-1.419-3.164-3.164S14.256,1,16,1     M16,0c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164s4.164-1.864,4.164-4.164C20.164,1.864,18.3,0,16,0L16,0z" })), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("path", { fill: "#000000", d: "M27.531,1c1.744,0,3.164,1.419,3.164,3.164s-1.419,3.164-3.164,3.164s-3.164-1.419-3.164-3.164    S25.786,1,27.531,1 M27.531,0c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164c2.3,0,4.164-1.864,4.164-4.164    C31.694,1.864,29.83,0,27.531,0L27.531,0z" })), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("path", { fill: "#000000", d: "M4.469,12.836c1.744,0,3.164,1.419,3.164,3.164s-1.419,3.164-3.164,3.164S1.306,17.744,1.306,16    S2.725,12.836,4.469,12.836 M4.469,11.836c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164    c2.3,0,4.164-1.864,4.164-4.164C8.633,13.7,6.769,11.836,4.469,11.836L4.469,11.836z" })), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("path", { fill: "#000000", d: "M16,12.836c1.744,0,3.164,1.419,3.164,3.164S17.744,19.164,16,19.164S12.836,17.744,12.836,16    S14.256,12.836,16,12.836 M16,11.836c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164S20.164,18.3,20.164,16    C20.164,13.7,18.3,11.836,16,11.836L16,11.836z" })), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("path", { fill: "#000000", d: "M27.531,12.836c1.744,0,3.164,1.419,3.164,3.164s-1.419,3.164-3.164,3.164S24.367,17.744,24.367,16    S25.786,12.836,27.531,12.836 M27.531,11.836c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164    c2.3,0,4.164-1.864,4.164-4.164C31.694,13.7,29.83,11.836,27.531,11.836L27.531,11.836z" })), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("path", { fill: "#000000", d: "M4.469,24.673c1.744,0,3.164,1.419,3.164,3.164S6.214,31,4.469,31s-3.164-1.419-3.164-3.164    S2.725,24.673,4.469,24.673 M4.469,23.673c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164    c2.3,0,4.164-1.864,4.164-4.164C8.633,25.537,6.769,23.673,4.469,23.673L4.469,23.673z" })), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("path", { fill: "#000000", d: "M16,24.673c1.744,0,3.164,1.419,3.164,3.164S17.744,31,16,31s-3.164-1.419-3.164-3.164    S14.256,24.673,16,24.673 M16,23.673c-2.3,0-4.164,1.864-4.164,4.164C11.836,30.136,13.7,32,16,32s4.164-1.864,4.164-4.164    C20.164,25.537,18.3,23.673,16,23.673L16,23.673z" })), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("path", { fill: "#000000", d: "M27.531,24.673c1.744,0,3.164,1.419,3.164,3.164S29.275,31,27.531,31s-3.164-1.419-3.164-3.164    S25.786,24.673,27.531,24.673 M27.531,23.673c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164    c2.3,0,4.164-1.864,4.164-4.164C31.694,25.537,29.83,23.673,27.531,23.673L27.531,23.673z" }))), /* @__PURE__ */ le.createElement("g", { display: "none" }, /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 16, cy: 16, r: 16 })), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 4.469, cy: 4.164, r: 3.664 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M4.469,1c1.744,0,3.164,1.419,3.164,3.164S6.214,7.327,4.469,7.327S1.306,5.908,1.306,4.164S2.725,1,4.469,1 M4.469,0      c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164c2.3,0,4.164-1.864,4.164-4.164C8.633,1.864,6.769,0,4.469,0      L4.469,0z" })))), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 16, cy: 4.164, r: 3.664 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M16,1c1.744,0,3.164,1.419,3.164,3.164S17.744,7.327,16,7.327s-3.164-1.419-3.164-3.164S14.256,1,16,1 M16,0     c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164s4.164-1.864,4.164-4.164C20.164,1.864,18.3,0,16,0L16,0z" }))), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 27.531, cy: 4.164, r: 3.664 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M27.531,1c1.744,0,3.164,1.419,3.164,3.164s-1.419,3.164-3.164,3.164s-3.164-1.419-3.164-3.164S25.786,1,27.531,1       M27.531,0c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164c2.3,0,4.164-1.864,4.164-4.164      C31.694,1.864,29.83,0,27.531,0L27.531,0z" })))), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 4.469, cy: 16, r: 3.664 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M4.469,12.836c1.744,0,3.164,1.419,3.164,3.164s-1.419,3.164-3.164,3.164S1.306,17.744,1.306,16     S2.725,12.836,4.469,12.836 M4.469,11.836c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164     c2.3,0,4.164-1.864,4.164-4.164C8.633,13.7,6.769,11.836,4.469,11.836L4.469,11.836z" }))), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 16, cy: 16, r: 3.664 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M16,12.836c1.744,0,3.164,1.419,3.164,3.164S17.744,19.164,16,19.164S12.836,17.744,12.836,16S14.256,12.836,16,12.836       M16,11.836c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164S20.164,18.3,20.164,16      C20.164,13.7,18.3,11.836,16,11.836L16,11.836z" })))), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 27.531, cy: 16, r: 3.664 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M27.531,12.836c1.744,0,3.164,1.419,3.164,3.164s-1.419,3.164-3.164,3.164S24.367,17.744,24.367,16     S25.786,12.836,27.531,12.836 M27.531,11.836c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164     c2.3,0,4.164-1.864,4.164-4.164C31.694,13.7,29.83,11.836,27.531,11.836L27.531,11.836z" }))), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 4.469, cy: 27.836, r: 3.664 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M4.469,24.673c1.744,0,3.164,1.419,3.164,3.164S6.214,31,4.469,31s-3.164-1.419-3.164-3.164S2.725,24.673,4.469,24.673       M4.469,23.673c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164c2.3,0,4.164-1.864,4.164-4.164      C8.633,25.537,6.769,23.673,4.469,23.673L4.469,23.673z" })))), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 16, cy: 27.836, r: 3.664 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M16,24.673c1.744,0,3.164,1.419,3.164,3.164S17.744,31,16,31s-3.164-1.419-3.164-3.164S14.256,24.673,16,24.673      M16,23.673c-2.3,0-4.164,1.864-4.164,4.164C11.836,30.136,13.7,32,16,32s4.164-1.864,4.164-4.164     C20.164,25.537,18.3,23.673,16,23.673L16,23.673z" }))), /* @__PURE__ */ le.createElement("g", { display: "inline" }, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { fill: "#000000", cx: 27.531, cy: 27.836, r: 3.664 })), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("path", { d: "M27.531,24.673c1.744,0,3.164,1.419,3.164,3.164S29.275,31,27.531,31s-3.164-1.419-3.164-3.164      S25.786,24.673,27.531,24.673 M27.531,23.673c-2.3,0-4.164,1.864-4.164,4.164c0,2.3,1.864,4.164,4.164,4.164      c2.3,0,4.164-1.864,4.164-4.164C31.694,25.537,29.83,23.673,27.531,23.673L27.531,23.673z" }))))), /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("g", null, /* @__PURE__ */ le.createElement("circle", { cx: 4.469, cy: 4.164, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { cx: 16, cy: 4.164, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { cx: 27.531, cy: 4.164, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { cx: 4.469, cy: 16, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { cx: 16, cy: 16, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { cx: 27.531, cy: 16, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { cx: 4.469, cy: 27.836, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { cx: 16, cy: 27.836, r: 4.164 }), /* @__PURE__ */ le.createElement("circle", { cx: 27.531, cy: 27.836, r: 4.164 }))));
function QBe(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function z6t(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? QBe(Object(n), !0).forEach(function(r) {
      mo(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : QBe(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function wBe(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ds(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wBe(Object(n), !0).forEach(function(r) {
      ae(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : wBe(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function B6e(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function b6e(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && m4(t, e);
}
function AU(t) {
  return AU = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, AU(t);
}
function V6t() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function J6t(t, e) {
  if (e && (Og(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return C4(t);
}
function _6e(t) {
  var e = V6t();
  return function() {
    var r = AU(t), i;
    if (e) {
      var o = AU(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return J6t(this, i);
  };
}
var S6e = function(e) {
  return +setTimeout(e, 16);
}, Q6e = function(e) {
  return clearTimeout(e);
};
typeof window < "u" && "requestAnimationFrame" in window && (S6e = function(e) {
  return window.requestAnimationFrame(e);
}, Q6e = function(e) {
  return window.cancelAnimationFrame(e);
});
var xBe = 0, NAe = /* @__PURE__ */ new Map();
function w6e(t) {
  NAe.delete(t);
}
function mI(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  xBe += 1;
  var n = xBe;
  function r(i) {
    if (i === 0)
      w6e(n), t();
    else {
      var o = S6e(function() {
        r(i - 1);
      });
      NAe.set(n, o);
    }
  }
  return r(e), n;
}
mI.cancel = function(t) {
  var e = NAe.get(t);
  return w6e(e), Q6e(e);
};
function Ik(t, e) {
  if (!t)
    return !1;
  if (t.contains)
    return t.contains(e);
  for (var n = e; n; ) {
    if (n === t)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
function x6e(t) {
  return t instanceof HTMLElement ? t : Sf.findDOMNode(t);
}
function R6e(t, e) {
  typeof t == "function" ? t(e) : Og(t) === "object" && t && "current" in t && (t.current = e);
}
function D6e() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  var r = e.filter(function(i) {
    return i;
  });
  return r.length <= 1 ? r[0] : function(i) {
    e.forEach(function(o) {
      R6e(o, i);
    });
  };
}
function T6e(t) {
  var e, n, r = _se.isMemo(t) ? t.type.type : t.type;
  return !(typeof r == "function" && !(!((e = r.prototype) === null || e === void 0) && e.render) || typeof t == "function" && !(!((n = t.prototype) === null || n === void 0) && n.render));
}
function mR(t, e, n, r) {
  var i = Sf.unstable_batchedUpdates ? function(s) {
    Sf.unstable_batchedUpdates(n, s);
  } : n;
  return t.addEventListener && t.addEventListener(e, i, r), {
    remove: function() {
      t.removeEventListener && t.removeEventListener(e, i, r);
    }
  };
}
function UL() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var K6t = /* @__PURE__ */ CE(function(t, e) {
  var n = t.didUpdate, r = t.getContainer, i = t.children, o = Zr(), s = Zr();
  rse(e, function() {
    return {};
  });
  var a = Zr(!1);
  return !a.current && UL() && (s.current = r(), o.current = s.current.parentNode, a.current = !0), Mn(function() {
    n?.(t);
  }), Mn(function() {
    return s.current.parentNode === null && o.current !== null && o.current.appendChild(s.current), function() {
      var A, l;
      (A = s.current) === null || A === void 0 || (l = A.parentNode) === null || l === void 0 || l.removeChild(s.current);
    };
  }, []), s.current ? /* @__PURE__ */ Sf.createPortal(i, s.current) : null;
});
function W6t(t, e, n) {
  return n ? t[0] === e[0] : t[0] === e[0] && t[1] === e[1];
}
function X6t(t, e, n) {
  var r = t[e] || {};
  return Ds(Ds({}, r), n);
}
function Z6t(t, e, n, r) {
  for (var i = n.points, o = Object.keys(t), s = 0; s < o.length; s += 1) {
    var a = o[s];
    if (W6t(t[a].points, i, r))
      return "".concat(e, "-placement-").concat(a);
  }
  return "";
}
function eHt(t) {
  if (Array.isArray(t))
    return t;
}
function tHt(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r, i, o, s, a = [], A = !0, l = !1;
    try {
      if (o = (n = n.call(t)).next, e === 0) {
        if (Object(n) !== n)
          return;
        A = !1;
      } else
        for (; !(A = (r = o.call(n)).done) && (a.push(r.value), a.length !== e); A = !0)
          ;
    } catch (c) {
      l = !0, i = c;
    } finally {
      try {
        if (!A && n.return != null && (s = n.return(), Object(s) !== s))
          return;
      } finally {
        if (l)
          throw i;
      }
    }
    return a;
  }
}
function nHt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AA(t, e) {
  return eHt(t) || tHt(t, e) || Ske(t, e) || nHt();
}
function rHt(t, e) {
  if (t == null)
    return {};
  var n = pke(t, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (i = 0; i < o.length; i++)
      r = o[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
const iHt = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var t = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(t?.substr(0, 4));
};
function RBe(t, e) {
  var n = {};
  return n[t.toLowerCase()] = e.toLowerCase(), n["Webkit".concat(t)] = "webkit".concat(e), n["Moz".concat(t)] = "moz".concat(e), n["ms".concat(t)] = "MS".concat(e), n["O".concat(t)] = "o".concat(e.toLowerCase()), n;
}
function oHt(t, e) {
  var n = {
    animationend: RBe("Animation", "AnimationEnd"),
    transitionend: RBe("Transition", "TransitionEnd")
  };
  return t && ("AnimationEvent" in e || delete n.animationend.animation, "TransitionEvent" in e || delete n.transitionend.transition), n;
}
var sHt = oHt(UL(), typeof window < "u" ? window : {}), N6e = {};
if (UL()) {
  var aHt = document.createElement("div");
  N6e = aHt.style;
}
var RF = {};
function L6e(t) {
  if (RF[t])
    return RF[t];
  var e = sHt[t];
  if (e)
    for (var n = Object.keys(e), r = n.length, i = 0; i < r; i += 1) {
      var o = n[i];
      if (Object.prototype.hasOwnProperty.call(e, o) && o in N6e)
        return RF[t] = e[o], RF[t];
    }
  return "";
}
var M6e = L6e("animationend"), O6e = L6e("transitionend"), AHt = !!(M6e && O6e), DBe = M6e || "animationend", TBe = O6e || "transitionend";
function NBe(t, e) {
  if (!t)
    return null;
  if (Og(t) === "object") {
    var n = e.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return t[n];
  }
  return "".concat(t, "-").concat(e);
}
var zb = "none", DF = "appear", TF = "enter", NF = "leave", LBe = "none", V0 = "prepare", c_ = "start", u_ = "active", LAe = "end";
function ID(t) {
  var e = le.useRef(!1), n = le.useState(t), r = AA(n, 2), i = r[0], o = r[1];
  le.useEffect(function() {
    return e.current = !1, function() {
      e.current = !0;
    };
  }, []);
  function s(a, A) {
    A && e.current || o(a);
  }
  return [i, s];
}
const lHt = function() {
  var t = le.useRef(null);
  function e() {
    mI.cancel(t.current);
  }
  function n(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    e();
    var o = mI(function() {
      i <= 1 ? r({
        isCanceled: function() {
          return o !== t.current;
        }
      }) : n(r, i - 1);
    });
    t.current = o;
  }
  return le.useEffect(function() {
    return function() {
      e();
    };
  }, []), [n, e];
};
var F6e = UL() ? nse : Mn, MBe = [V0, c_, u_, LAe], P6e = !1, cHt = !0;
function k6e(t) {
  return t === u_ || t === LAe;
}
const uHt = function(t, e) {
  var n = ID(LBe), r = AA(n, 2), i = r[0], o = r[1], s = lHt(), a = AA(s, 2), A = a[0], l = a[1];
  function c() {
    o(V0, !0);
  }
  return F6e(function() {
    if (i !== LBe && i !== LAe) {
      var u = MBe.indexOf(i), f = MBe[u + 1], h = e(i);
      h === P6e ? o(f, !0) : A(function(d) {
        function I() {
          d.isCanceled() || o(f, !0);
        }
        h === !0 ? I() : Promise.resolve(h).then(I);
      });
    }
  }, [t, i]), le.useEffect(function() {
    return function() {
      l();
    };
  }, []), [c, i];
}, fHt = function(t) {
  var e = Zr(), n = Zr(t);
  n.current = t;
  var r = le.useCallback(function(s) {
    n.current(s);
  }, []);
  function i(s) {
    s && (s.removeEventListener(TBe, r), s.removeEventListener(DBe, r));
  }
  function o(s) {
    e.current && e.current !== s && i(e.current), s && s !== e.current && (s.addEventListener(TBe, r), s.addEventListener(DBe, r), e.current = s);
  }
  return le.useEffect(function() {
    return function() {
      i(e.current);
    };
  }, []), [o, i];
};
function gHt(t, e, n, r) {
  var i = r.motionEnter, o = i === void 0 ? !0 : i, s = r.motionAppear, a = s === void 0 ? !0 : s, A = r.motionLeave, l = A === void 0 ? !0 : A, c = r.motionDeadline, u = r.motionLeaveImmediately, f = r.onAppearPrepare, h = r.onEnterPrepare, d = r.onLeavePrepare, I = r.onAppearStart, m = r.onEnterStart, C = r.onLeaveStart, y = r.onAppearActive, v = r.onEnterActive, b = r.onLeaveActive, Q = r.onAppearEnd, w = r.onEnterEnd, R = r.onLeaveEnd, M = r.onVisibleChanged, O = ID(), L = AA(O, 2), N = L[0], k = L[1], $ = ID(zb), U = AA($, 2), X = U[0], K = U[1], z = ID(null), Y = AA(z, 2), V = Y[0], Z = Y[1], ce = Zr(!1), ee = Zr(null);
  function pe() {
    return n();
  }
  var Ce = Zr(!1);
  function Be(_e) {
    var Re = pe();
    if (!(_e && !_e.deadline && _e.target !== Re)) {
      var Ee = Ce.current, oe;
      X === DF && Ee ? oe = Q?.(Re, _e) : X === TF && Ee ? oe = w?.(Re, _e) : X === NF && Ee && (oe = R?.(Re, _e)), X !== zb && Ee && oe !== !1 && (K(zb, !0), Z(null, !0));
    }
  }
  var Ie = fHt(Be), Qe = AA(Ie, 1), xe = Qe[0], Se = le.useMemo(function() {
    var _e, Re, Ee;
    switch (X) {
      case DF:
        return _e = {}, ae(_e, V0, f), ae(_e, c_, I), ae(_e, u_, y), _e;
      case TF:
        return Re = {}, ae(Re, V0, h), ae(Re, c_, m), ae(Re, u_, v), Re;
      case NF:
        return Ee = {}, ae(Ee, V0, d), ae(Ee, c_, C), ae(Ee, u_, b), Ee;
      default:
        return {};
    }
  }, [X]), De = uHt(X, function(_e) {
    if (_e === V0) {
      var Re = Se[V0];
      return Re ? Re(pe()) : P6e;
    }
    if (se in Se) {
      var Ee;
      Z(((Ee = Se[se]) === null || Ee === void 0 ? void 0 : Ee.call(Se, pe(), null)) || null);
    }
    return se === u_ && (xe(pe()), c > 0 && (clearTimeout(ee.current), ee.current = setTimeout(function() {
      Be({
        deadline: !0
      });
    }, c))), cHt;
  }), Ue = AA(De, 2), Te = Ue[0], se = Ue[1], fe = k6e(se);
  Ce.current = fe, F6e(function() {
    k(e);
    var _e = ce.current;
    if (ce.current = !0, !!t) {
      var Re;
      !_e && e && a && (Re = DF), _e && e && o && (Re = TF), (_e && !e && l || !_e && u && !e && l) && (Re = NF), Re && (K(Re), Te());
    }
  }, [e]), Mn(function() {
    // Cancel appear
    (X === DF && !a || // Cancel enter
    X === TF && !o || // Cancel leave
    X === NF && !l) && K(zb);
  }, [a, o, l]), Mn(function() {
    return function() {
      ce.current = !1, clearTimeout(ee.current);
    };
  }, []);
  var W = le.useRef(!1);
  Mn(function() {
    N && (W.current = !0), N !== void 0 && X === zb && ((W.current || N) && M?.(N), W.current = !0);
  }, [N, X]);
  var ge = V;
  return Se[V0] && se === c_ && (ge = Ds({
    transition: "none"
  }, ge)), [X, se, ge, N ?? e];
}
var hHt = /* @__PURE__ */ function(t) {
  b6e(n, t);
  var e = _6e(n);
  function n() {
    return B6e(this, n), e.apply(this, arguments);
  }
  return oH(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(le.Component);
function dHt(t) {
  var e = t;
  Og(t) === "object" && (e = t.transitionSupport);
  function n(i) {
    return !!(i.motionName && e);
  }
  var r = /* @__PURE__ */ le.forwardRef(function(i, o) {
    var s = i.visible, a = s === void 0 ? !0 : s, A = i.removeOnLeave, l = A === void 0 ? !0 : A, c = i.forceRender, u = i.children, f = i.motionName, h = i.leavedClassName, d = i.eventProps, I = n(i), m = Zr(), C = Zr();
    function y() {
      try {
        return m.current instanceof HTMLElement ? m.current : x6e(C.current);
      } catch {
        return null;
      }
    }
    var v = gHt(I, a, y, i), b = AA(v, 4), Q = b[0], w = b[1], R = b[2], M = b[3], O = le.useRef(M);
    M && (O.current = !0);
    var L = le.useCallback(function(z) {
      m.current = z, R6e(o, z);
    }, [o]), N, k = Ds(Ds({}, d), {}, {
      visible: a
    });
    if (!u)
      N = null;
    else if (Q === zb || !n(i))
      M ? N = u(Ds({}, k), L) : !l && O.current ? N = u(Ds(Ds({}, k), {}, {
        className: h
      }), L) : c ? N = u(Ds(Ds({}, k), {}, {
        style: {
          display: "none"
        }
      }), L) : N = null;
    else {
      var $, U;
      w === V0 ? U = "prepare" : k6e(w) ? U = "active" : w === c_ && (U = "start"), N = u(Ds(Ds({}, k), {}, {
        className: Gl(NBe(f, Q), ($ = {}, ae($, NBe(f, "".concat(Q, "-").concat(U)), U), ae($, f, typeof f == "string"), $)),
        style: R
      }), L);
    }
    if (/* @__PURE__ */ le.isValidElement(N) && T6e(N)) {
      var X = N, K = X.ref;
      K || (N = /* @__PURE__ */ le.cloneElement(N, {
        ref: L
      }));
    }
    return /* @__PURE__ */ le.createElement(hHt, {
      ref: C
    }, N);
  });
  return r.displayName = "CSSMotion", r;
}
const MAe = dHt(AHt);
function G6e(t) {
  var e = t.prefixCls, n = t.motion, r = t.animation, i = t.transitionName;
  return n || (r ? {
    motionName: "".concat(e, "-").concat(r)
  } : i ? {
    motionName: i
  } : null);
}
function pHt(t) {
  var e = t.prefixCls, n = t.visible, r = t.zIndex, i = t.mask, o = t.maskMotion, s = t.maskAnimation, a = t.maskTransitionName;
  if (!i)
    return null;
  var A = {};
  return (o || a || s) && (A = Ds({
    motionAppear: !0
  }, G6e({
    motion: o,
    prefixCls: e,
    transitionName: a,
    animation: s
  }))), /* @__PURE__ */ le.createElement(MAe, Ns({}, A, {
    visible: n,
    removeOnLeave: !0
  }), function(l) {
    var c = l.className;
    return /* @__PURE__ */ le.createElement("div", {
      style: {
        zIndex: r
      },
      className: Gl("".concat(e, "-mask"), c)
    });
  });
}
const IHt = function(t) {
  if (!t)
    return !1;
  if (t instanceof HTMLElement && t.offsetParent)
    return !0;
  if (t instanceof SVGGraphicsElement && t.getBBox) {
    var e = t.getBBox(), n = e.width, r = e.height;
    if (n || r)
      return !0;
  }
  if (t instanceof HTMLElement && t.getBoundingClientRect) {
    var i = t.getBoundingClientRect(), o = i.width, s = i.height;
    if (o || s)
      return !0;
  }
  return !1;
};
function OBe(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function FBe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? OBe(Object(n), !0).forEach(function(r) {
      mHt(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : OBe(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function mk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? mk = function(e) {
    return typeof e;
  } : mk = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, mk(t);
}
function mHt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var t2, CHt = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  // IE did it wrong again ...
  ms: "-ms-",
  O: "-o-"
};
function lU() {
  if (t2 !== void 0)
    return t2;
  t2 = "";
  var t = document.createElement("p").style, e = "Transform";
  for (var n in CHt)
    n + e in t && (t2 = n);
  return t2;
}
function U6e() {
  return lU() ? "".concat(lU(), "TransitionProperty") : "transitionProperty";
}
function O9() {
  return lU() ? "".concat(lU(), "Transform") : "transform";
}
function PBe(t, e) {
  var n = U6e();
  n && (t.style[n] = e, n !== "transitionProperty" && (t.style.transitionProperty = e));
}
function L7(t, e) {
  var n = O9();
  n && (t.style[n] = e, n !== "transform" && (t.style.transform = e));
}
function EHt(t) {
  return t.style.transitionProperty || t.style[U6e()];
}
function yHt(t) {
  var e = window.getComputedStyle(t, null), n = e.getPropertyValue("transform") || e.getPropertyValue(O9());
  if (n && n !== "none") {
    var r = n.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(r[12] || r[4], 0),
      y: parseFloat(r[13] || r[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var vHt = /matrix\((.*)\)/, BHt = /matrix3d\((.*)\)/;
function bHt(t, e) {
  var n = window.getComputedStyle(t, null), r = n.getPropertyValue("transform") || n.getPropertyValue(O9());
  if (r && r !== "none") {
    var i, o = r.match(vHt);
    if (o)
      o = o[1], i = o.split(",").map(function(a) {
        return parseFloat(a, 10);
      }), i[4] = e.x, i[5] = e.y, L7(t, "matrix(".concat(i.join(","), ")"));
    else {
      var s = r.match(BHt)[1];
      i = s.split(",").map(function(a) {
        return parseFloat(a, 10);
      }), i[12] = e.x, i[13] = e.y, L7(t, "matrix3d(".concat(i.join(","), ")"));
    }
  } else
    L7(t, "translateX(".concat(e.x, "px) translateY(").concat(e.y, "px) translateZ(0)"));
}
var _Ht = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source, HL;
function kBe(t) {
  var e = t.style.display;
  t.style.display = "none", t.offsetHeight, t.style.display = e;
}
function U_(t, e, n) {
  var r = n;
  if (mk(e) === "object") {
    for (var i in e)
      e.hasOwnProperty(i) && U_(t, i, e[i]);
    return;
  }
  if (typeof r < "u") {
    typeof r == "number" && (r = "".concat(r, "px")), t.style[e] = r;
    return;
  }
  return HL(t, e);
}
function SHt(t) {
  var e, n, r, i = t.ownerDocument, o = i.body, s = i && i.documentElement;
  return e = t.getBoundingClientRect(), n = Math.floor(e.left), r = Math.floor(e.top), n -= s.clientLeft || o.clientLeft || 0, r -= s.clientTop || o.clientTop || 0, {
    left: n,
    top: r
  };
}
function H6e(t, e) {
  var n = t["page".concat(e ? "Y" : "X", "Offset")], r = "scroll".concat(e ? "Top" : "Left");
  if (typeof n != "number") {
    var i = t.document;
    n = i.documentElement[r], typeof n != "number" && (n = i.body[r]);
  }
  return n;
}
function $6e(t) {
  return H6e(t);
}
function q6e(t) {
  return H6e(t, !0);
}
function DT(t) {
  var e = SHt(t), n = t.ownerDocument, r = n.defaultView || n.parentWindow;
  return e.left += $6e(r), e.top += q6e(r), e;
}
function OAe(t) {
  return t != null && t == t.window;
}
function j6e(t) {
  return OAe(t) ? t.document : t.nodeType === 9 ? t : t.ownerDocument;
}
function QHt(t, e, n) {
  var r = n, i = "", o = j6e(t);
  return r = r || o.defaultView.getComputedStyle(t, null), r && (i = r.getPropertyValue(e) || r[e]), i;
}
var wHt = new RegExp("^(".concat(_Ht, ")(?!px)[a-z%]+$"), "i"), xHt = /^(top|right|bottom|left)$/, M7 = "currentStyle", O7 = "runtimeStyle", gy = "left", RHt = "px";
function DHt(t, e) {
  var n = t[M7] && t[M7][e];
  if (wHt.test(n) && !xHt.test(e)) {
    var r = t.style, i = r[gy], o = t[O7][gy];
    t[O7][gy] = t[M7][gy], r[gy] = e === "fontSize" ? "1em" : n || 0, n = r.pixelLeft + RHt, r[gy] = i, t[O7][gy] = o;
  }
  return n === "" ? "auto" : n;
}
typeof window < "u" && (HL = window.getComputedStyle ? QHt : DHt);
function LF(t, e) {
  return t === "left" ? e.useCssRight ? "right" : t : e.useCssBottom ? "bottom" : t;
}
function GBe(t) {
  if (t === "left")
    return "right";
  if (t === "right")
    return "left";
  if (t === "top")
    return "bottom";
  if (t === "bottom")
    return "top";
}
function UBe(t, e, n) {
  U_(t, "position") === "static" && (t.style.position = "relative");
  var r = -999, i = -999, o = LF("left", n), s = LF("top", n), a = GBe(o), A = GBe(s);
  o !== "left" && (r = 999), s !== "top" && (i = 999);
  var l = "", c = DT(t);
  ("left" in e || "top" in e) && (l = EHt(t) || "", PBe(t, "none")), "left" in e && (t.style[a] = "", t.style[o] = "".concat(r, "px")), "top" in e && (t.style[A] = "", t.style[s] = "".concat(i, "px")), kBe(t);
  var u = DT(t), f = {};
  for (var h in e)
    if (e.hasOwnProperty(h)) {
      var d = LF(h, n), I = h === "left" ? r : i, m = c[h] - u[h];
      d === h ? f[d] = I + m : f[d] = I - m;
    }
  U_(t, f), kBe(t), ("left" in e || "top" in e) && PBe(t, l);
  var C = {};
  for (var y in e)
    if (e.hasOwnProperty(y)) {
      var v = LF(y, n), b = e[y] - c[y];
      y === v ? C[v] = f[v] + b : C[v] = f[v] - b;
    }
  U_(t, C);
}
function THt(t, e) {
  var n = DT(t), r = yHt(t), i = {
    x: r.x,
    y: r.y
  };
  "left" in e && (i.x = r.x + e.left - n.left), "top" in e && (i.y = r.y + e.top - n.top), bHt(t, i);
}
function NHt(t, e, n) {
  if (n.ignoreShake) {
    var r = DT(t), i = r.left.toFixed(0), o = r.top.toFixed(0), s = e.left.toFixed(0), a = e.top.toFixed(0);
    if (i === s && o === a)
      return;
  }
  n.useCssRight || n.useCssBottom ? UBe(t, e, n) : n.useCssTransform && O9() in document.body.style ? THt(t, e) : UBe(t, e, n);
}
function FAe(t, e) {
  for (var n = 0; n < t.length; n++)
    e(t[n]);
}
function Y6e(t) {
  return HL(t, "boxSizing") === "border-box";
}
var LHt = ["margin", "border", "padding"], dee = -1, MHt = 2, pee = 1, OHt = 0;
function FHt(t, e, n) {
  var r = {}, i = t.style, o;
  for (o in e)
    e.hasOwnProperty(o) && (r[o] = i[o], i[o] = e[o]);
  n.call(t);
  for (o in e)
    e.hasOwnProperty(o) && (i[o] = r[o]);
}
function CR(t, e, n) {
  var r = 0, i, o, s;
  for (o = 0; o < e.length; o++)
    if (i = e[o], i)
      for (s = 0; s < n.length; s++) {
        var a = void 0;
        i === "border" ? a = "".concat(i).concat(n[s], "Width") : a = i + n[s], r += parseFloat(HL(t, a)) || 0;
      }
  return r;
}
var bp = {
  getParent: function(e) {
    var n = e;
    do
      n.nodeType === 11 && n.host ? n = n.host : n = n.parentNode;
    while (n && n.nodeType !== 1 && n.nodeType !== 9);
    return n;
  }
};
FAe(["Width", "Height"], function(t) {
  bp["doc".concat(t)] = function(e) {
    var n = e.document;
    return Math.max(
      // firefox chrome documentElement.scrollHeight< body.scrollHeight
      // ie standard mode : documentElement.scrollHeight> body.scrollHeight
      n.documentElement["scroll".concat(t)],
      // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      n.body["scroll".concat(t)],
      bp["viewport".concat(t)](n)
    );
  }, bp["viewport".concat(t)] = function(e) {
    var n = "client".concat(t), r = e.document, i = r.body, o = r.documentElement, s = o[n];
    return r.compatMode === "CSS1Compat" && s || i && i[n] || s;
  };
});
function HBe(t, e, n) {
  var r = n;
  if (OAe(t))
    return e === "width" ? bp.viewportWidth(t) : bp.viewportHeight(t);
  if (t.nodeType === 9)
    return e === "width" ? bp.docWidth(t) : bp.docHeight(t);
  var i = e === "width" ? ["Left", "Right"] : ["Top", "Bottom"], o = Math.floor(e === "width" ? t.getBoundingClientRect().width : t.getBoundingClientRect().height), s = Y6e(t), a = 0;
  (o == null || o <= 0) && (o = void 0, a = HL(t, e), (a == null || Number(a) < 0) && (a = t.style[e] || 0), a = parseFloat(a) || 0), r === void 0 && (r = s ? pee : dee);
  var A = o !== void 0 || s, l = o || a;
  return r === dee ? A ? l - CR(t, ["border", "padding"], i) : a : A ? r === pee ? l : l + (r === MHt ? -CR(t, ["border"], i) : CR(t, ["margin"], i)) : a + CR(t, LHt.slice(r), i);
}
var PHt = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function $Be() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  var r, i = e[0];
  return i.offsetWidth !== 0 ? r = HBe.apply(void 0, e) : FHt(i, PHt, function() {
    r = HBe.apply(void 0, e);
  }), r;
}
FAe(["width", "height"], function(t) {
  var e = t.charAt(0).toUpperCase() + t.slice(1);
  bp["outer".concat(e)] = function(r, i) {
    return r && $Be(r, t, i ? OHt : pee);
  };
  var n = t === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  bp[t] = function(r, i) {
    var o = i;
    if (o !== void 0) {
      if (r) {
        var s = Y6e(r);
        return s && (o += CR(r, ["padding", "border"], n)), U_(r, t, o);
      }
      return;
    }
    return r && $Be(r, t, dee);
  };
});
function z6e(t, e) {
  for (var n in e)
    e.hasOwnProperty(n) && (t[n] = e[n]);
  return t;
}
var jr = {
  getWindow: function(e) {
    if (e && e.document && e.setTimeout)
      return e;
    var n = e.ownerDocument || e;
    return n.defaultView || n.parentWindow;
  },
  getDocument: j6e,
  offset: function(e, n, r) {
    if (typeof n < "u")
      NHt(e, n, r || {});
    else
      return DT(e);
  },
  isWindow: OAe,
  each: FAe,
  css: U_,
  clone: function(e) {
    var n, r = {};
    for (n in e)
      e.hasOwnProperty(n) && (r[n] = e[n]);
    var i = e.overflow;
    if (i)
      for (n in e)
        e.hasOwnProperty(n) && (r.overflow[n] = e.overflow[n]);
    return r;
  },
  mix: z6e,
  getWindowScrollLeft: function(e) {
    return $6e(e);
  },
  getWindowScrollTop: function(e) {
    return q6e(e);
  },
  merge: function() {
    for (var e = {}, n = 0; n < arguments.length; n++)
      jr.mix(e, n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return e;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
z6e(jr, bp);
var F7 = jr.getParent;
function Iee(t) {
  if (jr.isWindow(t) || t.nodeType === 9)
    return null;
  var e = jr.getDocument(t), n = e.body, r, i = jr.css(t, "position"), o = i === "fixed" || i === "absolute";
  if (!o)
    return t.nodeName.toLowerCase() === "html" ? null : F7(t);
  for (r = F7(t); r && r !== n && r.nodeType !== 9; r = F7(r))
    if (i = jr.css(r, "position"), i !== "static")
      return r;
  return null;
}
var qBe = jr.getParent;
function kHt(t) {
  if (jr.isWindow(t) || t.nodeType === 9)
    return !1;
  var e = jr.getDocument(t), n = e.body, r = null;
  for (
    r = qBe(t);
    // 修复元素位于 document.documentElement 下导致崩溃问题
    r && r !== n && r !== e;
    r = qBe(r)
  ) {
    var i = jr.css(r, "position");
    if (i === "fixed")
      return !0;
  }
  return !1;
}
function PAe(t, e) {
  for (var n = {
    left: 0,
    right: 1 / 0,
    top: 0,
    bottom: 1 / 0
  }, r = Iee(t), i = jr.getDocument(t), o = i.defaultView || i.parentWindow, s = i.body, a = i.documentElement; r; ) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || r.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    r !== s && r !== a && jr.css(r, "overflow") !== "visible") {
      var A = jr.offset(r);
      A.left += r.clientLeft, A.top += r.clientTop, n.top = Math.max(n.top, A.top), n.right = Math.min(
        n.right,
        // consider area without scrollBar
        A.left + r.clientWidth
      ), n.bottom = Math.min(n.bottom, A.top + r.clientHeight), n.left = Math.max(n.left, A.left);
    } else if (r === s || r === a)
      break;
    r = Iee(r);
  }
  var l = null;
  if (!jr.isWindow(t) && t.nodeType !== 9) {
    l = t.style.position;
    var c = jr.css(t, "position");
    c === "absolute" && (t.style.position = "fixed");
  }
  var u = jr.getWindowScrollLeft(o), f = jr.getWindowScrollTop(o), h = jr.viewportWidth(o), d = jr.viewportHeight(o), I = a.scrollWidth, m = a.scrollHeight, C = window.getComputedStyle(s);
  if (C.overflowX === "hidden" && (I = o.innerWidth), C.overflowY === "hidden" && (m = o.innerHeight), t.style && (t.style.position = l), e || kHt(t))
    n.left = Math.max(n.left, u), n.top = Math.max(n.top, f), n.right = Math.min(n.right, u + h), n.bottom = Math.min(n.bottom, f + d);
  else {
    var y = Math.max(I, u + h);
    n.right = Math.min(n.right, y);
    var v = Math.max(m, f + d);
    n.bottom = Math.min(n.bottom, v);
  }
  return n.top >= 0 && n.left >= 0 && n.bottom > n.top && n.right > n.left ? n : null;
}
function GHt(t, e, n, r) {
  var i = jr.clone(t), o = {
    width: e.width,
    height: e.height
  };
  return r.adjustX && i.left < n.left && (i.left = n.left), r.resizeWidth && i.left >= n.left && i.left + o.width > n.right && (o.width -= i.left + o.width - n.right), r.adjustX && i.left + o.width > n.right && (i.left = Math.max(n.right - o.width, n.left)), r.adjustY && i.top < n.top && (i.top = n.top), r.resizeHeight && i.top >= n.top && i.top + o.height > n.bottom && (o.height -= i.top + o.height - n.bottom), r.adjustY && i.top + o.height > n.bottom && (i.top = Math.max(n.bottom - o.height, n.top)), jr.mix(i, o);
}
function kAe(t) {
  var e, n, r;
  if (!jr.isWindow(t) && t.nodeType !== 9)
    e = jr.offset(t), n = jr.outerWidth(t), r = jr.outerHeight(t);
  else {
    var i = jr.getWindow(t);
    e = {
      left: jr.getWindowScrollLeft(i),
      top: jr.getWindowScrollTop(i)
    }, n = jr.viewportWidth(i), r = jr.viewportHeight(i);
  }
  return e.width = n, e.height = r, e;
}
function jBe(t, e) {
  var n = e.charAt(0), r = e.charAt(1), i = t.width, o = t.height, s = t.left, a = t.top;
  return n === "c" ? a += o / 2 : n === "b" && (a += o), r === "c" ? s += i / 2 : r === "r" && (s += i), {
    left: s,
    top: a
  };
}
function MF(t, e, n, r, i) {
  var o = jBe(e, n[1]), s = jBe(t, n[0]), a = [s.left - o.left, s.top - o.top];
  return {
    left: Math.round(t.left - a[0] + r[0] - i[0]),
    top: Math.round(t.top - a[1] + r[1] - i[1])
  };
}
function YBe(t, e, n) {
  return t.left < n.left || t.left + e.width > n.right;
}
function zBe(t, e, n) {
  return t.top < n.top || t.top + e.height > n.bottom;
}
function UHt(t, e, n) {
  return t.left > n.right || t.left + e.width < n.left;
}
function HHt(t, e, n) {
  return t.top > n.bottom || t.top + e.height < n.top;
}
function OF(t, e, n) {
  var r = [];
  return jr.each(t, function(i) {
    r.push(i.replace(e, function(o) {
      return n[o];
    }));
  }), r;
}
function FF(t, e) {
  return t[e] = -t[e], t;
}
function VBe(t, e) {
  var n;
  return /%$/.test(t) ? n = parseInt(t.substring(0, t.length - 1), 10) / 100 * e : n = parseInt(t, 10), n || 0;
}
function JBe(t, e) {
  t[0] = VBe(t[0], e.width), t[1] = VBe(t[1], e.height);
}
function V6e(t, e, n, r) {
  var i = n.points, o = n.offset || [0, 0], s = n.targetOffset || [0, 0], a = n.overflow, A = n.source || t;
  o = [].concat(o), s = [].concat(s), a = a || {};
  var l = {}, c = 0, u = !!(a && a.alwaysByViewport), f = PAe(A, u), h = kAe(A);
  JBe(o, h), JBe(s, e);
  var d = MF(h, e, i, o, s), I = jr.merge(h, d);
  if (f && (a.adjustX || a.adjustY) && r) {
    if (a.adjustX && YBe(d, h, f)) {
      var m = OF(i, /[lr]/gi, {
        l: "r",
        r: "l"
      }), C = FF(o, 0), y = FF(s, 0), v = MF(h, e, m, C, y);
      UHt(v, h, f) || (c = 1, i = m, o = C, s = y);
    }
    if (a.adjustY && zBe(d, h, f)) {
      var b = OF(i, /[tb]/gi, {
        t: "b",
        b: "t"
      }), Q = FF(o, 1), w = FF(s, 1), R = MF(h, e, b, Q, w);
      HHt(R, h, f) || (c = 1, i = b, o = Q, s = w);
    }
    c && (d = MF(h, e, i, o, s), jr.mix(I, d));
    var M = YBe(d, h, f), O = zBe(d, h, f);
    if (M || O) {
      var L = i;
      M && (L = OF(i, /[lr]/gi, {
        l: "r",
        r: "l"
      })), O && (L = OF(i, /[tb]/gi, {
        t: "b",
        b: "t"
      })), i = L, o = n.offset || [0, 0], s = n.targetOffset || [0, 0];
    }
    l.adjustX = a.adjustX && M, l.adjustY = a.adjustY && O, (l.adjustX || l.adjustY) && (I = GHt(d, h, f, l));
  }
  return I.width !== h.width && jr.css(A, "width", jr.width(A) + I.width - h.width), I.height !== h.height && jr.css(A, "height", jr.height(A) + I.height - h.height), jr.offset(A, {
    left: I.left,
    top: I.top
  }, {
    useCssRight: n.useCssRight,
    useCssBottom: n.useCssBottom,
    useCssTransform: n.useCssTransform,
    ignoreShake: n.ignoreShake
  }), {
    points: i,
    offset: o,
    targetOffset: s,
    overflow: l
  };
}
function $Ht(t, e) {
  var n = PAe(t, e), r = kAe(t);
  return !n || r.left + r.width <= n.left || r.top + r.height <= n.top || r.left >= n.right || r.top >= n.bottom;
}
function GAe(t, e, n) {
  var r = n.target || e, i = kAe(r), o = !$Ht(r, n.overflow && n.overflow.alwaysByViewport);
  return V6e(t, i, n, o);
}
GAe.__getOffsetParent = Iee;
GAe.__getVisibleRectForElement = PAe;
function qHt(t, e, n) {
  var r, i, o = jr.getDocument(t), s = o.defaultView || o.parentWindow, a = jr.getWindowScrollLeft(s), A = jr.getWindowScrollTop(s), l = jr.viewportWidth(s), c = jr.viewportHeight(s);
  "pageX" in e ? r = e.pageX : r = a + e.clientX, "pageY" in e ? i = e.pageY : i = A + e.clientY;
  var u = {
    left: r,
    top: i,
    width: 0,
    height: 0
  }, f = r >= 0 && r <= a + l && i >= 0 && i <= A + c, h = [n.points[0], "cc"];
  return V6e(t, u, FBe(FBe({}, n), {}, {
    points: h
  }), f);
}
var J6e = function() {
  if (typeof Map < "u")
    return Map;
  function t(e, n) {
    var r = -1;
    return e.some(function(i, o) {
      return i[0] === n ? (r = o, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function e() {
        this.__entries__ = [];
      }
      return Object.defineProperty(e.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function(n) {
        var r = t(this.__entries__, n), i = this.__entries__[r];
        return i && i[1];
      }, e.prototype.set = function(n, r) {
        var i = t(this.__entries__, n);
        ~i ? this.__entries__[i][1] = r : this.__entries__.push([n, r]);
      }, e.prototype.delete = function(n) {
        var r = this.__entries__, i = t(r, n);
        ~i && r.splice(i, 1);
      }, e.prototype.has = function(n) {
        return !!~t(this.__entries__, n);
      }, e.prototype.clear = function() {
        this.__entries__.splice(0);
      }, e.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var i = 0, o = this.__entries__; i < o.length; i++) {
          var s = o[i];
          n.call(r, s[1], s[0]);
        }
      }, e;
    }()
  );
}(), mee = typeof window < "u" && typeof document < "u" && window.document === document, cU = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), jHt = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(cU) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
}(), YHt = 2;
function zHt(t, e) {
  var n = !1, r = !1, i = 0;
  function o() {
    n && (n = !1, t()), r && a();
  }
  function s() {
    jHt(o);
  }
  function a() {
    var A = Date.now();
    if (n) {
      if (A - i < YHt)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(s, e);
    i = A;
  }
  return a;
}
var VHt = 20, JHt = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], KHt = typeof MutationObserver < "u", WHt = (
  /** @class */
  function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = zHt(this.refresh.bind(this), VHt);
    }
    return t.prototype.addObserver = function(e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(e) {
      var n = this.observers_, r = n.indexOf(e);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var e = this.updateObservers_();
      e && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var e = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return e.forEach(function(n) {
        return n.broadcastActive();
      }), e.length > 0;
    }, t.prototype.connect_ = function() {
      !mee || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), KHt ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !mee || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(e) {
      var n = e.propertyName, r = n === void 0 ? "" : n, i = JHt.some(function(o) {
        return !!~r.indexOf(o);
      });
      i && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  }()
), K6e = function(t, e) {
  for (var n = 0, r = Object.keys(e); n < r.length; n++) {
    var i = r[n];
    Object.defineProperty(t, i, {
      value: e[i],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}, OS = function(t) {
  var e = t && t.ownerDocument && t.ownerDocument.defaultView;
  return e || cU;
}, W6e = F9(0, 0, 0, 0);
function uU(t) {
  return parseFloat(t) || 0;
}
function KBe(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  return e.reduce(function(r, i) {
    var o = t["border-" + i + "-width"];
    return r + uU(o);
  }, 0);
}
function XHt(t) {
  for (var e = ["top", "right", "bottom", "left"], n = {}, r = 0, i = e; r < i.length; r++) {
    var o = i[r], s = t["padding-" + o];
    n[o] = uU(s);
  }
  return n;
}
function ZHt(t) {
  var e = t.getBBox();
  return F9(0, 0, e.width, e.height);
}
function e9t(t) {
  var e = t.clientWidth, n = t.clientHeight;
  if (!e && !n)
    return W6e;
  var r = OS(t).getComputedStyle(t), i = XHt(r), o = i.left + i.right, s = i.top + i.bottom, a = uU(r.width), A = uU(r.height);
  if (r.boxSizing === "border-box" && (Math.round(a + o) !== e && (a -= KBe(r, "left", "right") + o), Math.round(A + s) !== n && (A -= KBe(r, "top", "bottom") + s)), !n9t(t)) {
    var l = Math.round(a + o) - e, c = Math.round(A + s) - n;
    Math.abs(l) !== 1 && (a -= l), Math.abs(c) !== 1 && (A -= c);
  }
  return F9(i.left, i.top, a, A);
}
var t9t = function() {
  return typeof SVGGraphicsElement < "u" ? function(t) {
    return t instanceof OS(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof OS(t).SVGElement && typeof t.getBBox == "function";
  };
}();
function n9t(t) {
  return t === OS(t).document.documentElement;
}
function r9t(t) {
  return mee ? t9t(t) ? ZHt(t) : e9t(t) : W6e;
}
function i9t(t) {
  var e = t.x, n = t.y, r = t.width, i = t.height, o = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, s = Object.create(o.prototype);
  return K6e(s, {
    x: e,
    y: n,
    width: r,
    height: i,
    top: n,
    right: e + r,
    bottom: i + n,
    left: e
  }), s;
}
function F9(t, e, n, r) {
  return { x: t, y: e, width: n, height: r };
}
var o9t = (
  /** @class */
  function() {
    function t(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = F9(0, 0, 0, 0), this.target = e;
    }
    return t.prototype.isActive = function() {
      var e = r9t(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, t;
  }()
), s9t = (
  /** @class */
  function() {
    function t(e, n) {
      var r = i9t(n);
      K6e(this, { target: e, contentRect: r });
    }
    return t;
  }()
), a9t = (
  /** @class */
  function() {
    function t(e, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new J6e(), typeof e != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = n, this.callbackCtx_ = r;
    }
    return t.prototype.observe = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof OS(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(e) || (n.set(e, new o9t(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof OS(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(e) && (n.delete(e), n.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var e = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && e.activeObservations_.push(n);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var e = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new s9t(r.target, r.broadcastRect());
        });
        this.callback_.call(e, n, e), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  }()
), X6e = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new J6e(), Z6e = (
  /** @class */
  function() {
    function t(e) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = WHt.getInstance(), r = new a9t(e, n, this);
      X6e.set(this, r);
    }
    return t;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  Z6e.prototype[t] = function() {
    var e;
    return (e = X6e.get(this))[t].apply(e, arguments);
  };
});
var A9t = function() {
  return typeof cU.ResizeObserver < "u" ? cU.ResizeObserver : Z6e;
}();
function l9t(t, e) {
  return t === e ? !0 : !t || !e ? !1 : "pageX" in e && "pageY" in e ? t.pageX === e.pageX && t.pageY === e.pageY : "clientX" in e && "clientY" in e ? t.clientX === e.clientX && t.clientY === e.clientY : !1;
}
function c9t(t, e) {
  t !== document.activeElement && Ik(e, t) && typeof t.focus == "function" && t.focus();
}
function WBe(t, e) {
  var n = null, r = null;
  function i(s) {
    var a = AA(s, 1), A = a[0].target;
    if (document.documentElement.contains(A)) {
      var l = A.getBoundingClientRect(), c = l.width, u = l.height, f = Math.floor(c), h = Math.floor(u);
      (n !== f || r !== h) && Promise.resolve().then(function() {
        e({
          width: f,
          height: h
        });
      }), n = f, r = h;
    }
  }
  var o = new A9t(i);
  return t && o.observe(t), function() {
    o.disconnect();
  };
}
const u9t = function(t, e) {
  var n = St.useRef(!1), r = St.useRef(null);
  function i() {
    window.clearTimeout(r.current);
  }
  function o(s) {
    if (i(), !n.current || s === !0) {
      if (t() === !1)
        return;
      n.current = !0, r.current = window.setTimeout(function() {
        n.current = !1;
      }, e);
    } else
      r.current = window.setTimeout(function() {
        n.current = !1, o();
      }, e);
  }
  return [o, function() {
    n.current = !1, i();
  }];
};
function XBe(t) {
  return typeof t != "function" ? null : t();
}
function ZBe(t) {
  return Og(t) !== "object" || !t ? null : t;
}
var f9t = function(e, n) {
  var r = e.children, i = e.disabled, o = e.target, s = e.align, a = e.onAlign, A = e.monitorWindowResize, l = e.monitorBufferTime, c = l === void 0 ? 0 : l, u = St.useRef({}), f = St.useRef(), h = St.Children.only(r), d = St.useRef({});
  d.current.disabled = i, d.current.target = o, d.current.align = s, d.current.onAlign = a;
  var I = u9t(function() {
    var w = d.current, R = w.disabled, M = w.target, O = w.align, L = w.onAlign;
    if (!R && M) {
      var N = f.current, k, $ = XBe(M), U = ZBe(M);
      u.current.element = $, u.current.point = U, u.current.align = O;
      var X = document, K = X.activeElement;
      return $ && IHt($) ? k = GAe(N, $, O) : U && (k = qHt(N, U, O)), c9t(K, N), L && k && L(N, k), !0;
    }
    return !1;
  }, c), m = AA(I, 2), C = m[0], y = m[1], v = St.useRef({
    cancel: function() {
    }
  }), b = St.useRef({
    cancel: function() {
    }
  });
  St.useEffect(function() {
    var w = XBe(o), R = ZBe(o);
    f.current !== b.current.element && (b.current.cancel(), b.current.element = f.current, b.current.cancel = WBe(f.current, C)), (u.current.element !== w || !l9t(u.current.point, R) || !wFt(u.current.align, s)) && (C(), v.current.element !== w && (v.current.cancel(), v.current.element = w, v.current.cancel = WBe(w, C)));
  }), St.useEffect(function() {
    i ? y() : C();
  }, [i]);
  var Q = St.useRef(null);
  return St.useEffect(function() {
    A ? Q.current || (Q.current = mR(window, "resize", C)) : Q.current && (Q.current.remove(), Q.current = null);
  }, [A]), St.useEffect(function() {
    return function() {
      v.current.cancel(), b.current.cancel(), Q.current && Q.current.remove(), y();
    };
  }, []), St.useImperativeHandle(n, function() {
    return {
      forceAlign: function() {
        return C(!0);
      }
    };
  }), /* @__PURE__ */ St.isValidElement(h) && (h = /* @__PURE__ */ St.cloneElement(h, {
    ref: D6e(h.ref, f)
  })), h;
}, eHe = /* @__PURE__ */ St.forwardRef(f9t);
eHe.displayName = "Align";
var e1e = UL() ? le.useLayoutEffect : le.useEffect;
function Cee() {
  Cee = function() {
    return t;
  };
  var t = {}, e = Object.prototype, n = e.hasOwnProperty, r = Object.defineProperty || function(k, $, U) {
    k[$] = U.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, o = i.iterator || "@@iterator", s = i.asyncIterator || "@@asyncIterator", a = i.toStringTag || "@@toStringTag";
  function A(k, $, U) {
    return Object.defineProperty(k, $, {
      value: U,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), k[$];
  }
  try {
    A({}, "");
  } catch {
    A = function(U, X, K) {
      return U[X] = K;
    };
  }
  function l(k, $, U, X) {
    var K = $ && $.prototype instanceof f ? $ : f, z = Object.create(K.prototype), Y = new O(X || []);
    return r(z, "_invoke", {
      value: Q(k, U, Y)
    }), z;
  }
  function c(k, $, U) {
    try {
      return {
        type: "normal",
        arg: k.call($, U)
      };
    } catch (X) {
      return {
        type: "throw",
        arg: X
      };
    }
  }
  t.wrap = l;
  var u = {};
  function f() {
  }
  function h() {
  }
  function d() {
  }
  var I = {};
  A(I, o, function() {
    return this;
  });
  var m = Object.getPrototypeOf, C = m && m(m(L([])));
  C && C !== e && n.call(C, o) && (I = C);
  var y = d.prototype = f.prototype = Object.create(I);
  function v(k) {
    ["next", "throw", "return"].forEach(function($) {
      A(k, $, function(U) {
        return this._invoke($, U);
      });
    });
  }
  function b(k, $) {
    function U(K, z, Y, V) {
      var Z = c(k[K], k, z);
      if (Z.type !== "throw") {
        var ce = Z.arg, ee = ce.value;
        return ee && Og(ee) == "object" && n.call(ee, "__await") ? $.resolve(ee.__await).then(function(pe) {
          U("next", pe, Y, V);
        }, function(pe) {
          U("throw", pe, Y, V);
        }) : $.resolve(ee).then(function(pe) {
          ce.value = pe, Y(ce);
        }, function(pe) {
          return U("throw", pe, Y, V);
        });
      }
      V(Z.arg);
    }
    var X;
    r(this, "_invoke", {
      value: function(z, Y) {
        function V() {
          return new $(function(Z, ce) {
            U(z, Y, Z, ce);
          });
        }
        return X = X ? X.then(V, V) : V();
      }
    });
  }
  function Q(k, $, U) {
    var X = "suspendedStart";
    return function(K, z) {
      if (X === "executing")
        throw new Error("Generator is already running");
      if (X === "completed") {
        if (K === "throw")
          throw z;
        return N();
      }
      for (U.method = K, U.arg = z; ; ) {
        var Y = U.delegate;
        if (Y) {
          var V = w(Y, U);
          if (V) {
            if (V === u)
              continue;
            return V;
          }
        }
        if (U.method === "next")
          U.sent = U._sent = U.arg;
        else if (U.method === "throw") {
          if (X === "suspendedStart")
            throw X = "completed", U.arg;
          U.dispatchException(U.arg);
        } else
          U.method === "return" && U.abrupt("return", U.arg);
        X = "executing";
        var Z = c(k, $, U);
        if (Z.type === "normal") {
          if (X = U.done ? "completed" : "suspendedYield", Z.arg === u)
            continue;
          return {
            value: Z.arg,
            done: U.done
          };
        }
        Z.type === "throw" && (X = "completed", U.method = "throw", U.arg = Z.arg);
      }
    };
  }
  function w(k, $) {
    var U = $.method, X = k.iterator[U];
    if (X === void 0)
      return $.delegate = null, U === "throw" && k.iterator.return && ($.method = "return", $.arg = void 0, w(k, $), $.method === "throw") || U !== "return" && ($.method = "throw", $.arg = new TypeError("The iterator does not provide a '" + U + "' method")), u;
    var K = c(X, k.iterator, $.arg);
    if (K.type === "throw")
      return $.method = "throw", $.arg = K.arg, $.delegate = null, u;
    var z = K.arg;
    return z ? z.done ? ($[k.resultName] = z.value, $.next = k.nextLoc, $.method !== "return" && ($.method = "next", $.arg = void 0), $.delegate = null, u) : z : ($.method = "throw", $.arg = new TypeError("iterator result is not an object"), $.delegate = null, u);
  }
  function R(k) {
    var $ = {
      tryLoc: k[0]
    };
    1 in k && ($.catchLoc = k[1]), 2 in k && ($.finallyLoc = k[2], $.afterLoc = k[3]), this.tryEntries.push($);
  }
  function M(k) {
    var $ = k.completion || {};
    $.type = "normal", delete $.arg, k.completion = $;
  }
  function O(k) {
    this.tryEntries = [{
      tryLoc: "root"
    }], k.forEach(R, this), this.reset(!0);
  }
  function L(k) {
    if (k) {
      var $ = k[o];
      if ($)
        return $.call(k);
      if (typeof k.next == "function")
        return k;
      if (!isNaN(k.length)) {
        var U = -1, X = function K() {
          for (; ++U < k.length; )
            if (n.call(k, U))
              return K.value = k[U], K.done = !1, K;
          return K.value = void 0, K.done = !0, K;
        };
        return X.next = X;
      }
    }
    return {
      next: N
    };
  }
  function N() {
    return {
      value: void 0,
      done: !0
    };
  }
  return h.prototype = d, r(y, "constructor", {
    value: d,
    configurable: !0
  }), r(d, "constructor", {
    value: h,
    configurable: !0
  }), h.displayName = A(d, a, "GeneratorFunction"), t.isGeneratorFunction = function(k) {
    var $ = typeof k == "function" && k.constructor;
    return !!$ && ($ === h || ($.displayName || $.name) === "GeneratorFunction");
  }, t.mark = function(k) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(k, d) : (k.__proto__ = d, A(k, a, "GeneratorFunction")), k.prototype = Object.create(y), k;
  }, t.awrap = function(k) {
    return {
      __await: k
    };
  }, v(b.prototype), A(b.prototype, s, function() {
    return this;
  }), t.AsyncIterator = b, t.async = function(k, $, U, X, K) {
    K === void 0 && (K = Promise);
    var z = new b(l(k, $, U, X), K);
    return t.isGeneratorFunction($) ? z : z.next().then(function(Y) {
      return Y.done ? Y.value : z.next();
    });
  }, v(y), A(y, a, "Generator"), A(y, o, function() {
    return this;
  }), A(y, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(k) {
    var $ = Object(k), U = [];
    for (var X in $)
      U.push(X);
    return U.reverse(), function K() {
      for (; U.length; ) {
        var z = U.pop();
        if (z in $)
          return K.value = z, K.done = !1, K;
      }
      return K.done = !0, K;
    };
  }, t.values = L, O.prototype = {
    constructor: O,
    reset: function($) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(M), !$)
        for (var U in this)
          U.charAt(0) === "t" && n.call(this, U) && !isNaN(+U.slice(1)) && (this[U] = void 0);
    },
    stop: function() {
      this.done = !0;
      var $ = this.tryEntries[0].completion;
      if ($.type === "throw")
        throw $.arg;
      return this.rval;
    },
    dispatchException: function($) {
      if (this.done)
        throw $;
      var U = this;
      function X(ce, ee) {
        return Y.type = "throw", Y.arg = $, U.next = ce, ee && (U.method = "next", U.arg = void 0), !!ee;
      }
      for (var K = this.tryEntries.length - 1; K >= 0; --K) {
        var z = this.tryEntries[K], Y = z.completion;
        if (z.tryLoc === "root")
          return X("end");
        if (z.tryLoc <= this.prev) {
          var V = n.call(z, "catchLoc"), Z = n.call(z, "finallyLoc");
          if (V && Z) {
            if (this.prev < z.catchLoc)
              return X(z.catchLoc, !0);
            if (this.prev < z.finallyLoc)
              return X(z.finallyLoc);
          } else if (V) {
            if (this.prev < z.catchLoc)
              return X(z.catchLoc, !0);
          } else {
            if (!Z)
              throw new Error("try statement without catch or finally");
            if (this.prev < z.finallyLoc)
              return X(z.finallyLoc);
          }
        }
      }
    },
    abrupt: function($, U) {
      for (var X = this.tryEntries.length - 1; X >= 0; --X) {
        var K = this.tryEntries[X];
        if (K.tryLoc <= this.prev && n.call(K, "finallyLoc") && this.prev < K.finallyLoc) {
          var z = K;
          break;
        }
      }
      z && ($ === "break" || $ === "continue") && z.tryLoc <= U && U <= z.finallyLoc && (z = null);
      var Y = z ? z.completion : {};
      return Y.type = $, Y.arg = U, z ? (this.method = "next", this.next = z.finallyLoc, u) : this.complete(Y);
    },
    complete: function($, U) {
      if ($.type === "throw")
        throw $.arg;
      return $.type === "break" || $.type === "continue" ? this.next = $.arg : $.type === "return" ? (this.rval = this.arg = $.arg, this.method = "return", this.next = "end") : $.type === "normal" && U && (this.next = U), u;
    },
    finish: function($) {
      for (var U = this.tryEntries.length - 1; U >= 0; --U) {
        var X = this.tryEntries[U];
        if (X.finallyLoc === $)
          return this.complete(X.completion, X.afterLoc), M(X), u;
      }
    },
    catch: function($) {
      for (var U = this.tryEntries.length - 1; U >= 0; --U) {
        var X = this.tryEntries[U];
        if (X.tryLoc === $) {
          var K = X.completion;
          if (K.type === "throw") {
            var z = K.arg;
            M(X);
          }
          return z;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function($, U, X) {
      return this.delegate = {
        iterator: L($),
        resultName: U,
        nextLoc: X
      }, this.method === "next" && (this.arg = void 0), u;
    }
  }, t;
}
function t1e(t, e, n, r, i, o, s) {
  try {
    var a = t[o](s), A = a.value;
  } catch (l) {
    n(l);
    return;
  }
  a.done ? e(A) : Promise.resolve(A).then(r, i);
}
function g9t(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(r, i) {
      var o = t.apply(e, n);
      function s(A) {
        t1e(o, r, i, s, a, "next", A);
      }
      function a(A) {
        t1e(o, r, i, s, a, "throw", A);
      }
      s(void 0);
    });
  };
}
var n1e = ["measure", "alignPre", "align", null, "motion"];
const h9t = function(t, e) {
  var n = ID(null), r = AA(n, 2), i = r[0], o = r[1], s = Zr();
  function a(c) {
    o(c, !0);
  }
  function A() {
    mI.cancel(s.current);
  }
  function l(c) {
    A(), s.current = mI(function() {
      a(function(u) {
        switch (i) {
          case "align":
            return "motion";
          case "motion":
            return "stable";
        }
        return u;
      }), c?.();
    });
  }
  return Mn(function() {
    a("measure");
  }, [t]), Mn(function() {
    switch (i) {
      case "measure":
        e();
        break;
    }
    i && (s.current = mI(/* @__PURE__ */ g9t(/* @__PURE__ */ Cee().mark(function c() {
      var u, f;
      return Cee().wrap(function(d) {
        for (; ; )
          switch (d.prev = d.next) {
            case 0:
              u = n1e.indexOf(i), f = n1e[u + 1], f && u !== -1 && a(f);
            case 3:
            case "end":
              return d.stop();
          }
      }, c);
    }))));
  }, [i]), Mn(function() {
    return function() {
      A();
    };
  }, []), [i, l];
}, d9t = function(t) {
  var e = le.useState({
    width: 0,
    height: 0
  }), n = AA(e, 2), r = n[0], i = n[1];
  function o(a) {
    i({
      width: a.offsetWidth,
      height: a.offsetHeight
    });
  }
  var s = le.useMemo(function() {
    var a = {};
    if (t) {
      var A = r.width, l = r.height;
      t.indexOf("height") !== -1 && l ? a.height = l : t.indexOf("minHeight") !== -1 && l && (a.minHeight = l), t.indexOf("width") !== -1 && A ? a.width = A : t.indexOf("minWidth") !== -1 && A && (a.minWidth = A);
    }
    return a;
  }, [t, r]);
  return [s, o];
};
var tHe = /* @__PURE__ */ le.forwardRef(function(t, e) {
  var n = t.visible, r = t.prefixCls, i = t.className, o = t.style, s = t.children, a = t.zIndex, A = t.stretch, l = t.destroyPopupOnHide, c = t.forceRender, u = t.align, f = t.point, h = t.getRootDomNode, d = t.getClassNameFromAlign, I = t.onAlign, m = t.onMouseEnter, C = t.onMouseLeave, y = t.onMouseDown, v = t.onTouchStart, b = t.onClick, Q = Zr(), w = Zr(), R = mn(), M = AA(R, 2), O = M[0], L = M[1], N = d9t(A), k = AA(N, 2), $ = k[0], U = k[1];
  function X() {
    A && U(h());
  }
  var K = h9t(n, X), z = AA(K, 2), Y = z[0], V = z[1], Z = mn(0), ce = AA(Z, 2), ee = ce[0], pe = ce[1], Ce = Zr();
  e1e(function() {
    Y === "alignPre" && pe(0);
  }, [Y]);
  function Be() {
    return f || h;
  }
  function Ie() {
    var se;
    (se = Q.current) === null || se === void 0 || se.forceAlign();
  }
  function Qe(se, fe) {
    var W = d(fe);
    O !== W && L(W), pe(function(ge) {
      return ge + 1;
    }), Y === "align" && I?.(se, fe);
  }
  e1e(function() {
    Y === "align" && (ee < 2 ? Ie() : V(function() {
      var se;
      (se = Ce.current) === null || se === void 0 || se.call(Ce);
    }));
  }, [ee]);
  var xe = Ds({}, G6e(t));
  ["onAppearEnd", "onEnterEnd", "onLeaveEnd"].forEach(function(se) {
    var fe = xe[se];
    xe[se] = function(W, ge) {
      return V(), fe?.(W, ge);
    };
  });
  function Se() {
    return new Promise(function(se) {
      Ce.current = se;
    });
  }
  le.useEffect(function() {
    !xe.motionName && Y === "motion" && V();
  }, [xe.motionName, Y]), le.useImperativeHandle(e, function() {
    return {
      forceAlign: Ie,
      getElement: function() {
        return w.current;
      }
    };
  });
  var De = Ds(Ds({}, $), {}, {
    zIndex: a,
    opacity: Y === "motion" || Y === "stable" || !n ? void 0 : 0,
    // Cannot interact with disappearing elements
    // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
    pointerEvents: !n && Y !== "stable" ? "none" : void 0
  }, o), Ue = !0;
  u?.points && (Y === "align" || Y === "stable") && (Ue = !1);
  var Te = s;
  return le.Children.count(s) > 1 && (Te = /* @__PURE__ */ le.createElement("div", {
    className: "".concat(r, "-content")
  }, s)), /* @__PURE__ */ le.createElement(MAe, Ns({
    visible: n,
    ref: w,
    leavedClassName: "".concat(r, "-hidden")
  }, xe, {
    onAppearPrepare: Se,
    onEnterPrepare: Se,
    removeOnLeave: l,
    forceRender: c
  }), function(se, fe) {
    var W = se.className, ge = se.style, _e = Gl(r, i, O, W);
    return /* @__PURE__ */ le.createElement(eHe, {
      target: Be(),
      key: "popup",
      ref: Q,
      monitorWindowResize: !0,
      disabled: Ue,
      align: u,
      onAlign: Qe
    }, /* @__PURE__ */ le.createElement("div", {
      ref: fe,
      className: _e,
      onMouseEnter: m,
      onMouseLeave: C,
      onMouseDownCapture: y,
      onTouchStartCapture: v,
      onClick: b,
      style: Ds(Ds({}, ge), De)
    }, Te));
  });
});
tHe.displayName = "PopupInner";
var nHe = /* @__PURE__ */ le.forwardRef(function(t, e) {
  var n = t.prefixCls, r = t.visible, i = t.zIndex, o = t.children, s = t.mobile;
  s = s === void 0 ? {} : s;
  var a = s.popupClassName, A = s.popupStyle, l = s.popupMotion, c = l === void 0 ? {} : l, u = s.popupRender, f = t.onClick, h = le.useRef();
  le.useImperativeHandle(e, function() {
    return {
      forceAlign: function() {
      },
      getElement: function() {
        return h.current;
      }
    };
  });
  var d = Ds({
    zIndex: i
  }, A), I = o;
  return le.Children.count(o) > 1 && (I = /* @__PURE__ */ le.createElement("div", {
    className: "".concat(n, "-content")
  }, o)), u && (I = u(I)), /* @__PURE__ */ le.createElement(MAe, Ns({
    visible: r,
    ref: h,
    removeOnLeave: !0
  }, c), function(m, C) {
    var y = m.className, v = m.style, b = Gl(n, a, y);
    return /* @__PURE__ */ le.createElement("div", {
      ref: C,
      className: b,
      onClick: f,
      style: Ds(Ds({}, v), d)
    }, I);
  });
});
nHe.displayName = "MobilePopupInner";
var p9t = ["visible", "mobile"], rHe = /* @__PURE__ */ le.forwardRef(function(t, e) {
  var n = t.visible, r = t.mobile, i = rHt(t, p9t), o = mn(n), s = AA(o, 2), a = s[0], A = s[1], l = mn(!1), c = AA(l, 2), u = c[0], f = c[1], h = Ds(Ds({}, i), {}, {
    visible: a
  });
  Mn(function() {
    A(n), n && r && f(iHt());
  }, [n, r]);
  var d = u ? /* @__PURE__ */ le.createElement(nHe, Ns({}, h, {
    mobile: r,
    ref: e
  })) : /* @__PURE__ */ le.createElement(tHe, Ns({}, h, {
    ref: e
  }));
  return /* @__PURE__ */ le.createElement("div", null, /* @__PURE__ */ le.createElement(pHt, h), d);
});
rHe.displayName = "Popup";
var r1e = /* @__PURE__ */ le.createContext(null);
function P7() {
}
function I9t() {
  return "";
}
function m9t(t) {
  return t ? t.ownerDocument : window.document;
}
var C9t = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "onContextMenu"];
function E9t(t) {
  var e = /* @__PURE__ */ function(n) {
    b6e(i, n);
    var r = _6e(i);
    function i(o) {
      var s;
      B6e(this, i), s = r.call(this, o), s.popupRef = /* @__PURE__ */ le.createRef(), s.triggerRef = /* @__PURE__ */ le.createRef(), s.portalContainer = void 0, s.attachId = void 0, s.clickOutsideHandler = void 0, s.touchOutsideHandler = void 0, s.contextMenuOutsideHandler1 = void 0, s.contextMenuOutsideHandler2 = void 0, s.mouseDownTimeout = void 0, s.focusTime = void 0, s.preClickTime = void 0, s.preTouchTime = void 0, s.delayTimer = void 0, s.hasPopupMouseDown = void 0, s.onMouseEnter = function(A) {
        var l = s.props.mouseEnterDelay;
        s.fireEvents("onMouseEnter", A), s.delaySetPopupVisible(!0, l, l ? null : A);
      }, s.onMouseMove = function(A) {
        s.fireEvents("onMouseMove", A), s.setPoint(A);
      }, s.onMouseLeave = function(A) {
        s.fireEvents("onMouseLeave", A), s.delaySetPopupVisible(!1, s.props.mouseLeaveDelay);
      }, s.onPopupMouseEnter = function() {
        s.clearDelayTimer();
      }, s.onPopupMouseLeave = function(A) {
        var l;
        A.relatedTarget && !A.relatedTarget.setTimeout && Ik((l = s.popupRef.current) === null || l === void 0 ? void 0 : l.getElement(), A.relatedTarget) || s.delaySetPopupVisible(!1, s.props.mouseLeaveDelay);
      }, s.onFocus = function(A) {
        s.fireEvents("onFocus", A), s.clearDelayTimer(), s.isFocusToShow() && (s.focusTime = Date.now(), s.delaySetPopupVisible(!0, s.props.focusDelay));
      }, s.onMouseDown = function(A) {
        s.fireEvents("onMouseDown", A), s.preClickTime = Date.now();
      }, s.onTouchStart = function(A) {
        s.fireEvents("onTouchStart", A), s.preTouchTime = Date.now();
      }, s.onBlur = function(A) {
        s.fireEvents("onBlur", A), s.clearDelayTimer(), s.isBlurToHide() && s.delaySetPopupVisible(!1, s.props.blurDelay);
      }, s.onContextMenu = function(A) {
        A.preventDefault(), s.fireEvents("onContextMenu", A), s.setPopupVisible(!0, A);
      }, s.onContextMenuClose = function() {
        s.isContextMenuToShow() && s.close();
      }, s.onClick = function(A) {
        if (s.fireEvents("onClick", A), s.focusTime) {
          var l;
          if (s.preClickTime && s.preTouchTime ? l = Math.min(s.preClickTime, s.preTouchTime) : s.preClickTime ? l = s.preClickTime : s.preTouchTime && (l = s.preTouchTime), Math.abs(l - s.focusTime) < 20)
            return;
          s.focusTime = 0;
        }
        s.preClickTime = 0, s.preTouchTime = 0, s.isClickToShow() && (s.isClickToHide() || s.isBlurToHide()) && A && A.preventDefault && A.preventDefault();
        var c = !s.state.popupVisible;
        (s.isClickToHide() && !c || c && s.isClickToShow()) && s.setPopupVisible(!s.state.popupVisible, A);
      }, s.onPopupMouseDown = function() {
        if (s.hasPopupMouseDown = !0, clearTimeout(s.mouseDownTimeout), s.mouseDownTimeout = window.setTimeout(function() {
          s.hasPopupMouseDown = !1;
        }, 0), s.context) {
          var A;
          (A = s.context).onPopupMouseDown.apply(A, arguments);
        }
      }, s.onDocumentClick = function(A) {
        if (!(s.props.mask && !s.props.maskClosable)) {
          var l = A.target, c = s.getRootDomNode(), u = s.getPopupDomNode();
          // mousedown on the target should also close popup when action is contextMenu.
          // https://github.com/ant-design/ant-design/issues/29853
          (!Ik(c, l) || s.isContextMenuOnly()) && !Ik(u, l) && !s.hasPopupMouseDown && s.close();
        }
      }, s.getRootDomNode = function() {
        var A = s.props.getTriggerDOMNode;
        if (A)
          return A(s.triggerRef.current);
        try {
          var l = x6e(s.triggerRef.current);
          if (l)
            return l;
        } catch {
        }
        return Sf.findDOMNode(C4(s));
      }, s.getPopupClassNameFromAlign = function(A) {
        var l = [], c = s.props, u = c.popupPlacement, f = c.builtinPlacements, h = c.prefixCls, d = c.alignPoint, I = c.getPopupClassNameFromAlign;
        return u && f && l.push(Z6t(f, h, A, d)), I && l.push(I(A)), l.join(" ");
      }, s.getComponent = function() {
        var A = s.props, l = A.prefixCls, c = A.destroyPopupOnHide, u = A.popupClassName, f = A.onPopupAlign, h = A.popupMotion, d = A.popupAnimation, I = A.popupTransitionName, m = A.popupStyle, C = A.mask, y = A.maskAnimation, v = A.maskTransitionName, b = A.maskMotion, Q = A.zIndex, w = A.popup, R = A.stretch, M = A.alignPoint, O = A.mobile, L = A.forceRender, N = A.onPopupClick, k = s.state, $ = k.popupVisible, U = k.point, X = s.getPopupAlign(), K = {};
        return s.isMouseEnterToShow() && (K.onMouseEnter = s.onPopupMouseEnter), s.isMouseLeaveToHide() && (K.onMouseLeave = s.onPopupMouseLeave), K.onMouseDown = s.onPopupMouseDown, K.onTouchStart = s.onPopupMouseDown, /* @__PURE__ */ le.createElement(rHe, Ns({
          prefixCls: l,
          destroyPopupOnHide: c,
          visible: $,
          point: M && U,
          className: u,
          align: X,
          onAlign: f,
          animation: d,
          getClassNameFromAlign: s.getPopupClassNameFromAlign
        }, K, {
          stretch: R,
          getRootDomNode: s.getRootDomNode,
          style: m,
          mask: C,
          zIndex: Q,
          transitionName: I,
          maskAnimation: y,
          maskTransitionName: v,
          maskMotion: b,
          ref: s.popupRef,
          motion: h,
          mobile: O,
          forceRender: L,
          onClick: N
        }), typeof w == "function" ? w() : w);
      }, s.attachParent = function(A) {
        mI.cancel(s.attachId);
        var l = s.props, c = l.getPopupContainer, u = l.getDocument, f = s.getRootDomNode(), h;
        c ? (f || c.length === 0) && (h = c(f)) : h = u(s.getRootDomNode()).body, h ? h.appendChild(A) : s.attachId = mI(function() {
          s.attachParent(A);
        });
      }, s.getContainer = function() {
        if (!s.portalContainer) {
          var A = s.props.getDocument, l = A(s.getRootDomNode()).createElement("div");
          l.style.position = "absolute", l.style.top = "0", l.style.left = "0", l.style.width = "100%", s.portalContainer = l;
        }
        return s.attachParent(s.portalContainer), s.portalContainer;
      }, s.setPoint = function(A) {
        var l = s.props.alignPoint;
        !l || !A || s.setState({
          point: {
            pageX: A.pageX,
            pageY: A.pageY
          }
        });
      }, s.handlePortalUpdate = function() {
        s.state.prevPopupVisible !== s.state.popupVisible && s.props.afterPopupVisibleChange(s.state.popupVisible);
      }, s.triggerContextValue = {
        onPopupMouseDown: s.onPopupMouseDown
      };
      var a;
      return "popupVisible" in o ? a = !!o.popupVisible : a = !!o.defaultPopupVisible, s.state = {
        prevPopupVisible: a,
        popupVisible: a
      }, C9t.forEach(function(A) {
        s["fire".concat(A)] = function(l) {
          s.fireEvents(A, l);
        };
      }), s;
    }
    return oH(i, [{
      key: "componentDidMount",
      value: function() {
        this.componentDidUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        var s = this.props, a = this.state;
        if (a.popupVisible) {
          var A;
          !this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow()) && (A = s.getDocument(this.getRootDomNode()), this.clickOutsideHandler = mR(A, "mousedown", this.onDocumentClick)), this.touchOutsideHandler || (A = A || s.getDocument(this.getRootDomNode()), this.touchOutsideHandler = mR(A, "touchstart", this.onDocumentClick)), !this.contextMenuOutsideHandler1 && this.isContextMenuToShow() && (A = A || s.getDocument(this.getRootDomNode()), this.contextMenuOutsideHandler1 = mR(A, "scroll", this.onContextMenuClose)), !this.contextMenuOutsideHandler2 && this.isContextMenuToShow() && (this.contextMenuOutsideHandler2 = mR(window, "blur", this.onContextMenuClose));
          return;
        }
        this.clearOutsideHandler();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.clearDelayTimer(), this.clearOutsideHandler(), clearTimeout(this.mouseDownTimeout), mI.cancel(this.attachId);
      }
    }, {
      key: "getPopupDomNode",
      value: function() {
        var s;
        return ((s = this.popupRef.current) === null || s === void 0 ? void 0 : s.getElement()) || null;
      }
    }, {
      key: "getPopupAlign",
      value: function() {
        var s = this.props, a = s.popupPlacement, A = s.popupAlign, l = s.builtinPlacements;
        return a && l ? X6t(l, a, A) : A;
      }
    }, {
      key: "setPopupVisible",
      value: (
        /**
         * @param popupVisible    Show or not the popup element
         * @param event           SyntheticEvent, used for `pointAlign`
         */
        function(s, a) {
          var A = this.props.alignPoint, l = this.state.popupVisible;
          this.clearDelayTimer(), l !== s && ("popupVisible" in this.props || this.setState({
            popupVisible: s,
            prevPopupVisible: l
          }), this.props.onPopupVisibleChange(s)), A && a && s && this.setPoint(a);
        }
      )
    }, {
      key: "delaySetPopupVisible",
      value: function(s, a, A) {
        var l = this, c = a * 1e3;
        if (this.clearDelayTimer(), c) {
          var u = A ? {
            pageX: A.pageX,
            pageY: A.pageY
          } : null;
          this.delayTimer = window.setTimeout(function() {
            l.setPopupVisible(s, u), l.clearDelayTimer();
          }, c);
        } else
          this.setPopupVisible(s, A);
      }
    }, {
      key: "clearDelayTimer",
      value: function() {
        this.delayTimer && (clearTimeout(this.delayTimer), this.delayTimer = null);
      }
    }, {
      key: "clearOutsideHandler",
      value: function() {
        this.clickOutsideHandler && (this.clickOutsideHandler.remove(), this.clickOutsideHandler = null), this.contextMenuOutsideHandler1 && (this.contextMenuOutsideHandler1.remove(), this.contextMenuOutsideHandler1 = null), this.contextMenuOutsideHandler2 && (this.contextMenuOutsideHandler2.remove(), this.contextMenuOutsideHandler2 = null), this.touchOutsideHandler && (this.touchOutsideHandler.remove(), this.touchOutsideHandler = null);
      }
    }, {
      key: "createTwoChains",
      value: function(s) {
        var a = this.props.children.props, A = this.props;
        return a[s] && A[s] ? this["fire".concat(s)] : a[s] || A[s];
      }
    }, {
      key: "isClickToShow",
      value: function() {
        var s = this.props, a = s.action, A = s.showAction;
        return a.indexOf("click") !== -1 || A.indexOf("click") !== -1;
      }
    }, {
      key: "isContextMenuOnly",
      value: function() {
        var s = this.props.action;
        return s === "contextMenu" || s.length === 1 && s[0] === "contextMenu";
      }
    }, {
      key: "isContextMenuToShow",
      value: function() {
        var s = this.props, a = s.action, A = s.showAction;
        return a.indexOf("contextMenu") !== -1 || A.indexOf("contextMenu") !== -1;
      }
    }, {
      key: "isClickToHide",
      value: function() {
        var s = this.props, a = s.action, A = s.hideAction;
        return a.indexOf("click") !== -1 || A.indexOf("click") !== -1;
      }
    }, {
      key: "isMouseEnterToShow",
      value: function() {
        var s = this.props, a = s.action, A = s.showAction;
        return a.indexOf("hover") !== -1 || A.indexOf("mouseEnter") !== -1;
      }
    }, {
      key: "isMouseLeaveToHide",
      value: function() {
        var s = this.props, a = s.action, A = s.hideAction;
        return a.indexOf("hover") !== -1 || A.indexOf("mouseLeave") !== -1;
      }
    }, {
      key: "isFocusToShow",
      value: function() {
        var s = this.props, a = s.action, A = s.showAction;
        return a.indexOf("focus") !== -1 || A.indexOf("focus") !== -1;
      }
    }, {
      key: "isBlurToHide",
      value: function() {
        var s = this.props, a = s.action, A = s.hideAction;
        return a.indexOf("focus") !== -1 || A.indexOf("blur") !== -1;
      }
    }, {
      key: "forcePopupAlign",
      value: function() {
        if (this.state.popupVisible) {
          var s;
          (s = this.popupRef.current) === null || s === void 0 || s.forceAlign();
        }
      }
    }, {
      key: "fireEvents",
      value: function(s, a) {
        var A = this.props.children.props[s];
        A && A(a);
        var l = this.props[s];
        l && l(a);
      }
    }, {
      key: "close",
      value: function() {
        this.setPopupVisible(!1);
      }
    }, {
      key: "render",
      value: function() {
        var s = this.state.popupVisible, a = this.props, A = a.children, l = a.forceRender, c = a.alignPoint, u = a.className, f = a.autoDestroy, h = le.Children.only(A), d = {
          key: "trigger"
        };
        this.isContextMenuToShow() ? d.onContextMenu = this.onContextMenu : d.onContextMenu = this.createTwoChains("onContextMenu"), this.isClickToHide() || this.isClickToShow() ? (d.onClick = this.onClick, d.onMouseDown = this.onMouseDown, d.onTouchStart = this.onTouchStart) : (d.onClick = this.createTwoChains("onClick"), d.onMouseDown = this.createTwoChains("onMouseDown"), d.onTouchStart = this.createTwoChains("onTouchStart")), this.isMouseEnterToShow() ? (d.onMouseEnter = this.onMouseEnter, c && (d.onMouseMove = this.onMouseMove)) : d.onMouseEnter = this.createTwoChains("onMouseEnter"), this.isMouseLeaveToHide() ? d.onMouseLeave = this.onMouseLeave : d.onMouseLeave = this.createTwoChains("onMouseLeave"), this.isFocusToShow() || this.isBlurToHide() ? (d.onFocus = this.onFocus, d.onBlur = this.onBlur) : (d.onFocus = this.createTwoChains("onFocus"), d.onBlur = this.createTwoChains("onBlur"));
        var I = Gl(h && h.props && h.props.className, u);
        I && (d.className = I);
        var m = Ds({}, d);
        T6e(h) && (m.ref = D6e(this.triggerRef, h.ref));
        var C = /* @__PURE__ */ le.cloneElement(h, m), y;
        return (s || this.popupRef.current || l) && (y = /* @__PURE__ */ le.createElement(t, {
          key: "portal",
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        }, this.getComponent())), !s && f && (y = null), /* @__PURE__ */ le.createElement(r1e.Provider, {
          value: this.triggerContextValue
        }, C, y);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, a) {
        var A = s.popupVisible, l = {};
        return A !== void 0 && a.popupVisible !== A && (l.popupVisible = A, l.prevPopupVisible = a.popupVisible), l;
      }
    }]), i;
  }(le.Component);
  return e.contextType = r1e, e.defaultProps = {
    prefixCls: "rc-trigger-popup",
    getPopupClassNameFromAlign: I9t,
    getDocument: m9t,
    onPopupVisibleChange: P7,
    afterPopupVisibleChange: P7,
    onPopupAlign: P7,
    popupClassName: "",
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: !1,
    popupAlign: {},
    defaultPopupVisible: !1,
    mask: !1,
    maskClosable: !0,
    action: [],
    showAction: [],
    hideAction: [],
    autoDestroy: !1
  }, e;
}
const y9t = E9t(K6t);
var ng = {
  adjustX: 1,
  adjustY: 1
}, rg = [0, 0], v9t = {
  left: {
    points: ["cr", "cl"],
    overflow: ng,
    offset: [-4, 0],
    targetOffset: rg
  },
  right: {
    points: ["cl", "cr"],
    overflow: ng,
    offset: [4, 0],
    targetOffset: rg
  },
  top: {
    points: ["bc", "tc"],
    overflow: ng,
    offset: [0, -4],
    targetOffset: rg
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: ng,
    offset: [0, 4],
    targetOffset: rg
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: ng,
    offset: [0, -4],
    targetOffset: rg
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: ng,
    offset: [-4, 0],
    targetOffset: rg
  },
  topRight: {
    points: ["br", "tr"],
    overflow: ng,
    offset: [0, -4],
    targetOffset: rg
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: ng,
    offset: [4, 0],
    targetOffset: rg
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: ng,
    offset: [0, 4],
    targetOffset: rg
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: ng,
    offset: [4, 0],
    targetOffset: rg
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: ng,
    offset: [0, 4],
    targetOffset: rg
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: ng,
    offset: [-4, 0],
    targetOffset: rg
  }
};
function B9t(t) {
  var e = t.showArrow, n = t.arrowContent, r = t.children, i = t.prefixCls, o = t.id, s = t.overlayInnerStyle, a = t.className, A = t.style;
  return /* @__PURE__ */ le.createElement("div", {
    className: Gl("".concat(i, "-content"), a),
    style: A
  }, e !== !1 && /* @__PURE__ */ le.createElement("div", {
    className: "".concat(i, "-arrow"),
    key: "arrow"
  }, n), /* @__PURE__ */ le.createElement("div", {
    className: "".concat(i, "-inner"),
    id: o,
    role: "tooltip",
    style: s
  }, typeof r == "function" ? r() : r));
}
var b9t = function(e, n) {
  var r = e.overlayClassName, i = e.trigger, o = i === void 0 ? ["hover"] : i, s = e.mouseEnterDelay, a = s === void 0 ? 0 : s, A = e.mouseLeaveDelay, l = A === void 0 ? 0.1 : A, c = e.overlayStyle, u = e.prefixCls, f = u === void 0 ? "rc-tooltip" : u, h = e.children, d = e.onVisibleChange, I = e.afterVisibleChange, m = e.transitionName, C = e.animation, y = e.motion, v = e.placement, b = v === void 0 ? "right" : v, Q = e.align, w = Q === void 0 ? {} : Q, R = e.destroyTooltipOnHide, M = R === void 0 ? !1 : R, O = e.defaultVisible, L = e.getTooltipContainer, N = e.overlayInnerStyle, k = e.arrowContent, $ = e.overlay, U = e.id, X = e.showArrow, K = Rn(e, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"]), z = Zr(null);
  rse(n, function() {
    return z.current;
  });
  var Y = z6t({}, K);
  "visible" in e && (Y.popupVisible = e.visible);
  var V = function() {
    return /* @__PURE__ */ le.createElement(B9t, {
      showArrow: X,
      arrowContent: k,
      key: "content",
      prefixCls: f,
      id: U,
      overlayInnerStyle: N
    }, $);
  }, Z = !1, ce = !1;
  if (typeof M == "boolean")
    Z = M;
  else if (M && rT(M) === "object") {
    var ee = M.keepParent;
    Z = ee === !0, ce = ee === !1;
  }
  return /* @__PURE__ */ le.createElement(y9t, at({
    popupClassName: r,
    prefixCls: f,
    popup: V,
    action: o,
    builtinPlacements: v9t,
    popupPlacement: b,
    ref: z,
    popupAlign: w,
    getPopupContainer: L,
    onPopupVisibleChange: d,
    afterPopupVisibleChange: I,
    popupTransitionName: m,
    popupAnimation: C,
    popupMotion: y,
    defaultPopupVisible: O,
    destroyPopupOnHide: Z,
    autoDestroy: ce,
    mouseLeaveDelay: l,
    popupStyle: c,
    mouseEnterDelay: a
  }, Y), h);
};
const _9t = /* @__PURE__ */ CE(b9t), Sm = 32, $L = kr((t) => ({
  setsManager: {
    position: "relative",
    width: "100%",
    display: "block",
    height: "auto"
  },
  setOperationButtons: {
    backgroundColor: t.palette.grayLight,
    borderRadius: "4px",
    padding: "2px",
    display: "flex",
    flexDirection: "row",
    position: "absolute",
    bottom: "28px",
    right: "4px",
    boxShadow: "-2px -2px 5px rgba(0, 0, 0, 0.06)",
    "& button": {
      cursor: "pointer",
      border: "0",
      backgroundColor: "transparent",
      color: t.palette.grayDarkL5,
      "&[disabled]": {
        pointerEvents: "none",
        "& svg": {
          fill: "silver"
        }
      },
      "& svg": {
        fill: t.palette.grayDark,
        verticalAlign: "top",
        height: "20px",
        marginTop: "1px"
      },
      "&:hover,:hover path": {
        color: t.palette.grayDarkD15,
        fill: t.palette.grayDarkD15
      }
    }
  },
  setsManagerTree: {
    position: "relative",
    top: "0",
    left: "0",
    width: "100%",
    height: "auto",
    display: "block",
    paddingRight: "17px",
    boxSizing: "content-box",
    "@global .rc-tree": {
      paddingLeft: "0",
      margin: "0",
      border: "1px solid transparent"
    },
    "@global .level-0-treenode > .rc-tree-switcher i svg path": {
      fill: t.palette.primaryForegroundL5
    },
    "@global .rc-tree-focused:not(.rc-tree-active-focused)": {
      borderColor: "cyan"
    },
    "@global .rc-tree-treenode": {
      margin: "0",
      padding: "0",
      lineHeight: `${Sm - 8}px`,
      whiteSpace: "nowrap",
      listStyle: "none",
      outline: "0"
    },
    "@global .rc-tree-treenode .draggable": {
      color: "#333",
      userSelect: "none",
      /* Required to make elements draggable in old WebKit */
      "-khtml-user-drag": "element",
      "-webkit-user-drag": "element",
      border: "2px transparent solid"
    },
    "@global .rc-tree-treenode.drag-over > .draggable": {
      color: "white",
      backgroundColor: "#316ac5",
      border: "2px #316ac5 solid",
      opacity: "0.8"
    },
    "@global .rc-tree-treenode.drag-over-gap-top > .draggable": {
      borderTop: "2px blue solid"
    },
    "@global .rc-tree-treenode.drag-over-gap-bottom > .draggable": {
      borderBottom: "2px blue solid"
    },
    "@global .rc-tree-treenode.filter-node > .rc-tree-node-content-wrapper": {
      color: "#a60000 !important",
      fontWeight: "bold !important"
    },
    "@global .rc-tree-treenode ul": {
      margin: "0",
      paddingLeft: "35px"
    },
    "@global .rc-tree-treenode .rc-tree-node-content-wrapper": {
      width: "calc(100% - 20px)",
      display: "inline-block",
      margin: "0",
      padding: "0",
      textDecoration: "none",
      verticalAlign: "top",
      cursor: "pointer",
      position: "relative"
    },
    "@global .rc-tree-treenode .rc-tree-node-content-wrapper > span": {
      position: "relative",
      width: "100%",
      display: "inline-block"
    },
    "@global .rc-tree-treenode .rc-tree-node-content-wrapper > span .title-button": {
      position: "relative",
      /* To accomodate the checkbox and node menu button. */
      maxWidth: "calc(100% - 45px)",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    "@global .rc-tree-treenode .rc-tree-node-content-wrapper > span .node-menu-icon": {
      position: "relative",
      left: "0"
    },
    "@global .rc-tree-treenode span.rc-tree-switcher, .rc-tree-treenode span.rc-tree-checkbox": {
      display: "inline-block",
      marginTop: "4px",
      marginRight: "6px",
      verticalAlign: "middle",
      backgroundColor: "transparent",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "scroll",
      border: "0 none",
      outline: "none",
      cursor: "pointer"
    },
    "@global .rc-tree-treenode span.rc-tree-switcher svg": {
      width: "15px",
      height: "15px"
    },
    "@global .rc-tree-treenode span.rc-tree-switcher.rc-tree-switcher-noop": {
      cursor: "auto"
    },
    "@global .rc-tree-treenode span.rc-tree-switcher.rc-tree-switcher_close": {
      transform: "rotate(-90deg)"
    },
    "@global .rc-tree-treenode span.rc-tree-checkbox": {
      width: "13px",
      height: "13px",
      margin: "0 3px",
      border: `2px solid ${t.palette.grayMid}`,
      borderRadius: "3px",
      position: "relative",
      left: "0",
      marginRight: "10px"
    },
    "@global .rc-tree-treenode span.rc-tree-checkbox-checked": {
      backgroundColor: t.palette.grayMid
    },
    "@global .rc-tree-treenode span.rc-tree-checkbox-indeterminate": {
      backgroundPosition: "-14px -28px"
    },
    "@global .rc-tree-treenode span.rc-tree-checkbox-disabled": {
      backgroundPosition: "0 -56px"
    },
    "@global .rc-tree-treenode span.rc-tree-checkbox.rc-tree-checkbox-checked.rc-tree-checkbox-disabled": {
      backgroundPosition: "-14px -56px"
    },
    "@global .rc-tree-treenode span.rc-tree-checkbox.rc-tree-checkbox-indeterminate.rc-tree-checkbox-disabled": {
      position: "relative",
      background: "#ccc",
      borderRadius: "3px"
    },
    "@global .rc-tree-treenode span.rc-tree-checkbox.rc-tree-checkbox-indeterminate.rc-tree-checkbox-disabled::after": {
      position: "absolute",
      top: "5px",
      left: "3px",
      width: "5px",
      height: "0",
      border: "2px solid #fff",
      borderTop: "0",
      borderLeft: "0",
      transform: "scale(1)",
      content: "' '"
    },
    "@global .rc-tree:not(.rc-tree-show-line) .rc-treenode .rc-tree-switcher-noop": {
      background: "none"
    },
    "@global .rc-tree.rc-tree-show-line .rc-tree-treenode:not(:last-child) > .rc-tree-switcher-noop": {
      backgroundPosition: "-56px -18px"
    },
    "@global .rc-tree.rc-tree-show-line .rc-tree-treenode:last-child > .rc-tree-switcher-noop": {
      backgroundPosition: "-56px -36px"
    },
    "@global .rc-tree-child-tree": {
      display: "none"
    },
    "@global .rc-tree-child-tree-open": {
      display: "block"
    },
    "@global .rc-tree-treenode-disabled > span:not(.rc-tree-switcher), .rc-tree-treenode-disabled > a, .rc-tree-treenode-disabled > a span": {
      color: "#767676",
      cursor: "not-allowed"
    },
    "@global .rc-tree-treenode-active": {
      background: "rgba(0, 0, 0, 0.1)"
    },
    "@global .rc-tree-node-selected": {
      backgroundColor: "#ffe6b0",
      border: "1px #ffb951 solid",
      opacity: "0.8"
    },
    "@global .rc-tree-indent-unit": {
      display: "inline-block",
      paddingLeft: "18px"
    }
  },
  plusButton: {
    border: "0",
    backgroundColor: "transparent",
    color: t.palette.primaryForegroundL5,
    padding: "0",
    fontSize: "18px",
    marginBottom: "32px",
    cursor: "pointer"
  },
  nodeMenuIcon: {
    fill: t.palette.grayMid,
    cursor: "pointer",
    // Important needed due to Jupyter Notebook conflicting styles
    height: "14px !important",
    position: "relative",
    verticalAlign: "top",
    width: `${Sm}px`,
    top: "5.5px",
    "&:hover": {
      fill: t.palette.grayMidL10
    }
  },
  nodeSizeLabel: {
    fontSize: "12px",
    color: t.palette.primaryForegroundD15
  },
  levelButtonsContainer: {
    height: "20px",
    width: "100%",
    position: "relative",
    paddingLeft: "4px",
    left: "0"
  },
  levelRadioButton: {
    cursor: "pointer",
    appearance: "none",
    /* create custom radiobutton appearance */
    width: "12px",
    height: "12px",
    // Important needed due to Jupyter Notebook conflicting styles
    padding: "5px !important",
    /* background-color only for content */
    backgroundClip: "content-box",
    border: `2px solid ${t.palette.primaryForegroundL10}`,
    backgroundColor: t.palette.primaryForegroundL10,
    borderRadius: "6px",
    position: "relative",
    top: "3px",
    left: "0px",
    float: "left",
    marginRight: "10px",
    "&:checked": {
      backgroundClip: "unset"
    }
  },
  levelRadioButtonChecked: {
    backgroundClip: "unset"
  },
  titleButton: {
    padding: 0,
    margin: 0,
    height: `${Sm - 8}px`,
    lineHeight: `${Sm - 8}px`,
    border: "1px solid transparent",
    color: t.palette.primaryForegroundL5,
    background: "transparent",
    backgroundColor: "transparent",
    verticalAlign: "top",
    fontSize: "14px",
    cursor: "pointer"
  },
  titleButtonWithInput: {
    padding: 0,
    margin: 0,
    display: "block",
    height: `${Sm - 6}px`,
    boxSizing: "border-box"
  },
  titleInput: {
    fontSize: "14px",
    height: `${Sm - 8}px`,
    lineHeight: `${Sm - 8}px`,
    width: "calc(100% - 60px)",
    marginRight: "10px",
    backgroundColor: t.palette.grayLight,
    color: t.palette.black,
    borderRadius: "4px",
    outline: "none",
    padding: " 4px 0px 4px 4px",
    border: `1px solid ${t.palette.grayLight}`,
    "& :focus": {
      border: `1px solid ${t.palette.primaryForegroundActive}`
    }
  },
  titleSaveButton: {
    backgroundColor: t.palette.grayDark,
    border: `1px solid ${t.palette.grayDark}`,
    color: t.palette.grayLight,
    borderRadius: "3px",
    width: "50px",
    height: `${Sm - 8}px`,
    lineHeight: "20px",
    fontSize: "13px",
    verticalAlign: "top",
    margin: 0,
    padding: 0,
    "&:hover": {
      backgroundColor: t.palette.grayDarkL5,
      border: `1px solid ${t.palette.grayDarkL5}`
    }
  },
  // TODO(monorepo): is this style used anywhere?
  "@global .vitessce-tooltip .ant-tooltip-content .ant-tooltip-inner": {
    fontSize: "12px",
    backgroundColor: "rgba(0, 0, 0, 0.95)"
  }
})), i1e = {
  boxSizing: "border-box",
  margin: "0",
  padding: "0",
  color: "rgba(0, 0, 0, 0.65)",
  fontSize: "14px",
  listStyle: "none",
  position: "absolute"
}, UAe = kr((t) => ({
  helpTooltip: {
    zIndex: 1060,
    display: "block",
    maxWidth: "250px",
    visibility: "visible",
    paddingTop: "8px",
    ...i1e,
    "@global .rc-tooltip-inner": {
      fontSize: "10px",
      minWidth: "30px",
      padding: "6px 8px",
      color: "#fff",
      textAlign: "left",
      textDecoration: "none",
      wordWrap: "break-word",
      backgroundColor: "rgba(0, 0, 0, 0.9)",
      borderRadius: "2px",
      boxShadow: "0 3px 6px -4px rgba(100, 100, 100, 0.12), 0 6px 16px 0 rgba(100, 100, 100, 0.08), 0 9px 28px 8px rgba(100, 100, 100, 0.05)"
    },
    "@global .rc-tooltip-arrow": {
      display: "none"
    }
  },
  popover: {
    top: 0,
    left: 0,
    zIndex: 1030,
    fontWeight: "normal",
    whiteSpace: "normal",
    textAlign: "left",
    cursor: "auto",
    userSelect: "text",
    paddingBottom: "10px",
    "&.rc-tooltip-placement-top": {
      paddingBottom: "10px"
    },
    "&.rc-tooltip-placement-right": {
      paddingLeft: "10px"
    },
    "&.rc-tooltip-placement-bottom": {
      paddingTop: "10px"
    },
    "&.rc-tooltip-placement-left": {
      paddingRight: "10px"
    },
    "&.rc-tooltip-placement-top > .rc-tooltip-content > .rc-tooltip-arrow": {
      bottom: "6px",
      borderTopColor: "transparent",
      borderRightColor: "#fff",
      borderBottomColor: "#fff",
      borderLeftColor: "transparent",
      boxShadow: "3px 3px 7px rgba(0, 0, 0, 0.07)",
      left: "50%;",
      transform: "translateX(-50%) rotate(45deg)"
    },
    "&.rc-tooltip-placement-right > .rc-tooltip-content > .rc-tooltip-arrow": {
      left: "6px",
      borderTopColor: "transparent",
      borderRightColor: "transparent",
      borderBottomColor: "#fff",
      borderLeftColor: "#fff",
      boxShadow: "-3px 3px 7px rgba(0, 0, 0, 0.07)",
      top: "50%",
      transform: "translateY(-50%) rotate(45deg)"
    },
    "&.rc-tooltip-placement-bottom > .rc-tooltip-content > .rc-tooltip-arrow": {
      top: "6px",
      borderTopColor: "#fff",
      borderRightColor: "transparent",
      borderBottomColor: "transparent",
      borderLeftColor: "#fff",
      boxShadow: "-2px -2px 5px rgba(0, 0, 0, 0.06)",
      left: "50%",
      transform: "translateX(-50%) rotate(45deg)"
    },
    "&.rc-tooltip-placement-left > .rc-tooltip-content > .rc-tooltip-arrow": {
      right: "6px",
      borderTopColor: "#fff",
      borderRightColor: "#fff",
      borderBottomColor: "transparent",
      borderLeftColor: "transparent",
      boxShadow: "3px -3px 7px rgba(0, 0, 0, 0.07)",
      top: "50%",
      transform: "translateY(-50%) rotate(45deg)"
    },
    ...i1e,
    "& ::after": {
      position: "absolute",
      background: "rgba(255, 255, 255, 0.01)",
      content: "''"
    },
    "@global .rc-tooltip-inner": {
      boxSizing: "border-box",
      backgroundColor: t.palette.white,
      backgroundClip: "padding-box",
      borderRadius: "2px",
      boxShadow: "0 3px 6px -4px rgba(100, 100, 100, 0.12), 0 6px 16px 0 rgba(100, 100, 100, 0.08), 0 9px 28px 8px rgba(100, 100, 100, 0.05)"
    },
    "@global .rc-tooltip-content": {
      padding: 0
    },
    "@global .rc-tooltip-inner-content": {
      padding: "12px 16px",
      color: "rgba(0, 0, 0, 0.65)"
    },
    "@global .rc-tooltip-arrow": {
      position: "absolute",
      display: "block",
      width: "8px",
      height: "8px",
      background: "transparent",
      borderStyle: "solid",
      borderWidth: "4px"
    }
  },
  popoverMenuList: {
    listStyleType: "none",
    padding: 0,
    marginBottom: 0,
    marginTop: 0,
    "& dl, ol, ul": {
      marginTop: 0,
      marginBottom: "16px"
    },
    "& li button": {
      border: 0,
      padding: "4px 16px",
      cursor: "pointer",
      width: "100%",
      backgroundColor: "transparent",
      color: t.palette.grayDarkD15,
      borderRadius: "2px",
      "&:hover": {
        backgroundColor: t.palette.grayLightL10
      }
    },
    "& li:not(:last-child)": {
      borderBottom: `1px solid ${t.palette.grayMid}`
    },
    "& button": {
      appearance: "button",
      textTransform: "none",
      overflow: "visible",
      margin: 0,
      fontFamily: "inherit",
      fontSize: "14px",
      lineHeight: "inherit",
      borderRadius: 0
    }
  },
  small: {
    fontSize: "11px"
  },
  popoverMenuColor: {
    boxShadow: "none !important",
    margin: "0 auto",
    /* Sets margins around color picker and centers */
    "& > div:nth-child(3)": {
      padding: "6px !important",
      transform: "translate(2px, 0)"
    },
    "& > div > div:nth-of-type(1)": {
      fontSize: "12px",
      width: "20px !important"
    },
    "& input": {
      width: "60px !important",
      fontSize: "12px"
    },
    /* Sets smaller color squares */
    "& > div > span > div": {
      width: "18px !important",
      height: "18px !important"
    }
  }
}));
function P9(t) {
  const { title: e, content: n, overlayClassName: r } = t, i = Zr(), o = jae(i), s = e || n, a = UAe();
  return ne.jsxs(ne.Fragment, { children: [ne.jsx("span", { ref: i }), ne.jsx(_9t, { ...t, getTooltipContainer: o, overlayClassName: a[r], overlay: s })] });
}
P9.defaultProps = {
  overlayClassName: "helpTooltip",
  placement: "top",
  trigger: "hover",
  mouseEnterDelay: 0.2,
  mouseLeaveDelay: 0,
  destroyTooltipOnHide: !0
};
var S9t = Object.defineProperty, Q9t = (t, e, n) => e in t ? S9t(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, gg = (t, e, n) => (Q9t(t, typeof e != "symbol" ? e + "" : e, n), n), PF = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function w9t(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var hg = { exports: {} }, k7, o1e;
function x9t() {
  if (o1e)
    return k7;
  o1e = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return k7 = t, k7;
}
var G7, s1e;
function R9t() {
  if (s1e)
    return G7;
  s1e = 1;
  var t = x9t();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, G7 = function() {
    function r(s, a, A, l, c, u) {
      if (u !== t) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return o.PropTypes = o, o;
  }, G7;
}
hg.exports = R9t()();
var Cg = {}, qL = {}, D9t = typeof PF == "object" && PF && PF.Object === Object && PF, iHe = D9t, T9t = iHe, N9t = typeof self == "object" && self && self.Object === Object && self, L9t = T9t || N9t || Function("return this")(), xd = L9t, M9t = xd, O9t = M9t.Symbol, jL = O9t, a1e = jL, oHe = Object.prototype, F9t = oHe.hasOwnProperty, P9t = oHe.toString, n2 = a1e ? a1e.toStringTag : void 0;
function k9t(t) {
  var e = F9t.call(t, n2), n = t[n2];
  try {
    t[n2] = void 0;
    var r = !0;
  } catch {
  }
  var i = P9t.call(t);
  return r && (e ? t[n2] = n : delete t[n2]), i;
}
var G9t = k9t, U9t = Object.prototype, H9t = U9t.toString;
function $9t(t) {
  return H9t.call(t);
}
var q9t = $9t, A1e = jL, j9t = G9t, Y9t = q9t, z9t = "[object Null]", V9t = "[object Undefined]", l1e = A1e ? A1e.toStringTag : void 0;
function J9t(t) {
  return t == null ? t === void 0 ? V9t : z9t : l1e && l1e in Object(t) ? j9t(t) : Y9t(t);
}
var XB = J9t, K9t = Array.isArray, Yf = K9t;
function W9t(t) {
  return t != null && typeof t == "object";
}
var A0 = W9t, X9t = XB, Z9t = Yf, e$t = A0, t$t = "[object String]";
function n$t(t) {
  return typeof t == "string" || !Z9t(t) && e$t(t) && X9t(t) == t$t;
}
var r$t = n$t;
function i$t(t) {
  return function(e, n, r) {
    for (var i = -1, o = Object(e), s = r(e), a = s.length; a--; ) {
      var A = s[t ? a : ++i];
      if (n(o[A], A, o) === !1)
        break;
    }
    return e;
  };
}
var o$t = i$t, s$t = o$t, a$t = s$t(), sHe = a$t;
function A$t(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var l$t = A$t, c$t = XB, u$t = A0, f$t = "[object Arguments]";
function g$t(t) {
  return u$t(t) && c$t(t) == f$t;
}
var h$t = g$t, c1e = h$t, d$t = A0, aHe = Object.prototype, p$t = aHe.hasOwnProperty, I$t = aHe.propertyIsEnumerable, m$t = c1e(function() {
  return arguments;
}()) ? c1e : function(t) {
  return d$t(t) && p$t.call(t, "callee") && !I$t.call(t, "callee");
}, HAe = m$t, FS = { exports: {} };
function C$t() {
  return !1;
}
var E$t = C$t;
(function(t, e) {
  var n = xd, r = E$t, i = e && !e.nodeType && e, o = i && !0 && t && !t.nodeType && t, s = o && o.exports === i, a = s ? n.Buffer : void 0, A = a ? a.isBuffer : void 0, l = A || r;
  t.exports = l;
})(FS, FS.exports);
var y$t = 9007199254740991, v$t = /^(?:0|[1-9]\d*)$/;
function B$t(t, e) {
  var n = typeof t;
  return e = e ?? y$t, !!e && (n == "number" || n != "symbol" && v$t.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var $Ae = B$t, b$t = 9007199254740991;
function _$t(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= b$t;
}
var qAe = _$t, S$t = XB, Q$t = qAe, w$t = A0, x$t = "[object Arguments]", R$t = "[object Array]", D$t = "[object Boolean]", T$t = "[object Date]", N$t = "[object Error]", L$t = "[object Function]", M$t = "[object Map]", O$t = "[object Number]", F$t = "[object Object]", P$t = "[object RegExp]", k$t = "[object Set]", G$t = "[object String]", U$t = "[object WeakMap]", H$t = "[object ArrayBuffer]", $$t = "[object DataView]", q$t = "[object Float32Array]", j$t = "[object Float64Array]", Y$t = "[object Int8Array]", z$t = "[object Int16Array]", V$t = "[object Int32Array]", J$t = "[object Uint8Array]", K$t = "[object Uint8ClampedArray]", W$t = "[object Uint16Array]", X$t = "[object Uint32Array]", ls = {};
ls[q$t] = ls[j$t] = ls[Y$t] = ls[z$t] = ls[V$t] = ls[J$t] = ls[K$t] = ls[W$t] = ls[X$t] = !0;
ls[x$t] = ls[R$t] = ls[H$t] = ls[D$t] = ls[$$t] = ls[T$t] = ls[N$t] = ls[L$t] = ls[M$t] = ls[O$t] = ls[F$t] = ls[P$t] = ls[k$t] = ls[G$t] = ls[U$t] = !1;
function Z$t(t) {
  return w$t(t) && Q$t(t.length) && !!ls[S$t(t)];
}
var eqt = Z$t;
function tqt(t) {
  return function(e) {
    return t(e);
  };
}
var jAe = tqt, TT = { exports: {} };
(function(t, e) {
  var n = iHe, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, o = i && i.exports === r, s = o && n.process, a = function() {
    try {
      var A = i && i.require && i.require("util").types;
      return A || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  t.exports = a;
})(TT, TT.exports);
var nqt = eqt, rqt = jAe, u1e = TT.exports, f1e = u1e && u1e.isTypedArray, iqt = f1e ? rqt(f1e) : nqt, YAe = iqt, oqt = l$t, sqt = HAe, aqt = Yf, Aqt = FS.exports, lqt = $Ae, cqt = YAe, uqt = Object.prototype, fqt = uqt.hasOwnProperty;
function gqt(t, e) {
  var n = aqt(t), r = !n && sqt(t), i = !n && !r && Aqt(t), o = !n && !r && !i && cqt(t), s = n || r || i || o, a = s ? oqt(t.length, String) : [], A = a.length;
  for (var l in t)
    (e || fqt.call(t, l)) && !(s && (l == "length" || i && (l == "offset" || l == "parent") || o && (l == "buffer" || l == "byteLength" || l == "byteOffset") || lqt(l, A))) && a.push(l);
  return a;
}
var AHe = gqt, hqt = Object.prototype;
function dqt(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || hqt;
  return t === n;
}
var zAe = dqt;
function pqt(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var lHe = pqt, Iqt = lHe, mqt = Iqt(Object.keys, Object), Cqt = mqt, Eqt = zAe, yqt = Cqt, vqt = Object.prototype, Bqt = vqt.hasOwnProperty;
function bqt(t) {
  if (!Eqt(t))
    return yqt(t);
  var e = [];
  for (var n in Object(t))
    Bqt.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var _qt = bqt;
function Sqt(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Rd = Sqt, Qqt = XB, wqt = Rd, xqt = "[object AsyncFunction]", Rqt = "[object Function]", Dqt = "[object GeneratorFunction]", Tqt = "[object Proxy]";
function Nqt(t) {
  if (!wqt(t))
    return !1;
  var e = Qqt(t);
  return e == Rqt || e == Dqt || e == xqt || e == Tqt;
}
var VAe = Nqt, Lqt = VAe, Mqt = qAe;
function Oqt(t) {
  return t != null && Mqt(t.length) && !Lqt(t);
}
var Bw = Oqt, Fqt = AHe, Pqt = _qt, kqt = Bw;
function Gqt(t) {
  return kqt(t) ? Fqt(t) : Pqt(t);
}
var YL = Gqt, Uqt = sHe, Hqt = YL;
function $qt(t, e) {
  return t && Uqt(t, e, Hqt);
}
var cHe = $qt;
function qqt(t) {
  return t;
}
var k9 = qqt, jqt = k9;
function Yqt(t) {
  return typeof t == "function" ? t : jqt;
}
var uHe = Yqt, zqt = cHe, Vqt = uHe;
function Jqt(t, e) {
  return t && zqt(t, Vqt(e));
}
var JAe = Jqt, Kqt = lHe, Wqt = Kqt(Object.getPrototypeOf, Object), KAe = Wqt, Xqt = XB, Zqt = KAe, ejt = A0, tjt = "[object Object]", njt = Function.prototype, rjt = Object.prototype, fHe = njt.toString, ijt = rjt.hasOwnProperty, ojt = fHe.call(Object);
function sjt(t) {
  if (!ejt(t) || Xqt(t) != tjt)
    return !1;
  var e = Zqt(t);
  if (e === null)
    return !0;
  var n = ijt.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && fHe.call(n) == ojt;
}
var gHe = sjt;
function ajt(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = Array(r); ++n < r; )
    i[n] = e(t[n], n, t);
  return i;
}
var hHe = ajt;
function Ajt() {
  this.__data__ = [], this.size = 0;
}
var ljt = Ajt;
function cjt(t, e) {
  return t === e || t !== t && e !== e;
}
var zL = cjt, ujt = zL;
function fjt(t, e) {
  for (var n = t.length; n--; )
    if (ujt(t[n][0], e))
      return n;
  return -1;
}
var G9 = fjt, gjt = G9, hjt = Array.prototype, djt = hjt.splice;
function pjt(t) {
  var e = this.__data__, n = gjt(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : djt.call(e, n, 1), --this.size, !0;
}
var Ijt = pjt, mjt = G9;
function Cjt(t) {
  var e = this.__data__, n = mjt(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var Ejt = Cjt, yjt = G9;
function vjt(t) {
  return yjt(this.__data__, t) > -1;
}
var Bjt = vjt, bjt = G9;
function _jt(t, e) {
  var n = this.__data__, r = bjt(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
var Sjt = _jt, Qjt = ljt, wjt = Ijt, xjt = Ejt, Rjt = Bjt, Djt = Sjt;
function bw(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
bw.prototype.clear = Qjt;
bw.prototype.delete = wjt;
bw.prototype.get = xjt;
bw.prototype.has = Rjt;
bw.prototype.set = Djt;
var U9 = bw, Tjt = U9;
function Njt() {
  this.__data__ = new Tjt(), this.size = 0;
}
var Ljt = Njt;
function Mjt(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var Ojt = Mjt;
function Fjt(t) {
  return this.__data__.get(t);
}
var Pjt = Fjt;
function kjt(t) {
  return this.__data__.has(t);
}
var Gjt = kjt, Ujt = xd, Hjt = Ujt["__core-js_shared__"], $jt = Hjt, U7 = $jt, g1e = function() {
  var t = /[^.]+$/.exec(U7 && U7.keys && U7.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function qjt(t) {
  return !!g1e && g1e in t;
}
var jjt = qjt, Yjt = Function.prototype, zjt = Yjt.toString;
function Vjt(t) {
  if (t != null) {
    try {
      return zjt.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var dHe = Vjt, Jjt = VAe, Kjt = jjt, Wjt = Rd, Xjt = dHe, Zjt = /[\\^$.*+?()[\]{}|]/g, eYt = /^\[object .+?Constructor\]$/, tYt = Function.prototype, nYt = Object.prototype, rYt = tYt.toString, iYt = nYt.hasOwnProperty, oYt = RegExp(
  "^" + rYt.call(iYt).replace(Zjt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function sYt(t) {
  if (!Wjt(t) || Kjt(t))
    return !1;
  var e = Jjt(t) ? oYt : eYt;
  return e.test(Xjt(t));
}
var aYt = sYt;
function AYt(t, e) {
  return t?.[e];
}
var lYt = AYt, cYt = aYt, uYt = lYt;
function fYt(t, e) {
  var n = uYt(t, e);
  return cYt(n) ? n : void 0;
}
var ZB = fYt, gYt = ZB, hYt = xd, dYt = gYt(hYt, "Map"), WAe = dYt, pYt = ZB, IYt = pYt(Object, "create"), H9 = IYt, h1e = H9;
function mYt() {
  this.__data__ = h1e ? h1e(null) : {}, this.size = 0;
}
var CYt = mYt;
function EYt(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var yYt = EYt, vYt = H9, BYt = "__lodash_hash_undefined__", bYt = Object.prototype, _Yt = bYt.hasOwnProperty;
function SYt(t) {
  var e = this.__data__;
  if (vYt) {
    var n = e[t];
    return n === BYt ? void 0 : n;
  }
  return _Yt.call(e, t) ? e[t] : void 0;
}
var QYt = SYt, wYt = H9, xYt = Object.prototype, RYt = xYt.hasOwnProperty;
function DYt(t) {
  var e = this.__data__;
  return wYt ? e[t] !== void 0 : RYt.call(e, t);
}
var TYt = DYt, NYt = H9, LYt = "__lodash_hash_undefined__";
function MYt(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = NYt && e === void 0 ? LYt : e, this;
}
var OYt = MYt, FYt = CYt, PYt = yYt, kYt = QYt, GYt = TYt, UYt = OYt;
function _w(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
_w.prototype.clear = FYt;
_w.prototype.delete = PYt;
_w.prototype.get = kYt;
_w.prototype.has = GYt;
_w.prototype.set = UYt;
var HYt = _w, d1e = HYt, $Yt = U9, qYt = WAe;
function jYt() {
  this.size = 0, this.__data__ = {
    hash: new d1e(),
    map: new (qYt || $Yt)(),
    string: new d1e()
  };
}
var YYt = jYt;
function zYt(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var VYt = zYt, JYt = VYt;
function KYt(t, e) {
  var n = t.__data__;
  return JYt(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var $9 = KYt, WYt = $9;
function XYt(t) {
  var e = WYt(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var ZYt = XYt, ezt = $9;
function tzt(t) {
  return ezt(this, t).get(t);
}
var nzt = tzt, rzt = $9;
function izt(t) {
  return rzt(this, t).has(t);
}
var ozt = izt, szt = $9;
function azt(t, e) {
  var n = szt(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
var Azt = azt, lzt = YYt, czt = ZYt, uzt = nzt, fzt = ozt, gzt = Azt;
function Sw(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Sw.prototype.clear = lzt;
Sw.prototype.delete = czt;
Sw.prototype.get = uzt;
Sw.prototype.has = fzt;
Sw.prototype.set = gzt;
var XAe = Sw, hzt = U9, dzt = WAe, pzt = XAe, Izt = 200;
function mzt(t, e) {
  var n = this.__data__;
  if (n instanceof hzt) {
    var r = n.__data__;
    if (!dzt || r.length < Izt - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new pzt(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
var Czt = mzt, Ezt = U9, yzt = Ljt, vzt = Ojt, Bzt = Pjt, bzt = Gjt, _zt = Czt;
function Qw(t) {
  var e = this.__data__ = new Ezt(t);
  this.size = e.size;
}
Qw.prototype.clear = yzt;
Qw.prototype.delete = vzt;
Qw.prototype.get = Bzt;
Qw.prototype.has = bzt;
Qw.prototype.set = _zt;
var q9 = Qw, Szt = "__lodash_hash_undefined__";
function Qzt(t) {
  return this.__data__.set(t, Szt), this;
}
var wzt = Qzt;
function xzt(t) {
  return this.__data__.has(t);
}
var Rzt = xzt, Dzt = XAe, Tzt = wzt, Nzt = Rzt;
function fU(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new Dzt(); ++e < n; )
    this.add(t[e]);
}
fU.prototype.add = fU.prototype.push = Tzt;
fU.prototype.has = Nzt;
var Lzt = fU;
function Mzt(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
var Ozt = Mzt;
function Fzt(t, e) {
  return t.has(e);
}
var Pzt = Fzt, kzt = Lzt, Gzt = Ozt, Uzt = Pzt, Hzt = 1, $zt = 2;
function qzt(t, e, n, r, i, o) {
  var s = n & Hzt, a = t.length, A = e.length;
  if (a != A && !(s && A > a))
    return !1;
  var l = o.get(t), c = o.get(e);
  if (l && c)
    return l == e && c == t;
  var u = -1, f = !0, h = n & $zt ? new kzt() : void 0;
  for (o.set(t, e), o.set(e, t); ++u < a; ) {
    var d = t[u], I = e[u];
    if (r)
      var m = s ? r(I, d, u, e, t, o) : r(d, I, u, t, e, o);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!Gzt(e, function(C, y) {
        if (!Uzt(h, y) && (d === C || i(d, C, n, r, o)))
          return h.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(d === I || i(d, I, n, r, o))) {
      f = !1;
      break;
    }
  }
  return o.delete(t), o.delete(e), f;
}
var pHe = qzt, jzt = xd, Yzt = jzt.Uint8Array, IHe = Yzt;
function zzt(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, i) {
    n[++e] = [i, r];
  }), n;
}
var Vzt = zzt;
function Jzt(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var Kzt = Jzt, p1e = jL, I1e = IHe, Wzt = zL, Xzt = pHe, Zzt = Vzt, e7t = Kzt, t7t = 1, n7t = 2, r7t = "[object Boolean]", i7t = "[object Date]", o7t = "[object Error]", s7t = "[object Map]", a7t = "[object Number]", A7t = "[object RegExp]", l7t = "[object Set]", c7t = "[object String]", u7t = "[object Symbol]", f7t = "[object ArrayBuffer]", g7t = "[object DataView]", m1e = p1e ? p1e.prototype : void 0, H7 = m1e ? m1e.valueOf : void 0;
function h7t(t, e, n, r, i, o, s) {
  switch (n) {
    case g7t:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case f7t:
      return !(t.byteLength != e.byteLength || !o(new I1e(t), new I1e(e)));
    case r7t:
    case i7t:
    case a7t:
      return Wzt(+t, +e);
    case o7t:
      return t.name == e.name && t.message == e.message;
    case A7t:
    case c7t:
      return t == e + "";
    case s7t:
      var a = Zzt;
    case l7t:
      var A = r & t7t;
      if (a || (a = e7t), t.size != e.size && !A)
        return !1;
      var l = s.get(t);
      if (l)
        return l == e;
      r |= n7t, s.set(t, e);
      var c = Xzt(a(t), a(e), r, i, o, s);
      return s.delete(t), c;
    case u7t:
      if (H7)
        return H7.call(t) == H7.call(e);
  }
  return !1;
}
var d7t = h7t;
function p7t(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
var mHe = p7t, I7t = mHe, m7t = Yf;
function C7t(t, e, n) {
  var r = e(t);
  return m7t(t) ? r : I7t(r, n(t));
}
var CHe = C7t;
function E7t(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, o = []; ++n < r; ) {
    var s = t[n];
    e(s, n, t) && (o[i++] = s);
  }
  return o;
}
var y7t = E7t;
function v7t() {
  return [];
}
var EHe = v7t, B7t = y7t, b7t = EHe, _7t = Object.prototype, S7t = _7t.propertyIsEnumerable, C1e = Object.getOwnPropertySymbols, Q7t = C1e ? function(t) {
  return t == null ? [] : (t = Object(t), B7t(C1e(t), function(e) {
    return S7t.call(t, e);
  }));
} : b7t, ZAe = Q7t, w7t = CHe, x7t = ZAe, R7t = YL;
function D7t(t) {
  return w7t(t, R7t, x7t);
}
var yHe = D7t, E1e = yHe, T7t = 1, N7t = Object.prototype, L7t = N7t.hasOwnProperty;
function M7t(t, e, n, r, i, o) {
  var s = n & T7t, a = E1e(t), A = a.length, l = E1e(e), c = l.length;
  if (A != c && !s)
    return !1;
  for (var u = A; u--; ) {
    var f = a[u];
    if (!(s ? f in e : L7t.call(e, f)))
      return !1;
  }
  var h = o.get(t), d = o.get(e);
  if (h && d)
    return h == e && d == t;
  var I = !0;
  o.set(t, e), o.set(e, t);
  for (var m = s; ++u < A; ) {
    f = a[u];
    var C = t[f], y = e[f];
    if (r)
      var v = s ? r(y, C, f, e, t, o) : r(C, y, f, t, e, o);
    if (!(v === void 0 ? C === y || i(C, y, n, r, o) : v)) {
      I = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (I && !m) {
    var b = t.constructor, Q = e.constructor;
    b != Q && "constructor" in t && "constructor" in e && !(typeof b == "function" && b instanceof b && typeof Q == "function" && Q instanceof Q) && (I = !1);
  }
  return o.delete(t), o.delete(e), I;
}
var O7t = M7t, F7t = ZB, P7t = xd, k7t = F7t(P7t, "DataView"), G7t = k7t, U7t = ZB, H7t = xd, $7t = U7t(H7t, "Promise"), q7t = $7t, j7t = ZB, Y7t = xd, z7t = j7t(Y7t, "Set"), V7t = z7t, J7t = ZB, K7t = xd, W7t = J7t(K7t, "WeakMap"), X7t = W7t, Eee = G7t, yee = WAe, vee = q7t, Bee = V7t, bee = X7t, vHe = XB, ww = dHe, y1e = "[object Map]", Z7t = "[object Object]", v1e = "[object Promise]", B1e = "[object Set]", b1e = "[object WeakMap]", _1e = "[object DataView]", eVt = ww(Eee), tVt = ww(yee), nVt = ww(vee), rVt = ww(Bee), iVt = ww(bee), Gy = vHe;
(Eee && Gy(new Eee(new ArrayBuffer(1))) != _1e || yee && Gy(new yee()) != y1e || vee && Gy(vee.resolve()) != v1e || Bee && Gy(new Bee()) != B1e || bee && Gy(new bee()) != b1e) && (Gy = function(t) {
  var e = vHe(t), n = e == Z7t ? t.constructor : void 0, r = n ? ww(n) : "";
  if (r)
    switch (r) {
      case eVt:
        return _1e;
      case tVt:
        return y1e;
      case nVt:
        return v1e;
      case rVt:
        return B1e;
      case iVt:
        return b1e;
    }
  return e;
});
var j9 = Gy, $7 = q9, oVt = pHe, sVt = d7t, aVt = O7t, S1e = j9, Q1e = Yf, w1e = FS.exports, AVt = YAe, lVt = 1, x1e = "[object Arguments]", R1e = "[object Array]", kF = "[object Object]", cVt = Object.prototype, D1e = cVt.hasOwnProperty;
function uVt(t, e, n, r, i, o) {
  var s = Q1e(t), a = Q1e(e), A = s ? R1e : S1e(t), l = a ? R1e : S1e(e);
  A = A == x1e ? kF : A, l = l == x1e ? kF : l;
  var c = A == kF, u = l == kF, f = A == l;
  if (f && w1e(t)) {
    if (!w1e(e))
      return !1;
    s = !0, c = !1;
  }
  if (f && !c)
    return o || (o = new $7()), s || AVt(t) ? oVt(t, e, n, r, i, o) : sVt(t, e, A, n, r, i, o);
  if (!(n & lVt)) {
    var h = c && D1e.call(t, "__wrapped__"), d = u && D1e.call(e, "__wrapped__");
    if (h || d) {
      var I = h ? t.value() : t, m = d ? e.value() : e;
      return o || (o = new $7()), i(I, m, n, r, o);
    }
  }
  return f ? (o || (o = new $7()), aVt(t, e, n, r, i, o)) : !1;
}
var fVt = uVt, gVt = fVt, T1e = A0;
function BHe(t, e, n, r, i) {
  return t === e ? !0 : t == null || e == null || !T1e(t) && !T1e(e) ? t !== t && e !== e : gVt(t, e, n, r, BHe, i);
}
var bHe = BHe, hVt = q9, dVt = bHe, pVt = 1, IVt = 2;
function mVt(t, e, n, r) {
  var i = n.length, o = i, s = !r;
  if (t == null)
    return !o;
  for (t = Object(t); i--; ) {
    var a = n[i];
    if (s && a[2] ? a[1] !== t[a[0]] : !(a[0] in t))
      return !1;
  }
  for (; ++i < o; ) {
    a = n[i];
    var A = a[0], l = t[A], c = a[1];
    if (s && a[2]) {
      if (l === void 0 && !(A in t))
        return !1;
    } else {
      var u = new hVt();
      if (r)
        var f = r(l, c, A, t, e, u);
      if (!(f === void 0 ? dVt(c, l, pVt | IVt, r, u) : f))
        return !1;
    }
  }
  return !0;
}
var CVt = mVt, EVt = Rd;
function yVt(t) {
  return t === t && !EVt(t);
}
var _He = yVt, vVt = _He, BVt = YL;
function bVt(t) {
  for (var e = BVt(t), n = e.length; n--; ) {
    var r = e[n], i = t[r];
    e[n] = [r, i, vVt(i)];
  }
  return e;
}
var _Vt = bVt;
function SVt(t, e) {
  return function(n) {
    return n == null ? !1 : n[t] === e && (e !== void 0 || t in Object(n));
  };
}
var SHe = SVt, QVt = CVt, wVt = _Vt, xVt = SHe;
function RVt(t) {
  var e = wVt(t);
  return e.length == 1 && e[0][2] ? xVt(e[0][0], e[0][1]) : function(n) {
    return n === t || QVt(n, t, e);
  };
}
var DVt = RVt, TVt = XB, NVt = A0, LVt = "[object Symbol]";
function MVt(t) {
  return typeof t == "symbol" || NVt(t) && TVt(t) == LVt;
}
var Y9 = MVt, OVt = Yf, FVt = Y9, PVt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, kVt = /^\w*$/;
function GVt(t, e) {
  if (OVt(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || FVt(t) ? !0 : kVt.test(t) || !PVt.test(t) || e != null && t in Object(e);
}
var ele = GVt, QHe = XAe, UVt = "Expected a function";
function tle(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(UVt);
  var n = function() {
    var r = arguments, i = e ? e.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var s = t.apply(this, r);
    return n.cache = o.set(i, s) || o, s;
  };
  return n.cache = new (tle.Cache || QHe)(), n;
}
tle.Cache = QHe;
var HVt = tle, $Vt = HVt, qVt = 500;
function jVt(t) {
  var e = $Vt(t, function(r) {
    return n.size === qVt && n.clear(), r;
  }), n = e.cache;
  return e;
}
var YVt = jVt, zVt = YVt, VVt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, JVt = /\\(\\)?/g, KVt = zVt(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(VVt, function(n, r, i, o) {
    e.push(i ? o.replace(JVt, "$1") : r || n);
  }), e;
}), WVt = KVt, N1e = jL, XVt = hHe, ZVt = Yf, eJt = Y9, tJt = 1 / 0, L1e = N1e ? N1e.prototype : void 0, M1e = L1e ? L1e.toString : void 0;
function wHe(t) {
  if (typeof t == "string")
    return t;
  if (ZVt(t))
    return XVt(t, wHe) + "";
  if (eJt(t))
    return M1e ? M1e.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -tJt ? "-0" : e;
}
var nJt = wHe, rJt = nJt;
function iJt(t) {
  return t == null ? "" : rJt(t);
}
var oJt = iJt, sJt = Yf, aJt = ele, AJt = WVt, lJt = oJt;
function cJt(t, e) {
  return sJt(t) ? t : aJt(t, e) ? [t] : AJt(lJt(t));
}
var xHe = cJt, uJt = Y9, fJt = 1 / 0;
function gJt(t) {
  if (typeof t == "string" || uJt(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -fJt ? "-0" : e;
}
var z9 = gJt, hJt = xHe, dJt = z9;
function pJt(t, e) {
  e = hJt(e, t);
  for (var n = 0, r = e.length; t != null && n < r; )
    t = t[dJt(e[n++])];
  return n && n == r ? t : void 0;
}
var RHe = pJt, IJt = RHe;
function mJt(t, e, n) {
  var r = t == null ? void 0 : IJt(t, e);
  return r === void 0 ? n : r;
}
var CJt = mJt;
function EJt(t, e) {
  return t != null && e in Object(t);
}
var yJt = EJt, vJt = xHe, BJt = HAe, bJt = Yf, _Jt = $Ae, SJt = qAe, QJt = z9;
function wJt(t, e, n) {
  e = vJt(e, t);
  for (var r = -1, i = e.length, o = !1; ++r < i; ) {
    var s = QJt(e[r]);
    if (!(o = t != null && n(t, s)))
      break;
    t = t[s];
  }
  return o || ++r != i ? o : (i = t == null ? 0 : t.length, !!i && SJt(i) && _Jt(s, i) && (bJt(t) || BJt(t)));
}
var xJt = wJt, RJt = yJt, DJt = xJt;
function TJt(t, e) {
  return t != null && DJt(t, e, RJt);
}
var NJt = TJt, LJt = bHe, MJt = CJt, OJt = NJt, FJt = ele, PJt = _He, kJt = SHe, GJt = z9, UJt = 1, HJt = 2;
function $Jt(t, e) {
  return FJt(t) && PJt(e) ? kJt(GJt(t), e) : function(n) {
    var r = MJt(n, t);
    return r === void 0 && r === e ? OJt(n, t) : LJt(e, r, UJt | HJt);
  };
}
var qJt = $Jt;
function jJt(t) {
  return function(e) {
    return e?.[t];
  };
}
var YJt = jJt, zJt = RHe;
function VJt(t) {
  return function(e) {
    return zJt(e, t);
  };
}
var JJt = VJt, KJt = YJt, WJt = JJt, XJt = ele, ZJt = z9;
function eKt(t) {
  return XJt(t) ? KJt(ZJt(t)) : WJt(t);
}
var tKt = eKt, nKt = DVt, rKt = qJt, iKt = k9, oKt = Yf, sKt = tKt;
function aKt(t) {
  return typeof t == "function" ? t : t == null ? iKt : typeof t == "object" ? oKt(t) ? rKt(t[0], t[1]) : nKt(t) : sKt(t);
}
var AKt = aKt, lKt = Bw;
function cKt(t, e) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!lKt(n))
      return t(n, r);
    for (var i = n.length, o = e ? i : -1, s = Object(n); (e ? o-- : ++o < i) && r(s[o], o, s) !== !1; )
      ;
    return n;
  };
}
var uKt = cKt, fKt = cHe, gKt = uKt, hKt = gKt(fKt), DHe = hKt, dKt = DHe, pKt = Bw;
function IKt(t, e) {
  var n = -1, r = pKt(t) ? Array(t.length) : [];
  return dKt(t, function(i, o, s) {
    r[++n] = e(i, o, s);
  }), r;
}
var mKt = IKt, CKt = hHe, EKt = AKt, yKt = mKt, vKt = Yf;
function BKt(t, e) {
  var n = vKt(t) ? CKt : yKt;
  return n(t, EKt(e));
}
var THe = BKt;
Object.defineProperty(qL, "__esModule", {
  value: !0
});
qL.flattenNames = void 0;
var bKt = r$t, _Kt = V9(bKt), SKt = JAe, QKt = V9(SKt), wKt = gHe, xKt = V9(wKt), RKt = THe, DKt = V9(RKt);
function V9(t) {
  return t && t.__esModule ? t : { default: t };
}
var TKt = qL.flattenNames = function t() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = [];
  return (0, DKt.default)(e, function(r) {
    Array.isArray(r) ? t(r).map(function(i) {
      return n.push(i);
    }) : (0, xKt.default)(r) ? (0, QKt.default)(r, function(i, o) {
      i === !0 && n.push(o), n.push(o + "-" + i);
    }) : (0, _Kt.default)(r) && n.push(r);
  }), n;
};
qL.default = TKt;
var VL = {};
function NKt(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r && e(t[n], n, t) !== !1; )
    ;
  return t;
}
var NHe = NKt, LKt = ZB, MKt = function() {
  try {
    var t = LKt(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), LHe = MKt, O1e = LHe;
function OKt(t, e, n) {
  e == "__proto__" && O1e ? O1e(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
var nle = OKt, FKt = nle, PKt = zL, kKt = Object.prototype, GKt = kKt.hasOwnProperty;
function UKt(t, e, n) {
  var r = t[e];
  (!(GKt.call(t, e) && PKt(r, n)) || n === void 0 && !(e in t)) && FKt(t, e, n);
}
var MHe = UKt, HKt = MHe, $Kt = nle;
function qKt(t, e, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, s = e.length; ++o < s; ) {
    var a = e[o], A = r ? r(n[a], t[a], a, n, t) : void 0;
    A === void 0 && (A = t[a]), i ? $Kt(n, a, A) : HKt(n, a, A);
  }
  return n;
}
var JL = qKt, jKt = JL, YKt = YL;
function zKt(t, e) {
  return t && jKt(e, YKt(e), t);
}
var VKt = zKt;
function JKt(t) {
  var e = [];
  if (t != null)
    for (var n in Object(t))
      e.push(n);
  return e;
}
var KKt = JKt, WKt = Rd, XKt = zAe, ZKt = KKt, eWt = Object.prototype, tWt = eWt.hasOwnProperty;
function nWt(t) {
  if (!WKt(t))
    return ZKt(t);
  var e = XKt(t), n = [];
  for (var r in t)
    r == "constructor" && (e || !tWt.call(t, r)) || n.push(r);
  return n;
}
var rWt = nWt, iWt = AHe, oWt = rWt, sWt = Bw;
function aWt(t) {
  return sWt(t) ? iWt(t, !0) : oWt(t);
}
var KL = aWt, AWt = JL, lWt = KL;
function cWt(t, e) {
  return t && AWt(e, lWt(e), t);
}
var uWt = cWt, gU = { exports: {} };
(function(t, e) {
  var n = xd, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, o = i && i.exports === r, s = o ? n.Buffer : void 0, a = s ? s.allocUnsafe : void 0;
  function A(l, c) {
    if (c)
      return l.slice();
    var u = l.length, f = a ? a(u) : new l.constructor(u);
    return l.copy(f), f;
  }
  t.exports = A;
})(gU, gU.exports);
function fWt(t, e) {
  var n = -1, r = t.length;
  for (e || (e = Array(r)); ++n < r; )
    e[n] = t[n];
  return e;
}
var OHe = fWt, gWt = JL, hWt = ZAe;
function dWt(t, e) {
  return gWt(t, hWt(t), e);
}
var pWt = dWt, IWt = mHe, mWt = KAe, CWt = ZAe, EWt = EHe, yWt = Object.getOwnPropertySymbols, vWt = yWt ? function(t) {
  for (var e = []; t; )
    IWt(e, CWt(t)), t = mWt(t);
  return e;
} : EWt, FHe = vWt, BWt = JL, bWt = FHe;
function _Wt(t, e) {
  return BWt(t, bWt(t), e);
}
var SWt = _Wt, QWt = CHe, wWt = FHe, xWt = KL;
function RWt(t) {
  return QWt(t, xWt, wWt);
}
var DWt = RWt, TWt = Object.prototype, NWt = TWt.hasOwnProperty;
function LWt(t) {
  var e = t.length, n = new t.constructor(e);
  return e && typeof t[0] == "string" && NWt.call(t, "index") && (n.index = t.index, n.input = t.input), n;
}
var MWt = LWt, F1e = IHe;
function OWt(t) {
  var e = new t.constructor(t.byteLength);
  return new F1e(e).set(new F1e(t)), e;
}
var rle = OWt, FWt = rle;
function PWt(t, e) {
  var n = e ? FWt(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.byteLength);
}
var kWt = PWt, GWt = /\w*$/;
function UWt(t) {
  var e = new t.constructor(t.source, GWt.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var HWt = UWt, P1e = jL, k1e = P1e ? P1e.prototype : void 0, G1e = k1e ? k1e.valueOf : void 0;
function $Wt(t) {
  return G1e ? Object(G1e.call(t)) : {};
}
var qWt = $Wt, jWt = rle;
function YWt(t, e) {
  var n = e ? jWt(t.buffer) : t.buffer;
  return new t.constructor(n, t.byteOffset, t.length);
}
var PHe = YWt, zWt = rle, VWt = kWt, JWt = HWt, KWt = qWt, WWt = PHe, XWt = "[object Boolean]", ZWt = "[object Date]", eXt = "[object Map]", tXt = "[object Number]", nXt = "[object RegExp]", rXt = "[object Set]", iXt = "[object String]", oXt = "[object Symbol]", sXt = "[object ArrayBuffer]", aXt = "[object DataView]", AXt = "[object Float32Array]", lXt = "[object Float64Array]", cXt = "[object Int8Array]", uXt = "[object Int16Array]", fXt = "[object Int32Array]", gXt = "[object Uint8Array]", hXt = "[object Uint8ClampedArray]", dXt = "[object Uint16Array]", pXt = "[object Uint32Array]";
function IXt(t, e, n) {
  var r = t.constructor;
  switch (e) {
    case sXt:
      return zWt(t);
    case XWt:
    case ZWt:
      return new r(+t);
    case aXt:
      return VWt(t, n);
    case AXt:
    case lXt:
    case cXt:
    case uXt:
    case fXt:
    case gXt:
    case hXt:
    case dXt:
    case pXt:
      return WWt(t, n);
    case eXt:
      return new r();
    case tXt:
    case iXt:
      return new r(t);
    case nXt:
      return JWt(t);
    case rXt:
      return new r();
    case oXt:
      return KWt(t);
  }
}
var mXt = IXt, CXt = Rd, U1e = Object.create, EXt = function() {
  function t() {
  }
  return function(e) {
    if (!CXt(e))
      return {};
    if (U1e)
      return U1e(e);
    t.prototype = e;
    var n = new t();
    return t.prototype = void 0, n;
  };
}(), yXt = EXt, vXt = yXt, BXt = KAe, bXt = zAe;
function _Xt(t) {
  return typeof t.constructor == "function" && !bXt(t) ? vXt(BXt(t)) : {};
}
var kHe = _Xt, SXt = j9, QXt = A0, wXt = "[object Map]";
function xXt(t) {
  return QXt(t) && SXt(t) == wXt;
}
var RXt = xXt, DXt = RXt, TXt = jAe, H1e = TT.exports, $1e = H1e && H1e.isMap, NXt = $1e ? TXt($1e) : DXt, LXt = NXt, MXt = j9, OXt = A0, FXt = "[object Set]";
function PXt(t) {
  return OXt(t) && MXt(t) == FXt;
}
var kXt = PXt, GXt = kXt, UXt = jAe, q1e = TT.exports, j1e = q1e && q1e.isSet, HXt = j1e ? UXt(j1e) : GXt, $Xt = HXt, qXt = q9, jXt = NHe, YXt = MHe, zXt = VKt, VXt = uWt, JXt = gU.exports, KXt = OHe, WXt = pWt, XXt = SWt, ZXt = yHe, eZt = DWt, tZt = j9, nZt = MWt, rZt = mXt, iZt = kHe, oZt = Yf, sZt = FS.exports, aZt = LXt, AZt = Rd, lZt = $Xt, cZt = YL, uZt = KL, fZt = 1, gZt = 2, hZt = 4, GHe = "[object Arguments]", dZt = "[object Array]", pZt = "[object Boolean]", IZt = "[object Date]", mZt = "[object Error]", UHe = "[object Function]", CZt = "[object GeneratorFunction]", EZt = "[object Map]", yZt = "[object Number]", HHe = "[object Object]", vZt = "[object RegExp]", BZt = "[object Set]", bZt = "[object String]", _Zt = "[object Symbol]", SZt = "[object WeakMap]", QZt = "[object ArrayBuffer]", wZt = "[object DataView]", xZt = "[object Float32Array]", RZt = "[object Float64Array]", DZt = "[object Int8Array]", TZt = "[object Int16Array]", NZt = "[object Int32Array]", LZt = "[object Uint8Array]", MZt = "[object Uint8ClampedArray]", OZt = "[object Uint16Array]", FZt = "[object Uint32Array]", Jo = {};
Jo[GHe] = Jo[dZt] = Jo[QZt] = Jo[wZt] = Jo[pZt] = Jo[IZt] = Jo[xZt] = Jo[RZt] = Jo[DZt] = Jo[TZt] = Jo[NZt] = Jo[EZt] = Jo[yZt] = Jo[HHe] = Jo[vZt] = Jo[BZt] = Jo[bZt] = Jo[_Zt] = Jo[LZt] = Jo[MZt] = Jo[OZt] = Jo[FZt] = !0;
Jo[mZt] = Jo[UHe] = Jo[SZt] = !1;
function Ck(t, e, n, r, i, o) {
  var s, a = e & fZt, A = e & gZt, l = e & hZt;
  if (n && (s = i ? n(t, r, i, o) : n(t)), s !== void 0)
    return s;
  if (!AZt(t))
    return t;
  var c = oZt(t);
  if (c) {
    if (s = nZt(t), !a)
      return KXt(t, s);
  } else {
    var u = tZt(t), f = u == UHe || u == CZt;
    if (sZt(t))
      return JXt(t, a);
    if (u == HHe || u == GHe || f && !i) {
      if (s = A || f ? {} : iZt(t), !a)
        return A ? XXt(t, VXt(s, t)) : WXt(t, zXt(s, t));
    } else {
      if (!Jo[u])
        return i ? t : {};
      s = rZt(t, u, a);
    }
  }
  o || (o = new qXt());
  var h = o.get(t);
  if (h)
    return h;
  o.set(t, s), lZt(t) ? t.forEach(function(m) {
    s.add(Ck(m, e, n, m, t, o));
  }) : aZt(t) && t.forEach(function(m, C) {
    s.set(C, Ck(m, e, n, C, t, o));
  });
  var d = l ? A ? eZt : ZXt : A ? uZt : cZt, I = c ? void 0 : d(t);
  return jXt(I || t, function(m, C) {
    I && (C = m, m = t[C]), YXt(s, C, Ck(m, e, n, C, t, o));
  }), s;
}
var PZt = Ck, kZt = PZt, GZt = 1, UZt = 4;
function HZt(t) {
  return kZt(t, GZt | UZt);
}
var $Zt = HZt;
Object.defineProperty(VL, "__esModule", {
  value: !0
});
VL.mergeClasses = void 0;
var qZt = JAe, jZt = $He(qZt), YZt = $Zt, zZt = $He(YZt), VZt = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
};
function $He(t) {
  return t && t.__esModule ? t : { default: t };
}
var JZt = VL.mergeClasses = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = e.default && (0, zZt.default)(e.default) || {};
  return n.map(function(i) {
    var o = e[i];
    return o && (0, jZt.default)(o, function(s, a) {
      r[a] || (r[a] = {}), r[a] = VZt({}, r[a], o[a]);
    }), i;
  }), r;
};
VL.default = JZt;
var WL = {};
Object.defineProperty(WL, "__esModule", {
  value: !0
});
WL.autoprefix = void 0;
var KZt = JAe, Y1e = XZt(KZt), WZt = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
};
function XZt(t) {
  return t && t.__esModule ? t : { default: t };
}
var ZZt = {
  borderRadius: function(e) {
    return {
      msBorderRadius: e,
      MozBorderRadius: e,
      OBorderRadius: e,
      WebkitBorderRadius: e,
      borderRadius: e
    };
  },
  boxShadow: function(e) {
    return {
      msBoxShadow: e,
      MozBoxShadow: e,
      OBoxShadow: e,
      WebkitBoxShadow: e,
      boxShadow: e
    };
  },
  userSelect: function(e) {
    return {
      WebkitTouchCallout: e,
      KhtmlUserSelect: e,
      MozUserSelect: e,
      msUserSelect: e,
      WebkitUserSelect: e,
      userSelect: e
    };
  },
  flex: function(e) {
    return {
      WebkitBoxFlex: e,
      MozBoxFlex: e,
      WebkitFlex: e,
      msFlex: e,
      flex: e
    };
  },
  flexBasis: function(e) {
    return {
      WebkitFlexBasis: e,
      flexBasis: e
    };
  },
  justifyContent: function(e) {
    return {
      WebkitJustifyContent: e,
      justifyContent: e
    };
  },
  transition: function(e) {
    return {
      msTransition: e,
      MozTransition: e,
      OTransition: e,
      WebkitTransition: e,
      transition: e
    };
  },
  transform: function(e) {
    return {
      msTransform: e,
      MozTransform: e,
      OTransform: e,
      WebkitTransform: e,
      transform: e
    };
  },
  absolute: function(e) {
    var n = e && e.split(" ");
    return {
      position: "absolute",
      top: n && n[0],
      right: n && n[1],
      bottom: n && n[2],
      left: n && n[3]
    };
  },
  extend: function(e, n) {
    var r = n[e];
    return r || {
      extend: e
    };
  }
}, een = WL.autoprefix = function(e) {
  var n = {};
  return (0, Y1e.default)(e, function(r, i) {
    var o = {};
    (0, Y1e.default)(r, function(s, a) {
      var A = ZZt[a];
      A ? o = WZt({}, o, A(s)) : o[a] = s;
    }), n[i] = o;
  }), n;
};
WL.default = een;
var XL = {};
Object.defineProperty(XL, "__esModule", {
  value: !0
});
XL.hover = void 0;
var ten = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, nen = St, q7 = ren(nen);
function ren(t) {
  return t && t.__esModule ? t : { default: t };
}
function ien(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function z1e(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function oen(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var sen = XL.hover = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(r) {
    oen(i, r);
    function i() {
      var o, s, a, A;
      ien(this, i);
      for (var l = arguments.length, c = Array(l), u = 0; u < l; u++)
        c[u] = arguments[u];
      return A = (s = (a = z1e(this, (o = i.__proto__ || Object.getPrototypeOf(i)).call.apply(o, [this].concat(c))), a), a.state = { hover: !1 }, a.handleMouseOver = function() {
        return a.setState({ hover: !0 });
      }, a.handleMouseOut = function() {
        return a.setState({ hover: !1 });
      }, a.render = function() {
        return q7.default.createElement(
          n,
          { onMouseOver: a.handleMouseOver, onMouseOut: a.handleMouseOut },
          q7.default.createElement(e, ten({}, a.props, a.state))
        );
      }, s), z1e(a, A);
    }
    return i;
  }(q7.default.Component);
};
XL.default = sen;
var ZL = {};
Object.defineProperty(ZL, "__esModule", {
  value: !0
});
ZL.active = void 0;
var aen = Object.assign || function(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
  }
  return t;
}, Aen = St, j7 = len(Aen);
function len(t) {
  return t && t.__esModule ? t : { default: t };
}
function cen(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function V1e(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function uen(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var fen = ZL.active = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(r) {
    uen(i, r);
    function i() {
      var o, s, a, A;
      cen(this, i);
      for (var l = arguments.length, c = Array(l), u = 0; u < l; u++)
        c[u] = arguments[u];
      return A = (s = (a = V1e(this, (o = i.__proto__ || Object.getPrototypeOf(i)).call.apply(o, [this].concat(c))), a), a.state = { active: !1 }, a.handleMouseDown = function() {
        return a.setState({ active: !0 });
      }, a.handleMouseUp = function() {
        return a.setState({ active: !1 });
      }, a.render = function() {
        return j7.default.createElement(
          n,
          { onMouseDown: a.handleMouseDown, onMouseUp: a.handleMouseUp },
          j7.default.createElement(e, aen({}, a.props, a.state))
        );
      }, s), V1e(a, A);
    }
    return i;
  }(j7.default.Component);
};
ZL.default = fen;
var ile = {};
Object.defineProperty(ile, "__esModule", {
  value: !0
});
var gen = function(e, n) {
  var r = {}, i = function(s) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    r[s] = a;
  };
  return e === 0 && i("first-child"), e === n - 1 && i("last-child"), (e === 0 || e % 2 === 0) && i("even"), Math.abs(e % 2) === 1 && i("odd"), i("nth-child", e), r;
};
ile.default = gen;
Object.defineProperty(Cg, "__esModule", {
  value: !0
});
Cg.ReactCSS = Cg.loop = Cg.handleActive = Cg.handleHover = Cg.hover = void 0;
var hen = qL, den = xw(hen), pen = VL, Ien = xw(pen), men = WL, Cen = xw(men), Een = XL, qHe = xw(Een), yen = ZL, ven = xw(yen), Ben = ile, ben = xw(Ben);
function xw(t) {
  return t && t.__esModule ? t : { default: t };
}
Cg.hover = qHe.default;
Cg.handleHover = qHe.default;
Cg.handleActive = ven.default;
Cg.loop = ben.default;
var _en = Cg.ReactCSS = function(e) {
  for (var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  var o = (0, den.default)(r), s = (0, Ien.default)(e, o);
  return (0, Cen.default)(s);
}, J9 = Cg.default = _en, Sen = nle, Qen = zL;
function wen(t, e, n) {
  (n !== void 0 && !Qen(t[e], n) || n === void 0 && !(e in t)) && Sen(t, e, n);
}
var jHe = wen, xen = Bw, Ren = A0;
function Den(t) {
  return Ren(t) && xen(t);
}
var Ten = Den;
function Nen(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
var YHe = Nen, Len = JL, Men = KL;
function Oen(t) {
  return Len(t, Men(t));
}
var Fen = Oen, J1e = jHe, Pen = gU.exports, ken = PHe, Gen = OHe, Uen = kHe, K1e = HAe, W1e = Yf, Hen = Ten, $en = FS.exports, qen = VAe, jen = Rd, Yen = gHe, zen = YAe, X1e = YHe, Ven = Fen;
function Jen(t, e, n, r, i, o, s) {
  var a = X1e(t, n), A = X1e(e, n), l = s.get(A);
  if (l) {
    J1e(t, n, l);
    return;
  }
  var c = o ? o(a, A, n + "", t, e, s) : void 0, u = c === void 0;
  if (u) {
    var f = W1e(A), h = !f && $en(A), d = !f && !h && zen(A);
    c = A, f || h || d ? W1e(a) ? c = a : Hen(a) ? c = Gen(a) : h ? (u = !1, c = Pen(A, !0)) : d ? (u = !1, c = ken(A, !0)) : c = [] : Yen(A) || K1e(A) ? (c = a, K1e(a) ? c = Ven(a) : (!jen(a) || qen(a)) && (c = Uen(A))) : u = !1;
  }
  u && (s.set(A, c), i(c, A, r, o, s), s.delete(A)), J1e(t, n, c);
}
var Ken = Jen, Wen = q9, Xen = jHe, Zen = sHe, etn = Ken, ttn = Rd, ntn = KL, rtn = YHe;
function zHe(t, e, n, r, i) {
  t !== e && Zen(e, function(o, s) {
    if (i || (i = new Wen()), ttn(o))
      etn(t, e, s, n, zHe, r, i);
    else {
      var a = r ? r(rtn(t, s), o, s + "", t, e, i) : void 0;
      a === void 0 && (a = o), Xen(t, s, a);
    }
  }, ntn);
}
var itn = zHe;
function otn(t, e, n) {
  switch (n.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, n[0]);
    case 2:
      return t.call(e, n[0], n[1]);
    case 3:
      return t.call(e, n[0], n[1], n[2]);
  }
  return t.apply(e, n);
}
var stn = otn, atn = stn, Z1e = Math.max;
function Atn(t, e, n) {
  return e = Z1e(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var r = arguments, i = -1, o = Z1e(r.length - e, 0), s = Array(o); ++i < o; )
      s[i] = r[e + i];
    i = -1;
    for (var a = Array(e + 1); ++i < e; )
      a[i] = r[i];
    return a[e] = n(s), atn(t, this, a);
  };
}
var ltn = Atn;
function ctn(t) {
  return function() {
    return t;
  };
}
var utn = ctn, ftn = utn, ebe = LHe, gtn = k9, htn = ebe ? function(t, e) {
  return ebe(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: ftn(e),
    writable: !0
  });
} : gtn, dtn = htn, ptn = 800, Itn = 16, mtn = Date.now;
function Ctn(t) {
  var e = 0, n = 0;
  return function() {
    var r = mtn(), i = Itn - (r - n);
    if (n = r, i > 0) {
      if (++e >= ptn)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
var Etn = Ctn, ytn = dtn, vtn = Etn, Btn = vtn(ytn), btn = Btn, _tn = k9, Stn = ltn, Qtn = btn;
function wtn(t, e) {
  return Qtn(Stn(t, e, _tn), t + "");
}
var xtn = wtn, Rtn = zL, Dtn = Bw, Ttn = $Ae, Ntn = Rd;
function Ltn(t, e, n) {
  if (!Ntn(n))
    return !1;
  var r = typeof e;
  return (r == "number" ? Dtn(n) && Ttn(e, n.length) : r == "string" && e in n) ? Rtn(n[e], t) : !1;
}
var Mtn = Ltn, Otn = xtn, Ftn = Mtn;
function Ptn(t) {
  return Otn(function(e, n) {
    var r = -1, i = n.length, o = i > 1 ? n[i - 1] : void 0, s = i > 2 ? n[2] : void 0;
    for (o = t.length > 3 && typeof o == "function" ? (i--, o) : void 0, s && Ftn(n[0], n[1], s) && (o = i < 3 ? void 0 : o, i = 1), e = Object(e); ++r < i; ) {
      var a = n[r];
      a && t(e, a, r, o);
    }
    return e;
  });
}
var ktn = Ptn, Gtn = itn, Utn = ktn, Htn = Utn(function(t, e, n) {
  Gtn(t, e, n);
}), $tn = Htn, VHe = { exports: {} }, qtn = NHe, jtn = DHe, Ytn = uHe, ztn = Yf;
function Vtn(t, e) {
  var n = ztn(t) ? qtn : jtn;
  return n(t, Ytn(e));
}
var Jtn = Vtn;
(function(t) {
  t.exports = Jtn;
})(VHe);
const Ktn = /* @__PURE__ */ w9t(VHe.exports);
var JHe = { exports: {} };
(function(t) {
  (function(e) {
    var n = /^\s+/, r = /\s+$/, i = 0, o = e.round, s = e.min, a = e.max, A = e.random;
    function l(se, fe) {
      if (se = se || "", fe = fe || {}, se instanceof l)
        return se;
      if (!(this instanceof l))
        return new l(se, fe);
      var W = c(se);
      this._originalInput = se, this._r = W.r, this._g = W.g, this._b = W.b, this._a = W.a, this._roundA = o(100 * this._a) / 100, this._format = fe.format || W.format, this._gradientType = fe.gradientType, this._r < 1 && (this._r = o(this._r)), this._g < 1 && (this._g = o(this._g)), this._b < 1 && (this._b = o(this._b)), this._ok = W.ok, this._tc_id = i++;
    }
    l.prototype = {
      isDark: function() {
        return this.getBrightness() < 128;
      },
      isLight: function() {
        return !this.isDark();
      },
      isValid: function() {
        return this._ok;
      },
      getOriginalInput: function() {
        return this._originalInput;
      },
      getFormat: function() {
        return this._format;
      },
      getAlpha: function() {
        return this._a;
      },
      getBrightness: function() {
        var se = this.toRgb();
        return (se.r * 299 + se.g * 587 + se.b * 114) / 1e3;
      },
      getLuminance: function() {
        var se = this.toRgb(), fe, W, ge, _e, Re, Ee;
        return fe = se.r / 255, W = se.g / 255, ge = se.b / 255, fe <= 0.03928 ? _e = fe / 12.92 : _e = e.pow((fe + 0.055) / 1.055, 2.4), W <= 0.03928 ? Re = W / 12.92 : Re = e.pow((W + 0.055) / 1.055, 2.4), ge <= 0.03928 ? Ee = ge / 12.92 : Ee = e.pow((ge + 0.055) / 1.055, 2.4), 0.2126 * _e + 0.7152 * Re + 0.0722 * Ee;
      },
      setAlpha: function(se) {
        return this._a = V(se), this._roundA = o(100 * this._a) / 100, this;
      },
      toHsv: function() {
        var se = d(this._r, this._g, this._b);
        return { h: se.h * 360, s: se.s, v: se.v, a: this._a };
      },
      toHsvString: function() {
        var se = d(this._r, this._g, this._b), fe = o(se.h * 360), W = o(se.s * 100), ge = o(se.v * 100);
        return this._a == 1 ? "hsv(" + fe + ", " + W + "%, " + ge + "%)" : "hsva(" + fe + ", " + W + "%, " + ge + "%, " + this._roundA + ")";
      },
      toHsl: function() {
        var se = f(this._r, this._g, this._b);
        return { h: se.h * 360, s: se.s, l: se.l, a: this._a };
      },
      toHslString: function() {
        var se = f(this._r, this._g, this._b), fe = o(se.h * 360), W = o(se.s * 100), ge = o(se.l * 100);
        return this._a == 1 ? "hsl(" + fe + ", " + W + "%, " + ge + "%)" : "hsla(" + fe + ", " + W + "%, " + ge + "%, " + this._roundA + ")";
      },
      toHex: function(se) {
        return m(this._r, this._g, this._b, se);
      },
      toHexString: function(se) {
        return "#" + this.toHex(se);
      },
      toHex8: function(se) {
        return C(this._r, this._g, this._b, this._a, se);
      },
      toHex8String: function(se) {
        return "#" + this.toHex8(se);
      },
      toRgb: function() {
        return { r: o(this._r), g: o(this._g), b: o(this._b), a: this._a };
      },
      toRgbString: function() {
        return this._a == 1 ? "rgb(" + o(this._r) + ", " + o(this._g) + ", " + o(this._b) + ")" : "rgba(" + o(this._r) + ", " + o(this._g) + ", " + o(this._b) + ", " + this._roundA + ")";
      },
      toPercentageRgb: function() {
        return { r: o(Z(this._r, 255) * 100) + "%", g: o(Z(this._g, 255) * 100) + "%", b: o(Z(this._b, 255) * 100) + "%", a: this._a };
      },
      toPercentageRgbString: function() {
        return this._a == 1 ? "rgb(" + o(Z(this._r, 255) * 100) + "%, " + o(Z(this._g, 255) * 100) + "%, " + o(Z(this._b, 255) * 100) + "%)" : "rgba(" + o(Z(this._r, 255) * 100) + "%, " + o(Z(this._g, 255) * 100) + "%, " + o(Z(this._b, 255) * 100) + "%, " + this._roundA + ")";
      },
      toName: function() {
        return this._a === 0 ? "transparent" : this._a < 1 ? !1 : z[m(this._r, this._g, this._b, !0)] || !1;
      },
      toFilter: function(se) {
        var fe = "#" + y(this._r, this._g, this._b, this._a), W = fe, ge = this._gradientType ? "GradientType = 1, " : "";
        if (se) {
          var _e = l(se);
          W = "#" + y(_e._r, _e._g, _e._b, _e._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + ge + "startColorstr=" + fe + ",endColorstr=" + W + ")";
      },
      toString: function(se) {
        var fe = !!se;
        se = se || this._format;
        var W = !1, ge = this._a < 1 && this._a >= 0, _e = !fe && ge && (se === "hex" || se === "hex6" || se === "hex3" || se === "hex4" || se === "hex8" || se === "name");
        return _e ? se === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (se === "rgb" && (W = this.toRgbString()), se === "prgb" && (W = this.toPercentageRgbString()), (se === "hex" || se === "hex6") && (W = this.toHexString()), se === "hex3" && (W = this.toHexString(!0)), se === "hex4" && (W = this.toHex8String(!0)), se === "hex8" && (W = this.toHex8String()), se === "name" && (W = this.toName()), se === "hsl" && (W = this.toHslString()), se === "hsv" && (W = this.toHsvString()), W || this.toHexString());
      },
      clone: function() {
        return l(this.toString());
      },
      _applyModification: function(se, fe) {
        var W = se.apply(null, [this].concat([].slice.call(fe)));
        return this._r = W._r, this._g = W._g, this._b = W._b, this.setAlpha(W._a), this;
      },
      lighten: function() {
        return this._applyModification(w, arguments);
      },
      brighten: function() {
        return this._applyModification(R, arguments);
      },
      darken: function() {
        return this._applyModification(M, arguments);
      },
      desaturate: function() {
        return this._applyModification(v, arguments);
      },
      saturate: function() {
        return this._applyModification(b, arguments);
      },
      greyscale: function() {
        return this._applyModification(Q, arguments);
      },
      spin: function() {
        return this._applyModification(O, arguments);
      },
      _applyCombination: function(se, fe) {
        return se.apply(null, [this].concat([].slice.call(fe)));
      },
      analogous: function() {
        return this._applyCombination(U, arguments);
      },
      complement: function() {
        return this._applyCombination(L, arguments);
      },
      monochromatic: function() {
        return this._applyCombination(X, arguments);
      },
      splitcomplement: function() {
        return this._applyCombination($, arguments);
      },
      triad: function() {
        return this._applyCombination(N, arguments);
      },
      tetrad: function() {
        return this._applyCombination(k, arguments);
      }
    }, l.fromRatio = function(se, fe) {
      if (typeof se == "object") {
        var W = {};
        for (var ge in se)
          se.hasOwnProperty(ge) && (ge === "a" ? W[ge] = se[ge] : W[ge] = Ie(se[ge]));
        se = W;
      }
      return l(se, fe);
    };
    function c(se) {
      var fe = { r: 0, g: 0, b: 0 }, W = 1, ge = null, _e = null, Re = null, Ee = !1, oe = !1;
      return typeof se == "string" && (se = Ue(se)), typeof se == "object" && (De(se.r) && De(se.g) && De(se.b) ? (fe = u(se.r, se.g, se.b), Ee = !0, oe = String(se.r).substr(-1) === "%" ? "prgb" : "rgb") : De(se.h) && De(se.s) && De(se.v) ? (ge = Ie(se.s), _e = Ie(se.v), fe = I(se.h, ge, _e), Ee = !0, oe = "hsv") : De(se.h) && De(se.s) && De(se.l) && (ge = Ie(se.s), Re = Ie(se.l), fe = h(se.h, ge, Re), Ee = !0, oe = "hsl"), se.hasOwnProperty("a") && (W = se.a)), W = V(W), {
        ok: Ee,
        format: se.format || oe,
        r: s(255, a(fe.r, 0)),
        g: s(255, a(fe.g, 0)),
        b: s(255, a(fe.b, 0)),
        a: W
      };
    }
    function u(se, fe, W) {
      return {
        r: Z(se, 255) * 255,
        g: Z(fe, 255) * 255,
        b: Z(W, 255) * 255
      };
    }
    function f(se, fe, W) {
      se = Z(se, 255), fe = Z(fe, 255), W = Z(W, 255);
      var ge = a(se, fe, W), _e = s(se, fe, W), Re, Ee, oe = (ge + _e) / 2;
      if (ge == _e)
        Re = Ee = 0;
      else {
        var ie = ge - _e;
        switch (Ee = oe > 0.5 ? ie / (2 - ge - _e) : ie / (ge + _e), ge) {
          case se:
            Re = (fe - W) / ie + (fe < W ? 6 : 0);
            break;
          case fe:
            Re = (W - se) / ie + 2;
            break;
          case W:
            Re = (se - fe) / ie + 4;
            break;
        }
        Re /= 6;
      }
      return { h: Re, s: Ee, l: oe };
    }
    function h(se, fe, W) {
      var ge, _e, Re;
      se = Z(se, 360), fe = Z(fe, 100), W = Z(W, 100);
      function Ee(Ae, de, we) {
        return we < 0 && (we += 1), we > 1 && (we -= 1), we < 1 / 6 ? Ae + (de - Ae) * 6 * we : we < 1 / 2 ? de : we < 2 / 3 ? Ae + (de - Ae) * (2 / 3 - we) * 6 : Ae;
      }
      if (fe === 0)
        ge = _e = Re = W;
      else {
        var oe = W < 0.5 ? W * (1 + fe) : W + fe - W * fe, ie = 2 * W - oe;
        ge = Ee(ie, oe, se + 1 / 3), _e = Ee(ie, oe, se), Re = Ee(ie, oe, se - 1 / 3);
      }
      return { r: ge * 255, g: _e * 255, b: Re * 255 };
    }
    function d(se, fe, W) {
      se = Z(se, 255), fe = Z(fe, 255), W = Z(W, 255);
      var ge = a(se, fe, W), _e = s(se, fe, W), Re, Ee, oe = ge, ie = ge - _e;
      if (Ee = ge === 0 ? 0 : ie / ge, ge == _e)
        Re = 0;
      else {
        switch (ge) {
          case se:
            Re = (fe - W) / ie + (fe < W ? 6 : 0);
            break;
          case fe:
            Re = (W - se) / ie + 2;
            break;
          case W:
            Re = (se - fe) / ie + 4;
            break;
        }
        Re /= 6;
      }
      return { h: Re, s: Ee, v: oe };
    }
    function I(se, fe, W) {
      se = Z(se, 360) * 6, fe = Z(fe, 100), W = Z(W, 100);
      var ge = e.floor(se), _e = se - ge, Re = W * (1 - fe), Ee = W * (1 - _e * fe), oe = W * (1 - (1 - _e) * fe), ie = ge % 6, Ae = [W, Ee, Re, Re, oe, W][ie], de = [oe, W, W, Ee, Re, Re][ie], we = [Re, Re, oe, W, W, Ee][ie];
      return { r: Ae * 255, g: de * 255, b: we * 255 };
    }
    function m(se, fe, W, ge) {
      var _e = [
        Be(o(se).toString(16)),
        Be(o(fe).toString(16)),
        Be(o(W).toString(16))
      ];
      return ge && _e[0].charAt(0) == _e[0].charAt(1) && _e[1].charAt(0) == _e[1].charAt(1) && _e[2].charAt(0) == _e[2].charAt(1) ? _e[0].charAt(0) + _e[1].charAt(0) + _e[2].charAt(0) : _e.join("");
    }
    function C(se, fe, W, ge, _e) {
      var Re = [
        Be(o(se).toString(16)),
        Be(o(fe).toString(16)),
        Be(o(W).toString(16)),
        Be(Qe(ge))
      ];
      return _e && Re[0].charAt(0) == Re[0].charAt(1) && Re[1].charAt(0) == Re[1].charAt(1) && Re[2].charAt(0) == Re[2].charAt(1) && Re[3].charAt(0) == Re[3].charAt(1) ? Re[0].charAt(0) + Re[1].charAt(0) + Re[2].charAt(0) + Re[3].charAt(0) : Re.join("");
    }
    function y(se, fe, W, ge) {
      var _e = [
        Be(Qe(ge)),
        Be(o(se).toString(16)),
        Be(o(fe).toString(16)),
        Be(o(W).toString(16))
      ];
      return _e.join("");
    }
    l.equals = function(se, fe) {
      return !se || !fe ? !1 : l(se).toRgbString() == l(fe).toRgbString();
    }, l.random = function() {
      return l.fromRatio({
        r: A(),
        g: A(),
        b: A()
      });
    };
    function v(se, fe) {
      fe = fe === 0 ? 0 : fe || 10;
      var W = l(se).toHsl();
      return W.s -= fe / 100, W.s = ce(W.s), l(W);
    }
    function b(se, fe) {
      fe = fe === 0 ? 0 : fe || 10;
      var W = l(se).toHsl();
      return W.s += fe / 100, W.s = ce(W.s), l(W);
    }
    function Q(se) {
      return l(se).desaturate(100);
    }
    function w(se, fe) {
      fe = fe === 0 ? 0 : fe || 10;
      var W = l(se).toHsl();
      return W.l += fe / 100, W.l = ce(W.l), l(W);
    }
    function R(se, fe) {
      fe = fe === 0 ? 0 : fe || 10;
      var W = l(se).toRgb();
      return W.r = a(0, s(255, W.r - o(255 * -(fe / 100)))), W.g = a(0, s(255, W.g - o(255 * -(fe / 100)))), W.b = a(0, s(255, W.b - o(255 * -(fe / 100)))), l(W);
    }
    function M(se, fe) {
      fe = fe === 0 ? 0 : fe || 10;
      var W = l(se).toHsl();
      return W.l -= fe / 100, W.l = ce(W.l), l(W);
    }
    function O(se, fe) {
      var W = l(se).toHsl(), ge = (W.h + fe) % 360;
      return W.h = ge < 0 ? 360 + ge : ge, l(W);
    }
    function L(se) {
      var fe = l(se).toHsl();
      return fe.h = (fe.h + 180) % 360, l(fe);
    }
    function N(se) {
      var fe = l(se).toHsl(), W = fe.h;
      return [
        l(se),
        l({ h: (W + 120) % 360, s: fe.s, l: fe.l }),
        l({ h: (W + 240) % 360, s: fe.s, l: fe.l })
      ];
    }
    function k(se) {
      var fe = l(se).toHsl(), W = fe.h;
      return [
        l(se),
        l({ h: (W + 90) % 360, s: fe.s, l: fe.l }),
        l({ h: (W + 180) % 360, s: fe.s, l: fe.l }),
        l({ h: (W + 270) % 360, s: fe.s, l: fe.l })
      ];
    }
    function $(se) {
      var fe = l(se).toHsl(), W = fe.h;
      return [
        l(se),
        l({ h: (W + 72) % 360, s: fe.s, l: fe.l }),
        l({ h: (W + 216) % 360, s: fe.s, l: fe.l })
      ];
    }
    function U(se, fe, W) {
      fe = fe || 6, W = W || 30;
      var ge = l(se).toHsl(), _e = 360 / W, Re = [l(se)];
      for (ge.h = (ge.h - (_e * fe >> 1) + 720) % 360; --fe; )
        ge.h = (ge.h + _e) % 360, Re.push(l(ge));
      return Re;
    }
    function X(se, fe) {
      fe = fe || 6;
      for (var W = l(se).toHsv(), ge = W.h, _e = W.s, Re = W.v, Ee = [], oe = 1 / fe; fe--; )
        Ee.push(l({ h: ge, s: _e, v: Re })), Re = (Re + oe) % 1;
      return Ee;
    }
    l.mix = function(se, fe, W) {
      W = W === 0 ? 0 : W || 50;
      var ge = l(se).toRgb(), _e = l(fe).toRgb(), Re = W / 100, Ee = {
        r: (_e.r - ge.r) * Re + ge.r,
        g: (_e.g - ge.g) * Re + ge.g,
        b: (_e.b - ge.b) * Re + ge.b,
        a: (_e.a - ge.a) * Re + ge.a
      };
      return l(Ee);
    }, l.readability = function(se, fe) {
      var W = l(se), ge = l(fe);
      return (e.max(W.getLuminance(), ge.getLuminance()) + 0.05) / (e.min(W.getLuminance(), ge.getLuminance()) + 0.05);
    }, l.isReadable = function(se, fe, W) {
      var ge = l.readability(se, fe), _e, Re;
      switch (Re = !1, _e = Te(W), _e.level + _e.size) {
        case "AAsmall":
        case "AAAlarge":
          Re = ge >= 4.5;
          break;
        case "AAlarge":
          Re = ge >= 3;
          break;
        case "AAAsmall":
          Re = ge >= 7;
          break;
      }
      return Re;
    }, l.mostReadable = function(se, fe, W) {
      var ge = null, _e = 0, Re, Ee, oe, ie;
      W = W || {}, Ee = W.includeFallbackColors, oe = W.level, ie = W.size;
      for (var Ae = 0; Ae < fe.length; Ae++)
        Re = l.readability(se, fe[Ae]), Re > _e && (_e = Re, ge = l(fe[Ae]));
      return l.isReadable(se, ge, { level: oe, size: ie }) || !Ee ? ge : (W.includeFallbackColors = !1, l.mostReadable(se, ["#fff", "#000"], W));
    };
    var K = l.names = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "0ff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "00f",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      burntsienna: "ea7e5d",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "0ff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "f0f",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    }, z = l.hexNames = Y(K);
    function Y(se) {
      var fe = {};
      for (var W in se)
        se.hasOwnProperty(W) && (fe[se[W]] = W);
      return fe;
    }
    function V(se) {
      return se = parseFloat(se), (isNaN(se) || se < 0 || se > 1) && (se = 1), se;
    }
    function Z(se, fe) {
      pe(se) && (se = "100%");
      var W = Ce(se);
      return se = s(fe, a(0, parseFloat(se))), W && (se = parseInt(se * fe, 10) / 100), e.abs(se - fe) < 1e-6 ? 1 : se % fe / parseFloat(fe);
    }
    function ce(se) {
      return s(1, a(0, se));
    }
    function ee(se) {
      return parseInt(se, 16);
    }
    function pe(se) {
      return typeof se == "string" && se.indexOf(".") != -1 && parseFloat(se) === 1;
    }
    function Ce(se) {
      return typeof se == "string" && se.indexOf("%") != -1;
    }
    function Be(se) {
      return se.length == 1 ? "0" + se : "" + se;
    }
    function Ie(se) {
      return se <= 1 && (se = se * 100 + "%"), se;
    }
    function Qe(se) {
      return e.round(parseFloat(se) * 255).toString(16);
    }
    function xe(se) {
      return ee(se) / 255;
    }
    var Se = function() {
      var se = "[-\\+]?\\d+%?", fe = "[-\\+]?\\d*\\.\\d+%?", W = "(?:" + fe + ")|(?:" + se + ")", ge = "[\\s|\\(]+(" + W + ")[,|\\s]+(" + W + ")[,|\\s]+(" + W + ")\\s*\\)?", _e = "[\\s|\\(]+(" + W + ")[,|\\s]+(" + W + ")[,|\\s]+(" + W + ")[,|\\s]+(" + W + ")\\s*\\)?";
      return {
        CSS_UNIT: new RegExp(W),
        rgb: new RegExp("rgb" + ge),
        rgba: new RegExp("rgba" + _e),
        hsl: new RegExp("hsl" + ge),
        hsla: new RegExp("hsla" + _e),
        hsv: new RegExp("hsv" + ge),
        hsva: new RegExp("hsva" + _e),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
      };
    }();
    function De(se) {
      return !!Se.CSS_UNIT.exec(se);
    }
    function Ue(se) {
      se = se.replace(n, "").replace(r, "").toLowerCase();
      var fe = !1;
      if (K[se])
        se = K[se], fe = !0;
      else if (se == "transparent")
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
      var W;
      return (W = Se.rgb.exec(se)) ? { r: W[1], g: W[2], b: W[3] } : (W = Se.rgba.exec(se)) ? { r: W[1], g: W[2], b: W[3], a: W[4] } : (W = Se.hsl.exec(se)) ? { h: W[1], s: W[2], l: W[3] } : (W = Se.hsla.exec(se)) ? { h: W[1], s: W[2], l: W[3], a: W[4] } : (W = Se.hsv.exec(se)) ? { h: W[1], s: W[2], v: W[3] } : (W = Se.hsva.exec(se)) ? { h: W[1], s: W[2], v: W[3], a: W[4] } : (W = Se.hex8.exec(se)) ? {
        r: ee(W[1]),
        g: ee(W[2]),
        b: ee(W[3]),
        a: xe(W[4]),
        format: fe ? "name" : "hex8"
      } : (W = Se.hex6.exec(se)) ? {
        r: ee(W[1]),
        g: ee(W[2]),
        b: ee(W[3]),
        format: fe ? "name" : "hex"
      } : (W = Se.hex4.exec(se)) ? {
        r: ee(W[1] + "" + W[1]),
        g: ee(W[2] + "" + W[2]),
        b: ee(W[3] + "" + W[3]),
        a: xe(W[4] + "" + W[4]),
        format: fe ? "name" : "hex8"
      } : (W = Se.hex3.exec(se)) ? {
        r: ee(W[1] + "" + W[1]),
        g: ee(W[2] + "" + W[2]),
        b: ee(W[3] + "" + W[3]),
        format: fe ? "name" : "hex"
      } : !1;
    }
    function Te(se) {
      var fe, W;
      return se = se || { level: "AA", size: "small" }, fe = (se.level || "AA").toUpperCase(), W = (se.size || "small").toLowerCase(), fe !== "AA" && fe !== "AAA" && (fe = "AA"), W !== "small" && W !== "large" && (W = "small"), { level: fe, size: W };
    }
    t.exports ? t.exports = l : window.tinycolor = l;
  })(Math);
})(JHe);
const _ee = JHe.exports, tbe = (t) => {
  const e = ["r", "g", "b", "a", "h", "s", "l", "v"];
  let n = 0, r = 0;
  return Ktn(e, (i) => {
    t[i] && (n += 1, isNaN(t[i]) || (r += 1), (i === "s" || i === "l") && /^\d+%$/.test(t[i]) && (r += 1));
  }), n === r ? t : !1;
}, GF = (t, e) => {
  const n = t.hex ? _ee(t.hex) : _ee(t), r = n.toHsl(), i = n.toHsv(), o = n.toRgb(), s = n.toHex();
  r.s === 0 && (r.h = e || 0, i.h = e || 0);
  const a = s === "000000" && o.a === 0;
  return {
    hsl: r,
    hex: a ? "transparent" : `#${s}`,
    rgb: o,
    hsv: i,
    oldHue: t.h || e || r.h,
    source: t.source
  };
}, Wtn = (t) => {
  if (t === "transparent")
    return !0;
  const e = String(t).charAt(0) === "#" ? 1 : 0;
  return t.length !== 4 + e && t.length < 7 + e && _ee(t).isValid();
}, Y7 = {}, Xtn = (t, e, n, r) => {
  if (typeof document > "u" && !r)
    return null;
  const i = r ? new r() : document.createElement("canvas");
  i.width = n * 2, i.height = n * 2;
  const o = i.getContext("2d");
  return o ? (o.fillStyle = t, o.fillRect(0, 0, i.width, i.height), o.fillStyle = e, o.fillRect(0, 0, n, n), o.translate(n, n), o.fillRect(0, 0, n, n), i.toDataURL()) : null;
}, Ztn = (t, e, n, r) => {
  const i = `${t}-${e}-${n}${r ? "-server" : ""}`;
  if (Y7[i])
    return Y7[i];
  const o = Xtn(t, e, n, r);
  return Y7[i] = o, o;
}, KHe = ({ white: t, grey: e, size: n, renderers: r, borderRadius: i, boxShadow: o, children: s }) => {
  const a = J9({
    default: {
      grid: {
        borderRadius: i,
        boxShadow: o,
        absolute: "0px 0px 0px 0px",
        background: `url(${Ztn(t, e, n, r.canvas)}) center left`
      }
    }
  });
  return uD(s) ? St.cloneElement(s, { ...s.props, style: { ...s.props.style, ...a.grid } }) : /* @__PURE__ */ St.createElement("div", {
    style: a.grid
  });
};
KHe.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
const enn = 1, WHe = 38, tnn = 40, nnn = [
  WHe,
  tnn
], rnn = (t) => nnn.indexOf(t) > -1, inn = (t) => Number(String(t).replace(/%/g, ""));
let onn = 1;
class snn extends (ise || N3e) {
  constructor(e) {
    super(), gg(this, "handleBlur", () => {
      this.state.blurValue && this.setState({ value: this.state.blurValue, blurValue: null });
    }), gg(this, "handleChange", (n) => {
      this.setUpdatedValue(n.target.value, n);
    }), gg(this, "handleKeyDown", (n) => {
      const r = inn(n.target.value);
      if (!isNaN(r) && rnn(n.keyCode)) {
        const i = this.getArrowOffset(), o = n.keyCode === WHe ? r + i : r - i;
        this.setUpdatedValue(o, n);
      }
    }), gg(this, "handleDrag", (n) => {
      if (this.props.dragLabel) {
        const r = Math.round(this.props.value + n.movementX);
        r >= 0 && r <= this.props.dragMax && this.props.onChange && this.props.onChange(this.getValueObjectWithLabel(r), n);
      }
    }), gg(this, "handleMouseDown", (n) => {
      this.props.dragLabel && (n.preventDefault(), this.handleDrag(n), window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleMouseUp));
    }), gg(this, "handleMouseUp", () => {
      this.unbindEventListeners();
    }), gg(this, "unbindEventListeners", () => {
      window.removeEventListener("mousemove", this.handleDrag), window.removeEventListener("mouseup", this.handleMouseUp);
    }), this.state = {
      value: String(e.value).toUpperCase(),
      blurValue: String(e.value).toUpperCase()
    }, this.inputId = `rc-editable-input-${onn++}`;
  }
  componentDidUpdate(e, n) {
    this.props.value !== this.state.value && (e.value !== this.props.value || n.value !== this.state.value) && (this.input === document.activeElement ? this.setState({ blurValue: String(this.props.value).toUpperCase() }) : this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() }));
  }
  componentWillUnmount() {
    this.unbindEventListeners();
  }
  getValueObjectWithLabel(e) {
    return {
      [this.props.label]: e
    };
  }
  getArrowOffset() {
    return this.props.arrowOffset || enn;
  }
  setUpdatedValue(e, n) {
    const r = this.props.label ? this.getValueObjectWithLabel(e) : e;
    this.props.onChange && this.props.onChange(r, n), this.setState({ value: e });
  }
  render() {
    const e = J9({
      default: {
        wrap: {
          position: "relative"
        }
      },
      "user-override": {
        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
        input: this.props.style && this.props.style.input ? this.props.style.input : {},
        label: this.props.style && this.props.style.label ? this.props.style.label : {}
      },
      "dragLabel-true": {
        label: {
          cursor: "ew-resize"
        }
      }
    }, {
      "user-override": !0
    }, this.props);
    return /* @__PURE__ */ St.createElement("div", {
      style: e.wrap
    }, /* @__PURE__ */ St.createElement("input", {
      id: this.inputId,
      style: e.input,
      ref: (n) => this.input = n,
      value: this.state.value,
      onKeyDown: this.handleKeyDown,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      placeholder: this.props.placeholder,
      spellCheck: "false"
    }), this.props.label && !this.props.hideLabel ? /* @__PURE__ */ St.createElement("label", {
      htmlFor: this.inputId,
      style: e.label,
      onMouseDown: this.handleMouseDown
    }, this.props.label) : null);
  }
}
hg.exports.string, hg.exports.oneOf([0, 1, 2, 3, 4, 5]), hg.exports.number, hg.exports.object;
var ann = xd, Ann = function() {
  return ann.Date.now();
}, lnn = Ann, cnn = /\s/;
function unn(t) {
  for (var e = t.length; e-- && cnn.test(t.charAt(e)); )
    ;
  return e;
}
var fnn = unn, gnn = fnn, hnn = /^\s+/;
function dnn(t) {
  return t && t.slice(0, gnn(t) + 1).replace(hnn, "");
}
var pnn = dnn, Inn = pnn, nbe = Rd, mnn = Y9, rbe = 0 / 0, Cnn = /^[-+]0x[0-9a-f]+$/i, Enn = /^0b[01]+$/i, ynn = /^0o[0-7]+$/i, vnn = parseInt;
function Bnn(t) {
  if (typeof t == "number")
    return t;
  if (mnn(t))
    return rbe;
  if (nbe(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = nbe(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = Inn(t);
  var n = Enn.test(t);
  return n || ynn.test(t) ? vnn(t.slice(2), n ? 2 : 8) : Cnn.test(t) ? rbe : +t;
}
var bnn = Bnn, _nn = Rd, z7 = lnn, ibe = bnn, Snn = "Expected a function", Qnn = Math.max, wnn = Math.min;
function xnn(t, e, n) {
  var r, i, o, s, a, A, l = 0, c = !1, u = !1, f = !0;
  if (typeof t != "function")
    throw new TypeError(Snn);
  e = ibe(e) || 0, _nn(n) && (c = !!n.leading, u = "maxWait" in n, o = u ? Qnn(ibe(n.maxWait) || 0, e) : o, f = "trailing" in n ? !!n.trailing : f);
  function h(w) {
    var R = r, M = i;
    return r = i = void 0, l = w, s = t.apply(M, R), s;
  }
  function d(w) {
    return l = w, a = setTimeout(C, e), c ? h(w) : s;
  }
  function I(w) {
    var R = w - A, M = w - l, O = e - R;
    return u ? wnn(O, o - M) : O;
  }
  function m(w) {
    var R = w - A, M = w - l;
    return A === void 0 || R >= e || R < 0 || u && M >= o;
  }
  function C() {
    var w = z7();
    if (m(w))
      return y(w);
    a = setTimeout(C, I(w));
  }
  function y(w) {
    return a = void 0, f && r ? h(w) : (r = i = void 0, s);
  }
  function v() {
    a !== void 0 && clearTimeout(a), l = 0, r = A = i = a = void 0;
  }
  function b() {
    return a === void 0 ? s : y(z7());
  }
  function Q() {
    var w = z7(), R = m(w);
    if (r = arguments, i = this, A = w, R) {
      if (a === void 0)
        return d(A);
      if (u)
        return clearTimeout(a), a = setTimeout(C, e), h(A);
    }
    return a === void 0 && (a = setTimeout(C, e)), s;
  }
  return Q.cancel = v, Q.flush = b, Q;
}
var Rnn = xnn;
const Dnn = (t) => {
  class e extends (ise || N3e) {
    constructor(r) {
      super(), gg(this, "handleChange", (i, o) => {
        if (tbe(i)) {
          const a = GF(i, i.h || this.state.oldHue);
          this.setState(a), this.props.onChangeComplete && this.debounce(this.props.onChangeComplete, a, o), this.props.onChange && this.props.onChange(a, o);
        }
      }), gg(this, "handleSwatchHover", (i, o) => {
        if (tbe(i)) {
          const a = GF(i, i.h || this.state.oldHue);
          this.props.onSwatchHover && this.props.onSwatchHover(a, o);
        }
      }), this.state = {
        ...GF(r.color, 0)
      }, this.debounce = Rnn((i, o, s) => {
        i(o, s);
      }, 100);
    }
    static getDerivedStateFromProps(r, i) {
      return {
        ...GF(r.color, i.oldHue)
      };
    }
    render() {
      const r = {};
      return this.props.onSwatchHover && (r.onSwatchHover = this.handleSwatchHover), /* @__PURE__ */ St.createElement(t, {
        ...this.props,
        ...this.state,
        onChange: this.handleChange,
        ...r
      });
    }
  }
  return e.propTypes = {
    ...t.propTypes
  }, e.defaultProps = {
    ...t.defaultProps,
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  }, e;
}, Tnn = (t, e = "span") => class extends St.Component {
  constructor() {
    super(...arguments), gg(this, "state", { focus: !1 }), gg(this, "handleFocus", () => this.setState({ focus: !0 })), gg(this, "handleBlur", () => this.setState({ focus: !1 }));
  }
  render() {
    return /* @__PURE__ */ St.createElement(e, {
      onFocus: this.handleFocus,
      onBlur: this.handleBlur
    }, /* @__PURE__ */ St.createElement(t, {
      ...this.props,
      ...this.state
    }));
  }
}, Nnn = 13, Lnn = ({
  color: t,
  style: e,
  onClick: n = () => {
  },
  onHover: r,
  title: i = t,
  children: o,
  focus: s,
  focusStyle: a = {}
}) => {
  const A = t === "transparent", l = J9({
    default: {
      swatch: {
        background: t,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none",
        ...e,
        ...s ? a : {}
      }
    }
  }), c = (d) => n(t, d), u = (d) => d.keyCode === Nnn && n(t, d), f = (d) => r(t, d), h = {};
  return r && (h.onMouseOver = f), /* @__PURE__ */ St.createElement("div", {
    style: l.swatch,
    onClick: c,
    title: i,
    tabIndex: 0,
    onKeyDown: u,
    ...h
  }, o, A && /* @__PURE__ */ St.createElement(KHe, {
    borderRadius: l.swatch.borderRadius,
    boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
  }));
}, Mnn = Tnn(Lnn), ole = ({
  onChange: t,
  onSwatchHover: e,
  hex: n,
  colors: r,
  width: i,
  triangle: o,
  styles: s = {},
  className: a = ""
}) => {
  const A = J9($tn({
    default: {
      card: {
        width: i,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, s), {
    "hide-triangle": o === "hide",
    "top-left-triangle": o === "top-left",
    "top-right-triangle": o === "top-right"
  }), l = (c, u) => {
    Wtn(c) && t({
      hex: c,
      source: "hex"
    }, u);
  };
  return /* @__PURE__ */ St.createElement("div", {
    style: A.card,
    className: `twitter-picker ${a}`
  }, /* @__PURE__ */ St.createElement("div", {
    style: A.triangleShadow
  }), /* @__PURE__ */ St.createElement("div", {
    style: A.triangle
  }), /* @__PURE__ */ St.createElement("div", {
    style: A.body
  }, THe(r, (c, u) => /* @__PURE__ */ St.createElement(Mnn, {
    key: u,
    color: c,
    hex: c,
    style: A.swatch,
    onClick: l,
    onHover: e,
    focusStyle: {
      boxShadow: `0 0 4px ${c}`
    }
  })), /* @__PURE__ */ St.createElement("div", {
    style: A.hash
  }, "#"), /* @__PURE__ */ St.createElement(snn, {
    label: null,
    style: { input: A.input },
    value: n.replace("#", ""),
    onChange: l
  }), /* @__PURE__ */ St.createElement("div", {
    style: A.clear
  })));
};
ole.propTypes = {
  width: hg.exports.oneOfType([hg.exports.string, hg.exports.number]),
  triangle: hg.exports.oneOf(["hide", "top-left", "top-right"]),
  colors: hg.exports.arrayOf(hg.exports.string),
  styles: hg.exports.object
};
ole.defaultProps = {
  width: 276,
  colors: [
    "#FF6900",
    "#FCB900",
    "#7BDCB5",
    "#00D084",
    "#8ED1FC",
    "#0693E3",
    "#ABB8C3",
    "#EB144C",
    "#F78DA7",
    "#9900EF"
  ],
  triangle: "top-left",
  styles: {}
};
const XHe = Dnn(ole);
function ZHe(t) {
  return ne.jsx(P9, { ...t });
}
ZHe.defaultProps = {
  overlayClassName: "popover",
  placement: "top",
  trigger: "click",
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0
};
function Onn(t) {
  const { title: e, subtitle: n, onClick: r, handler: i, handlerKey: o, confirm: s, visible: a } = t, [A, l] = mn(!1);
  Mn(() => {
    l(!1);
  }, [a]);
  function c() {
    !s || A ? (r(), i()) : l(!0);
  }
  const u = `${A ? "Confirm " : ""}${e}`, f = UAe();
  return ne.jsxs("button", { title: u, type: "button", onClick: c, onKeyPress: (h) => C9(h, o, c), children: [u, n && ne.jsxs(ne.Fragment, { children: [ne.jsx("br", {}), ne.jsx("span", { className: f.small, children: n })] })] });
}
function Fnn(t) {
  const { menuConfig: e, onClick: n, color: r = null, palette: i = null, setColor: o = null, visible: s } = t;
  function a({ rgb: c }) {
    c && o && o([c.r, c.g, c.b]);
  }
  const A = i ? i.map(Qu) : Gv.concat([[255, 255, 255], [128, 128, 128], [0, 0, 0]]).map(Qu), l = UAe();
  return ne.jsxs("div", { children: [r && o && A && ne.jsx(XHe, { className: l.popoverMenuColor, disableAlpha: !0, width: 108, triangle: "hide", colors: A, color: Qu(r), onChangeComplete: a }), ne.jsx("ul", { className: l.popoverMenuList, children: e.map((c) => ne.jsx("li", { children: ne.jsx(Onn, { ...c, onClick: n, visible: s }) }, c.title + c.subtitle)) })] });
}
function e9e(t) {
  const { menuConfig: e, placement: n, children: r, color: i = null, setColor: o = null, palette: s = null } = t, [a, A] = mn(!1);
  return ne.jsx(ZHe, { content: ne.jsx(Fnn, { menuConfig: e, onClick: () => A(!1), color: i, setColor: o, palette: s, visible: a }), placement: n, visible: a, onVisibleChange: A, children: r });
}
function obe(t) {
  const { path: e, level: n, height: r, onCheckNode: i, onNodeRemove: o, onNodeSetIsEditing: s, onExportLevelZeroNodeJSON: a, onExportLevelZeroNodeTabular: A, onExportSetJSON: l, checkable: c, editable: u, exportable: f, checked: h } = t;
  return [
    ...u ? [
      {
        title: "Rename",
        handler: () => {
          s(e, !0);
        },
        handlerKey: "r"
      },
      {
        title: "Delete",
        confirm: !0,
        handler: () => {
          o(e);
        },
        handlerKey: "d"
      }
    ] : [],
    ...n === 0 && f ? [
      {
        title: "Export hierarchy",
        subtitle: "(to JSON file)",
        handler: () => {
          a(e);
        },
        handlerKey: "j"
      },
      ...r <= 1 ? [
        {
          title: "Export hierarchy",
          subtitle: "(to CSV file)",
          handler: () => {
            A(e);
          },
          handlerKey: "t"
        }
      ] : []
    ] : [],
    ...n > 0 ? [
      ...c ? [
        {
          title: h ? "Uncheck" : "Check",
          handler: () => {
            i(e, !h);
          },
          handlerKey: "s"
        }
      ] : [],
      ...f ? [
        {
          title: "Export set",
          subtitle: "(to JSON file)",
          handler: () => {
            l(e);
          },
          handlerKey: "e"
        }
      ] : []
    ] : []
  ];
}
function Pnn(t) {
  const { title: e, path: n, nodeKey: r, level: i, height: o, color: s, checkbox: a, isChecking: A, isLeaf: l, onNodeSetColor: c, onNodeView: u, expanded: f, onCheckLevel: h, checkedLevelPath: d, checkedLevelIndex: I, disableTooltip: m, size: C, datatype: y, editable: v, theme: b } = t, Q = i === 0 && !f, w = I && gr(n, d) && I < o ? I + 1 : 1, M = new Intl.NumberFormat("en-US").format(C);
  let O;
  Q ? O = m5e(w) : l || !f ? O = `Color individual set (${M} ${y}${C === 1 ? "" : "s"})` : O = "Color by expanded descendants";
  const L = i === 0 && !f ? () => h(r, w) : () => u(n), N = m ? { visible: !1 } : {}, k = obe(t), $ = $L();
  return ne.jsxs("span", { children: [ne.jsx(P9, { title: O, ...N, children: ne.jsx("button", { type: "button", onClick: L, onKeyPress: (U) => C9(U, "v", () => u(n)), className: $.titleButton, children: e }) }), k.length > 0 ? ne.jsx(e9e, { menuConfig: obe(t), color: i > 0 && v ? s || da(b) : null, setColor: (U) => c(n, U), children: ne.jsx(G6t, { className: $.nodeMenuIcon }) }) : null, i > 0 && A ? a : null, i > 0 && ne.jsx("span", { className: $.nodeSizeLabel, children: M })] });
}
function knn(t) {
  const { title: e, path: n, onNodeSetName: r, onNodeCheckNewName: i } = t, [o, s] = mn(e), a = i(n, o);
  function A() {
    a || r(n, o, !0);
  }
  const l = $L();
  return ne.jsxs("span", { className: l.titleButtonWithInput, children: [ne.jsx("input", {
    // eslint-disable-next-line jsx-a11y/no-autofocus
    autoFocus: !0,
    className: l.titleInput,
    type: "text",
    value: o,
    onChange: (c) => {
      s(c.target.value);
    },
    onKeyPress: (c) => C9(c, "Enter", A),
    onFocus: (c) => c.target.select()
  }), !a && ne.jsx("button", { type: "button", className: l.titleSaveButton, onClick: A, children: "Save" })] });
}
function Gnn(t) {
  const { isEditing: e, isCurrentSet: n } = t;
  return e || n ? ne.jsx(knn, { ...t }) : ne.jsx(Pnn, { ...t });
}
function Unn(t) {
  const { nodeKey: e, path: n, height: r, onCheckLevel: i, checkedLevelPath: o, checkedLevelIndex: s, hasColorEncoding: a } = t;
  function A(c) {
    if (c.target.checked) {
      const u = parseInt(c.target.value, 10);
      i(e, u);
    }
  }
  const l = $L();
  return ne.jsx("div", { className: l.levelButtonsContainer, children: oA(1, r + 1).map((c) => {
    const u = gr(n, o) && c === s;
    return ne.jsx("div", { children: ne.jsx(P9, { title: m5e(c), children: ne.jsx("input", { className: Xt(l.levelRadioButton, { [l.levelRadioButtonChecked]: u && !a }), type: "checkbox", value: c, checked: u && a, onChange: A }) }) }, c);
  }) });
}
function Hnn(t) {
  const { isLeaf: e, isOpen: n, color: r } = t, i = r ? Qu(r) : void 0;
  return e ? ne.jsx("i", { className: "anticon anticon-circle rc-tree-switcher-icon", children: ne.jsx("svg", { viewBox: "0 0 1024 1024", focusable: "false", "data-icon": "caret-down", width: "1em", height: "1em", "aria-hidden": "true", children: ne.jsx("rect", { fill: i, x: 600 / 2, y: 600 / 2, width: 1024 - 600, height: 1024 - 600 }) }) }) : ne.jsx("i", { className: "anticon anticon-caret-down rc-tree-switcher-icon", children: ne.jsx("svg", { viewBox: "0 0 1024 1024", focusable: "false", "data-icon": "caret-down", width: "1em", height: "1em", "aria-hidden": "true", children: ne.jsx("path", { fill: n ? "#444" : i, d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" }) }) });
}
let $nn = class extends JI {
  constructor() {
    super(...arguments);
    /**
     * Override the main node text elements.
     */
    Sr(this, "renderSelector", () => {
      const { title: n, isCurrentSet: r, isSelected: i, isEditing: o, onDragStart: s } = this.props, { rcTree: { prefixCls: a, draggable: A } } = this.context, l = (f) => {
        s(), this.onDragStart(f);
      }, c = `${a}-node-content-wrapper`, u = !r && !o && A;
      return ne.jsxs("span", { ref: this.setSelectHandle, title: n, className: Xt(c, `${c}-${this.getNodeState() || "normal"}`, i && `${a}-node-selected`, u && "draggable"), draggable: u, "aria-grabbed": u, onDragStart: u ? l : void 0, children: [ne.jsx(Gnn, { ...this.props, prefixClass: a, checkbox: this.renderCheckbox() }), this.renderLevels()] });
    });
    /**
     * Render the LevelsButtons component if this node
     * is a collapsed level zero node.
     */
    Sr(this, "renderLevels", () => {
      const { level: n, expanded: r } = this.props;
      return n !== 0 || r ? null : ne.jsx(Unn, { ...this.props });
    });
    /**
     * Override the switcher element.
     */
    Sr(this, "renderSwitcher", () => {
      const { expanded: n, isLeaf: r, color: i } = this.props, { rcTree: { prefixCls: o, onNodeExpand: s } } = this.context, a = (l) => {
        r || s(l, this);
      }, A = Xt(`${o}-switcher`, { [`${o}-switcher_${n ? "open" : "close"}`]: !r });
      return ne.jsx("span", { className: A, onClick: a, onKeyPress: (l) => C9(l, "d", a), role: "button", tabIndex: "0", children: ne.jsx(Hnn, { isLeaf: r, isOpen: n, color: i }) });
    });
  }
  /**
   * Override main render function,
   * to enable overriding the sub-render functions
   * for switcher, selector, etc.
   */
  render() {
    const { style: n, loading: r, level: i, dragOver: o, dragOverGapTop: s, dragOverGapBottom: a, isLeaf: A, expanded: l, selected: c, checked: u, halfChecked: f, onDragEnd: h, expandable: d, ...I } = this.props, { rcTree: { prefixCls: m, filterTreeNode: C, draggable: y } } = this.context, v = this.isDisabled(), b = TAe(I), Q = (w) => {
      h(), this.onDragEnd(w);
    };
    return ne.jsxs("li", { className: Xt("rc-tree-treenode", `level-${i}-treenode`, {
      [`${m}-treenode-disabled`]: v,
      [`${m}-treenode-switcher-${l ? "open" : "close"}`]: !A,
      [`${m}-treenode-checkbox-checked`]: u,
      [`${m}-treenode-checkbox-indeterminate`]: f,
      [`${m}-treenode-selected`]: c,
      [`${m}-treenode-loading`]: r,
      "drag-over": !v && o,
      "drag-over-gap-top": !v && s,
      "drag-over-gap-bottom": !v && a,
      "filter-node": C && C(this)
    }), style: n, role: "treeitem", "aria-selected": c, onDragEnter: y ? this.onDragEnter : void 0, onDragOver: y ? this.onDragOver : void 0, onDragLeave: y ? this.onDragLeave : void 0, onDrop: y ? this.onDrop.bind(this) : void 0, onDragEnd: y ? Q : void 0, ...b, children: [d ? this.renderSwitcher() : null, this.renderSelector(), this.renderChildren()] });
  }
};
function qnn(t) {
  const { datatype: e, onError: n, onImportTree: r, onCreateLevelZeroNode: i, importable: o, editable: s } = t, a = $L(), A = Qn((c, u) => () => {
    const f = document.createElement("input");
    f.setAttribute("type", "file"), f.setAttribute("accept", u), document.body.appendChild(f), f.click(), f.addEventListener("change", (h) => {
      if (!(window.File && window.FileReader && window.FileList && window.Blob)) {
        n("Local file reading APIs are not fully supported in this browser.");
        return;
      }
      const { files: d } = h.target;
      if (!d || d.length !== 1) {
        n("Incorrect number of files selected.");
        return;
      }
      const I = new FileReader();
      I.addEventListener("load", () => {
        const { result: m } = I;
        try {
          const C = c(m, e);
          n(!1), r(C);
        } catch (C) {
          n(C.message);
        }
      }, !1), I.readAsText(d[0]);
    }), f.remove();
  }, [e, n, r]), l = [
    ...s ? [
      {
        title: "Create hierarchy",
        handler: i,
        handlerKey: "n"
      }
    ] : [],
    ...o ? [
      {
        title: "Import hierarchy",
        subtitle: "(from CSV file)",
        handler: A(mUt, g5e),
        handlerKey: "c"
      },
      {
        title: "Import hierarchy",
        subtitle: "(from JSON file)",
        handler: A(IUt, f5e),
        handlerKey: "j"
      }
    ] : []
  ];
  return l.length > 0 ? ne.jsx(e9e, { menuConfig: l, children: ne.jsx("button", { className: a.plusButton, type: "submit", children: "+" }) }) : null;
}
function jnn(t) {
  const { onUnion: e, onIntersection: n, onComplement: r, operatable: i, hasCheckedSetsToUnion: o, hasCheckedSetsToIntersect: s, hasCheckedSetsToComplement: a } = t;
  return ne.jsx(ne.Fragment, { children: i && ne.jsxs(ne.Fragment, { children: [ne.jsx("button", { onClick: e, title: "New set from union of checked sets", type: "submit", disabled: !o, children: ne.jsx(F6t, {}) }), ne.jsx("button", { onClick: n, title: "New set from intersection of checked sets", type: "submit", disabled: !s, children: ne.jsx(P6t, {}) }), ne.jsx("button", { onClick: r, title: "New set from complement of checked sets", type: "submit", disabled: !a, children: ne.jsx(k6t, {}) })] }) });
}
function t9e(t, e, n, r) {
  const i = [...e, t.name];
  return {
    ...t,
    ...t.children ? {
      children: t.children.map((o) => t9e(o, i, n))
    } : {},
    color: n?.find((o) => gr(o.path, i))?.color || da(r)
  };
}
function sbe(t, e, n) {
  return {
    ...t,
    tree: t ? t.tree.map((r) => t9e(r, [], e, n)) : []
  };
}
function n9e(t, e = []) {
  if (!t)
    return null;
  const n = [...e, t.name];
  return t.children ? [k_(n), ...t.children.flatMap((r) => n9e(r, n))] : k_(n);
}
function Ynn(t) {
  const { theme: e, sets: n, additionalSets: r, setColor: i, levelSelection: o, setSelection: s, setExpansion: a, hasColorEncoding: A, datatype: l, draggable: c = !0, checkable: u = !0, editable: f = !0, expandable: h = !0, operatable: d = !0, exportable: I = !0, importable: m = !0, onError: C, onCheckNode: y, onExpandNode: v, onDropNode: b, onCheckLevel: Q, onNodeSetColor: w, onNodeSetName: R, onNodeCheckNewName: M, onNodeRemove: O, onNodeView: L, onImportTree: N, onCreateLevelZeroNode: k, onExportLevelZeroNodeJSON: $, onExportLevelZeroNodeTabular: U, onExportSetJSON: X, onUnion: K, onIntersection: z, onComplement: Y, hasCheckedSetsToUnion: V, hasCheckedSetsToIntersect: Z, hasCheckedSetsToComplement: ce } = t, ee = !0, pe = !0, [Ce, Be] = mn(!1), [Ie, Qe] = mn(null), xe = dt(() => sbe(n, i, e), [n, i, e]), Se = dt(() => sbe(r, i, e), [r, i, e]), De = Se ? Se.tree.flatMap((Ee) => n9e(Ee, [])) : [], Ue = (s || []).map(k_), Te = (a || []).map(k_), se = Ue.filter((Ee) => !De.includes(Ee)), fe = Te.filter((Ee) => !De.includes(Ee)), W = Ue.filter((Ee) => De.includes(Ee)), ge = Te.filter((Ee) => De.includes(Ee));
  function _e(Ee, oe, ie) {
    return Ee ? Ee.map((Ae) => {
      const de = [...ie, Ae.name];
      return ne.jsx($nn, { theme: e, ...eUt(Ae, de, i), isEditing: gr(Ie, de), datatype: l, draggable: c && !oe, editable: f && !oe, checkable: u, expandable: h, exportable: I, hasColorEncoding: A, isChecking: ee, checkedLevelPath: o ? o.levelZeroPath : null, checkedLevelIndex: o ? o.levelIndex : null, onCheckNode: y, onCheckLevel: Q, onNodeView: L, onNodeSetColor: w, onNodeSetName: (we, Pe) => {
        R(we, Pe), Qe(null);
      }, onNodeCheckNewName: M, onNodeSetIsEditing: Qe, onNodeRemove: O, onExportLevelZeroNodeJSON: $, onExportLevelZeroNodeTabular: U, onExportSetJSON: X, disableTooltip: Ce, onDragStart: () => Be(!0), onDragEnd: () => Be(!1), children: _e(Ae.children, oe, de) }, k_(de));
    }) : null;
  }
  const Re = $L();
  return ne.jsxs("div", { className: Re.setsManager, children: [ne.jsxs("div", { className: Re.setsManagerTree, children: [ne.jsx(aU, { draggable: !1, checkable: u, checkedKeys: se, expandedKeys: fe, autoExpandParent: pe, onCheck: (Ee, oe) => y(oe.node.props.nodeKey, oe.checked), onExpand: (Ee, oe) => v(Ee, oe.node.props.nodeKey, oe.expanded), children: _e(xe.tree, !0, []) }), ne.jsx(aU, { draggable: !0, checkable: u, checkedKeys: W, expandedKeys: ge, autoExpandParent: pe, onCheck: (Ee, oe) => y(oe.node.props.nodeKey, oe.checked), onExpand: (Ee, oe) => v(Ee, oe.node.props.nodeKey, oe.expanded), onDrop: (Ee) => {
    const { eventKey: oe } = Ee.node.props, { eventKey: ie } = Ee.dragNode.props, { dropToGap: Ae, dropPosition: de } = Ee;
    b(oe, ie, de, Ae);
  }, children: _e(Se.tree, !1, []) }), ne.jsx(qnn, { datatype: l, onError: C, onImportTree: N, onCreateLevelZeroNode: k, importable: m, editable: f })] }), ne.jsx("div", { className: Re.setOperationButtons, children: ne.jsx(jnn, { onUnion: K, onIntersection: z, onComplement: Y, operatable: d, hasCheckedSetsToUnion: V, hasCheckedSetsToIntersect: Z, hasCheckedSetsToComplement: ce }) })] });
}
const V7 = { name: "vitessce" };
function znn(t) {
  const { coordinationScopes: e, closeButtonVisible: n, downloadButtonVisible: r, removeGridComponent: i, theme: o, title: s } = t, a = eu(), A = vE(), [{ dataset: l, obsType: c, obsSetSelection: u, obsSetExpansion: f, obsSetColor: h, additionalObsSets: d, obsColorEncoding: I }, { setObsSetSelection: m, setObsColorEncoding: C, setObsSetColor: y, setObsSetExpansion: v, setAdditionalObsSets: b }] = uc(ea[Gn.OBS_SETS], e), Q = s || `${Ci(c)} Sets`;
  Mn(() => {
    v([]);
  }, [a, l]);
  const [{ obsIndex: w, obsSets: R }, M, O] = VB(a, l, !0, { setObsSetSelection: m, setObsSetColor: y }, { obsSetSelection: u, obsSetColor: h }, { obsType: c }), L = Jc([M]), N = Qd([O]);
  Mn(() => {
    if (d) {
      let fe, W;
      try {
        [fe, W] = aAe(d, lg);
      } catch (ge) {
        A(ge.message);
        return;
      }
      W && b(fe);
    }
  }, [d, b, A]);
  const k = dt(() => w || [], [w]), $ = Qn(() => {
    C("cellSetSelection");
  }, [C]), U = dt(() => RI(R, d), [R, d]), X = dt(() => u && u.length > 0 && U && U.tree.length > 0 ? sUt(U, u) : null, [u, U]), K = Qn((fe, W) => {
    const ge = U.tree.find((_e) => _e.name === fe);
    if (ge) {
      const _e = E9(ge, W, [], !0);
      m(_e), $();
    }
  }, [U, $, m]), z = Qn((fe, W) => {
    const ge = Array.isArray(fe) ? fe : fe.split(jb);
    fe && (m(W ? [...u, ge] : u.filter((_e) => !gr(_e, ge))), $());
  }, [u, $, m]), Y = Qn((fe, W, ge) => {
    const _e = f || [];
    if (ge)
      v([..._e, W.split(jb)]);
    else {
      const Re = _e.filter((Ee) => !gr(Ee, W.split(jb)));
      v(Re);
    }
  }, [f, v]), V = Qn((fe, W, ge, _e) => {
    const Re = fe.split(jb), Ee = kc(d, Re);
    if (!Ee.children && !_e)
      return;
    const ie = Re.length - 1 === 0, Ae = W.split(jb), de = kc(d, Ae);
    if (ie && _e && !de.children)
      return;
    let we, Pe, qe;
    ie ? qe = d.tree.findIndex((Ct) => Ct.name === Ee.name) : (Pe = Re.slice(0, -1), we = kc(d, Pe), qe = we.children.findIndex((Ct) => Ct.name === Ee.name));
    let ke;
    const Xe = de.name;
    if (!ie && _e ? ke = we.children.find((Ct) => Ct !== de && Ct.name === Xe) : _e ? ke = d.tree.find((Ct) => Ct !== de && Ct.name === Xe) : ke = Ee.children.find((Ct) => Ct !== de && Ct.name === Xe), ke)
      return;
    const rt = {
      ...d,
      tree: d.tree.map((Ct) => tee(Ct, [], Ae)).filter(Boolean)
    };
    ie ? qe = rt.tree.findIndex((Ct) => Ct.name === Ee.name) : qe = we.children.findIndex((Ct) => Ct.name === Ee.name);
    let it = [];
    if (!_e || !ie) {
      let Ct, zt;
      const jt = [];
      if (!_e)
        Ct = (lt) => b5e(lt, de), zt = (lt) => gr(lt, Re);
      else if (!ie)
        if (zt = (lt) => gr(lt, Pe), ge === -1)
          Ct = (lt) => V4t(lt, de);
        else {
          const lt = qe + (ge > qe ? 1 : 0);
          Ct = (Ht) => J4t(Ht, de, lt);
        }
      rt.tree = rt.tree.map((lt) => v5e(lt, (Ht, vt) => zt(vt), (Ht) => Ct(Ht), jt)), b(rt), it = [...jt[0], de.name], m([it]);
    } else if (ge === -1)
      rt.tree.unshift(de), b(rt), it = [de.name], m([it]);
    else {
      const Ct = qe + (ge > qe ? 1 : 0), zt = Array.from(rt.tree);
      zt.splice(Ct, 0, de), rt.tree = zt, b(rt), it = [de.name], m([it]);
    }
    const mt = h.filter((Ct) => qb(Ae, Ct.path)).map((Ct) => ({
      ...Ct,
      path: gr(Ct.path, Ae) ? it : it.concat(Ct.path.slice(Ae.length))
    })), _t = h.filter((Ct) => !qb(Ae, Ct.path));
    _t.push(...mt), y(_t);
  }, [
    d,
    h,
    b,
    y,
    m
  ]), Z = Qn((fe, W) => {
    const ge = h?.find((_e) => gr(_e.path, fe));
    y(ge ? [
      ...h.filter((_e) => !gr(_e.path, fe)),
      {
        path: fe,
        color: W
      }
    ] : [
      ...h || [],
      {
        path: fe,
        color: W
      }
    ]);
  }, [h, y]), ce = Qn((fe, W) => {
    const ge = [...fe];
    ge.pop(), ge.push(W);
    const _e = f || [];
    function Re(de, we) {
      return gr([...we, de.name], fe) ? {
        ...de,
        name: W
      } : de.children ? {
        ...de,
        children: de.children.map((Pe) => Re(Pe, [...we, de.name]))
      } : de;
    }
    const Ee = {
      ...d,
      tree: d.tree.map((de) => Re(de, []))
    }, oe = h.map((de) => ({
      path: l7(fe, de.path, ge),
      color: de.color
    })), ie = u.map((de) => l7(fe, de, ge)), Ae = _e.map((de) => l7(fe, de, ge));
    b(Ee), y(oe), m(ie), v(Ae);
  }, [
    d,
    h,
    f,
    u,
    b,
    y,
    m,
    v
  ]), ee = Qn((fe, W) => {
    const ge = [...fe];
    return ge.pop(), ge.push(W), !gr(fe, ge) && kc(d, ge);
  }, [d]), pe = Qn((fe) => {
    const W = f || [], ge = {
      ...d,
      tree: d.tree.map((oe) => tee(oe, [], fe)).filter(Boolean)
    }, _e = h.filter((oe) => !qb(fe, oe.path)), Re = u.filter((oe) => !qb(fe, oe)), Ee = W.filter((oe) => !qb(fe, oe));
    b(ge), y(_e), m(Re), v(Ee);
  }, [
    d,
    h,
    f,
    u,
    b,
    y,
    m,
    v
  ]), Ce = Qn((fe) => {
    const W = [];
    function ge(Re, Ee) {
      f?.find((oe) => gr(Ee, oe)) && Re.children ? Re.children.forEach((oe) => {
        ge(oe, [...Ee, oe.name]);
      }) : W.push(Ee);
    }
    const _e = kc(U, fe);
    ge(_e, fe), m(W), $();
  }, [f, U, $, m]), Be = Qn(() => {
    const fe = C5e(d?.tree, "My hierarchy ", "");
    b({
      ...d || eee(lg),
      tree: [
        ...d ? d.tree : [],
        {
          name: fe,
          children: []
        }
      ]
    });
  }, [d, b]), Ie = Qn(() => {
    const fe = _5e(U, u);
    pI(fe, d, h, m, b, y, C, "Union ");
  }, [
    d,
    h,
    u,
    U,
    b,
    C,
    y,
    m
  ]), Qe = Qn(() => {
    const fe = K4t(U, u);
    pI(fe, d, h, m, b, y, C, "Intersection ");
  }, [
    d,
    h,
    u,
    U,
    b,
    C,
    y,
    m
  ]), xe = Qn(() => {
    const fe = W4t(U, u, k);
    pI(fe, d, h, m, b, y, C, "Complement ");
  }, [
    d,
    k,
    h,
    u,
    U,
    b,
    C,
    y,
    m
  ]), Se = Qn((fe) => {
    if (!aUt(U, fe)) {
      b({
        ...d || eee(lg),
        tree: [
          ...d ? d.tree : [],
          ...fe.tree
        ]
      });
      const ge = y9(fe, h);
      y([
        ...h,
        ...ge
      ]);
    }
  }, [
    d,
    h,
    U,
    b,
    y
  ]), De = Qn((fe) => {
    const { treeToExport: W, nodeName: ge } = wve(U, fe, lg, h, o);
    g7(Dve(W), `${ge}_${V7.name}-${lg}-hierarchy.${Qve}`);
  }, [h, U, o]), Ue = Qn((fe) => {
    const { treeToExport: W, nodeName: ge } = wve(U, fe, lg, h, o);
    g7(CUt(W), `${ge}_${V7.name}-${lg}-hierarchy.${H4t}`);
  }, [h, U, o]), Te = Qn((fe) => {
    const { setToExport: W, nodeName: ge } = Z4t(U, fe);
    g7(Dve(W), `${ge}_${V7.name}-${lg}-set.${Qve}`);
  }, [U]), se = dt(() => ne.jsx(Ynn, { setColor: h, sets: R, additionalSets: d, levelSelection: X, setSelection: u, setExpansion: f, hasColorEncoding: I === "cellSetSelection", draggable: !0, datatype: lg, onError: A, onCheckNode: z, onExpandNode: Y, onDropNode: V, onCheckLevel: K, onNodeSetColor: Z, onNodeSetName: ce, onNodeCheckNewName: ee, onNodeRemove: pe, onNodeView: Ce, onImportTree: Se, onCreateLevelZeroNode: Be, onExportLevelZeroNodeJSON: De, onExportLevelZeroNodeTabular: Ue, onExportSetJSON: Te, onUnion: Ie, onIntersection: Qe, onComplement: xe, hasCheckedSetsToUnion: u?.length > 1, hasCheckedSetsToIntersect: u?.length > 1, hasCheckedSetsToComplement: u?.length > 0, theme: o }), [
    d,
    I,
    h,
    f,
    u,
    R,
    X,
    K,
    z,
    xe,
    Be,
    V,
    Y,
    De,
    Ue,
    Te,
    Se,
    Qe,
    ee,
    pe,
    Z,
    ce,
    Ce,
    Ie,
    A,
    o
  ]);
  return ne.jsx(fc, { title: Q, isScroll: !0, closeButtonVisible: n, downloadButtonVisible: r, removeGridComponent: i, urls: N, theme: o, isReady: L, children: se });
}
function Vnn(t) {
  var e = +this._x.call(null, t), n = +this._y.call(null, t);
  return r9e(this.cover(e, n), e, n, t);
}
function r9e(t, e, n, r) {
  if (isNaN(e) || isNaN(n))
    return t;
  var i, o = t._root, s = { data: r }, a = t._x0, A = t._y0, l = t._x1, c = t._y1, u, f, h, d, I, m, C, y;
  if (!o)
    return t._root = s, t;
  for (; o.length; )
    if ((I = e >= (u = (a + l) / 2)) ? a = u : l = u, (m = n >= (f = (A + c) / 2)) ? A = f : c = f, i = o, !(o = o[C = m << 1 | I]))
      return i[C] = s, t;
  if (h = +t._x.call(null, o.data), d = +t._y.call(null, o.data), e === h && n === d)
    return s.next = o, i ? i[C] = s : t._root = s, t;
  do
    i = i ? i[C] = new Array(4) : t._root = new Array(4), (I = e >= (u = (a + l) / 2)) ? a = u : l = u, (m = n >= (f = (A + c) / 2)) ? A = f : c = f;
  while ((C = m << 1 | I) === (y = (d >= f) << 1 | h >= u));
  return i[y] = o, i[C] = s, t;
}
function Jnn(t) {
  var e, n, r = t.length, i, o, s = new Array(r), a = new Array(r), A = 1 / 0, l = 1 / 0, c = -1 / 0, u = -1 / 0;
  for (n = 0; n < r; ++n)
    isNaN(i = +this._x.call(null, e = t[n])) || isNaN(o = +this._y.call(null, e)) || (s[n] = i, a[n] = o, i < A && (A = i), i > c && (c = i), o < l && (l = o), o > u && (u = o));
  if (A > c || l > u)
    return this;
  for (this.cover(A, l).cover(c, u), n = 0; n < r; ++n)
    r9e(this, s[n], a[n], t[n]);
  return this;
}
function Knn(t, e) {
  if (isNaN(t = +t) || isNaN(e = +e))
    return this;
  var n = this._x0, r = this._y0, i = this._x1, o = this._y1;
  if (isNaN(n))
    i = (n = Math.floor(t)) + 1, o = (r = Math.floor(e)) + 1;
  else {
    for (var s = i - n, a = this._root, A, l; n > t || t >= i || r > e || e >= o; )
      switch (l = (e < r) << 1 | t < n, A = new Array(4), A[l] = a, a = A, s *= 2, l) {
        case 0:
          i = n + s, o = r + s;
          break;
        case 1:
          n = i - s, o = r + s;
          break;
        case 2:
          i = n + s, r = o - s;
          break;
        case 3:
          n = i - s, r = o - s;
          break;
      }
    this._root && this._root.length && (this._root = a);
  }
  return this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = o, this;
}
function Wnn() {
  var t = [];
  return this.visit(function(e) {
    if (!e.length)
      do
        t.push(e.data);
      while (e = e.next);
  }), t;
}
function Xnn(t) {
  return arguments.length ? this.cover(+t[0][0], +t[0][1]).cover(+t[1][0], +t[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function Gc(t, e, n, r, i) {
  this.node = t, this.x0 = e, this.y0 = n, this.x1 = r, this.y1 = i;
}
function Znn(t, e, n) {
  var r, i = this._x0, o = this._y0, s, a, A, l, c = this._x1, u = this._y1, f = [], h = this._root, d, I;
  for (h && f.push(new Gc(h, i, o, c, u)), n == null ? n = 1 / 0 : (i = t - n, o = e - n, c = t + n, u = e + n, n *= n); d = f.pop(); )
    if (!(!(h = d.node) || (s = d.x0) > c || (a = d.y0) > u || (A = d.x1) < i || (l = d.y1) < o))
      if (h.length) {
        var m = (s + A) / 2, C = (a + l) / 2;
        f.push(
          new Gc(h[3], m, C, A, l),
          new Gc(h[2], s, C, m, l),
          new Gc(h[1], m, a, A, C),
          new Gc(h[0], s, a, m, C)
        ), (I = (e >= C) << 1 | t >= m) && (d = f[f.length - 1], f[f.length - 1] = f[f.length - 1 - I], f[f.length - 1 - I] = d);
      } else {
        var y = t - +this._x.call(null, h.data), v = e - +this._y.call(null, h.data), b = y * y + v * v;
        if (b < n) {
          var Q = Math.sqrt(n = b);
          i = t - Q, o = e - Q, c = t + Q, u = e + Q, r = h.data;
        }
      }
  return r;
}
function ern(t) {
  if (isNaN(c = +this._x.call(null, t)) || isNaN(u = +this._y.call(null, t)))
    return this;
  var e, n = this._root, r, i, o, s = this._x0, a = this._y0, A = this._x1, l = this._y1, c, u, f, h, d, I, m, C;
  if (!n)
    return this;
  if (n.length)
    for (; ; ) {
      if ((d = c >= (f = (s + A) / 2)) ? s = f : A = f, (I = u >= (h = (a + l) / 2)) ? a = h : l = h, e = n, !(n = n[m = I << 1 | d]))
        return this;
      if (!n.length)
        break;
      (e[m + 1 & 3] || e[m + 2 & 3] || e[m + 3 & 3]) && (r = e, C = m);
    }
  for (; n.data !== t; )
    if (i = n, !(n = n.next))
      return this;
  return (o = n.next) && delete n.next, i ? (o ? i.next = o : delete i.next, this) : e ? (o ? e[m] = o : delete e[m], (n = e[0] || e[1] || e[2] || e[3]) && n === (e[3] || e[2] || e[1] || e[0]) && !n.length && (r ? r[C] = n : this._root = n), this) : (this._root = o, this);
}
function trn(t) {
  for (var e = 0, n = t.length; e < n; ++e)
    this.remove(t[e]);
  return this;
}
function nrn() {
  return this._root;
}
function rrn() {
  var t = 0;
  return this.visit(function(e) {
    if (!e.length)
      do
        ++t;
      while (e = e.next);
  }), t;
}
function irn(t) {
  var e = [], n, r = this._root, i, o, s, a, A;
  for (r && e.push(new Gc(r, this._x0, this._y0, this._x1, this._y1)); n = e.pop(); )
    if (!t(r = n.node, o = n.x0, s = n.y0, a = n.x1, A = n.y1) && r.length) {
      var l = (o + a) / 2, c = (s + A) / 2;
      (i = r[3]) && e.push(new Gc(i, l, c, a, A)), (i = r[2]) && e.push(new Gc(i, o, c, l, A)), (i = r[1]) && e.push(new Gc(i, l, s, a, c)), (i = r[0]) && e.push(new Gc(i, o, s, l, c));
    }
  return this;
}
function orn(t) {
  var e = [], n = [], r;
  for (this._root && e.push(new Gc(this._root, this._x0, this._y0, this._x1, this._y1)); r = e.pop(); ) {
    var i = r.node;
    if (i.length) {
      var o, s = r.x0, a = r.y0, A = r.x1, l = r.y1, c = (s + A) / 2, u = (a + l) / 2;
      (o = i[0]) && e.push(new Gc(o, s, a, c, u)), (o = i[1]) && e.push(new Gc(o, c, a, A, u)), (o = i[2]) && e.push(new Gc(o, s, u, c, l)), (o = i[3]) && e.push(new Gc(o, c, u, A, l));
    }
    n.push(r);
  }
  for (; r = n.pop(); )
    t(r.node, r.x0, r.y0, r.x1, r.y1);
  return this;
}
function srn(t) {
  return t[0];
}
function arn(t) {
  return arguments.length ? (this._x = t, this) : this._x;
}
function Arn(t) {
  return t[1];
}
function lrn(t) {
  return arguments.length ? (this._y = t, this) : this._y;
}
function sle(t, e, n) {
  var r = new ale(e ?? srn, n ?? Arn, NaN, NaN, NaN, NaN);
  return t == null ? r : r.addAll(t);
}
function ale(t, e, n, r, i, o) {
  this._x = t, this._y = e, this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = o, this._root = void 0;
}
function abe(t) {
  for (var e = { data: t.data }, n = e; t = t.next; )
    n = n.next = { data: t.data };
  return e;
}
var tu = sle.prototype = ale.prototype;
tu.copy = function() {
  var t = new ale(this._x, this._y, this._x0, this._y0, this._x1, this._y1), e = this._root, n, r;
  if (!e)
    return t;
  if (!e.length)
    return t._root = abe(e), t;
  for (n = [{ source: e, target: t._root = new Array(4) }]; e = n.pop(); )
    for (var i = 0; i < 4; ++i)
      (r = e.source[i]) && (r.length ? n.push({ source: r, target: e.target[i] = new Array(4) }) : e.target[i] = abe(r));
  return t;
};
tu.add = Vnn;
tu.addAll = Jnn;
tu.cover = Knn;
tu.data = Wnn;
tu.extent = Xnn;
tu.find = Znn;
tu.remove = ern;
tu.removeAll = trn;
tu.root = nrn;
tu.size = rrn;
tu.visit = irn;
tu.visitAfter = orn;
tu.x = arn;
tu.y = lrn;
var crn = { value: () => {
} };
function i9e() {
  for (var t = 0, e = arguments.length, n = {}, r; t < e; ++t) {
    if (!(r = arguments[t] + "") || r in n || /[\s.]/.test(r))
      throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new Ek(n);
}
function Ek(t) {
  this._ = t;
}
function urn(t, e) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !e.hasOwnProperty(n))
      throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
Ek.prototype = i9e.prototype = {
  constructor: Ek,
  on: function(t, e) {
    var n = this._, r = urn(t + "", n), i, o = -1, s = r.length;
    if (arguments.length < 2) {
      for (; ++o < s; )
        if ((i = (t = r[o]).type) && (i = frn(n[i], t.name)))
          return i;
      return;
    }
    if (e != null && typeof e != "function")
      throw new Error("invalid callback: " + e);
    for (; ++o < s; )
      if (i = (t = r[o]).type)
        n[i] = Abe(n[i], t.name, e);
      else if (e == null)
        for (i in n)
          n[i] = Abe(n[i], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var n in e)
      t[n] = e[n].slice();
    return new Ek(t);
  },
  call: function(t, e) {
    if ((i = arguments.length - 2) > 0)
      for (var n = new Array(i), r = 0, i, o; r < i; ++r)
        n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (o = this._[t], r = 0, i = o.length; r < i; ++r)
      o[r].value.apply(e, n);
  },
  apply: function(t, e, n) {
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (var r = this._[t], i = 0, o = r.length; i < o; ++i)
      r[i].value.apply(e, n);
  }
};
function frn(t, e) {
  for (var n = 0, r = t.length, i; n < r; ++n)
    if ((i = t[n]).name === e)
      return i.value;
}
function Abe(t, e, n) {
  for (var r = 0, i = t.length; r < i; ++r)
    if (t[r].name === e) {
      t[r] = crn, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return n != null && t.push({ name: e, value: n }), t;
}
var PS = 0, ER = 0, r2 = 0, o9e = 1e3, hU, yR, dU = 0, Kv = 0, K9 = 0, NT = typeof performance == "object" && performance.now ? performance : Date, s9e = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function a9e() {
  return Kv || (s9e(grn), Kv = NT.now() + K9);
}
function grn() {
  Kv = 0;
}
function See() {
  this._call = this._time = this._next = null;
}
See.prototype = A9e.prototype = {
  constructor: See,
  restart: function(t, e, n) {
    if (typeof t != "function")
      throw new TypeError("callback is not a function");
    n = (n == null ? a9e() : +n) + (e == null ? 0 : +e), !this._next && yR !== this && (yR ? yR._next = this : hU = this, yR = this), this._call = t, this._time = n, Qee();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, Qee());
  }
};
function A9e(t, e, n) {
  var r = new See();
  return r.restart(t, e, n), r;
}
function hrn() {
  a9e(), ++PS;
  for (var t = hU, e; t; )
    (e = Kv - t._time) >= 0 && t._call.call(null, e), t = t._next;
  --PS;
}
function lbe() {
  Kv = (dU = NT.now()) + K9, PS = ER = 0;
  try {
    hrn();
  } finally {
    PS = 0, prn(), Kv = 0;
  }
}
function drn() {
  var t = NT.now(), e = t - dU;
  e > o9e && (K9 -= e, dU = t);
}
function prn() {
  for (var t, e = hU, n, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), t = e, e = e._next) : (n = e._next, e._next = null, e = t ? t._next = n : hU = n);
  yR = t, Qee(r);
}
function Qee(t) {
  if (!PS) {
    ER && (ER = clearTimeout(ER));
    var e = t - Kv;
    e > 24 ? (t < 1 / 0 && (ER = setTimeout(lbe, t - NT.now() - K9)), r2 && (r2 = clearInterval(r2))) : (r2 || (dU = NT.now(), r2 = setInterval(drn, o9e)), PS = 1, s9e(lbe));
  }
}
const Irn = 1664525, mrn = 1013904223, cbe = 4294967296;
function Crn() {
  let t = 1;
  return () => (t = (Irn * t + mrn) % cbe) / cbe;
}
var Ern = 10, yrn = Math.PI * (3 - Math.sqrt(5));
function vrn(t) {
  var e, n = 1, r = 1e-3, i = 1 - Math.pow(r, 1 / 300), o = 0, s = 0.6, a = /* @__PURE__ */ new Map(), A = A9e(u), l = i9e("tick", "end"), c = Crn();
  t == null && (t = []);
  function u() {
    f(), l.call("tick", e), n < r && (A.stop(), l.call("end", e));
  }
  function f(I) {
    var m, C = t.length, y;
    I === void 0 && (I = 1);
    for (var v = 0; v < I; ++v)
      for (n += (o - n) * i, a.forEach(function(b) {
        b(n);
      }), m = 0; m < C; ++m)
        y = t[m], y.fx == null ? y.x += y.vx *= s : (y.x = y.fx, y.vx = 0), y.fy == null ? y.y += y.vy *= s : (y.y = y.fy, y.vy = 0);
    return e;
  }
  function h() {
    for (var I = 0, m = t.length, C; I < m; ++I) {
      if (C = t[I], C.index = I, C.fx != null && (C.x = C.fx), C.fy != null && (C.y = C.fy), isNaN(C.x) || isNaN(C.y)) {
        var y = Ern * Math.sqrt(0.5 + I), v = I * yrn;
        C.x = y * Math.cos(v), C.y = y * Math.sin(v);
      }
      (isNaN(C.vx) || isNaN(C.vy)) && (C.vx = C.vy = 0);
    }
  }
  function d(I) {
    return I.initialize && I.initialize(t, c), I;
  }
  return h(), e = {
    tick: f,
    restart: function() {
      return A.restart(u), e;
    },
    stop: function() {
      return A.stop(), e;
    },
    nodes: function(I) {
      return arguments.length ? (t = I, h(), a.forEach(d), e) : t;
    },
    alpha: function(I) {
      return arguments.length ? (n = +I, e) : n;
    },
    alphaMin: function(I) {
      return arguments.length ? (r = +I, e) : r;
    },
    alphaDecay: function(I) {
      return arguments.length ? (i = +I, e) : +i;
    },
    alphaTarget: function(I) {
      return arguments.length ? (o = +I, e) : o;
    },
    velocityDecay: function(I) {
      return arguments.length ? (s = 1 - I, e) : 1 - s;
    },
    randomSource: function(I) {
      return arguments.length ? (c = I, a.forEach(d), e) : c;
    },
    force: function(I, m) {
      return arguments.length > 1 ? (m == null ? a.delete(I) : a.set(I, d(m)), e) : a.get(I);
    },
    find: function(I, m, C) {
      var y = 0, v = t.length, b, Q, w, R, M;
      for (C == null ? C = 1 / 0 : C *= C, y = 0; y < v; ++y)
        R = t[y], b = I - R.x, Q = m - R.y, w = b * b + Q * Q, w < C && (M = R, C = w);
      return M;
    },
    on: function(I, m) {
      return arguments.length > 1 ? (l.on(I, m), e) : l.on(I);
    }
  };
}
function _o(t, e) {
  if (!t)
    throw new Error(e || "loader assertion failed.");
}
const kS = !!(typeof process != "object" || String(process) !== "[object process]" || process.browser), ube = typeof process < "u" && process.version && /v([0-9]*)/.exec(process.version);
ube && parseFloat(ube[1]);
const Brn = "3.2.10";
function qp(t, e) {
  if (!t)
    throw new Error(e || "loaders.gl assertion failed.");
}
const J7 = {
  self: typeof self < "u" && self,
  window: typeof window < "u" && window,
  global: typeof global < "u" && global,
  document: typeof document < "u" && document
}, brn = J7.global || J7.self || J7.window || {}, _v = typeof process != "object" || String(process) !== "[object process]" || process.browser, Ale = typeof importScripts == "function", _rn = typeof window < "u" && typeof window.orientation < "u", fbe = typeof process < "u" && process.version && /v([0-9]*)/.exec(process.version);
fbe && parseFloat(fbe[1]);
class Srn {
  constructor(e, n) {
    ae(this, "name", void 0), ae(this, "workerThread", void 0), ae(this, "isRunning", !0), ae(this, "result", void 0), ae(this, "_resolve", () => {
    }), ae(this, "_reject", () => {
    }), this.name = e, this.workerThread = n, this.result = new Promise((r, i) => {
      this._resolve = r, this._reject = i;
    });
  }
  postMessage(e, n) {
    this.workerThread.postMessage({
      source: "loaders.gl",
      type: e,
      payload: n
    });
  }
  done(e) {
    qp(this.isRunning), this.isRunning = !1, this._resolve(e);
  }
  error(e) {
    qp(this.isRunning), this.isRunning = !1, this._reject(e);
  }
}
let K7 = class {
};
const W7 = /* @__PURE__ */ new Map();
function Qrn(t) {
  qp(t.source && !t.url || !t.source && t.url);
  let e = W7.get(t.source || t.url);
  return e || (t.url && (e = wrn(t.url), W7.set(t.url, e)), t.source && (e = l9e(t.source), W7.set(t.source, e))), qp(e), e;
}
function wrn(t) {
  if (!t.startsWith("http"))
    return t;
  const e = xrn(t);
  return l9e(e);
}
function l9e(t) {
  const e = new Blob([t], {
    type: "application/javascript"
  });
  return URL.createObjectURL(e);
}
function xrn(t) {
  return `try {
  importScripts('`.concat(t, `');
} catch (error) {
  console.error(error);
  throw error;
}`);
}
function c9e(t, e = !0, n) {
  const r = n || /* @__PURE__ */ new Set();
  if (t) {
    if (gbe(t))
      r.add(t);
    else if (gbe(t.buffer))
      r.add(t.buffer);
    else if (!ArrayBuffer.isView(t)) {
      if (e && typeof t == "object")
        for (const i in t)
          c9e(t[i], e, r);
    }
  }
  return n === void 0 ? Array.from(r) : [];
}
function gbe(t) {
  return t ? t instanceof ArrayBuffer || typeof MessagePort < "u" && t instanceof MessagePort || typeof ImageBitmap < "u" && t instanceof ImageBitmap || typeof OffscreenCanvas < "u" && t instanceof OffscreenCanvas : !1;
}
const X7 = () => {
};
class wee {
  static isSupported() {
    return typeof Worker < "u" && _v || typeof K7 < "u" && !_v;
  }
  constructor(e) {
    ae(this, "name", void 0), ae(this, "source", void 0), ae(this, "url", void 0), ae(this, "terminated", !1), ae(this, "worker", void 0), ae(this, "onMessage", void 0), ae(this, "onError", void 0), ae(this, "_loadableURL", "");
    const {
      name: n,
      source: r,
      url: i
    } = e;
    qp(r || i), this.name = n, this.source = r, this.url = i, this.onMessage = X7, this.onError = (o) => console.log(o), this.worker = _v ? this._createBrowserWorker() : this._createNodeWorker();
  }
  destroy() {
    this.onMessage = X7, this.onError = X7, this.worker.terminate(), this.terminated = !0;
  }
  get isRunning() {
    return !!this.onMessage;
  }
  postMessage(e, n) {
    n = n || c9e(e), this.worker.postMessage(e, n);
  }
  _getErrorFromErrorEvent(e) {
    let n = "Failed to load ";
    return n += "worker ".concat(this.name, " from ").concat(this.url, ". "), e.message && (n += "".concat(e.message, " in ")), e.lineno && (n += ":".concat(e.lineno, ":").concat(e.colno)), new Error(n);
  }
  _createBrowserWorker() {
    this._loadableURL = Qrn({
      source: this.source,
      url: this.url
    });
    const e = new Worker(this._loadableURL, {
      name: this.name
    });
    return e.onmessage = (n) => {
      n.data ? this.onMessage(n.data) : this.onError(new Error("No data received"));
    }, e.onerror = (n) => {
      this.onError(this._getErrorFromErrorEvent(n)), this.terminated = !0;
    }, e.onmessageerror = (n) => console.error(n), e;
  }
  _createNodeWorker() {
    let e;
    if (this.url) {
      const r = this.url.includes(":/") || this.url.startsWith("/") ? this.url : "./".concat(this.url);
      e = new K7(r, {
        eval: !1
      });
    } else if (this.source)
      e = new K7(this.source, {
        eval: !0
      });
    else
      throw new Error("no worker");
    return e.on("message", (n) => {
      this.onMessage(n);
    }), e.on("error", (n) => {
      this.onError(n);
    }), e.on("exit", (n) => {
    }), e;
  }
}
class Rrn {
  static isSupported() {
    return wee.isSupported();
  }
  constructor(e) {
    ae(this, "name", "unnamed"), ae(this, "source", void 0), ae(this, "url", void 0), ae(this, "maxConcurrency", 1), ae(this, "maxMobileConcurrency", 1), ae(this, "onDebug", () => {
    }), ae(this, "reuseWorkers", !0), ae(this, "props", {}), ae(this, "jobQueue", []), ae(this, "idleQueue", []), ae(this, "count", 0), ae(this, "isDestroyed", !1), this.source = e.source, this.url = e.url, this.setProps(e);
  }
  destroy() {
    this.idleQueue.forEach((e) => e.destroy()), this.isDestroyed = !0;
  }
  setProps(e) {
    this.props = {
      ...this.props,
      ...e
    }, e.name !== void 0 && (this.name = e.name), e.maxConcurrency !== void 0 && (this.maxConcurrency = e.maxConcurrency), e.maxMobileConcurrency !== void 0 && (this.maxMobileConcurrency = e.maxMobileConcurrency), e.reuseWorkers !== void 0 && (this.reuseWorkers = e.reuseWorkers), e.onDebug !== void 0 && (this.onDebug = e.onDebug);
  }
  async startJob(e, n = (i, o, s) => i.done(s), r = (i, o) => i.error(o)) {
    const i = new Promise((o) => (this.jobQueue.push({
      name: e,
      onMessage: n,
      onError: r,
      onStart: o
    }), this));
    return this._startQueuedJob(), await i;
  }
  async _startQueuedJob() {
    if (!this.jobQueue.length)
      return;
    const e = this._getAvailableWorker();
    if (!e)
      return;
    const n = this.jobQueue.shift();
    if (n) {
      this.onDebug({
        message: "Starting job",
        name: n.name,
        workerThread: e,
        backlog: this.jobQueue.length
      });
      const r = new Srn(n.name, e);
      e.onMessage = (i) => n.onMessage(r, i.type, i.payload), e.onError = (i) => n.onError(r, i), n.onStart(r);
      try {
        await r.result;
      } finally {
        this.returnWorkerToQueue(e);
      }
    }
  }
  returnWorkerToQueue(e) {
    this.isDestroyed || !this.reuseWorkers || this.count > this._getMaxConcurrency() ? (e.destroy(), this.count--) : this.idleQueue.push(e), this.isDestroyed || this._startQueuedJob();
  }
  _getAvailableWorker() {
    if (this.idleQueue.length > 0)
      return this.idleQueue.shift() || null;
    if (this.count < this._getMaxConcurrency()) {
      this.count++;
      const e = "".concat(this.name.toLowerCase(), " (#").concat(this.count, " of ").concat(this.maxConcurrency, ")");
      return new wee({
        name: e,
        source: this.source,
        url: this.url
      });
    }
    return null;
  }
  _getMaxConcurrency() {
    return _rn ? this.maxMobileConcurrency : this.maxConcurrency;
  }
}
const Drn = {
  maxConcurrency: 3,
  maxMobileConcurrency: 1,
  reuseWorkers: !0,
  onDebug: () => {
  }
};
class nI {
  static isSupported() {
    return wee.isSupported();
  }
  static getWorkerFarm(e = {}) {
    return nI._workerFarm = nI._workerFarm || new nI({}), nI._workerFarm.setProps(e), nI._workerFarm;
  }
  constructor(e) {
    ae(this, "props", void 0), ae(this, "workerPools", /* @__PURE__ */ new Map()), this.props = {
      ...Drn
    }, this.setProps(e), this.workerPools = /* @__PURE__ */ new Map();
  }
  destroy() {
    for (const e of this.workerPools.values())
      e.destroy();
    this.workerPools = /* @__PURE__ */ new Map();
  }
  setProps(e) {
    this.props = {
      ...this.props,
      ...e
    };
    for (const n of this.workerPools.values())
      n.setProps(this._getWorkerPoolProps());
  }
  getWorkerPool(e) {
    const {
      name: n,
      source: r,
      url: i
    } = e;
    let o = this.workerPools.get(n);
    return o || (o = new Rrn({
      name: n,
      source: r,
      url: i
    }), o.setProps(this._getWorkerPoolProps()), this.workerPools.set(n, o)), o;
  }
  _getWorkerPoolProps() {
    return {
      maxConcurrency: this.props.maxConcurrency,
      maxMobileConcurrency: this.props.maxMobileConcurrency,
      reuseWorkers: this.props.reuseWorkers,
      onDebug: this.props.onDebug
    };
  }
}
ae(nI, "_workerFarm", void 0);
const Trn = "latest";
function Nrn(t, e = {}) {
  const n = e[t.id] || {}, r = "".concat(t.id, "-worker.js");
  let i = n.workerUrl;
  if (!i && t.id === "compression" && (i = e.workerUrl), e._workerType === "test" && (i = "modules/".concat(t.module, "/dist/").concat(r)), !i) {
    let o = t.version;
    o === "latest" && (o = Trn);
    const s = o ? "@".concat(o) : "";
    i = "https://unpkg.com/@loaders.gl/".concat(t.module).concat(s, "/dist/").concat(r);
  }
  return qp(i), i;
}
function Lrn(t, e = Brn) {
  qp(t, "no worker provided");
  const n = t.version;
  return !(!e || !n);
}
const Sv = {}, u9e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sv
}, Symbol.toStringTag, { value: "Module" })), Mrn = "3.2.10", Z7 = {};
async function Qv(t, e = null, n = {}) {
  return e && (t = Orn(t, e, n)), Z7[t] = Z7[t] || Frn(t), await Z7[t];
}
function Orn(t, e, n) {
  if (t.startsWith("http"))
    return t;
  const r = n.modules || {};
  return r[t] ? r[t] : _v ? n.CDN ? (qp(n.CDN.startsWith("http")), "".concat(n.CDN, "/").concat(e, "@").concat(Mrn, "/dist/libs/").concat(t)) : Ale ? "../src/libs/".concat(t) : "modules/".concat(e, "/src/libs/").concat(t) : "modules/".concat(e, "/dist/libs/").concat(t);
}
async function Frn(t) {
  if (t.endsWith("wasm"))
    return await (await fetch(t)).arrayBuffer();
  if (!_v)
    try {
      return u9e && void 0;
    } catch {
      return null;
    }
  if (Ale)
    return importScripts(t);
  const n = await (await fetch(t)).text();
  return Prn(n, t);
}
function Prn(t, e) {
  if (!_v)
    return;
  if (Ale)
    return eval.call(brn, t), null;
  const n = document.createElement("script");
  n.id = e;
  try {
    n.appendChild(document.createTextNode(t));
  } catch {
    n.text = t;
  }
  return document.body.appendChild(n), null;
}
function krn(t, e) {
  return !nI.isSupported() || !_v && !(e != null && e._nodeWorkers) ? !1 : t.worker && e?.worker;
}
async function Grn(t, e, n, r, i) {
  const o = t.id, s = Nrn(t, n), A = nI.getWorkerFarm(n).getWorkerPool({
    name: o,
    url: s
  });
  n = JSON.parse(JSON.stringify(n)), r = JSON.parse(JSON.stringify(r || {}));
  const l = await A.startJob("process-on-worker", Urn.bind(null, i));
  return l.postMessage("process", {
    input: e,
    options: n,
    context: r
  }), await (await l.result).result;
}
async function Urn(t, e, n, r) {
  switch (n) {
    case "done":
      e.done(r);
      break;
    case "error":
      e.error(new Error(r.error));
      break;
    case "process":
      const {
        id: i,
        input: o,
        options: s
      } = r;
      try {
        const a = await t(o, s);
        e.postMessage("done", {
          id: i,
          result: a
        });
      } catch (a) {
        const A = a instanceof Error ? a.message : "unknown error";
        e.postMessage("error", {
          id: i,
          error: A
        });
      }
      break;
    default:
      console.warn("parse-with-worker unknown message ".concat(n));
  }
}
function Hrn(t, e = 5) {
  return typeof t == "string" ? t.slice(0, e) : ArrayBuffer.isView(t) ? hbe(t.buffer, t.byteOffset, e) : t instanceof ArrayBuffer ? hbe(t, 0, e) : "";
}
function hbe(t, e, n) {
  if (t.byteLength <= e + n)
    return "";
  const r = new DataView(t);
  let i = "";
  for (let o = 0; o < n; o++)
    i += String.fromCharCode(r.getUint8(e + o));
  return i;
}
function $rn(t) {
  try {
    return JSON.parse(t);
  } catch {
    throw new Error('Failed to parse JSON from data starting with "'.concat(Hrn(t), '"'));
  }
}
function f9e(t) {
  return t && typeof t == "object" && t.isBuffer;
}
function qrn(t) {
  return f9e(t) ? new Uint8Array(t.buffer, t.byteOffset, t.length).slice().buffer : t;
}
function g9e(t) {
  if (f9e(t))
    return qrn(t);
  if (t instanceof ArrayBuffer)
    return t;
  if (ArrayBuffer.isView(t))
    return t.byteOffset === 0 && t.byteLength === t.buffer.byteLength ? t.buffer : t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength);
  if (typeof t == "string") {
    const e = t;
    return new TextEncoder().encode(e).buffer;
  }
  if (t && typeof t == "object" && t._toArrayBuffer)
    return t._toArrayBuffer();
  throw new Error("toArrayBuffer");
}
function jrn(t, e, n) {
  if (n = n || t.byteLength, t.byteLength < n || e.byteLength < n)
    return !1;
  const r = new Uint8Array(t), i = new Uint8Array(e);
  for (let o = 0; o < r.length; ++o)
    if (r[o] !== i[o])
      return !1;
  return !0;
}
function Yrn(...t) {
  const e = t.map((o) => o instanceof ArrayBuffer ? new Uint8Array(o) : o), n = e.reduce((o, s) => o + s.byteLength, 0), r = new Uint8Array(n);
  let i = 0;
  for (const o of e)
    r.set(o, i), i += o.byteLength;
  return r.buffer;
}
function eV(...t) {
  const e = t, n = e && e.length > 1 && e[0].constructor || null;
  if (!n)
    throw new Error('"concatenateTypedArrays" - incorrect quantity of arguments or arguments have incompatible data types');
  const r = e.reduce((s, a) => s + a.length, 0), i = new n(r);
  let o = 0;
  for (const s of e)
    i.set(s, o), o += s.length;
  return i;
}
function lle(t, e, n) {
  const r = n !== void 0 ? new Uint8Array(t).subarray(e, e + n) : new Uint8Array(t).subarray(e);
  return new Uint8Array(r).buffer;
}
function eM(t, e) {
  return _o(t >= 0), _o(e > 0), t + (e - 1) & ~(e - 1);
}
function zrn(t, e, n) {
  let r;
  if (t instanceof ArrayBuffer)
    r = new Uint8Array(t);
  else {
    const i = t.byteOffset, o = t.byteLength;
    r = new Uint8Array(t.buffer || t.arrayBuffer, i, o);
  }
  return e.set(r, n), n + eM(r.byteLength, 4);
}
async function Vrn(t) {
  const e = [];
  for await (const n of t)
    e.push(n);
  return Yrn(...e);
}
function dbe() {
  let t;
  if (typeof window < "u" && window.performance)
    t = window.performance.now();
  else if (typeof process < "u" && process.hrtime) {
    const e = process.hrtime();
    t = e[0] * 1e3 + e[1] / 1e6;
  } else
    t = Date.now();
  return t;
}
class pbe {
  constructor(e, n) {
    ae(this, "name", void 0), ae(this, "type", void 0), ae(this, "sampleSize", 1), ae(this, "time", void 0), ae(this, "count", void 0), ae(this, "samples", void 0), ae(this, "lastTiming", void 0), ae(this, "lastSampleTime", void 0), ae(this, "lastSampleCount", void 0), ae(this, "_count", 0), ae(this, "_time", 0), ae(this, "_samples", 0), ae(this, "_startTime", 0), ae(this, "_timerPending", !1), this.name = e, this.type = n, this.reset();
  }
  setSampleSize(e) {
    return this.sampleSize = e, this;
  }
  incrementCount() {
    return this.addCount(1), this;
  }
  decrementCount() {
    return this.subtractCount(1), this;
  }
  addCount(e) {
    return this._count += e, this._samples++, this._checkSampling(), this;
  }
  subtractCount(e) {
    return this._count -= e, this._samples++, this._checkSampling(), this;
  }
  addTime(e) {
    return this._time += e, this.lastTiming = e, this._samples++, this._checkSampling(), this;
  }
  timeStart() {
    return this._startTime = dbe(), this._timerPending = !0, this;
  }
  timeEnd() {
    return this._timerPending ? (this.addTime(dbe() - this._startTime), this._timerPending = !1, this._checkSampling(), this) : this;
  }
  getSampleAverageCount() {
    return this.sampleSize > 0 ? this.lastSampleCount / this.sampleSize : 0;
  }
  getSampleAverageTime() {
    return this.sampleSize > 0 ? this.lastSampleTime / this.sampleSize : 0;
  }
  getSampleHz() {
    return this.lastSampleTime > 0 ? this.sampleSize / (this.lastSampleTime / 1e3) : 0;
  }
  getAverageCount() {
    return this.samples > 0 ? this.count / this.samples : 0;
  }
  getAverageTime() {
    return this.samples > 0 ? this.time / this.samples : 0;
  }
  getHz() {
    return this.time > 0 ? this.samples / (this.time / 1e3) : 0;
  }
  reset() {
    return this.time = 0, this.count = 0, this.samples = 0, this.lastTiming = 0, this.lastSampleTime = 0, this.lastSampleCount = 0, this._count = 0, this._time = 0, this._samples = 0, this._startTime = 0, this._timerPending = !1, this;
  }
  _checkSampling() {
    this._samples === this.sampleSize && (this.lastSampleTime = this._time, this.lastSampleCount = this._count, this.count += this._count, this.time += this._time, this.samples += this._samples, this._time = 0, this._count = 0, this._samples = 0);
  }
}
class tM {
  constructor(e) {
    ae(this, "id", void 0), ae(this, "stats", {}), this.id = e.id, this.stats = {}, this._initializeStats(e.stats), Object.seal(this);
  }
  get(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "count";
    return this._getOrCreate({
      name: e,
      type: n
    });
  }
  get size() {
    return Object.keys(this.stats).length;
  }
  reset() {
    for (const e in this.stats)
      this.stats[e].reset();
    return this;
  }
  forEach(e) {
    for (const n in this.stats)
      e(this.stats[n]);
  }
  getTable() {
    const e = {};
    return this.forEach((n) => {
      e[n.name] = {
        time: n.time || 0,
        count: n.count || 0,
        average: n.getAverageTime() || 0,
        hz: n.getHz() || 0
      };
    }), e;
  }
  _initializeStats() {
    (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).forEach((n) => this._getOrCreate(n));
  }
  _getOrCreate(e) {
    if (!e || !e.name)
      return null;
    const {
      name: n,
      type: r
    } = e;
    return this.stats[n] || (e instanceof pbe ? this.stats[n] = e : this.stats[n] = new pbe(n, r)), this.stats[n];
  }
}
const Jrn = "Queued Requests", Krn = "Active Requests", Wrn = "Cancelled Requests", Xrn = "Queued Requests Ever", Zrn = "Active Requests Ever", ein = {
  id: "request-scheduler",
  throttleRequests: !0,
  maxRequests: 6
};
class h9e {
  constructor(e = {}) {
    mo(this, "props", void 0), mo(this, "stats", void 0), mo(this, "activeRequestCount", 0), mo(this, "requestQueue", []), mo(this, "requestMap", /* @__PURE__ */ new Map()), mo(this, "deferredUpdate", null), this.props = {
      ...ein,
      ...e
    }, this.stats = new tM({
      id: this.props.id
    }), this.stats.get(Jrn), this.stats.get(Krn), this.stats.get(Wrn), this.stats.get(Xrn), this.stats.get(Zrn);
  }
  scheduleRequest(e, n = () => 0) {
    if (!this.props.throttleRequests)
      return Promise.resolve({
        done: () => {
        }
      });
    if (this.requestMap.has(e))
      return this.requestMap.get(e);
    const r = {
      handle: e,
      priority: 0,
      getPriority: n
    }, i = new Promise((o) => (r.resolve = o, r));
    return this.requestQueue.push(r), this.requestMap.set(e, i), this._issueNewRequests(), i;
  }
  _issueRequest(e) {
    const {
      handle: n,
      resolve: r
    } = e;
    let i = !1;
    const o = () => {
      i || (i = !0, this.requestMap.delete(n), this.activeRequestCount--, this._issueNewRequests());
    };
    return this.activeRequestCount++, r ? r({
      done: o
    }) : Promise.resolve({
      done: o
    });
  }
  _issueNewRequests() {
    this.deferredUpdate || (this.deferredUpdate = setTimeout(() => this._issueNewRequestsAsync(), 0));
  }
  _issueNewRequestsAsync() {
    this.deferredUpdate = null;
    const e = Math.max(this.props.maxRequests - this.activeRequestCount, 0);
    if (e !== 0) {
      this._updateAllRequests();
      for (let n = 0; n < e; ++n) {
        const r = this.requestQueue.shift();
        r && this._issueRequest(r);
      }
    }
  }
  _updateAllRequests() {
    const e = this.requestQueue;
    for (let n = 0; n < e.length; ++n) {
      const r = e[n];
      this._updateRequest(r) || (e.splice(n, 1), this.requestMap.delete(r.handle), n--);
    }
    e.sort((n, r) => n.priority - r.priority);
  }
  _updateRequest(e) {
    return e.priority = e.getPriority(e.handle), e.priority < 0 ? (e.resolve(null), !1) : !0;
  }
}
let tin = "";
const Ibe = {};
function nin(t) {
  for (const e in Ibe)
    if (t.startsWith(e)) {
      const n = Ibe[e];
      t = t.replace(e, n);
    }
  return !t.startsWith("http://") && !t.startsWith("https://") && (t = "".concat(tin).concat(t)), t;
}
function rin(t) {
  const e = t && t.lastIndexOf("/");
  return e >= 0 ? t.substr(e + 1) : "";
}
function d9e(t) {
  const e = t && t.lastIndexOf("/");
  return e >= 0 ? t.substr(0, e) : "";
}
const iin = (t) => typeof t == "boolean", mD = (t) => typeof t == "function", nM = (t) => t !== null && typeof t == "object", mbe = (t) => nM(t) && t.constructor === {}.constructor, oin = (t) => t && typeof t[Symbol.iterator] == "function", sin = (t) => t && typeof t[Symbol.asyncIterator] == "function", Rw = (t) => typeof Response < "u" && t instanceof Response || t && t.arrayBuffer && t.text && t.json, Dw = (t) => typeof Blob < "u" && t instanceof Blob, ain = (t) => t && typeof t == "object" && t.isBuffer, Ain = (t) => typeof ReadableStream < "u" && t instanceof ReadableStream || nM(t) && mD(t.tee) && mD(t.cancel) && mD(t.getReader), lin = (t) => nM(t) && mD(t.read) && mD(t.pipe) && iin(t.readable), p9e = (t) => Ain(t) || lin(t), cin = /^data:([-\w.]+\/[-\w.+]+)(;|,)/, uin = /^([-\w.]+\/[-\w.+]+)/;
function fin(t) {
  const e = uin.exec(t);
  return e ? e[1] : t;
}
function Cbe(t) {
  const e = cin.exec(t);
  return e ? e[1] : "";
}
const gin = /\?.*/;
function W9(t) {
  if (Rw(t)) {
    const e = tV(t.url || ""), n = t.headers.get("content-type") || "";
    return {
      url: e,
      type: fin(n) || Cbe(e)
    };
  }
  return Dw(t) ? {
    url: tV(t.name || ""),
    type: t.type || ""
  } : typeof t == "string" ? {
    url: tV(t),
    type: Cbe(t)
  } : {
    url: "",
    type: ""
  };
}
function hin(t) {
  return Rw(t) ? t.headers["content-length"] || -1 : Dw(t) ? t.size : typeof t == "string" ? t.length : t instanceof ArrayBuffer || ArrayBuffer.isView(t) ? t.byteLength : -1;
}
function tV(t) {
  return t.replace(gin, "");
}
async function I9e(t) {
  if (Rw(t))
    return t;
  const e = {}, n = hin(t);
  n >= 0 && (e["content-length"] = String(n));
  const {
    url: r,
    type: i
  } = W9(t);
  i && (e["content-type"] = i);
  const o = await Iin(t);
  o && (e["x-first-bytes"] = o), typeof t == "string" && (t = new TextEncoder().encode(t));
  const s = new Response(t, {
    headers: e
  });
  return Object.defineProperty(s, "url", {
    value: r
  }), s;
}
async function din(t) {
  if (!t.ok) {
    const e = await pin(t);
    throw new Error(e);
  }
}
async function pin(t) {
  let e = "Failed to fetch resource ".concat(t.url, " (").concat(t.status, "): ");
  try {
    const n = t.headers.get("Content-Type");
    let r = t.statusText;
    n.includes("application/json") && (r += " ".concat(await t.text())), e += r, e = e.length > 60 ? "".concat(e.slice(0, 60), "...") : e;
  } catch {
  }
  return e;
}
async function Iin(t) {
  if (typeof t == "string")
    return "data:,".concat(t.slice(0, 5));
  if (t instanceof Blob) {
    const n = t.slice(0, 5);
    return await new Promise((r) => {
      const i = new FileReader();
      i.onload = (o) => {
        var s;
        return r(o == null || (s = o.target) === null || s === void 0 ? void 0 : s.result);
      }, i.readAsDataURL(n);
    });
  }
  if (t instanceof ArrayBuffer) {
    const n = t.slice(0, 5), r = min(n);
    return "data:base64,".concat(r);
  }
  return null;
}
function min(t) {
  let e = "";
  const n = new Uint8Array(t);
  for (let r = 0; r < n.byteLength; r++)
    e += String.fromCharCode(n[r]);
  return btoa(e);
}
async function xee(t, e) {
  if (typeof t == "string") {
    t = nin(t);
    let n = e;
    return e != null && e.fetch && typeof e?.fetch != "function" && (n = e.fetch), await fetch(t, n);
  }
  return await I9e(t);
}
function m9e(t) {
  if (typeof window < "u" && typeof window.process == "object" && window.process.type === "renderer" || typeof process < "u" && typeof process.versions == "object" && process.versions.electron)
    return !0;
  const e = typeof navigator == "object" && typeof navigator.userAgent == "string" && navigator.userAgent, n = t || e;
  return !!(n && n.indexOf("Electron") >= 0);
}
function KI() {
  return !(typeof process == "object" && String(process) === "[object process]" && !process.browser) || m9e();
}
const yk = {
  self: typeof self < "u" && self,
  window: typeof window < "u" && window,
  global: typeof global < "u" && global,
  document: typeof document < "u" && document,
  process: typeof process == "object" && process
}, UF = yk.window || yk.self || yk.global, i2 = yk.process || {}, C9e = typeof __VERSION__ < "u" ? __VERSION__ : "untranspiled source";
KI();
const nV = globalThis;
function E9e(t) {
  if (!t && !KI())
    return "Node";
  if (m9e(t))
    return "Electron";
  const n = t || (typeof navigator < "u" ? navigator : {}).userAgent || "";
  if (n.indexOf("Edge") > -1)
    return "Edge";
  const r = n.indexOf("MSIE ") !== -1, i = n.indexOf("Trident/") !== -1;
  return r || i ? "IE" : nV.chrome ? "Chrome" : nV.safari ? "Safari" : nV.mozInnerScreenX ? "Firefox" : "Unknown";
}
function Cin(t) {
  try {
    const e = window[t], n = "__storage_test__";
    return e.setItem(n, n), e.removeItem(n), e;
  } catch {
    return null;
  }
}
class Ein {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "sessionStorage";
    ae(this, "storage", void 0), ae(this, "id", void 0), ae(this, "config", {}), this.storage = Cin(r), this.id = e, this.config = {}, Object.assign(this.config, n), this._loadConfiguration();
  }
  getConfiguration() {
    return this.config;
  }
  setConfiguration(e) {
    return this.config = {}, this.updateConfiguration(e);
  }
  updateConfiguration(e) {
    if (Object.assign(this.config, e), this.storage) {
      const n = JSON.stringify(this.config);
      this.storage.setItem(this.id, n);
    }
    return this;
  }
  _loadConfiguration() {
    let e = {};
    if (this.storage) {
      const n = this.storage.getItem(this.id);
      e = n ? JSON.parse(n) : {};
    }
    return Object.assign(this.config, e), this;
  }
}
function yin(t) {
  let e;
  return t < 10 ? e = "".concat(t.toFixed(2), "ms") : t < 100 ? e = "".concat(t.toFixed(1), "ms") : t < 1e3 ? e = "".concat(t.toFixed(0), "ms") : e = "".concat((t / 1e3).toFixed(2), "s"), e;
}
function vin(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 8;
  const n = Math.max(e - t.length, 0);
  return "".concat(" ".repeat(n)).concat(t);
}
function rV(t, e, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 600;
  const i = t.src.replace(/\(/g, "%28").replace(/\)/g, "%29");
  t.width > r && (n = Math.min(n, r / t.width));
  const o = t.width * n, s = t.height * n, a = ["font-size:1px;", "padding:".concat(Math.floor(s / 2), "px ").concat(Math.floor(o / 2), "px;"), "line-height:".concat(s, "px;"), "background:url(".concat(i, ");"), "background-size:".concat(o, "px ").concat(s, "px;"), "color:transparent;"].join("");
  return ["".concat(e, " %c+"), a];
}
let pU;
(function(t) {
  t[t.BLACK = 30] = "BLACK", t[t.RED = 31] = "RED", t[t.GREEN = 32] = "GREEN", t[t.YELLOW = 33] = "YELLOW", t[t.BLUE = 34] = "BLUE", t[t.MAGENTA = 35] = "MAGENTA", t[t.CYAN = 36] = "CYAN", t[t.WHITE = 37] = "WHITE", t[t.BRIGHT_BLACK = 90] = "BRIGHT_BLACK", t[t.BRIGHT_RED = 91] = "BRIGHT_RED", t[t.BRIGHT_GREEN = 92] = "BRIGHT_GREEN", t[t.BRIGHT_YELLOW = 93] = "BRIGHT_YELLOW", t[t.BRIGHT_BLUE = 94] = "BRIGHT_BLUE", t[t.BRIGHT_MAGENTA = 95] = "BRIGHT_MAGENTA", t[t.BRIGHT_CYAN = 96] = "BRIGHT_CYAN", t[t.BRIGHT_WHITE = 97] = "BRIGHT_WHITE";
})(pU || (pU = {}));
function Ebe(t) {
  return typeof t == "string" ? pU[t.toUpperCase()] || pU.WHITE : t;
}
function Bin(t, e, n) {
  return !KI && typeof t == "string" && (e && (e = Ebe(e), t = "\x1B[".concat(e, "m").concat(t, "\x1B[39m")), n && (e = Ebe(n), t = "\x1B[".concat(n + 10, "m").concat(t, "\x1B[49m"))), t;
}
function bin(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ["constructor"];
  const n = Object.getPrototypeOf(t), r = Object.getOwnPropertyNames(n);
  for (const i of r)
    typeof t[i] == "function" && (e.find((o) => i === o) || (t[i] = t[i].bind(t)));
}
function IU(t, e) {
  if (!t)
    throw new Error(e || "Assertion failed");
}
function nb() {
  let t;
  if (KI && "performance" in UF) {
    var e, n;
    t = UF == null || (e = UF.performance) === null || e === void 0 || (n = e.now) === null || n === void 0 ? void 0 : n.call(e);
  } else if ("hrtime" in i2) {
    var r;
    const i = i2 == null || (r = i2.hrtime) === null || r === void 0 ? void 0 : r.call(i2);
    t = i[0] * 1e3 + i[1] / 1e6;
  } else
    t = Date.now();
  return t;
}
const rb = {
  debug: KI && console.debug || console.log,
  log: console.log,
  info: console.info,
  warn: console.warn,
  error: console.error
}, _in = {
  enabled: !0,
  level: 0
};
function dg() {
}
const ybe = {}, vbe = {
  once: !0
};
let rM = class {
  constructor() {
    let {
      id: e
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      id: ""
    };
    ae(this, "id", void 0), ae(this, "VERSION", C9e), ae(this, "_startTs", nb()), ae(this, "_deltaTs", nb()), ae(this, "_storage", void 0), ae(this, "userData", {}), ae(this, "LOG_THROTTLE_TIMEOUT", 0), this.id = e, this._storage = new Ein("__probe-".concat(this.id, "__"), _in), this.userData = {}, this.timeStamp("".concat(this.id, " started")), bin(this), Object.seal(this);
  }
  set level(e) {
    this.setLevel(e);
  }
  get level() {
    return this.getLevel();
  }
  isEnabled() {
    return this._storage.config.enabled;
  }
  getLevel() {
    return this._storage.config.level;
  }
  getTotal() {
    return Number((nb() - this._startTs).toPrecision(10));
  }
  getDelta() {
    return Number((nb() - this._deltaTs).toPrecision(10));
  }
  set priority(e) {
    this.level = e;
  }
  get priority() {
    return this.level;
  }
  getPriority() {
    return this.level;
  }
  enable() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    return this._storage.updateConfiguration({
      enabled: e
    }), this;
  }
  setLevel(e) {
    return this._storage.updateConfiguration({
      level: e
    }), this;
  }
  get(e) {
    return this._storage.config[e];
  }
  set(e, n) {
    this._storage.updateConfiguration({
      [e]: n
    });
  }
  settings() {
    console.table ? console.table(this._storage.config) : console.log(this._storage.config);
  }
  assert(e, n) {
    IU(e, n);
  }
  warn(e) {
    return this._getLogFunction(0, e, rb.warn, arguments, vbe);
  }
  error(e) {
    return this._getLogFunction(0, e, rb.error, arguments);
  }
  deprecated(e, n) {
    return this.warn("`".concat(e, "` is deprecated and will be removed in a later version. Use `").concat(n, "` instead"));
  }
  removed(e, n) {
    return this.error("`".concat(e, "` has been removed. Use `").concat(n, "` instead"));
  }
  probe(e, n) {
    return this._getLogFunction(e, n, rb.log, arguments, {
      time: !0,
      once: !0
    });
  }
  log(e, n) {
    return this._getLogFunction(e, n, rb.debug, arguments);
  }
  info(e, n) {
    return this._getLogFunction(e, n, console.info, arguments);
  }
  once(e, n) {
    for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
      i[o - 2] = arguments[o];
    return this._getLogFunction(e, n, rb.debug || rb.info, arguments, vbe);
  }
  table(e, n, r) {
    return n ? this._getLogFunction(e, n, console.table || dg, r && [r], {
      tag: xin(n)
    }) : dg;
  }
  image(e) {
    let {
      logLevel: n,
      priority: r,
      image: i,
      message: o = "",
      scale: s = 1
    } = e;
    return this._shouldLog(n || r) ? KI ? win({
      image: i,
      message: o,
      scale: s
    }) : Qin({
      image: i,
      message: o,
      scale: s
    }) : dg;
  }
  time(e, n) {
    return this._getLogFunction(e, n, console.time ? console.time : console.info);
  }
  timeEnd(e, n) {
    return this._getLogFunction(e, n, console.timeEnd ? console.timeEnd : console.info);
  }
  timeStamp(e, n) {
    return this._getLogFunction(e, n, console.timeStamp || dg);
  }
  group(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
      collapsed: !1
    };
    const i = Bbe({
      logLevel: e,
      message: n,
      opts: r
    }), {
      collapsed: o
    } = r;
    return i.method = (o ? console.groupCollapsed : console.group) || console.info, this._getLogFunction(i);
  }
  groupCollapsed(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.group(e, n, Object.assign({}, r, {
      collapsed: !0
    }));
  }
  groupEnd(e) {
    return this._getLogFunction(e, "", console.groupEnd || dg);
  }
  withGroup(e, n, r) {
    this.group(e, n)();
    try {
      r();
    } finally {
      this.groupEnd(e)();
    }
  }
  trace() {
    console.trace && console.trace();
  }
  _shouldLog(e) {
    return this.isEnabled() && this.getLevel() >= y9e(e);
  }
  _getLogFunction(e, n, r, i, o) {
    if (this._shouldLog(e)) {
      o = Bbe({
        logLevel: e,
        message: n,
        args: i,
        opts: o
      }), r = r || o.method, IU(r), o.total = this.getTotal(), o.delta = this.getDelta(), this._deltaTs = nb();
      const s = o.tag || o.message;
      if (o.once)
        if (!ybe[s])
          ybe[s] = nb();
        else
          return dg;
      return n = Sin(this.id, o.message, o), r.bind(console, n, ...o.args);
    }
    return dg;
  }
};
ae(rM, "VERSION", C9e);
function y9e(t) {
  if (!t)
    return 0;
  let e;
  switch (typeof t) {
    case "number":
      e = t;
      break;
    case "object":
      e = t.logLevel || t.priority || 0;
      break;
    default:
      return 0;
  }
  return IU(Number.isFinite(e) && e >= 0), e;
}
function Bbe(t) {
  const {
    logLevel: e,
    message: n
  } = t;
  t.logLevel = y9e(e);
  const r = t.args ? Array.from(t.args) : [];
  for (; r.length && r.shift() !== n; )
    ;
  switch (typeof e) {
    case "string":
    case "function":
      n !== void 0 && r.unshift(n), t.message = e;
      break;
    case "object":
      Object.assign(t, e);
      break;
  }
  typeof t.message == "function" && (t.message = t.message());
  const i = typeof t.message;
  return IU(i === "string" || i === "object"), Object.assign(t, {
    args: r
  }, t.opts);
}
function Sin(t, e, n) {
  if (typeof e == "string") {
    const r = n.time ? vin(yin(n.total)) : "";
    e = n.time ? "".concat(t, ": ").concat(r, "  ").concat(e) : "".concat(t, ": ").concat(e), e = Bin(e, n.color, n.background);
  }
  return e;
}
function Qin(t) {
  let {
    image: e,
    message: n = "",
    scale: r = 1
  } = t;
  return (void 0)({
    image: e,
    message: n,
    scale: r
  }), dg;
}
function win(t) {
  let {
    image: e,
    message: n = "",
    scale: r = 1
  } = t;
  if (typeof e == "string") {
    const o = new Image();
    return o.onload = () => {
      const s = rV(o, n, r);
      console.log(...s);
    }, o.src = e, dg;
  }
  const i = e.nodeName || "";
  if (i.toLowerCase() === "img")
    return console.log(...rV(e, n, r)), dg;
  if (i.toLowerCase() === "canvas") {
    const o = new Image();
    return o.onload = () => console.log(...rV(o, n, r)), o.src = e.toDataURL(), dg;
  }
  return dg;
}
function xin(t) {
  for (const e in t)
    for (const n in t[e])
      return n || "untitled";
  return "empty";
}
const bbe = new rM({
  id: "loaders.gl"
});
class Rin {
  log() {
    return () => {
    };
  }
  info() {
    return () => {
    };
  }
  warn() {
    return () => {
    };
  }
  error() {
    return () => {
    };
  }
}
class Din {
  constructor() {
    mo(this, "console", void 0), this.console = console;
  }
  log(...e) {
    return this.console.log.bind(this.console, ...e);
  }
  info(...e) {
    return this.console.info.bind(this.console, ...e);
  }
  warn(...e) {
    return this.console.warn.bind(this.console, ...e);
  }
  error(...e) {
    return this.console.error.bind(this.console, ...e);
  }
}
const v9e = {
  fetch: null,
  mimeType: void 0,
  nothrow: !1,
  log: new Din(),
  CDN: "https://unpkg.com/@loaders.gl",
  worker: !0,
  maxConcurrency: 3,
  maxMobileConcurrency: 1,
  reuseWorkers: kS,
  _nodeWorkers: !1,
  _workerType: "",
  limit: 0,
  _limitMB: 0,
  batchSize: "auto",
  batchDebounceMs: 0,
  metadata: !1,
  transforms: []
}, Tin = {
  throws: "nothrow",
  dataType: "(no longer used)",
  uri: "baseUri",
  method: "fetch.method",
  headers: "fetch.headers",
  body: "fetch.body",
  mode: "fetch.mode",
  credentials: "fetch.credentials",
  cache: "fetch.cache",
  redirect: "fetch.redirect",
  referrer: "fetch.referrer",
  referrerPolicy: "fetch.referrerPolicy",
  integrity: "fetch.integrity",
  keepalive: "fetch.keepalive",
  signal: "fetch.signal"
};
function B9e() {
  globalThis.loaders = globalThis.loaders || {};
  const {
    loaders: t
  } = globalThis;
  return t._state = t._state || {}, t._state;
}
const b9e = () => {
  const t = B9e();
  return t.globalOptions = t.globalOptions || {
    ...v9e
  }, t.globalOptions;
};
function Nin(t, e, n, r) {
  return n = n || [], n = Array.isArray(n) ? n : [n], Lin(t, n), Oin(e, t, r);
}
function _9e(t, e) {
  const n = b9e(), r = t || n;
  return typeof r.fetch == "function" ? r.fetch : nM(r.fetch) ? (i) => xee(i, r) : e != null && e.fetch ? e?.fetch : xee;
}
function Lin(t, e) {
  _be(t, null, v9e, Tin, e);
  for (const n of e) {
    const r = t && t[n.id] || {}, i = n.options && n.options[n.id] || {}, o = n.deprecatedOptions && n.deprecatedOptions[n.id] || {};
    _be(r, n.id, i, o, e);
  }
}
function _be(t, e, n, r, i) {
  const o = e || "Top level", s = e ? "".concat(e, ".") : "";
  for (const a in t) {
    const A = !e && nM(t[a]), l = a === "baseUri" && !e, c = a === "workerUrl" && e;
    if (!(a in n) && !l && !c) {
      if (a in r)
        bbe.warn("".concat(o, " loader option '").concat(s).concat(a, "' no longer supported, use '").concat(r[a], "'"))();
      else if (!A) {
        const u = Min(a, i);
        bbe.warn("".concat(o, " loader option '").concat(s).concat(a, "' not recognized. ").concat(u))();
      }
    }
  }
}
function Min(t, e) {
  const n = t.toLowerCase();
  let r = "";
  for (const i of e)
    for (const o in i.options) {
      if (t === o)
        return "Did you mean '".concat(i.id, ".").concat(o, "'?");
      const s = o.toLowerCase();
      (n.startsWith(s) || s.startsWith(n)) && (r = r || "Did you mean '".concat(i.id, ".").concat(o, "'?"));
    }
  return r;
}
function Oin(t, e, n) {
  const i = {
    ...t.options || {}
  };
  return Fin(i, n), i.log === null && (i.log = new Rin()), Sbe(i, b9e()), Sbe(i, e), i;
}
function Sbe(t, e) {
  for (const n in e)
    if (n in e) {
      const r = e[n];
      mbe(r) && mbe(t[n]) ? t[n] = {
        ...t[n],
        ...e[n]
      } : t[n] = e[n];
    }
}
function Fin(t, e) {
  e && !("baseUri" in t) && (t.baseUri = e);
}
function cle(t) {
  var e;
  return t ? (Array.isArray(t) && (t = t[0]), Array.isArray((e = t) === null || e === void 0 ? void 0 : e.extensions)) : !1;
}
function ule(t) {
  var e, n;
  _o(t, "null loader"), _o(cle(t), "invalid loader");
  let r;
  return Array.isArray(t) && (r = t[1], t = t[0], t = {
    ...t,
    options: {
      ...t.options,
      ...r
    }
  }), ((e = t) !== null && e !== void 0 && e.parseTextSync || (n = t) !== null && n !== void 0 && n.parseText) && (t.text = !0), t.text || (t.binary = !0), t;
}
const S9e = () => {
  const t = B9e();
  return t.loaderRegistry = t.loaderRegistry || [], t.loaderRegistry;
};
function Pin(t) {
  const e = S9e();
  t = Array.isArray(t) ? t : [t];
  for (const n of t) {
    const r = ule(n);
    e.find((i) => r === i) || e.unshift(r);
  }
}
function kin() {
  return S9e();
}
const Gin = new rM({
  id: "loaders.gl"
}), Uin = /\.([^.]+)$/;
async function Hin(t, e = [], n, r) {
  if (!Q9e(t))
    return null;
  let i = Qbe(t, e, {
    ...n,
    nothrow: !0
  }, r);
  if (i)
    return i;
  if (Dw(t) && (t = await t.slice(0, 10).arrayBuffer(), i = Qbe(t, e, n, r)), !i && !(n != null && n.nothrow))
    throw new Error(w9e(t));
  return i;
}
function Qbe(t, e = [], n, r) {
  if (!Q9e(t))
    return null;
  if (e && !Array.isArray(e))
    return ule(e);
  let i = [];
  e && (i = i.concat(e)), n != null && n.ignoreRegisteredLoaders || i.push(...kin()), qin(i);
  const o = $in(t, i, n, r);
  if (!o && !(n != null && n.nothrow))
    throw new Error(w9e(t));
  return o;
}
function $in(t, e, n, r) {
  const {
    url: i,
    type: o
  } = W9(t), s = i || r?.url;
  let a = null, A = "";
  if (n != null && n.mimeType && (a = iV(e, n?.mimeType), A = "match forced by supplied MIME type ".concat(n?.mimeType)), a = a || jin(e, s), A = A || (a ? "matched url ".concat(s) : ""), a = a || iV(e, o), A = A || (a ? "matched MIME type ".concat(o) : ""), a = a || zin(e, t), A = A || (a ? "matched initial data ".concat(x9e(t)) : ""), a = a || iV(e, n?.fallbackMimeType), A = A || (a ? "matched fallback MIME type ".concat(o) : ""), A) {
    var l;
    Gin.log(1, "selectLoader selected ".concat((l = a) === null || l === void 0 ? void 0 : l.name, ": ").concat(A, "."));
  }
  return a;
}
function Q9e(t) {
  return !(t instanceof Response && t.status === 204);
}
function w9e(t) {
  const {
    url: e,
    type: n
  } = W9(t);
  let r = "No valid loader found (";
  r += e ? "".concat(rin(e), ", ") : "no url provided, ", r += "MIME type: ".concat(n ? '"'.concat(n, '"') : "not provided", ", ");
  const i = t ? x9e(t) : "";
  return r += i ? ' first bytes: "'.concat(i, '"') : "first bytes: not available", r += ")", r;
}
function qin(t) {
  for (const e of t)
    ule(e);
}
function jin(t, e) {
  const n = e && Uin.exec(e), r = n && n[1];
  return r ? Yin(t, r) : null;
}
function Yin(t, e) {
  e = e.toLowerCase();
  for (const n of t)
    for (const r of n.extensions)
      if (r.toLowerCase() === e)
        return n;
  return null;
}
function iV(t, e) {
  for (const n of t)
    if (n.mimeTypes && n.mimeTypes.includes(e) || e === "application/x.".concat(n.id))
      return n;
  return null;
}
function zin(t, e) {
  if (!e)
    return null;
  for (const n of t)
    if (typeof e == "string") {
      if (Vin(e, n))
        return n;
    } else if (ArrayBuffer.isView(e)) {
      if (wbe(e.buffer, e.byteOffset, n))
        return n;
    } else if (e instanceof ArrayBuffer && wbe(e, 0, n))
      return n;
  return null;
}
function Vin(t, e) {
  return e.testText ? e.testText(t) : (Array.isArray(e.tests) ? e.tests : [e.tests]).some((r) => t.startsWith(r));
}
function wbe(t, e, n) {
  return (Array.isArray(n.tests) ? n.tests : [n.tests]).some((i) => Jin(t, e, n, i));
}
function Jin(t, e, n, r) {
  if (r instanceof ArrayBuffer)
    return jrn(r, t, r.byteLength);
  switch (typeof r) {
    case "function":
      return r(t, n);
    case "string":
      const i = Ree(t, e, r.length);
      return r === i;
    default:
      return !1;
  }
}
function x9e(t, e = 5) {
  return typeof t == "string" ? t.slice(0, e) : ArrayBuffer.isView(t) ? Ree(t.buffer, t.byteOffset, e) : t instanceof ArrayBuffer ? Ree(t, 0, e) : "";
}
function Ree(t, e, n) {
  if (t.byteLength < e + n)
    return "";
  const r = new DataView(t);
  let i = "";
  for (let o = 0; o < n; o++)
    i += String.fromCharCode(r.getUint8(e + o));
  return i;
}
const Kin = 256 * 1024;
function* Win(t, e) {
  const n = e?.chunkSize || Kin;
  let r = 0;
  const i = new TextEncoder();
  for (; r < t.length; ) {
    const o = Math.min(t.length - r, n), s = t.slice(r, r + o);
    r += o, yield i.encode(s);
  }
}
const Xin = 256 * 1024;
function* Zin(t, e = {}) {
  const {
    chunkSize: n = Xin
  } = e;
  let r = 0;
  for (; r < t.byteLength; ) {
    const i = Math.min(t.byteLength - r, n), o = new ArrayBuffer(i), s = new Uint8Array(t, r, i);
    new Uint8Array(o).set(s), r += i, yield o;
  }
}
const eon = 1024 * 1024;
async function* ton(t, e) {
  const n = e?.chunkSize || eon;
  let r = 0;
  for (; r < t.size; ) {
    const i = r + n, o = await t.slice(r, i).arrayBuffer();
    r = i, yield o;
  }
}
function xbe(t, e) {
  return kS ? non(t, e) : ron(t);
}
async function* non(t, e) {
  const n = t.getReader();
  let r;
  try {
    for (; ; ) {
      const i = r || n.read();
      e != null && e._streamReadAhead && (r = n.read());
      const {
        done: o,
        value: s
      } = await i;
      if (o)
        return;
      yield g9e(s);
    }
  } catch {
    n.releaseLock();
  }
}
async function* ron(t, e) {
  for await (const n of t)
    yield g9e(n);
}
function ion(t, e) {
  if (typeof t == "string")
    return Win(t, e);
  if (t instanceof ArrayBuffer)
    return Zin(t, e);
  if (Dw(t))
    return ton(t, e);
  if (p9e(t))
    return xbe(t, e);
  if (Rw(t))
    return xbe(t.body, e);
  throw new Error("makeIterator");
}
const R9e = "Cannot convert supplied data type";
function oon(t, e, n) {
  if (e.text && typeof t == "string")
    return t;
  if (ain(t) && (t = t.buffer), t instanceof ArrayBuffer) {
    const r = t;
    return e.text && !e.binary ? new TextDecoder("utf8").decode(r) : r;
  }
  if (ArrayBuffer.isView(t)) {
    if (e.text && !e.binary)
      return new TextDecoder("utf8").decode(t);
    let r = t.buffer;
    const i = t.byteLength || t.length;
    return (t.byteOffset !== 0 || i !== r.byteLength) && (r = r.slice(t.byteOffset, t.byteOffset + i)), r;
  }
  throw new Error(R9e);
}
async function son(t, e, n) {
  const r = t instanceof ArrayBuffer || ArrayBuffer.isView(t);
  if (typeof t == "string" || r)
    return oon(t, e);
  if (Dw(t) && (t = await I9e(t)), Rw(t)) {
    const i = t;
    return await din(i), e.binary ? await i.arrayBuffer() : await i.text();
  }
  if (p9e(t) && (t = ion(t, n)), oin(t) || sin(t))
    return Vrn(t);
  throw new Error(R9e);
}
function aon(t, e, n = null) {
  if (n)
    return n;
  const r = {
    fetch: _9e(e, t),
    ...t
  };
  return Array.isArray(r.loaders) || (r.loaders = null), r;
}
function Aon(t, e) {
  if (!e && t && !Array.isArray(t))
    return t;
  let n;
  if (t && (n = Array.isArray(t) ? t : [t]), e && e.loaders) {
    const r = Array.isArray(e.loaders) ? e.loaders : [e.loaders];
    n = n ? [...n, ...r] : r;
  }
  return n && n.length ? n : null;
}
async function fle(t, e, n, r) {
  qp(!r || typeof r == "object"), e && !Array.isArray(e) && !cle(e) && (r = void 0, n = e, e = void 0), t = await t, n = n || {};
  const {
    url: i
  } = W9(t), s = Aon(e, r), a = await Hin(t, s, n);
  return a ? (n = Nin(n, a, s, i), r = aon({
    url: i,
    parse: fle,
    loaders: s
  }, n, r), await lon(a, t, n, r)) : null;
}
async function lon(t, e, n, r) {
  if (Lrn(t), Rw(e)) {
    const i = e, {
      ok: o,
      redirected: s,
      status: a,
      statusText: A,
      type: l,
      url: c
    } = i, u = Object.fromEntries(i.headers.entries());
    r.response = {
      headers: u,
      ok: o,
      redirected: s,
      status: a,
      statusText: A,
      type: l,
      url: c
    };
  }
  if (e = await son(e, t, n), t.parseTextSync && typeof e == "string")
    return n.dataType = "text", t.parseTextSync(e, n, r, t);
  if (krn(t, n))
    return await Grn(t, e, n, r, fle);
  if (t.parseText && typeof e == "string")
    return await t.parseText(e, n, r, t);
  if (t.parse)
    return await t.parse(e, n, r, t);
  throw qp(!t.parseSync), new Error("".concat(t.id, " loader - no parser found and worker is disabled"));
}
async function TI(t, e, n, r) {
  !Array.isArray(e) && !cle(e) && (n = e, e = void 0);
  const i = _9e(n);
  let o = t;
  return typeof t == "string" && (o = await i(t)), Dw(t) && (o = await i(t)), await fle(o, e, n);
}
const con = "3.2.10", {
  _parseImageNode: uon
} = globalThis, Dee = typeof Image < "u", Tee = typeof ImageBitmap < "u", fon = !!uon, Nee = kS ? !0 : fon;
function gon(t) {
  switch (t) {
    case "auto":
      return Tee || Dee || Nee;
    case "imagebitmap":
      return Tee;
    case "image":
      return Dee;
    case "data":
      return Nee;
    default:
      throw new Error("@loaders.gl/images: image ".concat(t, " not supported in this environment"));
  }
}
function hon() {
  if (Tee)
    return "imagebitmap";
  if (Dee)
    return "image";
  if (Nee)
    return "data";
  throw new Error("Install '@loaders.gl/polyfills' to parse images under Node.js");
}
function don(t) {
  const e = Ion(t);
  if (!e)
    throw new Error("Not an image");
  return e;
}
function pon(t) {
  switch (don(t)) {
    case "data":
      return t;
    case "image":
    case "imagebitmap":
      const e = document.createElement("canvas"), n = e.getContext("2d");
      if (!n)
        throw new Error("getImageData");
      return e.width = t.width, e.height = t.height, n.drawImage(t, 0, 0), n.getImageData(0, 0, t.width, t.height);
    default:
      throw new Error("getImageData");
  }
}
function Ion(t) {
  return typeof ImageBitmap < "u" && t instanceof ImageBitmap ? "imagebitmap" : typeof Image < "u" && t instanceof Image ? "image" : t && typeof t == "object" && t.data && t.width && t.height ? "data" : null;
}
const mon = /^data:image\/svg\+xml/, Con = /\.svg((\?|#).*)?$/;
function gle(t) {
  return t && (mon.test(t) || Con.test(t));
}
function Eon(t, e) {
  if (gle(e)) {
    let r = new TextDecoder().decode(t);
    try {
      typeof unescape == "function" && typeof encodeURIComponent == "function" && (r = unescape(encodeURIComponent(r)));
    } catch (o) {
      throw new Error(o.message);
    }
    return "data:image/svg+xml;base64,".concat(btoa(r));
  }
  return D9e(t, e);
}
function D9e(t, e) {
  if (gle(e))
    throw new Error("SVG cannot be parsed directly to imagebitmap");
  return new Blob([new Uint8Array(t)]);
}
async function T9e(t, e, n) {
  const r = Eon(t, n), i = self.URL || self.webkitURL, o = typeof r != "string" && i.createObjectURL(r);
  try {
    return await yon(o || r, e);
  } finally {
    o && i.revokeObjectURL(o);
  }
}
async function yon(t, e) {
  const n = new Image();
  return n.src = t, e.image && e.image.decode && n.decode ? (await n.decode(), n) : await new Promise((r, i) => {
    try {
      n.onload = () => r(n), n.onerror = (o) => i(new Error("Could not load image ".concat(t, ": ").concat(o)));
    } catch (o) {
      i(o);
    }
  });
}
const von = {};
let Rbe = !0;
async function Bon(t, e, n) {
  let r;
  gle(n) ? r = await T9e(t, e, n) : r = D9e(t, n);
  const i = e && e.imagebitmap;
  return await bon(r, i);
}
async function bon(t, e = null) {
  if ((_on(e) || !Rbe) && (e = null), e)
    try {
      return await createImageBitmap(t, e);
    } catch (n) {
      console.warn(n), Rbe = !1;
    }
  return await createImageBitmap(t);
}
function _on(t) {
  for (const e in t || von)
    return !1;
  return !0;
}
const gp = !1, CD = !0;
function hle(t) {
  const e = iM(t);
  return Son(e) || xon(e) || Qon(e) || won(e);
}
function Son(t) {
  const e = iM(t);
  return e.byteLength >= 24 && e.getUint32(0, gp) === 2303741511 ? {
    mimeType: "image/png",
    width: e.getUint32(16, gp),
    height: e.getUint32(20, gp)
  } : null;
}
function Qon(t) {
  const e = iM(t);
  return e.byteLength >= 10 && e.getUint32(0, gp) === 1195984440 ? {
    mimeType: "image/gif",
    width: e.getUint16(6, CD),
    height: e.getUint16(8, CD)
  } : null;
}
function won(t) {
  const e = iM(t);
  return e.byteLength >= 14 && e.getUint16(0, gp) === 16973 && e.getUint32(2, CD) === e.byteLength ? {
    mimeType: "image/bmp",
    width: e.getUint32(18, CD),
    height: e.getUint32(22, CD)
  } : null;
}
function xon(t) {
  const e = iM(t);
  if (!(e.byteLength >= 3 && e.getUint16(0, gp) === 65496 && e.getUint8(2) === 255))
    return null;
  const {
    tableMarkers: r,
    sofMarkers: i
  } = Ron();
  let o = 2;
  for (; o + 9 < e.byteLength; ) {
    const s = e.getUint16(o, gp);
    if (i.has(s))
      return {
        mimeType: "image/jpeg",
        height: e.getUint16(o + 5, gp),
        width: e.getUint16(o + 7, gp)
      };
    if (!r.has(s))
      return null;
    o += 2, o += e.getUint16(o, gp);
  }
  return null;
}
function Ron() {
  const t = /* @__PURE__ */ new Set([65499, 65476, 65484, 65501, 65534]);
  for (let n = 65504; n < 65520; ++n)
    t.add(n);
  return {
    tableMarkers: t,
    sofMarkers: /* @__PURE__ */ new Set([65472, 65473, 65474, 65475, 65477, 65478, 65479, 65481, 65482, 65483, 65485, 65486, 65487, 65502])
  };
}
function iM(t) {
  if (t instanceof DataView)
    return t;
  if (ArrayBuffer.isView(t))
    return new DataView(t.buffer);
  if (t instanceof ArrayBuffer)
    return new DataView(t);
  throw new Error("toDataView");
}
async function Don(t, e) {
  const {
    mimeType: n
  } = hle(t) || {}, r = globalThis._parseImageNode;
  return _o(r), await r(t, n);
}
async function Ton(t, e, n) {
  e = e || {};
  const i = (e.image || {}).type || "auto", {
    url: o
  } = n || {}, s = Non(i);
  let a;
  switch (s) {
    case "imagebitmap":
      a = await Bon(t, e, o);
      break;
    case "image":
      a = await T9e(t, e, o);
      break;
    case "data":
      a = await Don(t);
      break;
    default:
      _o(!1);
  }
  return i === "data" && (a = pon(a)), a;
}
function Non(t) {
  switch (t) {
    case "auto":
    case "data":
      return hon();
    default:
      return gon(t), t;
  }
}
const Lon = ["png", "jpg", "jpeg", "gif", "webp", "bmp", "ico", "svg"], Mon = ["image/png", "image/jpeg", "image/gif", "image/webp", "image/bmp", "image/vnd.microsoft.icon", "image/svg+xml"], Oon = {
  image: {
    type: "auto",
    decode: !0
  }
}, dle = {
  id: "image",
  module: "images",
  name: "Images",
  version: con,
  mimeTypes: Mon,
  extensions: Lon,
  parse: Ton,
  tests: [(t) => !!hle(new DataView(t))],
  options: Oon
}, Fon = ["image/png", "image/jpeg", "image/gif"], oV = {};
function Pon(t) {
  return oV[t] === void 0 && (oV[t] = kon(t)), oV[t];
}
function kon(t) {
  switch (t) {
    case "image/webp":
      return Gon();
    case "image/svg":
      return kS;
    default:
      if (!kS) {
        const {
          _parseImageNode: e
        } = globalThis;
        return !!e && Fon.includes(t);
      }
      return !0;
  }
}
function Gon() {
  if (!kS)
    return !1;
  try {
    return document.createElement("canvas").toDataURL("image/webp").indexOf("data:image/webp") === 0;
  } catch {
    return !1;
  }
}
const Rr = new rM({
  id: "deck"
});
let Lee = {};
function Uon(t) {
  Lee = t;
}
function Ul(t, e, n, r) {
  Rr.level > 0 && Lee[t] && Lee[t].call(null, e, n, r);
}
function Hon(t) {
  const e = t[0], n = t[t.length - 1];
  return e === "{" && n === "}" || e === "[" && n === "]";
}
const $on = {
  id: "JSON",
  name: "JSON",
  module: "",
  version: "",
  options: {},
  extensions: ["json", "geojson"],
  mimeTypes: ["application/json", "application/geo+json"],
  testText: Hon,
  parseTextSync: JSON.parse
}, ED = "8.8.27", vk = globalThis.deck && globalThis.deck.VERSION;
if (vk && vk !== ED)
  throw new Error("deck.gl - multiple versions detected: ".concat(vk, " vs ").concat(ED));
vk || (Rr.log(1, "deck.gl ".concat(ED))(), globalThis.deck = {
  ...globalThis.deck,
  VERSION: ED,
  version: ED,
  log: Rr,
  _registerLoggers: Uon
}, Pin([$on, [dle, {
  imagebitmap: {
    premultiplyAlpha: "none"
  }
}]]));
const qon = globalThis.deck, On = new rM({
  id: "luma.gl"
});
function Dc(t, e) {
  if (!t)
    throw new Error(e || "luma.gl: assertion failed.");
}
const jon = "Invalid WebGLRenderingContext", Yon = "Requires WebGL2";
function oM(t) {
  return typeof WebGLRenderingContext < "u" && t instanceof WebGLRenderingContext || typeof WebGL2RenderingContext < "u" && t instanceof WebGL2RenderingContext ? !0 : !!(t && Number.isFinite(t._version));
}
function Fr(t) {
  return typeof WebGL2RenderingContext < "u" && t instanceof WebGL2RenderingContext ? !0 : !!(t && t._version === 2);
}
function zon(t) {
  return Fr(t) ? t : null;
}
function X9(t) {
  return Dc(oM(t), jon), t;
}
function ol(t) {
  return Dc(Fr(t), Yon), t;
}
const vR = {};
function Von(t) {
  globalThis.console && globalThis.console.error && globalThis.console.error(t);
}
function Jon(t) {
  globalThis.console && globalThis.console.log && globalThis.console.log(t);
}
function Kon(t, e) {
  vR[t] = !0, e !== void 0 && Von(e);
}
function Won(t) {
  const e = t.getError;
  t.getError = function() {
    let r;
    do
      r = e.apply(t), r !== 0 && (vR[r] = !0);
    while (r !== 0);
    for (r in vR)
      if (vR[r])
        return delete vR[r], parseInt(r, 10);
    return 0;
  };
}
const sM = function t(e) {
  const n = e.gl;
  this.ext = e, this.isAlive = !0, this.hasBeenBound = !1, this.elementArrayBuffer = null, this.attribs = new Array(e.maxVertexAttribs);
  for (let r = 0; r < this.attribs.length; r++) {
    const i = new t.VertexAttrib(n);
    this.attribs[r] = i;
  }
  this.maxAttrib = 0;
};
sM.VertexAttrib = function(e) {
  this.enabled = !1, this.buffer = null, this.size = 4, this.type = 5126, this.normalized = !1, this.stride = 16, this.offset = 0, this.cached = "", this.recache();
};
sM.VertexAttrib.prototype.recache = function() {
  this.cached = [this.size, this.type, this.normalized, this.stride, this.offset].join(":");
};
const e1 = function(e) {
  const n = this;
  this.gl = e, Won(e);
  const r = this.original = {
    getParameter: e.getParameter,
    enableVertexAttribArray: e.enableVertexAttribArray,
    disableVertexAttribArray: e.disableVertexAttribArray,
    bindBuffer: e.bindBuffer,
    getVertexAttrib: e.getVertexAttrib,
    vertexAttribPointer: e.vertexAttribPointer
  };
  e.getParameter = function(o) {
    return o === n.VERTEX_ARRAY_BINDING_OES ? n.currentVertexArrayObject === n.defaultVertexArrayObject ? null : n.currentVertexArrayObject : r.getParameter.apply(this, arguments);
  }, e.enableVertexAttribArray = function(o) {
    const s = n.currentVertexArrayObject;
    s.maxAttrib = Math.max(s.maxAttrib, o);
    const a = s.attribs[o];
    return a.enabled = !0, r.enableVertexAttribArray.apply(this, arguments);
  }, e.disableVertexAttribArray = function(o) {
    const s = n.currentVertexArrayObject;
    s.maxAttrib = Math.max(s.maxAttrib, o);
    const a = s.attribs[o];
    return a.enabled = !1, r.disableVertexAttribArray.apply(this, arguments);
  }, e.bindBuffer = function(o, s) {
    switch (o) {
      case 34962:
        n.currentArrayBuffer = s;
        break;
      case 34963:
        n.currentVertexArrayObject.elementArrayBuffer = s;
        break;
    }
    return r.bindBuffer.apply(this, arguments);
  }, e.getVertexAttrib = function(o, s) {
    const A = n.currentVertexArrayObject.attribs[o];
    switch (s) {
      case 34975:
        return A.buffer;
      case 34338:
        return A.enabled;
      case 34339:
        return A.size;
      case 34340:
        return A.stride;
      case 34341:
        return A.type;
      case 34922:
        return A.normalized;
      default:
        return r.getVertexAttrib.apply(this, arguments);
    }
  }, e.vertexAttribPointer = function(o, s, a, A, l, c) {
    const u = n.currentVertexArrayObject;
    u.maxAttrib = Math.max(u.maxAttrib, o);
    const f = u.attribs[o];
    return f.buffer = n.currentArrayBuffer, f.size = s, f.type = a, f.normalized = A, f.stride = l, f.offset = c, f.recache(), r.vertexAttribPointer.apply(this, arguments);
  }, e.instrumentExtension && e.instrumentExtension(this, "OES_vertex_array_object"), e.canvas && e.canvas.addEventListener("webglcontextrestored", () => {
    Jon("OESVertexArrayObject emulation library context restored"), n.reset_();
  }, !0), this.reset_();
};
e1.prototype.VERTEX_ARRAY_BINDING_OES = 34229;
e1.prototype.reset_ = function() {
  if (this.vertexArrayObjects !== void 0)
    for (let r = 0; r < this.vertexArrayObjects.length; ++r)
      this.vertexArrayObjects.isAlive = !1;
  const n = this.gl;
  this.maxVertexAttribs = n.getParameter(34921), this.defaultVertexArrayObject = new sM(this), this.currentVertexArrayObject = null, this.currentArrayBuffer = null, this.vertexArrayObjects = [this.defaultVertexArrayObject], this.bindVertexArrayOES(null);
};
e1.prototype.createVertexArrayOES = function() {
  const e = new sM(this);
  return this.vertexArrayObjects.push(e), e;
};
e1.prototype.deleteVertexArrayOES = function(e) {
  e.isAlive = !1, this.vertexArrayObjects.splice(this.vertexArrayObjects.indexOf(e), 1), this.currentVertexArrayObject === e && this.bindVertexArrayOES(null);
};
e1.prototype.isVertexArrayOES = function(e) {
  return !!(e && e instanceof sM && e.hasBeenBound && e.ext === this);
};
e1.prototype.bindVertexArrayOES = function(e) {
  const n = this.gl;
  if (e && !e.isAlive) {
    Kon(1282, "bindVertexArrayOES: attempt to bind deleted arrayObject");
    return;
  }
  const r = this.original, i = this.currentVertexArrayObject;
  this.currentVertexArrayObject = e || this.defaultVertexArrayObject, this.currentVertexArrayObject.hasBeenBound = !0;
  const o = this.currentVertexArrayObject;
  if (i === o)
    return;
  (!i || o.elementArrayBuffer !== i.elementArrayBuffer) && r.bindBuffer.call(n, 34963, o.elementArrayBuffer);
  let s = this.currentArrayBuffer;
  const a = Math.max(i ? i.maxAttrib : 0, o.maxAttrib);
  for (let A = 0; A <= a; A++) {
    const l = o.attribs[A], c = i ? i.attribs[A] : null;
    if ((!i || l.enabled !== c.enabled) && (l.enabled ? r.enableVertexAttribArray.call(n, A) : r.disableVertexAttribArray.call(n, A)), l.enabled) {
      let u = !1;
      (!i || l.buffer !== c.buffer) && (s !== l.buffer && (r.bindBuffer.call(n, 34962, l.buffer), s = l.buffer), u = !0), (u || l.cached !== c.cached) && r.vertexAttribPointer.call(n, A, l.size, l.type, l.normalized, l.stride, l.offset);
    }
  }
  this.currentArrayBuffer !== s && r.bindBuffer.call(n, 34962, this.currentArrayBuffer);
};
function Xon(t) {
  if (typeof t.createVertexArray == "function")
    return;
  const e = t.getSupportedExtensions;
  t.getSupportedExtensions = function() {
    const i = e.call(this) || [];
    return i.indexOf("OES_vertex_array_object") < 0 && i.push("OES_vertex_array_object"), i;
  };
  const n = t.getExtension;
  t.getExtension = function(i) {
    const o = n.call(this, i);
    return o || (i !== "OES_vertex_array_object" ? null : (t.__OESVertexArrayObject || (this.__OESVertexArrayObject = new e1(this)), this.__OESVertexArrayObject));
  };
}
const Dbe = "OES_element_index", Tbe = "WEBGL_draw_buffers", Zon = "EXT_disjoint_timer_query", esn = "EXT_disjoint_timer_query_webgl2", tsn = "EXT_texture_filter_anisotropic", Nbe = "WEBGL_debug_renderer_info", nsn = 35723, rsn = 4352, isn = 36795, osn = 34047, ssn = 37445, asn = 37446, zo = (t) => Fr(t) ? void 0 : 0, Asn = {
  [3074]: (t) => Fr(t) ? void 0 : 36064,
  [nsn]: (t) => Fr(t) ? void 0 : rsn,
  [35977]: zo,
  [32937]: zo,
  [isn]: (t, e) => {
    const n = Fr(t) ? t.getExtension(esn) : t.getExtension(Zon);
    return n && n.GPU_DISJOINT_EXT ? e(n.GPU_DISJOINT_EXT) : 0;
  },
  [ssn]: (t, e) => {
    const n = t.getExtension(Nbe);
    return e(n && n.UNMASKED_VENDOR_WEBGL || 7936);
  },
  [asn]: (t, e) => {
    const n = t.getExtension(Nbe);
    return e(n && n.UNMASKED_RENDERER_WEBGL || 7937);
  },
  [osn]: (t, e) => {
    const n = t.luma.extensions[tsn];
    return n ? e(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 1;
  },
  [32883]: zo,
  [35071]: zo,
  [37447]: zo,
  [36063]: (t, e) => {
    if (!Fr(t)) {
      const n = t.getExtension(Tbe);
      return n ? e(n.MAX_COLOR_ATTACHMENTS_WEBGL) : 0;
    }
  },
  [35379]: zo,
  [35374]: zo,
  [35377]: zo,
  [34852]: (t) => {
    if (!Fr(t)) {
      const e = t.getExtension(Tbe);
      return e ? e.MAX_DRAW_BUFFERS_WEBGL : 0;
    }
  },
  [36203]: (t) => t.getExtension(Dbe) ? 2147483647 : 65535,
  [33001]: (t) => t.getExtension(Dbe) ? 16777216 : 65535,
  [33e3]: (t) => 16777216,
  [37157]: zo,
  [35373]: zo,
  [35657]: zo,
  [36183]: zo,
  [37137]: zo,
  [34045]: zo,
  [35978]: zo,
  [35979]: zo,
  [35968]: zo,
  [35376]: zo,
  [35375]: zo,
  [35659]: zo,
  [37154]: zo,
  [35371]: zo,
  [35658]: zo,
  [35076]: zo,
  [35077]: zo,
  [35380]: zo
};
function lsn(t, e, n) {
  const r = Asn[n], i = typeof r == "function" ? r(t, e, n) : r;
  return i !== void 0 ? i : e(n);
}
const csn = "OES_vertex_array_object", N9e = "ANGLE_instanced_arrays", usn = "WEBGL_draw_buffers", fsn = "EXT_disjoint_timer_query", gsn = "EXT_texture_filter_anisotropic", hsn = "VertexArray requires WebGL2 or OES_vertex_array_object extension";
function dsn(t, e) {
  return {
    webgl2: Fr(t),
    ext: t.getExtension(e)
  };
}
const L9e = {
  [csn]: {
    meta: {
      suffix: "OES"
    },
    createVertexArray: () => {
      Dc(!1, hsn);
    },
    deleteVertexArray: () => {
    },
    bindVertexArray: () => {
    },
    isVertexArray: () => !1
  },
  [N9e]: {
    meta: {
      suffix: "ANGLE"
    },
    vertexAttribDivisor(t, e) {
      Dc(e === 0, "WebGL instanced rendering not supported");
    },
    drawElementsInstanced: () => {
    },
    drawArraysInstanced: () => {
    }
  },
  [usn]: {
    meta: {
      suffix: "WEBGL"
    },
    drawBuffers: () => {
      Dc(!1);
    }
  },
  [fsn]: {
    meta: {
      suffix: "EXT"
    },
    createQuery: () => {
      Dc(!1);
    },
    deleteQuery: () => {
      Dc(!1);
    },
    beginQuery: () => {
      Dc(!1);
    },
    endQuery: () => {
    },
    getQuery(t, e) {
      return this.getQueryObject(t, e);
    },
    getQueryParameter(t, e) {
      return this.getQueryObject(t, e);
    },
    getQueryObject: () => {
    }
  }
}, sV = {
  readBuffer: (t, e, n) => {
    Fr(t) && e(n);
  },
  getVertexAttrib: (t, e, n, r) => {
    const {
      webgl2: i,
      ext: o
    } = dsn(t, N9e);
    let s;
    switch (r) {
      case 35069:
        s = i ? void 0 : !1;
        break;
      case 35070:
        s = !i && !o ? 0 : void 0;
        break;
    }
    return s !== void 0 ? s : e(n, r);
  },
  getProgramParameter: (t, e, n, r) => {
    if (!Fr(t))
      switch (r) {
        case 35967:
          return 35981;
        case 35971:
          return 0;
        case 35382:
          return 0;
      }
    return e(n, r);
  },
  getInternalformatParameter: (t, e, n, r, i) => {
    if (!Fr(t))
      switch (i) {
        case 32937:
          return new Int32Array([0]);
      }
    return t.getInternalformatParameter(n, r, i);
  },
  getTexParameter(t, e, n, r) {
    switch (r) {
      case 34046:
        const {
          extensions: i
        } = t.luma, o = i[gsn];
        r = o && o.TEXTURE_MAX_ANISOTROPY_EXT || 34046;
        break;
    }
    return e(n, r);
  },
  getParameter: lsn,
  hint(t, e, n, r) {
    return e(n, r);
  }
};
function psn(t) {
  t.luma = t.luma || {};
  const {
    luma: e
  } = t;
  return e.polyfilled || (Xon(t), Isn(t), Csn(t, L9e), msn(t, {
    target: e,
    target2: t
  }), e.polyfilled = !0), t;
}
globalThis.polyfillContext = psn;
function Isn(t) {
  t.luma.extensions = {};
  const e = t.getSupportedExtensions() || [];
  for (const n of e)
    t.luma[n] = t.getExtension(n);
}
function msn(t, e) {
  let {
    target: n,
    target2: r
  } = e;
  Object.keys(sV).forEach((i) => {
    if (typeof sV[i] == "function") {
      const o = t[i] ? t[i].bind(t) : () => {
      }, s = sV[i].bind(null, t, o);
      n[i] = s, r[i] = s;
    }
  });
}
function Csn(t, e) {
  for (const n of Object.getOwnPropertyNames(e))
    n !== "overrides" && Esn(t, {
      extension: n,
      target: t.luma,
      target2: t
    });
}
function Esn(t, e) {
  let {
    extension: n,
    target: r,
    target2: i
  } = e;
  const o = L9e[n];
  Dc(o);
  const {
    meta: s = {}
  } = o, {
    suffix: a = ""
  } = s, A = t.getExtension(n);
  for (const l of Object.keys(o)) {
    const c = "".concat(l).concat(a);
    let u = null;
    l === "meta" || typeof t[l] == "function" || (A && typeof A[c] == "function" ? u = function() {
      return A[c](...arguments);
    } : typeof o[l] == "function" && (u = o[l].bind(r))), u && (r[l] = u, i[l] = u);
  }
}
const ple = {
  [3042]: !1,
  [32773]: new Float32Array([0, 0, 0, 0]),
  [32777]: 32774,
  [34877]: 32774,
  [32969]: 1,
  [32968]: 0,
  [32971]: 1,
  [32970]: 0,
  [3106]: new Float32Array([0, 0, 0, 0]),
  [3107]: [!0, !0, !0, !0],
  [2884]: !1,
  [2885]: 1029,
  [2929]: !1,
  [2931]: 1,
  [2932]: 513,
  [2928]: new Float32Array([0, 1]),
  [2930]: !0,
  [3024]: !0,
  [36006]: null,
  [2886]: 2305,
  [33170]: 4352,
  [2849]: 1,
  [32823]: !1,
  [32824]: 0,
  [10752]: 0,
  [32938]: 1,
  [32939]: !1,
  [3089]: !1,
  [3088]: new Int32Array([0, 0, 1024, 1024]),
  [2960]: !1,
  [2961]: 0,
  [2968]: 4294967295,
  [36005]: 4294967295,
  [2962]: 519,
  [2967]: 0,
  [2963]: 4294967295,
  [34816]: 519,
  [36003]: 0,
  [36004]: 4294967295,
  [2964]: 7680,
  [2965]: 7680,
  [2966]: 7680,
  [34817]: 7680,
  [34818]: 7680,
  [34819]: 7680,
  [2978]: [0, 0, 1024, 1024],
  [3333]: 4,
  [3317]: 4,
  [37440]: !1,
  [37441]: !1,
  [37443]: 37444,
  [35723]: 4352,
  [36010]: null,
  [35977]: !1,
  [3330]: 0,
  [3332]: 0,
  [3331]: 0,
  [3314]: 0,
  [32878]: 0,
  [3316]: 0,
  [3315]: 0,
  [32877]: 0
}, Qm = (t, e, n) => e ? t.enable(n) : t.disable(n), Lbe = (t, e, n) => t.hint(n, e), af = (t, e, n) => t.pixelStorei(n, e), ysn = (t, e) => {
  const n = Fr(t) ? 36009 : 36160;
  return t.bindFramebuffer(n, e);
}, vsn = (t, e) => t.bindFramebuffer(36008, e);
function o2(t) {
  return Array.isArray(t) || ArrayBuffer.isView(t);
}
const Bsn = {
  [3042]: Qm,
  [32773]: (t, e) => t.blendColor(...e),
  [32777]: "blendEquation",
  [34877]: "blendEquation",
  [32969]: "blendFunc",
  [32968]: "blendFunc",
  [32971]: "blendFunc",
  [32970]: "blendFunc",
  [3106]: (t, e) => t.clearColor(...e),
  [3107]: (t, e) => t.colorMask(...e),
  [2884]: Qm,
  [2885]: (t, e) => t.cullFace(e),
  [2929]: Qm,
  [2931]: (t, e) => t.clearDepth(e),
  [2932]: (t, e) => t.depthFunc(e),
  [2928]: (t, e) => t.depthRange(...e),
  [2930]: (t, e) => t.depthMask(e),
  [3024]: Qm,
  [35723]: Lbe,
  [36006]: ysn,
  [2886]: (t, e) => t.frontFace(e),
  [33170]: Lbe,
  [2849]: (t, e) => t.lineWidth(e),
  [32823]: Qm,
  [32824]: "polygonOffset",
  [10752]: "polygonOffset",
  [35977]: Qm,
  [32938]: "sampleCoverage",
  [32939]: "sampleCoverage",
  [3089]: Qm,
  [3088]: (t, e) => t.scissor(...e),
  [2960]: Qm,
  [2961]: (t, e) => t.clearStencil(e),
  [2968]: (t, e) => t.stencilMaskSeparate(1028, e),
  [36005]: (t, e) => t.stencilMaskSeparate(1029, e),
  [2962]: "stencilFuncFront",
  [2967]: "stencilFuncFront",
  [2963]: "stencilFuncFront",
  [34816]: "stencilFuncBack",
  [36003]: "stencilFuncBack",
  [36004]: "stencilFuncBack",
  [2964]: "stencilOpFront",
  [2965]: "stencilOpFront",
  [2966]: "stencilOpFront",
  [34817]: "stencilOpBack",
  [34818]: "stencilOpBack",
  [34819]: "stencilOpBack",
  [2978]: (t, e) => t.viewport(...e),
  [3333]: af,
  [3317]: af,
  [37440]: af,
  [37441]: af,
  [37443]: af,
  [3330]: af,
  [3332]: af,
  [3331]: af,
  [36010]: vsn,
  [3314]: af,
  [32878]: af,
  [3316]: af,
  [3315]: af,
  [32877]: af,
  framebuffer: (t, e) => {
    const n = e && "handle" in e ? e.handle : e;
    return t.bindFramebuffer(36160, n);
  },
  blend: (t, e) => e ? t.enable(3042) : t.disable(3042),
  blendColor: (t, e) => t.blendColor(...e),
  blendEquation: (t, e) => {
    e = o2(e) ? e : [e, e], t.blendEquationSeparate(...e);
  },
  blendFunc: (t, e) => {
    e = o2(e) && e.length === 2 ? [...e, ...e] : e, t.blendFuncSeparate(...e);
  },
  clearColor: (t, e) => t.clearColor(...e),
  clearDepth: (t, e) => t.clearDepth(e),
  clearStencil: (t, e) => t.clearStencil(e),
  colorMask: (t, e) => t.colorMask(...e),
  cull: (t, e) => e ? t.enable(2884) : t.disable(2884),
  cullFace: (t, e) => t.cullFace(e),
  depthTest: (t, e) => e ? t.enable(2929) : t.disable(2929),
  depthFunc: (t, e) => t.depthFunc(e),
  depthMask: (t, e) => t.depthMask(e),
  depthRange: (t, e) => t.depthRange(...e),
  dither: (t, e) => e ? t.enable(3024) : t.disable(3024),
  derivativeHint: (t, e) => {
    t.hint(35723, e);
  },
  frontFace: (t, e) => t.frontFace(e),
  mipmapHint: (t, e) => t.hint(33170, e),
  lineWidth: (t, e) => t.lineWidth(e),
  polygonOffsetFill: (t, e) => e ? t.enable(32823) : t.disable(32823),
  polygonOffset: (t, e) => t.polygonOffset(...e),
  sampleCoverage: (t, e) => t.sampleCoverage(...e),
  scissorTest: (t, e) => e ? t.enable(3089) : t.disable(3089),
  scissor: (t, e) => t.scissor(...e),
  stencilTest: (t, e) => e ? t.enable(2960) : t.disable(2960),
  stencilMask: (t, e) => {
    e = o2(e) ? e : [e, e];
    const [n, r] = e;
    t.stencilMaskSeparate(1028, n), t.stencilMaskSeparate(1029, r);
  },
  stencilFunc: (t, e) => {
    e = o2(e) && e.length === 3 ? [...e, ...e] : e;
    const [n, r, i, o, s, a] = e;
    t.stencilFuncSeparate(1028, n, r, i), t.stencilFuncSeparate(1029, o, s, a);
  },
  stencilOp: (t, e) => {
    e = o2(e) && e.length === 3 ? [...e, ...e] : e;
    const [n, r, i, o, s, a] = e;
    t.stencilOpSeparate(1028, n, r, i), t.stencilOpSeparate(1029, o, s, a);
  },
  viewport: (t, e) => t.viewport(...e)
};
function sa(t, e, n) {
  return e[t] !== void 0 ? e[t] : n[t];
}
const bsn = {
  blendEquation: (t, e, n) => t.blendEquationSeparate(sa(32777, e, n), sa(34877, e, n)),
  blendFunc: (t, e, n) => t.blendFuncSeparate(sa(32969, e, n), sa(32968, e, n), sa(32971, e, n), sa(32970, e, n)),
  polygonOffset: (t, e, n) => t.polygonOffset(sa(32824, e, n), sa(10752, e, n)),
  sampleCoverage: (t, e, n) => t.sampleCoverage(sa(32938, e, n), sa(32939, e, n)),
  stencilFuncFront: (t, e, n) => t.stencilFuncSeparate(1028, sa(2962, e, n), sa(2967, e, n), sa(2963, e, n)),
  stencilFuncBack: (t, e, n) => t.stencilFuncSeparate(1029, sa(34816, e, n), sa(36003, e, n), sa(36004, e, n)),
  stencilOpFront: (t, e, n) => t.stencilOpSeparate(1028, sa(2964, e, n), sa(2965, e, n), sa(2966, e, n)),
  stencilOpBack: (t, e, n) => t.stencilOpSeparate(1029, sa(34817, e, n), sa(34818, e, n), sa(34819, e, n))
}, Mbe = {
  enable: (t, e) => t({
    [e]: !0
  }),
  disable: (t, e) => t({
    [e]: !1
  }),
  pixelStorei: (t, e, n) => t({
    [e]: n
  }),
  hint: (t, e, n) => t({
    [e]: n
  }),
  bindFramebuffer: (t, e, n) => {
    switch (e) {
      case 36160:
        return t({
          [36006]: n,
          [36010]: n
        });
      case 36009:
        return t({
          [36006]: n
        });
      case 36008:
        return t({
          [36010]: n
        });
      default:
        return null;
    }
  },
  blendColor: (t, e, n, r, i) => t({
    [32773]: new Float32Array([e, n, r, i])
  }),
  blendEquation: (t, e) => t({
    [32777]: e,
    [34877]: e
  }),
  blendEquationSeparate: (t, e, n) => t({
    [32777]: e,
    [34877]: n
  }),
  blendFunc: (t, e, n) => t({
    [32969]: e,
    [32968]: n,
    [32971]: e,
    [32970]: n
  }),
  blendFuncSeparate: (t, e, n, r, i) => t({
    [32969]: e,
    [32968]: n,
    [32971]: r,
    [32970]: i
  }),
  clearColor: (t, e, n, r, i) => t({
    [3106]: new Float32Array([e, n, r, i])
  }),
  clearDepth: (t, e) => t({
    [2931]: e
  }),
  clearStencil: (t, e) => t({
    [2961]: e
  }),
  colorMask: (t, e, n, r, i) => t({
    [3107]: [e, n, r, i]
  }),
  cullFace: (t, e) => t({
    [2885]: e
  }),
  depthFunc: (t, e) => t({
    [2932]: e
  }),
  depthRange: (t, e, n) => t({
    [2928]: new Float32Array([e, n])
  }),
  depthMask: (t, e) => t({
    [2930]: e
  }),
  frontFace: (t, e) => t({
    [2886]: e
  }),
  lineWidth: (t, e) => t({
    [2849]: e
  }),
  polygonOffset: (t, e, n) => t({
    [32824]: e,
    [10752]: n
  }),
  sampleCoverage: (t, e, n) => t({
    [32938]: e,
    [32939]: n
  }),
  scissor: (t, e, n, r, i) => t({
    [3088]: new Int32Array([e, n, r, i])
  }),
  stencilMask: (t, e) => t({
    [2968]: e,
    [36005]: e
  }),
  stencilMaskSeparate: (t, e, n) => t({
    [e === 1028 ? 2968 : 36005]: n
  }),
  stencilFunc: (t, e, n, r) => t({
    [2962]: e,
    [2967]: n,
    [2963]: r,
    [34816]: e,
    [36003]: n,
    [36004]: r
  }),
  stencilFuncSeparate: (t, e, n, r, i) => t({
    [e === 1028 ? 2962 : 34816]: n,
    [e === 1028 ? 2967 : 36003]: r,
    [e === 1028 ? 2963 : 36004]: i
  }),
  stencilOp: (t, e, n, r) => t({
    [2964]: e,
    [2965]: n,
    [2966]: r,
    [34817]: e,
    [34818]: n,
    [34819]: r
  }),
  stencilOpSeparate: (t, e, n, r, i) => t({
    [e === 1028 ? 2964 : 34817]: n,
    [e === 1028 ? 2965 : 34818]: r,
    [e === 1028 ? 2966 : 34819]: i
  }),
  viewport: (t, e, n, r, i) => t({
    [2978]: [e, n, r, i]
  })
}, zd = (t, e) => t.isEnabled(e), Obe = {
  [3042]: zd,
  [2884]: zd,
  [2929]: zd,
  [3024]: zd,
  [32823]: zd,
  [32926]: zd,
  [32928]: zd,
  [3089]: zd,
  [2960]: zd,
  [35977]: zd
};
function M9e(t) {
  for (const e in t)
    return !1;
  return !0;
}
function _sn(t, e) {
  if (t === e)
    return !0;
  const n = Array.isArray(t) || ArrayBuffer.isView(t), r = Array.isArray(e) || ArrayBuffer.isView(e);
  if (n && r && t.length === e.length) {
    for (let i = 0; i < t.length; ++i)
      if (t[i] !== e[i])
        return !1;
    return !0;
  }
  return !1;
}
function Fbe(t, e) {
  const n = t[e].bind(t);
  t[e] = function() {
    const i = arguments.length <= 0 ? void 0 : arguments[0];
    return i in t.state.cache ? t.state.enable ? t.state.cache[i] : n(...arguments) : n(...arguments);
  }, Object.defineProperty(t[e], "name", {
    value: "".concat(e, "-from-cache"),
    configurable: !1
  });
}
function Ssn(t, e, n) {
  const r = t[e].bind(t);
  t[e] = function() {
    for (var o = arguments.length, s = new Array(o), a = 0; a < o; a++)
      s[a] = arguments[a];
    const {
      valueChanged: A,
      oldValue: l
    } = n(t.state._updateCache, ...s);
    return A && r(...s), l;
  }, Object.defineProperty(t[e], "name", {
    value: "".concat(e, "-to-cache"),
    configurable: !1
  });
}
function Qsn(t) {
  const e = t.useProgram.bind(t);
  t.useProgram = function(r) {
    t.state.program !== r && (e(r), t.state.program = r);
  };
}
class wsn {
  constructor(e) {
    let {
      copyState: n = !1,
      log: r = () => {
      }
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.gl = e, this.program = null, this.stateStack = [], this.enable = !0, this.cache = n ? F9e(e) : Object.assign({}, ple), this.log = r, this._updateCache = this._updateCache.bind(this), Object.seal(this);
  }
  push() {
    this.stateStack.push({});
  }
  pop() {
    Dc(this.stateStack.length > 0);
    const e = this.stateStack[this.stateStack.length - 1];
    cd(this.gl, e), this.stateStack.pop();
  }
  _updateCache(e) {
    let n = !1, r;
    const i = this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1];
    for (const o in e) {
      Dc(o !== void 0);
      const s = e[o], a = this.cache[o];
      _sn(s, a) || (n = !0, r = a, i && !(o in i) && (i[o] = a), this.cache[o] = s);
    }
    return {
      valueChanged: n,
      oldValue: r
    };
  }
}
function O9e(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    enable: n = !0,
    copyState: r
  } = e;
  if (Dc(r !== void 0), !t.state) {
    const {
      polyfillContext: i
    } = globalThis;
    i && i(t), t.state = new wsn(t, {
      copyState: r
    }), Qsn(t);
    for (const o in Mbe) {
      const s = Mbe[o];
      Ssn(t, o, s);
    }
    Fbe(t, "getParameter"), Fbe(t, "isEnabled");
  }
  return t.state.enable = n, t;
}
function xsn(t) {
  t.state || O9e(t, {
    copyState: !1
  }), t.state.push();
}
function Pbe(t) {
  Dc(t.state), t.state.pop();
}
function cd(t, e) {
  if (Dc(oM(t), "setParameters requires a WebGL context"), M9e(e))
    return;
  const n = {};
  for (const i in e) {
    const o = Number(i), s = Bsn[i];
    s && (typeof s == "string" ? n[s] = !0 : s(t, e[i], o));
  }
  const r = t.state && t.state.cache;
  if (r)
    for (const i in n) {
      const o = bsn[i];
      o(t, e, r);
    }
}
function F9e(t, e) {
  if (e = e || ple, typeof e == "number") {
    const i = e, o = Obe[i];
    return o ? o(t, i) : t.getParameter(i);
  }
  const n = Array.isArray(e) ? e : Object.keys(e), r = {};
  for (const i of n) {
    const o = Obe[i];
    r[i] = o ? o(t, Number(i)) : t.getParameter(Number(i));
  }
  return r;
}
function P9e(t) {
  cd(t, ple);
}
function Yc(t, e, n) {
  if (M9e(e))
    return n(t);
  const {
    nocatch: r = !0
  } = e;
  xsn(t), cd(t, e);
  let i;
  if (r)
    i = n(t), Pbe(t);
  else
    try {
      i = n(t);
    } finally {
      Pbe(t);
    }
  return i;
}
function Wv(t) {
  const {
    luma: e
  } = t;
  if (t.canvas && e) {
    const n = e.canvasSizeInfo, r = "clientWidth" in n ? n.clientWidth : t.canvas.clientWidth;
    return r ? t.drawingBufferWidth / r : 1;
  }
  return 1;
}
function Bk(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  const r = Wv(t), i = t.drawingBufferWidth, o = t.drawingBufferHeight;
  return Dsn(e, r, i, o, n);
}
function Rsn(t) {
  const e = typeof window > "u" ? 1 : window.devicePixelRatio || 1;
  return Number.isFinite(t) ? t <= 0 ? 1 : t : t ? e : 1;
}
function Dsn(t, e, n, r, i) {
  const o = kbe(t[0], e, n);
  let s = Gbe(t[1], e, r, i), a = kbe(t[0] + 1, e, n);
  const A = a === n - 1 ? a : a - 1;
  a = Gbe(t[1] + 1, e, r, i);
  let l;
  return i ? (a = a === 0 ? a : a + 1, l = s, s = a) : l = a === r - 1 ? a : a - 1, {
    x: o,
    y: s,
    width: Math.max(A - o + 1, 1),
    height: Math.max(l - s + 1, 1)
  };
}
function kbe(t, e, n) {
  return Math.min(Math.round(t * e), n - 1);
}
function Gbe(t, e, n, r) {
  return r ? Math.max(0, n - 1 - Math.round(t * e)) : Math.min(Math.round(t * e), n - 1);
}
const Ile = KI(), Tsn = Ile && typeof document < "u", k9e = {
  webgl2: !0,
  webgl1: !0,
  throwOnError: !0,
  manageState: !0,
  canvas: null,
  debug: !1,
  width: 800,
  height: 600
};
function mle() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  Dc(Ile, `createGLContext only available in the browser.
Create your own headless context or use 'createHeadlessContext' from @luma.gl/test-utils`), t = Object.assign({}, k9e, t);
  const {
    width: e,
    height: n
  } = t;
  function r(a) {
    if (t.throwOnError)
      throw new Error(a);
    return console.error(a), null;
  }
  t.onError = r;
  let i;
  const {
    canvas: o
  } = t, s = Osn({
    canvas: o,
    width: e,
    height: n,
    onError: r
  });
  return i = Msn(s, t), i ? (i = Z9(i, t), Fsn(i), i) : null;
}
function Z9(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!t || t._instrumented)
    return t;
  t._version = t._version || Psn(t), t.luma = t.luma || {}, t.luma.canvasSizeInfo = t.luma.canvasSizeInfo || {}, e = Object.assign({}, k9e, e);
  const {
    manageState: n,
    debug: r
  } = e;
  return n && O9e(t, {
    copyState: !1,
    log: function() {
      for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
        o[s] = arguments[s];
      return On.log(1, ...o)();
    }
  }), Ile && r && (globalThis.makeDebugContext ? (t = globalThis.makeDebugContext(t, e), On.level = Math.max(On.level, 1)) : On.warn('WebGL debug mode not activated. import "@luma.gl/debug" to enable.')()), t._instrumented = !0, t;
}
function Nsn(t) {
  const e = t.getParameter(7936), n = t.getParameter(7937), r = t.getExtension("WEBGL_debug_renderer_info"), i = r && t.getParameter(r.UNMASKED_VENDOR_WEBGL || 7936), o = r && t.getParameter(r.UNMASKED_RENDERER_WEBGL || 7937);
  return {
    vendor: i || e,
    renderer: o || n,
    vendorMasked: e,
    rendererMasked: n,
    version: t.getParameter(7938),
    shadingLanguageVersion: t.getParameter(35724)
  };
}
function Lsn(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t.canvas) {
    const r = Rsn(e.useDevicePixels);
    ksn(t, r, e);
    return;
  }
  const n = t.getExtension("STACKGL_resize_drawingbuffer");
  n && "width" in e && "height" in e && n.resize(e.width, e.height);
}
function Msn(t, e) {
  const {
    onError: n
  } = e;
  let r = null;
  const i = (A) => r = A.statusMessage || r;
  t.addEventListener("webglcontextcreationerror", i, !1);
  const {
    webgl1: o = !0,
    webgl2: s = !0
  } = e;
  let a = null;
  return s && (a = a || t.getContext("webgl2", e), a = a || t.getContext("experimental-webgl2", e)), o && (a = a || t.getContext("webgl", e), a = a || t.getContext("experimental-webgl", e)), t.removeEventListener("webglcontextcreationerror", i, !1), a ? (e.onContextLost && t.addEventListener("webglcontextlost", e.onContextLost, !1), e.onContextRestored && t.addEventListener("webglcontextrestored", e.onContextRestored, !1), a) : n("Failed to create ".concat(s && !o ? "WebGL2" : "WebGL", " context: ").concat(r || "Unknown error"));
}
function Osn(t) {
  let {
    canvas: e,
    width: n = 800,
    height: r = 600,
    onError: i
  } = t, o;
  return typeof e == "string" ? (Tsn && document.readyState === "complete" || i("createGLContext called on canvas '".concat(e, "' before page was loaded")), o = document.getElementById(e)) : e ? o = e : (o = document.createElement("canvas"), o.id = "lumagl-canvas", o.style.width = Number.isFinite(n) ? "".concat(n, "px") : "100%", o.style.height = Number.isFinite(r) ? "".concat(r, "px") : "100%", document.body.insertBefore(o, document.body.firstChild)), o;
}
function Fsn(t) {
  const e = Fr(t) ? "WebGL2" : "WebGL1", n = Nsn(t), r = n ? "(".concat(n.vendor, ",").concat(n.renderer, ")") : "", i = t.debug ? " debug" : "";
  On.info(1, "".concat(e).concat(i, " context ").concat(r))();
}
function Psn(t) {
  return typeof WebGL2RenderingContext < "u" && t instanceof WebGL2RenderingContext ? 2 : 1;
}
function ksn(t, e, n) {
  let r = "width" in n ? n.width : t.canvas.clientWidth, i = "height" in n ? n.height : t.canvas.clientHeight;
  (!r || !i) && (On.log(1, "Canvas clientWidth/clientHeight is 0")(), e = 1, r = t.canvas.width || 1, i = t.canvas.height || 1), t.luma = t.luma || {}, t.luma.canvasSizeInfo = t.luma.canvasSizeInfo || {};
  const o = t.luma.canvasSizeInfo;
  if (o.clientWidth !== r || o.clientHeight !== i || o.devicePixelRatio !== e) {
    let s = e;
    const a = Math.floor(r * s), A = Math.floor(i * s);
    t.canvas.width = a, t.canvas.height = A, (t.drawingBufferWidth !== a || t.drawingBufferHeight !== A) && (On.warn("Device pixel ratio clamped")(), s = Math.min(t.drawingBufferWidth / r, t.drawingBufferHeight / i), t.canvas.width = Math.floor(r * s), t.canvas.height = Math.floor(i * s)), Object.assign(t.luma.canvasSizeInfo, {
      clientWidth: r,
      clientHeight: i,
      devicePixelRatio: e
    });
  }
}
const yD = "8.5.21", Gsn = "set luma.log.level=1 (or higher) to trace rendering";
class Usn {
  constructor() {
    this.stats = /* @__PURE__ */ new Map();
  }
  get(e) {
    return this.stats.has(e) || this.stats.set(e, new tM({
      id: e
    })), this.stats.get(e);
  }
}
const sC = new Usn();
if (globalThis.luma && globalThis.luma.VERSION !== yD)
  throw new Error("luma.gl - multiple VERSIONs detected: ".concat(globalThis.luma.VERSION, " vs ").concat(yD));
globalThis.luma || (KI() && On.log(1, "luma.gl ".concat(yD, " - ").concat(Gsn))(), globalThis.luma = globalThis.luma || {
  VERSION: yD,
  version: yD,
  log: On,
  stats: sC,
  globals: {
    modules: {},
    nodeIO: {}
  }
});
function Hsn(t) {
  return typeof window < "u" && window.requestAnimationFrame ? window.requestAnimationFrame(t) : setTimeout(t, 1e3 / 60);
}
function $sn(t) {
  return typeof window < "u" && window.cancelAnimationFrame ? window.cancelAnimationFrame(t) : clearTimeout(t);
}
function dn(t, e) {
  if (!t)
    throw new Error(e || "luma.gl: assertion failed.");
}
function aV(t, e) {
  if (typeof e != "string")
    return e;
  const n = Number(e);
  if (!isNaN(n))
    return n;
  e = e.replace(/^.*\./, "");
  const r = t[e];
  return dn(r !== void 0, "Accessing undefined constant GL.".concat(e)), r;
}
function SC(t, e) {
  e = Number(e);
  for (const n in t)
    if (t[n] === e)
      return "GL.".concat(n);
  return String(e);
}
const AV = {};
function PA() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "id";
  AV[t] = AV[t] || 1;
  const e = AV[t]++;
  return "".concat(t, "-").concat(e);
}
function Ube(t) {
  return dn(typeof t == "number", "Input must be a number"), t && (t & t - 1) === 0;
}
function GS(t) {
  let e = !0;
  for (const n in t) {
    e = !1;
    break;
  }
  return e;
}
function G9e(t, e, n, r) {
  const i = "See luma.gl ".concat(n, " Upgrade Guide at https://luma.gl/docs/upgrade-guide"), o = Object.getPrototypeOf(t);
  r.forEach((s) => {
    o.methodName || (o[s] = () => {
      throw On.removed("Calling removed method ".concat(e, ".").concat(s, ": "), i)(), new Error(s);
    });
  });
}
const ib = "Resource subclass must define virtual methods";
let WI = class {
  get [Symbol.toStringTag]() {
    return "Resource";
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    X9(e);
    const {
      id: r,
      userData: i = {}
    } = n;
    this.gl = e, this.gl2 = e, this.id = r || PA(this[Symbol.toStringTag]), this.userData = i, this._bound = !1, this._handle = n.handle, this._handle === void 0 && (this._handle = this._createHandle()), this.byteLength = 0, this._addStats();
  }
  toString() {
    return "".concat(this[Symbol.toStringTag] || this.constructor.name, "(").concat(this.id, ")");
  }
  get handle() {
    return this._handle;
  }
  delete() {
    let {
      deleteChildren: e = !1
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = this._handle && this._deleteHandle(this._handle);
    return this._handle && this._removeStats(), this._handle = null, n && e && n.filter(Boolean).forEach((r) => r.delete()), this;
  }
  bind() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.handle;
    if (typeof e != "function")
      return this._bindHandle(e), this;
    let n;
    return this._bound ? n = e() : (this._bindHandle(this.handle), this._bound = !0, n = e(), this._bound = !1, this._bindHandle(null)), n;
  }
  unbind() {
    this.bind(null);
  }
  getParameter(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    e = aV(this.gl, e), dn(e);
    const i = (this.constructor.PARAMETERS || {})[e];
    if (i) {
      const o = Fr(this.gl);
      if (!((!("webgl2" in i) || o) && (!("extension" in i) || this.gl.getExtension(i.extension)))) {
        const a = i.webgl1, A = "webgl2" in i ? i.webgl2 : i.webgl1;
        return o ? A : a;
      }
    }
    return this._getParameter(e, n);
  }
  getParameters() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      parameters: n,
      keys: r
    } = e, i = this.constructor.PARAMETERS || {}, o = Fr(this.gl), s = {}, a = n || Object.keys(i);
    for (const A of a) {
      const l = i[A];
      if (l && (!("webgl2" in l) || o) && (!("extension" in l) || this.gl.getExtension(l.extension))) {
        const u = r ? SC(this.gl, A) : A;
        s[u] = this.getParameter(A, e), r && l.type === "GLenum" && (s[u] = SC(this.gl, s[u]));
      }
    }
    return s;
  }
  setParameter(e, n) {
    e = aV(this.gl, e), dn(e);
    const i = (this.constructor.PARAMETERS || {})[e];
    if (i) {
      const o = Fr(this.gl);
      if (!((!("webgl2" in i) || o) && (!("extension" in i) || this.gl.getExtension(i.extension))))
        throw new Error("Parameter not available on this platform");
      i.type === "GLenum" && (n = aV(n));
    }
    return this._setParameter(e, n), this;
  }
  setParameters(e) {
    for (const n in e)
      this.setParameter(n, e[n]);
    return this;
  }
  stubRemovedMethods(e, n, r) {
    return G9e(this, e, n, r);
  }
  initialize(e) {
  }
  _createHandle() {
    throw new Error(ib);
  }
  _deleteHandle() {
    throw new Error(ib);
  }
  _bindHandle(e) {
    throw new Error(ib);
  }
  _getOptsFromHandle() {
    throw new Error(ib);
  }
  _getParameter(e, n) {
    throw new Error(ib);
  }
  _setParameter(e, n) {
    throw new Error(ib);
  }
  _context() {
    return this.gl.luma = this.gl.luma || {}, this.gl.luma;
  }
  _addStats() {
    const e = this[Symbol.toStringTag], n = sC.get("Resource Counts");
    n.get("Resources Created").incrementCount(), n.get("".concat(e, "s Created")).incrementCount(), n.get("".concat(e, "s Active")).incrementCount();
  }
  _removeStats() {
    const e = this[Symbol.toStringTag];
    sC.get("Resource Counts").get("".concat(e, "s Active")).decrementCount();
  }
  _trackAllocatedMemory(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this[Symbol.toStringTag];
    this._trackAllocatedMemoryForContext(e, n), this._trackAllocatedMemoryForContext(e, n, this.gl.canvas && this.gl.canvas.id), this.byteLength = e;
  }
  _trackAllocatedMemoryForContext(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this[Symbol.toStringTag], r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    const i = sC.get("Memory Usage".concat(r));
    i.get("GPU Memory").addCount(e), i.get("".concat(n, " Memory")).addCount(e);
  }
  _trackDeallocatedMemory() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this[Symbol.toStringTag];
    this._trackDeallocatedMemoryForContext(e), this._trackDeallocatedMemoryForContext(e, this.gl.canvas && this.gl.canvas.id), this.byteLength = 0;
  }
  _trackDeallocatedMemoryForContext() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this[Symbol.toStringTag], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = sC.get("Memory Usage".concat(n));
    r.get("GPU Memory").subtractCount(this.byteLength), r.get("".concat(e, " Memory")).subtractCount(this.byteLength);
  }
};
const qsn = "Failed to deduce GL constant from typed array";
function Mee(t) {
  switch (ArrayBuffer.isView(t) ? t.constructor : t) {
    case Float32Array:
      return 5126;
    case Uint16Array:
      return 5123;
    case Uint32Array:
      return 5125;
    case Uint8Array:
      return 5121;
    case Uint8ClampedArray:
      return 5121;
    case Int8Array:
      return 5120;
    case Int16Array:
      return 5122;
    case Int32Array:
      return 5124;
    default:
      throw new Error(qsn);
  }
}
function LT(t) {
  let {
    clamped: e = !0
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  switch (t) {
    case 5126:
      return Float32Array;
    case 5123:
    case 33635:
    case 32819:
    case 32820:
      return Uint16Array;
    case 5125:
      return Uint32Array;
    case 5121:
      return e ? Uint8ClampedArray : Uint8Array;
    case 5120:
      return Int8Array;
    case 5122:
      return Int16Array;
    case 5124:
      return Int32Array;
    default:
      throw new Error("Failed to deduce typed array type from GL constant");
  }
}
function jsn(t) {
  let {
    data: e,
    width: n,
    height: r,
    bytesPerPixel: i = 4,
    temp: o
  } = t;
  const s = n * i;
  o = o || new Uint8Array(s);
  for (let a = 0; a < r / 2; ++a) {
    const A = a * s, l = (r - a - 1) * s;
    o.set(e.subarray(A, A + s)), e.copyWithin(A, l, l + s), e.set(o, l);
  }
}
function Ysn(t) {
  let {
    data: e,
    width: n,
    height: r
  } = t;
  const i = Math.round(n / 2), o = Math.round(r / 2), s = new Uint8Array(i * o * 4);
  for (let a = 0; a < o; a++)
    for (let A = 0; A < i; A++)
      for (let l = 0; l < 4; l++)
        s[(a * i + A) * 4 + l] = e[(a * 2 * n + A * 2) * 4 + l];
  return {
    data: s,
    width: i,
    height: o
  };
}
function Oee(t, e, n) {
  const {
    removedProps: r = {},
    deprecatedProps: i = {},
    replacedProps: o = {}
  } = n;
  for (const a in r)
    if (a in e) {
      const l = r[a] ? "".concat(t, ".").concat(r[a]) : "N/A";
      On.removed("".concat(t, ".").concat(a), l)();
    }
  for (const a in i)
    if (a in e) {
      const A = i[a];
      On.deprecated("".concat(t, ".").concat(a), "".concat(t, ".").concat(A))();
    }
  let s = null;
  for (const a in o)
    if (a in e) {
      const A = o[a];
      On.deprecated("".concat(t, ".").concat(a), "".concat(t, ".").concat(A))(), s = s || Object.assign({}, e), s[A] = e[a], delete s[a];
    }
  return s || e;
}
const zsn = {
  offset: 0,
  stride: 0,
  type: 5126,
  size: 1,
  divisor: 0,
  normalized: !1,
  integer: !1
}, Vsn = {
  deprecatedProps: {
    instanced: "divisor",
    isInstanced: "divisor"
  }
};
class yu {
  static getBytesPerElement(e) {
    return LT(e.type || 5126).BYTES_PER_ELEMENT;
  }
  static getBytesPerVertex(e) {
    return dn(e.size), LT(e.type || 5126).BYTES_PER_ELEMENT * e.size;
  }
  static resolve() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return new yu(zsn, ...n);
  }
  constructor() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    n.forEach((i) => this._assign(i)), Object.freeze(this);
  }
  toString() {
    return JSON.stringify(this);
  }
  get BYTES_PER_ELEMENT() {
    return yu.getBytesPerElement(this);
  }
  get BYTES_PER_VERTEX() {
    return yu.getBytesPerVertex(this);
  }
  _assign() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return e = Oee("Accessor", e, Vsn), e.type !== void 0 && (this.type = e.type, (e.type === 5124 || e.type === 5125) && (this.integer = !0)), e.size !== void 0 && (this.size = e.size), e.offset !== void 0 && (this.offset = e.offset), e.stride !== void 0 && (this.stride = e.stride), e.normalized !== void 0 && (this.normalized = e.normalized), e.integer !== void 0 && (this.integer = e.integer), e.divisor !== void 0 && (this.divisor = e.divisor), e.buffer !== void 0 && (this.buffer = e.buffer), e.index !== void 0 && (typeof e.index == "boolean" ? this.index = e.index ? 1 : 0 : this.index = e.index), e.instanced !== void 0 && (this.divisor = e.instanced ? 1 : 0), e.isInstanced !== void 0 && (this.divisor = e.isInstanced ? 1 : 0), this;
  }
}
const Hbe = 10, U9e = {
  offset: "accessor.offset",
  stride: "accessor.stride",
  type: "accessor.type",
  size: "accessor.size",
  divisor: "accessor.divisor",
  normalized: "accessor.normalized",
  integer: "accessor.integer",
  instanced: "accessor.divisor",
  isInstanced: "accessor.divisor"
}, Jsn = {
  removedProps: {},
  replacedProps: {
    bytes: "byteLength"
  },
  deprecatedProps: U9e
}, Ksn = {
  removedProps: U9e
};
let ro = class extends WI {
  get [Symbol.toStringTag]() {
    return "Buffer";
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(e, n), this.stubRemovedMethods("Buffer", "v6.0", ["layout", "setLayout", "getIndexedParameter"]), this.target = n.target || (this.gl.webgl2 ? 36662 : 34962), this.initialize(n), Object.seal(this);
  }
  getElementCount() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.accessor;
    return Math.round(this.byteLength / yu.getBytesPerElement(e));
  }
  getVertexCount() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.accessor;
    return Math.round(this.byteLength / yu.getBytesPerVertex(e));
  }
  initialize() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return ArrayBuffer.isView(e) && (e = {
      data: e
    }), Number.isFinite(e) && (e = {
      byteLength: e
    }), e = Oee("Buffer", e, Jsn), this.usage = e.usage || 35044, this.debugData = null, this.setAccessor(Object.assign({}, e, e.accessor)), e.data ? this._setData(e.data, e.offset, e.byteLength) : this._setByteLength(e.byteLength || 0), this;
  }
  setProps(e) {
    return e = Oee("Buffer", e, Ksn), "accessor" in e && this.setAccessor(e.accessor), this;
  }
  setAccessor(e) {
    return e = Object.assign({}, e), delete e.buffer, this.accessor = new yu(e), this;
  }
  reallocate(e) {
    return e > this.byteLength ? (this._setByteLength(e), !0) : (this.bytesUsed = e, !1);
  }
  setData(e) {
    return this.initialize(e);
  }
  subData(e) {
    ArrayBuffer.isView(e) && (e = {
      data: e
    });
    const {
      data: n,
      offset: r = 0,
      srcOffset: i = 0
    } = e, o = e.byteLength || e.length;
    dn(n);
    const s = this.gl.webgl2 ? 36663 : this.target;
    return this.gl.bindBuffer(s, this.handle), i !== 0 || o !== void 0 ? (ol(this.gl), this.gl.bufferSubData(this.target, r, n, i, o)) : this.gl.bufferSubData(s, r, n), this.gl.bindBuffer(s, null), this.debugData = null, this._inferType(n), this;
  }
  copyData(e) {
    let {
      sourceBuffer: n,
      readOffset: r = 0,
      writeOffset: i = 0,
      size: o
    } = e;
    const {
      gl: s
    } = this;
    return ol(s), s.bindBuffer(36662, n.handle), s.bindBuffer(36663, this.handle), s.copyBufferSubData(36662, 36663, r, i, o), s.bindBuffer(36662, null), s.bindBuffer(36663, null), this.debugData = null, this;
  }
  getData() {
    let {
      dstData: e = null,
      srcByteOffset: n = 0,
      dstOffset: r = 0,
      length: i = 0
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ol(this.gl);
    const o = LT(this.accessor.type || 5126, {
      clamped: !1
    }), s = this._getAvailableElementCount(n), a = r;
    let A, l;
    e ? (l = e.length, A = l - a) : (A = Math.min(s, i || s), l = a + A);
    const c = Math.min(s, A);
    return i = i || c, dn(i <= c), e = e || new o(l), this.gl.bindBuffer(36662, this.handle), this.gl.getBufferSubData(36662, n, e, r, i), this.gl.bindBuffer(36662, null), e;
  }
  bind() {
    let {
      target: e = this.target,
      index: n = this.accessor && this.accessor.index,
      offset: r = 0,
      size: i
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return e === 35345 || e === 35982 ? i !== void 0 ? this.gl.bindBufferRange(e, n, this.handle, r, i) : (dn(r === 0), this.gl.bindBufferBase(e, n, this.handle)) : this.gl.bindBuffer(e, this.handle), this;
  }
  unbind() {
    let {
      target: e = this.target,
      index: n = this.accessor && this.accessor.index
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return e === 35345 || e === 35982 ? this.gl.bindBufferBase(e, n, null) : this.gl.bindBuffer(e, null), this;
  }
  getDebugData() {
    return this.debugData ? {
      data: this.debugData,
      changed: !1
    } : (this.debugData = this.getData({
      length: Math.min(Hbe, this.byteLength)
    }), {
      data: this.debugData,
      changed: !0
    });
  }
  invalidateDebugData() {
    this.debugData = null;
  }
  _setData(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e.byteLength + n;
    dn(ArrayBuffer.isView(e)), this._trackDeallocatedMemory();
    const i = this._getTarget();
    this.gl.bindBuffer(i, this.handle), this.gl.bufferData(i, r, this.usage), this.gl.bufferSubData(i, n, e), this.gl.bindBuffer(i, null), this.debugData = e.slice(0, Hbe), this.bytesUsed = r, this._trackAllocatedMemory(r);
    const o = Mee(e);
    return dn(o), this.setAccessor(new yu(this.accessor, {
      type: o
    })), this;
  }
  _setByteLength(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.usage;
    dn(e >= 0), this._trackDeallocatedMemory();
    let r = e;
    e === 0 && (r = new Float32Array(0));
    const i = this._getTarget();
    return this.gl.bindBuffer(i, this.handle), this.gl.bufferData(i, r, n), this.gl.bindBuffer(i, null), this.usage = n, this.debugData = null, this.bytesUsed = e, this._trackAllocatedMemory(e), this;
  }
  _getTarget() {
    return this.gl.webgl2 ? 36663 : this.target;
  }
  _getAvailableElementCount(e) {
    const n = LT(this.accessor.type || 5126, {
      clamped: !1
    }), r = e / n.BYTES_PER_ELEMENT;
    return this.getElementCount() - r;
  }
  _inferType(e) {
    this.accessor.type || this.setAccessor(new yu(this.accessor, {
      type: Mee(e)
    }));
  }
  _createHandle() {
    return this.gl.createBuffer();
  }
  _deleteHandle() {
    this.gl.deleteBuffer(this.handle), this._trackDeallocatedMemory();
  }
  _getParameter(e) {
    this.gl.bindBuffer(this.target, this.handle);
    const n = this.gl.getBufferParameter(this.target, e);
    return this.gl.bindBuffer(this.target, null), n;
  }
  get type() {
    return On.deprecated("Buffer.type", "Buffer.accessor.type")(), this.accessor.type;
  }
  get bytes() {
    return On.deprecated("Buffer.bytes", "Buffer.byteLength")(), this.byteLength;
  }
  setByteLength(e) {
    return On.deprecated("setByteLength", "reallocate")(), this.reallocate(e);
  }
  updateAccessor(e) {
    return On.deprecated("updateAccessor(...)", "setAccessor(new Accessor(buffer.accessor, ...)")(), this.accessor = new yu(this.accessor, e), this;
  }
};
const Cle = {
  [6407]: {
    dataFormat: 6407,
    types: [5121, 33635]
  },
  [6408]: {
    dataFormat: 6408,
    types: [5121, 32819, 32820]
  },
  [6406]: {
    dataFormat: 6406,
    types: [5121]
  },
  [6409]: {
    dataFormat: 6409,
    types: [5121]
  },
  [6410]: {
    dataFormat: 6410,
    types: [5121]
  },
  [33326]: {
    dataFormat: 6403,
    types: [5126],
    gl2: !0
  },
  [33328]: {
    dataFormat: 33319,
    types: [5126],
    gl2: !0
  },
  [34837]: {
    dataFormat: 6407,
    types: [5126],
    gl2: !0
  },
  [34836]: {
    dataFormat: 6408,
    types: [5126],
    gl2: !0
  }
}, H9e = {
  [6403]: 1,
  [36244]: 1,
  [33319]: 2,
  [33320]: 2,
  [6407]: 3,
  [36248]: 3,
  [6408]: 4,
  [36249]: 4,
  [6402]: 1,
  [34041]: 1,
  [6406]: 1,
  [6409]: 1,
  [6410]: 2
}, $9e = {
  [5126]: 4,
  [5125]: 4,
  [5124]: 4,
  [5123]: 2,
  [5122]: 2,
  [5131]: 2,
  [5120]: 1,
  [5121]: 1
};
function Wsn(t, e) {
  const n = Cle[e];
  if (!n)
    return !1;
  if (n.gl1 === void 0 && n.gl2 === void 0)
    return !0;
  const r = Fr(t) && n.gl2 || n.gl1;
  return typeof r == "string" ? t.getExtension(r) : r;
}
function Xsn(t, e) {
  const n = Cle[e];
  switch (n && n.types[0]) {
    case 5126:
      return t.getExtension("OES_texture_float_linear");
    case 5131:
      return t.getExtension("OES_texture_half_float_linear");
    default:
      return !0;
  }
}
const Zsn = [9729, 9728], $be = globalThis.WebGLBuffer || function() {
};
class Xv extends WI {
  get [Symbol.toStringTag]() {
    return "Texture";
  }
  static isSupported(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const {
      format: r,
      linearFiltering: i
    } = n;
    let o = !0;
    return r && (o = o && Wsn(e, r), o = o && (!i || Xsn(e, r))), o;
  }
  constructor(e, n) {
    const {
      id: r = PA("texture"),
      handle: i,
      target: o
    } = n;
    super(e, {
      id: r,
      handle: i
    }), this.target = o, this.textureUnit = void 0, this.loaded = !1, this.width = void 0, this.height = void 0, this.depth = void 0, this.format = void 0, this.type = void 0, this.dataFormat = void 0, this.border = void 0, this.textureUnit = void 0, this.mipmaps = void 0;
  }
  toString() {
    return "Texture(".concat(this.id, ",").concat(this.width, "x").concat(this.height, ")");
  }
  initialize() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.data;
    if (n instanceof Promise)
      return n.then((y) => this.initialize(Object.assign({}, e, {
        pixels: y,
        data: y
      }))), this;
    const r = typeof HTMLVideoElement < "u" && n instanceof HTMLVideoElement;
    if (r && n.readyState < HTMLVideoElement.HAVE_METADATA)
      return this._video = null, n.addEventListener("loadeddata", () => this.initialize(e)), this;
    const {
      pixels: i = null,
      format: o = 6408,
      border: s = 0,
      recreate: a = !1,
      parameters: A = {},
      pixelStore: l = {},
      textureUnit: c = void 0
    } = e;
    n || (n = i);
    let {
      width: u,
      height: f,
      dataFormat: h,
      type: d,
      compressed: I = !1,
      mipmaps: m = !0
    } = e;
    const {
      depth: C = 0
    } = e;
    return {
      width: u,
      height: f,
      compressed: I,
      dataFormat: h,
      type: d
    } = this._deduceParameters({
      format: o,
      type: d,
      dataFormat: h,
      compressed: I,
      data: n,
      width: u,
      height: f
    }), this.width = u, this.height = f, this.depth = C, this.format = o, this.type = d, this.dataFormat = h, this.border = s, this.textureUnit = c, Number.isFinite(this.textureUnit) && (this.gl.activeTexture(33984 + this.textureUnit), this.gl.bindTexture(this.target, this.handle)), m && this._isNPOT() && (On.warn("texture: ".concat(this, " is Non-Power-Of-Two, disabling mipmaping"))(), m = !1, this._updateForNPOT(A)), this.mipmaps = m, this.setImageData({
      data: n,
      width: u,
      height: f,
      depth: C,
      format: o,
      type: d,
      dataFormat: h,
      border: s,
      mipmaps: m,
      parameters: l,
      compressed: I
    }), m && this.generateMipmap(), this.setParameters(A), a && (this.data = n), r && (this._video = {
      video: n,
      parameters: A,
      lastTime: n.readyState >= HTMLVideoElement.HAVE_CURRENT_DATA ? n.currentTime : -1
    }), this;
  }
  update() {
    if (this._video) {
      const {
        video: e,
        parameters: n,
        lastTime: r
      } = this._video;
      if (r === e.currentTime || e.readyState < HTMLVideoElement.HAVE_CURRENT_DATA)
        return;
      this.setSubImageData({
        data: e,
        parameters: n
      }), this.mipmaps && this.generateMipmap(), this._video.lastTime = e.currentTime;
    }
  }
  resize(e) {
    let {
      height: n,
      width: r,
      mipmaps: i = !1
    } = e;
    return r !== this.width || n !== this.height ? this.initialize({
      width: r,
      height: n,
      format: this.format,
      type: this.type,
      dataFormat: this.dataFormat,
      border: this.border,
      mipmaps: i
    }) : this;
  }
  generateMipmap() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this._isNPOT() ? (On.warn("texture: ".concat(this, " is Non-Power-Of-Two, disabling mipmaping"))(), this) : (this.mipmaps = !0, this.gl.bindTexture(this.target, this.handle), Yc(this.gl, e, () => {
      this.gl.generateMipmap(this.target);
    }), this.gl.bindTexture(this.target, null), this);
  }
  setImageData(e) {
    this._trackDeallocatedMemory("Texture");
    const {
      target: n = this.target,
      pixels: r = null,
      level: i = 0,
      format: o = this.format,
      border: s = this.border,
      offset: a = 0,
      parameters: A = {}
    } = e;
    let {
      data: l = null,
      type: c = this.type,
      width: u = this.width,
      height: f = this.height,
      dataFormat: h = this.dataFormat,
      compressed: d = !1
    } = e;
    l || (l = r), {
      type: c,
      dataFormat: h,
      compressed: d,
      width: u,
      height: f
    } = this._deduceParameters({
      format: o,
      type: c,
      dataFormat: h,
      compressed: d,
      data: l,
      width: u,
      height: f
    });
    const {
      gl: I
    } = this;
    I.bindTexture(this.target, this.handle);
    let m = null;
    ({
      data: l,
      dataType: m
    } = this._getDataType({
      data: l,
      compressed: d
    }));
    let C, y = 0;
    if (Yc(this.gl, A, () => {
      switch (m) {
        case "null":
          I.texImage2D(n, i, o, u, f, s, h, c, l);
          break;
        case "typed-array":
          I.texImage2D(n, i, o, u, f, s, h, c, l, a);
          break;
        case "buffer":
          C = ol(I), C.bindBuffer(35052, l.handle || l), C.texImage2D(n, i, o, u, f, s, h, c, a), C.bindBuffer(35052, null);
          break;
        case "browser-object":
          Fr(I) ? I.texImage2D(n, i, o, u, f, s, h, c, l) : I.texImage2D(n, i, o, h, c, l);
          break;
        case "compressed":
          for (const [v, b] of l.entries())
            I.compressedTexImage2D(n, v, b.format, b.width, b.height, s, b.data), y += b.levelSize;
          break;
        default:
          dn(!1, "Unknown image data type");
      }
    }), m === "compressed")
      this._trackAllocatedMemory(y, "Texture");
    else if (l && l.byteLength)
      this._trackAllocatedMemory(l.byteLength, "Texture");
    else {
      const v = H9e[this.dataFormat] || 4, b = $9e[this.type] || 1;
      this._trackAllocatedMemory(this.width * this.height * v * b, "Texture");
    }
    return this.loaded = !0, this;
  }
  setSubImageData(e) {
    let {
      target: n = this.target,
      pixels: r = null,
      data: i = null,
      x: o = 0,
      y: s = 0,
      width: a = this.width,
      height: A = this.height,
      level: l = 0,
      format: c = this.format,
      type: u = this.type,
      dataFormat: f = this.dataFormat,
      compressed: h = !1,
      offset: d = 0,
      border: I = this.border,
      parameters: m = {}
    } = e;
    if ({
      type: u,
      dataFormat: f,
      compressed: h,
      width: a,
      height: A
    } = this._deduceParameters({
      format: c,
      type: u,
      dataFormat: f,
      compressed: h,
      data: i,
      width: a,
      height: A
    }), dn(this.depth === 0, "texSubImage not supported for 3D textures"), i || (i = r), i && i.data) {
      const C = i;
      i = C.data, a = C.shape[0], A = C.shape[1];
    }
    i instanceof ro && (i = i.handle), this.gl.bindTexture(this.target, this.handle), Yc(this.gl, m, () => {
      if (h)
        this.gl.compressedTexSubImage2D(n, l, o, s, a, A, c, i);
      else if (i === null)
        this.gl.texSubImage2D(n, l, o, s, a, A, f, u, null);
      else if (ArrayBuffer.isView(i))
        this.gl.texSubImage2D(n, l, o, s, a, A, f, u, i, d);
      else if (i instanceof $be) {
        const C = ol(this.gl);
        C.bindBuffer(35052, i), C.texSubImage2D(n, l, o, s, a, A, f, u, d), C.bindBuffer(35052, null);
      } else
        Fr(this.gl) ? ol(this.gl).texSubImage2D(n, l, o, s, a, A, f, u, i) : this.gl.texSubImage2D(n, l, o, s, f, u, i);
    }), this.gl.bindTexture(this.target, null);
  }
  copyFramebuffer() {
    return On.error("Texture.copyFramebuffer({...}) is no logner supported, use copyToTexture(source, target, opts})")(), null;
  }
  getActiveUnit() {
    return this.gl.getParameter(34016) - 33984;
  }
  bind() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.textureUnit;
    const {
      gl: n
    } = this;
    return e !== void 0 && (this.textureUnit = e, n.activeTexture(33984 + e)), n.bindTexture(this.target, this.handle), e;
  }
  unbind() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.textureUnit;
    const {
      gl: n
    } = this;
    return e !== void 0 && (this.textureUnit = e, n.activeTexture(33984 + e)), n.bindTexture(this.target, null), e;
  }
  _getDataType(e) {
    let {
      data: n,
      compressed: r = !1
    } = e;
    return r ? {
      data: n,
      dataType: "compressed"
    } : n === null ? {
      data: n,
      dataType: "null"
    } : ArrayBuffer.isView(n) ? {
      data: n,
      dataType: "typed-array"
    } : n instanceof ro ? {
      data: n.handle,
      dataType: "buffer"
    } : n instanceof $be ? {
      data: n,
      dataType: "buffer"
    } : {
      data: n,
      dataType: "browser-object"
    };
  }
  _deduceParameters(e) {
    const {
      format: n,
      data: r
    } = e;
    let {
      width: i,
      height: o,
      dataFormat: s,
      type: a,
      compressed: A
    } = e;
    const l = Cle[n];
    return s = s || l && l.dataFormat, a = a || l && l.types[0], A = A || l && l.compressed, {
      width: i,
      height: o
    } = this._deduceImageSize(r, i, o), {
      dataFormat: s,
      type: a,
      compressed: A,
      width: i,
      height: o,
      format: n,
      data: r
    };
  }
  _deduceImageSize(e, n, r) {
    let i;
    return typeof ImageData < "u" && e instanceof ImageData ? i = {
      width: e.width,
      height: e.height
    } : typeof HTMLImageElement < "u" && e instanceof HTMLImageElement ? i = {
      width: e.naturalWidth,
      height: e.naturalHeight
    } : typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement ? i = {
      width: e.width,
      height: e.height
    } : typeof ImageBitmap < "u" && e instanceof ImageBitmap ? i = {
      width: e.width,
      height: e.height
    } : typeof HTMLVideoElement < "u" && e instanceof HTMLVideoElement ? i = {
      width: e.videoWidth,
      height: e.videoHeight
    } : e ? i = {
      width: n,
      height: r
    } : i = {
      width: n >= 0 ? n : 1,
      height: r >= 0 ? r : 1
    }, dn(i, "Could not deduced texture size"), dn(n === void 0 || i.width === n, "Deduced texture width does not match supplied width"), dn(r === void 0 || i.height === r, "Deduced texture height does not match supplied height"), i;
  }
  _createHandle() {
    return this.gl.createTexture();
  }
  _deleteHandle() {
    this.gl.deleteTexture(this.handle), this._trackDeallocatedMemory("Texture");
  }
  _getParameter(e) {
    switch (e) {
      case 4096:
        return this.width;
      case 4097:
        return this.height;
      default:
        this.gl.bindTexture(this.target, this.handle);
        const n = this.gl.getTexParameter(this.target, e);
        return this.gl.bindTexture(this.target, null), n;
    }
  }
  _setParameter(e, n) {
    switch (this.gl.bindTexture(this.target, this.handle), n = this._getNPOTParam(e, n), e) {
      case 33082:
      case 33083:
        this.gl.texParameterf(this.handle, e, n);
        break;
      case 4096:
      case 4097:
        dn(!1);
        break;
      default:
        this.gl.texParameteri(this.target, e, n);
        break;
    }
    return this.gl.bindTexture(this.target, null), this;
  }
  _isNPOT() {
    return Fr(this.gl) || !this.width || !this.height ? !1 : !Ube(this.width) || !Ube(this.height);
  }
  _updateForNPOT(e) {
    e[this.gl.TEXTURE_MIN_FILTER] === void 0 && (e[this.gl.TEXTURE_MIN_FILTER] = this.gl.LINEAR), e[this.gl.TEXTURE_WRAP_S] === void 0 && (e[this.gl.TEXTURE_WRAP_S] = this.gl.CLAMP_TO_EDGE), e[this.gl.TEXTURE_WRAP_T] === void 0 && (e[this.gl.TEXTURE_WRAP_T] = this.gl.CLAMP_TO_EDGE);
  }
  _getNPOTParam(e, n) {
    if (this._isNPOT())
      switch (e) {
        case 10241:
          Zsn.indexOf(n) === -1 && (n = 9729);
          break;
        case 10242:
        case 10243:
          n !== 33071 && (n = 33071);
          break;
      }
    return n;
  }
}
let ean = "";
function tan(t, e) {
  return dn(typeof t == "string"), t = ean + t, new Promise((n, r) => {
    try {
      const i = new Image();
      i.onload = () => n(i), i.onerror = () => r(new Error("Could not load image ".concat(t, "."))), i.crossOrigin = e && e.crossOrigin || "anonymous", i.src = t;
    } catch (i) {
      r(i);
    }
  });
}
class xo extends Xv {
  get [Symbol.toStringTag]() {
    return "Texture2D";
  }
  static isSupported(e, n) {
    return Xv.isSupported(e, n);
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    X9(e), (n instanceof Promise || typeof n == "string") && (n = {
      data: n
    }), typeof n.data == "string" && (n = Object.assign({}, n, {
      data: tan(n.data)
    })), super(e, Object.assign({}, n, {
      target: 3553
    })), this.initialize(n), Object.seal(this);
  }
}
const Fee = [34069, 34070, 34071, 34072, 34073, 34074];
class Ele extends Xv {
  get [Symbol.toStringTag]() {
    return "TextureCube";
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    X9(e), super(e, Object.assign({}, n, {
      target: 34067
    })), this.initialize(n), Object.seal(this);
  }
  initialize() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      mipmaps: n = !0,
      parameters: r = {}
    } = e;
    return this.opts = e, this.setCubeMapImageData(e).then(() => {
      this.loaded = !0, n && this.generateMipmap(e), this.setParameters(r);
    }), this;
  }
  subImage(e) {
    let {
      face: n,
      data: r,
      x: i = 0,
      y: o = 0,
      mipmapLevel: s = 0
    } = e;
    return this._subImage({
      target: n,
      data: r,
      x: i,
      y: o,
      mipmapLevel: s
    });
  }
  async setCubeMapImageData(e) {
    let {
      width: n,
      height: r,
      pixels: i,
      data: o,
      border: s = 0,
      format: a = 6408,
      type: A = 5121
    } = e;
    const {
      gl: l
    } = this, c = i || o, u = await Promise.all(Fee.map((f) => {
      const h = c[f];
      return Promise.all(Array.isArray(h) ? h : [h]);
    }));
    this.bind(), Fee.forEach((f, h) => {
      u[h].length > 1 && this.opts.mipmaps !== !1 && On.warn("".concat(this.id, " has mipmap and multiple LODs."))(), u[h].forEach((d, I) => {
        n && r ? l.texImage2D(f, I, a, n, r, s, a, A, d) : l.texImage2D(f, I, a, a, A, d);
      });
    }), this.unbind();
  }
  setImageDataForFace(e) {
    const {
      face: n,
      width: r,
      height: i,
      pixels: o,
      data: s,
      border: a = 0,
      format: A = 6408,
      type: l = 5121
    } = e, {
      gl: c
    } = this, u = o || s;
    return this.bind(), u instanceof Promise ? u.then((f) => this.setImageDataForFace(Object.assign({}, e, {
      face: n,
      data: f,
      pixels: f
    }))) : this.width || this.height ? c.texImage2D(n, 0, A, r, i, a, A, l, u) : c.texImage2D(n, 0, A, A, l, u), this;
  }
}
Ele.FACES = Fee;
class yle extends Xv {
  get [Symbol.toStringTag]() {
    return "Texture3D";
  }
  static isSupported(e) {
    return Fr(e);
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    ol(e), n = Object.assign({
      depth: 1
    }, n, {
      target: 32879,
      unpackFlipY: !1
    }), super(e, n), this.initialize(n), Object.seal(this);
  }
  setImageData(e) {
    let {
      level: n = 0,
      dataFormat: r = 6408,
      width: i,
      height: o,
      depth: s = 1,
      border: a = 0,
      format: A,
      type: l = 5121,
      offset: c = 0,
      data: u,
      parameters: f = {}
    } = e;
    if (this._trackDeallocatedMemory("Texture"), this.gl.bindTexture(this.target, this.handle), Yc(this.gl, f, () => {
      ArrayBuffer.isView(u) && this.gl.texImage3D(this.target, n, r, i, o, s, a, A, l, u), u instanceof ro && (this.gl.bindBuffer(35052, u.handle), this.gl.texImage3D(this.target, n, r, i, o, s, a, A, l, c));
    }), u && u.byteLength)
      this._trackAllocatedMemory(u.byteLength, "Texture");
    else {
      const h = H9e[this.dataFormat] || 4, d = $9e[this.type] || 1;
      this._trackAllocatedMemory(this.width * this.height * this.depth * h * d, "Texture");
    }
    return this.loaded = !0, this;
  }
}
const hy = "EXT_color_buffer_float", qbe = {
  [33189]: {
    bpp: 2
  },
  [33190]: {
    gl2: !0,
    bpp: 3
  },
  [36012]: {
    gl2: !0,
    bpp: 4
  },
  [36168]: {
    bpp: 1
  },
  [34041]: {
    bpp: 4
  },
  [35056]: {
    gl2: !0,
    bpp: 4
  },
  [36013]: {
    gl2: !0,
    bpp: 5
  },
  [32854]: {
    bpp: 2
  },
  [36194]: {
    bpp: 2
  },
  [32855]: {
    bpp: 2
  },
  [33321]: {
    gl2: !0,
    bpp: 1
  },
  [33330]: {
    gl2: !0,
    bpp: 1
  },
  [33329]: {
    gl2: !0,
    bpp: 1
  },
  [33332]: {
    gl2: !0,
    bpp: 2
  },
  [33331]: {
    gl2: !0,
    bpp: 2
  },
  [33334]: {
    gl2: !0,
    bpp: 4
  },
  [33333]: {
    gl2: !0,
    bpp: 4
  },
  [33323]: {
    gl2: !0,
    bpp: 2
  },
  [33336]: {
    gl2: !0,
    bpp: 2
  },
  [33335]: {
    gl2: !0,
    bpp: 2
  },
  [33338]: {
    gl2: !0,
    bpp: 4
  },
  [33337]: {
    gl2: !0,
    bpp: 4
  },
  [33340]: {
    gl2: !0,
    bpp: 8
  },
  [33339]: {
    gl2: !0,
    bpp: 8
  },
  [32849]: {
    gl2: !0,
    bpp: 3
  },
  [32856]: {
    gl2: !0,
    bpp: 4
  },
  [32857]: {
    gl2: !0,
    bpp: 4
  },
  [36220]: {
    gl2: !0,
    bpp: 4
  },
  [36238]: {
    gl2: !0,
    bpp: 4
  },
  [36975]: {
    gl2: !0,
    bpp: 4
  },
  [36214]: {
    gl2: !0,
    bpp: 8
  },
  [36232]: {
    gl2: !0,
    bpp: 8
  },
  [36226]: {
    gl2: !0,
    bpp: 16
  },
  [36208]: {
    gl2: !0,
    bpp: 16
  },
  [33325]: {
    gl2: hy,
    bpp: 2
  },
  [33327]: {
    gl2: hy,
    bpp: 4
  },
  [34842]: {
    gl2: hy,
    bpp: 8
  },
  [33326]: {
    gl2: hy,
    bpp: 4
  },
  [33328]: {
    gl2: hy,
    bpp: 8
  },
  [34836]: {
    gl2: hy,
    bpp: 16
  },
  [35898]: {
    gl2: hy,
    bpp: 4
  }
};
function nan(t, e, n) {
  const r = n[e];
  if (!r)
    return !1;
  const i = Fr(t) && r.gl2 || r.gl1;
  return typeof i == "string" ? t.getExtension(i) : i;
}
class av extends WI {
  get [Symbol.toStringTag]() {
    return "Renderbuffer";
  }
  static isSupported(e) {
    let {
      format: n
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      format: null
    };
    return !n || nan(e, n, qbe);
  }
  static getSamplesForFormat(e, n) {
    let {
      format: r
    } = n;
    return e.getInternalformatParameter(36161, r, 32937);
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(e, n), this.initialize(n), Object.seal(this);
  }
  initialize(e) {
    let {
      format: n,
      width: r = 1,
      height: i = 1,
      samples: o = 0
    } = e;
    return dn(n, "Needs format"), this._trackDeallocatedMemory(), this.gl.bindRenderbuffer(36161, this.handle), o !== 0 && Fr(this.gl) ? this.gl.renderbufferStorageMultisample(36161, o, n, r, i) : this.gl.renderbufferStorage(36161, n, r, i), this.format = n, this.width = r, this.height = i, this.samples = o, this._trackAllocatedMemory(this.width * this.height * (this.samples || 1) * qbe[this.format].bpp), this;
  }
  resize(e) {
    let {
      width: n,
      height: r
    } = e;
    return n !== this.width || r !== this.height ? this.initialize({
      width: n,
      height: r,
      format: this.format,
      samples: this.samples
    }) : this;
  }
  _createHandle() {
    return this.gl.createRenderbuffer();
  }
  _deleteHandle() {
    this.gl.deleteRenderbuffer(this.handle), this._trackDeallocatedMemory();
  }
  _bindHandle(e) {
    this.gl.bindRenderbuffer(36161, e);
  }
  _syncHandle(e) {
    this.format = this.getParameter(36164), this.width = this.getParameter(36162), this.height = this.getParameter(36163), this.samples = this.getParameter(36011);
  }
  _getParameter(e) {
    return this.gl.bindRenderbuffer(36161, this.handle), this.gl.getRenderbufferParameter(36161, e);
  }
}
const ran = 256, ian = 1024, oan = 16384, jbe = 6144, Ybe = 6145, zbe = 6146, Vbe = 34041, q9e = "clear: bad arguments";
function aM(t) {
  let {
    framebuffer: e = null,
    color: n = null,
    depth: r = null,
    stencil: i = null
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const o = {};
  e && (o.framebuffer = e);
  let s = 0;
  n && (s |= oan, n !== !0 && (o.clearColor = n)), r && (s |= ran, r !== !0 && (o.clearDepth = r)), i && (s |= ian, r !== !0 && (o.clearStencil = r)), dn(s !== 0, q9e), Yc(t, o, () => {
    t.clear(s);
  });
}
function san(t) {
  let {
    framebuffer: e = null,
    buffer: n = jbe,
    drawBuffer: r = 0,
    value: i = [0, 0, 0, 0]
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  ol(t), Yc(t, {
    framebuffer: e
  }, () => {
    switch (n) {
      case jbe:
        switch (i.constructor) {
          case Int32Array:
            t.clearBufferiv(n, r, i);
            break;
          case Uint32Array:
            t.clearBufferuiv(n, r, i);
            break;
          case Float32Array:
          default:
            t.clearBufferfv(n, r, i);
        }
        break;
      case Ybe:
        t.clearBufferfv(Ybe, 0, [i]);
        break;
      case zbe:
        t.clearBufferiv(zbe, 0, [i]);
        break;
      case Vbe:
        const [o, s] = i;
        t.clearBufferfi(Vbe, 0, o, s);
        break;
      default:
        dn(!1, q9e);
    }
  });
}
function j9e(t) {
  switch (t) {
    case 6406:
    case 33326:
    case 6403:
      return 1;
    case 33328:
    case 33319:
      return 2;
    case 6407:
    case 34837:
      return 3;
    case 6408:
    case 34836:
      return 4;
    default:
      return dn(!1), 0;
  }
}
function aan(t) {
  switch (t) {
    case 5121:
      return 1;
    case 33635:
    case 32819:
    case 32820:
      return 2;
    case 5126:
      return 4;
    default:
      return dn(!1), 0;
  }
}
function AM(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    sourceX: n = 0,
    sourceY: r = 0,
    sourceFormat: i = 6408
  } = e;
  let {
    sourceAttachment: o = 36064,
    target: s = null,
    sourceWidth: a,
    sourceHeight: A,
    sourceType: l
  } = e;
  const {
    framebuffer: c,
    deleteFramebuffer: u
  } = vle(t);
  dn(c);
  const {
    gl: f,
    handle: h,
    attachments: d
  } = c;
  a = a || c.width, A = A || c.height, o === 36064 && h === null && (o = 1028), dn(d[o]), l = l || d[o].type, s = lan(s, l, i, a, A), l = l || Mee(s);
  const I = f.bindFramebuffer(36160, h);
  return f.readPixels(n, r, a, A, i, l, s), f.bindFramebuffer(36160, I || null), u && c.delete(), s;
}
function Aan(t, e) {
  let {
    sourceX: n = 0,
    sourceY: r = 0,
    sourceFormat: i = 6408,
    target: o = null,
    targetByteOffset: s = 0,
    sourceWidth: a,
    sourceHeight: A,
    sourceType: l
  } = e;
  const {
    framebuffer: c,
    deleteFramebuffer: u
  } = vle(t);
  dn(c), a = a || c.width, A = A || c.height;
  const f = ol(c.gl);
  if (l = l || (o ? o.type : 5121), !o) {
    const h = j9e(i), d = aan(l), I = s + a * A * h * d;
    o = new ro(f, {
      byteLength: I,
      accessor: {
        type: l,
        size: h
      }
    });
  }
  return o.bind({
    target: 35051
  }), Yc(f, {
    framebuffer: c
  }, () => {
    f.readPixels(n, r, a, A, i, l, s);
  }), o.unbind({
    target: 35051
  }), u && c.delete(), o;
}
function Jbe(t) {
  let {
    sourceAttachment: e = 36064,
    targetMaxHeight: n = Number.MAX_SAFE_INTEGER
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = AM(t, {
    sourceAttachment: e
  }), {
    width: i,
    height: o
  } = t;
  for (; o > n; )
    ({
      data: r,
      width: i,
      height: o
    } = Ysn({
      data: r,
      width: i,
      height: o
    }));
  jsn({
    data: r,
    width: i,
    height: o
  });
  const s = document.createElement("canvas");
  s.width = i, s.height = o;
  const a = s.getContext("2d"), A = a.createImageData(i, o);
  return A.data.set(r), a.putImageData(A, 0, 0), s.toDataURL();
}
function Y9e(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    sourceX: r = 0,
    sourceY: i = 0,
    targetMipmaplevel: o = 0,
    targetInternalFormat: s = 6408
  } = n;
  let {
    targetX: a,
    targetY: A,
    targetZ: l,
    width: c,
    height: u
  } = n;
  const {
    framebuffer: f,
    deleteFramebuffer: h
  } = vle(t);
  dn(f);
  const {
    gl: d,
    handle: I
  } = f, m = typeof a < "u" || typeof A < "u" || typeof l < "u";
  a = a || 0, A = A || 0, l = l || 0;
  const C = d.bindFramebuffer(36160, I);
  dn(e);
  let y = null;
  if (e instanceof Xv && (y = e, c = Number.isFinite(c) ? c : y.width, u = Number.isFinite(u) ? u : y.height, y.bind(0), e = y.target), !m)
    d.copyTexImage2D(e, o, s, r, i, c, u, 0);
  else
    switch (e) {
      case 3553:
      case 34067:
        d.copyTexSubImage2D(e, o, a, A, r, i, c, u);
        break;
      case 35866:
      case 32879:
        ol(d).copyTexSubImage3D(e, o, a, A, l, r, i, c, u);
        break;
    }
  return y && y.unbind(), d.bindFramebuffer(36160, C || null), h && f.delete(), y;
}
function vle(t) {
  return t instanceof Da ? {
    framebuffer: t,
    deleteFramebuffer: !1
  } : {
    framebuffer: Ian(t),
    deleteFramebuffer: !0
  };
}
function lan(t, e, n, r, i) {
  if (t)
    return t;
  e = e || 5121;
  const o = LT(e, {
    clamped: !1
  }), s = j9e(n);
  return new o(r * i * s);
}
const no = {
  WEBGL2: "WEBGL2",
  VERTEX_ARRAY_OBJECT: "VERTEX_ARRAY_OBJECT",
  TIMER_QUERY: "TIMER_QUERY",
  INSTANCED_RENDERING: "INSTANCED_RENDERING",
  MULTIPLE_RENDER_TARGETS: "MULTIPLE_RENDER_TARGETS",
  ELEMENT_INDEX_UINT32: "ELEMENT_INDEX_UINT32",
  BLEND_EQUATION_MINMAX: "BLEND_EQUATION_MINMAX",
  FLOAT_BLEND: "FLOAT_BLEND",
  COLOR_ENCODING_SRGB: "COLOR_ENCODING_SRGB",
  TEXTURE_DEPTH: "TEXTURE_DEPTH",
  TEXTURE_FLOAT: "TEXTURE_FLOAT",
  TEXTURE_HALF_FLOAT: "TEXTURE_HALF_FLOAT",
  TEXTURE_FILTER_LINEAR_FLOAT: "TEXTURE_FILTER_LINEAR_FLOAT",
  TEXTURE_FILTER_LINEAR_HALF_FLOAT: "TEXTURE_FILTER_LINEAR_HALF_FLOAT",
  TEXTURE_FILTER_ANISOTROPIC: "TEXTURE_FILTER_ANISOTROPIC",
  COLOR_ATTACHMENT_RGBA32F: "COLOR_ATTACHMENT_RGBA32F",
  COLOR_ATTACHMENT_FLOAT: "COLOR_ATTACHMENT_FLOAT",
  COLOR_ATTACHMENT_HALF_FLOAT: "COLOR_ATTACHMENT_HALF_FLOAT",
  GLSL_FRAG_DATA: "GLSL_FRAG_DATA",
  GLSL_FRAG_DEPTH: "GLSL_FRAG_DEPTH",
  GLSL_DERIVATIVES: "GLSL_DERIVATIVES",
  GLSL_TEXTURE_LOD: "GLSL_TEXTURE_LOD"
};
function can(t) {
  const e = new xo(t, {
    format: 6408,
    type: 5126,
    dataFormat: 6408
  }), n = new Da(t, {
    id: "test-framebuffer",
    check: !1,
    attachments: {
      [36064]: e
    }
  }), r = n.getStatus();
  return e.delete(), n.delete(), r === 36053;
}
const z9e = {
  [no.WEBGL2]: [!1, !0],
  [no.VERTEX_ARRAY_OBJECT]: ["OES_vertex_array_object", !0],
  [no.TIMER_QUERY]: ["EXT_disjoint_timer_query", "EXT_disjoint_timer_query_webgl2"],
  [no.INSTANCED_RENDERING]: ["ANGLE_instanced_arrays", !0],
  [no.MULTIPLE_RENDER_TARGETS]: ["WEBGL_draw_buffers", !0],
  [no.ELEMENT_INDEX_UINT32]: ["OES_element_index_uint", !0],
  [no.BLEND_EQUATION_MINMAX]: ["EXT_blend_minmax", !0],
  [no.FLOAT_BLEND]: ["EXT_float_blend"],
  [no.COLOR_ENCODING_SRGB]: ["EXT_sRGB", !0],
  [no.TEXTURE_DEPTH]: ["WEBGL_depth_texture", !0],
  [no.TEXTURE_FLOAT]: ["OES_texture_float", !0],
  [no.TEXTURE_HALF_FLOAT]: ["OES_texture_half_float", !0],
  [no.TEXTURE_FILTER_LINEAR_FLOAT]: ["OES_texture_float_linear"],
  [no.TEXTURE_FILTER_LINEAR_HALF_FLOAT]: ["OES_texture_half_float_linear"],
  [no.TEXTURE_FILTER_ANISOTROPIC]: ["EXT_texture_filter_anisotropic"],
  [no.COLOR_ATTACHMENT_RGBA32F]: [can, "EXT_color_buffer_float"],
  [no.COLOR_ATTACHMENT_FLOAT]: [!1, "EXT_color_buffer_float"],
  [no.COLOR_ATTACHMENT_HALF_FLOAT]: ["EXT_color_buffer_half_float"],
  [no.GLSL_FRAG_DATA]: ["WEBGL_draw_buffers", !0],
  [no.GLSL_FRAG_DEPTH]: ["EXT_frag_depth", !0],
  [no.GLSL_DERIVATIVES]: ["OES_standard_derivatives", !0],
  [no.GLSL_TEXTURE_LOD]: ["EXT_shader_texture_lod", !0]
}, uan = 2;
function Zv(t, e) {
  return e$(t, e);
}
function e$(t, e) {
  return e = Array.isArray(e) ? e : [e], e.every((n) => V9e(t, n));
}
function fan(t) {
  t.luma = t.luma || {}, t.luma.caps = t.luma.caps || {};
  for (const e in z9e)
    t.luma.caps[e] === void 0 && (t.luma.caps[e] = V9e(t, e));
  return t.luma.caps;
}
function V9e(t, e) {
  return t.luma = t.luma || {}, t.luma.caps = t.luma.caps || {}, t.luma.caps[e] === void 0 && (t.luma.caps[e] = gan(t, e)), t.luma.caps[e] || On.log(uan, "Feature: ".concat(e, " not supported"))(), t.luma.caps[e];
}
function gan(t, e) {
  const n = z9e[e];
  dn(n, e);
  let r;
  const i = Fr(t) && n[1] || n[0];
  if (typeof i == "function")
    r = i(t);
  else if (Array.isArray(i)) {
    r = !0;
    for (const o of i)
      r = r && !!t.getExtension(o);
  } else
    typeof i == "string" ? r = !!t.getExtension(i) : typeof i == "boolean" ? r = i : dn(!1);
  return r;
}
const Kbe = "Multiple render targets not supported";
class Da extends WI {
  get [Symbol.toStringTag]() {
    return "Framebuffer";
  }
  static isSupported(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const {
      colorBufferFloat: r,
      colorBufferHalfFloat: i
    } = n;
    let o = !0;
    return r && (o = !!(e.getExtension("EXT_color_buffer_float") || e.getExtension("WEBGL_color_buffer_float") || e.getExtension("OES_texture_float"))), i && (o = o && !!(e.getExtension("EXT_color_buffer_float") || e.getExtension("EXT_color_buffer_half_float"))), o;
  }
  static getDefaultFramebuffer(e) {
    return e.luma = e.luma || {}, e.luma.defaultFramebuffer = e.luma.defaultFramebuffer || new Da(e, {
      id: "default-framebuffer",
      handle: null,
      attachments: {}
    }), e.luma.defaultFramebuffer;
  }
  get MAX_COLOR_ATTACHMENTS() {
    const e = ol(this.gl);
    return e.getParameter(e.MAX_COLOR_ATTACHMENTS);
  }
  get MAX_DRAW_BUFFERS() {
    const e = ol(this.gl);
    return e.getParameter(e.MAX_DRAW_BUFFERS);
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(e, n), this.width = null, this.height = null, this.attachments = {}, this.readBuffer = 36064, this.drawBuffers = [36064], this.ownResources = [], this.initialize(n), Object.seal(this);
  }
  get color() {
    return this.attachments[36064] || null;
  }
  get texture() {
    return this.attachments[36064] || null;
  }
  get depth() {
    return this.attachments[36096] || this.attachments[33306] || null;
  }
  get stencil() {
    return this.attachments[36128] || this.attachments[33306] || null;
  }
  initialize(e) {
    let {
      width: n = 1,
      height: r = 1,
      attachments: i = null,
      color: o = !0,
      depth: s = !0,
      stencil: a = !1,
      check: A = !0,
      readBuffer: l = void 0,
      drawBuffers: c = void 0
    } = e;
    if (dn(n >= 0 && r >= 0, "Width and height need to be integers"), this.width = n, this.height = r, i)
      for (const u in i) {
        const f = i[u];
        (Array.isArray(f) ? f[0] : f).resize({
          width: n,
          height: r
        });
      }
    else
      i = this._createDefaultAttachments(o, s, a, n, r);
    this.update({
      clearAttachments: !0,
      attachments: i,
      readBuffer: l,
      drawBuffers: c
    }), i && A && this.checkStatus();
  }
  delete() {
    for (const e of this.ownResources)
      e.delete();
    return super.delete(), this;
  }
  update(e) {
    let {
      attachments: n = {},
      readBuffer: r,
      drawBuffers: i,
      clearAttachments: o = !1,
      resizeAttachments: s = !0
    } = e;
    this.attach(n, {
      clearAttachments: o,
      resizeAttachments: s
    });
    const {
      gl: a
    } = this, A = a.bindFramebuffer(36160, this.handle);
    return r && this._setReadBuffer(r), i && this._setDrawBuffers(i), a.bindFramebuffer(36160, A || null), this;
  }
  resize() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, {
      width: n,
      height: r
    } = e;
    if (this.handle === null)
      return dn(n === void 0 && r === void 0), this.width = this.gl.drawingBufferWidth, this.height = this.gl.drawingBufferHeight, this;
    n === void 0 && (n = this.gl.drawingBufferWidth), r === void 0 && (r = this.gl.drawingBufferHeight), n !== this.width && r !== this.height && On.log(2, "Resizing framebuffer ".concat(this.id, " to ").concat(n, "x").concat(r))();
    for (const i in this.attachments)
      this.attachments[i].resize({
        width: n,
        height: r
      });
    return this.width = n, this.height = r, this;
  }
  attach(e) {
    let {
      clearAttachments: n = !1,
      resizeAttachments: r = !0
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const i = {};
    n && Object.keys(this.attachments).forEach((s) => {
      i[s] = null;
    }), Object.assign(i, e);
    const o = this.gl.bindFramebuffer(36160, this.handle);
    for (const s in i) {
      dn(s !== void 0, "Misspelled framebuffer binding point?");
      const a = Number(s), A = i[a];
      let l = A;
      if (!l)
        this._unattach(a);
      else if (l instanceof av)
        this._attachRenderbuffer({
          attachment: a,
          renderbuffer: l
        });
      else if (Array.isArray(A)) {
        const [c, u = 0, f = 0] = A;
        l = c, this._attachTexture({
          attachment: a,
          texture: c,
          layer: u,
          level: f
        });
      } else
        this._attachTexture({
          attachment: a,
          texture: l,
          layer: 0,
          level: 0
        });
      r && l && l.resize({
        width: this.width,
        height: this.height
      });
    }
    this.gl.bindFramebuffer(36160, o || null), Object.assign(this.attachments, e), Object.keys(this.attachments).filter((s) => !this.attachments[s]).forEach((s) => {
      delete this.attachments[s];
    });
  }
  checkStatus() {
    const e = this.getStatus();
    if (e !== 36053)
      throw new Error(dan(e));
    return this;
  }
  getStatus() {
    const {
      gl: e
    } = this, n = e.bindFramebuffer(36160, this.handle), r = e.checkFramebufferStatus(36160);
    return e.bindFramebuffer(36160, n || null), r;
  }
  clear() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      color: n,
      depth: r,
      stencil: i,
      drawBuffers: o = []
    } = e, s = this.gl.bindFramebuffer(36160, this.handle);
    return (n || r || i) && aM(this.gl, {
      color: n,
      depth: r,
      stencil: i
    }), o.forEach((a, A) => {
      san(this.gl, {
        drawBuffer: A,
        value: a
      });
    }), this.gl.bindFramebuffer(36160, s || null), this;
  }
  readPixels() {
    return On.error("Framebuffer.readPixels() is no logner supported, use readPixelsToArray(framebuffer)")(), null;
  }
  readPixelsToBuffer() {
    return On.error("Framebuffer.readPixelsToBuffer()is no logner supported, use readPixelsToBuffer(framebuffer)")(), null;
  }
  copyToDataUrl() {
    return On.error("Framebuffer.copyToDataUrl() is no logner supported, use copyToDataUrl(framebuffer)")(), null;
  }
  copyToImage() {
    return On.error("Framebuffer.copyToImage() is no logner supported, use copyToImage(framebuffer)")(), null;
  }
  copyToTexture() {
    return On.error("Framebuffer.copyToTexture({...}) is no logner supported, use copyToTexture(source, target, opts})")(), null;
  }
  blit() {
    return On.error("Framebuffer.blit({...}) is no logner supported, use blit(source, target, opts)")(), null;
  }
  invalidate(e) {
    let {
      attachments: n = [],
      x: r = 0,
      y: i = 0,
      width: o,
      height: s
    } = e;
    const a = ol(this.gl), A = a.bindFramebuffer(36008, this.handle);
    return r === 0 && i === 0 && o === void 0 && s === void 0 ? a.invalidateFramebuffer(36008, n) : a.invalidateFramebuffer(36008, n, r, i, o, s), a.bindFramebuffer(36008, A), this;
  }
  getAttachmentParameter(e, n, r) {
    let i = this._getAttachmentParameterFallback(n);
    return i === null && (this.gl.bindFramebuffer(36160, this.handle), i = this.gl.getFramebufferAttachmentParameter(36160, e, n), this.gl.bindFramebuffer(36160, null)), r && i > 1e3 && (i = SC(this.gl, i)), i;
  }
  getAttachmentParameters() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 36064, n = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.constructor.ATTACHMENT_PARAMETERS || [];
    const i = {};
    for (const o of r) {
      const s = n ? SC(this.gl, o) : o;
      i[s] = this.getAttachmentParameter(e, o, n);
    }
    return i;
  }
  getParameters() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    const n = Object.keys(this.attachments), r = {};
    for (const i of n) {
      const o = Number(i), s = e ? SC(this.gl, o) : o;
      r[s] = this.getAttachmentParameters(o, e);
    }
    return r;
  }
  show() {
    return typeof window < "u" && window.open(Jbe(this), "luma-debug-texture"), this;
  }
  log() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (e > On.level || typeof window > "u")
      return this;
    n = n || "Framebuffer ".concat(this.id);
    const r = Jbe(this, {
      targetMaxHeight: 100
    });
    return On.image({
      logLevel: e,
      message: n,
      image: r
    }, n)(), this;
  }
  bind() {
    let {
      target: e = 36160
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.gl.bindFramebuffer(e, this.handle), this;
  }
  unbind() {
    let {
      target: e = 36160
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.gl.bindFramebuffer(e, null), this;
  }
  _createDefaultAttachments(e, n, r, i, o) {
    let s = null;
    return e && (s = s || {}, s[36064] = new xo(this.gl, {
      id: "".concat(this.id, "-color0"),
      pixels: null,
      format: 6408,
      type: 5121,
      width: i,
      height: o,
      mipmaps: !1,
      parameters: {
        [10241]: 9729,
        [10240]: 9729,
        [10242]: 33071,
        [10243]: 33071
      }
    }), this.ownResources.push(s[36064])), n && r ? (s = s || {}, s[33306] = new av(this.gl, {
      id: "".concat(this.id, "-depth-stencil"),
      format: 35056,
      width: i,
      height: 111
    }), this.ownResources.push(s[33306])) : n ? (s = s || {}, s[36096] = new av(this.gl, {
      id: "".concat(this.id, "-depth"),
      format: 33189,
      width: i,
      height: o
    }), this.ownResources.push(s[36096])) : r && dn(!1), s;
  }
  _unattach(e) {
    const n = this.attachments[e];
    n && (n instanceof av ? this.gl.framebufferRenderbuffer(36160, e, 36161, null) : this.gl.framebufferTexture2D(36160, e, 3553, null, 0), delete this.attachments[e]);
  }
  _attachRenderbuffer(e) {
    let {
      attachment: n = 36064,
      renderbuffer: r
    } = e;
    const {
      gl: i
    } = this;
    i.framebufferRenderbuffer(36160, n, 36161, r.handle), this.attachments[n] = r;
  }
  _attachTexture(e) {
    let {
      attachment: n = 36064,
      texture: r,
      layer: i,
      level: o
    } = e;
    const {
      gl: s
    } = this;
    switch (s.bindTexture(r.target, r.handle), r.target) {
      case 35866:
      case 32879:
        ol(s).framebufferTextureLayer(36160, n, r.target, o, i);
        break;
      case 34067:
        const A = han(i);
        s.framebufferTexture2D(36160, n, A, r.handle, o);
        break;
      case 3553:
        s.framebufferTexture2D(36160, n, 3553, r.handle, o);
        break;
      default:
        dn(!1, "Illegal texture type");
    }
    s.bindTexture(r.target, null), this.attachments[n] = r;
  }
  _setReadBuffer(e) {
    const n = zon(this.gl);
    n ? n.readBuffer(e) : dn(e === 36064 || e === 1029, Kbe), this.readBuffer = e;
  }
  _setDrawBuffers(e) {
    const {
      gl: n
    } = this, r = ol(n);
    if (r)
      r.drawBuffers(e);
    else {
      const i = n.getExtension("WEBGL_draw_buffers");
      i ? i.drawBuffersWEBGL(e) : dn(e.length === 1 && (e[0] === 36064 || e[0] === 1029), Kbe);
    }
    this.drawBuffers = e;
  }
  _getAttachmentParameterFallback(e) {
    const n = fan(this.gl);
    switch (e) {
      case 36052:
        return n.WEBGL2 ? null : 0;
      case 33298:
      case 33299:
      case 33300:
      case 33301:
      case 33302:
      case 33303:
        return n.WEBGL2 ? null : 8;
      case 33297:
        return n.WEBGL2 ? null : 5125;
      case 33296:
        return !n.WEBGL2 && !n.EXT_sRGB ? 9729 : null;
      default:
        return null;
    }
  }
  _createHandle() {
    return this.gl.createFramebuffer();
  }
  _deleteHandle() {
    this.gl.deleteFramebuffer(this.handle);
  }
  _bindHandle(e) {
    return this.gl.bindFramebuffer(36160, e);
  }
}
function han(t) {
  return t < 34069 ? t + 34069 : t;
}
function dan(t) {
  return (Da.STATUS || {})[t] || "Framebuffer error ".concat(t);
}
const pan = [36049, 36048, 33296, 33298, 33299, 33300, 33301, 33302, 33303];
Da.ATTACHMENT_PARAMETERS = pan;
function J9e(t, e) {
  dn(t instanceof xo || t instanceof Ele || t instanceof yle);
  const n = t.constructor, {
    gl: r,
    width: i,
    height: o,
    format: s,
    type: a,
    dataFormat: A,
    border: l,
    mipmaps: c
  } = t, u = Object.assign({
    width: i,
    height: o,
    format: s,
    type: a,
    dataFormat: A,
    border: l,
    mipmaps: c
  }, e);
  return new n(r, u);
}
function Ian(t, e) {
  const {
    gl: n,
    width: r,
    height: i,
    id: o
  } = t;
  return new Da(n, Object.assign({}, e, {
    id: "framebuffer-for-".concat(o),
    width: r,
    height: i,
    attachments: {
      [36064]: t
    }
  }));
}
function bk(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "unnamed";
  const n = /#define[\s*]SHADER_NAME[\s*]([A-Za-z0-9_-]+)[\s*]/, r = t.match(n);
  return r ? r[1] : e;
}
const man = 35632, Can = 35633;
function Ean(t) {
  switch (t) {
    case man:
      return "fragment";
    case Can:
      return "vertex";
    default:
      return "unknown type";
  }
}
function yan(t, e, n, r) {
  const i = t.split(/\r?\n/), o = {}, s = {}, a = r || bk(e) || "(unnamed)", A = "".concat(Ean(n), " shader ").concat(a);
  for (let c = 0; c < i.length; c++) {
    const u = i[c];
    if (u.length <= 1)
      continue;
    const f = u.split(":"), h = f[0], d = parseInt(f[2], 10);
    if (isNaN(d))
      throw new Error("GLSL compilation error in ".concat(A, ": ").concat(t));
    h !== "WARNING" ? o[d] = u : s[d] = u;
  }
  const l = van(e);
  return {
    shaderName: A,
    errors: Wbe(o, l),
    warnings: Wbe(s, l)
  };
}
function Wbe(t, e) {
  let n = "";
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    if (!(!t[r + 3] && !t[r + 2] && !t[r + 1]) && (n += "".concat(i, `
`), t[r + 1])) {
      const o = t[r + 1], s = o.split(":", 3), a = s[0], A = parseInt(s[1], 10) || 0, l = o.substring(s.join(":").length + 1).trim();
      n += K9e("^^^ ".concat(a, ": ").concat(l, `

`), A);
    }
  }
  return n;
}
function van(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ": ";
  const r = t.split(/\r?\n/), i = String(r.length + e - 1).length;
  return r.map((o, s) => {
    const a = String(s + e), A = a.length;
    return K9e(a, i - A) + n + o;
  });
}
function K9e(t, e) {
  let n = "";
  for (let r = 0; r < e; ++r)
    n += " ";
  return "".concat(n).concat(t);
}
function W9e(t) {
  let e = 100;
  const n = t.match(/[^\s]+/g);
  if (n.length >= 2 && n[0] === "#version") {
    const r = parseInt(n[1], 10);
    Number.isFinite(r) && (e = r);
  }
  return e;
}
const Ban = "Shader: GLSL source code must be a JavaScript string";
class MT extends WI {
  get [Symbol.toStringTag]() {
    return "Shader";
  }
  static getTypeName(e) {
    switch (e) {
      case 35633:
        return "vertex-shader";
      case 35632:
        return "fragment-shader";
      default:
        return dn(!1), "unknown";
    }
  }
  constructor(e, n) {
    X9(e), dn(typeof n.source == "string", Ban);
    const r = bk(n.source, null) || n.id || PA("unnamed ".concat(MT.getTypeName(n.shaderType)));
    super(e, {
      id: r
    }), this.shaderType = n.shaderType, this.source = n.source, this.initialize(n);
  }
  initialize(e) {
    let {
      source: n
    } = e;
    const r = bk(n, null);
    r && (this.id = PA(r)), this._compile(n);
  }
  getParameter(e) {
    return this.gl.getShaderParameter(this.handle, e);
  }
  toString() {
    return "".concat(MT.getTypeName(this.shaderType), ":").concat(this.id);
  }
  getName() {
    return bk(this.source) || "unnamed-shader";
  }
  getSource() {
    return this.gl.getShaderSource(this.handle);
  }
  getTranslatedSource() {
    const e = this.gl.getExtension("WEBGL_debug_shaders");
    return e ? e.getTranslatedShaderSource(this.handle) : "No translated source available. WEBGL_debug_shaders not implemented";
  }
  _compile() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.source;
    if (e.startsWith("#version ") || (e = `#version 100
`.concat(e)), this.source = e, this.gl.shaderSource(this.handle, this.source), this.gl.compileShader(this.handle), !this.getParameter(35713)) {
      const r = this.gl.getShaderInfoLog(this.handle), {
        shaderName: i,
        errors: o,
        warnings: s
      } = yan(r, this.source, this.shaderType, this.id);
      throw On.error("GLSL compilation errors in ".concat(i, `
`).concat(o))(), On.warn("GLSL compilation warnings in ".concat(i, `
`).concat(s))(), new Error("GLSL compilation errors in ".concat(i));
    }
  }
  _deleteHandle() {
    this.gl.deleteShader(this.handle);
  }
  _getOptsFromHandle() {
    return {
      type: this.getParameter(35663),
      source: this.getSource()
    };
  }
}
class _k extends MT {
  get [Symbol.toStringTag]() {
    return "VertexShader";
  }
  constructor(e, n) {
    typeof n == "string" && (n = {
      source: n
    }), super(e, Object.assign({}, n, {
      shaderType: 35633
    }));
  }
  _createHandle() {
    return this.gl.createShader(35633);
  }
}
class Sk extends MT {
  get [Symbol.toStringTag]() {
    return "FragmentShader";
  }
  constructor(e, n) {
    typeof n == "string" && (n = {
      source: n
    }), super(e, Object.assign({}, n, {
      shaderType: 35632
    }));
  }
  _createHandle() {
    return this.gl.createShader(35632);
  }
}
const ban = {
  [5126]: ss.bind(null, "uniform1fv", Af, 1, Sl),
  [35664]: ss.bind(null, "uniform2fv", Af, 2, Sl),
  [35665]: ss.bind(null, "uniform3fv", Af, 3, Sl),
  [35666]: ss.bind(null, "uniform4fv", Af, 4, Sl),
  [5124]: ss.bind(null, "uniform1iv", wm, 1, Sl),
  [35667]: ss.bind(null, "uniform2iv", wm, 2, Sl),
  [35668]: ss.bind(null, "uniform3iv", wm, 3, Sl),
  [35669]: ss.bind(null, "uniform4iv", wm, 4, Sl),
  [35670]: ss.bind(null, "uniform1iv", wm, 1, Sl),
  [35671]: ss.bind(null, "uniform2iv", wm, 2, Sl),
  [35672]: ss.bind(null, "uniform3iv", wm, 3, Sl),
  [35673]: ss.bind(null, "uniform4iv", wm, 4, Sl),
  [35674]: ss.bind(null, "uniformMatrix2fv", Af, 4, N0),
  [35675]: ss.bind(null, "uniformMatrix3fv", Af, 9, N0),
  [35676]: ss.bind(null, "uniformMatrix4fv", Af, 16, N0),
  [35678]: tl,
  [35680]: tl,
  [5125]: ss.bind(null, "uniform1uiv", HF, 1, Sl),
  [36294]: ss.bind(null, "uniform2uiv", HF, 2, Sl),
  [36295]: ss.bind(null, "uniform3uiv", HF, 3, Sl),
  [36296]: ss.bind(null, "uniform4uiv", HF, 4, Sl),
  [35685]: ss.bind(null, "uniformMatrix2x3fv", Af, 6, N0),
  [35686]: ss.bind(null, "uniformMatrix2x4fv", Af, 8, N0),
  [35687]: ss.bind(null, "uniformMatrix3x2fv", Af, 6, N0),
  [35688]: ss.bind(null, "uniformMatrix3x4fv", Af, 12, N0),
  [35689]: ss.bind(null, "uniformMatrix4x2fv", Af, 8, N0),
  [35690]: ss.bind(null, "uniformMatrix4x3fv", Af, 12, N0),
  [35678]: tl,
  [35680]: tl,
  [35679]: tl,
  [35682]: tl,
  [36289]: tl,
  [36292]: tl,
  [36293]: tl,
  [36298]: tl,
  [36299]: tl,
  [36300]: tl,
  [36303]: tl,
  [36306]: tl,
  [36307]: tl,
  [36308]: tl,
  [36311]: tl
}, _an = {}, San = {}, Qan = {}, Xbe = [0];
function Ble(t, e, n, r) {
  e === 1 && typeof t == "boolean" && (t = t ? 1 : 0), Number.isFinite(t) && (Xbe[0] = t, t = Xbe);
  const i = t.length;
  if (i % e && On.warn("Uniform size should be multiples of ".concat(e), t)(), t instanceof n)
    return t;
  let o = r[i];
  o || (o = new n(i), r[i] = o);
  for (let s = 0; s < i; s++)
    o[s] = t[s];
  return o;
}
function Af(t, e) {
  return Ble(t, e, Float32Array, _an);
}
function wm(t, e) {
  return Ble(t, e, Int32Array, San);
}
function HF(t, e) {
  return Ble(t, e, Uint32Array, Qan);
}
function Zbe(t, e, n) {
  const r = ban[n.type];
  if (!r)
    throw new Error("Unknown GLSL uniform type ".concat(n.type));
  return r().bind(null, t, e);
}
function wan(t) {
  if (t[t.length - 1] !== "]")
    return {
      name: t,
      length: 1,
      isArray: !1
    };
  const e = /([^[]*)(\[[0-9]+\])?/, n = t.match(e);
  if (!n || n.length < 2)
    throw new Error("Failed to parse GLSL uniform name ".concat(t));
  return {
    name: n[1],
    length: n[2] || 1,
    isArray: !!n[2]
  };
}
function xan(t, e, n) {
  for (const r in t) {
    const i = t[r];
    if ((!n || !!n[r]) && !Ran(i))
      throw e = e ? "".concat(e, " ") : "", console.error("".concat(e, " Bad uniform ").concat(r), i), new Error("".concat(e, " Bad uniform ").concat(r));
  }
  return !0;
}
function Ran(t) {
  return Array.isArray(t) || ArrayBuffer.isView(t) ? Tan(t) : isFinite(t) || t === !0 || t === !1 || t instanceof Xv || t instanceof av ? !0 : t instanceof Da ? !!t.texture : !1;
}
function Dan(t, e, n) {
  if (Array.isArray(n) || ArrayBuffer.isView(n))
    if (t[e]) {
      const r = t[e];
      for (let i = 0, o = n.length; i < o; ++i)
        r[i] = n[i];
    } else
      t[e] = n.slice();
  else
    t[e] = n;
}
function Tan(t) {
  if (t.length === 0)
    return !1;
  const e = Math.min(t.length, 16);
  for (let n = 0; n < e; ++n)
    if (!Number.isFinite(t[n]))
      return !1;
  return !0;
}
function tl() {
  let t = null;
  return (e, n, r) => {
    const i = t !== r;
    return i && (e.uniform1i(n, r), t = r), i;
  };
}
function ss(t, e, n, r) {
  let i = null, o = null;
  return (s, a, A) => {
    const l = e(A, n), c = l.length;
    let u = !1;
    if (i === null)
      i = new Float32Array(c), o = c, u = !0;
    else {
      dn(o === c, "Uniform length cannot change.");
      for (let f = 0; f < c; ++f)
        if (l[f] !== i[f]) {
          u = !0;
          break;
        }
    }
    return u && (r(s, t, a, l), i.set(l)), u;
  };
}
function Sl(t, e, n, r) {
  t[e](n, r);
}
function N0(t, e, n, r) {
  t[e](n, !1, r);
}
const Nan = 5120, Lan = 5121, Man = 5122, Oan = 5123, e_e = 0, $F = 1, Fan = 2, Pan = 3, qF = 4, kan = 5, Gan = 6, nA = 5126, Uan = 35664, Han = 35665, $an = 35666, s2 = 5124, qan = 35667, jan = 35668, Yan = 35669, a2 = 5125, zan = 36294, Van = 36295, Jan = 36296, Kan = 35670, Wan = 35671, Xan = 35672, Zan = 35673, eAn = 35674, tAn = 35675, nAn = 35676, rAn = 35685, iAn = 35686, oAn = 35687, sAn = 35688, aAn = 35689, AAn = 35690, Pee = {
  [nA]: [nA, 1, "float"],
  [Uan]: [nA, 2, "vec2"],
  [Han]: [nA, 3, "vec3"],
  [$an]: [nA, 4, "vec4"],
  [s2]: [s2, 1, "int"],
  [qan]: [s2, 2, "ivec2"],
  [jan]: [s2, 3, "ivec3"],
  [Yan]: [s2, 4, "ivec4"],
  [a2]: [a2, 1, "uint"],
  [zan]: [a2, 2, "uvec2"],
  [Van]: [a2, 3, "uvec3"],
  [Jan]: [a2, 4, "uvec4"],
  [Kan]: [nA, 1, "bool"],
  [Wan]: [nA, 2, "bvec2"],
  [Xan]: [nA, 3, "bvec3"],
  [Zan]: [nA, 4, "bvec4"],
  [eAn]: [nA, 8, "mat2"],
  [rAn]: [nA, 8, "mat2x3"],
  [iAn]: [nA, 8, "mat2x4"],
  [tAn]: [nA, 12, "mat3"],
  [oAn]: [nA, 12, "mat3x2"],
  [sAn]: [nA, 12, "mat3x4"],
  [nAn]: [nA, 16, "mat4"],
  [aAn]: [nA, 16, "mat4x2"],
  [AAn]: [nA, 16, "mat4x3"]
};
function lAn(t) {
  switch (t) {
    case e_e:
      return e_e;
    case $F:
      return $F;
    case Pan:
      return $F;
    case Fan:
      return $F;
    case qF:
      return qF;
    case kan:
      return qF;
    case Gan:
      return qF;
    default:
      return dn(!1), 0;
  }
}
function t_e(t) {
  const e = Pee[t];
  if (!e)
    return null;
  const [n, r] = e;
  return {
    type: n,
    components: r
  };
}
function X9e(t, e) {
  switch (t) {
    case Nan:
    case Lan:
    case Man:
    case Oan:
      t = nA;
      break;
  }
  for (const n in Pee) {
    const [r, i, o] = Pee[n];
    if (r === t && i === e)
      return {
        glType: n,
        name: o
      };
  }
  return null;
}
class cAn {
  constructor(e) {
    this.id = e.id, this.attributeInfos = [], this.attributeInfosByName = {}, this.attributeInfosByLocation = [], this.varyingInfos = [], this.varyingInfosByName = {}, Object.seal(this), this._readAttributesFromProgram(e), this._readVaryingsFromProgram(e);
  }
  getAttributeInfo(e) {
    const n = Number(e);
    return Number.isFinite(n) ? this.attributeInfosByLocation[n] : this.attributeInfosByName[e] || null;
  }
  getAttributeLocation(e) {
    const n = this.getAttributeInfo(e);
    return n ? n.location : -1;
  }
  getAttributeAccessor(e) {
    const n = this.getAttributeInfo(e);
    return n ? n.accessor : null;
  }
  getVaryingInfo(e) {
    const n = Number(e);
    return Number.isFinite(n) ? this.varyingInfos[n] : this.varyingInfosByName[e] || null;
  }
  getVaryingIndex(e) {
    const n = this.getVaryingInfo();
    return n ? n.location : -1;
  }
  getVaryingAccessor(e) {
    const n = this.getVaryingInfo();
    return n ? n.accessor : null;
  }
  _readAttributesFromProgram(e) {
    const {
      gl: n
    } = e, r = n.getProgramParameter(e.handle, 35721);
    for (let i = 0; i < r; i++) {
      const {
        name: o,
        type: s,
        size: a
      } = n.getActiveAttrib(e.handle, i), A = n.getAttribLocation(e.handle, o);
      A >= 0 && this._addAttribute(A, o, s, a);
    }
    this.attributeInfos.sort((i, o) => i.location - o.location);
  }
  _readVaryingsFromProgram(e) {
    const {
      gl: n
    } = e;
    if (!Fr(n))
      return;
    const r = n.getProgramParameter(e.handle, 35971);
    for (let i = 0; i < r; i++) {
      const {
        name: o,
        type: s,
        size: a
      } = n.getTransformFeedbackVarying(e.handle, i);
      this._addVarying(i, o, s, a);
    }
    this.varyingInfos.sort((i, o) => i.location - o.location);
  }
  _addAttribute(e, n, r, i) {
    const {
      type: o,
      components: s
    } = t_e(r), a = {
      type: o,
      size: i * s
    };
    this._inferProperties(e, n, a);
    const A = {
      location: e,
      name: n,
      accessor: new yu(a)
    };
    this.attributeInfos.push(A), this.attributeInfosByLocation[e] = A, this.attributeInfosByName[A.name] = A;
  }
  _inferProperties(e, n, r) {
    /instance/i.test(n) && (r.divisor = 1);
  }
  _addVarying(e, n, r, i) {
    const {
      type: o,
      components: s
    } = t_e(r), a = new yu({
      type: o,
      size: i * s
    }), A = {
      location: e,
      name: n,
      accessor: a
    };
    this.varyingInfos.push(A), this.varyingInfosByName[A.name] = A;
  }
}
const n_e = 4, uAn = 35981, fAn = ["setVertexArray", "setAttributes", "setBuffers", "unsetBuffers", "use", "getUniformCount", "getUniformInfo", "getUniformLocation", "getUniformValue", "getVarying", "getFragDataLocation", "getAttachedShaders", "getAttributeCount", "getAttributeLocation", "getAttributeInfo"];
class ble extends WI {
  get [Symbol.toStringTag]() {
    return "Program";
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(e, n), this.stubRemovedMethods("Program", "v6.0", fAn), this._isCached = !1, this.initialize(n), Object.seal(this), this._setId(n.id);
  }
  initialize() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      hash: n,
      vs: r,
      fs: i,
      varyings: o,
      bufferMode: s = uAn
    } = e;
    return this.hash = n || "", this.vs = typeof r == "string" ? new _k(this.gl, {
      id: "".concat(e.id, "-vs"),
      source: r
    }) : r, this.fs = typeof i == "string" ? new Sk(this.gl, {
      id: "".concat(e.id, "-fs"),
      source: i
    }) : i, dn(this.vs instanceof _k), dn(this.fs instanceof Sk), this.uniforms = {}, this._textureUniforms = {}, o && o.length > 0 && (ol(this.gl), this.varyings = o, this.gl2.transformFeedbackVaryings(this.handle, o, s)), this._compileAndLink(), this._readUniformLocationsFromLinkedProgram(), this.configuration = new cAn(this), this.setProps(e);
  }
  delete() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this._isCached ? this : super.delete(e);
  }
  setProps(e) {
    return "uniforms" in e && this.setUniforms(e.uniforms), this;
  }
  draw(e) {
    let {
      logPriority: n,
      drawMode: r = 4,
      vertexCount: i,
      offset: o = 0,
      start: s,
      end: a,
      isIndexed: A = !1,
      indexType: l = 5123,
      instanceCount: c = 0,
      isInstanced: u = c > 0,
      vertexArray: f = null,
      transformFeedback: h,
      framebuffer: d,
      parameters: I = {},
      uniforms: m,
      samplers: C
    } = e;
    if ((m || C) && (On.deprecated("Program.draw({uniforms})", "Program.setUniforms(uniforms)")(), this.setUniforms(m || {})), On.priority >= n) {
      const y = d ? d.id : "default", v = "mode=".concat(SC(this.gl, r), " verts=").concat(i, " ") + "instances=".concat(c, " indexType=").concat(SC(this.gl, l), " ") + "isInstanced=".concat(u, " isIndexed=").concat(A, " ") + "Framebuffer=".concat(y);
      On.log(n, v)();
    }
    return dn(f), this.gl.useProgram(this.handle), !this._areTexturesRenderable() || i === 0 || u && c === 0 ? !1 : (f.bindForDraw(i, c, () => {
      if (d !== void 0 && (I = Object.assign({}, I, {
        framebuffer: d
      })), h) {
        const y = lAn(r);
        h.begin(y);
      }
      this._bindTextures(), Yc(this.gl, I, () => {
        A && u ? this.gl2.drawElementsInstanced(r, i, l, o, c) : A && Fr(this.gl) && !isNaN(s) && !isNaN(a) ? this.gl2.drawRangeElements(r, s, a, i, l, o) : A ? this.gl.drawElements(r, i, l, o) : u ? this.gl2.drawArraysInstanced(r, o, i, c) : this.gl.drawArrays(r, o, i);
      }), h && h.end();
    }), !0);
  }
  setUniforms() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    On.priority >= 2 && xan(e, this.id, this._uniformSetters), this.gl.useProgram(this.handle);
    for (const n in e) {
      const r = e[n], i = this._uniformSetters[n];
      if (i) {
        let o = r, s = !1;
        if (o instanceof Da && (o = o.texture), o instanceof Xv)
          if (s = this.uniforms[n] !== r, s) {
            i.textureIndex === void 0 && (i.textureIndex = this._textureIndexCounter++);
            const a = o, {
              textureIndex: A
            } = i;
            a.bind(A), o = A, this._textureUniforms[n] = a;
          } else
            o = i.textureIndex;
        else
          this._textureUniforms[n] && delete this._textureUniforms[n];
        (i(o) || s) && Dan(this.uniforms, n, r);
      }
    }
    return this;
  }
  _areTexturesRenderable() {
    let e = !0;
    for (const n in this._textureUniforms) {
      const r = this._textureUniforms[n];
      r.update(), e = e && r.loaded;
    }
    return e;
  }
  _bindTextures() {
    for (const e in this._textureUniforms) {
      const n = this._uniformSetters[e].textureIndex;
      this._textureUniforms[e].bind(n);
    }
  }
  _createHandle() {
    return this.gl.createProgram();
  }
  _deleteHandle() {
    this.gl.deleteProgram(this.handle);
  }
  _getOptionsFromHandle(e) {
    const n = this.gl.getAttachedShaders(e), r = {};
    for (const i of n)
      switch (this.gl.getShaderParameter(this.handle, 35663)) {
        case 35633:
          r.vs = new _k({
            handle: i
          });
          break;
        case 35632:
          r.fs = new Sk({
            handle: i
          });
          break;
      }
    return r;
  }
  _getParameter(e) {
    return this.gl.getProgramParameter(this.handle, e);
  }
  _setId(e) {
    if (!e) {
      const n = this._getName();
      this.id = PA(n);
    }
  }
  _getName() {
    let e = this.vs.getName() || this.fs.getName();
    return e = e.replace(/shader/i, ""), e = e ? "".concat(e, "-program") : "program", e;
  }
  _compileAndLink() {
    const {
      gl: e
    } = this;
    if (e.attachShader(this.handle, this.vs.handle), e.attachShader(this.handle, this.fs.handle), On.time(n_e, "linkProgram for ".concat(this._getName()))(), e.linkProgram(this.handle), On.timeEnd(n_e, "linkProgram for ".concat(this._getName()))(), e.debug || On.level > 0) {
      if (!e.getProgramParameter(this.handle, 35714))
        throw new Error("Error linking: ".concat(e.getProgramInfoLog(this.handle)));
      if (e.validateProgram(this.handle), !e.getProgramParameter(this.handle, 35715))
        throw new Error("Error validating: ".concat(e.getProgramInfoLog(this.handle)));
    }
  }
  _readUniformLocationsFromLinkedProgram() {
    const {
      gl: e
    } = this;
    this._uniformSetters = {}, this._uniformCount = this._getParameter(35718);
    for (let n = 0; n < this._uniformCount; n++) {
      const r = this.gl.getActiveUniform(this.handle, n), {
        name: i
      } = wan(r.name);
      let o = e.getUniformLocation(this.handle, i);
      if (this._uniformSetters[i] = Zbe(e, o, r), r.size > 1)
        for (let s = 0; s < r.size; s++)
          o = e.getUniformLocation(this.handle, "".concat(i, "[").concat(s, "]")), this._uniformSetters["".concat(i, "[").concat(s, "]")] = Zbe(e, o, r);
    }
    this._textureIndexCounter = 0;
  }
  getActiveUniforms(e, n) {
    return this.gl2.getActiveUniforms(this.handle, e, n);
  }
  getUniformBlockIndex(e) {
    return this.gl2.getUniformBlockIndex(this.handle, e);
  }
  getActiveUniformBlockParameter(e, n) {
    return this.gl2.getActiveUniformBlockParameter(this.handle, e, n);
  }
  uniformBlockBinding(e, n) {
    this.gl2.uniformBlockBinding(this.handle, e, n);
  }
}
const gAn = 34918, hAn = 34919, dAn = 35007, pAn = 36795, IAn = 35976, mAn = 35887, CAn = 36202;
class mU extends WI {
  get [Symbol.toStringTag]() {
    return "Query";
  }
  static isSupported(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const r = Fr(e), i = e$(e, no.TIMER_QUERY);
    let o = r || i;
    for (const s of n)
      switch (s) {
        case "queries":
          o = o && r;
          break;
        case "timers":
          o = o && i;
          break;
        default:
          dn(!1);
      }
    return o;
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(e, n), this.target = null, this._queryPending = !1, this._pollingPromise = null, Object.seal(this);
  }
  beginTimeElapsedQuery() {
    return this.begin(dAn);
  }
  beginOcclusionQuery() {
    let {
      conservative: e = !1
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.begin(e ? CAn : mAn);
  }
  beginTransformFeedbackQuery() {
    return this.begin(IAn);
  }
  begin(e) {
    return this._queryPending ? this : (this.target = e, this.gl2.beginQuery(this.target, this.handle), this);
  }
  end() {
    return this._queryPending ? this : (this.target && (this.gl2.endQuery(this.target), this.target = null, this._queryPending = !0), this);
  }
  isResultAvailable() {
    if (!this._queryPending)
      return !1;
    const e = this.gl2.getQueryParameter(this.handle, hAn);
    return e && (this._queryPending = !1), e;
  }
  isTimerDisjoint() {
    return this.gl2.getParameter(pAn);
  }
  getResult() {
    return this.gl2.getQueryParameter(this.handle, gAn);
  }
  getTimerMilliseconds() {
    return this.getResult() / 1e6;
  }
  createPoll() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Number.POSITIVE_INFINITY;
    if (this._pollingPromise)
      return this._pollingPromise;
    let n = 0;
    return this._pollingPromise = new Promise((r, i) => {
      const o = () => {
        this.isResultAvailable() ? (r(this.getResult()), this._pollingPromise = null) : n++ > e ? (i("Timed out"), this._pollingPromise = null) : requestAnimationFrame(o);
      };
      requestAnimationFrame(o);
    }), this._pollingPromise;
  }
  _createHandle() {
    return mU.isSupported(this.gl) ? this.gl2.createQuery() : null;
  }
  _deleteHandle() {
    this.gl2.deleteQuery(this.handle);
  }
}
class _le extends WI {
  get [Symbol.toStringTag]() {
    return "TransformFeedback";
  }
  static isSupported(e) {
    return Fr(e);
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    ol(e), super(e, n), this.initialize(n), this.stubRemovedMethods("TransformFeedback", "v6.0", ["pause", "resume"]), Object.seal(this);
  }
  initialize() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.buffers = {}, this.unused = {}, this.configuration = null, this.bindOnUse = !0, GS(this.buffers) || this.bind(() => this._unbindBuffers()), this.setProps(e), this;
  }
  setProps(e) {
    "program" in e && (this.configuration = e.program && e.program.configuration), "configuration" in e && (this.configuration = e.configuration), "bindOnUse" in e && (e = e.bindOnUse), "buffers" in e && this.setBuffers(e.buffers);
  }
  setBuffers() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.bind(() => {
      for (const n in e)
        this.setBuffer(n, e[n]);
    }), this;
  }
  setBuffer(e, n) {
    const r = this._getVaryingIndex(e), {
      buffer: i,
      byteSize: o,
      byteOffset: s
    } = this._getBufferParams(n);
    return r < 0 ? (this.unused[e] = i, On.warn("".concat(this.id, " unused varying buffer ").concat(e))(), this) : (this.buffers[r] = n, this.bindOnUse || this._bindBuffer(r, i, s, o), this);
  }
  begin() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return this.gl.bindTransformFeedback(36386, this.handle), this._bindBuffers(), this.gl.beginTransformFeedback(e), this;
  }
  end() {
    return this.gl.endTransformFeedback(), this._unbindBuffers(), this.gl.bindTransformFeedback(36386, null), this;
  }
  _getBufferParams(e) {
    let n, r, i;
    return e instanceof ro ? i = e : (i = e.buffer, r = e.byteSize, n = e.byteOffset), (n !== void 0 || r !== void 0) && (n = n || 0, r = r || i.byteLength - n), {
      buffer: i,
      byteOffset: n,
      byteSize: r
    };
  }
  _getVaryingInfo(e) {
    return this.configuration && this.configuration.getVaryingInfo(e);
  }
  _getVaryingIndex(e) {
    if (this.configuration)
      return this.configuration.getVaryingInfo(e).location;
    const n = Number(e);
    return Number.isFinite(n) ? n : -1;
  }
  _bindBuffers() {
    if (this.bindOnUse)
      for (const e in this.buffers) {
        const {
          buffer: n,
          byteSize: r,
          byteOffset: i
        } = this._getBufferParams(this.buffers[e]);
        this._bindBuffer(e, n, i, r);
      }
  }
  _unbindBuffers() {
    if (this.bindOnUse)
      for (const e in this.buffers)
        this._bindBuffer(e, null);
  }
  _bindBuffer(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 ? arguments[3] : void 0;
    const o = n && n.handle;
    return !o || i === void 0 ? this.gl.bindBufferBase(35982, e, o) : this.gl.bindBufferRange(35982, e, o, r, i), this;
  }
  _createHandle() {
    return this.gl.createTransformFeedback();
  }
  _deleteHandle() {
    this.gl.deleteTransformFeedback(this.handle);
  }
  _bindHandle(e) {
    this.gl.bindTransformFeedback(36386, this.handle);
  }
}
let jF = null;
function EAn(t) {
  return (!jF || jF.byteLength < t) && (jF = new ArrayBuffer(t)), jF;
}
function yAn(t, e) {
  const n = EAn(t.BYTES_PER_ELEMENT * e);
  return new t(n, 0, e);
}
function vAn(t) {
  let {
    target: e,
    source: n,
    start: r = 0,
    count: i = 1
  } = t;
  const o = n.length, s = i * o;
  let a = 0;
  for (let A = r; a < o; a++)
    e[A++] = n[a];
  for (; a < s; )
    a < s - a ? (e.copyWithin(r + a, r, r + a), a *= 2) : (e.copyWithin(r + a, r, r + s - a), a = s);
  return e;
}
const BAn = "elements must be GL.ELEMENT_ARRAY_BUFFER";
class If extends WI {
  get [Symbol.toStringTag]() {
    return "VertexArrayObject";
  }
  static isSupported(e) {
    return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).constantAttributeZero ? Fr(e) || E9e() === "Chrome" : !0;
  }
  static getDefaultArray(e) {
    return e.luma = e.luma || {}, e.luma.defaultVertexArray || (e.luma.defaultVertexArray = new If(e, {
      handle: null,
      isDefaultArray: !0
    })), e.luma.defaultVertexArray;
  }
  static getMaxAttributes(e) {
    return If.MAX_ATTRIBUTES = If.MAX_ATTRIBUTES || e.getParameter(34921), If.MAX_ATTRIBUTES;
  }
  static setConstant(e, n, r) {
    switch (r.constructor) {
      case Float32Array:
        If._setConstantFloatArray(e, n, r);
        break;
      case Int32Array:
        If._setConstantIntArray(e, n, r);
        break;
      case Uint32Array:
        If._setConstantUintArray(e, n, r);
        break;
      default:
        dn(!1);
    }
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = n.id || n.program && n.program.id;
    super(e, Object.assign({}, n, {
      id: r
    })), this.buffer = null, this.bufferValue = null, this.isDefaultArray = n.isDefaultArray || !1, this.gl2 = e, this.initialize(n), Object.seal(this);
  }
  delete() {
    return super.delete(), this.buffer && this.buffer.delete(), this;
  }
  get MAX_ATTRIBUTES() {
    return If.getMaxAttributes(this.gl);
  }
  initialize() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.setProps(e);
  }
  setProps(e) {
    return this;
  }
  setElementBuffer() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return dn(!e || e.target === 34963, BAn), this.bind(() => {
      this.gl.bindBuffer(34963, e ? e.handle : null);
    }), this;
  }
  setBuffer(e, n, r) {
    if (n.target === 34963)
      return this.setElementBuffer(n, r);
    const {
      size: i,
      type: o,
      stride: s,
      offset: a,
      normalized: A,
      integer: l,
      divisor: c
    } = r, {
      gl: u,
      gl2: f
    } = this;
    return e = Number(e), this.bind(() => {
      u.bindBuffer(34962, n.handle), l ? (dn(Fr(u)), f.vertexAttribIPointer(e, i, o, s, a)) : u.vertexAttribPointer(e, i, o, A, s, a), u.enableVertexAttribArray(e), f.vertexAttribDivisor(e, c || 0);
    }), this;
  }
  enable(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return !n && e === 0 && !If.isSupported(this.gl, {
      constantAttributeZero: !0
    }) || (e = Number(e), this.bind(() => n ? this.gl.enableVertexAttribArray(e) : this.gl.disableVertexAttribArray(e))), this;
  }
  getConstantBuffer(e, n) {
    const r = this._normalizeConstantArrayValue(n), i = r.byteLength * e, o = r.length * e;
    let s = !this.buffer;
    if (this.buffer = this.buffer || new ro(this.gl, i), s = s || this.buffer.reallocate(i), s = s || !this._compareConstantArrayValues(r, this.bufferValue), s) {
      const a = yAn(n.constructor, o);
      vAn({
        target: a,
        source: r,
        start: 0,
        count: o
      }), this.buffer.subData(a), this.bufferValue = n;
    }
    return this.buffer;
  }
  _normalizeConstantArrayValue(e) {
    return Array.isArray(e) ? new Float32Array(e) : e;
  }
  _compareConstantArrayValues(e, n) {
    if (!e || !n || e.length !== n.length || e.constructor !== n.constructor)
      return !1;
    for (let r = 0; r < e.length; ++r)
      if (e[r] !== n[r])
        return !1;
    return !0;
  }
  static _setConstantFloatArray(e, n, r) {
    switch (r.length) {
      case 1:
        e.vertexAttrib1fv(n, r);
        break;
      case 2:
        e.vertexAttrib2fv(n, r);
        break;
      case 3:
        e.vertexAttrib3fv(n, r);
        break;
      case 4:
        e.vertexAttrib4fv(n, r);
        break;
      default:
        dn(!1);
    }
  }
  static _setConstantIntArray(e, n, r) {
    switch (dn(Fr(e)), r.length) {
      case 1:
        e.vertexAttribI1iv(n, r);
        break;
      case 2:
        e.vertexAttribI2iv(n, r);
        break;
      case 3:
        e.vertexAttribI3iv(n, r);
        break;
      case 4:
        e.vertexAttribI4iv(n, r);
        break;
      default:
        dn(!1);
    }
  }
  static _setConstantUintArray(e, n, r) {
    switch (dn(Fr(e)), r.length) {
      case 1:
        e.vertexAttribI1uiv(n, r);
        break;
      case 2:
        e.vertexAttribI2uiv(n, r);
        break;
      case 3:
        e.vertexAttribI3uiv(n, r);
        break;
      case 4:
        e.vertexAttribI4uiv(n, r);
        break;
      default:
        dn(!1);
    }
  }
  _createHandle() {
    return this.gl.createVertexArray();
  }
  _deleteHandle(e) {
    return this.gl2.deleteVertexArray(e), [this.elements];
  }
  _bindHandle(e) {
    this.gl2.bindVertexArray(e);
  }
  _getParameter(e, n) {
    let {
      location: r
    } = n;
    return dn(Number.isFinite(r)), this.bind(() => {
      switch (e) {
        case 34373:
          return this.gl.getVertexAttribOffset(r, e);
        default:
          return this.gl.getVertexAttrib(r, e);
      }
    });
  }
}
const bAn = "VertexArray: attributes must be Buffers or constants (i.e. typed array)", _An = /^(.+)__LOCATION_([0-9]+)$/, SAn = ["setBuffers", "setGeneric", "clearBindings", "setLocations", "setGenericValues", "setDivisor", "enable", "disable"];
class QAn {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = n.id || n.program && n.program.id;
    this.id = r, this.gl = e, this.configuration = null, this.elements = null, this.elementsAccessor = null, this.values = null, this.accessors = null, this.unused = null, this.drawParams = null, this.buffer = null, this.attributes = {}, this.vertexArrayObject = new If(e), G9e(this, "VertexArray", "v6.0", SAn), this.initialize(n), Object.seal(this);
  }
  delete() {
    this.buffer && this.buffer.delete(), this.vertexArrayObject.delete();
  }
  initialize() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.reset(), this.configuration = null, this.bindOnUse = !1, this.setProps(e);
  }
  reset() {
    this.elements = null, this.elementsAccessor = null;
    const {
      MAX_ATTRIBUTES: e
    } = this.vertexArrayObject;
    return this.values = new Array(e).fill(null), this.accessors = new Array(e).fill(null), this.unused = {}, this.drawParams = null, this;
  }
  setProps(e) {
    return "program" in e && (this.configuration = e.program && e.program.configuration), "configuration" in e && (this.configuration = e.configuration), "attributes" in e && this.setAttributes(e.attributes), "elements" in e && this.setElementBuffer(e.elements), "bindOnUse" in e && (e = e.bindOnUse), this;
  }
  clearDrawParams() {
    this.drawParams = null;
  }
  getDrawParams() {
    return this.drawParams = this.drawParams || this._updateDrawParams(), this.drawParams;
  }
  setAttributes(e) {
    return Object.assign(this.attributes, e), this.vertexArrayObject.bind(() => {
      for (const n in e) {
        const r = e[n];
        this._setAttribute(n, r);
      }
      this.gl.bindBuffer(34962, null);
    }), this;
  }
  setElementBuffer() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.elements = e, this.elementsAccessor = n, this.clearDrawParams(), this.vertexArrayObject.setElementBuffer(e, n), this;
  }
  setBuffer(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (n.target === 34963)
      return this.setElementBuffer(n, r);
    const {
      location: i,
      accessor: o
    } = this._resolveLocationAndAccessor(e, n, n.accessor, r);
    return i >= 0 && (this.values[i] = n, this.accessors[i] = o, this.clearDrawParams(), this.vertexArrayObject.setBuffer(i, n, o)), this;
  }
  setConstant(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const {
      location: i,
      accessor: o
    } = this._resolveLocationAndAccessor(e, n, Object.assign({
      size: n.length
    }, r));
    return i >= 0 && (n = this.vertexArrayObject._normalizeConstantArrayValue(n), this.values[i] = n, this.accessors[i] = o, this.clearDrawParams(), this.vertexArrayObject.enable(i, !1)), this;
  }
  unbindBuffers() {
    return this.vertexArrayObject.bind(() => {
      this.elements && this.vertexArrayObject.setElementBuffer(null), this.buffer = this.buffer || new ro(this.gl, {
        accessor: {
          size: 4
        }
      });
      for (let e = 0; e < this.vertexArrayObject.MAX_ATTRIBUTES; e++)
        this.values[e] instanceof ro && (this.gl.disableVertexAttribArray(e), this.gl.bindBuffer(34962, this.buffer.handle), this.gl.vertexAttribPointer(e, 1, 5126, !1, 0, 0));
    }), this;
  }
  bindBuffers() {
    return this.vertexArrayObject.bind(() => {
      this.elements && this.setElementBuffer(this.elements);
      for (let e = 0; e < this.vertexArrayObject.MAX_ATTRIBUTES; e++) {
        const n = this.values[e];
        n instanceof ro && this.setBuffer(e, n);
      }
    }), this;
  }
  bindForDraw(e, n, r) {
    let i;
    return this.vertexArrayObject.bind(() => {
      this._setConstantAttributes(e, n), i = r();
    }), i;
  }
  _resolveLocationAndAccessor(e, n, r, i) {
    const o = {
      location: -1,
      accessor: null
    }, {
      location: s,
      name: a
    } = this._getAttributeIndex(e);
    if (!Number.isFinite(s) || s < 0)
      return this.unused[e] = n, On.once(3, () => "unused value ".concat(e, " in ").concat(this.id))(), o;
    const A = this._getAttributeInfo(a || s);
    if (!A)
      return o;
    const l = this.accessors[s] || {}, c = yu.resolve(A.accessor, l, r, i), {
      size: u,
      type: f
    } = c;
    return dn(Number.isFinite(u) && Number.isFinite(f)), {
      location: s,
      accessor: c
    };
  }
  _getAttributeInfo(e) {
    return this.configuration && this.configuration.getAttributeInfo(e);
  }
  _getAttributeIndex(e) {
    const n = Number(e);
    if (Number.isFinite(n))
      return {
        location: n
      };
    const r = _An.exec(e), i = r ? r[1] : e, o = r ? Number(r[2]) : 0;
    return this.configuration ? {
      location: this.configuration.getAttributeLocation(i) + o,
      name: i
    } : {
      location: -1
    };
  }
  _setAttribute(e, n) {
    if (n instanceof ro)
      this.setBuffer(e, n);
    else if (Array.isArray(n) && n.length && n[0] instanceof ro) {
      const r = n[0], i = n[1];
      this.setBuffer(e, r, i);
    } else if (ArrayBuffer.isView(n) || Array.isArray(n)) {
      const r = n;
      this.setConstant(e, r);
    } else if (n.buffer instanceof ro) {
      const r = n;
      this.setBuffer(e, r.buffer, r);
    } else
      throw new Error(bAn);
  }
  _setConstantAttributes(e, n) {
    const r = Math.max(e | 0, n | 0);
    let i = this.values[0];
    ArrayBuffer.isView(i) && this._setConstantAttributeZero(i, r);
    for (let o = 1; o < this.vertexArrayObject.MAX_ATTRIBUTES; o++)
      i = this.values[o], ArrayBuffer.isView(i) && this._setConstantAttribute(o, i);
  }
  _setConstantAttributeZero(e, n) {
    if (If.isSupported(this.gl, {
      constantAttributeZero: !0
    })) {
      this._setConstantAttribute(0, e);
      return;
    }
    const r = this.vertexArrayObject.getConstantBuffer(n, e);
    this.vertexArrayObject.setBuffer(0, r, this.accessors[0]);
  }
  _setConstantAttribute(e, n) {
    If.setConstant(this.gl, e, n);
  }
  _updateDrawParams() {
    const e = {
      isIndexed: !1,
      isInstanced: !1,
      indexCount: 1 / 0,
      vertexCount: 1 / 0,
      instanceCount: 1 / 0
    };
    for (let n = 0; n < this.vertexArrayObject.MAX_ATTRIBUTES; n++)
      this._updateDrawParamsForLocation(e, n);
    return this.elements && (e.elementCount = this.elements.getElementCount(this.elements.accessor), e.isIndexed = !0, e.indexType = this.elementsAccessor.type || this.elements.accessor.type, e.indexOffset = this.elementsAccessor.offset || 0), e.indexCount === 1 / 0 && (e.indexCount = 0), e.vertexCount === 1 / 0 && (e.vertexCount = 0), e.instanceCount === 1 / 0 && (e.instanceCount = 0), e;
  }
  _updateDrawParamsForLocation(e, n) {
    const r = this.values[n], i = this.accessors[n];
    if (!r)
      return;
    const {
      divisor: o
    } = i, s = o > 0;
    if (e.isInstanced = e.isInstanced || s, r instanceof ro) {
      const a = r;
      if (s) {
        const A = a.getVertexCount(i);
        e.instanceCount = Math.min(e.instanceCount, A);
      } else {
        const A = a.getVertexCount(i);
        e.vertexCount = Math.min(e.vertexCount, A);
      }
    }
  }
  setElements() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return On.deprecated("setElements", "setElementBuffer")(), this.setElementBuffer(e, n);
  }
}
function wAn(t, e) {
  const {
    maxElts: n = 16,
    size: r = 1
  } = e;
  let i = "[";
  for (let s = 0; s < t.length && s < n; ++s)
    s > 0 && (i += ",".concat(s % r === 0 ? " " : "")), i += OT(t[s], e);
  const o = t.length > n ? "..." : "]";
  return "".concat(i).concat(o);
}
function OT(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const n = 1e-16, {
    isInteger: r = !1
  } = e;
  if (Array.isArray(t) || ArrayBuffer.isView(t))
    return wAn(t, e);
  if (!Number.isFinite(t))
    return String(t);
  if (Math.abs(t) < n)
    return r ? "0" : "0.";
  if (r || Math.abs(t) > 100 && Math.abs(t) < 1e4)
    return t.toFixed(0);
  const i = t.toPrecision(2);
  return i.indexOf(".0") === i.length - 2 ? i.slice(0, -1) : i;
}
function r_e(t) {
  let {
    header: e = "Uniforms",
    program: n,
    uniforms: r,
    undefinedOnly: i = !1
  } = t;
  dn(n);
  const o = ".*_.*", s = ".*Matrix", a = n._uniformSetters, A = {}, l = Object.keys(a).sort();
  let c = 0;
  for (const h of l)
    !h.match(o) && !h.match(s) && lV({
      table: A,
      header: e,
      uniforms: r,
      uniformName: h,
      undefinedOnly: i
    }) && c++;
  for (const h of l)
    h.match(s) && lV({
      table: A,
      header: e,
      uniforms: r,
      uniformName: h,
      undefinedOnly: i
    }) && c++;
  for (const h of l)
    A[h] || lV({
      table: A,
      header: e,
      uniforms: r,
      uniformName: h,
      undefinedOnly: i
    }) && c++;
  let u = 0;
  const f = {};
  if (!i)
    for (const h in r) {
      const d = r[h];
      A[h] || (u++, f[h] = {
        Type: "NOT USED: ".concat(d),
        [e]: OT(d)
      });
    }
  return {
    table: A,
    count: c,
    unusedTable: f,
    unusedCount: u
  };
}
function lV(t) {
  let {
    table: e,
    header: n,
    uniforms: r,
    uniformName: i,
    undefinedOnly: o
  } = t;
  const s = r[i], a = xAn(s);
  return !o || !a ? (e[i] = {
    [n]: a ? OT(s) : "N/A",
    "Uniform Type": a ? s : "NOT PROVIDED"
  }, !0) : !1;
}
function xAn(t) {
  return t != null;
}
function RAn(t) {
  let {
    vertexArray: e,
    header: n = "Attributes"
  } = t;
  if (!e.configuration)
    return {};
  const r = {};
  e.elements && (r.ELEMENT_ARRAY_BUFFER = i_e(e, e.elements, null, n));
  const i = e.values;
  for (const o in i) {
    const s = e._getAttributeInfo(o);
    if (s) {
      let a = "".concat(o, ": ").concat(s.name);
      const A = e.accessors[s.location];
      A && (a = "".concat(o, ": ").concat(DAn(s.name, A))), r[a] = i_e(e, i[o], A, n);
    }
  }
  return r;
}
function i_e(t, e, n, r) {
  const {
    gl: i
  } = t;
  if (!e)
    return {
      [r]: "null",
      "Format ": "N/A"
    };
  let o = "NOT PROVIDED", s = 1, a = 0, A = 0, l, c, u;
  if (n && (o = n.type, s = n.size, o = String(o).replace("Array", ""), l = o.indexOf("nt") !== -1), e instanceof ro) {
    const f = e, {
      data: h,
      changed: d
    } = f.getDebugData();
    c = d ? "*" : "", u = h, A = f.byteLength, a = A / h.BYTES_PER_ELEMENT / s;
    let I;
    if (n) {
      const m = n.divisor > 0;
      I = "".concat(m ? "I " : "P ", " ").concat(a, " (x").concat(s, "=").concat(A, " bytes ").concat(SC(i, o), ")");
    } else
      l = !0, I = "".concat(A, " bytes");
    return {
      [r]: "".concat(c).concat(OT(u, {
        size: s,
        isInteger: l
      })),
      "Format ": I
    };
  }
  return u = e, s = e.length, o = String(e.constructor.name).replace("Array", ""), l = o.indexOf("nt") !== -1, {
    [r]: "".concat(OT(u, {
      size: s,
      isInteger: l
    }), " (constant)"),
    "Format ": "".concat(s, "x").concat(o, " (constant)")
  };
}
function DAn(t, e) {
  const {
    type: n,
    size: r
  } = e, i = X9e(n, r);
  return i ? "".concat(t, " (").concat(i.name, ")") : t;
}
function TAn(t) {
  const e = {}, n = "Accessors for ".concat(t.id);
  for (const r of t.attributeInfos)
    if (r) {
      const i = o_e(r);
      e["in ".concat(i)] = {
        [n]: JSON.stringify(r.accessor)
      };
    }
  for (const r of t.varyingInfos)
    if (r) {
      const i = o_e(r);
      e["out ".concat(i)] = {
        [n]: JSON.stringify(r.accessor)
      };
    }
  return e;
}
function o_e(t) {
  const {
    type: e,
    size: n
  } = t.accessor, r = X9e(e, n);
  return r ? "".concat(r.name, " ").concat(t.name) : t.name;
}
const s_e = KI() && typeof document < "u";
let NAn = 0;
class Z9e {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      onCreateContext: n = (m) => mle(m),
      onAddHTML: r = null,
      onInitialize: i = () => {
      },
      onRender: o = () => {
      },
      onFinalize: s = () => {
      },
      onError: a,
      gl: A = null,
      glOptions: l = {},
      debug: c = !1,
      createFramebuffer: u = !1,
      autoResizeViewport: f = !0,
      autoResizeDrawingBuffer: h = !0,
      stats: d = sC.get("animation-loop-".concat(NAn++))
    } = e;
    let {
      useDevicePixels: I = !0
    } = e;
    "useDevicePixelRatio" in e && (On.deprecated("useDevicePixelRatio", "useDevicePixels")(), I = e.useDevicePixelRatio), this.props = {
      onCreateContext: n,
      onAddHTML: r,
      onInitialize: i,
      onRender: o,
      onFinalize: s,
      onError: a,
      gl: A,
      glOptions: l,
      debug: c,
      createFramebuffer: u
    }, this.gl = A, this.needsRedraw = null, this.timeline = null, this.stats = d, this.cpuTime = this.stats.get("CPU Time"), this.gpuTime = this.stats.get("GPU Time"), this.frameRate = this.stats.get("Frame Rate"), this._initialized = !1, this._running = !1, this._animationFrameId = null, this._nextFramePromise = null, this._resolveNextFrame = null, this._cpuStartTime = 0, this.setProps({
      autoResizeViewport: f,
      autoResizeDrawingBuffer: h,
      useDevicePixels: I
    }), this.start = this.start.bind(this), this.stop = this.stop.bind(this), this._pageLoadPromise = null, this._onMousemove = this._onMousemove.bind(this), this._onMouseleave = this._onMouseleave.bind(this);
  }
  delete() {
    this.stop(), this._setDisplay(null);
  }
  setNeedsRedraw(e) {
    return dn(typeof e == "string"), this.needsRedraw = this.needsRedraw || e, this;
  }
  setProps(e) {
    return "autoResizeViewport" in e && (this.autoResizeViewport = e.autoResizeViewport), "autoResizeDrawingBuffer" in e && (this.autoResizeDrawingBuffer = e.autoResizeDrawingBuffer), "useDevicePixels" in e && (this.useDevicePixels = e.useDevicePixels), this;
  }
  start() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (this._running)
      return this;
    this._running = !0;
    const n = this._getPageLoadPromise().then(() => !this._running || this._initialized ? null : (this._createWebGLContext(e), this._createFramebuffer(), this._startEventHandling(), this._initializeCallbackData(), this._updateCallbackData(), this._resizeCanvasDrawingBuffer(), this._resizeViewport(), this._gpuTimeQuery = mU.isSupported(this.gl, ["timers"]) ? new mU(this.gl) : null, this._initialized = !0, this.onInitialize(this.animationProps))).then((r) => {
      this._running && (this._addCallbackData(r || {}), r !== !1 && this._startLoop());
    });
    return this.props.onError && n.catch(this.props.onError), this;
  }
  redraw() {
    return this.isContextLost() ? this : (this._beginTimers(), this._setupFrame(), this._updateCallbackData(), this._renderFrame(this.animationProps), this._clearNeedsRedraw(), this.offScreen && this.gl.commit && this.gl.commit(), this._resolveNextFrame && (this._resolveNextFrame(this), this._nextFramePromise = null, this._resolveNextFrame = null), this._endTimers(), this);
  }
  stop() {
    return this._running && (this._finalizeCallbackData(), this._cancelAnimationFrame(this._animationFrameId), this._nextFramePromise = null, this._resolveNextFrame = null, this._animationFrameId = null, this._running = !1), this;
  }
  attachTimeline(e) {
    return this.timeline = e, this.timeline;
  }
  detachTimeline() {
    this.timeline = null;
  }
  waitForRender() {
    return this.setNeedsRedraw("waitForRender"), this._nextFramePromise || (this._nextFramePromise = new Promise((e) => {
      this._resolveNextFrame = e;
    })), this._nextFramePromise;
  }
  async toDataURL() {
    return this.setNeedsRedraw("toDataURL"), await this.waitForRender(), this.gl.canvas.toDataURL();
  }
  isContextLost() {
    return this.gl.isContextLost();
  }
  onCreateContext() {
    return this.props.onCreateContext(...arguments);
  }
  onInitialize() {
    return this.props.onInitialize(...arguments);
  }
  onRender() {
    return this.props.onRender(...arguments);
  }
  onFinalize() {
    return this.props.onFinalize(...arguments);
  }
  getHTMLControlValue(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    const r = document.getElementById(e);
    return r ? Number(r.value) : n;
  }
  setViewParameters() {
    return On.removed("AnimationLoop.setViewParameters", "AnimationLoop.setProps")(), this;
  }
  _startLoop() {
    const e = () => {
      this._running && (this.redraw(), this._animationFrameId = this._requestAnimationFrame(e));
    };
    this._cancelAnimationFrame(this._animationFrameId), this._animationFrameId = this._requestAnimationFrame(e);
  }
  _getPageLoadPromise() {
    return this._pageLoadPromise || (this._pageLoadPromise = s_e ? new Promise((e, n) => {
      if (s_e && document.readyState === "complete") {
        e(document);
        return;
      }
      window.addEventListener("load", () => {
        e(document);
      });
    }) : Promise.resolve({})), this._pageLoadPromise;
  }
  _setDisplay(e) {
    this.display && (this.display.delete(), this.display.animationLoop = null), e && (e.animationLoop = this), this.display = e;
  }
  _cancelAnimationFrame(e) {
    return this.display && this.display.cancelAnimationFrame ? this.display.cancelAnimationFrame(e) : $sn(e);
  }
  _requestAnimationFrame(e) {
    if (this._running)
      return this.display && this.display.requestAnimationFrame ? this.display.requestAnimationFrame(e) : Hsn(e);
  }
  _renderFrame() {
    if (this.display) {
      this.display._renderFrame(...arguments);
      return;
    }
    this.onRender(...arguments);
  }
  _clearNeedsRedraw() {
    this.needsRedraw = null;
  }
  _setupFrame() {
    this._resizeCanvasDrawingBuffer(), this._resizeViewport(), this._resizeFramebuffer();
  }
  _initializeCallbackData() {
    this.animationProps = {
      gl: this.gl,
      stop: this.stop,
      canvas: this.gl.canvas,
      framebuffer: this.framebuffer,
      useDevicePixels: this.useDevicePixels,
      needsRedraw: null,
      startTime: Date.now(),
      engineTime: 0,
      tick: 0,
      tock: 0,
      time: 0,
      _timeline: this.timeline,
      _loop: this,
      _animationLoop: this,
      _mousePosition: null
    };
  }
  _updateCallbackData() {
    const {
      width: e,
      height: n,
      aspect: r
    } = this._getSizeAndAspect();
    (e !== this.animationProps.width || n !== this.animationProps.height) && this.setNeedsRedraw("drawing buffer resized"), r !== this.animationProps.aspect && this.setNeedsRedraw("drawing buffer aspect changed"), this.animationProps.width = e, this.animationProps.height = n, this.animationProps.aspect = r, this.animationProps.needsRedraw = this.needsRedraw, this.animationProps.engineTime = Date.now() - this.animationProps.startTime, this.timeline && this.timeline.update(this.animationProps.engineTime), this.animationProps.tick = Math.floor(this.animationProps.time / 1e3 * 60), this.animationProps.tock++, this.animationProps.time = this.timeline ? this.timeline.getTime() : this.animationProps.engineTime, this.animationProps._offScreen = this.offScreen;
  }
  _finalizeCallbackData() {
    this.onFinalize(this.animationProps);
  }
  _addCallbackData(e) {
    typeof e == "object" && e !== null && (this.animationProps = Object.assign({}, this.animationProps, e));
  }
  _createWebGLContext(e) {
    if (this.offScreen = e.canvas && typeof OffscreenCanvas < "u" && e.canvas instanceof OffscreenCanvas, e = Object.assign({}, e, this.props.glOptions), this.gl = this.props.gl ? Z9(this.props.gl, e) : this.onCreateContext(e), !oM(this.gl))
      throw new Error("AnimationLoop.onCreateContext - illegal context returned");
    P9e(this.gl), this._createInfoDiv();
  }
  _createInfoDiv() {
    if (this.gl.canvas && this.props.onAddHTML) {
      const e = document.createElement("div");
      document.body.appendChild(e), e.style.position = "relative";
      const n = document.createElement("div");
      n.style.position = "absolute", n.style.left = "10px", n.style.bottom = "10px", n.style.width = "300px", n.style.background = "white", e.appendChild(this.gl.canvas), e.appendChild(n);
      const r = this.props.onAddHTML(n);
      r && (n.innerHTML = r);
    }
  }
  _getSizeAndAspect() {
    const e = this.gl.drawingBufferWidth, n = this.gl.drawingBufferHeight;
    let r = 1;
    const {
      canvas: i
    } = this.gl;
    return i && i.clientHeight ? r = i.clientWidth / i.clientHeight : e > 0 && n > 0 && (r = e / n), {
      width: e,
      height: n,
      aspect: r
    };
  }
  _resizeViewport() {
    this.autoResizeViewport && this.gl.viewport(0, 0, this.gl.drawingBufferWidth, this.gl.drawingBufferHeight);
  }
  _resizeCanvasDrawingBuffer() {
    this.autoResizeDrawingBuffer && Lsn(this.gl, {
      useDevicePixels: this.useDevicePixels
    });
  }
  _createFramebuffer() {
    this.props.createFramebuffer && (this.framebuffer = new Da(this.gl));
  }
  _resizeFramebuffer() {
    this.framebuffer && this.framebuffer.resize({
      width: this.gl.drawingBufferWidth,
      height: this.gl.drawingBufferHeight
    });
  }
  _beginTimers() {
    this.frameRate.timeEnd(), this.frameRate.timeStart(), this._gpuTimeQuery && this._gpuTimeQuery.isResultAvailable() && !this._gpuTimeQuery.isTimerDisjoint() && this.stats.get("GPU Time").addTime(this._gpuTimeQuery.getTimerMilliseconds()), this._gpuTimeQuery && this._gpuTimeQuery.beginTimeElapsedQuery(), this.cpuTime.timeStart();
  }
  _endTimers() {
    this.cpuTime.timeEnd(), this._gpuTimeQuery && this._gpuTimeQuery.end();
  }
  _startEventHandling() {
    const {
      canvas: e
    } = this.gl;
    e && (e.addEventListener("mousemove", this._onMousemove), e.addEventListener("mouseleave", this._onMouseleave));
  }
  _onMousemove(e) {
    this.animationProps._mousePosition = [e.offsetX, e.offsetY];
  }
  _onMouseleave(e) {
    this.animationProps._mousePosition = null;
  }
}
const lM = "vs", Sle = "fs";
function Nf(t, e) {
  if (!t)
    throw new Error(e || "shadertools: assertion failed.");
}
const cV = {
  number: {
    validate(t, e) {
      return Number.isFinite(t) && (!("max" in e) || t <= e.max) && (!("min" in e) || t >= e.min);
    }
  },
  array: {
    validate(t, e) {
      return Array.isArray(t) || ArrayBuffer.isView(t);
    }
  }
};
function LAn(t) {
  const e = {};
  for (const n in t) {
    const r = t[n], i = MAn(r);
    e[n] = i;
  }
  return e;
}
function MAn(t) {
  let e = a_e(t);
  return e === "object" ? t ? "type" in t ? Object.assign({}, t, cV[t.type]) : "value" in t ? (e = a_e(t.value), Object.assign({
    type: e
  }, t, cV[e])) : {
    type: "object",
    value: t
  } : {
    type: "object",
    value: null
  } : Object.assign({
    type: e,
    value: t
  }, cV[e]);
}
function a_e(t) {
  return Array.isArray(t) || ArrayBuffer.isView(t) ? "array" : typeof t;
}
const OAn = "vs", FAn = "fs";
class kee {
  constructor(e) {
    let {
      name: n,
      vs: r,
      fs: i,
      dependencies: o = [],
      uniforms: s,
      getUniforms: a,
      deprecations: A = [],
      defines: l = {},
      inject: c = {},
      vertexShader: u,
      fragmentShader: f
    } = e;
    Nf(typeof n == "string"), this.name = n, this.vs = r || u, this.fs = i || f, this.getModuleUniforms = a, this.dependencies = o, this.deprecations = this._parseDeprecationDefinitions(A), this.defines = l, this.injections = PAn(c), s && (this.uniforms = LAn(s));
  }
  getModuleSource(e) {
    let n;
    switch (e) {
      case OAn:
        n = this.vs || "";
        break;
      case FAn:
        n = this.fs || "";
        break;
      default:
        Nf(!1);
    }
    return "#define MODULE_".concat(this.name.toUpperCase().replace(/[^0-9a-z]/gi, "_"), `
`).concat(n, "// END MODULE_").concat(this.name, `

`);
  }
  getUniforms(e, n) {
    return this.getModuleUniforms ? this.getModuleUniforms(e, n) : this.uniforms ? this._defaultGetUniforms(e) : {};
  }
  getDefines() {
    return this.defines;
  }
  checkDeprecations(e, n) {
    this.deprecations.forEach((r) => {
      r.regex.test(e) && (r.deprecated ? n.deprecated(r.old, r.new)() : n.removed(r.old, r.new)());
    });
  }
  _parseDeprecationDefinitions(e) {
    return e.forEach((n) => {
      switch (n.type) {
        case "function":
          n.regex = new RegExp("\\b".concat(n.old, "\\("));
          break;
        default:
          n.regex = new RegExp("".concat(n.type, " ").concat(n.old, ";"));
      }
    }), e;
  }
  _defaultGetUniforms() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = {}, r = this.uniforms;
    for (const i in r) {
      const o = r[i];
      i in e && !o.private ? (o.validate && Nf(o.validate(e[i], o), "".concat(this.name, ": invalid ").concat(i)), n[i] = e[i]) : n[i] = o.value;
    }
    return n;
  }
}
function e$e(t) {
  if (!t.normalized && (t.normalized = !0, t.uniforms && !t.getUniforms)) {
    const e = new kee(t);
    t.getUniforms = e.getUniforms.bind(e);
  }
  return t;
}
function PAn(t) {
  const e = {
    vs: {},
    fs: {}
  };
  for (const n in t) {
    let r = t[n];
    const i = n.slice(0, 2);
    typeof r == "string" && (r = {
      order: 0,
      injection: r
    }), e[i][n] = r;
  }
  return e;
}
function kAn(t) {
  return GAn(n$e(t));
}
function GAn(t) {
  const e = {}, n = {};
  return t$e({
    modules: t,
    level: 0,
    moduleMap: e,
    moduleDepth: n
  }), Object.keys(n).sort((r, i) => n[i] - n[r]).map((r) => e[r]);
}
function t$e(t) {
  let {
    modules: e,
    level: n,
    moduleMap: r,
    moduleDepth: i
  } = t;
  if (n >= 5)
    throw new Error("Possible loop in shader dependency graph");
  for (const o of e)
    r[o.name] = o, (i[o.name] === void 0 || i[o.name] < n) && (i[o.name] = n);
  for (const o of e)
    o.dependencies && t$e({
      modules: o.dependencies,
      level: n + 1,
      moduleMap: r,
      moduleDepth: i
    });
}
function n$e(t, e) {
  return t.map((n) => (n instanceof kee || (Nf(typeof n != "string", "Shader module use by name is deprecated. Import shader module '".concat(n, "' and use it directly.")), Nf(n.name, "shader module has no name"), n = new kee(n), n.dependencies = n$e(n.dependencies)), n));
}
function UAn() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const e = typeof window < "u" ? window.navigator || {} : {}, n = t.userAgent || e.userAgent || "", r = n.indexOf("MSIE ") !== -1, i = n.indexOf("Trident/") !== -1;
  return r || i;
}
const HAn = 7936, $An = 7937, qAn = 7938, jAn = 35724, Qle = {
  GLSL_FRAG_DATA: ["WEBGL_draw_buffers", !0],
  GLSL_FRAG_DEPTH: ["EXT_frag_depth", !0],
  GLSL_DERIVATIVES: ["OES_standard_derivatives", !0],
  GLSL_TEXTURE_LOD: ["EXT_shader_texture_lod", !0]
}, Uy = {};
Object.keys(Qle).forEach((t) => {
  Uy[t] = t;
});
function YAn(t) {
  return typeof WebGL2RenderingContext < "u" && t instanceof WebGL2RenderingContext ? !0 : !!(t && t._version === 2);
}
function zAn(t) {
  const e = t.getExtension("WEBGL_debug_renderer_info"), n = t.getParameter(e && e.UNMASKED_VENDOR_WEBGL || HAn), r = t.getParameter(e && e.UNMASKED_RENDERER_WEBGL || $An);
  return {
    gpuVendor: VAn(n, r),
    vendor: n,
    renderer: r,
    version: t.getParameter(qAn),
    shadingLanguageVersion: t.getParameter(jAn)
  };
}
function VAn(t, e) {
  return t.match(/NVIDIA/i) || e.match(/NVIDIA/i) ? "NVIDIA" : t.match(/INTEL/i) || e.match(/INTEL/i) ? "INTEL" : t.match(/AMD/i) || e.match(/AMD/i) || t.match(/ATI/i) || e.match(/ATI/i) ? "AMD" : "UNKNOWN GPU";
}
const uV = {};
function A_e(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const r = Qle[e];
  if (Nf(r, e), !UAn(n))
    return !0;
  if (e in uV)
    return uV[e];
  const i = r[0], o = n.behavior || "enable", s = "#extension GL_".concat(i, " : ").concat(o, `
void main(void) {}`), a = t.createShader(35633);
  t.shaderSource(a, s), t.compileShader(a);
  const A = t.getShaderParameter(a, 35713);
  return t.deleteShader(a), uV[e] = A, A;
}
function JAn(t, e) {
  const n = Qle[e];
  Nf(n, e);
  const r = YAn(t) && n[1] || n[0], i = typeof r == "string" ? !!t.getExtension(r) : r;
  return Nf(i === !1 || i === !0), i;
}
function YF(t, e) {
  return e = Array.isArray(e) ? e : [e], e.every((n) => JAn(t, n));
}
function KAn(t) {
  switch (zAn(t).gpuVendor.toLowerCase()) {
    case "nvidia":
      return `#define NVIDIA_GPU
// Nvidia optimizes away the calculation necessary for emulated fp64
#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1
`;
    case "intel":
      return `#define INTEL_GPU
// Intel optimizes away the calculation necessary for emulated fp64
#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1
// Intel's built-in 'tan' function doesn't have acceptable precision
#define LUMA_FP32_TAN_PRECISION_WORKAROUND 1
// Intel GPU doesn't have full 32 bits precision in same cases, causes overflow
#define LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND 1
`;
    case "amd":
      return `#define AMD_GPU
`;
    default:
      return `#define DEFAULT_GPU
// Prevent driver from optimizing away the calculation necessary for emulated fp64
#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1
// Intel's built-in 'tan' function doesn't have acceptable precision
#define LUMA_FP32_TAN_PRECISION_WORKAROUND 1
// Intel GPU doesn't have full 32 bits precision in same cases, causes overflow
#define LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND 1
`;
  }
}
function WAn(t, e, n) {
  let r = `#if (__VERSION__ > 120)

# define FEATURE_GLSL_DERIVATIVES
# define FEATURE_GLSL_DRAW_BUFFERS
# define FEATURE_GLSL_FRAG_DEPTH
# define FEATURE_GLSL_TEXTURE_LOD

// DEPRECATED FLAGS, remove in v9
# define FRAG_DEPTH
# define DERIVATIVES
# define DRAW_BUFFERS
# define TEXTURE_LOD

#endif // __VERSION
`;
  return YF(t, Uy.GLSL_FRAG_DEPTH) && (r += `
// FRAG_DEPTH => gl_FragDepth is available
#ifdef GL_EXT_frag_depth
#extension GL_EXT_frag_depth : enable
# define FEATURE_GLSL_FRAG_DEPTH
# define FRAG_DEPTH
# define gl_FragDepth gl_FragDepthEXT
#endif
`), YF(t, Uy.GLSL_DERIVATIVES) && A_e(t, Uy.GLSL_DERIVATIVES) && (r += `
// DERIVATIVES => dxdF, dxdY and fwidth are available
#ifdef GL_OES_standard_derivatives
#extension GL_OES_standard_derivatives : enable
# define FEATURE_GLSL_DERIVATIVES
# define DERIVATIVES
#endif
`), YF(t, Uy.GLSL_FRAG_DATA) && A_e(t, Uy.GLSL_FRAG_DATA, {
    behavior: "require"
  }) && (r += `
// DRAW_BUFFERS => gl_FragData[] is available
#ifdef GL_EXT_draw_buffers
#extension GL_EXT_draw_buffers : require
#define FEATURE_GLSL_DRAW_BUFFERS
#define DRAW_BUFFERS
#endif
`), YF(t, Uy.GLSL_TEXTURE_LOD) && (r += `// TEXTURE_LOD => texture2DLod etc are available
#ifdef GL_EXT_shader_texture_lod
#extension GL_EXT_shader_texture_lod : enable

# define FEATURE_GLSL_TEXTURE_LOD
# define TEXTURE_LOD

#endif
`), r;
}
const XAn = `#ifdef MODULE_LOGDEPTH
  logdepth_adjustPosition(gl_Position);
#endif
`, ZAn = `#ifdef MODULE_MATERIAL
  gl_FragColor = material_filterColor(gl_FragColor);
#endif

#ifdef MODULE_LIGHTING
  gl_FragColor = lighting_filterColor(gl_FragColor);
#endif

#ifdef MODULE_FOG
  gl_FragColor = fog_filterColor(gl_FragColor);
#endif

#ifdef MODULE_PICKING
  gl_FragColor = picking_filterHighlightColor(gl_FragColor);
  gl_FragColor = picking_filterPickingColor(gl_FragColor);
#endif

#ifdef MODULE_LOGDEPTH
  logdepth_setFragDepth();
#endif
`, eln = {
  [lM]: XAn,
  [Sle]: ZAn
}, Qk = "__LUMA_INJECT_DECLARATIONS__", l_e = /void\s+main\s*\([^)]*\)\s*\{\n?/, c_e = /}\n?[^{}]*$/, fV = [];
function u_e(t, e, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  const i = e === lM;
  for (const o in n) {
    const s = n[o];
    s.sort((A, l) => A.order - l.order), fV.length = s.length;
    for (let A = 0, l = s.length; A < l; ++A)
      fV[A] = s[A].injection;
    const a = "".concat(fV.join(`
`), `
`);
    switch (o) {
      case "vs:#decl":
        i && (t = t.replace(Qk, a));
        break;
      case "vs:#main-start":
        i && (t = t.replace(l_e, (A) => A + a));
        break;
      case "vs:#main-end":
        i && (t = t.replace(c_e, (A) => a + A));
        break;
      case "fs:#decl":
        i || (t = t.replace(Qk, a));
        break;
      case "fs:#main-start":
        i || (t = t.replace(l_e, (A) => A + a));
        break;
      case "fs:#main-end":
        i || (t = t.replace(c_e, (A) => a + A));
        break;
      default:
        t = t.replace(o, (A) => A + a);
    }
  }
  return t = t.replace(Qk, ""), r && (t = t.replace(/\}\s*$/, (o) => o + eln[e])), t;
}
function Gee(t) {
  const e = {};
  return Nf(Array.isArray(t) && t.length > 1), t.forEach((n) => {
    for (const r in n)
      e[r] = e[r] ? "".concat(e[r], `
`).concat(n[r]) : n[r];
  }), e;
}
function US(t) {
  return new RegExp("\\b".concat(t, "[ \\t]+(\\w+[ \\t]+\\w+(\\[\\w+\\])?;)"), "g");
}
const r$e = [[/^(#version[ \t]+(100|300[ \t]+es))?[ \t]*\n/, `#version 300 es
`], [/\btexture(2D|2DProj|Cube)Lod(EXT)?\(/g, "textureLod("], [/\btexture(2D|2DProj|Cube)(EXT)?\(/g, "texture("]], tln = [...r$e, [US("attribute"), "in $1"], [US("varying"), "out $1"]], nln = [...r$e, [US("varying"), "in $1"]], i$e = [[/^#version[ \t]+300[ \t]+es/, "#version 100"], [/\btexture(2D|2DProj|Cube)Lod\(/g, "texture$1LodEXT("], [/\btexture\(/g, "texture2D("], [/\btextureLod\(/g, "texture2DLodEXT("]], rln = [...i$e, [US("in"), "attribute $1"], [US("out"), "varying $1"]], iln = [...i$e, [US("in"), "varying $1"]], Uee = "gl_FragColor", Hee = /\bout[ \t]+vec4[ \t]+(\w+)[ \t]*;\n?/, oln = /void\s+main\s*\([^)]*\)\s*\{\n?/;
function sln(t, e, n) {
  switch (e) {
    case 300:
      return n ? CU(t, tln) : aln(t);
    case 100:
      return n ? CU(t, rln) : Aln(t);
    default:
      throw new Error("unknown GLSL version ".concat(e));
  }
}
function CU(t, e) {
  for (const [n, r] of e)
    t = t.replace(n, r);
  return t;
}
function aln(t) {
  t = CU(t, nln);
  const e = t.match(Hee);
  if (e) {
    const n = e[1];
    t = t.replace(new RegExp("\\b".concat(Uee, "\\b"), "g"), n);
  } else {
    const n = "fragmentColor";
    t = t.replace(oln, (r) => "out vec4 ".concat(n, `;
`).concat(r)).replace(new RegExp("\\b".concat(Uee, "\\b"), "g"), n);
  }
  return t;
}
function Aln(t) {
  t = CU(t, iln);
  const e = t.match(Hee);
  if (e) {
    const n = e[1];
    t = t.replace(Hee, "").replace(new RegExp("\\b".concat(n, "\\b"), "g"), Uee);
  }
  return t;
}
const lln = `

`.concat(Qk, `

`), o$e = {
  [lM]: "vertex",
  [Sle]: "fragment"
}, cln = `precision highp float;

`;
function uln(t, e) {
  const {
    vs: n,
    fs: r
  } = e, i = kAn(e.modules || []);
  return {
    gl: t,
    vs: f_e(t, Object.assign({}, e, {
      source: n,
      type: lM,
      modules: i
    })),
    fs: f_e(t, Object.assign({}, e, {
      source: r,
      type: Sle,
      modules: i
    })),
    getUniforms: fln(i)
  };
}
function f_e(t, e) {
  let {
    id: n,
    source: r,
    type: i,
    modules: o,
    defines: s = {},
    hookFunctions: a = [],
    inject: A = {},
    transpileToGLSL100: l = !1,
    prologue: c = !0,
    log: u
  } = e;
  Nf(typeof r == "string", "shader source must be a string");
  const f = i === lM, h = r.split(`
`);
  let d = 100, I = "", m = r;
  h[0].indexOf("#version ") === 0 ? (d = 300, I = h[0], m = h.slice(1).join(`
`)) : I = "#version ".concat(d);
  const C = {};
  o.forEach((R) => {
    Object.assign(C, R.getDefines());
  }), Object.assign(C, s);
  let y = c ? "".concat(I, `
`).concat(hln({
    id: n,
    source: r,
    type: i
  }), `
`).concat(gln({
    type: i
  }), `
`).concat(KAn(t), `
`).concat(WAn(t), `
`).concat(dln(C), `
`).concat(f ? "" : cln, `
`) : "".concat(I, `
`);
  const v = Iln(a), b = {}, Q = {}, w = {};
  for (const R in A) {
    const M = typeof A[R] == "string" ? {
      injection: A[R],
      order: 0
    } : A[R], O = R.match(/^(v|f)s:(#)?([\w-]+)$/);
    if (O) {
      const L = O[2], N = O[3];
      L ? N === "decl" ? Q[R] = [M] : w[R] = [M] : b[R] = [M];
    } else
      w[R] = [M];
  }
  for (const R of o) {
    u && R.checkDeprecations(m, u);
    const M = R.getModuleSource(i, d);
    y += M;
    const O = R.injections[i];
    for (const L in O) {
      const N = L.match(/^(v|f)s:#([\w-]+)$/);
      if (N) {
        const $ = N[2] === "decl" ? Q : w;
        $[L] = $[L] || [], $[L].push(O[L]);
      } else
        b[L] = b[L] || [], b[L].push(O[L]);
    }
  }
  return y += lln, y = u_e(y, i, Q), y += pln(v[i], b), y += m, y = u_e(y, i, w), y = sln(y, l ? 100 : d, f), y;
}
function fln(t) {
  return function(n) {
    const r = {};
    for (const i of t) {
      const o = i.getUniforms(n, r);
      Object.assign(r, o);
    }
    return r;
  };
}
function gln(t) {
  let {
    type: e
  } = t;
  return `
#define SHADER_TYPE_`.concat(o$e[e].toUpperCase(), `
`);
}
function hln(t) {
  let {
    id: e,
    source: n,
    type: r
  } = t;
  return e && typeof e == "string" && n.indexOf("SHADER_NAME") === -1 ? `
#define SHADER_NAME `.concat(e, "_").concat(o$e[r], `

`) : "";
}
function dln() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = 0, n = "";
  for (const r in t) {
    e === 0 && (n += `
// APPLICATION DEFINES
`), e++;
    const i = t[r];
    (i || Number.isFinite(i)) && (n += "#define ".concat(r.toUpperCase(), " ").concat(t[r], `
`));
  }
  return e === 0 && (n += `
`), n;
}
function pln(t, e) {
  let n = "";
  for (const r in t) {
    const i = t[r];
    if (n += "void ".concat(i.signature, ` {
`), i.header && (n += "  ".concat(i.header)), e[r]) {
      const o = e[r];
      o.sort((s, a) => s.order - a.order);
      for (const s of o)
        n += "  ".concat(s.injection, `
`);
    }
    i.footer && (n += "  ".concat(i.footer)), n += `}
`;
  }
  return n;
}
function Iln(t) {
  const e = {
    vs: {},
    fs: {}
  };
  return t.forEach((n) => {
    let r;
    typeof n != "string" ? (r = n, n = r.hook) : r = {}, n = n.trim();
    const [i, o] = n.split(":"), s = n.replace(/\(.+/, "");
    e[i][s] = Object.assign(r, {
      signature: o
    });
  }), e;
}
const mln = "void main() {gl_FragColor = vec4(0);}", s$e = `out vec4 transform_output;
void main() {
  transform_output = vec4(0);
}`, Cln = `#version 300 es
`.concat(s$e);
function a$e(t, e) {
  e = Array.isArray(e) ? e : [e];
  const n = t.replace(/^\s+/, "").split(/\s+/), [r, i, o] = n;
  if (!e.includes(r) || !i || !o)
    return null;
  const s = o.split(";")[0];
  return {
    qualifier: r,
    type: i,
    name: s
  };
}
function A$e() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    version: e = 100,
    input: n,
    inputType: r,
    output: i
  } = t;
  if (!n)
    return e === 300 ? Cln : e > 300 ? "#version ".concat(e, `
`).concat(s$e) : mln;
  const o = vln(n, r);
  return e >= 300 ? "#version ".concat(e, " ").concat(e === 300 ? "es" : "", `
in `).concat(r, " ").concat(n, `;
out vec4 `).concat(i, `;
void main() {
  `).concat(i, " = ").concat(o, `;
}`) : "varying ".concat(r, " ").concat(n, `;
void main() {
  gl_FragColor = `).concat(o, `;
}`);
}
function Eln(t) {
  switch (t) {
    case "float":
      return "x";
    case "vec2":
      return "xy";
    case "vec3":
      return "xyz";
    case "vec4":
      return "xyzw";
    default:
      return Nf(!1), null;
  }
}
function yln(t) {
  switch (t) {
    case "float":
      return 1;
    case "vec2":
      return 2;
    case "vec3":
      return 3;
    case "vec4":
      return 4;
    default:
      return Nf(!1), null;
  }
}
function vln(t, e) {
  switch (e) {
    case "float":
      return "vec4(".concat(t, ", 0.0, 0.0, 1.0)");
    case "vec2":
      return "vec4(".concat(t, ", 0.0, 1.0)");
    case "vec3":
      return "vec4(".concat(t, ", 1.0)");
    case "vec4":
      return t;
    default:
      return Nf(!1), null;
  }
}
const Bln = `#ifdef LUMA_FP32_TAN_PRECISION_WORKAROUND
const float TWO_PI = 6.2831854820251465;
const float PI_2 = 1.5707963705062866;
const float PI_16 = 0.1963495463132858;

const float SIN_TABLE_0 = 0.19509032368659973;
const float SIN_TABLE_1 = 0.3826834261417389;
const float SIN_TABLE_2 = 0.5555702447891235;
const float SIN_TABLE_3 = 0.7071067690849304;

const float COS_TABLE_0 = 0.9807852506637573;
const float COS_TABLE_1 = 0.9238795042037964;
const float COS_TABLE_2 = 0.8314695954322815;
const float COS_TABLE_3 = 0.7071067690849304;

const float INVERSE_FACTORIAL_3 = 1.666666716337204e-01;
const float INVERSE_FACTORIAL_5 = 8.333333767950535e-03;
const float INVERSE_FACTORIAL_7 = 1.9841270113829523e-04;
const float INVERSE_FACTORIAL_9 = 2.75573188446287533e-06;

float sin_taylor_fp32(float a) {
  float r, s, t, x;

  if (a == 0.0) {
    return 0.0;
  }

  x = -a * a;
  s = a;
  r = a;

  r = r * x;
  t = r * INVERSE_FACTORIAL_3;
  s = s + t;

  r = r * x;
  t = r * INVERSE_FACTORIAL_5;
  s = s + t;

  r = r * x;
  t = r * INVERSE_FACTORIAL_7;
  s = s + t;

  r = r * x;
  t = r * INVERSE_FACTORIAL_9;
  s = s + t;

  return s;
}

void sincos_taylor_fp32(float a, out float sin_t, out float cos_t) {
  if (a == 0.0) {
    sin_t = 0.0;
    cos_t = 1.0;
  }
  sin_t = sin_taylor_fp32(a);
  cos_t = sqrt(1.0 - sin_t * sin_t);
}

float tan_taylor_fp32(float a) {
    float sin_a;
    float cos_a;

    if (a == 0.0) {
        return 0.0;
    }
    float z = floor(a / TWO_PI);
    float r = a - TWO_PI * z;

    float t;
    float q = floor(r / PI_2 + 0.5);
    int j = int(q);

    if (j < -2 || j > 2) {
        return 1.0 / 0.0;
    }

    t = r - PI_2 * q;

    q = floor(t / PI_16 + 0.5);
    int k = int(q);
    int abs_k = int(abs(float(k)));

    if (abs_k > 4) {
        return 1.0 / 0.0;
    } else {
        t = t - PI_16 * q;
    }

    float u = 0.0;
    float v = 0.0;

    float sin_t, cos_t;
    float s, c;
    sincos_taylor_fp32(t, sin_t, cos_t);

    if (k == 0) {
        s = sin_t;
        c = cos_t;
    } else {
        if (abs(float(abs_k) - 1.0) < 0.5) {
            u = COS_TABLE_0;
            v = SIN_TABLE_0;
        } else if (abs(float(abs_k) - 2.0) < 0.5) {
            u = COS_TABLE_1;
            v = SIN_TABLE_1;
        } else if (abs(float(abs_k) - 3.0) < 0.5) {
            u = COS_TABLE_2;
            v = SIN_TABLE_2;
        } else if (abs(float(abs_k) - 4.0) < 0.5) {
            u = COS_TABLE_3;
            v = SIN_TABLE_3;
        }
        if (k > 0) {
            s = u * sin_t + v * cos_t;
            c = u * cos_t - v * sin_t;
        } else {
            s = u * sin_t - v * cos_t;
            c = u * cos_t + v * sin_t;
        }
    }

    if (j == 0) {
        sin_a = s;
        cos_a = c;
    } else if (j == 1) {
        sin_a = c;
        cos_a = -s;
    } else if (j == -1) {
        sin_a = -c;
        cos_a = s;
    } else {
        sin_a = -s;
        cos_a = -c;
    }
    return sin_a / cos_a;
}
#endif

float tan_fp32(float a) {
#ifdef LUMA_FP32_TAN_PRECISION_WORKAROUND
  return tan_taylor_fp32(a);
#else
  return tan(a);
#endif
}
`, l$e = {
  name: "fp32",
  vs: Bln,
  fs: null
};
function wle(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
  const r = Math.fround(t), i = t - r;
  return e[n] = r, e[n + 1] = i, e;
}
function c$e(t) {
  return t - Math.fround(t);
}
function u$e(t) {
  const e = new Float32Array(32);
  for (let n = 0; n < 4; ++n)
    for (let r = 0; r < 4; ++r) {
      const i = n * 4 + r;
      wle(t[r * 4 + n], e, i * 2);
    }
  return e;
}
const bln = `uniform float ONE;
vec2 split(float a) {
  const float SPLIT = 4097.0;
  float t = a * SPLIT;
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
  float a_hi = t * ONE - (t - a);
  float a_lo = a * ONE - a_hi;
#else
  float a_hi = t - (t - a);
  float a_lo = a - a_hi;
#endif
  return vec2(a_hi, a_lo);
}
vec2 split2(vec2 a) {
  vec2 b = split(a.x);
  b.y += a.y;
  return b;
}
vec2 quickTwoSum(float a, float b) {
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
  float sum = (a + b) * ONE;
  float err = b - (sum - a) * ONE;
#else
  float sum = a + b;
  float err = b - (sum - a);
#endif
  return vec2(sum, err);
}
vec2 twoSum(float a, float b) {
  float s = (a + b);
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
  float v = (s * ONE - a) * ONE;
  float err = (a - (s - v) * ONE) * ONE * ONE * ONE + (b - v);
#else
  float v = s - a;
  float err = (a - (s - v)) + (b - v);
#endif
  return vec2(s, err);
}

vec2 twoSub(float a, float b) {
  float s = (a - b);
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
  float v = (s * ONE - a) * ONE;
  float err = (a - (s - v) * ONE) * ONE * ONE * ONE - (b + v);
#else
  float v = s - a;
  float err = (a - (s - v)) - (b + v);
#endif
  return vec2(s, err);
}

vec2 twoSqr(float a) {
  float prod = a * a;
  vec2 a_fp64 = split(a);
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
  float err = ((a_fp64.x * a_fp64.x - prod) * ONE + 2.0 * a_fp64.x *
    a_fp64.y * ONE * ONE) + a_fp64.y * a_fp64.y * ONE * ONE * ONE;
#else
  float err = ((a_fp64.x * a_fp64.x - prod) + 2.0 * a_fp64.x * a_fp64.y) + a_fp64.y * a_fp64.y;
#endif
  return vec2(prod, err);
}

vec2 twoProd(float a, float b) {
  float prod = a * b;
  vec2 a_fp64 = split(a);
  vec2 b_fp64 = split(b);
  float err = ((a_fp64.x * b_fp64.x - prod) + a_fp64.x * b_fp64.y +
    a_fp64.y * b_fp64.x) + a_fp64.y * b_fp64.y;
  return vec2(prod, err);
}

vec2 sum_fp64(vec2 a, vec2 b) {
  vec2 s, t;
  s = twoSum(a.x, b.x);
  t = twoSum(a.y, b.y);
  s.y += t.x;
  s = quickTwoSum(s.x, s.y);
  s.y += t.y;
  s = quickTwoSum(s.x, s.y);
  return s;
}

vec2 sub_fp64(vec2 a, vec2 b) {
  vec2 s, t;
  s = twoSub(a.x, b.x);
  t = twoSub(a.y, b.y);
  s.y += t.x;
  s = quickTwoSum(s.x, s.y);
  s.y += t.y;
  s = quickTwoSum(s.x, s.y);
  return s;
}

vec2 mul_fp64(vec2 a, vec2 b) {
  vec2 prod = twoProd(a.x, b.x);
  prod.y += a.x * b.y;
#if defined(LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND)
  prod = split2(prod);
#endif
  prod = quickTwoSum(prod.x, prod.y);
  prod.y += a.y * b.x;
#if defined(LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND)
  prod = split2(prod);
#endif
  prod = quickTwoSum(prod.x, prod.y);
  return prod;
}

vec2 div_fp64(vec2 a, vec2 b) {
  float xn = 1.0 / b.x;
#if defined(LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND)
  vec2 yn = mul_fp64(a, vec2(xn, 0));
#else
  vec2 yn = a * xn;
#endif
  float diff = (sub_fp64(a, mul_fp64(b, yn))).x;
  vec2 prod = twoProd(xn, diff);
  return sum_fp64(yn, prod);
}

vec2 sqrt_fp64(vec2 a) {
  if (a.x == 0.0 && a.y == 0.0) return vec2(0.0, 0.0);
  if (a.x < 0.0) return vec2(0.0 / 0.0, 0.0 / 0.0);

  float x = 1.0 / sqrt(a.x);
  float yn = a.x * x;
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
  vec2 yn_sqr = twoSqr(yn) * ONE;
#else
  vec2 yn_sqr = twoSqr(yn);
#endif
  float diff = sub_fp64(a, yn_sqr).x;
  vec2 prod = twoProd(x * 0.5, diff);
#if defined(LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND)
  return sum_fp64(split(yn), prod);
#else
  return sum_fp64(vec2(yn, 0.0), prod);
#endif
}
`, _ln = `const vec2 E_FP64 = vec2(2.7182817459106445e+00, 8.254840366817007e-08);
const vec2 LOG2_FP64 = vec2(0.6931471824645996e+00, -1.9046542121259336e-09);
const vec2 PI_FP64 = vec2(3.1415927410125732, -8.742278012618954e-8);
const vec2 TWO_PI_FP64 = vec2(6.2831854820251465, -1.7484556025237907e-7);
const vec2 PI_2_FP64 = vec2(1.5707963705062866, -4.371139006309477e-8);
const vec2 PI_4_FP64 = vec2(0.7853981852531433, -2.1855695031547384e-8);
const vec2 PI_16_FP64 = vec2(0.19634954631328583, -5.463923757886846e-9);
const vec2 PI_16_2_FP64 = vec2(0.39269909262657166, -1.0927847515773692e-8);
const vec2 PI_16_3_FP64 = vec2(0.5890486240386963, -1.4906100798128818e-9);
const vec2 PI_180_FP64 = vec2(0.01745329238474369, 1.3519960498364902e-10);

const vec2 SIN_TABLE_0_FP64 = vec2(0.19509032368659973, -1.6704714833615242e-9);
const vec2 SIN_TABLE_1_FP64 = vec2(0.3826834261417389, 6.22335089017767e-9);
const vec2 SIN_TABLE_2_FP64 = vec2(0.5555702447891235, -1.1769521357507529e-8);
const vec2 SIN_TABLE_3_FP64 = vec2(0.7071067690849304, 1.2101617041793133e-8);

const vec2 COS_TABLE_0_FP64 = vec2(0.9807852506637573, 2.9739473106360492e-8);
const vec2 COS_TABLE_1_FP64 = vec2(0.9238795042037964, 2.8307490351764386e-8);
const vec2 COS_TABLE_2_FP64 = vec2(0.8314695954322815, 1.6870263741530778e-8);
const vec2 COS_TABLE_3_FP64 = vec2(0.7071067690849304, 1.2101617152815436e-8);

const vec2 INVERSE_FACTORIAL_3_FP64 = vec2(1.666666716337204e-01, -4.967053879312289e-09);
const vec2 INVERSE_FACTORIAL_4_FP64 = vec2(4.16666679084301e-02, -1.2417634698280722e-09);
const vec2 INVERSE_FACTORIAL_5_FP64 = vec2(8.333333767950535e-03, -4.34617203337595e-10);
const vec2 INVERSE_FACTORIAL_6_FP64 = vec2(1.3888889225199819e-03, -3.3631094437103215e-11);
const vec2 INVERSE_FACTORIAL_7_FP64 = vec2(1.9841270113829523e-04,  -2.725596874933456e-12);
const vec2 INVERSE_FACTORIAL_8_FP64 = vec2(2.4801587642286904e-05, -3.406996025904184e-13);
const vec2 INVERSE_FACTORIAL_9_FP64 = vec2(2.75573188446287533e-06, 3.7935713937038186e-14);
const vec2 INVERSE_FACTORIAL_10_FP64 = vec2(2.755731998149713e-07, -7.575112367869873e-15);

float nint(float d) {
    if (d == floor(d)) return d;
    return floor(d + 0.5);
}

vec2 nint_fp64(vec2 a) {
    float hi = nint(a.x);
    float lo;
    vec2 tmp;
    if (hi == a.x) {
        lo = nint(a.y);
        tmp = quickTwoSum(hi, lo);
    } else {
        lo = 0.0;
        if (abs(hi - a.x) == 0.5 && a.y < 0.0) {
            hi -= 1.0;
        }
        tmp = vec2(hi, lo);
    }
    return tmp;
}

vec2 exp_fp64(vec2 a) {

  const int k_power = 4;
  const float k = 16.0;

  const float inv_k = 1.0 / k;

  if (a.x <= -88.0) return vec2(0.0, 0.0);
  if (a.x >= 88.0) return vec2(1.0 / 0.0, 1.0 / 0.0);
  if (a.x == 0.0 && a.y == 0.0) return vec2(1.0, 0.0);
  if (a.x == 1.0 && a.y == 0.0) return E_FP64;

  float m = floor(a.x / LOG2_FP64.x + 0.5);
  vec2 r = sub_fp64(a, mul_fp64(LOG2_FP64, vec2(m, 0.0))) * inv_k;
  vec2 s, t, p;

  p = mul_fp64(r, r);
  s = sum_fp64(r, p * 0.5);
  p = mul_fp64(p, r);
  t = mul_fp64(p, INVERSE_FACTORIAL_3_FP64);

  s = sum_fp64(s, t);
  p = mul_fp64(p, r);
  t = mul_fp64(p, INVERSE_FACTORIAL_4_FP64);

  s = sum_fp64(s, t);
  p = mul_fp64(p, r);
  t = mul_fp64(p, INVERSE_FACTORIAL_5_FP64);






  s = sum_fp64(s, t);
  for (int i = 0; i < k_power; i++) {
    s = sum_fp64(s * 2.0, mul_fp64(s, s));
  }

#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)
  s = sum_fp64(s, vec2(ONE, 0.0));
#else
  s = sum_fp64(s, vec2(1.0, 0.0));
#endif

  return s * pow(2.0, m);
}

vec2 log_fp64(vec2 a)
{
  if (a.x == 1.0 && a.y == 0.0) return vec2(0.0, 0.0);
  if (a.x <= 0.0) return vec2(0.0 / 0.0, 0.0 / 0.0);
  vec2 x = vec2(log(a.x), 0.0);
  vec2 s;
#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)
  s = vec2(ONE, 0.0);
#else
  s = vec2(1.0, 0.0);
#endif

  x = sub_fp64(sum_fp64(x, mul_fp64(a, exp_fp64(-x))), s);
  return x;
}

vec2 sin_taylor_fp64(vec2 a) {
  vec2 r, s, t, x;

  if (a.x == 0.0 && a.y == 0.0) {
    return vec2(0.0, 0.0);
  }

  x = -mul_fp64(a, a);
  s = a;
  r = a;

  r = mul_fp64(r, x);
  t = mul_fp64(r, INVERSE_FACTORIAL_3_FP64);
  s = sum_fp64(s, t);

  r = mul_fp64(r, x);
  t = mul_fp64(r, INVERSE_FACTORIAL_5_FP64);
  s = sum_fp64(s, t);






  return s;
}

vec2 cos_taylor_fp64(vec2 a) {
  vec2 r, s, t, x;

  if (a.x == 0.0 && a.y == 0.0) {
    return vec2(1.0, 0.0);
  }

  x = -mul_fp64(a, a);
  r = x;
  s = sum_fp64(vec2(1.0, 0.0), r * 0.5);

  r = mul_fp64(r, x);
  t = mul_fp64(r, INVERSE_FACTORIAL_4_FP64);
  s = sum_fp64(s, t);

  r = mul_fp64(r, x);
  t = mul_fp64(r, INVERSE_FACTORIAL_6_FP64);
  s = sum_fp64(s, t);






  return s;
}

void sincos_taylor_fp64(vec2 a, out vec2 sin_t, out vec2 cos_t) {
  if (a.x == 0.0 && a.y == 0.0) {
    sin_t = vec2(0.0, 0.0);
    cos_t = vec2(1.0, 0.0);
  }

  sin_t = sin_taylor_fp64(a);
  cos_t = sqrt_fp64(sub_fp64(vec2(1.0, 0.0), mul_fp64(sin_t, sin_t)));
}

vec2 sin_fp64(vec2 a) {
    if (a.x == 0.0 && a.y == 0.0) {
        return vec2(0.0, 0.0);
    }
    vec2 z = nint_fp64(div_fp64(a, TWO_PI_FP64));
    vec2 r = sub_fp64(a, mul_fp64(TWO_PI_FP64, z));

    vec2 t;
    float q = floor(r.x / PI_2_FP64.x + 0.5);
    int j = int(q);

    if (j < -2 || j > 2) {
        return vec2(0.0 / 0.0, 0.0 / 0.0);
    }

    t = sub_fp64(r, mul_fp64(PI_2_FP64, vec2(q, 0.0)));

    q = floor(t.x / PI_16_FP64.x + 0.5);
    int k = int(q);

    if (k == 0) {
        if (j == 0) {
            return sin_taylor_fp64(t);
        } else if (j == 1) {
            return cos_taylor_fp64(t);
        } else if (j == -1) {
            return -cos_taylor_fp64(t);
        } else {
            return -sin_taylor_fp64(t);
        }
    }

    int abs_k = int(abs(float(k)));

    if (abs_k > 4) {
        return vec2(0.0 / 0.0, 0.0 / 0.0);
    } else {
        t = sub_fp64(t, mul_fp64(PI_16_FP64, vec2(q, 0.0)));
    }

    vec2 u = vec2(0.0, 0.0);
    vec2 v = vec2(0.0, 0.0);

#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)
    if (abs(float(abs_k) - 1.0) < 0.5) {
        u = COS_TABLE_0_FP64;
        v = SIN_TABLE_0_FP64;
    } else if (abs(float(abs_k) - 2.0) < 0.5) {
        u = COS_TABLE_1_FP64;
        v = SIN_TABLE_1_FP64;
    } else if (abs(float(abs_k) - 3.0) < 0.5) {
        u = COS_TABLE_2_FP64;
        v = SIN_TABLE_2_FP64;
    } else if (abs(float(abs_k) - 4.0) < 0.5) {
        u = COS_TABLE_3_FP64;
        v = SIN_TABLE_3_FP64;
    }
#else
    if (abs_k == 1) {
        u = COS_TABLE_0_FP64;
        v = SIN_TABLE_0_FP64;
    } else if (abs_k == 2) {
        u = COS_TABLE_1_FP64;
        v = SIN_TABLE_1_FP64;
    } else if (abs_k == 3) {
        u = COS_TABLE_2_FP64;
        v = SIN_TABLE_2_FP64;
    } else if (abs_k == 4) {
        u = COS_TABLE_3_FP64;
        v = SIN_TABLE_3_FP64;
    }
#endif

    vec2 sin_t, cos_t;
    sincos_taylor_fp64(t, sin_t, cos_t);



    vec2 result = vec2(0.0, 0.0);
    if (j == 0) {
        if (k > 0) {
            result = sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
        } else {
            result = sub_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
        }
    } else if (j == 1) {
        if (k > 0) {
            result = sub_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        } else {
            result = sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        }
    } else if (j == -1) {
        if (k > 0) {
            result = sub_fp64(mul_fp64(v, sin_t), mul_fp64(u, cos_t));
        } else {
            result = -sum_fp64(mul_fp64(v, sin_t), mul_fp64(u, cos_t));
        }
    } else {
        if (k > 0) {
            result = -sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
        } else {
            result = sub_fp64(mul_fp64(v, cos_t), mul_fp64(u, sin_t));
        }
    }

    return result;
}

vec2 cos_fp64(vec2 a) {
    if (a.x == 0.0 && a.y == 0.0) {
        return vec2(1.0, 0.0);
    }
    vec2 z = nint_fp64(div_fp64(a, TWO_PI_FP64));
    vec2 r = sub_fp64(a, mul_fp64(TWO_PI_FP64, z));

    vec2 t;
    float q = floor(r.x / PI_2_FP64.x + 0.5);
    int j = int(q);

    if (j < -2 || j > 2) {
        return vec2(0.0 / 0.0, 0.0 / 0.0);
    }

    t = sub_fp64(r, mul_fp64(PI_2_FP64, vec2(q, 0.0)));

    q = floor(t.x / PI_16_FP64.x + 0.5);
    int k = int(q);

    if (k == 0) {
        if (j == 0) {
            return cos_taylor_fp64(t);
        } else if (j == 1) {
            return -sin_taylor_fp64(t);
        } else if (j == -1) {
            return sin_taylor_fp64(t);
        } else {
            return -cos_taylor_fp64(t);
        }
    }

    int abs_k = int(abs(float(k)));

    if (abs_k > 4) {
        return vec2(0.0 / 0.0, 0.0 / 0.0);
    } else {
        t = sub_fp64(t, mul_fp64(PI_16_FP64, vec2(q, 0.0)));
    }

    vec2 u = vec2(0.0, 0.0);
    vec2 v = vec2(0.0, 0.0);

#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)
    if (abs(float(abs_k) - 1.0) < 0.5) {
        u = COS_TABLE_0_FP64;
        v = SIN_TABLE_0_FP64;
    } else if (abs(float(abs_k) - 2.0) < 0.5) {
        u = COS_TABLE_1_FP64;
        v = SIN_TABLE_1_FP64;
    } else if (abs(float(abs_k) - 3.0) < 0.5) {
        u = COS_TABLE_2_FP64;
        v = SIN_TABLE_2_FP64;
    } else if (abs(float(abs_k) - 4.0) < 0.5) {
        u = COS_TABLE_3_FP64;
        v = SIN_TABLE_3_FP64;
    }
#else
    if (abs_k == 1) {
        u = COS_TABLE_0_FP64;
        v = SIN_TABLE_0_FP64;
    } else if (abs_k == 2) {
        u = COS_TABLE_1_FP64;
        v = SIN_TABLE_1_FP64;
    } else if (abs_k == 3) {
        u = COS_TABLE_2_FP64;
        v = SIN_TABLE_2_FP64;
    } else if (abs_k == 4) {
        u = COS_TABLE_3_FP64;
        v = SIN_TABLE_3_FP64;
    }
#endif

    vec2 sin_t, cos_t;
    sincos_taylor_fp64(t, sin_t, cos_t);

    vec2 result = vec2(0.0, 0.0);
    if (j == 0) {
        if (k > 0) {
            result = sub_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        } else {
            result = sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        }
    } else if (j == 1) {
        if (k > 0) {
            result = -sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
        } else {
            result = sub_fp64(mul_fp64(v, cos_t), mul_fp64(u, sin_t));
        }
    } else if (j == -1) {
        if (k > 0) {
            result = sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
        } else {
            result = sub_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
        }
    } else {
        if (k > 0) {
            result = sub_fp64(mul_fp64(v, sin_t), mul_fp64(u, cos_t));
        } else {
            result = -sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        }
    }

    return result;
}

vec2 tan_fp64(vec2 a) {
    vec2 sin_a;
    vec2 cos_a;

    if (a.x == 0.0 && a.y == 0.0) {
        return vec2(0.0, 0.0);
    }
    vec2 z = nint_fp64(div_fp64(a, TWO_PI_FP64));
    vec2 r = sub_fp64(a, mul_fp64(TWO_PI_FP64, z));

    vec2 t;
    float q = floor(r.x / PI_2_FP64.x + 0.5);
    int j = int(q);


    if (j < -2 || j > 2) {
        return vec2(0.0 / 0.0, 0.0 / 0.0);
    }

    t = sub_fp64(r, mul_fp64(PI_2_FP64, vec2(q, 0.0)));

    q = floor(t.x / PI_16_FP64.x + 0.5);
    int k = int(q);
    int abs_k = int(abs(float(k)));

    if (abs_k > 4) {
        return vec2(0.0 / 0.0, 0.0 / 0.0);
    } else {
        t = sub_fp64(t, mul_fp64(PI_16_FP64, vec2(q, 0.0)));
    }


    vec2 u = vec2(0.0, 0.0);
    vec2 v = vec2(0.0, 0.0);

    vec2 sin_t, cos_t;
    vec2 s, c;
    sincos_taylor_fp64(t, sin_t, cos_t);

    if (k == 0) {
        s = sin_t;
        c = cos_t;
    } else {
#if defined(NVIDIA_FP64_WORKAROUND) || defined(INTEL_FP64_WORKAROUND)
        if (abs(float(abs_k) - 1.0) < 0.5) {
            u = COS_TABLE_0_FP64;
            v = SIN_TABLE_0_FP64;
        } else if (abs(float(abs_k) - 2.0) < 0.5) {
            u = COS_TABLE_1_FP64;
            v = SIN_TABLE_1_FP64;
        } else if (abs(float(abs_k) - 3.0) < 0.5) {
            u = COS_TABLE_2_FP64;
            v = SIN_TABLE_2_FP64;
        } else if (abs(float(abs_k) - 4.0) < 0.5) {
            u = COS_TABLE_3_FP64;
            v = SIN_TABLE_3_FP64;
        }
#else
        if (abs_k == 1) {
            u = COS_TABLE_0_FP64;
            v = SIN_TABLE_0_FP64;
        } else if (abs_k == 2) {
            u = COS_TABLE_1_FP64;
            v = SIN_TABLE_1_FP64;
        } else if (abs_k == 3) {
            u = COS_TABLE_2_FP64;
            v = SIN_TABLE_2_FP64;
        } else if (abs_k == 4) {
            u = COS_TABLE_3_FP64;
            v = SIN_TABLE_3_FP64;
        }
#endif
        if (k > 0) {
            s = sum_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
            c = sub_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        } else {
            s = sub_fp64(mul_fp64(u, sin_t), mul_fp64(v, cos_t));
            c = sum_fp64(mul_fp64(u, cos_t), mul_fp64(v, sin_t));
        }
    }

    if (j == 0) {
        sin_a = s;
        cos_a = c;
    } else if (j == 1) {
        sin_a = c;
        cos_a = -s;
    } else if (j == -1) {
        sin_a = -c;
        cos_a = s;
    } else {
        sin_a = -s;
        cos_a = -c;
    }
    return div_fp64(sin_a, cos_a);
}

vec2 radians_fp64(vec2 degree) {
  return mul_fp64(degree, PI_180_FP64);
}

vec2 mix_fp64(vec2 a, vec2 b, float x) {
  vec2 range = sub_fp64(b, a);
  return sum_fp64(a, mul_fp64(range, vec2(x, 0.0)));
}

void vec2_sum_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {
    out_val[0] = sum_fp64(a[0], b[0]);
    out_val[1] = sum_fp64(a[1], b[1]);
}

void vec2_sub_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {
    out_val[0] = sub_fp64(a[0], b[0]);
    out_val[1] = sub_fp64(a[1], b[1]);
}

void vec2_mul_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {
    out_val[0] = mul_fp64(a[0], b[0]);
    out_val[1] = mul_fp64(a[1], b[1]);
}

void vec2_div_fp64(vec2 a[2], vec2 b[2], out vec2 out_val[2]) {
    out_val[0] = div_fp64(a[0], b[0]);
    out_val[1] = div_fp64(a[1], b[1]);
}

void vec2_mix_fp64(vec2 x[2], vec2 y[2], float a, out vec2 out_val[2]) {
  vec2 range[2];
  vec2_sub_fp64(y, x, range);
  vec2 portion[2];
  portion[0] = range[0] * a;
  portion[1] = range[1] * a;
  vec2_sum_fp64(x, portion, out_val);
}

vec2 vec2_length_fp64(vec2 x[2]) {
  return sqrt_fp64(sum_fp64(mul_fp64(x[0], x[0]), mul_fp64(x[1], x[1])));
}

void vec2_normalize_fp64(vec2 x[2], out vec2 out_val[2]) {
  vec2 length = vec2_length_fp64(x);
  vec2 length_vec2[2];
  length_vec2[0] = length;
  length_vec2[1] = length;

  vec2_div_fp64(x, length_vec2, out_val);
}

vec2 vec2_distance_fp64(vec2 x[2], vec2 y[2]) {
  vec2 diff[2];
  vec2_sub_fp64(x, y, diff);
  return vec2_length_fp64(diff);
}

vec2 vec2_dot_fp64(vec2 a[2], vec2 b[2]) {
  vec2 v[2];

  v[0] = mul_fp64(a[0], b[0]);
  v[1] = mul_fp64(a[1], b[1]);

  return sum_fp64(v[0], v[1]);
}
void vec3_sub_fp64(vec2 a[3], vec2 b[3], out vec2 out_val[3]) {
  for (int i = 0; i < 3; i++) {
    out_val[i] = sum_fp64(a[i], b[i]);
  }
}

void vec3_sum_fp64(vec2 a[3], vec2 b[3], out vec2 out_val[3]) {
  for (int i = 0; i < 3; i++) {
    out_val[i] = sum_fp64(a[i], b[i]);
  }
}

vec2 vec3_length_fp64(vec2 x[3]) {
  return sqrt_fp64(sum_fp64(sum_fp64(mul_fp64(x[0], x[0]), mul_fp64(x[1], x[1])),
    mul_fp64(x[2], x[2])));
}

vec2 vec3_distance_fp64(vec2 x[3], vec2 y[3]) {
  vec2 diff[3];
  vec3_sub_fp64(x, y, diff);
  return vec3_length_fp64(diff);
}
void vec4_fp64(vec4 a, out vec2 out_val[4]) {
  out_val[0].x = a[0];
  out_val[0].y = 0.0;

  out_val[1].x = a[1];
  out_val[1].y = 0.0;

  out_val[2].x = a[2];
  out_val[2].y = 0.0;

  out_val[3].x = a[3];
  out_val[3].y = 0.0;
}

void vec4_scalar_mul_fp64(vec2 a[4], vec2 b, out vec2 out_val[4]) {
  out_val[0] = mul_fp64(a[0], b);
  out_val[1] = mul_fp64(a[1], b);
  out_val[2] = mul_fp64(a[2], b);
  out_val[3] = mul_fp64(a[3], b);
}

void vec4_sum_fp64(vec2 a[4], vec2 b[4], out vec2 out_val[4]) {
  for (int i = 0; i < 4; i++) {
    out_val[i] = sum_fp64(a[i], b[i]);
  }
}

void vec4_dot_fp64(vec2 a[4], vec2 b[4], out vec2 out_val) {
  vec2 v[4];

  v[0] = mul_fp64(a[0], b[0]);
  v[1] = mul_fp64(a[1], b[1]);
  v[2] = mul_fp64(a[2], b[2]);
  v[3] = mul_fp64(a[3], b[3]);

  out_val = sum_fp64(sum_fp64(v[0], v[1]), sum_fp64(v[2], v[3]));
}

void mat4_vec4_mul_fp64(vec2 b[16], vec2 a[4], out vec2 out_val[4]) {
  vec2 tmp[4];

  for (int i = 0; i < 4; i++)
  {
    for (int j = 0; j < 4; j++)
    {
      tmp[j] = b[j + i * 4];
    }
    vec4_dot_fp64(a, tmp, out_val[i]);
  }
}
`, Sln = {
  ONE: 1
};
function Qln() {
  return Sln;
}
const wln = {
  name: "fp64-arithmetic",
  vs: bln,
  fs: null,
  getUniforms: Qln,
  fp64ify: wle,
  fp64LowPart: c$e,
  fp64ifyMatrix4: u$e
}, xln = {
  name: "fp64",
  vs: _ln,
  fs: null,
  dependencies: [wln],
  fp64ify: wle,
  fp64LowPart: c$e,
  fp64ifyMatrix4: u$e
};
function bf(t, e) {
  if (!t)
    throw new Error("math.gl assertion ".concat(e));
}
const Rln = 1 / Math.PI * 180, Dln = 1 / 180 * Math.PI, $o = {
  EPSILON: 1e-12,
  debug: !1,
  precision: 4,
  printTypes: !1,
  printDegrees: !1,
  printRowMajor: !0
};
function Tln(t) {
  for (const e in t)
    bf(e in $o), $o[e] = t[e];
  return $o;
}
function xle(t, {
  precision: e = $o.precision
} = {}) {
  return t = Uln(t), "".concat(parseFloat(t.toPrecision(e)));
}
function ud(t) {
  return Array.isArray(t) || ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function Nln(t) {
  return "clone" in t ? t.clone() : t.slice();
}
function f$e(t) {
  return f_(t);
}
function g$e(t) {
  return pg(t);
}
function f_(t, e) {
  return XI(t, (n) => n * Dln, e);
}
function pg(t, e) {
  return XI(t, (n) => n * Rln, e);
}
function Lln(t, e) {
  return XI(t, (n) => Math.sin(n), e);
}
function Mln(t, e) {
  return XI(t, (n) => Math.cos(n), e);
}
function Oln(t, e) {
  return XI(t, (n) => Math.tan(n), e);
}
function Fln(t, e) {
  return XI(t, (n) => Math.asin(n), e);
}
function Pln(t, e) {
  return XI(t, (n) => Math.acos(n), e);
}
function kln(t, e) {
  return XI(t, (n) => Math.atan(n), e);
}
function So(t, e, n) {
  return XI(t, (r) => Math.max(e, Math.min(n, r)));
}
function Lf(t, e, n) {
  return ud(t) ? t.map((r, i) => Lf(r, e[i], n)) : n * e + (1 - n) * t;
}
function ul(t, e, n) {
  const r = $o.EPSILON;
  n && ($o.EPSILON = n);
  try {
    if (t === e)
      return !0;
    if (ud(t) && ud(e)) {
      if (t.length !== e.length)
        return !1;
      for (let i = 0; i < t.length; ++i)
        if (!ul(t[i], e[i]))
          return !1;
      return !0;
    }
    return t && t.equals ? t.equals(e) : e && e.equals ? e.equals(t) : typeof t == "number" && typeof e == "number" ? Math.abs(t - e) <= $o.EPSILON * Math.max(1, Math.abs(t), Math.abs(e)) : !1;
  } finally {
    $o.EPSILON = r;
  }
}
function h$e(t, e) {
  if (t === e)
    return !0;
  if (t && typeof t == "object" && e && typeof e == "object") {
    if (t.constructor !== e.constructor)
      return !1;
    if (t.exactEquals)
      return t.exactEquals(e);
  }
  if (ud(t) && ud(e)) {
    if (t.length !== e.length)
      return !1;
    for (let n = 0; n < t.length; ++n)
      if (!h$e(t[n], e[n]))
        return !1;
    return !0;
  }
  return !1;
}
function Gln(t, e) {
  const n = $o.EPSILON;
  $o.EPSILON = t;
  let r;
  try {
    r = e();
  } finally {
    $o.EPSILON = n;
  }
  return r;
}
function Uln(t) {
  return Math.round(t / $o.EPSILON) * $o.EPSILON;
}
function Hln(t) {
  return t.clone ? t.clone() : new Array(t.length);
}
function XI(t, e, n) {
  if (ud(t)) {
    const r = t;
    n = n || Hln(r);
    for (let i = 0; i < n.length && i < r.length; ++i)
      n[i] = e(t[i], i, n);
    return n;
  }
  return e(t);
}
function $ln(t) {
  function e() {
    var n = Reflect.construct(t, Array.from(arguments));
    return Object.setPrototypeOf(n, Object.getPrototypeOf(this)), n;
  }
  return e.prototype = Object.create(t.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t, e;
}
class t$ extends $ln(Array) {
  clone() {
    return new this.constructor().copy(this);
  }
  fromArray(e, n = 0) {
    for (let r = 0; r < this.ELEMENTS; ++r)
      this[r] = e[r + n];
    return this.check();
  }
  toArray(e = [], n = 0) {
    for (let r = 0; r < this.ELEMENTS; ++r)
      e[n + r] = this[r];
    return e;
  }
  from(e) {
    return Array.isArray(e) ? this.copy(e) : this.fromObject(e);
  }
  to(e) {
    return e === this ? this : ud(e) ? this.toArray(e) : this.toObject(e);
  }
  toTarget(e) {
    return e ? this.to(e) : this;
  }
  toFloat32Array() {
    return new Float32Array(this);
  }
  toString() {
    return this.formatString($o);
  }
  formatString(e) {
    let n = "";
    for (let r = 0; r < this.ELEMENTS; ++r)
      n += (r > 0 ? ", " : "") + xle(this[r], e);
    return "".concat(e.printTypes ? this.constructor.name : "", "[").concat(n, "]");
  }
  equals(e) {
    if (!e || this.length !== e.length)
      return !1;
    for (let n = 0; n < this.ELEMENTS; ++n)
      if (!ul(this[n], e[n]))
        return !1;
    return !0;
  }
  exactEquals(e) {
    if (!e || this.length !== e.length)
      return !1;
    for (let n = 0; n < this.ELEMENTS; ++n)
      if (this[n] !== e[n])
        return !1;
    return !0;
  }
  negate() {
    for (let e = 0; e < this.ELEMENTS; ++e)
      this[e] = -this[e];
    return this.check();
  }
  lerp(e, n, r) {
    if (r === void 0)
      return this.lerp(this, e, n);
    for (let i = 0; i < this.ELEMENTS; ++i) {
      const o = e[i];
      this[i] = o + r * (n[i] - o);
    }
    return this.check();
  }
  min(e) {
    for (let n = 0; n < this.ELEMENTS; ++n)
      this[n] = Math.min(e[n], this[n]);
    return this.check();
  }
  max(e) {
    for (let n = 0; n < this.ELEMENTS; ++n)
      this[n] = Math.max(e[n], this[n]);
    return this.check();
  }
  clamp(e, n) {
    for (let r = 0; r < this.ELEMENTS; ++r)
      this[r] = Math.min(Math.max(this[r], e[r]), n[r]);
    return this.check();
  }
  add(...e) {
    for (const n of e)
      for (let r = 0; r < this.ELEMENTS; ++r)
        this[r] += n[r];
    return this.check();
  }
  subtract(...e) {
    for (const n of e)
      for (let r = 0; r < this.ELEMENTS; ++r)
        this[r] -= n[r];
    return this.check();
  }
  scale(e) {
    if (typeof e == "number")
      for (let n = 0; n < this.ELEMENTS; ++n)
        this[n] *= e;
    else
      for (let n = 0; n < this.ELEMENTS && n < e.length; ++n)
        this[n] *= e[n];
    return this.check();
  }
  multiplyByScalar(e) {
    for (let n = 0; n < this.ELEMENTS; ++n)
      this[n] *= e;
    return this.check();
  }
  check() {
    if ($o.debug && !this.validate())
      throw new Error("math.gl: ".concat(this.constructor.name, " some fields set to invalid numbers'"));
    return this;
  }
  validate() {
    let e = this.length === this.ELEMENTS;
    for (let n = 0; n < this.ELEMENTS; ++n)
      e = e && Number.isFinite(this[n]);
    return e;
  }
  sub(e) {
    return this.subtract(e);
  }
  setScalar(e) {
    for (let n = 0; n < this.ELEMENTS; ++n)
      this[n] = e;
    return this.check();
  }
  addScalar(e) {
    for (let n = 0; n < this.ELEMENTS; ++n)
      this[n] += e;
    return this.check();
  }
  subScalar(e) {
    return this.addScalar(-e);
  }
  multiplyScalar(e) {
    for (let n = 0; n < this.ELEMENTS; ++n)
      this[n] *= e;
    return this.check();
  }
  divideScalar(e) {
    return this.multiplyByScalar(1 / e);
  }
  clampScalar(e, n) {
    for (let r = 0; r < this.ELEMENTS; ++r)
      this[r] = Math.min(Math.max(this[r], e), n);
    return this.check();
  }
  get elements() {
    return this;
  }
}
function qln(t, e) {
  if (t.length !== e)
    return !1;
  for (let n = 0; n < t.length; ++n)
    if (!Number.isFinite(t[n]))
      return !1;
  return !0;
}
function Vr(t) {
  if (!Number.isFinite(t))
    throw new Error("Invalid number ".concat(t));
  return t;
}
function vD(t, e, n = "") {
  if ($o.debug && !qln(t, e))
    throw new Error("math.gl: ".concat(n, " some fields set to invalid numbers'"));
  return t;
}
class Rle extends t$ {
  get x() {
    return this[0];
  }
  set x(e) {
    this[0] = Vr(e);
  }
  get y() {
    return this[1];
  }
  set y(e) {
    this[1] = Vr(e);
  }
  len() {
    return Math.sqrt(this.lengthSquared());
  }
  magnitude() {
    return this.len();
  }
  lengthSquared() {
    let e = 0;
    for (let n = 0; n < this.ELEMENTS; ++n)
      e += this[n] * this[n];
    return e;
  }
  magnitudeSquared() {
    return this.lengthSquared();
  }
  distance(e) {
    return Math.sqrt(this.distanceSquared(e));
  }
  distanceSquared(e) {
    let n = 0;
    for (let r = 0; r < this.ELEMENTS; ++r) {
      const i = this[r] - e[r];
      n += i * i;
    }
    return Vr(n);
  }
  dot(e) {
    let n = 0;
    for (let r = 0; r < this.ELEMENTS; ++r)
      n += this[r] * e[r];
    return Vr(n);
  }
  normalize() {
    const e = this.magnitude();
    if (e !== 0)
      for (let n = 0; n < this.ELEMENTS; ++n)
        this[n] /= e;
    return this.check();
  }
  multiply(...e) {
    for (const n of e)
      for (let r = 0; r < this.ELEMENTS; ++r)
        this[r] *= n[r];
    return this.check();
  }
  divide(...e) {
    for (const n of e)
      for (let r = 0; r < this.ELEMENTS; ++r)
        this[r] /= n[r];
    return this.check();
  }
  lengthSq() {
    return this.lengthSquared();
  }
  distanceTo(e) {
    return this.distance(e);
  }
  distanceToSquared(e) {
    return this.distanceSquared(e);
  }
  getComponent(e) {
    return bf(e >= 0 && e < this.ELEMENTS, "index is out of range"), Vr(this[e]);
  }
  setComponent(e, n) {
    return bf(e >= 0 && e < this.ELEMENTS, "index is out of range"), this[e] = n, this.check();
  }
  addVectors(e, n) {
    return this.copy(e).add(n);
  }
  subVectors(e, n) {
    return this.copy(e).subtract(n);
  }
  multiplyVectors(e, n) {
    return this.copy(e).multiply(n);
  }
  addScaledVector(e, n) {
    return this.add(new this.constructor(e).multiplyScalar(n));
  }
}
var _a = 1e-6, fd = typeof Float32Array < "u" ? Float32Array : Array;
Math.hypot || (Math.hypot = function() {
  for (var t = 0, e = arguments.length; e--; )
    t += arguments[e] * arguments[e];
  return Math.sqrt(t);
});
function jln() {
  var t = new fd(2);
  return fd != Float32Array && (t[0] = 0, t[1] = 0), t;
}
function eB(t, e, n) {
  return t[0] = e[0] + n[0], t[1] = e[1] + n[1], t;
}
function Yln(t, e, n) {
  return t[0] = e[0] - n[0], t[1] = e[1] - n[1], t;
}
function zln(t, e, n) {
  return t[0] = e[0] * n, t[1] = e[1] * n, t;
}
function Vln(t) {
  var e = t[0], n = t[1];
  return Math.hypot(e, n);
}
function Dle(t, e) {
  return t[0] = -e[0], t[1] = -e[1], t;
}
function d$e(t, e, n, r) {
  var i = e[0], o = e[1];
  return t[0] = i + r * (n[0] - i), t[1] = o + r * (n[1] - o), t;
}
function Jln(t, e, n) {
  var r = e[0], i = e[1];
  return t[0] = n[0] * r + n[2] * i, t[1] = n[1] * r + n[3] * i, t;
}
function Kln(t, e, n) {
  var r = e[0], i = e[1];
  return t[0] = n[0] * r + n[2] * i + n[4], t[1] = n[1] * r + n[3] * i + n[5], t;
}
function p$e(t, e, n) {
  var r = e[0], i = e[1];
  return t[0] = n[0] * r + n[3] * i + n[6], t[1] = n[1] * r + n[4] * i + n[7], t;
}
function I$e(t, e, n) {
  var r = e[0], i = e[1];
  return t[0] = n[0] * r + n[4] * i + n[12], t[1] = n[1] * r + n[5] * i + n[13], t;
}
var Wln = Yln;
(function() {
  var t = jln();
  return function(e, n, r, i, o, s) {
    var a, A;
    for (n || (n = 2), r || (r = 0), i ? A = Math.min(i * n + r, e.length) : A = e.length, a = r; a < A; a += n)
      t[0] = e[a], t[1] = e[a + 1], o(t, t, s), e[a] = t[0], e[a + 1] = t[1];
    return e;
  };
})();
function m$e(t, e, n) {
  const r = e[0], i = e[1], o = n[3] * r + n[7] * i || 1;
  return t[0] = (n[0] * r + n[4] * i) / o, t[1] = (n[1] * r + n[5] * i) / o, t;
}
function C$e(t, e, n) {
  const r = e[0], i = e[1], o = e[2], s = n[3] * r + n[7] * i + n[11] * o || 1;
  return t[0] = (n[0] * r + n[4] * i + n[8] * o) / s, t[1] = (n[1] * r + n[5] * i + n[9] * o) / s, t[2] = (n[2] * r + n[6] * i + n[10] * o) / s, t;
}
function Xln(t, e, n) {
  const r = e[0], i = e[1];
  return t[0] = n[0] * r + n[2] * i, t[1] = n[1] * r + n[3] * i, t[2] = e[2], t;
}
function Zln(t, e, n) {
  const r = e[0], i = e[1];
  return t[0] = n[0] * r + n[2] * i, t[1] = n[1] * r + n[3] * i, t[2] = e[2], t[3] = e[3], t;
}
function E$e(t, e, n) {
  const r = e[0], i = e[1], o = e[2];
  return t[0] = n[0] * r + n[3] * i + n[6] * o, t[1] = n[1] * r + n[4] * i + n[7] * o, t[2] = n[2] * r + n[5] * i + n[8] * o, t[3] = e[3], t;
}
class n$ extends Rle {
  constructor(e = 0, n = 0) {
    super(2), ud(e) && arguments.length === 1 ? this.copy(e) : ($o.debug && (Vr(e), Vr(n)), this[0] = e, this[1] = n);
  }
  set(e, n) {
    return this[0] = e, this[1] = n, this.check();
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this.check();
  }
  fromObject(e) {
    return $o.debug && (Vr(e.x), Vr(e.y)), this[0] = e.x, this[1] = e.y, this.check();
  }
  toObject(e) {
    return e.x = this[0], e.y = this[1], e;
  }
  get ELEMENTS() {
    return 2;
  }
  horizontalAngle() {
    return Math.atan2(this.y, this.x);
  }
  verticalAngle() {
    return Math.atan2(this.x, this.y);
  }
  transform(e) {
    return this.transformAsPoint(e);
  }
  transformAsPoint(e) {
    return I$e(this, this, e), this.check();
  }
  transformAsVector(e) {
    return m$e(this, this, e), this.check();
  }
  transformByMatrix3(e) {
    return p$e(this, this, e), this.check();
  }
  transformByMatrix2x3(e) {
    return Kln(this, this, e), this.check();
  }
  transformByMatrix2(e) {
    return Jln(this, this, e), this.check();
  }
}
function y$e() {
  var t = new fd(3);
  return fd != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0), t;
}
function Tle(t) {
  var e = t[0], n = t[1], r = t[2];
  return Math.hypot(e, n, r);
}
function g_e(t, e, n) {
  var r = new fd(3);
  return r[0] = t, r[1] = e, r[2] = n, r;
}
function ecn(t, e, n) {
  return t[0] = e[0] + n[0], t[1] = e[1] + n[1], t[2] = e[2] + n[2], t;
}
function tcn(t, e, n) {
  return t[0] = e[0] - n[0], t[1] = e[1] - n[1], t[2] = e[2] - n[2], t;
}
function ncn(t, e, n) {
  return t[0] = e[0] * n[0], t[1] = e[1] * n[1], t[2] = e[2] * n[2], t;
}
function rcn(t) {
  var e = t[0], n = t[1], r = t[2];
  return e * e + n * n + r * r;
}
function icn(t, e) {
  return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t;
}
function ocn(t, e) {
  var n = e[0], r = e[1], i = e[2], o = n * n + r * r + i * i;
  return o > 0 && (o = 1 / Math.sqrt(o)), t[0] = e[0] * o, t[1] = e[1] * o, t[2] = e[2] * o, t;
}
function Nle(t, e) {
  return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
}
function wk(t, e, n) {
  var r = e[0], i = e[1], o = e[2], s = n[0], a = n[1], A = n[2];
  return t[0] = i * A - o * a, t[1] = o * s - r * A, t[2] = r * a - i * s, t;
}
function scn(t, e, n, r) {
  var i = e[0], o = e[1], s = e[2];
  return t[0] = i + r * (n[0] - i), t[1] = o + r * (n[1] - o), t[2] = s + r * (n[2] - s), t;
}
function Lle(t, e, n) {
  var r = e[0], i = e[1], o = e[2], s = n[3] * r + n[7] * i + n[11] * o + n[15];
  return s = s || 1, t[0] = (n[0] * r + n[4] * i + n[8] * o + n[12]) / s, t[1] = (n[1] * r + n[5] * i + n[9] * o + n[13]) / s, t[2] = (n[2] * r + n[6] * i + n[10] * o + n[14]) / s, t;
}
function v$e(t, e, n) {
  var r = e[0], i = e[1], o = e[2];
  return t[0] = r * n[0] + i * n[3] + o * n[6], t[1] = r * n[1] + i * n[4] + o * n[7], t[2] = r * n[2] + i * n[5] + o * n[8], t;
}
function B$e(t, e, n) {
  var r = n[0], i = n[1], o = n[2], s = n[3], a = e[0], A = e[1], l = e[2], c = i * l - o * A, u = o * a - r * l, f = r * A - i * a, h = i * f - o * u, d = o * c - r * f, I = r * u - i * c, m = s * 2;
  return c *= m, u *= m, f *= m, h *= 2, d *= 2, I *= 2, t[0] = a + c + h, t[1] = A + u + d, t[2] = l + f + I, t;
}
function acn(t, e, n, r) {
  var i = [], o = [];
  return i[0] = e[0] - n[0], i[1] = e[1] - n[1], i[2] = e[2] - n[2], o[0] = i[0], o[1] = i[1] * Math.cos(r) - i[2] * Math.sin(r), o[2] = i[1] * Math.sin(r) + i[2] * Math.cos(r), t[0] = o[0] + n[0], t[1] = o[1] + n[1], t[2] = o[2] + n[2], t;
}
function Acn(t, e, n, r) {
  var i = [], o = [];
  return i[0] = e[0] - n[0], i[1] = e[1] - n[1], i[2] = e[2] - n[2], o[0] = i[2] * Math.sin(r) + i[0] * Math.cos(r), o[1] = i[1], o[2] = i[2] * Math.cos(r) - i[0] * Math.sin(r), t[0] = o[0] + n[0], t[1] = o[1] + n[1], t[2] = o[2] + n[2], t;
}
function lcn(t, e, n, r) {
  var i = [], o = [];
  return i[0] = e[0] - n[0], i[1] = e[1] - n[1], i[2] = e[2] - n[2], o[0] = i[0] * Math.cos(r) - i[1] * Math.sin(r), o[1] = i[0] * Math.sin(r) + i[1] * Math.cos(r), o[2] = i[2], t[0] = o[0] + n[0], t[1] = o[1] + n[1], t[2] = o[2] + n[2], t;
}
function ccn(t, e) {
  var n = t[0], r = t[1], i = t[2], o = e[0], s = e[1], a = e[2], A = Math.sqrt(n * n + r * r + i * i), l = Math.sqrt(o * o + s * s + a * a), c = A * l, u = c && Nle(t, e) / c;
  return Math.acos(Math.min(Math.max(u, -1), 1));
}
var b$e = tcn, ucn = ncn, _$e = Tle, gV = rcn;
(function() {
  var t = y$e();
  return function(e, n, r, i, o, s) {
    var a, A;
    for (n || (n = 3), r || (r = 0), i ? A = Math.min(i * n + r, e.length) : A = e.length, a = r; a < A; a += n)
      t[0] = e[a], t[1] = e[a + 1], t[2] = e[a + 2], o(t, t, s), e[a] = t[0], e[a + 1] = t[1], e[a + 2] = t[2];
    return e;
  };
})();
const hV = [0, 0, 0];
let zF;
class ct extends Rle {
  static get ZERO() {
    return zF || (zF = new ct(0, 0, 0), Object.freeze(zF)), zF;
  }
  constructor(e = 0, n = 0, r = 0) {
    super(-0, -0, -0), arguments.length === 1 && ud(e) ? this.copy(e) : ($o.debug && (Vr(e), Vr(n), Vr(r)), this[0] = e, this[1] = n, this[2] = r);
  }
  set(e, n, r) {
    return this[0] = e, this[1] = n, this[2] = r, this.check();
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this[2] = e[2], this.check();
  }
  fromObject(e) {
    return $o.debug && (Vr(e.x), Vr(e.y), Vr(e.z)), this[0] = e.x, this[1] = e.y, this[2] = e.z, this.check();
  }
  toObject(e) {
    return e.x = this[0], e.y = this[1], e.z = this[2], e;
  }
  get ELEMENTS() {
    return 3;
  }
  get z() {
    return this[2];
  }
  set z(e) {
    this[2] = Vr(e);
  }
  angle(e) {
    return ccn(this, e);
  }
  cross(e) {
    return wk(this, this, e), this.check();
  }
  rotateX({
    radians: e,
    origin: n = hV
  }) {
    return acn(this, this, n, e), this.check();
  }
  rotateY({
    radians: e,
    origin: n = hV
  }) {
    return Acn(this, this, n, e), this.check();
  }
  rotateZ({
    radians: e,
    origin: n = hV
  }) {
    return lcn(this, this, n, e), this.check();
  }
  transform(e) {
    return this.transformAsPoint(e);
  }
  transformAsPoint(e) {
    return Lle(this, this, e), this.check();
  }
  transformAsVector(e) {
    return C$e(this, this, e), this.check();
  }
  transformByMatrix3(e) {
    return v$e(this, this, e), this.check();
  }
  transformByMatrix2(e) {
    return Xln(this, this, e), this.check();
  }
  transformByQuaternion(e) {
    return B$e(this, this, e), this.check();
  }
}
let VF;
class r$ extends Rle {
  static get ZERO() {
    return VF || (VF = new r$(0, 0, 0, 0), Object.freeze(VF)), VF;
  }
  constructor(e = 0, n = 0, r = 0, i = 0) {
    super(-0, -0, -0, -0), ud(e) && arguments.length === 1 ? this.copy(e) : ($o.debug && (Vr(e), Vr(n), Vr(r), Vr(i)), this[0] = e, this[1] = n, this[2] = r, this[3] = i);
  }
  set(e, n, r, i) {
    return this[0] = e, this[1] = n, this[2] = r, this[3] = i, this.check();
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this[2] = e[2], this[3] = e[3], this.check();
  }
  fromObject(e) {
    return $o.debug && (Vr(e.x), Vr(e.y), Vr(e.z), Vr(e.w)), this[0] = e.x, this[1] = e.y, this[2] = e.z, this[3] = e.w, this;
  }
  toObject(e) {
    return e.x = this[0], e.y = this[1], e.z = this[2], e.w = this[3], e;
  }
  get ELEMENTS() {
    return 4;
  }
  get z() {
    return this[2];
  }
  set z(e) {
    this[2] = Vr(e);
  }
  get w() {
    return this[3];
  }
  set w(e) {
    this[3] = Vr(e);
  }
  transform(e) {
    return Lle(this, this, e), this.check();
  }
  transformByMatrix3(e) {
    return E$e(this, this, e), this.check();
  }
  transformByMatrix2(e) {
    return Zln(this, this, e), this.check();
  }
  transformByQuaternion(e) {
    return B$e(this, this, e), this.check();
  }
  applyMatrix4(e) {
    return e.transform(this, this), this;
  }
}
let S$e = class extends t$ {
  toString() {
    let e = "[";
    if ($o.printRowMajor) {
      e += "row-major:";
      for (let n = 0; n < this.RANK; ++n)
        for (let r = 0; r < this.RANK; ++r)
          e += " ".concat(this[r * this.RANK + n]);
    } else {
      e += "column-major:";
      for (let n = 0; n < this.ELEMENTS; ++n)
        e += " ".concat(this[n]);
    }
    return e += "]", e;
  }
  getElementIndex(e, n) {
    return n * this.RANK + e;
  }
  getElement(e, n) {
    return this[n * this.RANK + e];
  }
  setElement(e, n, r) {
    return this[n * this.RANK + e] = Vr(r), this;
  }
  getColumn(e, n = new Array(this.RANK).fill(-0)) {
    const r = e * this.RANK;
    for (let i = 0; i < this.RANK; ++i)
      n[i] = this[r + i];
    return n;
  }
  setColumn(e, n) {
    const r = e * this.RANK;
    for (let i = 0; i < this.RANK; ++i)
      this[r + i] = n[i];
    return this;
  }
};
function fcn() {
  var t = new fd(9);
  return fd != Float32Array && (t[1] = 0, t[2] = 0, t[3] = 0, t[5] = 0, t[6] = 0, t[7] = 0), t[0] = 1, t[4] = 1, t[8] = 1, t;
}
function gcn(t, e) {
  if (t === e) {
    var n = e[1], r = e[2], i = e[5];
    t[1] = e[3], t[2] = e[6], t[3] = n, t[5] = e[7], t[6] = r, t[7] = i;
  } else
    t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8];
  return t;
}
function hcn(t, e) {
  var n = e[0], r = e[1], i = e[2], o = e[3], s = e[4], a = e[5], A = e[6], l = e[7], c = e[8], u = c * s - a * l, f = -c * o + a * A, h = l * o - s * A, d = n * u + r * f + i * h;
  return d ? (d = 1 / d, t[0] = u * d, t[1] = (-c * r + i * l) * d, t[2] = (a * r - i * s) * d, t[3] = f * d, t[4] = (c * n - i * A) * d, t[5] = (-a * n + i * o) * d, t[6] = h * d, t[7] = (-l * n + r * A) * d, t[8] = (s * n - r * o) * d, t) : null;
}
function dcn(t) {
  var e = t[0], n = t[1], r = t[2], i = t[3], o = t[4], s = t[5], a = t[6], A = t[7], l = t[8];
  return e * (l * o - s * A) + n * (-l * i + s * a) + r * (A * i - o * a);
}
function h_e(t, e, n) {
  var r = e[0], i = e[1], o = e[2], s = e[3], a = e[4], A = e[5], l = e[6], c = e[7], u = e[8], f = n[0], h = n[1], d = n[2], I = n[3], m = n[4], C = n[5], y = n[6], v = n[7], b = n[8];
  return t[0] = f * r + h * s + d * l, t[1] = f * i + h * a + d * c, t[2] = f * o + h * A + d * u, t[3] = I * r + m * s + C * l, t[4] = I * i + m * a + C * c, t[5] = I * o + m * A + C * u, t[6] = y * r + v * s + b * l, t[7] = y * i + v * a + b * c, t[8] = y * o + v * A + b * u, t;
}
function pcn(t, e, n) {
  var r = e[0], i = e[1], o = e[2], s = e[3], a = e[4], A = e[5], l = e[6], c = e[7], u = e[8], f = n[0], h = n[1];
  return t[0] = r, t[1] = i, t[2] = o, t[3] = s, t[4] = a, t[5] = A, t[6] = f * r + h * s + l, t[7] = f * i + h * a + c, t[8] = f * o + h * A + u, t;
}
function Icn(t, e, n) {
  var r = e[0], i = e[1], o = e[2], s = e[3], a = e[4], A = e[5], l = e[6], c = e[7], u = e[8], f = Math.sin(n), h = Math.cos(n);
  return t[0] = h * r + f * s, t[1] = h * i + f * a, t[2] = h * o + f * A, t[3] = h * s - f * r, t[4] = h * a - f * i, t[5] = h * A - f * o, t[6] = l, t[7] = c, t[8] = u, t;
}
function d_e(t, e, n) {
  var r = n[0], i = n[1];
  return t[0] = r * e[0], t[1] = r * e[1], t[2] = r * e[2], t[3] = i * e[3], t[4] = i * e[4], t[5] = i * e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t;
}
function mcn(t, e) {
  var n = e[0], r = e[1], i = e[2], o = e[3], s = n + n, a = r + r, A = i + i, l = n * s, c = r * s, u = r * a, f = i * s, h = i * a, d = i * A, I = o * s, m = o * a, C = o * A;
  return t[0] = 1 - u - d, t[3] = c - C, t[6] = f + m, t[1] = c + C, t[4] = 1 - l - d, t[7] = h - I, t[2] = f - m, t[5] = h + I, t[8] = 1 - l - u, t;
}
var $ee;
(function(t) {
  t[t.COL0ROW0 = 0] = "COL0ROW0", t[t.COL0ROW1 = 1] = "COL0ROW1", t[t.COL0ROW2 = 2] = "COL0ROW2", t[t.COL1ROW0 = 3] = "COL1ROW0", t[t.COL1ROW1 = 4] = "COL1ROW1", t[t.COL1ROW2 = 5] = "COL1ROW2", t[t.COL2ROW0 = 6] = "COL2ROW0", t[t.COL2ROW1 = 7] = "COL2ROW1", t[t.COL2ROW2 = 8] = "COL2ROW2";
})($ee || ($ee = {}));
const Ccn = Object.freeze([1, 0, 0, 0, 1, 0, 0, 0, 1]);
class ja extends S$e {
  static get IDENTITY() {
    return ycn();
  }
  static get ZERO() {
    return Ecn();
  }
  get ELEMENTS() {
    return 9;
  }
  get RANK() {
    return 3;
  }
  get INDICES() {
    return $ee;
  }
  constructor(e, ...n) {
    super(-0, -0, -0, -0, -0, -0, -0, -0, -0), arguments.length === 1 && Array.isArray(e) ? this.copy(e) : n.length > 0 ? this.copy([e, ...n]) : this.identity();
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this[2] = e[2], this[3] = e[3], this[4] = e[4], this[5] = e[5], this[6] = e[6], this[7] = e[7], this[8] = e[8], this.check();
  }
  identity() {
    return this.copy(Ccn);
  }
  fromObject(e) {
    return this.check();
  }
  fromQuaternion(e) {
    return mcn(this, e), this.check();
  }
  set(e, n, r, i, o, s, a, A, l) {
    return this[0] = e, this[1] = n, this[2] = r, this[3] = i, this[4] = o, this[5] = s, this[6] = a, this[7] = A, this[8] = l, this.check();
  }
  setRowMajor(e, n, r, i, o, s, a, A, l) {
    return this[0] = e, this[1] = i, this[2] = a, this[3] = n, this[4] = o, this[5] = A, this[6] = r, this[7] = s, this[8] = l, this.check();
  }
  determinant() {
    return dcn(this);
  }
  transpose() {
    return gcn(this, this), this.check();
  }
  invert() {
    return hcn(this, this), this.check();
  }
  multiplyLeft(e) {
    return h_e(this, e, this), this.check();
  }
  multiplyRight(e) {
    return h_e(this, this, e), this.check();
  }
  rotate(e) {
    return Icn(this, this, e), this.check();
  }
  scale(e) {
    return Array.isArray(e) ? d_e(this, this, e) : d_e(this, this, [e, e]), this.check();
  }
  translate(e) {
    return pcn(this, this, e), this.check();
  }
  transform(e, n) {
    let r;
    switch (e.length) {
      case 2:
        r = p$e(n || [-0, -0], e, this);
        break;
      case 3:
        r = v$e(n || [-0, -0, -0], e, this);
        break;
      case 4:
        r = E$e(n || [-0, -0, -0, -0], e, this);
        break;
      default:
        throw new Error("Illegal vector");
    }
    return vD(r, e.length), r;
  }
  transformVector(e, n) {
    return this.transform(e, n);
  }
  transformVector2(e, n) {
    return this.transform(e, n);
  }
  transformVector3(e, n) {
    return this.transform(e, n);
  }
}
let JF, KF;
function Ecn() {
  return JF || (JF = new ja([0, 0, 0, 0, 0, 0, 0, 0, 0]), Object.freeze(JF)), JF;
}
function ycn() {
  return KF || (KF = new ja(), Object.freeze(KF)), KF;
}
function vcn(t) {
  return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
}
function Bcn(t, e) {
  if (t === e) {
    var n = e[1], r = e[2], i = e[3], o = e[6], s = e[7], a = e[11];
    t[1] = e[4], t[2] = e[8], t[3] = e[12], t[4] = n, t[6] = e[9], t[7] = e[13], t[8] = r, t[9] = o, t[11] = e[14], t[12] = i, t[13] = s, t[14] = a;
  } else
    t[0] = e[0], t[1] = e[4], t[2] = e[8], t[3] = e[12], t[4] = e[1], t[5] = e[5], t[6] = e[9], t[7] = e[13], t[8] = e[2], t[9] = e[6], t[10] = e[10], t[11] = e[14], t[12] = e[3], t[13] = e[7], t[14] = e[11], t[15] = e[15];
  return t;
}
function EU(t, e) {
  var n = e[0], r = e[1], i = e[2], o = e[3], s = e[4], a = e[5], A = e[6], l = e[7], c = e[8], u = e[9], f = e[10], h = e[11], d = e[12], I = e[13], m = e[14], C = e[15], y = n * a - r * s, v = n * A - i * s, b = n * l - o * s, Q = r * A - i * a, w = r * l - o * a, R = i * l - o * A, M = c * I - u * d, O = c * m - f * d, L = c * C - h * d, N = u * m - f * I, k = u * C - h * I, $ = f * C - h * m, U = y * $ - v * k + b * N + Q * L - w * O + R * M;
  return U ? (U = 1 / U, t[0] = (a * $ - A * k + l * N) * U, t[1] = (i * k - r * $ - o * N) * U, t[2] = (I * R - m * w + C * Q) * U, t[3] = (f * w - u * R - h * Q) * U, t[4] = (A * L - s * $ - l * O) * U, t[5] = (n * $ - i * L + o * O) * U, t[6] = (m * b - d * R - C * v) * U, t[7] = (c * R - f * b + h * v) * U, t[8] = (s * k - a * L + l * M) * U, t[9] = (r * L - n * k - o * M) * U, t[10] = (d * w - I * b + C * y) * U, t[11] = (u * b - c * w - h * y) * U, t[12] = (a * O - s * N - A * M) * U, t[13] = (n * N - r * O + i * M) * U, t[14] = (I * v - d * Q - m * y) * U, t[15] = (c * Q - u * v + f * y) * U, t) : null;
}
function bcn(t) {
  var e = t[0], n = t[1], r = t[2], i = t[3], o = t[4], s = t[5], a = t[6], A = t[7], l = t[8], c = t[9], u = t[10], f = t[11], h = t[12], d = t[13], I = t[14], m = t[15], C = e * s - n * o, y = e * a - r * o, v = e * A - i * o, b = n * a - r * s, Q = n * A - i * s, w = r * A - i * a, R = l * d - c * h, M = l * I - u * h, O = l * m - f * h, L = c * I - u * d, N = c * m - f * d, k = u * m - f * I;
  return C * k - y * N + v * L + b * O - Q * M + w * R;
}
function Np(t, e, n) {
  var r = e[0], i = e[1], o = e[2], s = e[3], a = e[4], A = e[5], l = e[6], c = e[7], u = e[8], f = e[9], h = e[10], d = e[11], I = e[12], m = e[13], C = e[14], y = e[15], v = n[0], b = n[1], Q = n[2], w = n[3];
  return t[0] = v * r + b * a + Q * u + w * I, t[1] = v * i + b * A + Q * f + w * m, t[2] = v * o + b * l + Q * h + w * C, t[3] = v * s + b * c + Q * d + w * y, v = n[4], b = n[5], Q = n[6], w = n[7], t[4] = v * r + b * a + Q * u + w * I, t[5] = v * i + b * A + Q * f + w * m, t[6] = v * o + b * l + Q * h + w * C, t[7] = v * s + b * c + Q * d + w * y, v = n[8], b = n[9], Q = n[10], w = n[11], t[8] = v * r + b * a + Q * u + w * I, t[9] = v * i + b * A + Q * f + w * m, t[10] = v * o + b * l + Q * h + w * C, t[11] = v * s + b * c + Q * d + w * y, v = n[12], b = n[13], Q = n[14], w = n[15], t[12] = v * r + b * a + Q * u + w * I, t[13] = v * i + b * A + Q * f + w * m, t[14] = v * o + b * l + Q * h + w * C, t[15] = v * s + b * c + Q * d + w * y, t;
}
function FT(t, e, n) {
  var r = n[0], i = n[1], o = n[2], s, a, A, l, c, u, f, h, d, I, m, C;
  return e === t ? (t[12] = e[0] * r + e[4] * i + e[8] * o + e[12], t[13] = e[1] * r + e[5] * i + e[9] * o + e[13], t[14] = e[2] * r + e[6] * i + e[10] * o + e[14], t[15] = e[3] * r + e[7] * i + e[11] * o + e[15]) : (s = e[0], a = e[1], A = e[2], l = e[3], c = e[4], u = e[5], f = e[6], h = e[7], d = e[8], I = e[9], m = e[10], C = e[11], t[0] = s, t[1] = a, t[2] = A, t[3] = l, t[4] = c, t[5] = u, t[6] = f, t[7] = h, t[8] = d, t[9] = I, t[10] = m, t[11] = C, t[12] = s * r + c * i + d * o + e[12], t[13] = a * r + u * i + I * o + e[13], t[14] = A * r + f * i + m * o + e[14], t[15] = l * r + h * i + C * o + e[15]), t;
}
function i$(t, e, n) {
  var r = n[0], i = n[1], o = n[2];
  return t[0] = e[0] * r, t[1] = e[1] * r, t[2] = e[2] * r, t[3] = e[3] * r, t[4] = e[4] * i, t[5] = e[5] * i, t[6] = e[6] * i, t[7] = e[7] * i, t[8] = e[8] * o, t[9] = e[9] * o, t[10] = e[10] * o, t[11] = e[11] * o, t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
}
function _cn(t, e, n, r) {
  var i = r[0], o = r[1], s = r[2], a = Math.hypot(i, o, s), A, l, c, u, f, h, d, I, m, C, y, v, b, Q, w, R, M, O, L, N, k, $, U, X;
  return a < _a ? null : (a = 1 / a, i *= a, o *= a, s *= a, A = Math.sin(n), l = Math.cos(n), c = 1 - l, u = e[0], f = e[1], h = e[2], d = e[3], I = e[4], m = e[5], C = e[6], y = e[7], v = e[8], b = e[9], Q = e[10], w = e[11], R = i * i * c + l, M = o * i * c + s * A, O = s * i * c - o * A, L = i * o * c - s * A, N = o * o * c + l, k = s * o * c + i * A, $ = i * s * c + o * A, U = o * s * c - i * A, X = s * s * c + l, t[0] = u * R + I * M + v * O, t[1] = f * R + m * M + b * O, t[2] = h * R + C * M + Q * O, t[3] = d * R + y * M + w * O, t[4] = u * L + I * N + v * k, t[5] = f * L + m * N + b * k, t[6] = h * L + C * N + Q * k, t[7] = d * L + y * N + w * k, t[8] = u * $ + I * U + v * X, t[9] = f * $ + m * U + b * X, t[10] = h * $ + C * U + Q * X, t[11] = d * $ + y * U + w * X, e !== t && (t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t);
}
function Q$e(t, e, n) {
  var r = Math.sin(n), i = Math.cos(n), o = e[4], s = e[5], a = e[6], A = e[7], l = e[8], c = e[9], u = e[10], f = e[11];
  return e !== t && (t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[4] = o * i + l * r, t[5] = s * i + c * r, t[6] = a * i + u * r, t[7] = A * i + f * r, t[8] = l * i - o * r, t[9] = c * i - s * r, t[10] = u * i - a * r, t[11] = f * i - A * r, t;
}
function Scn(t, e, n) {
  var r = Math.sin(n), i = Math.cos(n), o = e[0], s = e[1], a = e[2], A = e[3], l = e[8], c = e[9], u = e[10], f = e[11];
  return e !== t && (t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = o * i - l * r, t[1] = s * i - c * r, t[2] = a * i - u * r, t[3] = A * i - f * r, t[8] = o * r + l * i, t[9] = s * r + c * i, t[10] = a * r + u * i, t[11] = A * r + f * i, t;
}
function w$e(t, e, n) {
  var r = Math.sin(n), i = Math.cos(n), o = e[0], s = e[1], a = e[2], A = e[3], l = e[4], c = e[5], u = e[6], f = e[7];
  return e !== t && (t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15]), t[0] = o * i + l * r, t[1] = s * i + c * r, t[2] = a * i + u * r, t[3] = A * i + f * r, t[4] = l * i - o * r, t[5] = c * i - s * r, t[6] = u * i - a * r, t[7] = f * i - A * r, t;
}
function Qcn(t, e) {
  var n = e[0], r = e[1], i = e[2], o = e[4], s = e[5], a = e[6], A = e[8], l = e[9], c = e[10];
  return t[0] = Math.hypot(n, r, i), t[1] = Math.hypot(o, s, a), t[2] = Math.hypot(A, l, c), t;
}
function wcn(t, e) {
  var n = e[0], r = e[1], i = e[2], o = e[3], s = n + n, a = r + r, A = i + i, l = n * s, c = r * s, u = r * a, f = i * s, h = i * a, d = i * A, I = o * s, m = o * a, C = o * A;
  return t[0] = 1 - u - d, t[1] = c + C, t[2] = f - m, t[3] = 0, t[4] = c - C, t[5] = 1 - l - d, t[6] = h + I, t[7] = 0, t[8] = f + m, t[9] = h - I, t[10] = 1 - l - u, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
}
function xcn(t, e, n, r, i, o, s) {
  var a = 1 / (n - e), A = 1 / (i - r), l = 1 / (o - s);
  return t[0] = o * 2 * a, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = o * 2 * A, t[6] = 0, t[7] = 0, t[8] = (n + e) * a, t[9] = (i + r) * A, t[10] = (s + o) * l, t[11] = -1, t[12] = 0, t[13] = 0, t[14] = s * o * 2 * l, t[15] = 0, t;
}
function Rcn(t, e, n, r, i) {
  var o = 1 / Math.tan(e / 2), s;
  return t[0] = o / n, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = o, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = -1, t[12] = 0, t[13] = 0, t[15] = 0, i != null && i !== 1 / 0 ? (s = 1 / (r - i), t[10] = (i + r) * s, t[14] = 2 * i * r * s) : (t[10] = -1, t[14] = -2 * r), t;
}
var x$e = Rcn;
function Dcn(t, e, n, r, i, o, s) {
  var a = 1 / (e - n), A = 1 / (r - i), l = 1 / (o - s);
  return t[0] = -2 * a, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * A, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 2 * l, t[11] = 0, t[12] = (e + n) * a, t[13] = (i + r) * A, t[14] = (s + o) * l, t[15] = 1, t;
}
var Tcn = Dcn;
function Ncn(t, e, n, r) {
  var i, o, s, a, A, l, c, u, f, h, d = e[0], I = e[1], m = e[2], C = r[0], y = r[1], v = r[2], b = n[0], Q = n[1], w = n[2];
  return Math.abs(d - b) < _a && Math.abs(I - Q) < _a && Math.abs(m - w) < _a ? vcn(t) : (c = d - b, u = I - Q, f = m - w, h = 1 / Math.hypot(c, u, f), c *= h, u *= h, f *= h, i = y * f - v * u, o = v * c - C * f, s = C * u - y * c, h = Math.hypot(i, o, s), h ? (h = 1 / h, i *= h, o *= h, s *= h) : (i = 0, o = 0, s = 0), a = u * s - f * o, A = f * i - c * s, l = c * o - u * i, h = Math.hypot(a, A, l), h ? (h = 1 / h, a *= h, A *= h, l *= h) : (a = 0, A = 0, l = 0), t[0] = i, t[1] = a, t[2] = c, t[3] = 0, t[4] = o, t[5] = A, t[6] = u, t[7] = 0, t[8] = s, t[9] = l, t[10] = f, t[11] = 0, t[12] = -(i * d + o * I + s * m), t[13] = -(a * d + A * I + l * m), t[14] = -(c * d + u * I + f * m), t[15] = 1, t);
}
function p_e(t, e) {
  var n = t[0], r = t[1], i = t[2], o = t[3], s = t[4], a = t[5], A = t[6], l = t[7], c = t[8], u = t[9], f = t[10], h = t[11], d = t[12], I = t[13], m = t[14], C = t[15], y = e[0], v = e[1], b = e[2], Q = e[3], w = e[4], R = e[5], M = e[6], O = e[7], L = e[8], N = e[9], k = e[10], $ = e[11], U = e[12], X = e[13], K = e[14], z = e[15];
  return Math.abs(n - y) <= _a * Math.max(1, Math.abs(n), Math.abs(y)) && Math.abs(r - v) <= _a * Math.max(1, Math.abs(r), Math.abs(v)) && Math.abs(i - b) <= _a * Math.max(1, Math.abs(i), Math.abs(b)) && Math.abs(o - Q) <= _a * Math.max(1, Math.abs(o), Math.abs(Q)) && Math.abs(s - w) <= _a * Math.max(1, Math.abs(s), Math.abs(w)) && Math.abs(a - R) <= _a * Math.max(1, Math.abs(a), Math.abs(R)) && Math.abs(A - M) <= _a * Math.max(1, Math.abs(A), Math.abs(M)) && Math.abs(l - O) <= _a * Math.max(1, Math.abs(l), Math.abs(O)) && Math.abs(c - L) <= _a * Math.max(1, Math.abs(c), Math.abs(L)) && Math.abs(u - N) <= _a * Math.max(1, Math.abs(u), Math.abs(N)) && Math.abs(f - k) <= _a * Math.max(1, Math.abs(f), Math.abs(k)) && Math.abs(h - $) <= _a * Math.max(1, Math.abs(h), Math.abs($)) && Math.abs(d - U) <= _a * Math.max(1, Math.abs(d), Math.abs(U)) && Math.abs(I - X) <= _a * Math.max(1, Math.abs(I), Math.abs(X)) && Math.abs(m - K) <= _a * Math.max(1, Math.abs(m), Math.abs(K)) && Math.abs(C - z) <= _a * Math.max(1, Math.abs(C), Math.abs(z));
}
function Lcn() {
  var t = new fd(4);
  return fd != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 0), t;
}
function Mcn(t, e, n) {
  return t[0] = e[0] + n[0], t[1] = e[1] + n[1], t[2] = e[2] + n[2], t[3] = e[3] + n[3], t;
}
function Mle(t, e, n) {
  return t[0] = e[0] * n, t[1] = e[1] * n, t[2] = e[2] * n, t[3] = e[3] * n, t;
}
function Ocn(t) {
  var e = t[0], n = t[1], r = t[2], i = t[3];
  return Math.hypot(e, n, r, i);
}
function Fcn(t) {
  var e = t[0], n = t[1], r = t[2], i = t[3];
  return e * e + n * n + r * r + i * i;
}
function Pcn(t, e) {
  var n = e[0], r = e[1], i = e[2], o = e[3], s = n * n + r * r + i * i + o * o;
  return s > 0 && (s = 1 / Math.sqrt(s)), t[0] = n * s, t[1] = r * s, t[2] = i * s, t[3] = o * s, t;
}
function kcn(t, e) {
  return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3] * e[3];
}
function Gcn(t, e, n, r) {
  var i = e[0], o = e[1], s = e[2], a = e[3];
  return t[0] = i + r * (n[0] - i), t[1] = o + r * (n[1] - o), t[2] = s + r * (n[2] - s), t[3] = a + r * (n[3] - a), t;
}
function Tw(t, e, n) {
  var r = e[0], i = e[1], o = e[2], s = e[3];
  return t[0] = n[0] * r + n[4] * i + n[8] * o + n[12] * s, t[1] = n[1] * r + n[5] * i + n[9] * o + n[13] * s, t[2] = n[2] * r + n[6] * i + n[10] * o + n[14] * s, t[3] = n[3] * r + n[7] * i + n[11] * o + n[15] * s, t;
}
function Ucn(t, e, n) {
  var r = e[0], i = e[1], o = e[2], s = n[0], a = n[1], A = n[2], l = n[3], c = l * r + a * o - A * i, u = l * i + A * r - s * o, f = l * o + s * i - a * r, h = -s * r - a * i - A * o;
  return t[0] = c * l + h * -s + u * -A - f * -a, t[1] = u * l + h * -a + f * -s - c * -A, t[2] = f * l + h * -A + c * -a - u * -s, t[3] = e[3], t;
}
(function() {
  var t = Lcn();
  return function(e, n, r, i, o, s) {
    var a, A;
    for (n || (n = 4), r || (r = 0), i ? A = Math.min(i * n + r, e.length) : A = e.length, a = r; a < A; a += n)
      t[0] = e[a], t[1] = e[a + 1], t[2] = e[a + 2], t[3] = e[a + 3], o(t, t, s), e[a] = t[0], e[a + 1] = t[1], e[a + 2] = t[2], e[a + 3] = t[3];
    return e;
  };
})();
var qee;
(function(t) {
  t[t.COL0ROW0 = 0] = "COL0ROW0", t[t.COL0ROW1 = 1] = "COL0ROW1", t[t.COL0ROW2 = 2] = "COL0ROW2", t[t.COL0ROW3 = 3] = "COL0ROW3", t[t.COL1ROW0 = 4] = "COL1ROW0", t[t.COL1ROW1 = 5] = "COL1ROW1", t[t.COL1ROW2 = 6] = "COL1ROW2", t[t.COL1ROW3 = 7] = "COL1ROW3", t[t.COL2ROW0 = 8] = "COL2ROW0", t[t.COL2ROW1 = 9] = "COL2ROW1", t[t.COL2ROW2 = 10] = "COL2ROW2", t[t.COL2ROW3 = 11] = "COL2ROW3", t[t.COL3ROW0 = 12] = "COL3ROW0", t[t.COL3ROW1 = 13] = "COL3ROW1", t[t.COL3ROW2 = 14] = "COL3ROW2", t[t.COL3ROW3 = 15] = "COL3ROW3";
})(qee || (qee = {}));
const Hcn = 45 * Math.PI / 180, $cn = 1, dV = 0.1, pV = 500, qcn = Object.freeze([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
class pn extends S$e {
  static get IDENTITY() {
    return Ycn();
  }
  static get ZERO() {
    return jcn();
  }
  get ELEMENTS() {
    return 16;
  }
  get RANK() {
    return 4;
  }
  get INDICES() {
    return qee;
  }
  constructor(e) {
    super(-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0), arguments.length === 1 && Array.isArray(e) ? this.copy(e) : this.identity();
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this[2] = e[2], this[3] = e[3], this[4] = e[4], this[5] = e[5], this[6] = e[6], this[7] = e[7], this[8] = e[8], this[9] = e[9], this[10] = e[10], this[11] = e[11], this[12] = e[12], this[13] = e[13], this[14] = e[14], this[15] = e[15], this.check();
  }
  set(e, n, r, i, o, s, a, A, l, c, u, f, h, d, I, m) {
    return this[0] = e, this[1] = n, this[2] = r, this[3] = i, this[4] = o, this[5] = s, this[6] = a, this[7] = A, this[8] = l, this[9] = c, this[10] = u, this[11] = f, this[12] = h, this[13] = d, this[14] = I, this[15] = m, this.check();
  }
  setRowMajor(e, n, r, i, o, s, a, A, l, c, u, f, h, d, I, m) {
    return this[0] = e, this[1] = o, this[2] = l, this[3] = h, this[4] = n, this[5] = s, this[6] = c, this[7] = d, this[8] = r, this[9] = a, this[10] = u, this[11] = I, this[12] = i, this[13] = A, this[14] = f, this[15] = m, this.check();
  }
  toRowMajor(e) {
    return e[0] = this[0], e[1] = this[4], e[2] = this[8], e[3] = this[12], e[4] = this[1], e[5] = this[5], e[6] = this[9], e[7] = this[13], e[8] = this[2], e[9] = this[6], e[10] = this[10], e[11] = this[14], e[12] = this[3], e[13] = this[7], e[14] = this[11], e[15] = this[15], e;
  }
  identity() {
    return this.copy(qcn);
  }
  fromObject(e) {
    return this.check();
  }
  fromQuaternion(e) {
    return wcn(this, e), this.check();
  }
  frustum(e) {
    const {
      left: n,
      right: r,
      bottom: i,
      top: o,
      near: s = dV,
      far: a = pV
    } = e;
    return a === 1 / 0 ? zcn(this, n, r, i, o, s) : xcn(this, n, r, i, o, s, a), this.check();
  }
  lookAt(e) {
    const {
      eye: n,
      center: r = [0, 0, 0],
      up: i = [0, 1, 0]
    } = e;
    return Ncn(this, n, r, i), this.check();
  }
  ortho(e) {
    const {
      left: n,
      right: r,
      bottom: i,
      top: o,
      near: s = dV,
      far: a = pV
    } = e;
    return Tcn(this, n, r, i, o, s, a), this.check();
  }
  orthographic(e) {
    const {
      fovy: n = Hcn,
      aspect: r = $cn,
      focalDistance: i = 1,
      near: o = dV,
      far: s = pV
    } = e;
    I_e(n);
    const a = n / 2, A = i * Math.tan(a), l = A * r;
    return this.ortho({
      left: -l,
      right: l,
      bottom: -A,
      top: A,
      near: o,
      far: s
    });
  }
  perspective(e) {
    const {
      fovy: n = 45 * Math.PI / 180,
      aspect: r = 1,
      near: i = 0.1,
      far: o = 500
    } = e;
    return I_e(n), x$e(this, n, r, i, o), this.check();
  }
  determinant() {
    return bcn(this);
  }
  getScale(e = [-0, -0, -0]) {
    return e[0] = Math.sqrt(this[0] * this[0] + this[1] * this[1] + this[2] * this[2]), e[1] = Math.sqrt(this[4] * this[4] + this[5] * this[5] + this[6] * this[6]), e[2] = Math.sqrt(this[8] * this[8] + this[9] * this[9] + this[10] * this[10]), e;
  }
  getTranslation(e = [-0, -0, -0]) {
    return e[0] = this[12], e[1] = this[13], e[2] = this[14], e;
  }
  getRotation(e, n) {
    e = e || [-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0], n = n || [-0, -0, -0];
    const r = this.getScale(n), i = 1 / r[0], o = 1 / r[1], s = 1 / r[2];
    return e[0] = this[0] * i, e[1] = this[1] * o, e[2] = this[2] * s, e[3] = 0, e[4] = this[4] * i, e[5] = this[5] * o, e[6] = this[6] * s, e[7] = 0, e[8] = this[8] * i, e[9] = this[9] * o, e[10] = this[10] * s, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
  }
  getRotationMatrix3(e, n) {
    e = e || [-0, -0, -0, -0, -0, -0, -0, -0, -0], n = n || [-0, -0, -0];
    const r = this.getScale(n), i = 1 / r[0], o = 1 / r[1], s = 1 / r[2];
    return e[0] = this[0] * i, e[1] = this[1] * o, e[2] = this[2] * s, e[3] = this[4] * i, e[4] = this[5] * o, e[5] = this[6] * s, e[6] = this[8] * i, e[7] = this[9] * o, e[8] = this[10] * s, e;
  }
  transpose() {
    return Bcn(this, this), this.check();
  }
  invert() {
    return EU(this, this), this.check();
  }
  multiplyLeft(e) {
    return Np(this, e, this), this.check();
  }
  multiplyRight(e) {
    return Np(this, this, e), this.check();
  }
  rotateX(e) {
    return Q$e(this, this, e), this.check();
  }
  rotateY(e) {
    return Scn(this, this, e), this.check();
  }
  rotateZ(e) {
    return w$e(this, this, e), this.check();
  }
  rotateXYZ(e) {
    return this.rotateX(e[0]).rotateY(e[1]).rotateZ(e[2]);
  }
  rotateAxis(e, n) {
    return _cn(this, this, e, n), this.check();
  }
  scale(e) {
    return i$(this, this, Array.isArray(e) ? e : [e, e, e]), this.check();
  }
  translate(e) {
    return FT(this, this, e), this.check();
  }
  transform(e, n) {
    return e.length === 4 ? (n = Tw(n || [-0, -0, -0, -0], e, this), vD(n, 4), n) : this.transformAsPoint(e, n);
  }
  transformAsPoint(e, n) {
    const {
      length: r
    } = e;
    let i;
    switch (r) {
      case 2:
        i = I$e(n || [-0, -0], e, this);
        break;
      case 3:
        i = Lle(n || [-0, -0, -0], e, this);
        break;
      default:
        throw new Error("Illegal vector");
    }
    return vD(i, e.length), i;
  }
  transformAsVector(e, n) {
    let r;
    switch (e.length) {
      case 2:
        r = m$e(n || [-0, -0], e, this);
        break;
      case 3:
        r = C$e(n || [-0, -0, -0], e, this);
        break;
      default:
        throw new Error("Illegal vector");
    }
    return vD(r, e.length), r;
  }
  transformPoint(e, n) {
    return this.transformAsPoint(e, n);
  }
  transformVector(e, n) {
    return this.transformAsPoint(e, n);
  }
  transformDirection(e, n) {
    return this.transformAsVector(e, n);
  }
  makeRotationX(e) {
    return this.identity().rotateX(e);
  }
  makeTranslation(e, n, r) {
    return this.identity().translate([e, n, r]);
  }
}
let WF, XF;
function jcn() {
  return WF || (WF = new pn([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), Object.freeze(WF)), WF;
}
function Ycn() {
  return XF || (XF = new pn(), Object.freeze(XF)), XF;
}
function I_e(t) {
  if (t > Math.PI * 2)
    throw Error("expected radians");
}
function zcn(t, e, n, r, i, o) {
  const s = 2 * o / (n - e), a = 2 * o / (i - r), A = (n + e) / (n - e), l = (i + r) / (i - r), c = -1, u = -1, f = -2 * o;
  return t[0] = s, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = a, t[6] = 0, t[7] = 0, t[8] = A, t[9] = l, t[10] = c, t[11] = u, t[12] = 0, t[13] = 0, t[14] = f, t[15] = 0, t;
}
function m_e() {
  var t = new fd(4);
  return fd != Float32Array && (t[0] = 0, t[1] = 0, t[2] = 0), t[3] = 1, t;
}
function Vcn(t) {
  return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 1, t;
}
function R$e(t, e, n) {
  n = n * 0.5;
  var r = Math.sin(n);
  return t[0] = r * e[0], t[1] = r * e[1], t[2] = r * e[2], t[3] = Math.cos(n), t;
}
function C_e(t, e, n) {
  var r = e[0], i = e[1], o = e[2], s = e[3], a = n[0], A = n[1], l = n[2], c = n[3];
  return t[0] = r * c + s * a + i * l - o * A, t[1] = i * c + s * A + o * a - r * l, t[2] = o * c + s * l + r * A - i * a, t[3] = s * c - r * a - i * A - o * l, t;
}
function Jcn(t, e, n) {
  n *= 0.5;
  var r = e[0], i = e[1], o = e[2], s = e[3], a = Math.sin(n), A = Math.cos(n);
  return t[0] = r * A + s * a, t[1] = i * A + o * a, t[2] = o * A - i * a, t[3] = s * A - r * a, t;
}
function Kcn(t, e, n) {
  n *= 0.5;
  var r = e[0], i = e[1], o = e[2], s = e[3], a = Math.sin(n), A = Math.cos(n);
  return t[0] = r * A - o * a, t[1] = i * A + s * a, t[2] = o * A + r * a, t[3] = s * A - i * a, t;
}
function Wcn(t, e, n) {
  n *= 0.5;
  var r = e[0], i = e[1], o = e[2], s = e[3], a = Math.sin(n), A = Math.cos(n);
  return t[0] = r * A + i * a, t[1] = i * A - r * a, t[2] = o * A + s * a, t[3] = s * A - o * a, t;
}
function Xcn(t, e) {
  var n = e[0], r = e[1], i = e[2];
  return t[0] = n, t[1] = r, t[2] = i, t[3] = Math.sqrt(Math.abs(1 - n * n - r * r - i * i)), t;
}
function xk(t, e, n, r) {
  var i = e[0], o = e[1], s = e[2], a = e[3], A = n[0], l = n[1], c = n[2], u = n[3], f, h, d, I, m;
  return h = i * A + o * l + s * c + a * u, h < 0 && (h = -h, A = -A, l = -l, c = -c, u = -u), 1 - h > _a ? (f = Math.acos(h), d = Math.sin(f), I = Math.sin((1 - r) * f) / d, m = Math.sin(r * f) / d) : (I = 1 - r, m = r), t[0] = I * i + m * A, t[1] = I * o + m * l, t[2] = I * s + m * c, t[3] = I * a + m * u, t;
}
function Zcn(t, e) {
  var n = e[0], r = e[1], i = e[2], o = e[3], s = n * n + r * r + i * i + o * o, a = s ? 1 / s : 0;
  return t[0] = -n * a, t[1] = -r * a, t[2] = -i * a, t[3] = o * a, t;
}
function eun(t, e) {
  return t[0] = -e[0], t[1] = -e[1], t[2] = -e[2], t[3] = e[3], t;
}
function D$e(t, e) {
  var n = e[0] + e[4] + e[8], r;
  if (n > 0)
    r = Math.sqrt(n + 1), t[3] = 0.5 * r, r = 0.5 / r, t[0] = (e[5] - e[7]) * r, t[1] = (e[6] - e[2]) * r, t[2] = (e[1] - e[3]) * r;
  else {
    var i = 0;
    e[4] > e[0] && (i = 1), e[8] > e[i * 3 + i] && (i = 2);
    var o = (i + 1) % 3, s = (i + 2) % 3;
    r = Math.sqrt(e[i * 3 + i] - e[o * 3 + o] - e[s * 3 + s] + 1), t[i] = 0.5 * r, r = 0.5 / r, t[3] = (e[o * 3 + s] - e[s * 3 + o]) * r, t[o] = (e[o * 3 + i] + e[i * 3 + o]) * r, t[s] = (e[s * 3 + i] + e[i * 3 + s]) * r;
  }
  return t;
}
var tun = Mcn, nun = Mle, run = kcn, iun = Gcn, oun = Ocn, sun = Fcn, T$e = Pcn, aun = function() {
  var t = y$e(), e = g_e(1, 0, 0), n = g_e(0, 1, 0);
  return function(r, i, o) {
    var s = Nle(i, o);
    return s < -0.999999 ? (wk(t, e, i), _$e(t) < 1e-6 && wk(t, n, i), ocn(t, t), R$e(r, t, Math.PI), r) : s > 0.999999 ? (r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 1, r) : (wk(t, i, o), r[0] = t[0], r[1] = t[1], r[2] = t[2], r[3] = 1 + s, T$e(r, r));
  };
}();
(function() {
  var t = m_e(), e = m_e();
  return function(n, r, i, o, s, a) {
    return xk(t, r, s, a), xk(e, i, o, a), xk(n, t, e, 2 * a * (1 - a)), n;
  };
})();
(function() {
  var t = fcn();
  return function(e, n, r, i) {
    return t[0] = r[0], t[3] = r[1], t[6] = r[2], t[1] = i[0], t[4] = i[1], t[7] = i[2], t[2] = -n[0], t[5] = -n[1], t[8] = -n[2], T$e(e, D$e(e, t));
  };
})();
const Aun = [0, 0, 0, 1];
class VC extends t$ {
  constructor(e = 0, n = 0, r = 0, i = 1) {
    super(-0, -0, -0, -0), Array.isArray(e) && arguments.length === 1 ? this.copy(e) : this.set(e, n, r, i);
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this[2] = e[2], this[3] = e[3], this.check();
  }
  set(e, n, r, i) {
    return this[0] = e, this[1] = n, this[2] = r, this[3] = i, this.check();
  }
  fromObject(e) {
    return this[0] = e.x, this[1] = e.y, this[2] = e.z, this[3] = e.w, this.check();
  }
  fromMatrix3(e) {
    return D$e(this, e), this.check();
  }
  fromAxisRotation(e, n) {
    return R$e(this, e, n), this.check();
  }
  identity() {
    return Vcn(this), this.check();
  }
  setAxisAngle(e, n) {
    return this.fromAxisRotation(e, n);
  }
  get ELEMENTS() {
    return 4;
  }
  get x() {
    return this[0];
  }
  set x(e) {
    this[0] = Vr(e);
  }
  get y() {
    return this[1];
  }
  set y(e) {
    this[1] = Vr(e);
  }
  get z() {
    return this[2];
  }
  set z(e) {
    this[2] = Vr(e);
  }
  get w() {
    return this[3];
  }
  set w(e) {
    this[3] = Vr(e);
  }
  len() {
    return oun(this);
  }
  lengthSquared() {
    return sun(this);
  }
  dot(e) {
    return run(this, e);
  }
  rotationTo(e, n) {
    return aun(this, e, n), this.check();
  }
  add(e) {
    return tun(this, this, e), this.check();
  }
  calculateW() {
    return Xcn(this, this), this.check();
  }
  conjugate() {
    return eun(this, this), this.check();
  }
  invert() {
    return Zcn(this, this), this.check();
  }
  lerp(e, n, r) {
    return r === void 0 ? this.lerp(this, e, n) : (iun(this, e, n, r), this.check());
  }
  multiplyRight(e) {
    return C_e(this, this, e), this.check();
  }
  multiplyLeft(e) {
    return C_e(this, e, this), this.check();
  }
  normalize() {
    const e = this.len(), n = e > 0 ? 1 / e : 0;
    return this[0] = this[0] * n, this[1] = this[1] * n, this[2] = this[2] * n, this[3] = this[3] * n, e === 0 && (this[3] = 1), this.check();
  }
  rotateX(e) {
    return Jcn(this, this, e), this.check();
  }
  rotateY(e) {
    return Kcn(this, this, e), this.check();
  }
  rotateZ(e) {
    return Wcn(this, this, e), this.check();
  }
  scale(e) {
    return nun(this, this, e), this.check();
  }
  slerp(e, n, r) {
    let i, o, s;
    switch (arguments.length) {
      case 1:
        ({
          start: i = Aun,
          target: o,
          ratio: s
        } = e);
        break;
      case 2:
        i = this, o = e, s = n;
        break;
      default:
        i = e, o = n, s = r;
    }
    return xk(this, i, o, s), this.check();
  }
  transformVector4(e, n = new r$()) {
    return Ucn(n, e, this), vD(n, 4);
  }
  lengthSq() {
    return this.lengthSquared();
  }
  setFromAxisAngle(e, n) {
    return this.setAxisAngle(e, n);
  }
  premultiply(e) {
    return this.multiplyLeft(e);
  }
  multiply(e) {
    return this.multiplyRight(e);
  }
}
const E_e = 1e-6, lun = 6371e3;
class HS {
  constructor({
    phi: e = 0,
    theta: n = 0,
    radius: r = 1,
    bearing: i,
    pitch: o,
    altitude: s,
    radiusScale: a = lun
  } = {}) {
    mo(this, "phi", void 0), mo(this, "theta", void 0), mo(this, "radius", void 0), mo(this, "radiusScale", void 0), this.phi = e, this.theta = n, this.radius = r || s || 1, this.radiusScale = a || 1, i !== void 0 && (this.bearing = i), o !== void 0 && (this.pitch = o), this.check();
  }
  toString() {
    return this.formatString($o);
  }
  formatString({
    printTypes: e = !1
  }) {
    const n = xle;
    return "".concat(e ? "Spherical" : "", "[rho:").concat(n(this.radius), ",theta:").concat(n(this.theta), ",phi:").concat(n(this.phi), "]");
  }
  equals(e) {
    return ul(this.radius, e.radius) && ul(this.theta, e.theta) && ul(this.phi, e.phi);
  }
  exactEquals(e) {
    return this.radius === e.radius && this.theta === e.theta && this.phi === e.phi;
  }
  get bearing() {
    return 180 - pg(this.phi);
  }
  set bearing(e) {
    this.phi = Math.PI - f_(e);
  }
  get pitch() {
    return pg(this.theta);
  }
  set pitch(e) {
    this.theta = f_(e);
  }
  get longitude() {
    return pg(this.phi);
  }
  get latitude() {
    return pg(this.theta);
  }
  get lng() {
    return pg(this.phi);
  }
  get lat() {
    return pg(this.theta);
  }
  get z() {
    return (this.radius - 1) * this.radiusScale;
  }
  set(e, n, r) {
    return this.radius = e, this.phi = n, this.theta = r, this.check();
  }
  clone() {
    return new HS().copy(this);
  }
  copy(e) {
    return this.radius = e.radius, this.phi = e.phi, this.theta = e.theta, this.check();
  }
  fromLngLatZ([e, n, r]) {
    return this.radius = 1 + r / this.radiusScale, this.phi = f_(n), this.theta = f_(e), this.check();
  }
  fromVector3(e) {
    return this.radius = Tle(e), this.radius > 0 && (this.theta = Math.atan2(e[0], e[1]), this.phi = Math.acos(So(e[2] / this.radius, -1, 1))), this.check();
  }
  toVector3() {
    return new ct(0, 0, this.radius).rotateX({
      radians: this.theta
    }).rotateZ({
      radians: this.phi
    });
  }
  makeSafe() {
    return this.phi = Math.max(E_e, Math.min(Math.PI - E_e, this.phi)), this;
  }
  check() {
    if (!Number.isFinite(this.phi) || !Number.isFinite(this.theta) || !(this.radius > 0))
      throw new Error("SphericalCoordinates: some fields set to invalid numbers");
    return this;
  }
}
const Rk = "Unknown Euler angle order", ob = 0.99999;
var rA;
(function(t) {
  t[t.ZYX = 0] = "ZYX", t[t.YXZ = 1] = "YXZ", t[t.XZY = 2] = "XZY", t[t.ZXY = 3] = "ZXY", t[t.YZX = 4] = "YZX", t[t.XYZ = 5] = "XYZ";
})(rA || (rA = {}));
class aa extends t$ {
  static get ZYX() {
    return rA.ZYX;
  }
  static get YXZ() {
    return rA.YXZ;
  }
  static get XZY() {
    return rA.XZY;
  }
  static get ZXY() {
    return rA.ZXY;
  }
  static get YZX() {
    return rA.YZX;
  }
  static get XYZ() {
    return rA.XYZ;
  }
  static get RollPitchYaw() {
    return rA.ZYX;
  }
  static get DefaultOrder() {
    return rA.ZYX;
  }
  static get RotationOrders() {
    return rA;
  }
  static rotationOrder(e) {
    return rA[e];
  }
  get ELEMENTS() {
    return 4;
  }
  constructor(e = 0, n = 0, r = 0, i = aa.DefaultOrder) {
    super(-0, -0, -0, -0), arguments.length > 0 && Array.isArray(arguments[0]) ? this.fromVector3(...arguments) : this.set(e, n, r, i);
  }
  fromQuaternion(e) {
    const [n, r, i, o] = e, s = r * r, a = -2 * (s + i * i) + 1, A = 2 * (n * r + o * i);
    let l = -2 * (n * i - o * r);
    const c = 2 * (r * i + o * n), u = -2 * (n * n + s) + 1;
    l = l > 1 ? 1 : l, l = l < -1 ? -1 : l;
    const f = Math.atan2(c, u), h = Math.asin(l), d = Math.atan2(A, a);
    return this.set(f, h, d, aa.RollPitchYaw);
  }
  fromObject(e) {
    throw new Error("not implemented");
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this[2] = e[2], this[3] = Number.isFinite(e[3]) || this.order, this.check();
  }
  set(e = 0, n = 0, r = 0, i) {
    return this[0] = e, this[1] = n, this[2] = r, this[3] = Number.isFinite(i) ? i : this[3], this.check();
  }
  validate() {
    return cun(this[3]) && Number.isFinite(this[0]) && Number.isFinite(this[1]) && Number.isFinite(this[2]);
  }
  toArray(e = [], n = 0) {
    return e[n] = this[0], e[n + 1] = this[1], e[n + 2] = this[2], e;
  }
  toArray4(e = [], n = 0) {
    return e[n] = this[0], e[n + 1] = this[1], e[n + 2] = this[2], e[n + 3] = this[3], e;
  }
  toVector3(e = [-0, -0, -0]) {
    return e[0] = this[0], e[1] = this[1], e[2] = this[2], e;
  }
  get x() {
    return this[0];
  }
  set x(e) {
    this[0] = Vr(e);
  }
  get y() {
    return this[1];
  }
  set y(e) {
    this[1] = Vr(e);
  }
  get z() {
    return this[2];
  }
  set z(e) {
    this[2] = Vr(e);
  }
  get alpha() {
    return this[0];
  }
  set alpha(e) {
    this[0] = Vr(e);
  }
  get beta() {
    return this[1];
  }
  set beta(e) {
    this[1] = Vr(e);
  }
  get gamma() {
    return this[2];
  }
  set gamma(e) {
    this[2] = Vr(e);
  }
  get phi() {
    return this[0];
  }
  set phi(e) {
    this[0] = Vr(e);
  }
  get theta() {
    return this[1];
  }
  set theta(e) {
    this[1] = Vr(e);
  }
  get psi() {
    return this[2];
  }
  set psi(e) {
    this[2] = Vr(e);
  }
  get roll() {
    return this[0];
  }
  set roll(e) {
    this[0] = Vr(e);
  }
  get pitch() {
    return this[1];
  }
  set pitch(e) {
    this[1] = Vr(e);
  }
  get yaw() {
    return this[2];
  }
  set yaw(e) {
    this[2] = Vr(e);
  }
  get order() {
    return this[3];
  }
  set order(e) {
    this[3] = uun(e);
  }
  fromVector3(e, n) {
    return this.set(e[0], e[1], e[2], Number.isFinite(n) ? n : this[3]);
  }
  fromArray(e, n = 0) {
    return this[0] = e[0 + n], this[1] = e[1 + n], this[2] = e[2 + n], e[3] !== void 0 && (this[3] = e[3]), this.check();
  }
  fromRollPitchYaw(e, n, r) {
    return this.set(e, n, r, rA.ZYX);
  }
  fromRotationMatrix(e, n = aa.DefaultOrder) {
    return this._fromRotationMatrix(e, n), this.check();
  }
  getRotationMatrix(e) {
    return this._getRotationMatrix(e);
  }
  getQuaternion() {
    const e = new VC();
    switch (this[4]) {
      case rA.XYZ:
        return e.rotateX(this[0]).rotateY(this[1]).rotateZ(this[2]);
      case rA.YXZ:
        return e.rotateY(this[0]).rotateX(this[1]).rotateZ(this[2]);
      case rA.ZXY:
        return e.rotateZ(this[0]).rotateX(this[1]).rotateY(this[2]);
      case rA.ZYX:
        return e.rotateZ(this[0]).rotateY(this[1]).rotateX(this[2]);
      case rA.YZX:
        return e.rotateY(this[0]).rotateZ(this[1]).rotateX(this[2]);
      case rA.XZY:
        return e.rotateX(this[0]).rotateZ(this[1]).rotateY(this[2]);
      default:
        throw new Error(Rk);
    }
  }
  _fromRotationMatrix(e, n = aa.DefaultOrder) {
    const r = e[0], i = e[4], o = e[8], s = e[1], a = e[5], A = e[9], l = e[2], c = e[6], u = e[10];
    switch (n = n || this[3], n) {
      case aa.XYZ:
        this[1] = Math.asin(So(o, -1, 1)), Math.abs(o) < ob ? (this[0] = Math.atan2(-A, u), this[2] = Math.atan2(-i, r)) : (this[0] = Math.atan2(c, a), this[2] = 0);
        break;
      case aa.YXZ:
        this[0] = Math.asin(-So(A, -1, 1)), Math.abs(A) < ob ? (this[1] = Math.atan2(o, u), this[2] = Math.atan2(s, a)) : (this[1] = Math.atan2(-l, r), this[2] = 0);
        break;
      case aa.ZXY:
        this[0] = Math.asin(So(c, -1, 1)), Math.abs(c) < ob ? (this[1] = Math.atan2(-l, u), this[2] = Math.atan2(-i, a)) : (this[1] = 0, this[2] = Math.atan2(s, r));
        break;
      case aa.ZYX:
        this[1] = Math.asin(-So(l, -1, 1)), Math.abs(l) < ob ? (this[0] = Math.atan2(c, u), this[2] = Math.atan2(s, r)) : (this[0] = 0, this[2] = Math.atan2(-i, a));
        break;
      case aa.YZX:
        this[2] = Math.asin(So(s, -1, 1)), Math.abs(s) < ob ? (this[0] = Math.atan2(-A, a), this[1] = Math.atan2(-l, r)) : (this[0] = 0, this[1] = Math.atan2(o, u));
        break;
      case aa.XZY:
        this[2] = Math.asin(-So(i, -1, 1)), Math.abs(i) < ob ? (this[0] = Math.atan2(c, a), this[1] = Math.atan2(o, r)) : (this[0] = Math.atan2(-A, u), this[1] = 0);
        break;
      default:
        throw new Error(Rk);
    }
    return this[3] = n, this;
  }
  _getRotationMatrix(e) {
    const n = e || [-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0], r = this.x, i = this.y, o = this.z, s = Math.cos(r), a = Math.cos(i), A = Math.cos(o), l = Math.sin(r), c = Math.sin(i), u = Math.sin(o);
    switch (this[3]) {
      case aa.XYZ: {
        const f = s * A, h = s * u, d = l * A, I = l * u;
        n[0] = a * A, n[4] = -a * u, n[8] = c, n[1] = h + d * c, n[5] = f - I * c, n[9] = -l * a, n[2] = I - f * c, n[6] = d + h * c, n[10] = s * a;
        break;
      }
      case aa.YXZ: {
        const f = a * A, h = a * u, d = c * A, I = c * u;
        n[0] = f + I * l, n[4] = d * l - h, n[8] = s * c, n[1] = s * u, n[5] = s * A, n[9] = -l, n[2] = h * l - d, n[6] = I + f * l, n[10] = s * a;
        break;
      }
      case aa.ZXY: {
        const f = a * A, h = a * u, d = c * A, I = c * u;
        n[0] = f - I * l, n[4] = -s * u, n[8] = d + h * l, n[1] = h + d * l, n[5] = s * A, n[9] = I - f * l, n[2] = -s * c, n[6] = l, n[10] = s * a;
        break;
      }
      case aa.ZYX: {
        const f = s * A, h = s * u, d = l * A, I = l * u;
        n[0] = a * A, n[4] = d * c - h, n[8] = f * c + I, n[1] = a * u, n[5] = I * c + f, n[9] = h * c - d, n[2] = -c, n[6] = l * a, n[10] = s * a;
        break;
      }
      case aa.YZX: {
        const f = s * a, h = s * c, d = l * a, I = l * c;
        n[0] = a * A, n[4] = I - f * u, n[8] = d * u + h, n[1] = u, n[5] = s * A, n[9] = -l * A, n[2] = -c * A, n[6] = h * u + d, n[10] = f - I * u;
        break;
      }
      case aa.XZY: {
        const f = s * a, h = s * c, d = l * a, I = l * c;
        n[0] = a * A, n[4] = -u, n[8] = c * A, n[1] = f * u + I, n[5] = s * A, n[9] = h * u - d, n[2] = d * u - h, n[6] = l * A, n[10] = I * u + f;
        break;
      }
      default:
        throw new Error(Rk);
    }
    return n[3] = 0, n[7] = 0, n[11] = 0, n[12] = 0, n[13] = 0, n[14] = 0, n[15] = 1, n;
  }
  toQuaternion() {
    const e = Math.cos(this.yaw * 0.5), n = Math.sin(this.yaw * 0.5), r = Math.cos(this.roll * 0.5), i = Math.sin(this.roll * 0.5), o = Math.cos(this.pitch * 0.5), s = Math.sin(this.pitch * 0.5), a = e * r * o + n * i * s, A = e * i * o - n * r * s, l = e * r * s + n * i * o, c = n * r * o - e * i * s;
    return new VC(A, l, c, a);
  }
}
function cun(t) {
  return t >= 0 && t < 6;
}
function uun(t) {
  if (t < 0 && t >= 6)
    throw new Error(Rk);
  return t;
}
class y_e {
  constructor({
    x: e = 0,
    y: n = 0,
    z: r = 0,
    roll: i = 0,
    pitch: o = 0,
    yaw: s = 0,
    position: a,
    orientation: A
  } = {}) {
    mo(this, "position", void 0), mo(this, "orientation", void 0), Array.isArray(a) && a.length === 3 ? this.position = new ct(a) : this.position = new ct(e, n, r), Array.isArray(A) && A.length === 4 ? this.orientation = new aa(A, A[3]) : this.orientation = new aa(i, o, s, aa.RollPitchYaw);
  }
  get x() {
    return this.position.x;
  }
  set x(e) {
    this.position.x = e;
  }
  get y() {
    return this.position.y;
  }
  set y(e) {
    this.position.y = e;
  }
  get z() {
    return this.position.z;
  }
  set z(e) {
    this.position.z = e;
  }
  get roll() {
    return this.orientation.roll;
  }
  set roll(e) {
    this.orientation.roll = e;
  }
  get pitch() {
    return this.orientation.pitch;
  }
  set pitch(e) {
    this.orientation.pitch = e;
  }
  get yaw() {
    return this.orientation.yaw;
  }
  set yaw(e) {
    this.orientation.yaw = e;
  }
  getPosition() {
    return this.position;
  }
  getOrientation() {
    return this.orientation;
  }
  equals(e) {
    return e ? this.position.equals(e.position) && this.orientation.equals(e.orientation) : !1;
  }
  exactEquals(e) {
    return e ? this.position.exactEquals(e.position) && this.orientation.exactEquals(e.orientation) : !1;
  }
  getTransformationMatrix() {
    const e = Math.sin(this.roll), n = Math.sin(this.pitch), r = Math.sin(this.yaw), i = Math.cos(this.roll), o = Math.cos(this.pitch), s = Math.cos(this.yaw);
    return new pn().setRowMajor(s * o, -r * i + s * n * e, r * e + s * n * i, this.x, r * o, s * i + r * n * e, -s * e + r * n * i, this.y, -n, o * e, o * i, this.z, 0, 0, 0, 1);
  }
  getTransformationMatrixFromPose(e) {
    return new pn().multiplyRight(this.getTransformationMatrix()).multiplyRight(e.getTransformationMatrix().invert());
  }
  getTransformationMatrixToPose(e) {
    return new pn().multiplyRight(e.getTransformationMatrix()).multiplyRight(this.getTransformationMatrix().invert());
  }
}
const $S = {
  EPSILON1: 0.1,
  EPSILON2: 0.01,
  EPSILON3: 1e-3,
  EPSILON4: 1e-4,
  EPSILON5: 1e-5,
  EPSILON6: 1e-6,
  EPSILON7: 1e-7,
  EPSILON8: 1e-8,
  EPSILON9: 1e-9,
  EPSILON10: 1e-10,
  EPSILON11: 1e-11,
  EPSILON12: 1e-12,
  EPSILON13: 1e-13,
  EPSILON14: 1e-14,
  EPSILON15: 1e-15,
  EPSILON16: 1e-16,
  EPSILON17: 1e-17,
  EPSILON18: 1e-18,
  EPSILON19: 1e-19,
  EPSILON20: 1e-20,
  PI_OVER_TWO: Math.PI / 2,
  PI_OVER_FOUR: Math.PI / 4,
  PI_OVER_SIX: Math.PI / 6,
  TWO_PI: Math.PI * 2
}, IV = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], fun = {
  modelMatrix: IV,
  viewMatrix: IV,
  projectionMatrix: IV,
  cameraPositionWorld: [0, 0, 0]
};
function gun() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fun;
  const e = {};
  return t.modelMatrix !== void 0 && (e.modelMatrix = t.modelMatrix), t.viewMatrix !== void 0 && (e.viewMatrix = t.viewMatrix), t.projectionMatrix !== void 0 && (e.projectionMatrix = t.projectionMatrix), t.cameraPositionWorld !== void 0 && (e.cameraPositionWorld = t.cameraPositionWorld), (t.projectionMatrix !== void 0 || t.viewMatrix !== void 0) && (e.viewProjectionMatrix = new pn(t.projectionMatrix).multiplyRight(t.viewMatrix)), e;
}
const N$e = `varying vec4 project_vPositionWorld;
varying vec3 project_vNormalWorld;

vec4 project_getPosition_World() {
  return project_vPositionWorld;
}

vec3 project_getNormal_World() {
  return project_vNormalWorld;
}
`, hun = "".concat(N$e, `
uniform mat4 modelMatrix;
uniform mat4 viewMatrix;
uniform mat4 projectionMatrix;
uniform mat4 viewProjectionMatrix;
uniform vec3 cameraPositionWorld;

struct World {
  vec3 position;
  vec3 normal;
};

World world;

void project_setPosition(vec4 position) {
  project_vPositionWorld = position;
}

void project_setNormal(vec3 normal) {
  project_vNormalWorld = normal;
}

void project_setPositionAndNormal_World(vec3 position, vec3 normal) {
  world.position = position;
  world.normal = normal;
}

void project_setPositionAndNormal_Model(vec3 position, vec3 normal) {
  world.position = (modelMatrix * vec4(position, 1.)).xyz;
  world.normal = mat3(modelMatrix) * normal;
}

vec4 project_model_to_clipspace(vec4 position) {
  return viewProjectionMatrix * modelMatrix * position;
}

vec4 project_model_to_clipspace(vec3 position) {
  return viewProjectionMatrix * modelMatrix * vec4(position, 1.);
}

vec4 project_world_to_clipspace(vec3 position) {
  return viewProjectionMatrix * vec4(position, 1.);
}

vec4 project_view_to_clipspace(vec3 position) {
  return projectionMatrix * vec4(position, 1.);
}

vec4 project_to_clipspace(vec3 position) {
  return viewProjectionMatrix * vec4(position, 1.);
}
`), dun = `
`.concat(N$e), L$e = {
  name: "project",
  getUniforms: gun,
  vs: hun,
  fs: dun
}, v_e = `#if (defined(SHADER_TYPE_FRAGMENT) && defined(LIGHTING_FRAGMENT)) || (defined(SHADER_TYPE_VERTEX) && defined(LIGHTING_VERTEX))

struct AmbientLight {
 vec3 color;
};

struct PointLight {
 vec3 color;
 vec3 position;
 vec3 attenuation;
};

struct DirectionalLight {
  vec3 color;
  vec3 direction;
};

uniform AmbientLight lighting_uAmbientLight;
uniform PointLight lighting_uPointLight[MAX_LIGHTS];
uniform DirectionalLight lighting_uDirectionalLight[MAX_LIGHTS];
uniform int lighting_uPointLightCount;
uniform int lighting_uDirectionalLightCount;

uniform bool lighting_uEnabled;

float getPointLightAttenuation(PointLight pointLight, float distance) {
  return pointLight.attenuation.x
       + pointLight.attenuation.y * distance
       + pointLight.attenuation.z * distance * distance;
}

#endif
`, pun = {
  lightSources: {}
};
function mV() {
  let {
    color: t = [0, 0, 0],
    intensity: e = 1
  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return t.map((n) => n * e / 255);
}
function Iun(t) {
  let {
    ambientLight: e,
    pointLights: n = [],
    directionalLights: r = []
  } = t;
  const i = {};
  return e ? i["lighting_uAmbientLight.color"] = mV(e) : i["lighting_uAmbientLight.color"] = [0, 0, 0], n.forEach((o, s) => {
    i["lighting_uPointLight[".concat(s, "].color")] = mV(o), i["lighting_uPointLight[".concat(s, "].position")] = o.position, i["lighting_uPointLight[".concat(s, "].attenuation")] = o.attenuation || [1, 0, 0];
  }), i.lighting_uPointLightCount = n.length, r.forEach((o, s) => {
    i["lighting_uDirectionalLight[".concat(s, "].color")] = mV(o), i["lighting_uDirectionalLight[".concat(s, "].direction")] = o.direction;
  }), i.lighting_uDirectionalLightCount = r.length, i;
}
function M$e() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : pun;
  if ("lightSources" in t) {
    const {
      ambientLight: e,
      pointLights: n,
      directionalLights: r
    } = t.lightSources || {};
    return e || n && n.length > 0 || r && r.length > 0 ? Object.assign({}, Iun({
      ambientLight: e,
      pointLights: n,
      directionalLights: r
    }), {
      lighting_uEnabled: !0
    }) : {
      lighting_uEnabled: !1
    };
  }
  if ("lights" in t) {
    const e = {
      pointLights: [],
      directionalLights: []
    };
    for (const n of t.lights || [])
      switch (n.type) {
        case "ambient":
          e.ambientLight = n;
          break;
        case "directional":
          e.directionalLights.push(n);
          break;
        case "point":
          e.pointLights.push(n);
          break;
      }
    return M$e({
      lightSources: e
    });
  }
  return {};
}
const Ole = {
  name: "lights",
  vs: v_e,
  fs: v_e,
  getUniforms: M$e,
  defines: {
    MAX_LIGHTS: 3
  }
}, mun = new Float32Array([1, 1, 2]), Cun = {
  lightDirection: mun
};
function Eun() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Cun;
  const e = {};
  return t.lightDirection && (e.dirlight_uLightDirection = t.lightDirection), e;
}
const yun = null, vun = `uniform vec3 dirlight_uLightDirection;
vec4 dirlight_filterColor(vec4 color) {
  vec3 normal = project_getNormal_World();
  float d = abs(dot(normalize(normal), normalize(dirlight_uLightDirection)));
  return vec4(color.rgb * d, color.a);
}
`, Bun = {
  name: "dirlight",
  vs: yun,
  fs: vun,
  getUniforms: Eun,
  dependencies: [L$e]
}, bun = new Uint8Array([0, 255, 255, 255]), _un = {
  pickingSelectedColor: null,
  pickingHighlightColor: bun,
  pickingActive: !1,
  pickingAttribute: !1
};
function Sun() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _un;
  const e = {};
  if (t.pickingSelectedColor !== void 0)
    if (!t.pickingSelectedColor)
      e.picking_uSelectedColorValid = 0;
    else {
      const n = t.pickingSelectedColor.slice(0, 3);
      e.picking_uSelectedColorValid = 1, e.picking_uSelectedColor = n;
    }
  if (t.pickingHighlightColor) {
    const n = Array.from(t.pickingHighlightColor, (r) => r / 255);
    Number.isFinite(n[3]) || (n[3] = 1), e.picking_uHighlightColor = n;
  }
  return t.pickingActive !== void 0 && (e.picking_uActive = !!t.pickingActive, e.picking_uAttribute = !!t.pickingAttribute), e;
}
const Qun = `uniform bool picking_uActive;
uniform bool picking_uAttribute;
uniform vec3 picking_uSelectedColor;
uniform bool picking_uSelectedColorValid;

out vec4 picking_vRGBcolor_Avalid;

const float COLOR_SCALE = 1. / 255.;

bool picking_isColorValid(vec3 color) {
  return dot(color, vec3(1.0)) > 0.001;
}

bool isVertexPicked(vec3 vertexColor) {
  return
    picking_uSelectedColorValid &&
    !picking_isColorValid(abs(vertexColor - picking_uSelectedColor));
}

void picking_setPickingColor(vec3 pickingColor) {
  if (picking_uActive) {
    picking_vRGBcolor_Avalid.a = float(picking_isColorValid(pickingColor));

    if (!picking_uAttribute) {
      picking_vRGBcolor_Avalid.rgb = pickingColor * COLOR_SCALE;
    }
  } else {
    picking_vRGBcolor_Avalid.a = float(isVertexPicked(pickingColor));
  }
}

void picking_setPickingAttribute(float value) {
  if (picking_uAttribute) {
    picking_vRGBcolor_Avalid.r = value;
  }
}
void picking_setPickingAttribute(vec2 value) {
  if (picking_uAttribute) {
    picking_vRGBcolor_Avalid.rg = value;
  }
}
void picking_setPickingAttribute(vec3 value) {
  if (picking_uAttribute) {
    picking_vRGBcolor_Avalid.rgb = value;
  }
}
`, wun = `uniform bool picking_uActive;
uniform vec3 picking_uSelectedColor;
uniform vec4 picking_uHighlightColor;

in vec4 picking_vRGBcolor_Avalid;
vec4 picking_filterHighlightColor(vec4 color) {
  if (picking_uActive) {
    return color;
  }
  bool selected = bool(picking_vRGBcolor_Avalid.a);

  if (selected) {
    float highLightAlpha = picking_uHighlightColor.a;
    float blendedAlpha = highLightAlpha + color.a * (1.0 - highLightAlpha);
    float highLightRatio = highLightAlpha / blendedAlpha;

    vec3 blendedRGB = mix(color.rgb, picking_uHighlightColor.rgb, highLightRatio);
    return vec4(blendedRGB, blendedAlpha);
  } else {
    return color;
  }
}
vec4 picking_filterPickingColor(vec4 color) {
  if (picking_uActive) {
    if (picking_vRGBcolor_Avalid.a == 0.0) {
      discard;
    }
    return picking_vRGBcolor_Avalid;
  }
  return color;
}
vec4 picking_filterColor(vec4 color) {
  vec4 highightColor = picking_filterHighlightColor(color);
  return picking_filterPickingColor(highightColor);
}

`, O$e = {
  name: "picking",
  vs: Qun,
  fs: wun,
  getUniforms: Sun
}, F$e = `
uniform float lighting_uAmbient;
uniform float lighting_uDiffuse;
uniform float lighting_uShininess;
uniform vec3  lighting_uSpecularColor;

vec3 lighting_getLightColor(vec3 surfaceColor, vec3 light_direction, vec3 view_direction, vec3 normal_worldspace, vec3 color) {
    vec3 halfway_direction = normalize(light_direction + view_direction);
    float lambertian = dot(light_direction, normal_worldspace);
    float specular = 0.0;
    if (lambertian > 0.0) {
      float specular_angle = max(dot(normal_worldspace, halfway_direction), 0.0);
      specular = pow(specular_angle, lighting_uShininess);
    }
    lambertian = max(lambertian, 0.0);
    return (lambertian * lighting_uDiffuse * surfaceColor + specular * lighting_uSpecularColor) * color;
}

vec3 lighting_getLightColor(vec3 surfaceColor, vec3 cameraPosition, vec3 position_worldspace, vec3 normal_worldspace) {
  vec3 lightColor = surfaceColor;

  if (lighting_uEnabled) {
    vec3 view_direction = normalize(cameraPosition - position_worldspace);
    lightColor = lighting_uAmbient * surfaceColor * lighting_uAmbientLight.color;

    for (int i = 0; i < MAX_LIGHTS; i++) {
      if (i >= lighting_uPointLightCount) {
        break;
      }
      PointLight pointLight = lighting_uPointLight[i];
      vec3 light_position_worldspace = pointLight.position;
      vec3 light_direction = normalize(light_position_worldspace - position_worldspace);
      lightColor += lighting_getLightColor(surfaceColor, light_direction, view_direction, normal_worldspace, pointLight.color);
    }

    for (int i = 0; i < MAX_LIGHTS; i++) {
      if (i >= lighting_uDirectionalLightCount) {
        break;
      }
      DirectionalLight directionalLight = lighting_uDirectionalLight[i];
      lightColor += lighting_getLightColor(surfaceColor, -directionalLight.direction, view_direction, normal_worldspace, directionalLight.color);
    }
  }
  return lightColor;
}

vec3 lighting_getSpecularLightColor(vec3 cameraPosition, vec3 position_worldspace, vec3 normal_worldspace) {
  vec3 lightColor = vec3(0, 0, 0);
  vec3 surfaceColor = vec3(0, 0, 0);

  if (lighting_uEnabled) {
    vec3 view_direction = normalize(cameraPosition - position_worldspace);

    for (int i = 0; i < MAX_LIGHTS; i++) {
      if (i >= lighting_uPointLightCount) {
        break;
      }
      PointLight pointLight = lighting_uPointLight[i];
      vec3 light_position_worldspace = pointLight.position;
      vec3 light_direction = normalize(light_position_worldspace - position_worldspace);
      lightColor += lighting_getLightColor(surfaceColor, light_direction, view_direction, normal_worldspace, pointLight.color);
    }

    for (int i = 0; i < MAX_LIGHTS; i++) {
      if (i >= lighting_uDirectionalLightCount) {
        break;
      }
      DirectionalLight directionalLight = lighting_uDirectionalLight[i];
      lightColor += lighting_getLightColor(surfaceColor, -directionalLight.direction, view_direction, normal_worldspace, directionalLight.color);
    }
  }
  return lightColor;
}
`, xun = {};
function Run(t) {
  const {
    ambient: e = 0.35,
    diffuse: n = 0.6,
    shininess: r = 32,
    specularColor: i = [30, 30, 30]
  } = t;
  return {
    lighting_uAmbient: e,
    lighting_uDiffuse: n,
    lighting_uShininess: r,
    lighting_uSpecularColor: i.map((o) => o / 255)
  };
}
function P$e() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : xun;
  if (!("material" in t))
    return {};
  const {
    material: e
  } = t;
  return e ? Run(e) : {
    lighting_uEnabled: !1
  };
}
const cM = {
  name: "gouraud-lighting",
  dependencies: [Ole],
  vs: F$e,
  defines: {
    LIGHTING_VERTEX: 1
  },
  getUniforms: P$e
}, o$ = {
  name: "phong-lighting",
  dependencies: [Ole],
  fs: F$e,
  defines: {
    LIGHTING_FRAGMENT: 1
  },
  getUniforms: P$e
}, Dun = `uniform mat4 u_MVPMatrix;
uniform mat4 u_ModelMatrix;
uniform mat4 u_NormalMatrix;

varying vec3 pbr_vPosition;
varying vec2 pbr_vUV;

#ifdef HAS_NORMALS
# ifdef HAS_TANGENTS
varying mat3 pbr_vTBN;
# else
varying vec3 pbr_vNormal;
# endif
#endif

void pbr_setPositionNormalTangentUV(vec4 position, vec4 normal, vec4 tangent, vec2 uv)
{
  vec4 pos = u_ModelMatrix * position;
  pbr_vPosition = vec3(pos.xyz) / pos.w;

#ifdef HAS_NORMALS
#ifdef HAS_TANGENTS
  vec3 normalW = normalize(vec3(u_NormalMatrix * vec4(normal.xyz, 0.0)));
  vec3 tangentW = normalize(vec3(u_ModelMatrix * vec4(tangent.xyz, 0.0)));
  vec3 bitangentW = cross(normalW, tangentW) * tangent.w;
  pbr_vTBN = mat3(tangentW, bitangentW, normalW);
#else
  pbr_vNormal = normalize(vec3(u_ModelMatrix * vec4(normal.xyz, 0.0)));
#endif
#endif

#ifdef HAS_UV
  pbr_vUV = uv;
#else
  pbr_vUV = vec2(0.,0.);
#endif
}
`, Tun = `#if defined(USE_TEX_LOD) && !defined(FEATURE_GLSL_TEXTURE_LOD)
# error PBR fragment shader: Texture LOD is not available
#endif

#if !defined(HAS_TANGENTS) && !defined(FEATURE_GLSL_DERIVATIVES)
# error PBR fragment shader: Derivatives are not available
#endif


#if (__VERSION__ < 300)
  #define SMART_FOR(INIT, WEBGL1COND, WEBGL2COND, INCR) for (INIT; WEBGL1COND; INCR)
#else
  #define SMART_FOR(INIT, WEBGL1COND, WEBGL2COND, INCR) for (INIT; WEBGL2COND; INCR)
#endif

precision highp float;

uniform bool pbr_uUnlit;

#ifdef USE_IBL
uniform samplerCube u_DiffuseEnvSampler;
uniform samplerCube u_SpecularEnvSampler;
uniform sampler2D u_brdfLUT;
uniform vec2 u_ScaleIBLAmbient;
#endif

#ifdef HAS_BASECOLORMAP
uniform sampler2D u_BaseColorSampler;
#endif
#ifdef HAS_NORMALMAP
uniform sampler2D u_NormalSampler;
uniform float u_NormalScale;
#endif
#ifdef HAS_EMISSIVEMAP
uniform sampler2D u_EmissiveSampler;
uniform vec3 u_EmissiveFactor;
#endif
#ifdef HAS_METALROUGHNESSMAP
uniform sampler2D u_MetallicRoughnessSampler;
#endif
#ifdef HAS_OCCLUSIONMAP
uniform sampler2D u_OcclusionSampler;
uniform float u_OcclusionStrength;
#endif

#ifdef ALPHA_CUTOFF
uniform float u_AlphaCutoff;
#endif

uniform vec2 u_MetallicRoughnessValues;
uniform vec4 u_BaseColorFactor;

uniform vec3 u_Camera;
#ifdef PBR_DEBUG
uniform vec4 u_ScaleDiffBaseMR;
uniform vec4 u_ScaleFGDSpec;
#endif

varying vec3 pbr_vPosition;

varying vec2 pbr_vUV;

#ifdef HAS_NORMALS
#ifdef HAS_TANGENTS
varying mat3 pbr_vTBN;
#else
varying vec3 pbr_vNormal;
#endif
#endif


struct PBRInfo
{
  float NdotL;
  float NdotV;
  float NdotH;
  float LdotH;
  float VdotH;
  float perceptualRoughness;
  float metalness;
  vec3 reflectance0;
  vec3 reflectance90;
  float alphaRoughness;
  vec3 diffuseColor;
  vec3 specularColor;
  vec3 n;
  vec3 v;
};

const float M_PI = 3.141592653589793;
const float c_MinRoughness = 0.04;

vec4 SRGBtoLINEAR(vec4 srgbIn)
{
#ifdef MANUAL_SRGB
#ifdef SRGB_FAST_APPROXIMATION
  vec3 linOut = pow(srgbIn.xyz,vec3(2.2));
#else
  vec3 bLess = step(vec3(0.04045),srgbIn.xyz);
  vec3 linOut = mix( srgbIn.xyz/vec3(12.92), pow((srgbIn.xyz+vec3(0.055))/vec3(1.055),vec3(2.4)), bLess );
#endif
  return vec4(linOut,srgbIn.w);;
#else
  return srgbIn;
#endif
}

vec3 getNormal()
{
#ifndef HAS_TANGENTS
  vec3 pos_dx = dFdx(pbr_vPosition);
  vec3 pos_dy = dFdy(pbr_vPosition);
  vec3 tex_dx = dFdx(vec3(pbr_vUV, 0.0));
  vec3 tex_dy = dFdy(vec3(pbr_vUV, 0.0));
  vec3 t = (tex_dy.t * pos_dx - tex_dx.t * pos_dy) / (tex_dx.s * tex_dy.t - tex_dy.s * tex_dx.t);

#ifdef HAS_NORMALS
  vec3 ng = normalize(pbr_vNormal);
#else
  vec3 ng = cross(pos_dx, pos_dy);
#endif

  t = normalize(t - ng * dot(ng, t));
  vec3 b = normalize(cross(ng, t));
  mat3 tbn = mat3(t, b, ng);
#else
  mat3 tbn = pbr_vTBN;
#endif

#ifdef HAS_NORMALMAP
  vec3 n = texture2D(u_NormalSampler, pbr_vUV).rgb;
  n = normalize(tbn * ((2.0 * n - 1.0) * vec3(u_NormalScale, u_NormalScale, 1.0)));
#else
  vec3 n = normalize(tbn[2].xyz);
#endif

  return n;
}


#ifdef USE_IBL
vec3 getIBLContribution(PBRInfo pbrInputs, vec3 n, vec3 reflection)
{
  float mipCount = 9.0;
  float lod = (pbrInputs.perceptualRoughness * mipCount);
  vec3 brdf = SRGBtoLINEAR(texture2D(u_brdfLUT,
    vec2(pbrInputs.NdotV, 1.0 - pbrInputs.perceptualRoughness))).rgb;
  vec3 diffuseLight = SRGBtoLINEAR(textureCube(u_DiffuseEnvSampler, n)).rgb;

#ifdef USE_TEX_LOD
  vec3 specularLight = SRGBtoLINEAR(textureCubeLod(u_SpecularEnvSampler, reflection, lod)).rgb;
#else
  vec3 specularLight = SRGBtoLINEAR(textureCube(u_SpecularEnvSampler, reflection)).rgb;
#endif

  vec3 diffuse = diffuseLight * pbrInputs.diffuseColor;
  vec3 specular = specularLight * (pbrInputs.specularColor * brdf.x + brdf.y);
  diffuse *= u_ScaleIBLAmbient.x;
  specular *= u_ScaleIBLAmbient.y;

  return diffuse + specular;
}
#endif


vec3 diffuse(PBRInfo pbrInputs)
{
  return pbrInputs.diffuseColor / M_PI;
}

vec3 specularReflection(PBRInfo pbrInputs)
{
  return pbrInputs.reflectance0 +
    (pbrInputs.reflectance90 - pbrInputs.reflectance0) *
    pow(clamp(1.0 - pbrInputs.VdotH, 0.0, 1.0), 5.0);
}



float geometricOcclusion(PBRInfo pbrInputs)
{
  float NdotL = pbrInputs.NdotL;
  float NdotV = pbrInputs.NdotV;
  float r = pbrInputs.alphaRoughness;

  float attenuationL = 2.0 * NdotL / (NdotL + sqrt(r * r + (1.0 - r * r) * (NdotL * NdotL)));
  float attenuationV = 2.0 * NdotV / (NdotV + sqrt(r * r + (1.0 - r * r) * (NdotV * NdotV)));
  return attenuationL * attenuationV;
}





float microfacetDistribution(PBRInfo pbrInputs)
{
  float roughnessSq = pbrInputs.alphaRoughness * pbrInputs.alphaRoughness;
  float f = (pbrInputs.NdotH * roughnessSq - pbrInputs.NdotH) * pbrInputs.NdotH + 1.0;
  return roughnessSq / (M_PI * f * f);
}

void PBRInfo_setAmbientLight(inout PBRInfo pbrInputs) {
  pbrInputs.NdotL = 1.0;
  pbrInputs.NdotH = 0.0;
  pbrInputs.LdotH = 0.0;
  pbrInputs.VdotH = 1.0;
}

void PBRInfo_setDirectionalLight(inout PBRInfo pbrInputs, vec3 lightDirection) {
  vec3 n = pbrInputs.n;
  vec3 v = pbrInputs.v;
  vec3 l = normalize(lightDirection);
  vec3 h = normalize(l+v);

  pbrInputs.NdotL = clamp(dot(n, l), 0.001, 1.0);
  pbrInputs.NdotH = clamp(dot(n, h), 0.0, 1.0);
  pbrInputs.LdotH = clamp(dot(l, h), 0.0, 1.0);
  pbrInputs.VdotH = clamp(dot(v, h), 0.0, 1.0);
}

void PBRInfo_setPointLight(inout PBRInfo pbrInputs, PointLight pointLight) {
  vec3 light_direction = normalize(pointLight.position - pbr_vPosition);
  PBRInfo_setDirectionalLight(pbrInputs, light_direction);
}

vec3 calculateFinalColor(PBRInfo pbrInputs, vec3 lightColor) {
  vec3 F = specularReflection(pbrInputs);
  float G = geometricOcclusion(pbrInputs);
  float D = microfacetDistribution(pbrInputs);
  vec3 diffuseContrib = (1.0 - F) * diffuse(pbrInputs);
  vec3 specContrib = F * G * D / (4.0 * pbrInputs.NdotL * pbrInputs.NdotV);
  return pbrInputs.NdotL * lightColor * (diffuseContrib + specContrib);
}

vec4 pbr_filterColor(vec4 colorUnused)
{
#ifdef HAS_BASECOLORMAP
  vec4 baseColor = SRGBtoLINEAR(texture2D(u_BaseColorSampler, pbr_vUV)) * u_BaseColorFactor;
#else
  vec4 baseColor = u_BaseColorFactor;
#endif

#ifdef ALPHA_CUTOFF
  if (baseColor.a < u_AlphaCutoff) {
    discard;
  }
#endif

  vec3 color = vec3(0, 0, 0);

  if(pbr_uUnlit){
    color.rgb = baseColor.rgb;
  }
  else{


    float perceptualRoughness = u_MetallicRoughnessValues.y;
    float metallic = u_MetallicRoughnessValues.x;
#ifdef HAS_METALROUGHNESSMAP

    vec4 mrSample = texture2D(u_MetallicRoughnessSampler, pbr_vUV);
    perceptualRoughness = mrSample.g * perceptualRoughness;
    metallic = mrSample.b * metallic;
#endif
    perceptualRoughness = clamp(perceptualRoughness, c_MinRoughness, 1.0);
    metallic = clamp(metallic, 0.0, 1.0);

    float alphaRoughness = perceptualRoughness * perceptualRoughness;

    vec3 f0 = vec3(0.04);
    vec3 diffuseColor = baseColor.rgb * (vec3(1.0) - f0);
    diffuseColor *= 1.0 - metallic;
    vec3 specularColor = mix(f0, baseColor.rgb, metallic);
    float reflectance = max(max(specularColor.r, specularColor.g), specularColor.b);



    float reflectance90 = clamp(reflectance * 25.0, 0.0, 1.0);
    vec3 specularEnvironmentR0 = specularColor.rgb;
    vec3 specularEnvironmentR90 = vec3(1.0, 1.0, 1.0) * reflectance90;

    vec3 n = getNormal();
    vec3 v = normalize(u_Camera - pbr_vPosition);

    float NdotV = clamp(abs(dot(n, v)), 0.001, 1.0);
    vec3 reflection = -normalize(reflect(v, n));

    PBRInfo pbrInputs = PBRInfo(
      0.0,
      NdotV,
      0.0,
      0.0,
      0.0,
      perceptualRoughness,
      metallic,
      specularEnvironmentR0,
      specularEnvironmentR90,
      alphaRoughness,
      diffuseColor,
      specularColor,
      n,
      v
    );

#ifdef USE_LIGHTS
    PBRInfo_setAmbientLight(pbrInputs);
    color += calculateFinalColor(pbrInputs, lighting_uAmbientLight.color);
    SMART_FOR(int i = 0, i < MAX_LIGHTS, i < lighting_uDirectionalLightCount, i++) {
      if (i < lighting_uDirectionalLightCount) {
        PBRInfo_setDirectionalLight(pbrInputs, lighting_uDirectionalLight[i].direction);
        color += calculateFinalColor(pbrInputs, lighting_uDirectionalLight[i].color);
      }
    }
    SMART_FOR(int i = 0, i < MAX_LIGHTS, i < lighting_uPointLightCount, i++) {
      if (i < lighting_uPointLightCount) {
        PBRInfo_setPointLight(pbrInputs, lighting_uPointLight[i]);
        float attenuation = getPointLightAttenuation(lighting_uPointLight[i], distance(lighting_uPointLight[i].position, pbr_vPosition));
        color += calculateFinalColor(pbrInputs, lighting_uPointLight[i].color / attenuation);
      }
    }
#endif
#ifdef USE_IBL
    color += getIBLContribution(pbrInputs, n, reflection);
#endif
#ifdef HAS_OCCLUSIONMAP
    float ao = texture2D(u_OcclusionSampler, pbr_vUV).r;
    color = mix(color, color * ao, u_OcclusionStrength);
#endif

#ifdef HAS_EMISSIVEMAP
    vec3 emissive = SRGBtoLINEAR(texture2D(u_EmissiveSampler, pbr_vUV)).rgb * u_EmissiveFactor;
    color += emissive;
#endif

#ifdef PBR_DEBUG





    color = mix(color, baseColor.rgb, u_ScaleDiffBaseMR.y);
    color = mix(color, vec3(metallic), u_ScaleDiffBaseMR.z);
    color = mix(color, vec3(perceptualRoughness), u_ScaleDiffBaseMR.w);
#endif

  }

  return vec4(pow(color,vec3(1.0/2.2)), baseColor.a);
}
`, s$ = {
  name: "pbr",
  vs: Dun,
  fs: Tun,
  defines: {
    LIGHTING_FRAGMENT: 1
  },
  dependencies: [Ole]
}, Nun = `attribute float transform_elementID;
vec2 transform_getPixelSizeHalf(vec2 size) {
  return vec2(1.) / (2. * size);
}

vec2 transform_getPixelIndices(vec2 texSize, vec2 pixelSizeHalf) {
  float yIndex = floor((transform_elementID / texSize[0]) + pixelSizeHalf[1]);
  float xIndex = transform_elementID - (yIndex * texSize[0]);
  return vec2(xIndex, yIndex);
}
vec2 transform_getTexCoord(vec2 size) {
  vec2 pixelSizeHalf = transform_getPixelSizeHalf(size);
  vec2 indices = transform_getPixelIndices(size, pixelSizeHalf);
  vec2 coord = indices / size + pixelSizeHalf;
  return coord;
}
vec2 transform_getPos(vec2 size) {
  vec2 texCoord = transform_getTexCoord(size);
  vec2 pos = (texCoord * (2.0, 2.0)) - (1., 1.);
  return pos;
}
vec4 transform_getInput(sampler2D texSampler, vec2 size) {
  vec2 texCoord = transform_getTexCoord(size);
  vec4 textureColor = texture2D(texSampler, texCoord);
  return textureColor;
}
`, Lun = {
  name: "transform",
  vs: Nun,
  fs: null
};
class SE {
  static getDefaultProgramManager(e) {
    return e.luma = e.luma || {}, e.luma.defaultProgramManager = e.luma.defaultProgramManager || new SE(e), e.luma.defaultProgramManager;
  }
  constructor(e) {
    this.gl = e, this._programCache = {}, this._getUniforms = {}, this._registeredModules = {}, this._hookFunctions = [], this._defaultModules = [], this._hashes = {}, this._hashCounter = 0, this.stateHash = 0, this._useCounts = {};
  }
  addDefaultModule(e) {
    this._defaultModules.find((n) => n.name === e.name) || this._defaultModules.push(e), this.stateHash++;
  }
  removeDefaultModule(e) {
    const n = typeof e == "string" ? e : e.name;
    this._defaultModules = this._defaultModules.filter((r) => r.name !== n), this.stateHash++;
  }
  addShaderHook(e, n) {
    n && (e = Object.assign(n, {
      hook: e
    })), this._hookFunctions.push(e), this.stateHash++;
  }
  get() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      vs: n = "",
      fs: r = "",
      defines: i = {},
      inject: o = {},
      varyings: s = [],
      bufferMode: a = 35981,
      transpileToGLSL100: A = !1
    } = e, l = this._getModuleList(e.modules), c = this._getHash(n), u = this._getHash(r), f = l.map((v) => this._getHash(v.name)).sort(), h = s.map((v) => this._getHash(v)), d = Object.keys(i).sort(), I = Object.keys(o).sort(), m = [], C = [];
    for (const v of d)
      m.push(this._getHash(v)), m.push(this._getHash(i[v]));
    for (const v of I)
      C.push(this._getHash(v)), C.push(this._getHash(o[v]));
    const y = "".concat(c, "/").concat(u, "D").concat(m.join("/"), "M").concat(f.join("/"), "I").concat(C.join("/"), "V").concat(h.join("/"), "H").concat(this.stateHash, "B").concat(a).concat(A ? "T" : "");
    if (!this._programCache[y]) {
      const v = uln(this.gl, {
        vs: n,
        fs: r,
        modules: l,
        inject: o,
        defines: i,
        hookFunctions: this._hookFunctions,
        transpileToGLSL100: A
      });
      this._programCache[y] = new ble(this.gl, {
        hash: y,
        vs: v.vs,
        fs: v.fs,
        varyings: s,
        bufferMode: a
      }), this._getUniforms[y] = v.getUniforms || ((b) => {
      }), this._useCounts[y] = 0;
    }
    return this._useCounts[y]++, this._programCache[y];
  }
  getUniforms(e) {
    return this._getUniforms[e.hash] || null;
  }
  release(e) {
    const n = e.hash;
    this._useCounts[n]--, this._useCounts[n] === 0 && (this._programCache[n].delete(), delete this._programCache[n], delete this._getUniforms[n], delete this._useCounts[n]);
  }
  _getHash(e) {
    return this._hashes[e] === void 0 && (this._hashes[e] = this._hashCounter++), this._hashes[e];
  }
  _getModuleList() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const n = new Array(this._defaultModules.length + e.length), r = {};
    let i = 0;
    for (let o = 0, s = this._defaultModules.length; o < s; ++o) {
      const a = this._defaultModules[o], A = a.name;
      n[i++] = a, r[A] = !0;
    }
    for (let o = 0, s = e.length; o < s; ++o) {
      const a = e[o], A = a.name;
      r[A] || (n[i++] = a, r[A] = !0);
    }
    return n.length = i, n;
  }
}
const Mun = {
  POSITION: "positions",
  NORMAL: "normals",
  COLOR_0: "colors",
  TEXCOORD_0: "texCoords",
  TEXCOORD_1: "texCoords1",
  TEXCOORD_2: "texCoords2"
};
function Oun(t, e, n) {
  const r = {};
  let i = e.indices;
  for (const o in e.attributes) {
    const s = e.attributes[o], a = Fun(o, n);
    if (o === "indices")
      i = s;
    else if (s.constant)
      r[a] = s.value;
    else {
      const A = s.value, l = {
        ...s
      };
      delete l.value, r[a] = [new ro(t, A), l], Pun(o, l);
    }
  }
  if (i) {
    const o = i.value || i;
    dn(o instanceof Uint16Array || o instanceof Uint32Array, 'attribute array for "indices" must be of integer type');
    const s = {
      size: 1,
      isIndexed: i.isIndexed === void 0 ? !0 : i.isIndexed
    };
    r.indices = [new ro(t, {
      data: o,
      target: 34963
    }), s];
  }
  return r;
}
function Fun(t, e) {
  const {
    attributeMap: n = Mun
  } = e || {};
  return n && n[t] || t;
}
function Pun(t, e) {
  let n;
  switch (t) {
    case "texCoords":
    case "texCoord1":
    case "texCoord2":
    case "texCoord3":
      n = "uvs";
      break;
    case "vertices":
    case "positions":
    case "normals":
    case "pickingColors":
      n = "vectors";
      break;
  }
  switch (n) {
    case "vectors":
      e.size = e.size || 3;
      break;
    case "uvs":
      e.size = e.size || 2;
      break;
  }
  dn(Number.isFinite(e.size), "attribute ".concat(t, " needs size"));
}
const sb = 2, kun = 1e4, Gun = "Model needs drawMode and vertexCount", B_e = () => {
}, Uun = {};
let Ta = class {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const {
      id: r = PA("model")
    } = n;
    dn(oM(e)), this.id = r, this.gl = e, this.id = n.id || PA("Model"), this.lastLogTime = 0, this.animated = !1, this.initialize(n);
  }
  initialize(e) {
    this.props = {}, this.programManager = e.programManager || SE.getDefaultProgramManager(this.gl), this._programManagerState = -1, this._managedProgram = !1;
    const {
      program: n = null,
      vs: r,
      fs: i,
      modules: o,
      defines: s,
      inject: a,
      varyings: A,
      bufferMode: l,
      transpileToGLSL100: c
    } = e;
    this.programProps = {
      program: n,
      vs: r,
      fs: i,
      modules: o,
      defines: s,
      inject: a,
      varyings: A,
      bufferMode: l,
      transpileToGLSL100: c
    }, this.program = null, this.vertexArray = null, this._programDirty = !0, this.userData = {}, this.needsRedraw = !0, this._attributes = {}, this.attributes = {}, this.uniforms = {}, this.pickable = !0, this._checkProgram(), this.setUniforms(Object.assign({}, this.getModuleUniforms(e.moduleSettings))), this.drawMode = e.drawMode !== void 0 ? e.drawMode : 4, this.vertexCount = e.vertexCount || 0, this.geometryBuffers = {}, this.isInstanced = e.isInstanced || e.instanced || e.instanceCount > 0, this._setModelProps(e), this.geometry = {}, dn(this.drawMode !== void 0 && Number.isFinite(this.vertexCount), Gun);
  }
  setProps(e) {
    this._setModelProps(e);
  }
  delete() {
    for (const e in this._attributes)
      this._attributes[e] !== this.attributes[e] && this._attributes[e].delete();
    this._managedProgram && (this.programManager.release(this.program), this._managedProgram = !1), this.vertexArray.delete(), this._deleteGeometryBuffers();
  }
  getDrawMode() {
    return this.drawMode;
  }
  getVertexCount() {
    return this.vertexCount;
  }
  getInstanceCount() {
    return this.instanceCount;
  }
  getAttributes() {
    return this.attributes;
  }
  getProgram() {
    return this.program;
  }
  setProgram(e) {
    const {
      program: n,
      vs: r,
      fs: i,
      modules: o,
      defines: s,
      inject: a,
      varyings: A,
      bufferMode: l,
      transpileToGLSL100: c
    } = e;
    this.programProps = {
      program: n,
      vs: r,
      fs: i,
      modules: o,
      defines: s,
      inject: a,
      varyings: A,
      bufferMode: l,
      transpileToGLSL100: c
    }, this._programDirty = !0;
  }
  getUniforms() {
    return this.uniforms;
  }
  setDrawMode(e) {
    return this.drawMode = e, this;
  }
  setVertexCount(e) {
    return dn(Number.isFinite(e)), this.vertexCount = e, this;
  }
  setInstanceCount(e) {
    return dn(Number.isFinite(e)), this.instanceCount = e, this;
  }
  setGeometry(e) {
    return this.drawMode = e.drawMode, this.vertexCount = e.getVertexCount(), this._deleteGeometryBuffers(), this.geometryBuffers = Oun(this.gl, e), this.vertexArray.setAttributes(this.geometryBuffers), this;
  }
  setAttributes() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (GS(e))
      return this;
    const n = {};
    for (const r in e) {
      const i = e[r];
      n[r] = i.getValue ? i.getValue() : i;
    }
    return this.vertexArray.setAttributes(n), this;
  }
  setUniforms() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Object.assign(this.uniforms, e), this;
  }
  getModuleUniforms(e) {
    this._checkProgram();
    const n = this.programManager.getUniforms(this.program);
    return n ? n(e) : {};
  }
  updateModuleSettings(e) {
    const n = this.getModuleUniforms(e || {});
    return this.setUniforms(n);
  }
  clear(e) {
    return aM(this.program.gl, e), this;
  }
  draw() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this._checkProgram();
    const {
      moduleSettings: n = null,
      framebuffer: r,
      uniforms: i = {},
      attributes: o = {},
      transformFeedback: s = this.transformFeedback,
      parameters: a = {},
      vertexArray: A = this.vertexArray
    } = e;
    this.setAttributes(o), this.updateModuleSettings(n), this.setUniforms(i);
    let l;
    On.priority >= sb && (l = this._logDrawCallStart(sb));
    const c = this.vertexArray.getDrawParams(), {
      isIndexed: u = c.isIndexed,
      indexType: f = c.indexType,
      indexOffset: h = c.indexOffset,
      vertexArrayInstanced: d = c.isInstanced
    } = this.props;
    d && !this.isInstanced && On.warn("Found instanced attributes on non-instanced model", this.id)();
    const {
      isInstanced: I,
      instanceCount: m
    } = this, {
      onBeforeRender: C = B_e,
      onAfterRender: y = B_e
    } = this.props;
    C(), this.program.setUniforms(this.uniforms);
    const v = this.program.draw(Object.assign(Uun, e, {
      logPriority: l,
      uniforms: null,
      framebuffer: r,
      parameters: a,
      drawMode: this.getDrawMode(),
      vertexCount: this.getVertexCount(),
      vertexArray: A,
      transformFeedback: s,
      isIndexed: u,
      indexType: f,
      isInstanced: I,
      instanceCount: m,
      offset: u ? h : 0
    }));
    return y(), On.priority >= sb && this._logDrawCallEnd(l, A, r), v;
  }
  transform() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      discard: n = !0,
      feedbackBuffers: r,
      unbindModels: i = []
    } = e;
    let {
      parameters: o
    } = e;
    r && this._setFeedbackBuffers(r), n && (o = Object.assign({}, o, {
      [35977]: n
    })), i.forEach((s) => s.vertexArray.unbindBuffers());
    try {
      this.draw(Object.assign({}, e, {
        parameters: o
      }));
    } finally {
      i.forEach((s) => s.vertexArray.bindBuffers());
    }
    return this;
  }
  render() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return On.warn("Model.render() is deprecated. Use Model.setUniforms() and Model.draw()")(), this.setUniforms(e).draw();
  }
  _setModelProps(e) {
    Object.assign(this.props, e), "uniforms" in e && this.setUniforms(e.uniforms), "pickable" in e && (this.pickable = e.pickable), "instanceCount" in e && (this.instanceCount = e.instanceCount), "geometry" in e && this.setGeometry(e.geometry), "attributes" in e && this.setAttributes(e.attributes), "_feedbackBuffers" in e && this._setFeedbackBuffers(e._feedbackBuffers);
  }
  _checkProgram() {
    if (!(this._programDirty || this.programManager.stateHash !== this._programManagerState))
      return;
    let {
      program: n
    } = this.programProps;
    if (n)
      this._managedProgram = !1;
    else {
      const {
        vs: r,
        fs: i,
        modules: o,
        inject: s,
        defines: a,
        varyings: A,
        bufferMode: l,
        transpileToGLSL100: c
      } = this.programProps;
      n = this.programManager.get({
        vs: r,
        fs: i,
        modules: o,
        inject: s,
        defines: a,
        varyings: A,
        bufferMode: l,
        transpileToGLSL100: c
      }), this.program && this._managedProgram && this.programManager.release(this.program), this._programManagerState = this.programManager.stateHash, this._managedProgram = !0;
    }
    dn(n instanceof ble, "Model needs a program"), this._programDirty = !1, n !== this.program && (this.program = n, this.vertexArray ? this.vertexArray.setProps({
      program: this.program,
      attributes: this.vertexArray.attributes
    }) : this.vertexArray = new QAn(this.gl, {
      program: this.program
    }), this.setUniforms(Object.assign({}, this.getModuleUniforms())));
  }
  _deleteGeometryBuffers() {
    for (const e in this.geometryBuffers) {
      const n = this.geometryBuffers[e][0] || this.geometryBuffers[e];
      n instanceof ro && n.delete();
    }
  }
  _setAnimationProps(e) {
    this.animated && dn(e, "Model.draw(): animated uniforms but no animationProps");
  }
  _setFeedbackBuffers() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (GS(e))
      return this;
    const {
      gl: n
    } = this.program;
    return this.transformFeedback = this.transformFeedback || new _le(n, {
      program: this.program
    }), this.transformFeedback.setBuffers(e), this;
  }
  _logDrawCallStart(e) {
    const n = e > 3 ? 0 : kun;
    if (!(Date.now() - this.lastLogTime < n))
      return this.lastLogTime = Date.now(), On.group(sb, ">>> DRAWING MODEL ".concat(this.id), {
        collapsed: On.level <= 2
      })(), e;
  }
  _logDrawCallEnd(e, n, r, i) {
    if (e === void 0)
      return;
    const o = RAn({
      vertexArray: n,
      header: "".concat(this.id, " attributes"),
      attributes: this._attributes
    }), {
      table: s,
      unusedTable: a,
      unusedCount: A
    } = r_e({
      header: "".concat(this.id, " uniforms"),
      program: this.program,
      uniforms: Object.assign({}, this.program.uniforms, r)
    }), {
      table: l,
      count: c
    } = r_e({
      header: "".concat(this.id, " uniforms"),
      program: this.program,
      uniforms: Object.assign({}, this.program.uniforms, r),
      undefinedOnly: !0
    });
    c > 0 && On.log("MISSING UNIFORMS", Object.keys(l))(), A > 0 && On.log("UNUSED UNIFORMS", Object.keys(a))();
    const u = TAn(this.vertexArray.configuration);
    On.table(e, o)(), On.table(e, s)(), On.table(e + 1, u)(), i && i.log({
      logLevel: sb,
      message: "Rendered to ".concat(i.id)
    }), On.groupEnd(sb)();
  }
};
class Hun {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.gl = e, this.currentIndex = 0, this.feedbackMap = {}, this.varyings = null, this.bindings = [], this.resources = {}, this._initialize(n), Object.seal(this);
  }
  setupResources(e) {
    for (const n of this.bindings)
      this._setupTransformFeedback(n, e);
  }
  updateModelProps() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      varyings: n
    } = this;
    return n.length > 0 && (e = Object.assign({}, e, {
      varyings: n
    })), e;
  }
  getDrawOptions() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = this.bindings[this.currentIndex], {
      sourceBuffers: r,
      transformFeedback: i
    } = n;
    return {
      attributes: Object.assign({}, r, e.attributes),
      transformFeedback: i
    };
  }
  swap() {
    return this.feedbackMap ? (this.currentIndex = this._getNextIndex(), !0) : !1;
  }
  update() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this._setupBuffers(e);
  }
  getBuffer(e) {
    const {
      feedbackBuffers: n
    } = this.bindings[this.currentIndex], r = e ? n[e] : null;
    return r ? r instanceof ro ? r : r.buffer : null;
  }
  getData() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      varyingName: n
    } = e, r = this.getBuffer(n);
    return r ? r.getData() : null;
  }
  delete() {
    for (const e in this.resources)
      this.resources[e].delete();
  }
  _initialize() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this._setupBuffers(e), this.varyings = e.varyings || Object.keys(this.bindings[this.currentIndex].feedbackBuffers), this.varyings.length > 0 && dn(Fr(this.gl));
  }
  _getFeedbackBuffers(e) {
    const {
      sourceBuffers: n = {}
    } = e, r = {};
    if (this.bindings[this.currentIndex] && Object.assign(r, this.bindings[this.currentIndex].feedbackBuffers), this.feedbackMap)
      for (const i in this.feedbackMap) {
        const o = this.feedbackMap[i];
        i in n && (r[o] = i);
      }
    Object.assign(r, e.feedbackBuffers);
    for (const i in r) {
      const o = r[i];
      if (typeof o == "string") {
        const s = n[o], {
          byteLength: a,
          usage: A,
          accessor: l
        } = s;
        r[i] = this._createNewBuffer(i, {
          byteLength: a,
          usage: A,
          accessor: l
        });
      }
    }
    return r;
  }
  _setupBuffers() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      sourceBuffers: n = null
    } = e;
    Object.assign(this.feedbackMap, e.feedbackMap);
    const r = this._getFeedbackBuffers(e);
    this._updateBindings({
      sourceBuffers: n,
      feedbackBuffers: r
    });
  }
  _setupTransformFeedback(e, n) {
    let {
      model: r
    } = n;
    const {
      program: i
    } = r;
    e.transformFeedback = new _le(this.gl, {
      program: i,
      buffers: e.feedbackBuffers
    });
  }
  _updateBindings(e) {
    if (this.bindings[this.currentIndex] = this._updateBinding(this.bindings[this.currentIndex], e), this.feedbackMap) {
      const {
        sourceBuffers: n,
        feedbackBuffers: r
      } = this._swapBuffers(this.bindings[this.currentIndex]), i = this._getNextIndex();
      this.bindings[i] = this._updateBinding(this.bindings[i], {
        sourceBuffers: n,
        feedbackBuffers: r
      });
    }
  }
  _updateBinding(e, n) {
    return e ? (Object.assign(e.sourceBuffers, n.sourceBuffers), Object.assign(e.feedbackBuffers, n.feedbackBuffers), e.transformFeedback && e.transformFeedback.setBuffers(e.feedbackBuffers), e) : {
      sourceBuffers: Object.assign({}, n.sourceBuffers),
      feedbackBuffers: Object.assign({}, n.feedbackBuffers)
    };
  }
  _swapBuffers(e) {
    if (!this.feedbackMap)
      return null;
    const n = Object.assign({}, e.sourceBuffers), r = Object.assign({}, e.feedbackBuffers);
    for (const i in this.feedbackMap) {
      const o = this.feedbackMap[i];
      n[i] = e.feedbackBuffers[o], r[o] = e.sourceBuffers[i], dn(r[o] instanceof ro);
    }
    return {
      sourceBuffers: n,
      feedbackBuffers: r
    };
  }
  _createNewBuffer(e, n) {
    const r = new ro(this.gl, n);
    return this.resources[e] && this.resources[e].delete(), this.resources[e] = r, r;
  }
  _getNextIndex() {
    return (this.currentIndex + 1) % 2;
  }
}
const $un = "transform_uSampler_", yU = "transform_uSize_", b_e = "transform_position";
function qun(t) {
  let {
    vs: e,
    sourceTextureMap: n,
    targetTextureVarying: r,
    targetTexture: i
  } = t, s = Object.keys(n).length, a = null;
  const A = {};
  let l = e, c = {};
  if (s > 0 || r) {
    const u = l.split(`
`), f = u.slice();
    if (u.forEach((h, d, I) => {
      if (s > 0) {
        const m = Jun(h, n);
        if (m) {
          const {
            updatedLine: C,
            inject: y
          } = m;
          f[d] = C, c = Gee([c, y]), Object.assign(A, m.samplerTextureMap), s--;
        }
      }
      r && !a && (a = Vun(h, r));
    }), r) {
      dn(i);
      const h = "".concat(yU).concat(r), d = "uniform vec2 ".concat(h, `;
`), I = "     vec2 ".concat(b_e, " = transform_getPos(").concat(h, `);
     gl_Position = vec4(`).concat(b_e, `, 0, 1.);
`);
      c = Gee([c, {
        "vs:#decl": d,
        "vs:#main-start": I
      }]);
    }
    l = f.join(`
`);
  }
  return {
    vs: l,
    targetTextureType: a,
    inject: c,
    samplerTextureMap: A
  };
}
function jun(t) {
  let {
    sourceTextureMap: e,
    targetTextureVarying: n,
    targetTexture: r
  } = t;
  const i = {};
  let o, s;
  n && ({
    width: o,
    height: s
  } = r, i["".concat(yU).concat(n)] = [o, s]);
  for (const a in e)
    ({
      width: o,
      height: s
    } = e[a]), i["".concat(yU).concat(a)] = [o, s];
  return i;
}
function Yun(t) {
  return a$e(t, ["attribute", "in"]);
}
function zun(t) {
  const e = "".concat($un).concat(t), n = "".concat(yU).concat(t), r = "  uniform sampler2D ".concat(e, `;
  uniform vec2 `).concat(n, ";");
  return {
    samplerName: e,
    sizeName: n,
    uniformDeclerations: r
  };
}
function Vun(t, e) {
  const n = a$e(t, ["varying", "out"]);
  return n && n.name === e ? n.type : null;
}
function Jun(t, e) {
  const n = {}, r = Yun(t);
  if (!r)
    return null;
  const {
    type: i,
    name: o
  } = r;
  if (o && e[o]) {
    const s = "// ".concat(t, " => Replaced by Transform with a sampler"), {
      samplerName: a,
      sizeName: A,
      uniformDeclerations: l
    } = zun(o), c = Eln(i), u = "  ".concat(i, " ").concat(o, " = transform_getInput(").concat(a, ", ").concat(A, ").").concat(c, `;
`);
    return n[a] = o, {
      updatedLine: s,
      inject: {
        "vs:#decl": l,
        "vs:#main-start": u
      },
      samplerTextureMap: n
    };
  }
  return null;
}
const Kun = {
  [10241]: 9728,
  [10240]: 9728,
  [10242]: 33071,
  [10243]: 33071
}, Wun = "transform_output";
class Xun {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.gl = e, this.id = this.currentIndex = 0, this._swapTexture = null, this.targetTextureVarying = null, this.targetTextureType = null, this.samplerTextureMap = null, this.bindings = [], this.resources = {}, this._initialize(n), Object.seal(this);
  }
  updateModelProps() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = this._processVertexShader(e);
    return Object.assign({}, e, n);
  }
  getDrawOptions() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      sourceBuffers: n,
      sourceTextures: r,
      framebuffer: i,
      targetTexture: o
    } = this.bindings[this.currentIndex], s = Object.assign({}, n, e.attributes), a = Object.assign({}, e.uniforms), A = Object.assign({}, e.parameters);
    let l = e.discard;
    if (this.hasSourceTextures || this.hasTargetTexture) {
      s.transform_elementID = this.elementIDBuffer;
      for (const u in this.samplerTextureMap) {
        const f = this.samplerTextureMap[u];
        a[u] = r[f];
      }
      this._setSourceTextureParameters();
      const c = jun({
        sourceTextureMap: r,
        targetTextureVarying: this.targetTextureVarying,
        targetTexture: o
      });
      Object.assign(a, c);
    }
    return this.hasTargetTexture && (l = !1, A.viewport = [0, 0, i.width, i.height]), {
      attributes: s,
      framebuffer: i,
      uniforms: a,
      discard: l,
      parameters: A
    };
  }
  swap() {
    return this._swapTexture ? (this.currentIndex = this._getNextIndex(), !0) : !1;
  }
  update() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this._setupTextures(e);
  }
  getTargetTexture() {
    const {
      targetTexture: e
    } = this.bindings[this.currentIndex];
    return e;
  }
  getData() {
    let {
      packed: e = !1
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      framebuffer: n
    } = this.bindings[this.currentIndex], r = AM(n);
    if (!e)
      return r;
    const i = r.constructor, o = yln(this.targetTextureType), s = new i(r.length * o / 4);
    let a = 0;
    for (let A = 0; A < r.length; A += 4)
      for (let l = 0; l < o; l++)
        s[a++] = r[A + l];
    return s;
  }
  getFramebuffer() {
    return this.bindings[this.currentIndex].framebuffer;
  }
  delete() {
    this.ownTexture && this.ownTexture.delete(), this.elementIDBuffer && this.elementIDBuffer.delete();
  }
  _initialize() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      _targetTextureVarying: n,
      _swapTexture: r
    } = e;
    this._swapTexture = r, this.targetTextureVarying = n, this.hasTargetTexture = n, this._setupTextures(e);
  }
  _createTargetTexture(e) {
    const {
      sourceTextures: n,
      textureOrReference: r
    } = e;
    if (r instanceof xo)
      return r;
    const i = n[r];
    return i ? (this._targetRefTexName = r, this._createNewTexture(i)) : null;
  }
  _setupTextures() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      sourceBuffers: n,
      _sourceTextures: r = {},
      _targetTexture: i
    } = e, o = this._createTargetTexture({
      sourceTextures: r,
      textureOrReference: i
    });
    this.hasSourceTextures = this.hasSourceTextures || r && Object.keys(r).length > 0, this._updateBindings({
      sourceBuffers: n,
      sourceTextures: r,
      targetTexture: o
    }), "elementCount" in e && this._updateElementIDBuffer(e.elementCount);
  }
  _updateElementIDBuffer(e) {
    if (typeof e != "number" || this.elementCount >= e)
      return;
    const n = new Float32Array(e);
    n.forEach((r, i, o) => {
      o[i] = i;
    }), this.elementIDBuffer ? this.elementIDBuffer.setData({
      data: n
    }) : this.elementIDBuffer = new ro(this.gl, {
      data: n,
      accessor: {
        size: 1
      }
    }), this.elementCount = e;
  }
  _updateBindings(e) {
    if (this.bindings[this.currentIndex] = this._updateBinding(this.bindings[this.currentIndex], e), this._swapTexture) {
      const {
        sourceTextures: n,
        targetTexture: r
      } = this._swapTextures(this.bindings[this.currentIndex]), i = this._getNextIndex();
      this.bindings[i] = this._updateBinding(this.bindings[i], {
        sourceTextures: n,
        targetTexture: r
      });
    }
  }
  _updateBinding(e, n) {
    const {
      sourceBuffers: r,
      sourceTextures: i,
      targetTexture: o
    } = n;
    if (e || (e = {
      sourceBuffers: {},
      sourceTextures: {},
      targetTexture: null
    }), Object.assign(e.sourceTextures, i), Object.assign(e.sourceBuffers, r), o) {
      e.targetTexture = o;
      const {
        width: s,
        height: a
      } = o, {
        framebuffer: A
      } = e;
      A ? (A.update({
        attachments: {
          [36064]: o
        },
        resizeAttachments: !1
      }), A.resize({
        width: s,
        height: a
      })) : e.framebuffer = new Da(this.gl, {
        id: "transform-framebuffer",
        width: s,
        height: a,
        attachments: {
          [36064]: o
        }
      });
    }
    return e;
  }
  _setSourceTextureParameters() {
    const e = this.currentIndex, {
      sourceTextures: n
    } = this.bindings[e];
    for (const r in n)
      n[r].setParameters(Kun);
  }
  _swapTextures(e) {
    if (!this._swapTexture)
      return null;
    const n = Object.assign({}, e.sourceTextures);
    n[this._swapTexture] = e.targetTexture;
    const r = e.sourceTextures[this._swapTexture];
    return {
      sourceTextures: n,
      targetTexture: r
    };
  }
  _createNewTexture(e) {
    const n = J9e(e, {
      parameters: {
        [10241]: 9728,
        [10240]: 9728,
        [10242]: 33071,
        [10243]: 33071
      },
      pixelStore: {
        [37440]: !1
      }
    });
    return this.ownTexture && this.ownTexture.delete(), this.ownTexture = n, n;
  }
  _getNextIndex() {
    return (this.currentIndex + 1) % 2;
  }
  _processVertexShader() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      sourceTextures: n,
      targetTexture: r
    } = this.bindings[this.currentIndex], {
      vs: i,
      uniforms: o,
      targetTextureType: s,
      inject: a,
      samplerTextureMap: A
    } = qun({
      vs: e.vs,
      sourceTextureMap: n,
      targetTextureVarying: this.targetTextureVarying,
      targetTexture: r
    }), l = Gee([e.inject || {}, a]);
    this.targetTextureType = s, this.samplerTextureMap = A;
    const c = e._fs || A$e({
      version: W9e(i),
      input: this.targetTextureVarying,
      inputType: s,
      output: Wun
    }), u = this.hasSourceTextures || this.targetTextureVarying ? [Lun].concat(e.modules || []) : e.modules;
    return {
      vs: i,
      fs: c,
      modules: u,
      uniforms: o,
      inject: l
    };
  }
}
let a$ = class {
  static isSupported(e) {
    return Fr(e);
  }
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.gl = e, this.model = null, this.elementCount = 0, this.bufferTransform = null, this.textureTransform = null, this.elementIDBuffer = null, this._initialize(n), Object.seal(this);
  }
  delete() {
    const {
      model: e,
      bufferTransform: n,
      textureTransform: r
    } = this;
    e && e.delete(), n && n.delete(), r && r.delete();
  }
  run() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      clearRenderTarget: n = !0
    } = e, r = this._updateDrawOptions(e);
    n && r.framebuffer && r.framebuffer.clear({
      color: !0
    }), this.model.transform(r);
  }
  swap() {
    let e = !1;
    const n = [this.bufferTransform, this.textureTransform].filter(Boolean);
    for (const r of n)
      e = e || r.swap();
    dn(e, "Nothing to swap");
  }
  getBuffer() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return this.bufferTransform && this.bufferTransform.getBuffer(e);
  }
  getData() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = [this.bufferTransform, this.textureTransform].filter(Boolean);
    for (const r of n) {
      const i = r.getData(e);
      if (i)
        return i;
    }
    return null;
  }
  getFramebuffer() {
    return this.textureTransform && this.textureTransform.getFramebuffer();
  }
  update() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    "elementCount" in e && this.model.setVertexCount(e.elementCount);
    const n = [this.bufferTransform, this.textureTransform].filter(Boolean);
    for (const r of n)
      r.update(e);
  }
  _initialize() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      gl: n
    } = this;
    this._buildResourceTransforms(n, e), e = this._updateModelProps(e), this.model = new Ta(n, Object.assign({}, e, {
      fs: e.fs || A$e({
        version: W9e(e.vs)
      }),
      id: e.id || "transform-model",
      drawMode: e.drawMode || 0,
      vertexCount: e.elementCount
    })), this.bufferTransform && this.bufferTransform.setupResources({
      model: this.model
    });
  }
  _updateModelProps(e) {
    let n = Object.assign({}, e);
    const r = [this.bufferTransform, this.textureTransform].filter(Boolean);
    for (const i of r)
      n = i.updateModelProps(n);
    return n;
  }
  _buildResourceTransforms(e, n) {
    Zun(n) && (this.bufferTransform = new Hun(e, n)), efn(n) && (this.textureTransform = new Xun(e, n)), dn(this.bufferTransform || this.textureTransform, "must provide source/feedback buffers or source/target textures");
  }
  _updateDrawOptions(e) {
    let n = Object.assign({}, e);
    const r = [this.bufferTransform, this.textureTransform].filter(Boolean);
    for (const i of r)
      n = Object.assign(n, i.getDrawOptions(n));
    return n;
  }
};
function Zun(t) {
  return !!(!GS(t.feedbackBuffers) || !GS(t.feedbackMap) || t.varyings && t.varyings.length > 0);
}
function efn(t) {
  return !!(!GS(t._sourceTextures) || t._targetTexture || t._targetTextureVarying);
}
const S_e = {
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6
};
class Os {
  static get DRAW_MODE() {
    return S_e;
  }
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      id: n = PA("geometry"),
      drawMode: r = S_e.TRIANGLES,
      attributes: i = {},
      indices: o = null,
      vertexCount: s = null
    } = e;
    this.id = n, this.drawMode = r | 0, this.attributes = {}, this.userData = {}, this._setAttributes(i, o), this.vertexCount = s || this._calculateVertexCount(this.attributes, this.indices);
  }
  get mode() {
    return this.drawMode;
  }
  getVertexCount() {
    return this.vertexCount;
  }
  getAttributes() {
    return this.indices ? {
      indices: this.indices,
      ...this.attributes
    } : this.attributes;
  }
  _print(e) {
    return "Geometry ".concat(this.id, " attribute ").concat(e);
  }
  _setAttributes(e, n) {
    n && (this.indices = ArrayBuffer.isView(n) ? {
      value: n,
      size: 1
    } : n);
    for (const r in e) {
      let i = e[r];
      i = ArrayBuffer.isView(i) ? {
        value: i
      } : i, dn(ArrayBuffer.isView(i.value), "".concat(this._print(r), ": must be typed array or object with value as typed array")), (r === "POSITION" || r === "positions") && !i.size && (i.size = 3), r === "indices" ? (dn(!this.indices), this.indices = i) : this.attributes[r] = i;
    }
    return this.indices && this.indices.isIndexed !== void 0 && (this.indices = Object.assign({}, this.indices), delete this.indices.isIndexed), this;
  }
  _calculateVertexCount(e, n) {
    if (n)
      return n.value.length;
    let r = 1 / 0;
    for (const i in e) {
      const o = e[i], {
        value: s,
        size: a,
        constant: A
      } = o;
      !A && s && a >= 1 && (r = Math.min(r, s.length / a));
    }
    return dn(Number.isFinite(r)), r;
  }
}
const tfn = {
  x: [2, 0, 1],
  y: [0, 1, 2],
  z: [1, 2, 0]
};
class Fle extends Os {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      id: n = PA("truncated-code-geometry")
    } = e, {
      indices: r,
      attributes: i
    } = nfn(e);
    super({
      ...e,
      id: n,
      indices: r,
      attributes: {
        ...i,
        ...e.attributes
      }
    });
  }
}
function nfn(t) {
  const {
    bottomRadius: e = 0,
    topRadius: n = 0,
    height: r = 1,
    nradial: i = 10,
    nvertical: o = 10,
    verticalAxis: s = "y",
    topCap: a = !1,
    bottomCap: A = !1
  } = t, l = (a ? 2 : 0) + (A ? 2 : 0), c = (i + 1) * (o + 1 + l), u = Math.atan2(e - n, r), f = Math.sin, h = Math.cos, d = Math.PI, I = h(u), m = f(u), C = a ? -2 : 0, y = o + (A ? 2 : 0), v = i + 1, b = new Uint16Array(i * (o + l) * 6), Q = tfn[s], w = new Float32Array(c * 3), R = new Float32Array(c * 3), M = new Float32Array(c * 2);
  let O = 0, L = 0;
  for (let N = C; N <= y; N++) {
    let k = N / o, $ = r * k, U;
    N < 0 ? ($ = 0, k = 1, U = e) : N > o ? ($ = r, k = 1, U = n) : U = e + (n - e) * (N / o), (N === -2 || N === o + 2) && (U = 0, k = 0), $ -= r / 2;
    for (let X = 0; X < v; X++) {
      const K = f(X * d * 2 / i), z = h(X * d * 2 / i);
      w[O + Q[0]] = K * U, w[O + Q[1]] = $, w[O + Q[2]] = z * U, R[O + Q[0]] = N < 0 || N > o ? 0 : K * I, R[O + Q[1]] = N < 0 ? -1 : N > o ? 1 : m, R[O + Q[2]] = N < 0 || N > o ? 0 : z * I, M[L + 0] = X / i, M[L + 1] = k, L += 2, O += 3;
    }
  }
  for (let N = 0; N < o + l; N++)
    for (let k = 0; k < i; k++) {
      const $ = (N * i + k) * 6;
      b[$ + 0] = v * (N + 0) + 0 + k, b[$ + 1] = v * (N + 0) + 1 + k, b[$ + 2] = v * (N + 1) + 1 + k, b[$ + 3] = v * (N + 0) + 0 + k, b[$ + 4] = v * (N + 1) + 1 + k, b[$ + 5] = v * (N + 1) + 0 + k;
    }
  return {
    indices: b,
    attributes: {
      POSITION: {
        size: 3,
        value: w
      },
      NORMAL: {
        size: 3,
        value: R
      },
      TEXCOORD_0: {
        size: 2,
        value: M
      }
    }
  };
}
class rfn extends Fle {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      id: n = PA("cone-geometry"),
      radius: r = 1,
      cap: i = !0
    } = e;
    super({
      ...e,
      id: n,
      topRadius: 0,
      topCap: !!i,
      bottomCap: !!i,
      bottomRadius: r
    });
  }
}
const ifn = new Uint16Array([0, 1, 2, 0, 2, 3, 4, 5, 6, 4, 6, 7, 8, 9, 10, 8, 10, 11, 12, 13, 14, 12, 14, 15, 16, 17, 18, 16, 18, 19, 20, 21, 22, 20, 22, 23]), ofn = new Float32Array([-1, -1, 1, 1, -1, 1, 1, 1, 1, -1, 1, 1, -1, -1, -1, -1, 1, -1, 1, 1, -1, 1, -1, -1, -1, 1, -1, -1, 1, 1, 1, 1, 1, 1, 1, -1, -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, -1, 1, -1, -1, -1, -1, -1, 1, -1, 1, 1, -1, 1, -1]), sfn = new Float32Array([0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0]), afn = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 0, 1, 0, 0, 1, 0, 1, 1, 1, 1, 0, 1, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 0, 0, 0, 0, 1, 0, 1, 1, 0, 1]), Afn = {
  POSITION: {
    size: 3,
    value: new Float32Array(ofn)
  },
  NORMAL: {
    size: 3,
    value: new Float32Array(sfn)
  },
  TEXCOORD_0: {
    size: 2,
    value: new Float32Array(afn)
  }
};
class k$e extends Os {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      id: n = PA("cube-geometry")
    } = e;
    super({
      ...e,
      id: n,
      indices: {
        size: 1,
        value: new Uint16Array(ifn)
      },
      attributes: {
        ...Afn,
        ...e.attributes
      }
    });
  }
}
class lfn extends Fle {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      id: n = PA("cylinder-geometry"),
      radius: r = 1
    } = e;
    super({
      ...e,
      id: n,
      bottomRadius: r,
      topRadius: r
    });
  }
}
const cfn = [-1, 0, 0, 0, 1, 0, 0, 0, -1, 0, 0, 1, 0, -1, 0, 1, 0, 0], ufn = [3, 4, 5, 3, 5, 1, 3, 1, 0, 3, 0, 4, 4, 0, 2, 4, 2, 5, 2, 0, 1, 5, 2, 1];
class ffn extends Os {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      id: n = PA("ico-sphere-geometry")
    } = e, {
      indices: r,
      attributes: i
    } = gfn(e);
    super({
      ...e,
      id: n,
      indices: r,
      attributes: {
        ...i,
        ...e.attributes
      }
    });
  }
}
function gfn(t) {
  const {
    iterations: e = 0
  } = t, n = Math.PI, r = n * 2, i = [...cfn];
  let o = [...ufn];
  i.push(), o.push();
  const s = (() => {
    const c = {};
    return (u, f) => {
      u *= 3, f *= 3;
      const h = u < f ? u : f, d = u > f ? u : f, I = "".concat(h, "|").concat(d);
      if (I in c)
        return c[I];
      const m = i[u], C = i[u + 1], y = i[u + 2], v = i[f], b = i[f + 1], Q = i[f + 2];
      let w = (m + v) / 2, R = (C + b) / 2, M = (y + Q) / 2;
      const O = Math.sqrt(w * w + R * R + M * M);
      return w /= O, R /= O, M /= O, i.push(w, R, M), c[I] = i.length / 3 - 1;
    };
  })();
  for (let c = 0; c < e; c++) {
    const u = [];
    for (let f = 0; f < o.length; f += 3) {
      const h = s(o[f + 0], o[f + 1]), d = s(o[f + 1], o[f + 2]), I = s(o[f + 2], o[f + 0]);
      u.push(I, o[f + 0], h, h, o[f + 1], d, d, o[f + 2], I, h, d, I);
    }
    o = u;
  }
  const a = new Array(i.length), A = new Array(i.length / 3 * 2), l = o.length;
  for (let c = l - 3; c >= 0; c -= 3) {
    const u = o[c + 0], f = o[c + 1], h = o[c + 2], d = u * 3, I = f * 3, m = h * 3, C = u * 2, y = f * 2, v = h * 2, b = i[d + 0], Q = i[d + 1], w = i[d + 2], R = Math.acos(w / Math.sqrt(b * b + Q * Q + w * w)), M = Math.atan2(Q, b) + n, O = R / n, L = 1 - M / r, N = i[I + 0], k = i[I + 1], $ = i[I + 2], U = Math.acos($ / Math.sqrt(N * N + k * k + $ * $)), X = Math.atan2(k, N) + n, K = U / n, z = 1 - X / r, Y = i[m + 0], V = i[m + 1], Z = i[m + 2], ce = Math.acos(Z / Math.sqrt(Y * Y + V * V + Z * Z)), ee = Math.atan2(V, Y) + n, pe = ce / n, Ce = 1 - ee / r, Be = [Y - N, V - k, Z - $], Ie = [b - N, Q - k, w - $], Qe = new ct(Be).cross(Ie).normalize();
    let xe;
    (L === 0 || z === 0 || Ce === 0) && (L === 0 || L > 0.5) && (z === 0 || z > 0.5) && (Ce === 0 || Ce > 0.5) && (i.push(i[d + 0], i[d + 1], i[d + 2]), xe = i.length / 3 - 1, o.push(xe), A[xe * 2 + 0] = 1, A[xe * 2 + 1] = O, a[xe * 3 + 0] = Qe.x, a[xe * 3 + 1] = Qe.y, a[xe * 3 + 2] = Qe.z, i.push(i[I + 0], i[I + 1], i[I + 2]), xe = i.length / 3 - 1, o.push(xe), A[xe * 2 + 0] = 1, A[xe * 2 + 1] = K, a[xe * 3 + 0] = Qe.x, a[xe * 3 + 1] = Qe.y, a[xe * 3 + 2] = Qe.z, i.push(i[m + 0], i[m + 1], i[m + 2]), xe = i.length / 3 - 1, o.push(xe), A[xe * 2 + 0] = 1, A[xe * 2 + 1] = pe, a[xe * 3 + 0] = Qe.x, a[xe * 3 + 1] = Qe.y, a[xe * 3 + 2] = Qe.z), a[d + 0] = a[I + 0] = a[m + 0] = Qe.x, a[d + 1] = a[I + 1] = a[m + 1] = Qe.y, a[d + 2] = a[I + 2] = a[m + 2] = Qe.z, A[C + 0] = L, A[C + 1] = O, A[y + 0] = z, A[y + 1] = K, A[v + 0] = Ce, A[v + 1] = pe;
  }
  return {
    indices: {
      size: 1,
      value: new Uint16Array(o)
    },
    attributes: {
      POSITION: {
        size: 3,
        value: new Float32Array(i)
      },
      NORMAL: {
        size: 3,
        value: new Float32Array(a)
      },
      TEXCOORD_0: {
        size: 2,
        value: new Float32Array(A)
      }
    }
  };
}
function hfn(t) {
  const {
    indices: e,
    attributes: n
  } = t;
  if (!e)
    return t;
  const r = e.value.length, i = {};
  for (const o in n) {
    const s = n[o], {
      constant: a,
      value: A,
      size: l
    } = s;
    if (a || !l)
      continue;
    const c = new A.constructor(r * l);
    for (let u = 0; u < r; ++u) {
      const f = e.value[u];
      for (let h = 0; h < l; h++)
        c[u * l + h] = A[f * l + h];
    }
    i[o] = {
      size: l,
      value: c
    };
  }
  return {
    attributes: Object.assign({}, n, i)
  };
}
class dfn extends Os {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      id: n = PA("plane-geometry")
    } = e, {
      indices: r,
      attributes: i
    } = pfn(e);
    super({
      ...e,
      id: n,
      indices: r,
      attributes: {
        ...i,
        ...e.attributes
      }
    });
  }
}
function pfn(t) {
  const {
    type: e = "x,y",
    offset: n = 0,
    flipCull: r = !1,
    unpack: i = !1
  } = t, o = e.split(",");
  let s = t["".concat(o[0], "len")] || 1;
  const a = t["".concat(o[1], "len")] || 1, A = t["n".concat(o[0])] || 1, l = t["n".concat(o[1])] || 1, c = (A + 1) * (l + 1), u = new Float32Array(c * 3), f = new Float32Array(c * 3), h = new Float32Array(c * 2);
  r && (s = -s);
  let d = 0, I = 0;
  for (let v = 0; v <= l; v++)
    for (let b = 0; b <= A; b++) {
      const Q = b / A, w = v / l;
      switch (h[d + 0] = r ? 1 - Q : Q, h[d + 1] = w, e) {
        case "x,y":
          u[I + 0] = s * Q - s * 0.5, u[I + 1] = a * w - a * 0.5, u[I + 2] = n, f[I + 0] = 0, f[I + 1] = 0, f[I + 2] = r ? 1 : -1;
          break;
        case "x,z":
          u[I + 0] = s * Q - s * 0.5, u[I + 1] = n, u[I + 2] = a * w - a * 0.5, f[I + 0] = 0, f[I + 1] = r ? 1 : -1, f[I + 2] = 0;
          break;
        case "y,z":
          u[I + 0] = n, u[I + 1] = s * Q - s * 0.5, u[I + 2] = a * w - a * 0.5, f[I + 0] = r ? 1 : -1, f[I + 1] = 0, f[I + 2] = 0;
          break;
        default:
          throw new Error("PlaneGeometry: unknown type");
      }
      d += 2, I += 3;
    }
  const m = A + 1, C = new Uint16Array(A * l * 6);
  for (let v = 0; v < l; v++)
    for (let b = 0; b < A; b++) {
      const Q = (v * A + b) * 6;
      C[Q + 0] = (v + 0) * m + b, C[Q + 1] = (v + 1) * m + b, C[Q + 2] = (v + 0) * m + b + 1, C[Q + 3] = (v + 1) * m + b, C[Q + 4] = (v + 1) * m + b + 1, C[Q + 5] = (v + 0) * m + b + 1;
    }
  const y = {
    indices: {
      size: 1,
      value: C
    },
    attributes: {
      POSITION: {
        size: 3,
        value: u
      },
      NORMAL: {
        size: 3,
        value: f
      },
      TEXCOORD_0: {
        size: 2,
        value: h
      }
    }
  };
  return i ? hfn(y) : y;
}
class Ifn extends Os {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      id: n = PA("sphere-geometry")
    } = e, {
      indices: r,
      attributes: i
    } = mfn(e);
    super({
      ...e,
      id: n,
      indices: r,
      attributes: {
        ...i,
        ...e.attributes
      }
    });
  }
}
function mfn(t) {
  const {
    nlat: e = 10,
    nlong: n = 10
  } = t;
  let {
    radius: r = 1
  } = t;
  const s = Math.PI - 0, a = 0, l = 2 * Math.PI - a, c = (e + 1) * (n + 1);
  if (typeof r == "number") {
    const C = r;
    r = (y, v, b, Q, w) => C;
  }
  const u = new Float32Array(c * 3), f = new Float32Array(c * 3), h = new Float32Array(c * 2), d = c > 65535 ? Uint32Array : Uint16Array, I = new d(e * n * 6);
  for (let C = 0; C <= e; C++)
    for (let y = 0; y <= n; y++) {
      const v = y / n, b = C / e, Q = y + C * (n + 1), w = Q * 2, R = Q * 3, M = l * v, O = s * b, L = Math.sin(M), N = Math.cos(M), k = Math.sin(O), $ = Math.cos(O), U = N * k, X = $, K = L * k, z = r(U, X, K, v, b);
      u[R + 0] = z * U, u[R + 1] = z * X, u[R + 2] = z * K, f[R + 0] = U, f[R + 1] = X, f[R + 2] = K, h[w + 0] = v, h[w + 1] = 1 - b;
    }
  const m = n + 1;
  for (let C = 0; C < n; C++)
    for (let y = 0; y < e; y++) {
      const v = (C * e + y) * 6;
      I[v + 0] = y * m + C, I[v + 1] = y * m + C + 1, I[v + 2] = (y + 1) * m + C, I[v + 3] = (y + 1) * m + C, I[v + 4] = y * m + C + 1, I[v + 5] = (y + 1) * m + C + 1;
    }
  return {
    indices: {
      size: 1,
      value: I
    },
    attributes: {
      POSITION: {
        size: 3,
        value: u
      },
      NORMAL: {
        size: 3,
        value: f
      },
      TEXCOORD_0: {
        size: 2,
        value: h
      }
    }
  };
}
let Cfn = 1, Efn = 1;
class Ple {
  constructor() {
    this.time = 0, this.channels = /* @__PURE__ */ new Map(), this.animations = /* @__PURE__ */ new Map(), this.playing = !1, this.lastEngineTime = -1;
  }
  addChannel(e) {
    const {
      delay: n = 0,
      duration: r = Number.POSITIVE_INFINITY,
      rate: i = 1,
      repeat: o = 1
    } = e, s = Cfn++, a = {
      time: 0,
      delay: n,
      duration: r,
      rate: i,
      repeat: o
    };
    return this._setChannelTime(a, this.time), this.channels.set(s, a), s;
  }
  removeChannel(e) {
    this.channels.delete(e);
    for (const [n, r] of this.animations)
      r.channel === e && this.detachAnimation(n);
  }
  isFinished(e) {
    const n = this.channels.get(e);
    return n === void 0 ? !1 : this.time >= n.delay + n.duration * n.repeat;
  }
  getTime(e) {
    if (e === void 0)
      return this.time;
    const n = this.channels.get(e);
    return n === void 0 ? -1 : n.time;
  }
  setTime(e) {
    this.time = Math.max(0, e);
    const n = this.channels.values();
    for (const i of n)
      this._setChannelTime(i, this.time);
    const r = this.animations.values();
    for (const i of r) {
      const {
        animation: o,
        channel: s
      } = i;
      o.setTime(this.getTime(s));
    }
  }
  play() {
    this.playing = !0;
  }
  pause() {
    this.playing = !1, this.lastEngineTime = -1;
  }
  reset() {
    this.setTime(0);
  }
  attachAnimation(e, n) {
    const r = Efn++;
    return this.animations.set(r, {
      animation: e,
      channel: n
    }), e.setTime(this.getTime(n)), r;
  }
  detachAnimation(e) {
    this.animations.delete(e);
  }
  update(e) {
    this.playing && (this.lastEngineTime === -1 && (this.lastEngineTime = e), this.setTime(this.time + (e - this.lastEngineTime)), this.lastEngineTime = e);
  }
  _setChannelTime(e, n) {
    const r = n - e.delay, i = e.duration * e.repeat;
    r >= i ? e.time = e.duration * e.rate : (e.time = Math.max(0, r) % e.duration, e.time *= e.rate);
  }
}
const yfn = `attribute vec2 aClipSpacePosition;
attribute vec2 aTexCoord;
attribute vec2 aCoordinate;

varying vec2 position;
varying vec2 coordinate;
varying vec2 uv;

void main(void) {
  gl_Position = vec4(aClipSpacePosition, 0., 1.);
  position = aClipSpacePosition;
  coordinate = aCoordinate;
  uv = aTexCoord;
}
`, Q_e = [-1, -1, 1, -1, -1, 1, 1, 1];
class G$e extends Ta {
  constructor(e, n) {
    const r = Q_e.map((i) => i === -1 ? 0 : i);
    super(e, Object.assign({}, n, {
      vs: yfn,
      geometry: new Os({
        drawMode: 5,
        vertexCount: 4,
        attributes: {
          aClipSpacePosition: {
            size: 2,
            value: new Float32Array(Q_e)
          },
          aTexCoord: {
            size: 2,
            value: new Float32Array(r)
          },
          aCoordinate: {
            size: 2,
            value: new Float32Array(r)
          }
        }
      })
    })), this.setVertexCount(4);
  }
}
const vfn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnimationLoop: Z9e,
  Buffer: ro,
  ClipSpace: G$e,
  ConeGeometry: rfn,
  CubeGeometry: k$e,
  CylinderGeometry: lfn,
  FEATURES: no,
  FragmentShader: Sk,
  Framebuffer: Da,
  Geometry: Os,
  IcoSphereGeometry: ffn,
  Model: Ta,
  PlaneGeometry: dfn,
  Program: ble,
  ProgramManager: SE,
  Renderbuffer: av,
  SphereGeometry: Ifn,
  Texture2D: xo,
  Texture3D: yle,
  TextureCube: Ele,
  Timeline: Ple,
  Transform: a$,
  TransformFeedback: _le,
  TruncatedConeGeometry: Fle,
  VertexShader: _k,
  assert: dn,
  clear: aM,
  cloneTextureFrom: J9e,
  copyToTexture: Y9e,
  createGLContext: mle,
  cssToDevicePixels: Bk,
  cssToDeviceRatio: Wv,
  dirlight: Bun,
  fp32: l$e,
  fp64: xln,
  getParameters: F9e,
  gouraudLighting: cM,
  hasFeature: Zv,
  hasFeatures: e$,
  instrumentGLContext: Z9,
  isWebGL: oM,
  isWebGL2: Fr,
  log: On,
  lumaStats: sC,
  normalizeShaderModule: e$e,
  pbr: s$,
  phongLighting: o$,
  picking: O$e,
  project: L$e,
  readPixelsToArray: AM,
  readPixelsToBuffer: Aan,
  resetParameters: P9e,
  setParameters: cd,
  uid: PA,
  withParameters: Yc
}, Symbol.toStringTag, { value: "Module" })), U$e = "#define SMOOTH_EDGE_RADIUS 0.5", Bfn = `
`.concat(U$e, `

struct VertexGeometry {
  vec4 position;
  vec3 worldPosition;
  vec3 worldPositionAlt;
  vec3 normal;
  vec2 uv;
  vec3 pickingColor;
} geometry = VertexGeometry(
  vec4(0.0, 0.0, 1.0, 0.0),
  vec3(0.0),
  vec3(0.0),
  vec3(0.0),
  vec2(0.0),
  vec3(0.0)
);
`), bfn = `
`.concat(U$e, `

struct FragmentGeometry {
  vec2 uv;
} geometry;

float smoothedge(float edge, float x) {
  return smoothstep(edge - SMOOTH_EDGE_RADIUS, edge + SMOOTH_EDGE_RADIUS, x);
}
`), _fn = {
  name: "geometry",
  vs: Bfn,
  fs: bfn
}, wn = {
  DEFAULT: -1,
  LNGLAT: 1,
  METER_OFFSETS: 2,
  LNGLAT_OFFSETS: 3,
  CARTESIAN: 0
};
Object.defineProperty(wn, "IDENTITY", {
  get: () => (Rr.deprecated("COORDINATE_SYSTEM.IDENTITY", "COORDINATE_SYSTEM.CARTESIAN")(), 0)
});
const qh = {
  WEB_MERCATOR: 1,
  GLOBE: 2,
  WEB_MERCATOR_AUTO_OFFSET: 4,
  IDENTITY: 0
}, Ou = {
  common: 0,
  meters: 1,
  pixels: 2
}, w_e = {
  click: {
    handler: "onClick"
  },
  panstart: {
    handler: "onDragStart"
  },
  panmove: {
    handler: "onDrag"
  },
  panend: {
    handler: "onDragEnd"
  }
}, Nw = {
  DRAW: "draw",
  MASK: "mask"
}, Sfn = Object.keys(wn).map((t) => "const int COORDINATE_SYSTEM_".concat(t, " = ").concat(wn[t], ";")).join(""), Qfn = Object.keys(qh).map((t) => "const int PROJECTION_MODE_".concat(t, " = ").concat(qh[t], ";")).join(""), wfn = Object.keys(Ou).map((t) => "const int UNIT_".concat(t.toUpperCase(), " = ").concat(Ou[t], ";")).join(""), xfn = "".concat(Sfn, `
`).concat(Qfn, `
`).concat(wfn, `

uniform int project_uCoordinateSystem;
uniform int project_uProjectionMode;
uniform float project_uScale;
uniform bool project_uWrapLongitude;
uniform vec3 project_uCommonUnitsPerMeter;
uniform vec3 project_uCommonUnitsPerWorldUnit;
uniform vec3 project_uCommonUnitsPerWorldUnit2;
uniform vec4 project_uCenter;
uniform mat4 project_uModelMatrix;
uniform mat4 project_uViewProjectionMatrix;
uniform vec2 project_uViewportSize;
uniform float project_uDevicePixelRatio;
uniform float project_uFocalDistance;
uniform vec3 project_uCameraPosition;
uniform vec3 project_uCoordinateOrigin;
uniform vec3 project_uCommonOrigin;
uniform bool project_uPseudoMeters;

const float TILE_SIZE = 512.0;
const float PI = 3.1415926536;
const float WORLD_SCALE = TILE_SIZE / (PI * 2.0);
const vec3 ZERO_64_LOW = vec3(0.0);
const float EARTH_RADIUS = 6370972.0; // meters
const float GLOBE_RADIUS = 256.0;

// returns an adjustment factor for uCommonUnitsPerMeter
float project_size_at_latitude(float lat) {
  float y = clamp(lat, -89.9, 89.9);
  return 1.0 / cos(radians(y));
}

float project_size() {
  if (project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR &&
    project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT &&
    project_uPseudoMeters == false) {

    // uCommonUnitsPerMeter in low-zoom Web Mercator is non-linear
    // Adjust by 1 / cos(latitude)
    // If geometry.position (vertex in common space) is populated, use it
    // Otherwise use geometry.worldPosition (anchor in world space)
    
    if (geometry.position.w == 0.0) {
      return project_size_at_latitude(geometry.worldPosition.y);
    }

    // latitude from common y: 2.0 * (atan(exp(y / TILE_SIZE * 2.0 * PI - PI)) - PI / 4.0)
    // Taylor series of 1 / cos(latitude)
    // Max error < 0.003
  
    float y = geometry.position.y / TILE_SIZE * 2.0 - 1.0;
    float y2 = y * y;
    float y4 = y2 * y2;
    float y6 = y4 * y2;
    return 1.0 + 4.9348 * y2 + 4.0587 * y4 + 1.5642 * y6;
  }
  return 1.0;
}

float project_size_at_latitude(float meters, float lat) {
  return meters * project_uCommonUnitsPerMeter.z * project_size_at_latitude(lat);
}

//
// Scaling offsets - scales meters to "world distance"
// Note the scalar version of project_size is for scaling the z component only
//
float project_size(float meters) {
  return meters * project_uCommonUnitsPerMeter.z * project_size();
}

vec2 project_size(vec2 meters) {
  return meters * project_uCommonUnitsPerMeter.xy * project_size();
}

vec3 project_size(vec3 meters) {
  return meters * project_uCommonUnitsPerMeter * project_size();
}

vec4 project_size(vec4 meters) {
  return vec4(meters.xyz * project_uCommonUnitsPerMeter, meters.w);
}

// Get rotation matrix that aligns the z axis with the given up vector
// Find 3 unit vectors ux, uy, uz that are perpendicular to each other and uz == up
mat3 project_get_orientation_matrix(vec3 up) {
  vec3 uz = normalize(up);
  // Tangent on XY plane
  vec3 ux = abs(uz.z) == 1.0 ? vec3(1.0, 0.0, 0.0) : normalize(vec3(uz.y, -uz.x, 0));
  vec3 uy = cross(uz, ux);
  return mat3(ux, uy, uz);
}

bool project_needs_rotation(vec3 commonPosition, out mat3 transform) {
  if (project_uProjectionMode == PROJECTION_MODE_GLOBE) {
    transform = project_get_orientation_matrix(commonPosition);
    return true;
  }
  return false;
}

//
// Projecting normal - transform deltas from current coordinate system to
// normals in the worldspace
//
vec3 project_normal(vec3 vector) {
  // Apply model matrix
  vec4 normal_modelspace = project_uModelMatrix * vec4(vector, 0.0);
  vec3 n = normalize(normal_modelspace.xyz * project_uCommonUnitsPerMeter);
  mat3 rotation;
  if (project_needs_rotation(geometry.position.xyz, rotation)) {
    n = rotation * n;
  }
  return n;
}

vec4 project_offset_(vec4 offset) {
  float dy = offset.y;
  vec3 commonUnitsPerWorldUnit = project_uCommonUnitsPerWorldUnit + project_uCommonUnitsPerWorldUnit2 * dy;
  return vec4(offset.xyz * commonUnitsPerWorldUnit, offset.w);
}

//
// Projecting positions - non-linear projection: lnglats => unit tile [0-1, 0-1]
//
vec2 project_mercator_(vec2 lnglat) {
  float x = lnglat.x;
  if (project_uWrapLongitude) {
    x = mod(x + 180., 360.0) - 180.;
  }
  float y = clamp(lnglat.y, -89.9, 89.9);
  return vec2(
    radians(x) + PI,
    PI + log(tan_fp32(PI * 0.25 + radians(y) * 0.5))
  ) * WORLD_SCALE;
}

vec3 project_globe_(vec3 lnglatz) {
  float lambda = radians(lnglatz.x);
  float phi = radians(lnglatz.y);
  float cosPhi = cos(phi);
  float D = (lnglatz.z / EARTH_RADIUS + 1.0) * GLOBE_RADIUS;

  return vec3(
    sin(lambda) * cosPhi,
    -cos(lambda) * cosPhi,
    sin(phi)
  ) * D;
}

//
// Projects positions (defined by project_uCoordinateSystem) to common space (defined by project_uProjectionMode)
//
vec4 project_position(vec4 position, vec3 position64Low) {
  vec4 position_world = project_uModelMatrix * position;

  // Work around for a Mac+NVIDIA bug https://github.com/visgl/deck.gl/issues/4145
  if (project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR) {
    if (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
      return vec4(
        project_mercator_(position_world.xy),
        project_size_at_latitude(position_world.z, position_world.y),
        position_world.w
      );
    }
    if (project_uCoordinateSystem == COORDINATE_SYSTEM_CARTESIAN) {
      position_world.xyz += project_uCoordinateOrigin;
    }
  }
  if (project_uProjectionMode == PROJECTION_MODE_GLOBE) {
    if (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
      return vec4(
        project_globe_(position_world.xyz),
        position_world.w
      );
    }
  }
  if (project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR_AUTO_OFFSET) {
    if (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
      if (abs(position_world.y - project_uCoordinateOrigin.y) > 0.25) {
        // Too far from the projection center for offset mode to be accurate
        // Only use high parts
        return vec4(
          project_mercator_(position_world.xy) - project_uCommonOrigin.xy,
          project_size(position_world.z),
          position_world.w
        );
      }
    }
  }
  if (project_uProjectionMode == PROJECTION_MODE_IDENTITY ||
    (project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR_AUTO_OFFSET &&
    (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT ||
     project_uCoordinateSystem == COORDINATE_SYSTEM_CARTESIAN))) {
    // Subtract high part of 64 bit value. Convert remainder to float32, preserving precision.
    position_world.xyz -= project_uCoordinateOrigin;
  }

  // Translation is already added to the high parts
  return project_offset_(position_world + project_uModelMatrix * vec4(position64Low, 0.0));
}

vec4 project_position(vec4 position) {
  return project_position(position, ZERO_64_LOW);
}

vec3 project_position(vec3 position, vec3 position64Low) {
  vec4 projected_position = project_position(vec4(position, 1.0), position64Low);
  return projected_position.xyz;
}

vec3 project_position(vec3 position) {
  vec4 projected_position = project_position(vec4(position, 1.0), ZERO_64_LOW);
  return projected_position.xyz;
}

vec2 project_position(vec2 position) {
  vec4 projected_position = project_position(vec4(position, 0.0, 1.0), ZERO_64_LOW);
  return projected_position.xy;
}

vec4 project_common_position_to_clipspace(vec4 position, mat4 viewProjectionMatrix, vec4 center) {
  return viewProjectionMatrix * position + center;
}

//
// Projects from common space coordinates to clip space.
// Uses project_uViewProjectionMatrix
//
vec4 project_common_position_to_clipspace(vec4 position) {
  return project_common_position_to_clipspace(position, project_uViewProjectionMatrix, project_uCenter);
}

// Returns a clip space offset that corresponds to a given number of screen pixels
vec2 project_pixel_size_to_clipspace(vec2 pixels) {
  vec2 offset = pixels / project_uViewportSize * project_uDevicePixelRatio * 2.0;
  return offset * project_uFocalDistance;
}

float project_size_to_pixel(float meters) {
  return project_size(meters) * project_uScale;
}
float project_size_to_pixel(float size, int unit) {
  if (unit == UNIT_METERS) return project_size_to_pixel(size);
  if (unit == UNIT_COMMON) return size * project_uScale;
  // UNIT_PIXELS
  return size;
}
float project_pixel_size(float pixels) {
  return pixels / project_uScale;
}
vec2 project_pixel_size(vec2 pixels) {
  return pixels / project_uScale;
}
`);
function Rfn(t, e) {
  if (t === e)
    return !0;
  if (Array.isArray(t)) {
    const n = t.length;
    if (!e || e.length !== n)
      return !1;
    for (let r = 0; r < n; r++)
      if (t[r] !== e[r])
        return !1;
    return !0;
  }
  return !1;
}
function Lw(t) {
  let e = {}, n;
  return (r) => {
    for (const i in r)
      if (!Rfn(r[i], e[i])) {
        n = t(r), e = r;
        break;
      }
    return n;
  };
}
const x_e = [0, 0, 0, 0], Dfn = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0], H$e = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], Tfn = [0, 0, 0], $$e = [0, 0, 0], Nfn = Lw(Mfn);
function q$e(t, e, n = $$e) {
  n.length < 3 && (n = [n[0], n[1], 0]);
  let r = n, i, o = !0;
  switch (e === wn.LNGLAT_OFFSETS || e === wn.METER_OFFSETS ? i = n : i = t.isGeospatial ? [Math.fround(t.longitude), Math.fround(t.latitude), 0] : null, t.projectionMode) {
    case qh.WEB_MERCATOR:
      (e === wn.LNGLAT || e === wn.CARTESIAN) && (i = [0, 0, 0], o = !1);
      break;
    case qh.WEB_MERCATOR_AUTO_OFFSET:
      e === wn.LNGLAT ? r = i : e === wn.CARTESIAN && (r = [Math.fround(t.center[0]), Math.fround(t.center[1]), 0], i = t.unprojectPosition(r), r[0] -= n[0], r[1] -= n[1], r[2] -= n[2]);
      break;
    case qh.IDENTITY:
      r = t.position.map(Math.fround), r[2] = r[2] || 0;
      break;
    case qh.GLOBE:
      o = !1, i = null;
      break;
    default:
      o = !1;
  }
  return {
    geospatialOrigin: i,
    shaderCoordinateOrigin: r,
    offsetMode: o
  };
}
function Lfn(t, e, n) {
  const {
    viewMatrixUncentered: r,
    projectionMatrix: i
  } = t;
  let {
    viewMatrix: o,
    viewProjectionMatrix: s
  } = t, a = x_e, A = x_e, l = t.cameraPosition;
  const {
    geospatialOrigin: c,
    shaderCoordinateOrigin: u,
    offsetMode: f
  } = q$e(t, e, n);
  return f && (A = t.projectPosition(c || u), l = [l[0] - A[0], l[1] - A[1], l[2] - A[2]], A[3] = 1, a = Tw([], A, s), o = r || o, s = Np([], i, o), s = Np([], s, Dfn)), {
    viewMatrix: o,
    viewProjectionMatrix: s,
    projectionCenter: a,
    originCommon: A,
    cameraPosCommon: l,
    shaderCoordinateOrigin: u,
    geospatialOrigin: c
  };
}
function j$e({
  viewport: t,
  devicePixelRatio: e = 1,
  modelMatrix: n = null,
  coordinateSystem: r = wn.DEFAULT,
  coordinateOrigin: i = $$e,
  autoWrapLongitude: o = !1
}) {
  r === wn.DEFAULT && (r = t.isGeospatial ? wn.LNGLAT : wn.CARTESIAN);
  const s = Nfn({
    viewport: t,
    devicePixelRatio: e,
    coordinateSystem: r,
    coordinateOrigin: i
  });
  return s.project_uWrapLongitude = o, s.project_uModelMatrix = n || H$e, s;
}
function Mfn({
  viewport: t,
  devicePixelRatio: e,
  coordinateSystem: n,
  coordinateOrigin: r
}) {
  const {
    projectionCenter: i,
    viewProjectionMatrix: o,
    originCommon: s,
    cameraPosCommon: a,
    shaderCoordinateOrigin: A,
    geospatialOrigin: l
  } = Lfn(t, n, r), c = t.getDistanceScales(), u = [t.width * e, t.height * e], f = Tw([], [0, 0, -t.focalDistance, 1], t.projectionMatrix)[3] || 1, h = {
    project_uCoordinateSystem: n,
    project_uProjectionMode: t.projectionMode,
    project_uCoordinateOrigin: A,
    project_uCommonOrigin: s.slice(0, 3),
    project_uCenter: i,
    project_uPseudoMeters: !!t._pseudoMeters,
    project_uViewportSize: u,
    project_uDevicePixelRatio: e,
    project_uFocalDistance: f,
    project_uCommonUnitsPerMeter: c.unitsPerMeter,
    project_uCommonUnitsPerWorldUnit: c.unitsPerMeter,
    project_uCommonUnitsPerWorldUnit2: Tfn,
    project_uScale: t.scale,
    project_uWrapLongitude: !1,
    project_uViewProjectionMatrix: o,
    project_uModelMatrix: H$e,
    project_uCameraPosition: a
  };
  if (l) {
    const d = t.getDistanceScales(l);
    switch (n) {
      case wn.METER_OFFSETS:
        h.project_uCommonUnitsPerWorldUnit = d.unitsPerMeter, h.project_uCommonUnitsPerWorldUnit2 = d.unitsPerMeter2;
        break;
      case wn.LNGLAT:
      case wn.LNGLAT_OFFSETS:
        t._pseudoMeters || (h.project_uCommonUnitsPerMeter = d.unitsPerMeter), h.project_uCommonUnitsPerWorldUnit = d.unitsPerDegree, h.project_uCommonUnitsPerWorldUnit2 = d.unitsPerDegree2;
        break;
      case wn.CARTESIAN:
        h.project_uCommonUnitsPerWorldUnit = [1, 1, d.unitsPerMeter[2]], h.project_uCommonUnitsPerWorldUnit2 = [0, 0, d.unitsPerMeter2[2]];
        break;
    }
  }
  return h;
}
const Ofn = {};
function Ffn(t = Ofn) {
  return "viewport" in t ? j$e(t) : {};
}
const A$ = {
  name: "project",
  dependencies: [l$e, _fn],
  vs: xfn,
  getUniforms: Ffn
}, Pfn = `
vec4 project_position_to_clipspace(
  vec3 position, vec3 position64Low, vec3 offset, out vec4 commonPosition
) {
  vec3 projectedPosition = project_position(position, position64Low);
  mat3 rotation;
  if (project_needs_rotation(projectedPosition, rotation)) {
    // offset is specified as ENU
    // when in globe projection, rotate offset so that the ground alighs with the surface of the globe
    offset = rotation * offset;
  }
  commonPosition = vec4(projectedPosition + offset, 1.0);
  return project_common_position_to_clipspace(commonPosition);
}

vec4 project_position_to_clipspace(
  vec3 position, vec3 position64Low, vec3 offset
) {
  vec4 commonPosition;
  return project_position_to_clipspace(position, position64Low, offset, commonPosition);
}
`, qA = {
  name: "project32",
  dependencies: [A$],
  vs: Pfn
};
function Dk() {
  return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
}
function H_(t, e) {
  const n = Tw([], e, t);
  return Mle(n, n, 1 / n[3]), n;
}
function R_e(t, e) {
  const n = t % e;
  return n < 0 ? e + n : n;
}
function kfn(t, e, n) {
  return n * e + (1 - n) * t;
}
function jee(t, e, n) {
  return t < e ? e : t > n ? n : t;
}
function Gfn(t) {
  return Math.log(t) * Math.LOG2E;
}
const kle = Math.log2 || Gfn;
function NI(t, e) {
  if (!t)
    throw new Error(e || "@math.gl/web-mercator: assertion failed.");
}
const jh = Math.PI, Y$e = jh / 4, Dg = jh / 180, Yee = 180 / jh, qS = 512, vU = 4003e4, BR = 85.051129, z$e = 1.5;
function BU(t) {
  return Math.pow(2, t);
}
function Gle(t) {
  return kle(t);
}
function Hc(t) {
  const [e, n] = t;
  NI(Number.isFinite(e)), NI(Number.isFinite(n) && n >= -90 && n <= 90, "invalid latitude");
  const r = e * Dg, i = n * Dg, o = qS * (r + jh) / (2 * jh), s = qS * (jh + Math.log(Math.tan(Y$e + i * 0.5))) / (2 * jh);
  return [o, s];
}
function Mf(t) {
  const [e, n] = t, r = e / qS * (2 * jh) - jh, i = 2 * (Math.atan(Math.exp(n / qS * (2 * jh) - jh)) - Y$e);
  return [r * Yee, i * Yee];
}
function Ule(t) {
  const {
    latitude: e
  } = t;
  NI(Number.isFinite(e));
  const n = Math.cos(e * Dg);
  return Gle(vU * n) - 9;
}
function Ufn(t) {
  const e = Math.cos(t * Dg);
  return qS / vU / e;
}
function PT(t) {
  const {
    latitude: e,
    longitude: n,
    highPrecision: r = !1
  } = t;
  NI(Number.isFinite(e) && Number.isFinite(n));
  const i = qS, o = Math.cos(e * Dg), s = i / 360, a = s / o, A = i / vU / o, l = {
    unitsPerMeter: [A, A, A],
    metersPerUnit: [1 / A, 1 / A, 1 / A],
    unitsPerDegree: [s, a, A],
    degreesPerUnit: [1 / s, 1 / a, 1 / A]
  };
  if (r) {
    const c = Dg * Math.tan(e * Dg) / o, u = s * c / 2, f = i / vU * c, h = f / a * A;
    l.unitsPerDegree2 = [0, u, f], l.unitsPerMeter2 = [h, 0, h];
  }
  return l;
}
function Hle(t, e) {
  const [n, r, i] = t, [o, s, a] = e, {
    unitsPerMeter: A,
    unitsPerMeter2: l
  } = PT({
    longitude: n,
    latitude: r,
    highPrecision: !0
  }), c = Hc(t);
  c[0] += o * (A[0] + l[0] * s), c[1] += s * (A[1] + l[1] * s);
  const u = Mf(c), f = (i || 0) + (a || 0);
  return Number.isFinite(i) || Number.isFinite(a) ? [u[0], u[1], f] : u;
}
function $le(t) {
  const {
    height: e,
    pitch: n,
    bearing: r,
    altitude: i,
    scale: o,
    center: s
  } = t, a = Dk();
  FT(a, a, [0, 0, -i]), Q$e(a, a, -n * Dg), w$e(a, a, r * Dg);
  const A = o / e;
  return i$(a, a, [A, A, A]), s && FT(a, a, icn([], s)), a;
}
function qle(t) {
  const {
    width: e,
    height: n,
    altitude: r,
    pitch: i = 0,
    offset: o,
    center: s,
    scale: a,
    nearZMultiplier: A = 1,
    farZMultiplier: l = 1
  } = t;
  let {
    fovy: c = tB(z$e)
  } = t;
  r !== void 0 && (c = tB(r));
  const u = c * Dg, f = i * Dg, h = uM(c);
  let d = h;
  s && (d += s[2] * a / Math.cos(f) / n);
  const I = u * (0.5 + (o ? o[1] : 0) / n), m = Math.sin(I) * d / Math.sin(jee(Math.PI / 2 - f - I, 0.01, Math.PI - 0.01)), C = Math.sin(f) * m + d, y = d * 10, v = Math.min(C * l, y);
  return {
    fov: u,
    aspect: e / n,
    focalDistance: h,
    near: A,
    far: v
  };
}
function V$e(t) {
  const {
    fov: e,
    aspect: n,
    near: r,
    far: i
  } = qle(t);
  return x$e([], e, n, r, i);
}
function tB(t) {
  return 2 * Math.atan(0.5 / t) * Yee;
}
function uM(t) {
  return 0.5 / Math.tan(0.5 * t * Dg);
}
function l$(t, e) {
  const [n, r, i = 0] = t;
  return NI(Number.isFinite(n) && Number.isFinite(r) && Number.isFinite(i)), H_(e, [n, r, i, 1]);
}
function JC(t, e, n = 0) {
  const [r, i, o] = t;
  if (NI(Number.isFinite(r) && Number.isFinite(i), "invalid pixel coordinate"), Number.isFinite(o))
    return H_(e, [r, i, o, 1]);
  const s = H_(e, [r, i, 0, 1]), a = H_(e, [r, i, 1, 1]), A = s[2], l = a[2], c = A === l ? 0 : ((n || 0) - A) / (l - A);
  return d$e([], s, a, c);
}
function c$(t) {
  const {
    width: e,
    height: n,
    bounds: r,
    minExtent: i = 0,
    maxZoom: o = 24,
    offset: s = [0, 0]
  } = t, [[a, A], [l, c]] = r, u = Hfn(t.padding), f = Hc([a, jee(c, -BR, BR)]), h = Hc([l, jee(A, -BR, BR)]), d = [Math.max(Math.abs(h[0] - f[0]), i), Math.max(Math.abs(h[1] - f[1]), i)], I = [e - u.left - u.right - Math.abs(s[0]) * 2, n - u.top - u.bottom - Math.abs(s[1]) * 2];
  NI(I[0] > 0 && I[1] > 0);
  const m = I[0] / d[0], C = I[1] / d[1], y = (u.right - u.left) / 2 / m, v = (u.top - u.bottom) / 2 / C, b = [(h[0] + f[0]) / 2 + y, (h[1] + f[1]) / 2 + v], Q = Mf(b), w = Math.min(o, kle(Math.abs(Math.min(m, C))));
  return NI(Number.isFinite(w)), {
    longitude: Q[0],
    latitude: Q[1],
    zoom: w
  };
}
function Hfn(t = 0) {
  return typeof t == "number" ? {
    top: t,
    bottom: t,
    left: t,
    right: t
  } : (NI(Number.isFinite(t.top) && Number.isFinite(t.bottom) && Number.isFinite(t.left) && Number.isFinite(t.right)), t);
}
const D_e = Math.PI / 180;
function jle(t, e = 0) {
  const {
    width: n,
    height: r,
    unproject: i
  } = t, o = {
    targetZ: e
  }, s = i([0, r], o), a = i([n, r], o);
  let A, l;
  const c = t.fovy ? 0.5 * t.fovy * D_e : Math.atan(0.5 / t.altitude), u = (90 - t.pitch) * D_e;
  return c > u - 0.01 ? (A = T_e(t, 0, e), l = T_e(t, n, e)) : (A = i([0, 0], o), l = i([n, 0], o)), [s, a, l, A];
}
function T_e(t, e, n) {
  const {
    pixelUnprojectionMatrix: r
  } = t, i = H_(r, [e, 0, 1, 1]), o = H_(r, [e, t.height, 1, 1]), a = (n * t.distanceScales.unitsPerMeter[2] - i[2]) / (o[2] - i[2]), A = d$e([], i, o, a), l = Mf(A);
  return l.push(n), l;
}
let N_e = class zee {
  constructor(e = {
    width: 1,
    height: 1
  }) {
    ae(this, "latitude", void 0), ae(this, "longitude", void 0), ae(this, "zoom", void 0), ae(this, "pitch", void 0), ae(this, "bearing", void 0), ae(this, "altitude", void 0), ae(this, "fovy", void 0), ae(this, "meterOffset", void 0), ae(this, "center", void 0), ae(this, "width", void 0), ae(this, "height", void 0), ae(this, "scale", void 0), ae(this, "distanceScales", void 0), ae(this, "viewMatrix", void 0), ae(this, "projectionMatrix", void 0), ae(this, "viewProjectionMatrix", void 0), ae(this, "pixelProjectionMatrix", void 0), ae(this, "pixelUnprojectionMatrix", void 0), ae(this, "equals", (C) => C instanceof zee ? C.width === this.width && C.height === this.height && p_e(C.projectionMatrix, this.projectionMatrix) && p_e(C.viewMatrix, this.viewMatrix) : !1), ae(this, "project", (C, y = {}) => {
      const {
        topLeft: v = !0
      } = y, b = this.projectPosition(C), Q = l$(b, this.pixelProjectionMatrix), [w, R] = Q, M = v ? R : this.height - R;
      return C.length === 2 ? [w, M] : [w, M, Q[2]];
    }), ae(this, "unproject", (C, y = {}) => {
      const {
        topLeft: v = !0,
        targetZ: b = void 0
      } = y, [Q, w, R] = C, M = v ? w : this.height - w, O = b && b * this.distanceScales.unitsPerMeter[2], L = JC([Q, M, R], this.pixelUnprojectionMatrix, O), [N, k, $] = this.unprojectPosition(L);
      return Number.isFinite(R) ? [N, k, $] : Number.isFinite(b) ? [N, k, b] : [N, k];
    }), ae(this, "projectPosition", (C) => {
      const [y, v] = Hc(C), b = (C[2] || 0) * this.distanceScales.unitsPerMeter[2];
      return [y, v, b];
    }), ae(this, "unprojectPosition", (C) => {
      const [y, v] = Mf(C), b = (C[2] || 0) * this.distanceScales.metersPerUnit[2];
      return [y, v, b];
    });
    let {
      width: n,
      height: r,
      altitude: i = null,
      fovy: o = null
    } = e;
    const {
      latitude: s = 0,
      longitude: a = 0,
      zoom: A = 0,
      pitch: l = 0,
      bearing: c = 0,
      position: u = null,
      nearZMultiplier: f = 0.02,
      farZMultiplier: h = 1.01
    } = e;
    n = n || 1, r = r || 1, o === null && i === null ? (i = z$e, o = tB(i)) : o === null ? o = tB(i) : i === null && (i = uM(o));
    const d = BU(A);
    i = Math.max(0.75, i);
    const I = PT({
      longitude: a,
      latitude: s
    }), m = Hc([a, s]);
    m.push(0), u && ecn(m, m, ucn([], u, I.unitsPerMeter)), this.projectionMatrix = V$e({
      width: n,
      height: r,
      scale: d,
      center: m,
      pitch: l,
      fovy: o,
      nearZMultiplier: f,
      farZMultiplier: h
    }), this.viewMatrix = $le({
      height: r,
      scale: d,
      center: m,
      pitch: l,
      bearing: c,
      altitude: i
    }), this.width = n, this.height = r, this.scale = d, this.latitude = s, this.longitude = a, this.zoom = A, this.pitch = l, this.bearing = c, this.altitude = i, this.fovy = o, this.center = m, this.meterOffset = u || [0, 0, 0], this.distanceScales = I, this._initMatrices(), Object.freeze(this);
  }
  _initMatrices() {
    const {
      width: e,
      height: n,
      projectionMatrix: r,
      viewMatrix: i
    } = this, o = Dk();
    Np(o, o, r), Np(o, o, i), this.viewProjectionMatrix = o;
    const s = Dk();
    i$(s, s, [e / 2, -n / 2, 1]), FT(s, s, [1, -1, 0]), Np(s, s, o);
    const a = EU(Dk(), s);
    if (!a)
      throw new Error("Pixel project matrix not invertible");
    this.pixelProjectionMatrix = s, this.pixelUnprojectionMatrix = a;
  }
  projectFlat(e) {
    return Hc(e);
  }
  unprojectFlat(e) {
    return Mf(e);
  }
  getMapCenterByLngLatPosition({
    lngLat: e,
    pos: n
  }) {
    const r = JC(n, this.pixelUnprojectionMatrix), i = Hc(e), o = eB([], i, Dle([], r)), s = eB([], this.center, o);
    return Mf(s);
  }
  fitBounds(e, n = {}) {
    const {
      width: r,
      height: i
    } = this, {
      longitude: o,
      latitude: s,
      zoom: a
    } = c$(Object.assign({
      width: r,
      height: i,
      bounds: e
    }, n));
    return new zee({
      width: r,
      height: i,
      longitude: o,
      latitude: s,
      zoom: a
    });
  }
  getBounds(e) {
    const n = this.getBoundingRegion(e), r = Math.min(...n.map((a) => a[0])), i = Math.max(...n.map((a) => a[0])), o = Math.min(...n.map((a) => a[1])), s = Math.max(...n.map((a) => a[1]));
    return [[r, o], [i, s]];
  }
  getBoundingRegion(e = {}) {
    return jle(this, e.z || 0);
  }
  getLocationAtPoint({
    lngLat: e,
    pos: n
  }) {
    return this.getMapCenterByLngLatPosition({
      lngLat: e,
      pos: n
    });
  }
};
const L_e = 512;
function J$e(t) {
  const {
    width: e,
    height: n,
    pitch: r = 0
  } = t;
  let {
    longitude: i,
    latitude: o,
    zoom: s,
    bearing: a = 0
  } = t;
  (i < -180 || i > 180) && (i = R_e(i + 180, 360) - 180), (a < -180 || a > 180) && (a = R_e(a + 180, 360) - 180);
  const A = kle(n / L_e);
  if (s <= A)
    s = A, o = 0;
  else {
    const l = n / 2 / Math.pow(2, s), c = Mf([0, l])[1];
    if (o < c)
      o = c;
    else {
      const u = Mf([0, L_e - l])[1];
      o > u && (o = u);
    }
  }
  return {
    width: e,
    height: n,
    longitude: i,
    latitude: o,
    zoom: s,
    pitch: r,
    bearing: a
  };
}
const K$e = 0.01, $fn = ["longitude", "latitude", "zoom"], W$e = {
  curve: 1.414,
  speed: 1.2
};
function X$e(t, e, n, r) {
  const {
    startZoom: i,
    startCenterXY: o,
    uDelta: s,
    w0: a,
    u1: A,
    S: l,
    rho: c,
    rho2: u,
    r0: f
  } = eqe(t, e, r);
  if (A < K$e) {
    const b = {};
    for (const Q of $fn) {
      const w = t[Q], R = e[Q];
      b[Q] = kfn(w, R, n);
    }
    return b;
  }
  const h = n * l, d = Math.cosh(f) / Math.cosh(f + c * h), I = a * ((Math.cosh(f) * Math.tanh(f + c * h) - Math.sinh(f)) / u) / A, m = 1 / d, C = i + Gle(m), y = zln([], s, I);
  eB(y, y, o);
  const v = Mf(y);
  return {
    longitude: v[0],
    latitude: v[1],
    zoom: C
  };
}
function Z$e(t, e, n) {
  const r = {
    ...W$e,
    ...n
  }, {
    screenSpeed: i,
    speed: o,
    maxDuration: s
  } = r, {
    S: a,
    rho: A
  } = eqe(t, e, r), l = 1e3 * a;
  let c;
  return Number.isFinite(i) ? c = l / (i / A) : c = l / o, Number.isFinite(s) && c > s ? 0 : c;
}
function eqe(t, e, n) {
  n = Object.assign({}, W$e, n);
  const r = n.curve, i = t.zoom, o = [t.longitude, t.latitude], s = BU(i), a = e.zoom, A = [e.longitude, e.latitude], l = BU(a - i), c = Hc(o), u = Hc(A), f = Wln([], u, c), h = Math.max(t.width, t.height), d = h / l, I = Vln(f) * s, m = Math.max(I, K$e), C = r * r, y = (d * d - h * h + C * C * m * m) / (2 * h * C * m), v = (d * d - h * h - C * C * m * m) / (2 * d * C * m), b = Math.log(Math.sqrt(y * y + 1) - y), Q = Math.log(Math.sqrt(v * v + 1) - v), w = (Q - b) / r;
  return {
    startZoom: i,
    startCenterXY: c,
    uDelta: f,
    w0: h,
    u1: I,
    S: w,
    rho: r,
    rho2: C,
    r0: b,
    r1: Q
  };
}
const qfn = `
const int max_lights = 2;
uniform mat4 shadow_uViewProjectionMatrices[max_lights];
uniform vec4 shadow_uProjectCenters[max_lights];
uniform bool shadow_uDrawShadowMap;
uniform bool shadow_uUseShadowMap;
uniform int shadow_uLightId;
uniform float shadow_uLightCount;

varying vec3 shadow_vPosition[max_lights];

vec4 shadow_setVertexPosition(vec4 position_commonspace) {
  if (shadow_uDrawShadowMap) {
    return project_common_position_to_clipspace(position_commonspace, shadow_uViewProjectionMatrices[shadow_uLightId], shadow_uProjectCenters[shadow_uLightId]);
  }
  if (shadow_uUseShadowMap) {
    for (int i = 0; i < max_lights; i++) {
      if(i < int(shadow_uLightCount)) {
        vec4 shadowMap_position = project_common_position_to_clipspace(position_commonspace, shadow_uViewProjectionMatrices[i], shadow_uProjectCenters[i]);
        shadow_vPosition[i] = (shadowMap_position.xyz / shadowMap_position.w + 1.0) / 2.0;
      }
    }
  }
  return gl_Position;
}
`, jfn = `
const int max_lights = 2;
uniform bool shadow_uDrawShadowMap;
uniform bool shadow_uUseShadowMap;
uniform sampler2D shadow_uShadowMap0;
uniform sampler2D shadow_uShadowMap1;
uniform vec4 shadow_uColor;
uniform float shadow_uLightCount;

varying vec3 shadow_vPosition[max_lights];

const vec4 bitPackShift = vec4(1.0, 255.0, 65025.0, 16581375.0);
const vec4 bitUnpackShift = 1.0 / bitPackShift;
const vec4 bitMask = vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0,  0.0);

float shadow_getShadowWeight(vec3 position, sampler2D shadowMap) {
  vec4 rgbaDepth = texture2D(shadowMap, position.xy);

  float z = dot(rgbaDepth, bitUnpackShift);
  return smoothstep(0.001, 0.01, position.z - z);
}

vec4 shadow_filterShadowColor(vec4 color) {
  if (shadow_uDrawShadowMap) {
    vec4 rgbaDepth = fract(gl_FragCoord.z * bitPackShift);
    rgbaDepth -= rgbaDepth.gbaa * bitMask;
    return rgbaDepth;
  }
  if (shadow_uUseShadowMap) {
    float shadowAlpha = 0.0;
    shadowAlpha += shadow_getShadowWeight(shadow_vPosition[0], shadow_uShadowMap0);
    if(shadow_uLightCount > 1.0) {
      shadowAlpha += shadow_getShadowWeight(shadow_vPosition[1], shadow_uShadowMap1);
    }
    shadowAlpha *= shadow_uColor.a / shadow_uLightCount;
    float blendedAlpha = shadowAlpha + color.a * (1.0 - shadowAlpha);

    return vec4(
      mix(color.rgb, shadow_uColor.rgb, shadowAlpha / blendedAlpha),
      blendedAlpha
    );
  }
  return color;
}
`, Yfn = Lw(Wfn), zfn = Lw(Xfn), Vfn = [0, 0, 0, 1], Jfn = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0];
function Kfn(t, e) {
  const [n, r, i] = t, o = JC([n, r, i], e);
  return Number.isFinite(i) ? o : [o[0], o[1], 0];
}
function Wfn({
  viewport: t,
  center: e
}) {
  return new pn(t.viewProjectionMatrix).invert().transform(e);
}
function Xfn({
  viewport: t,
  shadowMatrices: e
}) {
  const n = [], r = t.pixelUnprojectionMatrix, i = t.isGeospatial ? void 0 : 1, o = [[0, 0, i], [t.width, 0, i], [0, t.height, i], [t.width, t.height, i], [0, 0, -1], [t.width, 0, -1], [0, t.height, -1], [t.width, t.height, -1]].map((s) => Kfn(s, r));
  for (const s of e) {
    const a = s.clone().translate(new ct(t.center).negate()), A = o.map((c) => a.transform(c)), l = new pn().ortho({
      left: Math.min(...A.map((c) => c[0])),
      right: Math.max(...A.map((c) => c[0])),
      bottom: Math.min(...A.map((c) => c[1])),
      top: Math.max(...A.map((c) => c[1])),
      near: Math.min(...A.map((c) => -c[2])),
      far: Math.max(...A.map((c) => -c[2]))
    });
    n.push(l.multiplyRight(s));
  }
  return n;
}
function Zfn(t, e) {
  const {
    shadowEnabled: n = !0
  } = t;
  if (!n || !t.shadowMatrices || !t.shadowMatrices.length)
    return {
      shadow_uDrawShadowMap: !1,
      shadow_uUseShadowMap: !1
    };
  const r = {
    shadow_uDrawShadowMap: !!t.drawToShadowMap,
    shadow_uUseShadowMap: t.shadowMaps ? t.shadowMaps.length > 0 : !1,
    shadow_uColor: t.shadowColor || Vfn,
    shadow_uLightId: t.shadowLightId || 0,
    shadow_uLightCount: t.shadowMatrices.length
  }, i = Yfn({
    viewport: t.viewport,
    center: e.project_uCenter
  }), o = [], s = zfn({
    shadowMatrices: t.shadowMatrices,
    viewport: t.viewport
  }).slice();
  for (let a = 0; a < t.shadowMatrices.length; a++) {
    const A = s[a], l = A.clone().translate(new ct(t.viewport.center).negate());
    e.project_uCoordinateSystem === wn.LNGLAT && e.project_uProjectionMode === qh.WEB_MERCATOR ? (s[a] = l, o[a] = i) : (s[a] = A.clone().multiplyRight(Jfn), o[a] = l.transform(i));
  }
  for (let a = 0; a < s.length; a++)
    r["shadow_uViewProjectionMatrices[".concat(a, "]")] = s[a], r["shadow_uProjectCenters[".concat(a, "]")] = o[a], t.shadowMaps && t.shadowMaps.length > 0 ? r["shadow_uShadowMap".concat(a)] = t.shadowMaps[a] : r["shadow_uShadowMap".concat(a)] = t.dummyShadowMap;
  return r;
}
const Tk = {
  name: "shadow",
  dependencies: [A$],
  vs: qfn,
  fs: jfn,
  inject: {
    "vs:DECKGL_FILTER_GL_POSITION": `
    position = shadow_setVertexPosition(geometry.position);
    `,
    "fs:DECKGL_FILTER_COLOR": `
    color = shadow_filterShadowColor(color);
    `
  },
  getUniforms: (t = {}, e = {}) => "viewport" in t && (t.drawToShadowMap || t.shadowMaps && t.shadowMaps.length > 0) ? Zfn(t, e) : {}
}, jA = {
  inject: {
    "vs:DECKGL_FILTER_GL_POSITION": `
    // for picking depth values
    picking_setPickingAttribute(position.z / position.w);
  `,
    "vs:DECKGL_FILTER_COLOR": `
  picking_setPickingColor(geometry.pickingColor);
  `,
    "fs:#decl": `
uniform bool picking_uAttribute;
  `,
    "fs:DECKGL_FILTER_COLOR": {
      order: 99,
      injection: `
  // use highlight color if this fragment belongs to the selected object.
  color = picking_filterHighlightColor(color);

  // use picking color if rendering to picking FBO.
  color = picking_filterPickingColor(color);
    `
    }
  },
  ...O$e
}, egn = [A$], tgn = ["vs:DECKGL_FILTER_SIZE(inout vec3 size, VertexGeometry geometry)", "vs:DECKGL_FILTER_GL_POSITION(inout vec4 position, VertexGeometry geometry)", "vs:DECKGL_FILTER_COLOR(inout vec4 color, VertexGeometry geometry)", "fs:DECKGL_FILTER_COLOR(inout vec4 color, FragmentGeometry geometry)"];
function ngn(t) {
  const e = SE.getDefaultProgramManager(t);
  for (const n of egn)
    e.addDefaultModule(n);
  for (const n of tgn)
    e.addShaderHook(n);
  return e;
}
const rgn = [255, 255, 255], ign = 1;
let ogn = 0;
class tqe {
  constructor(e = {}) {
    ae(this, "id", void 0), ae(this, "color", void 0), ae(this, "intensity", void 0), ae(this, "type", "ambient");
    const {
      color: n = rgn
    } = e, {
      intensity: r = ign
    } = e;
    this.id = e.id || "ambient-".concat(ogn++), this.color = n, this.intensity = r;
  }
}
const sgn = [255, 255, 255], agn = 1, Agn = [0, 0, -1];
let lgn = 0;
class bU {
  constructor(e = {}) {
    ae(this, "id", void 0), ae(this, "color", void 0), ae(this, "intensity", void 0), ae(this, "type", "directional"), ae(this, "direction", void 0), ae(this, "shadow", void 0);
    const {
      color: n = sgn
    } = e, {
      intensity: r = agn
    } = e, {
      direction: i = Agn
    } = e, {
      _shadow: o = !1
    } = e;
    this.id = e.id || "directional-".concat(lgn++), this.color = n, this.intensity = r, this.type = "directional", this.direction = new ct(i).normalize().toArray(), this.shadow = o;
  }
  getProjectedLight(e) {
    return this;
  }
}
class nqe {
  constructor(e, n = {
    id: "pass"
  }) {
    ae(this, "id", void 0), ae(this, "gl", void 0), ae(this, "props", void 0);
    const {
      id: r
    } = n;
    this.id = r, this.gl = e, this.props = {
      ...n
    };
  }
  setProps(e) {
    Object.assign(this.props, e);
  }
  render(e) {
  }
  cleanup() {
  }
}
class fM extends nqe {
  constructor(...e) {
    super(...e), ae(this, "_lastRenderIndex", -1);
  }
  render(e) {
    const n = this.gl;
    return cd(n, {
      framebuffer: e.target
    }), this._drawLayers(e);
  }
  _drawLayers(e) {
    const {
      target: n,
      moduleParameters: r,
      viewports: i,
      views: o,
      onViewportActive: s,
      clearStack: a = !0,
      clearCanvas: A = !0
    } = e;
    e.pass = e.pass || "unknown";
    const l = this.gl;
    A && ugn(l), a && (this._lastRenderIndex = -1);
    const c = [];
    for (const u of i) {
      const f = o && o[u.id];
      s(u);
      const h = this._getDrawLayerParams(u, e), d = u.subViewports || [u];
      for (const I of d) {
        const m = this._drawLayersInViewport(l, {
          target: n,
          moduleParameters: r,
          viewport: I,
          view: f,
          pass: e.pass,
          layers: e.layers
        }, h);
        c.push(m);
      }
    }
    return c;
  }
  _getDrawLayerParams(e, {
    layers: n,
    pass: r,
    layerFilter: i,
    cullRect: o,
    effects: s,
    moduleParameters: a
  }) {
    const A = [], l = rqe(this._lastRenderIndex + 1), c = {
      layer: n[0],
      viewport: e,
      isPicking: r.startsWith("picking"),
      renderPass: r,
      cullRect: o
    }, u = {};
    for (let f = 0; f < n.length; f++) {
      const h = n[f], d = this._shouldDrawLayer(h, c, i, u), I = {
        shouldDrawLayer: d
      };
      d && (I.layerRenderIndex = l(h, d), I.moduleParameters = this._getModuleParameters(h, s, r, a), I.layerParameters = this.getLayerParameters(h, f, e)), A[f] = I;
    }
    return A;
  }
  _drawLayersInViewport(e, {
    layers: n,
    moduleParameters: r,
    pass: i,
    target: o,
    viewport: s,
    view: a
  }, A) {
    const l = cgn(e, {
      moduleParameters: r,
      target: o,
      viewport: s
    });
    if (a && a.props.clear) {
      const u = a.props.clear === !0 ? {
        color: !0,
        depth: !0
      } : a.props.clear;
      Yc(e, {
        scissorTest: !0,
        scissor: l
      }, () => aM(e, u));
    }
    const c = {
      totalCount: n.length,
      visibleCount: 0,
      compositeCount: 0,
      pickableCount: 0
    };
    cd(e, {
      viewport: l
    });
    for (let u = 0; u < n.length; u++) {
      const f = n[u], {
        shouldDrawLayer: h,
        layerRenderIndex: d,
        moduleParameters: I,
        layerParameters: m
      } = A[u];
      if (h && f.props.pickable && c.pickableCount++, f.isComposite)
        c.compositeCount++;
      else if (h) {
        c.visibleCount++, this._lastRenderIndex = Math.max(this._lastRenderIndex, d), I.viewport = s;
        try {
          f._drawLayer({
            moduleParameters: I,
            uniforms: {
              layerIndex: d
            },
            parameters: m
          });
        } catch (C) {
          f.raiseError(C, "drawing ".concat(f, " to ").concat(i));
        }
      }
    }
    return c;
  }
  shouldDrawLayer(e) {
    return !0;
  }
  getModuleParameters(e, n) {
    return null;
  }
  getLayerParameters(e, n, r) {
    return e.props.parameters;
  }
  _shouldDrawLayer(e, n, r, i) {
    if (!(e.props.visible && this.shouldDrawLayer(e)))
      return !1;
    n.layer = e;
    let s = e.parent;
    for (; s; ) {
      if (!s.props.visible || !s.filterSubLayer(n))
        return !1;
      n.layer = s, s = s.parent;
    }
    if (r) {
      const a = n.layer.id;
      if (a in i || (i[a] = r(n)), !i[a])
        return !1;
    }
    return e.activateViewport(n.viewport), !0;
  }
  _getModuleParameters(e, n, r, i) {
    var o;
    const s = Object.assign(Object.create(((o = e.internalState) === null || o === void 0 ? void 0 : o.propsInTransition) || e.props), {
      autoWrapLongitude: e.wrapLongitude,
      viewport: e.context.viewport,
      mousePosition: e.context.mousePosition,
      pickingActive: 0,
      devicePixelRatio: Wv(this.gl)
    });
    if (n)
      for (const A of n) {
        var a;
        Object.assign(s, (a = A.getModuleParameters) === null || a === void 0 ? void 0 : a.call(A, e));
      }
    return Object.assign(s, this.getModuleParameters(e, n), i);
  }
}
function rqe(t = 0, e = {}) {
  const n = {}, r = (i, o) => {
    const s = i.props._offset, a = i.id, A = i.parent && i.parent.id;
    let l;
    if (A && !(A in e) && r(i.parent, !1), A in n) {
      const c = n[A] = n[A] || rqe(e[A], e);
      l = c(i, o), n[a] = c;
    } else
      Number.isFinite(s) ? (l = s + (e[A] || 0), n[a] = null) : l = t;
    return o && l >= t && (t = l + 1), e[a] = l, l;
  };
  return r;
}
function cgn(t, {
  moduleParameters: e,
  target: n,
  viewport: r
}) {
  const i = n && n.id !== "default-framebuffer", o = e && e.devicePixelRatio || Wv(t), s = i ? n.height : t.drawingBufferHeight, a = r;
  return [a.x * o, s - (a.y + a.height) * o, a.width * o, a.height * o];
}
function ugn(t) {
  const e = t.drawingBufferWidth, n = t.drawingBufferHeight;
  cd(t, {
    viewport: [0, 0, e, n]
  }), t.clear(16640);
}
class fgn extends fM {
  constructor(e, n) {
    super(e, n), ae(this, "shadowMap", void 0), ae(this, "depthBuffer", void 0), ae(this, "fbo", void 0), this.shadowMap = new xo(e, {
      width: 1,
      height: 1,
      parameters: {
        [10241]: 9729,
        [10240]: 9729,
        [10242]: 33071,
        [10243]: 33071
      }
    }), this.depthBuffer = new av(e, {
      format: 33189,
      width: 1,
      height: 1
    }), this.fbo = new Da(e, {
      id: "shadowmap",
      width: 1,
      height: 1,
      attachments: {
        [36064]: this.shadowMap,
        [36096]: this.depthBuffer
      }
    });
  }
  render(e) {
    const n = this.fbo;
    Yc(this.gl, {
      depthRange: [0, 1],
      depthTest: !0,
      blend: !1,
      clearColor: [1, 1, 1, 1]
    }, () => {
      const r = e.viewports[0], i = Wv(this.gl), o = r.width * i, s = r.height * i;
      (o !== n.width || s !== n.height) && n.resize({
        width: o,
        height: s
      }), super.render({
        ...e,
        target: n,
        pass: "shadow"
      });
    });
  }
  shouldDrawLayer(e) {
    return e.props.shadowEnabled !== !1;
  }
  getModuleParameters() {
    return {
      drawToShadowMap: !0
    };
  }
  delete() {
    this.fbo && (this.fbo.delete(), this.fbo = null), this.shadowMap && (this.shadowMap.delete(), this.shadowMap = null), this.depthBuffer && (this.depthBuffer.delete(), this.depthBuffer = null);
  }
}
const ggn = {
  color: [255, 255, 255],
  intensity: 1
}, M_e = [{
  color: [255, 255, 255],
  intensity: 1,
  direction: [-1, 3, -1]
}, {
  color: [255, 255, 255],
  intensity: 0.9,
  direction: [1, -8, -2.5]
}], hgn = [0, 0, 0, 200 / 255];
class Yle {
  constructor(e = {}) {
    ae(this, "id", "lighting-effect"), ae(this, "props", null), ae(this, "shadowColor", hgn), ae(this, "shadow", void 0), ae(this, "ambientLight", null), ae(this, "directionalLights", []), ae(this, "pointLights", []), ae(this, "shadowPasses", []), ae(this, "shadowMaps", []), ae(this, "dummyShadowMap", null), ae(this, "programManager", void 0), ae(this, "shadowMatrices", void 0);
    for (const n in e) {
      const r = e[n];
      switch (r.type) {
        case "ambient":
          this.ambientLight = r;
          break;
        case "directional":
          this.directionalLights.push(r);
          break;
        case "point":
          this.pointLights.push(r);
          break;
      }
    }
    this._applyDefaultLights(), this.shadow = this.directionalLights.some((n) => n.shadow);
  }
  preRender(e, {
    layers: n,
    layerFilter: r,
    viewports: i,
    onViewportActive: o,
    views: s
  }) {
    if (this.shadow) {
      this.shadowMatrices = this._calculateMatrices(), this.shadowPasses.length === 0 && this._createShadowPasses(e), this.programManager || (this.programManager = SE.getDefaultProgramManager(e), Tk && this.programManager.addDefaultModule(Tk)), this.dummyShadowMap || (this.dummyShadowMap = new xo(e, {
        width: 1,
        height: 1
      }));
      for (let a = 0; a < this.shadowPasses.length; a++)
        this.shadowPasses[a].render({
          layers: n,
          layerFilter: r,
          viewports: i,
          onViewportActive: o,
          views: s,
          moduleParameters: {
            shadowLightId: a,
            dummyShadowMap: this.dummyShadowMap,
            shadowMatrices: this.shadowMatrices
          }
        });
    }
  }
  getModuleParameters(e) {
    const n = this.shadow ? {
      shadowMaps: this.shadowMaps,
      dummyShadowMap: this.dummyShadowMap,
      shadowColor: this.shadowColor,
      shadowMatrices: this.shadowMatrices
    } : {};
    return n.lightSources = {
      ambientLight: this.ambientLight,
      directionalLights: this.directionalLights.map((r) => r.getProjectedLight({
        layer: e
      })),
      pointLights: this.pointLights.map((r) => r.getProjectedLight({
        layer: e
      }))
    }, n;
  }
  cleanup() {
    for (const e of this.shadowPasses)
      e.delete();
    this.shadowPasses.length = 0, this.shadowMaps.length = 0, this.dummyShadowMap && (this.dummyShadowMap.delete(), this.dummyShadowMap = null), this.shadow && this.programManager && (this.programManager.removeDefaultModule(Tk), this.programManager = null);
  }
  _calculateMatrices() {
    const e = [];
    for (const n of this.directionalLights) {
      const r = new pn().lookAt({
        eye: new ct(n.direction).negate()
      });
      e.push(r);
    }
    return e;
  }
  _createShadowPasses(e) {
    for (let n = 0; n < this.directionalLights.length; n++) {
      const r = new fgn(e);
      this.shadowPasses[n] = r, this.shadowMaps[n] = r.shadowMap;
    }
  }
  _applyDefaultLights() {
    const {
      ambientLight: e,
      pointLights: n,
      directionalLights: r
    } = this;
    !e && n.length === 0 && r.length === 0 && (this.ambientLight = new tqe(ggn), this.directionalLights.push(new bU(M_e[0]), new bU(M_e[1])));
  }
}
class dgn {
  constructor(e = {}) {
    ae(this, "_pool", []), ae(this, "opts", {
      overAlloc: 2,
      poolSize: 100
    }), this.setOptions(e);
  }
  setOptions(e) {
    Object.assign(this.opts, e);
  }
  allocate(e, n, {
    size: r = 1,
    type: i,
    padding: o = 0,
    copy: s = !1,
    initialize: a = !1,
    maxCount: A
  }) {
    const l = i || e && e.constructor || Float32Array, c = n * r + o;
    if (ArrayBuffer.isView(e)) {
      if (c <= e.length)
        return e;
      if (c * e.BYTES_PER_ELEMENT <= e.buffer.byteLength)
        return new l(e.buffer, 0, c);
    }
    let u = 1 / 0;
    A && (u = A * r + o);
    const f = this._allocate(l, c, a, u);
    return e && s ? f.set(e) : a || f.fill(0, 0, 4), this._release(e), f;
  }
  release(e) {
    this._release(e);
  }
  _allocate(e, n, r, i) {
    let o = Math.max(Math.ceil(n * this.opts.overAlloc), 1);
    o > i && (o = i);
    const s = this._pool, a = e.BYTES_PER_ELEMENT * o, A = s.findIndex((l) => l.byteLength >= a);
    if (A >= 0) {
      const l = new e(s.splice(A, 1)[0], 0, o);
      return r && l.fill(0), l;
    }
    return new e(o);
  }
  _release(e) {
    if (!ArrayBuffer.isView(e))
      return;
    const n = this._pool, {
      buffer: r
    } = e, {
      byteLength: i
    } = r, o = n.findIndex((s) => s.byteLength >= i);
    o < 0 ? n.push(r) : (o > 0 || n.length < this.opts.poolSize) && n.splice(o, 0, r), n.length > this.opts.poolSize && n.shift();
  }
}
const jS = new dgn();
function bR() {
  return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
}
function _U(t, e) {
  const n = t % e;
  return n < 0 ? e + n : n;
}
function pgn(t) {
  return [t[12], t[13], t[14]];
}
function Ign(t) {
  return {
    left: ab(t[3] + t[0], t[7] + t[4], t[11] + t[8], t[15] + t[12]),
    right: ab(t[3] - t[0], t[7] - t[4], t[11] - t[8], t[15] - t[12]),
    bottom: ab(t[3] + t[1], t[7] + t[5], t[11] + t[9], t[15] + t[13]),
    top: ab(t[3] - t[1], t[7] - t[5], t[11] - t[9], t[15] - t[13]),
    near: ab(t[3] + t[2], t[7] + t[6], t[11] + t[10], t[15] + t[14]),
    far: ab(t[3] - t[2], t[7] - t[6], t[11] - t[10], t[15] - t[14])
  };
}
const O_e = new ct();
function ab(t, e, n, r) {
  O_e.set(t, e, n);
  const i = O_e.len();
  return {
    distance: r / i,
    normal: new ct(-t / i, -e / i, -n / i)
  };
}
function iqe(t) {
  return t - Math.fround(t);
}
let A2;
function CV(t, e) {
  const {
    size: n = 1,
    startIndex: r = 0
  } = e, i = e.endIndex !== void 0 ? e.endIndex : t.length, o = (i - r) / n;
  A2 = jS.allocate(A2, o, {
    type: Float32Array,
    size: n * 2
  });
  let s = r, a = 0;
  for (; s < i; ) {
    for (let A = 0; A < n; A++) {
      const l = t[s++];
      A2[a + A] = l, A2[a + A + n] = iqe(l);
    }
    a += n * 2;
  }
  return A2.subarray(0, o * n * 2);
}
const mgn = Math.PI / 180, Cgn = bR(), F_e = [0, 0, 0], Egn = {
  unitsPerMeter: [1, 1, 1],
  metersPerUnit: [1, 1, 1]
};
function ygn({
  width: t,
  height: e,
  orthographic: n,
  fovyRadians: r,
  focalDistance: i,
  padding: o,
  near: s,
  far: a
}) {
  const A = t / e, l = n ? new pn().orthographic({
    fovy: r,
    aspect: A,
    focalDistance: i,
    near: s,
    far: a
  }) : new pn().perspective({
    fovy: r,
    aspect: A,
    near: s,
    far: a
  });
  if (o) {
    const {
      left: c = 0,
      right: u = 0,
      top: f = 0,
      bottom: h = 0
    } = o, d = So((c + t - u) / 2, 0, t) - t / 2, I = So((f + e - h) / 2, 0, e) - e / 2;
    l[8] -= d * 2 / t, l[9] += I * 2 / e;
  }
  return l;
}
class Dd {
  constructor(e = {}) {
    ae(this, "id", void 0), ae(this, "x", void 0), ae(this, "y", void 0), ae(this, "width", void 0), ae(this, "height", void 0), ae(this, "padding", void 0), ae(this, "isGeospatial", void 0), ae(this, "zoom", void 0), ae(this, "focalDistance", void 0), ae(this, "position", void 0), ae(this, "modelMatrix", void 0), ae(this, "distanceScales", void 0), ae(this, "scale", void 0), ae(this, "center", void 0), ae(this, "cameraPosition", void 0), ae(this, "projectionMatrix", void 0), ae(this, "viewMatrix", void 0), ae(this, "viewMatrixUncentered", void 0), ae(this, "viewMatrixInverse", void 0), ae(this, "viewProjectionMatrix", void 0), ae(this, "pixelProjectionMatrix", void 0), ae(this, "pixelUnprojectionMatrix", void 0), ae(this, "resolution", void 0), ae(this, "_frustumPlanes", {}), this.id = e.id || this.constructor.displayName || "viewport", this.x = e.x || 0, this.y = e.y || 0, this.width = e.width || 1, this.height = e.height || 1, this.zoom = e.zoom || 0, this.padding = e.padding, this.distanceScales = e.distanceScales || Egn, this.focalDistance = e.focalDistance || 1, this.position = e.position || F_e, this.modelMatrix = e.modelMatrix || null;
    const {
      longitude: n,
      latitude: r
    } = e;
    this.isGeospatial = Number.isFinite(r) && Number.isFinite(n), this._initProps(e), this._initMatrices(e), this.equals = this.equals.bind(this), this.project = this.project.bind(this), this.unproject = this.unproject.bind(this), this.projectPosition = this.projectPosition.bind(this), this.unprojectPosition = this.unprojectPosition.bind(this), this.projectFlat = this.projectFlat.bind(this), this.unprojectFlat = this.unprojectFlat.bind(this);
  }
  get subViewports() {
    return null;
  }
  get metersPerPixel() {
    return this.distanceScales.metersPerUnit[2] / this.scale;
  }
  get projectionMode() {
    return this.isGeospatial ? this.zoom < 12 ? qh.WEB_MERCATOR : qh.WEB_MERCATOR_AUTO_OFFSET : qh.IDENTITY;
  }
  equals(e) {
    return e instanceof Dd ? this === e ? !0 : e.width === this.width && e.height === this.height && e.scale === this.scale && ul(e.projectionMatrix, this.projectionMatrix) && ul(e.viewMatrix, this.viewMatrix) : !1;
  }
  project(e, {
    topLeft: n = !0
  } = {}) {
    const r = this.projectPosition(e), i = l$(r, this.pixelProjectionMatrix), [o, s] = i, a = n ? s : this.height - s;
    return e.length === 2 ? [o, a] : [o, a, i[2]];
  }
  unproject(e, {
    topLeft: n = !0,
    targetZ: r
  } = {}) {
    const [i, o, s] = e, a = n ? o : this.height - o, A = r && r * this.distanceScales.unitsPerMeter[2], l = JC([i, a, s], this.pixelUnprojectionMatrix, A), [c, u, f] = this.unprojectPosition(l);
    return Number.isFinite(s) ? [c, u, f] : Number.isFinite(r) ? [c, u, r] : [c, u];
  }
  projectPosition(e) {
    const [n, r] = this.projectFlat(e), i = (e[2] || 0) * this.distanceScales.unitsPerMeter[2];
    return [n, r, i];
  }
  unprojectPosition(e) {
    const [n, r] = this.unprojectFlat(e), i = (e[2] || 0) * this.distanceScales.metersPerUnit[2];
    return [n, r, i];
  }
  projectFlat(e) {
    if (this.isGeospatial) {
      const n = Hc(e);
      return n[1] = So(n[1], -318, 830), n;
    }
    return e;
  }
  unprojectFlat(e) {
    return this.isGeospatial ? Mf(e) : e;
  }
  getBounds(e = {}) {
    const n = {
      targetZ: e.z || 0
    }, r = this.unproject([0, 0], n), i = this.unproject([this.width, 0], n), o = this.unproject([0, this.height], n), s = this.unproject([this.width, this.height], n);
    return [Math.min(r[0], i[0], o[0], s[0]), Math.min(r[1], i[1], o[1], s[1]), Math.max(r[0], i[0], o[0], s[0]), Math.max(r[1], i[1], o[1], s[1])];
  }
  getDistanceScales(e) {
    return e ? PT({
      longitude: e[0],
      latitude: e[1],
      highPrecision: !0
    }) : this.distanceScales;
  }
  containsPixel({
    x: e,
    y: n,
    width: r = 1,
    height: i = 1
  }) {
    return e < this.x + this.width && this.x < e + r && n < this.y + this.height && this.y < n + i;
  }
  getFrustumPlanes() {
    return this._frustumPlanes.near ? this._frustumPlanes : (Object.assign(this._frustumPlanes, Ign(this.viewProjectionMatrix)), this._frustumPlanes);
  }
  panByPosition(e, n) {
    return null;
  }
  _initProps(e) {
    const n = e.longitude, r = e.latitude;
    this.isGeospatial && (Number.isFinite(e.zoom) || (this.zoom = Ule({
      latitude: r
    }) + Math.log2(this.focalDistance)), this.distanceScales = e.distanceScales || PT({
      latitude: r,
      longitude: n
    }));
    const i = Math.pow(2, this.zoom);
    this.scale = i;
    const {
      position: o,
      modelMatrix: s
    } = e;
    let a = F_e;
    if (o && (a = s ? new pn(s).transformAsVector(o, []) : o), this.isGeospatial) {
      const A = this.projectPosition([n, r, 0]);
      this.center = new ct(a).scale(this.distanceScales.unitsPerMeter).add(A);
    } else
      this.center = this.projectPosition(a);
  }
  _initMatrices(e) {
    const {
      viewMatrix: n = Cgn,
      projectionMatrix: r = null,
      orthographic: i = !1,
      fovyRadians: o,
      fovy: s = 75,
      near: a = 0.1,
      far: A = 1e3,
      padding: l = null,
      focalDistance: c = 1
    } = e;
    this.viewMatrixUncentered = n, this.viewMatrix = new pn().multiplyRight(n).translate(new ct(this.center).negate()), this.projectionMatrix = r || ygn({
      width: this.width,
      height: this.height,
      orthographic: i,
      fovyRadians: o || s * mgn,
      focalDistance: c,
      padding: l,
      near: a,
      far: A
    });
    const u = bR();
    Np(u, u, this.projectionMatrix), Np(u, u, this.viewMatrix), this.viewProjectionMatrix = u, this.viewMatrixInverse = EU([], this.viewMatrix) || this.viewMatrix, this.cameraPosition = pgn(this.viewMatrixInverse);
    const f = bR(), h = bR();
    i$(f, f, [this.width / 2, -this.height / 2, 1]), FT(f, f, [1, -1, 0]), Np(h, f, this.viewProjectionMatrix), this.pixelProjectionMatrix = h, this.pixelUnprojectionMatrix = EU(bR(), this.pixelProjectionMatrix), this.pixelUnprojectionMatrix || Rr.warn("Pixel project matrix not invertible")();
  }
}
ae(Dd, "displayName", "Viewport");
const vgn = 512, Bgn = 4003e4, bgn = Math.PI / 180;
function P_e(t) {
  const e = Math.cos(t * bgn);
  return vgn / Bgn / e;
}
class gd extends Dd {
  constructor(e = {}) {
    const {
      latitude: n = 0,
      longitude: r = 0,
      zoom: i = 0,
      pitch: o = 0,
      bearing: s = 0,
      nearZMultiplier: a = 0.1,
      farZMultiplier: A = 1.01,
      orthographic: l = !1,
      projectionMatrix: c,
      repeat: u = !1,
      worldOffset: f = 0,
      legacyMeterSizes: h = !1
    } = e;
    let {
      width: d,
      height: I,
      altitude: m = 1.5
    } = e;
    const C = Math.pow(2, i);
    d = d || 1, I = I || 1;
    let y, v = null;
    c ? (m = c[5] / 2, y = tB(m)) : (e.fovy ? (y = e.fovy, m = uM(y)) : y = tB(m), v = qle({
      width: d,
      height: I,
      pitch: o,
      fovy: y,
      nearZMultiplier: a,
      farZMultiplier: A
    }));
    let b = $le({
      height: I,
      pitch: o,
      bearing: s,
      scale: C,
      altitude: m
    });
    f && (b = new pn().translate([512 * f, 0, 0]).multiplyLeft(b)), super({
      ...e,
      width: d,
      height: I,
      viewMatrix: b,
      longitude: r,
      latitude: n,
      zoom: i,
      ...v,
      fovy: y,
      focalDistance: m
    }), ae(this, "longitude", void 0), ae(this, "latitude", void 0), ae(this, "pitch", void 0), ae(this, "bearing", void 0), ae(this, "altitude", void 0), ae(this, "fovy", void 0), ae(this, "orthographic", void 0), ae(this, "_subViewports", void 0), ae(this, "_pseudoMeters", void 0), this.latitude = n, this.longitude = r, this.zoom = i, this.pitch = o, this.bearing = s, this.altitude = m, this.fovy = y, this.orthographic = l, this._subViewports = u ? [] : null, this._pseudoMeters = h, Object.freeze(this);
  }
  get subViewports() {
    if (this._subViewports && !this._subViewports.length) {
      const e = this.getBounds(), n = Math.floor((e[0] + 180) / 360), r = Math.ceil((e[2] - 180) / 360);
      for (let i = n; i <= r; i++) {
        const o = i ? new gd({
          ...this,
          worldOffset: i
        }) : this;
        this._subViewports.push(o);
      }
    }
    return this._subViewports;
  }
  projectPosition(e) {
    if (this._pseudoMeters)
      return super.projectPosition(e);
    const [n, r] = this.projectFlat(e), i = (e[2] || 0) * P_e(e[1]);
    return [n, r, i];
  }
  unprojectPosition(e) {
    if (this._pseudoMeters)
      return super.unprojectPosition(e);
    const [n, r] = this.unprojectFlat(e), i = (e[2] || 0) / P_e(r);
    return [n, r, i];
  }
  addMetersToLngLat(e, n) {
    return Hle(e, n);
  }
  panByPosition(e, n) {
    const r = JC(n, this.pixelUnprojectionMatrix), i = this.projectFlat(e), o = eB([], i, Dle([], r)), s = eB([], this.center, o), [a, A] = this.unprojectFlat(s);
    return {
      longitude: a,
      latitude: A
    };
  }
  getBounds(e = {}) {
    const n = jle(this, e.z || 0);
    return [Math.min(n[0][0], n[1][0], n[2][0], n[3][0]), Math.min(n[0][1], n[1][1], n[2][1], n[3][1]), Math.max(n[0][0], n[1][0], n[2][0], n[3][0]), Math.max(n[0][1], n[1][1], n[2][1], n[3][1])];
  }
  fitBounds(e, n = {}) {
    const {
      width: r,
      height: i
    } = this, {
      longitude: o,
      latitude: s,
      zoom: a
    } = c$({
      width: r,
      height: i,
      bounds: e,
      ...n
    });
    return new gd({
      width: r,
      height: i,
      longitude: o,
      latitude: s,
      zoom: a
    });
  }
}
ae(gd, "displayName", "WebMercatorViewport");
function EV(t, e, n = !1) {
  const r = e.projectPosition(t);
  if (n && e instanceof gd) {
    const [i, o, s = 0] = t, a = e.getDistanceScales([i, o]);
    r[2] = s * a.unitsPerMeter[2];
  }
  return r;
}
function _gn(t) {
  const {
    viewport: e,
    modelMatrix: n,
    coordinateOrigin: r
  } = t;
  let {
    coordinateSystem: i,
    fromCoordinateSystem: o,
    fromCoordinateOrigin: s
  } = t;
  return i === wn.DEFAULT && (i = e.isGeospatial ? wn.LNGLAT : wn.CARTESIAN), o === void 0 && (o = i), s === void 0 && (s = r), {
    viewport: e,
    coordinateSystem: i,
    coordinateOrigin: r,
    modelMatrix: n,
    fromCoordinateSystem: o,
    fromCoordinateOrigin: s
  };
}
function oqe(t, {
  viewport: e,
  modelMatrix: n,
  coordinateSystem: r,
  coordinateOrigin: i,
  offsetMode: o
}) {
  let [s, a, A = 0] = t;
  switch (n && ([s, a, A] = Tw([], [s, a, A, 1], n)), r) {
    case wn.LNGLAT:
      return EV([s, a, A], e, o);
    case wn.LNGLAT_OFFSETS:
      return EV([s + i[0], a + i[1], A + (i[2] || 0)], e, o);
    case wn.METER_OFFSETS:
      return EV(Hle(i, [s, a, A]), e, o);
    case wn.CARTESIAN:
    default:
      return e.isGeospatial ? [s + i[0], a + i[1], A + i[2]] : e.projectPosition([s, a, A]);
  }
}
function sqe(t, e) {
  const {
    viewport: n,
    coordinateSystem: r,
    coordinateOrigin: i,
    modelMatrix: o,
    fromCoordinateSystem: s,
    fromCoordinateOrigin: a
  } = _gn(e), {
    geospatialOrigin: A,
    shaderCoordinateOrigin: l,
    offsetMode: c
  } = q$e(n, r, i), u = oqe(t, {
    viewport: n,
    modelMatrix: o,
    coordinateSystem: s,
    coordinateOrigin: a,
    offsetMode: c
  });
  if (c) {
    const f = n.projectPosition(A || l);
    b$e(u, u, f);
  }
  return u;
}
const Sgn = [255, 255, 255], Qgn = 1, wgn = [0, 0, 1], xgn = [0, 0, 1];
let Rgn = 0;
class aqe {
  constructor(e = {}) {
    ae(this, "id", void 0), ae(this, "color", void 0), ae(this, "intensity", void 0), ae(this, "type", "point"), ae(this, "position", void 0), ae(this, "attenuation", void 0), ae(this, "projectedLight", void 0);
    const {
      color: n = Sgn
    } = e, {
      intensity: r = Qgn
    } = e, {
      position: i = xgn
    } = e;
    this.id = e.id || "point-".concat(Rgn++), this.color = n, this.intensity = r, this.type = "point", this.position = i, this.attenuation = Dgn(e), this.projectedLight = {
      ...this
    };
  }
  getProjectedLight({
    layer: e
  }) {
    const {
      projectedLight: n
    } = this, r = e.context.viewport, {
      coordinateSystem: i,
      coordinateOrigin: o
    } = e.props, s = sqe(this.position, {
      viewport: r,
      coordinateSystem: i,
      coordinateOrigin: o,
      fromCoordinateSystem: r.isGeospatial ? wn.LNGLAT : wn.CARTESIAN,
      fromCoordinateOrigin: [0, 0, 0]
    });
    return n.color = this.color, n.intensity = this.intensity, n.position = s, n;
  }
}
function Dgn(t) {
  return t.attenuation ? t.attenuation : "intensity" in t ? [0, 0, t.intensity || 0] : wgn;
}
class Tgn extends aqe {
  getProjectedLight({
    layer: e
  }) {
    const {
      projectedLight: n
    } = this, r = e.context.viewport, {
      coordinateSystem: i,
      coordinateOrigin: o,
      modelMatrix: s
    } = e.props, {
      project_uCameraPosition: a
    } = j$e({
      viewport: r,
      modelMatrix: s,
      coordinateSystem: i,
      coordinateOrigin: o
    });
    return n.color = this.color, n.intensity = this.intensity, n.position = a, n;
  }
}
const nB = Math.PI / 180, Ngn = 1e3 * 60 * 60 * 24, Lgn = 2440588, Mgn = 2451545, SU = nB * 23.4397, Ogn = 357.5291, Fgn = 0.98560028, Pgn = 280.147, kgn = 360.9856235;
function Ggn(t, e, n) {
  const r = nB * -n, i = nB * e, o = Hgn(t), s = Kgn(o), a = zgn(o, r) - s.rightAscension;
  return {
    azimuth: jgn(a, i, s.declination),
    altitude: Ygn(a, i, s.declination)
  };
}
function k_e(t, e, n) {
  const {
    azimuth: r,
    altitude: i
  } = Ggn(t, e, n);
  return [Math.sin(r) * Math.cos(i), Math.cos(r) * Math.cos(i), -Math.sin(i)];
}
function Ugn(t) {
  return (typeof t == "number" ? t : t.getTime()) / Ngn - 0.5 + Lgn;
}
function Hgn(t) {
  return Ugn(t) - Mgn;
}
function $gn(t, e) {
  const n = t;
  return Math.atan2(Math.sin(n) * Math.cos(SU) - Math.tan(e) * Math.sin(SU), Math.cos(n));
}
function qgn(t, e) {
  const n = t;
  return Math.asin(Math.sin(e) * Math.cos(SU) + Math.cos(e) * Math.sin(SU) * Math.sin(n));
}
function jgn(t, e, n) {
  const r = t, i = e, o = n;
  return Math.atan2(Math.sin(r), Math.cos(r) * Math.sin(i) - Math.tan(o) * Math.cos(i));
}
function Ygn(t, e, n) {
  const r = t, i = e, o = n;
  return Math.asin(Math.sin(i) * Math.sin(o) + Math.cos(i) * Math.cos(o) * Math.cos(r));
}
function zgn(t, e) {
  return nB * (Pgn + kgn * t) - e;
}
function Vgn(t) {
  return nB * (Ogn + Fgn * t);
}
function Jgn(t) {
  const e = t, n = nB * (1.9148 * Math.sin(e) + 0.02 * Math.sin(2 * e) + 3e-4 * Math.sin(3 * e)), r = nB * 102.9372;
  return e + n + r + Math.PI;
}
function Kgn(t) {
  const e = Vgn(t), n = Jgn(e);
  return {
    declination: qgn(n, 0),
    rightAscension: $gn(n, 0)
  };
}
class Wgn extends bU {
  constructor(e) {
    super(e), ae(this, "timestamp", void 0), this.timestamp = e.timestamp;
  }
  getProjectedLight({
    layer: e
  }) {
    const {
      viewport: n
    } = e.context;
    if (n.resolution && n.resolution > 0) {
      const [i, o, s] = k_e(this.timestamp, 0, 0);
      this.direction = [i, -s, o];
    } else {
      const {
        latitude: i,
        longitude: o
      } = n;
      this.direction = k_e(this.timestamp, i, o);
    }
    return this;
  }
}
class G_e extends nqe {
  constructor(e, n) {
    super(e, n), ae(this, "model", void 0);
    const {
      module: r,
      fs: i,
      id: o
    } = n;
    this.model = new G$e(e, {
      id: o,
      fs: i,
      modules: [r]
    });
  }
  render(e) {
    const n = this.gl;
    cd(n, {
      viewport: [0, 0, n.drawingBufferWidth, n.drawingBufferHeight]
    }), Yc(n, {
      framebuffer: e.outputBuffer,
      clearColor: [0, 0, 0, 0]
    }, () => this._renderPass(n, e));
  }
  delete() {
    this.model.delete(), this.model = null;
  }
  _renderPass(e, n) {
    const {
      inputBuffer: r
    } = n;
    aM(e, {
      color: !0
    }), this.model.draw({
      moduleSettings: this.props.moduleSettings,
      uniforms: {
        texture: r,
        texSize: [r.width, r.height]
      },
      parameters: {
        depthWrite: !1,
        depthTest: !1
      }
    });
  }
}
class Xgn {
  constructor(e, n = {}) {
    ae(this, "id", void 0), ae(this, "props", void 0), ae(this, "module", void 0), ae(this, "passes", void 0), this.id = "".concat(e.name, "-pass"), this.props = n, e$e(e), this.module = e;
  }
  preRender() {
  }
  postRender(e, n) {
    const r = this.passes || Zgn(e, this.module, this.id, this.props);
    this.passes = r;
    const {
      target: i
    } = n;
    let o = n.inputBuffer, s = n.swapBuffer;
    for (let a = 0; a < this.passes.length; a++) {
      i && a === this.passes.length - 1 && (s = i), this.passes[a].render({
        inputBuffer: o,
        outputBuffer: s
      });
      const A = s;
      s = o, o = A;
    }
    return o;
  }
  cleanup() {
    if (this.passes) {
      for (const e of this.passes)
        e.delete();
      this.passes = void 0;
    }
  }
}
function Zgn(t, e, n, r) {
  if (!e.passes) {
    const i = U_e(e);
    return [new G_e(t, {
      id: n,
      module: e,
      fs: i,
      moduleSettings: r
    })];
  }
  return e.passes.map((i, o) => {
    const s = U_e(e, i), a = "".concat(n, "-").concat(o);
    return new G_e(t, {
      id: a,
      module: e,
      fs: s,
      moduleSettings: r
    });
  });
}
const ehn = (t) => `uniform sampler2D texture;
uniform vec2 texSize;

varying vec2 position;
varying vec2 coordinate;
varying vec2 uv;

void main() {
  vec2 texCoord = coordinate;

  gl_FragColor = texture2D(texture, texCoord);
  gl_FragColor = `.concat(t, `(gl_FragColor, texSize, texCoord);
}
`), thn = (t) => `uniform sampler2D texture;
uniform vec2 texSize;

varying vec2 position;
varying vec2 coordinate;
varying vec2 uv;

void main() {
  vec2 texCoord = coordinate;

  gl_FragColor = `.concat(t, `(texture, texSize, texCoord);
}
`);
function U_e(t, e = t) {
  if (e.filter) {
    const n = typeof e.filter == "string" ? e.filter : "".concat(t.name, "_filterColor");
    return ehn(n);
  }
  if (e.sampler) {
    const n = typeof e.sampler == "string" ? e.sampler : "".concat(t.name, "_sampleColor");
    return thn(n);
  }
  return null;
}
const Vb = {
  NO_STATE: "Awaiting state",
  MATCHED: "Matched. State transferred from previous layer",
  INITIALIZED: "Initialized",
  AWAITING_GC: "Discarded. Awaiting garbage collection",
  AWAITING_FINALIZATION: "No longer matched. Awaiting garbage collection",
  FINALIZED: "Finalized! Awaiting garbage collection"
}, QU = Symbol.for("component"), $_ = Symbol.for("asyncPropDefaults"), rB = Symbol.for("asyncPropOriginal"), aC = Symbol.for("asyncPropResolved");
function gM(t, e = () => !0) {
  return Array.isArray(t) ? Aqe(t, e, []) : e(t) ? [t] : [];
}
function Aqe(t, e, n) {
  let r = -1;
  for (; ++r < t.length; ) {
    const i = t[r];
    Array.isArray(i) ? Aqe(i, e, n) : e(i) && n.push(i);
  }
  return n;
}
function lqe({
  target: t,
  source: e,
  start: n = 0,
  count: r = 1
}) {
  const i = e.length, o = r * i;
  let s = 0;
  for (let a = n; s < i; s++)
    t[a++] = e[s];
  for (; s < o; )
    s < o - s ? (t.copyWithin(n + s, n, n + s), s *= 2) : (t.copyWithin(n + s, n, n + o - s), s = o);
  return t;
}
class nhn {
  constructor(e, n, r) {
    ae(this, "id", void 0), ae(this, "context", void 0), ae(this, "isLoaded", void 0), ae(this, "persistent", void 0), ae(this, "_loadCount", 0), ae(this, "_subscribers", /* @__PURE__ */ new Set()), ae(this, "_data", void 0), ae(this, "_loader", void 0), ae(this, "_error", void 0), ae(this, "_content", void 0), this.id = e, this.context = r, this.setData(n);
  }
  subscribe(e) {
    this._subscribers.add(e);
  }
  unsubscribe(e) {
    this._subscribers.delete(e);
  }
  inUse() {
    return this._subscribers.size > 0;
  }
  delete() {
  }
  getData() {
    return this.isLoaded ? this._error ? Promise.reject(this._error) : this._content : this._loader.then(() => this.getData());
  }
  setData(e, n) {
    if (e === this._data && !n)
      return;
    this._data = e;
    const r = ++this._loadCount;
    let i = e;
    typeof e == "string" && (i = TI(e)), i instanceof Promise ? (this.isLoaded = !1, this._loader = i.then((o) => {
      this._loadCount === r && (this.isLoaded = !0, this._error = void 0, this._content = o);
    }).catch((o) => {
      this._loadCount === r && (this.isLoaded = !0, this._error = o || !0);
    })) : (this.isLoaded = !0, this._error = void 0, this._content = e);
    for (const o of this._subscribers)
      o.onChange(this.getData());
  }
}
class rhn {
  constructor({
    gl: e,
    protocol: n
  }) {
    ae(this, "protocol", void 0), ae(this, "_context", void 0), ae(this, "_resources", void 0), ae(this, "_consumers", void 0), ae(this, "_pruneRequest", void 0), this.protocol = n || "resource://", this._context = {
      gl: e,
      resourceManager: this
    }, this._resources = {}, this._consumers = {}, this._pruneRequest = null;
  }
  contains(e) {
    return e.startsWith(this.protocol) ? !0 : e in this._resources;
  }
  add({
    resourceId: e,
    data: n,
    forceUpdate: r = !1,
    persistent: i = !0
  }) {
    let o = this._resources[e];
    o ? o.setData(n, r) : (o = new nhn(e, n, this._context), this._resources[e] = o), o.persistent = i;
  }
  remove(e) {
    const n = this._resources[e];
    n && (n.delete(), delete this._resources[e]);
  }
  unsubscribe({
    consumerId: e
  }) {
    const n = this._consumers[e];
    if (n) {
      for (const r in n) {
        const i = n[r], o = this._resources[i.resourceId];
        o && o.unsubscribe(i);
      }
      delete this._consumers[e], this.prune();
    }
  }
  subscribe({
    resourceId: e,
    onChange: n,
    consumerId: r,
    requestId: i = "default"
  }) {
    const {
      _resources: o,
      protocol: s
    } = this;
    e.startsWith(s) && (e = e.replace(s, ""), o[e] || this.add({
      resourceId: e,
      data: null,
      persistent: !1
    }));
    const a = o[e];
    if (this._track(r, i, a, n), a)
      return a.getData();
  }
  prune() {
    this._pruneRequest || (this._pruneRequest = setTimeout(() => this._prune(), 0));
  }
  finalize() {
    for (const e in this._resources)
      this._resources[e].delete();
  }
  _track(e, n, r, i) {
    const o = this._consumers, s = o[e] = o[e] || {}, a = s[n] || {}, A = a.resourceId && this._resources[a.resourceId];
    A && (A.unsubscribe(a), this.prune()), r && (s[n] = a, a.onChange = i, a.resourceId = r.id, r.subscribe(a));
  }
  _prune() {
    this._pruneRequest = null;
    for (const e of Object.keys(this._resources)) {
      const n = this._resources[e];
      !n.persistent && !n.inUse() && (n.delete(), delete this._resources[e]);
    }
  }
}
const ihn = "layerManager.setLayers", ohn = "layerManager.activateViewport";
class cqe {
  constructor(e, {
    deck: n,
    stats: r,
    viewport: i,
    timeline: o
  } = {}) {
    ae(this, "layers", void 0), ae(this, "context", void 0), ae(this, "resourceManager", void 0), ae(this, "_lastRenderedLayers", []), ae(this, "_needsRedraw", !1), ae(this, "_needsUpdate", !1), ae(this, "_nextLayers", null), ae(this, "_debug", !1), ae(this, "activateViewport", (s) => {
      Ul(ohn, this, s), s && (this.context.viewport = s);
    }), this.layers = [], this.resourceManager = new rhn({
      gl: e,
      protocol: "deck://"
    }), this.context = {
      mousePosition: null,
      userData: {},
      layerManager: this,
      gl: e,
      deck: n,
      programManager: e && ngn(e),
      stats: r || new tM({
        id: "deck.gl"
      }),
      viewport: i || new Dd({
        id: "DEFAULT-INITIAL-VIEWPORT"
      }),
      timeline: o || new Ple(),
      resourceManager: this.resourceManager,
      onError: void 0
    }, Object.seal(this);
  }
  finalize() {
    this.resourceManager.finalize();
    for (const e of this.layers)
      this._finalizeLayer(e);
  }
  needsRedraw(e = {
    clearRedrawFlags: !1
  }) {
    let n = this._needsRedraw;
    e.clearRedrawFlags && (this._needsRedraw = !1);
    for (const r of this.layers) {
      const i = r.getNeedsRedraw(e);
      n = n || i;
    }
    return n;
  }
  needsUpdate() {
    return this._nextLayers && this._nextLayers !== this._lastRenderedLayers ? "layers changed" : this._needsUpdate;
  }
  setNeedsRedraw(e) {
    this._needsRedraw = this._needsRedraw || e;
  }
  setNeedsUpdate(e) {
    this._needsUpdate = this._needsUpdate || e;
  }
  getLayers({
    layerIds: e
  } = {}) {
    return e ? this.layers.filter((n) => e.find((r) => n.id.indexOf(r) === 0)) : this.layers;
  }
  setProps(e) {
    "debug" in e && (this._debug = e.debug), "userData" in e && (this.context.userData = e.userData), "layers" in e && (this._nextLayers = e.layers), "onError" in e && (this.context.onError = e.onError);
  }
  setLayers(e, n) {
    Ul(ihn, this, n, e), this._lastRenderedLayers = e;
    const r = gM(e, Boolean);
    for (const i of r)
      i.context = this.context;
    this._updateLayers(this.layers, r);
  }
  updateLayers() {
    const e = this.needsUpdate();
    e && (this.setNeedsRedraw("updating layers: ".concat(e)), this.setLayers(this._nextLayers || this._lastRenderedLayers, e)), this._nextLayers = null;
  }
  _handleError(e, n, r) {
    r.raiseError(n, "".concat(e, " of ").concat(r));
  }
  _updateLayers(e, n) {
    const r = {};
    for (const s of e)
      r[s.id] ? Rr.warn("Multiple old layers with same id ".concat(s.id))() : r[s.id] = s;
    const i = [];
    this._updateSublayersRecursively(n, r, i), this._finalizeOldLayers(r);
    let o = !1;
    for (const s of i)
      if (s.hasUniformTransition()) {
        o = "Uniform transition in ".concat(s);
        break;
      }
    this._needsUpdate = o, this.layers = i;
  }
  _updateSublayersRecursively(e, n, r) {
    for (const i of e) {
      i.context = this.context;
      const o = n[i.id];
      o === null && Rr.warn("Multiple new layers with same id ".concat(i.id))(), n[i.id] = null;
      let s = null;
      try {
        this._debug && o !== i && i.validateProps(), o ? (this._transferLayerState(o, i), this._updateLayer(i)) : this._initializeLayer(i), r.push(i), s = i.isComposite ? i.getSubLayers() : null;
      } catch (a) {
        this._handleError("matching", a, i);
      }
      s && this._updateSublayersRecursively(s, n, r);
    }
  }
  _finalizeOldLayers(e) {
    for (const n in e) {
      const r = e[n];
      r && this._finalizeLayer(r);
    }
  }
  _initializeLayer(e) {
    try {
      e._initialize(), e.lifecycle = Vb.INITIALIZED;
    } catch (n) {
      this._handleError("initialization", n, e);
    }
  }
  _transferLayerState(e, n) {
    n._transferState(e), n.lifecycle = Vb.MATCHED, n !== e && (e.lifecycle = Vb.AWAITING_GC);
  }
  _updateLayer(e) {
    try {
      e._update();
    } catch (n) {
      this._handleError("update", n, e);
    }
  }
  _finalizeLayer(e) {
    this._needsRedraw = this._needsRedraw || "finalized ".concat(e), e.lifecycle = Vb.AWAITING_FINALIZATION;
    try {
      e._finalize(), e.lifecycle = Vb.FINALIZED;
    } catch (n) {
      this._handleError("finalization", n, e);
    }
  }
}
function t1(t, e) {
  if (t === e)
    return !0;
  if (!t || !e)
    return !1;
  for (const n in t) {
    const r = t[n], i = e[n];
    if (!(r === i || Array.isArray(r) && Array.isArray(i) && t1(r, i)))
      return !1;
  }
  return !0;
}
class shn {
  constructor(e) {
    ae(this, "width", void 0), ae(this, "height", void 0), ae(this, "views", void 0), ae(this, "viewState", void 0), ae(this, "controllers", void 0), ae(this, "timeline", void 0), ae(this, "_viewports", void 0), ae(this, "_viewportMap", void 0), ae(this, "_isUpdating", void 0), ae(this, "_needsRedraw", void 0), ae(this, "_needsUpdate", void 0), ae(this, "_eventManager", void 0), ae(this, "_eventCallbacks", void 0), this.views = [], this.width = 100, this.height = 100, this.viewState = {}, this.controllers = {}, this.timeline = e.timeline, this._viewports = [], this._viewportMap = {}, this._isUpdating = !1, this._needsRedraw = "First render", this._needsUpdate = "Initialize", this._eventManager = e.eventManager, this._eventCallbacks = {
      onViewStateChange: e.onViewStateChange,
      onInteractionStateChange: e.onInteractionStateChange
    }, Object.seal(this), this.setProps(e);
  }
  finalize() {
    for (const e in this.controllers) {
      const n = this.controllers[e];
      n && n.finalize();
    }
    this.controllers = {};
  }
  needsRedraw(e = {
    clearRedrawFlags: !1
  }) {
    const n = this._needsRedraw;
    return e.clearRedrawFlags && (this._needsRedraw = !1), n;
  }
  setNeedsUpdate(e) {
    this._needsUpdate = this._needsUpdate || e, this._needsRedraw = this._needsRedraw || e;
  }
  updateViewStates() {
    for (const e in this.controllers) {
      const n = this.controllers[e];
      n && n.updateTransition();
    }
  }
  getViewports(e) {
    return e ? this._viewports.filter((n) => n.containsPixel(e)) : this._viewports;
  }
  getViews() {
    const e = {};
    return this.views.forEach((n) => {
      e[n.id] = n;
    }), e;
  }
  getView(e) {
    return this.views.find((n) => n.id === e);
  }
  getViewState(e) {
    const n = typeof e == "string" ? this.getView(e) : e, r = n && this.viewState[n.getViewStateId()] || this.viewState;
    return n ? n.filterViewState(r) : r;
  }
  getViewport(e) {
    return this._viewportMap[e];
  }
  unproject(e, n) {
    const r = this.getViewports(), i = {
      x: e[0],
      y: e[1]
    };
    for (let o = r.length - 1; o >= 0; --o) {
      const s = r[o];
      if (s.containsPixel(i)) {
        const a = e.slice();
        return a[0] -= s.x, a[1] -= s.y, s.unproject(a, n);
      }
    }
    return null;
  }
  setProps(e) {
    e.views && this._setViews(e.views), e.viewState && this._setViewState(e.viewState), ("width" in e || "height" in e) && this._setSize(e.width, e.height), this._isUpdating || this._update();
  }
  _update() {
    this._isUpdating = !0, this._needsUpdate && (this._needsUpdate = !1, this._rebuildViewports()), this._needsUpdate && (this._needsUpdate = !1, this._rebuildViewports()), this._isUpdating = !1;
  }
  _setSize(e, n) {
    (e !== this.width || n !== this.height) && (this.width = e, this.height = n, this.setNeedsUpdate("Size changed"));
  }
  _setViews(e) {
    e = gM(e, Boolean), this._diffViews(e, this.views) && this.setNeedsUpdate("views changed"), this.views = e;
  }
  _setViewState(e) {
    e ? (!t1(e, this.viewState) && this.setNeedsUpdate("viewState changed"), this.viewState = e) : Rr.warn("missing `viewState` or `initialViewState`")();
  }
  _onViewStateChange(e, n) {
    this._eventCallbacks.onViewStateChange && this._eventCallbacks.onViewStateChange({
      ...n,
      viewId: e
    });
  }
  _createController(e, n) {
    const r = n.type;
    return new r({
      timeline: this.timeline,
      eventManager: this._eventManager,
      onViewStateChange: this._onViewStateChange.bind(this, n.id),
      onStateChange: this._eventCallbacks.onInteractionStateChange,
      makeViewport: (o) => {
        var s;
        return (s = this.getView(e.id)) === null || s === void 0 ? void 0 : s.makeViewport({
          viewState: o,
          width: this.width,
          height: this.height
        });
      }
    });
  }
  _updateController(e, n, r, i) {
    const o = e.controller;
    if (o) {
      const s = {
        ...n,
        ...o,
        id: e.id,
        x: r.x,
        y: r.y,
        width: r.width,
        height: r.height
      };
      return i || (i = this._createController(e, s)), i && i.setProps(s), i;
    }
    return null;
  }
  _rebuildViewports() {
    const {
      views: e
    } = this, n = this.controllers;
    this._viewports = [], this.controllers = {};
    let r = !1;
    for (let i = e.length; i--; ) {
      const o = e[i], s = this.getViewState(o), a = o.makeViewport({
        viewState: s,
        width: this.width,
        height: this.height
      });
      let A = n[o.id];
      const l = !!o.controller;
      l && !A && (r = !0), (r || !l) && A && (A.finalize(), A = null), this.controllers[o.id] = this._updateController(o, s, a, A), this._viewports.unshift(a);
    }
    for (const i in n) {
      const o = n[i];
      o && !this.controllers[i] && o.finalize();
    }
    this._buildViewportMap();
  }
  _buildViewportMap() {
    this._viewportMap = {}, this._viewports.forEach((e) => {
      e.id && (this._viewportMap[e.id] = this._viewportMap[e.id] || e);
    });
  }
  _diffViews(e, n) {
    return e.length !== n.length ? !0 : e.some((r, i) => !e[i].equals(n[i]));
  }
}
const ahn = /([0-9]+\.?[0-9]*)(%|px)/;
function xm(t) {
  switch (typeof t) {
    case "number":
      return {
        position: t,
        relative: !1
      };
    case "string":
      const e = ahn.exec(t);
      if (e && e.length >= 3) {
        const n = e[2] === "%", r = parseFloat(e[1]);
        return {
          position: n ? r / 100 : r,
          relative: n
        };
      }
    default:
      throw new Error("Could not parse position string ".concat(t));
  }
}
function Rm(t, e) {
  return t.relative ? Math.round(t.position * e) : t.position;
}
function sA(t, e) {
  if (!t)
    throw new Error(e || "deck.gl: assertion failed.");
}
let hd = class {
  constructor(e) {
    ae(this, "id", void 0), ae(this, "viewportInstance", void 0), ae(this, "_x", void 0), ae(this, "_y", void 0), ae(this, "_width", void 0), ae(this, "_height", void 0), ae(this, "_padding", void 0), ae(this, "props", void 0);
    const {
      id: n,
      x: r = 0,
      y: i = 0,
      width: o = "100%",
      height: s = "100%",
      padding: a = null,
      viewportInstance: A
    } = e || {};
    sA(!A || A instanceof Dd), this.viewportInstance = A, this.id = n || this.constructor.displayName || "view", this.props = {
      ...e,
      id: this.id
    }, this._x = xm(r), this._y = xm(i), this._width = xm(o), this._height = xm(s), this._padding = a && {
      left: xm(a.left || 0),
      right: xm(a.right || 0),
      top: xm(a.top || 0),
      bottom: xm(a.bottom || 0)
    }, this.equals = this.equals.bind(this), Object.seal(this);
  }
  equals(e) {
    return this === e ? !0 : this.viewportInstance ? e.viewportInstance ? this.viewportInstance.equals(e.viewportInstance) : !1 : this.ViewportType === e.ViewportType && t1(this.props, e.props);
  }
  makeViewport({
    width: e,
    height: n,
    viewState: r
  }) {
    if (this.viewportInstance)
      return this.viewportInstance;
    r = this.filterViewState(r);
    const i = this.getDimensions({
      width: e,
      height: n
    });
    return new this.ViewportType({
      ...r,
      ...this.props,
      ...i
    });
  }
  getViewStateId() {
    const {
      viewState: e
    } = this.props;
    return typeof e == "string" ? e : e?.id || this.id;
  }
  filterViewState(e) {
    if (this.props.viewState && typeof this.props.viewState == "object") {
      if (!this.props.viewState.id)
        return this.props.viewState;
      const n = {
        ...e
      };
      for (const r in this.props.viewState)
        r !== "id" && (n[r] = this.props.viewState[r]);
      return n;
    }
    return e;
  }
  getDimensions({
    width: e,
    height: n
  }) {
    const r = {
      x: Rm(this._x, e),
      y: Rm(this._y, n),
      width: Rm(this._width, e),
      height: Rm(this._height, n)
    };
    return this._padding && (r.padding = {
      left: Rm(this._padding.left, e),
      top: Rm(this._padding.top, n),
      right: Rm(this._padding.right, e),
      bottom: Rm(this._padding.bottom, n)
    }), r;
  }
  get controller() {
    const e = this.props.controller;
    return e ? e === !0 ? {
      type: this.ControllerType
    } : typeof e == "function" ? {
      type: e
    } : {
      type: this.ControllerType,
      ...e
    } : null;
  }
};
class hM {
  constructor(e) {
    ae(this, "_inProgress", void 0), ae(this, "_handle", void 0), ae(this, "_timeline", void 0), ae(this, "time", void 0), ae(this, "settings", void 0), this._inProgress = !1, this._handle = null, this._timeline = e, this.time = 0, this.settings = {
      duration: 0
    };
  }
  get inProgress() {
    return this._inProgress;
  }
  start(e) {
    var n, r;
    this.cancel(), this.settings = e, this._inProgress = !0, (n = (r = this.settings).onStart) === null || n === void 0 || n.call(r, this);
  }
  end() {
    if (this._inProgress) {
      var e, n;
      this._timeline.removeChannel(this._handle), this._handle = null, this._inProgress = !1, (e = (n = this.settings).onEnd) === null || e === void 0 || e.call(n, this);
    }
  }
  cancel() {
    if (this._inProgress) {
      var e, n;
      (e = (n = this.settings).onInterrupt) === null || e === void 0 || e.call(n, this), this._timeline.removeChannel(this._handle), this._handle = null, this._inProgress = !1;
    }
  }
  update() {
    var e, n;
    if (!this._inProgress)
      return !1;
    if (this._handle === null) {
      const {
        _timeline: r,
        settings: i
      } = this;
      this._handle = r.addChannel({
        delay: r.getTime(),
        duration: i.duration
      });
    }
    return this.time = this._timeline.getTime(this._handle), this._onUpdate(), (e = (n = this.settings).onUpdate) === null || e === void 0 || e.call(n, this), this._timeline.isFinished(this._handle) && this.end(), !0;
  }
  _onUpdate() {
  }
}
const H_e = () => {
}, wU = {
  BREAK: 1,
  SNAP_TO_END: 2,
  IGNORE: 3
}, Ahn = (t) => t, lhn = wU.BREAK;
class chn {
  constructor(e) {
    ae(this, "getControllerState", void 0), ae(this, "props", void 0), ae(this, "propsInTransition", void 0), ae(this, "transition", void 0), ae(this, "onViewStateChange", void 0), ae(this, "onStateChange", void 0), ae(this, "_onTransitionUpdate", (n) => {
      const {
        time: r,
        settings: {
          interpolator: i,
          startProps: o,
          endProps: s,
          duration: a,
          easing: A
        }
      } = n, l = A(r / a), c = i.interpolateProps(o, s, l);
      this.propsInTransition = this.getControllerState({
        ...this.props,
        ...c
      }).getViewportProps(), this.onViewStateChange({
        viewState: this.propsInTransition,
        oldViewState: this.props
      });
    }), this.getControllerState = e.getControllerState, this.propsInTransition = null, this.transition = new hM(e.timeline), this.onViewStateChange = e.onViewStateChange || H_e, this.onStateChange = e.onStateChange || H_e;
  }
  finalize() {
    this.transition.cancel();
  }
  getViewportInTransition() {
    return this.propsInTransition;
  }
  processViewStateChange(e) {
    let n = !1;
    const r = this.props;
    if (this.props = e, !r || this._shouldIgnoreViewportChange(r, e))
      return !1;
    if (this._isTransitionEnabled(e)) {
      let i = r;
      if (this.transition.inProgress) {
        const {
          interruption: o,
          endProps: s
        } = this.transition.settings;
        i = {
          ...r,
          ...o === wU.SNAP_TO_END ? s : this.propsInTransition || r
        };
      }
      this._triggerTransition(i, e), n = !0;
    } else
      this.transition.cancel();
    return n;
  }
  updateTransition() {
    this.transition.update();
  }
  _isTransitionEnabled(e) {
    const {
      transitionDuration: n,
      transitionInterpolator: r
    } = e;
    return (n > 0 || n === "auto") && !!r;
  }
  _isUpdateDueToCurrentTransition(e) {
    return this.transition.inProgress && this.propsInTransition ? this.transition.settings.interpolator.arePropsEqual(e, this.propsInTransition) : !1;
  }
  _shouldIgnoreViewportChange(e, n) {
    return this.transition.inProgress ? this.transition.settings.interruption === wU.IGNORE || this._isUpdateDueToCurrentTransition(n) : this._isTransitionEnabled(n) ? n.transitionInterpolator.arePropsEqual(e, n) : !0;
  }
  _triggerTransition(e, n) {
    const r = this.getControllerState(e), i = this.getControllerState(n).shortestPathFrom(r), o = n.transitionInterpolator, s = o.getDuration ? o.getDuration(e, n) : n.transitionDuration;
    if (s === 0)
      return;
    const a = o.initializeProps(e, i);
    this.propsInTransition = {};
    const A = {
      duration: s,
      easing: n.transitionEasing || Ahn,
      interpolator: o,
      interruption: n.transitionInterruption || lhn,
      startProps: a.start,
      endProps: a.end,
      onStart: n.onTransitionStart,
      onUpdate: this._onTransitionUpdate,
      onInterrupt: this._onTransitionEnd(n.onTransitionInterrupt),
      onEnd: this._onTransitionEnd(n.onTransitionEnd)
    };
    this.transition.start(A), this.onStateChange({
      inTransition: !0
    }), this.updateTransition();
  }
  _onTransitionEnd(e) {
    return (n) => {
      this.propsInTransition = null, this.onStateChange({
        inTransition: !1,
        isZooming: !1,
        isPanning: !1,
        isRotating: !1
      }), e?.(n);
    };
  }
}
class zle {
  constructor(e) {
    ae(this, "_propsToCompare", void 0), ae(this, "_propsToExtract", void 0), ae(this, "_requiredProps", void 0);
    const {
      compare: n,
      extract: r,
      required: i
    } = e;
    this._propsToCompare = n, this._propsToExtract = r || n, this._requiredProps = i;
  }
  arePropsEqual(e, n) {
    for (const r of this._propsToCompare)
      if (!(r in e) || !(r in n) || !ul(e[r], n[r]))
        return !1;
    return !0;
  }
  initializeProps(e, n) {
    const r = {}, i = {};
    for (const o of this._propsToExtract)
      (o in e || o in n) && (r[o] = e[o], i[o] = n[o]);
    return this._checkRequiredProps(r), this._checkRequiredProps(i), {
      start: r,
      end: i
    };
  }
  getDuration(e, n) {
    return n.transitionDuration;
  }
  _checkRequiredProps(e) {
    this._requiredProps && this._requiredProps.forEach((n) => {
      const r = e[n];
      sA(Number.isFinite(r) || Array.isArray(r), "".concat(n, " is required for transition"));
    });
  }
}
const uhn = ["longitude", "latitude", "zoom", "bearing", "pitch"], fhn = ["longitude", "latitude", "zoom"];
class n1 extends zle {
  constructor(e = {}) {
    const n = Array.isArray(e) ? e : e.transitionProps, r = Array.isArray(e) ? {} : e;
    r.transitionProps = Array.isArray(n) ? {
      compare: n,
      required: n
    } : n || {
      compare: uhn,
      required: fhn
    }, super(r.transitionProps), ae(this, "opts", void 0), this.opts = r;
  }
  initializeProps(e, n) {
    const r = super.initializeProps(e, n), {
      makeViewport: i,
      around: o
    } = this.opts;
    if (i && o) {
      const s = i(e), a = i(n), A = s.unproject(o);
      r.start.around = o, Object.assign(r.end, {
        around: a.project(A),
        aroundPosition: A,
        width: n.width,
        height: n.height
      });
    }
    return r;
  }
  interpolateProps(e, n, r) {
    const i = {};
    for (const o of this._propsToExtract)
      i[o] = Lf(e[o] || 0, n[o] || 0, r);
    if (n.aroundPosition && this.opts.makeViewport) {
      const o = this.opts.makeViewport({
        ...n,
        ...i
      });
      Object.assign(i, o.panByPosition(n.aroundPosition, Lf(e.around, n.around, r)));
    }
    return i;
  }
}
const Dm = {
  transitionDuration: 0
}, ghn = 300, ZF = (t) => 1 - (1 - t) * (1 - t), Ab = {
  WHEEL: ["wheel"],
  PAN: ["panstart", "panmove", "panend"],
  PINCH: ["pinchstart", "pinchmove", "pinchend"],
  TRIPLE_PAN: ["tripanstart", "tripanmove", "tripanend"],
  DOUBLE_TAP: ["doubletap"],
  KEYBOARD: ["keydown"]
}, dy = {};
class Mw {
  constructor(e) {
    ae(this, "props", void 0), ae(this, "state", {}), ae(this, "transitionManager", void 0), ae(this, "eventManager", void 0), ae(this, "onViewStateChange", void 0), ae(this, "onStateChange", void 0), ae(this, "makeViewport", void 0), ae(this, "_controllerState", void 0), ae(this, "_events", {}), ae(this, "_interactionState", {
      isDragging: !1
    }), ae(this, "_customEvents", []), ae(this, "_eventStartBlocked", null), ae(this, "_panMove", !1), ae(this, "invertPan", !1), ae(this, "dragMode", "rotate"), ae(this, "inertia", 0), ae(this, "scrollZoom", !0), ae(this, "dragPan", !0), ae(this, "dragRotate", !0), ae(this, "doubleClickZoom", !0), ae(this, "touchZoom", !0), ae(this, "touchRotate", !1), ae(this, "keyboard", !0), this.transitionManager = new chn({
      ...e,
      getControllerState: (n) => new this.ControllerState(n),
      onViewStateChange: this._onTransition.bind(this),
      onStateChange: this._setInteractionState.bind(this)
    }), this.handleEvent = this.handleEvent.bind(this), this.eventManager = e.eventManager, this.onViewStateChange = e.onViewStateChange || (() => {
    }), this.onStateChange = e.onStateChange || (() => {
    }), this.makeViewport = e.makeViewport;
  }
  set events(e) {
    this.toggleEvents(this._customEvents, !1), this.toggleEvents(e, !0), this._customEvents = e, this.props && this.setProps(this.props);
  }
  finalize() {
    for (const n in this._events)
      if (this._events[n]) {
        var e;
        (e = this.eventManager) === null || e === void 0 || e.off(n, this.handleEvent);
      }
    this.transitionManager.finalize();
  }
  handleEvent(e) {
    this._controllerState = void 0;
    const n = this._eventStartBlocked;
    switch (e.type) {
      case "panstart":
        return n ? !1 : this._onPanStart(e);
      case "panmove":
        return this._onPan(e);
      case "panend":
        return this._onPanEnd(e);
      case "pinchstart":
        return n ? !1 : this._onPinchStart(e);
      case "pinchmove":
        return this._onPinch(e);
      case "pinchend":
        return this._onPinchEnd(e);
      case "tripanstart":
        return n ? !1 : this._onTriplePanStart(e);
      case "tripanmove":
        return this._onTriplePan(e);
      case "tripanend":
        return this._onTriplePanEnd(e);
      case "doubletap":
        return this._onDoubleTap(e);
      case "wheel":
        return this._onWheel(e);
      case "keydown":
        return this._onKeyDown(e);
      default:
        return !1;
    }
  }
  get controllerState() {
    return this._controllerState = this._controllerState || new this.ControllerState({
      makeViewport: this.makeViewport,
      ...this.props,
      ...this.state
    }), this._controllerState;
  }
  getCenter(e) {
    const {
      x: n,
      y: r
    } = this.props, {
      offsetCenter: i
    } = e;
    return [i.x - n, i.y - r];
  }
  isPointInBounds(e, n) {
    const {
      width: r,
      height: i
    } = this.props;
    if (n && n.handled)
      return !1;
    const o = e[0] >= 0 && e[0] <= r && e[1] >= 0 && e[1] <= i;
    return o && n && n.stopPropagation(), o;
  }
  isFunctionKeyPressed(e) {
    const {
      srcEvent: n
    } = e;
    return !!(n.metaKey || n.altKey || n.ctrlKey || n.shiftKey);
  }
  isDragging() {
    return this._interactionState.isDragging || !1;
  }
  blockEvents(e) {
    const n = setTimeout(() => {
      this._eventStartBlocked === n && (this._eventStartBlocked = null);
    }, e);
    this._eventStartBlocked = n;
  }
  setProps(e) {
    e.dragMode && (this.dragMode = e.dragMode), this.props = e, "transitionInterpolator" in e || (e.transitionInterpolator = this._getTransitionProps().transitionInterpolator), this.transitionManager.processViewStateChange(e);
    const {
      inertia: n
    } = e;
    this.inertia = Number.isFinite(n) ? n : n === !0 ? ghn : 0;
    const {
      scrollZoom: r = !0,
      dragPan: i = !0,
      dragRotate: o = !0,
      doubleClickZoom: s = !0,
      touchZoom: a = !0,
      touchRotate: A = !1,
      keyboard: l = !0
    } = e, c = !!this.onViewStateChange;
    this.toggleEvents(Ab.WHEEL, c && r), this.toggleEvents(Ab.PAN, c && (i || o)), this.toggleEvents(Ab.PINCH, c && (a || A)), this.toggleEvents(Ab.TRIPLE_PAN, c && A), this.toggleEvents(Ab.DOUBLE_TAP, c && s), this.toggleEvents(Ab.KEYBOARD, c && l), this.scrollZoom = r, this.dragPan = i, this.dragRotate = o, this.doubleClickZoom = s, this.touchZoom = a, this.touchRotate = A, this.keyboard = l;
  }
  updateTransition() {
    this.transitionManager.updateTransition();
  }
  toggleEvents(e, n) {
    this.eventManager && e.forEach((r) => {
      this._events[r] !== n && (this._events[r] = n, n ? this.eventManager.on(r, this.handleEvent) : this.eventManager.off(r, this.handleEvent));
    });
  }
  updateViewport(e, n = null, r = {}) {
    const i = {
      ...e.getViewportProps(),
      ...n
    }, o = this.controllerState !== e;
    if (this.state = e.getState(), this._setInteractionState(r), o) {
      const s = this.controllerState && this.controllerState.getViewportProps();
      this.onViewStateChange && this.onViewStateChange({
        viewState: i,
        interactionState: this._interactionState,
        oldViewState: s
      });
    }
  }
  _onTransition(e) {
    this.onViewStateChange({
      ...e,
      interactionState: this._interactionState
    });
  }
  _setInteractionState(e) {
    Object.assign(this._interactionState, e), this.onStateChange(this._interactionState);
  }
  _onPanStart(e) {
    const n = this.getCenter(e);
    if (!this.isPointInBounds(n, e))
      return !1;
    let r = this.isFunctionKeyPressed(e) || e.rightButton || !1;
    (this.invertPan || this.dragMode === "pan") && (r = !r);
    const i = this.controllerState[r ? "panStart" : "rotateStart"]({
      pos: n
    });
    return this._panMove = r, this.updateViewport(i, Dm, {
      isDragging: !0
    }), !0;
  }
  _onPan(e) {
    return this.isDragging() ? this._panMove ? this._onPanMove(e) : this._onPanRotate(e) : !1;
  }
  _onPanEnd(e) {
    return this.isDragging() ? this._panMove ? this._onPanMoveEnd(e) : this._onPanRotateEnd(e) : !1;
  }
  _onPanMove(e) {
    if (!this.dragPan)
      return !1;
    const n = this.getCenter(e), r = this.controllerState.pan({
      pos: n
    });
    return this.updateViewport(r, Dm, {
      isDragging: !0,
      isPanning: !0
    }), !0;
  }
  _onPanMoveEnd(e) {
    const {
      inertia: n
    } = this;
    if (this.dragPan && n && e.velocity) {
      const r = this.getCenter(e), i = [r[0] + e.velocityX * n / 2, r[1] + e.velocityY * n / 2], o = this.controllerState.pan({
        pos: i
      }).panEnd();
      this.updateViewport(o, {
        ...this._getTransitionProps(),
        transitionDuration: n,
        transitionEasing: ZF
      }, {
        isDragging: !1,
        isPanning: !0
      });
    } else {
      const r = this.controllerState.panEnd();
      this.updateViewport(r, null, {
        isDragging: !1,
        isPanning: !1
      });
    }
    return !0;
  }
  _onPanRotate(e) {
    if (!this.dragRotate)
      return !1;
    const n = this.getCenter(e), r = this.controllerState.rotate({
      pos: n
    });
    return this.updateViewport(r, Dm, {
      isDragging: !0,
      isRotating: !0
    }), !0;
  }
  _onPanRotateEnd(e) {
    const {
      inertia: n
    } = this;
    if (this.dragRotate && n && e.velocity) {
      const r = this.getCenter(e), i = [r[0] + e.velocityX * n / 2, r[1] + e.velocityY * n / 2], o = this.controllerState.rotate({
        pos: i
      }).rotateEnd();
      this.updateViewport(o, {
        ...this._getTransitionProps(),
        transitionDuration: n,
        transitionEasing: ZF
      }, {
        isDragging: !1,
        isRotating: !0
      });
    } else {
      const r = this.controllerState.rotateEnd();
      this.updateViewport(r, null, {
        isDragging: !1,
        isRotating: !1
      });
    }
    return !0;
  }
  _onWheel(e) {
    if (!this.scrollZoom)
      return !1;
    e.srcEvent.preventDefault();
    const n = this.getCenter(e);
    if (!this.isPointInBounds(n, e))
      return !1;
    const {
      speed: r = 0.01,
      smooth: i = !1
    } = this.scrollZoom === !0 ? {} : this.scrollZoom, {
      delta: o
    } = e;
    let s = 2 / (1 + Math.exp(-Math.abs(o * r)));
    o < 0 && s !== 0 && (s = 1 / s);
    const a = this.controllerState.zoom({
      pos: n,
      scale: s
    });
    return this.updateViewport(a, {
      ...this._getTransitionProps({
        around: n
      }),
      transitionDuration: i ? 250 : 1
    }, {
      isZooming: !0,
      isPanning: !0
    }), !0;
  }
  _onTriplePanStart(e) {
    const n = this.getCenter(e);
    if (!this.isPointInBounds(n, e))
      return !1;
    const r = this.controllerState.rotateStart({
      pos: n
    });
    return this.updateViewport(r, Dm, {
      isDragging: !0
    }), !0;
  }
  _onTriplePan(e) {
    if (!this.touchRotate || !this.isDragging())
      return !1;
    const n = this.getCenter(e);
    n[0] -= e.deltaX;
    const r = this.controllerState.rotate({
      pos: n
    });
    return this.updateViewport(r, Dm, {
      isDragging: !0,
      isRotating: !0
    }), !0;
  }
  _onTriplePanEnd(e) {
    if (!this.isDragging())
      return !1;
    const {
      inertia: n
    } = this;
    if (this.touchRotate && n && e.velocityY) {
      const r = this.getCenter(e), i = [r[0], r[1] += e.velocityY * n / 2], o = this.controllerState.rotate({
        pos: i
      });
      this.updateViewport(o, {
        ...this._getTransitionProps(),
        transitionDuration: n,
        transitionEasing: ZF
      }, {
        isDragging: !1,
        isRotating: !0
      }), this.blockEvents(n);
    } else {
      const r = this.controllerState.rotateEnd();
      this.updateViewport(r, null, {
        isDragging: !1,
        isRotating: !1
      });
    }
    return !0;
  }
  _onPinchStart(e) {
    const n = this.getCenter(e);
    if (!this.isPointInBounds(n, e))
      return !1;
    const r = this.controllerState.zoomStart({
      pos: n
    }).rotateStart({
      pos: n
    });
    return dy._startPinchRotation = e.rotation, dy._lastPinchEvent = e, this.updateViewport(r, Dm, {
      isDragging: !0
    }), !0;
  }
  _onPinch(e) {
    if (!this.touchZoom && !this.touchRotate || !this.isDragging())
      return !1;
    let n = this.controllerState;
    if (this.touchZoom) {
      const {
        scale: r
      } = e, i = this.getCenter(e);
      n = n.zoom({
        pos: i,
        scale: r
      });
    }
    if (this.touchRotate) {
      const {
        rotation: r
      } = e;
      n = n.rotate({
        deltaAngleX: dy._startPinchRotation - r
      });
    }
    return this.updateViewport(n, Dm, {
      isDragging: !0,
      isPanning: this.touchZoom,
      isZooming: this.touchZoom,
      isRotating: this.touchRotate
    }), dy._lastPinchEvent = e, !0;
  }
  _onPinchEnd(e) {
    if (!this.isDragging())
      return !1;
    const {
      inertia: n
    } = this, {
      _lastPinchEvent: r
    } = dy;
    if (this.touchZoom && n && r && e.scale !== r.scale) {
      const i = this.getCenter(e);
      let o = this.controllerState.rotateEnd();
      const s = Math.log2(e.scale), a = (s - Math.log2(r.scale)) / (e.deltaTime - r.deltaTime), A = Math.pow(2, s + a * n / 2);
      o = o.zoom({
        pos: i,
        scale: A
      }).zoomEnd(), this.updateViewport(o, {
        ...this._getTransitionProps({
          around: i
        }),
        transitionDuration: n,
        transitionEasing: ZF
      }, {
        isDragging: !1,
        isPanning: this.touchZoom,
        isZooming: this.touchZoom,
        isRotating: !1
      }), this.blockEvents(n);
    } else {
      const i = this.controllerState.zoomEnd().rotateEnd();
      this.updateViewport(i, null, {
        isDragging: !1,
        isPanning: !1,
        isZooming: !1,
        isRotating: !1
      });
    }
    return dy._startPinchRotation = null, dy._lastPinchEvent = null, !0;
  }
  _onDoubleTap(e) {
    if (!this.doubleClickZoom)
      return !1;
    const n = this.getCenter(e);
    if (!this.isPointInBounds(n, e))
      return !1;
    const r = this.isFunctionKeyPressed(e), i = this.controllerState.zoom({
      pos: n,
      scale: r ? 0.5 : 2
    });
    return this.updateViewport(i, this._getTransitionProps({
      around: n
    }), {
      isZooming: !0,
      isPanning: !0
    }), this.blockEvents(100), !0;
  }
  _onKeyDown(e) {
    if (!this.keyboard)
      return !1;
    const n = this.isFunctionKeyPressed(e), {
      zoomSpeed: r,
      moveSpeed: i,
      rotateSpeedX: o,
      rotateSpeedY: s
    } = this.keyboard === !0 ? {} : this.keyboard, {
      controllerState: a
    } = this;
    let A;
    const l = {};
    switch (e.srcEvent.code) {
      case "Minus":
        A = n ? a.zoomOut(r).zoomOut(r) : a.zoomOut(r), l.isZooming = !0;
        break;
      case "Equal":
        A = n ? a.zoomIn(r).zoomIn(r) : a.zoomIn(r), l.isZooming = !0;
        break;
      case "ArrowLeft":
        n ? (A = a.rotateLeft(o), l.isRotating = !0) : (A = a.moveLeft(i), l.isPanning = !0);
        break;
      case "ArrowRight":
        n ? (A = a.rotateRight(o), l.isRotating = !0) : (A = a.moveRight(i), l.isPanning = !0);
        break;
      case "ArrowUp":
        n ? (A = a.rotateUp(s), l.isRotating = !0) : (A = a.moveUp(i), l.isPanning = !0);
        break;
      case "ArrowDown":
        n ? (A = a.rotateDown(s), l.isRotating = !0) : (A = a.moveDown(i), l.isPanning = !0);
        break;
      default:
        return !1;
    }
    return this.updateViewport(A, this._getTransitionProps(), l), !0;
  }
  _getTransitionProps(e) {
    const {
      transition: n
    } = this;
    return !n || !n.transitionInterpolator ? Dm : e ? {
      ...n,
      transitionInterpolator: new n1({
        ...e,
        ...n.transitionInterpolator.opts,
        makeViewport: this.controllerState.makeViewport
      })
    } : n;
  }
}
class Vle {
  constructor(e, n) {
    ae(this, "_viewportProps", void 0), ae(this, "_state", void 0), this._viewportProps = this.applyConstraints(e), this._state = n;
  }
  getViewportProps() {
    return this._viewportProps;
  }
  getState() {
    return this._state;
  }
}
const $_e = 5, hhn = 1.2;
class uqe extends Vle {
  constructor(e) {
    const {
      width: n,
      height: r,
      latitude: i,
      longitude: o,
      zoom: s,
      bearing: a = 0,
      pitch: A = 0,
      altitude: l = 1.5,
      position: c = [0, 0, 0],
      maxZoom: u = 20,
      minZoom: f = 0,
      maxPitch: h = 60,
      minPitch: d = 0,
      startPanLngLat: I,
      startZoomLngLat: m,
      startRotatePos: C,
      startBearing: y,
      startPitch: v,
      startZoom: b,
      normalize: Q = !0
    } = e;
    sA(Number.isFinite(o)), sA(Number.isFinite(i)), sA(Number.isFinite(s)), super({
      width: n,
      height: r,
      latitude: i,
      longitude: o,
      zoom: s,
      bearing: a,
      pitch: A,
      altitude: l,
      maxZoom: u,
      minZoom: f,
      maxPitch: h,
      minPitch: d,
      normalize: Q,
      position: c
    }, {
      startPanLngLat: I,
      startZoomLngLat: m,
      startRotatePos: C,
      startBearing: y,
      startPitch: v,
      startZoom: b
    }), ae(this, "makeViewport", void 0), this.makeViewport = e.makeViewport;
  }
  panStart({
    pos: e
  }) {
    return this._getUpdatedState({
      startPanLngLat: this._unproject(e)
    });
  }
  pan({
    pos: e,
    startPos: n
  }) {
    const r = this.getState().startPanLngLat || this._unproject(n);
    if (!r)
      return this;
    const o = this.makeViewport(this.getViewportProps()).panByPosition(r, e);
    return this._getUpdatedState(o);
  }
  panEnd() {
    return this._getUpdatedState({
      startPanLngLat: null
    });
  }
  rotateStart({
    pos: e
  }) {
    return this._getUpdatedState({
      startRotatePos: e,
      startBearing: this.getViewportProps().bearing,
      startPitch: this.getViewportProps().pitch
    });
  }
  rotate({
    pos: e,
    deltaAngleX: n = 0,
    deltaAngleY: r = 0
  }) {
    const {
      startRotatePos: i,
      startBearing: o,
      startPitch: s
    } = this.getState();
    if (!i || o === void 0 || s === void 0)
      return this;
    let a;
    return e ? a = this._getNewRotation(e, i, s, o) : a = {
      bearing: o + n,
      pitch: s + r
    }, this._getUpdatedState(a);
  }
  rotateEnd() {
    return this._getUpdatedState({
      startBearing: null,
      startPitch: null
    });
  }
  zoomStart({
    pos: e
  }) {
    return this._getUpdatedState({
      startZoomLngLat: this._unproject(e),
      startZoom: this.getViewportProps().zoom
    });
  }
  zoom({
    pos: e,
    startPos: n,
    scale: r
  }) {
    let {
      startZoom: i,
      startZoomLngLat: o
    } = this.getState();
    if (o || (i = this.getViewportProps().zoom, o = this._unproject(n) || this._unproject(e)), !o)
      return this;
    const {
      maxZoom: s,
      minZoom: a
    } = this.getViewportProps();
    let A = i + Math.log2(r);
    A = So(A, a, s);
    const l = this.makeViewport({
      ...this.getViewportProps(),
      zoom: A
    });
    return this._getUpdatedState({
      zoom: A,
      ...l.panByPosition(o, e)
    });
  }
  zoomEnd() {
    return this._getUpdatedState({
      startZoomLngLat: null,
      startZoom: null
    });
  }
  zoomIn(e = 2) {
    return this._zoomFromCenter(e);
  }
  zoomOut(e = 2) {
    return this._zoomFromCenter(1 / e);
  }
  moveLeft(e = 100) {
    return this._panFromCenter([e, 0]);
  }
  moveRight(e = 100) {
    return this._panFromCenter([-e, 0]);
  }
  moveUp(e = 100) {
    return this._panFromCenter([0, e]);
  }
  moveDown(e = 100) {
    return this._panFromCenter([0, -e]);
  }
  rotateLeft(e = 15) {
    return this._getUpdatedState({
      bearing: this.getViewportProps().bearing - e
    });
  }
  rotateRight(e = 15) {
    return this._getUpdatedState({
      bearing: this.getViewportProps().bearing + e
    });
  }
  rotateUp(e = 10) {
    return this._getUpdatedState({
      pitch: this.getViewportProps().pitch + e
    });
  }
  rotateDown(e = 10) {
    return this._getUpdatedState({
      pitch: this.getViewportProps().pitch - e
    });
  }
  shortestPathFrom(e) {
    const n = e.getViewportProps(), r = {
      ...this.getViewportProps()
    }, {
      bearing: i,
      longitude: o
    } = r;
    return Math.abs(i - n.bearing) > 180 && (r.bearing = i < 0 ? i + 360 : i - 360), Math.abs(o - n.longitude) > 180 && (r.longitude = o < 0 ? o + 360 : o - 360), r;
  }
  applyConstraints(e) {
    const {
      maxZoom: n,
      minZoom: r,
      zoom: i
    } = e;
    e.zoom = So(i, r, n);
    const {
      maxPitch: o,
      minPitch: s,
      pitch: a
    } = e;
    e.pitch = So(a, s, o);
    const {
      normalize: A = !0
    } = e;
    return A && Object.assign(e, J$e(e)), e;
  }
  _zoomFromCenter(e) {
    const {
      width: n,
      height: r
    } = this.getViewportProps();
    return this.zoom({
      pos: [n / 2, r / 2],
      scale: e
    });
  }
  _panFromCenter(e) {
    const {
      width: n,
      height: r
    } = this.getViewportProps();
    return this.pan({
      startPos: [n / 2, r / 2],
      pos: [n / 2 + e[0], r / 2 + e[1]]
    });
  }
  _getUpdatedState(e) {
    return new this.constructor({
      makeViewport: this.makeViewport,
      ...this.getViewportProps(),
      ...this.getState(),
      ...e
    });
  }
  _unproject(e) {
    const n = this.makeViewport(this.getViewportProps());
    return e && n.unproject(e);
  }
  _getNewRotation(e, n, r, i) {
    const o = e[0] - n[0], s = e[1] - n[1], a = e[1], A = n[1], {
      width: l,
      height: c
    } = this.getViewportProps(), u = o / l;
    let f = 0;
    s > 0 ? Math.abs(c - A) > $_e && (f = s / (A - c) * hhn) : s < 0 && A > $_e && (f = 1 - a / A), f = So(f, -1, 1);
    const {
      minPitch: h,
      maxPitch: d
    } = this.getViewportProps(), I = i + 180 * u;
    let m = r;
    return f > 0 ? m = r + f * (d - r) : f < 0 && (m = r - f * (h - r)), {
      pitch: m,
      bearing: I
    };
  }
}
class fqe extends Mw {
  constructor(...e) {
    super(...e), ae(this, "ControllerState", uqe), ae(this, "transition", {
      transitionDuration: 300,
      transitionInterpolator: new n1({
        transitionProps: {
          compare: ["longitude", "latitude", "zoom", "bearing", "pitch", "position"],
          required: ["longitude", "latitude", "zoom"]
        }
      })
    }), ae(this, "dragMode", "pan");
  }
  setProps(e) {
    e.position = e.position || [0, 0, 0];
    const n = this.props;
    super.setProps(e), (!n || n.height !== e.height) && this.updateViewport(new this.ControllerState({
      makeViewport: this.makeViewport,
      ...e,
      ...this.state
    }));
  }
}
class Jle extends hd {
  get ViewportType() {
    return gd;
  }
  get ControllerType() {
    return fqe;
  }
}
ae(Jle, "displayName", "MapView");
class dhn extends fM {
  constructor(e, n) {
    super(e, n), ae(this, "maskMap", void 0), ae(this, "fbo", void 0);
    const {
      mapSize: r = 2048
    } = n;
    this.maskMap = new xo(e, {
      width: r,
      height: r,
      parameters: {
        [10241]: 9729,
        [10240]: 9729,
        [10242]: 33071,
        [10243]: 33071
      }
    }), this.fbo = new Da(e, {
      id: "maskmap",
      width: r,
      height: r,
      attachments: {
        [36064]: this.maskMap
      }
    });
  }
  render(e) {
    const n = this.gl, r = [!1, !1, !1, !1];
    return r[e.channel] = !0, Yc(n, {
      clearColor: [255, 255, 255, 255],
      blend: !0,
      blendFunc: [0, 1],
      blendEquation: 32778,
      colorMask: r,
      depthTest: !1
    }, () => super.render({
      ...e,
      target: this.fbo,
      pass: "mask"
    }));
  }
  shouldDrawLayer(e) {
    return e.props.operation === Nw.MASK;
  }
  delete() {
    this.fbo.delete(), this.maskMap.delete();
  }
}
const phn = new pn().lookAt({
  eye: [0, 0, 1]
});
function Ihn({
  width: t,
  height: e,
  near: n,
  far: r,
  padding: i
}) {
  let o = -t / 2, s = t / 2, a = -e / 2, A = e / 2;
  if (i) {
    const {
      left: l = 0,
      right: c = 0,
      top: u = 0,
      bottom: f = 0
    } = i, h = So((l + t - c) / 2, 0, t) - t / 2, d = So((u + e - f) / 2, 0, e) - e / 2;
    o -= h, s -= h, a += d, A += d;
  }
  return new pn().ortho({
    left: o,
    right: s,
    bottom: a,
    top: A,
    near: n,
    far: r
  });
}
class gqe extends Dd {
  constructor(e) {
    const {
      width: n,
      height: r,
      near: i = 0.1,
      far: o = 1e3,
      zoom: s = 0,
      target: a = [0, 0, 0],
      padding: A = null,
      flipY: l = !0
    } = e, c = Array.isArray(s) ? s[0] : s, u = Array.isArray(s) ? s[1] : s, f = Math.min(c, u), h = Math.pow(2, f);
    let d;
    if (c !== u) {
      const I = Math.pow(2, c), m = Math.pow(2, u);
      d = {
        unitsPerMeter: [I / h, m / h, 1],
        metersPerUnit: [h / I, h / m, 1]
      };
    }
    super({
      ...e,
      longitude: void 0,
      position: a,
      viewMatrix: phn.clone().scale([h, h * (l ? -1 : 1), h]),
      projectionMatrix: Ihn({
        width: n || 1,
        height: r || 1,
        padding: A,
        near: i,
        far: o
      }),
      zoom: f,
      distanceScales: d
    });
  }
  projectFlat([e, n]) {
    const {
      unitsPerMeter: r
    } = this.distanceScales;
    return [e * r[0], n * r[1]];
  }
  unprojectFlat([e, n]) {
    const {
      metersPerUnit: r
    } = this.distanceScales;
    return [e * r[0], n * r[1]];
  }
  panByPosition(e, n) {
    const r = JC(n, this.pixelUnprojectionMatrix), i = this.projectFlat(e), o = eB([], i, Dle([], r)), s = eB([], this.center, o);
    return {
      target: this.unprojectFlat(s)
    };
  }
}
class hqe extends Vle {
  constructor(e) {
    const {
      width: n,
      height: r,
      rotationX: i = 0,
      rotationOrbit: o = 0,
      target: s = [0, 0, 0],
      zoom: a = 0,
      minRotationX: A = -90,
      maxRotationX: l = 90,
      minZoom: c = -1 / 0,
      maxZoom: u = 1 / 0,
      startPanPosition: f,
      startRotatePos: h,
      startRotationX: d,
      startRotationOrbit: I,
      startZoomPosition: m,
      startZoom: C
    } = e;
    super({
      width: n,
      height: r,
      rotationX: i,
      rotationOrbit: o,
      target: s,
      zoom: a,
      minRotationX: A,
      maxRotationX: l,
      minZoom: c,
      maxZoom: u
    }, {
      startPanPosition: f,
      startRotatePos: h,
      startRotationX: d,
      startRotationOrbit: I,
      startZoomPosition: m,
      startZoom: C
    }), ae(this, "makeViewport", void 0), this.makeViewport = e.makeViewport;
  }
  panStart({
    pos: e
  }) {
    return this._getUpdatedState({
      startPanPosition: this._unproject(e)
    });
  }
  pan({
    pos: e,
    startPosition: n
  }) {
    const r = this.getState().startPanPosition || n;
    if (!r)
      return this;
    const o = this.makeViewport(this.getViewportProps()).panByPosition(r, e);
    return this._getUpdatedState(o);
  }
  panEnd() {
    return this._getUpdatedState({
      startPanPosition: null
    });
  }
  rotateStart({
    pos: e
  }) {
    return this._getUpdatedState({
      startRotatePos: e,
      startRotationX: this.getViewportProps().rotationX,
      startRotationOrbit: this.getViewportProps().rotationOrbit
    });
  }
  rotate({
    pos: e,
    deltaAngleX: n = 0,
    deltaAngleY: r = 0
  }) {
    const {
      startRotatePos: i,
      startRotationX: o,
      startRotationOrbit: s
    } = this.getState(), {
      width: a,
      height: A
    } = this.getViewportProps();
    if (!i || o === void 0 || s === void 0)
      return this;
    let l;
    if (e) {
      let c = (e[0] - i[0]) / a;
      const u = (e[1] - i[1]) / A;
      (o < -90 || o > 90) && (c *= -1), l = {
        rotationX: o + u * 180,
        rotationOrbit: s + c * 180
      };
    } else
      l = {
        rotationX: o + r,
        rotationOrbit: s + n
      };
    return this._getUpdatedState(l);
  }
  rotateEnd() {
    return this._getUpdatedState({
      startRotationX: null,
      startRotationOrbit: null
    });
  }
  shortestPathFrom(e) {
    const n = e.getViewportProps(), r = {
      ...this.getViewportProps()
    }, {
      rotationOrbit: i
    } = r;
    return Math.abs(i - n.rotationOrbit) > 180 && (r.rotationOrbit = i < 0 ? i + 360 : i - 360), r;
  }
  zoomStart({
    pos: e
  }) {
    return this._getUpdatedState({
      startZoomPosition: this._unproject(e),
      startZoom: this.getViewportProps().zoom
    });
  }
  zoom({
    pos: e,
    startPos: n,
    scale: r
  }) {
    let {
      startZoom: i,
      startZoomPosition: o
    } = this.getState();
    if (o || (i = this.getViewportProps().zoom, o = this._unproject(n) || this._unproject(e)), !o)
      return this;
    const s = this._calculateNewZoom({
      scale: r,
      startZoom: i
    }), a = this.makeViewport({
      ...this.getViewportProps(),
      zoom: s
    });
    return this._getUpdatedState({
      zoom: s,
      ...a.panByPosition(o, e)
    });
  }
  zoomEnd() {
    return this._getUpdatedState({
      startZoomPosition: null,
      startZoom: null
    });
  }
  zoomIn(e = 2) {
    return this._getUpdatedState({
      zoom: this._calculateNewZoom({
        scale: e
      })
    });
  }
  zoomOut(e = 2) {
    return this._getUpdatedState({
      zoom: this._calculateNewZoom({
        scale: 1 / e
      })
    });
  }
  moveLeft(e = 50) {
    return this._panFromCenter([-e, 0]);
  }
  moveRight(e = 50) {
    return this._panFromCenter([e, 0]);
  }
  moveUp(e = 50) {
    return this._panFromCenter([0, -e]);
  }
  moveDown(e = 50) {
    return this._panFromCenter([0, e]);
  }
  rotateLeft(e = 15) {
    return this._getUpdatedState({
      rotationOrbit: this.getViewportProps().rotationOrbit - e
    });
  }
  rotateRight(e = 15) {
    return this._getUpdatedState({
      rotationOrbit: this.getViewportProps().rotationOrbit + e
    });
  }
  rotateUp(e = 10) {
    return this._getUpdatedState({
      rotationX: this.getViewportProps().rotationX - e
    });
  }
  rotateDown(e = 10) {
    return this._getUpdatedState({
      rotationX: this.getViewportProps().rotationX + e
    });
  }
  _unproject(e) {
    const n = this.makeViewport(this.getViewportProps());
    return e && n.unproject(e);
  }
  _calculateNewZoom({
    scale: e,
    startZoom: n
  }) {
    const {
      maxZoom: r,
      minZoom: i
    } = this.getViewportProps();
    n === void 0 && (n = this.getViewportProps().zoom);
    const o = n + Math.log2(e);
    return So(o, i, r);
  }
  _panFromCenter(e) {
    const {
      width: n,
      height: r,
      target: i
    } = this.getViewportProps();
    return this.pan({
      startPosition: i,
      pos: [n / 2 + e[0], r / 2 + e[1]]
    });
  }
  _getUpdatedState(e) {
    return new this.constructor({
      makeViewport: this.makeViewport,
      ...this.getViewportProps(),
      ...this.getState(),
      ...e
    });
  }
  applyConstraints(e) {
    const {
      maxZoom: n,
      minZoom: r,
      zoom: i,
      maxRotationX: o,
      minRotationX: s,
      rotationOrbit: a
    } = e;
    return e.zoom = Array.isArray(i) ? [So(i[0], r, n), So(i[1], r, n)] : So(i, r, n), e.rotationX = So(e.rotationX, s, o), (a < -180 || a > 180) && (e.rotationOrbit = _U(a + 180, 360) - 180), e;
  }
}
class dqe extends Mw {
  constructor(...e) {
    super(...e), ae(this, "ControllerState", hqe), ae(this, "transition", {
      transitionDuration: 300,
      transitionInterpolator: new n1({
        transitionProps: {
          compare: ["target", "zoom", "rotationX", "rotationOrbit"],
          required: ["target", "zoom"]
        }
      })
    });
  }
}
class mhn extends hqe {
  constructor(e) {
    super(e), ae(this, "zoomAxis", void 0), this.zoomAxis = e.zoomAxis || "all";
  }
  _calculateNewZoom({
    scale: e,
    startZoom: n
  }) {
    const {
      maxZoom: r,
      minZoom: i
    } = this.getViewportProps();
    n === void 0 && (n = this.getViewportProps().zoom);
    let o = Math.log2(e);
    if (Array.isArray(n)) {
      let [s, a] = n;
      switch (this.zoomAxis) {
        case "X":
          s = So(s + o, i, r);
          break;
        case "Y":
          a = So(a + o, i, r);
          break;
        default:
          let A = Math.min(s + o, a + o);
          A < i && (o += i - A), A = Math.max(s + o, a + o), A > r && (o += r - A), s += o, a += o;
      }
      return [s, a];
    }
    return So(n + o, i, r);
  }
}
class pqe extends Mw {
  constructor(...e) {
    super(...e), ae(this, "ControllerState", mhn), ae(this, "transition", {
      transitionDuration: 300,
      transitionInterpolator: new n1(["target", "zoom"])
    }), ae(this, "dragMode", "pan");
  }
  _onPanRotate() {
    return !1;
  }
}
class Ig extends hd {
  get ViewportType() {
    return gqe;
  }
  get ControllerType() {
    return pqe;
  }
}
ae(Ig, "displayName", "OrthographicView");
function Chn({
  layers: t,
  viewport: e
}) {
  let n = null;
  for (const o of t) {
    const s = o.getBounds();
    s && (n ? (n[0] = Math.min(n[0], s[0][0]), n[1] = Math.min(n[1], s[0][1]), n[2] = Math.max(n[2], s[1][0]), n[3] = Math.max(n[3], s[1][1])) : n = [s[0][0], s[0][1], s[1][0], s[1][1]]);
  }
  const r = e.getBounds();
  if (!n)
    return r;
  const i = yhn(r);
  return n[2] - n[0] < i[2] - i[0] || n[3] - n[1] < i[3] - i[1] || (n[0] = Math.max(n[0], i[0]), n[1] = Math.max(n[1], i[1]), n[2] = Math.min(n[2], i[2]), n[3] = Math.min(n[3], i[3])), n;
}
function Ehn({
  bounds: t,
  viewport: e,
  width: n,
  height: r
}) {
  if (t[2] <= t[0] || t[3] <= t[1])
    return null;
  const i = 1;
  if (n -= i * 2, r -= i * 2, e instanceof gd) {
    const {
      longitude: a,
      latitude: A,
      zoom: l
    } = c$({
      width: n,
      height: r,
      bounds: [[t[0], t[1]], [t[2], t[3]]],
      maxZoom: 20
    });
    return new gd({
      longitude: a,
      latitude: A,
      zoom: l,
      x: i,
      y: i,
      width: n,
      height: r
    });
  }
  const o = [(t[0] + t[2]) / 2, (t[1] + t[3]) / 2, 0], s = Math.min(20, n / (t[2] - t[0]), r / (t[3] - t[1]));
  return new Ig({
    x: i,
    y: i
  }).makeViewport({
    width: n,
    height: r,
    viewState: {
      target: o,
      zoom: Math.log2(s)
    }
  });
}
function yhn(t) {
  const e = {
    x: t[2] - t[0],
    y: t[3] - t[1]
  }, n = {
    x: t[0] + 0.5 * e.x,
    y: t[1] + 0.5 * e.y
  };
  return [n.x - e.x, n.y - e.y, n.x + e.x, n.y + e.y];
}
class vhn {
  constructor() {
    ae(this, "id", "mask-effect"), ae(this, "props", null), ae(this, "useInPicking", !0), ae(this, "dummyMaskMap", void 0), ae(this, "channels", []), ae(this, "masks", null), ae(this, "maskPass", void 0), ae(this, "maskMap", void 0), ae(this, "lastViewport", void 0);
  }
  preRender(e, {
    layers: n,
    layerFilter: r,
    viewports: i,
    onViewportActive: o,
    views: s
  }) {
    this.dummyMaskMap || (this.dummyMaskMap = new xo(e, {
      width: 1,
      height: 1
    }));
    const a = n.filter((u) => u.props.visible && u.props.operation === Nw.MASK);
    if (a.length === 0) {
      this.masks = null, this.channels.length = 0;
      return;
    }
    this.masks = {}, this.maskPass || (this.maskPass = new dhn(e, {
      id: "default-mask"
    }), this.maskMap = this.maskPass.maskMap);
    const A = this._sortMaskChannels(a), l = i[0], c = !this.lastViewport || !this.lastViewport.equals(l);
    for (const u in A)
      this._renderChannel(A[u], {
        layerFilter: r,
        onViewportActive: o,
        views: s,
        viewport: l,
        viewportChanged: c
      });
  }
  _renderChannel(e, {
    layerFilter: n,
    onViewportActive: r,
    views: i,
    viewport: o,
    viewportChanged: s
  }) {
    const a = this.channels[e.index];
    if (!a)
      return;
    const A = e === a || a.layers.length !== e.layers.length || e.layerBounds.some((l, c) => l !== a.layerBounds[c]);
    if (e.bounds = a.bounds, e.maskBounds = a.maskBounds, this.channels[e.index] = e, (A || s) && (this.lastViewport = o, e.bounds = Chn({
      layers: e.layers,
      viewport: o
    }), A || !ul(e.bounds, a.bounds))) {
      const {
        maskPass: l,
        maskMap: c
      } = this, u = Ehn({
        bounds: e.bounds,
        viewport: o,
        width: c.width,
        height: c.height
      });
      e.maskBounds = u ? u.getBounds() : [0, 0, 1, 1], l.render({
        pass: "mask",
        channel: e.index,
        layers: e.layers,
        layerFilter: n,
        viewports: u ? [u] : [],
        onViewportActive: r,
        views: i,
        moduleParameters: {
          devicePixelRatio: 1
        }
      });
    }
    this.masks[e.id] = {
      index: e.index,
      bounds: e.maskBounds,
      coordinateOrigin: e.coordinateOrigin,
      coordinateSystem: e.coordinateSystem
    };
  }
  _sortMaskChannels(e) {
    const n = {};
    let r = 0;
    for (const i of e) {
      const {
        id: o
      } = i.root;
      let s = n[o];
      if (!s) {
        if (++r > 4) {
          Rr.warn("Too many mask layers. The max supported is 4")();
          continue;
        }
        s = {
          id: o,
          index: this.channels.findIndex((a) => a?.id === o),
          layers: [],
          layerBounds: [],
          coordinateOrigin: i.root.props.coordinateOrigin,
          coordinateSystem: i.root.props.coordinateSystem
        }, n[o] = s;
      }
      s.layers.push(i), s.layerBounds.push(i.getBounds());
    }
    for (let i = 0; i < 4; i++) {
      const o = this.channels[i];
      (!o || !(o.id in n)) && (this.channels[i] = null);
    }
    for (const i in n) {
      const o = n[i];
      o.index < 0 && (o.index = this.channels.findIndex((s) => !s), this.channels[o.index] = o);
    }
    return n;
  }
  getModuleParameters() {
    return {
      maskMap: this.masks ? this.maskMap : this.dummyMaskMap,
      maskChannels: this.masks
    };
  }
  cleanup() {
    this.dummyMaskMap && (this.dummyMaskMap.delete(), this.dummyMaskMap = void 0), this.maskPass && (this.maskPass.delete(), this.maskPass = void 0, this.maskMap = void 0), this.lastViewport = void 0, this.masks = null, this.channels.length = 0;
  }
}
const Bhn = new Yle();
class bhn {
  constructor() {
    ae(this, "effects", void 0), ae(this, "_internalEffects", void 0), ae(this, "_needsRedraw", void 0), this.effects = [], this._internalEffects = [], this._needsRedraw = "Initial render", this.setEffects();
  }
  setProps(e) {
    "effects" in e && (e.effects.length !== this.effects.length || !t1(e.effects, this.effects)) && (this.setEffects(e.effects), this._needsRedraw = "effects changed");
  }
  needsRedraw(e = {
    clearRedrawFlags: !1
  }) {
    const n = this._needsRedraw;
    return e.clearRedrawFlags && (this._needsRedraw = !1), n;
  }
  getEffects() {
    return this._internalEffects;
  }
  finalize() {
    this.cleanup();
  }
  setEffects(e = []) {
    this.cleanup(), this.effects = e, this._internalEffects = e.slice(), this._internalEffects.push(new vhn()), e.some((n) => n instanceof Yle) || this._internalEffects.push(Bhn);
  }
  cleanup() {
    for (const e of this.effects)
      e.cleanup();
    for (const e of this._internalEffects)
      e.cleanup();
    this.effects.length = 0, this._internalEffects.length = 0;
  }
}
class _hn extends fM {
  shouldDrawLayer(e) {
    return e.props.operation === Nw.DRAW;
  }
}
const q_e = {
  blendFunc: [1, 0, 32771, 0],
  blendEquation: 32774
};
class Iqe extends fM {
  constructor(...e) {
    super(...e), ae(this, "pickZ", void 0), ae(this, "_colors", null);
  }
  render(e) {
    return e.pickingFBO ? this._drawPickingBuffer(e) : super.render(e);
  }
  _drawPickingBuffer({
    layers: e,
    layerFilter: n,
    views: r,
    viewports: i,
    onViewportActive: o,
    pickingFBO: s,
    deviceRect: {
      x: a,
      y: A,
      width: l,
      height: c
    },
    cullRect: u,
    effects: f,
    pass: h = "picking",
    pickZ: d
  }) {
    const I = this.gl;
    this.pickZ = d;
    const m = d ? null : {
      byLayer: /* @__PURE__ */ new Map(),
      byAlpha: []
    };
    this._colors = m;
    const C = Yc(I, {
      scissorTest: !0,
      scissor: [a, A, l, c],
      clearColor: [0, 0, 0, 0],
      depthMask: !0,
      depthTest: !0,
      depthRange: [0, 1],
      colorMask: [!0, !0, !0, !0],
      ...q_e,
      blend: !d
    }, () => super.render({
      target: s,
      layers: e,
      layerFilter: n,
      views: r,
      viewports: i,
      onViewportActive: o,
      cullRect: u,
      effects: f?.filter((v) => v.useInPicking),
      pass: h
    }));
    return this._colors = null, {
      decodePickingColor: m && Qhn.bind(null, m),
      stats: C
    };
  }
  shouldDrawLayer(e) {
    return e.props.pickable && e.props.operation === Nw.DRAW;
  }
  getModuleParameters() {
    return {
      pickingActive: 1,
      pickingAttribute: this.pickZ,
      lightSources: {}
    };
  }
  getLayerParameters(e, n, r) {
    const i = {
      ...e.props.parameters
    };
    return this._colors ? (Object.assign(i, q_e), i.blend = !0, i.blendColor = Shn(this._colors, e, r)) : i.blend = !1, i;
  }
}
function Shn(t, e, n) {
  const {
    byLayer: r,
    byAlpha: i
  } = t;
  let o, s = r.get(e);
  return s ? (s.viewports.push(n), o = s.a) : (o = r.size + 1, o <= 255 ? (s = {
    a: o,
    layer: e,
    viewports: [n]
  }, r.set(e, s), i[o] = s) : (Rr.warn("Too many pickable layers, only picking the first 255")(), o = 0)), [0, 0, 0, o / 255];
}
function Qhn(t, e) {
  const n = t.byAlpha[e[3]];
  return n && {
    pickedLayer: n.layer,
    pickedViewports: n.viewports,
    pickedObjectIndex: n.layer.decodePickingColor(e)
  };
}
const whn = "deckRenderer.renderLayers";
class mqe {
  constructor(e) {
    this.gl = e, this.layerFilter = null, this.drawPickingColors = !1, this.drawLayersPass = new _hn(e), this.pickLayersPass = new Iqe(e), this.renderCount = 0, this._needsRedraw = "Initial render", this.renderBuffers = [], this.lastPostProcessEffect = null;
  }
  setProps(e) {
    "layerFilter" in e && this.layerFilter !== e.layerFilter && (this.layerFilter = e.layerFilter, this._needsRedraw = "layerFilter changed"), "drawPickingColors" in e && this.drawPickingColors !== e.drawPickingColors && (this.drawPickingColors = e.drawPickingColors, this._needsRedraw = "drawPickingColors changed");
  }
  renderLayers(e) {
    const n = this.drawPickingColors ? this.pickLayersPass : this.drawLayersPass;
    e.layerFilter = e.layerFilter || this.layerFilter, e.effects = e.effects || [], e.target = e.target || Da.getDefaultFramebuffer(this.gl), this._preRender(e.effects, e);
    const r = this.lastPostProcessEffect ? this.renderBuffers[0] : e.target, i = n.render({
      ...e,
      target: r
    });
    this._postRender(e.effects, e), this.renderCount++, Ul(whn, this, i, e);
  }
  needsRedraw(e = {
    clearRedrawFlags: !1
  }) {
    const n = this._needsRedraw;
    return e.clearRedrawFlags && (this._needsRedraw = !1), n;
  }
  finalize() {
    const {
      renderBuffers: e
    } = this;
    for (const n of e)
      n.delete();
    e.length = 0;
  }
  _preRender(e, n) {
    let r = null;
    for (const i of e)
      i.preRender(this.gl, n), i.postRender && (r = i);
    r && this._resizeRenderBuffers(), this.lastPostProcessEffect = r;
  }
  _resizeRenderBuffers() {
    const {
      renderBuffers: e
    } = this;
    e.length === 0 && e.push(new Da(this.gl), new Da(this.gl));
    for (const n of e)
      n.resize();
  }
  _postRender(e, n) {
    const {
      renderBuffers: r
    } = this, i = {
      inputBuffer: r[0],
      swapBuffer: r[1],
      target: null
    };
    for (const o of e)
      if (o.postRender) {
        if (o === this.lastPostProcessEffect) {
          i.target = n.target, o.postRender(this.gl, i);
          break;
        }
        const s = o.postRender(this.gl, i);
        i.inputBuffer = s, i.swapBuffer = s === r[0] ? r[1] : r[0];
      }
  }
}
const xhn = {
  pickedColor: null,
  pickedObjectIndex: -1
};
function Rhn({
  pickedColors: t,
  decodePickingColor: e,
  deviceX: n,
  deviceY: r,
  deviceRadius: i,
  deviceRect: o
}) {
  const {
    x: s,
    y: a,
    width: A,
    height: l
  } = o;
  let c = i * i, u = -1, f = 0;
  for (let h = 0; h < l; h++) {
    const d = h + a - r, I = d * d;
    if (I > c)
      f += 4 * A;
    else
      for (let m = 0; m < A; m++) {
        if (t[f + 3] - 1 >= 0) {
          const y = m + s - n, v = y * y + I;
          v <= c && (c = v, u = f);
        }
        f += 4;
      }
  }
  if (u >= 0) {
    const h = t.slice(u, u + 4), d = e(h);
    if (d) {
      const I = Math.floor(u / 4 / A), m = u / 4 - I * A;
      return {
        ...d,
        pickedColor: h,
        pickedX: s + m,
        pickedY: a + I
      };
    }
    Rr.error("Picked non-existent layer. Is picking buffer corrupt?")();
  }
  return xhn;
}
function Dhn({
  pickedColors: t,
  decodePickingColor: e
}) {
  const n = /* @__PURE__ */ new Map();
  if (t) {
    for (let r = 0; r < t.length; r += 4)
      if (t[r + 3] - 1 >= 0) {
        const o = t.slice(r, r + 4), s = o.join(",");
        if (!n.has(s)) {
          const a = e(o);
          a ? n.set(s, {
            ...a,
            color: o
          }) : Rr.error("Picked non-existent layer. Is picking buffer corrupt?")();
        }
      }
  }
  return Array.from(n.values());
}
function Cqe({
  pickInfo: t,
  viewports: e,
  pixelRatio: n,
  x: r,
  y: i,
  z: o
}) {
  let s = e[0];
  e.length > 1 && (s = Nhn(t?.pickedViewports || e, {
    x: r,
    y: i
  }));
  let a;
  if (s) {
    const A = [r - s.x, i - s.y];
    o !== void 0 && (A[2] = o), a = s.unproject(A);
  }
  return {
    color: null,
    layer: null,
    viewport: s,
    index: -1,
    picked: !1,
    x: r,
    y: i,
    pixel: [r, i],
    coordinate: a,
    devicePixel: t && "pickedX" in t ? [t.pickedX, t.pickedY] : void 0,
    pixelRatio: n
  };
}
function Thn(t) {
  const {
    pickInfo: e,
    lastPickedInfo: n,
    mode: r,
    layers: i
  } = t, {
    pickedColor: o,
    pickedLayer: s,
    pickedObjectIndex: a
  } = e, A = s ? [s] : [];
  if (r === "hover") {
    const u = n.index, f = n.layerId, h = s ? s.props.id : null;
    if (h !== f || a !== u) {
      if (h !== f) {
        const d = i.find((I) => I.props.id === f);
        d && A.unshift(d);
      }
      n.layerId = h, n.index = a, n.info = null;
    }
  }
  const l = Cqe(t), c = /* @__PURE__ */ new Map();
  return c.set(null, l), A.forEach((u) => {
    let f = {
      ...l
    };
    u === s && (f.color = o, f.index = a, f.picked = !0), f = Eqe({
      layer: u,
      info: f,
      mode: r
    });
    const h = f.layer;
    u === s && r === "hover" && (n.info = f), c.set(h.id, f), r === "hover" && h.updateAutoHighlight(f);
  }), c;
}
function Eqe({
  layer: t,
  info: e,
  mode: n
}) {
  for (; t && e; ) {
    const r = e.layer || null;
    e.sourceLayer = r, e.layer = t, e = t.getPickingInfo({
      info: e,
      mode: n,
      sourceLayer: r
    }), t = t.parent;
  }
  return e;
}
function Nhn(t, e) {
  for (let n = t.length - 1; n >= 0; n--) {
    const r = t[n];
    if (r.containsPixel(e))
      return r;
  }
  return t[0];
}
class Lhn {
  constructor(e) {
    ae(this, "gl", void 0), ae(this, "pickingFBO", void 0), ae(this, "depthFBO", void 0), ae(this, "pickLayersPass", void 0), ae(this, "layerFilter", void 0), ae(this, "lastPickedInfo", void 0), ae(this, "_pickable", !0), this.gl = e, this.pickLayersPass = new Iqe(e), this.lastPickedInfo = {
      index: -1,
      layerId: null,
      info: null
    };
  }
  setProps(e) {
    "layerFilter" in e && (this.layerFilter = e.layerFilter), "_pickable" in e && (this._pickable = e._pickable);
  }
  finalize() {
    this.pickingFBO && this.pickingFBO.delete(), this.depthFBO && (this.depthFBO.color.delete(), this.depthFBO.delete());
  }
  pickObject(e) {
    return this._pickClosestObject(e);
  }
  pickObjects(e) {
    return this._pickVisibleObjects(e);
  }
  getLastPickedObject({
    x: e,
    y: n,
    layers: r,
    viewports: i
  }, o = this.lastPickedInfo.info) {
    const s = o && o.layer && o.layer.id, a = o && o.viewport && o.viewport.id, A = s ? r.find((f) => f.id === s) : null, l = a && i.find((f) => f.id === a) || i[0], c = l && l.unproject([e - l.x, n - l.y]);
    return {
      ...o,
      ...{
        x: e,
        y: n,
        viewport: l,
        coordinate: c,
        layer: A
      }
    };
  }
  _resizeBuffer() {
    var e, n;
    const {
      gl: r
    } = this;
    if (!this.pickingFBO && (this.pickingFBO = new Da(r), Da.isSupported(r, {
      colorBufferFloat: !0
    }))) {
      const i = new Da(r);
      i.attach({
        [36064]: new xo(r, {
          format: Fr(r) ? 34836 : 6408,
          type: 5126
        })
      }), this.depthFBO = i;
    }
    (e = this.pickingFBO) === null || e === void 0 || e.resize({
      width: r.canvas.width,
      height: r.canvas.height
    }), (n = this.depthFBO) === null || n === void 0 || n.resize({
      width: r.canvas.width,
      height: r.canvas.height
    });
  }
  _getPickable(e) {
    if (this._pickable === !1)
      return null;
    const n = e.filter((r) => r.isPickable() && !r.isComposite);
    return n.length ? n : null;
  }
  _pickClosestObject({
    layers: e,
    views: n,
    viewports: r,
    x: i,
    y: o,
    radius: s = 0,
    depth: a = 1,
    mode: A = "query",
    unproject3D: l,
    onViewportActive: c,
    effects: u
  }) {
    const f = this._getPickable(e), h = Wv(this.gl);
    if (!f)
      return {
        result: [],
        emptyInfo: Cqe({
          viewports: r,
          x: i,
          y: o,
          pixelRatio: h
        })
      };
    this._resizeBuffer();
    const d = Bk(this.gl, [i, o], !0), I = [d.x + Math.floor(d.width / 2), d.y + Math.floor(d.height / 2)], m = Math.round(s * h), {
      width: C,
      height: y
    } = this.pickingFBO, v = this._getPickingRect({
      deviceX: I[0],
      deviceY: I[1],
      deviceRadius: m,
      deviceWidth: C,
      deviceHeight: y
    }), b = {
      x: i - s,
      y: o - s,
      width: s * 2 + 1,
      height: s * 2 + 1
    };
    let Q;
    const w = [], R = /* @__PURE__ */ new Set();
    for (let M = 0; M < a; M++) {
      let O;
      if (v) {
        const N = this._drawAndSample({
          layers: f,
          views: n,
          viewports: r,
          onViewportActive: c,
          deviceRect: v,
          cullRect: b,
          effects: u,
          pass: "picking:".concat(A)
        });
        O = Rhn({
          ...N,
          deviceX: I[0],
          deviceY: I[1],
          deviceRadius: m,
          deviceRect: v
        });
      } else
        O = {
          pickedColor: null,
          pickedObjectIndex: -1
        };
      let L;
      O.pickedLayer && l && this.depthFBO && (L = this._drawAndSample({
        layers: [O.pickedLayer],
        views: n,
        viewports: r,
        onViewportActive: c,
        deviceRect: {
          x: O.pickedX,
          y: O.pickedY,
          width: 1,
          height: 1
        },
        cullRect: b,
        effects: u,
        pass: "picking:".concat(A, ":z")
      }, !0).pickedColors[0]), O.pickedLayer && M + 1 < a && (R.add(O.pickedLayer), O.pickedLayer.disablePickingIndex(O.pickedObjectIndex)), Q = Thn({
        pickInfo: O,
        lastPickedInfo: this.lastPickedInfo,
        mode: A,
        layers: f,
        viewports: r,
        x: i,
        y: o,
        z: L,
        pixelRatio: h
      });
      for (const N of Q.values())
        N.layer && w.push(N);
      if (!O.pickedColor)
        break;
    }
    for (const M of R)
      M.restorePickingColors();
    return {
      result: w,
      emptyInfo: Q.get(null)
    };
  }
  _pickVisibleObjects({
    layers: e,
    views: n,
    viewports: r,
    x: i,
    y: o,
    width: s = 1,
    height: a = 1,
    mode: A = "query",
    maxObjects: l = null,
    onViewportActive: c,
    effects: u
  }) {
    const f = this._getPickable(e);
    if (!f)
      return [];
    this._resizeBuffer();
    const h = Wv(this.gl), d = Bk(this.gl, [i, o], !0), I = d.x, m = d.y + d.height, C = Bk(this.gl, [i + s, o + a], !0), y = C.x + C.width, v = C.y, b = {
      x: I,
      y: v,
      width: y - I,
      height: m - v
    }, Q = this._drawAndSample({
      layers: f,
      views: n,
      viewports: r,
      onViewportActive: c,
      deviceRect: b,
      cullRect: {
        x: i,
        y: o,
        width: s,
        height: a
      },
      effects: u,
      pass: "picking:".concat(A)
    }), w = Dhn(Q), R = /* @__PURE__ */ new Map(), M = Number.isFinite(l);
    for (let O = 0; O < w.length && !(M && l && R.size >= l); O++) {
      const L = w[O];
      let N = {
        color: L.pickedColor,
        layer: null,
        index: L.pickedObjectIndex,
        picked: !0,
        x: i,
        y: o,
        pixelRatio: h
      };
      N = Eqe({
        layer: L.pickedLayer,
        info: N,
        mode: A
      }), R.has(N.object) || R.set(N.object, N);
    }
    return Array.from(R.values());
  }
  _drawAndSample({
    layers: e,
    views: n,
    viewports: r,
    onViewportActive: i,
    deviceRect: o,
    cullRect: s,
    effects: a,
    pass: A
  }, l = !1) {
    const c = l ? this.depthFBO : this.pickingFBO, {
      decodePickingColor: u
    } = this.pickLayersPass.render({
      layers: e,
      layerFilter: this.layerFilter,
      views: n,
      viewports: r,
      onViewportActive: i,
      pickingFBO: c,
      deviceRect: o,
      cullRect: s,
      effects: a,
      pass: A,
      pickZ: l
    }), {
      x: f,
      y: h,
      width: d,
      height: I
    } = o, m = new (l ? Float32Array : Uint8Array)(d * I * 4);
    return AM(c, {
      sourceX: f,
      sourceY: h,
      sourceWidth: d,
      sourceHeight: I,
      target: m
    }), {
      pickedColors: m,
      decodePickingColor: u
    };
  }
  _getPickingRect({
    deviceX: e,
    deviceY: n,
    deviceRadius: r,
    deviceWidth: i,
    deviceHeight: o
  }) {
    const s = Math.max(0, e - r), a = Math.max(0, n - r), A = Math.min(i, e + r + 1) - s, l = Math.min(o, n + r + 1) - a;
    return A <= 0 || l <= 0 ? null : {
      x: s,
      y: a,
      width: A,
      height: l
    };
  }
}
const Mhn = {
  zIndex: "1",
  position: "absolute",
  pointerEvents: "none",
  color: "#a0a7b4",
  backgroundColor: "#29323c",
  padding: "10px",
  top: "0",
  left: "0",
  display: "none"
};
let Ohn = class {
  constructor(e) {
    ae(this, "el", null), ae(this, "isVisible", !1);
    const n = e.parentElement;
    n && (this.el = document.createElement("div"), this.el.className = "deck-tooltip", Object.assign(this.el.style, Mhn), n.appendChild(this.el));
  }
  setTooltip(e, n, r) {
    const i = this.el;
    if (i) {
      if (typeof e == "string")
        i.innerText = e;
      else if (e)
        e.text && (i.innerText = e.text), e.html && (i.innerHTML = e.html), e.className && (i.className = e.className), Object.assign(i.style, e.style);
      else {
        this.isVisible = !1, i.style.display = "none";
        return;
      }
      this.isVisible = !0, i.style.display = "block", i.style.transform = "translate(".concat(n, "px, ").concat(r, "px)");
    }
  }
  remove() {
    this.el && (this.el.remove(), this.el = null);
  }
};
var yqe = { exports: {} };
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(t) {
  (function(e, n, r, i) {
    var o = ["", "webkit", "Moz", "MS", "ms", "o"], s = n.createElement("div"), a = "function", A = Math.round, l = Math.abs, c = Date.now;
    function u(Ne, Fe, Ze) {
      return setTimeout(v(Ne, Ze), Fe);
    }
    function f(Ne, Fe, Ze) {
      return Array.isArray(Ne) ? (h(Ne, Ze[Fe], Ze), !0) : !1;
    }
    function h(Ne, Fe, Ze) {
      var Ve;
      if (Ne)
        if (Ne.forEach)
          Ne.forEach(Fe, Ze);
        else if (Ne.length !== i)
          for (Ve = 0; Ve < Ne.length; )
            Fe.call(Ze, Ne[Ve], Ve, Ne), Ve++;
        else
          for (Ve in Ne)
            Ne.hasOwnProperty(Ve) && Fe.call(Ze, Ne[Ve], Ve, Ne);
    }
    function d(Ne, Fe, Ze) {
      var Ve = "DEPRECATED METHOD: " + Fe + `
` + Ze + ` AT 
`;
      return function() {
        var Mt = new Error("get-stack-trace"), An = Mt && Mt.stack ? Mt.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace", lr = e.console && (e.console.warn || e.console.log);
        return lr && lr.call(e.console, Ve, An), Ne.apply(this, arguments);
      };
    }
    var I;
    typeof Object.assign != "function" ? I = function(Fe) {
      if (Fe === i || Fe === null)
        throw new TypeError("Cannot convert undefined or null to object");
      for (var Ze = Object(Fe), Ve = 1; Ve < arguments.length; Ve++) {
        var Mt = arguments[Ve];
        if (Mt !== i && Mt !== null)
          for (var An in Mt)
            Mt.hasOwnProperty(An) && (Ze[An] = Mt[An]);
      }
      return Ze;
    } : I = Object.assign;
    var m = d(function(Fe, Ze, Ve) {
      for (var Mt = Object.keys(Ze), An = 0; An < Mt.length; )
        (!Ve || Ve && Fe[Mt[An]] === i) && (Fe[Mt[An]] = Ze[Mt[An]]), An++;
      return Fe;
    }, "extend", "Use `assign`."), C = d(function(Fe, Ze) {
      return m(Fe, Ze, !0);
    }, "merge", "Use `assign`.");
    function y(Ne, Fe, Ze) {
      var Ve = Fe.prototype, Mt;
      Mt = Ne.prototype = Object.create(Ve), Mt.constructor = Ne, Mt._super = Ve, Ze && I(Mt, Ze);
    }
    function v(Ne, Fe) {
      return function() {
        return Ne.apply(Fe, arguments);
      };
    }
    function b(Ne, Fe) {
      return typeof Ne == a ? Ne.apply(Fe && Fe[0] || i, Fe) : Ne;
    }
    function Q(Ne, Fe) {
      return Ne === i ? Fe : Ne;
    }
    function w(Ne, Fe, Ze) {
      h(L(Fe), function(Ve) {
        Ne.addEventListener(Ve, Ze, !1);
      });
    }
    function R(Ne, Fe, Ze) {
      h(L(Fe), function(Ve) {
        Ne.removeEventListener(Ve, Ze, !1);
      });
    }
    function M(Ne, Fe) {
      for (; Ne; ) {
        if (Ne == Fe)
          return !0;
        Ne = Ne.parentNode;
      }
      return !1;
    }
    function O(Ne, Fe) {
      return Ne.indexOf(Fe) > -1;
    }
    function L(Ne) {
      return Ne.trim().split(/\s+/g);
    }
    function N(Ne, Fe, Ze) {
      if (Ne.indexOf && !Ze)
        return Ne.indexOf(Fe);
      for (var Ve = 0; Ve < Ne.length; ) {
        if (Ze && Ne[Ve][Ze] == Fe || !Ze && Ne[Ve] === Fe)
          return Ve;
        Ve++;
      }
      return -1;
    }
    function k(Ne) {
      return Array.prototype.slice.call(Ne, 0);
    }
    function $(Ne, Fe, Ze) {
      for (var Ve = [], Mt = [], An = 0; An < Ne.length; ) {
        var lr = Fe ? Ne[An][Fe] : Ne[An];
        N(Mt, lr) < 0 && Ve.push(Ne[An]), Mt[An] = lr, An++;
      }
      return Ze && (Fe ? Ve = Ve.sort(function(nn, Xn) {
        return nn[Fe] > Xn[Fe];
      }) : Ve = Ve.sort()), Ve;
    }
    function U(Ne, Fe) {
      for (var Ze, Ve, Mt = Fe[0].toUpperCase() + Fe.slice(1), An = 0; An < o.length; ) {
        if (Ze = o[An], Ve = Ze ? Ze + Mt : Fe, Ve in Ne)
          return Ve;
        An++;
      }
      return i;
    }
    var X = 1;
    function K() {
      return X++;
    }
    function z(Ne) {
      var Fe = Ne.ownerDocument || Ne;
      return Fe.defaultView || Fe.parentWindow || e;
    }
    var Y = /mobile|tablet|ip(ad|hone|od)|android/i, V = "ontouchstart" in e, Z = U(e, "PointerEvent") !== i, ce = V && Y.test(navigator.userAgent), ee = "touch", pe = "pen", Ce = "mouse", Be = "kinect", Ie = 25, Qe = 1, xe = 2, Se = 4, De = 8, Ue = 1, Te = 2, se = 4, fe = 8, W = 16, ge = Te | se, _e = fe | W, Re = ge | _e, Ee = ["x", "y"], oe = ["clientX", "clientY"];
    function ie(Ne, Fe) {
      var Ze = this;
      this.manager = Ne, this.callback = Fe, this.element = Ne.element, this.target = Ne.options.inputTarget, this.domHandler = function(Ve) {
        b(Ne.options.enable, [Ne]) && Ze.handler(Ve);
      }, this.init();
    }
    ie.prototype = {
      /**
       * should handle the inputEvent data and trigger the callback
       * @virtual
       */
      handler: function() {
      },
      /**
       * bind the events
       */
      init: function() {
        this.evEl && w(this.element, this.evEl, this.domHandler), this.evTarget && w(this.target, this.evTarget, this.domHandler), this.evWin && w(z(this.element), this.evWin, this.domHandler);
      },
      /**
       * unbind the events
       */
      destroy: function() {
        this.evEl && R(this.element, this.evEl, this.domHandler), this.evTarget && R(this.target, this.evTarget, this.domHandler), this.evWin && R(z(this.element), this.evWin, this.domHandler);
      }
    };
    function Ae(Ne) {
      var Fe, Ze = Ne.options.inputClass;
      return Ze ? Fe = Ze : Z ? Fe = We : ce ? Fe = yn : V ? Fe = nt : Fe = Ht, new Fe(Ne, de);
    }
    function de(Ne, Fe, Ze) {
      var Ve = Ze.pointers.length, Mt = Ze.changedPointers.length, An = Fe & Qe && Ve - Mt === 0, lr = Fe & (Se | De) && Ve - Mt === 0;
      Ze.isFirst = !!An, Ze.isFinal = !!lr, An && (Ne.session = {}), Ze.eventType = Fe, we(Ne, Ze), Ne.emit("hammer.input", Ze), Ne.recognize(Ze), Ne.session.prevInput = Ze;
    }
    function we(Ne, Fe) {
      var Ze = Ne.session, Ve = Fe.pointers, Mt = Ve.length;
      Ze.firstInput || (Ze.firstInput = ke(Fe)), Mt > 1 && !Ze.firstMultiple ? Ze.firstMultiple = ke(Fe) : Mt === 1 && (Ze.firstMultiple = !1);
      var An = Ze.firstInput, lr = Ze.firstMultiple, lo = lr ? lr.center : An.center, nn = Fe.center = Xe(Ve);
      Fe.timeStamp = c(), Fe.deltaTime = Fe.timeStamp - An.timeStamp, Fe.angle = mt(lo, nn), Fe.distance = ht(lo, nn), Pe(Ze, Fe), Fe.offsetDirection = it(Fe.deltaX, Fe.deltaY);
      var Xn = rt(Fe.deltaTime, Fe.deltaX, Fe.deltaY);
      Fe.overallVelocityX = Xn.x, Fe.overallVelocityY = Xn.y, Fe.overallVelocity = l(Xn.x) > l(Xn.y) ? Xn.x : Xn.y, Fe.scale = lr ? Ct(lr.pointers, Ve) : 1, Fe.rotation = lr ? _t(lr.pointers, Ve) : 0, Fe.maxPointers = Ze.prevInput ? Fe.pointers.length > Ze.prevInput.maxPointers ? Fe.pointers.length : Ze.prevInput.maxPointers : Fe.pointers.length, qe(Ze, Fe);
      var Zn = Ne.element;
      M(Fe.srcEvent.target, Zn) && (Zn = Fe.srcEvent.target), Fe.target = Zn;
    }
    function Pe(Ne, Fe) {
      var Ze = Fe.center, Ve = Ne.offsetDelta || {}, Mt = Ne.prevDelta || {}, An = Ne.prevInput || {};
      (Fe.eventType === Qe || An.eventType === Se) && (Mt = Ne.prevDelta = {
        x: An.deltaX || 0,
        y: An.deltaY || 0
      }, Ve = Ne.offsetDelta = {
        x: Ze.x,
        y: Ze.y
      }), Fe.deltaX = Mt.x + (Ze.x - Ve.x), Fe.deltaY = Mt.y + (Ze.y - Ve.y);
    }
    function qe(Ne, Fe) {
      var Ze = Ne.lastInterval || Fe, Ve = Fe.timeStamp - Ze.timeStamp, Mt, An, lr, lo;
      if (Fe.eventType != De && (Ve > Ie || Ze.velocity === i)) {
        var nn = Fe.deltaX - Ze.deltaX, Xn = Fe.deltaY - Ze.deltaY, Zn = rt(Ve, nn, Xn);
        An = Zn.x, lr = Zn.y, Mt = l(Zn.x) > l(Zn.y) ? Zn.x : Zn.y, lo = it(nn, Xn), Ne.lastInterval = Fe;
      } else
        Mt = Ze.velocity, An = Ze.velocityX, lr = Ze.velocityY, lo = Ze.direction;
      Fe.velocity = Mt, Fe.velocityX = An, Fe.velocityY = lr, Fe.direction = lo;
    }
    function ke(Ne) {
      for (var Fe = [], Ze = 0; Ze < Ne.pointers.length; )
        Fe[Ze] = {
          clientX: A(Ne.pointers[Ze].clientX),
          clientY: A(Ne.pointers[Ze].clientY)
        }, Ze++;
      return {
        timeStamp: c(),
        pointers: Fe,
        center: Xe(Fe),
        deltaX: Ne.deltaX,
        deltaY: Ne.deltaY
      };
    }
    function Xe(Ne) {
      var Fe = Ne.length;
      if (Fe === 1)
        return {
          x: A(Ne[0].clientX),
          y: A(Ne[0].clientY)
        };
      for (var Ze = 0, Ve = 0, Mt = 0; Mt < Fe; )
        Ze += Ne[Mt].clientX, Ve += Ne[Mt].clientY, Mt++;
      return {
        x: A(Ze / Fe),
        y: A(Ve / Fe)
      };
    }
    function rt(Ne, Fe, Ze) {
      return {
        x: Fe / Ne || 0,
        y: Ze / Ne || 0
      };
    }
    function it(Ne, Fe) {
      return Ne === Fe ? Ue : l(Ne) >= l(Fe) ? Ne < 0 ? Te : se : Fe < 0 ? fe : W;
    }
    function ht(Ne, Fe, Ze) {
      Ze || (Ze = Ee);
      var Ve = Fe[Ze[0]] - Ne[Ze[0]], Mt = Fe[Ze[1]] - Ne[Ze[1]];
      return Math.sqrt(Ve * Ve + Mt * Mt);
    }
    function mt(Ne, Fe, Ze) {
      Ze || (Ze = Ee);
      var Ve = Fe[Ze[0]] - Ne[Ze[0]], Mt = Fe[Ze[1]] - Ne[Ze[1]];
      return Math.atan2(Mt, Ve) * 180 / Math.PI;
    }
    function _t(Ne, Fe) {
      return mt(Fe[1], Fe[0], oe) + mt(Ne[1], Ne[0], oe);
    }
    function Ct(Ne, Fe) {
      return ht(Fe[0], Fe[1], oe) / ht(Ne[0], Ne[1], oe);
    }
    var zt = {
      mousedown: Qe,
      mousemove: xe,
      mouseup: Se
    }, jt = "mousedown", lt = "mousemove mouseup";
    function Ht() {
      this.evEl = jt, this.evWin = lt, this.pressed = !1, ie.apply(this, arguments);
    }
    y(Ht, ie, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(Fe) {
        var Ze = zt[Fe.type];
        Ze & Qe && Fe.button === 0 && (this.pressed = !0), Ze & xe && Fe.which !== 1 && (Ze = Se), this.pressed && (Ze & Se && (this.pressed = !1), this.callback(this.manager, Ze, {
          pointers: [Fe],
          changedPointers: [Fe],
          pointerType: Ce,
          srcEvent: Fe
        }));
      }
    });
    var vt = {
      pointerdown: Qe,
      pointermove: xe,
      pointerup: Se,
      pointercancel: De,
      pointerout: De
    }, It = {
      2: ee,
      3: pe,
      4: Ce,
      5: Be
      // see https://twitter.com/jacobrossi/status/480596438489890816
    }, un = "pointerdown", hn = "pointermove pointerup pointercancel";
    e.MSPointerEvent && !e.PointerEvent && (un = "MSPointerDown", hn = "MSPointerMove MSPointerUp MSPointerCancel");
    function We() {
      this.evEl = un, this.evWin = hn, ie.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
    }
    y(We, ie, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(Fe) {
        var Ze = this.store, Ve = !1, Mt = Fe.type.toLowerCase().replace("ms", ""), An = vt[Mt], lr = It[Fe.pointerType] || Fe.pointerType, lo = lr == ee, nn = N(Ze, Fe.pointerId, "pointerId");
        An & Qe && (Fe.button === 0 || lo) ? nn < 0 && (Ze.push(Fe), nn = Ze.length - 1) : An & (Se | De) && (Ve = !0), !(nn < 0) && (Ze[nn] = Fe, this.callback(this.manager, An, {
          pointers: Ze,
          changedPointers: [Fe],
          pointerType: lr,
          srcEvent: Fe
        }), Ve && Ze.splice(nn, 1));
      }
    });
    var En = {
      touchstart: Qe,
      touchmove: xe,
      touchend: Se,
      touchcancel: De
    }, qn = "touchstart", Pt = "touchstart touchmove touchend touchcancel";
    function dr() {
      this.evTarget = qn, this.evWin = Pt, this.started = !1, ie.apply(this, arguments);
    }
    y(dr, ie, {
      handler: function(Fe) {
        var Ze = En[Fe.type];
        if (Ze === Qe && (this.started = !0), !!this.started) {
          var Ve = yr.call(this, Fe, Ze);
          Ze & (Se | De) && Ve[0].length - Ve[1].length === 0 && (this.started = !1), this.callback(this.manager, Ze, {
            pointers: Ve[0],
            changedPointers: Ve[1],
            pointerType: ee,
            srcEvent: Fe
          });
        }
      }
    });
    function yr(Ne, Fe) {
      var Ze = k(Ne.touches), Ve = k(Ne.changedTouches);
      return Fe & (Se | De) && (Ze = $(Ze.concat(Ve), "identifier", !0)), [Ze, Ve];
    }
    var jn = {
      touchstart: Qe,
      touchmove: xe,
      touchend: Se,
      touchcancel: De
    }, Ot = "touchstart touchmove touchend touchcancel";
    function yn() {
      this.evTarget = Ot, this.targetIds = {}, ie.apply(this, arguments);
    }
    y(yn, ie, {
      handler: function(Fe) {
        var Ze = jn[Fe.type], Ve = Fn.call(this, Fe, Ze);
        Ve && this.callback(this.manager, Ze, {
          pointers: Ve[0],
          changedPointers: Ve[1],
          pointerType: ee,
          srcEvent: Fe
        });
      }
    });
    function Fn(Ne, Fe) {
      var Ze = k(Ne.touches), Ve = this.targetIds;
      if (Fe & (Qe | xe) && Ze.length === 1)
        return Ve[Ze[0].identifier] = !0, [Ze, Ze];
      var Mt, An, lr = k(Ne.changedTouches), lo = [], nn = this.target;
      if (An = Ze.filter(function(Xn) {
        return M(Xn.target, nn);
      }), Fe === Qe)
        for (Mt = 0; Mt < An.length; )
          Ve[An[Mt].identifier] = !0, Mt++;
      for (Mt = 0; Mt < lr.length; )
        Ve[lr[Mt].identifier] && lo.push(lr[Mt]), Fe & (Se | De) && delete Ve[lr[Mt].identifier], Mt++;
      if (lo.length)
        return [
          // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
          $(An.concat(lo), "identifier", !0),
          lo
        ];
    }
    var xn = 2500, vn = 25;
    function nt() {
      ie.apply(this, arguments);
      var Ne = v(this.handler, this);
      this.touch = new yn(this.manager, Ne), this.mouse = new Ht(this.manager, Ne), this.primaryTouch = null, this.lastTouches = [];
    }
    y(nt, ie, {
      /**
       * handle mouse and touch events
       * @param {Hammer} manager
       * @param {String} inputEvent
       * @param {Object} inputData
       */
      handler: function(Fe, Ze, Ve) {
        var Mt = Ve.pointerType == ee, An = Ve.pointerType == Ce;
        if (!(An && Ve.sourceCapabilities && Ve.sourceCapabilities.firesTouchEvents)) {
          if (Mt)
            st.call(this, Ze, Ve);
          else if (An && Me.call(this, Ve))
            return;
          this.callback(Fe, Ze, Ve);
        }
      },
      /**
       * remove the event listeners
       */
      destroy: function() {
        this.touch.destroy(), this.mouse.destroy();
      }
    });
    function st(Ne, Fe) {
      Ne & Qe ? (this.primaryTouch = Fe.changedPointers[0].identifier, xt.call(this, Fe)) : Ne & (Se | De) && xt.call(this, Fe);
    }
    function xt(Ne) {
      var Fe = Ne.changedPointers[0];
      if (Fe.identifier === this.primaryTouch) {
        var Ze = { x: Fe.clientX, y: Fe.clientY };
        this.lastTouches.push(Ze);
        var Ve = this.lastTouches, Mt = function() {
          var An = Ve.indexOf(Ze);
          An > -1 && Ve.splice(An, 1);
        };
        setTimeout(Mt, xn);
      }
    }
    function Me(Ne) {
      for (var Fe = Ne.srcEvent.clientX, Ze = Ne.srcEvent.clientY, Ve = 0; Ve < this.lastTouches.length; Ve++) {
        var Mt = this.lastTouches[Ve], An = Math.abs(Fe - Mt.x), lr = Math.abs(Ze - Mt.y);
        if (An <= vn && lr <= vn)
          return !0;
      }
      return !1;
    }
    var _ = U(s.style, "touchAction"), ye = _ !== i, He = "compute", ze = "auto", tt = "manipulation", At = "none", pt = "pan-x", Bt = "pan-y", Rt = Wr();
    function Lt(Ne, Fe) {
      this.manager = Ne, this.set(Fe);
    }
    Lt.prototype = {
      /**
       * set the touchAction value on the element or enable the polyfill
       * @param {String} value
       */
      set: function(Ne) {
        Ne == He && (Ne = this.compute()), ye && this.manager.element.style && Rt[Ne] && (this.manager.element.style[_] = Ne), this.actions = Ne.toLowerCase().trim();
      },
      /**
       * just re-set the touchAction value
       */
      update: function() {
        this.set(this.manager.options.touchAction);
      },
      /**
       * compute the value for the touchAction property based on the recognizer's settings
       * @returns {String} value
       */
      compute: function() {
        var Ne = [];
        return h(this.manager.recognizers, function(Fe) {
          b(Fe.options.enable, [Fe]) && (Ne = Ne.concat(Fe.getTouchAction()));
        }), rn(Ne.join(" "));
      },
      /**
       * this method is called on each input cycle and provides the preventing of the browser behavior
       * @param {Object} input
       */
      preventDefaults: function(Ne) {
        var Fe = Ne.srcEvent, Ze = Ne.offsetDirection;
        if (this.manager.session.prevented) {
          Fe.preventDefault();
          return;
        }
        var Ve = this.actions, Mt = O(Ve, At) && !Rt[At], An = O(Ve, Bt) && !Rt[Bt], lr = O(Ve, pt) && !Rt[pt];
        if (Mt) {
          var lo = Ne.pointers.length === 1, nn = Ne.distance < 2, Xn = Ne.deltaTime < 250;
          if (lo && nn && Xn)
            return;
        }
        if (!(lr && An) && (Mt || An && Ze & ge || lr && Ze & _e))
          return this.preventSrc(Fe);
      },
      /**
       * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
       * @param {Object} srcEvent
       */
      preventSrc: function(Ne) {
        this.manager.session.prevented = !0, Ne.preventDefault();
      }
    };
    function rn(Ne) {
      if (O(Ne, At))
        return At;
      var Fe = O(Ne, pt), Ze = O(Ne, Bt);
      return Fe && Ze ? At : Fe || Ze ? Fe ? pt : Bt : O(Ne, tt) ? tt : ze;
    }
    function Wr() {
      if (!ye)
        return !1;
      var Ne = {}, Fe = e.CSS && e.CSS.supports;
      return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(Ze) {
        Ne[Ze] = Fe ? e.CSS.supports("touch-action", Ze) : !0;
      }), Ne;
    }
    var pr = 1, Vt = 2, Sn = 4, kn = 8, vr = kn, Tr = 16, $t = 32;
    function Ye(Ne) {
      this.options = I({}, this.defaults, Ne || {}), this.id = K(), this.manager = null, this.options.enable = Q(this.options.enable, !0), this.state = pr, this.simultaneous = {}, this.requireFail = [];
    }
    Ye.prototype = {
      /**
       * @virtual
       * @type {Object}
       */
      defaults: {},
      /**
       * set options
       * @param {Object} options
       * @return {Recognizer}
       */
      set: function(Ne) {
        return I(this.options, Ne), this.manager && this.manager.touchAction.update(), this;
      },
      /**
       * recognize simultaneous with an other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      recognizeWith: function(Ne) {
        if (f(Ne, "recognizeWith", this))
          return this;
        var Fe = this.simultaneous;
        return Ne = zr(Ne, this), Fe[Ne.id] || (Fe[Ne.id] = Ne, Ne.recognizeWith(this)), this;
      },
      /**
       * drop the simultaneous link. it doesnt remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRecognizeWith: function(Ne) {
        return f(Ne, "dropRecognizeWith", this) ? this : (Ne = zr(Ne, this), delete this.simultaneous[Ne.id], this);
      },
      /**
       * recognizer can only run when an other is failing
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      requireFailure: function(Ne) {
        if (f(Ne, "requireFailure", this))
          return this;
        var Fe = this.requireFail;
        return Ne = zr(Ne, this), N(Fe, Ne) === -1 && (Fe.push(Ne), Ne.requireFailure(this)), this;
      },
      /**
       * drop the requireFailure link. it does not remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRequireFailure: function(Ne) {
        if (f(Ne, "dropRequireFailure", this))
          return this;
        Ne = zr(Ne, this);
        var Fe = N(this.requireFail, Ne);
        return Fe > -1 && this.requireFail.splice(Fe, 1), this;
      },
      /**
       * has require failures boolean
       * @returns {boolean}
       */
      hasRequireFailures: function() {
        return this.requireFail.length > 0;
      },
      /**
       * if the recognizer can recognize simultaneous with an other recognizer
       * @param {Recognizer} otherRecognizer
       * @returns {Boolean}
       */
      canRecognizeWith: function(Ne) {
        return !!this.simultaneous[Ne.id];
      },
      /**
       * You should use `tryEmit` instead of `emit` directly to check
       * that all the needed recognizers has failed before emitting.
       * @param {Object} input
       */
      emit: function(Ne) {
        var Fe = this, Ze = this.state;
        function Ve(Mt) {
          Fe.manager.emit(Mt, Ne);
        }
        Ze < kn && Ve(Fe.options.event + en(Ze)), Ve(Fe.options.event), Ne.additionalEvent && Ve(Ne.additionalEvent), Ze >= kn && Ve(Fe.options.event + en(Ze));
      },
      /**
       * Check that all the require failure recognizers has failed,
       * if true, it emits a gesture event,
       * otherwise, setup the state to FAILED.
       * @param {Object} input
       */
      tryEmit: function(Ne) {
        if (this.canEmit())
          return this.emit(Ne);
        this.state = $t;
      },
      /**
       * can we emit?
       * @returns {boolean}
       */
      canEmit: function() {
        for (var Ne = 0; Ne < this.requireFail.length; ) {
          if (!(this.requireFail[Ne].state & ($t | pr)))
            return !1;
          Ne++;
        }
        return !0;
      },
      /**
       * update the recognizer
       * @param {Object} inputData
       */
      recognize: function(Ne) {
        var Fe = I({}, Ne);
        if (!b(this.options.enable, [this, Fe])) {
          this.reset(), this.state = $t;
          return;
        }
        this.state & (vr | Tr | $t) && (this.state = pr), this.state = this.process(Fe), this.state & (Vt | Sn | kn | Tr) && this.tryEmit(Fe);
      },
      /**
       * return the state of the recognizer
       * the actual recognizing happens in this method
       * @virtual
       * @param {Object} inputData
       * @returns {Const} STATE
       */
      process: function(Ne) {
      },
      // jshint ignore:line
      /**
       * return the preferred touch-action
       * @virtual
       * @returns {Array}
       */
      getTouchAction: function() {
      },
      /**
       * called when the gesture isn't allowed to recognize
       * like when another is being recognized or it is disabled
       * @virtual
       */
      reset: function() {
      }
    };
    function en(Ne) {
      return Ne & Tr ? "cancel" : Ne & kn ? "end" : Ne & Sn ? "move" : Ne & Vt ? "start" : "";
    }
    function Ir(Ne) {
      return Ne == W ? "down" : Ne == fe ? "up" : Ne == Te ? "left" : Ne == se ? "right" : "";
    }
    function zr(Ne, Fe) {
      var Ze = Fe.manager;
      return Ze ? Ze.get(Ne) : Ne;
    }
    function In() {
      Ye.apply(this, arguments);
    }
    y(In, Ye, {
      /**
       * @namespace
       * @memberof AttrRecognizer
       */
      defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
      },
      /**
       * Used to check if it the recognizer receives valid input, like input.distance > 10.
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {Boolean} recognized
       */
      attrTest: function(Ne) {
        var Fe = this.options.pointers;
        return Fe === 0 || Ne.pointers.length === Fe;
      },
      /**
       * Process the input and return the state for the recognizer
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {*} State
       */
      process: function(Ne) {
        var Fe = this.state, Ze = Ne.eventType, Ve = Fe & (Vt | Sn), Mt = this.attrTest(Ne);
        return Ve && (Ze & De || !Mt) ? Fe | Tr : Ve || Mt ? Ze & Se ? Fe | kn : Fe & Vt ? Fe | Sn : Vt : $t;
      }
    });
    function mr() {
      In.apply(this, arguments), this.pX = null, this.pY = null;
    }
    y(mr, In, {
      /**
       * @namespace
       * @memberof PanRecognizer
       */
      defaults: {
        event: "pan",
        threshold: 10,
        pointers: 1,
        direction: Re
      },
      getTouchAction: function() {
        var Ne = this.options.direction, Fe = [];
        return Ne & ge && Fe.push(Bt), Ne & _e && Fe.push(pt), Fe;
      },
      directionTest: function(Ne) {
        var Fe = this.options, Ze = !0, Ve = Ne.distance, Mt = Ne.direction, An = Ne.deltaX, lr = Ne.deltaY;
        return Mt & Fe.direction || (Fe.direction & ge ? (Mt = An === 0 ? Ue : An < 0 ? Te : se, Ze = An != this.pX, Ve = Math.abs(Ne.deltaX)) : (Mt = lr === 0 ? Ue : lr < 0 ? fe : W, Ze = lr != this.pY, Ve = Math.abs(Ne.deltaY))), Ne.direction = Mt, Ze && Ve > Fe.threshold && Mt & Fe.direction;
      },
      attrTest: function(Ne) {
        return In.prototype.attrTest.call(this, Ne) && (this.state & Vt || !(this.state & Vt) && this.directionTest(Ne));
      },
      emit: function(Ne) {
        this.pX = Ne.deltaX, this.pY = Ne.deltaY;
        var Fe = Ir(Ne.direction);
        Fe && (Ne.additionalEvent = this.options.event + Fe), this._super.emit.call(this, Ne);
      }
    });
    function Mr() {
      In.apply(this, arguments);
    }
    y(Mr, In, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "pinch",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [At];
      },
      attrTest: function(Ne) {
        return this._super.attrTest.call(this, Ne) && (Math.abs(Ne.scale - 1) > this.options.threshold || this.state & Vt);
      },
      emit: function(Ne) {
        if (Ne.scale !== 1) {
          var Fe = Ne.scale < 1 ? "in" : "out";
          Ne.additionalEvent = this.options.event + Fe;
        }
        this._super.emit.call(this, Ne);
      }
    });
    function $e() {
      Ye.apply(this, arguments), this._timer = null, this._input = null;
    }
    y($e, Ye, {
      /**
       * @namespace
       * @memberof PressRecognizer
       */
      defaults: {
        event: "press",
        pointers: 1,
        time: 251,
        // minimal time of the pointer to be pressed
        threshold: 9
        // a minimal movement is ok, but keep it low
      },
      getTouchAction: function() {
        return [ze];
      },
      process: function(Ne) {
        var Fe = this.options, Ze = Ne.pointers.length === Fe.pointers, Ve = Ne.distance < Fe.threshold, Mt = Ne.deltaTime > Fe.time;
        if (this._input = Ne, !Ve || !Ze || Ne.eventType & (Se | De) && !Mt)
          this.reset();
        else if (Ne.eventType & Qe)
          this.reset(), this._timer = u(function() {
            this.state = vr, this.tryEmit();
          }, Fe.time, this);
        else if (Ne.eventType & Se)
          return vr;
        return $t;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function(Ne) {
        this.state === vr && (Ne && Ne.eventType & Se ? this.manager.emit(this.options.event + "up", Ne) : (this._input.timeStamp = c(), this.manager.emit(this.options.event, this._input)));
      }
    });
    function Ps() {
      In.apply(this, arguments);
    }
    y(Ps, In, {
      /**
       * @namespace
       * @memberof RotateRecognizer
       */
      defaults: {
        event: "rotate",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [At];
      },
      attrTest: function(Ne) {
        return this._super.attrTest.call(this, Ne) && (Math.abs(Ne.rotation) > this.options.threshold || this.state & Vt);
      }
    });
    function Wn() {
      In.apply(this, arguments);
    }
    y(Wn, In, {
      /**
       * @namespace
       * @memberof SwipeRecognizer
       */
      defaults: {
        event: "swipe",
        threshold: 10,
        velocity: 0.3,
        direction: ge | _e,
        pointers: 1
      },
      getTouchAction: function() {
        return mr.prototype.getTouchAction.call(this);
      },
      attrTest: function(Ne) {
        var Fe = this.options.direction, Ze;
        return Fe & (ge | _e) ? Ze = Ne.overallVelocity : Fe & ge ? Ze = Ne.overallVelocityX : Fe & _e && (Ze = Ne.overallVelocityY), this._super.attrTest.call(this, Ne) && Fe & Ne.offsetDirection && Ne.distance > this.options.threshold && Ne.maxPointers == this.options.pointers && l(Ze) > this.options.velocity && Ne.eventType & Se;
      },
      emit: function(Ne) {
        var Fe = Ir(Ne.offsetDirection);
        Fe && this.manager.emit(this.options.event + Fe, Ne), this.manager.emit(this.options.event, Ne);
      }
    });
    function Is() {
      Ye.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0;
    }
    y(Is, Ye, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "tap",
        pointers: 1,
        taps: 1,
        interval: 300,
        // max time between the multi-tap taps
        time: 250,
        // max time of the pointer to be down (like finger on the screen)
        threshold: 9,
        // a minimal movement is ok, but keep it low
        posThreshold: 10
        // a multi-tap can be a bit off the initial position
      },
      getTouchAction: function() {
        return [tt];
      },
      process: function(Ne) {
        var Fe = this.options, Ze = Ne.pointers.length === Fe.pointers, Ve = Ne.distance < Fe.threshold, Mt = Ne.deltaTime < Fe.time;
        if (this.reset(), Ne.eventType & Qe && this.count === 0)
          return this.failTimeout();
        if (Ve && Mt && Ze) {
          if (Ne.eventType != Se)
            return this.failTimeout();
          var An = this.pTime ? Ne.timeStamp - this.pTime < Fe.interval : !0, lr = !this.pCenter || ht(this.pCenter, Ne.center) < Fe.posThreshold;
          this.pTime = Ne.timeStamp, this.pCenter = Ne.center, !lr || !An ? this.count = 1 : this.count += 1, this._input = Ne;
          var lo = this.count % Fe.taps;
          if (lo === 0)
            return this.hasRequireFailures() ? (this._timer = u(function() {
              this.state = vr, this.tryEmit();
            }, Fe.interval, this), Vt) : vr;
        }
        return $t;
      },
      failTimeout: function() {
        return this._timer = u(function() {
          this.state = $t;
        }, this.options.interval, this), $t;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function() {
        this.state == vr && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
      }
    });
    function Ao(Ne, Fe) {
      return Fe = Fe || {}, Fe.recognizers = Q(Fe.recognizers, Ao.defaults.preset), new ml(Ne, Fe);
    }
    Ao.VERSION = "2.0.7", Ao.defaults = {
      /**
       * set if DOM events are being triggered.
       * But this is slower and unused by simple implementations, so disabled by default.
       * @type {Boolean}
       * @default false
       */
      domEvents: !1,
      /**
       * The value for the touchAction property/fallback.
       * When set to `compute` it will magically set the correct value based on the added recognizers.
       * @type {String}
       * @default compute
       */
      touchAction: He,
      /**
       * @type {Boolean}
       * @default true
       */
      enable: !0,
      /**
       * EXPERIMENTAL FEATURE -- can be removed/changed
       * Change the parent input target element.
       * If Null, then it is being set the to main element.
       * @type {Null|EventTarget}
       * @default null
       */
      inputTarget: null,
      /**
       * force an input class
       * @type {Null|Function}
       * @default null
       */
      inputClass: null,
      /**
       * Default recognizer setup when calling `Hammer()`
       * When creating a new Manager these will be skipped.
       * @type {Array}
       */
      preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [Ps, { enable: !1 }],
        [Mr, { enable: !1 }, ["rotate"]],
        [Wn, { direction: ge }],
        [mr, { direction: ge }, ["swipe"]],
        [Is],
        [Is, { event: "doubletap", taps: 2 }, ["tap"]],
        [$e]
      ],
      /**
       * Some CSS properties can be used to improve the working of Hammer.
       * Add them to this method and they will be set when creating a new Manager.
       * @namespace
       */
      cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: "none",
        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: "none",
        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: "none",
        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: "none",
        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: "none",
        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: "rgba(0,0,0,0)"
      }
    };
    var hc = 1, or = 2;
    function ml(Ne, Fe) {
      this.options = I({}, Ao.defaults, Fe || {}), this.options.inputTarget = this.options.inputTarget || Ne, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = Ne, this.input = Ae(this), this.touchAction = new Lt(this, this.options.touchAction), dc(this, !0), h(this.options.recognizers, function(Ze) {
        var Ve = this.add(new Ze[0](Ze[1]));
        Ze[2] && Ve.recognizeWith(Ze[2]), Ze[3] && Ve.requireFailure(Ze[3]);
      }, this);
    }
    ml.prototype = {
      /**
       * set options
       * @param {Object} options
       * @returns {Manager}
       */
      set: function(Ne) {
        return I(this.options, Ne), Ne.touchAction && this.touchAction.update(), Ne.inputTarget && (this.input.destroy(), this.input.target = Ne.inputTarget, this.input.init()), this;
      },
      /**
       * stop recognizing for this session.
       * This session will be discarded, when a new [input]start event is fired.
       * When forced, the recognizer cycle is stopped immediately.
       * @param {Boolean} [force]
       */
      stop: function(Ne) {
        this.session.stopped = Ne ? or : hc;
      },
      /**
       * run the recognizers!
       * called by the inputHandler function on every movement of the pointers (touches)
       * it walks through all the recognizers and tries to detect the gesture that is being made
       * @param {Object} inputData
       */
      recognize: function(Ne) {
        var Fe = this.session;
        if (!Fe.stopped) {
          this.touchAction.preventDefaults(Ne);
          var Ze, Ve = this.recognizers, Mt = Fe.curRecognizer;
          (!Mt || Mt && Mt.state & vr) && (Mt = Fe.curRecognizer = null);
          for (var An = 0; An < Ve.length; )
            Ze = Ve[An], Fe.stopped !== or && // 1
            (!Mt || Ze == Mt || // 2
            Ze.canRecognizeWith(Mt)) ? Ze.recognize(Ne) : Ze.reset(), !Mt && Ze.state & (Vt | Sn | kn) && (Mt = Fe.curRecognizer = Ze), An++;
        }
      },
      /**
       * get a recognizer by its event name.
       * @param {Recognizer|String} recognizer
       * @returns {Recognizer|Null}
       */
      get: function(Ne) {
        if (Ne instanceof Ye)
          return Ne;
        for (var Fe = this.recognizers, Ze = 0; Ze < Fe.length; Ze++)
          if (Fe[Ze].options.event == Ne)
            return Fe[Ze];
        return null;
      },
      /**
       * add a recognizer to the manager
       * existing recognizers with the same event name will be removed
       * @param {Recognizer} recognizer
       * @returns {Recognizer|Manager}
       */
      add: function(Ne) {
        if (f(Ne, "add", this))
          return this;
        var Fe = this.get(Ne.options.event);
        return Fe && this.remove(Fe), this.recognizers.push(Ne), Ne.manager = this, this.touchAction.update(), Ne;
      },
      /**
       * remove a recognizer by name or instance
       * @param {Recognizer|String} recognizer
       * @returns {Manager}
       */
      remove: function(Ne) {
        if (f(Ne, "remove", this))
          return this;
        if (Ne = this.get(Ne), Ne) {
          var Fe = this.recognizers, Ze = N(Fe, Ne);
          Ze !== -1 && (Fe.splice(Ze, 1), this.touchAction.update());
        }
        return this;
      },
      /**
       * bind event
       * @param {String} events
       * @param {Function} handler
       * @returns {EventEmitter} this
       */
      on: function(Ne, Fe) {
        if (Ne !== i && Fe !== i) {
          var Ze = this.handlers;
          return h(L(Ne), function(Ve) {
            Ze[Ve] = Ze[Ve] || [], Ze[Ve].push(Fe);
          }), this;
        }
      },
      /**
       * unbind event, leave emit blank to remove all handlers
       * @param {String} events
       * @param {Function} [handler]
       * @returns {EventEmitter} this
       */
      off: function(Ne, Fe) {
        if (Ne !== i) {
          var Ze = this.handlers;
          return h(L(Ne), function(Ve) {
            Fe ? Ze[Ve] && Ze[Ve].splice(N(Ze[Ve], Fe), 1) : delete Ze[Ve];
          }), this;
        }
      },
      /**
       * emit event to the listeners
       * @param {String} event
       * @param {Object} data
       */
      emit: function(Ne, Fe) {
        this.options.domEvents && Wa(Ne, Fe);
        var Ze = this.handlers[Ne] && this.handlers[Ne].slice();
        if (!(!Ze || !Ze.length)) {
          Fe.type = Ne, Fe.preventDefault = function() {
            Fe.srcEvent.preventDefault();
          };
          for (var Ve = 0; Ve < Ze.length; )
            Ze[Ve](Fe), Ve++;
        }
      },
      /**
       * destroy the manager and unbinds all events
       * it doesn't unbind dom events, that is the user own responsibility
       */
      destroy: function() {
        this.element && dc(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
      }
    };
    function dc(Ne, Fe) {
      var Ze = Ne.element;
      if (Ze.style) {
        var Ve;
        h(Ne.options.cssProps, function(Mt, An) {
          Ve = U(Ze.style, An), Fe ? (Ne.oldCssProps[Ve] = Ze.style[Ve], Ze.style[Ve] = Mt) : Ze.style[Ve] = Ne.oldCssProps[Ve] || "";
        }), Fe || (Ne.oldCssProps = {});
      }
    }
    function Wa(Ne, Fe) {
      var Ze = n.createEvent("Event");
      Ze.initEvent(Ne, !0, !0), Ze.gesture = Fe, Fe.target.dispatchEvent(Ze);
    }
    I(Ao, {
      INPUT_START: Qe,
      INPUT_MOVE: xe,
      INPUT_END: Se,
      INPUT_CANCEL: De,
      STATE_POSSIBLE: pr,
      STATE_BEGAN: Vt,
      STATE_CHANGED: Sn,
      STATE_ENDED: kn,
      STATE_RECOGNIZED: vr,
      STATE_CANCELLED: Tr,
      STATE_FAILED: $t,
      DIRECTION_NONE: Ue,
      DIRECTION_LEFT: Te,
      DIRECTION_RIGHT: se,
      DIRECTION_UP: fe,
      DIRECTION_DOWN: W,
      DIRECTION_HORIZONTAL: ge,
      DIRECTION_VERTICAL: _e,
      DIRECTION_ALL: Re,
      Manager: ml,
      Input: ie,
      TouchAction: Lt,
      TouchInput: yn,
      MouseInput: Ht,
      PointerEventInput: We,
      TouchMouseInput: nt,
      SingleTouchInput: dr,
      Recognizer: Ye,
      AttrRecognizer: In,
      Tap: Is,
      Pan: mr,
      Swipe: Wn,
      Pinch: Mr,
      Rotate: Ps,
      Press: $e,
      on: w,
      off: R,
      each: h,
      merge: C,
      extend: m,
      assign: I,
      inherit: y,
      bindFn: v,
      prefixed: U
    });
    var Ki = typeof e < "u" ? e : typeof self < "u" ? self : {};
    Ki.Hammer = Ao, typeof i == "function" && i.amd ? i(function() {
      return Ao;
    }) : t.exports ? t.exports = Ao : e[r] = Ao;
  })(window, document, "Hammer");
})(yqe);
var dM = yqe.exports;
const Fhn = /* @__PURE__ */ ko(dM), Vd = /* @__PURE__ */ $ct({
  __proto__: null,
  default: Fhn
}, [dM]), vqe = 1, Bqe = 2, Vee = 4, Phn = {
  mousedown: vqe,
  mousemove: Bqe,
  mouseup: Vee
};
function khn(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return !0;
  return !1;
}
function Ghn(t) {
  const e = t.prototype.handler;
  t.prototype.handler = function(r) {
    const i = this.store;
    r.button > 0 && r.type === "pointerdown" && (khn(i, (o) => o.pointerId === r.pointerId) || i.push(r)), e.call(this, r);
  };
}
function Uhn(t) {
  t.prototype.handler = function(n) {
    let r = Phn[n.type];
    r & vqe && n.button >= 0 && (this.pressed = !0), r & Bqe && n.which === 0 && (r = Vee), this.pressed && (r & Vee && (this.pressed = !1), this.callback(this.manager, r, {
      pointers: [n],
      changedPointers: [n],
      pointerType: "mouse",
      srcEvent: n
    }));
  };
}
Ghn(dM.PointerEventInput);
Uhn(dM.MouseInput);
const Hhn = dM.Manager;
class u$ {
  constructor(e, n, r) {
    this.element = e, this.callback = n, this.options = { enable: !0, ...r };
  }
}
const $hn = Vd ? [
  [Vd.Pan, { event: "tripan", pointers: 3, threshold: 0, enable: !1 }],
  [Vd.Rotate, { enable: !1 }],
  [Vd.Pinch, { enable: !1 }],
  [Vd.Swipe, { enable: !1 }],
  [Vd.Pan, { threshold: 0, enable: !1 }],
  [Vd.Press, { enable: !1 }],
  [Vd.Tap, { event: "doubletap", taps: 2, enable: !1 }],
  // TODO - rename to 'tap' and 'singletap' in the next major release
  [Vd.Tap, { event: "anytap", enable: !1 }],
  [Vd.Tap, { enable: !1 }]
] : null, j_e = {
  tripan: ["rotate", "pinch", "pan"],
  rotate: ["pinch"],
  pinch: ["pan"],
  pan: ["press", "doubletap", "anytap", "tap"],
  doubletap: ["anytap"],
  anytap: ["tap"]
}, qhn = {
  doubletap: ["tap"]
}, jhn = {
  pointerdown: "pointerdown",
  pointermove: "pointermove",
  pointerup: "pointerup",
  touchstart: "pointerdown",
  touchmove: "pointermove",
  touchend: "pointerup",
  mousedown: "pointerdown",
  mousemove: "pointermove",
  mouseup: "pointerup"
}, Kle = {
  KEY_EVENTS: ["keydown", "keyup"],
  MOUSE_EVENTS: ["mousedown", "mousemove", "mouseup", "mouseover", "mouseout", "mouseleave"],
  WHEEL_EVENTS: [
    // Chrome, Safari
    "wheel",
    // IE
    "mousewheel"
  ]
}, Yhn = {
  tap: "tap",
  anytap: "anytap",
  doubletap: "doubletap",
  press: "press",
  pinch: "pinch",
  pinchin: "pinch",
  pinchout: "pinch",
  pinchstart: "pinch",
  pinchmove: "pinch",
  pinchend: "pinch",
  pinchcancel: "pinch",
  rotate: "rotate",
  rotatestart: "rotate",
  rotatemove: "rotate",
  rotateend: "rotate",
  rotatecancel: "rotate",
  tripan: "tripan",
  tripanstart: "tripan",
  tripanmove: "tripan",
  tripanup: "tripan",
  tripandown: "tripan",
  tripanleft: "tripan",
  tripanright: "tripan",
  tripanend: "tripan",
  tripancancel: "tripan",
  pan: "pan",
  panstart: "pan",
  panmove: "pan",
  panup: "pan",
  pandown: "pan",
  panleft: "pan",
  panright: "pan",
  panend: "pan",
  pancancel: "pan",
  swipe: "swipe",
  swipeleft: "swipe",
  swiperight: "swipe",
  swipeup: "swipe",
  swipedown: "swipe"
}, Y_e = {
  click: "tap",
  anyclick: "anytap",
  dblclick: "doubletap",
  mousedown: "pointerdown",
  mousemove: "pointermove",
  mouseup: "pointerup",
  mouseover: "pointerover",
  mouseout: "pointerout",
  mouseleave: "pointerleave"
}, zhn = typeof navigator < "u" && navigator.userAgent ? navigator.userAgent.toLowerCase() : "", g_ = typeof window < "u" ? window : global;
let Jee = !1;
try {
  const t = {
    // This function will be called when the browser
    // attempts to access the passive property.
    get passive() {
      return Jee = !0, !0;
    }
  };
  g_.addEventListener("test", null, t), g_.removeEventListener("test", null);
} catch {
  Jee = !1;
}
const Vhn = zhn.indexOf("firefox") !== -1, { WHEEL_EVENTS: Jhn } = Kle, z_e = "wheel", V_e = 4.000244140625, Khn = 40, Whn = 0.25;
class Xhn extends u$ {
  constructor(e, n, r) {
    super(e, n, r), this.handleEvent = (i) => {
      if (!this.options.enable)
        return;
      let o = i.deltaY;
      g_.WheelEvent && (Vhn && i.deltaMode === g_.WheelEvent.DOM_DELTA_PIXEL && (o /= g_.devicePixelRatio), i.deltaMode === g_.WheelEvent.DOM_DELTA_LINE && (o *= Khn)), o !== 0 && o % V_e === 0 && (o = Math.floor(o / V_e)), i.shiftKey && o && (o = o * Whn), this.callback({
        type: z_e,
        center: {
          x: i.clientX,
          y: i.clientY
        },
        delta: -o,
        srcEvent: i,
        pointerType: "mouse",
        target: i.target
      });
    }, this.events = (this.options.events || []).concat(Jhn), this.events.forEach((i) => e.addEventListener(i, this.handleEvent, Jee ? { passive: !1 } : !1));
  }
  destroy() {
    this.events.forEach((e) => this.element.removeEventListener(e, this.handleEvent));
  }
  /**
   * Enable this input (begin processing events)
   * if the specified event type is among those handled by this input.
   */
  enableEventType(e, n) {
    e === z_e && (this.options.enable = n);
  }
}
const { MOUSE_EVENTS: Zhn } = Kle, J_e = "pointermove", K_e = "pointerover", W_e = "pointerout", X_e = "pointerenter", Z_e = "pointerleave";
class edn extends u$ {
  constructor(e, n, r) {
    super(e, n, r), this.handleEvent = (o) => {
      this.handleOverEvent(o), this.handleOutEvent(o), this.handleEnterEvent(o), this.handleLeaveEvent(o), this.handleMoveEvent(o);
    }, this.pressed = !1;
    const { enable: i } = this.options;
    this.enableMoveEvent = i, this.enableLeaveEvent = i, this.enableEnterEvent = i, this.enableOutEvent = i, this.enableOverEvent = i, this.events = (this.options.events || []).concat(Zhn), this.events.forEach((o) => e.addEventListener(o, this.handleEvent));
  }
  destroy() {
    this.events.forEach((e) => this.element.removeEventListener(e, this.handleEvent));
  }
  /**
   * Enable this input (begin processing events)
   * if the specified event type is among those handled by this input.
   */
  enableEventType(e, n) {
    e === J_e && (this.enableMoveEvent = n), e === K_e && (this.enableOverEvent = n), e === W_e && (this.enableOutEvent = n), e === X_e && (this.enableEnterEvent = n), e === Z_e && (this.enableLeaveEvent = n);
  }
  handleOverEvent(e) {
    this.enableOverEvent && e.type === "mouseover" && this._emit(K_e, e);
  }
  handleOutEvent(e) {
    this.enableOutEvent && e.type === "mouseout" && this._emit(W_e, e);
  }
  handleEnterEvent(e) {
    this.enableEnterEvent && e.type === "mouseenter" && this._emit(X_e, e);
  }
  handleLeaveEvent(e) {
    this.enableLeaveEvent && e.type === "mouseleave" && this._emit(Z_e, e);
  }
  handleMoveEvent(e) {
    if (this.enableMoveEvent)
      switch (e.type) {
        case "mousedown":
          e.button >= 0 && (this.pressed = !0);
          break;
        case "mousemove":
          e.which === 0 && (this.pressed = !1), this.pressed || this._emit(J_e, e);
          break;
        case "mouseup":
          this.pressed = !1;
          break;
      }
  }
  _emit(e, n) {
    this.callback({
      type: e,
      center: {
        x: n.clientX,
        y: n.clientY
      },
      srcEvent: n,
      pointerType: "mouse",
      target: n.target
    });
  }
}
const { KEY_EVENTS: tdn } = Kle, eSe = "keydown", tSe = "keyup";
class ndn extends u$ {
  constructor(e, n, r) {
    super(e, n, r), this.handleEvent = (i) => {
      const o = i.target || i.srcElement;
      o.tagName === "INPUT" && o.type === "text" || o.tagName === "TEXTAREA" || (this.enableDownEvent && i.type === "keydown" && this.callback({
        type: eSe,
        srcEvent: i,
        key: i.key,
        target: i.target
      }), this.enableUpEvent && i.type === "keyup" && this.callback({
        type: tSe,
        srcEvent: i,
        key: i.key,
        target: i.target
      }));
    }, this.enableDownEvent = this.options.enable, this.enableUpEvent = this.options.enable, this.events = (this.options.events || []).concat(tdn), e.tabIndex = this.options.tabIndex || 0, e.style.outline = "none", this.events.forEach((i) => e.addEventListener(i, this.handleEvent));
  }
  destroy() {
    this.events.forEach((e) => this.element.removeEventListener(e, this.handleEvent));
  }
  /**
   * Enable this input (begin processing events)
   * if the specified event type is among those handled by this input.
   */
  enableEventType(e, n) {
    e === eSe && (this.enableDownEvent = n), e === tSe && (this.enableUpEvent = n);
  }
}
const nSe = "contextmenu";
class rdn extends u$ {
  constructor(e, n, r) {
    super(e, n, r), this.handleEvent = (i) => {
      this.options.enable && this.callback({
        type: nSe,
        center: {
          x: i.clientX,
          y: i.clientY
        },
        srcEvent: i,
        pointerType: "mouse",
        target: i.target
      });
    }, e.addEventListener("contextmenu", this.handleEvent);
  }
  destroy() {
    this.element.removeEventListener("contextmenu", this.handleEvent);
  }
  /**
   * Enable this input (begin processing events)
   * if the specified event type is among those handled by this input.
   */
  enableEventType(e, n) {
    e === nSe && (this.options.enable = n);
  }
}
const Kee = 1, xU = 2, Wee = 4, idn = {
  pointerdown: Kee,
  pointermove: xU,
  pointerup: Wee,
  mousedown: Kee,
  mousemove: xU,
  mouseup: Wee
}, odn = 1, sdn = 2, adn = 3, Adn = 0, ldn = 1, cdn = 2, udn = 1, fdn = 2, gdn = 4;
function hdn(t) {
  const e = idn[t.srcEvent.type];
  if (!e)
    return null;
  const { buttons: n, button: r, which: i } = t.srcEvent;
  let o = !1, s = !1, a = !1;
  return /* button is up, need to find out which one was pressed before */ e === Wee || // moving but does not support `buttons` API
  e === xU && !Number.isFinite(n) ? (o = i === odn, s = i === sdn, a = i === adn) : e === xU ? (o = !!(n & udn), s = !!(n & gdn), a = !!(n & fdn)) : e === Kee && (o = r === Adn, s = r === ldn, a = r === cdn), { leftButton: o, middleButton: s, rightButton: a };
}
function ddn(t, e) {
  const n = t.center;
  if (!n)
    return null;
  const r = e.getBoundingClientRect(), i = r.width / e.offsetWidth || 1, o = r.height / e.offsetHeight || 1, s = {
    x: (n.x - r.left - e.clientLeft) / i,
    y: (n.y - r.top - e.clientTop) / o
  };
  return { center: n, offsetCenter: s };
}
const yV = {
  srcElement: "root",
  priority: 0
};
class pdn {
  constructor(e) {
    this.handleEvent = (n) => {
      if (this.isEmpty())
        return;
      const r = this._normalizeEvent(n);
      let i = n.srcEvent.target;
      for (; i && i !== r.rootElement; ) {
        if (this._emit(r, i), r.handled)
          return;
        i = i.parentNode;
      }
      this._emit(r, "root");
    }, this.eventManager = e, this.handlers = [], this.handlersByElement = /* @__PURE__ */ new Map(), this._active = !1;
  }
  // Returns true if there are no non-passive handlers
  isEmpty() {
    return !this._active;
  }
  add(e, n, r, i = !1, o = !1) {
    const { handlers: s, handlersByElement: a } = this;
    let A = yV;
    typeof r == "string" || r && r.addEventListener ? A = { ...yV, srcElement: r } : r && (A = { ...yV, ...r });
    let l = a.get(A.srcElement);
    l || (l = [], a.set(A.srcElement, l));
    const c = {
      type: e,
      handler: n,
      srcElement: A.srcElement,
      priority: A.priority
    };
    i && (c.once = !0), o && (c.passive = !0), s.push(c), this._active = this._active || !c.passive;
    let u = l.length - 1;
    for (; u >= 0 && !(l[u].priority >= c.priority); )
      u--;
    l.splice(u + 1, 0, c);
  }
  remove(e, n) {
    const { handlers: r, handlersByElement: i } = this;
    for (let o = r.length - 1; o >= 0; o--) {
      const s = r[o];
      if (s.type === e && s.handler === n) {
        r.splice(o, 1);
        const a = i.get(s.srcElement);
        a.splice(a.indexOf(s), 1), a.length === 0 && i.delete(s.srcElement);
      }
    }
    this._active = r.some((o) => !o.passive);
  }
  /**
   * Invoke handlers on a particular element
   */
  _emit(e, n) {
    const r = this.handlersByElement.get(n);
    if (r) {
      let i = !1;
      const o = () => {
        e.handled = !0;
      }, s = () => {
        e.handled = !0, i = !0;
      }, a = [];
      for (let A = 0; A < r.length; A++) {
        const { type: l, handler: c, once: u } = r[A];
        if (c({
          ...e,
          // @ts-ignore
          type: l,
          stopPropagation: o,
          stopImmediatePropagation: s
        }), u && a.push(r[A]), i)
          break;
      }
      for (let A = 0; A < a.length; A++) {
        const { type: l, handler: c } = a[A];
        this.remove(l, c);
      }
    }
  }
  /**
   * Normalizes hammerjs and custom events to have predictable fields.
   */
  _normalizeEvent(e) {
    const n = this.eventManager.getElement();
    return {
      ...e,
      ...hdn(e),
      ...ddn(e, n),
      preventDefault: () => {
        e.srcEvent.preventDefault();
      },
      stopImmediatePropagation: null,
      stopPropagation: null,
      handled: !1,
      rootElement: n
    };
  }
}
const Idn = {
  // event handlers
  events: null,
  // custom recognizers
  recognizers: null,
  recognizerOptions: {},
  // Manager class
  Manager: Hhn,
  // allow browser default touch action
  // https://github.com/uber/react-map-gl/issues/506
  touchAction: "none",
  tabIndex: 0
};
class mdn {
  constructor(e = null, n) {
    this._onBasicInput = (i) => {
      const { srcEvent: o } = i, s = jhn[o.type];
      s && this.manager.emit(s, i);
    }, this._onOtherEvent = (i) => {
      this.manager.emit(i.type, i);
    }, this.options = { ...Idn, ...n }, this.events = /* @__PURE__ */ new Map(), this.setElement(e);
    const { events: r } = this.options;
    r && this.on(r);
  }
  getElement() {
    return this.element;
  }
  setElement(e) {
    if (this.element && this.destroy(), this.element = e, !e)
      return;
    const { options: n } = this, r = n.Manager;
    this.manager = new r(e, {
      touchAction: n.touchAction,
      recognizers: n.recognizers || $hn
    }).on("hammer.input", this._onBasicInput), n.recognizers || Object.keys(j_e).forEach((i) => {
      const o = this.manager.get(i);
      o && j_e[i].forEach((s) => {
        o.recognizeWith(s);
      });
    });
    for (const i in n.recognizerOptions) {
      const o = this.manager.get(i);
      if (o) {
        const s = n.recognizerOptions[i];
        delete s.enable, o.set(s);
      }
    }
    this.wheelInput = new Xhn(e, this._onOtherEvent, {
      enable: !1
    }), this.moveInput = new edn(e, this._onOtherEvent, {
      enable: !1
    }), this.keyInput = new ndn(e, this._onOtherEvent, {
      enable: !1,
      tabIndex: n.tabIndex
    }), this.contextmenuInput = new rdn(e, this._onOtherEvent, {
      enable: !1
    });
    for (const [i, o] of this.events)
      o.isEmpty() || (this._toggleRecognizer(o.recognizerName, !0), this.manager.on(i, o.handleEvent));
  }
  // Tear down internal event management implementations.
  destroy() {
    this.element && (this.wheelInput.destroy(), this.moveInput.destroy(), this.keyInput.destroy(), this.contextmenuInput.destroy(), this.manager.destroy(), this.wheelInput = null, this.moveInput = null, this.keyInput = null, this.contextmenuInput = null, this.manager = null, this.element = null);
  }
  /** Register an event handler function to be called on `event` */
  on(e, n, r) {
    this._addEventHandler(e, n, r, !1);
  }
  once(e, n, r) {
    this._addEventHandler(e, n, r, !0);
  }
  watch(e, n, r) {
    this._addEventHandler(e, n, r, !1, !0);
  }
  off(e, n) {
    this._removeEventHandler(e, n);
  }
  /*
   * Enable/disable recognizer for the given event
   */
  _toggleRecognizer(e, n) {
    const { manager: r } = this;
    if (!r)
      return;
    const i = r.get(e);
    if (i && i.options.enable !== n) {
      i.set({ enable: n });
      const o = qhn[e];
      o && !this.options.recognizers && o.forEach((s) => {
        const a = r.get(s);
        n ? (a.requireFailure(e), i.dropRequireFailure(s)) : a.dropRequireFailure(e);
      });
    }
    this.wheelInput.enableEventType(e, n), this.moveInput.enableEventType(e, n), this.keyInput.enableEventType(e, n), this.contextmenuInput.enableEventType(e, n);
  }
  /**
   * Process the event registration for a single event + handler.
   */
  _addEventHandler(e, n, r, i, o) {
    if (typeof e != "string") {
      r = n;
      for (const c in e)
        this._addEventHandler(c, e[c], r, i, o);
      return;
    }
    const { manager: s, events: a } = this, A = Y_e[e] || e;
    let l = a.get(A);
    l || (l = new pdn(this), a.set(A, l), l.recognizerName = Yhn[A] || A, s && s.on(A, l.handleEvent)), l.add(e, n, r, i, o), l.isEmpty() || this._toggleRecognizer(l.recognizerName, !0);
  }
  /**
   * Process the event deregistration for a single event + handler.
   */
  _removeEventHandler(e, n) {
    if (typeof e != "string") {
      for (const s in e)
        this._removeEventHandler(s, e[s]);
      return;
    }
    const { events: r } = this, i = Y_e[e] || e, o = r.get(i);
    if (o && (o.remove(e, n), o.isEmpty())) {
      const { recognizerName: s } = o;
      let a = !1;
      for (const A of r.values())
        if (A.recognizerName === s && !A.isEmpty()) {
          a = !0;
          break;
        }
      a || this._toggleRecognizer(s, !1);
    }
  }
}
function py() {
}
const Cdn = ({
  isDragging: t
}) => t ? "grabbing" : "grab", bqe = {
  id: "",
  width: "100%",
  height: "100%",
  style: null,
  viewState: null,
  initialViewState: null,
  pickingRadius: 0,
  layerFilter: null,
  glOptions: {},
  parameters: {},
  parent: null,
  gl: null,
  canvas: null,
  layers: [],
  effects: [],
  views: null,
  controller: null,
  useDevicePixels: !0,
  touchAction: "none",
  eventRecognizerOptions: {},
  _framebuffer: null,
  _animate: !1,
  _pickable: !0,
  _typedArrayManagerProps: {},
  _customRender: null,
  onWebGLInitialized: py,
  onResize: py,
  onViewStateChange: py,
  onInteractionStateChange: py,
  onBeforeRender: py,
  onAfterRender: py,
  onLoad: py,
  onError: (t) => Rr.error(t.message)(),
  onHover: null,
  onClick: null,
  onDragStart: null,
  onDrag: null,
  onDragEnd: null,
  _onMetrics: null,
  getCursor: Cdn,
  getTooltip: null,
  debug: !1,
  drawPickingColors: !1
};
class pM {
  constructor(e) {
    ae(this, "props", void 0), ae(this, "width", 0), ae(this, "height", 0), ae(this, "userData", {}), ae(this, "canvas", null), ae(this, "viewManager", null), ae(this, "layerManager", null), ae(this, "effectManager", null), ae(this, "deckRenderer", null), ae(this, "deckPicker", null), ae(this, "eventManager", null), ae(this, "tooltip", null), ae(this, "metrics", void 0), ae(this, "animationLoop", void 0), ae(this, "stats", void 0), ae(this, "viewState", void 0), ae(this, "cursorState", void 0), ae(this, "_needsRedraw", void 0), ae(this, "_pickRequest", void 0), ae(this, "_lastPointerDownInfo", null), ae(this, "_metricsCounter", void 0), ae(this, "_onPointerMove", (n) => {
      const {
        _pickRequest: r
      } = this;
      if (n.type === "pointerleave")
        r.x = -1, r.y = -1, r.radius = 0;
      else {
        if (n.leftButton || n.rightButton)
          return;
        {
          const i = n.offsetCenter;
          if (!i)
            return;
          r.x = i.x, r.y = i.y, r.radius = this.props.pickingRadius;
        }
      }
      this.layerManager && (this.layerManager.context.mousePosition = {
        x: r.x,
        y: r.y
      }), r.event = n;
    }), ae(this, "_onEvent", (n) => {
      const r = w_e[n.type], i = n.offsetCenter;
      if (!r || !i || !this.layerManager)
        return;
      const o = this.layerManager.getLayers(), s = this.deckPicker.getLastPickedObject({
        x: i.x,
        y: i.y,
        layers: o,
        viewports: this.getViewports(i)
      }, this._lastPointerDownInfo), {
        layer: a
      } = s, A = a && (a[r.handler] || a.props[r.handler]), l = this.props[r.handler];
      let c = !1;
      A && (c = A.call(a, s, n)), !c && l && l(s, n);
    }), ae(this, "_onPointerDown", (n) => {
      const r = n.offsetCenter, i = this._pick("pickObject", "pickObject Time", {
        x: r.x,
        y: r.y,
        radius: this.props.pickingRadius
      });
      this._lastPointerDownInfo = i.result[0] || i.emptyInfo;
    }), this.props = {
      ...bqe,
      ...e
    }, e = this.props, this._needsRedraw = "Initial render", this._pickRequest = {
      mode: "hover",
      x: -1,
      y: -1,
      radius: 0,
      event: null
    }, this.cursorState = {
      isHovering: !1,
      isDragging: !1
    }, e.viewState && e.initialViewState && Rr.warn("View state tracking is disabled. Use either `initialViewState` for auto update or `viewState` for manual update.")(), E9e() === "IE" && Rr.warn("IE 11 is not supported")(), this.viewState = e.initialViewState, e.gl || typeof document < "u" && (this.canvas = this._createCanvas(e)), this.animationLoop = this._createAnimationLoop(e), this.stats = new tM({
      id: "deck.gl"
    }), this.metrics = {
      fps: 0,
      setPropsTime: 0,
      updateAttributesTime: 0,
      framesRedrawn: 0,
      pickTime: 0,
      pickCount: 0,
      gpuTime: 0,
      gpuTimePerFrame: 0,
      cpuTime: 0,
      cpuTimePerFrame: 0,
      bufferMemory: 0,
      textureMemory: 0,
      renderbufferMemory: 0,
      gpuMemory: 0
    }, this._metricsCounter = 0, this.setProps(e), e._typedArrayManagerProps && jS.setOptions(e._typedArrayManagerProps), this.animationLoop.start();
  }
  finalize() {
    var e, n, r, i, o, s, a;
    if (this.animationLoop.stop(), this.animationLoop = null, this._lastPointerDownInfo = null, (e = this.layerManager) === null || e === void 0 || e.finalize(), this.layerManager = null, (n = this.viewManager) === null || n === void 0 || n.finalize(), this.viewManager = null, (r = this.effectManager) === null || r === void 0 || r.finalize(), this.effectManager = null, (i = this.deckRenderer) === null || i === void 0 || i.finalize(), this.deckRenderer = null, (o = this.deckPicker) === null || o === void 0 || o.finalize(), this.deckPicker = null, (s = this.eventManager) === null || s === void 0 || s.destroy(), this.eventManager = null, (a = this.tooltip) === null || a === void 0 || a.remove(), this.tooltip = null, !this.props.canvas && !this.props.gl && this.canvas) {
      var A;
      (A = this.canvas.parentElement) === null || A === void 0 || A.removeChild(this.canvas), this.canvas = null;
    }
  }
  setProps(e) {
    this.stats.get("setProps Time").timeStart(), "onLayerHover" in e && Rr.removed("onLayerHover", "onHover")(), "onLayerClick" in e && Rr.removed("onLayerClick", "onClick")(), e.initialViewState && !t1(this.props.initialViewState, e.initialViewState) && (this.viewState = e.initialViewState), Object.assign(this.props, e), this._setCanvasSize(this.props);
    const n = Object.create(this.props);
    Object.assign(n, {
      views: this._getViews(),
      width: this.width,
      height: this.height,
      viewState: this._getViewState()
    }), this.animationLoop.setProps(n), this.layerManager && (this.viewManager.setProps(n), this.layerManager.activateViewport(this.getViewports()[0]), this.layerManager.setProps(n), this.effectManager.setProps(n), this.deckRenderer.setProps(n), this.deckPicker.setProps(n)), this.stats.get("setProps Time").timeEnd();
  }
  needsRedraw(e = {
    clearRedrawFlags: !1
  }) {
    if (!this.layerManager)
      return !1;
    if (this.props._animate)
      return "Deck._animate";
    let n = this._needsRedraw;
    e.clearRedrawFlags && (this._needsRedraw = !1);
    const r = this.viewManager.needsRedraw(e), i = this.layerManager.needsRedraw(e), o = this.effectManager.needsRedraw(e), s = this.deckRenderer.needsRedraw(e);
    return n = n || r || i || o || s, n;
  }
  redraw(e) {
    if (!this.layerManager)
      return;
    let n = this.needsRedraw({
      clearRedrawFlags: !0
    });
    n = e || n, n && (this.stats.get("Redraw Count").incrementCount(), this.props._customRender ? this.props._customRender(n) : this._drawLayers(n));
  }
  get isInitialized() {
    return this.viewManager !== null;
  }
  getViews() {
    return sA(this.viewManager), this.viewManager.views;
  }
  getViewports(e) {
    return sA(this.viewManager), this.viewManager.getViewports(e);
  }
  pickObject(e) {
    const n = this._pick("pickObject", "pickObject Time", e).result;
    return n.length ? n[0] : null;
  }
  pickMultipleObjects(e) {
    return e.depth = e.depth || 10, this._pick("pickObject", "pickMultipleObjects Time", e).result;
  }
  pickObjects(e) {
    return this._pick("pickObjects", "pickObjects Time", e);
  }
  _addResources(e, n = !1) {
    for (const r in e)
      this.layerManager.resourceManager.add({
        resourceId: r,
        data: e[r],
        forceUpdate: n
      });
  }
  _removeResources(e) {
    for (const n of e)
      this.layerManager.resourceManager.remove(n);
  }
  _pick(e, n, r) {
    sA(this.deckPicker);
    const {
      stats: i
    } = this;
    i.get("Pick Count").incrementCount(), i.get(n).timeStart();
    const o = this.deckPicker[e]({
      layers: this.layerManager.getLayers(r),
      views: this.viewManager.getViews(),
      viewports: this.getViewports(r),
      onViewportActive: this.layerManager.activateViewport,
      effects: this.effectManager.getEffects(),
      ...r
    });
    return i.get(n).timeEnd(), o;
  }
  _createCanvas(e) {
    let n = e.canvas;
    return typeof n == "string" && (n = document.getElementById(n), sA(n)), n || (n = document.createElement("canvas"), n.id = e.id || "deckgl-overlay", (e.parent || document.body).appendChild(n)), Object.assign(n.style, e.style), n;
  }
  _setCanvasSize(e) {
    if (!this.canvas)
      return;
    const {
      width: n,
      height: r
    } = e;
    if (n || n === 0) {
      const o = Number.isFinite(n) ? "".concat(n, "px") : n;
      this.canvas.style.width = o;
    }
    if (r || r === 0) {
      var i;
      const o = Number.isFinite(r) ? "".concat(r, "px") : r;
      this.canvas.style.position = ((i = e.style) === null || i === void 0 ? void 0 : i.position) || "absolute", this.canvas.style.height = o;
    }
  }
  _updateCanvasSize() {
    const {
      canvas: e
    } = this;
    if (!e)
      return;
    const n = e.clientWidth || e.width, r = e.clientHeight || e.height;
    if (n !== this.width || r !== this.height) {
      var i;
      this.width = n, this.height = r, (i = this.viewManager) === null || i === void 0 || i.setProps({
        width: n,
        height: r
      }), this.props.onResize({
        width: n,
        height: r
      });
    }
  }
  _createAnimationLoop(e) {
    const {
      width: n,
      height: r,
      gl: i,
      glOptions: o,
      debug: s,
      onError: a,
      onBeforeRender: A,
      onAfterRender: l,
      useDevicePixels: c
    } = e;
    return new Z9e({
      width: n,
      height: r,
      useDevicePixels: c,
      autoResizeViewport: !1,
      gl: i,
      onCreateContext: (u) => mle({
        ...o,
        ...u,
        canvas: this.canvas,
        debug: s,
        onContextLost: () => this._onContextLost()
      }),
      onInitialize: (u) => this._setGLContext(u.gl),
      onRender: this._onRenderFrame.bind(this),
      onBeforeRender: A,
      onAfterRender: l,
      onError: a
    });
  }
  _getViewState() {
    return this.props.viewState || this.viewState;
  }
  _getViews() {
    let e = this.props.views || [new Jle({
      id: "default-view"
    })];
    return e = Array.isArray(e) ? e : [e], e.length && this.props.controller && (e[0].props.controller = this.props.controller), e;
  }
  _onContextLost() {
    const {
      onError: e
    } = this.props;
    this.animationLoop && e && e(new Error("WebGL context is lost"));
  }
  _pickAndCallback() {
    const {
      _pickRequest: e
    } = this;
    if (e.event) {
      const {
        result: r,
        emptyInfo: i
      } = this._pick("pickObject", "pickObject Time", e);
      this.cursorState.isHovering = r.length > 0;
      let o = i, s = !1;
      for (const a of r) {
        var n;
        o = a, s = ((n = a.layer) === null || n === void 0 ? void 0 : n.onHover(a, e.event)) || s;
      }
      if (!s && this.props.onHover && this.props.onHover(o, e.event), this.props.getTooltip && this.tooltip) {
        const a = this.props.getTooltip(o);
        this.tooltip.setTooltip(a, o.x, o.y);
      }
      e.event = null;
    }
  }
  _updateCursor() {
    const e = this.props.parent || this.canvas;
    e && (e.style.cursor = this.props.getCursor(this.cursorState));
  }
  _setGLContext(e) {
    if (this.layerManager)
      return;
    this.canvas || (this.canvas = e.canvas, Z9(e, {
      enable: !0,
      copyState: !0
    })), this.tooltip = new Ohn(this.canvas), cd(e, {
      blend: !0,
      blendFunc: [770, 771, 1, 771],
      polygonOffsetFill: !0,
      depthTest: !0,
      depthFunc: 515
    }), this.props.onWebGLInitialized(e);
    const n = new Ple();
    n.play(), this.animationLoop.attachTimeline(n), this.eventManager = new mdn(this.props.parent || e.canvas, {
      touchAction: this.props.touchAction,
      recognizerOptions: this.props.eventRecognizerOptions,
      events: {
        pointerdown: this._onPointerDown,
        pointermove: this._onPointerMove,
        pointerleave: this._onPointerMove
      }
    });
    for (const i in w_e)
      this.eventManager.on(i, this._onEvent);
    this.viewManager = new shn({
      timeline: n,
      eventManager: this.eventManager,
      onViewStateChange: this._onViewStateChange.bind(this),
      onInteractionStateChange: this._onInteractionStateChange.bind(this),
      views: this._getViews(),
      viewState: this._getViewState(),
      width: this.width,
      height: this.height
    });
    const r = this.viewManager.getViewports()[0];
    this.layerManager = new cqe(e, {
      deck: this,
      stats: this.stats,
      viewport: r,
      timeline: n
    }), this.effectManager = new bhn(), this.deckRenderer = new mqe(e), this.deckPicker = new Lhn(e), this.setProps(this.props), this._updateCanvasSize(), this.props.onLoad();
  }
  _drawLayers(e, n) {
    const {
      gl: r
    } = this.layerManager.context;
    cd(r, this.props.parameters), this.props.onBeforeRender({
      gl: r
    }), this.deckRenderer.renderLayers({
      target: this.props._framebuffer,
      layers: this.layerManager.getLayers(),
      viewports: this.viewManager.getViewports(),
      onViewportActive: this.layerManager.activateViewport,
      views: this.viewManager.getViews(),
      pass: "screen",
      redrawReason: e,
      effects: this.effectManager.getEffects(),
      ...n
    }), this.props.onAfterRender({
      gl: r
    });
  }
  _onRenderFrame(e) {
    this._getFrameStats(), this._metricsCounter++ % 60 === 0 && (this._getMetrics(), this.stats.reset(), Rr.table(4, this.metrics)(), this.props._onMetrics && this.props._onMetrics(this.metrics)), this._updateCanvasSize(), this._updateCursor(), this.tooltip.isVisible && this.viewManager.needsRedraw() && this.tooltip.setTooltip(null), this.layerManager.updateLayers(), this._pickAndCallback(), this.redraw(), this.viewManager && this.viewManager.updateViewStates();
  }
  _onViewStateChange(e) {
    const n = this.props.onViewStateChange(e) || e.viewState;
    this.viewState && (this.viewState = {
      ...this.viewState,
      [e.viewId]: n
    }, this.props.viewState || this.viewManager && this.viewManager.setProps({
      viewState: this.viewState
    }));
  }
  _onInteractionStateChange(e) {
    this.cursorState.isDragging = e.isDragging || !1, this.props.onInteractionStateChange(e);
  }
  _getFrameStats() {
    const {
      stats: e
    } = this;
    e.get("frameRate").timeEnd(), e.get("frameRate").timeStart();
    const n = this.animationLoop.stats;
    e.get("GPU Time").addTime(n.get("GPU Time").lastTiming), e.get("CPU Time").addTime(n.get("CPU Time").lastTiming);
  }
  _getMetrics() {
    const {
      metrics: e,
      stats: n
    } = this;
    e.fps = n.get("frameRate").getHz(), e.setPropsTime = n.get("setProps Time").time, e.updateAttributesTime = n.get("Update Attributes").time, e.framesRedrawn = n.get("Redraw Count").count, e.pickTime = n.get("pickObject Time").time + n.get("pickMultipleObjects Time").time + n.get("pickObjects Time").time, e.pickCount = n.get("Pick Count").count, e.gpuTime = n.get("GPU Time").time, e.cpuTime = n.get("CPU Time").time, e.gpuTimePerFrame = n.get("GPU Time").getAverageTime(), e.cpuTimePerFrame = n.get("CPU Time").getAverageTime();
    const r = sC.get("Memory Usage");
    e.bufferMemory = r.get("Buffer Memory").count, e.textureMemory = r.get("Texture Memory").count, e.renderbufferMemory = r.get("Renderbuffer Memory").count, e.gpuMemory = r.get("GPU Memory").count;
  }
}
ae(pM, "defaultProps", bqe);
ae(pM, "VERSION", qon.VERSION);
class vV {
  constructor(e, n) {
    ae(this, "opts", void 0), ae(this, "source", void 0), this.opts = n, this.source = e;
  }
  get value() {
    return this.source.value;
  }
  getValue() {
    const e = this.source.getBuffer(), n = this.getAccessor();
    if (e)
      return [e, n];
    const {
      value: r
    } = this.source, {
      size: i
    } = n;
    let o = r;
    if (r && r.length !== i) {
      o = new Float32Array(i);
      const s = n.elementOffset || 0;
      for (let a = 0; a < i; ++a)
        o[a] = r[s + a];
    }
    return o;
  }
  getAccessor() {
    return {
      ...this.source.getAccessor(),
      ...this.opts
    };
  }
}
function Edn(t) {
  switch (t) {
    case 5126:
      return Float32Array;
    case 5130:
      return Float64Array;
    case 5123:
    case 33635:
    case 32819:
    case 32820:
      return Uint16Array;
    case 5125:
      return Uint32Array;
    case 5121:
      return Uint8ClampedArray;
    case 5120:
      return Int8Array;
    case 5122:
      return Int16Array;
    case 5124:
      return Int32Array;
    default:
      throw new Error("Unknown GL type");
  }
}
function Nk(t) {
  return t.stride || t.size * t.bytesPerElement;
}
function _qe(t, e) {
  e.offset && Rr.removed("shaderAttribute.offset", "vertexOffset, elementOffset")();
  const n = Nk(t), r = e.vertexOffset !== void 0 ? e.vertexOffset : t.vertexOffset || 0, i = e.elementOffset || 0, o = r * n + i * t.bytesPerElement + (t.offset || 0);
  return {
    ...e,
    offset: o,
    stride: n
  };
}
function ydn(t, e) {
  const n = _qe(t, e);
  return {
    high: n,
    low: {
      ...n,
      offset: n.offset + t.size * 4
    }
  };
}
class vdn {
  constructor(e, n, r) {
    ae(this, "gl", void 0), ae(this, "id", void 0), ae(this, "size", void 0), ae(this, "settings", void 0), ae(this, "value", void 0), ae(this, "doublePrecision", void 0), ae(this, "_buffer", void 0), ae(this, "state", void 0), this.gl = e, this.id = n.id || "", this.size = n.size || 1;
    const i = n.logicalType || n.type, o = i === 5130;
    let {
      defaultValue: s
    } = n;
    s = Number.isFinite(s) ? [s] : s || new Array(this.size).fill(0);
    let a;
    o ? a = 5126 : !i && n.isIndexed ? a = e && Zv(e, no.ELEMENT_INDEX_UINT32) ? 5125 : 5123 : a = i || 5126;
    let A = Edn(i || a || 5126);
    this.doublePrecision = o, o && n.fp64 === !1 && (A = Float32Array), this.value = null, this.settings = {
      ...n,
      defaultType: A,
      defaultValue: s,
      logicalType: i,
      type: a,
      size: this.size,
      bytesPerElement: A.BYTES_PER_ELEMENT
    }, this.state = {
      ...r,
      externalBuffer: null,
      bufferAccessor: this.settings,
      allocatedValue: null,
      numInstances: 0,
      bounds: null,
      constant: !1
    }, this._buffer = null;
  }
  get isConstant() {
    return this.state.constant;
  }
  get buffer() {
    if (!this._buffer) {
      const {
        isIndexed: e,
        type: n
      } = this.settings;
      this._buffer = new ro(this.gl, {
        id: this.id,
        target: e ? 34963 : 34962,
        accessor: {
          type: n
        }
      });
    }
    return this._buffer;
  }
  get byteOffset() {
    const e = this.getAccessor();
    return e.vertexOffset ? e.vertexOffset * Nk(e) : 0;
  }
  get numInstances() {
    return this.state.numInstances;
  }
  set numInstances(e) {
    this.state.numInstances = e;
  }
  delete() {
    this._buffer && (this._buffer.delete(), this._buffer = null), jS.release(this.state.allocatedValue);
  }
  getShaderAttributes(e, n) {
    if (this.doublePrecision) {
      const r = {}, i = this.value instanceof Float64Array, o = ydn(this.getAccessor(), n || {});
      return r[e] = new vV(this, o.high), r["".concat(e, "64Low")] = i ? new vV(this, o.low) : new Float32Array(this.size), r;
    }
    if (n) {
      const r = _qe(this.getAccessor(), n);
      return {
        [e]: new vV(this, r)
      };
    }
    return {
      [e]: this
    };
  }
  getBuffer() {
    return this.state.constant ? null : this.state.externalBuffer || this._buffer;
  }
  getValue() {
    return this.state.constant ? this.value : [this.getBuffer(), this.getAccessor()];
  }
  getAccessor() {
    return this.state.bufferAccessor;
  }
  getBounds() {
    if (this.state.bounds)
      return this.state.bounds;
    let e = null;
    if (this.state.constant && this.value) {
      const n = Array.from(this.value);
      e = [n, n];
    } else {
      const {
        value: n,
        numInstances: r,
        size: i
      } = this, o = r * i;
      if (n && o && n.length >= o) {
        const s = new Array(i).fill(1 / 0), a = new Array(i).fill(-1 / 0);
        for (let A = 0; A < o; )
          for (let l = 0; l < i; l++) {
            const c = n[A++];
            c < s[l] && (s[l] = c), c > a[l] && (a[l] = c);
          }
        e = [s, a];
      }
    }
    return this.state.bounds = e, e;
  }
  setData(e) {
    const {
      state: n
    } = this;
    let r;
    ArrayBuffer.isView(e) ? r = {
      value: e
    } : e instanceof ro ? r = {
      buffer: e
    } : r = e;
    const i = {
      ...this.settings,
      ...r
    };
    if (n.bufferAccessor = i, n.bounds = null, r.constant) {
      let o = r.value;
      if (o = this._normalizeValue(o, [], 0), this.settings.normalized && (o = this.normalizeConstant(o)), !(!n.constant || !this._areValuesEqual(o, this.value)))
        return !1;
      n.externalBuffer = null, n.constant = !0, this.value = o;
    } else if (r.buffer) {
      const o = r.buffer;
      n.externalBuffer = o, n.constant = !1, this.value = r.value || null;
      const s = r.value instanceof Float64Array;
      i.type = r.type || o.accessor.type, i.bytesPerElement = o.accessor.BYTES_PER_ELEMENT * (s ? 2 : 1), i.stride = Nk(i);
    } else if (r.value) {
      this._checkExternalBuffer(r);
      let o = r.value;
      n.externalBuffer = null, n.constant = !1, this.value = o, i.bytesPerElement = o.BYTES_PER_ELEMENT, i.stride = Nk(i);
      const {
        buffer: s,
        byteOffset: a
      } = this;
      this.doublePrecision && o instanceof Float64Array && (o = CV(o, i));
      const A = o.byteLength + a + i.stride * 2;
      s.byteLength < A && s.reallocate(A), s.setAccessor(null), s.subData({
        data: o,
        offset: a
      }), i.type = r.type || s.accessor.type;
    }
    return !0;
  }
  updateSubBuffer(e = {}) {
    this.state.bounds = null;
    const n = this.value, {
      startOffset: r = 0,
      endOffset: i
    } = e;
    this.buffer.subData({
      data: this.doublePrecision && n instanceof Float64Array ? CV(n, {
        size: this.size,
        startIndex: r,
        endIndex: i
      }) : n.subarray(r, i),
      offset: r * n.BYTES_PER_ELEMENT + this.byteOffset
    });
  }
  allocate(e, n = !1) {
    const {
      state: r
    } = this, i = r.allocatedValue, o = jS.allocate(i, e + 1, {
      size: this.size,
      type: this.settings.defaultType,
      copy: n
    });
    this.value = o;
    const {
      buffer: s,
      byteOffset: a
    } = this;
    return s.byteLength < o.byteLength + a && (s.reallocate(o.byteLength + a), n && i && s.subData({
      data: i instanceof Float64Array ? CV(i, this) : i,
      offset: a
    })), r.allocatedValue = o, r.constant = !1, r.externalBuffer = null, r.bufferAccessor = this.settings, !0;
  }
  _checkExternalBuffer(e) {
    const {
      value: n
    } = e;
    if (!ArrayBuffer.isView(n))
      throw new Error("Attribute ".concat(this.id, " value is not TypedArray"));
    const r = this.settings.defaultType;
    let i = !1;
    if (this.doublePrecision && (i = n.BYTES_PER_ELEMENT < 4), i)
      throw new Error("Attribute ".concat(this.id, " does not support ").concat(n.constructor.name));
    !(n instanceof r) && this.settings.normalized && !("normalized" in e) && Rr.warn("Attribute ".concat(this.id, " is normalized"))();
  }
  normalizeConstant(e) {
    switch (this.settings.type) {
      case 5120:
        return new Float32Array(e).map((n) => (n + 128) / 255 * 2 - 1);
      case 5122:
        return new Float32Array(e).map((n) => (n + 32768) / 65535 * 2 - 1);
      case 5121:
        return new Float32Array(e).map((n) => n / 255);
      case 5123:
        return new Float32Array(e).map((n) => n / 65535);
      default:
        return e;
    }
  }
  _normalizeValue(e, n, r) {
    const {
      defaultValue: i,
      size: o
    } = this.settings;
    if (Number.isFinite(e))
      return n[r] = e, n;
    if (!e)
      return n[r] = i[0], n;
    switch (o) {
      case 4:
        n[r + 3] = Number.isFinite(e[3]) ? e[3] : i[3];
      case 3:
        n[r + 2] = Number.isFinite(e[2]) ? e[2] : i[2];
      case 2:
        n[r + 1] = Number.isFinite(e[1]) ? e[1] : i[1];
      case 1:
        n[r + 0] = Number.isFinite(e[0]) ? e[0] : i[0];
        break;
      default:
        let s = o;
        for (; --s >= 0; )
          n[r + s] = Number.isFinite(e[s]) ? e[s] : i[s];
    }
    return n;
  }
  _areValuesEqual(e, n) {
    if (!e || !n)
      return !1;
    const {
      size: r
    } = this;
    for (let i = 0; i < r; i++)
      if (e[i] !== n[i])
        return !1;
    return !0;
  }
}
const rSe = [], iSe = [];
function ZI(t, e = 0, n = 1 / 0) {
  let r = rSe;
  const i = {
    index: -1,
    data: t,
    target: []
  };
  return t ? typeof t[Symbol.iterator] == "function" ? r = t : t.length > 0 && (iSe.length = t.length, r = iSe) : r = rSe, (e > 0 || Number.isFinite(n)) && (r = (Array.isArray(r) ? r : Array.from(r)).slice(e, n), i.index = e - 1), {
    iterable: r,
    objectInfo: i
  };
}
function Sqe(t) {
  return t && t[Symbol.asyncIterator];
}
function Qqe(t, e) {
  const {
    size: n,
    stride: r,
    offset: i,
    startIndices: o,
    nested: s
  } = e, a = t.BYTES_PER_ELEMENT, A = r ? r / a : n, l = i ? i / a : 0, c = Math.floor((t.length - l) / A);
  return (u, {
    index: f,
    target: h
  }) => {
    if (!o) {
      const C = f * A + l;
      for (let y = 0; y < n; y++)
        h[y] = t[C + y];
      return h;
    }
    const d = o[f], I = o[f + 1] || c;
    let m;
    if (s) {
      m = new Array(I - d);
      for (let C = d; C < I; C++) {
        const y = C * A + l;
        h = new Array(n);
        for (let v = 0; v < n; v++)
          h[v] = t[y + v];
        m[C - d] = h;
      }
    } else if (A === n)
      m = t.subarray(d * n + l, I * n + l);
    else {
      m = new t.constructor((I - d) * n);
      let C = 0;
      for (let y = d; y < I; y++) {
        const v = y * A + l;
        for (let b = 0; b < n; b++)
          m[C++] = t[v + b];
      }
    }
    return m;
  };
}
const Bdn = [], Lk = [[0, 1 / 0]];
function bdn(t, e) {
  if (t === Lk || (e[0] < 0 && (e[0] = 0), e[0] >= e[1]))
    return t;
  const n = [], r = t.length;
  let i = 0;
  for (let o = 0; o < r; o++) {
    const s = t[o];
    s[1] < e[0] ? (n.push(s), i = o + 1) : s[0] > e[1] ? n.push(s) : e = [Math.min(s[0], e[0]), Math.max(s[1], e[1])];
  }
  return n.splice(i, 0, e), n;
}
function BV(t) {
  const {
    source: e,
    target: n,
    start: r = 0,
    size: i,
    getData: o
  } = t, s = t.end || n.length, a = e.length, A = s - r;
  if (a > A) {
    n.set(e.subarray(0, A), r);
    return;
  }
  if (n.set(e, r), !o)
    return;
  let l = a;
  for (; l < A; ) {
    const c = o(l, e);
    for (let u = 0; u < i; u++)
      n[r + l] = c[u] || 0, l++;
  }
}
function _dn({
  source: t,
  target: e,
  size: n,
  getData: r,
  sourceStartIndices: i,
  targetStartIndices: o
}) {
  if (!Array.isArray(o))
    return BV({
      source: t,
      target: e,
      size: n,
      getData: r
    }), e;
  let s = 0, a = 0;
  const A = r && ((c, u) => r(c + a, u)), l = Math.min(i.length, o.length);
  for (let c = 1; c < l; c++) {
    const u = i[c] * n, f = o[c] * n;
    BV({
      source: t.subarray(s, u),
      target: e,
      start: a,
      end: f,
      size: n,
      getData: A
    }), s = u, a = f;
  }
  return a < e.length && BV({
    source: [],
    target: e,
    start: a,
    size: n,
    getData: A
  }), e;
}
const Sdn = {
  interpolation: {
    duration: 0,
    easing: (t) => t
  },
  spring: {
    stiffness: 0.05,
    damping: 0.5
  }
};
function wqe(t, e) {
  if (!t)
    return null;
  Number.isFinite(t) && (t = {
    type: "interpolation",
    duration: t
  });
  const n = t.type || "interpolation";
  return {
    ...Sdn[n],
    ...e,
    ...t,
    type: n
  };
}
function xqe(t, e) {
  const n = e.getBuffer();
  return n ? [n, {
    divisor: 0,
    size: e.size,
    normalized: e.settings.normalized
  }] : e.value;
}
function Rqe(t) {
  switch (t) {
    case 1:
      return "float";
    case 2:
      return "vec2";
    case 3:
      return "vec3";
    case 4:
      return "vec4";
    default:
      throw new Error('No defined attribute type for size "'.concat(t, '"'));
  }
}
function Dqe(t) {
  t.push(t.shift());
}
function Wle(t, e) {
  const {
    doublePrecision: n,
    settings: r,
    value: i,
    size: o
  } = t, s = n && i instanceof Float64Array ? 2 : 1;
  return (r.noAlloc ? i.length : e * o) * s;
}
function Tqe({
  buffer: t,
  numInstances: e,
  attribute: n,
  fromLength: r,
  fromStartIndices: i,
  getData: o = (s) => s
}) {
  const s = n.doublePrecision && n.value instanceof Float64Array ? 2 : 1, a = n.size * s, A = n.byteOffset, l = n.startIndices, c = i && l, u = Wle(n, e), f = n.isConstant;
  if (!c && r >= u)
    return;
  const h = f ? n.value : n.getBuffer().getData({
    srcByteOffset: A
  });
  if (n.settings.normalized && !f) {
    const C = o;
    o = (y, v) => n.normalizeConstant(C(y, v));
  }
  const d = f ? (C, y) => o(h, y) : (C, y) => o(h.subarray(C, C + a), y), I = t.getData({
    length: r
  }), m = new Float32Array(u);
  _dn({
    source: I,
    target: m,
    sourceStartIndices: i,
    targetStartIndices: l,
    size: a,
    getData: d
  }), t.byteLength < m.byteLength + A && t.reallocate(m.byteLength + A), t.subData({
    data: m,
    offset: A
  });
}
class Xle extends vdn {
  constructor(e, n) {
    super(e, n, {
      startIndices: null,
      lastExternalBuffer: null,
      binaryValue: null,
      binaryAccessor: null,
      needsUpdate: !0,
      needsRedraw: !1,
      updateRanges: Lk
    }), ae(this, "constant", !1), this.settings.update = n.update || (n.accessor ? this._autoUpdater : void 0), Object.seal(this.settings), Object.seal(this.state), this._validateAttributeUpdaters();
  }
  get startIndices() {
    return this.state.startIndices;
  }
  set startIndices(e) {
    this.state.startIndices = e;
  }
  needsUpdate() {
    return this.state.needsUpdate;
  }
  needsRedraw({
    clearChangedFlags: e = !1
  } = {}) {
    const n = this.state.needsRedraw;
    return this.state.needsRedraw = n && !e, n;
  }
  getUpdateTriggers() {
    const {
      accessor: e
    } = this.settings;
    return [this.id].concat(typeof e != "function" && e || []);
  }
  supportsTransition() {
    return !!this.settings.transition;
  }
  getTransitionSetting(e) {
    if (!e || !this.supportsTransition())
      return null;
    const {
      accessor: n
    } = this.settings, r = this.settings.transition, i = Array.isArray(n) ? e[n.find((o) => e[o])] : e[n];
    return wqe(i, r);
  }
  setNeedsUpdate(e = this.id, n) {
    if (this.state.needsUpdate = this.state.needsUpdate || e, this.setNeedsRedraw(e), n) {
      const {
        startRow: r = 0,
        endRow: i = 1 / 0
      } = n;
      this.state.updateRanges = bdn(this.state.updateRanges, [r, i]);
    } else
      this.state.updateRanges = Lk;
  }
  clearNeedsUpdate() {
    this.state.needsUpdate = !1, this.state.updateRanges = Bdn;
  }
  setNeedsRedraw(e = this.id) {
    this.state.needsRedraw = this.state.needsRedraw || e;
  }
  allocate(e) {
    const {
      state: n,
      settings: r
    } = this;
    return r.noAlloc ? !1 : r.update ? (super.allocate(e, n.updateRanges !== Lk), !0) : !1;
  }
  updateBuffer({
    numInstances: e,
    data: n,
    props: r,
    context: i
  }) {
    if (!this.needsUpdate())
      return !1;
    const {
      state: {
        updateRanges: o
      },
      settings: {
        update: s,
        noAlloc: a
      }
    } = this;
    let A = !0;
    if (s) {
      for (const [l, c] of o)
        s.call(i, this, {
          data: n,
          startRow: l,
          endRow: c,
          props: r,
          numInstances: e
        });
      if (this.value)
        if (this.constant || this.buffer.byteLength < this.value.byteLength + this.byteOffset)
          this.setData({
            value: this.value,
            constant: this.constant
          }), this.constant = !1;
        else
          for (const [l, c] of o) {
            const u = Number.isFinite(l) ? this.getVertexOffset(l) : 0, f = Number.isFinite(c) ? this.getVertexOffset(c) : a || !Number.isFinite(e) ? this.value.length : e * this.size;
            super.updateSubBuffer({
              startOffset: u,
              endOffset: f
            });
          }
      this._checkAttributeArray();
    } else
      A = !1;
    return this.clearNeedsUpdate(), this.setNeedsRedraw(), A;
  }
  setConstantValue(e) {
    return e === void 0 || typeof e == "function" ? !1 : (this.setData({
      constant: !0,
      value: e
    }) && this.setNeedsRedraw(), this.clearNeedsUpdate(), !0);
  }
  setExternalBuffer(e) {
    const {
      state: n
    } = this;
    return e ? (this.clearNeedsUpdate(), n.lastExternalBuffer === e || (n.lastExternalBuffer = e, this.setNeedsRedraw(), this.setData(e)), !0) : (n.lastExternalBuffer = null, !1);
  }
  setBinaryValue(e, n = null) {
    const {
      state: r,
      settings: i
    } = this;
    if (!e)
      return r.binaryValue = null, r.binaryAccessor = null, !1;
    if (i.noAlloc)
      return !1;
    if (r.binaryValue === e)
      return this.clearNeedsUpdate(), !0;
    if (r.binaryValue = e, this.setNeedsRedraw(), i.transform || n !== this.startIndices) {
      ArrayBuffer.isView(e) && (e = {
        value: e
      });
      const s = e;
      sA(ArrayBuffer.isView(s.value), "invalid ".concat(i.accessor));
      const a = !!s.size && s.size !== this.size;
      return r.binaryAccessor = Qqe(s.value, {
        size: s.size || this.size,
        stride: s.stride,
        offset: s.offset,
        startIndices: n,
        nested: a
      }), !1;
    }
    return this.clearNeedsUpdate(), this.setData(e), !0;
  }
  getVertexOffset(e) {
    const {
      startIndices: n
    } = this;
    return (n ? e < n.length ? n[e] : this.numInstances : e) * this.size;
  }
  getShaderAttributes() {
    const e = this.settings.shaderAttributes || {
      [this.id]: null
    }, n = {};
    for (const r in e)
      Object.assign(n, super.getShaderAttributes(r, e[r]));
    return n;
  }
  _autoUpdater(e, {
    data: n,
    startRow: r,
    endRow: i,
    props: o,
    numInstances: s
  }) {
    if (e.constant)
      return;
    const {
      settings: a,
      state: A,
      value: l,
      size: c,
      startIndices: u
    } = e, {
      accessor: f,
      transform: h
    } = a, d = A.binaryAccessor || (typeof f == "function" ? f : o[f]);
    sA(typeof d == "function", 'accessor "'.concat(f, '" is not a function'));
    let I = e.getVertexOffset(r);
    const {
      iterable: m,
      objectInfo: C
    } = ZI(n, r, i);
    for (const y of m) {
      C.index++;
      let v = d(y, C);
      if (h && (v = h.call(this, v)), u) {
        const b = (C.index < u.length - 1 ? u[C.index + 1] : s) - u[C.index];
        if (v && Array.isArray(v[0])) {
          let Q = I;
          for (const w of v)
            e._normalizeValue(w, l, Q), Q += c;
        } else
          v && v.length > c ? l.set(v, I) : (e._normalizeValue(v, C.target, 0), lqe({
            target: l,
            source: C.target,
            start: I,
            count: b
          }));
        I += b * c;
      } else
        e._normalizeValue(v, l, I), I += c;
    }
  }
  _validateAttributeUpdaters() {
    const {
      settings: e
    } = this;
    if (!(e.noAlloc || typeof e.update == "function"))
      throw new Error("Attribute ".concat(this.id, " missing update or accessor"));
  }
  _checkAttributeArray() {
    const {
      value: e
    } = this, n = Math.min(4, this.size);
    if (e && e.length >= n) {
      let r = !0;
      switch (n) {
        case 4:
          r = r && Number.isFinite(e[3]);
        case 3:
          r = r && Number.isFinite(e[2]);
        case 2:
          r = r && Number.isFinite(e[1]);
        case 1:
          r = r && Number.isFinite(e[0]);
          break;
        default:
          r = !1;
      }
      if (!r)
        throw new Error("Illegal attribute generated for ".concat(this.id));
    }
  }
}
class Qdn {
  constructor({
    gl: e,
    attribute: n,
    timeline: r
  }) {
    ae(this, "gl", void 0), ae(this, "type", "interpolation"), ae(this, "attributeInTransition", void 0), ae(this, "settings", void 0), ae(this, "attribute", void 0), ae(this, "transition", void 0), ae(this, "currentStartIndices", void 0), ae(this, "currentLength", void 0), ae(this, "transform", void 0), ae(this, "buffers", void 0), this.gl = e, this.transition = new hM(r), this.attribute = n, this.attributeInTransition = new Xle(e, n.settings), this.currentStartIndices = n.startIndices, this.currentLength = 0, this.transform = xdn(e, n);
    const i = {
      byteLength: 0,
      usage: 35050
    };
    this.buffers = [new ro(e, i), new ro(e, i)];
  }
  get inProgress() {
    return this.transition.inProgress;
  }
  start(e, n) {
    if (e.duration <= 0) {
      this.transition.cancel();
      return;
    }
    this.settings = e;
    const {
      gl: r,
      buffers: i,
      attribute: o
    } = this;
    Dqe(i);
    const s = {
      numInstances: n,
      attribute: o,
      fromLength: this.currentLength,
      fromStartIndices: this.currentStartIndices,
      getData: e.enter
    };
    for (const a of i)
      Tqe({
        buffer: a,
        ...s
      });
    this.currentStartIndices = o.startIndices, this.currentLength = Wle(o, n), this.attributeInTransition.setData({
      buffer: i[1],
      value: o.value
    }), this.transition.start(e), this.transform.update({
      elementCount: Math.floor(this.currentLength / o.size),
      sourceBuffers: {
        aFrom: i[0],
        aTo: xqe(r, o)
      },
      feedbackBuffers: {
        vCurrent: i[1]
      }
    });
  }
  update() {
    const e = this.transition.update();
    if (e) {
      const {
        duration: n,
        easing: r
      } = this.settings, {
        time: i
      } = this.transition;
      let o = i / n;
      r && (o = r(o)), this.transform.run({
        uniforms: {
          time: o
        }
      });
    }
    return e;
  }
  cancel() {
    this.transition.cancel(), this.transform.delete();
    for (const e of this.buffers)
      e.delete();
    this.buffers.length = 0;
  }
}
const wdn = `
#define SHADER_NAME interpolation-transition-vertex-shader

uniform float time;
attribute ATTRIBUTE_TYPE aFrom;
attribute ATTRIBUTE_TYPE aTo;
varying ATTRIBUTE_TYPE vCurrent;

void main(void) {
  vCurrent = mix(aFrom, aTo, time);
  gl_Position = vec4(0.0);
}
`;
function xdn(t, e) {
  const n = Rqe(e.size);
  return new a$(t, {
    vs: wdn,
    defines: {
      ATTRIBUTE_TYPE: n
    },
    varyings: ["vCurrent"]
  });
}
class Rdn {
  constructor({
    gl: e,
    attribute: n,
    timeline: r
  }) {
    ae(this, "gl", void 0), ae(this, "type", "spring"), ae(this, "attributeInTransition", void 0), ae(this, "settings", void 0), ae(this, "attribute", void 0), ae(this, "transition", void 0), ae(this, "currentStartIndices", void 0), ae(this, "currentLength", void 0), ae(this, "texture", void 0), ae(this, "framebuffer", void 0), ae(this, "transform", void 0), ae(this, "buffers", void 0), this.gl = e, this.type = "spring", this.transition = new hM(r), this.attribute = n, this.attributeInTransition = new Xle(e, {
      ...n.settings,
      normalized: !1
    }), this.currentStartIndices = n.startIndices, this.currentLength = 0, this.texture = Tdn(e), this.framebuffer = Ndn(e, this.texture), this.transform = Ddn(e, n, this.framebuffer);
    const i = {
      byteLength: 0,
      usage: 35050
    };
    this.buffers = [new ro(e, i), new ro(e, i), new ro(e, i)];
  }
  get inProgress() {
    return this.transition.inProgress;
  }
  start(e, n) {
    const {
      gl: r,
      buffers: i,
      attribute: o
    } = this, s = {
      numInstances: n,
      attribute: o,
      fromLength: this.currentLength,
      fromStartIndices: this.currentStartIndices,
      getData: e.enter
    };
    for (const a of i)
      Tqe({
        buffer: a,
        ...s
      });
    this.settings = e, this.currentStartIndices = o.startIndices, this.currentLength = Wle(o, n), this.attributeInTransition.setData({
      buffer: i[1],
      value: o.value
    }), this.transition.start({
      ...e,
      duration: 1 / 0
    }), this.transform.update({
      elementCount: Math.floor(this.currentLength / o.size),
      sourceBuffers: {
        aTo: xqe(r, o)
      }
    });
  }
  update() {
    const {
      buffers: e,
      transform: n,
      framebuffer: r,
      transition: i
    } = this;
    if (!i.update())
      return !1;
    const s = this.settings;
    return n.update({
      sourceBuffers: {
        aPrev: e[0],
        aCur: e[1]
      },
      feedbackBuffers: {
        vNext: e[2]
      }
    }), n.run({
      framebuffer: r,
      discard: !1,
      clearRenderTarget: !0,
      uniforms: {
        stiffness: s.stiffness,
        damping: s.damping
      },
      parameters: {
        depthTest: !1,
        blend: !0,
        viewport: [0, 0, 1, 1],
        blendFunc: [1, 1],
        blendEquation: [32776, 32776]
      }
    }), Dqe(e), this.attributeInTransition.setData({
      buffer: e[1],
      value: this.attribute.value
    }), AM(r)[0] > 0 || i.end(), !0;
  }
  cancel() {
    this.transition.cancel(), this.transform.delete();
    for (const e of this.buffers)
      e.delete();
    this.buffers.length = 0, this.texture.delete(), this.framebuffer.delete();
  }
}
function Ddn(t, e, n) {
  const r = Rqe(e.size);
  return new a$(t, {
    framebuffer: n,
    vs: `
#define SHADER_NAME spring-transition-vertex-shader

#define EPSILON 0.00001

uniform float stiffness;
uniform float damping;
attribute ATTRIBUTE_TYPE aPrev;
attribute ATTRIBUTE_TYPE aCur;
attribute ATTRIBUTE_TYPE aTo;
varying ATTRIBUTE_TYPE vNext;
varying float vIsTransitioningFlag;

ATTRIBUTE_TYPE getNextValue(ATTRIBUTE_TYPE cur, ATTRIBUTE_TYPE prev, ATTRIBUTE_TYPE dest) {
  ATTRIBUTE_TYPE velocity = cur - prev;
  ATTRIBUTE_TYPE delta = dest - cur;
  ATTRIBUTE_TYPE spring = delta * stiffness;
  ATTRIBUTE_TYPE damper = velocity * -1.0 * damping;
  return spring + damper + velocity + cur;
}

void main(void) {
  bool isTransitioning = length(aCur - aPrev) > EPSILON || length(aTo - aCur) > EPSILON;
  vIsTransitioningFlag = isTransitioning ? 1.0 : 0.0;

  vNext = getNextValue(aCur, aPrev, aTo);
  gl_Position = vec4(0, 0, 0, 1);
  gl_PointSize = 100.0;
}
`,
    fs: `
#define SHADER_NAME spring-transition-is-transitioning-fragment-shader

varying float vIsTransitioningFlag;

void main(void) {
  if (vIsTransitioningFlag == 0.0) {
    discard;
  }
  gl_FragColor = vec4(1.0);
}`,
    defines: {
      ATTRIBUTE_TYPE: r
    },
    varyings: ["vNext"]
  });
}
function Tdn(t) {
  return new xo(t, {
    data: new Uint8Array(4),
    format: 6408,
    type: 5121,
    border: 0,
    mipmaps: !1,
    dataFormat: 6408,
    width: 1,
    height: 1
  });
}
function Ndn(t, e) {
  return new Da(t, {
    id: "spring-transition-is-transitioning-framebuffer",
    width: 1,
    height: 1,
    attachments: {
      [36064]: e
    }
  });
}
const Ldn = {
  interpolation: Qdn,
  spring: Rdn
};
class Mdn {
  constructor(e, {
    id: n,
    timeline: r
  }) {
    ae(this, "id", void 0), ae(this, "isSupported", void 0), ae(this, "gl", void 0), ae(this, "timeline", void 0), ae(this, "transitions", void 0), ae(this, "needsRedraw", void 0), ae(this, "numInstances", void 0), this.id = n, this.gl = e, this.timeline = r, this.transitions = {}, this.needsRedraw = !1, this.numInstances = 1, this.isSupported = a$.isSupported(e);
  }
  finalize() {
    for (const e in this.transitions)
      this._removeTransition(e);
  }
  update({
    attributes: e,
    transitions: n,
    numInstances: r
  }) {
    this.numInstances = r || 1;
    for (const i in e) {
      const o = e[i], s = o.getTransitionSetting(n);
      s && this._updateAttribute(i, o, s);
    }
    for (const i in this.transitions) {
      const o = e[i];
      (!o || !o.getTransitionSetting(n)) && this._removeTransition(i);
    }
  }
  hasAttribute(e) {
    const n = this.transitions[e];
    return n && n.inProgress;
  }
  getAttributes() {
    const e = {};
    for (const n in this.transitions) {
      const r = this.transitions[n];
      r.inProgress && (e[n] = r.attributeInTransition);
    }
    return e;
  }
  run() {
    if (!this.isSupported || this.numInstances === 0)
      return !1;
    for (const n in this.transitions)
      this.transitions[n].update() && (this.needsRedraw = !0);
    const e = this.needsRedraw;
    return this.needsRedraw = !1, e;
  }
  _removeTransition(e) {
    this.transitions[e].cancel(), delete this.transitions[e];
  }
  _updateAttribute(e, n, r) {
    const i = this.transitions[e];
    let o = !i || i.type !== r.type;
    if (o) {
      if (!this.isSupported) {
        Rr.warn("WebGL2 not supported by this browser. Transition for ".concat(e, " is disabled."))();
        return;
      }
      i && this._removeTransition(e);
      const s = Ldn[r.type];
      s ? this.transitions[e] = new s({
        attribute: n,
        timeline: this.timeline,
        gl: this.gl
      }) : (Rr.error("unsupported transition type '".concat(r.type, "'"))(), o = !1);
    }
    (o || n.needsRedraw()) && (this.needsRedraw = !0, this.transitions[e].start(r, this.numInstances));
  }
}
const oSe = "attributeManager.invalidate", Odn = "attributeManager.updateStart", Fdn = "attributeManager.updateEnd", Pdn = "attribute.updateStart", kdn = "attribute.allocate", Gdn = "attribute.updateEnd";
class Nqe {
  constructor(e, {
    id: n = "attribute-manager",
    stats: r,
    timeline: i
  } = {}) {
    ae(this, "id", void 0), ae(this, "gl", void 0), ae(this, "attributes", void 0), ae(this, "updateTriggers", void 0), ae(this, "needsRedraw", void 0), ae(this, "userData", void 0), ae(this, "stats", void 0), ae(this, "attributeTransitionManager", void 0), this.id = n, this.gl = e, this.attributes = {}, this.updateTriggers = {}, this.needsRedraw = !0, this.userData = {}, this.stats = r, this.attributeTransitionManager = new Mdn(e, {
      id: "".concat(n, "-transitions"),
      timeline: i
    }), Object.seal(this);
  }
  finalize() {
    for (const e in this.attributes)
      this.attributes[e].delete();
    this.attributeTransitionManager.finalize();
  }
  getNeedsRedraw(e = {
    clearRedrawFlags: !1
  }) {
    const n = this.needsRedraw;
    return this.needsRedraw = this.needsRedraw && !e.clearRedrawFlags, n && this.id;
  }
  setNeedsRedraw() {
    this.needsRedraw = !0;
  }
  add(e) {
    this._add(e);
  }
  addInstanced(e) {
    this._add(e, {
      instanced: 1
    });
  }
  remove(e) {
    for (const n of e)
      this.attributes[n] !== void 0 && (this.attributes[n].delete(), delete this.attributes[n]);
  }
  invalidate(e, n) {
    const r = this._invalidateTrigger(e, n);
    Ul(oSe, this, e, r);
  }
  invalidateAll(e) {
    for (const n in this.attributes)
      this.attributes[n].setNeedsUpdate(n, e);
    Ul(oSe, this, "all");
  }
  update({
    data: e,
    numInstances: n,
    startIndices: r = null,
    transitions: i,
    props: o = {},
    buffers: s = {},
    context: a = {}
  }) {
    let A = !1;
    Ul(Odn, this), this.stats && this.stats.get("Update Attributes").timeStart();
    for (const l in this.attributes) {
      const c = this.attributes[l], u = c.settings.accessor;
      c.startIndices = r, c.numInstances = n, o[l] && Rr.removed("props.".concat(l), "data.attributes.".concat(l))(), c.setExternalBuffer(s[l]) || c.setBinaryValue(typeof u == "string" ? s[u] : void 0, e.startIndices) || typeof u == "string" && !s[u] && c.setConstantValue(o[u]) || c.needsUpdate() && (A = !0, this._updateAttribute({
        attribute: c,
        numInstances: n,
        data: e,
        props: o,
        context: a
      })), this.needsRedraw = this.needsRedraw || c.needsRedraw();
    }
    A && Ul(Fdn, this, n), this.stats && this.stats.get("Update Attributes").timeEnd(), this.attributeTransitionManager.update({
      attributes: this.attributes,
      numInstances: n,
      transitions: i
    });
  }
  updateTransition() {
    const {
      attributeTransitionManager: e
    } = this, n = e.run();
    return this.needsRedraw = this.needsRedraw || n, n;
  }
  getAttributes() {
    return this.attributes;
  }
  getChangedAttributes(e = {
    clearChangedFlags: !1
  }) {
    const {
      attributes: n,
      attributeTransitionManager: r
    } = this, i = {
      ...r.getAttributes()
    };
    for (const o in n) {
      const s = n[o];
      s.needsRedraw(e) && !r.hasAttribute(o) && (i[o] = s);
    }
    return i;
  }
  getShaderAttributes(e, n = {}) {
    e || (e = this.getAttributes());
    const r = {};
    for (const i in e)
      n[i] || Object.assign(r, e[i].getShaderAttributes());
    return r;
  }
  _add(e, n = {}) {
    for (const r in e) {
      const i = e[r];
      this.attributes[r] = this._createAttribute(r, i, n);
    }
    this._mapUpdateTriggersToAttributes();
  }
  _createAttribute(e, n, r) {
    const i = {
      ...n,
      id: e,
      size: n.isIndexed && 1 || n.size || 1,
      divisor: r.instanced ? 1 : n.divisor || 0
    };
    return new Xle(this.gl, i);
  }
  _mapUpdateTriggersToAttributes() {
    const e = {};
    for (const n in this.attributes)
      this.attributes[n].getUpdateTriggers().forEach((i) => {
        e[i] || (e[i] = []), e[i].push(n);
      });
    this.updateTriggers = e;
  }
  _invalidateTrigger(e, n) {
    const {
      attributes: r,
      updateTriggers: i
    } = this, o = i[e];
    return o && o.forEach((s) => {
      const a = r[s];
      a && a.setNeedsUpdate(a.id, n);
    }), o;
  }
  _updateAttribute(e) {
    const {
      attribute: n,
      numInstances: r
    } = e;
    if (Ul(Pdn, n), n.constant) {
      n.setConstantValue(n.value);
      return;
    }
    n.allocate(r) && Ul(kdn, n, r), n.updateBuffer(e) && (this.needsRedraw = !0, Ul(Gdn, n, r));
  }
}
class Udn extends hM {
  get value() {
    return this._value;
  }
  _onUpdate() {
    const {
      time: e,
      settings: {
        fromValue: n,
        toValue: r,
        duration: i,
        easing: o
      }
    } = this, s = o(e / i);
    this._value = Lf(n, r, s);
  }
}
const sSe = 1e-5;
function aSe(t, e, n, r, i) {
  const o = e - t, a = (n - e) * i, A = -o * r;
  return a + A + o + e;
}
function Hdn(t, e, n, r, i) {
  if (Array.isArray(n)) {
    const o = [];
    for (let s = 0; s < n.length; s++)
      o[s] = aSe(t[s], e[s], n[s], r, i);
    return o;
  }
  return aSe(t, e, n, r, i);
}
function ASe(t, e) {
  if (Array.isArray(t)) {
    let n = 0;
    for (let r = 0; r < t.length; r++) {
      const i = t[r] - e[r];
      n += i * i;
    }
    return Math.sqrt(n);
  }
  return Math.abs(t - e);
}
class $dn extends hM {
  get value() {
    return this._currValue;
  }
  _onUpdate() {
    const {
      fromValue: e,
      toValue: n,
      damping: r,
      stiffness: i
    } = this.settings, {
      _prevValue: o = e,
      _currValue: s = e
    } = this;
    let a = Hdn(o, s, n, r, i);
    const A = ASe(a, n), l = ASe(a, s);
    A < sSe && l < sSe && (a = n, this.end()), this._prevValue = s, this._currValue = a;
  }
}
const qdn = {
  interpolation: Udn,
  spring: $dn
};
class jdn {
  constructor(e) {
    this.transitions = /* @__PURE__ */ new Map(), this.timeline = e;
  }
  get active() {
    return this.transitions.size > 0;
  }
  add(e, n, r, i) {
    const {
      transitions: o
    } = this;
    if (o.has(e)) {
      const A = o.get(e), {
        value: l = A.settings.fromValue
      } = A;
      n = l, this.remove(e);
    }
    if (i = wqe(i), !i)
      return;
    const s = qdn[i.type];
    if (!s) {
      Rr.error("unsupported transition type '".concat(i.type, "'"))();
      return;
    }
    const a = new s(this.timeline);
    a.start({
      ...i,
      fromValue: n,
      toValue: r
    }), o.set(e, a);
  }
  remove(e) {
    const {
      transitions: n
    } = this;
    n.has(e) && (n.get(e).cancel(), n.delete(e));
  }
  update() {
    const e = {};
    for (const [n, r] of this.transitions)
      r.update(), e[n] = r.value, r.inProgress || this.remove(n);
    return e;
  }
  clear() {
    for (const e of this.transitions.keys())
      this.remove(e);
  }
}
function Ydn(t) {
  const e = ece(t);
  for (const n in e) {
    const r = e[n], {
      validate: i
    } = r;
    if (i && !i(t[n], r))
      throw new Error("Invalid prop ".concat(n, ": ").concat(t[n]));
  }
}
function zdn(t, e) {
  const n = Zle({
    newProps: t,
    oldProps: e,
    propTypes: ece(t),
    ignoreProps: {
      data: null,
      updateTriggers: null,
      extensions: null,
      transitions: null
    }
  }), r = Jdn(t, e);
  let i = !1;
  return r || (i = Kdn(t, e)), {
    dataChanged: r,
    propsChanged: n,
    updateTriggersChanged: i,
    extensionsChanged: Wdn(t, e),
    transitionsChanged: Vdn(t, e)
  };
}
function Vdn(t, e) {
  if (!t.transitions)
    return !1;
  const n = {}, r = ece(t);
  let i = !1;
  for (const o in t.transitions) {
    const s = r[o], a = s && s.type;
    (a === "number" || a === "color" || a === "array") && Xee(t[o], e[o], s) && (n[o] = !0, i = !0);
  }
  return i ? n : !1;
}
function Zle({
  newProps: t,
  oldProps: e,
  ignoreProps: n = {},
  propTypes: r = {},
  triggerName: i = "props"
}) {
  if (e === t)
    return !1;
  if (typeof t != "object" || t === null || typeof e != "object" || e === null)
    return "".concat(i, " changed shallowly");
  for (const o of Object.keys(t))
    if (!(o in n)) {
      if (!(o in e))
        return "".concat(i, ".").concat(o, " added");
      const s = Xee(t[o], e[o], r[o]);
      if (s)
        return "".concat(i, ".").concat(o, " ").concat(s);
    }
  for (const o of Object.keys(e))
    if (!(o in n)) {
      if (!(o in t))
        return "".concat(i, ".").concat(o, " dropped");
      if (!Object.hasOwnProperty.call(t, o)) {
        const s = Xee(t[o], e[o], r[o]);
        if (s)
          return "".concat(i, ".").concat(o, " ").concat(s);
      }
    }
  return !1;
}
function Xee(t, e, n) {
  let r = n && n.equal;
  return r && !r(t, e, n) || !r && (r = t && e && t.equals, r && !r.call(t, e)) ? "changed deeply" : !r && e !== t ? "changed shallowly" : null;
}
function Jdn(t, e) {
  if (e === null)
    return "oldProps is null, initial diff";
  let n = !1;
  const {
    dataComparator: r,
    _dataDiff: i
  } = t;
  return r ? r(t.data, e.data) || (n = "Data comparator detected a change") : t.data !== e.data && (n = "A new data container was supplied"), n && i && (n = i(t.data, e.data) || n), n;
}
function Kdn(t, e) {
  if (e === null)
    return {
      all: !0
    };
  if ("all" in t.updateTriggers && lSe(t, e, "all"))
    return {
      all: !0
    };
  const n = {};
  let r = !1;
  for (const i in t.updateTriggers)
    i !== "all" && lSe(t, e, i) && (n[i] = !0, r = !0);
  return r ? n : !1;
}
function Wdn(t, e) {
  if (e === null)
    return !0;
  const n = e.extensions, {
    extensions: r
  } = t;
  if (r === n)
    return !1;
  if (!n || !r || r.length !== n.length)
    return !0;
  for (let i = 0; i < r.length; i++)
    if (!r[i].equals(n[i]))
      return !0;
  return !1;
}
function lSe(t, e, n) {
  let r = t.updateTriggers[n];
  r = r ?? {};
  let i = e.updateTriggers[n];
  return i = i ?? {}, Zle({
    oldProps: i,
    newProps: r,
    triggerName: n
  });
}
function ece(t) {
  const e = t[QU], n = e && e.constructor;
  return n ? n._propTypes : {};
}
const Xdn = "count(): argument not an object", Zdn = "count(): argument not a container";
function Lqe(t) {
  if (!tpn(t))
    throw new Error(Xdn);
  if (typeof t.count == "function")
    return t.count();
  if (Number.isFinite(t.size))
    return t.size;
  if (Number.isFinite(t.length))
    return t.length;
  if (epn(t))
    return Object.keys(t).length;
  throw new Error(Zdn);
}
function epn(t) {
  return t !== null && typeof t == "object" && t.constructor === Object;
}
function tpn(t) {
  return t !== null && typeof t == "object";
}
function f$(t, e) {
  if (!e)
    return t;
  const n = {
    ...t,
    ...e
  };
  if ("defines" in e && (n.defines = {
    ...t.defines,
    ...e.defines
  }), "modules" in e && (n.modules = (t.modules || []).concat(e.modules), e.modules.some((r) => r.name === "project64"))) {
    const r = n.modules.findIndex((i) => i.name === "project32");
    r >= 0 && n.modules.splice(r, 1);
  }
  if ("inject" in e)
    if (!t.inject)
      n.inject = e.inject;
    else {
      const r = {
        ...t.inject
      };
      for (const i in e.inject)
        r[i] = (r[i] || "") + e.inject[i];
      n.inject = r;
    }
  return n;
}
const npn = {
  [10241]: 9987,
  [10240]: 9729,
  [10242]: 33071,
  [10243]: 33071
}, Zee = {};
function rpn(t, e) {
  const n = t.context && t.context.gl;
  if (!n || !e)
    return null;
  if (e instanceof xo)
    return e;
  e.constructor && e.constructor.name !== "Object" && (e = {
    data: e
  });
  let r = null;
  e.compressed && (r = {
    [10241]: e.data.length > 1 ? 9985 : 9729
  });
  const i = new xo(n, {
    ...e,
    parameters: {
      ...npn,
      ...r,
      ...t.props.textureParameters
    }
  });
  return Zee[i.id] = !0, i;
}
function ipn(t) {
  !t || !(t instanceof xo) || Zee[t.id] && (t.delete(), delete Zee[t.id]);
}
const opn = {
  boolean: {
    validate(t, e) {
      return !0;
    },
    equal(t, e, n) {
      return !!t == !!e;
    }
  },
  number: {
    validate(t, e) {
      return Number.isFinite(t) && (!("max" in e) || t <= e.max) && (!("min" in e) || t >= e.min);
    }
  },
  color: {
    validate(t, e) {
      return e.optional && !t || kT(t) && (t.length === 3 || t.length === 4);
    },
    equal(t, e, n) {
      return bV(t, e);
    }
  },
  accessor: {
    validate(t, e) {
      const n = RU(t);
      return n === "function" || n === RU(e.value);
    },
    equal(t, e, n) {
      return typeof e == "function" ? !0 : bV(t, e);
    }
  },
  array: {
    validate(t, e) {
      return e.optional && !t || kT(t);
    },
    equal(t, e, n) {
      return n.compare ? bV(t, e) : t === e;
    }
  },
  object: {
    equal(t, e, n) {
      return n.compare ? t1(t, e) : t === e;
    }
  },
  function: {
    validate(t, e) {
      return e.optional && !t || typeof t == "function";
    },
    equal(t, e, n) {
      return !n.compare || t === e;
    }
  },
  data: {
    transform: (t, e, n) => {
      const {
        dataTransform: r
      } = n.props;
      return r && t ? r(t) : t;
    }
  },
  image: {
    transform: (t, e, n) => rpn(n, t),
    release: (t) => {
      ipn(t);
    }
  }
};
function bV(t, e) {
  if (t === e)
    return !0;
  if (!kT(t) || !kT(e))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function spn(t) {
  const e = {}, n = {}, r = {};
  for (const [i, o] of Object.entries(t)) {
    const s = o?.deprecatedFor;
    if (s)
      r[i] = Array.isArray(s) ? s : [s];
    else {
      const a = apn(i, o);
      e[i] = a, n[i] = a.value;
    }
  }
  return {
    propTypes: e,
    defaultProps: n,
    deprecatedProps: r
  };
}
function apn(t, e) {
  switch (RU(e)) {
    case "object":
      return l2(t, e);
    case "array":
      return l2(t, {
        type: "array",
        value: e,
        compare: !1
      });
    case "boolean":
      return l2(t, {
        type: "boolean",
        value: e
      });
    case "number":
      return l2(t, {
        type: "number",
        value: e
      });
    case "function":
      return l2(t, {
        type: "function",
        value: e,
        compare: !0
      });
    default:
      return {
        name: t,
        type: "unknown",
        value: e
      };
  }
}
function l2(t, e) {
  return "type" in e ? {
    name: t,
    ...opn[e.type],
    ...e
  } : "value" in e ? {
    name: t,
    type: RU(e.value),
    ...e
  } : {
    name: t,
    type: "object",
    value: e
  };
}
function kT(t) {
  return Array.isArray(t) || ArrayBuffer.isView(t);
}
function RU(t) {
  return kT(t) ? "array" : t === null ? "null" : typeof t;
}
function Apn(t, e) {
  const n = Mqe(t.constructor), r = Object.create(n);
  r[QU] = t, r[rB] = {}, r[aC] = {};
  for (let i = 0; i < e.length; ++i) {
    const o = e[i];
    for (const s in o)
      r[s] = o[s];
  }
  return Object.freeze(r), r;
}
function Mqe(t) {
  const e = DU(t, "_mergedDefaultProps");
  return e || (lpn(t), t._mergedDefaultProps);
}
function lpn(t) {
  if (!t.prototype)
    return;
  const n = Object.getPrototypeOf(t), r = Mqe(n), i = DU(t, "defaultProps") || {}, o = spn(i), s = cpn(o.defaultProps, r, t), a = {
    ...n._propTypes,
    ...o.propTypes
  };
  fpn(s, a);
  const A = {
    ...n._deprecatedProps,
    ...o.deprecatedProps
  };
  upn(s, A), t._mergedDefaultProps = s, t._propTypes = a, t._deprecatedProps = A;
}
function cpn(t, e, n) {
  const r = /* @__PURE__ */ Object.create(null);
  Object.assign(r, e, t);
  const i = hpn(n);
  return delete t.id, Object.defineProperties(r, {
    id: {
      writable: !0,
      value: i
    }
  }), r;
}
function upn(t, e) {
  for (const n in e)
    Object.defineProperty(t, n, {
      enumerable: !1,
      set(r) {
        const i = "".concat(this.id, ": ").concat(n);
        for (const o of e[n])
          Oqe(this, o) || (this[o] = r);
        Rr.deprecated(i, e[n].join("/"))();
      }
    });
}
function fpn(t, e) {
  const n = {}, r = {};
  for (const i in e) {
    const o = e[i], {
      name: s,
      value: a
    } = o;
    o.async && (n[s] = a, r[s] = gpn(s));
  }
  t[$_] = n, t[rB] = {}, Object.defineProperties(t, r);
}
function gpn(t) {
  return {
    enumerable: !0,
    set(e) {
      typeof e == "string" || e instanceof Promise || Sqe(e) ? this[rB][t] = e : this[aC][t] = e;
    },
    get() {
      if (this[aC]) {
        if (t in this[aC])
          return this[aC][t] || this[$_][t];
        if (t in this[rB]) {
          const e = this[QU] && this[QU].internalState;
          if (e && e.hasAsyncProp(t))
            return e.getAsyncProp(t) || this[$_][t];
        }
      }
      return this[$_][t];
    }
  };
}
function Oqe(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function DU(t, e) {
  return Oqe(t, e) && t[e];
}
function hpn(t) {
  const e = DU(t, "layerName") || DU(t, "componentName");
  return e || Rr.once(0, "".concat(t.name, ".componentName not specified"))(), e || t.name;
}
let dpn = 0;
class tce {
  constructor(...e) {
    ae(this, "id", void 0), ae(this, "props", void 0), ae(this, "count", void 0), this.props = Apn(this, e), this.id = this.props.id, this.count = dpn++;
  }
  clone(e) {
    const {
      props: n
    } = this, r = {};
    for (const i in n[$_])
      i in n[aC] ? r[i] = n[aC][i] : i in n[rB] && (r[i] = n[rB][i]);
    return new this.constructor({
      ...n,
      ...r,
      ...e
    });
  }
}
ae(tce, "componentName", "Component");
ae(tce, "defaultProps", {});
const ppn = Object.freeze({});
class Ipn {
  constructor(e) {
    ae(this, "component", void 0), ae(this, "onAsyncPropUpdated", void 0), ae(this, "asyncProps", void 0), ae(this, "oldProps", void 0), ae(this, "oldAsyncProps", void 0), this.component = e, this.asyncProps = {}, this.onAsyncPropUpdated = () => {
    }, this.oldProps = null, this.oldAsyncProps = null;
  }
  finalize() {
    for (const e in this.asyncProps) {
      const n = this.asyncProps[e];
      n && n.type && n.type.release && n.type.release(n.resolvedValue, n.type, this.component);
    }
  }
  getOldProps() {
    return this.oldAsyncProps || this.oldProps || ppn;
  }
  resetOldProps() {
    this.oldAsyncProps = null, this.oldProps = this.component.props;
  }
  hasAsyncProp(e) {
    return e in this.asyncProps;
  }
  getAsyncProp(e) {
    const n = this.asyncProps[e];
    return n && n.resolvedValue;
  }
  isAsyncPropLoading(e) {
    if (e) {
      const n = this.asyncProps[e];
      return !!(n && n.pendingLoadCount > 0 && n.pendingLoadCount !== n.resolvedLoadCount);
    }
    for (const n in this.asyncProps)
      if (this.isAsyncPropLoading(n))
        return !0;
    return !1;
  }
  reloadAsyncProp(e, n) {
    this._watchPromise(e, Promise.resolve(n));
  }
  setAsyncProps(e) {
    const n = e[aC] || {}, r = e[rB] || e, i = e[$_] || {};
    for (const o in n) {
      const s = n[o];
      this._createAsyncPropData(o, i[o]), this._updateAsyncProp(o, s), n[o] = this.getAsyncProp(o);
    }
    for (const o in r) {
      const s = r[o];
      this._createAsyncPropData(o, i[o]), this._updateAsyncProp(o, s);
    }
  }
  _fetch(e, n) {
    return null;
  }
  _onResolve(e, n) {
  }
  _onError(e, n) {
  }
  _updateAsyncProp(e, n) {
    if (this._didAsyncInputValueChange(e, n)) {
      if (typeof n == "string" && (n = this._fetch(e, n)), n instanceof Promise) {
        this._watchPromise(e, n);
        return;
      }
      if (Sqe(n)) {
        this._resolveAsyncIterable(e, n);
        return;
      }
      this._setPropValue(e, n);
    }
  }
  _freezeAsyncOldProps() {
    if (!this.oldAsyncProps && this.oldProps) {
      this.oldAsyncProps = Object.create(this.oldProps);
      for (const e in this.asyncProps)
        Object.defineProperty(this.oldAsyncProps, e, {
          enumerable: !0,
          value: this.oldProps[e]
        });
    }
  }
  _didAsyncInputValueChange(e, n) {
    const r = this.asyncProps[e];
    return n === r.resolvedValue || n === r.lastValue ? !1 : (r.lastValue = n, !0);
  }
  _setPropValue(e, n) {
    this._freezeAsyncOldProps();
    const r = this.asyncProps[e];
    r && (n = this._postProcessValue(r, n), r.resolvedValue = n, r.pendingLoadCount++, r.resolvedLoadCount = r.pendingLoadCount);
  }
  _setAsyncPropValue(e, n, r) {
    const i = this.asyncProps[e];
    i && r >= i.resolvedLoadCount && n !== void 0 && (this._freezeAsyncOldProps(), i.resolvedValue = n, i.resolvedLoadCount = r, this.onAsyncPropUpdated(e, n));
  }
  _watchPromise(e, n) {
    const r = this.asyncProps[e];
    if (r) {
      r.pendingLoadCount++;
      const i = r.pendingLoadCount;
      n.then((o) => {
        o = this._postProcessValue(r, o), this._setAsyncPropValue(e, o, i), this._onResolve(e, o);
      }).catch((o) => {
        this._onError(e, o);
      });
    }
  }
  async _resolveAsyncIterable(e, n) {
    if (e !== "data") {
      this._setPropValue(e, n);
      return;
    }
    const r = this.asyncProps[e];
    if (!r)
      return;
    r.pendingLoadCount++;
    const i = r.pendingLoadCount;
    let o = [], s = 0;
    for await (const a of n) {
      const {
        dataTransform: A
      } = this.component.props;
      A ? o = A(a, o) : o = o.concat(a), Object.defineProperty(o, "__diff", {
        enumerable: !1,
        value: [{
          startRow: s,
          endRow: o.length
        }]
      }), s = o.length, this._setAsyncPropValue(e, o, i);
    }
    this._onResolve(e, o);
  }
  _postProcessValue(e, n) {
    const r = e.type;
    return r && (r.release && r.release(e.resolvedValue, r, this.component), r.transform) ? r.transform(n, r, this.component) : n;
  }
  _createAsyncPropData(e, n) {
    if (!this.asyncProps[e]) {
      const i = this.component && this.component.constructor._propTypes;
      this.asyncProps[e] = {
        type: i && i[e],
        lastValue: null,
        resolvedValue: n,
        pendingLoadCount: 0,
        resolvedLoadCount: 0
      };
    }
  }
}
class mpn extends Ipn {
  constructor({
    attributeManager: e,
    layer: n
  }) {
    super(n), ae(this, "attributeManager", void 0), ae(this, "needsRedraw", void 0), ae(this, "needsUpdate", void 0), ae(this, "subLayers", void 0), ae(this, "usesPickingColorCache", void 0), ae(this, "changeFlags", void 0), ae(this, "viewport", void 0), ae(this, "uniformTransitions", void 0), ae(this, "propsInTransition", void 0), this.attributeManager = e, this.needsRedraw = !0, this.needsUpdate = !0, this.subLayers = null, this.usesPickingColorCache = !1;
  }
  get layer() {
    return this.component;
  }
  set layer(e) {
    this.component = e;
  }
  _fetch(e, n) {
    const r = this.component.props.fetch;
    return r ? r(n, {
      propName: e,
      layer: this.layer
    }) : super._fetch(e, n);
  }
  _onResolve(e, n) {
    const r = this.component.props.onDataLoad;
    e === "data" && r && r(n, {
      propName: e,
      layer: this.layer
    });
  }
  _onError(e, n) {
    this.layer.raiseError(n, "loading ".concat(e, " of ").concat(this.layer));
  }
}
const Cpn = "layer.changeFlag", Epn = "layer.initialize", ypn = "layer.update", vpn = "layer.finalize", Bpn = "layer.matched", cSe = 2 ** 24 - 1, bpn = Object.freeze([]), _pn = Lw(({
  oldViewport: t,
  viewport: e
}) => t.equals(e));
let Jd = new Uint8ClampedArray(0);
const Spn = {
  data: {
    type: "data",
    value: bpn,
    async: !0
  },
  dataComparator: {
    type: "function",
    value: null,
    compare: !1,
    optional: !0
  },
  _dataDiff: {
    type: "function",
    value: (t) => t && t.__diff,
    compare: !1,
    optional: !0
  },
  dataTransform: {
    type: "function",
    value: null,
    compare: !1,
    optional: !0
  },
  onDataLoad: {
    type: "function",
    value: null,
    compare: !1,
    optional: !0
  },
  onError: {
    type: "function",
    value: null,
    compare: !1,
    optional: !0
  },
  fetch: {
    type: "function",
    value: (t, {
      propName: e,
      layer: n,
      loaders: r,
      loadOptions: i,
      signal: o
    }) => {
      const {
        resourceManager: s
      } = n.context;
      if (i = i || n.getLoadOptions(), r = r || n.props.loaders, o) {
        var a;
        i = {
          ...i,
          fetch: {
            ...(a = i) === null || a === void 0 ? void 0 : a.fetch,
            signal: o
          }
        };
      }
      let A = s.contains(t);
      return !A && !i && (s.add({
        resourceId: t,
        data: TI(t, r),
        persistent: !1
      }), A = !0), A ? s.subscribe({
        resourceId: t,
        onChange: (l) => {
          var c;
          return (c = n.internalState) === null || c === void 0 ? void 0 : c.reloadAsyncProp(e, l);
        },
        consumerId: n.id,
        requestId: e
      }) : TI(t, r, i);
    },
    compare: !1
  },
  updateTriggers: {},
  visible: !0,
  pickable: !1,
  opacity: {
    type: "number",
    min: 0,
    max: 1,
    value: 1
  },
  operation: Nw.DRAW,
  onHover: {
    type: "function",
    value: null,
    compare: !1,
    optional: !0
  },
  onClick: {
    type: "function",
    value: null,
    compare: !1,
    optional: !0
  },
  onDragStart: {
    type: "function",
    value: null,
    compare: !1,
    optional: !0
  },
  onDrag: {
    type: "function",
    value: null,
    compare: !1,
    optional: !0
  },
  onDragEnd: {
    type: "function",
    value: null,
    compare: !1,
    optional: !0
  },
  coordinateSystem: wn.DEFAULT,
  coordinateOrigin: {
    type: "array",
    value: [0, 0, 0],
    compare: !0
  },
  modelMatrix: {
    type: "array",
    value: null,
    compare: !0,
    optional: !0
  },
  wrapLongitude: !1,
  positionFormat: "XYZ",
  colorFormat: "RGBA",
  parameters: {
    type: "object",
    value: {},
    optional: !0,
    compare: !0
  },
  transitions: null,
  extensions: [],
  loaders: {
    type: "array",
    value: [],
    optional: !0,
    compare: !0
  },
  getPolygonOffset: {
    type: "function",
    value: ({
      layerIndex: t
    }) => [0, -t * 100],
    compare: !1
  },
  highlightedObjectIndex: null,
  autoHighlight: !1,
  highlightColor: {
    type: "accessor",
    value: [0, 0, 128, 128]
  }
};
class IA extends tce {
  constructor(...e) {
    super(...e), ae(this, "internalState", null), ae(this, "lifecycle", Vb.NO_STATE), ae(this, "context", void 0), ae(this, "state", void 0), ae(this, "parent", null);
  }
  get root() {
    let e = this;
    for (; e.parent; )
      e = e.parent;
    return e;
  }
  toString() {
    const e = this.constructor.layerName || this.constructor.name;
    return "".concat(e, "({id: '").concat(this.props.id, "'})");
  }
  project(e) {
    sA(this.internalState);
    const n = this.internalState.viewport || this.context.viewport, r = oqe(e, {
      viewport: n,
      modelMatrix: this.props.modelMatrix,
      coordinateOrigin: this.props.coordinateOrigin,
      coordinateSystem: this.props.coordinateSystem
    }), [i, o, s] = l$(r, n.pixelProjectionMatrix);
    return e.length === 2 ? [i, o] : [i, o, s];
  }
  unproject(e) {
    return sA(this.internalState), (this.internalState.viewport || this.context.viewport).unproject(e);
  }
  projectPosition(e, n) {
    sA(this.internalState);
    const r = this.internalState.viewport || this.context.viewport;
    return sqe(e, {
      viewport: r,
      modelMatrix: this.props.modelMatrix,
      coordinateOrigin: this.props.coordinateOrigin,
      coordinateSystem: this.props.coordinateSystem,
      ...n
    });
  }
  get isComposite() {
    return !1;
  }
  setState(e) {
    this.setChangeFlags({
      stateChanged: !0
    }), Object.assign(this.state, e), this.setNeedsRedraw();
  }
  setNeedsRedraw() {
    this.internalState && (this.internalState.needsRedraw = !0);
  }
  setNeedsUpdate() {
    this.internalState && (this.context.layerManager.setNeedsUpdate(String(this)), this.internalState.needsUpdate = !0);
  }
  get isLoaded() {
    return this.internalState ? !this.internalState.isAsyncPropLoading() : !1;
  }
  get wrapLongitude() {
    return this.props.wrapLongitude;
  }
  isPickable() {
    return this.props.pickable && this.props.visible;
  }
  getModels() {
    return this.state && (this.state.models || this.state.model && [this.state.model]) || [];
  }
  setModuleParameters(e) {
    for (const n of this.getModels())
      n.updateModuleSettings(e);
  }
  getAttributeManager() {
    return this.internalState && this.internalState.attributeManager;
  }
  getCurrentLayer() {
    return this.internalState && this.internalState.layer;
  }
  getLoadOptions() {
    return this.props.loadOptions;
  }
  use64bitPositions() {
    const {
      coordinateSystem: e
    } = this.props;
    return e === wn.DEFAULT || e === wn.LNGLAT || e === wn.CARTESIAN;
  }
  onHover(e, n) {
    return this.props.onHover && this.props.onHover(e, n) || !1;
  }
  onClick(e, n) {
    return this.props.onClick && this.props.onClick(e, n) || !1;
  }
  nullPickingColor() {
    return [0, 0, 0];
  }
  encodePickingColor(e, n = []) {
    return n[0] = e + 1 & 255, n[1] = e + 1 >> 8 & 255, n[2] = e + 1 >> 8 >> 8 & 255, n;
  }
  decodePickingColor(e) {
    sA(e instanceof Uint8Array);
    const [n, r, i] = e;
    return n + r * 256 + i * 65536 - 1;
  }
  getNumInstances() {
    return Number.isFinite(this.props.numInstances) ? this.props.numInstances : this.state && this.state.numInstances !== void 0 ? this.state.numInstances : Lqe(this.props.data);
  }
  getStartIndices() {
    return this.props.startIndices ? this.props.startIndices : this.state && this.state.startIndices ? this.state.startIndices : null;
  }
  getBounds() {
    var e;
    const n = this.getAttributeManager();
    if (!n)
      return null;
    const {
      positions: r,
      instancePositions: i
    } = n.attributes;
    return (e = r || i) === null || e === void 0 ? void 0 : e.getBounds();
  }
  getShaders(e) {
    for (const n of this.props.extensions)
      e = f$(e, n.getShaders.call(this, n));
    return e;
  }
  shouldUpdateState(e) {
    return e.changeFlags.propsOrDataChanged;
  }
  updateState(e) {
    const n = this.getAttributeManager(), {
      dataChanged: r
    } = e.changeFlags;
    if (r && n)
      if (Array.isArray(r))
        for (const A of r)
          n.invalidateAll(A);
      else
        n.invalidateAll();
    const {
      props: i,
      oldProps: o
    } = e, s = Number.isInteger(o.highlightedObjectIndex) || o.pickable, a = Number.isInteger(i.highlightedObjectIndex) || i.pickable;
    if (s !== a && n) {
      const {
        pickingColors: A,
        instancePickingColors: l
      } = n.attributes, c = A || l;
      c && (a && c.constant && (c.constant = !1, n.invalidate(c.id)), !c.value && !a && (c.constant = !0, c.value = [0, 0, 0]));
    }
  }
  finalizeState(e) {
    for (const r of this.getModels())
      r.delete();
    const n = this.getAttributeManager();
    n && n.finalize(), this.context && this.context.resourceManager.unsubscribe({
      consumerId: this.id
    }), this.internalState && (this.internalState.uniformTransitions.clear(), this.internalState.finalize());
  }
  draw(e) {
    for (const n of this.getModels())
      n.draw(e);
  }
  getPickingInfo({
    info: e,
    mode: n,
    sourceLayer: r
  }) {
    const {
      index: i
    } = e;
    return i >= 0 && Array.isArray(this.props.data) && (e.object = this.props.data[i]), e;
  }
  raiseError(e, n) {
    var r, i;
    if (n && (e.message = "".concat(n, ": ").concat(e.message)), !((r = (i = this.props).onError) !== null && r !== void 0 && r.call(i, e))) {
      var o, s;
      (o = this.context) === null || o === void 0 || (s = o.onError) === null || s === void 0 || s.call(o, e, this);
    }
  }
  getNeedsRedraw(e = {
    clearRedrawFlags: !1
  }) {
    return this._getNeedsRedraw(e);
  }
  needsUpdate() {
    return this.internalState ? this.internalState.needsUpdate || this.hasUniformTransition() || this.shouldUpdateState(this._getUpdateParams()) : !1;
  }
  hasUniformTransition() {
    var e;
    return ((e = this.internalState) === null || e === void 0 ? void 0 : e.uniformTransitions.active) || !1;
  }
  activateViewport(e) {
    if (!this.internalState)
      return;
    const n = this.internalState.viewport;
    this.internalState.viewport = e, (!n || !_pn({
      oldViewport: n,
      viewport: e
    })) && (this.setChangeFlags({
      viewportChanged: !0
    }), this.isComposite ? this.needsUpdate() && this.setNeedsUpdate() : this._update());
  }
  invalidateAttribute(e = "all") {
    const n = this.getAttributeManager();
    n && (e === "all" ? n.invalidateAll() : n.invalidate(e));
  }
  updateAttributes(e) {
    for (const n of this.getModels())
      this._setModelAttributes(n, e);
  }
  _updateAttributes() {
    const e = this.getAttributeManager();
    if (!e)
      return;
    const n = this.props, r = this.getNumInstances(), i = this.getStartIndices();
    e.update({
      data: n.data,
      numInstances: r,
      startIndices: i,
      props: n,
      transitions: n.transitions,
      buffers: n.data.attributes,
      context: this
    });
    const o = e.getChangedAttributes({
      clearChangedFlags: !0
    });
    this.updateAttributes(o);
  }
  _updateAttributeTransition() {
    const e = this.getAttributeManager();
    e && e.updateTransition();
  }
  _updateUniformTransition() {
    const {
      uniformTransitions: e
    } = this.internalState;
    if (e.active) {
      const n = e.update(), r = Object.create(this.props);
      for (const i in n)
        Object.defineProperty(r, i, {
          value: n[i]
        });
      return r;
    }
    return this.props;
  }
  calculateInstancePickingColors(e, {
    numInstances: n
  }) {
    if (e.constant)
      return;
    const r = Math.floor(Jd.length / 3);
    if (this.internalState.usesPickingColorCache = !0, r < n) {
      n > cSe && Rr.warn("Layer has too many data objects. Picking might not be able to distinguish all objects.")(), Jd = jS.allocate(Jd, n, {
        size: 3,
        copy: !0,
        maxCount: Math.max(n, cSe)
      });
      const i = Math.floor(Jd.length / 3), o = [];
      for (let s = r; s < i; s++)
        this.encodePickingColor(s, o), Jd[s * 3 + 0] = o[0], Jd[s * 3 + 1] = o[1], Jd[s * 3 + 2] = o[2];
    }
    e.value = Jd.subarray(0, n * 3);
  }
  _setModelAttributes(e, n) {
    const r = this.getAttributeManager(), i = e.userData.excludeAttributes || {}, o = r.getShaderAttributes(n, i);
    e.setAttributes(o);
  }
  disablePickingIndex(e) {
    this._disablePickingIndex(e);
  }
  _disablePickingIndex(e) {
    const {
      pickingColors: n,
      instancePickingColors: r
    } = this.getAttributeManager().attributes, i = n || r;
    if (!i)
      return;
    const o = i.getVertexOffset(e), s = i.getVertexOffset(e + 1);
    i.buffer.subData({
      data: new Uint8Array(s - o),
      offset: o
    });
  }
  restorePickingColors() {
    const {
      pickingColors: e,
      instancePickingColors: n
    } = this.getAttributeManager().attributes, r = e || n;
    r && (this.internalState.usesPickingColorCache && r.value.buffer !== Jd.buffer && (r.value = Jd.subarray(0, r.value.length)), r.updateSubBuffer({
      startOffset: 0
    }));
  }
  _initialize() {
    sA(!this.internalState), sA(Number.isFinite(this.props.coordinateSystem)), Ul(Epn, this);
    const e = this._getAttributeManager();
    e && e.addInstanced({
      instancePickingColors: {
        type: 5121,
        size: 3,
        noAlloc: !0,
        update: this.calculateInstancePickingColors
      }
    }), this.internalState = new mpn({
      attributeManager: e,
      layer: this
    }), this._clearChangeFlags(), this.state = {}, Object.defineProperty(this.state, "attributeManager", {
      get: () => (Rr.deprecated("layer.state.attributeManager", "layer.getAttributeManager()")(), e)
    }), this.internalState.layer = this, this.internalState.uniformTransitions = new jdn(this.context.timeline), this.internalState.onAsyncPropUpdated = this._onAsyncPropUpdated.bind(this), this.internalState.setAsyncProps(this.props), this.initializeState(this.context);
    for (const n of this.props.extensions)
      n.initializeState.call(this, this.context, n);
    this.setChangeFlags({
      dataChanged: "init",
      propsChanged: "init",
      viewportChanged: !0,
      extensionsChanged: !0
    }), this._update();
  }
  _transferState(e) {
    Ul(Bpn, this, this === e);
    const {
      state: n,
      internalState: r
    } = e;
    this !== e && (this.internalState = r, this.internalState.layer = this, this.state = n, this.internalState.setAsyncProps(this.props), this._diffProps(this.props, this.internalState.getOldProps()));
  }
  _update() {
    const e = this.needsUpdate();
    if (Ul(ypn, this, e), !e)
      return;
    const n = this.props, r = this.context, i = this.internalState, o = r.viewport, s = this._updateUniformTransition();
    i.propsInTransition = s, r.viewport = i.viewport || o, this.props = s;
    try {
      const a = this._getUpdateParams(), A = this.getModels();
      if (r.gl)
        this.updateState(a);
      else
        try {
          this.updateState(a);
        } catch {
        }
      for (const c of this.props.extensions)
        c.updateState.call(this, a, c);
      const l = this.getModels()[0] !== A[0];
      this._postUpdate(a, l);
    } finally {
      r.viewport = o, this.props = n, this._clearChangeFlags(), i.needsUpdate = !1, i.resetOldProps();
    }
  }
  _finalize() {
    Ul(vpn, this), this.finalizeState(this.context);
    for (const e of this.props.extensions)
      e.finalizeState.call(this, e);
  }
  _drawLayer({
    moduleParameters: e = null,
    uniforms: n = {},
    parameters: r = {}
  }) {
    this._updateAttributeTransition();
    const i = this.props, o = this.context;
    this.props = this.internalState.propsInTransition || i;
    const s = this.props.opacity;
    n.opacity = Math.pow(s, 1 / 2.2);
    try {
      e && this.setModuleParameters(e);
      const {
        getPolygonOffset: a
      } = this.props, A = a && a(n) || [0, 0];
      cd(o.gl, {
        polygonOffset: A
      }), Yc(o.gl, r, () => {
        const l = {
          moduleParameters: e,
          uniforms: n,
          parameters: r,
          context: o
        };
        for (const c of this.props.extensions)
          c.draw.call(this, l, c);
        this.draw(l);
      });
    } finally {
      this.props = i;
    }
  }
  getChangeFlags() {
    var e;
    return (e = this.internalState) === null || e === void 0 ? void 0 : e.changeFlags;
  }
  setChangeFlags(e) {
    if (!this.internalState)
      return;
    const {
      changeFlags: n
    } = this.internalState;
    for (const i in e)
      if (e[i]) {
        let o = !1;
        switch (i) {
          case "dataChanged":
            const s = e[i], a = n[i];
            s && Array.isArray(a) && (n.dataChanged = Array.isArray(s) ? a.concat(s) : s, o = !0);
          default:
            n[i] || (n[i] = e[i], o = !0);
        }
        o && Ul(Cpn, this, i, e);
      }
    const r = !!(n.dataChanged || n.updateTriggersChanged || n.propsChanged || n.extensionsChanged);
    n.propsOrDataChanged = r, n.somethingChanged = r || n.viewportChanged || n.stateChanged;
  }
  _clearChangeFlags() {
    this.internalState.changeFlags = {
      dataChanged: !1,
      propsChanged: !1,
      updateTriggersChanged: !1,
      viewportChanged: !1,
      stateChanged: !1,
      extensionsChanged: !1,
      propsOrDataChanged: !1,
      somethingChanged: !1
    };
  }
  _diffProps(e, n) {
    const r = zdn(e, n);
    if (r.updateTriggersChanged)
      for (const o in r.updateTriggersChanged)
        r.updateTriggersChanged[o] && this.invalidateAttribute(o);
    if (r.transitionsChanged)
      for (const o in r.transitionsChanged) {
        var i;
        this.internalState.uniformTransitions.add(o, n[o], e[o], (i = e.transitions) === null || i === void 0 ? void 0 : i[o]);
      }
    return this.setChangeFlags(r);
  }
  validateProps() {
    Ydn(this.props);
  }
  updateAutoHighlight(e) {
    this.props.autoHighlight && !Number.isInteger(this.props.highlightedObjectIndex) && this._updateAutoHighlight(e);
  }
  _updateAutoHighlight(e) {
    const n = {
      pickingSelectedColor: e.picked ? e.color : null
    }, {
      highlightColor: r
    } = this.props;
    e.picked && typeof r == "function" && (n.pickingHighlightColor = r(e)), this.setModuleParameters(n), this.setNeedsRedraw();
  }
  _getAttributeManager() {
    const e = this.context;
    return new Nqe(e.gl, {
      id: this.props.id,
      stats: e.stats,
      timeline: e.timeline
    });
  }
  _postUpdate(e, n) {
    const {
      props: r,
      oldProps: i
    } = e;
    this.setNeedsRedraw(), this._updateAttributes();
    const {
      model: o
    } = this.state;
    o?.setInstanceCount(this.getNumInstances());
    const {
      autoHighlight: s,
      highlightedObjectIndex: a,
      highlightColor: A
    } = r;
    if (n || i.autoHighlight !== s || i.highlightedObjectIndex !== a || i.highlightColor !== A) {
      const l = {};
      s || (l.pickingSelectedColor = null), Array.isArray(A) && (l.pickingHighlightColor = A), (n || a !== i.highlightedObjectIndex) && (l.pickingSelectedColor = Number.isFinite(a) && a >= 0 ? this.encodePickingColor(a) : null), this.setModuleParameters(l);
    }
  }
  _getUpdateParams() {
    return {
      props: this.props,
      oldProps: this.internalState.getOldProps(),
      context: this.context,
      changeFlags: this.internalState.changeFlags
    };
  }
  _getNeedsRedraw(e) {
    if (!this.internalState)
      return !1;
    let n = !1;
    n = n || this.internalState.needsRedraw && this.id, this.internalState.needsRedraw = this.internalState.needsRedraw && !e.clearRedrawFlags;
    const r = this.getAttributeManager(), i = r ? r.getNeedsRedraw(e) : !1;
    return n = n || i, n;
  }
  _onAsyncPropUpdated() {
    this._diffProps(this.props, this.internalState.getOldProps()), this.setNeedsUpdate();
  }
}
ae(IA, "defaultProps", Spn);
ae(IA, "layerName", "Layer");
const Qpn = "compositeLayer.renderLayers";
class mA extends IA {
  get isComposite() {
    return !0;
  }
  get isLoaded() {
    return super.isLoaded && this.getSubLayers().every((e) => e.isLoaded);
  }
  getSubLayers() {
    return this.internalState && this.internalState.subLayers || [];
  }
  initializeState(e) {
  }
  setState(e) {
    super.setState(e), this.setNeedsUpdate();
  }
  getPickingInfo({
    info: e
  }) {
    const {
      object: n
    } = e;
    return n && n.__source && n.__source.parent && n.__source.parent.id === this.id && (e.object = n.__source.object, e.index = n.__source.index), e;
  }
  filterSubLayer(e) {
    return !0;
  }
  shouldRenderSubLayer(e, n) {
    return n && n.length;
  }
  getSubLayerClass(e, n) {
    const {
      _subLayerProps: r
    } = this.props;
    return r && r[e] && r[e].type || n;
  }
  getSubLayerRow(e, n, r) {
    return e.__source = {
      parent: this,
      object: n,
      index: r
    }, e;
  }
  getSubLayerAccessor(e) {
    if (typeof e == "function") {
      const n = {
        index: -1,
        data: this.props.data,
        target: []
      };
      return (r, i) => r && r.__source ? (n.index = r.__source.index, e(r.__source.object, n)) : e(r, i);
    }
    return e;
  }
  getSubLayerProps(e = {}) {
    var n;
    const {
      opacity: r,
      pickable: i,
      visible: o,
      parameters: s,
      getPolygonOffset: a,
      highlightedObjectIndex: A,
      autoHighlight: l,
      highlightColor: c,
      coordinateSystem: u,
      coordinateOrigin: f,
      wrapLongitude: h,
      positionFormat: d,
      modelMatrix: I,
      extensions: m,
      fetch: C,
      operation: y,
      _subLayerProps: v
    } = this.props, b = {
      id: "",
      updateTriggers: {},
      opacity: r,
      pickable: i,
      visible: o,
      parameters: s,
      getPolygonOffset: a,
      highlightedObjectIndex: A,
      autoHighlight: l,
      highlightColor: c,
      coordinateSystem: u,
      coordinateOrigin: f,
      wrapLongitude: h,
      positionFormat: d,
      modelMatrix: I,
      extensions: m,
      fetch: C,
      operation: y
    }, Q = v && e.id && v[e.id], w = Q && Q.updateTriggers, R = e.id || "sublayer";
    if (Q) {
      const M = this.constructor._propTypes, O = e.type ? e.type._propTypes : {};
      for (const L in Q) {
        const N = O[L] || M[L];
        N && N.type === "accessor" && (Q[L] = this.getSubLayerAccessor(Q[L]));
      }
    }
    Object.assign(b, e, Q), b.id = "".concat(this.props.id, "-").concat(R), b.updateTriggers = {
      all: (n = this.props.updateTriggers) === null || n === void 0 ? void 0 : n.all,
      ...e.updateTriggers,
      ...w
    };
    for (const M of m) {
      const O = M.getSubLayerProps.call(this, M);
      O && Object.assign(b, O, {
        updateTriggers: Object.assign(b.updateTriggers, O.updateTriggers)
      });
    }
    return b;
  }
  _updateAutoHighlight(e) {
    for (const n of this.getSubLayers())
      n.updateAutoHighlight(e);
  }
  _getAttributeManager() {
    return null;
  }
  _postUpdate(e, n) {
    let r = this.internalState.subLayers;
    const i = !r || this.needsUpdate();
    if (i) {
      const o = this.renderLayers();
      r = gM(o, Boolean), this.internalState.subLayers = r;
    }
    Ul(Qpn, this, i, r);
    for (const o of r)
      o.parent = this;
  }
}
ae(mA, "layerName", "CompositeLayer");
const eP = Math.PI / 180, uSe = 180 / Math.PI, Mk = 6370972, h_ = 256;
function wpn() {
  const t = h_ / Mk, e = Math.PI / 180 * h_;
  return {
    unitsPerMeter: [t, t, t],
    unitsPerMeter2: [0, 0, 0],
    metersPerUnit: [1 / t, 1 / t, 1 / t],
    unitsPerDegree: [e, e, t],
    unitsPerDegree2: [0, 0, 0],
    degreesPerUnit: [1 / e, 1 / e, 1 / t]
  };
}
class nce extends Dd {
  constructor(e = {}) {
    const {
      latitude: n = 0,
      longitude: r = 0,
      zoom: i = 0,
      nearZMultiplier: o = 0.1,
      farZMultiplier: s = 2,
      resolution: a = 10
    } = e;
    let {
      height: A,
      altitude: l = 1.5
    } = e;
    A = A || 1, l = Math.max(0.75, l);
    const c = new pn().lookAt({
      eye: [0, -l, 0],
      up: [0, 0, 1]
    }), u = Math.pow(2, i);
    c.rotateX(n * eP), c.rotateZ(-r * eP), c.scale(u / A);
    const f = Math.atan(0.5 / l), h = h_ * 2 * u / A;
    super({
      ...e,
      height: A,
      viewMatrix: c,
      longitude: r,
      latitude: n,
      zoom: i,
      distanceScales: wpn(),
      fovyRadians: f * 2,
      focalDistance: l,
      near: o,
      far: Math.min(2, 1 / h + 1) * l * s
    }), ae(this, "longitude", void 0), ae(this, "latitude", void 0), ae(this, "resolution", void 0), this.latitude = n, this.longitude = r, this.resolution = a;
  }
  get projectionMode() {
    return qh.GLOBE;
  }
  getDistanceScales() {
    return this.distanceScales;
  }
  getBounds(e = {}) {
    const n = {
      targetZ: e.z || 0
    }, r = this.unproject([0, this.height / 2], n), i = this.unproject([this.width / 2, 0], n), o = this.unproject([this.width, this.height / 2], n), s = this.unproject([this.width / 2, this.height], n);
    return o[0] < this.longitude && (o[0] += 360), r[0] > this.longitude && (r[0] -= 360), [Math.min(r[0], o[0], i[0], s[0]), Math.min(r[1], o[1], i[1], s[1]), Math.max(r[0], o[0], i[0], s[0]), Math.max(r[1], o[1], i[1], s[1])];
  }
  unproject(e, {
    topLeft: n = !0,
    targetZ: r
  } = {}) {
    const [i, o, s] = e, a = n ? o : this.height - o, {
      pixelUnprojectionMatrix: A
    } = this;
    let l;
    if (Number.isFinite(s))
      l = _V(A, [i, a, s, 1]);
    else {
      const h = _V(A, [i, a, -1, 1]), d = _V(A, [i, a, 1, 1]), I = ((r || 0) / Mk + 1) * h_, m = gV(b$e([], h, d)), C = gV(h), y = gV(d), b = 4 * ((4 * C * y - (m - C - y) ** 2) / 16) / m, Q = Math.sqrt(C - b), w = Math.sqrt(Math.max(0, I * I - b)), R = (Q - w) / Math.sqrt(m);
      l = scn([], h, d, R);
    }
    const [c, u, f] = this.unprojectPosition(l);
    return Number.isFinite(s) ? [c, u, f] : Number.isFinite(r) ? [c, u, r] : [c, u];
  }
  projectPosition(e) {
    const [n, r, i = 0] = e, o = n * eP, s = r * eP, a = Math.cos(s), A = (i / Mk + 1) * h_;
    return [Math.sin(o) * a * A, -Math.cos(o) * a * A, Math.sin(s) * A];
  }
  unprojectPosition(e) {
    const [n, r, i] = e, o = _$e(e), s = Math.asin(i / o), A = Math.atan2(n, -r) * uSe, l = s * uSe, c = (o / h_ - 1) * Mk;
    return [A, l, c];
  }
  projectFlat(e) {
    return e;
  }
  unprojectFlat(e) {
    return e;
  }
  panByPosition(e, n) {
    const r = this.unproject(n);
    return {
      longitude: e[0] - r[0] + this.longitude,
      latitude: e[1] - r[1] + this.latitude
    };
  }
}
function _V(t, e) {
  const n = Tw([], e, t);
  return Mle(n, n, 1 / n[3]), n;
}
const SV = Math.PI / 180;
function xpn({
  height: t,
  focalDistance: e,
  orbitAxis: n,
  rotationX: r,
  rotationOrbit: i,
  zoom: o
}) {
  const s = n === "Z" ? [0, 0, 1] : [0, 1, 0], a = n === "Z" ? [0, -e, 0] : [0, 0, e], A = new pn().lookAt({
    eye: a,
    up: s
  });
  A.rotateX(r * SV), n === "Z" ? A.rotateZ(i * SV) : A.rotateY(i * SV);
  const l = Math.pow(2, o) / t;
  return A.scale(l), A;
}
class Fqe extends Dd {
  constructor(e) {
    const {
      height: n,
      projectionMatrix: r,
      fovy: i = 50,
      orbitAxis: o = "Z",
      target: s = [0, 0, 0],
      rotationX: a = 0,
      rotationOrbit: A = 0,
      zoom: l = 0
    } = e, c = r ? r[5] / 2 : uM(i);
    super({
      ...e,
      longitude: void 0,
      viewMatrix: xpn({
        height: n || 1,
        focalDistance: c,
        orbitAxis: o,
        rotationX: a,
        rotationOrbit: A,
        zoom: l
      }),
      fovy: i,
      focalDistance: c,
      position: s,
      zoom: l
    }), ae(this, "projectedCenter", void 0), this.projectedCenter = this.project(this.center);
  }
  unproject(e, {
    topLeft: n = !0
  } = {}) {
    const [r, i, o = this.projectedCenter[2]] = e, s = n ? i : this.height - i, [a, A, l] = JC([r, s, o], this.pixelUnprojectionMatrix);
    return [a, A, l];
  }
  panByPosition(e, n) {
    const r = this.project(e), i = [this.width / 2 + r[0] - n[0], this.height / 2 + r[1] - n[1], this.projectedCenter[2]];
    return {
      target: this.unproject(i)
    };
  }
}
class Pqe extends Dd {
  constructor(e) {
    const {
      longitude: n,
      latitude: r,
      modelMatrix: i,
      bearing: o = 0,
      pitch: s = 0,
      up: a = [0, 0, 1]
    } = e, l = new HS({
      bearing: o,
      pitch: s === -90 ? 1e-4 : 90 + s
    }).toVector3().normalize(), c = i ? new pn(i).transformAsVector(l) : l, u = Number.isFinite(r) ? Ule({
      latitude: r
    }) : 0, f = Math.pow(2, u), h = new pn().lookAt({
      eye: [0, 0, 0],
      center: c,
      up: a
    }).scale(f);
    super({
      ...e,
      zoom: u,
      viewMatrix: h
    }), ae(this, "longitude", void 0), ae(this, "latitude", void 0), this.latitude = r, this.longitude = n;
  }
}
const c2 = 20;
class rce extends Vle {
  constructor(e) {
    const {
      width: n,
      height: r,
      position: i = [0, 0, 0],
      bearing: o = 0,
      pitch: s = 0,
      longitude: a = null,
      latitude: A = null,
      maxPitch: l = 90,
      minPitch: c = -90,
      startRotatePos: u,
      startBearing: f,
      startPitch: h,
      startZoomPosition: d
    } = e;
    super({
      width: n,
      height: r,
      position: i,
      bearing: o,
      pitch: s,
      longitude: a,
      latitude: A,
      maxPitch: l,
      minPitch: c
    }, {
      startRotatePos: u,
      startBearing: f,
      startPitch: h,
      startZoomPosition: d
    });
  }
  panStart() {
    return this;
  }
  pan() {
    return this;
  }
  panEnd() {
    return this;
  }
  rotateStart({
    pos: e
  }) {
    return this._getUpdatedState({
      startRotatePos: e,
      startBearing: this.getViewportProps().bearing,
      startPitch: this.getViewportProps().pitch
    });
  }
  rotate({
    pos: e,
    deltaAngleX: n = 0,
    deltaAngleY: r = 0
  }) {
    const {
      startRotatePos: i,
      startBearing: o,
      startPitch: s
    } = this.getState(), {
      width: a,
      height: A
    } = this.getViewportProps();
    if (!i || o === void 0 || s === void 0)
      return this;
    let l;
    if (e) {
      const c = (e[0] - i[0]) / a, u = (e[1] - i[1]) / A;
      l = {
        bearing: o - c * 180,
        pitch: s - u * 90
      };
    } else
      l = {
        bearing: o - n,
        pitch: s - r
      };
    return this._getUpdatedState(l);
  }
  rotateEnd() {
    return this._getUpdatedState({
      startRotatePos: null,
      startBearing: null,
      startPitch: null
    });
  }
  zoomStart() {
    return this._getUpdatedState({
      startZoomPosition: this.getViewportProps().position
    });
  }
  zoom({
    scale: e
  }) {
    let {
      startZoomPosition: n
    } = this.getState();
    n || (n = this.getViewportProps().position);
    const r = this.getDirection();
    return this._move(r, Math.log2(e) * c2, n);
  }
  zoomEnd() {
    return this._getUpdatedState({
      startZoomPosition: null
    });
  }
  moveLeft(e = c2) {
    const n = this.getDirection(!0);
    return this._move(n.rotateZ({
      radians: Math.PI / 2
    }), e);
  }
  moveRight(e = c2) {
    const n = this.getDirection(!0);
    return this._move(n.rotateZ({
      radians: -Math.PI / 2
    }), e);
  }
  moveUp(e = c2) {
    const n = this.getDirection(!0);
    return this._move(n, e);
  }
  moveDown(e = c2) {
    const n = this.getDirection(!0);
    return this._move(n.negate(), e);
  }
  rotateLeft(e = 15) {
    return this._getUpdatedState({
      bearing: this.getViewportProps().bearing - e
    });
  }
  rotateRight(e = 15) {
    return this._getUpdatedState({
      bearing: this.getViewportProps().bearing + e
    });
  }
  rotateUp(e = 10) {
    return this._getUpdatedState({
      pitch: this.getViewportProps().pitch + e
    });
  }
  rotateDown(e = 10) {
    return this._getUpdatedState({
      pitch: this.getViewportProps().pitch - e
    });
  }
  zoomIn(e = 2) {
    return this.zoom({
      scale: e
    });
  }
  zoomOut(e = 2) {
    return this.zoom({
      scale: 1 / e
    });
  }
  shortestPathFrom(e) {
    const n = e.getViewportProps(), r = {
      ...this.getViewportProps()
    }, {
      bearing: i,
      longitude: o
    } = r;
    return Math.abs(i - n.bearing) > 180 && (r.bearing = i < 0 ? i + 360 : i - 360), o !== null && n.longitude !== null && Math.abs(o - n.longitude) > 180 && (r.longitude = o < 0 ? o + 360 : o - 360), r;
  }
  _move(e, n, r = this.getViewportProps().position) {
    const i = e.scale(n);
    return this._getUpdatedState({
      position: new ct(r).add(i)
    });
  }
  getDirection(e = !1) {
    return new HS({
      bearing: this.getViewportProps().bearing,
      pitch: e ? 90 : 90 + this.getViewportProps().pitch
    }).toVector3().normalize();
  }
  _getUpdatedState(e) {
    return new rce({
      ...this.getViewportProps(),
      ...this.getState(),
      ...e
    });
  }
  applyConstraints(e) {
    const {
      pitch: n,
      maxPitch: r,
      minPitch: i,
      longitude: o,
      bearing: s
    } = e;
    return e.pitch = So(n, i, r), o !== null && (o < -180 || o > 180) && (e.longitude = _U(o + 180, 360) - 180), (s < -180 || s > 180) && (e.bearing = _U(s + 180, 360) - 180), e;
  }
}
class kqe extends Mw {
  constructor(...e) {
    super(...e), ae(this, "ControllerState", rce), ae(this, "transition", {
      transitionDuration: 300,
      transitionInterpolator: new n1(["position", "pitch", "bearing"])
    });
  }
}
class Gqe extends hd {
  get ViewportType() {
    return Pqe;
  }
  get ControllerType() {
    return kqe;
  }
}
ae(Gqe, "displayName", "FirstPersonView");
class ice extends hd {
  constructor(e = {}) {
    super(e), this.props.orbitAxis = e.orbitAxis || "Z";
  }
  get ViewportType() {
    return Fqe;
  }
  get ControllerType() {
    return dqe;
  }
}
ae(ice, "displayName", "OrbitView");
class Rpn extends uqe {
  applyConstraints(e) {
    const {
      maxZoom: n,
      minZoom: r,
      zoom: i
    } = e;
    e.zoom = So(i, r, n);
    const {
      longitude: o,
      latitude: s
    } = e;
    return (o < -180 || o > 180) && (e.longitude = _U(o + 180, 360) - 180), e.latitude = So(s, -89, 89), e;
  }
}
class Uqe extends Mw {
  constructor(...e) {
    super(...e), ae(this, "ControllerState", Rpn), ae(this, "transition", {
      transitionDuration: 300,
      transitionInterpolator: new n1(["longitude", "latitude", "zoom"])
    }), ae(this, "dragMode", "pan");
  }
  setProps(e) {
    super.setProps(e), this.dragRotate = !1, this.touchRotate = !1;
  }
}
class Hqe extends hd {
  get ViewportType() {
    return nce;
  }
  get ControllerType() {
    return Uqe;
  }
}
ae(Hqe, "displayName", "GlobeView");
class l0 {
  constructor(e) {
    ae(this, "opts", void 0), e && (this.opts = e);
  }
  equals(e) {
    return this === e ? !0 : this.constructor === e.constructor && t1(this.opts, e.opts);
  }
  getShaders(e) {
    return null;
  }
  getSubLayerProps(e) {
    const {
      defaultProps: n
    } = e.constructor, r = {
      updateTriggers: {}
    };
    for (const i in n)
      if (i in this.props) {
        const o = n[i], s = this.props[i];
        r[i] = s, o && o.type === "accessor" && (r.updateTriggers[i] = this.props.updateTriggers[i], typeof s == "function" && (r[i] = this.getSubLayerAccessor(s)));
      }
    return r;
  }
  initializeState(e, n) {
  }
  updateState(e, n) {
  }
  draw(e, n) {
  }
  finalizeState(e, n) {
  }
}
ae(l0, "defaultProps", {});
const Dpn = ["bearing", "pitch"], Tpn = {
  speed: 1.2,
  curve: 1.414
};
class Npn extends zle {
  constructor(e = {}) {
    super({
      compare: ["longitude", "latitude", "zoom", "bearing", "pitch"],
      extract: ["width", "height", "longitude", "latitude", "zoom", "bearing", "pitch"],
      required: ["width", "height", "latitude", "longitude", "zoom"]
    }), ae(this, "opts", void 0), this.opts = {
      ...Tpn,
      ...e
    };
  }
  interpolateProps(e, n, r) {
    const i = X$e(e, n, r, this.opts);
    for (const o of Dpn)
      i[o] = Lf(e[o] || 0, n[o] || 0, r);
    return i;
  }
  getDuration(e, n) {
    let {
      transitionDuration: r
    } = n;
    return r === "auto" && (r = Z$e(e, n, this.opts)), r;
  }
}
class oce {
  constructor(e) {
    ae(this, "opts", void 0), ae(this, "typedArrayManager", void 0), ae(this, "indexStarts", [0]), ae(this, "vertexStarts", [0]), ae(this, "vertexCount", 0), ae(this, "instanceCount", 0), ae(this, "attributes", void 0), ae(this, "_attributeDefs", void 0), ae(this, "data", void 0), ae(this, "getGeometry", void 0), ae(this, "geometryBuffer", void 0), ae(this, "buffers", void 0), ae(this, "positionSize", void 0), ae(this, "normalize", void 0);
    const {
      attributes: n = {}
    } = e;
    this.typedArrayManager = jS, this.attributes = {}, this._attributeDefs = n, this.opts = e, this.updateGeometry(e);
  }
  updateGeometry(e) {
    Object.assign(this.opts, e);
    const {
      data: n,
      buffers: r = {},
      getGeometry: i,
      geometryBuffer: o,
      positionFormat: s,
      dataChanged: a,
      normalize: A = !0
    } = this.opts;
    if (this.data = n, this.getGeometry = i, this.positionSize = o && o.size || (s === "XY" ? 2 : 3), this.buffers = r, this.normalize = A, o && (sA(n.startIndices), this.getGeometry = this.getGeometryFromBuffer(o), A || (r.positions = o)), this.geometryBuffer = r.positions, Array.isArray(a))
      for (const l of a)
        this._rebuildGeometry(l);
    else
      this._rebuildGeometry();
  }
  updatePartialGeometry({
    startRow: e,
    endRow: n
  }) {
    this._rebuildGeometry({
      startRow: e,
      endRow: n
    });
  }
  getGeometryFromBuffer(e) {
    const n = e.value || e;
    return ArrayBuffer.isView(n) ? Qqe(n, {
      size: this.positionSize,
      offset: e.offset,
      stride: e.stride,
      startIndices: this.data.startIndices
    }) : null;
  }
  _allocate(e, n) {
    const {
      attributes: r,
      buffers: i,
      _attributeDefs: o,
      typedArrayManager: s
    } = this;
    for (const a in o)
      if (a in i)
        s.release(r[a]), r[a] = null;
      else {
        const A = o[a];
        A.copy = n, r[a] = s.allocate(r[a], e, A);
      }
  }
  _forEachGeometry(e, n, r) {
    const {
      data: i,
      getGeometry: o
    } = this, {
      iterable: s,
      objectInfo: a
    } = ZI(i, n, r);
    for (const A of s) {
      a.index++;
      const l = o ? o(A, a) : null;
      e(l, a.index);
    }
  }
  _rebuildGeometry(e) {
    if (!this.data)
      return;
    let {
      indexStarts: n,
      vertexStarts: r,
      instanceCount: i
    } = this;
    const {
      data: o,
      geometryBuffer: s
    } = this, {
      startRow: a = 0,
      endRow: A = 1 / 0
    } = e || {}, l = {};
    if (e || (n = [0], r = [0]), this.normalize || !s)
      this._forEachGeometry((u, f) => {
        const h = u && this.normalizeGeometry(u);
        l[f] = h, r[f + 1] = r[f] + (h ? this.getGeometrySize(h) : 0);
      }, a, A), i = r[r.length - 1];
    else if (r = o.startIndices, i = r[o.length] || 0, ArrayBuffer.isView(s))
      i = i || s.length / this.positionSize;
    else if (s instanceof ro) {
      const u = s.accessor.stride || this.positionSize * 4;
      i = i || s.byteLength / u;
    } else if (s.buffer) {
      const u = s.stride || this.positionSize * 4;
      i = i || s.buffer.byteLength / u;
    } else if (s.value) {
      const u = s.value, f = s.stride / u.BYTES_PER_ELEMENT || this.positionSize;
      i = i || u.length / f;
    }
    this._allocate(i, !!e), this.indexStarts = n, this.vertexStarts = r, this.instanceCount = i;
    const c = {};
    this._forEachGeometry((u, f) => {
      const h = l[f] || u;
      c.vertexStart = r[f], c.indexStart = n[f];
      const d = f < r.length - 1 ? r[f + 1] : i;
      c.geometrySize = d - r[f], c.geometryIndex = f, this.updateGeometryAttributes(h, c);
    }, a, A), this.vertexCount = n[n.length - 1];
  }
}
const Lpn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AmbientLight: tqe,
  AttributeManager: Nqe,
  COORDINATE_SYSTEM: wn,
  CompositeLayer: mA,
  Controller: Mw,
  Deck: pM,
  DeckRenderer: mqe,
  DirectionalLight: bU,
  FirstPersonController: kqe,
  FirstPersonView: Gqe,
  FirstPersonViewport: Pqe,
  FlyToInterpolator: Npn,
  Layer: IA,
  LayerExtension: l0,
  LayerManager: cqe,
  LightingEffect: Yle,
  LinearInterpolator: n1,
  MapController: fqe,
  MapView: Jle,
  OPERATION: Nw,
  OrbitController: dqe,
  OrbitView: ice,
  OrbitViewport: Fqe,
  OrthographicController: pqe,
  OrthographicView: Ig,
  OrthographicViewport: gqe,
  PointLight: aqe,
  PostProcessEffect: Xgn,
  TRANSITION_EVENTS: wU,
  Tesselator: oce,
  TransitionInterpolator: zle,
  UNIT: Ou,
  View: hd,
  Viewport: Dd,
  WebMercatorViewport: gd,
  _CameraLight: Tgn,
  _GlobeController: Uqe,
  _GlobeView: Hqe,
  _GlobeViewport: nce,
  _LayersPass: fM,
  _SunLight: Wgn,
  _compareProps: Zle,
  _count: Lqe,
  _fillArray: lqe,
  _flatten: gM,
  _memoize: Lw,
  _mergeShaders: f$,
  assert: sA,
  createIterable: ZI,
  fp64LowPart: iqe,
  gouraudLighting: cM,
  log: Rr,
  phongLighting: o$,
  picking: jA,
  project: A$,
  project32: qA,
  shadow: Tk
}, Symbol.toStringTag, { value: "Module" })), $qe = {
  clipBounds: [0, 0, 1, 1]
}, qqe = `
uniform vec4 clip_bounds;

bool clip_isInBounds(vec2 position) {
  return position.x >= clip_bounds[0] && position.y >= clip_bounds[1] && position.x < clip_bounds[2] && position.y < clip_bounds[3];
}
`, Mpn = {
  name: "clip-vs",
  vs: qqe
}, Opn = {
  "vs:#decl": `
varying float clip_isVisible;
`,
  "vs:DECKGL_FILTER_GL_POSITION": `
  clip_isVisible = float(clip_isInBounds(geometry.worldPosition.xy));
`,
  "fs:#decl": `
varying float clip_isVisible;
`,
  "fs:DECKGL_FILTER_COLOR": `
  if (clip_isVisible < 0.5) discard;
`
}, Fpn = {
  name: "clip-fs",
  fs: qqe
}, Ppn = {
  "vs:#decl": `
varying vec2 clip_commonPosition;
`,
  "vs:DECKGL_FILTER_GL_POSITION": `
  clip_commonPosition = geometry.position.xy;
`,
  "fs:#decl": `
varying vec2 clip_commonPosition;
`,
  "fs:DECKGL_FILTER_COLOR": `
  if (!clip_isInBounds(clip_commonPosition)) discard;
`
};
class sce extends l0 {
  getShaders() {
    let e = "instancePositions" in this.getAttributeManager().attributes;
    return "clipByInstance" in this.props && (e = this.props.clipByInstance), this.state.clipByInstance = e, e ? {
      modules: [Mpn],
      inject: Opn
    } : {
      modules: [Fpn],
      inject: Ppn
    };
  }
  draw({
    uniforms: e
  }) {
    const {
      clipBounds: n = $qe.clipBounds
    } = this.props;
    if (this.state.clipByInstance)
      e.clip_bounds = n;
    else {
      const r = this.projectPosition([n[0], n[1], 0]), i = this.projectPosition([n[2], n[3], 0]);
      e.clip_bounds = [Math.min(r[0], i[0]), Math.min(r[1], i[1]), Math.max(r[0], i[0]), Math.max(r[1], i[1])];
    }
  }
}
ae(sce, "defaultProps", $qe);
ae(sce, "extensionName", "ClipExtension");
const kpn = `#define SHADER_NAME arc-layer-vertex-shader

attribute vec3 positions;
attribute vec4 instanceSourceColors;
attribute vec4 instanceTargetColors;
attribute vec3 instanceSourcePositions;
attribute vec3 instanceSourcePositions64Low;
attribute vec3 instanceTargetPositions;
attribute vec3 instanceTargetPositions64Low;
attribute vec3 instancePickingColors;
attribute float instanceWidths;
attribute float instanceHeights;
attribute float instanceTilts;

uniform bool greatCircle;
uniform bool useShortestPath;
uniform float numSegments;
uniform float opacity;
uniform float widthScale;
uniform float widthMinPixels;
uniform float widthMaxPixels;
uniform int widthUnits;

varying vec4 vColor;
varying vec2 uv;
varying float isValid;

float paraboloid(float distance, float sourceZ, float targetZ, float ratio) {
  // d: distance on the xy plane
  // r: ratio of the current point
  // p: ratio of the peak of the arc
  // h: height multiplier
  // z = f(r) = sqrt(r * (p * 2 - r)) * d * h
  // f(0) = 0
  // f(1) = dz

  float deltaZ = targetZ - sourceZ;
  float dh = distance * instanceHeights;
  if (dh == 0.0) {
    return sourceZ + deltaZ * ratio;
  }
  float unitZ = deltaZ / dh;
  float p2 = unitZ * unitZ + 1.0;

  // sqrt does not deal with negative values, manually flip source and target if delta.z < 0
  float dir = step(deltaZ, 0.0);
  float z0 = mix(sourceZ, targetZ, dir);
  float r = mix(ratio, 1.0 - ratio, dir);
  return sqrt(r * (p2 - r)) * dh + z0;
}

// offset vector by strokeWidth pixels
// offset_direction is -1 (left) or 1 (right)
vec2 getExtrusionOffset(vec2 line_clipspace, float offset_direction, float width) {
  // normalized direction of the line
  vec2 dir_screenspace = normalize(line_clipspace * project_uViewportSize);
  // rotate by 90 degrees
  dir_screenspace = vec2(-dir_screenspace.y, dir_screenspace.x);

  return dir_screenspace * offset_direction * width / 2.0;
}

float getSegmentRatio(float index) {
  return smoothstep(0.0, 1.0, index / (numSegments - 1.0));
}

vec3 interpolateFlat(vec3 source, vec3 target, float segmentRatio) {
  float distance = length(source.xy - target.xy);
  float z = paraboloid(distance, source.z, target.z, segmentRatio);

  float tiltAngle = radians(instanceTilts);
  vec2 tiltDirection = normalize(target.xy - source.xy);
  vec2 tilt = vec2(-tiltDirection.y, tiltDirection.x) * z * sin(tiltAngle);

  return vec3(
    mix(source.xy, target.xy, segmentRatio) + tilt,
    z * cos(tiltAngle)
  );
}

/* Great circle interpolation
 * http://www.movable-type.co.uk/scripts/latlong.html
 */
float getAngularDist (vec2 source, vec2 target) {
  vec2 sourceRadians = radians(source);
  vec2 targetRadians = radians(target);
  vec2 sin_half_delta = sin((sourceRadians - targetRadians) / 2.0);
  vec2 shd_sq = sin_half_delta * sin_half_delta;

  float a = shd_sq.y + cos(sourceRadians.y) * cos(targetRadians.y) * shd_sq.x;
  return 2.0 * asin(sqrt(a));
}

vec3 interpolateGreatCircle(vec3 source, vec3 target, vec3 source3D, vec3 target3D, float angularDist, float t) {
  vec2 lngLat;

  // if the angularDist is PI, linear interpolation is applied. otherwise, use spherical interpolation
  if(abs(angularDist - PI) < 0.001) {
    lngLat = (1.0 - t) * source.xy + t * target.xy;
  } else {
    float a = sin((1.0 - t) * angularDist);
    float b = sin(t * angularDist);
    vec3 p = source3D.yxz * a + target3D.yxz * b;
    lngLat = degrees(vec2(atan(p.y, -p.x), atan(p.z, length(p.xy))));
  }

  float z = paraboloid(angularDist * EARTH_RADIUS, source.z, target.z, t);

  return vec3(lngLat, z);
}

/* END GREAT CIRCLE */

void main(void) {
  geometry.worldPosition = instanceSourcePositions;
  geometry.worldPositionAlt = instanceTargetPositions;

  float segmentIndex = positions.x;
  float segmentRatio = getSegmentRatio(segmentIndex);
  float prevSegmentRatio = getSegmentRatio(max(0.0, segmentIndex - 1.0));
  float nextSegmentRatio = getSegmentRatio(min(numSegments - 1.0, segmentIndex + 1.0));

  // if it's the first point, use next - current as direction
  // otherwise use current - prev
  float indexDir = mix(-1.0, 1.0, step(segmentIndex, 0.0));
  isValid = 1.0;

  uv = vec2(segmentRatio, positions.y);
  geometry.uv = uv;
  geometry.pickingColor = instancePickingColors;

  vec4 curr;
  vec4 next;
  vec3 source;
  vec3 target;

  if ((greatCircle || project_uProjectionMode == PROJECTION_MODE_GLOBE) && project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
    source = project_globe_(vec3(instanceSourcePositions.xy, 0.0));
    target = project_globe_(vec3(instanceTargetPositions.xy, 0.0));
    float angularDist = getAngularDist(instanceSourcePositions.xy, instanceTargetPositions.xy);

    vec3 prevPos = interpolateGreatCircle(instanceSourcePositions, instanceTargetPositions, source, target, angularDist, prevSegmentRatio);
    vec3 currPos = interpolateGreatCircle(instanceSourcePositions, instanceTargetPositions, source, target, angularDist, segmentRatio);
    vec3 nextPos = interpolateGreatCircle(instanceSourcePositions, instanceTargetPositions, source, target, angularDist, nextSegmentRatio);

    if (abs(currPos.x - prevPos.x) > 180.0) {
      indexDir = -1.0;
      isValid = 0.0;
    } else if (abs(currPos.x - nextPos.x) > 180.0) {
      indexDir = 1.0;
      isValid = 0.0;
    }
    nextPos = indexDir < 0.0 ? prevPos : nextPos;
    nextSegmentRatio = indexDir < 0.0 ? prevSegmentRatio : nextSegmentRatio;

    if (isValid == 0.0) {
      // split at the 180th meridian
      nextPos.x += nextPos.x > 0.0 ? -360.0 : 360.0;
      float t = ((currPos.x > 0.0 ? 180.0 : -180.0) - currPos.x) / (nextPos.x - currPos.x);
      currPos = mix(currPos, nextPos, t);
      segmentRatio = mix(segmentRatio, nextSegmentRatio, t);
    }

    vec3 currPos64Low = mix(instanceSourcePositions64Low, instanceTargetPositions64Low, segmentRatio);
    vec3 nextPos64Low = mix(instanceSourcePositions64Low, instanceTargetPositions64Low, nextSegmentRatio);
  
    curr = project_position_to_clipspace(currPos, currPos64Low, vec3(0.0), geometry.position);
    next = project_position_to_clipspace(nextPos, nextPos64Low, vec3(0.0));
  
  } else {
    vec3 source_world = instanceSourcePositions;
    vec3 target_world = instanceTargetPositions;
    if (useShortestPath) {
      source_world.x = mod(source_world.x + 180., 360.0) - 180.;
      target_world.x = mod(target_world.x + 180., 360.0) - 180.;

      float deltaLng = target_world.x - source_world.x;
      if (deltaLng > 180.) target_world.x -= 360.;
      if (deltaLng < -180.) source_world.x -= 360.;
    }
    source = project_position(source_world, instanceSourcePositions64Low);
    target = project_position(target_world, instanceTargetPositions64Low);

    // common x at longitude=-180
    float antiMeridianX = 0.0;

    if (useShortestPath) {
      if (project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR_AUTO_OFFSET) {
        antiMeridianX = -(project_uCoordinateOrigin.x + 180.) / 360. * TILE_SIZE;
      }
      float thresholdRatio = (antiMeridianX - source.x) / (target.x - source.x);

      if (prevSegmentRatio <= thresholdRatio && nextSegmentRatio > thresholdRatio) {
        isValid = 0.0;
        indexDir = sign(segmentRatio - thresholdRatio);
        segmentRatio = thresholdRatio;
      }
    }

    nextSegmentRatio = indexDir < 0.0 ? prevSegmentRatio : nextSegmentRatio;
    vec3 currPos = interpolateFlat(source, target, segmentRatio);
    vec3 nextPos = interpolateFlat(source, target, nextSegmentRatio);

    if (useShortestPath) {
      if (nextPos.x < antiMeridianX) {
        currPos.x += TILE_SIZE;
        nextPos.x += TILE_SIZE;
      }
    }

    curr = project_common_position_to_clipspace(vec4(currPos, 1.0));
    next = project_common_position_to_clipspace(vec4(nextPos, 1.0));
    geometry.position = vec4(currPos, 1.0);
  }

  // Multiply out width and clamp to limits
  // mercator pixels are interpreted as screen pixels
  float widthPixels = clamp(
    project_size_to_pixel(instanceWidths * widthScale, widthUnits),
    widthMinPixels, widthMaxPixels
  );

  // extrude
  vec3 offset = vec3(
    getExtrusionOffset((next.xy - curr.xy) * indexDir, positions.y, widthPixels),
    0.0);
  DECKGL_FILTER_SIZE(offset, geometry);
  gl_Position = curr + vec4(project_pixel_size_to_clipspace(offset.xy), 0.0, 0.0);
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  vec4 color = mix(instanceSourceColors, instanceTargetColors, segmentRatio);
  vColor = vec4(color.rgb, color.a * opacity);
  DECKGL_FILTER_COLOR(vColor, geometry);
}
`, Gpn = `#define SHADER_NAME arc-layer-fragment-shader

precision highp float;

varying vec4 vColor;
varying vec2 uv;
varying float isValid;

void main(void) {
  if (isValid == 0.0) {
    discard;
  }

  gl_FragColor = vColor;
  geometry.uv = uv;

  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`, TU = [0, 0, 0, 255], Upn = {
  getSourcePosition: {
    type: "accessor",
    value: (t) => t.sourcePosition
  },
  getTargetPosition: {
    type: "accessor",
    value: (t) => t.targetPosition
  },
  getSourceColor: {
    type: "accessor",
    value: TU
  },
  getTargetColor: {
    type: "accessor",
    value: TU
  },
  getWidth: {
    type: "accessor",
    value: 1
  },
  getHeight: {
    type: "accessor",
    value: 1
  },
  getTilt: {
    type: "accessor",
    value: 0
  },
  greatCircle: !1,
  widthUnits: "pixels",
  widthScale: {
    type: "number",
    value: 1,
    min: 0
  },
  widthMinPixels: {
    type: "number",
    value: 0,
    min: 0
  },
  widthMaxPixels: {
    type: "number",
    value: Number.MAX_SAFE_INTEGER,
    min: 0
  }
};
class g$ extends IA {
  constructor(...e) {
    super(...e), ae(this, "state", void 0);
  }
  getShaders() {
    return super.getShaders({
      vs: kpn,
      fs: Gpn,
      modules: [qA, jA]
    });
  }
  get wrapLongitude() {
    return !1;
  }
  initializeState() {
    this.getAttributeManager().addInstanced({
      instanceSourcePositions: {
        size: 3,
        type: 5130,
        fp64: this.use64bitPositions(),
        transition: !0,
        accessor: "getSourcePosition"
      },
      instanceTargetPositions: {
        size: 3,
        type: 5130,
        fp64: this.use64bitPositions(),
        transition: !0,
        accessor: "getTargetPosition"
      },
      instanceSourceColors: {
        size: this.props.colorFormat.length,
        type: 5121,
        normalized: !0,
        transition: !0,
        accessor: "getSourceColor",
        defaultValue: TU
      },
      instanceTargetColors: {
        size: this.props.colorFormat.length,
        type: 5121,
        normalized: !0,
        transition: !0,
        accessor: "getTargetColor",
        defaultValue: TU
      },
      instanceWidths: {
        size: 1,
        transition: !0,
        accessor: "getWidth",
        defaultValue: 1
      },
      instanceHeights: {
        size: 1,
        transition: !0,
        accessor: "getHeight",
        defaultValue: 1
      },
      instanceTilts: {
        size: 1,
        transition: !0,
        accessor: "getTilt",
        defaultValue: 0
      }
    });
  }
  updateState(e) {
    if (super.updateState(e), e.changeFlags.extensionsChanged) {
      var n;
      const {
        gl: r
      } = this.context;
      (n = this.state.model) === null || n === void 0 || n.delete(), this.state.model = this._getModel(r), this.getAttributeManager().invalidateAll();
    }
  }
  draw({
    uniforms: e
  }) {
    const {
      widthUnits: n,
      widthScale: r,
      widthMinPixels: i,
      widthMaxPixels: o,
      greatCircle: s,
      wrapLongitude: a
    } = this.props;
    this.state.model.setUniforms(e).setUniforms({
      greatCircle: s,
      widthUnits: Ou[n],
      widthScale: r,
      widthMinPixels: i,
      widthMaxPixels: o,
      useShortestPath: a
    }).draw();
  }
  _getModel(e) {
    let n = [];
    for (let o = 0; o < 50; o++)
      n = n.concat([o, 1, 0, o, -1, 0]);
    const i = new Ta(e, {
      ...this.getShaders(),
      id: this.props.id,
      geometry: new Os({
        drawMode: 5,
        attributes: {
          positions: new Float32Array(n)
        }
      }),
      isInstanced: !0
    });
    return i.setUniforms({
      numSegments: 50
    }), i;
  }
}
ae(g$, "layerName", "ArcLayer");
ae(g$, "defaultProps", Upn);
const Hpn = new Uint16Array([0, 2, 1, 0, 3, 2]), $pn = new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]);
function qpn(t, e) {
  if (!e)
    return jpn(t);
  const n = Math.max(Math.abs(t[0][0] - t[3][0]), Math.abs(t[1][0] - t[2][0])), r = Math.max(Math.abs(t[1][1] - t[0][1]), Math.abs(t[2][1] - t[3][1])), i = Math.ceil(n / e) + 1, o = Math.ceil(r / e) + 1, s = (i - 1) * (o - 1) * 6, a = new Uint32Array(s), A = new Float32Array(i * o * 2), l = new Float64Array(i * o * 3);
  let c = 0, u = 0;
  for (let f = 0; f < i; f++) {
    const h = f / (i - 1);
    for (let d = 0; d < o; d++) {
      const I = d / (o - 1), m = Ypn(t, h, I);
      l[c * 3 + 0] = m[0], l[c * 3 + 1] = m[1], l[c * 3 + 2] = m[2] || 0, A[c * 2 + 0] = h, A[c * 2 + 1] = 1 - I, f > 0 && d > 0 && (a[u++] = c - o, a[u++] = c - o - 1, a[u++] = c - 1, a[u++] = c - o, a[u++] = c - 1, a[u++] = c), c++;
    }
  }
  return {
    vertexCount: s,
    positions: l,
    indices: a,
    texCoords: A
  };
}
function jpn(t) {
  const e = new Float64Array(12);
  for (let n = 0; n < t.length; n++)
    e[n * 3 + 0] = t[n][0], e[n * 3 + 1] = t[n][1], e[n * 3 + 2] = t[n][2] || 0;
  return {
    vertexCount: 6,
    positions: e,
    indices: Hpn,
    texCoords: $pn
  };
}
function Ypn(t, e, n) {
  return Lf(Lf(t[0], t[1], n), Lf(t[3], t[2], n), e);
}
const zpn = `
#define SHADER_NAME bitmap-layer-vertex-shader

attribute vec2 texCoords;
attribute vec3 positions;
attribute vec3 positions64Low;

varying vec2 vTexCoord;
varying vec2 vTexPos;

uniform float coordinateConversion;

const vec3 pickingColor = vec3(1.0, 0.0, 0.0);

void main(void) {
  geometry.worldPosition = positions;
  geometry.uv = texCoords;
  geometry.pickingColor = pickingColor;

  gl_Position = project_position_to_clipspace(positions, positions64Low, vec3(0.0), geometry.position);
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  vTexCoord = texCoords;

  if (coordinateConversion < -0.5) {
    vTexPos = geometry.position.xy + project_uCommonOrigin.xy;
  } else if (coordinateConversion > 0.5) {
    vTexPos = geometry.worldPosition.xy;
  }

  vec4 color = vec4(0.0);
  DECKGL_FILTER_COLOR(color, geometry);
}
`, Vpn = `
vec3 packUVsIntoRGB(vec2 uv) {
  // Extract the top 8 bits. We want values to be truncated down so we can add a fraction
  vec2 uv8bit = floor(uv * 256.);

  // Calculate the normalized remainders of u and v parts that do not fit into 8 bits
  // Scale and clamp to 0-1 range
  vec2 uvFraction = fract(uv * 256.);
  vec2 uvFraction4bit = floor(uvFraction * 16.);

  // Remainder can be encoded in blue channel, encode as 4 bits for pixel coordinates
  float fractions = uvFraction4bit.x + uvFraction4bit.y * 16.;

  return vec3(uv8bit, fractions) / 255.;
}
`, Jpn = `
#define SHADER_NAME bitmap-layer-fragment-shader

#ifdef GL_ES
precision highp float;
#endif

uniform sampler2D bitmapTexture;

varying vec2 vTexCoord;
varying vec2 vTexPos;

uniform float desaturate;
uniform vec4 transparentColor;
uniform vec3 tintColor;
uniform float opacity;

uniform float coordinateConversion;
uniform vec4 bounds;

/* projection utils */
const float TILE_SIZE = 512.0;
const float PI = 3.1415926536;
const float WORLD_SCALE = TILE_SIZE / PI / 2.0;

// from degrees to Web Mercator
vec2 lnglat_to_mercator(vec2 lnglat) {
  float x = lnglat.x;
  float y = clamp(lnglat.y, -89.9, 89.9);
  return vec2(
    radians(x) + PI,
    PI + log(tan(PI * 0.25 + radians(y) * 0.5))
  ) * WORLD_SCALE;
}

// from Web Mercator to degrees
vec2 mercator_to_lnglat(vec2 xy) {
  xy /= WORLD_SCALE;
  return degrees(vec2(
    xy.x - PI,
    atan(exp(xy.y - PI)) * 2.0 - PI * 0.5
  ));
}
/* End projection utils */

// apply desaturation
vec3 color_desaturate(vec3 color) {
  float luminance = (color.r + color.g + color.b) * 0.333333333;
  return mix(color, vec3(luminance), desaturate);
}

// apply tint
vec3 color_tint(vec3 color) {
  return color * tintColor;
}

// blend with background color
vec4 apply_opacity(vec3 color, float alpha) {
  return mix(transparentColor, vec4(color, 1.0), alpha);
}

vec2 getUV(vec2 pos) {
  return vec2(
    (pos.x - bounds[0]) / (bounds[2] - bounds[0]),
    (pos.y - bounds[3]) / (bounds[1] - bounds[3])
  );
}

`.concat(Vpn, `

void main(void) {
  vec2 uv = vTexCoord;
  if (coordinateConversion < -0.5) {
    vec2 lnglat = mercator_to_lnglat(vTexPos);
    uv = getUV(lnglat);
  } else if (coordinateConversion > 0.5) {
    vec2 commonPos = lnglat_to_mercator(vTexPos);
    uv = getUV(commonPos);
  }
  vec4 bitmapColor = texture2D(bitmapTexture, uv);

  gl_FragColor = apply_opacity(color_tint(color_desaturate(bitmapColor.rgb)), bitmapColor.a * opacity);

  geometry.uv = uv;
  DECKGL_FILTER_COLOR(gl_FragColor, geometry);

  if (picking_uActive && !picking_uAttribute) {
    // Since instance information is not used, we can use picking color for pixel index
    gl_FragColor.rgb = packUVsIntoRGB(uv);
  }
}
`), Kpn = {
  image: {
    type: "image",
    value: null,
    async: !0
  },
  bounds: {
    type: "array",
    value: [1, 0, 0, 1],
    compare: !0
  },
  _imageCoordinateSystem: wn.DEFAULT,
  desaturate: {
    type: "number",
    min: 0,
    max: 1,
    value: 0
  },
  transparentColor: {
    type: "color",
    value: [0, 0, 0, 0]
  },
  tintColor: {
    type: "color",
    value: [255, 255, 255]
  }
};
let em = class extends IA {
  constructor(...e) {
    super(...e), ae(this, "state", void 0);
  }
  getShaders() {
    return super.getShaders({
      vs: zpn,
      fs: Jpn,
      modules: [qA, jA]
    });
  }
  initializeState() {
    const e = this.getAttributeManager();
    e.remove(["instancePickingColors"]);
    const n = !0;
    e.add({
      indices: {
        size: 1,
        isIndexed: !0,
        update: (r) => r.value = this.state.mesh.indices,
        noAlloc: n
      },
      positions: {
        size: 3,
        type: 5130,
        fp64: this.use64bitPositions(),
        update: (r) => r.value = this.state.mesh.positions,
        noAlloc: n
      },
      texCoords: {
        size: 2,
        update: (r) => r.value = this.state.mesh.texCoords,
        noAlloc: n
      }
    });
  }
  updateState({
    props: e,
    oldProps: n,
    changeFlags: r
  }) {
    const i = this.getAttributeManager();
    if (r.extensionsChanged) {
      var o;
      const {
        gl: s
      } = this.context;
      (o = this.state.model) === null || o === void 0 || o.delete(), this.state.model = this._getModel(s), i.invalidateAll();
    }
    if (e.bounds !== n.bounds) {
      const s = this.state.mesh, a = this._createMesh();
      this.state.model.setVertexCount(a.vertexCount);
      for (const A in a)
        s && s[A] !== a[A] && i.invalidate(A);
      this.setState({
        mesh: a,
        ...this._getCoordinateUniforms()
      });
    } else
      e._imageCoordinateSystem !== n._imageCoordinateSystem && this.setState(this._getCoordinateUniforms());
  }
  getPickingInfo(e) {
    const {
      image: n
    } = this.props, r = e.info;
    if (!r.color || !n)
      return r.bitmap = null, r;
    const {
      width: i,
      height: o
    } = n;
    r.index = 0;
    const s = Wpn(r.color), a = [Math.floor(s[0] * i), Math.floor(s[1] * o)];
    return r.bitmap = {
      size: {
        width: i,
        height: o
      },
      uv: s,
      pixel: a
    }, r;
  }
  disablePickingIndex() {
    this.setState({
      disablePicking: !0
    });
  }
  restorePickingColors() {
    this.setState({
      disablePicking: !1
    });
  }
  _updateAutoHighlight(e) {
    super._updateAutoHighlight({
      ...e,
      color: this.encodePickingColor(0)
    });
  }
  _createMesh() {
    const {
      bounds: e
    } = this.props;
    let n = e;
    return fSe(e) && (n = [[e[0], e[1]], [e[0], e[3]], [e[2], e[3]], [e[2], e[1]]]), qpn(n, this.context.viewport.resolution);
  }
  _getModel(e) {
    return e ? new Ta(e, {
      ...this.getShaders(),
      id: this.props.id,
      geometry: new Os({
        drawMode: 4,
        vertexCount: 6
      }),
      isInstanced: !1
    }) : null;
  }
  draw(e) {
    const {
      uniforms: n,
      moduleParameters: r
    } = e, {
      model: i,
      coordinateConversion: o,
      bounds: s,
      disablePicking: a
    } = this.state, {
      image: A,
      desaturate: l,
      transparentColor: c,
      tintColor: u
    } = this.props;
    r.pickingActive && a || A && i && i.setUniforms(n).setUniforms({
      bitmapTexture: A,
      desaturate: l,
      transparentColor: c.map((f) => f / 255),
      tintColor: u.slice(0, 3).map((f) => f / 255),
      coordinateConversion: o,
      bounds: s
    }).draw();
  }
  _getCoordinateUniforms() {
    const {
      LNGLAT: e,
      CARTESIAN: n,
      DEFAULT: r
    } = wn;
    let {
      _imageCoordinateSystem: i
    } = this.props;
    if (i !== r) {
      const {
        bounds: o
      } = this.props;
      if (!fSe(o))
        throw new Error("_imageCoordinateSystem only supports rectangular bounds");
      const s = this.context.viewport.resolution ? e : n;
      if (i = i === e ? e : n, i === e && s === n)
        return {
          coordinateConversion: -1,
          bounds: o
        };
      if (i === n && s === e) {
        const a = Hc([o[0], o[1]]), A = Hc([o[2], o[3]]);
        return {
          coordinateConversion: 1,
          bounds: [a[0], a[1], A[0], A[1]]
        };
      }
    }
    return {
      coordinateConversion: 0,
      bounds: [0, 0, 0, 0]
    };
  }
};
ae(em, "layerName", "BitmapLayer");
ae(em, "defaultProps", Kpn);
function Wpn(t) {
  const [e, n, r] = t, i = (r & 240) / 256, o = (r & 15) / 16;
  return [(e + o) / 256, (n + i) / 256];
}
function fSe(t) {
  return Number.isFinite(t[0]);
}
const Xpn = `#define SHADER_NAME icon-layer-vertex-shader

attribute vec2 positions;

attribute vec3 instancePositions;
attribute vec3 instancePositions64Low;
attribute float instanceSizes;
attribute float instanceAngles;
attribute vec4 instanceColors;
attribute vec3 instancePickingColors;
attribute vec4 instanceIconFrames;
attribute float instanceColorModes;
attribute vec2 instanceOffsets;
attribute vec2 instancePixelOffset;

uniform float sizeScale;
uniform vec2 iconsTextureDim;
uniform float sizeMinPixels;
uniform float sizeMaxPixels;
uniform bool billboard;
uniform int sizeUnits;

varying float vColorMode;
varying vec4 vColor;
varying vec2 vTextureCoords;
varying vec2 uv;

vec2 rotate_by_angle(vec2 vertex, float angle) {
  float angle_radian = angle * PI / 180.0;
  float cos_angle = cos(angle_radian);
  float sin_angle = sin(angle_radian);
  mat2 rotationMatrix = mat2(cos_angle, -sin_angle, sin_angle, cos_angle);
  return rotationMatrix * vertex;
}

void main(void) {
  geometry.worldPosition = instancePositions;
  geometry.uv = positions;
  geometry.pickingColor = instancePickingColors;
  uv = positions;

  vec2 iconSize = instanceIconFrames.zw;
  // convert size in meters to pixels, then scaled and clamp
 
  // project meters to pixels and clamp to limits 
  float sizePixels = clamp(
    project_size_to_pixel(instanceSizes * sizeScale, sizeUnits), 
    sizeMinPixels, sizeMaxPixels
  );

  // scale icon height to match instanceSize
  float instanceScale = iconSize.y == 0.0 ? 0.0 : sizePixels / iconSize.y;

  // scale and rotate vertex in "pixel" value and convert back to fraction in clipspace
  vec2 pixelOffset = positions / 2.0 * iconSize + instanceOffsets;
  pixelOffset = rotate_by_angle(pixelOffset, instanceAngles) * instanceScale;
  pixelOffset += instancePixelOffset;
  pixelOffset.y *= -1.0;

  if (billboard)  {
    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, vec3(0.0), geometry.position);
    vec3 offset = vec3(pixelOffset, 0.0);
    DECKGL_FILTER_SIZE(offset, geometry);
    gl_Position.xy += project_pixel_size_to_clipspace(offset.xy);

  } else {
    vec3 offset_common = vec3(project_pixel_size(pixelOffset), 0.0);
    DECKGL_FILTER_SIZE(offset_common, geometry);
    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, offset_common, geometry.position); 
  }
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  vTextureCoords = mix(
    instanceIconFrames.xy,
    instanceIconFrames.xy + iconSize,
    (positions.xy + 1.0) / 2.0
  ) / iconsTextureDim;

  vColor = instanceColors;
  DECKGL_FILTER_COLOR(vColor, geometry);

  vColorMode = instanceColorModes;
}
`, Zpn = `#define SHADER_NAME icon-layer-fragment-shader

precision highp float;

uniform float opacity;
uniform sampler2D iconsTexture;
uniform float alphaCutoff;

varying float vColorMode;
varying vec4 vColor;
varying vec2 vTextureCoords;
varying vec2 uv;

void main(void) {
  geometry.uv = uv;

  vec4 texColor = texture2D(iconsTexture, vTextureCoords);

  // if colorMode == 0, use pixel color from the texture
  // if colorMode == 1 or rendering picking buffer, use texture as transparency mask
  vec3 color = mix(texColor.rgb, vColor.rgb, vColorMode);
  // Take the global opacity and the alpha from vColor into account for the alpha component
  float a = texColor.a * opacity * vColor.a;

  if (a < alphaCutoff) {
    discard;
  }

  gl_FragColor = vec4(color, a);
  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`, e0n = 1024, t0n = 4, gSe = () => {
}, hSe = {
  [10241]: 9987,
  [10240]: 9729,
  [10242]: 33071,
  [10243]: 33071
};
function n0n(t) {
  return Math.pow(2, Math.ceil(Math.log2(t)));
}
function r0n(t, e, n, r) {
  return n === e.width && r === e.height ? e : (t.canvas.height = r, t.canvas.width = n, t.clearRect(0, 0, t.canvas.width, t.canvas.height), t.drawImage(e, 0, 0, e.width, e.height, 0, 0, n, r), t.canvas);
}
function GT(t) {
  return t && (t.id || t.url);
}
function i0n(t, e, n, r) {
  const i = t.width, o = t.height, s = new xo(t.gl, {
    width: e,
    height: n,
    parameters: r
  });
  return Y9e(t, s, {
    targetY: 0,
    width: i,
    height: o
  }), t.delete(), s;
}
function dSe(t, e, n) {
  for (let r = 0; r < e.length; r++) {
    const {
      icon: i,
      xOffset: o
    } = e[r], s = GT(i);
    t[s] = {
      ...i,
      x: o,
      y: n
    };
  }
}
function o0n({
  icons: t,
  buffer: e,
  mapping: n = {},
  xOffset: r = 0,
  yOffset: i = 0,
  rowHeight: o = 0,
  canvasWidth: s
}) {
  let a = [];
  for (let A = 0; A < t.length; A++) {
    const l = t[A], c = GT(l);
    if (!n[c]) {
      const {
        height: u,
        width: f
      } = l;
      r + f + e > s && (dSe(n, a, i), r = 0, i = o + i + e, o = 0, a = []), a.push({
        icon: l,
        xOffset: r
      }), r = r + f + e, o = Math.max(o, u);
    }
  }
  return a.length > 0 && dSe(n, a, i), {
    mapping: n,
    rowHeight: o,
    xOffset: r,
    yOffset: i,
    canvasWidth: s,
    canvasHeight: n0n(o + i + e)
  };
}
function s0n(t, e, n) {
  if (!t || !e)
    return null;
  n = n || {};
  const r = {}, {
    iterable: i,
    objectInfo: o
  } = ZI(t);
  for (const s of i) {
    o.index++;
    const a = e(s, o), A = GT(a);
    if (!a)
      throw new Error("Icon is missing.");
    if (!a.url)
      throw new Error("Icon url is missing.");
    !r[A] && (!n[A] || a.url !== n[A].url) && (r[A] = {
      ...a,
      source: s,
      sourceIndex: o.index
    });
  }
  return r;
}
class a0n {
  constructor(e, {
    onUpdate: n = gSe,
    onError: r = gSe
  }) {
    ae(this, "gl", void 0), ae(this, "onUpdate", void 0), ae(this, "onError", void 0), ae(this, "_loadOptions", null), ae(this, "_texture", null), ae(this, "_externalTexture", null), ae(this, "_mapping", {}), ae(this, "_textureParameters", null), ae(this, "_pendingCount", 0), ae(this, "_autoPacking", !1), ae(this, "_xOffset", 0), ae(this, "_yOffset", 0), ae(this, "_rowHeight", 0), ae(this, "_buffer", t0n), ae(this, "_canvasWidth", e0n), ae(this, "_canvasHeight", 0), ae(this, "_canvas", null), this.gl = e, this.onUpdate = n, this.onError = r;
  }
  finalize() {
    var e;
    (e = this._texture) === null || e === void 0 || e.delete();
  }
  getTexture() {
    return this._texture || this._externalTexture;
  }
  getIconMapping(e) {
    const n = this._autoPacking ? GT(e) : e;
    return this._mapping[n] || {};
  }
  setProps({
    loadOptions: e,
    autoPacking: n,
    iconAtlas: r,
    iconMapping: i,
    textureParameters: o
  }) {
    if (e && (this._loadOptions = e), n !== void 0 && (this._autoPacking = n), i && (this._mapping = i), r) {
      var s;
      (s = this._texture) === null || s === void 0 || s.delete(), this._texture = null, this._externalTexture = r;
    }
    o && (this._textureParameters = o);
  }
  get isLoaded() {
    return this._pendingCount === 0;
  }
  packIcons(e, n) {
    if (!this._autoPacking || typeof document > "u")
      return;
    const r = Object.values(s0n(e, n, this._mapping) || {});
    if (r.length > 0) {
      const {
        mapping: i,
        xOffset: o,
        yOffset: s,
        rowHeight: a,
        canvasHeight: A
      } = o0n({
        icons: r,
        buffer: this._buffer,
        canvasWidth: this._canvasWidth,
        mapping: this._mapping,
        rowHeight: this._rowHeight,
        xOffset: this._xOffset,
        yOffset: this._yOffset
      });
      this._rowHeight = a, this._mapping = i, this._xOffset = o, this._yOffset = s, this._canvasHeight = A, this._texture || (this._texture = new xo(this.gl, {
        width: this._canvasWidth,
        height: this._canvasHeight,
        parameters: this._textureParameters || hSe
      })), this._texture.height !== this._canvasHeight && (this._texture = i0n(this._texture, this._canvasWidth, this._canvasHeight, this._textureParameters || hSe)), this.onUpdate(), this._canvas = this._canvas || document.createElement("canvas"), this._loadIcons(r);
    }
  }
  _loadIcons(e) {
    const n = this._canvas.getContext("2d");
    for (const r of e)
      this._pendingCount++, TI(r.url, dle, this._loadOptions).then((i) => {
        const o = GT(r), {
          x: s,
          y: a,
          width: A,
          height: l
        } = this._mapping[o], c = r0n(n, i, A, l);
        this._texture.setSubImageData({
          data: c,
          x: s,
          y: a,
          width: A,
          height: l
        }), this._texture.generateMipmap(), this.onUpdate();
      }).catch((i) => {
        this.onError({
          url: r.url,
          source: r.source,
          sourceIndex: r.sourceIndex,
          loadOptions: this._loadOptions,
          error: i
        });
      }).finally(() => {
        this._pendingCount--;
      });
  }
}
const jqe = [0, 0, 0, 255], A0n = {
  iconAtlas: {
    type: "image",
    value: null,
    async: !0
  },
  iconMapping: {
    type: "object",
    value: {},
    async: !0
  },
  sizeScale: {
    type: "number",
    value: 1,
    min: 0
  },
  billboard: !0,
  sizeUnits: "pixels",
  sizeMinPixels: {
    type: "number",
    min: 0,
    value: 0
  },
  sizeMaxPixels: {
    type: "number",
    min: 0,
    value: Number.MAX_SAFE_INTEGER
  },
  alphaCutoff: {
    type: "number",
    value: 0.05,
    min: 0,
    max: 1
  },
  getPosition: {
    type: "accessor",
    value: (t) => t.position
  },
  getIcon: {
    type: "accessor",
    value: (t) => t.icon
  },
  getColor: {
    type: "accessor",
    value: jqe
  },
  getSize: {
    type: "accessor",
    value: 1
  },
  getAngle: {
    type: "accessor",
    value: 0
  },
  getPixelOffset: {
    type: "accessor",
    value: [0, 0]
  },
  onIconError: {
    type: "function",
    value: null,
    compare: !1,
    optional: !0
  }
};
class IM extends IA {
  constructor(...e) {
    super(...e), ae(this, "state", void 0);
  }
  getShaders() {
    return super.getShaders({
      vs: Xpn,
      fs: Zpn,
      modules: [qA, jA]
    });
  }
  initializeState() {
    this.state = {
      iconManager: new a0n(this.context.gl, {
        onUpdate: this._onUpdate.bind(this),
        onError: this._onError.bind(this)
      })
    }, this.getAttributeManager().addInstanced({
      instancePositions: {
        size: 3,
        type: 5130,
        fp64: this.use64bitPositions(),
        transition: !0,
        accessor: "getPosition"
      },
      instanceSizes: {
        size: 1,
        transition: !0,
        accessor: "getSize",
        defaultValue: 1
      },
      instanceOffsets: {
        size: 2,
        accessor: "getIcon",
        transform: this.getInstanceOffset
      },
      instanceIconFrames: {
        size: 4,
        accessor: "getIcon",
        transform: this.getInstanceIconFrame
      },
      instanceColorModes: {
        size: 1,
        type: 5121,
        accessor: "getIcon",
        transform: this.getInstanceColorMode
      },
      instanceColors: {
        size: this.props.colorFormat.length,
        type: 5121,
        normalized: !0,
        transition: !0,
        accessor: "getColor",
        defaultValue: jqe
      },
      instanceAngles: {
        size: 1,
        transition: !0,
        accessor: "getAngle"
      },
      instancePixelOffset: {
        size: 2,
        transition: !0,
        accessor: "getPixelOffset"
      }
    });
  }
  updateState(e) {
    super.updateState(e);
    const {
      props: n,
      oldProps: r,
      changeFlags: i
    } = e, o = this.getAttributeManager(), {
      iconAtlas: s,
      iconMapping: a,
      data: A,
      getIcon: l,
      textureParameters: c
    } = n, {
      iconManager: u
    } = this.state, f = s || this.internalState.isAsyncPropLoading("iconAtlas");
    if (u.setProps({
      loadOptions: n.loadOptions,
      autoPacking: !f,
      iconAtlas: s,
      iconMapping: f ? a : null,
      textureParameters: c
    }), f ? r.iconMapping !== n.iconMapping && o.invalidate("getIcon") : (i.dataChanged || i.updateTriggersChanged && (i.updateTriggersChanged.all || i.updateTriggersChanged.getIcon)) && u.packIcons(A, l), i.extensionsChanged) {
      var h;
      const {
        gl: d
      } = this.context;
      (h = this.state.model) === null || h === void 0 || h.delete(), this.state.model = this._getModel(d), o.invalidateAll();
    }
  }
  get isLoaded() {
    return super.isLoaded && this.state.iconManager.isLoaded;
  }
  finalizeState(e) {
    super.finalizeState(e), this.state.iconManager.finalize();
  }
  draw({
    uniforms: e
  }) {
    const {
      sizeScale: n,
      sizeMinPixels: r,
      sizeMaxPixels: i,
      sizeUnits: o,
      billboard: s,
      alphaCutoff: a
    } = this.props, {
      iconManager: A
    } = this.state, l = A.getTexture();
    l && this.state.model.setUniforms(e).setUniforms({
      iconsTexture: l,
      iconsTextureDim: [l.width, l.height],
      sizeUnits: Ou[o],
      sizeScale: n,
      sizeMinPixels: r,
      sizeMaxPixels: i,
      billboard: s,
      alphaCutoff: a
    }).draw();
  }
  _getModel(e) {
    const n = [-1, -1, -1, 1, 1, 1, 1, -1];
    return new Ta(e, {
      ...this.getShaders(),
      id: this.props.id,
      geometry: new Os({
        drawMode: 6,
        attributes: {
          positions: {
            size: 2,
            value: new Float32Array(n)
          }
        }
      }),
      isInstanced: !0
    });
  }
  _onUpdate() {
    this.setNeedsRedraw();
  }
  _onError(e) {
    var n;
    const r = (n = this.getCurrentLayer()) === null || n === void 0 ? void 0 : n.props.onIconError;
    r ? r(e) : Rr.error(e.error.message)();
  }
  getInstanceOffset(e) {
    const {
      width: n,
      height: r,
      anchorX: i = n / 2,
      anchorY: o = r / 2
    } = this.state.iconManager.getIconMapping(e);
    return [n / 2 - i, r / 2 - o];
  }
  getInstanceColorMode(e) {
    return this.state.iconManager.getIconMapping(e).mask ? 1 : 0;
  }
  getInstanceIconFrame(e) {
    const {
      x: n,
      y: r,
      width: i,
      height: o
    } = this.state.iconManager.getIconMapping(e);
    return [n, r, i, o];
  }
}
ae(IM, "defaultProps", A0n);
ae(IM, "layerName", "IconLayer");
const l0n = `#define SHADER_NAME line-layer-vertex-shader

attribute vec3 positions;
attribute vec3 instanceSourcePositions;
attribute vec3 instanceTargetPositions;
attribute vec3 instanceSourcePositions64Low;
attribute vec3 instanceTargetPositions64Low;
attribute vec4 instanceColors;
attribute vec3 instancePickingColors;
attribute float instanceWidths;

uniform float opacity;
uniform float widthScale;
uniform float widthMinPixels;
uniform float widthMaxPixels;
uniform float useShortestPath;
uniform int widthUnits;

varying vec4 vColor;
varying vec2 uv;

// offset vector by strokeWidth pixels
// offset_direction is -1 (left) or 1 (right)
vec2 getExtrusionOffset(vec2 line_clipspace, float offset_direction, float width) {
  // normalized direction of the line
  vec2 dir_screenspace = normalize(line_clipspace * project_uViewportSize);
  // rotate by 90 degrees
  dir_screenspace = vec2(-dir_screenspace.y, dir_screenspace.x);

  return dir_screenspace * offset_direction * width / 2.0;
}

vec3 splitLine(vec3 a, vec3 b, float x) {
  float t = (x - a.x) / (b.x - a.x);
  return vec3(x, mix(a.yz, b.yz, t));
}

void main(void) {
  geometry.worldPosition = instanceSourcePositions;
  geometry.worldPositionAlt = instanceTargetPositions;

  vec3 source_world = instanceSourcePositions;
  vec3 target_world = instanceTargetPositions;
  vec3 source_world_64low = instanceSourcePositions64Low;
  vec3 target_world_64low = instanceTargetPositions64Low;

  if (useShortestPath > 0.5 || useShortestPath < -0.5) {
    source_world.x = mod(source_world.x + 180., 360.0) - 180.;
    target_world.x = mod(target_world.x + 180., 360.0) - 180.;
    float deltaLng = target_world.x - source_world.x;

    if (deltaLng * useShortestPath > 180.) {
      source_world.x += 360. * useShortestPath;
      source_world = splitLine(source_world, target_world, 180. * useShortestPath);
      source_world_64low = vec3(0.0);
    } else if (deltaLng * useShortestPath < -180.) {
      target_world.x += 360. * useShortestPath;
      target_world = splitLine(source_world, target_world, 180. * useShortestPath);
      target_world_64low = vec3(0.0);
    } else if (useShortestPath < 0.) {
      // Line is not split, abort
      gl_Position = vec4(0.);
      return;
    }
  }

  // Position
  vec4 source_commonspace;
  vec4 target_commonspace;
  vec4 source = project_position_to_clipspace(source_world, source_world_64low, vec3(0.), source_commonspace);
  vec4 target = project_position_to_clipspace(target_world, target_world_64low, vec3(0.), target_commonspace);
  
  // linear interpolation of source & target to pick right coord
  float segmentIndex = positions.x;
  vec4 p = mix(source, target, segmentIndex);
  geometry.position = mix(source_commonspace, target_commonspace, segmentIndex);
  uv = positions.xy;
  geometry.uv = uv;
  geometry.pickingColor = instancePickingColors;

  // Multiply out width and clamp to limits
  float widthPixels = clamp(
    project_size_to_pixel(instanceWidths * widthScale, widthUnits),
    widthMinPixels, widthMaxPixels
  );

  // extrude
  vec3 offset = vec3(
    getExtrusionOffset(target.xy - source.xy, positions.y, widthPixels),
    0.0);
  DECKGL_FILTER_SIZE(offset, geometry);
  gl_Position = p + vec4(project_pixel_size_to_clipspace(offset.xy), 0.0, 0.0);
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  // Color
  vColor = vec4(instanceColors.rgb, instanceColors.a * opacity);
  DECKGL_FILTER_COLOR(vColor, geometry);
}
`, c0n = `#define SHADER_NAME line-layer-fragment-shader

precision highp float;

varying vec4 vColor;
varying vec2 uv;

void main(void) {
  geometry.uv = uv;

  gl_FragColor = vColor;

  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`, u0n = [0, 0, 0, 255], f0n = {
  getSourcePosition: {
    type: "accessor",
    value: (t) => t.sourcePosition
  },
  getTargetPosition: {
    type: "accessor",
    value: (t) => t.targetPosition
  },
  getColor: {
    type: "accessor",
    value: u0n
  },
  getWidth: {
    type: "accessor",
    value: 1
  },
  widthUnits: "pixels",
  widthScale: {
    type: "number",
    value: 1,
    min: 0
  },
  widthMinPixels: {
    type: "number",
    value: 0,
    min: 0
  },
  widthMaxPixels: {
    type: "number",
    value: Number.MAX_SAFE_INTEGER,
    min: 0
  }
};
class q_ extends IA {
  getShaders() {
    return super.getShaders({
      vs: l0n,
      fs: c0n,
      modules: [qA, jA]
    });
  }
  get wrapLongitude() {
    return !1;
  }
  initializeState() {
    this.getAttributeManager().addInstanced({
      instanceSourcePositions: {
        size: 3,
        type: 5130,
        fp64: this.use64bitPositions(),
        transition: !0,
        accessor: "getSourcePosition"
      },
      instanceTargetPositions: {
        size: 3,
        type: 5130,
        fp64: this.use64bitPositions(),
        transition: !0,
        accessor: "getTargetPosition"
      },
      instanceColors: {
        size: this.props.colorFormat.length,
        type: 5121,
        normalized: !0,
        transition: !0,
        accessor: "getColor",
        defaultValue: [0, 0, 0, 255]
      },
      instanceWidths: {
        size: 1,
        transition: !0,
        accessor: "getWidth",
        defaultValue: 1
      }
    });
  }
  updateState(e) {
    if (super.updateState(e), e.changeFlags.extensionsChanged) {
      var n;
      const {
        gl: r
      } = this.context;
      (n = this.state.model) === null || n === void 0 || n.delete(), this.state.model = this._getModel(r), this.getAttributeManager().invalidateAll();
    }
  }
  draw({
    uniforms: e
  }) {
    const {
      widthUnits: n,
      widthScale: r,
      widthMinPixels: i,
      widthMaxPixels: o,
      wrapLongitude: s
    } = this.props;
    this.state.model.setUniforms(e).setUniforms({
      widthUnits: Ou[n],
      widthScale: r,
      widthMinPixels: i,
      widthMaxPixels: o,
      useShortestPath: s ? 1 : 0
    }).draw(), s && this.state.model.setUniforms({
      useShortestPath: -1
    }).draw();
  }
  _getModel(e) {
    const n = [0, -1, 0, 0, 1, 0, 1, -1, 0, 1, 1, 0];
    return new Ta(e, {
      ...this.getShaders(),
      id: this.props.id,
      geometry: new Os({
        drawMode: 5,
        attributes: {
          positions: new Float32Array(n)
        }
      }),
      isInstanced: !0
    });
  }
}
ae(q_, "layerName", "LineLayer");
ae(q_, "defaultProps", f0n);
const g0n = `#define SHADER_NAME point-cloud-layer-vertex-shader

attribute vec3 positions;
attribute vec3 instanceNormals;
attribute vec4 instanceColors;
attribute vec3 instancePositions;
attribute vec3 instancePositions64Low;
attribute vec3 instancePickingColors;

uniform float opacity;
uniform float radiusPixels;
uniform int sizeUnits;

varying vec4 vColor;
varying vec2 unitPosition;

void main(void) {
  geometry.worldPosition = instancePositions;
  geometry.normal = project_normal(instanceNormals);

  // position on the containing square in [-1, 1] space
  unitPosition = positions.xy;
  geometry.uv = unitPosition;
  geometry.pickingColor = instancePickingColors;

  // Find the center of the point and add the current vertex
  vec3 offset = vec3(positions.xy * project_size_to_pixel(radiusPixels, sizeUnits), 0.0);
  DECKGL_FILTER_SIZE(offset, geometry);

  gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, vec3(0.), geometry.position);
  gl_Position.xy += project_pixel_size_to_clipspace(offset.xy);
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  // Apply lighting
  vec3 lightColor = lighting_getLightColor(instanceColors.rgb, project_uCameraPosition, geometry.position.xyz, geometry.normal);

  // Apply opacity to instance color, or return instance picking color
  vColor = vec4(lightColor, instanceColors.a * opacity);
  DECKGL_FILTER_COLOR(vColor, geometry);
}
`, h0n = `#define SHADER_NAME point-cloud-layer-fragment-shader

precision highp float;

varying vec4 vColor;
varying vec2 unitPosition;

void main(void) {
  geometry.uv = unitPosition;

  float distToCenter = length(unitPosition);

  if (distToCenter > 1.0) {
    discard;
  }

  gl_FragColor = vColor;
  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`, Yqe = [0, 0, 0, 255], zqe = [0, 0, 1], d0n = {
  sizeUnits: "pixels",
  pointSize: {
    type: "number",
    min: 0,
    value: 10
  },
  getPosition: {
    type: "accessor",
    value: (t) => t.position
  },
  getNormal: {
    type: "accessor",
    value: zqe
  },
  getColor: {
    type: "accessor",
    value: Yqe
  },
  material: !0,
  radiusPixels: {
    deprecatedFor: "pointSize"
  }
};
function p0n(t) {
  const {
    header: e,
    attributes: n
  } = t;
  !e || !n || (t.length = e.vertexCount, n.POSITION && (n.instancePositions = n.POSITION), n.NORMAL && (n.instanceNormals = n.NORMAL), n.COLOR_0 && (n.instanceColors = n.COLOR_0));
}
class h$ extends IA {
  getShaders() {
    return super.getShaders({
      vs: g0n,
      fs: h0n,
      modules: [qA, cM, jA]
    });
  }
  initializeState() {
    this.getAttributeManager().addInstanced({
      instancePositions: {
        size: 3,
        type: 5130,
        fp64: this.use64bitPositions(),
        transition: !0,
        accessor: "getPosition"
      },
      instanceNormals: {
        size: 3,
        transition: !0,
        accessor: "getNormal",
        defaultValue: zqe
      },
      instanceColors: {
        size: this.props.colorFormat.length,
        type: 5121,
        normalized: !0,
        transition: !0,
        accessor: "getColor",
        defaultValue: Yqe
      }
    });
  }
  updateState(e) {
    const {
      changeFlags: n,
      props: r
    } = e;
    if (super.updateState(e), n.extensionsChanged) {
      var i;
      const {
        gl: o
      } = this.context;
      (i = this.state.model) === null || i === void 0 || i.delete(), this.state.model = this._getModel(o), this.getAttributeManager().invalidateAll();
    }
    n.dataChanged && p0n(r.data);
  }
  draw({
    uniforms: e
  }) {
    const {
      pointSize: n,
      sizeUnits: r
    } = this.props;
    this.state.model.setUniforms(e).setUniforms({
      sizeUnits: Ou[r],
      radiusPixels: n
    }).draw();
  }
  _getModel(e) {
    const n = [];
    for (let r = 0; r < 3; r++) {
      const i = r / 3 * Math.PI * 2;
      n.push(Math.cos(i) * 2, Math.sin(i) * 2, 0);
    }
    return new Ta(e, {
      ...this.getShaders(),
      id: this.props.id,
      geometry: new Os({
        drawMode: 4,
        attributes: {
          positions: new Float32Array(n)
        }
      }),
      isInstanced: !0
    });
  }
}
ae(h$, "layerName", "PointCloudLayer");
ae(h$, "defaultProps", d0n);
const I0n = `#define SHADER_NAME scatterplot-layer-vertex-shader

attribute vec3 positions;

attribute vec3 instancePositions;
attribute vec3 instancePositions64Low;
attribute float instanceRadius;
attribute float instanceLineWidths;
attribute vec4 instanceFillColors;
attribute vec4 instanceLineColors;
attribute vec3 instancePickingColors;

uniform float opacity;
uniform float radiusScale;
uniform float radiusMinPixels;
uniform float radiusMaxPixels;
uniform float lineWidthScale;
uniform float lineWidthMinPixels;
uniform float lineWidthMaxPixels;
uniform float stroked;
uniform bool filled;
uniform bool antialiasing;
uniform bool billboard;
uniform int radiusUnits;
uniform int lineWidthUnits;

varying vec4 vFillColor;
varying vec4 vLineColor;
varying vec2 unitPosition;
varying float innerUnitRadius;
varying float outerRadiusPixels;


void main(void) {
  geometry.worldPosition = instancePositions;

  // Multiply out radius and clamp to limits
  outerRadiusPixels = clamp(
    project_size_to_pixel(radiusScale * instanceRadius, radiusUnits),
    radiusMinPixels, radiusMaxPixels
  );
  
  // Multiply out line width and clamp to limits
  float lineWidthPixels = clamp(
    project_size_to_pixel(lineWidthScale * instanceLineWidths, lineWidthUnits),
    lineWidthMinPixels, lineWidthMaxPixels
  );

  // outer radius needs to offset by half stroke width
  outerRadiusPixels += stroked * lineWidthPixels / 2.0;

  // Expand geometry to accomodate edge smoothing
  float edgePadding = antialiasing ? (outerRadiusPixels + SMOOTH_EDGE_RADIUS) / outerRadiusPixels : 1.0;

  // position on the containing square in [-1, 1] space
  unitPosition = edgePadding * positions.xy;
  geometry.uv = unitPosition;
  geometry.pickingColor = instancePickingColors;

  innerUnitRadius = 1.0 - stroked * lineWidthPixels / outerRadiusPixels;
  
  if (billboard) {
    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, vec3(0.0), geometry.position);
    vec3 offset = edgePadding * positions * outerRadiusPixels;
    DECKGL_FILTER_SIZE(offset, geometry);
    gl_Position.xy += project_pixel_size_to_clipspace(offset.xy);
  } else {
    vec3 offset = edgePadding * positions * project_pixel_size(outerRadiusPixels);
    DECKGL_FILTER_SIZE(offset, geometry);
    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, offset, geometry.position);
  }

  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  // Apply opacity to instance color, or return instance picking color
  vFillColor = vec4(instanceFillColors.rgb, instanceFillColors.a * opacity);
  DECKGL_FILTER_COLOR(vFillColor, geometry);
  vLineColor = vec4(instanceLineColors.rgb, instanceLineColors.a * opacity);
  DECKGL_FILTER_COLOR(vLineColor, geometry);
}
`, m0n = `#define SHADER_NAME scatterplot-layer-fragment-shader

precision highp float;

uniform bool filled;
uniform float stroked;
uniform bool antialiasing;

varying vec4 vFillColor;
varying vec4 vLineColor;
varying vec2 unitPosition;
varying float innerUnitRadius;
varying float outerRadiusPixels;

void main(void) {
  geometry.uv = unitPosition;

  float distToCenter = length(unitPosition) * outerRadiusPixels;
  float inCircle = antialiasing ? 
    smoothedge(distToCenter, outerRadiusPixels) : 
    step(distToCenter, outerRadiusPixels);

  if (inCircle == 0.0) {
    discard;
  }

  if (stroked > 0.5) {
    float isLine = antialiasing ? 
      smoothedge(innerUnitRadius * outerRadiusPixels, distToCenter) :
      step(innerUnitRadius * outerRadiusPixels, distToCenter);

    if (filled) {
      gl_FragColor = mix(vFillColor, vLineColor, isLine);
    } else {
      if (isLine == 0.0) {
        discard;
      }
      gl_FragColor = vec4(vLineColor.rgb, vLineColor.a * isLine);
    }
  } else if (filled) {
    gl_FragColor = vFillColor;
  } else {
    discard;
  }

  gl_FragColor.a *= inCircle;
  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`, pSe = [0, 0, 0, 255], C0n = {
  radiusUnits: "meters",
  radiusScale: {
    type: "number",
    min: 0,
    value: 1
  },
  radiusMinPixels: {
    type: "number",
    min: 0,
    value: 0
  },
  radiusMaxPixels: {
    type: "number",
    min: 0,
    value: Number.MAX_SAFE_INTEGER
  },
  lineWidthUnits: "meters",
  lineWidthScale: {
    type: "number",
    min: 0,
    value: 1
  },
  lineWidthMinPixels: {
    type: "number",
    min: 0,
    value: 0
  },
  lineWidthMaxPixels: {
    type: "number",
    min: 0,
    value: Number.MAX_SAFE_INTEGER
  },
  stroked: !1,
  filled: !0,
  billboard: !1,
  antialiasing: !0,
  getPosition: {
    type: "accessor",
    value: (t) => t.position
  },
  getRadius: {
    type: "accessor",
    value: 1
  },
  getFillColor: {
    type: "accessor",
    value: pSe
  },
  getLineColor: {
    type: "accessor",
    value: pSe
  },
  getLineWidth: {
    type: "accessor",
    value: 1
  },
  strokeWidth: {
    deprecatedFor: "getLineWidth"
  },
  outline: {
    deprecatedFor: "stroked"
  },
  getColor: {
    deprecatedFor: ["getFillColor", "getLineColor"]
  }
};
class LI extends IA {
  getShaders() {
    return super.getShaders({
      vs: I0n,
      fs: m0n,
      modules: [qA, jA]
    });
  }
  initializeState() {
    this.getAttributeManager().addInstanced({
      instancePositions: {
        size: 3,
        type: 5130,
        fp64: this.use64bitPositions(),
        transition: !0,
        accessor: "getPosition"
      },
      instanceRadius: {
        size: 1,
        transition: !0,
        accessor: "getRadius",
        defaultValue: 1
      },
      instanceFillColors: {
        size: this.props.colorFormat.length,
        transition: !0,
        normalized: !0,
        type: 5121,
        accessor: "getFillColor",
        defaultValue: [0, 0, 0, 255]
      },
      instanceLineColors: {
        size: this.props.colorFormat.length,
        transition: !0,
        normalized: !0,
        type: 5121,
        accessor: "getLineColor",
        defaultValue: [0, 0, 0, 255]
      },
      instanceLineWidths: {
        size: 1,
        transition: !0,
        accessor: "getLineWidth",
        defaultValue: 1
      }
    });
  }
  updateState(e) {
    if (super.updateState(e), e.changeFlags.extensionsChanged) {
      var n;
      const {
        gl: r
      } = this.context;
      (n = this.state.model) === null || n === void 0 || n.delete(), this.state.model = this._getModel(r), this.getAttributeManager().invalidateAll();
    }
  }
  draw({
    uniforms: e
  }) {
    const {
      radiusUnits: n,
      radiusScale: r,
      radiusMinPixels: i,
      radiusMaxPixels: o,
      stroked: s,
      filled: a,
      billboard: A,
      antialiasing: l,
      lineWidthUnits: c,
      lineWidthScale: u,
      lineWidthMinPixels: f,
      lineWidthMaxPixels: h
    } = this.props;
    this.state.model.setUniforms(e).setUniforms({
      stroked: s ? 1 : 0,
      filled: a,
      billboard: A,
      antialiasing: l,
      radiusUnits: Ou[n],
      radiusScale: r,
      radiusMinPixels: i,
      radiusMaxPixels: o,
      lineWidthUnits: Ou[c],
      lineWidthScale: u,
      lineWidthMinPixels: f,
      lineWidthMaxPixels: h
    }).draw();
  }
  _getModel(e) {
    const n = [-1, -1, 0, 1, -1, 0, 1, 1, 0, -1, 1, 0];
    return new Ta(e, {
      ...this.getShaders(),
      id: this.props.id,
      geometry: new Os({
        drawMode: 6,
        vertexCount: 4,
        attributes: {
          positions: {
            size: 3,
            value: new Float32Array(n)
          }
        }
      }),
      isInstanced: !0
    });
  }
}
ae(LI, "defaultProps", C0n);
ae(LI, "layerName", "ScatterplotLayer");
const ace = {
  CLOCKWISE: 1,
  COUNTER_CLOCKWISE: -1
};
function Ace(t, e, n = {}) {
  return E0n(t, n) !== e ? (y0n(t, n), !0) : !1;
}
function E0n(t, e = {}) {
  return Math.sign(NU(t, e));
}
function NU(t, e = {}) {
  const {
    start: n = 0,
    end: r = t.length
  } = e, i = e.size || 2;
  let o = 0;
  for (let s = n, a = r - i; s < r; s += i)
    o += (t[s] - t[a]) * (t[s + 1] + t[a + 1]), a = s;
  return o / 2;
}
function y0n(t, e) {
  const {
    start: n = 0,
    end: r = t.length,
    size: i = 2
  } = e, o = (r - n) / i, s = Math.floor(o / 2);
  for (let a = 0; a < s; ++a) {
    const A = n + a * i, l = n + (o - 1 - a) * i;
    for (let c = 0; c < i; ++c) {
      const u = t[A + c];
      t[A + c] = t[l + c], t[l + c] = u;
    }
  }
}
function v0n(t, e, n = 2, r) {
  const i = e && e.length, o = i ? e[0] * n : t.length;
  let s = Vqe(t, 0, o, n, !0, r && r[0]);
  const a = [];
  if (!s || s.next === s.prev)
    return a;
  let A, l, c, u, f, h, d;
  if (i && (s = Q0n(t, e, s, n, r)), t.length > 80 * n) {
    u = l = t[0], f = c = t[1];
    for (let I = n; I < o; I += n)
      h = t[I], d = t[I + 1], h < u && (u = h), d < f && (f = d), h > l && (l = h), d > c && (c = d);
    A = Math.max(l - u, c - f), A = A !== 0 ? 1 / A : 0;
  }
  return UT(s, a, n, u, f, A), a;
}
function Vqe(t, e, n, r, i, o) {
  let s, a;
  if (o === void 0 && (o = NU(t, {
    start: e,
    end: n,
    size: r
  })), i === o < 0)
    for (s = e; s < n; s += r)
      a = ISe(s, t[s], t[s + 1], a);
  else
    for (s = n - r; s >= e; s -= r)
      a = ISe(s, t[s], t[s + 1], a);
  return a && d$(a, a.next) && ($T(a), a = a.next), a;
}
function KC(t, e) {
  if (!t)
    return t;
  e || (e = t);
  let n = t, r;
  do
    if (r = !1, !n.steiner && (d$(n, n.next) || Ws(n.prev, n, n.next) === 0)) {
      if ($T(n), n = e = n.prev, n === n.next)
        break;
      r = !0;
    } else
      n = n.next;
  while (r || n !== e);
  return e;
}
function UT(t, e, n, r, i, o, s) {
  if (!t)
    return;
  !s && o && T0n(t, r, i, o);
  let a = t, A, l;
  for (; t.prev !== t.next; ) {
    if (A = t.prev, l = t.next, o ? b0n(t, r, i, o) : B0n(t)) {
      e.push(A.i / n), e.push(t.i / n), e.push(l.i / n), $T(t), t = l.next, a = l.next;
      continue;
    }
    if (t = l, t === a) {
      s ? s === 1 ? (t = _0n(KC(t), e, n), UT(t, e, n, r, i, o, 2)) : s === 2 && S0n(t, e, n, r, i, o) : UT(KC(t), e, n, r, i, o, 1);
      break;
    }
  }
}
function B0n(t) {
  const e = t.prev, n = t, r = t.next;
  if (Ws(e, n, r) >= 0)
    return !1;
  let i = t.next.next;
  for (; i !== t.prev; ) {
    if (d_(e.x, e.y, n.x, n.y, r.x, r.y, i.x, i.y) && Ws(i.prev, i, i.next) >= 0)
      return !1;
    i = i.next;
  }
  return !0;
}
function b0n(t, e, n, r) {
  const i = t.prev, o = t, s = t.next;
  if (Ws(i, o, s) >= 0)
    return !1;
  const a = i.x < o.x ? i.x < s.x ? i.x : s.x : o.x < s.x ? o.x : s.x, A = i.y < o.y ? i.y < s.y ? i.y : s.y : o.y < s.y ? o.y : s.y, l = i.x > o.x ? i.x > s.x ? i.x : s.x : o.x > s.x ? o.x : s.x, c = i.y > o.y ? i.y > s.y ? i.y : s.y : o.y > s.y ? o.y : s.y, u = ete(a, A, e, n, r), f = ete(l, c, e, n, r);
  let h = t.prevZ, d = t.nextZ;
  for (; h && h.z >= u && d && d.z <= f; ) {
    if (h !== t.prev && h !== t.next && d_(i.x, i.y, o.x, o.y, s.x, s.y, h.x, h.y) && Ws(h.prev, h, h.next) >= 0 || (h = h.prevZ, d !== t.prev && d !== t.next && d_(i.x, i.y, o.x, o.y, s.x, s.y, d.x, d.y) && Ws(d.prev, d, d.next) >= 0))
      return !1;
    d = d.nextZ;
  }
  for (; h && h.z >= u; ) {
    if (h !== t.prev && h !== t.next && d_(i.x, i.y, o.x, o.y, s.x, s.y, h.x, h.y) && Ws(h.prev, h, h.next) >= 0)
      return !1;
    h = h.prevZ;
  }
  for (; d && d.z <= f; ) {
    if (d !== t.prev && d !== t.next && d_(i.x, i.y, o.x, o.y, s.x, s.y, d.x, d.y) && Ws(d.prev, d, d.next) >= 0)
      return !1;
    d = d.nextZ;
  }
  return !0;
}
function _0n(t, e, n) {
  let r = t;
  do {
    const i = r.prev, o = r.next.next;
    !d$(i, o) && Jqe(i, r, r.next, o) && HT(i, o) && HT(o, i) && (e.push(i.i / n), e.push(r.i / n), e.push(o.i / n), $T(r), $T(r.next), r = t = o), r = r.next;
  } while (r !== t);
  return KC(r);
}
function S0n(t, e, n, r, i, o) {
  let s = t;
  do {
    let a = s.next.next;
    for (; a !== s.prev; ) {
      if (s.i !== a.i && M0n(s, a)) {
        let A = Kqe(s, a);
        s = KC(s, s.next), A = KC(A, A.next), UT(s, e, n, r, i, o), UT(A, e, n, r, i, o);
        return;
      }
      a = a.next;
    }
    s = s.next;
  } while (s !== t);
}
function Q0n(t, e, n, r, i) {
  const o = [];
  let s, a, A, l, c;
  for (s = 0, a = e.length; s < a; s++)
    A = e[s] * r, l = s < a - 1 ? e[s + 1] * r : t.length, c = Vqe(t, A, l, r, !1, i && i[s + 1]), c === c.next && (c.steiner = !0), o.push(L0n(c));
  for (o.sort(w0n), s = 0; s < o.length; s++)
    x0n(o[s], n), n = KC(n, n.next);
  return n;
}
function w0n(t, e) {
  return t.x - e.x;
}
function x0n(t, e) {
  if (e = R0n(t, e), e) {
    const n = Kqe(e, t);
    KC(e, e.next), KC(n, n.next);
  }
}
function R0n(t, e) {
  let n = e;
  const r = t.x, i = t.y;
  let o = -1 / 0, s;
  do {
    if (i <= n.y && i >= n.next.y && n.next.y !== n.y) {
      const f = n.x + (i - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
      if (f <= r && f > o) {
        if (o = f, f === r) {
          if (i === n.y)
            return n;
          if (i === n.next.y)
            return n.next;
        }
        s = n.x < n.next.x ? n : n.next;
      }
    }
    n = n.next;
  } while (n !== e);
  if (!s)
    return null;
  if (r === o)
    return s;
  const a = s, A = s.x, l = s.y;
  let c = 1 / 0, u;
  n = s;
  do
    r >= n.x && n.x >= A && r !== n.x && d_(i < l ? r : o, i, A, l, i < l ? o : r, i, n.x, n.y) && (u = Math.abs(i - n.y) / (r - n.x), HT(n, t) && (u < c || u === c && (n.x > s.x || n.x === s.x && D0n(s, n))) && (s = n, c = u)), n = n.next;
  while (n !== a);
  return s;
}
function D0n(t, e) {
  return Ws(t.prev, t, e.prev) < 0 && Ws(e.next, t, t.next) < 0;
}
function T0n(t, e, n, r) {
  let i = t;
  do
    i.z === null && (i.z = ete(i.x, i.y, e, n, r)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
  while (i !== t);
  i.prevZ.nextZ = null, i.prevZ = null, N0n(i);
}
function N0n(t) {
  let e, n, r = 1, i, o, s, a, A, l;
  do {
    for (o = t, t = null, l = null, i = 0; o; ) {
      for (i++, a = o, s = 0, n = 0; n < r && (s++, a = a.nextZ, !!a); n++)
        ;
      for (A = r; s > 0 || A > 0 && a; )
        s !== 0 && (A === 0 || !a || o.z <= a.z) ? (e = o, o = o.nextZ, s--) : (e = a, a = a.nextZ, A--), l ? l.nextZ = e : t = e, e.prevZ = l, l = e;
      o = a;
    }
    l.nextZ = null, r *= 2;
  } while (i > 1);
  return t;
}
function ete(t, e, n, r, i) {
  return t = 32767 * (t - n) * i, e = 32767 * (e - r) * i, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, t | e << 1;
}
function L0n(t) {
  let e = t, n = t;
  do
    (e.x < n.x || e.x === n.x && e.y < n.y) && (n = e), e = e.next;
  while (e !== t);
  return n;
}
function d_(t, e, n, r, i, o, s, a) {
  return (i - s) * (e - a) - (t - s) * (o - a) >= 0 && (t - s) * (r - a) - (n - s) * (e - a) >= 0 && (n - s) * (o - a) - (i - s) * (r - a) >= 0;
}
function M0n(t, e) {
  return t.next.i !== e.i && t.prev.i !== e.i && !O0n(t, e) && (HT(t, e) && HT(e, t) && F0n(t, e) && (Ws(t.prev, t, e.prev) || Ws(t, e.prev, e)) || d$(t, e) && Ws(t.prev, t, t.next) > 0 && Ws(e.prev, e, e.next) > 0);
}
function Ws(t, e, n) {
  return (e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y);
}
function d$(t, e) {
  return t.x === e.x && t.y === e.y;
}
function Jqe(t, e, n, r) {
  const i = nP(Ws(t, e, n)), o = nP(Ws(t, e, r)), s = nP(Ws(n, r, t)), a = nP(Ws(n, r, e));
  return !!(i !== o && s !== a || i === 0 && tP(t, n, e) || o === 0 && tP(t, r, e) || s === 0 && tP(n, t, r) || a === 0 && tP(n, e, r));
}
function tP(t, e, n) {
  return e.x <= Math.max(t.x, n.x) && e.x >= Math.min(t.x, n.x) && e.y <= Math.max(t.y, n.y) && e.y >= Math.min(t.y, n.y);
}
function nP(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
}
function O0n(t, e) {
  let n = t;
  do {
    if (n.i !== t.i && n.next.i !== t.i && n.i !== e.i && n.next.i !== e.i && Jqe(n, n.next, t, e))
      return !0;
    n = n.next;
  } while (n !== t);
  return !1;
}
function HT(t, e) {
  return Ws(t.prev, t, t.next) < 0 ? Ws(t, e, t.next) >= 0 && Ws(t, t.prev, e) >= 0 : Ws(t, e, t.prev) < 0 || Ws(t, t.next, e) < 0;
}
function F0n(t, e) {
  let n = t, r = !1;
  const i = (t.x + e.x) / 2, o = (t.y + e.y) / 2;
  do
    n.y > o != n.next.y > o && n.next.y !== n.y && i < (n.next.x - n.x) * (o - n.y) / (n.next.y - n.y) + n.x && (r = !r), n = n.next;
  while (n !== t);
  return r;
}
function Kqe(t, e) {
  const n = new tte(t.i, t.x, t.y), r = new tte(e.i, e.x, e.y), i = t.next, o = e.prev;
  return t.next = e, e.prev = t, n.next = i, i.prev = n, r.next = n, n.prev = r, o.next = r, r.prev = o, r;
}
function ISe(t, e, n, r) {
  const i = new tte(t, e, n);
  return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
}
function $T(t) {
  t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
}
function tte(t, e, n) {
  this.i = t, this.x = e, this.y = n, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}
function Yh(t, e) {
  const n = e.length, r = t.length;
  if (r > 0) {
    let i = !0;
    for (let o = 0; o < n; o++)
      if (t[r - n + o] !== e[o]) {
        i = !1;
        break;
      }
    if (i)
      return !1;
  }
  for (let i = 0; i < n; i++)
    t[r + i] = e[i];
  return !0;
}
function nte(t, e) {
  const n = e.length;
  for (let r = 0; r < n; r++)
    t[r] = e[r];
}
function qT(t, e, n, r, i = []) {
  const o = r + e * n;
  for (let s = 0; s < n; s++)
    i[s] = t[o + s];
  return i;
}
function rte(t, e, n, r, i = []) {
  let o, s;
  if (n & 8)
    o = (r[3] - t[1]) / (e[1] - t[1]), s = 3;
  else if (n & 4)
    o = (r[1] - t[1]) / (e[1] - t[1]), s = 1;
  else if (n & 2)
    o = (r[2] - t[0]) / (e[0] - t[0]), s = 2;
  else if (n & 1)
    o = (r[0] - t[0]) / (e[0] - t[0]), s = 0;
  else
    return null;
  for (let a = 0; a < t.length; a++)
    i[a] = (s & 1) === a ? r[s] : o * (e[a] - t[a]) + t[a];
  return i;
}
function Ok(t, e) {
  let n = 0;
  return t[0] < e[0] ? n |= 1 : t[0] > e[2] && (n |= 2), t[1] < e[1] ? n |= 4 : t[1] > e[3] && (n |= 8), n;
}
function Wqe(t, e) {
  const {
    size: n = 2,
    broken: r = !1,
    gridResolution: i = 10,
    gridOffset: o = [0, 0],
    startIndex: s = 0,
    endIndex: a = t.length
  } = e || {}, A = (a - s) / n;
  let l = [];
  const c = [l], u = qT(t, 0, n, s);
  let f, h;
  const d = Zqe(u, i, o, []), I = [];
  Yh(l, u);
  for (let m = 1; m < A; m++) {
    for (f = qT(t, m, n, s, f), h = Ok(f, d); h; ) {
      rte(u, f, h, d, I);
      const C = Ok(I, d);
      C && (rte(u, I, C, d, I), h = C), Yh(l, I), nte(u, I), k0n(d, i, h), r && l.length > n && (l = [], c.push(l), Yh(l, u)), h = Ok(f, d);
    }
    Yh(l, f), nte(u, f);
  }
  return r ? c : c[0];
}
const mSe = 0, P0n = 1;
function rP(t, e) {
  for (let n = 0; n < e.length; n++)
    t.push(e[n]);
  return t;
}
function Xqe(t, e = null, n) {
  if (!t.length)
    return [];
  const {
    size: r = 2,
    gridResolution: i = 10,
    gridOffset: o = [0, 0],
    edgeTypes: s = !1
  } = n || {}, a = [], A = [{
    pos: t,
    types: s ? new Array(t.length / r).fill(P0n) : null,
    holes: e || []
  }], l = [[], []];
  let c = [];
  for (; A.length; ) {
    const {
      pos: u,
      types: f,
      holes: h
    } = A.shift();
    G0n(u, r, h[0] || u.length, l), c = Zqe(l[0], i, o, c);
    const d = Ok(l[1], c);
    if (d) {
      let I = CSe(u, f, r, 0, h[0] || u.length, c, d);
      const m = {
        pos: I[0].pos,
        types: I[0].types,
        holes: []
      }, C = {
        pos: I[1].pos,
        types: I[1].types,
        holes: []
      };
      A.push(m, C);
      for (let y = 0; y < h.length; y++)
        I = CSe(u, f, r, h[y], h[y + 1] || u.length, c, d), I[0] && (m.holes.push(m.pos.length), m.pos = rP(m.pos, I[0].pos), s && (m.types = rP(m.types, I[0].types))), I[1] && (C.holes.push(C.pos.length), C.pos = rP(C.pos, I[1].pos), s && (C.types = rP(C.types, I[1].types)));
    } else {
      const I = {
        positions: u
      };
      s && (I.edgeTypes = f), h.length && (I.holeIndices = h), a.push(I);
    }
  }
  return a;
}
function CSe(t, e, n, r, i, o, s) {
  const a = (i - r) / n, A = [], l = [], c = [], u = [], f = [];
  let h, d, I;
  const m = qT(t, a - 1, n, r);
  let C = Math.sign(s & 8 ? m[1] - o[3] : m[0] - o[2]), y = e && e[a - 1], v = 0, b = 0;
  for (let Q = 0; Q < a; Q++)
    h = qT(t, Q, n, r, h), d = Math.sign(s & 8 ? h[1] - o[3] : h[0] - o[2]), I = e && e[r / n + Q], d && C && C !== d && (rte(m, h, s, o, f), Yh(A, f) && c.push(y), Yh(l, f) && u.push(y)), d <= 0 ? (Yh(A, h) && c.push(I), v -= d) : c.length && (c[c.length - 1] = mSe), d >= 0 ? (Yh(l, h) && u.push(I), b += d) : u.length && (u[u.length - 1] = mSe), nte(m, h), C = d, y = I;
  return [v ? {
    pos: A,
    types: e && c
  } : null, b ? {
    pos: l,
    types: e && u
  } : null];
}
function Zqe(t, e, n, r) {
  const i = Math.floor((t[0] - n[0]) / e) * e + n[0], o = Math.floor((t[1] - n[1]) / e) * e + n[1];
  return r[0] = i, r[1] = o, r[2] = i + e, r[3] = o + e, r;
}
function k0n(t, e, n) {
  n & 8 ? (t[1] += e, t[3] += e) : n & 4 ? (t[1] -= e, t[3] -= e) : n & 2 ? (t[0] += e, t[2] += e) : n & 1 && (t[0] -= e, t[2] -= e);
}
function G0n(t, e, n, r) {
  let i = 1 / 0, o = -1 / 0, s = 1 / 0, a = -1 / 0;
  for (let A = 0; A < n; A += e) {
    const l = t[A], c = t[A + 1];
    i = l < i ? l : i, o = l > o ? l : o, s = c < s ? c : s, a = c > a ? c : a;
  }
  return r[0][0] = i, r[0][1] = s, r[1][0] = o, r[1][1] = a, r;
}
const U0n = 85.051129;
function H0n(t, e) {
  const {
    size: n = 2,
    startIndex: r = 0,
    endIndex: i = t.length,
    normalize: o = !0
  } = e || {}, s = t.slice(r, i);
  eje(s, n, 0, i - r);
  const a = Wqe(s, {
    size: n,
    broken: !0,
    gridResolution: 360,
    gridOffset: [-180, -180]
  });
  if (o)
    for (const A of a)
      tje(A, n);
  return a;
}
function $0n(t, e = null, n) {
  const {
    size: r = 2,
    normalize: i = !0,
    edgeTypes: o = !1
  } = n || {};
  e = e || [];
  const s = [], a = [];
  let A = 0, l = 0;
  for (let u = 0; u <= e.length; u++) {
    const f = e[u] || t.length, h = l, d = q0n(t, r, A, f);
    for (let I = d; I < f; I++)
      s[l++] = t[I];
    for (let I = A; I < d; I++)
      s[l++] = t[I];
    eje(s, r, h, l), j0n(s, r, h, l, n?.maxLatitude), A = f, a[u] = l;
  }
  a.pop();
  const c = Xqe(s, a, {
    size: r,
    gridResolution: 360,
    gridOffset: [-180, -180],
    edgeTypes: o
  });
  if (i)
    for (const u of c)
      tje(u.positions, r);
  return c;
}
function q0n(t, e, n, r) {
  let i = -1, o = -1;
  for (let s = n + 1; s < r; s += e) {
    const a = Math.abs(t[s]);
    a > i && (i = a, o = s - 1);
  }
  return o;
}
function j0n(t, e, n, r, i = U0n) {
  const o = t[n], s = t[r - e];
  if (Math.abs(o - s) > 180) {
    const a = qT(t, 0, e, n);
    a[0] += Math.round((s - o) / 360) * 360, Yh(t, a), a[1] = Math.sign(a[1]) * i, Yh(t, a), a[0] = o, Yh(t, a);
  }
}
function eje(t, e, n, r) {
  let i = t[0], o;
  for (let s = n; s < r; s += e) {
    o = t[s];
    const a = o - i;
    (a > 180 || a < -180) && (o -= Math.round(a / 360) * 360), t[s] = i = o;
  }
}
function tje(t, e) {
  let n;
  const r = t.length / e;
  for (let o = 0; o < r && (n = t[o * e], (n + 180) % 360 === 0); o++)
    ;
  const i = -Math.round(n / 360) * 360;
  if (i !== 0)
    for (let o = 0; o < r; o++)
      t[o * e] += i;
}
class Y0n extends Os {
  constructor(e) {
    const {
      id: n = PA("column-geometry")
    } = e, {
      indices: r,
      attributes: i
    } = z0n(e);
    super({
      ...e,
      id: n,
      indices: r,
      attributes: i
    });
  }
}
function z0n(t) {
  const {
    radius: e,
    height: n = 1,
    nradial: r = 10
  } = t;
  let {
    vertices: i
  } = t;
  i && (Rr.assert(i.length >= r), i = i.flatMap((h) => [h[0], h[1]]), Ace(i, ace.COUNTER_CLOCKWISE));
  const o = n > 0, s = r + 1, a = o ? s * 3 + 1 : r, A = Math.PI * 2 / r, l = new Uint16Array(o ? r * 3 * 2 : 0), c = new Float32Array(a * 3), u = new Float32Array(a * 3);
  let f = 0;
  if (o) {
    for (let h = 0; h < s; h++) {
      const d = h * A, I = h % r, m = Math.sin(d), C = Math.cos(d);
      for (let y = 0; y < 2; y++)
        c[f + 0] = i ? i[I * 2] : C * e, c[f + 1] = i ? i[I * 2 + 1] : m * e, c[f + 2] = (1 / 2 - y) * n, u[f + 0] = i ? i[I * 2] : C, u[f + 1] = i ? i[I * 2 + 1] : m, f += 3;
    }
    c[f + 0] = c[f - 3], c[f + 1] = c[f - 2], c[f + 2] = c[f - 1], f += 3;
  }
  for (let h = o ? 0 : 1; h < s; h++) {
    const d = Math.floor(h / 2) * Math.sign(0.5 - h % 2), I = d * A, m = (d + r) % r, C = Math.sin(I), y = Math.cos(I);
    c[f + 0] = i ? i[m * 2] : y * e, c[f + 1] = i ? i[m * 2 + 1] : C * e, c[f + 2] = n / 2, u[f + 2] = 1, f += 3;
  }
  if (o) {
    let h = 0;
    for (let d = 0; d < r; d++)
      l[h++] = d * 2 + 0, l[h++] = d * 2 + 2, l[h++] = d * 2 + 0, l[h++] = d * 2 + 1, l[h++] = d * 2 + 1, l[h++] = d * 2 + 3;
  }
  return {
    indices: l,
    attributes: {
      POSITION: {
        size: 3,
        value: c
      },
      NORMAL: {
        size: 3,
        value: u
      }
    }
  };
}
const V0n = `#version 300 es

#define SHADER_NAME column-layer-vertex-shader

in vec3 positions;
in vec3 normals;

in vec3 instancePositions;
in float instanceElevations;
in vec3 instancePositions64Low;
in vec4 instanceFillColors;
in vec4 instanceLineColors;
in float instanceStrokeWidths;

in vec3 instancePickingColors;

// Custom uniforms
uniform float opacity;
uniform float radius;
uniform float angle;
uniform vec2 offset;
uniform bool extruded;
uniform bool stroked;
uniform bool isStroke;
uniform float coverage;
uniform float elevationScale;
uniform float edgeDistance;
uniform float widthScale;
uniform float widthMinPixels;
uniform float widthMaxPixels;
uniform int radiusUnits;
uniform int widthUnits;

// Result
out vec4 vColor;
#ifdef FLAT_SHADING
out vec4 position_commonspace;
#endif

void main(void) {
  geometry.worldPosition = instancePositions;

  vec4 color = isStroke ? instanceLineColors : instanceFillColors;
  // rotate primitive position and normal
  mat2 rotationMatrix = mat2(cos(angle), sin(angle), -sin(angle), cos(angle));

  // calculate elevation, if 3d not enabled set to 0
  // cylindar gemoetry height are between -1.0 to 1.0, transform it to between 0, 1
  float elevation = 0.0;
  // calculate stroke offset
  float strokeOffsetRatio = 1.0;

  if (extruded) {
    elevation = instanceElevations * (positions.z + 1.0) / 2.0 * elevationScale;
  } else if (stroked) {
    float widthPixels = clamp(
      project_size_to_pixel(instanceStrokeWidths * widthScale, widthUnits),
      widthMinPixels, widthMaxPixels) / 2.0;
    float halfOffset = project_pixel_size(widthPixels) / project_size(edgeDistance * coverage * radius);
    if (isStroke) {
      strokeOffsetRatio -= sign(positions.z) * halfOffset;
    } else {
      strokeOffsetRatio -= halfOffset;
    }
  }

  // if alpha == 0.0 or z < 0.0, do not render element
  float shouldRender = float(color.a > 0.0 && instanceElevations >= 0.0);
  float dotRadius = radius * coverage * shouldRender;

  geometry.pickingColor = instancePickingColors;

  // project center of column
  vec3 centroidPosition = vec3(instancePositions.xy, instancePositions.z + elevation);
  vec3 centroidPosition64Low = instancePositions64Low;
  vec2 offset = (rotationMatrix * positions.xy * strokeOffsetRatio + offset) * dotRadius;
  if (radiusUnits == UNIT_METERS) {
    offset = project_size(offset);
  }
  vec3 pos = vec3(offset, 0.);
  DECKGL_FILTER_SIZE(pos, geometry);

  gl_Position = project_position_to_clipspace(centroidPosition, centroidPosition64Low, pos, geometry.position);
  geometry.normal = project_normal(vec3(rotationMatrix * normals.xy, normals.z));
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  // Light calculations
  if (extruded && !isStroke) {
#ifdef FLAT_SHADING
    position_commonspace = geometry.position;
    vColor = vec4(color.rgb, color.a * opacity);
#else
    vec3 lightColor = lighting_getLightColor(color.rgb, project_uCameraPosition, geometry.position.xyz, geometry.normal);
    vColor = vec4(lightColor, color.a * opacity);
#endif
  } else {
    vColor = vec4(color.rgb, color.a * opacity);
  }
  DECKGL_FILTER_COLOR(vColor, geometry);
}
`, J0n = `#version 300 es
#define SHADER_NAME column-layer-fragment-shader

precision highp float;

uniform vec3 project_uCameraPosition;
uniform bool extruded;
uniform bool isStroke;

out vec4 fragColor;

in vec4 vColor;
#ifdef FLAT_SHADING
in vec4 position_commonspace;
#endif

void main(void) {
  fragColor = vColor;
#ifdef FLAT_SHADING
  if (extruded && !isStroke && !picking_uActive) {
    vec3 normal = normalize(cross(dFdx(position_commonspace.xyz), dFdy(position_commonspace.xyz)));
    fragColor.rgb = lighting_getLightColor(vColor.rgb, project_uCameraPosition, position_commonspace.xyz, normal);
  }
#endif
  DECKGL_FILTER_COLOR(fragColor, geometry);
}
`, LU = [0, 0, 0, 255], K0n = {
  diskResolution: {
    type: "number",
    min: 4,
    value: 20
  },
  vertices: null,
  radius: {
    type: "number",
    min: 0,
    value: 1e3
  },
  angle: {
    type: "number",
    value: 0
  },
  offset: {
    type: "array",
    value: [0, 0]
  },
  coverage: {
    type: "number",
    min: 0,
    max: 1,
    value: 1
  },
  elevationScale: {
    type: "number",
    min: 0,
    value: 1
  },
  radiusUnits: "meters",
  lineWidthUnits: "meters",
  lineWidthScale: 1,
  lineWidthMinPixels: 0,
  lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
  extruded: !0,
  wireframe: !1,
  filled: !0,
  stroked: !1,
  getPosition: {
    type: "accessor",
    value: (t) => t.position
  },
  getFillColor: {
    type: "accessor",
    value: LU
  },
  getLineColor: {
    type: "accessor",
    value: LU
  },
  getLineWidth: {
    type: "accessor",
    value: 1
  },
  getElevation: {
    type: "accessor",
    value: 1e3
  },
  material: !0,
  getColor: {
    deprecatedFor: ["getFillColor", "getLineColor"]
  }
};
class mM extends IA {
  getShaders() {
    const {
      gl: e
    } = this.context, n = !Fr(e), r = {}, i = this.props.flatShading && Zv(e, no.GLSL_DERIVATIVES);
    return i && (r.FLAT_SHADING = 1), super.getShaders({
      vs: V0n,
      fs: J0n,
      defines: r,
      transpileToGLSL100: n,
      modules: [qA, i ? o$ : cM, jA]
    });
  }
  initializeState() {
    this.getAttributeManager().addInstanced({
      instancePositions: {
        size: 3,
        type: 5130,
        fp64: this.use64bitPositions(),
        transition: !0,
        accessor: "getPosition"
      },
      instanceElevations: {
        size: 1,
        transition: !0,
        accessor: "getElevation"
      },
      instanceFillColors: {
        size: this.props.colorFormat.length,
        type: 5121,
        normalized: !0,
        transition: !0,
        accessor: "getFillColor",
        defaultValue: LU
      },
      instanceLineColors: {
        size: this.props.colorFormat.length,
        type: 5121,
        normalized: !0,
        transition: !0,
        accessor: "getLineColor",
        defaultValue: LU
      },
      instanceStrokeWidths: {
        size: 1,
        accessor: "getLineWidth",
        transition: !0
      }
    });
  }
  updateState(e) {
    super.updateState(e);
    const {
      props: n,
      oldProps: r,
      changeFlags: i
    } = e, o = i.extensionsChanged || n.flatShading !== r.flatShading;
    if (o) {
      var s;
      const {
        gl: a
      } = this.context;
      (s = this.state.model) === null || s === void 0 || s.delete(), this.state.model = this._getModel(a), this.getAttributeManager().invalidateAll();
    }
    (o || n.diskResolution !== r.diskResolution || n.vertices !== r.vertices || (n.extruded || n.stroked) !== (r.extruded || r.stroked)) && this._updateGeometry(n);
  }
  getGeometry(e, n, r) {
    const i = new Y0n({
      radius: 1,
      height: r ? 2 : 0,
      vertices: n,
      nradial: e
    });
    let o = 0;
    if (n)
      for (let s = 0; s < e; s++) {
        const a = n[s], A = Math.sqrt(a[0] * a[0] + a[1] * a[1]);
        o += A / e;
      }
    else
      o = 1;
    return this.setState({
      edgeDistance: Math.cos(Math.PI / e) * o
    }), i;
  }
  _getModel(e) {
    return new Ta(e, {
      ...this.getShaders(),
      id: this.props.id,
      isInstanced: !0
    });
  }
  _updateGeometry({
    diskResolution: e,
    vertices: n,
    extruded: r,
    stroked: i
  }) {
    const o = this.getGeometry(e, n, r || i);
    this.setState({
      fillVertexCount: o.attributes.POSITION.value.length / 3,
      wireframeVertexCount: o.indices.value.length
    }), this.state.model.setProps({
      geometry: o
    });
  }
  draw({
    uniforms: e
  }) {
    const {
      lineWidthUnits: n,
      lineWidthScale: r,
      lineWidthMinPixels: i,
      lineWidthMaxPixels: o,
      radiusUnits: s,
      elevationScale: a,
      extruded: A,
      filled: l,
      stroked: c,
      wireframe: u,
      offset: f,
      coverage: h,
      radius: d,
      angle: I
    } = this.props, {
      model: m,
      fillVertexCount: C,
      wireframeVertexCount: y,
      edgeDistance: v
    } = this.state;
    m.setUniforms(e).setUniforms({
      radius: d,
      angle: I / 180 * Math.PI,
      offset: f,
      extruded: A,
      stroked: c,
      coverage: h,
      elevationScale: a,
      edgeDistance: v,
      radiusUnits: Ou[s],
      widthUnits: Ou[n],
      widthScale: r,
      widthMinPixels: i,
      widthMaxPixels: o
    }), A && u && (m.setProps({
      isIndexed: !0
    }), m.setVertexCount(y).setDrawMode(1).setUniforms({
      isStroke: !0
    }).draw()), l && (m.setProps({
      isIndexed: !1
    }), m.setVertexCount(C).setDrawMode(5).setUniforms({
      isStroke: !1
    }).draw()), !A && c && (m.setProps({
      isIndexed: !1
    }), m.setVertexCount(C * 2 / 3).setDrawMode(5).setUniforms({
      isStroke: !0
    }).draw());
  }
}
ae(mM, "layerName", "ColumnLayer");
ae(mM, "defaultProps", K0n);
const W0n = {
  cellSize: {
    type: "number",
    min: 0,
    value: 1e3
  },
  offset: {
    type: "array",
    value: [1, 1]
  }
};
class lce extends mM {
  getGeometry(e) {
    return new k$e();
  }
  draw({
    uniforms: e
  }) {
    const {
      elevationScale: n,
      extruded: r,
      offset: i,
      coverage: o,
      cellSize: s,
      angle: a,
      radiusUnits: A
    } = this.props;
    this.state.model.setUniforms(e).setUniforms({
      radius: s / 2,
      radiusUnits: Ou[A],
      angle: a,
      offset: i,
      extruded: r,
      coverage: o,
      elevationScale: n,
      edgeDistance: 1,
      isWireframe: !1
    }).draw();
  }
}
ae(lce, "layerName", "GridCellLayer");
ae(lce, "defaultProps", W0n);
function X0n(t, e, n, r) {
  let i;
  if (Array.isArray(t[0])) {
    const o = t.length * e;
    i = new Array(o);
    for (let s = 0; s < t.length; s++)
      for (let a = 0; a < e; a++)
        i[s * e + a] = t[s][a] || 0;
  } else
    i = t;
  return n ? Wqe(i, {
    size: e,
    gridResolution: n
  }) : r ? H0n(i, {
    size: e
  }) : i;
}
const Z0n = 1, eIn = 2, QV = 4;
class tIn extends oce {
  constructor(e) {
    super({
      ...e,
      attributes: {
        positions: {
          size: 3,
          padding: 18,
          initialize: !0,
          type: e.fp64 ? Float64Array : Float32Array
        },
        segmentTypes: {
          size: 1,
          type: Uint8ClampedArray
        }
      }
    });
  }
  get(e) {
    return this.attributes[e];
  }
  getGeometryFromBuffer(e) {
    return this.normalize ? super.getGeometryFromBuffer(e) : null;
  }
  normalizeGeometry(e) {
    return this.normalize ? X0n(e, this.positionSize, this.opts.resolution, this.opts.wrapLongitude) : e;
  }
  getGeometrySize(e) {
    if (ESe(e)) {
      let r = 0;
      for (const i of e)
        r += this.getGeometrySize(i);
      return r;
    }
    const n = this.getPathLength(e);
    return n < 2 ? 0 : this.isClosed(e) ? n < 3 ? 0 : n + 2 : n;
  }
  updateGeometryAttributes(e, n) {
    if (n.geometrySize !== 0)
      if (e && ESe(e))
        for (const r of e) {
          const i = this.getGeometrySize(r);
          n.geometrySize = i, this.updateGeometryAttributes(r, n), n.vertexStart += i;
        }
      else
        this._updateSegmentTypes(e, n), this._updatePositions(e, n);
  }
  _updateSegmentTypes(e, n) {
    const r = this.attributes.segmentTypes, i = e ? this.isClosed(e) : !1, {
      vertexStart: o,
      geometrySize: s
    } = n;
    r.fill(0, o, o + s), i ? (r[o] = QV, r[o + s - 2] = QV) : (r[o] += Z0n, r[o + s - 2] += eIn), r[o + s - 1] = QV;
  }
  _updatePositions(e, n) {
    const {
      positions: r
    } = this.attributes;
    if (!r || !e)
      return;
    const {
      vertexStart: i,
      geometrySize: o
    } = n, s = new Array(3);
    for (let a = i, A = 0; A < o; a++, A++)
      this.getPointOnPath(e, A, s), r[a * 3] = s[0], r[a * 3 + 1] = s[1], r[a * 3 + 2] = s[2];
  }
  getPathLength(e) {
    return e.length / this.positionSize;
  }
  getPointOnPath(e, n, r = []) {
    const {
      positionSize: i
    } = this;
    n * i >= e.length && (n += 1 - e.length / i);
    const o = n * i;
    return r[0] = e[o], r[1] = e[o + 1], r[2] = i === 3 && e[o + 2] || 0, r;
  }
  isClosed(e) {
    if (!this.normalize)
      return !!this.opts.loop;
    const {
      positionSize: n
    } = this, r = e.length - n;
    return e[0] === e[r] && e[1] === e[r + 1] && (n === 2 || e[2] === e[r + 2]);
  }
}
function ESe(t) {
  return Array.isArray(t[0]);
}
const nIn = `#define SHADER_NAME path-layer-vertex-shader

attribute vec2 positions;

attribute float instanceTypes;
attribute vec3 instanceStartPositions;
attribute vec3 instanceEndPositions;
attribute vec3 instanceLeftPositions;
attribute vec3 instanceRightPositions;
attribute vec3 instanceLeftPositions64Low;
attribute vec3 instanceStartPositions64Low;
attribute vec3 instanceEndPositions64Low;
attribute vec3 instanceRightPositions64Low;
attribute float instanceStrokeWidths;
attribute vec4 instanceColors;
attribute vec3 instancePickingColors;

uniform float widthScale;
uniform float widthMinPixels;
uniform float widthMaxPixels;
uniform float jointType;
uniform float capType;
uniform float miterLimit;
uniform bool billboard;
uniform int widthUnits;

uniform float opacity;

varying vec4 vColor;
varying vec2 vCornerOffset;
varying float vMiterLength;
varying vec2 vPathPosition;
varying float vPathLength;
varying float vJointType;

const float EPSILON = 0.001;
const vec3 ZERO_OFFSET = vec3(0.0);

float flipIfTrue(bool flag) {
  return -(float(flag) * 2. - 1.);
}

// calculate line join positions
vec3 lineJoin(
  vec3 prevPoint, vec3 currPoint, vec3 nextPoint,
  vec2 width
) {
  bool isEnd = positions.x > 0.0;
  // side of the segment - -1: left, 0: center, 1: right
  float sideOfPath = positions.y;
  float isJoint = float(sideOfPath == 0.0);

  vec3 deltaA3 = (currPoint - prevPoint);
  vec3 deltaB3 = (nextPoint - currPoint);

  mat3 rotationMatrix;
  bool needsRotation = !billboard && project_needs_rotation(currPoint, rotationMatrix);
  if (needsRotation) {
    deltaA3 = deltaA3 * rotationMatrix;
    deltaB3 = deltaB3 * rotationMatrix;
  }
  vec2 deltaA = deltaA3.xy / width;
  vec2 deltaB = deltaB3.xy / width;

  float lenA = length(deltaA);
  float lenB = length(deltaB);

  vec2 dirA = lenA > 0. ? normalize(deltaA) : vec2(0.0, 0.0);
  vec2 dirB = lenB > 0. ? normalize(deltaB) : vec2(0.0, 0.0);

  vec2 perpA = vec2(-dirA.y, dirA.x);
  vec2 perpB = vec2(-dirB.y, dirB.x);

  // tangent of the corner
  vec2 tangent = dirA + dirB;
  tangent = length(tangent) > 0. ? normalize(tangent) : perpA;
  // direction of the corner
  vec2 miterVec = vec2(-tangent.y, tangent.x);
  // direction of the segment
  vec2 dir = isEnd ? dirA : dirB;
  // direction of the extrusion
  vec2 perp = isEnd ? perpA : perpB;
  // length of the segment
  float L = isEnd ? lenA : lenB;

  // A = angle of the corner
  float sinHalfA = abs(dot(miterVec, perp));
  float cosHalfA = abs(dot(dirA, miterVec));

  // -1: right, 1: left
  float turnDirection = flipIfTrue(dirA.x * dirB.y >= dirA.y * dirB.x);

  // relative position to the corner:
  // -1: inside (smaller side of the angle)
  // 0: center
  // 1: outside (bigger side of the angle)
  float cornerPosition = sideOfPath * turnDirection;

  float miterSize = 1.0 / max(sinHalfA, EPSILON);
  // trim if inside corner extends further than the line segment
  miterSize = mix(
    min(miterSize, max(lenA, lenB) / max(cosHalfA, EPSILON)),
    miterSize,
    step(0.0, cornerPosition)
  );

  vec2 offsetVec = mix(miterVec * miterSize, perp, step(0.5, cornerPosition))
    * (sideOfPath + isJoint * turnDirection);

  // special treatment for start cap and end cap
  bool isStartCap = lenA == 0.0 || (!isEnd && (instanceTypes == 1.0 || instanceTypes == 3.0));
  bool isEndCap = lenB == 0.0 || (isEnd && (instanceTypes == 2.0 || instanceTypes == 3.0));
  bool isCap = isStartCap || isEndCap;

  // extend out a triangle to envelope the round cap
  if (isCap) {
    offsetVec = mix(perp * sideOfPath, dir * capType * 4.0 * flipIfTrue(isStartCap), isJoint);
    vJointType = capType;
  } else {
    vJointType = jointType;
  }

  // Generate variables for fragment shader
  vPathLength = L;
  vCornerOffset = offsetVec;
  vMiterLength = dot(vCornerOffset, miterVec * turnDirection);
  vMiterLength = isCap ? isJoint : vMiterLength;

  vec2 offsetFromStartOfPath = vCornerOffset + deltaA * float(isEnd);
  vPathPosition = vec2(
    dot(offsetFromStartOfPath, perp),
    dot(offsetFromStartOfPath, dir)
  );
  geometry.uv = vPathPosition;

  float isValid = step(instanceTypes, 3.5);
  vec3 offset = vec3(offsetVec * width * isValid, 0.0);

  if (needsRotation) {
    offset = rotationMatrix * offset;
  }
  return currPoint + offset;
}

// In clipspace extrusion, if a line extends behind the camera, clip it to avoid visual artifacts
void clipLine(inout vec4 position, vec4 refPosition) {
  if (position.w < EPSILON) {
    float r = (EPSILON - refPosition.w) / (position.w - refPosition.w);
    position = refPosition + (position - refPosition) * r;
  }
}

void main() {
  geometry.pickingColor = instancePickingColors;

  vColor = vec4(instanceColors.rgb, instanceColors.a * opacity);

  float isEnd = positions.x;

  vec3 prevPosition = mix(instanceLeftPositions, instanceStartPositions, isEnd);
  vec3 prevPosition64Low = mix(instanceLeftPositions64Low, instanceStartPositions64Low, isEnd);

  vec3 currPosition = mix(instanceStartPositions, instanceEndPositions, isEnd);
  vec3 currPosition64Low = mix(instanceStartPositions64Low, instanceEndPositions64Low, isEnd);

  vec3 nextPosition = mix(instanceEndPositions, instanceRightPositions, isEnd);
  vec3 nextPosition64Low = mix(instanceEndPositions64Low, instanceRightPositions64Low, isEnd);

  geometry.worldPosition = currPosition;
  vec2 widthPixels = vec2(clamp(
    project_size_to_pixel(instanceStrokeWidths * widthScale, widthUnits),
    widthMinPixels, widthMaxPixels) / 2.0);
  vec3 width;

  if (billboard) {
    // Extrude in clipspace
    vec4 prevPositionScreen = project_position_to_clipspace(prevPosition, prevPosition64Low, ZERO_OFFSET);
    vec4 currPositionScreen = project_position_to_clipspace(currPosition, currPosition64Low, ZERO_OFFSET, geometry.position);
    vec4 nextPositionScreen = project_position_to_clipspace(nextPosition, nextPosition64Low, ZERO_OFFSET);

    clipLine(prevPositionScreen, currPositionScreen);
    clipLine(nextPositionScreen, currPositionScreen);
    clipLine(currPositionScreen, mix(nextPositionScreen, prevPositionScreen, isEnd));

    width = vec3(widthPixels, 0.0);
    DECKGL_FILTER_SIZE(width, geometry);

    vec3 pos = lineJoin(
      prevPositionScreen.xyz / prevPositionScreen.w,
      currPositionScreen.xyz / currPositionScreen.w,
      nextPositionScreen.xyz / nextPositionScreen.w,
      project_pixel_size_to_clipspace(width.xy)
    );

    gl_Position = vec4(pos * currPositionScreen.w, currPositionScreen.w);
  } else {
    // Extrude in commonspace
    prevPosition = project_position(prevPosition, prevPosition64Low);
    currPosition = project_position(currPosition, currPosition64Low);
    nextPosition = project_position(nextPosition, nextPosition64Low);

    width = vec3(project_pixel_size(widthPixels), 0.0);
    DECKGL_FILTER_SIZE(width, geometry);

    vec4 pos = vec4(
      lineJoin(prevPosition, currPosition, nextPosition, width.xy),
      1.0);
    geometry.position = pos;
    gl_Position = project_common_position_to_clipspace(pos);
  }
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
  DECKGL_FILTER_COLOR(vColor, geometry);
}
`, rIn = `#define SHADER_NAME path-layer-fragment-shader

precision highp float;

uniform float miterLimit;

varying vec4 vColor;
varying vec2 vCornerOffset;
varying float vMiterLength;
/*
 * vPathPosition represents the relative coordinates of the current fragment on the path segment.
 * vPathPosition.x - position along the width of the path, between [-1, 1]. 0 is the center line.
 * vPathPosition.y - position along the length of the path, between [0, L / width].
 */
varying vec2 vPathPosition;
varying float vPathLength;
varying float vJointType;

void main(void) {
  geometry.uv = vPathPosition;

  if (vPathPosition.y < 0.0 || vPathPosition.y > vPathLength) {
    // if joint is rounded, test distance from the corner
    if (vJointType > 0.5 && length(vCornerOffset) > 1.0) {
      discard;
    }
    // trim miter
    if (vJointType < 0.5 && vMiterLength > miterLimit + 1.0) {
      discard;
    }
  }
  gl_FragColor = vColor;

  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`, nje = [0, 0, 0, 255], iIn = {
  widthUnits: "meters",
  widthScale: {
    type: "number",
    min: 0,
    value: 1
  },
  widthMinPixels: {
    type: "number",
    min: 0,
    value: 0
  },
  widthMaxPixels: {
    type: "number",
    min: 0,
    value: Number.MAX_SAFE_INTEGER
  },
  jointRounded: !1,
  capRounded: !1,
  miterLimit: {
    type: "number",
    min: 0,
    value: 4
  },
  billboard: !1,
  _pathType: null,
  getPath: {
    type: "accessor",
    value: (t) => t.path
  },
  getColor: {
    type: "accessor",
    value: nje
  },
  getWidth: {
    type: "accessor",
    value: 1
  },
  rounded: {
    deprecatedFor: ["jointRounded", "capRounded"]
  }
}, wV = {
  enter: (t, e) => e.length ? e.subarray(e.length - t.length) : t
};
class Ow extends IA {
  constructor(...e) {
    super(...e), ae(this, "state", void 0);
  }
  getShaders() {
    return super.getShaders({
      vs: nIn,
      fs: rIn,
      modules: [qA, jA]
    });
  }
  get wrapLongitude() {
    return !1;
  }
  initializeState() {
    this.getAttributeManager().addInstanced({
      positions: {
        size: 3,
        vertexOffset: 1,
        type: 5130,
        fp64: this.use64bitPositions(),
        transition: wV,
        accessor: "getPath",
        update: this.calculatePositions,
        noAlloc: !0,
        shaderAttributes: {
          instanceLeftPositions: {
            vertexOffset: 0
          },
          instanceStartPositions: {
            vertexOffset: 1
          },
          instanceEndPositions: {
            vertexOffset: 2
          },
          instanceRightPositions: {
            vertexOffset: 3
          }
        }
      },
      instanceTypes: {
        size: 1,
        type: 5121,
        update: this.calculateSegmentTypes,
        noAlloc: !0
      },
      instanceStrokeWidths: {
        size: 1,
        accessor: "getWidth",
        transition: wV,
        defaultValue: 1
      },
      instanceColors: {
        size: this.props.colorFormat.length,
        type: 5121,
        normalized: !0,
        accessor: "getColor",
        transition: wV,
        defaultValue: nje
      },
      instancePickingColors: {
        size: 3,
        type: 5121,
        accessor: (r, {
          index: i,
          target: o
        }) => this.encodePickingColor(r && r.__source ? r.__source.index : i, o)
      }
    }), this.setState({
      pathTesselator: new tIn({
        fp64: this.use64bitPositions()
      })
    });
  }
  updateState(e) {
    super.updateState(e);
    const {
      props: n,
      changeFlags: r
    } = e, i = this.getAttributeManager();
    if (r.dataChanged || r.updateTriggersChanged && (r.updateTriggersChanged.all || r.updateTriggersChanged.getPath)) {
      const {
        pathTesselator: a
      } = this.state, A = n.data.attributes || {};
      a.updateGeometry({
        data: n.data,
        geometryBuffer: A.getPath,
        buffers: A,
        normalize: !n._pathType,
        loop: n._pathType === "loop",
        getGeometry: n.getPath,
        positionFormat: n.positionFormat,
        wrapLongitude: n.wrapLongitude,
        resolution: this.context.viewport.resolution,
        dataChanged: r.dataChanged
      }), this.setState({
        numInstances: a.instanceCount,
        startIndices: a.vertexStarts
      }), r.dataChanged || i.invalidateAll();
    }
    if (r.extensionsChanged) {
      var s;
      const {
        gl: a
      } = this.context;
      (s = this.state.model) === null || s === void 0 || s.delete(), this.state.model = this._getModel(a), i.invalidateAll();
    }
  }
  getPickingInfo(e) {
    const n = super.getPickingInfo(e), {
      index: r
    } = n, {
      data: i
    } = this.props;
    return i[0] && i[0].__source && (n.object = i.find((o) => o.__source.index === r)), n;
  }
  disablePickingIndex(e) {
    const {
      data: n
    } = this.props;
    if (n[0] && n[0].__source)
      for (let r = 0; r < n.length; r++)
        n[r].__source.index === e && this._disablePickingIndex(r);
    else
      this._disablePickingIndex(e);
  }
  draw({
    uniforms: e
  }) {
    const {
      jointRounded: n,
      capRounded: r,
      billboard: i,
      miterLimit: o,
      widthUnits: s,
      widthScale: a,
      widthMinPixels: A,
      widthMaxPixels: l
    } = this.props;
    this.state.model.setUniforms(e).setUniforms({
      jointType: Number(n),
      capType: Number(r),
      billboard: i,
      widthUnits: Ou[s],
      widthScale: a,
      miterLimit: o,
      widthMinPixels: A,
      widthMaxPixels: l
    }).draw();
  }
  _getModel(e) {
    const n = [0, 1, 2, 1, 4, 2, 1, 3, 4, 3, 5, 4], r = [0, 0, 0, -1, 0, 1, 1, -1, 1, 1, 1, 0];
    return new Ta(e, {
      ...this.getShaders(),
      id: this.props.id,
      geometry: new Os({
        drawMode: 4,
        attributes: {
          indices: new Uint16Array(n),
          positions: {
            value: new Float32Array(r),
            size: 2
          }
        }
      }),
      isInstanced: !0
    });
  }
  calculatePositions(e) {
    const {
      pathTesselator: n
    } = this.state;
    e.startIndices = n.vertexStarts, e.value = n.get("positions");
  }
  calculateSegmentTypes(e) {
    const {
      pathTesselator: n
    } = this.state;
    e.startIndices = n.vertexStarts, e.value = n.get("segmentTypes");
  }
}
ae(Ow, "defaultProps", iIn);
ae(Ow, "layerName", "PathLayer");
var cce = { exports: {} };
cce.exports = p$;
cce.exports.default = p$;
function p$(t, e, n) {
  n = n || 2;
  var r = e && e.length, i = r ? e[0] * n : t.length, o = rje(t, 0, i, n, !0), s = [];
  if (!o || o.next === o.prev)
    return s;
  var a, A, l, c, u, f, h;
  if (r && (o = lIn(t, e, o, n)), t.length > 80 * n) {
    a = l = t[0], A = c = t[1];
    for (var d = n; d < i; d += n)
      u = t[d], f = t[d + 1], u < a && (a = u), f < A && (A = f), u > l && (l = u), f > c && (c = f);
    h = Math.max(l - a, c - A), h = h !== 0 ? 32767 / h : 0;
  }
  return jT(o, s, n, a, A, h, 0), s;
}
function rje(t, e, n, r, i) {
  var o, s;
  if (i === ste(t, e, n, r) > 0)
    for (o = e; o < n; o += r)
      s = ySe(o, t[o], t[o + 1], s);
  else
    for (o = n - r; o >= e; o -= r)
      s = ySe(o, t[o], t[o + 1], s);
  return s && I$(s, s.next) && (zT(s), s = s.next), s;
}
function iB(t, e) {
  if (!t)
    return t;
  e || (e = t);
  var n = t, r;
  do
    if (r = !1, !n.steiner && (I$(n, n.next) || Xs(n.prev, n, n.next) === 0)) {
      if (zT(n), n = e = n.prev, n === n.next)
        break;
      r = !0;
    } else
      n = n.next;
  while (r || n !== e);
  return e;
}
function jT(t, e, n, r, i, o, s) {
  if (t) {
    !s && o && hIn(t, r, i, o);
    for (var a = t, A, l; t.prev !== t.next; ) {
      if (A = t.prev, l = t.next, o ? sIn(t, r, i, o) : oIn(t)) {
        e.push(A.i / n | 0), e.push(t.i / n | 0), e.push(l.i / n | 0), zT(t), t = l.next, a = l.next;
        continue;
      }
      if (t = l, t === a) {
        s ? s === 1 ? (t = aIn(iB(t), e, n), jT(t, e, n, r, i, o, 2)) : s === 2 && AIn(t, e, n, r, i, o) : jT(iB(t), e, n, r, i, o, 1);
        break;
      }
    }
  }
}
function oIn(t) {
  var e = t.prev, n = t, r = t.next;
  if (Xs(e, n, r) >= 0)
    return !1;
  for (var i = e.x, o = n.x, s = r.x, a = e.y, A = n.y, l = r.y, c = i < o ? i < s ? i : s : o < s ? o : s, u = a < A ? a < l ? a : l : A < l ? A : l, f = i > o ? i > s ? i : s : o > s ? o : s, h = a > A ? a > l ? a : l : A > l ? A : l, d = r.next; d !== e; ) {
    if (d.x >= c && d.x <= f && d.y >= u && d.y <= h && p_(i, a, o, A, s, l, d.x, d.y) && Xs(d.prev, d, d.next) >= 0)
      return !1;
    d = d.next;
  }
  return !0;
}
function sIn(t, e, n, r) {
  var i = t.prev, o = t, s = t.next;
  if (Xs(i, o, s) >= 0)
    return !1;
  for (var a = i.x, A = o.x, l = s.x, c = i.y, u = o.y, f = s.y, h = a < A ? a < l ? a : l : A < l ? A : l, d = c < u ? c < f ? c : f : u < f ? u : f, I = a > A ? a > l ? a : l : A > l ? A : l, m = c > u ? c > f ? c : f : u > f ? u : f, C = ite(h, d, e, n, r), y = ite(I, m, e, n, r), v = t.prevZ, b = t.nextZ; v && v.z >= C && b && b.z <= y; ) {
    if (v.x >= h && v.x <= I && v.y >= d && v.y <= m && v !== i && v !== s && p_(a, c, A, u, l, f, v.x, v.y) && Xs(v.prev, v, v.next) >= 0 || (v = v.prevZ, b.x >= h && b.x <= I && b.y >= d && b.y <= m && b !== i && b !== s && p_(a, c, A, u, l, f, b.x, b.y) && Xs(b.prev, b, b.next) >= 0))
      return !1;
    b = b.nextZ;
  }
  for (; v && v.z >= C; ) {
    if (v.x >= h && v.x <= I && v.y >= d && v.y <= m && v !== i && v !== s && p_(a, c, A, u, l, f, v.x, v.y) && Xs(v.prev, v, v.next) >= 0)
      return !1;
    v = v.prevZ;
  }
  for (; b && b.z <= y; ) {
    if (b.x >= h && b.x <= I && b.y >= d && b.y <= m && b !== i && b !== s && p_(a, c, A, u, l, f, b.x, b.y) && Xs(b.prev, b, b.next) >= 0)
      return !1;
    b = b.nextZ;
  }
  return !0;
}
function aIn(t, e, n) {
  var r = t;
  do {
    var i = r.prev, o = r.next.next;
    !I$(i, o) && ije(i, r, r.next, o) && YT(i, o) && YT(o, i) && (e.push(i.i / n | 0), e.push(r.i / n | 0), e.push(o.i / n | 0), zT(r), zT(r.next), r = t = o), r = r.next;
  } while (r !== t);
  return iB(r);
}
function AIn(t, e, n, r, i, o) {
  var s = t;
  do {
    for (var a = s.next.next; a !== s.prev; ) {
      if (s.i !== a.i && IIn(s, a)) {
        var A = oje(s, a);
        s = iB(s, s.next), A = iB(A, A.next), jT(s, e, n, r, i, o, 0), jT(A, e, n, r, i, o, 0);
        return;
      }
      a = a.next;
    }
    s = s.next;
  } while (s !== t);
}
function lIn(t, e, n, r) {
  var i = [], o, s, a, A, l;
  for (o = 0, s = e.length; o < s; o++)
    a = e[o] * r, A = o < s - 1 ? e[o + 1] * r : t.length, l = rje(t, a, A, r, !1), l === l.next && (l.steiner = !0), i.push(pIn(l));
  for (i.sort(cIn), o = 0; o < i.length; o++)
    n = uIn(i[o], n);
  return n;
}
function cIn(t, e) {
  return t.x - e.x;
}
function uIn(t, e) {
  var n = fIn(t, e);
  if (!n)
    return e;
  var r = oje(n, t);
  return iB(r, r.next), iB(n, n.next);
}
function fIn(t, e) {
  var n = e, r = t.x, i = t.y, o = -1 / 0, s;
  do {
    if (i <= n.y && i >= n.next.y && n.next.y !== n.y) {
      var a = n.x + (i - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
      if (a <= r && a > o && (o = a, s = n.x < n.next.x ? n : n.next, a === r))
        return s;
    }
    n = n.next;
  } while (n !== e);
  if (!s)
    return null;
  var A = s, l = s.x, c = s.y, u = 1 / 0, f;
  n = s;
  do
    r >= n.x && n.x >= l && r !== n.x && p_(i < c ? r : o, i, l, c, i < c ? o : r, i, n.x, n.y) && (f = Math.abs(i - n.y) / (r - n.x), YT(n, t) && (f < u || f === u && (n.x > s.x || n.x === s.x && gIn(s, n))) && (s = n, u = f)), n = n.next;
  while (n !== A);
  return s;
}
function gIn(t, e) {
  return Xs(t.prev, t, e.prev) < 0 && Xs(e.next, t, t.next) < 0;
}
function hIn(t, e, n, r) {
  var i = t;
  do
    i.z === 0 && (i.z = ite(i.x, i.y, e, n, r)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
  while (i !== t);
  i.prevZ.nextZ = null, i.prevZ = null, dIn(i);
}
function dIn(t) {
  var e, n, r, i, o, s, a, A, l = 1;
  do {
    for (n = t, t = null, o = null, s = 0; n; ) {
      for (s++, r = n, a = 0, e = 0; e < l && (a++, r = r.nextZ, !!r); e++)
        ;
      for (A = l; a > 0 || A > 0 && r; )
        a !== 0 && (A === 0 || !r || n.z <= r.z) ? (i = n, n = n.nextZ, a--) : (i = r, r = r.nextZ, A--), o ? o.nextZ = i : t = i, i.prevZ = o, o = i;
      n = r;
    }
    o.nextZ = null, l *= 2;
  } while (s > 1);
  return t;
}
function ite(t, e, n, r, i) {
  return t = (t - n) * i | 0, e = (e - r) * i | 0, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, t | e << 1;
}
function pIn(t) {
  var e = t, n = t;
  do
    (e.x < n.x || e.x === n.x && e.y < n.y) && (n = e), e = e.next;
  while (e !== t);
  return n;
}
function p_(t, e, n, r, i, o, s, a) {
  return (i - s) * (e - a) >= (t - s) * (o - a) && (t - s) * (r - a) >= (n - s) * (e - a) && (n - s) * (o - a) >= (i - s) * (r - a);
}
function IIn(t, e) {
  return t.next.i !== e.i && t.prev.i !== e.i && !mIn(t, e) && // dones't intersect other edges
  (YT(t, e) && YT(e, t) && CIn(t, e) && // locally visible
  (Xs(t.prev, t, e.prev) || Xs(t, e.prev, e)) || // does not create opposite-facing sectors
  I$(t, e) && Xs(t.prev, t, t.next) > 0 && Xs(e.prev, e, e.next) > 0);
}
function Xs(t, e, n) {
  return (e.y - t.y) * (n.x - e.x) - (e.x - t.x) * (n.y - e.y);
}
function I$(t, e) {
  return t.x === e.x && t.y === e.y;
}
function ije(t, e, n, r) {
  var i = oP(Xs(t, e, n)), o = oP(Xs(t, e, r)), s = oP(Xs(n, r, t)), a = oP(Xs(n, r, e));
  return !!(i !== o && s !== a || i === 0 && iP(t, n, e) || o === 0 && iP(t, r, e) || s === 0 && iP(n, t, r) || a === 0 && iP(n, e, r));
}
function iP(t, e, n) {
  return e.x <= Math.max(t.x, n.x) && e.x >= Math.min(t.x, n.x) && e.y <= Math.max(t.y, n.y) && e.y >= Math.min(t.y, n.y);
}
function oP(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
}
function mIn(t, e) {
  var n = t;
  do {
    if (n.i !== t.i && n.next.i !== t.i && n.i !== e.i && n.next.i !== e.i && ije(n, n.next, t, e))
      return !0;
    n = n.next;
  } while (n !== t);
  return !1;
}
function YT(t, e) {
  return Xs(t.prev, t, t.next) < 0 ? Xs(t, e, t.next) >= 0 && Xs(t, t.prev, e) >= 0 : Xs(t, e, t.prev) < 0 || Xs(t, t.next, e) < 0;
}
function CIn(t, e) {
  var n = t, r = !1, i = (t.x + e.x) / 2, o = (t.y + e.y) / 2;
  do
    n.y > o != n.next.y > o && n.next.y !== n.y && i < (n.next.x - n.x) * (o - n.y) / (n.next.y - n.y) + n.x && (r = !r), n = n.next;
  while (n !== t);
  return r;
}
function oje(t, e) {
  var n = new ote(t.i, t.x, t.y), r = new ote(e.i, e.x, e.y), i = t.next, o = e.prev;
  return t.next = e, e.prev = t, n.next = i, i.prev = n, r.next = n, n.prev = r, o.next = r, r.prev = o, r;
}
function ySe(t, e, n, r) {
  var i = new ote(t, e, n);
  return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, i.next = i), i;
}
function zT(t) {
  t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
}
function ote(t, e, n) {
  this.i = t, this.x = e, this.y = n, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}
p$.deviation = function(t, e, n, r) {
  var i = e && e.length, o = i ? e[0] * n : t.length, s = Math.abs(ste(t, 0, o, n));
  if (i)
    for (var a = 0, A = e.length; a < A; a++) {
      var l = e[a] * n, c = a < A - 1 ? e[a + 1] * n : t.length;
      s -= Math.abs(ste(t, l, c, n));
    }
  var u = 0;
  for (a = 0; a < r.length; a += 3) {
    var f = r[a] * n, h = r[a + 1] * n, d = r[a + 2] * n;
    u += Math.abs(
      (t[f] - t[d]) * (t[h + 1] - t[f + 1]) - (t[f] - t[h]) * (t[d + 1] - t[f + 1])
    );
  }
  return s === 0 && u === 0 ? 0 : Math.abs((u - s) / s);
};
function ste(t, e, n, r) {
  for (var i = 0, o = e, s = n - r; o < n; o += r)
    i += (t[s] - t[o]) * (t[o + 1] + t[s + 1]), s = o;
  return i;
}
p$.flatten = function(t) {
  for (var e = t[0][0].length, n = { vertices: [], holes: [], dimensions: e }, r = 0, i = 0; i < t.length; i++) {
    for (var o = 0; o < t[i].length; o++)
      for (var s = 0; s < e; s++)
        n.vertices.push(t[i][o][s]);
    i > 0 && (r += t[i - 1].length, n.holes.push(r));
  }
  return n;
};
var EIn = cce.exports;
const yIn = /* @__PURE__ */ ko(EIn), sP = ace.CLOCKWISE, vSe = ace.COUNTER_CLOCKWISE, AC = {
  isClosed: !0
};
function vIn(t) {
  if (t = t && t.positions || t, !Array.isArray(t) && !ArrayBuffer.isView(t))
    throw new Error("invalid polygon");
}
function _R(t) {
  return "positions" in t ? t.positions : t;
}
function Fk(t) {
  return "holeIndices" in t ? t.holeIndices : null;
}
function BIn(t) {
  return Array.isArray(t[0]);
}
function bIn(t) {
  return t.length >= 1 && t[0].length >= 2 && Number.isFinite(t[0][0]);
}
function _In(t) {
  const e = t[0], n = t[t.length - 1];
  return e[0] === n[0] && e[1] === n[1] && e[2] === n[2];
}
function SIn(t, e, n, r) {
  for (let i = 0; i < e; i++)
    if (t[n + i] !== t[r - e + i])
      return !1;
  return !0;
}
function BSe(t, e, n, r, i) {
  let o = e;
  const s = n.length;
  for (let a = 0; a < s; a++)
    for (let A = 0; A < r; A++)
      t[o++] = n[a][A] || 0;
  if (!_In(n))
    for (let a = 0; a < r; a++)
      t[o++] = n[0][a] || 0;
  return AC.start = e, AC.end = o, AC.size = r, Ace(t, i, AC), o;
}
function bSe(t, e, n, r, i = 0, o, s) {
  o = o || n.length;
  const a = o - i;
  if (a <= 0)
    return e;
  let A = e;
  for (let l = 0; l < a; l++)
    t[A++] = n[i + l];
  if (!SIn(n, r, i, o))
    for (let l = 0; l < r; l++)
      t[A++] = n[i + l];
  return AC.start = e, AC.end = A, AC.size = r, Ace(t, s, AC), A;
}
function sje(t, e) {
  vIn(t);
  const n = [], r = [];
  if ("positions" in t) {
    const {
      positions: i,
      holeIndices: o
    } = t;
    if (o) {
      let s = 0;
      for (let a = 0; a <= o.length; a++)
        s = bSe(n, s, i, e, o[a - 1], o[a], a === 0 ? sP : vSe), r.push(s);
      return r.pop(), {
        positions: n,
        holeIndices: r
      };
    }
    t = i;
  }
  if (!BIn(t))
    return bSe(n, 0, t, e, 0, n.length, sP), n;
  if (!bIn(t)) {
    let i = 0;
    for (const [o, s] of t.entries())
      i = BSe(n, i, s, e, o === 0 ? sP : vSe), r.push(i);
    return r.pop(), {
      positions: n,
      holeIndices: r
    };
  }
  return BSe(n, 0, t, e, sP), n;
}
function QIn(t, e, n) {
  let r = Fk(t);
  r && (r = r.map((o) => o / e));
  let i = _R(t);
  if (n) {
    const o = i.length;
    i = i.slice();
    const s = [];
    for (let a = 0; a < o; a += e) {
      s[0] = i[a], s[1] = i[a + 1];
      const A = n(s);
      i[a] = A[0], i[a + 1] = A[1];
    }
  }
  return yIn(i, r, e);
}
class wIn extends oce {
  constructor(e) {
    const {
      fp64: n,
      IndexType: r = Uint32Array
    } = e;
    super({
      ...e,
      attributes: {
        positions: {
          size: 3,
          type: n ? Float64Array : Float32Array
        },
        vertexValid: {
          type: Uint8ClampedArray,
          size: 1
        },
        indices: {
          type: r,
          size: 1
        }
      }
    });
  }
  get(e) {
    const {
      attributes: n
    } = this;
    return e === "indices" ? n.indices && n.indices.subarray(0, this.vertexCount) : n[e];
  }
  updateGeometry(e) {
    super.updateGeometry(e);
    const n = this.buffers.indices;
    if (n)
      this.vertexCount = (n.value || n).length;
    else if (this.data && !this.getGeometry)
      throw new Error("missing indices buffer");
  }
  normalizeGeometry(e) {
    if (this.normalize) {
      const n = sje(e, this.positionSize);
      return this.opts.resolution ? Xqe(_R(n), Fk(n), {
        size: this.positionSize,
        gridResolution: this.opts.resolution,
        edgeTypes: !0
      }) : this.opts.wrapLongitude ? $0n(_R(n), Fk(n), {
        size: this.positionSize,
        maxLatitude: 86,
        edgeTypes: !0
      }) : n;
    }
    return e;
  }
  getGeometrySize(e) {
    if (_Se(e)) {
      let n = 0;
      for (const r of e)
        n += this.getGeometrySize(r);
      return n;
    }
    return _R(e).length / this.positionSize;
  }
  getGeometryFromBuffer(e) {
    return this.normalize || !this.buffers.indices ? super.getGeometryFromBuffer(e) : null;
  }
  updateGeometryAttributes(e, n) {
    if (e && _Se(e))
      for (const r of e) {
        const i = this.getGeometrySize(r);
        n.geometrySize = i, this.updateGeometryAttributes(r, n), n.vertexStart += i, n.indexStart = this.indexStarts[n.geometryIndex + 1];
      }
    else
      this._updateIndices(e, n), this._updatePositions(e, n), this._updateVertexValid(e, n);
  }
  _updateIndices(e, {
    geometryIndex: n,
    vertexStart: r,
    indexStart: i
  }) {
    const {
      attributes: o,
      indexStarts: s,
      typedArrayManager: a
    } = this;
    let A = o.indices;
    if (!A || !e)
      return;
    let l = i;
    const c = QIn(e, this.positionSize, this.opts.preproject);
    A = a.allocate(A, i + c.length, {
      copy: !0
    });
    for (let u = 0; u < c.length; u++)
      A[l++] = c[u] + r;
    s[n + 1] = i + c.length, o.indices = A;
  }
  _updatePositions(e, {
    vertexStart: n,
    geometrySize: r
  }) {
    const {
      attributes: {
        positions: i
      },
      positionSize: o
    } = this;
    if (!i || !e)
      return;
    const s = _R(e);
    for (let a = n, A = 0; A < r; a++, A++) {
      const l = s[A * o], c = s[A * o + 1], u = o > 2 ? s[A * o + 2] : 0;
      i[a * 3] = l, i[a * 3 + 1] = c, i[a * 3 + 2] = u;
    }
  }
  _updateVertexValid(e, {
    vertexStart: n,
    geometrySize: r
  }) {
    const {
      positionSize: i
    } = this, o = this.attributes.vertexValid, s = e && Fk(e);
    if (e && e.edgeTypes ? o.set(e.edgeTypes, n) : o.fill(1, n, n + r), s)
      for (let a = 0; a < s.length; a++)
        o[n + s[a] / i - 1] = 0;
    o[n + r - 1] = 0;
  }
}
function _Se(t) {
  return Array.isArray(t) && t.length > 0 && !Number.isFinite(t[0]);
}
const aje = `
attribute vec2 vertexPositions;
attribute float vertexValid;

uniform bool extruded;
uniform bool isWireframe;
uniform float elevationScale;
uniform float opacity;

varying vec4 vColor;

struct PolygonProps {
  vec4 fillColors;
  vec4 lineColors;
  vec3 positions;
  vec3 nextPositions;
  vec3 pickingColors;
  vec3 positions64Low;
  vec3 nextPositions64Low;
  float elevations;
};

vec3 project_offset_normal(vec3 vector) {
  if (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT ||
    project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT_OFFSETS) {
    // normals generated by the polygon tesselator are in lnglat offsets instead of meters
    return normalize(vector * project_uCommonUnitsPerWorldUnit);
  }
  return project_normal(vector);
}

void calculatePosition(PolygonProps props) {
#ifdef IS_SIDE_VERTEX
  if(vertexValid < 0.5){
    gl_Position = vec4(0.);
    return;
  }
#endif

  vec3 pos;
  vec3 pos64Low;
  vec3 normal;
  vec4 colors = isWireframe ? props.lineColors : props.fillColors;

  geometry.worldPosition = props.positions;
  geometry.worldPositionAlt = props.nextPositions;
  geometry.pickingColor = props.pickingColors;

#ifdef IS_SIDE_VERTEX
  pos = mix(props.positions, props.nextPositions, vertexPositions.x);
  pos64Low = mix(props.positions64Low, props.nextPositions64Low, vertexPositions.x);
#else
  pos = props.positions;
  pos64Low = props.positions64Low;
#endif

  if (extruded) {
    pos.z += props.elevations * vertexPositions.y * elevationScale;
  }
  gl_Position = project_position_to_clipspace(pos, pos64Low, vec3(0.), geometry.position);

  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  if (extruded) {
  #ifdef IS_SIDE_VERTEX
    normal = vec3(
      props.positions.y - props.nextPositions.y + (props.positions64Low.y - props.nextPositions64Low.y),
      props.nextPositions.x - props.positions.x + (props.nextPositions64Low.x - props.positions64Low.x),
      0.0);
    normal = project_offset_normal(normal);
  #else
    normal = project_normal(vec3(0.0, 0.0, 1.0));
  #endif
    geometry.normal = normal;
    vec3 lightColor = lighting_getLightColor(colors.rgb, project_uCameraPosition, geometry.position.xyz, normal);
    vColor = vec4(lightColor, colors.a * opacity);
  } else {
    vColor = vec4(colors.rgb, colors.a * opacity);
  }
  DECKGL_FILTER_COLOR(vColor, geometry);
}
`, xIn = `#define SHADER_NAME solid-polygon-layer-vertex-shader

attribute vec3 positions;
attribute vec3 positions64Low;
attribute float elevations;
attribute vec4 fillColors;
attribute vec4 lineColors;
attribute vec3 pickingColors;

`.concat(aje, `

void main(void) {
  PolygonProps props;

  props.positions = positions;
  props.positions64Low = positions64Low;
  props.elevations = elevations;
  props.fillColors = fillColors;
  props.lineColors = lineColors;
  props.pickingColors = pickingColors;

  calculatePosition(props);
}
`), RIn = `#define SHADER_NAME solid-polygon-layer-vertex-shader-side
#define IS_SIDE_VERTEX


attribute vec3 instancePositions;
attribute vec3 nextPositions;
attribute vec3 instancePositions64Low;
attribute vec3 nextPositions64Low;
attribute float instanceElevations;
attribute vec4 instanceFillColors;
attribute vec4 instanceLineColors;
attribute vec3 instancePickingColors;

`.concat(aje, `

void main(void) {
  PolygonProps props;

  #if RING_WINDING_ORDER_CW == 1
    props.positions = instancePositions;
    props.positions64Low = instancePositions64Low;
    props.nextPositions = nextPositions;
    props.nextPositions64Low = nextPositions64Low;
  #else
    props.positions = nextPositions;
    props.positions64Low = nextPositions64Low;
    props.nextPositions = instancePositions;
    props.nextPositions64Low = instancePositions64Low;
  #endif
  props.elevations = instanceElevations;
  props.fillColors = instanceFillColors;
  props.lineColors = instanceLineColors;
  props.pickingColors = instancePickingColors;

  calculatePosition(props);
}
`), DIn = `#define SHADER_NAME solid-polygon-layer-fragment-shader

precision highp float;

varying vec4 vColor;

void main(void) {
  gl_FragColor = vColor;

  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`, MU = [0, 0, 0, 255], TIn = {
  filled: !0,
  extruded: !1,
  wireframe: !1,
  _normalize: !0,
  _windingOrder: "CW",
  elevationScale: {
    type: "number",
    min: 0,
    value: 1
  },
  getPolygon: {
    type: "accessor",
    value: (t) => t.polygon
  },
  getElevation: {
    type: "accessor",
    value: 1e3
  },
  getFillColor: {
    type: "accessor",
    value: MU
  },
  getLineColor: {
    type: "accessor",
    value: MU
  },
  material: !0
}, aP = {
  enter: (t, e) => e.length ? e.subarray(e.length - t.length) : t
};
class CM extends IA {
  constructor(...e) {
    super(...e), ae(this, "state", void 0);
  }
  getShaders(e) {
    return super.getShaders({
      vs: e === "top" ? xIn : RIn,
      fs: DIn,
      defines: {
        RING_WINDING_ORDER_CW: !this.props._normalize && this.props._windingOrder === "CCW" ? 0 : 1
      },
      modules: [qA, cM, jA]
    });
  }
  get wrapLongitude() {
    return !1;
  }
  initializeState() {
    const {
      gl: e,
      viewport: n
    } = this.context;
    let {
      coordinateSystem: r
    } = this.props;
    n.isGeospatial && r === wn.DEFAULT && (r = wn.LNGLAT), this.setState({
      numInstances: 0,
      polygonTesselator: new wIn({
        preproject: r === wn.LNGLAT && n.projectFlat.bind(n),
        fp64: this.use64bitPositions(),
        IndexType: !e || e$(e, no.ELEMENT_INDEX_UINT32) ? Uint32Array : Uint16Array
      })
    });
    const i = this.getAttributeManager(), o = !0;
    i.remove(["instancePickingColors"]), i.add({
      indices: {
        size: 1,
        isIndexed: !0,
        update: this.calculateIndices,
        noAlloc: o
      },
      positions: {
        size: 3,
        type: 5130,
        fp64: this.use64bitPositions(),
        transition: aP,
        accessor: "getPolygon",
        update: this.calculatePositions,
        noAlloc: o,
        shaderAttributes: {
          positions: {
            vertexOffset: 0,
            divisor: 0
          },
          instancePositions: {
            vertexOffset: 0,
            divisor: 1
          },
          nextPositions: {
            vertexOffset: 1,
            divisor: 1
          }
        }
      },
      vertexValid: {
        size: 1,
        divisor: 1,
        type: 5121,
        update: this.calculateVertexValid,
        noAlloc: o
      },
      elevations: {
        size: 1,
        transition: aP,
        accessor: "getElevation",
        shaderAttributes: {
          elevations: {
            divisor: 0
          },
          instanceElevations: {
            divisor: 1
          }
        }
      },
      fillColors: {
        size: this.props.colorFormat.length,
        type: 5121,
        normalized: !0,
        transition: aP,
        accessor: "getFillColor",
        defaultValue: MU,
        shaderAttributes: {
          fillColors: {
            divisor: 0
          },
          instanceFillColors: {
            divisor: 1
          }
        }
      },
      lineColors: {
        size: this.props.colorFormat.length,
        type: 5121,
        normalized: !0,
        transition: aP,
        accessor: "getLineColor",
        defaultValue: MU,
        shaderAttributes: {
          lineColors: {
            divisor: 0
          },
          instanceLineColors: {
            divisor: 1
          }
        }
      },
      pickingColors: {
        size: 3,
        type: 5121,
        accessor: (s, {
          index: a,
          target: A
        }) => this.encodePickingColor(s && s.__source ? s.__source.index : a, A),
        shaderAttributes: {
          pickingColors: {
            divisor: 0
          },
          instancePickingColors: {
            divisor: 1
          }
        }
      }
    });
  }
  getPickingInfo(e) {
    const n = super.getPickingInfo(e), {
      index: r
    } = n, {
      data: i
    } = this.props;
    return i[0] && i[0].__source && (n.object = i.find((o) => o.__source.index === r)), n;
  }
  disablePickingIndex(e) {
    const {
      data: n
    } = this.props;
    if (n[0] && n[0].__source)
      for (let r = 0; r < n.length; r++)
        n[r].__source.index === e && this._disablePickingIndex(r);
    else
      this._disablePickingIndex(e);
  }
  draw({
    uniforms: e
  }) {
    const {
      extruded: n,
      filled: r,
      wireframe: i,
      elevationScale: o
    } = this.props, {
      topModel: s,
      sideModel: a,
      polygonTesselator: A
    } = this.state, l = {
      ...e,
      extruded: !!n,
      elevationScale: o
    };
    a && (a.setInstanceCount(A.instanceCount - 1), a.setUniforms(l), i && (a.setDrawMode(3), a.setUniforms({
      isWireframe: !0
    }).draw()), r && (a.setDrawMode(6), a.setUniforms({
      isWireframe: !1
    }).draw())), s && (s.setVertexCount(A.vertexCount), s.setUniforms(l).draw());
  }
  updateState(e) {
    super.updateState(e), this.updateGeometry(e);
    const {
      props: n,
      oldProps: r,
      changeFlags: i
    } = e, o = this.getAttributeManager();
    if (i.extensionsChanged || n.filled !== r.filled || n.extruded !== r.extruded) {
      var a;
      (a = this.state.models) === null || a === void 0 || a.forEach((A) => A.delete()), this.setState(this._getModels(this.context.gl)), o.invalidateAll();
    }
  }
  updateGeometry({
    props: e,
    oldProps: n,
    changeFlags: r
  }) {
    if (r.dataChanged || r.updateTriggersChanged && (r.updateTriggersChanged.all || r.updateTriggersChanged.getPolygon)) {
      const {
        polygonTesselator: o
      } = this.state, s = e.data.attributes || {};
      o.updateGeometry({
        data: e.data,
        normalize: e._normalize,
        geometryBuffer: s.getPolygon,
        buffers: s,
        getGeometry: e.getPolygon,
        positionFormat: e.positionFormat,
        wrapLongitude: e.wrapLongitude,
        resolution: this.context.viewport.resolution,
        fp64: this.use64bitPositions(),
        dataChanged: r.dataChanged
      }), this.setState({
        numInstances: o.instanceCount,
        startIndices: o.vertexStarts
      }), r.dataChanged || this.getAttributeManager().invalidateAll();
    }
  }
  _getModels(e) {
    const {
      id: n,
      filled: r,
      extruded: i
    } = this.props;
    let o, s;
    if (r) {
      const a = this.getShaders("top");
      a.defines.NON_INSTANCED_MODEL = 1, o = new Ta(e, {
        ...a,
        id: "".concat(n, "-top"),
        drawMode: 4,
        attributes: {
          vertexPositions: new Float32Array([0, 1])
        },
        uniforms: {
          isWireframe: !1,
          isSideVertex: !1
        },
        vertexCount: 0,
        isIndexed: !0
      });
    }
    return i && (s = new Ta(e, {
      ...this.getShaders("side"),
      id: "".concat(n, "-side"),
      geometry: new Os({
        drawMode: 1,
        vertexCount: 4,
        attributes: {
          vertexPositions: {
            size: 2,
            value: new Float32Array([1, 0, 0, 0, 0, 1, 1, 1])
          }
        }
      }),
      instanceCount: 0,
      isInstanced: 1
    }), s.userData.excludeAttributes = {
      indices: !0
    }), {
      models: [s, o].filter(Boolean),
      topModel: o,
      sideModel: s
    };
  }
  calculateIndices(e) {
    const {
      polygonTesselator: n
    } = this.state;
    e.startIndices = n.indexStarts, e.value = n.get("indices");
  }
  calculatePositions(e) {
    const {
      polygonTesselator: n
    } = this.state;
    e.startIndices = n.vertexStarts, e.value = n.get("positions");
  }
  calculateVertexValid(e) {
    e.value = this.state.polygonTesselator.get("vertexValid");
  }
}
ae(CM, "defaultProps", TIn);
ae(CM, "layerName", "SolidPolygonLayer");
function Aje({
  data: t,
  getIndex: e,
  dataRange: n,
  replace: r
}) {
  const {
    startRow: i = 0,
    endRow: o = 1 / 0
  } = n, s = t.length;
  let a = s, A = s;
  for (let f = 0; f < s; f++) {
    const h = e(t[f]);
    if (a > f && h >= i && (a = f), h >= o) {
      A = f;
      break;
    }
  }
  let l = a;
  const u = A - a !== r.length ? t.slice(A) : void 0;
  for (let f = 0; f < r.length; f++)
    t[l++] = r[f];
  if (u) {
    for (let f = 0; f < u.length; f++)
      t[l++] = u[f];
    t.length = l;
  }
  return {
    startRow: a,
    endRow: a + r.length
  };
}
const lje = [0, 0, 0, 255], NIn = [0, 0, 0, 255], LIn = {
  stroked: !0,
  filled: !0,
  extruded: !1,
  elevationScale: 1,
  wireframe: !1,
  _normalize: !0,
  _windingOrder: "CW",
  lineWidthUnits: "meters",
  lineWidthScale: 1,
  lineWidthMinPixels: 0,
  lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
  lineJointRounded: !1,
  lineMiterLimit: 4,
  getPolygon: {
    type: "accessor",
    value: (t) => t.polygon
  },
  getFillColor: {
    type: "accessor",
    value: NIn
  },
  getLineColor: {
    type: "accessor",
    value: lje
  },
  getLineWidth: {
    type: "accessor",
    value: 1
  },
  getElevation: {
    type: "accessor",
    value: 1e3
  },
  material: !0
};
class Pf extends mA {
  initializeState() {
    this.state = {
      paths: []
    }, this.props.getLineDashArray && Rr.removed("getLineDashArray", "PathStyleExtension")();
  }
  updateState({
    changeFlags: e
  }) {
    const n = e.dataChanged || e.updateTriggersChanged && (e.updateTriggersChanged.all || e.updateTriggersChanged.getPolygon);
    if (n && Array.isArray(e.dataChanged)) {
      const r = this.state.paths.slice(), i = e.dataChanged.map((o) => Aje({
        data: r,
        getIndex: (s) => s.__source.index,
        dataRange: o,
        replace: this._getPaths(o)
      }));
      this.setState({
        paths: r,
        pathsDiff: i
      });
    } else
      n && this.setState({
        paths: this._getPaths(),
        pathsDiff: null
      });
  }
  _getPaths(e = {}) {
    const {
      data: n,
      getPolygon: r,
      positionFormat: i,
      _normalize: o
    } = this.props, s = [], a = i === "XY" ? 2 : 3, {
      startRow: A,
      endRow: l
    } = e, {
      iterable: c,
      objectInfo: u
    } = ZI(n, A, l);
    for (const f of c) {
      u.index++;
      let h = r(f, u);
      o && (h = sje(h, a));
      const {
        holeIndices: d
      } = h, I = h.positions || h;
      if (d)
        for (let m = 0; m <= d.length; m++) {
          const C = I.slice(d[m - 1] || 0, d[m] || I.length);
          s.push(this.getSubLayerRow({
            path: C
          }, f, u.index));
        }
      else
        s.push(this.getSubLayerRow({
          path: I
        }, f, u.index));
    }
    return s;
  }
  renderLayers() {
    const {
      data: e,
      _dataDiff: n,
      stroked: r,
      filled: i,
      extruded: o,
      wireframe: s,
      _normalize: a,
      _windingOrder: A,
      elevationScale: l,
      transitions: c,
      positionFormat: u
    } = this.props, {
      lineWidthUnits: f,
      lineWidthScale: h,
      lineWidthMinPixels: d,
      lineWidthMaxPixels: I,
      lineJointRounded: m,
      lineMiterLimit: C,
      lineDashJustified: y
    } = this.props, {
      getFillColor: v,
      getLineColor: b,
      getLineWidth: Q,
      getLineDashArray: w,
      getElevation: R,
      getPolygon: M,
      updateTriggers: O,
      material: L
    } = this.props, {
      paths: N,
      pathsDiff: k
    } = this.state, $ = this.getSubLayerClass("fill", CM), U = this.getSubLayerClass("stroke", Ow), X = this.shouldRenderSubLayer("fill", N) && new $({
      _dataDiff: n,
      extruded: o,
      elevationScale: l,
      filled: i,
      wireframe: s,
      _normalize: a,
      _windingOrder: A,
      getElevation: R,
      getFillColor: v,
      getLineColor: o && s ? b : lje,
      material: L,
      transitions: c
    }, this.getSubLayerProps({
      id: "fill",
      updateTriggers: O && {
        getPolygon: O.getPolygon,
        getElevation: O.getElevation,
        getFillColor: O.getFillColor,
        lineColors: o && s,
        getLineColor: O.getLineColor
      }
    }), {
      data: e,
      positionFormat: u,
      getPolygon: M
    }), K = !o && r && this.shouldRenderSubLayer("stroke", N) && new U({
      _dataDiff: k && (() => k),
      widthUnits: f,
      widthScale: h,
      widthMinPixels: d,
      widthMaxPixels: I,
      jointRounded: m,
      miterLimit: C,
      dashJustified: y,
      _pathType: "loop",
      transitions: c && {
        getWidth: c.getLineWidth,
        getColor: c.getLineColor,
        getPath: c.getPolygon
      },
      getColor: this.getSubLayerAccessor(b),
      getWidth: this.getSubLayerAccessor(Q),
      getDashArray: this.getSubLayerAccessor(w)
    }, this.getSubLayerProps({
      id: "stroke",
      updateTriggers: O && {
        getWidth: O.getLineWidth,
        getColor: O.getLineColor,
        getDashArray: O.getLineDashArray
      }
    }), {
      data: N,
      positionFormat: u,
      getPath: (z) => z.path
    });
    return [!o && X, K, o && X];
  }
}
ae(Pf, "layerName", "PolygonLayer");
ae(Pf, "defaultProps", LIn);
function MIn(t, e) {
  if (!t)
    return null;
  const n = "startIndices" in t ? t.startIndices[e] : e, r = t.featureIds.value[n];
  return n !== -1 ? OIn(t, r, n) : null;
}
function OIn(t, e, n) {
  const r = {
    properties: {
      ...t.properties[e]
    }
  };
  for (const i in t.numericProps)
    r.properties[i] = t.numericProps[i].value[n];
  return r;
}
function FIn(t, e) {
  const n = {
    points: null,
    lines: null,
    polygons: null
  };
  for (const r in n) {
    const i = t[r].globalFeatureIds.value;
    n[r] = new Uint8ClampedArray(i.length * 3);
    const o = [];
    for (let s = 0; s < i.length; s++)
      e(i[s], o), n[r][s * 3 + 0] = o[0], n[r][s * 3 + 1] = o[1], n[r][s * 3 + 2] = o[2];
  }
  return n;
}
const PIn = `#define SHADER_NAME multi-icon-layer-fragment-shader

precision highp float;

uniform float opacity;
uniform sampler2D iconsTexture;
uniform float gamma;
uniform bool sdf;
uniform float alphaCutoff;
uniform float buffer;
uniform float outlineBuffer;
uniform vec4 outlineColor;

varying vec4 vColor;
varying vec2 vTextureCoords;
varying vec2 uv;

void main(void) {
  geometry.uv = uv;

  if (!picking_uActive) {
    float alpha = texture2D(iconsTexture, vTextureCoords).a;
    vec4 color = vColor;

    // if enable sdf (signed distance fields)
    if (sdf) {
      float distance = alpha;
      alpha = smoothstep(buffer - gamma, buffer + gamma, distance);

      if (outlineBuffer > 0.0) {
        float inFill = alpha;
        float inBorder = smoothstep(outlineBuffer - gamma, outlineBuffer + gamma, distance);
        color = mix(outlineColor, vColor, inFill);
        alpha = inBorder;
      }
    }

    // Take the global opacity and the alpha from color into account for the alpha component
    float a = alpha * color.a;
    
    if (a < alphaCutoff) {
      discard;
    }

    gl_FragColor = vec4(color.rgb, a * opacity);
  }

  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`, SSe = 192 / 256, QSe = [], kIn = {
  getIconOffsets: {
    type: "accessor",
    value: (t) => t.offsets
  },
  alphaCutoff: 1e-3,
  smoothing: 0.1,
  outlineWidth: 0,
  outlineColor: {
    type: "color",
    value: [0, 0, 0, 255]
  }
};
class m$ extends IM {
  constructor(...e) {
    super(...e), ae(this, "state", void 0);
  }
  getShaders() {
    return {
      ...super.getShaders(),
      fs: PIn
    };
  }
  initializeState() {
    super.initializeState(), this.getAttributeManager().addInstanced({
      instanceOffsets: {
        size: 2,
        accessor: "getIconOffsets"
      },
      instancePickingColors: {
        type: 5121,
        size: 3,
        accessor: (n, {
          index: r,
          target: i
        }) => this.encodePickingColor(r, i)
      }
    });
  }
  updateState(e) {
    super.updateState(e);
    const {
      props: n,
      oldProps: r
    } = e;
    let {
      outlineColor: i
    } = n;
    i !== r.outlineColor && (i = i.map((o) => o / 255), i[3] = Number.isFinite(i[3]) ? i[3] : 1, this.setState({
      outlineColor: i
    })), !n.sdf && n.outlineWidth && Rr.warn("".concat(this.id, ": fontSettings.sdf is required to render outline"))();
  }
  draw(e) {
    const {
      sdf: n,
      smoothing: r,
      outlineWidth: i
    } = this.props, {
      outlineColor: o
    } = this.state;
    e.uniforms = {
      ...e.uniforms,
      buffer: SSe,
      outlineBuffer: i ? Math.max(r, SSe * (1 - i)) : -1,
      gamma: r,
      sdf: !!n,
      outlineColor: o
    }, super.draw(e);
  }
  getInstanceOffset(e) {
    return e ? Array.from(e).flatMap((n) => super.getInstanceOffset(n)) : QSe;
  }
  getInstanceColorMode(e) {
    return 1;
  }
  getInstanceIconFrame(e) {
    return e ? Array.from(e).flatMap((n) => super.getInstanceIconFrame(n)) : QSe;
  }
}
ae(m$, "defaultProps", kIn);
ae(m$, "layerName", "MultiIconLayer");
var uce = { exports: {} };
uce.exports = EM;
uce.exports.default = EM;
var j_ = 1e20;
function EM(t, e, n, r, i, o) {
  this.fontSize = t || 24, this.buffer = e === void 0 ? 3 : e, this.cutoff = r || 0.25, this.fontFamily = i || "sans-serif", this.fontWeight = o || "normal", this.radius = n || 8;
  var s = this.size = this.fontSize + this.buffer * 2, a = s + this.buffer * 2;
  this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = s, this.ctx = this.canvas.getContext("2d"), this.ctx.font = this.fontWeight + " " + this.fontSize + "px " + this.fontFamily, this.ctx.textAlign = "left", this.ctx.fillStyle = "black", this.gridOuter = new Float64Array(a * a), this.gridInner = new Float64Array(a * a), this.f = new Float64Array(a), this.z = new Float64Array(a + 1), this.v = new Uint16Array(a), this.useMetrics = this.ctx.measureText("A").actualBoundingBoxLeft !== void 0, this.middle = Math.round(s / 2 * (navigator.userAgent.indexOf("Gecko/") >= 0 ? 1.2 : 1));
}
function GIn(t, e, n, r, i, o, s) {
  o.fill(j_, 0, e * n), s.fill(0, 0, e * n);
  for (var a = (e - r) / 2, A = 0; A < i; A++)
    for (var l = 0; l < r; l++) {
      var c = (A + a) * e + l + a, u = t.data[4 * (A * r + l) + 3] / 255;
      if (u === 1)
        o[c] = 0, s[c] = j_;
      else if (u === 0)
        o[c] = j_, s[c] = 0;
      else {
        var f = Math.max(0, 0.5 - u), h = Math.max(0, u - 0.5);
        o[c] = f * f, s[c] = h * h;
      }
    }
}
function UIn(t, e, n, r, i, o, s) {
  for (var a = 0; a < e * n; a++) {
    var A = Math.sqrt(r[a]) - Math.sqrt(i[a]);
    t[a] = Math.round(255 - 255 * (A / o + s));
  }
}
EM.prototype._draw = function(t, e) {
  var n = this.ctx.measureText(t), r = n.width, i = 2 * this.buffer, o, s, a, A, l, c, u, f;
  e && this.useMetrics ? (l = Math.floor(n.actualBoundingBoxAscent), f = this.buffer + Math.ceil(n.actualBoundingBoxAscent), c = this.buffer, u = this.buffer, s = Math.min(
    this.size,
    Math.ceil(n.actualBoundingBoxRight - n.actualBoundingBoxLeft)
  ), A = Math.min(
    this.size - c,
    Math.ceil(n.actualBoundingBoxAscent + n.actualBoundingBoxDescent)
  ), o = s + i, a = A + i, this.ctx.textBaseline = "alphabetic") : (o = s = this.size, a = A = this.size, l = 19 * this.fontSize / 24, c = u = 0, f = this.middle, this.ctx.textBaseline = "middle");
  var h;
  s && A && (this.ctx.clearRect(u, c, s, A), this.ctx.fillText(t, this.buffer, f), h = this.ctx.getImageData(u, c, s, A));
  var d = new Uint8ClampedArray(o * a);
  return GIn(h, o, a, s, A, this.gridOuter, this.gridInner), wSe(this.gridOuter, o, a, this.f, this.v, this.z), wSe(this.gridInner, o, a, this.f, this.v, this.z), UIn(d, o, a, this.gridOuter, this.gridInner, this.radius, this.cutoff), {
    data: d,
    metrics: {
      width: s,
      height: A,
      sdfWidth: o,
      sdfHeight: a,
      top: l,
      left: 0,
      advance: r
    }
  };
};
EM.prototype.draw = function(t) {
  return this._draw(t, !1).data;
};
EM.prototype.drawWithMetrics = function(t) {
  return this._draw(t, !0);
};
function wSe(t, e, n, r, i, o) {
  for (var s = 0; s < e; s++)
    xSe(t, s, e, n, r, i, o);
  for (var a = 0; a < n; a++)
    xSe(t, a * e, 1, e, r, i, o);
}
function xSe(t, e, n, r, i, o, s) {
  var a, A, l, c;
  for (o[0] = 0, s[0] = -j_, s[1] = j_, a = 0; a < r; a++)
    i[a] = t[e + a * n];
  for (a = 1, A = 0, l = 0; a < r; a++) {
    do
      c = o[A], l = (i[a] - i[c] + a * a - c * c) / (a - c) / 2;
    while (l <= s[A] && --A > -1);
    A++, o[A] = a, s[A] = l, s[A + 1] = j_;
  }
  for (a = 0, A = 0; a < r; a++) {
    for (; s[A + 1] < a; )
      A++;
    c = o[A], t[e + a * n] = i[c] + (a - c) * (a - c);
  }
}
var HIn = uce.exports;
const $In = /* @__PURE__ */ ko(HIn), qIn = 32, jIn = [];
function YIn(t) {
  return Math.pow(2, Math.ceil(Math.log2(t)));
}
function zIn({
  characterSet: t,
  getFontWidth: e,
  fontHeight: n,
  buffer: r,
  maxCanvasWidth: i,
  mapping: o = {},
  xOffset: s = 0,
  yOffset: a = 0
}) {
  let A = 0, l = s;
  for (const u of t)
    if (!o[u]) {
      const f = e(u);
      l + f + r * 2 > i && (l = 0, A++), o[u] = {
        x: l + r,
        y: a + A * (n + r * 2) + r,
        width: f,
        height: n
      }, l += f + r * 2;
    }
  const c = n + r * 2;
  return {
    mapping: o,
    xOffset: l,
    yOffset: a + A * c,
    canvasHeight: YIn(a + (A + 1) * c)
  };
}
function cje(t, e, n, r) {
  let i = 0;
  for (let s = e; s < n; s++) {
    var o;
    const a = t[s];
    i += ((o = r[a]) === null || o === void 0 ? void 0 : o.width) || 0;
  }
  return i;
}
function uje(t, e, n, r, i, o) {
  let s = e, a = 0;
  for (let A = e; A < n; A++) {
    const l = cje(t, A, A + 1, i);
    a + l > r && (s < A && o.push(A), s = A, a = 0), a += l;
  }
  return a;
}
function VIn(t, e, n, r, i, o) {
  let s = e, a = e, A = e, l = 0;
  for (let c = e; c < n; c++)
    if ((t[c] === " " || t[c + 1] === " " || c + 1 === n) && (A = c + 1), A > a) {
      let u = cje(t, a, A, i);
      l + u > r && (s < a && (o.push(a), s = a, l = 0), u > r && (u = uje(t, a, A, r, i, o), s = o[o.length - 1])), a = A, l += u;
    }
  return l;
}
function JIn(t, e, n, r, i = 0, o) {
  o === void 0 && (o = t.length);
  const s = [];
  return e === "break-all" ? uje(t, i, o, n, r, s) : VIn(t, i, o, n, r, s), s;
}
function KIn(t, e, n, r, i, o) {
  let s = 0, a = 0;
  for (let A = e; A < n; A++) {
    const l = t[A], c = r[l];
    c ? (a || (a = c.height), i[A] = s + c.width / 2, s += c.width) : (Rr.warn("Missing character: ".concat(l, " (").concat(l.codePointAt(0), ")"))(), i[A] = s, s += qIn);
  }
  o[0] = s, o[1] = a;
}
function RSe(t, e, n, r, i) {
  const o = Array.from(t), s = o.length, a = new Array(s), A = new Array(s), l = new Array(s), c = (n === "break-word" || n === "break-all") && isFinite(r) && r > 0, u = [0, 0], f = [0, 0];
  let h = 0, d = 0, I = 0;
  for (let m = 0; m <= s; m++) {
    const C = o[m];
    if ((C === `
` || m === s) && (I = m), I > d) {
      const y = c ? JIn(o, n, r, i, d, I) : jIn;
      for (let v = 0; v <= y.length; v++) {
        const b = v === 0 ? d : y[v - 1], Q = v < y.length ? y[v] : I;
        KIn(o, b, Q, i, a, f);
        for (let w = b; w < Q; w++)
          A[w] = h + f[1] / 2, l[w] = f[0];
        h = h + f[1] * e, u[0] = Math.max(u[0], f[0]);
      }
      d = I;
    }
    C === `
` && (a[d] = 0, A[d] = 0, l[d] = 0, d++);
  }
  return u[1] = h, {
    x: a,
    y: A,
    rowWidth: l,
    size: u
  };
}
function WIn({
  value: t,
  length: e,
  stride: n,
  offset: r,
  startIndices: i,
  characterSet: o
}) {
  const s = t.BYTES_PER_ELEMENT, a = n ? n / s : 1, A = r ? r / s : 0, l = i[e] || Math.ceil((t.length - A) / a), c = o && /* @__PURE__ */ new Set(), u = new Array(e);
  let f = t;
  if (a > 1 || A > 0) {
    const h = t.constructor;
    f = new h(l);
    for (let d = 0; d < l; d++)
      f[d] = t[d * a + A];
  }
  for (let h = 0; h < e; h++) {
    const d = i[h], I = i[h + 1] || l, m = f.subarray(d, I);
    u[h] = String.fromCodePoint.apply(null, m), c && m.forEach(c.add, c);
  }
  if (c)
    for (const h of c)
      o.add(String.fromCodePoint(h));
  return {
    texts: u,
    characterCount: l
  };
}
let fje = class {
  constructor(e = 5) {
    ae(this, "limit", void 0), ae(this, "_cache", {}), ae(this, "_order", []), this.limit = e;
  }
  get(e) {
    const n = this._cache[e];
    return n && (this._deleteOrder(e), this._appendOrder(e)), n;
  }
  set(e, n) {
    this._cache[e] ? (this.delete(e), this._cache[e] = n, this._appendOrder(e)) : (Object.keys(this._cache).length === this.limit && this.delete(this._order[0]), this._cache[e] = n, this._appendOrder(e));
  }
  delete(e) {
    this._cache[e] && (delete this._cache[e], this._deleteOrder(e));
  }
  _deleteOrder(e) {
    const n = this._order.indexOf(e);
    n >= 0 && this._order.splice(n, 1);
  }
  _appendOrder(e) {
    this._order.push(e);
  }
};
function XIn() {
  const t = [];
  for (let e = 32; e < 128; e++)
    t.push(String.fromCharCode(e));
  return t;
}
const BD = {
  fontFamily: "Monaco, monospace",
  fontWeight: "normal",
  characterSet: XIn(),
  fontSize: 64,
  buffer: 4,
  sdf: !1,
  cutoff: 0.25,
  radius: 12,
  smoothing: 0.1
}, DSe = 1024, ZIn = 0.9, TSe = 1.2, gje = 3;
let OU = new fje(gje);
function emn(t, e) {
  let n;
  typeof e == "string" ? n = new Set(Array.from(e)) : n = new Set(e);
  const r = OU.get(t);
  if (!r)
    return n;
  for (const i in r.mapping)
    n.has(i) && n.delete(i);
  return n;
}
function tmn(t, e) {
  for (let n = 0; n < t.length; n++)
    e.data[4 * n + 3] = t[n];
}
function NSe(t, e, n, r) {
  t.font = "".concat(r, " ").concat(n, "px ").concat(e), t.fillStyle = "#000", t.textBaseline = "alphabetic", t.textAlign = "left";
}
function nmn(t) {
  Rr.assert(Number.isFinite(t) && t >= gje, "Invalid cache limit"), OU = new fje(t);
}
class rmn {
  constructor() {
    ae(this, "props", {
      ...BD
    }), ae(this, "_key", void 0), ae(this, "_atlas", void 0);
  }
  get texture() {
    return this._atlas;
  }
  get mapping() {
    return this._atlas && this._atlas.mapping;
  }
  get scale() {
    return TSe;
  }
  setProps(e = {}) {
    Object.assign(this.props, e);
    const n = this._key;
    this._key = this._getKey();
    const r = emn(this._key, this.props.characterSet), i = OU.get(this._key);
    if (i && r.size === 0) {
      this._key !== n && (this._atlas = i);
      return;
    }
    const o = this._generateFontAtlas(this._key, r, i);
    this._atlas = o, OU.set(this._key, o);
  }
  _generateFontAtlas(e, n, r) {
    const {
      fontFamily: i,
      fontWeight: o,
      fontSize: s,
      buffer: a,
      sdf: A,
      radius: l,
      cutoff: c
    } = this.props;
    let u = r && r.data;
    u || (u = document.createElement("canvas"), u.width = DSe);
    const f = u.getContext("2d");
    NSe(f, i, s, o);
    const {
      mapping: h,
      canvasHeight: d,
      xOffset: I,
      yOffset: m
    } = zIn({
      getFontWidth: (C) => f.measureText(C).width,
      fontHeight: s * TSe,
      buffer: a,
      characterSet: n,
      maxCanvasWidth: DSe,
      ...r && {
        mapping: r.mapping,
        xOffset: r.xOffset,
        yOffset: r.yOffset
      }
    });
    if (u.height !== d) {
      const C = f.getImageData(0, 0, u.width, u.height);
      u.height = d, f.putImageData(C, 0, 0);
    }
    if (NSe(f, i, s, o), A) {
      const C = new $In(s, a, l, c, i, o), y = f.getImageData(0, 0, C.size, C.size);
      for (const v of n)
        tmn(C.draw(v), y), f.putImageData(y, h[v].x - a, h[v].y + a);
    } else
      for (const C of n)
        f.fillText(C, h[C].x, h[C].y + s * ZIn);
    return {
      xOffset: I,
      yOffset: m,
      mapping: h,
      data: u,
      width: u.width,
      height: u.height
    };
  }
  _getKey() {
    const {
      fontFamily: e,
      fontWeight: n,
      fontSize: r,
      buffer: i,
      sdf: o,
      radius: s,
      cutoff: a
    } = this.props;
    return o ? "".concat(e, " ").concat(n, " ").concat(r, " ").concat(i, " ").concat(s, " ").concat(a) : "".concat(e, " ").concat(n, " ").concat(r, " ").concat(i);
  }
}
const imn = `#define SHADER_NAME text-background-layer-vertex-shader

attribute vec2 positions;

attribute vec3 instancePositions;
attribute vec3 instancePositions64Low;
attribute vec4 instanceRects;
attribute float instanceSizes;
attribute float instanceAngles;
attribute vec2 instancePixelOffsets;
attribute float instanceLineWidths;
attribute vec4 instanceFillColors;
attribute vec4 instanceLineColors;
attribute vec3 instancePickingColors;

uniform bool billboard;
uniform float opacity;
uniform float sizeScale;
uniform float sizeMinPixels;
uniform float sizeMaxPixels;
uniform vec4 padding;
uniform int sizeUnits;

varying vec4 vFillColor;
varying vec4 vLineColor;
varying float vLineWidth;
varying vec2 uv;
varying vec2 dimensions;

vec2 rotate_by_angle(vec2 vertex, float angle) {
  float angle_radian = radians(angle);
  float cos_angle = cos(angle_radian);
  float sin_angle = sin(angle_radian);
  mat2 rotationMatrix = mat2(cos_angle, -sin_angle, sin_angle, cos_angle);
  return rotationMatrix * vertex;
}

void main(void) {
  geometry.worldPosition = instancePositions;
  geometry.uv = positions;
  geometry.pickingColor = instancePickingColors;
  uv = positions;
  vLineWidth = instanceLineWidths;

  // convert size in meters to pixels, then scaled and clamp

  // project meters to pixels and clamp to limits
  float sizePixels = clamp(
    project_size_to_pixel(instanceSizes * sizeScale, sizeUnits),
    sizeMinPixels, sizeMaxPixels
  );

  dimensions = instanceRects.zw * sizePixels + padding.xy + padding.zw;

  vec2 pixelOffset = (positions * instanceRects.zw + instanceRects.xy) * sizePixels + mix(-padding.xy, padding.zw, positions);
  pixelOffset = rotate_by_angle(pixelOffset, instanceAngles);
  pixelOffset += instancePixelOffsets;
  pixelOffset.y *= -1.0;

  if (billboard)  {
    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, vec3(0.0), geometry.position);
    vec3 offset = vec3(pixelOffset, 0.0);
    DECKGL_FILTER_SIZE(offset, geometry);
    gl_Position.xy += project_pixel_size_to_clipspace(offset.xy);
  } else {
    vec3 offset_common = vec3(project_pixel_size(pixelOffset), 0.0);
    DECKGL_FILTER_SIZE(offset_common, geometry);
    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, offset_common, geometry.position);
  }
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  // Apply opacity to instance color, or return instance picking color
  vFillColor = vec4(instanceFillColors.rgb, instanceFillColors.a * opacity);
  DECKGL_FILTER_COLOR(vFillColor, geometry);
  vLineColor = vec4(instanceLineColors.rgb, instanceLineColors.a * opacity);
  DECKGL_FILTER_COLOR(vLineColor, geometry);
}
`, omn = `#define SHADER_NAME text-background-layer-fragment-shader

precision highp float;

uniform bool stroked;

varying vec4 vFillColor;
varying vec4 vLineColor;
varying float vLineWidth;
varying vec2 uv;
varying vec2 dimensions;

void main(void) {
  geometry.uv = uv;

  vec2 pixelPosition = uv * dimensions;
  if (stroked) {
    float distToEdge = min(
      min(pixelPosition.x, dimensions.x - pixelPosition.x),
      min(pixelPosition.y, dimensions.y - pixelPosition.y)
    );
    float isBorder = smoothedge(distToEdge, vLineWidth);
    gl_FragColor = mix(vFillColor, vLineColor, isBorder);
  } else {
    gl_FragColor = vFillColor;
  }

  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`, smn = {
  billboard: !0,
  sizeScale: 1,
  sizeUnits: "pixels",
  sizeMinPixels: 0,
  sizeMaxPixels: Number.MAX_SAFE_INTEGER,
  padding: {
    type: "array",
    value: [0, 0, 0, 0]
  },
  getPosition: {
    type: "accessor",
    value: (t) => t.position
  },
  getSize: {
    type: "accessor",
    value: 1
  },
  getAngle: {
    type: "accessor",
    value: 0
  },
  getPixelOffset: {
    type: "accessor",
    value: [0, 0]
  },
  getBoundingRect: {
    type: "accessor",
    value: [0, 0, 0, 0]
  },
  getFillColor: {
    type: "accessor",
    value: [0, 0, 0, 255]
  },
  getLineColor: {
    type: "accessor",
    value: [0, 0, 0, 255]
  },
  getLineWidth: {
    type: "accessor",
    value: 1
  }
};
class C$ extends IA {
  constructor(...e) {
    super(...e), ae(this, "state", void 0);
  }
  getShaders() {
    return super.getShaders({
      vs: imn,
      fs: omn,
      modules: [qA, jA]
    });
  }
  initializeState() {
    this.getAttributeManager().addInstanced({
      instancePositions: {
        size: 3,
        type: 5130,
        fp64: this.use64bitPositions(),
        transition: !0,
        accessor: "getPosition"
      },
      instanceSizes: {
        size: 1,
        transition: !0,
        accessor: "getSize",
        defaultValue: 1
      },
      instanceAngles: {
        size: 1,
        transition: !0,
        accessor: "getAngle"
      },
      instanceRects: {
        size: 4,
        accessor: "getBoundingRect"
      },
      instancePixelOffsets: {
        size: 2,
        transition: !0,
        accessor: "getPixelOffset"
      },
      instanceFillColors: {
        size: 4,
        transition: !0,
        normalized: !0,
        type: 5121,
        accessor: "getFillColor",
        defaultValue: [0, 0, 0, 255]
      },
      instanceLineColors: {
        size: 4,
        transition: !0,
        normalized: !0,
        type: 5121,
        accessor: "getLineColor",
        defaultValue: [0, 0, 0, 255]
      },
      instanceLineWidths: {
        size: 1,
        transition: !0,
        accessor: "getLineWidth",
        defaultValue: 1
      }
    });
  }
  updateState(e) {
    super.updateState(e);
    const {
      changeFlags: n
    } = e;
    if (n.extensionsChanged) {
      var r;
      const {
        gl: i
      } = this.context;
      (r = this.state.model) === null || r === void 0 || r.delete(), this.state.model = this._getModel(i), this.getAttributeManager().invalidateAll();
    }
  }
  draw({
    uniforms: e
  }) {
    const {
      billboard: n,
      sizeScale: r,
      sizeUnits: i,
      sizeMinPixels: o,
      sizeMaxPixels: s,
      getLineWidth: a
    } = this.props;
    let {
      padding: A
    } = this.props;
    A.length < 4 && (A = [A[0], A[1], A[0], A[1]]), this.state.model.setUniforms(e).setUniforms({
      billboard: n,
      stroked: !!a,
      padding: A,
      sizeUnits: Ou[i],
      sizeScale: r,
      sizeMinPixels: o,
      sizeMaxPixels: s
    }).draw();
  }
  _getModel(e) {
    const n = [0, 0, 1, 0, 1, 1, 0, 1];
    return new Ta(e, {
      ...this.getShaders(),
      id: this.props.id,
      geometry: new Os({
        drawMode: 6,
        vertexCount: 4,
        attributes: {
          positions: {
            size: 2,
            value: new Float32Array(n)
          }
        }
      }),
      isInstanced: !0
    });
  }
}
ae(C$, "defaultProps", smn);
ae(C$, "layerName", "TextBackgroundLayer");
const LSe = {
  start: 1,
  middle: 0,
  end: -1
}, MSe = {
  top: 1,
  center: 0,
  bottom: -1
}, xV = [0, 0, 0, 255], amn = 1, Amn = {
  billboard: !0,
  sizeScale: 1,
  sizeUnits: "pixels",
  sizeMinPixels: 0,
  sizeMaxPixels: Number.MAX_SAFE_INTEGER,
  background: !1,
  getBackgroundColor: {
    type: "accessor",
    value: [255, 255, 255, 255]
  },
  getBorderColor: {
    type: "accessor",
    value: xV
  },
  getBorderWidth: {
    type: "accessor",
    value: 0
  },
  backgroundPadding: {
    type: "array",
    value: [0, 0, 0, 0]
  },
  characterSet: {
    type: "object",
    value: BD.characterSet
  },
  fontFamily: BD.fontFamily,
  fontWeight: BD.fontWeight,
  lineHeight: amn,
  outlineWidth: {
    type: "number",
    value: 0,
    min: 0
  },
  outlineColor: {
    type: "color",
    value: xV
  },
  fontSettings: {},
  wordBreak: "break-word",
  maxWidth: {
    type: "number",
    value: -1
  },
  getText: {
    type: "accessor",
    value: (t) => t.text
  },
  getPosition: {
    type: "accessor",
    value: (t) => t.position
  },
  getColor: {
    type: "accessor",
    value: xV
  },
  getSize: {
    type: "accessor",
    value: 32
  },
  getAngle: {
    type: "accessor",
    value: 0
  },
  getTextAnchor: {
    type: "accessor",
    value: "middle"
  },
  getAlignmentBaseline: {
    type: "accessor",
    value: "center"
  },
  getPixelOffset: {
    type: "accessor",
    value: [0, 0]
  },
  backgroundColor: {
    deprecatedFor: ["background", "getBackgroundColor"]
  }
};
class Eg extends mA {
  constructor(...e) {
    super(...e), ae(this, "state", void 0), ae(this, "getBoundingRect", (n, r) => {
      const i = this.state.fontAtlasManager.mapping, o = this.state.getText, {
        wordBreak: s,
        maxWidth: a,
        lineHeight: A,
        getTextAnchor: l,
        getAlignmentBaseline: c
      } = this.props, u = o(n, r) || "", {
        size: [f, h]
      } = RSe(u, A, s, a, i), d = LSe[typeof l == "function" ? l(n, r) : l], I = MSe[typeof c == "function" ? c(n, r) : c];
      return [(d - 1) * f / 2, (I - 1) * h / 2, f, h];
    }), ae(this, "getIconOffsets", (n, r) => {
      const i = this.state.fontAtlasManager.mapping, o = this.state.getText, {
        wordBreak: s,
        maxWidth: a,
        lineHeight: A,
        getTextAnchor: l,
        getAlignmentBaseline: c
      } = this.props, u = o(n, r) || "", {
        x: f,
        y: h,
        rowWidth: d,
        size: [I, m]
      } = RSe(u, A, s, a, i), C = LSe[typeof l == "function" ? l(n, r) : l], y = MSe[typeof c == "function" ? c(n, r) : c], v = f.length, b = new Array(v * 2);
      let Q = 0;
      for (let w = 0; w < v; w++) {
        const R = (1 - C) * (I - d[w]) / 2;
        b[Q++] = (C - 1) * I / 2 + R + f[w], b[Q++] = (y - 1) * m / 2 + h[w];
      }
      return b;
    });
  }
  initializeState() {
    this.state = {
      styleVersion: 0,
      fontAtlasManager: new rmn()
    };
  }
  updateState(e) {
    const {
      props: n,
      oldProps: r,
      changeFlags: i
    } = e;
    (i.dataChanged || i.updateTriggersChanged && (i.updateTriggersChanged.all || i.updateTriggersChanged.getText)) && this._updateText(), (this._updateFontAtlas() || n.lineHeight !== r.lineHeight || n.wordBreak !== r.wordBreak || n.maxWidth !== r.maxWidth) && this.setState({
      styleVersion: this.state.styleVersion + 1
    });
  }
  getPickingInfo({
    info: e
  }) {
    return e.object = e.index >= 0 ? this.props.data[e.index] : null, e;
  }
  _updateFontAtlas() {
    const {
      fontSettings: e,
      fontFamily: n,
      fontWeight: r
    } = this.props, {
      fontAtlasManager: i,
      characterSet: o
    } = this.state, s = {
      ...e,
      characterSet: o,
      fontFamily: n,
      fontWeight: r
    };
    if (!i.mapping)
      return i.setProps(s), !0;
    for (const a in s)
      if (s[a] !== i.props[a])
        return i.setProps(s), !0;
    return !1;
  }
  _updateText() {
    var e;
    const {
      data: n,
      characterSet: r
    } = this.props, i = (e = n.attributes) === null || e === void 0 ? void 0 : e.getText;
    let {
      getText: o
    } = this.props, s = n.startIndices, a;
    const A = r === "auto" && /* @__PURE__ */ new Set();
    if (i && s) {
      const {
        texts: l,
        characterCount: c
      } = WIn({
        ...ArrayBuffer.isView(i) ? {
          value: i
        } : i,
        length: n.length,
        startIndices: s,
        characterSet: A
      });
      a = c, o = (u, {
        index: f
      }) => l[f];
    } else {
      const {
        iterable: l,
        objectInfo: c
      } = ZI(n);
      s = [0], a = 0;
      for (const u of l) {
        c.index++;
        const f = Array.from(o(u, c) || "");
        A && f.forEach(A.add, A), a += f.length, s.push(a);
      }
    }
    this.setState({
      getText: o,
      startIndices: s,
      numInstances: a,
      characterSet: A || r
    });
  }
  renderLayers() {
    const {
      startIndices: e,
      numInstances: n,
      getText: r,
      fontAtlasManager: {
        scale: i,
        texture: o,
        mapping: s
      },
      styleVersion: a
    } = this.state, {
      data: A,
      _dataDiff: l,
      getPosition: c,
      getColor: u,
      getSize: f,
      getAngle: h,
      getPixelOffset: d,
      getBackgroundColor: I,
      getBorderColor: m,
      getBorderWidth: C,
      backgroundPadding: y,
      background: v,
      billboard: b,
      fontSettings: Q,
      outlineWidth: w,
      outlineColor: R,
      sizeScale: M,
      sizeUnits: O,
      sizeMinPixels: L,
      sizeMaxPixels: N,
      transitions: k,
      updateTriggers: $
    } = this.props, U = this.getSubLayerClass("characters", m$), X = this.getSubLayerClass("background", C$);
    return [v && new X({
      getFillColor: I,
      getLineColor: m,
      getLineWidth: C,
      padding: y,
      getPosition: c,
      getSize: f,
      getAngle: h,
      getPixelOffset: d,
      billboard: b,
      sizeScale: M / this.state.fontAtlasManager.props.fontSize,
      sizeUnits: O,
      sizeMinPixels: L,
      sizeMaxPixels: N,
      transitions: k && {
        getPosition: k.getPosition,
        getAngle: k.getAngle,
        getSize: k.getSize,
        getFillColor: k.getBackgroundColor,
        getLineColor: k.getBorderColor,
        getLineWidth: k.getBorderWidth,
        getPixelOffset: k.getPixelOffset
      }
    }, this.getSubLayerProps({
      id: "background",
      updateTriggers: {
        getPosition: $.getPosition,
        getAngle: $.getAngle,
        getSize: $.getSize,
        getFillColor: $.getBackgroundColor,
        getLineColor: $.getBorderColor,
        getLineWidth: $.getBorderWidth,
        getPixelOffset: $.getPixelOffset,
        getBoundingRect: {
          getText: $.getText,
          getTextAnchor: $.getTextAnchor,
          getAlignmentBaseline: $.getAlignmentBaseline,
          styleVersion: a
        }
      }
    }), {
      data: A.attributes && A.attributes.background ? {
        length: A.length,
        attributes: A.attributes.background
      } : A,
      _dataDiff: l,
      autoHighlight: !1,
      getBoundingRect: this.getBoundingRect
    }), new U({
      sdf: Q.sdf,
      smoothing: Number.isFinite(Q.smoothing) ? Q.smoothing : BD.smoothing,
      outlineWidth: w,
      outlineColor: R,
      iconAtlas: o,
      iconMapping: s,
      getPosition: c,
      getColor: u,
      getSize: f,
      getAngle: h,
      getPixelOffset: d,
      billboard: b,
      sizeScale: M * i,
      sizeUnits: O,
      sizeMinPixels: L * i,
      sizeMaxPixels: N * i,
      transitions: k && {
        getPosition: k.getPosition,
        getAngle: k.getAngle,
        getColor: k.getColor,
        getSize: k.getSize,
        getPixelOffset: k.getPixelOffset
      }
    }, this.getSubLayerProps({
      id: "characters",
      updateTriggers: {
        getIcon: $.getText,
        getPosition: $.getPosition,
        getAngle: $.getAngle,
        getColor: $.getColor,
        getSize: $.getSize,
        getPixelOffset: $.getPixelOffset,
        getIconOffsets: {
          getText: $.getText,
          getTextAnchor: $.getTextAnchor,
          getAlignmentBaseline: $.getAlignmentBaseline,
          styleVersion: a
        }
      }
    }), {
      data: A,
      _dataDiff: l,
      startIndices: e,
      numInstances: n,
      getIconOffsets: this.getIconOffsets,
      getIcon: r
    })];
  }
  static set fontAtlasCacheLimit(e) {
    nmn(e);
  }
}
ae(Eg, "defaultProps", Amn);
ae(Eg, "layerName", "TextLayer");
const Pk = {
  circle: {
    type: LI,
    props: {
      filled: "filled",
      stroked: "stroked",
      lineWidthMaxPixels: "lineWidthMaxPixels",
      lineWidthMinPixels: "lineWidthMinPixels",
      lineWidthScale: "lineWidthScale",
      lineWidthUnits: "lineWidthUnits",
      pointRadiusMaxPixels: "radiusMaxPixels",
      pointRadiusMinPixels: "radiusMinPixels",
      pointRadiusScale: "radiusScale",
      pointRadiusUnits: "radiusUnits",
      pointAntialiasing: "antialiasing",
      pointBillboard: "billboard",
      getFillColor: "getFillColor",
      getLineColor: "getLineColor",
      getLineWidth: "getLineWidth",
      getPointRadius: "getRadius"
    }
  },
  icon: {
    type: IM,
    props: {
      iconAtlas: "iconAtlas",
      iconMapping: "iconMapping",
      iconSizeMaxPixels: "sizeMaxPixels",
      iconSizeMinPixels: "sizeMinPixels",
      iconSizeScale: "sizeScale",
      iconSizeUnits: "sizeUnits",
      iconAlphaCutoff: "alphaCutoff",
      iconBillboard: "billboard",
      getIcon: "getIcon",
      getIconAngle: "getAngle",
      getIconColor: "getColor",
      getIconPixelOffset: "getPixelOffset",
      getIconSize: "getSize"
    }
  },
  text: {
    type: Eg,
    props: {
      textSizeMaxPixels: "sizeMaxPixels",
      textSizeMinPixels: "sizeMinPixels",
      textSizeScale: "sizeScale",
      textSizeUnits: "sizeUnits",
      textBackground: "background",
      textBackgroundPadding: "backgroundPadding",
      textFontFamily: "fontFamily",
      textFontWeight: "fontWeight",
      textLineHeight: "lineHeight",
      textMaxWidth: "maxWidth",
      textOutlineColor: "outlineColor",
      textOutlineWidth: "outlineWidth",
      textWordBreak: "wordBreak",
      textCharacterSet: "characterSet",
      textBillboard: "billboard",
      textFontSettings: "fontSettings",
      getText: "getText",
      getTextAngle: "getAngle",
      getTextColor: "getColor",
      getTextPixelOffset: "getPixelOffset",
      getTextSize: "getSize",
      getTextAnchor: "getTextAnchor",
      getTextAlignmentBaseline: "getAlignmentBaseline",
      getTextBackgroundColor: "getBackgroundColor",
      getTextBorderColor: "getBorderColor",
      getTextBorderWidth: "getBorderWidth"
    }
  }
}, kk = {
  type: Ow,
  props: {
    lineWidthUnits: "widthUnits",
    lineWidthScale: "widthScale",
    lineWidthMinPixels: "widthMinPixels",
    lineWidthMaxPixels: "widthMaxPixels",
    lineJointRounded: "jointRounded",
    lineCapRounded: "capRounded",
    lineMiterLimit: "miterLimit",
    lineBillboard: "billboard",
    getLineColor: "getColor",
    getLineWidth: "getWidth"
  }
}, ate = {
  type: CM,
  props: {
    extruded: "extruded",
    filled: "filled",
    wireframe: "wireframe",
    elevationScale: "elevationScale",
    material: "material",
    getElevation: "getElevation",
    getFillColor: "getFillColor",
    getLineColor: "getLineColor"
  }
};
function u2({
  type: t,
  props: e
}) {
  const n = {};
  for (const r in e)
    n[r] = t.defaultProps[e[r]];
  return n;
}
function RV(t, e) {
  const {
    transitions: n,
    updateTriggers: r
  } = t.props, i = {
    updateTriggers: {},
    transitions: n && {
      getPosition: n.geometry
    }
  };
  for (const o in e) {
    const s = e[o];
    let a = t.props[o];
    o.startsWith("get") && (a = t.getSubLayerAccessor(a), i.updateTriggers[s] = r[o], n && (i.transitions[s] = n[o])), i[s] = a;
  }
  return i;
}
function lmn(t) {
  if (Array.isArray(t))
    return t;
  switch (Rr.assert(t.type, "GeoJSON does not have type"), t.type) {
    case "Feature":
      return [t];
    case "FeatureCollection":
      return Rr.assert(Array.isArray(t.features), "GeoJSON does not have features array"), t.features;
    default:
      return [{
        geometry: t
      }];
  }
}
function OSe(t, e, n = {}) {
  const r = {
    pointFeatures: [],
    lineFeatures: [],
    polygonFeatures: [],
    polygonOutlineFeatures: []
  }, {
    startRow: i = 0,
    endRow: o = t.length
  } = n;
  for (let s = i; s < o; s++) {
    const a = t[s], {
      geometry: A
    } = a;
    if (A)
      if (A.type === "GeometryCollection") {
        Rr.assert(Array.isArray(A.geometries), "GeoJSON does not have geometries array");
        const {
          geometries: l
        } = A;
        for (let c = 0; c < l.length; c++) {
          const u = l[c];
          FSe(u, r, e, a, s);
        }
      } else
        FSe(A, r, e, a, s);
  }
  return r;
}
function FSe(t, e, n, r, i) {
  const {
    type: o,
    coordinates: s
  } = t, {
    pointFeatures: a,
    lineFeatures: A,
    polygonFeatures: l,
    polygonOutlineFeatures: c
  } = e;
  if (!umn(o, s)) {
    Rr.warn("".concat(o, " coordinates are malformed"))();
    return;
  }
  switch (o) {
    case "Point":
      a.push(n({
        geometry: t
      }, r, i));
      break;
    case "MultiPoint":
      s.forEach((u) => {
        a.push(n({
          geometry: {
            type: "Point",
            coordinates: u
          }
        }, r, i));
      });
      break;
    case "LineString":
      A.push(n({
        geometry: t
      }, r, i));
      break;
    case "MultiLineString":
      s.forEach((u) => {
        A.push(n({
          geometry: {
            type: "LineString",
            coordinates: u
          }
        }, r, i));
      });
      break;
    case "Polygon":
      l.push(n({
        geometry: t
      }, r, i)), s.forEach((u) => {
        c.push(n({
          geometry: {
            type: "LineString",
            coordinates: u
          }
        }, r, i));
      });
      break;
    case "MultiPolygon":
      s.forEach((u) => {
        l.push(n({
          geometry: {
            type: "Polygon",
            coordinates: u
          }
        }, r, i)), u.forEach((f) => {
          c.push(n({
            geometry: {
              type: "LineString",
              coordinates: f
            }
          }, r, i));
        });
      });
      break;
  }
}
const cmn = {
  Point: 1,
  MultiPoint: 2,
  LineString: 2,
  MultiLineString: 3,
  Polygon: 3,
  MultiPolygon: 4
};
function umn(t, e) {
  let n = cmn[t];
  for (Rr.assert(n, "Unknown GeoJSON type ".concat(t)); e && --n > 0; )
    e = e[0];
  return e && Number.isFinite(e[0]);
}
function hje() {
  return {
    points: {},
    lines: {},
    polygons: {},
    polygonsOutline: {}
  };
}
function AP(t) {
  return t.geometry.coordinates;
}
function fmn(t, e) {
  const n = hje(), {
    pointFeatures: r,
    lineFeatures: i,
    polygonFeatures: o,
    polygonOutlineFeatures: s
  } = t;
  return n.points.data = r, n.points._dataDiff = e.pointFeatures && (() => e.pointFeatures), n.points.getPosition = AP, n.lines.data = i, n.lines._dataDiff = e.lineFeatures && (() => e.lineFeatures), n.lines.getPath = AP, n.polygons.data = o, n.polygons._dataDiff = e.polygonFeatures && (() => e.polygonFeatures), n.polygons.getPolygon = AP, n.polygonsOutline.data = s, n.polygonsOutline._dataDiff = e.polygonOutlineFeatures && (() => e.polygonOutlineFeatures), n.polygonsOutline.getPath = AP, n;
}
function gmn(t, e) {
  const n = hje(), {
    points: r,
    lines: i,
    polygons: o
  } = t, s = FIn(t, e);
  return n.points.data = {
    length: r.positions.value.length / r.positions.size,
    attributes: {
      ...r.attributes,
      getPosition: r.positions,
      instancePickingColors: {
        size: 3,
        value: s.points
      }
    },
    properties: r.properties,
    numericProps: r.numericProps,
    featureIds: r.featureIds
  }, n.lines.data = {
    length: i.pathIndices.value.length - 1,
    startIndices: i.pathIndices.value,
    attributes: {
      ...i.attributes,
      getPath: i.positions,
      instancePickingColors: {
        size: 3,
        value: s.lines
      }
    },
    properties: i.properties,
    numericProps: i.numericProps,
    featureIds: i.featureIds
  }, n.lines._pathType = "open", n.polygons.data = {
    length: o.polygonIndices.value.length - 1,
    startIndices: o.polygonIndices.value,
    attributes: {
      ...o.attributes,
      getPolygon: o.positions,
      pickingColors: {
        size: 3,
        value: s.polygons
      }
    },
    properties: o.properties,
    numericProps: o.numericProps,
    featureIds: o.featureIds
  }, n.polygons._normalize = !1, o.triangles && (n.polygons.data.attributes.indices = o.triangles.value), n.polygonsOutline.data = {
    length: o.primitivePolygonIndices.value.length - 1,
    startIndices: o.primitivePolygonIndices.value,
    attributes: {
      ...o.attributes,
      getPath: o.positions,
      instancePickingColors: {
        size: 3,
        value: s.polygons
      }
    },
    properties: o.properties,
    numericProps: o.numericProps,
    featureIds: o.featureIds
  }, n.polygonsOutline._pathType = "open", n;
}
const hmn = ["points", "linestrings", "polygons"], dmn = {
  ...u2(Pk.circle),
  ...u2(Pk.icon),
  ...u2(Pk.text),
  ...u2(kk),
  ...u2(ate),
  stroked: !0,
  filled: !0,
  extruded: !1,
  wireframe: !1,
  iconAtlas: {
    type: "object",
    value: null
  },
  iconMapping: {
    type: "object",
    value: {}
  },
  getIcon: {
    type: "accessor",
    value: (t) => t.properties.icon
  },
  getText: {
    type: "accessor",
    value: (t) => t.properties.text
  },
  pointType: "circle",
  getRadius: {
    deprecatedFor: "getPointRadius"
  }
};
class Fw extends mA {
  initializeState() {
    this.state = {
      layerProps: {},
      features: {}
    };
  }
  updateState({
    props: e,
    changeFlags: n
  }) {
    if (!n.dataChanged)
      return;
    const {
      data: r
    } = this.props, i = r && "points" in r && "polygons" in r && "lines" in r;
    this.setState({
      binary: i
    }), i ? this._updateStateBinary({
      props: e,
      changeFlags: n
    }) : this._updateStateJSON({
      props: e,
      changeFlags: n
    });
  }
  _updateStateBinary({
    props: e,
    changeFlags: n
  }) {
    const r = gmn(e.data, this.encodePickingColor);
    this.setState({
      layerProps: r
    });
  }
  _updateStateJSON({
    props: e,
    changeFlags: n
  }) {
    const r = lmn(e.data), i = this.getSubLayerRow.bind(this);
    let o = {};
    const s = {};
    if (Array.isArray(n.dataChanged)) {
      const A = this.state.features;
      for (const l in A)
        o[l] = A[l].slice(), s[l] = [];
      for (const l of n.dataChanged) {
        const c = OSe(r, i, l);
        for (const u in A)
          s[u].push(Aje({
            data: o[u],
            getIndex: (f) => f.__source.index,
            dataRange: l,
            replace: c[u]
          }));
      }
    } else
      o = OSe(r, i);
    const a = fmn(o, s);
    this.setState({
      features: o,
      featuresDiff: s,
      layerProps: a
    });
  }
  getPickingInfo(e) {
    const n = super.getPickingInfo(e), {
      index: r,
      sourceLayer: i
    } = n;
    return n.featureType = hmn.find((o) => i.id.startsWith("".concat(this.id, "-").concat(o, "-"))), r >= 0 && i.id.startsWith("".concat(this.id, "-points-text")) && this.state.binary && (n.index = this.props.data.points.globalFeatureIds.value[r]), n;
  }
  _updateAutoHighlight(e) {
    const n = "".concat(this.id, "-points-"), r = e.featureType === "points";
    for (const i of this.getSubLayers())
      i.id.startsWith(n) === r && i.updateAutoHighlight(e);
  }
  _renderPolygonLayer() {
    const {
      extruded: e,
      wireframe: n
    } = this.props, {
      layerProps: r
    } = this.state, i = "polygons-fill", o = this.shouldRenderSubLayer(i, r.polygons.data) && this.getSubLayerClass(i, ate.type);
    if (o) {
      const s = RV(this, ate.props), a = e && n;
      return a || delete s.getLineColor, s.updateTriggers.lineColors = a, new o(s, this.getSubLayerProps({
        id: i,
        updateTriggers: s.updateTriggers
      }), r.polygons);
    }
    return null;
  }
  _renderLineLayers() {
    const {
      extruded: e,
      stroked: n
    } = this.props, {
      layerProps: r
    } = this.state, i = "polygons-stroke", o = "linestrings", s = !e && n && this.shouldRenderSubLayer(i, r.polygonsOutline.data) && this.getSubLayerClass(i, kk.type), a = this.shouldRenderSubLayer(o, r.lines.data) && this.getSubLayerClass(o, kk.type);
    if (s || a) {
      const A = RV(this, kk.props);
      return [s && new s(A, this.getSubLayerProps({
        id: i,
        updateTriggers: A.updateTriggers
      }), r.polygonsOutline), a && new a(A, this.getSubLayerProps({
        id: o,
        updateTriggers: A.updateTriggers
      }), r.lines)];
    }
    return null;
  }
  _renderPointLayers() {
    const {
      pointType: e
    } = this.props, {
      layerProps: n,
      binary: r
    } = this.state;
    let {
      highlightedObjectIndex: i
    } = this.props;
    !r && Number.isFinite(i) && (i = n.points.data.findIndex((a) => a.__source.index === i));
    const o = new Set(e.split("+")), s = [];
    for (const a of o) {
      const A = "points-".concat(a), l = Pk[a], c = l && this.shouldRenderSubLayer(A, n.points.data) && this.getSubLayerClass(A, l.type);
      if (c) {
        const u = RV(this, l.props);
        let f = n.points;
        if (a === "text" && r) {
          const {
            instancePickingColors: h,
            ...d
          } = f.data.attributes;
          f = {
            ...f,
            data: {
              ...f.data,
              attributes: d
            }
          };
        }
        s.push(new c(u, this.getSubLayerProps({
          id: A,
          updateTriggers: u.updateTriggers,
          highlightedObjectIndex: i
        }), f));
      }
    }
    return s;
  }
  renderLayers() {
    const {
      extruded: e
    } = this.props, n = this._renderPolygonLayer(), r = this._renderLineLayers(), i = this._renderPointLayers();
    return [!e && n, r, i, e && n];
  }
  getSubLayerAccessor(e) {
    const {
      binary: n
    } = this.state;
    return !n || typeof e != "function" ? super.getSubLayerAccessor(e) : (r, i) => {
      const {
        data: o,
        index: s
      } = i, a = MIn(o, s);
      return e(a, i);
    };
  }
}
ae(Fw, "layerName", "GeoJsonLayer");
ae(Fw, "defaultProps", dmn);
const pmn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ArcLayer: g$,
  BitmapLayer: em,
  ColumnLayer: mM,
  GeoJsonLayer: Fw,
  GridCellLayer: lce,
  IconLayer: IM,
  LineLayer: q_,
  PathLayer: Ow,
  PointCloudLayer: h$,
  PolygonLayer: Pf,
  ScatterplotLayer: LI,
  SolidPolygonLayer: CM,
  TextLayer: Eg,
  _MultiIconLayer: m$,
  _TextBackgroundLayer: C$
}, Symbol.toStringTag, { value: "Module" })), Imn = {
  getHeight: {
    type: "accessor",
    value: 0
  },
  greatCircle: !0
};
class fce extends g$ {
}
ae(fce, "layerName", "GreatCircleLayer");
ae(fce, "defaultProps", Imn);
const mmn = {
  ...Pf.defaultProps
};
class r1 extends mA {
  indexToBounds() {
    return null;
  }
  renderLayers() {
    const {
      elevationScale: e,
      extruded: n,
      wireframe: r,
      filled: i,
      stroked: o,
      lineWidthUnits: s,
      lineWidthScale: a,
      lineWidthMinPixels: A,
      lineWidthMaxPixels: l,
      lineJointRounded: c,
      lineMiterLimit: u,
      lineDashJustified: f,
      getElevation: h,
      getFillColor: d,
      getLineColor: I,
      getLineWidth: m
    } = this.props, {
      updateTriggers: C,
      material: y,
      transitions: v
    } = this.props, b = this.getSubLayerClass("cell", Pf);
    return new b({
      filled: i,
      wireframe: r,
      extruded: n,
      elevationScale: e,
      stroked: o,
      lineWidthUnits: s,
      lineWidthScale: a,
      lineWidthMinPixels: A,
      lineWidthMaxPixels: l,
      lineJointRounded: c,
      lineMiterLimit: u,
      lineDashJustified: f,
      material: y,
      transitions: v,
      getElevation: h,
      getFillColor: d,
      getLineColor: I,
      getLineWidth: m
    }, this.getSubLayerProps({
      id: "cell",
      updateTriggers: C && {
        getElevation: C.getElevation,
        getFillColor: C.getFillColor,
        getLineColor: C.getLineColor,
        getLineWidth: C.getLineWidth
      }
    }), this.indexToBounds());
  }
}
ae(r1, "layerName", "GeoCellLayer");
ae(r1, "defaultProps", mmn);
var dje = { exports: {} };
(function(t) {
  /**
   * @license long.js (c) 2013 Daniel Wirtz <dcode@dcode.io>
   * Released under the Apache License, Version 2.0
   * see: https://github.com/dcodeIO/long.js for details
   */
  (function(e, n) {
    typeof M3e == "function" && t && t.exports ? t.exports = n() : (e.dcodeIO = e.dcodeIO || {}).Long = n();
  })(ei, function() {
    function e(L, N, k) {
      this.low = L | 0, this.high = N | 0, this.unsigned = !!k;
    }
    e.prototype.__isLong__, Object.defineProperty(e.prototype, "__isLong__", {
      value: !0,
      enumerable: !1,
      configurable: !1
    });
    function n(L) {
      return (L && L.__isLong__) === !0;
    }
    e.isLong = n;
    var r = {}, i = {};
    function o(L, N) {
      var k, $, U;
      return N ? (L >>>= 0, (U = 0 <= L && L < 256) && ($ = i[L], $) ? $ : (k = a(L, (L | 0) < 0 ? -1 : 0, !0), U && (i[L] = k), k)) : (L |= 0, (U = -128 <= L && L < 128) && ($ = r[L], $) ? $ : (k = a(L, L < 0 ? -1 : 0, !1), U && (r[L] = k), k));
    }
    e.fromInt = o;
    function s(L, N) {
      if (isNaN(L) || !isFinite(L))
        return N ? y : C;
      if (N) {
        if (L < 0)
          return y;
        if (L >= d)
          return R;
      } else {
        if (L <= -I)
          return M;
        if (L + 1 >= I)
          return w;
      }
      return L < 0 ? s(-L, N).neg() : a(L % h | 0, L / h | 0, N);
    }
    e.fromNumber = s;
    function a(L, N, k) {
      return new e(L, N, k);
    }
    e.fromBits = a;
    var A = Math.pow;
    function l(L, N, k) {
      if (L.length === 0)
        throw Error("empty string");
      if (L === "NaN" || L === "Infinity" || L === "+Infinity" || L === "-Infinity")
        return C;
      if (typeof N == "number" ? (k = N, N = !1) : N = !!N, k = k || 10, k < 2 || 36 < k)
        throw RangeError("radix");
      var $;
      if (($ = L.indexOf("-")) > 0)
        throw Error("interior hyphen");
      if ($ === 0)
        return l(L.substring(1), N, k).neg();
      for (var U = s(A(k, 8)), X = C, K = 0; K < L.length; K += 8) {
        var z = Math.min(8, L.length - K), Y = parseInt(L.substring(K, K + z), k);
        if (z < 8) {
          var V = s(A(k, z));
          X = X.mul(V).add(s(Y));
        } else
          X = X.mul(U), X = X.add(s(Y));
      }
      return X.unsigned = N, X;
    }
    e.fromString = l;
    function c(L) {
      return L instanceof e ? L : typeof L == "number" ? s(L) : typeof L == "string" ? l(L) : a(L.low, L.high, L.unsigned);
    }
    e.fromValue = c;
    var u = 65536, f = 1 << 24, h = u * u, d = h * h, I = d / 2, m = o(f), C = o(0);
    e.ZERO = C;
    var y = o(0, !0);
    e.UZERO = y;
    var v = o(1);
    e.ONE = v;
    var b = o(1, !0);
    e.UONE = b;
    var Q = o(-1);
    e.NEG_ONE = Q;
    var w = a(-1, 2147483647, !1);
    e.MAX_VALUE = w;
    var R = a(-1, -1, !0);
    e.MAX_UNSIGNED_VALUE = R;
    var M = a(0, -2147483648, !1);
    e.MIN_VALUE = M;
    var O = e.prototype;
    return O.toInt = function() {
      return this.unsigned ? this.low >>> 0 : this.low;
    }, O.toNumber = function() {
      return this.unsigned ? (this.high >>> 0) * h + (this.low >>> 0) : this.high * h + (this.low >>> 0);
    }, O.toString = function(N) {
      if (N = N || 10, N < 2 || 36 < N)
        throw RangeError("radix");
      if (this.isZero())
        return "0";
      if (this.isNegative())
        if (this.eq(M)) {
          var k = s(N), $ = this.div(k), U = $.mul(k).sub(this);
          return $.toString(N) + U.toInt().toString(N);
        } else
          return "-" + this.neg().toString(N);
      for (var X = s(A(N, 6), this.unsigned), K = this, z = ""; ; ) {
        var Y = K.div(X), V = K.sub(Y.mul(X)).toInt() >>> 0, Z = V.toString(N);
        if (K = Y, K.isZero())
          return Z + z;
        for (; Z.length < 6; )
          Z = "0" + Z;
        z = "" + Z + z;
      }
    }, O.getHighBits = function() {
      return this.high;
    }, O.getHighBitsUnsigned = function() {
      return this.high >>> 0;
    }, O.getLowBits = function() {
      return this.low;
    }, O.getLowBitsUnsigned = function() {
      return this.low >>> 0;
    }, O.getNumBitsAbs = function() {
      if (this.isNegative())
        return this.eq(M) ? 64 : this.neg().getNumBitsAbs();
      for (var N = this.high != 0 ? this.high : this.low, k = 31; k > 0 && !(N & 1 << k); k--)
        ;
      return this.high != 0 ? k + 33 : k + 1;
    }, O.isZero = function() {
      return this.high === 0 && this.low === 0;
    }, O.isNegative = function() {
      return !this.unsigned && this.high < 0;
    }, O.isPositive = function() {
      return this.unsigned || this.high >= 0;
    }, O.isOdd = function() {
      return (this.low & 1) === 1;
    }, O.isEven = function() {
      return (this.low & 1) === 0;
    }, O.equals = function(N) {
      return n(N) || (N = c(N)), this.unsigned !== N.unsigned && this.high >>> 31 === 1 && N.high >>> 31 === 1 ? !1 : this.high === N.high && this.low === N.low;
    }, O.eq = O.equals, O.notEquals = function(N) {
      return !this.eq(
        /* validates */
        N
      );
    }, O.neq = O.notEquals, O.lessThan = function(N) {
      return this.comp(
        /* validates */
        N
      ) < 0;
    }, O.lt = O.lessThan, O.lessThanOrEqual = function(N) {
      return this.comp(
        /* validates */
        N
      ) <= 0;
    }, O.lte = O.lessThanOrEqual, O.greaterThan = function(N) {
      return this.comp(
        /* validates */
        N
      ) > 0;
    }, O.gt = O.greaterThan, O.greaterThanOrEqual = function(N) {
      return this.comp(
        /* validates */
        N
      ) >= 0;
    }, O.gte = O.greaterThanOrEqual, O.compare = function(N) {
      if (n(N) || (N = c(N)), this.eq(N))
        return 0;
      var k = this.isNegative(), $ = N.isNegative();
      return k && !$ ? -1 : !k && $ ? 1 : this.unsigned ? N.high >>> 0 > this.high >>> 0 || N.high === this.high && N.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(N).isNegative() ? -1 : 1;
    }, O.comp = O.compare, O.negate = function() {
      return !this.unsigned && this.eq(M) ? M : this.not().add(v);
    }, O.neg = O.negate, O.add = function(N) {
      n(N) || (N = c(N));
      var k = this.high >>> 16, $ = this.high & 65535, U = this.low >>> 16, X = this.low & 65535, K = N.high >>> 16, z = N.high & 65535, Y = N.low >>> 16, V = N.low & 65535, Z = 0, ce = 0, ee = 0, pe = 0;
      return pe += X + V, ee += pe >>> 16, pe &= 65535, ee += U + Y, ce += ee >>> 16, ee &= 65535, ce += $ + z, Z += ce >>> 16, ce &= 65535, Z += k + K, Z &= 65535, a(ee << 16 | pe, Z << 16 | ce, this.unsigned);
    }, O.subtract = function(N) {
      return n(N) || (N = c(N)), this.add(N.neg());
    }, O.sub = O.subtract, O.multiply = function(N) {
      if (this.isZero() || (n(N) || (N = c(N)), N.isZero()))
        return C;
      if (this.eq(M))
        return N.isOdd() ? M : C;
      if (N.eq(M))
        return this.isOdd() ? M : C;
      if (this.isNegative())
        return N.isNegative() ? this.neg().mul(N.neg()) : this.neg().mul(N).neg();
      if (N.isNegative())
        return this.mul(N.neg()).neg();
      if (this.lt(m) && N.lt(m))
        return s(this.toNumber() * N.toNumber(), this.unsigned);
      var k = this.high >>> 16, $ = this.high & 65535, U = this.low >>> 16, X = this.low & 65535, K = N.high >>> 16, z = N.high & 65535, Y = N.low >>> 16, V = N.low & 65535, Z = 0, ce = 0, ee = 0, pe = 0;
      return pe += X * V, ee += pe >>> 16, pe &= 65535, ee += U * V, ce += ee >>> 16, ee &= 65535, ee += X * Y, ce += ee >>> 16, ee &= 65535, ce += $ * V, Z += ce >>> 16, ce &= 65535, ce += U * Y, Z += ce >>> 16, ce &= 65535, ce += X * z, Z += ce >>> 16, ce &= 65535, Z += k * V + $ * Y + U * z + X * K, Z &= 65535, a(ee << 16 | pe, Z << 16 | ce, this.unsigned);
    }, O.mul = O.multiply, O.divide = function(N) {
      if (n(N) || (N = c(N)), N.isZero())
        throw Error("division by zero");
      if (this.isZero())
        return this.unsigned ? y : C;
      var k, $, U;
      if (this.unsigned) {
        if (N.unsigned || (N = N.toUnsigned()), N.gt(this))
          return y;
        if (N.gt(this.shru(1)))
          return b;
        U = y;
      } else {
        if (this.eq(M)) {
          if (N.eq(v) || N.eq(Q))
            return M;
          if (N.eq(M))
            return v;
          var X = this.shr(1);
          return k = X.div(N).shl(1), k.eq(C) ? N.isNegative() ? v : Q : ($ = this.sub(N.mul(k)), U = k.add($.div(N)), U);
        } else if (N.eq(M))
          return this.unsigned ? y : C;
        if (this.isNegative())
          return N.isNegative() ? this.neg().div(N.neg()) : this.neg().div(N).neg();
        if (N.isNegative())
          return this.div(N.neg()).neg();
        U = C;
      }
      for ($ = this; $.gte(N); ) {
        k = Math.max(1, Math.floor($.toNumber() / N.toNumber()));
        for (var K = Math.ceil(Math.log(k) / Math.LN2), z = K <= 48 ? 1 : A(2, K - 48), Y = s(k), V = Y.mul(N); V.isNegative() || V.gt($); )
          k -= z, Y = s(k, this.unsigned), V = Y.mul(N);
        Y.isZero() && (Y = v), U = U.add(Y), $ = $.sub(V);
      }
      return U;
    }, O.div = O.divide, O.modulo = function(N) {
      return n(N) || (N = c(N)), this.sub(this.div(N).mul(N));
    }, O.mod = O.modulo, O.not = function() {
      return a(~this.low, ~this.high, this.unsigned);
    }, O.and = function(N) {
      return n(N) || (N = c(N)), a(this.low & N.low, this.high & N.high, this.unsigned);
    }, O.or = function(N) {
      return n(N) || (N = c(N)), a(this.low | N.low, this.high | N.high, this.unsigned);
    }, O.xor = function(N) {
      return n(N) || (N = c(N)), a(this.low ^ N.low, this.high ^ N.high, this.unsigned);
    }, O.shiftLeft = function(N) {
      return n(N) && (N = N.toInt()), (N &= 63) === 0 ? this : N < 32 ? a(this.low << N, this.high << N | this.low >>> 32 - N, this.unsigned) : a(0, this.low << N - 32, this.unsigned);
    }, O.shl = O.shiftLeft, O.shiftRight = function(N) {
      return n(N) && (N = N.toInt()), (N &= 63) === 0 ? this : N < 32 ? a(this.low >>> N | this.high << 32 - N, this.high >> N, this.unsigned) : a(this.high >> N - 32, this.high >= 0 ? 0 : -1, this.unsigned);
    }, O.shr = O.shiftRight, O.shiftRightUnsigned = function(N) {
      if (n(N) && (N = N.toInt()), N &= 63, N === 0)
        return this;
      var k = this.high;
      if (N < 32) {
        var $ = this.low;
        return a($ >>> N | k << 32 - N, k >>> N, this.unsigned);
      } else
        return N === 32 ? a(k, 0, this.unsigned) : a(k >>> N - 32, 0, this.unsigned);
    }, O.shru = O.shiftRightUnsigned, O.toSigned = function() {
      return this.unsigned ? a(this.low, this.high, !1) : this;
    }, O.toUnsigned = function() {
      return this.unsigned ? this : a(this.low, this.high, !0);
    }, O.toBytes = function(L) {
      return L ? this.toBytesLE() : this.toBytesBE();
    }, O.toBytesLE = function() {
      var L = this.high, N = this.low;
      return [
        N & 255,
        N >>> 8 & 255,
        N >>> 16 & 255,
        N >>> 24 & 255,
        L & 255,
        L >>> 8 & 255,
        L >>> 16 & 255,
        L >>> 24 & 255
      ];
    }, O.toBytesBE = function() {
      var L = this.high, N = this.low;
      return [
        L >>> 24 & 255,
        L >>> 16 & 255,
        L >>> 8 & 255,
        L & 255,
        N >>> 24 & 255,
        N >>> 16 & 255,
        N >>> 8 & 255,
        N & 255
      ];
    }, e;
  });
})(dje);
var Cmn = dje.exports;
const Gk = /* @__PURE__ */ ko(Cmn), Emn = 3, ymn = 30, vmn = 2 * ymn + 1, PSe = 180 / Math.PI;
function Bmn(t, e, n) {
  const r = 1 << e;
  return [(t[0] + n[0]) / r, (t[1] + n[1]) / r];
}
function kSe(t) {
  return t >= 0.5 ? 1 / 3 * (4 * t * t - 1) : 1 / 3 * (1 - 4 * (1 - t) * (1 - t));
}
function bmn(t) {
  return [kSe(t[0]), kSe(t[1])];
}
function _mn(t, [e, n]) {
  switch (t) {
    case 0:
      return [1, e, n];
    case 1:
      return [-e, 1, n];
    case 2:
      return [-e, -n, 1];
    case 3:
      return [-1, -n, -e];
    case 4:
      return [n, -1, -e];
    case 5:
      return [n, e, -1];
    default:
      throw new Error("Invalid face");
  }
}
function Smn([t, e, n]) {
  const r = Math.atan2(n, Math.sqrt(t * t + e * e));
  return [Math.atan2(e, t) * PSe, r * PSe];
}
function Qmn(t) {
  let e = Gk.fromString(t, !0, 10).toString(2);
  for (; e.length < Emn + vmn; )
    e = "0" + e;
  const n = e.lastIndexOf("1"), r = e.substring(0, 3), i = e.substring(3, n), o = i.length / 2, s = Gk.fromString(r, !0, 2).toString(10);
  let a = Gk.fromString(i, !0, 2).toString(4);
  for (; a.length < o; )
    a = "0" + a;
  return "".concat(s, "/").concat(a);
}
function wmn(t, e, n, r) {
  if (r === 0) {
    n === 1 && (e[0] = t - 1 - e[0], e[1] = t - 1 - e[1]);
    const i = e[0];
    e[0] = e[1], e[1] = i;
  }
}
function xmn(t) {
  const e = t.split("/"), n = parseInt(e[0], 10), r = e[1], i = r.length, o = [0, 0];
  let s;
  for (let a = i - 1; a >= 0; a--) {
    s = i - a;
    const A = r[a];
    let l = 0, c = 0;
    A === "1" ? c = 1 : A === "2" ? (l = 1, c = 1) : A === "3" && (l = 1);
    const u = Math.pow(2, s - 1);
    wmn(u, o, l, c), o[0] += u * l, o[1] += u * c;
  }
  if (n % 2 === 1) {
    const a = o[0];
    o[0] = o[1], o[1] = a;
  }
  return {
    face: n,
    ij: o,
    level: s
  };
}
function Rmn(t) {
  const e = t.padEnd(16, "0");
  return Gk.fromString(e, 16);
}
const Dmn = 100;
function Tmn({
  face: t,
  ij: e,
  level: n
}) {
  const r = [[0, 0], [0, 1], [1, 1], [1, 0], [0, 0]], i = Math.max(1, Math.ceil(Dmn * Math.pow(2, -n))), o = new Float64Array(4 * i * 2 + 2);
  let s = 0, a = 0;
  for (let A = 0; A < 4; A++) {
    const l = r[A].slice(0), c = r[A + 1], u = (c[0] - l[0]) / i, f = (c[1] - l[1]) / i;
    for (let h = 0; h < i; h++) {
      l[0] += u, l[1] += f;
      const d = Bmn(e, n, l), I = bmn(d), m = _mn(t, I), C = Smn(m);
      Math.abs(C[1]) > 89.999 && (C[0] = a);
      const y = C[0] - a;
      C[0] += y > 180 ? -360 : y < -180 ? 360 : 0, o[s++] = C[0], o[s++] = C[1], a = C[0];
    }
  }
  return o[s++] = o[0], o[s++] = o[1], o;
}
function Nmn(t) {
  if (typeof t == "string") {
    if (t.indexOf("/") > 0)
      return t;
    t = Rmn(t);
  }
  return Qmn(t.toString());
}
function Lmn(t) {
  const e = Nmn(t), n = xmn(e);
  return Tmn(n);
}
const Mmn = {
  getS2Token: {
    type: "accessor",
    value: (t) => t.token
  }
};
class gce extends r1 {
  indexToBounds() {
    const {
      data: e,
      getS2Token: n
    } = this.props;
    return {
      data: e,
      _normalize: !1,
      positionFormat: "XY",
      getPolygon: (r, i) => Lmn(n(r, i))
    };
  }
}
ae(gce, "layerName", "S2Layer");
ae(gce, "defaultProps", Mmn);
const DV = 512;
function Omn(t) {
  let e = 0, n = 0, r = 1 << t.length;
  const i = r / DV;
  for (let o = 0; o < t.length; o++) {
    r >>= 1;
    const s = parseInt(t[o]);
    s % 2 && (e |= r), s > 1 && (n |= r);
  }
  return [[e / i, DV - n / i], [(e + 0.99) / i, DV - (n + 0.99) / i]];
}
function Fmn(t) {
  const [e, n] = Omn(t), [r, i] = Mf(e), [o, s] = Mf(n);
  return [o, i, o, s, r, s, r, i, o, i];
}
const Pmn = {
  getQuadkey: {
    type: "accessor",
    value: (t) => t.quadkey
  }
};
class hce extends r1 {
  indexToBounds() {
    const {
      data: e,
      getQuadkey: n
    } = this.props;
    return {
      data: e,
      _normalize: !1,
      positionFormat: "XY",
      getPolygon: (r, i) => Fmn(n(r, i))
    };
  }
}
ae(hce, "layerName", "QuadkeyLayer");
ae(hce, "defaultProps", Pmn);
class pje {
  constructor(e) {
    ae(this, "index", void 0), ae(this, "isVisible", void 0), ae(this, "isSelected", void 0), ae(this, "parent", void 0), ae(this, "children", void 0), ae(this, "content", void 0), ae(this, "state", void 0), ae(this, "layers", void 0), ae(this, "id", void 0), ae(this, "bbox", void 0), ae(this, "zoom", void 0), ae(this, "userData", void 0), ae(this, "_abortController", void 0), ae(this, "_loader", void 0), ae(this, "_loaderId", void 0), ae(this, "_isLoaded", void 0), ae(this, "_isCancelled", void 0), ae(this, "_needsReload", void 0), this.index = e, this.isVisible = !1, this.isSelected = !1, this.parent = null, this.children = [], this.content = null, this._loader = void 0, this._abortController = null, this._loaderId = 0, this._isLoaded = !1, this._isCancelled = !1, this._needsReload = !1;
  }
  get data() {
    return this.isLoading && this._loader ? this._loader.then(() => this.data) : this.content;
  }
  get isLoaded() {
    return this._isLoaded && !this._needsReload;
  }
  get isLoading() {
    return !!this._loader && !this._isCancelled;
  }
  get needsReload() {
    return this._needsReload || this._isCancelled;
  }
  get byteLength() {
    const e = this.content ? this.content.byteLength : 0;
    return Number.isFinite(e) || Rr.error("byteLength not defined in tile data")(), e;
  }
  async _loadData({
    getData: e,
    requestScheduler: n,
    onLoad: r,
    onError: i
  }) {
    const {
      index: o,
      id: s,
      bbox: a,
      userData: A,
      zoom: l
    } = this, c = this._loaderId;
    this._abortController = new AbortController();
    const {
      signal: u
    } = this._abortController, f = await n.scheduleRequest(this, (I) => I.isSelected ? 1 : -1);
    if (!f) {
      this._isCancelled = !0;
      return;
    }
    if (this._isCancelled) {
      f.done();
      return;
    }
    let h = null, d;
    try {
      h = await e({
        index: o,
        id: s,
        bbox: a,
        userData: A,
        zoom: l,
        signal: u
      });
    } catch (I) {
      d = I || !0;
    } finally {
      f.done();
    }
    if (c === this._loaderId) {
      if (this._loader = void 0, this.content = h, this._isCancelled && !h) {
        this._isLoaded = !1;
        return;
      }
      this._isLoaded = !0, this._isCancelled = !1, d ? i(d, this) : r(this);
    }
  }
  loadData(e) {
    return this._isLoaded = !1, this._isCancelled = !1, this._needsReload = !1, this._loaderId++, this._loader = this._loadData(e), this._loader;
  }
  setNeedsReload() {
    this.isLoading && (this.abort(), this._loader = void 0), this._needsReload = !0;
  }
  abort() {
    var e;
    this.isLoaded || (this._isCancelled = !0, (e = this._abortController) === null || e === void 0 || e.abort());
  }
}
const Hl = {
  OUTSIDE: -1,
  INTERSECTING: 0,
  INSIDE: 1
}, GSe = new ct(), kmn = new ct();
class dce {
  constructor(e = [0, 0, 0], n = [0, 0, 0], r) {
    ae(this, "center", void 0), ae(this, "halfDiagonal", void 0), ae(this, "minimum", void 0), ae(this, "maximum", void 0), r = r || GSe.copy(e).add(n).scale(0.5), this.center = new ct(r), this.halfDiagonal = new ct(n).subtract(this.center), this.minimum = new ct(e), this.maximum = new ct(n);
  }
  clone() {
    return new dce(this.minimum, this.maximum, this.center);
  }
  equals(e) {
    return this === e || !!e && this.minimum.equals(e.minimum) && this.maximum.equals(e.maximum);
  }
  transform(e) {
    return this.center.transformAsPoint(e), this.halfDiagonal.transform(e), this.minimum.transform(e), this.maximum.transform(e), this;
  }
  intersectPlane(e) {
    const {
      halfDiagonal: n
    } = this, r = kmn.from(e.normal), i = n.x * Math.abs(r.x) + n.y * Math.abs(r.y) + n.z * Math.abs(r.z), o = this.center.dot(r) + e.distance;
    return o - i > 0 ? Hl.INSIDE : o + i < 0 ? Hl.OUTSIDE : Hl.INTERSECTING;
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceSquaredTo(e));
  }
  distanceSquaredTo(e) {
    const n = GSe.from(e).subtract(this.center), {
      halfDiagonal: r
    } = this;
    let i = 0, o;
    return o = Math.abs(n.x) - r.x, o > 0 && (i += o * o), o = Math.abs(n.y) - r.y, o > 0 && (i += o * o), o = Math.abs(n.z) - r.z, o > 0 && (i += o * o), i;
  }
}
const f2 = new ct(), USe = new ct();
class yM {
  constructor(e = [0, 0, 0], n = 0) {
    ae(this, "center", void 0), ae(this, "radius", void 0), this.radius = -0, this.center = new ct(), this.fromCenterRadius(e, n);
  }
  fromCenterRadius(e, n) {
    return this.center.from(e), this.radius = n, this;
  }
  fromCornerPoints(e, n) {
    return n = f2.from(n), this.center = new ct().from(e).add(n).scale(0.5), this.radius = this.center.distance(n), this;
  }
  equals(e) {
    return this === e || !!e && this.center.equals(e.center) && this.radius === e.radius;
  }
  clone() {
    return new yM(this.center, this.radius);
  }
  union(e) {
    const n = this.center, r = this.radius, i = e.center, o = e.radius, s = f2.copy(i).subtract(n), a = s.magnitude();
    if (r >= a + o)
      return this.clone();
    if (o >= a + r)
      return e.clone();
    const A = (r + a + o) * 0.5;
    return USe.copy(s).scale((-r + A) / a).add(n), this.center.copy(USe), this.radius = A, this;
  }
  expand(e) {
    const r = f2.from(e).subtract(this.center).magnitude();
    return r > this.radius && (this.radius = r), this;
  }
  transform(e) {
    this.center.transform(e);
    const n = Qcn(f2, e);
    return this.radius = Math.max(n[0], Math.max(n[1], n[2])) * this.radius, this;
  }
  distanceSquaredTo(e) {
    const n = this.distanceTo(e);
    return n * n;
  }
  distanceTo(e) {
    const r = f2.from(e).subtract(this.center);
    return Math.max(0, r.len() - this.radius);
  }
  intersectPlane(e) {
    const n = this.center, r = this.radius, o = e.normal.dot(n) + e.distance;
    return o < -r ? Hl.OUTSIDE : o < r ? Hl.INTERSECTING : Hl.INSIDE;
  }
}
const Gmn = new ct(), Umn = new ct(), lP = new ct(), cP = new ct(), uP = new ct(), Hmn = new ct(), $mn = new ct(), L0 = {
  COLUMN0ROW0: 0,
  COLUMN0ROW1: 1,
  COLUMN0ROW2: 2,
  COLUMN1ROW0: 3,
  COLUMN1ROW1: 4,
  COLUMN1ROW2: 5,
  COLUMN2ROW0: 6,
  COLUMN2ROW1: 7,
  COLUMN2ROW2: 8
};
class vM {
  constructor(e = [0, 0, 0], n = [0, 0, 0, 0, 0, 0, 0, 0, 0]) {
    ae(this, "center", void 0), ae(this, "halfAxes", void 0), this.center = new ct().from(e), this.halfAxes = new ja(n);
  }
  get halfSize() {
    const e = this.halfAxes.getColumn(0), n = this.halfAxes.getColumn(1), r = this.halfAxes.getColumn(2);
    return [new ct(e).len(), new ct(n).len(), new ct(r).len()];
  }
  get quaternion() {
    const e = this.halfAxes.getColumn(0), n = this.halfAxes.getColumn(1), r = this.halfAxes.getColumn(2), i = new ct(e).normalize(), o = new ct(n).normalize(), s = new ct(r).normalize();
    return new VC().fromMatrix3(new ja([...i, ...o, ...s]));
  }
  fromCenterHalfSizeQuaternion(e, n, r) {
    const i = new VC(r), o = new ja().fromQuaternion(i);
    return o[0] = o[0] * n[0], o[1] = o[1] * n[0], o[2] = o[2] * n[0], o[3] = o[3] * n[1], o[4] = o[4] * n[1], o[5] = o[5] * n[1], o[6] = o[6] * n[2], o[7] = o[7] * n[2], o[8] = o[8] * n[2], this.center = new ct().from(e), this.halfAxes = o, this;
  }
  clone() {
    return new vM(this.center, this.halfAxes);
  }
  equals(e) {
    return this === e || !!e && this.center.equals(e.center) && this.halfAxes.equals(e.halfAxes);
  }
  getBoundingSphere(e = new yM()) {
    const n = this.halfAxes, r = n.getColumn(0, lP), i = n.getColumn(1, cP), o = n.getColumn(2, uP), s = Gmn.copy(r).add(i).add(o);
    return e.center.copy(this.center), e.radius = s.magnitude(), e;
  }
  intersectPlane(e) {
    const n = this.center, r = e.normal, i = this.halfAxes, o = r.x, s = r.y, a = r.z, A = Math.abs(o * i[L0.COLUMN0ROW0] + s * i[L0.COLUMN0ROW1] + a * i[L0.COLUMN0ROW2]) + Math.abs(o * i[L0.COLUMN1ROW0] + s * i[L0.COLUMN1ROW1] + a * i[L0.COLUMN1ROW2]) + Math.abs(o * i[L0.COLUMN2ROW0] + s * i[L0.COLUMN2ROW1] + a * i[L0.COLUMN2ROW2]), l = r.dot(n) + e.distance;
    return l <= -A ? Hl.OUTSIDE : l >= A ? Hl.INSIDE : Hl.INTERSECTING;
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceSquaredTo(e));
  }
  distanceSquaredTo(e) {
    const n = Umn.from(e).subtract(this.center), r = this.halfAxes, i = r.getColumn(0, lP), o = r.getColumn(1, cP), s = r.getColumn(2, uP), a = i.magnitude(), A = o.magnitude(), l = s.magnitude();
    i.normalize(), o.normalize(), s.normalize();
    let c = 0, u;
    return u = Math.abs(n.dot(i)) - a, u > 0 && (c += u * u), u = Math.abs(n.dot(o)) - A, u > 0 && (c += u * u), u = Math.abs(n.dot(s)) - l, u > 0 && (c += u * u), c;
  }
  computePlaneDistances(e, n, r = [-0, -0]) {
    let i = Number.POSITIVE_INFINITY, o = Number.NEGATIVE_INFINITY;
    const s = this.center, a = this.halfAxes, A = a.getColumn(0, lP), l = a.getColumn(1, cP), c = a.getColumn(2, uP), u = Hmn.copy(A).add(l).add(c).add(s), f = $mn.copy(u).subtract(e);
    let h = n.dot(f);
    return i = Math.min(h, i), o = Math.max(h, o), u.copy(s).add(A).add(l).subtract(c), f.copy(u).subtract(e), h = n.dot(f), i = Math.min(h, i), o = Math.max(h, o), u.copy(s).add(A).subtract(l).add(c), f.copy(u).subtract(e), h = n.dot(f), i = Math.min(h, i), o = Math.max(h, o), u.copy(s).add(A).subtract(l).subtract(c), f.copy(u).subtract(e), h = n.dot(f), i = Math.min(h, i), o = Math.max(h, o), s.copy(u).subtract(A).add(l).add(c), f.copy(u).subtract(e), h = n.dot(f), i = Math.min(h, i), o = Math.max(h, o), s.copy(u).subtract(A).add(l).subtract(c), f.copy(u).subtract(e), h = n.dot(f), i = Math.min(h, i), o = Math.max(h, o), s.copy(u).subtract(A).subtract(l).add(c), f.copy(u).subtract(e), h = n.dot(f), i = Math.min(h, i), o = Math.max(h, o), s.copy(u).subtract(A).subtract(l).subtract(c), f.copy(u).subtract(e), h = n.dot(f), i = Math.min(h, i), o = Math.max(h, o), r[0] = i, r[1] = o, r;
  }
  transform(e) {
    this.center.transformAsPoint(e);
    const n = this.halfAxes.getColumn(0, lP);
    n.transformAsPoint(e);
    const r = this.halfAxes.getColumn(1, cP);
    r.transformAsPoint(e);
    const i = this.halfAxes.getColumn(2, uP);
    return i.transformAsPoint(e), this.halfAxes = new ja([...n, ...r, ...i]), this;
  }
  getTransform() {
    throw new Error("not implemented");
  }
}
const HSe = new ct(), $Se = new ct();
class Ef {
  constructor(e = [0, 0, 1], n = 0) {
    ae(this, "normal", void 0), ae(this, "distance", void 0), this.normal = new ct(), this.distance = -0, this.fromNormalDistance(e, n);
  }
  fromNormalDistance(e, n) {
    return bf(Number.isFinite(n)), this.normal.from(e).normalize(), this.distance = n, this;
  }
  fromPointNormal(e, n) {
    e = HSe.from(e), this.normal.from(n).normalize();
    const r = -this.normal.dot(e);
    return this.distance = r, this;
  }
  fromCoefficients(e, n, r, i) {
    return this.normal.set(e, n, r), bf(ul(this.normal.len(), 1)), this.distance = i, this;
  }
  clone() {
    return new Ef(this.normal, this.distance);
  }
  equals(e) {
    return ul(this.distance, e.distance) && ul(this.normal, e.normal);
  }
  getPointDistance(e) {
    return this.normal.dot(e) + this.distance;
  }
  transform(e) {
    const n = $Se.copy(this.normal).transformAsVector(e).normalize(), r = this.normal.scale(-this.distance).transform(e);
    return this.fromPointNormal(r, n);
  }
  projectPointOntoPlane(e, n = [0, 0, 0]) {
    e = HSe.from(e);
    const r = this.getPointDistance(e), i = $Se.copy(this.normal).scale(r);
    return e.subtract(i).to(n);
  }
}
const qSe = [new ct([1, 0, 0]), new ct([0, 1, 0]), new ct([0, 0, 1])], jSe = new ct(), qmn = new ct();
new Ef(new ct(1, 0, 0), 0);
class Qf {
  constructor(e = []) {
    ae(this, "planes", void 0), this.planes = e;
  }
  fromBoundingSphere(e) {
    this.planes.length = 2 * qSe.length;
    const n = e.center, r = e.radius;
    let i = 0;
    for (const o of qSe) {
      let s = this.planes[i], a = this.planes[i + 1];
      s || (s = this.planes[i] = new Ef()), a || (a = this.planes[i + 1] = new Ef());
      const A = jSe.copy(o).scale(-r).add(n);
      -o.dot(A), s.fromPointNormal(A, o);
      const l = jSe.copy(o).scale(r).add(n), c = qmn.copy(o).negate();
      -c.dot(l), a.fromPointNormal(l, c), i += 2;
    }
    return this;
  }
  computeVisibility(e) {
    let n = Hl.INSIDE;
    for (const r of this.planes)
      switch (e.intersectPlane(r)) {
        case Hl.OUTSIDE:
          return Hl.OUTSIDE;
        case Hl.INTERSECTING:
          n = Hl.INTERSECTING;
          break;
      }
    return n;
  }
  computeVisibilityWithPlaneMask(e, n) {
    if (bf(Number.isFinite(n), "parentPlaneMask is required."), n === Qf.MASK_OUTSIDE || n === Qf.MASK_INSIDE)
      return n;
    let r = Qf.MASK_INSIDE;
    const i = this.planes;
    for (let o = 0; o < this.planes.length; ++o) {
      const s = o < 31 ? 1 << o : 0;
      if (o < 31 && !(n & s))
        continue;
      const a = i[o], A = e.intersectPlane(a);
      if (A === Hl.OUTSIDE)
        return Qf.MASK_OUTSIDE;
      A === Hl.INTERSECTING && (r |= s);
    }
    return r;
  }
}
ae(Qf, "MASK_OUTSIDE", 4294967295);
ae(Qf, "MASK_INSIDE", 0);
ae(Qf, "MASK_INDETERMINATE", 2147483647);
new ct();
new ct();
new ct();
new ct();
new ct();
new ct();
new ct();
new ct();
new ct();
new ct();
new ct();
new ct();
new ct();
new ct();
new ct();
new ct();
new ct();
const op = new ja(), jmn = new ja(), Ymn = new ja(), fP = new ja(), YSe = new ja();
function zmn(t, e = {}) {
  const n = $S.EPSILON20, r = 10;
  let i = 0, o = 0;
  const s = jmn, a = Ymn;
  s.identity(), a.copy(t);
  const A = n * Vmn(a);
  for (; o < r && Jmn(a) > A; )
    Kmn(a, fP), YSe.copy(fP).transpose(), a.multiplyRight(fP), a.multiplyLeft(YSe), s.multiplyRight(fP), ++i > 2 && (++o, i = 0);
  return e.unitary = s.toTarget(e.unitary), e.diagonal = a.toTarget(e.diagonal), e;
}
function Vmn(t) {
  let e = 0;
  for (let n = 0; n < 9; ++n) {
    const r = t[n];
    e += r * r;
  }
  return Math.sqrt(e);
}
const Ate = [1, 0, 0], lte = [2, 2, 1];
function Jmn(t) {
  let e = 0;
  for (let n = 0; n < 3; ++n) {
    const r = t[op.getElementIndex(lte[n], Ate[n])];
    e += 2 * r * r;
  }
  return Math.sqrt(e);
}
function Kmn(t, e) {
  const n = $S.EPSILON15;
  let r = 0, i = 1;
  for (let l = 0; l < 3; ++l) {
    const c = Math.abs(t[op.getElementIndex(lte[l], Ate[l])]);
    c > r && (i = l, r = c);
  }
  const o = Ate[i], s = lte[i];
  let a = 1, A = 0;
  if (Math.abs(t[op.getElementIndex(s, o)]) > n) {
    const l = t[op.getElementIndex(s, s)], c = t[op.getElementIndex(o, o)], u = t[op.getElementIndex(s, o)], f = (l - c) / 2 / u;
    let h;
    f < 0 ? h = -1 / (-f + Math.sqrt(1 + f * f)) : h = 1 / (f + Math.sqrt(1 + f * f)), a = 1 / Math.sqrt(1 + h * h), A = h * a;
  }
  return ja.IDENTITY.to(e), e[op.getElementIndex(o, o)] = e[op.getElementIndex(s, s)] = a, e[op.getElementIndex(s, o)] = A, e[op.getElementIndex(o, s)] = -A, e;
}
const Tm = new ct(), Wmn = new ct(), Xmn = new ct(), Zmn = new ct(), eCn = new ct(), tCn = new ja(), nCn = {
  diagonal: new ja(),
  unitary: new ja()
};
function rCn(t, e = new vM()) {
  if (!t || t.length === 0)
    return e.halfAxes = new ja([0, 0, 0, 0, 0, 0, 0, 0, 0]), e.center = new ct(), e;
  const n = t.length, r = new ct(0, 0, 0);
  for (const O of t)
    r.add(O);
  const i = 1 / n;
  r.multiplyByScalar(i);
  let o = 0, s = 0, a = 0, A = 0, l = 0, c = 0;
  for (const O of t) {
    const L = Tm.copy(O).subtract(r);
    o += L.x * L.x, s += L.x * L.y, a += L.x * L.z, A += L.y * L.y, l += L.y * L.z, c += L.z * L.z;
  }
  o *= i, s *= i, a *= i, A *= i, l *= i, c *= i;
  const u = tCn;
  u[0] = o, u[1] = s, u[2] = a, u[3] = s, u[4] = A, u[5] = l, u[6] = a, u[7] = l, u[8] = c;
  const {
    unitary: f
  } = zmn(u, nCn), h = e.halfAxes.copy(f);
  let d = h.getColumn(0, Xmn), I = h.getColumn(1, Zmn), m = h.getColumn(2, eCn), C = -Number.MAX_VALUE, y = -Number.MAX_VALUE, v = -Number.MAX_VALUE, b = Number.MAX_VALUE, Q = Number.MAX_VALUE, w = Number.MAX_VALUE;
  for (const O of t)
    Tm.copy(O), C = Math.max(Tm.dot(d), C), y = Math.max(Tm.dot(I), y), v = Math.max(Tm.dot(m), v), b = Math.min(Tm.dot(d), b), Q = Math.min(Tm.dot(I), Q), w = Math.min(Tm.dot(m), w);
  d = d.multiplyByScalar(0.5 * (b + C)), I = I.multiplyByScalar(0.5 * (Q + y)), m = m.multiplyByScalar(0.5 * (w + v)), e.center.copy(d).add(I).add(m);
  const R = Wmn.set(C - b, y - Q, v - w).multiplyByScalar(0.5), M = new ja([R[0], 0, 0, 0, R[1], 0, 0, 0, R[2]]);
  return e.halfAxes.multiplyRight(M), e;
}
const I_ = 512, zSe = 3, Ije = [[0.5, 0.5], [0, 0], [0, 1], [1, 0], [1, 1]], mje = Ije.concat([[0, 0.5], [0.5, 0], [1, 0.5], [0.5, 1]]), iCn = mje.concat([[0.25, 0.5], [0.75, 0.5]]);
class m_ {
  constructor(e, n, r) {
    ae(this, "x", void 0), ae(this, "y", void 0), ae(this, "z", void 0), ae(this, "childVisible", void 0), ae(this, "selected", void 0), ae(this, "_children", void 0), this.x = e, this.y = n, this.z = r;
  }
  get children() {
    if (!this._children) {
      const e = this.x * 2, n = this.y * 2, r = this.z + 1;
      this._children = [new m_(e, n, r), new m_(e, n + 1, r), new m_(e + 1, n, r), new m_(e + 1, n + 1, r)];
    }
    return this._children;
  }
  update(e) {
    const {
      viewport: n,
      cullingVolume: r,
      elevationBounds: i,
      minZ: o,
      maxZ: s,
      bounds: a,
      offset: A,
      project: l
    } = e, c = this.getBoundingVolume(i, A, l);
    if (a && !this.insideBounds(a) || r.computeVisibility(c) < 0)
      return !1;
    if (!this.childVisible) {
      let {
        z: f
      } = this;
      if (f < s && f >= o) {
        const h = c.distanceTo(n.cameraPosition) * n.scale / n.height;
        f += Math.floor(Math.log2(h));
      }
      if (f >= s)
        return this.selected = !0, !0;
    }
    this.selected = !1, this.childVisible = !0;
    for (const f of this.children)
      f.update(e);
    return !0;
  }
  getSelected(e = []) {
    if (this.selected && e.push(this), this._children)
      for (const n of this._children)
        n.getSelected(e);
    return e;
  }
  insideBounds([e, n, r, i]) {
    const o = Math.pow(2, this.z), s = I_ / o;
    return this.x * s < r && this.y * s < i && (this.x + 1) * s > e && (this.y + 1) * s > n;
  }
  getBoundingVolume(e, n, r) {
    if (r) {
      const A = this.z < 1 ? iCn : this.z < 2 ? mje : Ije, l = [];
      for (const c of A) {
        const u = fte(this.x + c[0], this.y + c[1], this.z);
        u[2] = e[0], l.push(r(u)), e[0] !== e[1] && (u[2] = e[1], l.push(r(u)));
      }
      return rCn(l);
    }
    const i = Math.pow(2, this.z), o = I_ / i, s = this.x * o + n * I_, a = I_ - (this.y + 1) * o;
    return new dce([s, a, e[0]], [s + o, a + o, e[1]]);
  }
}
function oCn(t, e, n, r) {
  const i = t instanceof nce && t.resolution ? t.projectPosition : null, o = Object.values(t.getFrustumPlanes()).map(({
    normal: h,
    distance: d
  }) => new Ef(h.clone().negate(), d)), s = new Qf(o), a = t.distanceScales.unitsPerMeter[2], A = n && n[0] * a || 0, l = n && n[1] * a || 0, c = t instanceof gd && t.pitch <= 60 ? e : 0;
  if (r) {
    const [h, d, I, m] = r, C = Hc([h, m]), y = Hc([I, d]);
    r = [C[0], I_ - C[1], y[0], I_ - y[1]];
  }
  const u = new m_(0, 0, 0), f = {
    viewport: t,
    project: i,
    cullingVolume: s,
    elevationBounds: [A, l],
    minZ: c,
    maxZ: e,
    bounds: r,
    offset: 0
  };
  if (u.update(f), t instanceof gd && t.subViewports && t.subViewports.length > 1) {
    for (f.offset = -1; u.update(f) && !(--f.offset < -zSe); )
      ;
    for (f.offset = 1; u.update(f) && !(++f.offset > zSe); )
      ;
  }
  return u.getSelected();
}
const MI = 512, sCn = [-1 / 0, -1 / 0, 1 / 0, 1 / 0], cte = {
  type: "url",
  value: null,
  validate: (t, e) => e.optional && t === null || typeof t == "string" || Array.isArray(t) && t.every((n) => typeof n == "string"),
  equals: (t, e) => {
    if (t === e)
      return !0;
    if (!Array.isArray(t) || !Array.isArray(e))
      return !1;
    const n = t.length;
    if (n !== e.length)
      return !1;
    for (let r = 0; r < n; r++)
      if (t[r] !== e[r])
        return !1;
    return !0;
  }
};
function Cje(t, e) {
  const n = [e.transformAsPoint([t[0], t[1]]), e.transformAsPoint([t[2], t[1]]), e.transformAsPoint([t[0], t[3]]), e.transformAsPoint([t[2], t[3]])];
  return [Math.min(...n.map((i) => i[0])), Math.min(...n.map((i) => i[1])), Math.max(...n.map((i) => i[0])), Math.max(...n.map((i) => i[1]))];
}
function aCn(t) {
  return Math.abs(t.split("").reduce((e, n) => (e << 5) - e + n.charCodeAt(0) | 0, 0));
}
function VT(t, e) {
  if (!t || !t.length)
    return null;
  const {
    index: n,
    id: r
  } = e;
  if (Array.isArray(t)) {
    const o = aCn(r) % t.length;
    t = t[o];
  }
  let i = t;
  for (const o of Object.keys(n)) {
    const s = new RegExp("{".concat(o, "}"), "g");
    i = i.replace(s, String(n[o]));
  }
  return Number.isInteger(n.y) && Number.isInteger(n.z) && (i = i.replace(/\{-y\}/g, String(Math.pow(2, n.z) - n.y - 1))), i;
}
function ACn(t, e, n) {
  let r;
  if (e && e.length === 2) {
    const [i, o] = e, s = t.getBounds({
      z: i
    }), a = t.getBounds({
      z: o
    });
    r = [Math.min(s[0], a[0]), Math.min(s[1], a[1]), Math.max(s[2], a[2]), Math.max(s[3], a[3])];
  } else
    r = t.getBounds();
  return t.isGeospatial ? [Math.max(r[0], n[0]), Math.max(r[1], n[1]), Math.min(r[2], n[2]), Math.min(r[3], n[3])] : [Math.max(Math.min(r[0], n[2]), n[0]), Math.max(Math.min(r[1], n[3]), n[1]), Math.min(Math.max(r[2], n[0]), n[2]), Math.min(Math.max(r[3], n[1]), n[3])];
}
function lCn({
  viewport: t,
  z: e = 0,
  cullRect: n
}) {
  return (t.subViewports || [t]).map((i) => ute(i, e, n));
}
function ute(t, e, n) {
  if (!Array.isArray(e)) {
    const o = n.x - t.x, s = n.y - t.y, {
      width: a,
      height: A
    } = n, l = {
      targetZ: e
    }, c = t.unproject([o, s], l), u = t.unproject([o + a, s], l), f = t.unproject([o, s + A], l), h = t.unproject([o + a, s + A], l);
    return [Math.min(c[0], u[0], f[0], h[0]), Math.min(c[1], u[1], f[1], h[1]), Math.max(c[0], u[0], f[0], h[0]), Math.max(c[1], u[1], f[1], h[1])];
  }
  const r = ute(t, e[0], n), i = ute(t, e[1], n);
  return [Math.min(r[0], i[0]), Math.min(r[1], i[1]), Math.max(r[2], i[2]), Math.max(r[3], i[3])];
}
function cCn(t, e, n) {
  return n ? Cje(t, n).map((i) => i * e / MI) : t.map((r) => r * e / MI);
}
function pce(t, e) {
  return Math.pow(2, t) * MI / e;
}
function fte(t, e, n) {
  const r = pce(n, MI), i = t / r * 360 - 180, o = Math.PI - 2 * Math.PI * e / r, s = 180 / Math.PI * Math.atan(0.5 * (Math.exp(o) - Math.exp(-o)));
  return [i, s];
}
function VSe(t, e, n, r) {
  const i = pce(n, r);
  return [t / i * MI, e / i * MI];
}
function uCn(t, e, n, r, i = MI) {
  if (t.isGeospatial) {
    const [l, c] = fte(e, n, r), [u, f] = fte(e + 1, n + 1, r);
    return {
      west: l,
      north: c,
      east: u,
      south: f
    };
  }
  const [o, s] = VSe(e, n, r, i), [a, A] = VSe(e + 1, n + 1, r, i);
  return {
    left: o,
    top: s,
    right: a,
    bottom: A
  };
}
function fCn(t, e, n, r, i) {
  const o = ACn(t, null, r), s = pce(e, n), [a, A, l, c] = cCn(o, s, i), u = [];
  for (let f = Math.floor(a); f < l; f++)
    for (let h = Math.floor(A); h < c; h++)
      u.push({
        x: f,
        y: h,
        z: e
      });
  return u;
}
function gCn({
  viewport: t,
  maxZoom: e,
  minZoom: n,
  zRange: r,
  extent: i,
  tileSize: o = MI,
  modelMatrix: s,
  modelMatrixInverse: a,
  zoomOffset: A = 0
}) {
  let l = t.isGeospatial ? Math.round(t.zoom + Math.log2(MI / o)) + A : Math.ceil(t.zoom) + A;
  if (typeof n == "number" && Number.isFinite(n) && l < n) {
    if (!i)
      return [];
    l = n;
  }
  typeof e == "number" && Number.isFinite(e) && l > e && (l = e);
  let c = i;
  return s && a && i && !t.isGeospatial && (c = Cje(i, s)), t.isGeospatial ? oCn(t, l, r, i) : fCn(t, l, o, c || sCn, a);
}
function hCn(t) {
  return /(?=.*{z})(?=.*{x})(?=.*({y}|{-y}))/.test(t);
}
function dCn(t) {
  return Number.isFinite(t.west) && Number.isFinite(t.north) && Number.isFinite(t.east) && Number.isFinite(t.south);
}
const JSe = 1, E$ = 2, pCn = "never", ICn = "no-overlap", Ice = "best-available", mCn = 5, CCn = {
  [Ice]: ECn,
  [ICn]: yCn,
  [pCn]: () => {
  }
};
class Eje {
  constructor(e) {
    ae(this, "opts", void 0), ae(this, "_requestScheduler", void 0), ae(this, "_cache", void 0), ae(this, "_dirty", void 0), ae(this, "_tiles", void 0), ae(this, "_cacheByteSize", void 0), ae(this, "_viewport", void 0), ae(this, "_zRange", void 0), ae(this, "_selectedTiles", void 0), ae(this, "_frameNumber", void 0), ae(this, "_modelMatrix", void 0), ae(this, "_modelMatrixInverse", void 0), ae(this, "_maxZoom", void 0), ae(this, "_minZoom", void 0), ae(this, "onTileLoad", void 0), ae(this, "_getCullBounds", Lw(lCn)), this.opts = e, this.onTileLoad = (n) => {
      this.opts.onTileLoad(n), this.opts.maxCacheByteSize && (this._cacheByteSize += n.byteLength, this._resizeCache());
    }, this._requestScheduler = new h9e({
      maxRequests: e.maxRequests,
      throttleRequests: e.maxRequests > 0
    }), this._cache = /* @__PURE__ */ new Map(), this._tiles = [], this._dirty = !1, this._cacheByteSize = 0, this._viewport = null, this._selectedTiles = null, this._frameNumber = 0, this._modelMatrix = new pn(), this._modelMatrixInverse = new pn(), this.setOptions(e);
  }
  get tiles() {
    return this._tiles;
  }
  get selectedTiles() {
    return this._selectedTiles;
  }
  get isLoaded() {
    return this._selectedTiles !== null && this._selectedTiles.every((e) => e.isLoaded);
  }
  get needsReload() {
    return this._selectedTiles !== null && this._selectedTiles.some((e) => e.needsReload);
  }
  setOptions(e) {
    Object.assign(this.opts, e), Number.isFinite(e.maxZoom) && (this._maxZoom = Math.floor(e.maxZoom)), Number.isFinite(e.minZoom) && (this._minZoom = Math.ceil(e.minZoom));
  }
  finalize() {
    for (const e of this._cache.values())
      e.isLoading && e.abort();
    this._cache.clear(), this._tiles = [], this._selectedTiles = null;
  }
  reloadAll() {
    for (const e of this._cache.keys()) {
      const n = this._cache.get(e);
      !this._selectedTiles || !this._selectedTiles.includes(n) ? this._cache.delete(e) : n.setNeedsReload();
    }
  }
  update(e, {
    zRange: n,
    modelMatrix: r
  } = {}) {
    const i = new pn(r), o = !i.equals(this._modelMatrix);
    if (!this._viewport || !e.equals(this._viewport) || !ul(this._zRange, n) || o) {
      o && (this._modelMatrixInverse = i.clone().invert(), this._modelMatrix = i), this._viewport = e, this._zRange = n;
      const a = this.getTileIndices({
        viewport: e,
        maxZoom: this._maxZoom,
        minZoom: this._minZoom,
        zRange: n,
        modelMatrix: this._modelMatrix,
        modelMatrixInverse: this._modelMatrixInverse
      });
      this._selectedTiles = a.map((A) => this._getTile(A, !0)), this._dirty && this._rebuildTree();
    } else
      this.needsReload && (this._selectedTiles = this._selectedTiles.map((a) => this._getTile(a.index, !0)));
    const s = this.updateTileStates();
    return this._pruneRequests(), this._dirty && this._resizeCache(), s && this._frameNumber++, this._frameNumber;
  }
  isTileVisible(e, n) {
    if (!e.isVisible)
      return !1;
    if (n && this._viewport) {
      const r = this._getCullBounds({
        viewport: this._viewport,
        z: this._zRange,
        cullRect: n
      }), {
        bbox: i
      } = e;
      for (const [o, s, a, A] of r) {
        let l;
        if ("west" in i)
          l = i.west < a && i.east > o && i.south < A && i.north > s;
        else {
          const c = Math.min(i.top, i.bottom), u = Math.max(i.top, i.bottom);
          l = i.left < a && i.right > o && c < A && u > s;
        }
        if (l)
          return !0;
      }
      return !1;
    }
    return !0;
  }
  getTileIndices({
    viewport: e,
    maxZoom: n,
    minZoom: r,
    zRange: i,
    modelMatrix: o,
    modelMatrixInverse: s
  }) {
    const {
      tileSize: a,
      extent: A,
      zoomOffset: l
    } = this.opts;
    return gCn({
      viewport: e,
      maxZoom: n,
      minZoom: r,
      zRange: i,
      tileSize: a,
      extent: A,
      modelMatrix: o,
      modelMatrixInverse: s,
      zoomOffset: l
    });
  }
  getTileId(e) {
    return "".concat(e.x, "-").concat(e.y, "-").concat(e.z);
  }
  getTileZoom(e) {
    return e.z;
  }
  getTileMetadata(e) {
    const {
      tileSize: n
    } = this.opts;
    return {
      bbox: uCn(this._viewport, e.x, e.y, e.z, n)
    };
  }
  getParentIndex(e) {
    const n = Math.floor(e.x / 2), r = Math.floor(e.y / 2), i = e.z - 1;
    return {
      x: n,
      y: r,
      z: i
    };
  }
  updateTileStates() {
    const e = this.opts.refinementStrategy || Ice, n = new Array(this._cache.size);
    let r = 0;
    for (const i of this._cache.values())
      n[r++] = i.isVisible, i.isSelected = !1, i.isVisible = !1;
    for (const i of this._selectedTiles)
      i.isSelected = !0, i.isVisible = !0;
    (typeof e == "function" ? e : CCn[e])(Array.from(this._cache.values())), r = 0;
    for (const i of this._cache.values())
      if (n[r++] !== i.isVisible)
        return !0;
    return !1;
  }
  _pruneRequests() {
    const {
      maxRequests: e
    } = this.opts, n = [];
    let r = 0;
    for (const i of this._cache.values())
      i.isLoading && (r++, !i.isSelected && !i.isVisible && n.push(i));
    for (; e > 0 && r > e && n.length > 0; )
      n.shift().abort(), r--;
  }
  _rebuildTree() {
    const {
      _cache: e
    } = this;
    for (const n of e.values())
      n.parent = null, n.children && (n.children.length = 0);
    for (const n of e.values()) {
      const r = this._getNearestAncestor(n);
      n.parent = r, r != null && r.children && r.children.push(n);
    }
  }
  _resizeCache() {
    const {
      _cache: e,
      opts: n
    } = this, r = n.maxCacheSize || (n.maxCacheByteSize ? 1 / 0 : mCn * this.selectedTiles.length), i = n.maxCacheByteSize || 1 / 0;
    if (e.size > r || this._cacheByteSize > i) {
      for (const [s, a] of e)
        if (!a.isVisible && !a.isSelected && (this._cacheByteSize -= n.maxCacheByteSize ? a.byteLength : 0, e.delete(s), this.opts.onTileUnload(a)), e.size <= r && this._cacheByteSize <= i)
          break;
      this._rebuildTree(), this._dirty = !0;
    }
    this._dirty && (this._tiles = Array.from(this._cache.values()).sort((s, a) => s.zoom - a.zoom), this._dirty = !1);
  }
  _getTile(e, n) {
    const r = this.getTileId(e);
    let i = this._cache.get(r), o = !1;
    return !i && n ? (i = new pje(e), Object.assign(i, this.getTileMetadata(i.index)), Object.assign(i, {
      id: r,
      zoom: this.getTileZoom(i.index)
    }), o = !0, this._cache.set(r, i), this._dirty = !0) : i && i.needsReload && (o = !0), i && o && i.loadData({
      getData: this.opts.getTileData,
      requestScheduler: this._requestScheduler,
      onLoad: this.onTileLoad,
      onError: this.opts.onTileError
    }), i;
  }
  _getNearestAncestor(e) {
    const {
      _minZoom: n = 0
    } = this;
    let r = e.index;
    for (; this.getTileZoom(r) > n; ) {
      r = this.getParentIndex(r);
      const i = this._getTile(r);
      if (i)
        return i;
    }
    return null;
  }
}
function ECn(t) {
  for (const e of t)
    e.state = 0;
  for (const e of t)
    e.isSelected && !yje(e) && mce(e);
  for (const e of t)
    e.isVisible = !!(e.state & E$);
}
function yCn(t) {
  for (const n of t)
    n.state = 0;
  for (const n of t)
    n.isSelected && yje(n);
  const e = Array.from(t).sort((n, r) => n.zoom - r.zoom);
  for (const n of e)
    if (n.isVisible = !!(n.state & E$), n.children && (n.isVisible || n.state & JSe))
      for (const r of n.children)
        r.state = JSe;
    else
      n.isSelected && mce(n);
}
function yje(t) {
  let e = t;
  for (; e; ) {
    if (e.isLoaded || e.content)
      return e.state |= E$, !0;
    e = e.parent;
  }
  return !1;
}
function mce(t) {
  for (const e of t.children)
    e.isLoaded || e.content ? e.state |= E$ : mce(e);
}
const vCn = {
  TilesetClass: Eje,
  data: {
    type: "data",
    value: []
  },
  dataComparator: cte.equals,
  renderSubLayers: {
    type: "function",
    value: (t) => new Fw(t),
    compare: !1
  },
  getTileData: {
    type: "function",
    optional: !0,
    value: null,
    compare: !1
  },
  onViewportLoad: {
    type: "function",
    optional: !0,
    value: null,
    compare: !1
  },
  onTileLoad: {
    type: "function",
    value: (t) => {
    },
    compare: !1
  },
  onTileUnload: {
    type: "function",
    value: (t) => {
    },
    compare: !1
  },
  onTileError: {
    type: "function",
    value: (t) => console.error(t),
    compare: !1
  },
  extent: {
    type: "array",
    optional: !0,
    value: null,
    compare: !0
  },
  tileSize: 512,
  maxZoom: null,
  minZoom: 0,
  maxCacheSize: null,
  maxCacheByteSize: null,
  refinementStrategy: Ice,
  zRange: null,
  maxRequests: 6,
  zoomOffset: 0
};
class i1 extends mA {
  initializeState() {
    this.state = {
      tileset: null,
      isLoaded: !1
    };
  }
  finalizeState() {
    var e, n;
    (e = this.state) === null || e === void 0 || (n = e.tileset) === null || n === void 0 || n.finalize();
  }
  get isLoaded() {
    var e, n;
    return (e = this.state) === null || e === void 0 || (n = e.tileset) === null || n === void 0 ? void 0 : n.selectedTiles.every((r) => r.isLoaded && r.layers && r.layers.every((i) => i.isLoaded));
  }
  shouldUpdateState({
    changeFlags: e
  }) {
    return e.somethingChanged;
  }
  updateState({
    changeFlags: e
  }) {
    let {
      tileset: n
    } = this.state;
    const r = e.propsOrDataChanged || e.updateTriggersChanged, i = e.dataChanged || e.updateTriggersChanged && (e.updateTriggersChanged.all || e.updateTriggersChanged.getTileData);
    n ? r && (n.setOptions(this._getTilesetOptions()), i ? n.reloadAll() : this.state.tileset.tiles.forEach((o) => {
      o.layers = null;
    })) : (n = new this.props.TilesetClass(this._getTilesetOptions()), this.setState({
      tileset: n
    })), this._updateTileset();
  }
  _getTilesetOptions() {
    const {
      tileSize: e,
      maxCacheSize: n,
      maxCacheByteSize: r,
      refinementStrategy: i,
      extent: o,
      maxZoom: s,
      minZoom: a,
      maxRequests: A,
      zoomOffset: l
    } = this.props;
    return {
      maxCacheSize: n,
      maxCacheByteSize: r,
      maxZoom: s,
      minZoom: a,
      tileSize: e,
      refinementStrategy: i,
      extent: o,
      maxRequests: A,
      zoomOffset: l,
      getTileData: this.getTileData.bind(this),
      onTileLoad: this._onTileLoad.bind(this),
      onTileError: this._onTileError.bind(this),
      onTileUnload: this._onTileUnload.bind(this)
    };
  }
  _updateTileset() {
    const {
      tileset: e
    } = this.state, {
      zRange: n,
      modelMatrix: r
    } = this.props, i = e.update(this.context.viewport, {
      zRange: n,
      modelMatrix: r
    }), {
      isLoaded: o
    } = e, s = this.state.isLoaded !== o, a = this.state.frameNumber !== i;
    o && (s || a) && this._onViewportLoad(), a && this.setState({
      frameNumber: i
    }), this.state.isLoaded = o;
  }
  _onViewportLoad() {
    const {
      tileset: e
    } = this.state, {
      onViewportLoad: n
    } = this.props;
    n && n(e.selectedTiles);
  }
  _onTileLoad(e) {
    this.props.onTileLoad(e), e.layers = null, this.setNeedsUpdate();
  }
  _onTileError(e, n) {
    this.props.onTileError(e), n.layers = null, this.setNeedsUpdate();
  }
  _onTileUnload(e) {
    this.props.onTileUnload(e);
  }
  getTileData(e) {
    const {
      data: n,
      getTileData: r,
      fetch: i
    } = this.props, {
      signal: o
    } = e;
    return e.url = typeof n == "string" || Array.isArray(n) ? VT(n, e) : null, r ? r(e) : i && e.url ? i(e.url, {
      propName: "data",
      layer: this,
      signal: o
    }) : null;
  }
  renderSubLayers(e) {
    return this.props.renderSubLayers(e);
  }
  getSubLayerPropsByTile(e) {
    return null;
  }
  getPickingInfo({
    info: e,
    sourceLayer: n
  }) {
    const r = n.props.tile;
    return e.picked && (e.tile = r), e.sourceTile = r, e;
  }
  _updateAutoHighlight(e) {
    const n = e.sourceTile;
    if (n && n.layers)
      for (const r of n.layers)
        r.updateAutoHighlight(e);
  }
  renderLayers() {
    return this.state.tileset.tiles.map((e) => {
      const n = this.getSubLayerPropsByTile(e);
      if (!(!e.isLoaded && !e.content))
        if (e.layers)
          n && e.layers[0] && Object.keys(n).some((r) => e.layers[0].props[r] !== n[r]) && (e.layers = e.layers.map((r) => r.clone(n)));
        else {
          const r = this.renderSubLayers({
            ...this.props,
            id: "".concat(this.id, "-").concat(e.id),
            data: e.content,
            _offset: 0,
            tile: e
          });
          e.layers = gM(r, Boolean).map((i) => i.clone({
            tile: e,
            ...n
          }));
        }
      return e.layers;
    });
  }
  filterSubLayer({
    layer: e,
    cullRect: n
  }) {
    const {
      tile: r
    } = e.props;
    return this.state.tileset.isTileVisible(r, n);
  }
}
ae(i1, "defaultProps", vCn);
ae(i1, "layerName", "TileLayer");
const BCn = {
  fadeTrail: !0,
  trailLength: {
    type: "number",
    value: 120,
    min: 0
  },
  currentTime: {
    type: "number",
    value: 0,
    min: 0
  },
  getTimestamps: {
    type: "accessor",
    value: (t) => t.timestamps
  }
};
class Cce extends Ow {
  getShaders() {
    const e = super.getShaders();
    return e.inject = {
      "vs:#decl": `uniform float trailLength;
attribute float instanceTimestamps;
attribute float instanceNextTimestamps;
varying float vTime;
`,
      "vs:#main-end": `vTime = instanceTimestamps + (instanceNextTimestamps - instanceTimestamps) * vPathPosition.y / vPathLength;
`,
      "fs:#decl": `uniform bool fadeTrail;
uniform float trailLength;
uniform float currentTime;
varying float vTime;
`,
      "fs:#main-start": `if(vTime > currentTime || (fadeTrail && (vTime < currentTime - trailLength))) {
  discard;
}
`,
      "fs:DECKGL_FILTER_COLOR": `if(fadeTrail) {
  color.a *= 1.0 - (currentTime - vTime) / trailLength;
}
`
    }, e;
  }
  initializeState() {
    super.initializeState(), this.getAttributeManager().addInstanced({
      timestamps: {
        size: 1,
        accessor: "getTimestamps",
        shaderAttributes: {
          instanceTimestamps: {
            vertexOffset: 0
          },
          instanceNextTimestamps: {
            vertexOffset: 1
          }
        }
      }
    });
  }
  draw(e) {
    const {
      fadeTrail: n,
      trailLength: r,
      currentTime: i
    } = this.props;
    e.uniforms = {
      ...e.uniforms,
      fadeTrail: n,
      trailLength: r,
      currentTime: i
    }, super.draw(e);
  }
}
ae(Cce, "layerName", "TripsLayer");
ae(Cce, "defaultProps", BCn);
var Wt = function(t) {
  t = t || {};
  var e = typeof t < "u" ? t : {}, n = {}, r;
  for (r in e)
    e.hasOwnProperty(r) && (n[r] = e[r]);
  var i = "";
  function o(nt) {
    return e.locateFile ? e.locateFile(nt, i) : i + nt;
  }
  var s;
  document.currentScript && (i = document.currentScript.src), i.indexOf("blob:") !== 0 ? i = i.substr(0, i.lastIndexOf("/") + 1) : i = "", s = function(st, xt, Me) {
    var _ = new XMLHttpRequest();
    _.open("GET", st, !0), _.responseType = "arraybuffer", _.onload = function() {
      if (_.status == 200 || _.status == 0 && _.response) {
        xt(_.response);
        return;
      }
      var He = It(st);
      if (He) {
        xt(He.buffer);
        return;
      }
      Me();
    }, _.onerror = Me, _.send(null);
  };
  var a = e.print || console.log.bind(console), A = e.printErr || console.warn.bind(console);
  for (r in n)
    n.hasOwnProperty(r) && (e[r] = n[r]);
  n = null, e.arguments && e.arguments;
  var l = 0, c = function(nt) {
    l = nt;
  }, u = function() {
    return l;
  }, f = 8;
  function h(nt, st, xt, Me) {
    switch (xt = xt || "i8", xt.charAt(xt.length - 1) === "*" && (xt = "i32"), xt) {
      case "i1":
        k[nt >> 0] = st;
        break;
      case "i8":
        k[nt >> 0] = st;
        break;
      case "i16":
        U[nt >> 1] = st;
        break;
      case "i32":
        X[nt >> 2] = st;
        break;
      case "i64":
        Pe = [st >>> 0, (we = st, +se(we) >= 1 ? we > 0 ? (ge(+W(we / 4294967296), 4294967295) | 0) >>> 0 : ~~+fe((we - +(~~we >>> 0)) / 4294967296) >>> 0 : 0)], X[nt >> 2] = Pe[0], X[nt + 4 >> 2] = Pe[1];
        break;
      case "float":
        K[nt >> 2] = st;
        break;
      case "double":
        z[nt >> 3] = st;
        break;
      default:
        vn("invalid type for setValue: " + xt);
    }
  }
  function d(nt, st, xt) {
    switch (st = st || "i8", st.charAt(st.length - 1) === "*" && (st = "i32"), st) {
      case "i1":
        return k[nt >> 0];
      case "i8":
        return k[nt >> 0];
      case "i16":
        return U[nt >> 1];
      case "i32":
        return X[nt >> 2];
      case "i64":
        return X[nt >> 2];
      case "float":
        return K[nt >> 2];
      case "double":
        return z[nt >> 3];
      default:
        vn("invalid type for getValue: " + st);
    }
    return null;
  }
  var I = !1;
  function m(nt, st) {
    nt || vn("Assertion failed: " + st);
  }
  function C(nt) {
    var st = e["_" + nt];
    return m(st, "Cannot call unknown function " + nt + ", make sure it is exported"), st;
  }
  function y(nt, st, xt, Me, _) {
    var ye = {
      string: function(Lt) {
        var rn = 0;
        if (Lt != null && Lt !== 0) {
          var Wr = (Lt.length << 2) + 1;
          rn = qn(Wr), M(Lt, rn, Wr);
        }
        return rn;
      },
      array: function(Lt) {
        var rn = qn(Lt.length);
        return O(Lt, rn), rn;
      }
    };
    function He(Lt) {
      return st === "string" ? w(Lt) : st === "boolean" ? !!Lt : Lt;
    }
    var ze = C(nt), tt = [], At = 0;
    if (Me)
      for (var pt = 0; pt < Me.length; pt++) {
        var Bt = ye[xt[pt]];
        Bt ? (At === 0 && (At = dr()), tt[pt] = Bt(Me[pt])) : tt[pt] = Me[pt];
      }
    var Rt = ze.apply(null, tt);
    return Rt = He(Rt), At !== 0 && Pt(At), Rt;
  }
  function v(nt, st, xt, Me) {
    xt = xt || [];
    var _ = xt.every(function(He) {
      return He === "number";
    }), ye = st !== "string";
    return ye && _ && !Me ? C(nt) : function() {
      return y(nt, st, xt, arguments);
    };
  }
  var b = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
  function Q(nt, st, xt) {
    for (var Me = st + xt, _ = st; nt[_] && !(_ >= Me); )
      ++_;
    if (_ - st > 16 && nt.subarray && b)
      return b.decode(nt.subarray(st, _));
    for (var ye = ""; st < _; ) {
      var He = nt[st++];
      if (!(He & 128)) {
        ye += String.fromCharCode(He);
        continue;
      }
      var ze = nt[st++] & 63;
      if ((He & 224) == 192) {
        ye += String.fromCharCode((He & 31) << 6 | ze);
        continue;
      }
      var tt = nt[st++] & 63;
      if ((He & 240) == 224 ? He = (He & 15) << 12 | ze << 6 | tt : He = (He & 7) << 18 | ze << 12 | tt << 6 | nt[st++] & 63, He < 65536)
        ye += String.fromCharCode(He);
      else {
        var At = He - 65536;
        ye += String.fromCharCode(55296 | At >> 10, 56320 | At & 1023);
      }
    }
    return ye;
  }
  function w(nt, st) {
    return nt ? Q($, nt, st) : "";
  }
  function R(nt, st, xt, Me) {
    if (!(Me > 0))
      return 0;
    for (var _ = xt, ye = xt + Me - 1, He = 0; He < nt.length; ++He) {
      var ze = nt.charCodeAt(He);
      if (ze >= 55296 && ze <= 57343) {
        var tt = nt.charCodeAt(++He);
        ze = 65536 + ((ze & 1023) << 10) | tt & 1023;
      }
      if (ze <= 127) {
        if (xt >= ye)
          break;
        st[xt++] = ze;
      } else if (ze <= 2047) {
        if (xt + 1 >= ye)
          break;
        st[xt++] = 192 | ze >> 6, st[xt++] = 128 | ze & 63;
      } else if (ze <= 65535) {
        if (xt + 2 >= ye)
          break;
        st[xt++] = 224 | ze >> 12, st[xt++] = 128 | ze >> 6 & 63, st[xt++] = 128 | ze & 63;
      } else {
        if (xt + 3 >= ye)
          break;
        st[xt++] = 240 | ze >> 18, st[xt++] = 128 | ze >> 12 & 63, st[xt++] = 128 | ze >> 6 & 63, st[xt++] = 128 | ze & 63;
      }
    }
    return st[xt] = 0, xt - _;
  }
  function M(nt, st, xt) {
    return R(nt, $, st, xt);
  }
  typeof TextDecoder < "u" && new TextDecoder("utf-16le");
  function O(nt, st) {
    k.set(nt, st);
  }
  function L(nt, st) {
    return nt % st > 0 && (nt += st - nt % st), nt;
  }
  var N, k, $, U, X, K, z;
  function Y(nt) {
    N = nt, e.HEAP8 = k = new Int8Array(nt), e.HEAP16 = U = new Int16Array(nt), e.HEAP32 = X = new Int32Array(nt), e.HEAPU8 = $ = new Uint8Array(nt), e.HEAPU16 = new Uint16Array(nt), e.HEAPU32 = new Uint32Array(nt), e.HEAPF32 = K = new Float32Array(nt), e.HEAPF64 = z = new Float64Array(nt);
  }
  var V = 5266928, Z = 24016, ce = e.TOTAL_MEMORY || 33554432;
  e.buffer ? N = e.buffer : N = new ArrayBuffer(ce), ce = N.byteLength, Y(N), X[Z >> 2] = V;
  function ee(nt) {
    for (; nt.length > 0; ) {
      var st = nt.shift();
      if (typeof st == "function") {
        st();
        continue;
      }
      var xt = st.func;
      typeof xt == "number" ? st.arg === void 0 ? e.dynCall_v(xt) : e.dynCall_vi(xt, st.arg) : xt(st.arg === void 0 ? null : st.arg);
    }
  }
  var pe = [], Ce = [], Be = [], Ie = [];
  function Qe() {
    if (e.preRun)
      for (typeof e.preRun == "function" && (e.preRun = [e.preRun]); e.preRun.length; )
        Ue(e.preRun.shift());
    ee(pe);
  }
  function xe() {
    ee(Ce);
  }
  function Se() {
    ee(Be);
  }
  function De() {
    if (e.postRun)
      for (typeof e.postRun == "function" && (e.postRun = [e.postRun]); e.postRun.length; )
        Te(e.postRun.shift());
    ee(Ie);
  }
  function Ue(nt) {
    pe.unshift(nt);
  }
  function Te(nt) {
    Ie.unshift(nt);
  }
  var se = Math.abs, fe = Math.ceil, W = Math.floor, ge = Math.min, _e = 0, Re = null;
  function Ee(nt) {
    _e++, e.monitorRunDependencies && e.monitorRunDependencies(_e);
  }
  function oe(nt) {
    if (_e--, e.monitorRunDependencies && e.monitorRunDependencies(_e), _e == 0 && Re) {
      var st = Re;
      Re = null, st();
    }
  }
  e.preloadedImages = {}, e.preloadedAudios = {};
  var ie = null, Ae = "data:application/octet-stream;base64,";
  function de(nt) {
    return String.prototype.startsWith ? nt.startsWith(Ae) : nt.indexOf(Ae) === 0;
  }
  var we, Pe;
  ie = "data:application/octet-stream;base64,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";
  var qe = 24032;
  function ke(nt) {
    return nt;
  }
  function Xe(nt) {
    var st = /\b__Z[\w\d_]+/g;
    return nt.replace(st, function(xt) {
      var Me = xt;
      return xt === Me ? xt : Me + " [" + xt + "]";
    });
  }
  function rt() {
    var nt = new Error();
    if (!nt.stack) {
      try {
        throw new Error(0);
      } catch (st) {
        nt = st;
      }
      if (!nt.stack)
        return "(no stack trace available)";
    }
    return nt.stack.toString();
  }
  function it() {
    var nt = rt();
    return e.extraStackTrace && (nt += `
` + e.extraStackTrace()), Xe(nt);
  }
  function ht(nt, st, xt, Me) {
    vn("Assertion failed: " + w(nt) + ", at: " + [st ? w(st) : "unknown filename", xt, Me ? w(Me) : "unknown function"]);
  }
  function mt() {
    return k.length;
  }
  function _t(nt, st, xt) {
    $.set($.subarray(st, st + xt), nt);
  }
  function Ct(nt) {
    return e.___errno_location && (X[e.___errno_location() >> 2] = nt), nt;
  }
  function zt(nt) {
    vn("OOM");
  }
  function jt(nt) {
    try {
      var st = new ArrayBuffer(nt);
      return st.byteLength != nt ? void 0 : (new Int8Array(st).set(k), En(st), Y(st), 1);
    } catch {
    }
  }
  function lt(nt) {
    var st = mt(), xt = 16777216, Me = 2147483648 - xt;
    if (nt > Me)
      return !1;
    for (var _ = 16777216, ye = Math.max(st, _); ye < nt; )
      ye <= 536870912 ? ye = L(2 * ye, xt) : ye = Math.min(L((3 * ye + 2147483648) / 4, xt), Me);
    var He = jt(ye);
    return !!He;
  }
  var Ht = typeof atob == "function" ? atob : function(nt) {
    var st = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", xt = "", Me, _, ye, He, ze, tt, At, pt = 0;
    nt = nt.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    do
      He = st.indexOf(nt.charAt(pt++)), ze = st.indexOf(nt.charAt(pt++)), tt = st.indexOf(nt.charAt(pt++)), At = st.indexOf(nt.charAt(pt++)), Me = He << 2 | ze >> 4, _ = (ze & 15) << 4 | tt >> 2, ye = (tt & 3) << 6 | At, xt = xt + String.fromCharCode(Me), tt !== 64 && (xt = xt + String.fromCharCode(_)), At !== 64 && (xt = xt + String.fromCharCode(ye));
    while (pt < nt.length);
    return xt;
  };
  function vt(nt) {
    try {
      for (var st = Ht(nt), xt = new Uint8Array(st.length), Me = 0; Me < st.length; ++Me)
        xt[Me] = st.charCodeAt(Me);
      return xt;
    } catch {
      throw new Error("Converting base64 string to bytes failed.");
    }
  }
  function It(nt) {
    if (de(nt))
      return vt(nt.slice(Ae.length));
  }
  var un = {
    Math,
    Int8Array,
    Int32Array,
    Uint8Array,
    Float32Array,
    Float64Array
  }, hn = {
    a: vn,
    b: c,
    c: u,
    d: ht,
    e: Ct,
    f: mt,
    g: _t,
    h: lt,
    i: zt,
    j: ke,
    k: Xe,
    l: jt,
    m: rt,
    n: it,
    o: qe,
    p: Z
  }, We = (
    /** @suppress {uselessCode} */
    function(nt, st, xt) {
      "almost asm";
      var Me = new nt.Int8Array(xt), _ = new nt.Int32Array(xt);
      new nt.Uint8Array(xt), new nt.Float32Array(xt);
      var ye = new nt.Float64Array(xt), He = st.p | 0, ze = nt.Math.floor, tt = nt.Math.abs, At = nt.Math.sqrt, pt = nt.Math.pow, Bt = nt.Math.cos, Rt = nt.Math.sin, Lt = nt.Math.tan, rn = nt.Math.acos, Wr = nt.Math.asin, pr = nt.Math.atan, Vt = nt.Math.atan2, Sn = nt.Math.ceil, kn = nt.Math.imul, vr = nt.Math.min, Tr = nt.Math.clz32, $t = st.b, Ye = st.c, en = st.d, Ir = st.e, zr = st.f, In = st.g, mr = st.h, Mr = st.i, $e = 24048;
      function Ps(S) {
        return Me = new Int8Array(S), _ = new Int32Array(S), ye = new Float64Array(S), xt = S, !0;
      }
      function Wn(S) {
        S = S | 0;
        var x = 0;
        return x = $e, $e = $e + S | 0, $e = $e + 15 & -16, x | 0;
      }
      function Is() {
        return $e | 0;
      }
      function Ao(S) {
        S = S | 0, $e = S;
      }
      function hc(S, x) {
        S = S | 0, $e = S;
      }
      function or(S) {
        return S = S | 0, (kn(S * 3 | 0, S + 1 | 0) | 0) + 1 | 0;
      }
      function ml(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0;
        Wa(S, x, T, P, 0) | 0 && (J = (kn(T * 3 | 0, T + 1 | 0) | 0) + 1 | 0, Ys(P | 0, 0, J << 3 | 0) | 0, H = bA(J, 4) | 0, H && (Ki(S, x, T, P, H, J, 0), Or(H)));
      }
      function dc(S, x, T, P, H) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0;
        var J = 0;
        if (Wa(S, x, T, P, H) | 0) {
          if (J = (kn(T * 3 | 0, T + 1 | 0) | 0) + 1 | 0, Ys(P | 0, 0, J << 3 | 0) | 0, H | 0) {
            Ys(H | 0, 0, J << 2 | 0) | 0, Ki(S, x, T, P, H, J, 0);
            return;
          }
          H = bA(J, 4) | 0, H && (Ki(S, x, T, P, H, J, 0), Or(H));
        }
      }
      function Wa(S, x, T, P, H) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0;
        var J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0;
        if (he = $e, $e = $e + 16 | 0, te = he, J = P, _[J >> 2] = S, _[J + 4 >> 2] = x, J = (H | 0) != 0, J && (_[H >> 2] = 0), Fi(S, x) | 0)
          return te = 1, $e = he, te | 0;
        _[te >> 2] = 0;
        e:
          do
            if ((T | 0) >= 1)
              if (J)
                for (B = 0, D = 1, j = 1, g = 0, J = S; ; ) {
                  if (!(g | B)) {
                    if (J = Ne(J, x, 4, te) | 0, x = Ye() | 0, (J | 0) == 0 & (x | 0) == 0) {
                      J = 2;
                      break e;
                    }
                    if (Fi(J, x) | 0) {
                      J = 1;
                      break e;
                    }
                  }
                  if (J = Ne(J, x, _[16 + (B << 2) >> 2] | 0, te) | 0, x = Ye() | 0, (J | 0) == 0 & (x | 0) == 0) {
                    J = 2;
                    break e;
                  }
                  if (S = P + (j << 3) | 0, _[S >> 2] = J, _[S + 4 >> 2] = x, _[H + (j << 2) >> 2] = D, g = g + 1 | 0, S = (g | 0) == (D | 0), p = B + 1 | 0, E = (p | 0) == 6, Fi(J, x) | 0) {
                    J = 1;
                    break e;
                  }
                  if (D = D + (E & S & 1) | 0, (D | 0) > (T | 0)) {
                    J = 0;
                    break;
                  } else
                    B = S ? E ? 0 : p : B, j = j + 1 | 0, g = S ? 0 : g;
                }
              else
                for (B = 0, D = 1, j = 1, g = 0, J = S; ; ) {
                  if (!(g | B)) {
                    if (J = Ne(J, x, 4, te) | 0, x = Ye() | 0, (J | 0) == 0 & (x | 0) == 0) {
                      J = 2;
                      break e;
                    }
                    if (Fi(J, x) | 0) {
                      J = 1;
                      break e;
                    }
                  }
                  if (J = Ne(J, x, _[16 + (B << 2) >> 2] | 0, te) | 0, x = Ye() | 0, (J | 0) == 0 & (x | 0) == 0) {
                    J = 2;
                    break e;
                  }
                  if (S = P + (j << 3) | 0, _[S >> 2] = J, _[S + 4 >> 2] = x, g = g + 1 | 0, S = (g | 0) == (D | 0), p = B + 1 | 0, E = (p | 0) == 6, Fi(J, x) | 0) {
                    J = 1;
                    break e;
                  }
                  if (D = D + (E & S & 1) | 0, (D | 0) > (T | 0)) {
                    J = 0;
                    break;
                  } else
                    B = S ? E ? 0 : p : B, j = j + 1 | 0, g = S ? 0 : g;
                }
            else
              J = 0;
          while (0);
        return te = J, $e = he, te | 0;
      }
      function Ki(S, x, T, P, H, J, g) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0, J = J | 0, g = g | 0;
        var p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0;
        if (j = $e, $e = $e + 16 | 0, D = j, (S | 0) == 0 & (x | 0) == 0) {
          $e = j;
          return;
        }
        if (p = ka(S | 0, x | 0, J | 0, ((J | 0) < 0) << 31 >> 31 | 0) | 0, Ye() | 0, E = P + (p << 3) | 0, te = E, he = _[te >> 2] | 0, te = _[te + 4 >> 2] | 0, B = (he | 0) == (S | 0) & (te | 0) == (x | 0), !((he | 0) == 0 & (te | 0) == 0 | B))
          do
            p = (p + 1 | 0) % (J | 0) | 0, E = P + (p << 3) | 0, he = E, te = _[he >> 2] | 0, he = _[he + 4 >> 2] | 0, B = (te | 0) == (S | 0) & (he | 0) == (x | 0);
          while (!((te | 0) == 0 & (he | 0) == 0 | B));
        if (p = H + (p << 2) | 0, B && (_[p >> 2] | 0) <= (g | 0)) {
          $e = j;
          return;
        }
        if (he = E, _[he >> 2] = S, _[he + 4 >> 2] = x, _[p >> 2] = g, (g | 0) >= (T | 0)) {
          $e = j;
          return;
        }
        he = g + 1 | 0, _[D >> 2] = 0, te = Ne(S, x, 2, D) | 0, Ki(te, Ye() | 0, T, P, H, J, he), _[D >> 2] = 0, te = Ne(S, x, 3, D) | 0, Ki(te, Ye() | 0, T, P, H, J, he), _[D >> 2] = 0, te = Ne(S, x, 1, D) | 0, Ki(te, Ye() | 0, T, P, H, J, he), _[D >> 2] = 0, te = Ne(S, x, 5, D) | 0, Ki(te, Ye() | 0, T, P, H, J, he), _[D >> 2] = 0, te = Ne(S, x, 4, D) | 0, Ki(te, Ye() | 0, T, P, H, J, he), _[D >> 2] = 0, te = Ne(S, x, 6, D) | 0, Ki(te, Ye() | 0, T, P, H, J, he), $e = j;
      }
      function Ne(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0;
        if ((_[P >> 2] | 0) > 0) {
          H = 0;
          do
            T = Wf(T) | 0, H = H + 1 | 0;
          while ((H | 0) < (_[P >> 2] | 0));
        }
        p = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, E = p & 127, J = vi(S, x) | 0, H = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, H = H & 15;
        e:
          do
            if (!H)
              g = 6;
            else
              for (; ; ) {
                if (j = (15 - H | 0) * 3 | 0, te = Yt(S | 0, x | 0, j | 0) | 0, Ye() | 0, te = te & 7, he = (Oa(H) | 0) == 0, H = H + -1 | 0, D = gn(7, 0, j | 0) | 0, x = x & ~(Ye() | 0), j = gn(_[(he ? 464 : 48) + (te * 28 | 0) + (T << 2) >> 2] | 0, 0, j | 0) | 0, B = Ye() | 0, T = _[(he ? 672 : 256) + (te * 28 | 0) + (T << 2) >> 2] | 0, S = j | S & ~D, x = B | x, !T) {
                  T = 0;
                  break e;
                }
                if (!H) {
                  g = 6;
                  break;
                }
              }
          while (0);
        (g | 0) == 6 && (he = _[880 + (E * 28 | 0) + (T << 2) >> 2] | 0, te = gn(he | 0, 0, 45) | 0, S = te | S, x = Ye() | 0 | x & -1040385, T = _[4304 + (E * 28 | 0) + (T << 2) >> 2] | 0, (he & 127 | 0) == 127 && (he = gn(_[880 + (E * 28 | 0) + 20 >> 2] | 0, 0, 45) | 0, x = Ye() | 0 | x & -1040385, T = _[4304 + (E * 28 | 0) + 20 >> 2] | 0, S = Hs(he | S, x) | 0, x = Ye() | 0, _[P >> 2] = (_[P >> 2] | 0) + 1)), g = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, g = g & 127;
        e:
          do
            if (nn(g) | 0) {
              t:
                do
                  if ((vi(S, x) | 0) == 1) {
                    if ((E | 0) != (g | 0))
                      if (na(g, _[7728 + (E * 28 | 0) >> 2] | 0) | 0) {
                        S = $s(S, x) | 0, J = 1, x = Ye() | 0;
                        break;
                      } else {
                        S = Hs(S, x) | 0, J = 1, x = Ye() | 0;
                        break;
                      }
                    switch (J | 0) {
                      case 5: {
                        S = $s(S, x) | 0, x = Ye() | 0, _[P >> 2] = (_[P >> 2] | 0) + 5, J = 0;
                        break t;
                      }
                      case 3: {
                        S = Hs(S, x) | 0, x = Ye() | 0, _[P >> 2] = (_[P >> 2] | 0) + 1, J = 0;
                        break t;
                      }
                      default:
                        return te = 0, he = 0, $t(te | 0), he | 0;
                    }
                  } else
                    J = 0;
                while (0);
              if ((T | 0) > 0) {
                H = 0;
                do
                  S = vc(S, x) | 0, x = Ye() | 0, H = H + 1 | 0;
                while ((H | 0) != (T | 0));
              }
              if ((E | 0) != (g | 0)) {
                if (!(Xn(g) | 0)) {
                  if ((J | 0) != 0 | (vi(S, x) | 0) != 5)
                    break;
                  _[P >> 2] = (_[P >> 2] | 0) + 1;
                  break;
                }
                switch (p & 127) {
                  case 8:
                  case 118:
                    break e;
                }
                (vi(S, x) | 0) != 3 && (_[P >> 2] = (_[P >> 2] | 0) + 1);
              }
            } else if ((T | 0) > 0) {
              H = 0;
              do
                S = Hs(S, x) | 0, x = Ye() | 0, H = H + 1 | 0;
              while ((H | 0) != (T | 0));
            }
          while (0);
        return _[P >> 2] = ((_[P >> 2] | 0) + T | 0) % 6 | 0, te = x, he = S, $t(te | 0), he | 0;
      }
      function Fe(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0;
        if (j = $e, $e = $e + 16 | 0, D = j, !T)
          return D = P, _[D >> 2] = S, _[D + 4 >> 2] = x, D = 0, $e = j, D | 0;
        _[D >> 2] = 0;
        e:
          do
            if (Fi(S, x) | 0)
              S = 1;
            else {
              if (J = (T | 0) > 0, J) {
                H = 0, B = S;
                do {
                  if (B = Ne(B, x, 4, D) | 0, x = Ye() | 0, (B | 0) == 0 & (x | 0) == 0) {
                    S = 2;
                    break e;
                  }
                  if (H = H + 1 | 0, Fi(B, x) | 0) {
                    S = 1;
                    break e;
                  }
                } while ((H | 0) < (T | 0));
                if (E = P, _[E >> 2] = B, _[E + 4 >> 2] = x, E = T + -1 | 0, J) {
                  J = 0, g = 1, H = B, S = x;
                  do {
                    if (H = Ne(H, S, 2, D) | 0, S = Ye() | 0, (H | 0) == 0 & (S | 0) == 0) {
                      S = 2;
                      break e;
                    }
                    if (p = P + (g << 3) | 0, _[p >> 2] = H, _[p + 4 >> 2] = S, g = g + 1 | 0, Fi(H, S) | 0) {
                      S = 1;
                      break e;
                    }
                    J = J + 1 | 0;
                  } while ((J | 0) < (T | 0));
                  p = 0, J = g;
                  do {
                    if (H = Ne(H, S, 3, D) | 0, S = Ye() | 0, (H | 0) == 0 & (S | 0) == 0) {
                      S = 2;
                      break e;
                    }
                    if (g = P + (J << 3) | 0, _[g >> 2] = H, _[g + 4 >> 2] = S, J = J + 1 | 0, Fi(H, S) | 0) {
                      S = 1;
                      break e;
                    }
                    p = p + 1 | 0;
                  } while ((p | 0) < (T | 0));
                  g = 0;
                  do {
                    if (H = Ne(H, S, 1, D) | 0, S = Ye() | 0, (H | 0) == 0 & (S | 0) == 0) {
                      S = 2;
                      break e;
                    }
                    if (p = P + (J << 3) | 0, _[p >> 2] = H, _[p + 4 >> 2] = S, J = J + 1 | 0, Fi(H, S) | 0) {
                      S = 1;
                      break e;
                    }
                    g = g + 1 | 0;
                  } while ((g | 0) < (T | 0));
                  g = 0;
                  do {
                    if (H = Ne(H, S, 5, D) | 0, S = Ye() | 0, (H | 0) == 0 & (S | 0) == 0) {
                      S = 2;
                      break e;
                    }
                    if (p = P + (J << 3) | 0, _[p >> 2] = H, _[p + 4 >> 2] = S, J = J + 1 | 0, Fi(H, S) | 0) {
                      S = 1;
                      break e;
                    }
                    g = g + 1 | 0;
                  } while ((g | 0) < (T | 0));
                  g = 0;
                  do {
                    if (H = Ne(H, S, 4, D) | 0, S = Ye() | 0, (H | 0) == 0 & (S | 0) == 0) {
                      S = 2;
                      break e;
                    }
                    if (p = P + (J << 3) | 0, _[p >> 2] = H, _[p + 4 >> 2] = S, J = J + 1 | 0, Fi(H, S) | 0) {
                      S = 1;
                      break e;
                    }
                    g = g + 1 | 0;
                  } while ((g | 0) < (T | 0));
                  for (g = 0; ; ) {
                    if (H = Ne(H, S, 6, D) | 0, S = Ye() | 0, (H | 0) == 0 & (S | 0) == 0) {
                      S = 2;
                      break e;
                    }
                    if ((g | 0) != (E | 0))
                      if (p = P + (J << 3) | 0, _[p >> 2] = H, _[p + 4 >> 2] = S, !(Fi(H, S) | 0))
                        J = J + 1 | 0;
                      else {
                        S = 1;
                        break e;
                      }
                    if (g = g + 1 | 0, (g | 0) >= (T | 0)) {
                      g = B, J = x;
                      break;
                    }
                  }
                } else
                  g = B, H = B, J = x, S = x;
              } else
                g = P, _[g >> 2] = S, _[g + 4 >> 2] = x, g = S, H = S, J = x, S = x;
              S = ((g | 0) != (H | 0) | (J | 0) != (S | 0)) & 1;
            }
          while (0);
        return D = S, $e = j, D | 0;
      }
      function Ze(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        if (J = $e, $e = $e + 48 | 0, H = J + 8 | 0, P = J, p = S, g = _[p + 4 >> 2] | 0, T = P, _[T >> 2] = _[p >> 2], _[T + 4 >> 2] = g, Za(P, H), H = Ic(H, x) | 0, x = _[P >> 2] | 0, P = _[S + 8 >> 2] | 0, (P | 0) <= 0)
          return p = x, g = (H | 0) < (p | 0), p = g ? p : H, p = p + 12 | 0, $e = J, p | 0;
        T = _[S + 12 >> 2] | 0, S = 0;
        do
          x = (_[T + (S << 3) >> 2] | 0) + x | 0, S = S + 1 | 0;
        while ((S | 0) < (P | 0));
        return p = (H | 0) < (x | 0), p = p ? x : H, p = p + 12 | 0, $e = J, p | 0;
      }
      function Ve(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0, E = 0;
        if (p = $e, $e = $e + 48 | 0, P = p + 8 | 0, H = p, !(Mt(S, x, T) | 0)) {
          $e = p;
          return;
        }
        if (E = S, J = _[E + 4 >> 2] | 0, g = H, _[g >> 2] = _[E >> 2], _[g + 4 >> 2] = J, Za(H, P), g = Ic(P, x) | 0, x = _[H >> 2] | 0, J = _[S + 8 >> 2] | 0, (J | 0) > 0) {
          H = _[S + 12 >> 2] | 0, P = 0;
          do
            x = (_[H + (P << 3) >> 2] | 0) + x | 0, P = P + 1 | 0;
          while ((P | 0) != (J | 0));
        }
        if (x = (g | 0) < (x | 0) ? x : g, (x | 0) <= -12) {
          $e = p;
          return;
        }
        E = x + 11 | 0, Ys(T | 0, 0, (((E | 0) > 0 ? E : 0) << 3) + 8 | 0) | 0, $e = p;
      }
      function Mt(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0, Le = 0, Je = 0, et = 0, Ke = 0, ot = 0, je = 0, Et = 0, Gt = 0, kt = 0, bt = 0, Yn = 0, Hr = 0, li = 0, Ui = 0, hi = 0, Zi = 0, Bo = 0, xr = 0;
        if (xr = $e, $e = $e + 112 | 0, Ui = xr + 80 | 0, E = xr + 72 | 0, hi = xr, Zi = xr + 56 | 0, B = S + 8 | 0, Bo = BA((_[B >> 2] << 5) + 32 | 0) | 0, Bo || en(22848, 22448, 800, 22456), Yo(S, Bo), J = S, P = _[J + 4 >> 2] | 0, p = E, _[p >> 2] = _[J >> 2], _[p + 4 >> 2] = P, Za(E, Ui), p = Ic(Ui, x) | 0, P = _[E >> 2] | 0, J = _[B >> 2] | 0, (J | 0) > 0) {
          g = _[S + 12 >> 2] | 0, H = 0;
          do
            P = (_[g + (H << 3) >> 2] | 0) + P | 0, H = H + 1 | 0;
          while ((H | 0) != (J | 0));
        }
        if (p = (p | 0) < (P | 0) ? P : p, li = p + 12 | 0, H = bA(li, 8) | 0, D = bA(li, 8) | 0, _[Ui >> 2] = 0, Yn = S, Hr = _[Yn + 4 >> 2] | 0, P = E, _[P >> 2] = _[Yn >> 2], _[P + 4 >> 2] = Hr, P = An(E, li, x, Ui, H, D) | 0, P | 0)
          return Or(H), Or(D), Or(Bo), Bo = P, $e = xr, Bo | 0;
        e:
          do
            if ((_[B >> 2] | 0) > 0) {
              for (J = S + 12 | 0, P = 0; g = An((_[J >> 2] | 0) + (P << 3) | 0, li, x, Ui, H, D) | 0, P = P + 1 | 0, !(g | 0); )
                if ((P | 0) >= (_[B >> 2] | 0))
                  break e;
              return Or(H), Or(D), Or(Bo), Bo = g, $e = xr, Bo | 0;
            }
          while (0);
        (p | 0) > -12 && Ys(D | 0, 0, ((li | 0) > 1 ? li : 1) << 3 | 0) | 0;
        e:
          do
            if ((_[Ui >> 2] | 0) > 0) {
              Hr = ((li | 0) < 0) << 31 >> 31, je = H, Et = D, Gt = H, kt = H, bt = D, Yn = H, P = H, Je = H, et = D, Ke = D, ot = D, H = D;
              t:
                for (; ; ) {
                  for (Le = _[Ui >> 2] | 0, he = 0, ve = 0, J = 0; ; ) {
                    g = hi, p = g + 56 | 0;
                    do
                      _[g >> 2] = 0, g = g + 4 | 0;
                    while ((g | 0) < (p | 0));
                    if (x = je + (he << 3) | 0, E = _[x >> 2] | 0, x = _[x + 4 >> 2] | 0, Wa(E, x, 1, hi, 0) | 0) {
                      g = hi, p = g + 56 | 0;
                      do
                        _[g >> 2] = 0, g = g + 4 | 0;
                      while ((g | 0) < (p | 0));
                      g = bA(7, 4) | 0, g | 0 && (Ki(E, x, 1, hi, g, 7, 0), Or(g));
                    }
                    te = 0;
                    do {
                      j = hi + (te << 3) | 0, D = _[j >> 2] | 0, j = _[j + 4 >> 2] | 0;
                      n:
                        do
                          if (!((D | 0) == 0 & (j | 0) == 0)) {
                            if (E = ka(D | 0, j | 0, li | 0, Hr | 0) | 0, Ye() | 0, g = T + (E << 3) | 0, p = g, x = _[p >> 2] | 0, p = _[p + 4 >> 2] | 0, !((x | 0) == 0 & (p | 0) == 0))
                              for (B = 0; ; ) {
                                if ((B | 0) > (li | 0))
                                  break t;
                                if ((x | 0) == (D | 0) & (p | 0) == (j | 0))
                                  break n;
                                if (E = (E + 1 | 0) % (li | 0) | 0, g = T + (E << 3) | 0, p = g, x = _[p >> 2] | 0, p = _[p + 4 >> 2] | 0, (x | 0) == 0 & (p | 0) == 0)
                                  break;
                                B = B + 1 | 0;
                              }
                            (D | 0) == 0 & (j | 0) == 0 || (JA(D, j, Zi), eA(S, Bo, Zi) | 0 && (B = g, _[B >> 2] = D, _[B + 4 >> 2] = j, B = Et + (J << 3) | 0, _[B >> 2] = D, _[B + 4 >> 2] = j, J = J + 1 | 0));
                          }
                        while (0);
                      te = te + 1 | 0;
                    } while (te >>> 0 < 7);
                    if (ve = ve + 1 | 0, (ve | 0) >= (Le | 0))
                      break;
                    he = he + 1 | 0;
                  }
                  if ((Le | 0) > 0 && Ys(Gt | 0, 0, Le << 3 | 0) | 0, _[Ui >> 2] = J, (J | 0) > 0)
                    D = H, j = ot, te = Yn, he = Ke, ve = et, Le = Et, H = Je, ot = P, Ke = kt, et = Gt, Je = D, P = j, Yn = bt, bt = te, kt = he, Gt = ve, Et = je, je = Le;
                  else
                    break e;
                }
              return Or(kt), Or(bt), Or(Bo), Bo = -1, $e = xr, Bo | 0;
            } else
              P = D;
          while (0);
        return Or(Bo), Or(H), Or(P), Bo = 0, $e = xr, Bo | 0;
      }
      function An(S, x, T, P, H, J) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0, J = J | 0;
        var g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0, Le = 0, Je = 0, et = 0, Ke = 0, ot = 0, je = 0, Et = 0, Gt = 0, kt = 0, bt = 0, Yn = 0, Hr = 0, li = 0, Ui = 0;
        if (Hr = $e, $e = $e + 48 | 0, Gt = Hr + 32 | 0, kt = Hr + 16 | 0, bt = Hr, g = _[S >> 2] | 0, (g | 0) <= 0)
          return Yn = 0, $e = Hr, Yn | 0;
        et = S + 4 | 0, Ke = Gt + 8 | 0, ot = kt + 8 | 0, je = bt + 8 | 0, Et = ((x | 0) < 0) << 31 >> 31, Je = 0;
        e:
          for (; ; ) {
            p = _[et >> 2] | 0, ve = p + (Je << 4) | 0, _[Gt >> 2] = _[ve >> 2], _[Gt + 4 >> 2] = _[ve + 4 >> 2], _[Gt + 8 >> 2] = _[ve + 8 >> 2], _[Gt + 12 >> 2] = _[ve + 12 >> 2], (Je | 0) == (g + -1 | 0) ? (_[kt >> 2] = _[p >> 2], _[kt + 4 >> 2] = _[p + 4 >> 2], _[kt + 8 >> 2] = _[p + 8 >> 2], _[kt + 12 >> 2] = _[p + 12 >> 2]) : (ve = p + (Je + 1 << 4) | 0, _[kt >> 2] = _[ve >> 2], _[kt + 4 >> 2] = _[ve + 4 >> 2], _[kt + 8 >> 2] = _[ve + 8 >> 2], _[kt + 12 >> 2] = _[ve + 12 >> 2]), ve = Li(Gt, kt, T) | 0;
            t:
              do
                if ((ve | 0) > 0) {
                  Le = +(ve | 0), he = 0;
                  n:
                    for (; ; ) {
                      Ui = +(ve - he | 0), li = +(he | 0), ye[bt >> 3] = +ye[Gt >> 3] * Ui / Le + +ye[kt >> 3] * li / Le, ye[je >> 3] = +ye[Ke >> 3] * Ui / Le + +ye[ot >> 3] * li / Le, j = ah(bt, T) | 0, te = Ye() | 0, p = ka(j | 0, te | 0, x | 0, Et | 0) | 0, Ye() | 0, g = J + (p << 3) | 0, E = g, B = _[E >> 2] | 0, E = _[E + 4 >> 2] | 0;
                      r:
                        do
                          if ((B | 0) == 0 & (E | 0) == 0)
                            Yn = 14;
                          else
                            for (D = 0; ; ) {
                              if ((D | 0) > (x | 0)) {
                                g = 1;
                                break r;
                              }
                              if ((B | 0) == (j | 0) & (E | 0) == (te | 0)) {
                                g = 7;
                                break r;
                              }
                              if (p = (p + 1 | 0) % (x | 0) | 0, g = J + (p << 3) | 0, E = g, B = _[E >> 2] | 0, E = _[E + 4 >> 2] | 0, (B | 0) == 0 & (E | 0) == 0) {
                                Yn = 14;
                                break;
                              } else
                                D = D + 1 | 0;
                            }
                        while (0);
                      switch ((Yn | 0) == 14 && (Yn = 0, (j | 0) == 0 & (te | 0) == 0 ? g = 7 : (_[g >> 2] = j, _[g + 4 >> 2] = te, g = _[P >> 2] | 0, D = H + (g << 3) | 0, _[D >> 2] = j, _[D + 4 >> 2] = te, _[P >> 2] = g + 1, g = 0)), g & 7) {
                        case 7:
                        case 0:
                          break;
                        default:
                          break n;
                      }
                      if (he = he + 1 | 0, (ve | 0) <= (he | 0)) {
                        Yn = 8;
                        break t;
                      }
                    }
                  if (g | 0) {
                    g = -1, Yn = 20;
                    break e;
                  }
                } else
                  Yn = 8;
              while (0);
            if ((Yn | 0) == 8 && (Yn = 0), Je = Je + 1 | 0, g = _[S >> 2] | 0, (Je | 0) >= (g | 0)) {
              g = 0, Yn = 20;
              break;
            }
          }
        return (Yn | 0) == 20 ? ($e = Hr, g | 0) : 0;
      }
      function lr(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0;
        if (B = $e, $e = $e + 176 | 0, E = B, (x | 0) < 1) {
          Xi(T, 0, 0), $e = B;
          return;
        }
        g = S, g = Yt(_[g >> 2] | 0, _[g + 4 >> 2] | 0, 52) | 0, Ye() | 0, Xi(T, (x | 0) > 6 ? x : 6, g & 15), g = 0;
        do {
          if (P = S + (g << 3) | 0, ia(_[P >> 2] | 0, _[P + 4 >> 2] | 0, E), P = _[E >> 2] | 0, (P | 0) > 0) {
            p = 0;
            do
              J = E + 8 + (p << 4) | 0, p = p + 1 | 0, P = E + 8 + (((p | 0) % (P | 0) | 0) << 4) | 0, H = Cm(T, P, J) | 0, H ? va(T, H) | 0 : sy(T, J, P) | 0, P = _[E >> 2] | 0;
            while ((p | 0) < (P | 0));
          }
          g = g + 1 | 0;
        } while ((g | 0) != (x | 0));
        $e = B;
      }
      function lo(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0;
        if (J = $e, $e = $e + 32 | 0, P = J, H = J + 16 | 0, lr(S, x, H), _[T >> 2] = 0, _[T + 4 >> 2] = 0, _[T + 8 >> 2] = 0, S = jd(H) | 0, !S) {
          os(T) | 0, js(H), $e = J;
          return;
        }
        do {
          x = $1(T) | 0;
          do
            Zu(x, S) | 0, g = S + 16 | 0, _[P >> 2] = _[g >> 2], _[P + 4 >> 2] = _[g + 4 >> 2], _[P + 8 >> 2] = _[g + 8 >> 2], _[P + 12 >> 2] = _[g + 12 >> 2], va(H, S) | 0, S = po(H, P) | 0;
          while (S | 0);
          S = jd(H) | 0;
        } while (S | 0);
        os(T) | 0, js(H), $e = J;
      }
      function nn(S) {
        return S = S | 0, _[7728 + (S * 28 | 0) + 16 >> 2] | 0;
      }
      function Xn(S) {
        return S = S | 0, (S | 0) == 4 | (S | 0) == 117 | 0;
      }
      function Zn(S) {
        return S = S | 0, _[11152 + ((_[S >> 2] | 0) * 216 | 0) + ((_[S + 4 >> 2] | 0) * 72 | 0) + ((_[S + 8 >> 2] | 0) * 24 | 0) + (_[S + 12 >> 2] << 3) >> 2] | 0;
      }
      function Wi(S) {
        return S = S | 0, _[11152 + ((_[S >> 2] | 0) * 216 | 0) + ((_[S + 4 >> 2] | 0) * 72 | 0) + ((_[S + 8 >> 2] | 0) * 24 | 0) + (_[S + 12 >> 2] << 3) + 4 >> 2] | 0;
      }
      function To(S, x) {
        S = S | 0, x = x | 0, S = 7728 + (S * 28 | 0) | 0, _[x >> 2] = _[S >> 2], _[x + 4 >> 2] = _[S + 4 >> 2], _[x + 8 >> 2] = _[S + 8 >> 2], _[x + 12 >> 2] = _[S + 12 >> 2];
      }
      function pm(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0;
        if (x >>> 0 > 20)
          return x = -1, x | 0;
        do
          if ((_[11152 + (x * 216 | 0) >> 2] | 0) != (S | 0))
            if ((_[11152 + (x * 216 | 0) + 8 >> 2] | 0) != (S | 0))
              if ((_[11152 + (x * 216 | 0) + 16 >> 2] | 0) != (S | 0))
                if ((_[11152 + (x * 216 | 0) + 24 >> 2] | 0) != (S | 0))
                  if ((_[11152 + (x * 216 | 0) + 32 >> 2] | 0) != (S | 0))
                    if ((_[11152 + (x * 216 | 0) + 40 >> 2] | 0) != (S | 0))
                      if ((_[11152 + (x * 216 | 0) + 48 >> 2] | 0) != (S | 0))
                        if ((_[11152 + (x * 216 | 0) + 56 >> 2] | 0) != (S | 0))
                          if ((_[11152 + (x * 216 | 0) + 64 >> 2] | 0) != (S | 0))
                            if ((_[11152 + (x * 216 | 0) + 72 >> 2] | 0) != (S | 0))
                              if ((_[11152 + (x * 216 | 0) + 80 >> 2] | 0) != (S | 0))
                                if ((_[11152 + (x * 216 | 0) + 88 >> 2] | 0) != (S | 0))
                                  if ((_[11152 + (x * 216 | 0) + 96 >> 2] | 0) != (S | 0))
                                    if ((_[11152 + (x * 216 | 0) + 104 >> 2] | 0) != (S | 0))
                                      if ((_[11152 + (x * 216 | 0) + 112 >> 2] | 0) != (S | 0))
                                        if ((_[11152 + (x * 216 | 0) + 120 >> 2] | 0) != (S | 0))
                                          if ((_[11152 + (x * 216 | 0) + 128 >> 2] | 0) != (S | 0))
                                            if ((_[11152 + (x * 216 | 0) + 136 >> 2] | 0) == (S | 0))
                                              S = 2, T = 1, P = 2;
                                            else {
                                              if ((_[11152 + (x * 216 | 0) + 144 >> 2] | 0) == (S | 0)) {
                                                S = 0, T = 2, P = 0;
                                                break;
                                              }
                                              if ((_[11152 + (x * 216 | 0) + 152 >> 2] | 0) == (S | 0)) {
                                                S = 0, T = 2, P = 1;
                                                break;
                                              }
                                              if ((_[11152 + (x * 216 | 0) + 160 >> 2] | 0) == (S | 0)) {
                                                S = 0, T = 2, P = 2;
                                                break;
                                              }
                                              if ((_[11152 + (x * 216 | 0) + 168 >> 2] | 0) == (S | 0)) {
                                                S = 1, T = 2, P = 0;
                                                break;
                                              }
                                              if ((_[11152 + (x * 216 | 0) + 176 >> 2] | 0) == (S | 0)) {
                                                S = 1, T = 2, P = 1;
                                                break;
                                              }
                                              if ((_[11152 + (x * 216 | 0) + 184 >> 2] | 0) == (S | 0)) {
                                                S = 1, T = 2, P = 2;
                                                break;
                                              }
                                              if ((_[11152 + (x * 216 | 0) + 192 >> 2] | 0) == (S | 0)) {
                                                S = 2, T = 2, P = 0;
                                                break;
                                              }
                                              if ((_[11152 + (x * 216 | 0) + 200 >> 2] | 0) == (S | 0)) {
                                                S = 2, T = 2, P = 1;
                                                break;
                                              }
                                              if ((_[11152 + (x * 216 | 0) + 208 >> 2] | 0) == (S | 0)) {
                                                S = 2, T = 2, P = 2;
                                                break;
                                              } else
                                                S = -1;
                                              return S | 0;
                                            }
                                          else
                                            S = 2, T = 1, P = 1;
                                        else
                                          S = 2, T = 1, P = 0;
                                      else
                                        S = 1, T = 1, P = 2;
                                    else
                                      S = 1, T = 1, P = 1;
                                  else
                                    S = 1, T = 1, P = 0;
                                else
                                  S = 0, T = 1, P = 2;
                              else
                                S = 0, T = 1, P = 1;
                            else
                              S = 0, T = 1, P = 0;
                          else
                            S = 2, T = 0, P = 2;
                        else
                          S = 2, T = 0, P = 1;
                      else
                        S = 2, T = 0, P = 0;
                    else
                      S = 1, T = 0, P = 2;
                  else
                    S = 1, T = 0, P = 1;
                else
                  S = 1, T = 0, P = 0;
              else
                S = 0, T = 0, P = 2;
            else
              S = 0, T = 0, P = 1;
          else
            S = 0, T = 0, P = 0;
        while (0);
        return x = _[11152 + (x * 216 | 0) + (T * 72 | 0) + (S * 24 | 0) + (P << 3) + 4 >> 2] | 0, x | 0;
      }
      function na(S, x) {
        return S = S | 0, x = x | 0, (_[7728 + (S * 28 | 0) + 20 >> 2] | 0) == (x | 0) ? (x = 1, x | 0) : (x = (_[7728 + (S * 28 | 0) + 24 >> 2] | 0) == (x | 0), x | 0);
      }
      function Cl(S, x) {
        return S = S | 0, x = x | 0, _[880 + (S * 28 | 0) + (x << 2) >> 2] | 0;
      }
      function La(S, x) {
        return S = S | 0, x = x | 0, (_[880 + (S * 28 | 0) >> 2] | 0) == (x | 0) ? (x = 0, x | 0) : (_[880 + (S * 28 | 0) + 4 >> 2] | 0) == (x | 0) ? (x = 1, x | 0) : (_[880 + (S * 28 | 0) + 8 >> 2] | 0) == (x | 0) ? (x = 2, x | 0) : (_[880 + (S * 28 | 0) + 12 >> 2] | 0) == (x | 0) ? (x = 3, x | 0) : (_[880 + (S * 28 | 0) + 16 >> 2] | 0) == (x | 0) ? (x = 4, x | 0) : (_[880 + (S * 28 | 0) + 20 >> 2] | 0) == (x | 0) ? (x = 5, x | 0) : ((_[880 + (S * 28 | 0) + 24 >> 2] | 0) == (x | 0) ? 6 : 7) | 0;
      }
      function ai() {
        return 122;
      }
      function nh(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0;
        x = 0;
        do
          gn(x | 0, 0, 45) | 0, P = Ye() | 0 | 134225919, T = S + (x << 3) | 0, _[T >> 2] = -1, _[T + 4 >> 2] = P, x = x + 1 | 0;
        while ((x | 0) != 122);
      }
      function ns(S) {
        return S = S | 0, +ye[S + 16 >> 3] < +ye[S + 24 >> 3] | 0;
      }
      function pc(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0;
        return T = +ye[x >> 3], !(T >= +ye[S + 8 >> 3]) || !(T <= +ye[S >> 3]) ? (x = 0, x | 0) : (P = +ye[S + 16 >> 3], T = +ye[S + 24 >> 3], H = +ye[x + 8 >> 3], x = H >= T, S = H <= P & 1, P < T ? x && (S = 1) : x || (S = 0), x = (S | 0) != 0, x | 0);
      }
      function Ic(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0;
        g = $e, $e = $e + 288 | 0, T = g + 264 | 0, P = g + 96 | 0, H = g, J = H, p = J + 96 | 0;
        do
          _[J >> 2] = 0, J = J + 4 | 0;
        while ((J | 0) < (p | 0));
        return Fa(x, H), J = H, p = _[J >> 2] | 0, J = _[J + 4 >> 2] | 0, JA(p, J, T), ia(p, J, P), E = +Ca(T, P + 8 | 0), ye[T >> 3] = +ye[S >> 3], J = T + 8 | 0, ye[J >> 3] = +ye[S + 16 >> 3], ye[P >> 3] = +ye[S + 8 >> 3], p = P + 8 | 0, ye[p >> 3] = +ye[S + 24 >> 3], B = +Ca(T, P), p = ~~+Sn(+(B * B / +dh(+ +tt(+((+ye[J >> 3] - +ye[p >> 3]) / (+ye[T >> 3] - +ye[P >> 3]))), 3) / (E * (E * 2.59807621135) * 0.8))), $e = g, (p | 0 ? p : 1) | 0;
      }
      function Li(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0;
        p = $e, $e = $e + 288 | 0, P = p + 264 | 0, H = p + 96 | 0, J = p, g = J, E = g + 96 | 0;
        do
          _[g >> 2] = 0, g = g + 4 | 0;
        while ((g | 0) < (E | 0));
        return Fa(T, J), E = J, g = _[E >> 2] | 0, E = _[E + 4 >> 2] | 0, JA(g, E, P), ia(g, E, H), B = +Ca(P, H + 8 | 0), E = ~~+Sn(+(+Ca(S, x) / (B * 2))), $e = p, (E | 0 ? E : 1) | 0;
      }
      function ks(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, _[S >> 2] = x, _[S + 4 >> 2] = T, _[S + 8 >> 2] = P;
      }
      function Vu(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0;
        j = x + 8 | 0, _[j >> 2] = 0, E = +ye[S >> 3], g = +tt(+E), B = +ye[S + 8 >> 3], p = +tt(+B) / 0.8660254037844386, g = g + p * 0.5, T = ~~g, S = ~~p, g = g - +(T | 0), p = p - +(S | 0);
        do
          if (g < 0.5)
            if (g < 0.3333333333333333)
              if (_[x >> 2] = T, p < (g + 1) * 0.5) {
                _[x + 4 >> 2] = S;
                break;
              } else {
                S = S + 1 | 0, _[x + 4 >> 2] = S;
                break;
              }
            else if (te = 1 - g, S = (!(p < te) & 1) + S | 0, _[x + 4 >> 2] = S, te <= p & p < g * 2) {
              T = T + 1 | 0, _[x >> 2] = T;
              break;
            } else {
              _[x >> 2] = T;
              break;
            }
          else {
            if (!(g < 0.6666666666666666))
              if (T = T + 1 | 0, _[x >> 2] = T, p < g * 0.5) {
                _[x + 4 >> 2] = S;
                break;
              } else {
                S = S + 1 | 0, _[x + 4 >> 2] = S;
                break;
              }
            if (p < 1 - g) {
              if (_[x + 4 >> 2] = S, g * 2 + -1 < p) {
                _[x >> 2] = T;
                break;
              }
            } else
              S = S + 1 | 0, _[x + 4 >> 2] = S;
            T = T + 1 | 0, _[x >> 2] = T;
          }
        while (0);
        do
          if (E < 0)
            if (S & 1) {
              D = (S + 1 | 0) / 2 | 0, D = Au(T | 0, ((T | 0) < 0) << 31 >> 31 | 0, D | 0, ((D | 0) < 0) << 31 >> 31 | 0) | 0, T = ~~(+(T | 0) - ((+(D >>> 0) + 4294967296 * +(Ye() | 0)) * 2 + 1)), _[x >> 2] = T;
              break;
            } else {
              D = (S | 0) / 2 | 0, D = Au(T | 0, ((T | 0) < 0) << 31 >> 31 | 0, D | 0, ((D | 0) < 0) << 31 >> 31 | 0) | 0, T = ~~(+(T | 0) - (+(D >>> 0) + 4294967296 * +(Ye() | 0)) * 2), _[x >> 2] = T;
              break;
            }
        while (0);
        D = x + 4 | 0, B < 0 && (T = T - ((S << 1 | 1 | 0) / 2 | 0) | 0, _[x >> 2] = T, S = 0 - S | 0, _[D >> 2] = S), P = S - T | 0, (T | 0) < 0 ? (H = 0 - T | 0, _[D >> 2] = P, _[j >> 2] = H, _[x >> 2] = 0, S = P, T = 0) : H = 0, (S | 0) < 0 && (T = T - S | 0, _[x >> 2] = T, H = H - S | 0, _[j >> 2] = H, _[D >> 2] = 0, S = 0), J = T - H | 0, P = S - H | 0, (H | 0) < 0 && (_[x >> 2] = J, _[D >> 2] = P, _[j >> 2] = 0, S = P, T = J, H = 0), P = (S | 0) < (T | 0) ? S : T, P = (H | 0) < (P | 0) ? H : P, !((P | 0) <= 0) && (_[x >> 2] = T - P, _[D >> 2] = S - P, _[j >> 2] = H - P);
      }
      function zn(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0;
        x = _[S >> 2] | 0, g = S + 4 | 0, T = _[g >> 2] | 0, (x | 0) < 0 && (T = T - x | 0, _[g >> 2] = T, J = S + 8 | 0, _[J >> 2] = (_[J >> 2] | 0) - x, _[S >> 2] = 0, x = 0), (T | 0) < 0 ? (x = x - T | 0, _[S >> 2] = x, J = S + 8 | 0, H = (_[J >> 2] | 0) - T | 0, _[J >> 2] = H, _[g >> 2] = 0, T = 0) : (H = S + 8 | 0, J = H, H = _[H >> 2] | 0), (H | 0) < 0 && (x = x - H | 0, _[S >> 2] = x, T = T - H | 0, _[g >> 2] = T, _[J >> 2] = 0, H = 0), P = (T | 0) < (x | 0) ? T : x, P = (H | 0) < (P | 0) ? H : P, !((P | 0) <= 0) && (_[S >> 2] = x - P, _[g >> 2] = T - P, _[J >> 2] = H - P);
      }
      function Gr(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0;
        P = _[S + 8 >> 2] | 0, T = +((_[S + 4 >> 2] | 0) - P | 0), ye[x >> 3] = +((_[S >> 2] | 0) - P | 0) - T * 0.5, ye[x + 8 >> 3] = T * 0.8660254037844386;
      }
      function _r(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0, _[T >> 2] = (_[x >> 2] | 0) + (_[S >> 2] | 0), _[T + 4 >> 2] = (_[x + 4 >> 2] | 0) + (_[S + 4 >> 2] | 0), _[T + 8 >> 2] = (_[x + 8 >> 2] | 0) + (_[S + 8 >> 2] | 0);
      }
      function ms(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0, _[T >> 2] = (_[S >> 2] | 0) - (_[x >> 2] | 0), _[T + 4 >> 2] = (_[S + 4 >> 2] | 0) - (_[x + 4 >> 2] | 0), _[T + 8 >> 2] = (_[S + 8 >> 2] | 0) - (_[x + 8 >> 2] | 0);
      }
      function Mi(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0;
        T = kn(_[S >> 2] | 0, x) | 0, _[S >> 2] = T, T = S + 4 | 0, P = kn(_[T >> 2] | 0, x) | 0, _[T >> 2] = P, S = S + 8 | 0, x = kn(_[S >> 2] | 0, x) | 0, _[S >> 2] = x;
      }
      function mc(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        g = _[S >> 2] | 0, p = (g | 0) < 0, P = (_[S + 4 >> 2] | 0) - (p ? g : 0) | 0, J = (P | 0) < 0, H = (J ? 0 - P | 0 : 0) + ((_[S + 8 >> 2] | 0) - (p ? g : 0)) | 0, T = (H | 0) < 0, S = T ? 0 : H, x = (J ? 0 : P) - (T ? H : 0) | 0, H = (p ? 0 : g) - (J ? P : 0) - (T ? H : 0) | 0, T = (x | 0) < (H | 0) ? x : H, T = (S | 0) < (T | 0) ? S : T, P = (T | 0) > 0, S = S - (P ? T : 0) | 0, x = x - (P ? T : 0) | 0;
        e:
          do
            switch (H - (P ? T : 0) | 0) {
              case 0:
                switch (x | 0) {
                  case 0:
                    return p = S | 0 ? (S | 0) == 1 ? 1 : 7 : 0, p | 0;
                  case 1:
                    return p = S | 0 ? (S | 0) == 1 ? 3 : 7 : 2, p | 0;
                  default:
                    break e;
                }
              case 1:
                switch (x | 0) {
                  case 0:
                    return p = S | 0 ? (S | 0) == 1 ? 5 : 7 : 4, p | 0;
                  case 1: {
                    if (!S)
                      S = 6;
                    else
                      break e;
                    return S | 0;
                  }
                  default:
                    break e;
                }
            }
          while (0);
        return p = 7, p | 0;
      }
      function EA(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        g = S + 8 | 0, T = _[g >> 2] | 0, x = (_[S >> 2] | 0) - T | 0, p = S + 4 | 0, T = (_[p >> 2] | 0) - T | 0, P = T0(+((x * 3 | 0) - T | 0) / 7) | 0, _[S >> 2] = P, x = T0(+((T << 1) + x | 0) / 7) | 0, _[p >> 2] = x, _[g >> 2] = 0, T = x - P | 0, (P | 0) < 0 ? (J = 0 - P | 0, _[p >> 2] = T, _[g >> 2] = J, _[S >> 2] = 0, x = T, P = 0, T = J) : T = 0, (x | 0) < 0 && (P = P - x | 0, _[S >> 2] = P, T = T - x | 0, _[g >> 2] = T, _[p >> 2] = 0, x = 0), J = P - T | 0, H = x - T | 0, (T | 0) < 0 ? (_[S >> 2] = J, _[p >> 2] = H, _[g >> 2] = 0, x = H, H = J, T = 0) : H = P, P = (x | 0) < (H | 0) ? x : H, P = (T | 0) < (P | 0) ? T : P, !((P | 0) <= 0) && (_[S >> 2] = H - P, _[p >> 2] = x - P, _[g >> 2] = T - P);
      }
      function co(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        g = S + 8 | 0, T = _[g >> 2] | 0, x = (_[S >> 2] | 0) - T | 0, p = S + 4 | 0, T = (_[p >> 2] | 0) - T | 0, P = T0(+((x << 1) + T | 0) / 7) | 0, _[S >> 2] = P, x = T0(+((T * 3 | 0) - x | 0) / 7) | 0, _[p >> 2] = x, _[g >> 2] = 0, T = x - P | 0, (P | 0) < 0 ? (J = 0 - P | 0, _[p >> 2] = T, _[g >> 2] = J, _[S >> 2] = 0, x = T, P = 0, T = J) : T = 0, (x | 0) < 0 && (P = P - x | 0, _[S >> 2] = P, T = T - x | 0, _[g >> 2] = T, _[p >> 2] = 0, x = 0), J = P - T | 0, H = x - T | 0, (T | 0) < 0 ? (_[S >> 2] = J, _[p >> 2] = H, _[g >> 2] = 0, x = H, H = J, T = 0) : H = P, P = (x | 0) < (H | 0) ? x : H, P = (T | 0) < (P | 0) ? T : P, !((P | 0) <= 0) && (_[S >> 2] = H - P, _[p >> 2] = x - P, _[g >> 2] = T - P);
      }
      function uo(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        x = _[S >> 2] | 0, g = S + 4 | 0, T = _[g >> 2] | 0, p = S + 8 | 0, P = _[p >> 2] | 0, H = T + (x * 3 | 0) | 0, _[S >> 2] = H, T = P + (T * 3 | 0) | 0, _[g >> 2] = T, x = (P * 3 | 0) + x | 0, _[p >> 2] = x, P = T - H | 0, (H | 0) < 0 ? (x = x - H | 0, _[g >> 2] = P, _[p >> 2] = x, _[S >> 2] = 0, T = P, P = 0) : P = H, (T | 0) < 0 && (P = P - T | 0, _[S >> 2] = P, x = x - T | 0, _[p >> 2] = x, _[g >> 2] = 0, T = 0), J = P - x | 0, H = T - x | 0, (x | 0) < 0 ? (_[S >> 2] = J, _[g >> 2] = H, _[p >> 2] = 0, P = J, x = 0) : H = T, T = (H | 0) < (P | 0) ? H : P, T = (x | 0) < (T | 0) ? x : T, !((T | 0) <= 0) && (_[S >> 2] = P - T, _[g >> 2] = H - T, _[p >> 2] = x - T);
      }
      function ou(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        H = _[S >> 2] | 0, g = S + 4 | 0, x = _[g >> 2] | 0, p = S + 8 | 0, T = _[p >> 2] | 0, P = (x * 3 | 0) + H | 0, H = T + (H * 3 | 0) | 0, _[S >> 2] = H, _[g >> 2] = P, x = (T * 3 | 0) + x | 0, _[p >> 2] = x, T = P - H | 0, (H | 0) < 0 ? (x = x - H | 0, _[g >> 2] = T, _[p >> 2] = x, _[S >> 2] = 0, H = 0) : T = P, (T | 0) < 0 && (H = H - T | 0, _[S >> 2] = H, x = x - T | 0, _[p >> 2] = x, _[g >> 2] = 0, T = 0), J = H - x | 0, P = T - x | 0, (x | 0) < 0 ? (_[S >> 2] = J, _[g >> 2] = P, _[p >> 2] = 0, H = J, x = 0) : P = T, T = (P | 0) < (H | 0) ? P : H, T = (x | 0) < (T | 0) ? x : T, !((T | 0) <= 0) && (_[S >> 2] = H - T, _[g >> 2] = P - T, _[p >> 2] = x - T);
      }
      function F1(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        (x + -1 | 0) >>> 0 >= 6 || (H = (_[15472 + (x * 12 | 0) >> 2] | 0) + (_[S >> 2] | 0) | 0, _[S >> 2] = H, p = S + 4 | 0, P = (_[15472 + (x * 12 | 0) + 4 >> 2] | 0) + (_[p >> 2] | 0) | 0, _[p >> 2] = P, g = S + 8 | 0, x = (_[15472 + (x * 12 | 0) + 8 >> 2] | 0) + (_[g >> 2] | 0) | 0, _[g >> 2] = x, T = P - H | 0, (H | 0) < 0 ? (x = x - H | 0, _[p >> 2] = T, _[g >> 2] = x, _[S >> 2] = 0, P = 0) : (T = P, P = H), (T | 0) < 0 && (P = P - T | 0, _[S >> 2] = P, x = x - T | 0, _[g >> 2] = x, _[p >> 2] = 0, T = 0), J = P - x | 0, H = T - x | 0, (x | 0) < 0 ? (_[S >> 2] = J, _[p >> 2] = H, _[g >> 2] = 0, P = J, x = 0) : H = T, T = (H | 0) < (P | 0) ? H : P, T = (x | 0) < (T | 0) ? x : T, !((T | 0) <= 0) && (_[S >> 2] = P - T, _[p >> 2] = H - T, _[g >> 2] = x - T));
      }
      function Kf(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        H = _[S >> 2] | 0, g = S + 4 | 0, x = _[g >> 2] | 0, p = S + 8 | 0, T = _[p >> 2] | 0, P = x + H | 0, H = T + H | 0, _[S >> 2] = H, _[g >> 2] = P, x = T + x | 0, _[p >> 2] = x, T = P - H | 0, (H | 0) < 0 ? (x = x - H | 0, _[g >> 2] = T, _[p >> 2] = x, _[S >> 2] = 0, P = 0) : (T = P, P = H), (T | 0) < 0 && (P = P - T | 0, _[S >> 2] = P, x = x - T | 0, _[p >> 2] = x, _[g >> 2] = 0, T = 0), J = P - x | 0, H = T - x | 0, (x | 0) < 0 ? (_[S >> 2] = J, _[g >> 2] = H, _[p >> 2] = 0, P = J, x = 0) : H = T, T = (H | 0) < (P | 0) ? H : P, T = (x | 0) < (T | 0) ? x : T, !((T | 0) <= 0) && (_[S >> 2] = P - T, _[g >> 2] = H - T, _[p >> 2] = x - T);
      }
      function S0(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        x = _[S >> 2] | 0, g = S + 4 | 0, P = _[g >> 2] | 0, p = S + 8 | 0, T = _[p >> 2] | 0, H = P + x | 0, _[S >> 2] = H, P = T + P | 0, _[g >> 2] = P, x = T + x | 0, _[p >> 2] = x, T = P - H | 0, (H | 0) < 0 ? (x = x - H | 0, _[g >> 2] = T, _[p >> 2] = x, _[S >> 2] = 0, P = 0) : (T = P, P = H), (T | 0) < 0 && (P = P - T | 0, _[S >> 2] = P, x = x - T | 0, _[p >> 2] = x, _[g >> 2] = 0, T = 0), J = P - x | 0, H = T - x | 0, (x | 0) < 0 ? (_[S >> 2] = J, _[g >> 2] = H, _[p >> 2] = 0, P = J, x = 0) : H = T, T = (H | 0) < (P | 0) ? H : P, T = (x | 0) < (T | 0) ? x : T, !((T | 0) <= 0) && (_[S >> 2] = P - T, _[g >> 2] = H - T, _[p >> 2] = x - T);
      }
      function Wf(S) {
        switch (S = S | 0, S | 0) {
          case 1: {
            S = 5;
            break;
          }
          case 5: {
            S = 4;
            break;
          }
          case 4: {
            S = 6;
            break;
          }
          case 6: {
            S = 2;
            break;
          }
          case 2: {
            S = 3;
            break;
          }
          case 3: {
            S = 1;
            break;
          }
        }
        return S | 0;
      }
      function fo(S) {
        switch (S = S | 0, S | 0) {
          case 1: {
            S = 3;
            break;
          }
          case 3: {
            S = 2;
            break;
          }
          case 2: {
            S = 6;
            break;
          }
          case 6: {
            S = 4;
            break;
          }
          case 4: {
            S = 5;
            break;
          }
          case 5: {
            S = 1;
            break;
          }
        }
        return S | 0;
      }
      function yo(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        x = _[S >> 2] | 0, g = S + 4 | 0, T = _[g >> 2] | 0, p = S + 8 | 0, P = _[p >> 2] | 0, H = T + (x << 1) | 0, _[S >> 2] = H, T = P + (T << 1) | 0, _[g >> 2] = T, x = (P << 1) + x | 0, _[p >> 2] = x, P = T - H | 0, (H | 0) < 0 ? (x = x - H | 0, _[g >> 2] = P, _[p >> 2] = x, _[S >> 2] = 0, T = P, P = 0) : P = H, (T | 0) < 0 && (P = P - T | 0, _[S >> 2] = P, x = x - T | 0, _[p >> 2] = x, _[g >> 2] = 0, T = 0), J = P - x | 0, H = T - x | 0, (x | 0) < 0 ? (_[S >> 2] = J, _[g >> 2] = H, _[p >> 2] = 0, P = J, x = 0) : H = T, T = (H | 0) < (P | 0) ? H : P, T = (x | 0) < (T | 0) ? x : T, !((T | 0) <= 0) && (_[S >> 2] = P - T, _[g >> 2] = H - T, _[p >> 2] = x - T);
      }
      function Gs(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        H = _[S >> 2] | 0, g = S + 4 | 0, x = _[g >> 2] | 0, p = S + 8 | 0, T = _[p >> 2] | 0, P = (x << 1) + H | 0, H = T + (H << 1) | 0, _[S >> 2] = H, _[g >> 2] = P, x = (T << 1) + x | 0, _[p >> 2] = x, T = P - H | 0, (H | 0) < 0 ? (x = x - H | 0, _[g >> 2] = T, _[p >> 2] = x, _[S >> 2] = 0, H = 0) : T = P, (T | 0) < 0 && (H = H - T | 0, _[S >> 2] = H, x = x - T | 0, _[p >> 2] = x, _[g >> 2] = 0, T = 0), J = H - x | 0, P = T - x | 0, (x | 0) < 0 ? (_[S >> 2] = J, _[g >> 2] = P, _[p >> 2] = 0, H = J, x = 0) : P = T, T = (P | 0) < (H | 0) ? P : H, T = (x | 0) < (T | 0) ? x : T, !((T | 0) <= 0) && (_[S >> 2] = H - T, _[g >> 2] = P - T, _[p >> 2] = x - T);
      }
      function Ju(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        return g = (_[S >> 2] | 0) - (_[x >> 2] | 0) | 0, p = (g | 0) < 0, P = (_[S + 4 >> 2] | 0) - (_[x + 4 >> 2] | 0) - (p ? g : 0) | 0, J = (P | 0) < 0, H = (p ? 0 - g | 0 : 0) + (_[S + 8 >> 2] | 0) - (_[x + 8 >> 2] | 0) + (J ? 0 - P | 0 : 0) | 0, S = (H | 0) < 0, x = S ? 0 : H, T = (J ? 0 : P) - (S ? H : 0) | 0, H = (p ? 0 : g) - (J ? P : 0) - (S ? H : 0) | 0, S = (T | 0) < (H | 0) ? T : H, S = (x | 0) < (S | 0) ? x : S, P = (S | 0) > 0, x = x - (P ? S : 0) | 0, T = T - (P ? S : 0) | 0, S = H - (P ? S : 0) | 0, S = (S | 0) > -1 ? S : 0 - S | 0, T = (T | 0) > -1 ? T : 0 - T | 0, x = (x | 0) > -1 ? x : 0 - x | 0, x = (T | 0) > (x | 0) ? T : x, ((S | 0) > (x | 0) ? S : x) | 0;
      }
      function Cc(S, x) {
        S = S | 0, x = x | 0;
        var T = 0;
        T = _[S + 8 >> 2] | 0, _[x >> 2] = (_[S >> 2] | 0) - T, _[x + 4 >> 2] = (_[S + 4 >> 2] | 0) - T;
      }
      function Q0(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        P = _[S >> 2] | 0, _[x >> 2] = P, S = _[S + 4 >> 2] | 0, g = x + 4 | 0, _[g >> 2] = S, p = x + 8 | 0, _[p >> 2] = 0, T = S - P | 0, (P | 0) < 0 ? (S = 0 - P | 0, _[g >> 2] = T, _[p >> 2] = S, _[x >> 2] = 0, P = 0) : (T = S, S = 0), (T | 0) < 0 && (P = P - T | 0, _[x >> 2] = P, S = S - T | 0, _[p >> 2] = S, _[g >> 2] = 0, T = 0), J = P - S | 0, H = T - S | 0, (S | 0) < 0 ? (_[x >> 2] = J, _[g >> 2] = H, _[p >> 2] = 0, T = H, H = J, S = 0) : H = P, P = (T | 0) < (H | 0) ? T : H, P = (S | 0) < (P | 0) ? S : P, !((P | 0) <= 0) && (_[x >> 2] = H - P, _[g >> 2] = T - P, _[p >> 2] = S - P);
      }
      function ki(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0;
        x = S + 8 | 0, H = _[x >> 2] | 0, T = H - (_[S >> 2] | 0) | 0, _[S >> 2] = T, P = S + 4 | 0, S = (_[P >> 2] | 0) - H | 0, _[P >> 2] = S, _[x >> 2] = 0 - (S + T);
      }
      function Dn(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        T = _[S >> 2] | 0, x = 0 - T | 0, _[S >> 2] = x, g = S + 8 | 0, _[g >> 2] = 0, p = S + 4 | 0, P = _[p >> 2] | 0, H = P + T | 0, (T | 0) > 0 ? (_[p >> 2] = H, _[g >> 2] = T, _[S >> 2] = 0, x = 0, P = H) : T = 0, (P | 0) < 0 ? (J = x - P | 0, _[S >> 2] = J, T = T - P | 0, _[g >> 2] = T, _[p >> 2] = 0, H = J - T | 0, x = 0 - T | 0, (T | 0) < 0 ? (_[S >> 2] = H, _[p >> 2] = x, _[g >> 2] = 0, P = x, T = 0) : (P = 0, H = J)) : H = x, x = (P | 0) < (H | 0) ? P : H, x = (T | 0) < (x | 0) ? T : x, !((x | 0) <= 0) && (_[S >> 2] = H - x, _[p >> 2] = P - x, _[g >> 2] = T - x);
      }
      function P1(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0;
        P = $e, $e = $e + 16 | 0, H = P, w0(S, x, T, H), Vu(H, T + 4 | 0), $e = P;
      }
      function w0(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0, g = 0, p = 0, E = 0;
        if (E = $e, $e = $e + 32 | 0, J = E, oy(S, J), _[T >> 2] = 0, H = +Gi(15888, J), g = +Gi(15912, J), g < H && (_[T >> 2] = 1, H = g), g = +Gi(15936, J), g < H && (_[T >> 2] = 2, H = g), g = +Gi(15960, J), g < H && (_[T >> 2] = 3, H = g), g = +Gi(15984, J), g < H && (_[T >> 2] = 4, H = g), g = +Gi(16008, J), g < H && (_[T >> 2] = 5, H = g), g = +Gi(16032, J), g < H && (_[T >> 2] = 6, H = g), g = +Gi(16056, J), g < H && (_[T >> 2] = 7, H = g), g = +Gi(16080, J), g < H && (_[T >> 2] = 8, H = g), g = +Gi(16104, J), g < H && (_[T >> 2] = 9, H = g), g = +Gi(16128, J), g < H && (_[T >> 2] = 10, H = g), g = +Gi(16152, J), g < H && (_[T >> 2] = 11, H = g), g = +Gi(16176, J), g < H && (_[T >> 2] = 12, H = g), g = +Gi(16200, J), g < H && (_[T >> 2] = 13, H = g), g = +Gi(16224, J), g < H && (_[T >> 2] = 14, H = g), g = +Gi(16248, J), g < H && (_[T >> 2] = 15, H = g), g = +Gi(16272, J), g < H && (_[T >> 2] = 16, H = g), g = +Gi(16296, J), g < H && (_[T >> 2] = 17, H = g), g = +Gi(16320, J), g < H && (_[T >> 2] = 18, H = g), g = +Gi(16344, J), g < H && (_[T >> 2] = 19, H = g), g = +rn(+(1 - H * 0.5)), g < 1e-16) {
          _[P >> 2] = 0, _[P + 4 >> 2] = 0, _[P + 8 >> 2] = 0, _[P + 12 >> 2] = 0, $e = E;
          return;
        }
        if (T = _[T >> 2] | 0, H = +ye[16368 + (T * 24 | 0) >> 3], H = +yi(H - +yi(+ih(15568 + (T << 4) | 0, S))), Oa(x) | 0 ? p = +yi(H + -0.3334731722518321) : p = H, H = +Lt(+g) / 0.381966011250105, (x | 0) > 0) {
          J = 0;
          do
            H = H * 2.6457513110645907, J = J + 1 | 0;
          while ((J | 0) != (x | 0));
        }
        g = +Bt(+p) * H, ye[P >> 3] = g, p = +Rt(+p) * H, ye[P + 8 >> 3] = p, $e = E;
      }
      function rs(S, x, T, P, H) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0;
        var J = 0, g = 0;
        if (J = +iy(S), J < 1e-16) {
          x = 15568 + (x << 4) | 0, _[H >> 2] = _[x >> 2], _[H + 4 >> 2] = _[x + 4 >> 2], _[H + 8 >> 2] = _[x + 8 >> 2], _[H + 12 >> 2] = _[x + 12 >> 2];
          return;
        }
        if (g = +Vt(+ +ye[S + 8 >> 3], + +ye[S >> 3]), (T | 0) > 0) {
          S = 0;
          do
            J = J / 2.6457513110645907, S = S + 1 | 0;
          while ((S | 0) != (T | 0));
        }
        P ? (J = J / 3, T = (Oa(T) | 0) == 0, J = +pr(+((T ? J : J / 2.6457513110645907) * 0.381966011250105))) : (J = +pr(+(J * 0.381966011250105)), Oa(T) | 0 && (g = +yi(g + 0.3334731722518321))), Oi(15568 + (x << 4) | 0, +yi(+ye[16368 + (x * 24 | 0) >> 3] - g), J, H);
      }
      function El(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0;
        P = $e, $e = $e + 16 | 0, H = P, Gr(S + 4 | 0, H), rs(H, _[S >> 2] | 0, x, 0, T), $e = P;
      }
      function su(S, x, T, P, H) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0;
        var J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0, Le = 0, Je = 0, et = 0, Ke = 0, ot = 0, je = 0, Et = 0, Gt = 0, kt = 0, bt = 0, Yn = 0, Hr = 0, li = 0, Ui = 0, hi = 0, Zi = 0, Bo = 0, xr = 0;
        if (Zi = $e, $e = $e + 272 | 0, J = Zi + 256 | 0, Ke = Zi + 240 | 0, li = Zi, Ui = Zi + 224 | 0, hi = Zi + 208 | 0, ot = Zi + 176 | 0, je = Zi + 160 | 0, Et = Zi + 192 | 0, Gt = Zi + 144 | 0, kt = Zi + 128 | 0, bt = Zi + 112 | 0, Yn = Zi + 96 | 0, Hr = Zi + 80 | 0, _[J >> 2] = x, _[Ke >> 2] = _[S >> 2], _[Ke + 4 >> 2] = _[S + 4 >> 2], _[Ke + 8 >> 2] = _[S + 8 >> 2], _[Ke + 12 >> 2] = _[S + 12 >> 2], rh(Ke, J, li), _[H >> 2] = 0, Ke = P + T + ((P | 0) == 5 & 1) | 0, (Ke | 0) <= (T | 0)) {
          $e = Zi;
          return;
        }
        E = _[J >> 2] | 0, B = Ui + 4 | 0, D = ot + 4 | 0, j = T + 5 | 0, te = 16848 + (E << 2) | 0, he = 16928 + (E << 2) | 0, ve = kt + 8 | 0, Le = bt + 8 | 0, Je = Yn + 8 | 0, et = hi + 4 | 0, p = T;
        e:
          for (; ; ) {
            g = li + (((p | 0) % 5 | 0) << 4) | 0, _[hi >> 2] = _[g >> 2], _[hi + 4 >> 2] = _[g + 4 >> 2], _[hi + 8 >> 2] = _[g + 8 >> 2], _[hi + 12 >> 2] = _[g + 12 >> 2];
            do
              ;
            while ((Ku(hi, E, 0, 1) | 0) == 2);
            if ((p | 0) > (T | 0) & (Oa(x) | 0) != 0) {
              if (_[ot >> 2] = _[hi >> 2], _[ot + 4 >> 2] = _[hi + 4 >> 2], _[ot + 8 >> 2] = _[hi + 8 >> 2], _[ot + 12 >> 2] = _[hi + 12 >> 2], Gr(B, je), P = _[ot >> 2] | 0, J = _[17008 + (P * 80 | 0) + (_[Ui >> 2] << 2) >> 2] | 0, _[ot >> 2] = _[18608 + (P * 80 | 0) + (J * 20 | 0) >> 2], g = _[18608 + (P * 80 | 0) + (J * 20 | 0) + 16 >> 2] | 0, (g | 0) > 0) {
                S = 0;
                do
                  Kf(D), S = S + 1 | 0;
                while ((S | 0) < (g | 0));
              }
              switch (g = 18608 + (P * 80 | 0) + (J * 20 | 0) + 4 | 0, _[Et >> 2] = _[g >> 2], _[Et + 4 >> 2] = _[g + 4 >> 2], _[Et + 8 >> 2] = _[g + 8 >> 2], Mi(Et, (_[te >> 2] | 0) * 3 | 0), _r(D, Et, D), zn(D), Gr(D, Gt), Bo = +(_[he >> 2] | 0), ye[kt >> 3] = Bo * 3, ye[ve >> 3] = 0, xr = Bo * -1.5, ye[bt >> 3] = xr, ye[Le >> 3] = Bo * 2.598076211353316, ye[Yn >> 3] = xr, ye[Je >> 3] = Bo * -2.598076211353316, _[17008 + ((_[ot >> 2] | 0) * 80 | 0) + (_[hi >> 2] << 2) >> 2] | 0) {
                case 1: {
                  S = bt, P = kt;
                  break;
                }
                case 3: {
                  S = Yn, P = bt;
                  break;
                }
                case 2: {
                  S = kt, P = Yn;
                  break;
                }
                default: {
                  S = 12;
                  break e;
                }
              }
              nf(je, Gt, P, S, Hr), rs(Hr, _[ot >> 2] | 0, E, 1, H + 8 + (_[H >> 2] << 4) | 0), _[H >> 2] = (_[H >> 2] | 0) + 1;
            }
            if ((p | 0) < (j | 0) && (Gr(et, ot), rs(ot, _[hi >> 2] | 0, E, 1, H + 8 + (_[H >> 2] << 4) | 0), _[H >> 2] = (_[H >> 2] | 0) + 1), _[Ui >> 2] = _[hi >> 2], _[Ui + 4 >> 2] = _[hi + 4 >> 2], _[Ui + 8 >> 2] = _[hi + 8 >> 2], _[Ui + 12 >> 2] = _[hi + 12 >> 2], p = p + 1 | 0, (p | 0) >= (Ke | 0)) {
              S = 3;
              break;
            }
          }
        if ((S | 0) == 3) {
          $e = Zi;
          return;
        } else
          (S | 0) == 12 && en(22474, 22521, 581, 22531);
      }
      function rh(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0, E = 0;
        E = $e, $e = $e + 128 | 0, P = E + 64 | 0, H = E, J = P, g = 20208, p = J + 60 | 0;
        do
          _[J >> 2] = _[g >> 2], J = J + 4 | 0, g = g + 4 | 0;
        while ((J | 0) < (p | 0));
        J = H, g = 20272, p = J + 60 | 0;
        do
          _[J >> 2] = _[g >> 2], J = J + 4 | 0, g = g + 4 | 0;
        while ((J | 0) < (p | 0));
        p = (Oa(_[x >> 2] | 0) | 0) == 0, P = p ? P : H, H = S + 4 | 0, yo(H), Gs(H), Oa(_[x >> 2] | 0) | 0 && (ou(H), _[x >> 2] = (_[x >> 2] | 0) + 1), _[T >> 2] = _[S >> 2], x = T + 4 | 0, _r(H, P, x), zn(x), _[T + 16 >> 2] = _[S >> 2], x = T + 20 | 0, _r(H, P + 12 | 0, x), zn(x), _[T + 32 >> 2] = _[S >> 2], x = T + 36 | 0, _r(H, P + 24 | 0, x), zn(x), _[T + 48 >> 2] = _[S >> 2], x = T + 52 | 0, _r(H, P + 36 | 0, x), zn(x), _[T + 64 >> 2] = _[S >> 2], T = T + 68 | 0, _r(H, P + 48 | 0, T), zn(T), $e = E;
      }
      function Ku(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0;
        if (ve = $e, $e = $e + 32 | 0, te = ve + 12 | 0, p = ve, he = S + 4 | 0, j = _[16928 + (x << 2) >> 2] | 0, D = (P | 0) != 0, j = D ? j * 3 | 0 : j, H = _[he >> 2] | 0, B = S + 8 | 0, g = _[B >> 2] | 0, D) {
          if (J = S + 12 | 0, P = _[J >> 2] | 0, H = g + H + P | 0, (H | 0) == (j | 0))
            return he = 1, $e = ve, he | 0;
          E = J;
        } else
          E = S + 12 | 0, P = _[E >> 2] | 0, H = g + H + P | 0;
        if ((H | 0) <= (j | 0))
          return he = 0, $e = ve, he | 0;
        do
          if ((P | 0) > 0) {
            if (P = _[S >> 2] | 0, (g | 0) > 0) {
              J = 18608 + (P * 80 | 0) + 60 | 0, P = S;
              break;
            }
            P = 18608 + (P * 80 | 0) + 40 | 0, T ? (ks(te, j, 0, 0), ms(he, te, p), S0(p), _r(p, te, he), J = P, P = S) : (J = P, P = S);
          } else
            J = 18608 + ((_[S >> 2] | 0) * 80 | 0) + 20 | 0, P = S;
        while (0);
        if (_[P >> 2] = _[J >> 2], H = J + 16 | 0, (_[H >> 2] | 0) > 0) {
          P = 0;
          do
            Kf(he), P = P + 1 | 0;
          while ((P | 0) < (_[H >> 2] | 0));
        }
        return S = J + 4 | 0, _[te >> 2] = _[S >> 2], _[te + 4 >> 2] = _[S + 4 >> 2], _[te + 8 >> 2] = _[S + 8 >> 2], x = _[16848 + (x << 2) >> 2] | 0, Mi(te, D ? x * 3 | 0 : x), _r(he, te, he), zn(he), D ? P = ((_[B >> 2] | 0) + (_[he >> 2] | 0) + (_[E >> 2] | 0) | 0) == (j | 0) ? 1 : 2 : P = 2, he = P, $e = ve, he | 0;
      }
      function ny(S, x) {
        S = S | 0, x = x | 0;
        var T = 0;
        do
          T = Ku(S, x, 0, 1) | 0;
        while ((T | 0) == 2);
        return T | 0;
      }
      function Xr(S, x, T, P, H) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0;
        var J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0, Le = 0, Je = 0, et = 0, Ke = 0, ot = 0, je = 0, Et = 0, Gt = 0, kt = 0, bt = 0, Yn = 0, Hr = 0, li = 0;
        if (Yn = $e, $e = $e + 240 | 0, J = Yn + 224 | 0, Et = Yn + 208 | 0, Gt = Yn, kt = Yn + 192 | 0, bt = Yn + 176 | 0, Je = Yn + 160 | 0, et = Yn + 144 | 0, Ke = Yn + 128 | 0, ot = Yn + 112 | 0, je = Yn + 96 | 0, _[J >> 2] = x, _[Et >> 2] = _[S >> 2], _[Et + 4 >> 2] = _[S + 4 >> 2], _[Et + 8 >> 2] = _[S + 8 >> 2], _[Et + 12 >> 2] = _[S + 12 >> 2], yl(Et, J, Gt), _[H >> 2] = 0, Le = P + T + ((P | 0) == 6 & 1) | 0, (Le | 0) <= (T | 0)) {
          $e = Yn;
          return;
        }
        E = _[J >> 2] | 0, B = T + 6 | 0, D = 16928 + (E << 2) | 0, j = et + 8 | 0, te = Ke + 8 | 0, he = ot + 8 | 0, ve = kt + 4 | 0, g = 0, p = T, P = -1;
        e:
          for (; ; ) {
            if (J = (p | 0) % 6 | 0, S = Gt + (J << 4) | 0, _[kt >> 2] = _[S >> 2], _[kt + 4 >> 2] = _[S + 4 >> 2], _[kt + 8 >> 2] = _[S + 8 >> 2], _[kt + 12 >> 2] = _[S + 12 >> 2], S = g, g = Ku(kt, E, 0, 1) | 0, (p | 0) > (T | 0) & (Oa(x) | 0) != 0 && (S | 0) != 1 && (_[kt >> 2] | 0) != (P | 0)) {
              switch (Gr(Gt + (((J + 5 | 0) % 6 | 0) << 4) + 4 | 0, bt), Gr(Gt + (J << 4) + 4 | 0, Je), Hr = +(_[D >> 2] | 0), ye[et >> 3] = Hr * 3, ye[j >> 3] = 0, li = Hr * -1.5, ye[Ke >> 3] = li, ye[te >> 3] = Hr * 2.598076211353316, ye[ot >> 3] = li, ye[he >> 3] = Hr * -2.598076211353316, J = _[Et >> 2] | 0, _[17008 + (J * 80 | 0) + (((P | 0) == (J | 0) ? _[kt >> 2] | 0 : P) << 2) >> 2] | 0) {
                case 1: {
                  S = Ke, P = et;
                  break;
                }
                case 3: {
                  S = ot, P = Ke;
                  break;
                }
                case 2: {
                  S = et, P = ot;
                  break;
                }
                default: {
                  S = 8;
                  break e;
                }
              }
              nf(bt, Je, P, S, je), !(qs(bt, je) | 0) && !(qs(Je, je) | 0) && (rs(je, _[Et >> 2] | 0, E, 1, H + 8 + (_[H >> 2] << 4) | 0), _[H >> 2] = (_[H >> 2] | 0) + 1);
            }
            if ((p | 0) < (B | 0) && (Gr(ve, bt), rs(bt, _[kt >> 2] | 0, E, 1, H + 8 + (_[H >> 2] << 4) | 0), _[H >> 2] = (_[H >> 2] | 0) + 1), p = p + 1 | 0, (p | 0) >= (Le | 0)) {
              S = 3;
              break;
            } else
              P = _[kt >> 2] | 0;
          }
        if ((S | 0) == 3) {
          $e = Yn;
          return;
        } else
          (S | 0) == 8 && en(22557, 22521, 746, 22602);
      }
      function yl(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0, E = 0;
        E = $e, $e = $e + 160 | 0, P = E + 80 | 0, H = E, J = P, g = 20336, p = J + 72 | 0;
        do
          _[J >> 2] = _[g >> 2], J = J + 4 | 0, g = g + 4 | 0;
        while ((J | 0) < (p | 0));
        J = H, g = 20416, p = J + 72 | 0;
        do
          _[J >> 2] = _[g >> 2], J = J + 4 | 0, g = g + 4 | 0;
        while ((J | 0) < (p | 0));
        p = (Oa(_[x >> 2] | 0) | 0) == 0, P = p ? P : H, H = S + 4 | 0, yo(H), Gs(H), Oa(_[x >> 2] | 0) | 0 && (ou(H), _[x >> 2] = (_[x >> 2] | 0) + 1), _[T >> 2] = _[S >> 2], x = T + 4 | 0, _r(H, P, x), zn(x), _[T + 16 >> 2] = _[S >> 2], x = T + 20 | 0, _r(H, P + 12 | 0, x), zn(x), _[T + 32 >> 2] = _[S >> 2], x = T + 36 | 0, _r(H, P + 24 | 0, x), zn(x), _[T + 48 >> 2] = _[S >> 2], x = T + 52 | 0, _r(H, P + 36 | 0, x), zn(x), _[T + 64 >> 2] = _[S >> 2], x = T + 68 | 0, _r(H, P + 48 | 0, x), zn(x), _[T + 80 >> 2] = _[S >> 2], T = T + 84 | 0, _r(H, P + 60 | 0, T), zn(T), $e = E;
      }
      function yi(S) {
        S = +S;
        var x = 0;
        return x = S < 0 ? S + 6.283185307179586 : S, +(S >= 6.283185307179586 ? x + -6.283185307179586 : x);
      }
      function vl(S, x) {
        return S = S | 0, x = x | 0, +tt(+(+ye[S >> 3] - +ye[x >> 3])) < 17453292519943298e-27 ? (x = +tt(+(+ye[S + 8 >> 3] - +ye[x + 8 >> 3])) < 17453292519943298e-27, x | 0) : (x = 0, x | 0);
      }
      function ma(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0;
        return H = +ye[x >> 3], P = +ye[S >> 3], J = +Rt(+((H - P) * 0.5)), T = +Rt(+((+ye[x + 8 >> 3] - +ye[S + 8 >> 3]) * 0.5)), T = J * J + T * (+Bt(+H) * +Bt(+P) * T), +(+Vt(+ +At(+T), + +At(+(1 - T))) * 2);
      }
      function Ca(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0;
        return H = +ye[x >> 3], P = +ye[S >> 3], J = +Rt(+((H - P) * 0.5)), T = +Rt(+((+ye[x + 8 >> 3] - +ye[S + 8 >> 3]) * 0.5)), T = J * J + T * (+Bt(+H) * +Bt(+P) * T), +(+Vt(+ +At(+T), + +At(+(1 - T))) * 2 * 6371.007180918475);
      }
      function Ur(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0;
        return H = +ye[x >> 3], P = +ye[S >> 3], J = +Rt(+((H - P) * 0.5)), T = +Rt(+((+ye[x + 8 >> 3] - +ye[S + 8 >> 3]) * 0.5)), T = J * J + T * (+Bt(+H) * +Bt(+P) * T), +(+Vt(+ +At(+T), + +At(+(1 - T))) * 2 * 6371.007180918475 * 1e3);
      }
      function ih(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0;
        return J = +ye[x >> 3], P = +Bt(+J), H = +ye[x + 8 >> 3] - +ye[S + 8 >> 3], g = P * +Rt(+H), T = +ye[S >> 3], + +Vt(+g, +(+Rt(+J) * +Bt(+T) - +Bt(+H) * (P * +Rt(+T))));
      }
      function Oi(S, x, T, P) {
        S = S | 0, x = +x, T = +T, P = P | 0;
        var H = 0, J = 0, g = 0, p = 0;
        if (T < 1e-16) {
          _[P >> 2] = _[S >> 2], _[P + 4 >> 2] = _[S + 4 >> 2], _[P + 8 >> 2] = _[S + 8 >> 2], _[P + 12 >> 2] = _[S + 12 >> 2];
          return;
        }
        J = x < 0 ? x + 6.283185307179586 : x, J = x >= 6.283185307179586 ? J + -6.283185307179586 : J;
        do
          if (J < 1e-16)
            x = +ye[S >> 3] + T, ye[P >> 3] = x, H = P;
          else {
            if (H = +tt(+(J + -3.141592653589793)) < 1e-16, x = +ye[S >> 3], H) {
              x = x - T, ye[P >> 3] = x, H = P;
              break;
            }
            if (g = +Bt(+T), T = +Rt(+T), x = g * +Rt(+x) + +Bt(+J) * (T * +Bt(+x)), x = x > 1 ? 1 : x, x = +Wr(+(x < -1 ? -1 : x)), ye[P >> 3] = x, +tt(+(x + -1.5707963267948966)) < 1e-16) {
              ye[P >> 3] = 1.5707963267948966, ye[P + 8 >> 3] = 0;
              return;
            }
            if (+tt(+(x + 1.5707963267948966)) < 1e-16) {
              ye[P >> 3] = -1.5707963267948966, ye[P + 8 >> 3] = 0;
              return;
            }
            if (p = +Bt(+x), J = T * +Rt(+J) / p, T = +ye[S >> 3], x = (g - +Rt(+x) * +Rt(+T)) / +Bt(+T) / p, g = J > 1 ? 1 : J, x = x > 1 ? 1 : x, x = +ye[S + 8 >> 3] + +Vt(+(g < -1 ? -1 : g), +(x < -1 ? -1 : x)), x > 3.141592653589793)
              do
                x = x + -6.283185307179586;
              while (x > 3.141592653589793);
            if (x < -3.141592653589793)
              do
                x = x + 6.283185307179586;
              while (x < -3.141592653589793);
            ye[P + 8 >> 3] = x;
            return;
          }
        while (0);
        if (+tt(+(x + -1.5707963267948966)) < 1e-16) {
          ye[H >> 3] = 1.5707963267948966, ye[P + 8 >> 3] = 0;
          return;
        }
        if (+tt(+(x + 1.5707963267948966)) < 1e-16) {
          ye[H >> 3] = -1.5707963267948966, ye[P + 8 >> 3] = 0;
          return;
        }
        if (x = +ye[S + 8 >> 3], x > 3.141592653589793)
          do
            x = x + -6.283185307179586;
          while (x > 3.141592653589793);
        if (x < -3.141592653589793)
          do
            x = x + 6.283185307179586;
          while (x < -3.141592653589793);
        ye[P + 8 >> 3] = x;
      }
      function x0(S) {
        return S = S | 0, + +ye[20496 + (S << 3) >> 3];
      }
      function go(S) {
        return S = S | 0, + +ye[20624 + (S << 3) >> 3];
      }
      function Xf(S) {
        return S = S | 0, + +ye[20752 + (S << 3) >> 3];
      }
      function Hd(S) {
        return S = S | 0, + +ye[20880 + (S << 3) >> 3];
      }
      function Us(S) {
        S = S | 0;
        var x = 0;
        return x = 21008 + (S << 3) | 0, S = _[x >> 2] | 0, $t(_[x + 4 >> 2] | 0), S | 0;
      }
      function cr(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0;
        return te = +ye[x >> 3], D = +ye[S >> 3], E = +Rt(+((te - D) * 0.5)), J = +ye[x + 8 >> 3], B = +ye[S + 8 >> 3], g = +Rt(+((J - B) * 0.5)), p = +Bt(+D), j = +Bt(+te), g = E * E + g * (j * p * g), g = +Vt(+ +At(+g), + +At(+(1 - g))) * 2, E = +ye[T >> 3], te = +Rt(+((E - te) * 0.5)), P = +ye[T + 8 >> 3], J = +Rt(+((P - J) * 0.5)), H = +Bt(+E), J = te * te + J * (j * H * J), J = +Vt(+ +At(+J), + +At(+(1 - J))) * 2, E = +Rt(+((D - E) * 0.5)), P = +Rt(+((B - P) * 0.5)), P = E * E + P * (p * H * P), P = +Vt(+ +At(+P), + +At(+(1 - P))) * 2, H = (g + J + P) * 0.5, +(+pr(+ +At(+(+Lt(+(H * 0.5)) * +Lt(+((H - g) * 0.5)) * +Lt(+((H - J) * 0.5)) * +Lt(+((H - P) * 0.5))))) * 4);
      }
      function Ea(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0;
        if (J = $e, $e = $e + 192 | 0, P = J + 168 | 0, H = J, JA(S, x, P), ia(S, x, H), x = _[H >> 2] | 0, (x | 0) <= 0)
          return T = 0, $e = J, +T;
        if (T = +cr(H + 8 | 0, H + 8 + (((x | 0) != 1 & 1) << 4) | 0, P) + 0, (x | 0) == 1)
          return $e = J, +T;
        S = 1;
        do
          g = S, S = S + 1 | 0, T = T + +cr(H + 8 + (g << 4) | 0, H + 8 + (((S | 0) % (x | 0) | 0) << 4) | 0, P);
        while ((S | 0) < (x | 0));
        return $e = J, +T;
      }
      function oh(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0;
        if (J = $e, $e = $e + 192 | 0, P = J + 168 | 0, H = J, JA(S, x, P), ia(S, x, H), x = _[H >> 2] | 0, (x | 0) > 0) {
          if (T = +cr(H + 8 | 0, H + 8 + (((x | 0) != 1 & 1) << 4) | 0, P) + 0, (x | 0) != 1) {
            S = 1;
            do
              g = S, S = S + 1 | 0, T = T + +cr(H + 8 + (g << 4) | 0, H + 8 + (((S | 0) % (x | 0) | 0) << 4) | 0, P);
            while ((S | 0) < (x | 0));
          }
        } else
          T = 0;
        return $e = J, +(T * 6371.007180918475 * 6371.007180918475);
      }
      function yA(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0;
        if (J = $e, $e = $e + 192 | 0, P = J + 168 | 0, H = J, JA(S, x, P), ia(S, x, H), x = _[H >> 2] | 0, (x | 0) > 0) {
          if (T = +cr(H + 8 | 0, H + 8 + (((x | 0) != 1 & 1) << 4) | 0, P) + 0, (x | 0) != 1) {
            S = 1;
            do
              g = S, S = S + 1 | 0, T = T + +cr(H + 8 + (g << 4) | 0, H + 8 + (((S | 0) % (x | 0) | 0) << 4) | 0, P);
            while ((S | 0) < (x | 0));
          }
        } else
          T = 0;
        return $e = J, +(T * 6371.007180918475 * 6371.007180918475 * 1e3 * 1e3);
      }
      function ra(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0;
        if (g = $e, $e = $e + 176 | 0, J = g, is(S, x, J), S = _[J >> 2] | 0, (S | 0) <= 1)
          return H = 0, $e = g, +H;
        x = S + -1 | 0, S = 0, T = 0, P = +ye[J + 8 >> 3], H = +ye[J + 16 >> 3];
        do
          S = S + 1 | 0, E = P, P = +ye[J + 8 + (S << 4) >> 3], B = +Rt(+((P - E) * 0.5)), p = H, H = +ye[J + 8 + (S << 4) + 8 >> 3], p = +Rt(+((H - p) * 0.5)), p = B * B + p * (+Bt(+P) * +Bt(+E) * p), T = T + +Vt(+ +At(+p), + +At(+(1 - p))) * 2;
        while ((S | 0) < (x | 0));
        return $e = g, +T;
      }
      function Cs(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0;
        if (g = $e, $e = $e + 176 | 0, J = g, is(S, x, J), S = _[J >> 2] | 0, (S | 0) <= 1)
          return H = 0, $e = g, +H;
        x = S + -1 | 0, S = 0, T = 0, P = +ye[J + 8 >> 3], H = +ye[J + 16 >> 3];
        do
          S = S + 1 | 0, E = P, P = +ye[J + 8 + (S << 4) >> 3], B = +Rt(+((P - E) * 0.5)), p = H, H = +ye[J + 8 + (S << 4) + 8 >> 3], p = +Rt(+((H - p) * 0.5)), p = B * B + p * (+Bt(+E) * +Bt(+P) * p), T = T + +Vt(+ +At(+p), + +At(+(1 - p))) * 2;
        while ((S | 0) != (x | 0));
        return B = T * 6371.007180918475, $e = g, +B;
      }
      function k1(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0;
        if (g = $e, $e = $e + 176 | 0, J = g, is(S, x, J), S = _[J >> 2] | 0, (S | 0) <= 1)
          return H = 0, $e = g, +H;
        x = S + -1 | 0, S = 0, T = 0, P = +ye[J + 8 >> 3], H = +ye[J + 16 >> 3];
        do
          S = S + 1 | 0, E = P, P = +ye[J + 8 + (S << 4) >> 3], B = +Rt(+((P - E) * 0.5)), p = H, H = +ye[J + 8 + (S << 4) + 8 >> 3], p = +Rt(+((H - p) * 0.5)), p = B * B + p * (+Bt(+E) * +Bt(+P) * p), T = T + +Vt(+ +At(+p), + +At(+(1 - p))) * 2;
        while ((S | 0) != (x | 0));
        return B = T * 6371.007180918475 * 1e3, $e = g, +B;
      }
      function R0(S, x) {
        return S = S | 0, x = x | 0, x = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, x & 15 | 0;
      }
      function Bl(S, x) {
        return S = S | 0, x = x | 0, x = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, x & 127 | 0;
      }
      function vA(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        if (!(!0 & (x & -16777216 | 0) == 134217728) || (g = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, g = g & 127, g >>> 0 > 121))
          return x = 0, x | 0;
        T = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, T = T & 15;
        do
          if (T | 0) {
            for (H = 1, P = 0; ; ) {
              if (J = Yt(S | 0, x | 0, (15 - H | 0) * 3 | 0) | 0, Ye() | 0, J = J & 7, (J | 0) != 0 & (P ^ 1))
                if ((J | 0) == 1 & (nn(g) | 0) != 0) {
                  p = 0, P = 13;
                  break;
                } else
                  P = 1;
              if ((J | 0) == 7) {
                p = 0, P = 13;
                break;
              }
              if (H >>> 0 < T >>> 0)
                H = H + 1 | 0;
              else {
                P = 9;
                break;
              }
            }
            if ((P | 0) == 9) {
              if ((T | 0) == 15)
                p = 1;
              else
                break;
              return p | 0;
            } else if ((P | 0) == 13)
              return p | 0;
          }
        while (0);
        for (; ; ) {
          if (p = Yt(S | 0, x | 0, (14 - T | 0) * 3 | 0) | 0, Ye() | 0, !((p & 7 | 0) == 7 & !0)) {
            p = 0, P = 13;
            break;
          }
          if (T >>> 0 < 14)
            T = T + 1 | 0;
          else {
            p = 1, P = 13;
            break;
          }
        }
        return (P | 0) == 13 ? p | 0 : 0;
      }
      function Ec(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0;
        if (P = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, P = P & 15, (P | 0) >= (T | 0)) {
          if ((P | 0) != (T | 0))
            if (T >>> 0 <= 15) {
              if (H = gn(T | 0, 0, 52) | 0, S = H | S, x = Ye() | 0 | x & -15728641, (P | 0) > (T | 0))
                do
                  H = gn(7, 0, (14 - T | 0) * 3 | 0) | 0, T = T + 1 | 0, S = H | S, x = Ye() | 0 | x;
                while ((T | 0) < (P | 0));
            } else
              x = 0, S = 0;
        } else
          x = 0, S = 0;
        return $t(x | 0), S | 0;
      }
      function Ma(S, x, T) {
        return S = S | 0, x = x | 0, T = T | 0, S = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, S = S & 15, (T | 0) < 16 & (S | 0) <= (T | 0) ? (T = No(7, T - S | 0) | 0, T | 0) : (T = 0, T | 0);
      }
      function vo(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0;
        if (g = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, g = g & 15, !!((T | 0) < 16 & (g | 0) <= (T | 0))) {
          if ((g | 0) == (T | 0)) {
            T = P, _[T >> 2] = S, _[T + 4 >> 2] = x;
            return;
          }
          if (E = No(7, T - g | 0) | 0, B = (E | 0) / 7 | 0, p = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, !(nn(p & 127) | 0))
            J = 0;
          else {
            e:
              do
                if (!g)
                  H = 0;
                else
                  for (J = 1; ; ) {
                    if (H = Yt(S | 0, x | 0, (15 - J | 0) * 3 | 0) | 0, Ye() | 0, H = H & 7, H | 0)
                      break e;
                    if (J >>> 0 < g >>> 0)
                      J = J + 1 | 0;
                    else {
                      H = 0;
                      break;
                    }
                  }
              while (0);
            J = (H | 0) == 0;
          }
          if (D = gn(g + 1 | 0, 0, 52) | 0, H = Ye() | 0 | x & -15728641, p = (14 - g | 0) * 3 | 0, x = gn(7, 0, p | 0) | 0, x = (D | S) & ~x, g = H & ~(Ye() | 0), vo(x, g, T, P), H = P + (B << 3) | 0, !J) {
            D = gn(1, 0, p | 0) | 0, vo(D | x, Ye() | 0 | g, T, H), D = H + (B << 3) | 0, E = gn(2, 0, p | 0) | 0, vo(E | x, Ye() | 0 | g, T, D), D = D + (B << 3) | 0, E = gn(3, 0, p | 0) | 0, vo(E | x, Ye() | 0 | g, T, D), D = D + (B << 3) | 0, E = gn(4, 0, p | 0) | 0, vo(E | x, Ye() | 0 | g, T, D), D = D + (B << 3) | 0, E = gn(5, 0, p | 0) | 0, vo(E | x, Ye() | 0 | g, T, D), E = gn(6, 0, p | 0) | 0, vo(E | x, Ye() | 0 | g, T, D + (B << 3) | 0);
            return;
          }
          J = H + (B << 3) | 0, (E | 0) > 6 && (E = H + 8 | 0, D = (J >>> 0 > E >>> 0 ? J : E) + -1 + (0 - H) | 0, Ys(H | 0, 0, D + 8 & -8 | 0) | 0, H = E + (D >>> 3 << 3) | 0), D = gn(2, 0, p | 0) | 0, vo(D | x, Ye() | 0 | g, T, H), D = H + (B << 3) | 0, E = gn(3, 0, p | 0) | 0, vo(E | x, Ye() | 0 | g, T, D), D = D + (B << 3) | 0, E = gn(4, 0, p | 0) | 0, vo(E | x, Ye() | 0 | g, T, D), D = D + (B << 3) | 0, E = gn(5, 0, p | 0) | 0, vo(E | x, Ye() | 0 | g, T, D), E = gn(6, 0, p | 0) | 0, vo(E | x, Ye() | 0 | g, T, D + (B << 3) | 0);
        }
      }
      function Fi(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0;
        if (H = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, !(nn(H & 127) | 0))
          return H = 0, H | 0;
        H = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, H = H & 15;
        e:
          do
            if (!H)
              T = 0;
            else
              for (P = 1; ; ) {
                if (T = Yt(S | 0, x | 0, (15 - P | 0) * 3 | 0) | 0, Ye() | 0, T = T & 7, T | 0)
                  break e;
                if (P >>> 0 < H >>> 0)
                  P = P + 1 | 0;
                else {
                  T = 0;
                  break;
                }
              }
          while (0);
        return H = (T | 0) == 0 & 1, H | 0;
      }
      function Zf(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0;
        if (P = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, P = P & 15, (T | 0) < 16 & (P | 0) <= (T | 0)) {
          if ((P | 0) != (T | 0) && (H = gn(T | 0, 0, 52) | 0, S = H | S, x = Ye() | 0 | x & -15728641, (P | 0) < (T | 0)))
            do
              H = gn(7, 0, (14 - P | 0) * 3 | 0) | 0, P = P + 1 | 0, S = S & ~H, x = x & ~(Ye() | 0);
            while ((P | 0) < (T | 0));
        } else
          x = 0, S = 0;
        return $t(x | 0), S | 0;
      }
      function yc(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0, Le = 0, Je = 0, et = 0, Ke = 0, ot = 0, je = 0, Et = 0, Gt = 0, kt = 0, bt = 0;
        if (!T)
          return kt = 0, kt | 0;
        if (H = S, P = _[H >> 2] | 0, H = _[H + 4 >> 2] | 0, !0 & (H & 15728640 | 0) == 0) {
          if ((T | 0) <= 0 || (kt = x, _[kt >> 2] = P, _[kt + 4 >> 2] = H, (T | 0) == 1))
            return kt = 0, kt | 0;
          P = 1;
          do
            Et = S + (P << 3) | 0, Gt = _[Et + 4 >> 2] | 0, kt = x + (P << 3) | 0, _[kt >> 2] = _[Et >> 2], _[kt + 4 >> 2] = Gt, P = P + 1 | 0;
          while ((P | 0) != (T | 0));
          return P = 0, P | 0;
        }
        if (Et = T << 3, Gt = BA(Et) | 0, !Gt)
          return kt = -3, kt | 0;
        if (Vn(Gt | 0, S | 0, Et | 0) | 0, je = bA(T, 8) | 0, !je)
          return Or(Gt), kt = -3, kt | 0;
        P = T;
        e:
          for (; ; ) {
            g = Gt, D = _[g >> 2] | 0, g = _[g + 4 >> 2] | 0, Ke = Yt(D | 0, g | 0, 52) | 0, Ye() | 0, Ke = Ke & 15, ot = Ke + -1 | 0, et = (P | 0) > 0;
            t:
              do
                if (et) {
                  if (Je = ((P | 0) < 0) << 31 >> 31, ve = gn(ot | 0, 0, 52) | 0, Le = Ye() | 0, ot >>> 0 > 15)
                    for (H = 0, S = D, T = g; ; ) {
                      if (!((S | 0) == 0 & (T | 0) == 0)) {
                        if (J = Yt(S | 0, T | 0, 52) | 0, Ye() | 0, J = J & 15, p = (J | 0) < (ot | 0), J = (J | 0) == (ot | 0), B = p ? 0 : J ? S : 0, S = p ? 0 : J ? T : 0, T = ka(B | 0, S | 0, P | 0, Je | 0) | 0, Ye() | 0, J = je + (T << 3) | 0, p = J, E = _[p >> 2] | 0, p = _[p + 4 >> 2] | 0, (E | 0) == 0 & (p | 0) == 0)
                          T = B;
                        else
                          for (ve = 0, he = T, te = p, T = B; ; ) {
                            if ((ve | 0) > (P | 0)) {
                              kt = 41;
                              break e;
                            }
                            if ((E | 0) == (T | 0) & (te & -117440513 | 0) == (S | 0)) {
                              B = Yt(E | 0, te | 0, 56) | 0, Ye() | 0, B = B & 7, j = B + 1 | 0, Le = Yt(E | 0, te | 0, 45) | 0, Ye() | 0;
                              n:
                                do
                                  if (!(nn(Le & 127) | 0))
                                    p = 7;
                                  else {
                                    if (E = Yt(E | 0, te | 0, 52) | 0, Ye() | 0, E = E & 15, !E) {
                                      p = 6;
                                      break;
                                    }
                                    for (p = 1; ; ) {
                                      if (Le = gn(7, 0, (15 - p | 0) * 3 | 0) | 0, !((Le & T | 0) == 0 & ((Ye() | 0) & S | 0) == 0)) {
                                        p = 7;
                                        break n;
                                      }
                                      if (p >>> 0 < E >>> 0)
                                        p = p + 1 | 0;
                                      else {
                                        p = 6;
                                        break;
                                      }
                                    }
                                  }
                                while (0);
                              if ((B + 2 | 0) >>> 0 > p >>> 0) {
                                kt = 51;
                                break e;
                              }
                              Le = gn(j | 0, 0, 56) | 0, S = Ye() | 0 | S & -117440513, p = J, _[p >> 2] = 0, _[p + 4 >> 2] = 0, p = he, T = Le | T;
                            } else
                              p = (he + 1 | 0) % (P | 0) | 0;
                            if (J = je + (p << 3) | 0, te = J, E = _[te >> 2] | 0, te = _[te + 4 >> 2] | 0, (E | 0) == 0 & (te | 0) == 0)
                              break;
                            ve = ve + 1 | 0, he = p;
                          }
                        Le = J, _[Le >> 2] = T, _[Le + 4 >> 2] = S;
                      }
                      if (H = H + 1 | 0, (H | 0) >= (P | 0))
                        break t;
                      T = Gt + (H << 3) | 0, S = _[T >> 2] | 0, T = _[T + 4 >> 2] | 0;
                    }
                  for (H = 0, S = D, T = g; ; ) {
                    if (!((S | 0) == 0 & (T | 0) == 0)) {
                      if (p = Yt(S | 0, T | 0, 52) | 0, Ye() | 0, p = p & 15, (p | 0) >= (ot | 0)) {
                        if ((p | 0) != (ot | 0) && (S = S | ve, T = T & -15728641 | Le, p >>> 0 >= Ke >>> 0)) {
                          J = ot;
                          do
                            he = gn(7, 0, (14 - J | 0) * 3 | 0) | 0, J = J + 1 | 0, S = he | S, T = Ye() | 0 | T;
                          while (J >>> 0 < p >>> 0);
                        }
                      } else
                        S = 0, T = 0;
                      if (p = ka(S | 0, T | 0, P | 0, Je | 0) | 0, Ye() | 0, J = je + (p << 3) | 0, E = J, B = _[E >> 2] | 0, E = _[E + 4 >> 2] | 0, !((B | 0) == 0 & (E | 0) == 0))
                        for (he = 0; ; ) {
                          if ((he | 0) > (P | 0)) {
                            kt = 41;
                            break e;
                          }
                          if ((B | 0) == (S | 0) & (E & -117440513 | 0) == (T | 0)) {
                            j = Yt(B | 0, E | 0, 56) | 0, Ye() | 0, j = j & 7, te = j + 1 | 0, bt = Yt(B | 0, E | 0, 45) | 0, Ye() | 0;
                            n:
                              do
                                if (!(nn(bt & 127) | 0))
                                  E = 7;
                                else {
                                  if (B = Yt(B | 0, E | 0, 52) | 0, Ye() | 0, B = B & 15, !B) {
                                    E = 6;
                                    break;
                                  }
                                  for (E = 1; ; ) {
                                    if (bt = gn(7, 0, (15 - E | 0) * 3 | 0) | 0, !((bt & S | 0) == 0 & ((Ye() | 0) & T | 0) == 0)) {
                                      E = 7;
                                      break n;
                                    }
                                    if (E >>> 0 < B >>> 0)
                                      E = E + 1 | 0;
                                    else {
                                      E = 6;
                                      break;
                                    }
                                  }
                                }
                              while (0);
                            if ((j + 2 | 0) >>> 0 > E >>> 0) {
                              kt = 51;
                              break e;
                            }
                            bt = gn(te | 0, 0, 56) | 0, T = Ye() | 0 | T & -117440513, te = J, _[te >> 2] = 0, _[te + 4 >> 2] = 0, S = bt | S;
                          } else
                            p = (p + 1 | 0) % (P | 0) | 0;
                          if (J = je + (p << 3) | 0, E = J, B = _[E >> 2] | 0, E = _[E + 4 >> 2] | 0, (B | 0) == 0 & (E | 0) == 0)
                            break;
                          he = he + 1 | 0;
                        }
                      bt = J, _[bt >> 2] = S, _[bt + 4 >> 2] = T;
                    }
                    if (H = H + 1 | 0, (H | 0) >= (P | 0))
                      break t;
                    T = Gt + (H << 3) | 0, S = _[T >> 2] | 0, T = _[T + 4 >> 2] | 0;
                  }
                }
              while (0);
            if ((P + 5 | 0) >>> 0 < 11) {
              kt = 99;
              break;
            }
            if (Le = bA((P | 0) / 6 | 0, 8) | 0, !Le) {
              kt = 58;
              break;
            }
            t:
              do
                if (et) {
                  he = 0, te = 0;
                  do {
                    if (p = je + (he << 3) | 0, S = p, H = _[S >> 2] | 0, S = _[S + 4 >> 2] | 0, !((H | 0) == 0 & (S | 0) == 0)) {
                      E = Yt(H | 0, S | 0, 56) | 0, Ye() | 0, E = E & 7, T = E + 1 | 0, B = S & -117440513, bt = Yt(H | 0, S | 0, 45) | 0, Ye() | 0;
                      n:
                        do
                          if (nn(bt & 127) | 0) {
                            if (j = Yt(H | 0, S | 0, 52) | 0, Ye() | 0, j = j & 15, j | 0)
                              for (J = 1; ; ) {
                                if (bt = gn(7, 0, (15 - J | 0) * 3 | 0) | 0, !((H & bt | 0) == 0 & (B & (Ye() | 0) | 0) == 0))
                                  break n;
                                if (J >>> 0 < j >>> 0)
                                  J = J + 1 | 0;
                                else
                                  break;
                              }
                            S = gn(T | 0, 0, 56) | 0, H = S | H, S = Ye() | 0 | B, T = p, _[T >> 2] = H, _[T + 4 >> 2] = S, T = E + 2 | 0;
                          }
                        while (0);
                      (T | 0) == 7 && (bt = Le + (te << 3) | 0, _[bt >> 2] = H, _[bt + 4 >> 2] = S & -117440513, te = te + 1 | 0);
                    }
                    he = he + 1 | 0;
                  } while ((he | 0) != (P | 0));
                  if (et) {
                    if (ve = ((P | 0) < 0) << 31 >> 31, j = gn(ot | 0, 0, 52) | 0, he = Ye() | 0, ot >>> 0 > 15)
                      for (S = 0, H = 0; ; ) {
                        do
                          if (!((D | 0) == 0 & (g | 0) == 0)) {
                            for (E = Yt(D | 0, g | 0, 52) | 0, Ye() | 0, E = E & 15, J = (E | 0) < (ot | 0), E = (E | 0) == (ot | 0), p = J ? 0 : E ? D : 0, E = J ? 0 : E ? g : 0, J = ka(p | 0, E | 0, P | 0, ve | 0) | 0, Ye() | 0, T = 0; ; ) {
                              if ((T | 0) > (P | 0)) {
                                kt = 98;
                                break e;
                              }
                              if (bt = je + (J << 3) | 0, B = _[bt + 4 >> 2] | 0, (B & -117440513 | 0) == (E | 0) && (_[bt >> 2] | 0) == (p | 0)) {
                                kt = 70;
                                break;
                              }
                              if (J = (J + 1 | 0) % (P | 0) | 0, bt = je + (J << 3) | 0, (_[bt >> 2] | 0) == (p | 0) && (_[bt + 4 >> 2] | 0) == (E | 0))
                                break;
                              T = T + 1 | 0;
                            }
                            if ((kt | 0) == 70 && (kt = 0, !0 & (B & 117440512 | 0) == 100663296))
                              break;
                            bt = x + (H << 3) | 0, _[bt >> 2] = D, _[bt + 4 >> 2] = g, H = H + 1 | 0;
                          }
                        while (0);
                        if (S = S + 1 | 0, (S | 0) >= (P | 0)) {
                          P = te;
                          break t;
                        }
                        g = Gt + (S << 3) | 0, D = _[g >> 2] | 0, g = _[g + 4 >> 2] | 0;
                      }
                    for (S = 0, H = 0; ; ) {
                      do
                        if (!((D | 0) == 0 & (g | 0) == 0)) {
                          if (E = Yt(D | 0, g | 0, 52) | 0, Ye() | 0, E = E & 15, (E | 0) >= (ot | 0))
                            if ((E | 0) != (ot | 0))
                              if (T = D | j, J = g & -15728641 | he, E >>> 0 < Ke >>> 0)
                                E = J;
                              else {
                                p = ot;
                                do
                                  bt = gn(7, 0, (14 - p | 0) * 3 | 0) | 0, p = p + 1 | 0, T = bt | T, J = Ye() | 0 | J;
                                while (p >>> 0 < E >>> 0);
                                E = J;
                              }
                            else
                              T = D, E = g;
                          else
                            T = 0, E = 0;
                          for (p = ka(T | 0, E | 0, P | 0, ve | 0) | 0, Ye() | 0, J = 0; ; ) {
                            if ((J | 0) > (P | 0)) {
                              kt = 98;
                              break e;
                            }
                            if (bt = je + (p << 3) | 0, B = _[bt + 4 >> 2] | 0, (B & -117440513 | 0) == (E | 0) && (_[bt >> 2] | 0) == (T | 0)) {
                              kt = 93;
                              break;
                            }
                            if (p = (p + 1 | 0) % (P | 0) | 0, bt = je + (p << 3) | 0, (_[bt >> 2] | 0) == (T | 0) && (_[bt + 4 >> 2] | 0) == (E | 0))
                              break;
                            J = J + 1 | 0;
                          }
                          if ((kt | 0) == 93 && (kt = 0, !0 & (B & 117440512 | 0) == 100663296))
                            break;
                          bt = x + (H << 3) | 0, _[bt >> 2] = D, _[bt + 4 >> 2] = g, H = H + 1 | 0;
                        }
                      while (0);
                      if (S = S + 1 | 0, (S | 0) >= (P | 0)) {
                        P = te;
                        break t;
                      }
                      g = Gt + (S << 3) | 0, D = _[g >> 2] | 0, g = _[g + 4 >> 2] | 0;
                    }
                  } else
                    H = 0, P = te;
                } else
                  H = 0, P = 0;
              while (0);
            if (Ys(je | 0, 0, Et | 0) | 0, Vn(Gt | 0, Le | 0, P << 3 | 0) | 0, Or(Le), P)
              x = x + (H << 3) | 0;
            else
              break;
          }
        return (kt | 0) == 41 ? (Or(Gt), Or(je), bt = -1, bt | 0) : (kt | 0) == 51 ? (Or(Gt), Or(je), bt = -2, bt | 0) : (kt | 0) == 58 ? (Or(Gt), Or(je), bt = -3, bt | 0) : (kt | 0) == 98 ? (Or(Le), Or(Gt), Or(je), bt = -1, bt | 0) : ((kt | 0) == 99 && Vn(x | 0, Gt | 0, P << 3 | 0) | 0, Or(Gt), Or(je), bt = 0, bt | 0);
      }
      function Es(S, x, T, P, H) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0;
        var J = 0, g = 0, p = 0, E = 0, B = 0, D = 0;
        if ((x | 0) <= 0)
          return H = 0, H | 0;
        if ((H | 0) >= 16) {
          for (J = 0; ; ) {
            if (D = S + (J << 3) | 0, !((_[D >> 2] | 0) == 0 & (_[D + 4 >> 2] | 0) == 0)) {
              J = 14;
              break;
            }
            if (J = J + 1 | 0, (J | 0) >= (x | 0)) {
              g = 0, J = 16;
              break;
            }
          }
          if ((J | 0) == 14)
            return ((P | 0) > 0 ? -2 : -1) | 0;
          if ((J | 0) == 16)
            return g | 0;
        }
        J = 0, D = 0;
        e:
          for (; ; ) {
            B = S + (D << 3) | 0, p = B, g = _[p >> 2] | 0, p = _[p + 4 >> 2] | 0;
            do
              if (!((g | 0) == 0 & (p | 0) == 0)) {
                if ((J | 0) >= (P | 0)) {
                  g = -1, J = 16;
                  break e;
                }
                if (E = Yt(g | 0, p | 0, 52) | 0, Ye() | 0, E = E & 15, (E | 0) > (H | 0)) {
                  g = -2, J = 16;
                  break e;
                }
                if ((E | 0) == (H | 0)) {
                  B = T + (J << 3) | 0, _[B >> 2] = g, _[B + 4 >> 2] = p, J = J + 1 | 0;
                  break;
                }
                if (g = (No(7, H - E | 0) | 0) + J | 0, (g | 0) > (P | 0)) {
                  g = -1, J = 16;
                  break e;
                }
                vo(_[B >> 2] | 0, _[B + 4 >> 2] | 0, H, T + (J << 3) | 0), J = g;
              }
            while (0);
            if (D = D + 1 | 0, (D | 0) >= (x | 0)) {
              g = 0, J = 16;
              break;
            }
          }
        return (J | 0) == 16 ? g | 0 : 0;
      }
      function G1(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0;
        if ((x | 0) <= 0)
          return T = 0, T | 0;
        if ((T | 0) >= 16) {
          for (P = 0; ; ) {
            if (g = S + (P << 3) | 0, !((_[g >> 2] | 0) == 0 & (_[g + 4 >> 2] | 0) == 0)) {
              P = -1, H = 13;
              break;
            }
            if (P = P + 1 | 0, (P | 0) >= (x | 0)) {
              P = 0, H = 13;
              break;
            }
          }
          if ((H | 0) == 13)
            return P | 0;
        }
        P = 0, g = 0;
        e:
          for (; ; ) {
            H = S + (g << 3) | 0, J = _[H >> 2] | 0, H = _[H + 4 >> 2] | 0;
            do
              if (!((J | 0) == 0 & (H | 0) == 0)) {
                if (H = Yt(J | 0, H | 0, 52) | 0, Ye() | 0, H = H & 15, (H | 0) > (T | 0)) {
                  P = -1, H = 13;
                  break e;
                }
                if ((H | 0) == (T | 0)) {
                  P = P + 1 | 0;
                  break;
                } else {
                  P = (No(7, T - H | 0) | 0) + P | 0;
                  break;
                }
              }
            while (0);
            if (g = g + 1 | 0, (g | 0) >= (x | 0)) {
              H = 13;
              break;
            }
          }
        return (H | 0) == 13 ? P | 0 : 0;
      }
      function sh(S, x) {
        return S = S | 0, x = x | 0, x = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, x & 1 | 0;
      }
      function vi(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0;
        if (H = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, H = H & 15, !H)
          return H = 0, H | 0;
        for (P = 1; ; ) {
          if (T = Yt(S | 0, x | 0, (15 - P | 0) * 3 | 0) | 0, Ye() | 0, T = T & 7, T | 0) {
            P = 5;
            break;
          }
          if (P >>> 0 < H >>> 0)
            P = P + 1 | 0;
          else {
            T = 0, P = 5;
            break;
          }
        }
        return (P | 0) == 5 ? T | 0 : 0;
      }
      function vc(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0;
        if (E = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, E = E & 15, !E)
          return p = x, E = S, $t(p | 0), E | 0;
        for (p = 1, T = 0; ; ) {
          J = (15 - p | 0) * 3 | 0, P = gn(7, 0, J | 0) | 0, H = Ye() | 0, g = Yt(S | 0, x | 0, J | 0) | 0, Ye() | 0, J = gn(Wf(g & 7) | 0, 0, J | 0) | 0, g = Ye() | 0, S = J | S & ~P, x = g | x & ~H;
          e:
            do
              if (!T)
                if ((J & P | 0) == 0 & (g & H | 0) == 0)
                  T = 0;
                else if (P = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, P = P & 15, !P)
                  T = 1;
                else {
                  T = 1;
                  t:
                    for (; ; ) {
                      switch (g = Yt(S | 0, x | 0, (15 - T | 0) * 3 | 0) | 0, Ye() | 0, g & 7) {
                        case 1:
                          break t;
                        case 0:
                          break;
                        default: {
                          T = 1;
                          break e;
                        }
                      }
                      if (T >>> 0 < P >>> 0)
                        T = T + 1 | 0;
                      else {
                        T = 1;
                        break e;
                      }
                    }
                  for (T = 1; ; )
                    if (g = (15 - T | 0) * 3 | 0, H = Yt(S | 0, x | 0, g | 0) | 0, Ye() | 0, J = gn(7, 0, g | 0) | 0, x = x & ~(Ye() | 0), g = gn(Wf(H & 7) | 0, 0, g | 0) | 0, S = S & ~J | g, x = x | (Ye() | 0), T >>> 0 < P >>> 0)
                      T = T + 1 | 0;
                    else {
                      T = 1;
                      break;
                    }
                }
            while (0);
          if (p >>> 0 < E >>> 0)
            p = p + 1 | 0;
          else
            break;
        }
        return $t(x | 0), S | 0;
      }
      function Hs(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0;
        if (P = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, P = P & 15, !P)
          return T = x, P = S, $t(T | 0), P | 0;
        for (T = 1; J = (15 - T | 0) * 3 | 0, g = Yt(S | 0, x | 0, J | 0) | 0, Ye() | 0, H = gn(7, 0, J | 0) | 0, x = x & ~(Ye() | 0), J = gn(Wf(g & 7) | 0, 0, J | 0) | 0, S = J | S & ~H, x = Ye() | 0 | x, T >>> 0 < P >>> 0; )
          T = T + 1 | 0;
        return $t(x | 0), S | 0;
      }
      function U1(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0;
        if (E = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, E = E & 15, !E)
          return p = x, E = S, $t(p | 0), E | 0;
        for (p = 1, T = 0; ; ) {
          J = (15 - p | 0) * 3 | 0, P = gn(7, 0, J | 0) | 0, H = Ye() | 0, g = Yt(S | 0, x | 0, J | 0) | 0, Ye() | 0, J = gn(fo(g & 7) | 0, 0, J | 0) | 0, g = Ye() | 0, S = J | S & ~P, x = g | x & ~H;
          e:
            do
              if (!T)
                if ((J & P | 0) == 0 & (g & H | 0) == 0)
                  T = 0;
                else if (P = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, P = P & 15, !P)
                  T = 1;
                else {
                  T = 1;
                  t:
                    for (; ; ) {
                      switch (g = Yt(S | 0, x | 0, (15 - T | 0) * 3 | 0) | 0, Ye() | 0, g & 7) {
                        case 1:
                          break t;
                        case 0:
                          break;
                        default: {
                          T = 1;
                          break e;
                        }
                      }
                      if (T >>> 0 < P >>> 0)
                        T = T + 1 | 0;
                      else {
                        T = 1;
                        break e;
                      }
                    }
                  for (T = 1; ; )
                    if (H = (15 - T | 0) * 3 | 0, J = gn(7, 0, H | 0) | 0, g = x & ~(Ye() | 0), x = Yt(S | 0, x | 0, H | 0) | 0, Ye() | 0, x = gn(fo(x & 7) | 0, 0, H | 0) | 0, S = S & ~J | x, x = g | (Ye() | 0), T >>> 0 < P >>> 0)
                      T = T + 1 | 0;
                    else {
                      T = 1;
                      break;
                    }
                }
            while (0);
          if (p >>> 0 < E >>> 0)
            p = p + 1 | 0;
          else
            break;
        }
        return $t(x | 0), S | 0;
      }
      function $s(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0;
        if (P = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, P = P & 15, !P)
          return T = x, P = S, $t(T | 0), P | 0;
        for (T = 1; g = (15 - T | 0) * 3 | 0, J = gn(7, 0, g | 0) | 0, H = x & ~(Ye() | 0), x = Yt(S | 0, x | 0, g | 0) | 0, Ye() | 0, x = gn(fo(x & 7) | 0, 0, g | 0) | 0, S = x | S & ~J, x = Ye() | 0 | H, T >>> 0 < P >>> 0; )
          T = T + 1 | 0;
        return $t(x | 0), S | 0;
      }
      function H1(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0;
        if (E = $e, $e = $e + 64 | 0, p = E + 40 | 0, P = E + 24 | 0, H = E + 12 | 0, J = E, gn(x | 0, 0, 52) | 0, T = Ye() | 0 | 134225919, !x)
          return (_[S + 4 >> 2] | 0) > 2 || (_[S + 8 >> 2] | 0) > 2 || (_[S + 12 >> 2] | 0) > 2 ? (g = 0, p = 0, $t(g | 0), $e = E, p | 0) : (gn(Zn(S) | 0, 0, 45) | 0, g = Ye() | 0 | T, p = -1, $t(g | 0), $e = E, p | 0);
        if (_[p >> 2] = _[S >> 2], _[p + 4 >> 2] = _[S + 4 >> 2], _[p + 8 >> 2] = _[S + 8 >> 2], _[p + 12 >> 2] = _[S + 12 >> 2], g = p + 4 | 0, (x | 0) > 0)
          for (S = -1; _[P >> 2] = _[g >> 2], _[P + 4 >> 2] = _[g + 4 >> 2], _[P + 8 >> 2] = _[g + 8 >> 2], x & 1 ? (EA(g), _[H >> 2] = _[g >> 2], _[H + 4 >> 2] = _[g + 4 >> 2], _[H + 8 >> 2] = _[g + 8 >> 2], uo(H)) : (co(g), _[H >> 2] = _[g >> 2], _[H + 4 >> 2] = _[g + 4 >> 2], _[H + 8 >> 2] = _[g + 8 >> 2], ou(H)), ms(P, H, J), zn(J), D = (15 - x | 0) * 3 | 0, B = gn(7, 0, D | 0) | 0, T = T & ~(Ye() | 0), D = gn(mc(J) | 0, 0, D | 0) | 0, S = D | S & ~B, T = Ye() | 0 | T, (x | 0) > 1; )
            x = x + -1 | 0;
        else
          S = -1;
        e:
          do
            if ((_[g >> 2] | 0) <= 2 && (_[p + 8 >> 2] | 0) <= 2 && (_[p + 12 >> 2] | 0) <= 2) {
              if (P = Zn(p) | 0, x = gn(P | 0, 0, 45) | 0, x = x | S, S = Ye() | 0 | T & -1040385, J = Wi(p) | 0, !(nn(P) | 0)) {
                if ((J | 0) <= 0)
                  break;
                for (H = 0; ; ) {
                  if (P = Yt(x | 0, S | 0, 52) | 0, Ye() | 0, P = P & 15, P)
                    for (T = 1; D = (15 - T | 0) * 3 | 0, p = Yt(x | 0, S | 0, D | 0) | 0, Ye() | 0, B = gn(7, 0, D | 0) | 0, S = S & ~(Ye() | 0), D = gn(Wf(p & 7) | 0, 0, D | 0) | 0, x = x & ~B | D, S = S | (Ye() | 0), T >>> 0 < P >>> 0; )
                      T = T + 1 | 0;
                  if (H = H + 1 | 0, (H | 0) == (J | 0))
                    break e;
                }
              }
              H = Yt(x | 0, S | 0, 52) | 0, Ye() | 0, H = H & 15;
              t:
                do
                  if (H) {
                    T = 1;
                    n:
                      for (; ; ) {
                        switch (D = Yt(x | 0, S | 0, (15 - T | 0) * 3 | 0) | 0, Ye() | 0, D & 7) {
                          case 1:
                            break n;
                          case 0:
                            break;
                          default:
                            break t;
                        }
                        if (T >>> 0 < H >>> 0)
                          T = T + 1 | 0;
                        else
                          break t;
                      }
                    if (na(P, _[p >> 2] | 0) | 0)
                      for (T = 1; p = (15 - T | 0) * 3 | 0, B = gn(7, 0, p | 0) | 0, D = S & ~(Ye() | 0), S = Yt(x | 0, S | 0, p | 0) | 0, Ye() | 0, S = gn(fo(S & 7) | 0, 0, p | 0) | 0, x = x & ~B | S, S = D | (Ye() | 0), T >>> 0 < H >>> 0; )
                        T = T + 1 | 0;
                    else
                      for (T = 1; D = (15 - T | 0) * 3 | 0, p = Yt(x | 0, S | 0, D | 0) | 0, Ye() | 0, B = gn(7, 0, D | 0) | 0, S = S & ~(Ye() | 0), D = gn(Wf(p & 7) | 0, 0, D | 0) | 0, x = x & ~B | D, S = S | (Ye() | 0), T >>> 0 < H >>> 0; )
                        T = T + 1 | 0;
                  }
                while (0);
              if ((J | 0) > 0) {
                T = 0;
                do
                  x = vc(x, S) | 0, S = Ye() | 0, T = T + 1 | 0;
                while ((T | 0) != (J | 0));
              }
            } else
              x = 0, S = 0;
          while (0);
        return B = S, D = x, $t(B | 0), $e = E, D | 0;
      }
      function Oa(S) {
        return S = S | 0, (S | 0) % 2 | 0 | 0;
      }
      function ah(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0;
        return P = $e, $e = $e + 16 | 0, T = P, x >>> 0 <= 15 && (_[S + 4 >> 2] & 2146435072 | 0) != 2146435072 && (_[S + 8 + 4 >> 2] & 2146435072 | 0) != 2146435072 ? (P1(S, x, T), x = H1(T, x) | 0, S = Ye() | 0) : (S = 0, x = 0), $t(S | 0), $e = P, x | 0;
      }
      function Im(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0;
        if (H = T + 4 | 0, J = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, J = J & 15, g = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, P = (J | 0) == 0, nn(g & 127) | 0) {
          if (P)
            return g = 1, g | 0;
          P = 1;
        } else {
          if (P)
            return g = 0, g | 0;
          !(_[H >> 2] | 0) && !(_[T + 8 >> 2] | 0) ? P = (_[T + 12 >> 2] | 0) != 0 & 1 : P = 1;
        }
        for (T = 1; T & 1 ? uo(H) : ou(H), g = Yt(S | 0, x | 0, (15 - T | 0) * 3 | 0) | 0, Ye() | 0, F1(H, g & 7), T >>> 0 < J >>> 0; )
          T = T + 1 | 0;
        return P | 0;
      }
      function $d(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0;
        D = $e, $e = $e + 16 | 0, E = D, B = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, B = B & 127;
        e:
          do
            if (nn(B) | 0 && (J = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, J = J & 15, (J | 0) != 0)) {
              P = 1;
              t:
                for (; ; ) {
                  switch (p = Yt(S | 0, x | 0, (15 - P | 0) * 3 | 0) | 0, Ye() | 0, p & 7) {
                    case 5:
                      break t;
                    case 0:
                      break;
                    default: {
                      P = x;
                      break e;
                    }
                  }
                  if (P >>> 0 < J >>> 0)
                    P = P + 1 | 0;
                  else {
                    P = x;
                    break e;
                  }
                }
              for (H = 1, P = x; x = (15 - H | 0) * 3 | 0, g = gn(7, 0, x | 0) | 0, p = P & ~(Ye() | 0), P = Yt(S | 0, P | 0, x | 0) | 0, Ye() | 0, P = gn(fo(P & 7) | 0, 0, x | 0) | 0, S = S & ~g | P, P = p | (Ye() | 0), H >>> 0 < J >>> 0; )
                H = H + 1 | 0;
            } else
              P = x;
          while (0);
        if (p = 7728 + (B * 28 | 0) | 0, _[T >> 2] = _[p >> 2], _[T + 4 >> 2] = _[p + 4 >> 2], _[T + 8 >> 2] = _[p + 8 >> 2], _[T + 12 >> 2] = _[p + 12 >> 2], !(Im(S, P, T) | 0)) {
          $e = D;
          return;
        }
        if (g = T + 4 | 0, _[E >> 2] = _[g >> 2], _[E + 4 >> 2] = _[g + 4 >> 2], _[E + 8 >> 2] = _[g + 8 >> 2], J = Yt(S | 0, P | 0, 52) | 0, Ye() | 0, p = J & 15, J & 1 ? (ou(g), J = p + 1 | 0) : J = p, !(nn(B) | 0))
          P = 0;
        else {
          e:
            do
              if (!p)
                P = 0;
              else
                for (x = 1; ; ) {
                  if (H = Yt(S | 0, P | 0, (15 - x | 0) * 3 | 0) | 0, Ye() | 0, H = H & 7, H | 0) {
                    P = H;
                    break e;
                  }
                  if (x >>> 0 < p >>> 0)
                    x = x + 1 | 0;
                  else {
                    P = 0;
                    break;
                  }
                }
            while (0);
          P = (P | 0) == 4 & 1;
        }
        if (!(Ku(T, J, P, 0) | 0))
          (J | 0) != (p | 0) && (_[g >> 2] = _[E >> 2], _[g + 4 >> 2] = _[E + 4 >> 2], _[g + 8 >> 2] = _[E + 8 >> 2]);
        else {
          if (nn(B) | 0)
            do
              ;
            while (Ku(T, J, 0, 0) | 0);
          (J | 0) != (p | 0) && co(g);
        }
        $e = D;
      }
      function JA(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0;
        P = $e, $e = $e + 16 | 0, H = P, $d(S, x, H), x = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, El(H, x & 15, T), $e = P;
      }
      function ia(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0;
        g = $e, $e = $e + 16 | 0, J = g, $d(S, x, J), P = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, P = (nn(P & 127) | 0) == 0, H = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, H = H & 15;
        e:
          do
            if (!P) {
              if (H | 0)
                for (P = 1; ; ) {
                  if (p = gn(7, 0, (15 - P | 0) * 3 | 0) | 0, !((p & S | 0) == 0 & ((Ye() | 0) & x | 0) == 0))
                    break e;
                  if (P >>> 0 < H >>> 0)
                    P = P + 1 | 0;
                  else
                    break;
                }
              su(J, H, 0, 5, T), $e = g;
              return;
            }
          while (0);
        Xr(J, H, 0, 6, T), $e = g;
      }
      function ys(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0;
        if (P = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, !(nn(P & 127) | 0))
          return P = 2, P | 0;
        if (P = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, P = P & 15, !P)
          return P = 5, P | 0;
        for (T = 1; ; ) {
          if (H = gn(7, 0, (15 - T | 0) * 3 | 0) | 0, !((H & S | 0) == 0 & ((Ye() | 0) & x | 0) == 0)) {
            T = 2, S = 6;
            break;
          }
          if (T >>> 0 < P >>> 0)
            T = T + 1 | 0;
          else {
            T = 5, S = 6;
            break;
          }
        }
        return (S | 0) == 6 ? T | 0 : 0;
      }
      function Ah(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0;
        j = $e, $e = $e + 128 | 0, B = j + 112 | 0, J = j + 96 | 0, D = j, H = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, p = H & 15, _[B >> 2] = p, g = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, g = g & 127;
        e:
          do
            if (nn(g) | 0) {
              if (p | 0)
                for (P = 1; ; ) {
                  if (E = gn(7, 0, (15 - P | 0) * 3 | 0) | 0, !((E & S | 0) == 0 & ((Ye() | 0) & x | 0) == 0)) {
                    H = 0;
                    break e;
                  }
                  if (P >>> 0 < p >>> 0)
                    P = P + 1 | 0;
                  else
                    break;
                }
              if (H & 1)
                H = 1;
              else {
                E = gn(p + 1 | 0, 0, 52) | 0, D = Ye() | 0 | x & -15728641, B = gn(7, 0, (14 - p | 0) * 3 | 0) | 0, Ah((E | S) & ~B, D & ~(Ye() | 0), T), $e = j;
                return;
              }
            } else
              H = 0;
          while (0);
        $d(S, x, J), H ? (rh(J, B, D), E = 5) : (yl(J, B, D), E = 6);
        e:
          do
            if (nn(g) | 0)
              if (!p)
                P = 20;
              else
                for (P = 1; ; ) {
                  if (g = gn(7, 0, (15 - P | 0) * 3 | 0) | 0, !((g & S | 0) == 0 & ((Ye() | 0) & x | 0) == 0)) {
                    P = 8;
                    break e;
                  }
                  if (P >>> 0 < p >>> 0)
                    P = P + 1 | 0;
                  else {
                    P = 20;
                    break;
                  }
                }
            else
              P = 8;
          while (0);
        if (Ys(T | 0, -1, P | 0) | 0, H) {
          H = 0;
          do {
            for (J = D + (H << 4) | 0, ny(J, _[B >> 2] | 0) | 0, J = _[J >> 2] | 0, P = 0; g = T + (P << 2) | 0, p = _[g >> 2] | 0, !((p | 0) == -1 | (p | 0) == (J | 0)); )
              P = P + 1 | 0;
            _[g >> 2] = J, H = H + 1 | 0;
          } while ((H | 0) != (E | 0));
        } else {
          H = 0;
          do {
            for (J = D + (H << 4) | 0, Ku(J, _[B >> 2] | 0, 0, 1) | 0, J = _[J >> 2] | 0, P = 0; g = T + (P << 2) | 0, p = _[g >> 2] | 0, !((p | 0) == -1 | (p | 0) == (J | 0)); )
              P = P + 1 | 0;
            _[g >> 2] = J, H = H + 1 | 0;
          } while ((H | 0) != (E | 0));
        }
        $e = j;
      }
      function oa() {
        return 12;
      }
      function Fa(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0;
        if (gn(S | 0, 0, 52) | 0, p = Ye() | 0 | 134225919, (S | 0) < 1) {
          P = 0, T = 0;
          do
            nn(P) | 0 && (gn(P | 0, 0, 45) | 0, g = p | (Ye() | 0), S = x + (T << 3) | 0, _[S >> 2] = -1, _[S + 4 >> 2] = g, T = T + 1 | 0), P = P + 1 | 0;
          while ((P | 0) != 122);
          return;
        }
        g = 0, T = 0;
        do {
          if (nn(g) | 0) {
            for (gn(g | 0, 0, 45) | 0, P = 1, H = -1, J = p | (Ye() | 0); E = gn(7, 0, (15 - P | 0) * 3 | 0) | 0, H = H & ~E, J = J & ~(Ye() | 0), (P | 0) != (S | 0); )
              P = P + 1 | 0;
            E = x + (T << 3) | 0, _[E >> 2] = H, _[E + 4 >> 2] = J, T = T + 1 | 0;
          }
          g = g + 1 | 0;
        } while ((g | 0) != 122);
      }
      function Wu(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0, g = 0, p = 0, E = 0, B = 0;
        if (p = $e, $e = $e + 64 | 0, g = p, (S | 0) == (T | 0) & (x | 0) == (P | 0) | (!1 | (x & 2013265920 | 0) != 134217728 | (!1 | (P & 2013265920 | 0) != 134217728)) || (H = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, H = H & 15, J = Yt(T | 0, P | 0, 52) | 0, Ye() | 0, (H | 0) != (J & 15 | 0)))
          return g = 0, $e = p, g | 0;
        if (J = H + -1 | 0, H >>> 0 > 1 && (B = Ec(S, x, J) | 0, E = Ye() | 0, J = Ec(T, P, J) | 0, (B | 0) == (J | 0) & (E | 0) == (Ye() | 0)) && (J = (H ^ 15) * 3 | 0, H = Yt(S | 0, x | 0, J | 0) | 0, Ye() | 0, H = H & 7, J = Yt(T | 0, P | 0, J | 0) | 0, Ye() | 0, J = J & 7, (H | 0) == 0 | (J | 0) == 0 || (_[21136 + (H << 2) >> 2] | 0) == (J | 0) || (_[21168 + (H << 2) >> 2] | 0) == (J | 0)))
          return B = 1, $e = p, B | 0;
        H = g, J = H + 56 | 0;
        do
          _[H >> 2] = 0, H = H + 4 | 0;
        while ((H | 0) < (J | 0));
        return ml(S, x, 1, g), B = g, !((_[B >> 2] | 0) == (T | 0) && (_[B + 4 >> 2] | 0) == (P | 0)) && (B = g + 8 | 0, !((_[B >> 2] | 0) == (T | 0) && (_[B + 4 >> 2] | 0) == (P | 0))) && (B = g + 16 | 0, !((_[B >> 2] | 0) == (T | 0) && (_[B + 4 >> 2] | 0) == (P | 0))) && (B = g + 24 | 0, !((_[B >> 2] | 0) == (T | 0) && (_[B + 4 >> 2] | 0) == (P | 0))) && (B = g + 32 | 0, !((_[B >> 2] | 0) == (T | 0) && (_[B + 4 >> 2] | 0) == (P | 0))) && (B = g + 40 | 0, !((_[B >> 2] | 0) == (T | 0) && (_[B + 4 >> 2] | 0) == (P | 0))) ? (H = g + 48 | 0, H = ((_[H >> 2] | 0) == (T | 0) ? (_[H + 4 >> 2] | 0) == (P | 0) : 0) & 1) : H = 1, B = H, $e = p, B | 0;
      }
      function mm(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0;
        if (B = $e, $e = $e + 16 | 0, g = B, !(Wu(S, x, T, P) | 0))
          return p = 0, E = 0, $t(p | 0), $e = B, E | 0;
        for (p = x & -2130706433, H = (Fi(S, x) | 0) == 0, H = H ? 1 : 2; _[g >> 2] = 0, D = Ne(S, x, H, g) | 0, J = H + 1 | 0, !((D | 0) == (T | 0) & (Ye() | 0) == (P | 0)); )
          if (J >>> 0 < 7)
            H = J;
          else {
            H = 0, S = 0, E = 6;
            break;
          }
        return (E | 0) == 6 ? ($t(H | 0), $e = B, S | 0) : (D = gn(H | 0, 0, 56) | 0, E = p | (Ye() | 0) | 268435456, D = S | D, $t(E | 0), $e = B, D | 0);
      }
      function eg(S, x) {
        S = S | 0, x = x | 0;
        var T = 0;
        return T = !0 & (x & 2013265920 | 0) == 268435456, $t((T ? x & -2130706433 | 134217728 : 0) | 0), (T ? S : 0) | 0;
      }
      function Xu(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0;
        return P = $e, $e = $e + 16 | 0, T = P, !0 & (x & 2013265920 | 0) == 268435456 ? (H = Yt(S | 0, x | 0, 56) | 0, Ye() | 0, _[T >> 2] = 0, T = Ne(S, x & -2130706433 | 134217728, H & 7, T) | 0, x = Ye() | 0, $t(x | 0), $e = P, T | 0) : (x = 0, T = 0, $t(x | 0), $e = P, T | 0);
      }
      function au(S, x) {
        S = S | 0, x = x | 0;
        var T = 0;
        if (!(!0 & (x & 2013265920 | 0) == 268435456))
          return T = 0, T | 0;
        switch (T = Yt(S | 0, x | 0, 56) | 0, Ye() | 0, T & 7) {
          case 0:
          case 7:
            return T = 0, T | 0;
        }
        return T = x & -2130706433 | 134217728, !0 & (x & 117440512 | 0) == 16777216 & (Fi(S, T) | 0) != 0 ? (T = 0, T | 0) : (T = vA(S, T) | 0, T | 0);
      }
      function vs(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0;
        J = $e, $e = $e + 16 | 0, P = J, g = !0 & (x & 2013265920 | 0) == 268435456, H = x & -2130706433 | 134217728, p = T, _[p >> 2] = g ? S : 0, _[p + 4 >> 2] = g ? H : 0, g ? (x = Yt(S | 0, x | 0, 56) | 0, Ye() | 0, _[P >> 2] = 0, S = Ne(S, H, x & 7, P) | 0, x = Ye() | 0) : (S = 0, x = 0), p = T + 8 | 0, _[p >> 2] = S, _[p + 4 >> 2] = x, $e = J;
      }
      function KA(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0;
        H = (Fi(S, x) | 0) == 0, x = x & -2130706433, P = T, _[P >> 2] = H ? S : 0, _[P + 4 >> 2] = H ? x | 285212672 : 0, P = T + 8 | 0, _[P >> 2] = S, _[P + 4 >> 2] = x | 301989888, P = T + 16 | 0, _[P >> 2] = S, _[P + 4 >> 2] = x | 318767104, P = T + 24 | 0, _[P >> 2] = S, _[P + 4 >> 2] = x | 335544320, P = T + 32 | 0, _[P >> 2] = S, _[P + 4 >> 2] = x | 352321536, T = T + 40 | 0, _[T >> 2] = S, _[T + 4 >> 2] = x | 369098752;
      }
      function is(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0;
        if (g = $e, $e = $e + 16 | 0, J = g, P = Yt(S | 0, x | 0, 56) | 0, Ye() | 0, p = !0 & (x & 2013265920 | 0) == 268435456, H = p ? S : 0, S = p ? x & -2130706433 | 134217728 : 0, x = rf(H, S, P & 7) | 0, (x | 0) == -1) {
          _[T >> 2] = 0, $e = g;
          return;
        }
        $d(H, S, J), P = Yt(H | 0, S | 0, 52) | 0, Ye() | 0, P = P & 15, Fi(H, S) | 0 ? su(J, P, x, 2, T) : Xr(J, P, x, 2, T), $e = g;
      }
      function $1(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0;
        return x = bA(1, 12) | 0, x || en(22691, 22646, 49, 22704), T = S + 4 | 0, P = _[T >> 2] | 0, P | 0 ? (P = P + 8 | 0, _[P >> 2] = x, _[T >> 2] = x, x | 0) : (_[S >> 2] | 0 && en(22721, 22646, 61, 22744), P = S, _[P >> 2] = x, _[T >> 2] = x, x | 0);
      }
      function Zu(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0;
        return P = BA(24) | 0, P || en(22758, 22646, 78, 22772), _[P >> 2] = _[x >> 2], _[P + 4 >> 2] = _[x + 4 >> 2], _[P + 8 >> 2] = _[x + 8 >> 2], _[P + 12 >> 2] = _[x + 12 >> 2], _[P + 16 >> 2] = 0, x = S + 4 | 0, T = _[x >> 2] | 0, T | 0 ? (_[T + 16 >> 2] = P, _[x >> 2] = P, P | 0) : (_[S >> 2] | 0 && en(22787, 22646, 82, 22772), _[S >> 2] = P, _[x >> 2] = P, P | 0);
      }
      function lh(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0;
        if (S)
          for (P = 1; ; ) {
            if (x = _[S >> 2] | 0, x | 0)
              do {
                if (T = _[x >> 2] | 0, T | 0)
                  do
                    H = T, T = _[T + 16 >> 2] | 0, Or(H);
                  while (T | 0);
                H = x, x = _[x + 8 >> 2] | 0, Or(H);
              } while (x | 0);
            if (x = S, S = _[S + 8 >> 2] | 0, P || Or(x), S)
              P = 0;
            else
              break;
          }
      }
      function os(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0, Le = 0, Je = 0, et = 0, Ke = 0, ot = 0, je = 0, Et = 0, Gt = 0, kt = 0, bt = 0, Yn = 0, Hr = 0, li = 0, Ui = 0, hi = 0, Zi = 0, Bo = 0, xr = 0;
        if (H = S + 8 | 0, _[H >> 2] | 0)
          return xr = 1, xr | 0;
        if (P = _[S >> 2] | 0, !P)
          return xr = 0, xr | 0;
        x = P, T = 0;
        do
          T = T + 1 | 0, x = _[x + 8 >> 2] | 0;
        while (x | 0);
        if (T >>> 0 < 2)
          return xr = 0, xr | 0;
        Zi = BA(T << 2) | 0, Zi || en(22807, 22646, 317, 22826), hi = BA(T << 5) | 0, hi || en(22848, 22646, 321, 22826), _[S >> 2] = 0, Gt = S + 4 | 0, _[Gt >> 2] = 0, _[H >> 2] = 0, T = 0, Ui = 0, Et = 0, j = 0;
        e:
          for (; ; ) {
            if (D = _[P >> 2] | 0, D) {
              J = 0, g = D;
              do {
                if (E = +ye[g + 8 >> 3], x = g, g = _[g + 16 >> 2] | 0, B = (g | 0) == 0, H = B ? D : g, p = +ye[H + 8 >> 3], +tt(+(E - p)) > 3.141592653589793) {
                  xr = 14;
                  break;
                }
                J = J + (p - E) * (+ye[x >> 3] + +ye[H >> 3]);
              } while (!B);
              if ((xr | 0) == 14) {
                xr = 0, J = 0, x = D;
                do
                  je = +ye[x + 8 >> 3], li = x + 16 | 0, Hr = _[li >> 2] | 0, Hr = Hr | 0 ? Hr : D, ot = +ye[Hr + 8 >> 3], J = J + (+ye[x >> 3] + +ye[Hr >> 3]) * ((ot < 0 ? ot + 6.283185307179586 : ot) - (je < 0 ? je + 6.283185307179586 : je)), x = _[(x | 0 ? li : P) >> 2] | 0;
                while (x | 0);
              }
              J > 0 ? (_[Zi + (Ui << 2) >> 2] = P, Ui = Ui + 1 | 0, H = Et, x = j) : xr = 19;
            } else
              xr = 19;
            if ((xr | 0) == 19) {
              xr = 0;
              do
                if (T) {
                  if (x = T + 8 | 0, _[x >> 2] | 0) {
                    xr = 21;
                    break e;
                  }
                  if (T = bA(1, 12) | 0, !T) {
                    xr = 23;
                    break e;
                  }
                  _[x >> 2] = T, H = T + 4 | 0, g = T, x = j;
                } else if (j) {
                  H = Gt, g = j + 8 | 0, x = P, T = S;
                  break;
                } else if (_[S >> 2] | 0) {
                  xr = 27;
                  break e;
                } else {
                  H = Gt, g = S, x = P, T = S;
                  break;
                }
              while (0);
              if (_[g >> 2] = P, _[H >> 2] = P, g = hi + (Et << 5) | 0, B = _[P >> 2] | 0, B) {
                for (D = hi + (Et << 5) + 8 | 0, ye[D >> 3] = 17976931348623157e292, j = hi + (Et << 5) + 24 | 0, ye[j >> 3] = 17976931348623157e292, ye[g >> 3] = -17976931348623157e292, te = hi + (Et << 5) + 16 | 0, ye[te >> 3] = -17976931348623157e292, et = 17976931348623157e292, Ke = -17976931348623157e292, H = 0, he = B, E = 17976931348623157e292, Le = 17976931348623157e292, Je = -17976931348623157e292, p = -17976931348623157e292; J = +ye[he >> 3], je = +ye[he + 8 >> 3], he = _[he + 16 >> 2] | 0, ve = (he | 0) == 0, ot = +ye[(ve ? B : he) + 8 >> 3], J < E && (ye[D >> 3] = J, E = J), je < Le && (ye[j >> 3] = je, Le = je), J > Je ? ye[g >> 3] = J : J = Je, je > p && (ye[te >> 3] = je, p = je), et = je > 0 & je < et ? je : et, Ke = je < 0 & je > Ke ? je : Ke, H = H | +tt(+(je - ot)) > 3.141592653589793, !ve; )
                  Je = J;
                H && (ye[te >> 3] = Ke, ye[j >> 3] = et);
              } else
                _[g >> 2] = 0, _[g + 4 >> 2] = 0, _[g + 8 >> 2] = 0, _[g + 12 >> 2] = 0, _[g + 16 >> 2] = 0, _[g + 20 >> 2] = 0, _[g + 24 >> 2] = 0, _[g + 28 >> 2] = 0;
              H = Et + 1 | 0;
            }
            if (li = P + 8 | 0, P = _[li >> 2] | 0, _[li >> 2] = 0, P)
              Et = H, j = x;
            else {
              xr = 45;
              break;
            }
          }
        if ((xr | 0) == 21)
          en(22624, 22646, 35, 22658);
        else if ((xr | 0) == 23)
          en(22678, 22646, 37, 22658);
        else if ((xr | 0) == 27)
          en(22721, 22646, 61, 22744);
        else if ((xr | 0) == 45) {
          e:
            do
              if ((Ui | 0) > 0) {
                for (li = (H | 0) == 0, Yn = H << 2, Hr = (S | 0) == 0, bt = 0, x = 0; ; ) {
                  if (kt = _[Zi + (bt << 2) >> 2] | 0, li)
                    xr = 73;
                  else {
                    if (Et = BA(Yn) | 0, !Et) {
                      xr = 50;
                      break;
                    }
                    if (Gt = BA(Yn) | 0, !Gt) {
                      xr = 52;
                      break;
                    }
                    t:
                      do
                        if (Hr)
                          T = 0;
                        else {
                          for (H = 0, T = 0, g = S; P = hi + (H << 5) | 0, Bs(_[g >> 2] | 0, P, _[kt >> 2] | 0) | 0 ? (_[Et + (T << 2) >> 2] = g, _[Gt + (T << 2) >> 2] = P, ve = T + 1 | 0) : ve = T, g = _[g + 8 >> 2] | 0, g; )
                            H = H + 1 | 0, T = ve;
                          if ((ve | 0) > 0)
                            if (P = _[Et >> 2] | 0, (ve | 0) == 1)
                              T = P;
                            else
                              for (te = 0, he = -1, T = P, j = P; ; ) {
                                for (B = _[j >> 2] | 0, P = 0, g = 0; H = _[_[Et + (g << 2) >> 2] >> 2] | 0, (H | 0) == (B | 0) ? D = P : D = P + ((Bs(H, _[Gt + (g << 2) >> 2] | 0, _[B >> 2] | 0) | 0) & 1) | 0, g = g + 1 | 0, (g | 0) != (ve | 0); )
                                  P = D;
                                if (H = (D | 0) > (he | 0), T = H ? j : T, P = te + 1 | 0, (P | 0) == (ve | 0))
                                  break t;
                                te = P, he = H ? D : he, j = _[Et + (P << 2) >> 2] | 0;
                              }
                          else
                            T = 0;
                        }
                      while (0);
                    if (Or(Et), Or(Gt), T) {
                      if (H = T + 4 | 0, P = _[H >> 2] | 0, P)
                        T = P + 8 | 0;
                      else if (_[T >> 2] | 0) {
                        xr = 70;
                        break;
                      }
                      _[T >> 2] = kt, _[H >> 2] = kt;
                    } else
                      xr = 73;
                  }
                  if ((xr | 0) == 73) {
                    if (xr = 0, x = _[kt >> 2] | 0, x | 0)
                      do
                        Gt = x, x = _[x + 16 >> 2] | 0, Or(Gt);
                      while (x | 0);
                    Or(kt), x = 2;
                  }
                  if (bt = bt + 1 | 0, (bt | 0) >= (Ui | 0)) {
                    Bo = x;
                    break e;
                  }
                }
                (xr | 0) == 50 ? en(22863, 22646, 249, 22882) : (xr | 0) == 52 ? en(22901, 22646, 252, 22882) : (xr | 0) == 70 && en(22721, 22646, 61, 22744);
              } else
                Bo = 0;
            while (0);
          return Or(Zi), Or(hi), xr = Bo, xr | 0;
        }
        return 0;
      }
      function Bs(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0;
        if (!(pc(x, T) | 0) || (x = ns(x) | 0, B = +ye[T >> 3], P = +ye[T + 8 >> 3], P = x & P < 0 ? P + 6.283185307179586 : P, S = _[S >> 2] | 0, !S))
          return S = 0, S | 0;
        if (x) {
          x = 0, T = S;
          e:
            for (; ; ) {
              for (; g = +ye[T >> 3], E = +ye[T + 8 >> 3], T = T + 16 | 0, D = _[T >> 2] | 0, D = D | 0 ? D : S, J = +ye[D >> 3], H = +ye[D + 8 >> 3], g > J ? (p = g, g = E) : (p = J, J = g, g = H, H = E), !!(B < J | B > p); )
                if (T = _[T >> 2] | 0, !T) {
                  T = 22;
                  break e;
                }
              if (E = H < 0 ? H + 6.283185307179586 : H, g = g < 0 ? g + 6.283185307179586 : g, P = g == P | E == P ? P + -2220446049250313e-31 : P, E = E + (B - J) / (p - J) * (g - E), (E < 0 ? E + 6.283185307179586 : E) > P && (x = x ^ 1), T = _[T >> 2] | 0, !T) {
                T = 22;
                break;
              }
            }
          if ((T | 0) == 22)
            return x | 0;
        } else {
          x = 0, T = S;
          e:
            for (; ; ) {
              for (; g = +ye[T >> 3], E = +ye[T + 8 >> 3], T = T + 16 | 0, D = _[T >> 2] | 0, D = D | 0 ? D : S, J = +ye[D >> 3], H = +ye[D + 8 >> 3], g > J ? (p = g, g = E) : (p = J, J = g, g = H, H = E), !!(B < J | B > p); )
                if (T = _[T >> 2] | 0, !T) {
                  T = 22;
                  break e;
                }
              if (P = g == P | H == P ? P + -2220446049250313e-31 : P, H + (B - J) / (p - J) * (g - H) > P && (x = x ^ 1), T = _[T >> 2] | 0, !T) {
                T = 22;
                break;
              }
            }
          if ((T | 0) == 22)
            return x | 0;
        }
        return 0;
      }
      function bs(S, x, T, P, H) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0;
        var J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0, Le = 0, Je = 0, et = 0, Ke = 0;
        if (Ke = $e, $e = $e + 32 | 0, et = Ke + 16 | 0, Je = Ke, J = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, J = J & 15, he = Yt(T | 0, P | 0, 52) | 0, Ye() | 0, (J | 0) != (he & 15 | 0))
          return et = 1, $e = Ke, et | 0;
        if (B = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, B = B & 127, D = Yt(T | 0, P | 0, 45) | 0, Ye() | 0, D = D & 127, he = (B | 0) != (D | 0), he) {
          if (p = La(B, D) | 0, (p | 0) == 7)
            return et = 2, $e = Ke, et | 0;
          E = La(D, B) | 0, (E | 0) == 7 ? en(22925, 22949, 151, 22959) : (ve = p, g = E);
        } else
          ve = 0, g = 0;
        j = nn(B) | 0, te = nn(D) | 0, _[et >> 2] = 0, _[et + 4 >> 2] = 0, _[et + 8 >> 2] = 0, _[et + 12 >> 2] = 0;
        do
          if (ve) {
            if (D = _[4304 + (B * 28 | 0) + (ve << 2) >> 2] | 0, p = (D | 0) > 0, te)
              if (p) {
                B = 0, E = T, p = P;
                do
                  E = U1(E, p) | 0, p = Ye() | 0, g = fo(g) | 0, (g | 0) == 1 && (g = fo(1) | 0), B = B + 1 | 0;
                while ((B | 0) != (D | 0));
                D = g, B = E, E = p;
              } else
                D = g, B = T, E = P;
            else if (p) {
              B = 0, E = T, p = P;
              do
                E = $s(E, p) | 0, p = Ye() | 0, g = fo(g) | 0, B = B + 1 | 0;
              while ((B | 0) != (D | 0));
              D = g, B = E, E = p;
            } else
              D = g, B = T, E = P;
            if (Im(B, E, et) | 0, he || en(22972, 22949, 181, 22959), p = (j | 0) != 0, g = (te | 0) != 0, p & g && en(22999, 22949, 182, 22959), p) {
              if (g = vi(S, x) | 0, Me[22032 + (g * 7 | 0) + ve >> 0] | 0) {
                J = 3;
                break;
              }
              E = _[21200 + (g * 28 | 0) + (ve << 2) >> 2] | 0, B = E, Le = 26;
            } else if (g) {
              if (g = vi(B, E) | 0, Me[22032 + (g * 7 | 0) + D >> 0] | 0) {
                J = 4;
                break;
              }
              B = 0, E = _[21200 + (D * 28 | 0) + (g << 2) >> 2] | 0, Le = 26;
            } else
              g = 0;
            if ((Le | 0) == 26)
              if ((E | 0) <= -1 && en(23030, 22949, 212, 22959), (B | 0) <= -1 && en(23053, 22949, 213, 22959), (E | 0) > 0) {
                p = et + 4 | 0, g = 0;
                do
                  S0(p), g = g + 1 | 0;
                while ((g | 0) != (E | 0));
                g = B;
              } else
                g = B;
            if (_[Je >> 2] = 0, _[Je + 4 >> 2] = 0, _[Je + 8 >> 2] = 0, F1(Je, ve), J | 0)
              for (; Oa(J) | 0 ? uo(Je) : ou(Je), (J | 0) > 1; )
                J = J + -1 | 0;
            if ((g | 0) > 0) {
              J = 0;
              do
                S0(Je), J = J + 1 | 0;
              while ((J | 0) != (g | 0));
            }
            Le = et + 4 | 0, _r(Le, Je, Le), zn(Le), Le = 50;
          } else if (Im(T, P, et) | 0, (j | 0) != 0 & (te | 0) != 0)
            if ((D | 0) != (B | 0) && en(23077, 22949, 243, 22959), g = vi(S, x) | 0, J = vi(T, P) | 0, Me[22032 + (g * 7 | 0) + J >> 0] | 0)
              J = 5;
            else if (g = _[21200 + (g * 28 | 0) + (J << 2) >> 2] | 0, (g | 0) > 0) {
              p = et + 4 | 0, J = 0;
              do
                S0(p), J = J + 1 | 0;
              while ((J | 0) != (g | 0));
              Le = 50;
            } else
              Le = 50;
          else
            Le = 50;
        while (0);
        return (Le | 0) == 50 && (J = et + 4 | 0, _[H >> 2] = _[J >> 2], _[H + 4 >> 2] = _[J + 4 >> 2], _[H + 8 >> 2] = _[J + 8 >> 2], J = 0), et = J, $e = Ke, et | 0;
      }
      function Xa(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0, Le = 0, Je = 0, et = 0, Ke = 0;
        if (ve = $e, $e = $e + 48 | 0, g = ve + 36 | 0, p = ve + 24 | 0, E = ve + 12 | 0, B = ve, J = Yt(S | 0, x | 0, 52) | 0, Ye() | 0, J = J & 15, te = Yt(S | 0, x | 0, 45) | 0, Ye() | 0, te = te & 127, D = nn(te) | 0, gn(J | 0, 0, 52) | 0, Je = Ye() | 0 | 134225919, Le = P, _[Le >> 2] = -1, _[Le + 4 >> 2] = Je, !J)
          return (_[T >> 2] | 0) > 1 || (_[T + 4 >> 2] | 0) > 1 || (_[T + 8 >> 2] | 0) > 1 || (H = Cl(te, mc(T) | 0) | 0, (H | 0) == 127) ? (Je = 1, $e = ve, Je | 0) : (he = gn(H | 0, 0, 45) | 0, Le = Ye() | 0, te = P, Le = _[te + 4 >> 2] & -1040385 | Le, Je = P, _[Je >> 2] = _[te >> 2] | he, _[Je + 4 >> 2] = Le, Je = 0, $e = ve, Je | 0);
        for (_[g >> 2] = _[T >> 2], _[g + 4 >> 2] = _[T + 4 >> 2], _[g + 8 >> 2] = _[T + 8 >> 2]; _[p >> 2] = _[g >> 2], _[p + 4 >> 2] = _[g + 4 >> 2], _[p + 8 >> 2] = _[g + 8 >> 2], Oa(J) | 0 ? (EA(g), _[E >> 2] = _[g >> 2], _[E + 4 >> 2] = _[g + 4 >> 2], _[E + 8 >> 2] = _[g + 8 >> 2], uo(E)) : (co(g), _[E >> 2] = _[g >> 2], _[E + 4 >> 2] = _[g + 4 >> 2], _[E + 8 >> 2] = _[g + 8 >> 2], ou(E)), ms(p, E, B), zn(B), Le = P, et = _[Le >> 2] | 0, Le = _[Le + 4 >> 2] | 0, Ke = (15 - J | 0) * 3 | 0, T = gn(7, 0, Ke | 0) | 0, Le = Le & ~(Ye() | 0), Ke = gn(mc(B) | 0, 0, Ke | 0) | 0, Le = Ye() | 0 | Le, Je = P, _[Je >> 2] = Ke | et & ~T, _[Je + 4 >> 2] = Le, (J | 0) > 1; )
          J = J + -1 | 0;
        e:
          do
            if ((_[g >> 2] | 0) <= 1 && (_[g + 4 >> 2] | 0) <= 1 && (_[g + 8 >> 2] | 0) <= 1) {
              J = mc(g) | 0, p = Cl(te, J) | 0, (p | 0) == 127 ? B = 0 : B = nn(p) | 0;
              t:
                do
                  if (J) {
                    if (D) {
                      if (g = 21408 + ((vi(S, x) | 0) * 28 | 0) + (J << 2) | 0, g = _[g >> 2] | 0, (g | 0) > 0) {
                        T = 0;
                        do
                          J = Wf(J) | 0, T = T + 1 | 0;
                        while ((T | 0) != (g | 0));
                      }
                      if ((J | 0) == 1) {
                        H = 3;
                        break e;
                      }
                      T = Cl(te, J) | 0, (T | 0) == 127 && en(23104, 22949, 376, 23134), nn(T) | 0 ? en(23147, 22949, 377, 23134) : (he = g, j = J, H = T);
                    } else
                      he = 0, j = J, H = p;
                    if (E = _[4304 + (te * 28 | 0) + (j << 2) >> 2] | 0, (E | 0) <= -1 && en(23178, 22949, 384, 23134), !B) {
                      if ((he | 0) <= -1 && en(23030, 22949, 417, 23134), he | 0) {
                        g = P, J = 0, T = _[g >> 2] | 0, g = _[g + 4 >> 2] | 0;
                        do
                          T = Hs(T, g) | 0, g = Ye() | 0, Ke = P, _[Ke >> 2] = T, _[Ke + 4 >> 2] = g, J = J + 1 | 0;
                        while ((J | 0) < (he | 0));
                      }
                      if ((E | 0) <= 0) {
                        J = 54;
                        break;
                      }
                      for (g = P, J = 0, T = _[g >> 2] | 0, g = _[g + 4 >> 2] | 0; ; )
                        if (T = Hs(T, g) | 0, g = Ye() | 0, Ke = P, _[Ke >> 2] = T, _[Ke + 4 >> 2] = g, J = J + 1 | 0, (J | 0) == (E | 0)) {
                          J = 54;
                          break t;
                        }
                    }
                    if (p = La(H, te) | 0, (p | 0) == 7 && en(22925, 22949, 393, 23134), J = P, T = _[J >> 2] | 0, J = _[J + 4 >> 2] | 0, (E | 0) > 0) {
                      g = 0;
                      do
                        T = Hs(T, J) | 0, J = Ye() | 0, Ke = P, _[Ke >> 2] = T, _[Ke + 4 >> 2] = J, g = g + 1 | 0;
                      while ((g | 0) != (E | 0));
                    }
                    if (T = vi(T, J) | 0, Ke = Xn(H) | 0, T = _[(Ke ? 21824 : 21616) + (p * 28 | 0) + (T << 2) >> 2] | 0, (T | 0) <= -1 && en(23030, 22949, 412, 23134), !T)
                      J = 54;
                    else {
                      p = P, J = 0, g = _[p >> 2] | 0, p = _[p + 4 >> 2] | 0;
                      do
                        g = vc(g, p) | 0, p = Ye() | 0, Ke = P, _[Ke >> 2] = g, _[Ke + 4 >> 2] = p, J = J + 1 | 0;
                      while ((J | 0) < (T | 0));
                      J = 54;
                    }
                  } else if ((D | 0) != 0 & (B | 0) != 0)
                    if (Ke = vi(S, x) | 0, J = P, J = 21408 + (Ke * 28 | 0) + ((vi(_[J >> 2] | 0, _[J + 4 >> 2] | 0) | 0) << 2) | 0, J = _[J >> 2] | 0, (J | 0) <= -1 && en(23201, 22949, 433, 23134), !J)
                      H = p, J = 55;
                    else {
                      g = P, H = 0, T = _[g >> 2] | 0, g = _[g + 4 >> 2] | 0;
                      do
                        T = Hs(T, g) | 0, g = Ye() | 0, Ke = P, _[Ke >> 2] = T, _[Ke + 4 >> 2] = g, H = H + 1 | 0;
                      while ((H | 0) < (J | 0));
                      H = p, J = 54;
                    }
                  else
                    H = p, J = 54;
                while (0);
              if ((J | 0) == 54 && B && (J = 55), (J | 0) == 55 && (Ke = P, (vi(_[Ke >> 2] | 0, _[Ke + 4 >> 2] | 0) | 0) == 1)) {
                H = 4;
                break;
              }
              Ke = P, Je = _[Ke >> 2] | 0, Ke = _[Ke + 4 >> 2] & -1040385, et = gn(H | 0, 0, 45) | 0, Ke = Ke | (Ye() | 0), H = P, _[H >> 2] = Je | et, _[H + 4 >> 2] = Ke, H = 0;
            } else
              H = 2;
          while (0);
        return Ke = H, $e = ve, Ke | 0;
      }
      function D0(S, x, T, P, H) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0;
        var J = 0, g = 0;
        return g = $e, $e = $e + 16 | 0, J = g, S = bs(S, x, T, P, J) | 0, S || (Cc(J, H), S = 0), $e = g, S | 0;
      }
      function ch(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0;
        return H = $e, $e = $e + 16 | 0, J = H, Q0(T, J), P = Xa(S, x, J, P) | 0, $e = H, P | 0;
      }
      function ef(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0, g = 0;
        return g = $e, $e = $e + 32 | 0, H = g + 12 | 0, J = g, !(bs(S, x, S, x, H) | 0) && !(bs(S, x, T, P, J) | 0) ? S = Ju(H, J) | 0 : S = -1, $e = g, S | 0;
      }
      function Pa(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0, g = 0;
        return g = $e, $e = $e + 32 | 0, H = g + 12 | 0, J = g, !(bs(S, x, S, x, H) | 0) && !(bs(S, x, T, P, J) | 0) ? S = Ju(H, J) | 0 : S = -1, $e = g, (S >>> 31 ^ 1) + S | 0;
      }
      function ry(S, x, T, P, H) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0;
        var J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0, Le = 0, Je = 0, et = 0, Ke = 0, ot = 0, je = 0, Et = 0, Gt = 0;
        if (Et = $e, $e = $e + 48 | 0, J = Et + 24 | 0, g = Et + 12 | 0, je = Et, !(bs(S, x, S, x, J) | 0) && !(bs(S, x, T, P, g) | 0)) {
          if (ot = Ju(J, g) | 0, (ot | 0) < 0)
            return je = ot, $e = Et, je | 0;
          for (_[J >> 2] = 0, _[J + 4 >> 2] = 0, _[J + 8 >> 2] = 0, _[g >> 2] = 0, _[g + 4 >> 2] = 0, _[g + 8 >> 2] = 0, bs(S, x, S, x, J) | 0, bs(S, x, T, P, g) | 0, ki(J), ki(g), ot ? (D = _[J >> 2] | 0, he = +(ot | 0), Je = J + 4 | 0, j = _[Je >> 2] | 0, et = J + 8 | 0, te = _[et >> 2] | 0, Ke = J, T = D, P = j, J = te, ve = +((_[g >> 2] | 0) - D | 0) / he, Le = +((_[g + 4 >> 2] | 0) - j | 0) / he, he = +((_[g + 8 >> 2] | 0) - te | 0) / he) : (P = J + 4 | 0, te = J + 8 | 0, Je = P, et = te, Ke = J, T = _[J >> 2] | 0, P = _[P >> 2] | 0, J = _[te >> 2] | 0, ve = 0, Le = 0, he = 0), _[je >> 2] = T, te = je + 4 | 0, _[te >> 2] = P, j = je + 8 | 0, _[j >> 2] = J, D = 0; ; ) {
            E = +(D | 0), Gt = ve * E + +(T | 0), p = Le * E + +(_[Je >> 2] | 0), E = he * E + +(_[et >> 2] | 0), P = ~~+_c(+Gt), g = ~~+_c(+p), T = ~~+_c(+E), Gt = +tt(+(+(P | 0) - Gt)), p = +tt(+(+(g | 0) - p)), E = +tt(+(+(T | 0) - E));
            do
              if (Gt > p & Gt > E)
                P = 0 - (g + T) | 0, J = g;
              else if (B = 0 - P | 0, p > E) {
                J = B - T | 0;
                break;
              } else {
                J = g, T = B - g | 0;
                break;
              }
            while (0);
            if (_[je >> 2] = P, _[te >> 2] = J, _[j >> 2] = T, Dn(je), Xa(S, x, je, H + (D << 3) | 0) | 0, (D | 0) == (ot | 0))
              break;
            D = D + 1 | 0, T = _[Ke >> 2] | 0;
          }
          return je = 0, $e = Et, je | 0;
        }
        return je = -1, $e = Et, je | 0;
      }
      function No(S, x) {
        S = S | 0, x = x | 0;
        var T = 0;
        if (!x)
          return T = 1, T | 0;
        T = S, S = 1;
        do
          S = kn(x & 1 | 0 ? T : 1, S) | 0, x = x >> 1, T = kn(T, T) | 0;
        while (x | 0);
        return S | 0;
      }
      function qd(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0;
        if (!(pc(x, T) | 0) || (x = ns(x) | 0, te = +ye[T >> 3], P = +ye[T + 8 >> 3], P = x & P < 0 ? P + 6.283185307179586 : P, j = _[S >> 2] | 0, (j | 0) <= 0))
          return j = 0, j | 0;
        if (D = _[S + 4 >> 2] | 0, x) {
          x = 0, T = -1, S = 0;
          e:
            for (; ; ) {
              for (B = S; g = +ye[D + (B << 4) >> 3], E = +ye[D + (B << 4) + 8 >> 3], S = (T + 2 | 0) % (j | 0) | 0, J = +ye[D + (S << 4) >> 3], H = +ye[D + (S << 4) + 8 >> 3], g > J ? (p = g, g = E) : (p = J, J = g, g = H, H = E), !!(te < J | te > p); )
                if (T = B + 1 | 0, (T | 0) < (j | 0))
                  S = B, B = T, T = S;
                else {
                  T = 22;
                  break e;
                }
              if (E = H < 0 ? H + 6.283185307179586 : H, g = g < 0 ? g + 6.283185307179586 : g, P = g == P | E == P ? P + -2220446049250313e-31 : P, E = E + (te - J) / (p - J) * (g - E), (E < 0 ? E + 6.283185307179586 : E) > P && (x = x ^ 1), S = B + 1 | 0, (S | 0) >= (j | 0)) {
                T = 22;
                break;
              } else
                T = B;
            }
          if ((T | 0) == 22)
            return x | 0;
        } else {
          x = 0, T = -1, S = 0;
          e:
            for (; ; ) {
              for (B = S; g = +ye[D + (B << 4) >> 3], E = +ye[D + (B << 4) + 8 >> 3], S = (T + 2 | 0) % (j | 0) | 0, J = +ye[D + (S << 4) >> 3], H = +ye[D + (S << 4) + 8 >> 3], g > J ? (p = g, g = E) : (p = J, J = g, g = H, H = E), !!(te < J | te > p); )
                if (T = B + 1 | 0, (T | 0) < (j | 0))
                  S = B, B = T, T = S;
                else {
                  T = 22;
                  break e;
                }
              if (P = g == P | H == P ? P + -2220446049250313e-31 : P, H + (te - J) / (p - J) * (g - H) > P && (x = x ^ 1), S = B + 1 | 0, (S | 0) >= (j | 0)) {
                T = 22;
                break;
              } else
                T = B;
            }
          if ((T | 0) == 22)
            return x | 0;
        }
        return 0;
      }
      function Za(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0, Le = 0, Je = 0, et = 0, Ke = 0;
        if (ve = _[S >> 2] | 0, !ve) {
          _[x >> 2] = 0, _[x + 4 >> 2] = 0, _[x + 8 >> 2] = 0, _[x + 12 >> 2] = 0, _[x + 16 >> 2] = 0, _[x + 20 >> 2] = 0, _[x + 24 >> 2] = 0, _[x + 28 >> 2] = 0;
          return;
        }
        if (Le = x + 8 | 0, ye[Le >> 3] = 17976931348623157e292, Je = x + 24 | 0, ye[Je >> 3] = 17976931348623157e292, ye[x >> 3] = -17976931348623157e292, et = x + 16 | 0, ye[et >> 3] = -17976931348623157e292, !((ve | 0) <= 0)) {
          for (te = _[S + 4 >> 2] | 0, B = 17976931348623157e292, D = -17976931348623157e292, j = 0, S = -1, J = 17976931348623157e292, g = 17976931348623157e292, E = -17976931348623157e292, P = -17976931348623157e292, he = 0; T = +ye[te + (he << 4) >> 3], p = +ye[te + (he << 4) + 8 >> 3], S = S + 2 | 0, H = +ye[te + (((S | 0) == (ve | 0) ? 0 : S) << 4) + 8 >> 3], T < J && (ye[Le >> 3] = T, J = T), p < g && (ye[Je >> 3] = p, g = p), T > E ? ye[x >> 3] = T : T = E, p > P && (ye[et >> 3] = p, P = p), B = p > 0 & p < B ? p : B, D = p < 0 & p > D ? p : D, j = j | +tt(+(p - H)) > 3.141592653589793, S = he + 1 | 0, (S | 0) != (ve | 0); )
            Ke = he, E = T, he = S, S = Ke;
          j && (ye[et >> 3] = D, ye[Je >> 3] = B);
        }
      }
      function Yo(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0, Le = 0, Je = 0, et = 0, Ke = 0, ot = 0, je = 0, Et = 0, Gt = 0, kt = 0;
        if (ve = _[S >> 2] | 0, ve) {
          if (Le = x + 8 | 0, ye[Le >> 3] = 17976931348623157e292, Je = x + 24 | 0, ye[Je >> 3] = 17976931348623157e292, ye[x >> 3] = -17976931348623157e292, et = x + 16 | 0, ye[et >> 3] = -17976931348623157e292, (ve | 0) > 0) {
            for (H = _[S + 4 >> 2] | 0, te = 17976931348623157e292, he = -17976931348623157e292, P = 0, T = -1, E = 17976931348623157e292, B = 17976931348623157e292, j = -17976931348623157e292, g = -17976931348623157e292, Ke = 0; J = +ye[H + (Ke << 4) >> 3], D = +ye[H + (Ke << 4) + 8 >> 3], Gt = T + 2 | 0, p = +ye[H + (((Gt | 0) == (ve | 0) ? 0 : Gt) << 4) + 8 >> 3], J < E && (ye[Le >> 3] = J, E = J), D < B && (ye[Je >> 3] = D, B = D), J > j ? ye[x >> 3] = J : J = j, D > g && (ye[et >> 3] = D, g = D), te = D > 0 & D < te ? D : te, he = D < 0 & D > he ? D : he, P = P | +tt(+(D - p)) > 3.141592653589793, T = Ke + 1 | 0, (T | 0) != (ve | 0); )
              Gt = Ke, j = J, Ke = T, T = Gt;
            P && (ye[et >> 3] = he, ye[Je >> 3] = te);
          }
        } else
          _[x >> 2] = 0, _[x + 4 >> 2] = 0, _[x + 8 >> 2] = 0, _[x + 12 >> 2] = 0, _[x + 16 >> 2] = 0, _[x + 20 >> 2] = 0, _[x + 24 >> 2] = 0, _[x + 28 >> 2] = 0;
        if (Gt = S + 8 | 0, T = _[Gt >> 2] | 0, !((T | 0) <= 0)) {
          Et = S + 12 | 0, je = 0;
          do
            if (H = _[Et >> 2] | 0, P = je, je = je + 1 | 0, Je = x + (je << 5) | 0, et = _[H + (P << 3) >> 2] | 0, et) {
              if (Ke = x + (je << 5) + 8 | 0, ye[Ke >> 3] = 17976931348623157e292, S = x + (je << 5) + 24 | 0, ye[S >> 3] = 17976931348623157e292, ye[Je >> 3] = -17976931348623157e292, ot = x + (je << 5) + 16 | 0, ye[ot >> 3] = -17976931348623157e292, (et | 0) > 0) {
                for (ve = _[H + (P << 3) + 4 >> 2] | 0, te = 17976931348623157e292, he = -17976931348623157e292, H = 0, P = -1, Le = 0, E = 17976931348623157e292, B = 17976931348623157e292, D = -17976931348623157e292, g = -17976931348623157e292; J = +ye[ve + (Le << 4) >> 3], j = +ye[ve + (Le << 4) + 8 >> 3], P = P + 2 | 0, p = +ye[ve + (((P | 0) == (et | 0) ? 0 : P) << 4) + 8 >> 3], J < E && (ye[Ke >> 3] = J, E = J), j < B && (ye[S >> 3] = j, B = j), J > D ? ye[Je >> 3] = J : J = D, j > g && (ye[ot >> 3] = j, g = j), te = j > 0 & j < te ? j : te, he = j < 0 & j > he ? j : he, H = H | +tt(+(j - p)) > 3.141592653589793, P = Le + 1 | 0, (P | 0) != (et | 0); )
                  kt = Le, Le = P, D = J, P = kt;
                H && (ye[ot >> 3] = he, ye[S >> 3] = te);
              }
            } else
              _[Je >> 2] = 0, _[Je + 4 >> 2] = 0, _[Je + 8 >> 2] = 0, _[Je + 12 >> 2] = 0, _[Je + 16 >> 2] = 0, _[Je + 20 >> 2] = 0, _[Je + 24 >> 2] = 0, _[Je + 28 >> 2] = 0, T = _[Gt >> 2] | 0;
          while ((je | 0) < (T | 0));
        }
      }
      function eA(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0;
        if (!(qd(S, x, T) | 0))
          return H = 0, H | 0;
        if (H = S + 8 | 0, (_[H >> 2] | 0) <= 0)
          return H = 1, H | 0;
        for (P = S + 12 | 0, S = 0; ; ) {
          if (J = S, S = S + 1 | 0, qd((_[P >> 2] | 0) + (J << 3) | 0, x + (S << 5) | 0, T) | 0) {
            S = 0, P = 6;
            break;
          }
          if ((S | 0) >= (_[H >> 2] | 0)) {
            S = 1, P = 6;
            break;
          }
        }
        return (P | 0) == 6 ? S | 0 : 0;
      }
      function tf() {
        return 8;
      }
      function uh() {
        return 16;
      }
      function WA() {
        return 168;
      }
      function fh() {
        return 8;
      }
      function ya() {
        return 16;
      }
      function tA() {
        return 12;
      }
      function ho() {
        return 8;
      }
      function iy(S) {
        S = S | 0;
        var x = 0, T = 0;
        return T = +ye[S >> 3], x = +ye[S + 8 >> 3], + +At(+(T * T + x * x));
      }
      function nf(S, x, T, P, H) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0;
        var J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0;
        B = +ye[S >> 3], E = +ye[x >> 3] - B, p = +ye[S + 8 >> 3], g = +ye[x + 8 >> 3] - p, j = +ye[T >> 3], J = +ye[P >> 3] - j, te = +ye[T + 8 >> 3], D = +ye[P + 8 >> 3] - te, J = (J * (p - te) - (B - j) * D) / (E * D - g * J), ye[H >> 3] = B + E * J, ye[H + 8 >> 3] = p + g * J;
      }
      function qs(S, x) {
        return S = S | 0, x = x | 0, +ye[S >> 3] != +ye[x >> 3] ? (x = 0, x | 0) : (x = +ye[S + 8 >> 3] == +ye[x + 8 >> 3], x | 0);
      }
      function Gi(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0;
        return H = +ye[S >> 3] - +ye[x >> 3], P = +ye[S + 8 >> 3] - +ye[x + 8 >> 3], T = +ye[S + 16 >> 3] - +ye[x + 16 >> 3], +(H * H + P * P + T * T);
      }
      function oy(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0;
        T = +ye[S >> 3], P = +Bt(+T), T = +Rt(+T), ye[x + 16 >> 3] = T, T = +ye[S + 8 >> 3], H = P * +Bt(+T), ye[x >> 3] = H, T = P * +Rt(+T), ye[x + 8 >> 3] = T;
      }
      function gh(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0;
        if (B = $e, $e = $e + 32 | 0, H = B + 16 | 0, J = B, $d(S, x, H), g = Bl(S, x) | 0, E = vi(S, x) | 0, To(g, J), x = pm(g, _[H >> 2] | 0) | 0, !(nn(g) | 0))
          return E = x, $e = B, E | 0;
        do
          switch (g | 0) {
            case 4: {
              S = 0, T = 14;
              break;
            }
            case 14: {
              S = 1, T = 14;
              break;
            }
            case 24: {
              S = 2, T = 14;
              break;
            }
            case 38: {
              S = 3, T = 14;
              break;
            }
            case 49: {
              S = 4, T = 14;
              break;
            }
            case 58: {
              S = 5, T = 14;
              break;
            }
            case 63: {
              S = 6, T = 14;
              break;
            }
            case 72: {
              S = 7, T = 14;
              break;
            }
            case 83: {
              S = 8, T = 14;
              break;
            }
            case 97: {
              S = 9, T = 14;
              break;
            }
            case 107: {
              S = 10, T = 14;
              break;
            }
            case 117: {
              S = 11, T = 14;
              break;
            }
            default:
              p = 0, P = 0;
          }
        while (0);
        return (T | 0) == 14 && (p = _[22096 + (S * 24 | 0) + 8 >> 2] | 0, P = _[22096 + (S * 24 | 0) + 16 >> 2] | 0), S = _[H >> 2] | 0, (S | 0) != (_[J >> 2] | 0) && (g = Xn(g) | 0, S = _[H >> 2] | 0, g | (S | 0) == (P | 0) && (x = (x + 1 | 0) % 6 | 0)), (E | 0) == 3 & (S | 0) == (P | 0) ? (E = (x + 5 | 0) % 6 | 0, $e = B, E | 0) : (E | 0) == 5 & (S | 0) == (p | 0) ? (E = (x + 1 | 0) % 6 | 0, $e = B, E | 0) : (E = x, $e = B, E | 0);
      }
      function rf(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0;
        return P = Fi(S, x) | 0, (T + -1 | 0) >>> 0 > 5 || (H = (P | 0) != 0, (T | 0) == 1 & H) ? (T = -1, T | 0) : (P = gh(S, x) | 0, H ? (T = (5 - P + (_[22384 + (T << 2) >> 2] | 0) | 0) % 5 | 0, T | 0) : (T = (6 - P + (_[22416 + (T << 2) >> 2] | 0) | 0) % 6 | 0, T | 0));
      }
      function Xi(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0;
        (x | 0) > 0 ? (P = bA(x, 4) | 0, _[S >> 2] = P, P || en(23230, 23253, 40, 23267)) : _[S >> 2] = 0, _[S + 4 >> 2] = x, _[S + 8 >> 2] = 0, _[S + 12 >> 2] = T;
      }
      function js(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0;
        H = S + 4 | 0, J = S + 12 | 0, g = S + 8 | 0;
        e:
          for (; ; ) {
            for (T = _[H >> 2] | 0, x = 0; ; ) {
              if ((x | 0) >= (T | 0))
                break e;
              if (P = _[S >> 2] | 0, p = _[P + (x << 2) >> 2] | 0, !p)
                x = x + 1 | 0;
              else
                break;
            }
            x = P + (~~(+tt(+(+pt(10, + +(15 - (_[J >> 2] | 0) | 0)) * (+ye[p >> 3] + +ye[p + 8 >> 3]))) % +(T | 0)) >>> 0 << 2) | 0, T = _[x >> 2] | 0;
            t:
              do
                if (T | 0) {
                  if (P = p + 32 | 0, (T | 0) == (p | 0))
                    _[x >> 2] = _[P >> 2];
                  else {
                    if (T = T + 32 | 0, x = _[T >> 2] | 0, !x)
                      break;
                    for (; (x | 0) != (p | 0); )
                      if (T = x + 32 | 0, x = _[T >> 2] | 0, !x)
                        break t;
                    _[T >> 2] = _[P >> 2];
                  }
                  Or(p), _[g >> 2] = (_[g >> 2] | 0) + -1;
                }
              while (0);
          }
        Or(_[S >> 2] | 0);
      }
      function jd(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0;
        for (P = _[S + 4 >> 2] | 0, T = 0; ; ) {
          if ((T | 0) >= (P | 0)) {
            x = 0, T = 4;
            break;
          }
          if (x = _[(_[S >> 2] | 0) + (T << 2) >> 2] | 0, !x)
            T = T + 1 | 0;
          else {
            T = 4;
            break;
          }
        }
        return (T | 0) == 4 ? x | 0 : 0;
      }
      function va(S, x) {
        S = S | 0, x = x | 0;
        var T = 0, P = 0, H = 0, J = 0;
        if (T = ~~(+tt(+(+pt(10, + +(15 - (_[S + 12 >> 2] | 0) | 0)) * (+ye[x >> 3] + +ye[x + 8 >> 3]))) % +(_[S + 4 >> 2] | 0)) >>> 0, T = (_[S >> 2] | 0) + (T << 2) | 0, P = _[T >> 2] | 0, !P)
          return J = 1, J | 0;
        J = x + 32 | 0;
        do
          if ((P | 0) != (x | 0)) {
            if (T = _[P + 32 >> 2] | 0, !T)
              return J = 1, J | 0;
            for (H = T; ; ) {
              if ((H | 0) == (x | 0)) {
                H = 8;
                break;
              }
              if (T = _[H + 32 >> 2] | 0, T)
                P = H, H = T;
              else {
                T = 1, H = 10;
                break;
              }
            }
            if ((H | 0) == 8) {
              _[P + 32 >> 2] = _[J >> 2];
              break;
            } else if ((H | 0) == 10)
              return T | 0;
          } else
            _[T >> 2] = _[J >> 2];
        while (0);
        return Or(x), J = S + 8 | 0, _[J >> 2] = (_[J >> 2] | 0) + -1, J = 0, J | 0;
      }
      function sy(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0;
        J = BA(40) | 0, J || en(23283, 23253, 98, 23296), _[J >> 2] = _[x >> 2], _[J + 4 >> 2] = _[x + 4 >> 2], _[J + 8 >> 2] = _[x + 8 >> 2], _[J + 12 >> 2] = _[x + 12 >> 2], H = J + 16 | 0, _[H >> 2] = _[T >> 2], _[H + 4 >> 2] = _[T + 4 >> 2], _[H + 8 >> 2] = _[T + 8 >> 2], _[H + 12 >> 2] = _[T + 12 >> 2], _[J + 32 >> 2] = 0, H = ~~(+tt(+(+pt(10, + +(15 - (_[S + 12 >> 2] | 0) | 0)) * (+ye[x >> 3] + +ye[x + 8 >> 3]))) % +(_[S + 4 >> 2] | 0)) >>> 0, H = (_[S >> 2] | 0) + (H << 2) | 0, P = _[H >> 2] | 0;
        do
          if (!P)
            _[H >> 2] = J;
          else {
            for (; !(vl(P, x) | 0 && vl(P + 16 | 0, T) | 0); )
              if (H = _[P + 32 >> 2] | 0, P = H | 0 ? H : P, !(_[P + 32 >> 2] | 0)) {
                g = 10;
                break;
              }
            if ((g | 0) == 10) {
              _[P + 32 >> 2] = J;
              break;
            }
            return Or(J), g = P, g | 0;
          }
        while (0);
        return g = S + 8 | 0, _[g >> 2] = (_[g >> 2] | 0) + 1, g = J, g | 0;
      }
      function Cm(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0;
        if (H = ~~(+tt(+(+pt(10, + +(15 - (_[S + 12 >> 2] | 0) | 0)) * (+ye[x >> 3] + +ye[x + 8 >> 3]))) % +(_[S + 4 >> 2] | 0)) >>> 0, H = _[(_[S >> 2] | 0) + (H << 2) >> 2] | 0, !H)
          return T = 0, T | 0;
        if (!T) {
          for (S = H; ; ) {
            if (vl(S, x) | 0) {
              P = 10;
              break;
            }
            if (S = _[S + 32 >> 2] | 0, !S) {
              S = 0, P = 10;
              break;
            }
          }
          if ((P | 0) == 10)
            return S | 0;
        }
        for (S = H; ; ) {
          if (vl(S, x) | 0 && vl(S + 16 | 0, T) | 0) {
            P = 10;
            break;
          }
          if (S = _[S + 32 >> 2] | 0, !S) {
            S = 0, P = 10;
            break;
          }
        }
        return (P | 0) == 10 ? S | 0 : 0;
      }
      function po(S, x) {
        S = S | 0, x = x | 0;
        var T = 0;
        if (T = ~~(+tt(+(+pt(10, + +(15 - (_[S + 12 >> 2] | 0) | 0)) * (+ye[x >> 3] + +ye[x + 8 >> 3]))) % +(_[S + 4 >> 2] | 0)) >>> 0, S = _[(_[S >> 2] | 0) + (T << 2) >> 2] | 0, !S)
          return T = 0, T | 0;
        for (; ; ) {
          if (vl(S, x) | 0) {
            x = 5;
            break;
          }
          if (S = _[S + 32 >> 2] | 0, !S) {
            S = 0, x = 5;
            break;
          }
        }
        return (x | 0) == 5 ? S | 0 : 0;
      }
      function Fx() {
        return 23312;
      }
      function Bc(S) {
        return S = +S, + +ph(+S);
      }
      function T0(S) {
        return S = +S, ~~+Bc(S) | 0;
      }
      function BA(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0, Le = 0, Je = 0, et = 0, Ke = 0, ot = 0, je = 0, Et = 0;
        Et = $e, $e = $e + 16 | 0, te = Et;
        do
          if (S >>> 0 < 245) {
            if (B = S >>> 0 < 11 ? 16 : S + 11 & -8, S = B >>> 3, j = _[5829] | 0, T = j >>> S, T & 3 | 0)
              return x = (T & 1 ^ 1) + S | 0, S = 23356 + (x << 1 << 2) | 0, T = S + 8 | 0, P = _[T >> 2] | 0, H = P + 8 | 0, J = _[H >> 2] | 0, (J | 0) == (S | 0) ? _[5829] = j & ~(1 << x) : (_[J + 12 >> 2] = S, _[T >> 2] = J), je = x << 3, _[P + 4 >> 2] = je | 3, je = P + je + 4 | 0, _[je >> 2] = _[je >> 2] | 1, je = H, $e = Et, je | 0;
            if (D = _[5831] | 0, B >>> 0 > D >>> 0) {
              if (T | 0)
                return x = 2 << S, x = T << S & (x | 0 - x), x = (x & 0 - x) + -1 | 0, p = x >>> 12 & 16, x = x >>> p, T = x >>> 5 & 8, x = x >>> T, J = x >>> 2 & 4, x = x >>> J, S = x >>> 1 & 2, x = x >>> S, P = x >>> 1 & 1, P = (T | p | J | S | P) + (x >>> P) | 0, x = 23356 + (P << 1 << 2) | 0, S = x + 8 | 0, J = _[S >> 2] | 0, p = J + 8 | 0, T = _[p >> 2] | 0, (T | 0) == (x | 0) ? (S = j & ~(1 << P), _[5829] = S) : (_[T + 12 >> 2] = x, _[S >> 2] = T, S = j), je = P << 3, g = je - B | 0, _[J + 4 >> 2] = B | 3, H = J + B | 0, _[H + 4 >> 2] = g | 1, _[J + je >> 2] = g, D | 0 && (P = _[5834] | 0, x = D >>> 3, T = 23356 + (x << 1 << 2) | 0, x = 1 << x, S & x ? (S = T + 8 | 0, x = _[S >> 2] | 0) : (_[5829] = S | x, x = T, S = T + 8 | 0), _[S >> 2] = P, _[x + 12 >> 2] = P, _[P + 8 >> 2] = x, _[P + 12 >> 2] = T), _[5831] = g, _[5834] = H, je = p, $e = Et, je | 0;
              if (J = _[5830] | 0, J) {
                for (T = (J & 0 - J) + -1 | 0, H = T >>> 12 & 16, T = T >>> H, P = T >>> 5 & 8, T = T >>> P, g = T >>> 2 & 4, T = T >>> g, p = T >>> 1 & 2, T = T >>> p, E = T >>> 1 & 1, E = _[23620 + ((P | H | g | p | E) + (T >>> E) << 2) >> 2] | 0, T = E, p = E, E = (_[E + 4 >> 2] & -8) - B | 0; S = _[T + 16 >> 2] | 0, !(!S && (S = _[T + 20 >> 2] | 0, !S)); )
                  g = (_[S + 4 >> 2] & -8) - B | 0, H = g >>> 0 < E >>> 0, T = S, p = H ? S : p, E = H ? g : E;
                if (g = p + B | 0, g >>> 0 > p >>> 0) {
                  H = _[p + 24 >> 2] | 0, x = _[p + 12 >> 2] | 0;
                  do
                    if ((x | 0) == (p | 0)) {
                      if (S = p + 20 | 0, x = _[S >> 2] | 0, !x && (S = p + 16 | 0, x = _[S >> 2] | 0, !x)) {
                        T = 0;
                        break;
                      }
                      for (; ; )
                        if (P = x + 20 | 0, T = _[P >> 2] | 0, T)
                          x = T, S = P;
                        else if (P = x + 16 | 0, T = _[P >> 2] | 0, T)
                          x = T, S = P;
                        else
                          break;
                      _[S >> 2] = 0, T = x;
                    } else
                      T = _[p + 8 >> 2] | 0, _[T + 12 >> 2] = x, _[x + 8 >> 2] = T, T = x;
                  while (0);
                  do
                    if (H | 0) {
                      if (x = _[p + 28 >> 2] | 0, S = 23620 + (x << 2) | 0, (p | 0) == (_[S >> 2] | 0)) {
                        if (_[S >> 2] = T, !T) {
                          _[5830] = J & ~(1 << x);
                          break;
                        }
                      } else if (je = H + 16 | 0, _[((_[je >> 2] | 0) == (p | 0) ? je : H + 20 | 0) >> 2] = T, !T)
                        break;
                      _[T + 24 >> 2] = H, x = _[p + 16 >> 2] | 0, x | 0 && (_[T + 16 >> 2] = x, _[x + 24 >> 2] = T), x = _[p + 20 >> 2] | 0, x | 0 && (_[T + 20 >> 2] = x, _[x + 24 >> 2] = T);
                    }
                  while (0);
                  return E >>> 0 < 16 ? (je = E + B | 0, _[p + 4 >> 2] = je | 3, je = p + je + 4 | 0, _[je >> 2] = _[je >> 2] | 1) : (_[p + 4 >> 2] = B | 3, _[g + 4 >> 2] = E | 1, _[g + E >> 2] = E, D | 0 && (P = _[5834] | 0, x = D >>> 3, T = 23356 + (x << 1 << 2) | 0, x = 1 << x, x & j ? (S = T + 8 | 0, x = _[S >> 2] | 0) : (_[5829] = x | j, x = T, S = T + 8 | 0), _[S >> 2] = P, _[x + 12 >> 2] = P, _[P + 8 >> 2] = x, _[P + 12 >> 2] = T), _[5831] = E, _[5834] = g), je = p + 8 | 0, $e = Et, je | 0;
                } else
                  j = B;
              } else
                j = B;
            } else
              j = B;
          } else if (S >>> 0 <= 4294967231)
            if (S = S + 11 | 0, B = S & -8, P = _[5830] | 0, P) {
              H = 0 - B | 0, S = S >>> 8, S ? B >>> 0 > 16777215 ? E = 31 : (j = (S + 1048320 | 0) >>> 16 & 8, Le = S << j, p = (Le + 520192 | 0) >>> 16 & 4, Le = Le << p, E = (Le + 245760 | 0) >>> 16 & 2, E = 14 - (p | j | E) + (Le << E >>> 15) | 0, E = B >>> (E + 7 | 0) & 1 | E << 1) : E = 0, T = _[23620 + (E << 2) >> 2] | 0;
              e:
                do
                  if (!T)
                    T = 0, S = 0, Le = 61;
                  else
                    for (S = 0, p = B << ((E | 0) == 31 ? 0 : 25 - (E >>> 1) | 0), J = 0; ; ) {
                      if (g = (_[T + 4 >> 2] & -8) - B | 0, g >>> 0 < H >>> 0)
                        if (g)
                          S = T, H = g;
                        else {
                          S = T, H = 0, Le = 65;
                          break e;
                        }
                      if (Le = _[T + 20 >> 2] | 0, T = _[T + 16 + (p >>> 31 << 2) >> 2] | 0, J = (Le | 0) == 0 | (Le | 0) == (T | 0) ? J : Le, T)
                        p = p << 1;
                      else {
                        T = J, Le = 61;
                        break;
                      }
                    }
                while (0);
              if ((Le | 0) == 61) {
                if ((T | 0) == 0 & (S | 0) == 0) {
                  if (S = 2 << E, S = (S | 0 - S) & P, !S) {
                    j = B;
                    break;
                  }
                  j = (S & 0 - S) + -1 | 0, g = j >>> 12 & 16, j = j >>> g, J = j >>> 5 & 8, j = j >>> J, p = j >>> 2 & 4, j = j >>> p, E = j >>> 1 & 2, j = j >>> E, T = j >>> 1 & 1, S = 0, T = _[23620 + ((J | g | p | E | T) + (j >>> T) << 2) >> 2] | 0;
                }
                T ? Le = 65 : (p = S, g = H);
              }
              if ((Le | 0) == 65)
                for (J = T; ; )
                  if (j = (_[J + 4 >> 2] & -8) - B | 0, T = j >>> 0 < H >>> 0, H = T ? j : H, S = T ? J : S, T = _[J + 16 >> 2] | 0, T || (T = _[J + 20 >> 2] | 0), T)
                    J = T;
                  else {
                    p = S, g = H;
                    break;
                  }
              if (p | 0 && g >>> 0 < ((_[5831] | 0) - B | 0) >>> 0 && (D = p + B | 0, D >>> 0 > p >>> 0)) {
                J = _[p + 24 >> 2] | 0, x = _[p + 12 >> 2] | 0;
                do
                  if ((x | 0) == (p | 0)) {
                    if (S = p + 20 | 0, x = _[S >> 2] | 0, !x && (S = p + 16 | 0, x = _[S >> 2] | 0, !x)) {
                      x = 0;
                      break;
                    }
                    for (; ; )
                      if (H = x + 20 | 0, T = _[H >> 2] | 0, T)
                        x = T, S = H;
                      else if (H = x + 16 | 0, T = _[H >> 2] | 0, T)
                        x = T, S = H;
                      else
                        break;
                    _[S >> 2] = 0;
                  } else
                    je = _[p + 8 >> 2] | 0, _[je + 12 >> 2] = x, _[x + 8 >> 2] = je;
                while (0);
                do
                  if (J) {
                    if (S = _[p + 28 >> 2] | 0, T = 23620 + (S << 2) | 0, (p | 0) == (_[T >> 2] | 0)) {
                      if (_[T >> 2] = x, !x) {
                        P = P & ~(1 << S), _[5830] = P;
                        break;
                      }
                    } else if (je = J + 16 | 0, _[((_[je >> 2] | 0) == (p | 0) ? je : J + 20 | 0) >> 2] = x, !x)
                      break;
                    _[x + 24 >> 2] = J, S = _[p + 16 >> 2] | 0, S | 0 && (_[x + 16 >> 2] = S, _[S + 24 >> 2] = x), S = _[p + 20 >> 2] | 0, S && (_[x + 20 >> 2] = S, _[S + 24 >> 2] = x);
                  }
                while (0);
                e:
                  do
                    if (g >>> 0 < 16)
                      je = g + B | 0, _[p + 4 >> 2] = je | 3, je = p + je + 4 | 0, _[je >> 2] = _[je >> 2] | 1;
                    else {
                      if (_[p + 4 >> 2] = B | 3, _[D + 4 >> 2] = g | 1, _[D + g >> 2] = g, x = g >>> 3, g >>> 0 < 256) {
                        T = 23356 + (x << 1 << 2) | 0, S = _[5829] | 0, x = 1 << x, S & x ? (S = T + 8 | 0, x = _[S >> 2] | 0) : (_[5829] = S | x, x = T, S = T + 8 | 0), _[S >> 2] = D, _[x + 12 >> 2] = D, _[D + 8 >> 2] = x, _[D + 12 >> 2] = T;
                        break;
                      }
                      if (x = g >>> 8, x ? g >>> 0 > 16777215 ? T = 31 : (ot = (x + 1048320 | 0) >>> 16 & 8, je = x << ot, Ke = (je + 520192 | 0) >>> 16 & 4, je = je << Ke, T = (je + 245760 | 0) >>> 16 & 2, T = 14 - (Ke | ot | T) + (je << T >>> 15) | 0, T = g >>> (T + 7 | 0) & 1 | T << 1) : T = 0, x = 23620 + (T << 2) | 0, _[D + 28 >> 2] = T, S = D + 16 | 0, _[S + 4 >> 2] = 0, _[S >> 2] = 0, S = 1 << T, !(P & S)) {
                        _[5830] = P | S, _[x >> 2] = D, _[D + 24 >> 2] = x, _[D + 12 >> 2] = D, _[D + 8 >> 2] = D;
                        break;
                      }
                      x = _[x >> 2] | 0;
                      t:
                        do
                          if ((_[x + 4 >> 2] & -8 | 0) != (g | 0)) {
                            for (P = g << ((T | 0) == 31 ? 0 : 25 - (T >>> 1) | 0); T = x + 16 + (P >>> 31 << 2) | 0, S = _[T >> 2] | 0, !!S; )
                              if ((_[S + 4 >> 2] & -8 | 0) == (g | 0)) {
                                x = S;
                                break t;
                              } else
                                P = P << 1, x = S;
                            _[T >> 2] = D, _[D + 24 >> 2] = x, _[D + 12 >> 2] = D, _[D + 8 >> 2] = D;
                            break e;
                          }
                        while (0);
                      ot = x + 8 | 0, je = _[ot >> 2] | 0, _[je + 12 >> 2] = D, _[ot >> 2] = D, _[D + 8 >> 2] = je, _[D + 12 >> 2] = x, _[D + 24 >> 2] = 0;
                    }
                  while (0);
                return je = p + 8 | 0, $e = Et, je | 0;
              } else
                j = B;
            } else
              j = B;
          else
            j = -1;
        while (0);
        if (T = _[5831] | 0, T >>> 0 >= j >>> 0)
          return x = T - j | 0, S = _[5834] | 0, x >>> 0 > 15 ? (je = S + j | 0, _[5834] = je, _[5831] = x, _[je + 4 >> 2] = x | 1, _[S + T >> 2] = x, _[S + 4 >> 2] = j | 3) : (_[5831] = 0, _[5834] = 0, _[S + 4 >> 2] = T | 3, je = S + T + 4 | 0, _[je >> 2] = _[je >> 2] | 1), je = S + 8 | 0, $e = Et, je | 0;
        if (g = _[5832] | 0, g >>> 0 > j >>> 0)
          return Ke = g - j | 0, _[5832] = Ke, je = _[5835] | 0, ot = je + j | 0, _[5835] = ot, _[ot + 4 >> 2] = Ke | 1, _[je + 4 >> 2] = j | 3, je = je + 8 | 0, $e = Et, je | 0;
        if (_[5947] | 0 ? S = _[5949] | 0 : (_[5949] = 4096, _[5948] = 4096, _[5950] = -1, _[5951] = -1, _[5952] = 0, _[5940] = 0, _[5947] = te & -16 ^ 1431655768, S = 4096), p = j + 48 | 0, E = j + 47 | 0, J = S + E | 0, H = 0 - S | 0, B = J & H, B >>> 0 <= j >>> 0 || (S = _[5939] | 0, S | 0 && (D = _[5937] | 0, te = D + B | 0, te >>> 0 <= D >>> 0 | te >>> 0 > S >>> 0)))
          return je = 0, $e = Et, je | 0;
        e:
          do
            if (_[5940] & 4)
              x = 0, Le = 143;
            else {
              T = _[5835] | 0;
              t:
                do
                  if (T) {
                    for (P = 23764; te = _[P >> 2] | 0, !(te >>> 0 <= T >>> 0 && (te + (_[P + 4 >> 2] | 0) | 0) >>> 0 > T >>> 0); )
                      if (S = _[P + 8 >> 2] | 0, S)
                        P = S;
                      else {
                        Le = 128;
                        break t;
                      }
                    if (x = J - g & H, x >>> 0 < 2147483647)
                      if (S = Ba(x | 0) | 0, (S | 0) == ((_[P >> 2] | 0) + (_[P + 4 >> 2] | 0) | 0)) {
                        if ((S | 0) != -1) {
                          g = x, J = S, Le = 145;
                          break e;
                        }
                      } else
                        P = S, Le = 136;
                    else
                      x = 0;
                  } else
                    Le = 128;
                while (0);
              do
                if ((Le | 0) == 128)
                  if (T = Ba(0) | 0, (T | 0) != -1 && (x = T, he = _[5948] | 0, ve = he + -1 | 0, x = (ve & x | 0 ? (ve + x & 0 - he) - x | 0 : 0) + B | 0, he = _[5937] | 0, ve = x + he | 0, x >>> 0 > j >>> 0 & x >>> 0 < 2147483647)) {
                    if (te = _[5939] | 0, te | 0 && ve >>> 0 <= he >>> 0 | ve >>> 0 > te >>> 0) {
                      x = 0;
                      break;
                    }
                    if (S = Ba(x | 0) | 0, (S | 0) == (T | 0)) {
                      g = x, J = T, Le = 145;
                      break e;
                    } else
                      P = S, Le = 136;
                  } else
                    x = 0;
              while (0);
              do
                if ((Le | 0) == 136) {
                  if (T = 0 - x | 0, !(p >>> 0 > x >>> 0 & (x >>> 0 < 2147483647 & (P | 0) != -1)))
                    if ((P | 0) == -1) {
                      x = 0;
                      break;
                    } else {
                      g = x, J = P, Le = 145;
                      break e;
                    }
                  if (S = _[5949] | 0, S = E - x + S & 0 - S, S >>> 0 >= 2147483647) {
                    g = x, J = P, Le = 145;
                    break e;
                  }
                  if ((Ba(S | 0) | 0) == -1) {
                    Ba(T | 0) | 0, x = 0;
                    break;
                  } else {
                    g = S + x | 0, J = P, Le = 145;
                    break e;
                  }
                }
              while (0);
              _[5940] = _[5940] | 4, Le = 143;
            }
          while (0);
        if ((Le | 0) == 143 && B >>> 0 < 2147483647 && (Ke = Ba(B | 0) | 0, ve = Ba(0) | 0, Je = ve - Ke | 0, et = Je >>> 0 > (j + 40 | 0) >>> 0, !((Ke | 0) == -1 | et ^ 1 | Ke >>> 0 < ve >>> 0 & ((Ke | 0) != -1 & (ve | 0) != -1) ^ 1)) && (g = et ? Je : x, J = Ke, Le = 145), (Le | 0) == 145) {
          x = (_[5937] | 0) + g | 0, _[5937] = x, x >>> 0 > (_[5938] | 0) >>> 0 && (_[5938] = x), E = _[5835] | 0;
          e:
            do
              if (E) {
                for (x = 23764; ; ) {
                  if (S = _[x >> 2] | 0, T = _[x + 4 >> 2] | 0, (J | 0) == (S + T | 0)) {
                    Le = 154;
                    break;
                  }
                  if (P = _[x + 8 >> 2] | 0, P)
                    x = P;
                  else
                    break;
                }
                if ((Le | 0) == 154 && (ot = x + 4 | 0, (_[x + 12 >> 2] & 8 | 0) == 0) && J >>> 0 > E >>> 0 & S >>> 0 <= E >>> 0) {
                  _[ot >> 2] = T + g, je = (_[5832] | 0) + g | 0, Ke = E + 8 | 0, Ke = Ke & 7 | 0 ? 0 - Ke & 7 : 0, ot = E + Ke | 0, Ke = je - Ke | 0, _[5835] = ot, _[5832] = Ke, _[ot + 4 >> 2] = Ke | 1, _[E + je + 4 >> 2] = 40, _[5836] = _[5951];
                  break;
                }
                for (J >>> 0 < (_[5833] | 0) >>> 0 && (_[5833] = J), T = J + g | 0, x = 23764; ; ) {
                  if ((_[x >> 2] | 0) == (T | 0)) {
                    Le = 162;
                    break;
                  }
                  if (S = _[x + 8 >> 2] | 0, S)
                    x = S;
                  else
                    break;
                }
                if ((Le | 0) == 162 && !(_[x + 12 >> 2] & 8 | 0)) {
                  _[x >> 2] = J, D = x + 4 | 0, _[D >> 2] = (_[D >> 2] | 0) + g, D = J + 8 | 0, D = J + (D & 7 | 0 ? 0 - D & 7 : 0) | 0, x = T + 8 | 0, x = T + (x & 7 | 0 ? 0 - x & 7 : 0) | 0, B = D + j | 0, p = x - D - j | 0, _[D + 4 >> 2] = j | 3;
                  t:
                    do
                      if ((E | 0) == (x | 0))
                        je = (_[5832] | 0) + p | 0, _[5832] = je, _[5835] = B, _[B + 4 >> 2] = je | 1;
                      else {
                        if ((_[5834] | 0) == (x | 0)) {
                          je = (_[5831] | 0) + p | 0, _[5831] = je, _[5834] = B, _[B + 4 >> 2] = je | 1, _[B + je >> 2] = je;
                          break;
                        }
                        if (S = _[x + 4 >> 2] | 0, (S & 3 | 0) == 1) {
                          g = S & -8, P = S >>> 3;
                          n:
                            do
                              if (S >>> 0 < 256)
                                if (S = _[x + 8 >> 2] | 0, T = _[x + 12 >> 2] | 0, (T | 0) == (S | 0)) {
                                  _[5829] = _[5829] & ~(1 << P);
                                  break;
                                } else {
                                  _[S + 12 >> 2] = T, _[T + 8 >> 2] = S;
                                  break;
                                }
                              else {
                                J = _[x + 24 >> 2] | 0, S = _[x + 12 >> 2] | 0;
                                do
                                  if ((S | 0) == (x | 0)) {
                                    if (T = x + 16 | 0, P = T + 4 | 0, S = _[P >> 2] | 0, S)
                                      T = P;
                                    else if (S = _[T >> 2] | 0, !S) {
                                      S = 0;
                                      break;
                                    }
                                    for (; ; )
                                      if (H = S + 20 | 0, P = _[H >> 2] | 0, P)
                                        S = P, T = H;
                                      else if (H = S + 16 | 0, P = _[H >> 2] | 0, P)
                                        S = P, T = H;
                                      else
                                        break;
                                    _[T >> 2] = 0;
                                  } else
                                    je = _[x + 8 >> 2] | 0, _[je + 12 >> 2] = S, _[S + 8 >> 2] = je;
                                while (0);
                                if (!J)
                                  break;
                                T = _[x + 28 >> 2] | 0, P = 23620 + (T << 2) | 0;
                                do
                                  if ((_[P >> 2] | 0) != (x | 0)) {
                                    if (je = J + 16 | 0, _[((_[je >> 2] | 0) == (x | 0) ? je : J + 20 | 0) >> 2] = S, !S)
                                      break n;
                                  } else {
                                    if (_[P >> 2] = S, S | 0)
                                      break;
                                    _[5830] = _[5830] & ~(1 << T);
                                    break n;
                                  }
                                while (0);
                                if (_[S + 24 >> 2] = J, T = x + 16 | 0, P = _[T >> 2] | 0, P | 0 && (_[S + 16 >> 2] = P, _[P + 24 >> 2] = S), T = _[T + 4 >> 2] | 0, !T)
                                  break;
                                _[S + 20 >> 2] = T, _[T + 24 >> 2] = S;
                              }
                            while (0);
                          x = x + g | 0, H = g + p | 0;
                        } else
                          H = p;
                        if (x = x + 4 | 0, _[x >> 2] = _[x >> 2] & -2, _[B + 4 >> 2] = H | 1, _[B + H >> 2] = H, x = H >>> 3, H >>> 0 < 256) {
                          T = 23356 + (x << 1 << 2) | 0, S = _[5829] | 0, x = 1 << x, S & x ? (S = T + 8 | 0, x = _[S >> 2] | 0) : (_[5829] = S | x, x = T, S = T + 8 | 0), _[S >> 2] = B, _[x + 12 >> 2] = B, _[B + 8 >> 2] = x, _[B + 12 >> 2] = T;
                          break;
                        }
                        x = H >>> 8;
                        do
                          if (!x)
                            P = 0;
                          else {
                            if (H >>> 0 > 16777215) {
                              P = 31;
                              break;
                            }
                            ot = (x + 1048320 | 0) >>> 16 & 8, je = x << ot, Ke = (je + 520192 | 0) >>> 16 & 4, je = je << Ke, P = (je + 245760 | 0) >>> 16 & 2, P = 14 - (Ke | ot | P) + (je << P >>> 15) | 0, P = H >>> (P + 7 | 0) & 1 | P << 1;
                          }
                        while (0);
                        if (x = 23620 + (P << 2) | 0, _[B + 28 >> 2] = P, S = B + 16 | 0, _[S + 4 >> 2] = 0, _[S >> 2] = 0, S = _[5830] | 0, T = 1 << P, !(S & T)) {
                          _[5830] = S | T, _[x >> 2] = B, _[B + 24 >> 2] = x, _[B + 12 >> 2] = B, _[B + 8 >> 2] = B;
                          break;
                        }
                        x = _[x >> 2] | 0;
                        n:
                          do
                            if ((_[x + 4 >> 2] & -8 | 0) != (H | 0)) {
                              for (P = H << ((P | 0) == 31 ? 0 : 25 - (P >>> 1) | 0); T = x + 16 + (P >>> 31 << 2) | 0, S = _[T >> 2] | 0, !!S; )
                                if ((_[S + 4 >> 2] & -8 | 0) == (H | 0)) {
                                  x = S;
                                  break n;
                                } else
                                  P = P << 1, x = S;
                              _[T >> 2] = B, _[B + 24 >> 2] = x, _[B + 12 >> 2] = B, _[B + 8 >> 2] = B;
                              break t;
                            }
                          while (0);
                        ot = x + 8 | 0, je = _[ot >> 2] | 0, _[je + 12 >> 2] = B, _[ot >> 2] = B, _[B + 8 >> 2] = je, _[B + 12 >> 2] = x, _[B + 24 >> 2] = 0;
                      }
                    while (0);
                  return je = D + 8 | 0, $e = Et, je | 0;
                }
                for (x = 23764; S = _[x >> 2] | 0, !(S >>> 0 <= E >>> 0 && (je = S + (_[x + 4 >> 2] | 0) | 0, je >>> 0 > E >>> 0)); )
                  x = _[x + 8 >> 2] | 0;
                H = je + -47 | 0, S = H + 8 | 0, S = H + (S & 7 | 0 ? 0 - S & 7 : 0) | 0, H = E + 16 | 0, S = S >>> 0 < H >>> 0 ? E : S, x = S + 8 | 0, T = g + -40 | 0, Ke = J + 8 | 0, Ke = Ke & 7 | 0 ? 0 - Ke & 7 : 0, ot = J + Ke | 0, Ke = T - Ke | 0, _[5835] = ot, _[5832] = Ke, _[ot + 4 >> 2] = Ke | 1, _[J + T + 4 >> 2] = 40, _[5836] = _[5951], T = S + 4 | 0, _[T >> 2] = 27, _[x >> 2] = _[5941], _[x + 4 >> 2] = _[5942], _[x + 8 >> 2] = _[5943], _[x + 12 >> 2] = _[5944], _[5941] = J, _[5942] = g, _[5944] = 0, _[5943] = x, x = S + 24 | 0;
                do
                  ot = x, x = x + 4 | 0, _[x >> 2] = 7;
                while ((ot + 8 | 0) >>> 0 < je >>> 0);
                if ((S | 0) != (E | 0)) {
                  if (J = S - E | 0, _[T >> 2] = _[T >> 2] & -2, _[E + 4 >> 2] = J | 1, _[S >> 2] = J, x = J >>> 3, J >>> 0 < 256) {
                    T = 23356 + (x << 1 << 2) | 0, S = _[5829] | 0, x = 1 << x, S & x ? (S = T + 8 | 0, x = _[S >> 2] | 0) : (_[5829] = S | x, x = T, S = T + 8 | 0), _[S >> 2] = E, _[x + 12 >> 2] = E, _[E + 8 >> 2] = x, _[E + 12 >> 2] = T;
                    break;
                  }
                  if (x = J >>> 8, x ? J >>> 0 > 16777215 ? P = 31 : (ot = (x + 1048320 | 0) >>> 16 & 8, je = x << ot, Ke = (je + 520192 | 0) >>> 16 & 4, je = je << Ke, P = (je + 245760 | 0) >>> 16 & 2, P = 14 - (Ke | ot | P) + (je << P >>> 15) | 0, P = J >>> (P + 7 | 0) & 1 | P << 1) : P = 0, T = 23620 + (P << 2) | 0, _[E + 28 >> 2] = P, _[E + 20 >> 2] = 0, _[H >> 2] = 0, x = _[5830] | 0, S = 1 << P, !(x & S)) {
                    _[5830] = x | S, _[T >> 2] = E, _[E + 24 >> 2] = T, _[E + 12 >> 2] = E, _[E + 8 >> 2] = E;
                    break;
                  }
                  x = _[T >> 2] | 0;
                  t:
                    do
                      if ((_[x + 4 >> 2] & -8 | 0) != (J | 0)) {
                        for (P = J << ((P | 0) == 31 ? 0 : 25 - (P >>> 1) | 0); T = x + 16 + (P >>> 31 << 2) | 0, S = _[T >> 2] | 0, !!S; )
                          if ((_[S + 4 >> 2] & -8 | 0) == (J | 0)) {
                            x = S;
                            break t;
                          } else
                            P = P << 1, x = S;
                        _[T >> 2] = E, _[E + 24 >> 2] = x, _[E + 12 >> 2] = E, _[E + 8 >> 2] = E;
                        break e;
                      }
                    while (0);
                  ot = x + 8 | 0, je = _[ot >> 2] | 0, _[je + 12 >> 2] = E, _[ot >> 2] = E, _[E + 8 >> 2] = je, _[E + 12 >> 2] = x, _[E + 24 >> 2] = 0;
                }
              } else
                je = _[5833] | 0, (je | 0) == 0 | J >>> 0 < je >>> 0 && (_[5833] = J), _[5941] = J, _[5942] = g, _[5944] = 0, _[5838] = _[5947], _[5837] = -1, _[5842] = 23356, _[5841] = 23356, _[5844] = 23364, _[5843] = 23364, _[5846] = 23372, _[5845] = 23372, _[5848] = 23380, _[5847] = 23380, _[5850] = 23388, _[5849] = 23388, _[5852] = 23396, _[5851] = 23396, _[5854] = 23404, _[5853] = 23404, _[5856] = 23412, _[5855] = 23412, _[5858] = 23420, _[5857] = 23420, _[5860] = 23428, _[5859] = 23428, _[5862] = 23436, _[5861] = 23436, _[5864] = 23444, _[5863] = 23444, _[5866] = 23452, _[5865] = 23452, _[5868] = 23460, _[5867] = 23460, _[5870] = 23468, _[5869] = 23468, _[5872] = 23476, _[5871] = 23476, _[5874] = 23484, _[5873] = 23484, _[5876] = 23492, _[5875] = 23492, _[5878] = 23500, _[5877] = 23500, _[5880] = 23508, _[5879] = 23508, _[5882] = 23516, _[5881] = 23516, _[5884] = 23524, _[5883] = 23524, _[5886] = 23532, _[5885] = 23532, _[5888] = 23540, _[5887] = 23540, _[5890] = 23548, _[5889] = 23548, _[5892] = 23556, _[5891] = 23556, _[5894] = 23564, _[5893] = 23564, _[5896] = 23572, _[5895] = 23572, _[5898] = 23580, _[5897] = 23580, _[5900] = 23588, _[5899] = 23588, _[5902] = 23596, _[5901] = 23596, _[5904] = 23604, _[5903] = 23604, je = g + -40 | 0, Ke = J + 8 | 0, Ke = Ke & 7 | 0 ? 0 - Ke & 7 : 0, ot = J + Ke | 0, Ke = je - Ke | 0, _[5835] = ot, _[5832] = Ke, _[ot + 4 >> 2] = Ke | 1, _[J + je + 4 >> 2] = 40, _[5836] = _[5951];
            while (0);
          if (x = _[5832] | 0, x >>> 0 > j >>> 0)
            return Ke = x - j | 0, _[5832] = Ke, je = _[5835] | 0, ot = je + j | 0, _[5835] = ot, _[ot + 4 >> 2] = Ke | 1, _[je + 4 >> 2] = j | 3, je = je + 8 | 0, $e = Et, je | 0;
        }
        return je = Fx() | 0, _[je >> 2] = 12, je = 0, $e = Et, je | 0;
      }
      function Or(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0, H = 0, J = 0, g = 0, p = 0, E = 0;
        if (S) {
          T = S + -8 | 0, H = _[5833] | 0, S = _[S + -4 >> 2] | 0, x = S & -8, E = T + x | 0;
          do
            if (S & 1)
              p = T, g = T;
            else {
              if (P = _[T >> 2] | 0, !(S & 3) || (g = T + (0 - P) | 0, J = P + x | 0, g >>> 0 < H >>> 0))
                return;
              if ((_[5834] | 0) == (g | 0)) {
                if (S = E + 4 | 0, x = _[S >> 2] | 0, (x & 3 | 0) != 3) {
                  p = g, x = J;
                  break;
                }
                _[5831] = J, _[S >> 2] = x & -2, _[g + 4 >> 2] = J | 1, _[g + J >> 2] = J;
                return;
              }
              if (T = P >>> 3, P >>> 0 < 256)
                if (S = _[g + 8 >> 2] | 0, x = _[g + 12 >> 2] | 0, (x | 0) == (S | 0)) {
                  _[5829] = _[5829] & ~(1 << T), p = g, x = J;
                  break;
                } else {
                  _[S + 12 >> 2] = x, _[x + 8 >> 2] = S, p = g, x = J;
                  break;
                }
              H = _[g + 24 >> 2] | 0, S = _[g + 12 >> 2] | 0;
              do
                if ((S | 0) == (g | 0)) {
                  if (x = g + 16 | 0, T = x + 4 | 0, S = _[T >> 2] | 0, S)
                    x = T;
                  else if (S = _[x >> 2] | 0, !S) {
                    S = 0;
                    break;
                  }
                  for (; ; )
                    if (P = S + 20 | 0, T = _[P >> 2] | 0, T)
                      S = T, x = P;
                    else if (P = S + 16 | 0, T = _[P >> 2] | 0, T)
                      S = T, x = P;
                    else
                      break;
                  _[x >> 2] = 0;
                } else
                  p = _[g + 8 >> 2] | 0, _[p + 12 >> 2] = S, _[S + 8 >> 2] = p;
              while (0);
              if (H) {
                if (x = _[g + 28 >> 2] | 0, T = 23620 + (x << 2) | 0, (_[T >> 2] | 0) == (g | 0)) {
                  if (_[T >> 2] = S, !S) {
                    _[5830] = _[5830] & ~(1 << x), p = g, x = J;
                    break;
                  }
                } else if (p = H + 16 | 0, _[((_[p >> 2] | 0) == (g | 0) ? p : H + 20 | 0) >> 2] = S, !S) {
                  p = g, x = J;
                  break;
                }
                _[S + 24 >> 2] = H, x = g + 16 | 0, T = _[x >> 2] | 0, T | 0 && (_[S + 16 >> 2] = T, _[T + 24 >> 2] = S), x = _[x + 4 >> 2] | 0, x ? (_[S + 20 >> 2] = x, _[x + 24 >> 2] = S, p = g, x = J) : (p = g, x = J);
              } else
                p = g, x = J;
            }
          while (0);
          if (!(g >>> 0 >= E >>> 0) && (S = E + 4 | 0, P = _[S >> 2] | 0, !!(P & 1))) {
            if (P & 2)
              _[S >> 2] = P & -2, _[p + 4 >> 2] = x | 1, _[g + x >> 2] = x, H = x;
            else {
              if ((_[5835] | 0) == (E | 0)) {
                if (E = (_[5832] | 0) + x | 0, _[5832] = E, _[5835] = p, _[p + 4 >> 2] = E | 1, (p | 0) != (_[5834] | 0))
                  return;
                _[5834] = 0, _[5831] = 0;
                return;
              }
              if ((_[5834] | 0) == (E | 0)) {
                E = (_[5831] | 0) + x | 0, _[5831] = E, _[5834] = g, _[p + 4 >> 2] = E | 1, _[g + E >> 2] = E;
                return;
              }
              H = (P & -8) + x | 0, T = P >>> 3;
              do
                if (P >>> 0 < 256)
                  if (x = _[E + 8 >> 2] | 0, S = _[E + 12 >> 2] | 0, (S | 0) == (x | 0)) {
                    _[5829] = _[5829] & ~(1 << T);
                    break;
                  } else {
                    _[x + 12 >> 2] = S, _[S + 8 >> 2] = x;
                    break;
                  }
                else {
                  J = _[E + 24 >> 2] | 0, S = _[E + 12 >> 2] | 0;
                  do
                    if ((S | 0) == (E | 0)) {
                      if (x = E + 16 | 0, T = x + 4 | 0, S = _[T >> 2] | 0, S)
                        x = T;
                      else if (S = _[x >> 2] | 0, !S) {
                        T = 0;
                        break;
                      }
                      for (; ; )
                        if (P = S + 20 | 0, T = _[P >> 2] | 0, T)
                          S = T, x = P;
                        else if (P = S + 16 | 0, T = _[P >> 2] | 0, T)
                          S = T, x = P;
                        else
                          break;
                      _[x >> 2] = 0, T = S;
                    } else
                      T = _[E + 8 >> 2] | 0, _[T + 12 >> 2] = S, _[S + 8 >> 2] = T, T = S;
                  while (0);
                  if (J | 0) {
                    if (S = _[E + 28 >> 2] | 0, x = 23620 + (S << 2) | 0, (_[x >> 2] | 0) == (E | 0)) {
                      if (_[x >> 2] = T, !T) {
                        _[5830] = _[5830] & ~(1 << S);
                        break;
                      }
                    } else if (P = J + 16 | 0, _[((_[P >> 2] | 0) == (E | 0) ? P : J + 20 | 0) >> 2] = T, !T)
                      break;
                    _[T + 24 >> 2] = J, S = E + 16 | 0, x = _[S >> 2] | 0, x | 0 && (_[T + 16 >> 2] = x, _[x + 24 >> 2] = T), S = _[S + 4 >> 2] | 0, S | 0 && (_[T + 20 >> 2] = S, _[S + 24 >> 2] = T);
                  }
                }
              while (0);
              if (_[p + 4 >> 2] = H | 1, _[g + H >> 2] = H, (p | 0) == (_[5834] | 0)) {
                _[5831] = H;
                return;
              }
            }
            if (S = H >>> 3, H >>> 0 < 256) {
              T = 23356 + (S << 1 << 2) | 0, x = _[5829] | 0, S = 1 << S, x & S ? (x = T + 8 | 0, S = _[x >> 2] | 0) : (_[5829] = x | S, S = T, x = T + 8 | 0), _[x >> 2] = p, _[S + 12 >> 2] = p, _[p + 8 >> 2] = S, _[p + 12 >> 2] = T;
              return;
            }
            S = H >>> 8, S ? H >>> 0 > 16777215 ? P = 31 : (g = (S + 1048320 | 0) >>> 16 & 8, E = S << g, J = (E + 520192 | 0) >>> 16 & 4, E = E << J, P = (E + 245760 | 0) >>> 16 & 2, P = 14 - (J | g | P) + (E << P >>> 15) | 0, P = H >>> (P + 7 | 0) & 1 | P << 1) : P = 0, S = 23620 + (P << 2) | 0, _[p + 28 >> 2] = P, _[p + 20 >> 2] = 0, _[p + 16 >> 2] = 0, x = _[5830] | 0, T = 1 << P;
            e:
              do
                if (!(x & T))
                  _[5830] = x | T, _[S >> 2] = p, _[p + 24 >> 2] = S, _[p + 12 >> 2] = p, _[p + 8 >> 2] = p;
                else {
                  S = _[S >> 2] | 0;
                  t:
                    do
                      if ((_[S + 4 >> 2] & -8 | 0) != (H | 0)) {
                        for (P = H << ((P | 0) == 31 ? 0 : 25 - (P >>> 1) | 0); T = S + 16 + (P >>> 31 << 2) | 0, x = _[T >> 2] | 0, !!x; )
                          if ((_[x + 4 >> 2] & -8 | 0) == (H | 0)) {
                            S = x;
                            break t;
                          } else
                            P = P << 1, S = x;
                        _[T >> 2] = p, _[p + 24 >> 2] = S, _[p + 12 >> 2] = p, _[p + 8 >> 2] = p;
                        break e;
                      }
                    while (0);
                  g = S + 8 | 0, E = _[g >> 2] | 0, _[E + 12 >> 2] = p, _[g >> 2] = p, _[p + 8 >> 2] = E, _[p + 12 >> 2] = S, _[p + 24 >> 2] = 0;
                }
              while (0);
            if (E = (_[5837] | 0) + -1 | 0, _[5837] = E, !(E | 0)) {
              for (S = 23772; S = _[S >> 2] | 0, S; )
                S = S + 8 | 0;
              _[5837] = -1;
            }
          }
        }
      }
      function bA(S, x) {
        S = S | 0, x = x | 0;
        var T = 0;
        return S ? (T = kn(x, S) | 0, (x | S) >>> 0 > 65535 && (T = ((T >>> 0) / (S >>> 0) | 0 | 0) == (x | 0) ? T : -1)) : T = 0, S = BA(T) | 0, !S || !(_[S + -4 >> 2] & 3) || Ys(S | 0, 0, T | 0) | 0, S | 0;
      }
      function bc(S, x, T, P) {
        return S = S | 0, x = x | 0, T = T | 0, P = P | 0, T = S + T >>> 0, $t(x + P + (T >>> 0 < S >>> 0 | 0) >>> 0 | 0), T | 0 | 0;
      }
      function Au(S, x, T, P) {
        return S = S | 0, x = x | 0, T = T | 0, P = P | 0, P = x - P - (T >>> 0 > S >>> 0 | 0) >>> 0, $t(P | 0), S - T >>> 0 | 0 | 0;
      }
      function hh(S) {
        return S = S | 0, (S ? 31 - (Tr(S ^ S - 1) | 0) | 0 : 32) | 0;
      }
      function ay(S, x, T, P, H) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0, H = H | 0;
        var J = 0, g = 0, p = 0, E = 0, B = 0, D = 0, j = 0, te = 0, he = 0, ve = 0;
        if (D = S, E = x, B = E, g = T, te = P, p = te, !B)
          return J = (H | 0) != 0, p ? J ? (_[H >> 2] = S | 0, _[H + 4 >> 2] = x & 0, te = 0, H = 0, $t(te | 0), H | 0) : (te = 0, H = 0, $t(te | 0), H | 0) : (J && (_[H >> 2] = (D >>> 0) % (g >>> 0), _[H + 4 >> 2] = 0), te = 0, H = (D >>> 0) / (g >>> 0) >>> 0, $t(te | 0), H | 0);
        J = (p | 0) == 0;
        do
          if (g) {
            if (!J) {
              if (J = (Tr(p | 0) | 0) - (Tr(B | 0) | 0) | 0, J >>> 0 <= 31) {
                j = J + 1 | 0, p = 31 - J | 0, x = J - 31 >> 31, g = j, S = D >>> (j >>> 0) & x | B << p, x = B >>> (j >>> 0) & x, J = 0, p = D << p;
                break;
              }
              return H ? (_[H >> 2] = S | 0, _[H + 4 >> 2] = E | x & 0, te = 0, H = 0, $t(te | 0), H | 0) : (te = 0, H = 0, $t(te | 0), H | 0);
            }
            if (J = g - 1 | 0, J & g | 0) {
              p = (Tr(g | 0) | 0) + 33 - (Tr(B | 0) | 0) | 0, ve = 64 - p | 0, j = 32 - p | 0, E = j >> 31, he = p - 32 | 0, x = he >> 31, g = p, S = j - 1 >> 31 & B >>> (he >>> 0) | (B << j | D >>> (p >>> 0)) & x, x = x & B >>> (p >>> 0), J = D << ve & E, p = (B << ve | D >>> (he >>> 0)) & E | D << j & p - 33 >> 31;
              break;
            }
            return H | 0 && (_[H >> 2] = J & D, _[H + 4 >> 2] = 0), (g | 0) == 1 ? (he = E | x & 0, ve = S | 0 | 0, $t(he | 0), ve | 0) : (ve = hh(g | 0) | 0, he = B >>> (ve >>> 0) | 0, ve = B << 32 - ve | D >>> (ve >>> 0) | 0, $t(he | 0), ve | 0);
          } else {
            if (J)
              return H | 0 && (_[H >> 2] = (B >>> 0) % (g >>> 0), _[H + 4 >> 2] = 0), he = 0, ve = (B >>> 0) / (g >>> 0) >>> 0, $t(he | 0), ve | 0;
            if (!D)
              return H | 0 && (_[H >> 2] = 0, _[H + 4 >> 2] = (B >>> 0) % (p >>> 0)), he = 0, ve = (B >>> 0) / (p >>> 0) >>> 0, $t(he | 0), ve | 0;
            if (J = p - 1 | 0, !(J & p))
              return H | 0 && (_[H >> 2] = S | 0, _[H + 4 >> 2] = J & B | x & 0), he = 0, ve = B >>> ((hh(p | 0) | 0) >>> 0), $t(he | 0), ve | 0;
            if (J = (Tr(p | 0) | 0) - (Tr(B | 0) | 0) | 0, J >>> 0 <= 30) {
              x = J + 1 | 0, p = 31 - J | 0, g = x, S = B << p | D >>> (x >>> 0), x = B >>> (x >>> 0), J = 0, p = D << p;
              break;
            }
            return H ? (_[H >> 2] = S | 0, _[H + 4 >> 2] = E | x & 0, he = 0, ve = 0, $t(he | 0), ve | 0) : (he = 0, ve = 0, $t(he | 0), ve | 0);
          }
        while (0);
        if (!g)
          B = p, E = 0, p = 0;
        else {
          j = T | 0 | 0, D = te | P & 0, B = bc(j | 0, D | 0, -1, -1) | 0, T = Ye() | 0, E = p, p = 0;
          do
            P = E, E = J >>> 31 | E << 1, J = p | J << 1, P = S << 1 | P >>> 31 | 0, te = S >>> 31 | x << 1 | 0, Au(B | 0, T | 0, P | 0, te | 0) | 0, ve = Ye() | 0, he = ve >> 31 | ((ve | 0) < 0 ? -1 : 0) << 1, p = he & 1, S = Au(P | 0, te | 0, he & j | 0, (((ve | 0) < 0 ? -1 : 0) >> 31 | ((ve | 0) < 0 ? -1 : 0) << 1) & D | 0) | 0, x = Ye() | 0, g = g - 1 | 0;
          while (g | 0);
          B = E, E = 0;
        }
        return g = 0, H | 0 && (_[H >> 2] = S, _[H + 4 >> 2] = x), he = (J | 0) >>> 31 | (B | g) << 1 | (g << 1 | J >>> 31) & 0 | E, ve = (J << 1 | 0) & -2 | p, $t(he | 0), ve | 0;
      }
      function ka(S, x, T, P) {
        S = S | 0, x = x | 0, T = T | 0, P = P | 0;
        var H = 0, J = 0;
        return J = $e, $e = $e + 16 | 0, H = J | 0, ay(S, x, T, P, H) | 0, $e = J, $t(_[H + 4 >> 2] | 0), _[H >> 2] | 0 | 0;
      }
      function Yt(S, x, T) {
        return S = S | 0, x = x | 0, T = T | 0, (T | 0) < 32 ? ($t(x >>> T | 0), S >>> T | (x & (1 << T) - 1) << 32 - T) : ($t(0), x >>> T - 32 | 0);
      }
      function gn(S, x, T) {
        return S = S | 0, x = x | 0, T = T | 0, (T | 0) < 32 ? ($t(x << T | (S & (1 << T) - 1 << 32 - T) >>> 32 - T | 0), S << T) : ($t(S << T - 32 | 0), 0);
      }
      function dh(S, x) {
        return S = +S, x = +x, S != S ? +x : x != x ? +S : +vr(+S, +x);
      }
      function _c(S) {
        return S = +S, S >= 0 ? +ze(S + 0.5) : +Sn(S - 0.5);
      }
      function Vn(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0;
        if ((T | 0) >= 8192)
          return In(S | 0, x | 0, T | 0) | 0, S | 0;
        if (J = S | 0, H = S + T | 0, (S & 3) == (x & 3)) {
          for (; S & 3; ) {
            if (!T)
              return J | 0;
            Me[S >> 0] = Me[x >> 0] | 0, S = S + 1 | 0, x = x + 1 | 0, T = T - 1 | 0;
          }
          for (T = H & -4 | 0, P = T - 64 | 0; (S | 0) <= (P | 0); )
            _[S >> 2] = _[x >> 2], _[S + 4 >> 2] = _[x + 4 >> 2], _[S + 8 >> 2] = _[x + 8 >> 2], _[S + 12 >> 2] = _[x + 12 >> 2], _[S + 16 >> 2] = _[x + 16 >> 2], _[S + 20 >> 2] = _[x + 20 >> 2], _[S + 24 >> 2] = _[x + 24 >> 2], _[S + 28 >> 2] = _[x + 28 >> 2], _[S + 32 >> 2] = _[x + 32 >> 2], _[S + 36 >> 2] = _[x + 36 >> 2], _[S + 40 >> 2] = _[x + 40 >> 2], _[S + 44 >> 2] = _[x + 44 >> 2], _[S + 48 >> 2] = _[x + 48 >> 2], _[S + 52 >> 2] = _[x + 52 >> 2], _[S + 56 >> 2] = _[x + 56 >> 2], _[S + 60 >> 2] = _[x + 60 >> 2], S = S + 64 | 0, x = x + 64 | 0;
          for (; (S | 0) < (T | 0); )
            _[S >> 2] = _[x >> 2], S = S + 4 | 0, x = x + 4 | 0;
        } else
          for (T = H - 4 | 0; (S | 0) < (T | 0); )
            Me[S >> 0] = Me[x >> 0] | 0, Me[S + 1 >> 0] = Me[x + 1 >> 0] | 0, Me[S + 2 >> 0] = Me[x + 2 >> 0] | 0, Me[S + 3 >> 0] = Me[x + 3 >> 0] | 0, S = S + 4 | 0, x = x + 4 | 0;
        for (; (S | 0) < (H | 0); )
          Me[S >> 0] = Me[x >> 0] | 0, S = S + 1 | 0, x = x + 1 | 0;
        return J | 0;
      }
      function Ys(S, x, T) {
        S = S | 0, x = x | 0, T = T | 0;
        var P = 0, H = 0, J = 0, g = 0;
        if (J = S + T | 0, x = x & 255, (T | 0) >= 67) {
          for (; S & 3; )
            Me[S >> 0] = x, S = S + 1 | 0;
          for (P = J & -4 | 0, g = x | x << 8 | x << 16 | x << 24, H = P - 64 | 0; (S | 0) <= (H | 0); )
            _[S >> 2] = g, _[S + 4 >> 2] = g, _[S + 8 >> 2] = g, _[S + 12 >> 2] = g, _[S + 16 >> 2] = g, _[S + 20 >> 2] = g, _[S + 24 >> 2] = g, _[S + 28 >> 2] = g, _[S + 32 >> 2] = g, _[S + 36 >> 2] = g, _[S + 40 >> 2] = g, _[S + 44 >> 2] = g, _[S + 48 >> 2] = g, _[S + 52 >> 2] = g, _[S + 56 >> 2] = g, _[S + 60 >> 2] = g, S = S + 64 | 0;
          for (; (S | 0) < (P | 0); )
            _[S >> 2] = g, S = S + 4 | 0;
        }
        for (; (S | 0) < (J | 0); )
          Me[S >> 0] = x, S = S + 1 | 0;
        return J - T | 0;
      }
      function ph(S) {
        return S = +S, S >= 0 ? +ze(S + 0.5) : +Sn(S - 0.5);
      }
      function Ba(S) {
        S = S | 0;
        var x = 0, T = 0, P = 0;
        return P = zr() | 0, T = _[He >> 2] | 0, x = T + S | 0, (S | 0) > 0 & (x | 0) < (T | 0) | (x | 0) < 0 ? (Mr(x | 0) | 0, Ir(12), -1) : (x | 0) > (P | 0) && !(mr(x | 0) | 0) ? (Ir(12), -1) : (_[He >> 2] = x, T | 0);
      }
      return {
        ___uremdi3: ka,
        _bitshift64Lshr: Yt,
        _bitshift64Shl: gn,
        _calloc: bA,
        _cellAreaKm2: oh,
        _cellAreaM2: yA,
        _cellAreaRads2: Ea,
        _compact: yc,
        _destroyLinkedPolygon: lh,
        _edgeLengthKm: Xf,
        _edgeLengthM: Hd,
        _emscripten_replace_memory: Ps,
        _exactEdgeLengthKm: Cs,
        _exactEdgeLengthM: k1,
        _exactEdgeLengthRads: ra,
        _experimentalH3ToLocalIj: D0,
        _experimentalLocalIjToH3: ch,
        _free: Or,
        _geoToH3: ah,
        _getDestinationH3IndexFromUnidirectionalEdge: Xu,
        _getH3IndexesFromUnidirectionalEdge: vs,
        _getH3UnidirectionalEdge: mm,
        _getH3UnidirectionalEdgeBoundary: is,
        _getH3UnidirectionalEdgesFromHexagon: KA,
        _getOriginH3IndexFromUnidirectionalEdge: eg,
        _getPentagonIndexes: Fa,
        _getRes0Indexes: nh,
        _h3Distance: ef,
        _h3GetBaseCell: Bl,
        _h3GetFaces: Ah,
        _h3GetResolution: R0,
        _h3IndexesAreNeighbors: Wu,
        _h3IsPentagon: Fi,
        _h3IsResClassIII: sh,
        _h3IsValid: vA,
        _h3Line: ry,
        _h3LineSize: Pa,
        _h3SetToLinkedGeo: lo,
        _h3ToCenterChild: Zf,
        _h3ToChildren: vo,
        _h3ToGeo: JA,
        _h3ToGeoBoundary: ia,
        _h3ToParent: Ec,
        _h3UnidirectionalEdgeIsValid: au,
        _hexAreaKm2: x0,
        _hexAreaM2: go,
        _hexRing: Fe,
        _i64Subtract: Au,
        _kRing: ml,
        _kRingDistances: dc,
        _llvm_minnum_f64: dh,
        _llvm_round_f64: _c,
        _malloc: BA,
        _maxFaceCount: ys,
        _maxH3ToChildrenSize: Ma,
        _maxKringSize: or,
        _maxPolyfillSize: Ze,
        _maxUncompactSize: G1,
        _memcpy: Vn,
        _memset: Ys,
        _numHexagons: Us,
        _pentagonIndexCount: oa,
        _pointDistKm: Ca,
        _pointDistM: Ur,
        _pointDistRads: ma,
        _polyfill: Ve,
        _res0IndexCount: ai,
        _round: ph,
        _sbrk: Ba,
        _sizeOfCoordIJ: ho,
        _sizeOfGeoBoundary: WA,
        _sizeOfGeoCoord: uh,
        _sizeOfGeoPolygon: ya,
        _sizeOfGeofence: fh,
        _sizeOfH3Index: tf,
        _sizeOfLinkedGeoPolygon: tA,
        _uncompact: Es,
        establishStackSpace: hc,
        stackAlloc: Wn,
        stackRestore: Ao,
        stackSave: Is
      };
    }(
      // EMSCRIPTEN_END_ASM
      un,
      hn,
      N
    )
  );
  e.___uremdi3 = We.___uremdi3, e._bitshift64Lshr = We._bitshift64Lshr, e._bitshift64Shl = We._bitshift64Shl, e._calloc = We._calloc, e._cellAreaKm2 = We._cellAreaKm2, e._cellAreaM2 = We._cellAreaM2, e._cellAreaRads2 = We._cellAreaRads2, e._compact = We._compact, e._destroyLinkedPolygon = We._destroyLinkedPolygon, e._edgeLengthKm = We._edgeLengthKm, e._edgeLengthM = We._edgeLengthM;
  var En = e._emscripten_replace_memory = We._emscripten_replace_memory;
  e._exactEdgeLengthKm = We._exactEdgeLengthKm, e._exactEdgeLengthM = We._exactEdgeLengthM, e._exactEdgeLengthRads = We._exactEdgeLengthRads, e._experimentalH3ToLocalIj = We._experimentalH3ToLocalIj, e._experimentalLocalIjToH3 = We._experimentalLocalIjToH3, e._free = We._free, e._geoToH3 = We._geoToH3, e._getDestinationH3IndexFromUnidirectionalEdge = We._getDestinationH3IndexFromUnidirectionalEdge, e._getH3IndexesFromUnidirectionalEdge = We._getH3IndexesFromUnidirectionalEdge, e._getH3UnidirectionalEdge = We._getH3UnidirectionalEdge, e._getH3UnidirectionalEdgeBoundary = We._getH3UnidirectionalEdgeBoundary, e._getH3UnidirectionalEdgesFromHexagon = We._getH3UnidirectionalEdgesFromHexagon, e._getOriginH3IndexFromUnidirectionalEdge = We._getOriginH3IndexFromUnidirectionalEdge, e._getPentagonIndexes = We._getPentagonIndexes, e._getRes0Indexes = We._getRes0Indexes, e._h3Distance = We._h3Distance, e._h3GetBaseCell = We._h3GetBaseCell, e._h3GetFaces = We._h3GetFaces, e._h3GetResolution = We._h3GetResolution, e._h3IndexesAreNeighbors = We._h3IndexesAreNeighbors, e._h3IsPentagon = We._h3IsPentagon, e._h3IsResClassIII = We._h3IsResClassIII, e._h3IsValid = We._h3IsValid, e._h3Line = We._h3Line, e._h3LineSize = We._h3LineSize, e._h3SetToLinkedGeo = We._h3SetToLinkedGeo, e._h3ToCenterChild = We._h3ToCenterChild, e._h3ToChildren = We._h3ToChildren, e._h3ToGeo = We._h3ToGeo, e._h3ToGeoBoundary = We._h3ToGeoBoundary, e._h3ToParent = We._h3ToParent, e._h3UnidirectionalEdgeIsValid = We._h3UnidirectionalEdgeIsValid, e._hexAreaKm2 = We._hexAreaKm2, e._hexAreaM2 = We._hexAreaM2, e._hexRing = We._hexRing, e._i64Subtract = We._i64Subtract, e._kRing = We._kRing, e._kRingDistances = We._kRingDistances, e._llvm_minnum_f64 = We._llvm_minnum_f64, e._llvm_round_f64 = We._llvm_round_f64, e._malloc = We._malloc, e._maxFaceCount = We._maxFaceCount, e._maxH3ToChildrenSize = We._maxH3ToChildrenSize, e._maxKringSize = We._maxKringSize, e._maxPolyfillSize = We._maxPolyfillSize, e._maxUncompactSize = We._maxUncompactSize, e._memcpy = We._memcpy, e._memset = We._memset, e._numHexagons = We._numHexagons, e._pentagonIndexCount = We._pentagonIndexCount, e._pointDistKm = We._pointDistKm, e._pointDistM = We._pointDistM, e._pointDistRads = We._pointDistRads, e._polyfill = We._polyfill, e._res0IndexCount = We._res0IndexCount, e._round = We._round, e._sbrk = We._sbrk, e._sizeOfCoordIJ = We._sizeOfCoordIJ, e._sizeOfGeoBoundary = We._sizeOfGeoBoundary, e._sizeOfGeoCoord = We._sizeOfGeoCoord, e._sizeOfGeoPolygon = We._sizeOfGeoPolygon, e._sizeOfGeofence = We._sizeOfGeofence, e._sizeOfH3Index = We._sizeOfH3Index, e._sizeOfLinkedGeoPolygon = We._sizeOfLinkedGeoPolygon, e._uncompact = We._uncompact, e.establishStackSpace = We.establishStackSpace;
  var qn = e.stackAlloc = We.stackAlloc, Pt = e.stackRestore = We.stackRestore, dr = e.stackSave = We.stackSave;
  if (e.asm = We, e.cwrap = v, e.setValue = h, e.getValue = d, e.getTempRet0 = u, ie) {
    de(ie) || (ie = o(ie));
    {
      Ee();
      var yr = function(nt) {
        nt.byteLength && (nt = new Uint8Array(nt)), $.set(nt, f), e.memoryInitializerRequest && delete e.memoryInitializerRequest.response, oe();
      }, jn = function() {
        s(ie, yr, function() {
          throw "could not load memory initializer " + ie;
        });
      }, Ot = It(ie);
      if (Ot)
        yr(Ot.buffer);
      else if (e.memoryInitializerRequest) {
        var yn = function() {
          var nt = e.memoryInitializerRequest, st = nt.response;
          if (nt.status !== 200 && nt.status !== 0) {
            var xt = It(e.memoryInitializerRequestURL);
            if (xt)
              st = xt.buffer;
            else {
              console.warn("a problem seems to have happened with Module.memoryInitializerRequest, status: " + nt.status + ", retrying " + ie), jn();
              return;
            }
          }
          yr(st);
        };
        e.memoryInitializerRequest.response ? setTimeout(yn, 0) : e.memoryInitializerRequest.addEventListener("load", yn);
      } else
        jn();
    }
  }
  var Fn;
  Re = function nt() {
    Fn || xn(), Fn || (Re = nt);
  };
  function xn(nt) {
    if (_e > 0 || (Qe(), _e > 0))
      return;
    function st() {
      Fn || (Fn = !0, !I && (xe(), Se(), e.onRuntimeInitialized && e.onRuntimeInitialized(), De()));
    }
    e.setStatus ? (e.setStatus("Running..."), setTimeout(function() {
      setTimeout(function() {
        e.setStatus("");
      }, 1), st();
    }, 1)) : st();
  }
  e.run = xn;
  function vn(nt) {
    throw e.onAbort && e.onAbort(nt), nt += "", a(nt), A(nt), I = !0, "abort(" + nt + "). Build with -s ASSERTIONS=1 for more info.";
  }
  if (e.abort = vn, e.preInit)
    for (typeof e.preInit == "function" && (e.preInit = [e.preInit]); e.preInit.length > 0; )
      e.preInit.pop()();
  return xn(), t;
}(typeof Wt == "object" ? Wt : {}), fr = "number", g2 = fr, Nr = fr, ii = fr, cu = fr, xi = fr, bCn = [
  // The size functions are inserted via build/sizes.h
  ["sizeOfH3Index", fr],
  ["sizeOfGeoCoord", fr],
  ["sizeOfGeoBoundary", fr],
  ["sizeOfGeoPolygon", fr],
  ["sizeOfGeofence", fr],
  ["sizeOfLinkedGeoPolygon", fr],
  ["sizeOfCoordIJ", fr],
  // The remaining functions are defined in the core lib in h3Api.h
  ["h3IsValid", g2, [Nr, ii]],
  ["geoToH3", Nr, [fr, fr, cu]],
  ["h3ToGeo", null, [Nr, ii, xi]],
  ["h3ToGeoBoundary", null, [Nr, ii, xi]],
  ["maxKringSize", fr, [fr]],
  ["kRing", null, [Nr, ii, fr, xi]],
  ["kRingDistances", null, [Nr, ii, fr, xi, xi]],
  ["hexRing", null, [Nr, ii, fr, xi]],
  ["maxPolyfillSize", fr, [xi, cu]],
  ["polyfill", null, [xi, cu, xi]],
  ["h3SetToLinkedGeo", null, [xi, fr, xi]],
  ["destroyLinkedPolygon", null, [xi]],
  ["compact", fr, [xi, xi, fr]],
  ["uncompact", fr, [xi, fr, xi, fr, cu]],
  ["maxUncompactSize", fr, [xi, fr, cu]],
  ["h3IsPentagon", g2, [Nr, ii]],
  ["h3IsResClassIII", g2, [Nr, ii]],
  ["h3GetBaseCell", fr, [Nr, ii]],
  ["h3GetResolution", fr, [Nr, ii]],
  ["maxFaceCount", fr, [Nr, ii]],
  ["h3GetFaces", null, [Nr, ii, xi]],
  ["h3ToParent", Nr, [Nr, ii, cu]],
  ["h3ToChildren", null, [Nr, ii, cu, xi]],
  ["h3ToCenterChild", Nr, [Nr, ii, cu]],
  ["maxH3ToChildrenSize", fr, [Nr, ii, cu]],
  ["h3IndexesAreNeighbors", g2, [Nr, ii, Nr, ii]],
  ["getH3UnidirectionalEdge", Nr, [Nr, ii, Nr, ii]],
  ["getOriginH3IndexFromUnidirectionalEdge", Nr, [Nr, ii]],
  ["getDestinationH3IndexFromUnidirectionalEdge", Nr, [Nr, ii]],
  ["h3UnidirectionalEdgeIsValid", g2, [Nr, ii]],
  ["getH3IndexesFromUnidirectionalEdge", null, [Nr, ii, xi]],
  ["getH3UnidirectionalEdgesFromHexagon", null, [Nr, ii, xi]],
  ["getH3UnidirectionalEdgeBoundary", null, [Nr, ii, xi]],
  ["h3Distance", fr, [Nr, ii, Nr, ii]],
  ["h3Line", fr, [Nr, ii, Nr, ii, xi]],
  ["h3LineSize", fr, [Nr, ii, Nr, ii]],
  ["experimentalH3ToLocalIj", fr, [Nr, ii, Nr, ii, xi]],
  ["experimentalLocalIjToH3", fr, [Nr, ii, xi, xi]],
  ["hexAreaM2", fr, [cu]],
  ["hexAreaKm2", fr, [cu]],
  ["edgeLengthM", fr, [cu]],
  ["edgeLengthKm", fr, [cu]],
  ["pointDistM", fr, [xi, xi]],
  ["pointDistKm", fr, [xi, xi]],
  ["pointDistRads", fr, [xi, xi]],
  ["cellAreaM2", fr, [Nr, ii]],
  ["cellAreaKm2", fr, [Nr, ii]],
  ["cellAreaRads2", fr, [Nr, ii]],
  ["exactEdgeLengthM", fr, [Nr, ii]],
  ["exactEdgeLengthKm", fr, [Nr, ii]],
  ["exactEdgeLengthRads", fr, [Nr, ii]],
  ["numHexagons", fr, [cu]],
  ["getRes0Indexes", null, [xi]],
  ["res0IndexCount", fr],
  ["getPentagonIndexes", null, [fr, xi]],
  ["pentagonIndexCount", fr]
], Nn = {};
bCn.forEach(function(e) {
  Nn[e[0]] = Wt.cwrap.apply(Wt, e);
});
var C_ = 16, $c = 4, KSe = 4, WC = 8, oc = Nn.sizeOfH3Index(), y$ = Nn.sizeOfGeoCoord(), vje = Nn.sizeOfGeoBoundary(), _Cn = Nn.sizeOfGeoPolygon(), bD = Nn.sizeOfGeofence(), SCn = Nn.sizeOfLinkedGeoPolygon(), Bje = Nn.sizeOfCoordIJ(), Du = {
  m: "m",
  m2: "m2",
  km: "km",
  km2: "km2",
  rads: "rads",
  rads2: "rads2"
};
function Pw(t) {
  if (typeof t != "number" || t < 0 || t > 15 || Math.floor(t) !== t)
    throw new Error("Invalid resolution: " + t);
}
var QCn = /[^0-9a-fA-F]/;
function Qi(t) {
  if (Array.isArray(t) && t.length === 2 && Number.isInteger(t[0]) && Number.isInteger(t[1]))
    return t;
  if (typeof t != "string" || QCn.test(t))
    return [0, 0];
  var e = parseInt(t.substring(0, t.length - 8), C_), n = parseInt(t.substring(t.length - 8), C_);
  return [n, e];
}
function WSe(t) {
  if (t >= 0)
    return t.toString(C_);
  t = t & 2147483647;
  var e = bje(8, t.toString(C_)), n = (parseInt(e[0], C_) + 8).toString(C_);
  return e = n + e.substring(1), e;
}
function v$(t, e) {
  return WSe(e) + bje(8, WSe(t));
}
function bje(t, e) {
  for (var n = t - e.length, r = "", i = 0; i < n; i++)
    r += "0";
  return r = r + e, r;
}
function XSe(t, e, n) {
  for (var r = t.length, i = Wt._calloc(r, y$), o = n ? 1 : 0, s = n ? 0 : 1, a = 0; a < r * 2; a += 2)
    Wt.HEAPF64.set([t[a / 2][o], t[a / 2][s]].map(b$), i / WC + a);
  return Wt.HEAPU32.set([r, i], e / $c), e;
}
function wCn(t, e) {
  var n = t.length - 1, r = Wt._calloc(_Cn), i = 0, o = i + bD, s = o + $c;
  XSe(t[0], r + i, e);
  var a;
  if (n > 0) {
    a = Wt._calloc(n, bD);
    for (var A = 0; A < n; A++)
      XSe(t[A + 1], a + bD * A, e);
  }
  return Wt.setValue(r + o, n, "i32"), Wt.setValue(r + s, a, "i32"), r;
}
function xCn(t) {
  var e = 0, n = e + bD, r = n + $c, i = $c;
  Wt._free(Wt.getValue(t + e + i, "i8*"));
  var o = Wt.getValue(t + n, "i32");
  if (o > 0) {
    for (var s = Wt.getValue(t + r, "i32"), a = 0; a < o; a++)
      Wt._free(Wt.getValue(s + bD * a + i, "i8*"));
    Wt._free(s);
  }
  Wt._free(t);
}
function _je(t) {
  var e = Wt.getTempRet0();
  return [t, e];
}
function kw(t) {
  var e = _je(t), n = e[0], r = e[1];
  return r ? v$(n, r) : null;
}
function Sje(t, e) {
  e === void 0 && (e = 0);
  var n = Wt.getValue(t + $c * e * 2, "i32"), r = Wt.getValue(t + $c * (e * 2 + 1), "i32");
  return r ? v$(n, r) : null;
}
function RCn(t, e, n) {
  Wt.HEAPU32.set(Qi(t), e / $c + 2 * n);
}
function Td(t, e) {
  for (var n = [], r = 0; r < e; r++) {
    var i = Sje(t, r);
    i !== null && n.push(i);
  }
  return n;
}
function Ece(t, e) {
  for (var n = e.length, r = 0; r < n; r++)
    RCn(e[r], t, r);
}
function ZSe(t, e) {
  var n = Wt._calloc(1, y$);
  return Wt.HEAPF64.set([t, e].map(b$), n / WC), n;
}
function FU(t) {
  return Fje(Wt.getValue(t, "double"));
}
function yce(t) {
  return [FU(t), FU(t + WC)];
}
function Qje(t) {
  return [FU(t + WC), FU(t)];
}
function wje(t, e, n) {
  for (var r = Wt.getValue(t, "i32"), i = t + WC, o = [], s = e ? Qje : yce, a = 0; a < r * 2; a += 2)
    o.push(s(i + WC * a));
  return n && o.push(o[0]), o;
}
function DCn(t, e) {
  for (var n = [], r = e ? Qje : yce, i, o, s, a; t; ) {
    for (n.push(i = []), o = Wt.getValue(t, "i8*"); o; ) {
      for (i.push(s = []), a = Wt.getValue(o, "i8*"); a; )
        s.push(r(a)), a = Wt.getValue(a + WC * 2, "i8*");
      e && s.push(s[0]), o = Wt.getValue(o + KSe * 2, "i8*");
    }
    t = Wt.getValue(t + KSe * 2, "i8*");
  }
  return n;
}
function TCn(t) {
  return {
    i: Wt.getValue(t, "i32"),
    j: Wt.getValue(t + $c, "i32")
  };
}
function NCn(t, e) {
  var n = e.i, r = e.j;
  Wt.setValue(t, n, "i32"), Wt.setValue(t + $c, r, "i32");
}
function LCn(t, e) {
  for (var n = [], r = 0; r < e; r++) {
    var i = Wt.getValue(t + $c * r, "i32");
    i >= 0 && n.push(i);
  }
  return n;
}
function xje(t) {
  var e = Qi(t), n = e[0], r = e[1];
  return !!Nn.h3IsValid(n, r);
}
function Rje(t) {
  var e = Qi(t), n = e[0], r = e[1];
  return !!Nn.h3IsPentagon(n, r);
}
function MCn(t) {
  var e = Qi(t), n = e[0], r = e[1];
  return !!Nn.h3IsResClassIII(n, r);
}
function OCn(t) {
  var e = Qi(t), n = e[0], r = e[1];
  return Nn.h3GetBaseCell(n, r);
}
function FCn(t) {
  var e = Qi(t), n = e[0], r = e[1], i = Nn.maxFaceCount(n, r), o = Wt._malloc($c * i);
  Nn.h3GetFaces(n, r, o);
  var s = LCn(o, i);
  return Wt._free(o), s;
}
function Dje(t) {
  var e = Qi(t), n = e[0], r = e[1];
  return Nn.h3IsValid(n, r) ? Nn.h3GetResolution(n, r) : -1;
}
function Tje(t, e, n) {
  var r = Wt._malloc(y$);
  Wt.HEAPF64.set([t, e].map(b$), r / WC);
  var i = kw(Nn.geoToH3(r, n));
  return Wt._free(r), i;
}
function B$(t) {
  var e = Wt._malloc(y$), n = Qi(t), r = n[0], i = n[1];
  Nn.h3ToGeo(r, i, e);
  var o = yce(e);
  return Wt._free(e), o;
}
function Nje(t, e) {
  var n = Wt._malloc(vje), r = Qi(t), i = r[0], o = r[1];
  Nn.h3ToGeoBoundary(i, o, n);
  var s = wje(n, e, e);
  return Wt._free(n), s;
}
function PCn(t, e) {
  var n = Qi(t), r = n[0], i = n[1];
  return kw(Nn.h3ToParent(r, i, e));
}
function kCn(t, e) {
  if (!xje(t))
    return [];
  var n = Qi(t), r = n[0], i = n[1], o = Nn.maxH3ToChildrenSize(r, i, e), s = Wt._calloc(o, oc);
  Nn.h3ToChildren(r, i, e, s);
  var a = Td(s, o);
  return Wt._free(s), a;
}
function GCn(t, e) {
  var n = Qi(t), r = n[0], i = n[1];
  return kw(Nn.h3ToCenterChild(r, i, e));
}
function UCn(t, e) {
  var n = Qi(t), r = n[0], i = n[1], o = Nn.maxKringSize(e), s = Wt._calloc(o, oc);
  Nn.kRing(r, i, e, s);
  var a = Td(s, o);
  return Wt._free(s), a;
}
function HCn(t, e) {
  var n = Qi(t), r = n[0], i = n[1], o = Nn.maxKringSize(e), s = Wt._calloc(o, oc), a = Wt._calloc(o, $c);
  Nn.kRingDistances(r, i, e, s, a);
  for (var A = [], l = 0; l < e + 1; l++)
    A.push([]);
  for (var c = 0; c < o * 2; c += 2) {
    var u = Wt.getValue(s + $c * c, "i32"), f = Wt.getValue(s + $c * (c + 1), "i32"), h = Wt.getValue(a + $c * (c / 2), "i32");
    (u !== 0 || f !== 0) && A[h].push(v$(u, f));
  }
  return Wt._free(s), Wt._free(a), A;
}
function $Cn(t, e) {
  var n = e === 0 ? 1 : 6 * e, r = Wt._calloc(n, oc), i = Nn.hexRing.apply(Nn, Qi(t).concat([e], [r]));
  if (i !== 0)
    throw Wt._free(r), new Error("Failed to get hexRing (encountered a pentagon?)");
  var o = Td(r, n);
  return Wt._free(r), o;
}
function qCn(t, e, n) {
  if (Pw(e), n = !!n, t.length === 0 || t[0].length === 0)
    return [];
  typeof t[0][0] == "number" && (t = [t]);
  var r = wCn(t, n), i = Nn.maxPolyfillSize(r, e), o = Wt._calloc(i, oc);
  Nn.polyfill(r, e, o);
  var s = Td(o, i);
  return Wt._free(o), xCn(r), s;
}
function Lje(t, e) {
  if (!t || !t.length)
    return [];
  var n = t.length, r = Wt._calloc(n, oc);
  Ece(r, t);
  var i = Wt._calloc(SCn), o = i;
  Nn.h3SetToLinkedGeo(r, n, i);
  var s = DCn(i, e);
  return Nn.destroyLinkedPolygon(o), Wt._free(o), Wt._free(r), s;
}
function jCn(t) {
  if (!t || !t.length)
    return [];
  var e = t.length, n = Wt._calloc(e, oc);
  Ece(n, t);
  var r = Wt._calloc(e, oc), i = Nn.compact(n, r, e);
  if (i !== 0)
    throw Wt._free(n), Wt._free(r), new Error("Failed to compact, malformed input data (duplicate hexagons?)");
  var o = Td(r, e);
  return Wt._free(n), Wt._free(r), o;
}
function YCn(t, e) {
  if (Pw(e), !t || !t.length)
    return [];
  var n = t.length, r = Wt._calloc(n, oc);
  Ece(r, t);
  var i = Nn.maxUncompactSize(r, n, e), o = Wt._calloc(i, oc), s = Nn.uncompact(r, n, o, i, e);
  if (s !== 0)
    throw Wt._free(r), Wt._free(o), new Error("Failed to uncompact (bad resolution?)");
  var a = Td(o, i);
  return Wt._free(r), Wt._free(o), a;
}
function zCn(t, e) {
  var n = Qi(t), r = n[0], i = n[1], o = Qi(e), s = o[0], a = o[1];
  return !!Nn.h3IndexesAreNeighbors(r, i, s, a);
}
function VCn(t, e) {
  var n = Qi(t), r = n[0], i = n[1], o = Qi(e), s = o[0], a = o[1];
  return kw(Nn.getH3UnidirectionalEdge(r, i, s, a));
}
function JCn(t) {
  var e = Qi(t), n = e[0], r = e[1];
  return kw(Nn.getOriginH3IndexFromUnidirectionalEdge(n, r));
}
function KCn(t) {
  var e = Qi(t), n = e[0], r = e[1];
  return kw(Nn.getDestinationH3IndexFromUnidirectionalEdge(n, r));
}
function WCn(t) {
  var e = Qi(t), n = e[0], r = e[1];
  return !!Nn.h3UnidirectionalEdgeIsValid(n, r);
}
function XCn(t) {
  var e = Qi(t), n = e[0], r = e[1], i = 2, o = Wt._calloc(i, oc);
  Nn.getH3IndexesFromUnidirectionalEdge(n, r, o);
  var s = Td(o, i);
  return Wt._free(o), s;
}
function ZCn(t) {
  var e = Qi(t), n = e[0], r = e[1], i = 6, o = Wt._calloc(i, oc);
  Nn.getH3UnidirectionalEdgesFromHexagon(n, r, o);
  var s = Td(o, i);
  return Wt._free(o), s;
}
function eEn(t, e) {
  var n = Wt._malloc(vje), r = Qi(t), i = r[0], o = r[1];
  Nn.getH3UnidirectionalEdgeBoundary(i, o, n);
  var s = wje(n, e);
  return Wt._free(n), s;
}
function Mje(t, e) {
  var n = Qi(t), r = n[0], i = n[1], o = Qi(e), s = o[0], a = o[1];
  return Nn.h3Distance(r, i, s, a);
}
function tEn(t, e) {
  var n = Qi(t), r = n[0], i = n[1], o = Qi(e), s = o[0], a = o[1], A = Nn.h3LineSize(r, i, s, a);
  if (A < 0)
    throw new Error("Line cannot be calculated");
  var l = Wt._calloc(A, oc);
  Nn.h3Line(r, i, s, a, l);
  var c = Td(l, A);
  return Wt._free(l), c;
}
function nEn(t, e) {
  var n = Wt._malloc(Bje), r = Nn.experimentalH3ToLocalIj.apply(Nn, Qi(t).concat(Qi(e), [n])), i = TCn(n);
  switch (Wt._free(n), r) {
    case 0:
      return i;
    case 1:
      throw new Error("Incompatible origin and index.");
    case 2:
    default:
      throw new Error("Local IJ coordinates undefined for this origin and index pair. The index may be too far from the origin.");
    case 3:
    case 4:
    case 5:
      throw new Error("Encountered possible pentagon distortion");
  }
}
function rEn(t, e) {
  if (!e || typeof e.i != "number" || typeof e.j != "number")
    throw new Error("Coordinates must be provided as an {i, j} object");
  var n = Wt._malloc(Bje), r = Wt._malloc(oc);
  NCn(n, e);
  var i = Nn.experimentalLocalIjToH3.apply(Nn, Qi(t).concat([n], [r])), o = Sje(r);
  if (Wt._free(n), Wt._free(r), i !== 0)
    throw new Error("Index not defined for this origin and IJ coordinates pair. IJ coordinates may be too far from origin, or a pentagon distortion was encountered.");
  return o;
}
function iEn(t, e, n) {
  var r = ZSe(t[0], t[1]), i = ZSe(e[0], e[1]), o;
  switch (n) {
    case Du.m:
      o = Nn.pointDistM(r, i);
      break;
    case Du.km:
      o = Nn.pointDistKm(r, i);
      break;
    case Du.rads:
      o = Nn.pointDistRads(r, i);
      break;
    default:
      o = null;
  }
  if (Wt._free(r), Wt._free(i), o === null)
    throw new Error("Unknown unit: " + n);
  return o;
}
function oEn(t, e) {
  var n = Qi(t), r = n[0], i = n[1];
  switch (e) {
    case Du.m2:
      return Nn.cellAreaM2(r, i);
    case Du.km2:
      return Nn.cellAreaKm2(r, i);
    case Du.rads2:
      return Nn.cellAreaRads2(r, i);
    default:
      throw new Error("Unknown unit: " + e);
  }
}
function sEn(t, e) {
  var n = Qi(t), r = n[0], i = n[1];
  switch (e) {
    case Du.m:
      return Nn.exactEdgeLengthM(r, i);
    case Du.km:
      return Nn.exactEdgeLengthKm(r, i);
    case Du.rads:
      return Nn.exactEdgeLengthRads(r, i);
    default:
      throw new Error("Unknown unit: " + e);
  }
}
function aEn(t, e) {
  switch (Pw(t), e) {
    case Du.m2:
      return Nn.hexAreaM2(t);
    case Du.km2:
      return Nn.hexAreaKm2(t);
    default:
      throw new Error("Unknown unit: " + e);
  }
}
function Oje(t, e) {
  switch (Pw(t), e) {
    case Du.m:
      return Nn.edgeLengthM(t);
    case Du.km:
      return Nn.edgeLengthKm(t);
    default:
      throw new Error("Unknown unit: " + e);
  }
}
function AEn(t) {
  Pw(t);
  var e = _je(Nn.numHexagons(t)), n = e[0], r = e[1];
  return r ? r * Math.pow(2, 32) + n : n;
}
function lEn() {
  var t = Nn.res0IndexCount(), e = Wt._malloc(oc * t);
  Nn.getRes0Indexes(e);
  var n = Td(e, t);
  return Wt._free(e), n;
}
function cEn(t) {
  Pw(t);
  var e = Nn.pentagonIndexCount(), n = Wt._malloc(oc * e);
  Nn.getPentagonIndexes(t, n);
  var r = Td(n, e);
  return Wt._free(n), r;
}
function b$(t) {
  return t * Math.PI / 180;
}
function Fje(t) {
  return t * 180 / Math.PI;
}
const uEn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  UNITS: Du,
  cellArea: oEn,
  compact: jCn,
  degsToRads: b$,
  edgeLength: Oje,
  exactEdgeLength: sEn,
  experimentalH3ToLocalIj: nEn,
  experimentalLocalIjToH3: rEn,
  geoToH3: Tje,
  getDestinationH3IndexFromUnidirectionalEdge: KCn,
  getH3IndexesFromUnidirectionalEdge: XCn,
  getH3UnidirectionalEdge: VCn,
  getH3UnidirectionalEdgeBoundary: eEn,
  getH3UnidirectionalEdgesFromHexagon: ZCn,
  getOriginH3IndexFromUnidirectionalEdge: JCn,
  getPentagonIndexes: cEn,
  getRes0Indexes: lEn,
  h3Distance: Mje,
  h3GetBaseCell: OCn,
  h3GetFaces: FCn,
  h3GetResolution: Dje,
  h3IndexToSplitLong: Qi,
  h3IndexesAreNeighbors: zCn,
  h3IsPentagon: Rje,
  h3IsResClassIII: MCn,
  h3IsValid: xje,
  h3Line: tEn,
  h3SetToMultiPolygon: Lje,
  h3ToCenterChild: GCn,
  h3ToChildren: kCn,
  h3ToGeo: B$,
  h3ToGeoBoundary: Nje,
  h3ToParent: PCn,
  h3UnidirectionalEdgeIsValid: WCn,
  hexArea: aEn,
  hexRing: $Cn,
  kRing: UCn,
  kRingDistances: HCn,
  numHexagons: AEn,
  pointDist: iEn,
  polyfill: qCn,
  radsToDegs: Fje,
  splitLongToh3Index: v$,
  uncompact: YCn
}, Symbol.toStringTag, { value: "Module" })), fEn = {
  getHexagons: {
    type: "accessor",
    value: (t) => t.hexagons
  }
};
class vce extends r1 {
  initializeState() {
    o1._checkH3Lib();
  }
  updateState({
    props: e,
    changeFlags: n
  }) {
    if (n.dataChanged || n.updateTriggersChanged && n.updateTriggersChanged.getHexagons) {
      const {
        data: r,
        getHexagons: i
      } = e, o = [], {
        iterable: s,
        objectInfo: a
      } = ZI(r);
      for (const A of s) {
        a.index++;
        const l = i(A, a), c = Lje(l, !0);
        for (const u of c)
          o.push(this.getSubLayerRow({
            polygon: u
          }, A, a.index));
      }
      this.setState({
        polygons: o
      });
    }
  }
  indexToBounds() {
    return {
      data: this.state.polygons,
      getPolygon: (e) => e.polygon
    };
  }
}
ae(vce, "layerName", "H3ClusterLayer");
ae(vce, "defaultProps", fEn);
const gEn = 10;
function Pje(t, e) {
  e = e === void 0 ? t[0][0] : e;
  for (const n of t) {
    const r = n[0] - e;
    r > 180 ? n[0] -= 360 : r < -180 && (n[0] += 360);
  }
}
function hEn(t, e, n) {
  const [r, i] = B$(t), o = e.length;
  Pje(e, i);
  const s = e[0] === e[o - 1] ? o - 1 : o;
  for (let a = 0; a < s; a++)
    e[a][0] = Lf(i, e[a][0], n), e[a][1] = Lf(r, e[a][1], n);
}
function dEn(t, e, n) {
  const r = t(e, n), [i, o] = B$(r);
  return [o, i];
}
function eQe(t, e = 1) {
  const n = Nje(t, !0);
  return e !== 1 ? hEn(t, n, e) : Pje(n), n;
}
function pEn(t) {
  const e = new Float64Array(t.length * 2);
  let n = 0;
  for (const r of t)
    e[n++] = r[0], e[n++] = r[1];
  return e;
}
function IEn(t, e) {
  let n;
  return t == null ? n = e : typeof t == "object" ? n = {
    ...t,
    coverage: e
  } : n = {
    getHexagon: t,
    coverage: e
  }, n;
}
const mEn = {
  ...Pf.defaultProps,
  highPrecision: "auto",
  coverage: {
    type: "number",
    min: 0,
    max: 1,
    value: 1
  },
  centerHexagon: null,
  getHexagon: {
    type: "accessor",
    value: (t) => t.hexagon
  },
  extruded: !0
};
class o1 extends mA {
  constructor(...e) {
    super(...e), ae(this, "state", void 0);
  }
  initializeState() {
    o1._checkH3Lib(), this.state = {
      edgeLengthKM: 0,
      resolution: -1
    };
  }
  shouldUpdateState({
    changeFlags: e
  }) {
    return this._shouldUseHighPrecision() ? e.propsOrDataChanged : e.somethingChanged;
  }
  updateState({
    props: e,
    changeFlags: n
  }) {
    if (e.highPrecision !== !0 && (n.dataChanged || n.updateTriggersChanged && n.updateTriggersChanged.getHexagon)) {
      const r = this._calculateH3DataProps();
      this.setState(r);
    }
    this._updateVertices(this.context.viewport);
  }
  _calculateH3DataProps() {
    let e = -1, n = !1, r = !1;
    const {
      iterable: i,
      objectInfo: o
    } = ZI(this.props.data);
    for (const s of i) {
      o.index++;
      const a = this.props.getHexagon(s, o), A = Dje(a);
      if (e < 0) {
        if (e = A, !this.props.highPrecision)
          break;
      } else if (e !== A) {
        r = !0;
        break;
      }
      if (Rje(a)) {
        n = !0;
        break;
      }
    }
    return {
      resolution: e,
      edgeLengthKM: e >= 0 ? Oje(e, "km") : 0,
      hasMultipleRes: r,
      hasPentagon: n
    };
  }
  _shouldUseHighPrecision() {
    if (this.props.highPrecision === "auto") {
      const {
        resolution: e,
        hasPentagon: n,
        hasMultipleRes: r
      } = this.state, {
        viewport: i
      } = this.context;
      return !!i?.resolution || r || n || e >= 0 && e <= 5;
    }
    return this.props.highPrecision;
  }
  _updateVertices(e) {
    if (this._shouldUseHighPrecision())
      return;
    const {
      resolution: n,
      edgeLengthKM: r,
      centerHex: i
    } = this.state;
    if (n < 0)
      return;
    const o = this.props.centerHexagon || Tje(e.latitude, e.longitude, n);
    if (i === o)
      return;
    if (i) {
      const f = Mje(i, o);
      if (f >= 0 && f * r < gEn)
        return;
    }
    const {
      unitsPerMeter: s
    } = e.distanceScales;
    let a = eQe(o);
    const [A, l] = B$(o), [c, u] = e.projectFlat([l, A]);
    a = a.map((f) => {
      const h = e.projectFlat(f);
      return [(h[0] - c) / s[0], (h[1] - u) / s[1]];
    }), this.setState({
      centerHex: o,
      vertices: a
    });
  }
  renderLayers() {
    return this._shouldUseHighPrecision() ? this._renderPolygonLayer() : this._renderColumnLayer();
  }
  _getForwardProps() {
    const {
      elevationScale: e,
      material: n,
      coverage: r,
      extruded: i,
      wireframe: o,
      stroked: s,
      filled: a,
      lineWidthUnits: A,
      lineWidthScale: l,
      lineWidthMinPixels: c,
      lineWidthMaxPixels: u,
      getFillColor: f,
      getElevation: h,
      getLineColor: d,
      getLineWidth: I,
      transitions: m,
      updateTriggers: C
    } = this.props;
    return {
      elevationScale: e,
      extruded: i,
      coverage: r,
      wireframe: o,
      stroked: s,
      filled: a,
      lineWidthUnits: A,
      lineWidthScale: l,
      lineWidthMinPixels: c,
      lineWidthMaxPixels: u,
      material: n,
      getElevation: h,
      getFillColor: f,
      getLineColor: d,
      getLineWidth: I,
      transitions: m,
      updateTriggers: {
        getFillColor: C.getFillColor,
        getElevation: C.getElevation,
        getLineColor: C.getLineColor,
        getLineWidth: C.getLineWidth
      }
    };
  }
  _renderPolygonLayer() {
    const {
      data: e,
      getHexagon: n,
      updateTriggers: r,
      coverage: i
    } = this.props, o = this.getSubLayerClass("hexagon-cell-hifi", Pf), s = this._getForwardProps();
    return s.updateTriggers.getPolygon = IEn(r.getHexagon, i), new o(s, this.getSubLayerProps({
      id: "hexagon-cell-hifi",
      updateTriggers: s.updateTriggers
    }), {
      data: e,
      _normalize: !1,
      _windingOrder: "CCW",
      positionFormat: "XY",
      getPolygon: (a, A) => {
        const l = n(a, A);
        return pEn(eQe(l, i));
      }
    });
  }
  _renderColumnLayer() {
    const {
      data: e,
      getHexagon: n,
      updateTriggers: r
    } = this.props, i = this.getSubLayerClass("hexagon-cell", mM), o = this._getForwardProps();
    return o.updateTriggers.getPosition = r.getHexagon, new i(o, this.getSubLayerProps({
      id: "hexagon-cell",
      flatShading: !0,
      updateTriggers: o.updateTriggers
    }), {
      data: e,
      diskResolution: 6,
      radius: 1,
      vertices: this.state.vertices,
      getPosition: dEn.bind(null, n)
    });
  }
}
ae(o1, "defaultProps", mEn);
ae(o1, "layerName", "H3HexagonLayer");
ae(o1, "_checkH3Lib", () => {
});
const TV = Math.PI / 180, gP = new Float32Array(16), tQe = new Float32Array(12);
function nQe(t, e, n) {
  const r = e[0] * TV, i = e[1] * TV, o = e[2] * TV, s = Math.sin(o), a = Math.sin(r), A = Math.sin(i), l = Math.cos(o), c = Math.cos(r), u = Math.cos(i), f = n[0], h = n[1], d = n[2];
  t[0] = f * u * c, t[1] = f * A * c, t[2] = f * -a, t[3] = h * (-A * l + u * a * s), t[4] = h * (u * l + A * a * s), t[5] = h * c * s, t[6] = d * (A * s + u * a * l), t[7] = d * (-u * s + A * a * l), t[8] = d * c * l;
}
function rQe(t) {
  return t[0] = t[0], t[1] = t[1], t[2] = t[2], t[3] = t[4], t[4] = t[5], t[5] = t[6], t[6] = t[8], t[7] = t[9], t[8] = t[10], t[9] = t[12], t[10] = t[13], t[11] = t[14], t.subarray(0, 12);
}
const kje = {
  size: 12,
  accessor: ["getOrientation", "getScale", "getTranslation", "getTransformMatrix"],
  shaderAttributes: {
    instanceModelMatrix__LOCATION_0: {
      size: 3,
      elementOffset: 0
    },
    instanceModelMatrix__LOCATION_1: {
      size: 3,
      elementOffset: 3
    },
    instanceModelMatrix__LOCATION_2: {
      size: 3,
      elementOffset: 6
    },
    instanceTranslation: {
      size: 3,
      elementOffset: 9
    }
  },
  update(t, {
    startRow: e,
    endRow: n
  }) {
    const {
      data: r,
      getOrientation: i,
      getScale: o,
      getTranslation: s,
      getTransformMatrix: a
    } = this.props, A = Array.isArray(a), l = A && a.length === 16, c = Array.isArray(o), u = Array.isArray(i), f = Array.isArray(s), h = l || !A && !!a(r[0]);
    h ? t.constant = l : t.constant = u && c && f;
    const d = t.value;
    if (t.constant) {
      let I;
      h ? (gP.set(a), I = rQe(gP)) : (I = tQe, nQe(I, i, o), I.set(s, 9)), t.value = new Float32Array(I);
    } else {
      let I = e * t.size;
      const {
        iterable: m,
        objectInfo: C
      } = ZI(r, e, n);
      for (const y of m) {
        C.index++;
        let v;
        if (h)
          gP.set(l ? a : a(y, C)), v = rQe(gP);
        else {
          v = tQe;
          const b = u ? i : i(y, C), Q = c ? o : o(y, C);
          nQe(v, b, Q), v.set(f ? s : s(y, C), 9);
        }
        d[I++] = v[0], d[I++] = v[1], d[I++] = v[2], d[I++] = v[3], d[I++] = v[4], d[I++] = v[5], d[I++] = v[6], d[I++] = v[7], d[I++] = v[8], d[I++] = v[9], d[I++] = v[10], d[I++] = v[11];
      }
    }
  }
};
function Gje(t, e) {
  return e === wn.CARTESIAN || e === wn.METER_OFFSETS || e === wn.DEFAULT && !t.isGeospatial;
}
const CEn = `#version 300 es
#define SHADER_NAME simple-mesh-layer-vs

// Scale the model
uniform float sizeScale;
uniform bool composeModelMatrix;

// Primitive attributes
in vec3 positions;
in vec3 normals;
in vec3 colors;
in vec2 texCoords;

// Instance attributes
in vec3 instancePositions;
in vec3 instancePositions64Low;
in vec4 instanceColors;
in vec3 instancePickingColors;
in mat3 instanceModelMatrix;
in vec3 instanceTranslation;

// Outputs to fragment shader
out vec2 vTexCoord;
out vec3 cameraPosition;
out vec3 normals_commonspace;
out vec4 position_commonspace;
out vec4 vColor;

void main(void) {
  geometry.worldPosition = instancePositions;
  geometry.uv = texCoords;
  geometry.pickingColor = instancePickingColors;

  vTexCoord = texCoords;
  cameraPosition = project_uCameraPosition;
  vColor = vec4(colors * instanceColors.rgb, instanceColors.a);

  vec3 pos = (instanceModelMatrix * positions) * sizeScale + instanceTranslation;

  if (composeModelMatrix) {
    DECKGL_FILTER_SIZE(pos, geometry);
    // using instancePositions as world coordinates
    // when using globe mode, this branch does not re-orient the model to align with the surface of the earth
    // call project_normal before setting position to avoid rotation
    normals_commonspace = project_normal(instanceModelMatrix * normals);
    gl_Position = project_position_to_clipspace(pos + instancePositions, instancePositions64Low, vec3(0.0), position_commonspace);
    geometry.position = position_commonspace;
  }
  else {
    pos = project_size(pos);
    DECKGL_FILTER_SIZE(pos, geometry);
    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, pos, position_commonspace);
    geometry.position = position_commonspace;
    normals_commonspace = project_normal(instanceModelMatrix * normals);
  }

  geometry.normal = normals_commonspace;
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  DECKGL_FILTER_COLOR(vColor, geometry);
}
`, EEn = `#version 300 es
#define SHADER_NAME simple-mesh-layer-fs

precision highp float;

uniform bool hasTexture;
uniform sampler2D sampler;
uniform bool flatShading;
uniform float opacity;

in vec2 vTexCoord;
in vec3 cameraPosition;
in vec3 normals_commonspace;
in vec4 position_commonspace;
in vec4 vColor;

out vec4 fragColor;

void main(void) {
  geometry.uv = vTexCoord;

  vec3 normal;
  if (flatShading) {

// NOTE(Tarek): This is necessary because
// headless.gl reports the extension as
// available but does not support it in
// the shader.
#ifdef DERIVATIVES_AVAILABLE
    normal = normalize(cross(dFdx(position_commonspace.xyz), dFdy(position_commonspace.xyz)));
#else
    normal = vec3(0.0, 0.0, 1.0);
#endif
  } else {
    normal = normals_commonspace;
  }

  vec4 color = hasTexture ? texture(sampler, vTexCoord) : vColor;
  vec3 lightColor = lighting_getLightColor(color.rgb, cameraPosition, position_commonspace.xyz, normal);
  fragColor = vec4(lightColor, color.a * opacity);

  DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
function iQe(t, e) {
  (t.COLOR_0 || t.colors) && e || (t.colors = {
    constant: !0,
    value: new Float32Array([1, 1, 1])
  }), Rr.assert(t.positions || t.POSITION, 'no "postions" or "POSITION" attribute in mesh');
}
function yEn(t, e) {
  if (t.attributes)
    return iQe(t.attributes, e), t instanceof Os ? t : new Os(t);
  if (t.positions || t.POSITION)
    return iQe(t, e), new Os({
      attributes: t
    });
  throw Error("Invalid mesh");
}
const vEn = [0, 0, 0, 255], BEn = {
  mesh: {
    type: "object",
    value: null,
    async: !0
  },
  texture: {
    type: "image",
    value: null,
    async: !0
  },
  sizeScale: {
    type: "number",
    value: 1,
    min: 0
  },
  _useMeshColors: {
    type: "boolean",
    value: !1
  },
  _instanced: !0,
  wireframe: !1,
  material: !0,
  getPosition: {
    type: "accessor",
    value: (t) => t.position
  },
  getColor: {
    type: "accessor",
    value: vEn
  },
  getOrientation: {
    type: "accessor",
    value: [0, 0, 0]
  },
  getScale: {
    type: "accessor",
    value: [1, 1, 1]
  },
  getTranslation: {
    type: "accessor",
    value: [0, 0, 0]
  },
  getTransformMatrix: {
    type: "accessor",
    value: []
  }
};
class YS extends IA {
  constructor(...e) {
    super(...e), ae(this, "state", void 0);
  }
  getShaders() {
    const e = !Fr(this.context.gl), n = {};
    return Zv(this.context.gl, no.GLSL_DERIVATIVES) && (n.DERIVATIVES_AVAILABLE = 1), super.getShaders({
      vs: CEn,
      fs: EEn,
      modules: [qA, o$, jA],
      transpileToGLSL100: e,
      defines: n
    });
  }
  initializeState() {
    this.getAttributeManager().addInstanced({
      instancePositions: {
        transition: !0,
        type: 5130,
        fp64: this.use64bitPositions(),
        size: 3,
        accessor: "getPosition"
      },
      instanceColors: {
        type: 5121,
        transition: !0,
        size: this.props.colorFormat.length,
        normalized: !0,
        accessor: "getColor",
        defaultValue: [0, 0, 0, 255]
      },
      instanceModelMatrix: kje
    }), this.setState({
      emptyTexture: new xo(this.context.gl, {
        data: new Uint8Array(4),
        width: 1,
        height: 1
      })
    });
  }
  updateState(e) {
    super.updateState(e);
    const {
      props: n,
      oldProps: r,
      changeFlags: i
    } = e;
    if (n.mesh !== r.mesh || i.extensionsChanged) {
      var o;
      if ((o = this.state.model) === null || o === void 0 || o.delete(), n.mesh) {
        this.state.model = this.getModel(n.mesh);
        const s = n.mesh.attributes || n.mesh;
        this.setState({
          hasNormals: !!(s.NORMAL || s.normals)
        });
      }
      this.getAttributeManager().invalidateAll();
    }
    n.texture !== r.texture && this.setTexture(n.texture), this.state.model && this.state.model.setDrawMode(this.props.wireframe ? 3 : 4);
  }
  finalizeState(e) {
    super.finalizeState(e), this.state.emptyTexture.delete();
  }
  draw({
    uniforms: e
  }) {
    if (!this.state.model)
      return;
    const {
      viewport: n
    } = this.context, {
      sizeScale: r,
      coordinateSystem: i,
      _instanced: o
    } = this.props;
    this.state.model.setUniforms(e).setUniforms({
      sizeScale: r,
      composeModelMatrix: !o || Gje(n, i),
      flatShading: !this.state.hasNormals
    }).draw();
  }
  getModel(e) {
    const n = new Ta(this.context.gl, {
      ...this.getShaders(),
      id: this.props.id,
      geometry: yEn(e, this.props._useMeshColors),
      isInstanced: !0
    }), {
      texture: r
    } = this.props, {
      emptyTexture: i
    } = this.state;
    return n.setUniforms({
      sampler: r || i,
      hasTexture: !!r
    }), n;
  }
  setTexture(e) {
    const {
      emptyTexture: n,
      model: r
    } = this.state;
    r && r.setUniforms({
      sampler: e || n,
      hasTexture: !!e
    });
  }
}
ae(YS, "defaultProps", BEn);
ae(YS, "layerName", "SimpleMeshLayer");
class Y_ {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      id: n
    } = e;
    this.id = n || PA(this.constructor.name), this.display = !0, this.position = new ct(), this.rotation = new ct(), this.scale = new ct(1, 1, 1), this.matrix = new pn(), this.userData = {}, this.props = {}, this._setScenegraphNodeProps(e);
  }
  delete() {
  }
  setProps(e) {
    return this._setScenegraphNodeProps(e), this;
  }
  toString() {
    return "{type: ScenegraphNode, id: ".concat(this.id, ")}");
  }
  getBounds() {
    return null;
  }
  setPosition(e) {
    return dn(e.length === 3, "setPosition requires vector argument"), this.position = e, this;
  }
  setRotation(e) {
    return dn(e.length === 3, "setRotation requires vector argument"), this.rotation = e, this;
  }
  setScale(e) {
    return dn(e.length === 3, "setScale requires vector argument"), this.scale = e, this;
  }
  setMatrix(e) {
    (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? this.matrix.copy(e) : this.matrix = e;
  }
  setMatrixComponents(e) {
    let {
      position: n,
      rotation: r,
      scale: i,
      update: o = !0
    } = e;
    return n && this.setPosition(n), r && this.setRotation(r), i && this.setScale(i), o && this.updateMatrix(), this;
  }
  updateMatrix() {
    const e = this.position, n = this.rotation, r = this.scale;
    return this.matrix.identity(), this.matrix.translate(e), this.matrix.rotateXYZ(n), this.matrix.scale(r), this;
  }
  update() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      position: n,
      rotation: r,
      scale: i
    } = e;
    return n && this.setPosition(n), r && this.setRotation(r), i && this.setScale(i), this.updateMatrix(), this;
  }
  getCoordinateUniforms(e, n) {
    dn(e), n = n || this.matrix;
    const r = new pn(e).multiplyRight(n), i = r.invert(), o = i.transpose();
    return {
      viewMatrix: e,
      modelMatrix: n,
      objectMatrix: n,
      worldMatrix: r,
      worldInverseMatrix: i,
      worldInverseTransposeMatrix: o
    };
  }
  _setScenegraphNodeProps(e) {
    "display" in e && (this.display = e.display), "position" in e && this.setPosition(e.position), "rotation" in e && this.setRotation(e.rotation), "scale" in e && this.setScale(e.scale), "matrix" in e && this.setMatrix(e.matrix), Object.assign(this.props, e);
  }
}
class _D extends Y_ {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e = Array.isArray(e) ? {
      children: e
    } : e;
    const {
      children: n = []
    } = e;
    On.assert(n.every((r) => r instanceof Y_), "every child must an instance of ScenegraphNode"), super(e), this.children = n;
  }
  add() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    for (const i of n)
      Array.isArray(i) ? this.add(...i) : this.children.push(i);
    return this;
  }
  remove(e) {
    const n = this.children, r = n.indexOf(e);
    return r > -1 && n.splice(r, 1), this;
  }
  removeAll() {
    return this.children = [], this;
  }
  delete() {
    this.children.forEach((e) => e.delete()), this.removeAll(), super.delete();
  }
  getBounds() {
    const e = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]];
    return this.traverse((n, r) => {
      let {
        worldMatrix: i
      } = r;
      const o = n.getBounds();
      if (!o)
        return;
      const [s, a] = o, A = new ct(s).add(a).divide([2, 2, 2]);
      i.transformAsPoint(A, A);
      const l = new ct(a).subtract(s).divide([2, 2, 2]);
      i.transformAsVector(l, l);
      for (let c = 0; c < 8; c++) {
        const u = new ct(c & 1 ? -1 : 1, c & 2 ? -1 : 1, c & 4 ? -1 : 1).multiply(l).add(A);
        for (let f = 0; f < 3; f++)
          e[0][f] = Math.min(e[0][f], u[f]), e[1][f] = Math.max(e[1][f], u[f]);
      }
    }), Number.isFinite(e[0][0]) ? e : null;
  }
  traverse(e) {
    let {
      worldMatrix: n = new pn()
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = new pn(n).multiplyRight(this.matrix);
    for (const i of this.children)
      i instanceof _D ? i.traverse(e, {
        worldMatrix: r
      }) : e(i, {
        worldMatrix: r
      });
  }
}
const bEn = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, _En = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
};
function oQe(t) {
  if (!t._animation) {
    const e = _En[t.componentType], n = bEn[t.type], r = n * t.count, {
      buffer: i,
      byteOffset: o
    } = t.bufferView.data, s = new e(i, o + (t.byteOffset || 0), r);
    if (n === 1)
      t._animation = Array.from(s);
    else {
      const a = [];
      for (let A = 0; A < s.length; A += n)
        a.push(Array.from(s.slice(A, A + n)));
      t._animation = a;
    }
  }
  return t._animation;
}
const SEn = new pn();
function QEn(t, e) {
  if (e.matrix.identity(), t.translation && e.matrix.translate(t.translation), t.rotation) {
    const n = SEn.fromQuaternion(t.rotation);
    e.matrix.multiplyRight(n);
  }
  t.scale && e.matrix.scale(t.scale);
}
const NV = new VC();
function wEn(t, e, n, r, i) {
  if (e === "rotation") {
    NV.slerp({
      start: n,
      target: r,
      ratio: i
    });
    for (let o = 0; o < NV.length; o++)
      t[e][o] = NV[o];
  } else
    for (let o = 0; o < n.length; o++)
      t[e][o] = i * r[o] + (1 - i) * n[o];
}
function xEn(t, e, n) {
  let {
    p0: r,
    outTangent0: i,
    inTangent1: o,
    p1: s,
    tDiff: a,
    ratio: A
  } = n;
  for (let l = 0; l < t[e].length; l++) {
    const c = i[l] * a, u = o[l] * a;
    t[e][l] = (2 * Math.pow(A, 3) - 3 * Math.pow(A, 2) + 1) * r[l] + (Math.pow(A, 3) - 2 * Math.pow(A, 2) + A) * c + (-2 * Math.pow(A, 3) + 3 * Math.pow(A, 2)) * s[l] + (Math.pow(A, 3) - Math.pow(A, 2)) * u;
  }
}
function REn(t, e, n) {
  for (let r = 0; r < n.length; r++)
    t[e][r] = n[r];
}
function DEn(t, e, n, r) {
  let {
    input: i,
    interpolation: o,
    output: s
  } = e;
  const a = i[i.length - 1], A = t % a, l = i.findIndex((h) => h >= A), c = Math.max(0, l - 1);
  if (!Array.isArray(n[r]))
    switch (r) {
      case "translation":
        n[r] = [0, 0, 0];
        break;
      case "rotation":
        n[r] = [0, 0, 0, 1];
        break;
      case "scale":
        n[r] = [1, 1, 1];
        break;
      default:
        On.warn("Bad animation path ".concat(r))();
    }
  dn(n[r].length === s[c].length);
  const u = i[c], f = i[l];
  switch (o) {
    case "STEP":
      REn(n, r, s[c]);
      break;
    case "LINEAR":
      if (f > u) {
        const h = (A - u) / (f - u);
        wEn(n, r, s[c], s[l], h);
      }
      break;
    case "CUBICSPLINE":
      if (f > u) {
        const h = (A - u) / (f - u), d = f - u, I = s[3 * c + 1], m = s[3 * c + 2], C = s[3 * l + 0], y = s[3 * l + 1];
        xEn(n, r, {
          p0: I,
          outTangent0: m,
          inTangent1: C,
          p1: y,
          tDiff: d,
          ratio: h
        });
      }
      break;
    default:
      On.warn("Interpolation ".concat(o, " not supported"))();
      break;
  }
}
class TEn {
  constructor(e) {
    this.startTime = 0, this.playing = !0, this.speed = 1, this.channels = [], Object.assign(this, e);
  }
  animate(e) {
    if (!this.playing)
      return;
    const r = (e / 1e3 - this.startTime) * this.speed;
    this.channels.forEach((i) => {
      let {
        sampler: o,
        target: s,
        path: a
      } = i;
      DEn(r, o, s, a), QEn(s, s._node);
    });
  }
}
class NEn {
  constructor(e) {
    this.animations = e.animations.map((n, r) => {
      const i = n.name || "Animation-".concat(r), o = n.samplers.map((a) => {
        let {
          input: A,
          interpolation: l = "LINEAR",
          output: c
        } = a;
        return {
          input: oQe(e.accessors[A]),
          interpolation: l,
          output: oQe(e.accessors[c])
        };
      }), s = n.channels.map((a) => {
        let {
          sampler: A,
          target: l
        } = a;
        return {
          sampler: o[A],
          target: e.nodes[l.node],
          path: l.path
        };
      });
      return new TEn({
        name: i,
        channels: s
      });
    });
  }
  animate(e) {
    this.setTime(e);
  }
  setTime(e) {
    this.animations.forEach((n) => n.animate(e));
  }
  getAnimations() {
    return this.animations;
  }
}
class LEn extends Y_ {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(n), this.onBeforeRender = null, this.AfterRender = null, e instanceof Ta ? (this.model = e, this._setModelNodeProps(n)) : this.model = new Ta(e, n), this.bounds = null, this.managedResources = n.managedResources || [];
  }
  setProps(e) {
    return super.setProps(e), this._setModelNodeProps(e), this;
  }
  getBounds() {
    return this.bounds;
  }
  delete() {
    this.model && (this.model.delete(), this.model = null), this.managedResources.forEach((e) => e.delete()), this.managedResources = [];
  }
  draw() {
    return this.model.draw(...arguments);
  }
  setUniforms() {
    return this.model.setUniforms(...arguments), this;
  }
  setAttributes() {
    return this.model.setAttributes(...arguments), this;
  }
  updateModuleSettings() {
    return this.model.updateModuleSettings(...arguments), this;
  }
  _setModelNodeProps(e) {
    this.model.setProps(e);
  }
}
class Uje {
  constructor(e, n) {
    let {
      attributes: r,
      material: i,
      pbrDebug: o,
      imageBasedLightingEnvironment: s,
      lights: a,
      useTangents: A
    } = n;
    this.gl = e, this.defines = {
      MANUAL_SRGB: 1,
      SRGB_FAST_APPROXIMATION: 1
    }, Zv(e, no.GLSL_TEXTURE_LOD) && (this.defines.USE_TEX_LOD = 1), this.uniforms = {
      u_Camera: [0, 0, 0],
      u_MetallicRoughnessValues: [1, 1]
    }, this.parameters = {}, this.generatedTextures = [], s && (this.uniforms.u_DiffuseEnvSampler = s.getDiffuseEnvSampler(), this.uniforms.u_SpecularEnvSampler = s.getSpecularEnvSampler(), this.uniforms.u_brdfLUT = s.getBrdfTexture(), this.uniforms.u_ScaleIBLAmbient = [1, 1]), o && (this.uniforms.u_ScaleDiffBaseMR = [0, 0, 0, 0], this.uniforms.u_ScaleFGDSpec = [0, 0, 0, 0]), this.defineIfPresent(r.NORMAL, "HAS_NORMALS"), this.defineIfPresent(r.TANGENT && A, "HAS_TANGENTS"), this.defineIfPresent(r.TEXCOORD_0, "HAS_UV"), this.defineIfPresent(s, "USE_IBL"), this.defineIfPresent(a, "USE_LIGHTS"), this.defineIfPresent(o, "PBR_DEBUG"), i && this.parseMaterial(i);
  }
  defineIfPresent(e, n) {
    e && (this.defines[n] = 1);
  }
  parseTexture(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    const i = e.texture && e.texture.sampler && e.texture.sampler.parameters || {}, o = e.texture.source.image;
    let s, a = {};
    o.compressed ? (s = o, a = {
      [this.gl.TEXTURE_MIN_FILTER]: o.data.length > 1 ? this.gl.LINEAR_MIPMAP_NEAREST : this.gl.LINEAR
    }) : s = {
      data: o
    };
    const A = new xo(this.gl, {
      id: e.name || e.id,
      parameters: {
        ...i,
        ...a
      },
      pixelStore: {
        [this.gl.UNPACK_FLIP_Y_WEBGL]: !1
      },
      ...s
    });
    this.uniforms[n] = A, this.defineIfPresent(r, r), this.generatedTextures.push(A);
  }
  parsePbrMetallicRoughness(e) {
    e.baseColorTexture && this.parseTexture(e.baseColorTexture, "u_BaseColorSampler", "HAS_BASECOLORMAP"), this.uniforms.u_BaseColorFactor = e.baseColorFactor || [1, 1, 1, 1], e.metallicRoughnessTexture && this.parseTexture(e.metallicRoughnessTexture, "u_MetallicRoughnessSampler", "HAS_METALROUGHNESSMAP");
    const {
      metallicFactor: n = 1,
      roughnessFactor: r = 1
    } = e;
    this.uniforms.u_MetallicRoughnessValues = [n, r];
  }
  parseMaterial(e) {
    if (this.uniforms.pbr_uUnlit = !!e.unlit, e.pbrMetallicRoughness && this.parsePbrMetallicRoughness(e.pbrMetallicRoughness), e.normalTexture) {
      this.parseTexture(e.normalTexture, "u_NormalSampler", "HAS_NORMALMAP");
      const {
        scale: n = 1
      } = e.normalTexture;
      this.uniforms.u_NormalScale = n;
    }
    if (e.occlusionTexture) {
      this.parseTexture(e.occlusionTexture, "u_OcclusionSampler", "HAS_OCCLUSIONMAP");
      const {
        strength: n = 1
      } = e.occlusionTexture;
      this.uniforms.u_OcclusionStrength = n;
    }
    if (e.emissiveTexture && (this.parseTexture(e.emissiveTexture, "u_EmissiveSampler", "HAS_EMISSIVEMAP"), this.uniforms.u_EmissiveFactor = e.emissiveFactor || [0, 0, 0]), e.alphaMode === "MASK") {
      const {
        alphaCutoff: n = 0.5
      } = e;
      this.defines.ALPHA_CUTOFF = 1, this.uniforms.u_AlphaCutoff = n;
    } else
      e.alphaMode === "BLEND" && (On.warn("BLEND alphaMode might not work well because it requires mesh sorting")(), Object.assign(this.parameters, {
        blend: !0,
        blendEquation: this.gl.FUNC_ADD,
        blendFunc: [this.gl.SRC_ALPHA, this.gl.ONE_MINUS_SRC_ALPHA, this.gl.ONE, this.gl.ONE_MINUS_SRC_ALPHA]
      }));
  }
  delete() {
    this.generatedTextures.forEach((e) => e.delete());
  }
}
const MEn = `
#if (__VERSION__ < 300)
  #define _attr attribute
#else
  #define _attr in
#endif

  _attr vec4 POSITION;

  #ifdef HAS_NORMALS
    _attr vec4 NORMAL;
  #endif

  #ifdef HAS_TANGENTS
    _attr vec4 TANGENT;
  #endif

  #ifdef HAS_UV
    _attr vec2 TEXCOORD_0;
  #endif

  void main(void) {
    vec4 _NORMAL = vec4(0.);
    vec4 _TANGENT = vec4(0.);
    vec2 _TEXCOORD_0 = vec2(0.);

    #ifdef HAS_NORMALS
      _NORMAL = NORMAL;
    #endif

    #ifdef HAS_TANGENTS
      _TANGENT = TANGENT;
    #endif

    #ifdef HAS_UV
      _TEXCOORD_0 = TEXCOORD_0;
    #endif

    pbr_setPositionNormalTangentUV(POSITION, _NORMAL, _TANGENT, _TEXCOORD_0);
    gl_Position = u_MVPMatrix * POSITION;
  }
`, OEn = `
#if (__VERSION__ < 300)
  #define fragmentColor gl_FragColor
#else
  out vec4 fragmentColor;
#endif

  void main(void) {
    fragmentColor = pbr_filterColor(vec4(0));
  }
`;
function sQe(t, e) {
  return Fr(t) ? `#version 300 es
`.concat(e) : e;
}
function FEn(t, e) {
  const {
    id: n,
    drawMode: r,
    vertexCount: i,
    attributes: o,
    modelOptions: s
  } = e, a = new Uje(t, e);
  On.info(4, "createGLTFModel defines: ", a.defines)();
  const A = [];
  A.push(...a.generatedTextures), A.push(...Object.values(o).map((c) => c.buffer));
  const l = new LEn(t, {
    id: n,
    drawMode: r,
    vertexCount: i,
    modules: [s$],
    parameters: a.parameters,
    vs: sQe(t, MEn),
    fs: sQe(t, OEn),
    managedResources: A,
    ...s,
    defines: {
      ...a.defines,
      ...s.defines
    }
  });
  return l.setProps({
    attributes: o
  }), l.setUniforms(a.uniforms), l;
}
const PEn = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, kEn = {
  modelOptions: {},
  pbrDebug: !1,
  imageBasedLightingEnvironment: null,
  lights: !0,
  useTangents: !1
};
class GEn {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.gl = e, this.options = Object.assign({}, kEn, n);
  }
  instantiate(e) {
    return this.gltf = e, (e.scenes || []).map((r) => this.createScene(r));
  }
  createAnimator() {
    return Array.isArray(this.gltf.animations) ? new NEn(this.gltf) : null;
  }
  createScene(e) {
    const r = (e.nodes || []).map((o) => this.createNode(o));
    return new _D({
      id: e.name || e.id,
      children: r
    });
  }
  createNode(e) {
    if (!e._node) {
      const r = (e.children || []).map((o) => this.createNode(o));
      e.mesh && r.push(this.createMesh(e.mesh));
      const i = new _D({
        id: e.name || e.id,
        children: r
      });
      if (e.matrix)
        i.setMatrix(e.matrix);
      else {
        if (i.matrix.identity(), e.translation && i.matrix.translate(e.translation), e.rotation) {
          const o = new pn().fromQuaternion(e.rotation);
          i.matrix.multiplyRight(o);
        }
        e.scale && i.matrix.scale(e.scale);
      }
      e._node = i;
    }
    return e._node;
  }
  createMesh(e) {
    if (!e._mesh) {
      const r = (e.primitives || []).map((o, s) => this.createPrimitive(o, s, e)), i = new _D({
        id: e.name || e.id,
        children: r
      });
      e._mesh = i;
    }
    return e._mesh;
  }
  getVertexCount(e) {
    On.warn("getVertexCount() not found")();
  }
  createPrimitive(e, n, r) {
    const i = FEn(this.gl, Object.assign({
      id: e.name || "".concat(r.name || r.id, "-primitive-").concat(n),
      drawMode: e.mode || 4,
      vertexCount: e.indices ? e.indices.count : this.getVertexCount(e.attributes),
      attributes: this.createAttributes(e.attributes, e.indices),
      material: e.material
    }, this.options));
    return i.bounds = [e.attributes.POSITION.min, e.attributes.POSITION.max], i;
  }
  createAttributes(e, n) {
    const r = {};
    return Object.keys(e).forEach((i) => {
      r[i] = this.createAccessor(e[i], this.createBuffer(e[i], this.gl.ARRAY_BUFFER));
    }), n && (r.indices = this.createAccessor(n, this.createBuffer(n, this.gl.ELEMENT_ARRAY_BUFFER))), On.info(4, "glTF Attributes", {
      attributes: e,
      indices: n,
      generated: r
    })(), r;
  }
  createBuffer(e, n) {
    e.bufferView || (e.bufferView = {});
    const {
      bufferView: r
    } = e;
    return r.lumaBuffers || (r.lumaBuffers = {}), r.lumaBuffers[n] || (r.lumaBuffers[n] = new ro(this.gl, {
      id: "from-".concat(r.id),
      data: r.data || e.value,
      target: n
    })), r.lumaBuffers[n];
  }
  createAccessor(e, n) {
    return new yu({
      buffer: n,
      offset: e.byteOffset || 0,
      stride: e.bufferView.byteStride || 0,
      type: e.componentType,
      size: PEn[e.type]
    });
  }
  createSampler(e) {
    return e;
  }
  needsPOT() {
    return !1;
  }
}
function UEn(t, e, n) {
  const r = new GEn(t, n), i = r.instantiate(e), o = r.createAnimator();
  return {
    scenes: i,
    animator: o
  };
}
const HEn = "3.2.10", $En = "3.2.10", Hje = "3.2.10", qEn = "https://unpkg.com/@loaders.gl/textures@".concat(Hje, "/dist/libs/basis_encoder.wasm"), jEn = "https://unpkg.com/@loaders.gl/textures@".concat(Hje, "/dist/libs/basis_encoder.js");
let LV;
async function aQe(t) {
  const e = t.modules || {};
  return e.basis ? e.basis : (LV = LV || YEn(t), await LV);
}
async function YEn(t) {
  let e = null, n = null;
  return [e, n] = await Promise.all([await Qv("basis_transcoder.js", "textures", t), await Qv("basis_transcoder.wasm", "textures", t)]), e = e || globalThis.BASIS, await zEn(e, n);
}
function zEn(t, e) {
  const n = {};
  return e && (n.wasmBinary = e), new Promise((r) => {
    t(n).then((i) => {
      const {
        BasisFile: o,
        initializeBasis: s
      } = i;
      s(), r({
        BasisFile: o
      });
    });
  });
}
let MV;
async function AQe(t) {
  const e = t.modules || {};
  return e.basisEncoder ? e.basisEncoder : (MV = MV || VEn(t), await MV);
}
async function VEn(t) {
  let e = null, n = null;
  return [e, n] = await Promise.all([await Qv(jEn, "textures", t), await Qv(qEn, "textures", t)]), e = e || globalThis.BASIS, await JEn(e, n);
}
function JEn(t, e) {
  const n = {};
  return e && (n.wasmBinary = e), new Promise((r) => {
    t(n).then((i) => {
      const {
        BasisFile: o,
        KTX2File: s,
        initializeBasis: a,
        BasisEncoder: A
      } = i;
      a(), r({
        BasisFile: o,
        KTX2File: s,
        BasisEncoder: A
      });
    });
  });
}
const lb = {
  COMPRESSED_RGB_S3TC_DXT1_EXT: 33776,
  COMPRESSED_RGBA_S3TC_DXT1_EXT: 33777,
  COMPRESSED_RGBA_S3TC_DXT3_EXT: 33778,
  COMPRESSED_RGBA_S3TC_DXT5_EXT: 33779,
  COMPRESSED_R11_EAC: 37488,
  COMPRESSED_SIGNED_R11_EAC: 37489,
  COMPRESSED_RG11_EAC: 37490,
  COMPRESSED_SIGNED_RG11_EAC: 37491,
  COMPRESSED_RGB8_ETC2: 37492,
  COMPRESSED_RGBA8_ETC2_EAC: 37493,
  COMPRESSED_SRGB8_ETC2: 37494,
  COMPRESSED_SRGB8_ALPHA8_ETC2_EAC: 37495,
  COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2: 37496,
  COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2: 37497,
  COMPRESSED_RGB_PVRTC_4BPPV1_IMG: 35840,
  COMPRESSED_RGBA_PVRTC_4BPPV1_IMG: 35842,
  COMPRESSED_RGB_PVRTC_2BPPV1_IMG: 35841,
  COMPRESSED_RGBA_PVRTC_2BPPV1_IMG: 35843,
  COMPRESSED_RGB_ETC1_WEBGL: 36196,
  COMPRESSED_RGB_ATC_WEBGL: 35986,
  COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL: 35987,
  COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL: 34798,
  COMPRESSED_RGBA_ASTC_4X4_KHR: 37808,
  COMPRESSED_RGBA_ASTC_5X4_KHR: 37809,
  COMPRESSED_RGBA_ASTC_5X5_KHR: 37810,
  COMPRESSED_RGBA_ASTC_6X5_KHR: 37811,
  COMPRESSED_RGBA_ASTC_6X6_KHR: 37812,
  COMPRESSED_RGBA_ASTC_8X5_KHR: 37813,
  COMPRESSED_RGBA_ASTC_8X6_KHR: 37814,
  COMPRESSED_RGBA_ASTC_8X8_KHR: 37815,
  COMPRESSED_RGBA_ASTC_10X5_KHR: 37816,
  COMPRESSED_RGBA_ASTC_10X6_KHR: 37817,
  COMPRESSED_RGBA_ASTC_10X8_KHR: 37818,
  COMPRESSED_RGBA_ASTC_10X10_KHR: 37819,
  COMPRESSED_RGBA_ASTC_12X10_KHR: 37820,
  COMPRESSED_RGBA_ASTC_12X12_KHR: 37821,
  COMPRESSED_SRGB8_ALPHA8_ASTC_4X4_KHR: 37840,
  COMPRESSED_SRGB8_ALPHA8_ASTC_5X4_KHR: 37841,
  COMPRESSED_SRGB8_ALPHA8_ASTC_5X5_KHR: 37842,
  COMPRESSED_SRGB8_ALPHA8_ASTC_6X5_KHR: 37843,
  COMPRESSED_SRGB8_ALPHA8_ASTC_6X6_KHR: 37844,
  COMPRESSED_SRGB8_ALPHA8_ASTC_8X5_KHR: 37845,
  COMPRESSED_SRGB8_ALPHA8_ASTC_8X6_KHR: 37846,
  COMPRESSED_SRGB8_ALPHA8_ASTC_8X8_KHR: 37847,
  COMPRESSED_SRGB8_ALPHA8_ASTC_10X5_KHR: 37848,
  COMPRESSED_SRGB8_ALPHA8_ASTC_10X6_KHR: 37849,
  COMPRESSED_SRGB8_ALPHA8_ASTC_10X8_KHR: 37850,
  COMPRESSED_SRGB8_ALPHA8_ASTC_10X10_KHR: 37851,
  COMPRESSED_SRGB8_ALPHA8_ASTC_12X10_KHR: 37852,
  COMPRESSED_SRGB8_ALPHA8_ASTC_12X12_KHR: 37853,
  COMPRESSED_RED_RGTC1_EXT: 36283,
  COMPRESSED_SIGNED_RED_RGTC1_EXT: 36284,
  COMPRESSED_RED_GREEN_RGTC2_EXT: 36285,
  COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT: 36286,
  COMPRESSED_SRGB_S3TC_DXT1_EXT: 35916,
  COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT: 35917,
  COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT: 35918,
  COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT: 35919
}, KEn = ["", "WEBKIT_", "MOZ_"], lQe = {
  WEBGL_compressed_texture_s3tc: "dxt",
  WEBGL_compressed_texture_s3tc_srgb: "dxt-srgb",
  WEBGL_compressed_texture_etc1: "etc1",
  WEBGL_compressed_texture_etc: "etc2",
  WEBGL_compressed_texture_pvrtc: "pvrtc",
  WEBGL_compressed_texture_atc: "atc",
  WEBGL_compressed_texture_astc: "astc",
  EXT_texture_compression_rgtc: "rgtc"
};
let hP = null;
function WEn(t) {
  if (!hP) {
    t = t || XEn() || void 0, hP = /* @__PURE__ */ new Set();
    for (const e of KEn)
      for (const n in lQe)
        if (t && t.getExtension("".concat(e).concat(n))) {
          const r = lQe[n];
          hP.add(r);
        }
  }
  return hP;
}
function XEn() {
  try {
    return document.createElement("canvas").getContext("webgl");
  } catch {
    return null;
  }
}
var cQe, uQe, fQe, gQe, hQe, dQe, pQe, IQe;
(function(t) {
  t[t.NONE = 0] = "NONE", t[t.BASISLZ = 1] = "BASISLZ", t[t.ZSTD = 2] = "ZSTD", t[t.ZLIB = 3] = "ZLIB";
})(cQe || (cQe = {})), function(t) {
  t[t.BASICFORMAT = 0] = "BASICFORMAT";
}(uQe || (uQe = {})), function(t) {
  t[t.UNSPECIFIED = 0] = "UNSPECIFIED", t[t.ETC1S = 163] = "ETC1S", t[t.UASTC = 166] = "UASTC";
}(fQe || (fQe = {})), function(t) {
  t[t.UNSPECIFIED = 0] = "UNSPECIFIED", t[t.SRGB = 1] = "SRGB";
}(gQe || (gQe = {})), function(t) {
  t[t.UNSPECIFIED = 0] = "UNSPECIFIED", t[t.LINEAR = 1] = "LINEAR", t[t.SRGB = 2] = "SRGB", t[t.ITU = 3] = "ITU", t[t.NTSC = 4] = "NTSC", t[t.SLOG = 5] = "SLOG", t[t.SLOG2 = 6] = "SLOG2";
}(hQe || (hQe = {})), function(t) {
  t[t.ALPHA_STRAIGHT = 0] = "ALPHA_STRAIGHT", t[t.ALPHA_PREMULTIPLIED = 1] = "ALPHA_PREMULTIPLIED";
}(dQe || (dQe = {})), function(t) {
  t[t.RGB = 0] = "RGB", t[t.RRR = 3] = "RRR", t[t.GGG = 4] = "GGG", t[t.AAA = 15] = "AAA";
}(pQe || (pQe = {})), function(t) {
  t[t.RGB = 0] = "RGB", t[t.RGBA = 3] = "RGBA", t[t.RRR = 4] = "RRR", t[t.RRRG = 5] = "RRRG";
}(IQe || (IQe = {}));
const lf = [171, 75, 84, 88, 32, 50, 48, 187, 13, 10, 26, 10];
function ZEn(t) {
  const e = new Uint8Array(t);
  return !(e.byteLength < lf.length || e[0] !== lf[0] || e[1] !== lf[1] || e[2] !== lf[2] || e[3] !== lf[3] || e[4] !== lf[4] || e[5] !== lf[5] || e[6] !== lf[6] || e[7] !== lf[7] || e[8] !== lf[8] || e[9] !== lf[9] || e[10] !== lf[10] || e[11] !== lf[11]);
}
const eyn = {
  etc1: {
    basisFormat: 0,
    compressed: !0,
    format: lb.COMPRESSED_RGB_ETC1_WEBGL
  },
  etc2: {
    basisFormat: 1,
    compressed: !0
  },
  bc1: {
    basisFormat: 2,
    compressed: !0,
    format: lb.COMPRESSED_RGB_S3TC_DXT1_EXT
  },
  bc3: {
    basisFormat: 3,
    compressed: !0,
    format: lb.COMPRESSED_RGBA_S3TC_DXT5_EXT
  },
  bc4: {
    basisFormat: 4,
    compressed: !0
  },
  bc5: {
    basisFormat: 5,
    compressed: !0
  },
  "bc7-m6-opaque-only": {
    basisFormat: 6,
    compressed: !0
  },
  "bc7-m5": {
    basisFormat: 7,
    compressed: !0
  },
  "pvrtc1-4-rgb": {
    basisFormat: 8,
    compressed: !0,
    format: lb.COMPRESSED_RGB_PVRTC_4BPPV1_IMG
  },
  "pvrtc1-4-rgba": {
    basisFormat: 9,
    compressed: !0,
    format: lb.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG
  },
  "astc-4x4": {
    basisFormat: 10,
    compressed: !0,
    format: lb.COMPRESSED_RGBA_ASTC_4X4_KHR
  },
  "atc-rgb": {
    basisFormat: 11,
    compressed: !0
  },
  "atc-rgba-interpolated-alpha": {
    basisFormat: 12,
    compressed: !0
  },
  rgba32: {
    basisFormat: 13,
    compressed: !1
  },
  rgb565: {
    basisFormat: 14,
    compressed: !1
  },
  bgr565: {
    basisFormat: 15,
    compressed: !1
  },
  rgba4444: {
    basisFormat: 16,
    compressed: !1
  }
};
async function tyn(t, e) {
  if (e.basis.containerFormat === "auto") {
    if (ZEn(t)) {
      const r = await AQe(e);
      return mQe(r.KTX2File, t, e);
    }
    const {
      BasisFile: n
    } = await aQe(e);
    return OV(n, t, e);
  }
  switch (e.basis.module) {
    case "encoder":
      const n = await AQe(e);
      switch (e.basis.containerFormat) {
        case "ktx2":
          return mQe(n.KTX2File, t, e);
        case "basis":
        default:
          return OV(n.BasisFile, t, e);
      }
    case "transcoder":
    default:
      const {
        BasisFile: r
      } = await aQe(e);
      return OV(r, t, e);
  }
}
function OV(t, e, n) {
  const r = new t(new Uint8Array(e));
  try {
    if (!r.startTranscoding())
      throw new Error("Failed to start basis transcoding");
    const i = r.getNumImages(), o = [];
    for (let s = 0; s < i; s++) {
      const a = r.getNumLevels(s), A = [];
      for (let l = 0; l < a; l++)
        A.push(nyn(r, s, l, n));
      o.push(A);
    }
    return o;
  } finally {
    r.close(), r.delete();
  }
}
function nyn(t, e, n, r) {
  const i = t.getImageWidth(e, n), o = t.getImageHeight(e, n), s = t.getHasAlpha(), {
    compressed: a,
    format: A,
    basisFormat: l
  } = $je(r, s), c = t.getImageTranscodedSizeInBytes(e, n, l), u = new Uint8Array(c);
  if (!t.transcodeImage(u, e, n, l, 0, 0))
    throw new Error("failed to start Basis transcoding");
  return {
    width: i,
    height: o,
    data: u,
    compressed: a,
    format: A,
    hasAlpha: s
  };
}
function mQe(t, e, n) {
  const r = new t(new Uint8Array(e));
  try {
    if (!r.startTranscoding())
      throw new Error("failed to start KTX2 transcoding");
    const i = r.getLevels(), o = [];
    for (let s = 0; s < i; s++) {
      o.push(ryn(r, s, n));
      break;
    }
    return [o];
  } finally {
    r.close(), r.delete();
  }
}
function ryn(t, e, n) {
  const {
    alphaFlag: r,
    height: i,
    width: o
  } = t.getImageLevelInfo(e, 0, 0), {
    compressed: s,
    format: a,
    basisFormat: A
  } = $je(n, r), l = t.getImageTranscodedSizeInBytes(e, 0, 0, A), c = new Uint8Array(l);
  if (!t.transcodeImage(c, e, 0, 0, A, 0, -1, -1))
    throw new Error("Failed to transcode KTX2 image");
  return {
    width: o,
    height: i,
    data: c,
    compressed: s,
    hasAlpha: r,
    format: a
  };
}
function $je(t, e) {
  let n = t && t.basis && t.basis.format;
  return n === "auto" && (n = qje()), typeof n == "object" && (n = e ? n.alpha : n.noAlpha), n = n.toLowerCase(), eyn[n];
}
function qje() {
  const t = WEn();
  return t.has("astc") ? "astc-4x4" : t.has("dxt") ? {
    alpha: "bc3",
    noAlpha: "bc1"
  } : t.has("pvrtc") ? {
    alpha: "pvrtc1-4-rgba",
    noAlpha: "pvrtc1-4-rgb"
  } : t.has("etc1") ? "etc1" : t.has("etc2") ? "etc2" : "rgb565";
}
const iyn = {
  name: "Basis",
  id: "basis",
  module: "textures",
  version: $En,
  worker: !0,
  extensions: ["basis", "ktx2"],
  mimeTypes: ["application/octet-stream", "image/ktx2"],
  tests: ["sB"],
  binary: !0,
  options: {
    basis: {
      format: "auto",
      libraryPath: "libs/",
      containerFormat: "auto",
      module: "transcoder"
    }
  }
}, oyn = {
  ...iyn,
  parse: tyn
};
function wf(t, e) {
  if (!t)
    throw new Error(e || "assert failed: gltf");
}
function jje(t, e) {
  if (t.startsWith("data:") || t.startsWith("http:") || t.startsWith("https:"))
    return t;
  const r = e.baseUri || e.uri;
  if (!r)
    throw new Error("'baseUri' must be provided to resolve relative url ".concat(t));
  return r.substr(0, r.lastIndexOf("/") + 1) + t;
}
function syn(t, e, n) {
  const r = t.bufferViews[n];
  wf(r);
  const i = r.buffer, o = e[i];
  wf(o);
  const s = (r.byteOffset || 0) + o.byteOffset;
  return new Uint8Array(o.arrayBuffer, s, r.byteLength);
}
const CQe = ["SCALAR", "VEC2", "VEC3", "VEC4"], ayn = [[Int8Array, 5120], [Uint8Array, 5121], [Int16Array, 5122], [Uint16Array, 5123], [Uint32Array, 5125], [Float32Array, 5126], [Float64Array, 5130]], Ayn = new Map(ayn), lyn = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, cyn = {
  5120: 1,
  5121: 1,
  5122: 2,
  5123: 2,
  5125: 4,
  5126: 4
}, uyn = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
};
function Yje(t) {
  return CQe[t - 1] || CQe[0];
}
function zje(t) {
  const e = Ayn.get(t.constructor);
  if (!e)
    throw new Error("Illegal typed array");
  return e;
}
function Vje(t, e) {
  const n = uyn[t.componentType], r = lyn[t.type], i = cyn[t.componentType], o = t.count * r, s = t.count * r * i;
  return wf(s >= 0 && s <= e.byteLength), {
    ArrayType: n,
    length: o,
    byteLength: s
  };
}
const fyn = {
  asset: {
    version: "2.0",
    generator: "loaders.gl"
  },
  buffers: []
};
class Wg {
  constructor(e) {
    ae(this, "gltf", void 0), ae(this, "sourceBuffers", void 0), ae(this, "byteLength", void 0), this.gltf = e || {
      json: {
        ...fyn
      },
      buffers: []
    }, this.sourceBuffers = [], this.byteLength = 0, this.gltf.buffers && this.gltf.buffers[0] && (this.byteLength = this.gltf.buffers[0].byteLength, this.sourceBuffers = [this.gltf.buffers[0]]);
  }
  get json() {
    return this.gltf.json;
  }
  getApplicationData(e) {
    return this.json[e];
  }
  getExtraData(e) {
    return (this.json.extras || {})[e];
  }
  getExtension(e) {
    const n = this.getUsedExtensions().find((i) => i === e), r = this.json.extensions || {};
    return n ? r[e] || !0 : null;
  }
  getRequiredExtension(e) {
    return this.getRequiredExtensions().find((r) => r === e) ? this.getExtension(e) : null;
  }
  getRequiredExtensions() {
    return this.json.extensionsRequired || [];
  }
  getUsedExtensions() {
    return this.json.extensionsUsed || [];
  }
  getObjectExtension(e, n) {
    return (e.extensions || {})[n];
  }
  getScene(e) {
    return this.getObject("scenes", e);
  }
  getNode(e) {
    return this.getObject("nodes", e);
  }
  getSkin(e) {
    return this.getObject("skins", e);
  }
  getMesh(e) {
    return this.getObject("meshes", e);
  }
  getMaterial(e) {
    return this.getObject("materials", e);
  }
  getAccessor(e) {
    return this.getObject("accessors", e);
  }
  getTexture(e) {
    return this.getObject("textures", e);
  }
  getSampler(e) {
    return this.getObject("samplers", e);
  }
  getImage(e) {
    return this.getObject("images", e);
  }
  getBufferView(e) {
    return this.getObject("bufferViews", e);
  }
  getBuffer(e) {
    return this.getObject("buffers", e);
  }
  getObject(e, n) {
    if (typeof n == "object")
      return n;
    const r = this.json[e] && this.json[e][n];
    if (!r)
      throw new Error("glTF file error: Could not find ".concat(e, "[").concat(n, "]"));
    return r;
  }
  getTypedArrayForBufferView(e) {
    e = this.getBufferView(e);
    const n = e.buffer, r = this.gltf.buffers[n];
    wf(r);
    const i = (e.byteOffset || 0) + r.byteOffset;
    return new Uint8Array(r.arrayBuffer, i, e.byteLength);
  }
  getTypedArrayForAccessor(e) {
    e = this.getAccessor(e);
    const n = this.getBufferView(e.bufferView), i = this.getBuffer(n.buffer).data, {
      ArrayType: o,
      length: s
    } = Vje(e, n), a = n.byteOffset + e.byteOffset;
    return new o(i, a, s);
  }
  getTypedArrayForImageData(e) {
    e = this.getAccessor(e);
    const n = this.getBufferView(e.bufferView), i = this.getBuffer(n.buffer).data, o = n.byteOffset || 0;
    return new Uint8Array(i, o, n.byteLength);
  }
  addApplicationData(e, n) {
    return this.json[e] = n, this;
  }
  addExtraData(e, n) {
    return this.json.extras = this.json.extras || {}, this.json.extras[e] = n, this;
  }
  addObjectExtension(e, n, r) {
    return e.extensions = e.extensions || {}, e.extensions[n] = r, this.registerUsedExtension(n), this;
  }
  setObjectExtension(e, n, r) {
    const i = e.extensions || {};
    i[n] = r;
  }
  removeObjectExtension(e, n) {
    const r = e.extensions || {}, i = r[n];
    return delete r[n], i;
  }
  addExtension(e, n = {}) {
    return wf(n), this.json.extensions = this.json.extensions || {}, this.json.extensions[e] = n, this.registerUsedExtension(e), n;
  }
  addRequiredExtension(e, n = {}) {
    return wf(n), this.addExtension(e, n), this.registerRequiredExtension(e), n;
  }
  registerUsedExtension(e) {
    this.json.extensionsUsed = this.json.extensionsUsed || [], this.json.extensionsUsed.find((n) => n === e) || this.json.extensionsUsed.push(e);
  }
  registerRequiredExtension(e) {
    this.registerUsedExtension(e), this.json.extensionsRequired = this.json.extensionsRequired || [], this.json.extensionsRequired.find((n) => n === e) || this.json.extensionsRequired.push(e);
  }
  removeExtension(e) {
    this.json.extensionsRequired && this._removeStringFromArray(this.json.extensionsRequired, e), this.json.extensionsUsed && this._removeStringFromArray(this.json.extensionsUsed, e), this.json.extensions && delete this.json.extensions[e];
  }
  setDefaultScene(e) {
    this.json.scene = e;
  }
  addScene(e) {
    const {
      nodeIndices: n
    } = e;
    return this.json.scenes = this.json.scenes || [], this.json.scenes.push({
      nodes: n
    }), this.json.scenes.length - 1;
  }
  addNode(e) {
    const {
      meshIndex: n,
      matrix: r
    } = e;
    this.json.nodes = this.json.nodes || [];
    const i = {
      mesh: n
    };
    return r && (i.matrix = r), this.json.nodes.push(i), this.json.nodes.length - 1;
  }
  addMesh(e) {
    const {
      attributes: n,
      indices: r,
      material: i,
      mode: o = 4
    } = e, a = {
      primitives: [{
        attributes: this._addAttributes(n),
        mode: o
      }]
    };
    if (r) {
      const A = this._addIndices(r);
      a.primitives[0].indices = A;
    }
    return Number.isFinite(i) && (a.primitives[0].material = i), this.json.meshes = this.json.meshes || [], this.json.meshes.push(a), this.json.meshes.length - 1;
  }
  addPointCloud(e) {
    const r = {
      primitives: [{
        attributes: this._addAttributes(e),
        mode: 0
      }]
    };
    return this.json.meshes = this.json.meshes || [], this.json.meshes.push(r), this.json.meshes.length - 1;
  }
  addImage(e, n) {
    const r = hle(e), i = n || r?.mimeType, s = {
      bufferView: this.addBufferView(e),
      mimeType: i
    };
    return this.json.images = this.json.images || [], this.json.images.push(s), this.json.images.length - 1;
  }
  addBufferView(e) {
    const n = e.byteLength;
    wf(Number.isFinite(n)), this.sourceBuffers = this.sourceBuffers || [], this.sourceBuffers.push(e);
    const r = {
      buffer: 0,
      byteOffset: this.byteLength,
      byteLength: n
    };
    return this.byteLength += eM(n, 4), this.json.bufferViews = this.json.bufferViews || [], this.json.bufferViews.push(r), this.json.bufferViews.length - 1;
  }
  addAccessor(e, n) {
    const r = {
      bufferView: e,
      type: Yje(n.size),
      componentType: n.componentType,
      count: n.count,
      max: n.max,
      min: n.min
    };
    return this.json.accessors = this.json.accessors || [], this.json.accessors.push(r), this.json.accessors.length - 1;
  }
  addBinaryBuffer(e, n = {
    size: 3
  }) {
    const r = this.addBufferView(e);
    let i = {
      min: n.min,
      max: n.max
    };
    (!i.min || !i.max) && (i = this._getAccessorMinMax(e, n.size));
    const o = {
      size: n.size,
      componentType: zje(e),
      count: Math.round(e.length / n.size),
      min: i.min,
      max: i.max
    };
    return this.addAccessor(r, Object.assign(o, n));
  }
  addTexture(e) {
    const {
      imageIndex: n
    } = e, r = {
      source: n
    };
    return this.json.textures = this.json.textures || [], this.json.textures.push(r), this.json.textures.length - 1;
  }
  addMaterial(e) {
    return this.json.materials = this.json.materials || [], this.json.materials.push(e), this.json.materials.length - 1;
  }
  createBinaryChunk() {
    var e, n;
    this.gltf.buffers = [];
    const r = this.byteLength, i = new ArrayBuffer(r), o = new Uint8Array(i);
    let s = 0;
    for (const a of this.sourceBuffers || [])
      s = zrn(a, o, s);
    (e = this.json) !== null && e !== void 0 && (n = e.buffers) !== null && n !== void 0 && n[0] ? this.json.buffers[0].byteLength = r : this.json.buffers = [{
      byteLength: r
    }], this.gltf.binary = i, this.sourceBuffers = [i];
  }
  _removeStringFromArray(e, n) {
    let r = !0;
    for (; r; ) {
      const i = e.indexOf(n);
      i > -1 ? e.splice(i, 1) : r = !1;
    }
  }
  _addAttributes(e = {}) {
    const n = {};
    for (const r in e) {
      const i = e[r], o = this._getGltfAttributeName(r), s = this.addBinaryBuffer(i.value, i);
      n[o] = s;
    }
    return n;
  }
  _addIndices(e) {
    return this.addBinaryBuffer(e, {
      size: 1
    });
  }
  _getGltfAttributeName(e) {
    switch (e.toLowerCase()) {
      case "position":
      case "positions":
      case "vertices":
        return "POSITION";
      case "normal":
      case "normals":
        return "NORMAL";
      case "color":
      case "colors":
        return "COLOR_0";
      case "texcoord":
      case "texcoords":
        return "TEXCOORD_0";
      default:
        return e;
    }
  }
  _getAccessorMinMax(e, n) {
    const r = {
      min: null,
      max: null
    };
    if (e.length < n)
      return r;
    r.min = [], r.max = [];
    const i = e.subarray(0, n);
    for (const o of i)
      r.min.push(o), r.max.push(o);
    for (let o = n; o < e.length; o += n)
      for (let s = 0; s < n; s++)
        r.min[0 + s] = Math.min(r.min[0 + s], e[o + s]), r.max[0 + s] = Math.max(r.max[0 + s], e[o + s]);
    return r;
  }
}
const gyn = "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", hyn = "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", dyn = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 3, 2, 0, 0, 5, 3, 1, 0, 1, 12, 1, 0, 10, 22, 2, 12, 0, 65, 0, 65, 0, 65, 0, 252, 10, 0, 0, 11, 7, 0, 65, 0, 253, 15, 26, 11]), pyn = new Uint8Array([32, 0, 65, 253, 3, 1, 2, 34, 4, 106, 6, 5, 11, 8, 7, 20, 13, 33, 12, 16, 128, 9, 116, 64, 19, 113, 127, 15, 10, 21, 22, 14, 255, 66, 24, 54, 136, 107, 18, 23, 192, 26, 114, 118, 132, 17, 77, 101, 130, 144, 27, 87, 131, 44, 45, 74, 156, 154, 70, 167]), Iyn = {
  0: "",
  1: "meshopt_decodeFilterOct",
  2: "meshopt_decodeFilterQuat",
  3: "meshopt_decodeFilterExp",
  NONE: "",
  OCTAHEDRAL: "meshopt_decodeFilterOct",
  QUATERNION: "meshopt_decodeFilterQuat",
  EXPONENTIAL: "meshopt_decodeFilterExp"
}, myn = {
  0: "meshopt_decodeVertexBuffer",
  1: "meshopt_decodeIndexBuffer",
  2: "meshopt_decodeIndexSequence",
  ATTRIBUTES: "meshopt_decodeVertexBuffer",
  TRIANGLES: "meshopt_decodeIndexBuffer",
  INDICES: "meshopt_decodeIndexSequence"
};
async function Cyn(t, e, n, r, i, o = "NONE") {
  const s = await Eyn();
  Byn(s, s.exports[myn[i]], t, e, n, r, s.exports[Iyn[o || "NONE"]]);
}
let FV;
async function Eyn() {
  return FV || (FV = yyn()), FV;
}
async function yyn() {
  let t = gyn;
  WebAssembly.validate(dyn) && (t = hyn, console.log("Warning: meshopt_decoder is using experimental SIMD support"));
  const e = await WebAssembly.instantiate(vyn(t), {});
  return await e.instance.exports.__wasm_call_ctors(), e.instance;
}
function vyn(t) {
  const e = new Uint8Array(t.length);
  for (let r = 0; r < t.length; ++r) {
    const i = t.charCodeAt(r);
    e[r] = i > 96 ? i - 71 : i > 64 ? i - 65 : i > 47 ? i + 4 : i > 46 ? 63 : 62;
  }
  let n = 0;
  for (let r = 0; r < t.length; ++r)
    e[n++] = e[r] < 60 ? pyn[e[r]] : (e[r] - 60) * 64 + e[++r];
  return e.buffer.slice(0, n);
}
function Byn(t, e, n, r, i, o, s) {
  const a = t.exports.sbrk, A = r + 3 & -4, l = a(A * i), c = a(o.length), u = new Uint8Array(t.exports.memory.buffer);
  u.set(o, c);
  const f = e(l, r, i, c, o.length);
  if (f === 0 && s && s(l, A, i), n.set(u.subarray(l, l + r * i)), a(l - a(0)), f !== 0)
    throw new Error("Malformed buffer data: ".concat(f));
}
const Bce = "EXT_meshopt_compression", byn = Bce;
async function _yn(t, e) {
  var n;
  const r = new Wg(t);
  if (!(e != null && (n = e.gltf) !== null && n !== void 0 && n.decompressMeshes))
    return;
  const i = [];
  for (const o of t.json.bufferViews || [])
    i.push(Syn(r, o));
  await Promise.all(i), r.removeExtension(Bce);
}
async function Syn(t, e) {
  const n = t.getObjectExtension(e, Bce);
  if (n) {
    const {
      byteOffset: r = 0,
      byteLength: i = 0,
      byteStride: o,
      count: s,
      mode: a,
      filter: A = "NONE",
      buffer: l
    } = n, c = t.gltf.buffers[l], u = new Uint8Array(c.arrayBuffer, c.byteOffset + r, i), f = new Uint8Array(t.gltf.buffers[e.buffer].arrayBuffer, e.byteOffset, e.byteLength);
    return await Cyn(f, s, o, u, a, A), f;
  }
  return null;
}
const Qyn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: _yn,
  name: byn
}, Symbol.toStringTag, { value: "Module" })), Jb = "EXT_texture_webp", wyn = Jb;
function xyn(t, e) {
  const n = new Wg(t);
  if (!Pon("image/webp")) {
    if (n.getRequiredExtensions().includes(Jb))
      throw new Error("gltf: Required extension ".concat(Jb, " not supported by browser"));
    return;
  }
  const {
    json: r
  } = n;
  for (const i of r.textures || []) {
    const o = n.getObjectExtension(i, Jb);
    o && (i.source = o.source), n.removeObjectExtension(i, Jb);
  }
  n.removeExtension(Jb);
}
const Ryn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: wyn,
  preprocess: xyn
}, Symbol.toStringTag, { value: "Module" })), Uk = "KHR_texture_basisu", Dyn = Uk;
function Tyn(t, e) {
  const n = new Wg(t), {
    json: r
  } = n;
  for (const i of r.textures || []) {
    const o = n.getObjectExtension(i, Uk);
    o && (i.source = o.source), n.removeObjectExtension(i, Uk);
  }
  n.removeExtension(Uk);
}
const Nyn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: Dyn,
  preprocess: Tyn
}, Symbol.toStringTag, { value: "Module" })), Lyn = "3.2.10", Myn = {
  draco: {
    decoderType: typeof WebAssembly == "object" ? "wasm" : "js",
    libraryPath: "libs/",
    extraAttributes: {},
    attributeNameEntry: void 0
  }
}, Oyn = {
  name: "Draco",
  id: "draco",
  module: "draco",
  shapes: ["mesh"],
  version: Lyn,
  worker: !0,
  extensions: ["drc"],
  mimeTypes: ["application/octet-stream"],
  binary: !0,
  tests: ["DRACO"],
  options: Myn
};
function Jje(t) {
  let e = 1 / 0, n = 1 / 0, r = 1 / 0, i = -1 / 0, o = -1 / 0, s = -1 / 0;
  const a = t.POSITION ? t.POSITION.value : [], A = a && a.length;
  for (let l = 0; l < A; l += 3) {
    const c = a[l], u = a[l + 1], f = a[l + 2];
    e = c < e ? c : e, n = u < n ? u : n, r = f < r ? f : r, i = c > i ? c : i, o = u > o ? u : o, s = f > s ? f : s;
  }
  return [[e, n, r], [i, o, s]];
}
function Fyn(t, e) {
  if (!t)
    throw new Error(e || "loader assertion failed.");
}
class E_ {
  constructor(e, n) {
    ae(this, "fields", void 0), ae(this, "metadata", void 0), Fyn(Array.isArray(e)), Pyn(e), this.fields = e, this.metadata = n || /* @__PURE__ */ new Map();
  }
  compareTo(e) {
    if (this.metadata !== e.metadata || this.fields.length !== e.fields.length)
      return !1;
    for (let n = 0; n < this.fields.length; ++n)
      if (!this.fields[n].compareTo(e.fields[n]))
        return !1;
    return !0;
  }
  select(...e) {
    const n = /* @__PURE__ */ Object.create(null);
    for (const i of e)
      n[i] = !0;
    const r = this.fields.filter((i) => n[i.name]);
    return new E_(r, this.metadata);
  }
  selectAt(...e) {
    const n = e.map((r) => this.fields[r]).filter(Boolean);
    return new E_(n, this.metadata);
  }
  assign(e) {
    let n, r = this.metadata;
    if (e instanceof E_) {
      const s = e;
      n = s.fields, r = EQe(EQe(/* @__PURE__ */ new Map(), this.metadata), s.metadata);
    } else
      n = e;
    const i = /* @__PURE__ */ Object.create(null);
    for (const s of this.fields)
      i[s.name] = s;
    for (const s of n)
      i[s.name] = s;
    const o = Object.values(i);
    return new E_(o, r);
  }
}
function Pyn(t) {
  const e = {};
  for (const n of t)
    e[n.name] && console.warn("Schema: duplicated field name", n.name, n), e[n.name] = !0;
}
function EQe(t, e) {
  return new Map([...t || /* @__PURE__ */ new Map(), ...e || /* @__PURE__ */ new Map()]);
}
let yQe = class Kje {
  constructor(e, n, r = !1, i = /* @__PURE__ */ new Map()) {
    ae(this, "name", void 0), ae(this, "type", void 0), ae(this, "nullable", void 0), ae(this, "metadata", void 0), this.name = e, this.type = n, this.nullable = r, this.metadata = i;
  }
  get typeId() {
    return this.type && this.type.typeId;
  }
  clone() {
    return new Kje(this.name, this.type, this.nullable, this.metadata);
  }
  compareTo(e) {
    return this.name === e.name && this.type === e.type && this.nullable === e.nullable && this.metadata === e.metadata;
  }
  toString() {
    return "".concat(this.type).concat(this.nullable ? ", nullable" : "").concat(this.metadata ? ", metadata: ".concat(this.metadata) : "");
  }
}, xs;
(function(t) {
  t[t.NONE = 0] = "NONE", t[t.Null = 1] = "Null", t[t.Int = 2] = "Int", t[t.Float = 3] = "Float", t[t.Binary = 4] = "Binary", t[t.Utf8 = 5] = "Utf8", t[t.Bool = 6] = "Bool", t[t.Decimal = 7] = "Decimal", t[t.Date = 8] = "Date", t[t.Time = 9] = "Time", t[t.Timestamp = 10] = "Timestamp", t[t.Interval = 11] = "Interval", t[t.List = 12] = "List", t[t.Struct = 13] = "Struct", t[t.Union = 14] = "Union", t[t.FixedSizeBinary = 15] = "FixedSizeBinary", t[t.FixedSizeList = 16] = "FixedSizeList", t[t.Map = 17] = "Map", t[t.Dictionary = -1] = "Dictionary", t[t.Int8 = -2] = "Int8", t[t.Int16 = -3] = "Int16", t[t.Int32 = -4] = "Int32", t[t.Int64 = -5] = "Int64", t[t.Uint8 = -6] = "Uint8", t[t.Uint16 = -7] = "Uint16", t[t.Uint32 = -8] = "Uint32", t[t.Uint64 = -9] = "Uint64", t[t.Float16 = -10] = "Float16", t[t.Float32 = -11] = "Float32", t[t.Float64 = -12] = "Float64", t[t.DateDay = -13] = "DateDay", t[t.DateMillisecond = -14] = "DateMillisecond", t[t.TimestampSecond = -15] = "TimestampSecond", t[t.TimestampMillisecond = -16] = "TimestampMillisecond", t[t.TimestampMicrosecond = -17] = "TimestampMicrosecond", t[t.TimestampNanosecond = -18] = "TimestampNanosecond", t[t.TimeSecond = -19] = "TimeSecond", t[t.TimeMillisecond = -20] = "TimeMillisecond", t[t.TimeMicrosecond = -21] = "TimeMicrosecond", t[t.TimeNanosecond = -22] = "TimeNanosecond", t[t.DenseUnion = -23] = "DenseUnion", t[t.SparseUnion = -24] = "SparseUnion", t[t.IntervalDayTime = -25] = "IntervalDayTime", t[t.IntervalYearMonth = -26] = "IntervalYearMonth";
})(xs || (xs = {}));
let Wje, Xje, Zje;
class bce {
  static isNull(e) {
    return e && e.typeId === xs.Null;
  }
  static isInt(e) {
    return e && e.typeId === xs.Int;
  }
  static isFloat(e) {
    return e && e.typeId === xs.Float;
  }
  static isBinary(e) {
    return e && e.typeId === xs.Binary;
  }
  static isUtf8(e) {
    return e && e.typeId === xs.Utf8;
  }
  static isBool(e) {
    return e && e.typeId === xs.Bool;
  }
  static isDecimal(e) {
    return e && e.typeId === xs.Decimal;
  }
  static isDate(e) {
    return e && e.typeId === xs.Date;
  }
  static isTime(e) {
    return e && e.typeId === xs.Time;
  }
  static isTimestamp(e) {
    return e && e.typeId === xs.Timestamp;
  }
  static isInterval(e) {
    return e && e.typeId === xs.Interval;
  }
  static isList(e) {
    return e && e.typeId === xs.List;
  }
  static isStruct(e) {
    return e && e.typeId === xs.Struct;
  }
  static isUnion(e) {
    return e && e.typeId === xs.Union;
  }
  static isFixedSizeBinary(e) {
    return e && e.typeId === xs.FixedSizeBinary;
  }
  static isFixedSizeList(e) {
    return e && e.typeId === xs.FixedSizeList;
  }
  static isMap(e) {
    return e && e.typeId === xs.Map;
  }
  static isDictionary(e) {
    return e && e.typeId === xs.Dictionary;
  }
  get typeId() {
    return xs.NONE;
  }
  compareTo(e) {
    return this === e;
  }
}
Wje = Symbol.toStringTag;
class Gw extends bce {
  constructor(e, n) {
    super(), ae(this, "isSigned", void 0), ae(this, "bitWidth", void 0), this.isSigned = e, this.bitWidth = n;
  }
  get typeId() {
    return xs.Int;
  }
  get [Wje]() {
    return "Int";
  }
  toString() {
    return "".concat(this.isSigned ? "I" : "Ui", "nt").concat(this.bitWidth);
  }
}
class kyn extends Gw {
  constructor() {
    super(!0, 8);
  }
}
class Gyn extends Gw {
  constructor() {
    super(!0, 16);
  }
}
class Uyn extends Gw {
  constructor() {
    super(!0, 32);
  }
}
class Hyn extends Gw {
  constructor() {
    super(!1, 8);
  }
}
class $yn extends Gw {
  constructor() {
    super(!1, 16);
  }
}
class qyn extends Gw {
  constructor() {
    super(!1, 32);
  }
}
const eYe = {
  HALF: 16,
  SINGLE: 32,
  DOUBLE: 64
};
Xje = Symbol.toStringTag;
class tYe extends bce {
  constructor(e) {
    super(), ae(this, "precision", void 0), this.precision = e;
  }
  get typeId() {
    return xs.Float;
  }
  get [Xje]() {
    return "Float";
  }
  toString() {
    return "Float".concat(this.precision);
  }
}
class jyn extends tYe {
  constructor() {
    super(eYe.SINGLE);
  }
}
class Yyn extends tYe {
  constructor() {
    super(eYe.DOUBLE);
  }
}
Zje = Symbol.toStringTag;
class zyn extends bce {
  constructor(e, n) {
    super(), ae(this, "listSize", void 0), ae(this, "children", void 0), this.listSize = e, this.children = [n];
  }
  get typeId() {
    return xs.FixedSizeList;
  }
  get valueType() {
    return this.children[0].type;
  }
  get valueField() {
    return this.children[0];
  }
  get [Zje]() {
    return "FixedSizeList";
  }
  toString() {
    return "FixedSizeList[".concat(this.listSize, "]<").concat(this.valueType, ">");
  }
}
function Vyn(t) {
  switch (t.constructor) {
    case Int8Array:
      return new kyn();
    case Uint8Array:
      return new Hyn();
    case Int16Array:
      return new Gyn();
    case Uint16Array:
      return new $yn();
    case Int32Array:
      return new Uyn();
    case Uint32Array:
      return new qyn();
    case Float32Array:
      return new jyn();
    case Float64Array:
      return new Yyn();
    default:
      throw new Error("array type not supported");
  }
}
function Jyn(t, e, n) {
  const r = Vyn(e.value), i = n || Kyn(e);
  return new yQe(t, new zyn(e.size, new yQe("value", r)), !1, i);
}
function Kyn(t) {
  const e = /* @__PURE__ */ new Map();
  return "byteOffset" in t && e.set("byteOffset", t.byteOffset.toString(10)), "byteStride" in t && e.set("byteStride", t.byteStride.toString(10)), "normalized" in t && e.set("normalized", t.normalized.toString()), e;
}
function Wyn(t, e, n) {
  const r = nYe(e.metadata), i = [], o = Xyn(e.attributes);
  for (const s in t) {
    const a = t[s], A = vQe(s, a, o[s]);
    i.push(A);
  }
  if (n) {
    const s = vQe("indices", n);
    i.push(s);
  }
  return new E_(i, r);
}
function Xyn(t) {
  const e = {};
  for (const n in t) {
    const r = t[n];
    e[r.name || "undefined"] = r;
  }
  return e;
}
function vQe(t, e, n) {
  const r = n ? nYe(n.metadata) : void 0;
  return Jyn(t, e, r);
}
function nYe(t) {
  const e = /* @__PURE__ */ new Map();
  for (const n in t)
    e.set("".concat(n, ".string"), JSON.stringify(t[n]));
  return e;
}
const BQe = {
  POSITION: "POSITION",
  NORMAL: "NORMAL",
  COLOR: "COLOR_0",
  TEX_COORD: "TEXCOORD_0"
}, Zyn = {
  1: Int8Array,
  2: Uint8Array,
  3: Int16Array,
  4: Uint16Array,
  5: Int32Array,
  6: Uint32Array,
  9: Float32Array
}, evn = 4;
class tvn {
  constructor(e) {
    ae(this, "draco", void 0), ae(this, "decoder", void 0), ae(this, "metadataQuerier", void 0), this.draco = e, this.decoder = new this.draco.Decoder(), this.metadataQuerier = new this.draco.MetadataQuerier();
  }
  destroy() {
    this.draco.destroy(this.decoder), this.draco.destroy(this.metadataQuerier);
  }
  parseSync(e, n = {}) {
    const r = new this.draco.DecoderBuffer();
    r.Init(new Int8Array(e), e.byteLength), this._disableAttributeTransforms(n);
    const i = this.decoder.GetEncodedGeometryType(r), o = i === this.draco.TRIANGULAR_MESH ? new this.draco.Mesh() : new this.draco.PointCloud();
    try {
      let s;
      switch (i) {
        case this.draco.TRIANGULAR_MESH:
          s = this.decoder.DecodeBufferToMesh(r, o);
          break;
        case this.draco.POINT_CLOUD:
          s = this.decoder.DecodeBufferToPointCloud(r, o);
          break;
        default:
          throw new Error("DRACO: Unknown geometry type.");
      }
      if (!s.ok() || !o.ptr) {
        const f = "DRACO decompression failed: ".concat(s.error_msg());
        throw new Error(f);
      }
      const a = this._getDracoLoaderData(o, i, n), A = this._getMeshData(o, a, n), l = Jje(A.attributes), c = Wyn(A.attributes, a, A.indices);
      return {
        loader: "draco",
        loaderData: a,
        header: {
          vertexCount: o.num_points(),
          boundingBox: l
        },
        ...A,
        schema: c
      };
    } finally {
      this.draco.destroy(r), o && this.draco.destroy(o);
    }
  }
  _getDracoLoaderData(e, n, r) {
    const i = this._getTopLevelMetadata(e), o = this._getDracoAttributes(e, r);
    return {
      geometry_type: n,
      num_attributes: e.num_attributes(),
      num_points: e.num_points(),
      num_faces: e instanceof this.draco.Mesh ? e.num_faces() : 0,
      metadata: i,
      attributes: o
    };
  }
  _getDracoAttributes(e, n) {
    const r = {};
    for (let i = 0; i < e.num_attributes(); i++) {
      const o = this.decoder.GetAttribute(e, i), s = this._getAttributeMetadata(e, i);
      r[o.unique_id()] = {
        unique_id: o.unique_id(),
        attribute_type: o.attribute_type(),
        data_type: o.data_type(),
        num_components: o.num_components(),
        byte_offset: o.byte_offset(),
        byte_stride: o.byte_stride(),
        normalized: o.normalized(),
        attribute_index: i,
        metadata: s
      };
      const a = this._getQuantizationTransform(o, n);
      a && (r[o.unique_id()].quantization_transform = a);
      const A = this._getOctahedronTransform(o, n);
      A && (r[o.unique_id()].octahedron_transform = A);
    }
    return r;
  }
  _getMeshData(e, n, r) {
    const i = this._getMeshAttributes(n, e, r);
    if (!i.POSITION)
      throw new Error("DRACO: No position attribute found.");
    if (e instanceof this.draco.Mesh)
      switch (r.topology) {
        case "triangle-strip":
          return {
            topology: "triangle-strip",
            mode: 4,
            attributes: i,
            indices: {
              value: this._getTriangleStripIndices(e),
              size: 1
            }
          };
        case "triangle-list":
        default:
          return {
            topology: "triangle-list",
            mode: 5,
            attributes: i,
            indices: {
              value: this._getTriangleListIndices(e),
              size: 1
            }
          };
      }
    return {
      topology: "point-list",
      mode: 0,
      attributes: i
    };
  }
  _getMeshAttributes(e, n, r) {
    const i = {};
    for (const o of Object.values(e.attributes)) {
      const s = this._deduceAttributeName(o, r);
      o.name = s;
      const {
        value: a,
        size: A
      } = this._getAttributeValues(n, o);
      i[s] = {
        value: a,
        size: A,
        byteOffset: o.byte_offset,
        byteStride: o.byte_stride,
        normalized: o.normalized
      };
    }
    return i;
  }
  _getTriangleListIndices(e) {
    const r = e.num_faces() * 3, i = r * evn, o = this.draco._malloc(i);
    try {
      return this.decoder.GetTrianglesUInt32Array(e, i, o), new Uint32Array(this.draco.HEAPF32.buffer, o, r).slice();
    } finally {
      this.draco._free(o);
    }
  }
  _getTriangleStripIndices(e) {
    const n = new this.draco.DracoInt32Array();
    try {
      return this.decoder.GetTriangleStripsFromMesh(e, n), ivn(n);
    } finally {
      this.draco.destroy(n);
    }
  }
  _getAttributeValues(e, n) {
    const r = Zyn[n.data_type], i = n.num_components, s = e.num_points() * i, a = s * r.BYTES_PER_ELEMENT, A = nvn(this.draco, r);
    let l;
    const c = this.draco._malloc(a);
    try {
      const u = this.decoder.GetAttribute(e, n.attribute_index);
      this.decoder.GetAttributeDataArrayForAllPoints(e, u, A, a, c), l = new r(this.draco.HEAPF32.buffer, c, s).slice();
    } finally {
      this.draco._free(c);
    }
    return {
      value: l,
      size: i
    };
  }
  _deduceAttributeName(e, n) {
    const r = e.unique_id;
    for (const [s, a] of Object.entries(n.extraAttributes || {}))
      if (a === r)
        return s;
    const i = e.attribute_type;
    for (const s in BQe)
      if (this.draco[s] === i)
        return BQe[s];
    const o = n.attributeNameEntry || "name";
    return e.metadata[o] ? e.metadata[o].string : "CUSTOM_ATTRIBUTE_".concat(r);
  }
  _getTopLevelMetadata(e) {
    const n = this.decoder.GetMetadata(e);
    return this._getDracoMetadata(n);
  }
  _getAttributeMetadata(e, n) {
    const r = this.decoder.GetAttributeMetadata(e, n);
    return this._getDracoMetadata(r);
  }
  _getDracoMetadata(e) {
    if (!e || !e.ptr)
      return {};
    const n = {}, r = this.metadataQuerier.NumEntries(e);
    for (let i = 0; i < r; i++) {
      const o = this.metadataQuerier.GetEntryName(e, i);
      n[o] = this._getDracoMetadataField(e, o);
    }
    return n;
  }
  _getDracoMetadataField(e, n) {
    const r = new this.draco.DracoInt32Array();
    try {
      this.metadataQuerier.GetIntEntryArray(e, n, r);
      const i = rvn(r);
      return {
        int: this.metadataQuerier.GetIntEntry(e, n),
        string: this.metadataQuerier.GetStringEntry(e, n),
        double: this.metadataQuerier.GetDoubleEntry(e, n),
        intArray: i
      };
    } finally {
      this.draco.destroy(r);
    }
  }
  _disableAttributeTransforms(e) {
    const {
      quantizedAttributes: n = [],
      octahedronAttributes: r = []
    } = e, i = [...n, ...r];
    for (const o of i)
      this.decoder.SkipAttributeTransform(this.draco[o]);
  }
  _getQuantizationTransform(e, n) {
    const {
      quantizedAttributes: r = []
    } = n, i = e.attribute_type();
    if (r.map((s) => this.decoder[s]).includes(i)) {
      const s = new this.draco.AttributeQuantizationTransform();
      try {
        if (s.InitFromAttribute(e))
          return {
            quantization_bits: s.quantization_bits(),
            range: s.range(),
            min_values: new Float32Array([1, 2, 3]).map((a) => s.min_value(a))
          };
      } finally {
        this.draco.destroy(s);
      }
    }
    return null;
  }
  _getOctahedronTransform(e, n) {
    const {
      octahedronAttributes: r = []
    } = n, i = e.attribute_type();
    if (r.map((s) => this.decoder[s]).includes(i)) {
      const s = new this.draco.AttributeQuantizationTransform();
      try {
        if (s.InitFromAttribute(e))
          return {
            quantization_bits: s.quantization_bits()
          };
      } finally {
        this.draco.destroy(s);
      }
    }
    return null;
  }
}
function nvn(t, e) {
  switch (e) {
    case Float32Array:
      return t.DT_FLOAT32;
    case Int8Array:
      return t.DT_INT8;
    case Int16Array:
      return t.DT_INT16;
    case Int32Array:
      return t.DT_INT32;
    case Uint8Array:
      return t.DT_UINT8;
    case Uint16Array:
      return t.DT_UINT16;
    case Uint32Array:
      return t.DT_UINT32;
    default:
      return t.DT_INVALID;
  }
}
function rvn(t) {
  const e = t.size(), n = new Int32Array(e);
  for (let r = 0; r < e; r++)
    n[r] = t.GetValue(r);
  return n;
}
function ivn(t) {
  const e = t.size(), n = new Int32Array(e);
  for (let r = 0; r < e; r++)
    n[r] = t.GetValue(r);
  return n;
}
const _ce = "1.4.1", ovn = "https://www.gstatic.com/draco/versioned/decoders/".concat(_ce, "/draco_decoder.js"), svn = "https://www.gstatic.com/draco/versioned/decoders/".concat(_ce, "/draco_wasm_wrapper.js"), avn = "https://www.gstatic.com/draco/versioned/decoders/".concat(_ce, "/draco_decoder.wasm");
let h2;
async function Avn(t) {
  const e = t.modules || {};
  return e.draco3d ? h2 = h2 || e.draco3d.createDecoderModule({}).then((n) => ({
    draco: n
  })) : h2 = h2 || lvn(t), await h2;
}
async function lvn(t) {
  let e, n;
  switch (t.draco && t.draco.decoderType) {
    case "js":
      e = await Qv(ovn, "draco", t);
      break;
    case "wasm":
    default:
      [e, n] = await Promise.all([await Qv(svn, "draco", t), await Qv(avn, "draco", t)]);
  }
  return e = e || globalThis.DracoDecoderModule, await cvn(e, n);
}
function cvn(t, e) {
  const n = {};
  return e && (n.wasmBinary = e), new Promise((r) => {
    t({
      ...n,
      onModuleLoaded: (i) => r({
        draco: i
      })
    });
  });
}
const rYe = {
  ...Oyn,
  parse: uvn
};
async function uvn(t, e) {
  const {
    draco: n
  } = await Avn(e), r = new tvn(n);
  try {
    return r.parseSync(t, e?.draco);
  } finally {
    r.destroy();
  }
}
function fvn(t) {
  const e = {};
  for (const n in t) {
    const r = t[n];
    if (n !== "indices") {
      const i = iYe(r);
      e[n] = i;
    }
  }
  return e;
}
function iYe(t) {
  const {
    buffer: e,
    size: n,
    count: r
  } = gvn(t);
  return {
    value: e,
    size: n,
    byteOffset: 0,
    count: r,
    type: Yje(n),
    componentType: zje(e)
  };
}
function gvn(t) {
  let e = t, n = 1, r = 0;
  return t && t.value && (e = t.value, n = t.size || 1), e && (ArrayBuffer.isView(e) || (e = hvn(e, Float32Array)), r = e.length / n), {
    buffer: e,
    size: n,
    count: r
  };
}
function hvn(t, e, n = !1) {
  return t ? Array.isArray(t) ? new e(t) : n && !(t instanceof e) ? new e(t) : t : null;
}
const oB = "KHR_draco_mesh_compression", dvn = oB;
function pvn(t, e, n) {
  const r = new Wg(t);
  for (const i of oYe(r))
    r.getObjectExtension(i, oB);
}
async function Ivn(t, e, n) {
  var r;
  if (!(e != null && (r = e.gltf) !== null && r !== void 0 && r.decompressMeshes))
    return;
  const i = new Wg(t), o = [];
  for (const s of oYe(i))
    i.getObjectExtension(s, oB) && o.push(Cvn(i, s, e, n));
  await Promise.all(o), i.removeExtension(oB);
}
function mvn(t, e = {}) {
  const n = new Wg(t);
  for (const r of n.json.meshes || [])
    Evn(r), n.addRequiredExtension(oB);
}
async function Cvn(t, e, n, r) {
  const i = t.getObjectExtension(e, oB);
  if (!i)
    return;
  const o = t.getTypedArrayForBufferView(i.bufferView), s = lle(o.buffer, o.byteOffset), {
    parse: a
  } = r, A = {
    ...n
  };
  delete A["3d-tiles"];
  const l = await a(s, rYe, A, r), c = fvn(l.attributes);
  for (const [u, f] of Object.entries(c))
    if (u in e.attributes) {
      const h = e.attributes[u], d = t.getAccessor(h);
      d != null && d.min && d !== null && d !== void 0 && d.max && (f.min = d.min, f.max = d.max);
    }
  e.attributes = c, l.indices && (e.indices = iYe(l.indices)), yvn(e);
}
function Evn(t, e, n = 4, r, i) {
  var o;
  if (!r.DracoWriter)
    throw new Error("options.gltf.DracoWriter not provided");
  const s = r.DracoWriter.encodeSync({
    attributes: t
  }), a = i == null || (o = i.parseSync) === null || o === void 0 ? void 0 : o.call(i, {
    attributes: t
  }), A = r._addFauxAttributes(a.attributes), l = r.addBufferView(s);
  return {
    primitives: [{
      attributes: A,
      mode: n,
      extensions: {
        [oB]: {
          bufferView: l,
          attributes: A
        }
      }
    }]
  };
}
function yvn(t) {
  if (!t.attributes && Object.keys(t.attributes).length > 0)
    throw new Error("glTF: Empty primitive detected: Draco decompression failure?");
}
function* oYe(t) {
  for (const e of t.json.meshes || [])
    for (const n of e.primitives)
      yield n;
}
const vvn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: Ivn,
  encode: mvn,
  name: dvn,
  preprocess: pvn
}, Symbol.toStringTag, { value: "Module" })), Av = "KHR_lights_punctual", Bvn = Av;
async function bvn(t) {
  const e = new Wg(t), {
    json: n
  } = e, r = e.getExtension(Av);
  r && (e.json.lights = r.lights, e.removeExtension(Av));
  for (const i of n.nodes || []) {
    const o = e.getObjectExtension(i, Av);
    o && (i.light = o.light), e.removeObjectExtension(i, Av);
  }
}
async function _vn(t) {
  const e = new Wg(t), {
    json: n
  } = e;
  if (n.lights) {
    const r = e.addExtension(Av);
    wf(!r.lights), r.lights = n.lights, delete n.lights;
  }
  if (e.json.lights) {
    for (const r of e.json.lights) {
      const i = r.node;
      e.addObjectExtension(i, Av, r);
    }
    delete e.json.lights;
  }
}
const Svn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: bvn,
  encode: _vn,
  name: Bvn
}, Symbol.toStringTag, { value: "Module" })), JT = "KHR_materials_unlit", Qvn = JT;
async function wvn(t) {
  const e = new Wg(t), {
    json: n
  } = e;
  e.removeExtension(JT);
  for (const r of n.materials || [])
    r.extensions && r.extensions.KHR_materials_unlit && (r.unlit = !0), e.removeObjectExtension(r, JT);
}
function xvn(t) {
  const e = new Wg(t), {
    json: n
  } = e;
  if (e.materials)
    for (const r of n.materials || [])
      r.unlit && (delete r.unlit, e.addObjectExtension(r, JT, {}), e.addExtension(JT));
}
const Rvn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: wvn,
  encode: xvn,
  name: Qvn
}, Symbol.toStringTag, { value: "Module" })), SR = "KHR_techniques_webgl", Dvn = SR;
async function Tvn(t) {
  const e = new Wg(t), {
    json: n
  } = e, r = e.getExtension(SR);
  if (r) {
    const i = Lvn(r, e);
    for (const o of n.materials || []) {
      const s = e.getObjectExtension(o, SR);
      s && (o.technique = Object.assign({}, s, i[s.technique]), o.technique.values = Mvn(o.technique, e)), e.removeObjectExtension(o, SR);
    }
    e.removeExtension(SR);
  }
}
async function Nvn(t, e) {
}
function Lvn(t, e) {
  const {
    programs: n = [],
    shaders: r = [],
    techniques: i = []
  } = t, o = new TextDecoder();
  return r.forEach((s) => {
    if (Number.isFinite(s.bufferView))
      s.code = o.decode(e.getTypedArrayForBufferView(s.bufferView));
    else
      throw new Error("KHR_techniques_webgl: no shader code");
  }), n.forEach((s) => {
    s.fragmentShader = r[s.fragmentShader], s.vertexShader = r[s.vertexShader];
  }), i.forEach((s) => {
    s.program = n[s.program];
  }), i;
}
function Mvn(t, e) {
  const n = Object.assign({}, t.values);
  return Object.keys(t.uniforms || {}).forEach((r) => {
    t.uniforms[r].value && !(r in n) && (n[r] = t.uniforms[r].value);
  }), Object.keys(n).forEach((r) => {
    typeof n[r] == "object" && n[r].index !== void 0 && (n[r].texture = e.getTexture(n[r].index));
  }), n;
}
const Ovn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: Tvn,
  encode: Nvn,
  name: Dvn
}, Symbol.toStringTag, { value: "Module" })), sYe = [Qyn, Ryn, Nyn, vvn, Svn, Rvn, Ovn];
function Fvn(t, e = {}, n) {
  const r = sYe.filter((o) => aYe(o.name, e));
  for (const o of r) {
    var i;
    (i = o.preprocess) === null || i === void 0 || i.call(o, t, e, n);
  }
}
async function Pvn(t, e = {}, n) {
  const r = sYe.filter((o) => aYe(o.name, e));
  for (const o of r) {
    var i;
    await ((i = o.decode) === null || i === void 0 ? void 0 : i.call(o, t, e, n));
  }
}
function aYe(t, e) {
  var n;
  const r = (e == null || (n = e.gltf) === null || n === void 0 ? void 0 : n.excludeExtensions) || {};
  return !(t in r && !r[t]);
}
const PV = "KHR_binary_glTF";
function kvn(t) {
  const e = new Wg(t), {
    json: n
  } = e;
  for (const r of n.images || []) {
    const i = e.getObjectExtension(r, PV);
    i && Object.assign(r, i), e.removeObjectExtension(r, PV);
  }
  n.buffers && n.buffers[0] && delete n.buffers[0].uri, e.removeExtension(PV);
}
const bQe = {
  accessors: "accessor",
  animations: "animation",
  buffers: "buffer",
  bufferViews: "bufferView",
  images: "image",
  materials: "material",
  meshes: "mesh",
  nodes: "node",
  samplers: "sampler",
  scenes: "scene",
  skins: "skin",
  textures: "texture"
}, Gvn = {
  accessor: "accessors",
  animations: "animation",
  buffer: "buffers",
  bufferView: "bufferViews",
  image: "images",
  material: "materials",
  mesh: "meshes",
  node: "nodes",
  sampler: "samplers",
  scene: "scenes",
  skin: "skins",
  texture: "textures"
};
class Uvn {
  constructor() {
    ae(this, "idToIndexMap", {
      animations: {},
      accessors: {},
      buffers: {},
      bufferViews: {},
      images: {},
      materials: {},
      meshes: {},
      nodes: {},
      samplers: {},
      scenes: {},
      skins: {},
      textures: {}
    }), ae(this, "json", void 0);
  }
  normalize(e, n) {
    this.json = e.json;
    const r = e.json;
    switch (r.asset && r.asset.version) {
      case "2.0":
        return;
      case void 0:
      case "1.0":
        break;
      default:
        console.warn("glTF: Unknown version ".concat(r.asset.version));
        return;
    }
    if (!n.normalize)
      throw new Error("glTF v1 is not supported.");
    console.warn("Converting glTF v1 to glTF v2 format. This is experimental and may fail."), this._addAsset(r), this._convertTopLevelObjectsToArrays(r), kvn(e), this._convertObjectIdsToArrayIndices(r), this._updateObjects(r), this._updateMaterial(r);
  }
  _addAsset(e) {
    e.asset = e.asset || {}, e.asset.version = "2.0", e.asset.generator = e.asset.generator || "Normalized to glTF 2.0 by loaders.gl";
  }
  _convertTopLevelObjectsToArrays(e) {
    for (const n in bQe)
      this._convertTopLevelObjectToArray(e, n);
  }
  _convertTopLevelObjectToArray(e, n) {
    const r = e[n];
    if (!(!r || Array.isArray(r))) {
      e[n] = [];
      for (const i in r) {
        const o = r[i];
        o.id = o.id || i;
        const s = e[n].length;
        e[n].push(o), this.idToIndexMap[n][i] = s;
      }
    }
  }
  _convertObjectIdsToArrayIndices(e) {
    for (const n in bQe)
      this._convertIdsToIndices(e, n);
    "scene" in e && (e.scene = this._convertIdToIndex(e.scene, "scene"));
    for (const n of e.textures)
      this._convertTextureIds(n);
    for (const n of e.meshes)
      this._convertMeshIds(n);
    for (const n of e.nodes)
      this._convertNodeIds(n);
    for (const n of e.scenes)
      this._convertSceneIds(n);
  }
  _convertTextureIds(e) {
    e.source && (e.source = this._convertIdToIndex(e.source, "image"));
  }
  _convertMeshIds(e) {
    for (const n of e.primitives) {
      const {
        attributes: r,
        indices: i,
        material: o
      } = n;
      for (const s in r)
        r[s] = this._convertIdToIndex(r[s], "accessor");
      i && (n.indices = this._convertIdToIndex(i, "accessor")), o && (n.material = this._convertIdToIndex(o, "material"));
    }
  }
  _convertNodeIds(e) {
    e.children && (e.children = e.children.map((n) => this._convertIdToIndex(n, "node"))), e.meshes && (e.meshes = e.meshes.map((n) => this._convertIdToIndex(n, "mesh")));
  }
  _convertSceneIds(e) {
    e.nodes && (e.nodes = e.nodes.map((n) => this._convertIdToIndex(n, "node")));
  }
  _convertIdsToIndices(e, n) {
    e[n] || (console.warn("gltf v1: json doesn't contain attribute ".concat(n)), e[n] = []);
    for (const r of e[n])
      for (const i in r) {
        const o = r[i], s = this._convertIdToIndex(o, i);
        r[i] = s;
      }
  }
  _convertIdToIndex(e, n) {
    const r = Gvn[n];
    if (r in this.idToIndexMap) {
      const i = this.idToIndexMap[r][e];
      if (!Number.isFinite(i))
        throw new Error("gltf v1: failed to resolve ".concat(n, " with id ").concat(e));
      return i;
    }
    return e;
  }
  _updateObjects(e) {
    for (const n of this.json.buffers)
      delete n.type;
  }
  _updateMaterial(e) {
    for (const o of e.materials) {
      var n, r, i;
      o.pbrMetallicRoughness = {
        baseColorFactor: [1, 1, 1, 1],
        metallicFactor: 1,
        roughnessFactor: 1
      };
      const s = ((n = o.values) === null || n === void 0 ? void 0 : n.tex) || ((r = o.values) === null || r === void 0 ? void 0 : r.texture2d_0) || ((i = o.values) === null || i === void 0 ? void 0 : i.diffuseTex), a = e.textures.findIndex((A) => A.id === s);
      a !== -1 && (o.pbrMetallicRoughness.baseColorTexture = {
        index: a
      });
    }
  }
}
function Hvn(t, e = {}) {
  return new Uvn().normalize(t, e);
}
const $vn = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, qvn = {
  5120: 1,
  5121: 1,
  5122: 2,
  5123: 2,
  5125: 4,
  5126: 4
}, fg = {
  TEXTURE_MAG_FILTER: 10240,
  TEXTURE_MIN_FILTER: 10241,
  TEXTURE_WRAP_S: 10242,
  TEXTURE_WRAP_T: 10243,
  REPEAT: 10497,
  LINEAR: 9729,
  NEAREST_MIPMAP_LINEAR: 9986
}, jvn = {
  magFilter: fg.TEXTURE_MAG_FILTER,
  minFilter: fg.TEXTURE_MIN_FILTER,
  wrapS: fg.TEXTURE_WRAP_S,
  wrapT: fg.TEXTURE_WRAP_T
}, Yvn = {
  [fg.TEXTURE_MAG_FILTER]: fg.LINEAR,
  [fg.TEXTURE_MIN_FILTER]: fg.NEAREST_MIPMAP_LINEAR,
  [fg.TEXTURE_WRAP_S]: fg.REPEAT,
  [fg.TEXTURE_WRAP_T]: fg.REPEAT
};
function zvn(t) {
  return qvn[t];
}
function Vvn(t) {
  return $vn[t];
}
class Jvn {
  constructor() {
    ae(this, "baseUri", ""), ae(this, "json", {}), ae(this, "buffers", []), ae(this, "images", []);
  }
  postProcess(e, n = {}) {
    const {
      json: r,
      buffers: i = [],
      images: o = [],
      baseUri: s = ""
    } = e;
    return wf(r), this.baseUri = s, this.json = r, this.buffers = i, this.images = o, this._resolveTree(this.json, n), this.json;
  }
  _resolveTree(e, n = {}) {
    e.bufferViews && (e.bufferViews = e.bufferViews.map((r, i) => this._resolveBufferView(r, i))), e.images && (e.images = e.images.map((r, i) => this._resolveImage(r, i))), e.samplers && (e.samplers = e.samplers.map((r, i) => this._resolveSampler(r, i))), e.textures && (e.textures = e.textures.map((r, i) => this._resolveTexture(r, i))), e.accessors && (e.accessors = e.accessors.map((r, i) => this._resolveAccessor(r, i))), e.materials && (e.materials = e.materials.map((r, i) => this._resolveMaterial(r, i))), e.meshes && (e.meshes = e.meshes.map((r, i) => this._resolveMesh(r, i))), e.nodes && (e.nodes = e.nodes.map((r, i) => this._resolveNode(r, i))), e.skins && (e.skins = e.skins.map((r, i) => this._resolveSkin(r, i))), e.scenes && (e.scenes = e.scenes.map((r, i) => this._resolveScene(r, i))), e.scene !== void 0 && (e.scene = e.scenes[this.json.scene]);
  }
  getScene(e) {
    return this._get("scenes", e);
  }
  getNode(e) {
    return this._get("nodes", e);
  }
  getSkin(e) {
    return this._get("skins", e);
  }
  getMesh(e) {
    return this._get("meshes", e);
  }
  getMaterial(e) {
    return this._get("materials", e);
  }
  getAccessor(e) {
    return this._get("accessors", e);
  }
  getCamera(e) {
    return null;
  }
  getTexture(e) {
    return this._get("textures", e);
  }
  getSampler(e) {
    return this._get("samplers", e);
  }
  getImage(e) {
    return this._get("images", e);
  }
  getBufferView(e) {
    return this._get("bufferViews", e);
  }
  getBuffer(e) {
    return this._get("buffers", e);
  }
  _get(e, n) {
    if (typeof n == "object")
      return n;
    const r = this.json[e] && this.json[e][n];
    return r || console.warn("glTF file error: Could not find ".concat(e, "[").concat(n, "]")), r;
  }
  _resolveScene(e, n) {
    return e.id = e.id || "scene-".concat(n), e.nodes = (e.nodes || []).map((r) => this.getNode(r)), e;
  }
  _resolveNode(e, n) {
    return e.id = e.id || "node-".concat(n), e.children && (e.children = e.children.map((r) => this.getNode(r))), e.mesh !== void 0 ? e.mesh = this.getMesh(e.mesh) : e.meshes !== void 0 && e.meshes.length && (e.mesh = e.meshes.reduce((r, i) => {
      const o = this.getMesh(i);
      return r.id = o.id, r.primitives = r.primitives.concat(o.primitives), r;
    }, {
      primitives: []
    })), e.camera !== void 0 && (e.camera = this.getCamera(e.camera)), e.skin !== void 0 && (e.skin = this.getSkin(e.skin)), e;
  }
  _resolveSkin(e, n) {
    return e.id = e.id || "skin-".concat(n), e.inverseBindMatrices = this.getAccessor(e.inverseBindMatrices), e;
  }
  _resolveMesh(e, n) {
    return e.id = e.id || "mesh-".concat(n), e.primitives && (e.primitives = e.primitives.map((r) => {
      r = {
        ...r
      };
      const i = r.attributes;
      r.attributes = {};
      for (const o in i)
        r.attributes[o] = this.getAccessor(i[o]);
      return r.indices !== void 0 && (r.indices = this.getAccessor(r.indices)), r.material !== void 0 && (r.material = this.getMaterial(r.material)), r;
    })), e;
  }
  _resolveMaterial(e, n) {
    if (e.id = e.id || "material-".concat(n), e.normalTexture && (e.normalTexture = {
      ...e.normalTexture
    }, e.normalTexture.texture = this.getTexture(e.normalTexture.index)), e.occlusionTexture && (e.occlustionTexture = {
      ...e.occlustionTexture
    }, e.occlusionTexture.texture = this.getTexture(e.occlusionTexture.index)), e.emissiveTexture && (e.emmisiveTexture = {
      ...e.emmisiveTexture
    }, e.emissiveTexture.texture = this.getTexture(e.emissiveTexture.index)), e.emissiveFactor || (e.emissiveFactor = e.emmisiveTexture ? [1, 1, 1] : [0, 0, 0]), e.pbrMetallicRoughness) {
      e.pbrMetallicRoughness = {
        ...e.pbrMetallicRoughness
      };
      const r = e.pbrMetallicRoughness;
      r.baseColorTexture && (r.baseColorTexture = {
        ...r.baseColorTexture
      }, r.baseColorTexture.texture = this.getTexture(r.baseColorTexture.index)), r.metallicRoughnessTexture && (r.metallicRoughnessTexture = {
        ...r.metallicRoughnessTexture
      }, r.metallicRoughnessTexture.texture = this.getTexture(r.metallicRoughnessTexture.index));
    }
    return e;
  }
  _resolveAccessor(e, n) {
    if (e.id = e.id || "accessor-".concat(n), e.bufferView !== void 0 && (e.bufferView = this.getBufferView(e.bufferView)), e.bytesPerComponent = zvn(e.componentType), e.components = Vvn(e.type), e.bytesPerElement = e.bytesPerComponent * e.components, e.bufferView) {
      const r = e.bufferView.buffer, {
        ArrayType: i,
        byteLength: o
      } = Vje(e, e.bufferView), s = (e.bufferView.byteOffset || 0) + (e.byteOffset || 0) + r.byteOffset;
      let a = r.arrayBuffer.slice(s, s + o);
      e.bufferView.byteStride && (a = this._getValueFromInterleavedBuffer(r, s, e.bufferView.byteStride, e.bytesPerElement, e.count)), e.value = new i(a);
    }
    return e;
  }
  _getValueFromInterleavedBuffer(e, n, r, i, o) {
    const s = new Uint8Array(o * i);
    for (let a = 0; a < o; a++) {
      const A = n + a * r;
      s.set(new Uint8Array(e.arrayBuffer.slice(A, A + i)), a * i);
    }
    return s.buffer;
  }
  _resolveTexture(e, n) {
    return e.id = e.id || "texture-".concat(n), e.sampler = "sampler" in e ? this.getSampler(e.sampler) : Yvn, e.source = this.getImage(e.source), e;
  }
  _resolveSampler(e, n) {
    e.id = e.id || "sampler-".concat(n), e.parameters = {};
    for (const r in e) {
      const i = this._enumSamplerParameter(r);
      i !== void 0 && (e.parameters[i] = e[r]);
    }
    return e;
  }
  _enumSamplerParameter(e) {
    return jvn[e];
  }
  _resolveImage(e, n) {
    e.id = e.id || "image-".concat(n), e.bufferView !== void 0 && (e.bufferView = this.getBufferView(e.bufferView));
    const r = this.images[n];
    return r && (e.image = r), e;
  }
  _resolveBufferView(e, n) {
    const r = e.buffer, i = {
      id: "bufferView-".concat(n),
      ...e,
      buffer: this.buffers[r]
    }, o = this.buffers[r].arrayBuffer;
    let s = this.buffers[r].byteOffset || 0;
    return "byteOffset" in e && (s += e.byteOffset), i.data = new Uint8Array(o, s, e.byteLength), i;
  }
  _resolveCamera(e, n) {
    return e.id = e.id || "camera-".concat(n), e.perspective, e.orthographic, e;
  }
}
function Kvn(t, e) {
  return new Jvn().postProcess(t, e);
}
const _Qe = 1735152710, Sce = 12, PU = 8, Wvn = 1313821514, Xvn = 5130562, Zvn = 0, eBn = 1, tBn = 0, zS = !0;
function nBn(t, e = 0) {
  return "".concat(String.fromCharCode(t.getUint8(e + 0))).concat(String.fromCharCode(t.getUint8(e + 1))).concat(String.fromCharCode(t.getUint8(e + 2))).concat(String.fromCharCode(t.getUint8(e + 3)));
}
function rBn(t, e = 0, n = {}) {
  const r = new DataView(t), {
    magic: i = _Qe
  } = n, o = r.getUint32(e, !1);
  return o === i || o === _Qe;
}
function iBn(t, e, n = 0, r = {}) {
  const i = new DataView(e), o = nBn(i, n + 0), s = i.getUint32(n + 4, zS), a = i.getUint32(n + 8, zS);
  switch (Object.assign(t, {
    header: {
      byteOffset: n,
      byteLength: a,
      hasBinChunk: !1
    },
    type: o,
    version: s,
    json: {},
    binChunks: []
  }), n += Sce, t.version) {
    case 1:
      return oBn(t, i, n);
    case 2:
      return sBn(t, i, n, r = {});
    default:
      throw new Error("Invalid GLB version ".concat(t.version, ". Only supports v1 and v2."));
  }
}
function oBn(t, e, n) {
  _o(t.header.byteLength > Sce + PU);
  const r = e.getUint32(n + 0, zS), i = e.getUint32(n + 4, zS);
  return n += PU, _o(i === tBn), gte(t, e, n, r), n += r, n += hte(t, e, n, t.header.byteLength), n;
}
function sBn(t, e, n, r) {
  return _o(t.header.byteLength > Sce + PU), aBn(t, e, n, r), n + t.header.byteLength;
}
function aBn(t, e, n, r) {
  for (; n + 8 <= t.header.byteLength; ) {
    const i = e.getUint32(n + 0, zS), o = e.getUint32(n + 4, zS);
    switch (n += PU, o) {
      case Wvn:
        gte(t, e, n, i);
        break;
      case Xvn:
        hte(t, e, n, i);
        break;
      case Zvn:
        r.strict || gte(t, e, n, i);
        break;
      case eBn:
        r.strict || hte(t, e, n, i);
        break;
    }
    n += eM(i, 4);
  }
  return n;
}
function gte(t, e, n, r) {
  const i = new Uint8Array(e.buffer, n, r), s = new TextDecoder("utf8").decode(i);
  return t.json = JSON.parse(s), eM(r, 4);
}
function hte(t, e, n, r) {
  return t.header.hasBinChunk = !0, t.binChunks.push({
    byteOffset: n,
    byteLength: r,
    arrayBuffer: e.buffer
  }), eM(r, 4);
}
async function ABn(t, e, n = 0, r, i) {
  var o, s, a, A;
  lBn(t, e, n, r), Hvn(t, {
    normalize: r == null || (o = r.gltf) === null || o === void 0 ? void 0 : o.normalize
  }), Fvn(t, r, i);
  const l = [];
  if (r != null && (s = r.gltf) !== null && s !== void 0 && s.loadBuffers && t.json.buffers && await cBn(t, r, i), r != null && (a = r.gltf) !== null && a !== void 0 && a.loadImages) {
    const u = uBn(t, r, i);
    l.push(u);
  }
  const c = Pvn(t, r, i);
  return l.push(c), await Promise.all(l), r != null && (A = r.gltf) !== null && A !== void 0 && A.postProcess ? Kvn(t, r) : t;
}
function lBn(t, e, n, r) {
  if (r.uri && (t.baseUri = r.uri), e instanceof ArrayBuffer && !rBn(e, n, r) && (e = new TextDecoder().decode(e)), typeof e == "string")
    t.json = $rn(e);
  else if (e instanceof ArrayBuffer) {
    const s = {};
    n = iBn(s, e, n, r.glb), wf(s.type === "glTF", "Invalid GLB magic string ".concat(s.type)), t._glb = s, t.json = s.json;
  } else
    wf(!1, "GLTF: must be ArrayBuffer or string");
  const i = t.json.buffers || [];
  if (t.buffers = new Array(i.length).fill(null), t._glb && t._glb.header.hasBinChunk) {
    const {
      binChunks: s
    } = t._glb;
    t.buffers[0] = {
      arrayBuffer: s[0].arrayBuffer,
      byteOffset: s[0].byteOffset,
      byteLength: s[0].byteLength
    };
  }
  const o = t.json.images || [];
  t.images = new Array(o.length).fill({});
}
async function cBn(t, e, n) {
  const r = t.json.buffers || [];
  for (let s = 0; s < r.length; ++s) {
    const a = r[s];
    if (a.uri) {
      var i, o;
      const {
        fetch: A
      } = n;
      wf(A);
      const l = jje(a.uri, e), c = await (n == null || (i = n.fetch) === null || i === void 0 ? void 0 : i.call(n, l)), u = await (c == null || (o = c.arrayBuffer) === null || o === void 0 ? void 0 : o.call(c));
      t.buffers[s] = {
        arrayBuffer: u,
        byteOffset: 0,
        byteLength: u.byteLength
      }, delete a.uri;
    } else
      t.buffers[s] === null && (t.buffers[s] = {
        arrayBuffer: new ArrayBuffer(a.byteLength),
        byteOffset: 0,
        byteLength: a.byteLength
      });
  }
}
async function uBn(t, e, n) {
  const r = fBn(t), i = t.json.images || [], o = [];
  for (const s of r)
    o.push(gBn(t, i[s], s, e, n));
  return await Promise.all(o);
}
function fBn(t) {
  const e = /* @__PURE__ */ new Set(), n = t.json.textures || [];
  for (const r of n)
    r.source !== void 0 && e.add(r.source);
  return Array.from(e).sort();
}
async function gBn(t, e, n, r, i) {
  const {
    fetch: o,
    parse: s
  } = i;
  let a;
  if (e.uri && !e.hasOwnProperty("bufferView")) {
    const l = jje(e.uri, r);
    a = await (await o(l)).arrayBuffer();
  }
  if (Number.isFinite(e.bufferView)) {
    const l = syn(t.json, t.buffers, e.bufferView);
    a = lle(l.buffer, l.byteOffset, l.byteLength);
  }
  wf(a, "glTF image has no data");
  let A = await s(a, [dle, oyn], {
    mimeType: e.mimeType,
    basis: r.basis || {
      format: qje()
    }
  }, i);
  A && A[0] && (A = {
    compressed: !0,
    mipmaps: !1,
    width: A[0].width,
    height: A[0].height,
    data: A[0]
  }), t.images = t.images || [], t.images[n] = A;
}
const KT = {
  name: "glTF",
  id: "gltf",
  module: "gltf",
  version: HEn,
  extensions: ["gltf", "glb"],
  mimeTypes: ["model/gltf+json", "model/gltf-binary"],
  text: !0,
  binary: !0,
  tests: ["glTF"],
  parse: hBn,
  options: {
    gltf: {
      normalize: !0,
      loadBuffers: !0,
      loadImages: !0,
      decompressMeshes: !0,
      postProcess: !0
    },
    log: console
  },
  deprecatedOptions: {
    fetchImages: "gltf.loadImages",
    createImages: "gltf.loadImages",
    decompress: "gltf.decompressMeshes",
    postProcess: "gltf.postProcess",
    gltf: {
      decompress: "gltf.decompressMeshes"
    }
  }
};
async function hBn(t, e = {}, n) {
  e = {
    ...KT.options,
    ...e
  }, e.gltf = {
    ...KT.options.gltf,
    ...e.gltf
  };
  const {
    byteOffset: r = 0
  } = e;
  return await ABn({}, t, r, e, n);
}
async function dBn(t) {
  const e = [];
  return t.scenes.forEach((n) => {
    n.traverse((r) => {
      Object.values(r.model.getUniforms()).forEach((i) => {
        i.loaded === !1 && e.push(i);
      });
    });
  }), await pBn(() => e.some((n) => !n.loaded));
}
async function pBn(t) {
  for (; t(); )
    await new Promise((e) => requestAnimationFrame(e));
}
const IBn = `#version 300 es

// Instance attributes
in vec3 instancePositions;
in vec3 instancePositions64Low;
in vec4 instanceColors;
in vec3 instancePickingColors;
in mat3 instanceModelMatrix;
in vec3 instanceTranslation;

// Uniforms
uniform float sizeScale;
uniform float sizeMinPixels;
uniform float sizeMaxPixels;
uniform mat4 sceneModelMatrix;
uniform bool composeModelMatrix;

// Attributes
in vec4 POSITION;

#ifdef HAS_UV
  in vec2 TEXCOORD_0;
#endif

#ifdef MODULE_PBR
  #ifdef HAS_NORMALS
    in vec4 NORMAL;
  #endif
#endif

// Varying
out vec4 vColor;

// MODULE_PBR contains all the varying definitions needed
#ifndef MODULE_PBR
  #ifdef HAS_UV
    out vec2 vTEXCOORD_0;
  #endif
#endif

// Main
void main(void) {
  #if defined(HAS_UV) && !defined(MODULE_PBR)
    vTEXCOORD_0 = TEXCOORD_0;
    geometry.uv = vTEXCOORD_0;
  #endif

  geometry.worldPosition = instancePositions;
  geometry.pickingColor = instancePickingColors;

  vec3 normal = vec3(0.0, 0.0, 1.0);
  #ifdef MODULE_PBR
    #ifdef HAS_NORMALS
      normal = instanceModelMatrix * (sceneModelMatrix * vec4(NORMAL.xyz, 0.0)).xyz;
    #endif
  #endif

  float originalSize = project_size_to_pixel(sizeScale);
  float clampedSize = clamp(originalSize, sizeMinPixels, sizeMaxPixels);

  vec3 pos = (instanceModelMatrix * (sceneModelMatrix * POSITION).xyz) * sizeScale * (clampedSize / originalSize) + instanceTranslation;
  if(composeModelMatrix) {
    DECKGL_FILTER_SIZE(pos, geometry);
    // using instancePositions as world coordinates
    // when using globe mode, this branch does not re-orient the model to align with the surface of the earth
    // call project_normal before setting position to avoid rotation
    geometry.normal = project_normal(normal);
    gl_Position = project_position_to_clipspace(pos + instancePositions, instancePositions64Low, vec3(0.0), geometry.position);
  }
  else {
    pos = project_size(pos);
    DECKGL_FILTER_SIZE(pos, geometry);
    gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, pos, geometry.position);
    geometry.normal = project_normal(normal);
  }
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  #ifdef MODULE_PBR
    // set PBR data
    pbr_vPosition = geometry.position.xyz;
    #ifdef HAS_NORMALS
      pbr_vNormal = geometry.normal;
    #endif

    #ifdef HAS_UV
      pbr_vUV = TEXCOORD_0;
    #else
      pbr_vUV = vec2(0., 0.);
    #endif
    geometry.uv = pbr_vUV;
  #endif

  vColor = instanceColors;
  DECKGL_FILTER_COLOR(vColor, geometry);
}
`, mBn = `#version 300 es

// Uniforms
uniform float opacity;

// Varying
in vec4 vColor;

out vec4 fragmentColor;

// MODULE_PBR contains all the varying definitions needed
#ifndef MODULE_PBR
  #if defined(HAS_UV) && defined(HAS_BASECOLORMAP)
    in vec2 vTEXCOORD_0;
    uniform sampler2D u_BaseColorSampler;
  #endif
#endif

void main(void) {
  #ifdef MODULE_PBR
    fragmentColor = vColor * pbr_filterColor(vec4(0));
    geometry.uv = pbr_vUV;
  #else
    #if defined(HAS_UV) && defined(HAS_BASECOLORMAP)
      fragmentColor = vColor * texture2D(u_BaseColorSampler, vTEXCOORD_0);
      geometry.uv = vTEXCOORD_0;
    #else
      fragmentColor = vColor;
    #endif
  #endif

  fragmentColor.a *= opacity;
  DECKGL_FILTER_COLOR(fragmentColor, geometry);
}
`, AYe = [255, 255, 255, 255], CBn = {
  scenegraph: {
    type: "object",
    value: null,
    async: !0
  },
  getScene: (t) => t && t.scenes ? typeof t.scene == "object" ? t.scene : t.scenes[t.scene || 0] : t,
  getAnimator: (t) => t && t.animator,
  _animations: null,
  sizeScale: {
    type: "number",
    value: 1,
    min: 0
  },
  sizeMinPixels: {
    type: "number",
    min: 0,
    value: 0
  },
  sizeMaxPixels: {
    type: "number",
    min: 0,
    value: Number.MAX_SAFE_INTEGER
  },
  getPosition: {
    type: "accessor",
    value: (t) => t.position
  },
  getColor: {
    type: "accessor",
    value: AYe
  },
  _lighting: "flat",
  _imageBasedLightingEnvironment: null,
  getOrientation: {
    type: "accessor",
    value: [0, 0, 0]
  },
  getScale: {
    type: "accessor",
    value: [1, 1, 1]
  },
  getTranslation: {
    type: "accessor",
    value: [0, 0, 0]
  },
  getTransformMatrix: {
    type: "accessor",
    value: []
  },
  loaders: [KT]
};
class _$ extends IA {
  constructor(...e) {
    super(...e), ae(this, "state", void 0);
  }
  getShaders() {
    const e = [qA, jA];
    return this.props._lighting === "pbr" && e.push(s$), {
      vs: IBn,
      fs: mBn,
      modules: e
    };
  }
  initializeState() {
    this.getAttributeManager().addInstanced({
      instancePositions: {
        size: 3,
        type: 5130,
        fp64: this.use64bitPositions(),
        accessor: "getPosition",
        transition: !0
      },
      instanceColors: {
        type: 5121,
        size: this.props.colorFormat.length,
        accessor: "getColor",
        normalized: !0,
        defaultValue: AYe,
        transition: !0
      },
      instanceModelMatrix: kje
    });
  }
  updateState(e) {
    super.updateState(e);
    const {
      props: n,
      oldProps: r
    } = e;
    n.scenegraph !== r.scenegraph ? this._updateScenegraph() : n._animations !== r._animations && this._applyAnimationsProp(this.state.scenegraph, this.state.animator, n._animations);
  }
  finalizeState(e) {
    super.finalizeState(e), this._deleteScenegraph();
  }
  _updateScenegraph() {
    const e = this.props, {
      gl: n
    } = this.context;
    let r = null;
    if (e.scenegraph instanceof Y_)
      r = {
        scenes: [e.scenegraph]
      };
    else if (e.scenegraph && !e.scenegraph.gltf) {
      const a = e.scenegraph, A = UEn(n, a, this._getModelOptions());
      r = {
        gltf: a,
        ...A
      }, dBn(A).then(() => this.setNeedsRedraw());
    } else
      e.scenegraph && (Rr.deprecated("ScenegraphLayer.props.scenegraph", "Use GLTFLoader instead of GLTFScenegraphLoader")(), r = e.scenegraph);
    const i = {
      layer: this,
      gl: n
    }, o = e.getScene(r, i), s = e.getAnimator(r, i);
    o instanceof Y_ ? (this._deleteScenegraph(), this._applyAllAttributes(o), this._applyAnimationsProp(o, s, e._animations), this.setState({
      scenegraph: o,
      animator: s
    })) : o !== null && Rr.warn("invalid scenegraph:", o)();
  }
  _applyAllAttributes(e) {
    if (this.state.attributesAvailable) {
      const n = this.getAttributeManager().getAttributes();
      e.traverse((r) => {
        this._setModelAttributes(r.model, n);
      });
    }
  }
  _applyAnimationsProp(e, n, r) {
    if (!e || !n || !r)
      return;
    const i = n.getAnimations();
    Object.keys(r).sort().forEach((o) => {
      const s = r[o];
      if (o === "*")
        i.forEach((a) => {
          Object.assign(a, s);
        });
      else if (Number.isFinite(Number(o))) {
        const a = Number(o);
        a >= 0 && a < i.length ? Object.assign(i[a], s) : Rr.warn("animation ".concat(o, " not found"))();
      } else {
        const a = i.find(({
          name: A
        }) => A === o);
        a ? Object.assign(a, s) : Rr.warn("animation ".concat(o, " not found"))();
      }
    });
  }
  _deleteScenegraph() {
    const {
      scenegraph: e
    } = this.state;
    e instanceof Y_ && e.delete();
  }
  _getModelOptions() {
    const {
      _imageBasedLightingEnvironment: e
    } = this.props;
    let n = null;
    return e && (typeof e == "function" ? n = e({
      gl: this.context.gl,
      layer: this
    }) : n = e), {
      gl: this.context.gl,
      waitForFullLoad: !0,
      imageBasedLightingEnvironment: n,
      modelOptions: {
        isInstanced: !0,
        transpileToGLSL100: !Fr(this.context.gl),
        ...this.getShaders()
      },
      useTangents: !1
    };
  }
  updateAttributes(e) {
    this.setState({
      attributesAvailable: !0
    }), this.state.scenegraph && this.state.scenegraph.traverse((n) => {
      this._setModelAttributes(n.model, e);
    });
  }
  draw({
    moduleParameters: e = null,
    parameters: n = {},
    context: r
  }) {
    if (!this.state.scenegraph)
      return;
    this.props._animations && this.state.animator && (this.state.animator.animate(r.timeline.getTime()), this.setNeedsRedraw());
    const {
      viewport: i
    } = this.context, {
      sizeScale: o,
      sizeMinPixels: s,
      sizeMaxPixels: a,
      opacity: A,
      coordinateSystem: l
    } = this.props, c = this.getNumInstances();
    this.state.scenegraph.traverse((u, {
      worldMatrix: f
    }) => {
      u.model.setInstanceCount(c), u.updateModuleSettings(e), u.draw({
        parameters: n,
        uniforms: {
          sizeScale: o,
          opacity: A,
          sizeMinPixels: s,
          sizeMaxPixels: a,
          composeModelMatrix: Gje(i, l),
          sceneModelMatrix: f,
          u_Camera: u.model.getUniforms().project_uCameraPosition
        }
      });
    });
  }
}
ae(_$, "defaultProps", CBn);
ae(_$, "layerName", "ScenegraphLayer");
const EBn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ScenegraphLayer: _$,
  SimpleMeshLayer: YS
}, Symbol.toStringTag, { value: "Module" })), yBn = `#version 300 es
#define SHADER_NAME simple-mesh-layer-vs

// Scale the model
uniform float sizeScale;
uniform bool composeModelMatrix;
uniform bool pickFeatureIds;

// Primitive attributes
in vec3 positions;
in vec3 normals;
in vec3 colors;
in vec2 texCoords;
in vec4 uvRegions;
in vec3 featureIdsPickingColors;

// Instance attributes
in vec4 instanceColors;
in vec3 instancePickingColors;
in mat3 instanceModelMatrix;

// Outputs to fragment shader
out vec2 vTexCoord;
out vec3 cameraPosition;
out vec3 normals_commonspace;
out vec4 position_commonspace;
out vec4 vColor;

vec2 applyUVRegion(vec2 uv) {
  #ifdef HAS_UV_REGIONS
    // https://github.com/Esri/i3s-spec/blob/master/docs/1.7/geometryUVRegion.cmn.md
    return fract(uv) * (uvRegions.zw - uvRegions.xy) + uvRegions.xy;
  #else
    return uv;
  #endif
}

void main(void) {
  vec2 uv = applyUVRegion(texCoords);
  geometry.uv = uv;

  if (pickFeatureIds) {
    geometry.pickingColor = featureIdsPickingColors;
  } else {
    geometry.pickingColor = instancePickingColors;
  }

  vTexCoord = uv;
  cameraPosition = project_uCameraPosition;
  vColor = vec4(colors * instanceColors.rgb, instanceColors.a);

  vec3 pos = (instanceModelMatrix * positions) * sizeScale;
  vec3 projectedPosition = project_position(positions);
  position_commonspace = vec4(projectedPosition, 1.0);
  gl_Position = project_common_position_to_clipspace(position_commonspace);

  geometry.position = position_commonspace;
  normals_commonspace = project_normal(instanceModelMatrix * normals);
  geometry.normal = normals_commonspace;

  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  #ifdef MODULE_PBR
    // set PBR data
    pbr_vPosition = geometry.position.xyz;
    #ifdef HAS_NORMALS
      pbr_vNormal = geometry.normal;
    #endif

    #ifdef HAS_UV
      pbr_vUV = uv;
    #else
      pbr_vUV = vec2(0., 0.);
    #endif
    geometry.uv = pbr_vUV;
  #endif

  DECKGL_FILTER_COLOR(vColor, geometry);
}
`, vBn = `#version 300 es
#define SHADER_NAME simple-mesh-layer-fs

precision highp float;

uniform bool hasTexture;
uniform sampler2D sampler;
uniform bool flatShading;
uniform float opacity;

in vec2 vTexCoord;
in vec3 cameraPosition;
in vec3 normals_commonspace;
in vec4 position_commonspace;
in vec4 vColor;

out vec4 fragColor;

void main(void) {
  
#ifdef MODULE_PBR

  fragColor = vColor * pbr_filterColor(vec4(0));
  geometry.uv = pbr_vUV;
  fragColor.a *= opacity;

#else

  geometry.uv = vTexCoord;

  vec3 normal;
  if (flatShading) {

// NOTE(Tarek): This is necessary because
// headless.gl reports the extension as
// available but does not support it in
// the shader.
#ifdef DERIVATIVES_AVAILABLE
    normal = normalize(cross(dFdx(position_commonspace.xyz), dFdy(position_commonspace.xyz)));
#else
    normal = vec3(0.0, 0.0, 1.0);
#endif
  } else {
    normal = normals_commonspace;
  }

  vec4 color = hasTexture ? texture(sampler, vTexCoord) : vColor;
  vec3 lightColor = lighting_getLightColor(color.rgb, cameraPosition, position_commonspace.xyz, normal);
  fragColor = vec4(lightColor, color.a * opacity);

#endif

  DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
function BBn(t) {
  t.COLOR_0 || t.colors || (t.colors = {
    constant: !0,
    value: new Float32Array([1, 1, 1])
  });
}
const bBn = {
  pbrMaterial: {
    type: "object",
    value: null
  },
  featureIds: {
    type: "array",
    value: null,
    optional: !0
  }
};
class Qce extends YS {
  getShaders() {
    const e = super.getShaders();
    return e.modules.push(s$), {
      ...e,
      vs: yBn,
      fs: vBn
    };
  }
  initializeState() {
    const {
      featureIds: e
    } = this.props;
    super.initializeState();
    const n = this.getAttributeManager();
    e && n.add({
      featureIdsPickingColors: {
        type: 5121,
        size: 3,
        noAlloc: !0,
        update: this.calculateFeatureIdsPickingColors
      }
    });
  }
  updateState(e) {
    super.updateState(e);
    const {
      props: n,
      oldProps: r
    } = e;
    n.pbrMaterial !== r.pbrMaterial && this.updatePbrMaterialUniforms(n.pbrMaterial);
  }
  draw(e) {
    const {
      featureIds: n
    } = this.props;
    this.state.model && (this.state.model.setUniforms({
      u_Camera: this.state.model.getUniforms().project_uCameraPosition,
      pickFeatureIds: !!n
    }), super.draw(e));
  }
  getModel(e) {
    const {
      id: n,
      pbrMaterial: r
    } = this.props, i = this.parseMaterial(r, e);
    this.setState({
      materialParser: i
    });
    const o = this.getShaders();
    return BBn(e.attributes), new Ta(this.context.gl, {
      ...this.getShaders(),
      id: n,
      geometry: e,
      defines: {
        ...o.defines,
        ...i?.defines,
        HAS_UV_REGIONS: e.attributes.uvRegions
      },
      parameters: i?.parameters,
      isInstanced: !0
    });
  }
  updatePbrMaterialUniforms(e) {
    const {
      model: n
    } = this.state;
    if (n) {
      const {
        mesh: r
      } = this.props, i = this.parseMaterial(e, r);
      this.setState({
        materialParser: i
      }), n.setUniforms(i.uniforms);
    }
  }
  parseMaterial(e, n) {
    var r;
    const i = !!(e.pbrMetallicRoughness && e.pbrMetallicRoughness.baseColorTexture);
    return (r = this.state.materialParser) === null || r === void 0 || r.delete(), new Uje(this.context.gl, {
      attributes: {
        NORMAL: n.attributes.normals,
        TEXCOORD_0: n.attributes.texCoords
      },
      material: {
        unlit: i,
        ...e
      },
      pbrDebug: !1,
      imageBasedLightingEnvironment: null,
      lights: !0,
      useTangents: !1
    });
  }
  calculateFeatureIdsPickingColors(e) {
    const n = this.props.featureIds, r = new Uint8ClampedArray(n.length * e.size), i = [];
    for (let o = 0; o < n.length; o++)
      this.encodePickingColor(n[o], i), r[o * 3] = i[0], r[o * 3 + 1] = i[1], r[o * 3 + 2] = i[2];
    e.value = r;
  }
  finalizeState(e) {
    var n;
    super.finalizeState(e), (n = this.state.materialParser) === null || n === void 0 || n.delete(), this.setState({
      materialParser: null
    });
  }
}
ae(Qce, "layerName", "MeshLayer");
ae(Qce, "defaultProps", bBn);
const _Bn = 6378137, SBn = 6378137, QBn = 6356752314245179e-9;
function S$(t) {
  return t;
}
new ct();
function wBn(t, e = [], n = S$) {
  return "longitude" in t ? (e[0] = n(t.longitude), e[1] = n(t.latitude), e[2] = t.height) : "x" in t ? (e[0] = n(t.x), e[1] = n(t.y), e[2] = t.z) : (e[0] = n(t[0]), e[1] = n(t[1]), e[2] = t[2]), e;
}
function xBn(t, e = []) {
  return wBn(t, e, $o._cartographicRadians ? S$ : f$e);
}
function RBn(t, e, n = S$) {
  return "longitude" in e ? (e.longitude = n(t[0]), e.latitude = n(t[1]), e.height = t[2]) : "x" in e ? (e.x = n(t[0]), e.y = n(t[1]), e.z = t[2]) : (e[0] = n(t[0]), e[1] = n(t[1]), e[2] = t[2]), e;
}
function DBn(t, e) {
  return RBn(t, e, $o._cartographicRadians ? S$ : g$e);
}
const cb = new ct(), TBn = new ct(), NBn = new ct();
function LBn(t, e, n = []) {
  const {
    oneOverRadii: r,
    oneOverRadiiSquared: i,
    centerToleranceSquared: o
  } = e;
  cb.from(t);
  const s = cb.x, a = cb.y, A = cb.z, l = r.x, c = r.y, u = r.z, f = s * s * l * l, h = a * a * c * c, d = A * A * u * u, I = f + h + d, m = Math.sqrt(1 / I);
  if (!Number.isFinite(m))
    return;
  const C = TBn;
  if (C.copy(t).scale(m), I < o)
    return C.to(n);
  const y = i.x, v = i.y, b = i.z, Q = NBn;
  Q.set(C.x * y * 2, C.y * v * 2, C.z * b * 2);
  let w = (1 - m) * cb.len() / (0.5 * Q.len()), R = 0, M, O, L, N;
  do {
    w -= R, M = 1 / (1 + w * y), O = 1 / (1 + w * v), L = 1 / (1 + w * b);
    const k = M * M, $ = O * O, U = L * L, X = k * M, K = $ * O, z = U * L;
    N = f * k + h * $ + d * U - 1;
    const V = -2 * (f * X * y + h * K * v + d * z * b);
    R = N / V;
  } while (Math.abs(N) > $S.EPSILON12);
  return cb.scale([M, O, L]).to(n);
}
const SQe = 1e-14, MBn = new ct(), QQe = {
  up: {
    south: "east",
    north: "west",
    west: "south",
    east: "north"
  },
  down: {
    south: "west",
    north: "east",
    west: "north",
    east: "south"
  },
  south: {
    up: "west",
    down: "east",
    west: "down",
    east: "up"
  },
  north: {
    up: "east",
    down: "west",
    west: "up",
    east: "down"
  },
  west: {
    up: "north",
    down: "south",
    north: "down",
    south: "up"
  },
  east: {
    up: "south",
    down: "north",
    north: "up",
    south: "down"
  }
}, kV = {
  north: [-1, 0, 0],
  east: [0, 1, 0],
  up: [0, 0, 1],
  south: [1, 0, 0],
  west: [0, -1, 0],
  down: [0, 0, -1]
}, d2 = {
  east: new ct(),
  north: new ct(),
  up: new ct(),
  west: new ct(),
  south: new ct(),
  down: new ct()
}, OBn = new ct(), FBn = new ct(), PBn = new ct();
function wQe(t, e, n, r, i, o) {
  const s = QQe[e] && QQe[e][n];
  bf(s && (!r || r === s));
  let a, A, l;
  const c = MBn.copy(i);
  if (ul(c.x, 0, SQe) && ul(c.y, 0, SQe)) {
    const f = Math.sign(c.z);
    a = OBn.fromArray(kV[e]), e !== "east" && e !== "west" && a.scale(f), A = FBn.fromArray(kV[n]), n !== "east" && n !== "west" && A.scale(f), l = PBn.fromArray(kV[r]), r !== "east" && r !== "west" && l.scale(f);
  } else {
    const {
      up: f,
      east: h,
      north: d
    } = d2;
    h.set(-c.y, c.x, 0).normalize(), t.geodeticSurfaceNormal(c, f), d.copy(f).cross(h);
    const {
      down: I,
      west: m,
      south: C
    } = d2;
    I.copy(f).scale(-1), m.copy(h).scale(-1), C.copy(d).scale(-1), a = d2[e], A = d2[n], l = d2[r];
  }
  return o[0] = a.x, o[1] = a.y, o[2] = a.z, o[3] = 0, o[4] = A.x, o[5] = A.y, o[6] = A.z, o[7] = 0, o[8] = l.x, o[9] = l.y, o[10] = l.z, o[11] = 0, o[12] = c.x, o[13] = c.y, o[14] = c.z, o[15] = 1, o;
}
const dP = new ct(), xQe = new ct(), kBn = new ct(), mh = new ct(), GBn = new ct(), pP = new ct();
class uA {
  constructor(e = 0, n = 0, r = 0) {
    ae(this, "radii", void 0), ae(this, "radiiSquared", void 0), ae(this, "radiiToTheFourth", void 0), ae(this, "oneOverRadii", void 0), ae(this, "oneOverRadiiSquared", void 0), ae(this, "minimumRadius", void 0), ae(this, "maximumRadius", void 0), ae(this, "centerToleranceSquared", $S.EPSILON1), ae(this, "squaredXOverSquaredZ", void 0), bf(e >= 0), bf(n >= 0), bf(r >= 0), this.radii = new ct(e, n, r), this.radiiSquared = new ct(e * e, n * n, r * r), this.radiiToTheFourth = new ct(e * e * e * e, n * n * n * n, r * r * r * r), this.oneOverRadii = new ct(e === 0 ? 0 : 1 / e, n === 0 ? 0 : 1 / n, r === 0 ? 0 : 1 / r), this.oneOverRadiiSquared = new ct(e === 0 ? 0 : 1 / (e * e), n === 0 ? 0 : 1 / (n * n), r === 0 ? 0 : 1 / (r * r)), this.minimumRadius = Math.min(e, n, r), this.maximumRadius = Math.max(e, n, r), this.radiiSquared.z !== 0 && (this.squaredXOverSquaredZ = this.radiiSquared.x / this.radiiSquared.z), Object.freeze(this);
  }
  equals(e) {
    return this === e || !!(e && this.radii.equals(e.radii));
  }
  toString() {
    return this.radii.toString();
  }
  cartographicToCartesian(e, n = [0, 0, 0]) {
    const r = xQe, i = kBn, [, , o] = e;
    this.geodeticSurfaceNormalCartographic(e, r), i.copy(this.radiiSquared).scale(r);
    const s = Math.sqrt(r.dot(i));
    return i.scale(1 / s), r.scale(o), i.add(r), i.to(n);
  }
  cartesianToCartographic(e, n = [0, 0, 0]) {
    pP.from(e);
    const r = this.scaleToGeodeticSurface(pP, mh);
    if (!r)
      return;
    const i = this.geodeticSurfaceNormal(r, xQe), o = GBn;
    o.copy(pP).subtract(r);
    const s = Math.atan2(i.y, i.x), a = Math.asin(i.z), A = Math.sign(Nle(o, pP)) * Tle(o);
    return DBn([s, a, A], n);
  }
  eastNorthUpToFixedFrame(e, n = new pn()) {
    return wQe(this, "east", "north", "up", e, n);
  }
  localFrameToFixedFrame(e, n, r, i, o = new pn()) {
    return wQe(this, e, n, r, i, o);
  }
  geocentricSurfaceNormal(e, n = [0, 0, 0]) {
    return dP.from(e).normalize().to(n);
  }
  geodeticSurfaceNormalCartographic(e, n = [0, 0, 0]) {
    const r = xBn(e), i = r[0], o = r[1], s = Math.cos(o);
    return dP.set(s * Math.cos(i), s * Math.sin(i), Math.sin(o)).normalize(), dP.to(n);
  }
  geodeticSurfaceNormal(e, n = [0, 0, 0]) {
    return dP.from(e).scale(this.oneOverRadiiSquared).normalize().to(n);
  }
  scaleToGeodeticSurface(e, n) {
    return LBn(e, this, n);
  }
  scaleToGeocentricSurface(e, n = [0, 0, 0]) {
    mh.from(e);
    const r = mh.x, i = mh.y, o = mh.z, s = this.oneOverRadiiSquared, a = 1 / Math.sqrt(r * r * s.x + i * i * s.y + o * o * s.z);
    return mh.multiplyScalar(a).to(n);
  }
  transformPositionToScaledSpace(e, n = [0, 0, 0]) {
    return mh.from(e).scale(this.oneOverRadii).to(n);
  }
  transformPositionFromScaledSpace(e, n = [0, 0, 0]) {
    return mh.from(e).scale(this.radii).to(n);
  }
  getSurfaceNormalIntersectionWithZAxis(e, n = 0, r = [0, 0, 0]) {
    bf(ul(this.radii.x, this.radii.y, $S.EPSILON15)), bf(this.radii.z > 0), mh.from(e);
    const i = mh.z * (1 - this.squaredXOverSquaredZ);
    if (!(Math.abs(i) >= this.radii.z - n))
      return mh.set(0, 0, i).to(r);
  }
}
ae(uA, "WGS84", new uA(_Bn, SBn, QBn));
class UBn {
  constructor(e, n, r) {
    ae(this, "item", void 0), ae(this, "previous", void 0), ae(this, "next", void 0), this.item = e, this.previous = n, this.next = r;
  }
}
class HBn {
  constructor() {
    ae(this, "head", null), ae(this, "tail", null), ae(this, "_length", 0);
  }
  get length() {
    return this._length;
  }
  add(e) {
    const n = new UBn(e, this.tail, null);
    return this.tail ? (this.tail.next = n, this.tail = n) : (this.head = n, this.tail = n), ++this._length, n;
  }
  remove(e) {
    e && (e.previous && e.next ? (e.previous.next = e.next, e.next.previous = e.previous) : e.previous ? (e.previous.next = null, this.tail = e.previous) : e.next ? (e.next.previous = null, this.head = e.next) : (this.head = null, this.tail = null), e.next = null, e.previous = null, --this._length);
  }
  splice(e, n) {
    e !== n && (this.remove(n), this._insert(e, n));
  }
  _insert(e, n) {
    const r = e.next;
    e.next = n, this.tail === e ? this.tail = n : r.previous = n, n.next = r, n.previous = e, ++this._length;
  }
}
function GV(t) {
  return t != null;
}
class $Bn {
  constructor() {
    ae(this, "_list", void 0), ae(this, "_sentinel", void 0), ae(this, "_trimTiles", void 0), this._list = new HBn(), this._sentinel = this._list.add("sentinel"), this._trimTiles = !1;
  }
  reset() {
    this._list.splice(this._list.tail, this._sentinel);
  }
  touch(e) {
    const n = e._cacheNode;
    GV(n) && this._list.splice(this._sentinel, n);
  }
  add(e, n, r) {
    GV(n._cacheNode) || (n._cacheNode = this._list.add(n), r && r(e, n));
  }
  unloadTile(e, n, r) {
    const i = n._cacheNode;
    GV(i) && (this._list.remove(i), n._cacheNode = void 0, r && r(e, n));
  }
  unloadTiles(e, n) {
    const r = this._trimTiles;
    this._trimTiles = !1;
    const i = this._list, o = e.maximumMemoryUsage * 1024 * 1024, s = this._sentinel;
    let a = i.head;
    for (; a !== s && (e.gpuMemoryUsageInBytes > o || r); ) {
      const A = a.item;
      a = a.next, this.unloadTile(e, A, n);
    }
  }
  trim() {
    this._trimTiles = !0;
  }
}
function qBn(t, e) {
  _o(t), _o(e);
  const {
    rtcCenter: n,
    gltfUpAxis: r
  } = e, {
    computedTransform: i,
    boundingVolume: {
      center: o
    }
  } = t;
  let s = new pn(i);
  switch (n && s.translate(n), r) {
    case "Z":
      break;
    case "Y":
      const u = new pn().rotateX(Math.PI / 2);
      s = s.multiplyRight(u);
      break;
    case "X":
      const f = new pn().rotateY(-Math.PI / 2);
      s = s.multiplyRight(f);
      break;
  }
  e.isQuantized && s.translate(e.quantizedVolumeOffset).scale(e.quantizedVolumeScale);
  const a = new ct(o);
  e.cartesianModelMatrix = s, e.cartesianOrigin = a;
  const A = uA.WGS84.cartesianToCartographic(a, new ct()), c = uA.WGS84.eastNorthUpToFixedFrame(a).invert();
  e.cartographicModelMatrix = c.multiplyRight(s), e.cartographicOrigin = A, e.coordinateSystem || (e.modelMatrix = e.cartographicModelMatrix);
}
const RQe = new ct(), UV = new ct(), dte = new Qf([new Ef(), new Ef(), new Ef(), new Ef(), new Ef(), new Ef()]);
function jBn(t, e) {
  const {
    cameraDirection: n,
    cameraUp: r,
    height: i
  } = t, {
    metersPerUnit: o
  } = t.distanceScales, s = Hk(t, t.center), a = uA.WGS84.eastNorthUpToFixedFrame(s), A = t.unprojectPosition(t.cameraPosition), l = uA.WGS84.cartographicToCartesian(A, new ct()), c = new ct(a.transformAsVector(new ct(n).scale(o))).normalize(), u = new ct(a.transformAsVector(new ct(r).scale(o))).normalize();
  zBn(t);
  const f = t.constructor, {
    longitude: h,
    latitude: d,
    width: I,
    bearing: m,
    zoom: C
  } = t, y = new f({
    longitude: h,
    latitude: d,
    height: i,
    width: I,
    bearing: m,
    zoom: C,
    pitch: 0
  });
  return {
    camera: {
      position: l,
      direction: c,
      up: u
    },
    viewport: t,
    topDownViewport: y,
    height: i,
    cullingVolume: dte,
    frameNumber: e,
    sseDenominator: 1.15
  };
}
function YBn(t, e, n) {
  if (n === 0 || t.length <= n)
    return [t, []];
  const r = [], {
    longitude: i,
    latitude: o
  } = e.viewport;
  for (const [l, c] of t.entries()) {
    const [u, f] = c.header.mbs, h = Math.abs(i - u), d = Math.abs(o - f), I = Math.sqrt(d * d + h * h);
    r.push([l, I]);
  }
  const s = r.sort((l, c) => l[1] - c[1]), a = [];
  for (let l = 0; l < n; l++)
    a.push(t[s[l][0]]);
  const A = [];
  for (let l = n; l < s.length; l++)
    A.push(t[s[l][0]]);
  return [a, A];
}
function zBn(t) {
  const e = t.getFrustumPlanes(), n = DQe(e.near, t.cameraPosition), r = Hk(t, n), i = Hk(t, t.cameraPosition, UV);
  let o = 0;
  dte.planes[o++].fromPointNormal(r, RQe.copy(r).subtract(i));
  for (const s in e) {
    if (s === "near")
      continue;
    const a = e[s], A = DQe(a, n, UV), l = Hk(t, A, UV);
    dte.planes[o++].fromPointNormal(l, RQe.copy(r).subtract(l));
  }
}
function DQe(t, e, n = new ct()) {
  const r = t.normal.dot(e);
  return n.copy(t.normal).scale(t.distance - r).add(e), n;
}
function Hk(t, e, n = new ct()) {
  const r = t.unprojectPosition(e);
  return uA.WGS84.cartographicToCartesian(r, n);
}
const VBn = 6378137, JBn = 6378137, pte = 6356752314245179e-9, TQe = new ct();
function KBn(t, e) {
  if (t instanceof vM) {
    const {
      halfAxes: n
    } = t, r = XBn(n);
    return Math.log2(pte / (r + e[2]));
  } else if (t instanceof yM) {
    const {
      radius: n
    } = t;
    return Math.log2(pte / (n + e[2]));
  } else if (t.width && t.height) {
    const {
      width: n,
      height: r
    } = t, i = Math.log2(VBn / n), o = Math.log2(JBn / r);
    return (i + o) / 2;
  }
  return 1;
}
function lYe(t, e, n) {
  const r = uA.WGS84.cartographicToCartesian([t.xmax, t.ymax, t.zmax], new ct()), i = Math.sqrt(Math.pow(r[0] - n[0], 2) + Math.pow(r[1] - n[1], 2) + Math.pow(r[2] - n[2], 2));
  return Math.log2(pte / (i + e[2]));
}
function WBn(t, e, n) {
  const [r, i, o, s] = t;
  return lYe({
    xmin: r,
    xmax: o,
    ymin: i,
    ymax: s,
    zmin: 0,
    zmax: 0
  }, e, n);
}
function XBn(t) {
  t.getColumn(0, TQe);
  const e = t.getColumn(1), n = t.getColumn(2);
  return TQe.add(e).add(n).len();
}
const cf = {
  UNLOADED: 0,
  LOADING: 1,
  PROCESSING: 2,
  READY: 3,
  EXPIRED: 4,
  FAILED: 5
}, CI = {
  ADD: 1,
  REPLACE: 2
}, z_ = {
  EMPTY: "empty",
  SCENEGRAPH: "scenegraph",
  POINTCLOUD: "pointcloud",
  MESH: "mesh"
}, Ap = {
  I3S: "I3S",
  TILES3D: "TILES3D"
}, Q$ = {
  GEOMETRIC_ERROR: "geometricError",
  MAX_SCREEN_THRESHOLD: "maxScreenThreshold"
}, ZBn = {
  NOT_COMPUTED: -1,
  USE_OPTIMIZATION: 1,
  SKIP_OPTIMIZATION: 0
};
function cYe(t) {
  return t != null;
}
const e1n = new ct(), t1n = new ct(), n1n = new ct();
function HV(t, e, n) {
  if (_o(t, "3D Tile: boundingVolume must be defined"), t.box)
    return r1n(t.box, e, n);
  if (t.region) {
    const [r, i, o, s, a, A] = t.region, l = uA.WGS84.cartographicToCartesian([pg(r), pg(s), a], t1n), c = uA.WGS84.cartographicToCartesian([pg(o), pg(i), A], n1n), u = new ct().addVectors(l, c).multiplyScalar(0.5), f = new ct().subVectors(l, c).len() / 2;
    return NQe([u[0], u[1], u[2], f], new pn());
  }
  if (t.sphere)
    return NQe(t.sphere, e, n);
  throw new Error("3D Tile: boundingVolume must contain a sphere, region, or box");
}
function r1n(t, e, n) {
  const r = new ct(t[0], t[1], t[2]);
  e.transform(r, r);
  let i = [];
  if (t.length === 10) {
    const l = t.slice(3, 6), c = new VC();
    c.fromArray(t, 6);
    const u = new ct([1, 0, 0]), f = new ct([0, 1, 0]), h = new ct([0, 0, 1]);
    u.transformByQuaternion(c), u.scale(l[0]), f.transformByQuaternion(c), f.scale(l[1]), h.transformByQuaternion(c), h.scale(l[2]), i = [...u.toArray(), ...f.toArray(), ...h.toArray()];
  } else
    i = [...t.slice(3, 6), ...t.slice(6, 9), ...t.slice(9, 12)];
  const o = e.transformAsVector(i.slice(0, 3)), s = e.transformAsVector(i.slice(3, 6)), a = e.transformAsVector(i.slice(6, 9)), A = new ja([o[0], o[1], o[2], s[0], s[1], s[2], a[0], a[1], a[2]]);
  return cYe(n) ? (n.center = r, n.halfAxes = A, n) : new vM(r, A);
}
function NQe(t, e, n) {
  const r = new ct(t[0], t[1], t[2]);
  e.transform(r, r);
  const i = e.getScale(e1n), o = Math.max(Math.max(i[0], i[1]), i[2]), s = t[3] * o;
  return cYe(n) ? (n.center = r, n.radius = s, n) : new yM(r, s);
}
new ct();
new ct();
new pn();
new ct();
new ct();
new ct();
function i1n(t, e) {
  const n = t * e;
  return 1 - Math.exp(-(n * n));
}
function o1n(t, e) {
  if (t.dynamicScreenSpaceError && t.dynamicScreenSpaceErrorComputedDensity) {
    const n = t.dynamicScreenSpaceErrorComputedDensity, r = t.dynamicScreenSpaceErrorFactor;
    return i1n(e, n) * r;
  }
  return 0;
}
function s1n(t, e, n) {
  const r = t.tileset, i = t.parent && t.parent.lodMetricValue || t.lodMetricValue, o = n ? i : t.lodMetricValue;
  if (o === 0)
    return 0;
  const s = Math.max(t._distanceToCamera, 1e-7), {
    height: a,
    sseDenominator: A
  } = e, {
    viewDistanceScale: l
  } = r.options;
  let c = o * a * (l || 1) / (s * A);
  return c -= o1n(r, s), c;
}
const $V = new ct(), LQe = new ct(), Nm = new ct(), MQe = new ct(), a1n = new ct(), qV = new pn(), OQe = new pn();
function A1n(t, e) {
  if (t.lodMetricValue === 0 || isNaN(t.lodMetricValue))
    return "DIG";
  const n = 2 * uYe(t, e);
  return n < 2 ? "OUT" : !t.header.children || n <= t.lodMetricValue ? "DRAW" : t.header.children ? "DIG" : "OUT";
}
function uYe(t, e) {
  const {
    topDownViewport: n
  } = e, r = t.header.mbs[1], i = t.header.mbs[0], o = t.header.mbs[2], s = t.header.mbs[3], a = [...t.boundingVolume.center], A = n.unprojectPosition(n.cameraPosition);
  uA.WGS84.cartographicToCartesian(A, $V), LQe.copy($V).subtract(a).normalize(), uA.WGS84.eastNorthUpToFixedFrame(a, qV), OQe.copy(qV).invert(), Nm.copy($V).transform(OQe);
  const l = Math.sqrt(Nm[0] * Nm[0] + Nm[1] * Nm[1]), c = l * l / Nm[2];
  MQe.copy([Nm[0], Nm[1], c]);
  const f = MQe.transform(qV).subtract(a).normalize(), d = LQe.cross(f).normalize().scale(s).add(a), I = uA.WGS84.cartesianToCartographic(d), m = n.project([i, r, o]), C = n.project(I);
  return a1n.copy(m).subtract(C).magnitude();
}
function l1n(t) {
  return {
    assetGltfUpAxis: t.asset && t.asset.gltfUpAxis || "Y"
  };
}
class FQe {
  constructor(e = 0) {
    ae(this, "_map", /* @__PURE__ */ new Map()), ae(this, "_array", void 0), ae(this, "_length", void 0), this._array = new Array(e), this._length = e;
  }
  get length() {
    return this._length;
  }
  set length(e) {
    this._length = e, e > this._array.length && (this._array.length = e);
  }
  get values() {
    return this._array;
  }
  get(e) {
    return _o(e < this._array.length), this._array[e];
  }
  set(e, n) {
    _o(e >= 0), e >= this.length && (this.length = e + 1), this._map.has(this._array[e]) && this._map.delete(this._array[e]), this._array[e] = n, this._map.set(n, e);
  }
  delete(e) {
    const n = this._map.get(e);
    n >= 0 && (this._array.splice(n, 1), this._map.delete(e), this.length--);
  }
  peek() {
    return this._array[this._length - 1];
  }
  push(e) {
    if (!this._map.has(e)) {
      const n = this.length++;
      this._array[n] = e, this._map.set(e, n);
    }
  }
  pop() {
    const e = this._array[--this.length];
    return this._map.delete(e), e;
  }
  reserve(e) {
    _o(e >= 0), e > this._array.length && (this._array.length = e);
  }
  resize(e) {
    _o(e >= 0), this.length = e;
  }
  trim(e) {
    e == null && (e = this.length), this._array.length = e;
  }
  reset() {
    this._array = [], this._map = /* @__PURE__ */ new Map(), this._length = 0;
  }
  find(e) {
    return this._map.has(e);
  }
}
const c1n = {
  loadSiblings: !1,
  skipLevelOfDetail: !1,
  maximumScreenSpaceError: 2,
  updateTransforms: !0,
  onTraversalEnd: () => {
  },
  viewportTraversersMap: {},
  basePath: ""
};
class w$ {
  traversalFinished(e) {
    return !0;
  }
  constructor(e) {
    ae(this, "options", void 0), ae(this, "root", void 0), ae(this, "requestedTiles", void 0), ae(this, "selectedTiles", void 0), ae(this, "emptyTiles", void 0), ae(this, "lastUpdate", (/* @__PURE__ */ new Date()).getTime()), ae(this, "updateDebounceTime", 1e3), ae(this, "_traversalStack", void 0), ae(this, "_emptyTraversalStack", void 0), ae(this, "_frameNumber", void 0), this.options = {
      ...c1n,
      ...e
    }, this._traversalStack = new FQe(), this._emptyTraversalStack = new FQe(), this._frameNumber = null, this.root = null, this.selectedTiles = {}, this.requestedTiles = {}, this.emptyTiles = {};
  }
  traverse(e, n, r) {
    this.root = e, this.options = {
      ...this.options,
      ...r
    }, this.reset(), this.updateTile(e, n), this._frameNumber = n.frameNumber, this.executeTraversal(e, n);
  }
  reset() {
    this.requestedTiles = {}, this.selectedTiles = {}, this.emptyTiles = {}, this._traversalStack.reset(), this._emptyTraversalStack.reset();
  }
  executeTraversal(e, n) {
    const r = this._traversalStack;
    for (e._selectionDepth = 1, r.push(e); r.length > 0; ) {
      const o = r.pop();
      let s = !1;
      this.canTraverse(o, n) && (this.updateChildTiles(o, n), s = this.updateAndPushChildren(o, n, r, o.hasRenderContent ? o._selectionDepth + 1 : o._selectionDepth));
      const a = o.parent, A = !!(!a || a._shouldRefine), l = !s;
      o.hasRenderContent ? o.refine === CI.ADD ? (this.loadTile(o, n), this.selectTile(o, n)) : o.refine === CI.REPLACE && (this.loadTile(o, n), l && this.selectTile(o, n)) : (this.emptyTiles[o.id] = o, this.loadTile(o, n), l && this.selectTile(o, n)), this.touchTile(o, n), o._shouldRefine = s && A;
    }
    const i = (/* @__PURE__ */ new Date()).getTime();
    (this.traversalFinished(n) || i - this.lastUpdate > this.updateDebounceTime) && (this.lastUpdate = i, this.options.onTraversalEnd(n));
  }
  updateChildTiles(e, n) {
    const r = e.children;
    for (const i of r)
      this.updateTile(i, n);
    return !0;
  }
  updateAndPushChildren(e, n, r, i) {
    const {
      loadSiblings: o,
      skipLevelOfDetail: s
    } = this.options, a = e.children;
    a.sort(this.compareDistanceToCamera.bind(this));
    const A = e.refine === CI.REPLACE && e.hasRenderContent && !s;
    let l = !1, c = !0;
    for (const u of a)
      if (u._selectionDepth = i, u.isVisibleAndInRequestVolume ? (r.find(u) && r.delete(u), r.push(u), l = !0) : (A || o) && (this.loadTile(u, n), this.touchTile(u, n)), A) {
        let f;
        if (u._inRequestVolume ? u.hasRenderContent ? f = u.contentAvailable : f = this.executeEmptyTraversal(u, n) : f = !1, c = c && f, !c)
          return !1;
      }
    return l || (c = !1), c;
  }
  updateTile(e, n) {
    this.updateTileVisibility(e, n);
  }
  selectTile(e, n) {
    this.shouldSelectTile(e) && (e._selectedFrame = n.frameNumber, this.selectedTiles[e.id] = e);
  }
  loadTile(e, n) {
    this.shouldLoadTile(e) && (e._requestedFrame = n.frameNumber, e._priority = e._getPriority(), this.requestedTiles[e.id] = e);
  }
  touchTile(e, n) {
    e.tileset._cache.touch(e), e._touchedFrame = n.frameNumber;
  }
  canTraverse(e, n, r = !1, i = !1) {
    return e.hasChildren ? e.hasTilesetContent ? !e.contentExpired : !i && !e.isVisibleAndInRequestVolume ? !1 : this.shouldRefine(e, n, r) : !1;
  }
  shouldLoadTile(e) {
    return e.hasUnloadedContent || e.contentExpired;
  }
  shouldSelectTile(e) {
    return e.contentAvailable && !this.options.skipLevelOfDetail;
  }
  shouldRefine(e, n, r) {
    let i = e._screenSpaceError;
    return r && (i = e.getScreenSpaceError(n, !0)), i > this.options.maximumScreenSpaceError;
  }
  updateTileVisibility(e, n) {
    const r = [];
    if (this.options.viewportTraversersMap)
      for (const i in this.options.viewportTraversersMap)
        this.options.viewportTraversersMap[i] === n.viewport.id && r.push(i);
    else
      r.push(n.viewport.id);
    e.updateVisibility(n, r);
  }
  compareDistanceToCamera(e, n) {
    return e._distanceToCamera - n._distanceToCamera;
  }
  anyChildrenVisible(e, n) {
    let r = !1;
    for (const i of e.children)
      i.updateVisibility(n), r = r || i.isVisibleAndInRequestVolume;
    return r;
  }
  executeEmptyTraversal(e, n) {
    let r = !0;
    const i = this._emptyTraversalStack;
    for (i.push(e); i.length > 0 && r; ) {
      const o = i.pop();
      if (this.updateTile(o, n), o.isVisibleAndInRequestVolume || this.loadTile(o, n), this.touchTile(o, n), !o.hasRenderContent && this.canTraverse(o, n, !1, !0)) {
        const a = o.children;
        for (const A of a)
          i.find(A) && i.delete(A), i.push(A);
      } else
        o.contentAvailable || (r = !1);
    }
    return r;
  }
}
const PQe = new ct();
function u1n(t) {
  return t != null;
}
class Ite {
  constructor(e, n, r, i = "") {
    ae(this, "tileset", void 0), ae(this, "header", void 0), ae(this, "id", void 0), ae(this, "url", void 0), ae(this, "parent", void 0), ae(this, "refine", void 0), ae(this, "type", void 0), ae(this, "contentUrl", void 0), ae(this, "lodMetricType", void 0), ae(this, "lodMetricValue", void 0), ae(this, "boundingVolume", void 0), ae(this, "content", void 0), ae(this, "contentState", void 0), ae(this, "gpuMemoryUsageInBytes", void 0), ae(this, "children", void 0), ae(this, "depth", void 0), ae(this, "viewportIds", void 0), ae(this, "transform", void 0), ae(this, "extensions", void 0), ae(this, "userData", void 0), ae(this, "computedTransform", void 0), ae(this, "hasEmptyContent", void 0), ae(this, "hasTilesetContent", void 0), ae(this, "traverser", void 0), ae(this, "_cacheNode", void 0), ae(this, "_frameNumber", void 0), ae(this, "_lodJudge", void 0), ae(this, "_expireDate", void 0), ae(this, "_expiredContent", void 0), ae(this, "_shouldRefine", void 0), ae(this, "_distanceToCamera", void 0), ae(this, "_centerZDepth", void 0), ae(this, "_screenSpaceError", void 0), ae(this, "_visibilityPlaneMask", void 0), ae(this, "_visible", void 0), ae(this, "_inRequestVolume", void 0), ae(this, "_stackLength", void 0), ae(this, "_selectionDepth", void 0), ae(this, "_touchedFrame", void 0), ae(this, "_visitedFrame", void 0), ae(this, "_selectedFrame", void 0), ae(this, "_requestedFrame", void 0), ae(this, "_priority", void 0), ae(this, "_contentBoundingVolume", void 0), ae(this, "_viewerRequestVolume", void 0), ae(this, "_initialTransform", void 0), this.header = n, this.tileset = e, this.id = i || n.id, this.url = n.url, this.parent = r, this.refine = this._getRefine(n.refine), this.type = n.type, this.contentUrl = n.contentUrl, this.lodMetricType = "geometricError", this.lodMetricValue = 0, this.boundingVolume = null, this.content = null, this.contentState = cf.UNLOADED, this.gpuMemoryUsageInBytes = 0, this.children = [], this.hasEmptyContent = !1, this.hasTilesetContent = !1, this.depth = 0, this.viewportIds = [], this.userData = {}, this.extensions = null, this._priority = 0, this._touchedFrame = 0, this._visitedFrame = 0, this._selectedFrame = 0, this._requestedFrame = 0, this._screenSpaceError = 0, this._cacheNode = null, this._frameNumber = null, this._cacheNode = null, this.traverser = new w$({}), this._shouldRefine = !1, this._distanceToCamera = 0, this._centerZDepth = 0, this._visible = void 0, this._inRequestVolume = !1, this._stackLength = 0, this._selectionDepth = 0, this._initialTransform = new pn(), this.transform = new pn(), this._initializeLodMetric(n), this._initializeTransforms(n), this._initializeBoundingVolumes(n), this._initializeContent(n), this._initializeRenderingState(n), this._lodJudge = null, this._expireDate = null, this._expiredContent = null, Object.seal(this);
  }
  destroy() {
    this.header = null;
  }
  isDestroyed() {
    return this.header === null;
  }
  get selected() {
    return this._selectedFrame === this.tileset._frameNumber;
  }
  get isVisible() {
    return this._visible;
  }
  get isVisibleAndInRequestVolume() {
    return this._visible && this._inRequestVolume;
  }
  get hasRenderContent() {
    return !this.hasEmptyContent && !this.hasTilesetContent;
  }
  get hasChildren() {
    return this.children.length > 0 || this.header.children && this.header.children.length > 0;
  }
  get contentReady() {
    return this.contentState === cf.READY || this.hasEmptyContent;
  }
  get contentAvailable() {
    return !!(this.contentReady && this.hasRenderContent || this._expiredContent && !this.contentFailed);
  }
  get hasUnloadedContent() {
    return this.hasRenderContent && this.contentUnloaded;
  }
  get contentUnloaded() {
    return this.contentState === cf.UNLOADED;
  }
  get contentExpired() {
    return this.contentState === cf.EXPIRED;
  }
  get contentFailed() {
    return this.contentState === cf.FAILED;
  }
  getScreenSpaceError(e, n) {
    switch (this.tileset.type) {
      case Ap.I3S:
        return uYe(this, e);
      case Ap.TILES3D:
        return s1n(this, e, n);
      default:
        throw new Error("Unsupported tileset type");
    }
  }
  unselect() {
    this._selectedFrame = 0;
  }
  _getPriority() {
    const e = this.tileset._traverser, {
      skipLevelOfDetail: n
    } = e.options, r = this.refine === CI.ADD || n;
    if (r && !this.isVisible && this._visible !== void 0 || this.tileset._frameNumber - this._touchedFrame >= 1 || this.contentState === cf.UNLOADED)
      return -1;
    const i = this.parent, s = i && (!r || this._screenSpaceError === 0 || i.hasTilesetContent) ? i._screenSpaceError : this._screenSpaceError, a = e.root ? e.root._screenSpaceError : 0;
    return Math.max(a - s, 0);
  }
  async loadContent() {
    if (this.hasEmptyContent)
      return !1;
    if (this.content)
      return !0;
    this.contentExpired && (this._expireDate = null), this.contentState = cf.LOADING;
    const n = await this.tileset._requestScheduler.scheduleRequest(this.id, this._getPriority.bind(this));
    if (!n)
      return this.contentState = cf.UNLOADED, !1;
    try {
      const r = this.tileset.getTileUrl(this.contentUrl), i = this.tileset.loader, o = {
        ...this.tileset.loadOptions,
        [i.id]: {
          ...this.tileset.loadOptions[i.id],
          isTileset: this.type === "json",
          ...this._getLoaderSpecificOptions(i.id)
        }
      };
      return this.content = await TI(r, i, o), this.tileset.options.contentLoader && await this.tileset.options.contentLoader(this), this._isTileset() && this.tileset._initializeTileHeaders(this.content, this), this.contentState = cf.READY, this._onContentLoaded(), !0;
    } catch (r) {
      throw this.contentState = cf.FAILED, r;
    } finally {
      n.done();
    }
  }
  unloadContent() {
    return this.content && this.content.destroy && this.content.destroy(), this.content = null, this.header.content && this.header.content.destroy && this.header.content.destroy(), this.header.content = null, this.contentState = cf.UNLOADED, !0;
  }
  updateVisibility(e, n) {
    if (this._frameNumber === e.frameNumber)
      return;
    const r = this.parent, i = r ? r._visibilityPlaneMask : Qf.MASK_INDETERMINATE;
    if (this.tileset._traverser.options.updateTransforms) {
      const o = r ? r.computedTransform : this.tileset.modelMatrix;
      this._updateTransform(o);
    }
    this._distanceToCamera = this.distanceToTile(e), this._screenSpaceError = this.getScreenSpaceError(e, !1), this._visibilityPlaneMask = this.visibility(e, i), this._visible = this._visibilityPlaneMask !== Qf.MASK_OUTSIDE, this._inRequestVolume = this.insideViewerRequestVolume(e), this._frameNumber = e.frameNumber, this.viewportIds = n;
  }
  visibility(e, n) {
    const {
      cullingVolume: r
    } = e, {
      boundingVolume: i
    } = this;
    return r.computeVisibilityWithPlaneMask(i, n);
  }
  contentVisibility() {
    return !0;
  }
  distanceToTile(e) {
    const n = this.boundingVolume;
    return Math.sqrt(Math.max(n.distanceSquaredTo(e.camera.position), 0));
  }
  cameraSpaceZDepth({
    camera: e
  }) {
    const n = this.boundingVolume;
    return PQe.subVectors(n.center, e.position), e.direction.dot(PQe);
  }
  insideViewerRequestVolume(e) {
    const n = this._viewerRequestVolume;
    return !n || n.distanceSquaredTo(e.camera.position) <= 0;
  }
  updateExpiration() {
    if (u1n(this._expireDate) && this.contentReady && !this.hasEmptyContent) {
      const e = Date.now();
      Date.lessThan(this._expireDate, e) && (this.contentState = cf.EXPIRED, this._expiredContent = this.content);
    }
  }
  get extras() {
    return this.header.extras;
  }
  _initializeLodMetric(e) {
    "lodMetricType" in e ? this.lodMetricType = e.lodMetricType : (this.lodMetricType = this.parent && this.parent.lodMetricType || this.tileset.lodMetricType, console.warn("3D Tile: Required prop lodMetricType is undefined. Using parent lodMetricType")), "lodMetricValue" in e ? this.lodMetricValue = e.lodMetricValue : (this.lodMetricValue = this.parent && this.parent.lodMetricValue || this.tileset.lodMetricValue, console.warn("3D Tile: Required prop lodMetricValue is undefined. Using parent lodMetricValue"));
  }
  _initializeTransforms(e) {
    this.transform = e.transform ? new pn(e.transform) : new pn();
    const n = this.parent, r = this.tileset, i = n && n.computedTransform ? n.computedTransform.clone() : r.modelMatrix.clone();
    this.computedTransform = new pn(i).multiplyRight(this.transform);
    const o = n && n._initialTransform ? n._initialTransform.clone() : new pn();
    this._initialTransform = new pn(o).multiplyRight(this.transform);
  }
  _initializeBoundingVolumes(e) {
    this._contentBoundingVolume = null, this._viewerRequestVolume = null, this._updateBoundingVolume(e);
  }
  _initializeContent(e) {
    this.content = {
      _tileset: this.tileset,
      _tile: this
    }, this.hasEmptyContent = !0, this.contentState = cf.UNLOADED, this.hasTilesetContent = !1, e.contentUrl && (this.content = null, this.hasEmptyContent = !1);
  }
  _initializeRenderingState(e) {
    this.depth = e.level || (this.parent ? this.parent.depth + 1 : 0), this._shouldRefine = !1, this._distanceToCamera = 0, this._centerZDepth = 0, this._screenSpaceError = 0, this._visibilityPlaneMask = Qf.MASK_INDETERMINATE, this._visible = void 0, this._inRequestVolume = !1, this._stackLength = 0, this._selectionDepth = 0, this._frameNumber = 0, this._touchedFrame = 0, this._visitedFrame = 0, this._selectedFrame = 0, this._requestedFrame = 0, this._priority = 0;
  }
  _getRefine(e) {
    return e || this.parent && this.parent.refine || CI.REPLACE;
  }
  _isTileset() {
    return this.contentUrl.indexOf(".json") !== -1;
  }
  _onContentLoaded() {
    switch (this.content && this.content.type) {
      case "vctr":
      case "geom":
        this.tileset._traverser.disableSkipLevelOfDetail = !0;
        break;
    }
    this._isTileset() && (this.hasTilesetContent = !0);
  }
  _updateBoundingVolume(e) {
    this.boundingVolume = HV(e.boundingVolume, this.computedTransform, this.boundingVolume);
    const n = e.content;
    n && (n.boundingVolume && (this._contentBoundingVolume = HV(n.boundingVolume, this.computedTransform, this._contentBoundingVolume)), e.viewerRequestVolume && (this._viewerRequestVolume = HV(e.viewerRequestVolume, this.computedTransform, this._viewerRequestVolume)));
  }
  _updateTransform(e = new pn()) {
    const n = e.clone().multiplyRight(this.transform);
    n.equals(this.computedTransform) || (this.computedTransform = n, this._updateBoundingVolume(this.header));
  }
  _getLoaderSpecificOptions(e) {
    switch (e) {
      case "i3s":
        return {
          ...this.tileset.options.i3s,
          tile: this.header,
          tileset: this.tileset.tileset,
          isTileHeader: !1
        };
      case "3d-tiles":
      case "cesium-ion":
      default:
        return l1n(this.tileset.tileset);
    }
  }
}
class f1n extends w$ {
  compareDistanceToCamera(e, n) {
    return n._distanceToCamera === 0 && e._distanceToCamera === 0 ? n._centerZDepth - e._centerZDepth : n._distanceToCamera - e._distanceToCamera;
  }
  updateTileVisibility(e, n) {
    if (super.updateTileVisibility(e, n), !e.isVisibleAndInRequestVolume)
      return;
    const r = e.children.length > 0;
    if (e.hasTilesetContent && r) {
      const s = e.children[0];
      this.updateTileVisibility(s, n), e._visible = s._visible;
      return;
    }
    if (this.meetsScreenSpaceErrorEarly(e, n)) {
      e._visible = !1;
      return;
    }
    const i = e.refine === CI.REPLACE, o = e._optimChildrenWithinParent === ZBn.USE_OPTIMIZATION;
    if (i && o && r && !this.anyChildrenVisible(e, n)) {
      e._visible = !1;
      return;
    }
  }
  meetsScreenSpaceErrorEarly(e, n) {
    const {
      parent: r
    } = e;
    return !r || r.hasTilesetContent || r.refine !== CI.ADD ? !1 : !this.shouldRefine(e, n, !0);
  }
}
class g1n {
  constructor() {
    ae(this, "frameNumberMap", /* @__PURE__ */ new Map());
  }
  register(e, n) {
    const r = this.frameNumberMap.get(e) || /* @__PURE__ */ new Map(), i = r.get(n) || 0;
    r.set(n, i + 1), this.frameNumberMap.set(e, r);
  }
  deregister(e, n) {
    const r = this.frameNumberMap.get(e);
    if (!r)
      return;
    const i = r.get(n) || 1;
    r.set(n, i - 1);
  }
  isZero(e, n) {
    var r;
    return (((r = this.frameNumberMap.get(e)) === null || r === void 0 ? void 0 : r.get(n)) || 0) === 0;
  }
}
const jV = {
  REQUESTED: "REQUESTED",
  COMPLETED: "COMPLETED",
  ERROR: "ERROR"
};
class h1n {
  constructor() {
    ae(this, "_statusMap", void 0), ae(this, "pendingTilesRegister", new g1n()), this._statusMap = {};
  }
  add(e, n, r, i) {
    if (!this._statusMap[n]) {
      const {
        frameNumber: o,
        viewport: {
          id: s
        }
      } = i;
      this._statusMap[n] = {
        request: e,
        callback: r,
        key: n,
        frameState: i,
        status: jV.REQUESTED
      }, this.pendingTilesRegister.register(s, o), e().then((a) => {
        this._statusMap[n].status = jV.COMPLETED;
        const {
          frameNumber: A,
          viewport: {
            id: l
          }
        } = this._statusMap[n].frameState;
        this.pendingTilesRegister.deregister(l, A), this._statusMap[n].callback(a, i);
      }).catch((a) => {
        this._statusMap[n].status = jV.ERROR;
        const {
          frameNumber: A,
          viewport: {
            id: l
          }
        } = this._statusMap[n].frameState;
        this.pendingTilesRegister.deregister(l, A), r(a);
      });
    }
  }
  update(e, n) {
    if (this._statusMap[e]) {
      const {
        frameNumber: r,
        viewport: {
          id: i
        }
      } = this._statusMap[e].frameState;
      this.pendingTilesRegister.deregister(i, r);
      const {
        frameNumber: o,
        viewport: {
          id: s
        }
      } = n;
      this.pendingTilesRegister.register(s, o), this._statusMap[e].frameState = n;
    }
  }
  find(e) {
    return this._statusMap[e];
  }
  hasPendingTiles(e, n) {
    return !this.pendingTilesRegister.isZero(e, n);
  }
}
class d1n extends w$ {
  traversalFinished(e) {
    return !this._tileManager.hasPendingTiles(e.viewport.id, this._frameNumber || 0);
  }
  constructor(e) {
    super(e), ae(this, "_tileManager", void 0), this._tileManager = new h1n();
  }
  shouldRefine(e, n) {
    return e._lodJudge = A1n(e, n), e._lodJudge === "DIG";
  }
  updateChildTiles(e, n) {
    const r = e.header.children || [], i = e.children, o = e.tileset;
    for (const s of r) {
      const a = "".concat(s.id, "-").concat(n.viewport.id), A = i && i.find((l) => l.id === a);
      if (A)
        A && this.updateTile(A, n);
      else {
        let l = () => this._loadTile(s.id, o);
        this._tileManager.find(a) ? this._tileManager.update(a, n) : (o.tileset.nodePages && (l = () => o.tileset.nodePagesTile.formTileFromNodePages(s.id)), this._tileManager.add(l, a, (u) => this._onTileLoad(u, e, a), n));
      }
    }
    return !1;
  }
  async _loadTile(e, n) {
    const {
      loader: r
    } = n, i = n.getTileUrl("".concat(n.url, "/nodes/").concat(e)), o = {
      ...n.loadOptions,
      i3s: {
        ...n.loadOptions.i3s,
        isTileHeader: !0,
        loadContent: !1
      }
    };
    return await TI(i, r, o);
  }
  _onTileLoad(e, n, r) {
    const i = new Ite(n.tileset, e, n, r);
    n.children.push(i);
    const o = this._tileManager.find(i.id).frameState;
    this.updateTile(i, o), this._frameNumber === o.frameNumber && (this.traversalFinished(o) || (/* @__PURE__ */ new Date()).getTime() - this.lastUpdate > this.updateDebounceTime) && this.executeTraversal(i, o);
  }
}
const p1n = {
  description: "",
  ellipsoid: uA.WGS84,
  modelMatrix: new pn(),
  throttleRequests: !0,
  maxRequests: 64,
  maximumMemoryUsage: 32,
  maximumTilesSelected: 0,
  debounceTime: 0,
  onTileLoad: () => {
  },
  onTileUnload: () => {
  },
  onTileError: () => {
  },
  onTraversalComplete: (t) => t,
  contentLoader: void 0,
  viewDistanceScale: 1,
  maximumScreenSpaceError: 8,
  loadTiles: !0,
  updateTransforms: !0,
  viewportTraversersMap: null,
  loadOptions: {
    fetch: {}
  },
  attributions: [],
  basePath: "",
  i3s: {}
}, IP = "Tiles In Tileset(s)", YV = "Tiles In Memory", kQe = "Tiles In View", GQe = "Tiles To Render", UQe = "Tiles Loaded", zV = "Tiles Loading", HQe = "Tiles Unloaded", $Qe = "Failed Tile Loads", qQe = "Points/Vertices", VV = "Tile Memory Use";
class I1n {
  constructor(e, n) {
    ae(this, "options", void 0), ae(this, "loadOptions", void 0), ae(this, "type", void 0), ae(this, "tileset", void 0), ae(this, "loader", void 0), ae(this, "url", void 0), ae(this, "basePath", void 0), ae(this, "modelMatrix", void 0), ae(this, "ellipsoid", void 0), ae(this, "lodMetricType", void 0), ae(this, "lodMetricValue", void 0), ae(this, "refine", void 0), ae(this, "root", void 0), ae(this, "roots", void 0), ae(this, "asset", void 0), ae(this, "description", void 0), ae(this, "properties", void 0), ae(this, "extras", void 0), ae(this, "attributions", void 0), ae(this, "credits", void 0), ae(this, "stats", void 0), ae(this, "traverseCounter", void 0), ae(this, "geometricError", void 0), ae(this, "selectedTiles", void 0), ae(this, "updatePromise", null), ae(this, "tilesetInitializationPromise", void 0), ae(this, "cartographicCenter", void 0), ae(this, "cartesianCenter", void 0), ae(this, "zoom", void 0), ae(this, "boundingVolume", void 0), ae(this, "gpuMemoryUsageInBytes", void 0), ae(this, "dynamicScreenSpaceErrorComputedDensity", void 0), ae(this, "_traverser", void 0), ae(this, "_cache", void 0), ae(this, "_requestScheduler", void 0), ae(this, "_frameNumber", void 0), ae(this, "_queryParamsString", void 0), ae(this, "_queryParams", void 0), ae(this, "_extensionsUsed", void 0), ae(this, "_tiles", void 0), ae(this, "_pendingCount", void 0), ae(this, "lastUpdatedVieports", void 0), ae(this, "_requestedTiles", void 0), ae(this, "_emptyTiles", void 0), ae(this, "frameStateData", void 0), ae(this, "maximumMemoryUsage", void 0), _o(e), this.options = {
      ...p1n,
      ...n
    }, this.tileset = e, this.loader = e.loader, this.type = e.type, this.url = e.url, this.basePath = e.basePath || d9e(this.url), this.modelMatrix = this.options.modelMatrix, this.ellipsoid = this.options.ellipsoid, this.lodMetricType = e.lodMetricType, this.lodMetricValue = e.lodMetricValue, this.refine = e.root.refine, this.loadOptions = this.options.loadOptions || {}, this.root = null, this.roots = {}, this.cartographicCenter = null, this.cartesianCenter = null, this.zoom = 1, this.boundingVolume = null, this.traverseCounter = 0, this.geometricError = 0, this._traverser = this._initializeTraverser(), this._cache = new $Bn(), this._requestScheduler = new h9e({
      throttleRequests: this.options.throttleRequests,
      maxRequests: this.options.maxRequests
    }), this._frameNumber = 0, this._pendingCount = 0, this._tiles = {}, this.selectedTiles = [], this._emptyTiles = [], this._requestedTiles = [], this.frameStateData = {}, this.lastUpdatedVieports = null, this._queryParams = {}, this._queryParamsString = "", this.maximumMemoryUsage = this.options.maximumMemoryUsage || 32, this.gpuMemoryUsageInBytes = 0, this.stats = new tM({
      id: this.url
    }), this._initializeStats(), this._extensionsUsed = void 0, this.dynamicScreenSpaceErrorComputedDensity = 0, this.extras = null, this.asset = {}, this.credits = {}, this.description = this.options.description || "", this.tilesetInitializationPromise = this._initializeTileSet(e);
  }
  destroy() {
    this._destroy();
  }
  isLoaded() {
    return this._pendingCount === 0 && this._frameNumber !== 0 && this._requestedTiles.length === 0;
  }
  get tiles() {
    return Object.values(this._tiles);
  }
  get frameNumber() {
    return this._frameNumber;
  }
  get queryParams() {
    return this._queryParamsString || (this._queryParamsString = m1n(this._queryParams)), this._queryParamsString;
  }
  setProps(e) {
    this.options = {
      ...this.options,
      ...e
    };
  }
  setOptions(e) {
    this.options = {
      ...this.options,
      ...e
    };
  }
  getTileUrl(e) {
    return e.startsWith("data:") ? e : "".concat(e).concat(this.queryParams);
  }
  hasExtension(e) {
    return !!(this._extensionsUsed && this._extensionsUsed.indexOf(e) > -1);
  }
  update(e = null) {
    this.tilesetInitializationPromise.then(() => {
      !e && this.lastUpdatedVieports ? e = this.lastUpdatedVieports : this.lastUpdatedVieports = e, e && this.doUpdate(e);
    });
  }
  async selectTiles(e = null) {
    return await this.tilesetInitializationPromise, e && (this.lastUpdatedVieports = e), this.updatePromise || (this.updatePromise = new Promise((n) => {
      setTimeout(() => {
        this.lastUpdatedVieports && this.doUpdate(this.lastUpdatedVieports), n(this._frameNumber), this.updatePromise = null;
      }, this.options.debounceTime);
    })), this.updatePromise;
  }
  doUpdate(e) {
    if ("loadTiles" in this.options && !this.options.loadTiles || this.traverseCounter > 0)
      return;
    const n = e instanceof Array ? e : [e];
    this._cache.reset(), this._frameNumber++, this.traverseCounter = n.length;
    const r = [];
    for (const i of n) {
      const o = i.id;
      this._needTraverse(o) ? r.push(o) : this.traverseCounter--;
    }
    for (const i of n) {
      const o = i.id;
      if (this.roots[o] || (this.roots[o] = this._initializeTileHeaders(this.tileset, null)), !r.includes(o))
        continue;
      const s = jBn(i, this._frameNumber);
      this._traverser.traverse(this.roots[o], s, this.options);
    }
  }
  _needTraverse(e) {
    let n = e;
    return this.options.viewportTraversersMap && (n = this.options.viewportTraversersMap[e]), n === e;
  }
  _onTraversalEnd(e) {
    const n = e.viewport.id;
    this.frameStateData[n] || (this.frameStateData[n] = {
      selectedTiles: [],
      _requestedTiles: [],
      _emptyTiles: []
    });
    const r = this.frameStateData[n], i = Object.values(this._traverser.selectedTiles), [o, s] = YBn(i, e, this.options.maximumTilesSelected);
    r.selectedTiles = o;
    for (const a of s)
      a.unselect();
    r._requestedTiles = Object.values(this._traverser.requestedTiles), r._emptyTiles = Object.values(this._traverser.emptyTiles), this.traverseCounter--, !(this.traverseCounter > 0) && this._updateTiles();
  }
  _updateTiles() {
    this.selectedTiles = [], this._requestedTiles = [], this._emptyTiles = [];
    for (const e in this.frameStateData) {
      const n = this.frameStateData[e];
      this.selectedTiles = this.selectedTiles.concat(n.selectedTiles), this._requestedTiles = this._requestedTiles.concat(n._requestedTiles), this._emptyTiles = this._emptyTiles.concat(n._emptyTiles);
    }
    this.selectedTiles = this.options.onTraversalComplete(this.selectedTiles);
    for (const e of this.selectedTiles)
      this._tiles[e.id] = e;
    this._loadTiles(), this._unloadTiles(), this._updateStats();
  }
  _tilesChanged(e, n) {
    if (e.length !== n.length)
      return !0;
    const r = new Set(e.map((s) => s.id)), i = new Set(n.map((s) => s.id));
    let o = e.filter((s) => !i.has(s.id)).length > 0;
    return o = o || n.filter((s) => !r.has(s.id)).length > 0, o;
  }
  _loadTiles() {
    for (const e of this._requestedTiles)
      e.contentUnloaded && this._loadTile(e);
  }
  _unloadTiles() {
    this._cache.unloadTiles(this, (e, n) => e._unloadTile(n));
  }
  _updateStats() {
    let e = 0, n = 0;
    for (const r of this.selectedTiles)
      r.contentAvailable && r.content && (e++, r.content.pointCount ? n += r.content.pointCount : n += r.content.vertexCount);
    this.stats.get(kQe).count = this.selectedTiles.length, this.stats.get(GQe).count = e, this.stats.get(qQe).count = n;
  }
  async _initializeTileSet(e) {
    this.type === Ap.I3S && (this.calculateViewPropsI3S(), e.root = await e.root), this.root = this._initializeTileHeaders(e, null), this.type === Ap.TILES3D && (this._initializeTiles3DTileset(e), this.calculateViewPropsTiles3D()), this.type === Ap.I3S && this._initializeI3STileset();
  }
  calculateViewPropsI3S() {
    var e;
    const n = this.tileset.fullExtent;
    if (n) {
      const {
        xmin: i,
        xmax: o,
        ymin: s,
        ymax: a,
        zmin: A,
        zmax: l
      } = n;
      this.cartographicCenter = new ct(i + (o - i) / 2, s + (a - s) / 2, A + (l - A) / 2), this.cartesianCenter = uA.WGS84.cartographicToCartesian(this.cartographicCenter, new ct()), this.zoom = lYe(n, this.cartographicCenter, this.cartesianCenter);
      return;
    }
    const r = (e = this.tileset.store) === null || e === void 0 ? void 0 : e.extent;
    if (r) {
      const [i, o, s, a] = r;
      this.cartographicCenter = new ct(i + (s - i) / 2, o + (a - o) / 2, 0), this.cartesianCenter = uA.WGS84.cartographicToCartesian(this.cartographicCenter, new ct()), this.zoom = WBn(r, this.cartographicCenter, this.cartesianCenter);
      return;
    }
    console.warn("Extent is not defined in the tileset header"), this.cartographicCenter = new ct(), this.zoom = 1;
  }
  calculateViewPropsTiles3D() {
    const e = this.root;
    _o(e);
    const {
      center: n
    } = e.boundingVolume;
    if (!n) {
      console.warn("center was not pre-calculated for the root tile"), this.cartographicCenter = new ct(), this.zoom = 1;
      return;
    }
    n[0] !== 0 || n[1] !== 0 || n[2] !== 0 ? this.cartographicCenter = uA.WGS84.cartesianToCartographic(n, new ct()) : this.cartographicCenter = new ct(0, 0, -uA.WGS84.radii[0]), this.cartesianCenter = n, this.zoom = KBn(e.boundingVolume, this.cartographicCenter);
  }
  _initializeStats() {
    this.stats.get(IP), this.stats.get(zV), this.stats.get(YV), this.stats.get(kQe), this.stats.get(GQe), this.stats.get(UQe), this.stats.get(HQe), this.stats.get($Qe), this.stats.get(qQe, "memory"), this.stats.get(VV, "memory");
  }
  _initializeTileHeaders(e, n) {
    const r = new Ite(this, e.root, n);
    if (n && (n.children.push(r), r.depth = n.depth + 1), this.type === Ap.TILES3D) {
      const i = [];
      for (i.push(r); i.length > 0; ) {
        const o = i.pop();
        this.stats.get(IP).incrementCount();
        const s = o.header.children || [];
        for (const a of s) {
          const A = new Ite(this, a, o);
          o.children.push(A), A.depth = o.depth + 1, i.push(A);
        }
      }
    }
    return r;
  }
  _initializeTraverser() {
    let e;
    switch (this.type) {
      case Ap.TILES3D:
        e = f1n;
        break;
      case Ap.I3S:
        e = d1n;
        break;
      default:
        e = w$;
    }
    return new e({
      basePath: this.basePath,
      onTraversalEnd: this._onTraversalEnd.bind(this)
    });
  }
  _destroyTileHeaders(e) {
    this._destroySubtree(e);
  }
  async _loadTile(e) {
    let n;
    try {
      this._onStartTileLoading(), n = await e.loadContent();
    } catch (r) {
      this._onTileLoadError(e, r);
    } finally {
      this._onEndTileLoading(), this._onTileLoad(e, n);
    }
  }
  _onTileLoadError(e, n) {
    this.stats.get($Qe).incrementCount();
    const r = n.message || n.toString(), i = e.url;
    console.error("A 3D tile failed to load: ".concat(e.url, " ").concat(r)), this.options.onTileError(e, r, i);
  }
  _onTileLoad(e, n) {
    if (n) {
      if (this.type === Ap.I3S) {
        var r, i;
        const o = ((r = this.tileset) === null || r === void 0 || (i = r.nodePagesTile) === null || i === void 0 ? void 0 : i.nodesInNodePages) || 0;
        this.stats.get(IP).reset(), this.stats.get(IP).addCount(o);
      }
      e && e.content && qBn(e, e.content), this._addTileToCache(e), this.options.onTileLoad(e);
    }
  }
  _onStartTileLoading() {
    this._pendingCount++, this.stats.get(zV).incrementCount();
  }
  _onEndTileLoading() {
    this._pendingCount--, this.stats.get(zV).decrementCount();
  }
  _addTileToCache(e) {
    this._cache.add(this, e, (n) => n._updateCacheStats(e));
  }
  _updateCacheStats(e) {
    this.stats.get(UQe).incrementCount(), this.stats.get(YV).incrementCount(), this.gpuMemoryUsageInBytes += e.content.byteLength || 0, this.stats.get(VV).count = this.gpuMemoryUsageInBytes;
  }
  _unloadTile(e) {
    this.gpuMemoryUsageInBytes -= e.content && e.content.byteLength || 0, this.stats.get(YV).decrementCount(), this.stats.get(HQe).incrementCount(), this.stats.get(VV).count = this.gpuMemoryUsageInBytes, this.options.onTileUnload(e), e.unloadContent();
  }
  _destroy() {
    const e = [];
    for (this.root && e.push(this.root); e.length > 0; ) {
      const n = e.pop();
      for (const r of n.children)
        e.push(r);
      this._destroyTile(n);
    }
    this.root = null;
  }
  _destroySubtree(e) {
    const n = e, r = [];
    for (r.push(n); r.length > 0; ) {
      e = r.pop();
      for (const i of e.children)
        r.push(i);
      e !== n && this._destroyTile(e);
    }
    n.children = [];
  }
  _destroyTile(e) {
    this._cache.unloadTile(this, e), this._unloadTile(e), e.destroy();
  }
  _initializeTiles3DTileset(e) {
    if (this.asset = e.asset, !this.asset)
      throw new Error("Tileset must have an asset property.");
    if (this.asset.version !== "0.0" && this.asset.version !== "1.0")
      throw new Error("The tileset must be 3D Tiles version 0.0 or 1.0.");
    "tilesetVersion" in this.asset && (this._queryParams.v = this.asset.tilesetVersion), this.credits = {
      attributions: this.options.attributions || []
    }, this.description = this.options.description || "", this.properties = e.properties, this.geometricError = e.geometricError, this._extensionsUsed = e.extensionsUsed, this.extras = e.extras;
  }
  _initializeI3STileset() {
    this.loadOptions.i3s && "token" in this.loadOptions.i3s && (this._queryParams.token = this.loadOptions.i3s.token);
  }
}
function m1n(t) {
  const e = [];
  for (const n of Object.keys(t))
    e.push("".concat(n, "=").concat(t[n]));
  switch (e.length) {
    case 0:
      return "";
    case 1:
      return "?".concat(e[0]);
    default:
      return "?".concat(e.join("&"));
  }
}
const fYe = "3.2.10", p2 = {
  COMPOSITE: "cmpt",
  POINT_CLOUD: "pnts",
  BATCHED_3D_MODEL: "b3dm",
  INSTANCED_3D_MODEL: "i3dm",
  GEOMETRY: "geom",
  VECTOR: "vect",
  GLTF: "glTF"
};
function gYe(t, e, n) {
  _o(t instanceof ArrayBuffer);
  const r = new TextDecoder("utf8"), i = new Uint8Array(t, e, n);
  return r.decode(i);
}
function C1n(t, e = 0) {
  const n = new DataView(t);
  return "".concat(String.fromCharCode(n.getUint8(e + 0))).concat(String.fromCharCode(n.getUint8(e + 1))).concat(String.fromCharCode(n.getUint8(e + 2))).concat(String.fromCharCode(n.getUint8(e + 3)));
}
const E1n = {
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6
}, Ha = {
  BYTE: 5120,
  UNSIGNED_BYTE: 5121,
  SHORT: 5122,
  UNSIGNED_SHORT: 5123,
  INT: 5124,
  UNSIGNED_INT: 5125,
  FLOAT: 5126,
  DOUBLE: 5130
}, Pi = {
  ...E1n,
  ...Ha
}, JV = {
  [Ha.DOUBLE]: Float64Array,
  [Ha.FLOAT]: Float32Array,
  [Ha.UNSIGNED_SHORT]: Uint16Array,
  [Ha.UNSIGNED_INT]: Uint32Array,
  [Ha.UNSIGNED_BYTE]: Uint8Array,
  [Ha.BYTE]: Int8Array,
  [Ha.SHORT]: Int16Array,
  [Ha.INT]: Int32Array
}, y1n = {
  DOUBLE: Ha.DOUBLE,
  FLOAT: Ha.FLOAT,
  UNSIGNED_SHORT: Ha.UNSIGNED_SHORT,
  UNSIGNED_INT: Ha.UNSIGNED_INT,
  UNSIGNED_BYTE: Ha.UNSIGNED_BYTE,
  BYTE: Ha.BYTE,
  SHORT: Ha.SHORT,
  INT: Ha.INT
}, KV = "Failed to convert GL type";
class _p {
  static fromTypedArray(e) {
    e = ArrayBuffer.isView(e) ? e.constructor : e;
    for (const n in JV)
      if (JV[n] === e)
        return n;
    throw new Error(KV);
  }
  static fromName(e) {
    const n = y1n[e];
    if (!n)
      throw new Error(KV);
    return n;
  }
  static getArrayType(e) {
    switch (e) {
      case Ha.UNSIGNED_SHORT_5_6_5:
      case Ha.UNSIGNED_SHORT_4_4_4_4:
      case Ha.UNSIGNED_SHORT_5_5_5_1:
        return Uint16Array;
      default:
        const n = JV[e];
        if (!n)
          throw new Error(KV);
        return n;
    }
  }
  static getByteSize(e) {
    return _p.getArrayType(e).BYTES_PER_ELEMENT;
  }
  static validate(e) {
    return !!_p.getArrayType(e);
  }
  static createTypedArray(e, n, r = 0, i) {
    i === void 0 && (i = (n.byteLength - r) / _p.getByteSize(e));
    const o = _p.getArrayType(e);
    return new o(n, r, i);
  }
}
function v1n(t, e) {
  if (!t)
    throw new Error("math.gl assertion failed. ".concat(e));
}
function B1n(t, e = [0, 0, 0]) {
  const n = t >> 11 & 31, r = t >> 5 & 63, i = t & 31;
  return e[0] = n << 3, e[1] = r << 2, e[2] = i << 3, e;
}
new n$();
new ct();
new n$();
new n$();
function jQe(t, e = 255) {
  return So(t, 0, e) / e * 2 - 1;
}
function YQe(t) {
  return t < 0 ? -1 : 1;
}
function b1n(t, e, n, r) {
  if (v1n(r), t < 0 || t > n || e < 0 || e > n)
    throw new Error("x and y must be unsigned normalized integers between 0 and ".concat(n));
  if (r.x = jQe(t, n), r.y = jQe(e, n), r.z = 1 - (Math.abs(r.x) + Math.abs(r.y)), r.z < 0) {
    const i = r.x;
    r.x = (1 - Math.abs(r.y)) * YQe(i), r.y = (1 - Math.abs(i)) * YQe(r.y);
  }
  return r.normalize();
}
function _1n(t, e, n) {
  return b1n(t, e, 255, n);
}
class wce {
  constructor(e, n) {
    ae(this, "json", void 0), ae(this, "buffer", void 0), ae(this, "featuresLength", 0), ae(this, "_cachedTypedArrays", {}), this.json = e, this.buffer = n;
  }
  getExtension(e) {
    return this.json.extensions && this.json.extensions[e];
  }
  hasProperty(e) {
    return !!this.json[e];
  }
  getGlobalProperty(e, n = Pi.UNSIGNED_INT, r = 1) {
    const i = this.json[e];
    return i && Number.isFinite(i.byteOffset) ? this._getTypedArrayFromBinary(e, n, r, 1, i.byteOffset) : i;
  }
  getPropertyArray(e, n, r) {
    const i = this.json[e];
    return i && Number.isFinite(i.byteOffset) ? ("componentType" in i && (n = _p.fromName(i.componentType)), this._getTypedArrayFromBinary(e, n, r, this.featuresLength, i.byteOffset)) : this._getTypedArrayFromArray(e, n, i);
  }
  getProperty(e, n, r, i, o) {
    const s = this.json[e];
    if (!s)
      return s;
    const a = this.getPropertyArray(e, n, r);
    if (r === 1)
      return a[i];
    for (let A = 0; A < r; ++A)
      o[A] = a[r * i + A];
    return o;
  }
  _getTypedArrayFromBinary(e, n, r, i, o) {
    const s = this._cachedTypedArrays;
    let a = s[e];
    return a || (a = _p.createTypedArray(n, this.buffer.buffer, this.buffer.byteOffset + o, i * r), s[e] = a), a;
  }
  _getTypedArrayFromArray(e, n, r) {
    const i = this._cachedTypedArrays;
    let o = i[e];
    return o || (o = _p.createTypedArray(n, r), i[e] = o), o;
  }
}
const S1n = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, Q1n = {
  SCALAR: (t, e) => t[e],
  VEC2: (t, e) => [t[2 * e + 0], t[2 * e + 1]],
  VEC3: (t, e) => [t[3 * e + 0], t[3 * e + 1], t[3 * e + 2]],
  VEC4: (t, e) => [t[4 * e + 0], t[4 * e + 1], t[4 * e + 2], t[4 * e + 3]],
  MAT2: (t, e) => [t[4 * e + 0], t[4 * e + 1], t[4 * e + 2], t[4 * e + 3]],
  MAT3: (t, e) => [t[9 * e + 0], t[9 * e + 1], t[9 * e + 2], t[9 * e + 3], t[9 * e + 4], t[9 * e + 5], t[9 * e + 6], t[9 * e + 7], t[9 * e + 8]],
  MAT4: (t, e) => [t[16 * e + 0], t[16 * e + 1], t[16 * e + 2], t[16 * e + 3], t[16 * e + 4], t[16 * e + 5], t[16 * e + 6], t[16 * e + 7], t[16 * e + 8], t[16 * e + 9], t[16 * e + 10], t[16 * e + 11], t[16 * e + 12], t[16 * e + 13], t[16 * e + 14], t[16 * e + 15]]
}, w1n = {
  SCALAR: (t, e, n) => {
    e[n] = t;
  },
  VEC2: (t, e, n) => {
    e[2 * n + 0] = t[0], e[2 * n + 1] = t[1];
  },
  VEC3: (t, e, n) => {
    e[3 * n + 0] = t[0], e[3 * n + 1] = t[1], e[3 * n + 2] = t[2];
  },
  VEC4: (t, e, n) => {
    e[4 * n + 0] = t[0], e[4 * n + 1] = t[1], e[4 * n + 2] = t[2], e[4 * n + 3] = t[3];
  },
  MAT2: (t, e, n) => {
    e[4 * n + 0] = t[0], e[4 * n + 1] = t[1], e[4 * n + 2] = t[2], e[4 * n + 3] = t[3];
  },
  MAT3: (t, e, n) => {
    e[9 * n + 0] = t[0], e[9 * n + 1] = t[1], e[9 * n + 2] = t[2], e[9 * n + 3] = t[3], e[9 * n + 4] = t[4], e[9 * n + 5] = t[5], e[9 * n + 6] = t[6], e[9 * n + 7] = t[7], e[9 * n + 8] = t[8], e[9 * n + 9] = t[9];
  },
  MAT4: (t, e, n) => {
    e[16 * n + 0] = t[0], e[16 * n + 1] = t[1], e[16 * n + 2] = t[2], e[16 * n + 3] = t[3], e[16 * n + 4] = t[4], e[16 * n + 5] = t[5], e[16 * n + 6] = t[6], e[16 * n + 7] = t[7], e[16 * n + 8] = t[8], e[16 * n + 9] = t[9], e[16 * n + 10] = t[10], e[16 * n + 11] = t[11], e[16 * n + 12] = t[12], e[16 * n + 13] = t[13], e[16 * n + 14] = t[14], e[16 * n + 15] = t[15];
  }
};
function x1n(t, e, n, r) {
  const {
    componentType: i
  } = t;
  _o(t.componentType);
  const o = typeof i == "string" ? _p.fromName(i) : i, s = S1n[t.type], a = Q1n[t.type], A = w1n[t.type];
  return n += t.byteOffset, {
    values: _p.createTypedArray(o, e, n, s * r),
    type: o,
    size: s,
    unpacker: a,
    packer: A
  };
}
const hp = (t) => t !== void 0;
function R1n(t, e, n) {
  if (!e)
    return null;
  let r = t.getExtension("3DTILES_batch_table_hierarchy");
  const i = e.HIERARCHY;
  return i && (console.warn("3D Tile Parser: HIERARCHY is deprecated. Use 3DTILES_batch_table_hierarchy."), e.extensions = e.extensions || {}, e.extensions["3DTILES_batch_table_hierarchy"] = i, r = i), r ? D1n(r, n) : null;
}
function D1n(t, e) {
  let n, r, i;
  const o = t.instancesLength, s = t.classes;
  let a = t.classIds, A = t.parentCounts, l = t.parentIds, c = o;
  hp(a.byteOffset) && (a.componentType = defaultValue(a.componentType, GL.UNSIGNED_SHORT), a.type = AttributeType.SCALAR, i = getBinaryAccessor(a), a = i.createArrayBufferView(e.buffer, e.byteOffset + a.byteOffset, o));
  let u;
  if (hp(A))
    for (hp(A.byteOffset) && (A.componentType = defaultValue(A.componentType, GL.UNSIGNED_SHORT), A.type = AttributeType.SCALAR, i = getBinaryAccessor(A), A = i.createArrayBufferView(e.buffer, e.byteOffset + A.byteOffset, o)), u = new Uint16Array(o), c = 0, n = 0; n < o; ++n)
      u[n] = c, c += A[n];
  hp(l) && hp(l.byteOffset) && (l.componentType = defaultValue(l.componentType, GL.UNSIGNED_SHORT), l.type = AttributeType.SCALAR, i = getBinaryAccessor(l), l = i.createArrayBufferView(e.buffer, e.byteOffset + l.byteOffset, c));
  const f = s.length;
  for (n = 0; n < f; ++n) {
    const m = s[n].length, C = s[n].instances, y = getBinaryProperties(m, C, e);
    s[n].instances = combine(y, C);
  }
  const h = new Array(f).fill(0), d = new Uint16Array(o);
  for (n = 0; n < o; ++n)
    r = a[n], d[n] = h[r], ++h[r];
  const I = {
    classes: s,
    classIds: a,
    classIndexes: d,
    parentCounts: A,
    parentIndexes: u,
    parentIds: l
  };
  return L1n(I), I;
}
function I2(t, e, n) {
  if (!t)
    return;
  const r = t.parentCounts;
  return t.parentIds ? n(t, e) : r > 0 ? T1n(t, e, n) : N1n(t, e, n);
}
function T1n(t, e, n) {
  const r = t.classIds, i = t.parentCounts, o = t.parentIds, s = t.parentIndexes, a = r.length, A = scratchVisited;
  A.length = Math.max(A.length, a);
  const l = ++marker, c = scratchStack;
  for (c.length = 0, c.push(e); c.length > 0; ) {
    if (e = c.pop(), A[e] === l)
      continue;
    A[e] = l;
    const u = n(t, e);
    if (hp(u))
      return u;
    const f = i[e], h = s[e];
    for (let d = 0; d < f; ++d) {
      const I = o[h + d];
      I !== e && c.push(I);
    }
  }
  return null;
}
function N1n(t, e, n) {
  let r = !0;
  for (; r; ) {
    const i = n(t, e);
    if (hp(i))
      return i;
    const o = t.parentIds[e];
    r = o !== e, e = o;
  }
  throw new Error("traverseHierarchySingleParent");
}
function L1n(t) {
  const n = t.classIds.length;
  for (let r = 0; r < n; ++r)
    hYe(t, r, stack);
}
function hYe(t, e, n) {
  const r = t.parentCounts, i = t.parentIds, o = t.parentIndexes, a = t.classIds.length;
  if (!hp(i))
    return;
  assert(e < a, "Parent index ".concat(e, " exceeds the total number of instances: ").concat(a)), assert(n.indexOf(e) === -1, "Circular dependency detected in the batch table hierarchy."), n.push(e);
  const A = hp(r) ? r[e] : 1, l = hp(r) ? o[e] : e;
  for (let c = 0; c < A; ++c) {
    const u = i[l + c];
    u !== e && hYe(t, u, n);
  }
  n.pop(e);
}
function uu(t) {
  return t != null;
}
const mP = (t, e) => t, M1n = {
  HIERARCHY: !0,
  extensions: !0,
  extras: !0
};
class dYe {
  constructor(e, n, r, i = {}) {
    var o;
    ae(this, "json", void 0), ae(this, "binary", void 0), ae(this, "featureCount", void 0), ae(this, "_extensions", void 0), ae(this, "_properties", void 0), ae(this, "_binaryProperties", void 0), ae(this, "_hierarchy", void 0), _o(r >= 0), this.json = e || {}, this.binary = n, this.featureCount = r, this._extensions = ((o = this.json) === null || o === void 0 ? void 0 : o.extensions) || {}, this._properties = {};
    for (const s in this.json)
      M1n[s] || (this._properties[s] = this.json[s]);
    this._binaryProperties = this._initializeBinaryProperties(), i["3DTILES_batch_table_hierarchy"] && (this._hierarchy = R1n(this, this.json, this.binary));
  }
  getExtension(e) {
    return this.json && this.json.extensions && this.json.extensions[e];
  }
  memorySizeInBytes() {
    return 0;
  }
  isClass(e, n) {
    if (this._checkBatchId(e), _o(typeof n == "string", n), this._hierarchy) {
      const r = I2(this._hierarchy, e, (i, o) => {
        const s = i.classIds[o];
        return i.classes[s].name === n;
      });
      return uu(r);
    }
    return !1;
  }
  isExactClass(e, n) {
    return _o(typeof n == "string", n), this.getExactClassName(e) === n;
  }
  getExactClassName(e) {
    if (this._checkBatchId(e), this._hierarchy) {
      const n = this._hierarchy.classIds[e];
      return this._hierarchy.classes[n].name;
    }
  }
  hasProperty(e, n) {
    return this._checkBatchId(e), _o(typeof n == "string", n), uu(this._properties[n]) || this._hasPropertyInHierarchy(e, n);
  }
  getPropertyNames(e, n) {
    this._checkBatchId(e), n = uu(n) ? n : [], n.length = 0;
    const r = Object.keys(this._properties);
    return n.push(...r), this._hierarchy && this._getPropertyNamesInHierarchy(e, n), n;
  }
  getProperty(e, n) {
    if (this._checkBatchId(e), _o(typeof n == "string", n), this._binaryProperties) {
      const i = this._binaryProperties[n];
      if (uu(i))
        return this._getBinaryProperty(i, e);
    }
    const r = this._properties[n];
    if (uu(r))
      return mP(r[e]);
    if (this._hierarchy) {
      const i = this._getHierarchyProperty(e, n);
      if (uu(i))
        return i;
    }
  }
  setProperty(e, n, r) {
    const i = this.featureCount;
    if (this._checkBatchId(e), _o(typeof n == "string", n), this._binaryProperties) {
      const s = this._binaryProperties[n];
      if (s) {
        this._setBinaryProperty(s, e, r);
        return;
      }
    }
    if (this._hierarchy && this._setHierarchyProperty(this, e, n, r))
      return;
    let o = this._properties[n];
    uu(o) || (this._properties[n] = new Array(i), o = this._properties[n]), o[e] = mP(r);
  }
  _checkBatchId(e) {
    if (!(e >= 0 && e < this.featureCount))
      throw new Error("batchId not in range [0, featureCount - 1].");
  }
  _getBinaryProperty(e, n) {
    return e.unpack(e.typedArray, n);
  }
  _setBinaryProperty(e, n, r) {
    e.pack(r, e.typedArray, n);
  }
  _initializeBinaryProperties() {
    let e = null;
    for (const n in this._properties) {
      const r = this._properties[n], i = this._initializeBinaryProperty(n, r);
      i && (e = e || {}, e[n] = i);
    }
    return e;
  }
  _initializeBinaryProperty(e, n) {
    if ("byteOffset" in n) {
      const r = n;
      _o(this.binary, "Property ".concat(e, " requires a batch table binary.")), _o(r.type, "Property ".concat(e, " requires a type."));
      const i = x1n(r, this.binary.buffer, this.binary.byteOffset | 0, this.featureCount);
      return {
        typedArray: i.values,
        componentCount: i.size,
        unpack: i.unpacker,
        pack: i.packer
      };
    }
    return null;
  }
  _hasPropertyInHierarchy(e, n) {
    if (!this._hierarchy)
      return !1;
    const r = I2(this._hierarchy, e, (i, o) => {
      const s = i.classIds[o], a = i.classes[s].instances;
      return uu(a[n]);
    });
    return uu(r);
  }
  _getPropertyNamesInHierarchy(e, n) {
    I2(this._hierarchy, e, (r, i) => {
      const o = r.classIds[i], s = r.classes[o].instances;
      for (const a in s)
        s.hasOwnProperty(a) && n.indexOf(a) === -1 && n.push(a);
    });
  }
  _getHierarchyProperty(e, n) {
    return I2(this._hierarchy, e, (r, i) => {
      const o = r.classIds[i], s = r.classes[o], a = r.classIndexes[i], A = s.instances[n];
      return uu(A) ? uu(A.typedArray) ? this._getBinaryProperty(A, a) : mP(A[a]) : null;
    });
  }
  _setHierarchyProperty(e, n, r, i) {
    const o = I2(this._hierarchy, n, (s, a) => {
      const A = s.classIds[a], l = s.classes[A], c = s.classIndexes[a], u = l.instances[r];
      return uu(u) ? (_o(a === n, 'Inherited property "'.concat(r, '" is read-only.')), uu(u.typedArray) ? this._setBinaryProperty(u, c, i) : u[c] = mP(i), !0) : !1;
    });
    return uu(o);
  }
}
const WV = 4;
function x$(t, e, n = 0) {
  const r = new DataView(e);
  if (t.magic = r.getUint32(n, !0), n += WV, t.version = r.getUint32(n, !0), n += WV, t.byteLength = r.getUint32(n, !0), n += WV, t.version !== 1)
    throw new Error("3D Tile Version ".concat(t.version, " not supported"));
  return n;
}
const ub = 4, zQe = "b3dm tile in legacy format.";
function xce(t, e, n) {
  const r = new DataView(e);
  let i;
  t.header = t.header || {};
  let o = r.getUint32(n, !0);
  n += ub;
  let s = r.getUint32(n, !0);
  n += ub;
  let a = r.getUint32(n, !0);
  n += ub;
  let A = r.getUint32(n, !0);
  return n += ub, a >= 570425344 ? (n -= ub * 2, i = o, a = s, A = 0, o = 0, s = 0, console.warn(zQe)) : A >= 570425344 && (n -= ub, i = a, a = o, A = s, o = 0, s = 0, console.warn(zQe)), t.header.featureTableJsonByteLength = o, t.header.featureTableBinaryByteLength = s, t.header.batchTableJsonByteLength = a, t.header.batchTableBinaryByteLength = A, t.header.batchLength = i, n;
}
function Rce(t, e, n, r) {
  return n = O1n(t, e, n), n = F1n(t, e, n), n;
}
function O1n(t, e, n, r) {
  const {
    featureTableJsonByteLength: i,
    featureTableBinaryByteLength: o,
    batchLength: s
  } = t.header;
  if (t.featureTableJson = {
    BATCH_LENGTH: s || 0
  }, i > 0) {
    const a = gYe(e, n, i);
    t.featureTableJson = JSON.parse(a);
  }
  return n += i, t.featureTableBinary = new Uint8Array(e, n, o), n += o, n;
}
function F1n(t, e, n, r) {
  const {
    batchTableJsonByteLength: i,
    batchTableBinaryByteLength: o
  } = t.header;
  if (i > 0) {
    const s = gYe(e, n, i);
    t.batchTableJson = JSON.parse(s), n += i, o > 0 && (t.batchTableBinary = new Uint8Array(e, n, o), t.batchTableBinary = new Uint8Array(t.batchTableBinary), n += o);
  }
  return n;
}
function pYe(t, e, n) {
  if (!e && (!t || !t.batchIds || !n))
    return null;
  const {
    batchIds: r,
    isRGB565: i,
    pointCount: o
  } = t;
  if (r && n) {
    const s = new Uint8ClampedArray(o * 3);
    for (let a = 0; a < o; a++) {
      const A = r[a], c = n.getProperty(A, "dimensions").map((u) => u * 255);
      s[a * 3] = c[0], s[a * 3 + 1] = c[1], s[a * 3 + 2] = c[2];
    }
    return {
      type: Pi.UNSIGNED_BYTE,
      value: s,
      size: 3,
      normalized: !0
    };
  }
  if (i) {
    const s = new Uint8ClampedArray(o * 3);
    for (let a = 0; a < o; a++) {
      const A = B1n(e[a]);
      s[a * 3] = A[0], s[a * 3 + 1] = A[1], s[a * 3 + 2] = A[2];
    }
    return {
      type: Pi.UNSIGNED_BYTE,
      value: s,
      size: 3,
      normalized: !0
    };
  }
  return e && e.length === o * 3 ? {
    type: Pi.UNSIGNED_BYTE,
    value: e,
    size: 3,
    normalized: !0
  } : {
    type: Pi.UNSIGNED_BYTE,
    value: e,
    size: 4,
    normalized: !0
  };
}
const VQe = new ct();
function P1n(t, e) {
  if (!e)
    return null;
  if (t.isOctEncoded16P) {
    const n = new Float32Array(t.pointsLength * 3);
    for (let r = 0; r < t.pointsLength; r++)
      _1n(e[r * 2], e[r * 2 + 1], VQe), VQe.toArray(n, r * 3);
    return {
      type: Pi.FLOAT,
      size: 2,
      value: n
    };
  }
  return {
    type: Pi.FLOAT,
    size: 2,
    value: e
  };
}
function k1n(t, e, n) {
  return t.isQuantized ? n["3d-tiles"] && n["3d-tiles"].decodeQuantizedPositions ? (t.isQuantized = !1, G1n(t, e)) : {
    type: Pi.UNSIGNED_SHORT,
    value: e,
    size: 3,
    normalized: !0
  } : e;
}
function G1n(t, e) {
  const n = new ct(), r = new Float32Array(t.pointCount * 3);
  for (let i = 0; i < t.pointCount; i++)
    n.set(e[i * 3], e[i * 3 + 1], e[i * 3 + 2]).scale(1 / t.quantizedRange).multiply(t.quantizedVolumeScale).add(t.quantizedVolumeOffset).toArray(r, i * 3);
  return r;
}
async function U1n(t, e, n, r, i) {
  n = x$(t, e, n), n = xce(t, e, n), n = Rce(t, e, n), H1n(t);
  const {
    featureTable: o,
    batchTable: s
  } = $1n(t);
  return await V1n(t, o, s, r, i), q1n(t, o, r), j1n(t, o, s), Y1n(t, o), n;
}
function H1n(t) {
  t.attributes = {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  }, t.isQuantized = !1, t.isTranslucent = !1, t.isRGB565 = !1, t.isOctEncoded16P = !1;
}
function $1n(t) {
  const e = new wce(t.featureTableJson, t.featureTableBinary), n = e.getGlobalProperty("POINTS_LENGTH");
  if (!Number.isFinite(n))
    throw new Error("POINTS_LENGTH must be defined");
  e.featuresLength = n, t.featuresLength = n, t.pointsLength = n, t.pointCount = n, t.rtcCenter = e.getGlobalProperty("RTC_CENTER", Pi.FLOAT, 3);
  const r = z1n(t, e);
  return {
    featureTable: e,
    batchTable: r
  };
}
function q1n(t, e, n) {
  if (!t.attributes.positions) {
    if (e.hasProperty("POSITION"))
      t.attributes.positions = e.getPropertyArray("POSITION", Pi.FLOAT, 3);
    else if (e.hasProperty("POSITION_QUANTIZED")) {
      const r = e.getPropertyArray("POSITION_QUANTIZED", Pi.UNSIGNED_SHORT, 3);
      if (t.isQuantized = !0, t.quantizedRange = 65536 - 1, t.quantizedVolumeScale = e.getGlobalProperty("QUANTIZED_VOLUME_SCALE", Pi.FLOAT, 3), !t.quantizedVolumeScale)
        throw new Error("QUANTIZED_VOLUME_SCALE must be defined for quantized positions.");
      if (t.quantizedVolumeOffset = e.getGlobalProperty("QUANTIZED_VOLUME_OFFSET", Pi.FLOAT, 3), !t.quantizedVolumeOffset)
        throw new Error("QUANTIZED_VOLUME_OFFSET must be defined for quantized positions.");
      t.attributes.positions = k1n(t, r, n);
    }
  }
  if (!t.attributes.positions)
    throw new Error("Either POSITION or POSITION_QUANTIZED must be defined.");
}
function j1n(t, e, n) {
  if (!t.attributes.colors) {
    let r = null;
    e.hasProperty("RGBA") ? (r = e.getPropertyArray("RGBA", Pi.UNSIGNED_BYTE, 4), t.isTranslucent = !0) : e.hasProperty("RGB") ? r = e.getPropertyArray("RGB", Pi.UNSIGNED_BYTE, 3) : e.hasProperty("RGB565") && (r = e.getPropertyArray("RGB565", Pi.UNSIGNED_SHORT, 1), t.isRGB565 = !0), t.attributes.colors = pYe(t, r, n);
  }
  e.hasProperty("CONSTANT_RGBA") && (t.constantRGBA = e.getGlobalProperty("CONSTANT_RGBA", Pi.UNSIGNED_BYTE, 4));
}
function Y1n(t, e) {
  if (!t.attributes.normals) {
    let n = null;
    e.hasProperty("NORMAL") ? n = e.getPropertyArray("NORMAL", Pi.FLOAT, 3) : e.hasProperty("NORMAL_OCT16P") && (n = e.getPropertyArray("NORMAL_OCT16P", Pi.UNSIGNED_BYTE, 2), t.isOctEncoded16P = !0), t.attributes.normals = P1n(t, n);
  }
}
function z1n(t, e) {
  let n = null;
  if (!t.batchIds && e.hasProperty("BATCH_ID") && (t.batchIds = e.getPropertyArray("BATCH_ID", Pi.UNSIGNED_SHORT, 1), t.batchIds)) {
    const r = e.getGlobalProperty("BATCH_LENGTH");
    if (!r)
      throw new Error("Global property: BATCH_LENGTH must be defined when BATCH_ID is defined.");
    const {
      batchTableJson: i,
      batchTableBinary: o
    } = t;
    n = new dYe(i, o, r);
  }
  return n;
}
async function V1n(t, e, n, r, i) {
  let o, s, a;
  const A = t.batchTableJson && t.batchTableJson.extensions && t.batchTableJson.extensions["3DTILES_draco_point_compression"];
  A && (a = A.properties);
  const l = e.getExtension("3DTILES_draco_point_compression");
  if (l) {
    s = l.properties;
    const u = l.byteOffset, f = l.byteLength;
    if (!s || !Number.isFinite(u) || !f)
      throw new Error("Draco properties, byteOffset, and byteLength must be defined");
    o = t.featureTableBinary.slice(u, u + f), t.hasPositions = Number.isFinite(s.POSITION), t.hasColors = Number.isFinite(s.RGB) || Number.isFinite(s.RGBA), t.hasNormals = Number.isFinite(s.NORMAL), t.hasBatchIds = Number.isFinite(s.BATCH_ID), t.isTranslucent = Number.isFinite(s.RGBA);
  }
  if (!o)
    return !0;
  const c = {
    buffer: o,
    properties: {
      ...s,
      ...a
    },
    featureTableProperties: s,
    batchTableProperties: a,
    dequantizeInShader: !1
  };
  return await J1n(t, c, r, i);
}
async function J1n(t, e, n, r) {
  const {
    parse: i
  } = r, o = {
    ...n,
    draco: {
      ...n.draco,
      extraAttributes: e.batchTableProperties || {}
    }
  };
  delete o["3d-tiles"];
  const s = await i(e.buffer, rYe, o), a = s.attributes.POSITION && s.attributes.POSITION.value, A = s.attributes.COLOR_0 && s.attributes.COLOR_0.value, l = s.attributes.NORMAL && s.attributes.NORMAL.value, c = s.attributes.BATCH_ID && s.attributes.BATCH_ID.value, u = a && s.attributes.POSITION.value.quantization, f = l && s.attributes.NORMAL.value.quantization;
  if (u) {
    const d = s.POSITION.data.quantization, I = d.range;
    t.quantizedVolumeScale = new ct(I, I, I), t.quantizedVolumeOffset = new ct(d.minValues), t.quantizedRange = (1 << d.quantizationBits) - 1, t.isQuantizedDraco = !0;
  }
  f && (t.octEncodedRange = (1 << s.NORMAL.data.quantization.quantizationBits) - 1, t.isOctEncodedDraco = !0);
  const h = {};
  if (e.batchTableProperties)
    for (const d of Object.keys(e.batchTableProperties))
      s.attributes[d] && s.attributes[d].value && (h[d.toLowerCase()] = s.attributes[d].value);
  t.attributes = {
    positions: a,
    colors: pYe(t, A, void 0),
    normals: l,
    batchIds: c,
    ...h
  };
}
const mte = {
  URI: 0,
  EMBEDDED: 1
};
function IYe(t, e, n, r) {
  t.rotateYtoZ = !0;
  const i = t.byteOffset + t.byteLength - n;
  if (i === 0)
    throw new Error("glTF byte length must be greater than 0.");
  return t.gltfUpAxis = r["3d-tiles"] && r["3d-tiles"].assetGltfUpAxis ? r["3d-tiles"].assetGltfUpAxis : "Y", t.gltfArrayBuffer = lle(e, n, i), t.gltfByteOffset = 0, t.gltfByteLength = i, n % 4 === 0 || console.warn("".concat(t.type, ": embedded glb is not aligned to a 4-byte boundary.")), t.byteOffset + t.byteLength;
}
async function mYe(t, e, n, r) {
  const i = n["3d-tiles"] || {};
  if (K1n(t, e), i.loadGLTF) {
    const {
      parse: o,
      fetch: s
    } = r;
    t.gltfUrl && (t.gltfArrayBuffer = await s(t.gltfUrl, n), t.gltfByteOffset = 0), t.gltfArrayBuffer && (t.gltf = await o(t.gltfArrayBuffer, KT, n, r), delete t.gltfArrayBuffer, delete t.gltfByteOffset, delete t.gltfByteLength);
  }
}
function K1n(t, e, n) {
  switch (e) {
    case mte.URI:
      const r = new Uint8Array(t.gltfArrayBuffer, t.gltfByteOffset), o = new TextDecoder().decode(r);
      t.gltfUrl = o.replace(/[\s\0]+$/, ""), delete t.gltfArrayBuffer, delete t.gltfByteOffset, delete t.gltfByteLength;
      break;
    case mte.EMBEDDED:
      break;
    default:
      throw new Error("b3dm: Illegal glTF format field");
  }
}
async function W1n(t, e, n, r, i) {
  var o;
  n = X1n(t, e, n, r), await mYe(t, mte.EMBEDDED, r, i);
  const s = t == null || (o = t.gltf) === null || o === void 0 ? void 0 : o.extensions;
  return s && s.CESIUM_RTC && (t.rtcCenter = s.CESIUM_RTC.center), n;
}
function X1n(t, e, n, r, i) {
  n = x$(t, e, n), n = xce(t, e, n), n = Rce(t, e, n), n = IYe(t, e, n, r);
  const o = new wce(t.featureTableJson, t.featureTableBinary);
  return t.rtcCenter = o.getGlobalProperty("RTC_CENTER", Pi.FLOAT, 3), n;
}
async function Z1n(t, e, n, r, i) {
  return n = ebn(t, e, n, r), await mYe(t, t.gltfFormat, r, i), n;
}
function ebn(t, e, n, r, i) {
  if (n = x$(t, e, n), t.version !== 1)
    throw new Error("Instanced 3D Model version ".concat(t.version, " is not supported"));
  n = xce(t, e, n);
  const o = new DataView(e);
  if (t.gltfFormat = o.getUint32(n, !0), n += 4, n = Rce(t, e, n), n = IYe(t, e, n, r), t.featureTableJsonByteLength === 0)
    throw new Error("i3dm parser: featureTableJsonByteLength is zero.");
  const s = new wce(t.featureTableJson, t.featureTableBinary), a = s.getGlobalProperty("INSTANCES_LENGTH");
  if (s.featuresLength = a, !Number.isFinite(a))
    throw new Error("i3dm parser: INSTANCES_LENGTH must be defined");
  t.eastNorthUp = s.getGlobalProperty("EAST_NORTH_UP"), t.rtcCenter = s.getGlobalProperty("RTC_CENTER", Pi.FLOAT, 3);
  const A = new dYe(t.batchTableJson, t.batchTableBinary, a);
  return tbn(t, s, A, a), n;
}
function tbn(t, e, n, r) {
  const o = {
    instances: new Array(r),
    batchTable: t._batchTable,
    cull: !1,
    url: void 0,
    gltf: void 0,
    basePath: void 0,
    incrementallyLoadTextures: !1,
    forwardAxis: [1, 0, 0]
  }.instances, s = new ct();
  new ct(), new ct(), new ct();
  const a = new ja(), A = new VC(), l = new ct(), c = {}, u = new pn(), f = [], h = [], d = new ct(), I = new ct();
  for (let m = 0; m < r; m++) {
    let C;
    if (e.hasProperty("POSITION"))
      C = e.getProperty("POSITION", Pi.FLOAT, 3, m, s);
    else if (e.hasProperty("POSITION_QUANTIZED")) {
      C = e.getProperty("POSITION_QUANTIZED", Pi.UNSIGNED_SHORT, 3, m, s);
      const R = e.getGlobalProperty("QUANTIZED_VOLUME_OFFSET", Pi.FLOAT, 3, d);
      if (!R)
        throw new Error("i3dm parser: QUANTIZED_VOLUME_OFFSET must be defined for quantized positions.");
      const M = e.getGlobalProperty("QUANTIZED_VOLUME_SCALE", Pi.FLOAT, 3, I);
      if (!M)
        throw new Error("i3dm parser: QUANTIZED_VOLUME_SCALE must be defined for quantized positions.");
      const O = 65535;
      for (let L = 0; L < 3; L++)
        C[L] = C[L] / O * M[L] + R[L];
    }
    if (!C)
      throw new Error("i3dm: POSITION or POSITION_QUANTIZED must be defined for each instance.");
    if (s.copy(C), c.translation = s, t.normalUp = e.getProperty("NORMAL_UP", Pi.FLOAT, 3, m, f), t.normalRight = e.getProperty("NORMAL_RIGHT", Pi.FLOAT, 3, m, h), t.normalUp) {
      if (!t.normalRight)
        throw new Error("i3dm: Custom orientation requires both NORMAL_UP and NORMAL_RIGHT.");
      t.hasCustomOrientation = !0;
    } else {
      if (t.octNormalUp = e.getProperty("NORMAL_UP_OCT32P", Pi.UNSIGNED_SHORT, 2, f), t.octNormalRight = e.getProperty("NORMAL_RIGHT_OCT32P", Pi.UNSIGNED_SHORT, 2, h), t.octNormalUp)
        throw t.octNormalRight ? new Error("i3dm: oct-encoded orientation not implemented") : new Error("i3dm: oct-encoded orientation requires NORMAL_UP_OCT32P and NORMAL_RIGHT_OCT32P");
      t.eastNorthUp ? (uA.WGS84.eastNorthUpToFixedFrame(s, u), u.getRotationMatrix3(a)) : a.identity();
    }
    A.fromMatrix3(a), c.rotation = A, l.set(1, 1, 1);
    const y = e.getProperty("SCALE", Pi.FLOAT, 1, m);
    Number.isFinite(y) && l.multiplyByScalar(y);
    const v = e.getProperty("SCALE_NON_UNIFORM", Pi.FLOAT, 3, m, f);
    v && l.scale(v), c.scale = l;
    let b = e.getProperty("BATCH_ID", Pi.UNSIGNED_SHORT, 1, m);
    b === void 0 && (b = m);
    const Q = new pn().fromQuaternion(c.rotation);
    u.identity(), u.translate(c.translation), u.multiplyRight(Q), u.scale(c.scale);
    const w = u.clone();
    o[m] = {
      modelMatrix: w,
      batchId: b
    };
  }
  t.instances = o;
}
async function nbn(t, e, n, r, i, o) {
  n = x$(t, e, n);
  const s = new DataView(e);
  for (t.tilesLength = s.getUint32(n, !0), n += 4, t.tiles = []; t.tiles.length < t.tilesLength && t.byteLength - n > 12; ) {
    const a = {};
    t.tiles.push(a), n = await o(e, n, r, i, a);
  }
  return n;
}
async function rbn(t, e, n, r) {
  t.rotateYtoZ = !0, t.gltfUpAxis = n["3d-tiles"] && n["3d-tiles"].assetGltfUpAxis ? n["3d-tiles"].assetGltfUpAxis : "Y";
  const {
    parse: i
  } = r;
  t.gltf = await i(e, KT, n, r);
}
async function CYe(t, e = 0, n, r, i = {}) {
  switch (i.byteOffset = e, i.type = C1n(t, e), i.type) {
    case p2.COMPOSITE:
      return await nbn(i, t, e, n, r, CYe);
    case p2.BATCHED_3D_MODEL:
      return await W1n(i, t, e, n, r);
    case p2.GLTF:
      return await rbn(i, t, n, r);
    case p2.INSTANCED_3D_MODEL:
      return await Z1n(i, t, e, n, r);
    case p2.POINT_CLOUD:
      return await U1n(i, t, e, n, r);
    default:
      throw new Error("3DTileLoader: unknown type ".concat(i.type));
  }
}
const ibn = 1952609651, obn = 1;
async function sbn(t) {
  if (new Uint32Array(t.slice(0, 4))[0] !== ibn)
    throw new Error("Wrong subtree file magic number");
  if (new Uint32Array(t.slice(4, 8))[0] !== obn)
    throw new Error("Wrong subtree file verson, must be 1");
  const r = JQe(t.slice(8, 16)), i = new Uint8Array(t, 24, r), s = new TextDecoder("utf8").decode(i), a = JSON.parse(s), A = JQe(t.slice(16, 24));
  let l = new ArrayBuffer(0);
  return A && (l = t.slice(24 + r)), "bufferView" in a.tileAvailability && (a.tileAvailability.explicitBitstream = await XV(a, "tileAvailability", l)), "bufferView" in a.contentAvailability && (a.contentAvailability.explicitBitstream = await XV(a, "contentAvailability", l)), "bufferView" in a.childSubtreeAvailability && (a.childSubtreeAvailability.explicitBitstream = await XV(a, "childSubtreeAvailability", l)), a;
}
async function XV(t, e, n) {
  const r = t[e].bufferView, i = t.bufferViews[r], o = t.buffers[i.buffer];
  if (o.uri) {
    const a = await (await xee(o.uri)).arrayBuffer();
    return new Uint8Array(a, i.byteOffset, i.byteLength);
  }
  return new Uint8Array(n, i.byteOffset, i.byteLength);
}
function JQe(t) {
  const e = new DataView(t), n = e.getUint32(0, !0), r = e.getUint32(4, !0);
  return n + 2 ** 32 * r;
}
const EYe = {
  id: "3d-tiles-subtree",
  name: "3D Tiles Subtree",
  module: "3d-tiles",
  version: fYe,
  extensions: ["subtree"],
  mimeTypes: ["application/octet-stream"],
  tests: ["subtree"],
  parse: sbn,
  options: {}
}, abn = 4, Abn = 8, lbn = {
  QUADTREE: abn,
  OCTREE: Abn
};
async function yYe(t) {
  const {
    options: e,
    parentData: n = {
      mortonIndex: 0,
      x: 0,
      y: 0,
      z: 0
    },
    childIndex: r = 0,
    globalData: i = {
      level: 0,
      mortonIndex: 0,
      x: 0,
      y: 0,
      z: 0
    }
  } = t;
  let {
    subtree: o,
    level: s = 0
  } = t;
  const {
    subdivisionScheme: a,
    subtreeLevels: A,
    maximumLevel: l,
    contentUrlTemplate: c,
    subtreesUriTemplate: u,
    basePath: f
  } = e, h = {
    children: [],
    lodMetricValue: 0,
    contentUrl: ""
  }, d = lbn[a], I = r & 1, m = r >> 1 & 1, C = r >> 2 & 1, y = (d ** s - 1) / (d - 1);
  let v = Iy(n.mortonIndex, r), b = y + v, Q = Iy(n.x, I), w = Iy(n.y, m), R = Iy(n.z, C), M = !1;
  s + 1 > A && (M = ZV(o.childSubtreeAvailability, v));
  const O = Iy(i.x, Q), L = Iy(i.y, w), N = Iy(i.z, R), k = s + i.level;
  if (M) {
    const z = "".concat(f, "/").concat(u), Y = Cte(z, k, O, L, N);
    o = await TI(Y, EYe), i.mortonIndex = v, i.x = Q, i.y = w, i.z = R, i.level = s, v = 0, b = 0, Q = 0, w = 0, R = 0, s = 0;
  }
  if (!ZV(o.tileAvailability, b) || s > l)
    return h;
  ZV(o.contentAvailability, b) && (h.contentUrl = Cte(c, k, O, L, N));
  const X = s + 1, K = {
    mortonIndex: v,
    x: Q,
    y: w,
    z: R
  };
  for (let z = 0; z < d; z++) {
    const Y = await yYe({
      subtree: o,
      options: e,
      parentData: K,
      childIndex: z,
      level: X,
      globalData: i
    });
    if (Y.contentUrl || Y.children.length) {
      const V = k + 1, ce = cbn(Y, V, {
        childTileX: Q,
        childTileY: w,
        childTileZ: R
      }, e);
      h.children.push(ce);
    }
  }
  return h;
}
function ZV(t, e) {
  return "constant" in t ? !!t.constant : t.explicitBitstream ? gbn(e, t.explicitBitstream) : !1;
}
function cbn(t, e, n, r) {
  const {
    basePath: i,
    refine: o,
    getRefine: s,
    lodMetricType: a,
    getTileType: A,
    rootLodMetricValue: l,
    rootBoundingVolume: c
  } = r, u = t.contentUrl && t.contentUrl.replace("".concat(i, "/"), ""), f = l / 2 ** e, h = ubn(e, c, n);
  return {
    children: t.children,
    contentUrl: t.contentUrl,
    content: {
      uri: u
    },
    id: t.contentUrl,
    refine: s(o),
    type: A(t),
    lodMetricType: a,
    lodMetricValue: f,
    boundingVolume: h
  };
}
function ubn(t, e, n) {
  if (e.region) {
    const {
      childTileX: r,
      childTileY: i,
      childTileZ: o
    } = n, [s, a, A, l, c, u] = e.region, f = 2 ** t, h = (A - s) / f, d = (l - a) / f, I = (u - c) / f, [m, C] = [s + h * r, s + h * (r + 1)], [y, v] = [a + d * i, a + d * (i + 1)], [b, Q] = [c + I * o, c + I * (o + 1)];
    return {
      region: [m, y, C, v, b, Q]
    };
  }
  return console.warn("Unsupported bounding volume type: ", e), null;
}
function Iy(t, e) {
  return parseInt(t.toString(2) + e.toString(2), 2);
}
function Cte(t, e, n, r, i) {
  const o = fbn({
    level: e,
    x: n,
    y: r,
    z: i
  });
  return t.replace(/{level}|{x}|{y}|{z}/gi, (s) => o[s]);
}
function fbn(t) {
  const e = {};
  for (const n in t)
    e["{".concat(n, "}")] = t[n];
  return e;
}
function gbn(t, e) {
  const n = Math.floor(t / 8), r = t % 8;
  return (e[n] >> r & 1) === 1;
}
function Dce(t) {
  if (!t.contentUrl)
    return z_.EMPTY;
  const n = t.contentUrl.split(".").pop();
  switch (n) {
    case "pnts":
      return z_.POINTCLOUD;
    case "i3dm":
    case "b3dm":
    case "glb":
    case "gltf":
      return z_.SCENEGRAPH;
    default:
      return n;
  }
}
function Tce(t) {
  switch (t) {
    case "REPLACE":
    case "replace":
      return CI.REPLACE;
    case "ADD":
    case "add":
      return CI.ADD;
    default:
      return t;
  }
}
function Ete(t, e) {
  if (/^[a-z][0-9a-z+.-]*:/i.test(e)) {
    const r = new URL(t, "".concat(e, "/"));
    return decodeURI(r.toString());
  } else if (t.startsWith("/"))
    return t;
  return "".concat(e, "/").concat(t);
}
function KQe(t, e) {
  if (!t)
    return null;
  if (t.content) {
    const n = t.content.uri || t.content.url;
    t.contentUrl = Ete(n, e.basePath);
  }
  return t.id = t.contentUrl, t.lodMetricType = Q$.GEOMETRIC_ERROR, t.lodMetricValue = t.geometricError, t.transformMatrix = t.transform, t.type = Dce(t), t.refine = Tce(t.refine), t;
}
function hbn(t) {
  const e = t.basePath, n = KQe(t.root, t), r = [];
  for (r.push(n); r.length > 0; ) {
    const o = (r.pop() || {}).children || [];
    for (const s of o)
      KQe(s, {
        basePath: e
      }), r.push(s);
  }
  return n;
}
async function dbn(t) {
  if (!t.root)
    return null;
  const e = t.basePath, n = t.root.extensions["3DTILES_implicit_tiling"], {
    subdivisionScheme: r,
    maximumLevel: i,
    subtreeLevels: o,
    subtrees: {
      uri: s
    }
  } = n, a = Cte(s, 0, 0, 0, 0), A = Ete(a, e), l = await TI(A, EYe), c = Ete(t.root.content.uri, e), u = t.root.refine, f = t.root.geometricError, h = t.root.boundingVolume, d = {
    contentUrlTemplate: c,
    subtreesUriTemplate: s,
    subdivisionScheme: r,
    subtreeLevels: o,
    maximumLevel: i,
    refine: u,
    basePath: e,
    lodMetricType: Q$.GEOMETRIC_ERROR,
    rootLodMetricValue: f,
    rootBoundingVolume: h,
    getTileType: Dce,
    getRefine: Tce
  };
  return await pbn(t.root, l, d);
}
async function pbn(t, e, n) {
  if (!t)
    return null;
  t.lodMetricType = Q$.GEOMETRIC_ERROR, t.lodMetricValue = t.geometricError, t.transformMatrix = t.transform;
  const {
    children: r,
    contentUrl: i
  } = await yYe({
    subtree: e,
    options: n
  });
  return i && (t.contentUrl = i, t.content = {
    uri: i.replace("".concat(n.basePath, "/"), "")
  }), t.refine = Tce(t.refine), t.type = Dce(t), t.children = r, t.id = t.contentUrl, t;
}
const WQe = "3DTILES_implicit_tiling", vYe = {
  id: "3d-tiles",
  name: "3D Tiles",
  module: "3d-tiles",
  version: fYe,
  extensions: ["cmpt", "pnts", "b3dm", "i3dm"],
  mimeTypes: ["application/octet-stream"],
  tests: ["cmpt", "pnts", "b3dm", "i3dm"],
  parse: Ebn,
  options: {
    "3d-tiles": {
      loadGLTF: !0,
      decodeQuantizedPositions: !1,
      isTileset: "auto",
      assetGltfUpAxis: null
    }
  }
};
function Ibn(t) {
  return d9e(t.url);
}
async function mbn(t, e, n) {
  const r = {
    content: {
      featureIds: null
    }
  };
  return await CYe(t, 0, e, n, r.content), r.content;
}
async function Cbn(t, e, n) {
  var r;
  const i = JSON.parse(new TextDecoder().decode(t));
  return i.loader = e.loader || vYe, i.url = n.url, i.basePath = Ibn(i), i.root = ybn(i) ? await dbn(i) : hbn(i), i.type = Ap.TILES3D, i.lodMetricType = Q$.GEOMETRIC_ERROR, i.lodMetricValue = ((r = i.root) === null || r === void 0 ? void 0 : r.lodMetricValue) || 0, i;
}
async function Ebn(t, e, n) {
  const r = e["3d-tiles"] || {};
  let i;
  return r.isTileset === "auto" ? i = n.url && n.url.indexOf(".json") !== -1 : i = r.isTileset, i ? t = await Cbn(t, e, n) : t = await mbn(t, e, n), t;
}
function ybn(t) {
  var e, n;
  return (t == null || (e = t.extensionsRequired) === null || e === void 0 ? void 0 : e.includes(WQe)) && (t == null || (n = t.extensionsUsed) === null || n === void 0 ? void 0 : n.includes(WQe));
}
const XQe = [0], vbn = {
  getPointColor: {
    type: "accessor",
    value: [0, 0, 0, 255]
  },
  pointSize: 1,
  data: null,
  loader: vYe,
  onTilesetLoad: {
    type: "function",
    value: (t) => {
    },
    compare: !1
  },
  onTileLoad: {
    type: "function",
    value: (t) => {
    },
    compare: !1
  },
  onTileUnload: {
    type: "function",
    value: (t) => {
    },
    compare: !1
  },
  onTileError: {
    type: "function",
    value: (t, e, n) => {
    },
    compare: !1
  },
  _getMeshColor: {
    type: "function",
    value: (t) => [255, 255, 255],
    compare: !1
  }
};
class Nce extends mA {
  constructor(...e) {
    super(...e), ae(this, "state", void 0);
  }
  initializeState() {
    "onTileLoadFail" in this.props && Rr.removed("onTileLoadFail", "onTileError")(), this.state = {
      layerMap: {},
      tileset3d: null,
      activeViewports: {},
      lastUpdatedViewports: null
    };
  }
  get isLoaded() {
    const {
      tileset3d: e
    } = this.state;
    return e !== null && e.isLoaded();
  }
  shouldUpdateState({
    changeFlags: e
  }) {
    return e.somethingChanged;
  }
  updateState({
    props: e,
    oldProps: n,
    changeFlags: r
  }) {
    if (e.data && e.data !== n.data && this._loadTileset(e.data), r.viewportChanged) {
      const {
        activeViewports: i
      } = this.state;
      Object.keys(i).length && (this._updateTileset(i), this.state.lastUpdatedViewports = i, this.state.activeViewports = {});
    }
    if (r.propsChanged) {
      const {
        layerMap: i
      } = this.state;
      for (const o in i)
        i[o].needsUpdate = !0;
    }
  }
  activateViewport(e) {
    const {
      activeViewports: n,
      lastUpdatedViewports: r
    } = this.state;
    this.internalState.viewport = e, n[e.id] = e;
    const i = r?.[e.id];
    (!i || !e.equals(i)) && (this.setChangeFlags({
      viewportChanged: !0
    }), this.setNeedsUpdate());
  }
  getPickingInfo({
    info: e,
    sourceLayer: n
  }) {
    const r = n && n.props.tile;
    return e.picked && (e.object = r), e.sourceTile = r, e;
  }
  filterSubLayer({
    layer: e,
    viewport: n
  }) {
    const {
      tile: r
    } = e.props, {
      id: i
    } = n;
    return r.selected && r.viewportIds.includes(i);
  }
  _updateAutoHighlight(e) {
    const n = e.sourceTile, r = this.state.layerMap[n?.id];
    r && r.layer && r.layer.updateAutoHighlight(e);
  }
  async _loadTileset(e) {
    const {
      loadOptions: n = {}
    } = this.props;
    let r = this.props.loader || this.props.loaders;
    Array.isArray(r) && (r = r[0]);
    const i = {
      loadOptions: {
        ...n
      }
    };
    if (r.preload) {
      const a = await r.preload(e, n);
      a.headers && (i.loadOptions.fetch = {
        ...i.loadOptions.fetch,
        headers: a.headers
      }), Object.assign(i, a);
    }
    const o = await TI(e, r, i.loadOptions), s = new I1n(o, {
      onTileLoad: this._onTileLoad.bind(this),
      onTileUnload: this._onTileUnload.bind(this),
      onTileError: this.props.onTileError,
      ...i
    });
    this.setState({
      tileset3d: s,
      layerMap: {}
    }), this._updateTileset(this.state.activeViewports), this.props.onTilesetLoad(s);
  }
  _onTileLoad(e) {
    const {
      lastUpdatedViewports: n
    } = this.state;
    this.props.onTileLoad(e), this._updateTileset(n), this.setNeedsUpdate();
  }
  _onTileUnload(e) {
    delete this.state.layerMap[e.id], this.props.onTileUnload(e);
  }
  _updateTileset(e) {
    if (!e)
      return;
    const {
      tileset3d: n
    } = this.state, {
      timeline: r
    } = this.context, i = Object.keys(e).length;
    !r || !i || !n || n.selectTiles(Object.values(e)).then((o) => {
      this.state.frameNumber !== o && this.setState({
        frameNumber: o
      });
    });
  }
  _getSubLayer(e, n) {
    if (!e.content)
      return null;
    switch (e.type) {
      case z_.POINTCLOUD:
        return this._makePointCloudLayer(e, n);
      case z_.SCENEGRAPH:
        return this._make3DModelLayer(e);
      case z_.MESH:
        return this._makeSimpleMeshLayer(e, n);
      default:
        throw new Error("Tile3DLayer: Failed to render layer of type ".concat(e.content.type));
    }
  }
  _makePointCloudLayer(e, n) {
    const {
      attributes: r,
      pointCount: i,
      constantRGBA: o,
      cartographicOrigin: s,
      modelMatrix: a
    } = e.content, {
      positions: A,
      normals: l,
      colors: c
    } = r;
    if (!A)
      return null;
    const u = n && n.props.data || {
      header: {
        vertexCount: i
      },
      attributes: {
        POSITION: A,
        NORMAL: l,
        COLOR_0: c
      }
    }, {
      pointSize: f,
      getPointColor: h
    } = this.props, d = this.getSubLayerClass("pointcloud", h$);
    return new d({
      pointSize: f
    }, this.getSubLayerProps({
      id: "pointcloud"
    }), {
      id: "".concat(this.id, "-pointcloud-").concat(e.id),
      tile: e,
      data: u,
      coordinateSystem: wn.METER_OFFSETS,
      coordinateOrigin: s,
      modelMatrix: a,
      getColor: o || h,
      _offset: 0
    });
  }
  _make3DModelLayer(e) {
    const {
      gltf: n,
      instances: r,
      cartographicOrigin: i,
      modelMatrix: o
    } = e.content, s = this.getSubLayerClass("scenegraph", _$);
    return new s({
      _lighting: "pbr"
    }, this.getSubLayerProps({
      id: "scenegraph"
    }), {
      id: "".concat(this.id, "-scenegraph-").concat(e.id),
      tile: e,
      data: r || XQe,
      scenegraph: n,
      coordinateSystem: wn.METER_OFFSETS,
      coordinateOrigin: i,
      modelMatrix: o,
      getTransformMatrix: (a) => a.modelMatrix,
      getPosition: [0, 0, 0],
      _offset: 0
    });
  }
  _makeSimpleMeshLayer(e, n) {
    const r = e.content, {
      attributes: i,
      indices: o,
      modelMatrix: s,
      cartographicOrigin: a,
      coordinateSystem: A = wn.METER_OFFSETS,
      material: l,
      featureIds: c
    } = r, {
      _getMeshColor: u
    } = this.props, f = n && n.props.mesh || new Os({
      drawMode: 4,
      attributes: Bbn(i),
      indices: o
    }), h = this.getSubLayerClass("mesh", Qce);
    return new h(this.getSubLayerProps({
      id: "mesh"
    }), {
      id: "".concat(this.id, "-mesh-").concat(e.id),
      tile: e,
      mesh: f,
      data: XQe,
      getColor: u(e),
      pbrMaterial: l,
      modelMatrix: s,
      coordinateOrigin: a,
      coordinateSystem: A,
      featureIds: c,
      _offset: 0
    });
  }
  renderLayers() {
    const {
      tileset3d: e,
      layerMap: n
    } = this.state;
    return e ? e.tiles.map((r) => {
      const i = n[r.id] = n[r.id] || {
        tile: r
      };
      let {
        layer: o
      } = i;
      return r.selected && (o ? i.needsUpdate && (o = this._getSubLayer(r, o), i.needsUpdate = !1) : o = this._getSubLayer(r)), i.layer = o, o;
    }).filter(Boolean) : null;
  }
}
ae(Nce, "defaultProps", vbn);
ae(Nce, "layerName", "Tile3DLayer");
function Bbn(t) {
  const e = {};
  return e.positions = {
    ...t.positions,
    value: new Float32Array(t.positions.value)
  }, t.normals && (e.normals = t.normals), t.texCoords && (e.texCoords = t.texCoords), t.colors && (e.colors = t.colors), t.uvRegions && (e.uvRegions = t.uvRegions), e;
}
function bbn(t, e, n, r) {
  const i = r ? Sbn(r, t.POSITION.value) : _bn(e), o = new t.POSITION.value.constructor(i.length * 6), s = new t.TEXCOORD_0.value.constructor(i.length * 4), a = new e.constructor(i.length * 6);
  for (let l = 0; l < i.length; l++) {
    const c = i[l];
    Qbn({
      edge: c,
      edgeIndex: l,
      attributes: t,
      skirtHeight: n,
      newPosition: o,
      newTexcoord0: s,
      newTriangles: a
    });
  }
  t.POSITION.value = eV(t.POSITION.value, o), t.TEXCOORD_0.value = eV(t.TEXCOORD_0.value, s);
  const A = e instanceof Array ? e.concat(a) : eV(e, a);
  return {
    attributes: t,
    triangles: A
  };
}
function _bn(t) {
  const e = [];
  for (let s = 0; s < t.length; s += 3)
    e.push([t[s], t[s + 1]]), e.push([t[s + 1], t[s + 2]]), e.push([t[s + 2], t[s]]);
  e.sort((s, a) => Math.min(...s) - Math.min(...a) || Math.max(...s) - Math.max(...a));
  const n = [];
  let r = 0;
  for (; r < e.length; ) {
    var i, o;
    e[r][0] === ((i = e[r + 1]) === null || i === void 0 ? void 0 : i[1]) && e[r][1] === ((o = e[r + 1]) === null || o === void 0 ? void 0 : o[0]) ? r += 2 : (n.push(e[r]), r++);
  }
  return n;
}
function Sbn(t, e) {
  t.westIndices.sort((r, i) => e[3 * r + 1] - e[3 * i + 1]), t.eastIndices.sort((r, i) => e[3 * i + 1] - e[3 * r + 1]), t.southIndices.sort((r, i) => e[3 * i] - e[3 * r]), t.northIndices.sort((r, i) => e[3 * r] - e[3 * i]);
  const n = [];
  for (const r in t) {
    const i = t[r];
    for (let o = 0; o < i.length - 1; o++)
      n.push([i[o], i[o + 1]]);
  }
  return n;
}
function Qbn({
  edge: t,
  edgeIndex: e,
  attributes: n,
  skirtHeight: r,
  newPosition: i,
  newTexcoord0: o,
  newTriangles: s
}) {
  const a = n.POSITION.value.length, A = e * 2, l = e * 2 + 1;
  i.set(n.POSITION.value.subarray(t[0] * 3, t[0] * 3 + 3), A * 3), i[A * 3 + 2] = i[A * 3 + 2] - r, i.set(n.POSITION.value.subarray(t[1] * 3, t[1] * 3 + 3), l * 3), i[l * 3 + 2] = i[l * 3 + 2] - r, o.set(n.TEXCOORD_0.value.subarray(t[0] * 2, t[0] * 2 + 2), A * 2), o.set(n.TEXCOORD_0.value.subarray(t[1] * 2, t[1] * 2 + 2), l * 2);
  const c = e * 2 * 3;
  s[c] = t[0], s[c + 1] = a / 3 + l, s[c + 2] = t[1], s[c + 3] = a / 3 + l, s[c + 4] = t[0], s[c + 5] = a / 3 + A;
}
class wbn {
  constructor(e = 257) {
    this.gridSize = e;
    const n = e - 1;
    if (n & n - 1)
      throw new Error(
        `Expected grid size to be 2^n+1, got ${e}.`
      );
    this.numTriangles = n * n * 2 - 2, this.numParentTriangles = this.numTriangles - n * n, this.indices = new Uint32Array(this.gridSize * this.gridSize), this.coords = new Uint16Array(this.numTriangles * 4);
    for (let r = 0; r < this.numTriangles; r++) {
      let i = r + 2, o = 0, s = 0, a = 0, A = 0, l = 0, c = 0;
      for (i & 1 ? a = A = l = n : o = s = c = n; (i >>= 1) > 1; ) {
        const f = o + a >> 1, h = s + A >> 1;
        i & 1 ? (a = o, A = s, o = l, s = c) : (o = a, s = A, a = l, A = c), l = f, c = h;
      }
      const u = r * 4;
      this.coords[u + 0] = o, this.coords[u + 1] = s, this.coords[u + 2] = a, this.coords[u + 3] = A;
    }
  }
  createTile(e) {
    return new xbn(e, this);
  }
}
class xbn {
  constructor(e, n) {
    const r = n.gridSize;
    if (e.length !== r * r)
      throw new Error(
        `Expected terrain data of length ${r * r} (${r} x ${r}), got ${e.length}.`
      );
    this.terrain = e, this.martini = n, this.errors = new Float32Array(e.length), this.update();
  }
  update() {
    const { numTriangles: e, numParentTriangles: n, coords: r, gridSize: i } = this.martini, { terrain: o, errors: s } = this;
    for (let a = e - 1; a >= 0; a--) {
      const A = a * 4, l = r[A + 0], c = r[A + 1], u = r[A + 2], f = r[A + 3], h = l + u >> 1, d = c + f >> 1, I = h + d - c, m = d + l - h, C = (o[c * i + l] + o[f * i + u]) / 2, y = d * i + h, v = Math.abs(C - o[y]);
      if (s[y] = Math.max(s[y], v), a < n) {
        const b = (c + m >> 1) * i + (l + I >> 1), Q = (f + m >> 1) * i + (u + I >> 1);
        s[y] = Math.max(s[y], s[b], s[Q]);
      }
    }
  }
  getMesh(e = 0) {
    const { gridSize: n, indices: r } = this.martini, { errors: i } = this;
    let o = 0, s = 0;
    const a = n - 1;
    r.fill(0);
    function A(h, d, I, m, C, y) {
      const v = h + I >> 1, b = d + m >> 1;
      Math.abs(h - C) + Math.abs(d - y) > 1 && i[b * n + v] > e ? (A(C, y, h, d, v, b), A(I, m, C, y, v, b)) : (r[d * n + h] = r[d * n + h] || ++o, r[m * n + I] = r[m * n + I] || ++o, r[y * n + C] = r[y * n + C] || ++o, s++);
    }
    A(0, 0, a, a, a, 0), A(a, a, 0, 0, 0, a);
    const l = new Uint16Array(o * 2), c = new Uint32Array(s * 3);
    let u = 0;
    function f(h, d, I, m, C, y) {
      const v = h + I >> 1, b = d + m >> 1;
      if (Math.abs(h - C) + Math.abs(d - y) > 1 && i[b * n + v] > e)
        f(C, y, h, d, v, b), f(I, m, C, y, v, b);
      else {
        const Q = r[d * n + h] - 1, w = r[m * n + I] - 1, R = r[y * n + C] - 1;
        l[2 * Q] = h, l[2 * Q + 1] = d, l[2 * w] = I, l[2 * w + 1] = m, l[2 * R] = C, l[2 * R + 1] = y, c[u++] = Q, c[u++] = w, c[u++] = R;
      }
    }
    return f(0, 0, a, a, a, 0), f(a, a, 0, 0, 0, a), { vertices: l, triangles: c };
  }
}
class Rbn {
  constructor(e, n, r = n) {
    this.data = e, this.width = n, this.height = r, this.coords = [], this.triangles = [], this._halfedges = [], this._candidates = [], this._queueIndices = [], this._queue = [], this._errors = [], this._rms = [], this._pending = [], this._pendingLen = 0, this._rmsSum = 0;
    const i = n - 1, o = r - 1, s = this._addPoint(0, 0), a = this._addPoint(i, 0), A = this._addPoint(0, o), l = this._addPoint(i, o), c = this._addTriangle(l, s, A, -1, -1, -1);
    this._addTriangle(s, l, a, c, -1, -1), this._flush();
  }
  run(e = 1) {
    for (; this.getMaxError() > e; )
      this.refine();
  }
  refine() {
    this._step(), this._flush();
  }
  getMaxError() {
    return this._errors[0];
  }
  getRMSD() {
    return this._rmsSum > 0 ? Math.sqrt(this._rmsSum / (this.width * this.height)) : 0;
  }
  heightAt(e, n) {
    return this.data[this.width * n + e];
  }
  _flush() {
    const e = this.coords;
    for (let n = 0; n < this._pendingLen; n++) {
      const r = this._pending[n], i = 2 * this.triangles[r * 3 + 0], o = 2 * this.triangles[r * 3 + 1], s = 2 * this.triangles[r * 3 + 2];
      this._findCandidate(e[i], e[i + 1], e[o], e[o + 1], e[s], e[s + 1], r);
    }
    this._pendingLen = 0;
  }
  _findCandidate(e, n, r, i, o, s, a) {
    const A = Math.min(e, r, o), l = Math.min(n, i, s), c = Math.max(e, r, o), u = Math.max(n, i, s);
    let f = my(r, i, o, s, A, l), h = my(o, s, e, n, A, l), d = my(e, n, r, i, A, l);
    const I = i - n, m = e - r, C = s - i, y = r - o, v = n - s, b = o - e, Q = my(e, n, r, i, o, s), w = this.heightAt(e, n) / Q, R = this.heightAt(r, i) / Q, M = this.heightAt(o, s) / Q;
    let O = 0, L = 0, N = 0, k = 0;
    for (let $ = l; $ <= u; $++) {
      let U = 0;
      f < 0 && C !== 0 && (U = Math.max(U, Math.floor(-f / C))), h < 0 && v !== 0 && (U = Math.max(U, Math.floor(-h / v))), d < 0 && I !== 0 && (U = Math.max(U, Math.floor(-d / I)));
      let X = f + C * U, K = h + v * U, z = d + I * U, Y = !1;
      for (let V = A + U; V <= c; V++) {
        if (X >= 0 && K >= 0 && z >= 0) {
          Y = !0;
          const Z = w * X + R * K + M * z, ce = Math.abs(Z - this.heightAt(V, $));
          k += ce * ce, ce > O && (O = ce, L = V, N = $);
        } else if (Y)
          break;
        X += C, K += v, z += I;
      }
      f += y, h += b, d += m;
    }
    (L === e && N === n || L === r && N === i || L === o && N === s) && (O = 0), this._candidates[2 * a] = L, this._candidates[2 * a + 1] = N, this._rms[a] = k, this._queuePush(a, O, k);
  }
  _step() {
    const e = this._queuePop(), n = e * 3 + 0, r = e * 3 + 1, i = e * 3 + 2, o = this.triangles[n], s = this.triangles[r], a = this.triangles[i], A = this.coords[2 * o], l = this.coords[2 * o + 1], c = this.coords[2 * s], u = this.coords[2 * s + 1], f = this.coords[2 * a], h = this.coords[2 * a + 1], d = this._candidates[2 * e], I = this._candidates[2 * e + 1], m = this._addPoint(d, I);
    if (my(A, l, c, u, d, I) === 0)
      this._handleCollinear(m, n);
    else if (my(c, u, f, h, d, I) === 0)
      this._handleCollinear(m, r);
    else if (my(f, h, A, l, d, I) === 0)
      this._handleCollinear(m, i);
    else {
      const C = this._halfedges[n], y = this._halfedges[r], v = this._halfedges[i], b = this._addTriangle(o, s, m, C, -1, -1, n), Q = this._addTriangle(s, a, m, y, -1, b + 1), w = this._addTriangle(a, o, m, v, b + 2, Q + 1);
      this._legalize(b), this._legalize(Q), this._legalize(w);
    }
  }
  _addPoint(e, n) {
    const r = this.coords.length >> 1;
    return this.coords.push(e, n), r;
  }
  _addTriangle(e, n, r, i, o, s, a = this.triangles.length) {
    const A = a / 3;
    return this.triangles[a + 0] = e, this.triangles[a + 1] = n, this.triangles[a + 2] = r, this._halfedges[a + 0] = i, this._halfedges[a + 1] = o, this._halfedges[a + 2] = s, i >= 0 && (this._halfedges[i] = a + 0), o >= 0 && (this._halfedges[o] = a + 1), s >= 0 && (this._halfedges[s] = a + 2), this._candidates[2 * A + 0] = 0, this._candidates[2 * A + 1] = 0, this._queueIndices[A] = -1, this._rms[A] = 0, this._pending[this._pendingLen++] = A, a;
  }
  _legalize(e) {
    const n = this._halfedges[e];
    if (n < 0)
      return;
    const r = e - e % 3, i = n - n % 3, o = r + (e + 1) % 3, s = r + (e + 2) % 3, a = i + (n + 2) % 3, A = i + (n + 1) % 3, l = this.triangles[s], c = this.triangles[e], u = this.triangles[o], f = this.triangles[a], h = this.coords;
    if (!Dbn(h[2 * l], h[2 * l + 1], h[2 * c], h[2 * c + 1], h[2 * u], h[2 * u + 1], h[2 * f], h[2 * f + 1]))
      return;
    const d = this._halfedges[o], I = this._halfedges[s], m = this._halfedges[a], C = this._halfedges[A];
    this._queueRemove(r / 3), this._queueRemove(i / 3);
    const y = this._addTriangle(l, f, u, -1, m, d, r), v = this._addTriangle(f, l, c, y, I, C, i);
    this._legalize(y + 1), this._legalize(v + 2);
  }
  _handleCollinear(e, n) {
    const r = n - n % 3, i = r + (n + 1) % 3, o = r + (n + 2) % 3, s = this.triangles[o], a = this.triangles[n], A = this.triangles[i], l = this._halfedges[i], c = this._halfedges[o], u = this._halfedges[n];
    if (u < 0) {
      const w = this._addTriangle(e, s, a, -1, c, -1, r), R = this._addTriangle(s, e, A, w, -1, l);
      this._legalize(w + 1), this._legalize(R + 2);
      return;
    }
    const f = u - u % 3, h = f + (u + 2) % 3, d = f + (u + 1) % 3, I = this.triangles[h], m = this._halfedges[h], C = this._halfedges[d];
    this._queueRemove(f / 3);
    const y = this._addTriangle(s, a, e, c, -1, -1, r), v = this._addTriangle(a, I, e, C, -1, y + 1, f), b = this._addTriangle(I, A, e, m, -1, v + 1), Q = this._addTriangle(A, s, e, l, y + 2, b + 1);
    this._legalize(y), this._legalize(v), this._legalize(b), this._legalize(Q);
  }
  _queuePush(e, n, r) {
    const i = this._queue.length;
    this._queueIndices[e] = i, this._queue.push(e), this._errors.push(n), this._rmsSum += r, this._queueUp(i);
  }
  _queuePop() {
    const e = this._queue.length - 1;
    return this._queueSwap(0, e), this._queueDown(0, e), this._queuePopBack();
  }
  _queuePopBack() {
    const e = this._queue.pop();
    return this._errors.pop(), this._rmsSum -= this._rms[e], this._queueIndices[e] = -1, e;
  }
  _queueRemove(e) {
    const n = this._queueIndices[e];
    if (n < 0) {
      const i = this._pending.indexOf(e);
      if (i !== -1)
        this._pending[i] = this._pending[--this._pendingLen];
      else
        throw new Error("Broken triangulation (something went wrong).");
      return;
    }
    const r = this._queue.length - 1;
    r !== n && (this._queueSwap(n, r), this._queueDown(n, r) || this._queueUp(n)), this._queuePopBack();
  }
  _queueLess(e, n) {
    return this._errors[e] > this._errors[n];
  }
  _queueSwap(e, n) {
    const r = this._queue[e], i = this._queue[n];
    this._queue[e] = i, this._queue[n] = r, this._queueIndices[r] = n, this._queueIndices[i] = e;
    const o = this._errors[e];
    this._errors[e] = this._errors[n], this._errors[n] = o;
  }
  _queueUp(e) {
    let n = e;
    for (; ; ) {
      const r = n - 1 >> 1;
      if (r === n || !this._queueLess(n, r))
        break;
      this._queueSwap(r, n), n = r;
    }
  }
  _queueDown(e, n) {
    let r = e;
    for (; ; ) {
      const i = 2 * r + 1;
      if (i >= n || i < 0)
        break;
      const o = i + 1;
      let s = i;
      if (o < n && this._queueLess(o, i) && (s = o), !this._queueLess(s, r))
        break;
      this._queueSwap(r, s), r = s;
    }
    return r > e;
  }
}
function my(t, e, n, r, i, o) {
  return (n - i) * (e - o) - (r - o) * (t - i);
}
function Dbn(t, e, n, r, i, o, s, a) {
  const A = t - s, l = e - a, c = n - s, u = r - a, f = i - s, h = o - a, d = A * A + l * l, I = c * c + u * u, m = f * f + h * h;
  return A * (u * m - I * h) - l * (c * m - I * f) + d * (c * h - u * f) < 0;
}
function CP(t, e, n, r, i) {
  const {
    rScaler: o,
    bScaler: s,
    gScaler: a,
    offset: A
  } = r, l = new Float32Array((e + 1) * (n + 1));
  for (let c = 0, u = 0; u < n; u++)
    for (let f = 0; f < e; f++, c++) {
      const h = c * 4, d = t[h + 0], I = t[h + 1], m = t[h + 2];
      l[c + u] = d * o + I * a + m * s + A;
    }
  if (i === "martini") {
    for (let c = (e + 1) * e, u = 0; u < e; u++, c++)
      l[c] = l[c - e - 1];
    for (let c = n, u = 0; u < n + 1; u++, c += n + 1)
      l[c] = l[c - 1];
  }
  return l;
}
function Tbn(t, e, n, r, i) {
  const o = n + 1, s = t.length / 2, a = new Float32Array(s * 3), A = new Float32Array(s * 2), [l, c, u, f] = i || [0, 0, n, r], h = (u - l) / n, d = (f - c) / r;
  for (let I = 0; I < s; I++) {
    const m = t[I * 2], C = t[I * 2 + 1], y = C * o + m;
    a[3 * I + 0] = m * h + l, a[3 * I + 1] = -C * d + f, a[3 * I + 2] = e[y], A[2 * I + 0] = m / n, A[2 * I + 1] = C / r;
  }
  return {
    POSITION: {
      value: a,
      size: 3
    },
    TEXCOORD_0: {
      value: A,
      size: 2
    }
  };
}
function Nbn(t, e) {
  if (t === null)
    return null;
  const {
    meshMaxError: n,
    bounds: r,
    elevationDecoder: i
  } = e, {
    data: o,
    width: s,
    height: a
  } = t;
  let A, l;
  switch (e.tesselator) {
    case "martini":
      A = CP(o, s, a, i, e.tesselator), l = ZQe(n, s, A);
      break;
    case "delatin":
      A = CP(o, s, a, i, e.tesselator), l = ewe(n, s, a, A);
      break;
    default:
      s === a && !(a & s - 1) ? (A = CP(o, s, a, i, "martini"), l = ZQe(n, s, A)) : (A = CP(o, s, a, i, "delatin"), l = ewe(n, s, a, A));
      break;
  }
  const {
    vertices: c
  } = l;
  let {
    triangles: u
  } = l, f = Tbn(c, A, s, a, r);
  const h = Jje(f);
  if (e.skirtHeight) {
    const {
      attributes: d,
      triangles: I
    } = bbn(f, u, e.skirtHeight);
    f = d, u = I;
  }
  return {
    loaderData: {
      header: {}
    },
    header: {
      vertexCount: u.length,
      boundingBox: h
    },
    mode: 4,
    indices: {
      value: Uint32Array.from(u),
      size: 1
    },
    attributes: f
  };
}
function ZQe(t, e, n) {
  const r = e + 1, o = new wbn(r).createTile(n), {
    vertices: s,
    triangles: a
  } = o.getMesh(t);
  return {
    vertices: s,
    triangles: a
  };
}
function ewe(t, e, n, r) {
  const i = new Rbn(r, e + 1, n + 1);
  i.run(t);
  const {
    coords: o,
    triangles: s
  } = i;
  return {
    vertices: o,
    triangles: s
  };
}
async function Lbn(t, e, n) {
  const r = {
    ...e,
    mimeType: "application/x.image",
    image: {
      ...e.image,
      type: "data"
    }
  }, i = await n.parse(t, r);
  return Nbn(i, e.terrain);
}
const Mbn = "3.2.10", BYe = {
  name: "Terrain",
  id: "terrain",
  module: "terrain",
  version: Mbn,
  worker: !0,
  extensions: ["png", "pngraw", "jpg", "jpeg", "gif", "webp", "bmp"],
  mimeTypes: ["image/png", "image/jpeg", "image/gif", "image/webp", "image/bmp"],
  options: {
    terrain: {
      tesselator: "auto",
      bounds: null,
      meshMaxError: 10,
      elevationDecoder: {
        rScaler: 1,
        gScaler: 0,
        bScaler: 0,
        offset: 0
      },
      skirtHeight: null
    }
  }
};
({
  ...BYe
});
const twe = [1], Obn = {
  ...i1.defaultProps,
  elevationData: cte,
  texture: {
    ...cte,
    optional: !0
  },
  meshMaxError: {
    type: "number",
    value: 4
  },
  bounds: {
    type: "array",
    value: null,
    optional: !0,
    compare: !0
  },
  color: {
    type: "color",
    value: [255, 255, 255]
  },
  elevationDecoder: {
    type: "object",
    value: {
      rScaler: 1,
      gScaler: 0,
      bScaler: 0,
      offset: 0
    }
  },
  workerUrl: {
    type: "string",
    value: null
  },
  wireframe: !1,
  material: !0,
  loaders: [BYe]
};
function nwe(t) {
  return Array.isArray(t) ? t.join(";") : t || "";
}
class Lce extends mA {
  constructor(...e) {
    super(...e), ae(this, "state", void 0);
  }
  updateState({
    props: e,
    oldProps: n
  }) {
    const r = e.elevationData !== n.elevationData;
    if (r) {
      const {
        elevationData: o
      } = e, s = o && (Array.isArray(o) || o.includes("{x}") && o.includes("{y}"));
      this.setState({
        isTiled: s
      });
    }
    const i = r || e.meshMaxError !== n.meshMaxError || e.elevationDecoder !== n.elevationDecoder || e.bounds !== n.bounds;
    if (!this.state.isTiled && i) {
      const o = this.loadTerrain(e);
      this.setState({
        terrain: o
      });
    }
    e.workerUrl && Rr.removed("workerUrl", "loadOptions.terrain.workerUrl")();
  }
  loadTerrain({
    elevationData: e,
    bounds: n,
    elevationDecoder: r,
    meshMaxError: i,
    signal: o
  }) {
    var s;
    if (!e)
      return null;
    let a = this.getLoadOptions();
    a = {
      ...a,
      terrain: {
        skirtHeight: this.state.isTiled ? i * 2 : 0,
        ...(s = a) === null || s === void 0 ? void 0 : s.terrain,
        bounds: n,
        meshMaxError: i,
        elevationDecoder: r
      }
    };
    const {
      fetch: A
    } = this.props;
    return A(e, {
      propName: "elevationData",
      layer: this,
      loadOptions: a,
      signal: o
    });
  }
  getTiledTerrainData(e) {
    const {
      elevationData: n,
      fetch: r,
      texture: i,
      elevationDecoder: o,
      meshMaxError: s
    } = this.props, {
      viewport: a
    } = this.context, A = VT(n, e), l = i && VT(i, e), {
      signal: c
    } = e;
    let u = [0, 0], f = [0, 0];
    if (a.isGeospatial) {
      const m = e.bbox;
      u = a.projectFlat([m.west, m.south]), f = a.projectFlat([m.east, m.north]);
    } else {
      const m = e.bbox;
      u = [m.left, m.bottom], f = [m.right, m.top];
    }
    const h = [u[0], u[1], f[0], f[1]], d = this.loadTerrain({
      elevationData: A,
      bounds: h,
      elevationDecoder: o,
      meshMaxError: s,
      signal: c
    }), I = l ? r(l, {
      propName: "texture",
      layer: this,
      loaders: [],
      signal: c
    }).catch((m) => null) : Promise.resolve(null);
    return Promise.all([d, I]);
  }
  renderSubLayers(e) {
    const n = this.getSubLayerClass("mesh", YS), {
      color: r,
      wireframe: i,
      material: o
    } = this.props, {
      data: s
    } = e;
    if (!s)
      return null;
    const [a, A] = s;
    return new n(e, {
      data: twe,
      mesh: a,
      texture: A,
      _instanced: !1,
      coordinateSystem: wn.CARTESIAN,
      getPosition: (l) => [0, 0, 0],
      getColor: r,
      wireframe: i,
      material: o
    });
  }
  onViewportLoad(e) {
    if (!e)
      return;
    const {
      zRange: n
    } = this.state, r = e.map((s) => s.content).filter(Boolean).map((s) => s[0].header.boundingBox.map((A) => A[2]));
    if (r.length === 0)
      return;
    const i = Math.min(...r.map((s) => s[0])), o = Math.max(...r.map((s) => s[1]));
    (!n || i < n[0] || o > n[1]) && this.setState({
      zRange: [i, o]
    });
  }
  renderLayers() {
    const {
      color: e,
      material: n,
      elevationData: r,
      texture: i,
      wireframe: o,
      meshMaxError: s,
      elevationDecoder: a,
      tileSize: A,
      maxZoom: l,
      minZoom: c,
      extent: u,
      maxRequests: f,
      onTileLoad: h,
      onTileUnload: d,
      onTileError: I,
      maxCacheSize: m,
      maxCacheByteSize: C,
      refinementStrategy: y
    } = this.props;
    if (this.state.isTiled)
      return new i1(this.getSubLayerProps({
        id: "tiles"
      }), {
        getTileData: this.getTiledTerrainData.bind(this),
        renderSubLayers: this.renderSubLayers.bind(this),
        updateTriggers: {
          getTileData: {
            elevationData: nwe(r),
            texture: nwe(i),
            meshMaxError: s,
            elevationDecoder: a
          }
        },
        onViewportLoad: this.onViewportLoad.bind(this),
        zRange: this.state.zRange || null,
        tileSize: A,
        maxZoom: l,
        minZoom: c,
        extent: u,
        maxRequests: f,
        onTileLoad: h,
        onTileUnload: d,
        onTileError: I,
        maxCacheSize: m,
        maxCacheByteSize: C,
        refinementStrategy: y
      });
    const v = this.getSubLayerClass("mesh", YS);
    return new v(this.getSubLayerProps({
      id: "mesh"
    }), {
      data: twe,
      mesh: this.state.terrain,
      texture: i,
      _instanced: !1,
      getPosition: (b) => [0, 0, 0],
      getColor: e,
      material: n,
      wireframe: o
    });
  }
}
ae(Lce, "defaultProps", Obn);
ae(Lce, "layerName", "TerrainLayer");
function Fbn(t, e, n) {
  const r = Pbn(t), i = Object.keys(r).filter((o) => r[o] !== Array);
  return kbn(t, {
    propArrayTypes: r,
    ...e
  }, {
    numericPropKeys: n && n.numericPropKeys || i,
    PositionDataType: n ? n.PositionDataType : Float32Array
  });
}
function Pbn(t) {
  const e = {};
  for (const n of t)
    if (n.properties)
      for (const r in n.properties) {
        const i = n.properties[r];
        e[r] = jbn(i, e[r]);
      }
  return e;
}
function kbn(t, e, n) {
  const {
    pointPositionsCount: r,
    pointFeaturesCount: i,
    linePositionsCount: o,
    linePathsCount: s,
    lineFeaturesCount: a,
    polygonPositionsCount: A,
    polygonObjectsCount: l,
    polygonRingsCount: c,
    polygonFeaturesCount: u,
    propArrayTypes: f,
    coordLength: h
  } = e, {
    numericPropKeys: d = [],
    PositionDataType: I = Float32Array
  } = n, m = t[0] && "id" in t[0], C = t.length > 65535 ? Uint32Array : Uint16Array, y = {
    type: "Point",
    positions: new I(r * h),
    globalFeatureIds: new C(r),
    featureIds: i > 65535 ? new Uint32Array(r) : new Uint16Array(r),
    numericProps: {},
    properties: [],
    fields: []
  }, v = {
    type: "LineString",
    pathIndices: o > 65535 ? new Uint32Array(s + 1) : new Uint16Array(s + 1),
    positions: new I(o * h),
    globalFeatureIds: new C(o),
    featureIds: a > 65535 ? new Uint32Array(o) : new Uint16Array(o),
    numericProps: {},
    properties: [],
    fields: []
  }, b = {
    type: "Polygon",
    polygonIndices: A > 65535 ? new Uint32Array(l + 1) : new Uint16Array(l + 1),
    primitivePolygonIndices: A > 65535 ? new Uint32Array(c + 1) : new Uint16Array(c + 1),
    positions: new I(A * h),
    triangles: [],
    globalFeatureIds: new C(A),
    featureIds: u > 65535 ? new Uint32Array(A) : new Uint16Array(A),
    numericProps: {},
    properties: [],
    fields: []
  };
  for (const w of [y, v, b])
    for (const R of d) {
      const M = f[R];
      w.numericProps[R] = new M(w.positions.length / h);
    }
  v.pathIndices[s] = o, b.polygonIndices[l] = A, b.primitivePolygonIndices[c] = A;
  const Q = {
    pointPosition: 0,
    pointFeature: 0,
    linePosition: 0,
    linePath: 0,
    lineFeature: 0,
    polygonPosition: 0,
    polygonObject: 0,
    polygonRing: 0,
    polygonFeature: 0,
    feature: 0
  };
  for (const w of t) {
    const R = w.geometry, M = w.properties || {};
    switch (R.type) {
      case "Point":
        Gbn(R, y, Q, h, M), y.properties.push(tJ(M, d)), m && y.fields.push({
          id: w.id
        }), Q.pointFeature++;
        break;
      case "LineString":
        Ubn(R, v, Q, h, M), v.properties.push(tJ(M, d)), m && v.fields.push({
          id: w.id
        }), Q.lineFeature++;
        break;
      case "Polygon":
        Hbn(R, b, Q, h, M), b.properties.push(tJ(M, d)), m && b.fields.push({
          id: w.id
        }), Q.polygonFeature++;
        break;
      default:
        throw new Error("Invalid geometry type");
    }
    Q.feature++;
  }
  return qbn(y, v, b, h);
}
function Gbn(t, e, n, r, i) {
  e.positions.set(t.data, n.pointPosition * r);
  const o = t.data.length / r;
  Mce(e, i, n.pointPosition, o), e.globalFeatureIds.fill(n.feature, n.pointPosition, n.pointPosition + o), e.featureIds.fill(n.pointFeature, n.pointPosition, n.pointPosition + o), n.pointPosition += o;
}
function Ubn(t, e, n, r, i) {
  e.positions.set(t.data, n.linePosition * r);
  const o = t.data.length / r;
  Mce(e, i, n.linePosition, o), e.globalFeatureIds.fill(n.feature, n.linePosition, n.linePosition + o), e.featureIds.fill(n.lineFeature, n.linePosition, n.linePosition + o);
  for (let s = 0, a = t.indices.length; s < a; ++s) {
    const A = t.indices[s], l = s === a - 1 ? t.data.length : t.indices[s + 1];
    e.pathIndices[n.linePath++] = n.linePosition, n.linePosition += (l - A) / r;
  }
}
function Hbn(t, e, n, r, i) {
  e.positions.set(t.data, n.polygonPosition * r);
  const o = t.data.length / r;
  Mce(e, i, n.polygonPosition, o), e.globalFeatureIds.fill(n.feature, n.polygonPosition, n.polygonPosition + o), e.featureIds.fill(n.polygonFeature, n.polygonPosition, n.polygonPosition + o);
  for (let s = 0, a = t.indices.length; s < a; ++s) {
    const A = n.polygonPosition;
    e.polygonIndices[n.polygonObject++] = A;
    const l = t.areas[s], c = t.indices[s], u = t.indices[s + 1];
    for (let h = 0, d = c.length; h < d; ++h) {
      const I = c[h], m = h === d - 1 ? u === void 0 ? t.data.length : u[0] : c[h + 1];
      e.primitivePolygonIndices[n.polygonRing++] = n.polygonPosition, n.polygonPosition += (m - I) / r;
    }
    const f = n.polygonPosition;
    $bn(e, l, c, {
      startPosition: A,
      endPosition: f,
      coordLength: r
    });
  }
}
function $bn(t, e, n, {
  startPosition: r,
  endPosition: i,
  coordLength: o
}) {
  const s = r * o, a = i * o, A = t.positions.subarray(s, a), l = n[0], c = n.slice(1).map((f) => (f - l) / o), u = v0n(A, c, o, e);
  for (let f = 0, h = u.length; f < h; ++f)
    t.triangles.push(r + u[f]);
}
function eJ(t, e) {
  const n = {};
  for (const r in t)
    n[r] = {
      value: t[r],
      size: e
    };
  return n;
}
function qbn(t, e, n, r) {
  return {
    points: {
      ...t,
      positions: {
        value: t.positions,
        size: r
      },
      globalFeatureIds: {
        value: t.globalFeatureIds,
        size: 1
      },
      featureIds: {
        value: t.featureIds,
        size: 1
      },
      numericProps: eJ(t.numericProps, 1)
    },
    lines: {
      ...e,
      positions: {
        value: e.positions,
        size: r
      },
      pathIndices: {
        value: e.pathIndices,
        size: 1
      },
      globalFeatureIds: {
        value: e.globalFeatureIds,
        size: 1
      },
      featureIds: {
        value: e.featureIds,
        size: 1
      },
      numericProps: eJ(e.numericProps, 1)
    },
    polygons: {
      ...n,
      positions: {
        value: n.positions,
        size: r
      },
      polygonIndices: {
        value: n.polygonIndices,
        size: 1
      },
      primitivePolygonIndices: {
        value: n.primitivePolygonIndices,
        size: 1
      },
      triangles: {
        value: new Uint32Array(n.triangles),
        size: 1
      },
      globalFeatureIds: {
        value: n.globalFeatureIds,
        size: 1
      },
      featureIds: {
        value: n.featureIds,
        size: 1
      },
      numericProps: eJ(n.numericProps, 1)
    }
  };
}
function Mce(t, e, n, r) {
  for (const i in t.numericProps)
    if (i in e) {
      const o = e[i];
      t.numericProps[i].fill(o, n, n + r);
    }
}
function tJ(t, e) {
  const n = {};
  for (const r in t)
    e.includes(r) || (n[r] = t[r]);
  return n;
}
function jbn(t, e) {
  return e === Array || !Number.isFinite(t) ? Array : e === Float64Array || Math.fround(t) !== t ? Float64Array : Float32Array;
}
function rwe(t, e) {
  const n = e?.globalFeatureId;
  return n !== void 0 ? Ybn(t, n) : zbn(t, e?.type);
}
function Ybn(t, e) {
  const n = bYe(t);
  for (const r of n) {
    let i = 0, o = r.featureIds.value[0];
    for (let s = 0; s < r.featureIds.value.length; s++) {
      const a = r.featureIds.value[s];
      if (a !== o) {
        if (e === r.globalFeatureIds.value[i])
          return kU(r, i, s);
        i = s, o = a;
      }
    }
    if (e === r.globalFeatureIds.value[i])
      return kU(r, i, r.featureIds.value.length);
  }
  throw new Error("featureId:".concat(e, " not found"));
}
function zbn(t, e) {
  const n = bYe(t, e);
  return Jbn(n);
}
function Vbn(t, e, n) {
  switch (t.type) {
    case "Point":
      return Zbn(t, e, n);
    case "LineString":
      return Xbn(t, e, n);
    case "Polygon":
      return _Ye(t, e, n);
    default:
      const r = t;
      throw new Error("Unsupported geometry type: ".concat(r?.type));
  }
}
function bYe(t, e) {
  if (!!!(t.points || t.lines || t.polygons))
    return t.type = e || e_n(t), [t];
  const r = [];
  return t.points && (t.points.type = "Point", r.push(t.points)), t.lines && (t.lines.type = "LineString", r.push(t.lines)), t.polygons && (t.polygons.type = "Polygon", r.push(t.polygons)), r;
}
function Jbn(t) {
  const e = [];
  for (const n of t) {
    if (n.featureIds.value.length === 0)
      continue;
    let r = 0, i = n.featureIds.value[0];
    for (let o = 0; o < n.featureIds.value.length; o++) {
      const s = n.featureIds.value[o];
      s !== i && (e.push(kU(n, r, o)), r = o, i = s);
    }
    e.push(kU(n, r, n.featureIds.value.length));
  }
  return e;
}
function kU(t, e, n) {
  const r = Vbn(t, e, n), i = Wbn(t, e), o = Kbn(t, e);
  return {
    type: "Feature",
    geometry: r,
    properties: i,
    ...o
  };
}
function Kbn(t, e = 0, n) {
  return t.fields && t.fields[t.featureIds.value[e]];
}
function Wbn(t, e = 0, n) {
  const r = Object.assign({}, t.properties[t.featureIds.value[e]]);
  for (const i in t.numericProps)
    r[i] = t.numericProps[i].value[e];
  return r;
}
function _Ye(t, e = -1 / 0, n = 1 / 0) {
  const {
    positions: r
  } = t, i = t.polygonIndices.value.filter((A) => A >= e && A <= n), o = t.primitivePolygonIndices.value.filter((A) => A >= e && A <= n);
  if (!(i.length > 2)) {
    const A = [];
    for (let l = 0; l < o.length - 1; l++) {
      const c = o[l], u = o[l + 1], f = GU(r, c, u);
      A.push(f);
    }
    return {
      type: "Polygon",
      coordinates: A
    };
  }
  const a = [];
  for (let A = 0; A < i.length - 1; A++) {
    const l = i[A], c = i[A + 1], u = _Ye(t, l, c).coordinates;
    a.push(u);
  }
  return {
    type: "MultiPolygon",
    coordinates: a
  };
}
function Xbn(t, e = -1 / 0, n = 1 / 0) {
  const {
    positions: r
  } = t, i = t.pathIndices.value.filter((a) => a >= e && a <= n);
  if (!(i.length > 2))
    return {
      type: "LineString",
      coordinates: GU(r, i[0], i[1])
    };
  const s = [];
  for (let a = 0; a < i.length - 1; a++) {
    const A = GU(r, i[a], i[a + 1]);
    s.push(A);
  }
  return {
    type: "MultiLineString",
    coordinates: s
  };
}
function Zbn(t, e, n) {
  const {
    positions: r
  } = t, i = GU(r, e, n);
  return i.length > 1 ? {
    type: "MultiPoint",
    coordinates: i
  } : {
    type: "Point",
    coordinates: i[0]
  };
}
function GU(t, e, n) {
  e = e || 0, n = n || t.value.length / t.size;
  const r = [];
  for (let i = e; i < n; i++) {
    const o = Array();
    for (let s = i * t.size; s < (i + 1) * t.size; s++)
      o.push(Number(t.value[s]));
    r.push(o);
  }
  return r;
}
function e_n(t) {
  return t.pathIndices ? "LineString" : t.polygonIndices ? "Polygon" : "Point";
}
var Oce = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
Oce.read = function(t, e, n, r, i) {
  var o, s, a = i * 8 - r - 1, A = (1 << a) - 1, l = A >> 1, c = -7, u = n ? i - 1 : 0, f = n ? -1 : 1, h = t[e + u];
  for (u += f, o = h & (1 << -c) - 1, h >>= -c, c += a; c > 0; o = o * 256 + t[e + u], u += f, c -= 8)
    ;
  for (s = o & (1 << -c) - 1, o >>= -c, c += r; c > 0; s = s * 256 + t[e + u], u += f, c -= 8)
    ;
  if (o === 0)
    o = 1 - l;
  else {
    if (o === A)
      return s ? NaN : (h ? -1 : 1) * (1 / 0);
    s = s + Math.pow(2, r), o = o - l;
  }
  return (h ? -1 : 1) * s * Math.pow(2, o - r);
};
Oce.write = function(t, e, n, r, i, o) {
  var s, a, A, l = o * 8 - i - 1, c = (1 << l) - 1, u = c >> 1, f = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = r ? 0 : o - 1, d = r ? 1 : -1, I = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = c) : (s = Math.floor(Math.log(e) / Math.LN2), e * (A = Math.pow(2, -s)) < 1 && (s--, A *= 2), s + u >= 1 ? e += f / A : e += f * Math.pow(2, 1 - u), e * A >= 2 && (s++, A /= 2), s + u >= c ? (a = 0, s = c) : s + u >= 1 ? (a = (e * A - 1) * Math.pow(2, i), s = s + u) : (a = e * Math.pow(2, u - 1) * Math.pow(2, i), s = 0)); i >= 8; t[n + h] = a & 255, h += d, a /= 256, i -= 8)
    ;
  for (s = s << i | a, l += i; l > 0; t[n + h] = s & 255, h += d, s /= 256, l -= 8)
    ;
  t[n + h - d] |= I * 128;
};
var t_n = to, EP = Oce;
function to(t) {
  this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t) ? t : new Uint8Array(t || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
}
to.Varint = 0;
to.Fixed64 = 1;
to.Bytes = 2;
to.Fixed32 = 5;
var yte = 65536 * 65536, iwe = 1 / yte, n_n = 12, SYe = typeof TextDecoder > "u" ? null : new TextDecoder("utf8");
to.prototype = {
  destroy: function() {
    this.buf = null;
  },
  // === READING =================================================================
  readFields: function(t, e, n) {
    for (n = n || this.length; this.pos < n; ) {
      var r = this.readVarint(), i = r >> 3, o = this.pos;
      this.type = r & 7, t(i, e, this), this.pos === o && this.skip(r);
    }
    return e;
  },
  readMessage: function(t, e) {
    return this.readFields(t, e, this.readVarint() + this.pos);
  },
  readFixed32: function() {
    var t = yP(this.buf, this.pos);
    return this.pos += 4, t;
  },
  readSFixed32: function() {
    var t = swe(this.buf, this.pos);
    return this.pos += 4, t;
  },
  // 64-bit int handling is based on github.com/dpw/node-buffer-more-ints (MIT-licensed)
  readFixed64: function() {
    var t = yP(this.buf, this.pos) + yP(this.buf, this.pos + 4) * yte;
    return this.pos += 8, t;
  },
  readSFixed64: function() {
    var t = yP(this.buf, this.pos) + swe(this.buf, this.pos + 4) * yte;
    return this.pos += 8, t;
  },
  readFloat: function() {
    var t = EP.read(this.buf, this.pos, !0, 23, 4);
    return this.pos += 4, t;
  },
  readDouble: function() {
    var t = EP.read(this.buf, this.pos, !0, 52, 8);
    return this.pos += 8, t;
  },
  readVarint: function(t) {
    var e = this.buf, n, r;
    return r = e[this.pos++], n = r & 127, r < 128 || (r = e[this.pos++], n |= (r & 127) << 7, r < 128) || (r = e[this.pos++], n |= (r & 127) << 14, r < 128) || (r = e[this.pos++], n |= (r & 127) << 21, r < 128) ? n : (r = e[this.pos], n |= (r & 15) << 28, r_n(n, t, this));
  },
  readVarint64: function() {
    return this.readVarint(!0);
  },
  readSVarint: function() {
    var t = this.readVarint();
    return t % 2 === 1 ? (t + 1) / -2 : t / 2;
  },
  readBoolean: function() {
    return !!this.readVarint();
  },
  readString: function() {
    var t = this.readVarint() + this.pos, e = this.pos;
    return this.pos = t, t - e >= n_n && SYe ? I_n(this.buf, e, t) : p_n(this.buf, e, t);
  },
  readBytes: function() {
    var t = this.readVarint() + this.pos, e = this.buf.subarray(this.pos, t);
    return this.pos = t, e;
  },
  // verbose for performance reasons; doesn't affect gzipped size
  readPackedVarint: function(t, e) {
    if (this.type !== to.Bytes)
      return t.push(this.readVarint(e));
    var n = M0(this);
    for (t = t || []; this.pos < n; )
      t.push(this.readVarint(e));
    return t;
  },
  readPackedSVarint: function(t) {
    if (this.type !== to.Bytes)
      return t.push(this.readSVarint());
    var e = M0(this);
    for (t = t || []; this.pos < e; )
      t.push(this.readSVarint());
    return t;
  },
  readPackedBoolean: function(t) {
    if (this.type !== to.Bytes)
      return t.push(this.readBoolean());
    var e = M0(this);
    for (t = t || []; this.pos < e; )
      t.push(this.readBoolean());
    return t;
  },
  readPackedFloat: function(t) {
    if (this.type !== to.Bytes)
      return t.push(this.readFloat());
    var e = M0(this);
    for (t = t || []; this.pos < e; )
      t.push(this.readFloat());
    return t;
  },
  readPackedDouble: function(t) {
    if (this.type !== to.Bytes)
      return t.push(this.readDouble());
    var e = M0(this);
    for (t = t || []; this.pos < e; )
      t.push(this.readDouble());
    return t;
  },
  readPackedFixed32: function(t) {
    if (this.type !== to.Bytes)
      return t.push(this.readFixed32());
    var e = M0(this);
    for (t = t || []; this.pos < e; )
      t.push(this.readFixed32());
    return t;
  },
  readPackedSFixed32: function(t) {
    if (this.type !== to.Bytes)
      return t.push(this.readSFixed32());
    var e = M0(this);
    for (t = t || []; this.pos < e; )
      t.push(this.readSFixed32());
    return t;
  },
  readPackedFixed64: function(t) {
    if (this.type !== to.Bytes)
      return t.push(this.readFixed64());
    var e = M0(this);
    for (t = t || []; this.pos < e; )
      t.push(this.readFixed64());
    return t;
  },
  readPackedSFixed64: function(t) {
    if (this.type !== to.Bytes)
      return t.push(this.readSFixed64());
    var e = M0(this);
    for (t = t || []; this.pos < e; )
      t.push(this.readSFixed64());
    return t;
  },
  skip: function(t) {
    var e = t & 7;
    if (e === to.Varint)
      for (; this.buf[this.pos++] > 127; )
        ;
    else if (e === to.Bytes)
      this.pos = this.readVarint() + this.pos;
    else if (e === to.Fixed32)
      this.pos += 4;
    else if (e === to.Fixed64)
      this.pos += 8;
    else
      throw new Error("Unimplemented type: " + e);
  },
  // === WRITING =================================================================
  writeTag: function(t, e) {
    this.writeVarint(t << 3 | e);
  },
  realloc: function(t) {
    for (var e = this.length || 16; e < this.pos + t; )
      e *= 2;
    if (e !== this.length) {
      var n = new Uint8Array(e);
      n.set(this.buf), this.buf = n, this.length = e;
    }
  },
  finish: function() {
    return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
  },
  writeFixed32: function(t) {
    this.realloc(4), gb(this.buf, t, this.pos), this.pos += 4;
  },
  writeSFixed32: function(t) {
    this.realloc(4), gb(this.buf, t, this.pos), this.pos += 4;
  },
  writeFixed64: function(t) {
    this.realloc(8), gb(this.buf, t & -1, this.pos), gb(this.buf, Math.floor(t * iwe), this.pos + 4), this.pos += 8;
  },
  writeSFixed64: function(t) {
    this.realloc(8), gb(this.buf, t & -1, this.pos), gb(this.buf, Math.floor(t * iwe), this.pos + 4), this.pos += 8;
  },
  writeVarint: function(t) {
    if (t = +t || 0, t > 268435455 || t < 0) {
      i_n(t, this);
      return;
    }
    this.realloc(4), this.buf[this.pos++] = t & 127 | (t > 127 ? 128 : 0), !(t <= 127) && (this.buf[this.pos++] = (t >>>= 7) & 127 | (t > 127 ? 128 : 0), !(t <= 127) && (this.buf[this.pos++] = (t >>>= 7) & 127 | (t > 127 ? 128 : 0), !(t <= 127) && (this.buf[this.pos++] = t >>> 7 & 127)));
  },
  writeSVarint: function(t) {
    this.writeVarint(t < 0 ? -t * 2 - 1 : t * 2);
  },
  writeBoolean: function(t) {
    this.writeVarint(!!t);
  },
  writeString: function(t) {
    t = String(t), this.realloc(t.length * 4), this.pos++;
    var e = this.pos;
    this.pos = m_n(this.buf, t, this.pos);
    var n = this.pos - e;
    n >= 128 && owe(e, n, this), this.pos = e - 1, this.writeVarint(n), this.pos += n;
  },
  writeFloat: function(t) {
    this.realloc(4), EP.write(this.buf, t, this.pos, !0, 23, 4), this.pos += 4;
  },
  writeDouble: function(t) {
    this.realloc(8), EP.write(this.buf, t, this.pos, !0, 52, 8), this.pos += 8;
  },
  writeBytes: function(t) {
    var e = t.length;
    this.writeVarint(e), this.realloc(e);
    for (var n = 0; n < e; n++)
      this.buf[this.pos++] = t[n];
  },
  writeRawMessage: function(t, e) {
    this.pos++;
    var n = this.pos;
    t(e, this);
    var r = this.pos - n;
    r >= 128 && owe(n, r, this), this.pos = n - 1, this.writeVarint(r), this.pos += r;
  },
  writeMessage: function(t, e, n) {
    this.writeTag(t, to.Bytes), this.writeRawMessage(e, n);
  },
  writePackedVarint: function(t, e) {
    e.length && this.writeMessage(t, a_n, e);
  },
  writePackedSVarint: function(t, e) {
    e.length && this.writeMessage(t, A_n, e);
  },
  writePackedBoolean: function(t, e) {
    e.length && this.writeMessage(t, u_n, e);
  },
  writePackedFloat: function(t, e) {
    e.length && this.writeMessage(t, l_n, e);
  },
  writePackedDouble: function(t, e) {
    e.length && this.writeMessage(t, c_n, e);
  },
  writePackedFixed32: function(t, e) {
    e.length && this.writeMessage(t, f_n, e);
  },
  writePackedSFixed32: function(t, e) {
    e.length && this.writeMessage(t, g_n, e);
  },
  writePackedFixed64: function(t, e) {
    e.length && this.writeMessage(t, h_n, e);
  },
  writePackedSFixed64: function(t, e) {
    e.length && this.writeMessage(t, d_n, e);
  },
  writeBytesField: function(t, e) {
    this.writeTag(t, to.Bytes), this.writeBytes(e);
  },
  writeFixed32Field: function(t, e) {
    this.writeTag(t, to.Fixed32), this.writeFixed32(e);
  },
  writeSFixed32Field: function(t, e) {
    this.writeTag(t, to.Fixed32), this.writeSFixed32(e);
  },
  writeFixed64Field: function(t, e) {
    this.writeTag(t, to.Fixed64), this.writeFixed64(e);
  },
  writeSFixed64Field: function(t, e) {
    this.writeTag(t, to.Fixed64), this.writeSFixed64(e);
  },
  writeVarintField: function(t, e) {
    this.writeTag(t, to.Varint), this.writeVarint(e);
  },
  writeSVarintField: function(t, e) {
    this.writeTag(t, to.Varint), this.writeSVarint(e);
  },
  writeStringField: function(t, e) {
    this.writeTag(t, to.Bytes), this.writeString(e);
  },
  writeFloatField: function(t, e) {
    this.writeTag(t, to.Fixed32), this.writeFloat(e);
  },
  writeDoubleField: function(t, e) {
    this.writeTag(t, to.Fixed64), this.writeDouble(e);
  },
  writeBooleanField: function(t, e) {
    this.writeVarintField(t, !!e);
  }
};
function r_n(t, e, n) {
  var r = n.buf, i, o;
  if (o = r[n.pos++], i = (o & 112) >> 4, o < 128 || (o = r[n.pos++], i |= (o & 127) << 3, o < 128) || (o = r[n.pos++], i |= (o & 127) << 10, o < 128) || (o = r[n.pos++], i |= (o & 127) << 17, o < 128) || (o = r[n.pos++], i |= (o & 127) << 24, o < 128) || (o = r[n.pos++], i |= (o & 1) << 31, o < 128))
    return fb(t, i, e);
  throw new Error("Expected varint not more than 10 bytes");
}
function M0(t) {
  return t.type === to.Bytes ? t.readVarint() + t.pos : t.pos + 1;
}
function fb(t, e, n) {
  return n ? e * 4294967296 + (t >>> 0) : (e >>> 0) * 4294967296 + (t >>> 0);
}
function i_n(t, e) {
  var n, r;
  if (t >= 0 ? (n = t % 4294967296 | 0, r = t / 4294967296 | 0) : (n = ~(-t % 4294967296), r = ~(-t / 4294967296), n ^ 4294967295 ? n = n + 1 | 0 : (n = 0, r = r + 1 | 0)), t >= 18446744073709552e3 || t < -18446744073709552e3)
    throw new Error("Given varint doesn't fit into 10 bytes");
  e.realloc(10), o_n(n, r, e), s_n(r, e);
}
function o_n(t, e, n) {
  n.buf[n.pos++] = t & 127 | 128, t >>>= 7, n.buf[n.pos++] = t & 127 | 128, t >>>= 7, n.buf[n.pos++] = t & 127 | 128, t >>>= 7, n.buf[n.pos++] = t & 127 | 128, t >>>= 7, n.buf[n.pos] = t & 127;
}
function s_n(t, e) {
  var n = (t & 7) << 4;
  e.buf[e.pos++] |= n | ((t >>>= 3) ? 128 : 0), t && (e.buf[e.pos++] = t & 127 | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = t & 127 | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = t & 127 | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = t & 127 | ((t >>>= 7) ? 128 : 0), t && (e.buf[e.pos++] = t & 127)))));
}
function owe(t, e, n) {
  var r = e <= 16383 ? 1 : e <= 2097151 ? 2 : e <= 268435455 ? 3 : Math.floor(Math.log(e) / (Math.LN2 * 7));
  n.realloc(r);
  for (var i = n.pos - 1; i >= t; i--)
    n.buf[i + r] = n.buf[i];
}
function a_n(t, e) {
  for (var n = 0; n < t.length; n++)
    e.writeVarint(t[n]);
}
function A_n(t, e) {
  for (var n = 0; n < t.length; n++)
    e.writeSVarint(t[n]);
}
function l_n(t, e) {
  for (var n = 0; n < t.length; n++)
    e.writeFloat(t[n]);
}
function c_n(t, e) {
  for (var n = 0; n < t.length; n++)
    e.writeDouble(t[n]);
}
function u_n(t, e) {
  for (var n = 0; n < t.length; n++)
    e.writeBoolean(t[n]);
}
function f_n(t, e) {
  for (var n = 0; n < t.length; n++)
    e.writeFixed32(t[n]);
}
function g_n(t, e) {
  for (var n = 0; n < t.length; n++)
    e.writeSFixed32(t[n]);
}
function h_n(t, e) {
  for (var n = 0; n < t.length; n++)
    e.writeFixed64(t[n]);
}
function d_n(t, e) {
  for (var n = 0; n < t.length; n++)
    e.writeSFixed64(t[n]);
}
function yP(t, e) {
  return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + t[e + 3] * 16777216;
}
function gb(t, e, n) {
  t[n] = e, t[n + 1] = e >>> 8, t[n + 2] = e >>> 16, t[n + 3] = e >>> 24;
}
function swe(t, e) {
  return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) + (t[e + 3] << 24);
}
function p_n(t, e, n) {
  for (var r = "", i = e; i < n; ) {
    var o = t[i], s = null, a = o > 239 ? 4 : o > 223 ? 3 : o > 191 ? 2 : 1;
    if (i + a > n)
      break;
    var A, l, c;
    a === 1 ? o < 128 && (s = o) : a === 2 ? (A = t[i + 1], (A & 192) === 128 && (s = (o & 31) << 6 | A & 63, s <= 127 && (s = null))) : a === 3 ? (A = t[i + 1], l = t[i + 2], (A & 192) === 128 && (l & 192) === 128 && (s = (o & 15) << 12 | (A & 63) << 6 | l & 63, (s <= 2047 || s >= 55296 && s <= 57343) && (s = null))) : a === 4 && (A = t[i + 1], l = t[i + 2], c = t[i + 3], (A & 192) === 128 && (l & 192) === 128 && (c & 192) === 128 && (s = (o & 15) << 18 | (A & 63) << 12 | (l & 63) << 6 | c & 63, (s <= 65535 || s >= 1114112) && (s = null))), s === null ? (s = 65533, a = 1) : s > 65535 && (s -= 65536, r += String.fromCharCode(s >>> 10 & 1023 | 55296), s = 56320 | s & 1023), r += String.fromCharCode(s), i += a;
  }
  return r;
}
function I_n(t, e, n) {
  return SYe.decode(t.subarray(e, n));
}
function m_n(t, e, n) {
  for (var r = 0, i, o; r < e.length; r++) {
    if (i = e.charCodeAt(r), i > 55295 && i < 57344)
      if (o)
        if (i < 56320) {
          t[n++] = 239, t[n++] = 191, t[n++] = 189, o = i;
          continue;
        } else
          i = o - 55296 << 10 | i - 56320 | 65536, o = null;
      else {
        i > 56319 || r + 1 === e.length ? (t[n++] = 239, t[n++] = 191, t[n++] = 189) : o = i;
        continue;
      }
    else
      o && (t[n++] = 239, t[n++] = 191, t[n++] = 189, o = null);
    i < 128 ? t[n++] = i : (i < 2048 ? t[n++] = i >> 6 | 192 : (i < 65536 ? t[n++] = i >> 12 | 224 : (t[n++] = i >> 18 | 240, t[n++] = i >> 12 & 63 | 128), t[n++] = i >> 6 & 63 | 128), t[n++] = i & 63 | 128);
  }
  return n;
}
const QYe = /* @__PURE__ */ ko(t_n);
function C_n(t) {
  const e = t.length;
  if (e <= 1)
    return [t];
  const n = [];
  let r, i;
  for (let o = 0; o < e; o++) {
    const s = E_n(t[o]);
    s !== 0 && (i === void 0 && (i = s < 0), i === s < 0 ? (r && n.push(r), r = [t[o]]) : r && r.push(t[o]));
  }
  return r && n.push(r), n;
}
function E_n(t) {
  let e = 0;
  for (let n = 0, r = t.length - 1, i, o; n < t.length; r = n++)
    i = t[n], o = t[r], e += (o[0] - i[0]) * (i[1] + o[1]);
  return e;
}
function y_n(t, e, n) {
  e && n && (t === 1 ? e.id = n.readVarint() : t === 2 ? v_n(n, e) : t === 3 ? e.type = n.readVarint() : t === 4 && (e._geometry = n.pos));
}
function v_n(t, e) {
  const n = t.readVarint() + t.pos;
  for (; t.pos < n; ) {
    const r = e._keys[t.readVarint()], i = e._values[t.readVarint()];
    e.properties[r] = i;
  }
}
let B_n = class wYe {
  static get types() {
    return ["Unknown", "Point", "LineString", "Polygon"];
  }
  constructor(e, n, r, i, o) {
    ae(this, "properties", void 0), ae(this, "extent", void 0), ae(this, "type", void 0), ae(this, "id", void 0), ae(this, "_pbf", void 0), ae(this, "_geometry", void 0), ae(this, "_keys", void 0), ae(this, "_values", void 0), this.properties = {}, this.extent = r, this.type = 0, this.id = null, this._pbf = e, this._geometry = -1, this._keys = i, this._values = o, e.readFields(y_n, this, n);
  }
  loadGeometry() {
    const e = this._pbf;
    e.pos = this._geometry;
    const n = e.readVarint() + e.pos;
    let r = 1, i = 0, o = 0, s = 0;
    const a = [];
    let A;
    for (; e.pos < n; ) {
      if (i <= 0) {
        const l = e.readVarint();
        r = l & 7, i = l >> 3;
      }
      if (i--, r === 1 || r === 2)
        o += e.readSVarint(), s += e.readSVarint(), r === 1 && (A && a.push(A), A = []), A && A.push([o, s]);
      else if (r === 7)
        A && A.push(A[0].slice());
      else
        throw new Error("unknown command ".concat(r));
    }
    return A && a.push(A), a;
  }
  bbox() {
    const e = this._pbf;
    e.pos = this._geometry;
    const n = e.readVarint() + e.pos;
    let r = 1, i = 0, o = 0, s = 0, a = 1 / 0, A = -1 / 0, l = 1 / 0, c = -1 / 0;
    for (; e.pos < n; ) {
      if (i <= 0) {
        const u = e.readVarint();
        r = u & 7, i = u >> 3;
      }
      if (i--, r === 1 || r === 2)
        o += e.readSVarint(), s += e.readSVarint(), o < a && (a = o), o > A && (A = o), s < l && (l = s), s > c && (c = s);
      else if (r !== 7)
        throw new Error("unknown command ".concat(r));
    }
    return [a, l, A, c];
  }
  _toGeoJSON(e) {
    let n = this.loadGeometry(), r = wYe.types[this.type], i, o;
    switch (this.type) {
      case 1:
        const a = [];
        for (i = 0; i < n.length; i++)
          a[i] = n[i][0];
        n = a, e(n, this);
        break;
      case 2:
        for (i = 0; i < n.length; i++)
          e(n[i], this);
        break;
      case 3:
        for (n = C_n(n), i = 0; i < n.length; i++)
          for (o = 0; o < n[i].length; o++)
            e(n[i][o], this);
        break;
    }
    n.length === 1 ? n = n[0] : r = "Multi".concat(r);
    const s = {
      type: "Feature",
      geometry: {
        type: r,
        coordinates: n
      },
      properties: this.properties
    };
    return this.id !== null && (s.id = this.id), s;
  }
  toGeoJSON(e) {
    if (typeof e == "function")
      return this._toGeoJSON(e);
    const {
      x: n,
      y: r,
      z: i
    } = e, o = this.extent * Math.pow(2, i), s = this.extent * n, a = this.extent * r;
    function A(l) {
      for (let c = 0; c < l.length; c++) {
        const u = l[c];
        u[0] = (u[0] + s) * 360 / o - 180;
        const f = 180 - (u[1] + a) * 360 / o;
        u[1] = 360 / Math.PI * Math.atan(Math.exp(f * Math.PI / 180)) - 90;
      }
    }
    return this._toGeoJSON(A);
  }
}, b_n = class {
  constructor(e, n) {
    ae(this, "version", void 0), ae(this, "name", void 0), ae(this, "extent", void 0), ae(this, "length", void 0), ae(this, "_pbf", void 0), ae(this, "_keys", void 0), ae(this, "_values", void 0), ae(this, "_features", void 0), this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = e, this._keys = [], this._values = [], this._features = [], e.readFields(__n, this, n), this.length = this._features.length;
  }
  feature(e) {
    if (e < 0 || e >= this._features.length)
      throw new Error("feature index out of bounds");
    this._pbf.pos = this._features[e];
    const n = this._pbf.readVarint() + this._pbf.pos;
    return new B_n(this._pbf, n, this.extent, this._keys, this._values);
  }
};
function __n(t, e, n) {
  e && n && (t === 15 ? e.version = n.readVarint() : t === 1 ? e.name = n.readString() : t === 5 ? e.extent = n.readVarint() : t === 2 ? e._features.push(n.pos) : t === 3 ? e._keys.push(n.readString()) : t === 4 && e._values.push(S_n(n)));
}
function S_n(t) {
  let e = null;
  const n = t.readVarint() + t.pos;
  for (; t.pos < n; ) {
    const r = t.readVarint() >> 3;
    e = r === 1 ? t.readString() : r === 2 ? t.readFloat() : r === 3 ? t.readDouble() : r === 4 ? t.readVarint64() : r === 5 ? t.readVarint() : r === 6 ? t.readSVarint() : r === 7 ? t.readBoolean() : null;
  }
  return e;
}
let Q_n = class {
  constructor(e, n) {
    ae(this, "layers", void 0), this.layers = e.readFields(w_n, {}, n);
  }
};
function w_n(t, e, n) {
  if (t === 3 && n) {
    const r = new b_n(n, n.readVarint() + n.pos);
    r.length && e && (e[r.name] = r);
  }
}
function x_n(t) {
  const e = t.indices.length, n = "Polygon";
  if (e <= 1)
    return {
      type: n,
      data: t.data,
      areas: [[NU(t.data)]],
      indices: [t.indices]
    };
  const r = [], i = [];
  let o = [], s = [], a, A = 0;
  for (let l, c = 0, u; c < e; c++) {
    u = t.indices[c] - A, l = t.indices[c + 1] - A || t.data.length;
    const f = t.data.slice(u, l), h = NU(f);
    if (h === 0) {
      const d = t.data.slice(0, u), I = t.data.slice(l);
      t.data = d.concat(I), A += l - u;
      continue;
    }
    a === void 0 && (a = h < 0), a === h < 0 ? (s.length && (r.push(o), i.push(s)), s = [u], o = [h]) : (o.push(h), s.push(u));
  }
  return o && r.push(o), s.length && i.push(s), {
    type: n,
    areas: r,
    indices: i,
    data: t.data
  };
}
function R_n(t, e, n, r) {
  for (let i = 0, o = t.length; i < o; i += 2) {
    t[i] = (t[i] + e) * 360 / r - 180;
    const s = 180 - (t[i + 1] + n) * 360 / r;
    t[i + 1] = 360 / Math.PI * Math.atan(Math.exp(s * Math.PI / 180)) - 90;
  }
}
function D_n(t, e, n) {
  e && n && (t === 1 ? e.id = n.readVarint() : t === 2 ? T_n(n, e) : t === 3 ? e.type = n.readVarint() : t === 4 && (e._geometry = n.pos));
}
function T_n(t, e) {
  const n = t.readVarint() + t.pos;
  for (; t.pos < n; ) {
    const r = e._keys[t.readVarint()], i = e._values[t.readVarint()];
    e.properties[r] = i;
  }
}
let awe, Cy, nJ, vP, rJ, iJ, m2;
class N_n {
  constructor(e, n, r, i, o, s) {
    ae(this, "properties", void 0), ae(this, "extent", void 0), ae(this, "type", void 0), ae(this, "id", void 0), ae(this, "_pbf", void 0), ae(this, "_geometry", void 0), ae(this, "_keys", void 0), ae(this, "_values", void 0), ae(this, "_geometryInfo", void 0), this.properties = {}, this.extent = r, this.type = 0, this.id = null, this._pbf = e, this._geometry = -1, this._keys = i, this._values = o, this._geometryInfo = s, e.readFields(D_n, this, n);
  }
  loadGeometry() {
    const e = this._pbf;
    e.pos = this._geometry, awe = e.readVarint() + e.pos, Cy = 1, vP = 0, rJ = 0, iJ = 0, m2 = 0;
    const n = [], r = [];
    for (; e.pos < awe; )
      if (vP <= 0 && (nJ = e.readVarint(), Cy = nJ & 7, vP = nJ >> 3), vP--, Cy === 1 || Cy === 2)
        rJ += e.readSVarint(), iJ += e.readSVarint(), Cy === 1 && n.push(m2), r.push(rJ, iJ), m2 += 2;
      else if (Cy === 7) {
        if (m2 > 0) {
          const i = n[n.length - 1];
          r.push(r[i], r[i + 1]), m2 += 2;
        }
      } else
        throw new Error("unknown command ".concat(Cy));
    return {
      data: r,
      indices: n
    };
  }
  _toBinaryCoordinates(e) {
    const n = this.loadGeometry();
    let r;
    e(n.data, this);
    const i = 2;
    switch (this.type) {
      case 1:
        this._geometryInfo.pointFeaturesCount++, this._geometryInfo.pointPositionsCount += n.indices.length, r = {
          type: "Point",
          ...n
        };
        break;
      case 2:
        this._geometryInfo.lineFeaturesCount++, this._geometryInfo.linePathsCount += n.indices.length, this._geometryInfo.linePositionsCount += n.data.length / i, r = {
          type: "LineString",
          ...n
        };
        break;
      case 3:
        r = x_n(n), this._geometryInfo.polygonFeaturesCount++, this._geometryInfo.polygonObjectsCount += r.indices.length;
        for (const s of r.indices)
          this._geometryInfo.polygonRingsCount += s.length;
        this._geometryInfo.polygonPositionsCount += r.data.length / i;
        break;
      default:
        throw new Error("Invalid geometry type: ".concat(this.type));
    }
    const o = {
      type: "Feature",
      geometry: r,
      properties: this.properties
    };
    return this.id !== null && (o.id = this.id), o;
  }
  toBinaryCoordinates(e) {
    if (typeof e == "function")
      return this._toBinaryCoordinates(e);
    const {
      x: n,
      y: r,
      z: i
    } = e, o = this.extent * Math.pow(2, i), s = this.extent * n, a = this.extent * r;
    return this._toBinaryCoordinates((A) => R_n(A, s, a, o));
  }
}
class L_n {
  constructor(e, n) {
    ae(this, "version", void 0), ae(this, "name", void 0), ae(this, "extent", void 0), ae(this, "length", void 0), ae(this, "_pbf", void 0), ae(this, "_keys", void 0), ae(this, "_values", void 0), ae(this, "_features", void 0), this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = e, this._keys = [], this._values = [], this._features = [], e.readFields(M_n, this, n), this.length = this._features.length;
  }
  feature(e, n) {
    if (e < 0 || e >= this._features.length)
      throw new Error("feature index out of bounds");
    this._pbf.pos = this._features[e];
    const r = this._pbf.readVarint() + this._pbf.pos;
    return new N_n(this._pbf, r, this.extent, this._keys, this._values, n);
  }
}
function M_n(t, e, n) {
  e && n && (t === 15 ? e.version = n.readVarint() : t === 1 ? e.name = n.readString() : t === 5 ? e.extent = n.readVarint() : t === 2 ? e._features.push(n.pos) : t === 3 ? e._keys.push(n.readString()) : t === 4 && e._values.push(O_n(n)));
}
function O_n(t) {
  let e = null;
  const n = t.readVarint() + t.pos;
  for (; t.pos < n; ) {
    const r = t.readVarint() >> 3;
    e = r === 1 ? t.readString() : r === 2 ? t.readFloat() : r === 3 ? t.readDouble() : r === 4 ? t.readVarint64() : r === 5 ? t.readVarint() : r === 6 ? t.readSVarint() : r === 7 ? t.readBoolean() : null;
  }
  return e;
}
class F_n {
  constructor(e, n) {
    ae(this, "layers", void 0), this.layers = e.readFields(P_n, {}, n);
  }
}
function P_n(t, e, n) {
  if (t === 3 && n) {
    const r = new L_n(n, n.readVarint() + n.pos);
    r.length && e && (e[r.name] = r);
  }
}
function Awe(t, e) {
  var n, r;
  const i = G_n(e), o = (e == null || (n = e.gis) === null || n === void 0 ? void 0 : n.format) || (e == null || (r = e.mvt) === null || r === void 0 ? void 0 : r.shape);
  switch (o) {
    case "columnar-table":
      return {
        shape: "columnar-table",
        data: oJ(t, i)
      };
    case "geojson-row-table":
      return {
        shape: "geojson-row-table",
        data: lwe(t, i)
      };
    case "geojson":
      return lwe(t, i);
    case "binary-geometry":
      return oJ(t, i);
    case "binary":
      return oJ(t, i);
    default:
      throw new Error(o);
  }
}
function oJ(t, e) {
  const [n, r] = k_n(t, e), i = Fbn(n, r);
  return i.byteLength = t.byteLength, i;
}
function k_n(t, e) {
  const n = [], r = {
    coordLength: 2,
    pointPositionsCount: 0,
    pointFeaturesCount: 0,
    linePositionsCount: 0,
    linePathsCount: 0,
    lineFeaturesCount: 0,
    polygonPositionsCount: 0,
    polygonObjectsCount: 0,
    polygonRingsCount: 0,
    polygonFeaturesCount: 0
  };
  if (t.byteLength <= 0)
    return [n, r];
  const i = new F_n(new QYe(t));
  return (e && Array.isArray(e.layers) ? e.layers : Object.keys(i.layers)).forEach((s) => {
    const a = i.layers[s];
    if (a)
      for (let A = 0; A < a.length; A++) {
        const l = a.feature(A, r), c = H_n(l, e, s);
        n.push(c);
      }
  }), [n, r];
}
function lwe(t, e) {
  if (t.byteLength <= 0)
    return [];
  const n = [], r = new Q_n(new QYe(t));
  return (Array.isArray(e.layers) ? e.layers : Object.keys(r.layers)).forEach((o) => {
    const s = r.layers[o];
    if (s)
      for (let a = 0; a < s.length; a++) {
        const A = s.feature(a), l = U_n(A, e, o);
        n.push(l);
      }
  }), n;
}
function G_n(t) {
  var e;
  if (!(t != null && t.mvt))
    throw new Error("mvt options required");
  const n = ((e = t.mvt) === null || e === void 0 ? void 0 : e.coordinates) === "wgs84", {
    tileIndex: r
  } = t.mvt, i = r && Number.isFinite(r.x) && Number.isFinite(r.y) && Number.isFinite(r.z);
  if (n && !i)
    throw new Error("MVT Loader: WGS84 coordinates need tileIndex property");
  return t.mvt;
}
function U_n(t, e, n) {
  const r = t.toGeoJSON(e.coordinates === "wgs84" ? e.tileIndex : $_n);
  return e.layerProperty && (r.properties[e.layerProperty] = n), r;
}
function H_n(t, e, n) {
  const r = t.toBinaryCoordinates(e.coordinates === "wgs84" ? e.tileIndex : q_n);
  return e.layerProperty && r.properties && (r.properties[e.layerProperty] = n), r;
}
function $_n(t, e) {
  const {
    extent: n
  } = e;
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    i[0] /= n, i[1] /= n;
  }
}
function q_n(t, e) {
  const {
    extent: n
  } = e;
  for (let r = 0, i = t.length; r < i; ++r)
    t[r] /= n;
}
const j_n = "3.2.10", Y_n = {
  mvt: {
    shape: "geojson",
    coordinates: "local",
    layerProperty: "layerName",
    layers: void 0,
    tileIndex: null
  }
}, xYe = {
  name: "Mapbox Vector Tile",
  id: "mvt",
  module: "mvt",
  version: j_n,
  extensions: ["mvt", "pbf"],
  mimeTypes: ["application/vnd.mapbox-vector-tile", "application/x-protobuf"],
  worker: !0,
  category: "geometry",
  options: Y_n
};
({
  ...xYe
});
const z_n = {
  Point: RYe,
  MultiPoint: V_n,
  LineString: DYe,
  MultiLineString: J_n,
  Polygon: TYe,
  MultiPolygon: K_n
};
function RYe([t, e], [n, r], i) {
  const o = Lf(n[0], r[0], t), s = Lf(n[1], r[1], e);
  return i.unprojectFlat([o, s]);
}
function Fce(t, e, n) {
  return t.map((r) => RYe(r, e, n));
}
function V_n(t, e, n) {
  return Fce(t, e, n);
}
function DYe(t, e, n) {
  return Fce(t, e, n);
}
function J_n(t, e, n) {
  return t.map((r) => DYe(r, e, n));
}
function TYe(t, e, n) {
  return t.map((r) => Fce(r, e, n));
}
function K_n(t, e, n) {
  return t.map((r) => TYe(r, e, n));
}
function W_n(t, e, n) {
  const r = n.projectFlat([e.west, e.north]), i = n.projectFlat([e.east, e.south]), o = [r, i];
  return {
    ...t,
    coordinates: z_n[t.type](t.coordinates, o, n)
  };
}
const X_n = ["points", "lines", "polygons"];
function Z_n(t, e, n, r) {
  for (const i of X_n) {
    const o = t[i] && eSn(t[i], e, n, r);
    if (o >= 0)
      return o;
  }
  return -1;
}
function eSn(t, e, n, r) {
  const i = t.featureIds.value;
  if (!i.length)
    return -1;
  let o = 0, s = i[i.length - 1] + 1;
  if (r) {
    const A = tSn(t, r);
    if (A)
      o = A[0], s = A[1] + 1;
    else
      return -1;
  }
  let a = -1;
  if (e in t.numericProps) {
    const A = t.numericProps[e].value.findIndex((l, c) => l === n && i[c] >= o && i[c] < s);
    return A >= 0 ? t.globalFeatureIds.value[A] : -1;
  } else
    e ? a = cwe(t.properties, (A) => A[e] === n, o, s) : t.fields && (a = cwe(t.fields, (A) => A.id === n, o, s));
  return a >= 0 ? nSn(t, a) : -1;
}
function tSn(t, e) {
  if (!t.__layers) {
    const n = {}, {
      properties: r
    } = t;
    for (let i = 0; i < r.length; i++) {
      const {
        layerName: o
      } = r[i];
      o && (n[o] ? n[o][1] = i : n[o] = [i, i]);
    }
    t.__layers = n;
  }
  return t.__layers[e];
}
function nSn(t, e) {
  if (!t.__ids) {
    const n = [], r = t.featureIds.value, i = t.globalFeatureIds.value;
    for (let o = 0; o < r.length; o++)
      n[r[o]] = i[o];
    t.__ids = n;
  }
  return t.__ids[e];
}
function cwe(t, e, n, r) {
  for (let i = n; i < r; i++)
    if (e(t[i], i))
      return i;
  return -1;
}
const sJ = 512, rSn = {
  ...Fw.defaultProps,
  onDataLoad: {
    type: "function",
    value: null,
    optional: !0,
    compare: !1
  },
  uniqueIdProperty: "",
  highlightedFeatureId: null,
  loaders: [xYe],
  binary: !0
};
class Pce extends i1 {
  initializeState() {
    super.initializeState();
    const e = this.context.viewport.resolution !== void 0 ? !1 : this.props.binary;
    this.setState({
      binary: e,
      data: null,
      tileJSON: null
    });
  }
  get isLoaded() {
    return this.state && this.state.data && this.state.tileset && super.isLoaded;
  }
  updateState({
    props: e,
    oldProps: n,
    context: r,
    changeFlags: i
  }) {
    var o;
    i.dataChanged && this._updateTileData(), (o = this.state) !== null && o !== void 0 && o.data && (super.updateState({
      props: e,
      oldProps: n,
      context: r,
      changeFlags: i
    }), this._setWGS84PropertyForTiles());
    const {
      highlightColor: s
    } = e;
    s !== n.highlightColor && Array.isArray(s) && this.setState({
      highlightColor: s
    });
  }
  async _updateTileData() {
    let e = this.props.data, n = null;
    if (typeof e == "string" && !hCn(e)) {
      const {
        onDataLoad: r,
        fetch: i
      } = this.props;
      this.setState({
        data: null,
        tileJSON: null
      });
      try {
        n = await i(e, {
          propName: "data",
          layer: this,
          loaders: []
        });
      } catch (o) {
        this.raiseError(o, "loading TileJSON"), e = null;
      }
      r && r(n, {
        propName: "data",
        layer: this
      });
    } else
      e.tilejson && (n = e);
    n && (e = n.tiles), this.setState({
      data: e,
      tileJSON: n
    });
  }
  _getTilesetOptions() {
    const e = super._getTilesetOptions(), n = this.state.tileJSON, {
      minZoom: r,
      maxZoom: i
    } = this.props;
    return n && (Number.isFinite(n.minzoom) && n.minzoom > r && (e.minZoom = n.minzoom), Number.isFinite(n.maxzoom) && (!Number.isFinite(i) || n.maxzoom < i) && (e.maxZoom = n.maxzoom)), e;
  }
  renderLayers() {
    var e;
    return (e = this.state) !== null && e !== void 0 && e.data ? super.renderLayers() : null;
  }
  getTileData(e) {
    var n;
    const {
      data: r,
      binary: i
    } = this.state, {
      index: o,
      signal: s
    } = e, a = VT(r, e);
    if (!a)
      return Promise.reject("Invalid URL");
    let A = this.getLoadOptions();
    const {
      fetch: l
    } = this.props;
    return A = {
      ...A,
      mimeType: "application/x-protobuf",
      mvt: {
        ...(n = A) === null || n === void 0 ? void 0 : n.mvt,
        coordinates: this.context.viewport.resolution ? "wgs84" : "local",
        tileIndex: o
      },
      gis: i ? {
        format: "binary"
      } : {}
    }, l(a, {
      propName: "data",
      layer: this,
      loadOptions: A,
      signal: s
    });
  }
  renderSubLayers(e) {
    const {
      x: n,
      y: r,
      z: i
    } = e.tile.index, o = Math.pow(2, i), s = sJ / o, a = -s, A = sJ * n / o, l = sJ * (1 - r / o), c = new pn().scale([s, a, 1]);
    e.autoHighlight = !1, this.context.viewport.resolution || (e.modelMatrix = c, e.coordinateOrigin = [A, l, 0], e.coordinateSystem = wn.CARTESIAN, e.extensions = [...e.extensions || [], new sce()]);
    const u = super.renderSubLayers(e);
    return this.state.binary && !(u instanceof Fw) && Rr.warn("renderSubLayers() must return GeoJsonLayer when using binary:true")(), u;
  }
  _updateAutoHighlight(e) {
    const {
      uniqueIdProperty: n
    } = this.props, {
      hoveredFeatureId: r,
      hoveredFeatureLayerName: i
    } = this.state, o = e.object;
    let s, a;
    o && (s = aJ(o, n), a = uwe(o));
    let {
      highlightColor: A
    } = this.props;
    typeof A == "function" && (A = A(e)), (r !== s || i !== a) && this.setState({
      highlightColor: A,
      hoveredFeatureId: s,
      hoveredFeatureLayerName: a
    });
  }
  getPickingInfo(e) {
    const n = super.getPickingInfo(e), r = !!this.context.viewport.resolution;
    if (this.state.binary && n.index !== -1) {
      const {
        data: i
      } = e.sourceLayer.props;
      n.object = rwe(i, {
        globalFeatureId: n.index
      });
    }
    return n.object && !r && (n.object = gwe(n.object, n.tile.bbox, this.context.viewport)), n;
  }
  getSubLayerPropsByTile(e) {
    return {
      highlightedObjectIndex: this.getHighlightedObjectIndex(e),
      highlightColor: this.state.highlightColor
    };
  }
  getHighlightedObjectIndex(e) {
    const {
      hoveredFeatureId: n,
      hoveredFeatureLayerName: r,
      binary: i
    } = this.state, {
      uniqueIdProperty: o,
      highlightedFeatureId: s
    } = this.props, a = e.content, A = fwe(s);
    if (!(fwe(n) || A))
      return -1;
    const c = A ? s : n;
    return Array.isArray(a) ? a.findIndex((u) => {
      const f = aJ(u, o) === c, h = A || uwe(u) === r;
      return f && h;
    }) : a && i ? Z_n(a, o, c, A ? "" : r) : -1;
  }
  _pickObjects(e) {
    const {
      deck: n,
      viewport: r
    } = this.context, i = r.width, o = r.height, s = r.x, a = r.y, A = [this.id];
    return n.pickObjects({
      x: s,
      y: a,
      width: i,
      height: o,
      layerIds: A,
      maxObjects: e
    });
  }
  getRenderedFeatures(e = null) {
    const n = this._pickObjects(e), r = /* @__PURE__ */ new Set(), i = [];
    for (const o of n) {
      const s = aJ(o.object, this.props.uniqueIdProperty);
      s === void 0 ? i.push(o.object) : r.has(s) || (r.add(s), i.push(o.object));
    }
    return i;
  }
  _setWGS84PropertyForTiles() {
    const e = "dataInWGS84";
    this.state.tileset.selectedTiles.forEach((r) => {
      r.hasOwnProperty(e) || Object.defineProperty(r, e, {
        get: () => {
          if (!r.content)
            return null;
          if (this.state.binary && Array.isArray(r.content) && !r.content.length)
            return [];
          const {
            bbox: i
          } = r;
          if (r._contentWGS84 === void 0 && dCn(i)) {
            const o = this.state.binary ? rwe(r.content) : r.content;
            r._contentWGS84 = o.map((s) => gwe(s, i, this.context.viewport));
          }
          return r._contentWGS84;
        }
      });
    });
  }
}
ae(Pce, "layerName", "MVTLayer");
ae(Pce, "defaultProps", rSn);
function aJ(t, e) {
  if (t.properties && e)
    return t.properties[e];
  if ("id" in t)
    return t.id;
}
function uwe(t) {
  var e;
  return ((e = t.properties) === null || e === void 0 ? void 0 : e.layerName) || null;
}
function fwe(t) {
  return t != null && t !== "";
}
function gwe(t, e, n) {
  const r = {
    ...t,
    geometry: {
      type: t.geometry.type
    }
  };
  return Object.defineProperty(r.geometry, "coordinates", {
    get: () => W_n(t.geometry, e, n).coordinates
  }), r;
}
const hwe = "0123456789bcdefghjkmnpqrstuvwxyz", NYe = {};
for (let t = 0; t < hwe.length; t++)
  NYe[hwe.charAt(t)] = t;
const iSn = -90, oSn = 90, sSn = -180, aSn = 180;
function ASn(t) {
  let e = !0, n = oSn, r = iSn, i = aSn, o = sSn, s, a = 0;
  for (let A = 0, l = t.length; A < l; A++) {
    const c = t[A].toLowerCase();
    a = NYe[c];
    for (let u = 4; u >= 0; u--) {
      const f = a >> u & 1;
      e ? (s = (i + o) / 2, f === 1 ? o = s : i = s) : (s = (n + r) / 2, f === 1 ? r = s : n = s), e = !e;
    }
  }
  return [r, o, n, i];
}
function lSn(t) {
  const [e, n, r, i] = ASn(t);
  return [i, r, i, e, n, e, n, r, i, r];
}
const cSn = {
  getGeohash: {
    type: "accessor",
    value: (t) => t.geohash
  }
};
class kce extends r1 {
  indexToBounds() {
    const {
      data: e,
      getGeohash: n
    } = this.props;
    return {
      data: e,
      _normalize: !1,
      positionFormat: "XY",
      getPolygon: (r, i) => lSn(n(r, i))
    };
  }
}
ae(kce, "layerName", "GeohashLayer");
ae(kce, "defaultProps", cSn);
const uSn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GeohashLayer: kce,
  GreatCircleLayer: fce,
  H3ClusterLayer: vce,
  H3HexagonLayer: o1,
  MVTLayer: Pce,
  QuadkeyLayer: hce,
  S2Layer: gce,
  TerrainLayer: Lce,
  Tile3DLayer: Nce,
  TileLayer: i1,
  TripsLayer: Cce,
  _GeoCellLayer: r1,
  _Tile2DHeader: pje,
  _Tileset2D: Eje,
  _getURLFromTemplate: VT
}, Symbol.toStringTag, { value: "Module" })), fSn = typeof window < "u" ? nse : Mn, gSn = fSn;
function UU(t, e) {
  for (; t; ) {
    if (t === e)
      return !0;
    t = Object.getPrototypeOf(t);
  }
  return !1;
}
const hSn = {
  position: "absolute",
  zIndex: -1
};
function LYe(t, e) {
  if (typeof t == "function")
    return t(e);
  if (Array.isArray(t))
    return t.map((n) => LYe(n, e));
  if (R$(t)) {
    if (dSn(t))
      return e.style = hSn, D_(t, e);
    if (pSn(t))
      return D_(t, e);
  }
  return t;
}
function R$(t) {
  return t && typeof t == "object" && "type" in t || !1;
}
function dSn(t) {
  const e = t.type, n = e && e.defaultProps;
  return n && n.mapStyle;
}
function pSn(t) {
  const e = t.type;
  return e && e.deckGLViewProps;
}
function vte(t) {
  if (typeof t == "function")
    return yS(hd, {}, t);
  if (Array.isArray(t))
    return t.map(vte);
  if (R$(t)) {
    if (t.type === le.Fragment)
      return vte(t.props.children);
    if (UU(t.type, hd))
      return t;
  }
  return t;
}
function ISn({
  children: t,
  layers: e = [],
  views: n = null
}) {
  const r = [], i = [], o = {};
  return le.Children.forEach(vte(t), (s) => {
    if (R$(s)) {
      const a = s.type;
      if (UU(a, IA)) {
        const A = mSn(a, s.props);
        i.push(A);
      } else
        r.push(s);
      if (UU(a, hd) && a !== hd && s.props.id) {
        const A = new a(s.props);
        o[A.id] = A;
      }
    } else
      s && r.push(s);
  }), Object.keys(o).length > 0 && (Array.isArray(n) ? n.forEach((s) => {
    o[s.id] = s;
  }) : n && (o[n.id] = n), n = Object.values(o)), e = i.length > 0 ? [...i, ...e] : e, {
    layers: e,
    children: r,
    views: n
  };
}
function mSn(t, e) {
  const n = {}, r = t.defaultProps || {};
  for (const i in e)
    r[i] !== e[i] && (n[i] = e[i]);
  return new t(n);
}
function CSn({
  children: t,
  deck: e,
  ContextProvider: n
}) {
  const {
    viewManager: r
  } = e || {};
  if (!r || !r.views.length)
    return [];
  const i = {}, o = r.views[0].id;
  for (const s of t) {
    let a = o, A = s;
    R$(s) && UU(s.type, hd) && (a = s.props.id || o, A = s.props.children);
    const l = r.getViewport(a), c = r.getViewState(a);
    if (l) {
      c.padding = l.padding;
      const {
        x: u,
        y: f,
        width: h,
        height: d
      } = l;
      A = LYe(A, {
        x: u,
        y: f,
        width: h,
        height: d,
        viewport: l,
        viewState: c
      }), i[a] || (i[a] = {
        viewport: l,
        children: []
      }), i[a].children.push(A);
    }
  }
  return Object.keys(i).map((s) => {
    const {
      viewport: a,
      children: A
    } = i[s], {
      x: l,
      y: c,
      width: u,
      height: f
    } = a, h = {
      position: "absolute",
      left: l,
      top: c,
      width: u,
      height: f
    }, d = "view-".concat(s), I = yS("div", {
      key: d,
      id: d,
      style: h
    }, ...A);
    if (n) {
      const m = {
        viewport: a,
        container: e.canvas.offsetParent,
        eventManager: e.eventManager,
        onViewStateChange: (C) => {
          C.viewId = s, e._onViewStateChange(C);
        }
      };
      return yS(n, {
        key: d,
        value: m
      }, I);
    }
    return I;
  });
}
const ESn = {
  mixBlendMode: null
};
function ySn({
  width: t,
  height: e,
  style: n
}) {
  const r = {
    position: "absolute",
    zIndex: 0,
    left: 0,
    top: 0,
    width: t,
    height: e
  }, i = {
    left: 0,
    top: 0
  };
  if (n)
    for (const o in n)
      o in ESn ? i[o] = n[o] : r[o] = n[o];
  return {
    containerStyle: r,
    canvasStyle: i
  };
}
function vSn(t) {
  return {
    get deck() {
      return t.deck;
    },
    pickObject: (e) => t.deck.pickObject(e),
    pickMultipleObjects: (e) => t.deck.pickMultipleObjects(e),
    pickObjects: (e) => t.deck.pickObjects(e)
  };
}
function MYe(t) {
  t.redrawReason && (t.deck._drawLayers(t.redrawReason), t.redrawReason = null);
}
function BSn(t, e, n) {
  const r = new e({
    ...n,
    _customRender: (i) => {
      t.redrawReason = i;
      const o = r.getViewports();
      t.lastRenderedViewports !== o ? t.forceUpdate() : MYe(t);
    }
  });
  return r;
}
const OYe = CE((t, e) => {
  const [n, r] = mn(0), o = Zr({
    control: null,
    version: n,
    forceUpdate: () => r((Q) => Q + 1)
  }).current, s = Zr(null), a = Zr(null), A = dt(() => ISn(t), [t.layers, t.views, t.children]);
  let l = !0;
  const c = (Q) => {
    var w;
    return l && t.viewState ? (o.viewStateUpdateRequested = Q, null) : (o.viewStateUpdateRequested = null, (w = t.onViewStateChange) === null || w === void 0 ? void 0 : w.call(t, Q));
  }, u = (Q) => {
    if (l)
      o.interactionStateUpdateRequested = Q;
    else {
      var w;
      o.interactionStateUpdateRequested = null, (w = t.onInteractionStateChange) === null || w === void 0 || w.call(t, Q);
    }
  }, f = dt(() => {
    const Q = {
      ...t,
      style: null,
      width: "100%",
      height: "100%",
      parent: s.current,
      canvas: a.current,
      layers: A.layers,
      views: A.views,
      onViewStateChange: c,
      onInteractionStateChange: u
    };
    return delete Q._customRender, o.deck && o.deck.setProps(Q), Q;
  }, [t]);
  Mn(() => {
    const Q = t.Deck || pM;
    return o.deck = BSn(o, Q, {
      ...f,
      parent: s.current,
      canvas: a.current
    }), () => {
      var w;
      return (w = o.deck) === null || w === void 0 ? void 0 : w.finalize();
    };
  }, []), gSn(() => {
    MYe(o);
    const {
      viewStateUpdateRequested: Q,
      interactionStateUpdateRequested: w
    } = o;
    Q && c(Q), w && u(w);
  }), rse(e, () => vSn(o), []);
  const h = o.deck && o.deck.isInitialized ? o.deck.getViewports() : void 0, {
    ContextProvider: d,
    width: I,
    height: m,
    id: C,
    style: y
  } = t, {
    containerStyle: v,
    canvasStyle: b
  } = dt(() => ySn({
    width: I,
    height: m,
    style: y
  }), [I, m, y]);
  if (!o.viewStateUpdateRequested && o.lastRenderedViewports === h || o.version !== n) {
    o.lastRenderedViewports = h, o.version = n;
    const Q = CSn({
      children: A.children,
      deck: o.deck,
      ContextProvider: d
    }), w = yS("canvas", {
      key: "canvas",
      id: C || "deckgl-overlay",
      ref: a,
      style: b
    });
    o.control = yS("div", {
      id: "".concat(C || "deckgl", "-wrapper"),
      ref: s,
      style: v
    }, [w, Q]);
  }
  return l = !1, o.control;
});
OYe.defaultProps = pM.defaultProps;
const FYe = OYe;
function jp(t) {
  var e = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
  return JB(t, function(n) {
    e[0] > n[0] && (e[0] = n[0]), e[1] > n[1] && (e[1] = n[1]), e[2] < n[0] && (e[2] = n[0]), e[3] < n[1] && (e[3] = n[1]);
  }), e;
}
jp.default = jp;
function Gce(t) {
  if (!t)
    throw new Error("coord is required");
  if (!Array.isArray(t)) {
    if (t.type === "Feature" && t.geometry !== null && t.geometry.type === "Point")
      return t.geometry.coordinates;
    if (t.type === "Point")
      return t.coordinates;
  }
  if (Array.isArray(t) && t.length >= 2 && !Array.isArray(t[0]) && !Array.isArray(t[1]))
    return t;
  throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function Ug(t) {
  if (Array.isArray(t))
    return t;
  if (t.type === "Feature") {
    if (t.geometry !== null)
      return t.geometry.coordinates;
  } else if (t.coordinates)
    return t.coordinates;
  throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function PYe(t) {
  if (t.length > 1 && NS(t[0]) && NS(t[1]))
    return !0;
  if (Array.isArray(t[0]) && t[0].length)
    return PYe(t[0]);
  throw new Error("coordinates must only contain numbers");
}
function bSn(t, e, n) {
  if (!e || !n)
    throw new Error("type and name required");
  if (!t || t.type !== e)
    throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + t.type);
}
function _Sn(t, e, n) {
  if (!t)
    throw new Error("No feature passed");
  if (!n)
    throw new Error(".featureOf() requires a name");
  if (!t || t.type !== "Feature" || !t.geometry)
    throw new Error("Invalid input to " + n + ", Feature with geometry required");
  if (!t.geometry || t.geometry.type !== e)
    throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + t.geometry.type);
}
function SSn(t, e, n) {
  if (!t)
    throw new Error("No featureCollection passed");
  if (!n)
    throw new Error(".collectionOf() requires a name");
  if (!t || t.type !== "FeatureCollection")
    throw new Error("Invalid input to " + n + ", FeatureCollection required");
  for (var r = 0, i = t.features; r < i.length; r++) {
    var o = i[r];
    if (!o || o.type !== "Feature" || !o.geometry)
      throw new Error("Invalid input to " + n + ", Feature with geometry required");
    if (!o.geometry || o.geometry.type !== e)
      throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + o.geometry.type);
  }
}
function OI(t) {
  return t.type === "Feature" ? t.geometry : t;
}
function QSn(t, e) {
  return t.type === "FeatureCollection" ? "FeatureCollection" : t.type === "GeometryCollection" ? "GeometryCollection" : t.type === "Feature" && t.geometry !== null ? t.geometry.type : t.type;
}
const wSn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  collectionOf: SSn,
  containsNumber: PYe,
  featureOf: _Sn,
  geojsonType: bSn,
  getCoord: Gce,
  getCoords: Ug,
  getGeom: OI,
  getType: QSn
}, Symbol.toStringTag, { value: "Module" }));
function xf(t, e, n) {
  n === void 0 && (n = {});
  for (var r = Gce(t), i = Ug(e), o = 0; o < i.length - 1; o++) {
    var s = !1;
    if (n.ignoreEndVertices && (o === 0 && (s = "start"), o === i.length - 2 && (s = "end"), o === 0 && o + 1 === i.length - 1 && (s = "both")), xSn(i[o], i[o + 1], r, s, typeof n.epsilon > "u" ? null : n.epsilon))
      return !0;
  }
  return !1;
}
function xSn(t, e, n, r, i) {
  var o = n[0], s = n[1], a = t[0], A = t[1], l = e[0], c = e[1], u = n[0] - a, f = n[1] - A, h = l - a, d = c - A, I = u * d - f * h;
  if (i !== null) {
    if (Math.abs(I) > i)
      return !1;
  } else if (I !== 0)
    return !1;
  if (r) {
    if (r === "start")
      return Math.abs(h) >= Math.abs(d) ? h > 0 ? a < o && o <= l : l <= o && o < a : d > 0 ? A < s && s <= c : c <= s && s < A;
    if (r === "end")
      return Math.abs(h) >= Math.abs(d) ? h > 0 ? a <= o && o < l : l < o && o <= a : d > 0 ? A <= s && s < c : c < s && s <= A;
    if (r === "both")
      return Math.abs(h) >= Math.abs(d) ? h > 0 ? a < o && o < l : l < o && o < a : d > 0 ? A < s && s < c : c < s && s < A;
  } else
    return Math.abs(h) >= Math.abs(d) ? h > 0 ? a <= o && o <= l : l <= o && o <= a : d > 0 ? A <= s && s <= c : c <= s && s <= A;
  return !1;
}
function Tg(t, e, n) {
  if (n === void 0 && (n = {}), !t)
    throw new Error("point is required");
  if (!e)
    throw new Error("polygon is required");
  var r = Gce(t), i = OI(e), o = i.type, s = e.bbox, a = i.coordinates;
  if (s && RSn(r, s) === !1)
    return !1;
  o === "Polygon" && (a = [a]);
  for (var A = !1, l = 0; l < a.length && !A; l++)
    if (dwe(r, a[l][0], n.ignoreBoundary)) {
      for (var c = !1, u = 1; u < a[l].length && !c; )
        dwe(r, a[l][u], !n.ignoreBoundary) && (c = !0), u++;
      c || (A = !0);
    }
  return A;
}
function dwe(t, e, n) {
  var r = !1;
  e[0][0] === e[e.length - 1][0] && e[0][1] === e[e.length - 1][1] && (e = e.slice(0, e.length - 1));
  for (var i = 0, o = e.length - 1; i < e.length; o = i++) {
    var s = e[i][0], a = e[i][1], A = e[o][0], l = e[o][1], c = t[1] * (s - A) + a * (A - t[0]) + l * (t[0] - s) === 0 && (s - t[0]) * (A - t[0]) <= 0 && (a - t[1]) * (l - t[1]) <= 0;
    if (c)
      return !n;
    var u = a > t[1] != l > t[1] && t[0] < (A - s) * (t[1] - a) / (l - a) + s;
    u && (r = !r);
  }
  return r;
}
function RSn(t, e) {
  return e[0] <= t[0] && e[1] <= t[1] && e[2] >= t[0] && e[3] >= t[1];
}
function DSn(t, e) {
  var n = OI(t), r = OI(e), i = n.type, o = r.type;
  switch (i) {
    case "Point":
      switch (o) {
        case "MultiPoint":
          return TSn(n, r);
        case "LineString":
          return xf(n, r, { ignoreEndVertices: !0 });
        case "Polygon":
        case "MultiPolygon":
          return Tg(n, r, { ignoreBoundary: !0 });
        default:
          throw new Error("feature2 " + o + " geometry not supported");
      }
    case "MultiPoint":
      switch (o) {
        case "MultiPoint":
          return NSn(n, r);
        case "LineString":
          return LSn(n, r);
        case "Polygon":
        case "MultiPolygon":
          return MSn(n, r);
        default:
          throw new Error("feature2 " + o + " geometry not supported");
      }
    case "LineString":
      switch (o) {
        case "LineString":
          return OSn(n, r);
        case "Polygon":
        case "MultiPolygon":
          return FSn(n, r);
        default:
          throw new Error("feature2 " + o + " geometry not supported");
      }
    case "Polygon":
      switch (o) {
        case "Polygon":
        case "MultiPolygon":
          return PSn(n, r);
        default:
          throw new Error("feature2 " + o + " geometry not supported");
      }
    default:
      throw new Error("feature1 " + i + " geometry not supported");
  }
}
function TSn(t, e) {
  var n, r = !1;
  for (n = 0; n < e.coordinates.length; n++)
    if (GYe(e.coordinates[n], t.coordinates)) {
      r = !0;
      break;
    }
  return r;
}
function NSn(t, e) {
  for (var n = 0; n < t.coordinates.length; n++) {
    for (var r = !1, i = 0; i < e.coordinates.length; i++)
      GYe(t.coordinates[n], e.coordinates[i]) && (r = !0);
    if (!r)
      return !1;
  }
  return !0;
}
function LSn(t, e) {
  for (var n = !1, r = 0; r < t.coordinates.length; r++) {
    if (!xf(t.coordinates[r], e))
      return !1;
    n || (n = xf(t.coordinates[r], e, { ignoreEndVertices: !0 }));
  }
  return n;
}
function MSn(t, e) {
  for (var n = !0, r = !1, i = 0; i < t.coordinates.length; i++) {
    if (r = Tg(t.coordinates[1], e), !r) {
      n = !1;
      break;
    }
    r = Tg(t.coordinates[1], e, {
      ignoreBoundary: !0
    });
  }
  return n && r;
}
function OSn(t, e) {
  for (var n = 0; n < t.coordinates.length; n++)
    if (!xf(t.coordinates[n], e))
      return !1;
  return !0;
}
function FSn(t, e) {
  var n = jp(e), r = jp(t);
  if (!kYe(n, r))
    return !1;
  for (var i = !1, o = 0; o < t.coordinates.length - 1; o++) {
    if (!Tg(t.coordinates[o], e))
      return !1;
    if (i || (i = Tg(t.coordinates[o], e, { ignoreBoundary: !0 })), !i) {
      var s = kSn(t.coordinates[o], t.coordinates[o + 1]);
      i = Tg(s, e, {
        ignoreBoundary: !0
      });
    }
  }
  return i;
}
function PSn(t, e) {
  var n = jp(t), r = jp(e);
  if (!kYe(r, n))
    return !1;
  for (var i = 0; i < t.coordinates[0].length; i++)
    if (!Tg(t.coordinates[0][i], e))
      return !1;
  return !0;
}
function kYe(t, e) {
  return !(t[0] > e[0] || t[2] < e[2] || t[1] > e[1] || t[3] < e[3]);
}
function GYe(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}
function kSn(t, e) {
  return [(t[0] + e[0]) / 2, (t[1] + e[1]) / 2];
}
function GSn(t, e) {
  var n = OI(t), r = OI(e), i = n.type, o = r.type, s = n.coordinates, a = r.coordinates;
  switch (i) {
    case "Point":
      switch (o) {
        case "Point":
          return Uce(s, a);
        default:
          throw new Error("feature2 " + o + " geometry not supported");
      }
    case "MultiPoint":
      switch (o) {
        case "Point":
          return USn(n, r);
        case "MultiPoint":
          return HSn(n, r);
        default:
          throw new Error("feature2 " + o + " geometry not supported");
      }
    case "LineString":
      switch (o) {
        case "Point":
          return xf(r, n, { ignoreEndVertices: !0 });
        case "LineString":
          return jSn(n, r);
        case "MultiPoint":
          return $Sn(n, r);
        default:
          throw new Error("feature2 " + o + " geometry not supported");
      }
    case "Polygon":
      switch (o) {
        case "Point":
          return Tg(r, n, { ignoreBoundary: !0 });
        case "LineString":
          return YSn(n, r);
        case "Polygon":
          return zSn(n, r);
        case "MultiPoint":
          return qSn(n, r);
        default:
          throw new Error("feature2 " + o + " geometry not supported");
      }
    default:
      throw new Error("feature1 " + i + " geometry not supported");
  }
}
function USn(t, e) {
  var n, r = !1;
  for (n = 0; n < t.coordinates.length; n++)
    if (Uce(t.coordinates[n], e.coordinates)) {
      r = !0;
      break;
    }
  return r;
}
function HSn(t, e) {
  for (var n = 0, r = e.coordinates; n < r.length; n++) {
    for (var i = r[n], o = !1, s = 0, a = t.coordinates; s < a.length; s++) {
      var A = a[s];
      if (Uce(i, A)) {
        o = !0;
        break;
      }
    }
    if (!o)
      return !1;
  }
  return !0;
}
function $Sn(t, e) {
  for (var n = !1, r = 0, i = e.coordinates; r < i.length; r++) {
    var o = i[r];
    if (xf(o, t, { ignoreEndVertices: !0 }) && (n = !0), !xf(o, t))
      return !1;
  }
  return !!n;
}
function qSn(t, e) {
  for (var n = 0, r = e.coordinates; n < r.length; n++) {
    var i = r[n];
    if (!Tg(i, t, { ignoreBoundary: !0 }))
      return !1;
  }
  return !0;
}
function jSn(t, e) {
  for (var n = !1, r = 0, i = e.coordinates; r < i.length; r++) {
    var o = i[r];
    if (xf({ type: "Point", coordinates: o }, t, {
      ignoreEndVertices: !0
    }) && (n = !0), !xf({ type: "Point", coordinates: o }, t, {
      ignoreEndVertices: !1
    }))
      return !1;
  }
  return n;
}
function YSn(t, e) {
  var n = !1, r = 0, i = jp(t), o = jp(e);
  if (!UYe(i, o))
    return !1;
  for (r; r < e.coordinates.length - 1; r++) {
    var s = VSn(e.coordinates[r], e.coordinates[r + 1]);
    if (Tg({ type: "Point", coordinates: s }, t, {
      ignoreBoundary: !0
    })) {
      n = !0;
      break;
    }
  }
  return n;
}
function zSn(t, e) {
  if (t.type === "Feature" && t.geometry === null || e.type === "Feature" && e.geometry === null)
    return !1;
  var n = jp(t), r = jp(e);
  if (!UYe(n, r))
    return !1;
  for (var i = OI(e).coordinates, o = 0, s = i; o < s.length; o++)
    for (var a = s[o], A = 0, l = a; A < l.length; A++) {
      var c = l[A];
      if (!Tg(c, t))
        return !1;
    }
  return !0;
}
function UYe(t, e) {
  return !(t[0] > e[0] || t[2] < e[2] || t[1] > e[1] || t[3] < e[3]);
}
function Uce(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}
function VSn(t, e) {
  return [(t[0] + e[0]) / 2, (t[1] + e[1]) / 2];
}
var Hce = { exports: {} }, ar = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.earthRadius = 63710088e-1, t.factors = {
    centimeters: t.earthRadius * 100,
    centimetres: t.earthRadius * 100,
    degrees: t.earthRadius / 111325,
    feet: t.earthRadius * 3.28084,
    inches: t.earthRadius * 39.37,
    kilometers: t.earthRadius / 1e3,
    kilometres: t.earthRadius / 1e3,
    meters: t.earthRadius,
    metres: t.earthRadius,
    miles: t.earthRadius / 1609.344,
    millimeters: t.earthRadius * 1e3,
    millimetres: t.earthRadius * 1e3,
    nauticalmiles: t.earthRadius / 1852,
    radians: 1,
    yards: t.earthRadius * 1.0936
  }, t.unitsFactors = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 1 / 1e3,
    kilometres: 1 / 1e3,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1e3,
    millimetres: 1e3,
    nauticalmiles: 1 / 1852,
    radians: 1 / t.earthRadius,
    yards: 1.0936133
  }, t.areaFactors = {
    acres: 247105e-9,
    centimeters: 1e4,
    centimetres: 1e4,
    feet: 10.763910417,
    hectares: 1e-4,
    inches: 1550.003100006,
    kilometers: 1e-6,
    kilometres: 1e-6,
    meters: 1,
    metres: 1,
    miles: 386e-9,
    millimeters: 1e6,
    millimetres: 1e6,
    yards: 1.195990046
  };
  function e(N, k, $) {
    $ === void 0 && ($ = {});
    var U = { type: "Feature" };
    return ($.id === 0 || $.id) && (U.id = $.id), $.bbox && (U.bbox = $.bbox), U.properties = k || {}, U.geometry = N, U;
  }
  t.feature = e;
  function n(N, k, $) {
    switch (N) {
      case "Point":
        return r(k).geometry;
      case "LineString":
        return a(k).geometry;
      case "Polygon":
        return o(k).geometry;
      case "MultiPoint":
        return u(k).geometry;
      case "MultiLineString":
        return c(k).geometry;
      case "MultiPolygon":
        return f(k).geometry;
      default:
        throw new Error(N + " is invalid");
    }
  }
  t.geometry = n;
  function r(N, k, $) {
    if ($ === void 0 && ($ = {}), !N)
      throw new Error("coordinates is required");
    if (!Array.isArray(N))
      throw new Error("coordinates must be an Array");
    if (N.length < 2)
      throw new Error("coordinates must be at least 2 numbers long");
    if (!R(N[0]) || !R(N[1]))
      throw new Error("coordinates must contain numbers");
    var U = {
      type: "Point",
      coordinates: N
    };
    return e(U, k, $);
  }
  t.point = r;
  function i(N, k, $) {
    return $ === void 0 && ($ = {}), l(N.map(function(U) {
      return r(U, k);
    }), $);
  }
  t.points = i;
  function o(N, k, $) {
    $ === void 0 && ($ = {});
    for (var U = 0, X = N; U < X.length; U++) {
      var K = X[U];
      if (K.length < 4)
        throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
      for (var z = 0; z < K[K.length - 1].length; z++)
        if (K[K.length - 1][z] !== K[0][z])
          throw new Error("First and last Position are not equivalent.");
    }
    var Y = {
      type: "Polygon",
      coordinates: N
    };
    return e(Y, k, $);
  }
  t.polygon = o;
  function s(N, k, $) {
    return $ === void 0 && ($ = {}), l(N.map(function(U) {
      return o(U, k);
    }), $);
  }
  t.polygons = s;
  function a(N, k, $) {
    if ($ === void 0 && ($ = {}), N.length < 2)
      throw new Error("coordinates must be an array of two or more positions");
    var U = {
      type: "LineString",
      coordinates: N
    };
    return e(U, k, $);
  }
  t.lineString = a;
  function A(N, k, $) {
    return $ === void 0 && ($ = {}), l(N.map(function(U) {
      return a(U, k);
    }), $);
  }
  t.lineStrings = A;
  function l(N, k) {
    k === void 0 && (k = {});
    var $ = { type: "FeatureCollection" };
    return k.id && ($.id = k.id), k.bbox && ($.bbox = k.bbox), $.features = N, $;
  }
  t.featureCollection = l;
  function c(N, k, $) {
    $ === void 0 && ($ = {});
    var U = {
      type: "MultiLineString",
      coordinates: N
    };
    return e(U, k, $);
  }
  t.multiLineString = c;
  function u(N, k, $) {
    $ === void 0 && ($ = {});
    var U = {
      type: "MultiPoint",
      coordinates: N
    };
    return e(U, k, $);
  }
  t.multiPoint = u;
  function f(N, k, $) {
    $ === void 0 && ($ = {});
    var U = {
      type: "MultiPolygon",
      coordinates: N
    };
    return e(U, k, $);
  }
  t.multiPolygon = f;
  function h(N, k, $) {
    $ === void 0 && ($ = {});
    var U = {
      type: "GeometryCollection",
      geometries: N
    };
    return e(U, k, $);
  }
  t.geometryCollection = h;
  function d(N, k) {
    if (k === void 0 && (k = 0), k && !(k >= 0))
      throw new Error("precision must be a positive number");
    var $ = Math.pow(10, k || 0);
    return Math.round(N * $) / $;
  }
  t.round = d;
  function I(N, k) {
    k === void 0 && (k = "kilometers");
    var $ = t.factors[k];
    if (!$)
      throw new Error(k + " units is invalid");
    return N * $;
  }
  t.radiansToLength = I;
  function m(N, k) {
    k === void 0 && (k = "kilometers");
    var $ = t.factors[k];
    if (!$)
      throw new Error(k + " units is invalid");
    return N / $;
  }
  t.lengthToRadians = m;
  function C(N, k) {
    return v(m(N, k));
  }
  t.lengthToDegrees = C;
  function y(N) {
    var k = N % 360;
    return k < 0 && (k += 360), k;
  }
  t.bearingToAzimuth = y;
  function v(N) {
    var k = N % (2 * Math.PI);
    return k * 180 / Math.PI;
  }
  t.radiansToDegrees = v;
  function b(N) {
    var k = N % 360;
    return k * Math.PI / 180;
  }
  t.degreesToRadians = b;
  function Q(N, k, $) {
    if (k === void 0 && (k = "kilometers"), $ === void 0 && ($ = "kilometers"), !(N >= 0))
      throw new Error("length must be a positive number");
    return I(m(N, k), $);
  }
  t.convertLength = Q;
  function w(N, k, $) {
    if (k === void 0 && (k = "meters"), $ === void 0 && ($ = "kilometers"), !(N >= 0))
      throw new Error("area must be a positive number");
    var U = t.areaFactors[k];
    if (!U)
      throw new Error("invalid original units");
    var X = t.areaFactors[$];
    if (!X)
      throw new Error("invalid final units");
    return N / U * X;
  }
  t.convertArea = w;
  function R(N) {
    return !isNaN(N) && N !== null && !Array.isArray(N);
  }
  t.isNumber = R;
  function M(N) {
    return !!N && N.constructor === Object;
  }
  t.isObject = M;
  function O(N) {
    if (!N)
      throw new Error("bbox is required");
    if (!Array.isArray(N))
      throw new Error("bbox must be an Array");
    if (N.length !== 4 && N.length !== 6)
      throw new Error("bbox must be an Array of 4 or 6 numbers");
    N.forEach(function(k) {
      if (!R(k))
        throw new Error("bbox must only contain numbers");
    });
  }
  t.validateBBox = O;
  function L(N) {
    if (!N)
      throw new Error("id is required");
    if (["string", "number"].indexOf(typeof N) === -1)
      throw new Error("id must be a number or a string");
  }
  t.validateId = L;
})(ar);
var Do = {};
const BM = /* @__PURE__ */ Fs(c4t);
Object.defineProperty(Do, "__esModule", { value: !0 });
var $l = BM;
function bM(t, e, n) {
  if (t !== null)
    for (var r, i, o, s, a, A, l, c = 0, u = 0, f, h = t.type, d = h === "FeatureCollection", I = h === "Feature", m = d ? t.features.length : 1, C = 0; C < m; C++) {
      l = d ? t.features[C].geometry : I ? t.geometry : t, f = l ? l.type === "GeometryCollection" : !1, a = f ? l.geometries.length : 1;
      for (var y = 0; y < a; y++) {
        var v = 0, b = 0;
        if (s = f ? l.geometries[y] : l, s !== null) {
          A = s.coordinates;
          var Q = s.type;
          switch (c = n && (Q === "Polygon" || Q === "MultiPolygon") ? 1 : 0, Q) {
            case null:
              break;
            case "Point":
              if (e(
                A,
                u,
                C,
                v,
                b
              ) === !1)
                return !1;
              u++, v++;
              break;
            case "LineString":
            case "MultiPoint":
              for (r = 0; r < A.length; r++) {
                if (e(
                  A[r],
                  u,
                  C,
                  v,
                  b
                ) === !1)
                  return !1;
                u++, Q === "MultiPoint" && v++;
              }
              Q === "LineString" && v++;
              break;
            case "Polygon":
            case "MultiLineString":
              for (r = 0; r < A.length; r++) {
                for (i = 0; i < A[r].length - c; i++) {
                  if (e(
                    A[r][i],
                    u,
                    C,
                    v,
                    b
                  ) === !1)
                    return !1;
                  u++;
                }
                Q === "MultiLineString" && v++, Q === "Polygon" && b++;
              }
              Q === "Polygon" && v++;
              break;
            case "MultiPolygon":
              for (r = 0; r < A.length; r++) {
                for (b = 0, i = 0; i < A[r].length; i++) {
                  for (o = 0; o < A[r][i].length - c; o++) {
                    if (e(
                      A[r][i][o],
                      u,
                      C,
                      v,
                      b
                    ) === !1)
                      return !1;
                    u++;
                  }
                  b++;
                }
                v++;
              }
              break;
            case "GeometryCollection":
              for (r = 0; r < s.geometries.length; r++)
                if (bM(s.geometries[r], e, n) === !1)
                  return !1;
              break;
            default:
              throw new Error("Unknown Geometry Type");
          }
        }
      }
    }
}
function JSn(t, e, n, r) {
  var i = n;
  return bM(
    t,
    function(o, s, a, A, l) {
      s === 0 && n === void 0 ? i = o : i = e(
        i,
        o,
        s,
        a,
        A,
        l
      );
    },
    r
  ), i;
}
function HYe(t, e) {
  var n;
  switch (t.type) {
    case "FeatureCollection":
      for (n = 0; n < t.features.length && e(t.features[n].properties, n) !== !1; n++)
        ;
      break;
    case "Feature":
      e(t.properties, 0);
      break;
  }
}
function KSn(t, e, n) {
  var r = n;
  return HYe(t, function(i, o) {
    o === 0 && n === void 0 ? r = i : r = e(r, i, o);
  }), r;
}
function $Ye(t, e) {
  if (t.type === "Feature")
    e(t, 0);
  else if (t.type === "FeatureCollection")
    for (var n = 0; n < t.features.length && e(t.features[n], n) !== !1; n++)
      ;
}
function WSn(t, e, n) {
  var r = n;
  return $Ye(t, function(i, o) {
    o === 0 && n === void 0 ? r = i : r = e(r, i, o);
  }), r;
}
function XSn(t) {
  var e = [];
  return bM(t, function(n) {
    e.push(n);
  }), e;
}
function $ce(t, e) {
  var n, r, i, o, s, a, A, l, c, u, f = 0, h = t.type === "FeatureCollection", d = t.type === "Feature", I = h ? t.features.length : 1;
  for (n = 0; n < I; n++) {
    for (a = h ? t.features[n].geometry : d ? t.geometry : t, l = h ? t.features[n].properties : d ? t.properties : {}, c = h ? t.features[n].bbox : d ? t.bbox : void 0, u = h ? t.features[n].id : d ? t.id : void 0, A = a ? a.type === "GeometryCollection" : !1, s = A ? a.geometries.length : 1, i = 0; i < s; i++) {
      if (o = A ? a.geometries[i] : a, o === null) {
        if (e(
          null,
          f,
          l,
          c,
          u
        ) === !1)
          return !1;
        continue;
      }
      switch (o.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (e(
            o,
            f,
            l,
            c,
            u
          ) === !1)
            return !1;
          break;
        }
        case "GeometryCollection": {
          for (r = 0; r < o.geometries.length; r++)
            if (e(
              o.geometries[r],
              f,
              l,
              c,
              u
            ) === !1)
              return !1;
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    f++;
  }
}
function ZSn(t, e, n) {
  var r = n;
  return $ce(
    t,
    function(i, o, s, a, A) {
      o === 0 && n === void 0 ? r = i : r = e(
        r,
        i,
        o,
        s,
        a,
        A
      );
    }
  ), r;
}
function D$(t, e) {
  $ce(t, function(n, r, i, o, s) {
    var a = n === null ? null : n.type;
    switch (a) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        return e(
          $l.feature(n, i, { bbox: o, id: s }),
          r,
          0
        ) === !1 ? !1 : void 0;
    }
    var A;
    switch (a) {
      case "MultiPoint":
        A = "Point";
        break;
      case "MultiLineString":
        A = "LineString";
        break;
      case "MultiPolygon":
        A = "Polygon";
        break;
    }
    for (var l = 0; l < n.coordinates.length; l++) {
      var c = n.coordinates[l], u = {
        type: A,
        coordinates: c
      };
      if (e($l.feature(u, i), r, l) === !1)
        return !1;
    }
  });
}
function eQn(t, e, n) {
  var r = n;
  return D$(
    t,
    function(i, o, s) {
      o === 0 && s === 0 && n === void 0 ? r = i : r = e(
        r,
        i,
        o,
        s
      );
    }
  ), r;
}
function qYe(t, e) {
  D$(t, function(n, r, i) {
    var o = 0;
    if (n.geometry) {
      var s = n.geometry.type;
      if (!(s === "Point" || s === "MultiPoint")) {
        var a, A = 0, l = 0, c = 0;
        if (bM(
          n,
          function(u, f, h, d, I) {
            if (a === void 0 || r > A || d > l || I > c) {
              a = u, A = r, l = d, c = I, o = 0;
              return;
            }
            var m = $l.lineString(
              [a, u],
              n.properties
            );
            if (e(
              m,
              r,
              i,
              I,
              o
            ) === !1)
              return !1;
            o++, a = u;
          }
        ) === !1)
          return !1;
      }
    }
  });
}
function tQn(t, e, n) {
  var r = n, i = !1;
  return qYe(
    t,
    function(o, s, a, A, l) {
      i === !1 && n === void 0 ? r = o : r = e(
        r,
        o,
        s,
        a,
        A,
        l
      ), i = !0;
    }
  ), r;
}
function jYe(t, e) {
  if (!t)
    throw new Error("geojson is required");
  D$(t, function(n, r, i) {
    if (n.geometry !== null) {
      var o = n.geometry.type, s = n.geometry.coordinates;
      switch (o) {
        case "LineString":
          if (e(n, r, i, 0, 0) === !1)
            return !1;
          break;
        case "Polygon":
          for (var a = 0; a < s.length; a++)
            if (e(
              $l.lineString(s[a], n.properties),
              r,
              i,
              a
            ) === !1)
              return !1;
          break;
      }
    }
  });
}
function nQn(t, e, n) {
  var r = n;
  return jYe(
    t,
    function(i, o, s, a) {
      o === 0 && n === void 0 ? r = i : r = e(
        r,
        i,
        o,
        s,
        a
      );
    }
  ), r;
}
function rQn(t, e) {
  if (e = e || {}, !$l.isObject(e))
    throw new Error("options is invalid");
  var n = e.featureIndex || 0, r = e.multiFeatureIndex || 0, i = e.geometryIndex || 0, o = e.segmentIndex || 0, s = e.properties, a;
  switch (t.type) {
    case "FeatureCollection":
      n < 0 && (n = t.features.length + n), s = s || t.features[n].properties, a = t.features[n].geometry;
      break;
    case "Feature":
      s = s || t.properties, a = t.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      a = t;
      break;
    default:
      throw new Error("geojson is invalid");
  }
  if (a === null)
    return null;
  var A = a.coordinates;
  switch (a.type) {
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
      return o < 0 && (o = A.length + o - 1), $l.lineString(
        [A[o], A[o + 1]],
        s,
        e
      );
    case "Polygon":
      return i < 0 && (i = A.length + i), o < 0 && (o = A[i].length + o - 1), $l.lineString(
        [
          A[i][o],
          A[i][o + 1]
        ],
        s,
        e
      );
    case "MultiLineString":
      return r < 0 && (r = A.length + r), o < 0 && (o = A[r].length + o - 1), $l.lineString(
        [
          A[r][o],
          A[r][o + 1]
        ],
        s,
        e
      );
    case "MultiPolygon":
      return r < 0 && (r = A.length + r), i < 0 && (i = A[r].length + i), o < 0 && (o = A[r][i].length - o - 1), $l.lineString(
        [
          A[r][i][o],
          A[r][i][o + 1]
        ],
        s,
        e
      );
  }
  throw new Error("geojson is invalid");
}
function iQn(t, e) {
  if (e = e || {}, !$l.isObject(e))
    throw new Error("options is invalid");
  var n = e.featureIndex || 0, r = e.multiFeatureIndex || 0, i = e.geometryIndex || 0, o = e.coordIndex || 0, s = e.properties, a;
  switch (t.type) {
    case "FeatureCollection":
      n < 0 && (n = t.features.length + n), s = s || t.features[n].properties, a = t.features[n].geometry;
      break;
    case "Feature":
      s = s || t.properties, a = t.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      a = t;
      break;
    default:
      throw new Error("geojson is invalid");
  }
  if (a === null)
    return null;
  var A = a.coordinates;
  switch (a.type) {
    case "Point":
      return $l.point(A, s, e);
    case "MultiPoint":
      return r < 0 && (r = A.length + r), $l.point(A[r], s, e);
    case "LineString":
      return o < 0 && (o = A.length + o), $l.point(A[o], s, e);
    case "Polygon":
      return i < 0 && (i = A.length + i), o < 0 && (o = A[i].length + o), $l.point(A[i][o], s, e);
    case "MultiLineString":
      return r < 0 && (r = A.length + r), o < 0 && (o = A[r].length + o), $l.point(A[r][o], s, e);
    case "MultiPolygon":
      return r < 0 && (r = A.length + r), i < 0 && (i = A[r].length + i), o < 0 && (o = A[r][i].length - o), $l.point(
        A[r][i][o],
        s,
        e
      );
  }
  throw new Error("geojson is invalid");
}
Do.coordAll = XSn;
Do.coordEach = bM;
Do.coordReduce = JSn;
Do.featureEach = $Ye;
Do.featureReduce = WSn;
Do.findPoint = iQn;
Do.findSegment = rQn;
Do.flattenEach = D$;
Do.flattenReduce = eQn;
Do.geomEach = $ce;
Do.geomReduce = ZSn;
Do.lineEach = jYe;
Do.lineReduce = nQn;
Do.propEach = HYe;
Do.propReduce = KSn;
Do.segmentEach = qYe;
Do.segmentReduce = tQn;
var QE = {};
const T$ = /* @__PURE__ */ Fs(y4t);
Object.defineProperty(QE, "__esModule", { value: !0 });
var oQn = T$;
function Bte(t) {
  var e = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
  return oQn.coordEach(t, function(n) {
    e[0] > n[0] && (e[0] = n[0]), e[1] > n[1] && (e[1] = n[1]), e[2] < n[0] && (e[2] = n[0]), e[3] < n[1] && (e[3] = n[1]);
  }), e;
}
Bte.default = Bte;
QE.default = Bte;
var Kd = A5e, YYe = ar, zYe = Do, hb = QE.default, sQn = zYe.featureEach;
zYe.coordEach;
YYe.polygon;
var pwe = YYe.featureCollection;
function VYe(t) {
  var e = new Kd(t);
  return e.insert = function(n) {
    if (n.type !== "Feature")
      throw new Error("invalid feature");
    return n.bbox = n.bbox ? n.bbox : hb(n), Kd.prototype.insert.call(this, n);
  }, e.load = function(n) {
    var r = [];
    return Array.isArray(n) ? n.forEach(function(i) {
      if (i.type !== "Feature")
        throw new Error("invalid features");
      i.bbox = i.bbox ? i.bbox : hb(i), r.push(i);
    }) : sQn(n, function(i) {
      if (i.type !== "Feature")
        throw new Error("invalid features");
      i.bbox = i.bbox ? i.bbox : hb(i), r.push(i);
    }), Kd.prototype.load.call(this, r);
  }, e.remove = function(n, r) {
    if (n.type !== "Feature")
      throw new Error("invalid feature");
    return n.bbox = n.bbox ? n.bbox : hb(n), Kd.prototype.remove.call(this, n, r);
  }, e.clear = function() {
    return Kd.prototype.clear.call(this);
  }, e.search = function(n) {
    var r = Kd.prototype.search.call(this, this.toBBox(n));
    return pwe(r);
  }, e.collides = function(n) {
    return Kd.prototype.collides.call(this, this.toBBox(n));
  }, e.all = function() {
    var n = Kd.prototype.all.call(this);
    return pwe(n);
  }, e.toJSON = function() {
    return Kd.prototype.toJSON.call(this);
  }, e.fromJSON = function(n) {
    return Kd.prototype.fromJSON.call(this, n);
  }, e.toBBox = function(n) {
    var r;
    if (n.bbox)
      r = n.bbox;
    else if (Array.isArray(n) && n.length === 4)
      r = n;
    else if (Array.isArray(n) && n.length === 6)
      r = [n[0], n[1], n[3], n[4]];
    else if (n.type === "Feature")
      r = hb(n);
    else if (n.type === "FeatureCollection")
      r = hb(n);
    else
      throw new Error("invalid geojson");
    return {
      minX: r[0],
      minY: r[1],
      maxX: r[2],
      maxY: r[3]
    };
  }, e;
}
Hce.exports = VYe;
Hce.exports.default = VYe;
var JYe = Hce.exports;
const KYe = /* @__PURE__ */ ko(JYe);
function HU(t) {
  if (!t)
    throw new Error("geojson is required");
  var e = [];
  return dw(t, function(n) {
    aQn(n, e);
  }), xI(e);
}
function aQn(t, e) {
  var n = [], r = t.geometry;
  if (r !== null) {
    switch (r.type) {
      case "Polygon":
        n = Ug(r);
        break;
      case "LineString":
        n = [Ug(r)];
    }
    n.forEach(function(i) {
      var o = AQn(i, t.properties);
      o.forEach(function(s) {
        s.id = e.length, e.push(s);
      });
    });
  }
}
function AQn(t, e) {
  var n = [];
  return t.reduce(function(r, i) {
    var o = bg([r, i], e);
    return o.bbox = lQn(r, i), n.push(o), i;
  }), n;
}
function lQn(t, e) {
  var n = t[0], r = t[1], i = e[0], o = e[1], s = n < i ? n : i, a = r < o ? r : o, A = n > i ? n : i, l = r > o ? r : o;
  return [s, a, A, l];
}
const cQn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: HU
}, Symbol.toStringTag, { value: "Module" }));
var Eo = {};
Object.defineProperty(Eo, "__esModule", { value: !0 });
var Iwe = BM;
function uQn(t) {
  if (!t)
    throw new Error("coord is required");
  if (!Array.isArray(t)) {
    if (t.type === "Feature" && t.geometry !== null && t.geometry.type === "Point")
      return t.geometry.coordinates;
    if (t.type === "Point")
      return t.coordinates;
  }
  if (Array.isArray(t) && t.length >= 2 && !Array.isArray(t[0]) && !Array.isArray(t[1]))
    return t;
  throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
var WT = Eo.getCoord = uQn;
function fQn(t) {
  if (Array.isArray(t))
    return t;
  if (t.type === "Feature") {
    if (t.geometry !== null)
      return t.geometry.coordinates;
  } else if (t.coordinates)
    return t.coordinates;
  throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
Eo.getCoords = fQn;
function WYe(t) {
  if (t.length > 1 && Iwe.isNumber(t[0]) && Iwe.isNumber(t[1]))
    return !0;
  if (Array.isArray(t[0]) && t[0].length)
    return WYe(t[0]);
  throw new Error("coordinates must only contain numbers");
}
Eo.containsNumber = WYe;
function gQn(t, e, n) {
  if (!e || !n)
    throw new Error("type and name required");
  if (!t || t.type !== e)
    throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + t.type);
}
Eo.geojsonType = gQn;
function hQn(t, e, n) {
  if (!t)
    throw new Error("No feature passed");
  if (!n)
    throw new Error(".featureOf() requires a name");
  if (!t || t.type !== "Feature" || !t.geometry)
    throw new Error("Invalid input to " + n + ", Feature with geometry required");
  if (!t.geometry || t.geometry.type !== e)
    throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + t.geometry.type);
}
Eo.featureOf = hQn;
function dQn(t, e, n) {
  if (!t)
    throw new Error("No featureCollection passed");
  if (!n)
    throw new Error(".collectionOf() requires a name");
  if (!t || t.type !== "FeatureCollection")
    throw new Error("Invalid input to " + n + ", FeatureCollection required");
  for (var r = 0, i = t.features; r < i.length; r++) {
    var o = i[r];
    if (!o || o.type !== "Feature" || !o.geometry)
      throw new Error("Invalid input to " + n + ", Feature with geometry required");
    if (!o.geometry || o.geometry.type !== e)
      throw new Error("Invalid input to " + n + ": must be a " + e + ", given " + o.geometry.type);
  }
}
Eo.collectionOf = dQn;
function pQn(t) {
  return t.type === "Feature" ? t.geometry : t;
}
Eo.getGeom = pQn;
function IQn(t, e) {
  return t.type === "FeatureCollection" ? "FeatureCollection" : t.type === "GeometryCollection" ? "GeometryCollection" : t.type === "Feature" && t.geometry !== null ? t.geometry.type : t.type;
}
Eo.getType = IQn;
function qce(t, e, n) {
  if (n === void 0 && (n = {}), n.final === !0)
    return mQn(t, e);
  var r = WT(t), i = WT(e), o = ar.degreesToRadians(r[0]), s = ar.degreesToRadians(i[0]), a = ar.degreesToRadians(r[1]), A = ar.degreesToRadians(i[1]), l = Math.sin(s - o) * Math.cos(A), c = Math.cos(a) * Math.sin(A) - Math.sin(a) * Math.cos(A) * Math.cos(s - o);
  return ar.radiansToDegrees(Math.atan2(l, c));
}
function mQn(t, e) {
  var n = qce(e, t);
  return n = (n + 180) % 360, n;
}
const CQn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qce
}, Symbol.toStringTag, { value: "Module" }));
function Kb(t, e, n) {
  n === void 0 && (n = {});
  var r = WT(t), i = WT(e), o = ar.degreesToRadians(i[1] - r[1]), s = ar.degreesToRadians(i[0] - r[0]), a = ar.degreesToRadians(r[1]), A = ar.degreesToRadians(i[1]), l = Math.pow(Math.sin(o / 2), 2) + Math.pow(Math.sin(s / 2), 2) * Math.cos(a) * Math.cos(A);
  return ar.radiansToLength(2 * Math.atan2(Math.sqrt(l), Math.sqrt(1 - l)), n.units);
}
const EQn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Kb
}, Symbol.toStringTag, { value: "Module" }));
function bte(t, e, n, r) {
  r === void 0 && (r = {});
  var i = WT(t), o = ar.degreesToRadians(i[0]), s = ar.degreesToRadians(i[1]), a = ar.degreesToRadians(n), A = ar.lengthToRadians(e, r.units), l = Math.asin(Math.sin(s) * Math.cos(A) + Math.cos(s) * Math.sin(A) * Math.cos(a)), c = o + Math.atan2(Math.sin(a) * Math.sin(A) * Math.cos(s), Math.cos(A) - Math.sin(s) * Math.sin(l)), u = ar.radiansToDegrees(c), f = ar.radiansToDegrees(l);
  return ar.point([u, f], r.properties);
}
const yQn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bte
}, Symbol.toStringTag, { value: "Module" }));
function jce(t, e) {
  var n = {}, r = [];
  if (t.type === "LineString" && (t = Gg(t)), e.type === "LineString" && (e = Gg(e)), t.type === "Feature" && e.type === "Feature" && t.geometry !== null && e.geometry !== null && t.geometry.type === "LineString" && e.geometry.type === "LineString" && t.geometry.coordinates.length === 2 && e.geometry.coordinates.length === 2) {
    var i = mwe(t, e);
    return i && r.push(i), xI(r);
  }
  var o = KYe();
  return o.load(HU(e)), QT(HU(t), function(s) {
    QT(o.search(s), function(a) {
      var A = mwe(s, a);
      if (A) {
        var l = Ug(A).join(",");
        n[l] || (n[l] = !0, r.push(A));
      }
    });
  }), xI(r);
}
function mwe(t, e) {
  var n = Ug(t), r = Ug(e);
  if (n.length !== 2)
    throw new Error("<intersects> line1 must only contain 2 coordinates");
  if (r.length !== 2)
    throw new Error("<intersects> line2 must only contain 2 coordinates");
  var i = n[0][0], o = n[0][1], s = n[1][0], a = n[1][1], A = r[0][0], l = r[0][1], c = r[1][0], u = r[1][1], f = (u - l) * (s - i) - (c - A) * (a - o), h = (c - A) * (o - l) - (u - l) * (i - A), d = (s - i) * (o - l) - (a - o) * (i - A);
  if (f === 0)
    return null;
  var I = h / f, m = d / f;
  if (I >= 0 && I <= 1 && m >= 0 && m <= 1) {
    var C = i + I * (s - i), y = o + I * (a - o);
    return jl([C, y]);
  }
  return null;
}
const vQn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jce
}, Symbol.toStringTag, { value: "Module" }));
function BP(t, e, n) {
  n === void 0 && (n = {});
  var r = jl([1 / 0, 1 / 0], {
    dist: 1 / 0
  }), i = 0;
  return dw(t, function(o) {
    for (var s = Ug(o), a = 0; a < s.length - 1; a++) {
      var A = jl(s[a]);
      A.properties.dist = Kb(e, A, n);
      var l = jl(s[a + 1]);
      l.properties.dist = Kb(e, l, n);
      var c = Kb(A, l, n), u = Math.max(A.properties.dist, l.properties.dist), f = qce(A, l), h = bte(e, u, f + 90, n), d = bte(e, u, f - 90, n), I = jce(bg([
        h.geometry.coordinates,
        d.geometry.coordinates
      ]), bg([A.geometry.coordinates, l.geometry.coordinates])), m = null;
      I.features.length > 0 && (m = I.features[0], m.properties.dist = Kb(e, m, n), m.properties.location = i + Kb(A, m, n)), A.properties.dist < r.properties.dist && (r = A, r.properties.index = a, r.properties.location = i), l.properties.dist < r.properties.dist && (r = l, r.properties.index = a + 1, r.properties.location = i + c), m && m.properties.dist < r.properties.dist && (r = m, r.properties.index = a), i += c;
    }
  }), r;
}
var Cwe = Object.prototype.toString, XYe = function(e) {
  var n = Cwe.call(e), r = n === "[object Arguments]";
  return r || (r = n !== "[object Array]" && e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && Cwe.call(e.callee) === "[object Function]"), r;
}, AJ, Ewe;
function BQn() {
  if (Ewe)
    return AJ;
  Ewe = 1;
  var t;
  if (!Object.keys) {
    var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = XYe, i = Object.prototype.propertyIsEnumerable, o = !i.call({ toString: null }, "toString"), s = i.call(function() {
    }, "prototype"), a = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], A = function(f) {
      var h = f.constructor;
      return h && h.prototype === f;
    }, l = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, c = function() {
      if (typeof window > "u")
        return !1;
      for (var f in window)
        try {
          if (!l["$" + f] && e.call(window, f) && window[f] !== null && typeof window[f] == "object")
            try {
              A(window[f]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), u = function(f) {
      if (typeof window > "u" || !c)
        return A(f);
      try {
        return A(f);
      } catch {
        return !1;
      }
    };
    t = function(h) {
      var d = h !== null && typeof h == "object", I = n.call(h) === "[object Function]", m = r(h), C = d && n.call(h) === "[object String]", y = [];
      if (!d && !I && !m)
        throw new TypeError("Object.keys called on a non-object");
      var v = s && I;
      if (C && h.length > 0 && !e.call(h, 0))
        for (var b = 0; b < h.length; ++b)
          y.push(String(b));
      if (m && h.length > 0)
        for (var Q = 0; Q < h.length; ++Q)
          y.push(String(Q));
      else
        for (var w in h)
          !(v && w === "prototype") && e.call(h, w) && y.push(String(w));
      if (o)
        for (var R = u(h), M = 0; M < a.length; ++M)
          !(R && a[M] === "constructor") && e.call(h, a[M]) && y.push(a[M]);
      return y;
    };
  }
  return AJ = t, AJ;
}
var bQn = Array.prototype.slice, _Qn = XYe, ywe = Object.keys, $k = ywe ? function(e) {
  return ywe(e);
} : BQn(), vwe = Object.keys;
$k.shim = function() {
  if (Object.keys) {
    var e = function() {
      var n = Object.keys(arguments);
      return n && n.length === arguments.length;
    }(1, 2);
    e || (Object.keys = function(r) {
      return _Qn(r) ? vwe(bQn.call(r)) : vwe(r);
    });
  } else
    Object.keys = $k;
  return Object.keys || $k;
};
var ZYe = $k, eze = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, n = Symbol("test"), r = Object(n);
  if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
    return !1;
  var i = 42;
  e[n] = i;
  for (n in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var o = Object.getOwnPropertySymbols(e);
  if (o.length !== 1 || o[0] !== n || !Object.prototype.propertyIsEnumerable.call(e, n))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var s = Object.getOwnPropertyDescriptor(e, n);
    if (s.value !== i || s.enumerable !== !0)
      return !1;
  }
  return !0;
}, SQn = eze, Yce = function() {
  return SQn() && !!Symbol.toStringTag;
}, Bwe = typeof Symbol < "u" && Symbol, QQn = eze, wQn = function() {
  return typeof Bwe != "function" || typeof Symbol != "function" || typeof Bwe("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : QQn();
}, bwe = {
  foo: {}
}, xQn = Object, RQn = function() {
  return { __proto__: bwe }.foo === bwe.foo && !({ __proto__: null } instanceof xQn);
}, DQn = "Function.prototype.bind called on incompatible ", lJ = Array.prototype.slice, TQn = Object.prototype.toString, NQn = "[object Function]", LQn = function(e) {
  var n = this;
  if (typeof n != "function" || TQn.call(n) !== NQn)
    throw new TypeError(DQn + n);
  for (var r = lJ.call(arguments, 1), i, o = function() {
    if (this instanceof i) {
      var c = n.apply(
        this,
        r.concat(lJ.call(arguments))
      );
      return Object(c) === c ? c : this;
    } else
      return n.apply(
        e,
        r.concat(lJ.call(arguments))
      );
  }, s = Math.max(0, n.length - r.length), a = [], A = 0; A < s; A++)
    a.push("$" + A);
  if (i = Function("binder", "return function (" + a.join(",") + "){ return binder.apply(this,arguments); }")(o), n.prototype) {
    var l = function() {
    };
    l.prototype = n.prototype, i.prototype = new l(), l.prototype = null;
  }
  return i;
}, MQn = LQn, zce = Function.prototype.bind || MQn, OQn = zce, FQn = OQn.call(Function.call, Object.prototype.hasOwnProperty), Ii, VS = SyntaxError, tze = Function, V_ = TypeError, cJ = function(t) {
  try {
    return tze('"use strict"; return (' + t + ").constructor;")();
  } catch {
  }
}, wv = Object.getOwnPropertyDescriptor;
if (wv)
  try {
    wv({}, "");
  } catch {
    wv = null;
  }
var uJ = function() {
  throw new V_();
}, PQn = wv ? function() {
  try {
    return arguments.callee, uJ;
  } catch {
    try {
      return wv(arguments, "callee").get;
    } catch {
      return uJ;
    }
  }
}() : uJ, db = wQn(), kQn = RQn(), wA = Object.getPrototypeOf || (kQn ? function(t) {
  return t.__proto__;
} : null), Wb = {}, GQn = typeof Uint8Array > "u" || !wA ? Ii : wA(Uint8Array), xv = {
  "%AggregateError%": typeof AggregateError > "u" ? Ii : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? Ii : ArrayBuffer,
  "%ArrayIteratorPrototype%": db && wA ? wA([][Symbol.iterator]()) : Ii,
  "%AsyncFromSyncIteratorPrototype%": Ii,
  "%AsyncFunction%": Wb,
  "%AsyncGenerator%": Wb,
  "%AsyncGeneratorFunction%": Wb,
  "%AsyncIteratorPrototype%": Wb,
  "%Atomics%": typeof Atomics > "u" ? Ii : Atomics,
  "%BigInt%": typeof BigInt > "u" ? Ii : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? Ii : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? Ii : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? Ii : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? Ii : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? Ii : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? Ii : FinalizationRegistry,
  "%Function%": tze,
  "%GeneratorFunction%": Wb,
  "%Int8Array%": typeof Int8Array > "u" ? Ii : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? Ii : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? Ii : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": db && wA ? wA(wA([][Symbol.iterator]())) : Ii,
  "%JSON%": typeof JSON == "object" ? JSON : Ii,
  "%Map%": typeof Map > "u" ? Ii : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !db || !wA ? Ii : wA((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? Ii : Promise,
  "%Proxy%": typeof Proxy > "u" ? Ii : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? Ii : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? Ii : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !db || !wA ? Ii : wA((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? Ii : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": db && wA ? wA(""[Symbol.iterator]()) : Ii,
  "%Symbol%": db ? Symbol : Ii,
  "%SyntaxError%": VS,
  "%ThrowTypeError%": PQn,
  "%TypedArray%": GQn,
  "%TypeError%": V_,
  "%Uint8Array%": typeof Uint8Array > "u" ? Ii : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? Ii : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? Ii : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? Ii : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap > "u" ? Ii : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? Ii : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? Ii : WeakSet
};
if (wA)
  try {
    null.error;
  } catch (t) {
    var UQn = wA(wA(t));
    xv["%Error.prototype%"] = UQn;
  }
var HQn = function t(e) {
  var n;
  if (e === "%AsyncFunction%")
    n = cJ("async function () {}");
  else if (e === "%GeneratorFunction%")
    n = cJ("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    n = cJ("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var r = t("%AsyncGeneratorFunction%");
    r && (n = r.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var i = t("%AsyncGenerator%");
    i && wA && (n = wA(i.prototype));
  }
  return xv[e] = n, n;
}, _we = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, _M = zce, $U = FQn, $Qn = _M.call(Function.call, Array.prototype.concat), qQn = _M.call(Function.apply, Array.prototype.splice), Swe = _M.call(Function.call, String.prototype.replace), qU = _M.call(Function.call, String.prototype.slice), jQn = _M.call(Function.call, RegExp.prototype.exec), YQn = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, zQn = /\\(\\)?/g, VQn = function(e) {
  var n = qU(e, 0, 1), r = qU(e, -1);
  if (n === "%" && r !== "%")
    throw new VS("invalid intrinsic syntax, expected closing `%`");
  if (r === "%" && n !== "%")
    throw new VS("invalid intrinsic syntax, expected opening `%`");
  var i = [];
  return Swe(e, YQn, function(o, s, a, A) {
    i[i.length] = a ? Swe(A, zQn, "$1") : s || o;
  }), i;
}, JQn = function(e, n) {
  var r = e, i;
  if ($U(_we, r) && (i = _we[r], r = "%" + i[0] + "%"), $U(xv, r)) {
    var o = xv[r];
    if (o === Wb && (o = HQn(r)), typeof o > "u" && !n)
      throw new V_("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: i,
      name: r,
      value: o
    };
  }
  throw new VS("intrinsic " + e + " does not exist!");
}, Vce = function(e, n) {
  if (typeof e != "string" || e.length === 0)
    throw new V_("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof n != "boolean")
    throw new V_('"allowMissing" argument must be a boolean');
  if (jQn(/^%?[^%]*%?$/, e) === null)
    throw new VS("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var r = VQn(e), i = r.length > 0 ? r[0] : "", o = JQn("%" + i + "%", n), s = o.name, a = o.value, A = !1, l = o.alias;
  l && (i = l[0], qQn(r, $Qn([0, 1], l)));
  for (var c = 1, u = !0; c < r.length; c += 1) {
    var f = r[c], h = qU(f, 0, 1), d = qU(f, -1);
    if ((h === '"' || h === "'" || h === "`" || d === '"' || d === "'" || d === "`") && h !== d)
      throw new VS("property names with quotes must have matching quotes");
    if ((f === "constructor" || !u) && (A = !0), i += "." + f, s = "%" + i + "%", $U(xv, s))
      a = xv[s];
    else if (a != null) {
      if (!(f in a)) {
        if (!n)
          throw new V_("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (wv && c + 1 >= r.length) {
        var I = wv(a, f);
        u = !!I, u && "get" in I && !("originalValue" in I.get) ? a = I.get : a = a[f];
      } else
        u = $U(a, f), a = a[f];
      u && !A && (xv[s] = a);
    }
  }
  return a;
}, nze = { exports: {} };
(function(t) {
  var e = zce, n = Vce, r = n("%Function.prototype.apply%"), i = n("%Function.prototype.call%"), o = n("%Reflect.apply%", !0) || e.call(i, r), s = n("%Object.getOwnPropertyDescriptor%", !0), a = n("%Object.defineProperty%", !0), A = n("%Math.max%");
  if (a)
    try {
      a({}, "a", { value: 1 });
    } catch {
      a = null;
    }
  t.exports = function(u) {
    var f = o(e, i, arguments);
    if (s && a) {
      var h = s(f, "length");
      h.configurable && a(
        f,
        "length",
        { value: 1 + A(0, u.length - (arguments.length - 1)) }
      );
    }
    return f;
  };
  var l = function() {
    return o(e, r, arguments);
  };
  a ? a(t.exports, "apply", { value: l }) : t.exports.apply = l;
})(nze);
var Jce = nze.exports, rze = Vce, ize = Jce, KQn = ize(rze("String.prototype.indexOf")), oze = function(e, n) {
  var r = rze(e, !!n);
  return typeof r == "function" && KQn(e, ".prototype.") > -1 ? ize(r) : r;
}, WQn = Yce(), XQn = oze, _te = XQn("Object.prototype.toString"), N$ = function(e) {
  return WQn && e && typeof e == "object" && Symbol.toStringTag in e ? !1 : _te(e) === "[object Arguments]";
}, sze = function(e) {
  return N$(e) ? !0 : e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && _te(e) !== "[object Array]" && _te(e.callee) === "[object Function]";
}, ZQn = function() {
  return N$(arguments);
}();
N$.isLegacyArguments = sze;
var ewn = ZQn ? N$ : sze, twn = Vce, Ste = twn("%Object.defineProperty%", !0), Qte = function() {
  if (Ste)
    try {
      return Ste({}, "a", { value: 1 }), !0;
    } catch {
      return !1;
    }
  return !1;
};
Qte.hasArrayLengthDefineBug = function() {
  if (!Qte())
    return null;
  try {
    return Ste([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var nwn = Qte, rwn = ZYe, iwn = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", own = Object.prototype.toString, swn = Array.prototype.concat, aze = Object.defineProperty, awn = function(t) {
  return typeof t == "function" && own.call(t) === "[object Function]";
}, Awn = nwn(), Aze = aze && Awn, lwn = function(t, e, n, r) {
  if (e in t) {
    if (r === !0) {
      if (t[e] === n)
        return;
    } else if (!awn(r) || !r())
      return;
  }
  Aze ? aze(t, e, {
    configurable: !0,
    enumerable: !1,
    value: n,
    writable: !0
  }) : t[e] = n;
}, lze = function(t, e) {
  var n = arguments.length > 2 ? arguments[2] : {}, r = rwn(e);
  iwn && (r = swn.call(r, Object.getOwnPropertySymbols(e)));
  for (var i = 0; i < r.length; i += 1)
    lwn(t, r[i], e[r[i]], n[r[i]]);
};
lze.supportsDescriptors = !!Aze;
var SM = lze, Qwe = function(t) {
  return t !== t;
}, cze = function(e, n) {
  return e === 0 && n === 0 ? 1 / e === 1 / n : !!(e === n || Qwe(e) && Qwe(n));
}, cwn = cze, uze = function() {
  return typeof Object.is == "function" ? Object.is : cwn;
}, uwn = uze, fwn = SM, gwn = function() {
  var e = uwn();
  return fwn(Object, { is: e }, {
    is: function() {
      return Object.is !== e;
    }
  }), e;
}, hwn = SM, dwn = Jce, pwn = cze, fze = uze, Iwn = gwn, gze = dwn(fze(), Object);
hwn(gze, {
  getPolyfill: fze,
  implementation: pwn,
  shim: Iwn
});
var mwn = gze, wte = oze, hze = Yce(), dze, pze, xte, Rte;
if (hze) {
  dze = wte("Object.prototype.hasOwnProperty"), pze = wte("RegExp.prototype.exec"), xte = {};
  var fJ = function() {
    throw xte;
  };
  Rte = {
    toString: fJ,
    valueOf: fJ
  }, typeof Symbol.toPrimitive == "symbol" && (Rte[Symbol.toPrimitive] = fJ);
}
var Cwn = wte("Object.prototype.toString"), Ewn = Object.getOwnPropertyDescriptor, ywn = "[object RegExp]", vwn = hze ? function(e) {
  if (!e || typeof e != "object")
    return !1;
  var n = Ewn(e, "lastIndex"), r = n && dze(n, "value");
  if (!r)
    return !1;
  try {
    pze(e, Rte);
  } catch (i) {
    return i === xte;
  }
} : function(e) {
  return !e || typeof e != "object" && typeof e != "function" ? !1 : Cwn(e) === ywn;
}, Ize = { exports: {} }, XT = function() {
  return typeof function() {
  }.name == "string";
}, SD = Object.getOwnPropertyDescriptor;
if (SD)
  try {
    SD([], "length");
  } catch {
    SD = null;
  }
XT.functionsHaveConfigurableNames = function() {
  if (!XT() || !SD)
    return !1;
  var e = SD(function() {
  }, "name");
  return !!e && !!e.configurable;
};
var Bwn = Function.prototype.bind;
XT.boundFunctionsHaveNames = function() {
  return XT() && typeof Bwn == "function" && function() {
  }.bind().name !== "";
};
var bwn = XT;
(function(t) {
  var e = bwn.functionsHaveConfigurableNames(), n = Object, r = TypeError;
  t.exports = function() {
    if (this != null && this !== n(this))
      throw new r("RegExp.prototype.flags getter called on non-object");
    var o = "";
    return this.hasIndices && (o += "d"), this.global && (o += "g"), this.ignoreCase && (o += "i"), this.multiline && (o += "m"), this.dotAll && (o += "s"), this.unicode && (o += "u"), this.unicodeSets && (o += "v"), this.sticky && (o += "y"), o;
  }, e && Object.defineProperty && Object.defineProperty(t.exports, "name", { value: "get flags" });
})(Ize);
var mze = Ize.exports, _wn = mze, Swn = SM.supportsDescriptors, Qwn = Object.getOwnPropertyDescriptor, Cze = function() {
  if (Swn && /a/mig.flags === "gim") {
    var e = Qwn(RegExp.prototype, "flags");
    if (e && typeof e.get == "function" && typeof RegExp.prototype.dotAll == "boolean" && typeof RegExp.prototype.hasIndices == "boolean") {
      var n = "", r = {};
      if (Object.defineProperty(r, "hasIndices", {
        get: function() {
          n += "d";
        }
      }), Object.defineProperty(r, "sticky", {
        get: function() {
          n += "y";
        }
      }), n === "dy")
        return e.get;
    }
  }
  return _wn;
}, wwn = SM.supportsDescriptors, xwn = Cze, Rwn = Object.getOwnPropertyDescriptor, Dwn = Object.defineProperty, Twn = TypeError, wwe = Object.getPrototypeOf, Nwn = /a/, Lwn = function() {
  if (!wwn || !wwe)
    throw new Twn("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
  var e = xwn(), n = wwe(Nwn), r = Rwn(n, "flags");
  return (!r || r.get !== e) && Dwn(n, "flags", {
    configurable: !0,
    enumerable: !1,
    get: e
  }), e;
}, Mwn = SM, Own = Jce, Fwn = mze, Eze = Cze, Pwn = Lwn, yze = Own(Eze());
Mwn(yze, {
  getPolyfill: Eze,
  implementation: Fwn,
  shim: Pwn
});
var kwn = yze, Gwn = Date.prototype.getDay, Uwn = function(e) {
  try {
    return Gwn.call(e), !0;
  } catch {
    return !1;
  }
}, Hwn = Object.prototype.toString, $wn = "[object Date]", qwn = Yce(), jwn = function(e) {
  return typeof e != "object" || e === null ? !1 : qwn ? Uwn(e) : Hwn.call(e) === $wn;
}, xwe = ZYe, Rwe = ewn, Dwe = mwn, Twe = vwn, Nwe = kwn, Lwe = jwn, Mwe = Date.prototype.getTime;
function vze(t, e, n) {
  var r = n || {};
  return (r.strict ? Dwe(t, e) : t === e) ? !0 : !t || !e || typeof t != "object" && typeof e != "object" ? r.strict ? Dwe(t, e) : t == e : Ywn(t, e, r);
}
function Owe(t) {
  return t == null;
}
function Fwe(t) {
  return !(!t || typeof t != "object" || typeof t.length != "number" || typeof t.copy != "function" || typeof t.slice != "function" || t.length > 0 && typeof t[0] != "number");
}
function Ywn(t, e, n) {
  var r, i;
  if (typeof t != typeof e || Owe(t) || Owe(e) || t.prototype !== e.prototype || Rwe(t) !== Rwe(e))
    return !1;
  var o = Twe(t), s = Twe(e);
  if (o !== s)
    return !1;
  if (o || s)
    return t.source === e.source && Nwe(t) === Nwe(e);
  if (Lwe(t) && Lwe(e))
    return Mwe.call(t) === Mwe.call(e);
  var a = Fwe(t), A = Fwe(e);
  if (a !== A)
    return !1;
  if (a || A) {
    if (t.length !== e.length)
      return !1;
    for (r = 0; r < t.length; r++)
      if (t[r] !== e[r])
        return !1;
    return !0;
  }
  if (typeof t != typeof e)
    return !1;
  try {
    var l = xwe(t), c = xwe(e);
  } catch {
    return !1;
  }
  if (l.length !== c.length)
    return !1;
  for (l.sort(), c.sort(), r = l.length - 1; r >= 0; r--)
    if (l[r] != c[r])
      return !1;
  for (r = l.length - 1; r >= 0; r--)
    if (i = l[r], !vze(t[i], e[i], n))
      return !1;
  return !0;
}
var Bze = vze;
const QR = /* @__PURE__ */ ko(Bze);
function zwn(t, e, n) {
  if (n === void 0 && (n = {}), n = n || {}, !I9(n))
    throw new Error("options is invalid");
  var r = n.tolerance || 0, i = [], o = KYe(), s = HU(t);
  o.load(s);
  var a;
  return sv(e, function(A) {
    var l = !1;
    A && (QT(o.search(A), function(c) {
      if (l === !1) {
        var u = Ug(A).sort(), f = Ug(c).sort();
        QR(u, f) || (r === 0 ? xf(u[0], c) && xf(u[1], c) : BP(c, u[0]).properties.dist <= r && BP(c, u[1]).properties.dist <= r) ? (l = !0, a ? a = gJ(a, A) : a = A) : (r === 0 ? xf(f[0], A) && xf(f[1], A) : BP(A, f[0]).properties.dist <= r && BP(A, f[1]).properties.dist <= r) && (a ? a = gJ(a, c) : a = c);
      }
    }), l === !1 && a && (i.push(a), a = void 0));
  }), a && i.push(a), xI(i);
}
function gJ(t, e) {
  var n = Ug(e), r = Ug(t), i = r[0], o = r[r.length - 1], s = t.geometry.coordinates;
  return QR(n[0], i) ? s.unshift(n[1]) : QR(n[0], o) ? s.push(n[1]) : QR(n[1], i) ? s.unshift(n[0]) : QR(n[1], o) && s.push(n[0]), t;
}
var Vwn = Bze, c0 = function(t) {
  this.precision = t && t.precision ? t.precision : 17, this.direction = t && t.direction ? t.direction : !1, this.pseudoNode = t && t.pseudoNode ? t.pseudoNode : !1, this.objectComparator = t && t.objectComparator ? t.objectComparator : Jwn;
};
c0.prototype.compare = function(t, e) {
  if (t.type !== e.type || !bze(t, e))
    return !1;
  switch (t.type) {
    case "Point":
      return this.compareCoord(t.coordinates, e.coordinates);
    case "LineString":
      return this.compareLine(t.coordinates, e.coordinates, 0, !1);
    case "Polygon":
      return this.comparePolygon(t, e);
    case "Feature":
      return this.compareFeature(t, e);
    default:
      if (t.type.indexOf("Multi") === 0) {
        var n = this, r = Pwe(t), i = Pwe(e);
        return r.every(function(o) {
          return this.some(function(s) {
            return n.compare(o, s);
          });
        }, i);
      }
  }
  return !1;
};
function Pwe(t) {
  return t.coordinates.map(function(e) {
    return {
      type: t.type.replace("Multi", ""),
      coordinates: e
    };
  });
}
function bze(t, e) {
  return t.hasOwnProperty("coordinates") ? t.coordinates.length === e.coordinates.length : t.length === e.length;
}
c0.prototype.compareCoord = function(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var n = 0; n < t.length; n++)
    if (t[n].toFixed(this.precision) !== e[n].toFixed(this.precision))
      return !1;
  return !0;
};
c0.prototype.compareLine = function(t, e, n, r) {
  if (!bze(t, e))
    return !1;
  var i = this.pseudoNode ? t : this.removePseudo(t), o = this.pseudoNode ? e : this.removePseudo(e);
  if (!(r && !this.compareCoord(i[0], o[0]) && (o = this.fixStartIndex(o, i), !o))) {
    var s = this.compareCoord(i[n], o[n]);
    return this.direction || s ? this.comparePath(i, o) : this.compareCoord(i[n], o[o.length - (1 + n)]) ? this.comparePath(i.slice().reverse(), o) : !1;
  }
};
c0.prototype.fixStartIndex = function(t, e) {
  for (var n, r = -1, i = 0; i < t.length; i++)
    if (this.compareCoord(t[i], e[0])) {
      r = i;
      break;
    }
  return r >= 0 && (n = [].concat(
    t.slice(r, t.length),
    t.slice(1, r + 1)
  )), n;
};
c0.prototype.comparePath = function(t, e) {
  var n = this;
  return t.every(function(r, i) {
    return n.compareCoord(r, this[i]);
  }, e);
};
c0.prototype.comparePolygon = function(t, e) {
  if (this.compareLine(t.coordinates[0], e.coordinates[0], 1, !0)) {
    var n = t.coordinates.slice(1, t.coordinates.length), r = e.coordinates.slice(1, e.coordinates.length), i = this;
    return n.every(function(o) {
      return this.some(function(s) {
        return i.compareLine(o, s, 1, !0);
      });
    }, r);
  } else
    return !1;
};
c0.prototype.compareFeature = function(t, e) {
  return t.id !== e.id || !this.objectComparator(t.properties, e.properties) || !this.compareBBox(t, e) ? !1 : this.compare(t.geometry, e.geometry);
};
c0.prototype.compareBBox = function(t, e) {
  return !!(!t.bbox && !e.bbox || t.bbox && e.bbox && this.compareCoord(t.bbox, e.bbox));
};
c0.prototype.removePseudo = function(t) {
  return t;
};
function Jwn(t, e) {
  return Vwn(t, e, { strict: !0 });
}
var Kwn = c0;
const Wwn = /* @__PURE__ */ ko(Kwn);
function Xwn(t, e) {
  var n = OI(t), r = OI(e), i = n.type, o = r.type;
  if (i === "MultiPoint" && o !== "MultiPoint" || (i === "LineString" || i === "MultiLineString") && o !== "LineString" && o !== "MultiLineString" || (i === "Polygon" || i === "MultiPolygon") && o !== "Polygon" && o !== "MultiPolygon")
    throw new Error("features must be of the same type");
  if (i === "Point")
    throw new Error("Point geometry not supported");
  var s = new Wwn({ precision: 6 });
  if (s.compare(t, e))
    return !1;
  var a = 0;
  switch (i) {
    case "MultiPoint":
      for (var A = 0; A < n.coordinates.length; A++)
        for (var l = 0; l < r.coordinates.length; l++) {
          var c = n.coordinates[A], u = r.coordinates[l];
          if (c[0] === u[0] && c[1] === u[1])
            return !0;
        }
      return !1;
    case "LineString":
    case "MultiLineString":
      sv(t, function(f) {
        sv(e, function(h) {
          zwn(f, h).features.length && a++;
        });
      });
      break;
    case "Polygon":
    case "MultiPolygon":
      sv(t, function(f) {
        sv(e, function(h) {
          jce(f, h).features.length && a++;
        });
      });
      break;
  }
  return a > 0;
}
var jU = {}, zh = {};
Object.defineProperty(zh, "__esModule", {
  value: !0
});
zh.DEFAULT_STYLE = zh.MAX_ARROWS = zh.DEFAULT_ARROWS = zh.ArrowStyles = void 0;
var _ze = {
  NONE: 0,
  FORWARD: 1,
  BACKWARD: 2,
  BOTH: 3
};
zh.ArrowStyles = _ze;
var Sze = 1;
zh.DEFAULT_ARROWS = Sze;
var Zwn = 3;
zh.MAX_ARROWS = Zwn;
var exn = {
  arrowColor: [0, 0, 0, 1],
  arrowCount: Sze,
  arrowStyle: _ze.NONE,
  fillColor: [0, 0, 0, 1],
  lineColor: [0, 0, 0, 1],
  lineWidthMeters: 5,
  outlineRadiusMeters: 0,
  opacity: 1,
  zLevel: 0
};
zh.DEFAULT_STYLE = exn;
var Kce = {};
const wE = /* @__PURE__ */ Fs(pmn);
var xE = {};
Object.defineProperty(xE, "__esModule", { value: !0 });
var txn = ar;
function nxn(t, e) {
  e === void 0 && (e = {});
  var n = Number(t[0]), r = Number(t[1]), i = Number(t[2]), o = Number(t[3]);
  if (t.length === 6)
    throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
  var s = [n, r], a = [n, o], A = [i, o], l = [i, r];
  return txn.polygon([[s, l, A, a, s]], e.properties, { bbox: t, id: e.id });
}
xE.default = nxn;
var Wce = { exports: {} }, Uw = {}, rxn = ei && ei.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Uw, "__esModule", { value: !0 });
var ixn = rxn(QE), oxn = ar;
function sxn(t, e) {
  e === void 0 && (e = {});
  var n = ixn.default(t), r = (n[0] + n[2]) / 2, i = (n[1] + n[3]) / 2;
  return oxn.point([r, i], e.properties, e);
}
Uw.default = sxn;
var Dte = { exports: {} };
(function(t, e) {
  (function(n, r) {
    r(e);
  })(ei, function(n) {
    function r() {
    }
    function i(g) {
      this.message = g || "";
    }
    function o(g) {
      this.message = g || "";
    }
    function s(g) {
      this.message = g || "";
    }
    function a() {
    }
    function A(g) {
      return g === null ? vn : g.color;
    }
    function l(g) {
      return g === null ? null : g.parent;
    }
    function c(g, p) {
      g !== null && (g.color = p);
    }
    function u(g) {
      return g === null ? null : g.left;
    }
    function f(g) {
      return g === null ? null : g.right;
    }
    function h() {
      this.root_ = null, this.size_ = 0;
    }
    function d() {
    }
    function I() {
      this.array_ = [], arguments[0] instanceof It && this.addAll(arguments[0]);
    }
    function m() {
    }
    function C(g) {
      this.message = g || "";
    }
    function y() {
      this.array_ = [];
    }
    "fill" in Array.prototype || Object.defineProperty(Array.prototype, "fill", { configurable: !0, value: function(g) {
      if (this === void 0 || this === null)
        throw new TypeError(this + " is not an object");
      var p = Object(this), E = Math.max(Math.min(p.length, 9007199254740991), 0) || 0, B = 1 in arguments && parseInt(Number(arguments[1]), 10) || 0;
      B = B < 0 ? Math.max(E + B, 0) : Math.min(B, E);
      var D = 2 in arguments && arguments[2] !== void 0 ? parseInt(Number(arguments[2]), 10) || 0 : E;
      for (D = D < 0 ? Math.max(E + arguments[2], 0) : Math.min(D, E); B < D; )
        p[B] = g, ++B;
      return p;
    }, writable: !0 }), Number.isFinite = Number.isFinite || function(g) {
      return typeof g == "number" && isFinite(g);
    }, Number.isInteger = Number.isInteger || function(g) {
      return typeof g == "number" && isFinite(g) && Math.floor(g) === g;
    }, Number.parseFloat = Number.parseFloat || parseFloat, Number.isNaN = Number.isNaN || function(g) {
      return g != g;
    }, Math.trunc = Math.trunc || function(g) {
      return g < 0 ? Math.ceil(g) : Math.floor(g);
    };
    var v = function() {
    };
    v.prototype.interfaces_ = function() {
      return [];
    }, v.prototype.getClass = function() {
      return v;
    }, v.prototype.equalsWithTolerance = function(g, p, E) {
      return Math.abs(g - p) <= E;
    };
    var b = function(g) {
      function p(E) {
        g.call(this, E), this.name = "IllegalArgumentException", this.message = E, this.stack = new g().stack;
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p;
    }(Error), Q = function() {
    }, w = { MAX_VALUE: { configurable: !0 } };
    Q.isNaN = function(g) {
      return Number.isNaN(g);
    }, Q.doubleToLongBits = function(g) {
      return g;
    }, Q.longBitsToDouble = function(g) {
      return g;
    }, Q.isInfinite = function(g) {
      return !Number.isFinite(g);
    }, w.MAX_VALUE.get = function() {
      return Number.MAX_VALUE;
    }, Object.defineProperties(Q, w);
    var R = function() {
    }, M = function() {
    }, O = function() {
    }, L = function g() {
      if (this.x = null, this.y = null, this.z = null, arguments.length === 0)
        this.x = 0, this.y = 0, this.z = g.NULL_ORDINATE;
      else if (arguments.length === 1) {
        var p = arguments[0];
        this.x = p.x, this.y = p.y, this.z = p.z;
      } else
        arguments.length === 2 ? (this.x = arguments[0], this.y = arguments[1], this.z = g.NULL_ORDINATE) : arguments.length === 3 && (this.x = arguments[0], this.y = arguments[1], this.z = arguments[2]);
    }, N = { DimensionalComparator: { configurable: !0 }, serialVersionUID: { configurable: !0 }, NULL_ORDINATE: { configurable: !0 }, X: { configurable: !0 }, Y: { configurable: !0 }, Z: { configurable: !0 } };
    L.prototype.setOrdinate = function(g, p) {
      switch (g) {
        case L.X:
          this.x = p;
          break;
        case L.Y:
          this.y = p;
          break;
        case L.Z:
          this.z = p;
          break;
        default:
          throw new b("Invalid ordinate index: " + g);
      }
    }, L.prototype.equals2D = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return this.x === g.x && this.y === g.y;
      }
      if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        return !!v.equalsWithTolerance(this.x, p.x, E) && !!v.equalsWithTolerance(this.y, p.y, E);
      }
    }, L.prototype.getOrdinate = function(g) {
      switch (g) {
        case L.X:
          return this.x;
        case L.Y:
          return this.y;
        case L.Z:
          return this.z;
      }
      throw new b("Invalid ordinate index: " + g);
    }, L.prototype.equals3D = function(g) {
      return this.x === g.x && this.y === g.y && (this.z === g.z || Q.isNaN(this.z)) && Q.isNaN(g.z);
    }, L.prototype.equals = function(g) {
      return g instanceof L && this.equals2D(g);
    }, L.prototype.equalInZ = function(g, p) {
      return v.equalsWithTolerance(this.z, g.z, p);
    }, L.prototype.compareTo = function(g) {
      var p = g;
      return this.x < p.x ? -1 : this.x > p.x ? 1 : this.y < p.y ? -1 : this.y > p.y ? 1 : 0;
    }, L.prototype.clone = function() {
    }, L.prototype.copy = function() {
      return new L(this);
    }, L.prototype.toString = function() {
      return "(" + this.x + ", " + this.y + ", " + this.z + ")";
    }, L.prototype.distance3D = function(g) {
      var p = this.x - g.x, E = this.y - g.y, B = this.z - g.z;
      return Math.sqrt(p * p + E * E + B * B);
    }, L.prototype.distance = function(g) {
      var p = this.x - g.x, E = this.y - g.y;
      return Math.sqrt(p * p + E * E);
    }, L.prototype.hashCode = function() {
      var g = 17;
      return g = 37 * g + L.hashCode(this.x), g = 37 * g + L.hashCode(this.y);
    }, L.prototype.setCoordinate = function(g) {
      this.x = g.x, this.y = g.y, this.z = g.z;
    }, L.prototype.interfaces_ = function() {
      return [R, M, r];
    }, L.prototype.getClass = function() {
      return L;
    }, L.hashCode = function() {
      if (arguments.length === 1) {
        var g = arguments[0], p = Q.doubleToLongBits(g);
        return Math.trunc((p ^ p) >>> 32);
      }
    }, N.DimensionalComparator.get = function() {
      return k;
    }, N.serialVersionUID.get = function() {
      return 6683108902428367e3;
    }, N.NULL_ORDINATE.get = function() {
      return Q.NaN;
    }, N.X.get = function() {
      return 0;
    }, N.Y.get = function() {
      return 1;
    }, N.Z.get = function() {
      return 2;
    }, Object.defineProperties(L, N);
    var k = function(g) {
      if (this._dimensionsToTest = 2, arguments.length !== 0) {
        if (arguments.length === 1) {
          var p = arguments[0];
          if (p !== 2 && p !== 3)
            throw new b("only 2 or 3 dimensions may be specified");
          this._dimensionsToTest = p;
        }
      }
    };
    k.prototype.compare = function(g, p) {
      var E = g, B = p, D = k.compare(E.x, B.x);
      if (D !== 0)
        return D;
      var j = k.compare(E.y, B.y);
      return j !== 0 ? j : this._dimensionsToTest <= 2 ? 0 : k.compare(E.z, B.z);
    }, k.prototype.interfaces_ = function() {
      return [O];
    }, k.prototype.getClass = function() {
      return k;
    }, k.compare = function(g, p) {
      return g < p ? -1 : g > p ? 1 : Q.isNaN(g) ? Q.isNaN(p) ? 0 : -1 : Q.isNaN(p) ? 1 : 0;
    };
    var $ = function() {
    };
    $.prototype.create = function() {
    }, $.prototype.interfaces_ = function() {
      return [];
    }, $.prototype.getClass = function() {
      return $;
    };
    var U = function() {
    }, X = { INTERIOR: { configurable: !0 }, BOUNDARY: { configurable: !0 }, EXTERIOR: { configurable: !0 }, NONE: { configurable: !0 } };
    U.prototype.interfaces_ = function() {
      return [];
    }, U.prototype.getClass = function() {
      return U;
    }, U.toLocationSymbol = function(g) {
      switch (g) {
        case U.EXTERIOR:
          return "e";
        case U.BOUNDARY:
          return "b";
        case U.INTERIOR:
          return "i";
        case U.NONE:
          return "-";
      }
      throw new b("Unknown location value: " + g);
    }, X.INTERIOR.get = function() {
      return 0;
    }, X.BOUNDARY.get = function() {
      return 1;
    }, X.EXTERIOR.get = function() {
      return 2;
    }, X.NONE.get = function() {
      return -1;
    }, Object.defineProperties(U, X);
    var K = function(g, p) {
      return g.interfaces_ && g.interfaces_().indexOf(p) > -1;
    }, z = function() {
    }, Y = { LOG_10: { configurable: !0 } };
    z.prototype.interfaces_ = function() {
      return [];
    }, z.prototype.getClass = function() {
      return z;
    }, z.log10 = function(g) {
      var p = Math.log(g);
      return Q.isInfinite(p) || Q.isNaN(p) ? p : p / z.LOG_10;
    }, z.min = function(g, p, E, B) {
      var D = g;
      return p < D && (D = p), E < D && (D = E), B < D && (D = B), D;
    }, z.clamp = function() {
      if (typeof arguments[2] == "number" && typeof arguments[0] == "number" && typeof arguments[1] == "number") {
        var g = arguments[0], p = arguments[1], E = arguments[2];
        return g < p ? p : g > E ? E : g;
      }
      if (Number.isInteger(arguments[2]) && Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
        var B = arguments[0], D = arguments[1], j = arguments[2];
        return B < D ? D : B > j ? j : B;
      }
    }, z.wrap = function(g, p) {
      return g < 0 ? p - -g % p : g % p;
    }, z.max = function() {
      if (arguments.length === 3) {
        var g = arguments[0], p = arguments[1], E = arguments[2], B = g;
        return p > B && (B = p), E > B && (B = E), B;
      }
      if (arguments.length === 4) {
        var D = arguments[0], j = arguments[1], te = arguments[2], he = arguments[3], ve = D;
        return j > ve && (ve = j), te > ve && (ve = te), he > ve && (ve = he), ve;
      }
    }, z.average = function(g, p) {
      return (g + p) / 2;
    }, Y.LOG_10.get = function() {
      return Math.log(10);
    }, Object.defineProperties(z, Y);
    var V = function(g) {
      this.str = g;
    };
    V.prototype.append = function(g) {
      this.str += g;
    }, V.prototype.setCharAt = function(g, p) {
      this.str = this.str.substr(0, g) + p + this.str.substr(g + 1);
    }, V.prototype.toString = function(g) {
      return this.str;
    };
    var Z = function(g) {
      this.value = g;
    };
    Z.prototype.intValue = function() {
      return this.value;
    }, Z.prototype.compareTo = function(g) {
      return this.value < g ? -1 : this.value > g ? 1 : 0;
    }, Z.isNaN = function(g) {
      return Number.isNaN(g);
    };
    var ce = function() {
    };
    ce.isWhitespace = function(g) {
      return g <= 32 && g >= 0 || g === 127;
    }, ce.toUpperCase = function(g) {
      return g.toUpperCase();
    };
    var ee = function g() {
      if (this._hi = 0, this._lo = 0, arguments.length === 0)
        this.init(0);
      else if (arguments.length === 1) {
        if (typeof arguments[0] == "number") {
          var p = arguments[0];
          this.init(p);
        } else if (arguments[0] instanceof g) {
          var E = arguments[0];
          this.init(E);
        } else if (typeof arguments[0] == "string") {
          var B = arguments[0];
          g.call(this, g.parse(B));
        }
      } else if (arguments.length === 2) {
        var D = arguments[0], j = arguments[1];
        this.init(D, j);
      }
    }, pe = { PI: { configurable: !0 }, TWO_PI: { configurable: !0 }, PI_2: { configurable: !0 }, E: { configurable: !0 }, NaN: { configurable: !0 }, EPS: { configurable: !0 }, SPLIT: { configurable: !0 }, MAX_PRINT_DIGITS: { configurable: !0 }, TEN: { configurable: !0 }, ONE: { configurable: !0 }, SCI_NOT_EXPONENT_CHAR: { configurable: !0 }, SCI_NOT_ZERO: { configurable: !0 } };
    ee.prototype.le = function(g) {
      return (this._hi < g._hi || this._hi === g._hi) && this._lo <= g._lo;
    }, ee.prototype.extractSignificantDigits = function(g, p) {
      var E = this.abs(), B = ee.magnitude(E._hi), D = ee.TEN.pow(B);
      (E = E.divide(D)).gt(ee.TEN) ? (E = E.divide(ee.TEN), B += 1) : E.lt(ee.ONE) && (E = E.multiply(ee.TEN), B -= 1);
      for (var j = B + 1, te = new V(), he = ee.MAX_PRINT_DIGITS - 1, ve = 0; ve <= he; ve++) {
        g && ve === j && te.append(".");
        var Le = Math.trunc(E._hi);
        if (Le < 0)
          break;
        var Je = !1, et = 0;
        Le > 9 ? (Je = !0, et = "9") : et = "0" + Le, te.append(et), E = E.subtract(ee.valueOf(Le)).multiply(ee.TEN), Je && E.selfAdd(ee.TEN);
        var Ke = !0, ot = ee.magnitude(E._hi);
        if (ot < 0 && Math.abs(ot) >= he - ve && (Ke = !1), !Ke)
          break;
      }
      return p[0] = B, te.toString();
    }, ee.prototype.sqr = function() {
      return this.multiply(this);
    }, ee.prototype.doubleValue = function() {
      return this._hi + this._lo;
    }, ee.prototype.subtract = function() {
      if (arguments[0] instanceof ee) {
        var g = arguments[0];
        return this.add(g.negate());
      }
      if (typeof arguments[0] == "number") {
        var p = arguments[0];
        return this.add(-p);
      }
    }, ee.prototype.equals = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return this._hi === g._hi && this._lo === g._lo;
      }
    }, ee.prototype.isZero = function() {
      return this._hi === 0 && this._lo === 0;
    }, ee.prototype.selfSubtract = function() {
      if (arguments[0] instanceof ee) {
        var g = arguments[0];
        return this.isNaN() ? this : this.selfAdd(-g._hi, -g._lo);
      }
      if (typeof arguments[0] == "number") {
        var p = arguments[0];
        return this.isNaN() ? this : this.selfAdd(-p, 0);
      }
    }, ee.prototype.getSpecialNumberString = function() {
      return this.isZero() ? "0.0" : this.isNaN() ? "NaN " : null;
    }, ee.prototype.min = function(g) {
      return this.le(g) ? this : g;
    }, ee.prototype.selfDivide = function() {
      if (arguments.length === 1) {
        if (arguments[0] instanceof ee) {
          var g = arguments[0];
          return this.selfDivide(g._hi, g._lo);
        }
        if (typeof arguments[0] == "number") {
          var p = arguments[0];
          return this.selfDivide(p, 0);
        }
      } else if (arguments.length === 2) {
        var E = arguments[0], B = arguments[1], D = null, j = null, te = null, he = null, ve = null, Le = null, Je = null, et = null;
        return ve = this._hi / E, Le = ee.SPLIT * ve, D = Le - ve, et = ee.SPLIT * E, D = Le - D, j = ve - D, te = et - E, Je = ve * E, te = et - te, he = E - te, et = D * te - Je + D * he + j * te + j * he, Le = (this._hi - Je - et + this._lo - ve * B) / E, et = ve + Le, this._hi = et, this._lo = ve - et + Le, this;
      }
    }, ee.prototype.dump = function() {
      return "DD<" + this._hi + ", " + this._lo + ">";
    }, ee.prototype.divide = function() {
      if (arguments[0] instanceof ee) {
        var g = arguments[0], p = null, E = null, B = null, D = null, j = null, te = null, he = null, ve = null;
        return E = (j = this._hi / g._hi) - (p = (te = ee.SPLIT * j) - (p = te - j)), ve = p * (B = (ve = ee.SPLIT * g._hi) - (B = ve - g._hi)) - (he = j * g._hi) + p * (D = g._hi - B) + E * B + E * D, te = (this._hi - he - ve + this._lo - j * g._lo) / g._hi, new ee(ve = j + te, j - ve + te);
      }
      if (typeof arguments[0] == "number") {
        var Le = arguments[0];
        return Q.isNaN(Le) ? ee.createNaN() : ee.copy(this).selfDivide(Le, 0);
      }
    }, ee.prototype.ge = function(g) {
      return (this._hi > g._hi || this._hi === g._hi) && this._lo >= g._lo;
    }, ee.prototype.pow = function(g) {
      if (g === 0)
        return ee.valueOf(1);
      var p = new ee(this), E = ee.valueOf(1), B = Math.abs(g);
      if (B > 1)
        for (; B > 0; )
          B % 2 == 1 && E.selfMultiply(p), (B /= 2) > 0 && (p = p.sqr());
      else
        E = p;
      return g < 0 ? E.reciprocal() : E;
    }, ee.prototype.ceil = function() {
      if (this.isNaN())
        return ee.NaN;
      var g = Math.ceil(this._hi), p = 0;
      return g === this._hi && (p = Math.ceil(this._lo)), new ee(g, p);
    }, ee.prototype.compareTo = function(g) {
      var p = g;
      return this._hi < p._hi ? -1 : this._hi > p._hi ? 1 : this._lo < p._lo ? -1 : this._lo > p._lo ? 1 : 0;
    }, ee.prototype.rint = function() {
      return this.isNaN() ? this : this.add(0.5).floor();
    }, ee.prototype.setValue = function() {
      if (arguments[0] instanceof ee) {
        var g = arguments[0];
        return this.init(g), this;
      }
      if (typeof arguments[0] == "number") {
        var p = arguments[0];
        return this.init(p), this;
      }
    }, ee.prototype.max = function(g) {
      return this.ge(g) ? this : g;
    }, ee.prototype.sqrt = function() {
      if (this.isZero())
        return ee.valueOf(0);
      if (this.isNegative())
        return ee.NaN;
      var g = 1 / Math.sqrt(this._hi), p = this._hi * g, E = ee.valueOf(p), B = this.subtract(E.sqr())._hi * (0.5 * g);
      return E.add(B);
    }, ee.prototype.selfAdd = function() {
      if (arguments.length === 1) {
        if (arguments[0] instanceof ee) {
          var g = arguments[0];
          return this.selfAdd(g._hi, g._lo);
        }
        if (typeof arguments[0] == "number") {
          var p = arguments[0], E = null, B = null, D = null, j = null, te = null, he = null;
          return D = this._hi + p, te = D - this._hi, j = D - te, j = p - te + (this._hi - j), he = j + this._lo, E = D + he, B = he + (D - E), this._hi = E + B, this._lo = B + (E - this._hi), this;
        }
      } else if (arguments.length === 2) {
        var ve = arguments[0], Le = arguments[1], Je = null, et = null, Ke = null, ot = null, je = null, Et = null, Gt = null;
        ot = this._hi + ve, et = this._lo + Le, je = ot - (Et = ot - this._hi), Ke = et - (Gt = et - this._lo);
        var kt = (Je = ot + (Et = (je = ve - Et + (this._hi - je)) + et)) + (Et = (Ke = Le - Gt + (this._lo - Ke)) + (Et + (ot - Je))), bt = Et + (Je - kt);
        return this._hi = kt, this._lo = bt, this;
      }
    }, ee.prototype.selfMultiply = function() {
      if (arguments.length === 1) {
        if (arguments[0] instanceof ee) {
          var g = arguments[0];
          return this.selfMultiply(g._hi, g._lo);
        }
        if (typeof arguments[0] == "number") {
          var p = arguments[0];
          return this.selfMultiply(p, 0);
        }
      } else if (arguments.length === 2) {
        var E = arguments[0], B = arguments[1], D = null, j = null, te = null, he = null, ve = null, Le = null;
        D = (ve = ee.SPLIT * this._hi) - this._hi, Le = ee.SPLIT * E, D = ve - D, j = this._hi - D, te = Le - E;
        var Je = (ve = this._hi * E) + (Le = D * (te = Le - te) - ve + D * (he = E - te) + j * te + j * he + (this._hi * B + this._lo * E)), et = Le + (D = ve - Je);
        return this._hi = Je, this._lo = et, this;
      }
    }, ee.prototype.selfSqr = function() {
      return this.selfMultiply(this);
    }, ee.prototype.floor = function() {
      if (this.isNaN())
        return ee.NaN;
      var g = Math.floor(this._hi), p = 0;
      return g === this._hi && (p = Math.floor(this._lo)), new ee(g, p);
    }, ee.prototype.negate = function() {
      return this.isNaN() ? this : new ee(-this._hi, -this._lo);
    }, ee.prototype.clone = function() {
    }, ee.prototype.multiply = function() {
      if (arguments[0] instanceof ee) {
        var g = arguments[0];
        return g.isNaN() ? ee.createNaN() : ee.copy(this).selfMultiply(g);
      }
      if (typeof arguments[0] == "number") {
        var p = arguments[0];
        return Q.isNaN(p) ? ee.createNaN() : ee.copy(this).selfMultiply(p, 0);
      }
    }, ee.prototype.isNaN = function() {
      return Q.isNaN(this._hi);
    }, ee.prototype.intValue = function() {
      return Math.trunc(this._hi);
    }, ee.prototype.toString = function() {
      var g = ee.magnitude(this._hi);
      return g >= -3 && g <= 20 ? this.toStandardNotation() : this.toSciNotation();
    }, ee.prototype.toStandardNotation = function() {
      var g = this.getSpecialNumberString();
      if (g !== null)
        return g;
      var p = new Array(1).fill(null), E = this.extractSignificantDigits(!0, p), B = p[0] + 1, D = E;
      if (E.charAt(0) === ".")
        D = "0" + E;
      else if (B < 0)
        D = "0." + ee.stringOfChar("0", -B) + E;
      else if (E.indexOf(".") === -1) {
        var j = B - E.length;
        D = E + ee.stringOfChar("0", j) + ".0";
      }
      return this.isNegative() ? "-" + D : D;
    }, ee.prototype.reciprocal = function() {
      var g = null, p = null, E = null, B = null, D = null, j = null, te = null, he = null;
      p = (D = 1 / this._hi) - (g = (j = ee.SPLIT * D) - (g = j - D)), E = (he = ee.SPLIT * this._hi) - this._hi;
      var ve = D + (j = (1 - (te = D * this._hi) - (he = g * (E = he - E) - te + g * (B = this._hi - E) + p * E + p * B) - D * this._lo) / this._hi);
      return new ee(ve, D - ve + j);
    }, ee.prototype.toSciNotation = function() {
      if (this.isZero())
        return ee.SCI_NOT_ZERO;
      var g = this.getSpecialNumberString();
      if (g !== null)
        return g;
      var p = new Array(1).fill(null), E = this.extractSignificantDigits(!1, p), B = ee.SCI_NOT_EXPONENT_CHAR + p[0];
      if (E.charAt(0) === "0")
        throw new Error("Found leading zero: " + E);
      var D = "";
      E.length > 1 && (D = E.substring(1));
      var j = E.charAt(0) + "." + D;
      return this.isNegative() ? "-" + j + B : j + B;
    }, ee.prototype.abs = function() {
      return this.isNaN() ? ee.NaN : this.isNegative() ? this.negate() : new ee(this);
    }, ee.prototype.isPositive = function() {
      return (this._hi > 0 || this._hi === 0) && this._lo > 0;
    }, ee.prototype.lt = function(g) {
      return (this._hi < g._hi || this._hi === g._hi) && this._lo < g._lo;
    }, ee.prototype.add = function() {
      if (arguments[0] instanceof ee) {
        var g = arguments[0];
        return ee.copy(this).selfAdd(g);
      }
      if (typeof arguments[0] == "number") {
        var p = arguments[0];
        return ee.copy(this).selfAdd(p);
      }
    }, ee.prototype.init = function() {
      if (arguments.length === 1) {
        if (typeof arguments[0] == "number") {
          var g = arguments[0];
          this._hi = g, this._lo = 0;
        } else if (arguments[0] instanceof ee) {
          var p = arguments[0];
          this._hi = p._hi, this._lo = p._lo;
        }
      } else if (arguments.length === 2) {
        var E = arguments[0], B = arguments[1];
        this._hi = E, this._lo = B;
      }
    }, ee.prototype.gt = function(g) {
      return (this._hi > g._hi || this._hi === g._hi) && this._lo > g._lo;
    }, ee.prototype.isNegative = function() {
      return (this._hi < 0 || this._hi === 0) && this._lo < 0;
    }, ee.prototype.trunc = function() {
      return this.isNaN() ? ee.NaN : this.isPositive() ? this.floor() : this.ceil();
    }, ee.prototype.signum = function() {
      return this._hi > 0 ? 1 : this._hi < 0 ? -1 : this._lo > 0 ? 1 : this._lo < 0 ? -1 : 0;
    }, ee.prototype.interfaces_ = function() {
      return [r, R, M];
    }, ee.prototype.getClass = function() {
      return ee;
    }, ee.sqr = function(g) {
      return ee.valueOf(g).selfMultiply(g);
    }, ee.valueOf = function() {
      if (typeof arguments[0] == "string") {
        var g = arguments[0];
        return ee.parse(g);
      }
      if (typeof arguments[0] == "number") {
        var p = arguments[0];
        return new ee(p);
      }
    }, ee.sqrt = function(g) {
      return ee.valueOf(g).sqrt();
    }, ee.parse = function(g) {
      for (var p = 0, E = g.length; ce.isWhitespace(g.charAt(p)); )
        p++;
      var B = !1;
      if (p < E) {
        var D = g.charAt(p);
        D !== "-" && D !== "+" || (p++, D === "-" && (B = !0));
      }
      for (var j = new ee(), te = 0, he = 0, ve = 0; !(p >= E); ) {
        var Le = g.charAt(p);
        if (p++, ce.isDigit(Le)) {
          var Je = Le - "0";
          j.selfMultiply(ee.TEN), j.selfAdd(Je), te++;
        } else {
          if (Le !== ".") {
            if (Le === "e" || Le === "E") {
              var et = g.substring(p);
              try {
                ve = Z.parseInt(et);
              } catch (Gt) {
                throw Gt instanceof Error ? new Error("Invalid exponent " + et + " in string " + g) : Gt;
              }
              break;
            }
            throw new Error("Unexpected character '" + Le + "' at position " + p + " in string " + g);
          }
          he = te;
        }
      }
      var Ke = j, ot = te - he - ve;
      if (ot === 0)
        Ke = j;
      else if (ot > 0) {
        var je = ee.TEN.pow(ot);
        Ke = j.divide(je);
      } else if (ot < 0) {
        var Et = ee.TEN.pow(-ot);
        Ke = j.multiply(Et);
      }
      return B ? Ke.negate() : Ke;
    }, ee.createNaN = function() {
      return new ee(Q.NaN, Q.NaN);
    }, ee.copy = function(g) {
      return new ee(g);
    }, ee.magnitude = function(g) {
      var p = Math.abs(g), E = Math.log(p) / Math.log(10), B = Math.trunc(Math.floor(E));
      return 10 * Math.pow(10, B) <= p && (B += 1), B;
    }, ee.stringOfChar = function(g, p) {
      for (var E = new V(), B = 0; B < p; B++)
        E.append(g);
      return E.toString();
    }, pe.PI.get = function() {
      return new ee(3.141592653589793, 12246467991473532e-32);
    }, pe.TWO_PI.get = function() {
      return new ee(6.283185307179586, 24492935982947064e-32);
    }, pe.PI_2.get = function() {
      return new ee(1.5707963267948966, 6123233995736766e-32);
    }, pe.E.get = function() {
      return new ee(2.718281828459045, 14456468917292502e-32);
    }, pe.NaN.get = function() {
      return new ee(Q.NaN, Q.NaN);
    }, pe.EPS.get = function() {
      return 123259516440783e-46;
    }, pe.SPLIT.get = function() {
      return 134217729;
    }, pe.MAX_PRINT_DIGITS.get = function() {
      return 32;
    }, pe.TEN.get = function() {
      return ee.valueOf(10);
    }, pe.ONE.get = function() {
      return ee.valueOf(1);
    }, pe.SCI_NOT_EXPONENT_CHAR.get = function() {
      return "E";
    }, pe.SCI_NOT_ZERO.get = function() {
      return "0.0E0";
    }, Object.defineProperties(ee, pe);
    var Ce = function() {
    }, Be = { DP_SAFE_EPSILON: { configurable: !0 } };
    Ce.prototype.interfaces_ = function() {
      return [];
    }, Ce.prototype.getClass = function() {
      return Ce;
    }, Ce.orientationIndex = function(g, p, E) {
      var B = Ce.orientationIndexFilter(g, p, E);
      if (B <= 1)
        return B;
      var D = ee.valueOf(p.x).selfAdd(-g.x), j = ee.valueOf(p.y).selfAdd(-g.y), te = ee.valueOf(E.x).selfAdd(-p.x), he = ee.valueOf(E.y).selfAdd(-p.y);
      return D.selfMultiply(he).selfSubtract(j.selfMultiply(te)).signum();
    }, Ce.signOfDet2x2 = function(g, p, E, B) {
      return g.multiply(B).selfSubtract(p.multiply(E)).signum();
    }, Ce.intersection = function(g, p, E, B) {
      var D = ee.valueOf(B.y).selfSubtract(E.y).selfMultiply(ee.valueOf(p.x).selfSubtract(g.x)), j = ee.valueOf(B.x).selfSubtract(E.x).selfMultiply(ee.valueOf(p.y).selfSubtract(g.y)), te = D.subtract(j), he = ee.valueOf(B.x).selfSubtract(E.x).selfMultiply(ee.valueOf(g.y).selfSubtract(E.y)), ve = ee.valueOf(B.y).selfSubtract(E.y).selfMultiply(ee.valueOf(g.x).selfSubtract(E.x)), Le = he.subtract(ve).selfDivide(te).doubleValue(), Je = ee.valueOf(g.x).selfAdd(ee.valueOf(p.x).selfSubtract(g.x).selfMultiply(Le)).doubleValue(), et = ee.valueOf(p.x).selfSubtract(g.x).selfMultiply(ee.valueOf(g.y).selfSubtract(E.y)), Ke = ee.valueOf(p.y).selfSubtract(g.y).selfMultiply(ee.valueOf(g.x).selfSubtract(E.x)), ot = et.subtract(Ke).selfDivide(te).doubleValue(), je = ee.valueOf(E.y).selfAdd(ee.valueOf(B.y).selfSubtract(E.y).selfMultiply(ot)).doubleValue();
      return new L(Je, je);
    }, Ce.orientationIndexFilter = function(g, p, E) {
      var B = null, D = (g.x - E.x) * (p.y - E.y), j = (g.y - E.y) * (p.x - E.x), te = D - j;
      if (D > 0) {
        if (j <= 0)
          return Ce.signum(te);
        B = D + j;
      } else {
        if (!(D < 0) || j >= 0)
          return Ce.signum(te);
        B = -D - j;
      }
      var he = Ce.DP_SAFE_EPSILON * B;
      return te >= he || -te >= he ? Ce.signum(te) : 2;
    }, Ce.signum = function(g) {
      return g > 0 ? 1 : g < 0 ? -1 : 0;
    }, Be.DP_SAFE_EPSILON.get = function() {
      return 1e-15;
    }, Object.defineProperties(Ce, Be);
    var Ie = function() {
    }, Qe = { X: { configurable: !0 }, Y: { configurable: !0 }, Z: { configurable: !0 }, M: { configurable: !0 } };
    Qe.X.get = function() {
      return 0;
    }, Qe.Y.get = function() {
      return 1;
    }, Qe.Z.get = function() {
      return 2;
    }, Qe.M.get = function() {
      return 3;
    }, Ie.prototype.setOrdinate = function(g, p, E) {
    }, Ie.prototype.size = function() {
    }, Ie.prototype.getOrdinate = function(g, p) {
    }, Ie.prototype.getCoordinate = function() {
    }, Ie.prototype.getCoordinateCopy = function(g) {
    }, Ie.prototype.getDimension = function() {
    }, Ie.prototype.getX = function(g) {
    }, Ie.prototype.clone = function() {
    }, Ie.prototype.expandEnvelope = function(g) {
    }, Ie.prototype.copy = function() {
    }, Ie.prototype.getY = function(g) {
    }, Ie.prototype.toCoordinateArray = function() {
    }, Ie.prototype.interfaces_ = function() {
      return [M];
    }, Ie.prototype.getClass = function() {
      return Ie;
    }, Object.defineProperties(Ie, Qe);
    var xe = function() {
    }, Se = function(g) {
      function p() {
        g.call(this, "Projective point not representable on the Cartesian plane.");
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(xe), De = function() {
    };
    De.arraycopy = function(g, p, E, B, D) {
      for (var j = 0, te = p; te < p + D; te++)
        E[B + j] = g[te], j++;
    }, De.getProperty = function(g) {
      return { "line.separator": `
` }[g];
    };
    var Ue = function g() {
      if (this.x = null, this.y = null, this.w = null, arguments.length === 0)
        this.x = 0, this.y = 0, this.w = 1;
      else if (arguments.length === 1) {
        var p = arguments[0];
        this.x = p.x, this.y = p.y, this.w = 1;
      } else if (arguments.length === 2) {
        if (typeof arguments[0] == "number" && typeof arguments[1] == "number") {
          var E = arguments[0], B = arguments[1];
          this.x = E, this.y = B, this.w = 1;
        } else if (arguments[0] instanceof g && arguments[1] instanceof g) {
          var D = arguments[0], j = arguments[1];
          this.x = D.y * j.w - j.y * D.w, this.y = j.x * D.w - D.x * j.w, this.w = D.x * j.y - j.x * D.y;
        } else if (arguments[0] instanceof L && arguments[1] instanceof L) {
          var te = arguments[0], he = arguments[1];
          this.x = te.y - he.y, this.y = he.x - te.x, this.w = te.x * he.y - he.x * te.y;
        }
      } else if (arguments.length === 3) {
        var ve = arguments[0], Le = arguments[1], Je = arguments[2];
        this.x = ve, this.y = Le, this.w = Je;
      } else if (arguments.length === 4) {
        var et = arguments[0], Ke = arguments[1], ot = arguments[2], je = arguments[3], Et = et.y - Ke.y, Gt = Ke.x - et.x, kt = et.x * Ke.y - Ke.x * et.y, bt = ot.y - je.y, Yn = je.x - ot.x, Hr = ot.x * je.y - je.x * ot.y;
        this.x = Gt * Hr - Yn * kt, this.y = bt * kt - Et * Hr, this.w = Et * Yn - bt * Gt;
      }
    };
    Ue.prototype.getY = function() {
      var g = this.y / this.w;
      if (Q.isNaN(g) || Q.isInfinite(g))
        throw new Se();
      return g;
    }, Ue.prototype.getX = function() {
      var g = this.x / this.w;
      if (Q.isNaN(g) || Q.isInfinite(g))
        throw new Se();
      return g;
    }, Ue.prototype.getCoordinate = function() {
      var g = new L();
      return g.x = this.getX(), g.y = this.getY(), g;
    }, Ue.prototype.interfaces_ = function() {
      return [];
    }, Ue.prototype.getClass = function() {
      return Ue;
    }, Ue.intersection = function(g, p, E, B) {
      var D = g.y - p.y, j = p.x - g.x, te = g.x * p.y - p.x * g.y, he = E.y - B.y, ve = B.x - E.x, Le = E.x * B.y - B.x * E.y, Je = D * ve - he * j, et = (j * Le - ve * te) / Je, Ke = (he * te - D * Le) / Je;
      if (Q.isNaN(et) || Q.isInfinite(et) || Q.isNaN(Ke) || Q.isInfinite(Ke))
        throw new Se();
      return new L(et, Ke);
    };
    var Te = function g() {
      if (this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, arguments.length === 0)
        this.init();
      else if (arguments.length === 1) {
        if (arguments[0] instanceof L) {
          var p = arguments[0];
          this.init(p.x, p.x, p.y, p.y);
        } else if (arguments[0] instanceof g) {
          var E = arguments[0];
          this.init(E);
        }
      } else if (arguments.length === 2) {
        var B = arguments[0], D = arguments[1];
        this.init(B.x, D.x, B.y, D.y);
      } else if (arguments.length === 4) {
        var j = arguments[0], te = arguments[1], he = arguments[2], ve = arguments[3];
        this.init(j, te, he, ve);
      }
    }, se = { serialVersionUID: { configurable: !0 } };
    Te.prototype.getArea = function() {
      return this.getWidth() * this.getHeight();
    }, Te.prototype.equals = function(g) {
      if (!(g instanceof Te))
        return !1;
      var p = g;
      return this.isNull() ? p.isNull() : this._maxx === p.getMaxX() && this._maxy === p.getMaxY() && this._minx === p.getMinX() && this._miny === p.getMinY();
    }, Te.prototype.intersection = function(g) {
      if (this.isNull() || g.isNull() || !this.intersects(g))
        return new Te();
      var p = this._minx > g._minx ? this._minx : g._minx, E = this._miny > g._miny ? this._miny : g._miny, B = this._maxx < g._maxx ? this._maxx : g._maxx, D = this._maxy < g._maxy ? this._maxy : g._maxy;
      return new Te(p, B, E, D);
    }, Te.prototype.isNull = function() {
      return this._maxx < this._minx;
    }, Te.prototype.getMaxX = function() {
      return this._maxx;
    }, Te.prototype.covers = function() {
      if (arguments.length === 1) {
        if (arguments[0] instanceof L) {
          var g = arguments[0];
          return this.covers(g.x, g.y);
        }
        if (arguments[0] instanceof Te) {
          var p = arguments[0];
          return !this.isNull() && !p.isNull() && p.getMinX() >= this._minx && p.getMaxX() <= this._maxx && p.getMinY() >= this._miny && p.getMaxY() <= this._maxy;
        }
      } else if (arguments.length === 2) {
        var E = arguments[0], B = arguments[1];
        return !this.isNull() && E >= this._minx && E <= this._maxx && B >= this._miny && B <= this._maxy;
      }
    }, Te.prototype.intersects = function() {
      if (arguments.length === 1) {
        if (arguments[0] instanceof Te) {
          var g = arguments[0];
          return !this.isNull() && !g.isNull() && !(g._minx > this._maxx || g._maxx < this._minx || g._miny > this._maxy || g._maxy < this._miny);
        }
        if (arguments[0] instanceof L) {
          var p = arguments[0];
          return this.intersects(p.x, p.y);
        }
      } else if (arguments.length === 2) {
        var E = arguments[0], B = arguments[1];
        return !this.isNull() && !(E > this._maxx || E < this._minx || B > this._maxy || B < this._miny);
      }
    }, Te.prototype.getMinY = function() {
      return this._miny;
    }, Te.prototype.getMinX = function() {
      return this._minx;
    }, Te.prototype.expandToInclude = function() {
      if (arguments.length === 1) {
        if (arguments[0] instanceof L) {
          var g = arguments[0];
          this.expandToInclude(g.x, g.y);
        } else if (arguments[0] instanceof Te) {
          var p = arguments[0];
          if (p.isNull())
            return null;
          this.isNull() ? (this._minx = p.getMinX(), this._maxx = p.getMaxX(), this._miny = p.getMinY(), this._maxy = p.getMaxY()) : (p._minx < this._minx && (this._minx = p._minx), p._maxx > this._maxx && (this._maxx = p._maxx), p._miny < this._miny && (this._miny = p._miny), p._maxy > this._maxy && (this._maxy = p._maxy));
        }
      } else if (arguments.length === 2) {
        var E = arguments[0], B = arguments[1];
        this.isNull() ? (this._minx = E, this._maxx = E, this._miny = B, this._maxy = B) : (E < this._minx && (this._minx = E), E > this._maxx && (this._maxx = E), B < this._miny && (this._miny = B), B > this._maxy && (this._maxy = B));
      }
    }, Te.prototype.minExtent = function() {
      if (this.isNull())
        return 0;
      var g = this.getWidth(), p = this.getHeight();
      return g < p ? g : p;
    }, Te.prototype.getWidth = function() {
      return this.isNull() ? 0 : this._maxx - this._minx;
    }, Te.prototype.compareTo = function(g) {
      var p = g;
      return this.isNull() ? p.isNull() ? 0 : -1 : p.isNull() ? 1 : this._minx < p._minx ? -1 : this._minx > p._minx ? 1 : this._miny < p._miny ? -1 : this._miny > p._miny ? 1 : this._maxx < p._maxx ? -1 : this._maxx > p._maxx ? 1 : this._maxy < p._maxy ? -1 : this._maxy > p._maxy ? 1 : 0;
    }, Te.prototype.translate = function(g, p) {
      if (this.isNull())
        return null;
      this.init(this.getMinX() + g, this.getMaxX() + g, this.getMinY() + p, this.getMaxY() + p);
    }, Te.prototype.toString = function() {
      return "Env[" + this._minx + " : " + this._maxx + ", " + this._miny + " : " + this._maxy + "]";
    }, Te.prototype.setToNull = function() {
      this._minx = 0, this._maxx = -1, this._miny = 0, this._maxy = -1;
    }, Te.prototype.getHeight = function() {
      return this.isNull() ? 0 : this._maxy - this._miny;
    }, Te.prototype.maxExtent = function() {
      if (this.isNull())
        return 0;
      var g = this.getWidth(), p = this.getHeight();
      return g > p ? g : p;
    }, Te.prototype.expandBy = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        this.expandBy(g, g);
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        if (this.isNull())
          return null;
        this._minx -= p, this._maxx += p, this._miny -= E, this._maxy += E, (this._minx > this._maxx || this._miny > this._maxy) && this.setToNull();
      }
    }, Te.prototype.contains = function() {
      if (arguments.length === 1) {
        if (arguments[0] instanceof Te) {
          var g = arguments[0];
          return this.covers(g);
        }
        if (arguments[0] instanceof L) {
          var p = arguments[0];
          return this.covers(p);
        }
      } else if (arguments.length === 2) {
        var E = arguments[0], B = arguments[1];
        return this.covers(E, B);
      }
    }, Te.prototype.centre = function() {
      return this.isNull() ? null : new L((this.getMinX() + this.getMaxX()) / 2, (this.getMinY() + this.getMaxY()) / 2);
    }, Te.prototype.init = function() {
      if (arguments.length === 0)
        this.setToNull();
      else if (arguments.length === 1) {
        if (arguments[0] instanceof L) {
          var g = arguments[0];
          this.init(g.x, g.x, g.y, g.y);
        } else if (arguments[0] instanceof Te) {
          var p = arguments[0];
          this._minx = p._minx, this._maxx = p._maxx, this._miny = p._miny, this._maxy = p._maxy;
        }
      } else if (arguments.length === 2) {
        var E = arguments[0], B = arguments[1];
        this.init(E.x, B.x, E.y, B.y);
      } else if (arguments.length === 4) {
        var D = arguments[0], j = arguments[1], te = arguments[2], he = arguments[3];
        D < j ? (this._minx = D, this._maxx = j) : (this._minx = j, this._maxx = D), te < he ? (this._miny = te, this._maxy = he) : (this._miny = he, this._maxy = te);
      }
    }, Te.prototype.getMaxY = function() {
      return this._maxy;
    }, Te.prototype.distance = function(g) {
      if (this.intersects(g))
        return 0;
      var p = 0;
      this._maxx < g._minx ? p = g._minx - this._maxx : this._minx > g._maxx && (p = this._minx - g._maxx);
      var E = 0;
      return this._maxy < g._miny ? E = g._miny - this._maxy : this._miny > g._maxy && (E = this._miny - g._maxy), p === 0 ? E : E === 0 ? p : Math.sqrt(p * p + E * E);
    }, Te.prototype.hashCode = function() {
      var g = 17;
      return g = 37 * g + L.hashCode(this._minx), g = 37 * g + L.hashCode(this._maxx), g = 37 * g + L.hashCode(this._miny), g = 37 * g + L.hashCode(this._maxy);
    }, Te.prototype.interfaces_ = function() {
      return [R, r];
    }, Te.prototype.getClass = function() {
      return Te;
    }, Te.intersects = function() {
      if (arguments.length === 3) {
        var g = arguments[0], p = arguments[1], E = arguments[2];
        return E.x >= (g.x < p.x ? g.x : p.x) && E.x <= (g.x > p.x ? g.x : p.x) && E.y >= (g.y < p.y ? g.y : p.y) && E.y <= (g.y > p.y ? g.y : p.y);
      }
      if (arguments.length === 4) {
        var B = arguments[0], D = arguments[1], j = arguments[2], te = arguments[3], he = Math.min(j.x, te.x), ve = Math.max(j.x, te.x), Le = Math.min(B.x, D.x), Je = Math.max(B.x, D.x);
        return !(Le > ve) && !(Je < he) && (he = Math.min(j.y, te.y), ve = Math.max(j.y, te.y), Le = Math.min(B.y, D.y), Je = Math.max(B.y, D.y), !(Le > ve) && !(Je < he));
      }
    }, se.serialVersionUID.get = function() {
      return 5873921885273102e3;
    }, Object.defineProperties(Te, se);
    var fe = { typeStr: /^\s*(\w+)\s*\(\s*(.*)\s*\)\s*$/, emptyTypeStr: /^\s*(\w+)\s*EMPTY\s*$/, spaces: /\s+/, parenComma: /\)\s*,\s*\(/, doubleParenComma: /\)\s*\)\s*,\s*\(\s*\(/, trimParens: /^\s*\(?(.*?)\)?\s*$/ }, W = function(g) {
      this.geometryFactory = g || new or();
    };
    W.prototype.read = function(g) {
      var p, E, B;
      g = g.replace(/[\n\r]/g, " ");
      var D = fe.typeStr.exec(g);
      if (g.search("EMPTY") !== -1 && ((D = fe.emptyTypeStr.exec(g))[2] = void 0), D && (E = D[1].toLowerCase(), B = D[2], _e[E] && (p = _e[E].apply(this, [B]))), p === void 0)
        throw new Error("Could not parse WKT " + g);
      return p;
    }, W.prototype.write = function(g) {
      return this.extractGeometry(g);
    }, W.prototype.extractGeometry = function(g) {
      var p = g.getGeometryType().toLowerCase();
      if (!ge[p])
        return null;
      var E = p.toUpperCase();
      return g.isEmpty() ? E + " EMPTY" : E + "(" + ge[p].apply(this, [g]) + ")";
    };
    var ge = { coordinate: function(g) {
      return g.x + " " + g.y;
    }, point: function(g) {
      return ge.coordinate.call(this, g._coordinates._coordinates[0]);
    }, multipoint: function(g) {
      for (var p = [], E = 0, B = g._geometries.length; E < B; ++E)
        p.push("(" + ge.point.apply(this, [g._geometries[E]]) + ")");
      return p.join(",");
    }, linestring: function(g) {
      for (var p = [], E = 0, B = g._points._coordinates.length; E < B; ++E)
        p.push(ge.coordinate.apply(this, [g._points._coordinates[E]]));
      return p.join(",");
    }, linearring: function(g) {
      for (var p = [], E = 0, B = g._points._coordinates.length; E < B; ++E)
        p.push(ge.coordinate.apply(this, [g._points._coordinates[E]]));
      return p.join(",");
    }, multilinestring: function(g) {
      for (var p = [], E = 0, B = g._geometries.length; E < B; ++E)
        p.push("(" + ge.linestring.apply(this, [g._geometries[E]]) + ")");
      return p.join(",");
    }, polygon: function(g) {
      var p = [];
      p.push("(" + ge.linestring.apply(this, [g._shell]) + ")");
      for (var E = 0, B = g._holes.length; E < B; ++E)
        p.push("(" + ge.linestring.apply(this, [g._holes[E]]) + ")");
      return p.join(",");
    }, multipolygon: function(g) {
      for (var p = [], E = 0, B = g._geometries.length; E < B; ++E)
        p.push("(" + ge.polygon.apply(this, [g._geometries[E]]) + ")");
      return p.join(",");
    }, geometrycollection: function(g) {
      for (var p = [], E = 0, B = g._geometries.length; E < B; ++E)
        p.push(this.extractGeometry(g._geometries[E]));
      return p.join(",");
    } }, _e = { point: function(g) {
      if (g === void 0)
        return this.geometryFactory.createPoint();
      var p = g.trim().split(fe.spaces);
      return this.geometryFactory.createPoint(new L(Number.parseFloat(p[0]), Number.parseFloat(p[1])));
    }, multipoint: function(g) {
      if (g === void 0)
        return this.geometryFactory.createMultiPoint();
      for (var p, E = g.trim().split(","), B = [], D = 0, j = E.length; D < j; ++D)
        p = E[D].replace(fe.trimParens, "$1"), B.push(_e.point.apply(this, [p]));
      return this.geometryFactory.createMultiPoint(B);
    }, linestring: function(g) {
      if (g === void 0)
        return this.geometryFactory.createLineString();
      for (var p, E = g.trim().split(","), B = [], D = 0, j = E.length; D < j; ++D)
        p = E[D].trim().split(fe.spaces), B.push(new L(Number.parseFloat(p[0]), Number.parseFloat(p[1])));
      return this.geometryFactory.createLineString(B);
    }, linearring: function(g) {
      if (g === void 0)
        return this.geometryFactory.createLinearRing();
      for (var p, E = g.trim().split(","), B = [], D = 0, j = E.length; D < j; ++D)
        p = E[D].trim().split(fe.spaces), B.push(new L(Number.parseFloat(p[0]), Number.parseFloat(p[1])));
      return this.geometryFactory.createLinearRing(B);
    }, multilinestring: function(g) {
      if (g === void 0)
        return this.geometryFactory.createMultiLineString();
      for (var p, E = g.trim().split(fe.parenComma), B = [], D = 0, j = E.length; D < j; ++D)
        p = E[D].replace(fe.trimParens, "$1"), B.push(_e.linestring.apply(this, [p]));
      return this.geometryFactory.createMultiLineString(B);
    }, polygon: function(g) {
      if (g === void 0)
        return this.geometryFactory.createPolygon();
      for (var p, E, B, D, j = g.trim().split(fe.parenComma), te = [], he = 0, ve = j.length; he < ve; ++he)
        p = j[he].replace(fe.trimParens, "$1"), E = _e.linestring.apply(this, [p]), B = this.geometryFactory.createLinearRing(E._points), he === 0 ? D = B : te.push(B);
      return this.geometryFactory.createPolygon(D, te);
    }, multipolygon: function(g) {
      if (g === void 0)
        return this.geometryFactory.createMultiPolygon();
      for (var p, E = g.trim().split(fe.doubleParenComma), B = [], D = 0, j = E.length; D < j; ++D)
        p = E[D].replace(fe.trimParens, "$1"), B.push(_e.polygon.apply(this, [p]));
      return this.geometryFactory.createMultiPolygon(B);
    }, geometrycollection: function(g) {
      if (g === void 0)
        return this.geometryFactory.createGeometryCollection();
      for (var p = (g = g.replace(/,\s*([A-Za-z])/g, "|$1")).trim().split("|"), E = [], B = 0, D = p.length; B < D; ++B)
        E.push(this.read(p[B]));
      return this.geometryFactory.createGeometryCollection(E);
    } }, Re = function(g) {
      this.parser = new W(g);
    };
    Re.prototype.write = function(g) {
      return this.parser.write(g);
    }, Re.toLineString = function(g, p) {
      if (arguments.length !== 2)
        throw new Error("Not implemented");
      return "LINESTRING ( " + g.x + " " + g.y + ", " + p.x + " " + p.y + " )";
    };
    var Ee = function(g) {
      function p(E) {
        g.call(this, E), this.name = "RuntimeException", this.message = E, this.stack = new g().stack;
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p;
    }(Error), oe = function(g) {
      function p() {
        if (g.call(this), arguments.length === 0)
          g.call(this);
        else if (arguments.length === 1) {
          var E = arguments[0];
          g.call(this, E);
        }
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(Ee), ie = function() {
    };
    ie.prototype.interfaces_ = function() {
      return [];
    }, ie.prototype.getClass = function() {
      return ie;
    }, ie.shouldNeverReachHere = function() {
      if (arguments.length === 0)
        ie.shouldNeverReachHere(null);
      else if (arguments.length === 1) {
        var g = arguments[0];
        throw new oe("Should never reach here" + (g !== null ? ": " + g : ""));
      }
    }, ie.isTrue = function() {
      var g, p;
      if (arguments.length === 1)
        g = arguments[0], ie.isTrue(g, null);
      else if (arguments.length === 2 && (g = arguments[0], p = arguments[1], !g))
        throw p === null ? new oe() : new oe(p);
    }, ie.equals = function() {
      var g, p, E;
      if (arguments.length === 2)
        g = arguments[0], p = arguments[1], ie.equals(g, p, null);
      else if (arguments.length === 3 && (g = arguments[0], p = arguments[1], E = arguments[2], !p.equals(g)))
        throw new oe("Expected " + g + " but encountered " + p + (E !== null ? ": " + E : ""));
    };
    var Ae = function() {
      this._result = null, this._inputLines = Array(2).fill().map(function() {
        return Array(2);
      }), this._intPt = new Array(2).fill(null), this._intLineIndex = null, this._isProper = null, this._pa = null, this._pb = null, this._precisionModel = null, this._intPt[0] = new L(), this._intPt[1] = new L(), this._pa = this._intPt[0], this._pb = this._intPt[1], this._result = 0;
    }, de = { DONT_INTERSECT: { configurable: !0 }, DO_INTERSECT: { configurable: !0 }, COLLINEAR: { configurable: !0 }, NO_INTERSECTION: { configurable: !0 }, POINT_INTERSECTION: { configurable: !0 }, COLLINEAR_INTERSECTION: { configurable: !0 } };
    Ae.prototype.getIndexAlongSegment = function(g, p) {
      return this.computeIntLineIndex(), this._intLineIndex[g][p];
    }, Ae.prototype.getTopologySummary = function() {
      var g = new V();
      return this.isEndPoint() && g.append(" endpoint"), this._isProper && g.append(" proper"), this.isCollinear() && g.append(" collinear"), g.toString();
    }, Ae.prototype.computeIntersection = function(g, p, E, B) {
      this._inputLines[0][0] = g, this._inputLines[0][1] = p, this._inputLines[1][0] = E, this._inputLines[1][1] = B, this._result = this.computeIntersect(g, p, E, B);
    }, Ae.prototype.getIntersectionNum = function() {
      return this._result;
    }, Ae.prototype.computeIntLineIndex = function() {
      if (arguments.length === 0)
        this._intLineIndex === null && (this._intLineIndex = Array(2).fill().map(function() {
          return Array(2);
        }), this.computeIntLineIndex(0), this.computeIntLineIndex(1));
      else if (arguments.length === 1) {
        var g = arguments[0];
        this.getEdgeDistance(g, 0) > this.getEdgeDistance(g, 1) ? (this._intLineIndex[g][0] = 0, this._intLineIndex[g][1] = 1) : (this._intLineIndex[g][0] = 1, this._intLineIndex[g][1] = 0);
      }
    }, Ae.prototype.isProper = function() {
      return this.hasIntersection() && this._isProper;
    }, Ae.prototype.setPrecisionModel = function(g) {
      this._precisionModel = g;
    }, Ae.prototype.isInteriorIntersection = function() {
      if (arguments.length === 0)
        return !!this.isInteriorIntersection(0) || !!this.isInteriorIntersection(1);
      if (arguments.length === 1) {
        for (var g = arguments[0], p = 0; p < this._result; p++)
          if (!this._intPt[p].equals2D(this._inputLines[g][0]) && !this._intPt[p].equals2D(this._inputLines[g][1]))
            return !0;
        return !1;
      }
    }, Ae.prototype.getIntersection = function(g) {
      return this._intPt[g];
    }, Ae.prototype.isEndPoint = function() {
      return this.hasIntersection() && !this._isProper;
    }, Ae.prototype.hasIntersection = function() {
      return this._result !== Ae.NO_INTERSECTION;
    }, Ae.prototype.getEdgeDistance = function(g, p) {
      return Ae.computeEdgeDistance(this._intPt[p], this._inputLines[g][0], this._inputLines[g][1]);
    }, Ae.prototype.isCollinear = function() {
      return this._result === Ae.COLLINEAR_INTERSECTION;
    }, Ae.prototype.toString = function() {
      return Re.toLineString(this._inputLines[0][0], this._inputLines[0][1]) + " - " + Re.toLineString(this._inputLines[1][0], this._inputLines[1][1]) + this.getTopologySummary();
    }, Ae.prototype.getEndpoint = function(g, p) {
      return this._inputLines[g][p];
    }, Ae.prototype.isIntersection = function(g) {
      for (var p = 0; p < this._result; p++)
        if (this._intPt[p].equals2D(g))
          return !0;
      return !1;
    }, Ae.prototype.getIntersectionAlongSegment = function(g, p) {
      return this.computeIntLineIndex(), this._intPt[this._intLineIndex[g][p]];
    }, Ae.prototype.interfaces_ = function() {
      return [];
    }, Ae.prototype.getClass = function() {
      return Ae;
    }, Ae.computeEdgeDistance = function(g, p, E) {
      var B = Math.abs(E.x - p.x), D = Math.abs(E.y - p.y), j = -1;
      if (g.equals(p))
        j = 0;
      else if (g.equals(E))
        j = B > D ? B : D;
      else {
        var te = Math.abs(g.x - p.x), he = Math.abs(g.y - p.y);
        (j = B > D ? te : he) !== 0 || g.equals(p) || (j = Math.max(te, he));
      }
      return ie.isTrue(!(j === 0 && !g.equals(p)), "Bad distance calculation"), j;
    }, Ae.nonRobustComputeEdgeDistance = function(g, p, E) {
      var B = g.x - p.x, D = g.y - p.y, j = Math.sqrt(B * B + D * D);
      return ie.isTrue(!(j === 0 && !g.equals(p)), "Invalid distance calculation"), j;
    }, de.DONT_INTERSECT.get = function() {
      return 0;
    }, de.DO_INTERSECT.get = function() {
      return 1;
    }, de.COLLINEAR.get = function() {
      return 2;
    }, de.NO_INTERSECTION.get = function() {
      return 0;
    }, de.POINT_INTERSECTION.get = function() {
      return 1;
    }, de.COLLINEAR_INTERSECTION.get = function() {
      return 2;
    }, Object.defineProperties(Ae, de);
    var we = function(g) {
      function p() {
        g.apply(this, arguments);
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.isInSegmentEnvelopes = function(E) {
        var B = new Te(this._inputLines[0][0], this._inputLines[0][1]), D = new Te(this._inputLines[1][0], this._inputLines[1][1]);
        return B.contains(E) && D.contains(E);
      }, p.prototype.computeIntersection = function() {
        if (arguments.length !== 3)
          return g.prototype.computeIntersection.apply(this, arguments);
        var E = arguments[0], B = arguments[1], D = arguments[2];
        if (this._isProper = !1, Te.intersects(B, D, E) && ke.orientationIndex(B, D, E) === 0 && ke.orientationIndex(D, B, E) === 0)
          return this._isProper = !0, (E.equals(B) || E.equals(D)) && (this._isProper = !1), this._result = g.POINT_INTERSECTION, null;
        this._result = g.NO_INTERSECTION;
      }, p.prototype.normalizeToMinimum = function(E, B, D, j, te) {
        te.x = this.smallestInAbsValue(E.x, B.x, D.x, j.x), te.y = this.smallestInAbsValue(E.y, B.y, D.y, j.y), E.x -= te.x, E.y -= te.y, B.x -= te.x, B.y -= te.y, D.x -= te.x, D.y -= te.y, j.x -= te.x, j.y -= te.y;
      }, p.prototype.safeHCoordinateIntersection = function(E, B, D, j) {
        var te = null;
        try {
          te = Ue.intersection(E, B, D, j);
        } catch (he) {
          if (!(he instanceof Se))
            throw he;
          te = p.nearestEndpoint(E, B, D, j);
        }
        return te;
      }, p.prototype.intersection = function(E, B, D, j) {
        var te = this.intersectionWithNormalization(E, B, D, j);
        return this.isInSegmentEnvelopes(te) || (te = new L(p.nearestEndpoint(E, B, D, j))), this._precisionModel !== null && this._precisionModel.makePrecise(te), te;
      }, p.prototype.smallestInAbsValue = function(E, B, D, j) {
        var te = E, he = Math.abs(te);
        return Math.abs(B) < he && (te = B, he = Math.abs(B)), Math.abs(D) < he && (te = D, he = Math.abs(D)), Math.abs(j) < he && (te = j), te;
      }, p.prototype.checkDD = function(E, B, D, j, te) {
        var he = Ce.intersection(E, B, D, j), ve = this.isInSegmentEnvelopes(he);
        De.out.println("DD in env = " + ve + "  --------------------- " + he), te.distance(he) > 1e-4 && De.out.println("Distance = " + te.distance(he));
      }, p.prototype.intersectionWithNormalization = function(E, B, D, j) {
        var te = new L(E), he = new L(B), ve = new L(D), Le = new L(j), Je = new L();
        this.normalizeToEnvCentre(te, he, ve, Le, Je);
        var et = this.safeHCoordinateIntersection(te, he, ve, Le);
        return et.x += Je.x, et.y += Je.y, et;
      }, p.prototype.computeCollinearIntersection = function(E, B, D, j) {
        var te = Te.intersects(E, B, D), he = Te.intersects(E, B, j), ve = Te.intersects(D, j, E), Le = Te.intersects(D, j, B);
        return te && he ? (this._intPt[0] = D, this._intPt[1] = j, g.COLLINEAR_INTERSECTION) : ve && Le ? (this._intPt[0] = E, this._intPt[1] = B, g.COLLINEAR_INTERSECTION) : te && ve ? (this._intPt[0] = D, this._intPt[1] = E, !D.equals(E) || he || Le ? g.COLLINEAR_INTERSECTION : g.POINT_INTERSECTION) : te && Le ? (this._intPt[0] = D, this._intPt[1] = B, !D.equals(B) || he || ve ? g.COLLINEAR_INTERSECTION : g.POINT_INTERSECTION) : he && ve ? (this._intPt[0] = j, this._intPt[1] = E, !j.equals(E) || te || Le ? g.COLLINEAR_INTERSECTION : g.POINT_INTERSECTION) : he && Le ? (this._intPt[0] = j, this._intPt[1] = B, !j.equals(B) || te || ve ? g.COLLINEAR_INTERSECTION : g.POINT_INTERSECTION) : g.NO_INTERSECTION;
      }, p.prototype.normalizeToEnvCentre = function(E, B, D, j, te) {
        var he = E.x < B.x ? E.x : B.x, ve = E.y < B.y ? E.y : B.y, Le = E.x > B.x ? E.x : B.x, Je = E.y > B.y ? E.y : B.y, et = D.x < j.x ? D.x : j.x, Ke = D.y < j.y ? D.y : j.y, ot = D.x > j.x ? D.x : j.x, je = D.y > j.y ? D.y : j.y, Et = ((he > et ? he : et) + (Le < ot ? Le : ot)) / 2, Gt = ((ve > Ke ? ve : Ke) + (Je < je ? Je : je)) / 2;
        te.x = Et, te.y = Gt, E.x -= te.x, E.y -= te.y, B.x -= te.x, B.y -= te.y, D.x -= te.x, D.y -= te.y, j.x -= te.x, j.y -= te.y;
      }, p.prototype.computeIntersect = function(E, B, D, j) {
        if (this._isProper = !1, !Te.intersects(E, B, D, j))
          return g.NO_INTERSECTION;
        var te = ke.orientationIndex(E, B, D), he = ke.orientationIndex(E, B, j);
        if (te > 0 && he > 0 || te < 0 && he < 0)
          return g.NO_INTERSECTION;
        var ve = ke.orientationIndex(D, j, E), Le = ke.orientationIndex(D, j, B);
        return ve > 0 && Le > 0 || ve < 0 && Le < 0 ? g.NO_INTERSECTION : te === 0 && he === 0 && ve === 0 && Le === 0 ? this.computeCollinearIntersection(E, B, D, j) : (te === 0 || he === 0 || ve === 0 || Le === 0 ? (this._isProper = !1, E.equals2D(D) || E.equals2D(j) ? this._intPt[0] = E : B.equals2D(D) || B.equals2D(j) ? this._intPt[0] = B : te === 0 ? this._intPt[0] = new L(D) : he === 0 ? this._intPt[0] = new L(j) : ve === 0 ? this._intPt[0] = new L(E) : Le === 0 && (this._intPt[0] = new L(B))) : (this._isProper = !0, this._intPt[0] = this.intersection(E, B, D, j)), g.POINT_INTERSECTION);
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p.nearestEndpoint = function(E, B, D, j) {
        var te = E, he = ke.distancePointLine(E, D, j), ve = ke.distancePointLine(B, D, j);
        return ve < he && (he = ve, te = B), (ve = ke.distancePointLine(D, E, B)) < he && (he = ve, te = D), (ve = ke.distancePointLine(j, E, B)) < he && (he = ve, te = j), te;
      }, p;
    }(Ae), Pe = function() {
    };
    Pe.prototype.interfaces_ = function() {
      return [];
    }, Pe.prototype.getClass = function() {
      return Pe;
    }, Pe.orientationIndex = function(g, p, E) {
      var B = p.x - g.x, D = p.y - g.y, j = E.x - p.x, te = E.y - p.y;
      return Pe.signOfDet2x2(B, D, j, te);
    }, Pe.signOfDet2x2 = function(g, p, E, B) {
      var D = null, j = null, te = null;
      if (D = 1, g === 0 || B === 0)
        return p === 0 || E === 0 ? 0 : p > 0 ? E > 0 ? -D : D : E > 0 ? D : -D;
      if (p === 0 || E === 0)
        return B > 0 ? g > 0 ? D : -D : g > 0 ? -D : D;
      if (p > 0 ? B > 0 ? p <= B || (D = -D, j = g, g = E, E = j, j = p, p = B, B = j) : p <= -B ? (D = -D, E = -E, B = -B) : (j = g, g = -E, E = j, j = p, p = -B, B = j) : B > 0 ? -p <= B ? (D = -D, g = -g, p = -p) : (j = -g, g = E, E = j, j = -p, p = B, B = j) : p >= B ? (g = -g, p = -p, E = -E, B = -B) : (D = -D, j = -g, g = -E, E = j, j = -p, p = -B, B = j), g > 0) {
        if (!(E > 0) || !(g <= E))
          return D;
      } else {
        if (E > 0 || !(g >= E))
          return -D;
        D = -D, g = -g, E = -E;
      }
      for (; ; ) {
        if (te = Math.floor(E / g), E -= te * g, (B -= te * p) < 0)
          return -D;
        if (B > p)
          return D;
        if (g > E + E) {
          if (p < B + B)
            return D;
        } else {
          if (p > B + B)
            return -D;
          E = g - E, B = p - B, D = -D;
        }
        if (B === 0)
          return E === 0 ? 0 : -D;
        if (E === 0 || (te = Math.floor(g / E), g -= te * E, (p -= te * B) < 0))
          return D;
        if (p > B)
          return -D;
        if (E > g + g) {
          if (B < p + p)
            return -D;
        } else {
          if (B > p + p)
            return D;
          g = E - g, p = B - p, D = -D;
        }
        if (p === 0)
          return g === 0 ? 0 : D;
        if (g === 0)
          return -D;
      }
    };
    var qe = function() {
      this._p = null, this._crossingCount = 0, this._isPointOnSegment = !1;
      var g = arguments[0];
      this._p = g;
    };
    qe.prototype.countSegment = function(g, p) {
      if (g.x < this._p.x && p.x < this._p.x)
        return null;
      if (this._p.x === p.x && this._p.y === p.y)
        return this._isPointOnSegment = !0, null;
      if (g.y === this._p.y && p.y === this._p.y) {
        var E = g.x, B = p.x;
        return E > B && (E = p.x, B = g.x), this._p.x >= E && this._p.x <= B && (this._isPointOnSegment = !0), null;
      }
      if (g.y > this._p.y && p.y <= this._p.y || p.y > this._p.y && g.y <= this._p.y) {
        var D = g.x - this._p.x, j = g.y - this._p.y, te = p.x - this._p.x, he = p.y - this._p.y, ve = Pe.signOfDet2x2(D, j, te, he);
        if (ve === 0)
          return this._isPointOnSegment = !0, null;
        he < j && (ve = -ve), ve > 0 && this._crossingCount++;
      }
    }, qe.prototype.isPointInPolygon = function() {
      return this.getLocation() !== U.EXTERIOR;
    }, qe.prototype.getLocation = function() {
      return this._isPointOnSegment ? U.BOUNDARY : this._crossingCount % 2 == 1 ? U.INTERIOR : U.EXTERIOR;
    }, qe.prototype.isOnSegment = function() {
      return this._isPointOnSegment;
    }, qe.prototype.interfaces_ = function() {
      return [];
    }, qe.prototype.getClass = function() {
      return qe;
    }, qe.locatePointInRing = function() {
      if (arguments[0] instanceof L && K(arguments[1], Ie)) {
        for (var g = arguments[0], p = arguments[1], E = new qe(g), B = new L(), D = new L(), j = 1; j < p.size(); j++)
          if (p.getCoordinate(j, B), p.getCoordinate(j - 1, D), E.countSegment(B, D), E.isOnSegment())
            return E.getLocation();
        return E.getLocation();
      }
      if (arguments[0] instanceof L && arguments[1] instanceof Array) {
        for (var te = arguments[0], he = arguments[1], ve = new qe(te), Le = 1; Le < he.length; Le++) {
          var Je = he[Le], et = he[Le - 1];
          if (ve.countSegment(Je, et), ve.isOnSegment())
            return ve.getLocation();
        }
        return ve.getLocation();
      }
    };
    var ke = function() {
    }, Xe = { CLOCKWISE: { configurable: !0 }, RIGHT: { configurable: !0 }, COUNTERCLOCKWISE: { configurable: !0 }, LEFT: { configurable: !0 }, COLLINEAR: { configurable: !0 }, STRAIGHT: { configurable: !0 } };
    ke.prototype.interfaces_ = function() {
      return [];
    }, ke.prototype.getClass = function() {
      return ke;
    }, ke.orientationIndex = function(g, p, E) {
      return Ce.orientationIndex(g, p, E);
    }, ke.signedArea = function() {
      if (arguments[0] instanceof Array) {
        var g = arguments[0];
        if (g.length < 3)
          return 0;
        for (var p = 0, E = g[0].x, B = 1; B < g.length - 1; B++) {
          var D = g[B].x - E, j = g[B + 1].y;
          p += D * (g[B - 1].y - j);
        }
        return p / 2;
      }
      if (K(arguments[0], Ie)) {
        var te = arguments[0], he = te.size();
        if (he < 3)
          return 0;
        var ve = new L(), Le = new L(), Je = new L();
        te.getCoordinate(0, Le), te.getCoordinate(1, Je);
        var et = Le.x;
        Je.x -= et;
        for (var Ke = 0, ot = 1; ot < he - 1; ot++)
          ve.y = Le.y, Le.x = Je.x, Le.y = Je.y, te.getCoordinate(ot + 1, Je), Je.x -= et, Ke += Le.x * (ve.y - Je.y);
        return Ke / 2;
      }
    }, ke.distanceLineLine = function(g, p, E, B) {
      if (g.equals(p))
        return ke.distancePointLine(g, E, B);
      if (E.equals(B))
        return ke.distancePointLine(B, g, p);
      var D = !1;
      if (Te.intersects(g, p, E, B)) {
        var j = (p.x - g.x) * (B.y - E.y) - (p.y - g.y) * (B.x - E.x);
        if (j === 0)
          D = !0;
        else {
          var te = (g.y - E.y) * (B.x - E.x) - (g.x - E.x) * (B.y - E.y), he = ((g.y - E.y) * (p.x - g.x) - (g.x - E.x) * (p.y - g.y)) / j, ve = te / j;
          (ve < 0 || ve > 1 || he < 0 || he > 1) && (D = !0);
        }
      } else
        D = !0;
      return D ? z.min(ke.distancePointLine(g, E, B), ke.distancePointLine(p, E, B), ke.distancePointLine(E, g, p), ke.distancePointLine(B, g, p)) : 0;
    }, ke.isPointInRing = function(g, p) {
      return ke.locatePointInRing(g, p) !== U.EXTERIOR;
    }, ke.computeLength = function(g) {
      var p = g.size();
      if (p <= 1)
        return 0;
      var E = 0, B = new L();
      g.getCoordinate(0, B);
      for (var D = B.x, j = B.y, te = 1; te < p; te++) {
        g.getCoordinate(te, B);
        var he = B.x, ve = B.y, Le = he - D, Je = ve - j;
        E += Math.sqrt(Le * Le + Je * Je), D = he, j = ve;
      }
      return E;
    }, ke.isCCW = function(g) {
      var p = g.length - 1;
      if (p < 3)
        throw new b("Ring has fewer than 4 points, so orientation cannot be determined");
      for (var E = g[0], B = 0, D = 1; D <= p; D++) {
        var j = g[D];
        j.y > E.y && (E = j, B = D);
      }
      var te = B;
      do
        (te -= 1) < 0 && (te = p);
      while (g[te].equals2D(E) && te !== B);
      var he = B;
      do
        he = (he + 1) % p;
      while (g[he].equals2D(E) && he !== B);
      var ve = g[te], Le = g[he];
      if (ve.equals2D(E) || Le.equals2D(E) || ve.equals2D(Le))
        return !1;
      var Je = ke.computeOrientation(ve, E, Le), et = !1;
      return et = Je === 0 ? ve.x > Le.x : Je > 0, et;
    }, ke.locatePointInRing = function(g, p) {
      return qe.locatePointInRing(g, p);
    }, ke.distancePointLinePerpendicular = function(g, p, E) {
      var B = (E.x - p.x) * (E.x - p.x) + (E.y - p.y) * (E.y - p.y), D = ((p.y - g.y) * (E.x - p.x) - (p.x - g.x) * (E.y - p.y)) / B;
      return Math.abs(D) * Math.sqrt(B);
    }, ke.computeOrientation = function(g, p, E) {
      return ke.orientationIndex(g, p, E);
    }, ke.distancePointLine = function() {
      if (arguments.length === 2) {
        var g = arguments[0], p = arguments[1];
        if (p.length === 0)
          throw new b("Line array must contain at least one vertex");
        for (var E = g.distance(p[0]), B = 0; B < p.length - 1; B++) {
          var D = ke.distancePointLine(g, p[B], p[B + 1]);
          D < E && (E = D);
        }
        return E;
      }
      if (arguments.length === 3) {
        var j = arguments[0], te = arguments[1], he = arguments[2];
        if (te.x === he.x && te.y === he.y)
          return j.distance(te);
        var ve = (he.x - te.x) * (he.x - te.x) + (he.y - te.y) * (he.y - te.y), Le = ((j.x - te.x) * (he.x - te.x) + (j.y - te.y) * (he.y - te.y)) / ve;
        if (Le <= 0)
          return j.distance(te);
        if (Le >= 1)
          return j.distance(he);
        var Je = ((te.y - j.y) * (he.x - te.x) - (te.x - j.x) * (he.y - te.y)) / ve;
        return Math.abs(Je) * Math.sqrt(ve);
      }
    }, ke.isOnLine = function(g, p) {
      for (var E = new we(), B = 1; B < p.length; B++) {
        var D = p[B - 1], j = p[B];
        if (E.computeIntersection(g, D, j), E.hasIntersection())
          return !0;
      }
      return !1;
    }, Xe.CLOCKWISE.get = function() {
      return -1;
    }, Xe.RIGHT.get = function() {
      return ke.CLOCKWISE;
    }, Xe.COUNTERCLOCKWISE.get = function() {
      return 1;
    }, Xe.LEFT.get = function() {
      return ke.COUNTERCLOCKWISE;
    }, Xe.COLLINEAR.get = function() {
      return 0;
    }, Xe.STRAIGHT.get = function() {
      return ke.COLLINEAR;
    }, Object.defineProperties(ke, Xe);
    var rt = function() {
    };
    rt.prototype.filter = function(g) {
    }, rt.prototype.interfaces_ = function() {
      return [];
    }, rt.prototype.getClass = function() {
      return rt;
    };
    var it = function() {
      var g = arguments[0];
      this._envelope = null, this._factory = null, this._SRID = null, this._userData = null, this._factory = g, this._SRID = g.getSRID();
    }, ht = { serialVersionUID: { configurable: !0 }, SORTINDEX_POINT: { configurable: !0 }, SORTINDEX_MULTIPOINT: { configurable: !0 }, SORTINDEX_LINESTRING: { configurable: !0 }, SORTINDEX_LINEARRING: { configurable: !0 }, SORTINDEX_MULTILINESTRING: { configurable: !0 }, SORTINDEX_POLYGON: { configurable: !0 }, SORTINDEX_MULTIPOLYGON: { configurable: !0 }, SORTINDEX_GEOMETRYCOLLECTION: { configurable: !0 }, geometryChangedFilter: { configurable: !0 } };
    it.prototype.isGeometryCollection = function() {
      return this.getSortIndex() === it.SORTINDEX_GEOMETRYCOLLECTION;
    }, it.prototype.getFactory = function() {
      return this._factory;
    }, it.prototype.getGeometryN = function(g) {
      return this;
    }, it.prototype.getArea = function() {
      return 0;
    }, it.prototype.isRectangle = function() {
      return !1;
    }, it.prototype.equals = function() {
      if (arguments[0] instanceof it) {
        var g = arguments[0];
        return g !== null && this.equalsTopo(g);
      }
      if (arguments[0] instanceof Object) {
        var p = arguments[0];
        if (!(p instanceof it))
          return !1;
        var E = p;
        return this.equalsExact(E);
      }
    }, it.prototype.equalsExact = function(g) {
      return this === g || this.equalsExact(g, 0);
    }, it.prototype.geometryChanged = function() {
      this.apply(it.geometryChangedFilter);
    }, it.prototype.geometryChangedAction = function() {
      this._envelope = null;
    }, it.prototype.equalsNorm = function(g) {
      return g !== null && this.norm().equalsExact(g.norm());
    }, it.prototype.getLength = function() {
      return 0;
    }, it.prototype.getNumGeometries = function() {
      return 1;
    }, it.prototype.compareTo = function() {
      if (arguments.length === 1) {
        var g = arguments[0], p = g;
        return this.getSortIndex() !== p.getSortIndex() ? this.getSortIndex() - p.getSortIndex() : this.isEmpty() && p.isEmpty() ? 0 : this.isEmpty() ? -1 : p.isEmpty() ? 1 : this.compareToSameClass(g);
      }
      if (arguments.length === 2) {
        var E = arguments[0], B = arguments[1];
        return this.getSortIndex() !== E.getSortIndex() ? this.getSortIndex() - E.getSortIndex() : this.isEmpty() && E.isEmpty() ? 0 : this.isEmpty() ? -1 : E.isEmpty() ? 1 : this.compareToSameClass(E, B);
      }
    }, it.prototype.getUserData = function() {
      return this._userData;
    }, it.prototype.getSRID = function() {
      return this._SRID;
    }, it.prototype.getEnvelope = function() {
      return this.getFactory().toGeometry(this.getEnvelopeInternal());
    }, it.prototype.checkNotGeometryCollection = function(g) {
      if (g.getSortIndex() === it.SORTINDEX_GEOMETRYCOLLECTION)
        throw new b("This method does not support GeometryCollection arguments");
    }, it.prototype.equal = function(g, p, E) {
      return E === 0 ? g.equals(p) : g.distance(p) <= E;
    }, it.prototype.norm = function() {
      var g = this.copy();
      return g.normalize(), g;
    }, it.prototype.getPrecisionModel = function() {
      return this._factory.getPrecisionModel();
    }, it.prototype.getEnvelopeInternal = function() {
      return this._envelope === null && (this._envelope = this.computeEnvelopeInternal()), new Te(this._envelope);
    }, it.prototype.setSRID = function(g) {
      this._SRID = g;
    }, it.prototype.setUserData = function(g) {
      this._userData = g;
    }, it.prototype.compare = function(g, p) {
      for (var E = g.iterator(), B = p.iterator(); E.hasNext() && B.hasNext(); ) {
        var D = E.next(), j = B.next(), te = D.compareTo(j);
        if (te !== 0)
          return te;
      }
      return E.hasNext() ? 1 : B.hasNext() ? -1 : 0;
    }, it.prototype.hashCode = function() {
      return this.getEnvelopeInternal().hashCode();
    }, it.prototype.isGeometryCollectionOrDerived = function() {
      return this.getSortIndex() === it.SORTINDEX_GEOMETRYCOLLECTION || this.getSortIndex() === it.SORTINDEX_MULTIPOINT || this.getSortIndex() === it.SORTINDEX_MULTILINESTRING || this.getSortIndex() === it.SORTINDEX_MULTIPOLYGON;
    }, it.prototype.interfaces_ = function() {
      return [M, R, r];
    }, it.prototype.getClass = function() {
      return it;
    }, it.hasNonEmptyElements = function(g) {
      for (var p = 0; p < g.length; p++)
        if (!g[p].isEmpty())
          return !0;
      return !1;
    }, it.hasNullElements = function(g) {
      for (var p = 0; p < g.length; p++)
        if (g[p] === null)
          return !0;
      return !1;
    }, ht.serialVersionUID.get = function() {
      return 8763622679187377e3;
    }, ht.SORTINDEX_POINT.get = function() {
      return 0;
    }, ht.SORTINDEX_MULTIPOINT.get = function() {
      return 1;
    }, ht.SORTINDEX_LINESTRING.get = function() {
      return 2;
    }, ht.SORTINDEX_LINEARRING.get = function() {
      return 3;
    }, ht.SORTINDEX_MULTILINESTRING.get = function() {
      return 4;
    }, ht.SORTINDEX_POLYGON.get = function() {
      return 5;
    }, ht.SORTINDEX_MULTIPOLYGON.get = function() {
      return 6;
    }, ht.SORTINDEX_GEOMETRYCOLLECTION.get = function() {
      return 7;
    }, ht.geometryChangedFilter.get = function() {
      return mt;
    }, Object.defineProperties(it, ht);
    var mt = function() {
    };
    mt.interfaces_ = function() {
      return [rt];
    }, mt.filter = function(g) {
      g.geometryChangedAction();
    };
    var _t = function() {
    };
    _t.prototype.filter = function(g) {
    }, _t.prototype.interfaces_ = function() {
      return [];
    }, _t.prototype.getClass = function() {
      return _t;
    };
    var Ct = function() {
    }, zt = { Mod2BoundaryNodeRule: { configurable: !0 }, EndPointBoundaryNodeRule: { configurable: !0 }, MultiValentEndPointBoundaryNodeRule: { configurable: !0 }, MonoValentEndPointBoundaryNodeRule: { configurable: !0 }, MOD2_BOUNDARY_RULE: { configurable: !0 }, ENDPOINT_BOUNDARY_RULE: { configurable: !0 }, MULTIVALENT_ENDPOINT_BOUNDARY_RULE: { configurable: !0 }, MONOVALENT_ENDPOINT_BOUNDARY_RULE: { configurable: !0 }, OGC_SFS_BOUNDARY_RULE: { configurable: !0 } };
    Ct.prototype.isInBoundary = function(g) {
    }, Ct.prototype.interfaces_ = function() {
      return [];
    }, Ct.prototype.getClass = function() {
      return Ct;
    }, zt.Mod2BoundaryNodeRule.get = function() {
      return jt;
    }, zt.EndPointBoundaryNodeRule.get = function() {
      return lt;
    }, zt.MultiValentEndPointBoundaryNodeRule.get = function() {
      return Ht;
    }, zt.MonoValentEndPointBoundaryNodeRule.get = function() {
      return vt;
    }, zt.MOD2_BOUNDARY_RULE.get = function() {
      return new jt();
    }, zt.ENDPOINT_BOUNDARY_RULE.get = function() {
      return new lt();
    }, zt.MULTIVALENT_ENDPOINT_BOUNDARY_RULE.get = function() {
      return new Ht();
    }, zt.MONOVALENT_ENDPOINT_BOUNDARY_RULE.get = function() {
      return new vt();
    }, zt.OGC_SFS_BOUNDARY_RULE.get = function() {
      return Ct.MOD2_BOUNDARY_RULE;
    }, Object.defineProperties(Ct, zt);
    var jt = function() {
    };
    jt.prototype.isInBoundary = function(g) {
      return g % 2 == 1;
    }, jt.prototype.interfaces_ = function() {
      return [Ct];
    }, jt.prototype.getClass = function() {
      return jt;
    };
    var lt = function() {
    };
    lt.prototype.isInBoundary = function(g) {
      return g > 0;
    }, lt.prototype.interfaces_ = function() {
      return [Ct];
    }, lt.prototype.getClass = function() {
      return lt;
    };
    var Ht = function() {
    };
    Ht.prototype.isInBoundary = function(g) {
      return g > 1;
    }, Ht.prototype.interfaces_ = function() {
      return [Ct];
    }, Ht.prototype.getClass = function() {
      return Ht;
    };
    var vt = function() {
    };
    vt.prototype.isInBoundary = function(g) {
      return g === 1;
    }, vt.prototype.interfaces_ = function() {
      return [Ct];
    }, vt.prototype.getClass = function() {
      return vt;
    };
    var It = function() {
    };
    It.prototype.add = function() {
    }, It.prototype.addAll = function() {
    }, It.prototype.isEmpty = function() {
    }, It.prototype.iterator = function() {
    }, It.prototype.size = function() {
    }, It.prototype.toArray = function() {
    }, It.prototype.remove = function() {
    }, (i.prototype = new Error()).name = "IndexOutOfBoundsException";
    var un = function() {
    };
    un.prototype.hasNext = function() {
    }, un.prototype.next = function() {
    }, un.prototype.remove = function() {
    };
    var hn = function(g) {
      function p() {
        g.apply(this, arguments);
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.get = function() {
      }, p.prototype.set = function() {
      }, p.prototype.isEmpty = function() {
      }, p;
    }(It);
    (o.prototype = new Error()).name = "NoSuchElementException";
    var We = function(g) {
      function p() {
        g.call(this), this.array_ = [], arguments[0] instanceof It && this.addAll(arguments[0]);
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.ensureCapacity = function() {
      }, p.prototype.interfaces_ = function() {
        return [g, It];
      }, p.prototype.add = function(E) {
        return arguments.length === 1 ? this.array_.push(E) : this.array_.splice(arguments[0], arguments[1]), !0;
      }, p.prototype.clear = function() {
        this.array_ = [];
      }, p.prototype.addAll = function(E) {
        for (var B = E.iterator(); B.hasNext(); )
          this.add(B.next());
        return !0;
      }, p.prototype.set = function(E, B) {
        var D = this.array_[E];
        return this.array_[E] = B, D;
      }, p.prototype.iterator = function() {
        return new En(this);
      }, p.prototype.get = function(E) {
        if (E < 0 || E >= this.size())
          throw new i();
        return this.array_[E];
      }, p.prototype.isEmpty = function() {
        return this.array_.length === 0;
      }, p.prototype.size = function() {
        return this.array_.length;
      }, p.prototype.toArray = function() {
        for (var E = [], B = 0, D = this.array_.length; B < D; B++)
          E.push(this.array_[B]);
        return E;
      }, p.prototype.remove = function(E) {
        for (var B = !1, D = 0, j = this.array_.length; D < j; D++)
          if (this.array_[D] === E) {
            this.array_.splice(D, 1), B = !0;
            break;
          }
        return B;
      }, p;
    }(hn), En = function(g) {
      function p(E) {
        g.call(this), this.arrayList_ = E, this.position_ = 0;
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.next = function() {
        if (this.position_ === this.arrayList_.size())
          throw new o();
        return this.arrayList_.get(this.position_++);
      }, p.prototype.hasNext = function() {
        return this.position_ < this.arrayList_.size();
      }, p.prototype.set = function(E) {
        return this.arrayList_.set(this.position_ - 1, E);
      }, p.prototype.remove = function() {
        this.arrayList_.remove(this.arrayList_.get(this.position_));
      }, p;
    }(un), qn = function(g) {
      function p() {
        if (g.call(this), arguments.length !== 0) {
          if (arguments.length === 1) {
            var B = arguments[0];
            this.ensureCapacity(B.length), this.add(B, !0);
          } else if (arguments.length === 2) {
            var D = arguments[0], j = arguments[1];
            this.ensureCapacity(D.length), this.add(D, j);
          }
        }
      }
      g && (p.__proto__ = g), (p.prototype = Object.create(g && g.prototype)).constructor = p;
      var E = { coordArrayType: { configurable: !0 } };
      return E.coordArrayType.get = function() {
        return new Array(0).fill(null);
      }, p.prototype.getCoordinate = function(B) {
        return this.get(B);
      }, p.prototype.addAll = function() {
        if (arguments.length === 2) {
          for (var B = arguments[0], D = arguments[1], j = !1, te = B.iterator(); te.hasNext(); )
            this.add(te.next(), D), j = !0;
          return j;
        }
        return g.prototype.addAll.apply(this, arguments);
      }, p.prototype.clone = function() {
        for (var B = g.prototype.clone.call(this), D = 0; D < this.size(); D++)
          B.add(D, this.get(D).copy());
        return B;
      }, p.prototype.toCoordinateArray = function() {
        return this.toArray(p.coordArrayType);
      }, p.prototype.add = function() {
        if (arguments.length === 1) {
          var B = arguments[0];
          g.prototype.add.call(this, B);
        } else if (arguments.length === 2) {
          if (arguments[0] instanceof Array && typeof arguments[1] == "boolean") {
            var D = arguments[0], j = arguments[1];
            return this.add(D, j, !0), !0;
          }
          if (arguments[0] instanceof L && typeof arguments[1] == "boolean") {
            var te = arguments[0];
            if (!arguments[1] && this.size() >= 1 && this.get(this.size() - 1).equals2D(te))
              return null;
            g.prototype.add.call(this, te);
          } else if (arguments[0] instanceof Object && typeof arguments[1] == "boolean") {
            var he = arguments[0], ve = arguments[1];
            return this.add(he, ve), !0;
          }
        } else if (arguments.length === 3) {
          if (typeof arguments[2] == "boolean" && arguments[0] instanceof Array && typeof arguments[1] == "boolean") {
            var Le = arguments[0], Je = arguments[1];
            if (arguments[2])
              for (var et = 0; et < Le.length; et++)
                this.add(Le[et], Je);
            else
              for (var Ke = Le.length - 1; Ke >= 0; Ke--)
                this.add(Le[Ke], Je);
            return !0;
          }
          if (typeof arguments[2] == "boolean" && Number.isInteger(arguments[0]) && arguments[1] instanceof L) {
            var ot = arguments[0], je = arguments[1];
            if (!arguments[2]) {
              var Et = this.size();
              if (Et > 0 && (ot > 0 && this.get(ot - 1).equals2D(je) || ot < Et && this.get(ot).equals2D(je)))
                return null;
            }
            g.prototype.add.call(this, ot, je);
          }
        } else if (arguments.length === 4) {
          var Gt = arguments[0], kt = arguments[1], bt = arguments[2], Yn = arguments[3], Hr = 1;
          bt > Yn && (Hr = -1);
          for (var li = bt; li !== Yn; li += Hr)
            this.add(Gt[li], kt);
          return !0;
        }
      }, p.prototype.closeRing = function() {
        this.size() > 0 && this.add(new L(this.get(0)), !1);
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, Object.defineProperties(p, E), p;
    }(We), Pt = function() {
    }, dr = { ForwardComparator: { configurable: !0 }, BidirectionalComparator: { configurable: !0 }, coordArrayType: { configurable: !0 } };
    dr.ForwardComparator.get = function() {
      return yr;
    }, dr.BidirectionalComparator.get = function() {
      return jn;
    }, dr.coordArrayType.get = function() {
      return new Array(0).fill(null);
    }, Pt.prototype.interfaces_ = function() {
      return [];
    }, Pt.prototype.getClass = function() {
      return Pt;
    }, Pt.isRing = function(g) {
      return !(g.length < 4) && !!g[0].equals2D(g[g.length - 1]);
    }, Pt.ptNotInList = function(g, p) {
      for (var E = 0; E < g.length; E++) {
        var B = g[E];
        if (Pt.indexOf(B, p) < 0)
          return B;
      }
      return null;
    }, Pt.scroll = function(g, p) {
      var E = Pt.indexOf(p, g);
      if (E < 0)
        return null;
      var B = new Array(g.length).fill(null);
      De.arraycopy(g, E, B, 0, g.length - E), De.arraycopy(g, 0, B, g.length - E, E), De.arraycopy(B, 0, g, 0, g.length);
    }, Pt.equals = function() {
      if (arguments.length === 2) {
        var g = arguments[0], p = arguments[1];
        if (g === p)
          return !0;
        if (g === null || p === null || g.length !== p.length)
          return !1;
        for (var E = 0; E < g.length; E++)
          if (!g[E].equals(p[E]))
            return !1;
        return !0;
      }
      if (arguments.length === 3) {
        var B = arguments[0], D = arguments[1], j = arguments[2];
        if (B === D)
          return !0;
        if (B === null || D === null || B.length !== D.length)
          return !1;
        for (var te = 0; te < B.length; te++)
          if (j.compare(B[te], D[te]) !== 0)
            return !1;
        return !0;
      }
    }, Pt.intersection = function(g, p) {
      for (var E = new qn(), B = 0; B < g.length; B++)
        p.intersects(g[B]) && E.add(g[B], !0);
      return E.toCoordinateArray();
    }, Pt.hasRepeatedPoints = function(g) {
      for (var p = 1; p < g.length; p++)
        if (g[p - 1].equals(g[p]))
          return !0;
      return !1;
    }, Pt.removeRepeatedPoints = function(g) {
      return Pt.hasRepeatedPoints(g) ? new qn(g, !1).toCoordinateArray() : g;
    }, Pt.reverse = function(g) {
      for (var p = g.length - 1, E = Math.trunc(p / 2), B = 0; B <= E; B++) {
        var D = g[B];
        g[B] = g[p - B], g[p - B] = D;
      }
    }, Pt.removeNull = function(g) {
      for (var p = 0, E = 0; E < g.length; E++)
        g[E] !== null && p++;
      var B = new Array(p).fill(null);
      if (p === 0)
        return B;
      for (var D = 0, j = 0; j < g.length; j++)
        g[j] !== null && (B[D++] = g[j]);
      return B;
    }, Pt.copyDeep = function() {
      if (arguments.length === 1) {
        for (var g = arguments[0], p = new Array(g.length).fill(null), E = 0; E < g.length; E++)
          p[E] = new L(g[E]);
        return p;
      }
      if (arguments.length === 5)
        for (var B = arguments[0], D = arguments[1], j = arguments[2], te = arguments[3], he = arguments[4], ve = 0; ve < he; ve++)
          j[te + ve] = new L(B[D + ve]);
    }, Pt.isEqualReversed = function(g, p) {
      for (var E = 0; E < g.length; E++) {
        var B = g[E], D = p[g.length - E - 1];
        if (B.compareTo(D) !== 0)
          return !1;
      }
      return !0;
    }, Pt.envelope = function(g) {
      for (var p = new Te(), E = 0; E < g.length; E++)
        p.expandToInclude(g[E]);
      return p;
    }, Pt.toCoordinateArray = function(g) {
      return g.toArray(Pt.coordArrayType);
    }, Pt.atLeastNCoordinatesOrNothing = function(g, p) {
      return p.length >= g ? p : [];
    }, Pt.indexOf = function(g, p) {
      for (var E = 0; E < p.length; E++)
        if (g.equals(p[E]))
          return E;
      return -1;
    }, Pt.increasingDirection = function(g) {
      for (var p = 0; p < Math.trunc(g.length / 2); p++) {
        var E = g.length - 1 - p, B = g[p].compareTo(g[E]);
        if (B !== 0)
          return B;
      }
      return 1;
    }, Pt.compare = function(g, p) {
      for (var E = 0; E < g.length && E < p.length; ) {
        var B = g[E].compareTo(p[E]);
        if (B !== 0)
          return B;
        E++;
      }
      return E < p.length ? -1 : E < g.length ? 1 : 0;
    }, Pt.minCoordinate = function(g) {
      for (var p = null, E = 0; E < g.length; E++)
        (p === null || p.compareTo(g[E]) > 0) && (p = g[E]);
      return p;
    }, Pt.extract = function(g, p, E) {
      p = z.clamp(p, 0, g.length);
      var B = (E = z.clamp(E, -1, g.length)) - p + 1;
      E < 0 && (B = 0), p >= g.length && (B = 0), E < p && (B = 0);
      var D = new Array(B).fill(null);
      if (B === 0)
        return D;
      for (var j = 0, te = p; te <= E; te++)
        D[j++] = g[te];
      return D;
    }, Object.defineProperties(Pt, dr);
    var yr = function() {
    };
    yr.prototype.compare = function(g, p) {
      return Pt.compare(g, p);
    }, yr.prototype.interfaces_ = function() {
      return [O];
    }, yr.prototype.getClass = function() {
      return yr;
    };
    var jn = function() {
    };
    jn.prototype.compare = function(g, p) {
      var E = g, B = p;
      if (E.length < B.length)
        return -1;
      if (E.length > B.length)
        return 1;
      if (E.length === 0)
        return 0;
      var D = Pt.compare(E, B);
      return Pt.isEqualReversed(E, B) ? 0 : D;
    }, jn.prototype.OLDcompare = function(g, p) {
      var E = g, B = p;
      if (E.length < B.length)
        return -1;
      if (E.length > B.length)
        return 1;
      if (E.length === 0)
        return 0;
      for (var D = Pt.increasingDirection(E), j = Pt.increasingDirection(B), te = D > 0 ? 0 : E.length - 1, he = j > 0 ? 0 : E.length - 1, ve = 0; ve < E.length; ve++) {
        var Le = E[te].compareTo(B[he]);
        if (Le !== 0)
          return Le;
        te += D, he += j;
      }
      return 0;
    }, jn.prototype.interfaces_ = function() {
      return [O];
    }, jn.prototype.getClass = function() {
      return jn;
    };
    var Ot = function() {
    };
    Ot.prototype.get = function() {
    }, Ot.prototype.put = function() {
    }, Ot.prototype.size = function() {
    }, Ot.prototype.values = function() {
    }, Ot.prototype.entrySet = function() {
    };
    var yn = function(g) {
      function p() {
        g.apply(this, arguments);
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p;
    }(Ot);
    (s.prototype = new Error()).name = "OperationNotSupported", (a.prototype = new It()).contains = function() {
    };
    var Fn = function(g) {
      function p() {
        g.call(this), this.array_ = [], arguments[0] instanceof It && this.addAll(arguments[0]);
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.contains = function(E) {
        for (var B = 0, D = this.array_.length; B < D; B++)
          if (this.array_[B] === E)
            return !0;
        return !1;
      }, p.prototype.add = function(E) {
        return !this.contains(E) && (this.array_.push(E), !0);
      }, p.prototype.addAll = function(E) {
        for (var B = E.iterator(); B.hasNext(); )
          this.add(B.next());
        return !0;
      }, p.prototype.remove = function(E) {
        throw new Error();
      }, p.prototype.size = function() {
        return this.array_.length;
      }, p.prototype.isEmpty = function() {
        return this.array_.length === 0;
      }, p.prototype.toArray = function() {
        for (var E = [], B = 0, D = this.array_.length; B < D; B++)
          E.push(this.array_[B]);
        return E;
      }, p.prototype.iterator = function() {
        return new xn(this);
      }, p;
    }(a), xn = function(g) {
      function p(E) {
        g.call(this), this.hashSet_ = E, this.position_ = 0;
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.next = function() {
        if (this.position_ === this.hashSet_.size())
          throw new o();
        return this.hashSet_.array_[this.position_++];
      }, p.prototype.hasNext = function() {
        return this.position_ < this.hashSet_.size();
      }, p.prototype.remove = function() {
        throw new s();
      }, p;
    }(un), vn = 0;
    (h.prototype = new yn()).get = function(g) {
      for (var p = this.root_; p !== null; ) {
        var E = g.compareTo(p.key);
        if (E < 0)
          p = p.left;
        else {
          if (!(E > 0))
            return p.value;
          p = p.right;
        }
      }
      return null;
    }, h.prototype.put = function(g, p) {
      if (this.root_ === null)
        return this.root_ = { key: g, value: p, left: null, right: null, parent: null, color: vn, getValue: function() {
          return this.value;
        }, getKey: function() {
          return this.key;
        } }, this.size_ = 1, null;
      var E, B, D = this.root_;
      do
        if (E = D, (B = g.compareTo(D.key)) < 0)
          D = D.left;
        else {
          if (!(B > 0)) {
            var j = D.value;
            return D.value = p, j;
          }
          D = D.right;
        }
      while (D !== null);
      var te = { key: g, left: null, right: null, value: p, parent: E, color: vn, getValue: function() {
        return this.value;
      }, getKey: function() {
        return this.key;
      } };
      return B < 0 ? E.left = te : E.right = te, this.fixAfterInsertion(te), this.size_++, null;
    }, h.prototype.fixAfterInsertion = function(g) {
      for (g.color = 1; g != null && g !== this.root_ && g.parent.color === 1; )
        if (l(g) === u(l(l(g)))) {
          var p = f(l(l(g)));
          A(p) === 1 ? (c(l(g), vn), c(p, vn), c(l(l(g)), 1), g = l(l(g))) : (g === f(l(g)) && (g = l(g), this.rotateLeft(g)), c(l(g), vn), c(l(l(g)), 1), this.rotateRight(l(l(g))));
        } else {
          var E = u(l(l(g)));
          A(E) === 1 ? (c(l(g), vn), c(E, vn), c(l(l(g)), 1), g = l(l(g))) : (g === u(l(g)) && (g = l(g), this.rotateRight(g)), c(l(g), vn), c(l(l(g)), 1), this.rotateLeft(l(l(g))));
        }
      this.root_.color = vn;
    }, h.prototype.values = function() {
      var g = new We(), p = this.getFirstEntry();
      if (p !== null)
        for (g.add(p.value); (p = h.successor(p)) !== null; )
          g.add(p.value);
      return g;
    }, h.prototype.entrySet = function() {
      var g = new Fn(), p = this.getFirstEntry();
      if (p !== null)
        for (g.add(p); (p = h.successor(p)) !== null; )
          g.add(p);
      return g;
    }, h.prototype.rotateLeft = function(g) {
      if (g != null) {
        var p = g.right;
        g.right = p.left, p.left != null && (p.left.parent = g), p.parent = g.parent, g.parent === null ? this.root_ = p : g.parent.left === g ? g.parent.left = p : g.parent.right = p, p.left = g, g.parent = p;
      }
    }, h.prototype.rotateRight = function(g) {
      if (g != null) {
        var p = g.left;
        g.left = p.right, p.right != null && (p.right.parent = g), p.parent = g.parent, g.parent === null ? this.root_ = p : g.parent.right === g ? g.parent.right = p : g.parent.left = p, p.right = g, g.parent = p;
      }
    }, h.prototype.getFirstEntry = function() {
      var g = this.root_;
      if (g != null)
        for (; g.left != null; )
          g = g.left;
      return g;
    }, h.successor = function(g) {
      if (g === null)
        return null;
      if (g.right !== null) {
        for (var p = g.right; p.left !== null; )
          p = p.left;
        return p;
      }
      for (var E = g.parent, B = g; E !== null && B === E.right; )
        B = E, E = E.parent;
      return E;
    }, h.prototype.size = function() {
      return this.size_;
    };
    var nt = function() {
    };
    nt.prototype.interfaces_ = function() {
      return [];
    }, nt.prototype.getClass = function() {
      return nt;
    }, d.prototype = new a(), (I.prototype = new d()).contains = function(g) {
      for (var p = 0, E = this.array_.length; p < E; p++)
        if (this.array_[p].compareTo(g) === 0)
          return !0;
      return !1;
    }, I.prototype.add = function(g) {
      if (this.contains(g))
        return !1;
      for (var p = 0, E = this.array_.length; p < E; p++)
        if (this.array_[p].compareTo(g) === 1)
          return this.array_.splice(p, 0, g), !0;
      return this.array_.push(g), !0;
    }, I.prototype.addAll = function(g) {
      for (var p = g.iterator(); p.hasNext(); )
        this.add(p.next());
      return !0;
    }, I.prototype.remove = function(g) {
      throw new s();
    }, I.prototype.size = function() {
      return this.array_.length;
    }, I.prototype.isEmpty = function() {
      return this.array_.length === 0;
    }, I.prototype.toArray = function() {
      for (var g = [], p = 0, E = this.array_.length; p < E; p++)
        g.push(this.array_[p]);
      return g;
    }, I.prototype.iterator = function() {
      return new st(this);
    };
    var st = function(g) {
      this.treeSet_ = g, this.position_ = 0;
    };
    st.prototype.next = function() {
      if (this.position_ === this.treeSet_.size())
        throw new o();
      return this.treeSet_.array_[this.position_++];
    }, st.prototype.hasNext = function() {
      return this.position_ < this.treeSet_.size();
    }, st.prototype.remove = function() {
      throw new s();
    };
    var xt = function() {
    };
    xt.sort = function() {
      var g, p, E, B, D = arguments[0];
      if (arguments.length === 1)
        B = function(te, he) {
          return te.compareTo(he);
        }, D.sort(B);
      else if (arguments.length === 2)
        E = arguments[1], B = function(te, he) {
          return E.compare(te, he);
        }, D.sort(B);
      else if (arguments.length === 3) {
        (p = D.slice(arguments[1], arguments[2])).sort();
        var j = D.slice(0, arguments[1]).concat(p, D.slice(arguments[2], D.length));
        for (D.splice(0, D.length), g = 0; g < j.length; g++)
          D.push(j[g]);
      } else if (arguments.length === 4)
        for (p = D.slice(arguments[1], arguments[2]), E = arguments[3], B = function(te, he) {
          return E.compare(te, he);
        }, p.sort(B), j = D.slice(0, arguments[1]).concat(p, D.slice(arguments[2], D.length)), D.splice(0, D.length), g = 0; g < j.length; g++)
          D.push(j[g]);
    }, xt.asList = function(g) {
      for (var p = new We(), E = 0, B = g.length; E < B; E++)
        p.add(g[E]);
      return p;
    };
    var Me = function() {
    }, _ = { P: { configurable: !0 }, L: { configurable: !0 }, A: { configurable: !0 }, FALSE: { configurable: !0 }, TRUE: { configurable: !0 }, DONTCARE: { configurable: !0 }, SYM_FALSE: { configurable: !0 }, SYM_TRUE: { configurable: !0 }, SYM_DONTCARE: { configurable: !0 }, SYM_P: { configurable: !0 }, SYM_L: { configurable: !0 }, SYM_A: { configurable: !0 } };
    _.P.get = function() {
      return 0;
    }, _.L.get = function() {
      return 1;
    }, _.A.get = function() {
      return 2;
    }, _.FALSE.get = function() {
      return -1;
    }, _.TRUE.get = function() {
      return -2;
    }, _.DONTCARE.get = function() {
      return -3;
    }, _.SYM_FALSE.get = function() {
      return "F";
    }, _.SYM_TRUE.get = function() {
      return "T";
    }, _.SYM_DONTCARE.get = function() {
      return "*";
    }, _.SYM_P.get = function() {
      return "0";
    }, _.SYM_L.get = function() {
      return "1";
    }, _.SYM_A.get = function() {
      return "2";
    }, Me.prototype.interfaces_ = function() {
      return [];
    }, Me.prototype.getClass = function() {
      return Me;
    }, Me.toDimensionSymbol = function(g) {
      switch (g) {
        case Me.FALSE:
          return Me.SYM_FALSE;
        case Me.TRUE:
          return Me.SYM_TRUE;
        case Me.DONTCARE:
          return Me.SYM_DONTCARE;
        case Me.P:
          return Me.SYM_P;
        case Me.L:
          return Me.SYM_L;
        case Me.A:
          return Me.SYM_A;
      }
      throw new b("Unknown dimension value: " + g);
    }, Me.toDimensionValue = function(g) {
      switch (ce.toUpperCase(g)) {
        case Me.SYM_FALSE:
          return Me.FALSE;
        case Me.SYM_TRUE:
          return Me.TRUE;
        case Me.SYM_DONTCARE:
          return Me.DONTCARE;
        case Me.SYM_P:
          return Me.P;
        case Me.SYM_L:
          return Me.L;
        case Me.SYM_A:
          return Me.A;
      }
      throw new b("Unknown dimension symbol: " + g);
    }, Object.defineProperties(Me, _);
    var ye = function() {
    };
    ye.prototype.filter = function(g) {
    }, ye.prototype.interfaces_ = function() {
      return [];
    }, ye.prototype.getClass = function() {
      return ye;
    };
    var He = function() {
    };
    He.prototype.filter = function(g, p) {
    }, He.prototype.isDone = function() {
    }, He.prototype.isGeometryChanged = function() {
    }, He.prototype.interfaces_ = function() {
      return [];
    }, He.prototype.getClass = function() {
      return He;
    };
    var ze = function(g) {
      function p(B, D) {
        if (g.call(this, D), this._geometries = B || [], g.hasNullElements(this._geometries))
          throw new b("geometries must not contain null elements");
      }
      g && (p.__proto__ = g), (p.prototype = Object.create(g && g.prototype)).constructor = p;
      var E = { serialVersionUID: { configurable: !0 } };
      return p.prototype.computeEnvelopeInternal = function() {
        for (var B = new Te(), D = 0; D < this._geometries.length; D++)
          B.expandToInclude(this._geometries[D].getEnvelopeInternal());
        return B;
      }, p.prototype.getGeometryN = function(B) {
        return this._geometries[B];
      }, p.prototype.getSortIndex = function() {
        return g.SORTINDEX_GEOMETRYCOLLECTION;
      }, p.prototype.getCoordinates = function() {
        for (var B = new Array(this.getNumPoints()).fill(null), D = -1, j = 0; j < this._geometries.length; j++)
          for (var te = this._geometries[j].getCoordinates(), he = 0; he < te.length; he++)
            B[++D] = te[he];
        return B;
      }, p.prototype.getArea = function() {
        for (var B = 0, D = 0; D < this._geometries.length; D++)
          B += this._geometries[D].getArea();
        return B;
      }, p.prototype.equalsExact = function() {
        if (arguments.length === 2) {
          var B = arguments[0], D = arguments[1];
          if (!this.isEquivalentClass(B))
            return !1;
          var j = B;
          if (this._geometries.length !== j._geometries.length)
            return !1;
          for (var te = 0; te < this._geometries.length; te++)
            if (!this._geometries[te].equalsExact(j._geometries[te], D))
              return !1;
          return !0;
        }
        return g.prototype.equalsExact.apply(this, arguments);
      }, p.prototype.normalize = function() {
        for (var B = 0; B < this._geometries.length; B++)
          this._geometries[B].normalize();
        xt.sort(this._geometries);
      }, p.prototype.getCoordinate = function() {
        return this.isEmpty() ? null : this._geometries[0].getCoordinate();
      }, p.prototype.getBoundaryDimension = function() {
        for (var B = Me.FALSE, D = 0; D < this._geometries.length; D++)
          B = Math.max(B, this._geometries[D].getBoundaryDimension());
        return B;
      }, p.prototype.getDimension = function() {
        for (var B = Me.FALSE, D = 0; D < this._geometries.length; D++)
          B = Math.max(B, this._geometries[D].getDimension());
        return B;
      }, p.prototype.getLength = function() {
        for (var B = 0, D = 0; D < this._geometries.length; D++)
          B += this._geometries[D].getLength();
        return B;
      }, p.prototype.getNumPoints = function() {
        for (var B = 0, D = 0; D < this._geometries.length; D++)
          B += this._geometries[D].getNumPoints();
        return B;
      }, p.prototype.getNumGeometries = function() {
        return this._geometries.length;
      }, p.prototype.reverse = function() {
        for (var B = this._geometries.length, D = new Array(B).fill(null), j = 0; j < this._geometries.length; j++)
          D[j] = this._geometries[j].reverse();
        return this.getFactory().createGeometryCollection(D);
      }, p.prototype.compareToSameClass = function() {
        if (arguments.length === 1) {
          var B = arguments[0], D = new I(xt.asList(this._geometries)), j = new I(xt.asList(B._geometries));
          return this.compare(D, j);
        }
        if (arguments.length === 2) {
          for (var te = arguments[0], he = arguments[1], ve = te, Le = this.getNumGeometries(), Je = ve.getNumGeometries(), et = 0; et < Le && et < Je; ) {
            var Ke = this.getGeometryN(et), ot = ve.getGeometryN(et), je = Ke.compareToSameClass(ot, he);
            if (je !== 0)
              return je;
            et++;
          }
          return et < Le ? 1 : et < Je ? -1 : 0;
        }
      }, p.prototype.apply = function() {
        if (K(arguments[0], _t))
          for (var B = arguments[0], D = 0; D < this._geometries.length; D++)
            this._geometries[D].apply(B);
        else if (K(arguments[0], He)) {
          var j = arguments[0];
          if (this._geometries.length === 0)
            return null;
          for (var te = 0; te < this._geometries.length && (this._geometries[te].apply(j), !j.isDone()); te++)
            ;
          j.isGeometryChanged() && this.geometryChanged();
        } else if (K(arguments[0], ye)) {
          var he = arguments[0];
          he.filter(this);
          for (var ve = 0; ve < this._geometries.length; ve++)
            this._geometries[ve].apply(he);
        } else if (K(arguments[0], rt)) {
          var Le = arguments[0];
          Le.filter(this);
          for (var Je = 0; Je < this._geometries.length; Je++)
            this._geometries[Je].apply(Le);
        }
      }, p.prototype.getBoundary = function() {
        return this.checkNotGeometryCollection(this), ie.shouldNeverReachHere(), null;
      }, p.prototype.clone = function() {
        var B = g.prototype.clone.call(this);
        B._geometries = new Array(this._geometries.length).fill(null);
        for (var D = 0; D < this._geometries.length; D++)
          B._geometries[D] = this._geometries[D].clone();
        return B;
      }, p.prototype.getGeometryType = function() {
        return "GeometryCollection";
      }, p.prototype.copy = function() {
        for (var B = new Array(this._geometries.length).fill(null), D = 0; D < B.length; D++)
          B[D] = this._geometries[D].copy();
        return new p(B, this._factory);
      }, p.prototype.isEmpty = function() {
        for (var B = 0; B < this._geometries.length; B++)
          if (!this._geometries[B].isEmpty())
            return !1;
        return !0;
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, E.serialVersionUID.get = function() {
        return -5694727726395021e3;
      }, Object.defineProperties(p, E), p;
    }(it), tt = function(g) {
      function p() {
        g.apply(this, arguments);
      }
      g && (p.__proto__ = g), (p.prototype = Object.create(g && g.prototype)).constructor = p;
      var E = { serialVersionUID: { configurable: !0 } };
      return p.prototype.getSortIndex = function() {
        return it.SORTINDEX_MULTILINESTRING;
      }, p.prototype.equalsExact = function() {
        if (arguments.length === 2) {
          var B = arguments[0], D = arguments[1];
          return !!this.isEquivalentClass(B) && g.prototype.equalsExact.call(this, B, D);
        }
        return g.prototype.equalsExact.apply(this, arguments);
      }, p.prototype.getBoundaryDimension = function() {
        return this.isClosed() ? Me.FALSE : 0;
      }, p.prototype.isClosed = function() {
        if (this.isEmpty())
          return !1;
        for (var B = 0; B < this._geometries.length; B++)
          if (!this._geometries[B].isClosed())
            return !1;
        return !0;
      }, p.prototype.getDimension = function() {
        return 1;
      }, p.prototype.reverse = function() {
        for (var B = this._geometries.length, D = new Array(B).fill(null), j = 0; j < this._geometries.length; j++)
          D[B - 1 - j] = this._geometries[j].reverse();
        return this.getFactory().createMultiLineString(D);
      }, p.prototype.getBoundary = function() {
        return new At(this).getBoundary();
      }, p.prototype.getGeometryType = function() {
        return "MultiLineString";
      }, p.prototype.copy = function() {
        for (var B = new Array(this._geometries.length).fill(null), D = 0; D < B.length; D++)
          B[D] = this._geometries[D].copy();
        return new p(B, this._factory);
      }, p.prototype.interfaces_ = function() {
        return [nt];
      }, p.prototype.getClass = function() {
        return p;
      }, E.serialVersionUID.get = function() {
        return 8166665132445434e3;
      }, Object.defineProperties(p, E), p;
    }(ze), At = function() {
      if (this._geom = null, this._geomFact = null, this._bnRule = null, this._endpointMap = null, arguments.length === 1) {
        var g = arguments[0], p = Ct.MOD2_BOUNDARY_RULE;
        this._geom = g, this._geomFact = g.getFactory(), this._bnRule = p;
      } else if (arguments.length === 2) {
        var E = arguments[0], B = arguments[1];
        this._geom = E, this._geomFact = E.getFactory(), this._bnRule = B;
      }
    };
    At.prototype.boundaryMultiLineString = function(g) {
      if (this._geom.isEmpty())
        return this.getEmptyMultiPoint();
      var p = this.computeBoundaryCoordinates(g);
      return p.length === 1 ? this._geomFact.createPoint(p[0]) : this._geomFact.createMultiPointFromCoords(p);
    }, At.prototype.getBoundary = function() {
      return this._geom instanceof rn ? this.boundaryLineString(this._geom) : this._geom instanceof tt ? this.boundaryMultiLineString(this._geom) : this._geom.getBoundary();
    }, At.prototype.boundaryLineString = function(g) {
      return this._geom.isEmpty() ? this.getEmptyMultiPoint() : g.isClosed() ? this._bnRule.isInBoundary(2) ? g.getStartPoint() : this._geomFact.createMultiPoint() : this._geomFact.createMultiPoint([g.getStartPoint(), g.getEndPoint()]);
    }, At.prototype.getEmptyMultiPoint = function() {
      return this._geomFact.createMultiPoint();
    }, At.prototype.computeBoundaryCoordinates = function(g) {
      var p = new We();
      this._endpointMap = new h();
      for (var E = 0; E < g.getNumGeometries(); E++) {
        var B = g.getGeometryN(E);
        B.getNumPoints() !== 0 && (this.addEndpoint(B.getCoordinateN(0)), this.addEndpoint(B.getCoordinateN(B.getNumPoints() - 1)));
      }
      for (var D = this._endpointMap.entrySet().iterator(); D.hasNext(); ) {
        var j = D.next(), te = j.getValue().count;
        this._bnRule.isInBoundary(te) && p.add(j.getKey());
      }
      return Pt.toCoordinateArray(p);
    }, At.prototype.addEndpoint = function(g) {
      var p = this._endpointMap.get(g);
      p === null && (p = new pt(), this._endpointMap.put(g, p)), p.count++;
    }, At.prototype.interfaces_ = function() {
      return [];
    }, At.prototype.getClass = function() {
      return At;
    }, At.getBoundary = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return new At(g).getBoundary();
      }
      if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        return new At(p, E).getBoundary();
      }
    };
    var pt = function() {
      this.count = null;
    };
    pt.prototype.interfaces_ = function() {
      return [];
    }, pt.prototype.getClass = function() {
      return pt;
    };
    var Bt = function() {
    }, Rt = { NEWLINE: { configurable: !0 }, SIMPLE_ORDINATE_FORMAT: { configurable: !0 } };
    Bt.prototype.interfaces_ = function() {
      return [];
    }, Bt.prototype.getClass = function() {
      return Bt;
    }, Bt.chars = function(g, p) {
      for (var E = new Array(p).fill(null), B = 0; B < p; B++)
        E[B] = g;
      return String(E);
    }, Bt.getStackTrace = function() {
      if (arguments.length === 1) {
        var g = arguments[0], p = new function() {
        }(), E = new function() {
        }();
        return g.printStackTrace(E), p.toString();
      }
      if (arguments.length === 2) {
        for (var B = arguments[0], D = arguments[1], j = "", te = new function() {
        }(new function() {
        }(Bt.getStackTrace(B))), he = 0; he < D; he++)
          try {
            j += te.readLine() + Bt.NEWLINE;
          } catch (ve) {
            if (!(ve instanceof m))
              throw ve;
            ie.shouldNeverReachHere();
          }
        return j;
      }
    }, Bt.split = function(g, p) {
      for (var E = p.length, B = new We(), D = "" + g, j = D.indexOf(p); j >= 0; ) {
        var te = D.substring(0, j);
        B.add(te), j = (D = D.substring(j + E)).indexOf(p);
      }
      D.length > 0 && B.add(D);
      for (var he = new Array(B.size()).fill(null), ve = 0; ve < he.length; ve++)
        he[ve] = B.get(ve);
      return he;
    }, Bt.toString = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return Bt.SIMPLE_ORDINATE_FORMAT.format(g);
      }
    }, Bt.spaces = function(g) {
      return Bt.chars(" ", g);
    }, Rt.NEWLINE.get = function() {
      return De.getProperty("line.separator");
    }, Rt.SIMPLE_ORDINATE_FORMAT.get = function() {
      return new function() {
      }();
    }, Object.defineProperties(Bt, Rt);
    var Lt = function() {
    };
    Lt.prototype.interfaces_ = function() {
      return [];
    }, Lt.prototype.getClass = function() {
      return Lt;
    }, Lt.copyCoord = function(g, p, E, B) {
      for (var D = Math.min(g.getDimension(), E.getDimension()), j = 0; j < D; j++)
        E.setOrdinate(B, j, g.getOrdinate(p, j));
    }, Lt.isRing = function(g) {
      var p = g.size();
      return p === 0 || !(p <= 3) && g.getOrdinate(0, Ie.X) === g.getOrdinate(p - 1, Ie.X) && g.getOrdinate(0, Ie.Y) === g.getOrdinate(p - 1, Ie.Y);
    }, Lt.isEqual = function(g, p) {
      var E = g.size();
      if (E !== p.size())
        return !1;
      for (var B = Math.min(g.getDimension(), p.getDimension()), D = 0; D < E; D++)
        for (var j = 0; j < B; j++) {
          var te = g.getOrdinate(D, j), he = p.getOrdinate(D, j);
          if (g.getOrdinate(D, j) !== p.getOrdinate(D, j) && (!Q.isNaN(te) || !Q.isNaN(he)))
            return !1;
        }
      return !0;
    }, Lt.extend = function(g, p, E) {
      var B = g.create(E, p.getDimension()), D = p.size();
      if (Lt.copy(p, 0, B, 0, D), D > 0)
        for (var j = D; j < E; j++)
          Lt.copy(p, D - 1, B, j, 1);
      return B;
    }, Lt.reverse = function(g) {
      for (var p = g.size() - 1, E = Math.trunc(p / 2), B = 0; B <= E; B++)
        Lt.swap(g, B, p - B);
    }, Lt.swap = function(g, p, E) {
      if (p === E)
        return null;
      for (var B = 0; B < g.getDimension(); B++) {
        var D = g.getOrdinate(p, B);
        g.setOrdinate(p, B, g.getOrdinate(E, B)), g.setOrdinate(E, B, D);
      }
    }, Lt.copy = function(g, p, E, B, D) {
      for (var j = 0; j < D; j++)
        Lt.copyCoord(g, p + j, E, B + j);
    }, Lt.toString = function() {
      if (arguments.length === 1) {
        var g = arguments[0], p = g.size();
        if (p === 0)
          return "()";
        var E = g.getDimension(), B = new V();
        B.append("(");
        for (var D = 0; D < p; D++) {
          D > 0 && B.append(" ");
          for (var j = 0; j < E; j++)
            j > 0 && B.append(","), B.append(Bt.toString(g.getOrdinate(D, j)));
        }
        return B.append(")"), B.toString();
      }
    }, Lt.ensureValidRing = function(g, p) {
      var E = p.size();
      return E === 0 ? p : E <= 3 ? Lt.createClosedRing(g, p, 4) : p.getOrdinate(0, Ie.X) === p.getOrdinate(E - 1, Ie.X) && p.getOrdinate(0, Ie.Y) === p.getOrdinate(E - 1, Ie.Y) ? p : Lt.createClosedRing(g, p, E + 1);
    }, Lt.createClosedRing = function(g, p, E) {
      var B = g.create(E, p.getDimension()), D = p.size();
      Lt.copy(p, 0, B, 0, D);
      for (var j = D; j < E; j++)
        Lt.copy(p, 0, B, j, 1);
      return B;
    };
    var rn = function(g) {
      function p(B, D) {
        g.call(this, D), this._points = null, this.init(B);
      }
      g && (p.__proto__ = g), (p.prototype = Object.create(g && g.prototype)).constructor = p;
      var E = { serialVersionUID: { configurable: !0 } };
      return p.prototype.computeEnvelopeInternal = function() {
        return this.isEmpty() ? new Te() : this._points.expandEnvelope(new Te());
      }, p.prototype.isRing = function() {
        return this.isClosed() && this.isSimple();
      }, p.prototype.getSortIndex = function() {
        return g.SORTINDEX_LINESTRING;
      }, p.prototype.getCoordinates = function() {
        return this._points.toCoordinateArray();
      }, p.prototype.equalsExact = function() {
        if (arguments.length === 2) {
          var B = arguments[0], D = arguments[1];
          if (!this.isEquivalentClass(B))
            return !1;
          var j = B;
          if (this._points.size() !== j._points.size())
            return !1;
          for (var te = 0; te < this._points.size(); te++)
            if (!this.equal(this._points.getCoordinate(te), j._points.getCoordinate(te), D))
              return !1;
          return !0;
        }
        return g.prototype.equalsExact.apply(this, arguments);
      }, p.prototype.normalize = function() {
        for (var B = 0; B < Math.trunc(this._points.size() / 2); B++) {
          var D = this._points.size() - 1 - B;
          if (!this._points.getCoordinate(B).equals(this._points.getCoordinate(D)))
            return this._points.getCoordinate(B).compareTo(this._points.getCoordinate(D)) > 0 && Lt.reverse(this._points), null;
        }
      }, p.prototype.getCoordinate = function() {
        return this.isEmpty() ? null : this._points.getCoordinate(0);
      }, p.prototype.getBoundaryDimension = function() {
        return this.isClosed() ? Me.FALSE : 0;
      }, p.prototype.isClosed = function() {
        return !this.isEmpty() && this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints() - 1));
      }, p.prototype.getEndPoint = function() {
        return this.isEmpty() ? null : this.getPointN(this.getNumPoints() - 1);
      }, p.prototype.getDimension = function() {
        return 1;
      }, p.prototype.getLength = function() {
        return ke.computeLength(this._points);
      }, p.prototype.getNumPoints = function() {
        return this._points.size();
      }, p.prototype.reverse = function() {
        var B = this._points.copy();
        return Lt.reverse(B), this.getFactory().createLineString(B);
      }, p.prototype.compareToSameClass = function() {
        if (arguments.length === 1) {
          for (var B = arguments[0], D = 0, j = 0; D < this._points.size() && j < B._points.size(); ) {
            var te = this._points.getCoordinate(D).compareTo(B._points.getCoordinate(j));
            if (te !== 0)
              return te;
            D++, j++;
          }
          return D < this._points.size() ? 1 : j < B._points.size() ? -1 : 0;
        }
        if (arguments.length === 2) {
          var he = arguments[0];
          return arguments[1].compare(this._points, he._points);
        }
      }, p.prototype.apply = function() {
        if (K(arguments[0], _t))
          for (var B = arguments[0], D = 0; D < this._points.size(); D++)
            B.filter(this._points.getCoordinate(D));
        else if (K(arguments[0], He)) {
          var j = arguments[0];
          if (this._points.size() === 0)
            return null;
          for (var te = 0; te < this._points.size() && (j.filter(this._points, te), !j.isDone()); te++)
            ;
          j.isGeometryChanged() && this.geometryChanged();
        } else
          K(arguments[0], ye) ? arguments[0].filter(this) : K(arguments[0], rt) && arguments[0].filter(this);
      }, p.prototype.getBoundary = function() {
        return new At(this).getBoundary();
      }, p.prototype.isEquivalentClass = function(B) {
        return B instanceof p;
      }, p.prototype.clone = function() {
        var B = g.prototype.clone.call(this);
        return B._points = this._points.clone(), B;
      }, p.prototype.getCoordinateN = function(B) {
        return this._points.getCoordinate(B);
      }, p.prototype.getGeometryType = function() {
        return "LineString";
      }, p.prototype.copy = function() {
        return new p(this._points.copy(), this._factory);
      }, p.prototype.getCoordinateSequence = function() {
        return this._points;
      }, p.prototype.isEmpty = function() {
        return this._points.size() === 0;
      }, p.prototype.init = function(B) {
        if (B === null && (B = this.getFactory().getCoordinateSequenceFactory().create([])), B.size() === 1)
          throw new b("Invalid number of points in LineString (found " + B.size() + " - must be 0 or >= 2)");
        this._points = B;
      }, p.prototype.isCoordinate = function(B) {
        for (var D = 0; D < this._points.size(); D++)
          if (this._points.getCoordinate(D).equals(B))
            return !0;
        return !1;
      }, p.prototype.getStartPoint = function() {
        return this.isEmpty() ? null : this.getPointN(0);
      }, p.prototype.getPointN = function(B) {
        return this.getFactory().createPoint(this._points.getCoordinate(B));
      }, p.prototype.interfaces_ = function() {
        return [nt];
      }, p.prototype.getClass = function() {
        return p;
      }, E.serialVersionUID.get = function() {
        return 3110669828065365500;
      }, Object.defineProperties(p, E), p;
    }(it), Wr = function() {
    };
    Wr.prototype.interfaces_ = function() {
      return [];
    }, Wr.prototype.getClass = function() {
      return Wr;
    };
    var pr = function(g) {
      function p(B, D) {
        g.call(this, D), this._coordinates = B || null, this.init(this._coordinates);
      }
      g && (p.__proto__ = g), (p.prototype = Object.create(g && g.prototype)).constructor = p;
      var E = { serialVersionUID: { configurable: !0 } };
      return p.prototype.computeEnvelopeInternal = function() {
        if (this.isEmpty())
          return new Te();
        var B = new Te();
        return B.expandToInclude(this._coordinates.getX(0), this._coordinates.getY(0)), B;
      }, p.prototype.getSortIndex = function() {
        return g.SORTINDEX_POINT;
      }, p.prototype.getCoordinates = function() {
        return this.isEmpty() ? [] : [this.getCoordinate()];
      }, p.prototype.equalsExact = function() {
        if (arguments.length === 2) {
          var B = arguments[0], D = arguments[1];
          return !!this.isEquivalentClass(B) && (!(!this.isEmpty() || !B.isEmpty()) || this.isEmpty() === B.isEmpty() && this.equal(B.getCoordinate(), this.getCoordinate(), D));
        }
        return g.prototype.equalsExact.apply(this, arguments);
      }, p.prototype.normalize = function() {
      }, p.prototype.getCoordinate = function() {
        return this._coordinates.size() !== 0 ? this._coordinates.getCoordinate(0) : null;
      }, p.prototype.getBoundaryDimension = function() {
        return Me.FALSE;
      }, p.prototype.getDimension = function() {
        return 0;
      }, p.prototype.getNumPoints = function() {
        return this.isEmpty() ? 0 : 1;
      }, p.prototype.reverse = function() {
        return this.copy();
      }, p.prototype.getX = function() {
        if (this.getCoordinate() === null)
          throw new Error("getX called on empty Point");
        return this.getCoordinate().x;
      }, p.prototype.compareToSameClass = function() {
        if (arguments.length === 1) {
          var B = arguments[0];
          return this.getCoordinate().compareTo(B.getCoordinate());
        }
        if (arguments.length === 2) {
          var D = arguments[0];
          return arguments[1].compare(this._coordinates, D._coordinates);
        }
      }, p.prototype.apply = function() {
        if (K(arguments[0], _t)) {
          var B = arguments[0];
          if (this.isEmpty())
            return null;
          B.filter(this.getCoordinate());
        } else if (K(arguments[0], He)) {
          var D = arguments[0];
          if (this.isEmpty())
            return null;
          D.filter(this._coordinates, 0), D.isGeometryChanged() && this.geometryChanged();
        } else
          K(arguments[0], ye) ? arguments[0].filter(this) : K(arguments[0], rt) && arguments[0].filter(this);
      }, p.prototype.getBoundary = function() {
        return this.getFactory().createGeometryCollection(null);
      }, p.prototype.clone = function() {
        var B = g.prototype.clone.call(this);
        return B._coordinates = this._coordinates.clone(), B;
      }, p.prototype.getGeometryType = function() {
        return "Point";
      }, p.prototype.copy = function() {
        return new p(this._coordinates.copy(), this._factory);
      }, p.prototype.getCoordinateSequence = function() {
        return this._coordinates;
      }, p.prototype.getY = function() {
        if (this.getCoordinate() === null)
          throw new Error("getY called on empty Point");
        return this.getCoordinate().y;
      }, p.prototype.isEmpty = function() {
        return this._coordinates.size() === 0;
      }, p.prototype.init = function(B) {
        B === null && (B = this.getFactory().getCoordinateSequenceFactory().create([])), ie.isTrue(B.size() <= 1), this._coordinates = B;
      }, p.prototype.isSimple = function() {
        return !0;
      }, p.prototype.interfaces_ = function() {
        return [Wr];
      }, p.prototype.getClass = function() {
        return p;
      }, E.serialVersionUID.get = function() {
        return 4902022702746615e3;
      }, Object.defineProperties(p, E), p;
    }(it), Vt = function() {
    };
    Vt.prototype.interfaces_ = function() {
      return [];
    }, Vt.prototype.getClass = function() {
      return Vt;
    };
    var Sn = function(g) {
      function p(B, D, j) {
        if (g.call(this, j), this._shell = null, this._holes = null, B === null && (B = this.getFactory().createLinearRing()), D === null && (D = []), g.hasNullElements(D))
          throw new b("holes must not contain null elements");
        if (B.isEmpty() && g.hasNonEmptyElements(D))
          throw new b("shell is empty but holes are not");
        this._shell = B, this._holes = D;
      }
      g && (p.__proto__ = g), (p.prototype = Object.create(g && g.prototype)).constructor = p;
      var E = { serialVersionUID: { configurable: !0 } };
      return p.prototype.computeEnvelopeInternal = function() {
        return this._shell.getEnvelopeInternal();
      }, p.prototype.getSortIndex = function() {
        return g.SORTINDEX_POLYGON;
      }, p.prototype.getCoordinates = function() {
        if (this.isEmpty())
          return [];
        for (var B = new Array(this.getNumPoints()).fill(null), D = -1, j = this._shell.getCoordinates(), te = 0; te < j.length; te++)
          B[++D] = j[te];
        for (var he = 0; he < this._holes.length; he++)
          for (var ve = this._holes[he].getCoordinates(), Le = 0; Le < ve.length; Le++)
            B[++D] = ve[Le];
        return B;
      }, p.prototype.getArea = function() {
        var B = 0;
        B += Math.abs(ke.signedArea(this._shell.getCoordinateSequence()));
        for (var D = 0; D < this._holes.length; D++)
          B -= Math.abs(ke.signedArea(this._holes[D].getCoordinateSequence()));
        return B;
      }, p.prototype.isRectangle = function() {
        if (this.getNumInteriorRing() !== 0 || this._shell === null || this._shell.getNumPoints() !== 5)
          return !1;
        for (var B = this._shell.getCoordinateSequence(), D = this.getEnvelopeInternal(), j = 0; j < 5; j++) {
          var te = B.getX(j);
          if (te !== D.getMinX() && te !== D.getMaxX())
            return !1;
          var he = B.getY(j);
          if (he !== D.getMinY() && he !== D.getMaxY())
            return !1;
        }
        for (var ve = B.getX(0), Le = B.getY(0), Je = 1; Je <= 4; Je++) {
          var et = B.getX(Je), Ke = B.getY(Je);
          if (et !== ve == (Ke !== Le))
            return !1;
          ve = et, Le = Ke;
        }
        return !0;
      }, p.prototype.equalsExact = function() {
        if (arguments.length === 2) {
          var B = arguments[0], D = arguments[1];
          if (!this.isEquivalentClass(B))
            return !1;
          var j = B, te = this._shell, he = j._shell;
          if (!te.equalsExact(he, D) || this._holes.length !== j._holes.length)
            return !1;
          for (var ve = 0; ve < this._holes.length; ve++)
            if (!this._holes[ve].equalsExact(j._holes[ve], D))
              return !1;
          return !0;
        }
        return g.prototype.equalsExact.apply(this, arguments);
      }, p.prototype.normalize = function() {
        if (arguments.length === 0) {
          this.normalize(this._shell, !0);
          for (var B = 0; B < this._holes.length; B++)
            this.normalize(this._holes[B], !1);
          xt.sort(this._holes);
        } else if (arguments.length === 2) {
          var D = arguments[0], j = arguments[1];
          if (D.isEmpty())
            return null;
          var te = new Array(D.getCoordinates().length - 1).fill(null);
          De.arraycopy(D.getCoordinates(), 0, te, 0, te.length);
          var he = Pt.minCoordinate(D.getCoordinates());
          Pt.scroll(te, he), De.arraycopy(te, 0, D.getCoordinates(), 0, te.length), D.getCoordinates()[te.length] = te[0], ke.isCCW(D.getCoordinates()) === j && Pt.reverse(D.getCoordinates());
        }
      }, p.prototype.getCoordinate = function() {
        return this._shell.getCoordinate();
      }, p.prototype.getNumInteriorRing = function() {
        return this._holes.length;
      }, p.prototype.getBoundaryDimension = function() {
        return 1;
      }, p.prototype.getDimension = function() {
        return 2;
      }, p.prototype.getLength = function() {
        var B = 0;
        B += this._shell.getLength();
        for (var D = 0; D < this._holes.length; D++)
          B += this._holes[D].getLength();
        return B;
      }, p.prototype.getNumPoints = function() {
        for (var B = this._shell.getNumPoints(), D = 0; D < this._holes.length; D++)
          B += this._holes[D].getNumPoints();
        return B;
      }, p.prototype.reverse = function() {
        var B = this.copy();
        B._shell = this._shell.copy().reverse(), B._holes = new Array(this._holes.length).fill(null);
        for (var D = 0; D < this._holes.length; D++)
          B._holes[D] = this._holes[D].copy().reverse();
        return B;
      }, p.prototype.convexHull = function() {
        return this.getExteriorRing().convexHull();
      }, p.prototype.compareToSameClass = function() {
        if (arguments.length === 1) {
          var B = arguments[0], D = this._shell, j = B._shell;
          return D.compareToSameClass(j);
        }
        if (arguments.length === 2) {
          var te = arguments[0], he = arguments[1], ve = te, Le = this._shell, Je = ve._shell, et = Le.compareToSameClass(Je, he);
          if (et !== 0)
            return et;
          for (var Ke = this.getNumInteriorRing(), ot = ve.getNumInteriorRing(), je = 0; je < Ke && je < ot; ) {
            var Et = this.getInteriorRingN(je), Gt = ve.getInteriorRingN(je), kt = Et.compareToSameClass(Gt, he);
            if (kt !== 0)
              return kt;
            je++;
          }
          return je < Ke ? 1 : je < ot ? -1 : 0;
        }
      }, p.prototype.apply = function(B) {
        if (K(B, _t)) {
          this._shell.apply(B);
          for (var D = 0; D < this._holes.length; D++)
            this._holes[D].apply(B);
        } else if (K(B, He)) {
          if (this._shell.apply(B), !B.isDone())
            for (var j = 0; j < this._holes.length && (this._holes[j].apply(B), !B.isDone()); j++)
              ;
          B.isGeometryChanged() && this.geometryChanged();
        } else if (K(B, ye))
          B.filter(this);
        else if (K(B, rt)) {
          B.filter(this), this._shell.apply(B);
          for (var te = 0; te < this._holes.length; te++)
            this._holes[te].apply(B);
        }
      }, p.prototype.getBoundary = function() {
        if (this.isEmpty())
          return this.getFactory().createMultiLineString();
        var B = new Array(this._holes.length + 1).fill(null);
        B[0] = this._shell;
        for (var D = 0; D < this._holes.length; D++)
          B[D + 1] = this._holes[D];
        return B.length <= 1 ? this.getFactory().createLinearRing(B[0].getCoordinateSequence()) : this.getFactory().createMultiLineString(B);
      }, p.prototype.clone = function() {
        var B = g.prototype.clone.call(this);
        B._shell = this._shell.clone(), B._holes = new Array(this._holes.length).fill(null);
        for (var D = 0; D < this._holes.length; D++)
          B._holes[D] = this._holes[D].clone();
        return B;
      }, p.prototype.getGeometryType = function() {
        return "Polygon";
      }, p.prototype.copy = function() {
        for (var B = this._shell.copy(), D = new Array(this._holes.length).fill(null), j = 0; j < D.length; j++)
          D[j] = this._holes[j].copy();
        return new p(B, D, this._factory);
      }, p.prototype.getExteriorRing = function() {
        return this._shell;
      }, p.prototype.isEmpty = function() {
        return this._shell.isEmpty();
      }, p.prototype.getInteriorRingN = function(B) {
        return this._holes[B];
      }, p.prototype.interfaces_ = function() {
        return [Vt];
      }, p.prototype.getClass = function() {
        return p;
      }, E.serialVersionUID.get = function() {
        return -3494792200821764600;
      }, Object.defineProperties(p, E), p;
    }(it), kn = function(g) {
      function p() {
        g.apply(this, arguments);
      }
      g && (p.__proto__ = g), (p.prototype = Object.create(g && g.prototype)).constructor = p;
      var E = { serialVersionUID: { configurable: !0 } };
      return p.prototype.getSortIndex = function() {
        return it.SORTINDEX_MULTIPOINT;
      }, p.prototype.isValid = function() {
        return !0;
      }, p.prototype.equalsExact = function() {
        if (arguments.length === 2) {
          var B = arguments[0], D = arguments[1];
          return !!this.isEquivalentClass(B) && g.prototype.equalsExact.call(this, B, D);
        }
        return g.prototype.equalsExact.apply(this, arguments);
      }, p.prototype.getCoordinate = function() {
        if (arguments.length === 1) {
          var B = arguments[0];
          return this._geometries[B].getCoordinate();
        }
        return g.prototype.getCoordinate.apply(this, arguments);
      }, p.prototype.getBoundaryDimension = function() {
        return Me.FALSE;
      }, p.prototype.getDimension = function() {
        return 0;
      }, p.prototype.getBoundary = function() {
        return this.getFactory().createGeometryCollection(null);
      }, p.prototype.getGeometryType = function() {
        return "MultiPoint";
      }, p.prototype.copy = function() {
        for (var B = new Array(this._geometries.length).fill(null), D = 0; D < B.length; D++)
          B[D] = this._geometries[D].copy();
        return new p(B, this._factory);
      }, p.prototype.interfaces_ = function() {
        return [Wr];
      }, p.prototype.getClass = function() {
        return p;
      }, E.serialVersionUID.get = function() {
        return -8048474874175356e3;
      }, Object.defineProperties(p, E), p;
    }(ze), vr = function(g) {
      function p(B, D) {
        B instanceof L && D instanceof or && (B = D.getCoordinateSequenceFactory().create(B)), g.call(this, B, D), this.validateConstruction();
      }
      g && (p.__proto__ = g), (p.prototype = Object.create(g && g.prototype)).constructor = p;
      var E = { MINIMUM_VALID_SIZE: { configurable: !0 }, serialVersionUID: { configurable: !0 } };
      return p.prototype.getSortIndex = function() {
        return it.SORTINDEX_LINEARRING;
      }, p.prototype.getBoundaryDimension = function() {
        return Me.FALSE;
      }, p.prototype.isClosed = function() {
        return !!this.isEmpty() || g.prototype.isClosed.call(this);
      }, p.prototype.reverse = function() {
        var B = this._points.copy();
        return Lt.reverse(B), this.getFactory().createLinearRing(B);
      }, p.prototype.validateConstruction = function() {
        if (!this.isEmpty() && !g.prototype.isClosed.call(this))
          throw new b("Points of LinearRing do not form a closed linestring");
        if (this.getCoordinateSequence().size() >= 1 && this.getCoordinateSequence().size() < p.MINIMUM_VALID_SIZE)
          throw new b("Invalid number of points in LinearRing (found " + this.getCoordinateSequence().size() + " - must be 0 or >= 4)");
      }, p.prototype.getGeometryType = function() {
        return "LinearRing";
      }, p.prototype.copy = function() {
        return new p(this._points.copy(), this._factory);
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, E.MINIMUM_VALID_SIZE.get = function() {
        return 4;
      }, E.serialVersionUID.get = function() {
        return -4261142084085851600;
      }, Object.defineProperties(p, E), p;
    }(rn), Tr = function(g) {
      function p() {
        g.apply(this, arguments);
      }
      g && (p.__proto__ = g), (p.prototype = Object.create(g && g.prototype)).constructor = p;
      var E = { serialVersionUID: { configurable: !0 } };
      return p.prototype.getSortIndex = function() {
        return it.SORTINDEX_MULTIPOLYGON;
      }, p.prototype.equalsExact = function() {
        if (arguments.length === 2) {
          var B = arguments[0], D = arguments[1];
          return !!this.isEquivalentClass(B) && g.prototype.equalsExact.call(this, B, D);
        }
        return g.prototype.equalsExact.apply(this, arguments);
      }, p.prototype.getBoundaryDimension = function() {
        return 1;
      }, p.prototype.getDimension = function() {
        return 2;
      }, p.prototype.reverse = function() {
        for (var B = this._geometries.length, D = new Array(B).fill(null), j = 0; j < this._geometries.length; j++)
          D[j] = this._geometries[j].reverse();
        return this.getFactory().createMultiPolygon(D);
      }, p.prototype.getBoundary = function() {
        if (this.isEmpty())
          return this.getFactory().createMultiLineString();
        for (var B = new We(), D = 0; D < this._geometries.length; D++)
          for (var j = this._geometries[D].getBoundary(), te = 0; te < j.getNumGeometries(); te++)
            B.add(j.getGeometryN(te));
        var he = new Array(B.size()).fill(null);
        return this.getFactory().createMultiLineString(B.toArray(he));
      }, p.prototype.getGeometryType = function() {
        return "MultiPolygon";
      }, p.prototype.copy = function() {
        for (var B = new Array(this._geometries.length).fill(null), D = 0; D < B.length; D++)
          B[D] = this._geometries[D].copy();
        return new p(B, this._factory);
      }, p.prototype.interfaces_ = function() {
        return [Vt];
      }, p.prototype.getClass = function() {
        return p;
      }, E.serialVersionUID.get = function() {
        return -551033529766975900;
      }, Object.defineProperties(p, E), p;
    }(ze), $t = function(g) {
      this._factory = g || null, this._isUserDataCopied = !1;
    }, Ye = { NoOpGeometryOperation: { configurable: !0 }, CoordinateOperation: { configurable: !0 }, CoordinateSequenceOperation: { configurable: !0 } };
    $t.prototype.setCopyUserData = function(g) {
      this._isUserDataCopied = g;
    }, $t.prototype.edit = function(g, p) {
      if (g === null)
        return null;
      var E = this.editInternal(g, p);
      return this._isUserDataCopied && E.setUserData(g.getUserData()), E;
    }, $t.prototype.editInternal = function(g, p) {
      return this._factory === null && (this._factory = g.getFactory()), g instanceof ze ? this.editGeometryCollection(g, p) : g instanceof Sn ? this.editPolygon(g, p) : g instanceof pr ? p.edit(g, this._factory) : g instanceof rn ? p.edit(g, this._factory) : (ie.shouldNeverReachHere("Unsupported Geometry class: " + g.getClass().getName()), null);
    }, $t.prototype.editGeometryCollection = function(g, p) {
      for (var E = p.edit(g, this._factory), B = new We(), D = 0; D < E.getNumGeometries(); D++) {
        var j = this.edit(E.getGeometryN(D), p);
        j === null || j.isEmpty() || B.add(j);
      }
      return E.getClass() === kn ? this._factory.createMultiPoint(B.toArray([])) : E.getClass() === tt ? this._factory.createMultiLineString(B.toArray([])) : E.getClass() === Tr ? this._factory.createMultiPolygon(B.toArray([])) : this._factory.createGeometryCollection(B.toArray([]));
    }, $t.prototype.editPolygon = function(g, p) {
      var E = p.edit(g, this._factory);
      if (E === null && (E = this._factory.createPolygon(null)), E.isEmpty())
        return E;
      var B = this.edit(E.getExteriorRing(), p);
      if (B === null || B.isEmpty())
        return this._factory.createPolygon();
      for (var D = new We(), j = 0; j < E.getNumInteriorRing(); j++) {
        var te = this.edit(E.getInteriorRingN(j), p);
        te === null || te.isEmpty() || D.add(te);
      }
      return this._factory.createPolygon(B, D.toArray([]));
    }, $t.prototype.interfaces_ = function() {
      return [];
    }, $t.prototype.getClass = function() {
      return $t;
    }, $t.GeometryEditorOperation = function() {
    }, Ye.NoOpGeometryOperation.get = function() {
      return en;
    }, Ye.CoordinateOperation.get = function() {
      return Ir;
    }, Ye.CoordinateSequenceOperation.get = function() {
      return zr;
    }, Object.defineProperties($t, Ye);
    var en = function() {
    };
    en.prototype.edit = function(g, p) {
      return g;
    }, en.prototype.interfaces_ = function() {
      return [$t.GeometryEditorOperation];
    }, en.prototype.getClass = function() {
      return en;
    };
    var Ir = function() {
    };
    Ir.prototype.edit = function(g, p) {
      var E = this.editCoordinates(g.getCoordinates(), g);
      return E === null ? g : g instanceof vr ? p.createLinearRing(E) : g instanceof rn ? p.createLineString(E) : g instanceof pr ? E.length > 0 ? p.createPoint(E[0]) : p.createPoint() : g;
    }, Ir.prototype.interfaces_ = function() {
      return [$t.GeometryEditorOperation];
    }, Ir.prototype.getClass = function() {
      return Ir;
    };
    var zr = function() {
    };
    zr.prototype.edit = function(g, p) {
      return g instanceof vr ? p.createLinearRing(this.edit(g.getCoordinateSequence(), g)) : g instanceof rn ? p.createLineString(this.edit(g.getCoordinateSequence(), g)) : g instanceof pr ? p.createPoint(this.edit(g.getCoordinateSequence(), g)) : g;
    }, zr.prototype.interfaces_ = function() {
      return [$t.GeometryEditorOperation];
    }, zr.prototype.getClass = function() {
      return zr;
    };
    var In = function() {
      if (this._dimension = 3, this._coordinates = null, arguments.length === 1) {
        if (arguments[0] instanceof Array)
          this._coordinates = arguments[0], this._dimension = 3;
        else if (Number.isInteger(arguments[0])) {
          var g = arguments[0];
          this._coordinates = new Array(g).fill(null);
          for (var p = 0; p < g; p++)
            this._coordinates[p] = new L();
        } else if (K(arguments[0], Ie)) {
          var E = arguments[0];
          if (E === null)
            return this._coordinates = new Array(0).fill(null), null;
          this._dimension = E.getDimension(), this._coordinates = new Array(E.size()).fill(null);
          for (var B = 0; B < this._coordinates.length; B++)
            this._coordinates[B] = E.getCoordinateCopy(B);
        }
      } else if (arguments.length === 2) {
        if (arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
          var D = arguments[0], j = arguments[1];
          this._coordinates = D, this._dimension = j, D === null && (this._coordinates = new Array(0).fill(null));
        } else if (Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
          var te = arguments[0], he = arguments[1];
          this._coordinates = new Array(te).fill(null), this._dimension = he;
          for (var ve = 0; ve < te; ve++)
            this._coordinates[ve] = new L();
        }
      }
    }, mr = { serialVersionUID: { configurable: !0 } };
    In.prototype.setOrdinate = function(g, p, E) {
      switch (p) {
        case Ie.X:
          this._coordinates[g].x = E;
          break;
        case Ie.Y:
          this._coordinates[g].y = E;
          break;
        case Ie.Z:
          this._coordinates[g].z = E;
          break;
        default:
          throw new b("invalid ordinateIndex");
      }
    }, In.prototype.size = function() {
      return this._coordinates.length;
    }, In.prototype.getOrdinate = function(g, p) {
      switch (p) {
        case Ie.X:
          return this._coordinates[g].x;
        case Ie.Y:
          return this._coordinates[g].y;
        case Ie.Z:
          return this._coordinates[g].z;
      }
      return Q.NaN;
    }, In.prototype.getCoordinate = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return this._coordinates[g];
      }
      if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        E.x = this._coordinates[p].x, E.y = this._coordinates[p].y, E.z = this._coordinates[p].z;
      }
    }, In.prototype.getCoordinateCopy = function(g) {
      return new L(this._coordinates[g]);
    }, In.prototype.getDimension = function() {
      return this._dimension;
    }, In.prototype.getX = function(g) {
      return this._coordinates[g].x;
    }, In.prototype.clone = function() {
      for (var g = new Array(this.size()).fill(null), p = 0; p < this._coordinates.length; p++)
        g[p] = this._coordinates[p].clone();
      return new In(g, this._dimension);
    }, In.prototype.expandEnvelope = function(g) {
      for (var p = 0; p < this._coordinates.length; p++)
        g.expandToInclude(this._coordinates[p]);
      return g;
    }, In.prototype.copy = function() {
      for (var g = new Array(this.size()).fill(null), p = 0; p < this._coordinates.length; p++)
        g[p] = this._coordinates[p].copy();
      return new In(g, this._dimension);
    }, In.prototype.toString = function() {
      if (this._coordinates.length > 0) {
        var g = new V(17 * this._coordinates.length);
        g.append("("), g.append(this._coordinates[0]);
        for (var p = 1; p < this._coordinates.length; p++)
          g.append(", "), g.append(this._coordinates[p]);
        return g.append(")"), g.toString();
      }
      return "()";
    }, In.prototype.getY = function(g) {
      return this._coordinates[g].y;
    }, In.prototype.toCoordinateArray = function() {
      return this._coordinates;
    }, In.prototype.interfaces_ = function() {
      return [Ie, r];
    }, In.prototype.getClass = function() {
      return In;
    }, mr.serialVersionUID.get = function() {
      return -915438501601840600;
    }, Object.defineProperties(In, mr);
    var Mr = function() {
    }, $e = { serialVersionUID: { configurable: !0 }, instanceObject: { configurable: !0 } };
    Mr.prototype.readResolve = function() {
      return Mr.instance();
    }, Mr.prototype.create = function() {
      if (arguments.length === 1) {
        if (arguments[0] instanceof Array) {
          var g = arguments[0];
          return new In(g);
        }
        if (K(arguments[0], Ie)) {
          var p = arguments[0];
          return new In(p);
        }
      } else if (arguments.length === 2) {
        var E = arguments[0], B = arguments[1];
        return B > 3 && (B = 3), B < 2 ? new In(E) : new In(E, B);
      }
    }, Mr.prototype.interfaces_ = function() {
      return [$, r];
    }, Mr.prototype.getClass = function() {
      return Mr;
    }, Mr.instance = function() {
      return Mr.instanceObject;
    }, $e.serialVersionUID.get = function() {
      return -4099577099607551500;
    }, $e.instanceObject.get = function() {
      return new Mr();
    }, Object.defineProperties(Mr, $e);
    var Ps = function(g) {
      function p() {
        g.call(this), this.map_ = /* @__PURE__ */ new Map();
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.get = function(E) {
        return this.map_.get(E) || null;
      }, p.prototype.put = function(E, B) {
        return this.map_.set(E, B), B;
      }, p.prototype.values = function() {
        for (var E = new We(), B = this.map_.values(), D = B.next(); !D.done; )
          E.add(D.value), D = B.next();
        return E;
      }, p.prototype.entrySet = function() {
        var E = new Fn();
        return this.map_.entries().forEach(function(B) {
          return E.add(B);
        }), E;
      }, p.prototype.size = function() {
        return this.map_.size();
      }, p;
    }(Ot), Wn = function g() {
      if (this._modelType = null, this._scale = null, arguments.length === 0)
        this._modelType = g.FLOATING;
      else if (arguments.length === 1) {
        if (arguments[0] instanceof Ao) {
          var p = arguments[0];
          this._modelType = p, p === g.FIXED && this.setScale(1);
        } else if (typeof arguments[0] == "number") {
          var E = arguments[0];
          this._modelType = g.FIXED, this.setScale(E);
        } else if (arguments[0] instanceof g) {
          var B = arguments[0];
          this._modelType = B._modelType, this._scale = B._scale;
        }
      }
    }, Is = { serialVersionUID: { configurable: !0 }, maximumPreciseValue: { configurable: !0 } };
    Wn.prototype.equals = function(g) {
      if (!(g instanceof Wn))
        return !1;
      var p = g;
      return this._modelType === p._modelType && this._scale === p._scale;
    }, Wn.prototype.compareTo = function(g) {
      var p = g, E = this.getMaximumSignificantDigits(), B = p.getMaximumSignificantDigits();
      return new Z(E).compareTo(new Z(B));
    }, Wn.prototype.getScale = function() {
      return this._scale;
    }, Wn.prototype.isFloating = function() {
      return this._modelType === Wn.FLOATING || this._modelType === Wn.FLOATING_SINGLE;
    }, Wn.prototype.getType = function() {
      return this._modelType;
    }, Wn.prototype.toString = function() {
      var g = "UNKNOWN";
      return this._modelType === Wn.FLOATING ? g = "Floating" : this._modelType === Wn.FLOATING_SINGLE ? g = "Floating-Single" : this._modelType === Wn.FIXED && (g = "Fixed (Scale=" + this.getScale() + ")"), g;
    }, Wn.prototype.makePrecise = function() {
      if (typeof arguments[0] == "number") {
        var g = arguments[0];
        return Q.isNaN(g) || this._modelType === Wn.FLOATING_SINGLE ? g : this._modelType === Wn.FIXED ? Math.round(g * this._scale) / this._scale : g;
      }
      if (arguments[0] instanceof L) {
        var p = arguments[0];
        if (this._modelType === Wn.FLOATING)
          return null;
        p.x = this.makePrecise(p.x), p.y = this.makePrecise(p.y);
      }
    }, Wn.prototype.getMaximumSignificantDigits = function() {
      var g = 16;
      return this._modelType === Wn.FLOATING ? g = 16 : this._modelType === Wn.FLOATING_SINGLE ? g = 6 : this._modelType === Wn.FIXED && (g = 1 + Math.trunc(Math.ceil(Math.log(this.getScale()) / Math.log(10)))), g;
    }, Wn.prototype.setScale = function(g) {
      this._scale = Math.abs(g);
    }, Wn.prototype.interfaces_ = function() {
      return [r, R];
    }, Wn.prototype.getClass = function() {
      return Wn;
    }, Wn.mostPrecise = function(g, p) {
      return g.compareTo(p) >= 0 ? g : p;
    }, Is.serialVersionUID.get = function() {
      return 7777263578777804e3;
    }, Is.maximumPreciseValue.get = function() {
      return 9007199254740992;
    }, Object.defineProperties(Wn, Is);
    var Ao = function g(p) {
      this._name = p || null, g.nameToTypeMap.put(p, this);
    }, hc = { serialVersionUID: { configurable: !0 }, nameToTypeMap: { configurable: !0 } };
    Ao.prototype.readResolve = function() {
      return Ao.nameToTypeMap.get(this._name);
    }, Ao.prototype.toString = function() {
      return this._name;
    }, Ao.prototype.interfaces_ = function() {
      return [r];
    }, Ao.prototype.getClass = function() {
      return Ao;
    }, hc.serialVersionUID.get = function() {
      return -552860263173159e4;
    }, hc.nameToTypeMap.get = function() {
      return new Ps();
    }, Object.defineProperties(Ao, hc), Wn.Type = Ao, Wn.FIXED = new Ao("FIXED"), Wn.FLOATING = new Ao("FLOATING"), Wn.FLOATING_SINGLE = new Ao("FLOATING SINGLE");
    var or = function g() {
      this._precisionModel = new Wn(), this._SRID = 0, this._coordinateSequenceFactory = g.getDefaultCoordinateSequenceFactory(), arguments.length === 0 || (arguments.length === 1 ? K(arguments[0], $) ? this._coordinateSequenceFactory = arguments[0] : arguments[0] instanceof Wn && (this._precisionModel = arguments[0]) : arguments.length === 2 ? (this._precisionModel = arguments[0], this._SRID = arguments[1]) : arguments.length === 3 && (this._precisionModel = arguments[0], this._SRID = arguments[1], this._coordinateSequenceFactory = arguments[2]));
    }, ml = { serialVersionUID: { configurable: !0 } };
    or.prototype.toGeometry = function(g) {
      return g.isNull() ? this.createPoint(null) : g.getMinX() === g.getMaxX() && g.getMinY() === g.getMaxY() ? this.createPoint(new L(g.getMinX(), g.getMinY())) : g.getMinX() === g.getMaxX() || g.getMinY() === g.getMaxY() ? this.createLineString([new L(g.getMinX(), g.getMinY()), new L(g.getMaxX(), g.getMaxY())]) : this.createPolygon(this.createLinearRing([new L(g.getMinX(), g.getMinY()), new L(g.getMinX(), g.getMaxY()), new L(g.getMaxX(), g.getMaxY()), new L(g.getMaxX(), g.getMinY()), new L(g.getMinX(), g.getMinY())]), null);
    }, or.prototype.createLineString = function(g) {
      return g ? g instanceof Array ? new rn(this.getCoordinateSequenceFactory().create(g), this) : K(g, Ie) ? new rn(g, this) : void 0 : new rn(this.getCoordinateSequenceFactory().create([]), this);
    }, or.prototype.createMultiLineString = function() {
      if (arguments.length === 0)
        return new tt(null, this);
      if (arguments.length === 1) {
        var g = arguments[0];
        return new tt(g, this);
      }
    }, or.prototype.buildGeometry = function(g) {
      for (var p = null, E = !1, B = !1, D = g.iterator(); D.hasNext(); ) {
        var j = D.next(), te = j.getClass();
        p === null && (p = te), te !== p && (E = !0), j.isGeometryCollectionOrDerived() && (B = !0);
      }
      if (p === null)
        return this.createGeometryCollection();
      if (E || B)
        return this.createGeometryCollection(or.toGeometryArray(g));
      var he = g.iterator().next();
      if (g.size() > 1) {
        if (he instanceof Sn)
          return this.createMultiPolygon(or.toPolygonArray(g));
        if (he instanceof rn)
          return this.createMultiLineString(or.toLineStringArray(g));
        if (he instanceof pr)
          return this.createMultiPoint(or.toPointArray(g));
        ie.shouldNeverReachHere("Unhandled class: " + he.getClass().getName());
      }
      return he;
    }, or.prototype.createMultiPointFromCoords = function(g) {
      return this.createMultiPoint(g !== null ? this.getCoordinateSequenceFactory().create(g) : null);
    }, or.prototype.createPoint = function() {
      if (arguments.length === 0)
        return this.createPoint(this.getCoordinateSequenceFactory().create([]));
      if (arguments.length === 1) {
        if (arguments[0] instanceof L) {
          var g = arguments[0];
          return this.createPoint(g !== null ? this.getCoordinateSequenceFactory().create([g]) : null);
        }
        if (K(arguments[0], Ie)) {
          var p = arguments[0];
          return new pr(p, this);
        }
      }
    }, or.prototype.getCoordinateSequenceFactory = function() {
      return this._coordinateSequenceFactory;
    }, or.prototype.createPolygon = function() {
      if (arguments.length === 0)
        return new Sn(null, null, this);
      if (arguments.length === 1) {
        if (K(arguments[0], Ie)) {
          var g = arguments[0];
          return this.createPolygon(this.createLinearRing(g));
        }
        if (arguments[0] instanceof Array) {
          var p = arguments[0];
          return this.createPolygon(this.createLinearRing(p));
        }
        if (arguments[0] instanceof vr) {
          var E = arguments[0];
          return this.createPolygon(E, null);
        }
      } else if (arguments.length === 2) {
        var B = arguments[0], D = arguments[1];
        return new Sn(B, D, this);
      }
    }, or.prototype.getSRID = function() {
      return this._SRID;
    }, or.prototype.createGeometryCollection = function() {
      if (arguments.length === 0)
        return new ze(null, this);
      if (arguments.length === 1) {
        var g = arguments[0];
        return new ze(g, this);
      }
    }, or.prototype.createGeometry = function(g) {
      return new $t(this).edit(g, { edit: function() {
        if (arguments.length === 2) {
          var p = arguments[0];
          return this._coordinateSequenceFactory.create(p);
        }
      } });
    }, or.prototype.getPrecisionModel = function() {
      return this._precisionModel;
    }, or.prototype.createLinearRing = function() {
      if (arguments.length === 0)
        return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));
      if (arguments.length === 1) {
        if (arguments[0] instanceof Array) {
          var g = arguments[0];
          return this.createLinearRing(g !== null ? this.getCoordinateSequenceFactory().create(g) : null);
        }
        if (K(arguments[0], Ie)) {
          var p = arguments[0];
          return new vr(p, this);
        }
      }
    }, or.prototype.createMultiPolygon = function() {
      if (arguments.length === 0)
        return new Tr(null, this);
      if (arguments.length === 1) {
        var g = arguments[0];
        return new Tr(g, this);
      }
    }, or.prototype.createMultiPoint = function() {
      if (arguments.length === 0)
        return new kn(null, this);
      if (arguments.length === 1) {
        if (arguments[0] instanceof Array) {
          var g = arguments[0];
          return new kn(g, this);
        }
        if (arguments[0] instanceof Array) {
          var p = arguments[0];
          return this.createMultiPoint(p !== null ? this.getCoordinateSequenceFactory().create(p) : null);
        }
        if (K(arguments[0], Ie)) {
          var E = arguments[0];
          if (E === null)
            return this.createMultiPoint(new Array(0).fill(null));
          for (var B = new Array(E.size()).fill(null), D = 0; D < E.size(); D++) {
            var j = this.getCoordinateSequenceFactory().create(1, E.getDimension());
            Lt.copy(E, D, j, 0, 1), B[D] = this.createPoint(j);
          }
          return this.createMultiPoint(B);
        }
      }
    }, or.prototype.interfaces_ = function() {
      return [r];
    }, or.prototype.getClass = function() {
      return or;
    }, or.toMultiPolygonArray = function(g) {
      var p = new Array(g.size()).fill(null);
      return g.toArray(p);
    }, or.toGeometryArray = function(g) {
      if (g === null)
        return null;
      var p = new Array(g.size()).fill(null);
      return g.toArray(p);
    }, or.getDefaultCoordinateSequenceFactory = function() {
      return Mr.instance();
    }, or.toMultiLineStringArray = function(g) {
      var p = new Array(g.size()).fill(null);
      return g.toArray(p);
    }, or.toLineStringArray = function(g) {
      var p = new Array(g.size()).fill(null);
      return g.toArray(p);
    }, or.toMultiPointArray = function(g) {
      var p = new Array(g.size()).fill(null);
      return g.toArray(p);
    }, or.toLinearRingArray = function(g) {
      var p = new Array(g.size()).fill(null);
      return g.toArray(p);
    }, or.toPointArray = function(g) {
      var p = new Array(g.size()).fill(null);
      return g.toArray(p);
    }, or.toPolygonArray = function(g) {
      var p = new Array(g.size()).fill(null);
      return g.toArray(p);
    }, or.createPointFromInternalCoord = function(g, p) {
      return p.getPrecisionModel().makePrecise(g), p.getFactory().createPoint(g);
    }, ml.serialVersionUID.get = function() {
      return -6820524753094096e3;
    }, Object.defineProperties(or, ml);
    var dc = ["Point", "MultiPoint", "LineString", "MultiLineString", "Polygon", "MultiPolygon"], Wa = function(g) {
      this.geometryFactory = g || new or();
    };
    Wa.prototype.read = function(g) {
      var p, E = (p = typeof g == "string" ? JSON.parse(g) : g).type;
      if (!Ki[E])
        throw new Error("Unknown GeoJSON type: " + p.type);
      return dc.indexOf(E) !== -1 ? Ki[E].apply(this, [p.coordinates]) : E === "GeometryCollection" ? Ki[E].apply(this, [p.geometries]) : Ki[E].apply(this, [p]);
    }, Wa.prototype.write = function(g) {
      var p = g.getGeometryType();
      if (!Ne[p])
        throw new Error("Geometry is not supported");
      return Ne[p].apply(this, [g]);
    };
    var Ki = { Feature: function(g) {
      var p = {};
      for (var E in g)
        p[E] = g[E];
      if (g.geometry) {
        var B = g.geometry.type;
        if (!Ki[B])
          throw new Error("Unknown GeoJSON type: " + g.type);
        p.geometry = this.read(g.geometry);
      }
      return g.bbox && (p.bbox = Ki.bbox.apply(this, [g.bbox])), p;
    }, FeatureCollection: function(g) {
      var p = {};
      if (g.features) {
        p.features = [];
        for (var E = 0; E < g.features.length; ++E)
          p.features.push(this.read(g.features[E]));
      }
      return g.bbox && (p.bbox = this.parse.bbox.apply(this, [g.bbox])), p;
    }, coordinates: function(g) {
      for (var p = [], E = 0; E < g.length; ++E) {
        var B = g[E];
        p.push(new L(B[0], B[1]));
      }
      return p;
    }, bbox: function(g) {
      return this.geometryFactory.createLinearRing([new L(g[0], g[1]), new L(g[2], g[1]), new L(g[2], g[3]), new L(g[0], g[3]), new L(g[0], g[1])]);
    }, Point: function(g) {
      var p = new L(g[0], g[1]);
      return this.geometryFactory.createPoint(p);
    }, MultiPoint: function(g) {
      for (var p = [], E = 0; E < g.length; ++E)
        p.push(Ki.Point.apply(this, [g[E]]));
      return this.geometryFactory.createMultiPoint(p);
    }, LineString: function(g) {
      var p = Ki.coordinates.apply(this, [g]);
      return this.geometryFactory.createLineString(p);
    }, MultiLineString: function(g) {
      for (var p = [], E = 0; E < g.length; ++E)
        p.push(Ki.LineString.apply(this, [g[E]]));
      return this.geometryFactory.createMultiLineString(p);
    }, Polygon: function(g) {
      for (var p = Ki.coordinates.apply(this, [g[0]]), E = this.geometryFactory.createLinearRing(p), B = [], D = 1; D < g.length; ++D) {
        var j = g[D], te = Ki.coordinates.apply(this, [j]), he = this.geometryFactory.createLinearRing(te);
        B.push(he);
      }
      return this.geometryFactory.createPolygon(E, B);
    }, MultiPolygon: function(g) {
      for (var p = [], E = 0; E < g.length; ++E) {
        var B = g[E];
        p.push(Ki.Polygon.apply(this, [B]));
      }
      return this.geometryFactory.createMultiPolygon(p);
    }, GeometryCollection: function(g) {
      for (var p = [], E = 0; E < g.length; ++E) {
        var B = g[E];
        p.push(this.read(B));
      }
      return this.geometryFactory.createGeometryCollection(p);
    } }, Ne = { coordinate: function(g) {
      return [g.x, g.y];
    }, Point: function(g) {
      return { type: "Point", coordinates: Ne.coordinate.apply(this, [g.getCoordinate()]) };
    }, MultiPoint: function(g) {
      for (var p = [], E = 0; E < g._geometries.length; ++E) {
        var B = g._geometries[E], D = Ne.Point.apply(this, [B]);
        p.push(D.coordinates);
      }
      return { type: "MultiPoint", coordinates: p };
    }, LineString: function(g) {
      for (var p = [], E = g.getCoordinates(), B = 0; B < E.length; ++B) {
        var D = E[B];
        p.push(Ne.coordinate.apply(this, [D]));
      }
      return { type: "LineString", coordinates: p };
    }, MultiLineString: function(g) {
      for (var p = [], E = 0; E < g._geometries.length; ++E) {
        var B = g._geometries[E], D = Ne.LineString.apply(this, [B]);
        p.push(D.coordinates);
      }
      return { type: "MultiLineString", coordinates: p };
    }, Polygon: function(g) {
      var p = [], E = Ne.LineString.apply(this, [g._shell]);
      p.push(E.coordinates);
      for (var B = 0; B < g._holes.length; ++B) {
        var D = g._holes[B], j = Ne.LineString.apply(this, [D]);
        p.push(j.coordinates);
      }
      return { type: "Polygon", coordinates: p };
    }, MultiPolygon: function(g) {
      for (var p = [], E = 0; E < g._geometries.length; ++E) {
        var B = g._geometries[E], D = Ne.Polygon.apply(this, [B]);
        p.push(D.coordinates);
      }
      return { type: "MultiPolygon", coordinates: p };
    }, GeometryCollection: function(g) {
      for (var p = [], E = 0; E < g._geometries.length; ++E) {
        var B = g._geometries[E], D = B.getGeometryType();
        p.push(Ne[D].apply(this, [B]));
      }
      return { type: "GeometryCollection", geometries: p };
    } }, Fe = function(g) {
      this.geometryFactory = g || new or(), this.precisionModel = this.geometryFactory.getPrecisionModel(), this.parser = new Wa(this.geometryFactory);
    };
    Fe.prototype.read = function(g) {
      var p = this.parser.read(g);
      return this.precisionModel.getType() === Wn.FIXED && this.reducePrecision(p), p;
    }, Fe.prototype.reducePrecision = function(g) {
      var p, E;
      if (g.coordinate)
        this.precisionModel.makePrecise(g.coordinate);
      else if (g.points)
        for (p = 0, E = g.points.length; p < E; p++)
          this.precisionModel.makePrecise(g.points[p]);
      else if (g.geometries)
        for (p = 0, E = g.geometries.length; p < E; p++)
          this.reducePrecision(g.geometries[p]);
    };
    var Ze = function() {
      this.parser = new Wa(this.geometryFactory);
    };
    Ze.prototype.write = function(g) {
      return this.parser.write(g);
    };
    var Ve = function() {
    }, Mt = { ON: { configurable: !0 }, LEFT: { configurable: !0 }, RIGHT: { configurable: !0 } };
    Ve.prototype.interfaces_ = function() {
      return [];
    }, Ve.prototype.getClass = function() {
      return Ve;
    }, Ve.opposite = function(g) {
      return g === Ve.LEFT ? Ve.RIGHT : g === Ve.RIGHT ? Ve.LEFT : g;
    }, Mt.ON.get = function() {
      return 0;
    }, Mt.LEFT.get = function() {
      return 1;
    }, Mt.RIGHT.get = function() {
      return 2;
    }, Object.defineProperties(Ve, Mt), (C.prototype = new Error()).name = "EmptyStackException", (y.prototype = new hn()).add = function(g) {
      return this.array_.push(g), !0;
    }, y.prototype.get = function(g) {
      if (g < 0 || g >= this.size())
        throw new Error();
      return this.array_[g];
    }, y.prototype.push = function(g) {
      return this.array_.push(g), g;
    }, y.prototype.pop = function(g) {
      if (this.array_.length === 0)
        throw new C();
      return this.array_.pop();
    }, y.prototype.peek = function() {
      if (this.array_.length === 0)
        throw new C();
      return this.array_[this.array_.length - 1];
    }, y.prototype.empty = function() {
      return this.array_.length === 0;
    }, y.prototype.isEmpty = function() {
      return this.empty();
    }, y.prototype.search = function(g) {
      return this.array_.indexOf(g);
    }, y.prototype.size = function() {
      return this.array_.length;
    }, y.prototype.toArray = function() {
      for (var g = [], p = 0, E = this.array_.length; p < E; p++)
        g.push(this.array_[p]);
      return g;
    };
    var An = function() {
      this._minIndex = -1, this._minCoord = null, this._minDe = null, this._orientedDe = null;
    };
    An.prototype.getCoordinate = function() {
      return this._minCoord;
    }, An.prototype.getRightmostSide = function(g, p) {
      var E = this.getRightmostSideOfSegment(g, p);
      return E < 0 && (E = this.getRightmostSideOfSegment(g, p - 1)), E < 0 && (this._minCoord = null, this.checkForRightmostCoordinate(g)), E;
    }, An.prototype.findRightmostEdgeAtVertex = function() {
      var g = this._minDe.getEdge().getCoordinates();
      ie.isTrue(this._minIndex > 0 && this._minIndex < g.length, "rightmost point expected to be interior vertex of edge");
      var p = g[this._minIndex - 1], E = g[this._minIndex + 1], B = ke.computeOrientation(this._minCoord, E, p), D = !1;
      (p.y < this._minCoord.y && E.y < this._minCoord.y && B === ke.COUNTERCLOCKWISE || p.y > this._minCoord.y && E.y > this._minCoord.y && B === ke.CLOCKWISE) && (D = !0), D && (this._minIndex = this._minIndex - 1);
    }, An.prototype.getRightmostSideOfSegment = function(g, p) {
      var E = g.getEdge().getCoordinates();
      if (p < 0 || p + 1 >= E.length || E[p].y === E[p + 1].y)
        return -1;
      var B = Ve.LEFT;
      return E[p].y < E[p + 1].y && (B = Ve.RIGHT), B;
    }, An.prototype.getEdge = function() {
      return this._orientedDe;
    }, An.prototype.checkForRightmostCoordinate = function(g) {
      for (var p = g.getEdge().getCoordinates(), E = 0; E < p.length - 1; E++)
        (this._minCoord === null || p[E].x > this._minCoord.x) && (this._minDe = g, this._minIndex = E, this._minCoord = p[E]);
    }, An.prototype.findRightmostEdgeAtNode = function() {
      var g = this._minDe.getNode().getEdges();
      this._minDe = g.getRightmostEdge(), this._minDe.isForward() || (this._minDe = this._minDe.getSym(), this._minIndex = this._minDe.getEdge().getCoordinates().length - 1);
    }, An.prototype.findEdge = function(g) {
      for (var p = g.iterator(); p.hasNext(); ) {
        var E = p.next();
        E.isForward() && this.checkForRightmostCoordinate(E);
      }
      ie.isTrue(this._minIndex !== 0 || this._minCoord.equals(this._minDe.getCoordinate()), "inconsistency in rightmost processing"), this._minIndex === 0 ? this.findRightmostEdgeAtNode() : this.findRightmostEdgeAtVertex(), this._orientedDe = this._minDe, this.getRightmostSide(this._minDe, this._minIndex) === Ve.LEFT && (this._orientedDe = this._minDe.getSym());
    }, An.prototype.interfaces_ = function() {
      return [];
    }, An.prototype.getClass = function() {
      return An;
    };
    var lr = function(g) {
      function p(E, B) {
        g.call(this, p.msgWithCoord(E, B)), this.pt = B ? new L(B) : null, this.name = "TopologyException";
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.getCoordinate = function() {
        return this.pt;
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p.msgWithCoord = function(E, B) {
        return B ? E : E + " [ " + B + " ]";
      }, p;
    }(Ee), lo = function() {
      this.array_ = [];
    };
    lo.prototype.addLast = function(g) {
      this.array_.push(g);
    }, lo.prototype.removeFirst = function() {
      return this.array_.shift();
    }, lo.prototype.isEmpty = function() {
      return this.array_.length === 0;
    };
    var nn = function() {
      this._finder = null, this._dirEdgeList = new We(), this._nodes = new We(), this._rightMostCoord = null, this._env = null, this._finder = new An();
    };
    nn.prototype.clearVisitedEdges = function() {
      for (var g = this._dirEdgeList.iterator(); g.hasNext(); )
        g.next().setVisited(!1);
    }, nn.prototype.getRightmostCoordinate = function() {
      return this._rightMostCoord;
    }, nn.prototype.computeNodeDepth = function(g) {
      for (var p = null, E = g.getEdges().iterator(); E.hasNext(); ) {
        var B = E.next();
        if (B.isVisited() || B.getSym().isVisited()) {
          p = B;
          break;
        }
      }
      if (p === null)
        throw new lr("unable to find edge to compute depths at " + g.getCoordinate());
      g.getEdges().computeDepths(p);
      for (var D = g.getEdges().iterator(); D.hasNext(); ) {
        var j = D.next();
        j.setVisited(!0), this.copySymDepths(j);
      }
    }, nn.prototype.computeDepth = function(g) {
      this.clearVisitedEdges();
      var p = this._finder.getEdge();
      p.setEdgeDepths(Ve.RIGHT, g), this.copySymDepths(p), this.computeDepths(p);
    }, nn.prototype.create = function(g) {
      this.addReachable(g), this._finder.findEdge(this._dirEdgeList), this._rightMostCoord = this._finder.getCoordinate();
    }, nn.prototype.findResultEdges = function() {
      for (var g = this._dirEdgeList.iterator(); g.hasNext(); ) {
        var p = g.next();
        p.getDepth(Ve.RIGHT) >= 1 && p.getDepth(Ve.LEFT) <= 0 && !p.isInteriorAreaEdge() && p.setInResult(!0);
      }
    }, nn.prototype.computeDepths = function(g) {
      var p = new Fn(), E = new lo(), B = g.getNode();
      for (E.addLast(B), p.add(B), g.setVisited(!0); !E.isEmpty(); ) {
        var D = E.removeFirst();
        p.add(D), this.computeNodeDepth(D);
        for (var j = D.getEdges().iterator(); j.hasNext(); ) {
          var te = j.next().getSym();
          if (!te.isVisited()) {
            var he = te.getNode();
            p.contains(he) || (E.addLast(he), p.add(he));
          }
        }
      }
    }, nn.prototype.compareTo = function(g) {
      var p = g;
      return this._rightMostCoord.x < p._rightMostCoord.x ? -1 : this._rightMostCoord.x > p._rightMostCoord.x ? 1 : 0;
    }, nn.prototype.getEnvelope = function() {
      if (this._env === null) {
        for (var g = new Te(), p = this._dirEdgeList.iterator(); p.hasNext(); )
          for (var E = p.next().getEdge().getCoordinates(), B = 0; B < E.length - 1; B++)
            g.expandToInclude(E[B]);
        this._env = g;
      }
      return this._env;
    }, nn.prototype.addReachable = function(g) {
      var p = new y();
      for (p.add(g); !p.empty(); ) {
        var E = p.pop();
        this.add(E, p);
      }
    }, nn.prototype.copySymDepths = function(g) {
      var p = g.getSym();
      p.setDepth(Ve.LEFT, g.getDepth(Ve.RIGHT)), p.setDepth(Ve.RIGHT, g.getDepth(Ve.LEFT));
    }, nn.prototype.add = function(g, p) {
      g.setVisited(!0), this._nodes.add(g);
      for (var E = g.getEdges().iterator(); E.hasNext(); ) {
        var B = E.next();
        this._dirEdgeList.add(B);
        var D = B.getSym().getNode();
        D.isVisited() || p.push(D);
      }
    }, nn.prototype.getNodes = function() {
      return this._nodes;
    }, nn.prototype.getDirectedEdges = function() {
      return this._dirEdgeList;
    }, nn.prototype.interfaces_ = function() {
      return [R];
    }, nn.prototype.getClass = function() {
      return nn;
    };
    var Xn = function g() {
      if (this.location = null, arguments.length === 1) {
        if (arguments[0] instanceof Array) {
          var p = arguments[0];
          this.init(p.length);
        } else if (Number.isInteger(arguments[0])) {
          var E = arguments[0];
          this.init(1), this.location[Ve.ON] = E;
        } else if (arguments[0] instanceof g) {
          var B = arguments[0];
          if (this.init(B.location.length), B !== null)
            for (var D = 0; D < this.location.length; D++)
              this.location[D] = B.location[D];
        }
      } else if (arguments.length === 3) {
        var j = arguments[0], te = arguments[1], he = arguments[2];
        this.init(3), this.location[Ve.ON] = j, this.location[Ve.LEFT] = te, this.location[Ve.RIGHT] = he;
      }
    };
    Xn.prototype.setAllLocations = function(g) {
      for (var p = 0; p < this.location.length; p++)
        this.location[p] = g;
    }, Xn.prototype.isNull = function() {
      for (var g = 0; g < this.location.length; g++)
        if (this.location[g] !== U.NONE)
          return !1;
      return !0;
    }, Xn.prototype.setAllLocationsIfNull = function(g) {
      for (var p = 0; p < this.location.length; p++)
        this.location[p] === U.NONE && (this.location[p] = g);
    }, Xn.prototype.isLine = function() {
      return this.location.length === 1;
    }, Xn.prototype.merge = function(g) {
      if (g.location.length > this.location.length) {
        var p = new Array(3).fill(null);
        p[Ve.ON] = this.location[Ve.ON], p[Ve.LEFT] = U.NONE, p[Ve.RIGHT] = U.NONE, this.location = p;
      }
      for (var E = 0; E < this.location.length; E++)
        this.location[E] === U.NONE && E < g.location.length && (this.location[E] = g.location[E]);
    }, Xn.prototype.getLocations = function() {
      return this.location;
    }, Xn.prototype.flip = function() {
      if (this.location.length <= 1)
        return null;
      var g = this.location[Ve.LEFT];
      this.location[Ve.LEFT] = this.location[Ve.RIGHT], this.location[Ve.RIGHT] = g;
    }, Xn.prototype.toString = function() {
      var g = new V();
      return this.location.length > 1 && g.append(U.toLocationSymbol(this.location[Ve.LEFT])), g.append(U.toLocationSymbol(this.location[Ve.ON])), this.location.length > 1 && g.append(U.toLocationSymbol(this.location[Ve.RIGHT])), g.toString();
    }, Xn.prototype.setLocations = function(g, p, E) {
      this.location[Ve.ON] = g, this.location[Ve.LEFT] = p, this.location[Ve.RIGHT] = E;
    }, Xn.prototype.get = function(g) {
      return g < this.location.length ? this.location[g] : U.NONE;
    }, Xn.prototype.isArea = function() {
      return this.location.length > 1;
    }, Xn.prototype.isAnyNull = function() {
      for (var g = 0; g < this.location.length; g++)
        if (this.location[g] === U.NONE)
          return !0;
      return !1;
    }, Xn.prototype.setLocation = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        this.setLocation(Ve.ON, g);
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        this.location[p] = E;
      }
    }, Xn.prototype.init = function(g) {
      this.location = new Array(g).fill(null), this.setAllLocations(U.NONE);
    }, Xn.prototype.isEqualOnSide = function(g, p) {
      return this.location[p] === g.location[p];
    }, Xn.prototype.allPositionsEqual = function(g) {
      for (var p = 0; p < this.location.length; p++)
        if (this.location[p] !== g)
          return !1;
      return !0;
    }, Xn.prototype.interfaces_ = function() {
      return [];
    }, Xn.prototype.getClass = function() {
      return Xn;
    };
    var Zn = function g() {
      if (this.elt = new Array(2).fill(null), arguments.length === 1) {
        if (Number.isInteger(arguments[0])) {
          var p = arguments[0];
          this.elt[0] = new Xn(p), this.elt[1] = new Xn(p);
        } else if (arguments[0] instanceof g) {
          var E = arguments[0];
          this.elt[0] = new Xn(E.elt[0]), this.elt[1] = new Xn(E.elt[1]);
        }
      } else if (arguments.length === 2) {
        var B = arguments[0], D = arguments[1];
        this.elt[0] = new Xn(U.NONE), this.elt[1] = new Xn(U.NONE), this.elt[B].setLocation(D);
      } else if (arguments.length === 3) {
        var j = arguments[0], te = arguments[1], he = arguments[2];
        this.elt[0] = new Xn(j, te, he), this.elt[1] = new Xn(j, te, he);
      } else if (arguments.length === 4) {
        var ve = arguments[0], Le = arguments[1], Je = arguments[2], et = arguments[3];
        this.elt[0] = new Xn(U.NONE, U.NONE, U.NONE), this.elt[1] = new Xn(U.NONE, U.NONE, U.NONE), this.elt[ve].setLocations(Le, Je, et);
      }
    };
    Zn.prototype.getGeometryCount = function() {
      var g = 0;
      return this.elt[0].isNull() || g++, this.elt[1].isNull() || g++, g;
    }, Zn.prototype.setAllLocations = function(g, p) {
      this.elt[g].setAllLocations(p);
    }, Zn.prototype.isNull = function(g) {
      return this.elt[g].isNull();
    }, Zn.prototype.setAllLocationsIfNull = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        this.setAllLocationsIfNull(0, g), this.setAllLocationsIfNull(1, g);
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        this.elt[p].setAllLocationsIfNull(E);
      }
    }, Zn.prototype.isLine = function(g) {
      return this.elt[g].isLine();
    }, Zn.prototype.merge = function(g) {
      for (var p = 0; p < 2; p++)
        this.elt[p] === null && g.elt[p] !== null ? this.elt[p] = new Xn(g.elt[p]) : this.elt[p].merge(g.elt[p]);
    }, Zn.prototype.flip = function() {
      this.elt[0].flip(), this.elt[1].flip();
    }, Zn.prototype.getLocation = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return this.elt[g].get(Ve.ON);
      }
      if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        return this.elt[p].get(E);
      }
    }, Zn.prototype.toString = function() {
      var g = new V();
      return this.elt[0] !== null && (g.append("A:"), g.append(this.elt[0].toString())), this.elt[1] !== null && (g.append(" B:"), g.append(this.elt[1].toString())), g.toString();
    }, Zn.prototype.isArea = function() {
      if (arguments.length === 0)
        return this.elt[0].isArea() || this.elt[1].isArea();
      if (arguments.length === 1) {
        var g = arguments[0];
        return this.elt[g].isArea();
      }
    }, Zn.prototype.isAnyNull = function(g) {
      return this.elt[g].isAnyNull();
    }, Zn.prototype.setLocation = function() {
      if (arguments.length === 2) {
        var g = arguments[0], p = arguments[1];
        this.elt[g].setLocation(Ve.ON, p);
      } else if (arguments.length === 3) {
        var E = arguments[0], B = arguments[1], D = arguments[2];
        this.elt[E].setLocation(B, D);
      }
    }, Zn.prototype.isEqualOnSide = function(g, p) {
      return this.elt[0].isEqualOnSide(g.elt[0], p) && this.elt[1].isEqualOnSide(g.elt[1], p);
    }, Zn.prototype.allPositionsEqual = function(g, p) {
      return this.elt[g].allPositionsEqual(p);
    }, Zn.prototype.toLine = function(g) {
      this.elt[g].isArea() && (this.elt[g] = new Xn(this.elt[g].location[0]));
    }, Zn.prototype.interfaces_ = function() {
      return [];
    }, Zn.prototype.getClass = function() {
      return Zn;
    }, Zn.toLineLabel = function(g) {
      for (var p = new Zn(U.NONE), E = 0; E < 2; E++)
        p.setLocation(E, g.getLocation(E));
      return p;
    };
    var Wi = function() {
      this._startDe = null, this._maxNodeDegree = -1, this._edges = new We(), this._pts = new We(), this._label = new Zn(U.NONE), this._ring = null, this._isHole = null, this._shell = null, this._holes = new We(), this._geometryFactory = null;
      var g = arguments[0], p = arguments[1];
      this._geometryFactory = p, this.computePoints(g), this.computeRing();
    };
    Wi.prototype.computeRing = function() {
      if (this._ring !== null)
        return null;
      for (var g = new Array(this._pts.size()).fill(null), p = 0; p < this._pts.size(); p++)
        g[p] = this._pts.get(p);
      this._ring = this._geometryFactory.createLinearRing(g), this._isHole = ke.isCCW(this._ring.getCoordinates());
    }, Wi.prototype.isIsolated = function() {
      return this._label.getGeometryCount() === 1;
    }, Wi.prototype.computePoints = function(g) {
      this._startDe = g;
      var p = g, E = !0;
      do {
        if (p === null)
          throw new lr("Found null DirectedEdge");
        if (p.getEdgeRing() === this)
          throw new lr("Directed Edge visited twice during ring-building at " + p.getCoordinate());
        this._edges.add(p);
        var B = p.getLabel();
        ie.isTrue(B.isArea()), this.mergeLabel(B), this.addPoints(p.getEdge(), p.isForward(), E), E = !1, this.setEdgeRing(p, this), p = this.getNext(p);
      } while (p !== this._startDe);
    }, Wi.prototype.getLinearRing = function() {
      return this._ring;
    }, Wi.prototype.getCoordinate = function(g) {
      return this._pts.get(g);
    }, Wi.prototype.computeMaxNodeDegree = function() {
      this._maxNodeDegree = 0;
      var g = this._startDe;
      do {
        var p = g.getNode().getEdges().getOutgoingDegree(this);
        p > this._maxNodeDegree && (this._maxNodeDegree = p), g = this.getNext(g);
      } while (g !== this._startDe);
      this._maxNodeDegree *= 2;
    }, Wi.prototype.addPoints = function(g, p, E) {
      var B = g.getCoordinates();
      if (p) {
        var D = 1;
        E && (D = 0);
        for (var j = D; j < B.length; j++)
          this._pts.add(B[j]);
      } else {
        var te = B.length - 2;
        E && (te = B.length - 1);
        for (var he = te; he >= 0; he--)
          this._pts.add(B[he]);
      }
    }, Wi.prototype.isHole = function() {
      return this._isHole;
    }, Wi.prototype.setInResult = function() {
      var g = this._startDe;
      do
        g.getEdge().setInResult(!0), g = g.getNext();
      while (g !== this._startDe);
    }, Wi.prototype.containsPoint = function(g) {
      var p = this.getLinearRing();
      if (!p.getEnvelopeInternal().contains(g) || !ke.isPointInRing(g, p.getCoordinates()))
        return !1;
      for (var E = this._holes.iterator(); E.hasNext(); )
        if (E.next().containsPoint(g))
          return !1;
      return !0;
    }, Wi.prototype.addHole = function(g) {
      this._holes.add(g);
    }, Wi.prototype.isShell = function() {
      return this._shell === null;
    }, Wi.prototype.getLabel = function() {
      return this._label;
    }, Wi.prototype.getEdges = function() {
      return this._edges;
    }, Wi.prototype.getMaxNodeDegree = function() {
      return this._maxNodeDegree < 0 && this.computeMaxNodeDegree(), this._maxNodeDegree;
    }, Wi.prototype.getShell = function() {
      return this._shell;
    }, Wi.prototype.mergeLabel = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        this.mergeLabel(g, 0), this.mergeLabel(g, 1);
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1], B = p.getLocation(E, Ve.RIGHT);
        if (B === U.NONE)
          return null;
        if (this._label.getLocation(E) === U.NONE)
          return this._label.setLocation(E, B), null;
      }
    }, Wi.prototype.setShell = function(g) {
      this._shell = g, g !== null && g.addHole(this);
    }, Wi.prototype.toPolygon = function(g) {
      for (var p = new Array(this._holes.size()).fill(null), E = 0; E < this._holes.size(); E++)
        p[E] = this._holes.get(E).getLinearRing();
      return g.createPolygon(this.getLinearRing(), p);
    }, Wi.prototype.interfaces_ = function() {
      return [];
    }, Wi.prototype.getClass = function() {
      return Wi;
    };
    var To = function(g) {
      function p() {
        var E = arguments[0], B = arguments[1];
        g.call(this, E, B);
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.setEdgeRing = function(E, B) {
        E.setMinEdgeRing(B);
      }, p.prototype.getNext = function(E) {
        return E.getNextMin();
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(Wi), pm = function(g) {
      function p() {
        var E = arguments[0], B = arguments[1];
        g.call(this, E, B);
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.buildMinimalRings = function() {
        var E = new We(), B = this._startDe;
        do {
          if (B.getMinEdgeRing() === null) {
            var D = new To(B, this._geometryFactory);
            E.add(D);
          }
          B = B.getNext();
        } while (B !== this._startDe);
        return E;
      }, p.prototype.setEdgeRing = function(E, B) {
        E.setEdgeRing(B);
      }, p.prototype.linkDirectedEdgesForMinimalEdgeRings = function() {
        var E = this._startDe;
        do
          E.getNode().getEdges().linkMinimalDirectedEdges(this), E = E.getNext();
        while (E !== this._startDe);
      }, p.prototype.getNext = function(E) {
        return E.getNext();
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(Wi), na = function() {
      if (this._label = null, this._isInResult = !1, this._isCovered = !1, this._isCoveredSet = !1, this._isVisited = !1, arguments.length !== 0) {
        if (arguments.length === 1) {
          var g = arguments[0];
          this._label = g;
        }
      }
    };
    na.prototype.setVisited = function(g) {
      this._isVisited = g;
    }, na.prototype.setInResult = function(g) {
      this._isInResult = g;
    }, na.prototype.isCovered = function() {
      return this._isCovered;
    }, na.prototype.isCoveredSet = function() {
      return this._isCoveredSet;
    }, na.prototype.setLabel = function(g) {
      this._label = g;
    }, na.prototype.getLabel = function() {
      return this._label;
    }, na.prototype.setCovered = function(g) {
      this._isCovered = g, this._isCoveredSet = !0;
    }, na.prototype.updateIM = function(g) {
      ie.isTrue(this._label.getGeometryCount() >= 2, "found partial label"), this.computeIM(g);
    }, na.prototype.isInResult = function() {
      return this._isInResult;
    }, na.prototype.isVisited = function() {
      return this._isVisited;
    }, na.prototype.interfaces_ = function() {
      return [];
    }, na.prototype.getClass = function() {
      return na;
    };
    var Cl = function(g) {
      function p() {
        g.call(this), this._coord = null, this._edges = null;
        var E = arguments[0], B = arguments[1];
        this._coord = E, this._edges = B, this._label = new Zn(0, U.NONE);
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.isIncidentEdgeInResult = function() {
        for (var E = this.getEdges().getEdges().iterator(); E.hasNext(); )
          if (E.next().getEdge().isInResult())
            return !0;
        return !1;
      }, p.prototype.isIsolated = function() {
        return this._label.getGeometryCount() === 1;
      }, p.prototype.getCoordinate = function() {
        return this._coord;
      }, p.prototype.print = function(E) {
        E.println("node " + this._coord + " lbl: " + this._label);
      }, p.prototype.computeIM = function(E) {
      }, p.prototype.computeMergedLocation = function(E, B) {
        var D = U.NONE;
        if (D = this._label.getLocation(B), !E.isNull(B)) {
          var j = E.getLocation(B);
          D !== U.BOUNDARY && (D = j);
        }
        return D;
      }, p.prototype.setLabel = function() {
        if (arguments.length !== 2)
          return g.prototype.setLabel.apply(this, arguments);
        var E = arguments[0], B = arguments[1];
        this._label === null ? this._label = new Zn(E, B) : this._label.setLocation(E, B);
      }, p.prototype.getEdges = function() {
        return this._edges;
      }, p.prototype.mergeLabel = function() {
        if (arguments[0] instanceof p) {
          var E = arguments[0];
          this.mergeLabel(E._label);
        } else if (arguments[0] instanceof Zn)
          for (var B = arguments[0], D = 0; D < 2; D++) {
            var j = this.computeMergedLocation(B, D);
            this._label.getLocation(D) === U.NONE && this._label.setLocation(D, j);
          }
      }, p.prototype.add = function(E) {
        this._edges.insert(E), E.setNode(this);
      }, p.prototype.setLabelBoundary = function(E) {
        if (this._label === null)
          return null;
        var B = U.NONE;
        this._label !== null && (B = this._label.getLocation(E));
        var D = null;
        switch (B) {
          case U.BOUNDARY:
            D = U.INTERIOR;
            break;
          case U.INTERIOR:
          default:
            D = U.BOUNDARY;
        }
        this._label.setLocation(E, D);
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(na), La = function() {
      this.nodeMap = new h(), this.nodeFact = null;
      var g = arguments[0];
      this.nodeFact = g;
    };
    La.prototype.find = function(g) {
      return this.nodeMap.get(g);
    }, La.prototype.addNode = function() {
      if (arguments[0] instanceof L) {
        var g = arguments[0], p = this.nodeMap.get(g);
        return p === null && (p = this.nodeFact.createNode(g), this.nodeMap.put(g, p)), p;
      }
      if (arguments[0] instanceof Cl) {
        var E = arguments[0], B = this.nodeMap.get(E.getCoordinate());
        return B === null ? (this.nodeMap.put(E.getCoordinate(), E), E) : (B.mergeLabel(E), B);
      }
    }, La.prototype.print = function(g) {
      for (var p = this.iterator(); p.hasNext(); )
        p.next().print(g);
    }, La.prototype.iterator = function() {
      return this.nodeMap.values().iterator();
    }, La.prototype.values = function() {
      return this.nodeMap.values();
    }, La.prototype.getBoundaryNodes = function(g) {
      for (var p = new We(), E = this.iterator(); E.hasNext(); ) {
        var B = E.next();
        B.getLabel().getLocation(g) === U.BOUNDARY && p.add(B);
      }
      return p;
    }, La.prototype.add = function(g) {
      var p = g.getCoordinate();
      this.addNode(p).add(g);
    }, La.prototype.interfaces_ = function() {
      return [];
    }, La.prototype.getClass = function() {
      return La;
    };
    var ai = function() {
    }, nh = { NE: { configurable: !0 }, NW: { configurable: !0 }, SW: { configurable: !0 }, SE: { configurable: !0 } };
    ai.prototype.interfaces_ = function() {
      return [];
    }, ai.prototype.getClass = function() {
      return ai;
    }, ai.isNorthern = function(g) {
      return g === ai.NE || g === ai.NW;
    }, ai.isOpposite = function(g, p) {
      return g === p ? !1 : (g - p + 4) % 4 === 2;
    }, ai.commonHalfPlane = function(g, p) {
      if (g === p)
        return g;
      if ((g - p + 4) % 4 === 2)
        return -1;
      var E = g < p ? g : p;
      return E === 0 && (g > p ? g : p) === 3 ? 3 : E;
    }, ai.isInHalfPlane = function(g, p) {
      return p === ai.SE ? g === ai.SE || g === ai.SW : g === p || g === p + 1;
    }, ai.quadrant = function() {
      if (typeof arguments[0] == "number" && typeof arguments[1] == "number") {
        var g = arguments[0], p = arguments[1];
        if (g === 0 && p === 0)
          throw new b("Cannot compute the quadrant for point ( " + g + ", " + p + " )");
        return g >= 0 ? p >= 0 ? ai.NE : ai.SE : p >= 0 ? ai.NW : ai.SW;
      }
      if (arguments[0] instanceof L && arguments[1] instanceof L) {
        var E = arguments[0], B = arguments[1];
        if (B.x === E.x && B.y === E.y)
          throw new b("Cannot compute the quadrant for two identical points " + E);
        return B.x >= E.x ? B.y >= E.y ? ai.NE : ai.SE : B.y >= E.y ? ai.NW : ai.SW;
      }
    }, nh.NE.get = function() {
      return 0;
    }, nh.NW.get = function() {
      return 1;
    }, nh.SW.get = function() {
      return 2;
    }, nh.SE.get = function() {
      return 3;
    }, Object.defineProperties(ai, nh);
    var ns = function() {
      if (this._edge = null, this._label = null, this._node = null, this._p0 = null, this._p1 = null, this._dx = null, this._dy = null, this._quadrant = null, arguments.length === 1) {
        var g = arguments[0];
        this._edge = g;
      } else if (arguments.length === 3) {
        var p = arguments[0], E = arguments[1], B = arguments[2];
        this._edge = p, this.init(E, B), this._label = null;
      } else if (arguments.length === 4) {
        var D = arguments[0], j = arguments[1], te = arguments[2], he = arguments[3];
        this._edge = D, this.init(j, te), this._label = he;
      }
    };
    ns.prototype.compareDirection = function(g) {
      return this._dx === g._dx && this._dy === g._dy ? 0 : this._quadrant > g._quadrant ? 1 : this._quadrant < g._quadrant ? -1 : ke.computeOrientation(g._p0, g._p1, this._p1);
    }, ns.prototype.getDy = function() {
      return this._dy;
    }, ns.prototype.getCoordinate = function() {
      return this._p0;
    }, ns.prototype.setNode = function(g) {
      this._node = g;
    }, ns.prototype.print = function(g) {
      var p = Math.atan2(this._dy, this._dx), E = this.getClass().getName(), B = E.lastIndexOf("."), D = E.substring(B + 1);
      g.print("  " + D + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + p + "   " + this._label);
    }, ns.prototype.compareTo = function(g) {
      var p = g;
      return this.compareDirection(p);
    }, ns.prototype.getDirectedCoordinate = function() {
      return this._p1;
    }, ns.prototype.getDx = function() {
      return this._dx;
    }, ns.prototype.getLabel = function() {
      return this._label;
    }, ns.prototype.getEdge = function() {
      return this._edge;
    }, ns.prototype.getQuadrant = function() {
      return this._quadrant;
    }, ns.prototype.getNode = function() {
      return this._node;
    }, ns.prototype.toString = function() {
      var g = Math.atan2(this._dy, this._dx), p = this.getClass().getName(), E = p.lastIndexOf(".");
      return "  " + p.substring(E + 1) + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + g + "   " + this._label;
    }, ns.prototype.computeLabel = function(g) {
    }, ns.prototype.init = function(g, p) {
      this._p0 = g, this._p1 = p, this._dx = p.x - g.x, this._dy = p.y - g.y, this._quadrant = ai.quadrant(this._dx, this._dy), ie.isTrue(!(this._dx === 0 && this._dy === 0), "EdgeEnd with identical endpoints found");
    }, ns.prototype.interfaces_ = function() {
      return [R];
    }, ns.prototype.getClass = function() {
      return ns;
    };
    var pc = function(g) {
      function p() {
        var E = arguments[0], B = arguments[1];
        if (g.call(this, E), this._isForward = null, this._isInResult = !1, this._isVisited = !1, this._sym = null, this._next = null, this._nextMin = null, this._edgeRing = null, this._minEdgeRing = null, this._depth = [0, -999, -999], this._isForward = B, B)
          this.init(E.getCoordinate(0), E.getCoordinate(1));
        else {
          var D = E.getNumPoints() - 1;
          this.init(E.getCoordinate(D), E.getCoordinate(D - 1));
        }
        this.computeDirectedLabel();
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.getNextMin = function() {
        return this._nextMin;
      }, p.prototype.getDepth = function(E) {
        return this._depth[E];
      }, p.prototype.setVisited = function(E) {
        this._isVisited = E;
      }, p.prototype.computeDirectedLabel = function() {
        this._label = new Zn(this._edge.getLabel()), this._isForward || this._label.flip();
      }, p.prototype.getNext = function() {
        return this._next;
      }, p.prototype.setDepth = function(E, B) {
        if (this._depth[E] !== -999 && this._depth[E] !== B)
          throw new lr("assigned depths do not match", this.getCoordinate());
        this._depth[E] = B;
      }, p.prototype.isInteriorAreaEdge = function() {
        for (var E = !0, B = 0; B < 2; B++)
          this._label.isArea(B) && this._label.getLocation(B, Ve.LEFT) === U.INTERIOR && this._label.getLocation(B, Ve.RIGHT) === U.INTERIOR || (E = !1);
        return E;
      }, p.prototype.setNextMin = function(E) {
        this._nextMin = E;
      }, p.prototype.print = function(E) {
        g.prototype.print.call(this, E), E.print(" " + this._depth[Ve.LEFT] + "/" + this._depth[Ve.RIGHT]), E.print(" (" + this.getDepthDelta() + ")"), this._isInResult && E.print(" inResult");
      }, p.prototype.setMinEdgeRing = function(E) {
        this._minEdgeRing = E;
      }, p.prototype.isLineEdge = function() {
        var E = this._label.isLine(0) || this._label.isLine(1), B = !this._label.isArea(0) || this._label.allPositionsEqual(0, U.EXTERIOR), D = !this._label.isArea(1) || this._label.allPositionsEqual(1, U.EXTERIOR);
        return E && B && D;
      }, p.prototype.setEdgeRing = function(E) {
        this._edgeRing = E;
      }, p.prototype.getMinEdgeRing = function() {
        return this._minEdgeRing;
      }, p.prototype.getDepthDelta = function() {
        var E = this._edge.getDepthDelta();
        return this._isForward || (E = -E), E;
      }, p.prototype.setInResult = function(E) {
        this._isInResult = E;
      }, p.prototype.getSym = function() {
        return this._sym;
      }, p.prototype.isForward = function() {
        return this._isForward;
      }, p.prototype.getEdge = function() {
        return this._edge;
      }, p.prototype.printEdge = function(E) {
        this.print(E), E.print(" "), this._isForward ? this._edge.print(E) : this._edge.printReverse(E);
      }, p.prototype.setSym = function(E) {
        this._sym = E;
      }, p.prototype.setVisitedEdge = function(E) {
        this.setVisited(E), this._sym.setVisited(E);
      }, p.prototype.setEdgeDepths = function(E, B) {
        var D = this.getEdge().getDepthDelta();
        this._isForward || (D = -D);
        var j = 1;
        E === Ve.LEFT && (j = -1);
        var te = Ve.opposite(E), he = B + D * j;
        this.setDepth(E, B), this.setDepth(te, he);
      }, p.prototype.getEdgeRing = function() {
        return this._edgeRing;
      }, p.prototype.isInResult = function() {
        return this._isInResult;
      }, p.prototype.setNext = function(E) {
        this._next = E;
      }, p.prototype.isVisited = function() {
        return this._isVisited;
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p.depthFactor = function(E, B) {
        return E === U.EXTERIOR && B === U.INTERIOR ? 1 : E === U.INTERIOR && B === U.EXTERIOR ? -1 : 0;
      }, p;
    }(ns), Ic = function() {
    };
    Ic.prototype.createNode = function(g) {
      return new Cl(g, null);
    }, Ic.prototype.interfaces_ = function() {
      return [];
    }, Ic.prototype.getClass = function() {
      return Ic;
    };
    var Li = function() {
      if (this._edges = new We(), this._nodes = null, this._edgeEndList = new We(), arguments.length === 0)
        this._nodes = new La(new Ic());
      else if (arguments.length === 1) {
        var g = arguments[0];
        this._nodes = new La(g);
      }
    };
    Li.prototype.printEdges = function(g) {
      g.println("Edges:");
      for (var p = 0; p < this._edges.size(); p++) {
        g.println("edge " + p + ":");
        var E = this._edges.get(p);
        E.print(g), E.eiList.print(g);
      }
    }, Li.prototype.find = function(g) {
      return this._nodes.find(g);
    }, Li.prototype.addNode = function() {
      if (arguments[0] instanceof Cl) {
        var g = arguments[0];
        return this._nodes.addNode(g);
      }
      if (arguments[0] instanceof L) {
        var p = arguments[0];
        return this._nodes.addNode(p);
      }
    }, Li.prototype.getNodeIterator = function() {
      return this._nodes.iterator();
    }, Li.prototype.linkResultDirectedEdges = function() {
      for (var g = this._nodes.iterator(); g.hasNext(); )
        g.next().getEdges().linkResultDirectedEdges();
    }, Li.prototype.debugPrintln = function(g) {
      De.out.println(g);
    }, Li.prototype.isBoundaryNode = function(g, p) {
      var E = this._nodes.find(p);
      if (E === null)
        return !1;
      var B = E.getLabel();
      return B !== null && B.getLocation(g) === U.BOUNDARY;
    }, Li.prototype.linkAllDirectedEdges = function() {
      for (var g = this._nodes.iterator(); g.hasNext(); )
        g.next().getEdges().linkAllDirectedEdges();
    }, Li.prototype.matchInSameDirection = function(g, p, E, B) {
      return !!g.equals(E) && ke.computeOrientation(g, p, B) === ke.COLLINEAR && ai.quadrant(g, p) === ai.quadrant(E, B);
    }, Li.prototype.getEdgeEnds = function() {
      return this._edgeEndList;
    }, Li.prototype.debugPrint = function(g) {
      De.out.print(g);
    }, Li.prototype.getEdgeIterator = function() {
      return this._edges.iterator();
    }, Li.prototype.findEdgeInSameDirection = function(g, p) {
      for (var E = 0; E < this._edges.size(); E++) {
        var B = this._edges.get(E), D = B.getCoordinates();
        if (this.matchInSameDirection(g, p, D[0], D[1]) || this.matchInSameDirection(g, p, D[D.length - 1], D[D.length - 2]))
          return B;
      }
      return null;
    }, Li.prototype.insertEdge = function(g) {
      this._edges.add(g);
    }, Li.prototype.findEdgeEnd = function(g) {
      for (var p = this.getEdgeEnds().iterator(); p.hasNext(); ) {
        var E = p.next();
        if (E.getEdge() === g)
          return E;
      }
      return null;
    }, Li.prototype.addEdges = function(g) {
      for (var p = g.iterator(); p.hasNext(); ) {
        var E = p.next();
        this._edges.add(E);
        var B = new pc(E, !0), D = new pc(E, !1);
        B.setSym(D), D.setSym(B), this.add(B), this.add(D);
      }
    }, Li.prototype.add = function(g) {
      this._nodes.add(g), this._edgeEndList.add(g);
    }, Li.prototype.getNodes = function() {
      return this._nodes.values();
    }, Li.prototype.findEdge = function(g, p) {
      for (var E = 0; E < this._edges.size(); E++) {
        var B = this._edges.get(E), D = B.getCoordinates();
        if (g.equals(D[0]) && p.equals(D[1]))
          return B;
      }
      return null;
    }, Li.prototype.interfaces_ = function() {
      return [];
    }, Li.prototype.getClass = function() {
      return Li;
    }, Li.linkResultDirectedEdges = function(g) {
      for (var p = g.iterator(); p.hasNext(); )
        p.next().getEdges().linkResultDirectedEdges();
    };
    var ks = function() {
      this._geometryFactory = null, this._shellList = new We();
      var g = arguments[0];
      this._geometryFactory = g;
    };
    ks.prototype.sortShellsAndHoles = function(g, p, E) {
      for (var B = g.iterator(); B.hasNext(); ) {
        var D = B.next();
        D.isHole() ? E.add(D) : p.add(D);
      }
    }, ks.prototype.computePolygons = function(g) {
      for (var p = new We(), E = g.iterator(); E.hasNext(); ) {
        var B = E.next().toPolygon(this._geometryFactory);
        p.add(B);
      }
      return p;
    }, ks.prototype.placeFreeHoles = function(g, p) {
      for (var E = p.iterator(); E.hasNext(); ) {
        var B = E.next();
        if (B.getShell() === null) {
          var D = this.findEdgeRingContaining(B, g);
          if (D === null)
            throw new lr("unable to assign hole to a shell", B.getCoordinate(0));
          B.setShell(D);
        }
      }
    }, ks.prototype.buildMinimalEdgeRings = function(g, p, E) {
      for (var B = new We(), D = g.iterator(); D.hasNext(); ) {
        var j = D.next();
        if (j.getMaxNodeDegree() > 2) {
          j.linkDirectedEdgesForMinimalEdgeRings();
          var te = j.buildMinimalRings(), he = this.findShell(te);
          he !== null ? (this.placePolygonHoles(he, te), p.add(he)) : E.addAll(te);
        } else
          B.add(j);
      }
      return B;
    }, ks.prototype.containsPoint = function(g) {
      for (var p = this._shellList.iterator(); p.hasNext(); )
        if (p.next().containsPoint(g))
          return !0;
      return !1;
    }, ks.prototype.buildMaximalEdgeRings = function(g) {
      for (var p = new We(), E = g.iterator(); E.hasNext(); ) {
        var B = E.next();
        if (B.isInResult() && B.getLabel().isArea() && B.getEdgeRing() === null) {
          var D = new pm(B, this._geometryFactory);
          p.add(D), D.setInResult();
        }
      }
      return p;
    }, ks.prototype.placePolygonHoles = function(g, p) {
      for (var E = p.iterator(); E.hasNext(); ) {
        var B = E.next();
        B.isHole() && B.setShell(g);
      }
    }, ks.prototype.getPolygons = function() {
      return this.computePolygons(this._shellList);
    }, ks.prototype.findEdgeRingContaining = function(g, p) {
      for (var E = g.getLinearRing(), B = E.getEnvelopeInternal(), D = E.getCoordinateN(0), j = null, te = null, he = p.iterator(); he.hasNext(); ) {
        var ve = he.next(), Le = ve.getLinearRing(), Je = Le.getEnvelopeInternal();
        j !== null && (te = j.getLinearRing().getEnvelopeInternal());
        var et = !1;
        Je.contains(B) && ke.isPointInRing(D, Le.getCoordinates()) && (et = !0), et && (j === null || te.contains(Je)) && (j = ve);
      }
      return j;
    }, ks.prototype.findShell = function(g) {
      for (var p = 0, E = null, B = g.iterator(); B.hasNext(); ) {
        var D = B.next();
        D.isHole() || (E = D, p++);
      }
      return ie.isTrue(p <= 1, "found two shells in MinimalEdgeRing list"), E;
    }, ks.prototype.add = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        this.add(g.getEdgeEnds(), g.getNodes());
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        Li.linkResultDirectedEdges(E);
        var B = this.buildMaximalEdgeRings(p), D = new We(), j = this.buildMinimalEdgeRings(B, this._shellList, D);
        this.sortShellsAndHoles(j, this._shellList, D), this.placeFreeHoles(this._shellList, D);
      }
    }, ks.prototype.interfaces_ = function() {
      return [];
    }, ks.prototype.getClass = function() {
      return ks;
    };
    var Vu = function() {
    };
    Vu.prototype.getBounds = function() {
    }, Vu.prototype.interfaces_ = function() {
      return [];
    }, Vu.prototype.getClass = function() {
      return Vu;
    };
    var zn = function() {
      this._bounds = null, this._item = null;
      var g = arguments[0], p = arguments[1];
      this._bounds = g, this._item = p;
    };
    zn.prototype.getItem = function() {
      return this._item;
    }, zn.prototype.getBounds = function() {
      return this._bounds;
    }, zn.prototype.interfaces_ = function() {
      return [Vu, r];
    }, zn.prototype.getClass = function() {
      return zn;
    };
    var Gr = function() {
      this._size = null, this._items = null, this._size = 0, this._items = new We(), this._items.add(null);
    };
    Gr.prototype.poll = function() {
      if (this.isEmpty())
        return null;
      var g = this._items.get(1);
      return this._items.set(1, this._items.get(this._size)), this._size -= 1, this.reorder(1), g;
    }, Gr.prototype.size = function() {
      return this._size;
    }, Gr.prototype.reorder = function(g) {
      for (var p = null, E = this._items.get(g); 2 * g <= this._size && ((p = 2 * g) !== this._size && this._items.get(p + 1).compareTo(this._items.get(p)) < 0 && p++, this._items.get(p).compareTo(E) < 0); g = p)
        this._items.set(g, this._items.get(p));
      this._items.set(g, E);
    }, Gr.prototype.clear = function() {
      this._size = 0, this._items.clear();
    }, Gr.prototype.isEmpty = function() {
      return this._size === 0;
    }, Gr.prototype.add = function(g) {
      this._items.add(null), this._size += 1;
      var p = this._size;
      for (this._items.set(0, g); g.compareTo(this._items.get(Math.trunc(p / 2))) < 0; p /= 2)
        this._items.set(p, this._items.get(Math.trunc(p / 2)));
      this._items.set(p, g);
    }, Gr.prototype.interfaces_ = function() {
      return [];
    }, Gr.prototype.getClass = function() {
      return Gr;
    };
    var _r = function() {
    };
    _r.prototype.visitItem = function(g) {
    }, _r.prototype.interfaces_ = function() {
      return [];
    }, _r.prototype.getClass = function() {
      return _r;
    };
    var ms = function() {
    };
    ms.prototype.insert = function(g, p) {
    }, ms.prototype.remove = function(g, p) {
    }, ms.prototype.query = function() {
    }, ms.prototype.interfaces_ = function() {
      return [];
    }, ms.prototype.getClass = function() {
      return ms;
    };
    var Mi = function() {
      if (this._childBoundables = new We(), this._bounds = null, this._level = null, arguments.length !== 0) {
        if (arguments.length === 1) {
          var g = arguments[0];
          this._level = g;
        }
      }
    }, mc = { serialVersionUID: { configurable: !0 } };
    Mi.prototype.getLevel = function() {
      return this._level;
    }, Mi.prototype.size = function() {
      return this._childBoundables.size();
    }, Mi.prototype.getChildBoundables = function() {
      return this._childBoundables;
    }, Mi.prototype.addChildBoundable = function(g) {
      ie.isTrue(this._bounds === null), this._childBoundables.add(g);
    }, Mi.prototype.isEmpty = function() {
      return this._childBoundables.isEmpty();
    }, Mi.prototype.getBounds = function() {
      return this._bounds === null && (this._bounds = this.computeBounds()), this._bounds;
    }, Mi.prototype.interfaces_ = function() {
      return [Vu, r];
    }, Mi.prototype.getClass = function() {
      return Mi;
    }, mc.serialVersionUID.get = function() {
      return 6493722185909574e3;
    }, Object.defineProperties(Mi, mc);
    var EA = function() {
    };
    EA.reverseOrder = function() {
      return { compare: function(g, p) {
        return p.compareTo(g);
      } };
    }, EA.min = function(g) {
      return EA.sort(g), g.get(0);
    }, EA.sort = function(g, p) {
      var E = g.toArray();
      p ? xt.sort(E, p) : xt.sort(E);
      for (var B = g.iterator(), D = 0, j = E.length; D < j; D++)
        B.next(), B.set(E[D]);
    }, EA.singletonList = function(g) {
      var p = new We();
      return p.add(g), p;
    };
    var co = function() {
      this._boundable1 = null, this._boundable2 = null, this._distance = null, this._itemDistance = null;
      var g = arguments[0], p = arguments[1], E = arguments[2];
      this._boundable1 = g, this._boundable2 = p, this._itemDistance = E, this._distance = this.distance();
    };
    co.prototype.expandToQueue = function(g, p) {
      var E = co.isComposite(this._boundable1), B = co.isComposite(this._boundable2);
      if (E && B)
        return co.area(this._boundable1) > co.area(this._boundable2) ? (this.expand(this._boundable1, this._boundable2, g, p), null) : (this.expand(this._boundable2, this._boundable1, g, p), null);
      if (E)
        return this.expand(this._boundable1, this._boundable2, g, p), null;
      if (B)
        return this.expand(this._boundable2, this._boundable1, g, p), null;
      throw new b("neither boundable is composite");
    }, co.prototype.isLeaves = function() {
      return !(co.isComposite(this._boundable1) || co.isComposite(this._boundable2));
    }, co.prototype.compareTo = function(g) {
      var p = g;
      return this._distance < p._distance ? -1 : this._distance > p._distance ? 1 : 0;
    }, co.prototype.expand = function(g, p, E, B) {
      for (var D = g.getChildBoundables().iterator(); D.hasNext(); ) {
        var j = D.next(), te = new co(j, p, this._itemDistance);
        te.getDistance() < B && E.add(te);
      }
    }, co.prototype.getBoundable = function(g) {
      return g === 0 ? this._boundable1 : this._boundable2;
    }, co.prototype.getDistance = function() {
      return this._distance;
    }, co.prototype.distance = function() {
      return this.isLeaves() ? this._itemDistance.distance(this._boundable1, this._boundable2) : this._boundable1.getBounds().distance(this._boundable2.getBounds());
    }, co.prototype.interfaces_ = function() {
      return [R];
    }, co.prototype.getClass = function() {
      return co;
    }, co.area = function(g) {
      return g.getBounds().getArea();
    }, co.isComposite = function(g) {
      return g instanceof Mi;
    };
    var uo = function g() {
      if (this._root = null, this._built = !1, this._itemBoundables = new We(), this._nodeCapacity = null, arguments.length === 0) {
        var p = g.DEFAULT_NODE_CAPACITY;
        this._nodeCapacity = p;
      } else if (arguments.length === 1) {
        var E = arguments[0];
        ie.isTrue(E > 1, "Node capacity must be greater than 1"), this._nodeCapacity = E;
      }
    }, ou = { IntersectsOp: { configurable: !0 }, serialVersionUID: { configurable: !0 }, DEFAULT_NODE_CAPACITY: { configurable: !0 } };
    uo.prototype.getNodeCapacity = function() {
      return this._nodeCapacity;
    }, uo.prototype.lastNode = function(g) {
      return g.get(g.size() - 1);
    }, uo.prototype.size = function() {
      if (arguments.length === 0)
        return this.isEmpty() ? 0 : (this.build(), this.size(this._root));
      if (arguments.length === 1) {
        for (var g = 0, p = arguments[0].getChildBoundables().iterator(); p.hasNext(); ) {
          var E = p.next();
          E instanceof Mi ? g += this.size(E) : E instanceof zn && (g += 1);
        }
        return g;
      }
    }, uo.prototype.removeItem = function(g, p) {
      for (var E = null, B = g.getChildBoundables().iterator(); B.hasNext(); ) {
        var D = B.next();
        D instanceof zn && D.getItem() === p && (E = D);
      }
      return E !== null && (g.getChildBoundables().remove(E), !0);
    }, uo.prototype.itemsTree = function() {
      if (arguments.length === 0) {
        this.build();
        var g = this.itemsTree(this._root);
        return g === null ? new We() : g;
      }
      if (arguments.length === 1) {
        for (var p = arguments[0], E = new We(), B = p.getChildBoundables().iterator(); B.hasNext(); ) {
          var D = B.next();
          if (D instanceof Mi) {
            var j = this.itemsTree(D);
            j !== null && E.add(j);
          } else
            D instanceof zn ? E.add(D.getItem()) : ie.shouldNeverReachHere();
        }
        return E.size() <= 0 ? null : E;
      }
    }, uo.prototype.insert = function(g, p) {
      ie.isTrue(!this._built, "Cannot insert items into an STR packed R-tree after it has been built."), this._itemBoundables.add(new zn(g, p));
    }, uo.prototype.boundablesAtLevel = function() {
      if (arguments.length === 1) {
        var g = arguments[0], p = new We();
        return this.boundablesAtLevel(g, this._root, p), p;
      }
      if (arguments.length === 3) {
        var E = arguments[0], B = arguments[1], D = arguments[2];
        if (ie.isTrue(E > -2), B.getLevel() === E)
          return D.add(B), null;
        for (var j = B.getChildBoundables().iterator(); j.hasNext(); ) {
          var te = j.next();
          te instanceof Mi ? this.boundablesAtLevel(E, te, D) : (ie.isTrue(te instanceof zn), E === -1 && D.add(te));
        }
        return null;
      }
    }, uo.prototype.query = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        this.build();
        var p = new We();
        return this.isEmpty() || this.getIntersectsOp().intersects(this._root.getBounds(), g) && this.query(g, this._root, p), p;
      }
      if (arguments.length === 2) {
        var E = arguments[0], B = arguments[1];
        if (this.build(), this.isEmpty())
          return null;
        this.getIntersectsOp().intersects(this._root.getBounds(), E) && this.query(E, this._root, B);
      } else if (arguments.length === 3) {
        if (K(arguments[2], _r) && arguments[0] instanceof Object && arguments[1] instanceof Mi)
          for (var D = arguments[0], j = arguments[1], te = arguments[2], he = j.getChildBoundables(), ve = 0; ve < he.size(); ve++) {
            var Le = he.get(ve);
            this.getIntersectsOp().intersects(Le.getBounds(), D) && (Le instanceof Mi ? this.query(D, Le, te) : Le instanceof zn ? te.visitItem(Le.getItem()) : ie.shouldNeverReachHere());
          }
        else if (K(arguments[2], hn) && arguments[0] instanceof Object && arguments[1] instanceof Mi)
          for (var Je = arguments[0], et = arguments[1], Ke = arguments[2], ot = et.getChildBoundables(), je = 0; je < ot.size(); je++) {
            var Et = ot.get(je);
            this.getIntersectsOp().intersects(Et.getBounds(), Je) && (Et instanceof Mi ? this.query(Je, Et, Ke) : Et instanceof zn ? Ke.add(Et.getItem()) : ie.shouldNeverReachHere());
          }
      }
    }, uo.prototype.build = function() {
      if (this._built)
        return null;
      this._root = this._itemBoundables.isEmpty() ? this.createNode(0) : this.createHigherLevels(this._itemBoundables, -1), this._itemBoundables = null, this._built = !0;
    }, uo.prototype.getRoot = function() {
      return this.build(), this._root;
    }, uo.prototype.remove = function() {
      if (arguments.length === 2) {
        var g = arguments[0], p = arguments[1];
        return this.build(), !!this.getIntersectsOp().intersects(this._root.getBounds(), g) && this.remove(g, this._root, p);
      }
      if (arguments.length === 3) {
        var E = arguments[0], B = arguments[1], D = arguments[2], j = this.removeItem(B, D);
        if (j)
          return !0;
        for (var te = null, he = B.getChildBoundables().iterator(); he.hasNext(); ) {
          var ve = he.next();
          if (this.getIntersectsOp().intersects(ve.getBounds(), E) && ve instanceof Mi && (j = this.remove(E, ve, D))) {
            te = ve;
            break;
          }
        }
        return te !== null && te.getChildBoundables().isEmpty() && B.getChildBoundables().remove(te), j;
      }
    }, uo.prototype.createHigherLevels = function(g, p) {
      ie.isTrue(!g.isEmpty());
      var E = this.createParentBoundables(g, p + 1);
      return E.size() === 1 ? E.get(0) : this.createHigherLevels(E, p + 1);
    }, uo.prototype.depth = function() {
      if (arguments.length === 0)
        return this.isEmpty() ? 0 : (this.build(), this.depth(this._root));
      if (arguments.length === 1) {
        for (var g = 0, p = arguments[0].getChildBoundables().iterator(); p.hasNext(); ) {
          var E = p.next();
          if (E instanceof Mi) {
            var B = this.depth(E);
            B > g && (g = B);
          }
        }
        return g + 1;
      }
    }, uo.prototype.createParentBoundables = function(g, p) {
      ie.isTrue(!g.isEmpty());
      var E = new We();
      E.add(this.createNode(p));
      var B = new We(g);
      EA.sort(B, this.getComparator());
      for (var D = B.iterator(); D.hasNext(); ) {
        var j = D.next();
        this.lastNode(E).getChildBoundables().size() === this.getNodeCapacity() && E.add(this.createNode(p)), this.lastNode(E).addChildBoundable(j);
      }
      return E;
    }, uo.prototype.isEmpty = function() {
      return this._built ? this._root.isEmpty() : this._itemBoundables.isEmpty();
    }, uo.prototype.interfaces_ = function() {
      return [r];
    }, uo.prototype.getClass = function() {
      return uo;
    }, uo.compareDoubles = function(g, p) {
      return g > p ? 1 : g < p ? -1 : 0;
    }, ou.IntersectsOp.get = function() {
      return F1;
    }, ou.serialVersionUID.get = function() {
      return -3886435814360241e3;
    }, ou.DEFAULT_NODE_CAPACITY.get = function() {
      return 10;
    }, Object.defineProperties(uo, ou);
    var F1 = function() {
    }, Kf = function() {
    };
    Kf.prototype.distance = function(g, p) {
    }, Kf.prototype.interfaces_ = function() {
      return [];
    }, Kf.prototype.getClass = function() {
      return Kf;
    };
    var S0 = function(g) {
      function p(B) {
        B = B || p.DEFAULT_NODE_CAPACITY, g.call(this, B);
      }
      g && (p.__proto__ = g), (p.prototype = Object.create(g && g.prototype)).constructor = p;
      var E = { STRtreeNode: { configurable: !0 }, serialVersionUID: { configurable: !0 }, xComparator: { configurable: !0 }, yComparator: { configurable: !0 }, intersectsOp: { configurable: !0 }, DEFAULT_NODE_CAPACITY: { configurable: !0 } };
      return p.prototype.createParentBoundablesFromVerticalSlices = function(B, D) {
        ie.isTrue(B.length > 0);
        for (var j = new We(), te = 0; te < B.length; te++)
          j.addAll(this.createParentBoundablesFromVerticalSlice(B[te], D));
        return j;
      }, p.prototype.createNode = function(B) {
        return new Wf(B);
      }, p.prototype.size = function() {
        return arguments.length === 0 ? g.prototype.size.call(this) : g.prototype.size.apply(this, arguments);
      }, p.prototype.insert = function() {
        if (arguments.length !== 2)
          return g.prototype.insert.apply(this, arguments);
        var B = arguments[0], D = arguments[1];
        if (B.isNull())
          return null;
        g.prototype.insert.call(this, B, D);
      }, p.prototype.getIntersectsOp = function() {
        return p.intersectsOp;
      }, p.prototype.verticalSlices = function(B, D) {
        for (var j = Math.trunc(Math.ceil(B.size() / D)), te = new Array(D).fill(null), he = B.iterator(), ve = 0; ve < D; ve++) {
          te[ve] = new We();
          for (var Le = 0; he.hasNext() && Le < j; ) {
            var Je = he.next();
            te[ve].add(Je), Le++;
          }
        }
        return te;
      }, p.prototype.query = function() {
        if (arguments.length === 1) {
          var B = arguments[0];
          return g.prototype.query.call(this, B);
        }
        if (arguments.length === 2) {
          var D = arguments[0], j = arguments[1];
          g.prototype.query.call(this, D, j);
        } else if (arguments.length === 3) {
          if (K(arguments[2], _r) && arguments[0] instanceof Object && arguments[1] instanceof Mi) {
            var te = arguments[0], he = arguments[1], ve = arguments[2];
            g.prototype.query.call(this, te, he, ve);
          } else if (K(arguments[2], hn) && arguments[0] instanceof Object && arguments[1] instanceof Mi) {
            var Le = arguments[0], Je = arguments[1], et = arguments[2];
            g.prototype.query.call(this, Le, Je, et);
          }
        }
      }, p.prototype.getComparator = function() {
        return p.yComparator;
      }, p.prototype.createParentBoundablesFromVerticalSlice = function(B, D) {
        return g.prototype.createParentBoundables.call(this, B, D);
      }, p.prototype.remove = function() {
        if (arguments.length === 2) {
          var B = arguments[0], D = arguments[1];
          return g.prototype.remove.call(this, B, D);
        }
        return g.prototype.remove.apply(this, arguments);
      }, p.prototype.depth = function() {
        return arguments.length === 0 ? g.prototype.depth.call(this) : g.prototype.depth.apply(this, arguments);
      }, p.prototype.createParentBoundables = function(B, D) {
        ie.isTrue(!B.isEmpty());
        var j = Math.trunc(Math.ceil(B.size() / this.getNodeCapacity())), te = new We(B);
        EA.sort(te, p.xComparator);
        var he = this.verticalSlices(te, Math.trunc(Math.ceil(Math.sqrt(j))));
        return this.createParentBoundablesFromVerticalSlices(he, D);
      }, p.prototype.nearestNeighbour = function() {
        if (arguments.length === 1) {
          if (K(arguments[0], Kf)) {
            var B = arguments[0], D = new co(this.getRoot(), this.getRoot(), B);
            return this.nearestNeighbour(D);
          }
          if (arguments[0] instanceof co) {
            var j = arguments[0];
            return this.nearestNeighbour(j, Q.POSITIVE_INFINITY);
          }
        } else if (arguments.length === 2) {
          if (arguments[0] instanceof p && K(arguments[1], Kf)) {
            var te = arguments[0], he = arguments[1], ve = new co(this.getRoot(), te.getRoot(), he);
            return this.nearestNeighbour(ve);
          }
          if (arguments[0] instanceof co && typeof arguments[1] == "number") {
            var Le = arguments[0], Je = arguments[1], et = null, Ke = new Gr();
            for (Ke.add(Le); !Ke.isEmpty() && Je > 0; ) {
              var ot = Ke.poll(), je = ot.getDistance();
              if (je >= Je)
                break;
              ot.isLeaves() ? (Je = je, et = ot) : ot.expandToQueue(Ke, Je);
            }
            return [et.getBoundable(0).getItem(), et.getBoundable(1).getItem()];
          }
        } else if (arguments.length === 3) {
          var Et = arguments[0], Gt = arguments[1], kt = arguments[2], bt = new zn(Et, Gt), Yn = new co(this.getRoot(), bt, kt);
          return this.nearestNeighbour(Yn)[0];
        }
      }, p.prototype.interfaces_ = function() {
        return [ms, r];
      }, p.prototype.getClass = function() {
        return p;
      }, p.centreX = function(B) {
        return p.avg(B.getMinX(), B.getMaxX());
      }, p.avg = function(B, D) {
        return (B + D) / 2;
      }, p.centreY = function(B) {
        return p.avg(B.getMinY(), B.getMaxY());
      }, E.STRtreeNode.get = function() {
        return Wf;
      }, E.serialVersionUID.get = function() {
        return 259274702368956900;
      }, E.xComparator.get = function() {
        return { interfaces_: function() {
          return [O];
        }, compare: function(B, D) {
          return g.compareDoubles(p.centreX(B.getBounds()), p.centreX(D.getBounds()));
        } };
      }, E.yComparator.get = function() {
        return { interfaces_: function() {
          return [O];
        }, compare: function(B, D) {
          return g.compareDoubles(p.centreY(B.getBounds()), p.centreY(D.getBounds()));
        } };
      }, E.intersectsOp.get = function() {
        return { interfaces_: function() {
          return [g.IntersectsOp];
        }, intersects: function(B, D) {
          return B.intersects(D);
        } };
      }, E.DEFAULT_NODE_CAPACITY.get = function() {
        return 10;
      }, Object.defineProperties(p, E), p;
    }(uo), Wf = function(g) {
      function p() {
        var E = arguments[0];
        g.call(this, E);
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.computeBounds = function() {
        for (var E = null, B = this.getChildBoundables().iterator(); B.hasNext(); ) {
          var D = B.next();
          E === null ? E = new Te(D.getBounds()) : E.expandToInclude(D.getBounds());
        }
        return E;
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(Mi), fo = function() {
    };
    fo.prototype.interfaces_ = function() {
      return [];
    }, fo.prototype.getClass = function() {
      return fo;
    }, fo.relativeSign = function(g, p) {
      return g < p ? -1 : g > p ? 1 : 0;
    }, fo.compare = function(g, p, E) {
      if (p.equals2D(E))
        return 0;
      var B = fo.relativeSign(p.x, E.x), D = fo.relativeSign(p.y, E.y);
      switch (g) {
        case 0:
          return fo.compareValue(B, D);
        case 1:
          return fo.compareValue(D, B);
        case 2:
          return fo.compareValue(D, -B);
        case 3:
          return fo.compareValue(-B, D);
        case 4:
          return fo.compareValue(-B, -D);
        case 5:
          return fo.compareValue(-D, -B);
        case 6:
          return fo.compareValue(-D, B);
        case 7:
          return fo.compareValue(B, -D);
      }
      return ie.shouldNeverReachHere("invalid octant value"), 0;
    }, fo.compareValue = function(g, p) {
      return g < 0 ? -1 : g > 0 ? 1 : p < 0 ? -1 : p > 0 ? 1 : 0;
    };
    var yo = function() {
      this._segString = null, this.coord = null, this.segmentIndex = null, this._segmentOctant = null, this._isInterior = null;
      var g = arguments[0], p = arguments[1], E = arguments[2], B = arguments[3];
      this._segString = g, this.coord = new L(p), this.segmentIndex = E, this._segmentOctant = B, this._isInterior = !p.equals2D(g.getCoordinate(E));
    };
    yo.prototype.getCoordinate = function() {
      return this.coord;
    }, yo.prototype.print = function(g) {
      g.print(this.coord), g.print(" seg # = " + this.segmentIndex);
    }, yo.prototype.compareTo = function(g) {
      var p = g;
      return this.segmentIndex < p.segmentIndex ? -1 : this.segmentIndex > p.segmentIndex ? 1 : this.coord.equals2D(p.coord) ? 0 : fo.compare(this._segmentOctant, this.coord, p.coord);
    }, yo.prototype.isEndPoint = function(g) {
      return this.segmentIndex === 0 && !this._isInterior || this.segmentIndex === g;
    }, yo.prototype.isInterior = function() {
      return this._isInterior;
    }, yo.prototype.interfaces_ = function() {
      return [R];
    }, yo.prototype.getClass = function() {
      return yo;
    };
    var Gs = function() {
      this._nodeMap = new h(), this._edge = null;
      var g = arguments[0];
      this._edge = g;
    };
    Gs.prototype.getSplitCoordinates = function() {
      var g = new qn();
      this.addEndpoints();
      for (var p = this.iterator(), E = p.next(); p.hasNext(); ) {
        var B = p.next();
        this.addEdgeCoordinates(E, B, g), E = B;
      }
      return g.toCoordinateArray();
    }, Gs.prototype.addCollapsedNodes = function() {
      var g = new We();
      this.findCollapsesFromInsertedNodes(g), this.findCollapsesFromExistingVertices(g);
      for (var p = g.iterator(); p.hasNext(); ) {
        var E = p.next().intValue();
        this.add(this._edge.getCoordinate(E), E);
      }
    }, Gs.prototype.print = function(g) {
      g.println("Intersections:");
      for (var p = this.iterator(); p.hasNext(); )
        p.next().print(g);
    }, Gs.prototype.findCollapsesFromExistingVertices = function(g) {
      for (var p = 0; p < this._edge.size() - 2; p++) {
        var E = this._edge.getCoordinate(p), B = this._edge.getCoordinate(p + 2);
        E.equals2D(B) && g.add(new Z(p + 1));
      }
    }, Gs.prototype.addEdgeCoordinates = function(g, p, E) {
      var B = this._edge.getCoordinate(p.segmentIndex), D = p.isInterior() || !p.coord.equals2D(B);
      E.add(new L(g.coord), !1);
      for (var j = g.segmentIndex + 1; j <= p.segmentIndex; j++)
        E.add(this._edge.getCoordinate(j));
      D && E.add(new L(p.coord));
    }, Gs.prototype.iterator = function() {
      return this._nodeMap.values().iterator();
    }, Gs.prototype.addSplitEdges = function(g) {
      this.addEndpoints(), this.addCollapsedNodes();
      for (var p = this.iterator(), E = p.next(); p.hasNext(); ) {
        var B = p.next(), D = this.createSplitEdge(E, B);
        g.add(D), E = B;
      }
    }, Gs.prototype.findCollapseIndex = function(g, p, E) {
      if (!g.coord.equals2D(p.coord))
        return !1;
      var B = p.segmentIndex - g.segmentIndex;
      return p.isInterior() || B--, B === 1 && (E[0] = g.segmentIndex + 1, !0);
    }, Gs.prototype.findCollapsesFromInsertedNodes = function(g) {
      for (var p = new Array(1).fill(null), E = this.iterator(), B = E.next(); E.hasNext(); ) {
        var D = E.next();
        this.findCollapseIndex(B, D, p) && g.add(new Z(p[0])), B = D;
      }
    }, Gs.prototype.getEdge = function() {
      return this._edge;
    }, Gs.prototype.addEndpoints = function() {
      var g = this._edge.size() - 1;
      this.add(this._edge.getCoordinate(0), 0), this.add(this._edge.getCoordinate(g), g);
    }, Gs.prototype.createSplitEdge = function(g, p) {
      var E = p.segmentIndex - g.segmentIndex + 2, B = this._edge.getCoordinate(p.segmentIndex), D = p.isInterior() || !p.coord.equals2D(B);
      D || E--;
      var j = new Array(E).fill(null), te = 0;
      j[te++] = new L(g.coord);
      for (var he = g.segmentIndex + 1; he <= p.segmentIndex; he++)
        j[te++] = this._edge.getCoordinate(he);
      return D && (j[te] = new L(p.coord)), new ki(j, this._edge.getData());
    }, Gs.prototype.add = function(g, p) {
      var E = new yo(this._edge, g, p, this._edge.getSegmentOctant(p)), B = this._nodeMap.get(E);
      return B !== null ? (ie.isTrue(B.coord.equals2D(g), "Found equal nodes with different coordinates"), B) : (this._nodeMap.put(E, E), E);
    }, Gs.prototype.checkSplitEdgesCorrectness = function(g) {
      var p = this._edge.getCoordinates(), E = g.get(0).getCoordinate(0);
      if (!E.equals2D(p[0]))
        throw new Ee("bad split edge start point at " + E);
      var B = g.get(g.size() - 1).getCoordinates(), D = B[B.length - 1];
      if (!D.equals2D(p[p.length - 1]))
        throw new Ee("bad split edge end point at " + D);
    }, Gs.prototype.interfaces_ = function() {
      return [];
    }, Gs.prototype.getClass = function() {
      return Gs;
    };
    var Ju = function() {
    };
    Ju.prototype.interfaces_ = function() {
      return [];
    }, Ju.prototype.getClass = function() {
      return Ju;
    }, Ju.octant = function() {
      if (typeof arguments[0] == "number" && typeof arguments[1] == "number") {
        var g = arguments[0], p = arguments[1];
        if (g === 0 && p === 0)
          throw new b("Cannot compute the octant for point ( " + g + ", " + p + " )");
        var E = Math.abs(g), B = Math.abs(p);
        return g >= 0 ? p >= 0 ? E >= B ? 0 : 1 : E >= B ? 7 : 6 : p >= 0 ? E >= B ? 3 : 2 : E >= B ? 4 : 5;
      }
      if (arguments[0] instanceof L && arguments[1] instanceof L) {
        var D = arguments[0], j = arguments[1], te = j.x - D.x, he = j.y - D.y;
        if (te === 0 && he === 0)
          throw new b("Cannot compute the octant for two identical points " + D);
        return Ju.octant(te, he);
      }
    };
    var Cc = function() {
    };
    Cc.prototype.getCoordinates = function() {
    }, Cc.prototype.size = function() {
    }, Cc.prototype.getCoordinate = function(g) {
    }, Cc.prototype.isClosed = function() {
    }, Cc.prototype.setData = function(g) {
    }, Cc.prototype.getData = function() {
    }, Cc.prototype.interfaces_ = function() {
      return [];
    }, Cc.prototype.getClass = function() {
      return Cc;
    };
    var Q0 = function() {
    };
    Q0.prototype.addIntersection = function(g, p) {
    }, Q0.prototype.interfaces_ = function() {
      return [Cc];
    }, Q0.prototype.getClass = function() {
      return Q0;
    };
    var ki = function() {
      this._nodeList = new Gs(this), this._pts = null, this._data = null;
      var g = arguments[0], p = arguments[1];
      this._pts = g, this._data = p;
    };
    ki.prototype.getCoordinates = function() {
      return this._pts;
    }, ki.prototype.size = function() {
      return this._pts.length;
    }, ki.prototype.getCoordinate = function(g) {
      return this._pts[g];
    }, ki.prototype.isClosed = function() {
      return this._pts[0].equals(this._pts[this._pts.length - 1]);
    }, ki.prototype.getSegmentOctant = function(g) {
      return g === this._pts.length - 1 ? -1 : this.safeOctant(this.getCoordinate(g), this.getCoordinate(g + 1));
    }, ki.prototype.setData = function(g) {
      this._data = g;
    }, ki.prototype.safeOctant = function(g, p) {
      return g.equals2D(p) ? 0 : Ju.octant(g, p);
    }, ki.prototype.getData = function() {
      return this._data;
    }, ki.prototype.addIntersection = function() {
      if (arguments.length === 2) {
        var g = arguments[0], p = arguments[1];
        this.addIntersectionNode(g, p);
      } else if (arguments.length === 4) {
        var E = arguments[0], B = arguments[1], D = arguments[3], j = new L(E.getIntersection(D));
        this.addIntersection(j, B);
      }
    }, ki.prototype.toString = function() {
      return Re.toLineString(new In(this._pts));
    }, ki.prototype.getNodeList = function() {
      return this._nodeList;
    }, ki.prototype.addIntersectionNode = function(g, p) {
      var E = p, B = E + 1;
      if (B < this._pts.length) {
        var D = this._pts[B];
        g.equals2D(D) && (E = B);
      }
      return this._nodeList.add(g, E);
    }, ki.prototype.addIntersections = function(g, p, E) {
      for (var B = 0; B < g.getIntersectionNum(); B++)
        this.addIntersection(g, p, E, B);
    }, ki.prototype.interfaces_ = function() {
      return [Q0];
    }, ki.prototype.getClass = function() {
      return ki;
    }, ki.getNodedSubstrings = function() {
      if (arguments.length === 1) {
        var g = arguments[0], p = new We();
        return ki.getNodedSubstrings(g, p), p;
      }
      if (arguments.length === 2)
        for (var E = arguments[0], B = arguments[1], D = E.iterator(); D.hasNext(); )
          D.next().getNodeList().addSplitEdges(B);
    };
    var Dn = function() {
      if (this.p0 = null, this.p1 = null, arguments.length === 0)
        this.p0 = new L(), this.p1 = new L();
      else if (arguments.length === 1) {
        var g = arguments[0];
        this.p0 = new L(g.p0), this.p1 = new L(g.p1);
      } else if (arguments.length === 2)
        this.p0 = arguments[0], this.p1 = arguments[1];
      else if (arguments.length === 4) {
        var p = arguments[0], E = arguments[1], B = arguments[2], D = arguments[3];
        this.p0 = new L(p, E), this.p1 = new L(B, D);
      }
    }, P1 = { serialVersionUID: { configurable: !0 } };
    Dn.prototype.minX = function() {
      return Math.min(this.p0.x, this.p1.x);
    }, Dn.prototype.orientationIndex = function() {
      if (arguments[0] instanceof Dn) {
        var g = arguments[0], p = ke.orientationIndex(this.p0, this.p1, g.p0), E = ke.orientationIndex(this.p0, this.p1, g.p1);
        return p >= 0 && E >= 0 || p <= 0 && E <= 0 ? Math.max(p, E) : 0;
      }
      if (arguments[0] instanceof L) {
        var B = arguments[0];
        return ke.orientationIndex(this.p0, this.p1, B);
      }
    }, Dn.prototype.toGeometry = function(g) {
      return g.createLineString([this.p0, this.p1]);
    }, Dn.prototype.isVertical = function() {
      return this.p0.x === this.p1.x;
    }, Dn.prototype.equals = function(g) {
      if (!(g instanceof Dn))
        return !1;
      var p = g;
      return this.p0.equals(p.p0) && this.p1.equals(p.p1);
    }, Dn.prototype.intersection = function(g) {
      var p = new we();
      return p.computeIntersection(this.p0, this.p1, g.p0, g.p1), p.hasIntersection() ? p.getIntersection(0) : null;
    }, Dn.prototype.project = function() {
      if (arguments[0] instanceof L) {
        var g = arguments[0];
        if (g.equals(this.p0) || g.equals(this.p1))
          return new L(g);
        var p = this.projectionFactor(g), E = new L();
        return E.x = this.p0.x + p * (this.p1.x - this.p0.x), E.y = this.p0.y + p * (this.p1.y - this.p0.y), E;
      }
      if (arguments[0] instanceof Dn) {
        var B = arguments[0], D = this.projectionFactor(B.p0), j = this.projectionFactor(B.p1);
        if (D >= 1 && j >= 1 || D <= 0 && j <= 0)
          return null;
        var te = this.project(B.p0);
        D < 0 && (te = this.p0), D > 1 && (te = this.p1);
        var he = this.project(B.p1);
        return j < 0 && (he = this.p0), j > 1 && (he = this.p1), new Dn(te, he);
      }
    }, Dn.prototype.normalize = function() {
      this.p1.compareTo(this.p0) < 0 && this.reverse();
    }, Dn.prototype.angle = function() {
      return Math.atan2(this.p1.y - this.p0.y, this.p1.x - this.p0.x);
    }, Dn.prototype.getCoordinate = function(g) {
      return g === 0 ? this.p0 : this.p1;
    }, Dn.prototype.distancePerpendicular = function(g) {
      return ke.distancePointLinePerpendicular(g, this.p0, this.p1);
    }, Dn.prototype.minY = function() {
      return Math.min(this.p0.y, this.p1.y);
    }, Dn.prototype.midPoint = function() {
      return Dn.midPoint(this.p0, this.p1);
    }, Dn.prototype.projectionFactor = function(g) {
      if (g.equals(this.p0))
        return 0;
      if (g.equals(this.p1))
        return 1;
      var p = this.p1.x - this.p0.x, E = this.p1.y - this.p0.y, B = p * p + E * E;
      return B <= 0 ? Q.NaN : ((g.x - this.p0.x) * p + (g.y - this.p0.y) * E) / B;
    }, Dn.prototype.closestPoints = function(g) {
      var p = this.intersection(g);
      if (p !== null)
        return [p, p];
      var E = new Array(2).fill(null), B = Q.MAX_VALUE, D = null, j = this.closestPoint(g.p0);
      B = j.distance(g.p0), E[0] = j, E[1] = g.p0;
      var te = this.closestPoint(g.p1);
      (D = te.distance(g.p1)) < B && (B = D, E[0] = te, E[1] = g.p1);
      var he = g.closestPoint(this.p0);
      (D = he.distance(this.p0)) < B && (B = D, E[0] = this.p0, E[1] = he);
      var ve = g.closestPoint(this.p1);
      return (D = ve.distance(this.p1)) < B && (B = D, E[0] = this.p1, E[1] = ve), E;
    }, Dn.prototype.closestPoint = function(g) {
      var p = this.projectionFactor(g);
      return p > 0 && p < 1 ? this.project(g) : this.p0.distance(g) < this.p1.distance(g) ? this.p0 : this.p1;
    }, Dn.prototype.maxX = function() {
      return Math.max(this.p0.x, this.p1.x);
    }, Dn.prototype.getLength = function() {
      return this.p0.distance(this.p1);
    }, Dn.prototype.compareTo = function(g) {
      var p = g, E = this.p0.compareTo(p.p0);
      return E !== 0 ? E : this.p1.compareTo(p.p1);
    }, Dn.prototype.reverse = function() {
      var g = this.p0;
      this.p0 = this.p1, this.p1 = g;
    }, Dn.prototype.equalsTopo = function(g) {
      return this.p0.equals(g.p0) && (this.p1.equals(g.p1) || this.p0.equals(g.p1)) && this.p1.equals(g.p0);
    }, Dn.prototype.lineIntersection = function(g) {
      try {
        return Ue.intersection(this.p0, this.p1, g.p0, g.p1);
      } catch (p) {
        if (!(p instanceof Se))
          throw p;
      }
      return null;
    }, Dn.prototype.maxY = function() {
      return Math.max(this.p0.y, this.p1.y);
    }, Dn.prototype.pointAlongOffset = function(g, p) {
      var E = this.p0.x + g * (this.p1.x - this.p0.x), B = this.p0.y + g * (this.p1.y - this.p0.y), D = this.p1.x - this.p0.x, j = this.p1.y - this.p0.y, te = Math.sqrt(D * D + j * j), he = 0, ve = 0;
      if (p !== 0) {
        if (te <= 0)
          throw new Error("Cannot compute offset from zero-length line segment");
        he = p * D / te, ve = p * j / te;
      }
      return new L(E - ve, B + he);
    }, Dn.prototype.setCoordinates = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        this.setCoordinates(g.p0, g.p1);
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        this.p0.x = p.x, this.p0.y = p.y, this.p1.x = E.x, this.p1.y = E.y;
      }
    }, Dn.prototype.segmentFraction = function(g) {
      var p = this.projectionFactor(g);
      return p < 0 ? p = 0 : (p > 1 || Q.isNaN(p)) && (p = 1), p;
    }, Dn.prototype.toString = function() {
      return "LINESTRING( " + this.p0.x + " " + this.p0.y + ", " + this.p1.x + " " + this.p1.y + ")";
    }, Dn.prototype.isHorizontal = function() {
      return this.p0.y === this.p1.y;
    }, Dn.prototype.distance = function() {
      if (arguments[0] instanceof Dn) {
        var g = arguments[0];
        return ke.distanceLineLine(this.p0, this.p1, g.p0, g.p1);
      }
      if (arguments[0] instanceof L) {
        var p = arguments[0];
        return ke.distancePointLine(p, this.p0, this.p1);
      }
    }, Dn.prototype.pointAlong = function(g) {
      var p = new L();
      return p.x = this.p0.x + g * (this.p1.x - this.p0.x), p.y = this.p0.y + g * (this.p1.y - this.p0.y), p;
    }, Dn.prototype.hashCode = function() {
      var g = Q.doubleToLongBits(this.p0.x);
      g ^= 31 * Q.doubleToLongBits(this.p0.y);
      var p = Math.trunc(g) ^ Math.trunc(g >> 32), E = Q.doubleToLongBits(this.p1.x);
      return E ^= 31 * Q.doubleToLongBits(this.p1.y), p ^ (Math.trunc(E) ^ Math.trunc(E >> 32));
    }, Dn.prototype.interfaces_ = function() {
      return [R, r];
    }, Dn.prototype.getClass = function() {
      return Dn;
    }, Dn.midPoint = function(g, p) {
      return new L((g.x + p.x) / 2, (g.y + p.y) / 2);
    }, P1.serialVersionUID.get = function() {
      return 3252005833466256400;
    }, Object.defineProperties(Dn, P1);
    var w0 = function() {
      this.tempEnv1 = new Te(), this.tempEnv2 = new Te(), this._overlapSeg1 = new Dn(), this._overlapSeg2 = new Dn();
    };
    w0.prototype.overlap = function() {
      if (arguments.length !== 2) {
        if (arguments.length === 4) {
          var g = arguments[0], p = arguments[1], E = arguments[2], B = arguments[3];
          g.getLineSegment(p, this._overlapSeg1), E.getLineSegment(B, this._overlapSeg2), this.overlap(this._overlapSeg1, this._overlapSeg2);
        }
      }
    }, w0.prototype.interfaces_ = function() {
      return [];
    }, w0.prototype.getClass = function() {
      return w0;
    };
    var rs = function() {
      this._pts = null, this._start = null, this._end = null, this._env = null, this._context = null, this._id = null;
      var g = arguments[0], p = arguments[1], E = arguments[2], B = arguments[3];
      this._pts = g, this._start = p, this._end = E, this._context = B;
    };
    rs.prototype.getLineSegment = function(g, p) {
      p.p0 = this._pts[g], p.p1 = this._pts[g + 1];
    }, rs.prototype.computeSelect = function(g, p, E, B) {
      var D = this._pts[p], j = this._pts[E];
      if (B.tempEnv1.init(D, j), E - p == 1)
        return B.select(this, p), null;
      if (!g.intersects(B.tempEnv1))
        return null;
      var te = Math.trunc((p + E) / 2);
      p < te && this.computeSelect(g, p, te, B), te < E && this.computeSelect(g, te, E, B);
    }, rs.prototype.getCoordinates = function() {
      for (var g = new Array(this._end - this._start + 1).fill(null), p = 0, E = this._start; E <= this._end; E++)
        g[p++] = this._pts[E];
      return g;
    }, rs.prototype.computeOverlaps = function(g, p) {
      this.computeOverlapsInternal(this._start, this._end, g, g._start, g._end, p);
    }, rs.prototype.setId = function(g) {
      this._id = g;
    }, rs.prototype.select = function(g, p) {
      this.computeSelect(g, this._start, this._end, p);
    }, rs.prototype.getEnvelope = function() {
      if (this._env === null) {
        var g = this._pts[this._start], p = this._pts[this._end];
        this._env = new Te(g, p);
      }
      return this._env;
    }, rs.prototype.getEndIndex = function() {
      return this._end;
    }, rs.prototype.getStartIndex = function() {
      return this._start;
    }, rs.prototype.getContext = function() {
      return this._context;
    }, rs.prototype.getId = function() {
      return this._id;
    }, rs.prototype.computeOverlapsInternal = function(g, p, E, B, D, j) {
      var te = this._pts[g], he = this._pts[p], ve = E._pts[B], Le = E._pts[D];
      if (p - g == 1 && D - B == 1)
        return j.overlap(this, g, E, B), null;
      if (j.tempEnv1.init(te, he), j.tempEnv2.init(ve, Le), !j.tempEnv1.intersects(j.tempEnv2))
        return null;
      var Je = Math.trunc((g + p) / 2), et = Math.trunc((B + D) / 2);
      g < Je && (B < et && this.computeOverlapsInternal(g, Je, E, B, et, j), et < D && this.computeOverlapsInternal(g, Je, E, et, D, j)), Je < p && (B < et && this.computeOverlapsInternal(Je, p, E, B, et, j), et < D && this.computeOverlapsInternal(Je, p, E, et, D, j));
    }, rs.prototype.interfaces_ = function() {
      return [];
    }, rs.prototype.getClass = function() {
      return rs;
    };
    var El = function() {
    };
    El.prototype.interfaces_ = function() {
      return [];
    }, El.prototype.getClass = function() {
      return El;
    }, El.getChainStartIndices = function(g) {
      var p = 0, E = new We();
      E.add(new Z(p));
      do {
        var B = El.findChainEnd(g, p);
        E.add(new Z(B)), p = B;
      } while (p < g.length - 1);
      return El.toIntArray(E);
    }, El.findChainEnd = function(g, p) {
      for (var E = p; E < g.length - 1 && g[E].equals2D(g[E + 1]); )
        E++;
      if (E >= g.length - 1)
        return g.length - 1;
      for (var B = ai.quadrant(g[E], g[E + 1]), D = p + 1; D < g.length && !(!g[D - 1].equals2D(g[D]) && ai.quadrant(g[D - 1], g[D]) !== B); )
        D++;
      return D - 1;
    }, El.getChains = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return El.getChains(g, null);
      }
      if (arguments.length === 2) {
        for (var p = arguments[0], E = arguments[1], B = new We(), D = El.getChainStartIndices(p), j = 0; j < D.length - 1; j++) {
          var te = new rs(p, D[j], D[j + 1], E);
          B.add(te);
        }
        return B;
      }
    }, El.toIntArray = function(g) {
      for (var p = new Array(g.size()).fill(null), E = 0; E < p.length; E++)
        p[E] = g.get(E).intValue();
      return p;
    };
    var su = function() {
    };
    su.prototype.computeNodes = function(g) {
    }, su.prototype.getNodedSubstrings = function() {
    }, su.prototype.interfaces_ = function() {
      return [];
    }, su.prototype.getClass = function() {
      return su;
    };
    var rh = function() {
      if (this._segInt = null, arguments.length !== 0) {
        if (arguments.length === 1) {
          var g = arguments[0];
          this.setSegmentIntersector(g);
        }
      }
    };
    rh.prototype.setSegmentIntersector = function(g) {
      this._segInt = g;
    }, rh.prototype.interfaces_ = function() {
      return [su];
    }, rh.prototype.getClass = function() {
      return rh;
    };
    var Ku = function(g) {
      function p(B) {
        B ? g.call(this, B) : g.call(this), this._monoChains = new We(), this._index = new S0(), this._idCounter = 0, this._nodedSegStrings = null, this._nOverlaps = 0;
      }
      g && (p.__proto__ = g), (p.prototype = Object.create(g && g.prototype)).constructor = p;
      var E = { SegmentOverlapAction: { configurable: !0 } };
      return p.prototype.getMonotoneChains = function() {
        return this._monoChains;
      }, p.prototype.getNodedSubstrings = function() {
        return ki.getNodedSubstrings(this._nodedSegStrings);
      }, p.prototype.getIndex = function() {
        return this._index;
      }, p.prototype.add = function(B) {
        for (var D = El.getChains(B.getCoordinates(), B).iterator(); D.hasNext(); ) {
          var j = D.next();
          j.setId(this._idCounter++), this._index.insert(j.getEnvelope(), j), this._monoChains.add(j);
        }
      }, p.prototype.computeNodes = function(B) {
        this._nodedSegStrings = B;
        for (var D = B.iterator(); D.hasNext(); )
          this.add(D.next());
        this.intersectChains();
      }, p.prototype.intersectChains = function() {
        for (var B = new ny(this._segInt), D = this._monoChains.iterator(); D.hasNext(); )
          for (var j = D.next(), te = this._index.query(j.getEnvelope()).iterator(); te.hasNext(); ) {
            var he = te.next();
            if (he.getId() > j.getId() && (j.computeOverlaps(he, B), this._nOverlaps++), this._segInt.isDone())
              return null;
          }
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, E.SegmentOverlapAction.get = function() {
        return ny;
      }, Object.defineProperties(p, E), p;
    }(rh), ny = function(g) {
      function p() {
        g.call(this), this._si = null;
        var E = arguments[0];
        this._si = E;
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.overlap = function() {
        if (arguments.length !== 4)
          return g.prototype.overlap.apply(this, arguments);
        var E = arguments[0], B = arguments[1], D = arguments[2], j = arguments[3], te = E.getContext(), he = D.getContext();
        this._si.processIntersections(te, B, he, j);
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(w0), Xr = function g() {
      if (this._quadrantSegments = g.DEFAULT_QUADRANT_SEGMENTS, this._endCapStyle = g.CAP_ROUND, this._joinStyle = g.JOIN_ROUND, this._mitreLimit = g.DEFAULT_MITRE_LIMIT, this._isSingleSided = !1, this._simplifyFactor = g.DEFAULT_SIMPLIFY_FACTOR, arguments.length !== 0) {
        if (arguments.length === 1) {
          var p = arguments[0];
          this.setQuadrantSegments(p);
        } else if (arguments.length === 2) {
          var E = arguments[0], B = arguments[1];
          this.setQuadrantSegments(E), this.setEndCapStyle(B);
        } else if (arguments.length === 4) {
          var D = arguments[0], j = arguments[1], te = arguments[2], he = arguments[3];
          this.setQuadrantSegments(D), this.setEndCapStyle(j), this.setJoinStyle(te), this.setMitreLimit(he);
        }
      }
    }, yl = { CAP_ROUND: { configurable: !0 }, CAP_FLAT: { configurable: !0 }, CAP_SQUARE: { configurable: !0 }, JOIN_ROUND: { configurable: !0 }, JOIN_MITRE: { configurable: !0 }, JOIN_BEVEL: { configurable: !0 }, DEFAULT_QUADRANT_SEGMENTS: { configurable: !0 }, DEFAULT_MITRE_LIMIT: { configurable: !0 }, DEFAULT_SIMPLIFY_FACTOR: { configurable: !0 } };
    Xr.prototype.getEndCapStyle = function() {
      return this._endCapStyle;
    }, Xr.prototype.isSingleSided = function() {
      return this._isSingleSided;
    }, Xr.prototype.setQuadrantSegments = function(g) {
      this._quadrantSegments = g, this._quadrantSegments === 0 && (this._joinStyle = Xr.JOIN_BEVEL), this._quadrantSegments < 0 && (this._joinStyle = Xr.JOIN_MITRE, this._mitreLimit = Math.abs(this._quadrantSegments)), g <= 0 && (this._quadrantSegments = 1), this._joinStyle !== Xr.JOIN_ROUND && (this._quadrantSegments = Xr.DEFAULT_QUADRANT_SEGMENTS);
    }, Xr.prototype.getJoinStyle = function() {
      return this._joinStyle;
    }, Xr.prototype.setJoinStyle = function(g) {
      this._joinStyle = g;
    }, Xr.prototype.setSimplifyFactor = function(g) {
      this._simplifyFactor = g < 0 ? 0 : g;
    }, Xr.prototype.getSimplifyFactor = function() {
      return this._simplifyFactor;
    }, Xr.prototype.getQuadrantSegments = function() {
      return this._quadrantSegments;
    }, Xr.prototype.setEndCapStyle = function(g) {
      this._endCapStyle = g;
    }, Xr.prototype.getMitreLimit = function() {
      return this._mitreLimit;
    }, Xr.prototype.setMitreLimit = function(g) {
      this._mitreLimit = g;
    }, Xr.prototype.setSingleSided = function(g) {
      this._isSingleSided = g;
    }, Xr.prototype.interfaces_ = function() {
      return [];
    }, Xr.prototype.getClass = function() {
      return Xr;
    }, Xr.bufferDistanceError = function(g) {
      var p = Math.PI / 2 / g;
      return 1 - Math.cos(p / 2);
    }, yl.CAP_ROUND.get = function() {
      return 1;
    }, yl.CAP_FLAT.get = function() {
      return 2;
    }, yl.CAP_SQUARE.get = function() {
      return 3;
    }, yl.JOIN_ROUND.get = function() {
      return 1;
    }, yl.JOIN_MITRE.get = function() {
      return 2;
    }, yl.JOIN_BEVEL.get = function() {
      return 3;
    }, yl.DEFAULT_QUADRANT_SEGMENTS.get = function() {
      return 8;
    }, yl.DEFAULT_MITRE_LIMIT.get = function() {
      return 5;
    }, yl.DEFAULT_SIMPLIFY_FACTOR.get = function() {
      return 0.01;
    }, Object.defineProperties(Xr, yl);
    var yi = function(g) {
      this._distanceTol = null, this._isDeleted = null, this._angleOrientation = ke.COUNTERCLOCKWISE, this._inputLine = g || null;
    }, vl = { INIT: { configurable: !0 }, DELETE: { configurable: !0 }, KEEP: { configurable: !0 }, NUM_PTS_TO_CHECK: { configurable: !0 } };
    yi.prototype.isDeletable = function(g, p, E, B) {
      var D = this._inputLine[g], j = this._inputLine[p], te = this._inputLine[E];
      return !!this.isConcave(D, j, te) && !!this.isShallow(D, j, te, B) && this.isShallowSampled(D, j, g, E, B);
    }, yi.prototype.deleteShallowConcavities = function() {
      for (var g = 1, p = this.findNextNonDeletedIndex(g), E = this.findNextNonDeletedIndex(p), B = !1; E < this._inputLine.length; ) {
        var D = !1;
        this.isDeletable(g, p, E, this._distanceTol) && (this._isDeleted[p] = yi.DELETE, D = !0, B = !0), g = D ? E : p, p = this.findNextNonDeletedIndex(g), E = this.findNextNonDeletedIndex(p);
      }
      return B;
    }, yi.prototype.isShallowConcavity = function(g, p, E, B) {
      return ke.computeOrientation(g, p, E) !== this._angleOrientation ? !1 : ke.distancePointLine(p, g, E) < B;
    }, yi.prototype.isShallowSampled = function(g, p, E, B, D) {
      var j = Math.trunc((B - E) / yi.NUM_PTS_TO_CHECK);
      j <= 0 && (j = 1);
      for (var te = E; te < B; te += j)
        if (!this.isShallow(g, p, this._inputLine[te], D))
          return !1;
      return !0;
    }, yi.prototype.isConcave = function(g, p, E) {
      var B = ke.computeOrientation(g, p, E) === this._angleOrientation;
      return B;
    }, yi.prototype.simplify = function(g) {
      this._distanceTol = Math.abs(g), g < 0 && (this._angleOrientation = ke.CLOCKWISE), this._isDeleted = new Array(this._inputLine.length).fill(null);
      var p = !1;
      do
        p = this.deleteShallowConcavities();
      while (p);
      return this.collapseLine();
    }, yi.prototype.findNextNonDeletedIndex = function(g) {
      for (var p = g + 1; p < this._inputLine.length && this._isDeleted[p] === yi.DELETE; )
        p++;
      return p;
    }, yi.prototype.isShallow = function(g, p, E, B) {
      return ke.distancePointLine(p, g, E) < B;
    }, yi.prototype.collapseLine = function() {
      for (var g = new qn(), p = 0; p < this._inputLine.length; p++)
        this._isDeleted[p] !== yi.DELETE && g.add(this._inputLine[p]);
      return g.toCoordinateArray();
    }, yi.prototype.interfaces_ = function() {
      return [];
    }, yi.prototype.getClass = function() {
      return yi;
    }, yi.simplify = function(g, p) {
      return new yi(g).simplify(p);
    }, vl.INIT.get = function() {
      return 0;
    }, vl.DELETE.get = function() {
      return 1;
    }, vl.KEEP.get = function() {
      return 1;
    }, vl.NUM_PTS_TO_CHECK.get = function() {
      return 10;
    }, Object.defineProperties(yi, vl);
    var ma = function() {
      this._ptList = null, this._precisionModel = null, this._minimimVertexDistance = 0, this._ptList = new We();
    }, Ca = { COORDINATE_ARRAY_TYPE: { configurable: !0 } };
    ma.prototype.getCoordinates = function() {
      return this._ptList.toArray(ma.COORDINATE_ARRAY_TYPE);
    }, ma.prototype.setPrecisionModel = function(g) {
      this._precisionModel = g;
    }, ma.prototype.addPt = function(g) {
      var p = new L(g);
      if (this._precisionModel.makePrecise(p), this.isRedundant(p))
        return null;
      this._ptList.add(p);
    }, ma.prototype.revere = function() {
    }, ma.prototype.addPts = function(g, p) {
      if (p)
        for (var E = 0; E < g.length; E++)
          this.addPt(g[E]);
      else
        for (var B = g.length - 1; B >= 0; B--)
          this.addPt(g[B]);
    }, ma.prototype.isRedundant = function(g) {
      if (this._ptList.size() < 1)
        return !1;
      var p = this._ptList.get(this._ptList.size() - 1);
      return g.distance(p) < this._minimimVertexDistance;
    }, ma.prototype.toString = function() {
      return new or().createLineString(this.getCoordinates()).toString();
    }, ma.prototype.closeRing = function() {
      if (this._ptList.size() < 1)
        return null;
      var g = new L(this._ptList.get(0)), p = this._ptList.get(this._ptList.size() - 1);
      if (g.equals(p))
        return null;
      this._ptList.add(g);
    }, ma.prototype.setMinimumVertexDistance = function(g) {
      this._minimimVertexDistance = g;
    }, ma.prototype.interfaces_ = function() {
      return [];
    }, ma.prototype.getClass = function() {
      return ma;
    }, Ca.COORDINATE_ARRAY_TYPE.get = function() {
      return new Array(0).fill(null);
    }, Object.defineProperties(ma, Ca);
    var Ur = function() {
    }, ih = { PI_TIMES_2: { configurable: !0 }, PI_OVER_2: { configurable: !0 }, PI_OVER_4: { configurable: !0 }, COUNTERCLOCKWISE: { configurable: !0 }, CLOCKWISE: { configurable: !0 }, NONE: { configurable: !0 } };
    Ur.prototype.interfaces_ = function() {
      return [];
    }, Ur.prototype.getClass = function() {
      return Ur;
    }, Ur.toDegrees = function(g) {
      return 180 * g / Math.PI;
    }, Ur.normalize = function(g) {
      for (; g > Math.PI; )
        g -= Ur.PI_TIMES_2;
      for (; g <= -Math.PI; )
        g += Ur.PI_TIMES_2;
      return g;
    }, Ur.angle = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return Math.atan2(g.y, g.x);
      }
      if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1], B = E.x - p.x, D = E.y - p.y;
        return Math.atan2(D, B);
      }
    }, Ur.isAcute = function(g, p, E) {
      var B = g.x - p.x, D = g.y - p.y;
      return B * (E.x - p.x) + D * (E.y - p.y) > 0;
    }, Ur.isObtuse = function(g, p, E) {
      var B = g.x - p.x, D = g.y - p.y;
      return B * (E.x - p.x) + D * (E.y - p.y) < 0;
    }, Ur.interiorAngle = function(g, p, E) {
      var B = Ur.angle(p, g), D = Ur.angle(p, E);
      return Math.abs(D - B);
    }, Ur.normalizePositive = function(g) {
      if (g < 0) {
        for (; g < 0; )
          g += Ur.PI_TIMES_2;
        g >= Ur.PI_TIMES_2 && (g = 0);
      } else {
        for (; g >= Ur.PI_TIMES_2; )
          g -= Ur.PI_TIMES_2;
        g < 0 && (g = 0);
      }
      return g;
    }, Ur.angleBetween = function(g, p, E) {
      var B = Ur.angle(p, g), D = Ur.angle(p, E);
      return Ur.diff(B, D);
    }, Ur.diff = function(g, p) {
      var E = null;
      return (E = g < p ? p - g : g - p) > Math.PI && (E = 2 * Math.PI - E), E;
    }, Ur.toRadians = function(g) {
      return g * Math.PI / 180;
    }, Ur.getTurn = function(g, p) {
      var E = Math.sin(p - g);
      return E > 0 ? Ur.COUNTERCLOCKWISE : E < 0 ? Ur.CLOCKWISE : Ur.NONE;
    }, Ur.angleBetweenOriented = function(g, p, E) {
      var B = Ur.angle(p, g), D = Ur.angle(p, E) - B;
      return D <= -Math.PI ? D + Ur.PI_TIMES_2 : D > Math.PI ? D - Ur.PI_TIMES_2 : D;
    }, ih.PI_TIMES_2.get = function() {
      return 2 * Math.PI;
    }, ih.PI_OVER_2.get = function() {
      return Math.PI / 2;
    }, ih.PI_OVER_4.get = function() {
      return Math.PI / 4;
    }, ih.COUNTERCLOCKWISE.get = function() {
      return ke.COUNTERCLOCKWISE;
    }, ih.CLOCKWISE.get = function() {
      return ke.CLOCKWISE;
    }, ih.NONE.get = function() {
      return ke.COLLINEAR;
    }, Object.defineProperties(Ur, ih);
    var Oi = function g() {
      this._maxCurveSegmentError = 0, this._filletAngleQuantum = null, this._closingSegLengthFactor = 1, this._segList = null, this._distance = 0, this._precisionModel = null, this._bufParams = null, this._li = null, this._s0 = null, this._s1 = null, this._s2 = null, this._seg0 = new Dn(), this._seg1 = new Dn(), this._offset0 = new Dn(), this._offset1 = new Dn(), this._side = 0, this._hasNarrowConcaveAngle = !1;
      var p = arguments[0], E = arguments[1], B = arguments[2];
      this._precisionModel = p, this._bufParams = E, this._li = new we(), this._filletAngleQuantum = Math.PI / 2 / E.getQuadrantSegments(), E.getQuadrantSegments() >= 8 && E.getJoinStyle() === Xr.JOIN_ROUND && (this._closingSegLengthFactor = g.MAX_CLOSING_SEG_LEN_FACTOR), this.init(B);
    }, x0 = { OFFSET_SEGMENT_SEPARATION_FACTOR: { configurable: !0 }, INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR: { configurable: !0 }, CURVE_VERTEX_SNAP_DISTANCE_FACTOR: { configurable: !0 }, MAX_CLOSING_SEG_LEN_FACTOR: { configurable: !0 } };
    Oi.prototype.addNextSegment = function(g, p) {
      if (this._s0 = this._s1, this._s1 = this._s2, this._s2 = g, this._seg0.setCoordinates(this._s0, this._s1), this.computeOffsetSegment(this._seg0, this._side, this._distance, this._offset0), this._seg1.setCoordinates(this._s1, this._s2), this.computeOffsetSegment(this._seg1, this._side, this._distance, this._offset1), this._s1.equals(this._s2))
        return null;
      var E = ke.computeOrientation(this._s0, this._s1, this._s2), B = E === ke.CLOCKWISE && this._side === Ve.LEFT || E === ke.COUNTERCLOCKWISE && this._side === Ve.RIGHT;
      E === 0 ? this.addCollinear(p) : B ? this.addOutsideTurn(E, p) : this.addInsideTurn(E, p);
    }, Oi.prototype.addLineEndCap = function(g, p) {
      var E = new Dn(g, p), B = new Dn();
      this.computeOffsetSegment(E, Ve.LEFT, this._distance, B);
      var D = new Dn();
      this.computeOffsetSegment(E, Ve.RIGHT, this._distance, D);
      var j = p.x - g.x, te = p.y - g.y, he = Math.atan2(te, j);
      switch (this._bufParams.getEndCapStyle()) {
        case Xr.CAP_ROUND:
          this._segList.addPt(B.p1), this.addFilletArc(p, he + Math.PI / 2, he - Math.PI / 2, ke.CLOCKWISE, this._distance), this._segList.addPt(D.p1);
          break;
        case Xr.CAP_FLAT:
          this._segList.addPt(B.p1), this._segList.addPt(D.p1);
          break;
        case Xr.CAP_SQUARE:
          var ve = new L();
          ve.x = Math.abs(this._distance) * Math.cos(he), ve.y = Math.abs(this._distance) * Math.sin(he);
          var Le = new L(B.p1.x + ve.x, B.p1.y + ve.y), Je = new L(D.p1.x + ve.x, D.p1.y + ve.y);
          this._segList.addPt(Le), this._segList.addPt(Je);
      }
    }, Oi.prototype.getCoordinates = function() {
      return this._segList.getCoordinates();
    }, Oi.prototype.addMitreJoin = function(g, p, E, B) {
      var D = !0, j = null;
      try {
        j = Ue.intersection(p.p0, p.p1, E.p0, E.p1), (B <= 0 ? 1 : j.distance(g) / Math.abs(B)) > this._bufParams.getMitreLimit() && (D = !1);
      } catch (te) {
        if (!(te instanceof Se))
          throw te;
        j = new L(0, 0), D = !1;
      }
      D ? this._segList.addPt(j) : this.addLimitedMitreJoin(p, E, B, this._bufParams.getMitreLimit());
    }, Oi.prototype.addFilletCorner = function(g, p, E, B, D) {
      var j = p.x - g.x, te = p.y - g.y, he = Math.atan2(te, j), ve = E.x - g.x, Le = E.y - g.y, Je = Math.atan2(Le, ve);
      B === ke.CLOCKWISE ? he <= Je && (he += 2 * Math.PI) : he >= Je && (he -= 2 * Math.PI), this._segList.addPt(p), this.addFilletArc(g, he, Je, B, D), this._segList.addPt(E);
    }, Oi.prototype.addOutsideTurn = function(g, p) {
      if (this._offset0.p1.distance(this._offset1.p0) < this._distance * Oi.OFFSET_SEGMENT_SEPARATION_FACTOR)
        return this._segList.addPt(this._offset0.p1), null;
      this._bufParams.getJoinStyle() === Xr.JOIN_MITRE ? this.addMitreJoin(this._s1, this._offset0, this._offset1, this._distance) : this._bufParams.getJoinStyle() === Xr.JOIN_BEVEL ? this.addBevelJoin(this._offset0, this._offset1) : (p && this._segList.addPt(this._offset0.p1), this.addFilletCorner(this._s1, this._offset0.p1, this._offset1.p0, g, this._distance), this._segList.addPt(this._offset1.p0));
    }, Oi.prototype.createSquare = function(g) {
      this._segList.addPt(new L(g.x + this._distance, g.y + this._distance)), this._segList.addPt(new L(g.x + this._distance, g.y - this._distance)), this._segList.addPt(new L(g.x - this._distance, g.y - this._distance)), this._segList.addPt(new L(g.x - this._distance, g.y + this._distance)), this._segList.closeRing();
    }, Oi.prototype.addSegments = function(g, p) {
      this._segList.addPts(g, p);
    }, Oi.prototype.addFirstSegment = function() {
      this._segList.addPt(this._offset1.p0);
    }, Oi.prototype.addLastSegment = function() {
      this._segList.addPt(this._offset1.p1);
    }, Oi.prototype.initSideSegments = function(g, p, E) {
      this._s1 = g, this._s2 = p, this._side = E, this._seg1.setCoordinates(g, p), this.computeOffsetSegment(this._seg1, E, this._distance, this._offset1);
    }, Oi.prototype.addLimitedMitreJoin = function(g, p, E, B) {
      var D = this._seg0.p1, j = Ur.angle(D, this._seg0.p0), te = Ur.angleBetweenOriented(this._seg0.p0, D, this._seg1.p1) / 2, he = Ur.normalize(j + te), ve = Ur.normalize(he + Math.PI), Le = B * E, Je = E - Le * Math.abs(Math.sin(te)), et = D.x + Le * Math.cos(ve), Ke = D.y + Le * Math.sin(ve), ot = new L(et, Ke), je = new Dn(D, ot), Et = je.pointAlongOffset(1, Je), Gt = je.pointAlongOffset(1, -Je);
      this._side === Ve.LEFT ? (this._segList.addPt(Et), this._segList.addPt(Gt)) : (this._segList.addPt(Gt), this._segList.addPt(Et));
    }, Oi.prototype.computeOffsetSegment = function(g, p, E, B) {
      var D = p === Ve.LEFT ? 1 : -1, j = g.p1.x - g.p0.x, te = g.p1.y - g.p0.y, he = Math.sqrt(j * j + te * te), ve = D * E * j / he, Le = D * E * te / he;
      B.p0.x = g.p0.x - Le, B.p0.y = g.p0.y + ve, B.p1.x = g.p1.x - Le, B.p1.y = g.p1.y + ve;
    }, Oi.prototype.addFilletArc = function(g, p, E, B, D) {
      var j = B === ke.CLOCKWISE ? -1 : 1, te = Math.abs(p - E), he = Math.trunc(te / this._filletAngleQuantum + 0.5);
      if (he < 1)
        return null;
      for (var ve = te / he, Le = 0, Je = new L(); Le < te; ) {
        var et = p + j * Le;
        Je.x = g.x + D * Math.cos(et), Je.y = g.y + D * Math.sin(et), this._segList.addPt(Je), Le += ve;
      }
    }, Oi.prototype.addInsideTurn = function(g, p) {
      if (this._li.computeIntersection(this._offset0.p0, this._offset0.p1, this._offset1.p0, this._offset1.p1), this._li.hasIntersection())
        this._segList.addPt(this._li.getIntersection(0));
      else if (this._hasNarrowConcaveAngle = !0, this._offset0.p1.distance(this._offset1.p0) < this._distance * Oi.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR)
        this._segList.addPt(this._offset0.p1);
      else {
        if (this._segList.addPt(this._offset0.p1), this._closingSegLengthFactor > 0) {
          var E = new L((this._closingSegLengthFactor * this._offset0.p1.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset0.p1.y + this._s1.y) / (this._closingSegLengthFactor + 1));
          this._segList.addPt(E);
          var B = new L((this._closingSegLengthFactor * this._offset1.p0.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset1.p0.y + this._s1.y) / (this._closingSegLengthFactor + 1));
          this._segList.addPt(B);
        } else
          this._segList.addPt(this._s1);
        this._segList.addPt(this._offset1.p0);
      }
    }, Oi.prototype.createCircle = function(g) {
      var p = new L(g.x + this._distance, g.y);
      this._segList.addPt(p), this.addFilletArc(g, 0, 2 * Math.PI, -1, this._distance), this._segList.closeRing();
    }, Oi.prototype.addBevelJoin = function(g, p) {
      this._segList.addPt(g.p1), this._segList.addPt(p.p0);
    }, Oi.prototype.init = function(g) {
      this._distance = g, this._maxCurveSegmentError = g * (1 - Math.cos(this._filletAngleQuantum / 2)), this._segList = new ma(), this._segList.setPrecisionModel(this._precisionModel), this._segList.setMinimumVertexDistance(g * Oi.CURVE_VERTEX_SNAP_DISTANCE_FACTOR);
    }, Oi.prototype.addCollinear = function(g) {
      this._li.computeIntersection(this._s0, this._s1, this._s1, this._s2), this._li.getIntersectionNum() >= 2 && (this._bufParams.getJoinStyle() === Xr.JOIN_BEVEL || this._bufParams.getJoinStyle() === Xr.JOIN_MITRE ? (g && this._segList.addPt(this._offset0.p1), this._segList.addPt(this._offset1.p0)) : this.addFilletCorner(this._s1, this._offset0.p1, this._offset1.p0, ke.CLOCKWISE, this._distance));
    }, Oi.prototype.closeRing = function() {
      this._segList.closeRing();
    }, Oi.prototype.hasNarrowConcaveAngle = function() {
      return this._hasNarrowConcaveAngle;
    }, Oi.prototype.interfaces_ = function() {
      return [];
    }, Oi.prototype.getClass = function() {
      return Oi;
    }, x0.OFFSET_SEGMENT_SEPARATION_FACTOR.get = function() {
      return 1e-3;
    }, x0.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR.get = function() {
      return 1e-3;
    }, x0.CURVE_VERTEX_SNAP_DISTANCE_FACTOR.get = function() {
      return 1e-6;
    }, x0.MAX_CLOSING_SEG_LEN_FACTOR.get = function() {
      return 80;
    }, Object.defineProperties(Oi, x0);
    var go = function() {
      this._distance = 0, this._precisionModel = null, this._bufParams = null;
      var g = arguments[0], p = arguments[1];
      this._precisionModel = g, this._bufParams = p;
    };
    go.prototype.getOffsetCurve = function(g, p) {
      if (this._distance = p, p === 0)
        return null;
      var E = p < 0, B = Math.abs(p), D = this.getSegGen(B);
      g.length <= 1 ? this.computePointCurve(g[0], D) : this.computeOffsetCurve(g, E, D);
      var j = D.getCoordinates();
      return E && Pt.reverse(j), j;
    }, go.prototype.computeSingleSidedBufferCurve = function(g, p, E) {
      var B = this.simplifyTolerance(this._distance);
      if (p) {
        E.addSegments(g, !0);
        var D = yi.simplify(g, -B), j = D.length - 1;
        E.initSideSegments(D[j], D[j - 1], Ve.LEFT), E.addFirstSegment();
        for (var te = j - 2; te >= 0; te--)
          E.addNextSegment(D[te], !0);
      } else {
        E.addSegments(g, !1);
        var he = yi.simplify(g, B), ve = he.length - 1;
        E.initSideSegments(he[0], he[1], Ve.LEFT), E.addFirstSegment();
        for (var Le = 2; Le <= ve; Le++)
          E.addNextSegment(he[Le], !0);
      }
      E.addLastSegment(), E.closeRing();
    }, go.prototype.computeRingBufferCurve = function(g, p, E) {
      var B = this.simplifyTolerance(this._distance);
      p === Ve.RIGHT && (B = -B);
      var D = yi.simplify(g, B), j = D.length - 1;
      E.initSideSegments(D[j - 1], D[0], p);
      for (var te = 1; te <= j; te++) {
        var he = te !== 1;
        E.addNextSegment(D[te], he);
      }
      E.closeRing();
    }, go.prototype.computeLineBufferCurve = function(g, p) {
      var E = this.simplifyTolerance(this._distance), B = yi.simplify(g, E), D = B.length - 1;
      p.initSideSegments(B[0], B[1], Ve.LEFT);
      for (var j = 2; j <= D; j++)
        p.addNextSegment(B[j], !0);
      p.addLastSegment(), p.addLineEndCap(B[D - 1], B[D]);
      var te = yi.simplify(g, -E), he = te.length - 1;
      p.initSideSegments(te[he], te[he - 1], Ve.LEFT);
      for (var ve = he - 2; ve >= 0; ve--)
        p.addNextSegment(te[ve], !0);
      p.addLastSegment(), p.addLineEndCap(te[1], te[0]), p.closeRing();
    }, go.prototype.computePointCurve = function(g, p) {
      switch (this._bufParams.getEndCapStyle()) {
        case Xr.CAP_ROUND:
          p.createCircle(g);
          break;
        case Xr.CAP_SQUARE:
          p.createSquare(g);
      }
    }, go.prototype.getLineCurve = function(g, p) {
      if (this._distance = p, p < 0 && !this._bufParams.isSingleSided() || p === 0)
        return null;
      var E = Math.abs(p), B = this.getSegGen(E);
      if (g.length <= 1)
        this.computePointCurve(g[0], B);
      else if (this._bufParams.isSingleSided()) {
        var D = p < 0;
        this.computeSingleSidedBufferCurve(g, D, B);
      } else
        this.computeLineBufferCurve(g, B);
      return B.getCoordinates();
    }, go.prototype.getBufferParameters = function() {
      return this._bufParams;
    }, go.prototype.simplifyTolerance = function(g) {
      return g * this._bufParams.getSimplifyFactor();
    }, go.prototype.getRingCurve = function(g, p, E) {
      if (this._distance = E, g.length <= 2)
        return this.getLineCurve(g, E);
      if (E === 0)
        return go.copyCoordinates(g);
      var B = this.getSegGen(E);
      return this.computeRingBufferCurve(g, p, B), B.getCoordinates();
    }, go.prototype.computeOffsetCurve = function(g, p, E) {
      var B = this.simplifyTolerance(this._distance);
      if (p) {
        var D = yi.simplify(g, -B), j = D.length - 1;
        E.initSideSegments(D[j], D[j - 1], Ve.LEFT), E.addFirstSegment();
        for (var te = j - 2; te >= 0; te--)
          E.addNextSegment(D[te], !0);
      } else {
        var he = yi.simplify(g, B), ve = he.length - 1;
        E.initSideSegments(he[0], he[1], Ve.LEFT), E.addFirstSegment();
        for (var Le = 2; Le <= ve; Le++)
          E.addNextSegment(he[Le], !0);
      }
      E.addLastSegment();
    }, go.prototype.getSegGen = function(g) {
      return new Oi(this._precisionModel, this._bufParams, g);
    }, go.prototype.interfaces_ = function() {
      return [];
    }, go.prototype.getClass = function() {
      return go;
    }, go.copyCoordinates = function(g) {
      for (var p = new Array(g.length).fill(null), E = 0; E < p.length; E++)
        p[E] = new L(g[E]);
      return p;
    };
    var Xf = function() {
      this._subgraphs = null, this._seg = new Dn(), this._cga = new ke();
      var g = arguments[0];
      this._subgraphs = g;
    }, Hd = { DepthSegment: { configurable: !0 } };
    Xf.prototype.findStabbedSegments = function() {
      if (arguments.length === 1) {
        for (var g = arguments[0], p = new We(), E = this._subgraphs.iterator(); E.hasNext(); ) {
          var B = E.next(), D = B.getEnvelope();
          g.y < D.getMinY() || g.y > D.getMaxY() || this.findStabbedSegments(g, B.getDirectedEdges(), p);
        }
        return p;
      }
      if (arguments.length === 3) {
        if (K(arguments[2], hn) && arguments[0] instanceof L && arguments[1] instanceof pc) {
          for (var j = arguments[0], te = arguments[1], he = arguments[2], ve = te.getEdge().getCoordinates(), Le = 0; Le < ve.length - 1; Le++)
            if (this._seg.p0 = ve[Le], this._seg.p1 = ve[Le + 1], this._seg.p0.y > this._seg.p1.y && this._seg.reverse(), !(Math.max(this._seg.p0.x, this._seg.p1.x) < j.x) && !(this._seg.isHorizontal() || j.y < this._seg.p0.y || j.y > this._seg.p1.y || ke.computeOrientation(this._seg.p0, this._seg.p1, j) === ke.RIGHT)) {
              var Je = te.getDepth(Ve.LEFT);
              this._seg.p0.equals(ve[Le]) || (Je = te.getDepth(Ve.RIGHT));
              var et = new Us(this._seg, Je);
              he.add(et);
            }
        } else if (K(arguments[2], hn) && arguments[0] instanceof L && K(arguments[1], hn))
          for (var Ke = arguments[0], ot = arguments[1], je = arguments[2], Et = ot.iterator(); Et.hasNext(); ) {
            var Gt = Et.next();
            Gt.isForward() && this.findStabbedSegments(Ke, Gt, je);
          }
      }
    }, Xf.prototype.getDepth = function(g) {
      var p = this.findStabbedSegments(g);
      return p.size() === 0 ? 0 : EA.min(p)._leftDepth;
    }, Xf.prototype.interfaces_ = function() {
      return [];
    }, Xf.prototype.getClass = function() {
      return Xf;
    }, Hd.DepthSegment.get = function() {
      return Us;
    }, Object.defineProperties(Xf, Hd);
    var Us = function() {
      this._upwardSeg = null, this._leftDepth = null;
      var g = arguments[0], p = arguments[1];
      this._upwardSeg = new Dn(g), this._leftDepth = p;
    };
    Us.prototype.compareTo = function(g) {
      var p = g;
      if (this._upwardSeg.minX() >= p._upwardSeg.maxX())
        return 1;
      if (this._upwardSeg.maxX() <= p._upwardSeg.minX())
        return -1;
      var E = this._upwardSeg.orientationIndex(p._upwardSeg);
      return E !== 0 || (E = -1 * p._upwardSeg.orientationIndex(this._upwardSeg)) != 0 ? E : this._upwardSeg.compareTo(p._upwardSeg);
    }, Us.prototype.compareX = function(g, p) {
      var E = g.p0.compareTo(p.p0);
      return E !== 0 ? E : g.p1.compareTo(p.p1);
    }, Us.prototype.toString = function() {
      return this._upwardSeg.toString();
    }, Us.prototype.interfaces_ = function() {
      return [R];
    }, Us.prototype.getClass = function() {
      return Us;
    };
    var cr = function(g, p, E) {
      this.p0 = g || null, this.p1 = p || null, this.p2 = E || null;
    };
    cr.prototype.area = function() {
      return cr.area(this.p0, this.p1, this.p2);
    }, cr.prototype.signedArea = function() {
      return cr.signedArea(this.p0, this.p1, this.p2);
    }, cr.prototype.interpolateZ = function(g) {
      if (g === null)
        throw new b("Supplied point is null.");
      return cr.interpolateZ(g, this.p0, this.p1, this.p2);
    }, cr.prototype.longestSideLength = function() {
      return cr.longestSideLength(this.p0, this.p1, this.p2);
    }, cr.prototype.isAcute = function() {
      return cr.isAcute(this.p0, this.p1, this.p2);
    }, cr.prototype.circumcentre = function() {
      return cr.circumcentre(this.p0, this.p1, this.p2);
    }, cr.prototype.area3D = function() {
      return cr.area3D(this.p0, this.p1, this.p2);
    }, cr.prototype.centroid = function() {
      return cr.centroid(this.p0, this.p1, this.p2);
    }, cr.prototype.inCentre = function() {
      return cr.inCentre(this.p0, this.p1, this.p2);
    }, cr.prototype.interfaces_ = function() {
      return [];
    }, cr.prototype.getClass = function() {
      return cr;
    }, cr.area = function(g, p, E) {
      return Math.abs(((E.x - g.x) * (p.y - g.y) - (p.x - g.x) * (E.y - g.y)) / 2);
    }, cr.signedArea = function(g, p, E) {
      return ((E.x - g.x) * (p.y - g.y) - (p.x - g.x) * (E.y - g.y)) / 2;
    }, cr.det = function(g, p, E, B) {
      return g * B - p * E;
    }, cr.interpolateZ = function(g, p, E, B) {
      var D = p.x, j = p.y, te = E.x - D, he = B.x - D, ve = E.y - j, Le = B.y - j, Je = te * Le - he * ve, et = g.x - D, Ke = g.y - j, ot = (Le * et - he * Ke) / Je, je = (-ve * et + te * Ke) / Je;
      return p.z + ot * (E.z - p.z) + je * (B.z - p.z);
    }, cr.longestSideLength = function(g, p, E) {
      var B = g.distance(p), D = p.distance(E), j = E.distance(g), te = B;
      return D > te && (te = D), j > te && (te = j), te;
    }, cr.isAcute = function(g, p, E) {
      return !!Ur.isAcute(g, p, E) && !!Ur.isAcute(p, E, g) && !!Ur.isAcute(E, g, p);
    }, cr.circumcentre = function(g, p, E) {
      var B = E.x, D = E.y, j = g.x - B, te = g.y - D, he = p.x - B, ve = p.y - D, Le = 2 * cr.det(j, te, he, ve), Je = cr.det(te, j * j + te * te, ve, he * he + ve * ve), et = cr.det(j, j * j + te * te, he, he * he + ve * ve);
      return new L(B - Je / Le, D + et / Le);
    }, cr.perpendicularBisector = function(g, p) {
      var E = p.x - g.x, B = p.y - g.y, D = new Ue(g.x + E / 2, g.y + B / 2, 1), j = new Ue(g.x - B + E / 2, g.y + E + B / 2, 1);
      return new Ue(D, j);
    }, cr.angleBisector = function(g, p, E) {
      var B = p.distance(g), D = B / (B + p.distance(E)), j = E.x - g.x, te = E.y - g.y;
      return new L(g.x + D * j, g.y + D * te);
    }, cr.area3D = function(g, p, E) {
      var B = p.x - g.x, D = p.y - g.y, j = p.z - g.z, te = E.x - g.x, he = E.y - g.y, ve = E.z - g.z, Le = D * ve - j * he, Je = j * te - B * ve, et = B * he - D * te, Ke = Le * Le + Je * Je + et * et, ot = Math.sqrt(Ke) / 2;
      return ot;
    }, cr.centroid = function(g, p, E) {
      var B = (g.x + p.x + E.x) / 3, D = (g.y + p.y + E.y) / 3;
      return new L(B, D);
    }, cr.inCentre = function(g, p, E) {
      var B = p.distance(E), D = g.distance(E), j = g.distance(p), te = B + D + j, he = (B * g.x + D * p.x + j * E.x) / te, ve = (B * g.y + D * p.y + j * E.y) / te;
      return new L(he, ve);
    };
    var Ea = function() {
      this._inputGeom = null, this._distance = null, this._curveBuilder = null, this._curveList = new We();
      var g = arguments[0], p = arguments[1], E = arguments[2];
      this._inputGeom = g, this._distance = p, this._curveBuilder = E;
    };
    Ea.prototype.addPoint = function(g) {
      if (this._distance <= 0)
        return null;
      var p = g.getCoordinates(), E = this._curveBuilder.getLineCurve(p, this._distance);
      this.addCurve(E, U.EXTERIOR, U.INTERIOR);
    }, Ea.prototype.addPolygon = function(g) {
      var p = this._distance, E = Ve.LEFT;
      this._distance < 0 && (p = -this._distance, E = Ve.RIGHT);
      var B = g.getExteriorRing(), D = Pt.removeRepeatedPoints(B.getCoordinates());
      if (this._distance < 0 && this.isErodedCompletely(B, this._distance) || this._distance <= 0 && D.length < 3)
        return null;
      this.addPolygonRing(D, p, E, U.EXTERIOR, U.INTERIOR);
      for (var j = 0; j < g.getNumInteriorRing(); j++) {
        var te = g.getInteriorRingN(j), he = Pt.removeRepeatedPoints(te.getCoordinates());
        this._distance > 0 && this.isErodedCompletely(te, -this._distance) || this.addPolygonRing(he, p, Ve.opposite(E), U.INTERIOR, U.EXTERIOR);
      }
    }, Ea.prototype.isTriangleErodedCompletely = function(g, p) {
      var E = new cr(g[0], g[1], g[2]), B = E.inCentre();
      return ke.distancePointLine(B, E.p0, E.p1) < Math.abs(p);
    }, Ea.prototype.addLineString = function(g) {
      if (this._distance <= 0 && !this._curveBuilder.getBufferParameters().isSingleSided())
        return null;
      var p = Pt.removeRepeatedPoints(g.getCoordinates()), E = this._curveBuilder.getLineCurve(p, this._distance);
      this.addCurve(E, U.EXTERIOR, U.INTERIOR);
    }, Ea.prototype.addCurve = function(g, p, E) {
      if (g === null || g.length < 2)
        return null;
      var B = new ki(g, new Zn(0, U.BOUNDARY, p, E));
      this._curveList.add(B);
    }, Ea.prototype.getCurves = function() {
      return this.add(this._inputGeom), this._curveList;
    }, Ea.prototype.addPolygonRing = function(g, p, E, B, D) {
      if (p === 0 && g.length < vr.MINIMUM_VALID_SIZE)
        return null;
      var j = B, te = D;
      g.length >= vr.MINIMUM_VALID_SIZE && ke.isCCW(g) && (j = D, te = B, E = Ve.opposite(E));
      var he = this._curveBuilder.getRingCurve(g, E, p);
      this.addCurve(he, j, te);
    }, Ea.prototype.add = function(g) {
      if (g.isEmpty())
        return null;
      g instanceof Sn ? this.addPolygon(g) : g instanceof rn ? this.addLineString(g) : g instanceof pr ? this.addPoint(g) : g instanceof kn ? this.addCollection(g) : g instanceof tt ? this.addCollection(g) : g instanceof Tr ? this.addCollection(g) : g instanceof ze && this.addCollection(g);
    }, Ea.prototype.isErodedCompletely = function(g, p) {
      var E = g.getCoordinates();
      if (E.length < 4)
        return p < 0;
      if (E.length === 4)
        return this.isTriangleErodedCompletely(E, p);
      var B = g.getEnvelopeInternal(), D = Math.min(B.getHeight(), B.getWidth());
      return p < 0 && 2 * Math.abs(p) > D;
    }, Ea.prototype.addCollection = function(g) {
      for (var p = 0; p < g.getNumGeometries(); p++) {
        var E = g.getGeometryN(p);
        this.add(E);
      }
    }, Ea.prototype.interfaces_ = function() {
      return [];
    }, Ea.prototype.getClass = function() {
      return Ea;
    };
    var oh = function() {
    };
    oh.prototype.locate = function(g) {
    }, oh.prototype.interfaces_ = function() {
      return [];
    }, oh.prototype.getClass = function() {
      return oh;
    };
    var yA = function() {
      this._parent = null, this._atStart = null, this._max = null, this._index = null, this._subcollectionIterator = null;
      var g = arguments[0];
      this._parent = g, this._atStart = !0, this._index = 0, this._max = g.getNumGeometries();
    };
    yA.prototype.next = function() {
      if (this._atStart)
        return this._atStart = !1, yA.isAtomic(this._parent) && this._index++, this._parent;
      if (this._subcollectionIterator !== null) {
        if (this._subcollectionIterator.hasNext())
          return this._subcollectionIterator.next();
        this._subcollectionIterator = null;
      }
      if (this._index >= this._max)
        throw new o();
      var g = this._parent.getGeometryN(this._index++);
      return g instanceof ze ? (this._subcollectionIterator = new yA(g), this._subcollectionIterator.next()) : g;
    }, yA.prototype.remove = function() {
      throw new Error(this.getClass().getName());
    }, yA.prototype.hasNext = function() {
      if (this._atStart)
        return !0;
      if (this._subcollectionIterator !== null) {
        if (this._subcollectionIterator.hasNext())
          return !0;
        this._subcollectionIterator = null;
      }
      return !(this._index >= this._max);
    }, yA.prototype.interfaces_ = function() {
      return [un];
    }, yA.prototype.getClass = function() {
      return yA;
    }, yA.isAtomic = function(g) {
      return !(g instanceof ze);
    };
    var ra = function() {
      this._geom = null;
      var g = arguments[0];
      this._geom = g;
    };
    ra.prototype.locate = function(g) {
      return ra.locate(g, this._geom);
    }, ra.prototype.interfaces_ = function() {
      return [oh];
    }, ra.prototype.getClass = function() {
      return ra;
    }, ra.isPointInRing = function(g, p) {
      return !!p.getEnvelopeInternal().intersects(g) && ke.isPointInRing(g, p.getCoordinates());
    }, ra.containsPointInPolygon = function(g, p) {
      if (p.isEmpty())
        return !1;
      var E = p.getExteriorRing();
      if (!ra.isPointInRing(g, E))
        return !1;
      for (var B = 0; B < p.getNumInteriorRing(); B++) {
        var D = p.getInteriorRingN(B);
        if (ra.isPointInRing(g, D))
          return !1;
      }
      return !0;
    }, ra.containsPoint = function(g, p) {
      if (p instanceof Sn)
        return ra.containsPointInPolygon(g, p);
      if (p instanceof ze)
        for (var E = new yA(p); E.hasNext(); ) {
          var B = E.next();
          if (B !== p && ra.containsPoint(g, B))
            return !0;
        }
      return !1;
    }, ra.locate = function(g, p) {
      return p.isEmpty() ? U.EXTERIOR : ra.containsPoint(g, p) ? U.INTERIOR : U.EXTERIOR;
    };
    var Cs = function() {
      this._edgeMap = new h(), this._edgeList = null, this._ptInAreaLocation = [U.NONE, U.NONE];
    };
    Cs.prototype.getNextCW = function(g) {
      this.getEdges();
      var p = this._edgeList.indexOf(g), E = p - 1;
      return p === 0 && (E = this._edgeList.size() - 1), this._edgeList.get(E);
    }, Cs.prototype.propagateSideLabels = function(g) {
      for (var p = U.NONE, E = this.iterator(); E.hasNext(); ) {
        var B = E.next().getLabel();
        B.isArea(g) && B.getLocation(g, Ve.LEFT) !== U.NONE && (p = B.getLocation(g, Ve.LEFT));
      }
      if (p === U.NONE)
        return null;
      for (var D = p, j = this.iterator(); j.hasNext(); ) {
        var te = j.next(), he = te.getLabel();
        if (he.getLocation(g, Ve.ON) === U.NONE && he.setLocation(g, Ve.ON, D), he.isArea(g)) {
          var ve = he.getLocation(g, Ve.LEFT), Le = he.getLocation(g, Ve.RIGHT);
          if (Le !== U.NONE) {
            if (Le !== D)
              throw new lr("side location conflict", te.getCoordinate());
            ve === U.NONE && ie.shouldNeverReachHere("found single null side (at " + te.getCoordinate() + ")"), D = ve;
          } else
            ie.isTrue(he.getLocation(g, Ve.LEFT) === U.NONE, "found single null side"), he.setLocation(g, Ve.RIGHT, D), he.setLocation(g, Ve.LEFT, D);
        }
      }
    }, Cs.prototype.getCoordinate = function() {
      var g = this.iterator();
      return g.hasNext() ? g.next().getCoordinate() : null;
    }, Cs.prototype.print = function(g) {
      De.out.println("EdgeEndStar:   " + this.getCoordinate());
      for (var p = this.iterator(); p.hasNext(); )
        p.next().print(g);
    }, Cs.prototype.isAreaLabelsConsistent = function(g) {
      return this.computeEdgeEndLabels(g.getBoundaryNodeRule()), this.checkAreaLabelsConsistent(0);
    }, Cs.prototype.checkAreaLabelsConsistent = function(g) {
      var p = this.getEdges();
      if (p.size() <= 0)
        return !0;
      var E = p.size() - 1, B = p.get(E).getLabel().getLocation(g, Ve.LEFT);
      ie.isTrue(B !== U.NONE, "Found unlabelled area edge");
      for (var D = B, j = this.iterator(); j.hasNext(); ) {
        var te = j.next().getLabel();
        ie.isTrue(te.isArea(g), "Found non-area edge");
        var he = te.getLocation(g, Ve.LEFT), ve = te.getLocation(g, Ve.RIGHT);
        if (he === ve || ve !== D)
          return !1;
        D = he;
      }
      return !0;
    }, Cs.prototype.findIndex = function(g) {
      this.iterator();
      for (var p = 0; p < this._edgeList.size(); p++)
        if (this._edgeList.get(p) === g)
          return p;
      return -1;
    }, Cs.prototype.iterator = function() {
      return this.getEdges().iterator();
    }, Cs.prototype.getEdges = function() {
      return this._edgeList === null && (this._edgeList = new We(this._edgeMap.values())), this._edgeList;
    }, Cs.prototype.getLocation = function(g, p, E) {
      return this._ptInAreaLocation[g] === U.NONE && (this._ptInAreaLocation[g] = ra.locate(p, E[g].getGeometry())), this._ptInAreaLocation[g];
    }, Cs.prototype.toString = function() {
      var g = new V();
      g.append("EdgeEndStar:   " + this.getCoordinate()), g.append(`
`);
      for (var p = this.iterator(); p.hasNext(); ) {
        var E = p.next();
        g.append(E), g.append(`
`);
      }
      return g.toString();
    }, Cs.prototype.computeEdgeEndLabels = function(g) {
      for (var p = this.iterator(); p.hasNext(); )
        p.next().computeLabel(g);
    }, Cs.prototype.computeLabelling = function(g) {
      this.computeEdgeEndLabels(g[0].getBoundaryNodeRule()), this.propagateSideLabels(0), this.propagateSideLabels(1);
      for (var p = [!1, !1], E = this.iterator(); E.hasNext(); )
        for (var B = E.next().getLabel(), D = 0; D < 2; D++)
          B.isLine(D) && B.getLocation(D) === U.BOUNDARY && (p[D] = !0);
      for (var j = this.iterator(); j.hasNext(); )
        for (var te = j.next(), he = te.getLabel(), ve = 0; ve < 2; ve++)
          if (he.isAnyNull(ve)) {
            var Le = U.NONE;
            if (p[ve])
              Le = U.EXTERIOR;
            else {
              var Je = te.getCoordinate();
              Le = this.getLocation(ve, Je, g);
            }
            he.setAllLocationsIfNull(ve, Le);
          }
    }, Cs.prototype.getDegree = function() {
      return this._edgeMap.size();
    }, Cs.prototype.insertEdgeEnd = function(g, p) {
      this._edgeMap.put(g, p), this._edgeList = null;
    }, Cs.prototype.interfaces_ = function() {
      return [];
    }, Cs.prototype.getClass = function() {
      return Cs;
    };
    var k1 = function(g) {
      function p() {
        g.call(this), this._resultAreaEdgeList = null, this._label = null, this._SCANNING_FOR_INCOMING = 1, this._LINKING_TO_OUTGOING = 2;
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.linkResultDirectedEdges = function() {
        this.getResultAreaEdges();
        for (var E = null, B = null, D = this._SCANNING_FOR_INCOMING, j = 0; j < this._resultAreaEdgeList.size(); j++) {
          var te = this._resultAreaEdgeList.get(j), he = te.getSym();
          if (te.getLabel().isArea())
            switch (E === null && te.isInResult() && (E = te), D) {
              case this._SCANNING_FOR_INCOMING:
                if (!he.isInResult())
                  continue;
                B = he, D = this._LINKING_TO_OUTGOING;
                break;
              case this._LINKING_TO_OUTGOING:
                if (!te.isInResult())
                  continue;
                B.setNext(te), D = this._SCANNING_FOR_INCOMING;
            }
        }
        if (D === this._LINKING_TO_OUTGOING) {
          if (E === null)
            throw new lr("no outgoing dirEdge found", this.getCoordinate());
          ie.isTrue(E.isInResult(), "unable to link last incoming dirEdge"), B.setNext(E);
        }
      }, p.prototype.insert = function(E) {
        var B = E;
        this.insertEdgeEnd(B, B);
      }, p.prototype.getRightmostEdge = function() {
        var E = this.getEdges(), B = E.size();
        if (B < 1)
          return null;
        var D = E.get(0);
        if (B === 1)
          return D;
        var j = E.get(B - 1), te = D.getQuadrant(), he = j.getQuadrant();
        return ai.isNorthern(te) && ai.isNorthern(he) ? D : ai.isNorthern(te) || ai.isNorthern(he) ? D.getDy() !== 0 ? D : j.getDy() !== 0 ? j : (ie.shouldNeverReachHere("found two horizontal edges incident on node"), null) : j;
      }, p.prototype.print = function(E) {
        De.out.println("DirectedEdgeStar: " + this.getCoordinate());
        for (var B = this.iterator(); B.hasNext(); ) {
          var D = B.next();
          E.print("out "), D.print(E), E.println(), E.print("in "), D.getSym().print(E), E.println();
        }
      }, p.prototype.getResultAreaEdges = function() {
        if (this._resultAreaEdgeList !== null)
          return this._resultAreaEdgeList;
        this._resultAreaEdgeList = new We();
        for (var E = this.iterator(); E.hasNext(); ) {
          var B = E.next();
          (B.isInResult() || B.getSym().isInResult()) && this._resultAreaEdgeList.add(B);
        }
        return this._resultAreaEdgeList;
      }, p.prototype.updateLabelling = function(E) {
        for (var B = this.iterator(); B.hasNext(); ) {
          var D = B.next().getLabel();
          D.setAllLocationsIfNull(0, E.getLocation(0)), D.setAllLocationsIfNull(1, E.getLocation(1));
        }
      }, p.prototype.linkAllDirectedEdges = function() {
        this.getEdges();
        for (var E = null, B = null, D = this._edgeList.size() - 1; D >= 0; D--) {
          var j = this._edgeList.get(D), te = j.getSym();
          B === null && (B = te), E !== null && te.setNext(E), E = j;
        }
        B.setNext(E);
      }, p.prototype.computeDepths = function() {
        if (arguments.length === 1) {
          var E = arguments[0], B = this.findIndex(E), D = E.getDepth(Ve.LEFT), j = E.getDepth(Ve.RIGHT), te = this.computeDepths(B + 1, this._edgeList.size(), D);
          if (this.computeDepths(0, B, te) !== j)
            throw new lr("depth mismatch at " + E.getCoordinate());
        } else if (arguments.length === 3) {
          for (var he = arguments[0], ve = arguments[1], Le = arguments[2], Je = he; Je < ve; Je++) {
            var et = this._edgeList.get(Je);
            et.setEdgeDepths(Ve.RIGHT, Le), Le = et.getDepth(Ve.LEFT);
          }
          return Le;
        }
      }, p.prototype.mergeSymLabels = function() {
        for (var E = this.iterator(); E.hasNext(); ) {
          var B = E.next();
          B.getLabel().merge(B.getSym().getLabel());
        }
      }, p.prototype.linkMinimalDirectedEdges = function(E) {
        for (var B = null, D = null, j = this._SCANNING_FOR_INCOMING, te = this._resultAreaEdgeList.size() - 1; te >= 0; te--) {
          var he = this._resultAreaEdgeList.get(te), ve = he.getSym();
          switch (B === null && he.getEdgeRing() === E && (B = he), j) {
            case this._SCANNING_FOR_INCOMING:
              if (ve.getEdgeRing() !== E)
                continue;
              D = ve, j = this._LINKING_TO_OUTGOING;
              break;
            case this._LINKING_TO_OUTGOING:
              if (he.getEdgeRing() !== E)
                continue;
              D.setNextMin(he), j = this._SCANNING_FOR_INCOMING;
          }
        }
        j === this._LINKING_TO_OUTGOING && (ie.isTrue(B !== null, "found null for first outgoing dirEdge"), ie.isTrue(B.getEdgeRing() === E, "unable to link last incoming dirEdge"), D.setNextMin(B));
      }, p.prototype.getOutgoingDegree = function() {
        if (arguments.length === 0) {
          for (var E = 0, B = this.iterator(); B.hasNext(); )
            B.next().isInResult() && E++;
          return E;
        }
        if (arguments.length === 1) {
          for (var D = arguments[0], j = 0, te = this.iterator(); te.hasNext(); )
            te.next().getEdgeRing() === D && j++;
          return j;
        }
      }, p.prototype.getLabel = function() {
        return this._label;
      }, p.prototype.findCoveredLineEdges = function() {
        for (var E = U.NONE, B = this.iterator(); B.hasNext(); ) {
          var D = B.next(), j = D.getSym();
          if (!D.isLineEdge()) {
            if (D.isInResult()) {
              E = U.INTERIOR;
              break;
            }
            if (j.isInResult()) {
              E = U.EXTERIOR;
              break;
            }
          }
        }
        if (E === U.NONE)
          return null;
        for (var te = E, he = this.iterator(); he.hasNext(); ) {
          var ve = he.next(), Le = ve.getSym();
          ve.isLineEdge() ? ve.getEdge().setCovered(te === U.INTERIOR) : (ve.isInResult() && (te = U.EXTERIOR), Le.isInResult() && (te = U.INTERIOR));
        }
      }, p.prototype.computeLabelling = function(E) {
        g.prototype.computeLabelling.call(this, E), this._label = new Zn(U.NONE);
        for (var B = this.iterator(); B.hasNext(); )
          for (var D = B.next().getEdge().getLabel(), j = 0; j < 2; j++) {
            var te = D.getLocation(j);
            te !== U.INTERIOR && te !== U.BOUNDARY || this._label.setLocation(j, U.INTERIOR);
          }
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(Cs), R0 = function(g) {
      function p() {
        g.apply(this, arguments);
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.createNode = function(E) {
        return new Cl(E, new k1());
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(Ic), Bl = function g() {
      this._pts = null, this._orientation = null;
      var p = arguments[0];
      this._pts = p, this._orientation = g.orientation(p);
    };
    Bl.prototype.compareTo = function(g) {
      var p = g;
      return Bl.compareOriented(this._pts, this._orientation, p._pts, p._orientation);
    }, Bl.prototype.interfaces_ = function() {
      return [R];
    }, Bl.prototype.getClass = function() {
      return Bl;
    }, Bl.orientation = function(g) {
      return Pt.increasingDirection(g) === 1;
    }, Bl.compareOriented = function(g, p, E, B) {
      for (var D = p ? 1 : -1, j = B ? 1 : -1, te = p ? g.length : -1, he = B ? E.length : -1, ve = p ? 0 : g.length - 1, Le = B ? 0 : E.length - 1; ; ) {
        var Je = g[ve].compareTo(E[Le]);
        if (Je !== 0)
          return Je;
        var et = (ve += D) === te, Ke = (Le += j) === he;
        if (et && !Ke)
          return -1;
        if (!et && Ke)
          return 1;
        if (et && Ke)
          return 0;
      }
    };
    var vA = function() {
      this._edges = new We(), this._ocaMap = new h();
    };
    vA.prototype.print = function(g) {
      g.print("MULTILINESTRING ( ");
      for (var p = 0; p < this._edges.size(); p++) {
        var E = this._edges.get(p);
        p > 0 && g.print(","), g.print("(");
        for (var B = E.getCoordinates(), D = 0; D < B.length; D++)
          D > 0 && g.print(","), g.print(B[D].x + " " + B[D].y);
        g.println(")");
      }
      g.print(")  ");
    }, vA.prototype.addAll = function(g) {
      for (var p = g.iterator(); p.hasNext(); )
        this.add(p.next());
    }, vA.prototype.findEdgeIndex = function(g) {
      for (var p = 0; p < this._edges.size(); p++)
        if (this._edges.get(p).equals(g))
          return p;
      return -1;
    }, vA.prototype.iterator = function() {
      return this._edges.iterator();
    }, vA.prototype.getEdges = function() {
      return this._edges;
    }, vA.prototype.get = function(g) {
      return this._edges.get(g);
    }, vA.prototype.findEqualEdge = function(g) {
      var p = new Bl(g.getCoordinates());
      return this._ocaMap.get(p);
    }, vA.prototype.add = function(g) {
      this._edges.add(g);
      var p = new Bl(g.getCoordinates());
      this._ocaMap.put(p, g);
    }, vA.prototype.interfaces_ = function() {
      return [];
    }, vA.prototype.getClass = function() {
      return vA;
    };
    var Ec = function() {
    };
    Ec.prototype.processIntersections = function(g, p, E, B) {
    }, Ec.prototype.isDone = function() {
    }, Ec.prototype.interfaces_ = function() {
      return [];
    }, Ec.prototype.getClass = function() {
      return Ec;
    };
    var Ma = function() {
      this._hasIntersection = !1, this._hasProper = !1, this._hasProperInterior = !1, this._hasInterior = !1, this._properIntersectionPoint = null, this._li = null, this._isSelfIntersection = null, this.numIntersections = 0, this.numInteriorIntersections = 0, this.numProperIntersections = 0, this.numTests = 0;
      var g = arguments[0];
      this._li = g;
    };
    Ma.prototype.isTrivialIntersection = function(g, p, E, B) {
      if (g === E && this._li.getIntersectionNum() === 1) {
        if (Ma.isAdjacentSegments(p, B))
          return !0;
        if (g.isClosed()) {
          var D = g.size() - 1;
          if (p === 0 && B === D || B === 0 && p === D)
            return !0;
        }
      }
      return !1;
    }, Ma.prototype.getProperIntersectionPoint = function() {
      return this._properIntersectionPoint;
    }, Ma.prototype.hasProperInteriorIntersection = function() {
      return this._hasProperInterior;
    }, Ma.prototype.getLineIntersector = function() {
      return this._li;
    }, Ma.prototype.hasProperIntersection = function() {
      return this._hasProper;
    }, Ma.prototype.processIntersections = function(g, p, E, B) {
      if (g === E && p === B)
        return null;
      this.numTests++;
      var D = g.getCoordinates()[p], j = g.getCoordinates()[p + 1], te = E.getCoordinates()[B], he = E.getCoordinates()[B + 1];
      this._li.computeIntersection(D, j, te, he), this._li.hasIntersection() && (this.numIntersections++, this._li.isInteriorIntersection() && (this.numInteriorIntersections++, this._hasInterior = !0), this.isTrivialIntersection(g, p, E, B) || (this._hasIntersection = !0, g.addIntersections(this._li, p, 0), E.addIntersections(this._li, B, 1), this._li.isProper() && (this.numProperIntersections++, this._hasProper = !0, this._hasProperInterior = !0)));
    }, Ma.prototype.hasIntersection = function() {
      return this._hasIntersection;
    }, Ma.prototype.isDone = function() {
      return !1;
    }, Ma.prototype.hasInteriorIntersection = function() {
      return this._hasInterior;
    }, Ma.prototype.interfaces_ = function() {
      return [Ec];
    }, Ma.prototype.getClass = function() {
      return Ma;
    }, Ma.isAdjacentSegments = function(g, p) {
      return Math.abs(g - p) === 1;
    };
    var vo = function() {
      this.coord = null, this.segmentIndex = null, this.dist = null;
      var g = arguments[0], p = arguments[1], E = arguments[2];
      this.coord = new L(g), this.segmentIndex = p, this.dist = E;
    };
    vo.prototype.getSegmentIndex = function() {
      return this.segmentIndex;
    }, vo.prototype.getCoordinate = function() {
      return this.coord;
    }, vo.prototype.print = function(g) {
      g.print(this.coord), g.print(" seg # = " + this.segmentIndex), g.println(" dist = " + this.dist);
    }, vo.prototype.compareTo = function(g) {
      var p = g;
      return this.compare(p.segmentIndex, p.dist);
    }, vo.prototype.isEndPoint = function(g) {
      return this.segmentIndex === 0 && this.dist === 0 || this.segmentIndex === g;
    }, vo.prototype.toString = function() {
      return this.coord + " seg # = " + this.segmentIndex + " dist = " + this.dist;
    }, vo.prototype.getDistance = function() {
      return this.dist;
    }, vo.prototype.compare = function(g, p) {
      return this.segmentIndex < g ? -1 : this.segmentIndex > g ? 1 : this.dist < p ? -1 : this.dist > p ? 1 : 0;
    }, vo.prototype.interfaces_ = function() {
      return [R];
    }, vo.prototype.getClass = function() {
      return vo;
    };
    var Fi = function() {
      this._nodeMap = new h(), this.edge = null;
      var g = arguments[0];
      this.edge = g;
    };
    Fi.prototype.print = function(g) {
      g.println("Intersections:");
      for (var p = this.iterator(); p.hasNext(); )
        p.next().print(g);
    }, Fi.prototype.iterator = function() {
      return this._nodeMap.values().iterator();
    }, Fi.prototype.addSplitEdges = function(g) {
      this.addEndpoints();
      for (var p = this.iterator(), E = p.next(); p.hasNext(); ) {
        var B = p.next(), D = this.createSplitEdge(E, B);
        g.add(D), E = B;
      }
    }, Fi.prototype.addEndpoints = function() {
      var g = this.edge.pts.length - 1;
      this.add(this.edge.pts[0], 0, 0), this.add(this.edge.pts[g], g, 0);
    }, Fi.prototype.createSplitEdge = function(g, p) {
      var E = p.segmentIndex - g.segmentIndex + 2, B = this.edge.pts[p.segmentIndex], D = p.dist > 0 || !p.coord.equals2D(B);
      D || E--;
      var j = new Array(E).fill(null), te = 0;
      j[te++] = new L(g.coord);
      for (var he = g.segmentIndex + 1; he <= p.segmentIndex; he++)
        j[te++] = this.edge.pts[he];
      return D && (j[te] = p.coord), new sh(j, new Zn(this.edge._label));
    }, Fi.prototype.add = function(g, p, E) {
      var B = new vo(g, p, E), D = this._nodeMap.get(B);
      return D !== null ? D : (this._nodeMap.put(B, B), B);
    }, Fi.prototype.isIntersection = function(g) {
      for (var p = this.iterator(); p.hasNext(); )
        if (p.next().coord.equals(g))
          return !0;
      return !1;
    }, Fi.prototype.interfaces_ = function() {
      return [];
    }, Fi.prototype.getClass = function() {
      return Fi;
    };
    var Zf = function() {
    };
    Zf.prototype.getChainStartIndices = function(g) {
      var p = 0, E = new We();
      E.add(new Z(p));
      do {
        var B = this.findChainEnd(g, p);
        E.add(new Z(B)), p = B;
      } while (p < g.length - 1);
      return Zf.toIntArray(E);
    }, Zf.prototype.findChainEnd = function(g, p) {
      for (var E = ai.quadrant(g[p], g[p + 1]), B = p + 1; B < g.length && ai.quadrant(g[B - 1], g[B]) === E; )
        B++;
      return B - 1;
    }, Zf.prototype.interfaces_ = function() {
      return [];
    }, Zf.prototype.getClass = function() {
      return Zf;
    }, Zf.toIntArray = function(g) {
      for (var p = new Array(g.size()).fill(null), E = 0; E < p.length; E++)
        p[E] = g.get(E).intValue();
      return p;
    };
    var yc = function() {
      this.e = null, this.pts = null, this.startIndex = null, this.env1 = new Te(), this.env2 = new Te();
      var g = arguments[0];
      this.e = g, this.pts = g.getCoordinates();
      var p = new Zf();
      this.startIndex = p.getChainStartIndices(this.pts);
    };
    yc.prototype.getCoordinates = function() {
      return this.pts;
    }, yc.prototype.getMaxX = function(g) {
      var p = this.pts[this.startIndex[g]].x, E = this.pts[this.startIndex[g + 1]].x;
      return p > E ? p : E;
    }, yc.prototype.getMinX = function(g) {
      var p = this.pts[this.startIndex[g]].x, E = this.pts[this.startIndex[g + 1]].x;
      return p < E ? p : E;
    }, yc.prototype.computeIntersectsForChain = function() {
      if (arguments.length === 4) {
        var g = arguments[0], p = arguments[1], E = arguments[2], B = arguments[3];
        this.computeIntersectsForChain(this.startIndex[g], this.startIndex[g + 1], p, p.startIndex[E], p.startIndex[E + 1], B);
      } else if (arguments.length === 6) {
        var D = arguments[0], j = arguments[1], te = arguments[2], he = arguments[3], ve = arguments[4], Le = arguments[5], Je = this.pts[D], et = this.pts[j], Ke = te.pts[he], ot = te.pts[ve];
        if (j - D == 1 && ve - he == 1)
          return Le.addIntersections(this.e, D, te.e, he), null;
        if (this.env1.init(Je, et), this.env2.init(Ke, ot), !this.env1.intersects(this.env2))
          return null;
        var je = Math.trunc((D + j) / 2), Et = Math.trunc((he + ve) / 2);
        D < je && (he < Et && this.computeIntersectsForChain(D, je, te, he, Et, Le), Et < ve && this.computeIntersectsForChain(D, je, te, Et, ve, Le)), je < j && (he < Et && this.computeIntersectsForChain(je, j, te, he, Et, Le), Et < ve && this.computeIntersectsForChain(je, j, te, Et, ve, Le));
      }
    }, yc.prototype.getStartIndexes = function() {
      return this.startIndex;
    }, yc.prototype.computeIntersects = function(g, p) {
      for (var E = 0; E < this.startIndex.length - 1; E++)
        for (var B = 0; B < g.startIndex.length - 1; B++)
          this.computeIntersectsForChain(E, g, B, p);
    }, yc.prototype.interfaces_ = function() {
      return [];
    }, yc.prototype.getClass = function() {
      return yc;
    };
    var Es = function g() {
      this._depth = Array(2).fill().map(function() {
        return Array(3);
      });
      for (var p = 0; p < 2; p++)
        for (var E = 0; E < 3; E++)
          this._depth[p][E] = g.NULL_VALUE;
    }, G1 = { NULL_VALUE: { configurable: !0 } };
    Es.prototype.getDepth = function(g, p) {
      return this._depth[g][p];
    }, Es.prototype.setDepth = function(g, p, E) {
      this._depth[g][p] = E;
    }, Es.prototype.isNull = function() {
      if (arguments.length === 0) {
        for (var g = 0; g < 2; g++)
          for (var p = 0; p < 3; p++)
            if (this._depth[g][p] !== Es.NULL_VALUE)
              return !1;
        return !0;
      }
      if (arguments.length === 1) {
        var E = arguments[0];
        return this._depth[E][1] === Es.NULL_VALUE;
      }
      if (arguments.length === 2) {
        var B = arguments[0], D = arguments[1];
        return this._depth[B][D] === Es.NULL_VALUE;
      }
    }, Es.prototype.normalize = function() {
      for (var g = 0; g < 2; g++)
        if (!this.isNull(g)) {
          var p = this._depth[g][1];
          this._depth[g][2] < p && (p = this._depth[g][2]), p < 0 && (p = 0);
          for (var E = 1; E < 3; E++) {
            var B = 0;
            this._depth[g][E] > p && (B = 1), this._depth[g][E] = B;
          }
        }
    }, Es.prototype.getDelta = function(g) {
      return this._depth[g][Ve.RIGHT] - this._depth[g][Ve.LEFT];
    }, Es.prototype.getLocation = function(g, p) {
      return this._depth[g][p] <= 0 ? U.EXTERIOR : U.INTERIOR;
    }, Es.prototype.toString = function() {
      return "A: " + this._depth[0][1] + "," + this._depth[0][2] + " B: " + this._depth[1][1] + "," + this._depth[1][2];
    }, Es.prototype.add = function() {
      if (arguments.length === 1)
        for (var g = arguments[0], p = 0; p < 2; p++)
          for (var E = 1; E < 3; E++) {
            var B = g.getLocation(p, E);
            B !== U.EXTERIOR && B !== U.INTERIOR || (this.isNull(p, E) ? this._depth[p][E] = Es.depthAtLocation(B) : this._depth[p][E] += Es.depthAtLocation(B));
          }
      else if (arguments.length === 3) {
        var D = arguments[0], j = arguments[1];
        arguments[2] === U.INTERIOR && this._depth[D][j]++;
      }
    }, Es.prototype.interfaces_ = function() {
      return [];
    }, Es.prototype.getClass = function() {
      return Es;
    }, Es.depthAtLocation = function(g) {
      return g === U.EXTERIOR ? 0 : g === U.INTERIOR ? 1 : Es.NULL_VALUE;
    }, G1.NULL_VALUE.get = function() {
      return -1;
    }, Object.defineProperties(Es, G1);
    var sh = function(g) {
      function p() {
        if (g.call(this), this.pts = null, this._env = null, this.eiList = new Fi(this), this._name = null, this._mce = null, this._isIsolated = !0, this._depth = new Es(), this._depthDelta = 0, arguments.length === 1) {
          var E = arguments[0];
          p.call(this, E, null);
        } else if (arguments.length === 2) {
          var B = arguments[0], D = arguments[1];
          this.pts = B, this._label = D;
        }
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.getDepth = function() {
        return this._depth;
      }, p.prototype.getCollapsedEdge = function() {
        var E = new Array(2).fill(null);
        return E[0] = this.pts[0], E[1] = this.pts[1], new p(E, Zn.toLineLabel(this._label));
      }, p.prototype.isIsolated = function() {
        return this._isIsolated;
      }, p.prototype.getCoordinates = function() {
        return this.pts;
      }, p.prototype.setIsolated = function(E) {
        this._isIsolated = E;
      }, p.prototype.setName = function(E) {
        this._name = E;
      }, p.prototype.equals = function(E) {
        if (!(E instanceof p))
          return !1;
        var B = E;
        if (this.pts.length !== B.pts.length)
          return !1;
        for (var D = !0, j = !0, te = this.pts.length, he = 0; he < this.pts.length; he++)
          if (this.pts[he].equals2D(B.pts[he]) || (D = !1), this.pts[he].equals2D(B.pts[--te]) || (j = !1), !D && !j)
            return !1;
        return !0;
      }, p.prototype.getCoordinate = function() {
        if (arguments.length === 0)
          return this.pts.length > 0 ? this.pts[0] : null;
        if (arguments.length === 1) {
          var E = arguments[0];
          return this.pts[E];
        }
      }, p.prototype.print = function(E) {
        E.print("edge " + this._name + ": "), E.print("LINESTRING (");
        for (var B = 0; B < this.pts.length; B++)
          B > 0 && E.print(","), E.print(this.pts[B].x + " " + this.pts[B].y);
        E.print(")  " + this._label + " " + this._depthDelta);
      }, p.prototype.computeIM = function(E) {
        p.updateIM(this._label, E);
      }, p.prototype.isCollapsed = function() {
        return !!this._label.isArea() && this.pts.length === 3 && !!this.pts[0].equals(this.pts[2]);
      }, p.prototype.isClosed = function() {
        return this.pts[0].equals(this.pts[this.pts.length - 1]);
      }, p.prototype.getMaximumSegmentIndex = function() {
        return this.pts.length - 1;
      }, p.prototype.getDepthDelta = function() {
        return this._depthDelta;
      }, p.prototype.getNumPoints = function() {
        return this.pts.length;
      }, p.prototype.printReverse = function(E) {
        E.print("edge " + this._name + ": ");
        for (var B = this.pts.length - 1; B >= 0; B--)
          E.print(this.pts[B] + " ");
        E.println("");
      }, p.prototype.getMonotoneChainEdge = function() {
        return this._mce === null && (this._mce = new yc(this)), this._mce;
      }, p.prototype.getEnvelope = function() {
        if (this._env === null) {
          this._env = new Te();
          for (var E = 0; E < this.pts.length; E++)
            this._env.expandToInclude(this.pts[E]);
        }
        return this._env;
      }, p.prototype.addIntersection = function(E, B, D, j) {
        var te = new L(E.getIntersection(j)), he = B, ve = E.getEdgeDistance(D, j), Le = he + 1;
        if (Le < this.pts.length) {
          var Je = this.pts[Le];
          te.equals2D(Je) && (he = Le, ve = 0);
        }
        this.eiList.add(te, he, ve);
      }, p.prototype.toString = function() {
        var E = new V();
        E.append("edge " + this._name + ": "), E.append("LINESTRING (");
        for (var B = 0; B < this.pts.length; B++)
          B > 0 && E.append(","), E.append(this.pts[B].x + " " + this.pts[B].y);
        return E.append(")  " + this._label + " " + this._depthDelta), E.toString();
      }, p.prototype.isPointwiseEqual = function(E) {
        if (this.pts.length !== E.pts.length)
          return !1;
        for (var B = 0; B < this.pts.length; B++)
          if (!this.pts[B].equals2D(E.pts[B]))
            return !1;
        return !0;
      }, p.prototype.setDepthDelta = function(E) {
        this._depthDelta = E;
      }, p.prototype.getEdgeIntersectionList = function() {
        return this.eiList;
      }, p.prototype.addIntersections = function(E, B, D) {
        for (var j = 0; j < E.getIntersectionNum(); j++)
          this.addIntersection(E, B, D, j);
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p.updateIM = function() {
        if (arguments.length !== 2)
          return g.prototype.updateIM.apply(this, arguments);
        var E = arguments[0], B = arguments[1];
        B.setAtLeastIfValid(E.getLocation(0, Ve.ON), E.getLocation(1, Ve.ON), 1), E.isArea() && (B.setAtLeastIfValid(E.getLocation(0, Ve.LEFT), E.getLocation(1, Ve.LEFT), 2), B.setAtLeastIfValid(E.getLocation(0, Ve.RIGHT), E.getLocation(1, Ve.RIGHT), 2));
      }, p;
    }(na), vi = function(g) {
      this._workingPrecisionModel = null, this._workingNoder = null, this._geomFact = null, this._graph = null, this._edgeList = new vA(), this._bufParams = g || null;
    };
    vi.prototype.setWorkingPrecisionModel = function(g) {
      this._workingPrecisionModel = g;
    }, vi.prototype.insertUniqueEdge = function(g) {
      var p = this._edgeList.findEqualEdge(g);
      if (p !== null) {
        var E = p.getLabel(), B = g.getLabel();
        p.isPointwiseEqual(g) || (B = new Zn(g.getLabel())).flip(), E.merge(B);
        var D = vi.depthDelta(B), j = p.getDepthDelta() + D;
        p.setDepthDelta(j);
      } else
        this._edgeList.add(g), g.setDepthDelta(vi.depthDelta(g.getLabel()));
    }, vi.prototype.buildSubgraphs = function(g, p) {
      for (var E = new We(), B = g.iterator(); B.hasNext(); ) {
        var D = B.next(), j = D.getRightmostCoordinate(), te = new Xf(E).getDepth(j);
        D.computeDepth(te), D.findResultEdges(), E.add(D), p.add(D.getDirectedEdges(), D.getNodes());
      }
    }, vi.prototype.createSubgraphs = function(g) {
      for (var p = new We(), E = g.getNodes().iterator(); E.hasNext(); ) {
        var B = E.next();
        if (!B.isVisited()) {
          var D = new nn();
          D.create(B), p.add(D);
        }
      }
      return EA.sort(p, EA.reverseOrder()), p;
    }, vi.prototype.createEmptyResultGeometry = function() {
      return this._geomFact.createPolygon();
    }, vi.prototype.getNoder = function(g) {
      if (this._workingNoder !== null)
        return this._workingNoder;
      var p = new Ku(), E = new we();
      return E.setPrecisionModel(g), p.setSegmentIntersector(new Ma(E)), p;
    }, vi.prototype.buffer = function(g, p) {
      var E = this._workingPrecisionModel;
      E === null && (E = g.getPrecisionModel()), this._geomFact = g.getFactory();
      var B = new go(E, this._bufParams), D = new Ea(g, p, B).getCurves();
      if (D.size() <= 0)
        return this.createEmptyResultGeometry();
      this.computeNodedEdges(D, E), this._graph = new Li(new R0()), this._graph.addEdges(this._edgeList.getEdges());
      var j = this.createSubgraphs(this._graph), te = new ks(this._geomFact);
      this.buildSubgraphs(j, te);
      var he = te.getPolygons();
      return he.size() <= 0 ? this.createEmptyResultGeometry() : this._geomFact.buildGeometry(he);
    }, vi.prototype.computeNodedEdges = function(g, p) {
      var E = this.getNoder(p);
      E.computeNodes(g);
      for (var B = E.getNodedSubstrings().iterator(); B.hasNext(); ) {
        var D = B.next(), j = D.getCoordinates();
        if (j.length !== 2 || !j[0].equals2D(j[1])) {
          var te = D.getData(), he = new sh(D.getCoordinates(), new Zn(te));
          this.insertUniqueEdge(he);
        }
      }
    }, vi.prototype.setNoder = function(g) {
      this._workingNoder = g;
    }, vi.prototype.interfaces_ = function() {
      return [];
    }, vi.prototype.getClass = function() {
      return vi;
    }, vi.depthDelta = function(g) {
      var p = g.getLocation(0, Ve.LEFT), E = g.getLocation(0, Ve.RIGHT);
      return p === U.INTERIOR && E === U.EXTERIOR ? 1 : p === U.EXTERIOR && E === U.INTERIOR ? -1 : 0;
    }, vi.convertSegStrings = function(g) {
      for (var p = new or(), E = new We(); g.hasNext(); ) {
        var B = g.next(), D = p.createLineString(B.getCoordinates());
        E.add(D);
      }
      return p.buildGeometry(E);
    };
    var vc = function() {
      if (this._noder = null, this._scaleFactor = null, this._offsetX = null, this._offsetY = null, this._isScaled = !1, arguments.length === 2) {
        var g = arguments[0], p = arguments[1];
        this._noder = g, this._scaleFactor = p, this._offsetX = 0, this._offsetY = 0, this._isScaled = !this.isIntegerPrecision();
      } else if (arguments.length === 4) {
        var E = arguments[0], B = arguments[1], D = arguments[2], j = arguments[3];
        this._noder = E, this._scaleFactor = B, this._offsetX = D, this._offsetY = j, this._isScaled = !this.isIntegerPrecision();
      }
    };
    vc.prototype.rescale = function() {
      if (K(arguments[0], It))
        for (var g = arguments[0].iterator(); g.hasNext(); ) {
          var p = g.next();
          this.rescale(p.getCoordinates());
        }
      else if (arguments[0] instanceof Array) {
        for (var E = arguments[0], B = 0; B < E.length; B++)
          E[B].x = E[B].x / this._scaleFactor + this._offsetX, E[B].y = E[B].y / this._scaleFactor + this._offsetY;
        E.length === 2 && E[0].equals2D(E[1]) && De.out.println(E);
      }
    }, vc.prototype.scale = function() {
      if (K(arguments[0], It)) {
        for (var g = arguments[0], p = new We(), E = g.iterator(); E.hasNext(); ) {
          var B = E.next();
          p.add(new ki(this.scale(B.getCoordinates()), B.getData()));
        }
        return p;
      }
      if (arguments[0] instanceof Array) {
        for (var D = arguments[0], j = new Array(D.length).fill(null), te = 0; te < D.length; te++)
          j[te] = new L(Math.round((D[te].x - this._offsetX) * this._scaleFactor), Math.round((D[te].y - this._offsetY) * this._scaleFactor), D[te].z);
        return Pt.removeRepeatedPoints(j);
      }
    }, vc.prototype.isIntegerPrecision = function() {
      return this._scaleFactor === 1;
    }, vc.prototype.getNodedSubstrings = function() {
      var g = this._noder.getNodedSubstrings();
      return this._isScaled && this.rescale(g), g;
    }, vc.prototype.computeNodes = function(g) {
      var p = g;
      this._isScaled && (p = this.scale(g)), this._noder.computeNodes(p);
    }, vc.prototype.interfaces_ = function() {
      return [su];
    }, vc.prototype.getClass = function() {
      return vc;
    };
    var Hs = function() {
      this._li = new we(), this._segStrings = null;
      var g = arguments[0];
      this._segStrings = g;
    }, U1 = { fact: { configurable: !0 } };
    Hs.prototype.checkEndPtVertexIntersections = function() {
      if (arguments.length === 0)
        for (var g = this._segStrings.iterator(); g.hasNext(); ) {
          var p = g.next().getCoordinates();
          this.checkEndPtVertexIntersections(p[0], this._segStrings), this.checkEndPtVertexIntersections(p[p.length - 1], this._segStrings);
        }
      else if (arguments.length === 2) {
        for (var E = arguments[0], B = arguments[1].iterator(); B.hasNext(); )
          for (var D = B.next().getCoordinates(), j = 1; j < D.length - 1; j++)
            if (D[j].equals(E))
              throw new Ee("found endpt/interior pt intersection at index " + j + " :pt " + E);
      }
    }, Hs.prototype.checkInteriorIntersections = function() {
      if (arguments.length === 0)
        for (var g = this._segStrings.iterator(); g.hasNext(); )
          for (var p = g.next(), E = this._segStrings.iterator(); E.hasNext(); ) {
            var B = E.next();
            this.checkInteriorIntersections(p, B);
          }
      else if (arguments.length === 2)
        for (var D = arguments[0], j = arguments[1], te = D.getCoordinates(), he = j.getCoordinates(), ve = 0; ve < te.length - 1; ve++)
          for (var Le = 0; Le < he.length - 1; Le++)
            this.checkInteriorIntersections(D, ve, j, Le);
      else if (arguments.length === 4) {
        var Je = arguments[0], et = arguments[1], Ke = arguments[2], ot = arguments[3];
        if (Je === Ke && et === ot)
          return null;
        var je = Je.getCoordinates()[et], Et = Je.getCoordinates()[et + 1], Gt = Ke.getCoordinates()[ot], kt = Ke.getCoordinates()[ot + 1];
        if (this._li.computeIntersection(je, Et, Gt, kt), this._li.hasIntersection() && (this._li.isProper() || this.hasInteriorIntersection(this._li, je, Et) || this.hasInteriorIntersection(this._li, Gt, kt)))
          throw new Ee("found non-noded intersection at " + je + "-" + Et + " and " + Gt + "-" + kt);
      }
    }, Hs.prototype.checkValid = function() {
      this.checkEndPtVertexIntersections(), this.checkInteriorIntersections(), this.checkCollapses();
    }, Hs.prototype.checkCollapses = function() {
      if (arguments.length === 0)
        for (var g = this._segStrings.iterator(); g.hasNext(); ) {
          var p = g.next();
          this.checkCollapses(p);
        }
      else if (arguments.length === 1)
        for (var E = arguments[0].getCoordinates(), B = 0; B < E.length - 2; B++)
          this.checkCollapse(E[B], E[B + 1], E[B + 2]);
    }, Hs.prototype.hasInteriorIntersection = function(g, p, E) {
      for (var B = 0; B < g.getIntersectionNum(); B++) {
        var D = g.getIntersection(B);
        if (!D.equals(p) && !D.equals(E))
          return !0;
      }
      return !1;
    }, Hs.prototype.checkCollapse = function(g, p, E) {
      if (g.equals(E))
        throw new Ee("found non-noded collapse at " + Hs.fact.createLineString([g, p, E]));
    }, Hs.prototype.interfaces_ = function() {
      return [];
    }, Hs.prototype.getClass = function() {
      return Hs;
    }, U1.fact.get = function() {
      return new or();
    }, Object.defineProperties(Hs, U1);
    var $s = function() {
      this._li = null, this._pt = null, this._originalPt = null, this._ptScaled = null, this._p0Scaled = null, this._p1Scaled = null, this._scaleFactor = null, this._minx = null, this._maxx = null, this._miny = null, this._maxy = null, this._corner = new Array(4).fill(null), this._safeEnv = null;
      var g = arguments[0], p = arguments[1], E = arguments[2];
      if (this._originalPt = g, this._pt = g, this._scaleFactor = p, this._li = E, p <= 0)
        throw new b("Scale factor must be non-zero");
      p !== 1 && (this._pt = new L(this.scale(g.x), this.scale(g.y)), this._p0Scaled = new L(), this._p1Scaled = new L()), this.initCorners(this._pt);
    }, H1 = { SAFE_ENV_EXPANSION_FACTOR: { configurable: !0 } };
    $s.prototype.intersectsScaled = function(g, p) {
      var E = Math.min(g.x, p.x), B = Math.max(g.x, p.x), D = Math.min(g.y, p.y), j = Math.max(g.y, p.y), te = this._maxx < E || this._minx > B || this._maxy < D || this._miny > j;
      if (te)
        return !1;
      var he = this.intersectsToleranceSquare(g, p);
      return ie.isTrue(!(te && he), "Found bad envelope test"), he;
    }, $s.prototype.initCorners = function(g) {
      this._minx = g.x - 0.5, this._maxx = g.x + 0.5, this._miny = g.y - 0.5, this._maxy = g.y + 0.5, this._corner[0] = new L(this._maxx, this._maxy), this._corner[1] = new L(this._minx, this._maxy), this._corner[2] = new L(this._minx, this._miny), this._corner[3] = new L(this._maxx, this._miny);
    }, $s.prototype.intersects = function(g, p) {
      return this._scaleFactor === 1 ? this.intersectsScaled(g, p) : (this.copyScaled(g, this._p0Scaled), this.copyScaled(p, this._p1Scaled), this.intersectsScaled(this._p0Scaled, this._p1Scaled));
    }, $s.prototype.scale = function(g) {
      return Math.round(g * this._scaleFactor);
    }, $s.prototype.getCoordinate = function() {
      return this._originalPt;
    }, $s.prototype.copyScaled = function(g, p) {
      p.x = this.scale(g.x), p.y = this.scale(g.y);
    }, $s.prototype.getSafeEnvelope = function() {
      if (this._safeEnv === null) {
        var g = $s.SAFE_ENV_EXPANSION_FACTOR / this._scaleFactor;
        this._safeEnv = new Te(this._originalPt.x - g, this._originalPt.x + g, this._originalPt.y - g, this._originalPt.y + g);
      }
      return this._safeEnv;
    }, $s.prototype.intersectsPixelClosure = function(g, p) {
      return this._li.computeIntersection(g, p, this._corner[0], this._corner[1]), !!this._li.hasIntersection() || (this._li.computeIntersection(g, p, this._corner[1], this._corner[2]), !!this._li.hasIntersection() || (this._li.computeIntersection(g, p, this._corner[2], this._corner[3]), !!this._li.hasIntersection() || (this._li.computeIntersection(g, p, this._corner[3], this._corner[0]), !!this._li.hasIntersection())));
    }, $s.prototype.intersectsToleranceSquare = function(g, p) {
      var E = !1, B = !1;
      return this._li.computeIntersection(g, p, this._corner[0], this._corner[1]), !!this._li.isProper() || (this._li.computeIntersection(g, p, this._corner[1], this._corner[2]), !!this._li.isProper() || (this._li.hasIntersection() && (E = !0), this._li.computeIntersection(g, p, this._corner[2], this._corner[3]), !!this._li.isProper() || (this._li.hasIntersection() && (B = !0), this._li.computeIntersection(g, p, this._corner[3], this._corner[0]), !!this._li.isProper() || !(!E || !B) || !!g.equals(this._pt) || !!p.equals(this._pt))));
    }, $s.prototype.addSnappedNode = function(g, p) {
      var E = g.getCoordinate(p), B = g.getCoordinate(p + 1);
      return !!this.intersects(E, B) && (g.addIntersection(this.getCoordinate(), p), !0);
    }, $s.prototype.interfaces_ = function() {
      return [];
    }, $s.prototype.getClass = function() {
      return $s;
    }, H1.SAFE_ENV_EXPANSION_FACTOR.get = function() {
      return 0.75;
    }, Object.defineProperties($s, H1);
    var Oa = function() {
      this.tempEnv1 = new Te(), this.selectedSegment = new Dn();
    };
    Oa.prototype.select = function() {
      if (arguments.length !== 1) {
        if (arguments.length === 2) {
          var g = arguments[0], p = arguments[1];
          g.getLineSegment(p, this.selectedSegment), this.select(this.selectedSegment);
        }
      }
    }, Oa.prototype.interfaces_ = function() {
      return [];
    }, Oa.prototype.getClass = function() {
      return Oa;
    };
    var ah = function() {
      this._index = null;
      var g = arguments[0];
      this._index = g;
    }, Im = { HotPixelSnapAction: { configurable: !0 } };
    ah.prototype.snap = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return this.snap(g, null, -1);
      }
      if (arguments.length === 3) {
        var p = arguments[0], E = arguments[1], B = arguments[2], D = p.getSafeEnvelope(), j = new $d(p, E, B);
        return this._index.query(D, { interfaces_: function() {
          return [_r];
        }, visitItem: function(te) {
          te.select(D, j);
        } }), j.isNodeAdded();
      }
    }, ah.prototype.interfaces_ = function() {
      return [];
    }, ah.prototype.getClass = function() {
      return ah;
    }, Im.HotPixelSnapAction.get = function() {
      return $d;
    }, Object.defineProperties(ah, Im);
    var $d = function(g) {
      function p() {
        g.call(this), this._hotPixel = null, this._parentEdge = null, this._hotPixelVertexIndex = null, this._isNodeAdded = !1;
        var E = arguments[0], B = arguments[1], D = arguments[2];
        this._hotPixel = E, this._parentEdge = B, this._hotPixelVertexIndex = D;
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.isNodeAdded = function() {
        return this._isNodeAdded;
      }, p.prototype.select = function() {
        if (arguments.length !== 2)
          return g.prototype.select.apply(this, arguments);
        var E = arguments[0], B = arguments[1], D = E.getContext();
        if (this._parentEdge !== null && D === this._parentEdge && B === this._hotPixelVertexIndex)
          return null;
        this._isNodeAdded = this._hotPixel.addSnappedNode(D, B);
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(Oa), JA = function() {
      this._li = null, this._interiorIntersections = null;
      var g = arguments[0];
      this._li = g, this._interiorIntersections = new We();
    };
    JA.prototype.processIntersections = function(g, p, E, B) {
      if (g === E && p === B)
        return null;
      var D = g.getCoordinates()[p], j = g.getCoordinates()[p + 1], te = E.getCoordinates()[B], he = E.getCoordinates()[B + 1];
      if (this._li.computeIntersection(D, j, te, he), this._li.hasIntersection() && this._li.isInteriorIntersection()) {
        for (var ve = 0; ve < this._li.getIntersectionNum(); ve++)
          this._interiorIntersections.add(this._li.getIntersection(ve));
        g.addIntersections(this._li, p, 0), E.addIntersections(this._li, B, 1);
      }
    }, JA.prototype.isDone = function() {
      return !1;
    }, JA.prototype.getInteriorIntersections = function() {
      return this._interiorIntersections;
    }, JA.prototype.interfaces_ = function() {
      return [Ec];
    }, JA.prototype.getClass = function() {
      return JA;
    };
    var ia = function() {
      this._pm = null, this._li = null, this._scaleFactor = null, this._noder = null, this._pointSnapper = null, this._nodedSegStrings = null;
      var g = arguments[0];
      this._pm = g, this._li = new we(), this._li.setPrecisionModel(g), this._scaleFactor = g.getScale();
    };
    ia.prototype.checkCorrectness = function(g) {
      var p = ki.getNodedSubstrings(g), E = new Hs(p);
      try {
        E.checkValid();
      } catch (B) {
        if (!(B instanceof xe))
          throw B;
        B.printStackTrace();
      }
    }, ia.prototype.getNodedSubstrings = function() {
      return ki.getNodedSubstrings(this._nodedSegStrings);
    }, ia.prototype.snapRound = function(g, p) {
      var E = this.findInteriorIntersections(g, p);
      this.computeIntersectionSnaps(E), this.computeVertexSnaps(g);
    }, ia.prototype.findInteriorIntersections = function(g, p) {
      var E = new JA(p);
      return this._noder.setSegmentIntersector(E), this._noder.computeNodes(g), E.getInteriorIntersections();
    }, ia.prototype.computeVertexSnaps = function() {
      if (K(arguments[0], It))
        for (var g = arguments[0].iterator(); g.hasNext(); ) {
          var p = g.next();
          this.computeVertexSnaps(p);
        }
      else if (arguments[0] instanceof ki)
        for (var E = arguments[0], B = E.getCoordinates(), D = 0; D < B.length; D++) {
          var j = new $s(B[D], this._scaleFactor, this._li);
          this._pointSnapper.snap(j, E, D) && E.addIntersection(B[D], D);
        }
    }, ia.prototype.computeNodes = function(g) {
      this._nodedSegStrings = g, this._noder = new Ku(), this._pointSnapper = new ah(this._noder.getIndex()), this.snapRound(g, this._li);
    }, ia.prototype.computeIntersectionSnaps = function(g) {
      for (var p = g.iterator(); p.hasNext(); ) {
        var E = p.next(), B = new $s(E, this._scaleFactor, this._li);
        this._pointSnapper.snap(B);
      }
    }, ia.prototype.interfaces_ = function() {
      return [su];
    }, ia.prototype.getClass = function() {
      return ia;
    };
    var ys = function() {
      if (this._argGeom = null, this._distance = null, this._bufParams = new Xr(), this._resultGeometry = null, this._saveException = null, arguments.length === 1) {
        var g = arguments[0];
        this._argGeom = g;
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        this._argGeom = p, this._bufParams = E;
      }
    }, Ah = { CAP_ROUND: { configurable: !0 }, CAP_BUTT: { configurable: !0 }, CAP_FLAT: { configurable: !0 }, CAP_SQUARE: { configurable: !0 }, MAX_PRECISION_DIGITS: { configurable: !0 } };
    ys.prototype.bufferFixedPrecision = function(g) {
      var p = new vc(new ia(new Wn(1)), g.getScale()), E = new vi(this._bufParams);
      E.setWorkingPrecisionModel(g), E.setNoder(p), this._resultGeometry = E.buffer(this._argGeom, this._distance);
    }, ys.prototype.bufferReducedPrecision = function() {
      var g = this;
      if (arguments.length === 0) {
        for (var p = ys.MAX_PRECISION_DIGITS; p >= 0; p--) {
          try {
            g.bufferReducedPrecision(p);
          } catch (j) {
            if (!(j instanceof lr))
              throw j;
            g._saveException = j;
          }
          if (g._resultGeometry !== null)
            return null;
        }
        throw this._saveException;
      }
      if (arguments.length === 1) {
        var E = arguments[0], B = ys.precisionScaleFactor(this._argGeom, this._distance, E), D = new Wn(B);
        this.bufferFixedPrecision(D);
      }
    }, ys.prototype.computeGeometry = function() {
      if (this.bufferOriginalPrecision(), this._resultGeometry !== null)
        return null;
      var g = this._argGeom.getFactory().getPrecisionModel();
      g.getType() === Wn.FIXED ? this.bufferFixedPrecision(g) : this.bufferReducedPrecision();
    }, ys.prototype.setQuadrantSegments = function(g) {
      this._bufParams.setQuadrantSegments(g);
    }, ys.prototype.bufferOriginalPrecision = function() {
      try {
        var g = new vi(this._bufParams);
        this._resultGeometry = g.buffer(this._argGeom, this._distance);
      } catch (p) {
        if (!(p instanceof Ee))
          throw p;
        this._saveException = p;
      }
    }, ys.prototype.getResultGeometry = function(g) {
      return this._distance = g, this.computeGeometry(), this._resultGeometry;
    }, ys.prototype.setEndCapStyle = function(g) {
      this._bufParams.setEndCapStyle(g);
    }, ys.prototype.interfaces_ = function() {
      return [];
    }, ys.prototype.getClass = function() {
      return ys;
    }, ys.bufferOp = function() {
      if (arguments.length === 2) {
        var g = arguments[0], p = arguments[1];
        return new ys(g).getResultGeometry(p);
      }
      if (arguments.length === 3) {
        if (Number.isInteger(arguments[2]) && arguments[0] instanceof it && typeof arguments[1] == "number") {
          var E = arguments[0], B = arguments[1], D = arguments[2], j = new ys(E);
          return j.setQuadrantSegments(D), j.getResultGeometry(B);
        }
        if (arguments[2] instanceof Xr && arguments[0] instanceof it && typeof arguments[1] == "number") {
          var te = arguments[0], he = arguments[1], ve = arguments[2];
          return new ys(te, ve).getResultGeometry(he);
        }
      } else if (arguments.length === 4) {
        var Le = arguments[0], Je = arguments[1], et = arguments[2], Ke = arguments[3], ot = new ys(Le);
        return ot.setQuadrantSegments(et), ot.setEndCapStyle(Ke), ot.getResultGeometry(Je);
      }
    }, ys.precisionScaleFactor = function(g, p, E) {
      var B = g.getEnvelopeInternal(), D = z.max(Math.abs(B.getMaxX()), Math.abs(B.getMaxY()), Math.abs(B.getMinX()), Math.abs(B.getMinY())) + 2 * (p > 0 ? p : 0), j = E - Math.trunc(Math.log(D) / Math.log(10) + 1);
      return Math.pow(10, j);
    }, Ah.CAP_ROUND.get = function() {
      return Xr.CAP_ROUND;
    }, Ah.CAP_BUTT.get = function() {
      return Xr.CAP_FLAT;
    }, Ah.CAP_FLAT.get = function() {
      return Xr.CAP_FLAT;
    }, Ah.CAP_SQUARE.get = function() {
      return Xr.CAP_SQUARE;
    }, Ah.MAX_PRECISION_DIGITS.get = function() {
      return 12;
    }, Object.defineProperties(ys, Ah);
    var oa = function() {
      this._pt = [new L(), new L()], this._distance = Q.NaN, this._isNull = !0;
    };
    oa.prototype.getCoordinates = function() {
      return this._pt;
    }, oa.prototype.getCoordinate = function(g) {
      return this._pt[g];
    }, oa.prototype.setMinimum = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        this.setMinimum(g._pt[0], g._pt[1]);
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        if (this._isNull)
          return this.initialize(p, E), null;
        var B = p.distance(E);
        B < this._distance && this.initialize(p, E, B);
      }
    }, oa.prototype.initialize = function() {
      if (arguments.length === 0)
        this._isNull = !0;
      else if (arguments.length === 2) {
        var g = arguments[0], p = arguments[1];
        this._pt[0].setCoordinate(g), this._pt[1].setCoordinate(p), this._distance = g.distance(p), this._isNull = !1;
      } else if (arguments.length === 3) {
        var E = arguments[0], B = arguments[1], D = arguments[2];
        this._pt[0].setCoordinate(E), this._pt[1].setCoordinate(B), this._distance = D, this._isNull = !1;
      }
    }, oa.prototype.getDistance = function() {
      return this._distance;
    }, oa.prototype.setMaximum = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        this.setMaximum(g._pt[0], g._pt[1]);
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        if (this._isNull)
          return this.initialize(p, E), null;
        var B = p.distance(E);
        B > this._distance && this.initialize(p, E, B);
      }
    }, oa.prototype.interfaces_ = function() {
      return [];
    }, oa.prototype.getClass = function() {
      return oa;
    };
    var Fa = function() {
    };
    Fa.prototype.interfaces_ = function() {
      return [];
    }, Fa.prototype.getClass = function() {
      return Fa;
    }, Fa.computeDistance = function() {
      if (arguments[2] instanceof oa && arguments[0] instanceof rn && arguments[1] instanceof L)
        for (var g = arguments[0], p = arguments[1], E = arguments[2], B = g.getCoordinates(), D = new Dn(), j = 0; j < B.length - 1; j++) {
          D.setCoordinates(B[j], B[j + 1]);
          var te = D.closestPoint(p);
          E.setMinimum(te, p);
        }
      else if (arguments[2] instanceof oa && arguments[0] instanceof Sn && arguments[1] instanceof L) {
        var he = arguments[0], ve = arguments[1], Le = arguments[2];
        Fa.computeDistance(he.getExteriorRing(), ve, Le);
        for (var Je = 0; Je < he.getNumInteriorRing(); Je++)
          Fa.computeDistance(he.getInteriorRingN(Je), ve, Le);
      } else if (arguments[2] instanceof oa && arguments[0] instanceof it && arguments[1] instanceof L) {
        var et = arguments[0], Ke = arguments[1], ot = arguments[2];
        if (et instanceof rn)
          Fa.computeDistance(et, Ke, ot);
        else if (et instanceof Sn)
          Fa.computeDistance(et, Ke, ot);
        else if (et instanceof ze)
          for (var je = et, Et = 0; Et < je.getNumGeometries(); Et++) {
            var Gt = je.getGeometryN(Et);
            Fa.computeDistance(Gt, Ke, ot);
          }
        else
          ot.setMinimum(et.getCoordinate(), Ke);
      } else if (arguments[2] instanceof oa && arguments[0] instanceof Dn && arguments[1] instanceof L) {
        var kt = arguments[0], bt = arguments[1], Yn = arguments[2], Hr = kt.closestPoint(bt);
        Yn.setMinimum(Hr, bt);
      }
    };
    var Wu = function(g) {
      this._maxPtDist = new oa(), this._inputGeom = g || null;
    }, mm = { MaxPointDistanceFilter: { configurable: !0 }, MaxMidpointDistanceFilter: { configurable: !0 } };
    Wu.prototype.computeMaxMidpointDistance = function(g) {
      var p = new Xu(this._inputGeom);
      g.apply(p), this._maxPtDist.setMaximum(p.getMaxPointDistance());
    }, Wu.prototype.computeMaxVertexDistance = function(g) {
      var p = new eg(this._inputGeom);
      g.apply(p), this._maxPtDist.setMaximum(p.getMaxPointDistance());
    }, Wu.prototype.findDistance = function(g) {
      return this.computeMaxVertexDistance(g), this.computeMaxMidpointDistance(g), this._maxPtDist.getDistance();
    }, Wu.prototype.getDistancePoints = function() {
      return this._maxPtDist;
    }, Wu.prototype.interfaces_ = function() {
      return [];
    }, Wu.prototype.getClass = function() {
      return Wu;
    }, mm.MaxPointDistanceFilter.get = function() {
      return eg;
    }, mm.MaxMidpointDistanceFilter.get = function() {
      return Xu;
    }, Object.defineProperties(Wu, mm);
    var eg = function(g) {
      this._maxPtDist = new oa(), this._minPtDist = new oa(), this._geom = g || null;
    };
    eg.prototype.filter = function(g) {
      this._minPtDist.initialize(), Fa.computeDistance(this._geom, g, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
    }, eg.prototype.getMaxPointDistance = function() {
      return this._maxPtDist;
    }, eg.prototype.interfaces_ = function() {
      return [_t];
    }, eg.prototype.getClass = function() {
      return eg;
    };
    var Xu = function(g) {
      this._maxPtDist = new oa(), this._minPtDist = new oa(), this._geom = g || null;
    };
    Xu.prototype.filter = function(g, p) {
      if (p === 0)
        return null;
      var E = g.getCoordinate(p - 1), B = g.getCoordinate(p), D = new L((E.x + B.x) / 2, (E.y + B.y) / 2);
      this._minPtDist.initialize(), Fa.computeDistance(this._geom, D, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
    }, Xu.prototype.isDone = function() {
      return !1;
    }, Xu.prototype.isGeometryChanged = function() {
      return !1;
    }, Xu.prototype.getMaxPointDistance = function() {
      return this._maxPtDist;
    }, Xu.prototype.interfaces_ = function() {
      return [He];
    }, Xu.prototype.getClass = function() {
      return Xu;
    };
    var au = function(g) {
      this._comps = g || null;
    };
    au.prototype.filter = function(g) {
      g instanceof Sn && this._comps.add(g);
    }, au.prototype.interfaces_ = function() {
      return [ye];
    }, au.prototype.getClass = function() {
      return au;
    }, au.getPolygons = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return au.getPolygons(g, new We());
      }
      if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        return p instanceof Sn ? E.add(p) : p instanceof ze && p.apply(new au(E)), E;
      }
    };
    var vs = function() {
      if (this._lines = null, this._isForcedToLineString = !1, arguments.length === 1) {
        var g = arguments[0];
        this._lines = g;
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        this._lines = p, this._isForcedToLineString = E;
      }
    };
    vs.prototype.filter = function(g) {
      if (this._isForcedToLineString && g instanceof vr) {
        var p = g.getFactory().createLineString(g.getCoordinateSequence());
        return this._lines.add(p), null;
      }
      g instanceof rn && this._lines.add(g);
    }, vs.prototype.setForceToLineString = function(g) {
      this._isForcedToLineString = g;
    }, vs.prototype.interfaces_ = function() {
      return [rt];
    }, vs.prototype.getClass = function() {
      return vs;
    }, vs.getGeometry = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return g.getFactory().buildGeometry(vs.getLines(g));
      }
      if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        return p.getFactory().buildGeometry(vs.getLines(p, E));
      }
    }, vs.getLines = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return vs.getLines(g, !1);
      }
      if (arguments.length === 2) {
        if (K(arguments[0], It) && K(arguments[1], It)) {
          for (var p = arguments[0], E = arguments[1], B = p.iterator(); B.hasNext(); ) {
            var D = B.next();
            vs.getLines(D, E);
          }
          return E;
        }
        if (arguments[0] instanceof it && typeof arguments[1] == "boolean") {
          var j = arguments[0], te = arguments[1], he = new We();
          return j.apply(new vs(he, te)), he;
        }
        if (arguments[0] instanceof it && K(arguments[1], It)) {
          var ve = arguments[0], Le = arguments[1];
          return ve instanceof rn ? Le.add(ve) : ve.apply(new vs(Le)), Le;
        }
      } else if (arguments.length === 3) {
        if (typeof arguments[2] == "boolean" && K(arguments[0], It) && K(arguments[1], It)) {
          for (var Je = arguments[0], et = arguments[1], Ke = arguments[2], ot = Je.iterator(); ot.hasNext(); ) {
            var je = ot.next();
            vs.getLines(je, et, Ke);
          }
          return et;
        }
        if (typeof arguments[2] == "boolean" && arguments[0] instanceof it && K(arguments[1], It)) {
          var Et = arguments[0], Gt = arguments[1], kt = arguments[2];
          return Et.apply(new vs(Gt, kt)), Gt;
        }
      }
    };
    var KA = function() {
      if (this._boundaryRule = Ct.OGC_SFS_BOUNDARY_RULE, this._isIn = null, this._numBoundaries = null, arguments.length !== 0) {
        if (arguments.length === 1) {
          var g = arguments[0];
          if (g === null)
            throw new b("Rule must be non-null");
          this._boundaryRule = g;
        }
      }
    };
    KA.prototype.locateInternal = function() {
      if (arguments[0] instanceof L && arguments[1] instanceof Sn) {
        var g = arguments[0], p = arguments[1];
        if (p.isEmpty())
          return U.EXTERIOR;
        var E = p.getExteriorRing(), B = this.locateInPolygonRing(g, E);
        if (B === U.EXTERIOR)
          return U.EXTERIOR;
        if (B === U.BOUNDARY)
          return U.BOUNDARY;
        for (var D = 0; D < p.getNumInteriorRing(); D++) {
          var j = p.getInteriorRingN(D), te = this.locateInPolygonRing(g, j);
          if (te === U.INTERIOR)
            return U.EXTERIOR;
          if (te === U.BOUNDARY)
            return U.BOUNDARY;
        }
        return U.INTERIOR;
      }
      if (arguments[0] instanceof L && arguments[1] instanceof rn) {
        var he = arguments[0], ve = arguments[1];
        if (!ve.getEnvelopeInternal().intersects(he))
          return U.EXTERIOR;
        var Le = ve.getCoordinates();
        return ve.isClosed() || !he.equals(Le[0]) && !he.equals(Le[Le.length - 1]) ? ke.isOnLine(he, Le) ? U.INTERIOR : U.EXTERIOR : U.BOUNDARY;
      }
      if (arguments[0] instanceof L && arguments[1] instanceof pr) {
        var Je = arguments[0];
        return arguments[1].getCoordinate().equals2D(Je) ? U.INTERIOR : U.EXTERIOR;
      }
    }, KA.prototype.locateInPolygonRing = function(g, p) {
      return p.getEnvelopeInternal().intersects(g) ? ke.locatePointInRing(g, p.getCoordinates()) : U.EXTERIOR;
    }, KA.prototype.intersects = function(g, p) {
      return this.locate(g, p) !== U.EXTERIOR;
    }, KA.prototype.updateLocationInfo = function(g) {
      g === U.INTERIOR && (this._isIn = !0), g === U.BOUNDARY && this._numBoundaries++;
    }, KA.prototype.computeLocation = function(g, p) {
      if (p instanceof pr && this.updateLocationInfo(this.locateInternal(g, p)), p instanceof rn)
        this.updateLocationInfo(this.locateInternal(g, p));
      else if (p instanceof Sn)
        this.updateLocationInfo(this.locateInternal(g, p));
      else if (p instanceof tt)
        for (var E = p, B = 0; B < E.getNumGeometries(); B++) {
          var D = E.getGeometryN(B);
          this.updateLocationInfo(this.locateInternal(g, D));
        }
      else if (p instanceof Tr)
        for (var j = p, te = 0; te < j.getNumGeometries(); te++) {
          var he = j.getGeometryN(te);
          this.updateLocationInfo(this.locateInternal(g, he));
        }
      else if (p instanceof ze)
        for (var ve = new yA(p); ve.hasNext(); ) {
          var Le = ve.next();
          Le !== p && this.computeLocation(g, Le);
        }
    }, KA.prototype.locate = function(g, p) {
      return p.isEmpty() ? U.EXTERIOR : p instanceof rn ? this.locateInternal(g, p) : p instanceof Sn ? this.locateInternal(g, p) : (this._isIn = !1, this._numBoundaries = 0, this.computeLocation(g, p), this._boundaryRule.isInBoundary(this._numBoundaries) ? U.BOUNDARY : this._numBoundaries > 0 || this._isIn ? U.INTERIOR : U.EXTERIOR);
    }, KA.prototype.interfaces_ = function() {
      return [];
    }, KA.prototype.getClass = function() {
      return KA;
    };
    var is = function g() {
      if (this._component = null, this._segIndex = null, this._pt = null, arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        g.call(this, p, g.INSIDE_AREA, E);
      } else if (arguments.length === 3) {
        var B = arguments[0], D = arguments[1], j = arguments[2];
        this._component = B, this._segIndex = D, this._pt = j;
      }
    }, $1 = { INSIDE_AREA: { configurable: !0 } };
    is.prototype.isInsideArea = function() {
      return this._segIndex === is.INSIDE_AREA;
    }, is.prototype.getCoordinate = function() {
      return this._pt;
    }, is.prototype.getGeometryComponent = function() {
      return this._component;
    }, is.prototype.getSegmentIndex = function() {
      return this._segIndex;
    }, is.prototype.interfaces_ = function() {
      return [];
    }, is.prototype.getClass = function() {
      return is;
    }, $1.INSIDE_AREA.get = function() {
      return -1;
    }, Object.defineProperties(is, $1);
    var Zu = function(g) {
      this._pts = g || null;
    };
    Zu.prototype.filter = function(g) {
      g instanceof pr && this._pts.add(g);
    }, Zu.prototype.interfaces_ = function() {
      return [ye];
    }, Zu.prototype.getClass = function() {
      return Zu;
    }, Zu.getPoints = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return g instanceof pr ? EA.singletonList(g) : Zu.getPoints(g, new We());
      }
      if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        return p instanceof pr ? E.add(p) : p instanceof ze && p.apply(new Zu(E)), E;
      }
    };
    var lh = function() {
      this._locations = null;
      var g = arguments[0];
      this._locations = g;
    };
    lh.prototype.filter = function(g) {
      (g instanceof pr || g instanceof rn || g instanceof Sn) && this._locations.add(new is(g, 0, g.getCoordinate()));
    }, lh.prototype.interfaces_ = function() {
      return [ye];
    }, lh.prototype.getClass = function() {
      return lh;
    }, lh.getLocations = function(g) {
      var p = new We();
      return g.apply(new lh(p)), p;
    };
    var os = function() {
      if (this._geom = null, this._terminateDistance = 0, this._ptLocator = new KA(), this._minDistanceLocation = null, this._minDistance = Q.MAX_VALUE, arguments.length === 2) {
        var g = arguments[0], p = arguments[1];
        this._geom = [g, p], this._terminateDistance = 0;
      } else if (arguments.length === 3) {
        var E = arguments[0], B = arguments[1], D = arguments[2];
        this._geom = new Array(2).fill(null), this._geom[0] = E, this._geom[1] = B, this._terminateDistance = D;
      }
    };
    os.prototype.computeContainmentDistance = function() {
      if (arguments.length === 0) {
        var g = new Array(2).fill(null);
        if (this.computeContainmentDistance(0, g), this._minDistance <= this._terminateDistance)
          return null;
        this.computeContainmentDistance(1, g);
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1], B = 1 - p, D = au.getPolygons(this._geom[p]);
        if (D.size() > 0) {
          var j = lh.getLocations(this._geom[B]);
          if (this.computeContainmentDistance(j, D, E), this._minDistance <= this._terminateDistance)
            return this._minDistanceLocation[B] = E[0], this._minDistanceLocation[p] = E[1], null;
        }
      } else if (arguments.length === 3) {
        if (arguments[2] instanceof Array && K(arguments[0], hn) && K(arguments[1], hn)) {
          for (var te = arguments[0], he = arguments[1], ve = arguments[2], Le = 0; Le < te.size(); Le++)
            for (var Je = te.get(Le), et = 0; et < he.size(); et++)
              if (this.computeContainmentDistance(Je, he.get(et), ve), this._minDistance <= this._terminateDistance)
                return null;
        } else if (arguments[2] instanceof Array && arguments[0] instanceof is && arguments[1] instanceof Sn) {
          var Ke = arguments[0], ot = arguments[1], je = arguments[2], Et = Ke.getCoordinate();
          if (U.EXTERIOR !== this._ptLocator.locate(Et, ot))
            return this._minDistance = 0, je[0] = Ke, je[1] = new is(ot, Et), null;
        }
      }
    }, os.prototype.computeMinDistanceLinesPoints = function(g, p, E) {
      for (var B = 0; B < g.size(); B++)
        for (var D = g.get(B), j = 0; j < p.size(); j++) {
          var te = p.get(j);
          if (this.computeMinDistance(D, te, E), this._minDistance <= this._terminateDistance)
            return null;
        }
    }, os.prototype.computeFacetDistance = function() {
      var g = new Array(2).fill(null), p = vs.getLines(this._geom[0]), E = vs.getLines(this._geom[1]), B = Zu.getPoints(this._geom[0]), D = Zu.getPoints(this._geom[1]);
      return this.computeMinDistanceLines(p, E, g), this.updateMinDistance(g, !1), this._minDistance <= this._terminateDistance ? null : (g[0] = null, g[1] = null, this.computeMinDistanceLinesPoints(p, D, g), this.updateMinDistance(g, !1), this._minDistance <= this._terminateDistance ? null : (g[0] = null, g[1] = null, this.computeMinDistanceLinesPoints(E, B, g), this.updateMinDistance(g, !0), this._minDistance <= this._terminateDistance ? null : (g[0] = null, g[1] = null, this.computeMinDistancePoints(B, D, g), void this.updateMinDistance(g, !1))));
    }, os.prototype.nearestLocations = function() {
      return this.computeMinDistance(), this._minDistanceLocation;
    }, os.prototype.updateMinDistance = function(g, p) {
      if (g[0] === null)
        return null;
      p ? (this._minDistanceLocation[0] = g[1], this._minDistanceLocation[1] = g[0]) : (this._minDistanceLocation[0] = g[0], this._minDistanceLocation[1] = g[1]);
    }, os.prototype.nearestPoints = function() {
      return this.computeMinDistance(), [this._minDistanceLocation[0].getCoordinate(), this._minDistanceLocation[1].getCoordinate()];
    }, os.prototype.computeMinDistance = function() {
      if (arguments.length === 0) {
        if (this._minDistanceLocation !== null || (this._minDistanceLocation = new Array(2).fill(null), this.computeContainmentDistance(), this._minDistance <= this._terminateDistance))
          return null;
        this.computeFacetDistance();
      } else if (arguments.length === 3) {
        if (arguments[2] instanceof Array && arguments[0] instanceof rn && arguments[1] instanceof pr) {
          var g = arguments[0], p = arguments[1], E = arguments[2];
          if (g.getEnvelopeInternal().distance(p.getEnvelopeInternal()) > this._minDistance)
            return null;
          for (var B = g.getCoordinates(), D = p.getCoordinate(), j = 0; j < B.length - 1; j++) {
            var te = ke.distancePointLine(D, B[j], B[j + 1]);
            if (te < this._minDistance) {
              this._minDistance = te;
              var he = new Dn(B[j], B[j + 1]).closestPoint(D);
              E[0] = new is(g, j, he), E[1] = new is(p, 0, D);
            }
            if (this._minDistance <= this._terminateDistance)
              return null;
          }
        } else if (arguments[2] instanceof Array && arguments[0] instanceof rn && arguments[1] instanceof rn) {
          var ve = arguments[0], Le = arguments[1], Je = arguments[2];
          if (ve.getEnvelopeInternal().distance(Le.getEnvelopeInternal()) > this._minDistance)
            return null;
          for (var et = ve.getCoordinates(), Ke = Le.getCoordinates(), ot = 0; ot < et.length - 1; ot++)
            for (var je = 0; je < Ke.length - 1; je++) {
              var Et = ke.distanceLineLine(et[ot], et[ot + 1], Ke[je], Ke[je + 1]);
              if (Et < this._minDistance) {
                this._minDistance = Et;
                var Gt = new Dn(et[ot], et[ot + 1]), kt = new Dn(Ke[je], Ke[je + 1]), bt = Gt.closestPoints(kt);
                Je[0] = new is(ve, ot, bt[0]), Je[1] = new is(Le, je, bt[1]);
              }
              if (this._minDistance <= this._terminateDistance)
                return null;
            }
        }
      }
    }, os.prototype.computeMinDistancePoints = function(g, p, E) {
      for (var B = 0; B < g.size(); B++)
        for (var D = g.get(B), j = 0; j < p.size(); j++) {
          var te = p.get(j), he = D.getCoordinate().distance(te.getCoordinate());
          if (he < this._minDistance && (this._minDistance = he, E[0] = new is(D, 0, D.getCoordinate()), E[1] = new is(te, 0, te.getCoordinate())), this._minDistance <= this._terminateDistance)
            return null;
        }
    }, os.prototype.distance = function() {
      if (this._geom[0] === null || this._geom[1] === null)
        throw new b("null geometries are not supported");
      return this._geom[0].isEmpty() || this._geom[1].isEmpty() ? 0 : (this.computeMinDistance(), this._minDistance);
    }, os.prototype.computeMinDistanceLines = function(g, p, E) {
      for (var B = 0; B < g.size(); B++)
        for (var D = g.get(B), j = 0; j < p.size(); j++) {
          var te = p.get(j);
          if (this.computeMinDistance(D, te, E), this._minDistance <= this._terminateDistance)
            return null;
        }
    }, os.prototype.interfaces_ = function() {
      return [];
    }, os.prototype.getClass = function() {
      return os;
    }, os.distance = function(g, p) {
      return new os(g, p).distance();
    }, os.isWithinDistance = function(g, p, E) {
      return new os(g, p, E).distance() <= E;
    }, os.nearestPoints = function(g, p) {
      return new os(g, p).nearestPoints();
    };
    var Bs = function() {
      this._pt = [new L(), new L()], this._distance = Q.NaN, this._isNull = !0;
    };
    Bs.prototype.getCoordinates = function() {
      return this._pt;
    }, Bs.prototype.getCoordinate = function(g) {
      return this._pt[g];
    }, Bs.prototype.setMinimum = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        this.setMinimum(g._pt[0], g._pt[1]);
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        if (this._isNull)
          return this.initialize(p, E), null;
        var B = p.distance(E);
        B < this._distance && this.initialize(p, E, B);
      }
    }, Bs.prototype.initialize = function() {
      if (arguments.length === 0)
        this._isNull = !0;
      else if (arguments.length === 2) {
        var g = arguments[0], p = arguments[1];
        this._pt[0].setCoordinate(g), this._pt[1].setCoordinate(p), this._distance = g.distance(p), this._isNull = !1;
      } else if (arguments.length === 3) {
        var E = arguments[0], B = arguments[1], D = arguments[2];
        this._pt[0].setCoordinate(E), this._pt[1].setCoordinate(B), this._distance = D, this._isNull = !1;
      }
    }, Bs.prototype.toString = function() {
      return Re.toLineString(this._pt[0], this._pt[1]);
    }, Bs.prototype.getDistance = function() {
      return this._distance;
    }, Bs.prototype.setMaximum = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        this.setMaximum(g._pt[0], g._pt[1]);
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        if (this._isNull)
          return this.initialize(p, E), null;
        var B = p.distance(E);
        B > this._distance && this.initialize(p, E, B);
      }
    }, Bs.prototype.interfaces_ = function() {
      return [];
    }, Bs.prototype.getClass = function() {
      return Bs;
    };
    var bs = function() {
    };
    bs.prototype.interfaces_ = function() {
      return [];
    }, bs.prototype.getClass = function() {
      return bs;
    }, bs.computeDistance = function() {
      if (arguments[2] instanceof Bs && arguments[0] instanceof rn && arguments[1] instanceof L)
        for (var g = arguments[0], p = arguments[1], E = arguments[2], B = new Dn(), D = g.getCoordinates(), j = 0; j < D.length - 1; j++) {
          B.setCoordinates(D[j], D[j + 1]);
          var te = B.closestPoint(p);
          E.setMinimum(te, p);
        }
      else if (arguments[2] instanceof Bs && arguments[0] instanceof Sn && arguments[1] instanceof L) {
        var he = arguments[0], ve = arguments[1], Le = arguments[2];
        bs.computeDistance(he.getExteriorRing(), ve, Le);
        for (var Je = 0; Je < he.getNumInteriorRing(); Je++)
          bs.computeDistance(he.getInteriorRingN(Je), ve, Le);
      } else if (arguments[2] instanceof Bs && arguments[0] instanceof it && arguments[1] instanceof L) {
        var et = arguments[0], Ke = arguments[1], ot = arguments[2];
        if (et instanceof rn)
          bs.computeDistance(et, Ke, ot);
        else if (et instanceof Sn)
          bs.computeDistance(et, Ke, ot);
        else if (et instanceof ze)
          for (var je = et, Et = 0; Et < je.getNumGeometries(); Et++) {
            var Gt = je.getGeometryN(Et);
            bs.computeDistance(Gt, Ke, ot);
          }
        else
          ot.setMinimum(et.getCoordinate(), Ke);
      } else if (arguments[2] instanceof Bs && arguments[0] instanceof Dn && arguments[1] instanceof L) {
        var kt = arguments[0], bt = arguments[1], Yn = arguments[2], Hr = kt.closestPoint(bt);
        Yn.setMinimum(Hr, bt);
      }
    };
    var Xa = function() {
      this._g0 = null, this._g1 = null, this._ptDist = new Bs(), this._densifyFrac = 0;
      var g = arguments[0], p = arguments[1];
      this._g0 = g, this._g1 = p;
    }, D0 = { MaxPointDistanceFilter: { configurable: !0 }, MaxDensifiedByFractionDistanceFilter: { configurable: !0 } };
    Xa.prototype.getCoordinates = function() {
      return this._ptDist.getCoordinates();
    }, Xa.prototype.setDensifyFraction = function(g) {
      if (g > 1 || g <= 0)
        throw new b("Fraction is not in range (0.0 - 1.0]");
      this._densifyFrac = g;
    }, Xa.prototype.compute = function(g, p) {
      this.computeOrientedDistance(g, p, this._ptDist), this.computeOrientedDistance(p, g, this._ptDist);
    }, Xa.prototype.distance = function() {
      return this.compute(this._g0, this._g1), this._ptDist.getDistance();
    }, Xa.prototype.computeOrientedDistance = function(g, p, E) {
      var B = new ch(p);
      if (g.apply(B), E.setMaximum(B.getMaxPointDistance()), this._densifyFrac > 0) {
        var D = new ef(p, this._densifyFrac);
        g.apply(D), E.setMaximum(D.getMaxPointDistance());
      }
    }, Xa.prototype.orientedDistance = function() {
      return this.computeOrientedDistance(this._g0, this._g1, this._ptDist), this._ptDist.getDistance();
    }, Xa.prototype.interfaces_ = function() {
      return [];
    }, Xa.prototype.getClass = function() {
      return Xa;
    }, Xa.distance = function() {
      if (arguments.length === 2) {
        var g = arguments[0], p = arguments[1];
        return new Xa(g, p).distance();
      }
      if (arguments.length === 3) {
        var E = arguments[0], B = arguments[1], D = arguments[2], j = new Xa(E, B);
        return j.setDensifyFraction(D), j.distance();
      }
    }, D0.MaxPointDistanceFilter.get = function() {
      return ch;
    }, D0.MaxDensifiedByFractionDistanceFilter.get = function() {
      return ef;
    }, Object.defineProperties(Xa, D0);
    var ch = function() {
      this._maxPtDist = new Bs(), this._minPtDist = new Bs(), this._euclideanDist = new bs(), this._geom = null;
      var g = arguments[0];
      this._geom = g;
    };
    ch.prototype.filter = function(g) {
      this._minPtDist.initialize(), bs.computeDistance(this._geom, g, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
    }, ch.prototype.getMaxPointDistance = function() {
      return this._maxPtDist;
    }, ch.prototype.interfaces_ = function() {
      return [_t];
    }, ch.prototype.getClass = function() {
      return ch;
    };
    var ef = function() {
      this._maxPtDist = new Bs(), this._minPtDist = new Bs(), this._geom = null, this._numSubSegs = 0;
      var g = arguments[0], p = arguments[1];
      this._geom = g, this._numSubSegs = Math.trunc(Math.round(1 / p));
    };
    ef.prototype.filter = function(g, p) {
      if (p === 0)
        return null;
      for (var E = g.getCoordinate(p - 1), B = g.getCoordinate(p), D = (B.x - E.x) / this._numSubSegs, j = (B.y - E.y) / this._numSubSegs, te = 0; te < this._numSubSegs; te++) {
        var he = E.x + te * D, ve = E.y + te * j, Le = new L(he, ve);
        this._minPtDist.initialize(), bs.computeDistance(this._geom, Le, this._minPtDist), this._maxPtDist.setMaximum(this._minPtDist);
      }
    }, ef.prototype.isDone = function() {
      return !1;
    }, ef.prototype.isGeometryChanged = function() {
      return !1;
    }, ef.prototype.getMaxPointDistance = function() {
      return this._maxPtDist;
    }, ef.prototype.interfaces_ = function() {
      return [He];
    }, ef.prototype.getClass = function() {
      return ef;
    };
    var Pa = function(g, p, E) {
      this._minValidDistance = null, this._maxValidDistance = null, this._minDistanceFound = null, this._maxDistanceFound = null, this._isValid = !0, this._errMsg = null, this._errorLocation = null, this._errorIndicator = null, this._input = g || null, this._bufDistance = p || null, this._result = E || null;
    }, ry = { VERBOSE: { configurable: !0 }, MAX_DISTANCE_DIFF_FRAC: { configurable: !0 } };
    Pa.prototype.checkMaximumDistance = function(g, p, E) {
      var B = new Xa(p, g);
      if (B.setDensifyFraction(0.25), this._maxDistanceFound = B.orientedDistance(), this._maxDistanceFound > E) {
        this._isValid = !1;
        var D = B.getCoordinates();
        this._errorLocation = D[1], this._errorIndicator = g.getFactory().createLineString(D), this._errMsg = "Distance between buffer curve and input is too large (" + this._maxDistanceFound + " at " + Re.toLineString(D[0], D[1]) + ")";
      }
    }, Pa.prototype.isValid = function() {
      var g = Math.abs(this._bufDistance), p = Pa.MAX_DISTANCE_DIFF_FRAC * g;
      return this._minValidDistance = g - p, this._maxValidDistance = g + p, !(!this._input.isEmpty() && !this._result.isEmpty()) || (this._bufDistance > 0 ? this.checkPositiveValid() : this.checkNegativeValid(), Pa.VERBOSE && De.out.println("Min Dist= " + this._minDistanceFound + "  err= " + (1 - this._minDistanceFound / this._bufDistance) + "  Max Dist= " + this._maxDistanceFound + "  err= " + (this._maxDistanceFound / this._bufDistance - 1)), this._isValid);
    }, Pa.prototype.checkNegativeValid = function() {
      if (!(this._input instanceof Sn || this._input instanceof Tr || this._input instanceof ze))
        return null;
      var g = this.getPolygonLines(this._input);
      if (this.checkMinimumDistance(g, this._result, this._minValidDistance), !this._isValid)
        return null;
      this.checkMaximumDistance(g, this._result, this._maxValidDistance);
    }, Pa.prototype.getErrorIndicator = function() {
      return this._errorIndicator;
    }, Pa.prototype.checkMinimumDistance = function(g, p, E) {
      var B = new os(g, p, E);
      if (this._minDistanceFound = B.distance(), this._minDistanceFound < E) {
        this._isValid = !1;
        var D = B.nearestPoints();
        this._errorLocation = B.nearestPoints()[1], this._errorIndicator = g.getFactory().createLineString(D), this._errMsg = "Distance between buffer curve and input is too small (" + this._minDistanceFound + " at " + Re.toLineString(D[0], D[1]) + " )";
      }
    }, Pa.prototype.checkPositiveValid = function() {
      var g = this._result.getBoundary();
      if (this.checkMinimumDistance(this._input, g, this._minValidDistance), !this._isValid)
        return null;
      this.checkMaximumDistance(this._input, g, this._maxValidDistance);
    }, Pa.prototype.getErrorLocation = function() {
      return this._errorLocation;
    }, Pa.prototype.getPolygonLines = function(g) {
      for (var p = new We(), E = new vs(p), B = au.getPolygons(g).iterator(); B.hasNext(); )
        B.next().apply(E);
      return g.getFactory().buildGeometry(p);
    }, Pa.prototype.getErrorMessage = function() {
      return this._errMsg;
    }, Pa.prototype.interfaces_ = function() {
      return [];
    }, Pa.prototype.getClass = function() {
      return Pa;
    }, ry.VERBOSE.get = function() {
      return !1;
    }, ry.MAX_DISTANCE_DIFF_FRAC.get = function() {
      return 0.012;
    }, Object.defineProperties(Pa, ry);
    var No = function(g, p, E) {
      this._isValid = !0, this._errorMsg = null, this._errorLocation = null, this._errorIndicator = null, this._input = g || null, this._distance = p || null, this._result = E || null;
    }, qd = { VERBOSE: { configurable: !0 }, MAX_ENV_DIFF_FRAC: { configurable: !0 } };
    No.prototype.isValid = function() {
      return this.checkPolygonal(), this._isValid ? (this.checkExpectedEmpty(), this._isValid ? (this.checkEnvelope(), this._isValid ? (this.checkArea(), this._isValid ? (this.checkDistance(), this._isValid) : this._isValid) : this._isValid) : this._isValid) : this._isValid;
    }, No.prototype.checkEnvelope = function() {
      if (this._distance < 0)
        return null;
      var g = this._distance * No.MAX_ENV_DIFF_FRAC;
      g === 0 && (g = 1e-3);
      var p = new Te(this._input.getEnvelopeInternal());
      p.expandBy(this._distance);
      var E = new Te(this._result.getEnvelopeInternal());
      E.expandBy(g), E.contains(p) || (this._isValid = !1, this._errorMsg = "Buffer envelope is incorrect", this._errorIndicator = this._input.getFactory().toGeometry(E)), this.report("Envelope");
    }, No.prototype.checkDistance = function() {
      var g = new Pa(this._input, this._distance, this._result);
      g.isValid() || (this._isValid = !1, this._errorMsg = g.getErrorMessage(), this._errorLocation = g.getErrorLocation(), this._errorIndicator = g.getErrorIndicator()), this.report("Distance");
    }, No.prototype.checkArea = function() {
      var g = this._input.getArea(), p = this._result.getArea();
      this._distance > 0 && g > p && (this._isValid = !1, this._errorMsg = "Area of positive buffer is smaller than input", this._errorIndicator = this._result), this._distance < 0 && g < p && (this._isValid = !1, this._errorMsg = "Area of negative buffer is larger than input", this._errorIndicator = this._result), this.report("Area");
    }, No.prototype.checkPolygonal = function() {
      this._result instanceof Sn || this._result instanceof Tr || (this._isValid = !1), this._errorMsg = "Result is not polygonal", this._errorIndicator = this._result, this.report("Polygonal");
    }, No.prototype.getErrorIndicator = function() {
      return this._errorIndicator;
    }, No.prototype.getErrorLocation = function() {
      return this._errorLocation;
    }, No.prototype.checkExpectedEmpty = function() {
      return this._input.getDimension() >= 2 || this._distance > 0 ? null : (this._result.isEmpty() || (this._isValid = !1, this._errorMsg = "Result is non-empty", this._errorIndicator = this._result), void this.report("ExpectedEmpty"));
    }, No.prototype.report = function(g) {
      if (!No.VERBOSE)
        return null;
      De.out.println("Check " + g + ": " + (this._isValid ? "passed" : "FAILED"));
    }, No.prototype.getErrorMessage = function() {
      return this._errorMsg;
    }, No.prototype.interfaces_ = function() {
      return [];
    }, No.prototype.getClass = function() {
      return No;
    }, No.isValidMsg = function(g, p, E) {
      var B = new No(g, p, E);
      return B.isValid() ? null : B.getErrorMessage();
    }, No.isValid = function(g, p, E) {
      return !!new No(g, p, E).isValid();
    }, qd.VERBOSE.get = function() {
      return !1;
    }, qd.MAX_ENV_DIFF_FRAC.get = function() {
      return 0.012;
    }, Object.defineProperties(No, qd);
    var Za = function() {
      this._pts = null, this._data = null;
      var g = arguments[0], p = arguments[1];
      this._pts = g, this._data = p;
    };
    Za.prototype.getCoordinates = function() {
      return this._pts;
    }, Za.prototype.size = function() {
      return this._pts.length;
    }, Za.prototype.getCoordinate = function(g) {
      return this._pts[g];
    }, Za.prototype.isClosed = function() {
      return this._pts[0].equals(this._pts[this._pts.length - 1]);
    }, Za.prototype.getSegmentOctant = function(g) {
      return g === this._pts.length - 1 ? -1 : Ju.octant(this.getCoordinate(g), this.getCoordinate(g + 1));
    }, Za.prototype.setData = function(g) {
      this._data = g;
    }, Za.prototype.getData = function() {
      return this._data;
    }, Za.prototype.toString = function() {
      return Re.toLineString(new In(this._pts));
    }, Za.prototype.interfaces_ = function() {
      return [Cc];
    }, Za.prototype.getClass = function() {
      return Za;
    };
    var Yo = function() {
      this._findAllIntersections = !1, this._isCheckEndSegmentsOnly = !1, this._li = null, this._interiorIntersection = null, this._intSegments = null, this._intersections = new We(), this._intersectionCount = 0, this._keepIntersections = !0;
      var g = arguments[0];
      this._li = g, this._interiorIntersection = null;
    };
    Yo.prototype.getInteriorIntersection = function() {
      return this._interiorIntersection;
    }, Yo.prototype.setCheckEndSegmentsOnly = function(g) {
      this._isCheckEndSegmentsOnly = g;
    }, Yo.prototype.getIntersectionSegments = function() {
      return this._intSegments;
    }, Yo.prototype.count = function() {
      return this._intersectionCount;
    }, Yo.prototype.getIntersections = function() {
      return this._intersections;
    }, Yo.prototype.setFindAllIntersections = function(g) {
      this._findAllIntersections = g;
    }, Yo.prototype.setKeepIntersections = function(g) {
      this._keepIntersections = g;
    }, Yo.prototype.processIntersections = function(g, p, E, B) {
      if (!this._findAllIntersections && this.hasIntersection() || g === E && p === B || this._isCheckEndSegmentsOnly && !(this.isEndSegment(g, p) || this.isEndSegment(E, B)))
        return null;
      var D = g.getCoordinates()[p], j = g.getCoordinates()[p + 1], te = E.getCoordinates()[B], he = E.getCoordinates()[B + 1];
      this._li.computeIntersection(D, j, te, he), this._li.hasIntersection() && this._li.isInteriorIntersection() && (this._intSegments = new Array(4).fill(null), this._intSegments[0] = D, this._intSegments[1] = j, this._intSegments[2] = te, this._intSegments[3] = he, this._interiorIntersection = this._li.getIntersection(0), this._keepIntersections && this._intersections.add(this._interiorIntersection), this._intersectionCount++);
    }, Yo.prototype.isEndSegment = function(g, p) {
      return p === 0 || p >= g.size() - 2;
    }, Yo.prototype.hasIntersection = function() {
      return this._interiorIntersection !== null;
    }, Yo.prototype.isDone = function() {
      return !this._findAllIntersections && this._interiorIntersection !== null;
    }, Yo.prototype.interfaces_ = function() {
      return [Ec];
    }, Yo.prototype.getClass = function() {
      return Yo;
    }, Yo.createAllIntersectionsFinder = function(g) {
      var p = new Yo(g);
      return p.setFindAllIntersections(!0), p;
    }, Yo.createAnyIntersectionFinder = function(g) {
      return new Yo(g);
    }, Yo.createIntersectionCounter = function(g) {
      var p = new Yo(g);
      return p.setFindAllIntersections(!0), p.setKeepIntersections(!1), p;
    };
    var eA = function() {
      this._li = new we(), this._segStrings = null, this._findAllIntersections = !1, this._segInt = null, this._isValid = !0;
      var g = arguments[0];
      this._segStrings = g;
    };
    eA.prototype.execute = function() {
      if (this._segInt !== null)
        return null;
      this.checkInteriorIntersections();
    }, eA.prototype.getIntersections = function() {
      return this._segInt.getIntersections();
    }, eA.prototype.isValid = function() {
      return this.execute(), this._isValid;
    }, eA.prototype.setFindAllIntersections = function(g) {
      this._findAllIntersections = g;
    }, eA.prototype.checkInteriorIntersections = function() {
      this._isValid = !0, this._segInt = new Yo(this._li), this._segInt.setFindAllIntersections(this._findAllIntersections);
      var g = new Ku();
      if (g.setSegmentIntersector(this._segInt), g.computeNodes(this._segStrings), this._segInt.hasIntersection())
        return this._isValid = !1, null;
    }, eA.prototype.checkValid = function() {
      if (this.execute(), !this._isValid)
        throw new lr(this.getErrorMessage(), this._segInt.getInteriorIntersection());
    }, eA.prototype.getErrorMessage = function() {
      if (this._isValid)
        return "no intersections found";
      var g = this._segInt.getIntersectionSegments();
      return "found non-noded intersection between " + Re.toLineString(g[0], g[1]) + " and " + Re.toLineString(g[2], g[3]);
    }, eA.prototype.interfaces_ = function() {
      return [];
    }, eA.prototype.getClass = function() {
      return eA;
    }, eA.computeIntersections = function(g) {
      var p = new eA(g);
      return p.setFindAllIntersections(!0), p.isValid(), p.getIntersections();
    };
    var tf = function g() {
      this._nv = null;
      var p = arguments[0];
      this._nv = new eA(g.toSegmentStrings(p));
    };
    tf.prototype.checkValid = function() {
      this._nv.checkValid();
    }, tf.prototype.interfaces_ = function() {
      return [];
    }, tf.prototype.getClass = function() {
      return tf;
    }, tf.toSegmentStrings = function(g) {
      for (var p = new We(), E = g.iterator(); E.hasNext(); ) {
        var B = E.next();
        p.add(new Za(B.getCoordinates(), B));
      }
      return p;
    }, tf.checkValid = function(g) {
      new tf(g).checkValid();
    };
    var uh = function(g) {
      this._mapOp = g;
    };
    uh.prototype.map = function(g) {
      for (var p = new We(), E = 0; E < g.getNumGeometries(); E++) {
        var B = this._mapOp.map(g.getGeometryN(E));
        B.isEmpty() || p.add(B);
      }
      return g.getFactory().createGeometryCollection(or.toGeometryArray(p));
    }, uh.prototype.interfaces_ = function() {
      return [];
    }, uh.prototype.getClass = function() {
      return uh;
    }, uh.map = function(g, p) {
      return new uh(p).map(g);
    };
    var WA = function() {
      this._op = null, this._geometryFactory = null, this._ptLocator = null, this._lineEdgesList = new We(), this._resultLineList = new We();
      var g = arguments[0], p = arguments[1], E = arguments[2];
      this._op = g, this._geometryFactory = p, this._ptLocator = E;
    };
    WA.prototype.collectLines = function(g) {
      for (var p = this._op.getGraph().getEdgeEnds().iterator(); p.hasNext(); ) {
        var E = p.next();
        this.collectLineEdge(E, g, this._lineEdgesList), this.collectBoundaryTouchEdge(E, g, this._lineEdgesList);
      }
    }, WA.prototype.labelIsolatedLine = function(g, p) {
      var E = this._ptLocator.locate(g.getCoordinate(), this._op.getArgGeometry(p));
      g.getLabel().setLocation(p, E);
    }, WA.prototype.build = function(g) {
      return this.findCoveredLineEdges(), this.collectLines(g), this.buildLines(g), this._resultLineList;
    }, WA.prototype.collectLineEdge = function(g, p, E) {
      var B = g.getLabel(), D = g.getEdge();
      g.isLineEdge() && (g.isVisited() || !Vn.isResultOfOp(B, p) || D.isCovered() || (E.add(D), g.setVisitedEdge(!0)));
    }, WA.prototype.findCoveredLineEdges = function() {
      for (var g = this._op.getGraph().getNodes().iterator(); g.hasNext(); )
        g.next().getEdges().findCoveredLineEdges();
      for (var p = this._op.getGraph().getEdgeEnds().iterator(); p.hasNext(); ) {
        var E = p.next(), B = E.getEdge();
        if (E.isLineEdge() && !B.isCoveredSet()) {
          var D = this._op.isCoveredByA(E.getCoordinate());
          B.setCovered(D);
        }
      }
    }, WA.prototype.labelIsolatedLines = function(g) {
      for (var p = g.iterator(); p.hasNext(); ) {
        var E = p.next(), B = E.getLabel();
        E.isIsolated() && (B.isNull(0) ? this.labelIsolatedLine(E, 0) : this.labelIsolatedLine(E, 1));
      }
    }, WA.prototype.buildLines = function(g) {
      for (var p = this._lineEdgesList.iterator(); p.hasNext(); ) {
        var E = p.next(), B = this._geometryFactory.createLineString(E.getCoordinates());
        this._resultLineList.add(B), E.setInResult(!0);
      }
    }, WA.prototype.collectBoundaryTouchEdge = function(g, p, E) {
      var B = g.getLabel();
      return g.isLineEdge() || g.isVisited() || g.isInteriorAreaEdge() || g.getEdge().isInResult() ? null : (ie.isTrue(!(g.isInResult() || g.getSym().isInResult()) || !g.getEdge().isInResult()), void (Vn.isResultOfOp(B, p) && p === Vn.INTERSECTION && (E.add(g.getEdge()), g.setVisitedEdge(!0))));
    }, WA.prototype.interfaces_ = function() {
      return [];
    }, WA.prototype.getClass = function() {
      return WA;
    };
    var fh = function() {
      this._op = null, this._geometryFactory = null, this._resultPointList = new We();
      var g = arguments[0], p = arguments[1];
      this._op = g, this._geometryFactory = p;
    };
    fh.prototype.filterCoveredNodeToPoint = function(g) {
      var p = g.getCoordinate();
      if (!this._op.isCoveredByLA(p)) {
        var E = this._geometryFactory.createPoint(p);
        this._resultPointList.add(E);
      }
    }, fh.prototype.extractNonCoveredResultNodes = function(g) {
      for (var p = this._op.getGraph().getNodes().iterator(); p.hasNext(); ) {
        var E = p.next();
        if (!E.isInResult() && !E.isIncidentEdgeInResult() && (E.getEdges().getDegree() === 0 || g === Vn.INTERSECTION)) {
          var B = E.getLabel();
          Vn.isResultOfOp(B, g) && this.filterCoveredNodeToPoint(E);
        }
      }
    }, fh.prototype.build = function(g) {
      return this.extractNonCoveredResultNodes(g), this._resultPointList;
    }, fh.prototype.interfaces_ = function() {
      return [];
    }, fh.prototype.getClass = function() {
      return fh;
    };
    var ya = function() {
      this._inputGeom = null, this._factory = null, this._pruneEmptyGeometry = !0, this._preserveGeometryCollectionType = !0, this._preserveCollections = !1, this._preserveType = !1;
    };
    ya.prototype.transformPoint = function(g, p) {
      return this._factory.createPoint(this.transformCoordinates(g.getCoordinateSequence(), g));
    }, ya.prototype.transformPolygon = function(g, p) {
      var E = !0, B = this.transformLinearRing(g.getExteriorRing(), g);
      B !== null && B instanceof vr && !B.isEmpty() || (E = !1);
      for (var D = new We(), j = 0; j < g.getNumInteriorRing(); j++) {
        var te = this.transformLinearRing(g.getInteriorRingN(j), g);
        te === null || te.isEmpty() || (te instanceof vr || (E = !1), D.add(te));
      }
      if (E)
        return this._factory.createPolygon(B, D.toArray([]));
      var he = new We();
      return B !== null && he.add(B), he.addAll(D), this._factory.buildGeometry(he);
    }, ya.prototype.createCoordinateSequence = function(g) {
      return this._factory.getCoordinateSequenceFactory().create(g);
    }, ya.prototype.getInputGeometry = function() {
      return this._inputGeom;
    }, ya.prototype.transformMultiLineString = function(g, p) {
      for (var E = new We(), B = 0; B < g.getNumGeometries(); B++) {
        var D = this.transformLineString(g.getGeometryN(B), g);
        D !== null && (D.isEmpty() || E.add(D));
      }
      return this._factory.buildGeometry(E);
    }, ya.prototype.transformCoordinates = function(g, p) {
      return this.copy(g);
    }, ya.prototype.transformLineString = function(g, p) {
      return this._factory.createLineString(this.transformCoordinates(g.getCoordinateSequence(), g));
    }, ya.prototype.transformMultiPoint = function(g, p) {
      for (var E = new We(), B = 0; B < g.getNumGeometries(); B++) {
        var D = this.transformPoint(g.getGeometryN(B), g);
        D !== null && (D.isEmpty() || E.add(D));
      }
      return this._factory.buildGeometry(E);
    }, ya.prototype.transformMultiPolygon = function(g, p) {
      for (var E = new We(), B = 0; B < g.getNumGeometries(); B++) {
        var D = this.transformPolygon(g.getGeometryN(B), g);
        D !== null && (D.isEmpty() || E.add(D));
      }
      return this._factory.buildGeometry(E);
    }, ya.prototype.copy = function(g) {
      return g.copy();
    }, ya.prototype.transformGeometryCollection = function(g, p) {
      for (var E = new We(), B = 0; B < g.getNumGeometries(); B++) {
        var D = this.transform(g.getGeometryN(B));
        D !== null && (this._pruneEmptyGeometry && D.isEmpty() || E.add(D));
      }
      return this._preserveGeometryCollectionType ? this._factory.createGeometryCollection(or.toGeometryArray(E)) : this._factory.buildGeometry(E);
    }, ya.prototype.transform = function(g) {
      if (this._inputGeom = g, this._factory = g.getFactory(), g instanceof pr)
        return this.transformPoint(g, null);
      if (g instanceof kn)
        return this.transformMultiPoint(g, null);
      if (g instanceof vr)
        return this.transformLinearRing(g, null);
      if (g instanceof rn)
        return this.transformLineString(g, null);
      if (g instanceof tt)
        return this.transformMultiLineString(g, null);
      if (g instanceof Sn)
        return this.transformPolygon(g, null);
      if (g instanceof Tr)
        return this.transformMultiPolygon(g, null);
      if (g instanceof ze)
        return this.transformGeometryCollection(g, null);
      throw new b("Unknown Geometry subtype: " + g.getClass().getName());
    }, ya.prototype.transformLinearRing = function(g, p) {
      var E = this.transformCoordinates(g.getCoordinateSequence(), g);
      if (E === null)
        return this._factory.createLinearRing(null);
      var B = E.size();
      return B > 0 && B < 4 && !this._preserveType ? this._factory.createLineString(E) : this._factory.createLinearRing(E);
    }, ya.prototype.interfaces_ = function() {
      return [];
    }, ya.prototype.getClass = function() {
      return ya;
    };
    var tA = function g() {
      if (this._snapTolerance = 0, this._srcPts = null, this._seg = new Dn(), this._allowSnappingToSourceVertices = !1, this._isClosed = !1, arguments[0] instanceof rn && typeof arguments[1] == "number") {
        var p = arguments[0], E = arguments[1];
        g.call(this, p.getCoordinates(), E);
      } else if (arguments[0] instanceof Array && typeof arguments[1] == "number") {
        var B = arguments[0], D = arguments[1];
        this._srcPts = B, this._isClosed = g.isClosed(B), this._snapTolerance = D;
      }
    };
    tA.prototype.snapVertices = function(g, p) {
      for (var E = this._isClosed ? g.size() - 1 : g.size(), B = 0; B < E; B++) {
        var D = g.get(B), j = this.findSnapForVertex(D, p);
        j !== null && (g.set(B, new L(j)), B === 0 && this._isClosed && g.set(g.size() - 1, new L(j)));
      }
    }, tA.prototype.findSnapForVertex = function(g, p) {
      for (var E = 0; E < p.length; E++) {
        if (g.equals2D(p[E]))
          return null;
        if (g.distance(p[E]) < this._snapTolerance)
          return p[E];
      }
      return null;
    }, tA.prototype.snapTo = function(g) {
      var p = new qn(this._srcPts);
      return this.snapVertices(p, g), this.snapSegments(p, g), p.toCoordinateArray();
    }, tA.prototype.snapSegments = function(g, p) {
      if (p.length === 0)
        return null;
      var E = p.length;
      p[0].equals2D(p[p.length - 1]) && (E = p.length - 1);
      for (var B = 0; B < E; B++) {
        var D = p[B], j = this.findSegmentIndexToSnap(D, g);
        j >= 0 && g.add(j + 1, new L(D), !1);
      }
    }, tA.prototype.findSegmentIndexToSnap = function(g, p) {
      for (var E = Q.MAX_VALUE, B = -1, D = 0; D < p.size() - 1; D++) {
        if (this._seg.p0 = p.get(D), this._seg.p1 = p.get(D + 1), this._seg.p0.equals2D(g) || this._seg.p1.equals2D(g)) {
          if (this._allowSnappingToSourceVertices)
            continue;
          return -1;
        }
        var j = this._seg.distance(g);
        j < this._snapTolerance && j < E && (E = j, B = D);
      }
      return B;
    }, tA.prototype.setAllowSnappingToSourceVertices = function(g) {
      this._allowSnappingToSourceVertices = g;
    }, tA.prototype.interfaces_ = function() {
      return [];
    }, tA.prototype.getClass = function() {
      return tA;
    }, tA.isClosed = function(g) {
      return !(g.length <= 1) && g[0].equals2D(g[g.length - 1]);
    };
    var ho = function(g) {
      this._srcGeom = g || null;
    }, iy = { SNAP_PRECISION_FACTOR: { configurable: !0 } };
    ho.prototype.snapTo = function(g, p) {
      var E = this.extractTargetCoordinates(g);
      return new nf(p, E).transform(this._srcGeom);
    }, ho.prototype.snapToSelf = function(g, p) {
      var E = this.extractTargetCoordinates(this._srcGeom), B = new nf(g, E, !0).transform(this._srcGeom), D = B;
      return p && K(D, Vt) && (D = B.buffer(0)), D;
    }, ho.prototype.computeSnapTolerance = function(g) {
      return this.computeMinimumSegmentLength(g) / 10;
    }, ho.prototype.extractTargetCoordinates = function(g) {
      for (var p = new I(), E = g.getCoordinates(), B = 0; B < E.length; B++)
        p.add(E[B]);
      return p.toArray(new Array(0).fill(null));
    }, ho.prototype.computeMinimumSegmentLength = function(g) {
      for (var p = Q.MAX_VALUE, E = 0; E < g.length - 1; E++) {
        var B = g[E].distance(g[E + 1]);
        B < p && (p = B);
      }
      return p;
    }, ho.prototype.interfaces_ = function() {
      return [];
    }, ho.prototype.getClass = function() {
      return ho;
    }, ho.snap = function(g, p, E) {
      var B = new Array(2).fill(null), D = new ho(g);
      B[0] = D.snapTo(p, E);
      var j = new ho(p);
      return B[1] = j.snapTo(B[0], E), B;
    }, ho.computeOverlaySnapTolerance = function() {
      if (arguments.length === 1) {
        var g = arguments[0], p = ho.computeSizeBasedSnapTolerance(g), E = g.getPrecisionModel();
        if (E.getType() === Wn.FIXED) {
          var B = 1 / E.getScale() * 2 / 1.415;
          B > p && (p = B);
        }
        return p;
      }
      if (arguments.length === 2) {
        var D = arguments[0], j = arguments[1];
        return Math.min(ho.computeOverlaySnapTolerance(D), ho.computeOverlaySnapTolerance(j));
      }
    }, ho.computeSizeBasedSnapTolerance = function(g) {
      var p = g.getEnvelopeInternal();
      return Math.min(p.getHeight(), p.getWidth()) * ho.SNAP_PRECISION_FACTOR;
    }, ho.snapToSelf = function(g, p, E) {
      return new ho(g).snapToSelf(p, E);
    }, iy.SNAP_PRECISION_FACTOR.get = function() {
      return 1e-9;
    }, Object.defineProperties(ho, iy);
    var nf = function(g) {
      function p(E, B, D) {
        g.call(this), this._snapTolerance = E || null, this._snapPts = B || null, this._isSelfSnap = D !== void 0 && D;
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.snapLine = function(E, B) {
        var D = new tA(E, this._snapTolerance);
        return D.setAllowSnappingToSourceVertices(this._isSelfSnap), D.snapTo(B);
      }, p.prototype.transformCoordinates = function(E, B) {
        var D = E.toCoordinateArray(), j = this.snapLine(D, this._snapPts);
        return this._factory.getCoordinateSequenceFactory().create(j);
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(ya), qs = function() {
      this._isFirst = !0, this._commonMantissaBitsCount = 53, this._commonBits = 0, this._commonSignExp = null;
    };
    qs.prototype.getCommon = function() {
      return Q.longBitsToDouble(this._commonBits);
    }, qs.prototype.add = function(g) {
      var p = Q.doubleToLongBits(g);
      if (this._isFirst)
        return this._commonBits = p, this._commonSignExp = qs.signExpBits(this._commonBits), this._isFirst = !1, null;
      if (qs.signExpBits(p) !== this._commonSignExp)
        return this._commonBits = 0, null;
      this._commonMantissaBitsCount = qs.numCommonMostSigMantissaBits(this._commonBits, p), this._commonBits = qs.zeroLowerBits(this._commonBits, 64 - (12 + this._commonMantissaBitsCount));
    }, qs.prototype.toString = function() {
      if (arguments.length === 1) {
        var g = arguments[0], p = Q.longBitsToDouble(g), E = "0000000000000000000000000000000000000000000000000000000000000000" + Q.toBinaryString(g), B = E.substring(E.length - 64);
        return B.substring(0, 1) + "  " + B.substring(1, 12) + "(exp) " + B.substring(12) + " [ " + p + " ]";
      }
    }, qs.prototype.interfaces_ = function() {
      return [];
    }, qs.prototype.getClass = function() {
      return qs;
    }, qs.getBit = function(g, p) {
      return g & 1 << p ? 1 : 0;
    }, qs.signExpBits = function(g) {
      return g >> 52;
    }, qs.zeroLowerBits = function(g, p) {
      return g & ~((1 << p) - 1);
    }, qs.numCommonMostSigMantissaBits = function(g, p) {
      for (var E = 0, B = 52; B >= 0; B--) {
        if (qs.getBit(g, B) !== qs.getBit(p, B))
          return E;
        E++;
      }
      return 52;
    };
    var Gi = function() {
      this._commonCoord = null, this._ccFilter = new gh();
    }, oy = { CommonCoordinateFilter: { configurable: !0 }, Translater: { configurable: !0 } };
    Gi.prototype.addCommonBits = function(g) {
      var p = new rf(this._commonCoord);
      g.apply(p), g.geometryChanged();
    }, Gi.prototype.removeCommonBits = function(g) {
      if (this._commonCoord.x === 0 && this._commonCoord.y === 0)
        return g;
      var p = new L(this._commonCoord);
      p.x = -p.x, p.y = -p.y;
      var E = new rf(p);
      return g.apply(E), g.geometryChanged(), g;
    }, Gi.prototype.getCommonCoordinate = function() {
      return this._commonCoord;
    }, Gi.prototype.add = function(g) {
      g.apply(this._ccFilter), this._commonCoord = this._ccFilter.getCommonCoordinate();
    }, Gi.prototype.interfaces_ = function() {
      return [];
    }, Gi.prototype.getClass = function() {
      return Gi;
    }, oy.CommonCoordinateFilter.get = function() {
      return gh;
    }, oy.Translater.get = function() {
      return rf;
    }, Object.defineProperties(Gi, oy);
    var gh = function() {
      this._commonBitsX = new qs(), this._commonBitsY = new qs();
    };
    gh.prototype.filter = function(g) {
      this._commonBitsX.add(g.x), this._commonBitsY.add(g.y);
    }, gh.prototype.getCommonCoordinate = function() {
      return new L(this._commonBitsX.getCommon(), this._commonBitsY.getCommon());
    }, gh.prototype.interfaces_ = function() {
      return [_t];
    }, gh.prototype.getClass = function() {
      return gh;
    };
    var rf = function() {
      this.trans = null;
      var g = arguments[0];
      this.trans = g;
    };
    rf.prototype.filter = function(g, p) {
      var E = g.getOrdinate(p, 0) + this.trans.x, B = g.getOrdinate(p, 1) + this.trans.y;
      g.setOrdinate(p, 0, E), g.setOrdinate(p, 1, B);
    }, rf.prototype.isDone = function() {
      return !1;
    }, rf.prototype.isGeometryChanged = function() {
      return !0;
    }, rf.prototype.interfaces_ = function() {
      return [He];
    }, rf.prototype.getClass = function() {
      return rf;
    };
    var Xi = function(g, p) {
      this._geom = new Array(2).fill(null), this._snapTolerance = null, this._cbr = null, this._geom[0] = g, this._geom[1] = p, this.computeSnapTolerance();
    };
    Xi.prototype.selfSnap = function(g) {
      return new ho(g).snapTo(g, this._snapTolerance);
    }, Xi.prototype.removeCommonBits = function(g) {
      this._cbr = new Gi(), this._cbr.add(g[0]), this._cbr.add(g[1]);
      var p = new Array(2).fill(null);
      return p[0] = this._cbr.removeCommonBits(g[0].copy()), p[1] = this._cbr.removeCommonBits(g[1].copy()), p;
    }, Xi.prototype.prepareResult = function(g) {
      return this._cbr.addCommonBits(g), g;
    }, Xi.prototype.getResultGeometry = function(g) {
      var p = this.snap(this._geom), E = Vn.overlayOp(p[0], p[1], g);
      return this.prepareResult(E);
    }, Xi.prototype.checkValid = function(g) {
      g.isValid() || De.out.println("Snapped geometry is invalid");
    }, Xi.prototype.computeSnapTolerance = function() {
      this._snapTolerance = ho.computeOverlaySnapTolerance(this._geom[0], this._geom[1]);
    }, Xi.prototype.snap = function(g) {
      var p = this.removeCommonBits(g);
      return ho.snap(p[0], p[1], this._snapTolerance);
    }, Xi.prototype.interfaces_ = function() {
      return [];
    }, Xi.prototype.getClass = function() {
      return Xi;
    }, Xi.overlayOp = function(g, p, E) {
      return new Xi(g, p).getResultGeometry(E);
    }, Xi.union = function(g, p) {
      return Xi.overlayOp(g, p, Vn.UNION);
    }, Xi.intersection = function(g, p) {
      return Xi.overlayOp(g, p, Vn.INTERSECTION);
    }, Xi.symDifference = function(g, p) {
      return Xi.overlayOp(g, p, Vn.SYMDIFFERENCE);
    }, Xi.difference = function(g, p) {
      return Xi.overlayOp(g, p, Vn.DIFFERENCE);
    };
    var js = function(g, p) {
      this._geom = new Array(2).fill(null), this._geom[0] = g, this._geom[1] = p;
    };
    js.prototype.getResultGeometry = function(g) {
      var p = null, E = !1, B = null;
      try {
        p = Vn.overlayOp(this._geom[0], this._geom[1], g), E = !0;
      } catch (D) {
        if (!(D instanceof Ee))
          throw D;
        B = D;
      }
      if (!E)
        try {
          p = Xi.overlayOp(this._geom[0], this._geom[1], g);
        } catch (D) {
          throw D instanceof Ee ? B : D;
        }
      return p;
    }, js.prototype.interfaces_ = function() {
      return [];
    }, js.prototype.getClass = function() {
      return js;
    }, js.overlayOp = function(g, p, E) {
      return new js(g, p).getResultGeometry(E);
    }, js.union = function(g, p) {
      return js.overlayOp(g, p, Vn.UNION);
    }, js.intersection = function(g, p) {
      return js.overlayOp(g, p, Vn.INTERSECTION);
    }, js.symDifference = function(g, p) {
      return js.overlayOp(g, p, Vn.SYMDIFFERENCE);
    }, js.difference = function(g, p) {
      return js.overlayOp(g, p, Vn.DIFFERENCE);
    };
    var jd = function() {
      this.mce = null, this.chainIndex = null;
      var g = arguments[0], p = arguments[1];
      this.mce = g, this.chainIndex = p;
    };
    jd.prototype.computeIntersections = function(g, p) {
      this.mce.computeIntersectsForChain(this.chainIndex, g.mce, g.chainIndex, p);
    }, jd.prototype.interfaces_ = function() {
      return [];
    }, jd.prototype.getClass = function() {
      return jd;
    };
    var va = function g() {
      if (this._label = null, this._xValue = null, this._eventType = null, this._insertEvent = null, this._deleteEventIndex = null, this._obj = null, arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        this._eventType = g.DELETE, this._xValue = p, this._insertEvent = E;
      } else if (arguments.length === 3) {
        var B = arguments[0], D = arguments[1], j = arguments[2];
        this._eventType = g.INSERT, this._label = B, this._xValue = D, this._obj = j;
      }
    }, sy = { INSERT: { configurable: !0 }, DELETE: { configurable: !0 } };
    va.prototype.isDelete = function() {
      return this._eventType === va.DELETE;
    }, va.prototype.setDeleteEventIndex = function(g) {
      this._deleteEventIndex = g;
    }, va.prototype.getObject = function() {
      return this._obj;
    }, va.prototype.compareTo = function(g) {
      var p = g;
      return this._xValue < p._xValue ? -1 : this._xValue > p._xValue ? 1 : this._eventType < p._eventType ? -1 : this._eventType > p._eventType ? 1 : 0;
    }, va.prototype.getInsertEvent = function() {
      return this._insertEvent;
    }, va.prototype.isInsert = function() {
      return this._eventType === va.INSERT;
    }, va.prototype.isSameLabel = function(g) {
      return this._label !== null && this._label === g._label;
    }, va.prototype.getDeleteEventIndex = function() {
      return this._deleteEventIndex;
    }, va.prototype.interfaces_ = function() {
      return [R];
    }, va.prototype.getClass = function() {
      return va;
    }, sy.INSERT.get = function() {
      return 1;
    }, sy.DELETE.get = function() {
      return 2;
    }, Object.defineProperties(va, sy);
    var Cm = function() {
    };
    Cm.prototype.interfaces_ = function() {
      return [];
    }, Cm.prototype.getClass = function() {
      return Cm;
    };
    var po = function() {
      this._hasIntersection = !1, this._hasProper = !1, this._hasProperInterior = !1, this._properIntersectionPoint = null, this._li = null, this._includeProper = null, this._recordIsolated = null, this._isSelfIntersection = null, this._numIntersections = 0, this.numTests = 0, this._bdyNodes = null, this._isDone = !1, this._isDoneWhenProperInt = !1;
      var g = arguments[0], p = arguments[1], E = arguments[2];
      this._li = g, this._includeProper = p, this._recordIsolated = E;
    };
    po.prototype.isTrivialIntersection = function(g, p, E, B) {
      if (g === E && this._li.getIntersectionNum() === 1) {
        if (po.isAdjacentSegments(p, B))
          return !0;
        if (g.isClosed()) {
          var D = g.getNumPoints() - 1;
          if (p === 0 && B === D || B === 0 && p === D)
            return !0;
        }
      }
      return !1;
    }, po.prototype.getProperIntersectionPoint = function() {
      return this._properIntersectionPoint;
    }, po.prototype.setIsDoneIfProperInt = function(g) {
      this._isDoneWhenProperInt = g;
    }, po.prototype.hasProperInteriorIntersection = function() {
      return this._hasProperInterior;
    }, po.prototype.isBoundaryPointInternal = function(g, p) {
      for (var E = p.iterator(); E.hasNext(); ) {
        var B = E.next().getCoordinate();
        if (g.isIntersection(B))
          return !0;
      }
      return !1;
    }, po.prototype.hasProperIntersection = function() {
      return this._hasProper;
    }, po.prototype.hasIntersection = function() {
      return this._hasIntersection;
    }, po.prototype.isDone = function() {
      return this._isDone;
    }, po.prototype.isBoundaryPoint = function(g, p) {
      return p !== null && (!!this.isBoundaryPointInternal(g, p[0]) || !!this.isBoundaryPointInternal(g, p[1]));
    }, po.prototype.setBoundaryNodes = function(g, p) {
      this._bdyNodes = new Array(2).fill(null), this._bdyNodes[0] = g, this._bdyNodes[1] = p;
    }, po.prototype.addIntersections = function(g, p, E, B) {
      if (g === E && p === B)
        return null;
      this.numTests++;
      var D = g.getCoordinates()[p], j = g.getCoordinates()[p + 1], te = E.getCoordinates()[B], he = E.getCoordinates()[B + 1];
      this._li.computeIntersection(D, j, te, he), this._li.hasIntersection() && (this._recordIsolated && (g.setIsolated(!1), E.setIsolated(!1)), this._numIntersections++, this.isTrivialIntersection(g, p, E, B) || (this._hasIntersection = !0, !this._includeProper && this._li.isProper() || (g.addIntersections(this._li, p, 0), E.addIntersections(this._li, B, 1)), this._li.isProper() && (this._properIntersectionPoint = this._li.getIntersection(0).copy(), this._hasProper = !0, this._isDoneWhenProperInt && (this._isDone = !0), this.isBoundaryPoint(this._li, this._bdyNodes) || (this._hasProperInterior = !0))));
    }, po.prototype.interfaces_ = function() {
      return [];
    }, po.prototype.getClass = function() {
      return po;
    }, po.isAdjacentSegments = function(g, p) {
      return Math.abs(g - p) === 1;
    };
    var Fx = function(g) {
      function p() {
        g.call(this), this.events = new We(), this.nOverlaps = null;
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.prepareEvents = function() {
        EA.sort(this.events);
        for (var E = 0; E < this.events.size(); E++) {
          var B = this.events.get(E);
          B.isDelete() && B.getInsertEvent().setDeleteEventIndex(E);
        }
      }, p.prototype.computeIntersections = function() {
        if (arguments.length === 1) {
          var E = arguments[0];
          this.nOverlaps = 0, this.prepareEvents();
          for (var B = 0; B < this.events.size(); B++) {
            var D = this.events.get(B);
            if (D.isInsert() && this.processOverlaps(B, D.getDeleteEventIndex(), D, E), E.isDone())
              break;
          }
        } else if (arguments.length === 3) {
          if (arguments[2] instanceof po && K(arguments[0], hn) && K(arguments[1], hn)) {
            var j = arguments[0], te = arguments[1], he = arguments[2];
            this.addEdges(j, j), this.addEdges(te, te), this.computeIntersections(he);
          } else if (typeof arguments[2] == "boolean" && K(arguments[0], hn) && arguments[1] instanceof po) {
            var ve = arguments[0], Le = arguments[1];
            arguments[2] ? this.addEdges(ve, null) : this.addEdges(ve), this.computeIntersections(Le);
          }
        }
      }, p.prototype.addEdge = function(E, B) {
        for (var D = E.getMonotoneChainEdge(), j = D.getStartIndexes(), te = 0; te < j.length - 1; te++) {
          var he = new jd(D, te), ve = new va(B, D.getMinX(te), he);
          this.events.add(ve), this.events.add(new va(D.getMaxX(te), ve));
        }
      }, p.prototype.processOverlaps = function(E, B, D, j) {
        for (var te = D.getObject(), he = E; he < B; he++) {
          var ve = this.events.get(he);
          if (ve.isInsert()) {
            var Le = ve.getObject();
            D.isSameLabel(ve) || (te.computeIntersections(Le, j), this.nOverlaps++);
          }
        }
      }, p.prototype.addEdges = function() {
        if (arguments.length === 1)
          for (var E = arguments[0].iterator(); E.hasNext(); ) {
            var B = E.next();
            this.addEdge(B, B);
          }
        else if (arguments.length === 2)
          for (var D = arguments[0], j = arguments[1], te = D.iterator(); te.hasNext(); ) {
            var he = te.next();
            this.addEdge(he, j);
          }
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(Cm), Bc = function() {
      this._min = Q.POSITIVE_INFINITY, this._max = Q.NEGATIVE_INFINITY;
    }, T0 = { NodeComparator: { configurable: !0 } };
    Bc.prototype.getMin = function() {
      return this._min;
    }, Bc.prototype.intersects = function(g, p) {
      return !(this._min > p || this._max < g);
    }, Bc.prototype.getMax = function() {
      return this._max;
    }, Bc.prototype.toString = function() {
      return Re.toLineString(new L(this._min, 0), new L(this._max, 0));
    }, Bc.prototype.interfaces_ = function() {
      return [];
    }, Bc.prototype.getClass = function() {
      return Bc;
    }, T0.NodeComparator.get = function() {
      return BA;
    }, Object.defineProperties(Bc, T0);
    var BA = function() {
    };
    BA.prototype.compare = function(g, p) {
      var E = g, B = p, D = (E._min + E._max) / 2, j = (B._min + B._max) / 2;
      return D < j ? -1 : D > j ? 1 : 0;
    }, BA.prototype.interfaces_ = function() {
      return [O];
    }, BA.prototype.getClass = function() {
      return BA;
    };
    var Or = function(g) {
      function p() {
        g.call(this), this._item = null;
        var E = arguments[0], B = arguments[1], D = arguments[2];
        this._min = E, this._max = B, this._item = D;
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.query = function(E, B, D) {
        if (!this.intersects(E, B))
          return null;
        D.visitItem(this._item);
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(Bc), bA = function(g) {
      function p() {
        g.call(this), this._node1 = null, this._node2 = null;
        var E = arguments[0], B = arguments[1];
        this._node1 = E, this._node2 = B, this.buildExtent(this._node1, this._node2);
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.buildExtent = function(E, B) {
        this._min = Math.min(E._min, B._min), this._max = Math.max(E._max, B._max);
      }, p.prototype.query = function(E, B, D) {
        if (!this.intersects(E, B))
          return null;
        this._node1 !== null && this._node1.query(E, B, D), this._node2 !== null && this._node2.query(E, B, D);
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(Bc), bc = function() {
      this._leaves = new We(), this._root = null, this._level = 0;
    };
    bc.prototype.buildTree = function() {
      EA.sort(this._leaves, new Bc.NodeComparator());
      for (var g = this._leaves, p = null, E = new We(); ; ) {
        if (this.buildLevel(g, E), E.size() === 1)
          return E.get(0);
        p = g, g = E, E = p;
      }
    }, bc.prototype.insert = function(g, p, E) {
      if (this._root !== null)
        throw new Error("Index cannot be added to once it has been queried");
      this._leaves.add(new Or(g, p, E));
    }, bc.prototype.query = function(g, p, E) {
      this.init(), this._root.query(g, p, E);
    }, bc.prototype.buildRoot = function() {
      if (this._root !== null)
        return null;
      this._root = this.buildTree();
    }, bc.prototype.printNode = function(g) {
      De.out.println(Re.toLineString(new L(g._min, this._level), new L(g._max, this._level)));
    }, bc.prototype.init = function() {
      if (this._root !== null)
        return null;
      this.buildRoot();
    }, bc.prototype.buildLevel = function(g, p) {
      this._level++, p.clear();
      for (var E = 0; E < g.size(); E += 2) {
        var B = g.get(E);
        if ((E + 1 < g.size() ? g.get(E) : null) === null)
          p.add(B);
        else {
          var D = new bA(g.get(E), g.get(E + 1));
          p.add(D);
        }
      }
    }, bc.prototype.interfaces_ = function() {
      return [];
    }, bc.prototype.getClass = function() {
      return bc;
    };
    var Au = function() {
      this._items = new We();
    };
    Au.prototype.visitItem = function(g) {
      this._items.add(g);
    }, Au.prototype.getItems = function() {
      return this._items;
    }, Au.prototype.interfaces_ = function() {
      return [_r];
    }, Au.prototype.getClass = function() {
      return Au;
    };
    var hh = function() {
      this._index = null;
      var g = arguments[0];
      if (!K(g, Vt))
        throw new b("Argument must be Polygonal");
      this._index = new Yt(g);
    }, ay = { SegmentVisitor: { configurable: !0 }, IntervalIndexedGeometry: { configurable: !0 } };
    hh.prototype.locate = function(g) {
      var p = new qe(g), E = new ka(p);
      return this._index.query(g.y, g.y, E), p.getLocation();
    }, hh.prototype.interfaces_ = function() {
      return [oh];
    }, hh.prototype.getClass = function() {
      return hh;
    }, ay.SegmentVisitor.get = function() {
      return ka;
    }, ay.IntervalIndexedGeometry.get = function() {
      return Yt;
    }, Object.defineProperties(hh, ay);
    var ka = function() {
      this._counter = null;
      var g = arguments[0];
      this._counter = g;
    };
    ka.prototype.visitItem = function(g) {
      var p = g;
      this._counter.countSegment(p.getCoordinate(0), p.getCoordinate(1));
    }, ka.prototype.interfaces_ = function() {
      return [_r];
    }, ka.prototype.getClass = function() {
      return ka;
    };
    var Yt = function() {
      this._index = new bc();
      var g = arguments[0];
      this.init(g);
    };
    Yt.prototype.init = function(g) {
      for (var p = vs.getLines(g).iterator(); p.hasNext(); ) {
        var E = p.next().getCoordinates();
        this.addLine(E);
      }
    }, Yt.prototype.addLine = function(g) {
      for (var p = 1; p < g.length; p++) {
        var E = new Dn(g[p - 1], g[p]), B = Math.min(E.p0.y, E.p1.y), D = Math.max(E.p0.y, E.p1.y);
        this._index.insert(B, D, E);
      }
    }, Yt.prototype.query = function() {
      if (arguments.length === 2) {
        var g = arguments[0], p = arguments[1], E = new Au();
        return this._index.query(g, p, E), E.getItems();
      }
      if (arguments.length === 3) {
        var B = arguments[0], D = arguments[1], j = arguments[2];
        this._index.query(B, D, j);
      }
    }, Yt.prototype.interfaces_ = function() {
      return [];
    }, Yt.prototype.getClass = function() {
      return Yt;
    };
    var gn = function(g) {
      function p() {
        if (g.call(this), this._parentGeom = null, this._lineEdgeMap = new Ps(), this._boundaryNodeRule = null, this._useBoundaryDeterminationRule = !0, this._argIndex = null, this._boundaryNodes = null, this._hasTooFewPoints = !1, this._invalidPoint = null, this._areaPtLocator = null, this._ptLocator = new KA(), arguments.length === 2) {
          var E = arguments[0], B = arguments[1], D = Ct.OGC_SFS_BOUNDARY_RULE;
          this._argIndex = E, this._parentGeom = B, this._boundaryNodeRule = D, B !== null && this.add(B);
        } else if (arguments.length === 3) {
          var j = arguments[0], te = arguments[1], he = arguments[2];
          this._argIndex = j, this._parentGeom = te, this._boundaryNodeRule = he, te !== null && this.add(te);
        }
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.insertBoundaryPoint = function(E, B) {
        var D = this._nodes.addNode(B).getLabel(), j = 1;
        U.NONE, D.getLocation(E, Ve.ON) === U.BOUNDARY && j++;
        var te = p.determineBoundary(this._boundaryNodeRule, j);
        D.setLocation(E, te);
      }, p.prototype.computeSelfNodes = function() {
        if (arguments.length === 2) {
          var E = arguments[0], B = arguments[1];
          return this.computeSelfNodes(E, B, !1);
        }
        if (arguments.length === 3) {
          var D = arguments[0], j = arguments[1], te = arguments[2], he = new po(D, !0, !1);
          he.setIsDoneIfProperInt(te);
          var ve = this.createEdgeSetIntersector(), Le = this._parentGeom instanceof vr || this._parentGeom instanceof Sn || this._parentGeom instanceof Tr, Je = j || !Le;
          return ve.computeIntersections(this._edges, he, Je), this.addSelfIntersectionNodes(this._argIndex), he;
        }
      }, p.prototype.computeSplitEdges = function(E) {
        for (var B = this._edges.iterator(); B.hasNext(); )
          B.next().eiList.addSplitEdges(E);
      }, p.prototype.computeEdgeIntersections = function(E, B, D) {
        var j = new po(B, D, !0);
        return j.setBoundaryNodes(this.getBoundaryNodes(), E.getBoundaryNodes()), this.createEdgeSetIntersector().computeIntersections(this._edges, E._edges, j), j;
      }, p.prototype.getGeometry = function() {
        return this._parentGeom;
      }, p.prototype.getBoundaryNodeRule = function() {
        return this._boundaryNodeRule;
      }, p.prototype.hasTooFewPoints = function() {
        return this._hasTooFewPoints;
      }, p.prototype.addPoint = function() {
        if (arguments[0] instanceof pr) {
          var E = arguments[0].getCoordinate();
          this.insertPoint(this._argIndex, E, U.INTERIOR);
        } else if (arguments[0] instanceof L) {
          var B = arguments[0];
          this.insertPoint(this._argIndex, B, U.INTERIOR);
        }
      }, p.prototype.addPolygon = function(E) {
        this.addPolygonRing(E.getExteriorRing(), U.EXTERIOR, U.INTERIOR);
        for (var B = 0; B < E.getNumInteriorRing(); B++) {
          var D = E.getInteriorRingN(B);
          this.addPolygonRing(D, U.INTERIOR, U.EXTERIOR);
        }
      }, p.prototype.addEdge = function(E) {
        this.insertEdge(E);
        var B = E.getCoordinates();
        this.insertPoint(this._argIndex, B[0], U.BOUNDARY), this.insertPoint(this._argIndex, B[B.length - 1], U.BOUNDARY);
      }, p.prototype.addLineString = function(E) {
        var B = Pt.removeRepeatedPoints(E.getCoordinates());
        if (B.length < 2)
          return this._hasTooFewPoints = !0, this._invalidPoint = B[0], null;
        var D = new sh(B, new Zn(this._argIndex, U.INTERIOR));
        this._lineEdgeMap.put(E, D), this.insertEdge(D), ie.isTrue(B.length >= 2, "found LineString with single point"), this.insertBoundaryPoint(this._argIndex, B[0]), this.insertBoundaryPoint(this._argIndex, B[B.length - 1]);
      }, p.prototype.getInvalidPoint = function() {
        return this._invalidPoint;
      }, p.prototype.getBoundaryPoints = function() {
        for (var E = this.getBoundaryNodes(), B = new Array(E.size()).fill(null), D = 0, j = E.iterator(); j.hasNext(); ) {
          var te = j.next();
          B[D++] = te.getCoordinate().copy();
        }
        return B;
      }, p.prototype.getBoundaryNodes = function() {
        return this._boundaryNodes === null && (this._boundaryNodes = this._nodes.getBoundaryNodes(this._argIndex)), this._boundaryNodes;
      }, p.prototype.addSelfIntersectionNode = function(E, B, D) {
        if (this.isBoundaryNode(E, B))
          return null;
        D === U.BOUNDARY && this._useBoundaryDeterminationRule ? this.insertBoundaryPoint(E, B) : this.insertPoint(E, B, D);
      }, p.prototype.addPolygonRing = function(E, B, D) {
        if (E.isEmpty())
          return null;
        var j = Pt.removeRepeatedPoints(E.getCoordinates());
        if (j.length < 4)
          return this._hasTooFewPoints = !0, this._invalidPoint = j[0], null;
        var te = B, he = D;
        ke.isCCW(j) && (te = D, he = B);
        var ve = new sh(j, new Zn(this._argIndex, U.BOUNDARY, te, he));
        this._lineEdgeMap.put(E, ve), this.insertEdge(ve), this.insertPoint(this._argIndex, j[0], U.BOUNDARY);
      }, p.prototype.insertPoint = function(E, B, D) {
        var j = this._nodes.addNode(B), te = j.getLabel();
        te === null ? j._label = new Zn(E, D) : te.setLocation(E, D);
      }, p.prototype.createEdgeSetIntersector = function() {
        return new Fx();
      }, p.prototype.addSelfIntersectionNodes = function(E) {
        for (var B = this._edges.iterator(); B.hasNext(); )
          for (var D = B.next(), j = D.getLabel().getLocation(E), te = D.eiList.iterator(); te.hasNext(); ) {
            var he = te.next();
            this.addSelfIntersectionNode(E, he.coord, j);
          }
      }, p.prototype.add = function() {
        if (arguments.length !== 1)
          return g.prototype.add.apply(this, arguments);
        var E = arguments[0];
        if (E.isEmpty())
          return null;
        if (E instanceof Tr && (this._useBoundaryDeterminationRule = !1), E instanceof Sn)
          this.addPolygon(E);
        else if (E instanceof rn)
          this.addLineString(E);
        else if (E instanceof pr)
          this.addPoint(E);
        else if (E instanceof kn)
          this.addCollection(E);
        else if (E instanceof tt)
          this.addCollection(E);
        else if (E instanceof Tr)
          this.addCollection(E);
        else {
          if (!(E instanceof ze))
            throw new Error(E.getClass().getName());
          this.addCollection(E);
        }
      }, p.prototype.addCollection = function(E) {
        for (var B = 0; B < E.getNumGeometries(); B++) {
          var D = E.getGeometryN(B);
          this.add(D);
        }
      }, p.prototype.locate = function(E) {
        return K(this._parentGeom, Vt) && this._parentGeom.getNumGeometries() > 50 ? (this._areaPtLocator === null && (this._areaPtLocator = new hh(this._parentGeom)), this._areaPtLocator.locate(E)) : this._ptLocator.locate(E, this._parentGeom);
      }, p.prototype.findEdge = function() {
        if (arguments.length === 1) {
          var E = arguments[0];
          return this._lineEdgeMap.get(E);
        }
        return g.prototype.findEdge.apply(this, arguments);
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p.determineBoundary = function(E, B) {
        return E.isInBoundary(B) ? U.BOUNDARY : U.INTERIOR;
      }, p;
    }(Li), dh = function() {
      if (this._li = new we(), this._resultPrecisionModel = null, this._arg = null, arguments.length === 1) {
        var g = arguments[0];
        this.setComputationPrecision(g.getPrecisionModel()), this._arg = new Array(1).fill(null), this._arg[0] = new gn(0, g);
      } else if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1], B = Ct.OGC_SFS_BOUNDARY_RULE;
        p.getPrecisionModel().compareTo(E.getPrecisionModel()) >= 0 ? this.setComputationPrecision(p.getPrecisionModel()) : this.setComputationPrecision(E.getPrecisionModel()), this._arg = new Array(2).fill(null), this._arg[0] = new gn(0, p, B), this._arg[1] = new gn(1, E, B);
      } else if (arguments.length === 3) {
        var D = arguments[0], j = arguments[1], te = arguments[2];
        D.getPrecisionModel().compareTo(j.getPrecisionModel()) >= 0 ? this.setComputationPrecision(D.getPrecisionModel()) : this.setComputationPrecision(j.getPrecisionModel()), this._arg = new Array(2).fill(null), this._arg[0] = new gn(0, D, te), this._arg[1] = new gn(1, j, te);
      }
    };
    dh.prototype.getArgGeometry = function(g) {
      return this._arg[g].getGeometry();
    }, dh.prototype.setComputationPrecision = function(g) {
      this._resultPrecisionModel = g, this._li.setPrecisionModel(this._resultPrecisionModel);
    }, dh.prototype.interfaces_ = function() {
      return [];
    }, dh.prototype.getClass = function() {
      return dh;
    };
    var _c = function() {
    };
    _c.prototype.interfaces_ = function() {
      return [];
    }, _c.prototype.getClass = function() {
      return _c;
    }, _c.map = function() {
      if (arguments[0] instanceof it && K(arguments[1], _c.MapOp)) {
        for (var g = arguments[0], p = arguments[1], E = new We(), B = 0; B < g.getNumGeometries(); B++) {
          var D = p.map(g.getGeometryN(B));
          D !== null && E.add(D);
        }
        return g.getFactory().buildGeometry(E);
      }
      if (K(arguments[0], It) && K(arguments[1], _c.MapOp)) {
        for (var j = arguments[0], te = arguments[1], he = new We(), ve = j.iterator(); ve.hasNext(); ) {
          var Le = ve.next(), Je = te.map(Le);
          Je !== null && he.add(Je);
        }
        return he;
      }
    }, _c.MapOp = function() {
    };
    var Vn = function(g) {
      function p() {
        var E = arguments[0], B = arguments[1];
        g.call(this, E, B), this._ptLocator = new KA(), this._geomFact = null, this._resultGeom = null, this._graph = null, this._edgeList = new vA(), this._resultPolyList = new We(), this._resultLineList = new We(), this._resultPointList = new We(), this._graph = new Li(new R0()), this._geomFact = E.getFactory();
      }
      return g && (p.__proto__ = g), p.prototype = Object.create(g && g.prototype), p.prototype.constructor = p, p.prototype.insertUniqueEdge = function(E) {
        var B = this._edgeList.findEqualEdge(E);
        if (B !== null) {
          var D = B.getLabel(), j = E.getLabel();
          B.isPointwiseEqual(E) || (j = new Zn(E.getLabel())).flip();
          var te = B.getDepth();
          te.isNull() && te.add(D), te.add(j), D.merge(j);
        } else
          this._edgeList.add(E);
      }, p.prototype.getGraph = function() {
        return this._graph;
      }, p.prototype.cancelDuplicateResultEdges = function() {
        for (var E = this._graph.getEdgeEnds().iterator(); E.hasNext(); ) {
          var B = E.next(), D = B.getSym();
          B.isInResult() && D.isInResult() && (B.setInResult(!1), D.setInResult(!1));
        }
      }, p.prototype.isCoveredByLA = function(E) {
        return !!this.isCovered(E, this._resultLineList) || !!this.isCovered(E, this._resultPolyList);
      }, p.prototype.computeGeometry = function(E, B, D, j) {
        var te = new We();
        return te.addAll(E), te.addAll(B), te.addAll(D), te.isEmpty() ? p.createEmptyResult(j, this._arg[0].getGeometry(), this._arg[1].getGeometry(), this._geomFact) : this._geomFact.buildGeometry(te);
      }, p.prototype.mergeSymLabels = function() {
        for (var E = this._graph.getNodes().iterator(); E.hasNext(); )
          E.next().getEdges().mergeSymLabels();
      }, p.prototype.isCovered = function(E, B) {
        for (var D = B.iterator(); D.hasNext(); ) {
          var j = D.next();
          if (this._ptLocator.locate(E, j) !== U.EXTERIOR)
            return !0;
        }
        return !1;
      }, p.prototype.replaceCollapsedEdges = function() {
        for (var E = new We(), B = this._edgeList.iterator(); B.hasNext(); ) {
          var D = B.next();
          D.isCollapsed() && (B.remove(), E.add(D.getCollapsedEdge()));
        }
        this._edgeList.addAll(E);
      }, p.prototype.updateNodeLabelling = function() {
        for (var E = this._graph.getNodes().iterator(); E.hasNext(); ) {
          var B = E.next(), D = B.getEdges().getLabel();
          B.getLabel().merge(D);
        }
      }, p.prototype.getResultGeometry = function(E) {
        return this.computeOverlay(E), this._resultGeom;
      }, p.prototype.insertUniqueEdges = function(E) {
        for (var B = E.iterator(); B.hasNext(); ) {
          var D = B.next();
          this.insertUniqueEdge(D);
        }
      }, p.prototype.computeOverlay = function(E) {
        this.copyPoints(0), this.copyPoints(1), this._arg[0].computeSelfNodes(this._li, !1), this._arg[1].computeSelfNodes(this._li, !1), this._arg[0].computeEdgeIntersections(this._arg[1], this._li, !0);
        var B = new We();
        this._arg[0].computeSplitEdges(B), this._arg[1].computeSplitEdges(B), this.insertUniqueEdges(B), this.computeLabelsFromDepths(), this.replaceCollapsedEdges(), tf.checkValid(this._edgeList.getEdges()), this._graph.addEdges(this._edgeList.getEdges()), this.computeLabelling(), this.labelIncompleteNodes(), this.findResultAreaEdges(E), this.cancelDuplicateResultEdges();
        var D = new ks(this._geomFact);
        D.add(this._graph), this._resultPolyList = D.getPolygons();
        var j = new WA(this, this._geomFact, this._ptLocator);
        this._resultLineList = j.build(E);
        var te = new fh(this, this._geomFact, this._ptLocator);
        this._resultPointList = te.build(E), this._resultGeom = this.computeGeometry(this._resultPointList, this._resultLineList, this._resultPolyList, E);
      }, p.prototype.labelIncompleteNode = function(E, B) {
        var D = this._ptLocator.locate(E.getCoordinate(), this._arg[B].getGeometry());
        E.getLabel().setLocation(B, D);
      }, p.prototype.copyPoints = function(E) {
        for (var B = this._arg[E].getNodeIterator(); B.hasNext(); ) {
          var D = B.next();
          this._graph.addNode(D.getCoordinate()).setLabel(E, D.getLabel().getLocation(E));
        }
      }, p.prototype.findResultAreaEdges = function(E) {
        for (var B = this._graph.getEdgeEnds().iterator(); B.hasNext(); ) {
          var D = B.next(), j = D.getLabel();
          j.isArea() && !D.isInteriorAreaEdge() && p.isResultOfOp(j.getLocation(0, Ve.RIGHT), j.getLocation(1, Ve.RIGHT), E) && D.setInResult(!0);
        }
      }, p.prototype.computeLabelsFromDepths = function() {
        for (var E = this._edgeList.iterator(); E.hasNext(); ) {
          var B = E.next(), D = B.getLabel(), j = B.getDepth();
          if (!j.isNull()) {
            j.normalize();
            for (var te = 0; te < 2; te++)
              D.isNull(te) || !D.isArea() || j.isNull(te) || (j.getDelta(te) === 0 ? D.toLine(te) : (ie.isTrue(!j.isNull(te, Ve.LEFT), "depth of LEFT side has not been initialized"), D.setLocation(te, Ve.LEFT, j.getLocation(te, Ve.LEFT)), ie.isTrue(!j.isNull(te, Ve.RIGHT), "depth of RIGHT side has not been initialized"), D.setLocation(te, Ve.RIGHT, j.getLocation(te, Ve.RIGHT))));
          }
        }
      }, p.prototype.computeLabelling = function() {
        for (var E = this._graph.getNodes().iterator(); E.hasNext(); )
          E.next().getEdges().computeLabelling(this._arg);
        this.mergeSymLabels(), this.updateNodeLabelling();
      }, p.prototype.labelIncompleteNodes = function() {
        for (var E = this._graph.getNodes().iterator(); E.hasNext(); ) {
          var B = E.next(), D = B.getLabel();
          B.isIsolated() && (D.isNull(0) ? this.labelIncompleteNode(B, 0) : this.labelIncompleteNode(B, 1)), B.getEdges().updateLabelling(D);
        }
      }, p.prototype.isCoveredByA = function(E) {
        return !!this.isCovered(E, this._resultPolyList);
      }, p.prototype.interfaces_ = function() {
        return [];
      }, p.prototype.getClass = function() {
        return p;
      }, p;
    }(dh);
    Vn.overlayOp = function(g, p, E) {
      return new Vn(g, p).getResultGeometry(E);
    }, Vn.intersection = function(g, p) {
      if (g.isEmpty() || p.isEmpty())
        return Vn.createEmptyResult(Vn.INTERSECTION, g, p, g.getFactory());
      if (g.isGeometryCollection()) {
        var E = p;
        return uh.map(g, { interfaces_: function() {
          return [_c.MapOp];
        }, map: function(B) {
          return B.intersection(E);
        } });
      }
      return g.checkNotGeometryCollection(g), g.checkNotGeometryCollection(p), js.overlayOp(g, p, Vn.INTERSECTION);
    }, Vn.symDifference = function(g, p) {
      if (g.isEmpty() || p.isEmpty()) {
        if (g.isEmpty() && p.isEmpty())
          return Vn.createEmptyResult(Vn.SYMDIFFERENCE, g, p, g.getFactory());
        if (g.isEmpty())
          return p.copy();
        if (p.isEmpty())
          return g.copy();
      }
      return g.checkNotGeometryCollection(g), g.checkNotGeometryCollection(p), js.overlayOp(g, p, Vn.SYMDIFFERENCE);
    }, Vn.resultDimension = function(g, p, E) {
      var B = p.getDimension(), D = E.getDimension(), j = -1;
      switch (g) {
        case Vn.INTERSECTION:
          j = Math.min(B, D);
          break;
        case Vn.UNION:
          j = Math.max(B, D);
          break;
        case Vn.DIFFERENCE:
          j = B;
          break;
        case Vn.SYMDIFFERENCE:
          j = Math.max(B, D);
      }
      return j;
    }, Vn.createEmptyResult = function(g, p, E, B) {
      var D = null;
      switch (Vn.resultDimension(g, p, E)) {
        case -1:
          D = B.createGeometryCollection(new Array(0).fill(null));
          break;
        case 0:
          D = B.createPoint();
          break;
        case 1:
          D = B.createLineString();
          break;
        case 2:
          D = B.createPolygon();
      }
      return D;
    }, Vn.difference = function(g, p) {
      return g.isEmpty() ? Vn.createEmptyResult(Vn.DIFFERENCE, g, p, g.getFactory()) : p.isEmpty() ? g.copy() : (g.checkNotGeometryCollection(g), g.checkNotGeometryCollection(p), js.overlayOp(g, p, Vn.DIFFERENCE));
    }, Vn.isResultOfOp = function() {
      if (arguments.length === 2) {
        var g = arguments[0], p = arguments[1], E = g.getLocation(0), B = g.getLocation(1);
        return Vn.isResultOfOp(E, B, p);
      }
      if (arguments.length === 3) {
        var D = arguments[0], j = arguments[1], te = arguments[2];
        switch (D === U.BOUNDARY && (D = U.INTERIOR), j === U.BOUNDARY && (j = U.INTERIOR), te) {
          case Vn.INTERSECTION:
            return D === U.INTERIOR && j === U.INTERIOR;
          case Vn.UNION:
            return D === U.INTERIOR || j === U.INTERIOR;
          case Vn.DIFFERENCE:
            return D === U.INTERIOR && j !== U.INTERIOR;
          case Vn.SYMDIFFERENCE:
            return D === U.INTERIOR && j !== U.INTERIOR || D !== U.INTERIOR && j === U.INTERIOR;
        }
        return !1;
      }
    }, Vn.INTERSECTION = 1, Vn.UNION = 2, Vn.DIFFERENCE = 3, Vn.SYMDIFFERENCE = 4;
    var Ys = function() {
      this._g = null, this._boundaryDistanceTolerance = null, this._linework = null, this._ptLocator = new KA(), this._seg = new Dn();
      var g = arguments[0], p = arguments[1];
      this._g = g, this._boundaryDistanceTolerance = p, this._linework = this.extractLinework(g);
    };
    Ys.prototype.isWithinToleranceOfBoundary = function(g) {
      for (var p = 0; p < this._linework.getNumGeometries(); p++)
        for (var E = this._linework.getGeometryN(p).getCoordinateSequence(), B = 0; B < E.size() - 1; B++)
          if (E.getCoordinate(B, this._seg.p0), E.getCoordinate(B + 1, this._seg.p1), this._seg.distance(g) <= this._boundaryDistanceTolerance)
            return !0;
      return !1;
    }, Ys.prototype.getLocation = function(g) {
      return this.isWithinToleranceOfBoundary(g) ? U.BOUNDARY : this._ptLocator.locate(g, this._g);
    }, Ys.prototype.extractLinework = function(g) {
      var p = new ph();
      g.apply(p);
      var E = p.getLinework(), B = or.toLineStringArray(E);
      return g.getFactory().createMultiLineString(B);
    }, Ys.prototype.interfaces_ = function() {
      return [];
    }, Ys.prototype.getClass = function() {
      return Ys;
    };
    var ph = function() {
      this._linework = null, this._linework = new We();
    };
    ph.prototype.getLinework = function() {
      return this._linework;
    }, ph.prototype.filter = function(g) {
      if (g instanceof Sn) {
        var p = g;
        this._linework.add(p.getExteriorRing());
        for (var E = 0; E < p.getNumInteriorRing(); E++)
          this._linework.add(p.getInteriorRingN(E));
      }
    }, ph.prototype.interfaces_ = function() {
      return [ye];
    }, ph.prototype.getClass = function() {
      return ph;
    };
    var Ba = function() {
      this._g = null, this._doLeft = !0, this._doRight = !0;
      var g = arguments[0];
      this._g = g;
    };
    Ba.prototype.extractPoints = function(g, p, E) {
      for (var B = g.getCoordinates(), D = 0; D < B.length - 1; D++)
        this.computeOffsetPoints(B[D], B[D + 1], p, E);
    }, Ba.prototype.setSidesToGenerate = function(g, p) {
      this._doLeft = g, this._doRight = p;
    }, Ba.prototype.getPoints = function(g) {
      for (var p = new We(), E = vs.getLines(this._g).iterator(); E.hasNext(); ) {
        var B = E.next();
        this.extractPoints(B, g, p);
      }
      return p;
    }, Ba.prototype.computeOffsetPoints = function(g, p, E, B) {
      var D = p.x - g.x, j = p.y - g.y, te = Math.sqrt(D * D + j * j), he = E * D / te, ve = E * j / te, Le = (p.x + g.x) / 2, Je = (p.y + g.y) / 2;
      if (this._doLeft) {
        var et = new L(Le - ve, Je + he);
        B.add(et);
      }
      if (this._doRight) {
        var Ke = new L(Le + ve, Je - he);
        B.add(Ke);
      }
    }, Ba.prototype.interfaces_ = function() {
      return [];
    }, Ba.prototype.getClass = function() {
      return Ba;
    };
    var S = function g() {
      this._geom = null, this._locFinder = null, this._location = new Array(3).fill(null), this._invalidLocation = null, this._boundaryDistanceTolerance = g.TOLERANCE, this._testCoords = new We();
      var p = arguments[0], E = arguments[1], B = arguments[2];
      this._boundaryDistanceTolerance = g.computeBoundaryDistanceTolerance(p, E), this._geom = [p, E, B], this._locFinder = [new Ys(this._geom[0], this._boundaryDistanceTolerance), new Ys(this._geom[1], this._boundaryDistanceTolerance), new Ys(this._geom[2], this._boundaryDistanceTolerance)];
    }, x = { TOLERANCE: { configurable: !0 } };
    S.prototype.reportResult = function(g, p, E) {
      De.out.println("Overlay result invalid - A:" + U.toLocationSymbol(p[0]) + " B:" + U.toLocationSymbol(p[1]) + " expected:" + (E ? "i" : "e") + " actual:" + U.toLocationSymbol(p[2]));
    }, S.prototype.isValid = function(g) {
      this.addTestPts(this._geom[0]), this.addTestPts(this._geom[1]);
      var p = this.checkValid(g);
      return p;
    }, S.prototype.checkValid = function() {
      if (arguments.length === 1) {
        for (var g = arguments[0], p = 0; p < this._testCoords.size(); p++) {
          var E = this._testCoords.get(p);
          if (!this.checkValid(g, E))
            return this._invalidLocation = E, !1;
        }
        return !0;
      }
      if (arguments.length === 2) {
        var B = arguments[0], D = arguments[1];
        return this._location[0] = this._locFinder[0].getLocation(D), this._location[1] = this._locFinder[1].getLocation(D), this._location[2] = this._locFinder[2].getLocation(D), !!S.hasLocation(this._location, U.BOUNDARY) || this.isValidResult(B, this._location);
      }
    }, S.prototype.addTestPts = function(g) {
      var p = new Ba(g);
      this._testCoords.addAll(p.getPoints(5 * this._boundaryDistanceTolerance));
    }, S.prototype.isValidResult = function(g, p) {
      var E = Vn.isResultOfOp(p[0], p[1], g), B = !(E ^ p[2] === U.INTERIOR);
      return B || this.reportResult(g, p, E), B;
    }, S.prototype.getInvalidLocation = function() {
      return this._invalidLocation;
    }, S.prototype.interfaces_ = function() {
      return [];
    }, S.prototype.getClass = function() {
      return S;
    }, S.hasLocation = function(g, p) {
      for (var E = 0; E < 3; E++)
        if (g[E] === p)
          return !0;
      return !1;
    }, S.computeBoundaryDistanceTolerance = function(g, p) {
      return Math.min(ho.computeSizeBasedSnapTolerance(g), ho.computeSizeBasedSnapTolerance(p));
    }, S.isValid = function(g, p, E, B) {
      return new S(g, p, B).isValid(E);
    }, x.TOLERANCE.get = function() {
      return 1e-6;
    }, Object.defineProperties(S, x);
    var T = function g(p) {
      this._geomFactory = null, this._skipEmpty = !1, this._inputGeoms = null, this._geomFactory = g.extractFactory(p), this._inputGeoms = p;
    };
    T.prototype.extractElements = function(g, p) {
      if (g === null)
        return null;
      for (var E = 0; E < g.getNumGeometries(); E++) {
        var B = g.getGeometryN(E);
        this._skipEmpty && B.isEmpty() || p.add(B);
      }
    }, T.prototype.combine = function() {
      for (var g = new We(), p = this._inputGeoms.iterator(); p.hasNext(); ) {
        var E = p.next();
        this.extractElements(E, g);
      }
      return g.size() === 0 ? this._geomFactory !== null ? this._geomFactory.createGeometryCollection(null) : null : this._geomFactory.buildGeometry(g);
    }, T.prototype.interfaces_ = function() {
      return [];
    }, T.prototype.getClass = function() {
      return T;
    }, T.combine = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return new T(g).combine();
      }
      if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        return new T(T.createList(p, E)).combine();
      }
      if (arguments.length === 3) {
        var B = arguments[0], D = arguments[1], j = arguments[2];
        return new T(T.createList(B, D, j)).combine();
      }
    }, T.extractFactory = function(g) {
      return g.isEmpty() ? null : g.iterator().next().getFactory();
    }, T.createList = function() {
      if (arguments.length === 2) {
        var g = arguments[0], p = arguments[1], E = new We();
        return E.add(g), E.add(p), E;
      }
      if (arguments.length === 3) {
        var B = arguments[0], D = arguments[1], j = arguments[2], te = new We();
        return te.add(B), te.add(D), te.add(j), te;
      }
    };
    var P = function() {
      this._inputPolys = null, this._geomFactory = null;
      var g = arguments[0];
      this._inputPolys = g, this._inputPolys === null && (this._inputPolys = new We());
    }, H = { STRTREE_NODE_CAPACITY: { configurable: !0 } };
    P.prototype.reduceToGeometries = function(g) {
      for (var p = new We(), E = g.iterator(); E.hasNext(); ) {
        var B = E.next(), D = null;
        K(B, hn) ? D = this.unionTree(B) : B instanceof it && (D = B), p.add(D);
      }
      return p;
    }, P.prototype.extractByEnvelope = function(g, p, E) {
      for (var B = new We(), D = 0; D < p.getNumGeometries(); D++) {
        var j = p.getGeometryN(D);
        j.getEnvelopeInternal().intersects(g) ? B.add(j) : E.add(j);
      }
      return this._geomFactory.buildGeometry(B);
    }, P.prototype.unionOptimized = function(g, p) {
      var E = g.getEnvelopeInternal(), B = p.getEnvelopeInternal();
      if (!E.intersects(B))
        return T.combine(g, p);
      if (g.getNumGeometries() <= 1 && p.getNumGeometries() <= 1)
        return this.unionActual(g, p);
      var D = E.intersection(B);
      return this.unionUsingEnvelopeIntersection(g, p, D);
    }, P.prototype.union = function() {
      if (this._inputPolys === null)
        throw new Error("union() method cannot be called twice");
      if (this._inputPolys.isEmpty())
        return null;
      this._geomFactory = this._inputPolys.iterator().next().getFactory();
      for (var g = new S0(P.STRTREE_NODE_CAPACITY), p = this._inputPolys.iterator(); p.hasNext(); ) {
        var E = p.next();
        g.insert(E.getEnvelopeInternal(), E);
      }
      this._inputPolys = null;
      var B = g.itemsTree();
      return this.unionTree(B);
    }, P.prototype.binaryUnion = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return this.binaryUnion(g, 0, g.size());
      }
      if (arguments.length === 3) {
        var p = arguments[0], E = arguments[1], B = arguments[2];
        if (B - E <= 1) {
          var D = P.getGeometry(p, E);
          return this.unionSafe(D, null);
        }
        if (B - E == 2)
          return this.unionSafe(P.getGeometry(p, E), P.getGeometry(p, E + 1));
        var j = Math.trunc((B + E) / 2), te = this.binaryUnion(p, E, j), he = this.binaryUnion(p, j, B);
        return this.unionSafe(te, he);
      }
    }, P.prototype.repeatedUnion = function(g) {
      for (var p = null, E = g.iterator(); E.hasNext(); ) {
        var B = E.next();
        p = p === null ? B.copy() : p.union(B);
      }
      return p;
    }, P.prototype.unionSafe = function(g, p) {
      return g === null && p === null ? null : g === null ? p.copy() : p === null ? g.copy() : this.unionOptimized(g, p);
    }, P.prototype.unionActual = function(g, p) {
      return P.restrictToPolygons(g.union(p));
    }, P.prototype.unionTree = function(g) {
      var p = this.reduceToGeometries(g);
      return this.binaryUnion(p);
    }, P.prototype.unionUsingEnvelopeIntersection = function(g, p, E) {
      var B = new We(), D = this.extractByEnvelope(E, g, B), j = this.extractByEnvelope(E, p, B), te = this.unionActual(D, j);
      return B.add(te), T.combine(B);
    }, P.prototype.bufferUnion = function() {
      if (arguments.length === 1) {
        var g = arguments[0];
        return g.get(0).getFactory().buildGeometry(g).buffer(0);
      }
      if (arguments.length === 2) {
        var p = arguments[0], E = arguments[1];
        return p.getFactory().createGeometryCollection([p, E]).buffer(0);
      }
    }, P.prototype.interfaces_ = function() {
      return [];
    }, P.prototype.getClass = function() {
      return P;
    }, P.restrictToPolygons = function(g) {
      if (K(g, Vt))
        return g;
      var p = au.getPolygons(g);
      return p.size() === 1 ? p.get(0) : g.getFactory().createMultiPolygon(or.toPolygonArray(p));
    }, P.getGeometry = function(g, p) {
      return p >= g.size() ? null : g.get(p);
    }, P.union = function(g) {
      return new P(g).union();
    }, H.STRTREE_NODE_CAPACITY.get = function() {
      return 4;
    }, Object.defineProperties(P, H);
    var J = function() {
    };
    J.prototype.interfaces_ = function() {
      return [];
    }, J.prototype.getClass = function() {
      return J;
    }, J.union = function(g, p) {
      if (g.isEmpty() || p.isEmpty()) {
        if (g.isEmpty() && p.isEmpty())
          return Vn.createEmptyResult(Vn.UNION, g, p, g.getFactory());
        if (g.isEmpty())
          return p.copy();
        if (p.isEmpty())
          return g.copy();
      }
      return g.checkNotGeometryCollection(g), g.checkNotGeometryCollection(p), js.overlayOp(g, p, Vn.UNION);
    }, n.GeoJSONReader = Fe, n.GeoJSONWriter = Ze, n.OverlayOp = Vn, n.UnionOp = J, n.BufferOp = ys, Object.defineProperty(n, "__esModule", { value: !0 });
  });
})(Dte, Dte.exports);
var axn = Dte.exports;
function RE() {
  return new YU();
}
function YU() {
  this.reset();
}
YU.prototype = {
  constructor: YU,
  reset: function() {
    this.s = // rounded value
    this.t = 0;
  },
  add: function(t) {
    kwe(bP, t, this.t), kwe(this, bP.s, this.s), this.s ? this.t += bP.t : this.s = bP.t;
  },
  valueOf: function() {
    return this.s;
  }
};
var bP = new YU();
function kwe(t, e, n) {
  var r = t.s = e + n, i = r - e, o = r - i;
  t.t = e - o + (n - i);
}
var sr = 1e-6, Gwe = 1e-12, Ri = Math.PI, qa = Ri / 2, zU = Ri / 4, Fu = Ri * 2, us = 180 / Ri, wr = Ri / 180, oo = Math.abs, Hw = Math.atan, Kc = Math.atan2, nr = Math.cos, _P = Math.ceil, Qze = Math.exp, VU = Math.log, hJ = Math.pow, $n = Math.sin, ZT = Math.sign || function(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
}, pA = Math.sqrt, Xce = Math.tan;
function wze(t) {
  return t > 1 ? 0 : t < -1 ? Ri : Math.acos(t);
}
function kf(t) {
  return t > 1 ? qa : t < -1 ? -qa : Math.asin(t);
}
function Uwe(t) {
  return (t = $n(t / 2)) * t;
}
function Zs() {
}
function JU(t, e) {
  t && $we.hasOwnProperty(t.type) && $we[t.type](t, e);
}
var Hwe = {
  Feature: function(t, e) {
    JU(t.geometry, e);
  },
  FeatureCollection: function(t, e) {
    for (var n = t.features, r = -1, i = n.length; ++r < i; )
      JU(n[r].geometry, e);
  }
}, $we = {
  Sphere: function(t, e) {
    e.sphere();
  },
  Point: function(t, e) {
    t = t.coordinates, e.point(t[0], t[1], t[2]);
  },
  MultiPoint: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      t = n[r], e.point(t[0], t[1], t[2]);
  },
  LineString: function(t, e) {
    Tte(t.coordinates, e, 0);
  },
  MultiLineString: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      Tte(n[r], e, 0);
  },
  Polygon: function(t, e) {
    qwe(t.coordinates, e);
  },
  MultiPolygon: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      qwe(n[r], e);
  },
  GeometryCollection: function(t, e) {
    for (var n = t.geometries, r = -1, i = n.length; ++r < i; )
      JU(n[r], e);
  }
};
function Tte(t, e, n) {
  var r = -1, i = t.length - n, o;
  for (e.lineStart(); ++r < i; )
    o = t[r], e.point(o[0], o[1], o[2]);
  e.lineEnd();
}
function qwe(t, e) {
  var n = -1, r = t.length;
  for (e.polygonStart(); ++n < r; )
    Tte(t[n], e, 1);
  e.polygonEnd();
}
function Mh(t, e) {
  t && Hwe.hasOwnProperty(t.type) ? Hwe[t.type](t, e) : JU(t, e);
}
var KU = RE(), WU = RE(), xze, Rze, Nte, Lte, Mte, Yp = {
  point: Zs,
  lineStart: Zs,
  lineEnd: Zs,
  polygonStart: function() {
    KU.reset(), Yp.lineStart = Axn, Yp.lineEnd = lxn;
  },
  polygonEnd: function() {
    var t = +KU;
    WU.add(t < 0 ? Fu + t : t), this.lineStart = this.lineEnd = this.point = Zs;
  },
  sphere: function() {
    WU.add(Fu);
  }
};
function Axn() {
  Yp.point = cxn;
}
function lxn() {
  Dze(xze, Rze);
}
function cxn(t, e) {
  Yp.point = Dze, xze = t, Rze = e, t *= wr, e *= wr, Nte = t, Lte = nr(e = e / 2 + zU), Mte = $n(e);
}
function Dze(t, e) {
  t *= wr, e *= wr, e = e / 2 + zU;
  var n = t - Nte, r = n >= 0 ? 1 : -1, i = r * n, o = nr(e), s = $n(e), a = Mte * s, A = Lte * o + a * nr(i), l = a * r * $n(i);
  KU.add(Kc(l, A)), Nte = t, Lte = o, Mte = s;
}
function uxn(t) {
  return WU.reset(), Mh(t, Yp), WU * 2;
}
function XU(t) {
  return [Kc(t[1], t[0]), kf(t[2])];
}
function sB(t) {
  var e = t[0], n = t[1], r = nr(n);
  return [r * nr(e), r * $n(e), $n(n)];
}
function SP(t, e) {
  return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
}
function JS(t, e) {
  return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
}
function dJ(t, e) {
  t[0] += e[0], t[1] += e[1], t[2] += e[2];
}
function QP(t, e) {
  return [t[0] * e, t[1] * e, t[2] * e];
}
function ZU(t) {
  var e = pA(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
  t[0] /= e, t[1] /= e, t[2] /= e;
}
var Aa, yf, Qa, mg, Hy, Tze, Nze, J_, QD = RE(), Ym, FI, J0 = {
  point: Ote,
  lineStart: jwe,
  lineEnd: Ywe,
  polygonStart: function() {
    J0.point = Mze, J0.lineStart = fxn, J0.lineEnd = gxn, QD.reset(), Yp.polygonStart();
  },
  polygonEnd: function() {
    Yp.polygonEnd(), J0.point = Ote, J0.lineStart = jwe, J0.lineEnd = Ywe, KU < 0 ? (Aa = -(Qa = 180), yf = -(mg = 90)) : QD > sr ? mg = 90 : QD < -sr && (yf = -90), FI[0] = Aa, FI[1] = Qa;
  }
};
function Ote(t, e) {
  Ym.push(FI = [Aa = t, Qa = t]), e < yf && (yf = e), e > mg && (mg = e);
}
function Lze(t, e) {
  var n = sB([t * wr, e * wr]);
  if (J_) {
    var r = JS(J_, n), i = [r[1], -r[0], 0], o = JS(i, r);
    ZU(o), o = XU(o);
    var s = t - Hy, a = s > 0 ? 1 : -1, A = o[0] * us * a, l, c = oo(s) > 180;
    c ^ (a * Hy < A && A < a * t) ? (l = o[1] * us, l > mg && (mg = l)) : (A = (A + 360) % 360 - 180, c ^ (a * Hy < A && A < a * t) ? (l = -o[1] * us, l < yf && (yf = l)) : (e < yf && (yf = e), e > mg && (mg = e))), c ? t < Hy ? mf(Aa, t) > mf(Aa, Qa) && (Qa = t) : mf(t, Qa) > mf(Aa, Qa) && (Aa = t) : Qa >= Aa ? (t < Aa && (Aa = t), t > Qa && (Qa = t)) : t > Hy ? mf(Aa, t) > mf(Aa, Qa) && (Qa = t) : mf(t, Qa) > mf(Aa, Qa) && (Aa = t);
  } else
    Ym.push(FI = [Aa = t, Qa = t]);
  e < yf && (yf = e), e > mg && (mg = e), J_ = n, Hy = t;
}
function jwe() {
  J0.point = Lze;
}
function Ywe() {
  FI[0] = Aa, FI[1] = Qa, J0.point = Ote, J_ = null;
}
function Mze(t, e) {
  if (J_) {
    var n = t - Hy;
    QD.add(oo(n) > 180 ? n + (n > 0 ? 360 : -360) : n);
  } else
    Tze = t, Nze = e;
  Yp.point(t, e), Lze(t, e);
}
function fxn() {
  Yp.lineStart();
}
function gxn() {
  Mze(Tze, Nze), Yp.lineEnd(), oo(QD) > sr && (Aa = -(Qa = 180)), FI[0] = Aa, FI[1] = Qa, J_ = null;
}
function mf(t, e) {
  return (e -= t) < 0 ? e + 360 : e;
}
function hxn(t, e) {
  return t[0] - e[0];
}
function zwe(t, e) {
  return t[0] <= t[1] ? t[0] <= e && e <= t[1] : e < t[0] || t[1] < e;
}
function dxn(t) {
  var e, n, r, i, o, s, a;
  if (mg = Qa = -(Aa = yf = 1 / 0), Ym = [], Mh(t, J0), n = Ym.length) {
    for (Ym.sort(hxn), e = 1, r = Ym[0], o = [r]; e < n; ++e)
      i = Ym[e], zwe(r, i[0]) || zwe(r, i[1]) ? (mf(r[0], i[1]) > mf(r[0], r[1]) && (r[1] = i[1]), mf(i[0], r[1]) > mf(r[0], r[1]) && (r[0] = i[0])) : o.push(r = i);
    for (s = -1 / 0, n = o.length - 1, e = 0, r = o[n]; e <= n; r = i, ++e)
      i = o[e], (a = mf(r[1], i[0])) > s && (s = a, Aa = i[0], Qa = r[1]);
  }
  return Ym = FI = null, Aa === 1 / 0 || yf === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[Aa, yf], [Qa, mg]];
}
var wR, e8, t8, n8, r8, i8, o8, s8, Fte, Pte, kte, Oze, Fze, Tc, Nc, Lc, Vh = {
  sphere: Zs,
  point: Zce,
  lineStart: Vwe,
  lineEnd: Jwe,
  polygonStart: function() {
    Vh.lineStart = mxn, Vh.lineEnd = Cxn;
  },
  polygonEnd: function() {
    Vh.lineStart = Vwe, Vh.lineEnd = Jwe;
  }
};
function Zce(t, e) {
  t *= wr, e *= wr;
  var n = nr(e);
  QM(n * nr(t), n * $n(t), $n(e));
}
function QM(t, e, n) {
  ++wR, t8 += (t - t8) / wR, n8 += (e - n8) / wR, r8 += (n - r8) / wR;
}
function Vwe() {
  Vh.point = pxn;
}
function pxn(t, e) {
  t *= wr, e *= wr;
  var n = nr(e);
  Tc = n * nr(t), Nc = n * $n(t), Lc = $n(e), Vh.point = Ixn, QM(Tc, Nc, Lc);
}
function Ixn(t, e) {
  t *= wr, e *= wr;
  var n = nr(e), r = n * nr(t), i = n * $n(t), o = $n(e), s = Kc(pA((s = Nc * o - Lc * i) * s + (s = Lc * r - Tc * o) * s + (s = Tc * i - Nc * r) * s), Tc * r + Nc * i + Lc * o);
  e8 += s, i8 += s * (Tc + (Tc = r)), o8 += s * (Nc + (Nc = i)), s8 += s * (Lc + (Lc = o)), QM(Tc, Nc, Lc);
}
function Jwe() {
  Vh.point = Zce;
}
function mxn() {
  Vh.point = Exn;
}
function Cxn() {
  Pze(Oze, Fze), Vh.point = Zce;
}
function Exn(t, e) {
  Oze = t, Fze = e, t *= wr, e *= wr, Vh.point = Pze;
  var n = nr(e);
  Tc = n * nr(t), Nc = n * $n(t), Lc = $n(e), QM(Tc, Nc, Lc);
}
function Pze(t, e) {
  t *= wr, e *= wr;
  var n = nr(e), r = n * nr(t), i = n * $n(t), o = $n(e), s = Nc * o - Lc * i, a = Lc * r - Tc * o, A = Tc * i - Nc * r, l = pA(s * s + a * a + A * A), c = kf(l), u = l && -c / l;
  Fte += u * s, Pte += u * a, kte += u * A, e8 += c, i8 += c * (Tc + (Tc = r)), o8 += c * (Nc + (Nc = i)), s8 += c * (Lc + (Lc = o)), QM(Tc, Nc, Lc);
}
function yxn(t) {
  wR = e8 = t8 = n8 = r8 = i8 = o8 = s8 = Fte = Pte = kte = 0, Mh(t, Vh);
  var e = Fte, n = Pte, r = kte, i = e * e + n * n + r * r;
  return i < Gwe && (e = i8, n = o8, r = s8, e8 < sr && (e = t8, n = n8, r = r8), i = e * e + n * n + r * r, i < Gwe) ? [NaN, NaN] : [Kc(n, e) * us, kf(r / pA(i)) * us];
}
function pb(t) {
  return function() {
    return t;
  };
}
function kze(t, e) {
  function n(r, i) {
    return r = t(r, i), e(r[0], r[1]);
  }
  return t.invert && e.invert && (n.invert = function(r, i) {
    return r = e.invert(r, i), r && t.invert(r[0], r[1]);
  }), n;
}
function Gte(t, e) {
  return [t > Ri ? t - Fu : t < -Ri ? t + Fu : t, e];
}
Gte.invert = Gte;
function eue(t, e, n) {
  return (t %= Fu) ? e || n ? kze(Wwe(t), Xwe(e, n)) : Wwe(t) : e || n ? Xwe(e, n) : Gte;
}
function Kwe(t) {
  return function(e, n) {
    return e += t, [e > Ri ? e - Fu : e < -Ri ? e + Fu : e, n];
  };
}
function Wwe(t) {
  var e = Kwe(t);
  return e.invert = Kwe(-t), e;
}
function Xwe(t, e) {
  var n = nr(t), r = $n(t), i = nr(e), o = $n(e);
  function s(a, A) {
    var l = nr(A), c = nr(a) * l, u = $n(a) * l, f = $n(A), h = f * n + c * r;
    return [
      Kc(u * i - h * o, c * n - f * r),
      kf(h * i + u * o)
    ];
  }
  return s.invert = function(a, A) {
    var l = nr(A), c = nr(a) * l, u = $n(a) * l, f = $n(A), h = f * i - u * o;
    return [
      Kc(u * i + f * o, c * n + h * r),
      kf(h * n - c * r)
    ];
  }, s;
}
function Gze(t) {
  t = eue(t[0] * wr, t[1] * wr, t.length > 2 ? t[2] * wr : 0);
  function e(n) {
    return n = t(n[0] * wr, n[1] * wr), n[0] *= us, n[1] *= us, n;
  }
  return e.invert = function(n) {
    return n = t.invert(n[0] * wr, n[1] * wr), n[0] *= us, n[1] *= us, n;
  }, e;
}
function Uze(t, e, n, r, i, o) {
  if (n) {
    var s = nr(e), a = $n(e), A = r * n;
    i == null ? (i = e + r * Fu, o = e - A / 2) : (i = Zwe(s, i), o = Zwe(s, o), (r > 0 ? i < o : i > o) && (i += r * Fu));
    for (var l, c = i; r > 0 ? c > o : c < o; c -= A)
      l = XU([s, -a * nr(c), -a * $n(c)]), t.point(l[0], l[1]);
  }
}
function Zwe(t, e) {
  e = sB(e), e[0] -= t, ZU(e);
  var n = wze(-e[1]);
  return ((-e[2] < 0 ? -n : n) + Fu - sr) % Fu;
}
function vxn() {
  var t = pb([0, 0]), e = pb(90), n = pb(6), r, i, o = { point: s };
  function s(A, l) {
    r.push(A = i(A, l)), A[0] *= us, A[1] *= us;
  }
  function a() {
    var A = t.apply(this, arguments), l = e.apply(this, arguments) * wr, c = n.apply(this, arguments) * wr;
    return r = [], i = eue(-A[0] * wr, -A[1] * wr, 0).invert, Uze(o, l, c, 1), A = { type: "Polygon", coordinates: [r] }, r = i = null, A;
  }
  return a.center = function(A) {
    return arguments.length ? (t = typeof A == "function" ? A : pb([+A[0], +A[1]]), a) : t;
  }, a.radius = function(A) {
    return arguments.length ? (e = typeof A == "function" ? A : pb(+A), a) : e;
  }, a.precision = function(A) {
    return arguments.length ? (n = typeof A == "function" ? A : pb(+A), a) : n;
  }, a;
}
function Hze() {
  var t = [], e;
  return {
    point: function(n, r) {
      e.push([n, r]);
    },
    lineStart: function() {
      t.push(e = []);
    },
    lineEnd: Zs,
    rejoin: function() {
      t.length > 1 && t.push(t.pop().concat(t.shift()));
    },
    result: function() {
      var n = t;
      return t = [], e = null, n;
    }
  };
}
function Bxn(t, e, n, r, i, o) {
  var s = t[0], a = t[1], A = e[0], l = e[1], c = 0, u = 1, f = A - s, h = l - a, d;
  if (d = n - s, !(!f && d > 0)) {
    if (d /= f, f < 0) {
      if (d < c)
        return;
      d < u && (u = d);
    } else if (f > 0) {
      if (d > u)
        return;
      d > c && (c = d);
    }
    if (d = i - s, !(!f && d < 0)) {
      if (d /= f, f < 0) {
        if (d > u)
          return;
        d > c && (c = d);
      } else if (f > 0) {
        if (d < c)
          return;
        d < u && (u = d);
      }
      if (d = r - a, !(!h && d > 0)) {
        if (d /= h, h < 0) {
          if (d < c)
            return;
          d < u && (u = d);
        } else if (h > 0) {
          if (d > u)
            return;
          d > c && (c = d);
        }
        if (d = o - a, !(!h && d < 0)) {
          if (d /= h, h < 0) {
            if (d > u)
              return;
            d > c && (c = d);
          } else if (h > 0) {
            if (d < c)
              return;
            d < u && (u = d);
          }
          return c > 0 && (t[0] = s + c * f, t[1] = a + c * h), u < 1 && (e[0] = s + u * f, e[1] = a + u * h), !0;
        }
      }
    }
  }
}
function qk(t, e) {
  return oo(t[0] - e[0]) < sr && oo(t[1] - e[1]) < sr;
}
function wP(t, e, n, r) {
  this.x = t, this.z = e, this.o = n, this.e = r, this.v = !1, this.n = this.p = null;
}
function $ze(t, e, n, r, i) {
  var o = [], s = [], a, A;
  if (t.forEach(function(d) {
    if (!((I = d.length - 1) <= 0)) {
      var I, m = d[0], C = d[I], y;
      if (qk(m, C)) {
        for (i.lineStart(), a = 0; a < I; ++a)
          i.point((m = d[a])[0], m[1]);
        i.lineEnd();
        return;
      }
      o.push(y = new wP(m, d, null, !0)), s.push(y.o = new wP(m, null, y, !1)), o.push(y = new wP(C, d, null, !1)), s.push(y.o = new wP(C, null, y, !0));
    }
  }), !!o.length) {
    for (s.sort(e), exe(o), exe(s), a = 0, A = s.length; a < A; ++a)
      s[a].e = n = !n;
    for (var l = o[0], c, u; ; ) {
      for (var f = l, h = !0; f.v; )
        if ((f = f.n) === l)
          return;
      c = f.z, i.lineStart();
      do {
        if (f.v = f.o.v = !0, f.e) {
          if (h)
            for (a = 0, A = c.length; a < A; ++a)
              i.point((u = c[a])[0], u[1]);
          else
            r(f.x, f.n.x, 1, i);
          f = f.n;
        } else {
          if (h)
            for (c = f.p.z, a = c.length - 1; a >= 0; --a)
              i.point((u = c[a])[0], u[1]);
          else
            r(f.x, f.p.x, -1, i);
          f = f.p;
        }
        f = f.o, c = f.z, h = !h;
      } while (!f.v);
      i.lineEnd();
    }
  }
}
function exe(t) {
  if (e = t.length) {
    for (var e, n = 0, r = t[0], i; ++n < e; )
      r.n = i = t[n], i.p = r, r = i;
    r.n = i = t[0], i.p = r;
  }
}
function qze(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function bxn(t) {
  return t.length === 1 && (t = _xn(t)), {
    left: function(e, n, r, i) {
      for (r == null && (r = 0), i == null && (i = e.length); r < i; ) {
        var o = r + i >>> 1;
        t(e[o], n) < 0 ? r = o + 1 : i = o;
      }
      return r;
    },
    right: function(e, n, r, i) {
      for (r == null && (r = 0), i == null && (i = e.length); r < i; ) {
        var o = r + i >>> 1;
        t(e[o], n) > 0 ? i = o : r = o + 1;
      }
      return r;
    }
  };
}
function _xn(t) {
  return function(e, n) {
    return qze(t(e), n);
  };
}
bxn(qze);
function y_(t, e, n) {
  t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((e - t) / n)) | 0, o = new Array(i); ++r < i; )
    o[r] = t + r * n;
  return o;
}
function jze(t) {
  for (var e = t.length, n, r = -1, i = 0, o, s; ++r < e; )
    i += t[r].length;
  for (o = new Array(i); --e >= 0; )
    for (s = t[e], n = s.length; --n >= 0; )
      o[--i] = s[n];
  return o;
}
var xR = 1e9, xP = -xR;
function tue(t, e, n, r) {
  function i(l, c) {
    return t <= l && l <= n && e <= c && c <= r;
  }
  function o(l, c, u, f) {
    var h = 0, d = 0;
    if (l == null || (h = s(l, u)) !== (d = s(c, u)) || A(l, c) < 0 ^ u > 0)
      do
        f.point(h === 0 || h === 3 ? t : n, h > 1 ? r : e);
      while ((h = (h + u + 4) % 4) !== d);
    else
      f.point(c[0], c[1]);
  }
  function s(l, c) {
    return oo(l[0] - t) < sr ? c > 0 ? 0 : 3 : oo(l[0] - n) < sr ? c > 0 ? 2 : 1 : oo(l[1] - e) < sr ? c > 0 ? 1 : 0 : c > 0 ? 3 : 2;
  }
  function a(l, c) {
    return A(l.x, c.x);
  }
  function A(l, c) {
    var u = s(l, 1), f = s(c, 1);
    return u !== f ? u - f : u === 0 ? c[1] - l[1] : u === 1 ? l[0] - c[0] : u === 2 ? l[1] - c[1] : c[0] - l[0];
  }
  return function(l) {
    var c = l, u = Hze(), f, h, d, I, m, C, y, v, b, Q, w, R = {
      point: M,
      lineStart: k,
      lineEnd: $,
      polygonStart: L,
      polygonEnd: N
    };
    function M(X, K) {
      i(X, K) && c.point(X, K);
    }
    function O() {
      for (var X = 0, K = 0, z = h.length; K < z; ++K)
        for (var Y = h[K], V = 1, Z = Y.length, ce = Y[0], ee, pe, Ce = ce[0], Be = ce[1]; V < Z; ++V)
          ee = Ce, pe = Be, ce = Y[V], Ce = ce[0], Be = ce[1], pe <= r ? Be > r && (Ce - ee) * (r - pe) > (Be - pe) * (t - ee) && ++X : Be <= r && (Ce - ee) * (r - pe) < (Be - pe) * (t - ee) && --X;
      return X;
    }
    function L() {
      c = u, f = [], h = [], w = !0;
    }
    function N() {
      var X = O(), K = w && X, z = (f = jze(f)).length;
      (K || z) && (l.polygonStart(), K && (l.lineStart(), o(null, null, 1, l), l.lineEnd()), z && $ze(f, a, X, o, l), l.polygonEnd()), c = l, f = h = d = null;
    }
    function k() {
      R.point = U, h && h.push(d = []), Q = !0, b = !1, y = v = NaN;
    }
    function $() {
      f && (U(I, m), C && b && u.rejoin(), f.push(u.result())), R.point = M, b && c.lineEnd();
    }
    function U(X, K) {
      var z = i(X, K);
      if (h && d.push([X, K]), Q)
        I = X, m = K, C = z, Q = !1, z && (c.lineStart(), c.point(X, K));
      else if (z && b)
        c.point(X, K);
      else {
        var Y = [y = Math.max(xP, Math.min(xR, y)), v = Math.max(xP, Math.min(xR, v))], V = [X = Math.max(xP, Math.min(xR, X)), K = Math.max(xP, Math.min(xR, K))];
        Bxn(Y, V, t, e, n, r) ? (b || (c.lineStart(), c.point(Y[0], Y[1])), c.point(V[0], V[1]), z || c.lineEnd(), w = !1) : z && (c.lineStart(), c.point(X, K), w = !1);
      }
      y = X, v = K, b = z;
    }
    return R;
  };
}
function Sxn() {
  var t = 0, e = 0, n = 960, r = 500, i, o, s;
  return s = {
    stream: function(a) {
      return i && o === a ? i : i = tue(t, e, n, r)(o = a);
    },
    extent: function(a) {
      return arguments.length ? (t = +a[0][0], e = +a[0][1], n = +a[1][0], r = +a[1][1], i = o = null, s) : [[t, e], [n, r]];
    }
  };
}
var pJ = RE();
function Yze(t, e) {
  var n = e[0], r = e[1], i = [$n(n), -nr(n), 0], o = 0, s = 0;
  pJ.reset();
  for (var a = 0, A = t.length; a < A; ++a)
    if (c = (l = t[a]).length)
      for (var l, c, u = l[c - 1], f = u[0], h = u[1] / 2 + zU, d = $n(h), I = nr(h), m = 0; m < c; ++m, f = y, d = b, I = Q, u = C) {
        var C = l[m], y = C[0], v = C[1] / 2 + zU, b = $n(v), Q = nr(v), w = y - f, R = w >= 0 ? 1 : -1, M = R * w, O = M > Ri, L = d * b;
        if (pJ.add(Kc(L * R * $n(M), I * Q + L * nr(M))), o += O ? w + R * Fu : w, O ^ f >= n ^ y >= n) {
          var N = JS(sB(u), sB(C));
          ZU(N);
          var k = JS(i, N);
          ZU(k);
          var $ = (O ^ w >= 0 ? -1 : 1) * kf(k[2]);
          (r > $ || r === $ && (N[0] || N[1])) && (s += O ^ w >= 0 ? 1 : -1);
        }
      }
  return (o < -sr || o < sr && pJ < -sr) ^ s & 1;
}
var Ute = RE(), Hte, jk, Yk, KS = {
  sphere: Zs,
  point: Zs,
  lineStart: Qxn,
  lineEnd: Zs,
  polygonStart: Zs,
  polygonEnd: Zs
};
function Qxn() {
  KS.point = xxn, KS.lineEnd = wxn;
}
function wxn() {
  KS.point = KS.lineEnd = Zs;
}
function xxn(t, e) {
  t *= wr, e *= wr, Hte = t, jk = $n(e), Yk = nr(e), KS.point = Rxn;
}
function Rxn(t, e) {
  t *= wr, e *= wr;
  var n = $n(e), r = nr(e), i = oo(t - Hte), o = nr(i), s = $n(i), a = r * s, A = Yk * n - jk * r * o, l = jk * n + Yk * r * o;
  Ute.add(Kc(pA(a * a + A * A), l)), Hte = t, jk = n, Yk = r;
}
function zze(t) {
  return Ute.reset(), Mh(t, KS), +Ute;
}
var $te = [null, null], Dxn = { type: "LineString", coordinates: $te };
function wD(t, e) {
  return $te[0] = t, $te[1] = e, zze(Dxn);
}
var txe = {
  Feature: function(t, e) {
    return a8(t.geometry, e);
  },
  FeatureCollection: function(t, e) {
    for (var n = t.features, r = -1, i = n.length; ++r < i; )
      if (a8(n[r].geometry, e))
        return !0;
    return !1;
  }
}, nxe = {
  Sphere: function() {
    return !0;
  },
  Point: function(t, e) {
    return rxe(t.coordinates, e);
  },
  MultiPoint: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      if (rxe(n[r], e))
        return !0;
    return !1;
  },
  LineString: function(t, e) {
    return ixe(t.coordinates, e);
  },
  MultiLineString: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      if (ixe(n[r], e))
        return !0;
    return !1;
  },
  Polygon: function(t, e) {
    return oxe(t.coordinates, e);
  },
  MultiPolygon: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      if (oxe(n[r], e))
        return !0;
    return !1;
  },
  GeometryCollection: function(t, e) {
    for (var n = t.geometries, r = -1, i = n.length; ++r < i; )
      if (a8(n[r], e))
        return !0;
    return !1;
  }
};
function a8(t, e) {
  return t && nxe.hasOwnProperty(t.type) ? nxe[t.type](t, e) : !1;
}
function rxe(t, e) {
  return wD(t, e) === 0;
}
function ixe(t, e) {
  var n = wD(t[0], t[1]), r = wD(t[0], e), i = wD(e, t[1]);
  return r + i <= n + sr;
}
function oxe(t, e) {
  return !!Yze(t.map(Txn), Vze(e));
}
function Txn(t) {
  return t = t.map(Vze), t.pop(), t;
}
function Vze(t) {
  return [t[0] * wr, t[1] * wr];
}
function Nxn(t, e) {
  return (t && txe.hasOwnProperty(t.type) ? txe[t.type] : a8)(t, e);
}
function sxe(t, e, n) {
  var r = y_(t, e - sr, n).concat(e);
  return function(i) {
    return r.map(function(o) {
      return [i, o];
    });
  };
}
function axe(t, e, n) {
  var r = y_(t, e - sr, n).concat(e);
  return function(i) {
    return r.map(function(o) {
      return [o, i];
    });
  };
}
function Jze() {
  var t, e, n, r, i, o, s, a, A = 10, l = A, c = 90, u = 360, f, h, d, I, m = 2.5;
  function C() {
    return { type: "MultiLineString", coordinates: y() };
  }
  function y() {
    return y_(_P(r / c) * c, n, c).map(d).concat(y_(_P(a / u) * u, s, u).map(I)).concat(y_(_P(e / A) * A, t, A).filter(function(v) {
      return oo(v % c) > sr;
    }).map(f)).concat(y_(_P(o / l) * l, i, l).filter(function(v) {
      return oo(v % u) > sr;
    }).map(h));
  }
  return C.lines = function() {
    return y().map(function(v) {
      return { type: "LineString", coordinates: v };
    });
  }, C.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        d(r).concat(
          I(s).slice(1),
          d(n).reverse().slice(1),
          I(a).reverse().slice(1)
        )
      ]
    };
  }, C.extent = function(v) {
    return arguments.length ? C.extentMajor(v).extentMinor(v) : C.extentMinor();
  }, C.extentMajor = function(v) {
    return arguments.length ? (r = +v[0][0], n = +v[1][0], a = +v[0][1], s = +v[1][1], r > n && (v = r, r = n, n = v), a > s && (v = a, a = s, s = v), C.precision(m)) : [[r, a], [n, s]];
  }, C.extentMinor = function(v) {
    return arguments.length ? (e = +v[0][0], t = +v[1][0], o = +v[0][1], i = +v[1][1], e > t && (v = e, e = t, t = v), o > i && (v = o, o = i, i = v), C.precision(m)) : [[e, o], [t, i]];
  }, C.step = function(v) {
    return arguments.length ? C.stepMajor(v).stepMinor(v) : C.stepMinor();
  }, C.stepMajor = function(v) {
    return arguments.length ? (c = +v[0], u = +v[1], C) : [c, u];
  }, C.stepMinor = function(v) {
    return arguments.length ? (A = +v[0], l = +v[1], C) : [A, l];
  }, C.precision = function(v) {
    return arguments.length ? (m = +v, f = sxe(o, i, 90), h = axe(e, t, m), d = sxe(a, s, 90), I = axe(r, n, m), C) : m;
  }, C.extentMajor([[-180, -90 + sr], [180, 90 - sr]]).extentMinor([[-180, -80 - sr], [180, 80 + sr]]);
}
function Lxn() {
  return Jze()();
}
function Mxn(t, e) {
  var n = t[0] * wr, r = t[1] * wr, i = e[0] * wr, o = e[1] * wr, s = nr(r), a = $n(r), A = nr(o), l = $n(o), c = s * nr(n), u = s * $n(n), f = A * nr(i), h = A * $n(i), d = 2 * kf(pA(Uwe(o - r) + s * A * Uwe(i - n))), I = $n(d), m = d ? function(C) {
    var y = $n(C *= d) / I, v = $n(d - C) / I, b = v * c + y * f, Q = v * u + y * h, w = v * a + y * l;
    return [
      Kc(Q, b) * us,
      Kc(w, pA(b * b + Q * Q)) * us
    ];
  } : function() {
    return [n * us, r * us];
  };
  return m.distance = d, m;
}
function Rv(t) {
  return t;
}
var IJ = RE(), qte = RE(), Kze, Wze, jte, Yte, rI = {
  point: Zs,
  lineStart: Zs,
  lineEnd: Zs,
  polygonStart: function() {
    rI.lineStart = Oxn, rI.lineEnd = Pxn;
  },
  polygonEnd: function() {
    rI.lineStart = rI.lineEnd = rI.point = Zs, IJ.add(oo(qte)), qte.reset();
  },
  result: function() {
    var t = IJ / 2;
    return IJ.reset(), t;
  }
};
function Oxn() {
  rI.point = Fxn;
}
function Fxn(t, e) {
  rI.point = Xze, Kze = jte = t, Wze = Yte = e;
}
function Xze(t, e) {
  qte.add(Yte * t - jte * e), jte = t, Yte = e;
}
function Pxn() {
  Xze(Kze, Wze);
}
var WS = 1 / 0, A8 = WS, eN = -WS, l8 = eN, c8 = {
  point: kxn,
  lineStart: Zs,
  lineEnd: Zs,
  polygonStart: Zs,
  polygonEnd: Zs,
  result: function() {
    var t = [[WS, A8], [eN, l8]];
    return eN = l8 = -(A8 = WS = 1 / 0), t;
  }
};
function kxn(t, e) {
  t < WS && (WS = t), t > eN && (eN = t), e < A8 && (A8 = e), e > l8 && (l8 = e);
}
var zte = 0, Vte = 0, RR = 0, u8 = 0, f8 = 0, v_ = 0, Jte = 0, Kte = 0, DR = 0, Zze, e7e, dp, pp, yg = {
  point: aB,
  lineStart: Axe,
  lineEnd: lxe,
  polygonStart: function() {
    yg.lineStart = Hxn, yg.lineEnd = $xn;
  },
  polygonEnd: function() {
    yg.point = aB, yg.lineStart = Axe, yg.lineEnd = lxe;
  },
  result: function() {
    var t = DR ? [Jte / DR, Kte / DR] : v_ ? [u8 / v_, f8 / v_] : RR ? [zte / RR, Vte / RR] : [NaN, NaN];
    return zte = Vte = RR = u8 = f8 = v_ = Jte = Kte = DR = 0, t;
  }
};
function aB(t, e) {
  zte += t, Vte += e, ++RR;
}
function Axe() {
  yg.point = Gxn;
}
function Gxn(t, e) {
  yg.point = Uxn, aB(dp = t, pp = e);
}
function Uxn(t, e) {
  var n = t - dp, r = e - pp, i = pA(n * n + r * r);
  u8 += i * (dp + t) / 2, f8 += i * (pp + e) / 2, v_ += i, aB(dp = t, pp = e);
}
function lxe() {
  yg.point = aB;
}
function Hxn() {
  yg.point = qxn;
}
function $xn() {
  t7e(Zze, e7e);
}
function qxn(t, e) {
  yg.point = t7e, aB(Zze = dp = t, e7e = pp = e);
}
function t7e(t, e) {
  var n = t - dp, r = e - pp, i = pA(n * n + r * r);
  u8 += i * (dp + t) / 2, f8 += i * (pp + e) / 2, v_ += i, i = pp * t - dp * e, Jte += i * (dp + t), Kte += i * (pp + e), DR += i * 3, aB(dp = t, pp = e);
}
function n7e(t) {
  this._context = t;
}
n7e.prototype = {
  _radius: 4.5,
  pointRadius: function(t) {
    return this._radius = t, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._context.closePath(), this._point = NaN;
  },
  point: function(t, e) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(t, e), this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(t, e);
        break;
      }
      default: {
        this._context.moveTo(t + this._radius, e), this._context.arc(t, e, this._radius, 0, Fu);
        break;
      }
    }
  },
  result: Zs
};
var Wte = RE(), mJ, r7e, i7e, TR, NR, tN = {
  point: Zs,
  lineStart: function() {
    tN.point = jxn;
  },
  lineEnd: function() {
    mJ && o7e(r7e, i7e), tN.point = Zs;
  },
  polygonStart: function() {
    mJ = !0;
  },
  polygonEnd: function() {
    mJ = null;
  },
  result: function() {
    var t = +Wte;
    return Wte.reset(), t;
  }
};
function jxn(t, e) {
  tN.point = o7e, r7e = TR = t, i7e = NR = e;
}
function o7e(t, e) {
  TR -= t, NR -= e, Wte.add(pA(TR * TR + NR * NR)), TR = t, NR = e;
}
function s7e() {
  this._string = [];
}
s7e.prototype = {
  _radius: 4.5,
  _circle: cxe(4.5),
  pointRadius: function(t) {
    return (t = +t) !== this._radius && (this._radius = t, this._circle = null), this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._string.push("Z"), this._point = NaN;
  },
  point: function(t, e) {
    switch (this._point) {
      case 0: {
        this._string.push("M", t, ",", e), this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", t, ",", e);
        break;
      }
      default: {
        this._circle == null && (this._circle = cxe(this._radius)), this._string.push("M", t, ",", e, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var t = this._string.join("");
      return this._string = [], t;
    } else
      return null;
  }
};
function cxe(t) {
  return "m0," + t + "a" + t + "," + t + " 0 1,1 0," + -2 * t + "a" + t + "," + t + " 0 1,1 0," + 2 * t + "z";
}
function Yxn(t, e) {
  var n = 4.5, r, i;
  function o(s) {
    return s && (typeof n == "function" && i.pointRadius(+n.apply(this, arguments)), Mh(s, r(i))), i.result();
  }
  return o.area = function(s) {
    return Mh(s, r(rI)), rI.result();
  }, o.measure = function(s) {
    return Mh(s, r(tN)), tN.result();
  }, o.bounds = function(s) {
    return Mh(s, r(c8)), c8.result();
  }, o.centroid = function(s) {
    return Mh(s, r(yg)), yg.result();
  }, o.projection = function(s) {
    return arguments.length ? (r = s == null ? (t = null, Rv) : (t = s).stream, o) : t;
  }, o.context = function(s) {
    return arguments.length ? (i = s == null ? (e = null, new s7e()) : new n7e(e = s), typeof n != "function" && i.pointRadius(n), o) : e;
  }, o.pointRadius = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : (i.pointRadius(+s), +s), o) : n;
  }, o.projection(t).context(e);
}
function a7e(t, e, n, r) {
  return function(i, o) {
    var s = e(o), a = i.invert(r[0], r[1]), A = Hze(), l = e(A), c = !1, u, f, h, d = {
      point: I,
      lineStart: C,
      lineEnd: y,
      polygonStart: function() {
        d.point = v, d.lineStart = b, d.lineEnd = Q, f = [], u = [];
      },
      polygonEnd: function() {
        d.point = I, d.lineStart = C, d.lineEnd = y, f = jze(f);
        var w = Yze(u, a);
        f.length ? (c || (o.polygonStart(), c = !0), $ze(f, Vxn, w, n, o)) : w && (c || (o.polygonStart(), c = !0), o.lineStart(), n(null, null, 1, o), o.lineEnd()), c && (o.polygonEnd(), c = !1), f = u = null;
      },
      sphere: function() {
        o.polygonStart(), o.lineStart(), n(null, null, 1, o), o.lineEnd(), o.polygonEnd();
      }
    };
    function I(w, R) {
      var M = i(w, R);
      t(w = M[0], R = M[1]) && o.point(w, R);
    }
    function m(w, R) {
      var M = i(w, R);
      s.point(M[0], M[1]);
    }
    function C() {
      d.point = m, s.lineStart();
    }
    function y() {
      d.point = I, s.lineEnd();
    }
    function v(w, R) {
      h.push([w, R]);
      var M = i(w, R);
      l.point(M[0], M[1]);
    }
    function b() {
      l.lineStart(), h = [];
    }
    function Q() {
      v(h[0][0], h[0][1]), l.lineEnd();
      var w = l.clean(), R = A.result(), M, O = R.length, L, N, k;
      if (h.pop(), u.push(h), h = null, !!O) {
        if (w & 1) {
          if (N = R[0], (L = N.length - 1) > 0) {
            for (c || (o.polygonStart(), c = !0), o.lineStart(), M = 0; M < L; ++M)
              o.point((k = N[M])[0], k[1]);
            o.lineEnd();
          }
          return;
        }
        O > 1 && w & 2 && R.push(R.pop().concat(R.shift())), f.push(R.filter(zxn));
      }
    }
    return d;
  };
}
function zxn(t) {
  return t.length > 1;
}
function Vxn(t, e) {
  return ((t = t.x)[0] < 0 ? t[1] - qa - sr : qa - t[1]) - ((e = e.x)[0] < 0 ? e[1] - qa - sr : qa - e[1]);
}
const uxe = a7e(
  function() {
    return !0;
  },
  Jxn,
  Wxn,
  [-Ri, -qa]
);
function Jxn(t) {
  var e = NaN, n = NaN, r = NaN, i;
  return {
    lineStart: function() {
      t.lineStart(), i = 1;
    },
    point: function(o, s) {
      var a = o > 0 ? Ri : -Ri, A = oo(o - e);
      oo(A - Ri) < sr ? (t.point(e, n = (n + s) / 2 > 0 ? qa : -qa), t.point(r, n), t.lineEnd(), t.lineStart(), t.point(a, n), t.point(o, n), i = 0) : r !== a && A >= Ri && (oo(e - r) < sr && (e -= r * sr), oo(o - a) < sr && (o -= a * sr), n = Kxn(e, n, o, s), t.point(r, n), t.lineEnd(), t.lineStart(), t.point(a, n), i = 0), t.point(e = o, n = s), r = a;
    },
    lineEnd: function() {
      t.lineEnd(), e = n = NaN;
    },
    clean: function() {
      return 2 - i;
    }
  };
}
function Kxn(t, e, n, r) {
  var i, o, s = $n(t - n);
  return oo(s) > sr ? Hw(($n(e) * (o = nr(r)) * $n(n) - $n(r) * (i = nr(e)) * $n(t)) / (i * o * s)) : (e + r) / 2;
}
function Wxn(t, e, n, r) {
  var i;
  if (t == null)
    i = n * qa, r.point(-Ri, i), r.point(0, i), r.point(Ri, i), r.point(Ri, 0), r.point(Ri, -i), r.point(0, -i), r.point(-Ri, -i), r.point(-Ri, 0), r.point(-Ri, i);
  else if (oo(t[0] - e[0]) > sr) {
    var o = t[0] < e[0] ? Ri : -Ri;
    i = n * o / 2, r.point(-o, i), r.point(0, i), r.point(o, i);
  } else
    r.point(e[0], e[1]);
}
function Xxn(t, e) {
  var n = nr(t), r = n > 0, i = oo(n) > sr;
  function o(c, u, f, h) {
    Uze(h, t, e, f, c, u);
  }
  function s(c, u) {
    return nr(c) * nr(u) > n;
  }
  function a(c) {
    var u, f, h, d, I;
    return {
      lineStart: function() {
        d = h = !1, I = 1;
      },
      point: function(m, C) {
        var y = [m, C], v, b = s(m, C), Q = r ? b ? 0 : l(m, C) : b ? l(m + (m < 0 ? Ri : -Ri), C) : 0;
        if (!u && (d = h = b) && c.lineStart(), b !== h && (v = A(u, y), (!v || qk(u, v) || qk(y, v)) && (y[0] += sr, y[1] += sr, b = s(y[0], y[1]))), b !== h)
          I = 0, b ? (c.lineStart(), v = A(y, u), c.point(v[0], v[1])) : (v = A(u, y), c.point(v[0], v[1]), c.lineEnd()), u = v;
        else if (i && u && r ^ b) {
          var w;
          !(Q & f) && (w = A(y, u, !0)) && (I = 0, r ? (c.lineStart(), c.point(w[0][0], w[0][1]), c.point(w[1][0], w[1][1]), c.lineEnd()) : (c.point(w[1][0], w[1][1]), c.lineEnd(), c.lineStart(), c.point(w[0][0], w[0][1])));
        }
        b && (!u || !qk(u, y)) && c.point(y[0], y[1]), u = y, h = b, f = Q;
      },
      lineEnd: function() {
        h && c.lineEnd(), u = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return I | (d && h) << 1;
      }
    };
  }
  function A(c, u, f) {
    var h = sB(c), d = sB(u), I = [1, 0, 0], m = JS(h, d), C = SP(m, m), y = m[0], v = C - y * y;
    if (!v)
      return !f && c;
    var b = n * C / v, Q = -n * y / v, w = JS(I, m), R = QP(I, b), M = QP(m, Q);
    dJ(R, M);
    var O = w, L = SP(R, O), N = SP(O, O), k = L * L - N * (SP(R, R) - 1);
    if (!(k < 0)) {
      var $ = pA(k), U = QP(O, (-L - $) / N);
      if (dJ(U, R), U = XU(U), !f)
        return U;
      var X = c[0], K = u[0], z = c[1], Y = u[1], V;
      K < X && (V = X, X = K, K = V);
      var Z = K - X, ce = oo(Z - Ri) < sr, ee = ce || Z < sr;
      if (!ce && Y < z && (V = z, z = Y, Y = V), ee ? ce ? z + Y > 0 ^ U[1] < (oo(U[0] - X) < sr ? z : Y) : z <= U[1] && U[1] <= Y : Z > Ri ^ (X <= U[0] && U[0] <= K)) {
        var pe = QP(O, (-L + $) / N);
        return dJ(pe, R), [U, XU(pe)];
      }
    }
  }
  function l(c, u) {
    var f = r ? t : Ri - t, h = 0;
    return c < -f ? h |= 1 : c > f && (h |= 2), u < -f ? h |= 4 : u > f && (h |= 8), h;
  }
  return a7e(s, a, o, r ? [0, -t] : [-Ri, t - Ri]);
}
function Zxn(t) {
  return {
    stream: L$(t)
  };
}
function L$(t) {
  return function(e) {
    var n = new Xte();
    for (var r in t)
      n[r] = t[r];
    return n.stream = e, n;
  };
}
function Xte() {
}
Xte.prototype = {
  constructor: Xte,
  point: function(t, e) {
    this.stream.point(t, e);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function M$(t, e, n) {
  var r = e[1][0] - e[0][0], i = e[1][1] - e[0][1], o = t.clipExtent && t.clipExtent();
  t.scale(150).translate([0, 0]), o != null && t.clipExtent(null), Mh(n, t.stream(c8));
  var s = c8.result(), a = Math.min(r / (s[1][0] - s[0][0]), i / (s[1][1] - s[0][1])), A = +e[0][0] + (r - a * (s[1][0] + s[0][0])) / 2, l = +e[0][1] + (i - a * (s[1][1] + s[0][1])) / 2;
  return o != null && t.clipExtent(o), t.scale(a * 150).translate([A, l]);
}
function nue(t, e, n) {
  return M$(t, [[0, 0], e], n);
}
var fxe = 16, e2n = nr(30 * wr);
function gxe(t, e) {
  return +e ? n2n(t, e) : t2n(t);
}
function t2n(t) {
  return L$({
    point: function(e, n) {
      e = t(e, n), this.stream.point(e[0], e[1]);
    }
  });
}
function n2n(t, e) {
  function n(r, i, o, s, a, A, l, c, u, f, h, d, I, m) {
    var C = l - r, y = c - i, v = C * C + y * y;
    if (v > 4 * e && I--) {
      var b = s + f, Q = a + h, w = A + d, R = pA(b * b + Q * Q + w * w), M = kf(w /= R), O = oo(oo(w) - 1) < sr || oo(o - u) < sr ? (o + u) / 2 : Kc(Q, b), L = t(O, M), N = L[0], k = L[1], $ = N - r, U = k - i, X = y * $ - C * U;
      (X * X / v > e || oo((C * $ + y * U) / v - 0.5) > 0.3 || s * f + a * h + A * d < e2n) && (n(r, i, o, s, a, A, N, k, O, b /= R, Q /= R, w, I, m), m.point(N, k), n(N, k, O, b, Q, w, l, c, u, f, h, d, I, m));
    }
  }
  return function(r) {
    var i, o, s, a, A, l, c, u, f, h, d, I, m = {
      point: C,
      lineStart: y,
      lineEnd: b,
      polygonStart: function() {
        r.polygonStart(), m.lineStart = Q;
      },
      polygonEnd: function() {
        r.polygonEnd(), m.lineStart = y;
      }
    };
    function C(M, O) {
      M = t(M, O), r.point(M[0], M[1]);
    }
    function y() {
      u = NaN, m.point = v, r.lineStart();
    }
    function v(M, O) {
      var L = sB([M, O]), N = t(M, O);
      n(u, f, c, h, d, I, u = N[0], f = N[1], c = M, h = L[0], d = L[1], I = L[2], fxe, r), r.point(u, f);
    }
    function b() {
      m.point = C, r.lineEnd();
    }
    function Q() {
      y(), m.point = w, m.lineEnd = R;
    }
    function w(M, O) {
      v(i = M, O), o = u, s = f, a = h, A = d, l = I, m.point = v;
    }
    function R() {
      n(u, f, c, h, d, I, o, s, i, a, A, l, fxe, r), m.lineEnd = b, b();
    }
    return m;
  };
}
var r2n = L$({
  point: function(t, e) {
    this.stream.point(t * wr, e * wr);
  }
});
function tm(t) {
  return rue(function() {
    return t;
  })();
}
function rue(t) {
  var e, n = 150, r = 480, i = 250, o, s, a = 0, A = 0, l = 0, c = 0, u = 0, f, h, d = null, I = uxe, m = null, C, y, v, b = Rv, Q = 0.5, w = gxe(N, Q), R, M;
  function O(U) {
    return U = h(U[0] * wr, U[1] * wr), [U[0] * n + o, s - U[1] * n];
  }
  function L(U) {
    return U = h.invert((U[0] - o) / n, (s - U[1]) / n), U && [U[0] * us, U[1] * us];
  }
  function N(U, X) {
    return U = e(U, X), [U[0] * n + o, s - U[1] * n];
  }
  O.stream = function(U) {
    return R && M === U ? R : R = r2n(I(f, w(b(M = U))));
  }, O.clipAngle = function(U) {
    return arguments.length ? (I = +U ? Xxn(d = U * wr, 6 * wr) : (d = null, uxe), $()) : d * us;
  }, O.clipExtent = function(U) {
    return arguments.length ? (b = U == null ? (m = C = y = v = null, Rv) : tue(m = +U[0][0], C = +U[0][1], y = +U[1][0], v = +U[1][1]), $()) : m == null ? null : [[m, C], [y, v]];
  }, O.scale = function(U) {
    return arguments.length ? (n = +U, k()) : n;
  }, O.translate = function(U) {
    return arguments.length ? (r = +U[0], i = +U[1], k()) : [r, i];
  }, O.center = function(U) {
    return arguments.length ? (a = U[0] % 360 * wr, A = U[1] % 360 * wr, k()) : [a * us, A * us];
  }, O.rotate = function(U) {
    return arguments.length ? (l = U[0] % 360 * wr, c = U[1] % 360 * wr, u = U.length > 2 ? U[2] % 360 * wr : 0, k()) : [l * us, c * us, u * us];
  }, O.precision = function(U) {
    return arguments.length ? (w = gxe(N, Q = U * U), $()) : pA(Q);
  }, O.fitExtent = function(U, X) {
    return M$(O, U, X);
  }, O.fitSize = function(U, X) {
    return nue(O, U, X);
  };
  function k() {
    h = kze(f = eue(l, c, u), e);
    var U = e(a, A);
    return o = r - U[0] * n, s = i + U[1] * n, $();
  }
  function $() {
    return R = M = null, O;
  }
  return function() {
    return e = t.apply(this, arguments), O.invert = e.invert && L, k();
  };
}
function iue(t) {
  var e = 0, n = Ri / 3, r = rue(t), i = r(e, n);
  return i.parallels = function(o) {
    return arguments.length ? r(e = o[0] * wr, n = o[1] * wr) : [e * us, n * us];
  }, i;
}
function i2n(t) {
  var e = nr(t);
  function n(r, i) {
    return [r * e, $n(i) / e];
  }
  return n.invert = function(r, i) {
    return [r / e, kf(i * e)];
  }, n;
}
function A7e(t, e) {
  var n = $n(t), r = (n + $n(e)) / 2;
  if (oo(r) < sr)
    return i2n(t);
  var i = 1 + n * (2 * r - n), o = pA(i) / r;
  function s(a, A) {
    var l = pA(i - 2 * r * $n(A)) / r;
    return [l * $n(a *= r), o - l * nr(a)];
  }
  return s.invert = function(a, A) {
    var l = o - A;
    return [Kc(a, oo(l)) / r * ZT(l), kf((i - (a * a + l * l) * r * r) / (2 * r))];
  }, s;
}
function g8() {
  return iue(A7e).scale(155.424).center([0, 33.6442]);
}
function l7e() {
  return g8().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function o2n(t) {
  var e = t.length;
  return {
    point: function(n, r) {
      for (var i = -1; ++i < e; )
        t[i].point(n, r);
    },
    sphere: function() {
      for (var n = -1; ++n < e; )
        t[n].sphere();
    },
    lineStart: function() {
      for (var n = -1; ++n < e; )
        t[n].lineStart();
    },
    lineEnd: function() {
      for (var n = -1; ++n < e; )
        t[n].lineEnd();
    },
    polygonStart: function() {
      for (var n = -1; ++n < e; )
        t[n].polygonStart();
    },
    polygonEnd: function() {
      for (var n = -1; ++n < e; )
        t[n].polygonEnd();
    }
  };
}
function s2n() {
  var t, e, n = l7e(), r, i = g8().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), o, s = g8().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), a, A, l = { point: function(f, h) {
    A = [f, h];
  } };
  function c(f) {
    var h = f[0], d = f[1];
    return A = null, r.point(h, d), A || (o.point(h, d), A) || (a.point(h, d), A);
  }
  c.invert = function(f) {
    var h = n.scale(), d = n.translate(), I = (f[0] - d[0]) / h, m = (f[1] - d[1]) / h;
    return (m >= 0.12 && m < 0.234 && I >= -0.425 && I < -0.214 ? i : m >= 0.166 && m < 0.234 && I >= -0.214 && I < -0.115 ? s : n).invert(f);
  }, c.stream = function(f) {
    return t && e === f ? t : t = o2n([n.stream(e = f), i.stream(f), s.stream(f)]);
  }, c.precision = function(f) {
    return arguments.length ? (n.precision(f), i.precision(f), s.precision(f), u()) : n.precision();
  }, c.scale = function(f) {
    return arguments.length ? (n.scale(f), i.scale(f * 0.35), s.scale(f), c.translate(n.translate())) : n.scale();
  }, c.translate = function(f) {
    if (!arguments.length)
      return n.translate();
    var h = n.scale(), d = +f[0], I = +f[1];
    return r = n.translate(f).clipExtent([[d - 0.455 * h, I - 0.238 * h], [d + 0.455 * h, I + 0.238 * h]]).stream(l), o = i.translate([d - 0.307 * h, I + 0.201 * h]).clipExtent([[d - 0.425 * h + sr, I + 0.12 * h + sr], [d - 0.214 * h - sr, I + 0.234 * h - sr]]).stream(l), a = s.translate([d - 0.205 * h, I + 0.212 * h]).clipExtent([[d - 0.214 * h + sr, I + 0.166 * h + sr], [d - 0.115 * h - sr, I + 0.234 * h - sr]]).stream(l), u();
  }, c.fitExtent = function(f, h) {
    return M$(c, f, h);
  }, c.fitSize = function(f, h) {
    return nue(c, f, h);
  };
  function u() {
    return t = e = null, c;
  }
  return c.scale(1070);
}
function c7e(t) {
  return function(e, n) {
    var r = nr(e), i = nr(n), o = t(r * i);
    return [
      o * i * $n(e),
      o * $n(n)
    ];
  };
}
function wM(t) {
  return function(e, n) {
    var r = pA(e * e + n * n), i = t(r), o = $n(i), s = nr(i);
    return [
      Kc(e * o, r * s),
      kf(r && n * o / r)
    ];
  };
}
var oue = c7e(function(t) {
  return pA(2 / (1 + t));
});
oue.invert = wM(function(t) {
  return 2 * kf(t / 2);
});
function a2n() {
  return tm(oue).scale(124.75).clipAngle(180 - 1e-3);
}
var sue = c7e(function(t) {
  return (t = wze(t)) && t / $n(t);
});
sue.invert = wM(function(t) {
  return t;
});
function A2n() {
  return tm(sue).scale(79.4188).clipAngle(180 - 1e-3);
}
function xM(t, e) {
  return [t, VU(Xce((qa + e) / 2))];
}
xM.invert = function(t, e) {
  return [t, 2 * Hw(Qze(e)) - qa];
};
function l2n() {
  return u7e(xM).scale(961 / Fu);
}
function u7e(t) {
  var e = tm(t), n = e.center, r = e.scale, i = e.translate, o = e.clipExtent, s = null, a, A, l;
  e.scale = function(u) {
    return arguments.length ? (r(u), c()) : r();
  }, e.translate = function(u) {
    return arguments.length ? (i(u), c()) : i();
  }, e.center = function(u) {
    return arguments.length ? (n(u), c()) : n();
  }, e.clipExtent = function(u) {
    return arguments.length ? (u == null ? s = a = A = l = null : (s = +u[0][0], a = +u[0][1], A = +u[1][0], l = +u[1][1]), c()) : s == null ? null : [[s, a], [A, l]];
  };
  function c() {
    var u = Ri * r(), f = e(Gze(e.rotate()).invert([0, 0]));
    return o(s == null ? [[f[0] - u, f[1] - u], [f[0] + u, f[1] + u]] : t === xM ? [[Math.max(f[0] - u, s), a], [Math.min(f[0] + u, A), l]] : [[s, Math.max(f[1] - u, a)], [A, Math.min(f[1] + u, l)]]);
  }
  return c();
}
function RP(t) {
  return Xce((qa + t) / 2);
}
function f7e(t, e) {
  var n = nr(t), r = t === e ? $n(t) : VU(n / nr(e)) / VU(RP(e) / RP(t)), i = n * hJ(RP(t), r) / r;
  if (!r)
    return xM;
  function o(s, a) {
    i > 0 ? a < -qa + sr && (a = -qa + sr) : a > qa - sr && (a = qa - sr);
    var A = i / hJ(RP(a), r);
    return [A * $n(r * s), i - A * nr(r * s)];
  }
  return o.invert = function(s, a) {
    var A = i - a, l = ZT(r) * pA(s * s + A * A);
    return [Kc(s, oo(A)) / r * ZT(A), 2 * Hw(hJ(i / l, 1 / r)) - qa];
  }, o;
}
function c2n() {
  return iue(f7e).scale(109.5).parallels([30, 30]);
}
function nN(t, e) {
  return [t, e];
}
nN.invert = nN;
function u2n() {
  return tm(nN).scale(152.63);
}
function g7e(t, e) {
  var n = nr(t), r = t === e ? $n(t) : (n - nr(e)) / (e - t), i = n / r + t;
  if (oo(r) < sr)
    return nN;
  function o(s, a) {
    var A = i - a, l = r * s;
    return [A * $n(l), i - A * nr(l)];
  }
  return o.invert = function(s, a) {
    var A = i - a;
    return [Kc(s, oo(A)) / r * ZT(A), i - ZT(r) * pA(s * s + A * A)];
  }, o;
}
function f2n() {
  return iue(g7e).scale(131.154).center([0, 13.9389]);
}
function aue(t, e) {
  var n = nr(e), r = nr(t) * n;
  return [n * $n(t) / r, $n(e) / r];
}
aue.invert = wM(Hw);
function g2n() {
  return tm(aue).scale(144.049).clipAngle(60);
}
function DP(t, e, n, r) {
  return t === 1 && e === 1 && n === 0 && r === 0 ? Rv : L$({
    point: function(i, o) {
      this.stream.point(i * t + n, o * e + r);
    }
  });
}
function h2n() {
  var t = 1, e = 0, n = 0, r = 1, i = 1, o = Rv, s = null, a, A, l, c = Rv, u, f, h;
  function d() {
    return u = f = null, h;
  }
  return h = {
    stream: function(I) {
      return u && f === I ? u : u = o(c(f = I));
    },
    clipExtent: function(I) {
      return arguments.length ? (c = I == null ? (s = a = A = l = null, Rv) : tue(s = +I[0][0], a = +I[0][1], A = +I[1][0], l = +I[1][1]), d()) : s == null ? null : [[s, a], [A, l]];
    },
    scale: function(I) {
      return arguments.length ? (o = DP((t = +I) * r, t * i, e, n), d()) : t;
    },
    translate: function(I) {
      return arguments.length ? (o = DP(t * r, t * i, e = +I[0], n = +I[1]), d()) : [e, n];
    },
    reflectX: function(I) {
      return arguments.length ? (o = DP(t * (r = I ? -1 : 1), t * i, e, n), d()) : r < 0;
    },
    reflectY: function(I) {
      return arguments.length ? (o = DP(t * r, t * (i = I ? -1 : 1), e, n), d()) : i < 0;
    },
    fitExtent: function(I, m) {
      return M$(h, I, m);
    },
    fitSize: function(I, m) {
      return nue(h, I, m);
    }
  };
}
function Aue(t, e) {
  var n = e * e, r = n * n;
  return [
    t * (0.8707 - 0.131979 * n + r * (-0.013791 + r * (3971e-6 * n - 1529e-6 * r))),
    e * (1.007226 + n * (0.015085 + r * (-0.044475 + 0.028874 * n - 5916e-6 * r)))
  ];
}
Aue.invert = function(t, e) {
  var n = e, r = 25, i;
  do {
    var o = n * n, s = o * o;
    n -= i = (n * (1.007226 + o * (0.015085 + s * (-0.044475 + 0.028874 * o - 5916e-6 * s))) - e) / (1.007226 + o * (0.015085 * 3 + s * (-0.044475 * 7 + 0.028874 * 9 * o - 5916e-6 * 11 * s)));
  } while (oo(i) > sr && --r > 0);
  return [
    t / (0.8707 + (o = n * n) * (-0.131979 + o * (-0.013791 + o * o * o * (3971e-6 - 1529e-6 * o)))),
    n
  ];
};
function d2n() {
  return tm(Aue).scale(175.295);
}
function lue(t, e) {
  return [nr(e) * $n(t), $n(e)];
}
lue.invert = wM(kf);
function p2n() {
  return tm(lue).scale(249.5).clipAngle(90 + sr);
}
function cue(t, e) {
  var n = nr(e), r = 1 + nr(t) * n;
  return [n * $n(t) / r, $n(e) / r];
}
cue.invert = wM(function(t) {
  return 2 * Hw(t);
});
function I2n() {
  return tm(cue).scale(250).clipAngle(142);
}
function uue(t, e) {
  return [VU(Xce((qa + e) / 2)), -t];
}
uue.invert = function(t, e) {
  return [-e, 2 * Hw(Qze(t)) - qa];
};
function m2n() {
  var t = u7e(uue), e = t.center, n = t.rotate;
  return t.center = function(r) {
    return arguments.length ? e([-r[1], r[0]]) : (r = e(), [r[1], -r[0]]);
  }, t.rotate = function(r) {
    return arguments.length ? n([r[0], r[1], r.length > 2 ? r[2] + 90 : 90]) : (r = n(), [r[0], r[1], r[2] - 90]);
  }, n([0, 0, 90]).scale(159.155);
}
const C2n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  geoAlbers: l7e,
  geoAlbersUsa: s2n,
  geoArea: uxn,
  geoAzimuthalEqualArea: a2n,
  geoAzimuthalEqualAreaRaw: oue,
  geoAzimuthalEquidistant: A2n,
  geoAzimuthalEquidistantRaw: sue,
  geoBounds: dxn,
  geoCentroid: yxn,
  geoCircle: vxn,
  geoClipExtent: Sxn,
  geoConicConformal: c2n,
  geoConicConformalRaw: f7e,
  geoConicEqualArea: g8,
  geoConicEqualAreaRaw: A7e,
  geoConicEquidistant: f2n,
  geoConicEquidistantRaw: g7e,
  geoContains: Nxn,
  geoDistance: wD,
  geoEquirectangular: u2n,
  geoEquirectangularRaw: nN,
  geoGnomonic: g2n,
  geoGnomonicRaw: aue,
  geoGraticule: Jze,
  geoGraticule10: Lxn,
  geoIdentity: h2n,
  geoInterpolate: Mxn,
  geoLength: zze,
  geoMercator: l2n,
  geoMercatorRaw: xM,
  geoNaturalEarth1: d2n,
  geoNaturalEarth1Raw: Aue,
  geoOrthographic: p2n,
  geoOrthographicRaw: lue,
  geoPath: Yxn,
  geoProjection: tm,
  geoProjectionMutator: rue,
  geoRotation: Gze,
  geoStereographic: I2n,
  geoStereographicRaw: cue,
  geoStream: Mh,
  geoTransform: Zxn,
  geoTransverseMercator: m2n,
  geoTransverseMercatorRaw: uue
}, Symbol.toStringTag, { value: "Module" })), E2n = /* @__PURE__ */ Fs(C2n);
var y2n = Uw, CJ = axn, zk = Do, v2n = E2n, lv = ar;
function B2n(t) {
  return t && typeof t == "object" && "default" in t ? t : { default: t };
}
var b2n = /* @__PURE__ */ B2n(y2n);
function h7e(t, e, n) {
  n = n || {};
  var r = n.units || "kilometers", i = n.steps || 8;
  if (!t)
    throw new Error("geojson is required");
  if (typeof n != "object")
    throw new Error("options must be an object");
  if (typeof i != "number")
    throw new Error("steps must be an number");
  if (e === void 0)
    throw new Error("radius is required");
  if (i <= 0)
    throw new Error("steps must be greater than 0");
  var o = [];
  switch (t.type) {
    case "GeometryCollection":
      return zk.geomEach(t, function(s) {
        var a = Vk(s, e, r, i);
        a && o.push(a);
      }), lv.featureCollection(o);
    case "FeatureCollection":
      return zk.featureEach(t, function(s) {
        var a = Vk(s, e, r, i);
        a && zk.featureEach(a, function(A) {
          A && o.push(A);
        });
      }), lv.featureCollection(o);
  }
  return Vk(t, e, r, i);
}
function Vk(t, e, n, r) {
  var i = t.properties || {}, o = t.type === "Feature" ? t.geometry : t;
  if (o.type === "GeometryCollection") {
    var s = [];
    return zk.geomEach(t, function(I) {
      var m = Vk(I, e, n, r);
      m && s.push(m);
    }), lv.featureCollection(s);
  }
  var a = _2n(o), A = {
    type: o.type,
    coordinates: p7e(o.coordinates, a)
  }, l = new CJ.GeoJSONReader(), c = l.read(A), u = lv.radiansToLength(lv.lengthToRadians(e, n), "meters"), f = CJ.BufferOp.bufferOp(c, u, r), h = new CJ.GeoJSONWriter();
  if (f = h.write(f), !d7e(f.coordinates)) {
    var d = {
      type: f.type,
      coordinates: I7e(f.coordinates, a)
    };
    return lv.feature(d, i);
  }
}
function d7e(t) {
  return Array.isArray(t[0]) ? d7e(t[0]) : isNaN(t[0]);
}
function p7e(t, e) {
  return typeof t[0] != "object" ? e(t) : t.map(function(n) {
    return p7e(n, e);
  });
}
function I7e(t, e) {
  return typeof t[0] != "object" ? e.invert(t) : t.map(function(n) {
    return I7e(n, e);
  });
}
function _2n(t) {
  var e = b2n.default(t).geometry.coordinates, n = [-e[0], -e[1]];
  return v2n.geoAzimuthalEquidistant().rotate(n).scale(lv.earthRadius);
}
Wce.exports = h7e;
Wce.exports.default = h7e;
var fue = Wce.exports, gue = { exports: {} }, m7e = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ei, function() {
    function n(Ee, oe) {
      if (!(Ee instanceof oe))
        throw new TypeError("Cannot call a class as a function");
    }
    function r(Ee, oe) {
      for (var ie = 0; ie < oe.length; ie++) {
        var Ae = oe[ie];
        Ae.enumerable = Ae.enumerable || !1, Ae.configurable = !0, "value" in Ae && (Ae.writable = !0), Object.defineProperty(Ee, Ae.key, Ae);
      }
    }
    function i(Ee, oe, ie) {
      return oe && r(Ee.prototype, oe), ie && r(Ee, ie), Ee;
    }
    /**
     * splaytree v3.1.0
     * Fast Splay tree for Node and browser
     *
     * @author Alexander Milevski <info@w8r.name>
     * @license MIT
     * @preserve
     */
    var o = (
      /** @class */
      function() {
        function Ee(oe, ie) {
          this.next = null, this.key = oe, this.data = ie, this.left = null, this.right = null;
        }
        return Ee;
      }()
    );
    function s(Ee, oe) {
      return Ee > oe ? 1 : Ee < oe ? -1 : 0;
    }
    function a(Ee, oe, ie) {
      for (var Ae = new o(null, null), de = Ae, we = Ae; ; ) {
        var Pe = ie(Ee, oe.key);
        if (Pe < 0) {
          if (oe.left === null)
            break;
          if (ie(Ee, oe.left.key) < 0) {
            var qe = oe.left;
            if (oe.left = qe.right, qe.right = oe, oe = qe, oe.left === null)
              break;
          }
          we.left = oe, we = oe, oe = oe.left;
        } else if (Pe > 0) {
          if (oe.right === null)
            break;
          if (ie(Ee, oe.right.key) > 0) {
            var qe = oe.right;
            if (oe.right = qe.left, qe.left = oe, oe = qe, oe.right === null)
              break;
          }
          de.right = oe, de = oe, oe = oe.right;
        } else
          break;
      }
      return de.right = oe.left, we.left = oe.right, oe.left = Ae.right, oe.right = Ae.left, oe;
    }
    function A(Ee, oe, ie, Ae) {
      var de = new o(Ee, oe);
      if (ie === null)
        return de.left = de.right = null, de;
      ie = a(Ee, ie, Ae);
      var we = Ae(Ee, ie.key);
      return we < 0 ? (de.left = ie.left, de.right = ie, ie.left = null) : we >= 0 && (de.right = ie.right, de.left = ie, ie.right = null), de;
    }
    function l(Ee, oe, ie) {
      var Ae = null, de = null;
      if (oe) {
        oe = a(Ee, oe, ie);
        var we = ie(oe.key, Ee);
        we === 0 ? (Ae = oe.left, de = oe.right) : we < 0 ? (de = oe.right, oe.right = null, Ae = oe) : (Ae = oe.left, oe.left = null, de = oe);
      }
      return {
        left: Ae,
        right: de
      };
    }
    function c(Ee, oe, ie) {
      return oe === null ? Ee : (Ee === null || (oe = a(Ee.key, oe, ie), oe.left = Ee), oe);
    }
    function u(Ee, oe, ie, Ae, de) {
      if (Ee) {
        Ae("" + oe + (ie ? "└── " : "├── ") + de(Ee) + `
`);
        var we = oe + (ie ? "    " : "│   ");
        Ee.left && u(Ee.left, we, !1, Ae, de), Ee.right && u(Ee.right, we, !0, Ae, de);
      }
    }
    var f = (
      /** @class */
      function() {
        function Ee(oe) {
          oe === void 0 && (oe = s), this._root = null, this._size = 0, this._comparator = oe;
        }
        return Ee.prototype.insert = function(oe, ie) {
          return this._size++, this._root = A(oe, ie, this._root, this._comparator);
        }, Ee.prototype.add = function(oe, ie) {
          var Ae = new o(oe, ie);
          this._root === null && (Ae.left = Ae.right = null, this._size++, this._root = Ae);
          var de = this._comparator, we = a(oe, this._root, de), Pe = de(oe, we.key);
          return Pe === 0 ? this._root = we : (Pe < 0 ? (Ae.left = we.left, Ae.right = we, we.left = null) : Pe > 0 && (Ae.right = we.right, Ae.left = we, we.right = null), this._size++, this._root = Ae), this._root;
        }, Ee.prototype.remove = function(oe) {
          this._root = this._remove(oe, this._root, this._comparator);
        }, Ee.prototype._remove = function(oe, ie, Ae) {
          var de;
          if (ie === null)
            return null;
          ie = a(oe, ie, Ae);
          var we = Ae(oe, ie.key);
          return we === 0 ? (ie.left === null ? de = ie.right : (de = a(oe, ie.left, Ae), de.right = ie.right), this._size--, de) : ie;
        }, Ee.prototype.pop = function() {
          var oe = this._root;
          if (oe) {
            for (; oe.left; )
              oe = oe.left;
            return this._root = a(oe.key, this._root, this._comparator), this._root = this._remove(oe.key, this._root, this._comparator), {
              key: oe.key,
              data: oe.data
            };
          }
          return null;
        }, Ee.prototype.findStatic = function(oe) {
          for (var ie = this._root, Ae = this._comparator; ie; ) {
            var de = Ae(oe, ie.key);
            if (de === 0)
              return ie;
            de < 0 ? ie = ie.left : ie = ie.right;
          }
          return null;
        }, Ee.prototype.find = function(oe) {
          return this._root && (this._root = a(oe, this._root, this._comparator), this._comparator(oe, this._root.key) !== 0) ? null : this._root;
        }, Ee.prototype.contains = function(oe) {
          for (var ie = this._root, Ae = this._comparator; ie; ) {
            var de = Ae(oe, ie.key);
            if (de === 0)
              return !0;
            de < 0 ? ie = ie.left : ie = ie.right;
          }
          return !1;
        }, Ee.prototype.forEach = function(oe, ie) {
          for (var Ae = this._root, de = [], we = !1; !we; )
            Ae !== null ? (de.push(Ae), Ae = Ae.left) : de.length !== 0 ? (Ae = de.pop(), oe.call(ie, Ae), Ae = Ae.right) : we = !0;
          return this;
        }, Ee.prototype.range = function(oe, ie, Ae, de) {
          for (var we = [], Pe = this._comparator, qe = this._root, ke; we.length !== 0 || qe; )
            if (qe)
              we.push(qe), qe = qe.left;
            else {
              if (qe = we.pop(), ke = Pe(qe.key, ie), ke > 0)
                break;
              if (Pe(qe.key, oe) >= 0 && Ae.call(de, qe))
                return this;
              qe = qe.right;
            }
          return this;
        }, Ee.prototype.keys = function() {
          var oe = [];
          return this.forEach(function(ie) {
            var Ae = ie.key;
            return oe.push(Ae);
          }), oe;
        }, Ee.prototype.values = function() {
          var oe = [];
          return this.forEach(function(ie) {
            var Ae = ie.data;
            return oe.push(Ae);
          }), oe;
        }, Ee.prototype.min = function() {
          return this._root ? this.minNode(this._root).key : null;
        }, Ee.prototype.max = function() {
          return this._root ? this.maxNode(this._root).key : null;
        }, Ee.prototype.minNode = function(oe) {
          if (oe === void 0 && (oe = this._root), oe)
            for (; oe.left; )
              oe = oe.left;
          return oe;
        }, Ee.prototype.maxNode = function(oe) {
          if (oe === void 0 && (oe = this._root), oe)
            for (; oe.right; )
              oe = oe.right;
          return oe;
        }, Ee.prototype.at = function(oe) {
          for (var ie = this._root, Ae = !1, de = 0, we = []; !Ae; )
            if (ie)
              we.push(ie), ie = ie.left;
            else if (we.length > 0) {
              if (ie = we.pop(), de === oe)
                return ie;
              de++, ie = ie.right;
            } else
              Ae = !0;
          return null;
        }, Ee.prototype.next = function(oe) {
          var ie = this._root, Ae = null;
          if (oe.right) {
            for (Ae = oe.right; Ae.left; )
              Ae = Ae.left;
            return Ae;
          }
          for (var de = this._comparator; ie; ) {
            var we = de(oe.key, ie.key);
            if (we === 0)
              break;
            we < 0 ? (Ae = ie, ie = ie.left) : ie = ie.right;
          }
          return Ae;
        }, Ee.prototype.prev = function(oe) {
          var ie = this._root, Ae = null;
          if (oe.left !== null) {
            for (Ae = oe.left; Ae.right; )
              Ae = Ae.right;
            return Ae;
          }
          for (var de = this._comparator; ie; ) {
            var we = de(oe.key, ie.key);
            if (we === 0)
              break;
            we < 0 ? ie = ie.left : (Ae = ie, ie = ie.right);
          }
          return Ae;
        }, Ee.prototype.clear = function() {
          return this._root = null, this._size = 0, this;
        }, Ee.prototype.toList = function() {
          return I(this._root);
        }, Ee.prototype.load = function(oe, ie, Ae) {
          ie === void 0 && (ie = []), Ae === void 0 && (Ae = !1);
          var de = oe.length, we = this._comparator;
          if (Ae && y(oe, ie, 0, de - 1, we), this._root === null)
            this._root = h(oe, ie, 0, de), this._size = de;
          else {
            var Pe = C(this.toList(), d(oe, ie), we);
            de = this._size + de, this._root = m({
              head: Pe
            }, 0, de);
          }
          return this;
        }, Ee.prototype.isEmpty = function() {
          return this._root === null;
        }, Object.defineProperty(Ee.prototype, "size", {
          get: function() {
            return this._size;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(Ee.prototype, "root", {
          get: function() {
            return this._root;
          },
          enumerable: !0,
          configurable: !0
        }), Ee.prototype.toString = function(oe) {
          oe === void 0 && (oe = function(de) {
            return String(de.key);
          });
          var ie = [];
          return u(this._root, "", !0, function(Ae) {
            return ie.push(Ae);
          }, oe), ie.join("");
        }, Ee.prototype.update = function(oe, ie, Ae) {
          var de = this._comparator, we = l(oe, this._root, de), Pe = we.left, qe = we.right;
          de(oe, ie) < 0 ? qe = A(ie, Ae, qe, de) : Pe = A(ie, Ae, Pe, de), this._root = c(Pe, qe, de);
        }, Ee.prototype.split = function(oe) {
          return l(oe, this._root, this._comparator);
        }, Ee;
      }()
    );
    function h(Ee, oe, ie, Ae) {
      var de = Ae - ie;
      if (de > 0) {
        var we = ie + Math.floor(de / 2), Pe = Ee[we], qe = oe[we], ke = new o(Pe, qe);
        return ke.left = h(Ee, oe, ie, we), ke.right = h(Ee, oe, we + 1, Ae), ke;
      }
      return null;
    }
    function d(Ee, oe) {
      for (var ie = new o(null, null), Ae = ie, de = 0; de < Ee.length; de++)
        Ae = Ae.next = new o(Ee[de], oe[de]);
      return Ae.next = null, ie.next;
    }
    function I(Ee) {
      for (var oe = Ee, ie = [], Ae = !1, de = new o(null, null), we = de; !Ae; )
        oe ? (ie.push(oe), oe = oe.left) : ie.length > 0 ? (oe = we = we.next = ie.pop(), oe = oe.right) : Ae = !0;
      return we.next = null, de.next;
    }
    function m(Ee, oe, ie) {
      var Ae = ie - oe;
      if (Ae > 0) {
        var de = oe + Math.floor(Ae / 2), we = m(Ee, oe, de), Pe = Ee.head;
        return Pe.left = we, Ee.head = Ee.head.next, Pe.right = m(Ee, de + 1, ie), Pe;
      }
      return null;
    }
    function C(Ee, oe, ie) {
      for (var Ae = new o(null, null), de = Ae, we = Ee, Pe = oe; we !== null && Pe !== null; )
        ie(we.key, Pe.key) < 0 ? (de.next = we, we = we.next) : (de.next = Pe, Pe = Pe.next), de = de.next;
      return we !== null ? de.next = we : Pe !== null && (de.next = Pe), Ae.next;
    }
    function y(Ee, oe, ie, Ae, de) {
      if (!(ie >= Ae)) {
        for (var we = Ee[ie + Ae >> 1], Pe = ie - 1, qe = Ae + 1; ; ) {
          do
            Pe++;
          while (de(Ee[Pe], we) < 0);
          do
            qe--;
          while (de(Ee[qe], we) > 0);
          if (Pe >= qe)
            break;
          var ke = Ee[Pe];
          Ee[Pe] = Ee[qe], Ee[qe] = ke, ke = oe[Pe], oe[Pe] = oe[qe], oe[qe] = ke;
        }
        y(Ee, oe, ie, qe, de), y(Ee, oe, qe + 1, Ae, de);
      }
    }
    var v = function(oe, ie) {
      return oe.ll.x <= ie.x && ie.x <= oe.ur.x && oe.ll.y <= ie.y && ie.y <= oe.ur.y;
    }, b = function(oe, ie) {
      if (ie.ur.x < oe.ll.x || oe.ur.x < ie.ll.x || ie.ur.y < oe.ll.y || oe.ur.y < ie.ll.y)
        return null;
      var Ae = oe.ll.x < ie.ll.x ? ie.ll.x : oe.ll.x, de = oe.ur.x < ie.ur.x ? oe.ur.x : ie.ur.x, we = oe.ll.y < ie.ll.y ? ie.ll.y : oe.ll.y, Pe = oe.ur.y < ie.ur.y ? oe.ur.y : ie.ur.y;
      return {
        ll: {
          x: Ae,
          y: we
        },
        ur: {
          x: de,
          y: Pe
        }
      };
    }, Q = Number.EPSILON;
    Q === void 0 && (Q = Math.pow(2, -52));
    var w = Q * Q, R = function(oe, ie) {
      if (-Q < oe && oe < Q && -Q < ie && ie < Q)
        return 0;
      var Ae = oe - ie;
      return Ae * Ae < w * oe * ie ? 0 : oe < ie ? -1 : 1;
    }, M = /* @__PURE__ */ function() {
      function Ee() {
        n(this, Ee), this.reset();
      }
      return i(Ee, [{
        key: "reset",
        value: function() {
          this.xRounder = new O(), this.yRounder = new O();
        }
      }, {
        key: "round",
        value: function(ie, Ae) {
          return {
            x: this.xRounder.round(ie),
            y: this.yRounder.round(Ae)
          };
        }
      }]), Ee;
    }(), O = /* @__PURE__ */ function() {
      function Ee() {
        n(this, Ee), this.tree = new f(), this.round(0);
      }
      return i(Ee, [{
        key: "round",
        value: function(ie) {
          var Ae = this.tree.add(ie), de = this.tree.prev(Ae);
          if (de !== null && R(Ae.key, de.key) === 0)
            return this.tree.remove(ie), de.key;
          var we = this.tree.next(Ae);
          return we !== null && R(Ae.key, we.key) === 0 ? (this.tree.remove(ie), we.key) : ie;
        }
      }]), Ee;
    }(), L = new M(), N = function(oe, ie) {
      return oe.x * ie.y - oe.y * ie.x;
    }, k = function(oe, ie) {
      return oe.x * ie.x + oe.y * ie.y;
    }, $ = function(oe, ie, Ae) {
      var de = {
        x: ie.x - oe.x,
        y: ie.y - oe.y
      }, we = {
        x: Ae.x - oe.x,
        y: Ae.y - oe.y
      }, Pe = N(de, we);
      return R(Pe, 0);
    }, U = function(oe) {
      return Math.sqrt(k(oe, oe));
    }, X = function(oe, ie, Ae) {
      var de = {
        x: ie.x - oe.x,
        y: ie.y - oe.y
      }, we = {
        x: Ae.x - oe.x,
        y: Ae.y - oe.y
      };
      return N(we, de) / U(we) / U(de);
    }, K = function(oe, ie, Ae) {
      var de = {
        x: ie.x - oe.x,
        y: ie.y - oe.y
      }, we = {
        x: Ae.x - oe.x,
        y: Ae.y - oe.y
      };
      return k(we, de) / U(we) / U(de);
    }, z = function(oe, ie, Ae) {
      return ie.y === 0 ? null : {
        x: oe.x + ie.x / ie.y * (Ae - oe.y),
        y: Ae
      };
    }, Y = function(oe, ie, Ae) {
      return ie.x === 0 ? null : {
        x: Ae,
        y: oe.y + ie.y / ie.x * (Ae - oe.x)
      };
    }, V = function(oe, ie, Ae, de) {
      if (ie.x === 0)
        return Y(Ae, de, oe.x);
      if (de.x === 0)
        return Y(oe, ie, Ae.x);
      if (ie.y === 0)
        return z(Ae, de, oe.y);
      if (de.y === 0)
        return z(oe, ie, Ae.y);
      var we = N(ie, de);
      if (we == 0)
        return null;
      var Pe = {
        x: Ae.x - oe.x,
        y: Ae.y - oe.y
      }, qe = N(Pe, ie) / we, ke = N(Pe, de) / we, Xe = oe.x + ke * ie.x, rt = Ae.x + qe * de.x, it = oe.y + ke * ie.y, ht = Ae.y + qe * de.y, mt = (Xe + rt) / 2, _t = (it + ht) / 2;
      return {
        x: mt,
        y: _t
      };
    }, Z = /* @__PURE__ */ function() {
      i(Ee, null, [{
        key: "compare",
        // for ordering sweep events in the sweep event queue
        value: function(ie, Ae) {
          var de = Ee.comparePoints(ie.point, Ae.point);
          return de !== 0 ? de : (ie.point !== Ae.point && ie.link(Ae), ie.isLeft !== Ae.isLeft ? ie.isLeft ? 1 : -1 : ee.compare(ie.segment, Ae.segment));
        }
        // for ordering points in sweep line order
      }, {
        key: "comparePoints",
        value: function(ie, Ae) {
          return ie.x < Ae.x ? -1 : ie.x > Ae.x ? 1 : ie.y < Ae.y ? -1 : ie.y > Ae.y ? 1 : 0;
        }
        // Warning: 'point' input will be modified and re-used (for performance)
      }]);
      function Ee(oe, ie) {
        n(this, Ee), oe.events === void 0 ? oe.events = [this] : oe.events.push(this), this.point = oe, this.isLeft = ie;
      }
      return i(Ee, [{
        key: "link",
        value: function(ie) {
          if (ie.point === this.point)
            throw new Error("Tried to link already linked events");
          for (var Ae = ie.point.events, de = 0, we = Ae.length; de < we; de++) {
            var Pe = Ae[de];
            this.point.events.push(Pe), Pe.point = this.point;
          }
          this.checkForConsuming();
        }
        /* Do a pass over our linked events and check to see if any pair
         * of segments match, and should be consumed. */
      }, {
        key: "checkForConsuming",
        value: function() {
          for (var ie = this.point.events.length, Ae = 0; Ae < ie; Ae++) {
            var de = this.point.events[Ae];
            if (de.segment.consumedBy === void 0)
              for (var we = Ae + 1; we < ie; we++) {
                var Pe = this.point.events[we];
                Pe.consumedBy === void 0 && de.otherSE.point.events === Pe.otherSE.point.events && de.segment.consume(Pe.segment);
              }
          }
        }
      }, {
        key: "getAvailableLinkedEvents",
        value: function() {
          for (var ie = [], Ae = 0, de = this.point.events.length; Ae < de; Ae++) {
            var we = this.point.events[Ae];
            we !== this && !we.segment.ringOut && we.segment.isInResult() && ie.push(we);
          }
          return ie;
        }
        /**
         * Returns a comparator function for sorting linked events that will
         * favor the event that will give us the smallest left-side angle.
         * All ring construction starts as low as possible heading to the right,
         * so by always turning left as sharp as possible we'll get polygons
         * without uncessary loops & holes.
         *
         * The comparator function has a compute cache such that it avoids
         * re-computing already-computed values.
         */
      }, {
        key: "getLeftmostComparator",
        value: function(ie) {
          var Ae = this, de = /* @__PURE__ */ new Map(), we = function(qe) {
            var ke = qe.otherSE;
            de.set(qe, {
              sine: X(Ae.point, ie.point, ke.point),
              cosine: K(Ae.point, ie.point, ke.point)
            });
          };
          return function(Pe, qe) {
            de.has(Pe) || we(Pe), de.has(qe) || we(qe);
            var ke = de.get(Pe), Xe = ke.sine, rt = ke.cosine, it = de.get(qe), ht = it.sine, mt = it.cosine;
            return Xe >= 0 && ht >= 0 ? rt < mt ? 1 : rt > mt ? -1 : 0 : Xe < 0 && ht < 0 ? rt < mt ? -1 : rt > mt ? 1 : 0 : ht < Xe ? -1 : ht > Xe ? 1 : 0;
          };
        }
      }]), Ee;
    }(), ce = 0, ee = /* @__PURE__ */ function() {
      i(Ee, null, [{
        key: "compare",
        /* This compare() function is for ordering segments in the sweep
         * line tree, and does so according to the following criteria:
         *
         * Consider the vertical line that lies an infinestimal step to the
         * right of the right-more of the two left endpoints of the input
         * segments. Imagine slowly moving a point up from negative infinity
         * in the increasing y direction. Which of the two segments will that
         * point intersect first? That segment comes 'before' the other one.
         *
         * If neither segment would be intersected by such a line, (if one
         * or more of the segments are vertical) then the line to be considered
         * is directly on the right-more of the two left inputs.
         */
        value: function(ie, Ae) {
          var de = ie.leftSE.point.x, we = Ae.leftSE.point.x, Pe = ie.rightSE.point.x, qe = Ae.rightSE.point.x;
          if (qe < de)
            return 1;
          if (Pe < we)
            return -1;
          var ke = ie.leftSE.point.y, Xe = Ae.leftSE.point.y, rt = ie.rightSE.point.y, it = Ae.rightSE.point.y;
          if (de < we) {
            if (Xe < ke && Xe < rt)
              return 1;
            if (Xe > ke && Xe > rt)
              return -1;
            var ht = ie.comparePoint(Ae.leftSE.point);
            if (ht < 0)
              return 1;
            if (ht > 0)
              return -1;
            var mt = Ae.comparePoint(ie.rightSE.point);
            return mt !== 0 ? mt : -1;
          }
          if (de > we) {
            if (ke < Xe && ke < it)
              return -1;
            if (ke > Xe && ke > it)
              return 1;
            var _t = Ae.comparePoint(ie.leftSE.point);
            if (_t !== 0)
              return _t;
            var Ct = ie.comparePoint(Ae.rightSE.point);
            return Ct < 0 ? 1 : Ct > 0 ? -1 : 1;
          }
          if (ke < Xe)
            return -1;
          if (ke > Xe)
            return 1;
          if (Pe < qe) {
            var zt = Ae.comparePoint(ie.rightSE.point);
            if (zt !== 0)
              return zt;
          }
          if (Pe > qe) {
            var jt = ie.comparePoint(Ae.rightSE.point);
            if (jt < 0)
              return 1;
            if (jt > 0)
              return -1;
          }
          if (Pe !== qe) {
            var lt = rt - ke, Ht = Pe - de, vt = it - Xe, It = qe - we;
            if (lt > Ht && vt < It)
              return 1;
            if (lt < Ht && vt > It)
              return -1;
          }
          return Pe > qe ? 1 : Pe < qe || rt < it ? -1 : rt > it ? 1 : ie.id < Ae.id ? -1 : ie.id > Ae.id ? 1 : 0;
        }
        /* Warning: a reference to ringWindings input will be stored,
         *  and possibly will be later modified */
      }]);
      function Ee(oe, ie, Ae, de) {
        n(this, Ee), this.id = ++ce, this.leftSE = oe, oe.segment = this, oe.otherSE = ie, this.rightSE = ie, ie.segment = this, ie.otherSE = oe, this.rings = Ae, this.windings = de;
      }
      return i(Ee, [{
        key: "replaceRightSE",
        /* When a segment is split, the rightSE is replaced with a new sweep event */
        value: function(ie) {
          this.rightSE = ie, this.rightSE.segment = this, this.rightSE.otherSE = this.leftSE, this.leftSE.otherSE = this.rightSE;
        }
      }, {
        key: "bbox",
        value: function() {
          var ie = this.leftSE.point.y, Ae = this.rightSE.point.y;
          return {
            ll: {
              x: this.leftSE.point.x,
              y: ie < Ae ? ie : Ae
            },
            ur: {
              x: this.rightSE.point.x,
              y: ie > Ae ? ie : Ae
            }
          };
        }
        /* A vector from the left point to the right */
      }, {
        key: "vector",
        value: function() {
          return {
            x: this.rightSE.point.x - this.leftSE.point.x,
            y: this.rightSE.point.y - this.leftSE.point.y
          };
        }
      }, {
        key: "isAnEndpoint",
        value: function(ie) {
          return ie.x === this.leftSE.point.x && ie.y === this.leftSE.point.y || ie.x === this.rightSE.point.x && ie.y === this.rightSE.point.y;
        }
        /* Compare this segment with a point.
         *
         * A point P is considered to be colinear to a segment if there
         * exists a distance D such that if we travel along the segment
         * from one * endpoint towards the other a distance D, we find
         * ourselves at point P.
         *
         * Return value indicates:
         *
         *   1: point lies above the segment (to the left of vertical)
         *   0: point is colinear to segment
         *  -1: point lies below the segment (to the right of vertical)
         */
      }, {
        key: "comparePoint",
        value: function(ie) {
          if (this.isAnEndpoint(ie))
            return 0;
          var Ae = this.leftSE.point, de = this.rightSE.point, we = this.vector();
          if (Ae.x === de.x)
            return ie.x === Ae.x ? 0 : ie.x < Ae.x ? 1 : -1;
          var Pe = (ie.y - Ae.y) / we.y, qe = Ae.x + Pe * we.x;
          if (ie.x === qe)
            return 0;
          var ke = (ie.x - Ae.x) / we.x, Xe = Ae.y + ke * we.y;
          return ie.y === Xe ? 0 : ie.y < Xe ? -1 : 1;
        }
        /**
         * Given another segment, returns the first non-trivial intersection
         * between the two segments (in terms of sweep line ordering), if it exists.
         *
         * A 'non-trivial' intersection is one that will cause one or both of the
         * segments to be split(). As such, 'trivial' vs. 'non-trivial' intersection:
         *
         *   * endpoint of segA with endpoint of segB --> trivial
         *   * endpoint of segA with point along segB --> non-trivial
         *   * endpoint of segB with point along segA --> non-trivial
         *   * point along segA with point along segB --> non-trivial
         *
         * If no non-trivial intersection exists, return null
         * Else, return null.
         */
      }, {
        key: "getIntersection",
        value: function(ie) {
          var Ae = this.bbox(), de = ie.bbox(), we = b(Ae, de);
          if (we === null)
            return null;
          var Pe = this.leftSE.point, qe = this.rightSE.point, ke = ie.leftSE.point, Xe = ie.rightSE.point, rt = v(Ae, ke) && this.comparePoint(ke) === 0, it = v(de, Pe) && ie.comparePoint(Pe) === 0, ht = v(Ae, Xe) && this.comparePoint(Xe) === 0, mt = v(de, qe) && ie.comparePoint(qe) === 0;
          if (it && rt)
            return mt && !ht ? qe : !mt && ht ? Xe : null;
          if (it)
            return ht && Pe.x === Xe.x && Pe.y === Xe.y ? null : Pe;
          if (rt)
            return mt && qe.x === ke.x && qe.y === ke.y ? null : ke;
          if (mt && ht)
            return null;
          if (mt)
            return qe;
          if (ht)
            return Xe;
          var _t = V(Pe, this.vector(), ke, ie.vector());
          return _t === null || !v(we, _t) ? null : L.round(_t.x, _t.y);
        }
        /**
         * Split the given segment into multiple segments on the given points.
         *  * Each existing segment will retain its leftSE and a new rightSE will be
         *    generated for it.
         *  * A new segment will be generated which will adopt the original segment's
         *    rightSE, and a new leftSE will be generated for it.
         *  * If there are more than two points given to split on, new segments
         *    in the middle will be generated with new leftSE and rightSE's.
         *  * An array of the newly generated SweepEvents will be returned.
         *
         * Warning: input array of points is modified
         */
      }, {
        key: "split",
        value: function(ie) {
          var Ae = [], de = ie.events !== void 0, we = new Z(ie, !0), Pe = new Z(ie, !1), qe = this.rightSE;
          this.replaceRightSE(Pe), Ae.push(Pe), Ae.push(we);
          var ke = new Ee(we, qe, this.rings.slice(), this.windings.slice());
          return Z.comparePoints(ke.leftSE.point, ke.rightSE.point) > 0 && ke.swapEvents(), Z.comparePoints(this.leftSE.point, this.rightSE.point) > 0 && this.swapEvents(), de && (we.checkForConsuming(), Pe.checkForConsuming()), Ae;
        }
        /* Swap which event is left and right */
      }, {
        key: "swapEvents",
        value: function() {
          var ie = this.rightSE;
          this.rightSE = this.leftSE, this.leftSE = ie, this.leftSE.isLeft = !0, this.rightSE.isLeft = !1;
          for (var Ae = 0, de = this.windings.length; Ae < de; Ae++)
            this.windings[Ae] *= -1;
        }
        /* Consume another segment. We take their rings under our wing
         * and mark them as consumed. Use for perfectly overlapping segments */
      }, {
        key: "consume",
        value: function(ie) {
          for (var Ae = this, de = ie; Ae.consumedBy; )
            Ae = Ae.consumedBy;
          for (; de.consumedBy; )
            de = de.consumedBy;
          var we = Ee.compare(Ae, de);
          if (we !== 0) {
            if (we > 0) {
              var Pe = Ae;
              Ae = de, de = Pe;
            }
            if (Ae.prev === de) {
              var qe = Ae;
              Ae = de, de = qe;
            }
            for (var ke = 0, Xe = de.rings.length; ke < Xe; ke++) {
              var rt = de.rings[ke], it = de.windings[ke], ht = Ae.rings.indexOf(rt);
              ht === -1 ? (Ae.rings.push(rt), Ae.windings.push(it)) : Ae.windings[ht] += it;
            }
            de.rings = null, de.windings = null, de.consumedBy = Ae, de.leftSE.consumedBy = Ae.leftSE, de.rightSE.consumedBy = Ae.rightSE;
          }
        }
        /* The first segment previous segment chain that is in the result */
      }, {
        key: "prevInResult",
        value: function() {
          return this._prevInResult !== void 0 ? this._prevInResult : (this.prev ? this.prev.isInResult() ? this._prevInResult = this.prev : this._prevInResult = this.prev.prevInResult() : this._prevInResult = null, this._prevInResult);
        }
      }, {
        key: "beforeState",
        value: function() {
          if (this._beforeState !== void 0)
            return this._beforeState;
          if (!this.prev)
            this._beforeState = {
              rings: [],
              windings: [],
              multiPolys: []
            };
          else {
            var ie = this.prev.consumedBy || this.prev;
            this._beforeState = ie.afterState();
          }
          return this._beforeState;
        }
      }, {
        key: "afterState",
        value: function() {
          if (this._afterState !== void 0)
            return this._afterState;
          var ie = this.beforeState();
          this._afterState = {
            rings: ie.rings.slice(0),
            windings: ie.windings.slice(0),
            multiPolys: []
          };
          for (var Ae = this._afterState.rings, de = this._afterState.windings, we = this._afterState.multiPolys, Pe = 0, qe = this.rings.length; Pe < qe; Pe++) {
            var ke = this.rings[Pe], Xe = this.windings[Pe], rt = Ae.indexOf(ke);
            rt === -1 ? (Ae.push(ke), de.push(Xe)) : de[rt] += Xe;
          }
          for (var it = [], ht = [], mt = 0, _t = Ae.length; mt < _t; mt++)
            if (de[mt] !== 0) {
              var Ct = Ae[mt], zt = Ct.poly;
              if (ht.indexOf(zt) === -1)
                if (Ct.isExterior)
                  it.push(zt);
                else {
                  ht.indexOf(zt) === -1 && ht.push(zt);
                  var jt = it.indexOf(Ct.poly);
                  jt !== -1 && it.splice(jt, 1);
                }
            }
          for (var lt = 0, Ht = it.length; lt < Ht; lt++) {
            var vt = it[lt].multiPoly;
            we.indexOf(vt) === -1 && we.push(vt);
          }
          return this._afterState;
        }
        /* Is this segment part of the final result? */
      }, {
        key: "isInResult",
        value: function() {
          if (this.consumedBy)
            return !1;
          if (this._isInResult !== void 0)
            return this._isInResult;
          var ie = this.beforeState().multiPolys, Ae = this.afterState().multiPolys;
          switch (se.type) {
            case "union": {
              var de = ie.length === 0, we = Ae.length === 0;
              this._isInResult = de !== we;
              break;
            }
            case "intersection": {
              var Pe, qe;
              ie.length < Ae.length ? (Pe = ie.length, qe = Ae.length) : (Pe = Ae.length, qe = ie.length), this._isInResult = qe === se.numMultiPolys && Pe < qe;
              break;
            }
            case "xor": {
              var ke = Math.abs(ie.length - Ae.length);
              this._isInResult = ke % 2 === 1;
              break;
            }
            case "difference": {
              var Xe = function(it) {
                return it.length === 1 && it[0].isSubject;
              };
              this._isInResult = Xe(ie) !== Xe(Ae);
              break;
            }
            default:
              throw new Error("Unrecognized operation type found ".concat(se.type));
          }
          return this._isInResult;
        }
      }], [{
        key: "fromRing",
        value: function(ie, Ae, de) {
          var we, Pe, qe, ke = Z.comparePoints(ie, Ae);
          if (ke < 0)
            we = ie, Pe = Ae, qe = 1;
          else if (ke > 0)
            we = Ae, Pe = ie, qe = -1;
          else
            throw new Error("Tried to create degenerate segment at [".concat(ie.x, ", ").concat(ie.y, "]"));
          var Xe = new Z(we, !0), rt = new Z(Pe, !1);
          return new Ee(Xe, rt, [de], [qe]);
        }
      }]), Ee;
    }(), pe = /* @__PURE__ */ function() {
      function Ee(oe, ie, Ae) {
        if (n(this, Ee), !Array.isArray(oe) || oe.length === 0)
          throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        if (this.poly = ie, this.isExterior = Ae, this.segments = [], typeof oe[0][0] != "number" || typeof oe[0][1] != "number")
          throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        var de = L.round(oe[0][0], oe[0][1]);
        this.bbox = {
          ll: {
            x: de.x,
            y: de.y
          },
          ur: {
            x: de.x,
            y: de.y
          }
        };
        for (var we = de, Pe = 1, qe = oe.length; Pe < qe; Pe++) {
          if (typeof oe[Pe][0] != "number" || typeof oe[Pe][1] != "number")
            throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
          var ke = L.round(oe[Pe][0], oe[Pe][1]);
          ke.x === we.x && ke.y === we.y || (this.segments.push(ee.fromRing(we, ke, this)), ke.x < this.bbox.ll.x && (this.bbox.ll.x = ke.x), ke.y < this.bbox.ll.y && (this.bbox.ll.y = ke.y), ke.x > this.bbox.ur.x && (this.bbox.ur.x = ke.x), ke.y > this.bbox.ur.y && (this.bbox.ur.y = ke.y), we = ke);
        }
        (de.x !== we.x || de.y !== we.y) && this.segments.push(ee.fromRing(we, de, this));
      }
      return i(Ee, [{
        key: "getSweepEvents",
        value: function() {
          for (var ie = [], Ae = 0, de = this.segments.length; Ae < de; Ae++) {
            var we = this.segments[Ae];
            ie.push(we.leftSE), ie.push(we.rightSE);
          }
          return ie;
        }
      }]), Ee;
    }(), Ce = /* @__PURE__ */ function() {
      function Ee(oe, ie) {
        if (n(this, Ee), !Array.isArray(oe))
          throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        this.exteriorRing = new pe(oe[0], this, !0), this.bbox = {
          ll: {
            x: this.exteriorRing.bbox.ll.x,
            y: this.exteriorRing.bbox.ll.y
          },
          ur: {
            x: this.exteriorRing.bbox.ur.x,
            y: this.exteriorRing.bbox.ur.y
          }
        }, this.interiorRings = [];
        for (var Ae = 1, de = oe.length; Ae < de; Ae++) {
          var we = new pe(oe[Ae], this, !1);
          we.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = we.bbox.ll.x), we.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = we.bbox.ll.y), we.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = we.bbox.ur.x), we.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = we.bbox.ur.y), this.interiorRings.push(we);
        }
        this.multiPoly = ie;
      }
      return i(Ee, [{
        key: "getSweepEvents",
        value: function() {
          for (var ie = this.exteriorRing.getSweepEvents(), Ae = 0, de = this.interiorRings.length; Ae < de; Ae++)
            for (var we = this.interiorRings[Ae].getSweepEvents(), Pe = 0, qe = we.length; Pe < qe; Pe++)
              ie.push(we[Pe]);
          return ie;
        }
      }]), Ee;
    }(), Be = /* @__PURE__ */ function() {
      function Ee(oe, ie) {
        if (n(this, Ee), !Array.isArray(oe))
          throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        try {
          typeof oe[0][0][0] == "number" && (oe = [oe]);
        } catch {
        }
        this.polys = [], this.bbox = {
          ll: {
            x: Number.POSITIVE_INFINITY,
            y: Number.POSITIVE_INFINITY
          },
          ur: {
            x: Number.NEGATIVE_INFINITY,
            y: Number.NEGATIVE_INFINITY
          }
        };
        for (var Ae = 0, de = oe.length; Ae < de; Ae++) {
          var we = new Ce(oe[Ae], this);
          we.bbox.ll.x < this.bbox.ll.x && (this.bbox.ll.x = we.bbox.ll.x), we.bbox.ll.y < this.bbox.ll.y && (this.bbox.ll.y = we.bbox.ll.y), we.bbox.ur.x > this.bbox.ur.x && (this.bbox.ur.x = we.bbox.ur.x), we.bbox.ur.y > this.bbox.ur.y && (this.bbox.ur.y = we.bbox.ur.y), this.polys.push(we);
        }
        this.isSubject = ie;
      }
      return i(Ee, [{
        key: "getSweepEvents",
        value: function() {
          for (var ie = [], Ae = 0, de = this.polys.length; Ae < de; Ae++)
            for (var we = this.polys[Ae].getSweepEvents(), Pe = 0, qe = we.length; Pe < qe; Pe++)
              ie.push(we[Pe]);
          return ie;
        }
      }]), Ee;
    }(), Ie = /* @__PURE__ */ function() {
      i(Ee, null, [{
        key: "factory",
        /* Given the segments from the sweep line pass, compute & return a series
         * of closed rings from all the segments marked to be part of the result */
        value: function(ie) {
          for (var Ae = [], de = 0, we = ie.length; de < we; de++) {
            var Pe = ie[de];
            if (!(!Pe.isInResult() || Pe.ringOut)) {
              for (var qe = null, ke = Pe.leftSE, Xe = Pe.rightSE, rt = [ke], it = ke.point, ht = []; qe = ke, ke = Xe, rt.push(ke), ke.point !== it; )
                for (; ; ) {
                  var mt = ke.getAvailableLinkedEvents();
                  if (mt.length === 0) {
                    var _t = rt[0].point, Ct = rt[rt.length - 1].point;
                    throw new Error("Unable to complete output ring starting at [".concat(_t.x, ",") + " ".concat(_t.y, "]. Last matching segment found ends at") + " [".concat(Ct.x, ", ").concat(Ct.y, "]."));
                  }
                  if (mt.length === 1) {
                    Xe = mt[0].otherSE;
                    break;
                  }
                  for (var zt = null, jt = 0, lt = ht.length; jt < lt; jt++)
                    if (ht[jt].point === ke.point) {
                      zt = jt;
                      break;
                    }
                  if (zt !== null) {
                    var Ht = ht.splice(zt)[0], vt = rt.splice(Ht.index);
                    vt.unshift(vt[0].otherSE), Ae.push(new Ee(vt.reverse()));
                    continue;
                  }
                  ht.push({
                    index: rt.length,
                    point: ke.point
                  });
                  var It = ke.getLeftmostComparator(qe);
                  Xe = mt.sort(It)[0].otherSE;
                  break;
                }
              Ae.push(new Ee(rt));
            }
          }
          return Ae;
        }
      }]);
      function Ee(oe) {
        n(this, Ee), this.events = oe;
        for (var ie = 0, Ae = oe.length; ie < Ae; ie++)
          oe[ie].segment.ringOut = this;
        this.poly = null;
      }
      return i(Ee, [{
        key: "getGeom",
        value: function() {
          for (var ie = this.events[0].point, Ae = [ie], de = 1, we = this.events.length - 1; de < we; de++) {
            var Pe = this.events[de].point, qe = this.events[de + 1].point;
            $(Pe, ie, qe) !== 0 && (Ae.push(Pe), ie = Pe);
          }
          if (Ae.length === 1)
            return null;
          var ke = Ae[0], Xe = Ae[1];
          $(ke, ie, Xe) === 0 && Ae.shift(), Ae.push(Ae[0]);
          for (var rt = this.isExteriorRing() ? 1 : -1, it = this.isExteriorRing() ? 0 : Ae.length - 1, ht = this.isExteriorRing() ? Ae.length : -1, mt = [], _t = it; _t != ht; _t += rt)
            mt.push([Ae[_t].x, Ae[_t].y]);
          return mt;
        }
      }, {
        key: "isExteriorRing",
        value: function() {
          if (this._isExteriorRing === void 0) {
            var ie = this.enclosingRing();
            this._isExteriorRing = ie ? !ie.isExteriorRing() : !0;
          }
          return this._isExteriorRing;
        }
      }, {
        key: "enclosingRing",
        value: function() {
          return this._enclosingRing === void 0 && (this._enclosingRing = this._calcEnclosingRing()), this._enclosingRing;
        }
        /* Returns the ring that encloses this one, if any */
      }, {
        key: "_calcEnclosingRing",
        value: function() {
          for (var ie = this.events[0], Ae = 1, de = this.events.length; Ae < de; Ae++) {
            var we = this.events[Ae];
            Z.compare(ie, we) > 0 && (ie = we);
          }
          for (var Pe = ie.segment.prevInResult(), qe = Pe ? Pe.prevInResult() : null; ; ) {
            if (!Pe)
              return null;
            if (!qe)
              return Pe.ringOut;
            if (qe.ringOut !== Pe.ringOut)
              return qe.ringOut.enclosingRing() !== Pe.ringOut ? Pe.ringOut : Pe.ringOut.enclosingRing();
            Pe = qe.prevInResult(), qe = Pe ? Pe.prevInResult() : null;
          }
        }
      }]), Ee;
    }(), Qe = /* @__PURE__ */ function() {
      function Ee(oe) {
        n(this, Ee), this.exteriorRing = oe, oe.poly = this, this.interiorRings = [];
      }
      return i(Ee, [{
        key: "addInterior",
        value: function(ie) {
          this.interiorRings.push(ie), ie.poly = this;
        }
      }, {
        key: "getGeom",
        value: function() {
          var ie = [this.exteriorRing.getGeom()];
          if (ie[0] === null)
            return null;
          for (var Ae = 0, de = this.interiorRings.length; Ae < de; Ae++) {
            var we = this.interiorRings[Ae].getGeom();
            we !== null && ie.push(we);
          }
          return ie;
        }
      }]), Ee;
    }(), xe = /* @__PURE__ */ function() {
      function Ee(oe) {
        n(this, Ee), this.rings = oe, this.polys = this._composePolys(oe);
      }
      return i(Ee, [{
        key: "getGeom",
        value: function() {
          for (var ie = [], Ae = 0, de = this.polys.length; Ae < de; Ae++) {
            var we = this.polys[Ae].getGeom();
            we !== null && ie.push(we);
          }
          return ie;
        }
      }, {
        key: "_composePolys",
        value: function(ie) {
          for (var Ae = [], de = 0, we = ie.length; de < we; de++) {
            var Pe = ie[de];
            if (!Pe.poly)
              if (Pe.isExteriorRing())
                Ae.push(new Qe(Pe));
              else {
                var qe = Pe.enclosingRing();
                qe.poly || Ae.push(new Qe(qe)), qe.poly.addInterior(Pe);
              }
          }
          return Ae;
        }
      }]), Ee;
    }(), Se = /* @__PURE__ */ function() {
      function Ee(oe) {
        var ie = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ee.compare;
        n(this, Ee), this.queue = oe, this.tree = new f(ie), this.segments = [];
      }
      return i(Ee, [{
        key: "process",
        value: function(ie) {
          var Ae = ie.segment, de = [];
          if (ie.consumedBy)
            return ie.isLeft ? this.queue.remove(ie.otherSE) : this.tree.remove(Ae), de;
          var we = ie.isLeft ? this.tree.insert(Ae) : this.tree.find(Ae);
          if (!we)
            throw new Error("Unable to find segment #".concat(Ae.id, " ") + "[".concat(Ae.leftSE.point.x, ", ").concat(Ae.leftSE.point.y, "] -> ") + "[".concat(Ae.rightSE.point.x, ", ").concat(Ae.rightSE.point.y, "] ") + "in SweepLine tree. Please submit a bug report.");
          for (var Pe = we, qe = we, ke = void 0, Xe = void 0; ke === void 0; )
            Pe = this.tree.prev(Pe), Pe === null ? ke = null : Pe.key.consumedBy === void 0 && (ke = Pe.key);
          for (; Xe === void 0; )
            qe = this.tree.next(qe), qe === null ? Xe = null : qe.key.consumedBy === void 0 && (Xe = qe.key);
          if (ie.isLeft) {
            var rt = null;
            if (ke) {
              var it = ke.getIntersection(Ae);
              if (it !== null && (Ae.isAnEndpoint(it) || (rt = it), !ke.isAnEndpoint(it)))
                for (var ht = this._splitSafely(ke, it), mt = 0, _t = ht.length; mt < _t; mt++)
                  de.push(ht[mt]);
            }
            var Ct = null;
            if (Xe) {
              var zt = Xe.getIntersection(Ae);
              if (zt !== null && (Ae.isAnEndpoint(zt) || (Ct = zt), !Xe.isAnEndpoint(zt)))
                for (var jt = this._splitSafely(Xe, zt), lt = 0, Ht = jt.length; lt < Ht; lt++)
                  de.push(jt[lt]);
            }
            if (rt !== null || Ct !== null) {
              var vt = null;
              if (rt === null)
                vt = Ct;
              else if (Ct === null)
                vt = rt;
              else {
                var It = Z.comparePoints(rt, Ct);
                vt = It <= 0 ? rt : Ct;
              }
              this.queue.remove(Ae.rightSE), de.push(Ae.rightSE);
              for (var un = Ae.split(vt), hn = 0, We = un.length; hn < We; hn++)
                de.push(un[hn]);
            }
            de.length > 0 ? (this.tree.remove(Ae), de.push(ie)) : (this.segments.push(Ae), Ae.prev = ke);
          } else {
            if (ke && Xe) {
              var En = ke.getIntersection(Xe);
              if (En !== null) {
                if (!ke.isAnEndpoint(En))
                  for (var qn = this._splitSafely(ke, En), Pt = 0, dr = qn.length; Pt < dr; Pt++)
                    de.push(qn[Pt]);
                if (!Xe.isAnEndpoint(En))
                  for (var yr = this._splitSafely(Xe, En), jn = 0, Ot = yr.length; jn < Ot; jn++)
                    de.push(yr[jn]);
              }
            }
            this.tree.remove(Ae);
          }
          return de;
        }
        /* Safely split a segment that is currently in the datastructures
         * IE - a segment other than the one that is currently being processed. */
      }, {
        key: "_splitSafely",
        value: function(ie, Ae) {
          this.tree.remove(ie);
          var de = ie.rightSE;
          this.queue.remove(de);
          var we = ie.split(Ae);
          return we.push(de), ie.consumedBy === void 0 && this.tree.insert(ie), we;
        }
      }]), Ee;
    }(), De = typeof process < "u" && process.env.POLYGON_CLIPPING_MAX_QUEUE_SIZE || 1e6, Ue = typeof process < "u" && process.env.POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS || 1e6, Te = /* @__PURE__ */ function() {
      function Ee() {
        n(this, Ee);
      }
      return i(Ee, [{
        key: "run",
        value: function(ie, Ae, de) {
          se.type = ie, L.reset();
          for (var we = [new Be(Ae, !0)], Pe = 0, qe = de.length; Pe < qe; Pe++)
            we.push(new Be(de[Pe], !1));
          if (se.numMultiPolys = we.length, se.type === "difference")
            for (var ke = we[0], Xe = 1; Xe < we.length; )
              b(we[Xe].bbox, ke.bbox) !== null ? Xe++ : we.splice(Xe, 1);
          if (se.type === "intersection") {
            for (var rt = 0, it = we.length; rt < it; rt++)
              for (var ht = we[rt], mt = rt + 1, _t = we.length; mt < _t; mt++)
                if (b(ht.bbox, we[mt].bbox) === null)
                  return [];
          }
          for (var Ct = new f(Z.compare), zt = 0, jt = we.length; zt < jt; zt++)
            for (var lt = we[zt].getSweepEvents(), Ht = 0, vt = lt.length; Ht < vt; Ht++)
              if (Ct.insert(lt[Ht]), Ct.size > De)
                throw new Error("Infinite loop when putting segment endpoints in a priority queue (queue size too big). Please file a bug report.");
          for (var It = new Se(Ct), un = Ct.size, hn = Ct.pop(); hn; ) {
            var We = hn.key;
            if (Ct.size === un) {
              var En = We.segment;
              throw new Error("Unable to pop() ".concat(We.isLeft ? "left" : "right", " SweepEvent ") + "[".concat(We.point.x, ", ").concat(We.point.y, "] from segment #").concat(En.id, " ") + "[".concat(En.leftSE.point.x, ", ").concat(En.leftSE.point.y, "] -> ") + "[".concat(En.rightSE.point.x, ", ").concat(En.rightSE.point.y, "] from queue. ") + "Please file a bug report.");
            }
            if (Ct.size > De)
              throw new Error("Infinite loop when passing sweep line over endpoints (queue size too big). Please file a bug report.");
            if (It.segments.length > Ue)
              throw new Error("Infinite loop when passing sweep line over endpoints (too many sweep line segments). Please file a bug report.");
            for (var qn = It.process(We), Pt = 0, dr = qn.length; Pt < dr; Pt++) {
              var yr = qn[Pt];
              yr.consumedBy === void 0 && Ct.insert(yr);
            }
            un = Ct.size, hn = Ct.pop();
          }
          L.reset();
          var jn = Ie.factory(It.segments), Ot = new xe(jn);
          return Ot.getGeom();
        }
      }]), Ee;
    }(), se = new Te(), fe = function(oe) {
      for (var ie = arguments.length, Ae = new Array(ie > 1 ? ie - 1 : 0), de = 1; de < ie; de++)
        Ae[de - 1] = arguments[de];
      return se.run("union", oe, Ae);
    }, W = function(oe) {
      for (var ie = arguments.length, Ae = new Array(ie > 1 ? ie - 1 : 0), de = 1; de < ie; de++)
        Ae[de - 1] = arguments[de];
      return se.run("intersection", oe, Ae);
    }, ge = function(oe) {
      for (var ie = arguments.length, Ae = new Array(ie > 1 ? ie - 1 : 0), de = 1; de < ie; de++)
        Ae[de - 1] = arguments[de];
      return se.run("xor", oe, Ae);
    }, _e = function(oe) {
      for (var ie = arguments.length, Ae = new Array(ie > 1 ? ie - 1 : 0), de = 1; de < ie; de++)
        Ae[de - 1] = arguments[de];
      return se.run("difference", oe, Ae);
    }, Re = {
      union: fe,
      intersection: W,
      xor: ge,
      difference: _e
    };
    return Re;
  });
})(m7e);
var hue = m7e.exports, S2n = hue, hxe = ar, dxe = Eo;
function Q2n(t) {
  return t && typeof t == "object" && "default" in t ? t : { default: t };
}
var w2n = /* @__PURE__ */ Q2n(S2n);
function C7e(t, e) {
  var n = dxe.getGeom(t), r = dxe.getGeom(e), i = t.properties || {}, o = w2n.default.difference(
    n.coordinates,
    r.coordinates
  );
  return o.length === 0 ? null : o.length === 1 ? hxe.polygon(o[0], i) : hxe.multiPolygon(o, i);
}
gue.exports = C7e;
gue.exports.default = C7e;
var O$ = gue.exports, hl = {};
Object.defineProperty(hl, "__esModule", { value: !0 });
var pxe = Eo, C2 = ar;
function x2n(t, e, n) {
  n === void 0 && (n = {});
  var r = pxe.getCoord(t), i = pxe.getCoord(e), o = C2.degreesToRadians(i[1] - r[1]), s = C2.degreesToRadians(i[0] - r[0]), a = C2.degreesToRadians(r[1]), A = C2.degreesToRadians(i[1]), l = Math.pow(Math.sin(o / 2), 2) + Math.pow(Math.sin(s / 2), 2) * Math.cos(a) * Math.cos(A);
  return C2.radiansToLength(2 * Math.atan2(Math.sqrt(l), Math.sqrt(1 - l)), n.units);
}
hl.default = x2n;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = t.SELECTION_TYPE = void 0;
  var e = wE, n = ar, r = A(QE), i = A(xE), o = A(fue), s = A(O$), a = A(hl);
  function A(V) {
    return V && V.__esModule ? V : { default: V };
  }
  function l(V, Z) {
    var ce = Object.keys(V);
    if (Object.getOwnPropertySymbols) {
      var ee = Object.getOwnPropertySymbols(V);
      Z && (ee = ee.filter(function(pe) {
        return Object.getOwnPropertyDescriptor(V, pe).enumerable;
      })), ce.push.apply(ce, ee);
    }
    return ce;
  }
  function c(V) {
    for (var Z = 1; Z < arguments.length; Z++) {
      var ce = arguments[Z] != null ? arguments[Z] : {};
      Z % 2 ? l(Object(ce), !0).forEach(function(ee) {
        M(V, ee, ce[ee]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(V, Object.getOwnPropertyDescriptors(ce)) : l(Object(ce)).forEach(function(ee) {
        Object.defineProperty(V, ee, Object.getOwnPropertyDescriptor(ce, ee));
      });
    }
    return V;
  }
  function u(V, Z) {
    return d(V) || h(V, Z) || C(V, Z) || f();
  }
  function f() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function h(V, Z) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(V)))) {
      var ce = [], ee = !0, pe = !1, Ce = void 0;
      try {
        for (var Be = V[Symbol.iterator](), Ie; !(ee = (Ie = Be.next()).done) && (ce.push(Ie.value), !(Z && ce.length === Z)); ee = !0)
          ;
      } catch (Qe) {
        pe = !0, Ce = Qe;
      } finally {
        try {
          !ee && Be.return != null && Be.return();
        } finally {
          if (pe)
            throw Ce;
        }
      }
      return ce;
    }
  }
  function d(V) {
    if (Array.isArray(V))
      return V;
  }
  function I(V) {
    return v(V) || y(V) || C(V) || m();
  }
  function m() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function C(V, Z) {
    if (V) {
      if (typeof V == "string")
        return b(V, Z);
      var ce = Object.prototype.toString.call(V).slice(8, -1);
      if (ce === "Object" && V.constructor && (ce = V.constructor.name), ce === "Map" || ce === "Set")
        return Array.from(ce);
      if (ce === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ce))
        return b(V, Z);
    }
  }
  function y(V) {
    if (typeof Symbol < "u" && Symbol.iterator in Object(V))
      return Array.from(V);
  }
  function v(V) {
    if (Array.isArray(V))
      return b(V);
  }
  function b(V, Z) {
    (Z == null || Z > V.length) && (Z = V.length);
    for (var ce = 0, ee = new Array(Z); ce < Z; ce++)
      ee[ce] = V[ce];
    return ee;
  }
  function Q(V, Z) {
    if (!(V instanceof Z))
      throw new TypeError("Cannot call a class as a function");
  }
  function w(V, Z) {
    for (var ce = 0; ce < Z.length; ce++) {
      var ee = Z[ce];
      ee.enumerable = ee.enumerable || !1, ee.configurable = !0, "value" in ee && (ee.writable = !0), Object.defineProperty(V, ee.key, ee);
    }
  }
  function R(V, Z, ce) {
    return Z && w(V.prototype, Z), ce && w(V, ce), V;
  }
  function M(V, Z, ce) {
    return Z in V ? Object.defineProperty(V, Z, { value: ce, enumerable: !0, configurable: !0, writable: !0 }) : V[Z] = ce, V;
  }
  var O = [0, 255, 0, 255], L = [255, 255, 255, 90], N = 2, k = [20, 20], $ = 0.01, U = 10, X = "DeckDrawerView", K = "DeckDrawerPick", z = {
    NONE: null,
    RECTANGLE: "rectangle",
    POLYGON: "polygon"
  };
  t.SELECTION_TYPE = z;
  var Y = /* @__PURE__ */ function() {
    function V(Z) {
      Q(this, V), M(this, "nebula", void 0), M(this, "usePolygon", void 0), M(this, "validPolygon", void 0), M(this, "landPoints", void 0), M(this, "mousePoints", void 0), this.nebula = Z, this.usePolygon = !1, this.landPoints = [], this.mousePoints = [];
    }
    return R(V, [{
      key: "_getLayerIds",
      value: function() {
        return this.nebula.deckgl.props.layers.filter(function(ce) {
          return ce && ce.props && ce.props.nebulaLayer && ce.props.nebulaLayer.enableSelection;
        }).map(function(ce) {
          return ce.id;
        });
      }
    }, {
      key: "_selectFromPickingInfos",
      value: function(ce) {
        var ee = ce.map(function(pe) {
          var Ce = pe.layer, Be = pe.index, Ie = pe.object;
          return Ie.original || Ce.props.nebulaLayer.deckCache.originals[Be];
        });
        this.nebula.props.onSelection(ee);
      }
    }, {
      key: "_getBoundingBox",
      value: function() {
        var ce = this.mousePoints, ee = ce.map(function(xe) {
          return xe[0];
        }), pe = ce.map(function(xe) {
          return xe[1];
        }), Ce = Math.min.apply(Math, I(ee)), Be = Math.min.apply(Math, I(pe)), Ie = Math.max.apply(Math, I(ee)), Qe = Math.max.apply(Math, I(pe));
        return {
          x: Ce,
          y: Be,
          width: Ie - Ce,
          height: Qe - Be
        };
      }
    }, {
      key: "_selectRectangleObjects",
      value: function() {
        if (this.landPoints.length === 2) {
          var ce = u(this.mousePoints[0], 2), ee = ce[0], pe = ce[1], Ce = u(this.mousePoints[1], 2), Be = Ce[0], Ie = Ce[1], Qe = this.nebula.deckgl.pickObjects({
            x: Math.min(ee, Be),
            y: Math.min(pe, Ie),
            width: Math.abs(Be - ee),
            height: Math.abs(Ie - pe),
            layerIds: this._getLayerIds()
          });
          this._selectFromPickingInfos(Qe);
        }
      }
    }, {
      key: "_selectPolygonObjects",
      value: function() {
        var ce = this.nebula.deckgl.pickObjects(c({}, this._getBoundingBox(), {
          layerIds: [K].concat(I(this._getLayerIds()))
        }));
        this._selectFromPickingInfos(ce.filter(function(ee) {
          return ee.layer.id !== K;
        }));
      }
    }, {
      key: "_getMousePosFromEvent",
      value: function(ce) {
        var ee = ce.offsetX, pe = ce.offsetY;
        return [ee, pe];
      }
    }, {
      key: "handleEvent",
      value: function(ce, ee, pe) {
        ce.type !== "mouseup" && ce.stopPropagation(), this.usePolygon = pe === z.POLYGON;
        var Ce = !1, Be = !1, Ie = this.usePolygon, Qe = this.landPoints, xe = this.mousePoints;
        if (ce.type === "mousedown") {
          if (Ie && Qe.length)
            (this.landPoints.length < 3 || this.validPolygon) && (Qe.push(ee), xe.push(this._getMousePosFromEvent(ce)));
          else {
            this.landPoints = [ee, ee];
            var Se = this._getMousePosFromEvent(ce);
            this.mousePoints = [Se, Se];
          }
          Ce = !0;
        } else
          ce.type === "mousemove" && Qe.length ? (Qe[Qe.length - 1] = ee, xe[xe.length - 1] = this._getMousePosFromEvent(ce), Ce = !0) : ce.type === "mouseup" && (Ie ? Qe.length > 4 && (0, a.default)(Qe[0], Qe[Qe.length - 1]) < $ && this.validPolygon && (this._selectPolygonObjects(), this.reset(), Ce = !0, Be = !0) : (this._selectRectangleObjects(), this.reset(), Ce = !0, Be = !0));
        return {
          redraw: Ce,
          deactivate: Be
        };
      }
    }, {
      key: "reset",
      value: function() {
        this.landPoints = [], this.mousePoints = [];
      }
    }, {
      key: "_makeStartPointHighlight",
      value: function(ce) {
        var ee = (0, o.default)((0, n.point)(ce), $ / 4);
        return (0, i.default)((0, r.default)(ee)).geometry.coordinates;
      }
    }, {
      key: "render",
      value: function() {
        var ce = this, ee = [], pe = [];
        if (!this.usePolygon && this.landPoints.length === 2) {
          var Ce = u(this.mousePoints, 2), Be = u(Ce[0], 2), Ie = Be[0], Qe = Be[1], xe = u(Ce[1], 2), Se = xe[0], De = xe[1], Ue = [[Ie, Qe], [Ie, De], [Se, De], [Se, Qe], [Ie, Qe]].map(function(W) {
            return ce.nebula.unprojectMousePosition(W);
          });
          ee.push({
            polygon: Ue,
            lineColor: O,
            fillColor: L
          });
        } else if (this.usePolygon && this.landPoints.length && (ee.push({
          polygon: this.landPoints,
          lineColor: O,
          fillColor: L
        }), this.landPoints.length >= 3)) {
          var Te = (0, n.polygon)([[].concat(I(this.landPoints), [this.landPoints[0]])]), se = (0, o.default)((0, n.point)(this.landPoints[0]), U), fe;
          try {
            fe = (0, s.default)(se, Te), pe.push({
              polygon: fe.geometry.coordinates,
              fillColor: [0, 0, 0, 1]
            }), this.validPolygon = !0;
          } catch {
            this.validPolygon = !1;
          }
        }
        return this.landPoints.length && ee.push({
          polygon: this._makeStartPointHighlight(this.landPoints[0]),
          lineColor: [0, 0, 0, 0],
          fillColor: O
        }), ee.push({
          polygon: [[0, 0]]
        }), pe.push({
          polygon: [[0, 0]]
        }), [new e.PolygonLayer({
          id: X,
          data: ee,
          // @ts-ignore
          fp64: !1,
          opacity: 1,
          pickable: !1,
          lineWidthMinPixels: N,
          lineWidthMaxPixels: N,
          lineDashJustified: !0,
          getLineDashArray: function(ge) {
            return k;
          },
          // @ts-ignore
          getLineColor: function(ge) {
            return ge.lineColor || [0, 0, 0, 255];
          },
          // @ts-ignore
          getFillColor: function(ge) {
            return ge.fillColor || [0, 0, 0, 255];
          },
          // @ts-ignore
          getPolygon: function(ge) {
            return ge.polygon;
          }
        }), new e.PolygonLayer({
          id: K,
          data: pe,
          // @ts-ignore
          getLineColor: function(ge) {
            return ge.lineColor || [0, 0, 0, 255];
          },
          // @ts-ignore
          getFillColor: function(ge) {
            return ge.fillColor || [0, 0, 0, 255];
          },
          // @ts-ignore
          fp64: !1,
          opacity: 1,
          stroked: !1,
          pickable: !0,
          // @ts-ignore
          getPolygon: function(ge) {
            return ge.polygon;
          }
        })];
      }
    }]), V;
  }();
  t.default = Y;
})(Kce);
var E7e = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  function e(s, a) {
    if (!(s instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  function n(s, a) {
    for (var A = 0; A < a.length; A++) {
      var l = a[A];
      l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(s, l.key, l);
    }
  }
  function r(s, a, A) {
    return a && n(s.prototype, a), A && n(s, A), s;
  }
  function i(s, a, A) {
    return a in s ? Object.defineProperty(s, a, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : s[a] = A, s;
  }
  var o = /* @__PURE__ */ function() {
    function s(a, A) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, c = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      e(this, s), i(this, "geoJson", void 0), i(this, "style", void 0), i(this, "original", void 0), i(this, "metadata", void 0), this.geoJson = a, this.style = A, this.original = l, this.metadata = c;
    }
    return r(s, [{
      key: "getCoords",
      value: function() {
        return this.geoJson.geometry.coordinates;
      }
    }]), s;
  }();
  t.default = o;
})(E7e);
var due = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  function e(s, a) {
    if (!(s instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  function n(s, a) {
    for (var A = 0; A < a.length; A++) {
      var l = a[A];
      l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(s, l.key, l);
    }
  }
  function r(s, a, A) {
    return a && n(s.prototype, a), A && n(s, A), s;
  }
  function i(s, a, A) {
    return a in s ? Object.defineProperty(s, a, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : s[a] = A, s;
  }
  var o = /* @__PURE__ */ function() {
    function s(a, A) {
      var l = A.data, c = A.groundPoint, u = A.nebula, f = A.metadata;
      e(this, s), i(this, "canceled", void 0), i(this, "data", void 0), i(this, "metadata", void 0), i(this, "groundPoint", void 0), i(this, "nativeEvent", void 0), i(this, "nebula", void 0), this.nativeEvent = a, this.data = l, this.groundPoint = c, this.nebula = u, this.metadata = f;
    }
    return r(s, [{
      key: "stopPropagation",
      value: function() {
        this.nativeEvent.stopPropagation(), this.canceled = !0;
      }
    }]), s;
  }();
  t.default = o;
})(due);
var $w = {}, pue = { exports: {} }, K_ = typeof Reflect == "object" ? Reflect : null, Ixe = K_ && typeof K_.apply == "function" ? K_.apply : function(e, n, r) {
  return Function.prototype.apply.call(e, n, r);
}, Jk;
K_ && typeof K_.ownKeys == "function" ? Jk = K_.ownKeys : Object.getOwnPropertySymbols ? Jk = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Jk = function(e) {
  return Object.getOwnPropertyNames(e);
};
function R2n(t) {
  console && console.warn && console.warn(t);
}
var y7e = Number.isNaN || function(e) {
  return e !== e;
};
function Fo() {
  Fo.init.call(this);
}
pue.exports = Fo;
pue.exports.once = L2n;
Fo.EventEmitter = Fo;
Fo.prototype._events = void 0;
Fo.prototype._eventsCount = 0;
Fo.prototype._maxListeners = void 0;
var mxe = 10;
function F$(t) {
  if (typeof t != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
}
Object.defineProperty(Fo, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return mxe;
  },
  set: function(t) {
    if (typeof t != "number" || t < 0 || y7e(t))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
    mxe = t;
  }
});
Fo.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Fo.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || y7e(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function v7e(t) {
  return t._maxListeners === void 0 ? Fo.defaultMaxListeners : t._maxListeners;
}
Fo.prototype.getMaxListeners = function() {
  return v7e(this);
};
Fo.prototype.emit = function(e) {
  for (var n = [], r = 1; r < arguments.length; r++)
    n.push(arguments[r]);
  var i = e === "error", o = this._events;
  if (o !== void 0)
    i = i && o.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var s;
    if (n.length > 0 && (s = n[0]), s instanceof Error)
      throw s;
    var a = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
    throw a.context = s, a;
  }
  var A = o[e];
  if (A === void 0)
    return !1;
  if (typeof A == "function")
    Ixe(A, this, n);
  else
    for (var l = A.length, c = Q7e(A, l), r = 0; r < l; ++r)
      Ixe(c[r], this, n);
  return !0;
};
function B7e(t, e, n, r) {
  var i, o, s;
  if (F$(n), o = t._events, o === void 0 ? (o = t._events = /* @__PURE__ */ Object.create(null), t._eventsCount = 0) : (o.newListener !== void 0 && (t.emit(
    "newListener",
    e,
    n.listener ? n.listener : n
  ), o = t._events), s = o[e]), s === void 0)
    s = o[e] = n, ++t._eventsCount;
  else if (typeof s == "function" ? s = o[e] = r ? [n, s] : [s, n] : r ? s.unshift(n) : s.push(n), i = v7e(t), i > 0 && s.length > i && !s.warned) {
    s.warned = !0;
    var a = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    a.name = "MaxListenersExceededWarning", a.emitter = t, a.type = e, a.count = s.length, R2n(a);
  }
  return t;
}
Fo.prototype.addListener = function(e, n) {
  return B7e(this, e, n, !1);
};
Fo.prototype.on = Fo.prototype.addListener;
Fo.prototype.prependListener = function(e, n) {
  return B7e(this, e, n, !0);
};
function D2n() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function b7e(t, e, n) {
  var r = { fired: !1, wrapFn: void 0, target: t, type: e, listener: n }, i = D2n.bind(r);
  return i.listener = n, r.wrapFn = i, i;
}
Fo.prototype.once = function(e, n) {
  return F$(n), this.on(e, b7e(this, e, n)), this;
};
Fo.prototype.prependOnceListener = function(e, n) {
  return F$(n), this.prependListener(e, b7e(this, e, n)), this;
};
Fo.prototype.removeListener = function(e, n) {
  var r, i, o, s, a;
  if (F$(n), i = this._events, i === void 0)
    return this;
  if (r = i[e], r === void 0)
    return this;
  if (r === n || r.listener === n)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, r.listener || n));
  else if (typeof r != "function") {
    for (o = -1, s = r.length - 1; s >= 0; s--)
      if (r[s] === n || r[s].listener === n) {
        a = r[s].listener, o = s;
        break;
      }
    if (o < 0)
      return this;
    o === 0 ? r.shift() : T2n(r, o), r.length === 1 && (i[e] = r[0]), i.removeListener !== void 0 && this.emit("removeListener", e, a || n);
  }
  return this;
};
Fo.prototype.off = Fo.prototype.removeListener;
Fo.prototype.removeAllListeners = function(e) {
  var n, r, i;
  if (r = this._events, r === void 0)
    return this;
  if (r.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : r[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete r[e]), this;
  if (arguments.length === 0) {
    var o = Object.keys(r), s;
    for (i = 0; i < o.length; ++i)
      s = o[i], s !== "removeListener" && this.removeAllListeners(s);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (n = r[e], typeof n == "function")
    this.removeListener(e, n);
  else if (n !== void 0)
    for (i = n.length - 1; i >= 0; i--)
      this.removeListener(e, n[i]);
  return this;
};
function _7e(t, e, n) {
  var r = t._events;
  if (r === void 0)
    return [];
  var i = r[e];
  return i === void 0 ? [] : typeof i == "function" ? n ? [i.listener || i] : [i] : n ? N2n(i) : Q7e(i, i.length);
}
Fo.prototype.listeners = function(e) {
  return _7e(this, e, !0);
};
Fo.prototype.rawListeners = function(e) {
  return _7e(this, e, !1);
};
Fo.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : S7e.call(t, e);
};
Fo.prototype.listenerCount = S7e;
function S7e(t) {
  var e = this._events;
  if (e !== void 0) {
    var n = e[t];
    if (typeof n == "function")
      return 1;
    if (n !== void 0)
      return n.length;
  }
  return 0;
}
Fo.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Jk(this._events) : [];
};
function Q7e(t, e) {
  for (var n = new Array(e), r = 0; r < e; ++r)
    n[r] = t[r];
  return n;
}
function T2n(t, e) {
  for (; e + 1 < t.length; e++)
    t[e] = t[e + 1];
  t.pop();
}
function N2n(t) {
  for (var e = new Array(t.length), n = 0; n < e.length; ++n)
    e[n] = t[n].listener || t[n];
  return e;
}
function L2n(t, e) {
  return new Promise(function(n, r) {
    function i(s) {
      t.removeListener(e, o), r(s);
    }
    function o() {
      typeof t.removeListener == "function" && t.removeListener("error", i), n([].slice.call(arguments));
    }
    w7e(t, e, o, { once: !0 }), e !== "error" && M2n(t, i, { once: !0 });
  });
}
function M2n(t, e, n) {
  typeof t.on == "function" && w7e(t, "error", e, n);
}
function w7e(t, e, n, r) {
  if (typeof t.on == "function")
    r.once ? t.once(e, n) : t.on(e, n);
  else if (typeof t.addEventListener == "function")
    t.addEventListener(e, function i(o) {
      r.once && t.removeEventListener(e, i), n(o);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t);
}
var x7e = pue.exports, Cxe = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), O2n = new Uint8Array(16);
function R7e() {
  if (!Cxe)
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Cxe(O2n);
}
var D7e = [];
for (var TP = 0; TP < 256; ++TP)
  D7e[TP] = (TP + 256).toString(16).substr(1);
function Iue(t, e) {
  var n = e || 0, r = D7e;
  return [r[t[n++]], r[t[n++]], r[t[n++]], r[t[n++]], "-", r[t[n++]], r[t[n++]], "-", r[t[n++]], r[t[n++]], "-", r[t[n++]], r[t[n++]], "-", r[t[n++]], r[t[n++]], r[t[n++]], r[t[n++]], r[t[n++]], r[t[n++]]].join("");
}
var Exe, EJ, yJ = 0, vJ = 0;
function F2n(t, e, n) {
  var r = e && n || 0, i = e || [];
  t = t || {};
  var o = t.node || Exe, s = t.clockseq !== void 0 ? t.clockseq : EJ;
  if (o == null || s == null) {
    var a = t.random || (t.rng || R7e)();
    o == null && (o = Exe = [a[0] | 1, a[1], a[2], a[3], a[4], a[5]]), s == null && (s = EJ = (a[6] << 8 | a[7]) & 16383);
  }
  var A = t.msecs !== void 0 ? t.msecs : (/* @__PURE__ */ new Date()).getTime(), l = t.nsecs !== void 0 ? t.nsecs : vJ + 1, c = A - yJ + (l - vJ) / 1e4;
  if (c < 0 && t.clockseq === void 0 && (s = s + 1 & 16383), (c < 0 || A > yJ) && t.nsecs === void 0 && (l = 0), l >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  yJ = A, vJ = l, EJ = s, A += 122192928e5;
  var u = ((A & 268435455) * 1e4 + l) % 4294967296;
  i[r++] = u >>> 24 & 255, i[r++] = u >>> 16 & 255, i[r++] = u >>> 8 & 255, i[r++] = u & 255;
  var f = A / 4294967296 * 1e4 & 268435455;
  i[r++] = f >>> 8 & 255, i[r++] = f & 255, i[r++] = f >>> 24 & 15 | 16, i[r++] = f >>> 16 & 255, i[r++] = s >>> 8 | 128, i[r++] = s & 255;
  for (var h = 0; h < 6; ++h)
    i[r + h] = o[h];
  return e || Iue(i);
}
function P2n(t) {
  var e = [];
  return t.replace(/[a-fA-F0-9]{2}/g, function(n) {
    e.push(parseInt(n, 16));
  }), e;
}
function k2n(t) {
  t = unescape(encodeURIComponent(t));
  for (var e = new Array(t.length), n = 0; n < t.length; n++)
    e[n] = t.charCodeAt(n);
  return e;
}
var G2n = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", U2n = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function T7e(t, e, n) {
  var r = function(o, s, a, A) {
    var l = a && A || 0;
    if (typeof o == "string" && (o = k2n(o)), typeof s == "string" && (s = P2n(s)), !Array.isArray(o))
      throw TypeError("value must be an array of bytes");
    if (!Array.isArray(s) || s.length !== 16)
      throw TypeError("namespace must be uuid string or an Array of 16 byte values");
    var c = n(s.concat(o));
    if (c[6] = c[6] & 15 | e, c[8] = c[8] & 63 | 128, a)
      for (var u = 0; u < 16; ++u)
        a[l + u] = c[u];
    return a || Iue(c);
  };
  try {
    r.name = t;
  } catch {
  }
  return r.DNS = G2n, r.URL = U2n, r;
}
function H2n(t) {
  if (typeof t == "string") {
    var e = unescape(encodeURIComponent(t));
    t = new Array(e.length);
    for (var n = 0; n < e.length; n++)
      t[n] = e.charCodeAt(n);
  }
  return $2n(q2n(j2n(t), t.length * 8));
}
function $2n(t) {
  var e, n, r = [], i = t.length * 32, o = "0123456789abcdef", s;
  for (e = 0; e < i; e += 8)
    n = t[e >> 5] >>> e % 32 & 255, s = parseInt(o.charAt(n >>> 4 & 15) + o.charAt(n & 15), 16), r.push(s);
  return r;
}
function q2n(t, e) {
  t[e >> 5] |= 128 << e % 32, t[(e + 64 >>> 9 << 4) + 14] = e;
  var n, r, i, o, s, a = 1732584193, A = -271733879, l = -1732584194, c = 271733878;
  for (n = 0; n < t.length; n += 16)
    r = a, i = A, o = l, s = c, a = Ql(a, A, l, c, t[n], 7, -680876936), c = Ql(c, a, A, l, t[n + 1], 12, -389564586), l = Ql(l, c, a, A, t[n + 2], 17, 606105819), A = Ql(A, l, c, a, t[n + 3], 22, -1044525330), a = Ql(a, A, l, c, t[n + 4], 7, -176418897), c = Ql(c, a, A, l, t[n + 5], 12, 1200080426), l = Ql(l, c, a, A, t[n + 6], 17, -1473231341), A = Ql(A, l, c, a, t[n + 7], 22, -45705983), a = Ql(a, A, l, c, t[n + 8], 7, 1770035416), c = Ql(c, a, A, l, t[n + 9], 12, -1958414417), l = Ql(l, c, a, A, t[n + 10], 17, -42063), A = Ql(A, l, c, a, t[n + 11], 22, -1990404162), a = Ql(a, A, l, c, t[n + 12], 7, 1804603682), c = Ql(c, a, A, l, t[n + 13], 12, -40341101), l = Ql(l, c, a, A, t[n + 14], 17, -1502002290), A = Ql(A, l, c, a, t[n + 15], 22, 1236535329), a = wl(a, A, l, c, t[n + 1], 5, -165796510), c = wl(c, a, A, l, t[n + 6], 9, -1069501632), l = wl(l, c, a, A, t[n + 11], 14, 643717713), A = wl(A, l, c, a, t[n], 20, -373897302), a = wl(a, A, l, c, t[n + 5], 5, -701558691), c = wl(c, a, A, l, t[n + 10], 9, 38016083), l = wl(l, c, a, A, t[n + 15], 14, -660478335), A = wl(A, l, c, a, t[n + 4], 20, -405537848), a = wl(a, A, l, c, t[n + 9], 5, 568446438), c = wl(c, a, A, l, t[n + 14], 9, -1019803690), l = wl(l, c, a, A, t[n + 3], 14, -187363961), A = wl(A, l, c, a, t[n + 8], 20, 1163531501), a = wl(a, A, l, c, t[n + 13], 5, -1444681467), c = wl(c, a, A, l, t[n + 2], 9, -51403784), l = wl(l, c, a, A, t[n + 7], 14, 1735328473), A = wl(A, l, c, a, t[n + 12], 20, -1926607734), a = xl(a, A, l, c, t[n + 5], 4, -378558), c = xl(c, a, A, l, t[n + 8], 11, -2022574463), l = xl(l, c, a, A, t[n + 11], 16, 1839030562), A = xl(A, l, c, a, t[n + 14], 23, -35309556), a = xl(a, A, l, c, t[n + 1], 4, -1530992060), c = xl(c, a, A, l, t[n + 4], 11, 1272893353), l = xl(l, c, a, A, t[n + 7], 16, -155497632), A = xl(A, l, c, a, t[n + 10], 23, -1094730640), a = xl(a, A, l, c, t[n + 13], 4, 681279174), c = xl(c, a, A, l, t[n], 11, -358537222), l = xl(l, c, a, A, t[n + 3], 16, -722521979), A = xl(A, l, c, a, t[n + 6], 23, 76029189), a = xl(a, A, l, c, t[n + 9], 4, -640364487), c = xl(c, a, A, l, t[n + 12], 11, -421815835), l = xl(l, c, a, A, t[n + 15], 16, 530742520), A = xl(A, l, c, a, t[n + 2], 23, -995338651), a = Rl(a, A, l, c, t[n], 6, -198630844), c = Rl(c, a, A, l, t[n + 7], 10, 1126891415), l = Rl(l, c, a, A, t[n + 14], 15, -1416354905), A = Rl(A, l, c, a, t[n + 5], 21, -57434055), a = Rl(a, A, l, c, t[n + 12], 6, 1700485571), c = Rl(c, a, A, l, t[n + 3], 10, -1894986606), l = Rl(l, c, a, A, t[n + 10], 15, -1051523), A = Rl(A, l, c, a, t[n + 1], 21, -2054922799), a = Rl(a, A, l, c, t[n + 8], 6, 1873313359), c = Rl(c, a, A, l, t[n + 15], 10, -30611744), l = Rl(l, c, a, A, t[n + 6], 15, -1560198380), A = Rl(A, l, c, a, t[n + 13], 21, 1309151649), a = Rl(a, A, l, c, t[n + 4], 6, -145523070), c = Rl(c, a, A, l, t[n + 11], 10, -1120210379), l = Rl(l, c, a, A, t[n + 2], 15, 718787259), A = Rl(A, l, c, a, t[n + 9], 21, -343485551), a = lC(a, r), A = lC(A, i), l = lC(l, o), c = lC(c, s);
  return [a, A, l, c];
}
function j2n(t) {
  var e, n = [];
  for (n[(t.length >> 2) - 1] = void 0, e = 0; e < n.length; e += 1)
    n[e] = 0;
  var r = t.length * 8;
  for (e = 0; e < r; e += 8)
    n[e >> 5] |= (t[e / 8] & 255) << e % 32;
  return n;
}
function lC(t, e) {
  var n = (t & 65535) + (e & 65535), r = (t >> 16) + (e >> 16) + (n >> 16);
  return r << 16 | n & 65535;
}
function Y2n(t, e) {
  return t << e | t >>> 32 - e;
}
function P$(t, e, n, r, i, o) {
  return lC(Y2n(lC(lC(e, t), lC(r, o)), i), n);
}
function Ql(t, e, n, r, i, o, s) {
  return P$(e & n | ~e & r, t, e, i, o, s);
}
function wl(t, e, n, r, i, o, s) {
  return P$(e & r | n & ~r, t, e, i, o, s);
}
function xl(t, e, n, r, i, o, s) {
  return P$(e ^ n ^ r, t, e, i, o, s);
}
function Rl(t, e, n, r, i, o, s) {
  return P$(n ^ (e | ~r), t, e, i, o, s);
}
var z2n = T7e("v3", 48, H2n);
const V2n = z2n;
function J2n(t, e, n) {
  var r = e && n || 0;
  typeof t == "string" && (e = t === "binary" ? new Array(16) : null, t = null), t = t || {};
  var i = t.random || (t.rng || R7e)();
  if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, e)
    for (var o = 0; o < 16; ++o)
      e[r + o] = i[o];
  return e || Iue(i);
}
function K2n(t, e, n, r) {
  switch (t) {
    case 0:
      return e & n ^ ~e & r;
    case 1:
      return e ^ n ^ r;
    case 2:
      return e & n ^ e & r ^ n & r;
    case 3:
      return e ^ n ^ r;
  }
}
function BJ(t, e) {
  return t << e | t >>> 32 - e;
}
function W2n(t) {
  var e = [1518500249, 1859775393, 2400959708, 3395469782], n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof t == "string") {
    var r = unescape(encodeURIComponent(t));
    t = new Array(r.length);
    for (var i = 0; i < r.length; i++)
      t[i] = r.charCodeAt(i);
  }
  t.push(128);
  for (var o = t.length / 4 + 2, s = Math.ceil(o / 16), a = new Array(s), i = 0; i < s; i++) {
    a[i] = new Array(16);
    for (var A = 0; A < 16; A++)
      a[i][A] = t[i * 64 + A * 4] << 24 | t[i * 64 + A * 4 + 1] << 16 | t[i * 64 + A * 4 + 2] << 8 | t[i * 64 + A * 4 + 3];
  }
  a[s - 1][14] = (t.length - 1) * 8 / Math.pow(2, 32), a[s - 1][14] = Math.floor(a[s - 1][14]), a[s - 1][15] = (t.length - 1) * 8 & 4294967295;
  for (var i = 0; i < s; i++) {
    for (var l = new Array(80), c = 0; c < 16; c++)
      l[c] = a[i][c];
    for (var c = 16; c < 80; c++)
      l[c] = BJ(l[c - 3] ^ l[c - 8] ^ l[c - 14] ^ l[c - 16], 1);
    for (var u = n[0], f = n[1], h = n[2], d = n[3], I = n[4], c = 0; c < 80; c++) {
      var m = Math.floor(c / 20), C = BJ(u, 5) + K2n(m, f, h, d) + I + e[m] + l[c] >>> 0;
      I = d, d = h, h = BJ(f, 30) >>> 0, f = u, u = C;
    }
    n[0] = n[0] + u >>> 0, n[1] = n[1] + f >>> 0, n[2] = n[2] + h >>> 0, n[3] = n[3] + d >>> 0, n[4] = n[4] + I >>> 0;
  }
  return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, n[0] & 255, n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, n[1] & 255, n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, n[2] & 255, n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, n[3] & 255, n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, n[4] & 255];
}
var X2n = T7e("v5", 80, W2n);
const Z2n = X2n, eRn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  v1: F2n,
  v3: V2n,
  v4: J2n,
  v5: Z2n
}, Symbol.toStringTag, { value: "Module" })), tRn = /* @__PURE__ */ Fs(eRn);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = r(x7e), n = r(tRn);
  function r(C) {
    return C && C.__esModule ? C : { default: C };
  }
  function i(C) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? i = function(v) {
      return typeof v;
    } : i = function(v) {
      return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
    }, i(C);
  }
  function o(C, y) {
    if (!(C instanceof y))
      throw new TypeError("Cannot call a class as a function");
  }
  function s(C, y) {
    for (var v = 0; v < y.length; v++) {
      var b = y[v];
      b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(C, b.key, b);
    }
  }
  function a(C, y, v) {
    return y && s(C.prototype, y), v && s(C, v), C;
  }
  function A(C) {
    return function() {
      var y = f(C), v;
      if (u()) {
        var b = f(this).constructor;
        v = Reflect.construct(y, arguments, b);
      } else
        v = y.apply(this, arguments);
      return l(this, v);
    };
  }
  function l(C, y) {
    return y && (i(y) === "object" || typeof y == "function") ? y : c(C);
  }
  function c(C) {
    if (C === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return C;
  }
  function u() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function f(C) {
    return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
      return v.__proto__ || Object.getPrototypeOf(v);
    }, f(C);
  }
  function h(C, y) {
    if (typeof y != "function" && y !== null)
      throw new TypeError("Super expression must either be null or a function");
    C.prototype = Object.create(y && y.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), y && d(C, y);
  }
  function d(C, y) {
    return d = Object.setPrototypeOf || function(b, Q) {
      return b.__proto__ = Q, b;
    }, d(C, y);
  }
  function I(C, y, v) {
    return y in C ? Object.defineProperty(C, y, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : C[y] = v, C;
  }
  var m = /* @__PURE__ */ function(C) {
    h(v, C);
    var y = A(v);
    function v(b) {
      var Q, w = b.getData, R = b.on, M = b.toNebulaFeature;
      return o(this, v), Q = y.call(this), I(c(Q), "getData", void 0), I(c(Q), "toNebulaFeature", void 0), I(c(Q), "id", void 0), I(c(Q), "helperLayers", void 0), I(c(Q), "usesMapEvents", !1), I(c(Q), "enablePicking", !1), I(c(Q), "enableSelection", !1), Q.id = n.default.v4(), Q.getData = w, Q.toNebulaFeature = M, Q.helperLayers = [], R && Object.keys(R).forEach(function(O) {
        return Q.on(O, R[O]);
      }), Q;
    }
    return a(v, [{
      key: "render",
      value: function(Q) {
        return null;
      }
    }]), v;
  }(e.default.EventEmitter);
  t.default = m;
})($w);
var N7e = {}, RM = {}, QC = {};
Object.defineProperty(QC, "__esModule", {
  value: !0
});
QC.MAX_ARROWS = QC.DEFAULT_ARROWS = QC.ArrowStyles = void 0;
var nRn = {
  NONE: 0,
  FORWARD: 1,
  BACKWARD: 2,
  BOTH: 3
};
QC.ArrowStyles = nRn;
var rRn = 1;
QC.DEFAULT_ARROWS = rRn;
var iRn = 3;
QC.MAX_ARROWS = iRn;
var k$ = {}, s1 = {}, ts = {}, mue = {}, oRn = ei && ei.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(mue, "__esModule", { value: !0 });
var sRn = oRn(hue), yxe = Eo, vxe = ar;
function aRn(t, e, n) {
  n === void 0 && (n = {});
  var r = yxe.getGeom(t), i = yxe.getGeom(e), o = sRn.default.union(r.coordinates, i.coordinates);
  return o.length === 0 ? null : o.length === 1 ? vxe.polygon(o[0], n.properties) : vxe.multiPolygon(o, n.properties);
}
mue.default = aRn;
var Cue = {}, ARn = ei && ei.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Cue, "__esModule", { value: !0 });
var Bxe = ar, bxe = Eo, lRn = ARn(hue);
function cRn(t, e, n) {
  n === void 0 && (n = {});
  var r = bxe.getGeom(t), i = bxe.getGeom(e), o = lRn.default.intersection(r.coordinates, i.coordinates);
  return o.length === 0 ? null : o.length === 1 ? Bxe.polygon(o[0], n.properties) : Bxe.multiPolygon(o, n.properties);
}
Cue.default = cRn;
var Eue = { exports: {} }, qw = {};
Object.defineProperty(qw, "__esModule", { value: !0 });
function uRn(t) {
  if (!t)
    throw new Error("geojson is required");
  switch (t.type) {
    case "Feature":
      return L7e(t);
    case "FeatureCollection":
      return fRn(t);
    case "Point":
    case "LineString":
    case "Polygon":
    case "MultiPoint":
    case "MultiLineString":
    case "MultiPolygon":
    case "GeometryCollection":
      return yue(t);
    default:
      throw new Error("unknown GeoJSON type");
  }
}
function L7e(t) {
  var e = { type: "Feature" };
  return Object.keys(t).forEach(function(n) {
    switch (n) {
      case "type":
      case "properties":
      case "geometry":
        return;
      default:
        e[n] = t[n];
    }
  }), e.properties = M7e(t.properties), e.geometry = yue(t.geometry), e;
}
function M7e(t) {
  var e = {};
  return t && Object.keys(t).forEach(function(n) {
    var r = t[n];
    typeof r == "object" ? r === null ? e[n] = null : Array.isArray(r) ? e[n] = r.map(function(i) {
      return i;
    }) : e[n] = M7e(r) : e[n] = r;
  }), e;
}
function fRn(t) {
  var e = { type: "FeatureCollection" };
  return Object.keys(t).forEach(function(n) {
    switch (n) {
      case "type":
      case "features":
        return;
      default:
        e[n] = t[n];
    }
  }), e.features = t.features.map(function(n) {
    return L7e(n);
  }), e;
}
function yue(t) {
  var e = { type: t.type };
  return t.bbox && (e.bbox = t.bbox), t.type === "GeometryCollection" ? (e.geometries = t.geometries.map(function(n) {
    return yue(n);
  }), e) : (e.coordinates = O7e(t.coordinates), e);
}
function O7e(t) {
  var e = t;
  return typeof e[0] != "object" ? e.slice() : e.map(function(n) {
    return O7e(n);
  });
}
qw.default = uRn;
var vue = {};
Object.defineProperty(vue, "__esModule", { value: !0 });
var gRn = Eo;
function hRn(t) {
  for (var e = gRn.getCoords(t), n = 0, r = 1, i, o; r < e.length; )
    i = o || e[0], o = e[r], n += (o[0] - i[0]) * (o[1] + i[1]), r++;
  return n > 0;
}
vue.default = hRn;
var dRn = qw, pRn = vue, Kk = Do, NP = Eo, _xe = ar;
function F7e(t) {
  return t && typeof t == "object" && "default" in t ? t : { default: t };
}
var IRn = /* @__PURE__ */ F7e(dRn), Zte = /* @__PURE__ */ F7e(pRn);
function P7e(t, e) {
  if (e = e || {}, !_xe.isObject(e))
    throw new Error("options is invalid");
  var n = e.reverse || !1, r = e.mutate || !1;
  if (!t)
    throw new Error("<geojson> is required");
  if (typeof n != "boolean")
    throw new Error("<reverse> must be a boolean");
  if (typeof r != "boolean")
    throw new Error("<mutate> must be a boolean");
  r === !1 && (t = IRn.default(t));
  var i = [];
  switch (t.type) {
    case "GeometryCollection":
      return Kk.geomEach(t, function(o) {
        Wk(o, n);
      }), t;
    case "FeatureCollection":
      return Kk.featureEach(t, function(o) {
        Kk.featureEach(Wk(o, n), function(s) {
          i.push(s);
        });
      }), _xe.featureCollection(i);
  }
  return Wk(t, n);
}
function Wk(t, e) {
  var n = t.type === "Feature" ? t.geometry.type : t.type;
  switch (n) {
    case "GeometryCollection":
      return Kk.geomEach(t, function(r) {
        Wk(r, e);
      }), t;
    case "LineString":
      return Sxe(NP.getCoords(t), e), t;
    case "Polygon":
      return Qxe(NP.getCoords(t), e), t;
    case "MultiLineString":
      return NP.getCoords(t).forEach(function(r) {
        Sxe(r, e);
      }), t;
    case "MultiPolygon":
      return NP.getCoords(t).forEach(function(r) {
        Qxe(r, e);
      }), t;
    case "Point":
    case "MultiPoint":
      return t;
  }
}
function Sxe(t, e) {
  Zte.default(t) === e && t.reverse();
}
function Qxe(t, e) {
  Zte.default(t[0]) !== e && t[0].reverse();
  for (var n = 1; n < t.length; n++)
    Zte.default(t[n]) === e && t[n].reverse();
}
Eue.exports = P7e;
Eue.exports.default = P7e;
var mRn = Eue.exports, ao = {}, DE = {};
Object.defineProperty(DE, "__esModule", { value: !0 });
var Ey = ar, CRn = Eo;
function ERn(t, e, n, r) {
  r === void 0 && (r = {});
  var i = CRn.getCoord(t), o = Ey.degreesToRadians(i[0]), s = Ey.degreesToRadians(i[1]), a = Ey.degreesToRadians(n), A = Ey.lengthToRadians(e, r.units), l = Math.asin(Math.sin(s) * Math.cos(A) + Math.cos(s) * Math.sin(A) * Math.cos(a)), c = o + Math.atan2(Math.sin(a) * Math.sin(A) * Math.cos(s), Math.cos(A) - Math.sin(s) * Math.sin(l)), u = Ey.radiansToDegrees(c), f = Ey.radiansToDegrees(l);
  return Ey.point([u, f], r.properties);
}
DE.default = ERn;
var zf = {};
Object.defineProperty(zf, "__esModule", { value: !0 });
var E2 = ar, wxe = Eo;
function k7e(t, e, n) {
  if (n === void 0 && (n = {}), n.final === !0)
    return yRn(t, e);
  var r = wxe.getCoord(t), i = wxe.getCoord(e), o = E2.degreesToRadians(r[0]), s = E2.degreesToRadians(i[0]), a = E2.degreesToRadians(r[1]), A = E2.degreesToRadians(i[1]), l = Math.sin(s - o) * Math.cos(A), c = Math.cos(a) * Math.sin(A) - Math.sin(a) * Math.cos(A) * Math.cos(s - o);
  return E2.radiansToDegrees(Math.atan2(l, c));
}
zf.default = k7e;
function yRn(t, e) {
  var n = k7e(e, t);
  return n = (n + 180) % 360, n;
}
var G$ = {}, DM = {};
Object.defineProperty(DM, "__esModule", { value: !0 });
var G7e = ar, xxe = Eo;
function vRn(t, e, n) {
  n === void 0 && (n = {});
  var r = xxe.getCoord(t), i = xxe.getCoord(e);
  i[0] += i[0] - r[0] > 180 ? -360 : r[0] - i[0] > 180 ? 360 : 0;
  var o = BRn(r, i), s = G7e.convertLength(o, "meters", n.units);
  return s;
}
function BRn(t, e, n) {
  n = n === void 0 ? G7e.earthRadius : Number(n);
  var r = n, i = t[1] * Math.PI / 180, o = e[1] * Math.PI / 180, s = o - i, a = Math.abs(e[0] - t[0]) * Math.PI / 180;
  a > Math.PI && (a -= 2 * Math.PI);
  var A = Math.log(Math.tan(o / 2 + Math.PI / 4) / Math.tan(i / 2 + Math.PI / 4)), l = Math.abs(A) > 1e-11 ? s / A : Math.cos(i), c = Math.sqrt(s * s + l * l * a * a), u = c * r;
  return u;
}
DM.default = vRn;
var U7e = ei && ei.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(G$, "__esModule", { value: !0 });
var bRn = U7e(hl), y2 = ar, Rxe = Eo, _Rn = Do, SRn = U7e(DM);
function QRn(t, e, n) {
  if (n === void 0 && (n = {}), n.method || (n.method = "geodesic"), n.units || (n.units = "kilometers"), !t)
    throw new Error("pt is required");
  if (Array.isArray(t) ? t = y2.point(t) : t.type === "Point" ? t = y2.feature(t) : Rxe.featureOf(t, "Point", "point"), !e)
    throw new Error("line is required");
  Array.isArray(e) ? e = y2.lineString(e) : e.type === "LineString" ? e = y2.feature(e) : Rxe.featureOf(e, "LineString", "line");
  var r = 1 / 0, i = t.geometry.coordinates;
  return _Rn.segmentEach(e, function(o) {
    var s = o.geometry.coordinates[0], a = o.geometry.coordinates[1], A = wRn(i, s, a, n);
    A < r && (r = A);
  }), y2.convertLength(r, "degrees", n.units);
}
function wRn(t, e, n, r) {
  var i = [n[0] - e[0], n[1] - e[1]], o = [t[0] - e[0], t[1] - e[1]], s = Dxe(o, i);
  if (s <= 0)
    return bJ(t, e, { method: r.method, units: "degrees" });
  var a = Dxe(i, i);
  if (a <= s)
    return bJ(t, n, { method: r.method, units: "degrees" });
  var A = s / a, l = [e[0] + A * i[0], e[1] + A * i[1]];
  return bJ(t, l, { method: r.method, units: "degrees" });
}
function Dxe(t, e) {
  return t[0] * e[0] + t[1] * e[1];
}
function bJ(t, e, n) {
  return n.method === "planar" ? SRn.default(t, e, n) : bRn.default(t, e, n);
}
G$.default = QRn;
const xRn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MAX_LATITUDE: BR,
  WebMercatorViewport: N_e,
  addMetersToLngLat: Hle,
  altitudeToFovy: tB,
  default: N_e,
  fitBounds: c$,
  flyToViewport: X$e,
  fovyToAltitude: uM,
  getBounds: jle,
  getDistanceScales: PT,
  getFlyToDuration: Z$e,
  getMeterZoom: Ule,
  getProjectionMatrix: V$e,
  getProjectionParameters: qle,
  getViewMatrix: $le,
  lngLatToWorld: Hc,
  normalizeViewportProps: J$e,
  pixelsToWorld: JC,
  scaleToZoom: Gle,
  unitsPerMeter: Ufn,
  worldToLngLat: Mf,
  worldToPixels: l$,
  zoomToScale: BU
}, Symbol.toStringTag, { value: "Module" })), H7e = /* @__PURE__ */ Fs(xRn);
Object.defineProperty(ao, "__esModule", {
  value: !0
});
ao.toDeckColor = kRn;
ao.recursivelyTraverseNestedArrays = Y7e;
ao.generatePointsParallelToLinePoints = GRn;
ao.distance2d = nne;
ao.mix = z7e;
ao.nearestPointOnProjectedLine = URn;
ao.nearestPointOnLine = HRn;
ao.getPickedEditHandle = $Rn;
ao.getPickedSnapSourceEditHandle = qRn;
ao.getNonGuidePicks = jRn;
ao.getPickedExistingEditHandle = YRn;
ao.getPickedIntermediateEditHandle = zRn;
ao.getPickedEditHandles = TM;
ao.getEditHandlesForGeometry = VRn;
var Txe = U$(DE), RRn = U$(zf), DRn = U$(G$), TRn = Do, ene = ar, Nxe = Eo, $7e = U$(H7e);
function U$(t) {
  return t && t.__esModule ? t : { default: t };
}
function Ib(t, e) {
  return MRn(t) || LRn(t, e) || j7e(t, e) || NRn();
}
function NRn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function LRn(t, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var n = [], r = !0, i = !1, o = void 0;
    try {
      for (var s = t[Symbol.iterator](), a; !(r = (a = s.next()).done) && (n.push(a.value), !(e && n.length === e)); r = !0)
        ;
    } catch (A) {
      i = !0, o = A;
    } finally {
      try {
        !r && s.return != null && s.return();
      } finally {
        if (i)
          throw o;
      }
    }
    return n;
  }
}
function MRn(t) {
  if (Array.isArray(t))
    return t;
}
function q7e(t) {
  return PRn(t) || FRn(t) || j7e(t) || ORn();
}
function ORn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function j7e(t, e) {
  if (t) {
    if (typeof t == "string")
      return tne(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return tne(t, e);
  }
}
function FRn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function PRn(t) {
  if (Array.isArray(t))
    return tne(t);
}
function tne(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function kRn(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [255, 0, 0, 255];
  return Array.isArray(t) ? [t[0] * 255, t[1] * 255, t[2] * 255, t[3] * 255] : e;
}
function Y7e(t, e, n) {
  if (!Array.isArray(t[0]))
    return !0;
  for (var r = 0; r < t.length; r++)
    if (Y7e(t[r], [].concat(q7e(e), [r]), n)) {
      n(t, e);
      break;
    }
  return !1;
}
function GRn(t, e, n) {
  var r = {
    type: "LineString",
    coordinates: [t, e]
  }, i = (0, ene.point)(n), o = (0, DRn.default)(i, r), s = (0, RRn.default)(t, e), a = (n[0] - t[0]) * (e[1] - t[1]) - (n[1] - t[1]) * (e[0] - t[0]), A = a < 0 ? s - 90 : s - 270, l = (0, Txe.default)(e, o, A), c = (0, Txe.default)(t, o, A);
  return [l.geometry.coordinates, c.geometry.coordinates];
}
function nne(t, e, n, r) {
  var i = t - n, o = e - r;
  return Math.sqrt(i * i + o * o);
}
function z7e(t, e, n) {
  return e * n + t * (1 - n);
}
function URn(t, e, n) {
  var r = new $7e.default(n), i = t.geometry.coordinates, o = i.map(function(U) {
    var X = Ib(U, 3), K = X[0], z = X[1], Y = X[2], V = Y === void 0 ? 0 : Y;
    return r.project([K, z, V]);
  }), s = r.project(e.geometry.coordinates), a = Ib(s, 2), A = a[0], l = a[1], c = 1 / 0, u = {};
  o.forEach(function(U, X) {
    var K = Ib(U, 2), z = K[0], Y = K[1];
    if (X !== 0) {
      var V = Ib(o[X - 1], 2), Z = V[0], ce = V[1], ee = ce - Y, pe = z - Z, Ce = Z * Y - z * ce, Be = ee * ee + pe * pe, Ie = Math.abs(ee * A + pe * l + Ce) / Math.sqrt(Be);
      Ie < c && (c = Ie, u = {
        index: X,
        x0: (pe * (pe * A - ee * l) - ee * Ce) / Be,
        y0: (ee * (-pe * A + ee * l) - pe * Ce) / Be
      });
    }
  });
  var f = u, h = f.index, d = f.x0, I = f.y0, m = Ib(o[h - 1], 3), C = m[0], y = m[1], v = m[2], b = v === void 0 ? 0 : v, Q = Ib(o[h], 3), w = Q[0], R = Q[1], M = Q[2], O = M === void 0 ? 0 : M, L = nne(C, y, w, R), N = nne(C, y, d, I), k = N / L, $ = z7e(b, O, k);
  return {
    type: "Feature",
    geometry: {
      type: "Point",
      coordinates: r.unproject([d, I, $])
    },
    properties: {
      // TODO: calculate the distance in proper units
      dist: c,
      index: h - 1
    }
  };
}
function HRn(t, e, n) {
  var r, i, o;
  n && (o = new $7e.default(n));
  var s = (0, ene.point)([1 / 0, 1 / 0], {
    dist: 1 / 0
  });
  return !(!((r = t.geometry) === null || r === void 0) && r.coordinates.length) || ((i = t.geometry) === null || i === void 0 ? void 0 : i.coordinates.length) < 2 || (0, TRn.flattenEach)(t, function(a) {
    var A = (0, Nxe.getCoords)(a), l = (0, Nxe.getCoords)(e), c, u, f, h, d, I, m;
    if (A.length > 1 && l.length) {
      var C, y;
      o ? (C = A.map(function(X) {
        return o.project(X);
      }), y = o.project(l)) : (C = A, y = l);
      for (var v = 1; v < C.length; v++) {
        if (C[v][0] !== C[v - 1][0]) {
          var b = (C[v][1] - C[v - 1][1]) / (C[v][0] - C[v - 1][0]), Q = C[v][1] - b * C[v][0];
          m = Math.abs(b * y[0] + Q - y[1]) / Math.sqrt(b * b + 1);
        } else
          m = Math.abs(y[0] - C[v][0]);
        var w = Math.pow(C[v][1] - C[v - 1][1], 2) + Math.pow(C[v][0] - C[v - 1][0], 2), R = Math.pow(C[v][1] - y[1], 2) + Math.pow(C[v][0] - y[0], 2), M = Math.pow(C[v - 1][1] - y[1], 2) + Math.pow(C[v - 1][0] - y[0], 2), O = Math.pow(m, 2), L = R - O + M - O;
        L > w && (m = Math.sqrt(Math.min(R, M))), (c == null || c > m) && (L > w ? M < R ? (u = 0, f = 1) : (f = 0, u = 1) : (u = Math.sqrt(M - O) / Math.sqrt(w), f = Math.sqrt(R - O) / Math.sqrt(w)), c = m, I = v);
      }
      var N = C[I - 1][0] - C[I][0], k = C[I - 1][1] - C[I][1];
      h = C[I - 1][0] - N * u, d = C[I - 1][1] - k * u;
    }
    var $ = {
      x: h,
      y: d,
      idx: I - 1,
      to: u,
      from: f
    };
    if (o) {
      var U = o.unproject([$.x, $.y]);
      $ = {
        x: U[0],
        y: U[1],
        idx: I - 1,
        to: u,
        from: f
      };
    }
    s = (0, ene.point)([$.x, $.y], {
      dist: Math.abs($.from - $.to),
      index: $.idx
    });
  }), s;
}
function $Rn(t) {
  var e = TM(t);
  return e.length ? e[0] : null;
}
function qRn(t) {
  var e = TM(t);
  return e.find(function(n) {
    return n.properties.editHandleType === "snap-source";
  });
}
function jRn(t) {
  return t && t.filter(function(e) {
    return !e.isGuide;
  });
}
function YRn(t) {
  var e = TM(t);
  return e.find(function(n) {
    var r = n.properties;
    return r.featureIndex >= 0 && r.editHandleType === "existing";
  });
}
function zRn(t) {
  var e = TM(t);
  return e.find(function(n) {
    var r = n.properties;
    return r.featureIndex >= 0 && r.editHandleType === "intermediate";
  });
}
function TM(t) {
  var e = t && t.filter(function(n) {
    return n.isGuide && n.object.properties.guideType === "editHandle";
  }).map(function(n) {
    return n.object;
  }) || [];
  return e;
}
function VRn(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "existing", r = [];
  switch (t.type) {
    case "Point":
      r = [{
        type: "Feature",
        properties: {
          guideType: "editHandle",
          editHandleType: n,
          positionIndexes: [],
          featureIndex: e
        },
        geometry: {
          type: "Point",
          coordinates: t.coordinates
        }
      }];
      break;
    case "MultiPoint":
    case "LineString":
      r = r.concat(_J(t.coordinates, [], e, n));
      break;
    case "Polygon":
    case "MultiLineString":
      for (var i = 0; i < t.coordinates.length; i++)
        r = r.concat(_J(t.coordinates[i], [i], e, n)), t.type === "Polygon" && (r = r.slice(0, -1));
      break;
    case "MultiPolygon":
      for (var o = 0; o < t.coordinates.length; o++)
        for (var s = 0; s < t.coordinates[o].length; s++)
          r = r.concat(_J(t.coordinates[o][s], [o, s], e, n)), r = r.slice(0, -1);
      break;
    default:
      throw Error("Unhandled geometry type: ".concat(t.type));
  }
  return r;
}
function _J(t, e, n) {
  for (var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "existing", i = [], o = 0; o < t.length; o++) {
    var s = t[o];
    i.push({
      type: "Feature",
      properties: {
        guideType: "editHandle",
        positionIndexes: [].concat(q7e(e), [o]),
        featureIndex: n,
        editHandleType: r
      },
      geometry: {
        type: "Point",
        coordinates: s
      }
    });
  }
  return i;
}
var Vf = {};
Object.defineProperty(Vf, "__esModule", {
  value: !0
});
Vf.ImmutableFeatureCollection = void 0;
function sl(t) {
  return XRn(t) || WRn(t) || KRn(t) || JRn();
}
function JRn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function KRn(t, e) {
  if (t) {
    if (typeof t == "string")
      return rne(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return rne(t, e);
  }
}
function WRn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function XRn(t) {
  if (Array.isArray(t))
    return rne(t);
}
function rne(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function Lxe(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function yy(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Lxe(Object(n), !0).forEach(function(r) {
      V7e(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Lxe(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function ZRn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Mxe(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function eDn(t, e, n) {
  return e && Mxe(t.prototype, e), n && Mxe(t, n), t;
}
function V7e(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var tDn = /* @__PURE__ */ function() {
  function t(e) {
    ZRn(this, t), V7e(this, "featureCollection", void 0), this.featureCollection = e;
  }
  return eDn(t, [{
    key: "getObject",
    value: function() {
      return this.featureCollection;
    }
    /**
     * Replaces the position deeply nested withing the given feature's geometry.
     * Works with Point, MultiPoint, LineString, MultiLineString, Polygon, and MultiPolygon.
     *
     * @param featureIndex The index of the feature to update
     * @param positionIndexes An array containing the indexes of the position to replace
     * @param updatedPosition The updated position to place in the result (i.e. [lng, lat])
     *
     * @returns A new `ImmutableFeatureCollection` with the given position replaced. Does not modify this `ImmutableFeatureCollection`.
     */
  }, {
    key: "replacePosition",
    value: function(n, r, i) {
      var o = this.featureCollection.features[n].geometry, s = o.type === "Polygon" || o.type === "MultiPolygon", a = yy({}, o, {
        coordinates: J7e(o.coordinates, r, i, s)
      });
      return this.replaceGeometry(n, a);
    }
    /**
     * Removes a position deeply nested in a GeoJSON geometry coordinates array.
     * Works with MultiPoint, LineString, MultiLineString, Polygon, and MultiPolygon.
     *
     * @param featureIndex The index of the feature to update
     * @param positionIndexes An array containing the indexes of the postion to remove
     *
     * @returns A new `ImmutableFeatureCollection` with the given coordinate removed. Does not modify this `ImmutableFeatureCollection`.
     */
  }, {
    key: "removePosition",
    value: function(n, r) {
      var i = this.featureCollection.features[n].geometry;
      if (i.type === "Point")
        throw Error("Can't remove a position from a Point or there'd be nothing left");
      if (i.type === "MultiPoint" && // only 1 point left
      i.coordinates.length < 2)
        throw Error("Can't remove the last point of a MultiPoint or there'd be nothing left");
      if (i.type === "LineString" && // only 2 positions
      i.coordinates.length < 3)
        throw Error("Can't remove position. LineString must have at least two positions");
      if (i.type === "Polygon" && // outer ring is a triangle
      i.coordinates[0].length < 5 && Array.isArray(r) && // trying to remove from outer ring
      r[0] === 0)
        throw Error("Can't remove position. Polygon's outer ring must have at least four positions");
      if (i.type === "MultiLineString" && // only 1 LineString left
      i.coordinates.length === 1 && // only 2 positions
      i.coordinates[0].length < 3)
        throw Error("Can't remove position. MultiLineString must have at least two positions");
      if (i.type === "MultiPolygon" && // only 1 polygon left
      i.coordinates.length === 1 && // outer ring is a triangle
      i.coordinates[0][0].length < 5 && Array.isArray(r) && // trying to remove from first polygon
      r[0] === 0 && // trying to remove from outer ring
      r[1] === 0)
        throw Error("Can't remove position. MultiPolygon's outer ring must have at least four positions");
      var o = i.type === "Polygon" || i.type === "MultiPolygon", s = yy({}, i, {
        coordinates: K7e(i.coordinates, r, o)
      });
      return nDn(s), this.replaceGeometry(n, s);
    }
    /**
     * Adds a position deeply nested in a GeoJSON geometry coordinates array.
     * Works with MultiPoint, LineString, MultiLineString, Polygon, and MultiPolygon.
     *
     * @param featureIndex The index of the feature to update
     * @param positionIndexes An array containing the indexes of the position that will proceed the new position
     * @param positionToAdd The new position to place in the result (i.e. [lng, lat])
     *
     * @returns A new `ImmutableFeatureCollection` with the given coordinate removed. Does not modify this `ImmutableFeatureCollection`.
     */
  }, {
    key: "addPosition",
    value: function(n, r, i) {
      var o = this.featureCollection.features[n].geometry;
      if (o.type === "Point")
        throw new Error("Unable to add a position to a Point feature");
      o.type === "Polygon" || o.type;
      var s = yy({}, o, {
        coordinates: W7e(o.coordinates, r, i)
      });
      return this.replaceGeometry(n, s);
    }
  }, {
    key: "replaceGeometry",
    value: function(n, r) {
      var i = yy({}, this.featureCollection.features[n], {
        geometry: r
      }), o = yy({}, this.featureCollection, {
        features: [].concat(sl(this.featureCollection.features.slice(0, n)), [i], sl(this.featureCollection.features.slice(n + 1)))
      });
      return new t(o);
    }
  }, {
    key: "addFeature",
    value: function(n) {
      return this.addFeatures([n]);
    }
  }, {
    key: "addFeatures",
    value: function(n) {
      var r = yy({}, this.featureCollection, {
        features: [].concat(sl(this.featureCollection.features), sl(n))
      });
      return new t(r);
    }
  }, {
    key: "deleteFeature",
    value: function(n) {
      return this.deleteFeatures([n]);
    }
  }, {
    key: "deleteFeatures",
    value: function(n) {
      var r = sl(this.featureCollection.features);
      n.sort();
      for (var i = n.length - 1; i >= 0; i--) {
        var o = n[i];
        o >= 0 && o < r.length && r.splice(o, 1);
      }
      var s = yy({}, this.featureCollection, {
        features: r
      });
      return new t(s);
    }
  }]), t;
}();
Vf.ImmutableFeatureCollection = tDn;
function LP(t, e) {
  if (t.length === 2 && e.length === 3) {
    var n = e[2];
    return [t[0], t[1], n];
  }
  return t;
}
function J7e(t, e, n, r) {
  if (!e)
    return t;
  if (e.length === 0)
    return LP(n, t);
  if (e.length === 1) {
    var i = [].concat(sl(t.slice(0, e[0])), [LP(n, t[e[0]])], sl(t.slice(e[0] + 1)));
    return r && (e[0] === 0 || e[0] === t.length - 1) && (i[0] = LP(n, t[0]), i[t.length - 1] = LP(n, t[0])), i;
  }
  return [].concat(sl(t.slice(0, e[0])), [J7e(t[e[0]], e.slice(1, e.length), n, r)], sl(t.slice(e[0] + 1)));
}
function K7e(t, e, n) {
  if (!e)
    return t;
  if (e.length === 0)
    throw Error("Must specify the index of the position to remove");
  if (e.length === 1) {
    var r = [].concat(sl(t.slice(0, e[0])), sl(t.slice(e[0] + 1)));
    return n && (e[0] === 0 || e[0] === t.length - 1) && (e[0] === 0 ? r[r.length - 1] = r[0] : e[0] === t.length - 1 && (r[0] = r[r.length - 1])), r;
  }
  return [].concat(sl(t.slice(0, e[0])), [K7e(t[e[0]], e.slice(1, e.length), n)], sl(t.slice(e[0] + 1)));
}
function W7e(t, e, n, r) {
  if (!e)
    return t;
  if (e.length === 0)
    throw Error("Must specify the index of the position to remove");
  if (e.length === 1) {
    var i = [].concat(sl(t.slice(0, e[0])), [n], sl(t.slice(e[0])));
    return i;
  }
  return [].concat(sl(t.slice(0, e[0])), [W7e(t[e[0]], e.slice(1, e.length), n)], sl(t.slice(e[0] + 1)));
}
function nDn(t) {
  switch (t.type) {
    case "Polygon":
      rDn(t);
      break;
    case "MultiLineString":
      iDn(t);
      break;
    case "MultiPolygon":
      oDn(t);
      break;
  }
}
function rDn(t) {
  for (var e = t.coordinates, n = 1; n < e.length; n++)
    X7e(e, n) && n--;
}
function iDn(t) {
  for (var e = 0; e < t.coordinates.length; e++) {
    var n = t.coordinates[e];
    n.length === 1 && (t.coordinates.splice(e, 1), e--);
  }
}
function oDn(t) {
  for (var e = 0; e < t.coordinates.length; e++) {
    var n = t.coordinates[e], r = n[0];
    r.length <= 3 && (t.coordinates.splice(e, 1), e--);
    for (var i = 1; i < n.length; i++)
      X7e(n, i) && i--;
  }
}
function X7e(t, e) {
  var n = t[e];
  return n.length <= 3 ? (t.splice(e, 1), !0) : !1;
}
Object.defineProperty(ts, "__esModule", {
  value: !0
});
ts.getIntermediatePosition = EDn;
ts.GeoJsonEditMode = void 0;
var sDn = H$(mue), aDn = H$(O$), ADn = H$(Cue), lDn = H$(mRn), Oxe = ao, SJ = Vf;
function H$(t) {
  return t && t.__esModule ? t : { default: t };
}
function cDn(t) {
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (t = Z7e(t))) {
      var e = 0, n = function() {
      };
      return { s: n, n: function() {
        return e >= t.length ? { done: !0 } : { done: !1, value: t[e++] };
      }, e: function(A) {
        throw A;
      }, f: n };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var r, i = !0, o = !1, s;
  return { s: function() {
    r = t[Symbol.iterator]();
  }, n: function() {
    var A = r.next();
    return i = A.done, A;
  }, e: function(A) {
    o = !0, s = A;
  }, f: function() {
    try {
      !i && r.return != null && r.return();
    } finally {
      if (o)
        throw s;
    }
  } };
}
function Fxe(t) {
  return gDn(t) || fDn(t) || Z7e(t) || uDn();
}
function uDn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Z7e(t, e) {
  if (t) {
    if (typeof t == "string")
      return ine(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return ine(t, e);
  }
}
function fDn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function gDn(t) {
  if (Array.isArray(t))
    return ine(t);
}
function ine(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function hDn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Pxe(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function dDn(t, e, n) {
  return e && Pxe(t.prototype, e), n && Pxe(t, n), t;
}
function pDn(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var IDn = {
  type: "FeatureCollection",
  features: []
}, mDn = [], CDn = /* @__PURE__ */ function() {
  function t() {
    hDn(this, t), pDn(this, "_clickSequence", []);
  }
  return dDn(t, [{
    key: "getGuides",
    value: function(n) {
      return IDn;
    }
  }, {
    key: "getTooltips",
    value: function(n) {
      return mDn;
    }
  }, {
    key: "getSelectedFeature",
    value: function(n) {
      return n.selectedIndexes.length === 1 ? n.data.features[n.selectedIndexes[0]] : null;
    }
  }, {
    key: "getSelectedGeometry",
    value: function(n) {
      var r = this.getSelectedFeature(n);
      return r ? r.geometry : null;
    }
  }, {
    key: "getSelectedFeaturesAsFeatureCollection",
    value: function(n) {
      var r = n.data.features, i = n.selectedIndexes.map(function(o) {
        return r[o];
      });
      return {
        type: "FeatureCollection",
        features: i
      };
    }
  }, {
    key: "getClickSequence",
    value: function() {
      return this._clickSequence;
    }
  }, {
    key: "addClickSequence",
    value: function(n) {
      var r = n.mapCoords;
      this._clickSequence.push(r);
    }
  }, {
    key: "resetClickSequence",
    value: function() {
      this._clickSequence = [];
    }
  }, {
    key: "getTentativeGuide",
    value: function(n) {
      var r = this.getGuides(n);
      return r.features.find(function(i) {
        return i.properties && i.properties.guideType === "tentative";
      });
    }
  }, {
    key: "isSelectionPicked",
    value: function(n, r) {
      if (!n.length)
        return !1;
      var i = (0, Oxe.getNonGuidePicks)(n).map(function(a) {
        var A = a.index;
        return A;
      }), o = (0, Oxe.getPickedEditHandles)(n).map(function(a) {
        var A = a.properties;
        return A.featureIndex;
      }), s = new Set([].concat(Fxe(i), Fxe(o)));
      return r.selectedIndexes.some(function(a) {
        return s.has(a);
      });
    }
  }, {
    key: "rewindPolygon",
    value: function(n) {
      var r = n.geometry, i = r.type === "Polygon" || r.type === "MultiPolygon";
      return i ? (0, lDn.default)(n) : n;
    }
  }, {
    key: "getAddFeatureAction",
    value: function(n, r) {
      var i = n, o = i.type === "Feature" ? i : {
        type: "Feature",
        properties: {},
        geometry: i
      }, s = this.rewindPolygon(o), a = new SJ.ImmutableFeatureCollection(r).addFeature(s).getObject();
      return {
        updatedData: a,
        editType: "addFeature",
        editContext: {
          featureIndexes: [a.features.length - 1]
        }
      };
    }
  }, {
    key: "getAddManyFeaturesAction",
    value: function(n, r) {
      var i = n.features, o = new SJ.ImmutableFeatureCollection(r), s = o.getObject().features.length, a = [], A = cDn(i), l;
      try {
        for (A.s(); !(l = A.n()).done; ) {
          var c = l.value, u = c.properties, f = c.geometry, h = f;
          o = o.addFeature({
            type: "Feature",
            properties: u,
            geometry: h
          }), a.push(s + a.length);
        }
      } catch (d) {
        A.e(d);
      } finally {
        A.f();
      }
      return {
        updatedData: o.getObject(),
        editType: "addFeature",
        editContext: {
          featureIndexes: a
        }
      };
    }
  }, {
    key: "getAddFeatureOrBooleanPolygonAction",
    value: function(n, r) {
      var i = n, o = this.getSelectedFeature(r), s = r.modeConfig;
      if (s && s.booleanOperation) {
        if (!o || o.geometry.type !== "Polygon" && o.geometry.type !== "MultiPolygon")
          return console.warn("booleanOperation only supported for single Polygon or MultiPolygon selection"), null;
        var a = i.type === "Feature" ? i : {
          type: "Feature",
          geometry: i
        }, A;
        if (s.booleanOperation === "union")
          A = (0, sDn.default)(o, a);
        else if (s.booleanOperation === "difference")
          A = (0, aDn.default)(o, a);
        else if (s.booleanOperation === "intersection")
          A = (0, ADn.default)(o, a);
        else
          return console.warn("Invalid booleanOperation ".concat(s.booleanOperation)), null;
        if (!A)
          return console.warn("Canceling edit. Boolean operation erased entire polygon."), null;
        var l = r.selectedIndexes[0], c = new SJ.ImmutableFeatureCollection(r.data).replaceGeometry(l, A.geometry).getObject(), u = {
          updatedData: c,
          editType: "unionGeometry",
          editContext: {
            featureIndexes: [l]
          }
        };
        return u;
      }
      return this.getAddFeatureAction(n, r.data);
    }
  }, {
    key: "createTentativeFeature",
    value: function(n) {
      return null;
    }
  }, {
    key: "handleClick",
    value: function(n, r) {
    }
  }, {
    key: "handlePointerMove",
    value: function(n, r) {
      var i = this.createTentativeFeature(r);
      i && r.onEdit({
        updatedData: r.data,
        editType: "updateTentativeFeature",
        editContext: {
          feature: i
        }
      });
    }
  }, {
    key: "handleStartDragging",
    value: function(n, r) {
    }
  }, {
    key: "handleStopDragging",
    value: function(n, r) {
    }
  }, {
    key: "handleDragging",
    value: function(n, r) {
    }
  }, {
    key: "handleKeyUp",
    value: function(n, r) {
      n.key === "Escape" && (this.resetClickSequence(), r.onEdit({
        // Because the new drawing feature is dropped, so the data will keep as the same.
        updatedData: r.data,
        editType: "cancelFeature",
        editContext: {}
      }));
    }
  }]), t;
}();
ts.GeoJsonEditMode = CDn;
function EDn(t, e) {
  var n = [(t[0] + e[0]) / 2, (t[1] + e[1]) / 2];
  return n;
}
var jw = {};
Object.defineProperty(jw, "__esModule", {
  value: !0
});
jw.ModifyMode = void 0;
var kxe = ar, Ch = ao, yDn = ts, v2 = Vf;
function Xk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xk = function(n) {
    return typeof n;
  } : Xk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Xk(t);
}
function Gxe(t) {
  return bDn(t) || BDn(t) || eVe(t) || vDn();
}
function vDn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function BDn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function bDn(t) {
  if (Array.isArray(t))
    return one(t);
}
function _Dn(t) {
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (t = eVe(t))) {
      var e = 0, n = function() {
      };
      return { s: n, n: function() {
        return e >= t.length ? { done: !0 } : { done: !1, value: t[e++] };
      }, e: function(A) {
        throw A;
      }, f: n };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var r, i = !0, o = !1, s;
  return { s: function() {
    r = t[Symbol.iterator]();
  }, n: function() {
    var A = r.next();
    return i = A.done, A;
  }, e: function(A) {
    o = !0, s = A;
  }, f: function() {
    try {
      !i && r.return != null && r.return();
    } finally {
      if (o)
        throw s;
    }
  } };
}
function eVe(t, e) {
  if (t) {
    if (typeof t == "string")
      return one(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return one(t, e);
  }
}
function one(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function SDn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Uxe(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function QDn(t, e, n) {
  return e && Uxe(t.prototype, e), n && Uxe(t, n), t;
}
function wDn(t) {
  return function() {
    var e = h8(t), n;
    if (DDn()) {
      var r = h8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return xDn(this, n);
  };
}
function xDn(t, e) {
  return e && (Xk(e) === "object" || typeof e == "function") ? e : RDn(t);
}
function RDn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function DDn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function h8(t) {
  return h8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, h8(t);
}
function TDn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && sne(t, e);
}
function sne(t, e) {
  return sne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, sne(t, e);
}
var NDn = /* @__PURE__ */ function(t) {
  TDn(n, t);
  var e = wDn(n);
  function n() {
    return SDn(this, n), e.apply(this, arguments);
  }
  return QDn(n, [{
    key: "getGuides",
    value: function(i) {
      var o = this, s = [], a = i.data, A = i.lastPointerMoveEvent, l = a.features, c = A && A.picks, u = A && A.mapCoords, f = _Dn(i.selectedIndexes), h;
      try {
        for (f.s(); !(h = f.n()).done; ) {
          var d = h.value;
          if (d < l.length) {
            var I = l[d].geometry;
            s.push.apply(s, Gxe((0, Ch.getEditHandlesForGeometry)(I, d)));
          } else
            console.warn("selectedFeatureIndexes out of range ".concat(d));
        }
      } catch (M) {
        f.e(M);
      } finally {
        f.f();
      }
      if (c && c.length && u) {
        var m = (0, Ch.getPickedExistingEditHandle)(c), C = !m && c.find(function(M) {
          return !M.isGuide;
        });
        if (C && !C.object.geometry.type.includes("Point") && i.selectedIndexes.includes(C.index)) {
          var y = null, v = [], b = (0, kxe.point)(u);
          if ((0, Ch.recursivelyTraverseNestedArrays)(C.object.geometry.coordinates, [], function(M, O) {
            var L = (0, kxe.lineString)(M), N = o.getNearestPoint(
              // @ts-ignore
              L,
              b,
              i.modeConfig && i.modeConfig.viewport
            );
            (!y || N.properties.dist < y.properties.dist) && (y = N, v = O);
          }), y) {
            var Q = y, w = Q.geometry.coordinates, R = Q.properties.index;
            s.push({
              type: "Feature",
              properties: {
                guideType: "editHandle",
                editHandleType: "intermediate",
                featureIndex: C.index,
                positionIndexes: [].concat(Gxe(v), [R + 1])
              },
              geometry: {
                type: "Point",
                coordinates: w
              }
            });
          }
        }
      }
      return {
        type: "FeatureCollection",
        features: s
      };
    }
    // turf.js does not support elevation for nearestPointOnLine
  }, {
    key: "getNearestPoint",
    value: function(i, o, s) {
      var a = i.geometry.coordinates;
      if (a.some(function(A) {
        return A.length > 2;
      })) {
        if (s)
          return (0, Ch.nearestPointOnProjectedLine)(i, o, s);
        console.log("Editing 3D point but modeConfig.viewport not provided. Falling back to 2D logic.");
      }
      return (0, Ch.nearestPointOnLine)(i, o, s);
    }
  }, {
    key: "handleClick",
    value: function(i, o) {
      var s = (0, Ch.getPickedExistingEditHandle)(i.picks), a = (0, Ch.getPickedIntermediateEditHandle)(i.picks);
      if (s) {
        var A = s.properties, l = A.featureIndex, c = A.positionIndexes, u;
        try {
          u = new v2.ImmutableFeatureCollection(o.data).removePosition(l, c).getObject();
        } catch {
        }
        u && o.onEdit({
          updatedData: u,
          editType: "removePosition",
          editContext: {
            featureIndexes: [l],
            positionIndexes: c,
            position: s.geometry.coordinates
          }
        });
      } else if (a) {
        var f = a.properties, h = f.featureIndex, d = f.positionIndexes, I = new v2.ImmutableFeatureCollection(o.data).addPosition(h, d, a.geometry.coordinates).getObject();
        I && o.onEdit({
          updatedData: I,
          editType: "addPosition",
          editContext: {
            featureIndexes: [h],
            positionIndexes: d,
            position: a.geometry.coordinates
          }
        });
      }
    }
  }, {
    key: "handleDragging",
    value: function(i, o) {
      var s = (0, Ch.getPickedEditHandle)(i.pointerDownPicks);
      if (s) {
        i.cancelPan();
        var a = s.properties, A = new v2.ImmutableFeatureCollection(o.data).replacePosition(a.featureIndex, a.positionIndexes, i.mapCoords).getObject();
        o.onEdit({
          updatedData: A,
          editType: "movePosition",
          editContext: {
            featureIndexes: [a.featureIndex],
            positionIndexes: a.positionIndexes,
            position: i.mapCoords
          }
        });
      }
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      var s = this.getCursor(i);
      o.onUpdateCursor(s);
    }
  }, {
    key: "handleStartDragging",
    value: function(i, o) {
      var s = o.selectedIndexes, a = (0, Ch.getPickedIntermediateEditHandle)(i.picks);
      if (s.length && a) {
        var A = a.properties, l = new v2.ImmutableFeatureCollection(o.data).addPosition(A.featureIndex, A.positionIndexes, i.mapCoords).getObject();
        o.onEdit({
          updatedData: l,
          editType: "addPosition",
          editContext: {
            featureIndexes: [A.featureIndex],
            positionIndexes: A.positionIndexes,
            position: i.mapCoords
          }
        });
      }
    }
  }, {
    key: "handleStopDragging",
    value: function(i, o) {
      var s = o.selectedIndexes, a = (0, Ch.getPickedEditHandle)(i.picks);
      if (s.length && a) {
        var A = a.properties, l = new v2.ImmutableFeatureCollection(o.data).replacePosition(A.featureIndex, A.positionIndexes, i.mapCoords).getObject();
        o.onEdit({
          updatedData: l,
          editType: "finishMovePosition",
          editContext: {
            featureIndexes: [A.featureIndex],
            positionIndexes: A.positionIndexes,
            position: i.mapCoords
          }
        });
      }
    }
  }, {
    key: "getCursor",
    value: function(i) {
      var o = i && i.picks || [], s = (0, Ch.getPickedEditHandles)(o);
      return s.length ? "cell" : null;
    }
  }]), n;
}(yDn.GeoJsonEditMode);
jw.ModifyMode = NDn;
var $$ = {}, q$ = {};
const LDn = /* @__PURE__ */ Fs(CQn), MDn = /* @__PURE__ */ Fs(EQn), ODn = /* @__PURE__ */ Fs(yQn), FDn = /* @__PURE__ */ Fs(vQn), Bue = /* @__PURE__ */ Fs(wSn);
var j$ = ei && ei.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(q$, "__esModule", { value: !0 });
var PDn = j$(LDn), B2 = j$(MDn), Hxe = j$(ODn), kDn = j$(FDn), GDn = T$, b2 = BM, UDn = Bue;
function HDn(t, e, n) {
  n === void 0 && (n = {});
  var r = b2.point([1 / 0, 1 / 0], {
    dist: 1 / 0
  }), i = 0;
  return GDn.flattenEach(t, function(o) {
    for (var s = UDn.getCoords(o), a = 0; a < s.length - 1; a++) {
      var A = b2.point(s[a]);
      A.properties.dist = B2.default(e, A, n);
      var l = b2.point(s[a + 1]);
      l.properties.dist = B2.default(e, l, n);
      var c = B2.default(A, l, n), u = Math.max(A.properties.dist, l.properties.dist), f = PDn.default(A, l), h = Hxe.default(e, u, f + 90, n), d = Hxe.default(e, u, f - 90, n), I = kDn.default(b2.lineString([
        h.geometry.coordinates,
        d.geometry.coordinates
      ]), b2.lineString([A.geometry.coordinates, l.geometry.coordinates])), m = null;
      I.features.length > 0 && (m = I.features[0], m.properties.dist = B2.default(e, m, n), m.properties.location = i + B2.default(A, m, n)), A.properties.dist < r.properties.dist && (r = A, r.properties.index = a, r.properties.location = i), l.properties.dist < r.properties.dist && (r = l, r.properties.index = a + 1, r.properties.location = i + c), m && m.properties.dist < r.properties.dist && (r = m, r.properties.index = a), i += c;
    }
  }), r;
}
q$.default = HDn;
var NM = {}, $Dn = ei && ei.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(NM, "__esModule", { value: !0 });
var qDn = $Dn(DE), jDn = ar;
function YDn(t, e, n) {
  n === void 0 && (n = {});
  for (var r = n.steps || 64, i = n.properties ? n.properties : !Array.isArray(t) && t.type === "Feature" && t.properties ? t.properties : {}, o = [], s = 0; s < r; s++)
    o.push(qDn.default(t, e, s * -360 / r, n).geometry.coordinates);
  return o.push(o[0]), jDn.polygon([o], i);
}
NM.default = YDn;
Object.defineProperty($$, "__esModule", {
  value: !0
});
$$.ResizeCircleMode = void 0;
var zDn = Y$(q$), $xe = ar, VDn = Y$(NM), JDn = Y$(hl), KDn = Y$(Uw), _2 = ao, WDn = ts, XDn = Vf;
function Y$(t) {
  return t && t.__esModule ? t : { default: t };
}
function Zk(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Zk = function(n) {
    return typeof n;
  } : Zk = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Zk(t);
}
function ZDn(t) {
  return rTn(t) || nTn(t) || tTn(t) || eTn();
}
function eTn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tTn(t, e) {
  if (t) {
    if (typeof t == "string")
      return ane(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return ane(t, e);
  }
}
function nTn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function rTn(t) {
  if (Array.isArray(t))
    return ane(t);
}
function ane(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function iTn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function qxe(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function oTn(t, e, n) {
  return e && qxe(t.prototype, e), n && qxe(t, n), t;
}
function sTn(t) {
  return function() {
    var e = d8(t), n;
    if (ATn()) {
      var r = d8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return aTn(this, n);
  };
}
function aTn(t, e) {
  return e && (Zk(e) === "object" || typeof e == "function") ? e : Ane(t);
}
function Ane(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function ATn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function d8(t) {
  return d8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, d8(t);
}
function lTn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && lne(t, e);
}
function lne(t, e) {
  return lne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, lne(t, e);
}
function jxe(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var cTn = /* @__PURE__ */ function(t) {
  lTn(n, t);
  var e = sTn(n);
  function n() {
    var r;
    iTn(this, n);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)), jxe(Ane(r), "_selectedEditHandle", void 0), jxe(Ane(r), "_isResizing", !1), r;
  }
  return oTn(n, [{
    key: "getGuides",
    value: function(i) {
      var o = this, s = [], a = i.selectedIndexes, A = i.lastPointerMoveEvent, l = A && A.picks, c = A && A.mapCoords;
      if (l && l.length && c && a.length === 1 && !this._isResizing) {
        var u = l.find(function(y) {
          return !y.isGuide;
        });
        if (u && u.object.properties.shape && u.object.properties.shape.includes("Circle") && i.selectedIndexes.includes(u.index)) {
          var f = null, h = [], d = (0, $xe.point)(c);
          if ((0, _2.recursivelyTraverseNestedArrays)(u.object.geometry.coordinates, [], function(y, v) {
            var b = (0, $xe.lineString)(y), Q = o.getNearestPoint(
              // @ts-ignore
              b,
              d,
              i.modeConfig && i.modeConfig.viewport
            );
            (!f || Q.properties.dist < f.properties.dist) && (f = Q, h = v);
          }), f) {
            var I = f, m = I.geometry.coordinates, C = I.properties.index;
            s.push({
              type: "Feature",
              properties: {
                guideType: "editHandle",
                editHandleType: "intermediate",
                featureIndex: u.index,
                positionIndexes: [].concat(ZDn(h), [C + 1])
              },
              geometry: {
                type: "Point",
                coordinates: m
              }
            });
          }
        }
      }
      return {
        type: "FeatureCollection",
        features: s
      };
    }
    // turf.js does not support elevation for nearestPointOnLine
  }, {
    key: "getNearestPoint",
    value: function(i, o, s) {
      var a = i.geometry.coordinates;
      if (a.some(function(A) {
        return A.length > 2;
      })) {
        if (s)
          return (0, _2.nearestPointOnProjectedLine)(i, o, s);
        console.log("Editing 3D point but modeConfig.viewport not provided. Falling back to 2D logic.");
      }
      return (0, zDn.default)(i, o);
    }
  }, {
    key: "handleDragging",
    value: function(i, o) {
      var s = (0, _2.getPickedEditHandle)(i.pointerDownPicks);
      if (s) {
        i.cancelPan();
        var a = s.properties, A = this.getSelectedFeature(o), l = (0, KDn.default)(A).geometry.coordinates, c = Object.entries(A.geometry.coordinates[0]).length - 1, u = Math.max((0, JDn.default)(l, i.mapCoords), 1e-3), f = {}, h = f.steps, d = h === void 0 ? c : h, I = {
          steps: d
        }, m = (0, VDn.default)(l, u, I), C = m.geometry, y = new XDn.ImmutableFeatureCollection(o.data).replaceGeometry(a.featureIndex, C).getObject();
        o.onEdit({
          updatedData: y,
          editType: "unionGeometry",
          editContext: {
            featureIndexes: [a.featureIndex]
          }
        });
      }
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      if (!this._isResizing) {
        var s = (0, _2.getPickedEditHandle)(i.picks);
        this._selectedEditHandle = s && s.properties.editHandleType === "intermediate" ? s : null;
      }
      var a = this.getCursor(i);
      o.onUpdateCursor(a);
    }
  }, {
    key: "handleStartDragging",
    value: function(i, o) {
      this._selectedEditHandle && (this._isResizing = !0);
    }
  }, {
    key: "handleStopDragging",
    value: function(i, o) {
      this._isResizing && (this._selectedEditHandle = null, this._isResizing = !1);
    }
  }, {
    key: "getCursor",
    value: function(i) {
      var o = i && i.picks || [], s = (0, _2.getPickedEditHandles)(o);
      return s.length ? "cell" : null;
    }
  }]), n;
}(WDn.GeoJsonEditMode);
$$.ResizeCircleMode = cTn;
var Yw = {}, bue = { exports: {} }, zw = {};
Object.defineProperty(zw, "__esModule", { value: !0 });
var xD = ar, uTn = Eo;
function fTn(t, e, n, r) {
  r === void 0 && (r = {});
  var i = e < 0, o = xD.convertLength(Math.abs(e), r.units, "meters");
  i && (o = -Math.abs(o));
  var s = uTn.getCoord(t), a = gTn(s, o, n);
  return a[0] += a[0] - s[0] > 180 ? -360 : s[0] - a[0] > 180 ? 360 : 0, xD.point(a, r.properties);
}
function gTn(t, e, n, r) {
  r = r === void 0 ? xD.earthRadius : Number(r);
  var i = e / r, o = t[0] * Math.PI / 180, s = xD.degreesToRadians(t[1]), a = xD.degreesToRadians(n), A = i * Math.cos(a), l = s + A;
  Math.abs(l) > Math.PI / 2 && (l = l > 0 ? Math.PI - l : -Math.PI - l);
  var c = Math.log(Math.tan(l / 2 + Math.PI / 4) / Math.tan(s / 2 + Math.PI / 4)), u = Math.abs(c) > 1e-11 ? A / c : Math.cos(s), f = i * Math.sin(a) / u, h = o + f;
  return [
    (h * 180 / Math.PI + 540) % 360 - 180,
    l * 180 / Math.PI
  ];
}
zw.default = fTn;
var hTn = Do, dTn = ar, pTn = Eo, ITn = qw, mTn = zw;
function tVe(t) {
  return t && typeof t == "object" && "default" in t ? t : { default: t };
}
var CTn = /* @__PURE__ */ tVe(ITn), ETn = /* @__PURE__ */ tVe(mTn);
function nVe(t, e, n, r) {
  if (r = r || {}, !dTn.isObject(r))
    throw new Error("options is invalid");
  var i = r.units, o = r.zTranslation, s = r.mutate;
  if (!t)
    throw new Error("geojson is required");
  if (e == null || isNaN(e))
    throw new Error("distance is required");
  if (o && typeof o != "number" && isNaN(o))
    throw new Error("zTranslation is not a number");
  if (o = o !== void 0 ? o : 0, e === 0 && o === 0)
    return t;
  if (n == null || isNaN(n))
    throw new Error("direction is required");
  return e < 0 && (e = -e, n = n + 180), (s === !1 || s === void 0) && (t = CTn.default(t)), hTn.coordEach(t, function(a) {
    var A = pTn.getCoords(
      ETn.default(a, e, n, { units: i })
    );
    a[0] = A[0], a[1] = A[1], o && a.length === 3 && (a[2] += o);
  }), t;
}
bue.exports = nVe;
bue.exports.default = nVe;
var yTn = bue.exports;
Object.defineProperty(Yw, "__esModule", {
  value: !0
});
Yw.TranslateMode = void 0;
var vTn = _ue(zf), BTn = _ue(hl), bTn = _ue(yTn), Yxe = ar, _Tn = ts, STn = Vf;
function _ue(t) {
  return t && t.__esModule ? t : { default: t };
}
function eG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? eG = function(n) {
    return typeof n;
  } : eG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, eG(t);
}
function QTn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function zxe(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function wTn(t, e, n) {
  return e && zxe(t.prototype, e), n && zxe(t, n), t;
}
function xTn(t) {
  return function() {
    var e = p8(t), n;
    if (DTn()) {
      var r = p8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return RTn(this, n);
  };
}
function RTn(t, e) {
  return e && (eG(e) === "object" || typeof e == "function") ? e : cne(t);
}
function cne(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function DTn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function p8(t) {
  return p8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, p8(t);
}
function TTn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && une(t, e);
}
function une(t, e) {
  return une = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, une(t, e);
}
function Vxe(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var NTn = /* @__PURE__ */ function(t) {
  TTn(n, t);
  var e = xTn(n);
  function n() {
    var r;
    QTn(this, n);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)), Vxe(cne(r), "_geometryBeforeTranslate", void 0), Vxe(cne(r), "_isTranslatable", void 0), r;
  }
  return wTn(n, [{
    key: "handleDragging",
    value: function(i, o) {
      if (this._isTranslatable) {
        if (this._geometryBeforeTranslate) {
          var s = this.getTranslateAction(i.pointerDownMapCoords, i.mapCoords, "translating", o);
          s && o.onEdit(s);
        }
        i.cancelPan();
      }
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      this._isTranslatable = this.isSelectionPicked(i.pointerDownPicks || i.picks, o), this.updateCursor(o);
    }
  }, {
    key: "handleStartDragging",
    value: function(i, o) {
      this._isTranslatable && (this._geometryBeforeTranslate = this.getSelectedFeaturesAsFeatureCollection(o));
    }
  }, {
    key: "handleStopDragging",
    value: function(i, o) {
      if (this._geometryBeforeTranslate) {
        var s = this.getTranslateAction(i.pointerDownMapCoords, i.mapCoords, "translated", o);
        s && o.onEdit(s), this._geometryBeforeTranslate = null;
      }
    }
  }, {
    key: "updateCursor",
    value: function(i) {
      this._isTranslatable ? i.onUpdateCursor("move") : i.onUpdateCursor(null);
    }
  }, {
    key: "getTranslateAction",
    value: function(i, o, s, a) {
      if (!this._geometryBeforeTranslate)
        return null;
      for (var A = (0, Yxe.point)(i), l = (0, Yxe.point)(o), c = (0, BTn.default)(A, l), u = (0, vTn.default)(A, l), f = (0, bTn.default)(
        // @ts-ignore
        this._geometryBeforeTranslate,
        c,
        u
      ), h = new STn.ImmutableFeatureCollection(a.data), d = a.selectedIndexes, I = 0; I < d.length; I++) {
        var m = d[I], C = f.features[I];
        h = h.replaceGeometry(m, C.geometry);
      }
      return {
        updatedData: h.getObject(),
        editType: s,
        editContext: {
          featureIndexes: d
        }
      };
    }
  }]), n;
}(_Tn.GeoJsonEditMode);
Yw.TranslateMode = NTn;
var LM = {}, a1 = {};
Object.defineProperty(a1, "__esModule", { value: !0 });
var LTn = T$, MTn = BM;
function OTn(t, e) {
  e === void 0 && (e = {});
  var n = 0, r = 0, i = 0;
  return LTn.coordEach(t, function(o) {
    n += o[0], r += o[1], i++;
  }, !0), MTn.point([n / i, r / i], e.properties);
}
a1.default = OTn;
var TE = {};
Object.defineProperty(TE, "__esModule", { value: !0 });
var fne = ar, Sue = Eo;
function FTn(t, e) {
  e === void 0 && (e = {});
  var n = Sue.getGeom(t);
  switch (!e.properties && t.type === "Feature" && (e.properties = t.properties), n.type) {
    case "Polygon":
      return rVe(n, e);
    case "MultiPolygon":
      return iVe(n, e);
    default:
      throw new Error("invalid poly");
  }
}
TE.default = FTn;
function rVe(t, e) {
  e === void 0 && (e = {});
  var n = Sue.getGeom(t), r = n.coordinates, i = e.properties ? e.properties : t.type === "Feature" ? t.properties : {};
  return Que(r, i);
}
TE.polygonToLine = rVe;
function iVe(t, e) {
  e === void 0 && (e = {});
  var n = Sue.getGeom(t), r = n.coordinates, i = e.properties ? e.properties : t.type === "Feature" ? t.properties : {}, o = [];
  return r.forEach(function(s) {
    o.push(Que(s, i));
  }), fne.featureCollection(o);
}
TE.multiPolygonToLine = iVe;
function Que(t, e) {
  return t.length > 1 ? fne.multiLineString(t, e) : fne.lineString(t[0], e);
}
TE.coordsToLine = Que;
var wue = { exports: {} }, z$ = {};
Object.defineProperty(z$, "__esModule", { value: !0 });
var MP = ar, OP = Eo;
function PTn(t, e, n) {
  n === void 0 && (n = {});
  var r;
  n.final ? r = Jxe(OP.getCoord(e), OP.getCoord(t)) : r = Jxe(OP.getCoord(t), OP.getCoord(e));
  var i = r > 180 ? -(360 - r) : r;
  return i;
}
function Jxe(t, e) {
  var n = MP.degreesToRadians(t[1]), r = MP.degreesToRadians(e[1]), i = MP.degreesToRadians(e[0] - t[0]);
  i > Math.PI && (i -= 2 * Math.PI), i < -Math.PI && (i += 2 * Math.PI);
  var o = Math.log(Math.tan(r / 2 + Math.PI / 4) / Math.tan(n / 2 + Math.PI / 4)), s = Math.atan2(i, o);
  return (MP.radiansToDegrees(s) + 360) % 360;
}
z$.default = PTn;
var kTn = qw, GTn = Uw, UTn = a1, HTn = QE, $Tn = z$, qTn = DM, jTn = zw, oVe = Do, LR = ar, gne = Eo;
function A1(t) {
  return t && typeof t == "object" && "default" in t ? t : { default: t };
}
var YTn = /* @__PURE__ */ A1(kTn), zTn = /* @__PURE__ */ A1(GTn), VTn = /* @__PURE__ */ A1(UTn), JTn = /* @__PURE__ */ A1(HTn), KTn = /* @__PURE__ */ A1($Tn), WTn = /* @__PURE__ */ A1(qTn), XTn = /* @__PURE__ */ A1(jTn);
function sVe(t, e, n) {
  if (n = n || {}, !LR.isObject(n))
    throw new Error("options is invalid");
  var r = n.origin, i = n.mutate;
  if (!t)
    throw new Error("geojson required");
  if (typeof e != "number" || e === 0)
    throw new Error("invalid factor");
  var o = Array.isArray(r) || typeof r == "object";
  return i !== !0 && (t = YTn.default(t)), t.type === "FeatureCollection" && !o ? (oVe.featureEach(t, function(s, a) {
    t.features[a] = Kxe(s, e, r);
  }), t) : Kxe(t, e, r);
}
function Kxe(t, e, n) {
  var r = gne.getType(t) === "Point";
  return n = ZTn(t, n), e === 1 || r || oVe.coordEach(t, function(i) {
    var o = WTn.default(n, i), s = KTn.default(n, i), a = o * e, A = gne.getCoords(XTn.default(n, a, s));
    i[0] = A[0], i[1] = A[1], i.length === 3 && (i[2] *= e);
  }), t;
}
function ZTn(t, e) {
  if (e == null && (e = "centroid"), Array.isArray(e) || typeof e == "object")
    return gne.getCoord(e);
  var n = t.bbox ? t.bbox : JTn.default(t), r = n[0], i = n[1], o = n[2], s = n[3];
  switch (e) {
    case "sw":
    case "southwest":
    case "westsouth":
    case "bottomleft":
      return LR.point([r, i]);
    case "se":
    case "southeast":
    case "eastsouth":
    case "bottomright":
      return LR.point([o, i]);
    case "nw":
    case "northwest":
    case "westnorth":
    case "topleft":
      return LR.point([r, s]);
    case "ne":
    case "northeast":
    case "eastnorth":
    case "topright":
      return LR.point([o, s]);
    case "center":
      return zTn.default(t);
    case void 0:
    case null:
    case "centroid":
      return VTn.default(t);
    default:
      throw new Error("invalid origin");
  }
}
wue.exports = sVe;
wue.exports.default = sVe;
var eNn = wue.exports;
Object.defineProperty(LM, "__esModule", {
  value: !0
});
LM.ScaleMode = void 0;
var tNn = l1(QE), nNn = l1(a1), rNn = l1(zf), iNn = l1(xE), Wxe = ar, oNn = l1(TE), sNn = Do, Xxe = l1(hl), aNn = l1(eNn), Zxe = Eo, ANn = ao, lNn = ts, cNn = Vf;
function l1(t) {
  return t && t.__esModule ? t : { default: t };
}
function tG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? tG = function(n) {
    return typeof n;
  } : tG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, tG(t);
}
function uNn(t) {
  return dNn(t) || hNn(t) || gNn(t) || fNn();
}
function fNn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gNn(t, e) {
  if (t) {
    if (typeof t == "string")
      return hne(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return hne(t, e);
  }
}
function hNn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function dNn(t) {
  if (Array.isArray(t))
    return hne(t);
}
function hne(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function pNn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function e2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function INn(t, e, n) {
  return e && e2e(t.prototype, e), n && e2e(t, n), t;
}
function mNn(t) {
  return function() {
    var e = I8(t), n;
    if (ENn()) {
      var r = I8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return CNn(this, n);
  };
}
function CNn(t, e) {
  return e && (tG(e) === "object" || typeof e == "function") ? e : ag(t);
}
function ag(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function ENn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function I8(t) {
  return I8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, I8(t);
}
function yNn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && dne(t, e);
}
function dne(t, e) {
  return dne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, dne(t, e);
}
function Eh(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var vNn = /* @__PURE__ */ function(t) {
  yNn(n, t);
  var e = mNn(n);
  function n() {
    var r;
    pNn(this, n);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)), Eh(ag(r), "_geometryBeingScaled", void 0), Eh(ag(r), "_selectedEditHandle", void 0), Eh(ag(r), "_cornerGuidePoints", void 0), Eh(ag(r), "_cursor", void 0), Eh(ag(r), "_isScaling", !1), Eh(ag(r), "_isSinglePointGeometrySelected", function(a) {
      var A = a || {}, l = A.features;
      if (Array.isArray(l) && l.length === 1) {
        var c = (0, Zxe.getGeom)(l[0]), u = c.type;
        return u === "Point";
      }
      return !1;
    }), Eh(ag(r), "_getOppositeScaleHandle", function(a) {
      var A = a && a.properties && Array.isArray(a.properties.positionIndexes) && a.properties.positionIndexes[0];
      if (typeof A != "number")
        return null;
      var l = r._cornerGuidePoints.length, c = (A + l / 2) % l;
      return r._cornerGuidePoints.find(function(u) {
        return Array.isArray(u.properties.positionIndexes) ? u.properties.positionIndexes[0] === c : !1;
      });
    }), Eh(ag(r), "_getUpdatedData", function(a, A) {
      for (var l = new cNn.ImmutableFeatureCollection(a.data), c = a.selectedIndexes, u = 0; u < c.length; u++) {
        var f = c[u], h = A.features[u];
        l = l.replaceGeometry(f, h.geometry);
      }
      return l.getObject();
    }), Eh(ag(r), "isEditHandleSelected", function() {
      return !!r._selectedEditHandle;
    }), Eh(ag(r), "getScaleAction", function(a, A, l, c) {
      if (!r._selectedEditHandle)
        return null;
      var u = r._getOppositeScaleHandle(r._selectedEditHandle), f = (0, Zxe.getCoord)(u), h = BNn(f, a, A), d = (0, aNn.default)(
        // @ts-ignore
        r._geometryBeingScaled,
        h,
        {
          origin: f
        }
      );
      return {
        updatedData: r._getUpdatedData(c, d),
        editType: l,
        editContext: {
          featureIndexes: c.selectedIndexes
        }
      };
    }), Eh(ag(r), "updateCursor", function(a) {
      if (r._selectedEditHandle) {
        r._cursor && a.onUpdateCursor(r._cursor);
        var A = r.getSelectedFeaturesAsFeatureCollection(a), l = (0, nNn.default)(A), c = (0, rNn.default)(l, r._selectedEditHandle), u = c < 0 ? c + 180 : c;
        u >= 0 && u <= 90 || u >= 180 && u <= 270 ? (r._cursor = "nesw-resize", a.onUpdateCursor("nesw-resize")) : (r._cursor = "nwse-resize", a.onUpdateCursor("nwse-resize"));
      } else
        a.onUpdateCursor(null), r._cursor = null;
    }), r;
  }
  return INn(n, [{
    key: "handlePointerMove",
    value: function(i, o) {
      if (!this._isScaling) {
        var s = (0, ANn.getPickedEditHandle)(i.picks);
        this._selectedEditHandle = s && s.properties.editHandleType === "scale" ? s : null, s && this.updateCursor(o);
      }
    }
  }, {
    key: "handleStartDragging",
    value: function(i, o) {
      this._selectedEditHandle && (this._isScaling = !0, this._geometryBeingScaled = this.getSelectedFeaturesAsFeatureCollection(o));
    }
  }, {
    key: "handleDragging",
    value: function(i, o) {
      if (this._isScaling) {
        o.onUpdateCursor(this._cursor);
        var s = this.getScaleAction(i.pointerDownMapCoords, i.mapCoords, "scaling", o);
        s && o.onEdit(s), i.cancelPan();
      }
    }
  }, {
    key: "handleStopDragging",
    value: function(i, o) {
      if (this._isScaling) {
        var s = this.getScaleAction(i.pointerDownMapCoords, i.mapCoords, "scaled", o);
        s && o.onEdit(s), o.onUpdateCursor(null), this._geometryBeingScaled = null, this._selectedEditHandle = null, this._cursor = null, this._isScaling = !1;
      }
    }
  }, {
    key: "getGuides",
    value: function(i) {
      this._cornerGuidePoints = [];
      var o = this.getSelectedFeaturesAsFeatureCollection(i);
      if (this._isSinglePointGeometrySelected(o))
        return {
          type: "FeatureCollection",
          features: []
        };
      var s = (0, iNn.default)((0, tNn.default)(o));
      s.properties.mode = "scale";
      var a = [];
      return (0, sNn.coordEach)(s, function(A, l) {
        if (l < 4) {
          var c = (0, Wxe.point)(A, {
            guideType: "editHandle",
            editHandleType: "scale",
            positionIndexes: [l]
          });
          a.push(c);
        }
      }), this._cornerGuidePoints = a, (0, Wxe.featureCollection)([(0, oNn.default)(s)].concat(uNn(this._cornerGuidePoints)));
    }
  }]), n;
}(lNn.GeoJsonEditMode);
LM.ScaleMode = vNn;
function BNn(t, e, n) {
  var r = (0, Xxe.default)(t, e), i = (0, Xxe.default)(t, n);
  return i / r;
}
var MM = {}, xue = { exports: {} }, bNn = a1, _Nn = z$, SNn = DM, QNn = zw, wNn = qw, xNn = Do, RNn = Eo, DNn = ar;
function OM(t) {
  return t && typeof t == "object" && "default" in t ? t : { default: t };
}
var TNn = /* @__PURE__ */ OM(bNn), NNn = /* @__PURE__ */ OM(_Nn), LNn = /* @__PURE__ */ OM(SNn), MNn = /* @__PURE__ */ OM(QNn), ONn = /* @__PURE__ */ OM(wNn);
function aVe(t, e, n) {
  if (n = n || {}, !DNn.isObject(n))
    throw new Error("options is invalid");
  var r = n.pivot, i = n.mutate;
  if (!t)
    throw new Error("geojson is required");
  if (e == null || isNaN(e))
    throw new Error("angle is required");
  return e === 0 || (r || (r = TNn.default(t)), (i === !1 || i === void 0) && (t = ONn.default(t)), xNn.coordEach(t, function(o) {
    var s = NNn.default(r, o), a = s + e, A = LNn.default(r, o), l = RNn.getCoords(MNn.default(r, A, a));
    o[0] = l[0], o[1] = l[1];
  })), t;
}
xue.exports = aVe;
xue.exports.default = aVe;
var AVe = xue.exports;
Object.defineProperty(MM, "__esModule", {
  value: !0
});
MM.RotateMode = void 0;
var FNn = c1(QE), t2e = c1(a1), n2e = c1(zf), PNn = c1(xE), kNn = c1(hl), GNn = Do, UNn = Eo, FP = ar, HNn = c1(AVe), $Nn = c1(TE), qNn = ao, r2e = ts, jNn = Vf;
function c1(t) {
  return t && t.__esModule ? t : { default: t };
}
function nG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? nG = function(n) {
    return typeof n;
  } : nG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, nG(t);
}
function YNn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function i2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function zNn(t, e, n) {
  return e && i2e(t.prototype, e), n && i2e(t, n), t;
}
function VNn(t) {
  return function() {
    var e = m8(t), n;
    if (KNn()) {
      var r = m8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return JNn(this, n);
  };
}
function JNn(t, e) {
  return e && (nG(e) === "object" || typeof e == "function") ? e : Xb(t);
}
function Xb(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function KNn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function m8(t) {
  return m8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, m8(t);
}
function WNn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && pne(t, e);
}
function pne(t, e) {
  return pne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, pne(t, e);
}
function S2(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var XNn = /* @__PURE__ */ function(t) {
  WNn(n, t);
  var e = VNn(n);
  function n() {
    var r;
    YNn(this, n);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)), S2(Xb(r), "_selectedEditHandle", void 0), S2(Xb(r), "_geometryBeingRotated", void 0), S2(Xb(r), "_isRotating", !1), S2(Xb(r), "_isSinglePointGeometrySelected", function(a) {
      var A = a || {}, l = A.features;
      if (Array.isArray(l) && l.length === 1) {
        var c = (0, UNn.getGeom)(l[0]), u = c.type;
        return u === "Point";
      }
      return !1;
    }), S2(Xb(r), "getIsRotating", function() {
      return r._isRotating;
    }), r;
  }
  return zNn(n, [{
    key: "getGuides",
    value: function(i) {
      var o = this._geometryBeingRotated || this.getSelectedFeaturesAsFeatureCollection(i);
      if (this._isSinglePointGeometrySelected(o))
        return {
          type: "FeatureCollection",
          features: []
        };
      if (this._isRotating)
        return (0, FP.featureCollection)([(0, t2e.default)(o)]);
      var s = (0, PNn.default)((0, FNn.default)(o)), a = null, A = null, l = 0;
      (0, GNn.coordEach)(s, function(h) {
        if (a) {
          var d = (0, r2e.getIntermediatePosition)(h, a);
          (!A || d[1] > A[1]) && (A = d);
          var I = (0, kNn.default)(h, a);
          l = Math.max(l, I);
        }
        a = h;
      });
      var c = A && [A[0], A[1] + l / 1e3], u = (0, FP.lineString)([A, c]), f = (0, FP.point)(c, {
        guideType: "editHandle",
        editHandleType: "rotate"
      });
      return (0, FP.featureCollection)([
        // @ts-ignore
        (0, $Nn.default)(s),
        // @ts-ignore
        f,
        // @ts-ignore
        u
      ]);
    }
  }, {
    key: "handleDragging",
    value: function(i, o) {
      if (this._isRotating) {
        var s = this.getRotateAction(i.pointerDownMapCoords, i.mapCoords, "rotating", o);
        s && o.onEdit(s), i.cancelPan();
      }
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      if (!this._isRotating) {
        var s = (0, qNn.getPickedEditHandle)(i.picks);
        this._selectedEditHandle = s && s.properties.editHandleType === "rotate" ? s : null;
      }
      this.updateCursor(o);
    }
  }, {
    key: "handleStartDragging",
    value: function(i, o) {
      this._selectedEditHandle && (this._isRotating = !0, this._geometryBeingRotated = this.getSelectedFeaturesAsFeatureCollection(o));
    }
  }, {
    key: "handleStopDragging",
    value: function(i, o) {
      if (this._isRotating) {
        var s = this.getRotateAction(i.pointerDownMapCoords, i.mapCoords, "rotated", o);
        s && o.onEdit(s), this._geometryBeingRotated = null, this._selectedEditHandle = null, this._isRotating = !1;
      }
    }
  }, {
    key: "updateCursor",
    value: function(i) {
      this._selectedEditHandle ? i.onUpdateCursor("crosshair") : i.onUpdateCursor(null);
    }
  }, {
    key: "getRotateAction",
    value: function(i, o, s, a) {
      if (!this._geometryBeingRotated)
        return null;
      for (var A = (0, t2e.default)(this._geometryBeingRotated), l = ZNn(A, i, o), c = (0, HNn.default)(
        // @ts-ignore
        this._geometryBeingRotated,
        l,
        {
          pivot: A
        }
      ), u = new jNn.ImmutableFeatureCollection(a.data), f = a.selectedIndexes, h = 0; h < f.length; h++) {
        var d = f[h], I = c.features[h];
        u = u.replaceGeometry(d, I.geometry);
      }
      return {
        updatedData: u.getObject(),
        editType: s,
        editContext: {
          featureIndexes: f
        }
      };
    }
  }]), n;
}(r2e.GeoJsonEditMode);
MM.RotateMode = XNn;
function ZNn(t, e, n) {
  var r = (0, n2e.default)(t, e), i = (0, n2e.default)(t, n);
  return i - r;
}
var V$ = {};
Object.defineProperty(V$, "__esModule", {
  value: !0
});
V$.DuplicateMode = void 0;
var eLn = Yw;
function rG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? rG = function(n) {
    return typeof n;
  } : rG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, rG(t);
}
function tLn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function o2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function nLn(t, e, n) {
  return e && o2e(t.prototype, e), n && o2e(t, n), t;
}
function iG(t, e, n) {
  return typeof Reflect < "u" && Reflect.get ? iG = Reflect.get : iG = function(i, o, s) {
    var a = rLn(i, o);
    if (a) {
      var A = Object.getOwnPropertyDescriptor(a, o);
      return A.get ? A.get.call(s) : A.value;
    }
  }, iG(t, e, n || t);
}
function rLn(t, e) {
  for (; !Object.prototype.hasOwnProperty.call(t, e) && (t = XS(t), t !== null); )
    ;
  return t;
}
function iLn(t) {
  return function() {
    var e = XS(t), n;
    if (aLn()) {
      var r = XS(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return oLn(this, n);
  };
}
function oLn(t, e) {
  return e && (rG(e) === "object" || typeof e == "function") ? e : sLn(t);
}
function sLn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function aLn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function XS(t) {
  return XS = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, XS(t);
}
function ALn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Ine(t, e);
}
function Ine(t, e) {
  return Ine = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Ine(t, e);
}
var lLn = /* @__PURE__ */ function(t) {
  ALn(n, t);
  var e = iLn(n);
  function n() {
    return tLn(this, n), e.apply(this, arguments);
  }
  return nLn(n, [{
    key: "handleStartDragging",
    value: function(i, o) {
      iG(XS(n.prototype), "handleStartDragging", this).call(this, i, o), this._geometryBeforeTranslate && o.onEdit(this.getAddManyFeaturesAction(this._geometryBeforeTranslate, o.data));
    }
  }, {
    key: "updateCursor",
    value: function(i) {
      this._isTranslatable ? i.onUpdateCursor("copy") : i.onUpdateCursor(null);
    }
  }]), n;
}(eLn.TranslateMode);
V$.DuplicateMode = lLn;
var J$ = {};
Object.defineProperty(J$, "__esModule", {
  value: !0
});
J$.ExtendLineStringMode = void 0;
var cLn = ts, uLn = Vf;
function oG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? oG = function(n) {
    return typeof n;
  } : oG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, oG(t);
}
function fLn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function s2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function gLn(t, e, n) {
  return e && s2e(t.prototype, e), n && s2e(t, n), t;
}
function hLn(t) {
  return function() {
    var e = C8(t), n;
    if (ILn()) {
      var r = C8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return dLn(this, n);
  };
}
function dLn(t, e) {
  return e && (oG(e) === "object" || typeof e == "function") ? e : pLn(t);
}
function pLn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function ILn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function C8(t) {
  return C8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, C8(t);
}
function mLn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && mne(t, e);
}
function mne(t, e) {
  return mne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, mne(t, e);
}
var CLn = /* @__PURE__ */ function(t) {
  mLn(n, t);
  var e = hLn(n);
  function n() {
    return fLn(this, n), e.apply(this, arguments);
  }
  return gLn(n, [{
    key: "getSingleSelectedLineString",
    value: function(i) {
      var o = this.getSelectedGeometry(i);
      return o && o.type === "LineString" ? o : null;
    }
  }, {
    key: "handleClick",
    value: function(i, o) {
      var s = o.selectedIndexes, a = this.getSingleSelectedLineString(o);
      if (!a) {
        console.warn("ExtendLineStringMode only supported for single LineString selection");
        return;
      }
      var A = [a.coordinates.length], l = o.modeConfig;
      l && l.drawAtFront && (A = [0]);
      var c = s[0], u = new uLn.ImmutableFeatureCollection(o.data).addPosition(c, A, i.mapCoords).getObject();
      o.onEdit({
        updatedData: u,
        editType: "addPosition",
        editContext: {
          featureIndexes: [c],
          positionIndexes: A,
          position: i.mapCoords
        }
      });
    }
  }, {
    key: "getGuides",
    value: function(i) {
      var o = {
        type: "FeatureCollection",
        features: []
      }, s = this.getSingleSelectedLineString(i);
      if (!s)
        return o;
      var a = i.lastPointerMoveEvent && i.lastPointerMoveEvent.mapCoords, A = null, l = i.modeConfig;
      return l && l.drawAtFront ? A = s.coordinates[0] : A = s.coordinates[s.coordinates.length - 1], o.features.push({
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [A, a]
        }
      }), o;
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      o.onUpdateCursor("cell");
    }
  }]), n;
}(cLn.GeoJsonEditMode);
J$.ExtendLineStringMode = CLn;
var K$ = {}, Rue = {};
Object.defineProperty(Rue, "__esModule", { value: !0 });
var a2e = Bue;
function ELn(t, e, n) {
  if (n === void 0 && (n = {}), !t)
    throw new Error("point is required");
  if (!e)
    throw new Error("polygon is required");
  var r = a2e.getCoord(t), i = a2e.getGeom(e), o = i.type, s = e.bbox, a = i.coordinates;
  if (s && yLn(r, s) === !1)
    return !1;
  o === "Polygon" && (a = [a]);
  for (var A = !1, l = 0; l < a.length && !A; l++)
    if (A2e(r, a[l][0], n.ignoreBoundary)) {
      for (var c = !1, u = 1; u < a[l].length && !c; )
        A2e(r, a[l][u], !n.ignoreBoundary) && (c = !0), u++;
      c || (A = !0);
    }
  return A;
}
Rue.default = ELn;
function A2e(t, e, n) {
  var r = !1;
  e[0][0] === e[e.length - 1][0] && e[0][1] === e[e.length - 1][1] && (e = e.slice(0, e.length - 1));
  for (var i = 0, o = e.length - 1; i < e.length; o = i++) {
    var s = e[i][0], a = e[i][1], A = e[o][0], l = e[o][1], c = t[1] * (s - A) + a * (A - t[0]) + l * (t[0] - s) === 0 && (s - t[0]) * (A - t[0]) <= 0 && (a - t[1]) * (l - t[1]) <= 0;
    if (c)
      return !n;
    var u = a > t[1] != l > t[1] && t[0] < (A - s) * (t[1] - a) / (l - a) + s;
    u && (r = !r);
  }
  return r;
}
function yLn(t, e) {
  return e[0] <= t[0] && e[1] <= t[1] && e[2] >= t[0] && e[3] >= t[1];
}
var W$ = {};
const vLn = /* @__PURE__ */ Fs(cQn);
var lVe = ei && ei.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(W$, "__esModule", { value: !0 });
var MR = BM, Cne = Bue, l2e = lVe(vLn), c2e = T$, BLn = lVe(JYe);
function bLn(t, e) {
  var n = {}, r = [];
  if (t.type === "LineString" && (t = MR.feature(t)), e.type === "LineString" && (e = MR.feature(e)), t.type === "Feature" && e.type === "Feature" && t.geometry !== null && e.geometry !== null && t.geometry.type === "LineString" && e.geometry.type === "LineString" && t.geometry.coordinates.length === 2 && e.geometry.coordinates.length === 2) {
    var i = u2e(t, e);
    return i && r.push(i), MR.featureCollection(r);
  }
  var o = BLn.default();
  return o.load(l2e.default(e)), c2e.featureEach(l2e.default(t), function(s) {
    c2e.featureEach(o.search(s), function(a) {
      var A = u2e(s, a);
      if (A) {
        var l = Cne.getCoords(A).join(",");
        n[l] || (n[l] = !0, r.push(A));
      }
    });
  }), MR.featureCollection(r);
}
function u2e(t, e) {
  var n = Cne.getCoords(t), r = Cne.getCoords(e);
  if (n.length !== 2)
    throw new Error("<intersects> line1 must only contain 2 coordinates");
  if (r.length !== 2)
    throw new Error("<intersects> line2 must only contain 2 coordinates");
  var i = n[0][0], o = n[0][1], s = n[1][0], a = n[1][1], A = r[0][0], l = r[0][1], c = r[1][0], u = r[1][1], f = (u - l) * (s - i) - (c - A) * (a - o), h = (c - A) * (o - l) - (u - l) * (i - A), d = (s - i) * (o - l) - (a - o) * (i - A);
  if (f === 0)
    return null;
  var I = h / f, m = d / f;
  if (I >= 0 && I <= 1 && m >= 0 && m <= 1) {
    var C = i + I * (s - i), y = o + I * (a - o);
    return MR.point([C, y]);
  }
  return null;
}
W$.default = bLn;
Object.defineProperty(K$, "__esModule", {
  value: !0
});
K$.SplitPolygonMode = void 0;
var _Ln = nm(Rue), SLn = nm(O$), QLn = nm(fue), wLn = nm(W$), xLn = ar, RLn = nm(zf), f2e = nm(hl), DLn = nm(DE), TLn = nm(TE), g2e = nm(q$), NLn = ao, LLn = ts, MLn = Vf;
function nm(t) {
  return t && t.__esModule ? t : { default: t };
}
function sG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? sG = function(n) {
    return typeof n;
  } : sG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, sG(t);
}
function OLn(t) {
  return kLn(t) || PLn(t) || cVe(t) || FLn();
}
function FLn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PLn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function kLn(t) {
  if (Array.isArray(t))
    return Ene(t);
}
function GLn(t, e) {
  return $Ln(t) || HLn(t, e) || cVe(t, e) || ULn();
}
function ULn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cVe(t, e) {
  if (t) {
    if (typeof t == "string")
      return Ene(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Ene(t, e);
  }
}
function Ene(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function HLn(t, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var n = [], r = !0, i = !1, o = void 0;
    try {
      for (var s = t[Symbol.iterator](), a; !(r = (a = s.next()).done) && (n.push(a.value), !(e && n.length === e)); r = !0)
        ;
    } catch (A) {
      i = !0, o = A;
    } finally {
      try {
        !r && s.return != null && s.return();
      } finally {
        if (i)
          throw o;
      }
    }
    return n;
  }
}
function $Ln(t) {
  if (Array.isArray(t))
    return t;
}
function qLn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function h2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function jLn(t, e, n) {
  return e && h2e(t.prototype, e), n && h2e(t, n), t;
}
function YLn(t) {
  return function() {
    var e = E8(t), n;
    if (JLn()) {
      var r = E8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return zLn(this, n);
  };
}
function zLn(t, e) {
  return e && (sG(e) === "object" || typeof e == "function") ? e : VLn(t);
}
function VLn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function JLn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function E8(t) {
  return E8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, E8(t);
}
function KLn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && yne(t, e);
}
function yne(t, e) {
  return yne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, yne(t, e);
}
var WLn = /* @__PURE__ */ function(t) {
  KLn(n, t);
  var e = YLn(n);
  function n() {
    return qLn(this, n), e.apply(this, arguments);
  }
  return jLn(n, [{
    key: "calculateMapCoords",
    value: function(i, o, s) {
      var a = s.modeConfig;
      if (!a || !a.lock90Degree || !i.length)
        return o;
      if (i.length === 1) {
        var A = i[0], l = this.getSelectedGeometry(s), c = (0, TLn.default)(l), u = c.type === "FeatureCollection" ? c.features : [c], f = Number.MAX_SAFE_INTEGER, h = null;
        if (u.forEach(function(Q) {
          var w = (0, g2e.default)(Q, A), R = (0, f2e.default)(w, A);
          f > R && (f = R, h = w);
        }), h) {
          var d = (0, RLn.default)(A, h), I = (0, f2e.default)(A, o, {
            units: "meters"
          });
          return (0, DLn.default)(A, I, d, {
            units: "meters"
          }).geometry.coordinates;
        }
        return o;
      }
      var m = i[i.length - 1], C = (0, NLn.generatePointsParallelToLinePoints)(i[i.length - 2], m, o), y = GLn(C, 1), v = y[0], b = (0, g2e.default)((0, xLn.lineString)([m, v]), o).geometry.coordinates;
      return b;
    }
  }, {
    key: "getGuides",
    value: function(i) {
      var o = this.getClickSequence(), s = {
        type: "FeatureCollection",
        features: []
      };
      if (o.length === 0 || !i.lastPointerMoveEvent)
        return s;
      var a = i.lastPointerMoveEvent.mapCoords;
      return s.features.push({
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [].concat(OLn(o), [this.calculateMapCoords(o, a, i)])
        }
      }), s;
    }
  }, {
    key: "handleClick",
    value: function(i, o) {
      var s = this.getTentativeGuide(o), a = this.getSelectedGeometry(o);
      if (!a) {
        console.warn("A polygon must be selected for splitting");
        return;
      }
      var A = this.getClickSequence();
      s && s.geometry.type === "LineString" ? A.push(s.geometry.coordinates[s.geometry.coordinates.length - 1]) : this.addClickSequence(i);
      var l = {
        type: "Point",
        coordinates: A[A.length - 1]
      }, c = (0, _Ln.default)(l, a);
      if (A.length > 1 && s && !c) {
        this.resetClickSequence();
        var u = (0, wLn.default)(s, a);
        if (u.features.length === 0)
          return;
        var f = this.splitPolygon(s, o);
        f && o.onEdit(f);
      }
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      o.onUpdateCursor("cell");
    }
  }, {
    key: "splitPolygon",
    value: function(i, o) {
      var s = this.getSelectedGeometry(o), a = o.selectedIndexes[0], A = o.modeConfig || {}, l = A.gap, c = l === void 0 ? 0.1 : l, u = A.units, f = u === void 0 ? "centimeters" : u;
      c === 0 && (c = 0.1, f = "centimeters");
      var h = (0, QLn.default)(i, c, {
        units: f
      }), d = (0, SLn.default)(s, h);
      if (!d)
        return console.warn("Canceling edit. Split Polygon erased"), null;
      var I = d.geometry, m = I.type, C = I.coordinates, y = [];
      m === "Polygon" ? y = C.map(function(Q) {
        return [Q];
      }) : y = C.reduce(function(Q, w) {
        return w.forEach(function(R) {
          Q.push([R]);
        }), Q;
      }, []);
      var v = new MLn.ImmutableFeatureCollection(o.data).replaceGeometry(a, {
        type: "MultiPolygon",
        coordinates: y
      }), b = {
        updatedData: v.getObject(),
        editType: "split",
        editContext: {
          featureIndexes: [a]
        }
      };
      return b;
    }
  }]), n;
}(LLn.GeoJsonEditMode);
K$.SplitPolygonMode = WLn;
var X$ = {};
Object.defineProperty(X$, "__esModule", {
  value: !0
});
X$.ExtrudeMode = void 0;
var XLn = eMn(zf), Q2 = ao, ZLn = jw, QJ = Vf;
function eMn(t) {
  return t && t.__esModule ? t : { default: t };
}
function aG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? aG = function(n) {
    return typeof n;
  } : aG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, aG(t);
}
function d2e(t) {
  return rMn(t) || nMn(t) || uVe(t) || tMn();
}
function tMn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nMn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function rMn(t) {
  if (Array.isArray(t))
    return vne(t);
}
function mb(t, e) {
  return sMn(t) || oMn(t, e) || uVe(t, e) || iMn();
}
function iMn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uVe(t, e) {
  if (t) {
    if (typeof t == "string")
      return vne(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return vne(t, e);
  }
}
function vne(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function oMn(t, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var n = [], r = !0, i = !1, o = void 0;
    try {
      for (var s = t[Symbol.iterator](), a; !(r = (a = s.next()).done) && (n.push(a.value), !(e && n.length === e)); r = !0)
        ;
    } catch (A) {
      i = !0, o = A;
    } finally {
      try {
        !r && s.return != null && s.return();
      } finally {
        if (i)
          throw o;
      }
    }
    return n;
  }
}
function sMn(t) {
  if (Array.isArray(t))
    return t;
}
function aMn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function p2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function AMn(t, e, n) {
  return e && p2e(t.prototype, e), n && p2e(t, n), t;
}
function lMn(t) {
  return function() {
    var e = y8(t), n;
    if (uMn()) {
      var r = y8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return cMn(this, n);
  };
}
function cMn(t, e) {
  return e && (aG(e) === "object" || typeof e == "function") ? e : fVe(t);
}
function fVe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function uMn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function y8(t) {
  return y8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, y8(t);
}
function fMn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Bne(t, e);
}
function Bne(t, e) {
  return Bne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Bne(t, e);
}
function gMn(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var hMn = /* @__PURE__ */ function(t) {
  fMn(n, t);
  var e = lMn(n);
  function n() {
    var r;
    aMn(this, n);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)), gMn(fVe(r), "isPointAdded", !1), r;
  }
  return AMn(n, [{
    key: "handleDragging",
    value: function(i, o) {
      var s = (0, Q2.getPickedEditHandle)(i.pointerDownPicks);
      if (s) {
        var a = s.properties.featureIndex, A = s.properties.positionIndexes, l = this.coordinatesSize(A, a, o.data);
        A = this.isPointAdded ? this.nextPositionIndexes(A, l) : A;
        var c = this.getPointForPositionIndexes(this.prevPositionIndexes(A, l), a, o.data), u = this.getPointForPositionIndexes(A, a, o.data);
        if (c && u) {
          var f = (0, Q2.generatePointsParallelToLinePoints)(c, u, i.mapCoords), h = mb(f, 2), d = h[0], I = h[1], m = new QJ.ImmutableFeatureCollection(o.data).replacePosition(a, this.prevPositionIndexes(A, l), I).replacePosition(a, A, d).getObject();
          o.onEdit({
            updatedData: m,
            editType: "extruding",
            editContext: {
              featureIndexes: [a],
              positionIndexes: this.nextPositionIndexes(A, l),
              position: d
            }
          }), i.cancelPan();
        }
      }
    }
  }, {
    key: "handleStartDragging",
    value: function(i, o) {
      var s = o.selectedIndexes, a = (0, Q2.getPickedIntermediateEditHandle)(i.picks);
      if (s.length && a) {
        var A = a.properties, l = A.positionIndexes, c = A.featureIndex, u = this.coordinatesSize(l, c, o.data), f = this.getPointForPositionIndexes(this.prevPositionIndexes(l, u), c, o.data), h = this.getPointForPositionIndexes(l, c, o.data);
        if (f && h) {
          var d = new QJ.ImmutableFeatureCollection(o.data);
          this.isOrthogonal(l, c, u, o.data) || (d = d.addPosition(c, l, h)), this.isOrthogonal(this.prevPositionIndexes(l, u), c, u, o.data) || (d = d.addPosition(c, l, f), this.isPointAdded = !0), o.onEdit({
            updatedData: d.getObject(),
            editType: "startExtruding",
            editContext: {
              featureIndexes: [c],
              positionIndexes: l,
              position: f
            }
          });
        }
      }
    }
  }, {
    key: "handleStopDragging",
    value: function(i, o) {
      var s = o.selectedIndexes, a = (0, Q2.getPickedEditHandle)(i.pointerDownPicks);
      if (s.length && a) {
        var A = a.properties.featureIndex, l = a.properties.positionIndexes, c = this.coordinatesSize(l, A, o.data);
        l = this.isPointAdded ? this.nextPositionIndexes(l, c) : l;
        var u = this.getPointForPositionIndexes(this.prevPositionIndexes(l, c), A, o.data), f = this.getPointForPositionIndexes(l, A, o.data);
        if (u && f) {
          var h = (0, Q2.generatePointsParallelToLinePoints)(u, f, i.mapCoords), d = mb(h, 2), I = d[0], m = d[1], C = new QJ.ImmutableFeatureCollection(o.data).replacePosition(A, this.prevPositionIndexes(l, c), m).replacePosition(A, l, I).getObject();
          o.onEdit({
            updatedData: C,
            editType: "extruded",
            editContext: {
              featureIndexes: [A],
              positionIndexes: l,
              position: I
            }
          });
        }
      }
      this.isPointAdded = !1;
    }
  }, {
    key: "coordinatesSize",
    value: function(i, o, s) {
      var a = s.features, A = 0;
      if (Array.isArray(i)) {
        var l = a[o], c = l.geometry.coordinates;
        if (i.length === 3) {
          var u = mb(i, 2), f = u[0], h = u[1];
          c.length && c[f].length && (A = c[f][h].length);
        } else {
          var d = mb(i, 1), I = d[0];
          c.length && c[I].length && (A = c[I].length);
        }
      }
      return A;
    }
  }, {
    key: "getBearing",
    value: function(i, o) {
      var s = (0, XLn.default)(i, o);
      return s < 0 ? Math.floor(360 + s) : Math.floor(s);
    }
  }, {
    key: "isOrthogonal",
    value: function(i, o, s, a) {
      if (!Array.isArray(i))
        return !1;
      i[i.length - 1] === s - 1 && (i[i.length - 1] = 0);
      var A = this.getPointForPositionIndexes(this.prevPositionIndexes(i, s), o, a), l = this.getPointForPositionIndexes(this.nextPositionIndexes(i, s), o, a), c = this.getPointForPositionIndexes(i, o, a), u = this.getBearing(c, A), f = this.getBearing(c, l);
      return [89, 90, 91, 269, 270, 271].includes(Math.abs(u - f));
    }
  }, {
    key: "nextPositionIndexes",
    value: function(i, o) {
      if (!Array.isArray(i))
        return [];
      var s = d2e(i);
      return s.length && (s[s.length - 1] = s[s.length - 1] === o - 1 ? 0 : s[s.length - 1] + 1), s;
    }
  }, {
    key: "prevPositionIndexes",
    value: function(i, o) {
      if (!Array.isArray(i))
        return [];
      var s = d2e(i);
      return s.length && (s[s.length - 1] = s[s.length - 1] === 0 ? o - 2 : s[s.length - 1] - 1), s;
    }
  }, {
    key: "getPointForPositionIndexes",
    value: function(i, o, s) {
      var a = s.features, A;
      if (Array.isArray(i)) {
        var l = a[o], c = l.geometry.coordinates;
        if (i.length === 3) {
          var u = mb(i, 3), f = u[0], h = u[1], d = u[2];
          c.length && c[f].length && (A = c[f][h][d]);
        } else {
          var I = mb(i, 2), m = I[0], C = I[1];
          c.length && c[m].length && (A = c[m][C]);
        }
      }
      return A;
    }
  }]), n;
}(ZLn.ModifyMode);
X$.ExtrudeMode = hMn;
var Z$ = {};
Object.defineProperty(Z$, "__esModule", {
  value: !0
});
Z$.ElevationMode = void 0;
var I2e = ao, dMn = jw;
function AG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? AG = function(n) {
    return typeof n;
  } : AG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, AG(t);
}
function pMn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function m2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function IMn(t, e, n) {
  return e && m2e(t.prototype, e), n && m2e(t, n), t;
}
function W_(t, e, n) {
  return typeof Reflect < "u" && Reflect.get ? W_ = Reflect.get : W_ = function(i, o, s) {
    var a = mMn(i, o);
    if (a) {
      var A = Object.getOwnPropertyDescriptor(a, o);
      return A.get ? A.get.call(s) : A.value;
    }
  }, W_(t, e, n || t);
}
function mMn(t, e) {
  for (; !Object.prototype.hasOwnProperty.call(t, e) && (t = wC(t), t !== null); )
    ;
  return t;
}
function CMn(t) {
  return function() {
    var e = wC(t), n;
    if (vMn()) {
      var r = wC(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return EMn(this, n);
  };
}
function EMn(t, e) {
  return e && (AG(e) === "object" || typeof e == "function") ? e : yMn(t);
}
function yMn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function vMn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function wC(t) {
  return wC = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, wC(t);
}
function BMn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && bne(t, e);
}
function bne(t, e) {
  return bne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, bne(t, e);
}
function bMn(t) {
  var e = t.pointerDownScreenCoords, n = t.screenCoords;
  return 10 * (e[1] - n[1]);
}
var _Mn = /* @__PURE__ */ function(t) {
  BMn(n, t);
  var e = CMn(n);
  function n() {
    return pMn(this, n), e.apply(this, arguments);
  }
  return IMn(n, [{
    key: "makeElevatedEvent",
    value: function(i, o, s) {
      var a = s.modeConfig || {}, A = a.minElevation, l = A === void 0 ? 0 : A, c = a.maxElevation, u = c === void 0 ? 2e4 : c, f = a.calculateElevationChange, h = f === void 0 ? bMn : f;
      if (!i.pointerDownScreenCoords)
        return i;
      var d = o.length === 3 ? o[2] : 0;
      return d += h({
        pointerDownScreenCoords: i.pointerDownScreenCoords,
        screenCoords: i.screenCoords
      }), d = Math.min(d, u), d = Math.max(d, l), Object.assign({}, i, {
        mapCoords: [o[0], o[1], d]
      });
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      var s = (0, I2e.getPickedEditHandle)(i.pointerDownPicks), a = s ? s.geometry.coordinates : i.mapCoords;
      W_(wC(n.prototype), "handlePointerMove", this).call(this, this.makeElevatedEvent(i, a, o), o);
    }
  }, {
    key: "handleStopDragging",
    value: function(i, o) {
      var s = (0, I2e.getPickedEditHandle)(i.picks), a = s ? s.geometry.coordinates : i.mapCoords;
      W_(wC(n.prototype), "handleStopDragging", this).call(this, this.makeElevatedEvent(i, a, o), o);
    }
  }, {
    key: "getCursor",
    value: function(i) {
      var o = W_(wC(n.prototype), "getCursor", this).call(this, i);
      return o === "cell" && (o = "ns-resize"), o;
    }
  }], [{
    key: "calculateElevationChangeWithViewport",
    value: function(i, o) {
      var s = o.pointerDownScreenCoords, a = o.screenCoords, A = 156543.03392 * Math.cos(i.latitude * Math.PI / 180) / Math.pow(2, i.zoom);
      return A * (s[1] - a[1]) / 2;
    }
  }]), n;
}(dMn.ModifyMode);
Z$.ElevationMode = _Mn;
var eq = {}, FM = {};
Object.defineProperty(FM, "__esModule", {
  value: !0
});
FM.CompositeMode = void 0;
var SMn = ts;
function lG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? lG = function(n) {
    return typeof n;
  } : lG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, lG(t);
}
function QMn(t) {
  return RMn(t) || xMn(t) || gVe(t) || wMn();
}
function wMn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xMn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function RMn(t) {
  if (Array.isArray(t))
    return _ne(t);
}
function DMn(t) {
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (t = gVe(t))) {
      var e = 0, n = function() {
      };
      return { s: n, n: function() {
        return e >= t.length ? { done: !0 } : { done: !1, value: t[e++] };
      }, e: function(A) {
        throw A;
      }, f: n };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var r, i = !0, o = !1, s;
  return { s: function() {
    r = t[Symbol.iterator]();
  }, n: function() {
    var A = r.next();
    return i = A.done, A;
  }, e: function(A) {
    o = !0, s = A;
  }, f: function() {
    try {
      !i && r.return != null && r.return();
    } finally {
      if (o)
        throw s;
    }
  } };
}
function gVe(t, e) {
  if (t) {
    if (typeof t == "string")
      return _ne(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _ne(t, e);
  }
}
function _ne(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function TMn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function C2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function NMn(t, e, n) {
  return e && C2e(t.prototype, e), n && C2e(t, n), t;
}
function LMn(t) {
  return function() {
    var e = v8(t), n;
    if (OMn()) {
      var r = v8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return MMn(this, n);
  };
}
function MMn(t, e) {
  return e && (lG(e) === "object" || typeof e == "function") ? e : hVe(t);
}
function hVe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function OMn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function v8(t) {
  return v8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, v8(t);
}
function FMn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Sne(t, e);
}
function Sne(t, e) {
  return Sne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Sne(t, e);
}
function PMn(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var kMn = /* @__PURE__ */ function(t) {
  FMn(n, t);
  var e = LMn(n);
  function n(r) {
    var i;
    return TMn(this, n), i = e.call(this), PMn(hVe(i), "_modes", void 0), i._modes = r, i;
  }
  return NMn(n, [{
    key: "_coalesce",
    value: function(i) {
      for (var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, s, a = 0; a < this._modes.length && (s = i(this._modes[a]), !(o ? o(s) : s)); a++)
        ;
      return s;
    }
  }, {
    key: "handleClick",
    value: function(i, o) {
      this._coalesce(function(s) {
        return s.handleClick(i, o);
      });
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      return this._coalesce(function(s) {
        return s.handlePointerMove(i, o);
      });
    }
  }, {
    key: "handleStartDragging",
    value: function(i, o) {
      return this._coalesce(function(s) {
        return s.handleStartDragging(i, o);
      });
    }
  }, {
    key: "handleStopDragging",
    value: function(i, o) {
      return this._coalesce(function(s) {
        return s.handleStopDragging(i, o);
      });
    }
  }, {
    key: "handleDragging",
    value: function(i, o) {
      return this._coalesce(function(s) {
        return s.handleDragging(i, o);
      });
    }
  }, {
    key: "getGuides",
    value: function(i) {
      var o = [], s = DMn(this._modes), a;
      try {
        for (s.s(); !(a = s.n()).done; ) {
          var A = a.value;
          o.push.apply(o, QMn(A.getGuides(i).features));
        }
      } catch (l) {
        s.e(l);
      } finally {
        s.f();
      }
      return {
        type: "FeatureCollection",
        features: o
      };
    }
  }]), n;
}(SMn.GeoJsonEditMode);
FM.CompositeMode = kMn;
Object.defineProperty(eq, "__esModule", {
  value: !0
});
eq.TransformMode = void 0;
var GMn = ar, E2e = Yw, wJ = LM, xJ = MM, UMn = FM;
function cG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? cG = function(n) {
    return typeof n;
  } : cG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, cG(t);
}
function y2e(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function HMn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? y2e(Object(n), !0).forEach(function(r) {
      $Mn(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y2e(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function $Mn(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function qMn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function v2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function jMn(t, e, n) {
  return e && v2e(t.prototype, e), n && v2e(t, n), t;
}
function RD(t, e, n) {
  return typeof Reflect < "u" && Reflect.get ? RD = Reflect.get : RD = function(i, o, s) {
    var a = YMn(i, o);
    if (a) {
      var A = Object.getOwnPropertyDescriptor(a, o);
      return A.get ? A.get.call(s) : A.value;
    }
  }, RD(t, e, n || t);
}
function YMn(t, e) {
  for (; !Object.prototype.hasOwnProperty.call(t, e) && (t = AB(t), t !== null); )
    ;
  return t;
}
function zMn(t) {
  return function() {
    var e = AB(t), n;
    if (KMn()) {
      var r = AB(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return VMn(this, n);
  };
}
function VMn(t, e) {
  return e && (cG(e) === "object" || typeof e == "function") ? e : JMn(t);
}
function JMn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function KMn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function AB(t) {
  return AB = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, AB(t);
}
function WMn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Qne(t, e);
}
function Qne(t, e) {
  return Qne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Qne(t, e);
}
var XMn = /* @__PURE__ */ function(t) {
  WMn(n, t);
  var e = zMn(n);
  function n() {
    return qMn(this, n), e.call(this, [new E2e.TranslateMode(), new wJ.ScaleMode(), new xJ.RotateMode()]);
  }
  return jMn(n, [{
    key: "handlePointerMove",
    value: function(i, o) {
      var s = null;
      RD(AB(n.prototype), "handlePointerMove", this).call(this, i, HMn({}, o, {
        onUpdateCursor: function(A) {
          s = A || s;
        }
      })), o.onUpdateCursor(s);
    }
  }, {
    key: "handleStartDragging",
    value: function(i, o) {
      var s = null, a = null, A = [];
      this._modes.forEach(function(l) {
        l instanceof E2e.TranslateMode ? a = l : (l instanceof wJ.ScaleMode && (s = l), A.push(l));
      }), s instanceof wJ.ScaleMode && !s.isEditHandleSelected() && A.push(a), A.filter(Boolean).forEach(function(l) {
        return l.handleStartDragging(i, o);
      });
    }
  }, {
    key: "getGuides",
    value: function(i) {
      var o = RD(AB(n.prototype), "getGuides", this).call(this, i), s = (this._modes || []).find(function(A) {
        return A instanceof xJ.RotateMode;
      });
      if (s instanceof xJ.RotateMode) {
        var a = o.features.filter(function(A) {
          var l = A.properties || {}, c = l.editHandleType, u = l.mode, f = [u];
          return s.getIsRotating() && f.push(c), !f.includes("scale");
        });
        o = (0, GMn.featureCollection)(a);
      }
      return o;
    }
  }]), n;
}(UMn.CompositeMode);
eq.TransformMode = XMn;
var tq = {};
Object.defineProperty(tq, "__esModule", {
  value: !0
});
tq.DrawPointMode = void 0;
var ZMn = ts;
function uG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? uG = function(n) {
    return typeof n;
  } : uG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, uG(t);
}
function eOn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function B2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function tOn(t, e, n) {
  return e && B2e(t.prototype, e), n && B2e(t, n), t;
}
function fG(t, e, n) {
  return typeof Reflect < "u" && Reflect.get ? fG = Reflect.get : fG = function(i, o, s) {
    var a = nOn(i, o);
    if (a) {
      var A = Object.getOwnPropertyDescriptor(a, o);
      return A.get ? A.get.call(s) : A.value;
    }
  }, fG(t, e, n || t);
}
function nOn(t, e) {
  for (; !Object.prototype.hasOwnProperty.call(t, e) && (t = ZS(t), t !== null); )
    ;
  return t;
}
function rOn(t) {
  return function() {
    var e = ZS(t), n;
    if (sOn()) {
      var r = ZS(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return iOn(this, n);
  };
}
function iOn(t, e) {
  return e && (uG(e) === "object" || typeof e == "function") ? e : oOn(t);
}
function oOn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function sOn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ZS(t) {
  return ZS = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ZS(t);
}
function aOn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && wne(t, e);
}
function wne(t, e) {
  return wne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, wne(t, e);
}
var AOn = /* @__PURE__ */ function(t) {
  aOn(n, t);
  var e = rOn(n);
  function n() {
    return eOn(this, n), e.apply(this, arguments);
  }
  return tOn(n, [{
    key: "createTentativeFeature",
    value: function(i) {
      var o = i.lastPointerMoveEvent, s = o ? [o.mapCoords] : [];
      return {
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "Point",
          coordinates: s[0]
        }
      };
    }
  }, {
    key: "handleClick",
    value: function(i, o) {
      var s = i.mapCoords, a = {
        type: "Point",
        coordinates: s
      };
      o.onEdit(this.getAddFeatureAction(a, o.data));
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      o.onUpdateCursor("cell"), fG(ZS(n.prototype), "handlePointerMove", this).call(this, i, o);
    }
  }]), n;
}(ZMn.GeoJsonEditMode);
tq.DrawPointMode = AOn;
var nq = {};
Object.defineProperty(nq, "__esModule", {
  value: !0
});
nq.DrawLineStringMode = void 0;
var lOn = ao, cOn = ts;
function gG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? gG = function(n) {
    return typeof n;
  } : gG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, gG(t);
}
function PP(t) {
  return hOn(t) || gOn(t) || fOn(t) || uOn();
}
function uOn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fOn(t, e) {
  if (t) {
    if (typeof t == "string")
      return xne(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return xne(t, e);
  }
}
function gOn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function hOn(t) {
  if (Array.isArray(t))
    return xne(t);
}
function xne(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function dOn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function b2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function pOn(t, e, n) {
  return e && b2e(t.prototype, e), n && b2e(t, n), t;
}
function IOn(t) {
  return function() {
    var e = B8(t), n;
    if (EOn()) {
      var r = B8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return mOn(this, n);
  };
}
function mOn(t, e) {
  return e && (gG(e) === "object" || typeof e == "function") ? e : COn(t);
}
function COn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function EOn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function B8(t) {
  return B8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, B8(t);
}
function yOn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Rne(t, e);
}
function Rne(t, e) {
  return Rne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Rne(t, e);
}
var vOn = /* @__PURE__ */ function(t) {
  yOn(n, t);
  var e = IOn(n);
  function n() {
    return dOn(this, n), e.apply(this, arguments);
  }
  return pOn(n, [{
    key: "handleClick",
    value: function(i, o) {
      var s = i.picks, a = (0, lOn.getPickedEditHandle)(s), A = !1;
      a || (this.addClickSequence(i), A = !0);
      var l = this.getClickSequence();
      if (l.length > 1 && a && Array.isArray(a.properties.positionIndexes) && a.properties.positionIndexes[0] === l.length - 1) {
        var c = {
          type: "LineString",
          coordinates: PP(l)
        };
        this.resetClickSequence();
        var u = this.getAddFeatureAction(c, o.data);
        u && o.onEdit(u);
      } else
        A && o.onEdit({
          // data is the same
          updatedData: o.data,
          editType: "addTentativePosition",
          editContext: {
            position: i.mapCoords
          }
        });
    }
  }, {
    key: "handleKeyUp",
    value: function(i, o) {
      var s = i.key;
      if (s === "Enter") {
        var a = this.getClickSequence();
        if (a.length > 1) {
          var A = {
            type: "LineString",
            coordinates: PP(a)
          };
          this.resetClickSequence();
          var l = this.getAddFeatureAction(A, o.data);
          l && o.onEdit(l);
        }
      }
    }
  }, {
    key: "getGuides",
    value: function(i) {
      var o, s = i.lastPointerMoveEvent, a = this.getClickSequence(), A = s ? [s.mapCoords] : [], l = {
        type: "FeatureCollection",
        features: []
      }, c;
      a.length > 0 && (c = {
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [].concat(PP(a), A)
        }
      }), c && l.features.push(c);
      var u = a.map(function(f, h) {
        return {
          type: "Feature",
          properties: {
            guideType: "editHandle",
            editHandleType: "existing",
            featureIndex: -1,
            positionIndexes: [h]
          },
          geometry: {
            type: "Point",
            coordinates: f
          }
        };
      });
      return (o = l.features).push.apply(o, PP(u)), l;
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      o.onUpdateCursor("cell");
    }
  }]), n;
}(cOn.GeoJsonEditMode);
nq.DrawLineStringMode = vOn;
var Vw = {};
Object.defineProperty(Vw, "__esModule", {
  value: !0
});
Vw.DrawPolygonMode = void 0;
var BOn = ao, bOn = ts;
function hG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? hG = function(n) {
    return typeof n;
  } : hG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, hG(t);
}
function w2(t) {
  return wOn(t) || QOn(t) || SOn(t) || _On();
}
function _On() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function SOn(t, e) {
  if (t) {
    if (typeof t == "string")
      return Dne(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Dne(t, e);
  }
}
function QOn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function wOn(t) {
  if (Array.isArray(t))
    return Dne(t);
}
function Dne(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function xOn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function ROn(t, e, n) {
  return e && _2e(t.prototype, e), n && _2e(t, n), t;
}
function dG(t, e, n) {
  return typeof Reflect < "u" && Reflect.get ? dG = Reflect.get : dG = function(i, o, s) {
    var a = DOn(i, o);
    if (a) {
      var A = Object.getOwnPropertyDescriptor(a, o);
      return A.get ? A.get.call(s) : A.value;
    }
  }, dG(t, e, n || t);
}
function DOn(t, e) {
  for (; !Object.prototype.hasOwnProperty.call(t, e) && (t = eQ(t), t !== null); )
    ;
  return t;
}
function TOn(t) {
  return function() {
    var e = eQ(t), n;
    if (MOn()) {
      var r = eQ(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return NOn(this, n);
  };
}
function NOn(t, e) {
  return e && (hG(e) === "object" || typeof e == "function") ? e : LOn(t);
}
function LOn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function MOn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function eQ(t) {
  return eQ = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, eQ(t);
}
function OOn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Tne(t, e);
}
function Tne(t, e) {
  return Tne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Tne(t, e);
}
var FOn = /* @__PURE__ */ function(t) {
  OOn(n, t);
  var e = TOn(n);
  function n() {
    return xOn(this, n), e.apply(this, arguments);
  }
  return ROn(n, [{
    key: "createTentativeFeature",
    value: function(i) {
      var o = i.lastPointerMoveEvent, s = this.getClickSequence(), a = o ? [o.mapCoords] : [], A;
      return s.length === 1 || s.length === 2 ? A = {
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [].concat(w2(s), a)
        }
      } : s.length > 2 && (A = {
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "Polygon",
          coordinates: [[].concat(w2(s), a, [s[0]])]
        }
      }), A;
    }
  }, {
    key: "getGuides",
    value: function(i) {
      var o, s = this.getClickSequence(), a = {
        type: "FeatureCollection",
        features: []
      }, A = this.createTentativeFeature(i);
      A && a.features.push(A);
      var l = s.map(function(c, u) {
        return {
          type: "Feature",
          properties: {
            guideType: "editHandle",
            editHandleType: "existing",
            featureIndex: -1,
            positionIndexes: [u]
          },
          geometry: {
            type: "Point",
            coordinates: c
          }
        };
      });
      return (o = a.features).push.apply(o, w2(l)), a;
    }
  }, {
    key: "handleClick",
    value: function(i, o) {
      var s = i.picks, a = (0, BOn.getPickedEditHandle)(s), A = !1;
      a || (this.addClickSequence(i), A = !0);
      var l = this.getClickSequence();
      if (l.length > 2 && a && Array.isArray(a.properties.positionIndexes) && (a.properties.positionIndexes[0] === 0 || a.properties.positionIndexes[0] === l.length - 1)) {
        var c = {
          type: "Polygon",
          coordinates: [[].concat(w2(l), [l[0]])]
        };
        this.resetClickSequence();
        var u = this.getAddFeatureOrBooleanPolygonAction(c, o);
        u && o.onEdit(u);
      } else
        A && o.onEdit({
          // data is the same
          updatedData: o.data,
          editType: "addTentativePosition",
          editContext: {
            position: i.mapCoords
          }
        });
    }
  }, {
    key: "handleKeyUp",
    value: function(i, o) {
      if (i.key === "Enter") {
        var s = this.getClickSequence();
        if (s.length > 2) {
          var a = {
            type: "Polygon",
            coordinates: [[].concat(w2(s), [s[0]])]
          };
          this.resetClickSequence();
          var A = this.getAddFeatureOrBooleanPolygonAction(a, o);
          A && o.onEdit(A);
        }
      }
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      o.onUpdateCursor("cell"), dG(eQ(n.prototype), "handlePointerMove", this).call(this, i, o);
    }
  }]), n;
}(bOn.GeoJsonEditMode);
Vw.DrawPolygonMode = FOn;
var rq = {}, NE = {};
Object.defineProperty(NE, "__esModule", {
  value: !0
});
NE.TwoClickPolygonMode = void 0;
var POn = ts;
function pG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? pG = function(n) {
    return typeof n;
  } : pG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, pG(t);
}
function kOn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function S2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function GOn(t, e, n) {
  return e && S2e(t.prototype, e), n && S2e(t, n), t;
}
function IG(t, e, n) {
  return typeof Reflect < "u" && Reflect.get ? IG = Reflect.get : IG = function(i, o, s) {
    var a = UOn(i, o);
    if (a) {
      var A = Object.getOwnPropertyDescriptor(a, o);
      return A.get ? A.get.call(s) : A.value;
    }
  }, IG(t, e, n || t);
}
function UOn(t, e) {
  for (; !Object.prototype.hasOwnProperty.call(t, e) && (t = tQ(t), t !== null); )
    ;
  return t;
}
function HOn(t) {
  return function() {
    var e = tQ(t), n;
    if (jOn()) {
      var r = tQ(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return $On(this, n);
  };
}
function $On(t, e) {
  return e && (pG(e) === "object" || typeof e == "function") ? e : qOn(t);
}
function qOn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function jOn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function tQ(t) {
  return tQ = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, tQ(t);
}
function YOn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Nne(t, e);
}
function Nne(t, e) {
  return Nne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Nne(t, e);
}
var zOn = /* @__PURE__ */ function(t) {
  YOn(n, t);
  var e = HOn(n);
  function n() {
    return kOn(this, n), e.apply(this, arguments);
  }
  return GOn(n, [{
    key: "handleClick",
    value: function(i, o) {
      o.modeConfig && o.modeConfig.dragToDraw || (this.addClickSequence(i), this.checkAndFinishPolygon(o));
    }
  }, {
    key: "handleStartDragging",
    value: function(i, o) {
      !o.modeConfig || !o.modeConfig.dragToDraw || (this.addClickSequence(i), i.cancelPan());
    }
  }, {
    key: "handleStopDragging",
    value: function(i, o) {
      !o.modeConfig || !o.modeConfig.dragToDraw || (this.addClickSequence(i), this.checkAndFinishPolygon(o));
    }
  }, {
    key: "checkAndFinishPolygon",
    value: function(i) {
      var o = this.getClickSequence(), s = this.getTentativeGuide(i);
      if (o.length > 1 && s && s.geometry.type === "Polygon") {
        var a = {
          type: "Feature",
          properties: {
            shape: s.properties.shape
          },
          geometry: {
            type: "Polygon",
            coordinates: s.geometry.coordinates
          }
        }, A = this.getAddFeatureOrBooleanPolygonAction(a, i);
        this.resetClickSequence(), A && i.onEdit(A);
      }
    }
  }, {
    key: "getGuides",
    value: function(i) {
      var o = i.lastPointerMoveEvent, s = i.modeConfig, a = this.getClickSequence(), A = {
        type: "FeatureCollection",
        features: []
      };
      if (a.length === 0)
        return A;
      var l = a[0], c = o.mapCoords, u = this.getTwoClickPolygon(l, c, s);
      return u && A.features.push({
        type: "Feature",
        properties: {
          shape: u.properties && u.properties.shape,
          guideType: "tentative"
        },
        geometry: u.geometry
      }), A;
    }
  }, {
    key: "getTwoClickPolygon",
    value: function(i, o, s) {
      return null;
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      o.onUpdateCursor("cell"), IG(tQ(n.prototype), "handlePointerMove", this).call(this, i, o);
    }
  }, {
    key: "createTentativeFeature",
    value: function(i) {
      var o = i.lastPointerMoveEvent, s = this.getClickSequence(), a = o ? [o.mapCoords] : [], A;
      return s.length === 1 && (A = this.getTwoClickPolygon(s[0], a[0], i.modeConfig)), A;
    }
  }]), n;
}(POn.GeoJsonEditMode);
NE.TwoClickPolygonMode = zOn;
Object.defineProperty(rq, "__esModule", {
  value: !0
});
rq.DrawRectangleMode = void 0;
var VOn = KOn(xE), JOn = NE;
function KOn(t) {
  return t && t.__esModule ? t : { default: t };
}
function mG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? mG = function(n) {
    return typeof n;
  } : mG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, mG(t);
}
function WOn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Q2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function XOn(t, e, n) {
  return e && Q2e(t.prototype, e), n && Q2e(t, n), t;
}
function ZOn(t) {
  return function() {
    var e = b8(t), n;
    if (nFn()) {
      var r = b8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return eFn(this, n);
  };
}
function eFn(t, e) {
  return e && (mG(e) === "object" || typeof e == "function") ? e : tFn(t);
}
function tFn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function nFn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function b8(t) {
  return b8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, b8(t);
}
function rFn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Lne(t, e);
}
function Lne(t, e) {
  return Lne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Lne(t, e);
}
var iFn = /* @__PURE__ */ function(t) {
  rFn(n, t);
  var e = ZOn(n);
  function n() {
    return WOn(this, n), e.apply(this, arguments);
  }
  return XOn(n, [{
    key: "getTwoClickPolygon",
    value: function(i, o, s) {
      var a = (0, VOn.default)([i[0], i[1], o[0], o[1]]);
      return a.properties = a.properties || {}, a.properties.shape = "Rectangle", a;
    }
  }]), n;
}(JOn.TwoClickPolygonMode);
rq.DrawRectangleMode = iFn;
var iq = {}, Due = {}, Tue = ei && ei.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Due, "__esModule", { value: !0 });
var oFn = Tue(zf), sFn = Tue(DE), aFn = Tue(hl), w2e = ar, AFn = Eo;
function lFn(t, e, n) {
  n === void 0 && (n = {});
  for (var r = AFn.getGeom(t), i = r.coordinates, o = 0, s = 0; s < i.length && !(e >= o && s === i.length - 1); s++)
    if (o >= e) {
      var a = e - o;
      if (a) {
        var A = oFn.default(i[s], i[s - 1]) - 180, l = sFn.default(i[s], a, A, n);
        return l;
      } else
        return w2e.point(i[s]);
    } else
      o += aFn.default(i[s], i[s + 1], n);
  return w2e.point(i[i.length - 1]);
}
Due.default = lFn;
Object.defineProperty(iq, "__esModule", {
  value: !0
});
iq.DrawSquareFromCenterMode = void 0;
var cFn = Nue(xE), x2e = Nue(hl), uFn = Nue(Due), x2 = ar, fFn = NE;
function Nue(t) {
  return t && t.__esModule ? t : { default: t };
}
function CG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? CG = function(n) {
    return typeof n;
  } : CG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, CG(t);
}
function gFn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function R2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function hFn(t, e, n) {
  return e && R2e(t.prototype, e), n && R2e(t, n), t;
}
function dFn(t) {
  return function() {
    var e = _8(t), n;
    if (mFn()) {
      var r = _8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return pFn(this, n);
  };
}
function pFn(t, e) {
  return e && (CG(e) === "object" || typeof e == "function") ? e : IFn(t);
}
function IFn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function mFn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _8(t) {
  return _8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _8(t);
}
function CFn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Mne(t, e);
}
function Mne(t, e) {
  return Mne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Mne(t, e);
}
var EFn = /* @__PURE__ */ function(t) {
  CFn(n, t);
  var e = dFn(n);
  function n() {
    return gFn(this, n), e.apply(this, arguments);
  }
  return hFn(n, [{
    key: "getTwoClickPolygon",
    value: function(i, o, s) {
      var a = [o[0], i[1]], A = [i[0], o[1]], l = (0, x2e.default)((0, x2.point)(a), (0, x2.point)(i)), c = (0, x2e.default)((0, x2.point)(A), (0, x2.point)(i)), u = l <= c ? l : c, f = l <= c ? a : A, h = (0, x2.lineString)([f, o]), d = (0, uFn.default)(h, u), I = d.geometry.coordinates, m = i[0] > I[0] ? i[0] + Math.abs(i[0] - I[0]) : i[0] - Math.abs(i[0] - I[0]), C = i[1] > I[1] ? i[1] + Math.abs(i[1] - I[1]) : i[1] - Math.abs(i[1] - I[1]), y = (0, cFn.default)([m, C, I[0], I[1]]);
      return y.properties = y.properties || {}, y.properties.shape = "Square", y;
    }
  }]), n;
}(fFn.TwoClickPolygonMode);
iq.DrawSquareFromCenterMode = EFn;
var oq = {};
Object.defineProperty(oq, "__esModule", {
  value: !0
});
oq.DrawCircleByDiameterMode = void 0;
var yFn = dVe(NM), vFn = dVe(hl), BFn = ts, bFn = NE;
function dVe(t) {
  return t && t.__esModule ? t : { default: t };
}
function EG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? EG = function(n) {
    return typeof n;
  } : EG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, EG(t);
}
function _Fn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function D2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function SFn(t, e, n) {
  return e && D2e(t.prototype, e), n && D2e(t, n), t;
}
function QFn(t) {
  return function() {
    var e = S8(t), n;
    if (RFn()) {
      var r = S8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return wFn(this, n);
  };
}
function wFn(t, e) {
  return e && (EG(e) === "object" || typeof e == "function") ? e : xFn(t);
}
function xFn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function RFn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function S8(t) {
  return S8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, S8(t);
}
function DFn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && One(t, e);
}
function One(t, e) {
  return One = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, One(t, e);
}
var TFn = /* @__PURE__ */ function(t) {
  DFn(n, t);
  var e = QFn(n);
  function n() {
    return _Fn(this, n), e.apply(this, arguments);
  }
  return SFn(n, [{
    key: "getTwoClickPolygon",
    value: function(i, o, s) {
      var a = s || {}, A = a.steps, l = A === void 0 ? 64 : A, c = {
        steps: l
      };
      l < 4 && (console.warn("Minimum steps to draw a circle is 4 "), c.steps = 4);
      var u = (0, BFn.getIntermediatePosition)(i, o), f = Math.max((0, vFn.default)(i, u), 1e-3), h = (0, yFn.default)(u, f, c);
      return h.properties = h.properties || {}, h.properties.shape = "Circle", h;
    }
  }]), n;
}(bFn.TwoClickPolygonMode);
oq.DrawCircleByDiameterMode = TFn;
var sq = {};
Object.defineProperty(sq, "__esModule", {
  value: !0
});
sq.DrawCircleFromCenterMode = void 0;
var NFn = pVe(NM), LFn = pVe(hl), MFn = NE;
function pVe(t) {
  return t && t.__esModule ? t : { default: t };
}
function yG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? yG = function(n) {
    return typeof n;
  } : yG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, yG(t);
}
function OFn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function T2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function FFn(t, e, n) {
  return e && T2e(t.prototype, e), n && T2e(t, n), t;
}
function PFn(t) {
  return function() {
    var e = Q8(t), n;
    if (UFn()) {
      var r = Q8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return kFn(this, n);
  };
}
function kFn(t, e) {
  return e && (yG(e) === "object" || typeof e == "function") ? e : GFn(t);
}
function GFn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function UFn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Q8(t) {
  return Q8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Q8(t);
}
function HFn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Fne(t, e);
}
function Fne(t, e) {
  return Fne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Fne(t, e);
}
var $Fn = /* @__PURE__ */ function(t) {
  HFn(n, t);
  var e = PFn(n);
  function n() {
    return OFn(this, n), e.apply(this, arguments);
  }
  return FFn(n, [{
    key: "getTwoClickPolygon",
    value: function(i, o, s) {
      var a = s || {}, A = a.steps, l = A === void 0 ? 64 : A, c = {
        steps: l
      };
      l < 4 && (console.warn("Minimum steps to draw a circle is 4 "), c.steps = 4);
      var u = Math.max((0, LFn.default)(i, o), 1e-3), f = (0, NFn.default)(i, u, c);
      return f.properties = f.properties || {}, f.properties.shape = "Circle", f;
    }
  }]), n;
}(MFn.TwoClickPolygonMode);
sq.DrawCircleFromCenterMode = $Fn;
var aq = {}, Lue = { exports: {} }, Cb = ar, qFn = zw, jFn = AVe, RJ = Eo;
function IVe(t) {
  return t && typeof t == "object" && "default" in t ? t : { default: t };
}
var N2e = /* @__PURE__ */ IVe(qFn), YFn = /* @__PURE__ */ IVe(jFn);
function mVe(t, e, n, r) {
  r = r || {};
  var i = r.steps || 64, o = r.units || "kilometers", s = r.angle || 0, a = r.pivot || t, A = r.properties || t.properties || {};
  if (!t)
    throw new Error("center is required");
  if (!e)
    throw new Error("xSemiAxis is required");
  if (!n)
    throw new Error("ySemiAxis is required");
  if (!Cb.isObject(r))
    throw new Error("options must be an object");
  if (!Cb.isNumber(i))
    throw new Error("steps must be a number");
  if (!Cb.isNumber(s))
    throw new Error("angle must be a number");
  var l = RJ.getCoord(t);
  if (o === "degrees")
    var c = Cb.degreesToRadians(s);
  else
    e = N2e.default(t, e, 90, { units: o }), n = N2e.default(t, n, 0, { units: o }), e = RJ.getCoord(e)[0] - l[0], n = RJ.getCoord(n)[1] - l[1];
  for (var u = [], f = 0; f < i; f += 1) {
    var h = f * -360 / i, d = e * n / Math.sqrt(
      Math.pow(n, 2) + Math.pow(e, 2) * Math.pow(L2e(h), 2)
    ), I = e * n / Math.sqrt(
      Math.pow(e, 2) + Math.pow(n, 2) / Math.pow(L2e(h), 2)
    );
    if (h < -90 && h >= -270 && (d = -d), h < -180 && h >= -360 && (I = -I), o === "degrees") {
      var m = d * Math.cos(c) + I * Math.sin(c), C = I * Math.cos(c) - d * Math.sin(c);
      d = m, I = C;
    }
    u.push([d + l[0], I + l[1]]);
  }
  return u.push(u[0]), o === "degrees" ? Cb.polygon([u], A) : YFn.default(Cb.polygon([u], A), s, {
    pivot: a
  });
}
function L2e(t) {
  var e = t * Math.PI / 180;
  return Math.tan(e);
}
Lue.exports = mVe;
Lue.exports.default = mVe;
var CVe = Lue.exports;
Object.defineProperty(aq, "__esModule", {
  value: !0
});
aq.DrawEllipseByBoundingBoxMode = void 0;
var zFn = Mue(xE), M2e = Mue(hl), VFn = Mue(CVe), kP = ar, JFn = ts, KFn = NE;
function Mue(t) {
  return t && t.__esModule ? t : { default: t };
}
function vG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? vG = function(n) {
    return typeof n;
  } : vG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, vG(t);
}
function WFn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function O2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function XFn(t, e, n) {
  return e && O2e(t.prototype, e), n && O2e(t, n), t;
}
function ZFn(t) {
  return function() {
    var e = w8(t), n;
    if (nPn()) {
      var r = w8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return ePn(this, n);
  };
}
function ePn(t, e) {
  return e && (vG(e) === "object" || typeof e == "function") ? e : tPn(t);
}
function tPn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function nPn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function w8(t) {
  return w8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, w8(t);
}
function rPn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Pne(t, e);
}
function Pne(t, e) {
  return Pne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Pne(t, e);
}
var iPn = /* @__PURE__ */ function(t) {
  rPn(n, t);
  var e = ZFn(n);
  function n() {
    return WFn(this, n), e.apply(this, arguments);
  }
  return XFn(n, [{
    key: "getTwoClickPolygon",
    value: function(i, o, s) {
      var a = Math.min(i[0], o[0]), A = Math.min(i[1], o[1]), l = Math.max(i[0], o[0]), c = Math.max(i[1], o[1]), u = (0, zFn.default)([a, A, l, c]).geometry.coordinates[0], f = (0, JFn.getIntermediatePosition)(i, o), h = Math.max((0, M2e.default)((0, kP.point)(u[0]), (0, kP.point)(u[1])), 1e-3), d = Math.max((0, M2e.default)((0, kP.point)(u[0]), (0, kP.point)(u[3])), 1e-3);
      return (0, VFn.default)(f, h, d);
    }
  }]), n;
}(KFn.TwoClickPolygonMode);
aq.DrawEllipseByBoundingBoxMode = iPn;
var Aq = {}, PM = {};
Object.defineProperty(PM, "__esModule", {
  value: !0
});
PM.ThreeClickPolygonMode = void 0;
var oPn = ts;
function BG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? BG = function(n) {
    return typeof n;
  } : BG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, BG(t);
}
function sPn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function F2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function aPn(t, e, n) {
  return e && F2e(t.prototype, e), n && F2e(t, n), t;
}
function bG(t, e, n) {
  return typeof Reflect < "u" && Reflect.get ? bG = Reflect.get : bG = function(i, o, s) {
    var a = APn(i, o);
    if (a) {
      var A = Object.getOwnPropertyDescriptor(a, o);
      return A.get ? A.get.call(s) : A.value;
    }
  }, bG(t, e, n || t);
}
function APn(t, e) {
  for (; !Object.prototype.hasOwnProperty.call(t, e) && (t = nQ(t), t !== null); )
    ;
  return t;
}
function lPn(t) {
  return function() {
    var e = nQ(t), n;
    if (fPn()) {
      var r = nQ(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return cPn(this, n);
  };
}
function cPn(t, e) {
  return e && (BG(e) === "object" || typeof e == "function") ? e : uPn(t);
}
function uPn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function fPn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function nQ(t) {
  return nQ = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, nQ(t);
}
function gPn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && kne(t, e);
}
function kne(t, e) {
  return kne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, kne(t, e);
}
var hPn = /* @__PURE__ */ function(t) {
  gPn(n, t);
  var e = lPn(n);
  function n() {
    return sPn(this, n), e.apply(this, arguments);
  }
  return aPn(n, [{
    key: "handleClick",
    value: function(i, o) {
      this.addClickSequence(i);
      var s = this.getClickSequence(), a = this.getTentativeGuide(o);
      if (s.length > 2 && a && a.geometry.type === "Polygon") {
        var A = this.getAddFeatureOrBooleanPolygonAction(a.geometry, o);
        this.resetClickSequence(), A && o.onEdit(A);
      }
    }
  }, {
    key: "getGuides",
    value: function(i) {
      var o = i.lastPointerMoveEvent, s = i.modeConfig, a = this.getClickSequence(), A = {
        type: "FeatureCollection",
        features: []
      };
      if (a.length === 0)
        return A;
      var l = o.mapCoords;
      if (a.length === 1)
        A.features.push({
          type: "Feature",
          properties: {
            guideType: "tentative"
          },
          geometry: {
            type: "LineString",
            coordinates: [a[0], l]
          }
        });
      else {
        var c = this.getThreeClickPolygon(a[0], a[1], l, s);
        c && A.features.push({
          type: "Feature",
          properties: {
            guideType: "tentative"
          },
          geometry: c.geometry
        });
      }
      return A;
    }
  }, {
    key: "getThreeClickPolygon",
    value: function(i, o, s, a) {
      return null;
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      o.onUpdateCursor("cell"), bG(nQ(n.prototype), "handlePointerMove", this).call(this, i, o);
    }
  }, {
    key: "createTentativeFeature",
    value: function(i) {
      var o = i.lastPointerMoveEvent, s = this.getClickSequence(), a = o ? [o.mapCoords] : [], A;
      return s.length === 2 && (A = this.getThreeClickPolygon(s[0], s[1], a[0], i.modeConfig)), A;
    }
  }]), n;
}(oPn.GeoJsonEditMode);
PM.ThreeClickPolygonMode = hPn;
Object.defineProperty(Aq, "__esModule", {
  value: !0
});
Aq.DrawEllipseUsingThreePointsMode = void 0;
var P2e = Oue(hl), dPn = Oue(CVe), pPn = Oue(zf), IPn = ar, mPn = ts, CPn = PM;
function Oue(t) {
  return t && t.__esModule ? t : { default: t };
}
function _G(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _G = function(n) {
    return typeof n;
  } : _G = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _G(t);
}
function EPn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function k2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function yPn(t, e, n) {
  return e && k2e(t.prototype, e), n && k2e(t, n), t;
}
function vPn(t) {
  return function() {
    var e = x8(t), n;
    if (_Pn()) {
      var r = x8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return BPn(this, n);
  };
}
function BPn(t, e) {
  return e && (_G(e) === "object" || typeof e == "function") ? e : bPn(t);
}
function bPn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function _Pn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function x8(t) {
  return x8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, x8(t);
}
function SPn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Gne(t, e);
}
function Gne(t, e) {
  return Gne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Gne(t, e);
}
var QPn = /* @__PURE__ */ function(t) {
  SPn(n, t);
  var e = vPn(n);
  function n() {
    return EPn(this, n), e.apply(this, arguments);
  }
  return yPn(n, [{
    key: "getThreeClickPolygon",
    value: function(i, o, s, a) {
      var A = (0, mPn.getIntermediatePosition)(i, o), l = Math.max((0, P2e.default)(A, (0, IPn.point)(s)), 1e-3), c = Math.max((0, P2e.default)(i, o), 1e-3) / 2, u = {
        angle: (0, pPn.default)(i, o)
      };
      return (0, dPn.default)(A, l, c, u);
    }
  }]), n;
}(CPn.ThreeClickPolygonMode);
Aq.DrawEllipseUsingThreePointsMode = QPn;
var lq = {};
Object.defineProperty(lq, "__esModule", {
  value: !0
});
lq.DrawRectangleUsingThreePointsMode = void 0;
var wPn = ao, xPn = PM;
function SG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? SG = function(n) {
    return typeof n;
  } : SG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, SG(t);
}
function RPn(t, e) {
  return LPn(t) || NPn(t, e) || TPn(t, e) || DPn();
}
function DPn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function TPn(t, e) {
  if (t) {
    if (typeof t == "string")
      return G2e(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return G2e(t, e);
  }
}
function G2e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function NPn(t, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var n = [], r = !0, i = !1, o = void 0;
    try {
      for (var s = t[Symbol.iterator](), a; !(r = (a = s.next()).done) && (n.push(a.value), !(e && n.length === e)); r = !0)
        ;
    } catch (A) {
      i = !0, o = A;
    } finally {
      try {
        !r && s.return != null && s.return();
      } finally {
        if (i)
          throw o;
      }
    }
    return n;
  }
}
function LPn(t) {
  if (Array.isArray(t))
    return t;
}
function MPn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function U2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function OPn(t, e, n) {
  return e && U2e(t.prototype, e), n && U2e(t, n), t;
}
function FPn(t) {
  return function() {
    var e = R8(t), n;
    if (GPn()) {
      var r = R8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return PPn(this, n);
  };
}
function PPn(t, e) {
  return e && (SG(e) === "object" || typeof e == "function") ? e : kPn(t);
}
function kPn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function GPn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function R8(t) {
  return R8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, R8(t);
}
function UPn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Une(t, e);
}
function Une(t, e) {
  return Une = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Une(t, e);
}
var HPn = /* @__PURE__ */ function(t) {
  UPn(n, t);
  var e = FPn(n);
  function n() {
    return MPn(this, n), e.apply(this, arguments);
  }
  return OPn(n, [{
    key: "getThreeClickPolygon",
    value: function(i, o, s, a) {
      var A = (0, wPn.generatePointsParallelToLinePoints)(i, o, s), l = RPn(A, 2), c = l[0], u = l[1];
      return {
        type: "Feature",
        properties: {
          shape: "Rectangle"
        },
        geometry: {
          type: "Polygon",
          coordinates: [[
            // Draw a polygon containing all the points of the LineString,
            // then the points orthogonal to the lineString,
            // then back to the starting position
            i,
            o,
            c,
            u,
            i
          ]]
        }
      };
    }
  }]), n;
}(xPn.ThreeClickPolygonMode);
lq.DrawRectangleUsingThreePointsMode = HPn;
var cq = {};
Object.defineProperty(cq, "__esModule", {
  value: !0
});
cq.Draw90DegreePolygonMode = void 0;
var H2e = uq(DE), $2e = uq(zf), $Pn = uq(W$), qPn = uq(hl), GP = ar, DJ = ao, jPn = ts;
function uq(t) {
  return t && t.__esModule ? t : { default: t };
}
function QG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? QG = function(n) {
    return typeof n;
  } : QG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, QG(t);
}
function Wd(t) {
  return VPn(t) || zPn(t) || EVe(t) || YPn();
}
function YPn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zPn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function VPn(t) {
  if (Array.isArray(t))
    return Hne(t);
}
function JPn(t, e) {
  return XPn(t) || WPn(t, e) || EVe(t, e) || KPn();
}
function KPn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function EVe(t, e) {
  if (t) {
    if (typeof t == "string")
      return Hne(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Hne(t, e);
  }
}
function Hne(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function WPn(t, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var n = [], r = !0, i = !1, o = void 0;
    try {
      for (var s = t[Symbol.iterator](), a; !(r = (a = s.next()).done) && (n.push(a.value), !(e && n.length === e)); r = !0)
        ;
    } catch (A) {
      i = !0, o = A;
    } finally {
      try {
        !r && s.return != null && s.return();
      } finally {
        if (i)
          throw o;
      }
    }
    return n;
  }
}
function XPn(t) {
  if (Array.isArray(t))
    return t;
}
function ZPn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function q2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function e3n(t, e, n) {
  return e && q2e(t.prototype, e), n && q2e(t, n), t;
}
function wG(t, e, n) {
  return typeof Reflect < "u" && Reflect.get ? wG = Reflect.get : wG = function(i, o, s) {
    var a = t3n(i, o);
    if (a) {
      var A = Object.getOwnPropertyDescriptor(a, o);
      return A.get ? A.get.call(s) : A.value;
    }
  }, wG(t, e, n || t);
}
function t3n(t, e) {
  for (; !Object.prototype.hasOwnProperty.call(t, e) && (t = rQ(t), t !== null); )
    ;
  return t;
}
function n3n(t) {
  return function() {
    var e = rQ(t), n;
    if (o3n()) {
      var r = rQ(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return r3n(this, n);
  };
}
function r3n(t, e) {
  return e && (QG(e) === "object" || typeof e == "function") ? e : i3n(t);
}
function i3n(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function o3n() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function rQ(t) {
  return rQ = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, rQ(t);
}
function s3n(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && $ne(t, e);
}
function $ne(t, e) {
  return $ne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, $ne(t, e);
}
var a3n = /* @__PURE__ */ function(t) {
  s3n(n, t);
  var e = n3n(n);
  function n() {
    return ZPn(this, n), e.apply(this, arguments);
  }
  return e3n(n, [{
    key: "createTentativeFeature",
    value: function(i) {
      var o = this.getClickSequence(), s = i.lastPointerMoveEvent.mapCoords, a;
      if (o.length === 1)
        a = s;
      else {
        var A = o[o.length - 2], l = o[o.length - 1], c = (0, DJ.generatePointsParallelToLinePoints)(A, l, s), u = JPn(c, 1);
        a = u[0];
      }
      var f;
      return o.length < 3 ? f = {
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [].concat(Wd(o), [a])
        }
      } : f = {
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "Polygon",
          coordinates: [[].concat(Wd(o), [a, o[0]])]
        }
      }, f;
    }
  }, {
    key: "getGuides",
    value: function(i) {
      var o = {
        type: "FeatureCollection",
        features: []
      }, s = this.getClickSequence();
      if (s.length === 0 || !i.lastPointerMoveEvent)
        return o;
      var a = this.createTentativeFeature(i);
      return o.features.push(a), o.features = o.features.concat((0, DJ.getEditHandlesForGeometry)(a.geometry, -1)), o.features = o.features.slice(0, -1), o;
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      o.onUpdateCursor("cell"), wG(rQ(n.prototype), "handlePointerMove", this).call(this, i, o);
    }
  }, {
    key: "handleClick",
    value: function(i, o) {
      var s = i.picks, a = this.getTentativeGuide(o);
      this.addClickSequence(i);
      var A = this.getClickSequence();
      if (a) {
        if (A.length === 3 && a.geometry.type === "LineString") {
          var l = a.geometry;
          A[A.length - 1] = l.coordinates[l.coordinates.length - 1];
        } else if (A.length > 3 && a.geometry.type === "Polygon") {
          var c = a.geometry;
          A[A.length - 1] = c.coordinates[0][c.coordinates[0].length - 2];
          var u = (0, DJ.getPickedEditHandle)(s);
          if (u && Array.isArray(u.properties.positionIndexes) && (u.properties.positionIndexes[1] === 0 || u.properties.positionIndexes[1] === c.coordinates[0].length - 3)) {
            var f = {
              type: "Polygon",
              coordinates: this.finalizedCoordinates(Wd(c.coordinates[0]))
            };
            this.resetClickSequence();
            var h = this.getAddFeatureOrBooleanPolygonAction(f, o);
            h && o.onEdit(h);
          }
        }
        var d = {
          screenCoords: [-1, -1],
          mapCoords: i.mapCoords,
          picks: [],
          pointerDownPicks: null,
          pointerDownScreenCoords: null,
          pointerDownMapCoords: null,
          cancelPan: function() {
          },
          sourceEvent: null
        };
        this.handlePointerMove(d, o);
      }
    }
  }, {
    key: "finalizedCoordinates",
    value: function(i) {
      var o = [[].concat(Wd(i.slice(0, -2)), [i[0]])], s = this.getIntermediatePoint(Wd(i));
      if (s)
        o = [[].concat(Wd(i.slice(0, -2)), [s, i[0]])];
      else {
        var a = Wd(i);
        a.splice(-3, 1), s = this.getIntermediatePoint(Wd(a)), s && (o = [[].concat(Wd(i.slice(0, -3)), [s, i[0]])]);
      }
      return o;
    }
  }, {
    key: "getIntermediatePoint",
    value: function(i) {
      var o;
      if (i.length > 4) {
        var s = Wd(i), a = s[0], A = s[1], l = (0, $2e.default)(a, A), c = i[i.length - 3], u = i[i.length - 4], f = (0, $2e.default)(c, u), h = {
          first: [],
          second: []
        };
        [1, 2, 3].forEach(function(I) {
          var m = l + I * 90;
          h.first.push(m > 180 ? m - 360 : m);
          var C = f + I * 90;
          h.second.push(C > 180 ? C - 360 : C);
        });
        var d = (0, qPn.default)((0, GP.point)(a), (0, GP.point)(c));
        [0, 1, 2].forEach(function(I) {
          var m = (0, GP.lineString)([a, (0, H2e.default)(a, d, h.first[I]).geometry.coordinates]);
          [0, 1, 2].forEach(function(C) {
            var y = (0, GP.lineString)([c, (0, H2e.default)(c, d, h.second[C]).geometry.coordinates]), v = (0, $Pn.default)(m, y);
            v && v.features.length && (o = v.features[0].geometry.coordinates);
          });
        });
      }
      return o;
    }
  }]), n;
}(jPn.GeoJsonEditMode);
cq.Draw90DegreePolygonMode = a3n;
var fq = {}, yVe = "Expected a function", j2e = 0 / 0, A3n = "[object Symbol]", l3n = /^\s+|\s+$/g, c3n = /^[-+]0x[0-9a-f]+$/i, u3n = /^0b[01]+$/i, f3n = /^0o[0-7]+$/i, g3n = parseInt, h3n = typeof ei == "object" && ei && ei.Object === Object && ei, d3n = typeof self == "object" && self && self.Object === Object && self, p3n = h3n || d3n || Function("return this")(), I3n = Object.prototype, m3n = I3n.toString, C3n = Math.max, E3n = Math.min, TJ = function() {
  return p3n.Date.now();
};
function y3n(t, e, n) {
  var r, i, o, s, a, A, l = 0, c = !1, u = !1, f = !0;
  if (typeof t != "function")
    throw new TypeError(yVe);
  e = Y2e(e) || 0, D8(n) && (c = !!n.leading, u = "maxWait" in n, o = u ? C3n(Y2e(n.maxWait) || 0, e) : o, f = "trailing" in n ? !!n.trailing : f);
  function h(w) {
    var R = r, M = i;
    return r = i = void 0, l = w, s = t.apply(M, R), s;
  }
  function d(w) {
    return l = w, a = setTimeout(C, e), c ? h(w) : s;
  }
  function I(w) {
    var R = w - A, M = w - l, O = e - R;
    return u ? E3n(O, o - M) : O;
  }
  function m(w) {
    var R = w - A, M = w - l;
    return A === void 0 || R >= e || R < 0 || u && M >= o;
  }
  function C() {
    var w = TJ();
    if (m(w))
      return y(w);
    a = setTimeout(C, I(w));
  }
  function y(w) {
    return a = void 0, f && r ? h(w) : (r = i = void 0, s);
  }
  function v() {
    a !== void 0 && clearTimeout(a), l = 0, r = A = i = a = void 0;
  }
  function b() {
    return a === void 0 ? s : y(TJ());
  }
  function Q() {
    var w = TJ(), R = m(w);
    if (r = arguments, i = this, A = w, R) {
      if (a === void 0)
        return d(A);
      if (u)
        return a = setTimeout(C, e), h(A);
    }
    return a === void 0 && (a = setTimeout(C, e)), s;
  }
  return Q.cancel = v, Q.flush = b, Q;
}
function v3n(t, e, n) {
  var r = !0, i = !0;
  if (typeof t != "function")
    throw new TypeError(yVe);
  return D8(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), y3n(t, e, {
    leading: r,
    maxWait: e,
    trailing: i
  });
}
function D8(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function B3n(t) {
  return !!t && typeof t == "object";
}
function b3n(t) {
  return typeof t == "symbol" || B3n(t) && m3n.call(t) == A3n;
}
function Y2e(t) {
  if (typeof t == "number")
    return t;
  if (b3n(t))
    return j2e;
  if (D8(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = D8(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(l3n, "");
  var n = u3n.test(t);
  return n || f3n.test(t) ? g3n(t.slice(2), n ? 2 : 8) : c3n.test(t) ? j2e : +t;
}
var _3n = v3n;
Object.defineProperty(fq, "__esModule", {
  value: !0
});
fq.DrawPolygonByDraggingMode = void 0;
var S3n = x3n(_3n), Q3n = ao, w3n = Vw;
function x3n(t) {
  return t && t.__esModule ? t : { default: t };
}
function xG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? xG = function(n) {
    return typeof n;
  } : xG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, xG(t);
}
function R3n(t) {
  return L3n(t) || N3n(t) || T3n(t) || D3n();
}
function D3n() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function T3n(t, e) {
  if (t) {
    if (typeof t == "string")
      return qne(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return qne(t, e);
  }
}
function N3n(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function L3n(t) {
  if (Array.isArray(t))
    return qne(t);
}
function qne(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function M3n(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function z2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function O3n(t, e, n) {
  return e && z2e(t.prototype, e), n && z2e(t, n), t;
}
function F3n(t) {
  return function() {
    var e = T8(t), n;
    if (k3n()) {
      var r = T8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return P3n(this, n);
  };
}
function P3n(t, e) {
  return e && (xG(e) === "object" || typeof e == "function") ? e : vVe(t);
}
function vVe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function k3n() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function T8(t) {
  return T8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, T8(t);
}
function G3n(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && jne(t, e);
}
function jne(t, e) {
  return jne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, jne(t, e);
}
function U3n(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var H3n = /* @__PURE__ */ function(t) {
  G3n(n, t);
  var e = F3n(n);
  function n() {
    var r;
    M3n(this, n);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)), U3n(vVe(r), "handleDraggingThrottled", null), r;
  }
  return O3n(n, [{
    key: "handleClick",
    value: function(i, o) {
    }
  }, {
    key: "handleStartDragging",
    value: function(i, o) {
      i.cancelPan(), o.modeConfig && o.modeConfig.throttleMs ? this.handleDraggingThrottled = (0, S3n.default)(this.handleDraggingAux, o.modeConfig.throttleMs) : this.handleDraggingThrottled = this.handleDraggingAux;
    }
  }, {
    key: "handleStopDragging",
    value: function(i, o) {
      this.addClickSequence(i);
      var s = this.getClickSequence();
      if (this.handleDraggingThrottled && this.handleDraggingThrottled.cancel && this.handleDraggingThrottled.cancel(), s.length > 2) {
        var a = {
          type: "Polygon",
          coordinates: [[].concat(R3n(s), [s[0]])]
        };
        this.resetClickSequence();
        var A = this.getAddFeatureOrBooleanPolygonAction(a, o);
        A && o.onEdit(A);
      }
    }
  }, {
    key: "handleDraggingAux",
    value: function(i, o) {
      var s = i.picks, a = (0, Q3n.getPickedEditHandle)(s);
      a || this.addClickSequence(i);
    }
  }, {
    key: "handleDragging",
    value: function(i, o) {
      this.handleDraggingThrottled && this.handleDraggingThrottled(i, o);
    }
  }]), n;
}(w3n.DrawPolygonMode);
fq.DrawPolygonByDraggingMode = H3n;
var gq = {};
Object.defineProperty(gq, "__esModule", {
  value: !0
});
gq.ViewMode = void 0;
var $3n = ts;
function RG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? RG = function(n) {
    return typeof n;
  } : RG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, RG(t);
}
function q3n(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function j3n(t) {
  return function() {
    var e = N8(t), n;
    if (V3n()) {
      var r = N8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return Y3n(this, n);
  };
}
function Y3n(t, e) {
  return e && (RG(e) === "object" || typeof e == "function") ? e : z3n(t);
}
function z3n(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function V3n() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function N8(t) {
  return N8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, N8(t);
}
function J3n(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Yne(t, e);
}
function Yne(t, e) {
  return Yne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Yne(t, e);
}
var K3n = /* @__PURE__ */ function(t) {
  J3n(n, t);
  var e = j3n(n);
  function n() {
    return q3n(this, n), e.apply(this, arguments);
  }
  return n;
}($3n.GeoJsonEditMode);
gq.ViewMode = K3n;
var hq = {};
Object.defineProperty(hq, "__esModule", {
  value: !0
});
hq.MeasureDistanceMode = void 0;
var W3n = ekn(hl), X3n = ao, Z3n = ts;
function ekn(t) {
  return t && t.__esModule ? t : { default: t };
}
function DG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? DG = function(n) {
    return typeof n;
  } : DG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, DG(t);
}
function NJ(t) {
  return ikn(t) || rkn(t) || nkn(t) || tkn();
}
function tkn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nkn(t, e) {
  if (t) {
    if (typeof t == "string")
      return zne(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return zne(t, e);
  }
}
function rkn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function ikn(t) {
  if (Array.isArray(t))
    return zne(t);
}
function zne(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function okn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function V2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function skn(t, e, n) {
  return e && V2e(t.prototype, e), n && V2e(t, n), t;
}
function akn(t) {
  return function() {
    var e = L8(t), n;
    if (lkn()) {
      var r = L8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return Akn(this, n);
  };
}
function Akn(t, e) {
  return e && (DG(e) === "object" || typeof e == "function") ? e : OR(t);
}
function OR(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function lkn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function L8(t) {
  return L8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, L8(t);
}
function ckn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Vne(t, e);
}
function Vne(t, e) {
  return Vne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Vne(t, e);
}
function UP(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var ukn = /* @__PURE__ */ function(t) {
  ckn(n, t);
  var e = akn(n);
  function n() {
    var r;
    okn(this, n);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)), UP(OR(r), "_isMeasuringSessionFinished", !1), UP(OR(r), "_currentTooltips", []), UP(OR(r), "_currentDistance", 0), UP(OR(r), "_calculateDistanceForTooltip", function(a) {
      var A = a.positionA, l = a.positionB, c = a.modeConfig, u = c || {}, f = u.turfOptions, h = u.measurementCallback, d = (0, W3n.default)(A, l, f);
      return h && h(d), d;
    }), r;
  }
  return skn(n, [{
    key: "_formatTooltip",
    value: function(i, o) {
      var s = o || {}, a = s.formatTooltip, A = s.turfOptions, l = A && A.units || "kilometers", c;
      return a ? c = a(i) : c = "".concat(parseFloat(i).toFixed(2), " ").concat(l), c;
    }
  }, {
    key: "handleClick",
    value: function(i, o) {
      var s = o.modeConfig, a = o.data, A = o.onEdit;
      this._isMeasuringSessionFinished && (this._isMeasuringSessionFinished = !1, this.resetClickSequence(), this._currentTooltips = [], this._currentDistance = 0);
      var l = i.picks, c = (0, X3n.getPickedEditHandle)(l), u = !1;
      c || (this.addClickSequence(i), u = !0);
      var f = this.getClickSequence();
      f.length > 1 && c && Array.isArray(c.properties.positionIndexes) && c.properties.positionIndexes[0] === f.length - 1 ? this._isMeasuringSessionFinished = !0 : u && (f.length > 1 && (this._currentDistance += this._calculateDistanceForTooltip({
        positionA: f[f.length - 2],
        positionB: f[f.length - 1],
        modeConfig: s
      }), this._currentTooltips.push({
        position: i.mapCoords,
        text: this._formatTooltip(this._currentDistance, s)
      })), A({
        // data is the same
        updatedData: a,
        editType: "addTentativePosition",
        editContext: {
          position: i.mapCoords
        }
      }));
    }
  }, {
    key: "handleKeyUp",
    value: function(i, o) {
      if (!this._isMeasuringSessionFinished) {
        i.stopPropagation();
        var s = i.key, a = this.getClickSequence().length;
        switch (s) {
          case "Escape":
            this._isMeasuringSessionFinished = !0, a === 1 && (this.resetClickSequence(), this._currentTooltips = []), o.onUpdateCursor("cell");
            break;
          case "Enter":
            this.handleClick(o.lastPointerMoveEvent, o), this._isMeasuringSessionFinished = !0;
            break;
        }
      }
    }
  }, {
    key: "getGuides",
    value: function(i) {
      var o, s = i.lastPointerMoveEvent, a = this.getClickSequence(), A = s && !this._isMeasuringSessionFinished ? [s.mapCoords] : [], l = {
        type: "FeatureCollection",
        features: []
      };
      a.length > 0 && l.features.push({
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [].concat(NJ(a), A)
        }
      });
      var c = a.map(function(u, f) {
        return {
          type: "Feature",
          properties: {
            guideType: "editHandle",
            editHandleType: "existing",
            featureIndex: -1,
            positionIndexes: [f]
          },
          geometry: {
            type: "Point",
            coordinates: u
          }
        };
      });
      return (o = l.features).push.apply(o, NJ(c)), l;
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      o.onUpdateCursor("cell");
    }
  }, {
    key: "getTooltips",
    value: function(i) {
      var o = i.lastPointerMoveEvent, s = i.modeConfig, a = this.getClickSequence();
      if (a.length > 0 && o && !this._isMeasuringSessionFinished) {
        var A = this._calculateDistanceForTooltip({
          positionA: a[a.length - 1],
          positionB: o.mapCoords,
          modeConfig: i.modeConfig
        });
        return [].concat(NJ(this._currentTooltips), [{
          position: o.mapCoords,
          text: this._formatTooltip(this._currentDistance + A, s)
        }]);
      }
      return this._currentTooltips;
    }
  }]), n;
}(Z3n.GeoJsonEditMode);
hq.MeasureDistanceMode = ukn;
var dq = {}, Fue = {};
Object.defineProperty(Fue, "__esModule", { value: !0 });
var fkn = Do, J2e = 6378137;
function gkn(t) {
  return fkn.geomReduce(t, function(e, n) {
    return e + hkn(n);
  }, 0);
}
Fue.default = gkn;
function hkn(t) {
  var e = 0, n;
  switch (t.type) {
    case "Polygon":
      return K2e(t.coordinates);
    case "MultiPolygon":
      for (n = 0; n < t.coordinates.length; n++)
        e += K2e(t.coordinates[n]);
      return e;
    case "Point":
    case "MultiPoint":
    case "LineString":
    case "MultiLineString":
      return 0;
  }
  return 0;
}
function K2e(t) {
  var e = 0;
  if (t && t.length > 0) {
    e += Math.abs(W2e(t[0]));
    for (var n = 1; n < t.length; n++)
      e -= Math.abs(W2e(t[n]));
  }
  return e;
}
function W2e(t) {
  var e, n, r, i, o, s, a, A = 0, l = t.length;
  if (l > 2) {
    for (a = 0; a < l; a++)
      a === l - 2 ? (i = l - 2, o = l - 1, s = 0) : a === l - 1 ? (i = l - 1, o = 0, s = 1) : (i = a, o = a + 1, s = a + 2), e = t[i], n = t[o], r = t[s], A += (LJ(r[0]) - LJ(e[0])) * Math.sin(LJ(n[1]));
    A = A * J2e * J2e / 2;
  }
  return A;
}
function LJ(t) {
  return t * Math.PI / 180;
}
Object.defineProperty(dq, "__esModule", {
  value: !0
});
dq.MeasureAreaMode = void 0;
var dkn = BVe(Fue), pkn = BVe(a1), Ikn = Vw;
function BVe(t) {
  return t && t.__esModule ? t : { default: t };
}
function TG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? TG = function(n) {
    return typeof n;
  } : TG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, TG(t);
}
function X2e(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function mkn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? X2e(Object(n), !0).forEach(function(r) {
      Ckn(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : X2e(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Ckn(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Ekn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Z2e(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function ykn(t, e, n) {
  return e && Z2e(t.prototype, e), n && Z2e(t, n), t;
}
function NG(t, e, n) {
  return typeof Reflect < "u" && Reflect.get ? NG = Reflect.get : NG = function(i, o, s) {
    var a = vkn(i, o);
    if (a) {
      var A = Object.getOwnPropertyDescriptor(a, o);
      return A.get ? A.get.call(s) : A.value;
    }
  }, NG(t, e, n || t);
}
function vkn(t, e) {
  for (; !Object.prototype.hasOwnProperty.call(t, e) && (t = iQ(t), t !== null); )
    ;
  return t;
}
function Bkn(t) {
  return function() {
    var e = iQ(t), n;
    if (Skn()) {
      var r = iQ(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return bkn(this, n);
  };
}
function bkn(t, e) {
  return e && (TG(e) === "object" || typeof e == "function") ? e : _kn(t);
}
function _kn(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Skn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function iQ(t) {
  return iQ = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, iQ(t);
}
function Qkn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Jne(t, e);
}
function Jne(t, e) {
  return Jne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Jne(t, e);
}
var wkn = [], xkn = /* @__PURE__ */ function(t) {
  Qkn(n, t);
  var e = Bkn(n);
  function n() {
    return Ekn(this, n), e.apply(this, arguments);
  }
  return ykn(n, [{
    key: "handleClick",
    value: function(i, o) {
      var s = mkn({}, o, {
        // @ts-ignore
        onEdit: function() {
        }
      });
      NG(iQ(n.prototype), "handleClick", this).call(this, i, s);
    }
  }, {
    key: "getTooltips",
    value: function(i) {
      var o = this.getTentativeGuide(i);
      if (o && o.geometry.type === "Polygon") {
        var s = i.modeConfig, a = s || {}, A = a.formatTooltip, l = a.measurementCallback, c = "sq. m", u = (0, pkn.default)(o), f = (0, dkn.default)(o), h;
        return A ? h = A(f) : h = "".concat(parseFloat(f).toFixed(2), " ").concat(c), l && l(f), [{
          position: u.geometry.coordinates,
          text: h
        }];
      }
      return wkn;
    }
  }]), n;
}(Ikn.DrawPolygonMode);
dq.MeasureAreaMode = xkn;
var pq = {}, Pue = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function e(r, i) {
    if (r === i)
      return !0;
    if (Array.isArray(r)) {
      var o = r.length;
      if (!i || i.length !== o)
        return !1;
      for (var s = 0; s < o; s++)
        if (r[s] !== i[s])
          return !1;
      return !0;
    }
    return !1;
  }
  function n(r) {
    var i = {}, o;
    return function(s) {
      for (var a in s)
        if (!e(s[a], i[a])) {
          o = r(s), i = s;
          break;
        }
      return o;
    };
  }
})(Pue);
Object.defineProperty(pq, "__esModule", {
  value: !0
});
pq.MeasureAngleMode = void 0;
var eRe = kue(zf), Rkn = kue(Uw), Dkn = kue(Pue), Tkn = ts;
function kue(t) {
  return t && t.__esModule ? t : { default: t };
}
function LG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? LG = function(n) {
    return typeof n;
  } : LG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, LG(t);
}
function Nkn(t) {
  return Fkn(t) || Okn(t) || Mkn(t) || Lkn();
}
function Lkn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mkn(t, e) {
  if (t) {
    if (typeof t == "string")
      return Kne(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Kne(t, e);
  }
}
function Okn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function Fkn(t) {
  if (Array.isArray(t))
    return Kne(t);
}
function Kne(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function Pkn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function tRe(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function kkn(t, e, n) {
  return e && tRe(t.prototype, e), n && tRe(t, n), t;
}
function Gkn(t) {
  return function() {
    var e = M8(t), n;
    if (Hkn()) {
      var r = M8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return Ukn(this, n);
  };
}
function Ukn(t, e) {
  return e && (LG(e) === "object" || typeof e == "function") ? e : bVe(t);
}
function bVe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Hkn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function M8(t) {
  return M8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, M8(t);
}
function $kn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Wne(t, e);
}
function Wne(t, e) {
  return Wne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Wne(t, e);
}
function qkn(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var jkn = [], Ykn = /* @__PURE__ */ function(t) {
  $kn(n, t);
  var e = Gkn(n);
  function n() {
    var r;
    Pkn(this, n);
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)), qkn(bVe(r), "_getTooltips", (0, Dkn.default)(function(a) {
      var A = a.modeConfig, l = a.vertex, c = a.point1, u = a.point2, f = jkn;
      if (l && c && u) {
        var h = A || {}, d = h.formatTooltip, I = h.measurementCallback, m = "deg", C = (0, eRe.default)(l, c), y = (0, eRe.default)(l, u), v = Math.abs(C - y);
        v > 180 && (v = 360 - v);
        var b;
        d ? b = d(v) : b = "".concat(parseFloat(v).toFixed(2), " ").concat(m), I && I(v);
        var Q = (0, Rkn.default)({
          type: "FeatureCollection",
          features: [c, u].map(function(w) {
            return {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: w
              }
            };
          })
        }).geometry.coordinates;
        f = [{
          position: Q,
          text: b
        }];
      }
      return f;
    })), r;
  }
  return kkn(n, [{
    key: "handleClick",
    value: function(i, o) {
      this.getClickSequence().length >= 3 && this.resetClickSequence(), this.addClickSequence(i);
    }
    // Called when the pointer moved, regardless of whether the pointer is down, up, and whether something was picked
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      o.onUpdateCursor("cell");
    }
  }, {
    key: "getPoints",
    value: function(i) {
      var o = this.getClickSequence(), s = Nkn(o);
      return o.length < 3 && i.lastPointerMoveEvent && s.push(i.lastPointerMoveEvent.mapCoords), s;
    }
    // Return features that can be used as a guide for editing the data
  }, {
    key: "getGuides",
    value: function(i) {
      var o = {
        type: "FeatureCollection",
        features: []
      }, s = o.features, a = this.getPoints(i);
      return a.length > 2 ? s.push({
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [a[1], a[0], a[2]]
        }
      }) : a.length > 1 && s.push({
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [a[1], a[0]]
        }
      }), o;
    }
  }, {
    key: "getTooltips",
    value: function(i) {
      var o = this.getPoints(i);
      return this._getTooltips({
        modeConfig: i.modeConfig,
        vertex: o[0],
        point1: o[1],
        point2: o[2]
      });
    }
  }]), n;
}(Tkn.GeoJsonEditMode);
pq.MeasureAngleMode = Ykn;
var Iq = {};
Object.defineProperty(Iq, "__esModule", {
  value: !0
});
Iq.SnappableMode = void 0;
var HP = ao, zkn = ts;
function MG(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? MG = function(n) {
    return typeof n;
  } : MG = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, MG(t);
}
function Vkn(t) {
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (t = _Ve(t))) {
      var e = 0, n = function() {
      };
      return { s: n, n: function() {
        return e >= t.length ? { done: !0 } : { done: !1, value: t[e++] };
      }, e: function(A) {
        throw A;
      }, f: n };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var r, i = !0, o = !1, s;
  return { s: function() {
    r = t[Symbol.iterator]();
  }, n: function() {
    var A = r.next();
    return i = A.done, A;
  }, e: function(A) {
    o = !0, s = A;
  }, f: function() {
    try {
      !i && r.return != null && r.return();
    } finally {
      if (o)
        throw s;
    }
  } };
}
function Eb(t) {
  return Wkn(t) || Kkn(t) || _Ve(t) || Jkn();
}
function Jkn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _Ve(t, e) {
  if (t) {
    if (typeof t == "string")
      return Xne(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Xne(t, e);
  }
}
function Kkn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function Wkn(t) {
  if (Array.isArray(t))
    return Xne(t);
}
function Xne(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function nRe(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Xkn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? nRe(Object(n), !0).forEach(function(r) {
      QVe(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : nRe(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Zkn(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function rRe(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function eGn(t, e, n) {
  return e && rRe(t.prototype, e), n && rRe(t, n), t;
}
function tGn(t) {
  return function() {
    var e = O8(t), n;
    if (rGn()) {
      var r = O8(this).constructor;
      n = Reflect.construct(e, arguments, r);
    } else
      n = e.apply(this, arguments);
    return nGn(this, n);
  };
}
function nGn(t, e) {
  return e && (MG(e) === "object" || typeof e == "function") ? e : SVe(t);
}
function SVe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function rGn() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function O8(t) {
  return O8 = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, O8(t);
}
function iGn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Zne(t, e);
}
function Zne(t, e) {
  return Zne = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, Zne(t, e);
}
function QVe(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var oGn = /* @__PURE__ */ function(t) {
  iGn(n, t);
  var e = tGn(n);
  function n(r) {
    var i;
    return Zkn(this, n), i = e.call(this), QVe(SVe(i), "_handler", void 0), i._handler = r, i;
  }
  return eGn(n, [{
    key: "_getSnappedMouseEvent",
    value: function(i, o, s) {
      return Object.assign(i, {
        mapCoords: s.geometry.coordinates,
        pointerDownMapCoords: o && o.geometry.coordinates
      });
    }
  }, {
    key: "_getPickedSnapTarget",
    value: function(i) {
      return (0, HP.getPickedEditHandles)(i).find(function(o) {
        return o.properties.editHandleType === "snap-target";
      });
    }
  }, {
    key: "_getPickedSnapSource",
    value: function(i) {
      return (0, HP.getPickedSnapSourceEditHandle)(i);
    }
  }, {
    key: "_getUpdatedSnapSourceHandle",
    value: function(i, o) {
      var s = i.properties, a = s.featureIndex, A = s.positionIndexes;
      if (!Array.isArray(A))
        return i;
      var l = o.features[a], c = A.reduce(function(u, f) {
        return u[f];
      }, l.geometry.coordinates);
      return Xkn({}, i, {
        geometry: {
          type: "Point",
          coordinates: c
        }
      });
    }
    // If additionalSnapTargets is present in modeConfig and is populated, this
    // method will return those features along with the features
    // that live in the current layer. Otherwise, this method will simply return the
    // features from the current layer
  }, {
    key: "_getSnapTargets",
    value: function(i) {
      var o = i.modeConfig || {}, s = o.additionalSnapTargets;
      s = s || [];
      var a = [].concat(Eb(i.data.features), Eb(s));
      return a;
    }
  }, {
    key: "_getSnapTargetHandles",
    value: function(i) {
      for (var o = [], s = this._getSnapTargets(i), a = 0; a < s.length; a++) {
        var A = !i.selectedIndexes.includes(a);
        if (A) {
          var l = s[a].geometry;
          o.push.apply(o, Eb((0, HP.getEditHandlesForGeometry)(l, a, "snap-target")));
        }
      }
      return o;
    }
    // If no snap handle has been picked, only display the edit handles of the
    // selected feature. If a snap handle has been picked, display said snap handle
    // along with all snappable points on all non-selected features.
  }, {
    key: "getGuides",
    value: function(i) {
      var o = i.modeConfig, s = i.lastPointerMoveEvent, a = o || {}, A = a.enableSnapping, l = {
        type: "FeatureCollection",
        features: Eb(this._handler.getGuides(i).features)
      };
      if (!A)
        return l;
      var c = s && this._getPickedSnapSource(s.pointerDownPicks);
      if (c) {
        var u;
        return (u = l.features).push.apply(u, Eb(this._getSnapTargetHandles(i)).concat([this._getUpdatedSnapSourceHandle(c, i.data)])), l;
      }
      var f = i.data.features, h = Vkn(i.selectedIndexes), d;
      try {
        for (h.s(); !(d = h.n()).done; ) {
          var I = d.value;
          if (I < f.length) {
            var m, C = f[I].geometry;
            (m = l.features).push.apply(m, Eb((0, HP.getEditHandlesForGeometry)(C, I, "snap-source")));
          }
        }
      } catch (y) {
        h.e(y);
      } finally {
        h.f();
      }
      return l;
    }
  }, {
    key: "_getSnapAwareEvent",
    value: function(i, o) {
      var s = this._getPickedSnapSource(o.lastPointerMoveEvent.pointerDownPicks), a = this._getPickedSnapTarget(i.picks);
      return s && a ? this._getSnappedMouseEvent(i, s, a) : i;
    }
  }, {
    key: "handleStartDragging",
    value: function(i, o) {
      this._handler.handleStartDragging(i, o);
    }
  }, {
    key: "handleStopDragging",
    value: function(i, o) {
      this._handler.handleStopDragging(this._getSnapAwareEvent(i, o), o);
    }
  }, {
    key: "handleDragging",
    value: function(i, o) {
      this._handler.handleDragging(this._getSnapAwareEvent(i, o), o);
    }
  }, {
    key: "handlePointerMove",
    value: function(i, o) {
      this._handler.handlePointerMove(this._getSnapAwareEvent(i, o), o);
    }
  }]), n;
}(zkn.GeoJsonEditMode);
Iq.SnappableMode = oGn;
(function(t) {
  function e(ee) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(Ce) {
      return typeof Ce;
    } : e = function(Ce) {
      return Ce && typeof Symbol == "function" && Ce.constructor === Symbol && Ce !== Symbol.prototype ? "symbol" : typeof Ce;
    }, e(ee);
  }
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "GeoJsonEditMode", {
    enumerable: !0,
    get: function() {
      return n.GeoJsonEditMode;
    }
  }), Object.defineProperty(t, "ModifyMode", {
    enumerable: !0,
    get: function() {
      return r.ModifyMode;
    }
  }), Object.defineProperty(t, "ResizeCircleMode", {
    enumerable: !0,
    get: function() {
      return i.ResizeCircleMode;
    }
  }), Object.defineProperty(t, "TranslateMode", {
    enumerable: !0,
    get: function() {
      return o.TranslateMode;
    }
  }), Object.defineProperty(t, "ScaleMode", {
    enumerable: !0,
    get: function() {
      return s.ScaleMode;
    }
  }), Object.defineProperty(t, "RotateMode", {
    enumerable: !0,
    get: function() {
      return a.RotateMode;
    }
  }), Object.defineProperty(t, "DuplicateMode", {
    enumerable: !0,
    get: function() {
      return A.DuplicateMode;
    }
  }), Object.defineProperty(t, "ExtendLineStringMode", {
    enumerable: !0,
    get: function() {
      return l.ExtendLineStringMode;
    }
  }), Object.defineProperty(t, "SplitPolygonMode", {
    enumerable: !0,
    get: function() {
      return c.SplitPolygonMode;
    }
  }), Object.defineProperty(t, "ExtrudeMode", {
    enumerable: !0,
    get: function() {
      return u.ExtrudeMode;
    }
  }), Object.defineProperty(t, "ElevationMode", {
    enumerable: !0,
    get: function() {
      return f.ElevationMode;
    }
  }), Object.defineProperty(t, "TransformMode", {
    enumerable: !0,
    get: function() {
      return h.TransformMode;
    }
  }), Object.defineProperty(t, "DrawPointMode", {
    enumerable: !0,
    get: function() {
      return d.DrawPointMode;
    }
  }), Object.defineProperty(t, "DrawLineStringMode", {
    enumerable: !0,
    get: function() {
      return I.DrawLineStringMode;
    }
  }), Object.defineProperty(t, "DrawPolygonMode", {
    enumerable: !0,
    get: function() {
      return m.DrawPolygonMode;
    }
  }), Object.defineProperty(t, "DrawRectangleMode", {
    enumerable: !0,
    get: function() {
      return C.DrawRectangleMode;
    }
  }), Object.defineProperty(t, "DrawSquareFromCenterMode", {
    enumerable: !0,
    get: function() {
      return y.DrawSquareFromCenterMode;
    }
  }), Object.defineProperty(t, "DrawCircleByDiameterMode", {
    enumerable: !0,
    get: function() {
      return v.DrawCircleByDiameterMode;
    }
  }), Object.defineProperty(t, "DrawCircleFromCenterMode", {
    enumerable: !0,
    get: function() {
      return b.DrawCircleFromCenterMode;
    }
  }), Object.defineProperty(t, "DrawEllipseByBoundingBoxMode", {
    enumerable: !0,
    get: function() {
      return Q.DrawEllipseByBoundingBoxMode;
    }
  }), Object.defineProperty(t, "DrawEllipseUsingThreePointsMode", {
    enumerable: !0,
    get: function() {
      return w.DrawEllipseUsingThreePointsMode;
    }
  }), Object.defineProperty(t, "DrawRectangleUsingThreePointsMode", {
    enumerable: !0,
    get: function() {
      return R.DrawRectangleUsingThreePointsMode;
    }
  }), Object.defineProperty(t, "Draw90DegreePolygonMode", {
    enumerable: !0,
    get: function() {
      return M.Draw90DegreePolygonMode;
    }
  }), Object.defineProperty(t, "DrawPolygonByDraggingMode", {
    enumerable: !0,
    get: function() {
      return O.DrawPolygonByDraggingMode;
    }
  }), Object.defineProperty(t, "ImmutableFeatureCollection", {
    enumerable: !0,
    get: function() {
      return L.ImmutableFeatureCollection;
    }
  }), Object.defineProperty(t, "ViewMode", {
    enumerable: !0,
    get: function() {
      return N.ViewMode;
    }
  }), Object.defineProperty(t, "MeasureDistanceMode", {
    enumerable: !0,
    get: function() {
      return k.MeasureDistanceMode;
    }
  }), Object.defineProperty(t, "MeasureAreaMode", {
    enumerable: !0,
    get: function() {
      return $.MeasureAreaMode;
    }
  }), Object.defineProperty(t, "MeasureAngleMode", {
    enumerable: !0,
    get: function() {
      return U.MeasureAngleMode;
    }
  }), Object.defineProperty(t, "CompositeMode", {
    enumerable: !0,
    get: function() {
      return X.CompositeMode;
    }
  }), Object.defineProperty(t, "SnappableMode", {
    enumerable: !0,
    get: function() {
      return K.SnappableMode;
    }
  }), Object.defineProperty(t, "_memoize", {
    enumerable: !0,
    get: function() {
      return z.default;
    }
  }), t.utils = void 0;
  var n = ts, r = jw, i = $$, o = Yw, s = LM, a = MM, A = V$, l = J$, c = K$, u = X$, f = Z$, h = eq, d = tq, I = nq, m = Vw, C = rq, y = iq, v = oq, b = sq, Q = aq, w = Aq, R = lq, M = cq, O = fq, L = Vf, N = gq, k = hq, $ = dq, U = pq, X = FM, K = Iq, z = ce(Pue), Y = Z(ao);
  t.utils = Y;
  function V() {
    if (typeof WeakMap != "function")
      return null;
    var ee = /* @__PURE__ */ new WeakMap();
    return V = function() {
      return ee;
    }, ee;
  }
  function Z(ee) {
    if (ee && ee.__esModule)
      return ee;
    if (ee === null || e(ee) !== "object" && typeof ee != "function")
      return { default: ee };
    var pe = V();
    if (pe && pe.has(ee))
      return pe.get(ee);
    var Ce = {}, Be = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var Ie in ee)
      if (Object.prototype.hasOwnProperty.call(ee, Ie)) {
        var Qe = Be ? Object.getOwnPropertyDescriptor(ee, Ie) : null;
        Qe && (Qe.get || Qe.set) ? Object.defineProperty(Ce, Ie, Qe) : Ce[Ie] = ee[Ie];
      }
    return Ce.default = ee, pe && pe.set(ee, Ce), Ce;
  }
  function ce(ee) {
    return ee && ee.__esModule ? ee : { default: ee };
  }
})(s1);
var Gue = {};
const Jw = /* @__PURE__ */ Fs(Lpn);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = Jw;
  function n(Q) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(R) {
      return typeof R;
    } : n = function(R) {
      return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
    }, n(Q);
  }
  function r(Q, w) {
    var R = Object.keys(Q);
    if (Object.getOwnPropertySymbols) {
      var M = Object.getOwnPropertySymbols(Q);
      w && (M = M.filter(function(O) {
        return Object.getOwnPropertyDescriptor(Q, O).enumerable;
      })), R.push.apply(R, M);
    }
    return R;
  }
  function i(Q) {
    for (var w = 1; w < arguments.length; w++) {
      var R = arguments[w] != null ? arguments[w] : {};
      w % 2 ? r(Object(R), !0).forEach(function(M) {
        y(Q, M, R[M]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Q, Object.getOwnPropertyDescriptors(R)) : r(Object(R)).forEach(function(M) {
        Object.defineProperty(Q, M, Object.getOwnPropertyDescriptor(R, M));
      });
    }
    return Q;
  }
  function o(Q) {
    if (typeof Symbol > "u" || Q[Symbol.iterator] == null) {
      if (Array.isArray(Q) || (Q = s(Q))) {
        var w = 0, R = function() {
        };
        return { s: R, n: function() {
          return w >= Q.length ? { done: !0 } : { done: !1, value: Q[w++] };
        }, e: function($) {
          throw $;
        }, f: R };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var M, O = !0, L = !1, N;
    return { s: function() {
      M = Q[Symbol.iterator]();
    }, n: function() {
      var $ = M.next();
      return O = $.done, $;
    }, e: function($) {
      L = !0, N = $;
    }, f: function() {
      try {
        !O && M.return != null && M.return();
      } finally {
        if (L)
          throw N;
      }
    } };
  }
  function s(Q, w) {
    if (Q) {
      if (typeof Q == "string")
        return a(Q, w);
      var R = Object.prototype.toString.call(Q).slice(8, -1);
      if (R === "Object" && Q.constructor && (R = Q.constructor.name), R === "Map" || R === "Set")
        return Array.from(R);
      if (R === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(R))
        return a(Q, w);
    }
  }
  function a(Q, w) {
    (w == null || w > Q.length) && (w = Q.length);
    for (var R = 0, M = new Array(w); R < w; R++)
      M[R] = Q[R];
    return M;
  }
  function A(Q, w) {
    if (!(Q instanceof w))
      throw new TypeError("Cannot call a class as a function");
  }
  function l(Q, w) {
    for (var R = 0; R < w.length; R++) {
      var M = w[R];
      M.enumerable = M.enumerable || !1, M.configurable = !0, "value" in M && (M.writable = !0), Object.defineProperty(Q, M.key, M);
    }
  }
  function c(Q, w, R) {
    return w && l(Q.prototype, w), R && l(Q, R), Q;
  }
  function u(Q) {
    return function() {
      var w = I(Q), R;
      if (d()) {
        var M = I(this).constructor;
        R = Reflect.construct(w, arguments, M);
      } else
        R = w.apply(this, arguments);
      return f(this, R);
    };
  }
  function f(Q, w) {
    return w && (n(w) === "object" || typeof w == "function") ? w : h(Q);
  }
  function h(Q) {
    if (Q === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return Q;
  }
  function d() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function I(Q) {
    return I = Object.setPrototypeOf ? Object.getPrototypeOf : function(R) {
      return R.__proto__ || Object.getPrototypeOf(R);
    }, I(Q);
  }
  function m(Q, w) {
    if (typeof w != "function" && w !== null)
      throw new TypeError("Super expression must either be null or a function");
    Q.prototype = Object.create(w && w.prototype, { constructor: { value: Q, writable: !0, configurable: !0 } }), w && C(Q, w);
  }
  function C(Q, w) {
    return C = Object.setPrototypeOf || function(M, O) {
      return M.__proto__ = O, M;
    }, C(Q, w);
  }
  function y(Q, w, R) {
    return w in Q ? Object.defineProperty(Q, w, { value: R, enumerable: !0, configurable: !0, writable: !0 }) : Q[w] = R, Q;
  }
  var v = ["anyclick", "pointermove", "panstart", "panmove", "panend", "keyup"], b = /* @__PURE__ */ function(Q) {
    m(R, Q);
    var w = u(R);
    function R() {
      return A(this, R), w.apply(this, arguments);
    }
    return c(R, [{
      key: "onLayerClick",
      // Overridable interaction event handlers
      value: function(O) {
      }
    }, {
      key: "onStartDragging",
      value: function(O) {
      }
    }, {
      key: "onStopDragging",
      value: function(O) {
      }
    }, {
      key: "onDragging",
      value: function(O) {
      }
    }, {
      key: "onPointerMove",
      value: function(O) {
      }
    }, {
      key: "onLayerKeyUp",
      value: function(O) {
      }
      // default implementation - do nothing;
      // TODO: implement onCancelDragging (e.g. drag off screen)
    }, {
      key: "initializeState",
      value: function() {
        this.setState({
          _editableLayerState: {
            // Picked objects at the time the pointer went down
            pointerDownPicks: null,
            // Screen coordinates where the pointer went down
            pointerDownScreenCoords: null,
            // Ground coordinates where the pointer went down
            pointerDownMapCoords: null,
            // Keep track of the mjolnir.js event handler so it can be deregistered
            eventHandler: this._forwardEventToCurrentLayer.bind(this)
          }
        }), this._addEventHandlers();
      }
    }, {
      key: "finalizeState",
      value: function() {
        this._removeEventHandlers();
      }
    }, {
      key: "_addEventHandlers",
      value: function() {
        var O = this.context.deck.eventManager, L = this.state._editableLayerState.eventHandler, N = o(v), k;
        try {
          for (N.s(); !(k = N.n()).done; ) {
            var $ = k.value;
            O.on($, L, {
              // give nebula a higher priority so that it can stop propagation to deck.gl's map panning handlers
              priority: 100
            });
          }
        } catch (U) {
          N.e(U);
        } finally {
          N.f();
        }
      }
    }, {
      key: "_removeEventHandlers",
      value: function() {
        var O = this.context.deck.eventManager, L = this.state._editableLayerState.eventHandler, N = o(v), k;
        try {
          for (N.s(); !(k = N.n()).done; ) {
            var $ = k.value;
            O.off($, L);
          }
        } catch (U) {
          N.e(U);
        } finally {
          N.f();
        }
      }
      // A new layer instance is created on every render, so forward the event to the current layer
      // This means that the first layer instance will stick around to be the event listener, but will forward the event
      // to the latest layer instance.
    }, {
      key: "_forwardEventToCurrentLayer",
      value: function(O) {
        var L = this.getCurrentLayer(), N = L["_on".concat(O.type)].bind(L);
        if (!N) {
          console.warn("no handler for mjolnir.js event ".concat(O.type));
          return;
        }
        N(O);
      }
    }, {
      key: "_onanyclick",
      value: function(O) {
        var L = O.srcEvent, N = this.getScreenCoords(L), k = this.getMapCoords(N), $ = this.getPicks(N);
        this.onLayerClick({
          mapCoords: k,
          // @ts-ignore
          screenCoords: N,
          picks: $,
          sourceEvent: L
        });
      }
    }, {
      key: "_onkeyup",
      value: function(O) {
        var L = O.srcEvent;
        this.onLayerKeyUp(L);
      }
    }, {
      key: "_onpanstart",
      value: function(O) {
        var L = this.getScreenCoords(O.srcEvent), N = this.getMapCoords(L), k = this.getPicks(L);
        this.setState({
          _editableLayerState: i({}, this.state._editableLayerState, {
            pointerDownScreenCoords: L,
            pointerDownMapCoords: N,
            pointerDownPicks: k
          })
        }), this.onStartDragging({
          picks: k,
          // @ts-ignore
          screenCoords: L,
          // @ts-ignore
          mapCoords: N,
          // @ts-ignore
          pointerDownScreenCoords: L,
          pointerDownMapCoords: N,
          cancelPan: O.stopImmediatePropagation,
          sourceEvent: O.srcEvent
        });
      }
    }, {
      key: "_onpanmove",
      value: function(O) {
        var L = O.srcEvent, N = this.getScreenCoords(L), k = this.getMapCoords(N), $ = this.state._editableLayerState, U = $.pointerDownPicks, X = $.pointerDownScreenCoords, K = $.pointerDownMapCoords, z = this.getPicks(N);
        this.onDragging({
          // @ts-ignore
          screenCoords: N,
          mapCoords: k,
          picks: z,
          pointerDownPicks: U,
          pointerDownScreenCoords: X,
          pointerDownMapCoords: K,
          sourceEvent: L,
          cancelPan: O.stopImmediatePropagation
          // another (hacky) approach for cancelling map panning
          // const controller = this.context.deck.viewManager.controllers[
          //   Object.keys(this.context.deck.viewManager.controllers)[0]
          // ];
          // controller._state.isDragging = false;
        });
      }
    }, {
      key: "_onpanend",
      value: function(O) {
        var L = O.srcEvent, N = this.getScreenCoords(L), k = this.getMapCoords(N), $ = this.state._editableLayerState, U = $.pointerDownPicks, X = $.pointerDownScreenCoords, K = $.pointerDownMapCoords, z = this.getPicks(N);
        this.onStopDragging({
          picks: z,
          // @ts-ignore
          screenCoords: N,
          mapCoords: k,
          pointerDownPicks: U,
          pointerDownScreenCoords: X,
          pointerDownMapCoords: K,
          sourceEvent: L
        }), this.setState({
          _editableLayerState: i({}, this.state._editableLayerState, {
            pointerDownScreenCoords: null,
            pointerDownMapCoords: null,
            pointerDownPicks: null
          })
        });
      }
    }, {
      key: "_onpointermove",
      value: function(O) {
        var L = O.srcEvent, N = this.getScreenCoords(L), k = this.getMapCoords(N), $ = this.state._editableLayerState, U = $.pointerDownPicks, X = $.pointerDownScreenCoords, K = $.pointerDownMapCoords, z = this.getPicks(N);
        this.onPointerMove({
          // @ts-ignore
          screenCoords: N,
          mapCoords: k,
          picks: z,
          pointerDownPicks: U,
          pointerDownScreenCoords: X,
          pointerDownMapCoords: K,
          sourceEvent: L
        });
      }
    }, {
      key: "getPicks",
      value: function(O) {
        return this.context.deck.pickMultipleObjects({
          x: O[0],
          y: O[1],
          layerIds: [this.props.id],
          radius: this.props.pickingRadius,
          depth: this.props.pickingDepth
        });
      }
    }, {
      key: "getScreenCoords",
      value: function(O) {
        return [O.clientX - this.context.gl.canvas.getBoundingClientRect().left, O.clientY - this.context.gl.canvas.getBoundingClientRect().top];
      }
    }, {
      key: "getMapCoords",
      value: function(O) {
        return this.context.viewport.unproject([O[0], O[1]]);
      }
    }]), R;
  }(e.CompositeLayer);
  t.default = b, y(b, "layerName", "EditableLayer");
})(Gue);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = wE, n = s1, r = i(Gue);
  function i(Be) {
    return Be && Be.__esModule ? Be : { default: Be };
  }
  function o(Be) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? o = function(Qe) {
      return typeof Qe;
    } : o = function(Qe) {
      return Qe && typeof Symbol == "function" && Qe.constructor === Symbol && Qe !== Symbol.prototype ? "symbol" : typeof Qe;
    }, o(Be);
  }
  function s(Be, Ie) {
    if (!(Be instanceof Ie))
      throw new TypeError("Cannot call a class as a function");
  }
  function a(Be, Ie) {
    for (var Qe = 0; Qe < Ie.length; Qe++) {
      var xe = Ie[Qe];
      xe.enumerable = xe.enumerable || !1, xe.configurable = !0, "value" in xe && (xe.writable = !0), Object.defineProperty(Be, xe.key, xe);
    }
  }
  function A(Be, Ie, Qe) {
    return Ie && a(Be.prototype, Ie), Qe && a(Be, Qe), Be;
  }
  function l(Be, Ie, Qe) {
    return typeof Reflect < "u" && Reflect.get ? l = Reflect.get : l = function(Se, De, Ue) {
      var Te = c(Se, De);
      if (Te) {
        var se = Object.getOwnPropertyDescriptor(Te, De);
        return se.get ? se.get.call(Ue) : se.value;
      }
    }, l(Be, Ie, Qe || Be);
  }
  function c(Be, Ie) {
    for (; !Object.prototype.hasOwnProperty.call(Be, Ie) && (Be = I(Be), Be !== null); )
      ;
    return Be;
  }
  function u(Be) {
    return function() {
      var Ie = I(Be), Qe;
      if (d()) {
        var xe = I(this).constructor;
        Qe = Reflect.construct(Ie, arguments, xe);
      } else
        Qe = Ie.apply(this, arguments);
      return f(this, Qe);
    };
  }
  function f(Be, Ie) {
    return Ie && (o(Ie) === "object" || typeof Ie == "function") ? Ie : h(Be);
  }
  function h(Be) {
    if (Be === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return Be;
  }
  function d() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function I(Be) {
    return I = Object.setPrototypeOf ? Object.getPrototypeOf : function(Qe) {
      return Qe.__proto__ || Object.getPrototypeOf(Qe);
    }, I(Be);
  }
  function m(Be, Ie) {
    if (typeof Ie != "function" && Ie !== null)
      throw new TypeError("Super expression must either be null or a function");
    Be.prototype = Object.create(Ie && Ie.prototype, { constructor: { value: Be, writable: !0, configurable: !0 } }), Ie && C(Be, Ie);
  }
  function C(Be, Ie) {
    return C = Object.setPrototypeOf || function(xe, Se) {
      return xe.__proto__ = Se, xe;
    }, C(Be, Ie);
  }
  function y(Be, Ie, Qe) {
    return Ie in Be ? Object.defineProperty(Be, Ie, { value: Qe, enumerable: !0, configurable: !0, writable: !0 }) : Be[Ie] = Qe, Be;
  }
  var v = [0, 0, 0, 153], b = [0, 0, 0, 144], Q = [0, 0, 0, 255], w = [0, 0, 144, 144], R = [144, 144, 144, 255], M = [144, 144, 144, 144], O = [192, 0, 0, 255], L = [0, 0, 0, 128], N = [124, 0, 192, 255], k = [255, 255, 255, 255], $ = 5, U = 3, X = 7, K = n.DrawPolygonMode;
  function z(Be) {
    return !Be || typeof Be != "function" ? Be : function(Ie) {
      return Be(Y(Ie));
    };
  }
  function Y(Be) {
    return Be.__source ? Be.__source.object : Be.sourceFeature ? Be.sourceFeature.feature : Be;
  }
  function V(Be) {
    switch (Be.properties.editHandleType) {
      case "existing":
        return O;
      case "snap-source":
        return N;
      case "intermediate":
      default:
        return L;
    }
  }
  function Z(Be) {
    return k;
  }
  function ce(Be) {
    switch (Be.properties.editHandleType) {
      case "existing":
        return $;
      case "snap":
        return X;
      case "intermediate":
      default:
        return U;
    }
  }
  var ee = {
    mode: K,
    // Edit and interaction events
    onEdit: function() {
    },
    pickable: !0,
    pickingRadius: 10,
    pickingDepth: 5,
    fp64: !1,
    filled: !0,
    stroked: !0,
    lineWidthScale: 1,
    lineWidthMinPixels: 1,
    lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
    lineWidthUnits: "pixels",
    lineJointRounded: !1,
    lineMiterLimit: 4,
    pointRadiusScale: 1,
    pointRadiusMinPixels: 2,
    pointRadiusMaxPixels: Number.MAX_SAFE_INTEGER,
    getLineColor: function(Ie, Qe, xe) {
      return Qe ? Q : v;
    },
    getFillColor: function(Ie, Qe, xe) {
      return Qe ? w : b;
    },
    getRadius: function(Ie) {
      return Ie && Ie.properties && Ie.properties.radius || Ie && Ie.properties && Ie.properties.size || 1;
    },
    getLineWidth: function(Ie) {
      return Ie && Ie.properties && Ie.properties.lineWidth || 3;
    },
    // Tentative feature rendering
    getTentativeLineColor: function(Ie) {
      return R;
    },
    getTentativeFillColor: function(Ie) {
      return M;
    },
    getTentativeLineWidth: function(Ie) {
      return Ie && Ie.properties && Ie.properties.lineWidth || 3;
    },
    editHandleType: "point",
    // point handles
    editHandlePointRadiusScale: 1,
    editHandlePointOutline: !0,
    editHandlePointStrokeWidth: 2,
    editHandlePointRadiusMinPixels: 4,
    editHandlePointRadiusMaxPixels: 8,
    getEditHandlePointColor: V,
    getEditHandlePointOutlineColor: Z,
    getEditHandlePointRadius: ce,
    // icon handles
    editHandleIconAtlas: null,
    editHandleIconMapping: null,
    editHandleIconSizeScale: 1,
    getEditHandleIcon: function(Ie) {
      return Ie.properties.editHandleType;
    },
    getEditHandleIconSize: 10,
    getEditHandleIconColor: V,
    getEditHandleIconAngle: 0,
    // misc
    billboard: !0
  }, pe = {
    view: n.ViewMode,
    // Alter modes
    modify: n.ModifyMode,
    translate: new n.SnappableMode(new n.TranslateMode()),
    transform: new n.SnappableMode(new n.TransformMode()),
    scale: n.ScaleMode,
    rotate: n.RotateMode,
    duplicate: n.DuplicateMode,
    split: n.SplitPolygonMode,
    extrude: n.ExtrudeMode,
    elevation: n.ElevationMode,
    // Draw modes
    drawPoint: n.DrawPointMode,
    drawLineString: n.DrawLineStringMode,
    drawPolygon: n.DrawPolygonMode,
    drawRectangle: n.DrawRectangleMode,
    drawSquareFromCenter: n.DrawSquareFromCenterMode,
    drawCircleFromCenter: n.DrawCircleFromCenterMode,
    drawCircleByBoundingBox: n.DrawCircleByDiameterMode,
    drawEllipseByBoundingBox: n.DrawEllipseByBoundingBoxMode,
    drawRectangleUsing3Points: n.DrawRectangleUsingThreePointsMode,
    drawEllipseUsing3Points: n.DrawEllipseUsingThreePointsMode,
    draw90DegreePolygon: n.Draw90DegreePolygonMode,
    drawPolygonByDragging: n.DrawPolygonByDraggingMode
  }, Ce = /* @__PURE__ */ function(Be) {
    m(Qe, Be);
    var Ie = u(Qe);
    function Qe() {
      return s(this, Qe), Ie.apply(this, arguments);
    }
    return A(Qe, [{
      key: "renderLayers",
      // props: Props;
      // setState: ($Shape<State>) => void;
      value: function() {
        var Se = this.getSubLayerProps({
          id: "geojson",
          // Proxy most GeoJsonLayer props as-is
          data: this.props.data,
          fp64: this.props.fp64,
          filled: this.props.filled,
          stroked: this.props.stroked,
          lineWidthScale: this.props.lineWidthScale,
          lineWidthMinPixels: this.props.lineWidthMinPixels,
          lineWidthMaxPixels: this.props.lineWidthMaxPixels,
          lineWidthUnits: this.props.lineWidthUnits,
          lineJointRounded: this.props.lineJointRounded,
          lineMiterLimit: this.props.lineMiterLimit,
          pointRadiusScale: this.props.pointRadiusScale,
          pointRadiusMinPixels: this.props.pointRadiusMinPixels,
          pointRadiusMaxPixels: this.props.pointRadiusMaxPixels,
          getLineColor: this.selectionAwareAccessor(this.props.getLineColor),
          getFillColor: this.selectionAwareAccessor(this.props.getFillColor),
          getRadius: this.selectionAwareAccessor(this.props.getRadius),
          getLineWidth: this.selectionAwareAccessor(this.props.getLineWidth),
          _subLayerProps: {
            "line-strings": {
              billboard: this.props.billboard
            },
            "polygons-stroke": {
              billboard: this.props.billboard
            }
          },
          updateTriggers: {
            getLineColor: [this.props.selectedFeatureIndexes, this.props.mode],
            getFillColor: [this.props.selectedFeatureIndexes, this.props.mode],
            getRadius: [this.props.selectedFeatureIndexes, this.props.mode],
            getLineWidth: [this.props.selectedFeatureIndexes, this.props.mode]
          }
        }), De = [new e.GeoJsonLayer(Se)];
        return De = De.concat(this.createGuidesLayers(), this.createTooltipsLayers()), De;
      }
    }, {
      key: "initializeState",
      value: function() {
        l(I(Qe.prototype), "initializeState", this).call(this), this.setState({
          selectedFeatures: [],
          editHandles: []
        });
      }
      // TODO: is this the best way to properly update state from an outside event handler?
    }, {
      key: "shouldUpdateState",
      value: function(Se) {
        return l(I(Qe.prototype), "shouldUpdateState", this).call(this, Se) || Se.changeFlags.stateChanged;
      }
    }, {
      key: "updateState",
      value: function(Se) {
        var De = Se.props, Ue = Se.oldProps, Te = Se.changeFlags;
        if (l(I(Qe.prototype), "updateState", this).call(this, {
          oldProps: Ue,
          props: De,
          changeFlags: Te
        }), Te.propsOrDataChanged) {
          var se = Object.keys(Ue).length === 0 || De.mode !== Ue.mode;
          if (se) {
            var fe;
            if (typeof De.mode == "function") {
              var W = De.mode;
              fe = new W();
            } else
              typeof De.mode == "string" ? (fe = pe[De.mode], console.warn("Deprecated use of passing `mode` as a string. Pass the mode's class constructor instead.")) : fe = De.mode;
            fe || (console.warn("No mode configured for ".concat(String(De.mode))), fe = new K()), fe !== this.state.mode && this.setState({
              mode: fe,
              cursor: null
            });
          }
        }
        var ge = [];
        Array.isArray(De.selectedFeatureIndexes) && (ge = De.selectedFeatureIndexes.map(function(_e) {
          return De.data.features[_e];
        })), this.setState({
          selectedFeatures: ge
        });
      }
    }, {
      key: "getModeProps",
      value: function(Se) {
        var De = this;
        return {
          modeConfig: Se.modeConfig,
          data: Se.data,
          selectedIndexes: Se.selectedFeatureIndexes,
          lastPointerMoveEvent: this.state.lastPointerMoveEvent,
          cursor: this.state.cursor,
          onEdit: function(Te) {
            De.setNeedsUpdate(), Se.onEdit(Te);
          },
          onUpdateCursor: function(Te) {
            De.setState({
              cursor: Te
            });
          }
        };
      }
    }, {
      key: "selectionAwareAccessor",
      value: function(Se) {
        var De = this;
        return typeof Se != "function" ? Se : function(Ue) {
          return Se(Ue, De.isFeatureSelected(Ue), De.props.mode);
        };
      }
    }, {
      key: "isFeatureSelected",
      value: function(Se) {
        if (!this.props.data || !this.props.selectedFeatureIndexes || !this.props.selectedFeatureIndexes.length)
          return !1;
        var De = this.props.data.features.indexOf(Se);
        return this.props.selectedFeatureIndexes.includes(De);
      }
    }, {
      key: "getPickingInfo",
      value: function(Se) {
        var De = Se.info, Ue = Se.sourceLayer;
        return Ue.id.endsWith("guides") && (De.isGuide = !0), De;
      }
    }, {
      key: "createGuidesLayers",
      value: function() {
        var Se = this.getActiveMode(), De = Se.getGuides(this.getModeProps(this.props));
        if (!De || !De.features.length)
          return [];
        var Ue;
        this.props.editHandleType === "icon" ? Ue = {
          type: e.IconLayer,
          iconAtlas: this.props.editHandleIconAtlas,
          iconMapping: this.props.editHandleIconMapping,
          sizeScale: this.props.editHandleIconSizeScale,
          getIcon: z(this.props.getEditHandleIcon),
          getSize: z(this.props.getEditHandleIconSize),
          getColor: z(this.props.getEditHandleIconColor),
          getAngle: z(this.props.getEditHandleIconAngle)
        } : Ue = {
          type: e.ScatterplotLayer,
          radiusScale: this.props.editHandlePointRadiusScale,
          stroked: this.props.editHandlePointOutline,
          getLineWidth: this.props.editHandlePointStrokeWidth,
          radiusMinPixels: this.props.editHandlePointRadiusMinPixels,
          radiusMaxPixels: this.props.editHandlePointRadiusMaxPixels,
          getRadius: z(this.props.getEditHandlePointRadius),
          getFillColor: z(this.props.getEditHandlePointColor),
          getLineColor: z(this.props.getEditHandlePointOutlineColor)
        };
        var Te = new e.GeoJsonLayer(this.getSubLayerProps({
          id: "guides",
          data: De,
          fp64: this.props.fp64,
          _subLayerProps: {
            points: Ue
          },
          lineWidthScale: this.props.lineWidthScale,
          lineWidthMinPixels: this.props.lineWidthMinPixels,
          lineWidthMaxPixels: this.props.lineWidthMaxPixels,
          lineWidthUnits: this.props.lineWidthUnits,
          lineJointRounded: this.props.lineJointRounded,
          lineMiterLimit: this.props.lineMiterLimit,
          getLineColor: z(this.props.getTentativeLineColor),
          getLineWidth: z(this.props.getTentativeLineWidth),
          getFillColor: z(this.props.getTentativeFillColor)
        }));
        return [Te];
      }
    }, {
      key: "createTooltipsLayers",
      value: function() {
        var Se = this.getActiveMode(), De = Se.getTooltips(this.getModeProps(this.props)), Ue = new e.TextLayer(this.getSubLayerProps({
          id: "tooltips",
          data: De
        }));
        return [Ue];
      }
    }, {
      key: "onLayerClick",
      value: function(Se) {
        this.getActiveMode().handleClick(Se, this.getModeProps(this.props));
      }
    }, {
      key: "onLayerKeyUp",
      value: function(Se) {
        this.getActiveMode().handleKeyUp(Se, this.getModeProps(this.props));
      }
    }, {
      key: "onStartDragging",
      value: function(Se) {
        this.getActiveMode().handleStartDragging(Se, this.getModeProps(this.props));
      }
    }, {
      key: "onDragging",
      value: function(Se) {
        this.getActiveMode().handleDragging(Se, this.getModeProps(this.props));
      }
    }, {
      key: "onStopDragging",
      value: function(Se) {
        this.getActiveMode().handleStopDragging(Se, this.getModeProps(this.props));
      }
    }, {
      key: "onPointerMove",
      value: function(Se) {
        this.setState({
          lastPointerMoveEvent: Se
        }), this.getActiveMode().handlePointerMove(Se, this.getModeProps(this.props));
      }
    }, {
      key: "getCursor",
      value: function(Se) {
        var De = Se.isDragging;
        if (this.state === null)
          return null;
        var Ue = this.state.cursor;
        return Ue || (Ue = De ? "grabbing" : "grab"), Ue;
      }
    }, {
      key: "getActiveMode",
      value: function() {
        return this.state.mode;
      }
    }]), Qe;
  }(r.default);
  t.default = Ce, y(Ce, "layerName", "EditableGeoJsonLayer"), y(Ce, "defaultProps", ee);
})(k$);
var wVe = {};
const sGn = /* @__PURE__ */ Fs(uSn), aGn = /* @__PURE__ */ Fs(uEn);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = sGn, n = s1, r = aGn, i = s(k$), o = s(Gue);
  function s(Y) {
    return Y && Y.__esModule ? Y : { default: Y };
  }
  function a(Y) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(Z) {
      return typeof Z;
    } : a = function(Z) {
      return Z && typeof Symbol == "function" && Z.constructor === Symbol && Z !== Symbol.prototype ? "symbol" : typeof Z;
    }, a(Y);
  }
  function A(Y) {
    return f(Y) || u(Y) || c(Y) || l();
  }
  function l() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function c(Y, V) {
    if (Y) {
      if (typeof Y == "string")
        return h(Y, V);
      var Z = Object.prototype.toString.call(Y).slice(8, -1);
      if (Z === "Object" && Y.constructor && (Z = Y.constructor.name), Z === "Map" || Z === "Set")
        return Array.from(Z);
      if (Z === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Z))
        return h(Y, V);
    }
  }
  function u(Y) {
    if (typeof Symbol < "u" && Symbol.iterator in Object(Y))
      return Array.from(Y);
  }
  function f(Y) {
    if (Array.isArray(Y))
      return h(Y);
  }
  function h(Y, V) {
    (V == null || V > Y.length) && (V = Y.length);
    for (var Z = 0, ce = new Array(V); Z < V; Z++)
      ce[Z] = Y[Z];
    return ce;
  }
  function d(Y, V) {
    if (!(Y instanceof V))
      throw new TypeError("Cannot call a class as a function");
  }
  function I(Y, V) {
    for (var Z = 0; Z < V.length; Z++) {
      var ce = V[Z];
      ce.enumerable = ce.enumerable || !1, ce.configurable = !0, "value" in ce && (ce.writable = !0), Object.defineProperty(Y, ce.key, ce);
    }
  }
  function m(Y, V, Z) {
    return V && I(Y.prototype, V), Z && I(Y, Z), Y;
  }
  function C(Y, V, Z) {
    return typeof Reflect < "u" && Reflect.get ? C = Reflect.get : C = function(ee, pe, Ce) {
      var Be = y(ee, pe);
      if (Be) {
        var Ie = Object.getOwnPropertyDescriptor(Be, pe);
        return Ie.get ? Ie.get.call(Ce) : Ie.value;
      }
    }, C(Y, V, Z || Y);
  }
  function y(Y, V) {
    for (; !Object.prototype.hasOwnProperty.call(Y, V) && (Y = R(Y), Y !== null); )
      ;
    return Y;
  }
  function v(Y) {
    return function() {
      var V = R(Y), Z;
      if (w()) {
        var ce = R(this).constructor;
        Z = Reflect.construct(V, arguments, ce);
      } else
        Z = V.apply(this, arguments);
      return b(this, Z);
    };
  }
  function b(Y, V) {
    return V && (a(V) === "object" || typeof V == "function") ? V : Q(Y);
  }
  function Q(Y) {
    if (Y === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return Y;
  }
  function w() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function R(Y) {
    return R = Object.setPrototypeOf ? Object.getPrototypeOf : function(Z) {
      return Z.__proto__ || Object.getPrototypeOf(Z);
    }, R(Y);
  }
  function M(Y, V) {
    if (typeof V != "function" && V !== null)
      throw new TypeError("Super expression must either be null or a function");
    Y.prototype = Object.create(V && V.prototype, { constructor: { value: Y, writable: !0, configurable: !0 } }), V && O(Y, V);
  }
  function O(Y, V) {
    return O = Object.setPrototypeOf || function(ce, ee) {
      return ce.__proto__ = ee, ce;
    }, O(Y, V);
  }
  function L(Y, V) {
    var Z = Object.keys(Y);
    if (Object.getOwnPropertySymbols) {
      var ce = Object.getOwnPropertySymbols(Y);
      V && (ce = ce.filter(function(ee) {
        return Object.getOwnPropertyDescriptor(Y, ee).enumerable;
      })), Z.push.apply(Z, ce);
    }
    return Z;
  }
  function N(Y) {
    for (var V = 1; V < arguments.length; V++) {
      var Z = arguments[V] != null ? arguments[V] : {};
      V % 2 ? L(Object(Z), !0).forEach(function(ce) {
        k(Y, ce, Z[ce]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Y, Object.getOwnPropertyDescriptors(Z)) : L(Object(Z)).forEach(function(ce) {
        Object.defineProperty(Y, ce, Object.getOwnPropertyDescriptor(Z, ce));
      });
    }
    return Y;
  }
  function k(Y, V, Z) {
    return V in Y ? Object.defineProperty(Y, V, { value: Z, enumerable: !0, configurable: !0, writable: !0 }) : Y[V] = Z, Y;
  }
  var $ = n.ViewMode, U = 9, X = {
    type: "FeatureCollection",
    features: []
  }, K = N({
    mode: $
  }, i.default.defaultProps, {
    // h3 layer
    data: [],
    selectedIndexes: [],
    filled: !1,
    stroked: !0,
    lineWidthScale: 1,
    lineWidthMinPixels: 1,
    lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
    lineWidthUnits: "pixels",
    getHexagons: function(V) {
      return V.hexIds;
    },
    getEditedCluster: function(V, Z) {
      return Z ? N({}, Z, {
        hexIds: V
      }) : {
        hexIds: V
      };
    },
    resolution: U
  }), z = /* @__PURE__ */ function(Y) {
    M(Z, Y);
    var V = v(Z);
    function Z() {
      return d(this, Z), V.apply(this, arguments);
    }
    return m(Z, [{
      key: "initializeState",
      value: function() {
        C(R(Z.prototype), "initializeState", this).call(this), this.setState({
          tentativeHexagonIDs: []
        });
      }
      // convert array of (lng, lat) coords to cluster of hexes
    }, {
      key: "getDerivedHexagonIDs",
      value: function(ee) {
        return (0, r.polyfill)(ee, this.props.resolution, !0);
      }
      // convert pair of (lng, lat) coords into single hex
    }, {
      key: "getDerivedHexagonID",
      value: function(ee) {
        return (0, r.geoToH3)(ee[1], ee[0], this.props.resolution);
      }
    }, {
      key: "renderLayers",
      value: function() {
        var ee = this, pe = [new i.default(this.getSubLayerProps({
          id: "editable-geojson",
          mode: this.props.mode,
          data: X,
          selectedFeatureIndexes: [],
          onEdit: function(Be) {
            var Ie = Be.editType, Qe = Be.editContext;
            switch (Ie) {
              case "updateTentativeFeature":
                if (Qe.feature.geometry.type === "Polygon") {
                  var xe = Qe.feature.geometry.coordinates, Se = ee.getDerivedHexagonIDs(xe);
                  ee.setState({
                    tentativeHexagonIDs: Se
                  });
                } else if (Qe.feature.geometry.type === "Point") {
                  var De = Qe.feature.geometry.coordinates, Ue = ee.getDerivedHexagonID(De);
                  ee.setState({
                    tentativeHexagonIDs: [Ue]
                  });
                }
                break;
              case "addFeature":
                var Te = A(ee.props.data), se = ee.props.modeConfig;
                if (!se || !se.booleanOperation)
                  Te.push(ee.props.getEditedCluster(ee.state.tentativeHexagonIDs, null));
                else if (ee.props.selectedIndexes.length !== 1)
                  console.warn("booleanOperation only supported for single cluster selection");
                else {
                  var fe, W = new Set(ee.getSelectedHexIDs()), ge = new Set(ee.state.tentativeHexagonIDs);
                  switch (se.booleanOperation) {
                    case "union":
                    default:
                      fe = A(new Set([].concat(A(W), A(ge))));
                      break;
                    case "intersection":
                      fe = A(W).filter(function(Ee) {
                        return ge.has(Ee);
                      });
                      break;
                    case "difference":
                      fe = A(W).filter(function(Ee) {
                        return !ge.has(Ee);
                      });
                      break;
                  }
                  var _e = ee.props.selectedIndexes[0], Re = ee.props.data[_e];
                  Te[_e] = ee.props.getEditedCluster(fe, Re);
                }
                ee.setState({
                  tentativeHexagonIDs: []
                }), ee.props.onEdit({
                  updatedData: Te
                });
                break;
            }
          }
        })), new e.H3ClusterLayer(this.getSubLayerProps({
          id: "hexagons",
          data: this.props.data,
          getHexagons: this.props.getHexagons
        })), new e.H3ClusterLayer(this.getSubLayerProps({
          id: "tentative-hexagons",
          data: [{
            hexIds: this.state.tentativeHexagonIDs
          }],
          getHexagons: function(Be) {
            return Be.hexIds;
          }
        }))];
        return pe;
      }
      // because data is an array of hexagon data, we take the cumulative of all selected indexes,
      // using props.getHexagons to support multiple data types
    }, {
      key: "getSelectedHexIDs",
      value: function() {
        var ee = this, pe = [];
        return this.props.selectedIndexes.forEach(function(Ce) {
          var Be = ee.props.data[Ce], Ie = ee.props.getHexagons(Be);
          pe = pe.concat(Ie);
        }), pe;
      }
    }, {
      key: "getCursor",
      value: function(ee) {
        var pe = ee.isDragging, Ce = this.state.cursor;
        return Ce || (Ce = pe ? "grabbing" : "grab"), Ce;
      }
    }]), Z;
  }(o.default);
  t.default = z, k(z, "layerName", "EditableH3ClusterLayer"), k(z, "defaultProps", K);
})(wVe);
var xVe = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = t.SELECTION_TYPE = void 0;
  var e = Jw, n = wE, r = ar, i = l(fue), o = l(O$), s = s1, a = l(k$), A;
  function l(xe) {
    return xe && xe.__esModule ? xe : { default: xe };
  }
  function c(xe) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? c = function(De) {
      return typeof De;
    } : c = function(De) {
      return De && typeof Symbol == "function" && De.constructor === Symbol && De !== Symbol.prototype ? "symbol" : typeof De;
    }, c(xe);
  }
  function u(xe, Se) {
    var De = Object.keys(xe);
    if (Object.getOwnPropertySymbols) {
      var Ue = Object.getOwnPropertySymbols(xe);
      Se && (Ue = Ue.filter(function(Te) {
        return Object.getOwnPropertyDescriptor(xe, Te).enumerable;
      })), De.push.apply(De, Ue);
    }
    return De;
  }
  function f(xe) {
    for (var Se = 1; Se < arguments.length; Se++) {
      var De = arguments[Se] != null ? arguments[Se] : {};
      Se % 2 ? u(Object(De), !0).forEach(function(Ue) {
        z(xe, Ue, De[Ue]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(xe, Object.getOwnPropertyDescriptors(De)) : u(Object(De)).forEach(function(Ue) {
        Object.defineProperty(xe, Ue, Object.getOwnPropertyDescriptor(De, Ue));
      });
    }
    return xe;
  }
  function h(xe) {
    return m(xe) || I(xe) || v(xe) || d();
  }
  function d() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function I(xe) {
    if (typeof Symbol < "u" && Symbol.iterator in Object(xe))
      return Array.from(xe);
  }
  function m(xe) {
    if (Array.isArray(xe))
      return b(xe);
  }
  function C(xe, Se) {
    return w(xe) || Q(xe, Se) || v(xe, Se) || y();
  }
  function y() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function v(xe, Se) {
    if (xe) {
      if (typeof xe == "string")
        return b(xe, Se);
      var De = Object.prototype.toString.call(xe).slice(8, -1);
      if (De === "Object" && xe.constructor && (De = xe.constructor.name), De === "Map" || De === "Set")
        return Array.from(De);
      if (De === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(De))
        return b(xe, Se);
    }
  }
  function b(xe, Se) {
    (Se == null || Se > xe.length) && (Se = xe.length);
    for (var De = 0, Ue = new Array(Se); De < Se; De++)
      Ue[De] = xe[De];
    return Ue;
  }
  function Q(xe, Se) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(xe)))) {
      var De = [], Ue = !0, Te = !1, se = void 0;
      try {
        for (var fe = xe[Symbol.iterator](), W; !(Ue = (W = fe.next()).done) && (De.push(W.value), !(Se && De.length === Se)); Ue = !0)
          ;
      } catch (ge) {
        Te = !0, se = ge;
      } finally {
        try {
          !Ue && fe.return != null && fe.return();
        } finally {
          if (Te)
            throw se;
        }
      }
      return De;
    }
  }
  function w(xe) {
    if (Array.isArray(xe))
      return xe;
  }
  function R(xe, Se) {
    if (!(xe instanceof Se))
      throw new TypeError("Cannot call a class as a function");
  }
  function M(xe, Se) {
    for (var De = 0; De < Se.length; De++) {
      var Ue = Se[De];
      Ue.enumerable = Ue.enumerable || !1, Ue.configurable = !0, "value" in Ue && (Ue.writable = !0), Object.defineProperty(xe, Ue.key, Ue);
    }
  }
  function O(xe, Se, De) {
    return Se && M(xe.prototype, Se), De && M(xe, De), xe;
  }
  function L(xe) {
    return function() {
      var Se = U(xe), De;
      if ($()) {
        var Ue = U(this).constructor;
        De = Reflect.construct(Se, arguments, Ue);
      } else
        De = Se.apply(this, arguments);
      return N(this, De);
    };
  }
  function N(xe, Se) {
    return Se && (c(Se) === "object" || typeof Se == "function") ? Se : k(xe);
  }
  function k(xe) {
    if (xe === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return xe;
  }
  function $() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function U(xe) {
    return U = Object.setPrototypeOf ? Object.getPrototypeOf : function(De) {
      return De.__proto__ || Object.getPrototypeOf(De);
    }, U(xe);
  }
  function X(xe, Se) {
    if (typeof Se != "function" && Se !== null)
      throw new TypeError("Super expression must either be null or a function");
    xe.prototype = Object.create(Se && Se.prototype, { constructor: { value: xe, writable: !0, configurable: !0 } }), Se && K(xe, Se);
  }
  function K(xe, Se) {
    return K = Object.setPrototypeOf || function(Ue, Te) {
      return Ue.__proto__ = Te, Ue;
    }, K(xe, Se);
  }
  function z(xe, Se, De) {
    return Se in xe ? Object.defineProperty(xe, Se, { value: De, enumerable: !0, configurable: !0, writable: !0 }) : xe[Se] = De, xe;
  }
  var Y = {
    NONE: null,
    RECTANGLE: "rectangle",
    POLYGON: "polygon"
  };
  t.SELECTION_TYPE = Y;
  var V = (A = {}, z(A, Y.RECTANGLE, s.DrawRectangleMode), z(A, Y.POLYGON, s.DrawPolygonMode), A), Z = z({}, Y.RECTANGLE, {
    dragToDraw: !0
  }), ce = {
    selectionType: Y.RECTANGLE,
    layerIds: [],
    onSelect: function() {
    }
  }, ee = {
    type: "FeatureCollection",
    features: []
  }, pe = 50, Ce = "selection-geojson", Be = "selection-blocker", Ie = ["lineWidthScale", "lineWidthMinPixels", "lineWidthMaxPixels", "lineWidthUnits", "lineJointRounded", "lineMiterLimit", "pointRadiusScale", "pointRadiusMinPixels", "pointRadiusMaxPixels", "lineDashJustified", "getLineColor", "getFillColor", "getRadius", "getLineWidth", "getLineDashArray", "getTentativeLineDashArray", "getTentativeLineColor", "getTentativeFillColor", "getTentativeLineWidth"], Qe = /* @__PURE__ */ function(xe) {
    X(De, xe);
    var Se = L(De);
    function De() {
      return R(this, De), Se.apply(this, arguments);
    }
    return O(De, [{
      key: "_selectRectangleObjects",
      value: function(Te) {
        var se = this.props, fe = se.layerIds, W = se.onSelect, ge = this.context.viewport.project(Te[0][0]), _e = C(ge, 2), Re = _e[0], Ee = _e[1], oe = this.context.viewport.project(Te[0][2]), ie = C(oe, 2), Ae = ie[0], de = ie[1], we = this.context.deck.pickObjects({
          x: Math.min(Re, Ae),
          y: Math.min(Ee, de),
          width: Math.abs(Ae - Re),
          height: Math.abs(de - Ee),
          layerIds: fe
        });
        W({
          pickingInfos: we
        });
      }
    }, {
      key: "_selectPolygonObjects",
      value: function(Te) {
        var se = this, fe = this.props, W = fe.layerIds, ge = fe.onSelect, _e = Te[0].map(function(Xe) {
          return se.context.viewport.project(Xe);
        }), Re = _e.map(function(Xe) {
          return Xe[0];
        }), Ee = _e.map(function(Xe) {
          return Xe[1];
        }), oe = Math.min.apply(Math, h(Re)), ie = Math.min.apply(Math, h(Ee)), Ae = Math.max.apply(Math, h(Re)), de = Math.max.apply(Math, h(Ee)), we = (0, r.polygon)(Te), Pe = (0, i.default)(we, pe), qe;
        try {
          qe = (0, o.default)(Pe, we);
        } catch (Xe) {
          console.log("turfDifference() error", Xe);
          return;
        }
        this.setState({
          pendingPolygonSelection: {
            bigPolygon: qe
          }
        });
        var ke = "".concat(this.props.id, "-").concat(Be);
        setTimeout(function() {
          var Xe = se.context.deck.pickObjects({
            x: oe,
            y: ie,
            width: Ae - oe,
            height: de - ie,
            layerIds: [ke].concat(h(W))
          });
          ge({
            pickingInfos: Xe.filter(function(rt) {
              return rt.layer.id !== se.props.id;
            })
          });
        }, 250);
      }
    }, {
      key: "renderLayers",
      value: function() {
        var Te = this, se = this.state.pendingPolygonSelection, fe = V[this.props.selectionType] || s.ViewMode, W = Z[this.props.selectionType], ge = {};
        Ie.forEach(function(Ee) {
          Te.props[Ee] !== void 0 && (ge[Ee] = Te.props[Ee]);
        });
        var _e = [new a.default(this.getSubLayerProps(f({
          id: Ce,
          pickable: !0,
          mode: fe,
          modeConfig: W,
          selectedFeatureIndexes: [],
          data: ee,
          onEdit: function(oe) {
            var ie = oe.updatedData, Ae = oe.editType;
            if (Ae === "addFeature") {
              var de = ie.features[0].geometry.coordinates;
              Te.props.selectionType === Y.RECTANGLE ? Te._selectRectangleObjects(de) : Te.props.selectionType === Y.POLYGON && Te._selectPolygonObjects(de);
            }
          }
        }, ge)))];
        if (se) {
          var Re = se.bigPolygon;
          _e.push(new n.PolygonLayer(
            // @ts-ignore
            this.getSubLayerProps({
              id: Be,
              pickable: !0,
              stroked: !1,
              opacity: 1,
              data: [Re],
              getLineColor: function(oe) {
                return [0, 0, 0, 1];
              },
              getFillColor: function(oe) {
                return [0, 0, 0, 1];
              },
              getPolygon: function(oe) {
                return oe.geometry.coordinates;
              }
            })
          ));
        }
        return _e;
      }
    }, {
      key: "shouldUpdateState",
      value: function(Te) {
        var se = Te.changeFlags, fe = se.stateChanged, W = se.propsOrDataChanged;
        return fe || W;
      }
    }]), De;
  }(e.CompositeLayer);
  t.default = Qe, z(Qe, "layerName", "SelectionLayer"), z(Qe, "defaultProps", ce);
})(xVe);
var RVe = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = Jw, n = wE;
  function r(C) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(v) {
      return typeof v;
    } : r = function(v) {
      return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
    }, r(C);
  }
  function i(C, y) {
    if (!(C instanceof y))
      throw new TypeError("Cannot call a class as a function");
  }
  function o(C, y) {
    for (var v = 0; v < y.length; v++) {
      var b = y[v];
      b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(C, b.key, b);
    }
  }
  function s(C, y, v) {
    return y && o(C.prototype, y), v && o(C, v), C;
  }
  function a(C) {
    return function() {
      var y = u(C), v;
      if (c()) {
        var b = u(this).constructor;
        v = Reflect.construct(y, arguments, b);
      } else
        v = y.apply(this, arguments);
      return A(this, v);
    };
  }
  function A(C, y) {
    return y && (r(y) === "object" || typeof y == "function") ? y : l(C);
  }
  function l(C) {
    if (C === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return C;
  }
  function c() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function u(C) {
    return u = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
      return v.__proto__ || Object.getPrototypeOf(v);
    }, u(C);
  }
  function f(C, y) {
    if (typeof y != "function" && y !== null)
      throw new TypeError("Super expression must either be null or a function");
    C.prototype = Object.create(y && y.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), y && h(C, y);
  }
  function h(C, y) {
    return h = Object.setPrototypeOf || function(b, Q) {
      return b.__proto__ = Q, b;
    }, h(C, y);
  }
  function d(C, y, v) {
    return y in C ? Object.defineProperty(C, y, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : C[y] = v, C;
  }
  var I = {}, m = /* @__PURE__ */ function(C) {
    f(v, C);
    var y = a(v);
    function v() {
      return i(this, v), y.apply(this, arguments);
    }
    return s(v, [{
      key: "renderLayers",
      value: function() {
        var Q = new n.ScatterplotLayer(Object.assign({}, this.props, {
          id: "".concat(this.props.id, "-ScatterplotLayer"),
          data: this.props.data
        })), w = new n.LineLayer(Object.assign({}, this.props, {
          id: "".concat(this.props.id, "-LineLayer"),
          data: this.props.data,
          pickable: !1,
          getSourcePosition: function(M) {
            var O = M.position;
            return [O[0], O[1], 0];
          },
          getTargetPosition: function(M) {
            var O = M.position;
            return [O[0], O[1], O[2] || 0];
          },
          getColor: [150, 150, 150, 200],
          getStrokeWidth: 3
        }));
        return [Q, w];
      }
    }]), v;
  }(e.CompositeLayer);
  t.default = m, d(m, "layerName", "ElevatedEditHandleLayer"), d(m, "defaultProps", I);
})(RVe);
var Uue = {};
const gt = {
  DEPTH_BUFFER_BIT: 256,
  STENCIL_BUFFER_BIT: 1024,
  COLOR_BUFFER_BIT: 16384,
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6,
  ZERO: 0,
  ONE: 1,
  SRC_COLOR: 768,
  ONE_MINUS_SRC_COLOR: 769,
  SRC_ALPHA: 770,
  ONE_MINUS_SRC_ALPHA: 771,
  DST_ALPHA: 772,
  ONE_MINUS_DST_ALPHA: 773,
  DST_COLOR: 774,
  ONE_MINUS_DST_COLOR: 775,
  SRC_ALPHA_SATURATE: 776,
  CONSTANT_COLOR: 32769,
  ONE_MINUS_CONSTANT_COLOR: 32770,
  CONSTANT_ALPHA: 32771,
  ONE_MINUS_CONSTANT_ALPHA: 32772,
  FUNC_ADD: 32774,
  FUNC_SUBTRACT: 32778,
  FUNC_REVERSE_SUBTRACT: 32779,
  BLEND_EQUATION: 32777,
  BLEND_EQUATION_RGB: 32777,
  BLEND_EQUATION_ALPHA: 34877,
  BLEND_DST_RGB: 32968,
  BLEND_SRC_RGB: 32969,
  BLEND_DST_ALPHA: 32970,
  BLEND_SRC_ALPHA: 32971,
  BLEND_COLOR: 32773,
  ARRAY_BUFFER_BINDING: 34964,
  ELEMENT_ARRAY_BUFFER_BINDING: 34965,
  LINE_WIDTH: 2849,
  ALIASED_POINT_SIZE_RANGE: 33901,
  ALIASED_LINE_WIDTH_RANGE: 33902,
  CULL_FACE_MODE: 2885,
  FRONT_FACE: 2886,
  DEPTH_RANGE: 2928,
  DEPTH_WRITEMASK: 2930,
  DEPTH_CLEAR_VALUE: 2931,
  DEPTH_FUNC: 2932,
  STENCIL_CLEAR_VALUE: 2961,
  STENCIL_FUNC: 2962,
  STENCIL_FAIL: 2964,
  STENCIL_PASS_DEPTH_FAIL: 2965,
  STENCIL_PASS_DEPTH_PASS: 2966,
  STENCIL_REF: 2967,
  STENCIL_VALUE_MASK: 2963,
  STENCIL_WRITEMASK: 2968,
  STENCIL_BACK_FUNC: 34816,
  STENCIL_BACK_FAIL: 34817,
  STENCIL_BACK_PASS_DEPTH_FAIL: 34818,
  STENCIL_BACK_PASS_DEPTH_PASS: 34819,
  STENCIL_BACK_REF: 36003,
  STENCIL_BACK_VALUE_MASK: 36004,
  STENCIL_BACK_WRITEMASK: 36005,
  VIEWPORT: 2978,
  SCISSOR_BOX: 3088,
  COLOR_CLEAR_VALUE: 3106,
  COLOR_WRITEMASK: 3107,
  UNPACK_ALIGNMENT: 3317,
  PACK_ALIGNMENT: 3333,
  MAX_TEXTURE_SIZE: 3379,
  MAX_VIEWPORT_DIMS: 3386,
  SUBPIXEL_BITS: 3408,
  RED_BITS: 3410,
  GREEN_BITS: 3411,
  BLUE_BITS: 3412,
  ALPHA_BITS: 3413,
  DEPTH_BITS: 3414,
  STENCIL_BITS: 3415,
  POLYGON_OFFSET_UNITS: 10752,
  POLYGON_OFFSET_FACTOR: 32824,
  TEXTURE_BINDING_2D: 32873,
  SAMPLE_BUFFERS: 32936,
  SAMPLES: 32937,
  SAMPLE_COVERAGE_VALUE: 32938,
  SAMPLE_COVERAGE_INVERT: 32939,
  COMPRESSED_TEXTURE_FORMATS: 34467,
  VENDOR: 7936,
  RENDERER: 7937,
  VERSION: 7938,
  IMPLEMENTATION_COLOR_READ_TYPE: 35738,
  IMPLEMENTATION_COLOR_READ_FORMAT: 35739,
  BROWSER_DEFAULT_WEBGL: 37444,
  STATIC_DRAW: 35044,
  STREAM_DRAW: 35040,
  DYNAMIC_DRAW: 35048,
  ARRAY_BUFFER: 34962,
  ELEMENT_ARRAY_BUFFER: 34963,
  BUFFER_SIZE: 34660,
  BUFFER_USAGE: 34661,
  CURRENT_VERTEX_ATTRIB: 34342,
  VERTEX_ATTRIB_ARRAY_ENABLED: 34338,
  VERTEX_ATTRIB_ARRAY_SIZE: 34339,
  VERTEX_ATTRIB_ARRAY_STRIDE: 34340,
  VERTEX_ATTRIB_ARRAY_TYPE: 34341,
  VERTEX_ATTRIB_ARRAY_NORMALIZED: 34922,
  VERTEX_ATTRIB_ARRAY_POINTER: 34373,
  VERTEX_ATTRIB_ARRAY_BUFFER_BINDING: 34975,
  CULL_FACE: 2884,
  FRONT: 1028,
  BACK: 1029,
  FRONT_AND_BACK: 1032,
  BLEND: 3042,
  DEPTH_TEST: 2929,
  DITHER: 3024,
  POLYGON_OFFSET_FILL: 32823,
  SAMPLE_ALPHA_TO_COVERAGE: 32926,
  SAMPLE_COVERAGE: 32928,
  SCISSOR_TEST: 3089,
  STENCIL_TEST: 2960,
  NO_ERROR: 0,
  INVALID_ENUM: 1280,
  INVALID_VALUE: 1281,
  INVALID_OPERATION: 1282,
  OUT_OF_MEMORY: 1285,
  CONTEXT_LOST_WEBGL: 37442,
  CW: 2304,
  CCW: 2305,
  DONT_CARE: 4352,
  FASTEST: 4353,
  NICEST: 4354,
  GENERATE_MIPMAP_HINT: 33170,
  BYTE: 5120,
  UNSIGNED_BYTE: 5121,
  SHORT: 5122,
  UNSIGNED_SHORT: 5123,
  INT: 5124,
  UNSIGNED_INT: 5125,
  FLOAT: 5126,
  DOUBLE: 5130,
  DEPTH_COMPONENT: 6402,
  ALPHA: 6406,
  RGB: 6407,
  RGBA: 6408,
  LUMINANCE: 6409,
  LUMINANCE_ALPHA: 6410,
  UNSIGNED_SHORT_4_4_4_4: 32819,
  UNSIGNED_SHORT_5_5_5_1: 32820,
  UNSIGNED_SHORT_5_6_5: 33635,
  FRAGMENT_SHADER: 35632,
  VERTEX_SHADER: 35633,
  COMPILE_STATUS: 35713,
  DELETE_STATUS: 35712,
  LINK_STATUS: 35714,
  VALIDATE_STATUS: 35715,
  ATTACHED_SHADERS: 35717,
  ACTIVE_ATTRIBUTES: 35721,
  ACTIVE_UNIFORMS: 35718,
  MAX_VERTEX_ATTRIBS: 34921,
  MAX_VERTEX_UNIFORM_VECTORS: 36347,
  MAX_VARYING_VECTORS: 36348,
  MAX_COMBINED_TEXTURE_IMAGE_UNITS: 35661,
  MAX_VERTEX_TEXTURE_IMAGE_UNITS: 35660,
  MAX_TEXTURE_IMAGE_UNITS: 34930,
  MAX_FRAGMENT_UNIFORM_VECTORS: 36349,
  SHADER_TYPE: 35663,
  SHADING_LANGUAGE_VERSION: 35724,
  CURRENT_PROGRAM: 35725,
  NEVER: 512,
  ALWAYS: 519,
  LESS: 513,
  EQUAL: 514,
  LEQUAL: 515,
  GREATER: 516,
  GEQUAL: 518,
  NOTEQUAL: 517,
  KEEP: 7680,
  REPLACE: 7681,
  INCR: 7682,
  DECR: 7683,
  INVERT: 5386,
  INCR_WRAP: 34055,
  DECR_WRAP: 34056,
  NEAREST: 9728,
  LINEAR: 9729,
  NEAREST_MIPMAP_NEAREST: 9984,
  LINEAR_MIPMAP_NEAREST: 9985,
  NEAREST_MIPMAP_LINEAR: 9986,
  LINEAR_MIPMAP_LINEAR: 9987,
  TEXTURE_MAG_FILTER: 10240,
  TEXTURE_MIN_FILTER: 10241,
  TEXTURE_WRAP_S: 10242,
  TEXTURE_WRAP_T: 10243,
  TEXTURE_2D: 3553,
  TEXTURE: 5890,
  TEXTURE_CUBE_MAP: 34067,
  TEXTURE_BINDING_CUBE_MAP: 34068,
  TEXTURE_CUBE_MAP_POSITIVE_X: 34069,
  TEXTURE_CUBE_MAP_NEGATIVE_X: 34070,
  TEXTURE_CUBE_MAP_POSITIVE_Y: 34071,
  TEXTURE_CUBE_MAP_NEGATIVE_Y: 34072,
  TEXTURE_CUBE_MAP_POSITIVE_Z: 34073,
  TEXTURE_CUBE_MAP_NEGATIVE_Z: 34074,
  MAX_CUBE_MAP_TEXTURE_SIZE: 34076,
  TEXTURE0: 33984,
  ACTIVE_TEXTURE: 34016,
  REPEAT: 10497,
  CLAMP_TO_EDGE: 33071,
  MIRRORED_REPEAT: 33648,
  TEXTURE_WIDTH: 4096,
  TEXTURE_HEIGHT: 4097,
  FLOAT_VEC2: 35664,
  FLOAT_VEC3: 35665,
  FLOAT_VEC4: 35666,
  INT_VEC2: 35667,
  INT_VEC3: 35668,
  INT_VEC4: 35669,
  BOOL: 35670,
  BOOL_VEC2: 35671,
  BOOL_VEC3: 35672,
  BOOL_VEC4: 35673,
  FLOAT_MAT2: 35674,
  FLOAT_MAT3: 35675,
  FLOAT_MAT4: 35676,
  SAMPLER_2D: 35678,
  SAMPLER_CUBE: 35680,
  LOW_FLOAT: 36336,
  MEDIUM_FLOAT: 36337,
  HIGH_FLOAT: 36338,
  LOW_INT: 36339,
  MEDIUM_INT: 36340,
  HIGH_INT: 36341,
  FRAMEBUFFER: 36160,
  RENDERBUFFER: 36161,
  RGBA4: 32854,
  RGB5_A1: 32855,
  RGB565: 36194,
  DEPTH_COMPONENT16: 33189,
  STENCIL_INDEX: 6401,
  STENCIL_INDEX8: 36168,
  DEPTH_STENCIL: 34041,
  RENDERBUFFER_WIDTH: 36162,
  RENDERBUFFER_HEIGHT: 36163,
  RENDERBUFFER_INTERNAL_FORMAT: 36164,
  RENDERBUFFER_RED_SIZE: 36176,
  RENDERBUFFER_GREEN_SIZE: 36177,
  RENDERBUFFER_BLUE_SIZE: 36178,
  RENDERBUFFER_ALPHA_SIZE: 36179,
  RENDERBUFFER_DEPTH_SIZE: 36180,
  RENDERBUFFER_STENCIL_SIZE: 36181,
  FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE: 36048,
  FRAMEBUFFER_ATTACHMENT_OBJECT_NAME: 36049,
  FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL: 36050,
  FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE: 36051,
  COLOR_ATTACHMENT0: 36064,
  DEPTH_ATTACHMENT: 36096,
  STENCIL_ATTACHMENT: 36128,
  DEPTH_STENCIL_ATTACHMENT: 33306,
  NONE: 0,
  FRAMEBUFFER_COMPLETE: 36053,
  FRAMEBUFFER_INCOMPLETE_ATTACHMENT: 36054,
  FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT: 36055,
  FRAMEBUFFER_INCOMPLETE_DIMENSIONS: 36057,
  FRAMEBUFFER_UNSUPPORTED: 36061,
  FRAMEBUFFER_BINDING: 36006,
  RENDERBUFFER_BINDING: 36007,
  READ_FRAMEBUFFER: 36008,
  DRAW_FRAMEBUFFER: 36009,
  MAX_RENDERBUFFER_SIZE: 34024,
  INVALID_FRAMEBUFFER_OPERATION: 1286,
  UNPACK_FLIP_Y_WEBGL: 37440,
  UNPACK_PREMULTIPLY_ALPHA_WEBGL: 37441,
  UNPACK_COLORSPACE_CONVERSION_WEBGL: 37443,
  READ_BUFFER: 3074,
  UNPACK_ROW_LENGTH: 3314,
  UNPACK_SKIP_ROWS: 3315,
  UNPACK_SKIP_PIXELS: 3316,
  PACK_ROW_LENGTH: 3330,
  PACK_SKIP_ROWS: 3331,
  PACK_SKIP_PIXELS: 3332,
  TEXTURE_BINDING_3D: 32874,
  UNPACK_SKIP_IMAGES: 32877,
  UNPACK_IMAGE_HEIGHT: 32878,
  MAX_3D_TEXTURE_SIZE: 32883,
  MAX_ELEMENTS_VERTICES: 33e3,
  MAX_ELEMENTS_INDICES: 33001,
  MAX_TEXTURE_LOD_BIAS: 34045,
  MAX_FRAGMENT_UNIFORM_COMPONENTS: 35657,
  MAX_VERTEX_UNIFORM_COMPONENTS: 35658,
  MAX_ARRAY_TEXTURE_LAYERS: 35071,
  MIN_PROGRAM_TEXEL_OFFSET: 35076,
  MAX_PROGRAM_TEXEL_OFFSET: 35077,
  MAX_VARYING_COMPONENTS: 35659,
  FRAGMENT_SHADER_DERIVATIVE_HINT: 35723,
  RASTERIZER_DISCARD: 35977,
  VERTEX_ARRAY_BINDING: 34229,
  MAX_VERTEX_OUTPUT_COMPONENTS: 37154,
  MAX_FRAGMENT_INPUT_COMPONENTS: 37157,
  MAX_SERVER_WAIT_TIMEOUT: 37137,
  MAX_ELEMENT_INDEX: 36203,
  RED: 6403,
  RGB8: 32849,
  RGBA8: 32856,
  RGB10_A2: 32857,
  TEXTURE_3D: 32879,
  TEXTURE_WRAP_R: 32882,
  TEXTURE_MIN_LOD: 33082,
  TEXTURE_MAX_LOD: 33083,
  TEXTURE_BASE_LEVEL: 33084,
  TEXTURE_MAX_LEVEL: 33085,
  TEXTURE_COMPARE_MODE: 34892,
  TEXTURE_COMPARE_FUNC: 34893,
  SRGB: 35904,
  SRGB8: 35905,
  SRGB8_ALPHA8: 35907,
  COMPARE_REF_TO_TEXTURE: 34894,
  RGBA32F: 34836,
  RGB32F: 34837,
  RGBA16F: 34842,
  RGB16F: 34843,
  TEXTURE_2D_ARRAY: 35866,
  TEXTURE_BINDING_2D_ARRAY: 35869,
  R11F_G11F_B10F: 35898,
  RGB9_E5: 35901,
  RGBA32UI: 36208,
  RGB32UI: 36209,
  RGBA16UI: 36214,
  RGB16UI: 36215,
  RGBA8UI: 36220,
  RGB8UI: 36221,
  RGBA32I: 36226,
  RGB32I: 36227,
  RGBA16I: 36232,
  RGB16I: 36233,
  RGBA8I: 36238,
  RGB8I: 36239,
  RED_INTEGER: 36244,
  RGB_INTEGER: 36248,
  RGBA_INTEGER: 36249,
  R8: 33321,
  RG8: 33323,
  R16F: 33325,
  R32F: 33326,
  RG16F: 33327,
  RG32F: 33328,
  R8I: 33329,
  R8UI: 33330,
  R16I: 33331,
  R16UI: 33332,
  R32I: 33333,
  R32UI: 33334,
  RG8I: 33335,
  RG8UI: 33336,
  RG16I: 33337,
  RG16UI: 33338,
  RG32I: 33339,
  RG32UI: 33340,
  R8_SNORM: 36756,
  RG8_SNORM: 36757,
  RGB8_SNORM: 36758,
  RGBA8_SNORM: 36759,
  RGB10_A2UI: 36975,
  TEXTURE_IMMUTABLE_FORMAT: 37167,
  TEXTURE_IMMUTABLE_LEVELS: 33503,
  UNSIGNED_INT_2_10_10_10_REV: 33640,
  UNSIGNED_INT_10F_11F_11F_REV: 35899,
  UNSIGNED_INT_5_9_9_9_REV: 35902,
  FLOAT_32_UNSIGNED_INT_24_8_REV: 36269,
  UNSIGNED_INT_24_8: 34042,
  HALF_FLOAT: 5131,
  RG: 33319,
  RG_INTEGER: 33320,
  INT_2_10_10_10_REV: 36255,
  CURRENT_QUERY: 34917,
  QUERY_RESULT: 34918,
  QUERY_RESULT_AVAILABLE: 34919,
  ANY_SAMPLES_PASSED: 35887,
  ANY_SAMPLES_PASSED_CONSERVATIVE: 36202,
  MAX_DRAW_BUFFERS: 34852,
  DRAW_BUFFER0: 34853,
  DRAW_BUFFER1: 34854,
  DRAW_BUFFER2: 34855,
  DRAW_BUFFER3: 34856,
  DRAW_BUFFER4: 34857,
  DRAW_BUFFER5: 34858,
  DRAW_BUFFER6: 34859,
  DRAW_BUFFER7: 34860,
  DRAW_BUFFER8: 34861,
  DRAW_BUFFER9: 34862,
  DRAW_BUFFER10: 34863,
  DRAW_BUFFER11: 34864,
  DRAW_BUFFER12: 34865,
  DRAW_BUFFER13: 34866,
  DRAW_BUFFER14: 34867,
  DRAW_BUFFER15: 34868,
  MAX_COLOR_ATTACHMENTS: 36063,
  COLOR_ATTACHMENT1: 36065,
  COLOR_ATTACHMENT2: 36066,
  COLOR_ATTACHMENT3: 36067,
  COLOR_ATTACHMENT4: 36068,
  COLOR_ATTACHMENT5: 36069,
  COLOR_ATTACHMENT6: 36070,
  COLOR_ATTACHMENT7: 36071,
  COLOR_ATTACHMENT8: 36072,
  COLOR_ATTACHMENT9: 36073,
  COLOR_ATTACHMENT10: 36074,
  COLOR_ATTACHMENT11: 36075,
  COLOR_ATTACHMENT12: 36076,
  COLOR_ATTACHMENT13: 36077,
  COLOR_ATTACHMENT14: 36078,
  COLOR_ATTACHMENT15: 36079,
  SAMPLER_3D: 35679,
  SAMPLER_2D_SHADOW: 35682,
  SAMPLER_2D_ARRAY: 36289,
  SAMPLER_2D_ARRAY_SHADOW: 36292,
  SAMPLER_CUBE_SHADOW: 36293,
  INT_SAMPLER_2D: 36298,
  INT_SAMPLER_3D: 36299,
  INT_SAMPLER_CUBE: 36300,
  INT_SAMPLER_2D_ARRAY: 36303,
  UNSIGNED_INT_SAMPLER_2D: 36306,
  UNSIGNED_INT_SAMPLER_3D: 36307,
  UNSIGNED_INT_SAMPLER_CUBE: 36308,
  UNSIGNED_INT_SAMPLER_2D_ARRAY: 36311,
  MAX_SAMPLES: 36183,
  SAMPLER_BINDING: 35097,
  PIXEL_PACK_BUFFER: 35051,
  PIXEL_UNPACK_BUFFER: 35052,
  PIXEL_PACK_BUFFER_BINDING: 35053,
  PIXEL_UNPACK_BUFFER_BINDING: 35055,
  COPY_READ_BUFFER: 36662,
  COPY_WRITE_BUFFER: 36663,
  COPY_READ_BUFFER_BINDING: 36662,
  COPY_WRITE_BUFFER_BINDING: 36663,
  FLOAT_MAT2x3: 35685,
  FLOAT_MAT2x4: 35686,
  FLOAT_MAT3x2: 35687,
  FLOAT_MAT3x4: 35688,
  FLOAT_MAT4x2: 35689,
  FLOAT_MAT4x3: 35690,
  UNSIGNED_INT_VEC2: 36294,
  UNSIGNED_INT_VEC3: 36295,
  UNSIGNED_INT_VEC4: 36296,
  UNSIGNED_NORMALIZED: 35863,
  SIGNED_NORMALIZED: 36764,
  VERTEX_ATTRIB_ARRAY_INTEGER: 35069,
  VERTEX_ATTRIB_ARRAY_DIVISOR: 35070,
  TRANSFORM_FEEDBACK_BUFFER_MODE: 35967,
  MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS: 35968,
  TRANSFORM_FEEDBACK_VARYINGS: 35971,
  TRANSFORM_FEEDBACK_BUFFER_START: 35972,
  TRANSFORM_FEEDBACK_BUFFER_SIZE: 35973,
  TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN: 35976,
  MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS: 35978,
  MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS: 35979,
  INTERLEAVED_ATTRIBS: 35980,
  SEPARATE_ATTRIBS: 35981,
  TRANSFORM_FEEDBACK_BUFFER: 35982,
  TRANSFORM_FEEDBACK_BUFFER_BINDING: 35983,
  TRANSFORM_FEEDBACK: 36386,
  TRANSFORM_FEEDBACK_PAUSED: 36387,
  TRANSFORM_FEEDBACK_ACTIVE: 36388,
  TRANSFORM_FEEDBACK_BINDING: 36389,
  FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING: 33296,
  FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE: 33297,
  FRAMEBUFFER_ATTACHMENT_RED_SIZE: 33298,
  FRAMEBUFFER_ATTACHMENT_GREEN_SIZE: 33299,
  FRAMEBUFFER_ATTACHMENT_BLUE_SIZE: 33300,
  FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE: 33301,
  FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE: 33302,
  FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE: 33303,
  FRAMEBUFFER_DEFAULT: 33304,
  DEPTH24_STENCIL8: 35056,
  DRAW_FRAMEBUFFER_BINDING: 36006,
  READ_FRAMEBUFFER_BINDING: 36010,
  RENDERBUFFER_SAMPLES: 36011,
  FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER: 36052,
  FRAMEBUFFER_INCOMPLETE_MULTISAMPLE: 36182,
  UNIFORM_BUFFER: 35345,
  UNIFORM_BUFFER_BINDING: 35368,
  UNIFORM_BUFFER_START: 35369,
  UNIFORM_BUFFER_SIZE: 35370,
  MAX_VERTEX_UNIFORM_BLOCKS: 35371,
  MAX_FRAGMENT_UNIFORM_BLOCKS: 35373,
  MAX_COMBINED_UNIFORM_BLOCKS: 35374,
  MAX_UNIFORM_BUFFER_BINDINGS: 35375,
  MAX_UNIFORM_BLOCK_SIZE: 35376,
  MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS: 35377,
  MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS: 35379,
  UNIFORM_BUFFER_OFFSET_ALIGNMENT: 35380,
  ACTIVE_UNIFORM_BLOCKS: 35382,
  UNIFORM_TYPE: 35383,
  UNIFORM_SIZE: 35384,
  UNIFORM_BLOCK_INDEX: 35386,
  UNIFORM_OFFSET: 35387,
  UNIFORM_ARRAY_STRIDE: 35388,
  UNIFORM_MATRIX_STRIDE: 35389,
  UNIFORM_IS_ROW_MAJOR: 35390,
  UNIFORM_BLOCK_BINDING: 35391,
  UNIFORM_BLOCK_DATA_SIZE: 35392,
  UNIFORM_BLOCK_ACTIVE_UNIFORMS: 35394,
  UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES: 35395,
  UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER: 35396,
  UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER: 35398,
  OBJECT_TYPE: 37138,
  SYNC_CONDITION: 37139,
  SYNC_STATUS: 37140,
  SYNC_FLAGS: 37141,
  SYNC_FENCE: 37142,
  SYNC_GPU_COMMANDS_COMPLETE: 37143,
  UNSIGNALED: 37144,
  SIGNALED: 37145,
  ALREADY_SIGNALED: 37146,
  TIMEOUT_EXPIRED: 37147,
  CONDITION_SATISFIED: 37148,
  WAIT_FAILED: 37149,
  SYNC_FLUSH_COMMANDS_BIT: 1,
  COLOR: 6144,
  DEPTH: 6145,
  STENCIL: 6146,
  MIN: 32775,
  MAX: 32776,
  DEPTH_COMPONENT24: 33190,
  STREAM_READ: 35041,
  STREAM_COPY: 35042,
  STATIC_READ: 35045,
  STATIC_COPY: 35046,
  DYNAMIC_READ: 35049,
  DYNAMIC_COPY: 35050,
  DEPTH_COMPONENT32F: 36012,
  DEPTH32F_STENCIL8: 36013,
  INVALID_INDEX: 4294967295,
  TIMEOUT_IGNORED: -1,
  MAX_CLIENT_WAIT_TIMEOUT_WEBGL: 37447,
  VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE: 35070,
  UNMASKED_VENDOR_WEBGL: 37445,
  UNMASKED_RENDERER_WEBGL: 37446,
  MAX_TEXTURE_MAX_ANISOTROPY_EXT: 34047,
  TEXTURE_MAX_ANISOTROPY_EXT: 34046,
  COMPRESSED_RGB_S3TC_DXT1_EXT: 33776,
  COMPRESSED_RGBA_S3TC_DXT1_EXT: 33777,
  COMPRESSED_RGBA_S3TC_DXT3_EXT: 33778,
  COMPRESSED_RGBA_S3TC_DXT5_EXT: 33779,
  COMPRESSED_R11_EAC: 37488,
  COMPRESSED_SIGNED_R11_EAC: 37489,
  COMPRESSED_RG11_EAC: 37490,
  COMPRESSED_SIGNED_RG11_EAC: 37491,
  COMPRESSED_RGB8_ETC2: 37492,
  COMPRESSED_RGBA8_ETC2_EAC: 37493,
  COMPRESSED_SRGB8_ETC2: 37494,
  COMPRESSED_SRGB8_ALPHA8_ETC2_EAC: 37495,
  COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2: 37496,
  COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2: 37497,
  COMPRESSED_RGB_PVRTC_4BPPV1_IMG: 35840,
  COMPRESSED_RGBA_PVRTC_4BPPV1_IMG: 35842,
  COMPRESSED_RGB_PVRTC_2BPPV1_IMG: 35841,
  COMPRESSED_RGBA_PVRTC_2BPPV1_IMG: 35843,
  COMPRESSED_RGB_ETC1_WEBGL: 36196,
  COMPRESSED_RGB_ATC_WEBGL: 35986,
  COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL: 35986,
  COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL: 34798,
  UNSIGNED_INT_24_8_WEBGL: 34042,
  HALF_FLOAT_OES: 36193,
  RGBA32F_EXT: 34836,
  RGB32F_EXT: 34837,
  FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE_EXT: 33297,
  UNSIGNED_NORMALIZED_EXT: 35863,
  MIN_EXT: 32775,
  MAX_EXT: 32776,
  SRGB_EXT: 35904,
  SRGB_ALPHA_EXT: 35906,
  SRGB8_ALPHA8_EXT: 35907,
  FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING_EXT: 33296,
  FRAGMENT_SHADER_DERIVATIVE_HINT_OES: 35723,
  COLOR_ATTACHMENT0_WEBGL: 36064,
  COLOR_ATTACHMENT1_WEBGL: 36065,
  COLOR_ATTACHMENT2_WEBGL: 36066,
  COLOR_ATTACHMENT3_WEBGL: 36067,
  COLOR_ATTACHMENT4_WEBGL: 36068,
  COLOR_ATTACHMENT5_WEBGL: 36069,
  COLOR_ATTACHMENT6_WEBGL: 36070,
  COLOR_ATTACHMENT7_WEBGL: 36071,
  COLOR_ATTACHMENT8_WEBGL: 36072,
  COLOR_ATTACHMENT9_WEBGL: 36073,
  COLOR_ATTACHMENT10_WEBGL: 36074,
  COLOR_ATTACHMENT11_WEBGL: 36075,
  COLOR_ATTACHMENT12_WEBGL: 36076,
  COLOR_ATTACHMENT13_WEBGL: 36077,
  COLOR_ATTACHMENT14_WEBGL: 36078,
  COLOR_ATTACHMENT15_WEBGL: 36079,
  DRAW_BUFFER0_WEBGL: 34853,
  DRAW_BUFFER1_WEBGL: 34854,
  DRAW_BUFFER2_WEBGL: 34855,
  DRAW_BUFFER3_WEBGL: 34856,
  DRAW_BUFFER4_WEBGL: 34857,
  DRAW_BUFFER5_WEBGL: 34858,
  DRAW_BUFFER6_WEBGL: 34859,
  DRAW_BUFFER7_WEBGL: 34860,
  DRAW_BUFFER8_WEBGL: 34861,
  DRAW_BUFFER9_WEBGL: 34862,
  DRAW_BUFFER10_WEBGL: 34863,
  DRAW_BUFFER11_WEBGL: 34864,
  DRAW_BUFFER12_WEBGL: 34865,
  DRAW_BUFFER13_WEBGL: 34866,
  DRAW_BUFFER14_WEBGL: 34867,
  DRAW_BUFFER15_WEBGL: 34868,
  MAX_COLOR_ATTACHMENTS_WEBGL: 36063,
  MAX_DRAW_BUFFERS_WEBGL: 34852,
  VERTEX_ARRAY_BINDING_OES: 34229,
  QUERY_COUNTER_BITS_EXT: 34916,
  CURRENT_QUERY_EXT: 34917,
  QUERY_RESULT_EXT: 34918,
  QUERY_RESULT_AVAILABLE_EXT: 34919,
  TIME_ELAPSED_EXT: 35007,
  TIMESTAMP_EXT: 36392,
  GPU_DISJOINT_EXT: 36795
}, AGn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gt
}, Symbol.toStringTag, { value: "Module" })), DVe = /* @__PURE__ */ Fs(AGn), TVe = /* @__PURE__ */ Fs(vfn);
var NVe = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = {
    outlineEnabled: !1,
    outlineRenderShadowmap: !1,
    outlineShadowmap: null
  };
  function n() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e, a = s.outlineEnabled, A = s.outlineRenderShadowmap, l = s.outlineShadowmap, c = {};
    return a !== void 0 && (c.outline_uEnabled = a), A !== void 0 && (c.outline_uRenderOutlines = A), l !== void 0 && (c.outline_uShadowmap = l), c;
  }
  var r = `attribute float instanceZLevel;
varying float outline_vzLevel;
varying vec4 outline_vPosition;

// Set the z level for the outline shadowmap rendering
void outline_setZLevel(float zLevel) {
  outline_vzLevel = zLevel;
}

// Store an adjusted position for texture2DProj
void outline_setUV(vec4 position) {
  // mat4(
  //   0.5, 0.0, 0.0, 0.0,
  //   0.0, 0.5, 0.0, 0.0,
  //   0.0, 0.0, 0.5, 0.0,
  //   0.5, 0.5, 0.5, 1.0
  // ) * position;
  outline_vPosition = vec4(position.xyz * 0.5 + position.w * 0.5, position.w);
}
`, i = `uniform bool outline_uEnabled;
uniform bool outline_uRenderOutlines;
uniform sampler2D outline_uShadowmap;

varying float outline_vzLevel;
// varying vec2 outline_vUV;
varying vec4 outline_vPosition;

const float OUTLINE_Z_LEVEL_ERROR = 0.01;

// Return a darker color in shadowmap
vec4 outline_filterShadowColor(vec4 color) {
  return vec4(outline_vzLevel / 255., outline_vzLevel / 255., outline_vzLevel / 255., 1.);
}

// Return a darker color if in shadowmap
vec4 outline_filterDarkenColor(vec4 color) {
  if (outline_uEnabled) {
    float maxZLevel;
    if (outline_vPosition.q > 0.0) {
      maxZLevel = texture2DProj(outline_uShadowmap, outline_vPosition).r * 255.;
    } else {
      discard;
    }
    if (maxZLevel < outline_vzLevel + OUTLINE_Z_LEVEL_ERROR) {
      vec4(color.rgb * 0.5, color.a);
    } else {
      discard;
    }
  }
  return color;
}

// if enabled and rendering outlines - Render depth to shadowmap
// if enabled and rendering colors - Return a darker color if in shadowmap
// if disabled, just return color
vec4 outline_filterColor(vec4 color) {
  if (outline_uEnabled) {
    return outline_uRenderOutlines ?
      outline_filterShadowColor(color) :
      outline_filterDarkenColor(color);
  }
  return color;
}
`, o = {
    name: "outline",
    vs: r,
    fs: i,
    getUniforms: n
  };
  t.default = o;
})(NVe);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = wE, n = o(DVe), r = TVe, i = o(NVe);
  function o(O) {
    return O && O.__esModule ? O : { default: O };
  }
  function s(O) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? s = function(N) {
      return typeof N;
    } : s = function(N) {
      return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
    }, s(O);
  }
  function a(O, L) {
    if (!(O instanceof L))
      throw new TypeError("Cannot call a class as a function");
  }
  function A(O, L) {
    for (var N = 0; N < L.length; N++) {
      var k = L[N];
      k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(O, k.key, k);
    }
  }
  function l(O, L, N) {
    return L && A(O.prototype, L), N && A(O, N), O;
  }
  function c(O, L, N) {
    return typeof Reflect < "u" && Reflect.get ? c = Reflect.get : c = function($, U, X) {
      var K = u($, U);
      if (K) {
        var z = Object.getOwnPropertyDescriptor(K, U);
        return z.get ? z.get.call(X) : z.value;
      }
    }, c(O, L, N || O);
  }
  function u(O, L) {
    for (; !Object.prototype.hasOwnProperty.call(O, L) && (O = m(O), O !== null); )
      ;
    return O;
  }
  function f(O) {
    return function() {
      var L = m(O), N;
      if (I()) {
        var k = m(this).constructor;
        N = Reflect.construct(L, arguments, k);
      } else
        N = L.apply(this, arguments);
      return h(this, N);
    };
  }
  function h(O, L) {
    return L && (s(L) === "object" || typeof L == "function") ? L : d(O);
  }
  function d(O) {
    if (O === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return O;
  }
  function I() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function m(O) {
    return m = Object.setPrototypeOf ? Object.getPrototypeOf : function(N) {
      return N.__proto__ || Object.getPrototypeOf(N);
    }, m(O);
  }
  function C(O, L) {
    if (typeof L != "function" && L !== null)
      throw new TypeError("Super expression must either be null or a function");
    O.prototype = Object.create(L && L.prototype, { constructor: { value: O, writable: !0, configurable: !0 } }), L && y(O, L);
  }
  function y(O, L) {
    return y = Object.setPrototypeOf || function(k, $) {
      return k.__proto__ = $, k;
    }, y(O, L);
  }
  function v(O, L, N) {
    return L in O ? Object.defineProperty(O, L, { value: N, enumerable: !0, configurable: !0, writable: !0 }) : O[L] = N, O;
  }
  function b(O) {
    var L = O.source, N = O.code, k = N === void 0 ? "" : N, $ = /}[^{}]*$/;
    return L.replace($, k.concat(`
}
`));
  }
  var Q = `  outline_setUV(gl_Position);
  outline_setZLevel(instanceZLevel);
`, w = `  gl_FragColor = outline_filterColor(gl_FragColor);
`, R = {
    getZLevel: {
      type: "accessor",
      value: 0
    }
  }, M = /* @__PURE__ */ function(O) {
    C(N, O);
    var L = f(N);
    function N() {
      return a(this, N), L.apply(this, arguments);
    }
    return l(N, [{
      key: "getShaders",
      // Override getShaders to inject the outline module
      value: function() {
        var $ = c(m(N.prototype), "getShaders", this).call(this);
        return Object.assign({}, $, {
          modules: $.modules.concat([i.default]),
          vs: b({
            source: $.vs,
            code: Q
          }),
          fs: b({
            source: $.fs,
            code: w
          })
        });
      }
    }, {
      key: "initializeState",
      value: function($) {
        c(m(N.prototype), "initializeState", this).call(this, $), this.setState({
          outlineFramebuffer: new r.Framebuffer($.gl),
          dummyTexture: new r.Texture2D($.gl)
        }), this.state.attributeManager.addInstanced({
          instanceZLevel: {
            size: 1,
            type: n.default.UNSIGNED_BYTE,
            update: this.calculateZLevels,
            accessor: "getZLevel"
          }
        });
      }
      // Override draw to add render module
    }, {
      key: "draw",
      value: function($) {
        $.moduleParameters, $.parameters;
        var U = $.uniforms;
        $.context;
        var X = this.props, K = X.rounded, z = X.miterLimit, Y = X.widthScale, V = X.widthMinPixels, Z = X.widthMaxPixels, ce = X.dashJustified;
        U = Object.assign({}, U, {
          jointType: Number(K),
          alignMode: Number(ce),
          widthScale: Y,
          miterLimit: z,
          widthMinPixels: V,
          widthMaxPixels: Z
        });
        var ee = this.state, pe = ee.outlineFramebuffer, Ce = ee.dummyTexture;
        pe.resize(), pe.clear({
          color: !0,
          depth: !0
        }), this.state.model.updateModuleSettings({
          outlineEnabled: !0,
          outlineRenderShadowmap: !0,
          outlineShadowmap: Ce
        }), this.state.model.draw({
          uniforms: Object.assign({}, U, {
            jointType: 0,
            widthScale: this.props.widthScale * 1.3
          }),
          parameters: {
            depthTest: !1,
            // Biggest value needs to go into buffer
            blendEquation: n.default.MAX
          },
          framebuffer: pe
        }), this.state.model.updateModuleSettings({
          outlineEnabled: !0,
          outlineRenderShadowmap: !1,
          outlineShadowmap: pe
        }), this.state.model.draw({
          uniforms: Object.assign({}, U, {
            jointType: Number(K),
            widthScale: this.props.widthScale
          }),
          parameters: {
            depthTest: !1
          }
        });
      }
    }, {
      key: "calculateZLevels",
      value: function($) {
        var U = this.props.getZLevel, X = this.state.pathTesselator;
        $.value = X._updateAttribute({
          target: $.value,
          size: 1,
          getValue: function(z, Y) {
            return [U(z, Y) || 0];
          }
        });
      }
    }]), N;
  }(e.PathLayer);
  t.default = M, v(M, "layerName", "PathOutlineLayer"), v(M, "defaultProps", R);
})(Uue);
var LVe = {};
const lGn = /* @__PURE__ */ Fs(EBn);
var MVe = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = TVe;
  function n(h) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? n = function(I) {
      return typeof I;
    } : n = function(I) {
      return I && typeof Symbol == "function" && I.constructor === Symbol && I !== Symbol.prototype ? "symbol" : typeof I;
    }, n(h);
  }
  function r(h, d) {
    if (!(h instanceof d))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(h) {
    return function() {
      var d = A(h), I;
      if (a()) {
        var m = A(this).constructor;
        I = Reflect.construct(d, arguments, m);
      } else
        I = d.apply(this, arguments);
      return o(this, I);
    };
  }
  function o(h, d) {
    return d && (n(d) === "object" || typeof d == "function") ? d : s(h);
  }
  function s(h) {
    if (h === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return h;
  }
  function a() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function A(h) {
    return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(I) {
      return I.__proto__ || Object.getPrototypeOf(I);
    }, A(h);
  }
  function l(h, d) {
    if (typeof d != "function" && d !== null)
      throw new TypeError("Super expression must either be null or a function");
    h.prototype = Object.create(d && d.prototype, { constructor: { value: h, writable: !0, configurable: !0 } }), d && c(h, d);
  }
  function c(h, d) {
    return c = Object.setPrototypeOf || function(m, C) {
      return m.__proto__ = C, m;
    }, c(h, d);
  }
  var u = /* @__PURE__ */ function(h) {
    l(I, h);
    var d = i(I);
    function I() {
      var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return r(this, I), d.call(this, Object.assign({}, m, {
        attributes: f(m)
      }));
    }
    return I;
  }(e.Geometry);
  t.default = u;
  function f(h) {
    for (var d = h.length, I = d === void 0 ? 1 : d, m = h.headSize, C = m === void 0 ? 0.2 : m, y = h.tailWidth, v = y === void 0 ? 0.05 : y, b = h.tailStart, Q = b === void 0 ? 0.05 : b, w = [
      // HEAD
      0.5,
      1,
      0,
      0.5 - C / 2,
      1 - C,
      0,
      0.5 + C / 2,
      1 - C,
      0,
      0.5 - v / 2,
      Q,
      0,
      0.5 + v / 2,
      1 - C,
      0,
      0.5 + v / 2,
      Q,
      0,
      0.5 - v / 2,
      Q,
      0,
      0.5 - v / 2,
      1 - C,
      0,
      0.5 + v / 2,
      1 - C,
      0
    ], R = [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1], M = new Array(w.length), O = 0; O < w.length / 3; O++) {
      var L = O * 3;
      M[L + 0] = (w[L + 0] - 0.5) * I, M[L + 1] = (w[L + 1] - 0.5) * I, M[L + 2] = 0;
    }
    return {
      positions: new Float32Array(M),
      normals: new Float32Array(R),
      texCoords: new Float32Array(w)
    };
  }
})(MVe);
var OVe = {};
const cGn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Euler: aa,
  Matrix3: ja,
  Matrix4: pn,
  Pose: y_e,
  Quaternion: VC,
  SphericalCoordinates: HS,
  Vector2: n$,
  Vector3: ct,
  Vector4: r$,
  _Euler: aa,
  _MathUtils: $S,
  _Pose: y_e,
  _SphericalCoordinates: HS,
  acos: Pln,
  asin: Fln,
  assert: bf,
  atan: kln,
  clamp: So,
  clone: Nln,
  config: $o,
  configure: Tln,
  cos: Mln,
  degrees: pg,
  equals: ul,
  exactEquals: h$e,
  formatValue: xle,
  isArray: ud,
  lerp: Lf,
  radians: f_,
  sin: Lln,
  tan: Oln,
  toDegrees: g$e,
  toRadians: f$e,
  withEpsilon: Gln
}, Symbol.toStringTag, { value: "Module" })), FVe = /* @__PURE__ */ Fs(cGn);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = A;
  var e = FVe;
  function n(c) {
    if (typeof Symbol > "u" || c[Symbol.iterator] == null) {
      if (Array.isArray(c) || (c = r(c))) {
        var u = 0, f = function() {
        };
        return { s: f, n: function() {
          return u >= c.length ? { done: !0 } : { done: !1, value: c[u++] };
        }, e: function(y) {
          throw y;
        }, f };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var h, d = !0, I = !1, m;
    return { s: function() {
      h = c[Symbol.iterator]();
    }, n: function() {
      var y = h.next();
      return d = y.done, y;
    }, e: function(y) {
      I = !0, m = y;
    }, f: function() {
      try {
        !d && h.return != null && h.return();
      } finally {
        if (I)
          throw m;
      }
    } };
  }
  function r(c, u) {
    if (c) {
      if (typeof c == "string")
        return i(c, u);
      var f = Object.prototype.toString.call(c).slice(8, -1);
      if (f === "Object" && c.constructor && (f = c.constructor.name), f === "Map" || f === "Set")
        return Array.from(f);
      if (f === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(f))
        return i(c, u);
    }
  }
  function i(c, u) {
    (u == null || u > c.length) && (u = c.length);
    for (var f = 0, h = new Array(u); f < u; f++)
      h[f] = c[f];
    return h;
  }
  function o(c) {
    for (var u = 0, f = 0; f < c.length - 1; f++)
      u += c[f].distance(c[f + 1]);
    return u;
  }
  var s = [0, 0, 0, 255], a = {
    forward: !0,
    backward: !1
  };
  function A(c) {
    var u = c.data, f = c.getPath, h = f === void 0 ? function(ce) {
      return ce.path;
    } : f, d = c.getDirection, I = d === void 0 ? function(ce) {
      return ce.direction;
    } : d, m = c.getColor, C = m === void 0 ? function(ce) {
      return s;
    } : m, y = c.getMarkerPercentages, v = y === void 0 ? function(ce) {
      return [0.5];
    } : y, b = c.projectFlat, Q = [], w = n(u), R;
    try {
      for (w.s(); !(R = w.n()).done; ) {
        var M = R.value, O = h(M), L = I(M) || a, N = C(M), k = O.map(function(ce) {
          return new e.Vector2(ce);
        }), $ = k.slice(0).reverse(), U = o(k), X = v(M, {
          lineLength: U
        }), K = n(X), z;
        try {
          for (K.s(); !(z = K.n()).done; ) {
            var Y = z.value;
            if (L.forward) {
              var V = l({
                path: k,
                percentage: Y,
                lineLength: U,
                color: N,
                object: M,
                projectFlat: b
              });
              Q.push(V);
            }
            if (L.backward) {
              var Z = l({
                path: $,
                percentage: Y,
                lineLength: U,
                color: N,
                object: M,
                projectFlat: b
              });
              Q.push(Z);
            }
          }
        } catch (ce) {
          K.e(ce);
        } finally {
          K.f();
        }
      }
    } catch (ce) {
      w.e(ce);
    } finally {
      w.f();
    }
    return Q;
  }
  function l(c) {
    var u = c.path, f = c.percentage, h = c.lineLength, d = c.color, I = c.object, m = c.projectFlat, C = h * f, y = 0, v = 0, b = 0;
    for (b = 0; b < u.length - 1 && (y += u[b].distance(u[b + 1]), !(y > C)); b++)
      v = y;
    var Q = u[b + 1].clone().subtract(u[b]).normalize(), w = C - v, R = Q.clone().multiply(new e.Vector2(w, w)).add(u[b]), M = new e.Vector2(m(u[b + 1])).subtract(m(u[b])), O = M.verticalAngle() * 180 / Math.PI;
    return {
      position: [R.x, R.y, 0],
      angle: O,
      color: d,
      object: I
    };
  }
})(OVe);
var mq = {};
Object.defineProperty(mq, "__esModule", {
  value: !0
});
mq.getClosestPointOnLine = PVe;
mq.getClosestPointOnPolyline = uGn;
var OG = FVe;
function PVe(t) {
  var e = t.p, n = t.p1, r = t.p2, i = t.clampToLine, o = i === void 0 ? !0 : i, s = new OG.Vector3(r).subtract(n), a = new OG.Vector3(e).subtract(n), A = s.dot(a);
  return o && (A = (0, OG.clamp)(A, 0, 1)), s.lerp(A);
}
function uGn(t) {
  var e = t.p, n = t.points;
  e = new OG.Vector3(e);
  for (var r = null, i = 1 / 0, o = -1, s = 0; s < n.length - 1; ++s) {
    var a = n[s], A = n[s + 1], l = PVe({
      p: e,
      p1: a,
      p2: A
    }), c = e.distanceSquared(l);
    c < i && (i = c, r = l, o = s);
  }
  return {
    point: r,
    index: o,
    p1: n[o],
    p2: n[o + 1],
    distanceSquared: i,
    distance: Math.sqrt(i)
  };
}
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = Jw, n = wE, r = lGn, i = A(Uue), o = A(MVe), s = A(OVe), a = mq;
  function A(Y) {
    return Y && Y.__esModule ? Y : { default: Y };
  }
  function l(Y) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? l = function(Z) {
      return typeof Z;
    } : l = function(Z) {
      return Z && typeof Symbol == "function" && Z.constructor === Symbol && Z !== Symbol.prototype ? "symbol" : typeof Z;
    }, l(Y);
  }
  function c(Y, V) {
    return I(Y) || d(Y, V) || f(Y, V) || u();
  }
  function u() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function f(Y, V) {
    if (Y) {
      if (typeof Y == "string")
        return h(Y, V);
      var Z = Object.prototype.toString.call(Y).slice(8, -1);
      if (Z === "Object" && Y.constructor && (Z = Y.constructor.name), Z === "Map" || Z === "Set")
        return Array.from(Z);
      if (Z === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Z))
        return h(Y, V);
    }
  }
  function h(Y, V) {
    (V == null || V > Y.length) && (V = Y.length);
    for (var Z = 0, ce = new Array(V); Z < V; Z++)
      ce[Z] = Y[Z];
    return ce;
  }
  function d(Y, V) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(Y)))) {
      var Z = [], ce = !0, ee = !1, pe = void 0;
      try {
        for (var Ce = Y[Symbol.iterator](), Be; !(ce = (Be = Ce.next()).done) && (Z.push(Be.value), !(V && Z.length === V)); ce = !0)
          ;
      } catch (Ie) {
        ee = !0, pe = Ie;
      } finally {
        try {
          !ce && Ce.return != null && Ce.return();
        } finally {
          if (ee)
            throw pe;
        }
      }
      return Z;
    }
  }
  function I(Y) {
    if (Array.isArray(Y))
      return Y;
  }
  function m(Y, V) {
    if (!(Y instanceof V))
      throw new TypeError("Cannot call a class as a function");
  }
  function C(Y, V) {
    for (var Z = 0; Z < V.length; Z++) {
      var ce = V[Z];
      ce.enumerable = ce.enumerable || !1, ce.configurable = !0, "value" in ce && (ce.writable = !0), Object.defineProperty(Y, ce.key, ce);
    }
  }
  function y(Y, V, Z) {
    return V && C(Y.prototype, V), Z && C(Y, Z), Y;
  }
  function v(Y) {
    return function() {
      var V = R(Y), Z;
      if (w()) {
        var ce = R(this).constructor;
        Z = Reflect.construct(V, arguments, ce);
      } else
        Z = V.apply(this, arguments);
      return b(this, Z);
    };
  }
  function b(Y, V) {
    return V && (l(V) === "object" || typeof V == "function") ? V : Q(Y);
  }
  function Q(Y) {
    if (Y === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return Y;
  }
  function w() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function R(Y) {
    return R = Object.setPrototypeOf ? Object.getPrototypeOf : function(Z) {
      return Z.__proto__ || Object.getPrototypeOf(Z);
    }, R(Y);
  }
  function M(Y, V) {
    if (typeof V != "function" && V !== null)
      throw new TypeError("Super expression must either be null or a function");
    Y.prototype = Object.create(V && V.prototype, { constructor: { value: Y, writable: !0, configurable: !0 } }), V && O(Y, V);
  }
  function O(Y, V) {
    return O = Object.setPrototypeOf || function(ce, ee) {
      return ce.__proto__ = ee, ce;
    }, O(Y, V);
  }
  function L(Y, V, Z) {
    return V in Y ? Object.defineProperty(Y, V, { value: Z, enumerable: !0, configurable: !0, writable: !0 }) : Y[V] = Z, Y;
  }
  var N = 0.1, k = 0.2, $ = 0.05, U = r.SimpleMeshLayer, X = {
    mesh: new o.default({
      headSize: k,
      tailWidth: $
    })
  }, K = Object.assign({}, i.default.defaultProps, {
    MarkerLayer: U,
    markerLayerProps: X,
    sizeScale: 100,
    fp64: !1,
    hightlightIndex: -1,
    highlightPoint: null,
    getPath: function(V) {
      return V.path;
    },
    getColor: function(V) {
      return V.color;
    },
    getMarkerColor: function(V) {
      return [0, 0, 0, 255];
    },
    getDirection: function(V) {
      return V.direction;
    },
    getMarkerPercentages: function(V, Z) {
      var ce = Z.lineLength;
      return ce > N ? [0.25, 0.5, 0.75] : [0.5];
    }
  }), z = /* @__PURE__ */ function(Y) {
    M(Z, Y);
    var V = v(Z);
    function Z() {
      return m(this, Z), V.apply(this, arguments);
    }
    return y(Z, [{
      key: "initializeState",
      value: function() {
        this.state = {
          markers: [],
          mesh: new o.default({
            headSize: k,
            tailWidth: $
          }),
          closestPoint: null
        };
      }
      // @ts-ignore
    }, {
      key: "projectFlat",
      value: function(ee, pe, Ce, Be) {
        if (Ce === e.COORDINATE_SYSTEM.METER_OFFSETS) {
          var Ie = pe.metersToLngLatDelta(ee), Qe = c(Ie, 2), xe = Qe[0], Se = Qe[1], De = c(Be, 2), Ue = De[0], Te = De[1];
          return pe.projectFlat([Ue + xe, Se + Te]);
        } else if (Ce === e.COORDINATE_SYSTEM.LNGLAT_OFFSETS) {
          var se = c(ee, 2), fe = se[0], W = se[1], ge = c(Be, 2), _e = ge[0], Re = ge[1];
          return pe.projectFlat([_e + fe, W + Re]);
        }
        return pe.projectFlat(ee);
      }
    }, {
      key: "updateState",
      value: function(ee) {
        var pe = this, Ce = ee.props, Be = ee.oldProps, Ie = ee.changeFlags;
        if (Ie.dataChanged || Ie.updateTriggersChanged) {
          var Qe = this.props, xe = Qe.data, Se = Qe.getPath, De = Qe.getDirection, Ue = Qe.getMarkerColor, Te = Qe.getMarkerPercentages, se = Qe.coordinateSystem, fe = Qe.coordinateOrigin, W = this.context.viewport, ge = function(Re) {
            return pe.projectFlat(Re, W, se, fe);
          };
          this.state.markers = (0, s.default)({
            data: xe,
            getPath: Se,
            getDirection: De,
            getColor: Ue,
            getMarkerPercentages: Te,
            projectFlat: ge
          }), this._recalculateClosestPoint();
        }
        Ie.propsChanged && Ce.point !== Be.point && this._recalculateClosestPoint();
      }
    }, {
      key: "_recalculateClosestPoint",
      value: function() {
        var ee = this.props, pe = ee.highlightPoint, Ce = ee.highlightIndex;
        if (pe && Ce >= 0) {
          var Be = this.props.data[Ce], Ie = this.props.getPath(Be), Qe = (0, a.getClosestPointOnPolyline)({
            points: Ie,
            p: pe
          }), xe = Qe.point;
          this.state.closestPoints = [{
            position: xe
          }];
        } else
          this.state.closestPoints = [];
      }
    }, {
      key: "getPickingInfo",
      value: function(ee) {
        var pe = ee.info;
        return Object.assign(pe, {
          // override object with picked feature
          object: pe.object && pe.object.path || pe.object
        });
      }
    }, {
      key: "renderLayers",
      value: function() {
        return [new i.default(
          this.props,
          // @ts-ignore
          this.getSubLayerProps({
            id: "paths",
            // Note: data has to be passed explicitly like this to avoid being empty
            data: this.props.data
          })
        ), new this.props.MarkerLayer(this.getSubLayerProps(Object.assign({}, this.props.markerLayerProps, {
          id: "markers",
          data: this.state.markers,
          getOrientation: function(pe) {
            return [0, -pe.angle, 0];
          },
          getColor: function(pe) {
            return pe.color;
          },
          sizeScale: this.props.sizeScale,
          fp64: this.props.fp64,
          pickable: !1,
          parameters: {
            blend: !1,
            depthTest: !1
          }
        }))), this.state.closestPoints && new n.ScatterplotLayer({
          id: "".concat(this.props.id, "-highlight"),
          data: this.state.closestPoints,
          // @ts-ignore
          fp64: this.props.fp64
        })];
      }
    }]), Z;
  }(e.CompositeLayer);
  t.default = z, L(z, "layerName", "PathMarkerLayer"), L(z, "defaultProps", K);
})(LVe);
var kVe = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = Jw, n = wE;
  function r(y) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(b) {
      return typeof b;
    } : r = function(b) {
      return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
    }, r(y);
  }
  function i(y, v) {
    var b = Object.keys(y);
    if (Object.getOwnPropertySymbols) {
      var Q = Object.getOwnPropertySymbols(y);
      v && (Q = Q.filter(function(w) {
        return Object.getOwnPropertyDescriptor(y, w).enumerable;
      })), b.push.apply(b, Q);
    }
    return b;
  }
  function o(y) {
    for (var v = 1; v < arguments.length; v++) {
      var b = arguments[v] != null ? arguments[v] : {};
      v % 2 ? i(Object(b), !0).forEach(function(Q) {
        m(y, Q, b[Q]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(b)) : i(Object(b)).forEach(function(Q) {
        Object.defineProperty(y, Q, Object.getOwnPropertyDescriptor(b, Q));
      });
    }
    return y;
  }
  function s(y, v) {
    if (!(y instanceof v))
      throw new TypeError("Cannot call a class as a function");
  }
  function a(y, v) {
    for (var b = 0; b < v.length; b++) {
      var Q = v[b];
      Q.enumerable = Q.enumerable || !1, Q.configurable = !0, "value" in Q && (Q.writable = !0), Object.defineProperty(y, Q.key, Q);
    }
  }
  function A(y, v, b) {
    return v && a(y.prototype, v), b && a(y, b), y;
  }
  function l(y) {
    return function() {
      var v = h(y), b;
      if (f()) {
        var Q = h(this).constructor;
        b = Reflect.construct(v, arguments, Q);
      } else
        b = v.apply(this, arguments);
      return c(this, b);
    };
  }
  function c(y, v) {
    return v && (r(v) === "object" || typeof v == "function") ? v : u(y);
  }
  function u(y) {
    if (y === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return y;
  }
  function f() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function h(y) {
    return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(b) {
      return b.__proto__ || Object.getPrototypeOf(b);
    }, h(y);
  }
  function d(y, v) {
    if (typeof v != "function" && v !== null)
      throw new TypeError("Super expression must either be null or a function");
    y.prototype = Object.create(v && v.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), v && I(y, v);
  }
  function I(y, v) {
    return I = Object.setPrototypeOf || function(Q, w) {
      return Q.__proto__ = w, Q;
    }, I(y, v);
  }
  function m(y, v, b) {
    return v in y ? Object.defineProperty(y, v, { value: b, enumerable: !0, configurable: !0, writable: !0 }) : y[v] = b, y;
  }
  var C = /* @__PURE__ */ function(y) {
    d(b, y);
    var v = l(b);
    function b() {
      return s(this, b), v.apply(this, arguments);
    }
    return A(b, [{
      key: "renderLayers",
      value: function() {
        var w = this.props, R = w.id, M = w.getFillColor, O = w.getStrokeColor, L = w.getInnerRadius, N = w.updateTriggers;
        return [
          // the full circles
          new n.ScatterplotLayer(o({}, this.props, {
            id: "".concat(R, "-full"),
            data: this.props.data,
            getLineColor: O,
            updateTriggers: o({}, N, {
              getStrokeColor: N.getStrokeColor
            })
          })),
          // the inner part
          new n.ScatterplotLayer(o({}, this.props, {
            id: "".concat(R, "-inner"),
            data: this.props.data,
            getFillColor: M,
            getRadius: L,
            pickable: !1,
            updateTriggers: o({}, N, {
              getFillColor: N.getFillColor,
              getRadius: N.getInnerRadius
            })
          }))
        ];
      }
    }]), b;
  }(e.CompositeLayer);
  t.default = C, m(C, "layerName", "JunctionScatterplotLayer"), m(C, "defaultProps", o({}, n.ScatterplotLayer.defaultProps, {
    getFillColor: function(v) {
      return [0, 0, 0, 255];
    },
    getStrokeColor: function(v) {
      return [255, 255, 255, 255];
    },
    getInnerRadius: function(v) {
      return 1;
    }
  }));
})(kVe);
var LE = {};
Object.defineProperty(LE, "__esModule", {
  value: !0
});
LE.toDeckColor = BGn;
LE.recursivelyTraverseNestedArrays = UVe;
LE.generatePointsParallelToLinePoints = bGn;
LE.distance2d = tre;
LE.mix = HVe;
LE.nearestPointOnProjectedLine = _Gn;
var iRe = Cq(DE), fGn = Cq(zf), gGn = Cq(G$), hGn = ar, dGn = Cq(H7e);
function Cq(t) {
  return t && t.__esModule ? t : { default: t };
}
function yb(t, e) {
  return mGn(t) || IGn(t, e) || GVe(t, e) || pGn();
}
function pGn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function IGn(t, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var n = [], r = !0, i = !1, o = void 0;
    try {
      for (var s = t[Symbol.iterator](), a; !(r = (a = s.next()).done) && (n.push(a.value), !(e && n.length === e)); r = !0)
        ;
    } catch (A) {
      i = !0, o = A;
    } finally {
      try {
        !r && s.return != null && s.return();
      } finally {
        if (i)
          throw o;
      }
    }
    return n;
  }
}
function mGn(t) {
  if (Array.isArray(t))
    return t;
}
function CGn(t) {
  return vGn(t) || yGn(t) || GVe(t) || EGn();
}
function EGn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function GVe(t, e) {
  if (t) {
    if (typeof t == "string")
      return ere(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return ere(t, e);
  }
}
function yGn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function vGn(t) {
  if (Array.isArray(t))
    return ere(t);
}
function ere(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function BGn(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [255, 0, 0, 255];
  return Array.isArray(t) ? [t[0] * 255, t[1] * 255, t[2] * 255, t[3] * 255] : e;
}
function UVe(t, e, n) {
  if (!Array.isArray(t[0]))
    return !0;
  for (var r = 0; r < t.length; r++)
    if (UVe(t[r], [].concat(CGn(e), [r]), n)) {
      n(t, e);
      break;
    }
  return !1;
}
function bGn(t, e, n) {
  var r = {
    type: "LineString",
    coordinates: [t, e]
  }, i = (0, hGn.point)(n), o = (0, gGn.default)(i, r), s = (0, fGn.default)(t, e), a = (n[0] - t[0]) * (e[1] - t[1]) - (n[1] - t[1]) * (e[0] - t[0]), A = a < 0 ? s - 90 : s - 270, l = (0, iRe.default)(e, o, A), c = (0, iRe.default)(t, o, A);
  return [l.geometry.coordinates, c.geometry.coordinates];
}
function tre(t, e, n, r) {
  var i = t - n, o = e - r;
  return Math.sqrt(i * i + o * o);
}
function HVe(t, e, n) {
  return e * n + t * (1 - n);
}
function _Gn(t, e, n) {
  var r = new dGn.default(n), i = t.geometry.coordinates, o = i.map(function(U) {
    var X = yb(U, 3), K = X[0], z = X[1], Y = X[2], V = Y === void 0 ? 0 : Y;
    return r.project([K, z, V]);
  }), s = r.project(e.geometry.coordinates), a = yb(s, 2), A = a[0], l = a[1], c = 1 / 0, u = {};
  o.forEach(function(U, X) {
    var K = yb(U, 2), z = K[0], Y = K[1];
    if (X !== 0) {
      var V = yb(o[X - 1], 2), Z = V[0], ce = V[1], ee = ce - Y, pe = z - Z, Ce = Z * Y - z * ce, Be = ee * ee + pe * pe, Ie = Math.abs(ee * A + pe * l + Ce) / Math.sqrt(Be);
      Ie < c && (c = Ie, u = {
        index: X,
        x0: (pe * (pe * A - ee * l) - ee * Ce) / Be,
        y0: (ee * (-pe * A + ee * l) - pe * Ce) / Be
      });
    }
  });
  var f = u, h = f.index, d = f.x0, I = f.y0, m = yb(o[h - 1], 3), C = m[0], y = m[1], v = m[2], b = v === void 0 ? 0 : v, Q = yb(o[h], 3), w = Q[0], R = Q[1], M = Q[2], O = M === void 0 ? 0 : M, L = tre(C, y, w, R), N = tre(C, y, d, I), k = N / L, $ = HVe(b, O, k);
  return {
    type: "Feature",
    geometry: {
      type: "Point",
      coordinates: r.unproject([d, I, $])
    },
    properties: {
      // TODO: calculate the distance in proper units
      dist: c,
      index: h - 1
    }
  };
}
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "ArrowStyles", {
    enumerable: !0,
    get: function() {
      return e.ArrowStyles;
    }
  }), Object.defineProperty(t, "DEFAULT_ARROWS", {
    enumerable: !0,
    get: function() {
      return e.DEFAULT_ARROWS;
    }
  }), Object.defineProperty(t, "MAX_ARROWS", {
    enumerable: !0,
    get: function() {
      return e.MAX_ARROWS;
    }
  }), Object.defineProperty(t, "EditableGeoJsonLayer", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(t, "EditableH3ClusterLayer", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(t, "SelectionLayer", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  }), Object.defineProperty(t, "ElevatedEditHandleLayer", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  }), Object.defineProperty(t, "PathOutlineLayer", {
    enumerable: !0,
    get: function() {
      return s.default;
    }
  }), Object.defineProperty(t, "PathMarkerLayer", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(t, "JunctionScatterplotLayer", {
    enumerable: !0,
    get: function() {
      return A.default;
    }
  }), Object.defineProperty(t, "toDeckColor", {
    enumerable: !0,
    get: function() {
      return l.toDeckColor;
    }
  });
  var e = QC, n = c(k$), r = c(wVe), i = c(xVe), o = c(RVe), s = c(Uue), a = c(LVe), A = c(kVe), l = LE;
  function c(u) {
    return u && u.__esModule ? u : { default: u };
  }
})(RM);
var u1 = {};
Object.defineProperty(u1, "__esModule", {
  value: !0
});
u1.toDeckColor = DGn;
u1.recursivelyTraverseNestedArrays = $Ve;
function SGn(t) {
  return RGn(t) || xGn(t) || wGn(t) || QGn();
}
function QGn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wGn(t, e) {
  if (t) {
    if (typeof t == "string")
      return nre(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return nre(t, e);
  }
}
function xGn(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t))
    return Array.from(t);
}
function RGn(t) {
  if (Array.isArray(t))
    return nre(t);
}
function nre(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function DGn(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [255, 0, 0, 255];
  return Array.isArray(t) ? [t[0] * 255, t[1] * 255, t[2] * 255, t[3] * 255] : e;
}
function $Ve(t, e, n) {
  if (!Array.isArray(t[0]))
    return !0;
  for (var r = 0; r < t.length; r++)
    if ($Ve(t[r], [].concat(SGn(e), [r]), n)) {
      n(t, e);
      break;
    }
  return !1;
}
var Eq = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  function e(s, a) {
    if (!(s instanceof a))
      throw new TypeError("Cannot call a class as a function");
  }
  function n(s, a) {
    for (var A = 0; A < a.length; A++) {
      var l = a[A];
      l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(s, l.key, l);
    }
  }
  function r(s, a, A) {
    return a && n(s.prototype, a), A && n(s, A), s;
  }
  function i(s, a, A) {
    return a in s ? Object.defineProperty(s, a, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : s[a] = A, s;
  }
  var o = /* @__PURE__ */ function() {
    function s(a, A) {
      e(this, s), i(this, "objects", void 0), i(this, "originals", void 0), i(this, "updateTrigger", void 0), i(this, "_idToPosition", void 0), i(this, "_getData", void 0), i(this, "_convert", void 0), this.objects = [], this.originals = [], this.updateTrigger = 0, this._idToPosition = /* @__PURE__ */ new Map(), this._getData = a, this._convert = A;
    }
    return r(s, [{
      key: "updateAllDeckObjects",
      value: function() {
        var A = this;
        !this._getData || !this._convert || (this.originals.length = 0, this.objects.length = 0, this._idToPosition.clear(), this._getData().forEach(function(l) {
          A._idToPosition.set(l.id, A.objects.length), A.originals.push(l), A.objects.push(A._convert(l));
        }), this.triggerUpdate());
      }
    }, {
      key: "updateDeckObjectsByIds",
      value: function(A) {
        var l = this;
        !this._getData || !this._convert || (A.forEach(function(c) {
          var u = l._idToPosition.get(c);
          u !== void 0 && (l.objects[u] = l._convert(l.originals[u]));
        }), this.triggerUpdate());
      }
    }, {
      key: "triggerUpdate",
      value: function() {
        this.updateTrigger++;
      }
    }, {
      key: "getDeckObjectById",
      value: function(A) {
        var l = this._idToPosition.get(A);
        return l !== void 0 ? this.objects[l] : null;
      }
    }, {
      key: "getOriginalById",
      value: function(A) {
        var l = this._idToPosition.get(A);
        return l !== void 0 ? this.originals[l] : null;
      }
    }]), s;
  }();
  t.default = o;
})(Eq);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = RM, n = o($w), r = u1, i = o(Eq);
  function o(v) {
    return v && v.__esModule ? v : { default: v };
  }
  function s(v) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? s = function(Q) {
      return typeof Q;
    } : s = function(Q) {
      return Q && typeof Symbol == "function" && Q.constructor === Symbol && Q !== Symbol.prototype ? "symbol" : typeof Q;
    }, s(v);
  }
  function a(v, b) {
    if (!(v instanceof b))
      throw new TypeError("Cannot call a class as a function");
  }
  function A(v, b) {
    for (var Q = 0; Q < b.length; Q++) {
      var w = b[Q];
      w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(v, w.key, w);
    }
  }
  function l(v, b, Q) {
    return b && A(v.prototype, b), Q && A(v, Q), v;
  }
  function c(v) {
    return function() {
      var b = d(v), Q;
      if (h()) {
        var w = d(this).constructor;
        Q = Reflect.construct(b, arguments, w);
      } else
        Q = b.apply(this, arguments);
      return u(this, Q);
    };
  }
  function u(v, b) {
    return b && (s(b) === "object" || typeof b == "function") ? b : f(v);
  }
  function f(v) {
    if (v === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return v;
  }
  function h() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function d(v) {
    return d = Object.setPrototypeOf ? Object.getPrototypeOf : function(Q) {
      return Q.__proto__ || Object.getPrototypeOf(Q);
    }, d(v);
  }
  function I(v, b) {
    if (typeof b != "function" && b !== null)
      throw new TypeError("Super expression must either be null or a function");
    v.prototype = Object.create(b && b.prototype, { constructor: { value: v, writable: !0, configurable: !0 } }), b && m(v, b);
  }
  function m(v, b) {
    return m = Object.setPrototypeOf || function(w, R) {
      return w.__proto__ = R, w;
    }, m(v, b);
  }
  function C(v, b, Q) {
    return b in v ? Object.defineProperty(v, b, { value: Q, enumerable: !0, configurable: !0, writable: !0 }) : v[b] = Q, v;
  }
  var y = /* @__PURE__ */ function(v) {
    I(Q, v);
    var b = c(Q);
    function Q(w) {
      var R;
      return a(this, Q), R = b.call(this, w), C(f(R), "deckCache", void 0), R.deckCache = new i.default(w.getData, function(M) {
        return w.toNebulaFeature(M);
      }), R.enablePicking = !0, R;
    }
    return l(Q, [{
      key: "render",
      value: function(R) {
        R.nebula;
        var M = [0, 0, 0, 255], O = this.deckCache, L = O.objects, N = O.updateTrigger;
        return new e.JunctionScatterplotLayer({
          id: "junctions-".concat(this.id),
          data: L,
          opacity: 1,
          // @ts-ignore
          fp64: !1,
          pickable: !0,
          getPosition: function($) {
            return $.geoJson.geometry.coordinates;
          },
          getFillColor: function($) {
            return (0, r.toDeckColor)($.style.fillColor) || M;
          },
          getStrokeColor: function($) {
            return (0, r.toDeckColor)($.style.outlineColor) || (0, r.toDeckColor)($.style.fillColor) || M;
          },
          getRadius: function($) {
            return $.style.pointRadiusMeters + $.style.outlineRadiusMeters || 1;
          },
          getInnerRadius: function($) {
            return $.style.pointRadiusMeters || 0.5;
          },
          parameters: {
            depthTest: !1,
            blend: !1
          },
          updateTriggers: {
            all: N
          },
          nebulaLayer: this
        });
      }
    }]), Q;
  }(n.default);
  t.default = y;
})(N7e);
var qVe = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = wE, n = o($w), r = u1, i = o(Eq);
  function o(v) {
    return v && v.__esModule ? v : { default: v };
  }
  function s(v) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? s = function(Q) {
      return typeof Q;
    } : s = function(Q) {
      return Q && typeof Symbol == "function" && Q.constructor === Symbol && Q !== Symbol.prototype ? "symbol" : typeof Q;
    }, s(v);
  }
  function a(v, b) {
    if (!(v instanceof b))
      throw new TypeError("Cannot call a class as a function");
  }
  function A(v, b) {
    for (var Q = 0; Q < b.length; Q++) {
      var w = b[Q];
      w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(v, w.key, w);
    }
  }
  function l(v, b, Q) {
    return b && A(v.prototype, b), Q && A(v, Q), v;
  }
  function c(v) {
    return function() {
      var b = d(v), Q;
      if (h()) {
        var w = d(this).constructor;
        Q = Reflect.construct(b, arguments, w);
      } else
        Q = b.apply(this, arguments);
      return u(this, Q);
    };
  }
  function u(v, b) {
    return b && (s(b) === "object" || typeof b == "function") ? b : f(v);
  }
  function f(v) {
    if (v === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return v;
  }
  function h() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function d(v) {
    return d = Object.setPrototypeOf ? Object.getPrototypeOf : function(Q) {
      return Q.__proto__ || Object.getPrototypeOf(Q);
    }, d(v);
  }
  function I(v, b) {
    if (typeof b != "function" && b !== null)
      throw new TypeError("Super expression must either be null or a function");
    v.prototype = Object.create(b && b.prototype, { constructor: { value: v, writable: !0, configurable: !0 } }), b && m(v, b);
  }
  function m(v, b) {
    return m = Object.setPrototypeOf || function(w, R) {
      return w.__proto__ = R, w;
    }, m(v, b);
  }
  function C(v, b, Q) {
    return b in v ? Object.defineProperty(v, b, { value: Q, enumerable: !0, configurable: !0, writable: !0 }) : v[b] = Q, v;
  }
  var y = /* @__PURE__ */ function(v) {
    I(Q, v);
    var b = c(Q);
    function Q(w) {
      var R;
      return a(this, Q), R = b.call(this, w), C(f(R), "deckCache", void 0), R.deckCache = new i.default(w.getData, function(M) {
        return w.toNebulaFeature(M);
      }), R;
    }
    return l(Q, [{
      key: "render",
      value: function(R) {
        var M = R.nebula, O = [0, 0, 0, 255], L = this.deckCache, N = L.objects, k = L.updateTrigger, $ = M.props.viewport.zoom;
        return new e.TextLayer({
          id: "texts-".concat(this.id),
          data: N,
          opacity: 1,
          fp64: !1,
          pickable: !1,
          getText: function(X) {
            return X.style.text;
          },
          getPosition: function(X) {
            return X.geoJson.geometry.coordinates;
          },
          // @ts-ignore
          getColor: function(X) {
            return (0, r.toDeckColor)(X.style.fillColor) || O;
          },
          // TODO: layer should offer option to scale with zoom
          sizeScale: 1 / Math.pow(2, 20 - $),
          updateTriggers: {
            all: k
          },
          nebulaLayer: this
        });
      }
    }]), Q;
  }(n.default);
  t.default = y;
})(qVe);
var jVe = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = RM, n = DVe, r = zh, i = A($w), o = u1, s = A(Eq), a;
  function A(R) {
    return R && R.__esModule ? R : { default: R };
  }
  function l(R) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? l = function(O) {
      return typeof O;
    } : l = function(O) {
      return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
    }, l(R);
  }
  function c(R, M) {
    if (!(R instanceof M))
      throw new TypeError("Cannot call a class as a function");
  }
  function u(R, M) {
    for (var O = 0; O < M.length; O++) {
      var L = M[O];
      L.enumerable = L.enumerable || !1, L.configurable = !0, "value" in L && (L.writable = !0), Object.defineProperty(R, L.key, L);
    }
  }
  function f(R, M, O) {
    return M && u(R.prototype, M), O && u(R, O), R;
  }
  function h(R) {
    return function() {
      var M = C(R), O;
      if (m()) {
        var L = C(this).constructor;
        O = Reflect.construct(M, arguments, L);
      } else
        O = M.apply(this, arguments);
      return d(this, O);
    };
  }
  function d(R, M) {
    return M && (l(M) === "object" || typeof M == "function") ? M : I(R);
  }
  function I(R) {
    if (R === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return R;
  }
  function m() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function C(R) {
    return C = Object.setPrototypeOf ? Object.getPrototypeOf : function(O) {
      return O.__proto__ || Object.getPrototypeOf(O);
    }, C(R);
  }
  function y(R, M) {
    if (typeof M != "function" && M !== null)
      throw new TypeError("Super expression must either be null or a function");
    R.prototype = Object.create(M && M.prototype, { constructor: { value: R, writable: !0, configurable: !0 } }), M && v(R, M);
  }
  function v(R, M) {
    return v = Object.setPrototypeOf || function(L, N) {
      return L.__proto__ = N, L;
    }, v(R, M);
  }
  function b(R, M, O) {
    return M in R ? Object.defineProperty(R, M, { value: O, enumerable: !0, configurable: !0, writable: !0 }) : R[M] = O, R;
  }
  var Q = (a = {}, b(a, r.ArrowStyles.NONE, {
    forward: !1,
    backward: !1
  }), b(a, r.ArrowStyles.FORWARD, {
    forward: !0,
    backward: !1
  }), b(a, r.ArrowStyles.BACKWARD, {
    forward: !1,
    backward: !0
  }), b(a, r.ArrowStyles.BOTH, {
    forward: !0,
    backward: !0
  }), a), w = /* @__PURE__ */ function(R) {
    y(O, R);
    var M = h(O);
    function O(L) {
      var N;
      c(this, O), N = M.call(this, L), b(I(N), "deckCache", void 0), b(I(N), "noBlend", void 0), b(I(N), "highlightColor", void 0), b(I(N), "arrowSize", void 0), b(I(N), "rounded", void 0), b(I(N), "dashed", void 0), b(I(N), "markerLayerProps", void 0), N.deckCache = new s.default(L.getData, function(ee) {
        return L.toNebulaFeature(ee);
      }), N.enableSelection = !0;
      var k = L.enablePicking, $ = k === void 0 ? !0 : k, U = L.noBlend, X = U === void 0 ? !1 : U, K = L.rounded, z = K === void 0 ? !0 : K, Y = L.dashed, V = Y === void 0 ? !1 : Y, Z = L.markerLayerProps, ce = Z === void 0 ? null : Z;
      return Object.assign(I(N), {
        enablePicking: $,
        noBlend: X,
        rounded: z,
        dashed: V,
        markerLayerProps: ce
      }), N;
    }
    return f(O, [{
      key: "getMouseOverSegment",
      value: function() {
        return null;
      }
    }, {
      key: "_calcMarkerPercentages",
      value: function(N) {
        var k = N.style.arrowPercentages;
        if (k)
          return k;
        var $ = N.style.arrowStyle || r.DEFAULT_STYLE.arrowStyle;
        if ($ === r.ArrowStyles.NONE)
          return [];
        var U = Math.min(N.style.arrowCount || r.DEFAULT_STYLE.arrowCount, r.MAX_ARROWS);
        return [[0.5], [0.33, 0.66], [0.25, 0.5, 0.75]][U - 1];
      }
    }, {
      key: "_getHighlightedObjectIndex",
      value: function(N) {
        var k = N.nebula, $ = k.deckglMouseOverInfo;
        if ($) {
          var U = $.originalLayer, X = $.index;
          if (U === this)
            return X;
        }
        return -1;
      }
    }, {
      key: "render",
      value: function(N) {
        var k = N.nebula, $ = [0, 0, 0, 255], U = this.deckCache, X = U.objects, K = U.updateTrigger;
        return new e.PathMarkerLayer({
          id: "segments-".concat(this.id),
          data: X,
          opacity: 1,
          // @ts-ignore
          fp64: !1,
          rounded: this.rounded,
          pickable: !0,
          sizeScale: this.arrowSize || 6,
          parameters: {
            depthTest: !1,
            blend: !this.noBlend,
            blendEquation: n.GL.MAX
          },
          getPath: function(Y) {
            return Y.geoJson.geometry.coordinates;
          },
          // @ts-ignore
          getColor: function(Y) {
            return (0, o.toDeckColor)(Y.style.lineColor, $);
          },
          getWidth: function(Y) {
            return Y.style.lineWidthMeters || 1;
          },
          getZLevel: function(Y) {
            return Y.style.zLevel * 255;
          },
          getDirection: function(Y) {
            return Q[Y.style.arrowStyle];
          },
          // @ts-ignore
          getMarkerColor: function(Y) {
            return (0, o.toDeckColor)(Y.style.arrowColor, $);
          },
          getMarkerPercentages: this._calcMarkerPercentages,
          updateTriggers: {
            all: K
          },
          highlightedObjectIndex: this._getHighlightedObjectIndex({
            nebula: k
          }),
          highlightColor: (0, o.toDeckColor)(this.highlightColor),
          dashJustified: this.dashed,
          getDashArray: this.dashed ? function(z) {
            return z.style.dashArray;
          } : null,
          markerLayerProps: this.markerLayerProps || e.PathMarkerLayer.defaultProps.markerLayerProps,
          nebulaLayer: this
        });
      }
    }]), O;
  }(i.default);
  t.default = w;
})(jVe);
var YVe = {};
const TGn = /* @__PURE__ */ Fs(u9e);
var oRe = typeof ei < "u" ? ei : typeof window < "u" ? window : {}, NGn = TGn, FR;
typeof document < "u" ? FR = document : (FR = oRe["__GLOBAL_DOCUMENT_CACHE@4"], FR || (FR = oRe["__GLOBAL_DOCUMENT_CACHE@4"] = NGn));
var LGn = FR;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var e = x7e, n = a(LGn), r = Jw, i = a(Kce), o = a(due), s = a($w);
  function a(b) {
    return b && b.__esModule ? b : { default: b };
  }
  function A(b) {
    return f(b) || u(b) || c(b) || l();
  }
  function l() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function c(b, Q) {
    if (b) {
      if (typeof b == "string")
        return h(b, Q);
      var w = Object.prototype.toString.call(b).slice(8, -1);
      if (w === "Object" && b.constructor && (w = b.constructor.name), w === "Map" || w === "Set")
        return Array.from(w);
      if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w))
        return h(b, Q);
    }
  }
  function u(b) {
    if (typeof Symbol < "u" && Symbol.iterator in Object(b))
      return Array.from(b);
  }
  function f(b) {
    if (Array.isArray(b))
      return h(b);
  }
  function h(b, Q) {
    (Q == null || Q > b.length) && (Q = b.length);
    for (var w = 0, R = new Array(Q); w < Q; w++)
      R[w] = b[w];
    return R;
  }
  function d(b, Q) {
    if (!(b instanceof Q))
      throw new TypeError("Cannot call a class as a function");
  }
  function I(b, Q) {
    for (var w = 0; w < Q.length; w++) {
      var R = Q[w];
      R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(b, R.key, R);
    }
  }
  function m(b, Q, w) {
    return Q && I(b.prototype, Q), w && I(b, w), b;
  }
  function C(b, Q, w) {
    return Q in b ? Object.defineProperty(b, Q, { value: w, enumerable: !0, configurable: !0, writable: !0 }) : b[Q] = w, b;
  }
  var y = "Nebula: ", v = /* @__PURE__ */ function() {
    function b() {
      var Q = this;
      d(this, b), C(this, "props", void 0), C(this, "deckgl", void 0), C(this, "mainContainer", void 0), C(this, "deckglMouseOverInfo", void 0), C(this, "_deckDrawer", void 0), C(this, "_mouseWasDown", void 0), C(this, "wmViewport", void 0), C(this, "queryObjectEvents", new e.EventEmitter()), C(this, "forceUpdate", void 0), C(this, "inited", void 0), C(this, "_onMouseEvent", function(w) {
        if (Q._isNebulaEvent(w)) {
          w.type === "mousedown" && (Q._mouseWasDown = !0);
          var R = Q.mainContainer ? Q.mainContainer.getBoundingClientRect() : {}, M = R.top, O = M === void 0 ? 0 : M, L = R.left, N = L === void 0 ? 0 : L, k = new Proxy(w, {
            get: function(U, X) {
              if (X === "offsetX")
                return U.pageX - N;
              if (X === "offsetY")
                return U.pageY - O;
              if (X === "type")
                return U.type.replace("pointer", "mouse");
              var K = U[X];
              return typeof K == "function" ? K.bind(U) : K;
            }
          });
          Q._handleDeckGLEvent(k);
        }
      });
    }
    return m(b, [{
      key: "init",
      value: function(w) {
        var R = this;
        this.props = w, this.wmViewport = new r.WebMercatorViewport(this.props.viewport), ["click", "mousemove", "mouseup", "mousedown"].forEach(function(M) {
          return n.default.addEventListener(M, R._onMouseEvent, !0);
        });
      }
    }, {
      key: "detach",
      value: function() {
        var w = this;
        ["click", "mousemove", "mouseup", "mousedown"].forEach(function(R) {
          return n.default.removeEventListener(R, w._onMouseEvent, !0);
        });
      }
    }, {
      key: "updateProps",
      value: function(w) {
        this.props = w;
        var R = this.props.viewport;
        this.wmViewport = new r.WebMercatorViewport(R);
      }
    }, {
      key: "log",
      value: function(w) {
        var R = this.props.logger;
        R && R.info && R.info(y + w);
      }
    }, {
      key: "updateAllDeckObjects",
      value: function() {
        this.getAllLayers().forEach(function(w) {
          w && w.deckCache && w.deckCache.updateAllDeckObjects();
        }), this.forceUpdate();
      }
    }, {
      key: "updateDeckObjectsByIds",
      value: function(w) {
        this.getAllLayers().forEach(function(R) {
          R && R.deckCache && R.deckCache.updateDeckObjectsByIds(w);
        }), this.forceUpdate();
      }
    }, {
      key: "rerenderLayers",
      value: function() {
        this.updateAllDeckObjects();
      }
    }, {
      key: "_isNebulaEvent",
      value: function(w) {
        var R = w.buttons, M = w.target, O = w.type, L = this.props.viewport;
        if (this._mouseWasDown && O === "mouseup")
          return this._mouseWasDown = !1, !0;
        if (O === "mousemove" && R > 0)
          return !0;
        if (!M.getBoundingClientRect)
          return !1;
        var N = M.getBoundingClientRect();
        return Math.round(N.width) === Math.round(L.width) && Math.round(N.height) === Math.round(L.height);
      }
    }, {
      key: "getMouseGroundPosition",
      value: function(w) {
        return this.wmViewport.unproject([w.offsetX, w.offsetY]);
      }
    }, {
      key: "unprojectMousePosition",
      value: function(w) {
        return this.wmViewport.unproject(w);
      }
    }, {
      key: "_handleDeckGLEvent",
      value: function(w) {
        var R = this.deckgl, M = this.props, O = M.onMapMouseEvent, L = M.selectionType, N = M.eventFilter, k = !0, $ = "auto";
        if (w && R && L) {
          this._deckDrawer || (this._deckDrawer = new i.default(this));
          var U = this.getMouseGroundPosition(w);
          if (N && !N(U, w))
            return;
          var X = this._deckDrawer.handleEvent(w, U, L);
          X.redraw && this.forceUpdate();
          return;
        }
        if (w && R && (!w.buttons || w.type !== "mousemove")) {
          var K = R.props.layers.filter(function(Ie) {
            return Ie && Ie.props && Ie.props.nebulaLayer && Ie.props.nebulaLayer.enablePicking;
          }).map(function(Ie) {
            return Ie.id;
          }), z = R.pickObject({
            x: w.offsetX,
            y: w.offsetY,
            radius: 5,
            layerIds: K
          });
          if (this.queryObjectEvents.emit("pick", {
            event: w,
            pickingInfo: z
          }), z) {
            k = !1;
            var Y = z.index, V = z.lngLat;
            if (N && !N(V, w))
              return;
            var Z = z.layer, ce = z.object;
            Z && Z.props && Z.props.nebulaLayer && Z.props.nebulaLayer.eventHandler && Z.props.nebulaLayer.eventHandler(w, z);
            var ee = ce.original || Z.props.nebulaLayer && Z.props.nebulaLayer.deckCache && Z.props.nebulaLayer.deckCache.originals[Y];
            if (ee) {
              this.deckglMouseOverInfo = {
                originalLayer: Z.props.nebulaLayer,
                index: Y
              };
              var pe = new o.default(w, {
                data: ee,
                metadata: ce.metadata,
                groundPoint: V,
                nebula: this
              });
              Z.props.nebulaLayer.emit(w.type, pe), this.forceUpdate();
            }
            $ = "pointer";
          }
        }
        if (n.default.documentElement && (n.default.documentElement.style.cursor = $), k) {
          this.deckglMouseOverInfo = null;
          var Ce = this.getMouseGroundPosition(w);
          if (N && !N(Ce, w))
            return;
          var Be = new o.default(w, {
            groundPoint: Ce,
            nebula: this
          });
          this.getAllLayers().filter(function(Ie) {
            return Ie && Ie.usesMapEvents;
          }).forEach(function(Ie) {
            return Ie.emit("mapMouseEvent", Be);
          }), this.getAllLayers().filter(function(Ie) {
            return Ie && Ie.props && Ie.props.nebulaLayer && Ie.props.nebulaLayer.mapMouseEvent;
          }).forEach(function(Ie) {
            return Ie.props.nebulaLayer.mapMouseEvent(Be, Ie);
          }), O && O(w, Ce);
        }
      }
    }, {
      key: "getExtraDeckLayers",
      value: function() {
        var w = [];
        return this._deckDrawer && w.push.apply(w, A(this._deckDrawer.render())), w;
      }
    }, {
      key: "renderDeckLayers",
      value: function() {
        var w = this;
        return this.getAllLayers().map(function(R) {
          return R instanceof s.default ? R.render({
            nebula: w
          }) : R;
        }).filter(Boolean);
      }
    }, {
      key: "getAllLayers",
      value: function() {
        var w = [];
        return this.props.layers.filter(Boolean).forEach(function(R) {
          w.push(R), R instanceof s.default && w.push.apply(w, A(R.helperLayers));
        }), w.filter(Boolean);
      }
    }, {
      key: "getRenderedLayers",
      value: function() {
        return [].concat(A(this.renderDeckLayers()), A(this.getExtraDeckLayers()));
      }
    }, {
      key: "updateAndGetRenderedLayers",
      value: function(w, R, M) {
        return this.inited ? (this.updateProps({
          layers: w,
          viewport: R
        }), this.forceUpdate = function() {
          return M.forceUpdate();
        }) : (this.inited = !0, this.init({
          layers: w,
          viewport: R
        }), this.forceUpdate = function() {
          return M.forceUpdate();
        }, this.updateAllDeckObjects()), this.getRenderedLayers();
      }
    }, {
      key: "setDeck",
      value: function(w) {
        w && (this.deckgl = w);
      }
    }, {
      key: "setMainContainer",
      value: function(w) {
        w && (this.mainContainer = w);
      }
    }]), b;
  }();
  t.default = v;
})(YVe);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "ArrowStyles", {
    enumerable: !0,
    get: function() {
      return e.ArrowStyles;
    }
  }), Object.defineProperty(t, "DEFAULT_ARROWS", {
    enumerable: !0,
    get: function() {
      return e.DEFAULT_ARROWS;
    }
  }), Object.defineProperty(t, "MAX_ARROWS", {
    enumerable: !0,
    get: function() {
      return e.MAX_ARROWS;
    }
  }), Object.defineProperty(t, "SELECTION_TYPE", {
    enumerable: !0,
    get: function() {
      return n.SELECTION_TYPE;
    }
  }), Object.defineProperty(t, "Feature", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(t, "LayerMouseEvent", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  }), Object.defineProperty(t, "NebulaLayer", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  }), Object.defineProperty(t, "JunctionsLayer", {
    enumerable: !0,
    get: function() {
      return s.default;
    }
  }), Object.defineProperty(t, "TextsLayer", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(t, "SegmentsLayer", {
    enumerable: !0,
    get: function() {
      return A.default;
    }
  }), Object.defineProperty(t, "NebulaCore", {
    enumerable: !0,
    get: function() {
      return l.default;
    }
  }), Object.defineProperty(t, "toDeckColor", {
    enumerable: !0,
    get: function() {
      return c.toDeckColor;
    }
  }), Object.defineProperty(t, "EditableGeoJsonLayer", {
    enumerable: !0,
    get: function() {
      return u.EditableGeoJsonLayer;
    }
  }), Object.defineProperty(t, "SelectionLayer", {
    enumerable: !0,
    get: function() {
      return u.SelectionLayer;
    }
  }), Object.defineProperty(t, "ElevatedEditHandleLayer", {
    enumerable: !0,
    get: function() {
      return u.ElevatedEditHandleLayer;
    }
  }), Object.defineProperty(t, "PathOutlineLayer", {
    enumerable: !0,
    get: function() {
      return u.PathOutlineLayer;
    }
  }), Object.defineProperty(t, "PathMarkerLayer", {
    enumerable: !0,
    get: function() {
      return u.PathMarkerLayer;
    }
  }), Object.defineProperty(t, "GeoJsonEditMode", {
    enumerable: !0,
    get: function() {
      return f.GeoJsonEditMode;
    }
  }), Object.defineProperty(t, "ModifyMode", {
    enumerable: !0,
    get: function() {
      return f.ModifyMode;
    }
  }), Object.defineProperty(t, "ResizeCircleMode", {
    enumerable: !0,
    get: function() {
      return f.ResizeCircleMode;
    }
  }), Object.defineProperty(t, "TranslateMode", {
    enumerable: !0,
    get: function() {
      return f.TranslateMode;
    }
  }), Object.defineProperty(t, "ScaleMode", {
    enumerable: !0,
    get: function() {
      return f.ScaleMode;
    }
  }), Object.defineProperty(t, "RotateMode", {
    enumerable: !0,
    get: function() {
      return f.RotateMode;
    }
  }), Object.defineProperty(t, "DuplicateMode", {
    enumerable: !0,
    get: function() {
      return f.DuplicateMode;
    }
  }), Object.defineProperty(t, "ExtendLineStringMode", {
    enumerable: !0,
    get: function() {
      return f.ExtendLineStringMode;
    }
  }), Object.defineProperty(t, "SplitPolygonMode", {
    enumerable: !0,
    get: function() {
      return f.SplitPolygonMode;
    }
  }), Object.defineProperty(t, "ExtrudeMode", {
    enumerable: !0,
    get: function() {
      return f.ExtrudeMode;
    }
  }), Object.defineProperty(t, "ElevationMode", {
    enumerable: !0,
    get: function() {
      return f.ElevationMode;
    }
  }), Object.defineProperty(t, "TransformMode", {
    enumerable: !0,
    get: function() {
      return f.TransformMode;
    }
  }), Object.defineProperty(t, "DrawPointMode", {
    enumerable: !0,
    get: function() {
      return f.DrawPointMode;
    }
  }), Object.defineProperty(t, "DrawLineStringMode", {
    enumerable: !0,
    get: function() {
      return f.DrawLineStringMode;
    }
  }), Object.defineProperty(t, "DrawPolygonMode", {
    enumerable: !0,
    get: function() {
      return f.DrawPolygonMode;
    }
  }), Object.defineProperty(t, "DrawRectangleMode", {
    enumerable: !0,
    get: function() {
      return f.DrawRectangleMode;
    }
  }), Object.defineProperty(t, "DrawSquareFromCenterMode", {
    enumerable: !0,
    get: function() {
      return f.DrawSquareFromCenterMode;
    }
  }), Object.defineProperty(t, "DrawCircleByDiameterMode", {
    enumerable: !0,
    get: function() {
      return f.DrawCircleByDiameterMode;
    }
  }), Object.defineProperty(t, "DrawCircleFromCenterMode", {
    enumerable: !0,
    get: function() {
      return f.DrawCircleFromCenterMode;
    }
  }), Object.defineProperty(t, "DrawEllipseByBoundingBoxMode", {
    enumerable: !0,
    get: function() {
      return f.DrawEllipseByBoundingBoxMode;
    }
  }), Object.defineProperty(t, "DrawEllipseUsingThreePointsMode", {
    enumerable: !0,
    get: function() {
      return f.DrawEllipseUsingThreePointsMode;
    }
  }), Object.defineProperty(t, "DrawRectangleUsingThreePointsMode", {
    enumerable: !0,
    get: function() {
      return f.DrawRectangleUsingThreePointsMode;
    }
  }), Object.defineProperty(t, "Draw90DegreePolygonMode", {
    enumerable: !0,
    get: function() {
      return f.Draw90DegreePolygonMode;
    }
  }), Object.defineProperty(t, "DrawPolygonByDraggingMode", {
    enumerable: !0,
    get: function() {
      return f.DrawPolygonByDraggingMode;
    }
  }), Object.defineProperty(t, "ImmutableFeatureCollection", {
    enumerable: !0,
    get: function() {
      return f.ImmutableFeatureCollection;
    }
  }), Object.defineProperty(t, "ViewMode", {
    enumerable: !0,
    get: function() {
      return f.ViewMode;
    }
  }), Object.defineProperty(t, "MeasureDistanceMode", {
    enumerable: !0,
    get: function() {
      return f.MeasureDistanceMode;
    }
  }), Object.defineProperty(t, "MeasureAreaMode", {
    enumerable: !0,
    get: function() {
      return f.MeasureAreaMode;
    }
  }), Object.defineProperty(t, "MeasureAngleMode", {
    enumerable: !0,
    get: function() {
      return f.MeasureAngleMode;
    }
  }), Object.defineProperty(t, "CompositeMode", {
    enumerable: !0,
    get: function() {
      return f.CompositeMode;
    }
  }), Object.defineProperty(t, "SnappableMode", {
    enumerable: !0,
    get: function() {
      return f.SnappableMode;
    }
  });
  var e = zh, n = Kce, r = h(E7e), i = h(due), o = h($w), s = h(N7e), a = h(qVe), A = h(jVe), l = h(YVe), c = u1, u = RM, f = s1;
  function h(d) {
    return d && d.__esModule ? d : { default: d };
  }
})(jU);
const MGn = "addFeature", zVe = "clearFeatures";
class OGn extends s1.DrawPolygonByDraggingMode {
  // eslint-disable-next-line class-methods-use-this
  handleClick(e, n) {
    n.onEdit({ editType: zVe });
  }
}
const FGn = {
  [jU.SELECTION_TYPE.POLYGON]: OGn
}, PGn = {
  layerIds: [],
  onSelect: () => {
  }
}, kGn = {
  type: "FeatureCollection",
  features: []
}, GGn = "selection-geojson", UGn = [
  "lineWidthScale",
  "lineWidthMinPixels",
  "lineWidthMaxPixels",
  "lineWidthUnits",
  "lineJointRounded",
  "lineMiterLimit",
  "pointRadiusScale",
  "pointRadiusMinPixels",
  "pointRadiusMaxPixels",
  "lineDashJustified",
  "getLineColor",
  "getFillColor",
  "getPointRadius",
  "getLineWidth",
  "getLineDashArray",
  "getTentativeLineDashArray",
  "getTentativeLineColor",
  "getTentativeFillColor",
  "getTentativeLineWidth",
  "editHandlePointRadiusScale",
  "editHandlePointRadiusMinPixels",
  "editHandlePointRadiusMaxPixels",
  "getEditHandlePointColor",
  "getEditHandlePointRadius",
  "modeHandlers"
];
class Hue extends mA {
  _selectPolygonObjects(e) {
    const { flipY: n, obsLayers: r } = this.props, i = n ? e.map((s) => s.map((a) => [a[0], -a[1]])) : e, o = ST(i);
    r.forEach((s) => {
      const { getObsCoords: a, obsQuadTree: A, obsIndex: l, onSelect: c } = s, u = [];
      A?.visit((h, d, I, m, C) => {
        const v = ST([[[d, I], [m, I], [m, C], [d, C], [d, I]]]), b = GSn(v, o), Q = DSn(v, o), w = Xwn(v, o);
        return !b && !Q && !w ? !0 : (h.data && Tg(jl([].slice.call(a(h.data))), o) && u.push(h.data), !1);
      });
      const f = u.map((h) => l[h]);
      c(f);
    });
  }
  _selectEmpty() {
    const { obsLayers: e } = this.props;
    e.forEach((n) => {
      const { onSelect: r } = n;
      r([]);
    });
  }
  renderLayers() {
    const e = FGn[this.props.selectionType] || s1.ViewMode, n = {};
    return UGn.forEach((i) => {
      this.props[i] !== void 0 && (n[i] = this.props[i]);
    }), [
      new RM.EditableGeoJsonLayer(this.getSubLayerProps({
        id: GGn,
        pickable: !0,
        mode: e,
        modeConfig: {
          dragToDraw: !0
        },
        selectedFeatureIndexes: [],
        data: kGn,
        onEdit: ({ updatedData: i, editType: o }) => {
          if (o === MGn) {
            const { coordinates: s } = i.features[0].geometry;
            this._selectPolygonObjects(s);
          } else
            o === zVe && this._selectEmpty();
        },
        _subLayerProps: {
          guides: {
            pointType: "circle",
            _subLayerProps: {
              "points-circle": {
                // Styling for editHandles goes here.
                // Reference: https://github.com/uber/nebula.gl/issues/618#issuecomment-898466319
                type: LI,
                radiusScale: 1,
                stroked: !0,
                getLineWidth: 1,
                radiusMinPixels: 1,
                radiusMaxPixels: 3,
                getPointRadius: 2
              }
            }
          }
        },
        ...n
      }))
    ];
  }
}
Hue.layerName = "SelectionLayer";
Hue.defaultProps = PGn;
function HGn(t) {
  return `base-${t}`;
}
const $Gn = ({ pickingInfos: t }) => {
};
function $ue(t, e, n, r, i = !1) {
  if (!t)
    return [];
  const o = HGn(n), s = 5 / (e + 16);
  return new Hue({
    id: "selection",
    flipY: i,
    obsLayers: r,
    coordinateSystem: wn.CARTESIAN,
    selectionType: t,
    // This onSelect is no longer used since
    // the obsLayers each have their own onSelect.
    onSelect: $Gn,
    layerIds: [o],
    getTentativeFillColor: () => [255, 255, 255, 95],
    getTentativeLineColor: () => [143, 143, 143, 255],
    getTentativeLineDashArray: () => [7, 4],
    lineWidthMinPixels: 2,
    lineWidthMaxPixels: 2,
    getEditHandlePointColor: () => [255, 255, 255, 255],
    getEditHandlePointRadius: () => s,
    editHandlePointRadiusScale: 1,
    editHandlePointRadiusMinPixels: s,
    editHandlePointRadiusMaxPixels: 2 * s
  });
}
const Sa = 4096, vg = 4096, sRe = 1, aRe = 16, Qh = 20, Zb = 11, ARe = 15, lRe = 12, cRe = 120, zm = 3, uRe = 10, R2 = {
  dark: [224, 224, 224],
  light: [64, 64, 64]
}, e_ = "-apple-system, 'Helvetica Neue', Arial, sans-serif", yq = {
  // NEAREST for integer data to prevent interpolation.
  [gt.TEXTURE_MIN_FILTER]: gt.NEAREST,
  [gt.TEXTURE_MAG_FILTER]: gt.NEAREST,
  // CLAMP_TO_EDGE to remove tile artifacts.
  [gt.TEXTURE_WRAP_S]: gt.CLAMP_TO_EDGE,
  [gt.TEXTURE_WRAP_T]: gt.CLAMP_TO_EDGE
}, ME = [
  "plasma",
  "viridis",
  "jet"
], u0 = "plasma", lB = "COLORMAP_FUNC", qGn = { webgl2: !0 }, kM = `#define GLSLIFY 1
vec4 plasma (float x_4) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.050980392156862744,0.03137254901960784,0.5294117647058824,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.29411764705882354,0.011764705882352941,0.6313725490196078,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.49019607843137253,0.011764705882352941,0.6588235294117647,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.6588235294117647,0.13333333333333333,0.5882352941176471,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.796078431372549,0.27450980392156865,0.4745098039215686,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.8980392156862745,0.4196078431372549,0.36470588235294116,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.9725490196078431,0.5803921568627451,0.2549019607843137,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.9921568627450981,0.7647058823529411,0.1568627450980392,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9411764705882353,0.9764705882352941,0.12941176470588237,1);
  float a0 = smoothstep(e0,e1,x_4);
  float a1 = smoothstep(e1,e2,x_4);
  float a2 = smoothstep(e2,e3,x_4);
  float a3 = smoothstep(e3,e4,x_4);
  float a4 = smoothstep(e4,e5,x_4);
  float a5 = smoothstep(e5,e6,x_4);
  float a6 = smoothstep(e6,e7,x_4);
  float a7 = smoothstep(e7,e8,x_4);
  return max(mix(v0,v1,a0)*step(e0,x_4)*step(x_4,e1),
    max(mix(v1,v2,a1)*step(e1,x_4)*step(x_4,e2),
    max(mix(v2,v3,a2)*step(e2,x_4)*step(x_4,e3),
    max(mix(v3,v4,a3)*step(e3,x_4)*step(x_4,e4),
    max(mix(v4,v5,a4)*step(e4,x_4)*step(x_4,e5),
    max(mix(v5,v6,a5)*step(e5,x_4)*step(x_4,e6),
    max(mix(v6,v7,a6)*step(e6,x_4)*step(x_4,e7),mix(v7,v8,a7)*step(e7,x_4)*step(x_4,e8)
  )))))));
}

vec4 viridis (float x_1) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.26666666666666666,0.00392156862745098,0.32941176470588235,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.2784313725490196,0.17254901960784313,0.47843137254901963,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.23137254901960785,0.3176470588235294,0.5450980392156862,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.17254901960784313,0.44313725490196076,0.5568627450980392,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.12941176470588237,0.5647058823529412,0.5529411764705883,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.15294117647058825,0.6784313725490196,0.5058823529411764,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.3607843137254902,0.7843137254901961,0.38823529411764707,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.6666666666666666,0.8627450980392157,0.19607843137254902,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9921568627450981,0.9058823529411765,0.1450980392156863,1);
  float a0 = smoothstep(e0,e1,x_1);
  float a1 = smoothstep(e1,e2,x_1);
  float a2 = smoothstep(e2,e3,x_1);
  float a3 = smoothstep(e3,e4,x_1);
  float a4 = smoothstep(e4,e5,x_1);
  float a5 = smoothstep(e5,e6,x_1);
  float a6 = smoothstep(e6,e7,x_1);
  float a7 = smoothstep(e7,e8,x_1);
  return max(mix(v0,v1,a0)*step(e0,x_1)*step(x_1,e1),
    max(mix(v1,v2,a1)*step(e1,x_1)*step(x_1,e2),
    max(mix(v2,v3,a2)*step(e2,x_1)*step(x_1,e3),
    max(mix(v3,v4,a3)*step(e3,x_1)*step(x_1,e4),
    max(mix(v4,v5,a4)*step(e4,x_1)*step(x_1,e5),
    max(mix(v5,v6,a5)*step(e5,x_1)*step(x_1,e6),
    max(mix(v6,v7,a6)*step(e6,x_1)*step(x_1,e7),mix(v7,v8,a7)*step(e7,x_1)*step(x_1,e8)
  )))))));
}

vec4 greys (float x_10) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0,1);
  const float e1 = 1.0;
  const vec4 v1 = vec4(1,1,1,1);
  float a0 = smoothstep(e0,e1,x_10);
  return mix(v0,v1,a0)*step(e0,x_10)*step(x_10,e1);
}

vec4 magma (float x_7) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0.01568627450980392,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.10980392156862745,0.06274509803921569,0.26666666666666666,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.30980392156862746,0.07058823529411765,0.4823529411764706,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.5058823529411764,0.1450980392156863,0.5058823529411764,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.7098039215686275,0.21176470588235294,0.47843137254901963,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.8980392156862745,0.3137254901960784,0.39215686274509803,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.984313725490196,0.5294117647058824,0.3803921568627451,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.996078431372549,0.7607843137254902,0.5294117647058824,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9882352941176471,0.9921568627450981,0.7490196078431373,1);
  float a0 = smoothstep(e0,e1,x_7);
  float a1 = smoothstep(e1,e2,x_7);
  float a2 = smoothstep(e2,e3,x_7);
  float a3 = smoothstep(e3,e4,x_7);
  float a4 = smoothstep(e4,e5,x_7);
  float a5 = smoothstep(e5,e6,x_7);
  float a6 = smoothstep(e6,e7,x_7);
  float a7 = smoothstep(e7,e8,x_7);
  return max(mix(v0,v1,a0)*step(e0,x_7)*step(x_7,e1),
    max(mix(v1,v2,a1)*step(e1,x_7)*step(x_7,e2),
    max(mix(v2,v3,a2)*step(e2,x_7)*step(x_7,e3),
    max(mix(v3,v4,a3)*step(e3,x_7)*step(x_7,e4),
    max(mix(v4,v5,a4)*step(e4,x_7)*step(x_7,e5),
    max(mix(v5,v6,a5)*step(e5,x_7)*step(x_7,e6),
    max(mix(v6,v7,a6)*step(e6,x_7)*step(x_7,e7),mix(v7,v8,a7)*step(e7,x_7)*step(x_7,e8)
  )))))));
}

vec4 jet (float x_8) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0.5137254901960784,1);
  const float e1 = 0.125;
  const vec4 v1 = vec4(0,0.23529411764705882,0.6666666666666666,1);
  const float e2 = 0.375;
  const vec4 v2 = vec4(0.0196078431372549,1,1,1);
  const float e3 = 0.625;
  const vec4 v3 = vec4(1,1,0,1);
  const float e4 = 0.875;
  const vec4 v4 = vec4(0.9803921568627451,0,0,1);
  const float e5 = 1.0;
  const vec4 v5 = vec4(0.5019607843137255,0,0,1);
  float a0 = smoothstep(e0,e1,x_8);
  float a1 = smoothstep(e1,e2,x_8);
  float a2 = smoothstep(e2,e3,x_8);
  float a3 = smoothstep(e3,e4,x_8);
  float a4 = smoothstep(e4,e5,x_8);
  return max(mix(v0,v1,a0)*step(e0,x_8)*step(x_8,e1),
    max(mix(v1,v2,a1)*step(e1,x_8)*step(x_8,e2),
    max(mix(v2,v3,a2)*step(e2,x_8)*step(x_8,e3),
    max(mix(v3,v4,a3)*step(e3,x_8)*step(x_8,e4),mix(v4,v5,a4)*step(e4,x_8)*step(x_8,e5)
  ))));
}

vec4 bone (float x_11) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0,1);
  const float e1 = 0.376;
  const vec4 v1 = vec4(0.32941176470588235,0.32941176470588235,0.4549019607843137,1);
  const float e2 = 0.753;
  const vec4 v2 = vec4(0.6627450980392157,0.7843137254901961,0.7843137254901961,1);
  const float e3 = 1.0;
  const vec4 v3 = vec4(1,1,1,1);
  float a0 = smoothstep(e0,e1,x_11);
  float a1 = smoothstep(e1,e2,x_11);
  float a2 = smoothstep(e2,e3,x_11);
  return max(mix(v0,v1,a0)*step(e0,x_11)*step(x_11,e1),
    max(mix(v1,v2,a1)*step(e1,x_11)*step(x_11,e2),mix(v2,v3,a2)*step(e2,x_11)*step(x_11,e3)
  ));
}

vec4 copper (float x_6) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0,1);
  const float e1 = 0.804;
  const vec4 v1 = vec4(1,0.6274509803921569,0.4,1);
  const float e2 = 1.0;
  const vec4 v2 = vec4(1,0.7803921568627451,0.4980392156862745,1);
  float a0 = smoothstep(e0,e1,x_6);
  float a1 = smoothstep(e1,e2,x_6);
  return max(mix(v0,v1,a0)*step(e0,x_6)*step(x_6,e1),mix(v1,v2,a1)*step(e1,x_6)*step(x_6,e2)
  );
}

vec4 density (float x_5) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.21176470588235294,0.054901960784313725,0.1411764705882353,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.34901960784313724,0.09019607843137255,0.3137254901960784,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.43137254901960786,0.17647058823529413,0.5176470588235295,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.47058823529411764,0.30196078431372547,0.6980392156862745,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.47058823529411764,0.44313725490196076,0.8352941176470589,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.45098039215686275,0.592156862745098,0.8941176470588236,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.5254901960784314,0.7254901960784313,0.8901960784313725,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.6941176470588235,0.8392156862745098,0.8901960784313725,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9019607843137255,0.9450980392156862,0.9450980392156862,1);
  float a0 = smoothstep(e0,e1,x_5);
  float a1 = smoothstep(e1,e2,x_5);
  float a2 = smoothstep(e2,e3,x_5);
  float a3 = smoothstep(e3,e4,x_5);
  float a4 = smoothstep(e4,e5,x_5);
  float a5 = smoothstep(e5,e6,x_5);
  float a6 = smoothstep(e6,e7,x_5);
  float a7 = smoothstep(e7,e8,x_5);
  return max(mix(v0,v1,a0)*step(e0,x_5)*step(x_5,e1),
    max(mix(v1,v2,a1)*step(e1,x_5)*step(x_5,e2),
    max(mix(v2,v3,a2)*step(e2,x_5)*step(x_5,e3),
    max(mix(v3,v4,a3)*step(e3,x_5)*step(x_5,e4),
    max(mix(v4,v5,a4)*step(e4,x_5)*step(x_5,e5),
    max(mix(v5,v6,a5)*step(e5,x_5)*step(x_5,e6),
    max(mix(v6,v7,a6)*step(e6,x_5)*step(x_5,e7),mix(v7,v8,a7)*step(e7,x_5)*step(x_5,e8)
  )))))));
}

vec4 inferno (float x_3) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0.01568627450980392,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.12156862745098039,0.047058823529411764,0.2823529411764706,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.3333333333333333,0.058823529411764705,0.42745098039215684,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.5333333333333333,0.13333333333333333,0.41568627450980394,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.7294117647058823,0.21176470588235294,0.3333333333333333,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.8901960784313725,0.34901960784313724,0.2,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.9764705882352941,0.5490196078431373,0.0392156862745098,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.9764705882352941,0.788235294117647,0.19607843137254902,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9882352941176471,1,0.6431372549019608,1);
  float a0 = smoothstep(e0,e1,x_3);
  float a1 = smoothstep(e1,e2,x_3);
  float a2 = smoothstep(e2,e3,x_3);
  float a3 = smoothstep(e3,e4,x_3);
  float a4 = smoothstep(e4,e5,x_3);
  float a5 = smoothstep(e5,e6,x_3);
  float a6 = smoothstep(e6,e7,x_3);
  float a7 = smoothstep(e7,e8,x_3);
  return max(mix(v0,v1,a0)*step(e0,x_3)*step(x_3,e1),
    max(mix(v1,v2,a1)*step(e1,x_3)*step(x_3,e2),
    max(mix(v2,v3,a2)*step(e2,x_3)*step(x_3,e3),
    max(mix(v3,v4,a3)*step(e3,x_3)*step(x_3,e4),
    max(mix(v4,v5,a4)*step(e4,x_3)*step(x_3,e5),
    max(mix(v5,v6,a5)*step(e5,x_3)*step(x_3,e6),
    max(mix(v6,v7,a6)*step(e6,x_3)*step(x_3,e7),mix(v7,v8,a7)*step(e7,x_3)*step(x_3,e8)
  )))))));
}

vec4 cool (float x_2) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.49019607843137253,0,0.7019607843137254,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.4549019607843137,0,0.8549019607843137,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.3843137254901961,0.2901960784313726,0.9294117647058824,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.26666666666666666,0.5725490196078431,0.9058823529411765,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0,0.8,0.7725490196078432,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0,0.9686274509803922,0.5725490196078431,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0,1,0.34509803921568627,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.1568627450980392,1,0.03137254901960784,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.5764705882352941,1,0,1);
  float a0 = smoothstep(e0,e1,x_2);
  float a1 = smoothstep(e1,e2,x_2);
  float a2 = smoothstep(e2,e3,x_2);
  float a3 = smoothstep(e3,e4,x_2);
  float a4 = smoothstep(e4,e5,x_2);
  float a5 = smoothstep(e5,e6,x_2);
  float a6 = smoothstep(e6,e7,x_2);
  float a7 = smoothstep(e7,e8,x_2);
  return max(mix(v0,v1,a0)*step(e0,x_2)*step(x_2,e1),
    max(mix(v1,v2,a1)*step(e1,x_2)*step(x_2,e2),
    max(mix(v2,v3,a2)*step(e2,x_2)*step(x_2,e3),
    max(mix(v3,v4,a3)*step(e3,x_2)*step(x_2,e4),
    max(mix(v4,v5,a4)*step(e4,x_2)*step(x_2,e5),
    max(mix(v5,v6,a5)*step(e5,x_2)*step(x_2,e6),
    max(mix(v6,v7,a6)*step(e6,x_2)*step(x_2,e7),mix(v7,v8,a7)*step(e7,x_2)*step(x_2,e8)
  )))))));
}

vec4 hot (float x_0) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0,1);
  const float e1 = 0.3;
  const vec4 v1 = vec4(0.9019607843137255,0,0,1);
  const float e2 = 0.6;
  const vec4 v2 = vec4(1,0.8235294117647058,0,1);
  const float e3 = 1.0;
  const vec4 v3 = vec4(1,1,1,1);
  float a0 = smoothstep(e0,e1,x_0);
  float a1 = smoothstep(e1,e2,x_0);
  float a2 = smoothstep(e2,e3,x_0);
  return max(mix(v0,v1,a0)*step(e0,x_0)*step(x_0,e1),
    max(mix(v1,v2,a1)*step(e1,x_0)*step(x_0,e2),mix(v2,v3,a2)*step(e2,x_0)*step(x_0,e3)
  ));
}

vec4 spring (float x_14) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(1,0,1,1);
  const float e1 = 1.0;
  const vec4 v1 = vec4(1,1,0,1);
  float a0 = smoothstep(e0,e1,x_14);
  return mix(v0,v1,a0)*step(e0,x_14)*step(x_14,e1);
}

vec4 summer (float x_9) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0.5019607843137255,0.4,1);
  const float e1 = 1.0;
  const vec4 v1 = vec4(1,1,0.4,1);
  float a0 = smoothstep(e0,e1,x_9);
  return mix(v0,v1,a0)*step(e0,x_9)*step(x_9,e1);
}

vec4 autumn (float x_13) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(1,0,0,1);
  const float e1 = 1.0;
  const vec4 v1 = vec4(1,1,0,1);
  float a0 = smoothstep(e0,e1,x_13);
  return mix(v0,v1,a0)*step(e0,x_13)*step(x_13,e1);
}

vec4 winter (float x_12) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,1,1);
  const float e1 = 1.0;
  const vec4 v1 = vec4(0,1,0.5019607843137255,1);
  float a0 = smoothstep(e0,e1,x_12);
  return mix(v0,v1,a0)*step(e0,x_12)*step(x_12,e1);
}
`, jGn = `
#define SHADER_NAME heatmap-bitmap-layer-vertex-shader

attribute vec2 texCoords;
attribute vec3 positions;
attribute vec3 positions64Low;

varying vec2 vTexCoord;

const vec3 pickingColor = vec3(1.0, 0.0, 0.0);

void main(void) {
  geometry.worldPosition = positions;
  geometry.uv = texCoords;
  geometry.pickingColor = pickingColor;

  gl_Position = project_position_to_clipspace(positions, positions64Low, vec3(0.0), geometry.position);
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  vTexCoord = texCoords;

  vec4 color = vec4(0.0);
  DECKGL_FILTER_COLOR(color, geometry);
}
`, fRe = `
#define SHADER_NAME heatmap-bitmap-layer-fragment-shader

#ifdef GL_ES
precision mediump float;
#endif

${kM}

// The texture (GL.LUMINANCE & Uint8Array).
uniform sampler2D uBitmapTexture;

// What are the dimensions of the texture (width, height)?
uniform vec2 uTextureSize;

// How many consecutive pixels should be aggregated together along each axis?
uniform vec2 uAggSize;

// What are the values of the color scale sliders?
uniform vec2 uColorScaleRange;

// The texture coordinate, varying (interpolated between values set by the vertex shader).
varying vec2 vTexCoord;

void main(void) {
  // Compute 1 pixel in texture coordinates
  vec2 onePixel = vec2(1.0, 1.0) / uTextureSize;
  
  vec2 viewCoord = vec2(floor(vTexCoord.x * uTextureSize.x), floor(vTexCoord.y * uTextureSize.y));

  // Compute (x % aggSizeX, y % aggSizeY).
  // These values will be the number of values to the left / above the current position to consider.
  vec2 modAggSize = vec2(-1.0 * mod(viewCoord.x, uAggSize.x), -1.0 * mod(viewCoord.y, uAggSize.y));

  // Take the sum of values along each axis.
  float intensitySum = 0.0;
  vec2 offsetPixels = vec2(0.0, 0.0);

  for(int i = 0; i < 16; i++) {
    // Check to break outer loop early.
    // Uniforms cannot be used as conditions in GLSL for loops.
    if(float(i) >= uAggSize.y) {
      // Done in the y direction.
      break;
    }

    offsetPixels = vec2(offsetPixels.x, (modAggSize.y + float(i)) * onePixel.y);

    for(int j = 0; j < 16; j++) {
      // Check to break inner loop early.
      // Uniforms cannot be used as conditions in GLSL for loops.
      if(float(j) >= uAggSize.x) {
        // Done in the x direction.
        break;
      }

      offsetPixels = vec2((modAggSize.x + float(j)) * onePixel.x, offsetPixels.y);
      intensitySum += texture2D(uBitmapTexture, vTexCoord + offsetPixels).r;
    }
  }
  
  // Compute the mean value.
  float intensityMean = intensitySum / (uAggSize.x * uAggSize.y);
  
  // Re-scale using the color scale slider values.
  float scaledIntensityMean = (intensityMean - uColorScaleRange[0]) / max(0.005, (uColorScaleRange[1] - uColorScaleRange[0]));

  gl_FragColor = COLORMAP_FUNC(clamp(scaledIntensityMean, 0.0, 1.0));

  geometry.uv = vTexCoord;
  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`, YGn = {
  image: { type: "object", value: null, async: !0 },
  colormap: { type: "string", value: u0, compare: !0 },
  bounds: { type: "array", value: [1, 0, 0, 1], compare: !0 },
  aggSizeX: { type: "number", value: 8, compare: !0 },
  aggSizeY: { type: "number", value: 8, compare: !0 },
  colorScaleLo: { type: "number", value: 0, compare: !0 },
  colorScaleHi: { type: "number", value: 1, compare: !0 }
};
class que extends em {
  /**
   * Copy of getShaders from Layer (grandparent, parent of BitmapLayer).
   * Reference: https://github.com/visgl/deck.gl/blob/0afd4e99a6199aeec979989e0c361c97e6c17a16/modules/core/src/lib/layer.js#L302
   * @param {object} shaders
   * @returns {object} Merged shaders.
   */
  // eslint-disable-next-line no-underscore-dangle
  _getShaders(e) {
    return this.props.extensions.forEach((n) => {
      e = f$(e, n.getShaders.call(this, n));
    }), e;
  }
  /**
   * Need to override to provide custom shaders.
   */
  getShaders() {
    const { colormap: e } = this.props, n = ME.includes(e) ? fRe.replace(lB, e) : fRe.replace(lB, u0);
    return this._getShaders({
      vs: jGn,
      fs: n,
      modules: [qA, jA]
    });
  }
  updateState(e) {
    super.updateState(e), this.loadTexture(this.props.image);
    const { props: n, oldProps: r } = e;
    if (n.colormap !== r.colormap) {
      const { gl: i } = this.context;
      this.state.model?.delete(), this.state.model = this._getModel(i), this.getAttributeManager().invalidateAll();
    }
  }
  /**
   * Need to override to provide additional uniform values.
   * Simplified by removing video-related code.
   * Reference: https://github.com/visgl/deck.gl/blob/0afd4e99a6199aeec979989e0c361c97e6c17a16/modules/layers/src/bitmap-layer/bitmap-layer.js#L173
   * @param {*} opts
   */
  draw(e) {
    const { uniforms: n } = e, { bitmapTexture: r, model: i } = this.state, { aggSizeX: o, aggSizeY: s, colorScaleLo: a, colorScaleHi: A } = this.props;
    r && i && i.setUniforms(Object.assign({}, n, {
      uBitmapTexture: r,
      uTextureSize: [Sa, Sa],
      uAggSize: [o, s],
      uColorScaleRange: [a, A]
    })).draw();
  }
  /**
   * Need to override to provide the custom DEFAULT_TEXTURE_PARAMETERS
   * object.
   * Simplified by removing video-related code.
   * Reference: https://github.com/visgl/deck.gl/blob/0afd4e99a6199aeec979989e0c361c97e6c17a16/modules/layers/src/bitmap-layer/bitmap-layer.js#L218
   * @param {Uint8Array} image
   */
  loadTexture(e) {
    const { gl: n } = this.context;
    this.state.bitmapTexture && this.state.bitmapTexture.delete(), e instanceof xo ? this.setState({
      bitmapTexture: e
    }) : e && this.setState({
      bitmapTexture: new xo(n, {
        data: e,
        mipmaps: !1,
        parameters: yq,
        // Each color contains a single luminance value.
        // When sampled, rgb are all set to this luminance, alpha is 1.0.
        // Reference: https://luma.gl/docs/api-reference/webgl/texture#texture-formats
        format: gt.LUMINANCE,
        dataFormat: gt.LUMINANCE,
        type: gt.UNSIGNED_BYTE,
        width: Sa,
        height: Sa
      })
    });
  }
}
que.layerName = "HeatmapBitmapLayer";
que.defaultProps = YGn;
const zGn = {
  ...em.defaultProps,
  image: { type: "object", value: null, async: !0 },
  bounds: { type: "array", value: [1, 0, 0, 1], compare: !0 },
  desaturate: {
    type: "number",
    min: 0,
    max: 1,
    value: 0
  },
  transparentColor: { type: "color", value: [0, 0, 0, 0] },
  tintColor: { type: "color", value: [255, 255, 255] }
};
class jue extends mA {
  renderLayers() {
    const { image: e } = this.props;
    return new em(this.props, {
      id: `${this.props.id}-wrapped`,
      image: e,
      textureParameters: yq
    });
  }
}
jue.layerName = "PixelatedBitmapLayer";
jue.defaultProps = zGn;
class FG extends mA {
  _renderAxisTopLayers() {
    const { axisTopLabelData: e, matrixLeft: n, width: r, matrixWidth: i, viewWidth: o, theme: s, targetX: a, targetY: A, axisTopTitle: l, cellWidth: c, axisOffsetTop: u, scaleFactor: f, hideTopLabels: h } = this.props, d = c >= Zb, I = A + (u - zm) / 2 / f;
    return h ? [] : [
      new Eg({
        id: "axisTopLabels",
        coordinateSystem: wn.CARTESIAN,
        data: e,
        getText: (m) => m[1],
        getPosition: (m) => [n + (m[0] + 0.5) / r * i, I],
        getTextAnchor: "start",
        getColor: () => R2[s],
        getSize: d ? Zb : 0,
        getAngle: 75,
        fontFamily: e_,
        updateTriggers: {
          getPosition: [I, n, i, o],
          getSize: [d],
          getColor: [s]
        }
      }),
      new Eg({
        id: "axisTopTitle",
        coordinateSystem: wn.CARTESIAN,
        data: [{ title: l }],
        getText: (m) => m.title,
        getPosition: [a, A],
        getTextAnchor: "middle",
        getColor: () => R2[s],
        getSize: d ? 0 : ARe,
        getAngle: 0,
        fontFamily: e_,
        updateTriggers: {
          getSize: [d],
          getColor: [s]
        }
      })
    ];
  }
  _renderCornerLayers() {
    const { theme: e, targetX: n, targetY: r, axisOffsetTop: i, scaleFactor: o, cellColorLabelsData: s, axisOffsetLeft: a, transpose: A } = this.props, l = r + (i - zm) / 2 / o, c = n + (a - zm) / 2 / o;
    return s.map((u) => new Eg({
      id: `cellColorLabel-${u[0]}`,
      coordinateSystem: wn.CARTESIAN,
      data: [u],
      getText: (f) => f[1],
      getTextAnchor: A ? "end" : "start",
      getAlignmentBaseline: "top",
      getColor: () => R2[e],
      getSize: Zb,
      getPosition: (f) => [
        A ? c : n + ((-s.length + f[0] * 2) * Qh + zm) / 2 / o,
        A ? r + ((-s.length + f[0] * 2) * Qh + zm) / 2 / o : l
      ],
      getAngle: A ? 0 : 90,
      fontFamily: e_
    }));
  }
  _renderAxisLeftLayers() {
    const { axisLeftLabelData: e, matrixTop: n, height: r, matrixHeight: i, viewHeight: o, theme: s, axisLeftTitle: a, targetX: A, targetY: l, cellHeight: c, axisOffsetLeft: u, scaleFactor: f, hideLeftLabels: h } = this.props, d = c >= Zb, I = A + (u - zm) / 2 / f;
    return h ? [] : [
      new Eg({
        id: "axisLeftLabels",
        coordinateSystem: wn.CARTESIAN,
        data: e,
        getText: (m) => m[1],
        getPosition: (m) => [I, n + (m[0] + 0.5) / r * i],
        getTextAnchor: "end",
        getColor: () => R2[s],
        getSize: d ? Zb : 0,
        getAngle: 0,
        fontFamily: e_,
        updateTriggers: {
          getPosition: [I, n, i, o],
          getSize: [d],
          getColor: [s]
        }
      }),
      new Eg({
        id: "axisLeftTitle",
        coordinateSystem: wn.CARTESIAN,
        data: [{ title: a }],
        getText: (m) => m.title,
        getPosition: [A, l],
        getTextAnchor: "middle",
        getColor: () => R2[s],
        getSize: d ? 0 : ARe,
        getAngle: 90,
        fontFamily: e_,
        updateTriggers: {
          getSize: [d],
          getColor: [s]
        }
      })
    ];
  }
  renderLayers() {
    const { axis: e } = this.props;
    return e === "left" ? this._renderAxisLeftLayers() : e === "top" ? this._renderAxisTopLayers() : e === "corner" ? this._renderCornerLayers() : [];
  }
}
FG.layerName = "HeatmapCompositeTextLayer";
const VGn = `
#define SHADER_NAME heatmap-bitmap-layer-vertex-shader

attribute vec2 texCoords;
attribute vec3 positions;
attribute vec3 positions64Low;

varying vec2 vTexCoord;

const vec3 pickingColor = vec3(1.0, 0.0, 0.0);

void main(void) {
  geometry.worldPosition = positions;
  geometry.uv = texCoords;
  geometry.pickingColor = pickingColor;

  gl_Position = project_position_to_clipspace(positions, positions64Low, vec3(0.0), geometry.position);
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);

  vTexCoord = texCoords;

  vec4 color = vec4(0.0);
  DECKGL_FILTER_COLOR(color, geometry);
}
`, gRe = `
#define SHADER_NAME heatmap-bitmap-layer-fragment-shader

#ifdef GL_ES
precision mediump float;
#endif

${kM}

// The texture (GL.LUMINANCE & Uint8Array).
uniform sampler2D uBitmapTexture;

// height x width of the data matrix (i.e x and y are flipped compared to the graphics convention)
uniform vec2 uOrigDataSize;
uniform vec2 uReshapedDataSize;

uniform vec2 tileIJ;
uniform vec2 dataIJ;
uniform vec2 numTiles;

// What are the dimensions of the texture (width, height)?
uniform vec2 uTextureSize;

// How many consecutive pixels should be aggregated together along each axis?
uniform vec2 uAggSize;

// What are the values of the color scale sliders?
uniform vec2 uColorScaleRange;

// The texture coordinate, varying (interpolated between values set by the vertex shader).
varying vec2 vTexCoord;

vec2 offsetvTexcoord(vec2 coord) {
  float xTileToDataRatio = uTextureSize.x / uOrigDataSize.y;
  float yTileToDataRatio = uTextureSize.y / uOrigDataSize.x;
  vec2 vTexCoordOffset = vec2(
    (tileIJ.y * xTileToDataRatio) + (coord.x * xTileToDataRatio),
    (tileIJ.x * yTileToDataRatio) + ((1. - coord.y) * yTileToDataRatio)
  );
  return vTexCoordOffset;
}

vec2 dataCoordinateFromvTexCoordOffset(vec2 vTexCoordOffset) {
  
  // True pixel coordinate on scale of uOrigDataSize
  vec2 viewCoord = vec2(floor(vTexCoordOffset.x * uOrigDataSize.y), floor(vTexCoordOffset.y * uOrigDataSize.x));
  return viewCoord;
}

float getIndexFromViewCoord(vec2 viewCoord) {
  return viewCoord.y * uOrigDataSize.y + viewCoord.x;
}

vec2 transformDataCoordinate(float index) {
  float textureX = (floor( index / uReshapedDataSize.x )) / uReshapedDataSize.x;
  float textureY = (index - (floor( index / uReshapedDataSize.x ) * uReshapedDataSize.x)) / uReshapedDataSize.y;
  vec2 texturedCoord = vec2(textureY, textureX);
  return texturedCoord;
}

void main(void) {
  // Compute 1 pixel in texture coordinates
  vec2 onePixel = vec2(1.0, 1.0) / uTextureSize;
  vec2 vTexCoordOffset = offsetvTexcoord(vTexCoord);
  vec2 viewCoordTransformed = dataCoordinateFromvTexCoordOffset(vTexCoordOffset);
  // Compute (x % aggSizeX, y % aggSizeY).
  // These values will be the number of values to the left / above the current position to consider.
  vec2 modAggSize = vec2(-1.0 * mod(viewCoordTransformed.x, uAggSize.x), -1.0 * mod(viewCoordTransformed.y, uAggSize.y));
  // Take the sum of values along each axis.
  float intensitySum = 0.0;
  vec2 offsetPixels = vec2(0.0, 0.0);
  for(int i = 0; i < 16; i++) {
    // Check to break outer loop early.
    // Uniforms cannot be used as conditions in GLSL for loops.
    if(float(i) >= uAggSize.y) {
      // Done in the y direction.
      break;
    }

    offsetPixels = vec2(offsetPixels.x, (modAggSize.y + float(i)));

    for(int j = 0; j < 16; j++) {
      // Check to break inner loop early.
      // Uniforms cannot be used as conditions in GLSL for loops.
      if(float(j) >= uAggSize.x) {
        // Done in the x direction.
        break;
      }
      offsetPixels = vec2((modAggSize.x + float(j)), offsetPixels.y);
      float indexFull = getIndexFromViewCoord(viewCoordTransformed + offsetPixels);
      float index = indexFull - (floor(indexFull / (uReshapedDataSize.x * uReshapedDataSize.y)) * (uReshapedDataSize.x * uReshapedDataSize.y));
      vec2 vTexCoordTransformed = transformDataCoordinate(index);
      intensitySum += texture2D(uBitmapTexture, vTexCoordTransformed).r;
    }
  }
  
  // Compute the mean value.
  float intensityMean = intensitySum / (uAggSize.x * uAggSize.y);
  // Re-scale using the color scale slider values.
  float scaledIntensityMean = (intensityMean - uColorScaleRange[0]) / max(0.005, (uColorScaleRange[1] - uColorScaleRange[0]));

  gl_FragColor = COLORMAP_FUNC(clamp(scaledIntensityMean, 0.0, 1.0));

  geometry.uv = vTexCoord;
  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`, JGn = {
  image: { type: "object", value: null, async: !0 },
  colormap: { type: "string", value: u0, compare: !0 },
  bounds: { type: "array", value: [1, 0, 0, 1], compare: !0 },
  aggSizeX: { type: "number", value: 8, compare: !0 },
  aggSizeY: { type: "number", value: 8, compare: !0 },
  colorScaleLo: { type: "number", value: 0, compare: !0 },
  colorScaleHi: { type: "number", value: 1, compare: !0 }
};
class Yue extends em {
  /**
   * Copy of getShaders from Layer (grandparent, parent of BitmapLayer).
   * Reference: https://github.com/visgl/deck.gl/blob/0afd4e99a6199aeec979989e0c361c97e6c17a16/modules/core/src/lib/layer.js#L302
   * @param {object} shaders
   * @returns {object} Merged shaders.
   */
  _getShaders(e) {
    return this.props.extensions.forEach((n) => {
      e = f$(e, n.getShaders.call(this, n));
    }), e;
  }
  /**
   * Need to override to provide custom shaders.
   */
  getShaders() {
    const { colormap: e } = this.props, n = ME.includes(e) ? gRe.replace(lB, e) : gRe.replace(lB, u0);
    return this._getShaders({
      vs: VGn,
      fs: n,
      modules: [qA, jA]
    });
  }
  updateState(e) {
    super.updateState(e);
    const { props: n, oldProps: r } = e;
    if (n.colormap !== r.colormap) {
      const { gl: i } = this.context;
      this.state.model?.delete(), this.state.model = this._getModel(i), this.getAttributeManager().invalidateAll();
    }
    n.image !== r.image && this.loadTexture(this.props.image);
  }
  /**
   * Need to override to provide additional uniform values.
   * Simplified by removing video-related code.
   * Reference: https://github.com/visgl/deck.gl/blob/0afd4e99a6199aeec979989e0c361c97e6c17a16/modules/layers/src/bitmap-layer/bitmap-layer.js#L173
   * @param {*} opts
   */
  draw(e) {
    const { uniforms: n } = e, { bitmapTexture: r, model: i } = this.state, { aggSizeX: o, aggSizeY: s, colorScaleLo: a, colorScaleHi: A, origDataSize: l, tileI: c, tileJ: u, numXTiles: f, numYTiles: h } = this.props;
    r && i && i.setUniforms(Object.assign({}, n, {
      uBitmapTexture: r,
      uOrigDataSize: l,
      uReshapedDataSize: [vg, vg],
      uTextureSize: [Sa, Sa],
      uAggSize: [o, s],
      uColorScaleRange: [a, A],
      tileIJ: [c, u],
      dataIJ: [0, 0],
      numTiles: [f, h],
      numData: [1, 1]
    })).draw();
  }
  /**
   * Need to override to provide the custom DEFAULT_TEXTURE_PARAMETERS
   * object.
   * Simplified by removing video-related code.
   * Reference: https://github.com/visgl/deck.gl/blob/0afd4e99a6199aeec979989e0c361c97e6c17a16/modules/layers/src/bitmap-layer/bitmap-layer.js#L218
   * @param {Array<Uint8Array>} images
   */
  loadTexture(e) {
    const { gl: n } = this.context;
    this.state.bitmapTexture && this.state.bitmapTexture.delete(), e && e instanceof xo ? this.setState({
      bitmapTexture: e
    }) : e && this.setState({
      bitmapTexture: new xo(n, {
        data: e,
        mipmaps: !1,
        parameters: yq,
        // Each color contains a single luminance value.
        // When sampled, rgb are all set to this luminance, alpha is 1.0.
        // Reference: https://luma.gl/docs/api-reference/webgl/texture#texture-formats
        format: gt.LUMINANCE,
        dataFormat: gt.LUMINANCE,
        type: gt.UNSIGNED_BYTE,
        width: vg,
        height: vg
      })
    });
  }
}
Yue.layerName = "PaddedExpressionHeatmapBitmapLayer";
Yue.defaultProps = JGn;
const KGn = `
${kM}

// Custom attributes for Vitessce:
attribute float expressionValue;

// Custom uniforms for Vitessce:
uniform vec2 uColorScaleRange;
uniform bool uIsExpressionMode;

`, WGn = {
  "vs:DECKGL_FILTER_COLOR": `
    if(uIsExpressionMode) {
      float normalizedExpressionValue = expressionValue / 255.0;
      float scaledExpressionValue = (normalizedExpressionValue - uColorScaleRange[0]) / max(0.005, (uColorScaleRange[1] - uColorScaleRange[0]));
      color.rgb = COLORMAP_FUNC(clamp(scaledExpressionValue, 0.0, 1.0)).rgb;
    }
  `
}, XGn = {
  name: "scaled-expression",
  vs: KGn,
  inject: WGn
}, ZGn = {
  colormap: { type: "string", value: u0, compare: !0 },
  colorScaleLo: { type: "number", value: 0, compare: !0 },
  colorScaleHi: { type: "number", value: 1, compare: !0 },
  isExpressionMode: !1,
  getExpressionValue: { type: "accessor", value: 0 },
  getSelectionState: { type: "accessor", value: 0 }
};
class oQ extends l0 {
  getShaders() {
    const { colormap: e } = this.props;
    return {
      modules: [XGn],
      defines: {
        [lB]: ME.includes(e) ? e : u0
      }
    };
  }
  updateState({ props: e, oldProps: n }) {
    if (e.colormap !== n.colormap) {
      const { gl: r } = this.context;
      this.state.model ? (this.state.model?.delete(), this.state.model = this._getModel(r)) : (this.state.models && this.state.models?.forEach((o) => o?.delete()), this.state.topModel && this.state.topModel?.delete(), this.state.sideModel && this.state.sideModel?.delete(), this._getModels && this.setState(this._getModels(this.context.gl))), this.getAttributeManager() && this.getAttributeManager().invalidateAll();
    }
  }
  initializeState() {
    if (this.getCurrentLayer().isComposite)
      return;
    const n = this.getAttributeManager();
    n && n.add({
      expressionValue: {
        type: gt.FLOAT,
        size: 1,
        transition: !0,
        accessor: "getExpressionValue",
        defaultValue: 1,
        // PolygonLayer fill needs not-intsanced attribute but
        // ScatterplotLayer and the PolygonLayer stroke needs instanced.
        // So use another attribute's divisor property as a proxy for this divisor.
        divisor: Object.values(n.attributes)[0].settings.divisor
      }
    });
  }
  draw() {
    const { colorScaleLo: e, colorScaleHi: n, isExpressionMode: r } = this.props, { topModel: i, sideModel: o, models: s, model: a } = this.state, A = {
      uColorScaleRange: [e, n],
      uIsExpressionMode: r
    };
    a?.setUniforms(A), s?.forEach((l) => l.setUniforms(A)), i?.setUniforms(A), o?.setUniforms(A);
  }
}
oQ.extensionName = "ScaledExpressionExtension";
oQ.defaultProps = ZGn;
const e4n = `
attribute float isSelected;
`, t4n = {
  "vs:DECKGL_FILTER_GL_POSITION": `
    position.z += (1. - isSelected) * .00005; // Add a small z offset for unselected points in the positive direction i.e into the screen.
  `,
  "fs:#main-start": ` // Gets rid of bad border effects (active after deck.gl 8.5): https://github.com/visgl/deck.gl/pull/6081
    float distToCenterNew = length(unitPosition) * outerRadiusPixels;
    float inCircleNew = step(distToCenterNew, outerRadiusPixels);
    if (inCircleNew == 0.0) {
      discard;
    }
  `
}, n4n = {
  name: "selection",
  vs: e4n,
  inject: t4n
};
class VVe extends l0 {
  // eslint-disable-next-line class-methods-use-this
  getShaders() {
    return {
      modules: [n4n]
    };
  }
  initializeState(e, n) {
    const r = this.getAttributeManager();
    r && r.add({
      isSelected: {
        type: gt.FLOAT,
        size: 1,
        transition: !0,
        accessor: "getCellIsSelected",
        defaultValue: 1,
        // PolygonLayer needs not-intsanced attribute but
        // ScatterplotLayer needs instanced.
        divisor: Number(n.opts.instanced)
      }
    });
  }
}
VVe.extensionName = "SelectionExtension";
function dl(t) {
  return (e, ...n) => r4n(t, e, n);
}
function Kw(t, e) {
  return dl(
    JVe(
      t,
      e
    ).get
  );
}
const {
  apply: r4n,
  construct: kLr,
  defineProperty: GLr,
  get: ULr,
  getOwnPropertyDescriptor: JVe,
  getPrototypeOf: zue,
  has: HLr,
  ownKeys: i4n,
  set: $Lr,
  setPrototypeOf: qLr
} = Reflect, {
  iterator: GM,
  species: jLr,
  toStringTag: o4n,
  for: YLr
} = Symbol, s4n = Object, {
  create: Vue,
  defineProperty: a4n,
  freeze: zLr,
  is: VLr
} = s4n, A4n = Array, l4n = A4n.prototype, KVe = l4n[GM], c4n = dl(KVe), WVe = ArrayBuffer, u4n = WVe.prototype;
Kw(u4n, "byteLength");
const hRe = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : null;
hRe && Kw(hRe.prototype, "byteLength");
const XVe = zue(Uint8Array);
XVe.from;
const nu = XVe.prototype;
nu[GM];
dl(nu.keys);
dl(
  nu.values
);
dl(
  nu.entries
);
dl(nu.set);
dl(
  nu.reverse
);
dl(nu.fill);
dl(
  nu.copyWithin
);
dl(nu.sort);
dl(nu.slice);
dl(
  nu.subarray
);
Kw(
  nu,
  "buffer"
);
Kw(
  nu,
  "byteOffset"
);
Kw(
  nu,
  "length"
);
Kw(
  nu,
  o4n
);
const Ww = Uint32Array, f4n = Float32Array, F8 = zue([][GM]()), g4n = dl(F8.next), h4n = dl(function* () {
}().next), d4n = zue(F8), p4n = DataView.prototype, I4n = dl(
  p4n.getUint16
), Jue = WeakMap, ZVe = Jue.prototype, eJe = dl(ZVe.get), m4n = dl(ZVe.set), tJe = new Jue(), C4n = Vue(null, {
  next: {
    value: function() {
      const e = eJe(tJe, this);
      return g4n(e);
    }
  },
  [GM]: {
    value: function() {
      return this;
    }
  }
});
function E4n(t) {
  if (t[GM] === KVe)
    return t;
  const e = Vue(C4n);
  return m4n(tJe, e, c4n(t)), e;
}
const y4n = new Jue(), v4n = Vue(d4n, {
  next: {
    value: function() {
      const e = eJe(y4n, this);
      return h4n(e);
    },
    writable: !0,
    configurable: !0
  }
});
for (const t of i4n(F8))
  t !== "next" && a4n(v4n, t, JVe(F8, t));
const nJe = new WVe(4), B4n = new f4n(nJe), b4n = new Ww(nJe), Xd = new Ww(512), Zd = new Ww(512);
for (let t = 0; t < 256; ++t) {
  const e = t - 127;
  e < -27 ? (Xd[t] = 0, Xd[t | 256] = 32768, Zd[t] = 24, Zd[t | 256] = 24) : e < -14 ? (Xd[t] = 1024 >> -e - 14, Xd[t | 256] = 1024 >> -e - 14 | 32768, Zd[t] = -e - 1, Zd[t | 256] = -e - 1) : e <= 15 ? (Xd[t] = e + 15 << 10, Xd[t | 256] = e + 15 << 10 | 32768, Zd[t] = 13, Zd[t | 256] = 13) : e < 128 ? (Xd[t] = 31744, Xd[t | 256] = 64512, Zd[t] = 24, Zd[t | 256] = 24) : (Xd[t] = 31744, Xd[t | 256] = 64512, Zd[t] = 13, Zd[t | 256] = 13);
}
const Kue = new Ww(2048), Xw = new Ww(64), rJe = new Ww(64);
for (let t = 1; t < 1024; ++t) {
  let e = t << 13, n = 0;
  for (; !(e & 8388608); )
    e <<= 1, n -= 8388608;
  e &= -8388609, n += 947912704, Kue[t] = e | n;
}
for (let t = 1024; t < 2048; ++t)
  Kue[t] = 939524096 + (t - 1024 << 13);
for (let t = 1; t < 31; ++t)
  Xw[t] = t << 23;
Xw[31] = 1199570944;
Xw[32] = 2147483648;
for (let t = 33; t < 63; ++t)
  Xw[t] = 2147483648 + (t - 32 << 23);
Xw[63] = 3347054592;
for (let t = 1; t < 64; ++t)
  t !== 32 && (rJe[t] = 1024);
function _4n(t) {
  const e = t >> 10;
  return b4n[0] = Kue[rJe[e] + (t & 1023)] + Xw[e], B4n[0];
}
function iJe(t, e, ...n) {
  return _4n(
    I4n(t, e, ...E4n(n))
  );
}
var Wue = { exports: {} };
function oJe(t, e, n) {
  const r = n && n.debug || !1;
  r && console.log("getting " + e + " in " + t);
  const i = typeof t == "object" ? t.outer : t, o = `${e}\\="([^"]*)"`;
  r && console.log("pattern:", o);
  const a = new RegExp(o).exec(i);
  if (r && console.log("match:", a), a)
    return a[1];
}
Wue.exports = oJe;
Wue.exports.default = oJe;
var S4n = Wue.exports;
const MJ = /* @__PURE__ */ ko(S4n);
var Xue = { exports: {} }, Zue = { exports: {} }, efe = { exports: {} };
function sJe(t, e, n) {
  const i = new RegExp(e).exec(t.slice(n));
  return i ? n + i.index : -1;
}
efe.exports = sJe;
efe.exports.default = sJe;
var Q4n = efe.exports, tfe = { exports: {} };
function aJe(t, e, n) {
  const i = new RegExp(e).exec(t.slice(n));
  return i ? n + i.index + i[0].length - 1 : -1;
}
tfe.exports = aJe;
tfe.exports.default = aJe;
var w4n = tfe.exports, nfe = { exports: {} };
function AJe(t, e) {
  const n = new RegExp(e, "g"), r = t.match(n);
  return r ? r.length : 0;
}
nfe.exports = AJe;
nfe.exports.default = AJe;
var x4n = nfe.exports;
const R4n = Q4n, OJ = w4n, dRe = x4n;
function lJe(t, e, n) {
  const r = n && n.debug || !1, i = !(n && typeof n.nested === !1), o = n && n.startIndex || 0;
  r && console.log("[xml-utils] starting findTagByName with", e, " and ", n);
  const s = R4n(t, `<${e}[ >/]`, o);
  if (r && console.log("[xml-utils] start:", s), s === -1)
    return;
  const a = t.slice(s + e.length);
  let A = OJ(a, "^[^<]*[ /]>", 0);
  const l = A !== -1 && a[A - 1] === "/";
  if (r && console.log("[xml-utils] selfClosing:", l), l === !1)
    if (i) {
      let h = 0, d = 1, I = 0;
      for (; (A = OJ(a, "[ /]" + e + ">", h)) !== -1; ) {
        const m = a.substring(h, A + 1);
        if (d += dRe(m, "<" + e), I += dRe(m, "/" + e + ">"), I >= d)
          break;
        h = A;
      }
    } else
      A = OJ(a, "[ /]" + e + ">", 0);
  const c = s + e.length + A + 1;
  if (r && console.log("[xml-utils] end:", c), c === -1)
    return;
  const u = t.slice(s, c);
  let f;
  return l ? f = null : f = u.slice(u.indexOf(">") + 1, u.lastIndexOf("<")), { inner: f, outer: u, start: s, end: c };
}
Zue.exports = lJe;
Zue.exports.default = lJe;
var D4n = Zue.exports;
const T4n = D4n;
function cJe(t, e, n) {
  const r = [], i = n && n.debug || !1, o = n && typeof n.nested == "boolean" ? n.nested : !0;
  let s = n && n.startIndex || 0, a;
  for (; a = T4n(t, e, { debug: i, startIndex: s }); )
    o ? s = a.start + 1 + e.length : s = a.end, r.push(a);
  return i && console.log("findTagsByName found", r.length, "tags"), r;
}
Xue.exports = cJe;
Xue.exports.default = cJe;
var N4n = Xue.exports;
const L4n = /* @__PURE__ */ ko(N4n), DD = {
  // TIFF Baseline
  315: "Artist",
  258: "BitsPerSample",
  265: "CellLength",
  264: "CellWidth",
  320: "ColorMap",
  259: "Compression",
  33432: "Copyright",
  306: "DateTime",
  338: "ExtraSamples",
  266: "FillOrder",
  289: "FreeByteCounts",
  288: "FreeOffsets",
  291: "GrayResponseCurve",
  290: "GrayResponseUnit",
  316: "HostComputer",
  270: "ImageDescription",
  257: "ImageLength",
  256: "ImageWidth",
  271: "Make",
  281: "MaxSampleValue",
  280: "MinSampleValue",
  272: "Model",
  254: "NewSubfileType",
  274: "Orientation",
  262: "PhotometricInterpretation",
  284: "PlanarConfiguration",
  296: "ResolutionUnit",
  278: "RowsPerStrip",
  277: "SamplesPerPixel",
  305: "Software",
  279: "StripByteCounts",
  273: "StripOffsets",
  255: "SubfileType",
  263: "Threshholding",
  282: "XResolution",
  283: "YResolution",
  // TIFF Extended
  326: "BadFaxLines",
  327: "CleanFaxData",
  343: "ClipPath",
  328: "ConsecutiveBadFaxLines",
  433: "Decode",
  434: "DefaultImageColor",
  269: "DocumentName",
  336: "DotRange",
  321: "HalftoneHints",
  346: "Indexed",
  347: "JPEGTables",
  285: "PageName",
  297: "PageNumber",
  317: "Predictor",
  319: "PrimaryChromaticities",
  532: "ReferenceBlackWhite",
  339: "SampleFormat",
  340: "SMinSampleValue",
  341: "SMaxSampleValue",
  559: "StripRowCounts",
  330: "SubIFDs",
  292: "T4Options",
  293: "T6Options",
  325: "TileByteCounts",
  323: "TileLength",
  324: "TileOffsets",
  322: "TileWidth",
  301: "TransferFunction",
  318: "WhitePoint",
  344: "XClipPathUnits",
  286: "XPosition",
  529: "YCbCrCoefficients",
  531: "YCbCrPositioning",
  530: "YCbCrSubSampling",
  345: "YClipPathUnits",
  287: "YPosition",
  // EXIF
  37378: "ApertureValue",
  40961: "ColorSpace",
  36868: "DateTimeDigitized",
  36867: "DateTimeOriginal",
  34665: "Exif IFD",
  36864: "ExifVersion",
  33434: "ExposureTime",
  41728: "FileSource",
  37385: "Flash",
  40960: "FlashpixVersion",
  33437: "FNumber",
  42016: "ImageUniqueID",
  37384: "LightSource",
  37500: "MakerNote",
  37377: "ShutterSpeedValue",
  37510: "UserComment",
  // IPTC
  33723: "IPTC",
  // ICC
  34675: "ICC Profile",
  // XMP
  700: "XMP",
  // GDAL
  42112: "GDAL_METADATA",
  42113: "GDAL_NODATA",
  // Photoshop
  34377: "Photoshop",
  // GeoTiff
  33550: "ModelPixelScale",
  33922: "ModelTiepoint",
  34264: "ModelTransformation",
  34735: "GeoKeyDirectory",
  34736: "GeoDoubleParams",
  34737: "GeoAsciiParams",
  // LERC
  50674: "LercParameters"
}, sp = {};
for (const t in DD)
  DD.hasOwnProperty(t) && (sp[DD[t]] = parseInt(t, 10));
const M4n = [
  sp.BitsPerSample,
  sp.ExtraSamples,
  sp.SampleFormat,
  sp.StripByteCounts,
  sp.StripOffsets,
  sp.StripRowCounts,
  sp.TileByteCounts,
  sp.TileOffsets,
  sp.SubIFDs
], FJ = {
  1: "BYTE",
  2: "ASCII",
  3: "SHORT",
  4: "LONG",
  5: "RATIONAL",
  6: "SBYTE",
  7: "UNDEFINED",
  8: "SSHORT",
  9: "SLONG",
  10: "SRATIONAL",
  11: "FLOAT",
  12: "DOUBLE",
  // IFD offset, suggested by https://owl.phy.queensu.ca/~phil/exiftool/standards.html
  13: "IFD",
  // introduced by BigTIFF
  16: "LONG8",
  17: "SLONG8",
  18: "IFD8"
}, oi = {};
for (const t in FJ)
  FJ.hasOwnProperty(t) && (oi[FJ[t]] = parseInt(t, 10));
const uf = {
  WhiteIsZero: 0,
  BlackIsZero: 1,
  RGB: 2,
  Palette: 3,
  TransparencyMask: 4,
  CMYK: 5,
  YCbCr: 6,
  CIELab: 8,
  ICCLab: 9
}, O4n = {
  Unspecified: 0,
  Assocalpha: 1,
  Unassalpha: 2
}, JLr = {
  Version: 0,
  AddCompression: 1
}, KLr = {
  None: 0,
  Deflate: 1
}, F4n = {
  1024: "GTModelTypeGeoKey",
  1025: "GTRasterTypeGeoKey",
  1026: "GTCitationGeoKey",
  2048: "GeographicTypeGeoKey",
  2049: "GeogCitationGeoKey",
  2050: "GeogGeodeticDatumGeoKey",
  2051: "GeogPrimeMeridianGeoKey",
  2052: "GeogLinearUnitsGeoKey",
  2053: "GeogLinearUnitSizeGeoKey",
  2054: "GeogAngularUnitsGeoKey",
  2055: "GeogAngularUnitSizeGeoKey",
  2056: "GeogEllipsoidGeoKey",
  2057: "GeogSemiMajorAxisGeoKey",
  2058: "GeogSemiMinorAxisGeoKey",
  2059: "GeogInvFlatteningGeoKey",
  2060: "GeogAzimuthUnitsGeoKey",
  2061: "GeogPrimeMeridianLongGeoKey",
  2062: "GeogTOWGS84GeoKey",
  3072: "ProjectedCSTypeGeoKey",
  3073: "PCSCitationGeoKey",
  3074: "ProjectionGeoKey",
  3075: "ProjCoordTransGeoKey",
  3076: "ProjLinearUnitsGeoKey",
  3077: "ProjLinearUnitSizeGeoKey",
  3078: "ProjStdParallel1GeoKey",
  3079: "ProjStdParallel2GeoKey",
  3080: "ProjNatOriginLongGeoKey",
  3081: "ProjNatOriginLatGeoKey",
  3082: "ProjFalseEastingGeoKey",
  3083: "ProjFalseNorthingGeoKey",
  3084: "ProjFalseOriginLongGeoKey",
  3085: "ProjFalseOriginLatGeoKey",
  3086: "ProjFalseOriginEastingGeoKey",
  3087: "ProjFalseOriginNorthingGeoKey",
  3088: "ProjCenterLongGeoKey",
  3089: "ProjCenterLatGeoKey",
  3090: "ProjCenterEastingGeoKey",
  3091: "ProjCenterNorthingGeoKey",
  3092: "ProjScaleAtNatOriginGeoKey",
  3093: "ProjScaleAtCenterGeoKey",
  3094: "ProjAzimuthAngleGeoKey",
  3095: "ProjStraightVertPoleLongGeoKey",
  3096: "ProjRectifiedGridAngleGeoKey",
  4096: "VerticalCSTypeGeoKey",
  4097: "VerticalCitationGeoKey",
  4098: "VerticalDatumGeoKey",
  4099: "VerticalUnitsGeoKey"
};
function P4n(t, e) {
  const { width: n, height: r } = t, i = new Uint8Array(n * r * 3);
  let o;
  for (let s = 0, a = 0; s < t.length; ++s, a += 3)
    o = 256 - t[s] / e * 256, i[a] = o, i[a + 1] = o, i[a + 2] = o;
  return i;
}
function k4n(t, e) {
  const { width: n, height: r } = t, i = new Uint8Array(n * r * 3);
  let o;
  for (let s = 0, a = 0; s < t.length; ++s, a += 3)
    o = t[s] / e * 256, i[a] = o, i[a + 1] = o, i[a + 2] = o;
  return i;
}
function G4n(t, e) {
  const { width: n, height: r } = t, i = new Uint8Array(n * r * 3), o = e.length / 3, s = e.length / 3 * 2;
  for (let a = 0, A = 0; a < t.length; ++a, A += 3) {
    const l = t[a];
    i[A] = e[l] / 65536 * 256, i[A + 1] = e[l + o] / 65536 * 256, i[A + 2] = e[l + s] / 65536 * 256;
  }
  return i;
}
function U4n(t) {
  const { width: e, height: n } = t, r = new Uint8Array(e * n * 3);
  for (let i = 0, o = 0; i < t.length; i += 4, o += 3) {
    const s = t[i], a = t[i + 1], A = t[i + 2], l = t[i + 3];
    r[o] = 255 * ((255 - s) / 256) * ((255 - l) / 256), r[o + 1] = 255 * ((255 - a) / 256) * ((255 - l) / 256), r[o + 2] = 255 * ((255 - A) / 256) * ((255 - l) / 256);
  }
  return r;
}
function H4n(t) {
  const { width: e, height: n } = t, r = new Uint8ClampedArray(e * n * 3);
  for (let i = 0, o = 0; i < t.length; i += 3, o += 3) {
    const s = t[i], a = t[i + 1], A = t[i + 2];
    r[o] = s + 1.402 * (A - 128), r[o + 1] = s - 0.34414 * (a - 128) - 0.71414 * (A - 128), r[o + 2] = s + 1.772 * (a - 128);
  }
  return r;
}
const $4n = 0.95047, q4n = 1, j4n = 1.08883;
function Y4n(t) {
  const { width: e, height: n } = t, r = new Uint8Array(e * n * 3);
  for (let i = 0, o = 0; i < t.length; i += 3, o += 3) {
    const s = t[i + 0], a = t[i + 1] << 24 >> 24, A = t[i + 2] << 24 >> 24;
    let l = (s + 16) / 116, c = a / 500 + l, u = l - A / 200, f, h, d;
    c = $4n * (c * c * c > 8856e-6 ? c * c * c : (c - 16 / 116) / 7.787), l = q4n * (l * l * l > 8856e-6 ? l * l * l : (l - 16 / 116) / 7.787), u = j4n * (u * u * u > 8856e-6 ? u * u * u : (u - 16 / 116) / 7.787), f = c * 3.2406 + l * -1.5372 + u * -0.4986, h = c * -0.9689 + l * 1.8758 + u * 0.0415, d = c * 0.0557 + l * -0.204 + u * 1.057, f = f > 31308e-7 ? 1.055 * f ** (1 / 2.4) - 0.055 : 12.92 * f, h = h > 31308e-7 ? 1.055 * h ** (1 / 2.4) - 0.055 : 12.92 * h, d = d > 31308e-7 ? 1.055 * d ** (1 / 2.4) - 0.055 : 12.92 * d, r[o] = Math.max(0, Math.min(1, f)) * 255, r[o + 1] = Math.max(0, Math.min(1, h)) * 255, r[o + 2] = Math.max(0, Math.min(1, d)) * 255;
  }
  return r;
}
const uJe = /* @__PURE__ */ new Map();
function rm(t, e) {
  Array.isArray(t) || (t = [t]), t.forEach((n) => uJe.set(n, e));
}
async function z4n(t) {
  const e = uJe.get(t.Compression);
  if (!e)
    throw new Error(`Unknown compression method identifier: ${t.Compression}`);
  const n = await e();
  return new n(t);
}
rm([void 0, 1], () => import("./raw-d04f7cfa.js").then((t) => t.default));
rm(5, () => import("./lzw-8f504cea.js").then((t) => t.default));
rm(6, () => {
  throw new Error("old style JPEG compression is not supported.");
});
rm(7, () => import("./jpeg-979514ae.js").then((t) => t.default));
rm([8, 32946], () => import("./deflate-d875db2f.js").then((t) => t.default));
rm(32773, () => import("./packbits-a93ad6f9.js").then((t) => t.default));
rm(34887, () => import("./lerc-e0e600e6.js").then((t) => t.default));
rm(50001, () => import("./webimage-bb620558.js").then((t) => t.default));
function vq(t, e, n, r = 1) {
  return new (Object.getPrototypeOf(t)).constructor(e * n * r);
}
function V4n(t, e, n, r, i) {
  const o = e / r, s = n / i;
  return t.map((a) => {
    const A = vq(a, r, i);
    for (let l = 0; l < i; ++l) {
      const c = Math.min(Math.round(s * l), n - 1);
      for (let u = 0; u < r; ++u) {
        const f = Math.min(Math.round(o * u), e - 1), h = a[c * e + f];
        A[l * r + u] = h;
      }
    }
    return A;
  });
}
function X_(t, e, n) {
  return (1 - n) * t + n * e;
}
function J4n(t, e, n, r, i) {
  const o = e / r, s = n / i;
  return t.map((a) => {
    const A = vq(a, r, i);
    for (let l = 0; l < i; ++l) {
      const c = s * l, u = Math.floor(c), f = Math.min(Math.ceil(c), n - 1);
      for (let h = 0; h < r; ++h) {
        const d = o * h, I = d % 1, m = Math.floor(d), C = Math.min(Math.ceil(d), e - 1), y = a[u * e + m], v = a[u * e + C], b = a[f * e + m], Q = a[f * e + C], w = X_(
          X_(y, v, I),
          X_(b, Q, I),
          c % 1
        );
        A[l * r + h] = w;
      }
    }
    return A;
  });
}
function K4n(t, e, n, r, i, o = "nearest") {
  switch (o.toLowerCase()) {
    case "nearest":
      return V4n(t, e, n, r, i);
    case "bilinear":
    case "linear":
      return J4n(t, e, n, r, i);
    default:
      throw new Error(`Unsupported resampling method: '${o}'`);
  }
}
function W4n(t, e, n, r, i, o) {
  const s = e / r, a = n / i, A = vq(t, r, i, o);
  for (let l = 0; l < i; ++l) {
    const c = Math.min(Math.round(a * l), n - 1);
    for (let u = 0; u < r; ++u) {
      const f = Math.min(Math.round(s * u), e - 1);
      for (let h = 0; h < o; ++h) {
        const d = t[c * e * o + f * o + h];
        A[l * r * o + u * o + h] = d;
      }
    }
  }
  return A;
}
function X4n(t, e, n, r, i, o) {
  const s = e / r, a = n / i, A = vq(t, r, i, o);
  for (let l = 0; l < i; ++l) {
    const c = a * l, u = Math.floor(c), f = Math.min(Math.ceil(c), n - 1);
    for (let h = 0; h < r; ++h) {
      const d = s * h, I = d % 1, m = Math.floor(d), C = Math.min(Math.ceil(d), e - 1);
      for (let y = 0; y < o; ++y) {
        const v = t[u * e * o + m * o + y], b = t[u * e * o + C * o + y], Q = t[f * e * o + m * o + y], w = t[f * e * o + C * o + y], R = X_(
          X_(v, b, I),
          X_(Q, w, I),
          c % 1
        );
        A[l * r * o + h * o + y] = R;
      }
    }
  }
  return A;
}
function Z4n(t, e, n, r, i, o, s = "nearest") {
  switch (s.toLowerCase()) {
    case "nearest":
      return W4n(
        t,
        e,
        n,
        r,
        i,
        o
      );
    case "bilinear":
    case "linear":
      return X4n(
        t,
        e,
        n,
        r,
        i,
        o
      );
    default:
      throw new Error(`Unsupported resampling method: '${s}'`);
  }
}
function eUn(t, e, n) {
  let r = 0;
  for (let i = e; i < n; ++i)
    r += t[i];
  return r;
}
function rre(t, e, n) {
  switch (t) {
    case 1:
      if (e <= 8)
        return new Uint8Array(n);
      if (e <= 16)
        return new Uint16Array(n);
      if (e <= 32)
        return new Uint32Array(n);
      break;
    case 2:
      if (e === 8)
        return new Int8Array(n);
      if (e === 16)
        return new Int16Array(n);
      if (e === 32)
        return new Int32Array(n);
      break;
    case 3:
      switch (e) {
        case 16:
        case 32:
          return new Float32Array(n);
        case 64:
          return new Float64Array(n);
      }
      break;
  }
  throw Error("Unsupported data format/bitsPerSample");
}
function tUn(t, e) {
  return (t === 1 || t === 2) && e <= 32 && e % 8 === 0 ? !1 : !(t === 3 && (e === 16 || e === 32 || e === 64));
}
function nUn(t, e, n, r, i, o, s) {
  const a = new DataView(t), A = n === 2 ? s * o : s * o * r, l = n === 2 ? 1 : r, c = rre(e, i, A), u = parseInt("1".repeat(i), 2);
  if (e === 1) {
    let f;
    n === 1 ? f = r * i : f = i;
    let h = o * f;
    h & 7 && (h = h + 7 & -8);
    for (let d = 0; d < s; ++d) {
      const I = d * h;
      for (let m = 0; m < o; ++m) {
        const C = I + m * l * i;
        for (let y = 0; y < l; ++y) {
          const v = C + y * i, b = (d * o + m) * l + y, Q = Math.floor(v / 8), w = v % 8;
          if (w + i <= 8)
            c[b] = a.getUint8(Q) >> 8 - i - w & u;
          else if (w + i <= 16)
            c[b] = a.getUint16(Q) >> 16 - i - w & u;
          else if (w + i <= 24) {
            const R = a.getUint16(Q) << 8 | a.getUint8(Q + 2);
            c[b] = R >> 24 - i - w & u;
          } else
            c[b] = a.getUint32(Q) >> 32 - i - w & u;
        }
      }
    }
  }
  return c.buffer;
}
class rUn {
  /**
   * @constructor
   * @param {Object} fileDirectory The parsed file directory
   * @param {Object} geoKeys The parsed geo-keys
   * @param {DataView} dataView The DataView for the underlying file.
   * @param {Boolean} littleEndian Whether the file is encoded in little or big endian
   * @param {Boolean} cache Whether or not decoded tiles shall be cached
   * @param {Source} source The datasource to read from
   */
  constructor(e, n, r, i, o, s) {
    this.fileDirectory = e, this.geoKeys = n, this.dataView = r, this.littleEndian = i, this.tiles = o ? {} : null, this.isTiled = !e.StripOffsets;
    const a = e.PlanarConfiguration;
    if (this.planarConfiguration = typeof a > "u" ? 1 : a, this.planarConfiguration !== 1 && this.planarConfiguration !== 2)
      throw new Error("Invalid planar configuration.");
    this.source = s;
  }
  /**
   * Returns the associated parsed file directory.
   * @returns {Object} the parsed file directory
   */
  getFileDirectory() {
    return this.fileDirectory;
  }
  /**
   * Returns the associated parsed geo keys.
   * @returns {Object} the parsed geo keys
   */
  getGeoKeys() {
    return this.geoKeys;
  }
  /**
   * Returns the width of the image.
   * @returns {Number} the width of the image
   */
  getWidth() {
    return this.fileDirectory.ImageWidth;
  }
  /**
   * Returns the height of the image.
   * @returns {Number} the height of the image
   */
  getHeight() {
    return this.fileDirectory.ImageLength;
  }
  /**
   * Returns the number of samples per pixel.
   * @returns {Number} the number of samples per pixel
   */
  getSamplesPerPixel() {
    return typeof this.fileDirectory.SamplesPerPixel < "u" ? this.fileDirectory.SamplesPerPixel : 1;
  }
  /**
   * Returns the width of each tile.
   * @returns {Number} the width of each tile
   */
  getTileWidth() {
    return this.isTiled ? this.fileDirectory.TileWidth : this.getWidth();
  }
  /**
   * Returns the height of each tile.
   * @returns {Number} the height of each tile
   */
  getTileHeight() {
    return this.isTiled ? this.fileDirectory.TileLength : typeof this.fileDirectory.RowsPerStrip < "u" ? Math.min(this.fileDirectory.RowsPerStrip, this.getHeight()) : this.getHeight();
  }
  getBlockWidth() {
    return this.getTileWidth();
  }
  getBlockHeight(e) {
    return this.isTiled || (e + 1) * this.getTileHeight() <= this.getHeight() ? this.getTileHeight() : this.getHeight() - e * this.getTileHeight();
  }
  /**
   * Calculates the number of bytes for each pixel across all samples. Only full
   * bytes are supported, an exception is thrown when this is not the case.
   * @returns {Number} the bytes per pixel
   */
  getBytesPerPixel() {
    let e = 0;
    for (let n = 0; n < this.fileDirectory.BitsPerSample.length; ++n)
      e += this.getSampleByteSize(n);
    return e;
  }
  getSampleByteSize(e) {
    if (e >= this.fileDirectory.BitsPerSample.length)
      throw new RangeError(`Sample index ${e} is out of range.`);
    return Math.ceil(this.fileDirectory.BitsPerSample[e] / 8);
  }
  getReaderForSample(e) {
    const n = this.fileDirectory.SampleFormat ? this.fileDirectory.SampleFormat[e] : 1, r = this.fileDirectory.BitsPerSample[e];
    switch (n) {
      case 1:
        if (r <= 8)
          return DataView.prototype.getUint8;
        if (r <= 16)
          return DataView.prototype.getUint16;
        if (r <= 32)
          return DataView.prototype.getUint32;
        break;
      case 2:
        if (r <= 8)
          return DataView.prototype.getInt8;
        if (r <= 16)
          return DataView.prototype.getInt16;
        if (r <= 32)
          return DataView.prototype.getInt32;
        break;
      case 3:
        switch (r) {
          case 16:
            return function(i, o) {
              return iJe(this, i, o);
            };
          case 32:
            return DataView.prototype.getFloat32;
          case 64:
            return DataView.prototype.getFloat64;
        }
        break;
    }
    throw Error("Unsupported data format/bitsPerSample");
  }
  getSampleFormat(e = 0) {
    return this.fileDirectory.SampleFormat ? this.fileDirectory.SampleFormat[e] : 1;
  }
  getBitsPerSample(e = 0) {
    return this.fileDirectory.BitsPerSample[e];
  }
  getArrayForSample(e, n) {
    const r = this.getSampleFormat(e), i = this.getBitsPerSample(e);
    return rre(r, i, n);
  }
  /**
   * Returns the decoded strip or tile.
   * @param {Number} x the strip or tile x-offset
   * @param {Number} y the tile y-offset (0 for stripped images)
   * @param {Number} sample the sample to get for separated samples
   * @param {import("./geotiff").Pool|AbstractDecoder} poolOrDecoder the decoder or decoder pool
   * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
   *                               to be aborted
   * @returns {Promise.<ArrayBuffer>}
   */
  async getTileOrStrip(e, n, r, i, o) {
    const s = Math.ceil(this.getWidth() / this.getTileWidth()), a = Math.ceil(this.getHeight() / this.getTileHeight());
    let A;
    const { tiles: l } = this;
    this.planarConfiguration === 1 ? A = n * s + e : this.planarConfiguration === 2 && (A = r * s * a + n * s + e);
    let c, u;
    this.isTiled ? (c = this.fileDirectory.TileOffsets[A], u = this.fileDirectory.TileByteCounts[A]) : (c = this.fileDirectory.StripOffsets[A], u = this.fileDirectory.StripByteCounts[A]);
    const f = (await this.source.fetch([{ offset: c, length: u }], o))[0];
    let h;
    return l === null || !l[A] ? (h = (async () => {
      let d = await i.decode(this.fileDirectory, f);
      const I = this.getSampleFormat(), m = this.getBitsPerSample();
      return tUn(I, m) && (d = nUn(
        d,
        I,
        this.planarConfiguration,
        this.getSamplesPerPixel(),
        m,
        this.getTileWidth(),
        this.getBlockHeight(n)
      )), d;
    })(), l !== null && (l[A] = h)) : h = l[A], { x: e, y: n, sample: r, data: await h };
  }
  /**
   * Internal read function.
   * @private
   * @param {Array} imageWindow The image window in pixel coordinates
   * @param {Array} samples The selected samples (0-based indices)
   * @param {TypedArray[]|TypedArray} valueArrays The array(s) to write into
   * @param {Boolean} interleave Whether or not to write in an interleaved manner
   * @param {import("./geotiff").Pool|AbstractDecoder} poolOrDecoder the decoder or decoder pool
   * @param {number} width the width of window to be read into
   * @param {number} height the height of window to be read into
   * @param {number} resampleMethod the resampling method to be used when interpolating
   * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
   *                               to be aborted
   * @returns {Promise<TypedArray[]>|Promise<TypedArray>}
   */
  async _readRaster(e, n, r, i, o, s, a, A, l) {
    const c = this.getTileWidth(), u = this.getTileHeight(), f = this.getWidth(), h = this.getHeight(), d = Math.max(Math.floor(e[0] / c), 0), I = Math.min(
      Math.ceil(e[2] / c),
      Math.ceil(f / c)
    ), m = Math.max(Math.floor(e[1] / u), 0), C = Math.min(
      Math.ceil(e[3] / u),
      Math.ceil(h / u)
    ), y = e[2] - e[0];
    let v = this.getBytesPerPixel();
    const b = [], Q = [];
    for (let M = 0; M < n.length; ++M)
      this.planarConfiguration === 1 ? b.push(eUn(this.fileDirectory.BitsPerSample, 0, n[M]) / 8) : b.push(0), Q.push(this.getReaderForSample(n[M]));
    const w = [], { littleEndian: R } = this;
    for (let M = m; M < C; ++M)
      for (let O = d; O < I; ++O)
        for (let L = 0; L < n.length; ++L) {
          const N = L, k = n[L];
          this.planarConfiguration === 2 && (v = this.getSampleByteSize(L));
          const $ = this.getTileOrStrip(O, M, k, o, l).then((U) => {
            const X = U.data, K = new DataView(X), z = this.getBlockHeight(U.y), Y = U.y * u, V = U.x * c, Z = Y + z, ce = (U.x + 1) * c, ee = Q[N], pe = Math.min(z, z - (Z - e[3]), h - Y), Ce = Math.min(c, c - (ce - e[2]), f - V);
            for (let Be = Math.max(0, e[1] - Y); Be < pe; ++Be)
              for (let Ie = Math.max(0, e[0] - V); Ie < Ce; ++Ie) {
                const Qe = (Be * c + Ie) * v, xe = ee.call(
                  K,
                  Qe + b[N],
                  R
                );
                let Se;
                i ? (Se = (Be + Y - e[1]) * y * n.length + (Ie + V - e[0]) * n.length + N, r[Se] = xe) : (Se = (Be + Y - e[1]) * y + Ie + V - e[0], r[N][Se] = xe);
              }
          });
          w.push($);
        }
    if (await Promise.all(w), s && e[2] - e[0] !== s || a && e[3] - e[1] !== a) {
      let M;
      return i ? M = Z4n(
        r,
        e[2] - e[0],
        e[3] - e[1],
        s,
        a,
        n.length,
        A
      ) : M = K4n(
        r,
        e[2] - e[0],
        e[3] - e[1],
        s,
        a,
        A
      ), M.width = s, M.height = a, M;
    }
    return r.width = s || e[2] - e[0], r.height = a || e[3] - e[1], r;
  }
  /**
   * Reads raster data from the image. This function reads all selected samples
   * into separate arrays of the correct type for that sample or into a single
   * combined array when `interleave` is set. When provided, only a subset
   * of the raster is read for each sample.
   *
   * @param {ReadRasterOptions} [options={}] optional parameters
   * @returns {Promise.<(TypedArray|TypedArray[])>} the decoded arrays as a promise
   */
  async readRasters({
    window: e,
    samples: n = [],
    interleave: r,
    pool: i = null,
    width: o,
    height: s,
    resampleMethod: a,
    fillValue: A,
    signal: l
  } = {}) {
    const c = e || [0, 0, this.getWidth(), this.getHeight()];
    if (c[0] > c[2] || c[1] > c[3])
      throw new Error("Invalid subsets");
    const u = c[2] - c[0], f = c[3] - c[1], h = u * f, d = this.getSamplesPerPixel();
    if (!n || !n.length)
      for (let y = 0; y < d; ++y)
        n.push(y);
    else
      for (let y = 0; y < n.length; ++y)
        if (n[y] >= d)
          return Promise.reject(new RangeError(`Invalid sample index '${n[y]}'.`));
    let I;
    if (r) {
      const y = this.fileDirectory.SampleFormat ? Math.max.apply(null, this.fileDirectory.SampleFormat) : 1, v = Math.max.apply(null, this.fileDirectory.BitsPerSample);
      I = rre(y, v, h * n.length), A && I.fill(A);
    } else {
      I = [];
      for (let y = 0; y < n.length; ++y) {
        const v = this.getArrayForSample(n[y], h);
        Array.isArray(A) && y < A.length ? v.fill(A[y]) : A && !Array.isArray(A) && v.fill(A), I.push(v);
      }
    }
    const m = i || await z4n(this.fileDirectory);
    return await this._readRaster(
      c,
      n,
      I,
      r,
      m,
      o,
      s,
      a,
      l
    );
  }
  /**
   * Reads raster data from the image as RGB. The result is always an
   * interleaved typed array.
   * Colorspaces other than RGB will be transformed to RGB, color maps expanded.
   * When no other method is applicable, the first sample is used to produce a
   * greayscale image.
   * When provided, only a subset of the raster is read for each sample.
   *
   * @param {Object} [options] optional parameters
   * @param {Array<number>} [options.window] the subset to read data from in pixels.
   * @param {boolean} [options.interleave=true] whether the data shall be read
   *                                             in one single array or separate
   *                                             arrays.
   * @param {import("./geotiff").Pool} [options.pool=null] The optional decoder pool to use.
   * @param {number} [options.width] The desired width of the output. When the width is no the
   *                                 same as the images, resampling will be performed.
   * @param {number} [options.height] The desired height of the output. When the width is no the
   *                                  same as the images, resampling will be performed.
   * @param {string} [options.resampleMethod='nearest'] The desired resampling method.
   * @param {boolean} [options.enableAlpha=false] Enable reading alpha channel if present.
   * @param {AbortSignal} [options.signal] An AbortSignal that may be signalled if the request is
   *                                       to be aborted
   * @returns {Promise<TypedArray|TypedArray[]>} the RGB array as a Promise
   */
  async readRGB({
    window: e,
    interleave: n = !0,
    pool: r = null,
    width: i,
    height: o,
    resampleMethod: s,
    enableAlpha: a = !1,
    signal: A
  } = {}) {
    const l = e || [0, 0, this.getWidth(), this.getHeight()];
    if (l[0] > l[2] || l[1] > l[3])
      throw new Error("Invalid subsets");
    const c = this.fileDirectory.PhotometricInterpretation;
    if (c === uf.RGB) {
      let C = [0, 1, 2];
      if (this.fileDirectory.ExtraSamples !== O4n.Unspecified && a) {
        C = [];
        for (let y = 0; y < this.fileDirectory.BitsPerSample.length; y += 1)
          C.push(y);
      }
      return this.readRasters({
        window: e,
        interleave: n,
        samples: C,
        pool: r,
        width: i,
        height: o,
        resampleMethod: s,
        signal: A
      });
    }
    let u;
    switch (c) {
      case uf.WhiteIsZero:
      case uf.BlackIsZero:
      case uf.Palette:
        u = [0];
        break;
      case uf.CMYK:
        u = [0, 1, 2, 3];
        break;
      case uf.YCbCr:
      case uf.CIELab:
        u = [0, 1, 2];
        break;
      default:
        throw new Error("Invalid or unsupported photometric interpretation.");
    }
    const f = {
      window: l,
      interleave: !0,
      samples: u,
      pool: r,
      width: i,
      height: o,
      resampleMethod: s,
      signal: A
    }, { fileDirectory: h } = this, d = await this.readRasters(f), I = 2 ** this.fileDirectory.BitsPerSample[0];
    let m;
    switch (c) {
      case uf.WhiteIsZero:
        m = P4n(d, I);
        break;
      case uf.BlackIsZero:
        m = k4n(d, I);
        break;
      case uf.Palette:
        m = G4n(d, h.ColorMap);
        break;
      case uf.CMYK:
        m = U4n(d);
        break;
      case uf.YCbCr:
        m = H4n(d);
        break;
      case uf.CIELab:
        m = Y4n(d);
        break;
      default:
        throw new Error("Unsupported photometric interpretation.");
    }
    if (!n) {
      const C = new Uint8Array(m.length / 3), y = new Uint8Array(m.length / 3), v = new Uint8Array(m.length / 3);
      for (let b = 0, Q = 0; b < m.length; b += 3, ++Q)
        C[Q] = m[b], y[Q] = m[b + 1], v[Q] = m[b + 2];
      m = [C, y, v];
    }
    return m.width = d.width, m.height = d.height, m;
  }
  /**
   * Returns an array of tiepoints.
   * @returns {Object[]}
   */
  getTiePoints() {
    if (!this.fileDirectory.ModelTiepoint)
      return [];
    const e = [];
    for (let n = 0; n < this.fileDirectory.ModelTiepoint.length; n += 6)
      e.push({
        i: this.fileDirectory.ModelTiepoint[n],
        j: this.fileDirectory.ModelTiepoint[n + 1],
        k: this.fileDirectory.ModelTiepoint[n + 2],
        x: this.fileDirectory.ModelTiepoint[n + 3],
        y: this.fileDirectory.ModelTiepoint[n + 4],
        z: this.fileDirectory.ModelTiepoint[n + 5]
      });
    return e;
  }
  /**
   * Returns the parsed GDAL metadata items.
   *
   * If sample is passed to null, dataset-level metadata will be returned.
   * Otherwise only metadata specific to the provided sample will be returned.
   *
   * @param {number} [sample=null] The sample index.
   * @returns {Object}
   */
  getGDALMetadata(e = null) {
    const n = {};
    if (!this.fileDirectory.GDAL_METADATA)
      return null;
    const r = this.fileDirectory.GDAL_METADATA;
    let i = L4n(r, "Item");
    e === null ? i = i.filter((o) => MJ(o, "sample") === void 0) : i = i.filter((o) => Number(MJ(o, "sample")) === e);
    for (let o = 0; o < i.length; ++o) {
      const s = i[o];
      n[MJ(s, "name")] = s.inner;
    }
    return n;
  }
  /**
   * Returns the GDAL nodata value
   * @returns {number|null}
   */
  getGDALNoData() {
    if (!this.fileDirectory.GDAL_NODATA)
      return null;
    const e = this.fileDirectory.GDAL_NODATA;
    return Number(e.substring(0, e.length - 1));
  }
  /**
   * Returns the image origin as a XYZ-vector. When the image has no affine
   * transformation, then an exception is thrown.
   * @returns {Array<number>} The origin as a vector
   */
  getOrigin() {
    const e = this.fileDirectory.ModelTiepoint, n = this.fileDirectory.ModelTransformation;
    if (e && e.length === 6)
      return [
        e[3],
        e[4],
        e[5]
      ];
    if (n)
      return [
        n[3],
        n[7],
        n[11]
      ];
    throw new Error("The image does not have an affine transformation.");
  }
  /**
   * Returns the image resolution as a XYZ-vector. When the image has no affine
   * transformation, then an exception is thrown.
   * @param {GeoTIFFImage} [referenceImage=null] A reference image to calculate the resolution from
   *                                             in cases when the current image does not have the
   *                                             required tags on its own.
   * @returns {Array<number>} The resolution as a vector
   */
  getResolution(e = null) {
    const n = this.fileDirectory.ModelPixelScale, r = this.fileDirectory.ModelTransformation;
    if (n)
      return [
        n[0],
        -n[1],
        n[2]
      ];
    if (r)
      return [
        r[0],
        r[5],
        r[10]
      ];
    if (e) {
      const [i, o, s] = e.getResolution();
      return [
        i * e.getWidth() / this.getWidth(),
        o * e.getHeight() / this.getHeight(),
        s * e.getWidth() / this.getWidth()
      ];
    }
    throw new Error("The image does not have an affine transformation.");
  }
  /**
   * Returns whether or not the pixels of the image depict an area (or point).
   * @returns {Boolean} Whether the pixels are a point
   */
  pixelIsArea() {
    return this.geoKeys.GTRasterTypeGeoKey === 1;
  }
  /**
   * Returns the image bounding box as an array of 4 values: min-x, min-y,
   * max-x and max-y. When the image has no affine transformation, then an
   * exception is thrown.
   * @returns {Array<number>} The bounding box
   */
  getBoundingBox() {
    const e = this.getOrigin(), n = this.getResolution(), r = e[0], i = e[1], o = r + n[0] * this.getWidth(), s = i + n[1] * this.getHeight();
    return [
      Math.min(r, o),
      Math.min(i, s),
      Math.max(r, o),
      Math.max(i, s)
    ];
  }
}
const fJe = rUn;
class iUn {
  constructor(e) {
    this._dataView = new DataView(e);
  }
  get buffer() {
    return this._dataView.buffer;
  }
  getUint64(e, n) {
    const r = this.getUint32(e, n), i = this.getUint32(e + 4, n);
    let o;
    if (n) {
      if (o = r + 2 ** 32 * i, !Number.isSafeInteger(o))
        throw new Error(
          `${o} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`
        );
      return o;
    }
    if (o = 2 ** 32 * r + i, !Number.isSafeInteger(o))
      throw new Error(
        `${o} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`
      );
    return o;
  }
  // adapted from https://stackoverflow.com/a/55338384/8060591
  getInt64(e, n) {
    let r = 0;
    const i = (this._dataView.getUint8(e + (n ? 7 : 0)) & 128) > 0;
    let o = !0;
    for (let s = 0; s < 8; s++) {
      let a = this._dataView.getUint8(e + (n ? s : 7 - s));
      i && (o ? a !== 0 && (a = ~(a - 1) & 255, o = !1) : a = ~a & 255), r += a * 256 ** s;
    }
    return i && (r = -r), r;
  }
  getUint8(e, n) {
    return this._dataView.getUint8(e, n);
  }
  getInt8(e, n) {
    return this._dataView.getInt8(e, n);
  }
  getUint16(e, n) {
    return this._dataView.getUint16(e, n);
  }
  getInt16(e, n) {
    return this._dataView.getInt16(e, n);
  }
  getUint32(e, n) {
    return this._dataView.getUint32(e, n);
  }
  getInt32(e, n) {
    return this._dataView.getInt32(e, n);
  }
  getFloat16(e, n) {
    return iJe(this._dataView, e, n);
  }
  getFloat32(e, n) {
    return this._dataView.getFloat32(e, n);
  }
  getFloat64(e, n) {
    return this._dataView.getFloat64(e, n);
  }
}
class oUn {
  constructor(e, n, r, i) {
    this._dataView = new DataView(e), this._sliceOffset = n, this._littleEndian = r, this._bigTiff = i;
  }
  get sliceOffset() {
    return this._sliceOffset;
  }
  get sliceTop() {
    return this._sliceOffset + this.buffer.byteLength;
  }
  get littleEndian() {
    return this._littleEndian;
  }
  get bigTiff() {
    return this._bigTiff;
  }
  get buffer() {
    return this._dataView.buffer;
  }
  covers(e, n) {
    return this.sliceOffset <= e && this.sliceTop >= e + n;
  }
  readUint8(e) {
    return this._dataView.getUint8(
      e - this._sliceOffset,
      this._littleEndian
    );
  }
  readInt8(e) {
    return this._dataView.getInt8(
      e - this._sliceOffset,
      this._littleEndian
    );
  }
  readUint16(e) {
    return this._dataView.getUint16(
      e - this._sliceOffset,
      this._littleEndian
    );
  }
  readInt16(e) {
    return this._dataView.getInt16(
      e - this._sliceOffset,
      this._littleEndian
    );
  }
  readUint32(e) {
    return this._dataView.getUint32(
      e - this._sliceOffset,
      this._littleEndian
    );
  }
  readInt32(e) {
    return this._dataView.getInt32(
      e - this._sliceOffset,
      this._littleEndian
    );
  }
  readFloat32(e) {
    return this._dataView.getFloat32(
      e - this._sliceOffset,
      this._littleEndian
    );
  }
  readFloat64(e) {
    return this._dataView.getFloat64(
      e - this._sliceOffset,
      this._littleEndian
    );
  }
  readUint64(e) {
    const n = this.readUint32(e), r = this.readUint32(e + 4);
    let i;
    if (this._littleEndian) {
      if (i = n + 2 ** 32 * r, !Number.isSafeInteger(i))
        throw new Error(
          `${i} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`
        );
      return i;
    }
    if (i = 2 ** 32 * n + r, !Number.isSafeInteger(i))
      throw new Error(
        `${i} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`
      );
    return i;
  }
  // adapted from https://stackoverflow.com/a/55338384/8060591
  readInt64(e) {
    let n = 0;
    const r = (this._dataView.getUint8(e + (this._littleEndian ? 7 : 0)) & 128) > 0;
    let i = !0;
    for (let o = 0; o < 8; o++) {
      let s = this._dataView.getUint8(
        e + (this._littleEndian ? o : 7 - o)
      );
      r && (i ? s !== 0 && (s = ~(s - 1) & 255, i = !1) : s = ~s & 255), n += s * 256 ** o;
    }
    return r && (n = -n), n;
  }
  readOffset(e) {
    return this._bigTiff ? this.readUint64(e) : this.readUint32(e);
  }
}
const pRe = `\r
\r
`;
function gJe(t) {
  if (typeof Object.fromEntries < "u")
    return Object.fromEntries(t);
  const e = {};
  for (const [n, r] of t)
    e[n.toLowerCase()] = r;
  return e;
}
function sUn(t) {
  const e = t.split(`\r
`).map((n) => {
    const r = n.split(":").map((i) => i.trim());
    return r[0] = r[0].toLowerCase(), r;
  });
  return gJe(e);
}
function aUn(t) {
  const [e, ...n] = t.split(";").map((i) => i.trim()), r = n.map((i) => i.split("="));
  return { type: e, params: gJe(r) };
}
function ire(t) {
  let e, n, r;
  return t && ([, e, n, r] = t.match(/bytes (\d+)-(\d+)\/(\d+)/), e = parseInt(e, 10), n = parseInt(n, 10), r = parseInt(r, 10)), { start: e, end: n, total: r };
}
function AUn(t, e) {
  let n = null;
  const r = new TextDecoder("ascii"), i = [], o = `--${e}`, s = `${o}--`;
  for (let a = 0; a < 10; ++a)
    r.decode(
      new Uint8Array(t, a, o.length)
    ) === o && (n = a);
  if (n === null)
    throw new Error("Could not find initial boundary");
  for (; n < t.byteLength; ) {
    const a = r.decode(
      new Uint8Array(
        t,
        n,
        Math.min(o.length + 1024, t.byteLength - n)
      )
    );
    if (a.length === 0 || a.startsWith(s))
      break;
    if (!a.startsWith(o))
      throw new Error("Part does not start with boundary");
    const A = a.substr(o.length + 2);
    if (A.length === 0)
      break;
    const l = A.indexOf(pRe), c = sUn(A.substr(0, l)), { start: u, end: f, total: h } = ire(c["content-range"]), d = n + o.length + l + pRe.length, I = parseInt(f, 10) + 1 - parseInt(u, 10);
    i.push({
      headers: c,
      data: t.slice(d, d + I),
      offset: u,
      length: I,
      fileSize: h
    }), n = d + I + 4;
  }
  return i;
}
class Bq {
  /**
   *
   * @param {Slice[]} slices
   * @returns {ArrayBuffer[]}
   */
  async fetch(e, n = void 0) {
    return Promise.all(
      e.map((r) => this.fetchSlice(r, n))
    );
  }
  /**
   *
   * @param {Slice} slice
   * @returns {ArrayBuffer}
   */
  async fetchSlice(e) {
    throw new Error(`fetching of slice ${e} not possible, not implemented`);
  }
  /**
   * Returns the filesize if already determined and null otherwise
   */
  get fileSize() {
    return null;
  }
  async close() {
  }
}
class lUn extends Map {
  constructor(e = {}) {
    if (super(), !(e.maxSize && e.maxSize > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    if (typeof e.maxAge == "number" && e.maxAge === 0)
      throw new TypeError("`maxAge` must be a number greater than 0");
    this.maxSize = e.maxSize, this.maxAge = e.maxAge || Number.POSITIVE_INFINITY, this.onEviction = e.onEviction, this.cache = /* @__PURE__ */ new Map(), this.oldCache = /* @__PURE__ */ new Map(), this._size = 0;
  }
  // TODO: Use private class methods when targeting Node.js 16.
  _emitEvictions(e) {
    if (typeof this.onEviction == "function")
      for (const [n, r] of e)
        this.onEviction(n, r.value);
  }
  _deleteIfExpired(e, n) {
    return typeof n.expiry == "number" && n.expiry <= Date.now() ? (typeof this.onEviction == "function" && this.onEviction(e, n.value), this.delete(e)) : !1;
  }
  _getOrDeleteIfExpired(e, n) {
    if (this._deleteIfExpired(e, n) === !1)
      return n.value;
  }
  _getItemValue(e, n) {
    return n.expiry ? this._getOrDeleteIfExpired(e, n) : n.value;
  }
  _peek(e, n) {
    const r = n.get(e);
    return this._getItemValue(e, r);
  }
  _set(e, n) {
    this.cache.set(e, n), this._size++, this._size >= this.maxSize && (this._size = 0, this._emitEvictions(this.oldCache), this.oldCache = this.cache, this.cache = /* @__PURE__ */ new Map());
  }
  _moveToRecent(e, n) {
    this.oldCache.delete(e), this._set(e, n);
  }
  *_entriesAscending() {
    for (const e of this.oldCache) {
      const [n, r] = e;
      this.cache.has(n) || this._deleteIfExpired(n, r) === !1 && (yield e);
    }
    for (const e of this.cache) {
      const [n, r] = e;
      this._deleteIfExpired(n, r) === !1 && (yield e);
    }
  }
  get(e) {
    if (this.cache.has(e)) {
      const n = this.cache.get(e);
      return this._getItemValue(e, n);
    }
    if (this.oldCache.has(e)) {
      const n = this.oldCache.get(e);
      if (this._deleteIfExpired(e, n) === !1)
        return this._moveToRecent(e, n), n.value;
    }
  }
  set(e, n, { maxAge: r = this.maxAge } = {}) {
    const i = typeof r == "number" && r !== Number.POSITIVE_INFINITY ? Date.now() + r : void 0;
    this.cache.has(e) ? this.cache.set(e, {
      value: n,
      expiry: i
    }) : this._set(e, { value: n, expiry: i });
  }
  has(e) {
    return this.cache.has(e) ? !this._deleteIfExpired(e, this.cache.get(e)) : this.oldCache.has(e) ? !this._deleteIfExpired(e, this.oldCache.get(e)) : !1;
  }
  peek(e) {
    if (this.cache.has(e))
      return this._peek(e, this.cache);
    if (this.oldCache.has(e))
      return this._peek(e, this.oldCache);
  }
  delete(e) {
    const n = this.cache.delete(e);
    return n && this._size--, this.oldCache.delete(e) || n;
  }
  clear() {
    this.cache.clear(), this.oldCache.clear(), this._size = 0;
  }
  resize(e) {
    if (!(e && e > 0))
      throw new TypeError("`maxSize` must be a number greater than 0");
    const n = [...this._entriesAscending()], r = n.length - e;
    r < 0 ? (this.cache = new Map(n), this.oldCache = /* @__PURE__ */ new Map(), this._size = n.length) : (r > 0 && this._emitEvictions(n.slice(0, r)), this.oldCache = new Map(n.slice(r)), this.cache = /* @__PURE__ */ new Map(), this._size = 0), this.maxSize = e;
  }
  *keys() {
    for (const [e] of this)
      yield e;
  }
  *values() {
    for (const [, e] of this)
      yield e;
  }
  *[Symbol.iterator]() {
    for (const e of this.cache) {
      const [n, r] = e;
      this._deleteIfExpired(n, r) === !1 && (yield [n, r.value]);
    }
    for (const e of this.oldCache) {
      const [n, r] = e;
      this.cache.has(n) || this._deleteIfExpired(n, r) === !1 && (yield [n, r.value]);
    }
  }
  *entriesDescending() {
    let e = [...this.cache];
    for (let n = e.length - 1; n >= 0; --n) {
      const r = e[n], [i, o] = r;
      this._deleteIfExpired(i, o) === !1 && (yield [i, o.value]);
    }
    e = [...this.oldCache];
    for (let n = e.length - 1; n >= 0; --n) {
      const r = e[n], [i, o] = r;
      this.cache.has(i) || this._deleteIfExpired(i, o) === !1 && (yield [i, o.value]);
    }
  }
  *entriesAscending() {
    for (const [e, n] of this._entriesAscending())
      yield [e, n.value];
  }
  get size() {
    if (!this._size)
      return this.oldCache.size;
    let e = 0;
    for (const n of this.oldCache.keys())
      this.cache.has(n) || e++;
    return Math.min(this._size + e, this.maxSize);
  }
  entries() {
    return this.entriesAscending();
  }
  forEach(e, n = this) {
    for (const [r, i] of this.entriesAscending())
      e.call(n, i, r, this);
  }
  get [Symbol.toStringTag]() {
    return JSON.stringify([...this.entriesAscending()]);
  }
}
async function cUn(t) {
  return new Promise((e) => setTimeout(e, t));
}
function uUn(t, e) {
  const n = Array.isArray(t) ? t : Array.from(t), r = Array.isArray(e) ? e : Array.from(e);
  return n.map((i, o) => [i, r[o]]);
}
class sQ extends Error {
  constructor(e) {
    super(e), Error.captureStackTrace && Error.captureStackTrace(this, sQ), this.name = "AbortError";
  }
}
class fUn extends Error {
  constructor(e, n) {
    super(n), this.errors = e, this.message = n, this.name = "AggregateError";
  }
}
const gUn = fUn;
class hUn {
  /**
   *
   * @param {number} offset
   * @param {number} length
   * @param {ArrayBuffer} [data]
   */
  constructor(e, n, r = null) {
    this.offset = e, this.length = n, this.data = r;
  }
  /**
   * @returns {number} the top byte border
   */
  get top() {
    return this.offset + this.length;
  }
}
class IRe {
  /**
   *
   * @param {number} offset
   * @param {number} length
   * @param {number[]} blockIds
   */
  constructor(e, n, r) {
    this.offset = e, this.length = n, this.blockIds = r;
  }
}
class dUn extends Bq {
  /**
   *
   * @param {Source} source The underlying source that shall be blocked and cached
   * @param {object} options
   */
  constructor(e, { blockSize: n = 65536, cacheSize: r = 100 } = {}) {
    super(), this.source = e, this.blockSize = n, this.blockCache = new lUn({ maxSize: r }), this.blockRequests = /* @__PURE__ */ new Map(), this.blockIdsToFetch = /* @__PURE__ */ new Set(), this.abortedBlockIds = /* @__PURE__ */ new Set();
  }
  get fileSize() {
    return this.source.fileSize;
  }
  /**
   *
   * @param {basesource/Slice[]} slices
   */
  async fetch(e, n) {
    const r = [], i = [], o = [];
    for (const { offset: f, length: h } of e) {
      let d = f + h;
      const { fileSize: I } = this;
      I !== null && (d = Math.min(d, I));
      const m = Math.floor(f / this.blockSize) * this.blockSize;
      for (let C = m; C < d; C += this.blockSize) {
        const y = Math.floor(C / this.blockSize);
        !this.blockCache.has(y) && !this.blockRequests.has(y) && (this.blockIdsToFetch.add(y), i.push(y)), this.blockRequests.has(y) && r.push(this.blockRequests.get(y)), o.push(y);
      }
    }
    await cUn(), this.fetchBlocks(n);
    const s = [];
    for (const f of i)
      this.blockRequests.has(f) && s.push(this.blockRequests.get(f));
    await Promise.allSettled(r), await Promise.allSettled(s);
    const a = [], A = o.filter((f) => this.abortedBlockIds.has(f) || !this.blockCache.has(f));
    if (A.forEach((f) => this.blockIdsToFetch.add(f)), A.length > 0 && n && !n.aborted) {
      this.fetchBlocks(null);
      for (const f of A) {
        const h = this.blockRequests.get(f);
        if (!h)
          throw new Error(`Block ${f} is not in the block requests`);
        a.push(h);
      }
      await Promise.allSettled(a);
    }
    if (n && n.aborted)
      throw new sQ("Request was aborted");
    const l = o.map((f) => this.blockCache.get(f)), c = l.filter((f) => !f);
    if (c.length)
      throw new gUn(c, "Request failed");
    const u = new Map(uUn(o, l));
    return this.readSliceData(e, u);
  }
  /**
   *
   * @param {AbortSignal} signal
   */
  fetchBlocks(e) {
    if (this.blockIdsToFetch.size > 0) {
      const n = this.groupBlocks(this.blockIdsToFetch), r = this.source.fetch(n, e);
      for (let i = 0; i < n.length; ++i) {
        const o = n[i];
        for (const s of o.blockIds)
          this.blockRequests.set(s, (async () => {
            try {
              const a = (await r)[i], A = s * this.blockSize, l = A - a.offset, c = Math.min(l + this.blockSize, a.data.byteLength), u = a.data.slice(l, c), f = new hUn(
                A,
                u.byteLength,
                u,
                s
              );
              this.blockCache.set(s, f), this.abortedBlockIds.delete(s);
            } catch (a) {
              if (a.name === "AbortError")
                a.signal = e, this.blockCache.delete(s), this.abortedBlockIds.add(s);
              else
                throw a;
            } finally {
              this.blockRequests.delete(s);
            }
          })());
      }
      this.blockIdsToFetch.clear();
    }
  }
  /**
   *
   * @param {Set} blockIds
   * @returns {BlockGroup[]}
   */
  groupBlocks(e) {
    const n = Array.from(e).sort((s, a) => s - a);
    if (n.length === 0)
      return [];
    let r = [], i = null;
    const o = [];
    for (const s of n)
      i === null || i + 1 === s ? (r.push(s), i = s) : (o.push(new IRe(
        r[0] * this.blockSize,
        r.length * this.blockSize,
        r
      )), r = [s], i = s);
    return o.push(new IRe(
      r[0] * this.blockSize,
      r.length * this.blockSize,
      r
    )), o;
  }
  /**
   *
   * @param {Slice[]} slices
   * @param {Map} blocks
   */
  readSliceData(e, n) {
    return e.map((r) => {
      let i = r.offset + r.length;
      this.fileSize !== null && (i = Math.min(this.fileSize, i));
      const o = Math.floor(r.offset / this.blockSize), s = Math.floor(i / this.blockSize), a = new ArrayBuffer(r.length), A = new Uint8Array(a);
      for (let l = o; l <= s; ++l) {
        const c = n.get(l), u = c.offset - r.offset, f = c.top - i;
        let h = 0, d = 0, I;
        u < 0 ? h = -u : u > 0 && (d = u), f < 0 ? I = c.length - h : I = i - c.offset - h;
        const m = new Uint8Array(c.data, h, I);
        A.set(m, d);
      }
      return a;
    });
  }
}
class rfe {
  /**
   * Returns whether the response has an ok'ish status code
   */
  get ok() {
    return this.status >= 200 && this.status <= 299;
  }
  /**
   * Returns the status code of the response
   */
  get status() {
    throw new Error("not implemented");
  }
  /**
   * Returns the value of the specified header
   * @param {string} headerName the header name
   * @returns {string} the header value
   */
  getHeader(e) {
    throw new Error("not implemented");
  }
  /**
   * @returns {ArrayBuffer} the response data of the request
   */
  async getData() {
    throw new Error("not implemented");
  }
}
class ife {
  constructor(e) {
    this.url = e;
  }
  /**
   * Send a request with the options
   * @param {object} [options]
   */
  async request({ headers: e, credentials: n, signal: r } = {}) {
    throw new Error("request is not implemented");
  }
}
class pUn extends rfe {
  /**
   * BaseResponse facade for fetch API Response
   * @param {Response} response
   */
  constructor(e) {
    super(), this.response = e;
  }
  get status() {
    return this.response.status;
  }
  getHeader(e) {
    return this.response.headers.get(e);
  }
  async getData() {
    return this.response.arrayBuffer ? await this.response.arrayBuffer() : (await this.response.buffer()).buffer;
  }
}
class IUn extends ife {
  constructor(e, n) {
    super(e), this.credentials = n;
  }
  async request({ headers: e, credentials: n, signal: r } = {}) {
    const i = await fetch(this.url, {
      headers: e,
      credentials: n,
      signal: r
    });
    return new pUn(i);
  }
}
class mUn extends rfe {
  /**
   * BaseResponse facade for XMLHttpRequest
   * @param {XMLHttpRequest} xhr
   * @param {ArrayBuffer} data
   */
  constructor(e, n) {
    super(), this.xhr = e, this.data = n;
  }
  get status() {
    return this.xhr.status;
  }
  getHeader(e) {
    return this.xhr.getResponseHeader(e);
  }
  async getData() {
    return this.data;
  }
}
class CUn extends ife {
  constructRequest(e, n) {
    return new Promise((r, i) => {
      const o = new XMLHttpRequest();
      o.open("GET", this.url), o.responseType = "arraybuffer";
      for (const [s, a] of Object.entries(e))
        o.setRequestHeader(s, a);
      o.onload = () => {
        const s = o.response;
        r(new mUn(o, s));
      }, o.onerror = i, o.onabort = () => i(new sQ("Request aborted")), o.send(), n && (n.aborted && o.abort(), n.addEventListener("abort", () => o.abort()));
    });
  }
  async request({ headers: e, signal: n } = {}) {
    return await this.constructRequest(e, n);
  }
}
class EUn extends rfe {
  /**
   * BaseResponse facade for node HTTP/HTTPS API Response
   * @param {http.ServerResponse} response
   */
  constructor(e, n) {
    super(), this.response = e, this.dataPromise = n;
  }
  get status() {
    return this.response.statusCode;
  }
  getHeader(e) {
    return this.response.headers[e];
  }
  async getData() {
    return await this.dataPromise;
  }
}
class yUn extends ife {
  constructor(e) {
    super(e), this.parsedUrl = Sv.parse(this.url), this.httpApi = (this.parsedUrl.protocol === "http:", Sv);
  }
  constructRequest(e, n) {
    return new Promise((r, i) => {
      const o = this.httpApi.get(
        {
          ...this.parsedUrl,
          headers: e
        },
        (s) => {
          const a = new Promise((A) => {
            const l = [];
            s.on("data", (c) => {
              l.push(c);
            }), s.on("end", () => {
              const c = Buffer.concat(l).buffer;
              A(c);
            }), s.on("error", i);
          });
          r(new EUn(s, a));
        }
      );
      o.on("error", i), n && (n.aborted && o.destroy(new sQ("Request aborted")), n.addEventListener("abort", () => o.destroy(new sQ("Request aborted"))));
    });
  }
  async request({ headers: e, signal: n } = {}) {
    return await this.constructRequest(e, n);
  }
}
class ofe extends Bq {
  /**
   *
   * @param {BaseClient} client
   * @param {object} headers
   * @param {numbers} maxRanges
   * @param {boolean} allowFullFile
   */
  constructor(e, n, r, i) {
    super(), this.client = e, this.headers = n, this.maxRanges = r, this.allowFullFile = i, this._fileSize = null;
  }
  /**
   *
   * @param {Slice[]} slices
   */
  async fetch(e, n) {
    return this.maxRanges >= e.length ? this.fetchSlices(e, n) : (this.maxRanges > 0 && e.length > 1, Promise.all(
      e.map((r) => this.fetchSlice(r, n))
    ));
  }
  async fetchSlices(e, n) {
    const r = await this.client.request({
      headers: {
        ...this.headers,
        Range: `bytes=${e.map(({ offset: i, length: o }) => `${i}-${i + o}`).join(",")}`
      },
      signal: n
    });
    if (r.ok)
      if (r.status === 206) {
        const { type: i, params: o } = aUn(r.getHeader("content-type"));
        if (i === "multipart/byteranges") {
          const u = AUn(await r.getData(), o.boundary);
          return this._fileSize = u[0].fileSize || null, u;
        }
        const s = await r.getData(), { start: a, end: A, total: l } = ire(r.getHeader("content-range"));
        this._fileSize = l || null;
        const c = [{
          data: s,
          offset: a,
          length: A - a
        }];
        if (e.length > 1) {
          const u = await Promise.all(e.slice(1).map((f) => this.fetchSlice(f, n)));
          return c.concat(u);
        }
        return c;
      } else {
        if (!this.allowFullFile)
          throw new Error("Server responded with full file");
        const i = await r.getData();
        return this._fileSize = i.byteLength, [{
          data: i,
          offset: 0,
          length: i.byteLength
        }];
      }
    else
      throw new Error("Error fetching data.");
  }
  async fetchSlice(e, n) {
    const { offset: r, length: i } = e, o = await this.client.request({
      headers: {
        ...this.headers,
        Range: `bytes=${r}-${r + i}`
      },
      signal: n
    });
    if (o.ok)
      if (o.status === 206) {
        const s = await o.getData(), { total: a } = ire(o.getHeader("content-range"));
        return this._fileSize = a || null, {
          data: s,
          offset: r,
          length: i
        };
      } else {
        if (!this.allowFullFile)
          throw new Error("Server responded with full file");
        const s = await o.getData();
        return this._fileSize = s.byteLength, {
          data: s,
          offset: 0,
          length: s.byteLength
        };
      }
    else
      throw new Error("Error fetching data.");
  }
  get fileSize() {
    return this._fileSize;
  }
}
function sfe(t, { blockSize: e, cacheSize: n }) {
  return e === null ? t : new dUn(t, { blockSize: e, cacheSize: n });
}
function vUn(t, { headers: e = {}, credentials: n, maxRanges: r = 0, allowFullFile: i = !1, ...o } = {}) {
  const s = new IUn(t, n), a = new ofe(s, e, r, i);
  return sfe(a, o);
}
function BUn(t, { headers: e = {}, maxRanges: n = 0, allowFullFile: r = !1, ...i } = {}) {
  const o = new CUn(t), s = new ofe(o, e, n, r);
  return sfe(s, i);
}
function bUn(t, { headers: e = {}, maxRanges: n = 0, allowFullFile: r = !1, ...i } = {}) {
  const o = new yUn(t), s = new ofe(o, e, n, r);
  return sfe(s, i);
}
function _Un(t, { forceXHR: e = !1, ...n } = {}) {
  return typeof fetch == "function" && !e ? vUn(t, n) : typeof XMLHttpRequest < "u" ? BUn(t, n) : bUn(t, n);
}
class SUn extends Bq {
  constructor(e) {
    super(), this.file = e;
  }
  async fetchSlice(e, n) {
    return new Promise((r, i) => {
      const o = this.file.slice(e.offset, e.offset + e.length), s = new FileReader();
      s.onload = (a) => r(a.target.result), s.onerror = i, s.onabort = i, s.readAsArrayBuffer(o), n && n.addEventListener("abort", () => s.abort());
    });
  }
}
function QUn(t) {
  return new SUn(t);
}
function wUn(t) {
  return new Promise((e, n) => {
    Sv.close(t, (r) => {
      r ? n(r) : e();
    });
  });
}
function xUn(t, e, n = void 0) {
  return new Promise((r, i) => {
    Sv.open(t, e, n, (o, s) => {
      o ? i(o) : r(s);
    });
  });
}
function RUn(...t) {
  return new Promise((e, n) => {
    Sv.read(...t, (r, i, o) => {
      r ? n(r) : e({ bytesRead: i, buffer: o });
    });
  });
}
class DUn extends Bq {
  constructor(e) {
    super(), this.path = e, this.openRequest = xUn(e, "r");
  }
  async fetchSlice(e) {
    const n = await this.openRequest, { buffer: r } = await RUn(
      n,
      Buffer.alloc(e.length),
      0,
      e.length,
      e.offset
    );
    return r.buffer;
  }
  async close() {
    const e = await this.openRequest;
    await wUn(e);
  }
}
function TUn(t) {
  return new DUn(t);
}
function NUn(t, e) {
  let n = t.length - e, r = 0;
  do {
    for (let i = e; i > 0; i--)
      t[r + e] += t[r], r++;
    n -= e;
  } while (n > 0);
}
function LUn(t, e, n) {
  let r = 0, i = t.length;
  const o = i / n;
  for (; i > e; ) {
    for (let a = e; a > 0; --a)
      t[r + e] += t[r], ++r;
    i -= e;
  }
  const s = t.slice();
  for (let a = 0; a < o; ++a)
    for (let A = 0; A < n; ++A)
      t[n * a + A] = s[(n - A - 1) * o + a];
}
function MUn(t, e, n, r, i, o) {
  if (!e || e === 1)
    return t;
  for (let A = 0; A < i.length; ++A) {
    if (i[A] % 8 !== 0)
      throw new Error("When decoding with predictor, only multiple of 8 bits are supported.");
    if (i[A] !== i[0])
      throw new Error("When decoding with predictor, all samples must have the same size.");
  }
  const s = i[0] / 8, a = o === 2 ? 1 : i.length;
  for (let A = 0; A < r && !(A * a * n * s >= t.byteLength); ++A) {
    let l;
    if (e === 2) {
      switch (i[0]) {
        case 8:
          l = new Uint8Array(
            t,
            A * a * n * s,
            a * n * s
          );
          break;
        case 16:
          l = new Uint16Array(
            t,
            A * a * n * s,
            a * n * s / 2
          );
          break;
        case 32:
          l = new Uint32Array(
            t,
            A * a * n * s,
            a * n * s / 4
          );
          break;
        default:
          throw new Error(`Predictor 2 not allowed with ${i[0]} bits per sample.`);
      }
      NUn(l, a);
    } else
      e === 3 && (l = new Uint8Array(
        t,
        A * a * n * s,
        a * n * s
      ), LUn(l, a, s));
  }
  return t;
}
class OUn {
  async decode(e, n) {
    const r = await this.decodeBlock(n), i = e.Predictor || 1;
    if (i !== 1) {
      const o = !e.StripOffsets, s = o ? e.TileWidth : e.ImageWidth, a = o ? e.TileLength : e.RowsPerStrip || e.ImageLength;
      return MUn(
        r,
        i,
        s,
        a,
        e.BitsPerSample,
        e.PlanarConfiguration
      );
    }
    return r;
  }
}
function ore(t) {
  switch (t) {
    case oi.BYTE:
    case oi.ASCII:
    case oi.SBYTE:
    case oi.UNDEFINED:
      return 1;
    case oi.SHORT:
    case oi.SSHORT:
      return 2;
    case oi.LONG:
    case oi.SLONG:
    case oi.FLOAT:
    case oi.IFD:
      return 4;
    case oi.RATIONAL:
    case oi.SRATIONAL:
    case oi.DOUBLE:
    case oi.LONG8:
    case oi.SLONG8:
    case oi.IFD8:
      return 8;
    default:
      throw new RangeError(`Invalid field type: ${t}`);
  }
}
function FUn(t) {
  const e = t.GeoKeyDirectory;
  if (!e)
    return null;
  const n = {};
  for (let r = 4; r <= e[3] * 4; r += 4) {
    const i = F4n[e[r]], o = e[r + 1] ? DD[e[r + 1]] : null, s = e[r + 2], a = e[r + 3];
    let A = null;
    if (!o)
      A = a;
    else {
      if (A = t[o], typeof A > "u" || A === null)
        throw new Error(`Could not get value of geoKey '${i}'.`);
      typeof A == "string" ? A = A.substring(a, a + s - 1) : A.subarray && (A = A.subarray(a, a + s), s === 1 && (A = A[0]));
    }
    n[i] = A;
  }
  return n;
}
function vb(t, e, n, r) {
  let i = null, o = null;
  const s = ore(e);
  switch (e) {
    case oi.BYTE:
    case oi.ASCII:
    case oi.UNDEFINED:
      i = new Uint8Array(n), o = t.readUint8;
      break;
    case oi.SBYTE:
      i = new Int8Array(n), o = t.readInt8;
      break;
    case oi.SHORT:
      i = new Uint16Array(n), o = t.readUint16;
      break;
    case oi.SSHORT:
      i = new Int16Array(n), o = t.readInt16;
      break;
    case oi.LONG:
    case oi.IFD:
      i = new Uint32Array(n), o = t.readUint32;
      break;
    case oi.SLONG:
      i = new Int32Array(n), o = t.readInt32;
      break;
    case oi.LONG8:
    case oi.IFD8:
      i = new Array(n), o = t.readUint64;
      break;
    case oi.SLONG8:
      i = new Array(n), o = t.readInt64;
      break;
    case oi.RATIONAL:
      i = new Uint32Array(n * 2), o = t.readUint32;
      break;
    case oi.SRATIONAL:
      i = new Int32Array(n * 2), o = t.readInt32;
      break;
    case oi.FLOAT:
      i = new Float32Array(n), o = t.readFloat32;
      break;
    case oi.DOUBLE:
      i = new Float64Array(n), o = t.readFloat64;
      break;
    default:
      throw new RangeError(`Invalid field type: ${e}`);
  }
  if (e === oi.RATIONAL || e === oi.SRATIONAL)
    for (let a = 0; a < n; a += 2)
      i[a] = o.call(
        t,
        r + a * s
      ), i[a + 1] = o.call(
        t,
        r + (a * s + 4)
      );
  else
    for (let a = 0; a < n; ++a)
      i[a] = o.call(
        t,
        r + a * s
      );
  return e === oi.ASCII ? new TextDecoder("utf-8").decode(i) : i;
}
class PUn {
  constructor(e, n, r) {
    this.fileDirectory = e, this.geoKeyDirectory = n, this.nextIFDByteOffset = r;
  }
}
class $P extends Error {
  constructor(e) {
    super(`No image at index ${e}`), this.index = e;
  }
}
class kUn {
  /**
   * (experimental) Reads raster data from the best fitting image. This function uses
   * the image with the lowest resolution that is still a higher resolution than the
   * requested resolution.
   * When specified, the `bbox` option is translated to the `window` option and the
   * `resX` and `resY` to `width` and `height` respectively.
   * Then, the [readRasters]{@link GeoTIFFImage#readRasters} method of the selected
   * image is called and the result returned.
   * @see GeoTIFFImage.readRasters
   * @param {import('./geotiffimage').ReadRasterOptions} [options={}] optional parameters
   * @returns {Promise<(TypedArray|TypedArray[])>} the decoded arrays as a promise
   */
  async readRasters(e = {}) {
    const { window: n, width: r, height: i } = e;
    let { resX: o, resY: s, bbox: a } = e;
    const A = await this.getImage();
    let l = A;
    const c = await this.getImageCount(), u = A.getBoundingBox();
    if (n && a)
      throw new Error('Both "bbox" and "window" passed.');
    if (r || i) {
      if (n) {
        const [d, I] = A.getOrigin(), [m, C] = A.getResolution();
        a = [
          d + n[0] * m,
          I + n[1] * C,
          d + n[2] * m,
          I + n[3] * C
        ];
      }
      const h = a || u;
      if (r) {
        if (o)
          throw new Error("Both width and resX passed");
        o = (h[2] - h[0]) / r;
      }
      if (i) {
        if (s)
          throw new Error("Both width and resY passed");
        s = (h[3] - h[1]) / i;
      }
    }
    if (o || s) {
      const h = [];
      for (let d = 0; d < c; ++d) {
        const I = await this.getImage(d), { SubfileType: m, NewSubfileType: C } = I.fileDirectory;
        (d === 0 || m === 2 || C & 1) && h.push(I);
      }
      h.sort((d, I) => d.getWidth() - I.getWidth());
      for (let d = 0; d < h.length; ++d) {
        const I = h[d], m = (u[2] - u[0]) / I.getWidth(), C = (u[3] - u[1]) / I.getHeight();
        if (l = I, o && o > m || s && s > C)
          break;
      }
    }
    let f = n;
    if (a) {
      const [h, d] = A.getOrigin(), [I, m] = l.getResolution(A);
      f = [
        Math.round((a[0] - h) / I),
        Math.round((a[1] - d) / m),
        Math.round((a[2] - h) / I),
        Math.round((a[3] - d) / m)
      ], f = [
        Math.min(f[0], f[2]),
        Math.min(f[1], f[3]),
        Math.max(f[0], f[2]),
        Math.max(f[1], f[3])
      ];
    }
    return l.readRasters({ ...e, window: f });
  }
}
class UM extends kUn {
  /**
   * @constructor
   * @param {*} source The datasource to read from.
   * @param {boolean} littleEndian Whether the image uses little endian.
   * @param {boolean} bigTiff Whether the image uses bigTIFF conventions.
   * @param {number} firstIFDOffset The numeric byte-offset from the start of the image
   *                                to the first IFD.
   * @param {GeoTIFFOptions} [options] further options.
   */
  constructor(e, n, r, i, o = {}) {
    super(), this.source = e, this.littleEndian = n, this.bigTiff = r, this.firstIFDOffset = i, this.cache = o.cache || !1, this.ifdRequests = [], this.ghostValues = null;
  }
  async getSlice(e, n) {
    const r = this.bigTiff ? 4048 : 1024;
    return new oUn(
      (await this.source.fetch([{
        offset: e,
        length: typeof n < "u" ? n : r
      }]))[0],
      e,
      this.littleEndian,
      this.bigTiff
    );
  }
  /**
   * Instructs to parse an image file directory at the given file offset.
   * As there is no way to ensure that a location is indeed the start of an IFD,
   * this function must be called with caution (e.g only using the IFD offsets from
   * the headers or other IFDs).
   * @param {number} offset the offset to parse the IFD at
   * @returns {Promise<ImageFileDirectory>} the parsed IFD
   */
  async parseFileDirectoryAt(e) {
    const n = this.bigTiff ? 20 : 12, r = this.bigTiff ? 8 : 2;
    let i = await this.getSlice(e);
    const o = this.bigTiff ? i.readUint64(e) : i.readUint16(e), s = o * n + (this.bigTiff ? 16 : 6);
    i.covers(e, s) || (i = await this.getSlice(e, s));
    const a = {};
    let A = e + (this.bigTiff ? 8 : 2);
    for (let u = 0; u < o; A += n, ++u) {
      const f = i.readUint16(A), h = i.readUint16(A + 2), d = this.bigTiff ? i.readUint64(A + 4) : i.readUint32(A + 4);
      let I, m;
      const C = ore(h), y = A + (this.bigTiff ? 12 : 8);
      if (C * d <= (this.bigTiff ? 8 : 4))
        I = vb(i, h, d, y);
      else {
        const v = i.readOffset(y), b = ore(h) * d;
        if (i.covers(v, b))
          I = vb(i, h, d, v);
        else {
          const Q = await this.getSlice(v, b);
          I = vb(Q, h, d, v);
        }
      }
      d === 1 && M4n.indexOf(f) === -1 && !(h === oi.RATIONAL || h === oi.SRATIONAL) ? m = I[0] : m = I, a[DD[f]] = m;
    }
    const l = FUn(a), c = i.readOffset(
      e + r + n * o
    );
    return new PUn(
      a,
      l,
      c
    );
  }
  async requestIFD(e) {
    if (this.ifdRequests[e])
      return this.ifdRequests[e];
    if (e === 0)
      return this.ifdRequests[e] = this.parseFileDirectoryAt(this.firstIFDOffset), this.ifdRequests[e];
    if (!this.ifdRequests[e - 1])
      try {
        this.ifdRequests[e - 1] = this.requestIFD(e - 1);
      } catch (n) {
        throw n instanceof $P ? new $P(e) : n;
      }
    return this.ifdRequests[e] = (async () => {
      const n = await this.ifdRequests[e - 1];
      if (n.nextIFDByteOffset === 0)
        throw new $P(e);
      return this.parseFileDirectoryAt(n.nextIFDByteOffset);
    })(), this.ifdRequests[e];
  }
  /**
   * Get the n-th internal subfile of an image. By default, the first is returned.
   *
   * @param {number} [index=0] the index of the image to return.
   * @returns {Promise<GeoTIFFImage>} the image at the given index
   */
  async getImage(e = 0) {
    const n = await this.requestIFD(e);
    return new fJe(
      n.fileDirectory,
      n.geoKeyDirectory,
      this.dataView,
      this.littleEndian,
      this.cache,
      this.source
    );
  }
  /**
   * Returns the count of the internal subfiles.
   *
   * @returns {Promise<number>} the number of internal subfile images
   */
  async getImageCount() {
    let e = 0, n = !0;
    for (; n; )
      try {
        await this.requestIFD(e), ++e;
      } catch (r) {
        if (r instanceof $P)
          n = !1;
        else
          throw r;
      }
    return e;
  }
  /**
   * Get the values of the COG ghost area as a parsed map.
   * See https://gdal.org/drivers/raster/cog.html#header-ghost-area for reference
   * @returns {Promise<Object>} the parsed ghost area or null, if no such area was found
   */
  async getGhostValues() {
    const e = this.bigTiff ? 16 : 8;
    if (this.ghostValues)
      return this.ghostValues;
    const n = "GDAL_STRUCTURAL_METADATA_SIZE=", r = n.length + 100;
    let i = await this.getSlice(e, r);
    if (n === vb(i, oi.ASCII, n.length, e)) {
      const s = vb(i, oi.ASCII, r, e).split(`
`)[0], a = Number(s.split("=")[1].split(" ")[0]) + s.length;
      a > r && (i = await this.getSlice(e, a));
      const A = vb(i, oi.ASCII, a, e);
      this.ghostValues = {}, A.split(`
`).filter((l) => l.length > 0).map((l) => l.split("=")).forEach(([l, c]) => {
        this.ghostValues[l] = c;
      });
    }
    return this.ghostValues;
  }
  /**
   * Parse a (Geo)TIFF file from the given source.
   *
   * @param {*} source The source of data to parse from.
   * @param {GeoTIFFOptions} [options] Additional options.
   * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
   *                               to be aborted
   */
  static async fromSource(e, n, r) {
    const i = (await e.fetch([{ offset: 0, length: 1024 }], r))[0], o = new iUn(i), s = o.getUint16(0, 0);
    let a;
    if (s === 18761)
      a = !0;
    else if (s === 19789)
      a = !1;
    else
      throw new TypeError("Invalid byte order value.");
    const A = o.getUint16(2, a);
    let l;
    if (A === 42)
      l = !1;
    else if (A === 43) {
      if (l = !0, o.getUint16(4, a) !== 8)
        throw new Error("Unsupported offset byte-size.");
    } else
      throw new TypeError("Invalid magic number.");
    const c = l ? o.getUint64(8, a) : o.getUint32(4, a);
    return new UM(e, a, l, c, n);
  }
  /**
   * Closes the underlying file buffer
   * N.B. After the GeoTIFF has been completely processed it needs
   * to be closed but only if it has been constructed from a file.
   */
  close() {
    return typeof this.source.close == "function" ? this.source.close() : !1;
  }
}
async function GUn(t, e = {}, n) {
  return UM.fromSource(_Un(t, e), n);
}
async function UUn(t, e) {
  return UM.fromSource(TUn(t), e);
}
async function HUn(t, e) {
  return UM.fromSource(QUn(t), e);
}
let Oh, qP = null;
function mRe() {
  return qP !== null && qP.buffer === Oh.memory.buffer || (qP = new Uint8Array(Oh.memory.buffer)), qP;
}
let CRe = 0, jP = null;
function ERe() {
  return jP !== null && jP.buffer === Oh.memory.buffer || (jP = new Int32Array(Oh.memory.buffer)), jP;
}
async function afe(t) {
  t === void 0 && (t = "".replace(/\.js$/, "_bg.wasm")), (typeof t == "string" || typeof Request == "function" && t instanceof Request || typeof URL == "function" && t instanceof URL) && (t = fetch(t));
  const { instance: e, module: n } = await async function(r, i) {
    if (typeof Response == "function" && r instanceof Response) {
      if (typeof WebAssembly.instantiateStreaming == "function")
        try {
          return await WebAssembly.instantiateStreaming(r, i);
        } catch (s) {
          if (r.headers.get("Content-Type") == "application/wasm")
            throw s;
          console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", s);
        }
      const o = await r.arrayBuffer();
      return await WebAssembly.instantiate(o, i);
    }
    {
      const o = await WebAssembly.instantiate(r, i);
      return o instanceof WebAssembly.Instance ? { instance: o, module: r } : o;
    }
  }(await t, {});
  return Oh = e.exports, afe.__wbindgen_wasm_module = n, Oh;
}
var $Un = Object.freeze({ __proto__: null, decompress: function(t, e) {
  try {
    const l = Oh.__wbindgen_add_to_stack_pointer(-16);
    var n = function(c, u) {
      const f = u(1 * c.length);
      return mRe().set(c, f / 1), CRe = c.length, f;
    }(t, Oh.__wbindgen_malloc), r = CRe;
    Oh.decompress(l, n, r, e);
    var i = ERe()[l / 4 + 0], o = ERe()[l / 4 + 1], s = (a = i, A = o, mRe().subarray(a / 1, a / 1 + A)).slice();
    return Oh.__wbindgen_free(i, 1 * o), s;
  } finally {
    Oh.__wbindgen_add_to_stack_pointer(16);
  }
  var a, A;
}, default: afe });
const qUn = [62, 0, 0, 0, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 0, 0, 0, 0, 0, 0, 0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 0, 0, 0, 0, 0, 0, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51];
function YP(t) {
  return qUn[t - 43];
}
const jUn = function(t) {
  let e, n = t.endsWith("==") ? 2 : t.endsWith("=") ? 1 : 0, r = t.length, i = new Uint8Array(r / 4 * 3);
  for (let o = 0, s = 0; o < r; o += 4, s += 3)
    e = YP(t.charCodeAt(o)) << 18 | YP(t.charCodeAt(o + 1)) << 12 | YP(t.charCodeAt(o + 2)) << 6 | YP(t.charCodeAt(o + 3)), i[s] = e >> 16, i[s + 1] = e >> 8 & 255, i[s + 2] = 255 & e;
  return i.subarray(0, i.length - n);
}("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");
let PJ;
async function YUn(t, e) {
  PJ || (PJ = await (async () => (await afe(jUn), $Un))());
  const n = PJ.decompress(t, e);
  if (n.length === 0)
    throw Error("Failed to decode with LZW decoder.");
  return n;
}
function D2(t, e, n, r, i) {
  hJe(t, e, n || 0, r || t.length - 1, i || zUn);
}
function hJe(t, e, n, r, i) {
  for (; r > n; ) {
    if (r - n > 600) {
      var o = r - n + 1, s = e - n + 1, a = Math.log(o), A = 0.5 * Math.exp(2 * a / 3), l = 0.5 * Math.sqrt(a * A * (o - A) / o) * (s - o / 2 < 0 ? -1 : 1), c = Math.max(n, Math.floor(e - s * A / o + l)), u = Math.min(r, Math.floor(e + (o - s) * A / o + l));
      hJe(t, e, c, u, i);
    }
    var f = t[e], h = n, d = r;
    for (T2(t, n, e), i(t[r], f) > 0 && T2(t, n, r); h < d; ) {
      for (T2(t, h, d), h++, d--; i(t[h], f) < 0; )
        h++;
      for (; i(t[d], f) > 0; )
        d--;
    }
    i(t[n], f) === 0 ? T2(t, n, d) : (d++, T2(t, d, r)), d <= e && (n = d + 1), e <= d && (r = d - 1);
  }
}
function T2(t, e, n) {
  var r = t[e];
  t[e] = t[n], t[n] = r;
}
function zUn(t, e) {
  return t < e ? -1 : t > e ? 1 : 0;
}
var dJe = {}, pJe = {}, zp = {};
(function(t) {
  const e = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", n = e + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040", r = "[" + e + "][" + n + "]*", i = new RegExp("^" + r + "$"), o = function(a, A) {
    const l = [];
    let c = A.exec(a);
    for (; c; ) {
      const u = [];
      u.startIndex = A.lastIndex - c[0].length;
      const f = c.length;
      for (let h = 0; h < f; h++)
        u.push(c[h]);
      l.push(u), c = A.exec(a);
    }
    return l;
  }, s = function(a) {
    const A = i.exec(a);
    return !(A === null || typeof A > "u");
  };
  t.isExist = function(a) {
    return typeof a < "u";
  }, t.isEmptyObject = function(a) {
    return Object.keys(a).length === 0;
  }, t.merge = function(a, A, l) {
    if (A) {
      const c = Object.keys(A), u = c.length;
      for (let f = 0; f < u; f++)
        l === "strict" ? a[c[f]] = [A[c[f]]] : a[c[f]] = A[c[f]];
    }
  }, t.getValue = function(a) {
    return t.isExist(a) ? a : "";
  }, t.buildOptions = function(a, A, l) {
    let c = {};
    if (!a)
      return A;
    for (let u = 0; u < l.length; u++)
      a[l[u]] !== void 0 ? c[l[u]] = a[l[u]] : c[l[u]] = A[l[u]];
    return c;
  }, t.isTagNameInArrayMode = function(a, A, l) {
    return A === !1 ? !1 : A instanceof RegExp ? A.test(a) : typeof A == "function" ? !!A(a, l) : A === "strict";
  }, t.isName = s, t.getAllMatches = o, t.nameRegexp = r;
})(zp);
const vy = zp, sre = function(t, e, n) {
  const r = {};
  if (!e.alwaysCreateTextNode && (!t.child || vy.isEmptyObject(t.child)) && (!t.attrsMap || vy.isEmptyObject(t.attrsMap)))
    return vy.isExist(t.val) ? t.val : "";
  if (vy.isExist(t.val) && !(typeof t.val == "string" && (t.val === "" || t.val === e.cdataPositionChar))) {
    const o = vy.isTagNameInArrayMode(t.tagname, e.arrayMode, n);
    r[e.textNodeName] = o ? [t.val] : t.val;
  }
  vy.merge(r, t.attrsMap, e.arrayMode);
  const i = Object.keys(t.child);
  for (let o = 0; o < i.length; o++) {
    const s = i[o];
    if (t.child[s] && t.child[s].length > 1) {
      r[s] = [];
      for (let a in t.child[s])
        t.child[s].hasOwnProperty(a) && r[s].push(sre(t.child[s][a], e, s));
    } else {
      const a = sre(t.child[s][0], e, s), A = e.arrayMode === !0 && typeof a == "object" || vy.isTagNameInArrayMode(s, e.arrayMode, n);
      r[s] = A ? [a] : a;
    }
  }
  return r;
};
pJe.convertToJson = sre;
var cB = {}, VUn = function(t, e, n) {
  this.tagname = t, this.parent = e, this.child = {}, this.attrsMap = {}, this.val = n, this.addChild = function(r) {
    Array.isArray(this.child[r.tagname]) ? this.child[r.tagname].push(r) : this.child[r.tagname] = [r];
  };
};
const JUn = /^[-+]?0x[a-fA-F0-9]+$/, KUn = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
!Number.parseInt && window.parseInt && (Number.parseInt = window.parseInt);
!Number.parseFloat && window.parseFloat && (Number.parseFloat = window.parseFloat);
const WUn = {
  hex: !0,
  leadingZeros: !0,
  decimalPoint: ".",
  eNotation: !0
  //skipLike: /regex/
};
function XUn(t, e = {}) {
  if (e = Object.assign({}, WUn, e), !t || typeof t != "string")
    return t;
  let n = t.trim();
  if (e.skipLike !== void 0 && e.skipLike.test(n))
    return t;
  if (e.hex && JUn.test(n))
    return Number.parseInt(n, 16);
  {
    const r = KUn.exec(n);
    if (r) {
      const i = r[1], o = r[2];
      let s = ZUn(r[3]);
      const a = r[4] || r[6];
      if (!e.leadingZeros && o.length > 0 && i && n[2] !== ".")
        return t;
      if (!e.leadingZeros && o.length > 0 && !i && n[1] !== ".")
        return t;
      {
        const A = Number(n), l = "" + A;
        return l.search(/[eE]/) !== -1 || a ? e.eNotation ? A : t : n.indexOf(".") !== -1 ? l === "0" && s === "" || l === s || i && l === "-" + s ? A : t : o ? s === l || i + s === l ? A : t : n === l || n === i + l ? A : t;
      }
    } else
      return t;
  }
}
function ZUn(t) {
  return t && t.indexOf(".") !== -1 && (t = t.replace(/0+$/, ""), t === "." ? t = "0" : t[0] === "." ? t = "0" + t : t[t.length - 1] === "." && (t = t.substr(0, t.length - 1))), t;
}
var e8n = XUn;
const cv = zp, t8n = zp.buildOptions, zP = VUn, n8n = e8n;
"<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)".replace(/NAME/g, cv.nameRegexp);
!Number.parseInt && window.parseInt && (Number.parseInt = window.parseInt);
!Number.parseFloat && window.parseFloat && (Number.parseFloat = window.parseFloat);
const IJe = {
  attributeNamePrefix: "@_",
  attrNodeName: !1,
  textNodeName: "#text",
  ignoreAttributes: !0,
  ignoreNameSpace: !1,
  allowBooleanAttributes: !1,
  //a tag can have attributes without any value
  //ignoreRootElement : false,
  parseNodeValue: !0,
  parseAttributeValue: !1,
  arrayMode: !1,
  trimValues: !0,
  //Trim string values of tag and attributes
  cdataTagName: !1,
  cdataPositionChar: "\\c",
  numParseOptions: {
    hex: !0,
    leadingZeros: !0
  },
  tagValueProcessor: function(t, e) {
    return t;
  },
  attrValueProcessor: function(t, e) {
    return t;
  },
  stopNodes: [],
  alwaysCreateTextNode: !1
  //decodeStrict: false,
};
cB.defaultOptions = IJe;
const mJe = [
  "attributeNamePrefix",
  "attrNodeName",
  "textNodeName",
  "ignoreAttributes",
  "ignoreNameSpace",
  "allowBooleanAttributes",
  "parseNodeValue",
  "parseAttributeValue",
  "arrayMode",
  "trimValues",
  "cdataTagName",
  "cdataPositionChar",
  "tagValueProcessor",
  "attrValueProcessor",
  "parseTrueNumberOnly",
  "numParseOptions",
  "stopNodes",
  "alwaysCreateTextNode"
];
cB.props = mJe;
function VP(t, e, n) {
  return e && (n.trimValues && (e = e.trim()), e = n.tagValueProcessor(e, t), e = CJe(e, n.parseNodeValue, n.numParseOptions)), e;
}
function r8n(t, e) {
  if (e.ignoreNameSpace) {
    const n = t.split(":"), r = t.charAt(0) === "/" ? "/" : "";
    if (n[0] === "xmlns")
      return "";
    n.length === 2 && (t = r + n[1]);
  }
  return t;
}
function CJe(t, e, n) {
  if (e && typeof t == "string") {
    const r = t.trim();
    return r === "true" ? !0 : r === "false" ? !1 : n8n(t, n);
  } else
    return cv.isExist(t) ? t : "";
}
const i8n = new RegExp(`([^\\s=]+)\\s*(=\\s*(['"])(.*?)\\3)?`, "g");
function yRe(t, e) {
  if (!e.ignoreAttributes && typeof t == "string") {
    t = t.replace(/\r?\n/g, " ");
    const n = cv.getAllMatches(t, i8n), r = n.length, i = {};
    for (let o = 0; o < r; o++) {
      const s = r8n(n[o][1], e);
      s.length && (n[o][4] !== void 0 ? (e.trimValues && (n[o][4] = n[o][4].trim()), n[o][4] = e.attrValueProcessor(n[o][4], s), i[e.attributeNamePrefix + s] = CJe(
        n[o][4],
        e.parseAttributeValue,
        e.numParseOptions
      )) : e.allowBooleanAttributes && (i[e.attributeNamePrefix + s] = !0));
    }
    if (!Object.keys(i).length)
      return;
    if (e.attrNodeName) {
      const o = {};
      return o[e.attrNodeName] = i, o;
    }
    return i;
  }
}
const o8n = function(t, e) {
  t = t.replace(/\r\n?/g, `
`), e = t8n(e, IJe, mJe);
  const n = new zP("!xml");
  let r = n, i = "";
  for (let o = 0; o < t.length; o++)
    if (t[o] === "<")
      if (t[o + 1] === "/") {
        const a = N2(t, ">", o, "Closing Tag is not closed.");
        let A = t.substring(o + 2, a).trim();
        if (e.ignoreNameSpace) {
          const l = A.indexOf(":");
          l !== -1 && (A = A.substr(l + 1));
        }
        r && (r.val ? r.val = cv.getValue(r.val) + "" + VP(A, i, e) : r.val = VP(A, i, e)), e.stopNodes.length && e.stopNodes.includes(r.tagname) && (r.child = [], r.attrsMap == null && (r.attrsMap = {}), r.val = t.substr(r.startIndex + 1, o - r.startIndex - 1)), r = r.parent, i = "", o = a;
      } else if (t[o + 1] === "?")
        o = N2(t, "?>", o, "Pi Tag is not closed.");
      else if (t.substr(o + 1, 3) === "!--")
        o = N2(t, "-->", o, "Comment is not closed.");
      else if (t.substr(o + 1, 2) === "!D") {
        const a = N2(t, ">", o, "DOCTYPE is not closed.");
        t.substring(o, a).indexOf("[") >= 0 ? o = t.indexOf("]>", o) + 1 : o = a;
      } else if (t.substr(o + 1, 2) === "![") {
        const a = N2(t, "]]>", o, "CDATA is not closed.") - 2, A = t.substring(o + 9, a);
        if (i && (r.val = cv.getValue(r.val) + "" + VP(r.tagname, i, e), i = ""), e.cdataTagName) {
          const l = new zP(e.cdataTagName, r, A);
          r.addChild(l), r.val = cv.getValue(r.val) + e.cdataPositionChar, A && (l.val = A);
        } else
          r.val = (r.val || "") + (A || "");
        o = a + 2;
      } else {
        const a = s8n(t, o + 1);
        let A = a.data;
        const l = a.index, c = A.indexOf(" ");
        let u = A, f = !0;
        if (c !== -1 && (u = A.substr(0, c).replace(/\s\s*$/, ""), A = A.substr(c + 1)), e.ignoreNameSpace) {
          const h = u.indexOf(":");
          h !== -1 && (u = u.substr(h + 1), f = u !== a.data.substr(h + 1));
        }
        if (r && i && r.tagname !== "!xml" && (r.val = cv.getValue(r.val) + "" + VP(r.tagname, i, e)), A.length > 0 && A.lastIndexOf("/") === A.length - 1) {
          u[u.length - 1] === "/" ? (u = u.substr(0, u.length - 1), A = u) : A = A.substr(0, A.length - 1);
          const h = new zP(u, r, "");
          u !== A && (h.attrsMap = yRe(A, e)), r.addChild(h);
        } else {
          const h = new zP(u, r);
          e.stopNodes.length && e.stopNodes.includes(h.tagname) && (h.startIndex = l), u !== A && f && (h.attrsMap = yRe(A, e)), r.addChild(h), r = h;
        }
        i = "", o = l;
      }
    else
      i += t[o];
  return n;
};
function s8n(t, e) {
  let n, r = "";
  for (let i = e; i < t.length; i++) {
    let o = t[i];
    if (n)
      o === n && (n = "");
    else if (o === '"' || o === "'")
      n = o;
    else {
      if (o === ">")
        return {
          data: r,
          index: i
        };
      o === "	" && (o = " ");
    }
    r += o;
  }
}
function N2(t, e, n, r) {
  const i = t.indexOf(e, n);
  if (i === -1)
    throw new Error(r);
  return i + e.length - 1;
}
cB.getTraversalObj = o8n;
var EJe = {};
const bq = zp, a8n = {
  allowBooleanAttributes: !1
  //A tag can have attributes without any value
}, A8n = ["allowBooleanAttributes"];
EJe.validate = function(t, e) {
  e = bq.buildOptions(e, a8n, A8n);
  const n = [];
  let r = !1, i = !1;
  t[0] === "\uFEFF" && (t = t.substr(1));
  for (let o = 0; o < t.length; o++)
    if (t[o] === "<" && t[o + 1] === "?") {
      if (o += 2, o = vRe(t, o), o.err)
        return o;
    } else if (t[o] === "<") {
      let s = o;
      if (o++, t[o] === "!") {
        o = BRe(t, o);
        continue;
      } else {
        let a = !1;
        t[o] === "/" && (a = !0, o++);
        let A = "";
        for (; o < t.length && t[o] !== ">" && t[o] !== " " && t[o] !== "	" && t[o] !== `
` && t[o] !== "\r"; o++)
          A += t[o];
        if (A = A.trim(), A[A.length - 1] === "/" && (A = A.substring(0, A.length - 1), o--), !p8n(A)) {
          let u;
          return A.trim().length === 0 ? u = "Invalid space after '<'." : u = "Tag '" + A + "' is an invalid name.", QA("InvalidTag", u, hf(t, o));
        }
        const l = u8n(t, o);
        if (l === !1)
          return QA("InvalidAttr", "Attributes for '" + A + "' have open quote.", hf(t, o));
        let c = l.value;
        if (o = l.index, c[c.length - 1] === "/") {
          const u = o - c.length;
          c = c.substring(0, c.length - 1);
          const f = bRe(c, e);
          if (f === !0)
            r = !0;
          else
            return QA(f.err.code, f.err.msg, hf(t, u + f.err.line));
        } else if (a)
          if (l.tagClosed) {
            if (c.trim().length > 0)
              return QA("InvalidTag", "Closing tag '" + A + "' can't have attributes or invalid starting.", hf(t, s));
            {
              const u = n.pop();
              if (A !== u.tagName) {
                let f = hf(t, u.tagStartPos);
                return QA(
                  "InvalidTag",
                  "Expected closing tag '" + u.tagName + "' (opened in line " + f.line + ", col " + f.col + ") instead of closing tag '" + A + "'.",
                  hf(t, s)
                );
              }
              n.length == 0 && (i = !0);
            }
          } else
            return QA("InvalidTag", "Closing tag '" + A + "' doesn't have proper closing.", hf(t, o));
        else {
          const u = bRe(c, e);
          if (u !== !0)
            return QA(u.err.code, u.err.msg, hf(t, o - c.length + u.err.line));
          if (i === !0)
            return QA("InvalidXml", "Multiple possible root nodes found.", hf(t, o));
          n.push({ tagName: A, tagStartPos: s }), r = !0;
        }
        for (o++; o < t.length; o++)
          if (t[o] === "<")
            if (t[o + 1] === "!") {
              o++, o = BRe(t, o);
              continue;
            } else if (t[o + 1] === "?") {
              if (o = vRe(t, ++o), o.err)
                return o;
            } else
              break;
          else if (t[o] === "&") {
            const u = h8n(t, o);
            if (u == -1)
              return QA("InvalidChar", "char '&' is not expected.", hf(t, o));
            o = u;
          }
        t[o] === "<" && o--;
      }
    } else {
      if (t[o] === " " || t[o] === "	" || t[o] === `
` || t[o] === "\r")
        continue;
      return QA("InvalidChar", "char '" + t[o] + "' is not expected.", hf(t, o));
    }
  if (r) {
    if (n.length == 1)
      return QA("InvalidTag", "Unclosed tag '" + n[0].tagName + "'.", hf(t, n[0].tagStartPos));
    if (n.length > 0)
      return QA("InvalidXml", "Invalid '" + JSON.stringify(n.map((o) => o.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", { line: 1, col: 1 });
  } else
    return QA("InvalidXml", "Start tag expected.", 1);
  return !0;
};
function vRe(t, e) {
  const n = e;
  for (; e < t.length; e++)
    if (t[e] == "?" || t[e] == " ") {
      const r = t.substr(n, e - n);
      if (e > 5 && r === "xml")
        return QA("InvalidXml", "XML declaration allowed only at the start of the document.", hf(t, e));
      if (t[e] == "?" && t[e + 1] == ">") {
        e++;
        break;
      } else
        continue;
    }
  return e;
}
function BRe(t, e) {
  if (t.length > e + 5 && t[e + 1] === "-" && t[e + 2] === "-") {
    for (e += 3; e < t.length; e++)
      if (t[e] === "-" && t[e + 1] === "-" && t[e + 2] === ">") {
        e += 2;
        break;
      }
  } else if (t.length > e + 8 && t[e + 1] === "D" && t[e + 2] === "O" && t[e + 3] === "C" && t[e + 4] === "T" && t[e + 5] === "Y" && t[e + 6] === "P" && t[e + 7] === "E") {
    let n = 1;
    for (e += 8; e < t.length; e++)
      if (t[e] === "<")
        n++;
      else if (t[e] === ">" && (n--, n === 0))
        break;
  } else if (t.length > e + 9 && t[e + 1] === "[" && t[e + 2] === "C" && t[e + 3] === "D" && t[e + 4] === "A" && t[e + 5] === "T" && t[e + 6] === "A" && t[e + 7] === "[") {
    for (e += 8; e < t.length; e++)
      if (t[e] === "]" && t[e + 1] === "]" && t[e + 2] === ">") {
        e += 2;
        break;
      }
  }
  return e;
}
const l8n = '"', c8n = "'";
function u8n(t, e) {
  let n = "", r = "", i = !1;
  for (; e < t.length; e++) {
    if (t[e] === l8n || t[e] === c8n)
      r === "" ? r = t[e] : r !== t[e] || (r = "");
    else if (t[e] === ">" && r === "") {
      i = !0;
      break;
    }
    n += t[e];
  }
  return r !== "" ? !1 : {
    value: n,
    index: e,
    tagClosed: i
  };
}
const f8n = new RegExp(`(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['"])(([\\s\\S])*?)\\5)?`, "g");
function bRe(t, e) {
  const n = bq.getAllMatches(t, f8n), r = {};
  for (let i = 0; i < n.length; i++) {
    if (n[i][1].length === 0)
      return QA("InvalidAttr", "Attribute '" + n[i][2] + "' has no space in starting.", JP(n[i]));
    if (n[i][3] === void 0 && !e.allowBooleanAttributes)
      return QA("InvalidAttr", "boolean attribute '" + n[i][2] + "' is not allowed.", JP(n[i]));
    const o = n[i][2];
    if (!d8n(o))
      return QA("InvalidAttr", "Attribute '" + o + "' is an invalid name.", JP(n[i]));
    if (!r.hasOwnProperty(o))
      r[o] = 1;
    else
      return QA("InvalidAttr", "Attribute '" + o + "' is repeated.", JP(n[i]));
  }
  return !0;
}
function g8n(t, e) {
  let n = /\d/;
  for (t[e] === "x" && (e++, n = /[\da-fA-F]/); e < t.length; e++) {
    if (t[e] === ";")
      return e;
    if (!t[e].match(n))
      break;
  }
  return -1;
}
function h8n(t, e) {
  if (e++, t[e] === ";")
    return -1;
  if (t[e] === "#")
    return e++, g8n(t, e);
  let n = 0;
  for (; e < t.length; e++, n++)
    if (!(t[e].match(/\w/) && n < 20)) {
      if (t[e] === ";")
        break;
      return -1;
    }
  return e;
}
function QA(t, e, n) {
  return {
    err: {
      code: t,
      msg: e,
      line: n.line || n,
      col: n.col
    }
  };
}
function d8n(t) {
  return bq.isName(t);
}
function p8n(t) {
  return bq.isName(t);
}
function hf(t, e) {
  const n = t.substring(0, e).split(/\r?\n/);
  return {
    line: n.length,
    // column number is last line's length + 1, because column numbering starts at 1:
    col: n[n.length - 1].length + 1
  };
}
function JP(t) {
  return t.startIndex + t[1].length;
}
var kJ = {}, _Re;
function I8n() {
  if (_Re)
    return kJ;
  _Re = 1;
  const t = function(u) {
    return String.fromCharCode(u);
  }, e = {
    nilChar: t(176),
    missingChar: t(201),
    nilPremitive: t(175),
    missingPremitive: t(200),
    emptyChar: t(178),
    emptyValue: t(177),
    //empty Premitive
    boundryChar: t(179),
    objStart: t(198),
    arrStart: t(204),
    arrayEnd: t(185)
  }, n = [
    e.nilChar,
    e.nilPremitive,
    e.missingChar,
    e.missingPremitive,
    e.boundryChar,
    e.emptyChar,
    e.emptyValue,
    e.arrayEnd,
    e.objStart,
    e.arrStart
  ], r = function(u, f, h) {
    if (typeof f == "string")
      return u && u[0] && u[0].val !== void 0 ? i(u[0].val) : i(u);
    {
      const d = a(u);
      if (d === !0) {
        let I = "";
        if (Array.isArray(f)) {
          I += e.arrStart;
          const m = f[0], C = u.length;
          if (typeof m == "string")
            for (let y = 0; y < C; y++) {
              const v = i(u[y].val);
              I = o(I, v);
            }
          else
            for (let y = 0; y < C; y++) {
              const v = r(u[y], m, h);
              I = o(I, v);
            }
          I += e.arrayEnd;
        } else {
          I += e.objStart;
          const m = Object.keys(f);
          Array.isArray(u) && (u = u[0]);
          for (let C in m) {
            const y = m[C];
            let v;
            !h.ignoreAttributes && u.attrsMap && u.attrsMap[y] ? v = r(u.attrsMap[y], f[y], h) : y === h.textNodeName ? v = r(u.val, f[y], h) : v = r(u.child[y], f[y], h), I = o(I, v);
          }
        }
        return I;
      } else
        return d;
    }
  }, i = function(u) {
    switch (u) {
      case void 0:
        return e.missingPremitive;
      case null:
        return e.nilPremitive;
      case "":
        return e.emptyValue;
      default:
        return u;
    }
  }, o = function(u, f) {
    return !s(f[0]) && !s(u[u.length - 1]) && (u += e.boundryChar), u + f;
  }, s = function(u) {
    return n.indexOf(u) !== -1;
  };
  function a(u) {
    return u === void 0 ? e.missingChar : u === null ? e.nilChar : u.child && Object.keys(u.child).length === 0 && (!u.attrsMap || Object.keys(u.attrsMap).length === 0) ? e.emptyChar : !0;
  }
  const A = cB, l = zp.buildOptions, c = function(u, f, h) {
    return h = l(h, A.defaultOptions, A.props), r(u, f, h);
  };
  return kJ.convert2nimn = c, kJ;
}
var GJ = {}, SRe;
function m8n() {
  if (SRe)
    return GJ;
  SRe = 1;
  const t = zp, e = zp.buildOptions, n = cB, r = function(s, a) {
    return a = e(a, n.defaultOptions, n.props), a.indentBy = a.indentBy || "", i(s, a);
  }, i = function(s, a, A) {
    let l = "{";
    const c = Object.keys(s.child);
    for (let u = 0; u < c.length; u++) {
      const f = c[u];
      if (s.child[f] && s.child[f].length > 1) {
        l += '"' + f + '" : [ ';
        for (let h in s.child[f])
          l += i(s.child[f][h], a) + " , ";
        l = l.substr(0, l.length - 1) + " ] ";
      } else
        l += '"' + f + '" : ' + i(s.child[f][0], a) + " ,";
    }
    return t.merge(l, s.attrsMap), t.isEmptyObject(l) ? t.isExist(s.val) ? s.val : "" : (t.isExist(s.val) && (typeof s.val == "string" && (s.val === "" || s.val === a.cdataPositionChar) || (l += '"' + a.textNodeName + '" : ' + o(s.val))), l[l.length - 1] === "," && (l = l.substr(0, l.length - 2)), l + "}");
  };
  function o(s) {
    return s === !0 || s === !1 || !isNaN(s) ? s : '"' + s + '"';
  }
  return GJ.convertToJsonString = r, GJ;
}
var UJ, QRe;
function C8n() {
  if (QRe)
    return UJ;
  QRe = 1;
  const t = zp.buildOptions, e = {
    attributeNamePrefix: "@_",
    attrNodeName: !1,
    textNodeName: "#text",
    ignoreAttributes: !0,
    cdataTagName: !1,
    cdataPositionChar: "\\c",
    format: !1,
    indentBy: "  ",
    supressEmptyNode: !1,
    tagValueProcessor: function(d) {
      return d;
    },
    attrValueProcessor: function(d) {
      return d;
    }
  }, n = [
    "attributeNamePrefix",
    "attrNodeName",
    "textNodeName",
    "ignoreAttributes",
    "cdataTagName",
    "cdataPositionChar",
    "format",
    "indentBy",
    "supressEmptyNode",
    "tagValueProcessor",
    "attrValueProcessor",
    "rootNodeName"
    //when array as root
  ];
  function r(d) {
    this.options = t(d, e, n), this.options.ignoreAttributes || this.options.attrNodeName ? this.isAttribute = function() {
      return !1;
    } : (this.attrPrefixLen = this.options.attributeNamePrefix.length, this.isAttribute = f), this.options.cdataTagName ? this.isCDATA = h : this.isCDATA = function() {
      return !1;
    }, this.replaceCDATAstr = o, this.replaceCDATAarr = s, this.processTextOrObjNode = i, this.options.format ? (this.indentate = u, this.tagEndChar = `>
`, this.newLine = `
`) : (this.indentate = function() {
      return "";
    }, this.tagEndChar = ">", this.newLine = ""), this.options.supressEmptyNode ? (this.buildTextNode = c, this.buildObjNode = A) : (this.buildTextNode = l, this.buildObjNode = a), this.buildTextValNode = l, this.buildObjectNode = a;
  }
  r.prototype.parse = function(d) {
    return Array.isArray(d) && this.options.rootNodeName && this.options.rootNodeName.length > 1 && (d = {
      [this.options.rootNodeName]: d
    }), this.j2x(d, 0).val;
  }, r.prototype.j2x = function(d, I) {
    let m = "", C = "";
    for (let y in d)
      if (!(typeof d[y] > "u"))
        if (d[y] === null)
          C += this.indentate(I) + "<" + y + "/" + this.tagEndChar;
        else if (d[y] instanceof Date)
          C += this.buildTextNode(d[y], y, "", I);
        else if (typeof d[y] != "object") {
          const v = this.isAttribute(y);
          v ? m += " " + v + '="' + this.options.attrValueProcessor("" + d[y]) + '"' : this.isCDATA(y) ? d[this.options.textNodeName] ? C += this.replaceCDATAstr(d[this.options.textNodeName], d[y]) : C += this.replaceCDATAstr("", d[y]) : y === this.options.textNodeName ? d[this.options.cdataTagName] || (C += this.options.tagValueProcessor("" + d[y])) : C += this.buildTextNode(d[y], y, "", I);
        } else if (Array.isArray(d[y]))
          if (this.isCDATA(y))
            C += this.indentate(I), d[this.options.textNodeName] ? C += this.replaceCDATAarr(d[this.options.textNodeName], d[y]) : C += this.replaceCDATAarr("", d[y]);
          else {
            const v = d[y].length;
            for (let b = 0; b < v; b++) {
              const Q = d[y][b];
              typeof Q > "u" || (Q === null ? C += this.indentate(I) + "<" + y + "/" + this.tagEndChar : typeof Q == "object" ? C += this.processTextOrObjNode(Q, y, I) : C += this.buildTextNode(Q, y, "", I));
            }
          }
        else if (this.options.attrNodeName && y === this.options.attrNodeName) {
          const v = Object.keys(d[y]), b = v.length;
          for (let Q = 0; Q < b; Q++)
            m += " " + v[Q] + '="' + this.options.attrValueProcessor("" + d[y][v[Q]]) + '"';
        } else
          C += this.processTextOrObjNode(d[y], y, I);
    return { attrStr: m, val: C };
  };
  function i(d, I, m) {
    const C = this.j2x(d, m + 1);
    return d[this.options.textNodeName] !== void 0 && Object.keys(d).length === 1 ? this.buildTextNode(C.val, I, C.attrStr, m) : this.buildObjNode(C.val, I, C.attrStr, m);
  }
  function o(d, I) {
    return d = this.options.tagValueProcessor("" + d), this.options.cdataPositionChar === "" || d === "" ? d + "<![CDATA[" + I + "]]" + this.tagEndChar : d.replace(this.options.cdataPositionChar, "<![CDATA[" + I + "]]" + this.tagEndChar);
  }
  function s(d, I) {
    if (d = this.options.tagValueProcessor("" + d), this.options.cdataPositionChar === "" || d === "")
      return d + "<![CDATA[" + I.join("]]><![CDATA[") + "]]" + this.tagEndChar;
    for (let m in I)
      d = d.replace(this.options.cdataPositionChar, "<![CDATA[" + I[m] + "]]>");
    return d + this.newLine;
  }
  function a(d, I, m, C) {
    return m && d.indexOf("<") === -1 ? this.indentate(C) + "<" + I + m + ">" + d + //+ this.newLine
    // + this.indentate(level)
    "</" + I + this.tagEndChar : this.indentate(C) + "<" + I + m + this.tagEndChar + d + //+ this.newLine
    this.indentate(C) + "</" + I + this.tagEndChar;
  }
  function A(d, I, m, C) {
    return d !== "" ? this.buildObjectNode(d, I, m, C) : this.indentate(C) + "<" + I + m + "/" + this.tagEndChar;
  }
  function l(d, I, m, C) {
    return this.indentate(C) + "<" + I + m + ">" + this.options.tagValueProcessor(d) + "</" + I + this.tagEndChar;
  }
  function c(d, I, m, C) {
    return d !== "" ? this.buildTextValNode(d, I, m, C) : this.indentate(C) + "<" + I + m + "/" + this.tagEndChar;
  }
  function u(d) {
    return this.options.indentBy.repeat(d);
  }
  function f(d) {
    return d.startsWith(this.options.attributeNamePrefix) ? d.substr(this.attrPrefixLen) : !1;
  }
  function h(d) {
    return d === this.options.cdataTagName;
  }
  return UJ = r, UJ;
}
(function(t) {
  const e = pJe, n = cB, r = cB, i = zp.buildOptions, o = EJe;
  t.parse = function(s, a = {}, A) {
    if (A) {
      A === !0 && (A = {});
      const u = o.validate(s, A);
      if (u !== !0)
        throw Error(u.err.msg);
    }
    a.parseTrueNumberOnly && a.parseNodeValue !== !1 && !a.numParseOptions && (a.numParseOptions = {
      leadingZeros: !1
    });
    let l = i(a, r.defaultOptions, r.props);
    const c = n.getTraversalObj(s, l);
    return e.convertToJson(c, l);
  }, t.convertTonimn = I8n().convert2nimn, t.getTraversalObj = n.getTraversalObj, t.convertToJson = e.convertToJson, t.convertToJsonString = m8n().convertToJsonString, t.validate = o.validate, t.j2xParser = C8n(), t.parseToNimn = function(s, a, A) {
    return t.convertTonimn(t.getTraversalObj(s, A), a, A);
  };
})(dJe);
const E8n = /* @__PURE__ */ new Map();
function Afe(t, e) {
  E8n.set(t, e);
}
class P8 extends RangeError {
  constructor(e) {
    super(e), this.__zarr__ = "BoundsCheckError", Object.setPrototypeOf(this, P8.prototype);
  }
}
class k8 extends RangeError {
  constructor(e, n, r, i) {
    super(`slice arguments slice(${e}, ${n}, ${r}) invalid: ${i}`), this.__zarr__ = "InvalidSliceError", Object.setPrototypeOf(this, k8.prototype);
  }
}
function wRe(t, e = void 0, n = null) {
  if (t === void 0)
    throw new k8(t, e, n, "The first argument must not be undefined");
  if (typeof t == "string" && t !== ":" || typeof e == "string" && e !== ":")
    throw new k8(t, e, n, 'Arguments can only be integers, ":" or null');
  return e === void 0 && (e = t, t = null), {
    start: t === ":" ? null : t,
    stop: e === ":" ? null : e,
    step: n,
    _slice: !0
  };
}
typeof process < "u" && process.versions && process.versions.node;
function y8n(t) {
  var e = { exports: {} };
  return t(e, e.exports), e.exports;
}
y8n(function(t) {
  var e = Object.prototype.hasOwnProperty, n = "~";
  function r() {
  }
  Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
  function i(A, l, c) {
    this.fn = A, this.context = l, this.once = c || !1;
  }
  function o(A, l, c, u, f) {
    if (typeof c != "function")
      throw new TypeError("The listener must be a function");
    var h = new i(c, u || A, f), d = n ? n + l : l;
    return A._events[d] ? A._events[d].fn ? A._events[d] = [A._events[d], h] : A._events[d].push(h) : (A._events[d] = h, A._eventsCount++), A;
  }
  function s(A, l) {
    --A._eventsCount === 0 ? A._events = new r() : delete A._events[l];
  }
  function a() {
    this._events = new r(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var l = [], c, u;
    if (this._eventsCount === 0)
      return l;
    for (u in c = this._events)
      e.call(c, u) && l.push(n ? u.slice(1) : u);
    return Object.getOwnPropertySymbols ? l.concat(Object.getOwnPropertySymbols(c)) : l;
  }, a.prototype.listeners = function(l) {
    var c = n ? n + l : l, u = this._events[c];
    if (!u)
      return [];
    if (u.fn)
      return [u.fn];
    for (var f = 0, h = u.length, d = new Array(h); f < h; f++)
      d[f] = u[f].fn;
    return d;
  }, a.prototype.listenerCount = function(l) {
    var c = n ? n + l : l, u = this._events[c];
    return u ? u.fn ? 1 : u.length : 0;
  }, a.prototype.emit = function(l, c, u, f, h, d) {
    var I = n ? n + l : l;
    if (!this._events[I])
      return !1;
    var m = this._events[I], C = arguments.length, y, v;
    if (m.fn) {
      switch (m.once && this.removeListener(l, m.fn, void 0, !0), C) {
        case 1:
          return m.fn.call(m.context), !0;
        case 2:
          return m.fn.call(m.context, c), !0;
        case 3:
          return m.fn.call(m.context, c, u), !0;
        case 4:
          return m.fn.call(m.context, c, u, f), !0;
        case 5:
          return m.fn.call(m.context, c, u, f, h), !0;
        case 6:
          return m.fn.call(m.context, c, u, f, h, d), !0;
      }
      for (v = 1, y = new Array(C - 1); v < C; v++)
        y[v - 1] = arguments[v];
      m.fn.apply(m.context, y);
    } else {
      var b = m.length, Q;
      for (v = 0; v < b; v++)
        switch (m[v].once && this.removeListener(l, m[v].fn, void 0, !0), C) {
          case 1:
            m[v].fn.call(m[v].context);
            break;
          case 2:
            m[v].fn.call(m[v].context, c);
            break;
          case 3:
            m[v].fn.call(m[v].context, c, u);
            break;
          case 4:
            m[v].fn.call(m[v].context, c, u, f);
            break;
          default:
            if (!y)
              for (Q = 1, y = new Array(C - 1); Q < C; Q++)
                y[Q - 1] = arguments[Q];
            m[v].fn.apply(m[v].context, y);
        }
    }
    return !0;
  }, a.prototype.on = function(l, c, u) {
    return o(this, l, c, u, !1);
  }, a.prototype.once = function(l, c, u) {
    return o(this, l, c, u, !0);
  }, a.prototype.removeListener = function(l, c, u, f) {
    var h = n ? n + l : l;
    if (!this._events[h])
      return this;
    if (!c)
      return s(this, h), this;
    var d = this._events[h];
    if (d.fn)
      d.fn === c && (!f || d.once) && (!u || d.context === u) && s(this, h);
    else {
      for (var I = 0, m = [], C = d.length; I < C; I++)
        (d[I].fn !== c || f && !d[I].once || u && d[I].context !== u) && m.push(d[I]);
      m.length ? this._events[h] = m.length === 1 ? m[0] : m : s(this, h);
    }
    return this;
  }, a.prototype.removeAllListeners = function(l) {
    var c;
    return l ? (c = n ? n + l : l, this._events[c] && s(this, c)) : (this._events = new r(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = n, a.EventEmitter = a, t.exports = a;
});
var v8n = (t, e) => (e = e || (() => {
}), t.then(
  (n) => new Promise((r) => {
    r(e());
  }).then(() => n),
  (n) => new Promise((r) => {
    r(e());
  }).then(() => {
    throw n;
  })
));
class yJe extends Error {
  constructor(e) {
    super(e), this.name = "TimeoutError";
  }
}
const vJe = (t, e, n) => new Promise((r, i) => {
  if (typeof e != "number" || e < 0)
    throw new TypeError("Expected `milliseconds` to be a positive number");
  if (e === 1 / 0) {
    r(t);
    return;
  }
  const o = setTimeout(() => {
    if (typeof n == "function") {
      try {
        r(n());
      } catch (A) {
        i(A);
      }
      return;
    }
    const s = typeof n == "string" ? n : `Promise timed out after ${e} milliseconds`, a = n instanceof Error ? n : new yJe(s);
    typeof t.cancel == "function" && t.cancel(), i(a);
  }, e);
  v8n(
    // eslint-disable-next-line promise/prefer-await-to-then
    t.then(r, i),
    () => {
      clearTimeout(o);
    }
  );
});
var lfe = vJe, B8n = vJe, b8n = yJe;
lfe.default = B8n;
lfe.TimeoutError = b8n;
new lfe.default.TimeoutError();
var TD;
(function(t) {
  t.HEAD = "HEAD", t.GET = "GET", t.PUT = "PUT";
})(TD || (TD = {}));
TD.HEAD, TD.GET, TD.PUT;
/*! pako 2.0.3 https://github.com/nodeca/pako @license (MIT AND Zlib) */
const _8n = 4, xRe = 0, RRe = 1, S8n = 2;
function Zw(t) {
  let e = t.length;
  for (; --e >= 0; )
    t[e] = 0;
}
const Q8n = 0, BJe = 1, w8n = 2, x8n = 3, R8n = 258, cfe = 29, HM = 256, rN = HM + 1 + cfe, Z_ = 30, ufe = 19, bJe = 2 * rN + 1, uv = 15, HJ = 16, D8n = 7, ffe = 256, _Je = 16, SJe = 17, QJe = 18, are = (
  /* extra bits for each length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
), PG = (
  /* extra bits for each distance code */
  new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
), T8n = (
  /* extra bits for each bit length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
), wJe = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), N8n = 512, K0 = new Array((rN + 2) * 2);
Zw(K0);
const ND = new Array(Z_ * 2);
Zw(ND);
const iN = new Array(N8n);
Zw(iN);
const oN = new Array(R8n - x8n + 1);
Zw(oN);
const gfe = new Array(cfe);
Zw(gfe);
const G8 = new Array(Z_);
Zw(G8);
function $J(t, e, n, r, i) {
  this.static_tree = t, this.extra_bits = e, this.extra_base = n, this.elems = r, this.max_length = i, this.has_stree = t && t.length;
}
let xJe, RJe, DJe;
function qJ(t, e) {
  this.dyn_tree = t, this.max_code = 0, this.stat_desc = e;
}
const TJe = (t) => t < 256 ? iN[t] : iN[256 + (t >>> 7)], sN = (t, e) => {
  t.pending_buf[t.pending++] = e & 255, t.pending_buf[t.pending++] = e >>> 8 & 255;
}, wu = (t, e, n) => {
  t.bi_valid > HJ - n ? (t.bi_buf |= e << t.bi_valid & 65535, sN(t, t.bi_buf), t.bi_buf = e >> HJ - t.bi_valid, t.bi_valid += n - HJ) : (t.bi_buf |= e << t.bi_valid & 65535, t.bi_valid += n);
}, Ip = (t, e, n) => {
  wu(
    t,
    n[e * 2],
    n[e * 2 + 1]
    /*.Len*/
  );
}, NJe = (t, e) => {
  let n = 0;
  do
    n |= t & 1, t >>>= 1, n <<= 1;
  while (--e > 0);
  return n >>> 1;
}, L8n = (t) => {
  t.bi_valid === 16 ? (sN(t, t.bi_buf), t.bi_buf = 0, t.bi_valid = 0) : t.bi_valid >= 8 && (t.pending_buf[t.pending++] = t.bi_buf & 255, t.bi_buf >>= 8, t.bi_valid -= 8);
}, M8n = (t, e) => {
  const n = e.dyn_tree, r = e.max_code, i = e.stat_desc.static_tree, o = e.stat_desc.has_stree, s = e.stat_desc.extra_bits, a = e.stat_desc.extra_base, A = e.stat_desc.max_length;
  let l, c, u, f, h, d, I = 0;
  for (f = 0; f <= uv; f++)
    t.bl_count[f] = 0;
  for (n[t.heap[t.heap_max] * 2 + 1] = 0, l = t.heap_max + 1; l < bJe; l++)
    c = t.heap[l], f = n[n[c * 2 + 1] * 2 + 1] + 1, f > A && (f = A, I++), n[c * 2 + 1] = f, !(c > r) && (t.bl_count[f]++, h = 0, c >= a && (h = s[c - a]), d = n[c * 2], t.opt_len += d * (f + h), o && (t.static_len += d * (i[c * 2 + 1] + h)));
  if (I !== 0) {
    do {
      for (f = A - 1; t.bl_count[f] === 0; )
        f--;
      t.bl_count[f]--, t.bl_count[f + 1] += 2, t.bl_count[A]--, I -= 2;
    } while (I > 0);
    for (f = A; f !== 0; f--)
      for (c = t.bl_count[f]; c !== 0; )
        u = t.heap[--l], !(u > r) && (n[u * 2 + 1] !== f && (t.opt_len += (f - n[u * 2 + 1]) * n[u * 2], n[u * 2 + 1] = f), c--);
  }
}, LJe = (t, e, n) => {
  const r = new Array(uv + 1);
  let i = 0, o, s;
  for (o = 1; o <= uv; o++)
    r[o] = i = i + n[o - 1] << 1;
  for (s = 0; s <= e; s++) {
    let a = t[s * 2 + 1];
    a !== 0 && (t[s * 2] = NJe(r[a]++, a));
  }
}, O8n = () => {
  let t, e, n, r, i;
  const o = new Array(uv + 1);
  for (n = 0, r = 0; r < cfe - 1; r++)
    for (gfe[r] = n, t = 0; t < 1 << are[r]; t++)
      oN[n++] = r;
  for (oN[n - 1] = r, i = 0, r = 0; r < 16; r++)
    for (G8[r] = i, t = 0; t < 1 << PG[r]; t++)
      iN[i++] = r;
  for (i >>= 7; r < Z_; r++)
    for (G8[r] = i << 7, t = 0; t < 1 << PG[r] - 7; t++)
      iN[256 + i++] = r;
  for (e = 0; e <= uv; e++)
    o[e] = 0;
  for (t = 0; t <= 143; )
    K0[t * 2 + 1] = 8, t++, o[8]++;
  for (; t <= 255; )
    K0[t * 2 + 1] = 9, t++, o[9]++;
  for (; t <= 279; )
    K0[t * 2 + 1] = 7, t++, o[7]++;
  for (; t <= 287; )
    K0[t * 2 + 1] = 8, t++, o[8]++;
  for (LJe(K0, rN + 1, o), t = 0; t < Z_; t++)
    ND[t * 2 + 1] = 5, ND[t * 2] = NJe(t, 5);
  xJe = new $J(K0, are, HM + 1, rN, uv), RJe = new $J(ND, PG, 0, Z_, uv), DJe = new $J(new Array(0), T8n, 0, ufe, D8n);
}, MJe = (t) => {
  let e;
  for (e = 0; e < rN; e++)
    t.dyn_ltree[e * 2] = 0;
  for (e = 0; e < Z_; e++)
    t.dyn_dtree[e * 2] = 0;
  for (e = 0; e < ufe; e++)
    t.bl_tree[e * 2] = 0;
  t.dyn_ltree[ffe * 2] = 1, t.opt_len = t.static_len = 0, t.last_lit = t.matches = 0;
}, OJe = (t) => {
  t.bi_valid > 8 ? sN(t, t.bi_buf) : t.bi_valid > 0 && (t.pending_buf[t.pending++] = t.bi_buf), t.bi_buf = 0, t.bi_valid = 0;
}, F8n = (t, e, n, r) => {
  OJe(t), r && (sN(t, n), sN(t, ~n)), t.pending_buf.set(t.window.subarray(e, e + n), t.pending), t.pending += n;
}, DRe = (t, e, n, r) => {
  const i = e * 2, o = n * 2;
  return t[i] < t[o] || t[i] === t[o] && r[e] <= r[n];
}, jJ = (t, e, n) => {
  const r = t.heap[n];
  let i = n << 1;
  for (; i <= t.heap_len && (i < t.heap_len && DRe(e, t.heap[i + 1], t.heap[i], t.depth) && i++, !DRe(e, r, t.heap[i], t.depth)); )
    t.heap[n] = t.heap[i], n = i, i <<= 1;
  t.heap[n] = r;
}, TRe = (t, e, n) => {
  let r, i, o = 0, s, a;
  if (t.last_lit !== 0)
    do
      r = t.pending_buf[t.d_buf + o * 2] << 8 | t.pending_buf[t.d_buf + o * 2 + 1], i = t.pending_buf[t.l_buf + o], o++, r === 0 ? Ip(t, i, e) : (s = oN[i], Ip(t, s + HM + 1, e), a = are[s], a !== 0 && (i -= gfe[s], wu(t, i, a)), r--, s = TJe(r), Ip(t, s, n), a = PG[s], a !== 0 && (r -= G8[s], wu(t, r, a)));
    while (o < t.last_lit);
  Ip(t, ffe, e);
}, Are = (t, e) => {
  const n = e.dyn_tree, r = e.stat_desc.static_tree, i = e.stat_desc.has_stree, o = e.stat_desc.elems;
  let s, a, A = -1, l;
  for (t.heap_len = 0, t.heap_max = bJe, s = 0; s < o; s++)
    n[s * 2] !== 0 ? (t.heap[++t.heap_len] = A = s, t.depth[s] = 0) : n[s * 2 + 1] = 0;
  for (; t.heap_len < 2; )
    l = t.heap[++t.heap_len] = A < 2 ? ++A : 0, n[l * 2] = 1, t.depth[l] = 0, t.opt_len--, i && (t.static_len -= r[l * 2 + 1]);
  for (e.max_code = A, s = t.heap_len >> 1; s >= 1; s--)
    jJ(t, n, s);
  l = o;
  do
    s = t.heap[
      1
      /*SMALLEST*/
    ], t.heap[
      1
      /*SMALLEST*/
    ] = t.heap[t.heap_len--], jJ(
      t,
      n,
      1
      /*SMALLEST*/
    ), a = t.heap[
      1
      /*SMALLEST*/
    ], t.heap[--t.heap_max] = s, t.heap[--t.heap_max] = a, n[l * 2] = n[s * 2] + n[a * 2], t.depth[l] = (t.depth[s] >= t.depth[a] ? t.depth[s] : t.depth[a]) + 1, n[s * 2 + 1] = n[a * 2 + 1] = l, t.heap[
      1
      /*SMALLEST*/
    ] = l++, jJ(
      t,
      n,
      1
      /*SMALLEST*/
    );
  while (t.heap_len >= 2);
  t.heap[--t.heap_max] = t.heap[
    1
    /*SMALLEST*/
  ], M8n(t, e), LJe(n, A, t.bl_count);
}, NRe = (t, e, n) => {
  let r, i = -1, o, s = e[0 * 2 + 1], a = 0, A = 7, l = 4;
  for (s === 0 && (A = 138, l = 3), e[(n + 1) * 2 + 1] = 65535, r = 0; r <= n; r++)
    o = s, s = e[(r + 1) * 2 + 1], !(++a < A && o === s) && (a < l ? t.bl_tree[o * 2] += a : o !== 0 ? (o !== i && t.bl_tree[o * 2]++, t.bl_tree[_Je * 2]++) : a <= 10 ? t.bl_tree[SJe * 2]++ : t.bl_tree[QJe * 2]++, a = 0, i = o, s === 0 ? (A = 138, l = 3) : o === s ? (A = 6, l = 3) : (A = 7, l = 4));
}, LRe = (t, e, n) => {
  let r, i = -1, o, s = e[0 * 2 + 1], a = 0, A = 7, l = 4;
  for (s === 0 && (A = 138, l = 3), r = 0; r <= n; r++)
    if (o = s, s = e[(r + 1) * 2 + 1], !(++a < A && o === s)) {
      if (a < l)
        do
          Ip(t, o, t.bl_tree);
        while (--a !== 0);
      else
        o !== 0 ? (o !== i && (Ip(t, o, t.bl_tree), a--), Ip(t, _Je, t.bl_tree), wu(t, a - 3, 2)) : a <= 10 ? (Ip(t, SJe, t.bl_tree), wu(t, a - 3, 3)) : (Ip(t, QJe, t.bl_tree), wu(t, a - 11, 7));
      a = 0, i = o, s === 0 ? (A = 138, l = 3) : o === s ? (A = 6, l = 3) : (A = 7, l = 4);
    }
}, P8n = (t) => {
  let e;
  for (NRe(t, t.dyn_ltree, t.l_desc.max_code), NRe(t, t.dyn_dtree, t.d_desc.max_code), Are(t, t.bl_desc), e = ufe - 1; e >= 3 && t.bl_tree[wJe[e] * 2 + 1] === 0; e--)
    ;
  return t.opt_len += 3 * (e + 1) + 5 + 5 + 4, e;
}, k8n = (t, e, n, r) => {
  let i;
  for (wu(t, e - 257, 5), wu(t, n - 1, 5), wu(t, r - 4, 4), i = 0; i < r; i++)
    wu(t, t.bl_tree[wJe[i] * 2 + 1], 3);
  LRe(t, t.dyn_ltree, e - 1), LRe(t, t.dyn_dtree, n - 1);
}, G8n = (t) => {
  let e = 4093624447, n;
  for (n = 0; n <= 31; n++, e >>>= 1)
    if (e & 1 && t.dyn_ltree[n * 2] !== 0)
      return xRe;
  if (t.dyn_ltree[9 * 2] !== 0 || t.dyn_ltree[10 * 2] !== 0 || t.dyn_ltree[13 * 2] !== 0)
    return RRe;
  for (n = 32; n < HM; n++)
    if (t.dyn_ltree[n * 2] !== 0)
      return RRe;
  return xRe;
};
let MRe = !1;
const U8n = (t) => {
  MRe || (O8n(), MRe = !0), t.l_desc = new qJ(t.dyn_ltree, xJe), t.d_desc = new qJ(t.dyn_dtree, RJe), t.bl_desc = new qJ(t.bl_tree, DJe), t.bi_buf = 0, t.bi_valid = 0, MJe(t);
}, FJe = (t, e, n, r) => {
  wu(t, (Q8n << 1) + (r ? 1 : 0), 3), F8n(t, e, n, !0);
}, H8n = (t) => {
  wu(t, BJe << 1, 3), Ip(t, ffe, K0), L8n(t);
}, $8n = (t, e, n, r) => {
  let i, o, s = 0;
  t.level > 0 ? (t.strm.data_type === S8n && (t.strm.data_type = G8n(t)), Are(t, t.l_desc), Are(t, t.d_desc), s = P8n(t), i = t.opt_len + 3 + 7 >>> 3, o = t.static_len + 3 + 7 >>> 3, o <= i && (i = o)) : i = o = n + 5, n + 4 <= i && e !== -1 ? FJe(t, e, n, r) : t.strategy === _8n || o === i ? (wu(t, (BJe << 1) + (r ? 1 : 0), 3), TRe(t, K0, ND)) : (wu(t, (w8n << 1) + (r ? 1 : 0), 3), k8n(t, t.l_desc.max_code + 1, t.d_desc.max_code + 1, s + 1), TRe(t, t.dyn_ltree, t.dyn_dtree)), MJe(t), r && OJe(t);
}, q8n = (t, e, n) => (t.pending_buf[t.d_buf + t.last_lit * 2] = e >>> 8 & 255, t.pending_buf[t.d_buf + t.last_lit * 2 + 1] = e & 255, t.pending_buf[t.l_buf + t.last_lit] = n & 255, t.last_lit++, e === 0 ? t.dyn_ltree[n * 2]++ : (t.matches++, e--, t.dyn_ltree[(oN[n] + HM + 1) * 2]++, t.dyn_dtree[TJe(e) * 2]++), t.last_lit === t.lit_bufsize - 1);
var j8n = U8n, Y8n = FJe, z8n = $8n, V8n = q8n, J8n = H8n, K8n = {
  _tr_init: j8n,
  _tr_stored_block: Y8n,
  _tr_flush_block: z8n,
  _tr_tally: V8n,
  _tr_align: J8n
};
const W8n = (t, e, n, r) => {
  let i = t & 65535 | 0, o = t >>> 16 & 65535 | 0, s = 0;
  for (; n !== 0; ) {
    s = n > 2e3 ? 2e3 : n, n -= s;
    do
      i = i + e[r++] | 0, o = o + i | 0;
    while (--s);
    i %= 65521, o %= 65521;
  }
  return i | o << 16 | 0;
};
var aN = W8n;
const X8n = () => {
  let t, e = [];
  for (var n = 0; n < 256; n++) {
    t = n;
    for (var r = 0; r < 8; r++)
      t = t & 1 ? 3988292384 ^ t >>> 1 : t >>> 1;
    e[n] = t;
  }
  return e;
}, Z8n = new Uint32Array(X8n()), e5n = (t, e, n, r) => {
  const i = Z8n, o = r + n;
  t ^= -1;
  for (let s = r; s < o; s++)
    t = t >>> 8 ^ i[(t ^ e[s]) & 255];
  return t ^ -1;
};
var xA = e5n, uB = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, f1 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const { _tr_init: t5n, _tr_stored_block: n5n, _tr_flush_block: r5n, _tr_tally: xC, _tr_align: i5n } = K8n, {
  Z_NO_FLUSH: g1,
  Z_PARTIAL_FLUSH: o5n,
  Z_FULL_FLUSH: s5n,
  Z_FINISH: RC,
  Z_BLOCK: ORe,
  Z_OK: mp,
  Z_STREAM_END: FRe,
  Z_STREAM_ERROR: Ng,
  Z_DATA_ERROR: a5n,
  Z_BUF_ERROR: YJ,
  Z_DEFAULT_COMPRESSION: A5n,
  Z_FILTERED: l5n,
  Z_HUFFMAN_ONLY: KP,
  Z_RLE: c5n,
  Z_FIXED: u5n,
  Z_DEFAULT_STRATEGY: f5n,
  Z_UNKNOWN: g5n,
  Z_DEFLATED: _q
} = f1, h5n = 9, d5n = 15, p5n = 8, I5n = 29, m5n = 256, lre = m5n + 1 + I5n, C5n = 30, E5n = 19, y5n = 2 * lre + 1, v5n = 15, Bi = 3, cC = 258, rd = cC + Bi + 1, B5n = 32, Sq = 42, cre = 69, kG = 73, GG = 91, UG = 103, fv = 113, PR = 666, lA = 1, $M = 2, fB = 3, ex = 4, b5n = 3, uC = (t, e) => (t.msg = uB[e], e), PRe = (t) => (t << 1) - (t > 4 ? 9 : 0), tC = (t) => {
  let e = t.length;
  for (; --e >= 0; )
    t[e] = 0;
};
let _5n = (t, e, n) => (e << t.hash_shift ^ n) & t.hash_mask, DC = _5n;
const Gm = (t) => {
  const e = t.state;
  let n = e.pending;
  n > t.avail_out && (n = t.avail_out), n !== 0 && (t.output.set(e.pending_buf.subarray(e.pending_out, e.pending_out + n), t.next_out), t.next_out += n, e.pending_out += n, t.total_out += n, t.avail_out -= n, e.pending -= n, e.pending === 0 && (e.pending_out = 0));
}, al = (t, e) => {
  r5n(t, t.block_start >= 0 ? t.block_start : -1, t.strstart - t.block_start, e), t.block_start = t.strstart, Gm(t.strm);
}, Hi = (t, e) => {
  t.pending_buf[t.pending++] = e;
}, L2 = (t, e) => {
  t.pending_buf[t.pending++] = e >>> 8 & 255, t.pending_buf[t.pending++] = e & 255;
}, S5n = (t, e, n, r) => {
  let i = t.avail_in;
  return i > r && (i = r), i === 0 ? 0 : (t.avail_in -= i, e.set(t.input.subarray(t.next_in, t.next_in + i), n), t.state.wrap === 1 ? t.adler = aN(t.adler, e, i, n) : t.state.wrap === 2 && (t.adler = xA(t.adler, e, i, n)), t.next_in += i, t.total_in += i, i);
}, PJe = (t, e) => {
  let n = t.max_chain_length, r = t.strstart, i, o, s = t.prev_length, a = t.nice_match;
  const A = t.strstart > t.w_size - rd ? t.strstart - (t.w_size - rd) : 0, l = t.window, c = t.w_mask, u = t.prev, f = t.strstart + cC;
  let h = l[r + s - 1], d = l[r + s];
  t.prev_length >= t.good_match && (n >>= 2), a > t.lookahead && (a = t.lookahead);
  do
    if (i = e, !(l[i + s] !== d || l[i + s - 1] !== h || l[i] !== l[r] || l[++i] !== l[r + 1])) {
      r += 2, i++;
      do
        ;
      while (l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && r < f);
      if (o = cC - (f - r), r = f - cC, o > s) {
        if (t.match_start = e, s = o, o >= a)
          break;
        h = l[r + s - 1], d = l[r + s];
      }
    }
  while ((e = u[e & c]) > A && --n !== 0);
  return s <= t.lookahead ? s : t.lookahead;
}, gB = (t) => {
  const e = t.w_size;
  let n, r, i, o, s;
  do {
    if (o = t.window_size - t.lookahead - t.strstart, t.strstart >= e + (e - rd)) {
      t.window.set(t.window.subarray(e, e + e), 0), t.match_start -= e, t.strstart -= e, t.block_start -= e, r = t.hash_size, n = r;
      do
        i = t.head[--n], t.head[n] = i >= e ? i - e : 0;
      while (--r);
      r = e, n = r;
      do
        i = t.prev[--n], t.prev[n] = i >= e ? i - e : 0;
      while (--r);
      o += e;
    }
    if (t.strm.avail_in === 0)
      break;
    if (r = S5n(t.strm, t.window, t.strstart + t.lookahead, o), t.lookahead += r, t.lookahead + t.insert >= Bi)
      for (s = t.strstart - t.insert, t.ins_h = t.window[s], t.ins_h = DC(t, t.ins_h, t.window[s + 1]); t.insert && (t.ins_h = DC(t, t.ins_h, t.window[s + Bi - 1]), t.prev[s & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = s, s++, t.insert--, !(t.lookahead + t.insert < Bi)); )
        ;
  } while (t.lookahead < rd && t.strm.avail_in !== 0);
}, Q5n = (t, e) => {
  let n = 65535;
  for (n > t.pending_buf_size - 5 && (n = t.pending_buf_size - 5); ; ) {
    if (t.lookahead <= 1) {
      if (gB(t), t.lookahead === 0 && e === g1)
        return lA;
      if (t.lookahead === 0)
        break;
    }
    t.strstart += t.lookahead, t.lookahead = 0;
    const r = t.block_start + n;
    if ((t.strstart === 0 || t.strstart >= r) && (t.lookahead = t.strstart - r, t.strstart = r, al(t, !1), t.strm.avail_out === 0) || t.strstart - t.block_start >= t.w_size - rd && (al(t, !1), t.strm.avail_out === 0))
      return lA;
  }
  return t.insert = 0, e === RC ? (al(t, !0), t.strm.avail_out === 0 ? fB : ex) : (t.strstart > t.block_start && (al(t, !1), t.strm.avail_out === 0), lA);
}, zJ = (t, e) => {
  let n, r;
  for (; ; ) {
    if (t.lookahead < rd) {
      if (gB(t), t.lookahead < rd && e === g1)
        return lA;
      if (t.lookahead === 0)
        break;
    }
    if (n = 0, t.lookahead >= Bi && (t.ins_h = DC(t, t.ins_h, t.window[t.strstart + Bi - 1]), n = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), n !== 0 && t.strstart - n <= t.w_size - rd && (t.match_length = PJe(t, n)), t.match_length >= Bi)
      if (r = xC(t, t.strstart - t.match_start, t.match_length - Bi), t.lookahead -= t.match_length, t.match_length <= t.max_lazy_match && t.lookahead >= Bi) {
        t.match_length--;
        do
          t.strstart++, t.ins_h = DC(t, t.ins_h, t.window[t.strstart + Bi - 1]), n = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart;
        while (--t.match_length !== 0);
        t.strstart++;
      } else
        t.strstart += t.match_length, t.match_length = 0, t.ins_h = t.window[t.strstart], t.ins_h = DC(t, t.ins_h, t.window[t.strstart + 1]);
    else
      r = xC(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++;
    if (r && (al(t, !1), t.strm.avail_out === 0))
      return lA;
  }
  return t.insert = t.strstart < Bi - 1 ? t.strstart : Bi - 1, e === RC ? (al(t, !0), t.strm.avail_out === 0 ? fB : ex) : t.last_lit && (al(t, !1), t.strm.avail_out === 0) ? lA : $M;
}, Bb = (t, e) => {
  let n, r, i;
  for (; ; ) {
    if (t.lookahead < rd) {
      if (gB(t), t.lookahead < rd && e === g1)
        return lA;
      if (t.lookahead === 0)
        break;
    }
    if (n = 0, t.lookahead >= Bi && (t.ins_h = DC(t, t.ins_h, t.window[t.strstart + Bi - 1]), n = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), t.prev_length = t.match_length, t.prev_match = t.match_start, t.match_length = Bi - 1, n !== 0 && t.prev_length < t.max_lazy_match && t.strstart - n <= t.w_size - rd && (t.match_length = PJe(t, n), t.match_length <= 5 && (t.strategy === l5n || t.match_length === Bi && t.strstart - t.match_start > 4096) && (t.match_length = Bi - 1)), t.prev_length >= Bi && t.match_length <= t.prev_length) {
      i = t.strstart + t.lookahead - Bi, r = xC(t, t.strstart - 1 - t.prev_match, t.prev_length - Bi), t.lookahead -= t.prev_length - 1, t.prev_length -= 2;
      do
        ++t.strstart <= i && (t.ins_h = DC(t, t.ins_h, t.window[t.strstart + Bi - 1]), n = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart);
      while (--t.prev_length !== 0);
      if (t.match_available = 0, t.match_length = Bi - 1, t.strstart++, r && (al(t, !1), t.strm.avail_out === 0))
        return lA;
    } else if (t.match_available) {
      if (r = xC(t, 0, t.window[t.strstart - 1]), r && al(t, !1), t.strstart++, t.lookahead--, t.strm.avail_out === 0)
        return lA;
    } else
      t.match_available = 1, t.strstart++, t.lookahead--;
  }
  return t.match_available && (r = xC(t, 0, t.window[t.strstart - 1]), t.match_available = 0), t.insert = t.strstart < Bi - 1 ? t.strstart : Bi - 1, e === RC ? (al(t, !0), t.strm.avail_out === 0 ? fB : ex) : t.last_lit && (al(t, !1), t.strm.avail_out === 0) ? lA : $M;
}, w5n = (t, e) => {
  let n, r, i, o;
  const s = t.window;
  for (; ; ) {
    if (t.lookahead <= cC) {
      if (gB(t), t.lookahead <= cC && e === g1)
        return lA;
      if (t.lookahead === 0)
        break;
    }
    if (t.match_length = 0, t.lookahead >= Bi && t.strstart > 0 && (i = t.strstart - 1, r = s[i], r === s[++i] && r === s[++i] && r === s[++i])) {
      o = t.strstart + cC;
      do
        ;
      while (r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && r === s[++i] && i < o);
      t.match_length = cC - (o - i), t.match_length > t.lookahead && (t.match_length = t.lookahead);
    }
    if (t.match_length >= Bi ? (n = xC(t, 1, t.match_length - Bi), t.lookahead -= t.match_length, t.strstart += t.match_length, t.match_length = 0) : (n = xC(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++), n && (al(t, !1), t.strm.avail_out === 0))
      return lA;
  }
  return t.insert = 0, e === RC ? (al(t, !0), t.strm.avail_out === 0 ? fB : ex) : t.last_lit && (al(t, !1), t.strm.avail_out === 0) ? lA : $M;
}, x5n = (t, e) => {
  let n;
  for (; ; ) {
    if (t.lookahead === 0 && (gB(t), t.lookahead === 0)) {
      if (e === g1)
        return lA;
      break;
    }
    if (t.match_length = 0, n = xC(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++, n && (al(t, !1), t.strm.avail_out === 0))
      return lA;
  }
  return t.insert = 0, e === RC ? (al(t, !0), t.strm.avail_out === 0 ? fB : ex) : t.last_lit && (al(t, !1), t.strm.avail_out === 0) ? lA : $M;
};
function ep(t, e, n, r, i) {
  this.good_length = t, this.max_lazy = e, this.nice_length = n, this.max_chain = r, this.func = i;
}
const kR = [
  /*      good lazy nice chain */
  new ep(0, 0, 0, 0, Q5n),
  /* 0 store only */
  new ep(4, 4, 8, 4, zJ),
  /* 1 max speed, no lazy matches */
  new ep(4, 5, 16, 8, zJ),
  /* 2 */
  new ep(4, 6, 32, 32, zJ),
  /* 3 */
  new ep(4, 4, 16, 16, Bb),
  /* 4 lazy matches */
  new ep(8, 16, 32, 32, Bb),
  /* 5 */
  new ep(8, 16, 128, 128, Bb),
  /* 6 */
  new ep(8, 32, 128, 256, Bb),
  /* 7 */
  new ep(32, 128, 258, 1024, Bb),
  /* 8 */
  new ep(32, 258, 258, 4096, Bb)
  /* 9 max compression */
], R5n = (t) => {
  t.window_size = 2 * t.w_size, tC(t.head), t.max_lazy_match = kR[t.level].max_lazy, t.good_match = kR[t.level].good_length, t.nice_match = kR[t.level].nice_length, t.max_chain_length = kR[t.level].max_chain, t.strstart = 0, t.block_start = 0, t.lookahead = 0, t.insert = 0, t.match_length = t.prev_length = Bi - 1, t.match_available = 0, t.ins_h = 0;
};
function D5n() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = _q, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(y5n * 2), this.dyn_dtree = new Uint16Array((2 * C5n + 1) * 2), this.bl_tree = new Uint16Array((2 * E5n + 1) * 2), tC(this.dyn_ltree), tC(this.dyn_dtree), tC(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(v5n + 1), this.heap = new Uint16Array(2 * lre + 1), tC(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * lre + 1), tC(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const kJe = (t) => {
  if (!t || !t.state)
    return uC(t, Ng);
  t.total_in = t.total_out = 0, t.data_type = g5n;
  const e = t.state;
  return e.pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = e.wrap ? Sq : fv, t.adler = e.wrap === 2 ? 0 : 1, e.last_flush = g1, t5n(e), mp;
}, GJe = (t) => {
  const e = kJe(t);
  return e === mp && R5n(t.state), e;
}, T5n = (t, e) => !t || !t.state || t.state.wrap !== 2 ? Ng : (t.state.gzhead = e, mp), UJe = (t, e, n, r, i, o) => {
  if (!t)
    return Ng;
  let s = 1;
  if (e === A5n && (e = 6), r < 0 ? (s = 0, r = -r) : r > 15 && (s = 2, r -= 16), i < 1 || i > h5n || n !== _q || r < 8 || r > 15 || e < 0 || e > 9 || o < 0 || o > u5n)
    return uC(t, Ng);
  r === 8 && (r = 9);
  const a = new D5n();
  return t.state = a, a.strm = t, a.wrap = s, a.gzhead = null, a.w_bits = r, a.w_size = 1 << a.w_bits, a.w_mask = a.w_size - 1, a.hash_bits = i + 7, a.hash_size = 1 << a.hash_bits, a.hash_mask = a.hash_size - 1, a.hash_shift = ~~((a.hash_bits + Bi - 1) / Bi), a.window = new Uint8Array(a.w_size * 2), a.head = new Uint16Array(a.hash_size), a.prev = new Uint16Array(a.w_size), a.lit_bufsize = 1 << i + 6, a.pending_buf_size = a.lit_bufsize * 4, a.pending_buf = new Uint8Array(a.pending_buf_size), a.d_buf = 1 * a.lit_bufsize, a.l_buf = (1 + 2) * a.lit_bufsize, a.level = e, a.strategy = o, a.method = n, GJe(t);
}, N5n = (t, e) => UJe(t, e, _q, d5n, p5n, f5n), L5n = (t, e) => {
  let n, r;
  if (!t || !t.state || e > ORe || e < 0)
    return t ? uC(t, Ng) : Ng;
  const i = t.state;
  if (!t.output || !t.input && t.avail_in !== 0 || i.status === PR && e !== RC)
    return uC(t, t.avail_out === 0 ? YJ : Ng);
  i.strm = t;
  const o = i.last_flush;
  if (i.last_flush = e, i.status === Sq)
    if (i.wrap === 2)
      t.adler = 0, Hi(i, 31), Hi(i, 139), Hi(i, 8), i.gzhead ? (Hi(
        i,
        (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)
      ), Hi(i, i.gzhead.time & 255), Hi(i, i.gzhead.time >> 8 & 255), Hi(i, i.gzhead.time >> 16 & 255), Hi(i, i.gzhead.time >> 24 & 255), Hi(i, i.level === 9 ? 2 : i.strategy >= KP || i.level < 2 ? 4 : 0), Hi(i, i.gzhead.os & 255), i.gzhead.extra && i.gzhead.extra.length && (Hi(i, i.gzhead.extra.length & 255), Hi(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (t.adler = xA(t.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = cre) : (Hi(i, 0), Hi(i, 0), Hi(i, 0), Hi(i, 0), Hi(i, 0), Hi(i, i.level === 9 ? 2 : i.strategy >= KP || i.level < 2 ? 4 : 0), Hi(i, b5n), i.status = fv);
    else {
      let s = _q + (i.w_bits - 8 << 4) << 8, a = -1;
      i.strategy >= KP || i.level < 2 ? a = 0 : i.level < 6 ? a = 1 : i.level === 6 ? a = 2 : a = 3, s |= a << 6, i.strstart !== 0 && (s |= B5n), s += 31 - s % 31, i.status = fv, L2(i, s), i.strstart !== 0 && (L2(i, t.adler >>> 16), L2(i, t.adler & 65535)), t.adler = 1;
    }
  if (i.status === cre)
    if (i.gzhead.extra) {
      for (n = i.pending; i.gzindex < (i.gzhead.extra.length & 65535) && !(i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > n && (t.adler = xA(t.adler, i.pending_buf, i.pending - n, n)), Gm(t), n = i.pending, i.pending === i.pending_buf_size)); )
        Hi(i, i.gzhead.extra[i.gzindex] & 255), i.gzindex++;
      i.gzhead.hcrc && i.pending > n && (t.adler = xA(t.adler, i.pending_buf, i.pending - n, n)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = kG);
    } else
      i.status = kG;
  if (i.status === kG)
    if (i.gzhead.name) {
      n = i.pending;
      do {
        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > n && (t.adler = xA(t.adler, i.pending_buf, i.pending - n, n)), Gm(t), n = i.pending, i.pending === i.pending_buf_size)) {
          r = 1;
          break;
        }
        i.gzindex < i.gzhead.name.length ? r = i.gzhead.name.charCodeAt(i.gzindex++) & 255 : r = 0, Hi(i, r);
      } while (r !== 0);
      i.gzhead.hcrc && i.pending > n && (t.adler = xA(t.adler, i.pending_buf, i.pending - n, n)), r === 0 && (i.gzindex = 0, i.status = GG);
    } else
      i.status = GG;
  if (i.status === GG)
    if (i.gzhead.comment) {
      n = i.pending;
      do {
        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > n && (t.adler = xA(t.adler, i.pending_buf, i.pending - n, n)), Gm(t), n = i.pending, i.pending === i.pending_buf_size)) {
          r = 1;
          break;
        }
        i.gzindex < i.gzhead.comment.length ? r = i.gzhead.comment.charCodeAt(i.gzindex++) & 255 : r = 0, Hi(i, r);
      } while (r !== 0);
      i.gzhead.hcrc && i.pending > n && (t.adler = xA(t.adler, i.pending_buf, i.pending - n, n)), r === 0 && (i.status = UG);
    } else
      i.status = UG;
  if (i.status === UG && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && Gm(t), i.pending + 2 <= i.pending_buf_size && (Hi(i, t.adler & 255), Hi(i, t.adler >> 8 & 255), t.adler = 0, i.status = fv)) : i.status = fv), i.pending !== 0) {
    if (Gm(t), t.avail_out === 0)
      return i.last_flush = -1, mp;
  } else if (t.avail_in === 0 && PRe(e) <= PRe(o) && e !== RC)
    return uC(t, YJ);
  if (i.status === PR && t.avail_in !== 0)
    return uC(t, YJ);
  if (t.avail_in !== 0 || i.lookahead !== 0 || e !== g1 && i.status !== PR) {
    let s = i.strategy === KP ? x5n(i, e) : i.strategy === c5n ? w5n(i, e) : kR[i.level].func(i, e);
    if ((s === fB || s === ex) && (i.status = PR), s === lA || s === fB)
      return t.avail_out === 0 && (i.last_flush = -1), mp;
    if (s === $M && (e === o5n ? i5n(i) : e !== ORe && (n5n(i, 0, 0, !1), e === s5n && (tC(i.head), i.lookahead === 0 && (i.strstart = 0, i.block_start = 0, i.insert = 0))), Gm(t), t.avail_out === 0))
      return i.last_flush = -1, mp;
  }
  return e !== RC ? mp : i.wrap <= 0 ? FRe : (i.wrap === 2 ? (Hi(i, t.adler & 255), Hi(i, t.adler >> 8 & 255), Hi(i, t.adler >> 16 & 255), Hi(i, t.adler >> 24 & 255), Hi(i, t.total_in & 255), Hi(i, t.total_in >> 8 & 255), Hi(i, t.total_in >> 16 & 255), Hi(i, t.total_in >> 24 & 255)) : (L2(i, t.adler >>> 16), L2(i, t.adler & 65535)), Gm(t), i.wrap > 0 && (i.wrap = -i.wrap), i.pending !== 0 ? mp : FRe);
}, M5n = (t) => {
  if (!t || !t.state)
    return Ng;
  const e = t.state.status;
  return e !== Sq && e !== cre && e !== kG && e !== GG && e !== UG && e !== fv && e !== PR ? uC(t, Ng) : (t.state = null, e === fv ? uC(t, a5n) : mp);
}, O5n = (t, e) => {
  let n = e.length;
  if (!t || !t.state)
    return Ng;
  const r = t.state, i = r.wrap;
  if (i === 2 || i === 1 && r.status !== Sq || r.lookahead)
    return Ng;
  if (i === 1 && (t.adler = aN(t.adler, e, n, 0)), r.wrap = 0, n >= r.w_size) {
    i === 0 && (tC(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0);
    let A = new Uint8Array(r.w_size);
    A.set(e.subarray(n - r.w_size, n), 0), e = A, n = r.w_size;
  }
  const o = t.avail_in, s = t.next_in, a = t.input;
  for (t.avail_in = n, t.next_in = 0, t.input = e, gB(r); r.lookahead >= Bi; ) {
    let A = r.strstart, l = r.lookahead - (Bi - 1);
    do
      r.ins_h = DC(r, r.ins_h, r.window[A + Bi - 1]), r.prev[A & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = A, A++;
    while (--l);
    r.strstart = A, r.lookahead = Bi - 1, gB(r);
  }
  return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = Bi - 1, r.match_available = 0, t.next_in = s, t.input = a, t.avail_in = o, r.wrap = i, mp;
};
var F5n = N5n, P5n = UJe, k5n = GJe, G5n = kJe, U5n = T5n, H5n = L5n, $5n = M5n, q5n = O5n, j5n = "pako deflate (from Nodeca project)", LD = {
  deflateInit: F5n,
  deflateInit2: P5n,
  deflateReset: k5n,
  deflateResetKeep: G5n,
  deflateSetHeader: U5n,
  deflate: H5n,
  deflateEnd: $5n,
  deflateSetDictionary: q5n,
  deflateInfo: j5n
};
const Y5n = (t, e) => Object.prototype.hasOwnProperty.call(t, e);
var z5n = function(t) {
  const e = Array.prototype.slice.call(arguments, 1);
  for (; e.length; ) {
    const n = e.shift();
    if (n) {
      if (typeof n != "object")
        throw new TypeError(n + "must be non-object");
      for (const r in n)
        Y5n(n, r) && (t[r] = n[r]);
    }
  }
  return t;
}, V5n = (t) => {
  let e = 0;
  for (let r = 0, i = t.length; r < i; r++)
    e += t[r].length;
  const n = new Uint8Array(e);
  for (let r = 0, i = 0, o = t.length; r < o; r++) {
    let s = t[r];
    n.set(s, i), i += s.length;
  }
  return n;
}, Qq = {
  assign: z5n,
  flattenChunks: V5n
};
let HJe = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  HJe = !1;
}
const AN = new Uint8Array(256);
for (let t = 0; t < 256; t++)
  AN[t] = t >= 252 ? 6 : t >= 248 ? 5 : t >= 240 ? 4 : t >= 224 ? 3 : t >= 192 ? 2 : 1;
AN[254] = AN[254] = 1;
var J5n = (t) => {
  let e, n, r, i, o, s = t.length, a = 0;
  for (i = 0; i < s; i++)
    n = t.charCodeAt(i), (n & 64512) === 55296 && i + 1 < s && (r = t.charCodeAt(i + 1), (r & 64512) === 56320 && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++)), a += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
  for (e = new Uint8Array(a), o = 0, i = 0; o < a; i++)
    n = t.charCodeAt(i), (n & 64512) === 55296 && i + 1 < s && (r = t.charCodeAt(i + 1), (r & 64512) === 56320 && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++)), n < 128 ? e[o++] = n : n < 2048 ? (e[o++] = 192 | n >>> 6, e[o++] = 128 | n & 63) : n < 65536 ? (e[o++] = 224 | n >>> 12, e[o++] = 128 | n >>> 6 & 63, e[o++] = 128 | n & 63) : (e[o++] = 240 | n >>> 18, e[o++] = 128 | n >>> 12 & 63, e[o++] = 128 | n >>> 6 & 63, e[o++] = 128 | n & 63);
  return e;
};
const K5n = (t, e) => {
  if (e < 65534 && t.subarray && HJe)
    return String.fromCharCode.apply(null, t.length === e ? t : t.subarray(0, e));
  let n = "";
  for (let r = 0; r < e; r++)
    n += String.fromCharCode(t[r]);
  return n;
};
var W5n = (t, e) => {
  let n, r;
  const i = e || t.length, o = new Array(i * 2);
  for (r = 0, n = 0; n < i; ) {
    let s = t[n++];
    if (s < 128) {
      o[r++] = s;
      continue;
    }
    let a = AN[s];
    if (a > 4) {
      o[r++] = 65533, n += a - 1;
      continue;
    }
    for (s &= a === 2 ? 31 : a === 3 ? 15 : 7; a > 1 && n < i; )
      s = s << 6 | t[n++] & 63, a--;
    if (a > 1) {
      o[r++] = 65533;
      continue;
    }
    s < 65536 ? o[r++] = s : (s -= 65536, o[r++] = 55296 | s >> 10 & 1023, o[r++] = 56320 | s & 1023);
  }
  return K5n(o, r);
}, X5n = (t, e) => {
  e = e || t.length, e > t.length && (e = t.length);
  let n = e - 1;
  for (; n >= 0 && (t[n] & 192) === 128; )
    n--;
  return n < 0 || n === 0 ? e : n + AN[t[n]] > e ? n : e;
}, lN = {
  string2buf: J5n,
  buf2string: W5n,
  utf8border: X5n
};
function Z5n() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var $Je = Z5n;
const qJe = Object.prototype.toString, {
  Z_NO_FLUSH: e6n,
  Z_SYNC_FLUSH: t6n,
  Z_FULL_FLUSH: n6n,
  Z_FINISH: r6n,
  Z_OK: U8,
  Z_STREAM_END: i6n,
  Z_DEFAULT_COMPRESSION: o6n,
  Z_DEFAULT_STRATEGY: s6n,
  Z_DEFLATED: a6n
} = f1;
function qM(t) {
  this.options = Qq.assign({
    level: o6n,
    method: a6n,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: s6n
  }, t || {});
  let e = this.options;
  e.raw && e.windowBits > 0 ? e.windowBits = -e.windowBits : e.gzip && e.windowBits > 0 && e.windowBits < 16 && (e.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new $Je(), this.strm.avail_out = 0;
  let n = LD.deflateInit2(
    this.strm,
    e.level,
    e.method,
    e.windowBits,
    e.memLevel,
    e.strategy
  );
  if (n !== U8)
    throw new Error(uB[n]);
  if (e.header && LD.deflateSetHeader(this.strm, e.header), e.dictionary) {
    let r;
    if (typeof e.dictionary == "string" ? r = lN.string2buf(e.dictionary) : qJe.call(e.dictionary) === "[object ArrayBuffer]" ? r = new Uint8Array(e.dictionary) : r = e.dictionary, n = LD.deflateSetDictionary(this.strm, r), n !== U8)
      throw new Error(uB[n]);
    this._dict_set = !0;
  }
}
qM.prototype.push = function(t, e) {
  const n = this.strm, r = this.options.chunkSize;
  let i, o;
  if (this.ended)
    return !1;
  for (e === ~~e ? o = e : o = e === !0 ? r6n : e6n, typeof t == "string" ? n.input = lN.string2buf(t) : qJe.call(t) === "[object ArrayBuffer]" ? n.input = new Uint8Array(t) : n.input = t, n.next_in = 0, n.avail_in = n.input.length; ; ) {
    if (n.avail_out === 0 && (n.output = new Uint8Array(r), n.next_out = 0, n.avail_out = r), (o === t6n || o === n6n) && n.avail_out <= 6) {
      this.onData(n.output.subarray(0, n.next_out)), n.avail_out = 0;
      continue;
    }
    if (i = LD.deflate(n, o), i === i6n)
      return n.next_out > 0 && this.onData(n.output.subarray(0, n.next_out)), i = LD.deflateEnd(this.strm), this.onEnd(i), this.ended = !0, i === U8;
    if (n.avail_out === 0) {
      this.onData(n.output);
      continue;
    }
    if (o > 0 && n.next_out > 0) {
      this.onData(n.output.subarray(0, n.next_out)), n.avail_out = 0;
      continue;
    }
    if (n.avail_in === 0)
      break;
  }
  return !0;
};
qM.prototype.onData = function(t) {
  this.chunks.push(t);
};
qM.prototype.onEnd = function(t) {
  t === U8 && (this.result = Qq.flattenChunks(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
};
function hfe(t, e) {
  const n = new qM(e);
  if (n.push(t, !0), n.err)
    throw n.msg || uB[n.err];
  return n.result;
}
function A6n(t, e) {
  return e = e || {}, e.raw = !0, hfe(t, e);
}
function l6n(t, e) {
  return e = e || {}, e.gzip = !0, hfe(t, e);
}
var c6n = qM, u6n = hfe, f6n = A6n, g6n = l6n, h6n = f1, d6n = {
  Deflate: c6n,
  deflate: u6n,
  deflateRaw: f6n,
  gzip: g6n,
  constants: h6n
};
const WP = 30, p6n = 12;
var I6n = function(e, n) {
  let r, i, o, s, a, A, l, c, u, f, h, d, I, m, C, y, v, b, Q, w, R, M, O, L;
  const N = e.state;
  r = e.next_in, O = e.input, i = r + (e.avail_in - 5), o = e.next_out, L = e.output, s = o - (n - e.avail_out), a = o + (e.avail_out - 257), A = N.dmax, l = N.wsize, c = N.whave, u = N.wnext, f = N.window, h = N.hold, d = N.bits, I = N.lencode, m = N.distcode, C = (1 << N.lenbits) - 1, y = (1 << N.distbits) - 1;
  e:
    do {
      d < 15 && (h += O[r++] << d, d += 8, h += O[r++] << d, d += 8), v = I[h & C];
      t:
        for (; ; ) {
          if (b = v >>> 24, h >>>= b, d -= b, b = v >>> 16 & 255, b === 0)
            L[o++] = v & 65535;
          else if (b & 16) {
            Q = v & 65535, b &= 15, b && (d < b && (h += O[r++] << d, d += 8), Q += h & (1 << b) - 1, h >>>= b, d -= b), d < 15 && (h += O[r++] << d, d += 8, h += O[r++] << d, d += 8), v = m[h & y];
            n:
              for (; ; ) {
                if (b = v >>> 24, h >>>= b, d -= b, b = v >>> 16 & 255, b & 16) {
                  if (w = v & 65535, b &= 15, d < b && (h += O[r++] << d, d += 8, d < b && (h += O[r++] << d, d += 8)), w += h & (1 << b) - 1, w > A) {
                    e.msg = "invalid distance too far back", N.mode = WP;
                    break e;
                  }
                  if (h >>>= b, d -= b, b = o - s, w > b) {
                    if (b = w - b, b > c && N.sane) {
                      e.msg = "invalid distance too far back", N.mode = WP;
                      break e;
                    }
                    if (R = 0, M = f, u === 0) {
                      if (R += l - b, b < Q) {
                        Q -= b;
                        do
                          L[o++] = f[R++];
                        while (--b);
                        R = o - w, M = L;
                      }
                    } else if (u < b) {
                      if (R += l + u - b, b -= u, b < Q) {
                        Q -= b;
                        do
                          L[o++] = f[R++];
                        while (--b);
                        if (R = 0, u < Q) {
                          b = u, Q -= b;
                          do
                            L[o++] = f[R++];
                          while (--b);
                          R = o - w, M = L;
                        }
                      }
                    } else if (R += u - b, b < Q) {
                      Q -= b;
                      do
                        L[o++] = f[R++];
                      while (--b);
                      R = o - w, M = L;
                    }
                    for (; Q > 2; )
                      L[o++] = M[R++], L[o++] = M[R++], L[o++] = M[R++], Q -= 3;
                    Q && (L[o++] = M[R++], Q > 1 && (L[o++] = M[R++]));
                  } else {
                    R = o - w;
                    do
                      L[o++] = L[R++], L[o++] = L[R++], L[o++] = L[R++], Q -= 3;
                    while (Q > 2);
                    Q && (L[o++] = L[R++], Q > 1 && (L[o++] = L[R++]));
                  }
                } else if (b & 64) {
                  e.msg = "invalid distance code", N.mode = WP;
                  break e;
                } else {
                  v = m[(v & 65535) + (h & (1 << b) - 1)];
                  continue n;
                }
                break;
              }
          } else if (b & 64)
            if (b & 32) {
              N.mode = p6n;
              break e;
            } else {
              e.msg = "invalid literal/length code", N.mode = WP;
              break e;
            }
          else {
            v = I[(v & 65535) + (h & (1 << b) - 1)];
            continue t;
          }
          break;
        }
    } while (r < i && o < a);
  Q = d >> 3, r -= Q, d -= Q << 3, h &= (1 << d) - 1, e.next_in = r, e.next_out = o, e.avail_in = r < i ? 5 + (i - r) : 5 - (r - i), e.avail_out = o < a ? 257 + (a - o) : 257 - (o - a), N.hold = h, N.bits = d;
};
const bb = 15, kRe = 852, GRe = 592, URe = 0, VJ = 1, HRe = 2, m6n = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), C6n = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), E6n = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), y6n = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), v6n = (t, e, n, r, i, o, s, a) => {
  const A = a.bits;
  let l = 0, c = 0, u = 0, f = 0, h = 0, d = 0, I = 0, m = 0, C = 0, y = 0, v, b, Q, w, R, M = null, O = 0, L;
  const N = new Uint16Array(bb + 1), k = new Uint16Array(bb + 1);
  let $ = null, U = 0, X, K, z;
  for (l = 0; l <= bb; l++)
    N[l] = 0;
  for (c = 0; c < r; c++)
    N[e[n + c]]++;
  for (h = A, f = bb; f >= 1 && N[f] === 0; f--)
    ;
  if (h > f && (h = f), f === 0)
    return i[o++] = 1 << 24 | 64 << 16 | 0, i[o++] = 1 << 24 | 64 << 16 | 0, a.bits = 1, 0;
  for (u = 1; u < f && N[u] === 0; u++)
    ;
  for (h < u && (h = u), m = 1, l = 1; l <= bb; l++)
    if (m <<= 1, m -= N[l], m < 0)
      return -1;
  if (m > 0 && (t === URe || f !== 1))
    return -1;
  for (k[1] = 0, l = 1; l < bb; l++)
    k[l + 1] = k[l] + N[l];
  for (c = 0; c < r; c++)
    e[n + c] !== 0 && (s[k[e[n + c]]++] = c);
  if (t === URe ? (M = $ = s, L = 19) : t === VJ ? (M = m6n, O -= 257, $ = C6n, U -= 257, L = 256) : (M = E6n, $ = y6n, L = -1), y = 0, c = 0, l = u, R = o, d = h, I = 0, Q = -1, C = 1 << h, w = C - 1, t === VJ && C > kRe || t === HRe && C > GRe)
    return 1;
  for (; ; ) {
    X = l - I, s[c] < L ? (K = 0, z = s[c]) : s[c] > L ? (K = $[U + s[c]], z = M[O + s[c]]) : (K = 32 + 64, z = 0), v = 1 << l - I, b = 1 << d, u = b;
    do
      b -= v, i[R + (y >> I) + b] = X << 24 | K << 16 | z | 0;
    while (b !== 0);
    for (v = 1 << l - 1; y & v; )
      v >>= 1;
    if (v !== 0 ? (y &= v - 1, y += v) : y = 0, c++, --N[l] === 0) {
      if (l === f)
        break;
      l = e[n + s[c]];
    }
    if (l > h && (y & w) !== Q) {
      for (I === 0 && (I = h), R += u, d = l - I, m = 1 << d; d + I < f && (m -= N[d + I], !(m <= 0)); )
        d++, m <<= 1;
      if (C += 1 << d, t === VJ && C > kRe || t === HRe && C > GRe)
        return 1;
      Q = y & w, i[Q] = h << 24 | d << 16 | R - o | 0;
    }
  }
  return y !== 0 && (i[R + y] = l - I << 24 | 64 << 16 | 0), a.bits = h, 0;
};
var MD = v6n;
const B6n = 0, jJe = 1, YJe = 2, {
  Z_FINISH: $Re,
  Z_BLOCK: b6n,
  Z_TREES: XP,
  Z_OK: hB,
  Z_STREAM_END: _6n,
  Z_NEED_DICT: S6n,
  Z_STREAM_ERROR: Hg,
  Z_DATA_ERROR: zJe,
  Z_MEM_ERROR: VJe,
  Z_BUF_ERROR: Q6n,
  Z_DEFLATED: qRe
} = f1, JJe = 1, jRe = 2, YRe = 3, zRe = 4, VRe = 5, JRe = 6, KRe = 7, WRe = 8, XRe = 9, ZRe = 10, H8 = 11, O0 = 12, JJ = 13, eDe = 14, KJ = 15, tDe = 16, nDe = 17, rDe = 18, iDe = 19, ZP = 20, e3 = 21, oDe = 22, sDe = 23, aDe = 24, ADe = 25, lDe = 26, WJ = 27, cDe = 28, uDe = 29, ws = 30, KJe = 31, w6n = 32, x6n = 852, R6n = 592, D6n = 15, T6n = D6n, fDe = (t) => (t >>> 24 & 255) + (t >>> 8 & 65280) + ((t & 65280) << 8) + ((t & 255) << 24);
function N6n() {
  this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const WJe = (t) => {
  if (!t || !t.state)
    return Hg;
  const e = t.state;
  return t.total_in = t.total_out = e.total = 0, t.msg = "", e.wrap && (t.adler = e.wrap & 1), e.mode = JJe, e.last = 0, e.havedict = 0, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new Int32Array(x6n), e.distcode = e.distdyn = new Int32Array(R6n), e.sane = 1, e.back = -1, hB;
}, XJe = (t) => {
  if (!t || !t.state)
    return Hg;
  const e = t.state;
  return e.wsize = 0, e.whave = 0, e.wnext = 0, WJe(t);
}, ZJe = (t, e) => {
  let n;
  if (!t || !t.state)
    return Hg;
  const r = t.state;
  return e < 0 ? (n = 0, e = -e) : (n = (e >> 4) + 1, e < 48 && (e &= 15)), e && (e < 8 || e > 15) ? Hg : (r.window !== null && r.wbits !== e && (r.window = null), r.wrap = n, r.wbits = e, XJe(t));
}, eKe = (t, e) => {
  if (!t)
    return Hg;
  const n = new N6n();
  t.state = n, n.window = null;
  const r = ZJe(t, e);
  return r !== hB && (t.state = null), r;
}, L6n = (t) => eKe(t, T6n);
let gDe = !0, XJ, ZJ;
const M6n = (t) => {
  if (gDe) {
    XJ = new Int32Array(512), ZJ = new Int32Array(32);
    let e = 0;
    for (; e < 144; )
      t.lens[e++] = 8;
    for (; e < 256; )
      t.lens[e++] = 9;
    for (; e < 280; )
      t.lens[e++] = 7;
    for (; e < 288; )
      t.lens[e++] = 8;
    for (MD(jJe, t.lens, 0, 288, XJ, 0, t.work, { bits: 9 }), e = 0; e < 32; )
      t.lens[e++] = 5;
    MD(YJe, t.lens, 0, 32, ZJ, 0, t.work, { bits: 5 }), gDe = !1;
  }
  t.lencode = XJ, t.lenbits = 9, t.distcode = ZJ, t.distbits = 5;
}, tKe = (t, e, n, r) => {
  let i;
  const o = t.state;
  return o.window === null && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new Uint8Array(o.wsize)), r >= o.wsize ? (o.window.set(e.subarray(n - o.wsize, n), 0), o.wnext = 0, o.whave = o.wsize) : (i = o.wsize - o.wnext, i > r && (i = r), o.window.set(e.subarray(n - r, n - r + i), o.wnext), r -= i, r ? (o.window.set(e.subarray(n - r, n), 0), o.wnext = r, o.whave = o.wsize) : (o.wnext += i, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += i))), 0;
}, O6n = (t, e) => {
  let n, r, i, o, s, a, A, l, c, u, f, h, d, I, m = 0, C, y, v, b, Q, w, R, M;
  const O = new Uint8Array(4);
  let L, N;
  const k = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (!t || !t.state || !t.output || !t.input && t.avail_in !== 0)
    return Hg;
  n = t.state, n.mode === O0 && (n.mode = JJ), s = t.next_out, i = t.output, A = t.avail_out, o = t.next_in, r = t.input, a = t.avail_in, l = n.hold, c = n.bits, u = a, f = A, M = hB;
  e:
    for (; ; )
      switch (n.mode) {
        case JJe:
          if (n.wrap === 0) {
            n.mode = JJ;
            break;
          }
          for (; c < 16; ) {
            if (a === 0)
              break e;
            a--, l += r[o++] << c, c += 8;
          }
          if (n.wrap & 2 && l === 35615) {
            n.check = 0, O[0] = l & 255, O[1] = l >>> 8 & 255, n.check = xA(n.check, O, 2, 0), l = 0, c = 0, n.mode = jRe;
            break;
          }
          if (n.flags = 0, n.head && (n.head.done = !1), !(n.wrap & 1) || /* check if zlib header allowed */
          (((l & 255) << 8) + (l >> 8)) % 31) {
            t.msg = "incorrect header check", n.mode = ws;
            break;
          }
          if ((l & 15) !== qRe) {
            t.msg = "unknown compression method", n.mode = ws;
            break;
          }
          if (l >>>= 4, c -= 4, R = (l & 15) + 8, n.wbits === 0)
            n.wbits = R;
          else if (R > n.wbits) {
            t.msg = "invalid window size", n.mode = ws;
            break;
          }
          n.dmax = 1 << n.wbits, t.adler = n.check = 1, n.mode = l & 512 ? ZRe : O0, l = 0, c = 0;
          break;
        case jRe:
          for (; c < 16; ) {
            if (a === 0)
              break e;
            a--, l += r[o++] << c, c += 8;
          }
          if (n.flags = l, (n.flags & 255) !== qRe) {
            t.msg = "unknown compression method", n.mode = ws;
            break;
          }
          if (n.flags & 57344) {
            t.msg = "unknown header flags set", n.mode = ws;
            break;
          }
          n.head && (n.head.text = l >> 8 & 1), n.flags & 512 && (O[0] = l & 255, O[1] = l >>> 8 & 255, n.check = xA(n.check, O, 2, 0)), l = 0, c = 0, n.mode = YRe;
        case YRe:
          for (; c < 32; ) {
            if (a === 0)
              break e;
            a--, l += r[o++] << c, c += 8;
          }
          n.head && (n.head.time = l), n.flags & 512 && (O[0] = l & 255, O[1] = l >>> 8 & 255, O[2] = l >>> 16 & 255, O[3] = l >>> 24 & 255, n.check = xA(n.check, O, 4, 0)), l = 0, c = 0, n.mode = zRe;
        case zRe:
          for (; c < 16; ) {
            if (a === 0)
              break e;
            a--, l += r[o++] << c, c += 8;
          }
          n.head && (n.head.xflags = l & 255, n.head.os = l >> 8), n.flags & 512 && (O[0] = l & 255, O[1] = l >>> 8 & 255, n.check = xA(n.check, O, 2, 0)), l = 0, c = 0, n.mode = VRe;
        case VRe:
          if (n.flags & 1024) {
            for (; c < 16; ) {
              if (a === 0)
                break e;
              a--, l += r[o++] << c, c += 8;
            }
            n.length = l, n.head && (n.head.extra_len = l), n.flags & 512 && (O[0] = l & 255, O[1] = l >>> 8 & 255, n.check = xA(n.check, O, 2, 0)), l = 0, c = 0;
          } else
            n.head && (n.head.extra = null);
          n.mode = JRe;
        case JRe:
          if (n.flags & 1024 && (h = n.length, h > a && (h = a), h && (n.head && (R = n.head.extra_len - n.length, n.head.extra || (n.head.extra = new Uint8Array(n.head.extra_len)), n.head.extra.set(
            r.subarray(
              o,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              o + h
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            R
          )), n.flags & 512 && (n.check = xA(n.check, r, h, o)), a -= h, o += h, n.length -= h), n.length))
            break e;
          n.length = 0, n.mode = KRe;
        case KRe:
          if (n.flags & 2048) {
            if (a === 0)
              break e;
            h = 0;
            do
              R = r[o + h++], n.head && R && n.length < 65536 && (n.head.name += String.fromCharCode(R));
            while (R && h < a);
            if (n.flags & 512 && (n.check = xA(n.check, r, h, o)), a -= h, o += h, R)
              break e;
          } else
            n.head && (n.head.name = null);
          n.length = 0, n.mode = WRe;
        case WRe:
          if (n.flags & 4096) {
            if (a === 0)
              break e;
            h = 0;
            do
              R = r[o + h++], n.head && R && n.length < 65536 && (n.head.comment += String.fromCharCode(R));
            while (R && h < a);
            if (n.flags & 512 && (n.check = xA(n.check, r, h, o)), a -= h, o += h, R)
              break e;
          } else
            n.head && (n.head.comment = null);
          n.mode = XRe;
        case XRe:
          if (n.flags & 512) {
            for (; c < 16; ) {
              if (a === 0)
                break e;
              a--, l += r[o++] << c, c += 8;
            }
            if (l !== (n.check & 65535)) {
              t.msg = "header crc mismatch", n.mode = ws;
              break;
            }
            l = 0, c = 0;
          }
          n.head && (n.head.hcrc = n.flags >> 9 & 1, n.head.done = !0), t.adler = n.check = 0, n.mode = O0;
          break;
        case ZRe:
          for (; c < 32; ) {
            if (a === 0)
              break e;
            a--, l += r[o++] << c, c += 8;
          }
          t.adler = n.check = fDe(l), l = 0, c = 0, n.mode = H8;
        case H8:
          if (n.havedict === 0)
            return t.next_out = s, t.avail_out = A, t.next_in = o, t.avail_in = a, n.hold = l, n.bits = c, S6n;
          t.adler = n.check = 1, n.mode = O0;
        case O0:
          if (e === b6n || e === XP)
            break e;
        case JJ:
          if (n.last) {
            l >>>= c & 7, c -= c & 7, n.mode = WJ;
            break;
          }
          for (; c < 3; ) {
            if (a === 0)
              break e;
            a--, l += r[o++] << c, c += 8;
          }
          switch (n.last = l & 1, l >>>= 1, c -= 1, l & 3) {
            case 0:
              n.mode = eDe;
              break;
            case 1:
              if (M6n(n), n.mode = ZP, e === XP) {
                l >>>= 2, c -= 2;
                break e;
              }
              break;
            case 2:
              n.mode = nDe;
              break;
            case 3:
              t.msg = "invalid block type", n.mode = ws;
          }
          l >>>= 2, c -= 2;
          break;
        case eDe:
          for (l >>>= c & 7, c -= c & 7; c < 32; ) {
            if (a === 0)
              break e;
            a--, l += r[o++] << c, c += 8;
          }
          if ((l & 65535) !== (l >>> 16 ^ 65535)) {
            t.msg = "invalid stored block lengths", n.mode = ws;
            break;
          }
          if (n.length = l & 65535, l = 0, c = 0, n.mode = KJ, e === XP)
            break e;
        case KJ:
          n.mode = tDe;
        case tDe:
          if (h = n.length, h) {
            if (h > a && (h = a), h > A && (h = A), h === 0)
              break e;
            i.set(r.subarray(o, o + h), s), a -= h, o += h, A -= h, s += h, n.length -= h;
            break;
          }
          n.mode = O0;
          break;
        case nDe:
          for (; c < 14; ) {
            if (a === 0)
              break e;
            a--, l += r[o++] << c, c += 8;
          }
          if (n.nlen = (l & 31) + 257, l >>>= 5, c -= 5, n.ndist = (l & 31) + 1, l >>>= 5, c -= 5, n.ncode = (l & 15) + 4, l >>>= 4, c -= 4, n.nlen > 286 || n.ndist > 30) {
            t.msg = "too many length or distance symbols", n.mode = ws;
            break;
          }
          n.have = 0, n.mode = rDe;
        case rDe:
          for (; n.have < n.ncode; ) {
            for (; c < 3; ) {
              if (a === 0)
                break e;
              a--, l += r[o++] << c, c += 8;
            }
            n.lens[k[n.have++]] = l & 7, l >>>= 3, c -= 3;
          }
          for (; n.have < 19; )
            n.lens[k[n.have++]] = 0;
          if (n.lencode = n.lendyn, n.lenbits = 7, L = { bits: n.lenbits }, M = MD(B6n, n.lens, 0, 19, n.lencode, 0, n.work, L), n.lenbits = L.bits, M) {
            t.msg = "invalid code lengths set", n.mode = ws;
            break;
          }
          n.have = 0, n.mode = iDe;
        case iDe:
          for (; n.have < n.nlen + n.ndist; ) {
            for (; m = n.lencode[l & (1 << n.lenbits) - 1], C = m >>> 24, y = m >>> 16 & 255, v = m & 65535, !(C <= c); ) {
              if (a === 0)
                break e;
              a--, l += r[o++] << c, c += 8;
            }
            if (v < 16)
              l >>>= C, c -= C, n.lens[n.have++] = v;
            else {
              if (v === 16) {
                for (N = C + 2; c < N; ) {
                  if (a === 0)
                    break e;
                  a--, l += r[o++] << c, c += 8;
                }
                if (l >>>= C, c -= C, n.have === 0) {
                  t.msg = "invalid bit length repeat", n.mode = ws;
                  break;
                }
                R = n.lens[n.have - 1], h = 3 + (l & 3), l >>>= 2, c -= 2;
              } else if (v === 17) {
                for (N = C + 3; c < N; ) {
                  if (a === 0)
                    break e;
                  a--, l += r[o++] << c, c += 8;
                }
                l >>>= C, c -= C, R = 0, h = 3 + (l & 7), l >>>= 3, c -= 3;
              } else {
                for (N = C + 7; c < N; ) {
                  if (a === 0)
                    break e;
                  a--, l += r[o++] << c, c += 8;
                }
                l >>>= C, c -= C, R = 0, h = 11 + (l & 127), l >>>= 7, c -= 7;
              }
              if (n.have + h > n.nlen + n.ndist) {
                t.msg = "invalid bit length repeat", n.mode = ws;
                break;
              }
              for (; h--; )
                n.lens[n.have++] = R;
            }
          }
          if (n.mode === ws)
            break;
          if (n.lens[256] === 0) {
            t.msg = "invalid code -- missing end-of-block", n.mode = ws;
            break;
          }
          if (n.lenbits = 9, L = { bits: n.lenbits }, M = MD(jJe, n.lens, 0, n.nlen, n.lencode, 0, n.work, L), n.lenbits = L.bits, M) {
            t.msg = "invalid literal/lengths set", n.mode = ws;
            break;
          }
          if (n.distbits = 6, n.distcode = n.distdyn, L = { bits: n.distbits }, M = MD(YJe, n.lens, n.nlen, n.ndist, n.distcode, 0, n.work, L), n.distbits = L.bits, M) {
            t.msg = "invalid distances set", n.mode = ws;
            break;
          }
          if (n.mode = ZP, e === XP)
            break e;
        case ZP:
          n.mode = e3;
        case e3:
          if (a >= 6 && A >= 258) {
            t.next_out = s, t.avail_out = A, t.next_in = o, t.avail_in = a, n.hold = l, n.bits = c, I6n(t, f), s = t.next_out, i = t.output, A = t.avail_out, o = t.next_in, r = t.input, a = t.avail_in, l = n.hold, c = n.bits, n.mode === O0 && (n.back = -1);
            break;
          }
          for (n.back = 0; m = n.lencode[l & (1 << n.lenbits) - 1], C = m >>> 24, y = m >>> 16 & 255, v = m & 65535, !(C <= c); ) {
            if (a === 0)
              break e;
            a--, l += r[o++] << c, c += 8;
          }
          if (y && !(y & 240)) {
            for (b = C, Q = y, w = v; m = n.lencode[w + ((l & (1 << b + Q) - 1) >> b)], C = m >>> 24, y = m >>> 16 & 255, v = m & 65535, !(b + C <= c); ) {
              if (a === 0)
                break e;
              a--, l += r[o++] << c, c += 8;
            }
            l >>>= b, c -= b, n.back += b;
          }
          if (l >>>= C, c -= C, n.back += C, n.length = v, y === 0) {
            n.mode = lDe;
            break;
          }
          if (y & 32) {
            n.back = -1, n.mode = O0;
            break;
          }
          if (y & 64) {
            t.msg = "invalid literal/length code", n.mode = ws;
            break;
          }
          n.extra = y & 15, n.mode = oDe;
        case oDe:
          if (n.extra) {
            for (N = n.extra; c < N; ) {
              if (a === 0)
                break e;
              a--, l += r[o++] << c, c += 8;
            }
            n.length += l & (1 << n.extra) - 1, l >>>= n.extra, c -= n.extra, n.back += n.extra;
          }
          n.was = n.length, n.mode = sDe;
        case sDe:
          for (; m = n.distcode[l & (1 << n.distbits) - 1], C = m >>> 24, y = m >>> 16 & 255, v = m & 65535, !(C <= c); ) {
            if (a === 0)
              break e;
            a--, l += r[o++] << c, c += 8;
          }
          if (!(y & 240)) {
            for (b = C, Q = y, w = v; m = n.distcode[w + ((l & (1 << b + Q) - 1) >> b)], C = m >>> 24, y = m >>> 16 & 255, v = m & 65535, !(b + C <= c); ) {
              if (a === 0)
                break e;
              a--, l += r[o++] << c, c += 8;
            }
            l >>>= b, c -= b, n.back += b;
          }
          if (l >>>= C, c -= C, n.back += C, y & 64) {
            t.msg = "invalid distance code", n.mode = ws;
            break;
          }
          n.offset = v, n.extra = y & 15, n.mode = aDe;
        case aDe:
          if (n.extra) {
            for (N = n.extra; c < N; ) {
              if (a === 0)
                break e;
              a--, l += r[o++] << c, c += 8;
            }
            n.offset += l & (1 << n.extra) - 1, l >>>= n.extra, c -= n.extra, n.back += n.extra;
          }
          if (n.offset > n.dmax) {
            t.msg = "invalid distance too far back", n.mode = ws;
            break;
          }
          n.mode = ADe;
        case ADe:
          if (A === 0)
            break e;
          if (h = f - A, n.offset > h) {
            if (h = n.offset - h, h > n.whave && n.sane) {
              t.msg = "invalid distance too far back", n.mode = ws;
              break;
            }
            h > n.wnext ? (h -= n.wnext, d = n.wsize - h) : d = n.wnext - h, h > n.length && (h = n.length), I = n.window;
          } else
            I = i, d = s - n.offset, h = n.length;
          h > A && (h = A), A -= h, n.length -= h;
          do
            i[s++] = I[d++];
          while (--h);
          n.length === 0 && (n.mode = e3);
          break;
        case lDe:
          if (A === 0)
            break e;
          i[s++] = n.length, A--, n.mode = e3;
          break;
        case WJ:
          if (n.wrap) {
            for (; c < 32; ) {
              if (a === 0)
                break e;
              a--, l |= r[o++] << c, c += 8;
            }
            if (f -= A, t.total_out += f, n.total += f, f && (t.adler = n.check = /*UPDATE(state.check, put - _out, _out);*/
            n.flags ? xA(n.check, i, f, s - f) : aN(n.check, i, f, s - f)), f = A, (n.flags ? l : fDe(l)) !== n.check) {
              t.msg = "incorrect data check", n.mode = ws;
              break;
            }
            l = 0, c = 0;
          }
          n.mode = cDe;
        case cDe:
          if (n.wrap && n.flags) {
            for (; c < 32; ) {
              if (a === 0)
                break e;
              a--, l += r[o++] << c, c += 8;
            }
            if (l !== (n.total & 4294967295)) {
              t.msg = "incorrect length check", n.mode = ws;
              break;
            }
            l = 0, c = 0;
          }
          n.mode = uDe;
        case uDe:
          M = _6n;
          break e;
        case ws:
          M = zJe;
          break e;
        case KJe:
          return VJe;
        case w6n:
        default:
          return Hg;
      }
  return t.next_out = s, t.avail_out = A, t.next_in = o, t.avail_in = a, n.hold = l, n.bits = c, (n.wsize || f !== t.avail_out && n.mode < ws && (n.mode < WJ || e !== $Re)) && tKe(t, t.output, t.next_out, f - t.avail_out), u -= t.avail_in, f -= t.avail_out, t.total_in += u, t.total_out += f, n.total += f, n.wrap && f && (t.adler = n.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
  n.flags ? xA(n.check, i, f, t.next_out - f) : aN(n.check, i, f, t.next_out - f)), t.data_type = n.bits + (n.last ? 64 : 0) + (n.mode === O0 ? 128 : 0) + (n.mode === ZP || n.mode === KJ ? 256 : 0), (u === 0 && f === 0 || e === $Re) && M === hB && (M = Q6n), M;
}, F6n = (t) => {
  if (!t || !t.state)
    return Hg;
  let e = t.state;
  return e.window && (e.window = null), t.state = null, hB;
}, P6n = (t, e) => {
  if (!t || !t.state)
    return Hg;
  const n = t.state;
  return n.wrap & 2 ? (n.head = e, e.done = !1, hB) : Hg;
}, k6n = (t, e) => {
  const n = e.length;
  let r, i, o;
  return !t || !t.state || (r = t.state, r.wrap !== 0 && r.mode !== H8) ? Hg : r.mode === H8 && (i = 1, i = aN(i, e, n, 0), i !== r.check) ? zJe : (o = tKe(t, e, n, n), o ? (r.mode = KJe, VJe) : (r.havedict = 1, hB));
};
var G6n = XJe, U6n = ZJe, H6n = WJe, $6n = L6n, q6n = eKe, j6n = O6n, Y6n = F6n, z6n = P6n, V6n = k6n, J6n = "pako inflate (from Nodeca project)", W0 = {
  inflateReset: G6n,
  inflateReset2: U6n,
  inflateResetKeep: H6n,
  inflateInit: $6n,
  inflateInit2: q6n,
  inflate: j6n,
  inflateEnd: Y6n,
  inflateGetHeader: z6n,
  inflateSetDictionary: V6n,
  inflateInfo: J6n
};
function K6n() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var W6n = K6n;
const nKe = Object.prototype.toString, {
  Z_NO_FLUSH: X6n,
  Z_FINISH: Z6n,
  Z_OK: cN,
  Z_STREAM_END: eK,
  Z_NEED_DICT: tK,
  Z_STREAM_ERROR: eHn,
  Z_DATA_ERROR: hDe,
  Z_MEM_ERROR: tHn
} = f1;
function jM(t) {
  this.options = Qq.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, t || {});
  const e = this.options;
  e.raw && e.windowBits >= 0 && e.windowBits < 16 && (e.windowBits = -e.windowBits, e.windowBits === 0 && (e.windowBits = -15)), e.windowBits >= 0 && e.windowBits < 16 && !(t && t.windowBits) && (e.windowBits += 32), e.windowBits > 15 && e.windowBits < 48 && (e.windowBits & 15 || (e.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new $Je(), this.strm.avail_out = 0;
  let n = W0.inflateInit2(
    this.strm,
    e.windowBits
  );
  if (n !== cN)
    throw new Error(uB[n]);
  if (this.header = new W6n(), W0.inflateGetHeader(this.strm, this.header), e.dictionary && (typeof e.dictionary == "string" ? e.dictionary = lN.string2buf(e.dictionary) : nKe.call(e.dictionary) === "[object ArrayBuffer]" && (e.dictionary = new Uint8Array(e.dictionary)), e.raw && (n = W0.inflateSetDictionary(this.strm, e.dictionary), n !== cN)))
    throw new Error(uB[n]);
}
jM.prototype.push = function(t, e) {
  const n = this.strm, r = this.options.chunkSize, i = this.options.dictionary;
  let o, s, a;
  if (this.ended)
    return !1;
  for (e === ~~e ? s = e : s = e === !0 ? Z6n : X6n, nKe.call(t) === "[object ArrayBuffer]" ? n.input = new Uint8Array(t) : n.input = t, n.next_in = 0, n.avail_in = n.input.length; ; ) {
    for (n.avail_out === 0 && (n.output = new Uint8Array(r), n.next_out = 0, n.avail_out = r), o = W0.inflate(n, s), o === tK && i && (o = W0.inflateSetDictionary(n, i), o === cN ? o = W0.inflate(n, s) : o === hDe && (o = tK)); n.avail_in > 0 && o === eK && n.state.wrap > 0 && t[n.next_in] !== 0; )
      W0.inflateReset(n), o = W0.inflate(n, s);
    switch (o) {
      case eHn:
      case hDe:
      case tK:
      case tHn:
        return this.onEnd(o), this.ended = !0, !1;
    }
    if (a = n.avail_out, n.next_out && (n.avail_out === 0 || o === eK))
      if (this.options.to === "string") {
        let A = lN.utf8border(n.output, n.next_out), l = n.next_out - A, c = lN.buf2string(n.output, A);
        n.next_out = l, n.avail_out = r - l, l && n.output.set(n.output.subarray(A, A + l), 0), this.onData(c);
      } else
        this.onData(n.output.length === n.next_out ? n.output : n.output.subarray(0, n.next_out));
    if (!(o === cN && a === 0)) {
      if (o === eK)
        return o = W0.inflateEnd(this.strm), this.onEnd(o), this.ended = !0, !0;
      if (n.avail_in === 0)
        break;
    }
  }
  return !0;
};
jM.prototype.onData = function(t) {
  this.chunks.push(t);
};
jM.prototype.onEnd = function(t) {
  t === cN && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = Qq.flattenChunks(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
};
function dfe(t, e) {
  const n = new jM(e);
  if (n.push(t), n.err)
    throw n.msg || uB[n.err];
  return n.result;
}
function nHn(t, e) {
  return e = e || {}, e.raw = !0, dfe(t, e);
}
var rHn = jM, iHn = dfe, oHn = nHn, sHn = dfe, aHn = f1, AHn = {
  Inflate: rHn,
  inflate: iHn,
  inflateRaw: oHn,
  ungzip: sHn,
  constants: aHn
};
const { Deflate: lHn, deflate: cHn, deflateRaw: uHn, gzip: fHn } = d6n, { Inflate: gHn, inflate: hHn, inflateRaw: dHn, ungzip: pHn } = AHn;
var IHn = lHn, mHn = cHn, CHn = uHn, EHn = fHn, yHn = gHn, vHn = hHn, BHn = dHn, bHn = pHn, _Hn = f1, $8 = {
  Deflate: IHn,
  deflate: mHn,
  deflateRaw: CHn,
  gzip: EHn,
  Inflate: yHn,
  inflate: vHn,
  inflateRaw: BHn,
  ungzip: bHn,
  constants: _Hn
}, nK;
const dDe = (nK = class rKe {
  constructor(e = 1) {
    if (e < 0 || e > 9)
      throw new Error("Invalid gzip compression level, it should be between 0 and 9");
    this.level = e;
  }
  static fromConfig({ level: e }) {
    return new rKe(e);
  }
  encode(e) {
    return $8.gzip(e, { level: this.level });
  }
  decode(e, n) {
    const r = $8.ungzip(e);
    return n !== void 0 ? (n.set(r), n) : r;
  }
}, nK.codecId = "gzip", nK);
var rK;
const pDe = (rK = class iKe {
  constructor(e = 1) {
    if (e < -1 || e > 9)
      throw new Error("Invalid zlib compression level, it should be between -1 and 9");
    this.level = e;
  }
  static fromConfig({ level: e }) {
    return new iKe(e);
  }
  encode(e) {
    return $8.deflate(e, { level: this.level });
  }
  decode(e, n) {
    const r = $8.inflate(e);
    return n !== void 0 ? (n.set(r), n) : r;
  }
}, rK.codecId = "zlib", rK), SHn = typeof process < "u" && process.versions != null && process.versions.node != null;
let QHn = SHn ? (t) => new Uint8Array(Buffer.from(t, "base64")) : /* @__PURE__ */ (() => {
  for (var t = new Uint8Array(128), e = 0; e < 64; e++)
    t[e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e * 4 - 205] = e;
  return (n) => {
    for (var r = n.length, i = new Uint8Array((r - (n[r - 1] == "=") - (n[r - 2] == "=")) * 3 / 4 | 0), o = 0, s = 0; o < r; ) {
      var a = t[n.charCodeAt(o++)], A = t[n.charCodeAt(o++)], l = t[n.charCodeAt(o++)], c = t[n.charCodeAt(o++)];
      i[s++] = a << 2 | A >> 4, i[s++] = A << 4 | l >> 2, i[s++] = l << 6 | c;
    }
    return i;
  };
})();
function IDe(t, e) {
  const n = QHn(e);
  return t({ noInitialRun: !0, wasmBinary: n });
}
var mDe = function() {
  return typeof document < "u" && document.currentScript && document.currentScript.src, function(t) {
    t = t || {};
    var e;
    e || (e = typeof t < "u" ? t : {});
    var n, r;
    e.ready = new Promise(function(Me, _) {
      n = Me, r = _;
    });
    var i = {}, o;
    for (o in e)
      e.hasOwnProperty(o) && (i[o] = e[o]);
    var s = "./this.program", a = e.print || console.log.bind(console), A = e.printErr || console.warn.bind(console);
    for (o in i)
      i.hasOwnProperty(o) && (e[o] = i[o]);
    i = null, e.thisProgram && (s = e.thisProgram);
    var l;
    e.wasmBinary && (l = e.wasmBinary), e.noExitRuntime && e.noExitRuntime, typeof WebAssembly != "object" && Be("no native wasm support detected");
    var c, u = !1, f = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
    function h(Me, _, ye) {
      var He = _ + ye;
      for (ye = _; Me[ye] && !(ye >= He); )
        ++ye;
      if (16 < ye - _ && Me.subarray && f)
        return f.decode(Me.subarray(_, ye));
      for (He = ""; _ < ye; ) {
        var ze = Me[_++];
        if (ze & 128) {
          var tt = Me[_++] & 63;
          if ((ze & 224) == 192)
            He += String.fromCharCode((ze & 31) << 6 | tt);
          else {
            var At = Me[_++] & 63;
            ze = (ze & 240) == 224 ? (ze & 15) << 12 | tt << 6 | At : (ze & 7) << 18 | tt << 12 | At << 6 | Me[_++] & 63, 65536 > ze ? He += String.fromCharCode(ze) : (ze -= 65536, He += String.fromCharCode(55296 | ze >> 10, 56320 | ze & 1023));
          }
        } else
          He += String.fromCharCode(ze);
      }
      return He;
    }
    function d(Me, _, ye) {
      var He = M;
      if (0 < ye) {
        ye = _ + ye - 1;
        for (var ze = 0; ze < Me.length; ++ze) {
          var tt = Me.charCodeAt(ze);
          if (55296 <= tt && 57343 >= tt) {
            var At = Me.charCodeAt(++ze);
            tt = 65536 + ((tt & 1023) << 10) | At & 1023;
          }
          if (127 >= tt) {
            if (_ >= ye)
              break;
            He[_++] = tt;
          } else {
            if (2047 >= tt) {
              if (_ + 1 >= ye)
                break;
              He[_++] = 192 | tt >> 6;
            } else {
              if (65535 >= tt) {
                if (_ + 2 >= ye)
                  break;
                He[_++] = 224 | tt >> 12;
              } else {
                if (_ + 3 >= ye)
                  break;
                He[_++] = 240 | tt >> 18, He[_++] = 128 | tt >> 12 & 63;
              }
              He[_++] = 128 | tt >> 6 & 63;
            }
            He[_++] = 128 | tt & 63;
          }
        }
        He[_] = 0;
      }
    }
    var I = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0;
    function m(Me, _) {
      for (var ye = Me >> 1, He = ye + _ / 2; !(ye >= He) && L[ye]; )
        ++ye;
      if (ye <<= 1, 32 < ye - Me && I)
        return I.decode(M.subarray(Me, ye));
      for (ye = 0, He = ""; ; ) {
        var ze = O[Me + 2 * ye >> 1];
        if (ze == 0 || ye == _ / 2)
          return He;
        ++ye, He += String.fromCharCode(ze);
      }
    }
    function C(Me, _, ye) {
      if (ye === void 0 && (ye = 2147483647), 2 > ye)
        return 0;
      ye -= 2;
      var He = _;
      ye = ye < 2 * Me.length ? ye / 2 : Me.length;
      for (var ze = 0; ze < ye; ++ze)
        O[_ >> 1] = Me.charCodeAt(ze), _ += 2;
      return O[_ >> 1] = 0, _ - He;
    }
    function y(Me) {
      return 2 * Me.length;
    }
    function v(Me, _) {
      for (var ye = 0, He = ""; !(ye >= _ / 4); ) {
        var ze = N[Me + 4 * ye >> 2];
        if (ze == 0)
          break;
        ++ye, 65536 <= ze ? (ze -= 65536, He += String.fromCharCode(55296 | ze >> 10, 56320 | ze & 1023)) : He += String.fromCharCode(ze);
      }
      return He;
    }
    function b(Me, _, ye) {
      if (ye === void 0 && (ye = 2147483647), 4 > ye)
        return 0;
      var He = _;
      ye = He + ye - 4;
      for (var ze = 0; ze < Me.length; ++ze) {
        var tt = Me.charCodeAt(ze);
        if (55296 <= tt && 57343 >= tt) {
          var At = Me.charCodeAt(++ze);
          tt = 65536 + ((tt & 1023) << 10) | At & 1023;
        }
        if (N[_ >> 2] = tt, _ += 4, _ + 4 > ye)
          break;
      }
      return N[_ >> 2] = 0, _ - He;
    }
    function Q(Me) {
      for (var _ = 0, ye = 0; ye < Me.length; ++ye) {
        var He = Me.charCodeAt(ye);
        55296 <= He && 57343 >= He && ++ye, _ += 4;
      }
      return _;
    }
    var w, R, M, O, L, N, k, $, U;
    function X(Me) {
      w = Me, e.HEAP8 = R = new Int8Array(Me), e.HEAP16 = O = new Int16Array(Me), e.HEAP32 = N = new Int32Array(Me), e.HEAPU8 = M = new Uint8Array(Me), e.HEAPU16 = L = new Uint16Array(Me), e.HEAPU32 = k = new Uint32Array(Me), e.HEAPF32 = $ = new Float32Array(Me), e.HEAPF64 = U = new Float64Array(Me);
    }
    var K = e.INITIAL_MEMORY || 16777216;
    e.wasmMemory ? c = e.wasmMemory : c = new WebAssembly.Memory({ initial: K / 65536, maximum: 32768 }), c && (w = c.buffer), K = w.byteLength, X(w);
    var z, Y = [], V = [], Z = [], ce = [];
    function ee() {
      var Me = e.preRun.shift();
      Y.unshift(Me);
    }
    var pe = 0, Ce = null;
    e.preloadedImages = {}, e.preloadedAudios = {};
    function Be(Me) {
      throw e.onAbort && e.onAbort(Me), A(Me), u = !0, Me = new WebAssembly.RuntimeError("abort(" + Me + "). Build with -s ASSERTIONS=1 for more info."), r(Me), Me;
    }
    function Ie(Me) {
      var _ = xe;
      return String.prototype.startsWith ? _.startsWith(Me) : _.indexOf(Me) === 0;
    }
    function Qe() {
      return Ie("data:application/octet-stream;base64,");
    }
    var xe = "blosc_codec.wasm";
    if (!Qe()) {
      var Se = xe;
      xe = e.locateFile ? e.locateFile(Se, "") : "" + Se;
    }
    function De() {
      try {
        if (l)
          return new Uint8Array(l);
        throw "both async and sync fetching of the wasm failed";
      } catch (Me) {
        Be(Me);
      }
    }
    function Ue(Me) {
      for (; 0 < Me.length; ) {
        var _ = Me.shift();
        if (typeof _ == "function")
          _(e);
        else {
          var ye = _.T;
          typeof ye == "number" ? _.O === void 0 ? z.get(ye)() : z.get(ye)(_.O) : ye(_.O === void 0 ? null : _.O);
        }
      }
    }
    function Te(Me) {
      this.N = Me - 16, this.$ = function(_) {
        N[this.N + 8 >> 2] = _;
      }, this.X = function(_) {
        N[this.N + 0 >> 2] = _;
      }, this.Y = function() {
        N[this.N + 4 >> 2] = 0;
      }, this.W = function() {
        R[this.N + 12 >> 0] = 0;
      }, this.Z = function() {
        R[this.N + 13 >> 0] = 0;
      }, this.V = function(_, ye) {
        this.$(_), this.X(ye), this.Y(), this.W(), this.Z();
      };
    }
    function se(Me) {
      switch (Me) {
        case 1:
          return 0;
        case 2:
          return 1;
        case 4:
          return 2;
        case 8:
          return 3;
        default:
          throw new TypeError("Unknown type size: " + Me);
      }
    }
    var fe = void 0;
    function W(Me) {
      for (var _ = ""; M[Me]; )
        _ += fe[M[Me++]];
      return _;
    }
    var ge = {}, _e = {}, Re = {};
    function Ee(Me) {
      if (Me === void 0)
        return "_unknown";
      Me = Me.replace(/[^a-zA-Z0-9_]/g, "$");
      var _ = Me.charCodeAt(0);
      return 48 <= _ && 57 >= _ ? "_" + Me : Me;
    }
    function oe(Me, _) {
      return Me = Ee(Me), new Function("body", "return function " + Me + `() {
    "use strict";    return body.apply(this, arguments);
};
`)(_);
    }
    function ie(Me) {
      var _ = Error, ye = oe(Me, function(He) {
        this.name = Me, this.message = He, He = Error(He).stack, He !== void 0 && (this.stack = this.toString() + `
` + He.replace(/^Error(:[^\n]*)?\n/, ""));
      });
      return ye.prototype = Object.create(_.prototype), ye.prototype.constructor = ye, ye.prototype.toString = function() {
        return this.message === void 0 ? this.name : this.name + ": " + this.message;
      }, ye;
    }
    var Ae = void 0;
    function de(Me) {
      throw new Ae(Me);
    }
    var we = void 0;
    function Pe(Me, _) {
      function ye(pt) {
        if (pt = _(pt), pt.length !== He.length)
          throw new we("Mismatched type converter count");
        for (var Bt = 0; Bt < He.length; ++Bt)
          qe(He[Bt], pt[Bt]);
      }
      var He = [];
      He.forEach(function(pt) {
        Re[pt] = Me;
      });
      var ze = Array(Me.length), tt = [], At = 0;
      Me.forEach(function(pt, Bt) {
        _e.hasOwnProperty(pt) ? ze[Bt] = _e[pt] : (tt.push(pt), ge.hasOwnProperty(pt) || (ge[pt] = []), ge[pt].push(function() {
          ze[Bt] = _e[pt], ++At, At === tt.length && ye(ze);
        }));
      }), tt.length === 0 && ye(ze);
    }
    function qe(Me, _, ye) {
      if (ye = ye || {}, !("argPackAdvance" in _))
        throw new TypeError("registerType registeredInstance requires argPackAdvance");
      var He = _.name;
      if (Me || de('type "' + He + '" must have a positive integer typeid pointer'), _e.hasOwnProperty(Me)) {
        if (ye.U)
          return;
        de("Cannot register type '" + He + "' twice");
      }
      _e[Me] = _, delete Re[Me], ge.hasOwnProperty(Me) && (_ = ge[Me], delete ge[Me], _.forEach(function(ze) {
        ze();
      }));
    }
    var ke = [], Xe = [{}, { value: void 0 }, { value: null }, { value: !0 }, { value: !1 }];
    function rt(Me) {
      4 < Me && --Xe[Me].P === 0 && (Xe[Me] = void 0, ke.push(Me));
    }
    function it(Me) {
      switch (Me) {
        case void 0:
          return 1;
        case null:
          return 2;
        case !0:
          return 3;
        case !1:
          return 4;
        default:
          var _ = ke.length ? ke.pop() : Xe.length;
          return Xe[_] = { P: 1, value: Me }, _;
      }
    }
    function ht(Me) {
      return this.fromWireType(k[Me >> 2]);
    }
    function mt(Me) {
      if (Me === null)
        return "null";
      var _ = typeof Me;
      return _ === "object" || _ === "array" || _ === "function" ? Me.toString() : "" + Me;
    }
    function _t(Me, _) {
      switch (_) {
        case 2:
          return function(ye) {
            return this.fromWireType($[ye >> 2]);
          };
        case 3:
          return function(ye) {
            return this.fromWireType(U[ye >> 3]);
          };
        default:
          throw new TypeError("Unknown float type: " + Me);
      }
    }
    function Ct(Me) {
      var _ = Function;
      if (!(_ instanceof Function))
        throw new TypeError("new_ called with constructor type " + typeof _ + " which is not a function");
      var ye = oe(_.name || "unknownFunctionName", function() {
      });
      return ye.prototype = _.prototype, ye = new ye(), Me = _.apply(ye, Me), Me instanceof Object ? Me : ye;
    }
    function zt(Me) {
      for (; Me.length; ) {
        var _ = Me.pop();
        Me.pop()(_);
      }
    }
    function jt(Me, _) {
      var ye = e;
      if (ye[Me].L === void 0) {
        var He = ye[Me];
        ye[Me] = function() {
          return ye[Me].L.hasOwnProperty(arguments.length) || de("Function '" + _ + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + ye[Me].L + ")!"), ye[Me].L[arguments.length].apply(this, arguments);
        }, ye[Me].L = [], ye[Me].L[He.S] = He;
      }
    }
    function lt(Me, _, ye) {
      e.hasOwnProperty(Me) ? ((ye === void 0 || e[Me].L !== void 0 && e[Me].L[ye] !== void 0) && de("Cannot register public name '" + Me + "' twice"), jt(Me, Me), e.hasOwnProperty(ye) && de("Cannot register multiple overloads of a function with the same number of arguments (" + ye + ")!"), e[Me].L[ye] = _) : (e[Me] = _, ye !== void 0 && (e[Me].ba = ye));
    }
    function Ht(Me, _) {
      for (var ye = [], He = 0; He < Me; He++)
        ye.push(N[(_ >> 2) + He]);
      return ye;
    }
    function vt(Me, _) {
      0 <= Me.indexOf("j") || Be("Assertion failed: getDynCaller should only be called with i64 sigs");
      var ye = [];
      return function() {
        ye.length = arguments.length;
        for (var He = 0; He < arguments.length; He++)
          ye[He] = arguments[He];
        var ze;
        return Me.indexOf("j") != -1 ? ze = ye && ye.length ? e["dynCall_" + Me].apply(null, [_].concat(ye)) : e["dynCall_" + Me].call(null, _) : ze = z.get(_).apply(null, ye), ze;
      };
    }
    function It(Me, _) {
      Me = W(Me);
      var ye = Me.indexOf("j") != -1 ? vt(Me, _) : z.get(_);
      return typeof ye != "function" && de("unknown function pointer with signature " + Me + ": " + _), ye;
    }
    var un = void 0;
    function hn(Me) {
      Me = nt(Me);
      var _ = W(Me);
      return vn(Me), _;
    }
    function We(Me, _) {
      function ye(tt) {
        ze[tt] || _e[tt] || (Re[tt] ? Re[tt].forEach(ye) : (He.push(tt), ze[tt] = !0));
      }
      var He = [], ze = {};
      throw _.forEach(ye), new un(Me + ": " + He.map(hn).join([", "]));
    }
    function En(Me, _, ye) {
      switch (_) {
        case 0:
          return ye ? function(He) {
            return R[He];
          } : function(He) {
            return M[He];
          };
        case 1:
          return ye ? function(He) {
            return O[He >> 1];
          } : function(He) {
            return L[He >> 1];
          };
        case 2:
          return ye ? function(He) {
            return N[He >> 2];
          } : function(He) {
            return k[He >> 2];
          };
        default:
          throw new TypeError("Unknown integer type: " + Me);
      }
    }
    var qn = {};
    function Pt() {
      if (!dr) {
        var Me = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _: s || "./this.program" }, _;
        for (_ in qn)
          Me[_] = qn[_];
        var ye = [];
        for (_ in Me)
          ye.push(_ + "=" + Me[_]);
        dr = ye;
      }
      return dr;
    }
    for (var dr, yr = [null, [], []], jn = Array(256), Ot = 0; 256 > Ot; ++Ot)
      jn[Ot] = String.fromCharCode(Ot);
    fe = jn, Ae = e.BindingError = ie("BindingError"), we = e.InternalError = ie("InternalError"), e.count_emval_handles = function() {
      for (var Me = 0, _ = 5; _ < Xe.length; ++_)
        Xe[_] !== void 0 && ++Me;
      return Me;
    }, e.get_first_emval = function() {
      for (var Me = 5; Me < Xe.length; ++Me)
        if (Xe[Me] !== void 0)
          return Xe[Me];
      return null;
    }, un = e.UnboundTypeError = ie("UnboundTypeError"), V.push({ T: function() {
      Fn();
    } });
    var yn = { p: function(Me) {
      return xn(Me + 16) + 16;
    }, o: function(Me, _, ye) {
      throw new Te(Me).V(_, ye), Me;
    }, z: function(Me, _, ye, He, ze) {
      var tt = se(ye);
      _ = W(_), qe(Me, { name: _, fromWireType: function(At) {
        return !!At;
      }, toWireType: function(At, pt) {
        return pt ? He : ze;
      }, argPackAdvance: 8, readValueFromPointer: function(At) {
        if (ye === 1)
          var pt = R;
        else if (ye === 2)
          pt = O;
        else if (ye === 4)
          pt = N;
        else
          throw new TypeError("Unknown boolean type size: " + _);
        return this.fromWireType(pt[At >> tt]);
      }, M: null });
    }, y: function(Me, _) {
      _ = W(_), qe(Me, { name: _, fromWireType: function(ye) {
        var He = Xe[ye].value;
        return rt(ye), He;
      }, toWireType: function(ye, He) {
        return it(He);
      }, argPackAdvance: 8, readValueFromPointer: ht, M: null });
    }, h: function(Me, _, ye) {
      ye = se(ye), _ = W(_), qe(Me, { name: _, fromWireType: function(He) {
        return He;
      }, toWireType: function(He, ze) {
        if (typeof ze != "number" && typeof ze != "boolean")
          throw new TypeError('Cannot convert "' + mt(ze) + '" to ' + this.name);
        return ze;
      }, argPackAdvance: 8, readValueFromPointer: _t(_, ye), M: null });
    }, e: function(Me, _, ye, He, ze, tt) {
      var At = Ht(_, ye);
      Me = W(Me), ze = It(He, ze), lt(Me, function() {
        We(
          "Cannot call " + Me + " due to unbound types",
          At
        );
      }, _ - 1), Pe(At, function(pt) {
        var Bt = Me, Rt = Me;
        pt = [pt[0], null].concat(pt.slice(1));
        var Lt = ze, rn = pt.length;
        2 > rn && de("argTypes array size mismatch! Must at least get return value and 'this' types!");
        for (var Wr = pt[1] !== null && !1, pr = !1, Vt = 1; Vt < pt.length; ++Vt)
          if (pt[Vt] !== null && pt[Vt].M === void 0) {
            pr = !0;
            break;
          }
        var Sn = pt[0].name !== "void", kn = "", vr = "";
        for (Vt = 0; Vt < rn - 2; ++Vt)
          kn += (Vt !== 0 ? ", " : "") + "arg" + Vt, vr += (Vt !== 0 ? ", " : "") + "arg" + Vt + "Wired";
        Rt = "return function " + Ee(Rt) + "(" + kn + `) {
if (arguments.length !== ` + (rn - 2) + `) {
throwBindingError('function ` + Rt + " called with ' + arguments.length + ' arguments, expected " + (rn - 2) + ` args!');
}
`, pr && (Rt += `var destructors = [];
`);
        var Tr = pr ? "destructors" : "null";
        for (kn = "throwBindingError invoker fn runDestructors retType classParam".split(" "), Lt = [de, Lt, tt, zt, pt[0], pt[1]], Wr && (Rt += "var thisWired = classParam.toWireType(" + Tr + `, this);
`), Vt = 0; Vt < rn - 2; ++Vt)
          Rt += "var arg" + Vt + "Wired = argType" + Vt + ".toWireType(" + Tr + ", arg" + Vt + "); // " + pt[Vt + 2].name + `
`, kn.push("argType" + Vt), Lt.push(pt[Vt + 2]);
        if (Wr && (vr = "thisWired" + (0 < vr.length ? ", " : "") + vr), Rt += (Sn ? "var rv = " : "") + "invoker(fn" + (0 < vr.length ? ", " : "") + vr + `);
`, pr)
          Rt += `runDestructors(destructors);
`;
        else
          for (Vt = Wr ? 1 : 2; Vt < pt.length; ++Vt)
            rn = Vt === 1 ? "thisWired" : "arg" + (Vt - 2) + "Wired", pt[Vt].M !== null && (Rt += rn + "_dtor(" + rn + "); // " + pt[Vt].name + `
`, kn.push(rn + "_dtor"), Lt.push(pt[Vt].M));
        if (Sn && (Rt += `var ret = retType.fromWireType(rv);
return ret;
`), kn.push(Rt + `}
`), pt = Ct(kn).apply(null, Lt), Vt = _ - 1, !e.hasOwnProperty(Bt))
          throw new we("Replacing nonexistant public symbol");
        return e[Bt].L !== void 0 && Vt !== void 0 ? e[Bt].L[Vt] = pt : (e[Bt] = pt, e[Bt].S = Vt), [];
      });
    }, c: function(Me, _, ye, He, ze) {
      function tt(Rt) {
        return Rt;
      }
      _ = W(_), ze === -1 && (ze = 4294967295);
      var At = se(ye);
      if (He === 0) {
        var pt = 32 - 8 * ye;
        tt = function(Rt) {
          return Rt << pt >>> pt;
        };
      }
      var Bt = _.indexOf("unsigned") != -1;
      qe(Me, { name: _, fromWireType: tt, toWireType: function(Rt, Lt) {
        if (typeof Lt != "number" && typeof Lt != "boolean")
          throw new TypeError('Cannot convert "' + mt(Lt) + '" to ' + this.name);
        if (Lt < He || Lt > ze)
          throw new TypeError('Passing a number "' + mt(Lt) + '" from JS side to C/C++ side to an argument of type "' + _ + '", which is outside the valid range [' + He + ", " + ze + "]!");
        return Bt ? Lt >>> 0 : Lt | 0;
      }, argPackAdvance: 8, readValueFromPointer: En(
        _,
        At,
        He !== 0
      ), M: null });
    }, b: function(Me, _, ye) {
      function He(tt) {
        tt >>= 2;
        var At = k;
        return new ze(w, At[tt + 1], At[tt]);
      }
      var ze = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array][_];
      ye = W(ye), qe(Me, { name: ye, fromWireType: He, argPackAdvance: 8, readValueFromPointer: He }, { U: !0 });
    }, i: function(Me, _) {
      _ = W(_);
      var ye = _ === "std::string";
      qe(Me, { name: _, fromWireType: function(He) {
        var ze = k[He >> 2];
        if (ye)
          for (var tt = He + 4, At = 0; At <= ze; ++At) {
            var pt = He + 4 + At;
            if (At == ze || M[pt] == 0) {
              if (tt = tt ? h(M, tt, pt - tt) : "", Bt === void 0)
                var Bt = tt;
              else
                Bt += String.fromCharCode(0), Bt += tt;
              tt = pt + 1;
            }
          }
        else {
          for (Bt = Array(ze), At = 0; At < ze; ++At)
            Bt[At] = String.fromCharCode(M[He + 4 + At]);
          Bt = Bt.join("");
        }
        return vn(He), Bt;
      }, toWireType: function(He, ze) {
        ze instanceof ArrayBuffer && (ze = new Uint8Array(ze));
        var tt = typeof ze == "string";
        tt || ze instanceof Uint8Array || ze instanceof Uint8ClampedArray || ze instanceof Int8Array || de("Cannot pass non-string to std::string");
        var At = (ye && tt ? function() {
          for (var Rt = 0, Lt = 0; Lt < ze.length; ++Lt) {
            var rn = ze.charCodeAt(Lt);
            55296 <= rn && 57343 >= rn && (rn = 65536 + ((rn & 1023) << 10) | ze.charCodeAt(++Lt) & 1023), 127 >= rn ? ++Rt : Rt = 2047 >= rn ? Rt + 2 : 65535 >= rn ? Rt + 3 : Rt + 4;
          }
          return Rt;
        } : function() {
          return ze.length;
        })(), pt = xn(4 + At + 1);
        if (k[pt >> 2] = At, ye && tt)
          d(ze, pt + 4, At + 1);
        else if (tt)
          for (tt = 0; tt < At; ++tt) {
            var Bt = ze.charCodeAt(tt);
            255 < Bt && (vn(pt), de("String has UTF-16 code units that do not fit in 8 bits")), M[pt + 4 + tt] = Bt;
          }
        else
          for (tt = 0; tt < At; ++tt)
            M[pt + 4 + tt] = ze[tt];
        return He !== null && He.push(vn, pt), pt;
      }, argPackAdvance: 8, readValueFromPointer: ht, M: function(He) {
        vn(He);
      } });
    }, d: function(Me, _, ye) {
      if (ye = W(ye), _ === 2)
        var He = m, ze = C, tt = y, At = function() {
          return L;
        }, pt = 1;
      else
        _ === 4 && (He = v, ze = b, tt = Q, At = function() {
          return k;
        }, pt = 2);
      qe(Me, { name: ye, fromWireType: function(Bt) {
        for (var Rt = k[Bt >> 2], Lt = At(), rn, Wr = Bt + 4, pr = 0; pr <= Rt; ++pr) {
          var Vt = Bt + 4 + pr * _;
          (pr == Rt || Lt[Vt >> pt] == 0) && (Wr = He(Wr, Vt - Wr), rn === void 0 ? rn = Wr : (rn += String.fromCharCode(0), rn += Wr), Wr = Vt + _);
        }
        return vn(Bt), rn;
      }, toWireType: function(Bt, Rt) {
        typeof Rt != "string" && de("Cannot pass non-string to C++ string type " + ye);
        var Lt = tt(Rt), rn = xn(4 + Lt + _);
        return k[rn >> 2] = Lt >> pt, ze(Rt, rn + 4, Lt + _), Bt !== null && Bt.push(vn, rn), rn;
      }, argPackAdvance: 8, readValueFromPointer: ht, M: function(Bt) {
        vn(Bt);
      } });
    }, A: function(Me, _) {
      _ = W(_), qe(Me, {
        aa: !0,
        name: _,
        argPackAdvance: 0,
        fromWireType: function() {
        },
        toWireType: function() {
        }
      });
    }, n: rt, x: function(Me) {
      4 < Me && (Xe[Me].P += 1);
    }, C: function(Me, _) {
      var ye = _e[Me];
      return ye === void 0 && de("_emval_take_value has unknown type " + hn(Me)), Me = ye.readValueFromPointer(_), it(Me);
    }, t: function() {
      Be();
    }, r: function(Me, _, ye) {
      M.copyWithin(Me, _, _ + ye);
    }, s: function(Me) {
      Me >>>= 0;
      var _ = M.length;
      if (2147483648 < Me)
        return !1;
      for (var ye = 1; 4 >= ye; ye *= 2) {
        var He = _ * (1 + 0.2 / ye);
        He = Math.min(He, Me + 100663296), He = Math.max(16777216, Me, He), 0 < He % 65536 && (He += 65536 - He % 65536);
        e: {
          try {
            c.grow(Math.min(2147483648, He) - w.byteLength + 65535 >>> 16), X(c.buffer);
            var ze = 1;
            break e;
          } catch {
          }
          ze = void 0;
        }
        if (ze)
          return !0;
      }
      return !1;
    }, u: function(Me, _) {
      var ye = 0;
      return Pt().forEach(function(He, ze) {
        var tt = _ + ye;
        for (ze = N[Me + 4 * ze >> 2] = tt, tt = 0; tt < He.length; ++tt)
          R[ze++ >> 0] = He.charCodeAt(tt);
        R[ze >> 0] = 0, ye += He.length + 1;
      }), 0;
    }, v: function(Me, _) {
      var ye = Pt();
      N[Me >> 2] = ye.length;
      var He = 0;
      return ye.forEach(function(ze) {
        He += ze.length + 1;
      }), N[_ >> 2] = He, 0;
    }, w: function() {
      return 0;
    }, q: function() {
    }, g: function(Me, _, ye, He) {
      for (var ze = 0, tt = 0; tt < ye; tt++) {
        for (var At = N[_ + 8 * tt >> 2], pt = N[_ + (8 * tt + 4) >> 2], Bt = 0; Bt < pt; Bt++) {
          var Rt = M[At + Bt], Lt = yr[Me];
          Rt === 0 || Rt === 10 ? ((Me === 1 ? a : A)(h(Lt, 0)), Lt.length = 0) : Lt.push(Rt);
        }
        ze += pt;
      }
      return N[He >> 2] = ze, 0;
    }, a: c, l: function() {
      return 0;
    }, k: function() {
      return 0;
    }, j: function() {
    }, B: function() {
      return 6;
    }, m: function() {
    }, f: function() {
    } };
    (function() {
      function Me(ze) {
        e.asm = ze.exports, z = e.asm.D, pe--, e.monitorRunDependencies && e.monitorRunDependencies(pe), pe == 0 && Ce && (ze = Ce, Ce = null, ze());
      }
      function _(ze) {
        Me(ze.instance);
      }
      function ye(ze) {
        return Promise.resolve().then(De).then(function(tt) {
          return WebAssembly.instantiate(tt, He);
        }).then(ze, function(tt) {
          A("failed to asynchronously prepare wasm: " + tt), Be(tt);
        });
      }
      var He = { a: yn };
      if (pe++, e.monitorRunDependencies && e.monitorRunDependencies(pe), e.instantiateWasm)
        try {
          return e.instantiateWasm(
            He,
            Me
          );
        } catch (ze) {
          return A("Module.instantiateWasm callback failed with error: " + ze), !1;
        }
      return function() {
        return l || typeof WebAssembly.instantiateStreaming != "function" || Qe() || Ie("file://") || typeof fetch != "function" ? ye(_) : fetch(xe, { credentials: "same-origin" }).then(function(ze) {
          return WebAssembly.instantiateStreaming(ze, He).then(_, function(tt) {
            return A("wasm streaming compile failed: " + tt), A("falling back to ArrayBuffer instantiation"), ye(_);
          });
        });
      }().catch(r), {};
    })();
    var Fn = e.___wasm_call_ctors = function() {
      return (Fn = e.___wasm_call_ctors = e.asm.E).apply(null, arguments);
    }, xn = e._malloc = function() {
      return (xn = e._malloc = e.asm.F).apply(null, arguments);
    }, vn = e._free = function() {
      return (vn = e._free = e.asm.G).apply(null, arguments);
    }, nt = e.___getTypeName = function() {
      return (nt = e.___getTypeName = e.asm.H).apply(null, arguments);
    };
    e.___embind_register_native_and_builtin_types = function() {
      return (e.___embind_register_native_and_builtin_types = e.asm.I).apply(null, arguments);
    }, e.dynCall_jiiiii = function() {
      return (e.dynCall_jiiiii = e.asm.J).apply(null, arguments);
    }, e.dynCall_jiji = function() {
      return (e.dynCall_jiji = e.asm.K).apply(null, arguments);
    };
    var st;
    Ce = function Me() {
      st || xt(), st || (Ce = Me);
    };
    function xt() {
      function Me() {
        if (!st && (st = !0, e.calledRun = !0, !u)) {
          if (Ue(V), Ue(Z), n(e), e.onRuntimeInitialized && e.onRuntimeInitialized(), e.postRun)
            for (typeof e.postRun == "function" && (e.postRun = [e.postRun]); e.postRun.length; ) {
              var _ = e.postRun.shift();
              ce.unshift(_);
            }
          Ue(ce);
        }
      }
      if (!(0 < pe)) {
        if (e.preRun)
          for (typeof e.preRun == "function" && (e.preRun = [e.preRun]); e.preRun.length; )
            ee();
        Ue(Y), 0 < pe || (e.setStatus ? (e.setStatus("Running..."), setTimeout(function() {
          setTimeout(function() {
            e.setStatus("");
          }, 1), Me();
        }, 1)) : Me());
      }
    }
    if (e.run = xt, e.preInit)
      for (typeof e.preInit == "function" && (e.preInit = [e.preInit]); 0 < e.preInit.length; )
        e.preInit.pop()();
    return xt(), t.ready;
  };
}(), CDe = "AGFzbQEAAAABwAImYAF/AX9gA39/fwF/YAV/f39/fwF/YAJ/fwF/YAJ/fwBgAX8AYAN/f38AYAR/f39/AX9gBH9/f38AYAAAYAZ/f39/f38Bf2AFf39/f38AYAZ/f39/f38AYAd/f39/f39/AX9gBH9/f38BfmAFf39/f38BfmAIf39/f39/f38Bf2AJf39/f39/f39/AX9gAn5/AX9gC39/f39/f39/f39/AX9gA39+fwF+YAN/f34AYAN/f34Bf2ADfn9/AX9gAn5+AX5gCH9/f39/f39/AGAJf39/f39/f39/AGAFf35/f38AYAABf2ANf39/f39/f39/f39/fwF/YA9/f39/f39/f39/f39/f38Bf2AFf39/fn8Bf2AGf3x/f39/AX9gAX8BfmACf38BfmAHf35/f39/fwF+YAF+AX5gBH5/f34BfgK0AR0BYQFiAAYBYQFjAAsBYQFkAAYBYQFlAAwBYQFmAAUBYQFnAAcBYQFoAAYBYQFpAAQBYQFqAAMBYQFrAAABYQFsAAABYQFtAAMBYQFuAAUBYQFvAAYBYQFwAAABYQFxAAIBYQFyAAEBYQFzAAABYQF0AAkBYQF1AAMBYQF2AAMBYQF3AAABYQF4AAUBYQF5AAQBYQF6AAsBYQFBAAQBYQFCAAcBYQFDAAMBYQFhAgGAAoCAAgOtBKsEBAEBAwIACAAAAAQHAQEBAAIBAAQDAQMBBAEFAwUFAAYAAwAIAgIDAQgBAwYBCwEBAAQYBAEEBwoGAwMLBwgBBggDCwUDAwMGCAEGBAYABwIGAAABAAIEBAYEBQMDAAsABgwDAAANBgIYAwkAAQwGBggAAgAAAAUQHQAEAQMbBwcHBwMDBh4TBAgBAgECCgcGCgYEAAQAARARAwAIAAYDBgAFBQUFBQUJCwUGAQAFBQICAgcHAwQEAAcSARIXJQQGAwMDAAUEAQABBQUDAAMGCgAFBQMBHwUDAwUFAREDBwoEAAUBAwcKCiEGBQEABgYGBQUIAxMNAAADAAkBBwcHBwcHBwcAAQgGBwMRAgICAgYCCAoCAgcCCAAFBAUFAAMAAAIKBBQACQwMCwMLCAgICwwAAQEFAAUABQkDAAMSEhcGAQAUAAAJCQkJBgAJCQkJCQkJCQkJCQkJDQ0ABgcBAQcHAgEBAgEEAwoABAcFBRwKCgoFAgoCAgMaGQUEAgICAgkFCwICAQoQAggMIiMCBgYBDAICAgICAgICAgMCAg0MAgoCAgIECgICAgQTAQEHAQcBCAUGCgUFBAYkBwUAAAgWFgYRAA0CAgsDEAUBAgYHCwIBAgIABRUVAwUABgIBCQEGAgIHBwcFAAoEAgIHAQAAAAAABAMGCAgIAAAFBgQAAAEDAwEDBQUABAEDAQQABAMNDQQECgoFAg4PDg8ODg4ICAgBCAEBAQEHBAUBcAFWVgYJAX8BQaD9wQILByYIAUQBAAFFAJYCAUYATAFHADgBSADhAgFJAMMBAUoAvgIBSwC9AgmlAQEAQQELVX9f5wK6ArYCf1+rAqECuAPVA6MDrgOPA50DjQG0Ap8CngKdApwCmwK3BLkEvgTBBKcEpgSiBKAEnwTBA8YDtwO5A7oDvQOlA6EDoAO/A8QDsgOxA7ADrwOaA5kDwAPFA7MDtAO1A7YDnAObA9cC3QLfAn9f0wLSAtEC0AJ/X/UB9QHOAswCywLKAl/PAl/DAsUCyQJfxALHAsgCwQLAAgqyrRGrBBYAIAAgASkAADcAACAAIAEpAAg3AAgLrgEBA38CQCACQX1qIgQgAE0EQCAAIQMMAQsgASgAACAAKAAAcyIDRQRAIAAhAwNAIAFBBGohASADQQRqIgMgBE8NAiABKAAAIAMoAABzIgVFDQALIAUQJSADaiAAaw8LIAMQJQ8LAkAgAyACQX9qTw0AIAEvAAAgAy8AAEcNACABQQJqIQEgA0ECaiEDCyADIAJJBH8gA0EBaiADIAEtAAAgAy0AAEYbBSADCyAAawtoAAJAAkACQAJAAkAgAkF7ag4EAQIDBAALIAAgARDeAQ8LIAAgARDdAQ8LIAAgARDcAQ8LIAApAABCgMaV/cub741PfkHAACABa62Ipw8LIAApAABC48iVvcub741PfkHAACABa62IpwsUACAAKAAAIgBBCHQgACABQQNGGws4AQF/IAMgASAAIAEgACADIAFraiIFIAIgBSACSRsQHSIFakYEfyAAIAVqIAQgAhAdIAVqBSAFCwsIACAAQYh/SwuTAQECfyABIANNBEAgACABEBwgAEEQaiABQRBqEBwgACADIAFrIgRqIQUgBEEhTgRAIABBIGohAANAIAAgAUEgaiIEEBwgAEEQaiABQTBqEBwgBCEBIABBIGoiACAFSQ0ACwsgAyEBIAUhAAsgASACSQRAA0AgACABLQAAOgAAIABBAWohACABQQFqIgEgAkcNAAsLC5gBAQR/QQMhAQJAIAAoAgQiAkEgTQRAIAACfyAAKAIIIgEgACgCEE8EQCAAIAEgAkEDdmsiAzYCCEEAIQEgAkEHcQwBCyABIAAoAgwiA0YNAiAAIAEgASADayACQQN2IgQgASAEayADSSIBGyIEayIDNgIIIAIgBEEDdGsLNgIEIAAgAygAADYCAAsgAQ8LQQFBAiACQSBJGwsIACAAZ0EfcwsIACAAaEEDdgsPACAAIAAoAgQgAWo2AgQLHAAgACACQQEgA3QiA2sgACACIABrIANLGyABGwvzAgICfwF+AkAgAkUNACAAIAJqIgNBf2ogAToAACAAIAE6AAAgAkEDSQ0AIANBfmogAToAACAAIAE6AAEgA0F9aiABOgAAIAAgAToAAiACQQdJDQAgA0F8aiABOgAAIAAgAToAAyACQQlJDQAgAEEAIABrQQNxIgRqIgMgAUH/AXFBgYKECGwiATYCACADIAIgBGtBfHEiBGoiAkF8aiABNgIAIARBCUkNACADIAE2AgggAyABNgIEIAJBeGogATYCACACQXRqIAE2AgAgBEEZSQ0AIAMgATYCGCADIAE2AhQgAyABNgIQIAMgATYCDCACQXBqIAE2AgAgAkFsaiABNgIAIAJBaGogATYCACACQWRqIAE2AgAgBCADQQRxQRhyIgRrIgJBIEkNACABrSIFQiCGIAWEIQUgAyAEaiEBA0AgASAFNwMYIAEgBTcDECABIAU3AwggASAFNwMAIAFBIGohASACQWBqIgJBH0sNAAsLIAALDQAgACABdEEAIAJrdguCBAEDfyACQYAETwRAIAAgASACEBAaIAAPCyAAIAJqIQMCQCAAIAFzQQNxRQRAAkAgAkEBSARAIAAhAgwBCyAAQQNxRQRAIAAhAgwBCyAAIQIDQCACIAEtAAA6AAAgAUEBaiEBIAJBAWoiAiADTw0BIAJBA3ENAAsLAkAgA0F8cSIEQcAASQ0AIAIgBEFAaiIFSw0AA0AgAiABKAIANgIAIAIgASgCBDYCBCACIAEoAgg2AgggAiABKAIMNgIMIAIgASgCEDYCECACIAEoAhQ2AhQgAiABKAIYNgIYIAIgASgCHDYCHCACIAEoAiA2AiAgAiABKAIkNgIkIAIgASgCKDYCKCACIAEoAiw2AiwgAiABKAIwNgIwIAIgASgCNDYCNCACIAEoAjg2AjggAiABKAI8NgI8IAFBQGshASACQUBrIgIgBU0NAAsLIAIgBE8NAQNAIAIgASgCADYCACABQQRqIQEgAkEEaiICIARJDQALDAELIANBBEkEQCAAIQIMAQsgA0F8aiIEIABJBEAgACECDAELIAAhAgNAIAIgAS0AADoAACACIAEtAAE6AAEgAiABLQACOgACIAIgAS0AAzoAAyABQQRqIQEgAkEEaiICIARNDQALCyACIANJBEADQCACIAEtAAA6AAAgAUEBaiEBIAJBAWoiAiADRw0ACwsgAAsbAQF/IABBAWoiABAkIgFBCHQgAEEIdCABdmoLhQEBBn8gACgCICEGIAAoAhgiBSADIAAoAgQiCGsiB0kEQEF/IAF0QX9zIQEgACgCKCEJA0AgCSABIAVxQQJ0aiAGIAUgCGogAiAEEFpBAnRqIgooAgA2AgAgCiAFNgIAIAVBAWoiBSAHSQ0ACwsgACAHNgIYIAYgAyACIAQQWkECdGooAgALXAEBfyABKAI4QQFGBEAgAgRAIAAQKw8LIAAQLg8LIAAQgAFBAnQiA0GwpwFqKAIAQQh0IAEoAixqIQAgASgCBCADaigCACEBIAIEQCAAIAEQK2sPCyAAIAEQLmsLDAAgAEEBahAkQQh0CwkAIAAgATsAAAsWACAAQbHz3fF5bEETQRQgAUEDRht2C5sBAQV/IwBBEGsiBSQAIAUgAjYCDCACQRh2IQYgAUEEaiEHIAAhBANAIAQiAyAHTwRAIAIgA0F8aiIEKAAARg0BCwsCQCADIAFNDQAgA0F/aiIELQAAIAZHDQAgBUEMakEDciECA0AgBCIDIAFNBEAgASEDDAILIANBf2oiBC0AACACQX9qIgItAABGDQALCyAFQRBqJAAgACADawsNACABQX9zIABqQQJLC3gBA38CQAJAIAFBfWoiBCAAIgNNDQADQCACIAMoAABzIgVFBEAgA0EEaiIDIARJDQEMAgsLIAUQJSADaiEDDAELIAMgAU8NAANAIAMtAAAgAkH/AXFHDQEgAkEIdiECIANBAWoiAyABRw0ACyABIABrDwsgAyAAawsJACAAIAE2AAALFAAgAUUEQEEADwsgACABIAIQqQQLigEBA38gACgCHCIBEJkEAkAgACgCECICIAEoAhQiAyADIAJLGyICRQ0AIAAoAgwgASgCECACECoaIAAgACgCDCACajYCDCABIAEoAhAgAmo2AhAgACAAKAIUIAJqNgIUIAAgACgCECACazYCECABIAEoAhQgAmsiADYCFCAADQAgASABKAIINgIQCwsRACAAIAEpAAA3AAAgAEEIagvXAgEFfyAABEAgAEF8aiIBKAIAIgQhAyABIQIgAEF4aigCACIFQX9MBEAgASAFaiIAKAIFIgIgACgCCTYCCCAAKAIJIAI2AgQgBCAFQX9zaiEDIABBAWohAgsgASAEaiIAKAIAIgEgACABakF8aigCAEcEQCAAKAIEIgQgACgCCDYCCCAAKAIIIAQ2AgQgASADaiEDCyACIAM2AgAgA0F8cSACakF8aiADQX9zNgIAIAICfyACKAIAQXhqIgBB/wBNBEAgAEEDdkF/agwBCyAAZyEBIABBHSABa3ZBBHMgAUECdGtB7gBqIABB/x9NDQAaIABBHiABa3ZBAnMgAUEBdGtBxwBqIgBBPyAAQT9JGwsiA0EEdCIAQYDtAWo2AgQgAiAAQYjtAWoiACgCADYCCCAAIAI2AgAgAigCCCACNgIEQYj1AUGI9QEpAwBCASADrYaENwMACwtUAQJ/IAAoAgQhASAAKAIMIAAoAgAQ/AEgACAAKAIEQQdxNgIEIAAgACgCACABQXhxdjYCACAAIAAoAhAiAiAAKAIMIAFBA3ZqIgAgACACSxs2AgwLEQAgACgAAEGx893xeWxBEXYLIgADQCAAIAEpAAA3AAAgAUEIaiEBIABBCGoiACACSQ0ACwsdACAAQYABTwRAIAAQJEEkag8LIABBsKYBai0AAAsKACABIABBA3R3Cw0AIAAoAgggACgCDGoLpQEBAX8gAkEDTwRAIAAgASgCBDYCCCABKAIAIQEgACACQX5qNgIAIAAgATYCBA8LAkACfwJAAkAgAiADaiICDgQDAQEAAQsgASgCACIDQX9qDAELIAEoAgAhAyABIAJBAnRqKAIACyEEIAFBBEEIIAJBAUsbaigCACEBIAAgAzYCBCAAIAE2AgggACAENgIADwsgACABKQIANwIAIAAgASgCCDYCCAtVAQJ/IAQgARDQASEGIAMoAgAiBSAEIABrIgRJBEADQCACIAAgBWogARDQAUECdGogBTYCACAFQQFqIgUgBEkNAAsLIAMgBDYCACACIAZBAnRqKAIAC7QEARV/IwBBEGsiDiQAIAAoAiAgASAAKAJ8IAMQHkECdGoiBSgCACEDIAAoAnghBiAAKAIIIQ8gACgCDCEMIAAoAighEiAAKAKAASEIIAAoAhAhEyAFIAEgACgCBCINayIJNgIAIBIgCUF/IAZBf2p0QX9zIhRxQQN0aiEHIAlBCWohCgJ/IAMgE0kEQCAHQgA3AgBBAAwBC0EAIAkgFGsiACAAIAlLGyEVIAdBBGohBiAMIA1qIRYgDCAPaiEXQX8gCHRBf3MhEUEIIQtBACEIA0ACfyAEQQAgECAIIBAgCEkbIgAgA2ogDEkbRQRAIAAgAWogAyANaiAAaiACEB0gAGoiACADaiEFIA0MAQsgDyANIAAgAWogAyAPaiAAaiACIBcgFhAgIABqIgAgA2oiBSAMSRsLIRggBSAKIAAgCiADa0sbIAogACALSyIFGyEKIAAgCyAFGyELAkAgACABaiIZIAJGDQAgEiADIBRxQQN0aiEFAkACQCADIBhqIABqLQAAIBktAABJBEAgByADNgIAIAMgFUsNASAOQQxqIQcMAwsgBiADNgIAIAMgFUsEQCAAIQggBSEGDAILIA5BDGohBgwCCyAAIRAgBUEEaiIHIQULIBFFDQAgEUF/aiERIAUoAgAiAyATTw0BCwsgBkEANgIAIAdBADYCACALQYB9aiIAQcABIABBwAFJG0EAIAtBgANLGwshAyAOQRBqJAAgAyAKIAlrQXhqIgAgAyAASxsLHAEBfyAAKAIAIAAoAgQgARApIQIgACABECYgAgssACACRQRAIAAoAgQgASgCBEYPCyAAIAFGBEBBAQ8LIAAQkAEgARCQARBdRQukBAEDf0EBIQYCQCABRSACQQRqAn8gACgChAFBAU4EQCAAKAIAIgQoAixBAkYEQCAEIAAQmAQ2AiwLIAAgAEGYFmoQrgEgACAAQaQWahCuASAAEJcEQQFqIQYgACgCqC1BCmpBA3YiBSAAKAKsLUEKakEDdiIEIAQgBUsbDAELIAJBBWoiBAsiBUtyRQRAIAAgASACIAMQjgIMAQsgACgCvC0hAQJAIAQgBUcEQCAAKAKIAUEERw0BCyAAIAAvAbgtIANBAmpB//8DcSICIAF0ciIEOwG4LSAAAn8gAUEOTgRAIAAgACgCFCIBQQFqNgIUIAEgACgCCGogBDoAACAAIAAoAhQiAUEBajYCFCABIAAoAghqIABBuS1qLQAAOgAAIAAgAkEQIAAoArwtIgFrdjsBuC0gAUFzagwBCyABQQNqCzYCvC0gAEGA2wBBgNkAEIsCDAELIAAgAC8BuC0gA0EEakH//wNxIgIgAXRyIgQ7AbgtIAACfyABQQ5OBEAgACAAKAIUIgFBAWo2AhQgASAAKAIIaiAEOgAAIAAgACgCFCIBQQFqNgIUIAEgACgCCGogAEG5LWotAAA6AAAgACACQRAgACgCvC0iAWt2OwG4LSABQXNqDAELIAFBA2oLNgK8LSAAIABBnBZqKAIAQQFqIABBqBZqKAIAQQFqIAYQlgQgACAAQZQBaiAAQYgTahCLAgsgABCNAiADBEAgABCMAgsL9QEBAX8gAkUEQCAAQgA3AgAgAEEANgIQIABCADcCCEG4fw8LIAAgATYCDCAAIAFBBGo2AhAgAkEETwRAIAAgASACaiIBQXxqIgM2AgggACADKAAANgIAIAFBf2otAAAiAUUEQCAAQQA2AgRBfw8LIABBCCABECRrNgIEIAIPCyAAIAE2AgggACABLQAAIgM2AgACQAJAAkAgAkF+ag4CAQACCyAAIAEtAAJBEHQgA3IiAzYCAAsgACABLQABQQh0IANqNgIACyABIAJqQX9qLQAAIgFFBEAgAEEANgIEQWwPCyAAQSggARAkIAJBA3RqazYCBCACCy0BAX8gAUECdEGwwwFqKAIAIAAoAgBBICABIAAoAgRqa3ZxIQIgACABECYgAgsxAQF/IAAgACgCBCIDIAJqNgIEIAAgACgCACACQQJ0QbDDAWooAgAgAXEgA3RyNgIACyEAIAJBAkYEQCABIABBAnRqKAIADwsgASAAQQF0ai8BAAtIAAJAAkACQAJAIANBf2oOAwABAgMLIAIgAUECdGogADYCAA8LIAIgAUECdGogACAEazYCAA8LIAIgAUEBdGogACAEazsBAAsL6QIBAX8CQCAAIAFGDQAgASAAayACa0EAIAJBAXRrTQRAIAAgASACECoPCyAAIAFzQQNxIQMCQAJAIAAgAUkEQCADBEAgACEDDAMLIABBA3FFBEAgACEDDAILIAAhAwNAIAJFDQQgAyABLQAAOgAAIAFBAWohASACQX9qIQIgA0EBaiIDQQNxDQALDAELAkAgAw0AIAAgAmpBA3EEQANAIAJFDQUgACACQX9qIgJqIgMgASACai0AADoAACADQQNxDQALCyACQQNNDQADQCAAIAJBfGoiAmogASACaigCADYCACACQQNLDQALCyACRQ0CA0AgACACQX9qIgJqIAEgAmotAAA6AAAgAg0ACwwCCyACQQNNDQADQCADIAEoAgA2AgAgAUEEaiEBIANBBGohAyACQXxqIgJBA0sNAAsLIAJFDQADQCADIAEtAAA6AAAgA0EBaiEDIAFBAWohASACQX9qIgINAAsLIAALDQAgASACRiAAQSBGcQsJAEEIIAAQtQELCAAgACABEDQLIQAgAULP1tO+0ser2UJ+IAB8Qh+JQoeVr6+Ytt6bnn9+CyYBAX8jAEEQayICJAAgAiABNgIMQdjpASAAIAEQuQEgAkEQaiQAC2AAAkACQAJAAkAgAkF4ag4ZAgMDAwMDAwMBAwMDAwMDAwMDAwMDAwMDAAMLIAAgARCUAg8LIAAgARBWDwsgACABEDcPCyACQQdNBEAgACABIAIQwwQPCyAAIAEgAhDCBAt/AQF/IABBQGsoAgAQcARAIAAoAhghAiAAAn8gAQRAIAIQKwwBCyACEC4LNgIoCyAAKAIcIQIgAAJ/IAEEQCACECshASAAKAIgECshAiAAKAIkECsMAQsgAhAuIQEgACgCIBAuIQIgACgCJBAuCzYCNCAAIAI2AjAgACABNgIsC4MBAQN/IAFFBEBBAA8LIAJBQGsoAgAQcEUEQCABQQt0DwsgAigCOEEBRgRAIAFBgAxsDwsgAigCKCABbCEEIAIoAgAhBkEAIQIDQCAGIAAgAmotAABBAnRqKAIAIQUgBAJ/IAMEQCAFECsMAQsgBRAuC2shBCACQQFqIgIgAUcNAAsgBAuwBgEXfyMAQRBrIhQkAEEBIAAoAoABdCEKIAAoAighDgJAIAAoAiAgASAAKAJ8IAQQWkECdGoiDCgCACIJQQAgASAAKAIEIg9rIghBfyAAKAJ4QX9qdEF/cyIQayIGIAYgCEsbIhUgACgCECAAKAIUIAggACgCdBAnIhYgFSAWSxsiDU0NACAKIQcCQANAIA4gCSIGIBBxQQN0aiIJKAIEIhdBAUcgB0ECSXJFBEAgCSALNgIEIAdBf2ohByAGIQsgCSgCACIJIA1LDQEMAgsLIBdBAUYEQCAJQgA3AgALIAsiBkUNAQsgDkEEaiEJA0AgCSAGIBBxQQN0aigCACELIAAgBiACIAcgDSAFELwDIAdBAWohByALIgYNAAsLIAAoAgghGCAAKAIMIREgDCgCACEHIAwgCDYCACAKQX9qIQogCEEJaiESIA4gCCAQcUEDdGoiE0EEaiEMAkAgByAWTQRAIAohBkEAIQgMAQsgDyARaiEZIBEgGGohGiAIQQJqIRsgCEEBaiEcQQAhCEEAIQtBACENA0ACfyAFQQFGQQAgDSALIA0gC0kbIgYgB2ogEUkbRQRAIAEgBmogByAPaiAGaiACEB0gBmohBiAPDAELIBggDyABIAZqIAcgGGogBmogAiAaIBkQICAGaiIGIAdqIBFJGwshFwJAIAYgCE0NACAGIAhrQQJ0IBwgB2sQJCADKAIAQQFqECRrSgRAIAMgGyAHazYCACAGIQgLIAYgB2ogEiAGIBIgB2tLGyESIAEgBmogAkcNAEEAIAogBUECRhshBgwCCyAOIAcgEHFBA3RqIQkCQAJAIAcgF2ogBmotAAAgASAGai0AAEkEQCATIAc2AgAgByAVSw0BIBRBDGohEyAKIQYMBAsgDCAHNgIAIAcgFUsEQCAGIQsgCSEMDAILIBRBDGohDCAKIQYMAwsgBiENIAlBBGoiEyEJCyAKQX9qIgYgCk8NASAGIQogCSgCACIHIBZLDQALCyAMQQA2AgAgE0EANgIAIAZFIAVBAkdyRQRAIAAgASACIAMgCCAGIAQQuwMhCAsgACASQXhqNgIYIBRBEGokACAIC44BAQh/IAAoAhgiAyABIAAoAgQiBWsiAUkEQEF/IAAoAnhBf2p0QX9zIQYgACgCfCEHIAAoAighCCAAKAIgIQkDQCAJIAMgBWogByACEFpBAnRqIgQoAgAhCiAEIAM2AgAgCCADIAZxQQN0aiIEQQE2AgQgBCAKNgIAIANBAWoiAyABSQ0ACwsgACABNgIYCw4AIAAgARDjAUECEOIBC6cBACAAIAEtAAA6AAAgACABLQABOgABIAAgAS0AAjoAAiAAIAEtAAM6AAMgACABLQAEOgAEIAAgAS0ABToABSAAIAEtAAY6AAYgACABLQAHOgAHIAAgAS0ACDoACCAAIAEtAAk6AAkgACABLQAKOgAKIAAgAS0ACzoACyAAIAEtAAw6AAwgACABLQANOgANIAAgAS0ADjoADiAAIAEtAA86AA8gAEEQagvTAQEDfyAAQUBrKAIAEHAEQCABBEAgACgCACEGA0AgBiACIAVqLQAAQQJ0aiIHIAcoAgBBAmo2AgAgBUEBaiIFIAFHDQALCyAAIAAoAhggAUEBdGo2AhgLIAAoAgQgARCAAUECdGoiASABKAIAQQFqNgIAIAAgACgCHEEBajYCHCAAKAIMIANBAWoQJEECdGoiASABKAIAQQFqNgIAIAAgACgCJEEBajYCJCAAKAIIIARBfWoQPEECdGoiASABKAIAQQFqNgIAIAAgACgCIEEBajYCIAsWACAAIAEgAiADEFIgASACIAMQogNqC7cIAQR/IwBBEGsiBiQAIABBQGsoAgAQcCEFIABBADYCOAJAIAAoAhxFBEAgAkGACE0EQCAAQQE2AjgLIAAoAjwiBCgCgAhBAkYEQEEAIQIgAEEANgI4IAUEQCAAQQA2AhggACgCACIFQQFBCyAEQQAQ+QEiAWt0QQEgARsiATYCACAAIAAoAhggAWo2AhhBASEBA0AgBSABQQJ0akEBQQsgBCABEPkBIgdrdEEBIAcbIgc2AgAgACAAKAIYIAdqNgIYIAFBAWoiAUGAAkcNAAsLIAYgBEG0GWoQcyAAQQA2AhwgACgCBCEBIAYoAgghBQNAIAEgAkECdGpBAUEKIAUgAhCYASIEa3RBASAEGyIENgIAIAAgACgCHCAEajYCHCACQQFqIgJBJEcNAAsgBiAAKAI8QYgOahBzQQAhAiAAQQA2AiAgACgCCCEBIAYoAgghBQNAIAEgAkECdGpBAUEKIAUgAhCYASIEa3RBASAEGyIENgIAIAAgACgCICAEajYCICACQQFqIgJBNUcNAAsgBiAAKAI8QYQIahBzQQAhAiAAQQA2AiQgACgCDCEBIAYoAgghBQNAIAEgAkECdGpBAUEKIAUgAhCYASIEa3RBASAEGyIENgIAIAAgACgCJCAEajYCJCACQQFqIgJBIEcNAAsMAgsgBQRAIAZB/wE2AgAgACgCACAGIAEgAhCqARogACAAKAIAQf8BQQEQbzYCGAsgACgCBCIBQoGAgIAQNwKIASABQoGAgIAQNwKAASABQoGAgIAQNwJ4IAFCgYCAgBA3AnAgAUKBgICAEDcCaCABQoGAgIAQNwJgIAFCgYCAgBA3AlggAUKBgICAEDcCUCABQoGAgIAQNwJIIAFCgYCAgBA3AkAgAUKBgICAEDcCOCABQoGAgIAQNwIwIAFCgYCAgBA3AiggAUKBgICAEDcCICABQoGAgIAQNwIYIAFCgYCAgBA3AhAgAUKBgICAEDcCCCABQoGAgIAQNwIAIABBJDYCHCAAKAIIIQFBACECA0AgASACQQJ0akEBNgIAIAJBAWoiAkE1Rw0ACyAAQTU2AiAgACgCDCIBQoGAgIAQNwJ4IAFCgYCAgBA3AnAgAUKBgICAEDcCaCABQoGAgIAQNwJgIAFCgYCAgBA3AlggAUKBgICAEDcCUCABQoGAgIAQNwJIIAFCgYCAgBA3AkAgAUKBgICAEDcCOCABQoGAgIAQNwIwIAFCgYCAgBA3AiggAUKBgICAEDcCICABQoGAgIAQNwIYIAFCgYCAgBA3AhAgAUKBgICAEDcCCCABQoGAgIAQNwIAIABBIDYCJAwBCyAFBEAgACAAKAIAQf8BQQEQbzYCGAsgACAAKAIEQSNBABBvNgIcIAAgACgCCEE0QQAQbzYCICAAIAAoAgxBH0EAEG82AiQLIAAgAxBRIAZBEGokAAssAAJAAkACQCACQXtqDgIBAgALIAAgARDeAQ8LIAAgARDdAQ8LIAAgARDcAQshACAAIAIgACgCBCICajYCBCAAIAAoAgAgASACdHI2AgALMAACQAJAAkAgA0F+ag4CAAECCyACIAFBAnRqIAA2AgAPCyACIAFBAXRqIAA7AQALC0oBAn8CQCAALQAAIgJFIAIgAS0AACIDR3INAANAIAEtAAEhAyAALQABIgJFDQEgAUEBaiEBIABBAWohACACIANGDQALCyACIANrC20BAX8jAEGAAmsiBSQAIARBgMAEcSACIANMckUEQCAFIAFB/wFxIAIgA2siAkGAAiACQYACSSIBGxAoGiABRQRAA0AgACAFQYACEGYgAkGAfmoiAkH/AUsNAAsLIAAgBSACEGYLIAVBgAJqJAALBgAgABA4CwsAIAAgAUEBEOIBCy8BAn8gACgCBCAAKAIAQQJ0aiICLQACIQMgACACLwEAIAEgAi0AAxBGajYCACADCy8BAn8gACgCBCAAKAIAQQJ0aiICLQACIQMgACACLwEAIAEgAi0AAxBCajYCACADC0YAIAAgARBzIAAgACgCBCAAKAIIIAJBA3RqIgAoAgQiAUGAgAJqIgJBgIB8cSABayACQRB2dSAAKAIAakEBdGovAQA2AgALGgAgAARAIAIEQCADIAAgAhEEAA8LIAAQOAsL0AUBA38gAEH//wNxIQMgAEEQdiEEQQEhACACQQFGBEAgAyABLQAAaiIAQY+AfGogACAAQfD/A0sbIgAgBGoiAUEQdCICQYCAPGogAiABQfD/A0sbIAByDwsgAQR/IAJBEE8EQAJAAkACQCACQa8rSwRAA0BB2wIhBSABIQADQCADIAAtAABqIgMgBGogAyAALQABaiIDaiADIAAtAAJqIgNqIAMgAC0AA2oiA2ogAyAALQAEaiIDaiADIAAtAAVqIgNqIAMgAC0ABmoiA2ogAyAALQAHaiIDaiADIAAtAAhqIgNqIAMgAC0ACWoiA2ogAyAALQAKaiIDaiADIAAtAAtqIgNqIAMgAC0ADGoiA2ogAyAALQANaiIDaiADIAAtAA5qIgNqIAMgAC0AD2oiA2ohBCAAQRBqIQAgBUF/aiIFDQALIARB8f8DcCEEIANB8f8DcCEDIAFBsCtqIQEgAkHQVGoiAkGvK0sNAAsgAkUNAyACQRBJDQELA0AgAyABLQAAaiIAIARqIAAgAS0AAWoiAGogACABLQACaiIAaiAAIAEtAANqIgBqIAAgAS0ABGoiAGogACABLQAFaiIAaiAAIAEtAAZqIgBqIAAgAS0AB2oiAGogACABLQAIaiIAaiAAIAEtAAlqIgBqIAAgAS0ACmoiAGogACABLQALaiIAaiAAIAEtAAxqIgBqIAAgAS0ADWoiAGogACABLQAOaiIAaiAAIAEtAA9qIgNqIQQgAUEQaiEBIAJBcGoiAkEPSw0ACyACRQ0BCwNAIAMgAS0AAGoiAyAEaiEEIAFBAWohASACQX9qIgINAAsLIARB8f8DcCEEIANB8f8DcCEDCyAEQRB0IANyDwsgAgRAA0AgAyABLQAAaiIDIARqIQQgAUEBaiEBIAJBf2oiAg0ACwsgBEHx/wNwQRB0IANBj4B8aiADIANB8P8DSxtyBSAACwsYACAALQAAQSBxRQRAIAEgAiAAEKUBGgsLDAAgACABKQAANwAACx8AIAAgASACKAIEEEY2AgAgARAjGiAAIAJBCGo2AgQLCQBBAUEFIAAbC88MAQ1/AkACQAJAAkACQCAAKAKEAUF7ag4DAQICAAsgACgCBCELIAAoAnQhByAAKAIQIQUgACgCFCEKIAAoAighCCAAKAIMIQ9BASAAKAKAAXQhDEEDIQYCQCAAIAAoAngiDSAAKAJ8IAFBBBAsIgQgBSABIAtrIglBASAHdCIHayAFIAkgBWsgB0sbIAobIgdNDQBBACAJQQEgDXQiBmsiBSAFIAlLGyEKIAZBf2ohDSAJQQJqIQ5BAyEGA0ACQCAEIAtqIgUgBmotAAAgASAGai0AAEcNACABIAUgAhAdIgUgBk0NACADIA4gBGs2AgAgBSIGIAFqIAJHDQAMAgsgBCAKTQ0BIAxBf2oiDEUNASAIIAQgDXFBAnRqKAIAIgQgB0sNAAsLIAAoAnAiACgCBCEFIAAoAgAhByAAKAJ4IQggACgCDCEKIAAoAighDSAAKAIgIQQgASAAKAJ8QQQQWiEAIAxFDQMgBCAAQQJ0aigCACIEIApNDQMgCyAPaiELQQAgByAFayIAQQEgCHQiCGsiDiAOIABLGyEOIAhBf2ohCCABQQRqIRAgCSAPayAAakECaiEJA0ACQCAEIAVqIgAoAAAgASgAAEcNACAQIABBBGogAiAHIAsQIEEEaiIAIAZNDQAgAyAJIARrNgIAIAAhBiAAIAFqIAJGDQQLIAQgDk0NBCAMQX9qIgxFDQQgBiEAIA0gBCAIcUECdGooAgAiBCAKSw0ACwwCCyAAKAIEIQsgACgCdCEHIAAoAhAhBSAAKAIUIQogACgCKCEIIAAoAgwhD0EBIAAoAoABdCEMQQMhBgJAIAAgACgCeCINIAAoAnwgAUEFECwiBCAFIAEgC2siCUEBIAd0IgdrIAUgCSAFayAHSxsgChsiB00NAEEAIAlBASANdCIGayIFIAUgCUsbIQogBkF/aiENIAlBAmohDkEDIQYDQAJAIAQgC2oiBSAGai0AACABIAZqLQAARw0AIAEgBSACEB0iBSAGTQ0AIAMgDiAEazYCACAFIgYgAWogAkcNAAwCCyAEIApNDQEgDEF/aiIMRQ0BIAggBCANcUECdGooAgAiBCAHSw0ACwsgACgCcCIAKAIEIQUgACgCACEHIAAoAnghCCAAKAIMIQogACgCKCENIAAoAiAhBCABIAAoAnxBBRBaIQAgDEUNAiAEIABBAnRqKAIAIgQgCk0NAiALIA9qIQtBACAHIAVrIgBBASAIdCIIayIOIA4gAEsbIQ4gCEF/aiEIIAFBBGohECAJIA9rIABqQQJqIQkDQAJAIAQgBWoiACgAACABKAAARw0AIBAgAEEEaiACIAcgCxAgQQRqIgAgBk0NACADIAkgBGs2AgAgACEGIAAgAWogAkYNAwsgBCAOTQ0DIAxBf2oiDEUNAyAGIQAgDSAEIAhxQQJ0aigCACIEIApLDQALDAELIAAoAgQhCyAAKAJ0IQcgACgCECEFIAAoAhQhCiAAKAIoIQggACgCDCEPQQEgACgCgAF0IQxBAyEGAkAgACAAKAJ4Ig0gACgCfCABQQYQLCIEIAUgASALayIJQQEgB3QiB2sgBSAJIAVrIAdLGyAKGyIHTQ0AQQAgCUEBIA10IgZrIgUgBSAJSxshCiAGQX9qIQ0gCUECaiEOQQMhBgNAAkAgBCALaiIFIAZqLQAAIAEgBmotAABHDQAgASAFIAIQHSIFIAZNDQAgAyAOIARrNgIAIAUiBiABaiACRw0ADAILIAQgCk0NASAMQX9qIgxFDQEgCCAEIA1xQQJ0aigCACIEIAdLDQALCyAAKAJwIgAoAgQhBSAAKAIAIQcgACgCeCEIIAAoAgwhCiAAKAIoIQ0gACgCICEEIAEgACgCfEEGEFohACAMRQ0BIAQgAEECdGooAgAiBCAKTQ0BIAsgD2ohC0EAIAcgBWsiAEEBIAh0IghrIg4gDiAASxshDiAIQX9qIQggAUEEaiEQIAkgD2sgAGpBAmohCQNAAkAgBCAFaiIAKAAAIAEoAABHDQAgECAAQQRqIAIgByALECBBBGoiACAGTQ0AIAMgCSAEazYCACAAIQYgACABaiACRg0CCyAEIA5NDQIgDEF/aiIMRQ0CIAYhACANIAQgCHFBAnRqKAIAIgQgCksNAAsLIAAPCyAGC9wFAQx/IwBBEGsiCiQAAn8gBEEDTQRAIApBADYCDCAKQQxqIAMgBBAqGiAAIAEgAiAKQQxqQQQQayIAQWwgABAhGyAAIAAgBEsbDAELIABBACABKAIAQQF0QQJqECghDkFUIAMoAAAiBUEPcSIAQQpLDQAaIAIgAEEFajYCACADIARqIgJBfGohCyACQXlqIQ8gAkF7aiEQQQQhAiAFQQR2IQQgAEEGaiEMQSAgAHQiCEEBciEJIAEoAgAhDSADIQZBACEAQQAhBQNAAkACQCAARQRAIAUhBwwBCyAFIQAgBEH//wNxQf//A0YEQANAIABBGGohAAJ/IAYgEEkEQCAGQQJqIgYoAAAgAnYMAQsgAkEQaiECIARBEHYLIgRB//8DcUH//wNGDQALCyAEQQNxIgdBA0YEQANAIAJBAmohAiAAQQNqIQAgBEECdiIEQQNxIgdBA0YNAAsLQVAgACAHaiIHIA1LDQMaIAJBAmohAgJAIAcgBU0EQCAFIQcMAQsgDiAFQQF0akEAIAcgBWtBAXQQKBoLIAYgD0tBACAGIAJBA3VqIgAgC0sbRQRAIAAoAAAgAkEHcSICdiEEDAILIARBAnYhBAsgBiEACwJ/IAxBf2ogBCAIQX9qcSIGIAhBAXRBf2oiBSAJayINSQ0AGiAEIAVxIgRBACANIAQgCEgbayEGIAwLIQUgDiAHQQF0aiAGQX9qIgQ7AQAgBEEBIAZrIAZBAUgbIAlqIgkgCEgEQANAIAxBf2ohDCAJIAhBAXUiCEgNAAsLIAIgBWoiAiAAIAtrQQN0aiACQQdxIAAgD0sgACACQQN1aiIAIAtLcSIFGyECIAsgACAFGyIGKAAAIQUgCUECTgRAIARFIQAgBSACdiEEIAdBAWoiBSABKAIAIg1NDQELC0FsIAlBAUcgAkEgSnINABogASAHNgIAIAYgAkEHakEDdWogA2sLIQAgCkEQaiQAIAALTgECfyABKAIIIAJBA3RqIgIoAgAhAyABKAIEIQQgACABKAIAIgAgACACKAIEakEQdiIAEEcgASAEIAMgASgCACAAdWpBAXRqLwEANgIACxsAIABBASAAGyEAAkAgABBMIgANABASAAsgAAsKACAAQVBqQQpJC0cBA38gAkEEaiEFQQAhAgNAIAAgAkECdGoiAyADKAIAIAV2QQFqIgM2AgAgAyAEaiEEIAEgAkchAyACQQFqIQIgAw0ACyAECwcAIABBAkcL9AIBAn8jAEEgayIFJAACf0EAIAFBCEkNABogBUEIaiAAIAEQ+QNBAEEAECENABogA0F8cSEGAkACQAJAAkAgA0EDcUEBaw4DAgEAAwsgBUEIaiAEIAIgBkECcmotAABBAnRqIgAvAQAgAC0AAhBbIAVBCGoQOQsgBUEIaiAEIAIgBkEBcmotAABBAnRqIgAvAQAgAC0AAhBbCyAFQQhqIAQgAiAGai0AAEECdGoiAC8BACAALQACEFsgBUEIahA5CyAGBEADQCAFQQhqIAQgAiAGaiIAQX9qLQAAQQJ0aiIBLwEAIAEtAAIQWyAFQQhqIAQgAEF+ai0AAEECdGoiAS8BACABLQACEFsgBUEIahA5IAVBCGogBCAAQX1qLQAAQQJ0aiIALwEAIAAtAAIQWyAFQQhqIAQgAiAGQXxqIgZqLQAAQQJ0aiIALwEAIAAtAAIQWyAFQQhqEDkgBg0ACwsgBUEIahD4AwshBiAFQSBqJAAgBgs/AQF/IAEhAiACAn9BpOoBKAIAQX9MBEAgACACQdjpARClAQwBCyAAIAJB2OkBEKUBCyIARgRADwsgACABbhoLPgEBfyAAIAEvAAAiAjYCDCAAIAFBBGoiATYCBCAAQQEgAnQ2AgAgACABQQEgAkF/anRBASACG0ECdGo2AggLDgAgACABIAIQRyAAEDkLPwEBfyAAIAAoAhQiAkEBajYCFCACIAAoAghqIAFBCHY6AAAgACAAKAIUIgJBAWo2AhQgAiAAKAIIaiABOgAAC44FAQp/IAAoAiwiAkH6fWohCCAAKAJ0IQUgAiEBA0AgACgCPCAFayAAKAJsIgVrIQQgBSABIAhqTwRAIAAoAjgiASABIAJqIAIQKhogACAAKAJwIAJrNgJwIAAgACgCbCACayIFNgJsIAAgACgCXCACazYCXCAAKAJEIAAoAkwiA0EBdGohAQNAIAFBfmoiAUEAIAEvAQAiByACayIGIAYgB0sbOwEAIANBf2oiAw0ACyAAKAJAIAJBAXRqIQEgAiEDA0AgAUF+aiIBQQAgAS8BACIHIAJrIgYgBiAHSxs7AQAgA0F/aiIDDQALIAIgBGohBAsCQCAAKAIAIgEoAgRFDQAgACABIAAoAnQgACgCOCAFamogBBCeBCAAKAJ0aiIFNgJ0AkAgACgCtC0iAyAFakEDSQ0AIAAgACgCOCIHIAAoAmwgA2siAWoiBC0AACIGNgJIIAAgACgCVCIJIAQtAAEgBiAAKAJYIgZ0c3EiBDYCSANAIANFDQEgACABIAdqLQACIAQgBnRzIAlxIgQ2AkggACgCQCAAKAI0IAFxQQF0aiAAKAJEIARBAXRqIgovAQA7AQAgCiABOwEAIAAgA0F/aiIDNgK0LSABQQFqIQEgAyAFakECSw0ACwsgBUGFAksNACAAKAIAKAIERQ0AIAAoAiwhAQwBCwsCQCAAKAI8IgMgACgCwC0iAk0NACACIAAoAnQgACgCbGoiAUkEQCAAKAI4IAFqQQAgAyABayICQYICIAJBggJJGyICECgaIAAgASACajYCwC0PCyABQYICaiIBIAJNDQAgACgCOCACakEAIAMgAmsiAyABIAJrIgIgAiADSxsiAhAoGiAAIAAoAsAtIAJqNgLALQsLEQAgACABKAAANgAAIABBBGoLEQAgACABLwAAOwAAIABBAmoLTAEBfyMAQRBrIgEkACABQQA2AgwCQAJ/IAFBICAAELUBIgA2AgxBAEEMIAAbRQsEQCABKAIMIgANAQsQ/ANBACEACyABQRBqJAAgAAtJAQJ/IAAoAgQiBUEIdSEGIAAoAgAiACABIAVBAXEEfyACKAIAIAZqKAIABSAGCyACaiADQQIgBUECcRsgBCAAKAIAKAIYEQsACxYAAn8gABCRAQRAIAAoAgAMAQsgAAsLsAEBAX8gAQJ/IAJBB00EQCAAKAIAIAEoAgAtAAA6AAAgACgCACABKAIALQABOgABIAAoAgAgASgCAC0AAjoAAiAAKAIAIAEoAgAtAAM6AAMgASABKAIAIAJBAnQiAkGQwwFqKAIAaiIDNgIAIAAoAgAgAygAADYABCABKAIAIAJB8MIBaigCAGsMAQsgACgCACABKAIAEGcgASgCAAtBCGo2AgAgACAAKAIAQQhqNgIAC9EDAQp/IwBB8ABrIgskACAAQQhqIQxBASAFdCEKAkAgAkF/RgRAIAAgBTYCBCAAQQE2AgAMAQtBgIAEIAVBf2p0QRB1IQ0gCkF/aiIOIQhBASEGA0ACQCABIAdBAXQiD2ovAQAiCUH//wNGBEAgDCAIQQN0aiAHNgIEIAhBf2ohCEEBIQkMAQsgBkEAIA0gCUEQdEEQdUobIQYLIAsgD2ogCTsBACACIAdHIQkgB0EBaiEHIAkNAAsgACAFNgIEIAAgBjYCACAKQQN2IApBAXZqQQNqIQlBACEHQQAhBgNAIAEgBkEBdGouAQAiAEEBTgRAIABB//8DcSIAQQEgAEEBSxshDUEAIQADQCAMIAdBA3RqIAY2AgQDQCAHIAlqIA5xIgcgCEsNAAsgAEEBaiIAIA1HDQALCyACIAZGIQAgBkEBaiEGIABFDQALCyAKQQEgCkEBSxshAkEAIQgDQCALIAwgCEEDdGoiACgCBCIGQQF0aiIBIAEvAQAiAUEBajsBACAAIAUgARAkayIHOgADIAAgASAHdCAKazsBACAAIAQgBkECdCIBaigCADoAAiAAIAEgA2ooAgA2AgQgCEEBaiIIIAJHDQALIAtB8ABqJAALPAEDfwNAIAAgA0ECdGoiAiACKAIAQQR0QX9qIgI2AgAgAiAEaiEEIAEgA0chAiADQQFqIQMgAg0ACyAECwQAIAALHQAgAEHAAE8EQCAAECRBE2oPCyAAQfClAWotAAALUQAgAiABayECAn8gBUUEQCABIAIgAyAEIAYQcQwBCyABIAIgAyAEIAYQ+gMLIgUQISAFRXJFBEAgASAFaiAAayIAQQAgACAEQX9qSRsPCyAFCx8AIAAgASACLwEAEEY2AgAgARAjGiAAIAJBBGo2AgQLNwEBfyADQdsLTQRAIAAgASACIAMQqgEPC0F/IQUgBEEDcQR/IAUFIAAgASACIANBACAEEIMCCwsjAEIAIAEQTiAAhUKHla+vmLbem55/fkLj3MqV/M7y9YV/fAsNACABIABBAnRqKAIAC0ABAX8jAEEgayIAJAAgAEEIahC0BEGg7AEgACgCGDYCAEGY7AEgACkDEDcCAEGQ7AEgACkDCDcCACAAQSBqJAALPAACQCAAKAJEQQFHBEAgACgCFCAAKAIkbUEBSg0BCyAAELkCDwsgABC4AiAAQoGAgIBwNwLAESAAKAIsC6sDAQN/IAEgAEEEaiIEakF/akEAIAFrcSIFIAJqIAAgACgCACIBakF8ak0EfyAAKAIEIgMgACgCCDYCCCAAKAIIIAM2AgQgBCAFRwRAIAAgAEF8aigCACIDQR91IANzayIDIAUgBGsiBCADKAIAaiIFNgIAIAVBfHEgA2pBfGogBTYCACAAIARqIgAgASAEayIBNgIACwJAIAJBGGogAU0EQCAAIAJqQQhqIgMgASACayIBQXhqIgQ2AgAgBEF8cSADakF8akEHIAFrNgIAIAMCfyADKAIAQXhqIgFB/wBNBEAgAUEDdkF/agwBCyABZyEEIAFBHSAEa3ZBBHMgBEECdGtB7gBqIAFB/x9NDQAaIAFBHiAEa3ZBAnMgBEEBdGtBxwBqIgFBPyABQT9JGwsiAUEEdCIEQYDtAWo2AgQgAyAEQYjtAWoiBCgCADYCCCAEIAM2AgAgAygCCCADNgIEQYj1AUGI9QEpAwBCASABrYaENwMAIAAgAkEIaiIBNgIAIAFBfHEgAGpBfGogATYCAAwBCyAAIAFqQXxqIAE2AgALIABBBGoFIAMLC0sBAn8gACgCBCIGQQh1IQcgACgCACIAIAEgAiAGQQFxBH8gAygCACAHaigCAAUgBwsgA2ogBEECIAZBAnEbIAUgACgCACgCFBEMAAtdAQF/IAAoAhAiA0UEQCAAQQE2AiQgACACNgIYIAAgATYCEA8LAkAgASADRgRAIAAoAhhBAkcNASAAIAI2AhgPCyAAQQE6ADYgAEECNgIYIAAgACgCJEEBajYCJAsLIAACQCAAKAIEIAFHDQAgACgCHEEBRg0AIAAgAjYCHAsLogEAIABBAToANQJAIAAoAgQgAkcNACAAQQE6ADQgACgCECICRQRAIABBATYCJCAAIAM2AhggACABNgIQIANBAUcNASAAKAIwQQFHDQEgAEEBOgA2DwsgASACRgRAIAAoAhgiAkECRgRAIAAgAzYCGCADIQILIAAoAjBBAUcgAkEBR3INASAAQQE6ADYPCyAAQQE6ADYgACAAKAIkQQFqNgIkCws3AQJ/IABB/OMBNgIAAn8gACgCBEF0aiICIgEgASgCCEF/aiIBNgIIIAFBf0wLBEAgAhA4CyAAC4oRAg9/AX4jAEHQAGsiBSQAIAUgATYCTCAFQTdqIRMgBUE4aiERQQAhAQJAA0ACQCANQQBIDQAgAUH/////ByANa0oEQEGw7AFBPTYCAEF/IQ0MAQsgASANaiENCyAFKAJMIgkhAQJAAkACQCAJLQAAIgYEQANAAkACQCAGQf8BcSIGRQRAIAEhBgwBCyAGQSVHDQEgASEGA0AgAS0AAUElRw0BIAUgAUECaiIHNgJMIAZBAWohBiABLQACIQogByEBIApBJUYNAAsLIAYgCWshASAABEAgACAJIAEQZgsgAQ0GIAUoAkwiB0EBaiEBQX8hDwJAIAcsAAEiBhBuRQ0AIActAAJBJEcNACAHQQNqIQEgBkFQaiEPQQEhEgsgBSABNgJMQQAhDgJAIAEsAAAiCkFgaiIHQR9LBEAgASEGDAELIAEhBkEBIAd0IgdBidEEcUUNAANAIAUgAUEBaiIGNgJMIAcgDnIhDiABLAABIgpBYGoiB0EgTw0BIAYhAUEBIAd0IgdBidEEcQ0ACwsCQCAKQSpGBEACfwJAIAYsAAEiARBuRQ0AIAYtAAJBJEcNACABQQJ0IARqQcB+akEKNgIAIAZBA2ohASAGLAABQQN0IANqQYB9aigCACELQQEMAQsgEg0GIAZBAWohASAARQRAIAUgATYCTEEAIRJBACELDAMLIAIgAigCACIGQQRqNgIAIAYoAgAhC0EACyESIAUgATYCTCALQX9KDQFBACALayELIA5BgMAAciEODAELIAVBzABqELwBIgtBAEgNBCAFKAJMIQELQX8hCAJAIAEtAABBLkcNACABLQABQSpGBEACQAJAIAEsAAIiBhBuRQ0AIAEtAANBJEcNACAGQQJ0IARqQcB+akEKNgIAIAEsAAJBA3QgA2pBgH1qKAIAIQggAUEEaiEBDAELIBINBiABQQJqIQEgAEUEQEEAIQgMAQsgAiACKAIAIgZBBGo2AgAgBigCACEICyAFIAE2AkwMAQsgBSABQQFqNgJMIAVBzABqELwBIQggBSgCTCEBC0EAIQcDQCAHIRBBfyEMIAEiCiwAAEG/f2pBOUsNCCAFIApBAWoiATYCTCAKLAAAIBBBOmxqQf/PAWotAAAiB0F/akEISQ0ACwJAAkAgB0ETRwRAIAdFDQogD0EATgRAIAQgD0ECdGogBzYCACAFIAMgD0EDdGopAwA3A0AMAgsgAEUNCCAFQUBrIAcgAhC7AQwCCyAPQX9KDQkLQQAhASAARQ0HCyAOQf//e3EiBiAOIA5BgMAAcRshB0EAIQxBkNQBIQ8gESEOAkACQAJAAn8CQAJAAkACQAJ/AkACQAJAAkACQAJAAkAgCiwAACIBQV9xIAEgAUEPcUEDRhsgASAQGyIBQah/ag4hBBQUFBQUFBQUDhQPBg4ODhQGFBQUFAIFAxQUCRQBFBQEAAsCQCABQb9/ag4HDhQLFA4ODgALIAFB0wBGDQkMEwsgBSkDQCEUQZDUAQwFC0EAIQECQAJAAkACQAJAAkACQCAQQf8BcQ4IAAECAwQaBQYaCyAFKAJAIA02AgAMGQsgBSgCQCANNgIADBgLIAUoAkAgDaw3AwAMFwsgBSgCQCANOwEADBYLIAUoAkAgDToAAAwVCyAFKAJAIA02AgAMFAsgBSgCQCANrDcDAAwTCyAIQQggCEEISxshCCAHQQhyIQdB+AAhAQsgBSkDQCARIAFBIHEQ2wIhCSAHQQhxRQ0DIAUpA0BQDQMgAUEEdkGQ1AFqIQ9BAiEMDAMLIAUpA0AgERDaAiEJIAdBCHFFDQIgCCARIAlrIgFBAWogCCABShshCAwCCyAFKQNAIhRCf1cEQCAFQgAgFH0iFDcDQEEBIQxBkNQBDAELIAdBgBBxBEBBASEMQZHUAQwBC0GS1AFBkNQBIAdBAXEiDBsLIQ8gFCARENkCIQkLIAdB//97cSAHIAhBf0obIQcgCCAFKQNAIhRQRXJFBEBBACEIIBEhCQwMCyAIIBRQIBEgCWtqIgEgCCABShshCAwLCyAFKAJAIgFBmtQBIAEbIgkgCBDYAiIBIAggCWogARshDiAGIQcgASAJayAIIAEbIQgMCgsgCARAIAUoAkAMAgtBACEBIABBICALQQAgBxBeDAILIAVBADYCDCAFIAUpA0A+AgggBSAFQQhqNgJAQX8hCCAFQQhqCyEGQQAhAQJAA0AgBigCACIJRQ0BIAVBBGogCRC6ASIKQQBIIgkgCiAIIAFrS3JFBEAgBkEEaiEGIAggASAKaiIBSw0BDAILC0F/IQwgCQ0LCyAAQSAgCyABIAcQXiABRQRAQQAhAQwBC0EAIQogBSgCQCEGA0AgBigCACIJRQ0BIAVBBGogCRC6ASIJIApqIgogAUoNASAAIAVBBGogCRBmIAZBBGohBiAKIAFJDQALCyAAQSAgCyABIAdBgMAAcxBeIAsgASALIAFKGyEBDAgLIAAgBSsDQCALIAggByABQQARIAAhAQwHCyAFIAUpA0A8ADdBASEIIBMhCSAGIQcMBAsgBSABQQFqIgc2AkwgAS0AASEGIAchAQwACwALIA0hDCAADQQgEkUNAkEBIQEDQCAEIAFBAnRqKAIAIgAEQCADIAFBA3RqIAAgAhC7AUEBIQwgAUEBaiIBQQpHDQEMBgsLQQEhDCABQQpPDQRBACEGA0AgBg0BIAFBAWoiAUEKRg0FIAQgAUECdGooAgAhBgwACwALQX8hDAwDCyAAQSAgDCAOIAlrIgogCCAIIApIGyIGaiIQIAsgCyAQSBsiASAQIAcQXiAAIA8gDBBmIABBMCABIBAgB0GAgARzEF4gAEEwIAYgCkEAEF4gACAJIAoQZiAAQSAgASAQIAdBgMAAcxBeDAELC0EAIQwLIAVB0ABqJAAgDAsWACAARQRAQQAPC0Gw7AEgADYCAEF/CyIBAX8jAEEQayIBIAA2AgggASABKAIIKAIENgIMIAEoAgwLCgAgAC0AC0EHdgsRACAAEJEBBEAgACgCABA4CwvYAQEIf0G6fyEJAkAgACACKAIEIgggAigCACIKaiINaiABSw0AQWwhCSADKAIAIg4gCmoiDyAESw0AIAAgCmoiBCACKAIIIgtrIQwgACABQWBqIgEgDiAKQQAQxAEgAyAPNgIAAkACQCALIAQgBWtNBEAgDCEFDAELIAsgBCAGa0sNAiAHIAwgBWsiA2oiACAIaiAHTQRAIAQgACAIEEoaDAILIAQgAEEAIANrEEohACACIAMgCGoiCDYCBCAAIANrIQQLIAQgASAFIAhBARDEAQsgDSEJCyAJC4wCAQJ/IwBBgAFrIg4kACAOIAM2AnxBfyENAkACQAJAAkACQCACDgQBAAMCBAsgBkUEQEG4fyENDAQLQWwhDSAFLQAAIgIgA0sNAyAAIAcgAkECdCICaigCACACIAhqKAIAEPgCIAEgADYCAEEBIQ0MAwsgASAJNgIAQQAhDQwCCyAKRQRAQWwhDQwCC0EAIQ0gC0UgDEEZSHINAUEIIAR0QQhqIQBBACEDA0AgA0FAayIDIABJDQALDAELQWwhDSAOIA5B/ABqIA5B+ABqIAUgBhBrIgIQIQ0AIA4oAngiAyAESw0AIAAgDiAOKAJ8IAcgCCADEH0gASAANgIAIAIhDQsgDkGAAWokACANCxAAIAAvAAAgAC0AAkEQdHILEQAgACABQQRqIAEoAgAQ5gILXgEBf0G4fyEDIAIQaSICIAFNBH8gACACakF/ai0AACIAQQNxQQJ0QcCrAWooAgAgAmogAEEGdiIBQQJ0QdCrAWooAgBqIABBIHFBBXYiAEEBc2ogACABRXFqBSADCwsVACAAIAFBA3RqKAIEQf//A2pBEHYLdgECfyMAQSBrIgUkACABIAIgBCgCECIGENgBQX8gBnRBf3NGBEAgACgCGCEGIAAoAhQhACAFIAQpAhA3AxggBSAEKQIINwMQIAUgBCkCADcDCCAAIAYgASACENcBIAMgASACENUBIAVBCGoQpwMLIAVBIGokAAuaAQACfwJAAkACQCAAKAKEAUF7ag4DAQICAAtBACAAKAIEIAAoAhhqIAFLDQIaIAAgAUEEEFQgACABIAIgA0EEQQEQUw8LQQAgACgCBCAAKAIYaiABSw0BGiAAIAFBBRBUIAAgASACIANBBUEBEFMPC0EAIAAoAgQgACgCGGogAUsNABogACABQQYQVCAAIAEgAiADQQZBARBTCwuaAQACfwJAAkACQCAAKAKEAUF7ag4DAQICAAtBACAAKAIEIAAoAhhqIAFLDQIaIAAgAUEEEFQgACABIAIgA0EEQQIQUw8LQQAgACgCBCAAKAIYaiABSw0BGiAAIAFBBRBUIAAgASACIANBBUECEFMPC0EAIAAoAgQgACgCGGogAUsNABogACABQQYQVCAAIAEgAiADQQZBAhBTCwuaAQACfwJAAkACQCAAKAKEAUF7ag4DAQICAAtBACAAKAIEIAAoAhhqIAFLDQIaIAAgAUEEEFQgACABIAIgA0EEQQAQUw8LQQAgACgCBCAAKAIYaiABSw0BGiAAIAFBBRBUIAAgASACIANBBUEAEFMPC0EAIAAoAgQgACgCGGogAUsNABogACABQQYQVCAAIAEgAiADQQZBABBTCwt6AQN/Qbp/IQUgA0H/H0tBAkEBIANBH0sbaiIEIANqIgYgAU0EfwJAAkACQAJAIARBf2oOAwABAgMLIAAgA0EDdDoAAAwCCyAAIANBBHRBBHJB9P8DcRAvDAELIAAgA0EEdEEMchBNCyAAIARqIAIgAxAqGiAGBSAFCws5AQJ/IAAoAhQhAyAAKAIMIQIgAEECEOEBIAEgAmoiASADSwRAIABBATYCGEEADwsgACABNgIMIAILTAEBfyABEOMBIQECQCAAKAIgRQRAIAAoAggiAiABaiIBIAAoAgRNDQELIABBATYCGEEADwsgACABNgIQIAAgATYCDCAAIAE2AgggAgvjAwEGfyABQRBtIQggAUEQTgRAA0AgACAGQQJ0IgVqIgFBACABKAIAIgEgAmsiAyADIAFLGzYCACAAIAVBBHJqIgFBACABKAIAIgMgAmsiBCAEIANLGzYCACABQQAgASgCBCIBIAJrIgMgAyABSxs2AgQgACAFQQxyaiIBQQAgASgCACIDIAJrIgQgBCADSxs2AgAgAUEAIAEoAgQiAyACayIEIAQgA0sbNgIEIAFBACABKAIIIgMgAmsiBCAEIANLGzYCCCABQQAgASgCDCIBIAJrIgMgAyABSxs2AgwgACAFQRxyaiIBQQAgASgCACIDIAJrIgQgBCADSxs2AgAgAUEAIAEoAgQiAyACayIEIAQgA0sbNgIEIAFBACABKAIIIgMgAmsiBCAEIANLGzYCCCABQQAgASgCDCIDIAJrIgQgBCADSxs2AgwgAUEAIAEoAhAiAyACayIEIAQgA0sbNgIQIAFBACABKAIUIgMgAmsiBCAEIANLGzYCFCABQQAgASgCGCIDIAJrIgQgBCADSxs2AhggAUEAIAEoAhwiASACayIDIAMgAUsbNgIcIAAgBUE8cmoiAUEAIAEoAgAiASACayIFIAUgAUsbNgIAIAZBEGohBiAHQQFqIgcgCEcNAAsLC5ICAQJ/IwBB8ABrIhAkAEF/IQ8CQAJAAkACQAJAIAQOBAIAAwEECyACIAZB/wFxEIcEQQAhD0EAECENAyABRQRAQbp/IQ8MBAsgACAHLQAAOgAAQQEhDwwDCyACIAwgDRAqGkEAIQ8MAgsgAiAJIAsgCiAOQYAwEKkBIgAQISEBIBBB8ABqJAAgAEEAIAEbDwsgECADIAggBhCnASIEIAUgBSAHIAhBf2oiA2otAABBAnRqIgcoAgAiCUECTwR/IAcgCUF/ajYCACADBSAICyAGEKYBIg8QIQ0AIAAgASAQIAYgBBCoASIPECENACACIBAgBiAEIA5BgDAQqQEiACAPIAAQIRshDwsgEEHwAGokACAPC+ABAAJAIAMgBEcEQAJAAkAgCkEDTQRAIAlFDQEgBEHnB00EQEEDIQkgACgCAEECRg0DC0EKIAprIAh0QQN2IARLDQQgBCAIQX9qdiADTQ0BDAQLQX8hCkF/IQMgCQRAIAcgCCABIAIQzQMhAwtBAyEJAn8gACgCAARAIAYgASACEMwDIQoLIAMgCk0LQQAgAyABIAIgBCAFEMsDQQN0IAEgAiAEEMoDaiIBTRsNAyAKIAFNDQELIABBATYCAEECIQkLIAkPCyAAQQA2AgAgCUUgA0ECS3IPCyAAQQA2AgBBAAsXACAAIAFB//8DcRAvIAAgAUEQdjoAAgs4AQF/IABCADcCCCAAQgA3AhAgAEIANwIYIABBADYCICAAKAIAIQQgAEIANwIAIAQgASACIAMQZAvBAQEDfwJAIAIoAhAiAwR/IAMFIAIQhQQNASACKAIQCyACKAIUIgVrIAFJBEAgAiAAIAEgAigCJBEBAA8LAkAgAiwAS0EASARAQQAhAwwBCyABIQQDQCAEIgNFBEBBACEDDAILIAAgA0F/aiIEai0AAEEKRw0ACyACIAAgAyACKAIkEQEAIgQgA0kNASAAIANqIQAgASADayEBIAIoAhQhBQsgBSAAIAEQKhogAiACKAIUIAFqNgIUIAEgA2ohBAsgBAv9AgIIfwV+AkACf0F/IAFBCyABGyIGQQVJDQAaQVQgBkEMSw0AGkF/IAYgAyAEEIACSQ0AGiADIAZ2IQxBASAGdCEHQoCAgICAgICAwAAgA62AIQ5BPiAGa60iDUJsfCEPQQAhAQJAA0AgAiABQQJ0aigCACIFIANGDQECQCAFRQRAIAAgAUEBdGpBADsBAAwBCyAFIAxNBEAgACABQQF0akH//wM7AQAgB0F/aiEHDAELIA4gBa1+IhAgDYgiEaciBUH//wNxIgpBB00EQCAQIBFC//8DgyANhn0gCkECdEHghAFqNQIAIA+GViAFaiEFCyAAIAFBAXRqIAU7AQAgBSAIIAVBEHRBEHUiBSAIQRB0QRB1SiIKGyEIIAEgCSAKGyEJIAcgBWshBwsgAUEBaiIBIARNDQALIAAgCUEBdGoiAS4BACIFQQF1QQAgB2tKDQIgBiIFIAAgBSACIAMgBBCIBCILECFFDQEaCyALCw8LIAEgBSAHajsBACAGCw0AIAAgASACQQIQgQILUgACf0FUIARBDEsNABpBfyAEQQVJDQAaIANBAWogBGxBA3ZBA2pBgAQgAxsgAUsEQCAAIAEgAiADIARBABCCAg8LIAAgASACIAMgBEEBEIICCwvIBAEKfyMAQZAIayIJJABBASEGQVQhB0EBIAN0IgggBU0EQCAIQQF2IgxBASADG0ECdCEKIAAgAzsBACAAQQRqIg5BfmogAjsBAEEAIQAgCUEANgIAIAhBf2oiBSEHIAJBAWoiCyACTwRAIAUhBwNAIAkgBkECdGoCfyABIAZBf2oiDUEBdGouAQAiD0F/RgRAIAQgB2ogDToAACAHQX9qIQcgAEEBagwBCyAAIA9qCyIANgIAIAZBAWoiBiALTQ0ACwsgCiAOaiEKIAkgC0ECdGogCEEBajYCACAIQQN2IAxqQQNqIQxBACEAQQAhBgNAIAEgAEEBdGouAQAiDUEBTgRAQQAhCwNAIAQgBmogADoAAANAIAYgDGogBXEiBiAHSw0ACyALQQFqIgsgDUcNAAsLIABBAWoiACACTQ0ACyAIQQEgCEEBSxshAEEAIQYDQCAJIAQgBmotAABBAnRqIgUgBSgCACIFQQFqNgIAIA4gBUEBdGogBiAIajsBACAGQQFqIgYgAEcNAAsgA0EQdCAIayIEQYCABGohBUEAIQZBACEHA0ACQAJAAkACQCABIAZBAXRqLgEAIgBBAWoOAwEAAQILIAogBkEDdGogBTYCBAwCCyAKIAZBA3RqIgAgB0F/ajYCACAAIAQ2AgQgB0EBaiEHDAELIAogBkEDdGoiCCAHIABrNgIAIAggAyAAQX9qECRrIghBEHQgACAIdGs2AgQgACAHaiEHCyAGQQFqIgYgAk0NAAtBACEHCyAJQZAIaiQAIAcLrwEBAn8gAEEAIAEoAgAiAEECdEEEahAoIQQgAwRAIANBAEoEQCACIANqIQMDQCAEIAItAABBAnRqIgUgBSgCAEEBajYCACACQQFqIgIgA0kNAAsLA0AgACICQX9qIQAgBCACQQJ0aigCAEUNAAsgASACNgIAQQAhA0EAIQADQCAEIANBAnRqKAIAIgEgACABIABLGyEAIANBAWoiAyACTQ0ACyAADwsgAUEANgIAQQALCwAgACABIAIQKhoLmg0BF38jAEFAaiIHQgA3AzAgB0IANwM4IAdCADcDICAHQgA3AygCQAJAAn8CQAJAIAIEQANAIAdBIGogASAIQQF0ai8BAEEBdGoiBiAGLwEAQQFqOwEAIAhBAWoiCCACRw0ACyAEKAIAIQhBDyEKIAcvAT4iDA0CIAcvATxFDQFBDiEKQQAhDAwCCyAEKAIAIQgLQQ0hCkEAIQwgBy8BOg0AQQwhCiAHLwE4DQBBCyEKIAcvATYNAEEKIQogBy8BNA0AQQkhCiAHLwEyDQBBCCEKIAcvATANAEEHIQogBy8BLg0AQQYhCiAHLwEsDQBBBSEKIAcvASoNAEEEIQogBy8BKA0AQQMhCiAHLwEmDQBBAiEKIAcvASQNACAHLwEiIgtFBEAgAyADKAIAIgBBBGo2AgAgAEHAAjYBACADIAMoAgAiAEEEajYCACAAQcACNgEAIARBATYCAAwDCyAIQQBHIQ5BASEKQQEhCEEADAELIAogCCAIIApLGyEOQQEhCAJAA0AgB0EgaiAIQQF0ai8BAA0BIAhBAWoiCCAKRw0ACyAKIQgLIAcvASIhC0EBCyEQQX8hCSALQf//A3EiBkECSw0BQQQgBy8BJCIRIAZBAXRqayIGQQBIDQEgBkEBdCAHLwEmIhJrIgZBAEgNASAGQQF0IAcvASgiE2siBkEASA0BIAZBAXQgBy8BKiIUayIGQQBIDQEgBkEBdCAHLwEsIhVrIgZBAEgNASAGQQF0IAcvAS4iGGsiBkEASA0BIAZBAXQgBy8BMCIbayIGQQBIDQEgBkEBdCAHLwEyIhxrIgZBAEgNASAGQQF0IAcvATQiDWsiBkEASA0BIAZBAXQgBy8BNiIWayIGQQBIDQEgBkEBdCAHLwE4IhdrIgZBAEgNASAGQQF0IAcvAToiGWsiBkEASA0BIAZBAXQgBy8BPCIaayIGQQBIDQEgBkEBdCAMayIGQQBIIAZBACAARSAQchtyDQFBACEJIAdBADsBAiAHIAs7AQQgByALIBFqIgY7AQYgByAGIBJqIgY7AQggByAGIBNqIgY7AQogByAGIBRqIgY7AQwgByAGIBVqIgY7AQ4gByAGIBhqIgY7ARAgByAGIBtqIgY7ARIgByAGIBxqIgY7ARQgByAGIA1qIgY7ARYgByAGIBZqIgY7ARggByAGIBdqIgY7ARogByAGIBlqIgY7ARwgByAGIBpqOwEeIAIEQANAIAEgCUEBdGovAQAiBgRAIAcgBkEBdGoiBiAGLwEAIgZBAWo7AQAgBSAGQQF0aiAJOwEACyAJQQFqIgkgAkcNAAsLIAggDiAOIAhJGyENQRMhDkEAIRQgBSEWIAUhF0EAIRACQAJAAkAgAA4CAgABC0EBIQkgDUEJSw0DQYACIQ5B3uoAIRdB3ukAIRZBASEQDAELIABBAkYhFEF/IQ5BoO4AIRdBoO0AIRYgAEECRwRADAELQQEhCSANQQlLDQILQQEgDXQiEUF/aiEbIAMoAgAhEkEAIRMgDSEGQQAhC0F/IRoDQEEBIAZ0IRkCQANAIAggD2shFQJ/QQAgDiAFIBNBAXRqLwEAIgZKDQAaIA4gBk4EQEEAIQZB4AAMAQsgFiAGQQF0IgBqLwEAIQYgACAXai0AAAshACALIA92IRxBfyAVdCEJIBkhAgNAIBIgAiAJaiICIBxqQQJ0aiIYIAY7AQIgGCAVOgABIBggADoAACACDQALQQEgCEF/anQhCQNAIAkiAEEBdiEJIAAgC3ENAAsgB0EgaiAIQQF0aiICIAIvAQBBf2oiAjsBACAAQX9qIAtxIABqQQAgABshCyATQQFqIRMgAkH//wNxRQRAIAggCkYNAiABIAUgE0EBdGovAQBBAXRqLwEAIQgLIAggDU0NACALIBtxIgAgGkYNAAtBASAIIA8gDSAPGyIPayIGdCEMIAggCkkEQCAKIA9rIQIgCCEJAkADQCAMIAdBIGogCUEBdGovAQBrIglBAUgNASAJQQF0IQwgBkEBaiIGIA9qIgkgCkkNAAsgAiEGC0EBIAZ0IQwLQQEhCSAQIAwgEWoiEUHUBktxIBQgEUHQBEtxcg0DIAMoAgAiAiAAQQJ0aiIJIA06AAEgCSAGOgAAIAkgEiAZQQJ0aiISIAJrQQJ2OwECIAAhGgwBCwsgCwRAIBIgC0ECdGoiAEEAOwECIAAgFToAASAAQcAAOgAACyADIAMoAgAgEUECdGo2AgAgBCANNgIAC0EAIQkLIAkLygIBC38gACACQQJ0akHcFmooAgAhBgJAIAJBAXQiAyAAKALQKCIFSgRAIAIhBAwBCyAAIAZqQdgoaiEKIAEgBkECdGohCyAAQdwWaiEIIABB2ChqIQkDQAJ/IAMgAyAFTg0AGiABIAggA0EBciIFQQJ0aigCACIHQQJ0ai8BACIEIAEgCCADQQJ0aigCACIMQQJ0ai8BACINTwRAIAMgBCANRw0BGiADIAcgCWotAAAgCSAMai0AAEsNARoLIAULIQQgCy8BACIFIAEgACAEQQJ0akHcFmooAgAiA0ECdGovAQAiB0kEQCACIQQMAgsCQCAFIAdHDQAgCi0AACAAIANqQdgoai0AAEsNACACIQQMAgsgACACQQJ0akHcFmogAzYCACAEIgJBAXQiAyAAKALQKCIFTA0ACwsgACAEQQJ0akHcFmogBjYCAAuyBQEKfyABKAIIIgMoAgAhByADKAIMIQUgASgCACEGIABCgICAgNDHADcC0ChBfyEDAkAgBUEASgRAA0ACQCAGIAJBAnRqIgQvAQAEQCAAIAAoAtAoQQFqIgM2AtAoIAAgA0ECdGpB3BZqIAI2AgAgACACakHYKGpBADoAACACIQMMAQsgBEEAOwECCyACQQFqIgIgBUcNAAsgACgC0CgiAkEBSg0BCwNAIAAgAkEBaiICNgLQKCAAIAJBAnRqQdwWaiADQQFqIglBACADQQJIIgQbIgg2AgAgBiAIQQJ0IgJqQQE7AQAgACAIakHYKGpBADoAACAAIAAoAqgtQX9qNgKoLSAHBEAgACAAKAKsLSACIAdqLwECazYCrC0LIAkgAyAEGyEDIAAoAtAoIgJBAkgNAAsLIAEgAzYCBCACQQF2IQIDQCAAIAYgAhCtASACQQFKIQQgAkF/aiECIAQNAAsgACgC0CghAiAAQdwWaiEKIABB2ChqIQsDQCAAIAJBf2o2AtAoIAAoAuAWIQcgACAKIAJBAnRqKAIANgLgFiAAIAZBARCtASAAIAAoAtQoQX9qIgI2AtQoIAAoAuAWIQQgCiACQQJ0aiAHNgIAIAAgACgC1ChBf2oiAjYC1CggCiACQQJ0aiAENgIAIAYgBUECdGogBiAEQQJ0aiIILwEAIAYgB0ECdGoiCS8BAGo7AQAgBSALaiAEIAtqLQAAIgQgByALai0AACICIAIgBEkbQQFqOgAAIAggBTsBAiAJIAU7AQIgACAFNgLgFiAAIAZBARCtASAFQQFqIQUgACgC0CgiAkEBSg0ACyAAIAAoAtQoQX9qIgI2AtQoIAAgAkECdGpB3BZqIAAoAuAWNgIAIAAgASgCACABKAIEIAEoAggQlAQgBiADIABBvBZqEJMEC5gCAQN/QX4hAgJAIABFDQAgACgCHCIBRQ0AAkACQCABKAIEIgNBu39qDi0BAgICAQICAgICAgICAgICAgICAgICAQICAgICAgICAgICAQICAgICAgICAgEACyADQZoFRg0AIANBKkcNAQsCfwJ/An8gASgCCCICBEAgACgCKCACIAAoAiQRBAAgACgCHCEBCyABKAJEIgILBEAgACgCKCACIAAoAiQRBAAgACgCHCEBCyABKAJAIgILBEAgACgCKCACIAAoAiQRBAAgACgCHCEBCyABKAI4IgILBEAgACgCKCACIAAoAiQRBAAgACgCHCEBCyAAKAIoIAEgACgCJBEEACAAQQA2AhxBfUEAIANB8QBGGyECCyACCx0AIABBCSABIAFBAUgbIgBBDCAAQQxIGzsBmIAQC6IDAQZ/IwBBEGsiAyQAAn8gACgCBCIBIAAoAggiAkYEQCAAKAIAIgIgACgCDCACKAIAKAIQEQQAIAAoAgAiAiADQQxqIAIoAgAoAgwRAwAhASAAIAMoAgwiAjYCDCACRQRAIABBAToAEEEADAILIAAgASACaiICNgIICwJAIAIgAWsiAiABLQAAQQF0QcAJai8BAEELdkEBaiIESQRAIABBEWogASACEEohBiAAKAIAIgEgACgCDCABKAIAKAIQEQQAIABBADYCDANAIAAoAgAiASADQQhqIAEoAgAoAgwRAwAhBUEAIAMoAggiAUUNAxogACACakERaiAFIAEgBCACayIFIAEgBUkbIgEQKhogACgCACIFIAEgBSgCACgCEBEEACABIAJqIgIgBEkNAAsgACAGNgIEIAAgACAEakERajYCCAwBCyACQQRNBEAgAEERaiABIAIQSiEBIAAoAgAiBCAAKAIMIAQoAgAoAhARBAAgACABIAJqNgIIIAAgATYCBCAAQQA2AgwMAQsgACABNgIEC0EBCyECIANBEGokACACCx4BAX8gAEEFRiABQRBKcgR/IAMFIAIgAW1B/wBKCwvCAgEKfyAAKAIMLQAAIghBAnYgACgCKCIJIAFMcSENIAggCUEBSnEhDiAAKAIYIQsgASEKQQEhDAJAAkACQCAIQRBxIAlBEEpyDQAgAiABIAltIghBgAFIcg0AIAghCiAJIQwgCUEBTg0ADAELIAYgBiAFIA0bIA4bIQIgCiAMbCEPIAtBfGohEANAQX8hCCAEQQBIIAQgEEtyDQIgAyAEaigAACILQQBIDQIgCyAAKAIYIARBBGoiBGtKDQIgAyAEaiEIAkAgCiALRgRAIAIgCCAKEFAaDAELIAggCyACIAogACgCQBEHACAKRg0AQX4PCyACIApqIQIgBCALaiEEIBFBAWoiESAMRw0ACwsCQCAOBEAgCSABIAYgBRCtAgwBCyANRQ0AIAkgASAGIAUgBxCsAiIIQQBIDQELIA8hCAsgCAufBQEKfyMAQRBrIgokAAJAAkAgACgCDC0AACIJQQFxRSAAKAIoIgtBAkhyRQRAIAsgASAFIAcQswIMAQsgCyABSgRAIAUhBwwBCyAJQQRxRQRAIAUhBwwBCyALIAEgBSAHIAgQsgIiCEEASA0BCyABQQEgCyAJQRBxIAJyGyINbSEFIAAiASgCOEEBRgR/QQogASgCPGsFQQELIQ4gDUEBSARAQQAhCAwBC0EAIQJBACEIA0AgA0EEaiEMIAUhAyAAKAI4QQNGBEAgBRCVAiEDCwJAIAMgDGogBEwNACAEIAxrIgNBAU4NAEEAIQgMAgsgBkEEaiEJAn8CQAJAAkACQAJAAkACQCAAKAI4IgEOBgYAAQIDBAULIAcgAiAFbGogCSAFIAMgDhCqAgwGCyAHIAIgBWxqIQ8gCSEBIAMhECAAKAI8IREgBSISQYCAgIB4TQR/IA8gASASIBAgERCpAgVBfwsMBQsgByACIAVsaiAFIAkgAxCxAgwECyAHIAIgBWxqIAUgCSADIAAoAjwQsAIMAwsgByACIAVsaiAFIAkgAyAAKAI8EK8CDAILIAogAUEFTQR/IAFBAnRBgBBqKAIABUEACzYCDCAKIAooAgwiAEGa1AEgABs2AgBB6BEgChBPQY8SQS8QckF7IQgMAwsgACgCPCAHIAIgBWxqIAUgCSADIAAoAgwtAAAgC0EBSnEQrgILIgEgA0oEQEF/IQgMAgsgAUEASARAQX4hCAwCCwJAIAFFIAEgBUZyRQRAIAEgDGohAwwBCyAFIAxqIgMgBEoEQEEAIQgMAwsgCSAHIAIgBWxqIAUQUBogBSEBCyAGIAEQNCAIQQRqIAFqIQggASAJaiEGIAJBAWoiAiANRw0ACwsgCkEQaiQAIAgL9AMCBX8CfgJAAkADQCAAIABBf2pxDQEgAEEIIABBCEsbIQBBiPUBKQMAIggCfyABQQNqQXxxQQggAUEISxsiAUH/AE0EQCABQQN2QX9qDAELIAFnIQIgAUEdIAJrdkEEcyACQQJ0a0HuAGogAUH/H00NABogAUEeIAJrdkECcyACQQF0a0HHAGoiAkE/IAJBP0kbCyIErYgiB1BFBEADQCAHIAd6IgiIIQcCfiAEIAinaiIEQQR0IgNBiO0BaigCACICIANBgO0BaiIGRwRAIAIgACABEIgBIgUNBiACKAIEIgUgAigCCDYCCCACKAIIIAU2AgQgAiAGNgIIIAIgA0GE7QFqIgMoAgA2AgQgAyACNgIAIAIoAgQgAjYCCCAEQQFqIQQgB0IBiAwBC0GI9QFBiPUBKQMAQn4gBK2JgzcDACAHQgGFCyIHQgBSDQALQYj1ASkDACEIC0E/IAh5p2tBBHQiAkGA7QFqIQMgAkGI7QFqKAIAIQICQCAIQoCAgIAEVA0AQeMAIQQgAiADRg0AA0AgBEUNASACIAAgARCIASIFDQQgBEF/aiEEIAIoAggiAiADRw0ACyADIQILIAFBMGoQtgENAAsgAiADRg0AA0AgAiAAIAEQiAEiBQ0CIAIoAggiAiADRw0ACwtBACEFCyAFC/0DAQZ/QejqASgCACICIABBA2pBfHEiA2ohAQJAIANBAU5BACABIAJNG0UEQCABPwBBEHRNDQEgARARDQELQbDsAUEwNgIAQQAPC0EAIQNB6OoBIAE2AgAgAkEBTgR/QRAhAyAAIAJqIgRBcGoiAEEQNgIMIABBEDYCAAJAAkACQEGA9QEoAgAiAUUNACACIAEoAghHDQAgAiACQXxqKAIAIgNBH3UgA3NrIgZBfGooAgAhBSABIAQ2AghBcCEDIAYgBSAFQR91c2siASABKAIAakF8aigCAEF/Sg0BIAEoAgQiAiABKAIINgIIIAEoAgggAjYCBCABIAAgAWsiADYCAAwCCyACQRA2AgwgAkEQNgIAIAIgBDYCCCACIAE2AgRBgPUBIAI2AgALIAIgA2oiASAAIAFrIgA2AgALIABBfHEgAWpBfGogAEF/czYCACABAn8gASgCAEF4aiIAQf8ATQRAIABBA3ZBf2oMAQsgAGchAiAAQR0gAmt2QQRzIAJBAnRrQe4AaiAAQf8fTQ0AGiAAQR4gAmt2QQJzIAJBAXRrQccAaiIAQT8gAEE/SRsLIgJBBHQiAEGA7QFqNgIEIAEgAEGI7QFqIgAoAgA2AgggACABNgIAIAEoAgggATYCBEGI9QFBiPUBKQMAQgEgAq2GhDcDAEEBBSADCwtSAQF/IAAoAgQhBCAAKAIAIgAgAQJ/QQAgAkUNABogBEEIdSIBIARBAXFFDQAaIAIoAgAgAWooAgALIAJqIANBAiAEQQJxGyAAKAIAKAIcEQgAC3UBA38CQAJAA0AgACABQcDUAWotAABHBEBB1wAhAiABQQFqIgFB1wBHDQEMAgsLIAEhAiABDQBBoNUBIQAMAQtBoNUBIQEDQCABLQAAIQMgAUEBaiIAIQEgAw0AIAAhASACQX9qIgINAAsLQfDsASgCABogAAsLACAAIAEgAhDcAgsSACAARQRAQQAPCyAAIAEQ1gILuwIAAkAgAUEUSw0AAkACQAJAAkACQAJAAkACQAJAAkAgAUF3ag4KAAECAwQFBgcICQoLIAIgAigCACIBQQRqNgIAIAAgASgCADYCAA8LIAIgAigCACIBQQRqNgIAIAAgATQCADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATUCADcDAA8LIAIgAigCAEEHakF4cSIBQQhqNgIAIAAgASkDADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATIBADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATMBADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATAAADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATEAADcDAA8LIAIgAigCAEEHakF4cSIBQQhqNgIAIAAgASsDADkDAA8LIAAgAkEAEQQACwtEAQR/IAAoAgAiAiwAACIDEG4EQANAIAAgAkEBaiIENgIAIAFBCmwgA2pBUGohASACLAABIQMgBCECIAMQbg0ACwsgAQsoAQF/IwBBEGsiASQAIAEgADYCDEHoywFBBSABKAIMEAAgAUEQaiQACygBAX8jAEEQayIBJAAgASAANgIMQZDMAUEEIAEoAgwQACABQRBqJAALKAEBfyMAQRBrIgEkACABIAA2AgxBuMwBQQMgASgCDBAAIAFBEGokAAsoAQF/IwBBEGsiASQAIAEgADYCDEHgzAFBAiABKAIMEAAgAUEQaiQACycBAX8jAEEQayIBJAAgASAANgIMQcwPQQEgASgCDBAAIAFBEGokAAsoAQF/IwBBEGsiASQAIAEgADYCDEGIzQFBACABKAIMEAAgAUEQaiQAC+ABAEH45gFBsMQBEBlBhOcBQbXEAUEBQQFBABAYEPMCEPICEPECEPACEO8CEO4CEO0CEOwCEOsCEOoCEOkCQbAOQZ/FARAHQejPAUGrxQEQB0GQzwFBBEHMxQEQAkG0zgFBAkHZxQEQAkHYzQFBBEHoxQEQAkGoDkH3xQEQFxDoAkGlxgEQwgFBysYBEMEBQfHGARDAAUGQxwEQvwFBuMcBEL4BQdXHARC9ARDlAhDkAkHAyAEQwgFB4MgBEMEBQYHJARDAAUGiyQEQvwFBxMkBEL4BQeXJARC9ARDjAhDiAguNBAEDfyMAQRBrIgUkACAFIAI2AgggBSAANgIMIAAgA2ohBwJAIANBB0wEQCADQQFIDQEDQCAAIAItAAA6AAAgAkEBaiECIABBAWoiACAHRw0ACyAFIAc2AgwgBSACNgIIDAELIARBAUYEQCAFQQxqIAVBCGogACACaxB8IAUoAgwhAAsgByABTQRAIAAgA2ohBiAEQQFHIAAgBSgCCCICa0EPSnJFBEADQCAAIAIQZyACQQhqIQIgAEEIaiIAIAZJDQAMAwsACyAAIAIQHCAAQRBqIAJBEGoQHCADQSFIDQEgAEEgaiEAA0AgACACQSBqIgEQHCAAQRBqIAJBMGoQHCABIQIgAEEgaiIAIAZJDQALDAELAkAgACABSwRAIAAhAQwBCwJAIARBAUcgACAFKAIIIgZrQQ9KckUEQCAAIQIgBiEDA0AgAiADEGcgA0EIaiEDIAJBCGoiAiABSQ0ACyABIABrIQQMAQsgACAGEBwgAEEQaiAGQRBqEBwgASAAayIEQSFIDQAgAEEgaiEAIAYhAgNAIAAgAkEgaiIDEBwgAEEQaiACQTBqEBwgAyECIABBIGoiACABSQ0ACwsgBSAEIAZqNgIICyABIAdPDQAgBSgCCCEAA0AgASAALQAAOgAAIABBAWohACABQQFqIgEgB0cNAAsgBSAHNgIMIAUgADYCCAsgBUEQaiQACwkAIAAoAgAQDAtBAQJ/IAAgACgCuOABIgM2AsTgASAAKAK84AEhBCAAIAE2ArzgASAAIAEgAmo2ArjgASAAIAEgBCADa2o2AsDgAQtbAQF/Qbh/IQMCQCABQQNJDQAgAiAAEJUBIgFBA3YiADYCCEEBIQMgAiABQQFxNgIEIAIgAUEBdkEDcSIBNgIAAkACQCABQX9qDgMCAQABC0FsDwsgACEDCyADCw4AIAAoAgAQFiAAKAIAC6wBAQF/IAAoAuzhASEBIABBADYChOEBIAAgARBpNgLI4AEgAEIANwP44AEgAEIANwO44AEgAEHA4AFqQgA3AwAgAEGo0ABqIgFBjICA4AA2AgAgAEEANgKY4gEgAEIANwOI4QEgAEGs0AFqQdCwASkCADcCACAAQbTQAWpB2LABKAIANgIAIAAgATYCDCAAIABBmCBqNgIIIAAgAEGgMGo2AgQgACAAQRBqNgIACx4AIAAoApDiARCXAyAAQQA2AqDiASAAQgA3A5DiAQu3EAEMfyMAQfAAayIFJABBbCEGAkAgA0EKSQ0AIAIvAAAhCyACLwACIQcgAi8ABCEMIAVBCGogBCgCABA0IAMgDCAHIAtqakEGaiIISQ0AIAUtAAohCSAFQdgAaiACQQZqIgIgCxBFIgYQIQ0AIAVBQGsgAiALaiICIAcQRSIGECENACAFQShqIAIgB2oiAiAMEEUiBhAhDQAgBUEQaiACIAxqIAMgCGsQRSIGECENACAEQQRqIQggACABQQNqQQJ2IgJqIgcgAmoiDCACaiILIAAgAWoiDkF9aiIPSSEKIAVB2ABqECMhAiAFQUBrECMhAyAFQShqECMhBAJAIAVBEGoQIyACIANyIARyciALIA9PckUEQCAHIQQgDCEDIAshAgNAIAggBSgCWCAFKAJcIAkQKUEBdGoiBi0AACEKIAVB2ABqIAYtAAEQJiAAIAo6AAAgCCAFKAJAIAUoAkQgCRApQQF0aiIGLQAAIQogBUFAayAGLQABECYgBCAKOgAAIAggBSgCKCAFKAIsIAkQKUEBdGoiBi0AACEKIAVBKGogBi0AARAmIAMgCjoAACAIIAUoAhAgBSgCFCAJEClBAXRqIgYtAAAhCiAFQRBqIAYtAAEQJiACIAo6AAAgCCAFKAJYIAUoAlwgCRApQQF0aiIGLQAAIQogBUHYAGogBi0AARAmIAAgCjoAASAIIAUoAkAgBSgCRCAJEClBAXRqIgYtAAAhCiAFQUBrIAYtAAEQJiAEIAo6AAEgCCAFKAIoIAUoAiwgCRApQQF0aiIGLQAAIQogBUEoaiAGLQABECYgAyAKOgABIAggBSgCECAFKAIUIAkQKUEBdGoiBi0AACEKIAVBEGogBi0AARAmIAIgCjoAASADQQJqIQMgBEECaiEEIABBAmohACAFQdgAahAjGiAFQUBrECMaIAVBKGoQIxogBUEQahAjGiACQQJqIgIgD0kNAAtBACEKDAELIAshAiAMIQMgByEECyADIAtLBEBBbCEGDAELIAQgDEsEQEFsIQYMAQtBbCEGIAAgB0sNAAJAIAVB2ABqECMgB0F9aiIGIABNcg0AA0AgCCAFKAJYIAUoAlwgCRApQQF0aiINLQAAIRAgBUHYAGogDS0AARAmIAAgEDoAACAIIAUoAlggBSgCXCAJEClBAXRqIg0tAAAhECAFQdgAaiANLQABECYgACAQOgABIAVB2ABqECMhDSAAQQJqIgAgBk8NASANRQ0ACwsCQCAFQdgAahAjIAAgB09yDQADQCAIIAUoAlggBSgCXCAJEClBAXRqIgYtAAAhDSAFQdgAaiAGLQABECYgACANOgAAIAVB2ABqECMhBiAAQQFqIgAgB08NASAGRQ0ACwsgACAHSQRAA0AgCCAFKAJYIAUoAlwgCRApQQF0aiIGLQAAIQ0gBUHYAGogBi0AARAmIAAgDToAACAAQQFqIgAgB0cNAAsLAkAgBUFAaxAjIAxBfWoiACAETXINAANAIAggBSgCQCAFKAJEIAkQKUEBdGoiBy0AACEGIAVBQGsgBy0AARAmIAQgBjoAACAIIAUoAkAgBSgCRCAJEClBAXRqIgctAAAhBiAFQUBrIActAAEQJiAEIAY6AAEgBUFAaxAjIQcgBEECaiIEIABPDQEgB0UNAAsLAkAgBUFAaxAjIAQgDE9yDQADQCAIIAUoAkAgBSgCRCAJEClBAXRqIgAtAAAhByAFQUBrIAAtAAEQJiAEIAc6AAAgBUFAaxAjIQAgBEEBaiIEIAxPDQEgAEUNAAsLIAQgDEkEQANAIAggBSgCQCAFKAJEIAkQKUEBdGoiAC0AACEHIAVBQGsgAC0AARAmIAQgBzoAACAEQQFqIgQgDEcNAAsLAkAgBUEoahAjIAtBfWoiACADTXINAANAIAggBSgCKCAFKAIsIAkQKUEBdGoiBC0AACEHIAVBKGogBC0AARAmIAMgBzoAACAIIAUoAiggBSgCLCAJEClBAXRqIgQtAAAhByAFQShqIAQtAAEQJiADIAc6AAEgBUEoahAjIQQgA0ECaiIDIABPDQEgBEUNAAsLAkAgBUEoahAjIAMgC09yDQADQCAIIAUoAiggBSgCLCAJEClBAXRqIgAtAAAhBCAFQShqIAAtAAEQJiADIAQ6AAAgBUEoahAjIQAgA0EBaiIDIAtPDQEgAEUNAAsLIAMgC0kEQANAIAggBSgCKCAFKAIsIAkQKUEBdGoiAC0AACEEIAVBKGogAC0AARAmIAMgBDoAACADQQFqIgMgC0cNAAsLAkAgBUEQahAjIApBAXNyDQADQCAIIAUoAhAgBSgCFCAJEClBAXRqIgAtAAAhAyAFQRBqIAAtAAEQJiACIAM6AAAgCCAFKAIQIAUoAhQgCRApQQF0aiIALQAAIQMgBUEQaiAALQABECYgAiADOgABIAVBEGoQIyEAIAJBAmoiAiAPTw0BIABFDQALCwJAIAVBEGoQIyACIA5Pcg0AA0AgCCAFKAIQIAUoAhQgCRApQQF0aiIALQAAIQMgBUEQaiAALQABECYgAiADOgAAIAVBEGoQIyEAIAJBAWoiAiAOTw0BIABFDQALCyACIA5JBEADQCAIIAUoAhAgBSgCFCAJEClBAXRqIgAtAAAhAyAFQRBqIAAtAAEQJiACIAM6AAAgAkEBaiICIA5HDQALCyABQWwgBSgCXCAFKAJgIAUoAmQQSyAFKAJEIAUoAkggBSgCTBBLcSAFKAIsIAUoAjAgBSgCNBBLcSAFKAIUIAUoAhggBSgCHBBLcRshBgsgBUHwAGokACAGC7YUAQ1/IwBB8ABrIgUkAEFsIQYCQCADQQpJDQAgAi8AACELIAIvAAIhCSACLwAEIQwgBUEIaiAEKAIAEDQgAyAMIAkgC2pqQQZqIgdJDQAgBS0ACiEIIAVB2ABqIAJBBmoiAiALEEUiBhAhDQAgBUFAayACIAtqIgIgCRBFIgYQIQ0AIAVBKGogAiAJaiICIAwQRSIGECENACAFQRBqIAIgDGogAyAHaxBFIgYQIQ0AIARBBGohByAAIAFBA2pBAnYiAmoiCSACaiIMIAJqIgsgACABaiIRQX1qIg9JIQ0gBUHYAGoQIyECIAVBQGsQIyEDIAVBKGoQIyEEAkAgBUEQahAjIAIgA3IgBHJyIAsgD09yRQRAIAkhAiAMIQQgCyEDA0AgACAHIAUoAlggBSgCXCAIEClBAnRqIgYvAQA7AAAgBUHYAGogBi0AAhAmIAYtAAMhDSACIAcgBSgCQCAFKAJEIAgQKUECdGoiBi8BADsAACAFQUBrIAYtAAIQJiAGLQADIQogBCAHIAUoAiggBSgCLCAIEClBAnRqIgYvAQA7AAAgBUEoaiAGLQACECYgBi0AAyEOIAMgByAFKAIQIAUoAhQgCBApQQJ0aiIGLwEAOwAAIAVBEGogBi0AAhAmIAYtAAMhBiAAIA1qIg0gByAFKAJYIAUoAlwgCBApQQJ0aiIALwEAOwAAIAVB2ABqIAAtAAIQJiAALQADIRAgAiAKaiICIAcgBSgCQCAFKAJEIAgQKUECdGoiAC8BADsAACAFQUBrIAAtAAIQJiAALQADIQogBCAOaiIEIAcgBSgCKCAFKAIsIAgQKUECdGoiAC8BADsAACAFQShqIAAtAAIQJiAALQADIQ4gAyAGaiIGIAcgBSgCECAFKAIUIAgQKUECdGoiAy8BADsAACAFQRBqIAMtAAIQJiANIBBqIQAgAiAKaiECIAQgDmohBCAGIAMtAANqIgMgD0khDSAFQdgAahAjIQYgBUFAaxAjIQogBUEoahAjIQ4gBUEQahAjIRAgAyAPTw0CIAYgCnIgDnIgEHJFDQALDAELIAshAyAMIQQgCSECCyAEIAtLBEBBbCEGDAELIAIgDEsEQEFsIQYMAQtBbCEGIAAgCUsNAAJAIAVB2ABqECMgCUF9aiIKIABNcg0AA0AgACAHIAUoAlggBSgCXCAIEClBAnRqIgYvAQA7AAAgBUHYAGogBi0AAhAmIAAgBi0AA2oiBiAHIAUoAlggBSgCXCAIEClBAnRqIgAvAQA7AAAgBUHYAGogAC0AAhAmIAYgAC0AA2ohACAFQdgAahAjDQEgACAKSQ0ACwsCQCAFQdgAahAjIAAgCUF+aiIGS3INAANAIAAgByAFKAJYIAUoAlwgCBApQQJ0aiIKLwEAOwAAIAVB2ABqIAotAAIQJiAAIAotAANqIQAgBUHYAGoQIw0BIAAgBk0NAAsLIAAgBk0EQANAIAAgByAFKAJYIAUoAlwgCBApQQJ0aiIKLwEAOwAAIAVB2ABqIAotAAIQJiAAIAotAANqIgAgBk0NAAsLAkAgACAJTw0AIAAgByAFKAJYIAUoAlwgCBApIglBAnRqIgAtAAA6AAAgAC0AA0EBRgRAIAVB2ABqIAAtAAIQJgwBCyAFKAJcQR9LDQAgBUHYAGogByAJQQJ0ai0AAhAmIAUoAlxBIUkNACAFQSA2AlwLAkAgBUFAaxAjIAxBfWoiCSACTXINAANAIAIgByAFKAJAIAUoAkQgCBApQQJ0aiIALwEAOwAAIAVBQGsgAC0AAhAmIAIgAC0AA2oiAiAHIAUoAkAgBSgCRCAIEClBAnRqIgAvAQA7AAAgBUFAayAALQACECYgAiAALQADaiECIAVBQGsQIw0BIAIgCUkNAAsLAkAgBUFAaxAjIAIgDEF+aiIAS3INAANAIAIgByAFKAJAIAUoAkQgCBApQQJ0aiIJLwEAOwAAIAVBQGsgCS0AAhAmIAIgCS0AA2ohAiAFQUBrECMNASACIABNDQALCyACIABNBEADQCACIAcgBSgCQCAFKAJEIAgQKUECdGoiCS8BADsAACAFQUBrIAktAAIQJiACIAktAANqIgIgAE0NAAsLAkAgAiAMTw0AIAIgByAFKAJAIAUoAkQgCBApIgJBAnRqIgAtAAA6AAAgAC0AA0EBRgRAIAVBQGsgAC0AAhAmDAELIAUoAkRBH0sNACAFQUBrIAcgAkECdGotAAIQJiAFKAJEQSFJDQAgBUEgNgJECwJAIAVBKGoQIyALQX1qIgIgBE1yDQADQCAEIAcgBSgCKCAFKAIsIAgQKUECdGoiAC8BADsAACAFQShqIAAtAAIQJiAEIAAtAANqIgQgByAFKAIoIAUoAiwgCBApQQJ0aiIALwEAOwAAIAVBKGogAC0AAhAmIAQgAC0AA2ohBCAFQShqECMNASAEIAJJDQALCwJAIAVBKGoQIyAEIAtBfmoiAEtyDQADQCAEIAcgBSgCKCAFKAIsIAgQKUECdGoiAi8BADsAACAFQShqIAItAAIQJiAEIAItAANqIQQgBUEoahAjDQEgBCAATQ0ACwsgBCAATQRAA0AgBCAHIAUoAiggBSgCLCAIEClBAnRqIgIvAQA7AAAgBUEoaiACLQACECYgBCACLQADaiIEIABNDQALCwJAIAQgC08NACAEIAcgBSgCKCAFKAIsIAgQKSICQQJ0aiIALQAAOgAAIAAtAANBAUYEQCAFQShqIAAtAAIQJgwBCyAFKAIsQR9LDQAgBUEoaiAHIAJBAnRqLQACECYgBSgCLEEhSQ0AIAVBIDYCLAsCQCAFQRBqECMgDUEBc3INAANAIAMgByAFKAIQIAUoAhQgCBApQQJ0aiIALwEAOwAAIAVBEGogAC0AAhAmIAMgAC0AA2oiAiAHIAUoAhAgBSgCFCAIEClBAnRqIgAvAQA7AAAgBUEQaiAALQACECYgAiAALQADaiEDIAVBEGoQIw0BIAMgD0kNAAsLAkAgBUEQahAjIAMgEUF+aiIAS3INAANAIAMgByAFKAIQIAUoAhQgCBApQQJ0aiICLwEAOwAAIAVBEGogAi0AAhAmIAMgAi0AA2ohAyAFQRBqECMNASADIABNDQALCyADIABNBEADQCADIAcgBSgCECAFKAIUIAgQKUECdGoiAi8BADsAACAFQRBqIAItAAIQJiADIAItAANqIgMgAE0NAAsLAkAgAyARTw0AIAMgByAFKAIQIAUoAhQgCBApIgJBAnRqIgAtAAA6AAAgAC0AA0EBRgRAIAVBEGogAC0AAhAmDAELIAUoAhRBH0sNACAFQRBqIAcgAkECdGotAAIQJiAFKAIUQSFJDQAgBUEgNgIUCyABQWwgBSgCXCAFKAJgIAUoAmQQSyAFKAJEIAUoAkggBSgCTBBLcSAFKAIsIAUoAjAgBSgCNBBLcSAFKAIUIAUoAhggBSgCHBBLcRshBgsgBUHwAGokACAGC48DAQR/IwBBIGsiBSQAIAUgBCgCABA0IAUtAAIhByAFQQhqIAIgAxBFIgIQIUUEQCAEQQRqIQICQCAFQQhqECMgACABaiIDQX1qIgQgAE1yDQADQCACIAUoAgggBSgCDCAHEClBAXRqIgYtAAAhCCAFQQhqIAYtAAEQJiAAIAg6AAAgAiAFKAIIIAUoAgwgBxApQQF0aiIGLQAAIQggBUEIaiAGLQABECYgACAIOgABIAVBCGoQIyEGIABBAmoiACAETw0BIAZFDQALCwJAIAVBCGoQIyAAIANPcg0AA0AgAiAFKAIIIAUoAgwgBxApQQF0aiIELQAAIQYgBUEIaiAELQABECYgACAGOgAAIAVBCGoQIyEEIABBAWoiACADTw0BIARFDQALCyAAIANJBEADQCACIAUoAgggBSgCDCAHEClBAXRqIgQtAAAhBiAFQQhqIAQtAAEQJiAAIAY6AAAgAEEBaiIAIANHDQALCyABQWwgBSgCDCAFKAIQIAUoAhQQSxshAgsgBUEgaiQAIAILwgQBDX8jAEEQayIFJAAgBUEEaiAAKAIAEDQgBS0ABCEHIANB8ARqQQBB7AAQKCEIQVQhBAJAIAdBDEsNACADQdwJaiIMIAggBUEIaiAFQQxqIAEgAhD7ASIQECFFBEAgBSgCDCINIAdLDQEgA0GoBWohBiANIQQDQCAEIgJBf2ohBCAIIAJBAnRqKAIARQ0AC0EBIQFBACEEIAJBAWoiCkECTwRAA0AgCCABQQJ0IgtqKAIAIQ4gBiALaiAJNgIAIAkgDmohCSABIAJHIQsgAUEBaiEBIAsNAAsLIANB3AVqIQsgBiAJNgIAIAUoAggiAQRAA0AgBiAEIAxqLQAAIg5BAnRqIg8gDygCACIPQQFqNgIAIAsgD0EBdGoiDyAOOgABIA8gBDoAACAEQQFqIgQgAUcNAAsLQQAhASADQQA2AqgFIApBAk8EQCANQX9zIAdqIQZBASEEA0AgCCAEQQJ0IgxqKAIAIQ4gAyAMaiABNgIAIA4gBCAGanQgAWohASACIARHIQwgBEEBaiEEIAwNAAsLIA1BAWoiDSACayIBIAcgAWtBAWoiCEkEQCAKQQJJIQYDQEEBIQQgBkUEQANAIARBAnQiCiADIAFBNGxqaiADIApqKAIAIAF2NgIAIAIgBEchCiAEQQFqIQQgCg0ACwsgAUEBaiIBIAhJDQALCyAAQQRqIAcgCyAJIANBpAVqIAMgAiANEJYDIAVBAToABSAFIAc6AAYgACAFKAIENgIACyAQIQQLIAVBEGokACAEC+ACAQl/IwBBEGsiBCQAIARBADYCDCAEQQA2AggCQCADQUBrIgkgAyAEQQhqIARBDGogASACEPsBIggQIQ0AIARBBGogACgCABA0QQEhASAEKAIMIgUgBC0ABEEBak0EQEEAIQIgBEEAOgAFIAQgBToABiAAIAQoAgQ2AgAgBUEBakEBSwRAA0AgAyABQQJ0aiIGKAIAIQcgBiACNgIAIAcgAUF/anQgAmohAiABIAVGIQYgAUEBaiEBIAZFDQALCyAEKAIIIgdFDQEgAEEEaiEKIAVBAWohC0EAIQADQCADIAAgCWotAAAiBUECdGoiBigCACIBIAFBASAFdEEBdSIMaiICSQRAIAsgBWshBQNAIAogAUEBdGoiAiAFOgABIAIgADoAACABQQFqIgEgBigCACAMaiICSQ0ACwsgBiACNgIAIABBAWoiACAHRw0ACwwBC0FUIQgLIARBEGokACAICxQAIAAoAABBgPqerQNsQSAgAWt2CygAAkACQAJAIAAoAowBQX9qDgIAAQILIAAgARDCAw8LIAAgARDHAwsLOgEBfyABIAAoAgRrIgEgACgCGCICQYAIaksEQCAAIAEgASACa0GAeGoiAEGABCAAQYAESRtrNgIYCwsVACAAEJEBBEAgACgCBA8LIAAtAAsLRQEBfwJAIAIgA00gACABTXINAANAIABBf2oiAC0AACACQX9qIgItAABHDQEgBEEBaiEEIAIgA00NASAAIAFLDQALCyAECwwAIABBICABa62IpwsQACAAIAEgAigCCHRBA3RqCxIAIABBwAAgAWutiKdBACABGwsvAEEgIAFrIgEgAkkEQCAAp0F/IAJ0QX9zcQ8LIAAgASACa62Ip0F/IAJ0QX9zcQsgACACrSAAIAGtQgp8IAN+fULjyJW9y5vvjU9+fEIKfAsoAQF/IwBBEGsiAiQAIABBzA8gAkEIaiABEMYCEBs2AgAgAkEQaiQACxAAIAAgAjYCBCAAIAE2AgALGwAgACkAAEKAgOz8y5vvjU9+QcAAIAFrrYinCxsAIAApAABCgICA2Mub741PfkHAACABa62IpwsUACAAKAAAQbHz3fF5bEEgIAFrdgsNACAAKAIIQQh2QQFxCxAAIABCADcCACAAQgA3AggLUgEBfyAAKAIgIgIgAUkEQCACRQRAIAAgACgCCDYCEAsCQCABQQJJDQAgACAAKAIUQXxxIgI2AhQgAiAAKAIQTw0AIAAgAjYCEAsgACABNgIgCwtHAQF/IAAoAgwhAyAAIAIQ4QEgACgCFCABayIBIANJBEAgAEEBNgIYQQAPCyABIAAoAhBJBEAgACABNgIQCyAAIAE2AhQgAQsKACAAQQNqQXxxCw8AIAAgARDnASACQQNsTwsdAQF/IAAgACgCACAAKAIEayIBNgIQIAAgATYCDAsvACAAQQA2AhggACAAKAIINgIMIAAgACgCBDYCFCAAKAIgQQJPBEAgAEEBNgIgCwsHACABIABrCw0AIAAoAhAgACgCDEkLFQAgACABQX9qQQYgAUEHSxt2QQJqC8oBAQd/AkAgAUUNACAAKAIEIgMgACgCCCIGIAMgBksbIQgDQCADIAhGDQEgACgCACIJIANBDGxqIgUhBCABIAUoAgQiB00EQCAEIAcgAWs2AgQPCyAEQQA2AgQgASAHayIBIAUoAggiBEkEQCAFIAQgAWsiATYCCCABIAJPDQIgA0EBaiICIAZJBEAgCUEMaiADQQxsaiIDIAMoAgQgAWo2AgQLIAAgAjYCBA8LIAVBADYCCCAAIANBAWoiAzYCBCABIARrIgENAAsLC5gEAgx/AX4jAEEQayIIJAAgBCAFaiEJIAEoAoQBIQ8gASgCjAEgARDsARDzASELAkACQCAFQQFIDQAgACgCBCAAKAIITw0AIAlBYGohDANAIAggACAJIARrIgUgDxCmAyAIKAIAIg1FDQIgASAEENIBIAEgBBDRASABIAIgAyAEIAgoAgQiBSALEQIAIQYgAykCACESIAMgDTYCACADIBI3AgQgBCAFaiIKIAZrIQcgCCgCCCIQQX1qIQ4gAigCDCEEAkACQCAKIAxNBEAgBCAHEBwgAigCDCEEIAZBEE0EQCACIAQgBmo2AgwMAwsgBEEQaiAHQRBqIgUQHCAEQSBqIAdBIGoQHCAGQTFIDQEgBCAGaiERIARBMGohBANAIAQgBUEgaiIHEBwgBEEQaiAFQTBqEBwgByEFIARBIGoiBCARSQ0ACwwBCyAEIAcgCiAMECILIAIgAigCDCAGajYCDCAGQYCABEkNACACQQE2AiQgAiACKAIEIAIoAgBrQQN1NgIoCyACKAIEIgQgDUEDajYCACAEIAY7AQQgDkGAgARPBEAgAkECNgIkIAIgBCACKAIAa0EDdTYCKAsgBCAOOwEGIAIgBEEIajYCBCAKIBBqIgQgCU8NASAAKAIEIAAoAghJDQALCyAJIARrIQULIAEgBBDSASABIAQQ0QEgASACIAMgBCAFIAsRAgAhACAIQRBqJAAgAAtRAQJ/IwBBIGsiASQAIAEgACgCEDYCGCABIAApAgg3AxAgASAAKQIANwMIQQEhAiABQQhqEOgBRQRAIAAoAnBBAEdBAXQhAgsgAUEgaiQAIAILGwEBfyAAKAIQIAAoAgwiAUkEQCAAIAE2AhALCwwAIAAgACgCCDYCEAsRACABIAAoAgRrQYCAgIB6SwupAQEEfwJAIAEgACgCACIDRgRAIAAoAgwhAyAAKAIQIQUgACgCCCEEQQEhBgwBCyAAIAAoAgwiBTYCECAAIAAoAgQiBDYCCCAAIAMgBGsiAzYCDCAAIAEgA2s2AgQgAyAFa0EHSw0AIAAgAzYCECADIQULIAAgASACaiICNgIAIAIgBCAFak0gAyAEaiABTXJFBEAgACADIAIgBGsiACAAIANKGzYCEAsgBguRAwEGfyACKAIoIQYgAigCBCEJIAIoAiQhByACKAIgIgoEQCADQv8BViADQv+BBFZqIANC/v///w9WaiEIC0G6fyEFAkAgAUESSQ0AQQAgBEEARyAEQf8BS2ogBEH//wNLaiAGGyIGIAdBAEpBAnRqQSBBACAKQQBHQQEgCXStIANacSIBG3IgCEEGdHIhB0EAIQUgAigCAEUEQCAAQajqvmkQTUEEIQULIAAgBWogBzoAACAFQQFyIQUgAUUEQCAAIAVqIAlBA3RBsH9qOgAAIAVBAWohBQsCQAJAAkACQCAGQX9qDgMAAQIDCyAAIAVqIAQ6AAAgBUEBaiEFDAILIAAgBWogBEH//wNxEC8gBUECaiEFDAELIAAgBWogBBBNIAVBBGohBQsCQAJAAkACQCAIQX9qDgMBAgMACyABRQ0DIAAgBWogAzwAACAFQQFqDwsgACAFaiADp0GAfmpB//8DcRAvIAVBAmoPCyAAIAVqIAOnEE0gBUEEag8LIAAgBWogAzcAACAFQQhqIQULIAULHQAgAEEANgIkIAAgACgCCDYCDCAAIAAoAgA2AgQLFQAgAUEobCAAQQJ0akGQmQFqKAIACwoAIAAgAUEFS2sLAwABC00AIAAoAvAFIAAoApgDIAAoApwDIAAoAqADEGQgACgCgAYQ9wMgAEEANgKQBiAAQgA3A4gGIABCADcDgAYgAEIANwP4BSAAQgA3A/AFC0QBA38gAkEATgR/A0AgBCABIANBAnQiBGooAgAgACAEai0AAmxqIQQgAiADRyEFIANBAWohAyAFDQALIARBA3YFIAMLC6AEAQV/IwBBEGsiCyQAIAtB/wE2AgxBfyEJAkAgBUEDcQ0AIAFFBEBBACEJDAELQbh/IQkgA0GAgAhLDQAgACABaiEMAkAgB0EARyAIQQBHcSIIRQ0AIAcoAgBBAkcNACAAIAAgDCACIAMgBCAGEIEBIQkMAQsgBSALQQxqIAIgAyAFEIkEIgkQIQ0AIAMgCUYEQCAAIAItAAA6AABBASEJDAELIAkgA0EHdkEEak0hCkEAIQkgCg0AAkAgB0UNAAJAAkAgBygCACIJQQFGBEAgBiAFIAsoAgwQ+wMNASAHQQA2AgAMAwsgCUUNAiAIQQFzRQ0BDAILIAhFDQELIAAgACAMIAIgAyAEIAYQgQEhCQwBCyAFQYAIaiIIIAUgCygCDCIKQQsgAyAKQQEQgQIgBUGAEGoQ/wMiCRAhDQAgCkECdCINIAhqQQRqQQBB/AcgDWsQKBogACABIAggCiAJEIAEIgEQIQRAIAEhCQwBCwJAAkAgBwRAIAcoAgBFBEAgAUEMaiEFDAILIAYgBSAKEPcBIQkgCCAFIAoQ9wEhCiABQQxqIgUgA0lBACAJIAEgCmpLGw0BIAAgACAMIAIgAyAEIAYQgQEhCQwDC0EAIQkgAUEMaiADTw0CDAELQQAhCSAFIANPDQEgB0EANgIACyAGBEAgBiAIQYAIECoaCyAAIAAgAWogDCACIAMgBCAIEIEBIQkLIAtBEGokACAJCw0AIAAgAUECdGotAAILgAIBBn8jAEGQA2siBCQAIARBDDYCjAMCQCADQQJJDQAgBEEgaiAEQYwDaiACIAMQqgEiBSADRiEGIAVBAUYgAyAFRnINACAEQQYgAyAEKAKMAyIHEKcBIgggBEEgaiADIAcQpgEiBhAhDQAgACABIAQgByAIEKgBIgUQISIJBEAgBSEGDAELIARBoAFqIAQgByAIIARB4ABqQcAAEKkBIgYQIQ0AIAAgACAFaiAJGyIFIAAgAWogBWsiASACIAMgBEGgAWogAyADQQd2akEIaiABTRCGBCIBECEEQCABIQYMAQtBACEGIAFFDQAgASAFaiAAayEGCyAEQZADaiQAIAYLggQBBn8jAEGQAmsiCyQAQbh/IQgCQCAFRQ0AIAQsAAAiCUH/AXEhBgJAAkAgCUF/TARAIAZBgn9qQQF2IgkgBU8NA0FsIQggBkGBf2oiB0H/AUsNAyAHRQ0CIARBAWohBEEAIQUDQCAAIAVqIAQgBUEBdmoiBi0AAEEEdjoAACAAIAVBAXJqIAYtAABBD3E6AAAgBUECaiIFIAdJDQALIAkhBgwBCyAGIAVPDQIgACAEQQFqIAYgCxCBBCIHIQggBxAhDQILIAFCADcCAEEAIQQgAUEANgIwIAFCADcCKCABQgA3AiAgAUIANwIYIAFCADcCECABQgA3AghBbCEIIAdFDQFBACEFA0AgACAFaiIJLQAAIgpBC0sNAiABIApBAnRqIgogCigCAEEBajYCAEEBIAktAAB0QQF1IARqIQQgBUEBaiIFIAdHDQALIARFDQEgBBAkQQFqIgVBDEsNASADIAU2AgBBAUEBIAV0IARrIgMQJCIEdCADRw0BIAAgB2ogBEEBaiIAOgAAIAEgAEECdGoiACAAKAIAQQFqNgIAIAEoAgQiAEECSSAAQQFxcg0BIAIgB0EBajYCACAGQQFqIQgMAQsgAUIANwIAIAFBADYCMCABQgA3AiggAUIANwIgIAFCADcCGCABQgA3AhAgAUIANwIICyALQZACaiQAIAgLCAAgACABEE0LMQECfyAAEIQEIAAQOSAAKAIMIgIgACgCEEkEfyACIAAoAghrIAAoAgRBAEdqBSABCwtFAQF/IAAoAgQhASAAKAIMIAAoAgAQ/AEgACAAKAIMIAFBA3ZqNgIMIAAgACgCBEEHcTYCBCAAIAAoAgAgAUF4cXY2AgALLwAgACABNgIMIAAgATYCCCAAQgA3AgAgACABIAJqQXxqNgIQQbp/QQAgAkEFSRsLGgAgABAkQQFqIgAgARAkQQJqIgEgACABSRsLQQEBfyABQX9qECQhBCABIAIQgAIiASAEIANrIgIgACACIABJGyIAIAEgAEsbIgBBBSAAQQVLGyIAQQwgAEEMSRsL5AQBC38Cf0F/IANBAWoiDiADSQ0AGiAEQQFqIQ8gBEF7aiEHQQEgBHQiDEEBaiEKIAAgAWpBfmohDUEEIQEgACEIA0ACQAJAIAtFBEAgBiEEDAELAkAgBiIEIA5PDQADQCACIARBAXRqLwEADQEgAyAERiEJIARBAWohBCAJRQ0ACyAKIQkMAgsgBCAORgRAIAohCQwCCyAEIAZBGGoiCU8EQEH//wMgAXQhCwNAIAUgCCANTXJFBEBBun8PCyAIIAcgC2oiBjsAACAGQRB2IQcgCEECaiEIIAkiBkEYaiIQIQkgBCAQTw0ACwsgBCAGQQNqIglPBEADQEEDIAF0IAdqIQcgAUECaiEBIAQgCSIGQQNqIglPDQALCyAEIAZrIAF0IAdqIQcgAUEPSARAIAFBAmohAQwBCyAFIAggDU1yRQRAQbp/DwsgCCAHOwAAIAFBcmohASAHQRB2IQcgCEECaiEIC0F/IAIgBEEBdGouAQAiBkEAIAZrIAZBAEgbIApqIglBAUgNAhogASAPakEAIApBf3MgDEEBdGoiCyAGQQFqIgYgDEgbIAZqIgogC0hrIQYgCSAMSARAA0AgD0F/aiEPIAkgDEEBdSIMSA0ACwsgCiABdCAHaiEHIAZBEUgEfyAGBSAFIAggDU1yRQRAQbp/DwsgCCAHOwAAIAdBEHYhByAIQQJqIQggBkFwagshASAJQQJIDQAgCkEBRiELIAkhCiAEQQFqIgYgDkkNAQsLQX8gCUEBRw0AGiAFRQRAQbp/IAggDUsNARoLIAggBzsAACAIIAFBB2pBCG1qIABrCwvgBgEJfyABKAIAIQwgBUEAQYAgECghByADRQRAIABBACAMQQFqECgaIAFBADYCAEEADwsgB0GAGGohCCAHQYAQaiEJIAdBgAhqIQogAiADaiENAkAgA0EUSARAIAIhAwwBCyANQXFqIQ4gAkEEaiEFIAIoAAAhBgNAIAUoAAAhAyAHIAZB/wFxQQJ0aiIFIAUoAgBBAWo2AgAgCiAGQQZ2QfwHcWoiBSAFKAIAQQFqNgIAIAkgBkEOdkH8B3FqIgUgBSgCAEEBajYCACAIIAZBFnZB/AdxaiIFIAUoAgBBAWo2AgAgAigACCEFIAcgA0H/AXFBAnRqIgYgBigCAEEBajYCACAKIANBBnZB/AdxaiIGIAYoAgBBAWo2AgAgCSADQQ52QfwHcWoiBiAGKAIAQQFqNgIAIAggA0EWdkH8B3FqIgMgAygCAEEBajYCACACKAAMIQsgByAFQf8BcUECdGoiAyADKAIAQQFqNgIAIAogBUEGdkH8B3FqIgMgAygCAEEBajYCACAJIAVBDnZB/AdxaiIDIAMoAgBBAWo2AgAgCCAFQRZ2QfwHcWoiAyADKAIAQQFqNgIAIAJBEGoiAygAACEGIAcgC0H/AXFBAnRqIgUgBSgCAEEBajYCACAKIAtBBnZB/AdxaiIFIAUoAgBBAWo2AgAgCSALQQ52QfwHcWoiBSAFKAIAQQFqNgIAIAggC0EWdkH8B3FqIgUgBSgCAEEBajYCACACQRRqIQUgAyECIAUgDkkNAAsLIAMgDUkEQANAIAcgAy0AAEECdGoiAiACKAIAQQFqNgIAIANBAWoiAyANRw0ACwsCQCAERSAMQf8BIAwbIgJB/wFPcg0AQf8BIQMDQAJAIAcgA0ECdCIEaiIFIAUoAgAgBCAIaigCACAEIAlqKAIAIAQgCmooAgBqamoiBDYCACAEDQAgA0F/aiIDIAJLDQEMAgsLQVAPCyACQf8BIAJB/wFJGyEFQQAhA0EAIQYDQCAAIANBAnQiAmogAiAIaigCACACIAlqKAIAIAIgCmooAgAgAiAHaigCAGpqaiICNgIAIAIgBiACIAZLGyEGIAMgBUchAiADQQFqIQMgAg0ACwNAIAUiAkF/aiEFIAAgAkECdGooAgBFDQALIAEgAjYCACAGC4gDAgV/BX4gAEEoaiIBIAAoAkgiBWohAgJ+IAApAwAiBkIgWgRAIAApAxAiB0IHiSAAKQMIIghCAYl8IAApAxgiCUIMiXwgACkDICIKQhKJfCAIEIQBIAcQhAEgCRCEASAKEIQBDAELIAApAxhCxc/ZsvHluuonfAsgBnwhBgJAIAIgAEEwaiIESQRAIAEhAwwBCwNAQgAgASkAABBOIAaFQhuJQoeVr6+Ytt6bnn9+QuPcypX8zvL1hX98IQYgBCIDIgFBCGoiBCACTQ0ACwsCQCADQQRqIgEgAksEQCADIQEMAQsgAygAAK1Ch5Wvr5i23puef34gBoVCF4lCz9bTvtLHq9lCfkL5893xmfaZqxZ8IQYLIAEgAkkEQCAAIAVqQShqIQADQCABMQAAQsXP2bLx5brqJ34gBoVCC4lCh5Wvr5i23puef34hBiABQQFqIgEgAEcNAAsLIAZCIYggBoVCz9bTvtLHq9lCfiIGQh2IIAaFQvnz3fGZ9pmrFn4iBkIgiCAGhQv4AgICfwR+IAAgACkDACACrXw3AwACQAJAIAAoAkgiAyACakEfTQRAIAAgA2pBKGogASACEKsBIAAoAkggAmohAQwBCyABIAJqIQQCQAJ/IAMEQCAAQShqIgIgA2ogAUEgIANrEKsBIAAgACkDCCACKQAAEE43AwggACAAKQMQIAApADAQTjcDECAAIAApAxggACkAOBBONwMYIAAgACkDICAAQUBrKQAAEE43AyAgACgCSCECIABBADYCSCABIAJrQSBqIQELIAFBIGogBEsLBEAgASECDAELIARBYGohAyAAKQMgIQUgACkDGCEGIAApAxAhByAAKQMIIQgDQCAIIAEpAAAQTiEIIAcgASkACBBOIQcgBiABKQAQEE4hBiAFIAEpABgQTiEFIAFBIGoiAiEBIAIgA00NAAsgACAFNwMgIAAgBjcDGCAAIAc3AxAgACAINwMICyACIARPDQEgAEEoaiACIAQgAmsiARCrAQsgACABNgJICwtlACAAQgA3AyggAEL56tDQ58mh5OEANwMgIABCADcDGCAAQs/W077Sx6vZQjcDECAAQtbrgu7q/Yn14AA3AwggAEIANwMAIABCADcDMCAAQgA3AzggAEFAa0IANwMAIABCADcDSAsVACABBEAgAiAAIAERAwAPCyAAEEwLYQEDf0F+IQECQCAARQ0AIAAoAhwiAkUNACAAKAIkIgNFDQAgAigCNCIBBEAgACgCKCABIAMRBAAgACgCJCEDIAAoAhwhAgsgACgCKCACIAMRBABBACEBIABBADYCHAsgAQudCwEMfyACQQBOBEBBBEEDIAEvAQIiCxshB0EHQYoBIAsbIQQgAEG5LWohCEF/IQYDQCALIQkCQCAJIAEgDCINQQFqIgxBAnRqLwECIgtHIAVBAWoiAyAETnJFBEAgAyEFDAELAkAgAyAHSARAIAAgCUECdGoiBUH8FGohByAFQf4UaiEKIAAvAbgtIQQgACgCvC0hBQNAIAovAQAhBiAAIAQgBy8BACIOIAV0ciIEOwG4LSAAAn8gBUEQIAZrSgRAIAAgACgCFCIFQQFqNgIUIAUgACgCCGogBDoAACAAIAAoAhQiBUEBajYCFCAFIAAoAghqIAgtAAA6AAAgACAOQRAgACgCvC0iBWt2IgQ7AbgtIAUgBmpBcGoMAQsgBSAGagsiBTYCvC0gA0F/aiIDDQALDAELIAACfyAJBEACQCAGIAlGBEAgAC8BuC0hByAAKAK8LSEEIAMhBQwBCyAAIAlBAnRqIgZB/hRqLwEAIQMgACAALwG4LSAGQfwUai8BACIKIAAoArwtIgZ0ciIHOwG4LQJAIAZBECADa0oEQCAAIAAoAhQiBkEBajYCFCAGIAAoAghqIAc6AAAgACAAKAIUIgZBAWo2AhQgBiAAKAIIaiAILQAAOgAAIAMgACgCvC0iBmpBcGohBCAKQRAgBmt2IQcMAQsgAyAGaiEECyAAIAQ2ArwtCyAHIAAvAbwVIgYgBHRyIQcCQCAEQRAgAC8BvhUiA2tKBEAgACAHOwG4LSAAIAAoAhQiBEEBajYCFCAEIAAoAghqIAc6AAAgACAAKAIUIgRBAWo2AhQgBCAAKAIIaiAILQAAOgAAIAMgACgCvC0iB2pBcGohBCAGQRAgB2t2IQcMAQsgAyAEaiEECyAAIAQ2ArwtIAAgByAFQf3/A2pB//8DcSIFIAR0ciIDOwG4LSAEQQ9OBEAgACAAKAIUIgZBAWo2AhQgBiAAKAIIaiADOgAAIAAgACgCFCIDQQFqNgIUIAMgACgCCGogCC0AADoAACAAIAVBECAAKAK8LSIFa3Y7AbgtIAVBcmoMAgsgBEECagwBCyAFQQlMBEAgAC8BuC0gAC8BwBUiCiAAKAK8LSIDdHIhBwJAIANBECAALwHCFSIGa0oEQCAAIAc7AbgtIAAgACgCFCIDQQFqNgIUIAMgACgCCGogBzoAACAAIAAoAhQiA0EBajYCFCADIAAoAghqIAgtAAA6AAAgBiAAKAK8LSIDakFwaiEEIApBECADa3YhBwwBCyADIAZqIQQLIAAgBDYCvC0gACAHIAVB/v8DakH//wNxIgUgBHRyIgM7AbgtIARBDk4EQCAAIAAoAhQiBkEBajYCFCAGIAAoAghqIAM6AAAgACAAKAIUIgNBAWo2AhQgAyAAKAIIaiAILQAAOgAAIAAgBUEQIAAoArwtIgVrdjsBuC0gBUFzagwCCyAEQQNqDAELIAAvAbgtIAAvAcQVIgogACgCvC0iA3RyIQcCQCADQRAgAC8BxhUiBmtKBEAgACAHOwG4LSAAIAAoAhQiA0EBajYCFCADIAAoAghqIAc6AAAgACAAKAIUIgNBAWo2AhQgAyAAKAIIaiAILQAAOgAAIAYgACgCvC0iA2pBcGohBCAKQRAgA2t2IQcMAQsgAyAGaiEECyAAIAQ2ArwtIAAgByAFQfb/A2pB//8DcSIFIAR0ciIDOwG4LSAEQQpOBEAgACAAKAIUIgZBAWo2AhQgBiAAKAIIaiADOgAAIAAgACgCFCIDQQFqNgIUIAMgACgCCGogCC0AADoAACAAIAVBECAAKAK8LSIFa3Y7AbgtIAVBd2oMAQsgBEEHags2ArwtC0EAIQUCfyALRQRAQYoBIQRBAwwBC0EGQQcgCSALRiIDGyEEQQNBBCADGwshByAJIQYLIAIgDUcNAAsLC7kCAQx/IAEvAQIhBiACQQJ0IAFqQf//AzsBBiACQQBOBEBBB0GKASAGGyEIQQRBAyAGGyEHIABBwBVqIQsgAEHEFWohDCAAQbwVaiENQX8hCQNAIAYhBAJAIAQgASAKIg5BAWoiCkECdGovAQIiBkcgA0EBaiIFIAhOckUEQCAFIQMMAQsCfyAFIAdIBEAgACAEQQJ0akH8FGoiAy8BACAFagwBCyAEBEAgBCAJRwRAIAAgBEECdGpB/BRqIgMgAy8BAEEBajsBAAsgDSIDLwEAQQFqDAELIANBCUwEQCALIgMvAQBBAWoMAQsgDCIDLwEAQQFqCyEFIAMgBTsBAEEAIQMCfyAGRQRAQQMhB0GKAQwBC0EDQQQgBCAGRiIFGyEHQQZBByAFGwshCCAEIQkLIAIgDkcNAAsLC+EIAQp/AkAgACgCoC1FBEAgAC8BuC0hBSAAKAK8LSEEDAELIABBuS1qIQgDQCADQQFqIQogACgCmC0gA2otAAAhBQJAIAACfyAAKAKkLSADQQF0ai8BACIJRQRAIAEgBUECdGoiBC8BAiEDIAAgAC8BuC0gBC8BACIHIAAoArwtIgR0ciIFOwG4LSAEQRAgA2tKBEAgACAAKAIUIgRBAWo2AhQgBCAAKAIIaiAFOgAAIAAgACgCFCIEQQFqNgIUIAQgACgCCGogCC0AADoAACAAIAdBECAAKAK8LSIEa3YiBTsBuC0gAyAEakFwagwCCyADIARqDAELIAVBoOUAai0AACILQQJ0IgdBgAhyIAFqIgQvAQYhAyAAIAAvAbgtIAQvAQQiDCAAKAK8LSIGdHIiBDsBuC0gAAJ/IAZBECADa0oEQCAAIAAoAhQiBkEBajYCFCAGIAAoAghqIAQ6AAAgACAAKAIUIgRBAWo2AhQgBCAAKAIIaiAILQAAOgAAIAAgDEEQIAAoArwtIgZrdiIEOwG4LSADIAZqQXBqDAELIAMgBmoLIgM2ArwtIAtBeGpBE00EQCAAIAQgBSAHQaDnAGooAgBrQf//A3EiBiADdHIiBDsBuC0gAAJ/IANBECAHQYDkAGooAgAiBWtKBEAgACAAKAIUIgNBAWo2AhQgAyAAKAIIaiAEOgAAIAAgACgCFCIDQQFqNgIUIAMgACgCCGogCC0AADoAACAAIAZBECAAKAK8LSIDa3YiBDsBuC0gAyAFakFwagwBCyADIAVqCyIDNgK8LQsgAiAJQX9qIgcgB0EHdkGAAmogB0GAAkkbQaDoAGotAAAiC0ECdCIJaiIFLwECIQYgACAEIAUvAQAiDCADdHIiBTsBuC0gAAJ/IANBECAGa0oEQCAAIAAoAhQiA0EBajYCFCADIAAoAghqIAU6AAAgACAAKAIUIgNBAWo2AhQgAyAAKAIIaiAILQAAOgAAIAAgDEEQIAAoArwtIgNrdiIFOwG4LSADIAZqQXBqDAELIAMgBmoLIgQ2ArwtIAtBBEkNASAAIAUgByAJQaDsAGooAgBrQf//A3EiByAEdHIiBTsBuC0gBEEQIAlBgNoAaigCACIDa0oEQCAAIAAoAhQiBEEBajYCFCAEIAAoAghqIAU6AAAgACAAKAIUIgRBAWo2AhQgBCAAKAIIaiAILQAAOgAAIAAgB0EQIAAoArwtIgRrdiIFOwG4LSADIARqQXBqDAELIAMgBGoLIgQ2ArwtCyAKIgMgACgCoC1JDQALCyABQYIIai8BACECIAAgBSABLwGACCIBIAR0ciIDOwG4LSAEQRAgAmtKBEAgACAAKAIUIgpBAWo2AhQgCiAAKAIIaiADOgAAIAAgACgCFCIDQQFqNgIUIAMgACgCCGogAEG5LWotAAA6AAAgACABQRAgACgCvC0iAWt2OwG4LSAAIAEgAmpBcGo2ArwtDwsgACACIARqNgK8LQuXAQECfwJAAn8gACgCvC0iAUEJTgRAIAAgACgCFCIBQQFqNgIUIAEgACgCCGogAC0AuC06AAAgACAAKAIUIgFBAWo2AhQgAEG5LWotAAAhAiABIAAoAghqDAELIAFBAUgNASAAIAAoAhQiAUEBajYCFCAALQC4LSECIAEgACgCCGoLIAI6AAALIABBADYCvC0gAEEAOwG4LQvaBAEBfwNAIAAgAUECdGpBADsBlAEgAUEBaiIBQZ4CRw0ACyAAQQA7AfwUIABBADsBiBMgAEHEFWpBADsBACAAQcAVakEAOwEAIABBvBVqQQA7AQAgAEG4FWpBADsBACAAQbQVakEAOwEAIABBsBVqQQA7AQAgAEGsFWpBADsBACAAQagVakEAOwEAIABBpBVqQQA7AQAgAEGgFWpBADsBACAAQZwVakEAOwEAIABBmBVqQQA7AQAgAEGUFWpBADsBACAAQZAVakEAOwEAIABBjBVqQQA7AQAgAEGIFWpBADsBACAAQYQVakEAOwEAIABBgBVqQQA7AQAgAEH8E2pBADsBACAAQfgTakEAOwEAIABB9BNqQQA7AQAgAEHwE2pBADsBACAAQewTakEAOwEAIABB6BNqQQA7AQAgAEHkE2pBADsBACAAQeATakEAOwEAIABB3BNqQQA7AQAgAEHYE2pBADsBACAAQdQTakEAOwEAIABB0BNqQQA7AQAgAEHME2pBADsBACAAQcgTakEAOwEAIABBxBNqQQA7AQAgAEHAE2pBADsBACAAQbwTakEAOwEAIABBuBNqQQA7AQAgAEG0E2pBADsBACAAQbATakEAOwEAIABBrBNqQQA7AQAgAEGoE2pBADsBACAAQaQTakEAOwEAIABBoBNqQQA7AQAgAEGcE2pBADsBACAAQZgTakEAOwEAIABBlBNqQQA7AQAgAEGQE2pBADsBACAAQYwTakEAOwEAIABCADcCrC0gAEGUCWpBATsBACAAQQA2AqgtIABBADYCoC0LngEBAn8gACAALwG4LSADQf//A3EiBCAAKAK8LSIDdHIiBTsBuC0gAAJ/IANBDk4EQCAAIAAoAhQiA0EBajYCFCADIAAoAghqIAU6AAAgACAAKAIUIgNBAWo2AhQgAyAAKAIIaiAAQbktai0AADoAACAAIARBECAAKAK8LSIDa3Y7AbgtIANBc2oMAQsgA0EDags2ArwtIAAgASACEJoEC5cEARB/IAAoAnwiBCAEQQJ2IAAoAngiBCAAKAKMAUkbIQlBACAAKAJsIgIgACgCLGtBhgJqIgMgAyACSxshDCAAKAJ0IgcgACgCkAEiAyADIAdLGyENIAAoAjgiDiACaiIFQYICaiEPIAQgBWoiAi0AACEKIAJBf2otAAAhCyAAKAI0IRAgACgCQCERA0ACQAJAIAEgDmoiAyAEaiICLQAAIApHDQAgAkF/ai0AACALRw0AIAMtAAAgBS0AAEcNAEECIQYgAy0AASAFLQABRw0AA0ACQCAFIAZqIgItAAEgAy0AA0cEQCACQQFqIQIMAQsgAi0AAiADLQAERwRAIAJBAmohAgwBCyACLQADIAMtAAVHBEAgAkEDaiECDAELIAItAAQgAy0ABkcEQCACQQRqIQIMAQsgAi0ABSADLQAHRwRAIAJBBWohAgwBCyACLQAGIAMtAAhHBEAgAkEGaiECDAELIAItAAcgAy0ACUcEQCACQQdqIQIMAQsgBkH5AUshCCAFIAZBCGoiBmohAiAIDQAgAy0ACiEIIANBCGohAyACLQAAIAhGDQELCyACIA9rIgNBggJqIgIgBEwNACAAIAE2AnAgAiANTgRAIAIhBAwCCyACIAVqLQAAIQogAyAFai0AgQIhCyACIQQLIAwgESABIBBxQQF0ai8BACIBTw0AIAlBf2oiCQ0BCwsgByAEIAQgB0sbC+BGATF/IwBBsIAEayIZJAAgAygCACELIANBADYCACACIARqIjdBe2ogNyAHQQJGIjsbITIgAiEdAn8CQCALIAEiJ2oiOEF0aiI5ICdJDQAgBkH/HyAGQf8fSRshOiA4QXtqIhpBf2ohLyAaQX1qISYgASEeA0AgACgCkIAQIg1BgIAEaiAeIAAoAoSAECIfayIOSyEMIB8gACgCjIAQIhtqIRwgACgCiIAQISogACgCnIAQISsgHigAACEiIAAoApSAECIGIA5JBEADQCAAIAZB//8DcUEBdGpBgIAIaiAGIAAgBiAfahA6QQJ0aiILKAIAayIEQf//AyAEQf//A0kbOwEAIAsgBjYCACAGQQFqIgYgDkkNAAsLIA0gDkGBgHxqIAwbISwgHiAnayEXIAAgDjYClIAQICJB//8DcSAiQRB2RiAiQf8BcSAiQRh2RnEhJSAbICpqITAgHEEEaiESIB5BCGohLiAeQQRqIRMgHkF/aiEWIAAgHhA6QQJ0IiBqKAIAIRRBAyEMQQAhD0EAIS1BACENQQAhESAFISQDQAJAICRFIBQgLElyDQBBACEQAkAgCkEAIA4gFGtBCEkbDQACQAJ/AkACQCAbIBRNBEAgDCAWai8AACAUIB9qIhggDGpBf2ovAABHDQUgIiAYKAAARw0FIBhBBGohBiAmIBNNBH8gEwUgBigAACATKAAAcyIEDQIgBkEEaiEGIC4LIgQgJkkEQANAIAYoAAAgBCgAAHMiCwRAIAsQJSAEaiATayEGDAcLIAZBBGohBiAEQQRqIgQgJkkNAAsLAkAgBCAvTw0AIAYvAAAgBC8AAEcNACAGQQJqIQYgBEECaiEECyAEIBpJBH8gBEEBaiAEIAYtAAAgBC0AAEYbBSAECyATayEGDAQLICIgFCAqaiIEKAAARw0EIARBBGohBgJ/IBMgGiAeIBsgFGtqIhUgFSAaSxsiC0F9aiIYIBNNDQAaIAYoAAAgEygAAHMiBA0CIAZBBGohBiAuCyIEIBhJBEADQCAGKAAAIAQoAABzIhAEQCAQECUgBGogE2sMBQsgBkEEaiEGIARBBGoiBCAYSQ0ACwsCQCAEIAtBf2pPDQAgBi8AACAELwAARw0AIAZBAmohBiAEQQJqIQQLIAQgC0kEfyAEQQFqIAQgBi0AACAELQAARhsFIAQLIBNrDAILIAQQJSEGDAILIAQQJQshBCAUIB9qIA8CfyAEQQRqIhAgHmogC0cgFSAaT3JFBEAgHCEEAn8CQCAmIAsiBksEQCAcKAAAIAsoAABzIgQNASALQQRqIQYgEiEECyAGICZJBEADQCAEKAAAIAYoAABzIg8EQCAPECUgBmogC2sMBAsgBEEEaiEEIAZBBGoiBiAmSQ0ACwsCQCAGIC9PDQAgBC8AACAGLwAARw0AIARBAmohBCAGQQJqIQYLIAYgGkkEfyAGQQFqIAYgBC0AACAGLQAARhsFIAYLIAtrDAELIAQQJQsgEGohEAsgECAMSiIECxshDyAQIAwgBBshDAwBCyAGQQRqIhAgDCAQIAxKIgQbIQwgGCAPIAQbIQ8LICRBf2ohJAJAAkAgDCAQRyAMIBRqIA5LciAQQQRIcg0AIBBBfWohFUEAIQZBECELQQEhBANAIAAgBiAUakH//wNxQQF0akGAgAhqLwEAIhggBCAEIBhJIjEbIQQgBiARIDEbIREgC0EEdSEYQRAgC0EBaiAxGyELIAYgGGoiBiAVSA0ACyAUQQAgBCAUIARJIgYbQQAgBEEBSyIEG2shFCAERQ0AQQNBAiAGGyEGIBAhDAwBCwJAIBENACAAIBRB//8DcUEBdGpBgIAIai8BAEEBRw0AIA1FBEBBASENICVFDQEgEyAaICIQM0EEaiEtQQIhDQsgDUECRyAUQX9qIhggLElyDQBBAiENIBsgGBAyRQ0AICIgKiAfIBggG0kiBBsgGGoiECgAAEcNACAQQQRqIDAgGiAEGyIGICIQM0EEaiELICogACgCkIAQIgRqIRQCQCAYIBtJBEAgBiALIBBqRgRAIBwgGiALICIQPRAzIAtqIQsLIBAgFCAiEDEhDQwBCyAQIBAgHCAiEDEiDWsgHEcgBCAbT3INACAwIBRBACANayAiED0QMSANaiENCyAYIBggDWsiBCAsIAQgLEsbIhRrIAtqIgQgLUkgCyAtS3JFBEAgCyAYIC1raiIEIBsgGyAEEDIbIRRBACERQQIhBkECIQ0MAgtBACERQQIhBiAbIBQQMkUEQEECIQ0gGyEUDAILAkAgDCAEIC0gBCAtSRsiC08EQCAPIQ0gDCELDAELIB4gFCAfaiINa0H//wNKDQMLIBQgACAUQf//A3FBAXRqQYCACGovAQAiBEkEQCANIQ8gCyEMDAMLIBQgBGshFCANIQ9BAiENIAshDAwBCyAUIAAgESAUakH//wNxQQF0akGAgAhqLwEAayEUQQAhBgsgBkEDRw0BCwsCQCAkRSAJQQFHIA4gLGtB/v8DS3JyDQAgDiAgICtqKAIAIhEgLGogKygCgIAQICsoAoSAECISayINayIUa0H//wNLDQADQCAkRQ0BICIgESASaiIEKAAARgRAIARBBGohBgJ/AkACfyATIBogHiANIBFraiIEIAQgGksbIhxBfWoiECATTQ0AGiAGKAAAIBMoAABzIgQNASAGQQRqIQYgLgsiBCAQSQRAA0AgBigAACAEKAAAcyILBEAgCxAlIARqIBNrDAQLIAZBBGohBiAEQQRqIgQgEEkNAAsLAkAgBCAcQX9qTw0AIAYvAAAgBC8AAEcNACAGQQJqIQYgBEECaiEECyAEIBxJBH8gBEEBaiAEIAYtAAAgBC0AAEYbBSAECyATawwBCyAEECULQQRqIgQgDCAEIAxKIgQbIQwgFCAfaiAPIAQbIQ8LICRBf2ohJCARICsgEUH//wNxQQF0akGAgAhqLwEAIgRrIREgDiAUIARrIhRrQYCABEkNAAsLAkACQAJ/AkACQCAMQQROBEAgHiAPayEPQRIgDCAMQW1qQRJJGyAMIAobIhwgOksNASAXQQ5KIgsNAiAXQQFqIQYgFwwDCyAeQQFqIR4MAwsgBwRAIB0gF0H/AW5qIBdqQQlqIDJLDQQLIB1BAWohBgJAIBdBD08EQCAdQfABOgAAIBdBcWoiBEH/AU8EQCAGQf8BIB4gJ2tB8n1qIgRB/wFuIgZBAWoQKBogBkGBfmwgBGohBCAGIB1qQQJqIQYLIAYgBDoAACAGQQFqIQYMAQsgHSAXQQR0OgAACyAGICcgBiAXaiIEEDsgBCAPQf//A3EQLyAcQXxqIQwgBEECaiEEIAcEQCAEIAxB/wFuakEGaiAySw0ECyAdLQAAIQsgDEEPTwRAIB0gC0EPajoAACAcQW1qIgtB/gNPBEAgBEH/ASAcQe97aiIMQf4DbiILQQF0IgRBAmoQKBogC0GCfGwgDGohCyAGIAQgHmogJ2tqQQRqIQQLIAtB/wFPBEAgBEH/AToAACALQYF+aiELIARBAWohBAsgBCALOgAAIARBAWohHSAcIB5qIh4hJwwDCyAdIAsgDGo6AAAgHCAeaiIeIScgBCEdDAILIBdBAWoiBiAXQXFqQf8BbWoLIQQgGSAXNgIMIBlCgICAgBA3AgQgGSAENgIAIAYiBEEOSgRAIAYgBkFxakH/AW1qQQFqIQQLIBkgBjYCHCAZQoCAgIAQNwIUIBkgBDYCECAXQQJqIQQCfwJAIBdBDU4EQCAZIAQ2AiwgGUKAgICAEDcCJCAZIBdBA2oiDSAXQXNqQf8BbWo2AiAMAQsgGSAENgIsIBlCgICAgBA3AiQgGSAENgIgIBdBA2oiDSAXQQxHDQEaCyAXIBdBdGpB/wFtakEEagshBCAZIA02AjwgGUKAgICAEDcCNCAZIAQ2AjAgBiAXQXFqQf8BbWogFyALG0EDaiEEQQQhBgNAIAQhCyAGQRNPBEAgBkFtakH/AW0gBGpBAWohCwsgGSAGQQR0aiIMIBc2AgwgDCAPNgIEIAwgBjYCCCAMIAs2AgAgBiAcRyELIAZBAWohBiALDQALQQEhFCAZIBxBBHRqIgZBATYCHCAGQoCAgIAQNwIUIAZCgICAgBA3AiQgBkECNgIsIAZBAzYCPCAGQoCAgIAQNwI0IAYgBigCACIEQQFqNgIQIAYgBEECajYCICAGIARBA2o2AjACQANAIB4gFCIYaiIhIDlNBEAgGSAYQQR0IgRqIjQoAgAhMyAZIBhBAWoiFEEEdGoiNSgCACE2AkACQAJAIAgEQCA2IDNMBEAgBCAZakFAaygCACAzQQNqSA0ECyAAKAKQgBAiDEGAgARqICEgH2siIEshCyAfIAAoAoyAECITaiEbICEoAAAhIyAOICBJBEADQCAAIA5B//8DcUEBdGpBgIAIaiAOIAAgDiAfahA6QQJ0aiIGKAIAayIEQf//AyAEQf//A0kbOwEAIAYgDjYCACAOQQFqIg4gIEkNAAsLIAwgIEGBgHxqIAsbIRcgACAgNgKUgBAgI0H//wNxICNBEHZGICNB/wFxICNBGHZGcSEuIBMgKmohLCAbQQRqIQ8gIUEIaiEiICFBBGohFSAhQX9qITAgACAhEDpBAnQiMWooAgAhDkEDIQxBACESQQAhKUEAIQ1BACERIAUhJANAAkAgJEUgDiAXSXINAEEAIRACQCAKQQAgICAOa0EISRsNAAJAAn8CQAJAIBMgDk0EQCAMIDBqLwAAIA4gH2oiFiAMakF/ai8AAEcNBSAjIBYoAABHDQUgFkEEaiEGICYgFU0EfyAVBSAGKAAAIBUoAABzIgQNAiAGQQRqIQYgIgsiBCAmSQRAA0AgBigAACAEKAAAcyILBEAgCxAlIARqIBVrIQYMBwsgBkEEaiEGIARBBGoiBCAmSQ0ACwsCQCAEIC9PDQAgBi8AACAELwAARw0AIAZBAmohBiAEQQJqIQQLIAQgGkkEfyAEQQFqIAQgBi0AACAELQAARhsFIAQLIBVrIQYMBAsgIyAOICpqIgQoAABHDQQgBEEEaiEGAn8gFSAaICEgEyAOa2oiJSAlIBpLGyILQX1qIhYgFU0NABogBigAACAVKAAAcyIEDQIgBkEEaiEGICILIgQgFkkEQANAIAYoAAAgBCgAAHMiEARAIBAQJSAEaiAVawwFCyAGQQRqIQYgBEEEaiIEIBZJDQALCwJAIAQgC0F/ak8NACAGLwAAIAQvAABHDQAgBkECaiEGIARBAmohBAsgBCALSQR/IARBAWogBCAGLQAAIAQtAABGGwUgBAsgFWsMAgsgBBAlIQYMAgsgBBAlCyEEIA4gH2ogEgJ/ICEgBEEEaiIQaiALRyAlIBpPckUEQCAbIQQCfwJAICYgCyIGSwRAIBsoAAAgCygAAHMiBA0BIAtBBGohBiAPIQQLIAYgJkkEQANAIAQoAAAgBigAAHMiEgRAIBIQJSAGaiALawwECyAEQQRqIQQgBkEEaiIGICZJDQALCwJAIAYgL08NACAELwAAIAYvAABHDQAgBEECaiEEIAZBAmohBgsgBiAaSQR/IAZBAWogBiAELQAAIAYtAABGGwUgBgsgC2sMAQsgBBAlCyAQaiEQCyAQIAxKIgQLGyESIBAgDCAEGyEMDAELIAZBBGoiECAMIBAgDEoiBBshDCAWIBIgBBshEgsgJEF/aiEkAkACQCAMIBBHIAwgDmogIEtyIBBBBEhyDQAgEEF9aiElQQAhBkEQIQtBASEEA0AgACAGIA5qQf//A3FBAXRqQYCACGovAQAiFiAEIAQgFkkiLRshBCAGIBEgLRshESALQQR1IRZBECALQQFqIC0bIQsgBiAWaiIGICVIDQALIA5BACAEIA4gBEkiBhtBACAEQQFLIgQbayEOIARFDQBBA0ECIAYbIQYgECEMDAELAkAgEQ0AIAAgDkH//wNxQQF0akGAgAhqLwEAQQFHDQAgDUUEQEEBIQ0gLkUNASAVIBogIxAzQQRqISlBAiENCyANQQJHIA5Bf2oiFiAXSXINAEECIQ0gEyAWEDJFDQAgIyAqIB8gFiATSSIEGyAWaiIQKAAARw0AIBBBBGogLCAaIAQbIgYgIxAzQQRqIQsgKiAAKAKQgBAiBGohDgJAIBYgE0kEQCAGIAsgEGpGBEAgGyAaIAsgIxA9EDMgC2ohCwsgECAOICMQMSENDAELIBAgECAbICMQMSINayAbRyAEIBNPcg0AICwgDkEAIA1rICMQPRAxIA1qIQ0LIBYgFiANayIEIBcgBCAXSxsiDmsgC2oiBCApSSALIClLckUEQCALIBYgKWtqIgQgEyATIAQQMhshDkEAIRFBAiEGQQIhDQwCC0EAIRFBAiEGIBMgDhAyRQRAQQIhDSATIQ4MAgsCQCAMIAQgKSAEIClJGyILTwRAIBIhDSAMIQsMAQsgISAOIB9qIg1rQf//A0oNAwsgDiAAIA5B//8DcUEBdGpBgIAIai8BACIESQRAIA0hEiALIQwMAwsgDiAEayEOIA0hEkECIQ0gCyEMDAELIA4gACAOIBFqQf//A3FBAXRqQYCACGovAQBrIQ5BACEGCyAGQQNHDQELCwJAICRFIAlBAUcgICAXa0H+/wNLcnINACAgICsgMWooAgAiESAXaiArKAKAgBAgKygChIAQIg9rIg1rIg5rQf//A0sNAANAICRFDQEgIyAPIBFqIgQoAABGBEAgBEEEaiEGAn8CQAJ/IBUgGiAhIA0gEWtqIgQgBCAaSxsiG0F9aiIQIBVNDQAaIAYoAAAgFSgAAHMiBA0BIAZBBGohBiAiCyIEIBBJBEADQCAGKAAAIAQoAABzIgsEQCALECUgBGogFWsMBAsgBkEEaiEGIARBBGoiBCAQSQ0ACwsCQCAEIBtBf2pPDQAgBi8AACAELwAARw0AIAZBAmohBiAEQQJqIQQLIAQgG0kEfyAEQQFqIAQgBi0AACAELQAARhsFIAQLIBVrDAELIAQQJQtBBGoiBCAMIAQgDEoiBBshDCAOIB9qIBIgBBshEgsgJEF/aiEkIBEgKyARQf//A3FBAXRqQYCACGovAQAiBGshESAgIA4gBGsiDmtBgIAESQ0ACwsgDEEESA0CQRIgDCAMQW1qQRJJGyAMIAobIQ8gISASayEODAELIDYgM0wNAiAAKAKQgBAiDEGAgARqICEgH2siIEshCyAfIAAoAoyAECITaiEbICEoAAAhKCAOICBJBEADQCAAIA5B//8DcUEBdGpBgIAIaiAOIAAgDiAfahA6QQJ0aiIGKAIAayIEQf//AyAEQf//A0kbOwEAIAYgDjYCACAOQQFqIg4gIEkNAAsLIAwgIEGBgHxqIAsbISMgACAgNgKUgBAgKEH//wNxIChBEHZGIChB/wFxIChBGHZGcSEtIBMgKmohIiAbQQRqISQgIUEIaiEXICFBBGohFSAhQX9qIS4gACAhEDpBAnQiMGooAgAhDkEAIRJBACEpQQAhDUEAIREgBSEQIBwgGGsiMSEPA0ACQCAQRSAOICNJcg0AQQAhDAJAIApBACAgIA5rQQhJGw0AAkACfwJAAkAgEyAOTQRAIA8gLmovAAAgDiAfaiIWIA9qQX9qLwAARw0FICggFigAAEcNBSAWQQRqIQYgJiAVTQR/IBUFIAYoAAAgFSgAAHMiBA0CIAZBBGohBiAXCyIEICZJBEADQCAGKAAAIAQoAABzIgsEQCALECUgBGogFWshBgwHCyAGQQRqIQYgBEEEaiIEICZJDQALCwJAIAQgL08NACAGLwAAIAQvAABHDQAgBkECaiEGIARBAmohBAsgBCAaSQR/IARBAWogBCAGLQAAIAQtAABGGwUgBAsgFWshBgwECyAoIA4gKmoiBCgAAEcNBCAEQQRqIQYCfyAVIBogISATIA5raiIlICUgGksbIgtBfWoiFiAVTQ0AGiAGKAAAIBUoAABzIgQNAiAGQQRqIQYgFwsiBCAWSQRAA0AgBigAACAEKAAAcyIMBEAgDBAlIARqIBVrDAULIAZBBGohBiAEQQRqIgQgFkkNAAsLAkAgBCALQX9qTw0AIAYvAAAgBC8AAEcNACAGQQJqIQYgBEECaiEECyAEIAtJBH8gBEEBaiAEIAYtAAAgBC0AAEYbBSAECyAVawwCCyAEECUhBgwCCyAEECULIQQgDiAfaiASAn8gISAEQQRqIgxqIAtHICUgGk9yRQRAIBshBAJ/AkAgJiALIgZLBEAgGygAACALKAAAcyIEDQEgC0EEaiEGICQhBAsgBiAmSQRAA0AgBCgAACAGKAAAcyISBEAgEhAlIAZqIAtrDAQLIARBBGohBCAGQQRqIgYgJkkNAAsLAkAgBiAvTw0AIAQvAAAgBi8AAEcNACAEQQJqIQQgBkECaiEGCyAGIBpJBH8gBkEBaiAGIAQtAAAgBi0AAEYbBSAGCyALawwBCyAEECULIAxqIQwLIAwgD0oiBAsbIRIgDCAPIAQbIQ8MAQsgBkEEaiIMIA8gDCAPSiIEGyEPIBYgEiAEGyESCyAQQX9qIRACQAJAIAwgD0cgDiAPaiAgS3IgDEEESHINACAMQX1qISVBACEGQRAhC0EBIQQDQCAAIAYgDmpB//8DcUEBdGpBgIAIai8BACIWIAQgBCAWSSIsGyEEIAYgESAsGyERIAtBBHUhFkEQIAtBAWogLBshCyAGIBZqIgYgJUgNAAsgDkEAIAQgDiAESSIGG0EAIARBAUsiBBtrIQ4gBEUNAEEDQQIgBhshBiAMIQ8MAQsCQCARDQAgACAOQf//A3FBAXRqQYCACGovAQBBAUcNACANRQRAQQEhDSAtRQ0BIBUgGiAoEDNBBGohKUECIQ0LIA1BAkcgDkF/aiIlICNJcg0AQQIhDSATICUQMkUNACAoICogHyAlIBNJIgQbICVqIhYoAABHDQAgFkEEaiAiIBogBBsiBiAoEDNBBGohCyAqIAAoApCAECIEaiEMAkAgJSATSQRAIAYgCyAWakYEQCAbIBogCyAoED0QMyALaiELCyAWIAwgKBAxIQ0MAQsgFiAWIBsgKBAxIg1rIBtHIAQgE09yDQAgIiAMQQAgDWsgKBA9EDEgDWohDQsgJSAlIA1rIgQgIyAEICNLGyIMayALaiIEIClJIAsgKUtyRQRAIAsgJSApa2oiBCATIBMgBBAyGyEOQQAhEUECIQZBAiENDAILQQAhEUECIQYgEyAMEDJFBEBBAiENIBMhDgwCCwJAIA8gBCApIAQgKUkbIgtPBEAgEiENIA8hCwwBCyAhIAwgH2oiDWtB//8DSg0DCyAMIAAgDEH//wNxQQF0akGAgAhqLwEAIgRJBEAgDSESIAshDwwDCyAMIARrIQ4gDSESQQIhDSALIQ8MAQsgDiAAIA4gEWpB//8DcUEBdGpBgIAIai8BAGshDkEAIQYLIAZBA0cNAQsLAkAgEEUgCUEBRyAgICNrQf7/A0tycg0AICAgKyAwaigCACIRICNqICsoAoCAECArKAKEgBAiDWsiDGsiDmtB//8DSw0AA0AgEEUNASAoIA0gEWoiBCgAAEYEQCAEQQRqIQYCfwJAAn8gFSAaICEgDCARa2oiBCAEIBpLGyIbQX1qIiQgFU0NABogBigAACAVKAAAcyIEDQEgBkEEaiEGIBcLIgQgJEkEQANAIAYoAAAgBCgAAHMiCwRAIAsQJSAEaiAVawwECyAGQQRqIQYgBEEEaiIEICRJDQALCwJAIAQgG0F/ak8NACAGLwAAIAQvAABHDQAgBkECaiEGIARBAmohBAsgBCAbSQR/IARBAWogBCAGLQAAIAQtAABGGwUgBAsgFWsMAQsgBBAlC0EEaiIEIA8gBCAPSiIEGyEPIA4gH2ogEiAEGyESCyAQQX9qIRAgESArIBFB//8DcUEBdGpBgIAIai8BACIEayERICAgDiAEayIOa0GAgARJDQALCyAPIDFMDQEgISASayEOIApFIA9BbWpBEk9yRQRAQRIhDwwBCyAPRQ0BCyAPIDpLBEAgFCEcDAULIA8gGGpB/x9KBEAgFCEcDAULIDMgNCgCDCINQQFqIgYgDUFxakH/AW1qIA0gDUEOShtrIQwgBiIEQQ5KBH8gDSANQXJqQf8BbWpBAmoFIAQLIAxqIgQgNkgEQCA1IAY2AgwgNUKAgICAEDcCBCA1IAQ2AgALIA1BAmoiBiEEIA1BDEoEfyANIA1Bc2pB/wFtakEDagUgBAsgDGoiBCAZIBhBAmpBBHRqIgsoAgBIBEAgCyAGNgIMIAtCgICAgBA3AgQgCyAENgIACyANQQNqIgYhBCANQQxOBH8gDSANQXRqQf8BbWpBBGoFIAQLIAxqIgQgGSAYQQNqQQR0aiILKAIASARAIAsgBjYCDCALQoCAgIAQNwIEIAsgBDYCAAsgD0EETgRAIDRBDHIhDUEEIQYgGSAYQQR0akEIciEMA0AgBiAYaiESAn8gDCgCAEEBRgRAQQAhESAYIA0oAgAiC0oEQCAZIBggC2tBBHRqKAIAIRELIAsiBEEPTgR/IAsgC0FxakH/AW1qQQFqBSAEC0EDaiEEIAZBE08EfyAGQW1qQf8BbSAEakEBagUgBAsgEWoMAQsgNCgCACEEQQAhCyAGQRNPBH8gBkFtakH/AW1BBGoFQQMLIARqCyERAkAgEiAcQQNqTARAIBEgGSASQQR0aigCACAKa0oNAQsgGSASQQR0aiIEIAs2AgwgBCAONgIEIAQgBjYCCCAEIBE2AgAgEiAcIBwgEkgbIBwgBiAPRhshHAsgBiAPRiEEIAZBAWohBiAERQ0ACwsgGSAcQQR0aiIGQQE2AhwgBkKAgICAEDcCFCAGQoCAgIAQNwIkIAZBAjYCLCAGQQM2AjwgBkKAgICAEDcCNCAGIAYoAgAiBEEBajYCECAGIARBAmo2AiAgBiAEQQNqNgIwCyAgIQ4LIBwgFEoNAQsLIBwgGSAcQQR0aiIEKAIIIg9rIRggBCgCBCEOCwNAIBkgGEEEdGoiCygCCCEGIAsgDzYCCCALKAIEIQQgCyAONgIEIBggBk4hCyAYIAZrIRggBiEPIAQhDiALDQALQQAhBiAcQQFIDQADQAJ/IBkgBkEEdGoiBCgCCCIPQQFGBEAgHkEBaiEeIAZBAWoMAQsgHiAnayESIAQoAgQhCyAHBEAgHSASQf8BbmogEmpBCWogMksNBAsgHUEBaiENAkAgEkEPTwRAIB1B8AE6AAAgEkFxaiIOQf8BTwRAIA1B/wEgEkHyfWoiBEH/AW4iDEEBahAoGiAMQYF+bCAEaiEOIAwgHWpBAmohDQsgDSAOOgAAIA1BAWohDQwBCyAdIBJBBHQ6AAALIA0gJyANIBJqIgQQOyAEIAtB//8DcRAvIA9BfGohDCAEQQJqIQsgBwRAIAsgDEH/AW5qQQZqIDJLDQQLIB0tAAAhBAJ/IAxBD08EQCAdIARBD2o6AAAgD0FtaiIRQf4DTwRAIAtB/wEgD0Hve2oiDEH+A24iC0EBdCIEQQJqECgaIAtBgnxsIAxqIREgDSAEIB5qICdrakEEaiELCyARQf8BTwRAIAtB/wE6AAAgEUGBfmohESALQQFqIQsLIAsgEToAACALQQFqDAELIB0gBCAMajoAACALCyEdIA8gHmoiHiEnIAYgD2oLIgYgHEgNAAsLIB4gOU0NAQwCCwtBACAHQQJHDQEaCyA4ICdrIgZB8AFqQf8BbiEAAkAgB0UNACAAIAZqIB1qQQFqIDJBBWogNyA7GyIATQ0AQQAgB0EBRg0BGiAdQX9zIABqIgAgAEHwAWpB/wFuayEGCyAGICdqIQUCQCAGQQ9PBEAgHUHwAToAACAdQQFqIQAgBkFxaiIEQf8BSQRAIAAiHSAEOgAADAILIABB/wEgBkHyfWoiAEH/AW4iBEEBahAoGiAEIB1qQQJqIh0gBEGBfmwgAGo6AAAMAQsgHSAGQQR0OgAACyAdQQFqICcgBhAqIQAgAyAFIAFrNgIAIAAgBmogAmsLIQAgGUGwgARqJAAgAAuuPQE0fwJAIARBAExBACAGQQJGGw0AIAMoAgAiCkGAgIDwB0sNACAAIAAoAoCAECAKajYCgIAQQQkgBSAFQQFIGyIFQQwgBUEMSBsiB0EMbCIJQZQWaigCACEuAkACfwJAAn8CfwJAIAdBCU0EQCADQQA2AgAgAiAEaiI3QXtqIDcgBkECRiI4GyEmIAEgCmohMSABISUgAiEJIApBDUgNBCAxQXRqIi8gAUkNBEGANCAHdkEBcSEyIDFBe2oiGEF/aiErIBhBfWohHgNAIAAoApSAECEHIAAoAoiAECEdIAAoAoSAECERICUhDAJAAkADQCAAKAKQgBAiBCAMIBFrIg5BgYB8aiAEQYCABGogDksbISAgACgCjIAQIRAgDCgAACENIAcgDkkEQANAIAAgB0H//wNxQQF0akGAgAhqIAcgACAHIBFqEDpBAnRqIgQoAgBrIgVB//8DIAVB//8DSRs7AQAgBCAHNgIAIAdBAWoiByAOSQ0ACwsgACAONgKUgBACQAJAIAAgDBA6QQJ0aigCACIFICBJDQAgDUH//wNxIA1BEHZGIA1B/wFxIA1BGHZGcSEfIBAgHWohEyAQIBFqIhdBBGohKSAMQQhqIRwgDEEEaiEZIAxBf2ohI0EAIRtBAyEKIC4hCEEAIRoDQAJAAkACfwJAAkAgECAFTQRAIAogI2ovAAAgBSARaiILIApqQX9qLwAARw0FIA0gCygAAEcNBSALQQRqIQcgHiAZTQR/IBkFIAcoAAAgGSgAAHMiBA0CIAdBBGohByAcCyIEIB5JBEADQCAHKAAAIAQoAABzIhYEQCAWECUgBGogGWshBwwHCyAHQQRqIQcgBEEEaiIEIB5JDQALCwJAIAQgK08NACAHLwAAIAQvAABHDQAgB0ECaiEHIARBAmohBAsgBCAYSQR/IARBAWogBCAHLQAAIAQtAABGGwUgBAsgGWshBwwECyANIAUgHWoiBCgAAEcNBCAEQQRqIQcCfyAZIBggDCAQIAVraiIhICEgGEsbIhZBfWoiCyAZTQ0AGiAHKAAAIBkoAABzIgQNAiAHQQRqIQcgHAsiBCALSQRAA0AgBygAACAEKAAAcyIkBEAgJBAlIARqIBlrDAULIAdBBGohByAEQQRqIgQgC0kNAAsLAkAgBCAWQX9qTw0AIAcvAAAgBC8AAEcNACAHQQJqIQcgBEECaiEECyAEIBZJBH8gBEEBaiAEIActAAAgBC0AAEYbBSAECyAZawwCCyAEECUhBwwCCyAEECULIQQgBSARaiAUAn8gBEEEaiILIAxqIBZHICEgGE9yRQRAIBchBAJ/AkAgHiAWIgdLBEAgFygAACAWKAAAcyIEDQEgFkEEaiEHICkhBAsgByAeSQRAA0AgBCgAACAHKAAAcyIUBEAgFBAlIAdqIBZrDAQLIARBBGohBCAHQQRqIgcgHkkNAAsLAkAgByArTw0AIAQvAAAgBy8AAEcNACAEQQJqIQQgB0ECaiEHCyAHIBhJBH8gB0EBaiAHIAQtAAAgBy0AAEYbBSAHCyAWawwBCyAEECULIAtqIQsLIAsgCkoiBAsbIRQgCyAKIAQbIQoMAQsgB0EEaiIEIAogBCAKSiIEGyEKIAsgFCAEGyEUCwJAAkACQCAyRSAAIAVB//8DcUEBdGpBgIAIai8BACIHQQFHcg0AIBtFBEBBASEbIB9FDQEgGSAYIA0QM0EEaiEaQQIhGwsgG0ECRyAFQX9qIgQgIElyDQBBAiEbIBAgBBAyRQ0AIA0gHSARIAQgEEkiFhsgBGoiCygAAEcNACALQQRqIBMgGCAWGyIFIA0QM0EEaiEHIB0gACgCkIAQIhtqIRYCQCAEIBBJBEAgBSAHIAtqRgRAIBcgGCAHIA0QPRAzIAdqIQcLIAsgFiANEDEhBQwBCyALIAsgFyANEDEiBWsgF0cgGyAQT3INACATIBZBACAFayANED0QMSAFaiEFCyAEIAQgBWsiBSAgIAUgIEsbIgVrIAdqIgsgGkkgByAaS3JFBEAgByAEIBpraiIEIBAgECAEEDIbIQVBAiEbDAILQQIhGyAQIAUQMkUEQCAQIQUMAgsCQCAKIAsgGiALIBpJGyIHTwRAIBQhBCAKIQcMAQsgDCAFIBFqIgRrQf//A0oNAwsgBSAAIAVB//8DcUEBdGpBgIAIai8BACIKSQRAIAQhFCAHIQoMAwsgBSAKayEFIAQhFCAHIQoMAQsgBSAHayEFCyAIQX9qIghFDQAgBSAgTw0BCwsgCkEDTA0AICUhFiAJIQ0gDCEZIBQiCSEbIAohEANAIAkhFAJAAkAgDCAKIhdqIiUgL0sNACAAKAKQgBAiBSAlQX5qIhEgACgChIAQIh9rIgRBgYB8aiAFQYCABGogBEsbISMgACgCjIAQIRwgACgCiIAQISQgESgAACETIAAoApSAECIHIARJBEADQCAAIAdB//8DcUEBdGpBgIAIaiAHIAAgByAfahA6QQJ0aiIFKAIAayIJQf//AyAJQf//A0kbOwEAIAUgBzYCACAHQQFqIgcgBEkNAAsLIAAgBDYClIAQIAAgERA6QQJ0aigCACIFICNJDQAgE0H//wNxIBNBEHZGIBNB/wFxIBNBGHZGcSEwIBwgJGohLCAcIB9qIiBBBGohHSARQQhqIS0gEUEEaiEaIAwgEWshKEEAISFBACARIAxrIiprITMgDEF/aiE0IBchCiAuISlBACEOIA8hCQNAAkACQAJ/AkACQCAcIAVNBEAgCiA0ai8AACAFIB9qIgggM2ogCmpBf2ovAABHDQUgEyAIKAAARw0FAkAgKkUEQEEAIQsMAQsgKCAgIAhrIgQgKCAEShsiD0EfdSAPcSEEQQAhBwNAIAciCyAPTARAIAQhCwwCCyARIAtBf2oiB2otAAAgByAIai0AAEYNAAsLIAhBBGohByAeIBpNBH8gGgUgBygAACAaKAAAcyIEDQIgB0EEaiEHIC0LIgQgHkkEQANAIAcoAAAgBCgAAHMiDwRAIA8QJSAEaiAaayEHDAcLIAdBBGohByAEQQRqIgQgHkkNAAsLAkAgBCArTw0AIAcvAAAgBC8AAEcNACAHQQJqIQcgBEECaiEECyAEIBhJBH8gBEEBaiAEIActAAAgBC0AAEYbBSAECyAaayEHDAQLIBMgBSAkaiIPKAAARw0EIA9BBGohByAAKAKQgBAhNQJ/IBogGCARIBwgBWtqIicgJyAYSxsiCEF9aiILIBpNDQAaIAcoAAAgGigAAHMiBA0CIAdBBGohByAtCyIEIAtJBEADQCAHKAAAIAQoAABzIjYEQCA2ECUgBGogGmsMBQsgB0EEaiEHIARBBGoiBCALSQ0ACwsCQCAEIAhBf2pPDQAgBy8AACAELwAARw0AIAdBAmohByAEQQJqIQQLIAQgCEkEfyAEQQFqIAQgBy0AACAELQAARhsFIAQLIBprDAILIAQQJSEHDAILIAQQJQshBCARIARBBGoiC2ogCEcgJyAYT3JFBEAgICEEAn8CQCAeIAgiB0sEQCAgKAAAIAgoAABzIgQNASAIQQRqIQcgHSEECyAHIB5JBEADQCAEKAAAIAcoAABzIicEQCAnECUgB2ogCGsMBAsgBEEEaiEEIAdBBGoiByAeSQ0ACwsCQCAHICtPDQAgBC8AACAHLwAARw0AIARBAmohBCAHQQJqIQcLIAcgGEkEfyAHQQFqIAcgBC0AACAHLQAARhsFIAcLIAhrDAELIAQQJQsgC2ohCwsCQCAqRQRAQQAhBAwBCyAoICQgNWogD2siBCAoIARKGyInQR91ICdxIQhBACEHA0AgByIEICdMBEAgCCEEDAILIBEgBEF/aiIHai0AACAHIA9qLQAARg0ACwsgCyAEayIHIApMDQEgBCARaiEVIAUgH2ogBGohCSAHIQoMAQsgByALa0EEaiIEIApMDQAgCyARaiEVIAggC2ohCSAEIQoLAkACQAJAIDJFIAAgBUH//wNxQQF0akGAgAhqLwEAIgdBAUdyDQAgIUUEQEEBISEgMEUNAUECISEgGiAYIBMQM0EEaiEOCyAhQQJHIAVBf2oiBCAjSXINAEECISEgHCAEEDJFDQAgEyAkIB8gBCAcSSIPGyAEaiIIKAAARw0AIAhBBGogLCAYIA8bIgUgExAzQQRqIQcgJCAAKAKQgBAiC2ohDwJAIAQgHEkEQCAFIAcgCGpGBEAgICAYIAcgExA9EDMgB2ohBwsgCCAPIBMQMSEFDAELIAggCCAgIBMQMSIFayAgRyALIBxPcg0AICwgD0EAIAVrIBMQPRAxIAVqIQULIAQgBCAFayIFICMgBSAjSxsiD2sgB2oiCCAOSSAHIA5LckUEQCAHIAQgDmtqIgQgHCAcIAQQMhshBQwCCyAPIBwgHCAPEDIiBBshBSAqIARFcg0BAkAgCiAIIA4gCCAOSRsiB08EQCAVIQQgCSEIIAohBwwBCyARIgQgDyAfaiIIa0H//wNKDQMLIA8gACAPQf//A3FBAXRqQYCACGovAQAiBUkEQCAEIRUgCCEJIAchCgwDCyAPIAVrIQUgBCEVIAghCSAHIQoMAQsgBSAHayEFCyApQX9qIilFDQAgBSAjTw0BCwsgCiAXRw0BIAkhDwsgDCAWayEKIAYEQCANIApB/wFuaiAKakEJaiAmSw0KCyANQQFqIQQCQCAKQQ9PBEAgDUHwAToAACAKQXFqIgVB/wFPBEAgBEH/ASAKQfJ9aiIFQf8BbiIEQQFqECgaIARBgX5sIAVqIQUgBCANakECaiEECyAEIAU6AAAgBEEBaiEEDAELIA0gCkEEdDoAAAsgBCAWIAQgCmoiCRA7IAkgDCAUa0H//wNxEC8gF0F8aiEFIAlBAmohCSAGBEAgCSAFQf8BbmpBBmogJksNCgsgDS0AACEHIAVBD08EQCANIAdBD2o6AAAgF0FtaiIFQf4DTwRAIAlB/wEgF0Hve2oiBUH+A24iCUEBdCIHQQJqECgaIAlBgnxsIAVqIQUgBCAHIApqakEEaiEJCyAFQf8BTwRAIAlB/wE6AAAgCUEBaiEJIAVBgX5qIQULIAkgBToAACAJQQFqIQkMBwsgDSAFIAdqOgAADAYLIBkgDCAZIAxJIBUgDCAQaklxIgQbIQ4gCSEPIBUiDCAOa0EDSA0AIBAgFyAEGyEZIBsgFCAEGyEUIBYhEQNAIA4gGWoiFkEDaiEzIA4gGUESIBlBEkgbIixqIS0CQANAAkACQAJ/AkAgDCAOayIEQRFKDQAgDiAMayAEIApqQXxqICwgLSAKIAxqQXxqSxtqIgRBAUgNACAKIARrIRAgBCAJaiEPIAQgDGoMAQsgCSEPIAohECAMCyIVIBBqIiUgL0sNACAAKAKQgBAiBSAlQX1qIhcgACgChIAQIhxrIgRBgYB8aiAFQYCABGogBEsbISMgACgCjIAQIRMgACgCiIAQISQgFygAACEdIAAoApSAECIHIARJBEADQCAAIAdB//8DcUEBdGpBgIAIaiAHIAAgByAcahA6QQJ0aiIFKAIAayIJQf//AyAJQf//A0kbOwEAIAUgBzYCACAHQQFqIgcgBEkNAAsLIAAgBDYClIAQIAAgFxA6QQJ0aigCACIFICNJDQAgHUH//wNxIB1BEHZGIB1B/wFxIB1BGHZGcSE0IBMgJGohJyATIBxqIhpBBGohICAXQQhqITAgF0EEaiEbIBUgF2shKEEAISFBACAXIBVrIiprITUgFUF/aiE2IBAhCiAuISlBACEfIBIhCSAiIQwDQAJAAkACfwJAAkAgEyAFTQRAIAogNmovAAAgBSAcaiIIIDVqIApqQX9qLwAARw0FIB0gCCgAAEcNBQJAICpFBEBBACELDAELICggGiAIayIEICggBEobIhJBH3UgEnEhBEEAIQcDQCAHIgsgEkwEQCAEIQsMAgsgFyALQX9qIgdqLQAAIAcgCGotAABGDQALCyAIQQRqIQcgHiAbTQR/IBsFIAcoAAAgGygAAHMiBA0CIAdBBGohByAwCyIEIB5JBEADQCAHKAAAIAQoAABzIhIEQCASECUgBGogG2shBwwHCyAHQQRqIQcgBEEEaiIEIB5JDQALCwJAIAQgK08NACAHLwAAIAQvAABHDQAgB0ECaiEHIARBAmohBAsgBCAYSQR/IARBAWogBCAHLQAAIAQtAABGGwUgBAsgG2shBwwECyAdIAUgJGoiEigAAEcNBCASQQRqIQcgACgCkIAQITkCfyAbIBggFyATIAVraiIiICIgGEsbIghBfWoiCyAbTQ0AGiAHKAAAIBsoAABzIgQNAiAHQQRqIQcgMAsiBCALSQRAA0AgBygAACAEKAAAcyI6BEAgOhAlIARqIBtrDAULIAdBBGohByAEQQRqIgQgC0kNAAsLAkAgBCAIQX9qTw0AIAcvAAAgBC8AAEcNACAHQQJqIQcgBEECaiEECyAEIAhJBH8gBEEBaiAEIActAAAgBC0AAEYbBSAECyAbawwCCyAEECUhBwwCCyAEECULIQQgFyAEQQRqIgtqIAhHICIgGE9yRQRAIBohBAJ/AkAgHiAIIgdLBEAgGigAACAIKAAAcyIEDQEgCEEEaiEHICAhBAsgByAeSQRAA0AgBCgAACAHKAAAcyIiBEAgIhAlIAdqIAhrDAQLIARBBGohBCAHQQRqIgcgHkkNAAsLAkAgByArTw0AIAQvAAAgBy8AAEcNACAEQQJqIQQgB0ECaiEHCyAHIBhJBH8gB0EBaiAHIAQtAAAgBy0AAEYbBSAHCyAIawwBCyAEECULIAtqIQsLAkAgKkUEQEEAIQQMAQsgKCAkIDlqIBJrIgQgKCAEShsiIkEfdSAicSEIQQAhBwNAIAciBCAiTARAIAghBAwCCyAXIARBf2oiB2otAAAgByASai0AAEYNAAsLIAsgBGsiByAKTA0BIAQgF2ohDCAFIBxqIARqIQkgByEKDAELIAcgC2tBBGoiBCAKTA0AIAsgF2ohDCAIIAtqIQkgBCEKCwJAAkACQCAyRSAAIAVB//8DcUEBdGpBgIAIai8BACIHQQFHcg0AICFFBEBBASEhIDRFDQEgGyAYIB0QM0EEaiEfQQIhIQsgIUECRyAFQX9qIgQgI0lyDQBBAiEhIBMgBBAyRQ0AIB0gJCAcIAQgE0kiEhsgBGoiCCgAAEcNACAIQQRqICcgGCASGyIFIB0QM0EEaiEHICQgACgCkIAQIiJqIRICQCAEIBNJBEAgBSAHIAhqRgRAIBogGCAHIB0QPRAzIAdqIQcLIAggEiAdEDEhBQwBCyAIIAggGiAdEDEiBWsgGkcgIiATT3INACAnIBJBACAFayAdED0QMSAFaiEFCyAEIAQgBWsiBSAjIAUgI0sbIhJrIAdqIgggH0kgByAfS3JFBEAgByAEIB9raiIEIBMgEyAEEDIbIQUMAgsgEiATIBMgEhAyIgQbIQUgKiAERXINAQJAIAogCCAfIAggH0kbIgdPBEAgDCEEIAkhCCAKIQcMAQsgFyIEIBIgHGoiCGtB//8DSg0DCyASIAAgEkH//wNxQQF0akGAgAhqLwEAIgVJBEAgBCEMIAghCSAHIQoMAwsgEiAFayEFIAQhDCAIIQkgByEKDAELIAUgB2shBQsgKUF/aiIpRQ0AIAUgI08NAQsLIAogEEcNASAJIRIgDCEiCyAOIBFrIQQgBgRAIA0gBEH/AW5qIARqQQlqICZLDQcLIBUgDmsgGSAVIBZJGyEJIA1BAWohBQJAIARBD08EQCANQfABOgAAIARBcWoiB0H/AU8EQCAFQf8BIARB8n1qIgpB/wFuIgVBAWoQKBogBUGBfmwgCmohByAFIA1qQQJqIQULIAUgBzoAACAFQQFqIQUMAQsgDSAEQQR0OgAACyAFIBEgBCAFaiIHEDsgByAOIBRrQf//A3EQLyAJQXxqIQogB0ECaiEHIAYEQCAHIApB/wFuakEGaiAmSw0HCyANLQAAIQwCQCAKQQ9PBEAgDSAMQQ9qOgAAIAlBbWoiC0H+A08EQCAHQf8BIAlB73tqIgpB/gNuIgdBAXQiDEECahAoGiAHQYJ8bCAKaiELIAUgBCAMampBBGohBwsgC0H/AU8EQCAHQf8BOgAAIAtBgX5qIQsgB0EBaiEHCyAHIAs6AAAgB0EBaiEHDAELIA0gCiAMajoAAAsgFSAJIA5qIgRrIQkgBgRAIAcgCUH/AW5qIAlqQQlqICZLDQkLIAdBAWohBQJAIAlBD08EQCAHQfABOgAAIAlBcWoiCEH/AU8EQCAFQf8BIAlB8n1qIgpB/wFuIgVBAWoQKBogBUGBfmwgCmohCCAFIAdqQQJqIQULIAUgCDoAACAFQQFqIQUMAQsgByAJQQR0OgAACyAFIAQgBSAJaiIJEDsgCSAVIA9rQf//A3EQLyAQQXxqIQogCUECaiEJIAYEQCAJIApB/wFuakEGaiAmSw0JCyAHLQAAIQwgCkEPTwRAIAcgDEEPajoAACAQQW1qIgdB/gNPBEAgCUH/ASAQQe97aiIJQf4DbiIKQQF0IgxBAmoQKBogCkGCfGwgCWohByAFIAwgFWogBGtqQQRqIQkLIAdB/wFPBEAgCUH/AToAACAHQYF+aiEHIAlBAWohCQsgCSAHOgAAIAlBAWohCQwKCyAHIAogDGo6AAAMCQsgDCAzTw0BIAwhIiAJIRIgDCAWSQ0ACwJAIBUgFk8NACAQIBYgFWsiBGsiEEEDSgRAIAQgD2ohDyAWIRUMAQsgDCEVIAkhDyAKIRALIA4gEWshByAGBEAgDSAHQf8BbmogB2pBCWogJksNBQsgDUEBaiEEAkAgB0EPTwRAIA1B8AE6AAAgB0FxaiIFQf8BTwRAIARB/wEgB0HyfWoiBUH/AW4iBEEBahAoGiAEQYF+bCAFaiEFIAQgDWpBAmohBAsgBCAFOgAAIARBAWohBAwBCyANIAdBBHQ6AAALIAQgESAEIAdqIgUQOyAFIA4gFGtB//8DcRAvIBlBfGohCCAFQQJqIQUgBgRAIAUgCEH/AW5qQQZqICZLDQULIA0tAAAhFAJ/IAhBD08EQCANIBRBD2o6AAAgGUFtaiIIQf4DTwRAIAVB/wEgGUHve2oiBUH+A24iCEEBdCIUQQJqECgaIAhBgnxsIAVqIQggBCAHIBRqakEEaiEFCyAIQf8BTwRAIAVB/wE6AAAgCEGBfmohCCAFQQFqIQULIAUgCDoAACAFQQFqDAELIA0gCCAUajoAACAFCyENIAwhIiAJIRIgFSEZIA8hGwwCCwJ/IBUgFk8EQCAZIQggEAwBCyAQIBUgDmsiCEERSg0AGiAQIAggEGpBfGogLCAtIBAgFWpBfGpLGyIIIA4gFWtqIgRBAUgNABogBCAPaiEPIAQgFWohFSAQIARrCyEZIA4gEWshByAGBEAgDSAHQf8BbmogB2pBCWogJksNBAsgDUEBaiEEAkAgB0EPTwRAIA1B8AE6AAAgB0FxaiIFQf8BTwRAIARB/wEgB0HyfWoiBUH/AW4iBEEBahAoGiAEQYF+bCAFaiEFIAQgDWpBAmohBAsgBCAFOgAAIARBAWohBAwBCyANIAdBBHQ6AAALIAQgESAEIAdqIgUQOyAFIA4gFGtB//8DcRAvIAhBfGohFCAFQQJqIQUgBgRAIAUgFEH/AW5qQQZqICZLDQQLIA0tAAAhEgJ/IBRBD08EQCANIBJBD2o6AAAgCEFtaiILQf4DTwRAIAVB/wEgCEHve2oiBUH+A24iFEEBdCISQQJqECgaIBRBgnxsIAVqIQsgBCAHIBJqakEEaiEFCyALQf8BTwRAIAVB/wE6AAAgC0GBfmohCyAFQQFqIQULIAUgCzoAACAIIA5qIREgFSEOIAVBAWoMAQsgDSASIBRqOgAAIAggDmohESAVIQ4gBQshDSAPIRQgDCEiIAkhEgwACwALAAsgDiEHIAxBAWoiDCAvTQ0BDAkLCyARDAULIAQhJSAHDAULICUgL00NAAsMBAsgACABIAIgAyAEIC4gCUGYFmooAgAgBiAFQQtKQQAgAC0AmoAQQQBHEJACDAQLIBYLISUgDQshCUEAIQcgBkECRw0CCyAxICVrIgdB8AFqQf8BbiEEAkAgBkUNACAEIAdqIAlqQQFqICZBBWogNyA4GyIETQ0AQQAhByAGQQFGDQIgCUF/cyAEaiIEIARB8AFqQf8BbmshBwsgByAlaiEFAkAgB0EPTwRAIAlB8AE6AAAgCUEBaiEEIAdBcWoiBkH/AUkEQCAEIgkgBjoAAAwCCyAEQf8BIAdB8n1qIgZB/wFuIgRBAWoQKBogBCAJakECaiIJIARBgX5sIAZqOgAADAELIAkgB0EEdDoAAAsgCUEBaiAlIAcQKiEEIAMgBSABazYCACAEIAdqIAJrCyIHQQBKDQELIABBAToAm4AQCyAHCzsBAX8gAEUgAEEDcXIEfyABBSAAQQA2ApyAECAAQv////8PNwKAgBAgAEEAOwGagBAgAEEJELABIAALCx8BAX8gAEGAgIDwB00EfyAAIABB/wFuakEQagUgAQsLxwIAIAAgAS0AADoAACAAIAEtAAE6AAEgACABLQACOgACIAAgAS0AAzoAAyAAIAEtAAQ6AAQgACABLQAFOgAFIAAgAS0ABjoABiAAIAEtAAc6AAcgACABLQAIOgAIIAAgAS0ACToACSAAIAEtAAo6AAogACABLQALOgALIAAgAS0ADDoADCAAIAEtAA06AA0gACABLQAOOgAOIAAgAS0ADzoADyAAIAEtABA6ABAgACABLQAROgARIAAgAS0AEjoAEiAAIAEtABM6ABMgACABLQAUOgAUIAAgAS0AFToAFSAAIAEtABY6ABYgACABLQAXOgAXIAAgAS0AGDoAGCAAIAEtABk6ABkgACABLQAaOgAaIAAgAS0AGzoAGyAAIAEtABw6ABwgACABLQAdOgAdIAAgAS0AHjoAHiAAIAEtAB86AB8gAEEgagsNACAAIABBBm5qQSBqCz4AEMICENUCQdQNQQJB+A9B8w9BCkELEANB3w1BBkGQDkH8DUEMQQ0QA0HoDUEBQfgNQfQNQQ5BDxADEPQCC0UBBH8gASAAIAEgAEsbIQMDQCAAIAFPBEAgAw8LIAAtAAAhBCACLQAAIQUgAEEBaiIGIQAgAkEBaiECIAQgBUYNAAsgBgsrAQF/EIsDIgRFBEBBQA8LIAQgACABIAIgAyAEEIYDEIUDIQAgBBCJAyAAC6QBAQF/IwBBQGoiBCQAIAQgADYCFCAEIAM2AgwgBCACNgIIIAEoAgAhACAEQgA3AyggBCAANgIYAkAgBEEIahCNBCICDQAgBEEIahCMBCIAQQFHBEAgBEEIahCIAhpBfSECAkACQCAAQQVqDggAAQEBAQEBAwELIAQoAgxFDQILIAAhAgwBCyABIAQoAhw2AgAgBEEIahCIAiECCyAEQUBrJAAgAgvABgEQf0F/IQUCQCAARQ0AIANFBEAgAkEBRw0BQX9BACAALQAAGw8LIAJFDQAgASADaiIIQWBqIQ8gACACaiIJQXBqIRAgCEF7aiERIAhBeWohCiAJQXtqIQwgCUF4aiESIAhBdGohDSAJQXFqIQ4gACECIAEhBQJAA0ACQCACQQFqIQMCQAJAAkAgAi0AACIHQQR2IgJBD0cEQCAFIA9LIAMgEE9yDQEgBSADKQAANwAAIAUgAykACDcACCACIAVqIgYgAiADaiICLwAAIgtrIQQgAkECaiECIAdBD3EiBUEPRgRAIAIhAwwDCyALQQhJBEAgAiEDDAMLIAQgAUkNAyAGIAQpAAA3AAAgBiAEKQAINwAIIAYgBC8AEDsAECAFIAZqQQRqIQUMBQtBACECIAMgDk8NBQNAAkAgAiADLQAAIgRqIQIgA0EBaiIDIA5PDQAgBEH/AUYNAQsLIAJBD2oiAiAFQX9zSyACIANBf3NLcg0FCyACIAVqIgYgDU1BACACIANqIgQgEk0bRQRAIAQgCUcgBiAIS3INBSAFIAMgAhBKGiAGIAFrIQUMBgsgBSADIAYQOyAHQQ9xIQUgBEECaiEDIAYgBC8AACILayEECyAFQQ9HBEAgAyECDAELIAMgDCADIAxLGyEHQQAhBQNAIANBAWohAiADIAdGDQIgBSADLQAAIhNqIQUgAiEDIBNB/wFGDQALIAVBD2oiBSAGQX9zSw0DCyAEIAFJDQAgBiAFQQRqIgdqIQUCfyALQQdNBEAgBkEAEDQgBiAELQAAOgAAIAYgBC0AAToAASAGIAQtAAI6AAIgBiAELQADOgADIAYgBCALQQJ0IgNB0BVqKAIAaiIEKAAANgAEIAQgA0HwFWooAgBrDAELIAYgBCkAADcAACAEQQhqCyEDIAZBCGohBCAFIA1LBEAgBSARSw0BIAQgCkkEQCAEIAMgChA7IAMgCiAEa2ohAyAKIQQLIAQgBU8NAgNAIAQgAy0AADoAACADQQFqIQMgBEEBaiIEIAVHDQALDAILIAQgAykAADcAACAHQRFJDQEgBkEQaiADQQhqIAUQOwwBCwsgAiEDCyADQX9zIABqDwsgBQsWAEEAIAIgAyAAIAEQmAIiACAAECEbCzkBAX8jAEEQayIEJAAgBCADNgIMIAIgBEEMaiAAIAEQmQIhACAEKAIMIQEgBEEQaiQAQQAgASAAGws5AQF/IwBBEGsiBCQAIAQgAzYCDCAAIAEgAiAEQQxqEIoEIQAgBCgCDCEBIARBEGokAEEAIAEgABsLDQAgACACIAEgAxCaAguXAwEIfwJAIAFFDQAgAiADaiEKIAAgAWohBSAAQQFqIQEgAC0AAEEfcSEGIAIhBANAAkACfyAGQSBPBEACQCAGQQV2QX9qIgNBBkYEQCABIQBBBiEDA0AgAEEBaiIBIAVPDQcgAyAALQAAIgdqIQMgASEAIAdB/wFGDQALDAELIAEgBU8NBQsgAUEBaiEAIAQgBkEIdEGAPnEiCGsgAS0AACILayEHIAhBgD5HIAtB/wFHckUEQCABQQJqIAVPDQUgBCABLQACIAEtAAFBCHRya0GBQGohByABQQNqIQALIAMgBGpBA2ogCksNBCAHQX9qIgEgAkkNBCAAIAVPBH9BAAUgAC0AACEGIABBAWohAEEBCyEIIAQgB0YEQCAEIAEtAAAgA0EDaiIBECggAWohBCAADAILIAQgASADQQNqEMQEIQQgAAwBCyAEIAZBAWoiA2ogCksNAyABIANqIgAgBUsNAyAEIAEgAxBQIQQgACAFTw0BQQEhCCAALQAAIQYgAEEBagshASAIDQELCyAEIAJrIQkLIAkLnwEBAn8gACgCECECQXshAQJAAkACQAJAAkACQAJAIAAoAgwtAABBBXYOBQABAgMEBgtBdyEBIAJBAUcNBSAAQRI2AkAMBAtBdyEBIAJBAUcNBCAAQRM2AkAMAwtBdyEBIAJBAUcNAyAAQRQ2AkAMAgtBdyEBIAJBAUcNAiAAQRU2AkAMAQtBdyEBIAJBAUcNASAAQRY2AkALQQAhAQsgAQsHACAAKAIEC6QCAQR/IAAgAzYCMCAAIAI2AgggACABNgIEIABBADYCACAAQQA2AkwgAEEBNgJEIABBADYCLCABLQAAIQUgAS0AASECIAAgAUECajYCDCAAIAI2AhAgACABLQADIgc2AiggACABKAAEIgI2AhQgACABKAAIIgQ2AiQgASgADCEGIAAgAUEQajYCNCAAIAY2AhgCQCACRSAEQdbSqtUCS3IgBEEBSCAEIANLcnIgB0UgBUECR3JyDQAgAS0AAkEIcQ0AIAAgAiAEIAIgBG0iBWxrIgQ2AiAgACAFIARBAEpqNgIcIAIgA0oNAAJAIAEtAAJBAnEEQCACQRBqIAZGDQEMAgsgABCgAg0BIAAoAhwgACgCGEFwakEEbUoNAQsgABCHARoLCysBAX8jAEHQEWsiAyQAIANBADYCUCADQQhqIAAgASACEKICIANB0BFqJAALyQIBAn9BASEEAkAgAkEESA0AAkACQAJAIAMEQCADQYABIANBgAFKGyIDQdbSqtUCIANB1tKq1QJJGyEEDAELIAIiBEGAgAJIDQBBgIACIQQgACgCOCIDQX5qIgVBA00EQCAFQQJ0QcAUaigCACEECwJAAkACQAJAAkACQCABDgoAAQYCAwMEBAQFBgsgBEECdiEEDAcLIARBAXYhBAwFCyAEQQF0IQQMBAsgBEECdCEEDAMLIARBA3QhBAwCCyAEQQN0IQAgA0EFSwRAIAAhBAwCC0EBIAN0QTRxRQRAIAAhBAwCCyAEQQR0IQQMAQsgAUEBSA0BIAAoAjghAwsgA0EEIAQQsgFFDQAgBEGAgAQgBEGAgARIG0ECdCIAQYCABCAAQYCABEobIQQLIAIgBCAEIAJKGyIEQQVIDQAgBCAEQQRvayEECyAEC/UCAQN/IwBBEGsiBCQAIAAoAghBAjoAAAJ/IAAoAjgiA0EGTwRAIARBmtQBNgIAQegRIAQQT0GPEkEvEHJBewwBCyAAKAIIQQE6AAEgACAAKAIIIgJBAmo2AgwgAkEAOgACIAAoAgggACgCKDoAAyAAKAIIQQRqIAAoAhQQNCAAKAIIQQhqIAAoAiQQNCAAIAAoAghBEGo2AjQgACAAKAIcQQJ0QRBqNgIsIAAoAjxFBEAgACgCDCICIAItAABBAnI6AAAgAEEQNgIsCyAAKAIUQf8ATARAIAAoAgwiAiACLQAAQQJyOgAAIABBEDYCLAtCgMCAgYSMICADrUIDhoinIQJBASEDAkACQAJAIAFBf2oOAgEAAgtBBCEDCyAAKAIMIgEgAS0AACADcjoAAAsgACgCDCIBIAAoAjggACgCKCAAKAIkELIBRUEEdCABLQAAcjoAACAAKAIMIgAgAC0AACACcjoAAEEBCyEAIARBEGokACAAC/sBAQF/IwBBIGsiCSQAIAAgBjYCMCAAIAU2AgggACAENgIEIABBATYCACAAQQA2AkwgAEEBNgJEIAAgBzYCOCAAQgQ3AiggACADNgIUIAAgATYCPAJ/IANB8P///wdPBEAgCUHv////BzYCAEGGEyAJEE9BfwwBCyAGQQ9NBEAgCUEQNgIQQbATIAlBEGoQT0F/DAELIAFBCk8EQEHjE0EsEHJBdgwBCyACQQNPBEBBkBRBLhByQXYMAQsgACAAIAEgAyAIEKQCIgE2AiQgACADIAEgAyABbSICbGsiATYCICAAIAIgAUEASmo2AhxBAQshACAJQSBqJAAgAAtZAQF/IwBBoAZrIgUkACAFQQhqENADIAVBCGogACABIAIgAyAEENIDIQEgBUEIaiIAEPYBIABBgAJqIAAoApgDIAAoApwDIAAoAqADEKQBIAVBoAZqJAAgAQuQAQEBfyMAQUBqIgUkACAFIAA2AhQgBSADNgIMIAUgAjYCCCABKAIAIQAgBUEANgIwIAVCADcDKCAFIAA2AhgCQCAFQQhqIAQQqAQiBA0AIAVBCGoQqwQiAEEBRwRAIABBeyAAGyEEIAVBCGoQrwEaDAELIAEgBSgCHDYCACAFQQhqEK8BIQQLIAVBQGskACAECzEBAn8Cf0EAQbiAEBBMIgUiBhCSAkUNABogBiAAIAEgAiADIAQQsgQLIQAgBRA4IAALKwEBfyMAQaCAAWsiBSQAIAUgACABIAIgAyAEELMEIQAgBUGggAFqJAAgAAsqAQF/IAAgASAAKAIEIgNHBH8gAyABIAIQKhogACgCBAUgAQsgAmo2AgQLaQIBfwF+IAEgAG4hBUGM7AEtAABFBEAQhgFBjOwBQQE6AAALIAVBB3FFBEAgAiADIAUgACAEQaDsASgCABEPACEGIAMgACAFbCIAaiAAIAJqIAEgAGsQKhogBqcPCyADIAIgARAqGiAFCysAQYzsAS0AAEUEQBCGAUGM7AFBAToAAAsgACABIAIgA0GY7AEoAgARCAALxQsCEn8BfCMAQYCAAmsiCyQAIABB0BRqIQcgAEHaFGohCQJ/IABBA3RB8BRqKwMAIAK3oiIYmUQAAAAAAADgQWMEQCAYqgwBC0GAgICAeAshBiABIAJqIQggBy0AACEHIAktAAAhDkEAIQADQCALIABBAXRqQQA7AQAgAEEBaiIAIAd2RQ0ACwJ/QQAgAkEESA0AGkEAIARBwgBIDQAaIAhBfmohDCADIAQgBiAGIARKG2ohDSADQR86AAAgAyABLQAAOgABIAMgAS0AAToAAiADQQNqIQRBAiEGIAFBAmohACACQQ9OBEAgCEF0aiEPIAxBAmohEkEgIAdrIRBBACEHA0ACfwJ/AkACQCAALQAAIgkgAEF/ai0AAEcEQCAALQACIQIgAC0AASEIDAELIAlBCHQgCXIgAC0AASIIIAAtAAIiAkEIdHJHDQAgAEECaiEIIABBA2ohBwwBCyAFQQAgACABIAsgCEEIdCAJciACQRB0ciAALQADQRh0ckGx893xeWwgEHZBAXRqIggvAQBqIgprIgJBH3EbRQRAIAggACABazsBAAsgAEEBaiEIIAJBf2oiCUH8vwRPBEBBACAEQQJqIgIgDUsNBhogBCAALQAAOgAAIARBAWohBCAIIAZBAWoiBkH/AXFBIEcNAxogBEEfOgAAQQAiBiAHQQFqIgcgDksNBhogAiEEIAgMAwsCQCAKLQAAIhMgCi0AASIUQQh0ciAKLQACIhVBEHRyIAotAANBGHRyIAAtAAAiESAALQABIhZBCHRyIAAtAAIiF0EQdHIgAC0AA0EYdHJGBEBBBCEHIApBBGohCAwBCyARIBNHIBQgFkdyIBUgF0dyRQRAIApBA2ohCEEDIQcMAQtBACAEQQJqIgAgDUsNBhogBCAROgAAIARBAWohBCAIIAZBAWoiBkH/AXFBIEcNAxogBEEfOgAAQQAiBiAHQQFqIgcgDksNBhogACEEIAgMAwsgACAHaiEHIAlFDQAgByASIAgQlwIMAQtBASECQQAhCSAHIAwgCBDFBAshCAJAIAZB/wFxBEAgBkF/c0GAfnIgBGogBkF/ajoAAAwBCyAEQX9qIQQLQQAgBCAIQX1qIgYgAGsiAEH/AW5qQQZqIA1LDQMaAn8gCUH+P00EQCAAQQZNBEAgBCAAQQV0IAlBCHZqOgAAIARBAmohACAEQQFqDAILIAQgCUEIdkFgajoAACAEQQFqIQIgAEF5aiIHQf8BTwRAIAJB/wEgAEH6fWoiAkH/AW4iAEEBahAoGiAAQYF+bCACaiEHIAAgBGoiAEECaiECIABBAWohBAsgAiAHOgAAIARBA2ohACAEQQJqDAELIAJBgEBqIQkgAEEGTQRAIARB/wE6AAEgBCAJQQh2OgACIAQgAEEFdEEfcjoAACAEQQRqIQAgBEEDagwBCyAEQf8BOgAAIARBAWohAiAAQXlqIgdB/wFPBEAgAkH/ASAAQfp9aiICQf8BbiIAQQFqECgaIABBgX5sIAJqIQcgACAEaiIAQQJqIQIgAEEBaiEECyACIAc6AAAgBCAJQQh2OgADIARB/wE6AAIgBEEFaiEAIARBBGoLIAk6AAAgBiAPSQRAIAsgBi0AACAIQX5qLQAAQQh0ciAIQX9qLQAAQRB0ciAILQAAQRh0ckGx893xeWwgEHZBAXRqIAYgAWs7AQALIABBHzoAACAAQQFqIQRBACEGQQAhByAIQX9qCyIAIA9JDQALCyAAIAxBAWpNBEADQEEAIARBAmoiASANSw0CGiAEIAAtAAA6AAAgBEEBaiEEIAZBAWoiBkH/AXFBIEYEQCAEQR86AABBACEGIAEhBAsgACAMTSEBIABBAWohACABDQALCwJAIAZB/wFxBEAgBkF/c0GAfnIgBGogBkF/ajoAAAwBCyAEQX9qIQQLIAMgAy0AAEEgcjoAACAEIANrCyEGIAtBgIACaiQAIAYLJgBBACACIAMgACABIARBAXRBf2pBFiAEQQlIGxCnAiIAIAAQIRsLOwEBfyMAQRBrIgUkACAFIAM2AgwgAiAFQQxqIAAgASAEEKgCIQAgBSgCDCEBIAVBEGokAEEAIAEgABsLOQEBfyMAQRBrIgQkACAEIAM2AgwgACABIAIgBEEMahDGBCEAIAQoAgwhASAEQRBqJABBACABIAAbC2kCAX8BfiABIABuIQVBjOwBLQAARQRAEIYBQYzsAUEBOgAACyAFQQdxRQRAIAIgAyAFIAAgBEGc7AEoAgARDwAhBiADIAAgBWwiAGogACACaiABIABrECoaIAanDwsgAyACIAEQKhogBQsrAEGM7AEtAABFBEAQhgFBjOwBQQE6AAALIAAgASACIANBlOwBKAIAEQgAC8YFARd/A0ACQCAAKAIAIgEoAkxFBEAgASgCJCIFIAEoAihBAnRqIQsgACgCCCEGIAEoAgghCCABKAIEIQkgASgCNCENIAEoAiAhDiABKAIcIQIgASgCMCEUIAEoAgAhDyABKAIMLQAAIQECQCAFIAAoAhRMBEAgACgCECEQIAAoAgwhBwwBCyAGEDggACALIAVBAXRqEHkiBjYCCCAAIAUgBmoiBzYCDCAAIAcgC2oiEDYCEAsCfyABQQJxIhFFIA9BAEdxIhIEQCAAKAIAIgQgBCgCxBFBAWoiAzYCxBEgAgwBCyACIAIgACgCACIEKAJEIgFtIgMgAiABIANsa0EASmoiASAAKAIEbCIDIAFqIgEgASACShsLIRNBACEMIAMgE04NASAJQRBqIRUgCEEQaiEWIAJBf2ohF0EAIQoDQCAEKALAEUEBSA0CIA4gBSADIBdGIA5BAEpxIgIbIQFBASAKIAIbIQoCQCAPBEAgAyAFbCECIBEEQCACIBZqIAIgCWogARBQGgwCCyAEIAEgCkEAIAsgAiAJaiAHIAYgEBC0ASEBDAELIBEEQCAIIAMgBWwiAmogAiAVaiABEFAaDAELIAQgASAKIAkgDSADQQJ0aigAACAIIAMgBWxqIAYgBxCzASEBCyAAKAIAIgIoAsARQQFIDQIgAUF/TARAIAIgATYCwBEMAwsCQCASBEAgDSADQQJ0aiACKAIsIgQQNCAAKAIAIQIgAUEAIAEgBGogFEwbRQRAIAJBADYCwBEMBgsgAiACKALEEUEBaiIDNgLEESACIAIoAiwgAWo2AiwgBCAIaiAHIAEQUBoMAQsgASAMaiEMIANBAWohAwsgAyATTg0CIAAoAgAhBAwACwALIAAoAggQOCAAEDhBAA8LIBINACAAKAIAIgEoAsARQQFIDQAgASABKAIsIAxqNgIsDAALAAvyAQEIfyMAQSBrIgIkACAAQoGAgIBwNwLAESAAQZQRaiIFEAkaIAVBABAIGgJAIAAoAkRBAUgNAANAAkAgACAEQQJ0aiIGQdAIaiAENgIAQRgQeSIBIAQ2AgQgASAANgIAIAEgACgCJCIDIAAoAihBAnRqIgcgA0EBdGoQeSIDNgIIIAEgACgCJCIINgIUIAEgAyAIaiIDNgIMIAEgAyAHajYCECAGQdAAaiAFQREgARAaIgENACAEQQFqIgQgACgCREgNAQwCCwsgAiABNgIQQaURIAJBEGoQTyACIAEQuAE2AgBB1REgAhBPCyACQSBqJAALHAAgACAAKAIIIAFrNgIIIAAgACgCBCABajYCBAuBAQEDfyMAQSBrIgEkACAAKAJIQQFOBEAgAEEBNgJMA0AgACACQQJ0aigCUCABQRxqEAsiAwRAIAEgAzYCEEHYEiABQRBqEE8gASADELgBNgIAQdURIAEQTwsgAkEBaiICIAAoAkhIDQALIABBlBFqEAoaCyAAQQA2AkggAUEgaiQAC3UBAn8jAEEQayICJAACQCAAKAJEIgFBgQJOBEAgAkGAAjYCAEG7ECACEE8MAQsgAUEATARAQfkQQSsQcgwBCyAAAn9BASABQQFGDQAaIAEgASAAKAJIRg0AGiAAELcCIAAQtQIgACgCRAs2AkgLIAJBEGokAAv/AgEIfyAAKAIsIQQgACgCKEECdCAAKAIkQQF0ahB5IQUgACgCHCIGQQFOBEAgBSAAKAIkaiEIA0ACQCAAKAIARQ0AIAAoAgwtAABBAnENACAAKAI0IANBAnRqIAQQNCAAKAIcIQYLQQAhByAAKAIkIgIhASAGQX9qIANGBEAgACgCICIBIAIgAUEASiIHGyEBCyAAKAIMLQAAQQJxIQYCQCAAKAIABEAgBgRAIAIgA2wiAiAAKAIIakEQaiAAKAIEIAJqIAEQUBoMAgsgACABIAcgBCAAKAIwIAAoAgQgAiADbGogACgCCCAEaiAFIAgQtAEiAQ0BIAUQOEEADwsgBgRAIAIgA2wiAiAAKAIIaiAAKAIEIAJqQRBqIAEQUBoMAQsgACABIAcgACgCBCAAKAI0IANBAnRqKAAAIAAoAgggAiADbGogBSAIELMBIQELIAFBAEgEQCAFEDggAQ8LIAEgBGohBCADQQFqIgMgACgCHCIGSA0ACwsgBRA4IAQLEQAgASAAKAIINgIAIAAoAgQLhwEBAn8CQCAAKAIMLQAAQQJxBEAgACgCFEEQaiAAKAIwSg0BC0F/IQIgABCHASIBQQBIDQACQCABDQBBACEBIAAoAhRBEGogACgCMEoNACAAKAIMIgEgAS0AAEECcjoAACAAQRA2AiwgABCHASIBQQBIDQELIAAoAghBDGogARA0IAEhAgsgAgtUACAAQZgQEF1FBEBBAA8LIABBoBAQXUUEQEEBDwsgAEGkEBBdRQRAQQIPCyAAQaoQEF1FBEBBAw8LIABBsRAQXUUEQEEEDwtBf0EFIABBthAQXRsLIgEBfiABIAKtIAOtQiCGhCAEIAARFAAiBUIgiKcQBCAFpwseAQF+IAEgAiADIAQgBSAAEQ8AIgZCIIinEAQgBqcLKQAgACgCACABKAIANgIAIAAoAgAgASgCBDYCBCAAIAAoAgBBCGo2AgALBABCAAsEAEEACz4BA38DQCAAQQR0IgFBhO0BaiABQYDtAWoiAjYCACABQYjtAWogAjYCACAAQQFqIgBBwABHDQALQTAQtgEaCxsAIAAgASgCCCAFEEMEQCABIAIgAyAEEIwBCwuWAgEGfyAAIAEoAgggBRBDBEAgASACIAMgBBCMAQ8LIAEtADUhByAAKAIMIQYgAUEAOgA1IAEtADQhCCABQQA6ADQgAEEQaiIJIAEgAiADIAQgBRCJASAHIAEtADUiCnIhByAIIAEtADQiC3IhCAJAIAZBAkgNACAJIAZBA3RqIQkgAEEYaiEGA0AgAS0ANg0BAkAgCwRAIAEoAhhBAUYNAyAALQAIQQJxDQEMAwsgCkUNACAALQAIQQFxRQ0CCyABQQA7ATQgBiABIAIgAyAEIAUQiQEgAS0ANSIKIAdyIQcgAS0ANCILIAhyIQggBkEIaiIGIAlJDQALCyABIAdB/wFxQQBHOgA1IAEgCEH/AXFBAEc6ADQLkgEAIAAgASgCCCAEEEMEQCABIAIgAxCLAQ8LAkAgACABKAIAIAQQQ0UNAAJAIAIgASgCEEcEQCABKAIUIAJHDQELIANBAUcNASABQQE2AiAPCyABIAI2AhQgASADNgIgIAEgASgCKEEBajYCKAJAIAEoAiRBAUcNACABKAIYQQJHDQAgAUEBOgA2CyABQQQ2AiwLCzQBAX8jAEEQayICJAAgAiAANgIEIAIgASkCADcCCCACQQRqIAJBCGoQvwIgAkEQaiQAIAALoQQBBH8gACABKAIIIAQQQwRAIAEgAiADEIsBDwsCQCAAIAEoAgAgBBBDBEACQCACIAEoAhBHBEAgASgCFCACRw0BCyADQQFHDQIgAUEBNgIgDwsgASADNgIgIAEoAixBBEcEQCAAQRBqIgUgACgCDEEDdGohCCABAn8CQANAAkAgBSAITw0AIAFBADsBNCAFIAEgAiACQQEgBBCJASABLQA2DQACQCABLQA1RQ0AIAEtADQEQEEBIQMgASgCGEEBRg0EQQEhB0EBIQYgAC0ACEECcQ0BDAQLQQEhByAGIQMgAC0ACEEBcUUNAwsgBUEIaiEFDAELCyAGIQNBBCAHRQ0BGgtBAws2AiwgA0EBcQ0CCyABIAI2AhQgASABKAIoQQFqNgIoIAEoAiRBAUcNASABKAIYQQJHDQEgAUEBOgA2DwsgACgCDCEGIABBEGoiBSABIAIgAyAEEHogBkECSA0AIAUgBkEDdGohBiAAQRhqIQUCQCAAKAIIIgBBAnFFBEAgASgCJEEBRw0BCwNAIAEtADYNAiAFIAEgAiADIAQQeiAFQQhqIgUgBkkNAAsMAQsgAEEBcUUEQANAIAEtADYNAiABKAIkQQFGDQIgBSABIAIgAyAEEHogBUEIaiIFIAZJDQAMAgsACwNAIAEtADYNASABKAIkQQFGBEAgASgCGEEBRg0CCyAFIAEgAiADIAQQeiAFQQhqIgUgBkkNAAsLC28BAn8gACABKAIIQQAQQwRAIAEgAiADEIoBDwsgACgCDCEEIABBEGoiBSABIAIgAxC3AQJAIARBAkgNACAFIARBA3RqIQQgAEEYaiEAA0AgACABIAIgAxC3ASABLQA2DQEgAEEIaiIAIARJDQALCwsZACAAIAEoAghBABBDBEAgASACIAMQigELCzIAIAAgASgCCEEAEEMEQCABIAIgAxCKAQ8LIAAoAggiACABIAIgAyAAKAIAKAIcEQgAC/MBACAAIAEoAgggBBBDBEAgASACIAMQiwEPCwJAIAAgASgCACAEEEMEQAJAIAIgASgCEEcEQCABKAIUIAJHDQELIANBAUcNAiABQQE2AiAPCyABIAM2AiACQCABKAIsQQRGDQAgAUEAOwE0IAAoAggiACABIAIgAkEBIAQgACgCACgCFBEMACABLQA1BEAgAUEDNgIsIAEtADRFDQEMAwsgAUEENgIsCyABIAI2AhQgASABKAIoQQFqNgIoIAEoAiRBAUcNASABKAIYQQJHDQEgAUEBOgA2DwsgACgCCCIAIAEgAiADIAQgACgCACgCGBELAAsLOAAgACABKAIIIAUQQwRAIAEgAiADIAQQjAEPCyAAKAIIIgAgASACIAMgBCAFIAAoAgAoAhQRDAALoAIBBH8jAEFAaiIBJAAgACgCACICQXxqKAIAIQMgAkF4aigCACEEIAFB7OQBNgIQIAEgADYCDCABQfjkATYCCEEAIQIgAUEUakEAQSsQKBogACAEaiEAAkAgA0H45AFBABBDBEAgAUEBNgI4IAMgAUEIaiAAIABBAUEAIAMoAgAoAhQRDAAgAEEAIAEoAiBBAUYbIQIMAQsgAyABQQhqIABBAUEAIAMoAgAoAhgRCwACQAJAIAEoAiwOAgABAgsgASgCHEEAIAEoAihBAUYbQQAgASgCJEEBRhtBACABKAIwQQFGGyECDAELIAEoAiBBAUcEQCABKAIwDQEgASgCJEEBRw0BIAEoAihBAUcNAQsgASgCGCECCyABQUBrJAAgAgudAQEBfyMAQUBqIgMkAAJ/QQEgACABQQAQQw0AGkEAIAFFDQAaQQAgARDNAiIBRQ0AGiADQQhqQQRyQQBBNBAoGiADQQE2AjggA0F/NgIUIAMgADYCECADIAE2AgggASADQQhqIAIoAgBBASABKAIAKAIcEQgAIAMoAiAiAEEBRgRAIAIgAygCGDYCAAsgAEEBRgshACADQUBrJAAgAAsKACAAIAFBABBDCwwAIAAQjQEaIAAQOAsHACAAKAIECwkAIAAQjQEQOAsGAEG54wELPwEBf0EZEG0iAUEANgIIIAFCjICAgMABNwIAIAFBDGoiAUGx4wEpAAA3AAUgAUGs4wEpAAA3AAAgACABNgIAC4EBAQN/IwBBEGsiACQAAkAgAEEMaiAAQQhqEBQNAEH07AEgACgCDEECdEEEahBMIgE2AgAgAUUNACAAKAIIEEwiAUUEQEH07AFBADYCAAwBC0H07AEoAgAiAiAAKAIMQQJ0akEANgIAIAIgARATRQ0AQfTsAUEANgIACyAAQRBqJAALjgIBAX9BASECAkAgAAR/IAFB/wBNDQECQEHc7AEoAgBFBEAgAUGAf3FBgL8DRg0DDAELIAFB/w9NBEAgACABQT9xQYABcjoAASAAIAFBBnZBwAFyOgAAQQIPCyABQYCwA09BACABQYBAcUGAwANHG0UEQCAAIAFBP3FBgAFyOgACIAAgAUEMdkHgAXI6AAAgACABQQZ2QT9xQYABcjoAAUEDDwsgAUGAgHxqQf//P00EQCAAIAFBP3FBgAFyOgADIAAgAUESdkHwAXI6AAAgACABQQZ2QT9xQYABcjoAAiAAIAFBDHZBP3FBgAFyOgABQQQPCwtBsOwBQRk2AgBBfwUgAgsPCyAAIAE6AABBAQsJACAAKAI8EBULuAEBAX8gAUEARyECAkACQAJAIAFFIABBA3FFcg0AA0AgAC0AAEUNAiAAQQFqIQAgAUF/aiIBQQBHIQIgAUUNASAAQQNxDQALCyACRQ0BAkAgAC0AAEUgAUEESXINAANAIAAoAgAiAkF/cyACQf/9+3dqcUGAgYKEeHENASAAQQRqIQAgAUF8aiIBQQNLDQALCyABRQ0BCwNAIAAtAABFBEAgAA8LIABBAWohACABQX9qIgENAAsLQQALgwECA38BfgJAIABCgICAgBBUBEAgACEFDAELA0AgAUF/aiIBIABCCoAiBUJ2fiAAfKdBMHI6AAAgAEL/////nwFWIQIgBSEAIAINAAsLIAWnIgIEQANAIAFBf2oiASACQQpuIgNBdmwgAmpBMHI6AAAgAkEJSyEEIAMhAiAEDQALCyABCy0AIABQRQRAA0AgAUF/aiIBIACnQQdxQTByOgAAIABCA4giAEIAUg0ACwsgAQs1ACAAUEUEQANAIAFBf2oiASAAp0EPcUGw1AFqLQAAIAJyOgAAIABCBIgiAEIAUg0ACwsgAQvPAgEDfyMAQdABayIDJAAgAyACNgLMAUEAIQIgA0GgAWpBAEEoECgaIAMgAygCzAE2AsgBAkBBACABIANByAFqIANB0ABqIANBoAFqEI4BQQBIDQAgACgCTEEATgRAQQEhAgsgACgCACEEIAAsAEpBAEwEQCAAIARBX3E2AgALIARBIHEhBQJ/IAAoAjAEQCAAIAEgA0HIAWogA0HQAGogA0GgAWoQjgEMAQsgAEHQADYCMCAAIANB0ABqNgIQIAAgAzYCHCAAIAM2AhQgACgCLCEEIAAgAzYCLCAAIAEgA0HIAWogA0HQAGogA0GgAWoQjgEgBEUNABogAEEAQQAgACgCJBEBABogAEEANgIwIAAgBDYCLCAAQQA2AhwgAEEANgIQIAAoAhQaIABBADYCFEEACxogACAAKAIAIAVyNgIAIAJFDQALIANB0AFqJAAL1AIBB38jAEEgayIDJAAgAyAAKAIcIgQ2AhAgACgCFCEFIAMgAjYCHCADIAE2AhggAyAFIARrIgE2AhQgASACaiEEQQIhByADQRBqIQECfwJAAkAgACgCPCADQRBqQQIgA0EMahAFEI8BRQRAA0AgBCADKAIMIgVGDQIgBUF/TA0DIAEgBSABKAIEIghLIgZBA3RqIgkgBSAIQQAgBhtrIgggCSgCAGo2AgAgAUEMQQQgBhtqIgkgCSgCACAIazYCACAEIAVrIQQgACgCPCABQQhqIAEgBhsiASAHIAZrIgcgA0EMahAFEI8BRQ0ACwsgBEF/Rw0BCyAAIAAoAiwiATYCHCAAIAE2AhQgACABIAAoAjBqNgIQIAIMAQsgAEEANgIcIABCADcDECAAIAAoAgBBIHI2AgBBACAHQQJGDQAaIAIgASgCBGsLIQQgA0EgaiQAIAQLJAAgAEELTwR/IABBEGpBcHEiACAAQX9qIgAgAEELRhsFQQoLC0IBAX8jAEEQayIDJAAgACgCPCABpyABQiCIpyACQf8BcSADQQhqEA8QjwEhACADKQMIIQEgA0EQaiQAQn8gASAAGwshAQJ/IAAQ8gNBAWoiARBMIgJFBEBBAA8LIAIgACABECoLKgEBfyMAQRBrIgEkACABIAA2AgwgASgCDBCQARDgAiEAIAFBEGokACAACyoBAX8jAEEQayIAJAAgAEGmygE2AgxByMoBQQcgACgCDBAAIABBEGokAAsqAQF/IwBBEGsiACQAIABBh8oBNgIMQfDKAUEGIAAoAgwQACAAQRBqJAALKgEBfyMAQRBrIgAkACAAQZnIATYCDEGYywFBBSAAKAIMEAAgAEEQaiQACyoBAX8jAEEQayIAJAAgAEH7xwE2AgxBwMsBQQQgACgCDBAAIABBEGokAAudAQECfyACQXBJBEACQCACQQpNBEAgACACOgALIAAhAwwBCyAAIAIQ3gJBAWoiBBBtIgM2AgAgACAEQYCAgIB4cjYCCCAAIAI2AgQLIAIiAARAIAMgASAAECoaCyACIANqQQA6AAAPC0EIEA4iASICIgBB0OMBNgIAIABB/OMBNgIAIABBBGoQ1AIgAkGs5AE2AgAgAUG45AFBEBANAAsHACAAKAIICyoBAX8jAEEQayIAJAAgAEGHxgE2AgxBsM0BQQAgACgCDBAAIABBEGokAAsqAQF/IwBBEGsiACQAIABBmMUBNgIMQYjoASAAKAIMQQgQBiAAQRBqJAALKgEBfyMAQRBrIgAkACAAQZLFATYCDEH85wEgACgCDEEEEAYgAEEQaiQACy4BAX8jAEEQayIAJAAgAEGExQE2AgxB8OcBIAAoAgxBBEEAQX8QASAAQRBqJAALNgEBfyMAQRBrIgAkACAAQf/EATYCDEHk5wEgACgCDEEEQYCAgIB4Qf////8HEAEgAEEQaiQACy4BAX8jAEEQayIAJAAgAEHyxAE2AgxB2OcBIAAoAgxBBEEAQX8QASAAQRBqJAALNgEBfyMAQRBrIgAkACAAQe7EATYCDEHM5wEgACgCDEEEQYCAgIB4Qf////8HEAEgAEEQaiQACzABAX8jAEEQayIAJAAgAEHfxAE2AgxBwOcBIAAoAgxBAkEAQf//AxABIABBEGokAAsyAQF/IwBBEGsiACQAIABB2cQBNgIMQbTnASAAKAIMQQJBgIB+Qf//ARABIABBEGokAAsvAQF/IwBBEGsiACQAIABBy8QBNgIMQZznASAAKAIMQQFBAEH/ARABIABBEGokAAswAQF/IwBBEGsiACQAIABBv8QBNgIMQajnASAAKAIMQQFBgH9B/wAQASAAQRBqJAALMAEBfyMAQRBrIgAkACAAQbrEATYCDEGQ5wEgACgCDEEBQYB/Qf8AEAEgAEEQaiQACyYBAX8jAEEQayIAJAAgAEGk7AE2AgwgACgCDBoQwwEgAEEQaiQAC+gLAg9/AX4jAEHwAGsiByQAIAcgACgC8OEBIgg2AlQgASACaiEOIAggACgCgOIBaiEPIAEhCgJAAkAgBUUNACAAKALE4AEhECAAKALA4AEhESAAKAK84AEhDSAAQQE2AozhASAHIABBtNABaigCADYCRCAHIABBrNABaiISKQIANwI8IAdBEGogAyAEEEUQIQRAQWwhAAwCCyAHQTxqIRMgB0EkaiAHQRBqIAAoAgAQaCAHQSxqIAdBEGogACgCCBBoIAdBNGogB0EQaiAAKAIEEGggDkFgaiEUA0ACQAJAIAVFIAdBEGoQI0ECS3JFBEAgBygCKCAHKAIkQQN0aiIALQACIQIgBygCOCAHKAI0QQN0aiIELQACIQMgBCgCBCEMIAAoAgQhBAJAIAcoAjAgBygCLEEDdGoiCC0AAiIARQRAQQAhCQwBCyAIKAIEIQggBkUgAEEZSXJFBEAgCCAHQRBqIABBICAHKAIUayIIIAggAEsbIggQQiAAIAhrIgB0aiEJIAdBEGoQIxogAEUNAyAHQRBqIAAQQiAJaiEJDAMLIAdBEGogABBCIAhqIQkgB0EQahAjGiAAQQFLDQILAkACQAJAAkACQCAJIARFaiIADgQEAQEAAQsgBygCPEF/aiIAIABFaiEJDAELIABBAnQgB2ooAjwiCCAIRWohCSAAQQFGDQELIAcgBygCQDYCRAsgByAHKAI8NgJAIAcgCTYCPAwDCyAHKAI8IQkMAgsgBQRAQWwhAAwFC0FsIQAgB0EQahAjQQJJDQQgEiATKQIANwIAIBIgEygCCDYCCCAHKAJUIQgMAwsgBykCPCEWIAcgCTYCPCAHIBY3A0ALIAIgA2ohACADBH8gB0EQaiADEEIFQQALIQggAEEUTwRAIAdBEGoQIxoLIAggDGohCyACBH8gB0EQaiACEEIFQQALIQggB0EQahAjGiAHIAcoAiggBygCJEEDdGoiAC8BACAHQRBqIAAtAAMQRmo2AiQgByAHKAI4IAcoAjRBA3RqIgAvAQAgB0EQaiAALQADEEZqNgI0IAdBEGoQIxogByAHKAIwIAcoAixBA3RqIgAvAQAgB0EQaiAALQADEEZqNgIsIAcgBCAIaiIANgJYIAcgCTYCYCAHIAs2AlwgBygCVCEMIAcgACAKaiIEIAlrIgI2AmgCfwJAIAogACALaiIDaiAUTQRAIAAgDGoiFSAPTQ0BCyAHIAcpA2A3AwggByAHKQNYNwMAIAogDiAHIAdB1ABqIA8gDSARIBAQkwEMAQsgCiAMEBwCQCAAQRFJDQAgCkEQaiAMQRBqIggQHCAKQSBqIAxBIGoQHCAAQXBqQSFIDQAgCkEwaiEAA0AgACAIQSBqIgwQHCAAQRBqIAhBMGoQHCAMIQggAEEgaiIAIARJDQALCyAHIBU2AlQgByAENgJsAkAgCSAEIA1rSwRAQWwgCSAEIBFrSw0CGiAQIAIgDWsiAGoiAiALaiAQTQRAIAQgAiALEEoaDAILIAQgAkEAIABrEEohAiAHIAAgC2oiCzYCXCAHIAIgAGsiBDYCbCAHIA02AmggDSECCyAJQRBPBEAgBCACEBwgBEEQaiACQRBqEBwgC0EhSA0BIAQgC2ohCCAEQSBqIQADQCAAIAJBIGoiBBAcIABBEGogAkEwahAcIAQhAiAAQSBqIgAgCEkNAAsMAQsgB0HsAGogB0HoAGogCRB8IAtBCUkNACALIAcoAmwiCGpBeGohBCAIIAcoAmgiAGtBD0wEQANAIAggABBnIABBCGohACAIQQhqIgggBEkNAAwCCwALIAggABAcIAhBEGogAEEQahAcIAtBKUgNACAIQSBqIQgDQCAIIABBIGoiAhAcIAhBEGogAEEwahAcIAIhACAIQSBqIgggBEkNAAsLIAMLIQAgBUF/aiEFIAAgCmohCiAAECFFDQALDAELQbp/IQAgDyAIayICIA4gCmtLDQAgCiAIIAIQKiACaiABayEACyAHQfAAaiQAIAALkBgCGX8CfiMAQdABayIHJAAgByAAKALw4QEiCDYCtAEgASACaiESIAggACgCgOIBaiETIAEhCgJAIAUEQCAAKALE4AEhECAAKALA4AEhFCAAKAK84AEhDiAAQQE2AozhASAHIABBtNABaigCADYCXCAHIABBrNABaiIXKQIANwJUIAcgEDYCZCAHIA42AmAgByABIA5rNgJoQWwhDyAHQShqIAMgBBBFECENASAFQQQgBUEESBshFiAHQTxqIAdBKGogACgCABBoIAdBxABqIAdBKGogACgCCBBoIAdBzABqIAdBKGogACgCBBBoQQAhCCAFQQBKIQICQCAFQQFIIAdBKGoQI0ECS3INACAHQeAAaiELIAdB5ABqIQwDQCAHKAJAIAcoAjxBA3RqIgAtAAIhAyAHKAJQIAcoAkxBA3RqIgItAAIhBCACKAIEIQ0gACgCBCEJQQAhAAJAAkAgBygCSCAHKAJEQQN0aiIKLQACIgIEQCAKKAIEIQACQCAGBEAgACAHQShqIAJBGCACQRhJGyIAEEIgAiAAayIKdGohACAHQShqECMaIApFDQEgB0EoaiAKEEIgAGohAAwBCyAHQShqIAIQQiAAaiEAIAdBKGoQIxoLIAJBAUsNAQsCQAJAAkACQAJAIAAgCUVqIgIOBAQBAQABCyAHKAJUQX9qIgAgAEVqIQAMAQsgAkECdCAHaigCVCIAIABFaiEAIAJBAUYNAQsgByAHKAJYNgJcCyAHIAcoAlQ2AlggByAANgJUDAILIAcoAlQhAAwBCyAHKQJUISAgByAANgJUIAcgIDcDWAsgAyAEaiECIAQEfyAHQShqIAQQQgVBAAshCiACQRRPBEAgB0EoahAjGgsgCiANaiEEIAMEfyAHQShqIAMQQgVBAAshAiAHQShqECMaIAcgAiAJaiIKIAcoAmhqIgMgBGo2AmggDCALIAAgA0sbKAIAIQkgByAHKAJAIAcoAjxBA3RqIgIvAQAgB0EoaiACLQADEEZqNgI8IAcgBygCUCAHKAJMQQN0aiICLwEAIAdBKGogAi0AAxBGajYCTCAHQShqECMaIAcoAkggBygCREEDdGoiAi8BACENIAdBKGogAi0AAxBGIREgB0HwAGogCEEEdGoiAiADIAlqIABrNgIMIAIgADYCCCACIAQ2AgQgAiAKNgIAIAcgDSARajYCRCAIQQFqIgggFkghAiAHQShqECMhACAIIBZODQEgAEEDSQ0ACwsgAg0BIAggBUghAiAHQShqECMhAAJAIAggBU4EQCABIQoMAQsgAEECSwRAIAEhCgwBCyASQWBqIRogB0HgAGohGyAHQeQAaiEcIAEhCgNAIAcoAkAgBygCPEEDdGoiAC0AAiEDIAcoAlAgBygCTEEDdGoiBC0AAiECIAQoAgQhDCAAKAIEIQRBACELAkACQCAHKAJIIAcoAkRBA3RqIgktAAIiAARAIAkoAgQhCQJAIAYEQCAJIAdBKGogAEEYIABBGEkbIgkQQiAAIAlrIgl0aiELIAdBKGoQIxogCUUNASAHQShqIAkQQiALaiELDAELIAdBKGogABBCIAlqIQsgB0EoahAjGgsgAEEBSw0BCwJAAkACQAJAAkAgCyAERWoiAA4EBAEBAAELIAcoAlRBf2oiACAARWohCwwBCyAAQQJ0IAdqKAJUIgkgCUVqIQsgAEEBRg0BCyAHIAcoAlg2AlwLIAcgBygCVDYCWCAHIAs2AlQMAgsgBygCVCELDAELIAcpAlQhICAHIAs2AlQgByAgNwNYCyACIANqIQAgAgR/IAdBKGogAhBCBUEACyECIABBFE8EQCAHQShqECMaCyACIAxqIRggAwR/IAdBKGogAxBCBUEACyEAIAdBKGoQIxogByAAIARqIh0gBygCaGoiGSAYajYCaCAcIBsgCyAZSxsoAgAhHiAHIAcoAkAgBygCPEEDdGoiAC8BACAHQShqIAAtAAMQRmo2AjwgByAHKAJQIAcoAkxBA3RqIgAvAQAgB0EoaiAALQADEEZqNgJMIAdBKGoQIxogByAHKAJIIAcoAkRBA3RqIgAvAQAgB0EoaiAALQADEEZqNgJEIAcgB0HwAGogCEEDcUEEdGoiESkDCCIgNwPAASAHIBEpAwAiITcDuAEgBygCtAEhACAHKAK8ASENIAcgCiAhpyIJaiIMICCnIhVrIgM2AsgBAn8CQCAAIAlqIh8gE00EQCAKIAkgDWoiBGogGk0NAQsgByAHKQPAATcDICAHIAcpA7gBNwMYIAogEiAHQRhqIAdBtAFqIBMgDiAUIBAQkwEMAQsgCiAAEBwCQCAJQRFJDQAgCkEQaiAAQRBqIgIQHCAKQSBqIABBIGoQHCAJQXBqQSFIDQAgCkEwaiEAA0AgACACQSBqIgkQHCAAQRBqIAJBMGoQHCAJIQIgAEEgaiIAIAxJDQALCyAHIB82ArQBIAcgDDYCzAECQCAVIAwgDmtLBEBBbCAVIAwgFGtLDQIaIBAgAyAOayIAaiICIA1qIBBNBEAgDCACIA0QShoMAgsgDCACQQAgAGsQSiECIAcgACANaiINNgK8ASAHIAIgAGsiDDYCzAEgByAONgLIASAOIQMLIBVBEE8EQCAMIAMQHCAMQRBqIANBEGoQHCANQSFIDQEgDCANaiEJIAxBIGohAANAIAAgA0EgaiICEBwgAEEQaiADQTBqEBwgAiEDIABBIGoiACAJSQ0ACwwBCyAHQcwBaiAHQcgBaiAVEHwgDUEJSQ0AIA0gBygCzAEiAmpBeGohCSACIAcoAsgBIgBrQQ9MBEADQCACIAAQZyAAQQhqIQAgAkEIaiICIAlJDQAMAgsACyACIAAQHCACQRBqIABBEGoQHCANQSlIDQAgAkEgaiECA0AgAiAAQSBqIgMQHCACQRBqIABBMGoQHCADIQAgAkEgaiICIAlJDQALCyAECyIAECEEQCAAIQ8MBAsgESAdNgIAIBEgGSAeaiALazYCDCARIAs2AgggESAYNgIEIAAgCmohCiAIQQFqIgggBUghAiAHQShqECMhACAIIAVODQEgAEEDSQ0ACwsgAg0BIAggFmsiDCAFSARAIBJBYGohDQNAIAcgB0HwAGogDEEDcUEEdGoiACkDCCIgNwPAASAHIAApAwAiITcDuAEgBygCtAEhACAHKAK8ASELIAcgCiAhpyIGaiIEICCnIglrIgI2AsgBAn8CQCAAIAZqIg8gE00EQCAKIAYgC2oiA2ogDU0NAQsgByAHKQPAATcDECAHIAcpA7gBNwMIIAogEiAHQQhqIAdBtAFqIBMgDiAUIBAQkwEMAQsgCiAAEBwCQCAGQRFJDQAgCkEQaiAAQRBqIggQHCAKQSBqIABBIGoQHCAGQXBqQSFIDQAgCkEwaiEAA0AgACAIQSBqIgYQHCAAQRBqIAhBMGoQHCAGIQggAEEgaiIAIARJDQALCyAHIA82ArQBIAcgBDYCzAECQCAJIAQgDmtLBEBBbCAJIAQgFGtLDQIaIBAgAiAOayIAaiICIAtqIBBNBEAgBCACIAsQShoMAgsgBCACQQAgAGsQSiECIAcgACALaiILNgK8ASAHIAIgAGsiBDYCzAEgByAONgLIASAOIQILIAlBEE8EQCAEIAIQHCAEQRBqIAJBEGoQHCALQSFIDQEgBCALaiEGIARBIGohAANAIAAgAkEgaiIEEBwgAEEQaiACQTBqEBwgBCECIABBIGoiACAGSQ0ACwwBCyAHQcwBaiAHQcgBaiAJEHwgC0EJSQ0AIAsgBygCzAEiCGpBeGohBCAIIAcoAsgBIgBrQQ9MBEADQCAIIAAQZyAAQQhqIQAgCEEIaiIIIARJDQAMAgsACyAIIAAQHCAIQRBqIABBEGoQHCALQSlIDQAgCEEgaiEIA0AgCCAAQSBqIgIQHCAIQRBqIABBMGoQHCACIQAgCEEgaiIIIARJDQALCyADCyIPECENAyAKIA9qIQogDEEBaiIMIAVHDQALCyAXIAcpAlQ3AgAgFyAHKAJcNgIIIAcoArQBIQgLQbp/IQ8gEyAIayIAIBIgCmtLDQAgCiAIIAAQKiAAaiABayEPCyAHQdABaiQAIA8LQQEDfyAAQQhqIQMgACgCBCECQQAhAANAIAEgAyAAQQN0ai0AAkEWS2ohASAAQQFqIgAgAnZFDQALIAFBCCACa3QLJQAgAEIANwIAIABBADsBCCAAQQA6AAsgACABNgIMIAAgAjoACguUAwEFf0G4fyEHAkACQCADRQ0AIAItAAAiBEUNAQJ/IAJBAWoiBSAEQRh0QRh1IgZBf0oNABogBkF/RgRAIANBA0gNAiAFLwAAQYD+AWohBCACQQNqDAELIANBAkgNASACLQABIARBCHRyQYCAfmohBCACQQJqCyEFIAEgBDYCACAFQQFqIgEgAiADaiIDSw0AQWwhByAAQRBqIAAgBS0AACIFQQZ2QSNBCSABIAMgAWtB4LABQfCxAUGAswEgACgCjOEBIAAoApziASAEEJQBIgYQISIIDQAgAEGYIGogAEEIaiAFQQR2QQNxQR9BCCABIAEgBmogCBsiASADIAFrQZC3AUGQuAFBkLkBIAAoAozhASAAKAKc4gEgBBCUASIGECEiCA0AIABBoDBqIABBBGogBUECdkEDcUE0QQkgASABIAZqIAgbIgEgAyABa0GguwFBgL0BQeC+ASAAKAKM4QEgACgCnOIBIAQQlAEiABAhDQAgACABaiACayEHCyAHDwsgAUEANgIAQQFBuH8gA0EBRhsLygYBCH9BbCEIAkAgAkEDSQ0AAkACQAJAAkAgAS0AACIEQQNxIglBAWsOAwMBAAILIAAoAojhAQ0AQWIPCyACQQVJDQJBAyEGIAEoAAAhBQJ/AkACQAJAIARBAnZBA3EiB0F+ag4CAQIACyAFQQ52Qf8HcSEEIAVBBHZB/wdxIQMgB0UMAgsgBUESdiEEQQQhBiAFQQR2Qf//AHEhA0EADAELIAVBBHZB//8PcSIDQYCACEsNAyABLQAEQQp0IAVBFnZyIQRBBSEGQQALIQUgBCAGaiIKIAJLDQICQCADQYEGSQ0AIAAoApziAUUNAEEAIQIDQCACQcT/AEkhByACQUBrIQIgBw0ACwsCfyAJQQNGBEAgASAGaiEBIABB4OIBaiECIAAoAgwhBiAFBEAgAiADIAEgBCAGEJMDDAILIAIgAyABIAQgBhCQAwwBCyAAQbjQAWohAiABIAZqIQEgAEHg4gFqIQYgAEGo0ABqIQcgBQRAIAcgBiADIAEgBCACEJEDDAELIAcgBiADIAEgBCACEI4DCxAhDQIgACADNgKA4gEgAEEBNgKI4QEgACAAQeDiAWo2AvDhASAJQQJGBEAgACAAQajQAGo2AgwLIAAgA2oiAEH44gFqQgA3AAAgAEHw4gFqQgA3AAAgAEHo4gFqQgA3AAAgAEHg4gFqQgA3AAAgCg8LQQIhAwJ/AkACQAJAIARBAnZBA3FBf2oOAwEAAgALQQEhAyAEQQN2DAILIAEvAABBBHYMAQtBAyEDIAEQlQFBBHYLIgQgA2oiBUEgaiACSwRAIAUgAksNAiAAQeDiAWogASADaiAEECohASAAIAQ2AoDiASAAIAE2AvDhASABIARqIgBCADcAGCAAQgA3ABAgAEIANwAIIABCADcAACAFDwsgACAENgKA4gEgACABIANqNgLw4QEgBQ8LQQIhAwJ/AkACQAJAIARBAnZBA3FBf2oOAwEAAgALQQEhAyAEQQN2DAILIAEvAABBBHYMAQsgAkEESSABEJUBIgJBj4CAAUtyDQFBAyEDIAJBBHYLIQIgAEHg4gFqIAEgA2otAAAgAkEgahAoIQEgACACNgKA4gEgACABNgLw4QEgA0EBaiEICyAIC8kDAQZ/IwBBgAFrIgMkAEFiIQgCQCACQQlJDQAgAEGY0ABqIAFBCGoiBCACQXhqIAAQzgEiBRAhIgYNACADQR82AnwgAyADQfwAaiADQfgAaiAEIAQgBWogBhsiBCABIAJqIgIgBGsQayIFECENACADKAJ8IgZBH0sNACADKAJ4IgdBCU8NACAAQYggaiADIAZB4KsBQeCsASAHEH0gA0E0NgJ8IAMgA0H8AGogA0H4AGogBCAFaiIEIAIgBGsQayIFECENACADKAJ8IgZBNEsNACADKAJ4IgdBCk8NACAAQZAwaiADIAZB4K0BQZCkASAHEH0gA0EjNgJ8IAMgA0H8AGogA0H4AGogBCAFaiIEIAIgBGsQayIFECENACADKAJ8IgZBI0sNACADKAJ4IgdBCk8NACAAIAMgBkHArwFBsKcBIAcQfSAEIAVqIgRBDGoiBSACSw0AIAQoAAAiBkF/aiACIAVrIgJPDQAgACAGNgKc0AEgBEEEaiIEKAAAIgVBf2ogAk8NACAAQaDQAWogBTYCACAEQQRqIgQoAAAiBUF/aiACTw0AIABBpNABaiAFNgIAIAQgAWtBBGohCAsgA0GAAWokACAICy0BAX8gAARAQbp/IQQgAyABTQR/IAAgAiADECgaIAMFIAQLDwtBtn9BACADGwstAQF/IAAEQEG6fyEEIAMgAU0EfyAAIAIgAxAqGiADBSAECw8LQbZ/QQAgAxsLpAICBH8BfiMAQRBrIgckAEG4fyEFAkAgBEH//wdLDQAgAEHY4AFqKQMAIQkgACADIAQQ+gIiBRAhIgYNACAAKAKc4gEhCCAAIAdBDGogAyADIAVqIAYbIgMgBEEAIAUgBhtrIgYQ+QIiBRAhDQAgCUKAgIAQViEEIAYgBWshBiADIAVqIQUCQAJAIAgEQCAAQQA2ApziASAHKAIMIQMMAQsCQAJAIAApA9jgAUKAgIAIWARAIAcoAgwhAwwBCyAHKAIMIgNBBEoNAQsgAEEANgKc4gEMAgsgACgCCBD3AiEIIABBADYCnOIBIAhBFEkNAQsgACABIAIgBSAGIAMgBBD2AiEFDAELIAAgASACIAUgBiADIAQQ9QIhBQsgB0EQaiQAIAULaQAgAEHQ4AFqIAEgAiAAKALs4QEQiAMiARAhBEAgAQ8LQbh/IQICQCABDQAgAEHs4AFqKAIAIgEEQEFgIQIgACgCmOIBIAFHDQELQQAhAiAAQfDgAWooAgBFDQAgAEGQ4QFqEIYCCyACC2wBAX8CfwJAAkAgAkEHTQ0AIAEoAABBt8jC4X5HDQAgACABKAAENgKY4gFBYiAAQRBqIAEgAhD7AiIDECENAhogAEKBgICAEDcDiOEBIAAgASADaiACIANrEMYBDAELIAAgASACEMYBC0EACwvIAwIHfwF+IwBBEGsiCSQAQbh/IQcCQCAEKAIAIghBBUEJIAAoAuzhASIFG0kNACADKAIAIgZBAUEFIAUbIAUQlwEiBRAhBEAgBSEHDAELIAggBUEDakkNACAAIAYgBRD/AiIHECENACAFIAZqIgYgCCAFayIIIAkQxwEiBRAhBEAgBSEHDAELIAEgAmohCiAAQZDhAWohCyABIQIDQCAIQX1qIgggBUkEQEG4fyEHDAILIAZBA2ohBkFsIQcCfwJAAkACQCAJKAIADgMBAgAFCyAAIAIgCiACayAGIAUQ/gIMAgsgAiAKIAJrIAYgBRD9AgwBCyACIAogAmsgBi0AACAJKAIIEPwCCyIHECENASAAKALw4AEEQCALIAIgBxCFAgsgCCAFayEIIAUgBmohBiACIAdqIQIgCSgCBEUEQCAGIAggCRDHASIFIQcgBRAhRQ0BDAILCyAAKQPQ4AEiDEJ/UgRAQWwhByAMIAIgAWusUg0BCyADIAAoAvDgAQR/QWohByAIQQRJDQEgCxCEAiEMIAYoAAAgDKdHDQEgCEF8aiEIIAZBBGoFIAYLNgIAIAQgCDYCACACIAFrIQcLIAlBEGokACAHCzAAIAAQyQECf0EAQQAQIQ0AGiABRSACRXJFBEBBYiAAIAEgAhCAAxAhDQEaC0EACws5ACABBEAgACAAKALE4AEgASgCBCABKAIIakc2ApziAQsgABDJAUEAECEgAUVyRQRAIAAgARCYAwsLLwACf0G4fyABQQhJDQAaQXIgACgABCIAQXdLDQAaQbh/IABBCGoiACAAIAFLGwsL3gIBB38jAEEQayIHJAAgBQR/IAUoAgQhCiAFKAIIBUEACyELAkACQCAAKALs4QEiCRBpIARLBEAgASEIDAELIAEhCANAAkAgAygAAEFwcUHQ1LTCAUYEQCADIAQQhAMiBhAhDQEgAyAGaiEDIAQgBmsiBCAJEGlPDQIgByAENgIIIAcgAzYCDAwDCyAHIAQ2AgggByADNgIMAkAgBQRAIAAgBRCDA0EAIQZBABAhRQ0BDAULIAAgCiALEIIDIgYQIQ0ECyAAIAgQhwNBACAAIAggAiAHQQxqIAdBCGoQgQMiBiIDa0EAIAMQIRtBCkYgDHEEQEG4fyEGDAQLIAYQIQ0DIAYgCGohCCAHKAIIIgQgACgC7OEBIgkQaUkNAiACIAZrIQJBASEMIAcoAgwhAwwBCwsgByAENgIIIAcgAzYCDAwBC0G4fyEGIAQNACAIIAFrIQYLIAdBEGokACAGCzMAAkACQAJAIAAoAqDiAUEBag4DAgABAAsgABDKAUEADwsgAEEANgKg4gELIAAoApTiAQtGAQJ/IAEgACgCuOABIgJHBEAgACACNgLE4AEgACABNgK44AEgACgCvOABIQMgACABNgK84AEgACABIAMgAmtqNgLA4AELC7EEAgR/An4gAEIANwMgIABCADcDGCAAQgA3AxAgAEIANwMIIABCADcDACADEGkiBCACSwRAIAQPCyABRQRAQX8PCwJAAkACQAJAAkACQAJ/IANBAUYEQCABIAJBARCXAQwBCyABKAAAIgZBqOq+aUcNASABIAIgAxCXAQsiAyACSw0FIAAgAzYCGEFyIQMgASAEaiIFQX9qLQAAIgJBCHENBSACQSBxIgZFBEBBcCEDIAUtAAAiBUGnAUsNBiAFQQdxrUIBIAVBA3ZBCmqthiIIQgOIfiAIfCEJIARBAWohBAsgAkEGdiEFIAJBAnYhB0EAIQMgAkEDcUF/ag4DAQIDBAtBdiEDIAZBcHFB0NS0wgFHDQRBCCEDIAJBCEkNBCAAQgA3AwAgAEIANwMgIABCADcDGCAAQgA3AxAgAEIANwMIIAEoAAQhASAAQQE2AhQgACABrTcDAEEADwsgASAEai0AACEDIARBAWohBAwCCyABIARqLwAAIQMgBEECaiEEDAELIAEgBGooAAAhAyAEQQRqIQQLIAdBAXEhAgJ+AkACQAJAAkAgBUF/ag4DAQIDAAtCfyAGRQ0DGiABIARqMQAADAMLIAEgBGovAACtQoACfAwCCyABIARqKAAArQwBCyABIARqKQAACyEIIAAgAjYCICAAIAM2AhwgACAINwMAQQAhAyAAQQA2AhQgACAIIAkgBhsiCDcDCCAAIAhCgIAIIAhCgIAIVBs+AhALIAMLXQEDfwJAIABFDQAgACgCiOIBDQAgAEH84QFqKAIAIQEgAEH44QFqKAIAIQIgACgC9OEBIQMgABDKASAAKAKo4gEgAyACIAEQZCAAQQA2AqjiASAAIAMgAiABEGQLC6kBAQF/IwBBIGsiASQAIABBgYCAwAA2ArTiASAAQQA2AojiASAAQQA2AuzhASAAQgA3A5DiASAAQQA2AtziASAAQgA3AsziASAAQQA2ArziASAAQQA2AsTgASAAQgA3ApziASAAQaTiAWpCADcCACAAQaziAWpBADYCACABQRBqEOABIAEgASkDGDcDCCABIAEpAxA3AwAgACABEN8BNgKM4gEgAUEgaiQACzkBAn9BmOMJQQBBABCHAiIABH8gAEEANgL84QEgAEEANgL44QEgAEEANgL04QEgABCKAyAABSABCws8AQF/IAAgAyAEIAUQzwEiBRAhBEAgBQ8LQbh/IQYgBSAESQR/IAEgAiADIAVqIAQgBWsgABDLAQUgBgsLPAEBfyAAIAMgBCAFEM4BIgUQIQRAIAUPC0G4fyEGIAUgBEkEfyABIAIgAyAFaiAEIAVrIAAQzAEFIAYLCz4AIAJFBEBBun8PCyAERQRAQWwPCyACIAQQlAMEQCAAIAEgAiADIAQgBRCNAw8LIAAgASACIAMgBCAFEIwDCwcAIAARCQALSwEBfyMAQRBrIgUkACAFQQhqIAQoAgAQNAJ/IAUtAAkEQCAAIAEgAiADIAQQzAEMAQsgACABIAIgAyAEEMsBCyEEIAVBEGokACAECzwBAX8gACADIAQgBRDPASIFECEEQCAFDwtBuH8hBiAFIARJBH8gASACIAMgBWogBCAFayAAEM0BBSAGCwv/AwEDfyMAQSBrIgUkACAFQQhqIAIgAxBFIgIQIUUEQCAFIAQoAgAQNCAEQQRqIQIgBS0AAiEDAkAgBUEIahAjIAAgAWoiB0F9aiIGIABNcg0AA0AgACACIAUoAgggBSgCDCADEClBAnRqIgQvAQA7AAAgBUEIaiAELQACECYgACAELQADaiIEIAIgBSgCCCAFKAIMIAMQKUECdGoiAC8BADsAACAFQQhqIAAtAAIQJiAEIAAtAANqIQAgBUEIahAjDQEgACAGSQ0ACwsCQCAFQQhqECMgACAHQX5qIgRLcg0AA0AgACACIAUoAgggBSgCDCADEClBAnRqIgYvAQA7AAAgBUEIaiAGLQACECYgACAGLQADaiEAIAVBCGoQIw0BIAAgBE0NAAsLIAAgBE0EQANAIAAgAiAFKAIIIAUoAgwgAxApQQJ0aiIGLwEAOwAAIAVBCGogBi0AAhAmIAAgBi0AA2oiACAETQ0ACwsCQCAAIAdPDQAgACACIAUoAgggBSgCDCADECkiA0ECdGoiAC0AADoAACAALQADQQFGBEAgBUEIaiAALQACECYMAQsgBSgCDEEfSw0AIAVBCGogAiADQQJ0ai0AAhAmIAUoAgxBIUkNACAFQSA2AgwLIAFBbCAFKAIMIAUoAhAgBSgCFBBLGyECCyAFQSBqJAAgAgtLAQF/IwBBEGsiBSQAIAVBCGogBCgCABA0An8gBS0ACQRAIAAgASACIAMgBBCSAwwBCyAAIAEgAiADIAQQzQELIQQgBUEQaiQAIAQLXQEBf0EPIQIgASAASQRAIAFBBHQgAG4hAgsgAEEIdiIBIAJBGGwiAEHMqAFqKAIAbCAAQcioAWooAgBqIgJBA3YgAmogAEHAqAFqKAIAIABBxKgBaigCACABbGpJC8wCAQR/IwBBQGoiCSQAIAkgAygCMDYCMCAJIAMpAig3AyggCSADKQIgNwMgIAkgAykCGDcDGCAJIAMpAhA3AxAgCSADKQIINwMIIAkgAykCADcDAAJAIARBAkgNACAJIARBAnRqKAIAIQQgCUE8aiAIEC8gCUEBOgA/IAkgAjoAPiAERQ0AQQAhAyAJKAI8IQoDQCAAIANBAnRqIAo2AQAgA0EBaiIDIARHDQALCyAGBEBBACEEA0AgCSAFIARBAXRqIgotAAEiC0ECdGoiDCgCACEDIAlBPGogCi0AAEEIdCAIakH//wNxEC8gCUECOgA/IAkgByALayIKIAJqOgA+IANBASABIAprdGohCiAJKAI8IQsDQCAAIANBAnRqIAs2AQAgA0EBaiIDIApJDQALIAwgCjYCACAEQQFqIgQgBkcNAAsLIAlBQGskAAvdAgEJfyMAQdAAayIJJAAgCUFAayAFKAIwNgIAIAkgBSkCKDcDOCAJIAUpAiA3AzAgCSAFKQIYNwMoIAkgBSkCEDcDICAJIAUpAgA3AxAgCSAFKQIINwMYIAMEQCAHIAZrIQ8gByABayEQA0BBASABIAcgAiALQQF0aiIGLQABIgxrIghrIgp0IQ0gBi0AACEOIAlBEGogDEECdGoiDCgCACEGAkAgCiAPTwRAIAAgBkECdGogCiAIIAUgCEE0bGogCCAQaiIIQQEgCEEBShsiCCACIAQgCEECdGooAgAiCEEBdGogAyAIayAHIA4QlQMgBiANaiEIDAELIAlBDGogDhAvIAlBAToADyAJIAg6AA4gBiAGIA1qIghPDQAgCSgCDCEKA0AgACAGQQJ0aiAKNgEAIAZBAWoiBiAIRw0ACwsgDCAINgIAIAtBAWoiCyADRw0ACwsgCUHQAGokAAs+AQN/IAAEQCAAKAIAIABBvNABaigCACIBIABBwNABaigCACICIABBxNABaigCACIDEGQgACABIAIgAxBkCwvMAQEBfyAAIAEoArTQATYCmOIBIAAgASgCBCICNgLA4AEgACACNgK84AEgACACIAEoAghqIgI2ArjgASAAIAI2AsTgASABKAK40AEEQCAAQoGAgIAQNwOI4QEgACABQaTQAGo2AgwgACABQZQgajYCCCAAIAFBnDBqNgIEIAAgAUEMajYCACAAQazQAWogAUGo0AFqKAIANgIAIABBsNABaiABQazQAWooAgA2AgAgAEG00AFqIAFBsNABaigCADYCAA8LIABCADcDiOEBC6JIAS5/IwBB4ABrIhIkACAAKAKEASEGIAAoAgQhByAAKAKIASEFIAAoAgwhCCASIAAoAhg2AlwgACgCPCEbIABBQGsoAgAhHCAAQSxqIiYgAyAEQQIQWSADIAcgCGogA0ZqIg0gAyAEaiIMQXhqIi5JBEAgBUH/HyAFQf8fSRshLyAMQWBqITBBA0EEIAZBA0YbIi1Bf2ohJwNAAkACQAJAAkACQAJAAkACQAJAIAAoAgQiBSAAKAIYIgRqIA1LDQAgDSADayEdIAAoAoQBIQYgBCANIAVrIgdJBEADQCAAIAQgBWogDCAGQQEQQSAEaiIEIAdJDQALCyAdRSEhIAAgBzYCGAJAAkACQAJAAkAgBkF9ag4FAAECAwMBC0EAIQlBACANIAAoAgQiGWsiCEF/IAAoAnhBf2p0QX9zIiRrIgQgBCAISxshFiAAKAIgIA0gACgCfEEDEB5BAnRqIgooAgAhBSAIIAAoAhAgACgCFCAIIAAoAnQQJyIEayEYIARBASAEGyEVQQNBBCAdGyEeIAAoAigiHyAIICRxQQN0aiILQQRqIRQgACgCiAEiBEH/HyAEQf8fSRshDiANQQNqIQ8gCEEJaiERIAggACgCDCITayEgIBMgGWohGiAAKAIIIhAgE2ohFyAAKAKAASEiICchBiAhIQQDQAJAAn8CfyAEQQNGBEAgAigCAEF/agwBCyACIARBAnRqKAIACyIHQX9qIiMgIEkEQCANQQMQHyANIAdrQQMQH0cNAiAPIA8gB2sgDBAdDAELICMgGE8NASATIAggB2siB0F/c2pBA0kNASANQQMQHyAHIBBqIgdBAxAfRw0BIA8gB0EDaiAMIBcgGhAgC0EDaiIHIAZNDQAgGyAJQQN0aiIGIAc2AgQgBiAEICFrNgIAIAlBAWohCSAHIA5LDQUgByIGIA1qIAxGDQULIARBAWoiBCAeSQ0ACwJAIAZBAksNAEECIQYgGSAAKAIcIAAoAiQgEkHcAGogDRBAIgQgFUkNACAIIARrIgdB//8PSw0AAn8gBCATTwRAIA0gBCAZaiAMEB0MAQsgDSAEIBBqIAwgFyAaECALIgRBA0kNACAbIAQ2AgQgGyAHQQJqNgIAIAQgDk0EQEEBIQkgBCEGIAQgDWogDEcNAQtBASEJIAAgCEEBajYCGAwECyAKIAg2AgACQCAFIBVJDQAgCEECaiEYQX8gInRBf3MhCkEAIQ5BACEPA0ACfyAOIA8gDiAPSRsiBCAFaiATTwRAIAQgDWogBSAZaiAEaiAMEB0gBGohBCAZDAELIBAgGSAEIA1qIAUgEGogBGogDCAXIBoQICAEaiIEIAVqIBNJGwshCCAEIAZLBEAgGyAJQQN0aiIGIAQ2AgQgBiAYIAVrNgIAIAQgBWogESAEIBEgBWtLGyERIAlBAWohCSAEQYAgSw0CIAQhBiAEIA1qIAxGDQILIB8gBSAkcUEDdGohBwJAAkAgBSAIaiAEai0AACAEIA1qLQAASQRAIAsgBTYCACAFIBZLDQEgEkFAayELDAQLIBQgBTYCACAFIBZLBEAgByEUIAQhDwwCCyASQUBrIRQMAwsgBCEOIAdBBGoiCyEHCyAKRQ0BIApBf2ohCiAHKAIAIgUgFU8NAAsLIBRBADYCACALQQA2AgAgACARQXhqNgIYDAMLQQAhCUEAIA0gACgCBCITayIIQX8gACgCeEF/anRBf3MiFWsiBCAEIAhLGyEaIAAoAiAgDSAAKAJ8QQQQHkECdGoiDigCACEFIAggACgCECAAKAIUIAggACgCdBAnIgRrIQogBEEBIAQbIRdBA0EEIB0bIRggACgCKCIeIAggFXFBA3RqIhRBBGohGSAAKAKIASIEQf8fIARB/x9JGyEfIA1BBGohDyAIQQlqIREgCCAAKAIMIgtrISAgCyATaiEkIAAoAggiECALaiEWIAAoAoABISIgJyEGICEhBANAAkACfwJ/IARBA0YEQCACKAIAQX9qDAELIAIgBEECdGooAgALIgdBf2oiIyAgSQRAIA1BBBAfIA0gB2tBBBAfRw0CIA8gDyAHayAMEB0MAQsgIyAKTw0BIAsgCCAHayIHQX9zakEDSQ0BIA1BBBAfIAcgEGoiB0EEEB9HDQEgDyAHQQRqIAwgFiAkECALQQRqIgcgBk0NACAbIAlBA3RqIgYgBzYCBCAGIAQgIWs2AgAgCUEBaiEJIAcgH0sNBCAHIgYgDWogDEYNBAsgBEEBaiIEIBhJDQALIA4gCDYCAAJAIAUgF0kNACAIQQJqIRhBfyAidEF/cyEKQQAhDkEAIQ8DQAJ/IA4gDyAOIA9JGyIEIAVqIAtPBEAgBCANaiAFIBNqIARqIAwQHSAEaiEEIBMMAQsgECATIAQgDWogBSAQaiAEaiAMIBYgJBAgIARqIgQgBWogC0kbCyEIIAQgBksEQCAbIAlBA3RqIgYgBDYCBCAGIBggBWs2AgAgBCAFaiARIAQgESAFa0sbIREgCUEBaiEJIARBgCBLDQIgBCEGIAQgDWogDEYNAgsgHiAFIBVxQQN0aiEHAkACQCAFIAhqIARqLQAAIAQgDWotAABJBEAgFCAFNgIAIAUgGksNASASQUBrIRQMBAsgGSAFNgIAIAUgGksEQCAHIRkgBCEPDAILIBJBQGshGQwDCyAEIQ4gB0EEaiIUIQcLIApFDQEgCkF/aiEKIAcoAgAiBSAXTw0ACwsgGUEANgIAIBRBADYCACAAIBFBeGo2AhgMAgtBACEJQQAgDSAAKAIEIhNrIghBfyAAKAJ4QX9qdEF/cyIVayIEIAQgCEsbIRogACgCICANIAAoAnxBBRAeQQJ0aiIOKAIAIQUgCCAAKAIQIAAoAhQgCCAAKAJ0ECciBGshCiAEQQEgBBshF0EDQQQgHRshGCAAKAIoIh4gCCAVcUEDdGoiGUEEaiEUIAAoAogBIgRB/x8gBEH/H0kbIR8gDUEEaiEPIAhBCWohESAIIAAoAgwiC2shICALIBNqISQgACgCCCIQIAtqIRYgACgCgAEhIiAnIQYgISEEA0ACQAJ/An8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiB0F/aiIjICBJBEAgDUEEEB8gDSAHa0EEEB9HDQIgDyAPIAdrIAwQHQwBCyAjIApPDQEgCyAIIAdrIgdBf3NqQQNJDQEgDUEEEB8gByAQaiIHQQQQH0cNASAPIAdBBGogDCAWICQQIAtBBGoiByAGTQ0AIBsgCUEDdGoiBiAHNgIEIAYgBCAhazYCACAJQQFqIQkgByAfSw0DIAciBiANaiAMRg0DCyAEQQFqIgQgGEkNAAsgDiAINgIAAkAgBSAXSQ0AIAhBAmohGEF/ICJ0QX9zIQpBACEOQQAhDwNAAn8gDiAPIA4gD0kbIgQgBWogC08EQCAEIA1qIAUgE2ogBGogDBAdIARqIQQgEwwBCyAQIBMgBCANaiAFIBBqIARqIAwgFiAkECAgBGoiBCAFaiALSRsLIQggBCAGSwRAIBsgCUEDdGoiBiAENgIEIAYgGCAFazYCACAEIAVqIBEgBCARIAVrSxshESAJQQFqIQkgBEGAIEsNAiAEIQYgBCANaiAMRg0CCyAeIAUgFXFBA3RqIQcCQAJAIAUgCGogBGotAAAgBCANai0AAEkEQCAZIAU2AgAgBSAaSw0BIBJBQGshGQwECyAUIAU2AgAgBSAaSwRAIAchFCAEIQ8MAgsgEkFAayEUDAMLIAQhDiAHQQRqIhkhBwsgCkUNASAKQX9qIQogBygCACIFIBdPDQALCyAUQQA2AgAgGUEANgIAIAAgEUF4ajYCGAwBC0EAIQlBACANIAAoAgQiE2siCEF/IAAoAnhBf2p0QX9zIhVrIgQgBCAISxshGiAAKAIgIA0gACgCfEEGEB5BAnRqIg4oAgAhBSAIIAAoAhAgACgCFCAIIAAoAnQQJyIEayEKIARBASAEGyEXQQNBBCAdGyEYIAAoAigiHiAIIBVxQQN0aiIZQQRqIRQgACgCiAEiBEH/HyAEQf8fSRshHyANQQRqIQ8gCEEJaiERIAggACgCDCILayEgIAsgE2ohJCAAKAIIIhAgC2ohFiAAKAKAASEiICchBiAhIQQDQAJAAn8CfyAEQQNGBEAgAigCAEF/agwBCyACIARBAnRqKAIACyIHQX9qIiMgIEkEQCANQQQQHyANIAdrQQQQH0cNAiAPIA8gB2sgDBAdDAELICMgCk8NASALIAggB2siB0F/c2pBA0kNASANQQQQHyAHIBBqIgdBBBAfRw0BIA8gB0EEaiAMIBYgJBAgC0EEaiIHIAZNDQAgGyAJQQN0aiIGIAc2AgQgBiAEICFrNgIAIAlBAWohCSAHIB9LDQIgByIGIA1qIAxGDQILIARBAWoiBCAYSQ0ACyAOIAg2AgACQCAFIBdJDQAgCEECaiEYQX8gInRBf3MhCkEAIQ5BACEPA0ACfyAOIA8gDiAPSRsiBCAFaiALTwRAIAQgDWogBSATaiAEaiAMEB0gBGohBCATDAELIBAgEyAEIA1qIAUgEGogBGogDCAWICQQICAEaiIEIAVqIAtJGwshCCAEIAZLBEAgGyAJQQN0aiIGIAQ2AgQgBiAYIAVrNgIAIAQgBWogESAEIBEgBWtLGyERIAlBAWohCSAEQYAgSw0CIAQhBiAEIA1qIAxGDQILIB4gBSAVcUEDdGohBwJAAkAgBSAIaiAEai0AACAEIA1qLQAASQRAIBkgBTYCACAFIBpLDQEgEkFAayEZDAQLIBQgBTYCACAFIBpLBEAgByEUIAQhDwwCCyASQUBrIRQMAwsgBCEOIAdBBGoiGSEHCyAKRQ0BIApBf2ohCiAHKAIAIgUgF08NAAsLIBRBADYCACAZQQA2AgAgACARQXhqNgIYCyAJRQ0AIBwgAigCADYCECAcIAIoAgQ2AhQgAigCCCEEIBwgHTYCDCAcQQA2AgggHCAENgIYIBwgAyAdICZBAhBYIgU2AgAgGyAJQX9qQQN0aiIEKAIEIgcgL0sEQCAEKAIAIQoMAwtBASEEQQAgJkECEC0hBgNAIBwgBEEcbGpBgICAgAQ2AgAgBEEBaiIEIC1HDQALIAUgBmohCkEAIQggLSEHA0AgGyAIQQN0aiIEKAIEIQYgEkFAayACIAQoAgAiDyAhED8gByAGTQRAIA9BAWoQJCIOQQh0QYAgaiERA0AgB0F9aiEEAn8gACgCZEEBRgRAIAQQKyARagwBCyAAKAJgIAAoAjggDkECdGooAgAQK2sgACgCXGogBBA8QQJ0IgRBkKQBaigCACAOakEIdGogACgCNCAEaigCABAra0EzagshBSAcIAdBHGxqIgQgHTYCDCAEIA82AgQgBCAHNgIIIAQgBSAKajYCACAEIBIpA0A3AhAgBCASKAJINgIYIAdBAWoiByAGTQ0ACwsgCEEBaiIIIAlHDQALQQEhDwJAIAdBf2oiBEUEQEEAIQQMAQsDQEEBIQUgHCAPQX9qQRxsaiIHKAIIRQRAIAcoAgxBAWohBQsgDSAPaiILQX9qQQEgJkECEFIgBygCAGogBSAmQQIQLWogBUF/aiAmQQIQLWsiBiAcIA9BHGxqIhooAgAiGUwEQCAaIAU2AgwgGkIANwIEIBogBjYCACAaIAcoAhg2AhggGiAHKQIQNwIQIAYhGQsCQCALIC5LDQAgBCAPRgRAIA8hBAwDC0EAIR0gGigCCCIHRQRAIBooAgwhHQtBACAmQQIQLSEyIAAoAgQiBiAAKAIYIgVqIAtLDQAgACgChAEhCCAFIAsgBmsiCUkEQANAIAAgBSAGaiAMIAhBARBBIAVqIgUgCUkNAAsLIAdBAEchISAaQRBqISQgACAJNgIYAkACQAJAAkACQCAIQX1qDgUAAQIDAwELQQAhEEEAIAsgACgCBCIOayIJQX8gACgCeEF/anRBf3MiImsiBSAFIAlLGyEjIAAoAiAgCyAAKAJ8QQMQHkECdGoiJSgCACEGIAkgACgCECAAKAIUIAkgACgCdBAnIgVrISggBUEBIAUbIR5BBEEDIAcbISkgACgCKCIqIAkgInFBA3RqIhZBBGohEyAAKAKIASIFQf8fIAVB/x9JGyEVIAtBA2ohESAJQQlqIRQgCSAAKAIMIhdrISsgDiAXaiEfIAAoAggiGCAXaiEgIAAoAoABISwgJyEHICEhBQNAAkACfwJ/IAVBA0YEQCAkKAIAQX9qDAELIBogBUECdGooAhALIgpBf2oiCCArSQRAIAtBAxAfIAsgCmtBAxAfRw0CIBEgESAKayAMEB0MAQsgCCAoTw0BIBcgCSAKayIIQX9zakEDSQ0BIAtBAxAfIAggGGoiCEEDEB9HDQEgESAIQQNqIAwgICAfECALQQNqIgggB00NACAbIBBBA3RqIgcgCDYCBCAHIAUgIWs2AgAgEEEBaiEQIAggFUsNBSAIIgcgC2ogDEYNBQsgBUEBaiIFIClJDQALAkAgB0ECSw0AQQIhByAOIAAoAhwgACgCJCASQdwAaiALEEAiBSAeSQ0AIAkgBWsiCEH//w9LDQACfyAFIBdPBEAgCyAFIA5qIAwQHQwBCyALIAUgGGogDCAgIB8QIAsiBUEDSQ0AIBsgBTYCBCAbIAhBAmo2AgAgBSAVTQRAQQEhECAFIQcgBSALaiAMRw0BC0EBIRAgACAJQQFqNgIYDAQLICUgCTYCAAJAIAYgHkkNACAJQQJqISVBfyAsdEF/cyEVQQAhCUEAIQgDQAJ/IAkgCCAJIAhJGyIFIAZqIBdPBEAgBSALaiAGIA5qIAVqIAwQHSAFaiEFIA4MAQsgGCAOIAUgC2ogBiAYaiAFaiAMICAgHxAgIAVqIgUgBmogF0kbCyERIAUgB0sEQCAbIBBBA3RqIgcgBTYCBCAHICUgBms2AgAgBSAGaiAUIAUgFCAGa0sbIRQgEEEBaiEQIAVBgCBLDQIgBSEHIAUgC2ogDEYNAgsgKiAGICJxQQN0aiEKAkACQCAGIBFqIAVqLQAAIAUgC2otAABJBEAgFiAGNgIAIAYgI0sNASASQUBrIRYMBAsgEyAGNgIAIAYgI0sEQCAKIRMgBSEIDAILIBJBQGshEwwDCyAFIQkgCkEEaiIWIQoLIBVFDQEgFUF/aiEVIAooAgAiBiAeTw0ACwsgE0EANgIAIBZBADYCACAAIBRBeGo2AhgMAwtBACEQQQAgCyAAKAIEIhNrIglBfyAAKAJ4QX9qdEF/cyIeayIFIAUgCUsbIR8gACgCICALIAAoAnxBBBAeQQJ0aiIVKAIAIQYgCSAAKAIQIAAoAhQgCSAAKAJ0ECciBWshJSAFQQEgBRshIEEEQQMgBxshKCAAKAIoIikgCSAecUEDdGoiF0EEaiEOIAAoAogBIgVB/x8gBUH/H0kbISogC0EEaiERIAlBCWohFCAJIAAoAgwiFmshKyATIBZqISIgACgCCCIYIBZqISMgACgCgAEhLCAnIQcgISEFA0ACQAJ/An8gBUEDRgRAICQoAgBBf2oMAQsgGiAFQQJ0aigCEAsiCkF/aiIIICtJBEAgC0EEEB8gCyAKa0EEEB9HDQIgESARIAprIAwQHQwBCyAIICVPDQEgFiAJIAprIghBf3NqQQNJDQEgC0EEEB8gCCAYaiIIQQQQH0cNASARIAhBBGogDCAjICIQIAtBBGoiCCAHTQ0AIBsgEEEDdGoiByAINgIEIAcgBSAhazYCACAQQQFqIRAgCCAqSw0EIAgiByALaiAMRg0ECyAFQQFqIgUgKEkNAAsgFSAJNgIAAkAgBiAgSQ0AIAlBAmohJUF/ICx0QX9zIRVBACEJQQAhCANAAn8gCSAIIAkgCEkbIgUgBmogFk8EQCAFIAtqIAYgE2ogBWogDBAdIAVqIQUgEwwBCyAYIBMgBSALaiAGIBhqIAVqIAwgIyAiECAgBWoiBSAGaiAWSRsLIREgBSAHSwRAIBsgEEEDdGoiByAFNgIEIAcgJSAGazYCACAFIAZqIBQgBSAUIAZrSxshFCAQQQFqIRAgBUGAIEsNAiAFIQcgBSALaiAMRg0CCyApIAYgHnFBA3RqIQoCQAJAIAYgEWogBWotAAAgBSALai0AAEkEQCAXIAY2AgAgBiAfSw0BIBJBQGshFwwECyAOIAY2AgAgBiAfSwRAIAohDiAFIQgMAgsgEkFAayEODAMLIAUhCSAKQQRqIhchCgsgFUUNASAVQX9qIRUgCigCACIGICBPDQALCyAOQQA2AgAgF0EANgIAIAAgFEF4ajYCGAwCC0EAIRBBACALIAAoAgQiE2siCUF/IAAoAnhBf2p0QX9zIh5rIgUgBSAJSxshHyAAKAIgIAsgACgCfEEFEB5BAnRqIhUoAgAhBiAJIAAoAhAgACgCFCAJIAAoAnQQJyIFayElIAVBASAFGyEgQQRBAyAHGyEoIAAoAigiKSAJIB5xQQN0aiIXQQRqIQ4gACgCiAEiBUH/HyAFQf8fSRshKiALQQRqIREgCUEJaiEUIAkgACgCDCIWayErIBMgFmohIiAAKAIIIhggFmohIyAAKAKAASEsICchByAhIQUDQAJAAn8CfyAFQQNGBEAgJCgCAEF/agwBCyAaIAVBAnRqKAIQCyIKQX9qIgggK0kEQCALQQQQHyALIAprQQQQH0cNAiARIBEgCmsgDBAdDAELIAggJU8NASAWIAkgCmsiCEF/c2pBA0kNASALQQQQHyAIIBhqIghBBBAfRw0BIBEgCEEEaiAMICMgIhAgC0EEaiIIIAdNDQAgGyAQQQN0aiIHIAg2AgQgByAFICFrNgIAIBBBAWohECAIICpLDQMgCCIHIAtqIAxGDQMLIAVBAWoiBSAoSQ0ACyAVIAk2AgACQCAGICBJDQAgCUECaiElQX8gLHRBf3MhFUEAIQlBACEIA0ACfyAJIAggCSAISRsiBSAGaiAWTwRAIAUgC2ogBiATaiAFaiAMEB0gBWohBSATDAELIBggEyAFIAtqIAYgGGogBWogDCAjICIQICAFaiIFIAZqIBZJGwshESAFIAdLBEAgGyAQQQN0aiIHIAU2AgQgByAlIAZrNgIAIAUgBmogFCAFIBQgBmtLGyEUIBBBAWohECAFQYAgSw0CIAUhByAFIAtqIAxGDQILICkgBiAecUEDdGohCgJAAkAgBiARaiAFai0AACAFIAtqLQAASQRAIBcgBjYCACAGIB9LDQEgEkFAayEXDAQLIA4gBjYCACAGIB9LBEAgCiEOIAUhCAwCCyASQUBrIQ4MAwsgBSEJIApBBGoiFyEKCyAVRQ0BIBVBf2ohFSAKKAIAIgYgIE8NAAsLIA5BADYCACAXQQA2AgAgACAUQXhqNgIYDAELQQAhEEEAIAsgACgCBCITayIJQX8gACgCeEF/anRBf3MiHmsiBSAFIAlLGyEfIAAoAiAgCyAAKAJ8QQYQHkECdGoiFSgCACEGIAkgACgCECAAKAIUIAkgACgCdBAnIgVrISUgBUEBIAUbISBBBEEDIAcbISggACgCKCIpIAkgHnFBA3RqIhdBBGohDiAAKAKIASIFQf8fIAVB/x9JGyEqIAtBBGohESAJQQlqIRQgCSAAKAIMIhZrISsgEyAWaiEiIAAoAggiGCAWaiEjIAAoAoABISwgJyEHICEhBQNAAkACfwJ/IAVBA0YEQCAkKAIAQX9qDAELIBogBUECdGooAhALIgpBf2oiCCArSQRAIAtBBBAfIAsgCmtBBBAfRw0CIBEgESAKayAMEB0MAQsgCCAlTw0BIBYgCSAKayIIQX9zakEDSQ0BIAtBBBAfIAggGGoiCEEEEB9HDQEgESAIQQRqIAwgIyAiECALQQRqIgggB00NACAbIBBBA3RqIgcgCDYCBCAHIAUgIWs2AgAgEEEBaiEQIAggKksNAiAIIgcgC2ogDEYNAgsgBUEBaiIFIChJDQALIBUgCTYCAAJAIAYgIEkNACAJQQJqISVBfyAsdEF/cyEVQQAhCUEAIQgDQAJ/IAkgCCAJIAhJGyIFIAZqIBZPBEAgBSALaiAGIBNqIAVqIAwQHSAFaiEFIBMMAQsgGCATIAUgC2ogBiAYaiAFaiAMICMgIhAgIAVqIgUgBmogFkkbCyERIAUgB0sEQCAbIBBBA3RqIgcgBTYCBCAHICUgBms2AgAgBSAGaiAUIAUgFCAGa0sbIRQgEEEBaiEQIAVBgCBLDQIgBSEHIAUgC2ogDEYNAgsgKSAGIB5xQQN0aiEKAkACQCAGIBFqIAVqLQAAIAUgC2otAABJBEAgFyAGNgIAIAYgH0sNASASQUBrIRcMBAsgDiAGNgIAIAYgH0sEQCAKIQ4gBSEIDAILIBJBQGshDgwDCyAFIQkgCkEEaiIXIQoLIBVFDQEgFUF/aiEVIAooAgAiBiAgTw0ACwsgDkEANgIAIBdBADYCACAAIBRBeGo2AhgLIBBFDQAgGyAQQX9qQQN0aiIFKAIEIgcgL0sgByAPakGAIE9yDQQgGSAyaiERQQAhBwNAIBJBQGsgJCAbIAdBA3RqIgYoAgAiCCAhED8gLSEOAn8gBwRAIAZBfGooAgBBAWohDgsgBigCBCIFIA5PCwRAIAhBAWoQJCIJQQh0QYAgaiEZA0AgBUF9aiEKIAUgD2ohBgJ/IAAoAmRBAUYEQCAKECsgGWoMAQsgACgCYCAAKAI4IAlBAnRqKAIAECtrIAAoAlxqIAoQPEECdCIKQZCkAWooAgAgCWpBCHRqIAAoAjQgCmooAgAQK2tBM2oLIBFqIQoCQAJAIAYgBE0EQCAKIBwgBkEcbGooAgBIDQEMAgsDQCAcIARBAWoiBEEcbGpBgICAgAQ2AgAgBCAGSQ0ACwsgHCAGQRxsaiIGIB02AgwgBiAINgIEIAYgBTYCCCAGIAo2AgAgBiASKQNANwIQIAYgEigCSDYCGAsgBUF/aiIFIA5PDQALCyAHQQFqIgcgEEcNAAsLIA9BAWoiDyAETQ0ACwsgHCAEQRxsaiIFKAIMIR0gBSgCBCEKIAUoAgAhMSAFKAIIIQcgEiAFKAIYNgJYIBIgBSkCEDcDUCASIAUpAgg3AyggEiAFKQIQNwMwIBIgBSgCGDYCOCASIAUpAgA3AyBBACAEIBJBIGoQPmsiBSAFIARLGyEEDAMLIA1BAWohDQwHCyAFKAIAIQpBACEEIA8gGigCCAR/IAQFIBooAgwLayIEQYAgTQ0BCyAcIB02AiggHCAHNgIkIBwgCjYCICAcIDE2AhwgHCASKAJYNgI0IBwgEikDUDcCLAwBCyAcIARBAWoiCUEcbGoiBSAdNgIMIAUgBzYCCCAFIAo2AgQgBSAxNgIAIAUgEikDUDcCECAFIBIoAlg2AhggCSEdIAQNAQtBASEdQQEhCQwBCwNAIBIgHCAEQRxsaiIFIghBGGooAgA2AhggEiAFKQIQNwMQIBIgBSkCCDcDCCASIAUpAgA3AwAgEhA+IQcgHCAdQX9qIh1BHGxqIgYgCCgCGDYCGCAGIAUpAhA3AhAgBiAFKQIINwIIIAYgBSkCADcCACAEIAdLIQVBACAEIAdrIgYgBiAESxshBCAFDQALIB0gCUsNAQsDQCAcIB1BHGxqIgQoAgwhBgJ/IAMgBmogBCgCCCIPRQ0AGgJAAkAgBCgCBCIIQQNPBEAgAiACKQIANwIEIAhBfmohBAwBCwJAAkACQAJAIAggBkVqIgUOBAUBAQABCyACKAIAQX9qIQQMAQsgAiAFQQJ0aigCACEEIAVBAkkNAQsgAiACKAIENgIICyACIAIoAgA2AgQLIAIgBDYCAAsgJiAGIAMgCCAPEFcgD0F9aiEOIAEoAgwhBAJAAkAgAyAGaiIFIDBNBEAgBCADEBwgASgCDCEEIAZBEE0EQCABIAQgBmo2AgwMAwsgBEEQaiADQRBqIgcQHCAEQSBqIANBIGoQHCAGQTFIDQEgBCAGaiEKIARBMGohBANAIAQgB0EgaiIFEBwgBEEQaiAHQTBqEBwgBSEHIARBIGoiBCAKSQ0ACwwBCyAEIAMgBSAwECILIAEgASgCDCAGajYCDCAGQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyABKAIEIgQgCEEBajYCACAEIAY7AQQgDkGAgARPBEAgAUECNgIkIAEgBCABKAIAa0EDdTYCKAsgBCAOOwEGIAEgBEEIajYCBCAGIA9qIANqIgMLIQ0gHUEBaiIdIAlNDQALCyAmQQIQUQsgDSAuSQ0ACwsgEkHgAGokACAMIANrC+NIAS9/IwBB4ABrIhEkACAAKAKEASEGIAAoAgQhCCAAKAKIASEFIAAoAgwhByARIAAoAhg2AlwgACgCPCEcIABBQGsoAgAhGyAAQSxqIicgAyAEQQAQWSADIAcgCGogA0ZqIg0gAyAEaiIMQXhqIi9JBEAgBUH/HyAFQf8fSRshMCAMQWBqITFBA0EEIAZBA0YbIi5Bf2ohKANAAkACQAJAAkACQAJAAkACQAJAIAAoAgQiBSAAKAIYIgRqIA1LDQAgDSADayEkIAAoAoQBIQYgBCANIAVrIghJBEADQCAAIAQgBWogDCAGQQEQQSAEaiIEIAhJDQALCyAkRSEZIAAgCDYCGAJAAkACQAJAAkAgBkF9ag4FAAECAwMBC0EAIQlBACANIAAoAgQiC2siB0F/IAAoAnhBf2p0QX9zIhVrIgQgBCAHSxshIyAAKAIgIA0gACgCfEEDEB5BAnRqIg4oAgAhBSAHIAAoAhAgACgCFCAHIAAoAnQQJyIEayETIARBASAEGyEXQQNBBCAkGyEdIAAoAigiHyAHIBVxQQN0aiIKQQRqIRggACgCiAEiBEH/HyAEQf8fSRshFiANQQNqIQ8gB0EJaiESIAcgACgCDCIeayEgIAsgHmohFCAAKAIIIhAgHmohGiAAKAKAASEhICghBiAZIQQDQAJAAn8CfyAEQQNGBEAgAigCAEF/agwBCyACIARBAnRqKAIACyIIQX9qIiIgIEkEQCANQQMQHyANIAhrQQMQH0cNAiAPIA8gCGsgDBAdDAELICIgE08NASAeIAcgCGsiCEF/c2pBA0kNASANQQMQHyAIIBBqIghBAxAfRw0BIA8gCEEDaiAMIBogFBAgC0EDaiIIIAZNDQAgHCAJQQN0aiIGIAg2AgQgBiAEIBlrNgIAIAlBAWohCSAIIBZLDQUgCCIGIA1qIAxGDQULIARBAWoiBCAdSQ0ACwJAIAZBAksNAEECIQYgCyAAKAIcIAAoAiQgEUHcAGogDRBAIgQgF0kNACAHIARrIghB//8PSw0AAn8gBCAeTwRAIA0gBCALaiAMEB0MAQsgDSAEIBBqIAwgGiAUECALIgRBA0kNACAcIAQ2AgQgHCAIQQJqNgIAIAQgFk0EQEEBIQkgBCEGIAQgDWogDEcNAQtBASEJIAAgB0EBajYCGAwECyAOIAc2AgACQCAFIBdJDQAgB0ECaiETQX8gIXRBf3MhDkEAIQ9BACEHA0ACfyAPIAcgDyAHSRsiBCAFaiAeTwRAIAQgDWogBSALaiAEaiAMEB0gBGohBCALDAELIBAgCyAEIA1qIAUgEGogBGogDCAaIBQQICAEaiIEIAVqIB5JGwshFiAEIAZLBEAgHCAJQQN0aiIGIAQ2AgQgBiATIAVrNgIAIAQgBWogEiAEIBIgBWtLGyESIAlBAWohCSAEQYAgSw0CIAQhBiAEIA1qIAxGDQILIB8gBSAVcUEDdGohCAJAAkAgBSAWaiAEai0AACAEIA1qLQAASQRAIAogBTYCACAFICNLDQEgEUFAayEKDAQLIBggBTYCACAFICNLBEAgCCEYIAQhBwwCCyARQUBrIRgMAwsgBCEPIAhBBGoiCiEICyAORQ0BIA5Bf2ohDiAIKAIAIgUgF08NAAsLIBhBADYCACAKQQA2AgAgACASQXhqNgIYDAMLQQAhCUEAIA0gACgCBCIYayIHQX8gACgCeEF/anRBf3MiF2siBCAEIAdLGyEUIAAoAiAgDSAAKAJ8QQQQHkECdGoiFigCACEFIAcgACgCECAAKAIUIAcgACgCdBAnIgRrIQ4gBEEBIAQbIRpBA0EEICQbIRMgACgCKCIdIAcgF3FBA3RqIh5BBGohCyAAKAKIASIEQf8fIARB/x9JGyEfIA1BBGohDyAHQQlqIRIgByAAKAIMIgprISAgCiAYaiEVIAAoAggiECAKaiEjIAAoAoABISEgKCEGIBkhBANAAkACfwJ/IARBA0YEQCACKAIAQX9qDAELIAIgBEECdGooAgALIghBf2oiIiAgSQRAIA1BBBAfIA0gCGtBBBAfRw0CIA8gDyAIayAMEB0MAQsgIiAOTw0BIAogByAIayIIQX9zakEDSQ0BIA1BBBAfIAggEGoiCEEEEB9HDQEgDyAIQQRqIAwgIyAVECALQQRqIgggBk0NACAcIAlBA3RqIgYgCDYCBCAGIAQgGWs2AgAgCUEBaiEJIAggH0sNBCAIIgYgDWogDEYNBAsgBEEBaiIEIBNJDQALIBYgBzYCAAJAIAUgGkkNACAHQQJqIRNBfyAhdEF/cyEOQQAhD0EAIQcDQAJ/IA8gByAPIAdJGyIEIAVqIApPBEAgBCANaiAFIBhqIARqIAwQHSAEaiEEIBgMAQsgECAYIAQgDWogBSAQaiAEaiAMICMgFRAgIARqIgQgBWogCkkbCyEWIAQgBksEQCAcIAlBA3RqIgYgBDYCBCAGIBMgBWs2AgAgBCAFaiASIAQgEiAFa0sbIRIgCUEBaiEJIARBgCBLDQIgBCEGIAQgDWogDEYNAgsgHSAFIBdxQQN0aiEIAkACQCAFIBZqIARqLQAAIAQgDWotAABJBEAgHiAFNgIAIAUgFEsNASARQUBrIR4MBAsgCyAFNgIAIAUgFEsEQCAIIQsgBCEHDAILIBFBQGshCwwDCyAEIQ8gCEEEaiIeIQgLIA5FDQEgDkF/aiEOIAgoAgAiBSAaTw0ACwsgC0EANgIAIB5BADYCACAAIBJBeGo2AhgMAgtBACEJQQAgDSAAKAIEIhhrIgdBfyAAKAJ4QX9qdEF/cyIXayIEIAQgB0sbIRQgACgCICANIAAoAnxBBRAeQQJ0aiIWKAIAIQUgByAAKAIQIAAoAhQgByAAKAJ0ECciBGshDiAEQQEgBBshGkEDQQQgJBshEyAAKAIoIh0gByAXcUEDdGoiHkEEaiELIAAoAogBIgRB/x8gBEH/H0kbIR8gDUEEaiEPIAdBCWohEiAHIAAoAgwiCmshICAKIBhqIRUgACgCCCIQIApqISMgACgCgAEhISAoIQYgGSEEA0ACQAJ/An8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCEF/aiIiICBJBEAgDUEEEB8gDSAIa0EEEB9HDQIgDyAPIAhrIAwQHQwBCyAiIA5PDQEgCiAHIAhrIghBf3NqQQNJDQEgDUEEEB8gCCAQaiIIQQQQH0cNASAPIAhBBGogDCAjIBUQIAtBBGoiCCAGTQ0AIBwgCUEDdGoiBiAINgIEIAYgBCAZazYCACAJQQFqIQkgCCAfSw0DIAgiBiANaiAMRg0DCyAEQQFqIgQgE0kNAAsgFiAHNgIAAkAgBSAaSQ0AIAdBAmohE0F/ICF0QX9zIQ5BACEPQQAhBwNAAn8gDyAHIA8gB0kbIgQgBWogCk8EQCAEIA1qIAUgGGogBGogDBAdIARqIQQgGAwBCyAQIBggBCANaiAFIBBqIARqIAwgIyAVECAgBGoiBCAFaiAKSRsLIRYgBCAGSwRAIBwgCUEDdGoiBiAENgIEIAYgEyAFazYCACAEIAVqIBIgBCASIAVrSxshEiAJQQFqIQkgBEGAIEsNAiAEIQYgBCANaiAMRg0CCyAdIAUgF3FBA3RqIQgCQAJAIAUgFmogBGotAAAgBCANai0AAEkEQCAeIAU2AgAgBSAUSw0BIBFBQGshHgwECyALIAU2AgAgBSAUSwRAIAghCyAEIQcMAgsgEUFAayELDAMLIAQhDyAIQQRqIh4hCAsgDkUNASAOQX9qIQ4gCCgCACIFIBpPDQALCyALQQA2AgAgHkEANgIAIAAgEkF4ajYCGAwBC0EAIQlBACANIAAoAgQiGGsiB0F/IAAoAnhBf2p0QX9zIhdrIgQgBCAHSxshFCAAKAIgIA0gACgCfEEGEB5BAnRqIhYoAgAhBSAHIAAoAhAgACgCFCAHIAAoAnQQJyIEayEOIARBASAEGyEaQQNBBCAkGyETIAAoAigiHSAHIBdxQQN0aiIeQQRqIQsgACgCiAEiBEH/HyAEQf8fSRshHyANQQRqIQ8gB0EJaiESIAcgACgCDCIKayEgIAogGGohFSAAKAIIIhAgCmohIyAAKAKAASEhICghBiAZIQQDQAJAAn8CfyAEQQNGBEAgAigCAEF/agwBCyACIARBAnRqKAIACyIIQX9qIiIgIEkEQCANQQQQHyANIAhrQQQQH0cNAiAPIA8gCGsgDBAdDAELICIgDk8NASAKIAcgCGsiCEF/c2pBA0kNASANQQQQHyAIIBBqIghBBBAfRw0BIA8gCEEEaiAMICMgFRAgC0EEaiIIIAZNDQAgHCAJQQN0aiIGIAg2AgQgBiAEIBlrNgIAIAlBAWohCSAIIB9LDQIgCCIGIA1qIAxGDQILIARBAWoiBCATSQ0ACyAWIAc2AgACQCAFIBpJDQAgB0ECaiETQX8gIXRBf3MhDkEAIQ9BACEHA0ACfyAPIAcgDyAHSRsiBCAFaiAKTwRAIAQgDWogBSAYaiAEaiAMEB0gBGohBCAYDAELIBAgGCAEIA1qIAUgEGogBGogDCAjIBUQICAEaiIEIAVqIApJGwshFiAEIAZLBEAgHCAJQQN0aiIGIAQ2AgQgBiATIAVrNgIAIAQgBWogEiAEIBIgBWtLGyESIAlBAWohCSAEQYAgSw0CIAQhBiAEIA1qIAxGDQILIB0gBSAXcUEDdGohCAJAAkAgBSAWaiAEai0AACAEIA1qLQAASQRAIB4gBTYCACAFIBRLDQEgEUFAayEeDAQLIAsgBTYCACAFIBRLBEAgCCELIAQhBwwCCyARQUBrIQsMAwsgBCEPIAhBBGoiHiEICyAORQ0BIA5Bf2ohDiAIKAIAIgUgGk8NAAsLIAtBADYCACAeQQA2AgAgACASQXhqNgIYCyAJRQ0AIBsgAigCADYCECAbIAIoAgQ2AhQgAigCCCEEIBsgJDYCDCAbQQA2AgggGyAENgIYIBsgAyAkICdBABBYIgU2AgAgHCAJQX9qQQN0aiIEKAIEIgggMEsEQCAEKAIAIQcMAwtBASEEQQAgJ0EAEC0hBgNAIBsgBEEcbGpBgICAgAQ2AgAgBEEBaiIEIC5HDQALIAUgBmohFkEAIQsgLiEIA0AgHCALQQN0aiIEKAIEIQcgEUFAayACIAQoAgAiDyAZED8gCCAHTQRAIA9BAWoQJCIGQQl0QbO0f2pBMyAGQRNLGyEYIAZBCHRBgCBqIQ4DQCAIQX1qIQQCfyAAKAJkQQFGBEAgBBAuIA5qDAELIAAoAmAgGGogACgCOCAGQQJ0aigCABAuayAAKAJcaiAEEDxBAnQiBEGQpAFqKAIAIAZqQQh0aiAAKAI0IARqKAIAEC5rCyEFIBsgCEEcbGoiBCAkNgIMIAQgDzYCBCAEIAg2AgggBCAFIBZqNgIAIAQgESkDQDcCECAEIBEoAkg2AhggCEEBaiIIIAdNDQALCyALQQFqIgsgCUcNAAtBASEPAkAgCEF/aiIERQRAQQAhBAwBCwNAQQEhBSAbIA9Bf2pBHGxqIggoAghFBEAgCCgCDEEBaiEFCyANIA9qIgpBf2pBASAnQQAQUiAIKAIAaiAFICdBABAtaiAFQX9qICdBABAtayIGIBsgD0EcbGoiGigCACIWTARAIBogBTYCDCAaQgA3AgQgGiAGNgIAIBogCCgCGDYCGCAaIAgpAhA3AhAgBiEWCyAKIC9LBH8gD0EBagUgBCAPRgRAIA8hBAwDCwJAIBsgD0EBaiIeQRxsaigCACAWQYABakwNAEEAISQgGigCCCIIRQRAIBooAgwhJAtBACAnQQAQLSEzIAAoAgQiBiAAKAIYIgVqIApLDQAgACgChAEhByAFIAogBmsiCUkEQANAIAAgBSAGaiAMIAdBARBBIAVqIgUgCUkNAAsLIAhBAEchGCAaQRBqISMgACAJNgIYAkACQAJAAkACQCAHQX1qDgUAAQIDAwELQQAhEEEAIAogACgCBCIOayIJQX8gACgCeEF/anRBf3MiImsiBSAFIAlLGyEmIAAoAiAgCiAAKAJ8QQMQHkECdGoiFCgCACEGIAkgACgCECAAKAIUIAkgACgCdBAnIgVrISUgBUEBIAUbIR9BBEEDIAgbISkgACgCKCIqIAkgInFBA3RqIhNBBGohEiAAKAKIASIFQf8fIAVB/x9JGyEZIApBA2ohCyAJQQlqIRcgCSAAKAIMIhVrISsgDiAVaiEgIAAoAggiHSAVaiEhIAAoAoABISwgKCEIIBghBQNAAkACfwJ/IAVBA0YEQCAjKAIAQX9qDAELIBogBUECdGooAhALIgdBf2oiLSArSQRAIApBAxAfIAogB2tBAxAfRw0CIAsgCyAHayAMEB0MAQsgLSAlTw0BIBUgCSAHayIHQX9zakEDSQ0BIApBAxAfIAcgHWoiB0EDEB9HDQEgCyAHQQNqIAwgISAgECALQQNqIgcgCE0NACAcIBBBA3RqIgggBzYCBCAIIAUgGGs2AgAgEEEBaiEQIAcgGUsNBSAHIgggCmogDEYNBQsgBUEBaiIFIClJDQALAkAgCEECSw0AQQIhCCAOIAAoAhwgACgCJCARQdwAaiAKEEAiBSAfSQ0AIAkgBWsiB0H//w9LDQACfyAFIBVPBEAgCiAFIA5qIAwQHQwBCyAKIAUgHWogDCAhICAQIAsiBUEDSQ0AIBwgBTYCBCAcIAdBAmo2AgAgBSAZTQRAQQEhECAFIQggBSAKaiAMRw0BC0EBIRAgACAJQQFqNgIYDAQLIBQgCTYCAAJAIAYgH0kNACAJQQJqISVBfyAsdEF/cyEUQQAhCUEAIQsDQAJ/IAkgCyAJIAtJGyIFIAZqIBVPBEAgBSAKaiAGIA5qIAVqIAwQHSAFaiEFIA4MAQsgHSAOIAUgCmogBiAdaiAFaiAMICEgIBAgIAVqIgUgBmogFUkbCyEZIAUgCEsEQCAcIBBBA3RqIgggBTYCBCAIICUgBms2AgAgBSAGaiAXIAUgFyAGa0sbIRcgEEEBaiEQIAVBgCBLDQIgBSEIIAUgCmogDEYNAgsgKiAGICJxQQN0aiEHAkACQCAGIBlqIAVqLQAAIAUgCmotAABJBEAgEyAGNgIAIAYgJksNASARQUBrIRMMBAsgEiAGNgIAIAYgJksEQCAHIRIgBSELDAILIBFBQGshEgwDCyAFIQkgB0EEaiITIQcLIBRFDQEgFEF/aiEUIAcoAgAiBiAfTw0ACwsgEkEANgIAIBNBADYCACAAIBdBeGo2AhgMAwtBACEQQQAgCiAAKAIEIhJrIglBfyAAKAJ4QX9qdEF/cyIfayIFIAUgCUsbISAgACgCICAKIAAoAnxBBBAeQQJ0aiIZKAIAIQYgCSAAKAIQIAAoAhQgCSAAKAJ0ECciBWshFCAFQQEgBRshIUEEQQMgCBshJSAAKAIoIikgCSAfcUEDdGoiFUEEaiEOIAAoAogBIgVB/x8gBUH/H0kbISogCkEEaiELIAlBCWohFyAJIAAoAgwiE2shKyASIBNqISIgACgCCCIdIBNqISYgACgCgAEhLCAoIQggGCEFA0ACQAJ/An8gBUEDRgRAICMoAgBBf2oMAQsgGiAFQQJ0aigCEAsiB0F/aiItICtJBEAgCkEEEB8gCiAHa0EEEB9HDQIgCyALIAdrIAwQHQwBCyAtIBRPDQEgEyAJIAdrIgdBf3NqQQNJDQEgCkEEEB8gByAdaiIHQQQQH0cNASALIAdBBGogDCAmICIQIAtBBGoiByAITQ0AIBwgEEEDdGoiCCAHNgIEIAggBSAYazYCACAQQQFqIRAgByAqSw0EIAciCCAKaiAMRg0ECyAFQQFqIgUgJUkNAAsgGSAJNgIAAkAgBiAhSQ0AIAlBAmohJUF/ICx0QX9zIRRBACEJQQAhCwNAAn8gCSALIAkgC0kbIgUgBmogE08EQCAFIApqIAYgEmogBWogDBAdIAVqIQUgEgwBCyAdIBIgBSAKaiAGIB1qIAVqIAwgJiAiECAgBWoiBSAGaiATSRsLIRkgBSAISwRAIBwgEEEDdGoiCCAFNgIEIAggJSAGazYCACAFIAZqIBcgBSAXIAZrSxshFyAQQQFqIRAgBUGAIEsNAiAFIQggBSAKaiAMRg0CCyApIAYgH3FBA3RqIQcCQAJAIAYgGWogBWotAAAgBSAKai0AAEkEQCAVIAY2AgAgBiAgSw0BIBFBQGshFQwECyAOIAY2AgAgBiAgSwRAIAchDiAFIQsMAgsgEUFAayEODAMLIAUhCSAHQQRqIhUhBwsgFEUNASAUQX9qIRQgBygCACIGICFPDQALCyAOQQA2AgAgFUEANgIAIAAgF0F4ajYCGAwCC0EAIRBBACAKIAAoAgQiEmsiCUF/IAAoAnhBf2p0QX9zIh9rIgUgBSAJSxshICAAKAIgIAogACgCfEEFEB5BAnRqIhkoAgAhBiAJIAAoAhAgACgCFCAJIAAoAnQQJyIFayEUIAVBASAFGyEhQQRBAyAIGyElIAAoAigiKSAJIB9xQQN0aiIVQQRqIQ4gACgCiAEiBUH/HyAFQf8fSRshKiAKQQRqIQsgCUEJaiEXIAkgACgCDCITayErIBIgE2ohIiAAKAIIIh0gE2ohJiAAKAKAASEsICghCCAYIQUDQAJAAn8CfyAFQQNGBEAgIygCAEF/agwBCyAaIAVBAnRqKAIQCyIHQX9qIi0gK0kEQCAKQQQQHyAKIAdrQQQQH0cNAiALIAsgB2sgDBAdDAELIC0gFE8NASATIAkgB2siB0F/c2pBA0kNASAKQQQQHyAHIB1qIgdBBBAfRw0BIAsgB0EEaiAMICYgIhAgC0EEaiIHIAhNDQAgHCAQQQN0aiIIIAc2AgQgCCAFIBhrNgIAIBBBAWohECAHICpLDQMgByIIIApqIAxGDQMLIAVBAWoiBSAlSQ0ACyAZIAk2AgACQCAGICFJDQAgCUECaiElQX8gLHRBf3MhFEEAIQlBACELA0ACfyAJIAsgCSALSRsiBSAGaiATTwRAIAUgCmogBiASaiAFaiAMEB0gBWohBSASDAELIB0gEiAFIApqIAYgHWogBWogDCAmICIQICAFaiIFIAZqIBNJGwshGSAFIAhLBEAgHCAQQQN0aiIIIAU2AgQgCCAlIAZrNgIAIAUgBmogFyAFIBcgBmtLGyEXIBBBAWohECAFQYAgSw0CIAUhCCAFIApqIAxGDQILICkgBiAfcUEDdGohBwJAAkAgBiAZaiAFai0AACAFIApqLQAASQRAIBUgBjYCACAGICBLDQEgEUFAayEVDAQLIA4gBjYCACAGICBLBEAgByEOIAUhCwwCCyARQUBrIQ4MAwsgBSEJIAdBBGoiFSEHCyAURQ0BIBRBf2ohFCAHKAIAIgYgIU8NAAsLIA5BADYCACAVQQA2AgAgACAXQXhqNgIYDAELQQAhEEEAIAogACgCBCISayIJQX8gACgCeEF/anRBf3MiH2siBSAFIAlLGyEgIAAoAiAgCiAAKAJ8QQYQHkECdGoiGSgCACEGIAkgACgCECAAKAIUIAkgACgCdBAnIgVrIRQgBUEBIAUbISFBBEEDIAgbISUgACgCKCIpIAkgH3FBA3RqIhVBBGohDiAAKAKIASIFQf8fIAVB/x9JGyEqIApBBGohCyAJQQlqIRcgCSAAKAIMIhNrISsgEiATaiEiIAAoAggiHSATaiEmIAAoAoABISwgKCEIIBghBQNAAkACfwJ/IAVBA0YEQCAjKAIAQX9qDAELIBogBUECdGooAhALIgdBf2oiLSArSQRAIApBBBAfIAogB2tBBBAfRw0CIAsgCyAHayAMEB0MAQsgLSAUTw0BIBMgCSAHayIHQX9zakEDSQ0BIApBBBAfIAcgHWoiB0EEEB9HDQEgCyAHQQRqIAwgJiAiECALQQRqIgcgCE0NACAcIBBBA3RqIgggBzYCBCAIIAUgGGs2AgAgEEEBaiEQIAcgKksNAiAHIgggCmogDEYNAgsgBUEBaiIFICVJDQALIBkgCTYCAAJAIAYgIUkNACAJQQJqISVBfyAsdEF/cyEUQQAhCUEAIQsDQAJ/IAkgCyAJIAtJGyIFIAZqIBNPBEAgBSAKaiAGIBJqIAVqIAwQHSAFaiEFIBIMAQsgHSASIAUgCmogBiAdaiAFaiAMICYgIhAgIAVqIgUgBmogE0kbCyEZIAUgCEsEQCAcIBBBA3RqIgggBTYCBCAIICUgBms2AgAgBSAGaiAXIAUgFyAGa0sbIRcgEEEBaiEQIAVBgCBLDQIgBSEIIAUgCmogDEYNAgsgKSAGIB9xQQN0aiEHAkACQCAGIBlqIAVqLQAAIAUgCmotAABJBEAgFSAGNgIAIAYgIEsNASARQUBrIRUMBAsgDiAGNgIAIAYgIEsEQCAHIQ4gBSELDAILIBFBQGshDgwDCyAFIQkgB0EEaiIVIQcLIBRFDQEgFEF/aiEUIAcoAgAiBiAhTw0ACwsgDkEANgIAIBVBADYCACAAIBdBeGo2AhgLIBBFDQAgHCAQQX9qQQN0aiIFKAIEIgggMEsgCCAPakGAIE9yDQUgFiAzaiEZQQAhCANAIBFBQGsgIyAcIAhBA3RqIgYoAgAiCSAYED8gLiEHIAgEQCAGQXxqKAIAQQFqIQcLAkAgBigCBCIFIAdJDQAgCUEBahAkIhZBCXRBs7R/akEzIBZBE0sbIRIgFkEIdEGAIGohCgNAIAVBfWohCyAFIA9qIQYCfyAAKAJkQQFGBEAgCxAuIApqDAELIAAoAmAgEmogACgCOCAWQQJ0aigCABAuayAAKAJcaiALEDxBAnQiC0GQpAFqKAIAIBZqQQh0aiAAKAI0IAtqKAIAEC5rCyAZaiELAkAgBiAETQRAIAsgGyAGQRxsaigCAEgNAQwDCwNAIBsgBEEBaiIEQRxsakGAgICABDYCACAEIAZJDQALCyAbIAZBHGxqIgYgJDYCDCAGIAk2AgQgBiAFNgIIIAYgCzYCACAGIBEpA0A3AhAgBiARKAJINgIYIAVBf2oiBSAHTw0ACwsgCEEBaiIIIBBHDQALCyAeCyIPIARNDQALCyAbIARBHGxqIgUoAgwhJCAFKAIEIQcgBSgCACEyIAUoAgghCCARIAUoAhg2AlggESAFKQIQNwNQIBEgBSkCCDcDKCARIAUpAhA3AzAgESAFKAIYNgI4IBEgBSkCADcDIEEAIAQgEUEgahA+ayIFIAUgBEsbIQQMAwsgDUEBaiENDAcLIAUoAgAhB0EAIQQgDyAaKAIIBH8gBAUgGigCDAtrIgRBgCBNDQELIBsgJDYCKCAbIAg2AiQgGyAHNgIgIBsgMjYCHCAbIBEoAlg2AjQgGyARKQNQNwIsDAELIBsgBEEBaiIWQRxsaiIFICQ2AgwgBSAINgIIIAUgBzYCBCAFIDI2AgAgBSARKQNQNwIQIAUgESgCWDYCGCAWIQ4gBA0BC0EBIQ5BASEWDAELA0AgESAbIARBHGxqIgUiB0EYaigCADYCGCARIAUpAhA3AxAgESAFKQIINwMIIBEgBSkCADcDACARED4hCCAbIA5Bf2oiDkEcbGoiBiAHKAIYNgIYIAYgBSkCEDcCECAGIAUpAgg3AgggBiAFKQIANwIAIAQgCEshBUEAIAQgCGsiBiAGIARLGyEEIAUNAAsgDiAWSw0BCwNAIBsgDkEcbGoiBCgCDCEGAn8gAyAGaiAEKAIIIg9FDQAaAkACQCAEKAIEIgdBA08EQCACIAIpAgA3AgQgB0F+aiEEDAELAkACQAJAAkAgByAGRWoiBQ4EBQEBAAELIAIoAgBBf2ohBAwBCyACIAVBAnRqKAIAIQQgBUECSQ0BCyACIAIoAgQ2AggLIAIgAigCADYCBAsgAiAENgIACyAnIAYgAyAHIA8QVyAPQX1qIQkgASgCDCEEAkACQCADIAZqIgUgMU0EQCAEIAMQHCABKAIMIQQgBkEQTQRAIAEgBCAGajYCDAwDCyAEQRBqIANBEGoiCBAcIARBIGogA0EgahAcIAZBMUgNASAEIAZqIQsgBEEwaiEEA0AgBCAIQSBqIgUQHCAEQRBqIAhBMGoQHCAFIQggBEEgaiIEIAtJDQALDAELIAQgAyAFIDEQIgsgASABKAIMIAZqNgIMIAZBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiBCAHQQFqNgIAIAQgBjsBBCAJQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAk7AQYgASAEQQhqNgIEIAYgD2ogA2oiAwshDSAOQQFqIg4gFk0NAAsLICdBABBRCyANIC9JDQALCyARQeAAaiQAIAwgA2sL+lsBNn8jAEHgAGsiFSQAIAAoAoQBIQYgACgCBCEHIAAoAogBIQUgACgCDCEJIBUgACgCGDYCXCAAKAI8IRkgAEFAaygCACEgIABBLGoiLSADIARBAhBZIAMgByAJaiADRmoiECADIARqIhJBeGoiN0kEQCAFQf8fIAVB/x9JGyE4IBJBYGohOUEDQQQgBkEDRhsiNkF/aiEuA0ACQAJAAkACQAJAAkACQAJAAkAgACgCBCIFIAAoAhgiBGogEEsNACAQIANrISIgACgChAEhBiAEIBAgBWsiB0kEQANAIAAgBCAFaiASIAZBABBBIARqIgQgB0kNAAsLICJFISggACAHNgIYAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgBkF9ag4FAAECAwMBC0EAIQlBACAQIAAoAgQiFGsiDkF/IAAoAnhBf2p0QX9zIhtrIgQgBCAOSxshHCAAKAIgIBAgACgCfEEDEB5BAnRqIiQoAgAhCCAAKAJwIhEoAgAiHSARKAIEIhNrIhZBfyARKAJ4QX9qdEF/cyIeayARKAIQIhogFiAaayAeSxshHyAAKAIQIAAoAhQgDiAAKAJ0ECciBEEBIAQbISUgEyAEIBZrIhhrISkgDiAaayAYayEqQQNBBCAiGyEmIAAoAigiIyAOIBtxQQN0aiIXQQRqIQ0gACgCiAEiBEH/HyAEQf8fSRshByAQQQNqIQYgDkEJaiELIA4gACgCDCIPayEsIA8gFGohISARKAJ8ISsgACgCgAEhJyAuIQwgKCEEA0ACQAJ/An8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCkF/aiIFICxJBEAgEEEDEB8gECAKa0EDEB9HDQIgBiAGIAprIBIQHQwBCyAFICpPDQEgDyAOIAprIgVBf3NqQQNJDQEgEEEDEB8gBSApaiIFQQMQH0cNASAGIAVBA2ogEiAdICEQIAtBA2oiBSAMTQ0AIBkgCUEDdGoiDCAFNgIEIAwgBCAoazYCACAJQQFqIQkgBSAHSw0NIAUiDCAQaiASRg0NCyAEQQFqIgQgJkkNAAsCQCAMQQJLDQBBAiEMIBQgACgCHCAAKAIkIBVB3ABqIBAQQCIEICVJDQAgDiAEayIFQf//D0sNACAQIAQgFGogEhAdIgRBA0kNACAZIAQ2AgQgGSAFQQJqNgIAIAQgB00EQEEBIQkgBCIMIBBqIBJHDQELQQEhCSAAIA5BAWo2AhgMDAsgJCAONgIAQX8gJ3RBf3MhDwJAIAggJUkEQCAPIQUMAQsgDkECaiEkQQAhB0EAIQYDQCAQIAcgBiAHIAZJGyIEaiAIIBRqIgUgBGogEhAdIARqIgQgDEsEQCAZIAlBA3RqIgwgBDYCBCAMICQgCGs2AgAgBCAIaiALIAQgCyAIa0sbIQsgCUEBaiEJIAQgEGogEkYgBEGAIEtyDQYgBCEMCyAjIAggG3FBA3RqIQoCQAJAIAQgBWotAAAgBCAQai0AAEkEQCAXIAg2AgAgCCAcSw0BIBVBQGshFyAPIQUMBAsgDSAINgIAIAggHEsEQCAKIQ0gBCEGDAILIBVBQGshDSAPIQUMAwsgBCEHIApBBGoiFyEKCyAPQX9qIgUgD08NASAFIQ8gCigCACIIICVPDQALCyANQQA2AgAgF0EANgIAIAVFDQogESgCICAQICtBAxAeQQJ0aigCACIKIBpNDQogESgCKCEHIA5BAmohFyAUIBhqIQ1BACEIQQAhDwNAIBAgCCAPIAggD0kbIgRqIAogE2ogBGogEiAdICEQICAEaiIEIAxLBEAgGSAJQQN0aiIGIAQ2AgQgBiAXIAogGGoiBms2AgAgBCAGaiALIAQgCyAGa0sbIQsgCUEBaiEJIARBgCBLDQwgBCIMIBBqIBJGDQwLIAogH00NCyAFQX9qIgVFDQsgBCAIIBMgDSAEIApqIBZJGyAKaiAEai0AACAEIBBqLQAASSIGGyEIIA8gBCAGGyEPIAcgCiAecUEDdGogBkECdGooAgAiCiAaSw0ACwwKC0EAIQlBACAQIAAoAgQiGmsiC0F/IAAoAnhBf2p0QX9zIhhrIgQgBCALSxshGyAAKAIgIBAgACgCfEEEEB5BAnRqIg8oAgAhCCAAKAJwIhEoAgAiHCARKAIEIhNrIhZBfyARKAJ4QX9qdEF/cyIdayARKAIQIhQgFiAUayAdSxshJCAAKAIQIAAoAhQgCyAAKAJ0ECciBEEBIAQbIR4gEyAEIBZrIiVrIR8gCyAUayAlayEpQQNBBCAiGyEqIAAoAigiJiALIBhxQQN0aiIXQQRqIQ0gACgCiAEiBEH/HyAEQf8fSRshIyAQQQRqIQYgC0EJaiEOIAsgACgCDCIHayEsIAcgGmohISARKAJ8ISsgACgCgAEhJyAuIQwgKCEEA0ACQAJ/An8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCkF/aiIFICxJBEAgEEEEEB8gECAKa0EEEB9HDQIgBiAGIAprIBIQHQwBCyAFIClPDQEgByALIAprIgVBf3NqQQNJDQEgEEEEEB8gBSAfaiIFQQQQH0cNASAGIAVBBGogEiAcICEQIAtBBGoiBSAMTQ0AIBkgCUEDdGoiDCAFNgIEIAwgBCAoazYCACAJQQFqIQkgBSAjSw0MIAUiDCAQaiASRg0MCyAEQQFqIgQgKkkNAAsgDyALNgIAQX8gJ3RBf3MhDwJAIAggHkkEQCAPIQUMAQsgC0ECaiEfQQAhB0EAIQYDQCAQIAcgBiAHIAZJGyIEaiAIIBpqIgUgBGogEhAdIARqIgQgDEsEQCAZIAlBA3RqIgwgBDYCBCAMIB8gCGs2AgAgBCAIaiAOIAQgDiAIa0sbIQ4gCUEBaiEJIAQgEGogEkYgBEGAIEtyDQYgBCEMCyAmIAggGHFBA3RqIQoCQAJAIAQgBWotAAAgBCAQai0AAEkEQCAXIAg2AgAgCCAbSw0BIBVBQGshFyAPIQUMBAsgDSAINgIAIAggG0sEQCAKIQ0gBCEGDAILIBVBQGshDSAPIQUMAwsgBCEHIApBBGoiFyEKCyAPQX9qIgUgD08NASAFIQ8gCigCACIIIB5PDQALCyANQQA2AgAgF0EANgIAIAVFDQggESgCICAQICtBBBAeQQJ0aigCACIKIBRNDQggESgCKCEHIAtBAmohFyAaICVqIQ1BACEIQQAhDwNAIBAgCCAPIAggD0kbIgRqIAogE2ogBGogEiAcICEQICAEaiIEIAxLBEAgGSAJQQN0aiIGIAQ2AgQgBiAXIAogJWoiBms2AgAgBCAGaiAOIAQgDiAGa0sbIQ4gCUEBaiEJIARBgCBLDQogBCIMIBBqIBJGDQoLIAogJE0NCSAFQX9qIgVFDQkgBCAIIBMgDSAEIApqIBZJGyAKaiAEai0AACAEIBBqLQAASSIGGyEIIA8gBCAGGyEPIAcgCiAdcUEDdGogBkECdGooAgAiCiAUSw0ACwwIC0EAIQlBACAQIAAoAgQiGmsiC0F/IAAoAnhBf2p0QX9zIhhrIgQgBCALSxshGyAAKAIgIBAgACgCfEEFEB5BAnRqIg8oAgAhCCAAKAJwIhEoAgAiHCARKAIEIhNrIhZBfyARKAJ4QX9qdEF/cyIdayARKAIQIhQgFiAUayAdSxshJCAAKAIQIAAoAhQgCyAAKAJ0ECciBEEBIAQbIR4gEyAEIBZrIiVrIR8gCyAUayAlayEpQQNBBCAiGyEqIAAoAigiJiALIBhxQQN0aiINQQRqIRcgACgCiAEiBEH/HyAEQf8fSRshIyAQQQRqIQYgC0EJaiEOIAsgACgCDCIHayEsIAcgGmohISARKAJ8ISsgACgCgAEhJyAuIQwgKCEEA0ACQAJ/An8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCkF/aiIFICxJBEAgEEEEEB8gECAKa0EEEB9HDQIgBiAGIAprIBIQHQwBCyAFIClPDQEgByALIAprIgVBf3NqQQNJDQEgEEEEEB8gBSAfaiIFQQQQH0cNASAGIAVBBGogEiAcICEQIAtBBGoiBSAMTQ0AIBkgCUEDdGoiDCAFNgIEIAwgBCAoazYCACAJQQFqIQkgBSAjSw0LIAUiDCAQaiASRg0LCyAEQQFqIgQgKkkNAAsgDyALNgIAQX8gJ3RBf3MhDwJAIAggHkkEQCAPIQUMAQsgC0ECaiEfQQAhB0EAIQYDQCAQIAcgBiAHIAZJGyIEaiAIIBpqIgUgBGogEhAdIARqIgQgDEsEQCAZIAlBA3RqIgwgBDYCBCAMIB8gCGs2AgAgBCAIaiAOIAQgDiAIa0sbIQ4gCUEBaiEJIAQgEGogEkYgBEGAIEtyDQYgBCEMCyAmIAggGHFBA3RqIQoCQAJAIAQgBWotAAAgBCAQai0AAEkEQCANIAg2AgAgCCAbSw0BIBVBQGshDSAPIQUMBAsgFyAINgIAIAggG0sEQCAKIRcgBCEGDAILIBVBQGshFyAPIQUMAwsgBCEHIApBBGoiDSEKCyAPQX9qIgUgD08NASAFIQ8gCigCACIIIB5PDQALCyAXQQA2AgAgDUEANgIAIAVFDQYgESgCICAQICtBBRAeQQJ0aigCACIKIBRNDQYgESgCKCEHIAtBAmohFyAaICVqIQ1BACEIQQAhDwNAIBAgCCAPIAggD0kbIgRqIAogE2ogBGogEiAcICEQICAEaiIEIAxLBEAgGSAJQQN0aiIGIAQ2AgQgBiAXIAogJWoiBms2AgAgBCAGaiAOIAQgDiAGa0sbIQ4gCUEBaiEJIARBgCBLDQggBCIMIBBqIBJGDQgLIAogJE0NByAFQX9qIgVFDQcgBCAIIBMgDSAEIApqIBZJGyAKaiAEai0AACAEIBBqLQAASSIGGyEIIA8gBCAGGyEPIAcgCiAdcUEDdGogBkECdGooAgAiCiAUSw0ACwwGC0EAIQlBACAQIAAoAgQiGmsiC0F/IAAoAnhBf2p0QX9zIhhrIgQgBCALSxshGyAAKAIgIBAgACgCfEEGEB5BAnRqIg8oAgAhCCAAKAJwIhEoAgAiHCARKAIEIhNrIhZBfyARKAJ4QX9qdEF/cyIdayARKAIQIhQgFiAUayAdSxshJCAAKAIQIAAoAhQgCyAAKAJ0ECciBEEBIAQbIR4gEyAEIBZrIiVrIR8gCyAUayAlayEpQQNBBCAiGyEqIAAoAigiJiALIBhxQQN0aiINQQRqIRcgACgCiAEiBEH/HyAEQf8fSRshIyAQQQRqIQYgC0EJaiEOIAsgACgCDCIHayEsIAcgGmohISARKAJ8ISsgACgCgAEhJyAuIQwgKCEEA0ACQAJ/An8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCkF/aiIFICxJBEAgEEEEEB8gECAKa0EEEB9HDQIgBiAGIAprIBIQHQwBCyAFIClPDQEgByALIAprIgVBf3NqQQNJDQEgEEEEEB8gBSAfaiIFQQQQH0cNASAGIAVBBGogEiAcICEQIAtBBGoiBSAMTQ0AIBkgCUEDdGoiDCAFNgIEIAwgBCAoazYCACAJQQFqIQkgBSAjSw0KIAUiDCAQaiASRg0KCyAEQQFqIgQgKkkNAAsgDyALNgIAQX8gJ3RBf3MhDwJAIAggHkkEQCAPIQUMAQsgC0ECaiEfQQAhB0EAIQYDQCAQIAcgBiAHIAZJGyIEaiAIIBpqIgUgBGogEhAdIARqIgQgDEsEQCAZIAlBA3RqIgwgBDYCBCAMIB8gCGs2AgAgBCAIaiAOIAQgDiAIa0sbIQ4gCUEBaiEJIAQgEGogEkYgBEGAIEtyDQYgBCEMCyAmIAggGHFBA3RqIQoCQAJAIAQgBWotAAAgBCAQai0AAEkEQCANIAg2AgAgCCAbSw0BIBVBQGshDSAPIQUMBAsgFyAINgIAIAggG0sEQCAKIRcgBCEGDAILIBVBQGshFyAPIQUMAwsgBCEHIApBBGoiDSEKCyAPQX9qIgUgD08NASAFIQ8gCigCACIIIB5PDQALCyAXQQA2AgAgDUEANgIAIAVFDQQgESgCICAQICtBBhAeQQJ0aigCACIKIBRNDQQgESgCKCEHIAtBAmohFyAaICVqIQ1BACEIQQAhDwNAIBAgCCAPIAggD0kbIgRqIAogE2ogBGogEiAcICEQICAEaiIEIAxLBEAgGSAJQQN0aiIGIAQ2AgQgBiAXIAogJWoiBms2AgAgBCAGaiAOIAQgDiAGa0sbIQ4gCUEBaiEJIARBgCBLDQYgBCIMIBBqIBJGDQYLIAogJE0NBSAFQX9qIgVFDQUgBCAIIBMgDSAEIApqIBZJGyAKaiAEai0AACAEIBBqLQAASSIGGyEIIA8gBCAGGyEPIAcgCiAdcUEDdGogBkECdGooAgAiCiAUSw0ACwwECyANQQA2AgAgF0EANgIADAYLIA1BADYCACAXQQA2AgAMBAsgF0EANgIAIA1BADYCAAwCCyAXQQA2AgAgDUEANgIACyAAIA5BeGo2AhgMAwsgACAOQXhqNgIYDAILIAAgDkF4ajYCGAwBCyAAIAtBeGo2AhgLIAlFDQAgICACKAIANgIQICAgAigCBDYCFCACKAIIIQQgICAiNgIMICBBADYCCCAgIAQ2AhggICADICIgLUECEFgiBTYCACAZIAlBf2pBA3RqIgQoAgQiCiA4SwRAIAQoAgAhCAwDC0EBIQRBACAtQQIQLSEGA0AgICAEQRxsakGAgICABDYCACAEQQFqIgQgNkcNAAsgBSAGaiEIQQAhBiA2IQoDQCAZIAZBA3RqIgQoAgQhByAVQUBrIAIgBCgCACIMICgQPyAKIAdNBEAgDEEBahAkIg9BCHRBgCBqIRcDQCAKQX1qIQQCfyAAKAJkQQFGBEAgBBArIBdqDAELIAAoAmAgACgCOCAPQQJ0aigCABArayAAKAJcaiAEEDxBAnQiBEGQpAFqKAIAIA9qQQh0aiAAKAI0IARqKAIAECtrQTNqCyEFICAgCkEcbGoiBCAiNgIMIAQgDDYCBCAEIAo2AgggBCAFIAhqNgIAIAQgFSkDQDcCECAEIBUoAkg2AhggCkEBaiIKIAdNDQALCyAGQQFqIgYgCUcNAAtBASEPAkAgCkF/aiIERQRAQQAhBAwBCwNAQQEhBSAgIA9Bf2pBHGxqIgcoAghFBEAgBygCDEEBaiEFCyAPIBBqIgtBf2pBASAtQQIQUiAHKAIAaiAFIC1BAhAtaiAFQX9qIC1BAhAtayIGICAgD0EcbGoiGigCACIXTARAIBogBTYCDCAaQgA3AgQgGiAGNgIAIBogBygCGDYCGCAaIAcpAhA3AhAgBiEXCwJAIAsgN0sNACAEIA9GBEAgDyEEDAMLQQAhIiAaKAIIIgZFBEAgGigCDCEiC0EAIC1BAhAtISwgACgCBCIHIAAoAhgiBWogC0sNACAAKAKEASEJIAUgCyAHayIMSQRAA0AgACAFIAdqIBIgCUEAEEEgBWoiBSAMSQ0ACwsgBkEARyEoIBpBEGohJSAAIAw2AhgCQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCAJQX1qDgUAAQIDAwELQQAhDkEAIAsgACgCBCIWayIRQX8gACgCeEF/anRBf3MiJGsiBSAFIBFLGyEfIAAoAiAgCyAAKAJ8QQMQHkECdGoiKygCACENIAAoAnAiEygCACIpIBMoAgQiHGsiHUF/IBMoAnhBf2p0QX9zIiprIBMoAhAiGyAdIBtrICpLGyEnIAAoAhAgACgCFCARIAAoAnQQJyIFQQEgBRshHiAcIAUgHWsiIWshLyARIBtrICFrITBBBEEDIAYbITEgACgCKCIyIBEgJHFBA3RqIhhBBGohDCAAKAKIASIFQf8fIAVB/x9JGyEKIAtBA2ohByARQQlqIRQgESAAKAIMIiZrITMgFiAmaiEjIBMoAnwhNCAAKAKAASE1IC4hCSAoIQUDQAJAAn8CfyAFQQNGBEAgJSgCAEF/agwBCyAaIAVBAnRqKAIQCyIIQX9qIgYgM0kEQCALQQMQHyALIAhrQQMQH0cNAiAHIAcgCGsgEhAdDAELIAYgME8NASAmIBEgCGsiBkF/c2pBA0kNASALQQMQHyAGIC9qIgZBAxAfRw0BIAcgBkEDaiASICkgIxAgC0EDaiIGIAlNDQAgGSAOQQN0aiIJIAY2AgQgCSAFIChrNgIAIA5BAWohDiAGIApLDQ0gBiIJIAtqIBJGDQ0LIAVBAWoiBSAxSQ0ACwJAIAlBAksNAEECIQkgFiAAKAIcIAAoAiQgFUHcAGogCxBAIgUgHkkNACARIAVrIgZB//8PSw0AIAsgBSAWaiASEB0iBUEDSQ0AIBkgBTYCBCAZIAZBAmo2AgAgBSAKTQRAQQEhDiAFIgkgC2ogEkcNAQtBASEOIAAgEUEBajYCGAwMCyArIBE2AgBBfyA1dEF/cyEGAkAgDSAeSQRAIAYhBwwBCyARQQJqISZBACEKQQAhBQNAIAsgCiAFIAogBUkbIgdqIA0gFmoiKyAHaiASEB0gB2oiByAJSwRAIBkgDkEDdGoiCSAHNgIEIAkgJiANazYCACAHIA1qIBQgByAUIA1rSxshFCAOQQFqIQ4gByALaiASRiAHQYAgS3INBiAHIQkLIDIgDSAkcUEDdGohCAJAAkAgByArai0AACAHIAtqLQAASQRAIBggDTYCACANIB9LDQEgFUFAayEYIAYhBwwECyAMIA02AgAgDSAfSwRAIAghDCAHIQUMAgsgFUFAayEMIAYhBwwDCyAHIQogCEEEaiIYIQgLIAZBf2oiByAGTw0BIAchBiAIKAIAIg0gHk8NAAsLIAxBADYCACAYQQA2AgAgB0UNCiATKAIgIAsgNEEDEB5BAnRqKAIAIgggG00NCiATKAIoIQogEUECaiERIBYgIWohE0EAIQ1BACEGA0AgCyANIAYgDSAGSRsiBWogCCAcaiAFaiASICkgIxAgIAVqIgUgCUsEQCAZIA5BA3RqIgkgBTYCBCAJIBEgCCAhaiIJazYCACAFIAlqIBQgBSAUIAlrSxshFCAOQQFqIQ4gBUGAIEsNDCAFIgkgC2ogEkYNDAsgCCAnTQ0LIAdBf2oiB0UNCyAFIA0gHCATIAUgCGogHUkbIAhqIAVqLQAAIAUgC2otAABJIgwbIQ0gBiAFIAwbIQYgCiAIICpxQQN0aiAMQQJ0aigCACIIIBtLDQALDAoLQQAhDkEAIAsgACgCBCIbayITQX8gACgCeEF/anRBf3MiIWsiBSAFIBNLGyEkIAAoAiAgCyAAKAJ8QQQQHkECdGoiIygCACENIAAoAnAiFigCACIfIBYoAgQiHGsiHUF/IBYoAnhBf2p0QX9zIilrIBYoAhAiGCAdIBhrIClLGyErIAAoAhAgACgCFCATIAAoAnQQJyIFQQEgBRshKiAcIAUgHWsiHmshJyATIBhrIB5rIS9BBEEDIAYbITAgACgCKCIxIBMgIXFBA3RqIhRBBGohDCAAKAKIASIFQf8fIAVB/x9JGyEyIAtBBGohByATQQlqIREgEyAAKAIMIgprITMgCiAbaiEmIBYoAnwhNCAAKAKAASE1IC4hCSAoIQUDQAJAAn8CfyAFQQNGBEAgJSgCAEF/agwBCyAaIAVBAnRqKAIQCyIIQX9qIgYgM0kEQCALQQQQHyALIAhrQQQQH0cNAiAHIAcgCGsgEhAdDAELIAYgL08NASAKIBMgCGsiBkF/c2pBA0kNASALQQQQHyAGICdqIgZBBBAfRw0BIAcgBkEEaiASIB8gJhAgC0EEaiIGIAlNDQAgGSAOQQN0aiIJIAY2AgQgCSAFIChrNgIAIA5BAWohDiAGIDJLDQwgBiIJIAtqIBJGDQwLIAVBAWoiBSAwSQ0ACyAjIBM2AgBBfyA1dEF/cyEGAkAgDSAqSQRAIAYhBwwBCyATQQJqISNBACEKQQAhBQNAIAsgCiAFIAogBUkbIgdqIA0gG2oiJyAHaiASEB0gB2oiByAJSwRAIBkgDkEDdGoiCSAHNgIEIAkgIyANazYCACAHIA1qIBEgByARIA1rSxshESAOQQFqIQ4gByALaiASRiAHQYAgS3INBiAHIQkLIDEgDSAhcUEDdGohCAJAAkAgByAnai0AACAHIAtqLQAASQRAIBQgDTYCACANICRLDQEgFUFAayEUIAYhBwwECyAMIA02AgAgDSAkSwRAIAghDCAHIQUMAgsgFUFAayEMIAYhBwwDCyAHIQogCEEEaiIUIQgLIAZBf2oiByAGTw0BIAchBiAIKAIAIg0gKk8NAAsLIAxBADYCACAUQQA2AgAgB0UNCCAWKAIgIAsgNEEEEB5BAnRqKAIAIgggGE0NCCAWKAIoIQogE0ECaiEUIBsgHmohE0EAIQ1BACEGA0AgCyANIAYgDSAGSRsiBWogCCAcaiAFaiASIB8gJhAgIAVqIgUgCUsEQCAZIA5BA3RqIgkgBTYCBCAJIBQgCCAeaiIJazYCACAFIAlqIBEgBSARIAlrSxshESAOQQFqIQ4gBUGAIEsNCiAFIgkgC2ogEkYNCgsgCCArTQ0JIAdBf2oiB0UNCSAFIA0gHCATIAUgCGogHUkbIAhqIAVqLQAAIAUgC2otAABJIgwbIQ0gBiAFIAwbIQYgCiAIIClxQQN0aiAMQQJ0aigCACIIIBhLDQALDAgLQQAhDkEAIAsgACgCBCIbayITQX8gACgCeEF/anRBf3MiIWsiBSAFIBNLGyEkIAAoAiAgCyAAKAJ8QQUQHkECdGoiIygCACENIAAoAnAiFigCACIfIBYoAgQiHGsiHUF/IBYoAnhBf2p0QX9zIilrIBYoAhAiGCAdIBhrIClLGyErIAAoAhAgACgCFCATIAAoAnQQJyIFQQEgBRshKiAcIAUgHWsiHmshJyATIBhrIB5rIS9BBEEDIAYbITAgACgCKCIxIBMgIXFBA3RqIhRBBGohDCAAKAKIASIFQf8fIAVB/x9JGyEyIAtBBGohByATQQlqIREgEyAAKAIMIgprITMgCiAbaiEmIBYoAnwhNCAAKAKAASE1IC4hCSAoIQUDQAJAAn8CfyAFQQNGBEAgJSgCAEF/agwBCyAaIAVBAnRqKAIQCyIIQX9qIgYgM0kEQCALQQQQHyALIAhrQQQQH0cNAiAHIAcgCGsgEhAdDAELIAYgL08NASAKIBMgCGsiBkF/c2pBA0kNASALQQQQHyAGICdqIgZBBBAfRw0BIAcgBkEEaiASIB8gJhAgC0EEaiIGIAlNDQAgGSAOQQN0aiIJIAY2AgQgCSAFIChrNgIAIA5BAWohDiAGIDJLDQsgBiIJIAtqIBJGDQsLIAVBAWoiBSAwSQ0ACyAjIBM2AgBBfyA1dEF/cyEGAkAgDSAqSQRAIAYhBwwBCyATQQJqISNBACEKQQAhBQNAIAsgCiAFIAogBUkbIgdqIA0gG2oiJyAHaiASEB0gB2oiByAJSwRAIBkgDkEDdGoiCSAHNgIEIAkgIyANazYCACAHIA1qIBEgByARIA1rSxshESAOQQFqIQ4gByALaiASRiAHQYAgS3INBiAHIQkLIDEgDSAhcUEDdGohCAJAAkAgByAnai0AACAHIAtqLQAASQRAIBQgDTYCACANICRLDQEgFUFAayEUIAYhBwwECyAMIA02AgAgDSAkSwRAIAghDCAHIQUMAgsgFUFAayEMIAYhBwwDCyAHIQogCEEEaiIUIQgLIAZBf2oiByAGTw0BIAchBiAIKAIAIg0gKk8NAAsLIAxBADYCACAUQQA2AgAgB0UNBiAWKAIgIAsgNEEFEB5BAnRqKAIAIgggGE0NBiAWKAIoIQogE0ECaiEUIBsgHmohE0EAIQ1BACEGA0AgCyANIAYgDSAGSRsiBWogCCAcaiAFaiASIB8gJhAgIAVqIgUgCUsEQCAZIA5BA3RqIgkgBTYCBCAJIBQgCCAeaiIJazYCACAFIAlqIBEgBSARIAlrSxshESAOQQFqIQ4gBUGAIEsNCCAFIgkgC2ogEkYNCAsgCCArTQ0HIAdBf2oiB0UNByAFIA0gHCATIAUgCGogHUkbIAhqIAVqLQAAIAUgC2otAABJIgwbIQ0gBiAFIAwbIQYgCiAIIClxQQN0aiAMQQJ0aigCACIIIBhLDQALDAYLQQAhDkEAIAsgACgCBCIbayITQX8gACgCeEF/anRBf3MiIWsiBSAFIBNLGyEkIAAoAiAgCyAAKAJ8QQYQHkECdGoiIygCACENIAAoAnAiFigCACIfIBYoAgQiHGsiHUF/IBYoAnhBf2p0QX9zIilrIBYoAhAiGCAdIBhrIClLGyErIAAoAhAgACgCFCATIAAoAnQQJyIFQQEgBRshKiAcIAUgHWsiHmshJyATIBhrIB5rIS9BBEEDIAYbITAgACgCKCIxIBMgIXFBA3RqIhRBBGohDCAAKAKIASIFQf8fIAVB/x9JGyEyIAtBBGohByATQQlqIREgEyAAKAIMIgprITMgCiAbaiEmIBYoAnwhNCAAKAKAASE1IC4hCSAoIQUDQAJAAn8CfyAFQQNGBEAgJSgCAEF/agwBCyAaIAVBAnRqKAIQCyIIQX9qIgYgM0kEQCALQQQQHyALIAhrQQQQH0cNAiAHIAcgCGsgEhAdDAELIAYgL08NASAKIBMgCGsiBkF/c2pBA0kNASALQQQQHyAGICdqIgZBBBAfRw0BIAcgBkEEaiASIB8gJhAgC0EEaiIGIAlNDQAgGSAOQQN0aiIJIAY2AgQgCSAFIChrNgIAIA5BAWohDiAGIDJLDQogBiIJIAtqIBJGDQoLIAVBAWoiBSAwSQ0ACyAjIBM2AgBBfyA1dEF/cyEGAkAgDSAqSQRAIAYhBwwBCyATQQJqISNBACEKQQAhBQNAIAsgCiAFIAogBUkbIgdqIA0gG2oiJyAHaiASEB0gB2oiByAJSwRAIBkgDkEDdGoiCSAHNgIEIAkgIyANazYCACAHIA1qIBEgByARIA1rSxshESAOQQFqIQ4gByALaiASRiAHQYAgS3INBiAHIQkLIDEgDSAhcUEDdGohCAJAAkAgByAnai0AACAHIAtqLQAASQRAIBQgDTYCACANICRLDQEgFUFAayEUIAYhBwwECyAMIA02AgAgDSAkSwRAIAghDCAHIQUMAgsgFUFAayEMIAYhBwwDCyAHIQogCEEEaiIUIQgLIAZBf2oiByAGTw0BIAchBiAIKAIAIg0gKk8NAAsLIAxBADYCACAUQQA2AgAgB0UNBCAWKAIgIAsgNEEGEB5BAnRqKAIAIgggGE0NBCAWKAIoIQogE0ECaiEUIBsgHmohE0EAIQ1BACEGA0AgCyANIAYgDSAGSRsiBWogCCAcaiAFaiASIB8gJhAgIAVqIgUgCUsEQCAZIA5BA3RqIgkgBTYCBCAJIBQgCCAeaiIJazYCACAFIAlqIBEgBSARIAlrSxshESAOQQFqIQ4gBUGAIEsNBiAFIgkgC2ogEkYNBgsgCCArTQ0FIAdBf2oiB0UNBSAFIA0gHCATIAUgCGogHUkbIAhqIAVqLQAAIAUgC2otAABJIgwbIQ0gBiAFIAwbIQYgCiAIIClxQQN0aiAMQQJ0aigCACIIIBhLDQALDAQLIAxBADYCACAYQQA2AgAMBgsgDEEANgIAIBRBADYCAAwECyAMQQA2AgAgFEEANgIADAILIAxBADYCACAUQQA2AgALIAAgEUF4ajYCGAwDCyAAIBFBeGo2AhgMAgsgACARQXhqNgIYDAELIAAgFEF4ajYCGAsgDkUNACAZIA5Bf2pBA3RqIgUoAgQiCiA4SyAKIA9qQYAgT3INBCAXICxqIRdBACEKA0AgFUFAayAlIBkgCkEDdGoiBigCACIHICgQPyA2IQwCfyAKBEAgBkF8aigCAEEBaiEMCyAGKAIEIgUgDE8LBEAgB0EBahAkIglBCHRBgCBqIQ0DQCAFQX1qIQggBSAPaiEGAn8gACgCZEEBRgRAIAgQKyANagwBCyAAKAJgIAAoAjggCUECdGooAgAQK2sgACgCXGogCBA8QQJ0IghBkKQBaigCACAJakEIdGogACgCNCAIaigCABAra0EzagsgF2ohCAJAAkAgBiAETQRAIAggICAGQRxsaigCAEgNAQwCCwNAICAgBEEBaiIEQRxsakGAgICABDYCACAEIAZJDQALCyAgIAZBHGxqIgYgIjYCDCAGIAc2AgQgBiAFNgIIIAYgCDYCACAGIBUpA0A3AhAgBiAVKAJINgIYCyAFQX9qIgUgDE8NAAsLIApBAWoiCiAORw0ACwsgD0EBaiIPIARNDQALCyAgIARBHGxqIgUoAgwhIiAFKAIEIQggBSgCACE6IAUoAgghCiAVIAUoAhg2AlggFSAFKQIQNwNQIBUgBSkCCDcDKCAVIAUpAhA3AzAgFSAFKAIYNgI4IBUgBSkCADcDIEEAIAQgFUEgahA+ayIFIAUgBEsbIQQMAwsgEEEBaiEQDAcLIAUoAgAhCEEAIQQgDyAaKAIIBH8gBAUgGigCDAtrIgRBgCBNDQELICAgIjYCKCAgIAo2AiQgICAINgIgICAgOjYCHCAgIBUoAlg2AjQgICAVKQNQNwIsDAELICAgBEEBaiIJQRxsaiIFICI2AgwgBSAKNgIIIAUgCDYCBCAFIDo2AgAgBSAVKQNQNwIQIAUgFSgCWDYCGCAJISIgBA0BC0EBISJBASEJDAELA0AgFSAgIARBHGxqIgUiDEEYaigCADYCGCAVIAUpAhA3AxAgFSAFKQIINwMIIBUgBSkCADcDACAVED4hByAgICJBf2oiIkEcbGoiBiAMKAIYNgIYIAYgBSkCEDcCECAGIAUpAgg3AgggBiAFKQIANwIAIAQgB0shBUEAIAQgB2siBiAGIARLGyEEIAUNAAsgIiAJSw0BCwNAICAgIkEcbGoiBCgCDCEGAn8gAyAGaiAEKAIIIgxFDQAaAkACQCAEKAIEIgdBA08EQCACIAIpAgA3AgQgB0F+aiEEDAELAkACQAJAAkAgByAGRWoiBQ4EBQEBAAELIAIoAgBBf2ohBAwBCyACIAVBAnRqKAIAIQQgBUECSQ0BCyACIAIoAgQ2AggLIAIgAigCADYCBAsgAiAENgIACyAtIAYgAyAHIAwQVyAMQX1qIQ8gASgCDCEEAkACQCADIAZqIgUgOU0EQCAEIAMQHCABKAIMIQQgBkEQTQRAIAEgBCAGajYCDAwDCyAEQRBqIANBEGoiChAcIARBIGogA0EgahAcIAZBMUgNASAEIAZqIQggBEEwaiEEA0AgBCAKQSBqIgUQHCAEQRBqIApBMGoQHCAFIQogBEEgaiIEIAhJDQALDAELIAQgAyAFIDkQIgsgASABKAIMIAZqNgIMIAZBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiBCAHQQFqNgIAIAQgBjsBBCAPQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIA87AQYgASAEQQhqNgIEIAYgDGogA2oiAwshECAiQQFqIiIgCU0NAAsLIC1BAhBRCyAQIDdJDQALCyAVQeAAaiQAIBIgA2sLu1wBN38jAEHgAGsiFyQAIAAoAoQBIQcgACgCBCEGIAAoAogBIREgACgCDCEFIBcgACgCGDYCXCAAKAI8IRsgAEFAaygCACEkIABBLGoiNSADIARBABBZIAMgBSAGaiADRmoiDSADIARqIhBBeGoiOEkEQCARQf8fIBFB/x9JGyE5IBBBYGohOkEDQQQgB0EDRhsiN0F/aiE2A0ACQAJAAkACQAJAAkACQAJAAkAgACgCBCIHIAAoAhgiBGogDUsNACANIANrIS4gACgChAEhBiAEIA0gB2siBUkEQANAIAAgBCAHaiAQIAZBABBBIARqIgQgBUkNAAsLIC5FISwgACAFNgIYAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgBkF9ag4FAAECAwMBC0EAIQtBACANIAAoAgQiGWsiD0F/IAAoAnhBf2p0QX9zIiZrIgQgBCAPSxshJyAAKAIgIA0gACgCfEEDEB5BAnRqIi8oAgAhCSAAKAJwIhYoAgAiKCAWKAIEIh1rIh5BfyAWKAJ4QX9qdEF/cyIpayAWKAIQIhwgHiAcayApSxshMCAAKAIQIAAoAhQgDyAAKAJ0ECciBEEBIAQbIR8gHSAEIB5rIiJrITEgDyAcayAiayEUQQNBBCAuGyEgIAAoAigiMiAPICZxQQN0aiIMQQRqIQogACgCiAEiBEH/HyAEQf8fSRshNCANQQNqISUgD0EJaiETIA8gACgCDCIrayEVIBkgK2ohLSAWKAJ8ISEgACgCgAEhByA2IREgLCEEA0ACQAJ/An8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCEF/aiIFIBVJBEAgDUEDEB8gDSAIa0EDEB9HDQIgJSAlIAhrIBAQHQwBCyAFIBRPDQEgKyAPIAhrIgVBf3NqQQNJDQEgDUEDEB8gBSAxaiIFQQMQH0cNASAlIAVBA2ogECAoIC0QIAtBA2oiBSARTQ0AIBsgC0EDdGoiBiAFNgIEIAYgBCAsazYCACALQQFqIQsgBSA0Sw0NIAUiESANaiAQRg0NCyAEQQFqIgQgIEkNAAsCQCARQQJLDQBBAiERIBkgACgCHCAAKAIkIBdB3ABqIA0QQCIEIB9JDQAgDyAEayIFQf//D0sNACANIAQgGWogEBAdIgRBA0kNACAbIAQ2AgQgGyAFQQJqNgIAIAQgNE0EQEEBIQsgBCIRIA1qIBBHDQELQQEhCyAAIA9BAWo2AhgMDAsgLyAPNgIAQX8gB3RBf3MhBQJAIAkgH0kEQCAFIQcMAQsgD0ECaiEUQQAhBkEAIRUDQCANIAYgFSAGIBVJGyIEaiAJIBlqIiAgBGogEBAdIARqIgQgEUsEQCAbIAtBA3RqIgcgBDYCBCAHIBQgCWs2AgAgBCAJaiATIAQgEyAJa0sbIRMgC0EBaiELIAQgDWogEEYgBEGAIEtyDQYgBCERCyAyIAkgJnFBA3RqIQgCQAJAIAQgIGotAAAgBCANai0AAEkEQCAMIAk2AgAgCSAnSw0BIBdBQGshDCAFIQcMBAsgCiAJNgIAIAkgJ0sEQCAIIQogBCEVDAILIBdBQGshCiAFIQcMAwsgBCEGIAhBBGoiDCEICyAFQX9qIgcgBU8NASAHIQUgCCgCACIJIB9PDQALCyAKQQA2AgAgDEEANgIAIAdFDQogFigCICANICFBAxAeQQJ0aigCACIIIBxNDQogFigCKCEMIA9BAmohFSAZICJqIQpBACEJQQAhBQNAIA0gCSAFIAkgBUkbIgRqIAggHWogBGogECAoIC0QICAEaiIEIBFLBEAgGyALQQN0aiIGIAQ2AgQgBiAVIAggImoiBms2AgAgBCAGaiATIAQgEyAGa0sbIRMgC0EBaiELIARBgCBLDQwgBCIRIA1qIBBGDQwLIAggME0NCyAHQX9qIgdFDQsgBCAJIB0gCiAEIAhqIB5JGyAIaiAEai0AACAEIA1qLQAASSIGGyEJIAUgBCAGGyEFIAwgCCApcUEDdGogBkECdGooAgAiCCAcSw0ACwwKC0EAIQtBACANIAAoAgQiHGsiD0F/IAAoAnhBf2p0QX9zIiVrIgQgBCAPSxshJiAAKAIgIA0gACgCfEEEEB5BAnRqIi0oAgAhCSAAKAJwIhYoAgAiJyAWKAIEIh1rIh5BfyAWKAJ4QX9qdEF/cyIoayAWKAIQIhkgHiAZayAoSxshLyAAKAIQIAAoAhQgDyAAKAJ0ECciBEEBIAQbISkgHSAEIB5rIh9rITAgDyAZayAfayExQQNBBCAuGyEUIAAoAigiMiAPICVxQQN0aiIqQQRqIQwgACgCiAEiBEH/HyAEQf8fSRshICANQQRqISIgD0EJaiEKIA8gACgCDCI0ayEVIBwgNGohKyAWKAJ8ISEgACgCgAEhByA2IREgLCEEA0ACQAJ/An8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCEF/aiIFIBVJBEAgDUEEEB8gDSAIa0EEEB9HDQIgIiAiIAhrIBAQHQwBCyAFIDFPDQEgNCAPIAhrIgVBf3NqQQNJDQEgDUEEEB8gBSAwaiIFQQQQH0cNASAiIAVBBGogECAnICsQIAtBBGoiBSARTQ0AIBsgC0EDdGoiBiAFNgIEIAYgBCAsazYCACALQQFqIQsgBSAgSw0MIAUiESANaiAQRg0MCyAEQQFqIgQgFEkNAAsgLSAPNgIAQX8gB3RBf3MhBQJAIAkgKUkEQCAFIQcMAQsgD0ECaiEUQQAhBkEAIRUDQCANIAYgFSAGIBVJGyIEaiAJIBxqIiAgBGogEBAdIARqIgQgEUsEQCAbIAtBA3RqIgcgBDYCBCAHIBQgCWs2AgAgBCAJaiAKIAQgCiAJa0sbIQogC0EBaiELIAQgDWogEEYgBEGAIEtyDQYgBCERCyAyIAkgJXFBA3RqIQgCQAJAIAQgIGotAAAgBCANai0AAEkEQCAqIAk2AgAgCSAmSw0BIBdBQGshKiAFIQcMBAsgDCAJNgIAIAkgJksEQCAIIQwgBCEVDAILIBdBQGshDCAFIQcMAwsgBCEGIAhBBGoiKiEICyAFQX9qIgcgBU8NASAHIQUgCCgCACIJIClPDQALCyAMQQA2AgAgKkEANgIAIAdFDQggFigCICANICFBBBAeQQJ0aigCACIIIBlNDQggFigCKCEgIA9BAmohDCAcIB9qIRVBACEJQQAhBQNAIA0gCSAFIAkgBUkbIgRqIAggHWogBGogECAnICsQICAEaiIEIBFLBEAgGyALQQN0aiIGIAQ2AgQgBiAMIAggH2oiBms2AgAgBCAGaiAKIAQgCiAGa0sbIQogC0EBaiELIARBgCBLDQogBCIRIA1qIBBGDQoLIAggL00NCSAHQX9qIgdFDQkgBCAJIB0gFSAEIAhqIB5JGyAIaiAEai0AACAEIA1qLQAASSIGGyEJIAUgBCAGGyEFICAgCCAocUEDdGogBkECdGooAgAiCCAZSw0ACwwIC0EAIQtBACANIAAoAgQiHGsiD0F/IAAoAnhBf2p0QX9zIiVrIgQgBCAPSxshJiAAKAIgIA0gACgCfEEFEB5BAnRqIi0oAgAhCSAAKAJwIhYoAgAiJyAWKAIEIh1rIh5BfyAWKAJ4QX9qdEF/cyIoayAWKAIQIhkgHiAZayAoSxshLyAAKAIQIAAoAhQgDyAAKAJ0ECciBEEBIAQbISkgHSAEIB5rIh9rITAgDyAZayAfayExQQNBBCAuGyEUIAAoAigiMiAPICVxQQN0aiIqQQRqIQwgACgCiAEiBEH/HyAEQf8fSRshICANQQRqISIgD0EJaiEKIA8gACgCDCI0ayEVIBwgNGohKyAWKAJ8ISEgACgCgAEhByA2IREgLCEEA0ACQAJ/An8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCEF/aiIFIBVJBEAgDUEEEB8gDSAIa0EEEB9HDQIgIiAiIAhrIBAQHQwBCyAFIDFPDQEgNCAPIAhrIgVBf3NqQQNJDQEgDUEEEB8gBSAwaiIFQQQQH0cNASAiIAVBBGogECAnICsQIAtBBGoiBSARTQ0AIBsgC0EDdGoiBiAFNgIEIAYgBCAsazYCACALQQFqIQsgBSAgSw0LIAUiESANaiAQRg0LCyAEQQFqIgQgFEkNAAsgLSAPNgIAQX8gB3RBf3MhBQJAIAkgKUkEQCAFIQcMAQsgD0ECaiEUQQAhBkEAIRUDQCANIAYgFSAGIBVJGyIEaiAJIBxqIiAgBGogEBAdIARqIgQgEUsEQCAbIAtBA3RqIgcgBDYCBCAHIBQgCWs2AgAgBCAJaiAKIAQgCiAJa0sbIQogC0EBaiELIAQgDWogEEYgBEGAIEtyDQYgBCERCyAyIAkgJXFBA3RqIQgCQAJAIAQgIGotAAAgBCANai0AAEkEQCAqIAk2AgAgCSAmSw0BIBdBQGshKiAFIQcMBAsgDCAJNgIAIAkgJksEQCAIIQwgBCEVDAILIBdBQGshDCAFIQcMAwsgBCEGIAhBBGoiKiEICyAFQX9qIgcgBU8NASAHIQUgCCgCACIJIClPDQALCyAMQQA2AgAgKkEANgIAIAdFDQYgFigCICANICFBBRAeQQJ0aigCACIIIBlNDQYgFigCKCEgIA9BAmohDCAcIB9qIRVBACEJQQAhBQNAIA0gCSAFIAkgBUkbIgRqIAggHWogBGogECAnICsQICAEaiIEIBFLBEAgGyALQQN0aiIGIAQ2AgQgBiAMIAggH2oiBms2AgAgBCAGaiAKIAQgCiAGa0sbIQogC0EBaiELIARBgCBLDQggBCIRIA1qIBBGDQgLIAggL00NByAHQX9qIgdFDQcgBCAJIB0gFSAEIAhqIB5JGyAIaiAEai0AACAEIA1qLQAASSIGGyEJIAUgBCAGGyEFICAgCCAocUEDdGogBkECdGooAgAiCCAZSw0ACwwGC0EAIQtBACANIAAoAgQiHGsiD0F/IAAoAnhBf2p0QX9zIiVrIgQgBCAPSxshJiAAKAIgIA0gACgCfEEGEB5BAnRqIi0oAgAhCSAAKAJwIhYoAgAiJyAWKAIEIh1rIh5BfyAWKAJ4QX9qdEF/cyIoayAWKAIQIhkgHiAZayAoSxshLyAAKAIQIAAoAhQgDyAAKAJ0ECciBEEBIAQbISkgHSAEIB5rIh9rITAgDyAZayAfayExQQNBBCAuGyEUIAAoAigiMiAPICVxQQN0aiIqQQRqIQwgACgCiAEiBEH/HyAEQf8fSRshICANQQRqISIgD0EJaiEKIA8gACgCDCI0ayEVIBwgNGohKyAWKAJ8ISEgACgCgAEhByA2IREgLCEEA0ACQAJ/An8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCEF/aiIFIBVJBEAgDUEEEB8gDSAIa0EEEB9HDQIgIiAiIAhrIBAQHQwBCyAFIDFPDQEgNCAPIAhrIgVBf3NqQQNJDQEgDUEEEB8gBSAwaiIFQQQQH0cNASAiIAVBBGogECAnICsQIAtBBGoiBSARTQ0AIBsgC0EDdGoiBiAFNgIEIAYgBCAsazYCACALQQFqIQsgBSAgSw0KIAUiESANaiAQRg0KCyAEQQFqIgQgFEkNAAsgLSAPNgIAQX8gB3RBf3MhBQJAIAkgKUkEQCAFIQcMAQsgD0ECaiEUQQAhBkEAIRUDQCANIAYgFSAGIBVJGyIEaiAJIBxqIiAgBGogEBAdIARqIgQgEUsEQCAbIAtBA3RqIgcgBDYCBCAHIBQgCWs2AgAgBCAJaiAKIAQgCiAJa0sbIQogC0EBaiELIAQgDWogEEYgBEGAIEtyDQYgBCERCyAyIAkgJXFBA3RqIQgCQAJAIAQgIGotAAAgBCANai0AAEkEQCAqIAk2AgAgCSAmSw0BIBdBQGshKiAFIQcMBAsgDCAJNgIAIAkgJksEQCAIIQwgBCEVDAILIBdBQGshDCAFIQcMAwsgBCEGIAhBBGoiKiEICyAFQX9qIgcgBU8NASAHIQUgCCgCACIJIClPDQALCyAMQQA2AgAgKkEANgIAIAdFDQQgFigCICANICFBBhAeQQJ0aigCACIIIBlNDQQgFigCKCEgIA9BAmohDCAcIB9qIRVBACEJQQAhBQNAIA0gCSAFIAkgBUkbIgRqIAggHWogBGogECAnICsQICAEaiIEIBFLBEAgGyALQQN0aiIGIAQ2AgQgBiAMIAggH2oiBms2AgAgBCAGaiAKIAQgCiAGa0sbIQogC0EBaiELIARBgCBLDQYgBCIRIA1qIBBGDQYLIAggL00NBSAHQX9qIgdFDQUgBCAJIB0gFSAEIAhqIB5JGyAIaiAEai0AACAEIA1qLQAASSIGGyEJIAUgBCAGGyEFICAgCCAocUEDdGogBkECdGooAgAiCCAZSw0ACwwECyAKQQA2AgAgDEEANgIADAYLIAxBADYCACAqQQA2AgAMBAsgDEEANgIAICpBADYCAAwCCyAMQQA2AgAgKkEANgIACyAAIApBeGo2AhgMAwsgACAKQXhqNgIYDAILIAAgCkF4ajYCGAwBCyAAIBNBeGo2AhgLIAtFDQAgJCACKAIANgIQICQgAigCBDYCFCACKAIIIQQgJCAuNgIMICRBADYCCCAkIAQ2AhggJCADIC4gNUEAEFgiBjYCACAbIAtBf2pBA3RqIgQoAgQiCCA5SwRAIAQoAgAhBQwDC0EBIQRBACA1QQAQLSEFA0AgJCAEQRxsakGAgICABDYCACAEQQFqIgQgN0cNAAsgBSAGaiERQQAhCiA3IQgDQCAbIApBA3RqIgQoAgQhDCAXQUBrIAIgBCgCACIVICwQPyAIIAxNBEAgFUEBahAkIiBBCXRBs7R/akEzICBBE0sbIQYgIEEIdEGAIGohBQNAIAhBfWohBAJ/IAAoAmRBAUYEQCAEEC4gBWoMAQsgACgCYCAGaiAAKAI4ICBBAnRqKAIAEC5rIAAoAlxqIAQQPEECdCIEQZCkAWooAgAgIGpBCHRqIAAoAjQgBGooAgAQLmsLIQcgJCAIQRxsaiIEIC42AgwgBCAVNgIEIAQgCDYCCCAEIAcgEWo2AgAgBCAXKQNANwIQIAQgFygCSDYCGCAIQQFqIgggDE0NAAsLIApBAWoiCiALRw0AC0EBIRECQCAIQX9qIgRFBEBBACEEDAELA0BBASEHICQgEUF/akEcbGoiBigCCEUEQCAGKAIMQQFqIQcLIA0gEWoiEkF/akEBIDVBABBSIAYoAgBqIAcgNUEAEC1qIAdBf2ogNUEAEC1rIgUgJCARQRxsaiIzKAIAIhVMBEAgMyAHNgIMIDNCADcCBCAzIAU2AgAgMyAGKAIYNgIYIDMgBikCEDcCECAFIRULIBIgOEsEfyARQQFqBSAEIBFGBEAgESEEDAMLAkAgJCARQQFqIiBBHGxqKAIAIBVBgAFqTA0AQQAhLiAzKAIIIgpFBEAgMygCDCEuC0EAIDVBABAtITQgACgCBCILIAAoAhgiB2ogEksNACAAKAKEASEGIAcgEiALayIFSQRAA0AgACAHIAtqIBAgBkEAEEEgB2oiByAFSQ0ACwsgCkEARyEsIDNBEGohKiAAIAU2AhgCQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCAGQX1qDgUAAQIDAwELQQAhE0EAIBIgACgCBCIPayIaQX8gACgCeEF/anRBf3MiImsiBSAFIBpLGyElIAAoAiAgEiAAKAJ8QQMQHkECdGoiLSgCACEOIAAoAnAiIygCACImICMoAgQiGWsiHEF/ICMoAnhBf2p0QX9zIidrICMoAhAiFiAcIBZrICdLGyEvIAAoAhAgACgCFCAaIAAoAnQQJyIFQQEgBRshHSAZIAUgHGsiHmshMCAaIBZrIB5rISFBBEEDIAobIRQgACgCKCIxIBogInFBA3RqIgxBBGohCSAAKAKIASIFQf8fIAVB/x9JGyEoIBJBA2ohHyAaQQlqIRggGiAAKAIMIilrIQggDyApaiErICMoAnwhMiAAKAKAASEKIDYhCyAsIQcDQAJAAn8CfyAHQQNGBEAgKigCAEF/agwBCyAzIAdBAnRqKAIQCyIFQX9qIgYgCEkEQCASQQMQHyASIAVrQQMQH0cNAiAfIB8gBWsgEBAdDAELIAYgIU8NASApIBogBWsiBUF/c2pBA0kNASASQQMQHyAFIDBqIgVBAxAfRw0BIB8gBUEDaiAQICYgKxAgC0EDaiIFIAtNDQAgGyATQQN0aiIGIAU2AgQgBiAHICxrNgIAIBNBAWohEyAFIChLDQ0gBSILIBJqIBBGDQ0LIAdBAWoiByAUSQ0ACwJAIAtBAksNAEECIQsgDyAAKAIcIAAoAiQgF0HcAGogEhBAIgUgHUkNACAaIAVrIgZB//8PSw0AIBIgBSAPaiAQEB0iBUEDSQ0AIBsgBTYCBCAbIAZBAmo2AgAgBSAoTQRAQQEhEyAFIgsgEmogEEcNAQtBASETIAAgGkEBajYCGAwMCyAtIBo2AgBBfyAKdEF/cyEKAkAgDiAdSQRAIAohBgwBCyAaQQJqISFBACEIQQAhBwNAIBIgCCAHIAggB0kbIgVqIA4gD2oiFCAFaiAQEB0gBWoiBiALSwRAIBsgE0EDdGoiBSAGNgIEIAUgISAOazYCACAGIA5qIBggBiAYIA5rSxshGCATQQFqIRMgBiASaiAQRiAGQYAgS3INBiAGIQsLIDEgDiAicUEDdGohBQJAAkAgBiAUai0AACAGIBJqLQAASQRAIAwgDjYCACAOICVLDQEgF0FAayEMIAohBgwECyAJIA42AgAgDiAlSwRAIAUhCSAGIQcMAgsgF0FAayEJIAohBgwDCyAGIQggBUEEaiIMIQULIApBf2oiBiAKTw0BIAYhCiAFKAIAIg4gHU8NAAsLIAlBADYCACAMQQA2AgAgBkUNCiAjKAIgIBIgMkEDEB5BAnRqKAIAIgUgFk0NCiAjKAIoIQkgGkECaiEMIA8gHmohCEEAIQ5BACEKA0AgEiAOIAogDiAKSRsiB2ogBSAZaiAHaiAQICYgKxAgIAdqIgcgC0sEQCAbIBNBA3RqIgsgBzYCBCALIAwgBSAeaiILazYCACAHIAtqIBggByAYIAtrSxshGCATQQFqIRMgB0GAIEsNDCAHIgsgEmogEEYNDAsgBSAvTQ0LIAZBf2oiBkUNCyAHIA4gGSAIIAUgB2ogHEkbIAVqIAdqLQAAIAcgEmotAABJIhQbIQ4gCiAHIBQbIQogCSAFICdxQQN0aiAUQQJ0aigCACIFIBZLDQALDAoLQQAhE0EAIBIgACgCBCIWayIYQX8gACgCeEF/anRBf3MiH2siBSAFIBhLGyEiIAAoAiAgEiAAKAJ8QQQQHkECdGoiKygCACEOIAAoAnAiIygCACIlICMoAgQiGWsiHEF/ICMoAnhBf2p0QX9zIiZrICMoAhAiDyAcIA9rICZLGyEtIAAoAhAgACgCFCAYIAAoAnQQJyIFQQEgBRshJyAZIAUgHGsiHWshLyAYIA9rIB1rITBBBEEDIAobISEgACgCKCIxIBggH3FBA3RqIglBBGohDCAAKAKIASIFQf8fIAVB/x9JGyEUIBJBBGohHiAYQQlqIRogGCAAKAIMIihrIQggFiAoaiEpICMoAnwhMiAAKAKAASEKIDYhCyAsIQcDQAJAAn8CfyAHQQNGBEAgKigCAEF/agwBCyAzIAdBAnRqKAIQCyIFQX9qIgYgCEkEQCASQQQQHyASIAVrQQQQH0cNAiAeIB4gBWsgEBAdDAELIAYgME8NASAoIBggBWsiBUF/c2pBA0kNASASQQQQHyAFIC9qIgVBBBAfRw0BIB4gBUEEaiAQICUgKRAgC0EEaiIFIAtNDQAgGyATQQN0aiIGIAU2AgQgBiAHICxrNgIAIBNBAWohEyAFIBRLDQwgBSILIBJqIBBGDQwLIAdBAWoiByAhSQ0ACyArIBg2AgBBfyAKdEF/cyEKAkAgDiAnSQRAIAohBgwBCyAYQQJqISFBACEIQQAhBwNAIBIgCCAHIAggB0kbIgVqIA4gFmoiFCAFaiAQEB0gBWoiBiALSwRAIBsgE0EDdGoiBSAGNgIEIAUgISAOazYCACAGIA5qIBogBiAaIA5rSxshGiATQQFqIRMgBiASaiAQRiAGQYAgS3INBiAGIQsLIDEgDiAfcUEDdGohBQJAAkAgBiAUai0AACAGIBJqLQAASQRAIAkgDjYCACAOICJLDQEgF0FAayEJIAohBgwECyAMIA42AgAgDiAiSwRAIAUhDCAGIQcMAgsgF0FAayEMIAohBgwDCyAGIQggBUEEaiIJIQULIApBf2oiBiAKTw0BIAYhCiAFKAIAIg4gJ08NAAsLIAxBADYCACAJQQA2AgAgBkUNCCAjKAIgIBIgMkEEEB5BAnRqKAIAIgUgD00NCCAjKAIoIQkgGEECaiEMIBYgHWohCEEAIQ5BACEKA0AgEiAOIAogDiAKSRsiB2ogBSAZaiAHaiAQICUgKRAgIAdqIgcgC0sEQCAbIBNBA3RqIgsgBzYCBCALIAwgBSAdaiILazYCACAHIAtqIBogByAaIAtrSxshGiATQQFqIRMgB0GAIEsNCiAHIgsgEmogEEYNCgsgBSAtTQ0JIAZBf2oiBkUNCSAHIA4gGSAIIAUgB2ogHEkbIAVqIAdqLQAAIAcgEmotAABJIhQbIQ4gCiAHIBQbIQogCSAFICZxQQN0aiAUQQJ0aigCACIFIA9LDQALDAgLQQAhE0EAIBIgACgCBCIWayIYQX8gACgCeEF/anRBf3MiH2siBSAFIBhLGyEiIAAoAiAgEiAAKAJ8QQUQHkECdGoiKygCACEOIAAoAnAiIygCACIlICMoAgQiGWsiHEF/ICMoAnhBf2p0QX9zIiZrICMoAhAiDyAcIA9rICZLGyEtIAAoAhAgACgCFCAYIAAoAnQQJyIFQQEgBRshJyAZIAUgHGsiHWshLyAYIA9rIB1rITBBBEEDIAobISEgACgCKCIxIBggH3FBA3RqIglBBGohDCAAKAKIASIFQf8fIAVB/x9JGyEUIBJBBGohHiAYQQlqIRogGCAAKAIMIihrIQggFiAoaiEpICMoAnwhMiAAKAKAASEKIDYhCyAsIQcDQAJAAn8CfyAHQQNGBEAgKigCAEF/agwBCyAzIAdBAnRqKAIQCyIFQX9qIgYgCEkEQCASQQQQHyASIAVrQQQQH0cNAiAeIB4gBWsgEBAdDAELIAYgME8NASAoIBggBWsiBUF/c2pBA0kNASASQQQQHyAFIC9qIgVBBBAfRw0BIB4gBUEEaiAQICUgKRAgC0EEaiIFIAtNDQAgGyATQQN0aiIGIAU2AgQgBiAHICxrNgIAIBNBAWohEyAFIBRLDQsgBSILIBJqIBBGDQsLIAdBAWoiByAhSQ0ACyArIBg2AgBBfyAKdEF/cyEKAkAgDiAnSQRAIAohBgwBCyAYQQJqISFBACEIQQAhBwNAIBIgCCAHIAggB0kbIgVqIA4gFmoiFCAFaiAQEB0gBWoiBiALSwRAIBsgE0EDdGoiBSAGNgIEIAUgISAOazYCACAGIA5qIBogBiAaIA5rSxshGiATQQFqIRMgBiASaiAQRiAGQYAgS3INBiAGIQsLIDEgDiAfcUEDdGohBQJAAkAgBiAUai0AACAGIBJqLQAASQRAIAkgDjYCACAOICJLDQEgF0FAayEJIAohBgwECyAMIA42AgAgDiAiSwRAIAUhDCAGIQcMAgsgF0FAayEMIAohBgwDCyAGIQggBUEEaiIJIQULIApBf2oiBiAKTw0BIAYhCiAFKAIAIg4gJ08NAAsLIAxBADYCACAJQQA2AgAgBkUNBiAjKAIgIBIgMkEFEB5BAnRqKAIAIgUgD00NBiAjKAIoIQkgGEECaiEMIBYgHWohCEEAIQ5BACEKA0AgEiAOIAogDiAKSRsiB2ogBSAZaiAHaiAQICUgKRAgIAdqIgcgC0sEQCAbIBNBA3RqIgsgBzYCBCALIAwgBSAdaiILazYCACAHIAtqIBogByAaIAtrSxshGiATQQFqIRMgB0GAIEsNCCAHIgsgEmogEEYNCAsgBSAtTQ0HIAZBf2oiBkUNByAHIA4gGSAIIAUgB2ogHEkbIAVqIAdqLQAAIAcgEmotAABJIhQbIQ4gCiAHIBQbIQogCSAFICZxQQN0aiAUQQJ0aigCACIFIA9LDQALDAYLQQAhE0EAIBIgACgCBCIWayIYQX8gACgCeEF/anRBf3MiH2siBSAFIBhLGyEiIAAoAiAgEiAAKAJ8QQYQHkECdGoiKygCACEOIAAoAnAiIygCACIlICMoAgQiGWsiHEF/ICMoAnhBf2p0QX9zIiZrICMoAhAiDyAcIA9rICZLGyEtIAAoAhAgACgCFCAYIAAoAnQQJyIFQQEgBRshJyAZIAUgHGsiHWshLyAYIA9rIB1rITBBBEEDIAobISEgACgCKCIxIBggH3FBA3RqIgxBBGohCSAAKAKIASIFQf8fIAVB/x9JGyEUIBJBBGohHiAYQQlqIRogGCAAKAIMIihrIQggFiAoaiEpICMoAnwhMiAAKAKAASEKIDYhCyAsIQcDQAJAAn8CfyAHQQNGBEAgKigCAEF/agwBCyAzIAdBAnRqKAIQCyIFQX9qIgYgCEkEQCASQQQQHyASIAVrQQQQH0cNAiAeIB4gBWsgEBAdDAELIAYgME8NASAoIBggBWsiBUF/c2pBA0kNASASQQQQHyAFIC9qIgVBBBAfRw0BIB4gBUEEaiAQICUgKRAgC0EEaiIFIAtNDQAgGyATQQN0aiIGIAU2AgQgBiAHICxrNgIAIBNBAWohEyAFIBRLDQogBSILIBJqIBBGDQoLIAdBAWoiByAhSQ0ACyArIBg2AgBBfyAKdEF/cyEKAkAgDiAnSQRAIAohBgwBCyAYQQJqISFBACEIQQAhBwNAIBIgCCAHIAggB0kbIgVqIA4gFmoiFCAFaiAQEB0gBWoiBiALSwRAIBsgE0EDdGoiBSAGNgIEIAUgISAOazYCACAGIA5qIBogBiAaIA5rSxshGiATQQFqIRMgBiASaiAQRiAGQYAgS3INBiAGIQsLIDEgDiAfcUEDdGohBQJAAkAgBiAUai0AACAGIBJqLQAASQRAIAwgDjYCACAOICJLDQEgF0FAayEMIAohBgwECyAJIA42AgAgDiAiSwRAIAUhCSAGIQcMAgsgF0FAayEJIAohBgwDCyAGIQggBUEEaiIMIQULIApBf2oiBiAKTw0BIAYhCiAFKAIAIg4gJ08NAAsLIAlBADYCACAMQQA2AgAgBkUNBCAjKAIgIBIgMkEGEB5BAnRqKAIAIgUgD00NBCAjKAIoIQkgGEECaiEMIBYgHWohCEEAIQ5BACEKA0AgEiAOIAogDiAKSRsiB2ogBSAZaiAHaiAQICUgKRAgIAdqIgcgC0sEQCAbIBNBA3RqIgsgBzYCBCALIAwgBSAdaiILazYCACAHIAtqIBogByAaIAtrSxshGiATQQFqIRMgB0GAIEsNBiAHIgsgEmogEEYNBgsgBSAtTQ0FIAZBf2oiBkUNBSAHIA4gGSAIIAUgB2ogHEkbIAVqIAdqLQAAIAcgEmotAABJIhQbIQ4gCiAHIBQbIQogCSAFICZxQQN0aiAUQQJ0aigCACIFIA9LDQALDAQLIAlBADYCACAMQQA2AgAMBgsgDEEANgIAIAlBADYCAAwECyAMQQA2AgAgCUEANgIADAILIAlBADYCACAMQQA2AgALIAAgGkF4ajYCGAwDCyAAIBpBeGo2AhgMAgsgACAaQXhqNgIYDAELIAAgGEF4ajYCGAsgE0UNACAbIBNBf2pBA3RqIgUoAgQiCCA5SyAIIBFqQYAgT3INBSAVIDRqIRVBACEIA0AgF0FAayAqIBsgCEEDdGoiBigCACIMICwQPyA3IQUgCARAIAZBfGooAgBBAWohBQsCQCAGKAIEIgcgBUkNACAMQQFqECQiIUEJdEGztH9qQTMgIUETSxshCiAhQQh0QYAgaiELA0AgB0F9aiEGIAcgEWohFAJ/IAAoAmRBAUYEQCAGEC4gC2oMAQsgACgCYCAKaiAAKAI4ICFBAnRqKAIAEC5rIAAoAlxqIAYQPEECdCIGQZCkAWooAgAgIWpBCHRqIAAoAjQgBmooAgAQLmsLIBVqIQYCQCAUIARNBEAgBiAkIBRBHGxqKAIASA0BDAMLA0AgJCAEQQFqIgRBHGxqQYCAgIAENgIAIAQgFEkNAAsLICQgFEEcbGoiCSAuNgIMIAkgDDYCBCAJIAc2AgggCSAGNgIAIAkgFykDQDcCECAJIBcoAkg2AhggB0F/aiIHIAVPDQALCyAIQQFqIgggE0cNAAsLICALIhEgBE0NAAsLICQgBEEcbGoiBigCDCEuIAYoAgQhBSAGKAIAITsgBigCCCEIIBcgBigCGDYCWCAXIAYpAhA3A1AgFyAGKQIINwMoIBcgBikCEDcDMCAXIAYoAhg2AjggFyAGKQIANwMgQQAgBCAXQSBqED5rIgYgBiAESxshBAwDCyANQQFqIQ0MBwsgBSgCACEFQQAhBCARIDMoAggEfyAEBSAzKAIMC2siBEGAIE0NAQsgJCAuNgIoICQgCDYCJCAkIAU2AiAgJCA7NgIcICQgFygCWDYCNCAkIBcpA1A3AiwMAQsgJCAEQQFqIhVBHGxqIgYgLjYCDCAGIAg2AgggBiAFNgIEIAYgOzYCACAGIBcpA1A3AhAgBiAXKAJYNgIYIBUhCSAEDQELQQEhCUEBIRUMAQsDQCAXICQgBEEcbGoiESIFQRhqKAIANgIYIBcgESkCEDcDECAXIBEpAgg3AwggFyARKQIANwMAIBcQPiEHICQgCUF/aiIJQRxsaiIGIAUoAhg2AhggBiARKQIQNwIQIAYgESkCCDcCCCAGIBEpAgA3AgAgBCAHSyEGQQAgBCAHayIFIAUgBEsbIQQgBg0ACyAJIBVLDQELA0AgJCAJQRxsaiIEKAIMIQoCfyADIApqIAQoAggiEUUNABoCQAJAIAQoAgQiC0EDTwRAIAIgAikCADcCBCALQX5qIQQMAQsCQAJAAkACQCALIApFaiIFDgQFAQEAAQsgAigCAEF/aiEEDAELIAIgBUECdGooAgAhBCAFQQJJDQELIAIgAigCBDYCCAsgAiACKAIANgIECyACIAQ2AgALIDUgCiADIAsgERBXIBFBfWohByABKAIMIQUCQAJAIAMgCmoiBCA6TQRAIAUgAxAcIAEoAgwhBCAKQRBNBEAgASAEIApqNgIMDAMLIARBEGogA0EQaiIIEBwgBEEgaiADQSBqEBwgCkExSA0BIAQgCmohBiAEQTBqIQQDQCAEIAhBIGoiBRAcIARBEGogCEEwahAcIAUhCCAEQSBqIgQgBkkNAAsMAQsgBSADIAQgOhAiCyABIAEoAgwgCmo2AgwgCkGAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIEIAtBAWo2AgAgBCAKOwEEIAdBgIAETwRAIAFBAjYCJCABIAQgASgCAGtBA3U2AigLIAQgBzsBBiABIARBCGo2AgQgCiARaiADaiIDCyENIAlBAWoiCSAVTQ0ACwsgNUEAEFELIA0gOEkNAAsLIBdB4ABqJAAgECADawsLAEGI7AEoAgAQOAtIACAAQUBrKAIAEHAEQCAAIAAoAgBB/wEQfjYCGAsgACAAKAIEQSMQfjYCHCAAIAAoAghBNBB+NgIgIAAgACgCDEEfEH42AiQL6T4BKX8jAEHwAGsiDCQAIAwgAigCCDYCSCAMIAIpAgA3A0AgACgChAEhBSAAKAIEIQkgACgCiAEhAiAAKAIMIQcgDCAAKAIYNgJsIAAoAjwhFyAAQUBrKAIAIRggAEEsaiIiIAMgBEECEFkgAyAHIAlqIANGaiIPIAMgBGoiEkF4aiIpSQRAIAJB/x8gAkH/H0kbISogEkFgaiErQQNBBCAFQQNGGyIoQX9qISMDQAJAAkACQAJAAkACQAJAAkACQCAAKAIEIgUgACgCGCICaiAPSw0AIA8gA2shGSAAKAKEASEJIAIgDyAFayIHSQRAA0AgACACIAVqIBIgCUEAEEEgAmoiAiAHSQ0ACwsgGUUhHSAAIAc2AhgCQAJAAkACQAJAIAlBfWoOBQABAgMDAQtBACEKQQAgDyAAKAIEIhNrIgZBfyAAKAJ4QX9qdEF/cyIQayICIAIgBksbIRUgACgCICAPIAAoAnxBAxAeQQJ0aiIaKAIAIQggACgCECAAKAIUIAYgACgCdBAnIgJBASACGyENQQNBBCAZGyEbIAAoAigiHCAGIBBxQQN0aiIOQQRqIRYgACgCiAEiAkH/HyACQf8fSRshCyAPQQNqIRQgBkEJaiEJIAYgACgCDGshHiAMKAJAQX9qIREgACgCgAEhHyAjIQUgHSECA0AgESEHIAJBA0cEQCAMQUBrIAJBAnRqKAIAIQcLAkAgB0F/aiAeTw0AIA9BAxAfIA8gB2tBAxAfRw0AIBQgFCAHayASEB1BA2oiByAFTQ0AIBcgCkEDdGoiBSAHNgIEIAUgAiAdazYCACAKQQFqIQogByALSw0FIAciBSAPaiASRg0FCyACQQFqIgIgG0kNAAsCQCAFQQJLDQBBAiEFIBMgACgCHCAAKAIkIAxB7ABqIA8QQCICIA1JDQAgBiACayIHQf//D0sNACAPIAIgE2ogEhAdIgJBA0kNACAXIAI2AgQgFyAHQQJqNgIAIAIgC00EQEEBIQogAiIFIA9qIBJHDQELQQEhCiAAIAZBAWo2AhgMBAsgGiAGNgIAAkAgCCANSQ0AIAZBAmohFEF/IB90QX9zIQtBACEGQQAhEQNAIA8gBiARIAYgEUkbIgJqIAggE2oiGiACaiASEB0gAmoiAiAFSwRAIBcgCkEDdGoiBSACNgIEIAUgFCAIazYCACACIAhqIAkgAiAJIAhrSxshCSAKQQFqIQogAkGAIEsNAiACIgUgD2ogEkYNAgsgHCAIIBBxQQN0aiEHAkACQCACIBpqLQAAIAIgD2otAABJBEAgDiAINgIAIAggFUsNASAMQdAAaiEODAQLIBYgCDYCACAIIBVLBEAgByEWIAIhEQwCCyAMQdAAaiEWDAMLIAIhBiAHQQRqIg4hBwsgC0UNASALQX9qIQsgBygCACIIIA1PDQALCyAWQQA2AgAgDkEANgIAIAAgCUF4ajYCGAwDC0EAIQpBACAPIAAoAgQiFWsiBkF/IAAoAnhBf2p0QX9zIhNrIgIgAiAGSxshDSAAKAIgIA8gACgCfEEEEB5BAnRqIhQoAgAhCCAAKAIQIAAoAhQgBiAAKAJ0ECciAkEBIAIbIRBBA0EEIBkbIRogACgCKCIbIAYgE3FBA3RqIg5BBGohFiAAKAKIASICQf8fIAJB/x9JGyEcIA9BBGohCyAGQQlqIQkgBiAAKAIMayEeIAwoAkBBf2ohESAAKAKAASEfICMhBSAdIQIDQCARIQcgAkEDRwRAIAxBQGsgAkECdGooAgAhBwsCQCAHQX9qIB5PDQAgD0EEEB8gDyAHa0EEEB9HDQAgCyALIAdrIBIQHUEEaiIHIAVNDQAgFyAKQQN0aiIFIAc2AgQgBSACIB1rNgIAIApBAWohCiAHIBxLDQQgByIFIA9qIBJGDQQLIAJBAWoiAiAaSQ0ACyAUIAY2AgACQCAIIBBJDQAgBkECaiEUQX8gH3RBf3MhC0EAIQZBACERA0AgDyAGIBEgBiARSRsiAmogCCAVaiIaIAJqIBIQHSACaiICIAVLBEAgFyAKQQN0aiIFIAI2AgQgBSAUIAhrNgIAIAIgCGogCSACIAkgCGtLGyEJIApBAWohCiACQYAgSw0CIAIiBSAPaiASRg0CCyAbIAggE3FBA3RqIQcCQAJAIAIgGmotAAAgAiAPai0AAEkEQCAOIAg2AgAgCCANSw0BIAxB0ABqIQ4MBAsgFiAINgIAIAggDUsEQCAHIRYgAiERDAILIAxB0ABqIRYMAwsgAiEGIAdBBGoiDiEHCyALRQ0BIAtBf2ohCyAHKAIAIgggEE8NAAsLIBZBADYCACAOQQA2AgAgACAJQXhqNgIYDAILQQAhCkEAIA8gACgCBCIVayIGQX8gACgCeEF/anRBf3MiE2siAiACIAZLGyENIAAoAiAgDyAAKAJ8QQUQHkECdGoiFCgCACEIIAAoAhAgACgCFCAGIAAoAnQQJyICQQEgAhshEEEDQQQgGRshGiAAKAIoIhsgBiATcUEDdGoiFkEEaiEOIAAoAogBIgJB/x8gAkH/H0kbIRwgD0EEaiELIAZBCWohCSAGIAAoAgxrIR4gDCgCQEF/aiERIAAoAoABIR8gIyEFIB0hAgNAIBEhByACQQNHBEAgDEFAayACQQJ0aigCACEHCwJAIAdBf2ogHk8NACAPQQQQHyAPIAdrQQQQH0cNACALIAsgB2sgEhAdQQRqIgcgBU0NACAXIApBA3RqIgUgBzYCBCAFIAIgHWs2AgAgCkEBaiEKIAcgHEsNAyAHIgUgD2ogEkYNAwsgAkEBaiICIBpJDQALIBQgBjYCAAJAIAggEEkNACAGQQJqIRRBfyAfdEF/cyELQQAhBkEAIREDQCAPIAYgESAGIBFJGyICaiAIIBVqIhogAmogEhAdIAJqIgIgBUsEQCAXIApBA3RqIgUgAjYCBCAFIBQgCGs2AgAgAiAIaiAJIAIgCSAIa0sbIQkgCkEBaiEKIAJBgCBLDQIgAiIFIA9qIBJGDQILIBsgCCATcUEDdGohBwJAAkAgAiAaai0AACACIA9qLQAASQRAIBYgCDYCACAIIA1LDQEgDEHQAGohFgwECyAOIAg2AgAgCCANSwRAIAchDiACIREMAgsgDEHQAGohDgwDCyACIQYgB0EEaiIWIQcLIAtFDQEgC0F/aiELIAcoAgAiCCAQTw0ACwsgDkEANgIAIBZBADYCACAAIAlBeGo2AhgMAQtBACEKQQAgDyAAKAIEIhVrIgZBfyAAKAJ4QX9qdEF/cyITayICIAIgBksbIQ0gACgCICAPIAAoAnxBBhAeQQJ0aiIUKAIAIQggACgCECAAKAIUIAYgACgCdBAnIgJBASACGyEQQQNBBCAZGyEaIAAoAigiGyAGIBNxQQN0aiIWQQRqIQ4gACgCiAEiAkH/HyACQf8fSRshHCAPQQRqIQsgBkEJaiEJIAYgACgCDGshHiAMKAJAQX9qIREgACgCgAEhHyAjIQUgHSECA0AgESEHIAJBA0cEQCAMQUBrIAJBAnRqKAIAIQcLAkAgB0F/aiAeTw0AIA9BBBAfIA8gB2tBBBAfRw0AIAsgCyAHayASEB1BBGoiByAFTQ0AIBcgCkEDdGoiBSAHNgIEIAUgAiAdazYCACAKQQFqIQogByAcSw0CIAciBSAPaiASRg0CCyACQQFqIgIgGkkNAAsgFCAGNgIAAkAgCCAQSQ0AIAZBAmohFEF/IB90QX9zIQtBACEGQQAhEQNAIA8gBiARIAYgEUkbIgJqIAggFWoiGiACaiASEB0gAmoiAiAFSwRAIBcgCkEDdGoiBSACNgIEIAUgFCAIazYCACACIAhqIAkgAiAJIAhrSxshCSAKQQFqIQogAkGAIEsNAiACIgUgD2ogEkYNAgsgGyAIIBNxQQN0aiEHAkACQCACIBpqLQAAIAIgD2otAABJBEAgFiAINgIAIAggDUsNASAMQdAAaiEWDAQLIA4gCDYCACAIIA1LBEAgByEOIAIhEQwCCyAMQdAAaiEODAMLIAIhBiAHQQRqIhYhBwsgC0UNASALQX9qIQsgBygCACIIIBBPDQALCyAOQQA2AgAgFkEANgIAIAAgCUF4ajYCGAsgCkUNACAYIAwoAkA2AhAgGCAMKAJENgIUIAwoAkghAiAYIBk2AgwgGEEANgIIIBggAjYCGCAYIAMgGSAiQQIQWCIFNgIAIBcgCkF/akEDdGoiAigCBCIHICpLBEAgAigCACELDAMLQQEhAkEAICJBAhAtIQkDQCAYIAJBHGxqQYCAgIAENgIAIAJBAWoiAiAoRw0ACyAFIAlqIQtBACEJICghBwNAIBcgCUEDdGoiAigCBCEFIAxB0ABqIAxBQGsgAigCACIRIB0QPyAHIAVNBEAgEUEBahAkIgZBCHRBgCBqIQ4DQCAHQX1qIQICfyAAKAJkQQFGBEAgAhArIA5qDAELIAAoAmAgACgCOCAGQQJ0aigCABArayAAKAJcaiACEDxBAnQiAkGQpAFqKAIAIAZqQQh0aiAAKAI0IAJqKAIAECtrQTNqCyEIIBggB0EcbGoiAiAZNgIMIAIgETYCBCACIAc2AgggAiAIIAtqNgIAIAIgDCkDUDcCECACIAwoAlg2AhggB0EBaiIHIAVNDQALCyAJQQFqIgkgCkcNAAtBASERAkAgB0F/aiICRQRAQQAhAgwBCwNAQQEhCCAYIBFBf2pBHGxqIgkoAghFBEAgCSgCDEEBaiEICyAPIBFqIg1Bf2pBASAiQQIQUiAJKAIAaiAIICJBAhAtaiAIQX9qICJBAhAtayIFIBggEUEcbGoiFCgCACIWTARAIBQgCDYCDCAUQgA3AgQgFCAFNgIAIBQgCSgCGDYCGCAUIAkpAhA3AhAgBSEWCwJAIA0gKUsNACACIBFGBEAgESECDAMLQQAhGSAUKAIIIglFBEAgFCgCDCEZC0EAICJBAhAtIS0gACgCBCIFIAAoAhgiCGogDUsNACAAKAKEASEHIAggDSAFayIKSQRAA0AgACAFIAhqIBIgB0EAEEEgCGoiCCAKSQ0ACwsgCUEARyEdIBRBEGohGiAAIAo2AhgCQAJAAkACQAJAIAdBfWoOBQABAgMDAQtBACEQQQAgDSAAKAIEIhtrIgZBfyAAKAJ4QX9qdEF/cyIeayIFIAUgBksbIR8gACgCICANIAAoAnxBAxAeQQJ0aiIhKAIAIQUgACgCECAAKAIUIAYgACgCdBAnIgdBASAHGyEcQQRBAyAJGyEkIAAoAigiJSAGIB5xQQN0aiIHQQRqIRMgACgCiAEiCUH/HyAJQf8fSRshDiANQQNqISAgBkEJaiEVIAYgACgCDGshJiAAKAKAASEnICMhCSAdIQgDQAJAAn8gCEEDRgRAIBooAgBBf2oMAQsgFCAIQQJ0aigCEAsiC0F/aiAmTw0AIA1BAxAfIA0gC2tBAxAfRw0AICAgICALayASEB1BA2oiCiAJTQ0AIBcgEEEDdGoiCSAKNgIEIAkgCCAdazYCACAQQQFqIRAgCiAOSw0FIAoiCSANaiASRg0FCyAIQQFqIgggJEkNAAsCQCAJQQJLDQBBAiEJIBsgACgCHCAAKAIkIAxB7ABqIA0QQCIKIBxJDQAgBiAKayIIQf//D0sNACANIAogG2ogEhAdIgpBA0kNACAXIAo2AgQgFyAIQQJqNgIAIAogDk0EQEEBIRAgCiIJIA1qIBJHDQELQQEhECAAIAZBAWo2AhgMBAsgISAGNgIAAkAgBSAcSQ0AIAZBAmohIEF/ICd0QX9zIQhBACEKQQAhDgNAIA0gCiAOIAogDkkbIgZqIAUgG2oiISAGaiASEB0gBmoiBiAJSwRAIBcgEEEDdGoiCSAGNgIEIAkgICAFazYCACAFIAZqIBUgBiAVIAVrSxshFSAQQQFqIRAgBkGAIEsNAiAGIgkgDWogEkYNAgsgJSAFIB5xQQN0aiELAkACQCAGICFqLQAAIAYgDWotAABJBEAgByAFNgIAIAUgH0sNASAMQdAAaiEHDAQLIBMgBTYCACAFIB9LBEAgCyETIAYhDgwCCyAMQdAAaiETDAMLIAYhCiALQQRqIgchCwsgCEUNASAIQX9qIQggCygCACIFIBxPDQALCyATQQA2AgAgB0EANgIAIAAgFUF4ajYCGAwDC0EAIRBBACANIAAoAgQiH2siBkF/IAAoAnhBf2p0QX9zIhtrIgUgBSAGSxshHCAAKAIgIA0gACgCfEEEEB5BAnRqIiAoAgAhBSAAKAIQIAAoAhQgBiAAKAJ0ECciB0EBIAcbIR5BBEEDIAkbISEgACgCKCIkIAYgG3FBA3RqIhNBBGohByAAKAKIASIJQf8fIAlB/x9JGyElIA1BBGohDiAGQQlqIRUgBiAAKAIMayEmIAAoAoABIScgIyEJIB0hCANAAkACfyAIQQNGBEAgGigCAEF/agwBCyAUIAhBAnRqKAIQCyILQX9qICZPDQAgDUEEEB8gDSALa0EEEB9HDQAgDiAOIAtrIBIQHUEEaiIKIAlNDQAgFyAQQQN0aiIJIAo2AgQgCSAIIB1rNgIAIBBBAWohECAKICVLDQQgCiIJIA1qIBJGDQQLIAhBAWoiCCAhSQ0ACyAgIAY2AgACQCAFIB5JDQAgBkECaiEgQX8gJ3RBf3MhCEEAIQpBACEOA0AgDSAKIA4gCiAOSRsiBmogBSAfaiIhIAZqIBIQHSAGaiIGIAlLBEAgFyAQQQN0aiIJIAY2AgQgCSAgIAVrNgIAIAUgBmogFSAGIBUgBWtLGyEVIBBBAWohECAGQYAgSw0CIAYiCSANaiASRg0CCyAkIAUgG3FBA3RqIQsCQAJAIAYgIWotAAAgBiANai0AAEkEQCATIAU2AgAgBSAcSw0BIAxB0ABqIRMMBAsgByAFNgIAIAUgHEsEQCALIQcgBiEODAILIAxB0ABqIQcMAwsgBiEKIAtBBGoiEyELCyAIRQ0BIAhBf2ohCCALKAIAIgUgHk8NAAsLIAdBADYCACATQQA2AgAgACAVQXhqNgIYDAILQQAhEEEAIA0gACgCBCIfayIGQX8gACgCeEF/anRBf3MiG2siBSAFIAZLGyEcIAAoAiAgDSAAKAJ8QQUQHkECdGoiICgCACEFIAAoAhAgACgCFCAGIAAoAnQQJyIHQQEgBxshHkEEQQMgCRshISAAKAIoIiQgBiAbcUEDdGoiE0EEaiEHIAAoAogBIglB/x8gCUH/H0kbISUgDUEEaiEOIAZBCWohFSAGIAAoAgxrISYgACgCgAEhJyAjIQkgHSEIA0ACQAJ/IAhBA0YEQCAaKAIAQX9qDAELIBQgCEECdGooAhALIgtBf2ogJk8NACANQQQQHyANIAtrQQQQH0cNACAOIA4gC2sgEhAdQQRqIgogCU0NACAXIBBBA3RqIgkgCjYCBCAJIAggHWs2AgAgEEEBaiEQIAogJUsNAyAKIgkgDWogEkYNAwsgCEEBaiIIICFJDQALICAgBjYCAAJAIAUgHkkNACAGQQJqISBBfyAndEF/cyEIQQAhCkEAIQ4DQCANIAogDiAKIA5JGyIGaiAFIB9qIiEgBmogEhAdIAZqIgYgCUsEQCAXIBBBA3RqIgkgBjYCBCAJICAgBWs2AgAgBSAGaiAVIAYgFSAFa0sbIRUgEEEBaiEQIAZBgCBLDQIgBiIJIA1qIBJGDQILICQgBSAbcUEDdGohCwJAAkAgBiAhai0AACAGIA1qLQAASQRAIBMgBTYCACAFIBxLDQEgDEHQAGohEwwECyAHIAU2AgAgBSAcSwRAIAshByAGIQ4MAgsgDEHQAGohBwwDCyAGIQogC0EEaiITIQsLIAhFDQEgCEF/aiEIIAsoAgAiBSAeTw0ACwsgB0EANgIAIBNBADYCACAAIBVBeGo2AhgMAQtBACEQQQAgDSAAKAIEIh9rIgZBfyAAKAJ4QX9qdEF/cyIbayIFIAUgBksbIRwgACgCICANIAAoAnxBBhAeQQJ0aiIgKAIAIQUgACgCECAAKAIUIAYgACgCdBAnIgdBASAHGyEeQQRBAyAJGyEhIAAoAigiJCAGIBtxQQN0aiITQQRqIQcgACgCiAEiCUH/HyAJQf8fSRshJSANQQRqIQ4gBkEJaiEVIAYgACgCDGshJiAAKAKAASEnICMhCSAdIQgDQAJAAn8gCEEDRgRAIBooAgBBf2oMAQsgFCAIQQJ0aigCEAsiC0F/aiAmTw0AIA1BBBAfIA0gC2tBBBAfRw0AIA4gDiALayASEB1BBGoiCiAJTQ0AIBcgEEEDdGoiCSAKNgIEIAkgCCAdazYCACAQQQFqIRAgCiAlSw0CIAoiCSANaiASRg0CCyAIQQFqIgggIUkNAAsgICAGNgIAAkAgBSAeSQ0AIAZBAmohIEF/ICd0QX9zIQhBACEKQQAhDgNAIA0gCiAOIAogDkkbIgZqIAUgH2oiISAGaiASEB0gBmoiBiAJSwRAIBcgEEEDdGoiCSAGNgIEIAkgICAFazYCACAFIAZqIBUgBiAVIAVrSxshFSAQQQFqIRAgBkGAIEsNAiAGIgkgDWogEkYNAgsgJCAFIBtxQQN0aiELAkACQCAGICFqLQAAIAYgDWotAABJBEAgEyAFNgIAIAUgHEsNASAMQdAAaiETDAQLIAcgBTYCACAFIBxLBEAgCyEHIAYhDgwCCyAMQdAAaiEHDAMLIAYhCiALQQRqIhMhCwsgCEUNASAIQX9qIQggCygCACIFIB5PDQALCyAHQQA2AgAgE0EANgIAIAAgFUF4ajYCGAsgEEUNACAXIBBBf2pBA3RqIgUoAgQiByAqSyAHIBFqQYAgT3INBCAWIC1qIQ5BACEWA0AgDEHQAGogGiAXIBZBA3RqIgUoAgAiCSAdED8gKCEGAn8gFgRAIAVBfGooAgBBAWohBgsgBSgCBCIIIAZPCwRAIAlBAWoQJCIHQQh0QYAgaiETA0AgCEF9aiEKIAggEWohBQJ/IAAoAmRBAUYEQCAKECsgE2oMAQsgACgCYCAAKAI4IAdBAnRqKAIAECtrIAAoAlxqIAoQPEECdCIKQZCkAWooAgAgB2pBCHRqIAAoAjQgCmooAgAQK2tBM2oLIA5qIQoCQAJAIAUgAk0EQCAKIBggBUEcbGooAgBIDQEMAgsDQCAYIAJBAWoiAkEcbGpBgICAgAQ2AgAgAiAFSQ0ACwsgGCAFQRxsaiIFIBk2AgwgBSAJNgIEIAUgCDYCCCAFIAo2AgAgBSAMKQNQNwIQIAUgDCgCWDYCGAsgCEF/aiIIIAZPDQALCyAWQQFqIhYgEEcNAAsLIBFBAWoiESACTQ0ACwsgGCACQRxsaiIFKAIMIRkgBSgCBCELIAUoAgAhLCAFKAIIIQcgDCAFKAIYNgJoIAwgBSkCEDcDYCAMIAUpAgg3AyggDCAFKQIQNwMwIAwgBSgCGDYCOCAMIAUpAgA3AyBBACACIAxBIGoQPmsiBSAFIAJLGyECDAMLIA9BAWohDwwHCyAFKAIAIQtBACECIBEgFCgCCAR/IAIFIBQoAgwLayICQYAgTQ0BCyAYIBk2AiggGCAHNgIkIBggCzYCICAYICw2AhwgGCAMKAJoNgI0IBggDCkDYDcCLAwBCyAYIAJBAWoiCkEcbGoiBSAZNgIMIAUgBzYCCCAFIAs2AgQgBSAsNgIAIAUgDCkDYDcCECAFIAwoAmg2AhggCiEZIAINAQtBASEZQQEhCgwBCwNAIAwgGCACQRxsaiIFIhFBGGooAgA2AhggDCAFKQIQNwMQIAwgBSkCCDcDCCAMIAUpAgA3AwAgDBA+IQcgGCAZQX9qIhlBHGxqIgkgESgCGDYCGCAJIAUpAhA3AhAgCSAFKQIINwIIIAkgBSkCADcCACACIAdLIQVBACACIAdrIgkgCSACSxshAiAFDQALIBkgCksNAQsDQCAYIBlBHGxqIgIoAgwhCQJ/IAMgCWogAigCCCIGRQ0AGgJAIAIoAgQiEUEDTwRAIAwgDCkDQDcCRCAMIBFBfmo2AkAMAQsCQAJAAkACQCARIAlFaiICDgQEAQEAAQsgDCgCQEF/aiEHDAELIAxBQGsgAkECdGooAgAhByACQQJJDQELIAwgDCgCRDYCSAsgDCAMKAJANgJEIAwgBzYCQAsgIiAJIAMgESAGEFcgBkF9aiEIIAEoAgwhAgJAAkAgAyAJaiIFICtNBEAgAiADEBwgASgCDCECIAlBEE0EQCABIAIgCWo2AgwMAwsgAkEQaiADQRBqIgcQHCACQSBqIANBIGoQHCAJQTFIDQEgAiAJaiELIAJBMGohAgNAIAIgB0EgaiIFEBwgAkEQaiAHQTBqEBwgBSEHIAJBIGoiAiALSQ0ACwwBCyACIAMgBSArECILIAEgASgCDCAJajYCDCAJQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyABKAIEIgIgEUEBajYCACACIAk7AQQgCEGAgARPBEAgAUECNgIkIAEgAiABKAIAa0EDdTYCKAsgAiAIOwEGIAEgAkEIajYCBCAGIAlqIANqIgMLIQ8gGUEBaiIZIApNDQALCyAiQQIQUQsgDyApSQ0ACwsgARDyASAAIAAoAgQgBGs2AgQgACAAKAIMIARqIgE2AgwgACABNgIYIAAgATYCECAiEJ4DIAxB8ABqJAALwD4BKX8jAEHgAGsiESQAIAAoAgQhBQJAIAAoAkgNACABKAIEIAEoAgBHDQAgACgCDCIJIAAoAhBHIARBgQhJciADIAVrIAlHcg0AIAAgASACIAMgBBCfAyAAKAIEIQULIAAoAoQBIQcgACgCiAEhCSAAKAIMISEgESAAKAIYNgJcIAAoAjwhGCAAQUBrKAIAIRkgAEEsaiIiIAMgBEECEFkgAyAFICFqIANGaiIPIAMgBGoiEkF4aiIpSQRAIAlB/x8gCUH/H0kbISogEkFgaiErQQNBBCAHQQNGGyIoQX9qISEDQAJAAkACQAJAAkACQAJAAkACQCAAKAIEIgkgACgCGCIEaiAPSw0AIA8gA2shGiAAKAKEASEHIAQgDyAJayIFSQRAA0AgACAEIAlqIBIgB0EAEEEgBGoiBCAFSQ0ACwsgGkUhHCAAIAU2AhgCQAJAAkACQAJAIAdBfWoOBQABAgMDAQtBACELQQAgDyAAKAIEIhNrIgZBfyAAKAJ4QX9qdEF/cyIQayIEIAQgBksbIRUgACgCICAPIAAoAnxBAxAeQQJ0aiIUKAIAIQggACgCECAAKAIUIAYgACgCdBAnIgRBASAEGyEOQQNBBCAaGyEfIAAoAigiFyAGIBBxQQN0aiIWQQRqIQogACgCiAEiBEH/HyAEQf8fSRshDSAPQQNqIQwgBkEJaiEHIAYgACgCDGshGyAAKAKAASEdICEhCSAcIQQDQAJAAn8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiBUF/aiAbTw0AIA9BAxAfIA8gBWtBAxAfRw0AIAwgDCAFayASEB1BA2oiBSAJTQ0AIBggC0EDdGoiCSAFNgIEIAkgBCAcazYCACALQQFqIQsgBSANSw0FIAUiCSAPaiASRg0FCyAEQQFqIgQgH0kNAAsCQCAJQQJLDQBBAiEJIBMgACgCHCAAKAIkIBFB3ABqIA8QQCIEIA5JDQAgBiAEayIFQf//D0sNACAPIAQgE2ogEhAdIgRBA0kNACAYIAQ2AgQgGCAFQQJqNgIAIAQgDU0EQEEBIQsgBCIJIA9qIBJHDQELQQEhCyAAIAZBAWo2AhgMBAsgFCAGNgIAAkAgCCAOSQ0AIAZBAmohFEF/IB10QX9zIQ1BACEGQQAhDANAIA8gBiAMIAYgDEkbIgRqIAggE2oiHyAEaiASEB0gBGoiBCAJSwRAIBggC0EDdGoiCSAENgIEIAkgFCAIazYCACAEIAhqIAcgBCAHIAhrSxshByALQQFqIQsgBEGAIEsNAiAEIgkgD2ogEkYNAgsgFyAIIBBxQQN0aiEFAkACQCAEIB9qLQAAIAQgD2otAABJBEAgFiAINgIAIAggFUsNASARQUBrIRYMBAsgCiAINgIAIAggFUsEQCAFIQogBCEMDAILIBFBQGshCgwDCyAEIQYgBUEEaiIWIQULIA1FDQEgDUF/aiENIAUoAgAiCCAOTw0ACwsgCkEANgIAIBZBADYCACAAIAdBeGo2AhgMAwtBACELQQAgDyAAKAIEIhVrIgZBfyAAKAJ4QX9qdEF/cyITayIEIAQgBksbIQ4gACgCICAPIAAoAnxBBBAeQQJ0aiIMKAIAIQggACgCECAAKAIUIAYgACgCdBAnIgRBASAEGyEQQQNBBCAaGyEUIAAoAigiHyAGIBNxQQN0aiIKQQRqIRYgACgCiAEiBEH/HyAEQf8fSRshFyAPQQRqIQ0gBkEJaiEHIAYgACgCDGshGyAAKAKAASEdICEhCSAcIQQDQAJAAn8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiBUF/aiAbTw0AIA9BBBAfIA8gBWtBBBAfRw0AIA0gDSAFayASEB1BBGoiBSAJTQ0AIBggC0EDdGoiCSAFNgIEIAkgBCAcazYCACALQQFqIQsgBSAXSw0EIAUiCSAPaiASRg0ECyAEQQFqIgQgFEkNAAsgDCAGNgIAAkAgCCAQSQ0AIAZBAmohFEF/IB10QX9zIQ1BACEGQQAhDANAIA8gBiAMIAYgDEkbIgRqIAggFWoiFyAEaiASEB0gBGoiBCAJSwRAIBggC0EDdGoiCSAENgIEIAkgFCAIazYCACAEIAhqIAcgBCAHIAhrSxshByALQQFqIQsgBEGAIEsNAiAEIgkgD2ogEkYNAgsgHyAIIBNxQQN0aiEFAkACQCAEIBdqLQAAIAQgD2otAABJBEAgCiAINgIAIAggDksNASARQUBrIQoMBAsgFiAINgIAIAggDksEQCAFIRYgBCEMDAILIBFBQGshFgwDCyAEIQYgBUEEaiIKIQULIA1FDQEgDUF/aiENIAUoAgAiCCAQTw0ACwsgFkEANgIAIApBADYCACAAIAdBeGo2AhgMAgtBACELQQAgDyAAKAIEIhVrIgZBfyAAKAJ4QX9qdEF/cyITayIEIAQgBksbIQ4gACgCICAPIAAoAnxBBRAeQQJ0aiIMKAIAIQggACgCECAAKAIUIAYgACgCdBAnIgRBASAEGyEQQQNBBCAaGyEUIAAoAigiHyAGIBNxQQN0aiIKQQRqIRYgACgCiAEiBEH/HyAEQf8fSRshFyAPQQRqIQ0gBkEJaiEHIAYgACgCDGshGyAAKAKAASEdICEhCSAcIQQDQAJAAn8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiBUF/aiAbTw0AIA9BBBAfIA8gBWtBBBAfRw0AIA0gDSAFayASEB1BBGoiBSAJTQ0AIBggC0EDdGoiCSAFNgIEIAkgBCAcazYCACALQQFqIQsgBSAXSw0DIAUiCSAPaiASRg0DCyAEQQFqIgQgFEkNAAsgDCAGNgIAAkAgCCAQSQ0AIAZBAmohFEF/IB10QX9zIQ1BACEGQQAhDANAIA8gBiAMIAYgDEkbIgRqIAggFWoiFyAEaiASEB0gBGoiBCAJSwRAIBggC0EDdGoiCSAENgIEIAkgFCAIazYCACAEIAhqIAcgBCAHIAhrSxshByALQQFqIQsgBEGAIEsNAiAEIgkgD2ogEkYNAgsgHyAIIBNxQQN0aiEFAkACQCAEIBdqLQAAIAQgD2otAABJBEAgCiAINgIAIAggDksNASARQUBrIQoMBAsgFiAINgIAIAggDksEQCAFIRYgBCEMDAILIBFBQGshFgwDCyAEIQYgBUEEaiIKIQULIA1FDQEgDUF/aiENIAUoAgAiCCAQTw0ACwsgFkEANgIAIApBADYCACAAIAdBeGo2AhgMAQtBACELQQAgDyAAKAIEIhVrIgZBfyAAKAJ4QX9qdEF/cyITayIEIAQgBksbIQ4gACgCICAPIAAoAnxBBhAeQQJ0aiIMKAIAIQggACgCECAAKAIUIAYgACgCdBAnIgRBASAEGyEQQQNBBCAaGyEUIAAoAigiHyAGIBNxQQN0aiIKQQRqIRYgACgCiAEiBEH/HyAEQf8fSRshFyAPQQRqIQ0gBkEJaiEHIAYgACgCDGshGyAAKAKAASEdICEhCSAcIQQDQAJAAn8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiBUF/aiAbTw0AIA9BBBAfIA8gBWtBBBAfRw0AIA0gDSAFayASEB1BBGoiBSAJTQ0AIBggC0EDdGoiCSAFNgIEIAkgBCAcazYCACALQQFqIQsgBSAXSw0CIAUiCSAPaiASRg0CCyAEQQFqIgQgFEkNAAsgDCAGNgIAAkAgCCAQSQ0AIAZBAmohFEF/IB10QX9zIQ1BACEGQQAhDANAIA8gBiAMIAYgDEkbIgRqIAggFWoiFyAEaiASEB0gBGoiBCAJSwRAIBggC0EDdGoiCSAENgIEIAkgFCAIazYCACAEIAhqIAcgBCAHIAhrSxshByALQQFqIQsgBEGAIEsNAiAEIgkgD2ogEkYNAgsgHyAIIBNxQQN0aiEFAkACQCAEIBdqLQAAIAQgD2otAABJBEAgCiAINgIAIAggDksNASARQUBrIQoMBAsgFiAINgIAIAggDksEQCAFIRYgBCEMDAILIBFBQGshFgwDCyAEIQYgBUEEaiIKIQULIA1FDQEgDUF/aiENIAUoAgAiCCAQTw0ACwsgFkEANgIAIApBADYCACAAIAdBeGo2AhgLIAtFDQAgGSACKAIANgIQIBkgAigCBDYCFCACKAIIIQQgGSAaNgIMIBlBADYCCCAZIAQ2AhggGSADIBogIkECEFgiCTYCACAYIAtBf2pBA3RqIgQoAgQiBSAqSwRAIAQoAgAhDQwDC0EBIQRBACAiQQIQLSEHA0AgGSAEQRxsakGAgICABDYCACAEQQFqIgQgKEcNAAsgByAJaiENQQAhByAoIQUDQCAYIAdBA3RqIgQoAgQhCSARQUBrIAIgBCgCACIKIBwQPyAFIAlNBEAgCkEBahAkIgZBCHRBgCBqIQwDQCAFQX1qIQQCfyAAKAJkQQFGBEAgBBArIAxqDAELIAAoAmAgACgCOCAGQQJ0aigCABArayAAKAJcaiAEEDxBAnQiBEGQpAFqKAIAIAZqQQh0aiAAKAI0IARqKAIAECtrQTNqCyEIIBkgBUEcbGoiBCAaNgIMIAQgCjYCBCAEIAU2AgggBCAIIA1qNgIAIAQgESkDQDcCECAEIBEoAkg2AhggBUEBaiIFIAlNDQALCyAHQQFqIgcgC0cNAAtBASEJAkAgBUF/aiIERQRAQQAhBAwBCwNAQQEhCCAZIAlBf2pBHGxqIgUoAghFBEAgBSgCDEEBaiEICyAJIA9qIg5Bf2pBASAiQQIQUiAFKAIAaiAIICJBAhAtaiAIQX9qICJBAhAtayIHIBkgCUEcbGoiFCgCACIWTARAIBQgCDYCDCAUQgA3AgQgFCAHNgIAIBQgBSgCGDYCGCAUIAUpAhA3AhAgByEWCwJAIA4gKUsNACAEIAlGBEAgCSEEDAMLQQAhGiAUKAIIIgdFBEAgFCgCDCEaC0EAICJBAhAtIS0gACgCBCIFIAAoAhgiCGogDksNACAAKAKEASELIAggDiAFayIKSQRAA0AgACAFIAhqIBIgC0EAEEEgCGoiCCAKSQ0ACwsgB0EARyEcIBRBEGohHyAAIAo2AhgCQAJAAkACQAJAIAtBfWoOBQABAgMDAQtBACEQQQAgDiAAKAIEIhdrIgpBfyAAKAJ4QX9qdEF/cyIdayIFIAUgCksbISMgACgCICAOIAAoAnxBAxAeQQJ0aiIgKAIAIQwgACgCECAAKAIUIAogACgCdBAnIgVBASAFGyEbQQRBAyAHGyEkIAAoAigiJSAKIB1xQQN0aiIFQQRqIRMgACgCiAEiB0H/HyAHQf8fSRshBiAOQQNqIR4gCkEJaiEVIAogACgCDGshJiAAKAKAASEnICEhByAcIQgDQAJAAn8gCEEDRgRAIB8oAgBBf2oMAQsgFCAIQQJ0aigCEAsiDUF/aiAmTw0AIA5BAxAfIA4gDWtBAxAfRw0AIB4gHiANayASEB1BA2oiCyAHTQ0AIBggEEEDdGoiByALNgIEIAcgCCAcazYCACAQQQFqIRAgCyAGSw0FIAsiByAOaiASRg0FCyAIQQFqIgggJEkNAAsCQCAHQQJLDQBBAiEHIBcgACgCHCAAKAIkIBFB3ABqIA4QQCILIBtJDQAgCiALayIIQf//D0sNACAOIAsgF2ogEhAdIgtBA0kNACAYIAs2AgQgGCAIQQJqNgIAIAsgBk0EQEEBIRAgCyIHIA5qIBJHDQELQQEhECAAIApBAWo2AhgMBAsgICAKNgIAAkAgDCAbSQ0AIApBAmohHkF/ICd0QX9zIQhBACELQQAhCgNAIA4gCyAKIAsgCkkbIgZqIAwgF2oiICAGaiASEB0gBmoiBiAHSwRAIBggEEEDdGoiByAGNgIEIAcgHiAMazYCACAGIAxqIBUgBiAVIAxrSxshFSAQQQFqIRAgBkGAIEsNAiAGIgcgDmogEkYNAgsgJSAMIB1xQQN0aiENAkACQCAGICBqLQAAIAYgDmotAABJBEAgBSAMNgIAIAwgI0sNASARQUBrIQUMBAsgEyAMNgIAIAwgI0sEQCANIRMgBiEKDAILIBFBQGshEwwDCyAGIQsgDUEEaiIFIQ0LIAhFDQEgCEF/aiEIIA0oAgAiDCAbTw0ACwsgE0EANgIAIAVBADYCACAAIBVBeGo2AhgMAwtBACEQQQAgDiAAKAIEIiNrIgpBfyAAKAJ4QX9qdEF/cyIXayIFIAUgCksbIRsgACgCICAOIAAoAnxBBBAeQQJ0aiIeKAIAIQwgACgCECAAKAIUIAogACgCdBAnIgVBASAFGyEdQQRBAyAHGyEgIAAoAigiJCAKIBdxQQN0aiITQQRqIQUgACgCiAEiB0H/HyAHQf8fSRshJSAOQQRqIQYgCkEJaiEVIAogACgCDGshJiAAKAKAASEnICEhByAcIQgDQAJAAn8gCEEDRgRAIB8oAgBBf2oMAQsgFCAIQQJ0aigCEAsiDUF/aiAmTw0AIA5BBBAfIA4gDWtBBBAfRw0AIAYgBiANayASEB1BBGoiCyAHTQ0AIBggEEEDdGoiByALNgIEIAcgCCAcazYCACAQQQFqIRAgCyAlSw0EIAsiByAOaiASRg0ECyAIQQFqIgggIEkNAAsgHiAKNgIAAkAgDCAdSQ0AIApBAmohHkF/ICd0QX9zIQhBACELQQAhCgNAIA4gCyAKIAsgCkkbIgZqIAwgI2oiICAGaiASEB0gBmoiBiAHSwRAIBggEEEDdGoiByAGNgIEIAcgHiAMazYCACAGIAxqIBUgBiAVIAxrSxshFSAQQQFqIRAgBkGAIEsNAiAGIgcgDmogEkYNAgsgJCAMIBdxQQN0aiENAkACQCAGICBqLQAAIAYgDmotAABJBEAgEyAMNgIAIAwgG0sNASARQUBrIRMMBAsgBSAMNgIAIAwgG0sEQCANIQUgBiEKDAILIBFBQGshBQwDCyAGIQsgDUEEaiITIQ0LIAhFDQEgCEF/aiEIIA0oAgAiDCAdTw0ACwsgBUEANgIAIBNBADYCACAAIBVBeGo2AhgMAgtBACEQQQAgDiAAKAIEIiNrIgpBfyAAKAJ4QX9qdEF/cyIXayIFIAUgCksbIRsgACgCICAOIAAoAnxBBRAeQQJ0aiIeKAIAIQwgACgCECAAKAIUIAogACgCdBAnIgVBASAFGyEdQQRBAyAHGyEgIAAoAigiJCAKIBdxQQN0aiITQQRqIQUgACgCiAEiB0H/HyAHQf8fSRshJSAOQQRqIQYgCkEJaiEVIAogACgCDGshJiAAKAKAASEnICEhByAcIQgDQAJAAn8gCEEDRgRAIB8oAgBBf2oMAQsgFCAIQQJ0aigCEAsiDUF/aiAmTw0AIA5BBBAfIA4gDWtBBBAfRw0AIAYgBiANayASEB1BBGoiCyAHTQ0AIBggEEEDdGoiByALNgIEIAcgCCAcazYCACAQQQFqIRAgCyAlSw0DIAsiByAOaiASRg0DCyAIQQFqIgggIEkNAAsgHiAKNgIAAkAgDCAdSQ0AIApBAmohHkF/ICd0QX9zIQhBACELQQAhCgNAIA4gCyAKIAsgCkkbIgZqIAwgI2oiICAGaiASEB0gBmoiBiAHSwRAIBggEEEDdGoiByAGNgIEIAcgHiAMazYCACAGIAxqIBUgBiAVIAxrSxshFSAQQQFqIRAgBkGAIEsNAiAGIgcgDmogEkYNAgsgJCAMIBdxQQN0aiENAkACQCAGICBqLQAAIAYgDmotAABJBEAgEyAMNgIAIAwgG0sNASARQUBrIRMMBAsgBSAMNgIAIAwgG0sEQCANIQUgBiEKDAILIBFBQGshBQwDCyAGIQsgDUEEaiITIQ0LIAhFDQEgCEF/aiEIIA0oAgAiDCAdTw0ACwsgBUEANgIAIBNBADYCACAAIBVBeGo2AhgMAQtBACEQQQAgDiAAKAIEIiNrIgpBfyAAKAJ4QX9qdEF/cyIXayIFIAUgCksbIRsgACgCICAOIAAoAnxBBhAeQQJ0aiIeKAIAIQwgACgCECAAKAIUIAogACgCdBAnIgVBASAFGyEdQQRBAyAHGyEgIAAoAigiJCAKIBdxQQN0aiITQQRqIQUgACgCiAEiB0H/HyAHQf8fSRshJSAOQQRqIQYgCkEJaiEVIAogACgCDGshJiAAKAKAASEnICEhByAcIQgDQAJAAn8gCEEDRgRAIB8oAgBBf2oMAQsgFCAIQQJ0aigCEAsiDUF/aiAmTw0AIA5BBBAfIA4gDWtBBBAfRw0AIAYgBiANayASEB1BBGoiCyAHTQ0AIBggEEEDdGoiByALNgIEIAcgCCAcazYCACAQQQFqIRAgCyAlSw0CIAsiByAOaiASRg0CCyAIQQFqIgggIEkNAAsgHiAKNgIAAkAgDCAdSQ0AIApBAmohHkF/ICd0QX9zIQhBACELQQAhCgNAIA4gCyAKIAsgCkkbIgZqIAwgI2oiICAGaiASEB0gBmoiBiAHSwRAIBggEEEDdGoiByAGNgIEIAcgHiAMazYCACAGIAxqIBUgBiAVIAxrSxshFSAQQQFqIRAgBkGAIEsNAiAGIgcgDmogEkYNAgsgJCAMIBdxQQN0aiENAkACQCAGICBqLQAAIAYgDmotAABJBEAgEyAMNgIAIAwgG0sNASARQUBrIRMMBAsgBSAMNgIAIAwgG0sEQCANIQUgBiEKDAILIBFBQGshBQwDCyAGIQsgDUEEaiITIQ0LIAhFDQEgCEF/aiEIIA0oAgAiDCAdTw0ACwsgBUEANgIAIBNBADYCACAAIBVBeGo2AhgLIBBFDQAgGCAQQX9qQQN0aiIHKAIEIgUgKksgBSAJakGAIE9yDQQgFiAtaiEMQQAhFgNAIBFBQGsgHyAYIBZBA3RqIgcoAgAiBSAcED8gKCEGAn8gFgRAIAdBfGooAgBBAWohBgsgBygCBCIIIAZPCwRAIAVBAWoQJCILQQh0QYAgaiETA0AgCEF9aiEKIAggCWohBwJ/IAAoAmRBAUYEQCAKECsgE2oMAQsgACgCYCAAKAI4IAtBAnRqKAIAECtrIAAoAlxqIAoQPEECdCIKQZCkAWooAgAgC2pBCHRqIAAoAjQgCmooAgAQK2tBM2oLIAxqIQoCQAJAIAcgBE0EQCAKIBkgB0EcbGooAgBIDQEMAgsDQCAZIARBAWoiBEEcbGpBgICAgAQ2AgAgBCAHSQ0ACwsgGSAHQRxsaiIHIBo2AgwgByAFNgIEIAcgCDYCCCAHIAo2AgAgByARKQNANwIQIAcgESgCSDYCGAsgCEF/aiIIIAZPDQALCyAWQQFqIhYgEEcNAAsLIAlBAWoiCSAETQ0ACwsgGSAEQRxsaiIJKAIMIRogCSgCBCENIAkoAgAhLCAJKAIIIQUgESAJKAIYNgJYIBEgCSkCEDcDUCARIAkpAgg3AyggESAJKQIQNwMwIBEgCSgCGDYCOCARIAkpAgA3AyBBACAEIBFBIGoQPmsiCSAJIARLGyEEDAMLIA9BAWohDwwHCyAHKAIAIQ1BACEEIAkgFCgCCAR/IAQFIBQoAgwLayIEQYAgTQ0BCyAZIBo2AiggGSAFNgIkIBkgDTYCICAZICw2AhwgGSARKAJYNgI0IBkgESkDUDcCLAwBCyAZIARBAWoiC0EcbGoiCSAaNgIMIAkgBTYCCCAJIA02AgQgCSAsNgIAIAkgESkDUDcCECAJIBEoAlg2AhggCyEaIAQNAQtBASEaQQEhCwwBCwNAIBEgGSAEQRxsaiIJIgpBGGooAgA2AhggESAJKQIQNwMQIBEgCSkCCDcDCCARIAkpAgA3AwAgERA+IQUgGSAaQX9qIhpBHGxqIgcgCigCGDYCGCAHIAkpAhA3AhAgByAJKQIINwIIIAcgCSkCADcCACAEIAVLIQlBACAEIAVrIgcgByAESxshBCAJDQALIBogC0sNAQsDQCAZIBpBHGxqIgQoAgwhBwJ/IAMgB2ogBCgCCCIGRQ0AGgJAAkAgBCgCBCIKQQNPBEAgAiACKQIANwIEIApBfmohBAwBCwJAAkACQAJAIAogB0VqIgkOBAUBAQABCyACKAIAQX9qIQQMAQsgAiAJQQJ0aigCACEEIAlBAkkNAQsgAiACKAIENgIICyACIAIoAgA2AgQLIAIgBDYCAAsgIiAHIAMgCiAGEFcgBkF9aiEIIAEoAgwhBAJAAkAgAyAHaiIJICtNBEAgBCADEBwgASgCDCEEIAdBEE0EQCABIAQgB2o2AgwMAwsgBEEQaiADQRBqIgUQHCAEQSBqIANBIGoQHCAHQTFIDQEgBCAHaiENIARBMGohBANAIAQgBUEgaiIJEBwgBEEQaiAFQTBqEBwgCSEFIARBIGoiBCANSQ0ACwwBCyAEIAMgCSArECILIAEgASgCDCAHajYCDCAHQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyABKAIEIgQgCkEBajYCACAEIAc7AQQgCEGAgARPBEAgAUECNgIkIAEgBCABKAIAa0EDdTYCKAsgBCAIOwEGIAEgBEEIajYCBCAGIAdqIANqIgMLIQ8gGkEBaiIaIAtNDQALCyAiQQIQUQsgDyApSQ0ACwsgEUHgAGokACASIANrC/Y9ASl/IwBB4ABrIhEkACAAKAKEASEHIAAoAgQhISAAKAKIASEJIAAoAgwhBiARIAAoAhg2AlwgACgCPCEYIABBQGsoAgAhGSAAQSxqIiIgAyAEQQIQWSADIAYgIWogA0ZqIg8gAyAEaiISQXhqIilJBEAgCUH/HyAJQf8fSRshKiASQWBqIStBA0EEIAdBA0YbIihBf2ohIQNAAkACQAJAAkACQAJAAkACQAJAIAAoAgQiCSAAKAIYIgRqIA9LDQAgDyADayEaIAAoAoQBIQcgBCAPIAlrIgZJBEADQCAAIAQgCWogEiAHQQAQQSAEaiIEIAZJDQALCyAaRSEcIAAgBjYCGAJAAkACQAJAAkAgB0F9ag4FAAECAwMBC0EAIQtBACAPIAAoAgQiE2siBUF/IAAoAnhBf2p0QX9zIhBrIgQgBCAFSxshFSAAKAIgIA8gACgCfEEDEB5BAnRqIhQoAgAhCCAAKAIQIAAoAhQgBSAAKAJ0ECciBEEBIAQbIQ5BA0EEIBobIR8gACgCKCIXIAUgEHFBA3RqIhZBBGohCiAAKAKIASIEQf8fIARB/x9JGyENIA9BA2ohDCAFQQlqIQcgBSAAKAIMayEbIAAoAoABIR0gISEJIBwhBANAAkACfyAEQQNGBEAgAigCAEF/agwBCyACIARBAnRqKAIACyIGQX9qIBtPDQAgD0EDEB8gDyAGa0EDEB9HDQAgDCAMIAZrIBIQHUEDaiIGIAlNDQAgGCALQQN0aiIJIAY2AgQgCSAEIBxrNgIAIAtBAWohCyAGIA1LDQUgBiIJIA9qIBJGDQULIARBAWoiBCAfSQ0ACwJAIAlBAksNAEECIQkgEyAAKAIcIAAoAiQgEUHcAGogDxBAIgQgDkkNACAFIARrIgZB//8PSw0AIA8gBCATaiASEB0iBEEDSQ0AIBggBDYCBCAYIAZBAmo2AgAgBCANTQRAQQEhCyAEIgkgD2ogEkcNAQtBASELIAAgBUEBajYCGAwECyAUIAU2AgACQCAIIA5JDQAgBUECaiEUQX8gHXRBf3MhDUEAIQVBACEMA0AgDyAFIAwgBSAMSRsiBGogCCATaiIfIARqIBIQHSAEaiIEIAlLBEAgGCALQQN0aiIJIAQ2AgQgCSAUIAhrNgIAIAQgCGogByAEIAcgCGtLGyEHIAtBAWohCyAEQYAgSw0CIAQiCSAPaiASRg0CCyAXIAggEHFBA3RqIQYCQAJAIAQgH2otAAAgBCAPai0AAEkEQCAWIAg2AgAgCCAVSw0BIBFBQGshFgwECyAKIAg2AgAgCCAVSwRAIAYhCiAEIQwMAgsgEUFAayEKDAMLIAQhBSAGQQRqIhYhBgsgDUUNASANQX9qIQ0gBigCACIIIA5PDQALCyAKQQA2AgAgFkEANgIAIAAgB0F4ajYCGAwDC0EAIQtBACAPIAAoAgQiFWsiBUF/IAAoAnhBf2p0QX9zIhNrIgQgBCAFSxshDiAAKAIgIA8gACgCfEEEEB5BAnRqIgwoAgAhCCAAKAIQIAAoAhQgBSAAKAJ0ECciBEEBIAQbIRBBA0EEIBobIRQgACgCKCIfIAUgE3FBA3RqIhZBBGohCiAAKAKIASIEQf8fIARB/x9JGyEXIA9BBGohDSAFQQlqIQcgBSAAKAIMayEbIAAoAoABIR0gISEJIBwhBANAAkACfyAEQQNGBEAgAigCAEF/agwBCyACIARBAnRqKAIACyIGQX9qIBtPDQAgD0EEEB8gDyAGa0EEEB9HDQAgDSANIAZrIBIQHUEEaiIGIAlNDQAgGCALQQN0aiIJIAY2AgQgCSAEIBxrNgIAIAtBAWohCyAGIBdLDQQgBiIJIA9qIBJGDQQLIARBAWoiBCAUSQ0ACyAMIAU2AgACQCAIIBBJDQAgBUECaiEUQX8gHXRBf3MhDUEAIQVBACEMA0AgDyAFIAwgBSAMSRsiBGogCCAVaiIXIARqIBIQHSAEaiIEIAlLBEAgGCALQQN0aiIJIAQ2AgQgCSAUIAhrNgIAIAQgCGogByAEIAcgCGtLGyEHIAtBAWohCyAEQYAgSw0CIAQiCSAPaiASRg0CCyAfIAggE3FBA3RqIQYCQAJAIAQgF2otAAAgBCAPai0AAEkEQCAWIAg2AgAgCCAOSw0BIBFBQGshFgwECyAKIAg2AgAgCCAOSwRAIAYhCiAEIQwMAgsgEUFAayEKDAMLIAQhBSAGQQRqIhYhBgsgDUUNASANQX9qIQ0gBigCACIIIBBPDQALCyAKQQA2AgAgFkEANgIAIAAgB0F4ajYCGAwCC0EAIQtBACAPIAAoAgQiFWsiBUF/IAAoAnhBf2p0QX9zIhNrIgQgBCAFSxshDiAAKAIgIA8gACgCfEEFEB5BAnRqIgwoAgAhCCAAKAIQIAAoAhQgBSAAKAJ0ECciBEEBIAQbIRBBA0EEIBobIRQgACgCKCIfIAUgE3FBA3RqIgpBBGohFiAAKAKIASIEQf8fIARB/x9JGyEXIA9BBGohDSAFQQlqIQcgBSAAKAIMayEbIAAoAoABIR0gISEJIBwhBANAAkACfyAEQQNGBEAgAigCAEF/agwBCyACIARBAnRqKAIACyIGQX9qIBtPDQAgD0EEEB8gDyAGa0EEEB9HDQAgDSANIAZrIBIQHUEEaiIGIAlNDQAgGCALQQN0aiIJIAY2AgQgCSAEIBxrNgIAIAtBAWohCyAGIBdLDQMgBiIJIA9qIBJGDQMLIARBAWoiBCAUSQ0ACyAMIAU2AgACQCAIIBBJDQAgBUECaiEUQX8gHXRBf3MhDUEAIQVBACEMA0AgDyAFIAwgBSAMSRsiBGogCCAVaiIXIARqIBIQHSAEaiIEIAlLBEAgGCALQQN0aiIJIAQ2AgQgCSAUIAhrNgIAIAQgCGogByAEIAcgCGtLGyEHIAtBAWohCyAEQYAgSw0CIAQiCSAPaiASRg0CCyAfIAggE3FBA3RqIQYCQAJAIAQgF2otAAAgBCAPai0AAEkEQCAKIAg2AgAgCCAOSw0BIBFBQGshCgwECyAWIAg2AgAgCCAOSwRAIAYhFiAEIQwMAgsgEUFAayEWDAMLIAQhBSAGQQRqIgohBgsgDUUNASANQX9qIQ0gBigCACIIIBBPDQALCyAWQQA2AgAgCkEANgIAIAAgB0F4ajYCGAwBC0EAIQtBACAPIAAoAgQiFWsiBUF/IAAoAnhBf2p0QX9zIhNrIgQgBCAFSxshDiAAKAIgIA8gACgCfEEGEB5BAnRqIgwoAgAhCCAAKAIQIAAoAhQgBSAAKAJ0ECciBEEBIAQbIRBBA0EEIBobIRQgACgCKCIfIAUgE3FBA3RqIgpBBGohFiAAKAKIASIEQf8fIARB/x9JGyEXIA9BBGohDSAFQQlqIQcgBSAAKAIMayEbIAAoAoABIR0gISEJIBwhBANAAkACfyAEQQNGBEAgAigCAEF/agwBCyACIARBAnRqKAIACyIGQX9qIBtPDQAgD0EEEB8gDyAGa0EEEB9HDQAgDSANIAZrIBIQHUEEaiIGIAlNDQAgGCALQQN0aiIJIAY2AgQgCSAEIBxrNgIAIAtBAWohCyAGIBdLDQIgBiIJIA9qIBJGDQILIARBAWoiBCAUSQ0ACyAMIAU2AgACQCAIIBBJDQAgBUECaiEUQX8gHXRBf3MhDUEAIQVBACEMA0AgDyAFIAwgBSAMSRsiBGogCCAVaiIXIARqIBIQHSAEaiIEIAlLBEAgGCALQQN0aiIJIAQ2AgQgCSAUIAhrNgIAIAQgCGogByAEIAcgCGtLGyEHIAtBAWohCyAEQYAgSw0CIAQiCSAPaiASRg0CCyAfIAggE3FBA3RqIQYCQAJAIAQgF2otAAAgBCAPai0AAEkEQCAKIAg2AgAgCCAOSw0BIBFBQGshCgwECyAWIAg2AgAgCCAOSwRAIAYhFiAEIQwMAgsgEUFAayEWDAMLIAQhBSAGQQRqIgohBgsgDUUNASANQX9qIQ0gBigCACIIIBBPDQALCyAWQQA2AgAgCkEANgIAIAAgB0F4ajYCGAsgC0UNACAZIAIoAgA2AhAgGSACKAIENgIUIAIoAgghBCAZIBo2AgwgGUEANgIIIBkgBDYCGCAZIAMgGiAiQQIQWCIJNgIAIBggC0F/akEDdGoiBCgCBCIGICpLBEAgBCgCACENDAMLQQEhBEEAICJBAhAtIQcDQCAZIARBHGxqQYCAgIAENgIAIARBAWoiBCAoRw0ACyAHIAlqIQ1BACEHICghBgNAIBggB0EDdGoiBCgCBCEJIBFBQGsgAiAEKAIAIgogHBA/IAYgCU0EQCAKQQFqECQiBUEIdEGAIGohDANAIAZBfWohBAJ/IAAoAmRBAUYEQCAEECsgDGoMAQsgACgCYCAAKAI4IAVBAnRqKAIAECtrIAAoAlxqIAQQPEECdCIEQZCkAWooAgAgBWpBCHRqIAAoAjQgBGooAgAQK2tBM2oLIQggGSAGQRxsaiIEIBo2AgwgBCAKNgIEIAQgBjYCCCAEIAggDWo2AgAgBCARKQNANwIQIAQgESgCSDYCGCAGQQFqIgYgCU0NAAsLIAdBAWoiByALRw0AC0EBIQkCQCAGQX9qIgRFBEBBACEEDAELA0BBASEIIBkgCUF/akEcbGoiBigCCEUEQCAGKAIMQQFqIQgLIAkgD2oiDkF/akEBICJBAhBSIAYoAgBqIAggIkECEC1qIAhBf2ogIkECEC1rIgcgGSAJQRxsaiIUKAIAIhZMBEAgFCAINgIMIBRCADcCBCAUIAc2AgAgFCAGKAIYNgIYIBQgBikCEDcCECAHIRYLAkAgDiApSw0AIAQgCUYEQCAJIQQMAwtBACEaIBQoAggiB0UEQCAUKAIMIRoLQQAgIkECEC0hLSAAKAIEIgYgACgCGCIIaiAOSw0AIAAoAoQBIQsgCCAOIAZrIgpJBEADQCAAIAYgCGogEiALQQAQQSAIaiIIIApJDQALCyAHQQBHIRwgFEEQaiEfIAAgCjYCGAJAAkACQAJAAkAgC0F9ag4FAAECAwMBC0EAIRBBACAOIAAoAgQiF2siCkF/IAAoAnhBf2p0QX9zIh1rIgYgBiAKSxshIyAAKAIgIA4gACgCfEEDEB5BAnRqIiAoAgAhDCAAKAIQIAAoAhQgCiAAKAJ0ECciBkEBIAYbIRtBBEEDIAcbISQgACgCKCIlIAogHXFBA3RqIgZBBGohEyAAKAKIASIHQf8fIAdB/x9JGyEFIA5BA2ohHiAKQQlqIRUgCiAAKAIMayEmIAAoAoABIScgISEHIBwhCANAAkACfyAIQQNGBEAgHygCAEF/agwBCyAUIAhBAnRqKAIQCyINQX9qICZPDQAgDkEDEB8gDiANa0EDEB9HDQAgHiAeIA1rIBIQHUEDaiILIAdNDQAgGCAQQQN0aiIHIAs2AgQgByAIIBxrNgIAIBBBAWohECALIAVLDQUgCyIHIA5qIBJGDQULIAhBAWoiCCAkSQ0ACwJAIAdBAksNAEECIQcgFyAAKAIcIAAoAiQgEUHcAGogDhBAIgsgG0kNACAKIAtrIghB//8PSw0AIA4gCyAXaiASEB0iC0EDSQ0AIBggCzYCBCAYIAhBAmo2AgAgCyAFTQRAQQEhECALIgcgDmogEkcNAQtBASEQIAAgCkEBajYCGAwECyAgIAo2AgACQCAMIBtJDQAgCkECaiEeQX8gJ3RBf3MhCEEAIQtBACEKA0AgDiALIAogCyAKSRsiBWogDCAXaiIgIAVqIBIQHSAFaiIFIAdLBEAgGCAQQQN0aiIHIAU2AgQgByAeIAxrNgIAIAUgDGogFSAFIBUgDGtLGyEVIBBBAWohECAFQYAgSw0CIAUiByAOaiASRg0CCyAlIAwgHXFBA3RqIQ0CQAJAIAUgIGotAAAgBSAOai0AAEkEQCAGIAw2AgAgDCAjSw0BIBFBQGshBgwECyATIAw2AgAgDCAjSwRAIA0hEyAFIQoMAgsgEUFAayETDAMLIAUhCyANQQRqIgYhDQsgCEUNASAIQX9qIQggDSgCACIMIBtPDQALCyATQQA2AgAgBkEANgIAIAAgFUF4ajYCGAwDC0EAIRBBACAOIAAoAgQiI2siCkF/IAAoAnhBf2p0QX9zIhdrIgYgBiAKSxshGyAAKAIgIA4gACgCfEEEEB5BAnRqIh4oAgAhDCAAKAIQIAAoAhQgCiAAKAJ0ECciBkEBIAYbIR1BBEEDIAcbISAgACgCKCIkIAogF3FBA3RqIhNBBGohBiAAKAKIASIHQf8fIAdB/x9JGyElIA5BBGohBSAKQQlqIRUgCiAAKAIMayEmIAAoAoABIScgISEHIBwhCANAAkACfyAIQQNGBEAgHygCAEF/agwBCyAUIAhBAnRqKAIQCyINQX9qICZPDQAgDkEEEB8gDiANa0EEEB9HDQAgBSAFIA1rIBIQHUEEaiILIAdNDQAgGCAQQQN0aiIHIAs2AgQgByAIIBxrNgIAIBBBAWohECALICVLDQQgCyIHIA5qIBJGDQQLIAhBAWoiCCAgSQ0ACyAeIAo2AgACQCAMIB1JDQAgCkECaiEeQX8gJ3RBf3MhCEEAIQtBACEKA0AgDiALIAogCyAKSRsiBWogDCAjaiIgIAVqIBIQHSAFaiIFIAdLBEAgGCAQQQN0aiIHIAU2AgQgByAeIAxrNgIAIAUgDGogFSAFIBUgDGtLGyEVIBBBAWohECAFQYAgSw0CIAUiByAOaiASRg0CCyAkIAwgF3FBA3RqIQ0CQAJAIAUgIGotAAAgBSAOai0AAEkEQCATIAw2AgAgDCAbSw0BIBFBQGshEwwECyAGIAw2AgAgDCAbSwRAIA0hBiAFIQoMAgsgEUFAayEGDAMLIAUhCyANQQRqIhMhDQsgCEUNASAIQX9qIQggDSgCACIMIB1PDQALCyAGQQA2AgAgE0EANgIAIAAgFUF4ajYCGAwCC0EAIRBBACAOIAAoAgQiI2siCkF/IAAoAnhBf2p0QX9zIhdrIgYgBiAKSxshGyAAKAIgIA4gACgCfEEFEB5BAnRqIh4oAgAhDCAAKAIQIAAoAhQgCiAAKAJ0ECciBkEBIAYbIR1BBEEDIAcbISAgACgCKCIkIAogF3FBA3RqIhNBBGohBiAAKAKIASIHQf8fIAdB/x9JGyElIA5BBGohBSAKQQlqIRUgCiAAKAIMayEmIAAoAoABIScgISEHIBwhCANAAkACfyAIQQNGBEAgHygCAEF/agwBCyAUIAhBAnRqKAIQCyINQX9qICZPDQAgDkEEEB8gDiANa0EEEB9HDQAgBSAFIA1rIBIQHUEEaiILIAdNDQAgGCAQQQN0aiIHIAs2AgQgByAIIBxrNgIAIBBBAWohECALICVLDQMgCyIHIA5qIBJGDQMLIAhBAWoiCCAgSQ0ACyAeIAo2AgACQCAMIB1JDQAgCkECaiEeQX8gJ3RBf3MhCEEAIQtBACEKA0AgDiALIAogCyAKSRsiBWogDCAjaiIgIAVqIBIQHSAFaiIFIAdLBEAgGCAQQQN0aiIHIAU2AgQgByAeIAxrNgIAIAUgDGogFSAFIBUgDGtLGyEVIBBBAWohECAFQYAgSw0CIAUiByAOaiASRg0CCyAkIAwgF3FBA3RqIQ0CQAJAIAUgIGotAAAgBSAOai0AAEkEQCATIAw2AgAgDCAbSw0BIBFBQGshEwwECyAGIAw2AgAgDCAbSwRAIA0hBiAFIQoMAgsgEUFAayEGDAMLIAUhCyANQQRqIhMhDQsgCEUNASAIQX9qIQggDSgCACIMIB1PDQALCyAGQQA2AgAgE0EANgIAIAAgFUF4ajYCGAwBC0EAIRBBACAOIAAoAgQiI2siCkF/IAAoAnhBf2p0QX9zIhdrIgYgBiAKSxshGyAAKAIgIA4gACgCfEEGEB5BAnRqIh4oAgAhDCAAKAIQIAAoAhQgCiAAKAJ0ECciBkEBIAYbIR1BBEEDIAcbISAgACgCKCIkIAogF3FBA3RqIhNBBGohBiAAKAKIASIHQf8fIAdB/x9JGyElIA5BBGohBSAKQQlqIRUgCiAAKAIMayEmIAAoAoABIScgISEHIBwhCANAAkACfyAIQQNGBEAgHygCAEF/agwBCyAUIAhBAnRqKAIQCyINQX9qICZPDQAgDkEEEB8gDiANa0EEEB9HDQAgBSAFIA1rIBIQHUEEaiILIAdNDQAgGCAQQQN0aiIHIAs2AgQgByAIIBxrNgIAIBBBAWohECALICVLDQIgCyIHIA5qIBJGDQILIAhBAWoiCCAgSQ0ACyAeIAo2AgACQCAMIB1JDQAgCkECaiEeQX8gJ3RBf3MhCEEAIQtBACEKA0AgDiALIAogCyAKSRsiBWogDCAjaiIgIAVqIBIQHSAFaiIFIAdLBEAgGCAQQQN0aiIHIAU2AgQgByAeIAxrNgIAIAUgDGogFSAFIBUgDGtLGyEVIBBBAWohECAFQYAgSw0CIAUiByAOaiASRg0CCyAkIAwgF3FBA3RqIQ0CQAJAIAUgIGotAAAgBSAOai0AAEkEQCATIAw2AgAgDCAbSw0BIBFBQGshEwwECyAGIAw2AgAgDCAbSwRAIA0hBiAFIQoMAgsgEUFAayEGDAMLIAUhCyANQQRqIhMhDQsgCEUNASAIQX9qIQggDSgCACIMIB1PDQALCyAGQQA2AgAgE0EANgIAIAAgFUF4ajYCGAsgEEUNACAYIBBBf2pBA3RqIgcoAgQiBiAqSyAGIAlqQYAgT3INBCAWIC1qIQxBACEWA0AgEUFAayAfIBggFkEDdGoiBygCACIGIBwQPyAoIQUCfyAWBEAgB0F8aigCAEEBaiEFCyAHKAIEIgggBU8LBEAgBkEBahAkIgtBCHRBgCBqIRMDQCAIQX1qIQogCCAJaiEHAn8gACgCZEEBRgRAIAoQKyATagwBCyAAKAJgIAAoAjggC0ECdGooAgAQK2sgACgCXGogChA8QQJ0IgpBkKQBaigCACALakEIdGogACgCNCAKaigCABAra0EzagsgDGohCgJAAkAgByAETQRAIAogGSAHQRxsaigCAEgNAQwCCwNAIBkgBEEBaiIEQRxsakGAgICABDYCACAEIAdJDQALCyAZIAdBHGxqIgcgGjYCDCAHIAY2AgQgByAINgIIIAcgCjYCACAHIBEpA0A3AhAgByARKAJINgIYCyAIQX9qIgggBU8NAAsLIBZBAWoiFiAQRw0ACwsgCUEBaiIJIARNDQALCyAZIARBHGxqIgkoAgwhGiAJKAIEIQ0gCSgCACEsIAkoAgghBiARIAkoAhg2AlggESAJKQIQNwNQIBEgCSkCCDcDKCARIAkpAhA3AzAgESAJKAIYNgI4IBEgCSkCADcDIEEAIAQgEUEgahA+ayIJIAkgBEsbIQQMAwsgD0EBaiEPDAcLIAcoAgAhDUEAIQQgCSAUKAIIBH8gBAUgFCgCDAtrIgRBgCBNDQELIBkgGjYCKCAZIAY2AiQgGSANNgIgIBkgLDYCHCAZIBEoAlg2AjQgGSARKQNQNwIsDAELIBkgBEEBaiILQRxsaiIJIBo2AgwgCSAGNgIIIAkgDTYCBCAJICw2AgAgCSARKQNQNwIQIAkgESgCWDYCGCALIRogBA0BC0EBIRpBASELDAELA0AgESAZIARBHGxqIgkiCkEYaigCADYCGCARIAkpAhA3AxAgESAJKQIINwMIIBEgCSkCADcDACARED4hBiAZIBpBf2oiGkEcbGoiByAKKAIYNgIYIAcgCSkCEDcCECAHIAkpAgg3AgggByAJKQIANwIAIAQgBkshCUEAIAQgBmsiByAHIARLGyEEIAkNAAsgGiALSw0BCwNAIBkgGkEcbGoiBCgCDCEHAn8gAyAHaiAEKAIIIgVFDQAaAkACQCAEKAIEIgpBA08EQCACIAIpAgA3AgQgCkF+aiEEDAELAkACQAJAAkAgCiAHRWoiCQ4EBQEBAAELIAIoAgBBf2ohBAwBCyACIAlBAnRqKAIAIQQgCUECSQ0BCyACIAIoAgQ2AggLIAIgAigCADYCBAsgAiAENgIACyAiIAcgAyAKIAUQVyAFQX1qIQggASgCDCEEAkACQCADIAdqIgkgK00EQCAEIAMQHCABKAIMIQQgB0EQTQRAIAEgBCAHajYCDAwDCyAEQRBqIANBEGoiBhAcIARBIGogA0EgahAcIAdBMUgNASAEIAdqIQ0gBEEwaiEEA0AgBCAGQSBqIgkQHCAEQRBqIAZBMGoQHCAJIQYgBEEgaiIEIA1JDQALDAELIAQgAyAJICsQIgsgASABKAIMIAdqNgIMIAdBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiBCAKQQFqNgIAIAQgBzsBBCAIQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAg7AQYgASAEQQhqNgIEIAUgB2ogA2oiAwshDyAaQQFqIhogC00NAAsLICJBAhBRCyAPIClJDQALCyARQeAAaiQAIBIgA2sLcgECfyABKAI4BEAgAgRAIAAQKw8LIAAQLg8LIAAQgAFBAnQiAEGwpwFqKAIAQQh0IQQgASgCBCIBKAIAIQMCfyACBEAgAxArIQIgACABaigCABArDAELIAMQLiECIAAgAWooAgAQLgshASACIARqIAFrC2YBAX8jAEEwayIGJAAgBkEYaiABEJYBIAZBCGogAhCWASAGQShqIAZBGGogBkEIaiADIAQgBSAAEQwAIAZBKGoQyAEhACAGQShqEMUBIAZBCGoQkgEgBkEYahCSASAGQTBqJAAgAAtfAQF/IwBB0BFrIggkACAIQQA2AlACQCAIQQhqIAAgASACIAMgBCAFIAYQvAIgBxCmAiIGQQBIDQAgCEEIaiABEKUCIgZBAEgNACAIQQhqELsCIQYLIAhB0BFqJAAgBgu3PgEpfyMAQeAAayIQJAAgACgChAEhBiAAKAIEISIgACgCiAEhBSAAKAIMIQggECAAKAIYNgJcIAAoAjwhFyAAQUBrKAIAIRYgAEEsaiIkIAMgBEEAEFkgAyAIICJqIANGaiIPIAMgBGoiEUF4aiIpSQRAIAVB/x8gBUH/H0kbISogEUFgaiErQQNBBCAGQQNGGyIoQX9qISIDQAJAAkACQAJAAkACQAJAAkACQCAAKAIEIgUgACgCGCIEaiAPSw0AIA8gA2shHSAAKAKEASEGIAQgDyAFayIISQRAA0AgACAEIAVqIBEgBkEAEEEgBGoiBCAISQ0ACwsgHUUhGyAAIAg2AhgCQAJAAkACQAJAIAZBfWoOBQABAgMDAQtBACELQQAgDyAAKAIEIh9rIgpBfyAAKAJ4QX9qdEF/cyINayIEIAQgCksbIRUgACgCICAPIAAoAnxBAxAeQQJ0aiISKAIAIQcgACgCECAAKAIUIAogACgCdBAnIgRBASAEGyEOQQNBBCAdGyEYIAAoAigiHCAKIA1xQQN0aiIGQQRqIRMgACgCiAEiBEH/HyAEQf8fSRshCSAPQQNqIQwgCkEJaiEUIAogACgCDGshGSAAKAKAASEaICIhBSAbIQQDQAJAAn8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCEF/aiAZTw0AIA9BAxAfIA8gCGtBAxAfRw0AIAwgDCAIayAREB1BA2oiCCAFTQ0AIBcgC0EDdGoiBSAINgIEIAUgBCAbazYCACALQQFqIQsgCCAJSw0FIAgiBSAPaiARRg0FCyAEQQFqIgQgGEkNAAsCQCAFQQJLDQBBAiEFIB8gACgCHCAAKAIkIBBB3ABqIA8QQCIEIA5JDQAgCiAEayIIQf//D0sNACAPIAQgH2ogERAdIgRBA0kNACAXIAQ2AgQgFyAIQQJqNgIAIAQgCU0EQEEBIQsgBCIFIA9qIBFHDQELQQEhCyAAIApBAWo2AhgMBAsgEiAKNgIAAkAgByAOSQ0AIApBAmohEkF/IBp0QX9zIQxBACEKQQAhCQNAIA8gCiAJIAogCUkbIgRqIAcgH2oiGCAEaiAREB0gBGoiBCAFSwRAIBcgC0EDdGoiBSAENgIEIAUgEiAHazYCACAEIAdqIBQgBCAUIAdrSxshFCALQQFqIQsgBEGAIEsNAiAEIgUgD2ogEUYNAgsgHCAHIA1xQQN0aiEIAkACQCAEIBhqLQAAIAQgD2otAABJBEAgBiAHNgIAIAcgFUsNASAQQUBrIQYMBAsgEyAHNgIAIAcgFUsEQCAIIRMgBCEJDAILIBBBQGshEwwDCyAEIQogCEEEaiIGIQgLIAxFDQEgDEF/aiEMIAgoAgAiByAOTw0ACwsgE0EANgIAIAZBADYCACAAIBRBeGo2AhgMAwtBACELQQAgDyAAKAIEIhVrIgpBfyAAKAJ4QX9qdEF/cyITayIEIAQgCksbIR8gACgCICAPIAAoAnxBBBAeQQJ0aiIMKAIAIQcgACgCECAAKAIUIAogACgCdBAnIgRBASAEGyENQQNBBCAdGyESIAAoAigiGCAKIBNxQQN0aiIOQQRqIQYgACgCiAEiBEH/HyAEQf8fSRshHCAPQQRqIQkgCkEJaiEUIAogACgCDGshGSAAKAKAASEaICIhBSAbIQQDQAJAAn8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCEF/aiAZTw0AIA9BBBAfIA8gCGtBBBAfRw0AIAkgCSAIayAREB1BBGoiCCAFTQ0AIBcgC0EDdGoiBSAINgIEIAUgBCAbazYCACALQQFqIQsgCCAcSw0EIAgiBSAPaiARRg0ECyAEQQFqIgQgEkkNAAsgDCAKNgIAAkAgByANSQ0AIApBAmohEkF/IBp0QX9zIQxBACEKQQAhCQNAIA8gCiAJIAogCUkbIgRqIAcgFWoiHCAEaiAREB0gBGoiBCAFSwRAIBcgC0EDdGoiBSAENgIEIAUgEiAHazYCACAEIAdqIBQgBCAUIAdrSxshFCALQQFqIQsgBEGAIEsNAiAEIgUgD2ogEUYNAgsgGCAHIBNxQQN0aiEIAkACQCAEIBxqLQAAIAQgD2otAABJBEAgDiAHNgIAIAcgH0sNASAQQUBrIQ4MBAsgBiAHNgIAIAcgH0sEQCAIIQYgBCEJDAILIBBBQGshBgwDCyAEIQogCEEEaiIOIQgLIAxFDQEgDEF/aiEMIAgoAgAiByANTw0ACwsgBkEANgIAIA5BADYCACAAIBRBeGo2AhgMAgtBACELQQAgDyAAKAIEIhVrIgpBfyAAKAJ4QX9qdEF/cyITayIEIAQgCksbIR8gACgCICAPIAAoAnxBBRAeQQJ0aiIMKAIAIQcgACgCECAAKAIUIAogACgCdBAnIgRBASAEGyENQQNBBCAdGyESIAAoAigiGCAKIBNxQQN0aiIOQQRqIQYgACgCiAEiBEH/HyAEQf8fSRshHCAPQQRqIQkgCkEJaiEUIAogACgCDGshGSAAKAKAASEaICIhBSAbIQQDQAJAAn8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCEF/aiAZTw0AIA9BBBAfIA8gCGtBBBAfRw0AIAkgCSAIayAREB1BBGoiCCAFTQ0AIBcgC0EDdGoiBSAINgIEIAUgBCAbazYCACALQQFqIQsgCCAcSw0DIAgiBSAPaiARRg0DCyAEQQFqIgQgEkkNAAsgDCAKNgIAAkAgByANSQ0AIApBAmohEkF/IBp0QX9zIQxBACEKQQAhCQNAIA8gCiAJIAogCUkbIgRqIAcgFWoiHCAEaiAREB0gBGoiBCAFSwRAIBcgC0EDdGoiBSAENgIEIAUgEiAHazYCACAEIAdqIBQgBCAUIAdrSxshFCALQQFqIQsgBEGAIEsNAiAEIgUgD2ogEUYNAgsgGCAHIBNxQQN0aiEIAkACQCAEIBxqLQAAIAQgD2otAABJBEAgDiAHNgIAIAcgH0sNASAQQUBrIQ4MBAsgBiAHNgIAIAcgH0sEQCAIIQYgBCEJDAILIBBBQGshBgwDCyAEIQogCEEEaiIOIQgLIAxFDQEgDEF/aiEMIAgoAgAiByANTw0ACwsgBkEANgIAIA5BADYCACAAIBRBeGo2AhgMAQtBACELQQAgDyAAKAIEIhVrIgpBfyAAKAJ4QX9qdEF/cyITayIEIAQgCksbIR8gACgCICAPIAAoAnxBBhAeQQJ0aiIMKAIAIQcgACgCECAAKAIUIAogACgCdBAnIgRBASAEGyENQQNBBCAdGyESIAAoAigiGCAKIBNxQQN0aiIOQQRqIQYgACgCiAEiBEH/HyAEQf8fSRshHCAPQQRqIQkgCkEJaiEUIAogACgCDGshGSAAKAKAASEaICIhBSAbIQQDQAJAAn8gBEEDRgRAIAIoAgBBf2oMAQsgAiAEQQJ0aigCAAsiCEF/aiAZTw0AIA9BBBAfIA8gCGtBBBAfRw0AIAkgCSAIayAREB1BBGoiCCAFTQ0AIBcgC0EDdGoiBSAINgIEIAUgBCAbazYCACALQQFqIQsgCCAcSw0CIAgiBSAPaiARRg0CCyAEQQFqIgQgEkkNAAsgDCAKNgIAAkAgByANSQ0AIApBAmohEkF/IBp0QX9zIQxBACEKQQAhCQNAIA8gCiAJIAogCUkbIgRqIAcgFWoiHCAEaiAREB0gBGoiBCAFSwRAIBcgC0EDdGoiBSAENgIEIAUgEiAHazYCACAEIAdqIBQgBCAUIAdrSxshFCALQQFqIQsgBEGAIEsNAiAEIgUgD2ogEUYNAgsgGCAHIBNxQQN0aiEIAkACQCAEIBxqLQAAIAQgD2otAABJBEAgDiAHNgIAIAcgH0sNASAQQUBrIQ4MBAsgBiAHNgIAIAcgH0sEQCAIIQYgBCEJDAILIBBBQGshBgwDCyAEIQogCEEEaiIOIQgLIAxFDQEgDEF/aiEMIAgoAgAiByANTw0ACwsgBkEANgIAIA5BADYCACAAIBRBeGo2AhgLIAtFDQAgFiACKAIANgIQIBYgAigCBDYCFCACKAIIIQQgFiAdNgIMIBZBADYCCCAWIAQ2AhggFiADIB0gJEEAEFgiBTYCACAXIAtBf2pBA3RqIgQoAgQiCCAqSwRAIAQoAgAhBQwDC0EBIQRBACAkQQAQLSEGA0AgFiAEQRxsakGAgICABDYCACAEQQFqIgQgKEcNAAsgBSAGaiEMQQAhBiAoIQgDQCAXIAZBA3RqIgQoAgQhCiAQQUBrIAIgBCgCACIJIBsQPyAIIApNBEAgCUEBahAkIgVBCXRBs7R/akEzIAVBE0sbIRQgBUEIdEGAIGohEwNAIAhBfWohBAJ/IAAoAmRBAUYEQCAEEC4gE2oMAQsgACgCYCAUaiAAKAI4IAVBAnRqKAIAEC5rIAAoAlxqIAQQPEECdCIEQZCkAWooAgAgBWpBCHRqIAAoAjQgBGooAgAQLmsLIQcgFiAIQRxsaiIEIB02AgwgBCAJNgIEIAQgCDYCCCAEIAcgDGo2AgAgBCAQKQNANwIQIAQgECgCSDYCGCAIQQFqIgggCk0NAAsLIAZBAWoiBiALRw0AC0EBIQoCQCAIQX9qIgRFBEBBACEEDAELA0BBASEHIBYgCkF/akEcbGoiBigCCEUEQCAGKAIMQQFqIQcLIAogD2oiDUF/akEBICRBABBSIAYoAgBqIAcgJEEAEC1qIAdBf2ogJEEAEC1rIgUgFiAKQRxsaiIYKAIAIhRMBEAgGCAHNgIMIBhCADcCBCAYIAU2AgAgGCAGKAIYNgIYIBggBikCEDcCECAFIRQLIA0gKUsEfyAKQQFqBSAEIApGBEAgCiEEDAMLAkAgFiAKQQFqIh9BHGxqKAIAIBRBgAFqTA0AQQAhHSAYKAIIIgVFBEAgGCgCDCEdC0EAICRBABAtIS0gACgCBCIGIAAoAhgiB2ogDUsNACAAKAKEASEIIAcgDSAGayIJSQRAA0AgACAGIAdqIBEgCEEAEEEgB2oiByAJSQ0ACwsgBUEARyEbIBhBEGohHCAAIAk2AhgCQAJAAkACQAJAIAhBfWoOBQABAgMDAQtBACEOQQAgDSAAKAIEIhlrIghBfyAAKAJ4QX9qdEF/cyIhayIGIAYgCEsbISUgACgCICANIAAoAnxBAxAeQQJ0aiIeKAIAIQkgACgCECAAKAIUIAggACgCdBAnIgZBASAGGyEaQQRBAyAFGyEjIAAoAigiICAIICFxQQN0aiIMQQRqIRMgACgCiAEiBUH/HyAFQf8fSRshCyANQQNqIRIgCEEJaiEVIAggACgCDGshJiAAKAKAASEnICIhBiAbIQcDQAJAAn8gB0EDRgRAIBwoAgBBf2oMAQsgGCAHQQJ0aigCEAsiBUF/aiAmTw0AIA1BAxAfIA0gBWtBAxAfRw0AIBIgEiAFayAREB1BA2oiBSAGTQ0AIBcgDkEDdGoiBiAFNgIEIAYgByAbazYCACAOQQFqIQ4gBSALSw0FIAUiBiANaiARRg0FCyAHQQFqIgcgI0kNAAsCQCAGQQJLDQBBAiEGIBkgACgCHCAAKAIkIBBB3ABqIA0QQCIFIBpJDQAgCCAFayIHQf//D0sNACANIAUgGWogERAdIgVBA0kNACAXIAU2AgQgFyAHQQJqNgIAIAUgC00EQEEBIQ4gBSIGIA1qIBFHDQELQQEhDiAAIAhBAWo2AhgMBAsgHiAINgIAAkAgCSAaSQ0AIAhBAmohHkF/ICd0QX9zIRJBACELQQAhCANAIA0gCyAIIAsgCEkbIgVqIAkgGWoiIyAFaiAREB0gBWoiByAGSwRAIBcgDkEDdGoiBSAHNgIEIAUgHiAJazYCACAHIAlqIBUgByAVIAlrSxshFSAOQQFqIQ4gB0GAIEsNAiAHIgYgDWogEUYNAgsgICAJICFxQQN0aiEFAkACQCAHICNqLQAAIAcgDWotAABJBEAgDCAJNgIAIAkgJUsNASAQQUBrIQwMBAsgEyAJNgIAIAkgJUsEQCAFIRMgByEIDAILIBBBQGshEwwDCyAHIQsgBUEEaiIMIQULIBJFDQEgEkF/aiESIAUoAgAiCSAaTw0ACwsgE0EANgIAIAxBADYCACAAIBVBeGo2AhgMAwtBACEOQQAgDSAAKAIEIiVrIghBfyAAKAJ4QX9qdEF/cyIZayIGIAYgCEsbIRogACgCICANIAAoAnxBBBAeQQJ0aiISKAIAIQkgACgCECAAKAIUIAggACgCdBAnIgZBASAGGyEhQQRBAyAFGyEeIAAoAigiIyAIIBlxQQN0aiITQQRqIQwgACgCiAEiBUH/HyAFQf8fSRshICANQQRqIQsgCEEJaiEVIAggACgCDGshJiAAKAKAASEnICIhBiAbIQcDQAJAAn8gB0EDRgRAIBwoAgBBf2oMAQsgGCAHQQJ0aigCEAsiBUF/aiAmTw0AIA1BBBAfIA0gBWtBBBAfRw0AIAsgCyAFayAREB1BBGoiBSAGTQ0AIBcgDkEDdGoiBiAFNgIEIAYgByAbazYCACAOQQFqIQ4gBSAgSw0EIAUiBiANaiARRg0ECyAHQQFqIgcgHkkNAAsgEiAINgIAAkAgCSAhSQ0AIAhBAmohHkF/ICd0QX9zIRJBACELQQAhCANAIA0gCyAIIAsgCEkbIgVqIAkgJWoiICAFaiAREB0gBWoiByAGSwRAIBcgDkEDdGoiBSAHNgIEIAUgHiAJazYCACAHIAlqIBUgByAVIAlrSxshFSAOQQFqIQ4gB0GAIEsNAiAHIgYgDWogEUYNAgsgIyAJIBlxQQN0aiEFAkACQCAHICBqLQAAIAcgDWotAABJBEAgEyAJNgIAIAkgGksNASAQQUBrIRMMBAsgDCAJNgIAIAkgGksEQCAFIQwgByEIDAILIBBBQGshDAwDCyAHIQsgBUEEaiITIQULIBJFDQEgEkF/aiESIAUoAgAiCSAhTw0ACwsgDEEANgIAIBNBADYCACAAIBVBeGo2AhgMAgtBACEOQQAgDSAAKAIEIiVrIghBfyAAKAJ4QX9qdEF/cyIZayIGIAYgCEsbIRogACgCICANIAAoAnxBBRAeQQJ0aiISKAIAIQkgACgCECAAKAIUIAggACgCdBAnIgZBASAGGyEhQQRBAyAFGyEeIAAoAigiIyAIIBlxQQN0aiITQQRqIQwgACgCiAEiBUH/HyAFQf8fSRshICANQQRqIQsgCEEJaiEVIAggACgCDGshJiAAKAKAASEnICIhBiAbIQcDQAJAAn8gB0EDRgRAIBwoAgBBf2oMAQsgGCAHQQJ0aigCEAsiBUF/aiAmTw0AIA1BBBAfIA0gBWtBBBAfRw0AIAsgCyAFayAREB1BBGoiBSAGTQ0AIBcgDkEDdGoiBiAFNgIEIAYgByAbazYCACAOQQFqIQ4gBSAgSw0DIAUiBiANaiARRg0DCyAHQQFqIgcgHkkNAAsgEiAINgIAAkAgCSAhSQ0AIAhBAmohHkF/ICd0QX9zIRJBACELQQAhCANAIA0gCyAIIAsgCEkbIgVqIAkgJWoiICAFaiAREB0gBWoiByAGSwRAIBcgDkEDdGoiBSAHNgIEIAUgHiAJazYCACAHIAlqIBUgByAVIAlrSxshFSAOQQFqIQ4gB0GAIEsNAiAHIgYgDWogEUYNAgsgIyAJIBlxQQN0aiEFAkACQCAHICBqLQAAIAcgDWotAABJBEAgEyAJNgIAIAkgGksNASAQQUBrIRMMBAsgDCAJNgIAIAkgGksEQCAFIQwgByEIDAILIBBBQGshDAwDCyAHIQsgBUEEaiITIQULIBJFDQEgEkF/aiESIAUoAgAiCSAhTw0ACwsgDEEANgIAIBNBADYCACAAIBVBeGo2AhgMAQtBACEOQQAgDSAAKAIEIiVrIghBfyAAKAJ4QX9qdEF/cyIZayIGIAYgCEsbIRogACgCICANIAAoAnxBBhAeQQJ0aiISKAIAIQkgACgCECAAKAIUIAggACgCdBAnIgZBASAGGyEhQQRBAyAFGyEeIAAoAigiIyAIIBlxQQN0aiITQQRqIQwgACgCiAEiBUH/HyAFQf8fSRshICANQQRqIQsgCEEJaiEVIAggACgCDGshJiAAKAKAASEnICIhBiAbIQcDQAJAAn8gB0EDRgRAIBwoAgBBf2oMAQsgGCAHQQJ0aigCEAsiBUF/aiAmTw0AIA1BBBAfIA0gBWtBBBAfRw0AIAsgCyAFayAREB1BBGoiBSAGTQ0AIBcgDkEDdGoiBiAFNgIEIAYgByAbazYCACAOQQFqIQ4gBSAgSw0CIAUiBiANaiARRg0CCyAHQQFqIgcgHkkNAAsgEiAINgIAAkAgCSAhSQ0AIAhBAmohHkF/ICd0QX9zIRJBACELQQAhCANAIA0gCyAIIAsgCEkbIgVqIAkgJWoiICAFaiAREB0gBWoiByAGSwRAIBcgDkEDdGoiBSAHNgIEIAUgHiAJazYCACAHIAlqIBUgByAVIAlrSxshFSAOQQFqIQ4gB0GAIEsNAiAHIgYgDWogEUYNAgsgIyAJIBlxQQN0aiEFAkACQCAHICBqLQAAIAcgDWotAABJBEAgEyAJNgIAIAkgGksNASAQQUBrIRMMBAsgDCAJNgIAIAkgGksEQCAFIQwgByEIDAILIBBBQGshDAwDCyAHIQsgBUEEaiITIQULIBJFDQEgEkF/aiESIAUoAgAiCSAhTw0ACwsgDEEANgIAIBNBADYCACAAIBVBeGo2AhgLIA5FDQAgFyAOQX9qQQN0aiIFKAIEIgggKksgCCAKakGAIE9yDQUgFCAtaiEUQQAhCANAIBBBQGsgHCAXIAhBA3RqIgYoAgAiCyAbED8gKCEFIAgEQCAGQXxqKAIAQQFqIQULAkAgBigCBCIHIAVJDQAgC0EBahAkIglBCXRBs7R/akEzIAlBE0sbIRMgCUEIdEGAIGohDQNAIAdBfWohDCAHIApqIQYCfyAAKAJkQQFGBEAgDBAuIA1qDAELIAAoAmAgE2ogACgCOCAJQQJ0aigCABAuayAAKAJcaiAMEDxBAnQiDEGQpAFqKAIAIAlqQQh0aiAAKAI0IAxqKAIAEC5rCyAUaiEMAkAgBiAETQRAIAwgFiAGQRxsaigCAEgNAQwDCwNAIBYgBEEBaiIEQRxsakGAgICABDYCACAEIAZJDQALCyAWIAZBHGxqIgYgHTYCDCAGIAs2AgQgBiAHNgIIIAYgDDYCACAGIBApA0A3AhAgBiAQKAJINgIYIAdBf2oiByAFTw0ACwsgCEEBaiIIIA5HDQALCyAfCyIKIARNDQALCyAWIARBHGxqIgYoAgwhHSAGKAIEIQUgBigCACEsIAYoAgghCCAQIAYoAhg2AlggECAGKQIQNwNQIBAgBikCCDcDKCAQIAYpAhA3AzAgECAGKAIYNgI4IBAgBikCADcDIEEAIAQgEEEgahA+ayIGIAYgBEsbIQQMAwsgD0EBaiEPDAcLIAUoAgAhBUEAIQQgCiAYKAIIBH8gBAUgGCgCDAtrIgRBgCBNDQELIBYgHTYCKCAWIAg2AiQgFiAFNgIgIBYgLDYCHCAWIBAoAlg2AjQgFiAQKQNQNwIsDAELIBYgBEEBaiIUQRxsaiIGIB02AgwgBiAINgIIIAYgBTYCBCAGICw2AgAgBiAQKQNQNwIQIAYgECgCWDYCGCAUIQwgBA0BC0EBIQxBASEUDAELA0AgECAWIARBHGxqIgUiCkEYaigCADYCGCAQIAUpAhA3AxAgECAFKQIINwMIIBAgBSkCADcDACAQED4hCCAWIAxBf2oiDEEcbGoiBiAKKAIYNgIYIAYgBSkCEDcCECAGIAUpAgg3AgggBiAFKQIANwIAIAQgCEshBUEAIAQgCGsiBiAGIARLGyEEIAUNAAsgDCAUSw0BCwNAIBYgDEEcbGoiBCgCDCEGAn8gAyAGaiAEKAIIIgdFDQAaAkACQCAEKAIEIgpBA08EQCACIAIpAgA3AgQgCkF+aiEEDAELAkACQAJAAkAgCiAGRWoiBQ4EBQEBAAELIAIoAgBBf2ohBAwBCyACIAVBAnRqKAIAIQQgBUECSQ0BCyACIAIoAgQ2AggLIAIgAigCADYCBAsgAiAENgIACyAkIAYgAyAKIAcQVyAHQX1qIQkgASgCDCEEAkACQCADIAZqIgUgK00EQCAEIAMQHCABKAIMIQQgBkEQTQRAIAEgBCAGajYCDAwDCyAEQRBqIANBEGoiCBAcIARBIGogA0EgahAcIAZBMUgNASAEIAZqIQsgBEEwaiEEA0AgBCAIQSBqIgUQHCAEQRBqIAhBMGoQHCAFIQggBEEgaiIEIAtJDQALDAELIAQgAyAFICsQIgsgASABKAIMIAZqNgIMIAZBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiBCAKQQFqNgIAIAQgBjsBBCAJQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAk7AQYgASAEQQhqNgIEIAYgB2ogA2oiAwshDyAMQQFqIgwgFE0NAAsLICRBABBRCyAPIClJDQALCyAQQeAAaiQAIBEgA2sLcwEDfyAAIAEoAgAgASgCBCIFQQxsaiIEKQIANwIAIAAgBCgCCCIGNgIIIAYgACgCBCIEaiACTQRAIAEgBUEBajYCBA8LAkAgBCACSQRAIAAgAiAEayIENgIIIAQgA08NAQsgAEEANgIACyABIAIgAxDqAQtyAQF/IwBBIGsiBiQAIAYgBSkCEDcDGCAGIAUpAgg3AxAgBiAFKQIANwMIIAAgAiAGQQhqENYBIAEgAmoiAC0AAEEDdGogA60gBK1CIIaENwIAIAAgAC0AAEEBakF/IAUoAgh0QX9zcToAACAGQSBqJAALNwIBfwF+IAEEQANAIAAgAmoxAAAgA0LjyJW9y5vvjU9+fEIKfCEDIAJBAWoiAiABRw0ACwsgAwuRAQIEfwF+IwBBIGsiByQAIAJBAWoiCCADSQRAIAYoAgwhCQNAIAIgCWotAAAhCiAAKQMgIQsgAi0AACECIAcgBikCEDcDGCAHIAYpAgg3AxAgByAGKQIANwMIIAAgASACIAogCxDZASIBIAUgCCAEayAHQQhqEJkBIAgiAkEBaiIIIANJDQALCyAHQSBqJAAgAQvoBgIdfwJ+IwBBgAFrIgUkACAFIAAoAhA2AnggBSAAKQIINwNwIAUgACkCADcDaCACKAIIIQYgAigCBCEHIAIoAhAhGCAAKQMgISMgAigCDCEKIAAoAgwiECENIAVB6ABqEOgBIhEEQCAAKAIIIRIgACgCECENCwJ/AkAgAyAEaiIOIApBCCAKQQhLG2siGSADSQRAIAMhBwwBCyAHIAZrIQtBfyAYdEF/cyEbIBAgEmpBACARGyEcIA0gEmpBACARGyEdIAAoAgQiDyAQaiETQQAhBEEBIAZ0QQN0IR4gBkEfRiEfIAMiByEGA0ACfwJ+IAMgBkcEQCAiIAQtAAAgBCAKai0AACAjENkBDAELIAMgChCoAwsiIiALIBgQ2AEgG0cEQCAGIQQgBkEBagwBCyAGIA9rIRQgACgCFCEEIAUgAikCEDcDYCAFIAIpAgg3A1ggBSACKQIANwNQIAQgIiALENcBIAVB0ABqENYBIQQgIiALENUBISACQCAfRQRAIAQgHmohIUEAIRVBACEWQQAhDEEAIRoDQAJAIAQoAgQgIEcNACAEKAIAIgggDU0NAAJ/IBEEQCAGIBIgDyAIIBBJIgkbIAhqIhcgDiAcIA4gCRsgExAgIgggCkkNAiAGIAcgFyAdIBMgCRsQ1AEMAQsgBiAIIA9qIgkgDhAdIgggCkkNASAGIAcgCSATENQBCyEJIAggCWoiFyAaTQ0AIBchGiAEIQwgCSEWIAghFQsgBEEIaiIEICFJDQALIAwNAQsgBSACKQIQNwMYIAUgAikCCDcDECAFIAIpAgA3AwggACAiIAsgFCAFQQhqEJkBIAYhBCAGQQFqDAELQbp/IAEoAggiBCABKAIMRg0DGiAMKAIAIQggASgCACAEQQxsaiIMIBUgFmo2AgggDCAGIBZrIAdrNgIEIAwgFCAIazYCACABIARBAWo2AgggBSACKQIQNwNIIAVBQGsgAikCCDcDACAFIAIpAgA3AzggACAiIAsgFCAFQThqEJkBAn8gBiAGIBVqIgcgGUsNABogBSACKQIQNwMwIAUgAikCCDcDKCAFIAIpAgA3AyAgACAiIAYgByAPIAsgBUEgahCpAyEiIAdBf2oLIQQgBwsiBiAZTQ0ACwsgDiAHawshACAFQYABaiQAIAALRAEBfwJAIAEgACgCBGsiAyACTQ0AIAAoAhAiASADIAJrIgJJBEAgACACNgIQIAIhAQsgACgCDCABTw0AIAAgATYCDAsLOQEDfyABBEADQCAAIANBA3RqIgRBACAEKAIAIgQgAmsiBSAFIARLGzYCACADQQFqIgMgAUcNAAsLC0YBAX8gACgCBCEDIAAgAiABazYCBCAAIAIgA2sgAWsiASAAKAIIajYCCCAAIAAoAhAgAWs2AhAgACAAKAIMIAFrNgIMIAELXwECfyMAQRBrIgYkAEGI7AEgARDTAUEQahBMIgc2AgAgBkEIaiADIAQgARDTASIDIAEQeyAHIANBEGogAhB7IAUQpANBiOwBKAIAENsBIAAgBkEIahDaASAGQRBqJAALgAwBF38jAEEQayIPJAAgAigCBCEJIAIoAgAhBiADIAAoAgQiECAAKAIMIhFqIhQgA0ZqIgUgAyAEaiIOQXhqIhJJBEAgACgCCCITIAAoAhAiFWohGiARIBNqIRYgDkFgaiEXIBFBf2ohGANAAn9BACAFQQFqIgcgBiAQamsiBCAVTQ0AGkEAIBggBGtBA0kNABpBACAHKAAAIAQgEyAQIAQgEUkiBBtqIgooAABHDQAaIAVBBWogCkEEaiAOIBYgDiAEGyAUECBBBGoLIQQgD0H/k+vcAzYCDAJAIAAgBSAOIA9BDGoQmgEiCiAEIAogBEsiCBsiCkEDTQRAIAUgA2tBCHUgBWpBAWohBQwBCyAPKAIMQQAgCBshBCAFIAcgCBshBwJAAkAgBSASTw0AIAUgEGshDANAIAxBAWohDSAFQQFqIQgCQCAERQRAQQAhBAwBCyANIAZrIgsgFU0gGCALa0EDSXINACAIKAAAIAsgEyAQIAsgEUkiCxtqIhkoAABHDQAgBUEFaiAZQQRqIA4gFiAOIAsbIBQQICILQXtLDQAgC0EEaiILQQNsIApBA2wgBEEBahAka0EBakwNACAIIQdBACEEIAshCgsgD0H/k+vcAzYCCAJ/AkAgACAIIA4gD0EIahCaASILQQRJDQAgBEEBahAkIRkgC0ECdCAPKAIIIhtBAWoQJGsgCkECdCAZa0EEakwNACANIQwgCCEFIAshCiAbDAELIAggEk8NAiAMQQJqIQwgBUECaiEIAkAgBEUEQEEAIQQMAQsgDCAGayINIBVNIBggDWtBA0lyDQAgCCgAACANIBMgECANIBFJIg0baiILKAAARw0AIAVBBmogC0EEaiAOIBYgDiANGyAUECAiBUF7Sw0AIAVBBGoiBUECdCAKQQJ0QQFyIARBAWoQJGtMDQAgCCEHQQAhBCAFIQoLIA9B/5Pr3AM2AgQgACAIIA4gD0EEahCaASINQQRJDQIgBEEBahAkIQUgDUECdCAPKAIEIgtBAWoQJGsgCkECdCAFa0EHakwNAiAIIQUgDSEKIAsLIQQgBSEHIAUgEkkNAAsMAQsgByEFCwJ/IARFBEAgBiEIIAkMAQsgBEF+aiEIAkAgBSADTQ0AIBMgECAFIBBrIAhrIgcgEUkiCRsgB2oiByAaIBQgCRsiDE0NAANAIAVBf2oiCS0AACAHQX9qIgctAABHDQEgCkEBaiEKIAcgDEsEQCAJIgUgA0sNAQsLIAkhBQsgBgshByAKQX1qIQ0gBSADayEMIAEoAgwhBgJAAkAgBSAXTQRAIAYgAxAcIAEoAgwhCSAMQRBNBEAgASAJIAxqNgIMDAMLIAlBEGogA0EQaiIGEBwgCUEgaiADQSBqEBwgDEExSA0BIAkgDGohCyAJQTBqIQMDQCADIAZBIGoiCRAcIANBEGogBkEwahAcIAkhBiADQSBqIgMgC0kNAAsMAQsgBiADIAUgFxAiCyABIAEoAgwgDGo2AgwgDEGAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIARBAWo2AgAgAyAMOwEEIA1BgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgDTsBBiABIANBCGo2AgQgByEJIAghBiAFIApqIgMhBSADIBJLDQADQAJAIAchBiAIIQcgAyAQayAGayIEIBVNIBggBGtBA0lyDQAgAygAACAEIBMgECAEIBFJIgQbaiIFKAAARw0AIANBBGogBUEEaiAOIBYgDiAEGyAUECAiCkEBaiEFIAEoAgwhBAJAIAMgF00EQCAEIAMQHAwBCyAEIAMgAyAXECILIAEoAgQiBEEBNgIAIARBADsBBCAFQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAU7AQYgASAEQQhqNgIEIAYhCCAHIQkgCkEEaiADaiIDIQUgAyASTQ0BDAILCyAGIQkgByEGIAMhBQsgBSASSQ0ACwsgAiAJNgIEIAIgBjYCACAPQRBqJAAgDiADawudJQEjfyACKAIEIR0gAigCACEUIAMgACgCBCIbIAAoAgwiHmoiISADRmoiByADIARqIgxBeGoiH0kEQCAAKAIIIiAgACgCECIjaiEnIB4gIGohJCAMQWBqISUgHkF/aiEmA0ACf0EAIAdBAWoiHCAUIBtqayIEICNNDQAaQQAgJiAEa0EDSQ0AGkEAIBwoAAAgBCAgIBsgBCAeSSIFG2oiBCgAAEcNABogB0EFaiAEQQRqIAwgJCAMIAUbICEQIEEEagshFQJAAkACQAJAAkAgACgChAFBe2oOAwECAgALIAAoAgQhECAAKAJ0IQUgACgCECEEIAAoAhQhCCAAKAKAASELIAAoAighDiAAKAIMIQogACgCCCENIAAgACgCeCIPIAAoAnwgB0EEECwiBiAEIAcgEGsiCUEBIAV0IgVrIAQgCSAEayAFSxsgCBsiEU0NAkEAIAlBASAPdCIEayIFIAUgCUsbIQ8gCiANaiEWIAogEGohEiAEQX9qIRMgB0EEaiEXQQEgC3QhC0H/k+vcAyEIQQMhBQNAAkACfyAGIApPBEAgBiAQaiIEIAVqLQAAIAUgB2otAABHDQIgByAEIAwQHQwBCyAGIA1qIgQoAAAgBygAAEcNASAXIARBBGogDCAWIBIQIEEEagsiBCAFTQ0AIAkgBmtBAmohCCAHIAQiBWogDEYNBQsgBiAPTQRAIAUhBAwFCyAOIAYgE3FBAnRqKAIAIgYgEU0EQCAFIQQMBQsgBSEEIAtBf2oiCw0ACwwDCyAAKAIEIRAgACgCdCEFIAAoAhAhBCAAKAIUIQggACgCgAEhCyAAKAIoIQ4gACgCDCEKIAAoAgghDSAAIAAoAngiDyAAKAJ8IAdBBRAsIgYgBCAHIBBrIglBASAFdCIFayAEIAkgBGsgBUsbIAgbIhFNDQFBACAJQQEgD3QiBGsiBSAFIAlLGyEPIAogDWohFiAKIBBqIRIgBEF/aiETIAdBBGohF0EBIAt0IQtB/5Pr3AMhCEEDIQUDQAJAAn8gBiAKTwRAIAYgEGoiBCAFai0AACAFIAdqLQAARw0CIAcgBCAMEB0MAQsgBiANaiIEKAAAIAcoAABHDQEgFyAEQQRqIAwgFiASECBBBGoLIgQgBU0NACAJIAZrQQJqIQggByAEIgVqIAxGDQQLIAYgD00EQCAFIQQMBAsgDiAGIBNxQQJ0aigCACIGIBFNBEAgBSEEDAQLIAUhBCALQX9qIgsNAAsMAgsgACgCBCEQIAAoAnQhBSAAKAIQIQQgACgCFCEIIAAoAoABIQsgACgCKCEOIAAoAgwhCiAAKAIIIQ0gACAAKAJ4Ig8gACgCfCAHQQYQLCIGIAQgByAQayIJQQEgBXQiBWsgBCAJIARrIAVLGyAIGyIRTQ0AQQAgCUEBIA90IgRrIgUgBSAJSxshDyAKIA1qIRYgCiAQaiESIARBf2ohEyAHQQRqIRdBASALdCELQf+T69wDIQhBAyEFA0ACQAJ/IAYgCk8EQCAGIBBqIgQgBWotAAAgBSAHai0AAEcNAiAHIAQgDBAdDAELIAYgDWoiBCgAACAHKAAARw0BIBcgBEEEaiAMIBYgEhAgQQRqCyIEIAVNDQAgCSAGa0ECaiEIIAcgBCIFaiAMRg0DCyAGIA9NBEAgBSEEDAMLIA4gBiATcUECdGooAgAiBiARTQRAIAUhBAwDCyAFIQQgC0F/aiILDQALDAELQQMhBEH/k+vcAyEICwJAIAQgFSAEIBVLIgUbIgRBA00EQCAHIANrQQh1IAdqQQFqIQcMAQsgCEEAIAUbIQkgByAcIAUbIRACQAJAIAcgH08NACAHIBtrIRwDQCAcQQFqIRUgB0EBaiEKAkAgCUUEQEEAIQkMAQsgFSAUayIFICNNICYgBWtBA0lyDQAgCigAACAFICAgGyAFIB5JIggbaiIFKAAARw0AIAdBBWogBUEEaiAMICQgDCAIGyAhECAiBUF7Sw0AIAVBBGoiBUEDbCAEQQNsIAlBAWoQJGtBAWpMDQAgCiEQQQAhCSAFIQQLAkACQAJAAkACQAJAIAAoAoQBQXtqDgMBAgIACyAAKAIEIQ8gACgCdCEIIAAoAhAhBSAAKAIUIQsgACgCgAEhDSAAKAIoIRIgACgCDCERIAAoAgghFiAAIAAoAngiEyAAKAJ8IApBBBAsIgYgBSAKIA9rIg5BASAIdCIIayAFIA4gBWsgCEsbIAsbIhdNDQNBACAOQQEgE3QiBWsiCCAIIA5LGyETIBEgFmohGCAPIBFqIRkgBUF/aiEaIAdBBWohIkEBIA10IQ1B/5Pr3AMhC0EDIQgDQAJAAn8gBiARTwRAIAYgD2oiBSAIai0AACAIIApqLQAARw0CIAogBSAMEB0MAQsgBiAWaiIFKAAAIAooAABHDQEgIiAFQQRqIAwgGCAZECBBBGoLIgUgCE0NACAOIAZrQQJqIQsgBSEIIAUgCmogDEYNBAsgBiATTQRAIAghBQwECyASIAYgGnFBAnRqKAIAIgYgF00EQCAIIQUMBAsgCCEFIA1Bf2oiDQ0ACwwCCyAAKAIEIQ8gACgCdCEIIAAoAhAhBSAAKAIUIQsgACgCgAEhDSAAKAIoIRIgACgCDCERIAAoAgghFiAAIAAoAngiEyAAKAJ8IApBBRAsIgYgBSAKIA9rIg5BASAIdCIIayAFIA4gBWsgCEsbIAsbIhdNDQJBACAOQQEgE3QiBWsiCCAIIA5LGyETIBEgFmohGCAPIBFqIRkgBUF/aiEaIAdBBWohIkEBIA10IQ1B/5Pr3AMhC0EDIQgDQAJAAn8gBiARTwRAIAYgD2oiBSAIai0AACAIIApqLQAARw0CIAogBSAMEB0MAQsgBiAWaiIFKAAAIAooAABHDQEgIiAFQQRqIAwgGCAZECBBBGoLIgUgCE0NACAOIAZrQQJqIQsgBSEIIAUgCmogDEYNAwsgBiATTQRAIAghBQwDCyASIAYgGnFBAnRqKAIAIgYgF00EQCAIIQUMAwsgCCEFIA1Bf2oiDQ0ACwwBCyAAKAIEIQ8gACgCdCEIIAAoAhAhBSAAKAIUIQsgACgCgAEhDSAAKAIoIRIgACgCDCERIAAoAgghFiAAIAAoAngiEyAAKAJ8IApBBhAsIgYgBSAKIA9rIg5BASAIdCIIayAFIA4gBWsgCEsbIAsbIhdNDQFBACAOQQEgE3QiBWsiCCAIIA5LGyETIBEgFmohGCAPIBFqIRkgBUF/aiEaIAdBBWohIkEBIA10IQ1B/5Pr3AMhC0EDIQgDQAJAAn8gBiARTwRAIAYgD2oiBSAIai0AACAIIApqLQAARw0CIAogBSAMEB0MAQsgBiAWaiIFKAAAIAooAABHDQEgIiAFQQRqIAwgGCAZECBBBGoLIgUgCE0NACAOIAZrQQJqIQsgBSEIIAUgCmogDEYNAgsgBiATTQRAIAghBQwCCyASIAYgGnFBAnRqKAIAIgYgF00EQCAIIQUMAgsgCCEFIA1Bf2oiDQ0ACwsgBUEESQ0AIAlBAWoQJCEIIAVBAnQgC0EBahAkayAEQQJ0IAhrQQRqTA0AIBUhHCAKIQcgCyEJIAUhBAwBCyAKIB9PDQIgHEECaiEcIAdBAmohBUEAIQoCfyAEIAlFDQAaAkAgHCAUayIIICNNICYgCGtBA0lyDQAgBSgAACAIICAgGyAIIB5JIgYbaiIIKAAARw0AIAdBBmogCEEEaiAMICQgDCAGGyAhECAiCEF7Sw0AIAQgCEEEaiIIQQJ0IARBAnRBAXIgCSIKQQFqECRrTA0BGiAFIRBBACEKIAgMAQsgCSEKIAQLIQgCQAJAAkACQCAAKAKEAUF7ag4DAQICAAsgACgCBCENIAAoAnQhCSAAKAIQIQQgACgCFCELIAAoAoABIREgACgCKCEWIAAoAgwhDiAAKAIIIQ8gACAAKAJ4IhIgACgCfCAFQQQQLCIGIAQgBSANayIVQQEgCXQiCWsgBCAVIARrIAlLGyALGyITTQ0GQQAgFUEBIBJ0IgRrIgkgCSAVSxshEiAOIA9qIRcgDSAOaiEYIARBf2ohGSAHQQZqIRpBASARdCELQf+T69wDIQlBAyEHA0ACQAJ/IAYgDk8EQCAGIA1qIgQgB2otAAAgBSAHai0AAEcNAiAFIAQgDBAdDAELIAYgD2oiBCgAACAFKAAARw0BIBogBEEEaiAMIBcgGBAgQQRqCyIEIAdNDQAgFSAGa0ECaiEJIAUgBCIHaiAMRg0ECyAGIBJNBEAgByEEDAQLIBYgBiAZcUECdGooAgAiBiATTQRAIAchBAwECyAHIQQgC0F/aiILDQALDAILIAAoAgQhDSAAKAJ0IQkgACgCECEEIAAoAhQhCyAAKAKAASERIAAoAighFiAAKAIMIQ4gACgCCCEPIAAgACgCeCISIAAoAnwgBUEFECwiBiAEIAUgDWsiFUEBIAl0IglrIAQgFSAEayAJSxsgCxsiE00NBUEAIBVBASASdCIEayIJIAkgFUsbIRIgDiAPaiEXIA0gDmohGCAEQX9qIRkgB0EGaiEaQQEgEXQhC0H/k+vcAyEJQQMhBwNAAkACfyAGIA5PBEAgBiANaiIEIAdqLQAAIAUgB2otAABHDQIgBSAEIAwQHQwBCyAGIA9qIgQoAAAgBSgAAEcNASAaIARBBGogDCAXIBgQIEEEagsiBCAHTQ0AIBUgBmtBAmohCSAFIAQiB2ogDEYNAwsgBiASTQRAIAchBAwDCyAWIAYgGXFBAnRqKAIAIgYgE00EQCAHIQQMAwsgByEEIAtBf2oiCw0ACwwBCyAAKAIEIQ0gACgCdCEJIAAoAhAhBCAAKAIUIQsgACgCgAEhESAAKAIoIRYgACgCDCEOIAAoAgghDyAAIAAoAngiEiAAKAJ8IAVBBhAsIgYgBCAFIA1rIhVBASAJdCIJayAEIBUgBGsgCUsbIAsbIhNNDQRBACAVQQEgEnQiBGsiCSAJIBVLGyESIA4gD2ohFyANIA5qIRggBEF/aiEZIAdBBmohGkEBIBF0IQtB/5Pr3AMhCUEDIQcDQAJAAn8gBiAOTwRAIAYgDWoiBCAHai0AACAFIAdqLQAARw0CIAUgBCAMEB0MAQsgBiAPaiIEKAAAIAUoAABHDQEgGiAEQQRqIAwgFyAYECBBBGoLIgQgB00NACAVIAZrQQJqIQkgBSAEIgdqIAxGDQILIAYgEk0EQCAHIQQMAgsgFiAGIBlxQQJ0aigCACIGIBNNBEAgByEEDAILIAchBCALQX9qIgsNAAsLIARBBEkNAyAKQQFqECQhBiAFIQcgBEECdCAJQQFqECRrIAhBAnQgBmtBB2pMDQMLIAchECAJIQogBCEIIAcgH0kNAAsMAQsgCSEKIAQhCAsCfyAKRQRAIBQhBSAdDAELIApBfmohBQJAIBAgA00NACAgIBsgECAbayAFayIEIB5JIgcbIARqIgQgJyAhIAcbIgZNDQADQCAQQX9qIgctAAAgBEF/aiIELQAARw0BIAhBAWohCCAEIAZLBEAgByIQIANLDQELCyAHIRALIBQLIQYgCEF9aiEJIBAgA2shFCABKAIMIQQCQAJAIBAgJU0EQCAEIAMQHCABKAIMIQQgFEEQTQRAIAEgBCAUajYCDAwDCyAEQRBqIANBEGoiBxAcIARBIGogA0EgahAcIBRBMUgNASAEIBRqIR0gBEEwaiEEA0AgBCAHQSBqIgMQHCAEQRBqIAdBMGoQHCADIQcgBEEgaiIEIB1JDQALDAELIAQgAyAQICUQIgsgASABKAIMIBRqNgIMIBRBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAyAKQQFqNgIAIAMgFDsBBCAJQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyADIAk7AQYgASADQQhqNgIEIAYhHSAFIRQgCCAQaiIDIQcgAyAfSw0AA0ACQCAGIRQgBSEGIAMgG2sgFGsiBCAjTSAmIARrQQNJcg0AIAMoAAAgBCAgIBsgBCAeSSIFG2oiBCgAAEcNACADQQRqIARBBGogDCAkIAwgBRsgIRAgIgdBAWohBSABKAIMIQQCQCADICVNBEAgBCADEBwMAQsgBCADIAMgJRAiCyABKAIEIgRBATYCACAEQQA7AQQgBUGAgARPBEAgAUECNgIkIAEgBCABKAIAa0EDdTYCKAsgBCAFOwEGIAEgBEEIajYCBCAUIQUgBiEdIAdBBGogA2oiAyEHIAMgH00NAQwCCwsgFCEdIAYhFCADIQcLIAcgH0kNAAsLIAIgHTYCBCACIBQ2AgAgDCADawvXGgEifyACKAIEIRggAigCACEQIAMgACgCBCIZIAAoAgwiGmoiISADRmoiByADIARqIgpBeGoiHEkEQCAAKAIIIh0gACgCECIjaiEmIBogHWohJCAKQWBqISIgGkF/aiElA0ACf0EAIAdBAWoiESAQIBlqayIEICNNDQAaQQAgJSAEa0EDSQ0AGkEAIBEoAAAgBCAdIBkgBCAaSSIFG2oiBCgAAEcNABogB0EFaiAEQQRqIAogJCAKIAUbICEQIEEEagshGwJAAkACQAJAAkAgACgChAFBe2oOAwECAgALIAAoAgQhDSAAKAJ0IQYgACgCECEEIAAoAhQhCyAAKAKAASEJIAAoAighEiAAKAIMIQggACgCCCEOIAAgACgCeCIPIAAoAnwgB0EEECwiBSAEIAcgDWsiDEEBIAZ0IgZrIAQgDCAEayAGSxsgCxsiFE0NAkEAIAxBASAPdCIEayIGIAYgDEsbIQ8gCCAOaiEVIAggDWohEyAEQX9qIRYgB0EEaiEXQQEgCXQhCUH/k+vcAyELQQMhBgNAAkACfyAFIAhPBEAgBSANaiIEIAZqLQAAIAYgB2otAABHDQIgByAEIAoQHQwBCyAFIA5qIgQoAAAgBygAAEcNASAXIARBBGogCiAVIBMQIEEEagsiBCAGTQ0AIAwgBWtBAmohCyAEIQYgBCAHaiAKRg0FCyAFIA9NBEAgBiEEDAULIBIgBSAWcUECdGooAgAiBSAUTQRAIAYhBAwFCyAGIQQgCUF/aiIJDQALDAMLIAAoAgQhDSAAKAJ0IQYgACgCECEEIAAoAhQhCyAAKAKAASEJIAAoAighEiAAKAIMIQggACgCCCEOIAAgACgCeCIPIAAoAnwgB0EFECwiBSAEIAcgDWsiDEEBIAZ0IgZrIAQgDCAEayAGSxsgCxsiFE0NAUEAIAxBASAPdCIEayIGIAYgDEsbIQ8gCCAOaiEVIAggDWohEyAEQX9qIRYgB0EEaiEXQQEgCXQhCUH/k+vcAyELQQMhBgNAAkACfyAFIAhPBEAgBSANaiIEIAZqLQAAIAYgB2otAABHDQIgByAEIAoQHQwBCyAFIA5qIgQoAAAgBygAAEcNASAXIARBBGogCiAVIBMQIEEEagsiBCAGTQ0AIAwgBWtBAmohCyAEIQYgBCAHaiAKRg0ECyAFIA9NBEAgBiEEDAQLIBIgBSAWcUECdGooAgAiBSAUTQRAIAYhBAwECyAGIQQgCUF/aiIJDQALDAILIAAoAgQhDSAAKAJ0IQYgACgCECEEIAAoAhQhCyAAKAKAASEJIAAoAighEiAAKAIMIQggACgCCCEOIAAgACgCeCIPIAAoAnwgB0EGECwiBSAEIAcgDWsiDEEBIAZ0IgZrIAQgDCAEayAGSxsgCxsiFE0NAEEAIAxBASAPdCIEayIGIAYgDEsbIQ8gCCAOaiEVIAggDWohEyAEQX9qIRYgB0EEaiEXQQEgCXQhCUH/k+vcAyELQQMhBgNAAkACfyAFIAhPBEAgBSANaiIEIAZqLQAAIAYgB2otAABHDQIgByAEIAoQHQwBCyAFIA5qIgQoAAAgBygAAEcNASAXIARBBGogCiAVIBMQIEEEagsiBCAGTQ0AIAwgBWtBAmohCyAEIQYgBCAHaiAKRg0DCyAFIA9NBEAgBiEEDAMLIBIgBSAWcUECdGooAgAiBSAUTQRAIAYhBAwDCyAGIQQgCUF/aiIJDQALDAELQQMhBEH/k+vcAyELCwJAIAQgGyAEIBtLIgQbIgxBA00EQCAHIANrQQh1IAdqQQFqIQcMAQsgC0EAIAQbIQ0gByARIAQbIQsCQCAHIBxPDQAgByAZayEbA0AgG0EBaiEbIAdBAWohBgJAIA1FBEBBACENDAELIBsgEGsiBCAjTSAlIARrQQNJcg0AIAYoAAAgBCAdIBkgBCAaSSIFG2oiBCgAAEcNACAHQQVqIARBBGogCiAkIAogBRsgIRAgIgRBe0sNACAEQQRqIgRBA2wgDEEDbCANQQFqECRrQQFqTA0AIAYhC0EAIQ0gBCEMCwJAAkACQAJAIAAoAoQBQXtqDgMBAgIACyAAKAIEIQ4gACgCdCEIIAAoAhAhBSAAKAIUIQkgACgCgAEhFCAAKAIoIRUgACgCDCESIAAoAgghDyAAIAAoAngiEyAAKAJ8IAZBBBAsIgQgBSAGIA5rIhFBASAIdCIIayAFIBEgBWsgCEsbIAkbIhZNDQRBACARQQEgE3QiBWsiCCAIIBFLGyETIA8gEmohFyAOIBJqIR4gBUF/aiEfIAdBBWohIEEBIBR0IQlB/5Pr3AMhCEEDIQcDQAJAAn8gBCASTwRAIAQgDmoiBSAHai0AACAGIAdqLQAARw0CIAYgBSAKEB0MAQsgBCAPaiIFKAAAIAYoAABHDQEgICAFQQRqIAogFyAeECBBBGoLIgUgB00NACARIARrQQJqIQggBiAFIgdqIApGDQQLIAQgE00EQCAHIQUMBAsgFSAEIB9xQQJ0aigCACIEIBZNBEAgByEFDAQLIAchBSAJQX9qIgkNAAsMAgsgACgCBCEOIAAoAnQhCCAAKAIQIQUgACgCFCEJIAAoAoABIRQgACgCKCEVIAAoAgwhEiAAKAIIIQ8gACAAKAJ4IhMgACgCfCAGQQUQLCIEIAUgBiAOayIRQQEgCHQiCGsgBSARIAVrIAhLGyAJGyIWTQ0DQQAgEUEBIBN0IgVrIgggCCARSxshEyAPIBJqIRcgDiASaiEeIAVBf2ohHyAHQQVqISBBASAUdCEJQf+T69wDIQhBAyEHA0ACQAJ/IAQgEk8EQCAEIA5qIgUgB2otAAAgBiAHai0AAEcNAiAGIAUgChAdDAELIAQgD2oiBSgAACAGKAAARw0BICAgBUEEaiAKIBcgHhAgQQRqCyIFIAdNDQAgESAEa0ECaiEIIAYgBSIHaiAKRg0DCyAEIBNNBEAgByEFDAMLIBUgBCAfcUECdGooAgAiBCAWTQRAIAchBQwDCyAHIQUgCUF/aiIJDQALDAELIAAoAgQhDiAAKAJ0IQggACgCECEFIAAoAhQhCSAAKAKAASEUIAAoAighFSAAKAIMIRIgACgCCCEPIAAgACgCeCITIAAoAnwgBkEGECwiBCAFIAYgDmsiEUEBIAh0IghrIAUgESAFayAISxsgCRsiFk0NAkEAIBFBASATdCIFayIIIAggEUsbIRMgDyASaiEXIA4gEmohHiAFQX9qIR8gB0EFaiEgQQEgFHQhCUH/k+vcAyEIQQMhBwNAAkACfyAEIBJPBEAgBCAOaiIFIAdqLQAAIAYgB2otAABHDQIgBiAFIAoQHQwBCyAEIA9qIgUoAAAgBigAAEcNASAgIAVBBGogCiAXIB4QIEEEagsiBSAHTQ0AIBEgBGtBAmohCCAGIAUiB2ogCkYNAgsgBCATTQRAIAchBQwCCyAVIAQgH3FBAnRqKAIAIgQgFk0EQCAHIQUMAgsgByEFIAlBf2oiCQ0ACwsgBUEESQ0BIA1BAWoQJCEEIAVBAnQgCEEBahAkayAMQQJ0IARrQQRqTA0BIAUhDCAIIQ0gBiIHIQsgByAcSQ0ACwsCfyANRQRAIBAhBiAYDAELIA1BfmohBgJAIAsgA00NACAdIBkgCyAZayAGayIEIBpJIgUbIARqIgQgJiAhIAUbIgdNDQADQCALQX9qIgUtAAAgBEF/aiIELQAARw0BIAxBAWohDCAEIAdLBEAgBSILIANLDQELCyAFIQsLIBALIQUgDEF9aiEYIAsgA2shECABKAIMIQQCQAJAIAsgIk0EQCAEIAMQHCABKAIMIQQgEEEQTQRAIAEgBCAQajYCDAwDCyAEQRBqIANBEGoiBxAcIARBIGogA0EgahAcIBBBMUgNASAEIBBqIQggBEEwaiEEA0AgBCAHQSBqIgMQHCAEQRBqIAdBMGoQHCADIQcgBEEgaiIEIAhJDQALDAELIAQgAyALICIQIgsgASABKAIMIBBqNgIMIBBBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAyANQQFqNgIAIAMgEDsBBCAYQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyADIBg7AQYgASADQQhqNgIEIAUhGCAGIRAgCyAMaiIDIQcgAyAcSw0AA0ACQCAFIRAgBiEFIAMgGWsgEGsiBCAjTSAlIARrQQNJcg0AIAMoAAAgBCAdIBkgBCAaSSIGG2oiBCgAAEcNACADQQRqIARBBGogCiAkIAogBhsgIRAgIgdBAWohBiABKAIMIQQCQCADICJNBEAgBCADEBwMAQsgBCADIAMgIhAiCyABKAIEIgRBATYCACAEQQA7AQQgBkGAgARPBEAgAUECNgIkIAEgBCABKAIAa0EDdTYCKAsgBCAGOwEGIAEgBEEIajYCBCAQIQYgBSEYIAdBBGogA2oiAyEHIAMgHE0NAQwCCwsgECEYIAUhECADIQcLIAcgHEkNAAsLIAIgGDYCBCACIBA2AgAgCiADawuAEAEdfyACKAIEIQogAigCACEIIAMgACgCBCISIAAoAgwiE2oiHCADRmoiBiADIARqIgxBeGoiHUkEQCAAKAIIIhogACgCECIeaiEhIBMgGmohHyAMQWBqIRsgE0F/aiEgA0ACQAJ/AkACfwJAIAZBAWoiBSAIIBJqayIEIB5NICAgBGtBA0lyDQAgBSgAACAEIBogEiAEIBNJIgQbaiIHKAAARw0AIAZBBWogB0EEaiAMIB8gDCAEGyAcECBBBGohBEEADAELAkACQAJAAkACQAJAIAAoAoQBQXtqDgMBAgIACyAAKAIEIQ4gACgCdCEFIAAoAhAhBCAAKAIUIQkgACgCgAEhDSAAKAIoIRQgACgCDCEPIAAoAgghESAAIAAoAngiECAAKAJ8IAZBBBAsIgcgBCAGIA5rIgtBASAFdCIFayAEIAsgBGsgBUsbIAkbIhVNDQNBACALQQEgEHQiBGsiBSAFIAtLGyEQIA8gEWohFiAOIA9qIRcgBEF/aiEYIAZBBGohGUEBIA10IQlB/5Pr3AMhDUEDIQUDQAJAAn8gByAPTwRAIAcgDmoiBCAFai0AACAFIAZqLQAARw0CIAYgBCAMEB0MAQsgByARaiIEKAAAIAYoAABHDQEgGSAEQQRqIAwgFiAXECBBBGoLIgQgBU0NACALIAdrQQJqIQ0gBiAEIgVqIAxGDQQLIAcgEE0EQCAFIQQMBAsgFCAHIBhxQQJ0aigCACIHIBVNBEAgBSEEDAQLIAUhBCAJQX9qIgkNAAsMAgsgACgCBCEOIAAoAnQhBSAAKAIQIQQgACgCFCEJIAAoAoABIQ0gACgCKCEUIAAoAgwhDyAAKAIIIREgACAAKAJ4IhAgACgCfCAGQQUQLCIHIAQgBiAOayILQQEgBXQiBWsgBCALIARrIAVLGyAJGyIVTQ0CQQAgC0EBIBB0IgRrIgUgBSALSxshECAPIBFqIRYgDiAPaiEXIARBf2ohGCAGQQRqIRlBASANdCEJQf+T69wDIQ1BAyEFA0ACQAJ/IAcgD08EQCAHIA5qIgQgBWotAAAgBSAGai0AAEcNAiAGIAQgDBAdDAELIAcgEWoiBCgAACAGKAAARw0BIBkgBEEEaiAMIBYgFxAgQQRqCyIEIAVNDQAgCyAHa0ECaiENIAYgBCIFaiAMRg0DCyAHIBBNBEAgBSEEDAMLIBQgByAYcUECdGooAgAiByAVTQRAIAUhBAwDCyAFIQQgCUF/aiIJDQALDAELIAAoAgQhDiAAKAJ0IQUgACgCECEEIAAoAhQhCSAAKAKAASENIAAoAighFCAAKAIMIQ8gACgCCCERIAAgACgCeCIQIAAoAnwgBkEGECwiByAEIAYgDmsiC0EBIAV0IgVrIAQgCyAEayAFSxsgCRsiFU0NAUEAIAtBASAQdCIEayIFIAUgC0sbIRAgDyARaiEWIA4gD2ohFyAEQX9qIRggBkEEaiEZQQEgDXQhCUH/k+vcAyENQQMhBQNAAkACfyAHIA9PBEAgByAOaiIEIAVqLQAAIAUgBmotAABHDQIgBiAEIAwQHQwBCyAHIBFqIgQoAAAgBigAAEcNASAZIARBBGogDCAWIBcQIEEEagsiBCAFTQ0AIAsgB2tBAmohDSAGIAQiBWogDEYNAgsgByAQTQRAIAUhBAwCCyAUIAcgGHFBAnRqKAIAIgcgFU0EQCAFIQQMAgsgBSEEIAlBf2oiCQ0ACwsgBEEDSw0BCyAGIANrQQh1IAZqQQFqIQYMBAsgDQ0BIAYhBUEACyENIAghCSAKDAELIA1BfmohCQJAAkAgBiADTQ0AIBogEiAGIBJrIAlrIgUgE0kiChsgBWoiByAhIBwgChsiCk0NAANAIAZBf2oiBS0AACAHQX9qIgctAABHDQEgBEEBaiEEIAcgCk0NAiAFIgYgA0sNAAsMAQsgBiEFCyAICyEHIARBfWohCyAFIANrIQogASgCDCEIAkACQCAFIBtNBEAgCCADEBwgASgCDCEIIApBEE0EQCABIAggCmo2AgwMAwsgCEEQaiADQRBqIgYQHCAIQSBqIANBIGoQHCAKQTFIDQEgCCAKaiEOIAhBMGohAwNAIAMgBkEgaiIIEBwgA0EQaiAGQTBqEBwgCCEGIANBIGoiAyAOSQ0ACwwBCyAIIAMgBSAbECILIAEgASgCDCAKajYCDCAKQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyABKAIEIgMgDUEBajYCACADIAo7AQQgC0GAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyALOwEGIAEgA0EIajYCBCAHIQogCSEIIAQgBWoiAyEGIAMgHUsNAANAAkAgByEIIAkhByADIBJrIAhrIgQgHk0gICAEa0EDSXINACADKAAAIAQgGiASIAQgE0kiBBtqIgUoAABHDQAgA0EEaiAFQQRqIAwgHyAMIAQbIBwQICIGQQFqIQUgASgCDCEEAkAgAyAbTQRAIAQgAxAcDAELIAQgAyADIBsQIgsgASgCBCIEQQE2AgAgBEEAOwEEIAVBgIAETwRAIAFBAjYCJCABIAQgASgCAGtBA3U2AigLIAQgBTsBBiABIARBCGo2AgQgCCEJIAchCiAGQQRqIANqIgMhBiADIB1NDQEMAgsLIAghCiAHIQggAyEGCyAGIB1JDQALCyACIAo2AgQgAiAINgIAIAwgA2sL+QcBFX8jAEEQayIOJAAgAigCBCEIIAIoAgAhBiADIAAoAnAiBSgCACIRIAMgACgCBCINIAAoAgwiDGoiEmtqIAUoAgQiEyAFKAIMaiIXRmoiBSADIARqIgpBeGoiFEkEQCATIAwgE2ogEWsiGGshFSAKQWBqIQ8DQAJAAn8CQAJ/AkAgDCAFQQFqIgcgBiANamsiBEF/c2pBA0kNACATIAQgGGtqIAcgBmsgBCAMSSIEGyIJKAAAIAcoAABHDQAgBUEFaiAJQQRqIAogESAKIAQbIBIQIEEEaiELQQAMAQsgDkH/k+vcAzYCDCAAIAUgCiAOQQxqEGoiC0EDTQRAIAUgA2tBCHUgBWpBAWohBQwECyAOKAIMIhANASAFIQdBAAshECAGIQkgCAwBCwJAIAUgA00EQCAFIQcMAQsgBSEHIBUgDSAFIA0gEGprQQJqIgQgDEkiCRsgBGoiBCAXIBIgCRsiCU0NAANAIAVBf2oiBy0AACAEQX9qIgQtAABHBEAgBSEHDAILIAtBAWohCyAEIAlNDQEgByIFIANLDQALCyAQQX5qIQkgBgshBCALQX1qIRYgByADayEIIAEoAgwhBQJAAkAgByAPTQRAIAUgAxAcIAEoAgwhBiAIQRBNBEAgASAGIAhqNgIMDAMLIAZBEGogA0EQaiIFEBwgBkEgaiADQSBqEBwgCEExSA0BIAYgCGohGSAGQTBqIQMDQCADIAVBIGoiBhAcIANBEGogBUEwahAcIAYhBSADQSBqIgMgGUkNAAsMAQsgBSADIAcgDxAiCyABIAEoAgwgCGo2AgwgCEGAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIBBBAWo2AgAgAyAIOwEEIBZBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgFjsBBiABIANBCGo2AgQgBCEIIAkhBiAHIAtqIgMhBSADIBRLDQADQAJAIAQhBiAJIQQgDCADIA1rIAZrIgVBf3NqQQNJDQAgBSAVIA0gBSAMSSIFG2oiBygAACADKAAARw0AIANBBGogB0EEaiAKIBEgCiAFGyASECAiC0EBaiEHIAEoAgwhBQJAIAMgD00EQCAFIAMQHAwBCyAFIAMgAyAPECILIAEoAgQiBUEBNgIAIAVBADsBBCAHQYCABE8EQCABQQI2AiQgASAFIAEoAgBrQQN1NgIoCyAFIAc7AQYgASAFQQhqNgIEIAYhCSAEIQggC0EEaiADaiIDIQUgAyAUTQ0BDAILCyAGIQggBCEGIAMhBQsgBSAUSQ0ACwsgAiAINgIEIAIgBjYCACAOQRBqJAAgCiADawuaCgEVfyMAQRBrIg8kACACKAIEIQkgAigCACEIIAMgACgCcCIFKAIAIhIgAyAAKAIEIhAgACgCDCINaiITa2ogBSgCBCIUIAUoAgxqIhhGaiIGIAMgBGoiDEF4aiIRSQRAIBQgDSAUaiASayIWayEXIAxBYGohFQNAAn9BACANIAZBAWoiBCAIIBBqayIFQX9zakEDSQ0AGkEAIBQgBSAWa2ogBCAIayAFIA1JIgUbIgcoAAAgBCgAAEcNABogBkEFaiAHQQRqIAwgEiAMIAUbIBMQIEEEagshBSAPQf+T69wDNgIMAkAgACAGIAwgD0EMahBqIgcgBSAHIAVLIgobIgdBA00EQCAGIANrQQh1IAZqQQFqIQYMAQsgBiAEIAobIgshBSAPKAIMQQAgChsiDiEKIAchBAJAIAYgEU8NAANAAkAgDSAGQQFqIgUgEGsgCGsiBEF/c2pBA0kNACAUIAQgFmtqIAUgCGsgBCANSSIEGyIKKAAAIAUoAABHDQAgBkEFaiAKQQRqIAwgEiAMIAQbIBMQICIEQXtLDQAgBEEEaiIEQQNsIAdBA2wgDkEBahAka0EBakwNAEEAIQ4gBSELIAQhBwsgD0H/k+vcAzYCCAJAIAAgBSAMIA9BCGoQaiIEQQRJDQAgDkEBahAkIQYgBEECdCAPKAIIIgpBAWoQJGsgB0ECdCAGa0EEakwNACAFIQYgBCEHIAohDiAFIQsgBSARSQ0BDAILCyALIQUgDiEKIAchBAsCfyAKRQRAIAUhBiAJIQcgCAwBCwJAIAUgA00EQCAFIQYMAQsgBSEGIBcgECAFIAogEGprQQJqIgcgDUkiCRsgB2oiByAYIBMgCRsiCU0NAANAIAVBf2oiBi0AACAHQX9qIgctAABHBEAgBSEGDAILIARBAWohBCAHIAlNDQEgBiIFIANLDQALCyAIIQcgCkF+agshBSAEQX1qIQ4gBiADayELIAEoAgwhCAJAAkAgBiAVTQRAIAggAxAcIAEoAgwhCSALQRBNBEAgASAJIAtqNgIMDAMLIAlBEGogA0EQaiIIEBwgCUEgaiADQSBqEBwgC0ExSA0BIAkgC2ohGSAJQTBqIQMDQCADIAhBIGoiCRAcIANBEGogCEEwahAcIAkhCCADQSBqIgMgGUkNAAsMAQsgCCADIAYgFRAiCyABIAEoAgwgC2o2AgwgC0GAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIApBAWo2AgAgAyALOwEEIA5BgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgDjsBBiABIANBCGo2AgQgByEJIAUhCCAEIAZqIgMhBiADIBFLDQADQAJAIAchCCAFIQcgDSADIBBrIAhrIgRBf3NqQQNJDQAgBCAXIBAgBCANSSIFG2oiBCgAACADKAAARw0AIANBBGogBEEEaiAMIBIgDCAFGyATECAiBkEBaiEFIAEoAgwhBAJAIAMgFU0EQCAEIAMQHAwBCyAEIAMgAyAVECILIAEoAgQiBEEBNgIAIARBADsBBCAFQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAU7AQYgASAEQQhqNgIEIAghBSAHIQkgBkEEaiADaiIDIQYgAyARTQ0BDAILCyAIIQkgByEIIAMhBgsgBiARSQ0ACwsgAiAJNgIEIAIgCDYCACAPQRBqJAAgDCADawvmCwEVfyMAQRBrIg0kACACKAIEIQogAigCACEIIAMgACgCcCIGKAIAIhIgAyAAKAIEIhAgACgCDCIOaiITa2ogBigCBCIUIAYoAgxqIhlGaiIFIAMgBGoiC0F4aiIRSQRAIBQgDiAUaiASayIWayEYIAtBYGohFQNAAn9BACAOIAVBAWoiBCAIIBBqayIGQX9zakEDSQ0AGkEAIBQgBiAWa2ogBCAIayAGIA5JIgYbIgkoAAAgBCgAAEcNABogBUEFaiAJQQRqIAsgEiALIAYbIBMQIEEEagshBiANQf+T69wDNgIMAkAgACAFIAsgDUEMahBqIgkgBiAJIAZLIgYbIglBA00EQCAFIANrQQh1IAVqQQFqIQUMAQsgDSgCDEEAIAYbIQwgBSAEIAYbIQQCQCAFIBFPDQADQAJAIA4gBUEBaiIGIBBrIAhrIgdBf3NqQQNJDQAgFCAHIBZraiAGIAhrIAcgDkkiBxsiDygAACAGKAAARw0AIAVBBWogD0EEaiALIBIgCyAHGyATECAiB0F7Sw0AIAdBBGoiB0EDbCAJQQNsIAxBAWoQJGtBAWpMDQBBACEMIAYhBCAHIQkLIA1B/5Pr3AM2AggCfwJAIAAgBiALIA1BCGoQaiIHQQRJDQAgDEEBahAkIRcgB0ECdCANKAIIIg9BAWoQJGsgCUECdCAXa0EEakwNACAPIQwgByEJIAYMAQsgBiARTw0CAkAgDiAFQQJqIgYgEGsgCGsiB0F/c2pBA0kNACAUIAcgFmtqIAYgCGsgByAOSSIHGyIPKAAAIAYoAABHDQAgBUEGaiAPQQRqIAsgEiALIAcbIBMQICIFQXtLDQAgBUEEaiIFQQJ0IAlBAnRBAXIgDEEBahAka0wNAEEAIQwgBiEEIAUhCQsgDUH/k+vcAzYCBCAAIAYgCyANQQRqEGoiBUEESQ0CIAxBAWoQJCEPIAVBAnQgDSgCBCIHQQFqECRrIAlBAnQgD2tBB2pMDQIgByEMIAUhCSAGCyIFIQQgBSARSQ0ACwsCfyAMRQRAIAQhBSAKIQYgCAwBCwJAIAQgA00EQCAEIQUMAQsgGCAQIAQiBSAMIBBqa0ECaiIGIA5JIgobIAZqIgYgGSATIAobIgpNDQADQCAEQX9qIgUtAAAgBkF/aiIGLQAARwRAIAQhBQwCCyAJQQFqIQkgBiAKTQ0BIAUhBCAFIANLDQALCyAIIQYgDEF+agshBCAJQX1qIQ8gBSADayEHIAEoAgwhCAJAAkAgBSAVTQRAIAggAxAcIAEoAgwhCiAHQRBNBEAgASAHIApqNgIMDAMLIApBEGogA0EQaiIIEBwgCkEgaiADQSBqEBwgB0ExSA0BIAcgCmohFyAKQTBqIQMDQCADIAhBIGoiChAcIANBEGogCEEwahAcIAohCCADQSBqIgMgF0kNAAsMAQsgCCADIAUgFRAiCyABIAEoAgwgB2o2AgwgB0GAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIAxBAWo2AgAgAyAHOwEEIA9BgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgDzsBBiABIANBCGo2AgQgBiEKIAQhCCAFIAlqIgMhBSADIBFLDQADQAJAIAYhCCAEIQYgDiADIBBrIAhrIgRBf3NqQQNJDQAgBCAYIBAgBCAOSSIFG2oiBCgAACADKAAARw0AIANBBGogBEEEaiALIBIgCyAFGyATECAiCUEBaiEFIAEoAgwhBAJAIAMgFU0EQCAEIAMQHAwBCyAEIAMgAyAVECILIAEoAgQiBEEBNgIAIARBADsBBCAFQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAU7AQYgASAEQQhqNgIEIAghBCAGIQogCUEEaiADaiIDIQUgAyARTQ0BDAILCyAIIQogBiEIIAMhBQsgBSARSQ0ACwsgAiAKNgIEIAIgCDYCACANQRBqJAAgCyADawvpCwEVfyMAQRBrIg0kACACKAIEIQogAigCACEIIAMgACgCcCIGKAIAIhIgAyAAKAIEIhAgACgCDCIOaiITa2ogBigCBCIUIAYoAgxqIhlGaiIFIAMgBGoiC0F4aiIRSQRAIBQgDiAUaiASayIWayEYIAtBYGohFQNAAn9BACAOIAVBAWoiBCAIIBBqayIGQX9zakEDSQ0AGkEAIBQgBiAWa2ogBCAIayAGIA5JIgYbIgkoAAAgBCgAAEcNABogBUEFaiAJQQRqIAsgEiALIAYbIBMQIEEEagshBiANQf+T69wDNgIMAkAgACAFIAsgDUEMahCbASIJIAYgCSAGSyIGGyIJQQNNBEAgBSADa0EIdSAFakEBaiEFDAELIA0oAgxBACAGGyEMIAUgBCAGGyEEAkAgBSARTw0AA0ACQCAOIAVBAWoiBiAQayAIayIHQX9zakEDSQ0AIBQgByAWa2ogBiAIayAHIA5JIgcbIg8oAAAgBigAAEcNACAFQQVqIA9BBGogCyASIAsgBxsgExAgIgdBe0sNACAHQQRqIgdBA2wgCUEDbCAMQQFqECRrQQFqTA0AQQAhDCAGIQQgByEJCyANQf+T69wDNgIIAn8CQCAAIAYgCyANQQhqEJsBIgdBBEkNACAMQQFqECQhFyAHQQJ0IA0oAggiD0EBahAkayAJQQJ0IBdrQQRqTA0AIA8hDCAHIQkgBgwBCyAGIBFPDQICQCAOIAVBAmoiBiAQayAIayIHQX9zakEDSQ0AIBQgByAWa2ogBiAIayAHIA5JIgcbIg8oAAAgBigAAEcNACAFQQZqIA9BBGogCyASIAsgBxsgExAgIgVBe0sNACAFQQRqIgVBAnQgCUECdEEBciAMQQFqECRrTA0AQQAhDCAGIQQgBSEJCyANQf+T69wDNgIEIAAgBiALIA1BBGoQmwEiBUEESQ0CIAxBAWoQJCEPIAVBAnQgDSgCBCIHQQFqECRrIAlBAnQgD2tBB2pMDQIgByEMIAUhCSAGCyIFIQQgBSARSQ0ACwsCfyAMRQRAIAQhBSAKIQYgCAwBCwJAIAQgA00EQCAEIQUMAQsgGCAQIAQiBSAMIBBqa0ECaiIGIA5JIgobIAZqIgYgGSATIAobIgpNDQADQCAEQX9qIgUtAAAgBkF/aiIGLQAARwRAIAQhBQwCCyAJQQFqIQkgBiAKTQ0BIAUhBCAFIANLDQALCyAIIQYgDEF+agshBCAJQX1qIQ8gBSADayEHIAEoAgwhCAJAAkAgBSAVTQRAIAggAxAcIAEoAgwhCiAHQRBNBEAgASAHIApqNgIMDAMLIApBEGogA0EQaiIIEBwgCkEgaiADQSBqEBwgB0ExSA0BIAcgCmohFyAKQTBqIQMDQCADIAhBIGoiChAcIANBEGogCEEwahAcIAohCCADQSBqIgMgF0kNAAsMAQsgCCADIAUgFRAiCyABIAEoAgwgB2o2AgwgB0GAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIAxBAWo2AgAgAyAHOwEEIA9BgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgDzsBBiABIANBCGo2AgQgBiEKIAQhCCAFIAlqIgMhBSADIBFLDQADQAJAIAYhCCAEIQYgDiADIBBrIAhrIgRBf3NqQQNJDQAgBCAYIBAgBCAOSSIFG2oiBCgAACADKAAARw0AIANBBGogBEEEaiALIBIgCyAFGyATECAiCUEBaiEFIAEoAgwhBAJAIAMgFU0EQCAEIAMQHAwBCyAEIAMgAyAVECILIAEoAgQiBEEBNgIAIARBADsBBCAFQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAU7AQYgASAEQQhqNgIEIAghBCAGIQogCUEEaiADaiIDIQUgAyARTQ0BDAILCyAIIQogBiEIIAMhBQsgBSARSQ0ACwsgAiAKNgIEIAIgCDYCACANQRBqJAAgCyADawvcDQESfyACKAIAIgUgAigCBCIHQQAgByADIAAoAgQgACgCDGoiFCADRmoiBiAUayIJSyIKGyAFIAlLIgkbIRZBACAFIAkbIQlBACAHIAobIQogBiADIARqIg5BeGoiFUkEQCAOQWBqIRMDQAJAAn8CQAJ/IAlFIAZBAWoiCCAJaygAACAIKAAAR3JFBEAgBkEFaiIEIAQgCWsgDhAdQQRqIQVBAAwBCwJAAkACQAJAAkACQCAAKAKEAUF7ag4DAQICAAsgACgCBCEPIAAoAnQhBSAAKAIQIQQgACgCFCEIIAAoAoABIQwgACgCKCEQIAAgACgCeCINIAAoAnwgBkEEECwiByAEIAYgD2siC0EBIAV0IgVrIAQgCyAEayAFSxsgCBsiEU0NA0EAIAtBASANdCIEayIFIAUgC0sbIQ0gBEF/aiESQQEgDHQhCEH/k+vcAyEMQQMhBANAAkAgByAPaiIFIARqLQAAIAQgBmotAABHDQAgBiAFIA4QHSIFIARNDQAgCyAHa0ECaiEMIAUiBCAGaiAORg0ECyAHIA1NBEAgBCEFDAQLIBAgByAScUECdGooAgAiByARTQRAIAQhBQwECyAEIQUgCEF/aiIIDQALDAILIAAoAgQhDyAAKAJ0IQUgACgCECEEIAAoAhQhCCAAKAKAASEMIAAoAighECAAIAAoAngiDSAAKAJ8IAZBBRAsIgcgBCAGIA9rIgtBASAFdCIFayAEIAsgBGsgBUsbIAgbIhFNDQJBACALQQEgDXQiBGsiBSAFIAtLGyENIARBf2ohEkEBIAx0IQhB/5Pr3AMhDEEDIQQDQAJAIAcgD2oiBSAEai0AACAEIAZqLQAARw0AIAYgBSAOEB0iBSAETQ0AIAsgB2tBAmohDCAFIgQgBmogDkYNAwsgByANTQRAIAQhBQwDCyAQIAcgEnFBAnRqKAIAIgcgEU0EQCAEIQUMAwsgBCEFIAhBf2oiCA0ACwwBCyAAKAIEIQ8gACgCdCEFIAAoAhAhBCAAKAIUIQggACgCgAEhDCAAKAIoIRAgACAAKAJ4Ig0gACgCfCAGQQYQLCIHIAQgBiAPayILQQEgBXQiBWsgBCALIARrIAVLGyAIGyIRTQ0BQQAgC0EBIA10IgRrIgUgBSALSxshDSAEQX9qIRJBASAMdCEIQf+T69wDIQxBAyEEA0ACQCAHIA9qIgUgBGotAAAgBCAGai0AAEcNACAGIAUgDhAdIgUgBE0NACALIAdrQQJqIQwgBSIEIAZqIA5GDQILIAcgDU0EQCAEIQUMAgsgECAHIBJxQQJ0aigCACIHIBFNBEAgBCEFDAILIAQhBSAIQX9qIggNAAsLIAVBA0sNAQsgBiADa0EIdSAGakEBaiEGDAQLIAwNASAGIQhBAAshDCAKIQcgCQwBCwJAIAYgA00EQCAGIQgMAQsgBiEIIAZBAiAMayIEaiAUTQ0AA0AgBkF/aiIILQAAIAQgBmpBf2otAABHBEAgBiEIDAILIAVBAWohBSAIIANNDQEgBCAIIgZqIBRLDQALCyAJIQcgDEF+agshBCAFQX1qIQsgCCADayEKIAEoAgwhBgJAAkAgCCATTQRAIAYgAxAcIAEoAgwhBiAKQRBNBEAgASAGIApqNgIMDAMLIAZBEGogA0EQaiIJEBwgBkEgaiADQSBqEBwgCkExSA0BIAYgCmohDyAGQTBqIQMDQCADIAlBIGoiBhAcIANBEGogCUEwahAcIAYhCSADQSBqIgMgD0kNAAsMAQsgBiADIAggExAiCyABIAEoAgwgCmo2AgwgCkGAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIAxBAWo2AgAgAyAKOwEEIAtBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgCzsBBiABIANBCGo2AgQgBSAIaiEDIAdFBEAgByEKIAQhCSADIQYMAQsgByEKIAQhCSADIgYgFUsNAANAIAchCSAEIQcgAygAACADIAlrKAAARwRAIAkhCiAHIQkgAyEGDAILIANBBGoiBCAEIAlrIA4QHSIGQQFqIQUgASgCDCEEAkAgAyATTQRAIAQgAxAcDAELIAQgAyADIBMQIgsgASgCBCIEQQE2AgAgBEEAOwEEIAVBgIAETwRAIAFBAjYCJCABIAQgASgCAGtBA3U2AigLIAQgBTsBBiABIARBCGo2AgQgBkEEaiADaiEDIAdFBEAgByEKIAMhBgwCCyAJIQQgByEKIAMiBiAVTQ0ACwsgBiAVSQ0ACwsgAiAKIBYgChs2AgQgAiAJIBYgCRs2AgAgDiADawtJAQF/IwBBIGsiAiQAIAJBCGogARCWASACQRhqIAJBCGogABEEACACQRhqEMgBIQAgAkEYahDFASACQQhqEJIBIAJBIGokACAAC4gWARZ/IAIoAgAiBSACKAIEIgZBACAGIAMgACgCBCAAKAIMaiIYIANGaiIHIBhrIgpLIgkbIAUgCksiChshGkEAIAUgChshCkEAIAYgCRshFCAHIAMgBGoiDkF4aiIVSQRAIA5BYGohFwNAQQAhDUEAIAprIRkgCkUgB0EBaiIPIAprKAAAIA8oAABHckUEQCAHQQVqIgQgBCAZaiAOEB1BBGohDQsCQAJAAkACQAJAIAAoAoQBQXtqDgMBAgIACyAAKAIEIQwgACgCdCEFIAAoAhAhBCAAKAIUIQkgACgCgAEhCCAAKAIoIRIgACAAKAJ4IhAgACgCfCAHQQQQLCIGIAQgByAMayILQQEgBXQiBWsgBCALIARrIAVLGyAJGyIRTQ0CQQAgC0EBIBB0IgRrIgUgBSALSxshECAEQX9qIRNBASAIdCEIQf+T69wDIQlBAyEEA0ACQCAGIAxqIgUgBGotAAAgBCAHai0AAEcNACAHIAUgDhAdIgUgBE0NACALIAZrQQJqIQkgByAFIgRqIA5GDQULIAYgEE0EQCAEIQUMBQsgEiAGIBNxQQJ0aigCACIGIBFNBEAgBCEFDAULIAQhBSAIQX9qIggNAAsMAwsgACgCBCEMIAAoAnQhBSAAKAIQIQQgACgCFCEJIAAoAoABIQggACgCKCESIAAgACgCeCIQIAAoAnwgB0EFECwiBiAEIAcgDGsiC0EBIAV0IgVrIAQgCyAEayAFSxsgCRsiEU0NAUEAIAtBASAQdCIEayIFIAUgC0sbIRAgBEF/aiETQQEgCHQhCEH/k+vcAyEJQQMhBANAAkAgBiAMaiIFIARqLQAAIAQgB2otAABHDQAgByAFIA4QHSIFIARNDQAgCyAGa0ECaiEJIAcgBSIEaiAORg0ECyAGIBBNBEAgBCEFDAQLIBIgBiATcUECdGooAgAiBiARTQRAIAQhBQwECyAEIQUgCEF/aiIIDQALDAILIAAoAgQhDCAAKAJ0IQUgACgCECEEIAAoAhQhCSAAKAKAASEIIAAoAighEiAAIAAoAngiECAAKAJ8IAdBBhAsIgYgBCAHIAxrIgtBASAFdCIFayAEIAsgBGsgBUsbIAkbIhFNDQBBACALQQEgEHQiBGsiBSAFIAtLGyEQIARBf2ohE0EBIAh0IQhB/5Pr3AMhCUEDIQQDQAJAIAYgDGoiBSAEai0AACAEIAdqLQAARw0AIAcgBSAOEB0iBSAETQ0AIAsgBmtBAmohCSAHIAUiBGogDkYNAwsgBiAQTQRAIAQhBQwDCyASIAYgE3FBAnRqKAIAIgYgEU0EQCAEIQUMAwsgBCEFIAhBf2oiCA0ACwwBC0EDIQVB/5Pr3AMhCQsCQCAFIA0gBSANSyIEGyILQQNNBEAgByADa0EIdSAHakEBaiEHDAELIAlBACAEGyEMIAcgDyAEGyEJAkAgByAVTw0AA0AgB0EBaiEFAkAgDEUEQEEAIQwMAQsgCkUgBSgAACAFIBlqKAAAR3INACAHQQVqIgQgBCAZaiAOEB0iBEF7Sw0AIARBBGoiBEEDbCALQQNsIAxBAWoQJGtBAWpMDQAgBSEJQQAhDCAEIQsLAkACQAJAAkAgACgChAFBe2oOAwECAgALIAAoAgQhEiAAKAJ0IQYgACgCECEEIAAoAhQhCCAAKAKAASENIAAoAighECAAIAAoAngiESAAKAJ8IAVBBBAsIgcgBCAFIBJrIg9BASAGdCIGayAEIA8gBGsgBksbIAgbIhNNDQRBACAPQQEgEXQiBGsiBiAGIA9LGyERIARBf2ohFkEBIA10IQhB/5Pr3AMhDUEDIQQDQAJAIAcgEmoiBiAEai0AACAEIAVqLQAARw0AIAUgBiAOEB0iBiAETQ0AIA8gB2tBAmohDSAFIAYiBGogDkYNBAsgByARTQRAIAQhBgwECyAQIAcgFnFBAnRqKAIAIgcgE00EQCAEIQYMBAsgBCEGIAhBf2oiCA0ACwwCCyAAKAIEIRIgACgCdCEGIAAoAhAhBCAAKAIUIQggACgCgAEhDSAAKAIoIRAgACAAKAJ4IhEgACgCfCAFQQUQLCIHIAQgBSASayIPQQEgBnQiBmsgBCAPIARrIAZLGyAIGyITTQ0DQQAgD0EBIBF0IgRrIgYgBiAPSxshESAEQX9qIRZBASANdCEIQf+T69wDIQ1BAyEEA0ACQCAHIBJqIgYgBGotAAAgBCAFai0AAEcNACAFIAYgDhAdIgYgBE0NACAPIAdrQQJqIQ0gBSAGIgRqIA5GDQMLIAcgEU0EQCAEIQYMAwsgECAHIBZxQQJ0aigCACIHIBNNBEAgBCEGDAMLIAQhBiAIQX9qIggNAAsMAQsgACgCBCESIAAoAnQhBiAAKAIQIQQgACgCFCEIIAAoAoABIQ0gACgCKCEQIAAgACgCeCIRIAAoAnwgBUEGECwiByAEIAUgEmsiD0EBIAZ0IgZrIAQgDyAEayAGSxsgCBsiE00NAkEAIA9BASARdCIEayIGIAYgD0sbIREgBEF/aiEWQQEgDXQhCEH/k+vcAyENQQMhBANAAkAgByASaiIGIARqLQAAIAQgBWotAABHDQAgBSAGIA4QHSIGIARNDQAgDyAHa0ECaiENIAUgBiIEaiAORg0CCyAHIBFNBEAgBCEGDAILIBAgByAWcUECdGooAgAiByATTQRAIAQhBgwCCyAEIQYgCEF/aiIIDQALCyAGQQRJDQEgDEEBahAkIQQgBkECdCANQQFqECRrIAtBAnQgBGtBBGpMDQEgBiELIA0hDCAFIgchCSAFIBVJDQALCwJ/IAxFBEAgCSEHIAohBiAUDAELAkAgCSADTQRAIAkhBwwBC0ECIAxrIgQgCSIHaiAYTQ0AA0AgCUF/aiIHLQAAIAQgCWpBf2otAABHBEAgCSEHDAILIAtBAWohCyAHIANNDQEgByEJIAQgB2ogGEsNAAsLIAxBfmohBiAKCyEFIAtBfWohCSAHIANrIQogASgCDCEEAkACQCAHIBdNBEAgBCADEBwgASgCDCEEIApBEE0EQCABIAQgCmo2AgwMAwsgBEEQaiADQRBqIggQHCAEQSBqIANBIGoQHCAKQTFIDQEgBCAKaiEUIARBMGohBANAIAQgCEEgaiIDEBwgBEEQaiAIQTBqEBwgAyEIIARBIGoiBCAUSQ0ACwwBCyAEIAMgByAXECILIAEgASgCDCAKajYCDCAKQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyABKAIEIgMgDEEBajYCACADIAo7AQQgCUGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAJOwEGIAEgA0EIajYCBCAHIAtqIQMgBUUEQCAFIRQgBiEKIAMhBwwBCyAFIRQgBiEKIAMiByAVSw0AA0AgBSEKIAYhBSADKAAAIAMgCmsoAABHBEAgCiEUIAUhCiADIQcMAgsgA0EEaiIEIAQgCmsgDhAdIgdBAWohBiABKAIMIQQCQCADIBdNBEAgBCADEBwMAQsgBCADIAMgFxAiCyABKAIEIgRBATYCACAEQQA7AQQgBkGAgARPBEAgAUECNgIkIAEgBCABKAIAa0EDdTYCKAsgBCAGOwEGIAEgBEEIajYCBCAHQQRqIANqIQMgBUUEQCAFIRQgAyEHDAILIAohBiAFIRQgAyIHIBVNDQALCyAHIBVJDQALCyACIBQgGiAUGzYCBCACIAogGiAKGzYCACAOIANrC6keARd/IAIoAgAiBSACKAIEIgZBACAGIAMgACgCBCAAKAIMaiIaIANGaiIIIBprIgdLIgsbIAUgB0siBxshG0EAIAUgBxshE0EAIAYgCxshFSAIIAMgBGoiEEF4aiIWSQRAIBBBYGohGQNAQQAhDEEAIBNrIRcgE0UgCEEBaiIOIBNrKAAAIA4oAABHckUEQCAIQQVqIgQgBCAXaiAQEB1BBGohDAsCQAJAAkACQAJAIAAoAoQBQXtqDgMBAgIACyAAKAIEIQogACgCdCEFIAAoAhAhBCAAKAIUIQcgACgCgAEhCSAAKAIoIQ0gACAAKAJ4Ig8gACgCfCAIQQQQLCIGIAQgCCAKayILQQEgBXQiBWsgBCALIARrIAVLGyAHGyIRTQ0CQQAgC0EBIA90IgRrIgUgBSALSxshDyAEQX9qIRJBASAJdCEHQf+T69wDIQlBAyEEA0ACQCAGIApqIgUgBGotAAAgBCAIai0AAEcNACAIIAUgEBAdIgUgBE0NACALIAZrQQJqIQkgCCAFIgRqIBBGDQULIAYgD00EQCAEIQUMBQsgDSAGIBJxQQJ0aigCACIGIBFNBEAgBCEFDAULIAQhBSAHQX9qIgcNAAsMAwsgACgCBCEKIAAoAnQhBSAAKAIQIQQgACgCFCEHIAAoAoABIQkgACgCKCENIAAgACgCeCIPIAAoAnwgCEEFECwiBiAEIAggCmsiC0EBIAV0IgVrIAQgCyAEayAFSxsgBxsiEU0NAUEAIAtBASAPdCIEayIFIAUgC0sbIQ8gBEF/aiESQQEgCXQhB0H/k+vcAyEJQQMhBANAAkAgBiAKaiIFIARqLQAAIAQgCGotAABHDQAgCCAFIBAQHSIFIARNDQAgCyAGa0ECaiEJIAggBSIEaiAQRg0ECyAGIA9NBEAgBCEFDAQLIA0gBiAScUECdGooAgAiBiARTQRAIAQhBQwECyAEIQUgB0F/aiIHDQALDAILIAAoAgQhCiAAKAJ0IQUgACgCECEEIAAoAhQhByAAKAKAASEJIAAoAighDSAAIAAoAngiDyAAKAJ8IAhBBhAsIgYgBCAIIAprIgtBASAFdCIFayAEIAsgBGsgBUsbIAcbIhFNDQBBACALQQEgD3QiBGsiBSAFIAtLGyEPIARBf2ohEkEBIAl0IQdB/5Pr3AMhCUEDIQQDQAJAIAYgCmoiBSAEai0AACAEIAhqLQAARw0AIAggBSAQEB0iBSAETQ0AIAsgBmtBAmohCSAIIAUiBGogEEYNAwsgBiAPTQRAIAQhBQwDCyANIAYgEnFBAnRqKAIAIgYgEU0EQCAEIQUMAwsgBCEFIAdBf2oiBw0ACwwBC0EDIQVB/5Pr3AMhCQsCQCAFIAwgBSAMSyIEGyIFQQNNBEAgCCADa0EIdSAIakEBaiEIDAELIAggDiAEGyELIAlBACAEGyIMIQ4gBSEJAkAgCCAWTw0AA0AgCEEBaiEJAkAgDEUEQEEAIQwMAQsgE0UgCSgAACAJIBdqKAAAR3INACAIQQVqIgQgBCAXaiAQEB0iBEF7Sw0AIARBBGoiBEEDbCAFQQNsIAxBAWoQJGtBAWpMDQAgCSELQQAhDCAEIQULAkACQAJAAkACQAJAIAAoAoQBQXtqDgMBAgIACyAAKAIEIQ8gACgCdCEHIAAoAhAhBiAAKAIUIQ4gACgCgAEhCiAAKAIoIREgACAAKAJ4IhIgACgCfCAJQQQQLCIEIAYgCSAPayINQQEgB3QiB2sgBiANIAZrIAdLGyAOGyIUTQ0DQQAgDUEBIBJ0IgZrIgcgByANSxshEiAGQX9qIRhBASAKdCEKQf+T69wDIQ5BAyEGA0ACQCAEIA9qIgcgBmotAAAgBiAJai0AAEcNACAJIAcgEBAdIgcgBk0NACANIARrQQJqIQ4gCSAHIgZqIBBGDQQLIAQgEk0EQCAGIQcMBAsgESAEIBhxQQJ0aigCACIEIBRNBEAgBiEHDAQLIAYhByAKQX9qIgoNAAsMAgsgACgCBCEPIAAoAnQhByAAKAIQIQYgACgCFCEOIAAoAoABIQogACgCKCERIAAgACgCeCISIAAoAnwgCUEFECwiBCAGIAkgD2siDUEBIAd0IgdrIAYgDSAGayAHSxsgDhsiFE0NAkEAIA1BASASdCIGayIHIAcgDUsbIRIgBkF/aiEYQQEgCnQhCkH/k+vcAyEOQQMhBgNAAkAgBCAPaiIHIAZqLQAAIAYgCWotAABHDQAgCSAHIBAQHSIHIAZNDQAgDSAEa0ECaiEOIAkgByIGaiAQRg0DCyAEIBJNBEAgBiEHDAMLIBEgBCAYcUECdGooAgAiBCAUTQRAIAYhBwwDCyAGIQcgCkF/aiIKDQALDAELIAAoAgQhDyAAKAJ0IQcgACgCECEGIAAoAhQhDiAAKAKAASEKIAAoAighESAAIAAoAngiEiAAKAJ8IAlBBhAsIgQgBiAJIA9rIg1BASAHdCIHayAGIA0gBmsgB0sbIA4bIhRNDQFBACANQQEgEnQiBmsiByAHIA1LGyESIAZBf2ohGEEBIAp0IQpB/5Pr3AMhDkEDIQYDQAJAIAQgD2oiByAGai0AACAGIAlqLQAARw0AIAkgByAQEB0iByAGTQ0AIA0gBGtBAmohDiAJIAciBmogEEYNAgsgBCASTQRAIAYhBwwCCyARIAQgGHFBAnRqKAIAIgQgFE0EQCAGIQcMAgsgBiEHIApBf2oiCg0ACwsgB0EESQ0AIAxBAWoQJCEEIAdBAnQgDkEBahAkayAFQQJ0IARrQQRqTA0AIAkhCCAOIQwgByEFDAELIAkgFk8EQCAMIQ4gBSEJDAMLIAhBAmohBkEAIQ4CfyAFIAxFDQAaAkAgE0UgBigAACAGIBdqKAAAR3INACAIQQZqIgQgBCAXaiAQEB0iBEF7Sw0AIAwhDiAFIARBBGoiBEECdCAFQQJ0QQFyIAxBAWoQJGtMDQEaIAYhC0EAIQ4gBAwBCyAMIQ4gBQshCQJAAkACQAJAIAAoAoQBQXtqDgMBAgIACyAAKAIEIQ0gACgCdCEFIAAoAhAhBCAAKAIUIQcgACgCgAEhDCAAKAIoIQ8gACAAKAJ4IhEgACgCfCAGQQQQLCIIIAQgBiANayIKQQEgBXQiBWsgBCAKIARrIAVLGyAHGyISTQ0FQQAgCkEBIBF0IgRrIgUgBSAKSxshESAEQX9qIRRBASAMdCEHQf+T69wDIQxBAyEEA0ACQCAIIA1qIgUgBGotAAAgBCAGai0AAEcNACAGIAUgEBAdIgUgBE0NACAKIAhrQQJqIQwgBiAFIgRqIBBGDQQLIAggEU0EQCAEIQUMBAsgDyAIIBRxQQJ0aigCACIIIBJNBEAgBCEFDAQLIAQhBSAHQX9qIgcNAAsMAgsgACgCBCENIAAoAnQhBSAAKAIQIQQgACgCFCEHIAAoAoABIQwgACgCKCEPIAAgACgCeCIRIAAoAnwgBkEFECwiCCAEIAYgDWsiCkEBIAV0IgVrIAQgCiAEayAFSxsgBxsiEk0NBEEAIApBASARdCIEayIFIAUgCksbIREgBEF/aiEUQQEgDHQhB0H/k+vcAyEMQQMhBANAAkAgCCANaiIFIARqLQAAIAQgBmotAABHDQAgBiAFIBAQHSIFIARNDQAgCiAIa0ECaiEMIAYgBSIEaiAQRg0DCyAIIBFNBEAgBCEFDAMLIA8gCCAUcUECdGooAgAiCCASTQRAIAQhBQwDCyAEIQUgB0F/aiIHDQALDAELIAAoAgQhDSAAKAJ0IQUgACgCECEEIAAoAhQhByAAKAKAASEMIAAoAighDyAAIAAoAngiESAAKAJ8IAZBBhAsIgggBCAGIA1rIgpBASAFdCIFayAEIAogBGsgBUsbIAcbIhJNDQNBACAKQQEgEXQiBGsiBSAFIApLGyERIARBf2ohFEEBIAx0IQdB/5Pr3AMhDEEDIQQDQAJAIAggDWoiBSAEai0AACAEIAZqLQAARw0AIAYgBSAQEB0iBSAETQ0AIAogCGtBAmohDCAGIAUiBGogEEYNAgsgCCARTQRAIAQhBQwCCyAPIAggFHFBAnRqKAIAIgggEk0EQCAEIQUMAgsgBCEFIAdBf2oiBw0ACwsgBUEESQ0CIA5BAWoQJCEEIAYhCCAFQQJ0IAxBAWoQJGsgCUECdCAEa0EHakwNAgsgCCELIAwhDiAFIQkgCCAWSQ0ACwsCfyAORQRAIAshBSAVIQYgEwwBCwJAIAsgA00EQCALIQUMAQtBAiAOayIEIAsiBWogGk0NAANAIAtBf2oiBS0AACAEIAtqQX9qLQAARwRAIAshBQwCCyAJQQFqIQkgBSADTQ0BIAUhCyAEIAVqIBpLDQALCyATIQYgDkF+agshBCAJQX1qIRMgBSADayELIAEoAgwhBwJAAkAgBSAZTQRAIAcgAxAcIAEoAgwhCCALQRBNBEAgASAIIAtqNgIMDAMLIAhBEGogA0EQaiIHEBwgCEEgaiADQSBqEBwgC0ExSA0BIAggC2ohFSAIQTBqIQgDQCAIIAdBIGoiAxAcIAhBEGogB0EwahAcIAMhByAIQSBqIgggFUkNAAsMAQsgByADIAUgGRAiCyABIAEoAgwgC2o2AgwgC0GAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIA5BAWo2AgAgAyALOwEEIBNBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgEzsBBiABIANBCGo2AgQgBSAJaiEDIAZFBEAgBiEVIAQhEyADIQgMAQsgBiEVIAQhEyADIgggFksNAANAIAYhEyAEIQYgAygAACADIBNrKAAARwRAIBMhFSAGIRMgAyEIDAILIANBBGoiBCAEIBNrIBAQHSIHQQFqIQUgASgCDCEEAkAgAyAZTQRAIAQgAxAcDAELIAQgAyADIBkQIgsgASgCBCIEQQE2AgAgBEEAOwEEIAVBgIAETwRAIAFBAjYCJCABIAQgASgCAGtBA3U2AigLIAQgBTsBBiABIARBCGo2AgQgB0EEaiADaiEDIAZFBEAgBiEVIAMhCAwCCyATIQQgBiEVIAMiCCAWTQ0ACwsgCCAWSQ0ACwsgAiAVIBsgFRs2AgQgAiATIBsgExs2AgAgECADawvyAgEPfwJAIAAoAnAiBygCICABIAcoAnwgBhBaQQJ0aigCACIGIAcoAhAiCk0NACAHKAIAIg8gBygCBCIMayILQX8gBygCeEF/anRBf3MiDWsgCiALIAprIA1LGyEOIAAoAgQiCSAAKAIMaiEQIAEgCWsiCEECaiERIAhBAWohEiAJIAAoAhAgC2siE2ohFCAHKAIoIRVBACEAQQAhCQNAIAEgCSAAIAkgAEkbIgdqIAYgDGogB2ogAiAPIBAQICAHaiIHIARLBEAgByAEa0ECdCASIAYgE2oiCGsQJCADKAIAQQFqECRrSgRAIAMgESAIazYCACAHIQQLIAEgB2ogAkYNAgsgFSAGIA1xQQN0aiEIAkAgDCAUIAYgB2ogC0kbIAZqIAdqLQAAIAEgB2otAABJBEAgBiAOTQ0DIAhBBGohCCAHIQkgACEHDAELIAYgDk0NAgsgCCgCACIGIApNDQEgByEAIAVBf2oiBQ0ACwsgBAvDAwETfyMAQRBrIgwkACAAKAIoIhJBfyAAKAJ4QX9qdEF/cyITIAFxQQN0aiIIQQRqIQoCQCADRSAIKAIAIgYgAUEBIAAoAnR0IglrIAAoAhAiByABIAdrIAlLGyIUTXINACAAKAIIIg0gACgCDCIHaiIVIAIgByABSyIQGyEOIAAoAgQiCyAHaiEWIA0gCyAQGyABaiEPQQAhAiAFQQFGIRdBACEJA0ACQCAQIAVBAUdyRUEAIAIgCSACIAlJGyIAIAZqIgEgB0kbRQRAIAAgD2ogDSALIAEgB0kbIAsgFxsgBmoiESAAaiAOEB0gAGohAAwBCyAGIA1qIgEgBiALaiAAIA9qIAAgAWogDiAVIBYQICAAaiIAIAZqIAdJGyERCyAAIA9qIhggDkYNASASIAYgE3FBA3RqIQECQAJAIAAgEWotAAAgGC0AAEkEQCAIIAY2AgAgBiAESw0BIAxBDGohCAwECyAKIAY2AgAgBiAESwRAIAEhCiAAIQkMAgsgDEEMaiEKDAMLIAFBBGoiASEIIAAhAgsgASgCACIGIBRNDQEgA0F/aiIDDQALCyAKQQA2AgAgCEEANgIAIAxBEGokAAv7CgEQfyMAQRBrIgwkACACKAIAIgYgAigCBCIIQQAgCCADIAAoAgQgACgCDGoiEiADRmoiBSASayIHSyIJGyAGIAdLIgcbIRNBACAGIAcbIQdBACAIIAkbIQggBSADIARqIg1BeGoiD0kEQCANQWBqIREDQEEAIQZBACAHayEOIAdFIAVBAWoiCSAHaygAACAJKAAAR3JFBEAgBUEFaiIEIAQgDmogDRAdQQRqIQYLIAxB/5Pr3AM2AgwCQCAAIAUgDSAMQQxqEJwBIgQgBiAEIAZLIgYbIgtBA00EQCAFIANrQQh1IAVqQQFqIQUMAQsgDCgCDEEAIAYbIQQgBSAJIAYbIQYCQCAFIA9PDQADQCAFQQFqIQkCQCAERQRAQQAhBAwBCyAHRSAJKAAAIAkgDmooAABHcg0AIAVBBWoiCiAKIA5qIA0QHSIKQXtLDQAgCkEEaiIKQQNsIAtBA2wgBEEBahAka0EBakwNACAJIQZBACEEIAohCwsgDEH/k+vcAzYCCAJ/AkAgACAJIA0gDEEIahCcASIKQQRJDQAgBEEBahAkIRAgCkECdCAMKAIIIhRBAWoQJGsgC0ECdCAQa0EEakwNACAJIQUgCiELIBQMAQsgCSAPTw0CIAVBAmohCQJAIARFBEBBACEEDAELIAdFIAkoAAAgCSAOaigAAEdyDQAgBUEGaiIFIAUgDmogDRAdIgVBe0sNACAFQQRqIgVBAnQgC0ECdEEBciAEQQFqECRrTA0AIAkhBkEAIQQgBSELCyAMQf+T69wDNgIEIAAgCSANIAxBBGoQnAEiCkEESQ0CIARBAWoQJCEFIApBAnQgDCgCBCIQQQFqECRrIAtBAnQgBWtBB2pMDQIgCSEFIAohCyAQCyEEIAUhBiAFIA9JDQALCwJ/IARFBEAgBiEFIAchCSAIDAELAkAgBiADTQRAIAYhBQwBC0ECIARrIgggBiIFaiASTQ0AA0AgBkF/aiIFLQAAIAYgCGpBf2otAABHBEAgBiEFDAILIAtBAWohCyAFIANNDQEgBSEGIAUgCGogEksNAAsLIARBfmohCSAHCyEGIAtBfWohDiAFIANrIQogASgCDCEHAkACQCAFIBFNBEAgByADEBwgASgCDCEIIApBEE0EQCABIAggCmo2AgwMAwsgCEEQaiADQRBqIgcQHCAIQSBqIANBIGoQHCAKQTFIDQEgCCAKaiEQIAhBMGohAwNAIAMgB0EgaiIIEBwgA0EQaiAHQTBqEBwgCCEHIANBIGoiAyAQSQ0ACwwBCyAHIAMgBSARECILIAEgASgCDCAKajYCDCAKQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyABKAIEIgMgBEEBajYCACADIAo7AQQgDkGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAOOwEGIAEgA0EIajYCBCAFIAtqIQMgBkUEQCAGIQggCSEHIAMhBQwBCyAGIQggCSEHIAMhBSADIA9LDQADQCAGIQcgCSEGIAMoAAAgAyAHaygAAEcEQCAHIQggBiEHIAMhBQwCCyADQQRqIgQgBCAHayANEB0iCEEBaiEFIAEoAgwhBAJAIAMgEU0EQCAEIAMQHAwBCyAEIAMgAyARECILIAEoAgQiBEEBNgIAIARBADsBBCAFQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAU7AQYgASAEQQhqNgIEIAhBBGogA2ohAyAGRQRAIAYhCCADIQUMAgsgByEJIAYhCCADIQUgAyAPTQ0ACwsgBSAPSQ0ACwsgAiAIIBMgCBs2AgQgAiAHIBMgBxs2AgAgDEEQaiQAIA0gA2sLphQBF38gACgCfCERIAAoAiAhEiAAKAIIIQ0gACgCiAEiCSAJRWohFyADIARqIg5BeGohEyACKAIEIQYgAigCACEJAkAgACgCECAAKAIUIAMgACgCBCIMayAEaiIEIAAoAnQiBxAnIg8gACgCDCIASQRAIBMgA0sEQCANIA8gACAAIA9JGyIUaiEVIAwgFGohFiANIA9qIRwgDkFgaiEQIBRBf2ohGCADIQADQCASIAMgESAFEB5BAnRqIgQoAgAhCiAEIAMgDGsiGTYCAAJAAkACQAJAIAMgCSAMamtBAWoiBCAPTSAYIARrQQNJckUEQCAEIA0gDCAEIBRJIgcbaiIEKAAAIANBAWoiCygAAEYNAQsgCiAPTwRAIA0gDCAKIBRJIgQbIApqIgcoAAAgAygAAEYNAgsgAyAXIAMgAGtBCHVqaiEDDAMLIANBBWogBEEEaiAOIBUgDiAHGyAWECAiGkEBaiEKIAsgAGshCCABKAIMIQQCQAJAIAsgEE0EQCAEIAAQHCABKAIMIQcgCEEQTQRAIAEgByAIajYCDAwDCyAHQRBqIABBEGoiBBAcIAdBIGogAEEgahAcIAhBMUgNASAHIAhqIRsgB0EwaiEAA0AgACAEQSBqIgcQHCAAQRBqIARBMGoQHCAHIQQgAEEgaiIAIBtJDQALDAELIAQgACALIBAQIgsgASABKAIMIAhqNgIMIAhBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAEEBNgIAIAAgCDsBBCAKQYCABE8EQCABQQI2AiQgASAAIAEoAgBrQQN1NgIoCyAAIAo7AQYgASAAQQhqNgIEIBpBBGogC2ohAAwBCyADQQRqIAdBBGogDiAVIA4gBBsgFhAgQQRqIQYCQCAHIBwgFiAEGyILTQRAIAMhBAwBCyADIQggAyEEIAMgAE0NAANAIAhBf2oiBC0AACAHQX9qIgctAABHBEAgCCEEDAILIAZBAWohBiAHIAtNDQEgBCEIIAQgAEsNAAsLIBkgCmshCCAGQX1qIRogBCAAayELIAEoAgwhBwJAAkAgBCAQTQRAIAcgABAcIAEoAgwhCiALQRBNBEAgASAKIAtqNgIMDAMLIApBEGogAEEQaiIHEBwgCkEgaiAAQSBqEBwgC0ExSA0BIAogC2ohGyAKQTBqIQADQCAAIAdBIGoiChAcIABBEGogB0EwahAcIAohByAAQSBqIgAgG0kNAAsMAQsgByAAIAQgEBAiCyABIAEoAgwgC2o2AgwgC0GAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIAIAhBA2o2AgAgACALOwEEIBpBgIAETwRAIAFBAjYCJCABIAAgASgCAGtBA3U2AigLIAAgGjsBBiABIABBCGo2AgQgBCAGaiEAIAkhBiAIIQkLIAAgE0sEQCAAIQMMAQsgEiADQQJqIBEgBRAeQQJ0aiAZQQJqNgIAIBIgAEF+aiIDIBEgBRAeQQJ0aiADIAxrNgIAIAkhByAGIQQDQAJAIAQhCSAHIQQgACAMayIGIAlrIgMgD00gGCADa0EDSXINACADIA0gDCADIBRJIgcbaiIDKAAAIAAoAABHDQAgAEEEaiADQQRqIA4gFSAOIAcbIBYQICIIQQFqIQcgASgCDCEDAkAgACAQTQRAIAMgABAcDAELIAMgACAAIBAQIgsgASgCBCIDQQE2AgAgA0EAOwEEIAdBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBzsBBiABIANBCGo2AgQgEiAAIBEgBRAeQQJ0aiAGNgIAIAkhByAEIQYgCEEEaiAAaiIAIQMgACATTQ0BDAILCyAJIQYgBCEJIAAhAwsgAyATSQ0ACyAAIQMLIAIgCTYCAAwBCyAJIAZBACAGIAMgDCAEQQEgB3QiB2sgACAEIABrIAdLGyIUaiIQIANGaiIAIBBrIgRLIggbIAkgBEsiBBshFkEAIAkgBBshB0EAIAYgCBshCSAAQQFqIgQgE0kEQCAXQQFqIRcgDkFgaiEPA0AgACARIAUQHiEGIAAoAAAhCyAEIBEgBRAeIQggBCgAACEVIBIgCEECdGoiCigCACEIIBIgBkECdGoiDSgCACEGIA0gACAMayIYNgIAIAogBCAMazYCAAJ/AkAgB0UgAEECaiINIAdrIgooAAAgDSgAAEdyRQRAIAogAC0AASAKQX9qLQAARiIEayEGIA0gBGshAEEAIRUMAQsCQAJAAkAgBiAUSwRAIAsgBiAMaiIGKAAARg0BCyAIIBRNDQEgFSAIIAxqIgYoAABHDQEgBCEACyAAIAZrIgpBAmohFUEAIQQgBiAQTSAAIANNcg0BA0AgAEF/aiIILQAAIAZBf2oiCy0AAEcNAiAEQQFqIQQgCCADSwRAIAghACALIgYgEEsNAQsLIAchCSALIQYgCiEHIAghAAwCCyAEIBcgACADa0EHdmoiBmohBCAAIAZqDAILIAchCSAKIQcLIAAgBGpBBGogBCAGakEEaiAOEB0gBGoiC0EBaiEKIAAgA2shCCABKAIMIQQCQAJAIAAgD00EQCAEIAMQHCABKAIMIQYgCEEQTQRAIAEgBiAIaiIGNgIMDAMLIAZBEGogA0EQaiIEEBwgBkEgaiADQSBqEBwgCEExSA0BIAYgCGohGSAGQTBqIQMDQCADIARBIGoiBhAcIANBEGogBEEwahAcIAYhBCADQSBqIgMgGUkNAAsMAQsgBCADIAAgDxAiCyABIAEoAgwgCGoiBjYCDCAIQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyABKAIEIgMgFUEBajYCACADIAg7AQQgCkGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAKOwEGIAEgA0EIajYCBCALQQRqIABqIgNBAWohBAJAIAMgE0sNACASIA0gESAFEB5BAnRqIBhBAmo2AgAgEiADQX5qIgAgESAFEB5BAnRqIAAgDGs2AgAgCUUEQEEAIQkMAQsgAygAACADIAlrKAAARw0AQQAgCWshBANAIAkhACAHIQkgACEHIANBBGoiACAAIARqIA4QHSEEIBIgAyARIAUQHkECdGogAyAMazYCACAEQQFqIQgCQCADIA9NBEAgBiADEBwMAQsgBiADIAMgDxAiCyABKAIEIgBBATYCACAAQQA7AQQgCEGAgARPBEAgAUECNgIkIAEgACABKAIAa0EDdTYCKAsgACAIOwEGIAEgAEEIajYCBAJAIAlFIAMgBGpBBGoiAyATS3INACADKAAAIAMgCWsoAABHDQBBACAJayEEIAEoAgwhBgwBCwsgA0EBaiEECyADCyEAIAQgE0kNAAsLIAIgByAWIAcbNgIAIAkgFiAJGyEGCyACIAY2AgQgDiADawsiACAAIAEgAiADIAQgACgChAEiAEEEIABBe2pBA0kbEL4DC486ARt/AkACQAJAAkACQCAAKAKEAUF7ag4DAwIBAAsgAigCBCEFIAIoAgAhCiADIAAoAnAiBigCACIRIAMgACgCBCIOIAAoAgwiD2oiEmtqIAYoAgQiEyAGKAIMIhdqIhxGaiIHIAMgBGoiDUF4aiIWSQRAIAAoAogBIgQgBEVqIRggACgCfCEUIAYoAnwhHSAAKAIgIRUgBigCICEeIBMgEyARayAPaiIZayEfIA1BYGohDCAPQX9qIRoDQCAVIAcgFEEEEB5BAnRqIgAoAgAhCyAAIAcgDmsiGzYCAAJAAkACQCAaIAdBAWoiACAKIA5qayIEa0EDSQ0AIBMgBCAZa2ogACAKayAEIA9JIgQbIgYoAAAgACgAAEcNACAHQQVqIAZBBGogDSARIA0gBBsgEhAgIglBAWohCyAAIANrIQggASgCDCEEAkACQCAAIAxNBEAgBCADEBwgASgCDCEGIAhBEE0EQCABIAYgCGo2AgwMAwsgBkEQaiADQRBqIgQQHCAGQSBqIANBIGoQHCAIQTFIDQEgBiAIaiEQIAZBMGohAwNAIAMgBEEgaiIGEBwgA0EQaiAEQTBqEBwgBiEEIANBIGoiAyAQSQ0ACwwBCyAEIAMgACAMECILIAEgASgCDCAIajYCDCAIQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyAJQQRqIQQgASgCBCIDQQE2AgAgAyAIOwEEIAtBgIAESQ0BIAFBAjYCJCABIAMgASgCAGtBA3U2AigMAQsCQCALIA9NBEACQCAeIAcgHUEEEB5BAnRqKAIAIgggF00NACAIIBNqIgYoAAAgBygAAEcNACAHQQRqIAZBBGogDSARIBIQIEEEaiEEIBsgCGshCwJAIAcgA00EQCAHIQAMAQsgByEFIAchACAIIBdMDQADQCAFQX9qIgAtAAAgBkF/aiIGLQAARwRAIAUhAAwCCyAEQQFqIQQgACADTQ0BIAAhBSAGIBxLDQALCyALIBlrIQYgBEF9aiELIAAgA2shCSABKAIMIQUCQAJAIAAgDE0EQCAFIAMQHCABKAIMIQggCUEQTQRAIAEgCCAJajYCDAwDCyAIQRBqIANBEGoiBRAcIAhBIGogA0EgahAcIAlBMUgNASAIIAlqIRAgCEEwaiEDA0AgAyAFQSBqIggQHCADQRBqIAVBMGoQHCAIIQUgA0EgaiIDIBBJDQALDAELIAUgAyAAIAwQIgsgASABKAIMIAlqNgIMIAlBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAyAGQQNqNgIAIAMgCTsBBCALQYCABEkNAiABQQI2AiQgASADIAEoAgBrQQN1NgIoDAILIAcgByADa0EIdSAYamohBwwDCyALIA5qIggoAAAgBygAAEcEQCAHIAcgA2tBCHUgGGpqIQcMAwsgB0EEaiAIQQRqIA0QHUEEaiEEAkAgByADTQRAIAchAAwBCyAHIQYgCCEFIAchACALIA9MDQADQCAGQX9qIgAtAAAgBUF/aiIFLQAARwRAIAYhAAwCCyAEQQFqIQQgACADTQ0BIAAhBiAFIBJLDQALCyAHIAhrIQYgBEF9aiELIAAgA2shCSABKAIMIQUCQAJAIAAgDE0EQCAFIAMQHCABKAIMIQggCUEQTQRAIAEgCCAJajYCDAwDCyAIQRBqIANBEGoiBRAcIAhBIGogA0EgahAcIAlBMUgNASAIIAlqIRAgCEEwaiEDA0AgAyAFQSBqIggQHCADQRBqIAVBMGoQHCAIIQUgA0EgaiIDIBBJDQALDAELIAUgAyAAIAwQIgsgASABKAIMIAlqNgIMIAlBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAyAGQQNqNgIAIAMgCTsBBCALQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyAKIQUgBiEKDAELIAohBSAGIQoLIAMgCzsBBiABIANBCGo2AgQgACAEaiIDIBZLBEAgAyEHDAELIBUgB0ECaiAUQQQQHkECdGogG0ECajYCACAVIANBfmoiACAUQQQQHkECdGogACAOazYCACAKIQQgBSEAA0ACQCAAIQogBCEAIBogAyAOayIHIAprIgRrQQNJDQAgBCAfIA4gBCAPSSIFG2oiBCgAACADKAAARw0AIANBBGogBEEEaiANIBEgDSAFGyASECAiBkEBaiEFIAEoAgwhBAJAIAMgDE0EQCAEIAMQHAwBCyAEIAMgAyAMECILIAEoAgQiBEEBNgIAIARBADsBBCAFQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAU7AQYgASAEQQhqNgIEIBUgAyAUQQQQHkECdGogBzYCACAKIQQgACEFIAZBBGogA2oiAyEHIAMgFk0NAQwCCwsgCiEFIAAhCiADIQcLIAcgFkkNAAsLDAMLIAIoAgQhBSACKAIAIQogAyAAKAJwIgYoAgAiESADIAAoAgQiDiAAKAIMIg9qIhJraiAGKAIEIhMgBigCDCIXaiIcRmoiByADIARqIg1BeGoiFkkEQCAAKAKIASIEIARFaiEYIAAoAnwhFCAGKAJ8IR0gACgCICEVIAYoAiAhHiATIBMgEWsgD2oiGWshHyANQWBqIQwgD0F/aiEaA0AgFSAHIBRBBxAeQQJ0aiIAKAIAIQsgACAHIA5rIhs2AgACQAJAAkAgGiAHQQFqIgAgCiAOamsiBGtBA0kNACATIAQgGWtqIAAgCmsgBCAPSSIEGyIGKAAAIAAoAABHDQAgB0EFaiAGQQRqIA0gESANIAQbIBIQICIJQQFqIQsgACADayEIIAEoAgwhBAJAAkAgACAMTQRAIAQgAxAcIAEoAgwhBiAIQRBNBEAgASAGIAhqNgIMDAMLIAZBEGogA0EQaiIEEBwgBkEgaiADQSBqEBwgCEExSA0BIAYgCGohECAGQTBqIQMDQCADIARBIGoiBhAcIANBEGogBEEwahAcIAYhBCADQSBqIgMgEEkNAAsMAQsgBCADIAAgDBAiCyABIAEoAgwgCGo2AgwgCEGAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgCUEEaiEEIAEoAgQiA0EBNgIAIAMgCDsBBCALQYCABEkNASABQQI2AiQgASADIAEoAgBrQQN1NgIoDAELAkAgCyAPTQRAAkAgHiAHIB1BBxAeQQJ0aigCACIIIBdNDQAgCCATaiIGKAAAIAcoAABHDQAgB0EEaiAGQQRqIA0gESASECBBBGohBCAbIAhrIQsCQCAHIANNBEAgByEADAELIAchBSAHIQAgCCAXTA0AA0AgBUF/aiIALQAAIAZBf2oiBi0AAEcEQCAFIQAMAgsgBEEBaiEEIAAgA00NASAAIQUgBiAcSw0ACwsgCyAZayEGIARBfWohCyAAIANrIQkgASgCDCEFAkACQCAAIAxNBEAgBSADEBwgASgCDCEIIAlBEE0EQCABIAggCWo2AgwMAwsgCEEQaiADQRBqIgUQHCAIQSBqIANBIGoQHCAJQTFIDQEgCCAJaiEQIAhBMGohAwNAIAMgBUEgaiIIEBwgA0EQaiAFQTBqEBwgCCEFIANBIGoiAyAQSQ0ACwwBCyAFIAMgACAMECILIAEgASgCDCAJajYCDCAJQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyABKAIEIgMgBkEDajYCACADIAk7AQQgC0GAgARJDQIgAUECNgIkIAEgAyABKAIAa0EDdTYCKAwCCyAHIAcgA2tBCHUgGGpqIQcMAwsgCyAOaiIIKAAAIAcoAABHBEAgByAHIANrQQh1IBhqaiEHDAMLIAdBBGogCEEEaiANEB1BBGohBAJAIAcgA00EQCAHIQAMAQsgByEGIAghBSAHIQAgCyAPTA0AA0AgBkF/aiIALQAAIAVBf2oiBS0AAEcEQCAGIQAMAgsgBEEBaiEEIAAgA00NASAAIQYgBSASSw0ACwsgByAIayEGIARBfWohCyAAIANrIQkgASgCDCEFAkACQCAAIAxNBEAgBSADEBwgASgCDCEIIAlBEE0EQCABIAggCWo2AgwMAwsgCEEQaiADQRBqIgUQHCAIQSBqIANBIGoQHCAJQTFIDQEgCCAJaiEQIAhBMGohAwNAIAMgBUEgaiIIEBwgA0EQaiAFQTBqEBwgCCEFIANBIGoiAyAQSQ0ACwwBCyAFIAMgACAMECILIAEgASgCDCAJajYCDCAJQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyABKAIEIgMgBkEDajYCACADIAk7AQQgC0GAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgCiEFIAYhCgwBCyAKIQUgBiEKCyADIAs7AQYgASADQQhqNgIEIAAgBGoiAyAWSwRAIAMhBwwBCyAVIAdBAmogFEEHEB5BAnRqIBtBAmo2AgAgFSADQX5qIgAgFEEHEB5BAnRqIAAgDms2AgAgCiEEIAUhAANAAkAgACEKIAQhACAaIAMgDmsiByAKayIEa0EDSQ0AIAQgHyAOIAQgD0kiBRtqIgQoAAAgAygAAEcNACADQQRqIARBBGogDSARIA0gBRsgEhAgIgZBAWohBSABKAIMIQQCQCADIAxNBEAgBCADEBwMAQsgBCADIAMgDBAiCyABKAIEIgRBATYCACAEQQA7AQQgBUGAgARPBEAgAUECNgIkIAEgBCABKAIAa0EDdTYCKAsgBCAFOwEGIAEgBEEIajYCBCAVIAMgFEEHEB5BAnRqIAc2AgAgCiEEIAAhBSAGQQRqIANqIgMhByADIBZNDQEMAgsLIAohBSAAIQogAyEHCyAHIBZJDQALCwwCCyACKAIEIQUgAigCACEKIAMgACgCcCIGKAIAIhEgAyAAKAIEIg4gACgCDCIPaiISa2ogBigCBCITIAYoAgwiF2oiHEZqIgcgAyAEaiINQXhqIhZJBEAgACgCiAEiBCAERWohGCAAKAJ8IRQgBigCfCEdIAAoAiAhFSAGKAIgIR4gEyATIBFrIA9qIhlrIR8gDUFgaiEMIA9Bf2ohGgNAIBUgByAUQQYQHkECdGoiACgCACELIAAgByAOayIbNgIAAkACQAJAIBogB0EBaiIAIAogDmprIgRrQQNJDQAgEyAEIBlraiAAIAprIAQgD0kiBBsiBigAACAAKAAARw0AIAdBBWogBkEEaiANIBEgDSAEGyASECAiCUEBaiELIAAgA2shCCABKAIMIQQCQAJAIAAgDE0EQCAEIAMQHCABKAIMIQYgCEEQTQRAIAEgBiAIajYCDAwDCyAGQRBqIANBEGoiBBAcIAZBIGogA0EgahAcIAhBMUgNASAGIAhqIRAgBkEwaiEDA0AgAyAEQSBqIgYQHCADQRBqIARBMGoQHCAGIQQgA0EgaiIDIBBJDQALDAELIAQgAyAAIAwQIgsgASABKAIMIAhqNgIMIAhBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAlBBGohBCABKAIEIgNBATYCACADIAg7AQQgC0GAgARJDQEgAUECNgIkIAEgAyABKAIAa0EDdTYCKAwBCwJAIAsgD00EQAJAIB4gByAdQQYQHkECdGooAgAiCCAXTQ0AIAggE2oiBigAACAHKAAARw0AIAdBBGogBkEEaiANIBEgEhAgQQRqIQQgGyAIayELAkAgByADTQRAIAchAAwBCyAHIQUgByEAIAggF0wNAANAIAVBf2oiAC0AACAGQX9qIgYtAABHBEAgBSEADAILIARBAWohBCAAIANNDQEgACEFIAYgHEsNAAsLIAsgGWshBiAEQX1qIQsgACADayEJIAEoAgwhBQJAAkAgACAMTQRAIAUgAxAcIAEoAgwhCCAJQRBNBEAgASAIIAlqNgIMDAMLIAhBEGogA0EQaiIFEBwgCEEgaiADQSBqEBwgCUExSA0BIAggCWohECAIQTBqIQMDQCADIAVBIGoiCBAcIANBEGogBUEwahAcIAghBSADQSBqIgMgEEkNAAsMAQsgBSADIAAgDBAiCyABIAEoAgwgCWo2AgwgCUGAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIAZBA2o2AgAgAyAJOwEEIAtBgIAESQ0CIAFBAjYCJCABIAMgASgCAGtBA3U2AigMAgsgByAHIANrQQh1IBhqaiEHDAMLIAsgDmoiCCgAACAHKAAARwRAIAcgByADa0EIdSAYamohBwwDCyAHQQRqIAhBBGogDRAdQQRqIQQCQCAHIANNBEAgByEADAELIAchBiAIIQUgByEAIAsgD0wNAANAIAZBf2oiAC0AACAFQX9qIgUtAABHBEAgBiEADAILIARBAWohBCAAIANNDQEgACEGIAUgEksNAAsLIAcgCGshBiAEQX1qIQsgACADayEJIAEoAgwhBQJAAkAgACAMTQRAIAUgAxAcIAEoAgwhCCAJQRBNBEAgASAIIAlqNgIMDAMLIAhBEGogA0EQaiIFEBwgCEEgaiADQSBqEBwgCUExSA0BIAggCWohECAIQTBqIQMDQCADIAVBIGoiCBAcIANBEGogBUEwahAcIAghBSADQSBqIgMgEEkNAAsMAQsgBSADIAAgDBAiCyABIAEoAgwgCWo2AgwgCUGAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIAZBA2o2AgAgAyAJOwEEIAtBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAohBSAGIQoMAQsgCiEFIAYhCgsgAyALOwEGIAEgA0EIajYCBCAAIARqIgMgFksEQCADIQcMAQsgFSAHQQJqIBRBBhAeQQJ0aiAbQQJqNgIAIBUgA0F+aiIAIBRBBhAeQQJ0aiAAIA5rNgIAIAohBCAFIQADQAJAIAAhCiAEIQAgGiADIA5rIgcgCmsiBGtBA0kNACAEIB8gDiAEIA9JIgUbaiIEKAAAIAMoAABHDQAgA0EEaiAEQQRqIA0gESANIAUbIBIQICIGQQFqIQUgASgCDCEEAkAgAyAMTQRAIAQgAxAcDAELIAQgAyADIAwQIgsgASgCBCIEQQE2AgAgBEEAOwEEIAVBgIAETwRAIAFBAjYCJCABIAQgASgCAGtBA3U2AigLIAQgBTsBBiABIARBCGo2AgQgFSADIBRBBhAeQQJ0aiAHNgIAIAohBCAAIQUgBkEEaiADaiIDIQcgAyAWTQ0BDAILCyAKIQUgACEKIAMhBwsgByAWSQ0ACwsMAQsgAigCBCEFIAIoAgAhCiADIAAoAnAiBigCACIRIAMgACgCBCIOIAAoAgwiD2oiEmtqIAYoAgQiEyAGKAIMIhdqIhxGaiIHIAMgBGoiDUF4aiIWSQRAIAAoAogBIgQgBEVqIRggACgCfCEUIAYoAnwhHSAAKAIgIRUgBigCICEeIBMgEyARayAPaiIZayEfIA1BYGohDCAPQX9qIRoDQCAVIAcgFEEFEB5BAnRqIgAoAgAhCyAAIAcgDmsiGzYCAAJAAkACQCAaIAdBAWoiACAKIA5qayIEa0EDSQ0AIBMgBCAZa2ogACAKayAEIA9JIgQbIgYoAAAgACgAAEcNACAHQQVqIAZBBGogDSARIA0gBBsgEhAgIglBAWohCyAAIANrIQggASgCDCEEAkACQCAAIAxNBEAgBCADEBwgASgCDCEGIAhBEE0EQCABIAYgCGo2AgwMAwsgBkEQaiADQRBqIgQQHCAGQSBqIANBIGoQHCAIQTFIDQEgBiAIaiEQIAZBMGohAwNAIAMgBEEgaiIGEBwgA0EQaiAEQTBqEBwgBiEEIANBIGoiAyAQSQ0ACwwBCyAEIAMgACAMECILIAEgASgCDCAIajYCDCAIQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyAJQQRqIQQgASgCBCIDQQE2AgAgAyAIOwEEIAtBgIAESQ0BIAFBAjYCJCABIAMgASgCAGtBA3U2AigMAQsCQCALIA9NBEACQCAeIAcgHUEFEB5BAnRqKAIAIgggF00NACAIIBNqIgYoAAAgBygAAEcNACAHQQRqIAZBBGogDSARIBIQIEEEaiEEIBsgCGshCwJAIAcgA00EQCAHIQAMAQsgByEFIAchACAIIBdMDQADQCAFQX9qIgAtAAAgBkF/aiIGLQAARwRAIAUhAAwCCyAEQQFqIQQgACADTQ0BIAAhBSAGIBxLDQALCyALIBlrIQYgBEF9aiELIAAgA2shCSABKAIMIQUCQAJAIAAgDE0EQCAFIAMQHCABKAIMIQggCUEQTQRAIAEgCCAJajYCDAwDCyAIQRBqIANBEGoiBRAcIAhBIGogA0EgahAcIAlBMUgNASAIIAlqIRAgCEEwaiEDA0AgAyAFQSBqIggQHCADQRBqIAVBMGoQHCAIIQUgA0EgaiIDIBBJDQALDAELIAUgAyAAIAwQIgsgASABKAIMIAlqNgIMIAlBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAyAGQQNqNgIAIAMgCTsBBCALQYCABEkNAiABQQI2AiQgASADIAEoAgBrQQN1NgIoDAILIAcgByADa0EIdSAYamohBwwDCyALIA5qIggoAAAgBygAAEcEQCAHIAcgA2tBCHUgGGpqIQcMAwsgB0EEaiAIQQRqIA0QHUEEaiEEAkAgByADTQRAIAchAAwBCyAHIQYgCCEFIAchACALIA9MDQADQCAGQX9qIgAtAAAgBUF/aiIFLQAARwRAIAYhAAwCCyAEQQFqIQQgACADTQ0BIAAhBiAFIBJLDQALCyAHIAhrIQYgBEF9aiELIAAgA2shCSABKAIMIQUCQAJAIAAgDE0EQCAFIAMQHCABKAIMIQggCUEQTQRAIAEgCCAJajYCDAwDCyAIQRBqIANBEGoiBRAcIAhBIGogA0EgahAcIAlBMUgNASAIIAlqIRAgCEEwaiEDA0AgAyAFQSBqIggQHCADQRBqIAVBMGoQHCAIIQUgA0EgaiIDIBBJDQALDAELIAUgAyAAIAwQIgsgASABKAIMIAlqNgIMIAlBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAyAGQQNqNgIAIAMgCTsBBCALQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyAKIQUgBiEKDAELIAohBSAGIQoLIAMgCzsBBiABIANBCGo2AgQgACAEaiIDIBZLBEAgAyEHDAELIBUgB0ECaiAUQQUQHkECdGogG0ECajYCACAVIANBfmoiACAUQQUQHkECdGogACAOazYCACAKIQQgBSEAA0ACQCAAIQogBCEAIBogAyAOayIHIAprIgRrQQNJDQAgBCAfIA4gBCAPSSIFG2oiBCgAACADKAAARw0AIANBBGogBEEEaiANIBEgDSAFGyASECAiBkEBaiEFIAEoAgwhBAJAIAMgDE0EQCAEIAMQHAwBCyAEIAMgAyAMECILIAEoAgQiBEEBNgIAIARBADsBBCAFQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAU7AQYgASAEQQhqNgIEIBUgAyAUQQUQHkECdGogBzYCACAKIQQgACEFIAZBBGogA2oiAyEHIAMgFk0NAQwCCwsgCiEFIAAhCiADIQcLIAcgFkkNAAsLIAIgBTYCBCACIAo2AgAgDSADaw8LIAIgBTYCBCACIAo2AgAgDSADawuKJgEUfwJ/AkACQAJAAkAgACgChAFBe2oOAwMCAQALIAIoAgAiCSACKAIEIghBACAIIAMgACgCBCILIAMgC2sgBGoiBUEBIAAoAnR0IgZrIAAoAgwiByAFIAdrIAZLGyIUaiISIANGaiIFIBJrIgZLIgcbIAkgBksiBhshFUEAIAkgBhshCUEAIAggBxshCCAFQQFqIgYgAyAEaiIEQXhqIhNJBEAgACgCfCENIAAoAiAhDiAEQWBqIRAgACgCiAEiACAARWpBAWohFgNAIAUgDUEEEB4hACAFKAAAIQwgBiANQQQQHiEHIAYoAAAhESAOIAdBAnRqIgooAgAhByAOIABBAnRqIg8oAgAhACAPIAUgC2siFzYCACAKIAYgC2s2AgACfwJAIAlFIAVBAmoiDyAJayIKKAAAIA8oAABHckUEQCAKIAUtAAEgCkF/ai0AAEYiBmshACAPIAZrIQVBACERDAELAkACQAJAIAAgFEsEQCAMIAAgC2oiACgAAEYNAQsgByAUTQ0BIBEgByALaiIAKAAARw0BIAYhBQsgBSAAayIKQQJqIRFBACEGIAAgEk0gBSADTXINAQNAIAVBf2oiBy0AACAAQX9qIgwtAABHDQIgBkEBaiEGIAcgA0sEQCAHIQUgDCIAIBJLDQELCyAJIQggDCEAIAohCSAHIQUMAgsgBiAWIAUgA2tBB3ZqIgBqIQYgACAFagwCCyAJIQggCiEJCyAFIAZqQQRqIAAgBmpBBGogBBAdIAZqIgxBAWohCiAFIANrIQcgASgCDCEAAkACQCAFIBBNBEAgACADEBwgASgCDCEAIAdBEE0EQCABIAAgB2oiADYCDAwDCyAAQRBqIANBEGoiBhAcIABBIGogA0EgahAcIAdBMUgNASAAIAdqIRggAEEwaiEDA0AgAyAGQSBqIgAQHCADQRBqIAZBMGoQHCAAIQYgA0EgaiIDIBhJDQALDAELIAAgAyAFIBAQIgsgASABKAIMIAdqIgA2AgwgB0GAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIBFBAWo2AgAgAyAHOwEEIApBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgCjsBBiABIANBCGo2AgQgDEEEaiAFaiIDQQFqIQYCQCADIBNLDQAgDiAPIA1BBBAeQQJ0aiAXQQJqNgIAIA4gA0F+aiIFIA1BBBAeQQJ0aiAFIAtrNgIAIAhFBEBBACEIDAELIAMoAAAgAyAIaygAAEcNAEEAIAhrIQYDQCAIIQUgCSEIIAUhCSADQQRqIgUgBSAGaiAEEB0hBSAOIAMgDUEEEB5BAnRqIAMgC2s2AgAgBUEBaiEGAkAgAyAQTQRAIAAgAxAcDAELIAAgAyADIBAQIgsgASgCBCIAQQE2AgAgAEEAOwEEIAZBgIAETwRAIAFBAjYCJCABIAAgASgCAGtBA3U2AigLIAAgBjsBBiABIABBCGo2AgQCQCAIRSADIAVqQQRqIgMgE0tyDQAgAygAACADIAhrKAAARw0AQQAgCGshBiABKAIMIQAMAQsLIANBAWohBgsgAwshBSAGIBNJDQALCyACIAkgFSAJGzYCACAIIBUgCBshBSACQQRqDAMLIAIoAgAiCSACKAIEIghBACAIIAMgACgCBCILIAMgC2sgBGoiBUEBIAAoAnR0IgZrIAAoAgwiByAFIAdrIAZLGyIUaiISIANGaiIFIBJrIgZLIgcbIAkgBksiBhshFUEAIAkgBhshCUEAIAggBxshCCAFQQFqIgYgAyAEaiIEQXhqIhNJBEAgACgCfCENIAAoAiAhDiAEQWBqIRAgACgCiAEiACAARWpBAWohFgNAIAUgDUEHEB4hACAFKAAAIQwgBiANQQcQHiEHIAYoAAAhESAOIAdBAnRqIgooAgAhByAOIABBAnRqIg8oAgAhACAPIAUgC2siFzYCACAKIAYgC2s2AgACfwJAIAlFIAVBAmoiDyAJayIKKAAAIA8oAABHckUEQCAKIAUtAAEgCkF/ai0AAEYiBmshACAPIAZrIQVBACERDAELAkACQAJAIAAgFEsEQCAMIAAgC2oiACgAAEYNAQsgByAUTQ0BIBEgByALaiIAKAAARw0BIAYhBQsgBSAAayIKQQJqIRFBACEGIAAgEk0gBSADTXINAQNAIAVBf2oiBy0AACAAQX9qIgwtAABHDQIgBkEBaiEGIAcgA0sEQCAHIQUgDCIAIBJLDQELCyAJIQggDCEAIAohCSAHIQUMAgsgBiAWIAUgA2tBB3ZqIgBqIQYgACAFagwCCyAJIQggCiEJCyAFIAZqQQRqIAAgBmpBBGogBBAdIAZqIgxBAWohCiAFIANrIQcgASgCDCEAAkACQCAFIBBNBEAgACADEBwgASgCDCEAIAdBEE0EQCABIAAgB2oiADYCDAwDCyAAQRBqIANBEGoiBhAcIABBIGogA0EgahAcIAdBMUgNASAAIAdqIRggAEEwaiEDA0AgAyAGQSBqIgAQHCADQRBqIAZBMGoQHCAAIQYgA0EgaiIDIBhJDQALDAELIAAgAyAFIBAQIgsgASABKAIMIAdqIgA2AgwgB0GAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIBFBAWo2AgAgAyAHOwEEIApBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgCjsBBiABIANBCGo2AgQgDEEEaiAFaiIDQQFqIQYCQCADIBNLDQAgDiAPIA1BBxAeQQJ0aiAXQQJqNgIAIA4gA0F+aiIFIA1BBxAeQQJ0aiAFIAtrNgIAIAhFBEBBACEIDAELIAMoAAAgAyAIaygAAEcNAEEAIAhrIQYDQCAIIQUgCSEIIAUhCSADQQRqIgUgBSAGaiAEEB0hBSAOIAMgDUEHEB5BAnRqIAMgC2s2AgAgBUEBaiEGAkAgAyAQTQRAIAAgAxAcDAELIAAgAyADIBAQIgsgASgCBCIAQQE2AgAgAEEAOwEEIAZBgIAETwRAIAFBAjYCJCABIAAgASgCAGtBA3U2AigLIAAgBjsBBiABIABBCGo2AgQCQCAIRSADIAVqQQRqIgMgE0tyDQAgAygAACADIAhrKAAARw0AQQAgCGshBiABKAIMIQAMAQsLIANBAWohBgsgAwshBSAGIBNJDQALCyACIAkgFSAJGzYCACAIIBUgCBshBSACQQRqDAILIAIoAgAiCSACKAIEIghBACAIIAMgACgCBCILIAMgC2sgBGoiBUEBIAAoAnR0IgZrIAAoAgwiByAFIAdrIAZLGyIUaiISIANGaiIFIBJrIgZLIgcbIAkgBksiBhshFUEAIAkgBhshCUEAIAggBxshCCAFQQFqIgYgAyAEaiIEQXhqIhNJBEAgACgCfCENIAAoAiAhDiAEQWBqIRAgACgCiAEiACAARWpBAWohFgNAIAUgDUEGEB4hACAFKAAAIQwgBiANQQYQHiEHIAYoAAAhESAOIAdBAnRqIgooAgAhByAOIABBAnRqIg8oAgAhACAPIAUgC2siFzYCACAKIAYgC2s2AgACfwJAIAlFIAVBAmoiDyAJayIKKAAAIA8oAABHckUEQCAKIAUtAAEgCkF/ai0AAEYiBmshACAPIAZrIQVBACERDAELAkACQAJAIAAgFEsEQCAMIAAgC2oiACgAAEYNAQsgByAUTQ0BIBEgByALaiIAKAAARw0BIAYhBQsgBSAAayIKQQJqIRFBACEGIAAgEk0gBSADTXINAQNAIAVBf2oiBy0AACAAQX9qIgwtAABHDQIgBkEBaiEGIAcgA0sEQCAHIQUgDCIAIBJLDQELCyAJIQggDCEAIAohCSAHIQUMAgsgBiAWIAUgA2tBB3ZqIgBqIQYgACAFagwCCyAJIQggCiEJCyAFIAZqQQRqIAAgBmpBBGogBBAdIAZqIgxBAWohCiAFIANrIQcgASgCDCEAAkACQCAFIBBNBEAgACADEBwgASgCDCEAIAdBEE0EQCABIAAgB2oiADYCDAwDCyAAQRBqIANBEGoiBhAcIABBIGogA0EgahAcIAdBMUgNASAAIAdqIRggAEEwaiEDA0AgAyAGQSBqIgAQHCADQRBqIAZBMGoQHCAAIQYgA0EgaiIDIBhJDQALDAELIAAgAyAFIBAQIgsgASABKAIMIAdqIgA2AgwgB0GAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIBFBAWo2AgAgAyAHOwEEIApBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgCjsBBiABIANBCGo2AgQgDEEEaiAFaiIDQQFqIQYCQCADIBNLDQAgDiAPIA1BBhAeQQJ0aiAXQQJqNgIAIA4gA0F+aiIFIA1BBhAeQQJ0aiAFIAtrNgIAIAhFBEBBACEIDAELIAMoAAAgAyAIaygAAEcNAEEAIAhrIQYDQCAIIQUgCSEIIAUhCSADQQRqIgUgBSAGaiAEEB0hBSAOIAMgDUEGEB5BAnRqIAMgC2s2AgAgBUEBaiEGAkAgAyAQTQRAIAAgAxAcDAELIAAgAyADIBAQIgsgASgCBCIAQQE2AgAgAEEAOwEEIAZBgIAETwRAIAFBAjYCJCABIAAgASgCAGtBA3U2AigLIAAgBjsBBiABIABBCGo2AgQCQCAIRSADIAVqQQRqIgMgE0tyDQAgAygAACADIAhrKAAARw0AQQAgCGshBiABKAIMIQAMAQsLIANBAWohBgsgAwshBSAGIBNJDQALCyACIAkgFSAJGzYCACAIIBUgCBshBSACQQRqDAELIAIoAgAiCSACKAIEIghBACAIIAMgACgCBCILIAMgC2sgBGoiBUEBIAAoAnR0IgZrIAAoAgwiByAFIAdrIAZLGyIUaiISIANGaiIFIBJrIgZLIgcbIAkgBksiBhshFUEAIAkgBhshCUEAIAggBxshCCAFQQFqIgYgAyAEaiIEQXhqIhNJBEAgACgCfCENIAAoAiAhDiAEQWBqIRAgACgCiAEiACAARWpBAWohFgNAIAUgDUEFEB4hACAFKAAAIQwgBiANQQUQHiEHIAYoAAAhESAOIAdBAnRqIgooAgAhByAOIABBAnRqIg8oAgAhACAPIAUgC2siFzYCACAKIAYgC2s2AgACfwJAIAlFIAVBAmoiDyAJayIKKAAAIA8oAABHckUEQCAKIAUtAAEgCkF/ai0AAEYiBmshACAPIAZrIQVBACERDAELAkACQAJAIAAgFEsEQCAMIAAgC2oiACgAAEYNAQsgByAUTQ0BIBEgByALaiIAKAAARw0BIAYhBQsgBSAAayIKQQJqIRFBACEGIAAgEk0gBSADTXINAQNAIAVBf2oiBy0AACAAQX9qIgwtAABHDQIgBkEBaiEGIAcgA0sEQCAHIQUgDCIAIBJLDQELCyAJIQggDCEAIAohCSAHIQUMAgsgBiAWIAUgA2tBB3ZqIgBqIQYgACAFagwCCyAJIQggCiEJCyAFIAZqQQRqIAAgBmpBBGogBBAdIAZqIgxBAWohCiAFIANrIQcgASgCDCEAAkACQCAFIBBNBEAgACADEBwgASgCDCEAIAdBEE0EQCABIAAgB2oiADYCDAwDCyAAQRBqIANBEGoiBhAcIABBIGogA0EgahAcIAdBMUgNASAAIAdqIRggAEEwaiEDA0AgAyAGQSBqIgAQHCADQRBqIAZBMGoQHCAAIQYgA0EgaiIDIBhJDQALDAELIAAgAyAFIBAQIgsgASABKAIMIAdqIgA2AgwgB0GAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIBFBAWo2AgAgAyAHOwEEIApBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgCjsBBiABIANBCGo2AgQgDEEEaiAFaiIDQQFqIQYCQCADIBNLDQAgDiAPIA1BBRAeQQJ0aiAXQQJqNgIAIA4gA0F+aiIFIA1BBRAeQQJ0aiAFIAtrNgIAIAhFBEBBACEIDAELIAMoAAAgAyAIaygAAEcNAEEAIAhrIQYDQCAIIQUgCSEIIAUhCSADQQRqIgUgBSAGaiAEEB0hBSAOIAMgDUEFEB5BAnRqIAMgC2s2AgAgBUEBaiEGAkAgAyAQTQRAIAAgAxAcDAELIAAgAyADIBAQIgsgASgCBCIAQQE2AgAgAEEAOwEEIAZBgIAETwRAIAFBAjYCJCABIAAgASgCAGtBA3U2AigLIAAgBjsBBiABIABBCGo2AgQCQCAIRSADIAVqQQRqIgMgE0tyDQAgAygAACADIAhrKAAARw0AQQAgCGshBiABKAIMIQAMAQsLIANBAWohBgsgAwshBSAGIBNJDQALCyACIAkgFSAJGzYCACAIIBUgCBshBSACQQRqCyAFNgIAIAQgA2sLYAEFfyAAKAIEIgQgACgCGGoiAkEDaiIDIAFBemoiBUkEQCAAKAKEASEGIAAoAnwhASAAKAIgIQADQCAAIAIgASAGEB5BAnRqIAIgBGs2AgAgAyICQQNqIgMgBUkNAAsLC/4dARl/IAAoAnghFSAAKAJ8IRMgACgCKCEWIAAoAiAhFCADIARqIg1BeGohFyACKAIEIQcgAigCACEIAkAgACgCDCIGIAAoAhAgACgCFCADIAAoAgQiC2sgBGoiBCAAKAJ0IgoQJyIQSwRAIBcgA0sEQCAAKAIIIg4gBiAQIAYgEEsbIg9qIRggCyAPaiERIA4gEGohGyANQWBqIRIgD0F/aiEcIAMhAANAIBYgAyAVIAUQHkECdGoiBCgCACEKIBQgAyATQQgQHkECdGoiBigCACEMIAYgAyALayIaNgIAIAQgGjYCAAJAAkACQAJAAkACQAJAIBpBAWoiGSAIayIEIBBNIBwgBGtBA0lyRQRAIA4gCyAEIA9JIgYbIARqIgkoAAAgA0EBaiIEKAAARg0BCyAMIBBNDQMgDiALIAwgD0kiBBsgDGoiCSkAACADKQAAUg0DIANBCGogCUEIaiANIBggDSAEGyARECBBCGohBiAJIBsgESAEGyIHSw0BIAMhBAwCCyADQQVqIAlBBGogDSAYIA0gBhsgERAgIglBAWohDCAEIABrIQogASgCDCEDAkACQCAEIBJNBEAgAyAAEBwgASgCDCEDIApBEE0EQCABIAMgCmo2AgwMAwsgA0EQaiAAQRBqIgYQHCADQSBqIABBIGoQHCAKQTFIDQEgAyAKaiEZIANBMGohAwNAIAMgBkEgaiIAEBwgA0EQaiAGQTBqEBwgACEGIANBIGoiAyAZSQ0ACwwBCyADIAAgBCASECILIAEgASgCDCAKajYCDCAKQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyAJQQRqIQYgASgCBCIDQQE2AgAgAyAKOwEEIAxBgIAESQ0EIAFBAjYCJCABIAMgASgCAGtBA3U2AigMBAsgAyEEIAMgAE0NAANAIANBf2oiBC0AACAJQX9qIgktAABHBEAgAyEEDAILIAZBAWohBiAJIAdNDQEgBCIDIABLDQALCyAaIAxrIQogBkF9aiEMIAQgAGshByABKAIMIQMCQAJAIAQgEk0EQCADIAAQHCABKAIMIQMgB0EQTQRAIAEgAyAHajYCDAwDCyADQRBqIABBEGoiCRAcIANBIGogAEEgahAcIAdBMUgNASADIAdqIRkgA0EwaiEDA0AgAyAJQSBqIgAQHCADQRBqIAlBMGoQHCAAIQkgA0EgaiIDIBlJDQALDAELIAMgACAEIBIQIgsgASABKAIMIAdqNgIMIAdBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAyAKQQNqNgIAIAMgBzsBBCAMQYCABEkNASABQQI2AiQgASADIAEoAgBrQQN1NgIoDAELAkACQCAKIBBNDQAgDiALIAogD0kiHRsgCmoiCSgAACADKAAARw0AIBQgA0EBaiIEIBNBCBAeQQJ0aiIGKAIAIQwgBiAZNgIAAkACQCAMIBBNDQAgDiALIAwgD0kiHhsgDGoiBykAACAEKQAAUg0AIANBCWogB0EIaiANIBggDSAeGyARECBBCGohBiAZIAxrIQogByAbIBEgHhsiCU0gBCAATXINAQNAIARBf2oiAy0AACAHQX9qIgctAABHDQIgBkEBaiEGIAcgCU0EQCADIQQMAwsgAyIEIABLDQALDAELIANBBGogCUEEaiANIBggDSAdGyARECBBBGohBiAaIAprIQogCSAbIBEgHRsiB00EQCADIQQMAQsgAyAATQRAIAMhBAwBCwNAIANBf2oiBC0AACAJQX9qIgktAABHBEAgAyEEDAILIAZBAWohBiAJIAdNDQEgBCIDIABLDQALCyAGQX1qIQwgBCAAayEHIAEoAgwhAwJAAkAgBCASTQRAIAMgABAcIAEoAgwhAyAHQRBNBEAgASADIAdqNgIMDAMLIANBEGogAEEQaiIJEBwgA0EgaiAAQSBqEBwgB0ExSA0BIAMgB2ohGSADQTBqIQMDQCADIAlBIGoiABAcIANBEGogCUEwahAcIAAhCSADQSBqIgMgGUkNAAsMAQsgAyAAIAQgEhAiCyABIAEoAgwgB2o2AgwgB0GAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIApBA2o2AgAgAyAHOwEEIAxBgIAESQ0BIAFBAjYCJCABIAMgASgCAGtBA3U2AigMAQsgAyAAa0EIdSADakEBaiEDDAMLIAghByAKIQgMAQsgCCEHIAohCAsgAyAMOwEGIAEgA0EIajYCBCAEIAZqIgAgF0sEQCAAIQMMAQsgFCALIBpBAmoiA2oiBCATQQgQHkECdGogAzYCACAUIABBfmoiBiATQQgQHkECdGogBiALazYCACAWIAQgFSAFEB5BAnRqIAM2AgAgFiAAQX9qIgMgFSAFEB5BAnRqIAMgC2s2AgAgCCEGIAchBANAAkAgBCEIIAYhBCAAIAtrIgYgCGsiAyAQTSAcIANrQQNJcg0AIAMgDiALIAMgD0kiBxtqIgMoAAAgACgAAEcNACAAQQRqIANBBGogDSAYIA0gBxsgERAgIgpBAWohByABKAIMIQMCQCAAIBJNBEAgAyAAEBwMAQsgAyAAIAAgEhAiCyABKAIEIgNBATYCACADQQA7AQQgB0GAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAHOwEGIAEgA0EIajYCBCAWIAAgFSAFEB5BAnRqIAY2AgAgFCAAIBNBCBAeQQJ0aiAGNgIAIAghBiAEIQcgCkEEaiAAaiIAIQMgACAXTQ0BDAILCyAIIQcgBCEIIAAhAwsgAyAXSQ0ACyAAIQMLIAIgCDYCAAwBCyAIIAdBACAHIAMgCyAEQQEgCnQiAGsgBiAEIAZrIABLGyIQaiISIANGaiIEIBJrIgBLIgYbIAggAEsiABshGEEAIAggABshAEEAIAcgBhshCiAEIBdJBEAgDUFgaiERA0AgBCATQQgQHiEIIBYgBCAVIAUQHkECdGoiBigCACEPIBQgCEECdGoiCCgCACEOIAYgBCALayIMNgIAIAggDDYCAAJAAkAgAEUgBEEBaiIIIABrKAAAIAgoAABHckUEQCAEQQVqIgQgBCAAayANEB0iCUEBaiEPIAggA2shByABKAIMIQQCQAJAIAggEU0EQCAEIAMQHCABKAIMIQYgB0EQTQRAIAEgBiAHajYCDAwDCyAGQRBqIANBEGoiBBAcIAZBIGogA0EgahAcIAdBMUgNASAGIAdqIQ4gBkEwaiEDA0AgAyAEQSBqIgYQHCADQRBqIARBMGoQHCAGIQQgA0EgaiIDIA5JDQALDAELIAQgAyAIIBEQIgsgASABKAIMIAdqNgIMIAdBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAlBBGohBiABKAIEIgNBATYCACADIAc7AQQgD0GAgARJDQEgAUECNgIkIAEgAyABKAIAa0EDdTYCKAwBCwJAAkACQAJAAkAgDiAQSwRAIAsgDmoiCSkAACAEKQAAUg0BIARBCGogCUEIaiANEB1BCGohBiAEIAlrIQcgBCADTQRAIAQhCAwGCyAOIBBMBEAgBCEIDAYLA0AgBEF/aiIILQAAIAlBf2oiCS0AAEcEQCAEIQgMBwsgBkEBaiEGIAggA00NBiAIIQQgCSASSw0ACwwFCyAPIBBLDQEMAgsgDyAQTQ0BCyALIA9qIgkoAAAgBCgAAEYNAQsgBCADa0EIdSAEakEBaiEEDAMLIBQgCCATQQgQHkECdGoiBigCACEOIAYgDEEBajYCAAJAIA4gEE0NACALIA5qIgopAAAgCCkAAFINACAEQQlqIApBCGogDRAdQQhqIQYgCCAKayEHIA4gEEwgCCADTXINAQNAIAhBf2oiBC0AACAKQX9qIgotAABHDQIgBkEBaiEGIAQgA00EQCAEIQgMAwsgBCEIIAogEksNAAsMAQsgBEEEaiAJQQRqIA0QHUEEaiEGIAQgCWshByAEIANNBEAgBCEIDAELIA8gEEwEQCAEIQgMAQsDQCAEQX9qIggtAAAgCUF/aiIJLQAARwRAIAQhCAwCCyAGQQFqIQYgCCADTQ0BIAghBCAJIBJLDQALCyAGQX1qIQ8gCCADayEJIAEoAgwhBAJAAkAgCCARTQRAIAQgAxAcIAEoAgwhCiAJQRBNBEAgASAJIApqNgIMDAMLIApBEGogA0EQaiIEEBwgCkEgaiADQSBqEBwgCUExSA0BIAkgCmohDiAKQTBqIQMDQCADIARBIGoiChAcIANBEGogBEEwahAcIAohBCADQSBqIgMgDkkNAAsMAQsgBCADIAggERAiCyABIAEoAgwgCWo2AgwgCUGAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIAdBA2o2AgAgAyAJOwEEIA9BgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAAhCiAHIQALIAMgDzsBBiABIANBCGo2AgQgBiAIaiIDIBdLBEAgAyEEDAELIBQgCyAMQQJqIgRqIgggE0EIEB5BAnRqIAQ2AgAgFCADQX5qIgYgE0EIEB5BAnRqIAYgC2s2AgAgFiAIIBUgBRAeQQJ0aiAENgIAIBYgA0F/aiIEIBUgBRAeQQJ0aiAEIAtrNgIAIAAhBiAKIQgDQAJAIAghACAGIQggAEUgAygAACADIABrKAAAR3INACADQQRqIgQgBCAAayANEB0hByAWIAMgFSAFEB5BAnRqIAMgC2siBDYCACAUIAMgE0EIEB5BAnRqIAQ2AgAgB0EBaiEGIAEoAgwhBAJAIAMgEU0EQCAEIAMQHAwBCyAEIAMgAyARECILIAEoAgQiBEEBNgIAIARBADsBBCAGQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAY7AQYgASAEQQhqNgIEIAAhBiAIIQogB0EEaiADaiIDIQQgAyAXTQ0BDAILCyAAIQogCCEAIAMhBAsgBCAXSQ0ACwsgAiAAIBggABs2AgAgCiAYIAobIQcLIAIgBzYCBCANIANrCyIAIAAgASACIAMgBCAAKAKEASIAQQQgAEF7akEDSRsQwwMLm0kBHn8CQAJAAkACQAJAIAAoAoQBQXtqDgMDAgEACyACKAIEIQggAigCACENIAMgACgCcCIGKAIAIg8gAyAAKAIEIgwgAyAMayAEaiIFQQEgACgCdHQiB2sgACgCDCIKIAUgCmsgB0sbIgtqIg5raiAGKAIEIhAgBigCDCIaaiIWRmoiBSADIARqIgpBeGoiG0kEQCAAKAJ4IRcgACgCfCETIAYoAnghHiAGKAJ8IRwgACgCKCEYIAAoAiAhFCAGKAIoIR8gBigCICEdIBAgCyAQaiAPayIZayEgIApBYGohEQNAIAUgE0EIEB4hACAFIBdBBBAeIQQgBSAcQQgQHiEHIAUgHkEEEB4hISAUIABBAnRqIgAoAgAhCSAYIARBAnRqIgQoAgAhBiAEIAUgDGsiFTYCACAAIBU2AgACQAJAAkAgCyAVQQFqIhIgDWsiAEF/c2pBA0kNACAQIAAgGWtqIAAgDGogACALSSIEGyIiKAAAIAVBAWoiACgAAEcNACAFQQVqICJBBGogCiAPIAogBBsgDhAgIglBAWohByAAIANrIQYgASgCDCEEAkACQCAAIBFNBEAgBCADEBwgASgCDCEEIAZBEE0EQCABIAQgBmo2AgwMAwsgBEEQaiADQRBqIgUQHCAEQSBqIANBIGoQHCAGQTFIDQEgBCAGaiESIARBMGohAwNAIAMgBUEgaiIEEBwgA0EQaiAFQTBqEBwgBCEFIANBIGoiAyASSQ0ACwwBCyAEIAMgACARECILIAEgASgCDCAGajYCDCAGQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyAJQQRqIQQgASgCBCIDQQE2AgAgAyAGOwEEIAdBgIAESQ0BIAFBAjYCJCABIAMgASgCAGtBA3U2AigMAQsCQAJAAkACQAJAAkAgCSALSwRAIAkgDGoiBykAACAFKQAAUg0BIAVBCGogB0EIaiAKEB1BCGohBCAFIAdrIQYgBSADTQRAIAUhAAwHCyAJIAtMBEAgBSEADAcLA0AgBUF/aiIALQAAIAdBf2oiBy0AAEcEQCAFIQAMCAsgBEEBaiEEIAAgA00NByAAIQUgByAOSw0ACwwGCwJAIB0gB0ECdGooAgAiACAaTA0AIAAgEGoiBykAACAFKQAAUg0AIAVBCGogB0EIaiAKIA8gDhAgQQhqIQQgFSAAayAZayEGIAUgA00EQCAFIQAMBwsDQCAFQX9qIgAtAAAgB0F/aiIHLQAARwRAIAUhAAwICyAEQQFqIQQgACADTQ0HIAAhBSAHIBZLDQALDAYLIAYgC00NAQwCCyAGIAtLDQELIB8gIUECdGooAgAiACAaTA0BIAAgEGoiBygAACAFKAAARw0BIAAgGWohBgwCCyAGIAxqIgcoAAAgBSgAAEYNAQsgBSADa0EIdSAFakEBaiEFDAMLIAVBAWoiACATQQgQHiEEIAAgHEEIEB4hCCAUIARBAnRqIgQoAgAhCSAEIBI2AgACQCAJIAtLBEAgCSAMaiIIKQAAIAApAABSDQEgBUEJaiAIQQhqIAoQHUEIaiEEIAAgCGshBiAJIAtMIAAgA01yDQIDQCAAQX9qIgUtAAAgCEF/aiIILQAARw0DIARBAWohBCAFIANNBEAgBSEADAQLIAUhACAIIA5LDQALDAILIB0gCEECdGooAgAiCSAaTA0AIAkgEGoiCCkAACAAKQAAUg0AIAVBCWogCEEIaiAKIA8gDhAgQQhqIQQgEiAJayAZayEGIAAgA00NAQNAIABBf2oiBS0AACAIQX9qIggtAABHDQIgBEEBaiEEIAUgA00EQCAFIQAMAwsgBSEAIAggFksNAAsMAQsgB0EEaiEAIAVBBGohBCAGIAtJBEAgBCAAIAogDyAOECBBBGohBCAVIAZrIQYgBSADTQRAIAUhAAwCCyAHIBZNBEAgBSEADAILA0AgBUF/aiIALQAAIAdBf2oiBy0AAEcEQCAFIQAMAwsgBEEBaiEEIAAgA00NAiAAIQUgByAWSw0ACwwBCyAEIAAgChAdQQRqIQQgBSAHayEGIAUgA00EQCAFIQAMAQsgByAOTQRAIAUhAAwBCwNAIAVBf2oiAC0AACAHQX9qIgctAABHBEAgBSEADAILIARBAWohBCAAIANNDQEgACEFIAcgDksNAAsLIARBfWohByAAIANrIQkgASgCDCEFAkACQCAAIBFNBEAgBSADEBwgASgCDCEIIAlBEE0EQCABIAggCWo2AgwMAwsgCEEQaiADQRBqIgUQHCAIQSBqIANBIGoQHCAJQTFIDQEgCCAJaiESIAhBMGohAwNAIAMgBUEgaiIIEBwgA0EQaiAFQTBqEBwgCCEFIANBIGoiAyASSQ0ACwwBCyAFIAMgACARECILIAEgASgCDCAJajYCDCAJQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyABKAIEIgMgBkEDajYCACADIAk7AQQgB0GAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgDSEIIAYhDQsgAyAHOwEGIAEgA0EIajYCBCAAIARqIgMgG0sEQCADIQUMAQsgFCAMIBVBAmoiAGoiBCATQQgQHkECdGogADYCACAUIANBfmoiBSATQQgQHkECdGogBSAMazYCACAYIAQgF0EEEB5BAnRqIAA2AgAgGCADQX9qIgAgF0EEEB5BAnRqIAAgDGs2AgAgDSEEIAghAANAAkAgACENIAQhACALIAMgDGsiBSANayIEQX9zakEDSQ0AIAQgICAMIAQgC0kiCBtqIgQoAAAgAygAAEcNACADQQRqIARBBGogCiAPIAogCBsgDhAgIgZBAWohCCABKAIMIQQCQCADIBFNBEAgBCADEBwMAQsgBCADIAMgERAiCyABKAIEIgRBATYCACAEQQA7AQQgCEGAgARPBEAgAUECNgIkIAEgBCABKAIAa0EDdTYCKAsgBCAIOwEGIAEgBEEIajYCBCAYIAMgF0EEEB5BAnRqIAU2AgAgFCADIBNBCBAeQQJ0aiAFNgIAIA0hBCAAIQggBkEEaiADaiIDIQUgAyAbTQ0BDAILCyANIQggACENIAMhBQsgBSAbSQ0ACwsMAwsgAigCBCEIIAIoAgAhDSADIAAoAnAiBigCACIPIAMgACgCBCIMIAMgDGsgBGoiBUEBIAAoAnR0IgdrIAAoAgwiCiAFIAprIAdLGyILaiIOa2ogBigCBCIQIAYoAgwiGmoiFkZqIgUgAyAEaiIKQXhqIhtJBEAgACgCeCEXIAAoAnwhEyAGKAJ4IR4gBigCfCEcIAAoAighGCAAKAIgIRQgBigCKCEfIAYoAiAhHSAQIAsgEGogD2siGWshICAKQWBqIREDQCAFIBNBCBAeIQAgBSAXQQcQHiEEIAUgHEEIEB4hByAFIB5BBxAeISEgFCAAQQJ0aiIAKAIAIQkgGCAEQQJ0aiIEKAIAIQYgBCAFIAxrIhU2AgAgACAVNgIAAkACQAJAIAsgFUEBaiISIA1rIgBBf3NqQQNJDQAgECAAIBlraiAAIAxqIAAgC0kiBBsiIigAACAFQQFqIgAoAABHDQAgBUEFaiAiQQRqIAogDyAKIAQbIA4QICIJQQFqIQcgACADayEGIAEoAgwhBAJAAkAgACARTQRAIAQgAxAcIAEoAgwhBCAGQRBNBEAgASAEIAZqNgIMDAMLIARBEGogA0EQaiIFEBwgBEEgaiADQSBqEBwgBkExSA0BIAQgBmohEiAEQTBqIQMDQCADIAVBIGoiBBAcIANBEGogBUEwahAcIAQhBSADQSBqIgMgEkkNAAsMAQsgBCADIAAgERAiCyABIAEoAgwgBmo2AgwgBkGAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgCUEEaiEEIAEoAgQiA0EBNgIAIAMgBjsBBCAHQYCABEkNASABQQI2AiQgASADIAEoAgBrQQN1NgIoDAELAkACQAJAAkACQAJAIAkgC0sEQCAJIAxqIgcpAAAgBSkAAFINASAFQQhqIAdBCGogChAdQQhqIQQgBSAHayEGIAUgA00EQCAFIQAMBwsgCSALTARAIAUhAAwHCwNAIAVBf2oiAC0AACAHQX9qIgctAABHBEAgBSEADAgLIARBAWohBCAAIANNDQcgACEFIAcgDksNAAsMBgsCQCAdIAdBAnRqKAIAIgAgGkwNACAAIBBqIgcpAAAgBSkAAFINACAFQQhqIAdBCGogCiAPIA4QIEEIaiEEIBUgAGsgGWshBiAFIANNBEAgBSEADAcLA0AgBUF/aiIALQAAIAdBf2oiBy0AAEcEQCAFIQAMCAsgBEEBaiEEIAAgA00NByAAIQUgByAWSw0ACwwGCyAGIAtNDQEMAgsgBiALSw0BCyAfICFBAnRqKAIAIgAgGkwNASAAIBBqIgcoAAAgBSgAAEcNASAAIBlqIQYMAgsgBiAMaiIHKAAAIAUoAABGDQELIAUgA2tBCHUgBWpBAWohBQwDCyAFQQFqIgAgE0EIEB4hBCAAIBxBCBAeIQggFCAEQQJ0aiIEKAIAIQkgBCASNgIAAkAgCSALSwRAIAkgDGoiCCkAACAAKQAAUg0BIAVBCWogCEEIaiAKEB1BCGohBCAAIAhrIQYgCSALTCAAIANNcg0CA0AgAEF/aiIFLQAAIAhBf2oiCC0AAEcNAyAEQQFqIQQgBSADTQRAIAUhAAwECyAFIQAgCCAOSw0ACwwCCyAdIAhBAnRqKAIAIgkgGkwNACAJIBBqIggpAAAgACkAAFINACAFQQlqIAhBCGogCiAPIA4QIEEIaiEEIBIgCWsgGWshBiAAIANNDQEDQCAAQX9qIgUtAAAgCEF/aiIILQAARw0CIARBAWohBCAFIANNBEAgBSEADAMLIAUhACAIIBZLDQALDAELIAdBBGohACAFQQRqIQQgBiALSQRAIAQgACAKIA8gDhAgQQRqIQQgFSAGayEGIAUgA00EQCAFIQAMAgsgByAWTQRAIAUhAAwCCwNAIAVBf2oiAC0AACAHQX9qIgctAABHBEAgBSEADAMLIARBAWohBCAAIANNDQIgACEFIAcgFksNAAsMAQsgBCAAIAoQHUEEaiEEIAUgB2shBiAFIANNBEAgBSEADAELIAcgDk0EQCAFIQAMAQsDQCAFQX9qIgAtAAAgB0F/aiIHLQAARwRAIAUhAAwCCyAEQQFqIQQgACADTQ0BIAAhBSAHIA5LDQALCyAEQX1qIQcgACADayEJIAEoAgwhBQJAAkAgACARTQRAIAUgAxAcIAEoAgwhCCAJQRBNBEAgASAIIAlqNgIMDAMLIAhBEGogA0EQaiIFEBwgCEEgaiADQSBqEBwgCUExSA0BIAggCWohEiAIQTBqIQMDQCADIAVBIGoiCBAcIANBEGogBUEwahAcIAghBSADQSBqIgMgEkkNAAsMAQsgBSADIAAgERAiCyABIAEoAgwgCWo2AgwgCUGAgARJDQAgAUEBNgIkIAEgASgCBCABKAIAa0EDdTYCKAsgASgCBCIDIAZBA2o2AgAgAyAJOwEEIAdBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIA0hCCAGIQ0LIAMgBzsBBiABIANBCGo2AgQgACAEaiIDIBtLBEAgAyEFDAELIBQgDCAVQQJqIgBqIgQgE0EIEB5BAnRqIAA2AgAgFCADQX5qIgUgE0EIEB5BAnRqIAUgDGs2AgAgGCAEIBdBBxAeQQJ0aiAANgIAIBggA0F/aiIAIBdBBxAeQQJ0aiAAIAxrNgIAIA0hBCAIIQADQAJAIAAhDSAEIQAgCyADIAxrIgUgDWsiBEF/c2pBA0kNACAEICAgDCAEIAtJIggbaiIEKAAAIAMoAABHDQAgA0EEaiAEQQRqIAogDyAKIAgbIA4QICIGQQFqIQggASgCDCEEAkAgAyARTQRAIAQgAxAcDAELIAQgAyADIBEQIgsgASgCBCIEQQE2AgAgBEEAOwEEIAhBgIAETwRAIAFBAjYCJCABIAQgASgCAGtBA3U2AigLIAQgCDsBBiABIARBCGo2AgQgGCADIBdBBxAeQQJ0aiAFNgIAIBQgAyATQQgQHkECdGogBTYCACANIQQgACEIIAZBBGogA2oiAyEFIAMgG00NAQwCCwsgDSEIIAAhDSADIQULIAUgG0kNAAsLDAILIAIoAgQhCCACKAIAIQ0gAyAAKAJwIgYoAgAiDyADIAAoAgQiDCADIAxrIARqIgVBASAAKAJ0dCIHayAAKAIMIgogBSAKayAHSxsiC2oiDmtqIAYoAgQiECAGKAIMIhpqIhZGaiIFIAMgBGoiCkF4aiIbSQRAIAAoAnghFyAAKAJ8IRMgBigCeCEeIAYoAnwhHCAAKAIoIRggACgCICEUIAYoAighHyAGKAIgIR0gECALIBBqIA9rIhlrISAgCkFgaiERA0AgBSATQQgQHiEAIAUgF0EGEB4hBCAFIBxBCBAeIQcgBSAeQQYQHiEhIBQgAEECdGoiACgCACEJIBggBEECdGoiBCgCACEGIAQgBSAMayIVNgIAIAAgFTYCAAJAAkACQCALIBVBAWoiEiANayIAQX9zakEDSQ0AIBAgACAZa2ogACAMaiAAIAtJIgQbIiIoAAAgBUEBaiIAKAAARw0AIAVBBWogIkEEaiAKIA8gCiAEGyAOECAiCUEBaiEHIAAgA2shBiABKAIMIQQCQAJAIAAgEU0EQCAEIAMQHCABKAIMIQQgBkEQTQRAIAEgBCAGajYCDAwDCyAEQRBqIANBEGoiBRAcIARBIGogA0EgahAcIAZBMUgNASAEIAZqIRIgBEEwaiEDA0AgAyAFQSBqIgQQHCADQRBqIAVBMGoQHCAEIQUgA0EgaiIDIBJJDQALDAELIAQgAyAAIBEQIgsgASABKAIMIAZqNgIMIAZBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAlBBGohBCABKAIEIgNBATYCACADIAY7AQQgB0GAgARJDQEgAUECNgIkIAEgAyABKAIAa0EDdTYCKAwBCwJAAkACQAJAAkACQCAJIAtLBEAgCSAMaiIHKQAAIAUpAABSDQEgBUEIaiAHQQhqIAoQHUEIaiEEIAUgB2shBiAFIANNBEAgBSEADAcLIAkgC0wEQCAFIQAMBwsDQCAFQX9qIgAtAAAgB0F/aiIHLQAARwRAIAUhAAwICyAEQQFqIQQgACADTQ0HIAAhBSAHIA5LDQALDAYLAkAgHSAHQQJ0aigCACIAIBpMDQAgACAQaiIHKQAAIAUpAABSDQAgBUEIaiAHQQhqIAogDyAOECBBCGohBCAVIABrIBlrIQYgBSADTQRAIAUhAAwHCwNAIAVBf2oiAC0AACAHQX9qIgctAABHBEAgBSEADAgLIARBAWohBCAAIANNDQcgACEFIAcgFksNAAsMBgsgBiALTQ0BDAILIAYgC0sNAQsgHyAhQQJ0aigCACIAIBpMDQEgACAQaiIHKAAAIAUoAABHDQEgACAZaiEGDAILIAYgDGoiBygAACAFKAAARg0BCyAFIANrQQh1IAVqQQFqIQUMAwsgBUEBaiIAIBNBCBAeIQQgACAcQQgQHiEIIBQgBEECdGoiBCgCACEJIAQgEjYCAAJAIAkgC0sEQCAJIAxqIggpAAAgACkAAFINASAFQQlqIAhBCGogChAdQQhqIQQgACAIayEGIAkgC0wgACADTXINAgNAIABBf2oiBS0AACAIQX9qIggtAABHDQMgBEEBaiEEIAUgA00EQCAFIQAMBAsgBSEAIAggDksNAAsMAgsgHSAIQQJ0aigCACIJIBpMDQAgCSAQaiIIKQAAIAApAABSDQAgBUEJaiAIQQhqIAogDyAOECBBCGohBCASIAlrIBlrIQYgACADTQ0BA0AgAEF/aiIFLQAAIAhBf2oiCC0AAEcNAiAEQQFqIQQgBSADTQRAIAUhAAwDCyAFIQAgCCAWSw0ACwwBCyAHQQRqIQAgBUEEaiEEIAYgC0kEQCAEIAAgCiAPIA4QIEEEaiEEIBUgBmshBiAFIANNBEAgBSEADAILIAcgFk0EQCAFIQAMAgsDQCAFQX9qIgAtAAAgB0F/aiIHLQAARwRAIAUhAAwDCyAEQQFqIQQgACADTQ0CIAAhBSAHIBZLDQALDAELIAQgACAKEB1BBGohBCAFIAdrIQYgBSADTQRAIAUhAAwBCyAHIA5NBEAgBSEADAELA0AgBUF/aiIALQAAIAdBf2oiBy0AAEcEQCAFIQAMAgsgBEEBaiEEIAAgA00NASAAIQUgByAOSw0ACwsgBEF9aiEHIAAgA2shCSABKAIMIQUCQAJAIAAgEU0EQCAFIAMQHCABKAIMIQggCUEQTQRAIAEgCCAJajYCDAwDCyAIQRBqIANBEGoiBRAcIAhBIGogA0EgahAcIAlBMUgNASAIIAlqIRIgCEEwaiEDA0AgAyAFQSBqIggQHCADQRBqIAVBMGoQHCAIIQUgA0EgaiIDIBJJDQALDAELIAUgAyAAIBEQIgsgASABKAIMIAlqNgIMIAlBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAyAGQQNqNgIAIAMgCTsBBCAHQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyANIQggBiENCyADIAc7AQYgASADQQhqNgIEIAAgBGoiAyAbSwRAIAMhBQwBCyAUIAwgFUECaiIAaiIEIBNBCBAeQQJ0aiAANgIAIBQgA0F+aiIFIBNBCBAeQQJ0aiAFIAxrNgIAIBggBCAXQQYQHkECdGogADYCACAYIANBf2oiACAXQQYQHkECdGogACAMazYCACANIQQgCCEAA0ACQCAAIQ0gBCEAIAsgAyAMayIFIA1rIgRBf3NqQQNJDQAgBCAgIAwgBCALSSIIG2oiBCgAACADKAAARw0AIANBBGogBEEEaiAKIA8gCiAIGyAOECAiBkEBaiEIIAEoAgwhBAJAIAMgEU0EQCAEIAMQHAwBCyAEIAMgAyARECILIAEoAgQiBEEBNgIAIARBADsBBCAIQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAg7AQYgASAEQQhqNgIEIBggAyAXQQYQHkECdGogBTYCACAUIAMgE0EIEB5BAnRqIAU2AgAgDSEEIAAhCCAGQQRqIANqIgMhBSADIBtNDQEMAgsLIA0hCCAAIQ0gAyEFCyAFIBtJDQALCwwBCyACKAIEIQggAigCACENIAMgACgCcCIGKAIAIg8gAyAAKAIEIgwgAyAMayAEaiIFQQEgACgCdHQiB2sgACgCDCIKIAUgCmsgB0sbIgpqIg5raiAGKAIEIhAgBigCDCIaaiIWRmoiBSADIARqIgtBeGoiG0kEQCAAKAJ4IRcgACgCfCETIAYoAnghHiAGKAJ8IRwgACgCKCEYIAAoAiAhFCAGKAIoIR8gBigCICEdIBAgCiAQaiAPayIZayEgIAtBYGohEQNAIAUgE0EIEB4hACAFIBdBBRAeIQQgBSAcQQgQHiEHIAUgHkEFEB4hISAUIABBAnRqIgAoAgAhCSAYIARBAnRqIgQoAgAhBiAEIAUgDGsiFTYCACAAIBU2AgACQAJAAkAgCiAVQQFqIhIgDWsiAEF/c2pBA0kNACAQIAAgGWtqIAAgDGogACAKSSIEGyIiKAAAIAVBAWoiACgAAEcNACAFQQVqICJBBGogCyAPIAsgBBsgDhAgIglBAWohByAAIANrIQYgASgCDCEEAkACQCAAIBFNBEAgBCADEBwgASgCDCEEIAZBEE0EQCABIAQgBmo2AgwMAwsgBEEQaiADQRBqIgUQHCAEQSBqIANBIGoQHCAGQTFIDQEgBCAGaiESIARBMGohAwNAIAMgBUEgaiIEEBwgA0EQaiAFQTBqEBwgBCEFIANBIGoiAyASSQ0ACwwBCyAEIAMgACARECILIAEgASgCDCAGajYCDCAGQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyAJQQRqIQQgASgCBCIDQQE2AgAgAyAGOwEEIAdBgIAESQ0BIAFBAjYCJCABIAMgASgCAGtBA3U2AigMAQsCQAJAAkACQAJAAkAgCSAKSwRAIAkgDGoiBykAACAFKQAAUg0BIAVBCGogB0EIaiALEB1BCGohBCAFIAdrIQYgBSADTQRAIAUhAAwHCyAJIApMBEAgBSEADAcLA0AgBUF/aiIALQAAIAdBf2oiBy0AAEcEQCAFIQAMCAsgBEEBaiEEIAAgA00NByAAIQUgByAOSw0ACwwGCwJAIB0gB0ECdGooAgAiACAaTA0AIAAgEGoiBykAACAFKQAAUg0AIAVBCGogB0EIaiALIA8gDhAgQQhqIQQgFSAAayAZayEGIAUgA00EQCAFIQAMBwsDQCAFQX9qIgAtAAAgB0F/aiIHLQAARwRAIAUhAAwICyAEQQFqIQQgACADTQ0HIAAhBSAHIBZLDQALDAYLIAYgCk0NAQwCCyAGIApLDQELIB8gIUECdGooAgAiACAaTA0BIAAgEGoiBygAACAFKAAARw0BIAAgGWohBgwCCyAGIAxqIgcoAAAgBSgAAEYNAQsgBSADa0EIdSAFakEBaiEFDAMLIAVBAWoiACATQQgQHiEEIAAgHEEIEB4hCCAUIARBAnRqIgQoAgAhCSAEIBI2AgACQCAJIApLBEAgCSAMaiIIKQAAIAApAABSDQEgBUEJaiAIQQhqIAsQHUEIaiEEIAAgCGshBiAJIApMIAAgA01yDQIDQCAAQX9qIgUtAAAgCEF/aiIILQAARw0DIARBAWohBCAFIANNBEAgBSEADAQLIAUhACAIIA5LDQALDAILIB0gCEECdGooAgAiCSAaTA0AIAkgEGoiCCkAACAAKQAAUg0AIAVBCWogCEEIaiALIA8gDhAgQQhqIQQgEiAJayAZayEGIAAgA00NAQNAIABBf2oiBS0AACAIQX9qIggtAABHDQIgBEEBaiEEIAUgA00EQCAFIQAMAwsgBSEAIAggFksNAAsMAQsgB0EEaiEAIAVBBGohBCAGIApJBEAgBCAAIAsgDyAOECBBBGohBCAVIAZrIQYgBSADTQRAIAUhAAwCCyAHIBZNBEAgBSEADAILA0AgBUF/aiIALQAAIAdBf2oiBy0AAEcEQCAFIQAMAwsgBEEBaiEEIAAgA00NAiAAIQUgByAWSw0ACwwBCyAEIAAgCxAdQQRqIQQgBSAHayEGIAUgA00EQCAFIQAMAQsgByAOTQRAIAUhAAwBCwNAIAVBf2oiAC0AACAHQX9qIgctAABHBEAgBSEADAILIARBAWohBCAAIANNDQEgACEFIAcgDksNAAsLIARBfWohByAAIANrIQkgASgCDCEFAkACQCAAIBFNBEAgBSADEBwgASgCDCEIIAlBEE0EQCABIAggCWo2AgwMAwsgCEEQaiADQRBqIgUQHCAIQSBqIANBIGoQHCAJQTFIDQEgCCAJaiESIAhBMGohAwNAIAMgBUEgaiIIEBwgA0EQaiAFQTBqEBwgCCEFIANBIGoiAyASSQ0ACwwBCyAFIAMgACARECILIAEgASgCDCAJajYCDCAJQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyABKAIEIgMgBkEDajYCACADIAk7AQQgB0GAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgDSEIIAYhDQsgAyAHOwEGIAEgA0EIajYCBCAAIARqIgMgG0sEQCADIQUMAQsgFCAMIBVBAmoiAGoiBCATQQgQHkECdGogADYCACAUIANBfmoiBSATQQgQHkECdGogBSAMazYCACAYIAQgF0EFEB5BAnRqIAA2AgAgGCADQX9qIgAgF0EFEB5BAnRqIAAgDGs2AgAgDSEEIAghAANAAkAgACENIAQhACAKIAMgDGsiBSANayIEQX9zakEDSQ0AIAQgICAMIAQgCkkiCBtqIgQoAAAgAygAAEcNACADQQRqIARBBGogCyAPIAsgCBsgDhAgIgZBAWohCCABKAIMIQQCQCADIBFNBEAgBCADEBwMAQsgBCADIAMgERAiCyABKAIEIgRBATYCACAEQQA7AQQgCEGAgARPBEAgAUECNgIkIAEgBCABKAIAa0EDdTYCKAsgBCAIOwEGIAEgBEEIajYCBCAYIAMgF0EFEB5BAnRqIAU2AgAgFCADIBNBCBAeQQJ0aiAFNgIAIA0hBCAAIQggBkEEaiADaiIDIQUgAyAbTQ0BDAILCyANIQggACENIAMhBQsgBSAbSQ0ACwsgAiAINgIEIAIgDTYCACALIANrDwsgAiAINgIEIAIgDTYCACAKIANrC+42ARN/An8CQAJAAkACQCAAKAKEAUF7ag4DAwIBAAsgAigCACIIIAIoAgQiB0EAIAcgAyAAKAIEIg0gAyANayAEaiIFQQEgACgCdHQiBmsgACgCDCIJIAUgCWsgBksbIg5qIhIgA0ZqIgUgEmsiBksiCRsgCCAGSyIGGyEXQQAgCCAGGyEIQQAgByAJGyEHIAUgAyAEaiIEQXhqIhVJBEAgACgCeCETIAAoAnwhECAAKAIoIRQgACgCICERIARBYGohDwNAIAUgEEEIEB4hACAUIAUgE0EEEB5BAnRqIgYoAgAhCyARIABBAnRqIgAoAgAhDCAGIAUgDWsiFjYCACAAIBY2AgACQAJAIAhFIAVBAWoiACAIaygAACAAKAAAR3JFBEAgBUEFaiIFIAUgCGsgBBAdIgtBAWohCiAAIANrIQkgASgCDCEFAkACQCAAIA9NBEAgBSADEBwgASgCDCEGIAlBEE0EQCABIAYgCWo2AgwMAwsgBkEQaiADQRBqIgUQHCAGQSBqIANBIGoQHCAJQTFIDQEgBiAJaiEMIAZBMGohAwNAIAMgBUEgaiIGEBwgA0EQaiAFQTBqEBwgBiEFIANBIGoiAyAMSQ0ACwwBCyAFIAMgACAPECILIAEgASgCDCAJajYCDCAJQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyALQQRqIQYgASgCBCIDQQE2AgAgAyAJOwEEIApBgIAESQ0BIAFBAjYCJCABIAMgASgCAGtBA3U2AigMAQsCQAJAAkACQAJAIAwgDksEQCAMIA1qIgopAAAgBSkAAFINASAFQQhqIApBCGogBBAdQQhqIQYgBSAKayEJIAUgA00EQCAFIQAMBgsgDCAOTARAIAUhAAwGCwNAIAVBf2oiAC0AACAKQX9qIgotAABHBEAgBSEADAcLIAZBAWohBiAAIANNDQYgACEFIAogEksNAAsMBQsgCyAOSw0BDAILIAsgDk0NAQsgCyANaiIKKAAAIAUoAABGDQELIAUgA2tBCHUgBWpBAWohBQwDCyARIAAgEEEIEB5BAnRqIgcoAgAhDCAHIBZBAWo2AgACQCAMIA5NDQAgDCANaiIHKQAAIAApAABSDQAgBUEJaiAHQQhqIAQQHUEIaiEGIAAgB2shCSAMIA5MIAAgA01yDQEDQCAAQX9qIgUtAAAgB0F/aiIHLQAARw0CIAZBAWohBiAFIANNBEAgBSEADAMLIAUhACAHIBJLDQALDAELIAVBBGogCkEEaiAEEB1BBGohBiAFIAprIQkgBSADTQRAIAUhAAwBCyALIA5MBEAgBSEADAELA0AgBUF/aiIALQAAIApBf2oiCi0AAEcEQCAFIQAMAgsgBkEBaiEGIAAgA00NASAAIQUgCiASSw0ACwsgBkF9aiEKIAAgA2shCyABKAIMIQUCQAJAIAAgD00EQCAFIAMQHCABKAIMIQcgC0EQTQRAIAEgByALajYCDAwDCyAHQRBqIANBEGoiBRAcIAdBIGogA0EgahAcIAtBMUgNASAHIAtqIQwgB0EwaiEDA0AgAyAFQSBqIgcQHCADQRBqIAVBMGoQHCAHIQUgA0EgaiIDIAxJDQALDAELIAUgAyAAIA8QIgsgASABKAIMIAtqNgIMIAtBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAyAJQQNqNgIAIAMgCzsBBCAKQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyAIIQcgCSEICyADIAo7AQYgASADQQhqNgIEIAAgBmoiAyAVSwRAIAMhBQwBCyARIA0gFkECaiIAaiIFIBBBCBAeQQJ0aiAANgIAIBEgA0F+aiIGIBBBCBAeQQJ0aiAGIA1rNgIAIBQgBSATQQQQHkECdGogADYCACAUIANBf2oiACATQQQQHkECdGogACANazYCACAIIQYgByEAA0ACQCAAIQggBiEAIAhFIAMoAAAgAyAIaygAAEdyDQAgA0EEaiIFIAUgCGsgBBAdIQkgFCADIBNBBBAeQQJ0aiADIA1rIgU2AgAgESADIBBBCBAeQQJ0aiAFNgIAIAlBAWohByABKAIMIQUCQCADIA9NBEAgBSADEBwMAQsgBSADIAMgDxAiCyABKAIEIgVBATYCACAFQQA7AQQgB0GAgARPBEAgAUECNgIkIAEgBSABKAIAa0EDdTYCKAsgBSAHOwEGIAEgBUEIajYCBCAIIQYgACEHIAlBBGogA2oiAyEFIAMgFU0NAQwCCwsgCCEHIAAhCCADIQULIAUgFUkNAAsLIAIgCCAXIAgbNgIAIAcgFyAHGyEIIAJBBGoMAwsgAigCACIIIAIoAgQiB0EAIAcgAyAAKAIEIg0gAyANayAEaiIFQQEgACgCdHQiBmsgACgCDCIJIAUgCWsgBksbIg5qIhIgA0ZqIgUgEmsiBksiCRsgCCAGSyIGGyEXQQAgCCAGGyEIQQAgByAJGyEHIAUgAyAEaiIEQXhqIhVJBEAgACgCeCETIAAoAnwhECAAKAIoIRQgACgCICERIARBYGohDwNAIAUgEEEIEB4hACAUIAUgE0EHEB5BAnRqIgYoAgAhCyARIABBAnRqIgAoAgAhDCAGIAUgDWsiFjYCACAAIBY2AgACQAJAIAhFIAVBAWoiACAIaygAACAAKAAAR3JFBEAgBUEFaiIFIAUgCGsgBBAdIgtBAWohCiAAIANrIQkgASgCDCEFAkACQCAAIA9NBEAgBSADEBwgASgCDCEGIAlBEE0EQCABIAYgCWo2AgwMAwsgBkEQaiADQRBqIgUQHCAGQSBqIANBIGoQHCAJQTFIDQEgBiAJaiEMIAZBMGohAwNAIAMgBUEgaiIGEBwgA0EQaiAFQTBqEBwgBiEFIANBIGoiAyAMSQ0ACwwBCyAFIAMgACAPECILIAEgASgCDCAJajYCDCAJQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyALQQRqIQYgASgCBCIDQQE2AgAgAyAJOwEEIApBgIAESQ0BIAFBAjYCJCABIAMgASgCAGtBA3U2AigMAQsCQAJAAkACQAJAIAwgDksEQCAMIA1qIgopAAAgBSkAAFINASAFQQhqIApBCGogBBAdQQhqIQYgBSAKayEJIAUgA00EQCAFIQAMBgsgDCAOTARAIAUhAAwGCwNAIAVBf2oiAC0AACAKQX9qIgotAABHBEAgBSEADAcLIAZBAWohBiAAIANNDQYgACEFIAogEksNAAsMBQsgCyAOSw0BDAILIAsgDk0NAQsgCyANaiIKKAAAIAUoAABGDQELIAUgA2tBCHUgBWpBAWohBQwDCyARIAAgEEEIEB5BAnRqIgcoAgAhDCAHIBZBAWo2AgACQCAMIA5NDQAgDCANaiIHKQAAIAApAABSDQAgBUEJaiAHQQhqIAQQHUEIaiEGIAAgB2shCSAMIA5MIAAgA01yDQEDQCAAQX9qIgUtAAAgB0F/aiIHLQAARw0CIAZBAWohBiAFIANNBEAgBSEADAMLIAUhACAHIBJLDQALDAELIAVBBGogCkEEaiAEEB1BBGohBiAFIAprIQkgBSADTQRAIAUhAAwBCyALIA5MBEAgBSEADAELA0AgBUF/aiIALQAAIApBf2oiCi0AAEcEQCAFIQAMAgsgBkEBaiEGIAAgA00NASAAIQUgCiASSw0ACwsgBkF9aiEKIAAgA2shCyABKAIMIQUCQAJAIAAgD00EQCAFIAMQHCABKAIMIQcgC0EQTQRAIAEgByALajYCDAwDCyAHQRBqIANBEGoiBRAcIAdBIGogA0EgahAcIAtBMUgNASAHIAtqIQwgB0EwaiEDA0AgAyAFQSBqIgcQHCADQRBqIAVBMGoQHCAHIQUgA0EgaiIDIAxJDQALDAELIAUgAyAAIA8QIgsgASABKAIMIAtqNgIMIAtBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAyAJQQNqNgIAIAMgCzsBBCAKQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyAIIQcgCSEICyADIAo7AQYgASADQQhqNgIEIAAgBmoiAyAVSwRAIAMhBQwBCyARIA0gFkECaiIAaiIFIBBBCBAeQQJ0aiAANgIAIBEgA0F+aiIGIBBBCBAeQQJ0aiAGIA1rNgIAIBQgBSATQQcQHkECdGogADYCACAUIANBf2oiACATQQcQHkECdGogACANazYCACAIIQYgByEAA0ACQCAAIQggBiEAIAhFIAMoAAAgAyAIaygAAEdyDQAgA0EEaiIFIAUgCGsgBBAdIQkgFCADIBNBBxAeQQJ0aiADIA1rIgU2AgAgESADIBBBCBAeQQJ0aiAFNgIAIAlBAWohByABKAIMIQUCQCADIA9NBEAgBSADEBwMAQsgBSADIAMgDxAiCyABKAIEIgVBATYCACAFQQA7AQQgB0GAgARPBEAgAUECNgIkIAEgBSABKAIAa0EDdTYCKAsgBSAHOwEGIAEgBUEIajYCBCAIIQYgACEHIAlBBGogA2oiAyEFIAMgFU0NAQwCCwsgCCEHIAAhCCADIQULIAUgFUkNAAsLIAIgCCAXIAgbNgIAIAcgFyAHGyEIIAJBBGoMAgsgAigCACIIIAIoAgQiB0EAIAcgAyAAKAIEIg0gAyANayAEaiIFQQEgACgCdHQiBmsgACgCDCIJIAUgCWsgBksbIg5qIhIgA0ZqIgUgEmsiBksiCRsgCCAGSyIGGyEXQQAgCCAGGyEIQQAgByAJGyEHIAUgAyAEaiIEQXhqIhVJBEAgACgCeCETIAAoAnwhECAAKAIoIRQgACgCICERIARBYGohDwNAIAUgEEEIEB4hACAUIAUgE0EGEB5BAnRqIgYoAgAhCyARIABBAnRqIgAoAgAhDCAGIAUgDWsiFjYCACAAIBY2AgACQAJAIAhFIAVBAWoiACAIaygAACAAKAAAR3JFBEAgBUEFaiIFIAUgCGsgBBAdIgtBAWohCiAAIANrIQkgASgCDCEFAkACQCAAIA9NBEAgBSADEBwgASgCDCEGIAlBEE0EQCABIAYgCWo2AgwMAwsgBkEQaiADQRBqIgUQHCAGQSBqIANBIGoQHCAJQTFIDQEgBiAJaiEMIAZBMGohAwNAIAMgBUEgaiIGEBwgA0EQaiAFQTBqEBwgBiEFIANBIGoiAyAMSQ0ACwwBCyAFIAMgACAPECILIAEgASgCDCAJajYCDCAJQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyALQQRqIQYgASgCBCIDQQE2AgAgAyAJOwEEIApBgIAESQ0BIAFBAjYCJCABIAMgASgCAGtBA3U2AigMAQsCQAJAAkACQAJAIAwgDksEQCAMIA1qIgopAAAgBSkAAFINASAFQQhqIApBCGogBBAdQQhqIQYgBSAKayEJIAUgA00EQCAFIQAMBgsgDCAOTARAIAUhAAwGCwNAIAVBf2oiAC0AACAKQX9qIgotAABHBEAgBSEADAcLIAZBAWohBiAAIANNDQYgACEFIAogEksNAAsMBQsgCyAOSw0BDAILIAsgDk0NAQsgCyANaiIKKAAAIAUoAABGDQELIAUgA2tBCHUgBWpBAWohBQwDCyARIAAgEEEIEB5BAnRqIgcoAgAhDCAHIBZBAWo2AgACQCAMIA5NDQAgDCANaiIHKQAAIAApAABSDQAgBUEJaiAHQQhqIAQQHUEIaiEGIAAgB2shCSAMIA5MIAAgA01yDQEDQCAAQX9qIgUtAAAgB0F/aiIHLQAARw0CIAZBAWohBiAFIANNBEAgBSEADAMLIAUhACAHIBJLDQALDAELIAVBBGogCkEEaiAEEB1BBGohBiAFIAprIQkgBSADTQRAIAUhAAwBCyALIA5MBEAgBSEADAELA0AgBUF/aiIALQAAIApBf2oiCi0AAEcEQCAFIQAMAgsgBkEBaiEGIAAgA00NASAAIQUgCiASSw0ACwsgBkF9aiEKIAAgA2shCyABKAIMIQUCQAJAIAAgD00EQCAFIAMQHCABKAIMIQcgC0EQTQRAIAEgByALajYCDAwDCyAHQRBqIANBEGoiBRAcIAdBIGogA0EgahAcIAtBMUgNASAHIAtqIQwgB0EwaiEDA0AgAyAFQSBqIgcQHCADQRBqIAVBMGoQHCAHIQUgA0EgaiIDIAxJDQALDAELIAUgAyAAIA8QIgsgASABKAIMIAtqNgIMIAtBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAyAJQQNqNgIAIAMgCzsBBCAKQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyAIIQcgCSEICyADIAo7AQYgASADQQhqNgIEIAAgBmoiAyAVSwRAIAMhBQwBCyARIA0gFkECaiIAaiIFIBBBCBAeQQJ0aiAANgIAIBEgA0F+aiIGIBBBCBAeQQJ0aiAGIA1rNgIAIBQgBSATQQYQHkECdGogADYCACAUIANBf2oiACATQQYQHkECdGogACANazYCACAIIQYgByEAA0ACQCAAIQggBiEAIAhFIAMoAAAgAyAIaygAAEdyDQAgA0EEaiIFIAUgCGsgBBAdIQkgFCADIBNBBhAeQQJ0aiADIA1rIgU2AgAgESADIBBBCBAeQQJ0aiAFNgIAIAlBAWohByABKAIMIQUCQCADIA9NBEAgBSADEBwMAQsgBSADIAMgDxAiCyABKAIEIgVBATYCACAFQQA7AQQgB0GAgARPBEAgAUECNgIkIAEgBSABKAIAa0EDdTYCKAsgBSAHOwEGIAEgBUEIajYCBCAIIQYgACEHIAlBBGogA2oiAyEFIAMgFU0NAQwCCwsgCCEHIAAhCCADIQULIAUgFUkNAAsLIAIgCCAXIAgbNgIAIAcgFyAHGyEIIAJBBGoMAQsgAigCACIIIAIoAgQiB0EAIAcgAyAAKAIEIg0gAyANayAEaiIFQQEgACgCdHQiBmsgACgCDCIJIAUgCWsgBksbIg5qIhIgA0ZqIgUgEmsiBksiCRsgCCAGSyIGGyEXQQAgCCAGGyEIQQAgByAJGyEHIAUgAyAEaiIEQXhqIhVJBEAgACgCeCETIAAoAnwhECAAKAIoIRQgACgCICERIARBYGohDwNAIAUgEEEIEB4hACAUIAUgE0EFEB5BAnRqIgYoAgAhCyARIABBAnRqIgAoAgAhDCAGIAUgDWsiFjYCACAAIBY2AgACQAJAIAhFIAVBAWoiACAIaygAACAAKAAAR3JFBEAgBUEFaiIFIAUgCGsgBBAdIgtBAWohCiAAIANrIQkgASgCDCEFAkACQCAAIA9NBEAgBSADEBwgASgCDCEGIAlBEE0EQCABIAYgCWo2AgwMAwsgBkEQaiADQRBqIgUQHCAGQSBqIANBIGoQHCAJQTFIDQEgBiAJaiEMIAZBMGohAwNAIAMgBUEgaiIGEBwgA0EQaiAFQTBqEBwgBiEFIANBIGoiAyAMSQ0ACwwBCyAFIAMgACAPECILIAEgASgCDCAJajYCDCAJQYCABEkNACABQQE2AiQgASABKAIEIAEoAgBrQQN1NgIoCyALQQRqIQYgASgCBCIDQQE2AgAgAyAJOwEEIApBgIAESQ0BIAFBAjYCJCABIAMgASgCAGtBA3U2AigMAQsCQAJAAkACQAJAIAwgDksEQCAMIA1qIgopAAAgBSkAAFINASAFQQhqIApBCGogBBAdQQhqIQYgBSAKayEJIAUgA00EQCAFIQAMBgsgDCAOTARAIAUhAAwGCwNAIAVBf2oiAC0AACAKQX9qIgotAABHBEAgBSEADAcLIAZBAWohBiAAIANNDQYgACEFIAogEksNAAsMBQsgCyAOSw0BDAILIAsgDk0NAQsgCyANaiIKKAAAIAUoAABGDQELIAUgA2tBCHUgBWpBAWohBQwDCyARIAAgEEEIEB5BAnRqIgcoAgAhDCAHIBZBAWo2AgACQCAMIA5NDQAgDCANaiIHKQAAIAApAABSDQAgBUEJaiAHQQhqIAQQHUEIaiEGIAAgB2shCSAMIA5MIAAgA01yDQEDQCAAQX9qIgUtAAAgB0F/aiIHLQAARw0CIAZBAWohBiAFIANNBEAgBSEADAMLIAUhACAHIBJLDQALDAELIAVBBGogCkEEaiAEEB1BBGohBiAFIAprIQkgBSADTQRAIAUhAAwBCyALIA5MBEAgBSEADAELA0AgBUF/aiIALQAAIApBf2oiCi0AAEcEQCAFIQAMAgsgBkEBaiEGIAAgA00NASAAIQUgCiASSw0ACwsgBkF9aiEKIAAgA2shCyABKAIMIQUCQAJAIAAgD00EQCAFIAMQHCABKAIMIQcgC0EQTQRAIAEgByALajYCDAwDCyAHQRBqIANBEGoiBRAcIAdBIGogA0EgahAcIAtBMUgNASAHIAtqIQwgB0EwaiEDA0AgAyAFQSBqIgcQHCADQRBqIAVBMGoQHCAHIQUgA0EgaiIDIAxJDQALDAELIAUgAyAAIA8QIgsgASABKAIMIAtqNgIMIAtBgIAESQ0AIAFBATYCJCABIAEoAgQgASgCAGtBA3U2AigLIAEoAgQiAyAJQQNqNgIAIAMgCzsBBCAKQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyAIIQcgCSEICyADIAo7AQYgASADQQhqNgIEIAAgBmoiAyAVSwRAIAMhBQwBCyARIA0gFkECaiIAaiIFIBBBCBAeQQJ0aiAANgIAIBEgA0F+aiIGIBBBCBAeQQJ0aiAGIA1rNgIAIBQgBSATQQUQHkECdGogADYCACAUIANBf2oiACATQQUQHkECdGogACANazYCACAIIQYgByEAA0ACQCAAIQggBiEAIAhFIAMoAAAgAyAIaygAAEdyDQAgA0EEaiIFIAUgCGsgBBAdIQkgFCADIBNBBRAeQQJ0aiADIA1rIgU2AgAgESADIBBBCBAeQQJ0aiAFNgIAIAlBAWohByABKAIMIQUCQCADIA9NBEAgBSADEBwMAQsgBSADIAMgDxAiCyABKAIEIgVBATYCACAFQQA7AQQgB0GAgARPBEAgAUECNgIkIAEgBSABKAIAa0EDdTYCKAsgBSAHOwEGIAEgBUEIajYCBCAIIQYgACEHIAlBBGogA2oiAyEFIAMgFU0NAQwCCwsgCCEHIAAhCCADIQULIAUgFUkNAAsLIAIgCCAXIAgbNgIAIAcgFyAHGyEIIAJBBGoLIAg2AgAgBCADawuMAQEIfyAAKAIEIgQgACgCGGoiAkECaiABQXhqIgFNBEAgACgCeCEFIAAoAoQBIQYgACgCfCEHIAAoAighCCAAKAIgIQADQCACIAdBCBAeIQMgCCACIAUgBhAeQQJ0aiACIARrIgk2AgAgACADQQJ0aiAJNgIAIAJBBWohAyACQQNqIQIgAyABTQ0ACwsLgwUBAn8jAEHQAGsiCyQAQbp/IQwgC0E4aiAAIAEQ/wEQIUUEQCALQShqIAIgAyAJQX9qIgBqIgItAAAQYyALQRhqIAQgACAFaiIBLQAAEGMgC0EIaiAGIAAgB2oiBC0AABBjIAtBOGogCCAAQQN0aiIALwEEIAQtAABBAnRBsKcBaigCABBHIAtBOGoQOSALQThqIAAvAQYgAi0AAEECdEGQpAFqKAIAEEcgC0E4ahA5AkAgCgRAIAEtAAAiASABQRggAUEYSRsiAmsiAQRAIAtBOGogACgCACABEEcgC0E4ahA5CyALQThqIAAoAgAgAXYgAhBHDAELIAtBOGogACgCACABLQAAEEcLIAtBOGoQOSAJQQJPBEAgCUF+aiEMA0AgByAMai0AACECIAMgDGotAAAhBCALQThqIAtBGGogBSAMai0AACIAEGwgC0E4aiALQShqIAQQbCALQThqEDkgC0E4aiALQQhqIAIQbCALQThqEDkgC0E4aiAIIAxBA3RqIgEvAQQgAkECdEGwpwFqKAIAIgIQRyACIARBAnRBkKQBaigCACICakEZTwRAIAtBOGoQOQsgC0E4aiABLwEGIAIQRyALQThqEDkCQCAKBEAgACAAQRggAEEYSRsiAmsiAARAIAtBOGogASgCACAAEEcgC0E4ahA5CyALQThqIAEoAgAgAHYgAhBHDAELIAtBOGogASgCACAAEEcLIAtBOGoQOSAMQX9qIgwgCUkNAAsLIAtBOGogCygCKCALKAI0EHQgC0E4aiALKAIYIAsoAiQQdCALQThqIAsoAgggCygCFBB0IAtBOGoQ/QEiAEG6fyAAGyEMCyALQdAAaiQAIAwLLwAgACACQQN0aigCBCIAQRB2QQFqIgJBCHRBfyABdCAAayACQRB0akEIdCABdmsLTwEEfwNAIANBASAAIARBAnRqKAIAIgNBCHQiBSACbiIGIAUgAkkbIAYgAxtBAnRBkJwBaigCACADbGohAyAEQQFqIgQgAU0NAAsgA0EIdgtKAQF/IwBB8ARrIgQkACAEIAMgAiABEKcBIgMgACACIAEQpgEiAhAhRQRAIARB8ABqQYAEIAQgASADEKgBIQILIARB8ARqJAAgAguKAQEIfyMAQRBrIgMkACADIAAQc0F/IQUCQCAALwACIAJJDQAgAygCDCIHQQh0QYACaiEIIAMoAgghCUEAIQADQCAJIAcgABDJAyEGIAEgAEECdGooAgAiCgRAIAYgCE8NAiAGIApsIARqIQQLIABBAWoiACACTQ0ACyAEQQh2IQULIANBEGokACAFC18BAn9BCCABayEFQQAhAQNAIARBASAAIAFBAXRqLwEAIgQgBEH//wNGG0EQdEEQdSAFdEECdEGQnAFqKAIAIAIgAUECdGooAgBsaiEEIAFBAWoiASADTQ0ACyAEQQh2C2wBAX8CQAJAAkACQCACQf8fS0ECQQEgAkEfSxtqIgNBf2oOAwABAgMLIAAgAkEDdEEBcjoAAAwCCyAAIAJBBHRBBXJB9f8DcRAvDAELIAAgAkEEdEENchBNCyAAIANqIAEtAAA6AAAgA0EBagtBACAALQAAQQJHBEAgAkEANgIAIANBADYCACABQQA2AgAPCyABIAAoAAQ2AgAgAyAAKAAINgIAIAIgACgADDYCAAuLAQEBfyMAQSBrIgEkACAAQQBBmAYQKCIAQQA2AqADIABBADYCnAMgAEEANgKYAyABQRBqEOABIAEgASkDGDcDCCABIAEpAxA3AwAgACABEN8BNgIIIAAoAugFRQRAIAAQ9gEgAEEMaiIABEAgAEEAQfgAECgiAEEBNgIgIABBAzYCLAsLIAFBIGokAAtOACAAIAFB+AAQKiIAIAIoAhg2AhwgACACKQIQNwIUIAAgAikCCDcCDCAAIAIpAgA3AgQgACACKQIcNwIgIAAgAigCJDYCKCAAQQM2AiwLqQEBAn8jAEHQAWsiBiQAIAZBqAFqIgcgBSAERSAEaq0Q9QMgB0EBNgIcIAdCADcCICAGIAYpA7ABNwMQIAYgBikDuAE3AxggBiAGKQPAATcDICAGIAYpA8gBNwMoIAYgBikDqAE3AwggBkEwaiAAQQxqIAZBCGoQ0QMgACAGQTBqIAStEN4DIgUQIQR/IAUFIAAgASACIAMgBBDxAwshACAGQdABaiQAIAALJwECfyAAKAIQIgEgACgCDCICSQRAIAFBACACIAFrECgaCyAAEO0BCyYAIAAQ5QEgAEEANgJwIABBADYCSCAAQQA2AhQgACAAKAIMNgIYC2IBA38jAEEgayICJAAgARB7IAJBFGogAkEcaiACQRhqEM8DQYjsASACKAIUIgMQTCIENgIAIAEQeyAEIAMQowIgAkEIaiADQYjsASgCABDbASAAIAJBCGoQ2gEgAkEgaiQACzQAIABBADYCICAAIAE2AhAgACABNgIIIAAgATYCACAAIAEgAmo2AgQgABDmASAAQQA2AhwLQwECfkIBIQIgAFBFBEBC48iVvcub741PIQEDQEIBIAEgAEIBg1AbIAJ+IQIgASABfiEBIABCAYgiAEIAUg0ACwsgAgvEAgEDfyACKAIYQQFHBEBBBCACKAIEdCEFCyACKAIIIQYgAigCEEEDRgRAIAIoAgAiBEERIARBEUkbIQQLIANBAUYEQCAAQoGAgIAQNwIMIABCADcCBCAAQQE2AgAgARDuAQsgACAENgIcIAAQ1AMgASABKAIINgIMIAAgAUEEIAZ0EJ4BNgIgIAAgASAFEJ4BNgIoIAAgAUEEIAR0QQAgBBsQngE2AiQgASgCGEUEQCABENMDIAIoAhhBB08EQCAAIAFBgAgQVTYCLCAAIAFBkAEQVTYCMCAAIAFB1AEQVTYCNCAAIAFBgAEQVTYCOCAAIAFBiIACEFU2AjwgAEFAayABQZyABxBVNgIACyAAIAIpAgA3AnQgACACKAIYNgKMASAAIAIpAhA3AoQBIAAgAikCCDcCfEFAQQAgASgCGBsPC0FACzQAIABBADYCgAggAEHoI2pChICAgIABNwIAIABB4CNqQoCAgIAQNwIAIABB2CNqQgA3AgALLAECf0EBQQAgACgCBCIBIAAoAghrIgIgAiABSxt0QQggAXRqQQAgACgCABsLhQEBA38gACgCGCIBQQFHBEBBBCAAKAIEdCEDCyAAKAIIIQICfwJAIAAoAhBBA0YEQEGIjAlBACABQQZLGyEBQQQgAnQhAkGAgCAgACgCACIAQRFPDQIaIABFDQFBBCAAdAwCC0GIjAlBACABQQZLGyEBQQQgAnQhAgtBAAsgASADaiACamoLlQEBAn8gACABNgIUIAAoAgghBSAAKAIMIgRFBEAgAEHAADYCDEHAACEECyADQQdPBEAgACACIAQgBCACSRs2AgwLIAAoAgQiBEUEQCAAIAFBeWoiAkEGIAJBBksbIgQ2AgQLIAAoAhBFBEAgAEEAIAEgBGsiAiACIAFLGzYCEAsgACAFQQMgBRsiACAEIAAgBEkbNgIIC/AIAhB/AX4jAEHQAGsiBSQAIABBATYCuAMgAUHUAGohBiABKAJUBEAgBiABKAIEIAEoAhggASgCHBDcAyAAIAEoAmBBf2qtENcDNwOIBAsgASgCFCEIIAE1AgQhEyABQQRqIgkQ2wMhDiAFIAYpAhA3A0ggBUFAayAGKQIINwMAIAUgBikCADcDOAJ/QgEgE4YiEyACIBMgAlQbpyIEQQEgBBsiBEGAgAggBEGAgAhJGyILIQRBACAFKAI4RQ0AGiAEIAUoAkRuCyEMIAUgACgCwAQ2AjAgBSAAKQK4BDcDKCAFIABBsARqIg8pAgA3AyAgBSgCICAFKAIka0GAgID4eUshByAAQYACaiIEIgMgAygCDCADKAIUQQAQ5AEEfyADKAIcQQFqBUEACzYCHCAAKAKkAyENIAUgBikCEDcDGCAFIAYpAgg3AxAgBSAGKQIANwMIIAVBCGoQ2gMhAyAEKAIAIAAoAoQCEOcBIRACQAJ/QQAgBCIKKAIMIAQoAhQgAyAMQQxsIhEgDiALQSBqIhIgC0EDQQQgCEEDRhtuIghBC2xqampqQfj9AEHg9wAgDRtqIgMQ5AFFDQAaIAooAhxBgAFKCyAQIANJcgRAIA0EQEFAIQMMAgsgBCAAKAKYAyAAKAKcAyAAKAKgAxCkAQJ/IAQhByAAKAKcAxpBQCADIAAoApgDIAAoAqADEIcCIgpFDQAaIAcgCiADENYDQQALIgMQIQ0BIAAgBEHwIxCfASIDNgKoBCADRQRAQUAhAwwCCyAAIARB8CMQnwEiAzYCrAQgA0UEQEFAIQMMAgsgACAEQYAwEJ8BNgLABUEBIQdBQCEDIAAoAqwERQ0BCyAEEOYBIABBhAFqIAFB+AAQKhogACAJKAIYNgK8BSAAIAkpAhA3ArQFIAAgCSkCCDcCrAUgACAJKQIANwKkBSAAQgA3A7ACIAAgAkIBfDcDqAIgAEIANwO4AiACQn9RBEAgAEEANgKkAQsgACALNgKkAiAAQcACahCGAiAAQQA2AvwBIABBATYCACAAKAKoBBDZAyAEIBIQYCEDIABBADYCyAUgACALNgLcAyAAIAM2AsQDIARBABBgIQMgAEEANgLcBSAAIAM2AsQFIAAgBEEAEGA2AtgFIAYoAgAiCgRAIAAgBEEBIAEoAlggASgCXGt0IgMQYCIGNgKABCAGQQAgAxAoGgsCQCAAIgMoAgBBAUcNACADKALYAQ0AIANCADcDmAQgA0IANwOgBAsgACAINgLYAyAAIAQgCBBgNgLMAyAAIAQgCBBgNgLQAyAAIAQgCBBgNgLUAyAAIAQgCEEDdBBVNgK8AyAPIAQgCSAHENgDIgNBACADECEiBxshAyAHIApFcg0AIAAgBEEIIAEoAlh0IgEQVSIHNgL8A0EAIQMgB0EAIAEQKBogBCAREFUhASAAIAw2ApQEIAAgATYCkAQgAEIANwPoAyAAQgA3A/ADIABBADYC+AMgAEHoA2oQ5QELIAVB0ABqJAAgAwtMAQF/IwBBgAFrIgMkACADQQhqIAFB+AAQKhoCQCAAIANBCGogAhDdAyIBECENAEEAIQFBABAhDQAgAEEANgL8AQsgA0GAAWokACABC7MFAQZ/IAFBEG0hCCABQRBOBEADQCAAIAZBAnQiBWoiAUEAIAJBACABKAIAIgFBAUYbIAFqIgEgAmsiAyADIAFLGzYCACAAIAVBBHJqIgFBACACQQAgASgCACIDQQFGGyADaiIDIAJrIgQgBCADSxs2AgAgAUEAIAJBACABKAIEIgFBAUYbIAFqIgEgAmsiAyADIAFLGzYCBCAAIAVBDHJqIgFBACACQQAgASgCACIDQQFGGyADaiIDIAJrIgQgBCADSxs2AgAgAUEAIAJBACABKAIEIgNBAUYbIANqIgMgAmsiBCAEIANLGzYCBCABQQAgAkEAIAEoAggiA0EBRhsgA2oiAyACayIEIAQgA0sbNgIIIAFBACACQQAgASgCDCIBQQFGGyABaiIBIAJrIgMgAyABSxs2AgwgACAFQRxyaiIBQQAgAkEAIAEoAgAiA0EBRhsgA2oiAyACayIEIAQgA0sbNgIAIAFBACACQQAgASgCBCIDQQFGGyADaiIDIAJrIgQgBCADSxs2AgQgAUEAIAJBACABKAIIIgNBAUYbIANqIgMgAmsiBCAEIANLGzYCCCABQQAgAkEAIAEoAgwiA0EBRhsgA2oiAyACayIEIAQgA0sbNgIMIAFBACACQQAgASgCECIDQQFGGyADaiIDIAJrIgQgBCADSxs2AhAgAUEAIAJBACABKAIUIgNBAUYbIANqIgMgAmsiBCAEIANLGzYCFCABQQAgAkEAIAEoAhgiA0EBRhsgA2oiAyACayIEIAQgA0sbNgIYIAFBACACQQAgASgCHCIBQQFGGyABaiIBIAJrIgMgAyABSxs2AhwgACAFQTxyaiIBQQAgAkEAIAEoAgAiAUEBRhsgAWoiASACayIFIAUgAUsbNgIAIAZBEGohBiAHQQFqIgcgCEcNAAsLC8sDAQV/IwBBEGsiCSQAIAcgAhDpASENIAEgAEGECBAqIQoCfyADBEAgBCAFIAYgBxCdAQwBC0EGQT8gACgCgAgiAUECRhsgB08EQCAEIAUgBiAHEJ0BDAELQbp/IAdB//8AS0EEQQMgB0H/B0sbaiILIAVPDQAaIAJBBEkgB0GBCElxIQwgCSABNgIMIAUgC2shAyAEIAtqIQICfyALQQNGIAFBAkZxIAdBgAJJciIBBEAgAiADIAYgB0EAIAggCiAJQQxqIAwQ+AEMAQsgAiADIAYgB0EBIAggCiAJQQxqIAwQ+AELIQMgCSgCDCECIAMQISADRSADIAcgDWtPcnIEQCAKIABBhAgQKhogBCAFIAYgBxCdAQwBCyADQQFGBEAgCiAAQYQIECoaIAQgBiAHEM4DDAELIAJFBEAgCkEBNgKACAtBA0ECIAIbIQACQAJAAkACQCALQX1qDgMAAQIDCyAEIAdBBHRBBEEAIAEbciAAckEEcyADQQ50ahCjAQwCCyAEIAdBBHQgAHJBCHIgA0ESdGoQTQwBCyAEIAdBBHQgAHJBDHIgA0EWdGoQTSAEIANBCnY6AAQLIAMgC2oLIQAgCUEQaiQAIAALMwEBfwJAAkACQCAAKAJAQX9qDgICAAELQQEPCyAAKAIcQQFHDQAgACgCGEEARyEBCyABC/8GARJ/IwBB8AFrIggkACADKAIEIRUgACgCFCENIAAoAhAhDiAAKAIYIQ8gACgCBCEJIAAoAgAhEwJAIAEgAiADKAIcIhAgAxDhAyAEIAUgACgCCCIDIAAoAgwgA2sgBhDgAyIDECEiBw0AIAMgBGohCkG6fyEDIAQgBWoiCyAEIAogBxsiB2tBBEgNAAJ/IAkgE2siA0EDdSIFQf8ATQRAIAcgBToAACAHQQFqDAELIAVB//0BTQRAIAcgBToAASAHIAVBCHZBgAFzOgAAIAdBAmoMAQsgB0H/AToAACAHQQFqIAVBgIJ+akH//wNxEC8gB0EDagshCiACQYQIaiERIANFBEAgESABQYQIakHgGxAqGiAKIARrIQMMAQsgABDzAyAIQSM2AgwgCEEQaiAIQQxqIA4gBSAGEIMBIQMgAkHgI2oiByABQeAjaigCADYCACAKQQFqIgAgCyAAayACQbQZaiIWQQkgByAIQRBqIAgoAgwiByADIAVBCSABQbQZaiIDQZCaAUEGQQEgEBCiASIUIAhBEGogByAOIAVBkJoBQQZBIyADQaQKIAYQoQEiAxAhIgcNACAIQR82AgwgCEEQaiAIQQxqIA8gBSAGEIMBIQwgCCgCDCEJIAJB2CNqIhIgAUHYI2ooAgA2AgAgACAAIANqIAcbIgcgCyAHayARQQggEiAIQRBqIAkgDCAFQQggAUGECGoiA0HgmgFBBSAJQR1JIBAQogEiDCAIQRBqIAkgDyAFQeCaAUEFQRwgA0GEBiAGEKEBIgMQISIJDQAgCEE0NgIMIAhBEGogCEEMaiANIAUgBhCDASESIAJB3CNqIhcgAUHcI2ooAgA2AgAgByADIAdqIAkbIgkgCyAJayACQYgOaiIYQQkgFyAIQRBqIAgoAgwiAiASIAVBCSABQYgOaiIDQaCbAUEGQQEgEBCiASIBIAhBEGogAiANIAVBoJsBQQZBNCADQawLIAYQoQEiAxAhIgINACAKIAxBBHQgFEEGdGogAUECdGo6AAAgCSADIAlqIAIbIgYgCyAGayAYIA0gESAPIBYgDiATIAUgFUEZSxDIAyIDECENACADIAZqIQUgByAAQQAgFEECRhsgDEECRhsiACAJIAIbIAAgAUECRhsiAARAQQAhAyAFIABrQQRIDQELIAUgBGshAwsgCEHwAWokACADC6kCAQx/IwBBIGsiBiQAAkAgBEEUdiAEQf//P3FBAEdqIg5FDQAgAyAEaiELQQEgAigCFHQhDCABKAIIIQUDQCAFIAEoAgxPDQEgBiAAKAIQNgIYIAYgACkCCDcDECAGIAApAgA3AwggCyADIAlBFHRqIgRBgIBAayALIARrQYCAwABJGyIHIARrIQ0gBkEIaiAHEO8BBEAgAigCBCEPIAAgDCAEEK0DIRAgACgCFEEBIA90IBAQrAMLIAAgByAMEKsDIAAgASACIAQgDRCqAyIEECEEQCAEIQgMAgsCfyAFIAEoAggiB0kEQCABKAIAIAVBDGxqIgUgBSgCBCAKajYCBCAEDAELIAogDWoLIQogByEFIAlBAWoiCSAORw0ACwsgBkEgaiQAIAgLNAECf0G6fyEFIANBA2oiBiABTQR/IAAgA0EDdCAEahCjASAAQQNqIAIgAxAqGiAGBSAFCwshACABIABrIAMoAgAgAmpLBEAgA0EANgIAIARBADYCAAsLPgECf0EBIQIgAUECTwR/IAAtAAAhAwJAA0AgAyAAIAJqLQAARw0BIAJBAWoiAiABRw0AC0EBDwtBAAUgAgsLTwEBfwJAIAAgASACIAMgBCAFIAcQ4gMiAEUgBiAFTUEAIABBun9GG3IEfyAIBSAAECFFDQEgAAsPCyAAQQAgACAGIAYgAygCHBDpAWtJGwuEAwEPfyAAKAKwAyEJIABBvANqIgcoAgQiASAHKAIAIgprIgQEQCAAKAKsAyAJQRRsaiELIAogAWsiASAEIAEgBEobQQN2IARBfyAEQX9KGyIBQQEgAUEBSBtsIgFBASABQQFLGyEMIAcoAighDQNAIAsgA0EUbGoiASAKIANBA3RqIgUoAgAiAjYCBCABIAUvAQQiBjYCCCABIAUvAQYiCEEDaiIFNgIMAkAgAyANRw0AAkACQCAHKAIkQX9qDgIAAQILIAEgBkGAgARyIgY2AggMAQsgASAIQYOABGoiBTYCDAsCQCABAn8gAkEDTQRAIAEgAiAGRWoiCDYCECABIAsgAyACayIOIAMgDiACQQNGG0F/aiAGGyICQRRsakEEaiACQX9zQQJ0QdCwAWogAkF/ShsoAgAiAjYCBCAIQQRHDQIgAkF/agwBCyACQX1qCzYCBAsgASAGIA9qIgE2AgAgASAFaiEPIANBAWoiAyAMRw0ACwsgACAEQQN1IAlqNgKwAwurAwEHfyMAQRBrIgUkACACQQZLBEAgAEG8A2oiBxDyASAAIAAoAqgEIgY2ApgFIAAgACgCxAE2ApwFIAEgACgCtARrIgQgACgCyAQiA0GAA2pLBEAgACAEIAQgA2tBgH1qIgRBwAEgBEHAAUkbazYCyAQLIABBsARqIgQQ7AEhCCAAKAKsBCIDIAYoAuQjNgLkIyADQegjaiAGQegjaigCADYCACADQewjaiAGQewjaigCADYCACADQeQjaiEDIAchBgJAIAEgAmoCfyAAKAKcBCAAKAKgBEkEQCAAQZgEaiAEIAcgAyABIAIQ6wEMAQsgAEHYAWoiCSgCAARAIAVCADcCBCAFIAAoApAENgIAIAUgACgClAQ2AgwgAEHoA2ogBSAJIAEgAhDjAyIDECENAiAFIAQgByAAKAKsBEHkI2ogASACEOsBDAELIAQgByADIAEgAiAAKAKgASAIEPMBEQIACyIAayEBIAYoAgwgASAAECoaIAYgBigCDCAAajYCDEEAIQMLIAVBEGokACADDwsgAEGYBGogAiAAKAKYARDqASAFQRBqJABBAQvrAQECfwJAAkACQEEBIAAgAyAEEOkDIgVBAUZBAnQgBRAhGw4FAAICAgECCyAAKAKoAwRAIAAQ6ANBAA8LIABBvANqIAAoAqgEIAAoAqwEIABBhAFqIAEgAiAEIAAoAsAFEOcDIgZBGEsNACAAKAK4Aw0AIAMgBBDmA0UNACABIAMtAAA6AABBASEGCyAGECEhAiAAKAKoBCEBAkAgBkECSQRAIAEhBQwBCyACBEAgASEFDAELIAAoAqwEIQUgACABNgKsBCAAIAU2AqgECyAFQdgjaigCAEECRgRAIAVBATYC2CMLIAYhBQsgBQtrAQJ/IAAoAiBBASABKAIMdCACEKABAkAgASgCHCIEQQFGDQBBASABKAIIdCEBIAAoAighAyAEQQZGBEAgAyABIAIQ3wMMAQsgAyABIAIQoAELIAAoAhwiAQRAIAAoAiRBASABdCACEKABCwtSAQF/IAAgACgCBCIEIAMgBGsiAyACayADQX8gAXRBf3NxayIBajYCBCAAIAAoAgggAWo2AgggACAAKAIQIAFrNgIQIAAgACgCDCABazYCDCABC5cBAQF/IwBBIGsiBSQAIAUgACgCEDYCGCAFIAApAgg3AxAgBSAAKQIANwMIIAVBCGogBBDvAQRAIAAgAigCCCACKAIcEPQBQQEgAigCBHQgAxDsAyEDIAEQ7gEgACACIAMQ6wMgARDtASAAQQA2AnAgAEEANgIUIABBACAAKAIYIgAgA2siASABIABLGzYCGAsgBUEgaiQAC/ECAQ1/IAAoAogBIQUgACgCpAIhByAAKAKoAQRAIABBwAJqIAMgBBCFAgsgAEGEAWohDEEBIAV0IQ0gAEGgBWohDiAAQcQEaiEPIABBgAJqIRAgAEGwBGohESABIQUCQANAIAJBBkkEQEG6fw8LIBEgECAMIAMgAyAEIAcgBCAHSRsiCGoiChDtAyAAKAK0BCAKIA0gDyAOEOUDIAAoAsgEIAAoAsAEIglJBEAgACAJNgLIBAsgACAFQQNqIAJBfWogAyAIEOoDIgYQIQ0BIAcgBE8hBwJAAn8CQAJAAkAgBg4CAAECCyAFIAIgAyAIIAcQ5AMiBhAhRQ0DDAULQQIhCyAHIQkgCEEDdAwBCyAGQQN0IQlBBCELIAcLIQMgBSADIAlyIAtyEKMBIAZBA2ohBgsgAEEANgK4AyACIAZrIQIgBSAGaiEFIAohAyAEIAgiB2siBA0ACyAFIAFLBEAgAEEDNgIACyAFIAFrIQYLIAYLrgEBA39BRCEDIAEhBSABIQQCQAJAAkACQCAAKAIADgQDAAECAQsgASACIABBhAFqQgBBABDxASIDECENAiAAQQI2AgAgASADaiEFIAIgA2shAgtBun8hAyACQQRJDQEgBUEBEE0gAkF9aiECIAVBA2ohBAsgACgCqAEEQEG6fyEDIAJBBEkNASAEIABBwAJqEIQCpxBNIARBBGohBAsgAEEANgIAIAQgAWshAwsgAwvtAQICfwF+QUQhBgJAAkACQAJAIAAoAgAOAgMAAQsgASACIABBhAFqIAApA6gCQn98IAAoAvwBEPEBIgUQIQ0BIABBAjYCACABIAVqIQEgAiAFayECCyAERQ0AIABBsARqIAMgBBDwAUUEQCAAIAAoArwENgLIBAsgACgC2AEEQCAAQegDaiADIAQQ8AEaCyAAIAEgAiADIAQQ7gMiBhAhDQEgACAAKQOwAiAErXwiBzcDsAIgACAAKQO4AiAFIAZqIgGtfDcDuAJBuH8gASAHQgF8IAApA6gCIgdWGyABIAdCAFIbDwsgBSEGCyAGC1sBAX4gACABIAIgAyAEEPADIgMQIQRAIAMPCyAAIAEgA2ogAiADaxDvAyIBECEEQCABDwsCfyAAKQOoAiIFUEUEQEG4fyAFIAApA7ACQgF8Ug0BGgsgASADagsLkAEBA38gACEBAkACQCAAQQNxRQ0AIAAtAABFBEBBAA8LA0AgAUEBaiIBQQNxRQ0BIAEtAAANAAsMAQsDQCABIgJBBGohASACKAIAIgNBf3MgA0H//ft3anFBgIGChHhxRQ0ACyADQf8BcUUEQCACIABrDwsDQCACLQABIQMgAkEBaiIBIQIgAw0ACwsgASAAawviAQEIfyAAKAIUIQMgACgCECEEIAAoAgQiAiAAKAIAIgVrIgEEQCAAKAIYIQYgBSACayICIAEgAiABShtBA3YgAUF/IAFBf0obIgFBASABQQFIG2wiAUEBIAFBAUsbIQdBACEBA0AgBSABQQN0aiICLwEGIQggASAEaiACLwEEEIABOgAAIAEgBmogAigCABAkOgAAIAEgA2ogCBA8OgAAIAFBAWoiASAHRw0ACwsgACgCJCIBQQFGBH8gBCAAKAIoakEjOgAAIAAoAiQFIAELQQJGBEAgAyAAKAIoakE0OgAACwvJAQEDfwJAQn8gAiACUBsiAkKAgICAAloEQCABKAIAIQQMAQtBBiEDIAKnIgRBwABPBEAgBEF/ahAkQQFqIQMLIAEoAgAiBCADTQ0AIAEgAzYCACADIQQLIAEoAgggBEEBaiIDSwRAIAEgAzYCCAsgBCABKAIEIgUgASgCGBD0ASIDSQRAIAEgBCAFaiADazYCBAsgBEEJTQRAIAFBCjYCAAsgACABKQIANwIAIAAgASgCGDYCGCAAIAEpAhA3AhAgACABKQIINwIIC9MBAgJ/AX4jAEFAaiIDJAAgA0J/IAIgAlAbIgVCgYAQVCAFQoGACFRqIAVCgYABVGpBhAVsQRZBACABQQMgARsgAUEASBsgAUEWShtBHGxqIgRBmIUBaigCADYCOCADIARBkIUBaikCADcDMCADIARBiIUBaikCADcDKCADIARBgIUBaikCADcDICABQX9MBEAgA0EAIAFrNgI0CyADIAMoAjg2AhggAyADKQMwNwMQIAMgAykDKDcDCCADIAMpAyA3AwAgACADIAIQ9AMgA0FAayQACyIBAX8CQCABRQ0AIAAoAgAgAUsNACAAKAIEIAFPIQILIAILSwEEfwJAIABFDQAgAEEMaiIBIAAQ9gMhAiABIAAoArAlIgEgAEG0JWooAgAiAyAAQbglaigCACIEEKQBIAINACAAIAEgAyAEEGQLCzQBAn8gAEEBQQEQWyAAEDkgACgCDCICIAAoAhBJBH8gAiAAKAIIayAAKAIEQQBHagUgAQsLJAAgACABNgIMIAAgATYCCCAAQgA3AgAgACABIAJqQXxqNgIQC/UBAQV/AkAgAUERSSADQQxJcg0AIABBBmoiByABQXpqIAIgA0EDakECdiIGIAQQcSIFECEEQCAFDwsgBUUNACAAIAVB//8DcRAvIAUgB2oiBSAAIAFqIgcgBWsgAiAGaiIIIAYgBBBxIgEQIQRAIAEPCyABRQ0AIABBAmogAUH//wNxEC8gASAFaiIFIAcgBWsgBiAIaiIIIAYgBBBxIgEQIQRAIAEPCyABRQ0AIABBBGogAUH//wNxEC8gASAFaiIFIAcgBWsgBiAIaiIBIAIgA2ogAWsgBBBxIgEQIQRAIAEPCyABRQ0AIAEgBWogAGshCQsgCQtGAQN/IAJBAEgEQEEBDwsDQCAEIAEgA0ECdCIFaigCAEEARyAAIAVqLQACRXFyIQQgAiADRyEFIANBAWohAyAFDQALIARFCyoBAX8jAEEQayIAJAAgAEEANgIMQZTpASgCAEG/EkEAELkBIABBEGokAAv4BgEHfyMAQUBqIgckAAJAIAAgAUEDdGoiBC0AByIFIAJNBEAgBSECDAELIARBB2ohBkEBIAUgAmsiCXQhCEEAIQQgBSEDA0AgBiACOgAAIAQgCGpBfyAFIANrdGohBCAAIAFBf2oiAUEDdGoiA0EHaiEGIAMtAAciAyACSw0ACwNAIANB/wFxIAJHRQRAIAAgAUF/aiIBQQN0ai0AByEDDAELCyAHQvDhw4ePnrz4cDcDMCAHQvDhw4ePnrz4cDcDKCAHQvDhw4ePnrz4cDcDICAHQvDhw4ePnrz4cDcDGCAHQvDhw4ePnrz4cDcDECAHQvDhw4ePnrz4cDcDCCAHQvDhw4ePnrz4cDcDACAEIAl1IQUCQCABQX9MDQAgAiEGIAEhBANAIAYgA0H/AXEiA0sEQCAHIAIgA2tBAnRqIAQ2AgAgAyEGCyAEQQFIDQEgACAEQX9qIgRBA3RqLQAHIQMMAAsACyAFQQBKBEADQAJAAkAgBRAkQQFqIgRBAkkEQCAEIQMMAQsgByAEQQJ0aigCACEIA0ACQCAHIARBf2oiBkECdGooAgAhCSAIQfDhw4d/RwRAIAlB8OHDh39GDQEgACAIQQN0aigCACAAIAlBA3RqKAIAQQF0TQ0BC0EBIQMgCSEIIAYiBEEBSw0BDAILCyAEIgNBDEsNAQsDQAJAIAcgA0ECdGooAgBB8OHDh39HBEAgAyEEDAELQQ0hBCADQQFqIgNBDUcNAQsLIAcgBEF/aiIGQQJ0aigCACEJCyAHIARBAnRqIggoAgAhAyAJQfDhw4d/RgRAIAcgBkECdGogAzYCAAtBfyAGdCAFaiEFIAAgA0EDdGoiBiAGLQAHQQFqOgAHIAggAwR/IAggA0F/aiIDNgIAIANB8OHDh38gACADQQN0ai0AByACIARrRhsFQfDhw4d/CzYCACAFQQBKDQALCyAFQX9KDQAgBygCBCEEA0AgBUF/IAVBf0obIQYgBSEDA0AgBEHw4cOHf0YEQCABIQQDQCAEIgFBf2ohBCAAIAFBA3RqLQAHIAJGDQALIAAgAUEBaiIEQQN0aiIGIAYtAAdBf2o6AAcgA0EBaiEFIANBfkoNAwwCCyAAIARBAWoiBEEDdGoiBSAFLQAHQX9qOgAHIAMgBkchBSADQQFqIQMgBQ0ACwsLIAdBQGskACACC74CAQd/IwBBgAJrIgQkACAEQQBBgAIQKCEFA0AgBSABIANBAnRqKAIAQQFqECRBA3RqIgQgBCgCAEEBajYCACADQQFqIgMgAk0NAAtBHiEDIAUoAvABIQQDQCAFIANBf2oiA0EDdGoiByAHKAIAIARqIgQ2AgAgAw0AC0EAIQMDQCAFIANBA3RqIgQgBCgCADYCBCADQQFqIgNBIEcNAAsDQCABIAZBAnRqKAIAIghBAWoQJEEDdCAFaiIEIgNBDGogAygCDCIDQQFqNgIAAkAgAyAEKAIIIgRNDQADQCAIIAAgA0F/aiIHQQN0aiIJKAIATQ0BIAAgA0EDdGogCSkCADcCACAHIgMgBEsNAAsgBCEDCyAAIANBA3RqIgMgBjoABiADIAg2AgAgBkEBaiIGIAJNDQALIAVBgAJqJAAL4wYBDH8jAEFAaiIHJABBfyEFAkACQAJAIARBA3ENAEFSIQUgAkH/AUsNACADQQsgAxshDCAEQQBBgCAQKCEIIARBCGoiBiABIAIQ/gMgAiEDA0AgAyIFQX9qIQMgBiAFQQN0aigCACIBRQ0ACyAIIAEgBiADQQN0aiIBKAIAajYCiBAgAUGAAjsBBCAGIAVBA3RqQYACOwEEIAVB/wFqIgpBgAJNDQEgBUF+aiEDQYECIQEDQCAGIAFBA3RqQYCAgIAENgIAIAFBAWoiASAKTQ0ACyAIQYCAgIB4NgIAQYACIQFBgQIhCEGBAiEEA0AgBiAIQQN0aiAGIAMgBiADQQN0aigCACIJIAYgAUEDdGooAgAiC0kiDWsiCCABIAkgC09qIgkgBiAIQQN0aigCACILIAYgCUEDdGooAgAiDkkiDxtBA3RqIhAoAgAgBiADIAEgDRtBA3RqIgEoAgBqNgIAIBAgBDsBBCABIAQ7AQQgCSALIA5PaiEBIAggD2shAyAKIARBAWoiBEH//wNxIghPDQALDAILIAdBQGskACAFDwsgCEGAgICAeDYCAAtBACEDIAYgCkEDdGpBADoAByAFQf4BaiIBQYACTwRAA0AgBiABQQN0aiIEIAYgBC8BBEEDdGotAAdBAWo6AAcgAUF/aiIBQf8BSw0ACwsDQCAGIANBA3RqIgEgBiABLwEEQQN0ai0AB0EBajoAByADQQFqIgMgBU0NAAsgBiAFIAwQ/QMhBEEAIQMgB0EAOwE4IAdCADcDMCAHQgA3AyggB0IANwMgIAdBADsBGCAHQgA3AxAgB0IANwMIIAdCADcDAEF/IQEgBEEMTQRAA0AgB0EgaiAGIANBA3RqLQAHQQF0aiIBIAEvAQBBAWo7AQAgA0EBaiIDIAVNDQALIAQEQEEAIQUgBCEDA0AgByADQQF0IgFqIAU7AQAgB0EgaiABai8BACAFakH+/wNxQQF2IQUgA0F/aiIDDQALC0EAIQVBACEDA0AgACAGIANBA3RqIgEtAAZBAnRqIAEtAAc6AAIgA0EBaiIDIAJNDQALA0AgByAAIAVBAnRqIgEtAAJBAXRqIgMgAy8BACIDQQFqOwEAIAEgAzsBACAFQQFqIgUgAk0NAAsgBCEBCyAHQUBrJAAgAQvdAgEFfyMAQZACayIGJABBUiEFAkAgA0H/AUsNACAGQQA6AIMCQQEhBSAEQQFqIghBAUsEQANAIAZBgwJqIAVqIAggBWs6AAAgBCAFRiEJIAVBAWohBSAJRQ0ACwsCfyADBEADQCAGIAdqIAIgB0ECdGotAAIgBkGDAmpqLQAAOgAAIAdBAWoiByADRw0ACyAAQQFqIAFBf2ogBiADEPoBDAELIABBAWogAUF/aiAGQQAQ+gELIgUQIQ0AIAVBAkkgBSADQQF2T3JFBEAgACAFOgAAIAVBAWohBQwBC0F/IQUgA0GAAUsNAEG6fyEFIANBAWpBAXYiAiABTw0AIAJBAWohBSAAIANB/wBqOgAAQQAhByADIAZqQQA6AAAgA0UNAANAIAdBAXYgAGogBiAHQQFyai0AACAGIAdqLQAAQQR0ajoAASAHQQJqIgcgA0kNAAsLIAZBkAJqJAAgBQt/AQR/IwBBkARrIgQkACAEQf8BNgIIAkAgBEEQaiAEQQhqIARBDGogASACEGsiBhAhBEAgBiEFDAELQVQhBSAEKAIMIgdBBksNACADIARBEGogBCgCCCAHEIMEIgUQIQ0AIAAgASAGaiACIAZrIAMQggQhBQsgBEGQBGokACAFC+8FAQN/IwBBMGsiBCQAAkAgAy8BAgRAIARBGGogASACEEUiARAhDQEgBEEQaiAEQRhqIAMQggEgBEEIaiAEQRhqIAMQggFBACEBAkAgBEEYahAjBEBBACEDDAELA0AgACABaiICIARBEGogBEEYahBiOgAAIAIgBEEIaiAEQRhqEGI6AAEgBEEYahAjBEAgAUECciEDDAILIAIgBEEQaiAEQRhqEGI6AAIgAiAEQQhqIARBGGoQYjoAAyABQQRqIQMgBEEYahAjIQIgAUH3AUsNASADIQEgAkUNAAsLAn8DQEG6fyEBIANB/QFLDQMgACADaiICIARBEGogBEEYahBiOgAAIAIiBkEBaiEFIARBGGoQI0EDRgRAQQIhAyAEQQhqDAILIANB/AFLDQMgBiAEQQhqIARBGGoQYjoAASADQQJqIQMgBEEYahAjQQNHDQALIAAgA2ohBUEDIQMgBEEQagshASAFIAEgBEEYahBiOgAAIAIgA2ogAGshAQwBCyAEQRhqIAEgAhBFIgEQIQ0AIARBEGogBEEYaiADEIIBIARBCGogBEEYaiADEIIBQQAhAQJAIARBGGoQIwRAQQAhAwwBCwNAIAAgAWoiAiAEQRBqIARBGGoQYToAACACIARBCGogBEEYahBhOgABIARBGGoQIwRAIAFBAnIhAwwCCyACIARBEGogBEEYahBhOgACIAIgBEEIaiAEQRhqEGE6AAMgAUEEaiEDIARBGGoQIyECIAFB9wFLDQEgAyEBIAJFDQALCwJ/A0BBun8hASADQf0BSw0CIAAgA2oiAiAEQRBqIARBGGoQYToAACACIgZBAWohBSAEQRhqECNBA0YEQEECIQMgBEEIagwCCyADQfwBSw0CIAYgBEEIaiAEQRhqEGE6AAEgA0ECaiEDIARBGGoQI0EDRw0ACyAAIANqIQVBAyEDIARBEGoLIQEgBSABIARBGGoQYToAACACIANqIABrIQELIARBMGokACABC68DAQp/IwBBgARrIgkkAEFSIQUCQCACQf8BSw0AIABBBGohCkGAgAQgA0F/anRBEHUhC0EBIAN0IghBf2oiDCEHQQEhBQNAAkAgASAEQQF0Ig1qLwEAIgZB//8DRgRAIAogB0ECdGogBDoAAiAHQX9qIQdBASEGDAELIAVBACALIAZBEHRBEHVKGyEFCyAJIA1qIAY7AQAgAiAERyEGIARBAWohBCAGDQALIAAgBTsBAiAAIAM7AQAgCEEDdiAIQQF2akEDaiEGQQAhBEEAIQUDQCABIAVBAXRqLgEAIgBBAU4EQCAAQf//A3EiAEEBIABBAUsbIQtBACEAA0AgCiAEQQJ0aiAFOgACA0AgBCAGaiAMcSIEIAdLDQALIABBAWoiACALRw0ACwsgAiAFRyEAIAVBAWohBSAADQALQX8hBSAEDQAgCEEBIAhBAUsbIQJBACEFQQAhBANAIAkgCiAEQQJ0aiIALQACQQF0aiIBIAEvAQAiAUEBajsBACAAIAMgARAkayIHOgADIAAgASAHdCAIazsBACAEQQFqIgQgAkcNAAsLIAlBgARqJAAgBQsjAQF/IAAgACgCBCIBQQFqNgIEIAAgACgCAEEBIAF0cjYCAAtZAQF/IAAgAC0ASiIBQX9qIAFyOgBKIAAoAgAiAUEIcQRAIAAgAUEgcjYCAEF/DwsgAEIANwIEIAAgACgCLCIBNgIcIAAgATYCFCAAIAEgACgCMGo2AhBBAAuzAgECfyMAQUBqIgYkAAJAIANBA0kNACAGQShqIAAgARD/ARAhDQAgAiADakF/aiIALQAAIQECQCADQQFxBEAgBkEYaiAEIAEQYyAGQQhqIAQgAEF/ai0AABBjIAZBKGogBkEYaiAAQX5qIgMtAAAQbCAFBEAgBkEoahD+AQwCCyAGQShqEDkMAQsgBkEIaiAEIAEQYyAGQRhqIAQgAEF/aiIDLQAAEGMLIAMgAksEQANAIAZBKGogBkEIaiADQX9qLQAAEGwgBkEoaiAGQRhqIANBfmoiAy0AABBsAkAgBQRAIAZBKGoQ/gEMAQsgBkEoahA5CyADIAJLDQALCyAGQShqIAYoAgggBigCFBB0IAZBKGogBigCGCAGKAIkEHQgBkEoahD9ASEHCyAGQUBrJAAgBwskACAAQQA2AQQgAEEAOwEAIAAgATsBAiAAIAFBA3RqQgA3AggLzgQCBn8EfiADQQNsIAFBAWp2IQggAyABdiEKA0ACQCACIAVBAnRqKAIAIgZFBEAgACAFQQF0akEAOwEADAELAkACQCAGIApNBEAgACAFQQF0akH//wM7AQAMAQsgACAFQQF0aiEJIAYgCEsNASAJQQE7AQALIAMgBmshAyAHQQFqIQcMAQsgCUH+/wM7AQALIAVBAWoiBSAETQ0ACwJAAkBBASABdCIJIAdrIgZFDQAgAyAGbiAISwRAIANBA2wgBkEBdG4hBkEAIQUDQAJAIAAgBUEBdGoiCC8BAEH+/wNHDQAgAiAFQQJ0aigCACIKIAZLDQAgCEEBOwEAIAMgCmshAyAHQQFqIQcLIAVBAWoiBSAETQ0ACyAJIAdrIQYLIAcgBEEBaiIHRgRAQQAhBUEAIQFBACEDA0AgAiAFQQJ0aigCACIHIAEgByABSyIHGyEBIAUgAyAHGyEDIAVBAWoiBSAETQ0ACyAAIANBAXRqIgAgAC8BACAGajsBAAwBCyADRQRAQQAhAiAGRQ0CQQAhBQNAIAAgBUEBdGoiAS4BACIDQQFOBEAgASADQQFqOwEAIAZBf2ohBgsgBUEBaiAHcCEFIAYNAAsMAgsgBq1BPiABa60iC4ZCfyALQn98hkJ/hSIMfCADrYAhDUEAIQUDQCAAIAVBAXRqIgEvAQBB/v8DRgRAIAwgC4ghDiANIAIgBUECdGo1AgB+IAx8IgwgC4inIA6nayIDRQRAQX8PCyABIAM7AQALIAVBAWoiBSAETQ0ACwtBACECCyACC0QBAX9BfyEFIARBA3EEfyAFBSABKAIAQf4BTQRAIAAgASACIANBASAEEIMCDwsgAUH/ATYCACAAIAEgAiADIAQQgwELC1gBAX8jAEEQayIEJAACf0EBIAAgASAEQQxqEMAERQ0AGkECIAMoAgAgBCgCDEkNABpBASAAIAEgAhChBEUNABogAyAEKAIMNgIAQQALIQAgBEEQaiQAIAALiQIBA38CQAJAIAAoAhwiAygCNCIERQRAQQEhBSADIAAoAihBASADKAIkdEEBIAAoAiARAQAiBDYCNCAERQ0BCyADKAIoIgBFBEAgA0IANwIsIANBASADKAIkdCIANgIoCyAAIAJNBEAgBCABIABrIAAQKhogA0EANgIwDAILIAQgAygCMCIFaiABIAJrIAIgACAFayIAIAAgAksbIgAQKhogAiAAayICBEAgAygCNCABIAJrIAIQKhogAyACNgIwDAILQQAhBSADQQAgAygCMCAAaiIBIAEgAygCKCICRhs2AjAgAygCLCIBIAJPDQAgAyAAIAFqNgIsCyAFDwsgAyADKAIoNgIsQQALsjcBHX8jAEEQayISJABBfiEUAkAgAEUNACAAKAIcIgFFDQAgACgCDCIORQ0AIAAoAgAiBkUEQCAAKAIEDQELIAEoAgAiAkELRgRAIAFBDDYCAEEMIQILIAFB2ABqIRsgAUHwBWohFyABQfAAaiEZIAFB1ABqIRogAUHsAGohGCABQbAKaiEWIAEoAjwhBCABKAI4IQUgACgCBCIcIQcgACgCECIMIRMCQANAAkBBfCEUQQEhAwJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAn8CQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAIOHwgJCg0QAwIBABobHBwdHh8gIQclJgY3BTknKARFLkYvCyABKAIQIQMMGAsgASgCECEDDBYLIAEoAhAhAwwUCyABKAIQIQMMEgsgASgCCCEJDCQLIAEoAkghCQwyCyABKAJIIQkMLwsgASgCaCEJDBwLIAEoAggiA0UNISAEQRBJBEADQCAHRQ08IAdBf2ohByAGLQAAIAR0IAVqIQUgBEEISSECIARBCGohBCAGQQFqIQYgAg0ACwsgA0ECcUUgBUGflgJHckUEQEEAIQUgAUEAQQBBABA1IgM2AhggEkGflgI7AAwgAyASQQxqQQIQNSEDIAFBATYCACABIAM2AhhBACEEIAEoAgAhAgw8CyABQQA2AhAgASgCICICBEAgAkF/NgIwCwJAIANBAXEEQCAFQQh0QYD+A3EgBUEIdmpBH3BFDQELIABBnu8ANgIYIAFBHTYCACABKAIAIQIMPAsgBUEPcUEIRwRAIABBte8ANgIYIAFBHTYCACABKAIAIQIMPAsgBUEEdiIDQQ9xIghBCGohAiABKAIkIglFBEAgASACNgIkDDoLIAIgCU0NOSAEQXxqIQQgAEHQ7wA2AhggAUEdNgIAIAMhBSABKAIAIQIMOwsgBEEQSQRAA0AgB0UNOyAHQX9qIQcgBi0AACAEdCAFaiEFIARBCEkhAyAEQQhqIQQgBkEBaiEGIAMNAAsLIAEgBTYCECAFQf8BcUEIRwRAIABBte8ANgIYIAFBHTYCACABKAIAIQIMOwsgBUGAwANxBEAgAEHk7wA2AhggAUEdNgIAIAEoAgAhAgw7CyABKAIgIgMEQCADIAVBCHZBAXE2AgALIAVBgARxBEAgEiAFOwAMIAEgASgCGCASQQxqQQIQNTYCGAsgAUECNgIAQQAhBEEAIQUMAQsgBEEfSw0BCyAGIQIDQCAHRQRAQQAhByACIQYgDyEDDDsLIAdBf2ohByACLQAAIAR0IAVqIQUgBEEYSSEDIARBCGohBCACQQFqIgYhAiADDQALCyABKAIgIgMEQCADIAU2AgQLIAEtABFBAnEEQCASIAU2AAwgASABKAIYIBJBDGpBBBA1NgIYCyABQQM2AgBBACEEQQAhBQwBCyAEQQ9LDQELIAYhAgNAIAdFBEBBACEHIAIhBiAPIQMMOAsgB0F/aiEHIAItAAAgBHQgBWohBSAEQQhJIQMgBEEIaiEEIAJBAWoiBiECIAMNAAsLIAEoAiAiCQRAIAkgBUEIdjYCDCAJIAVB/wFxNgIICyABKAIQIgNBgARxBEAgEiAFOwAMIAEgASgCGCASQQxqQQIQNTYCGAsgAUEENgIAQQAhBEEAIQVBACICIANBgAhxRQ0BGgwDCyABKAIQIgNBgAhxDQEgASgCICEJIAQLIQQgCQRAIAlBADYCEAsMAwsgBSECIARBD0sNAQsDQCAHRQRAQQAhByACIQUgDyEDDDMLIAdBf2ohByAGLQAAIAR0IAJqIQIgBEEISSEFIARBCGohBCAGQQFqIgghBiAFDQALIAghBiACIQULIAEgBTYCQCABKAIgIgIEQCACIAU2AhQLQQAhBCADQYAEcQRAIBIgBTsADCABIAEoAhggEkEMakECEDU2AhgLQQAhBQsgAUEFNgIACwJAIANBgAhxRQ0AIAcgASgCQCICIAIgB0sbIggEQAJAIAEoAiAiCUUNACAJKAIQIgpFDQAgCiAJKAIUIAJrIgNqIAYgCSgCGCICIANrIAggAyAIaiACSxsQKhogASgCECEDCyADQYAEcQRAIAEgASgCGCAGIAgQNTYCGAsgASABKAJAIAhrIgI2AkAgByAIayEHIAYgCGohBgsgAkUNACAPIQMMLwsgAUEGNgIAIAFBADYCQAsCQCADQYAQcQRAQQAhAyAHRQ0tA0AgA0EBaiECIAMgBmotAAAhCAJAIAEoAiAiA0UNACADKAIcIgpFDQAgASgCQCIJIAMoAiBPDQAgASAJQQFqNgJAIAkgCmogCDoAAAsgByACSwRAIAIhAyAIDQELCyABKAIQIgNBgARxBEAgASABKAIYIAYgAhA1NgIYCyACIAZqIQYgByACayEHIAhFDQEgDyEDDC8LIAEoAiAiAkUNACACQQA2AhwLIAFBBzYCACABQQA2AkALAkAgA0GAIHEEQEEAIQMgB0UNLANAIANBAWohAiADIAZqLQAAIQgCQCABKAIgIgNFDQAgAygCJCIKRQ0AIAEoAkAiCSADKAIoTw0AIAEgCUEBajYCQCAJIApqIAg6AAALIAcgAksEQCACIQMgCA0BCwsgASgCECIDQYAEcQRAIAEgASgCGCAGIAIQNTYCGAsgAiAGaiEGIAcgAmshByAIRQ0BIA8hAwwuCyABKAIgIgJFDQAgAkEANgIkCyABQQg2AgALIANBgARxBEAgBEEPTQRAA0AgB0UNLCAHQX9qIQcgBi0AACAEdCAFaiEFIARBCEkhAiAEQQhqIQQgBkEBaiEGIAINAAsLIAUgAS8BGEcNF0EAIQVBACEECyABKAIgIgIEQCACQQE2AjAgAiADQQl2QQFxNgIsCyABQQBBAEEAEDUiAzYCGCAAIAM2AjAgAUELNgIAIAEoAgAhAgwqCyAEQSBJBEADQCAHRQ0qIAdBf2ohByAGLQAAIAR0IAVqIQUgBEEYSSEDIARBCGohBCAGQQFqIQYgAw0ACwsgASAFQQh0QYCA/AdxIAVBGHRyIAVBCHZBgP4DcSAFQRh2cnIiAzYCGCAAIAM2AjAgAUEKNgIAQQAhBUEAIQQLIAEoAgxFBEAgACAMNgIQIAAgDjYCDCAAIAc2AgQgACAGNgIAIAEgBDYCPCABIAU2AjhBAiEUDCsLIAFBAEEAQQAQZSIDNgIYIAAgAzYCMCABQQs2AgALIAEoAgQNFCAEQQJLBH8gBAUgB0UNJyAHQX9qIQcgBi0AACAEdCAFaiEFIAZBAWohBiAEQQhqCyEDIAEgBUEBcTYCBEENIQQCQAJAAkACQCAFQQF2QQNxQQFrDgMAAQIDCyABQaDzADYCTCABQomAgIDQADcCVCABQaCDATYCUEETIQQMAgtBECEEDAELIABBkfAANgIYQR0hBAsgASAENgIAIANBfWohBCAFQQN2IQUgASgCACECDCcLIAUgBEEHcXYhBSAEQXhxIgRBH00EQANAIAdFDScgB0F/aiEHIAYtAAAgBHQgBWohBSAEQRhJIQMgBEEIaiEEIAZBAWohBiADDQALCyAFQf//A3EiAyAFQX9zQRB2RwRAIABBpPAANgIYIAFBHTYCACABKAIAIQIMJwsgAUEONgIAIAEgAzYCQEEAIQVBACEECyABQQ82AgALIAEoAkAiAwRAIAwgByADIAMgB0sbIgMgAyAMSxsiA0UEQCAPIQMMJwsgDiAGIAMQKiECIAEgASgCQCADazYCQCACIANqIQ4gDCADayEMIAMgBmohBiAHIANrIQcgASgCACECDCULIAFBCzYCACABKAIAIQIMJAsgBEEOSQRAA0AgB0UNJCAHQX9qIQcgBi0AACAEdCAFaiEFIARBBkkhAyAEQQhqIQQgBkEBaiEGIAMNAAsLIAEgBUEfcSIDQYECajYCYCABIAVBBXZBH3EiAkEBajYCZCABIAVBCnZBD3FBBGoiCDYCXCAEQXJqIQQgBUEOdiEFIANBHU1BACACQR5JG0UEQCAAQcHwADYCGCABQR02AgAgASgCACECDCQLIAFBETYCAEEAIQIgAUEANgJoDAELIAEoAmgiAiABKAJcIghPDQELIAIhAwNAIARBAk0EQCAHRQ0iIAdBf2ohByAGLQAAIAR0IAVqIQUgBkEBaiEGIARBCGohBAsgASADQQFqIgI2AmggASADQQF0QfDwAGovAQBBAXRqIAVBB3E7AXAgBEF9aiEEIAVBA3YhBSACIQMgAiAISQ0ACwsgAkETSQRAA0AgASACQQF0QfDwAGovAQBBAXRqQQA7AXAgAkEBaiICQRNHDQALIAFBEzYCaAsgAUEHNgJUIAEgFjYCTCABIBY2AmxBACEJQQAgGUETIBggGiAXEKwBIg8EQCAAQZbxADYCGCABQR02AgAgASgCACECDCELIAFBEjYCACABQQA2AmhBACEPCyAJIAEoAmAiHSABKAJkaiIQSQRAQX8gASgCVHRBf3MhFSABKAJMIQ0DQCAEIQogByECIAYhAwJAIAQgDSAFIBVxIhFBAnRqLQABIgtPBEAgBCEIDAELA0AgAkUNCiADLQAAIAp0IQsgA0EBaiEDIAJBf2ohAiAKQQhqIgghCiAIIA0gBSALaiIFIBVxIhFBAnRqLQABIgtJDQALCwJAIA0gEUECdGovAQIiBEEPTQRAIAEgCUEBaiIGNgJoIAEgCUEBdGogBDsBcCAIIAtrIQQgBSALdiEFIAYhCQwBCwJ/An8CQAJAAkAgBEFwag4CAAECCyAIIAtBAmoiBkkEQANAIAJFDSUgAkF/aiECIAMtAAAgCHQgBWohBSADQQFqIQMgCEEIaiIIIAZJDQALCyAIIAtrIQQgBSALdiEIIAlFBEAgAEGv8QA2AhggAUEdNgIAIAMhBiACIQcgCCEFIAEoAgAhAgwnCyAEQX5qIQQgCEECdiEFIAhBA3FBA2ohByAJQQF0IAFqLwFuDAMLIAggC0EDaiIGSQRAA0AgAkUNJCACQX9qIQIgAy0AACAIdCAFaiEFIANBAWohAyAIQQhqIgggBkkNAAsLIAggC2tBfWohBCAFIAt2IgZBA3YhBSAGQQdxQQNqDAELIAggC0EHaiIGSQRAA0AgAkUNIyACQX9qIQIgAy0AACAIdCAFaiEFIANBAWohAyAIQQhqIgggBkkNAAsLIAggC2tBeWohBCAFIAt2IgZBB3YhBSAGQf8AcUELagshB0EACyEGIAcgCWogEEsEQCAAQa/xADYCGCABQR02AgAgAyEGIAIhByABKAIAIQIMIwsDQCABIAlBAXRqIAY7AXAgCUEBaiEJIAdBf2oiBw0ACyABIAk2AmgLIAMhBiACIQcgCSAQSQ0ACwsgAS8B8ARFBEAgAEHJ8QA2AhggAUEdNgIAIAEoAgAhAgwgCyABQQk2AlQgASAWNgJMIAEgFjYCbEEBIBkgHSAYIBogFxCsASIPBEAgAEHu8QA2AhggAUEdNgIAIAEoAgAhAgwgCyABQQY2AlggASABKAJsNgJQQQIgASABKAJgQQF0akHwAGogASgCZCAYIBsgFxCsASIPBEAgAEGK8gA2AhggAUEdNgIAIAEoAgAhAgwgCyABQRM2AgBBACEPCyABQRQ2AgALIAxBggJJIAdBBklyRQRAIAAgDDYCECAAIA42AgwgACAHNgIEIAAgBjYCACABIAQ2AjwgASAFNgI4IAAgExCRBCABKAI8IQQgASgCOCEFIAAoAgQhByAAKAIAIQYgACgCECEMIAAoAgwhDiABKAIAQQtHDRYgAUF/NgLENyABKAIAIQIMHgsgAUEANgLENyAEIQkgByECIAYhAwJAIAQgASgCTCIQIAVBfyABKAJUdEF/cyINcSILQQJ0ai0AASIKTwRAIAQhCAwBCwNAIAJFDQggAy0AACAJdCEKIANBAWohAyACQX9qIQIgCUEIaiIIIQkgCCAQIAUgCmoiBSANcSILQQJ0ai0AASIKSQ0ACwsgCiEEIBAgC0ECdGoiBi8BAiERIAYtAAAiDUUgDUHwAXFyDQ0gAiEHIAMhBgJAIAQgECAFQX8gBCANanRBf3MiFXEgBHYgEWoiDUECdGotAAEiCmogCCIJTQRAIAghCwwBCwNAIAdFDQcgBi0AACAJdCEKIAZBAWohBiAHQX9qIQcgCUEIaiILIQkgBCAQIAUgCmoiBSAVcSAEdiARaiINQQJ0ai0AASIKaiALSw0ACwsgECANQQJ0aiIDLQAAIQ0gAy8BAiERIAEgBDYCxDcgCyAEayEIIAUgBHYhBQwOCyAMRQ0SIA4gASgCQDoAACABQRQ2AgAgDEF/aiEMIA5BAWohDiABKAIAIQIMHAsgASgCCCIJBEAgBEEfTQRAA0AgB0UNHSAHQX9qIQcgBi0AACAEdCAFaiEFIARBGEkhAiAEQQhqIQQgBkEBaiEGIAINAAsLIAAgEyAMayICIAAoAhRqNgIUIAEgASgCHCACajYCHAJAIAJFBEAgASgCECEIIAEoAhghAgwBCyAOIAJrIQogASgCGCETIAECfyABKAIQIggEQCATIAogAhA1DAELIBMgCiACEGULIgI2AhggACACNgIwCyAFIAVBCHRBgID8B3EgBUEYdHIgBUEIdkGA/gNxIAVBGHZyciAIGyACRw0KQQAhBSAMIRNBACEECyABQRs2AgALAkAgCUUNACABKAIQRQ0AIARBH00EQANAIAdFDRwgB0F/aiEHIAYtAAAgBHQgBWohBSAEQRhJIQIgBEEIaiEEIAZBAWohBiACDQALCyAFIAEoAhxHDQpBACEFQQAhBAsgAUEcNgIADBsLIAFBDDYCAAwRCyAGIAdqIQYgBCAHQQN0aiEEDBcLIAIgA2ohBiAIIAJBA3RqIQQMFgsgBiAHaiEGIAQgB0EDdGohBAwVC0F9IQMMFgtBfiEUDBYLIABB/e8ANgIYIAFBHTYCACABKAIAIQIMEwsgAUEaNgIAIAUgBEEHcXYhBSAEQXhxIQQgASgCACECDBILIABB8PIANgIYIAFBHTYCACAMIRMgASgCACECDBELIABBhfMANgIYIAFBHTYCACABKAIAIQIMEAtBACEEIAMhBiACIQcLIAEgEUH//wNxNgJAIAEgBCAKajYCxDcgCCAKayEEIAUgCnYhBSANRQRAIAFBGTYCACABKAIAIQIMDwsgDUEgcQRAIAFBCzYCACABQX82AsQ3IAEoAgAhAgwPCyANQcAAcQRAIABBoPIANgIYIAFBHTYCACABKAIAIQIMDwsgAUEVNgIAIAEgDUEPcSIJNgJICyAGIQggByEKAkAgCUUEQCABKAJAIQMMAQsgCCEDIAQiAiAJSQRAA0AgB0UNDCAHQX9qIQcgAy0AACACdCAFaiEFIANBAWoiBiEDIAJBCGoiAiAJSQ0ACwsgASABKALENyAJajYCxDcgASABKAJAIAVBfyAJdEF/c3FqIgM2AkAgAiAJayEEIAUgCXYhBQsgAUEWNgIAIAEgAzYCyDcLIAQhCSAHIQIgBiEDAkAgBCABKAJQIhAgBUF/IAEoAlh0QX9zIg1xIgtBAnRqLQABIgpPBEAgBCEIDAELA0AgAkUNCSADLQAAIAl0IQogA0EBaiEDIAJBf2ohAiAJQQhqIgghCSAIIBAgBSAKaiIFIA1xIgtBAnRqLQABIgpJDQALCyAQIAtBAnRqIgYvAQIhEQJAIAYtAAAiDUHwAXEEQCABKALENyEEIAMhBiACIQcgCiEJDAELIAIhByADIQYCQCAKIBAgBUF/IAogDWp0QX9zIhVxIAp2IBFqIg1BAnRqLQABIglqIAgiBE0EQCAIIQsMAQsDQCAHRQ0JIAYtAAAgBHQhCSAGQQFqIQYgB0F/aiEHIARBCGoiCyEEIAogECAFIAlqIgUgFXEgCnYgEWoiDUECdGotAAEiCWogC0sNAAsLIBAgDUECdGoiAy0AACENIAMvAQIhESABIAEoAsQ3IApqIgQ2AsQ3IAsgCmshCCAFIAp2IQULIAEgBCAJajYCxDcgCCAJayEEIAUgCXYhBSANQcAAcQRAIABBvPIANgIYIAFBHTYCACABKAIAIQIMDQsgAUEXNgIAIAEgDUEPcSIJNgJIIAEgEUH//wNxNgJECyAGIQggByEKIAkEQCAIIQMgBCICIAlJBEADQCAHRQ0HIAdBf2ohByADLQAAIAJ0IAVqIQUgA0EBaiIGIQMgAkEIaiICIAlJDQALCyABIAEoAsQ3IAlqNgLENyABIAEoAkQgBUF/IAl0QX9zcWo2AkQgBSAJdiEFIAIgCWshBAsgAUEYNgIACyAMDQELQQAhDCAPIQMMCgsCQCABKAJEIgMgEyAMayICSwRAAkAgAyACayICIAEoAixNDQAgASgCwDdFDQAgAEHS8gA2AhggAUEdNgIAIAEoAgAhAgwLCwJ/IAIgASgCMCIDSwRAIAEoAiggAiADayICawwBCyADIAJrCyEIIAEoAkAiFCACIAIgFEsbIQMgASgCNCAIaiECDAELIA4gA2shAiABKAJAIhQhAwsgASAUIAwgAyADIAxLGyIIazYCQCAIIQMDQCAOIAItAAA6AAAgDkEBaiEOIAJBAWohAiADQX9qIgMNAAsgDCAIayEMIAEoAkANACABQRQ2AgAgASgCACECDAgLIAEoAgAhAgwHCyAIIApqIQYgBCAKQQN0aiEEDAULIAIgA2ohBiAIIAJBA3RqIQQMBAsgBiAHaiEGIAQgB0EDdGohBAwDCyAIIApqIQYgBCAKQQN0aiEEDAILQQAhByADIQYgCCEEIA8hAwwDCyABQYACIAh0NgIUQQAhBCABQQBBAEEAEGUiAzYCGCAAIAM2AjAgAUEJQQsgBUGAwABxGzYCAEEAIQUgASgCACECDAELC0EAIQcgDyEDCyAAIAw2AhAgACAONgIMIAAgBzYCBCAAIAY2AgAgASAENgI8IAEgBTYCOAJAAkAgASgCKEUEQCAMIBNGDQEgASgCAEEZSw0BCyAAIA4gEyAMaxCLBA0BIAAoAhAhDCAAKAIEIQcLIAAgACgCCCAcIAdrajYCCCAAIBMgDGsiAiAAKAIUajYCFCABIAEoAhwgAmo2AhwCQCACRQ0AIAEoAghFDQAgACgCDCACayEGIAEoAhghBCABAn8gASgCEARAIAQgBiACEDUMAQsgBCAGIAIQZQsiAjYCGCAAIAI2AjALIAAgASgCPCABKAIEQQBHQQZ0aiABKAIAIgBBC0ZBB3RqQYACIABBDkZBCHQgAEETRhtqNgIsIANBeyADGyEUDAELIAFBHjYCAAsgEkEQaiQAIBQLkAEBA38gAEUEQEF+DwsgAEEANgIYIAAoAiAiAUUEQCAAQQA2AiggAEEbNgIgQRshAQsgACgCJEUEQCAAQRw2AiQLIAAoAihBAUHMNyABEQEAIgJFBEBBfA8LIAAgAjYCHEEAIQEgAkEANgI0IAAQjgQiAwR/IAAoAiggAiAAKAIkEQQAIABBADYCHCADBSABCwteAQJ/QX4hAgJAIABFDQAgACgCHCIBRQ0AAkAgASgCNCICRQ0AIAEoAiRBD0YNACAAKAIoIAIgACgCJBEEACABQQA2AjQLIAFBDzYCJCABQQE2AgggABCPBCECCyACCzEBAn9BfiEBAkAgAEUNACAAKAIcIgJFDQAgAkEANgIwIAJCADcCKCAAEJAEIQELIAELlQEBA39BfiECAkAgAEUNACAAKAIcIgFFDQBBACECIAFBADYCHCAAQQA2AgggAEIANwIUIAEoAggiAwRAIAAgA0EBcTYCMAsgAUIANwI4IAFBADYCICABQYCAAjYCFCABQQA2AgwgAUIANwIAIAFCgYCAgHA3AsA3IAEgAUGwCmoiADYCbCABIAA2AlAgASAANgJMCyACC9QLARV/IAAoAgxBf2oiBCAAKAIQIgMgAWtqIREgACgCHCIJKAIwIgogCSgCKCISaiETIAkoAjRBf2ohDEF/IAkoAlh0QX9zIRRBfyAJKAJUdEF/cyEVIAMgBGpB/31qIQ0gACgCAEF/aiIIIAAoAgRqQXtqIQ4gCSgCUCEPIAkoAkwhECAJKAI8IQUgCSgCOCEBIAkoAiwhFgNAIAVBDk0EQCAILQABIAV0IAFqIAgtAAIgBUEIanRqIQEgBUEQaiEFIAhBAmohCAsgBSAQIAEgFXFBAnRqIgMtAAEiAmshBSABIAJ2IQEgAy8BAiEHAkACQAJAIAMtAAAiAkUNACAJAn8CQAJAA0AgAkH/AXEhAyACQRBxBEAgB0H//wNxIQcCfyADQQ9xIgZFBEAgCCEDIAEMAQsCfyAFIAZPBEAgBSECIAgMAQsgBUEIaiECIAgtAAEgBXQgAWohASAIQQFqCyEDIAIgBmshBSABQX8gBnRBf3NxIAdqIQcgASAGdgshAiAFQQ5NBEAgAy0AASAFdCACaiADLQACIAVBCGp0aiECIAVBEGohBSADQQJqIQMLIAUgDyACIBRxQQJ0aiIILQABIgFrIQUgAiABdiEBIAgvAQIhBiAILQAAIgJBEHENAgNAIAJBwABxRQRAIAUgDyABQX8gAnRBf3NxIAZB//8DcWpBAnRqIgItAAEiBmshBSABIAZ2IQEgAi8BAiEGIAItAAAiAkEQcUUNAQwECwtBvPIAIQcgAyEIDAMLIANBwABxRQRAIAUgECABQX8gA3RBf3NxIAdB//8DcWpBAnRqIgMtAAEiAmshBSABIAJ2IQEgAy8BAiEHIAMtAAAiAkUNBQwBCwtBoPIAIQdBCyADQSBxDQIaDAELIAZB//8DcSELAn8gBSACQQ9xIgJPBEAgBSEGIAMMAQsgAy0AASAFdCABaiEBIANBAWogBUEIaiIGIAJPDQAaIAMtAAIgBnQgAWohASAFQRBqIQYgA0ECagshCCABQX8gAnRBf3NxIQMgBiACayEFIAEgAnYhAQJAIAMgC2oiCyAEIBFrIgNLBEACQCALIANrIgMgFk0NACAJKALAN0UNAEHS8gAhBwwDCwJAAkAgCkUEQCAMIBIgA2tqIQIgAyEGIAcgA00NAgNAIAQgAi0AAToAASAEQQFqIQQgAkEBaiECIAZBf2oiBg0ACwwBCyAKIANJBEAgDCATIANraiECIAMgCmsiAyEGIAcgA00NAgNAIAQgAi0AAToAASAEQQFqIQQgAkEBaiECIAZBf2oiBg0ACyAMIQIgByADayIHIAoiBk0EQAwDCwNAIAQgAi0AAToAASAEQQFqIQQgAkEBaiECIAZBf2oiBg0ACyAEIAtrIQIgByAKayEHDAILIAwgCiADa2ohAiADIQYgByADTQ0BA0AgBCACLQABOgABIARBAWohBCACQQFqIQIgBkF/aiIGDQALCyAEIAtrIQIgByADayEHCyAHQQNPBEADQCAEIAItAAE6AAEgBCACLQACOgACIAQgAi0AAzoAAyAEQQNqIQQgAkEDaiECIAdBfWoiB0ECSw0ACwsgB0UNBSAEIAItAAE6AAEgB0EBRw0BIARBAWohBAwFCyAEIAtrIQMDQCAEIgIgAyIGLQABOgABIAIgAy0AAjoAAiACIAMtAAM6AAMgAkEDaiEEIANBA2ohAyAHQX1qIgdBAksNAAsgB0UNBCACIAYtAAQ6AAQgB0EBRgRAIAJBBGohBAwFCyACIAYtAAU6AAUgAkEFaiEEDAQLIAQgAi0AAjoAAiAEQQJqIQQMAwsgACAHNgIYQR0LNgIADAILIAQgBzoAASAEQQFqIQQLIAQgDU8NACAIIA5JDQELCyAAIARBAWo2AgwgACANIARrQYECajYCECAAIAggBUEDdmsiA0EBajYCACAAIA4gA2tBBWo2AgQgCSAFQQdxIgA2AjwgCSABQX8gAHRBf3NxNgI4CzgBA38DQCACIABBAXFyIgNBAXQhAiABQQFKIQQgAEEBdiEAIAFBf2ohASAEDQALIANB/////wdxC6oDAQR/IwBBIGsiBCQAIAQgAi8BAEEBdCIDOwECIAQgAi8BAiADQf7/A3FqQQF0IgM7AQQgBCACLwEEIANB/v8DcWpBAXQiAzsBBiAEIAIvAQYgA0H+/wNxakEBdCIDOwEIIAQgAi8BCCADQf7/A3FqQQF0IgM7AQogBCACLwEKIANB/v8DcWpBAXQiAzsBDCAEIAIvAQwgA0H+/wNxakEBdCIDOwEOIAQgAi8BDiADQf7/A3FqQQF0IgM7ARAgBCACLwEQIANB/v8DcWpBAXQiAzsBEiAEIAIvARIgA0H+/wNxakEBdCIDOwEUIAQgAi8BFCADQf7/A3FqQQF0IgM7ARYgBCACLwEWIANB/v8DcWpBAXQiAzsBGCAEIAMgAi8BGGpBAXQiAzsBGiAEIAIvARogA2pBAXQiAzsBHCAEIAIvARwgA2pBAXQ7AR5BACECIAFBAE4EQANAIAAgAkECdGoiBi8BAiIDBEAgBCADQQF0aiIFIAUvAQAiBUEBajsBACAGIAUgAxCSBDsBAAsgASACRyEDIAJBAWohAiADDQALCyAEQSBqJAAL7gQBC38gAygCECEGIAMoAgghCCADKAIEIQwgAygCACEJIABB1BZqQgA3AQAgAEHMFmpCADcBACAAQcQWakIANwEAIABBvBZqQgA3AQAgASAAIAAoAtQoQQJ0akHcFmooAgBBAnRqQQA7AQICQCAAKALUKCIDQbsESg0AIANBAWohAwNAIAEgACADQQJ0akHcFmooAgAiBUECdCINaiIKIAEgCi8BAkECdGovAQIiBEEBaiAGIAYgBEobIgs7AQIgBiAETCEOAkAgBSACSg0AIAAgC0EBdGpBvBZqIgQgBC8BAEEBajsBAEEAIQQgBSAITgRAIAwgBSAIa0ECdGooAgAhBAsgACAAKAKoLSAKLwEAIgUgBCALamxqNgKoLSAJRQ0AIAAgACgCrC0gBCAJIA1qLwECaiAFbGo2AqwtCyAHIA5qIQcgA0EBaiIDQb0ERw0ACyAHRQ0AIAAgBkEBdGpBvBZqIQQDQCAGIQMDQCAAIAMiBUF/aiIDQQF0akG8FmoiCC8BACIJRQ0ACyAIIAlBf2o7AQAgACAFQQF0akG8FmoiAyADLwEAQQJqOwEAIAQgBC8BAEF/aiIDOwEAIAdBAkohBSAHQX5qIQcgBQ0ACyAGRQ0AQb0EIQUDQCADQf//A3EhByAFIQMDQCAHBEAgACADQX9qIgNBAnRqQdwWaigCACIEIAJKDQEgASAEQQJ0aiIFLwECIgQgBkcEQCAAIAAoAqgtIAUvAQAgBiAEa2xqNgKoLSAFIAY7AQILIAdBf2ohByADIQUMAQsLIAZBf2oiBkUNASAAIAZBAXRqQbwWai8BACEDDAALAAsLUwEBfyMAQSBrIgQkACAEIAE2AhggBCAANgIUIARBvAg2AhAgBEGACTYCCCAEIAI2AgwgBEEQaiAEQQhqEKoEIAMgBCgCDCACazYCACAEQSBqJAALkwUBBX8gAC8BuC0gAUH//QNqQf//A3EiBiAAKAK8LSIEdHIhBQJAIARBDE4EQCAAIAU7AbgtIAAgACgCFCIEQQFqNgIUIAQgACgCCGogBToAACAAIAAoAhQiBEEBajYCFCAEIAAoAghqIABBuS1qLQAAOgAAIAAoArwtIgVBdWohBCAGQRAgBWt2IQUMAQsgBEEFaiEECyAAIAQ2ArwtIAJBf2pB//8DcSIHIAR0IQYCfyAEQQxOBEAgACAFIAZyIgQ7AbgtIAAgACgCFCIFQQFqNgIUIAUgACgCCGogBDoAACAAIAAoAhQiBEEBajYCFCAEIAAoAghqIABBuS1qLQAAOgAAIAAoArwtIgVBdWohBCAHQRAgBWt2DAELIARBBWohBCAFIAZyCyEFIAAgBDYCvC0gACAFIANB/P8DakH//wNxIgYgBHRyIgU7AbgtAkAgBEENTgRAIAAgACgCFCIEQQFqNgIUIAQgACgCCGogBToAACAAIAAoAhQiBEEBajYCFCAEIAAoAghqIABBuS1qLQAAOgAAIAAoArwtIgVBdGohBCAGQRAgBWt2IQUMAQsgBEEEaiEECyAAIAQ2ArwtQQAhBiAAQbktaiEHA0AgACAFIAAgBkGA5QBqLQAAQQJ0akH+FGovAQAiCCAEdHIiBTsBuC0gAAJ/IARBDk4EQCAAIAAoAhQiBEEBajYCFCAEIAAoAghqIAU6AAAgACAAKAIUIgRBAWo2AhQgBCAAKAIIaiAHLQAAOgAAIAAgCEEQIAAoArwtIgRrdiIFOwG4LSAEQXNqDAELIARBA2oLIgQ2ArwtIAZBAWoiBiADRw0ACyAAIABBlAFqIAFBf2oQiQIgACAAQYgTaiACQX9qEIkCC68CACAAIABBlAFqIABBnBZqKAIAEIoCIAAgAEGIE2ogAEGoFmooAgAQigIgACAAQbAWahCuASAAIAAoAqgtAn9BEiAAQboVai8BAA0AGkERIABBghVqLwEADQAaQRAgAEG2FWovAQANABpBDyAAQYYVai8BAA0AGkEOIABBshVqLwEADQAaQQ0gAEGKFWovAQANABpBDCAAQa4Vai8BAA0AGkELIABBjhVqLwEADQAaQQogAEGqFWovAQANABpBCSAAQZIVai8BAA0AGkEIIABBphVqLwEADQAaQQcgAEGWFWovAQANABpBBiAAQaIVai8BAA0AGkEFIABBmhVqLwEADQAaQQQgAEGeFWovAQANABpBA0ECIABB/hRqLwEAGwsiAEEDbGpBEWo2AqgtIAALjgEBAn9B/4D/n38hAQNAAkAgAUEBcUUNACAAIAJBAnRqLwGUAUUNAEEADwsgAUEBdiEBIAJBAWoiAkEgRw0AC0EBIQECQCAALwG4AQ0AIAAvAbwBDQAgAC8ByAENAEEgIQIDQCAAIAJBAnRqLwGUAUUEQEEAIQEgAkEBaiICQYACRw0BDAILC0EBIQELIAELrAEBAX8CQCAAAn8gACgCvC0iAUEQRgRAIAAgACgCFCIBQQFqNgIUIAEgACgCCGogAC0AuC06AAAgACAAKAIUIgFBAWo2AhQgASAAKAIIaiAAQbktai0AADoAACAAQQA7AbgtQQAMAQsgAUEISA0BIAAgACgCFCIBQQFqNgIUIAEgACgCCGogAC0AuC06AAAgACAAQbktai0AADsBuC0gACgCvC1BeGoLNgK8LQsLvwEBAn8gABCMAiAAIAAoAhQiA0EBajYCFCADIAAoAghqIAI6AAAgACAAKAIUIgNBAWo2AhQgAyAAKAIIaiACQQh2OgAAIAAgACgCFCIDQQFqNgIUIAMgACgCCGogAkF/cyIDOgAAIAAgACgCFCIEQQFqNgIUIAQgACgCCGogA0EIdjoAACACBEADQCABLQAAIQMgACAAKAIUIgRBAWo2AhQgBCAAKAIIaiADOgAAIAFBAWohASACQX9qIgINAAsLC/0GAQt/IwBBEGsiCiQAAkAgACgCCCAAKAIEIgNrQQRMBEAgABCxAUUNASAAKAIEIQMLA0AgA0EBaiEIIAMtAAAiB0EDcUUEQCAHQQJ2IgZBAWohBCAAKAIIIgsgCGsiBUEVSSAHQT9LciABKAIIIgwgASgCBCICayIJQRBJckUEQCACIAMoAAE2AAAgAiADKAAFNgAEIAIgAygACTYACCACIAMoAA02AAwgASACIARqNgIEIAQgCGohAwwCCwJAIAdB8AFJBEAgCCEGDAELIAsgCCAGQUVqIgdqIgZrIQUgB0ECdEHADWooAgAgCCgAAHFBAWohBAsCQCAEIAVNDQAgDCACayAFSQ0DA0AgASACIAYgBRAqIAVqNgIEIAAoAgAiAiAAKAIMIAIoAgAoAhARBAAgACgCACICIApBDGogAigCACgCDBEDACEGIAAgCigCDCIHNgIMIAdFDQQgACAGIAdqNgIIIAEoAgggASgCBCICayEJIAQgBWsiBCAHTQ0BIAkgByIFTw0ACwwDCyAJIARJDQIgASACIAYgBBAqIARqNgIEIAAoAgggBCAGaiIDa0EESg0BIAAgAzYCBCAAELEBRQ0CIAAoAgQhAwwBCyABKAIEIgYgASgCAGsgB0EBdEHACWovAQAiBUELdiIJQQJ0QcANaigCACAIKAAAcSAFQYAOcWoiBEF/ak0NAQJAIARBCEkgBUH/AXEiB0EQS3IgASgCCCAGayICQRBJckUEQCAGIAYgBGsiAigAADYAACAGIAIoAAQ2AAQgBiACKAAINgAIIAYgAigADDYADAwBCwJAAkAgAiAHQQpqTwRAIAYgBGshBSAGIQMgByECIARBB0wNAQwCCyACIAdJDQQgBiAEayEDIAYhBSAHIQIDQCAFIAMtAAA6AAAgBUEBaiEFIANBAWohAyACQQFKIQQgAkF/aiECIAQNAAsMAgsDQCADIAUoAAA2AAAgAyAFKAAENgAEIAIgBGshAiADIARqIgMgBWsiBEEISA0ACwsgAkEATA0AA0AgAyAFKAAANgAAIAMgBSgABDYABCADQQhqIQMgBUEIaiEFIAJBCEohBCACQXhqIQIgBA0ACwsgASAGIAdqNgIEIAAoAgggCCAJaiIDa0EESg0AIAAgAzYCBCAAELEBRQ0BIAAoAgQhAwwACwALIApBEGokAAuoBgEJfwNAAkACQAJAIAAoAnQiBkGDAk8EQCAAQQA2AmAMAQsgABB2IAAoAnQiBkGDAk9BBHJFBEBBAA8LIAYEQCAAQQA2AmAgBkECSw0BIAAoAmwhBwwCCyAAQQA2ArQtIAAgACgCXCIBQQBOBH8gACgCOCABagVBAAsgACgCbCABa0EBEEQgACAAKAJsNgJcIAAoAgAQNkEDQQIgACgCACgCEBsPCyAAKAJsIgdFBEBBACEHDAELIAAoAjggB2oiCEF/aiIBLQAAIgMgCC0AAEcNACADIAEtAAJHDQAgAyABLQADRw0AIAhBggJqIQlBfyEBA0ACQCABIAhqIgItAAQgA0cEQCACQQRqIQUMAQsgAi0ABSADRwRAIAJBBWohBQwBCyACLQAGIANHBEAgAkEGaiEFDAELIAItAAcgA0cEQCACQQdqIQUMAQsgAyAIIAFBCGoiBGoiBS0AAEcNACACLQAJIANHBEAgAkEJaiEFDAELIAItAAogA0cEQCACQQpqIQUMAQsgAkELaiEFIAFB9gFKDQAgBCEBIAMgBS0AAEYNAQsLIAAgBiAFIAlrQYICaiIBIAEgBksbIgE2AmAgAUEDSQ0AIAAoAqQtIAAoAqAtIgRBAXRqQQE7AQAgACAEQQFqNgKgLSAEIAAoApgtaiABQX1qIgE6AAAgAUH/AXFBoOUAai0AAEECdEGACHIgAGoiASABLwGYAUEBajsBmAEgACgCYCEBIABBADYCYCAAIAAvAYgTQQFqOwGIEyAAIAAoAnQgAWs2AnQgACABIAAoAmxqIgY2AmwMAQsgACgCOCAHai0AACEBIAAoAqQtIAAoAqAtIgRBAXRqQQA7AQAgACAEQQFqNgKgLSAEIAAoApgtaiABOgAAIAAgAUECdGoiASABLwGUAUEBajsBlAEgACAAKAJ0QX9qNgJ0IAAgACgCbEEBaiIGNgJsCyAAKAKgLSAAKAKcLUF/akcNAEEAIQEgACAAKAJcIgRBAE4EfyAAKAI4IARqBUEACyAGIARrQQAQRCAAIAAoAmw2AlwgACgCABA2IAAoAgAoAhANAAsgAQu/AgEDfwJAA0ACQAJAIAAoAnQNACAAEHYgACgCdA0ADAELIABBADYCYCAAKAI4IAAoAmxqLQAAIQEgACgCpC0gACgCoC0iAkEBdGpBADsBACAAIAJBAWo2AqAtIAIgACgCmC1qIAE6AAAgACABQQJ0aiIBIAEvAZQBQQFqOwGUASAAIAAoAnRBf2o2AnQgACAAKAJsQQFqIgI2AmwgACgCoC0gACgCnC1Bf2pHDQEgACAAKAJcIgFBAE4EfyAAKAI4IAFqBUEACyACIAFrQQAQRCAAIAAoAmw2AlwgACgCABA2IAAoAgAoAhANAQwCCwsgAEEANgK0LSAAIAAoAlwiAUEATgR/IAAoAjggAWoFQQALIAAoAmwgAWtBARBEIAAgACgCbDYCXCAAKAIAEDZBA0ECIAAoAgAoAhAbDwsgAwuGAQEBfyACIAAoAgQiAyADIAJLGyICBEAgACADIAJrNgIEIAEgACgCACACECohAQJAAkACQCAAKAIcKAIYQX9qDgIAAQILIAAgACgCMCABIAIQZTYCMAwBCyAAIAAoAjAgASACEDU2AjALIAAgACgCACACajYCACAAIAAoAgggAmo2AggLIAIL2goBB38CQANAAkACQAJAIAAoAnRBhQJLDQAgABB2IAEgACgCdCICQYYCT3JFBEBBAA8LIAJFDQIgAkECSw0AIAAgACgCYCICNgJ4IAAgACgCcDYCZEECIQQgAEECNgJgDAELQQIhBCAAIAAoAlQgACgCbCIDIAAoAjhqLQACIAAoAkggACgCWHRzcSICNgJIIAAoAkAgAyAAKAI0cUEBdGogACgCRCACQQF0aiICLwEAIgU7AQAgAiADOwEAIAAgACgCYCICNgJ4IAAgACgCcDYCZCAAQQI2AmAgBUUNAAJAIAIgACgCgAFPDQAgAyAFayAAKAIsQfp9aksNACAAIAAgBRCPAiIENgJgIARBBUsNACAAKAKIAUEBRwRAIARBA0cNAUEDIQQgACgCbCAAKAJwa0GBIEkNAQtBAiEEIABBAjYCYAsgACgCeCECCyACQQNJIAQgAktyRQRAIAAoAnQhBSAAKAKkLSAAKAKgLSIDQQF0aiAAKAJsIgYgACgCZEF/c2oiBDsBACAAIANBAWo2AqAtIAMgACgCmC1qIAJBfWoiAjoAACACQf8BcUGg5QBqLQAAQQJ0QYAIciAAaiICQZgBaiACLwGYAUEBajsBACAAIARBf2pB//8DcSICIAJBB3ZBgAJqIAJBgAJJG0Gg6ABqLQAAQQJ0akGIE2oiAiACLwEAQQFqOwEAIAAgACgCeCICQX5qIgQ2AnggACAAKAJ0IAJrQQFqNgJ0IAUgBmpBfWohBSAAKAJsIQIgACgCnC0hBiAAKAKgLSEIA0AgACACIgNBAWoiAjYCbCACIAVNBEAgACAAKAJUIAMgACgCOGotAAMgACgCSCAAKAJYdHNxIgc2AkggACgCQCAAKAI0IAJxQQF0aiAAKAJEIAdBAXRqIgcvAQA7AQAgByACOwEACyAAIARBf2oiBDYCeCAEDQALIABBAjYCYCAAQQA2AmggACADQQJqIgU2AmwgCCAGQX9qRw0CQQAhAkEAIQQgACAAKAJcIgNBAE4EfyAAKAI4IANqBSAECyAFIANrQQAQRCAAIAAoAmw2AlwgACgCABA2IAAoAgAoAhANAgwDCyAAKAJoBEAgACgCbCAAKAI4akF/ai0AACECIAAoAqQtIAAoAqAtIgNBAXRqQQA7AQAgACADQQFqNgKgLSADIAAoApgtaiACOgAAIAAgAkECdGoiAkGUAWogAi8BlAFBAWo7AQAgACgCoC0gACgCnC1Bf2pGBEBBACECIAAgACgCXCIDQQBOBH8gACgCOCADagUgAgsgACgCbCADa0EAEEQgACAAKAJsNgJcIAAoAgAQNgsgACAAKAJsQQFqNgJsIAAgACgCdEF/ajYCdCAAKAIAKAIQDQJBAA8FIABBATYCaCAAIAAoAmxBAWo2AmwgACAAKAJ0QX9qNgJ0DAILAAsLIAAoAmgEQCAAKAJsIAAoAjhqQX9qLQAAIQIgACgCpC0gACgCoC0iA0EBdGpBADsBACAAIANBAWo2AqAtIAMgACgCmC1qIAI6AAAgACACQQJ0aiICQZQBaiACLwGUAUEBajsBACAAQQA2AmgLIAAgACgCbCIDQQIgA0ECSRs2ArQtIAFBBEYEQEEAIQQgACAAKAJcIgFBAE4EfyAAKAI4IAFqBSAECyADIAFrQQEQRCAAIAAoAmw2AlwgACgCABA2QQNBAiAAKAIAKAIQGw8LIAAoAqAtBEBBACECQQAhBCAAIAAoAlwiAUEATgR/IAAoAjggAWoFIAQLIAMgAWtBABBEIAAgACgCbDYCXCAAKAIAEDYgACgCACgCEEUNAQtBASECCyACC7wIAQ1/AkADQAJAAkACQCAAKAJ0QYUCTQRAIAAQdiABIAAoAnQiAkGGAk9yRQRAQQAPCyACRQ0DIAJBA0kNAQsgACAAKAJUIAAoAmwiBCAAKAI4ai0AAiAAKAJIIAAoAlh0c3EiAjYCSCAAKAJAIAQgACgCNHFBAXRqIAAoAkQgAkEBdGoiAi8BACIDOwEAIAIgBDsBACADRQ0AIAQgA2sgACgCLEH6fWpLDQAgACAAIAMQjwIiAzYCYAwBCyAAKAJgIQMLAkAgA0EDTwRAIAAoAqQtIAAoAqAtIgJBAXRqIAAoAmwgACgCcGsiBDsBACAAIAJBAWo2AqAtIAIgACgCmC1qIANBfWoiAjoAACACQf8BcUGg5QBqLQAAQQJ0QYAIciAAaiICQZgBaiACLwGYAUEBajsBACAAIARBf2pB//8DcSICIAJBB3ZBgAJqIAJBgAJJG0Gg6ABqLQAAQQJ0akGIE2oiAiACLwEAQQFqOwEAIAAgACgCdCAAKAJgIgNrIgI2AnQgACgCnC1Bf2ohByAAKAKgLSEIAkAgAkEDSQ0AIAMgACgCgAFLDQAgACADQX9qIgU2AmAgACgCSCEGIAAoAmwhAyAAKAI0IQkgACgCQCEKIAAoAkQhCyAAKAJUIQwgACgCOCENIAAoAlghDgNAIAAgAyICQQFqIgM2AmwgACACIA1qLQADIAYgDnRzIAxxIgY2AkggCiADIAlxQQF0aiALIAZBAXRqIgQvAQA7AQAgBCADOwEAIAAgBUF/aiIFNgJgIAUNAAsgACACQQJqIgM2AmwgByAIRw0EDAILIABBADYCYCAAIAAoAmwgA2oiAzYCbCAAIAAoAjggA2oiBC0AACICNgJIIAAgACgCVCAELQABIAIgACgCWHRzcTYCSCAHIAhHDQMMAQsgACgCOCAAKAJsai0AACEDIAAoAqQtIAAoAqAtIgJBAXRqQQA7AQAgACACQQFqNgKgLSACIAAoApgtaiADOgAAIAAgA0ECdGoiAkGUAWogAi8BlAFBAWo7AQAgACAAKAJ0QX9qNgJ0IAAgACgCbEEBaiIDNgJsIAAoAqAtIAAoApwtQX9qRw0CC0EAIQRBACEGIAAgACgCXCICQQBOBH8gACgCOCACagUgBgsgAyACa0EAEEQgACAAKAJsNgJcIAAoAgAQNiAAKAIAKAIQDQEMAgsLIAAgACgCbCICQQIgAkECSRs2ArQtIAFBBEYEQEEAIQUgACAAKAJcIgFBAE4EfyAAKAI4IAFqBSAFCyACIAFrQQEQRCAAIAAoAmw2AlwgACgCABA2QQNBAiAAKAIAKAIQGw8LIAAoAqAtBEBBACEEQQAhBSAAIAAoAlwiAUEATgR/IAAoAjggAWoFIAULIAIgAWtBABBEIAAgACgCbDYCXCAAKAIAEDYgACgCACgCEEUNAQtBASEECyAEC7YBAQF/IwBBQGoiAyQAIAMgATYCECADIAA2AgwgA0G8CDYCCCADIAI2AhwgAyACNgIYIANCADcAMSADQgA3AiwgAyADQQhqNgIoQQAhACADQQA2AiQCQCADQShqIANBJGoQrQRFDQAgAyACIAMoAiRqNgIgIANBKGogA0EYahCbBCADLQA4RQ0AIAMoAhwgAygCIEYhAAsgAygCKCIBIAMoAjQgASgCACgCEBEEACADQUBrJAAgAAvYAwEFfyAAKAIMQXtqIgJB//8DIAJB//8DSRshBQJAA0ACQCAAKAJ0IgJBAU0EQCAAEHYgACgCdCICIAFyRQRAQQAPCyACRQ0BCyAAQQA2AnQgACAAKAJsIAJqIgI2AmwgAkEAIAIgACgCXCIDIAVqIgRJGwR/IAIFIAAgBDYCbCAAIAIgBGs2AnRBACEEQQAhAiAAIANBAE4EfyAAKAI4IANqBSACCyAFQQAQRCAAIAAoAmw2AlwgACgCABA2IAAoAgAoAhBFDQMgACgCXCEDIAAoAmwLIANrIgYgACgCLEH6fWpJDQFBACEEQQAhAiAAIANBAE4EfyAAKAI4IANqBSACCyAGQQAQRCAAIAAoAmw2AlwgACgCABA2IAAoAgAoAhANAQwCCwtBACECIABBADYCtC0gAUEERgRAIAAgACgCXCIBQQBOBH8gACgCOCABagUgAgsgACgCbCABa0EBEEQgACAAKAJsNgJcIAAoAgAQNkEDQQIgACgCACgCEBsPCyAAKAJsIgMgACgCXCIBSgRAQQAhBCAAIAFBAE4EfyAAKAI4IAFqBSACCyADIAFrQQAQRCAAIAAoAmw2AlwgACgCABA2IAAoAgAoAhBFDQELQQEhBAsgBAtiACAAQQA2ArwtIABBADsBuC0gAEG4FmpBwOkBNgIAIAAgAEH8FGo2ArAWIABBrBZqQazpATYCACAAIABBiBNqNgKkFiAAQaAWakGY6QE2AgAgACAAQZQBajYCmBYgABCNAguoAQECfyAAIAAoAixBAXQ2AjwgACgCRCIBIAAoAkxBAXRBfmoiAmpBADsBACABQQAgAhAoGiAAQQA2ArQtIABCgICAgCA3AnQgAEIANwJoIABCgICAgCA3AlwgAEEANgJIIAAgACgChAFBDGwiAUG01wBqLwEANgKQASAAIAFBsNcAai8BADYCjAEgACABQbLXAGovAQA2AoABIAAgAUG21wBqLwEANgJ8C6oBAQJ/QX4hAgJAIABFDQAgACgCHCIBRQ0AIAAoAiBFDQAgACgCJEUNACAAQQI2AiwgAEEANgIIIABCADcCFCABQQA2AhQgASABKAIINgIQIAEoAhgiAkF/TARAIAFBACACayICNgIYCyABQSpB8QAgAhs2AgQgAAJ/IAJBAkYEQEEAQQBBABA1DAELQQBBAEEAEGULNgIwQQAhAiABQQA2AiggARCjBAsgAgsGACABEDgLCQAgASACbBBMC9ADAQN/QXohAgJAQaCEAS0AAEExRw0AQX4hAiAARQ0AIABBADYCGCAAKAIgIgNFBEAgAEEANgIoIABBGzYCIEEbIQMLIAAoAiRFBEAgAEEcNgIkC0EGIAEgAUF/RhsiBEEJSw0AQXwhAiAAKAIoQQFBxC0gAxEBACIBRQ0AIAAgATYCHCABQgE3AhggASAANgIAIAFB//8BNgI0IAFCgICCgPABNwIsIAFC//+BgNAANwJUIAFCgICCgPABNwJMIAEgACgCKEGAgAJBAiAAKAIgEQEANgI4IAEgACgCKCABKAIsQQIgACgCIBEBADYCQCAAKAIoIAEoAkxBAiAAKAIgEQEAIQIgAUEANgLALSABIAI2AkQgAUGAgAE2ApwtIAEgACgCKEGAgAFBBCAAKAIgEQEAIgI2AgggASABKAKcLSIDQQJ0NgIMAkACQCABKAI4RQ0AIAEoAkBFIAJFcg0AIAEoAkQNAQsgAUGaBTYCBCAAQbOEATYCGCAAEK8BGkF8DwsgAUEANgKIASABIAQ2AoQBIAFBCDoAJCABIAIgA0EDbGo2ApgtIAEgAiADQX5xajYCpC0gABClBCIBRQRAIAAoAhwQpAQLIAEhAgsgAgvhBgAgAEF/cyEAAkAgAkUgAUEDcUVyDQADQCABLQAAIABB/wFxc0ECdEGwF2ooAgAgAEEIdnMhACABQQFqIQEgAkF/aiICRQ0BIAFBA3ENAAsLIAJBH0sEQANAIAEoAhwgASgCGCABKAIUIAEoAhAgASgCDCABKAIIIAEoAgQgASgCACAAcyIAQQZ2QfwHcUGwJ2ooAgAgAEH/AXFBAnRBsC9qKAIAcyAAQQ52QfwHcUGwH2ooAgBzIABBFnZB/AdxQbAXaigCAHNzIgBBBnZB/AdxQbAnaigCACAAQf8BcUECdEGwL2ooAgBzIABBDnZB/AdxQbAfaigCAHMgAEEWdkH8B3FBsBdqKAIAc3MiAEEGdkH8B3FBsCdqKAIAIABB/wFxQQJ0QbAvaigCAHMgAEEOdkH8B3FBsB9qKAIAcyAAQRZ2QfwHcUGwF2ooAgBzcyIAQQZ2QfwHcUGwJ2ooAgAgAEH/AXFBAnRBsC9qKAIAcyAAQQ52QfwHcUGwH2ooAgBzIABBFnZB/AdxQbAXaigCAHNzIgBBBnZB/AdxQbAnaigCACAAQf8BcUECdEGwL2ooAgBzIABBDnZB/AdxQbAfaigCAHMgAEEWdkH8B3FBsBdqKAIAc3MiAEEGdkH8B3FBsCdqKAIAIABB/wFxQQJ0QbAvaigCAHMgAEEOdkH8B3FBsB9qKAIAcyAAQRZ2QfwHcUGwF2ooAgBzcyIAQQZ2QfwHcUGwJ2ooAgAgAEH/AXFBAnRBsC9qKAIAcyAAQQ52QfwHcUGwH2ooAgBzIABBFnZB/AdxQbAXaigCAHNzIgBBBnZB/AdxQbAnaigCACAAQf8BcUECdEGwL2ooAgBzIABBDnZB/AdxQbAfaigCAHMgAEEWdkH8B3FBsBdqKAIAcyEAIAFBIGohASACQWBqIgJBH0sNAAsLIAJBA0sEQANAIAEoAgAgAHMiAEEGdkH8B3FBsCdqKAIAIABB/wFxQQJ0QbAvaigCAHMgAEEOdkH8B3FBsB9qKAIAcyAAQRZ2QfwHcUGwF2ooAgBzIQAgAUEEaiEBIAJBfGoiAkEDSw0ACwsgAgRAA0AgAS0AACAAQf8BcXNBAnRBsBdqKAIAIABBCHZzIQAgAUEBaiEBIAJBf2oiAg0ACwsgAEF/cwvTBQELfyMAQaAQayICJAAgASACQZsQagJ/IAAgACgCACgCCBEAACIDQf8ATQRAIAIgAzoAmxAgAkGcEGoMAQsgA0H//wBNBEAgAiADQQd2OgCcECACIANBgAFyOgCbECACQZ0QagwBCyADQf///wBNBEAgAiADQQ52OgCdECACIANBgAFyOgCbECACIANBB3ZBgAFyOgCcECACQZ4QagwBCyACIANBgAFyOgCbECACIANBDnZBgAFyOgCdECACIANBB3ZBgAFyOgCcECADQRV2IQQgA0H/////AE0EQCACIAQ6AJ4QIAJBnxBqDAELIAIgA0EcdjoAnxAgAiAEQYABcjoAnhAgAkGgEGoLIAJBmxBqayILIAEoAgAoAggRBgAgAkEANgKQEAJAIANFDQADQCAAIAJBDGogACgCACgCDBEDACEIAn8gAigCDCIEIANBgIAEIANBgIAESRsiBk8EQCAGDAELAn8gCUUEQCAGEG0hCQsgCQsgCCAEECohCCAAIAQgACgCACgCEBEEAANAIAQgCGogACACQQxqIAAoAgAoAgwRAwAgBiAEayIFIAIoAgwiByAFIAdJGyIFECoaIAAgBSAAKAIAKAIQEQQAIAYgBCAFaiIESw0AC0EACyEMIAIgBjYCDEGAAiEFA0ACQCAFIgRBAXQhBSAEQf//AEsNACAEIAZJDQELCyACQRBqIQcCQCAEQYEISQ0AIAIoApAQIgcNACACQYCAAhBtIgc2ApAQCyAHQQAgBRAoIQcgASABIAYgBkEGbmpBIGoiBQJ/IApFBEAgBRBtIQoLIAoLIAEoAgAoAgwRAQAiBSAIIAIoAgwgBSAHIAQQtQQgBWsiBCABKAIAKAIIEQYAIAAgDCAAKAIAKAIQEQQAIAQgC2ohCyADIAZrIgMNAAsgCQRAIAkQOAsgChA4IAIoApAQIgBFDQAgABA4CyACQaAQaiQAC8wWAQh/QX4hAgJAAkACQCAARQ0AIAAoAhwiAUUNAAJAAkAgACgCDEUNACAAKAIARQRAIAAoAgQNAQsgASgCBCICQZoFR0EBcg0BCyAAQaaEATYCGEF+DwsgACgCEEUNASABIAA2AgAgASgCKBogAUEENgIoAkACQAJAAkACQAJAAkACQAJAAkACQCACQSpGBEAgASgCGEECRgRAIABBAEEAQQAQNTYCMCABIAEoAhQiAkEBajYCFCACIAEoAghqQR86AAAgASABKAIUIgJBAWo2AhQgAiABKAIIakGLAToAACABIAEoAhQiAkEBajYCFCACIAEoAghqQQg6AAAgASgCHCICRQRAIAEgASgCFCICQQFqNgIUIAIgASgCCGpBADoAACABIAEoAhQiAkEBajYCFCACIAEoAghqQQA6AAAgASABKAIUIgJBAWo2AhQgAiABKAIIakEAOgAAIAEgASgCFCICQQFqNgIUIAIgASgCCGpBADoAACABIAEoAhQiAkEBajYCFCACIAEoAghqQQA6AABBAiECIAEoAoQBIgNBCUcEQEEEIAEoAogBQQFKQQJ0IANBAkgbIQILIAEgASgCFCIDQQFqNgIUIAMgASgCCGogAjoAACABIAEoAhQiAkEBajYCFCACIAEoAghqQQM6AAAgAUHxADYCBAwNCyACKAIkIQMgAigCHCEEIAIoAhAhBSACKAIsIQYgAigCACEHIAEgASgCFCIIQQFqNgIUQQIhAiAIIAEoAghqIAZBAEdBAXQgB0EAR3IgBUEAR0ECdHIgBEEAR0EDdHIgA0EAR0EEdHI6AAAgASgCHCgCBCEDIAEgASgCFCIEQQFqNgIUIAQgASgCCGogAzoAACABKAIcKAIEIQMgASABKAIUIgRBAWo2AhQgBCABKAIIaiADQQh2OgAAIAEoAhwvAQYhAyABIAEoAhQiBEEBajYCFCAEIAEoAghqIAM6AAAgASgCHC0AByEDIAEgASgCFCIEQQFqNgIUIAQgASgCCGogAzoAACABKAKEASIDQQlHBEBBBCABKAKIAUEBSkECdCADQQJIGyECCyABIAEoAhQiA0EBajYCFCADIAEoAghqIAI6AAAgASgCHCgCDCECIAEgASgCFCIDQQFqNgIUIAMgASgCCGogAjoAAAJ/IAEoAhwiBCgCEARAIAQoAhQhAiABIAEoAhQiA0EBajYCFCADIAEoAghqIAI6AAAgASgCHCgCFCECIAEgASgCFCIDQQFqNgIUIAMgASgCCGogAkEIdjoAACABKAIcIQQLIAQoAiwLBEAgACAAKAIwIAEoAgggASgCFBA1NgIwCyABQcUANgIEIAFBADYCIAwCCyABKAIwQQx0QYCQfmohBEEAIQICQCABKAKIAUEBSg0AIAEoAoQBIgNBAkgNAEHAACECIANBBkgNAEGAAUHAASADQQZGGyECCyABQfEANgIEIAEgAiAEciICQSByIAIgASgCbBsiAkEfcCACckEfcxB1IAEoAmwEQCABIAAvATIQdSABIAAvATAQdQsgAEEAQQBBABBlNgIwIAEoAgQhAgsgAkHFAEcNASABKAIcIQQLAkAgBCgCEARAIAEoAhQhAiABKAIgIgUgBC8BFE8NASACIQMDQCABKAIMIAJGBEACQCACIANNDQAgBCgCLEUNACAAIAAoAjAgASgCCCADaiACIANrEDU2AjALIAAQNiABKAIcIQQgASgCFCICIAEoAgxGDQMgASgCICEFIAIhAwsgBCgCECAFai0AACEEIAEgAkEBajYCFCABKAIIIAJqIAQ6AAAgASABKAIgQQFqIgU2AiAgBSABKAIcIgQvARRPBEAgAyECDAMFIAEoAhQhAgwBCwALAAsgAUHJADYCBAwCCwJAIAQoAixFDQAgASgCFCIDIAJNDQAgACAAKAIwIAEoAgggAmogAyACaxA1NgIwCyABKAIgIAQoAhRGBEAgAUHJADYCBCABQQA2AiAMAgsgASgCBCECCyACQckARw0BIAEoAhwhBAsgBCgCHEUNAiABKAIUIgIhAwJAA0ACQCABKAIMIAJGBEACQCACIANNDQAgASgCHCgCLEUNACAAIAAoAjAgASgCCCADaiACIANrEDU2AjALIAAQNiABKAIUIgIgASgCDEYNASACIQMLQQEhBSABKAIcKAIcIQQgASABKAIgIgZBAWo2AiAgBCAGai0AACEEIAEgAkEBajYCFCABKAIIIAJqIAQ6AAAgBARAIAEoAhQhAgwCBSADIQIMAwsACwtBACEFCwJAIAEoAhwiBCgCLEUNACABKAIUIgMgAk0NACAAIAAoAjAgASgCCCACaiADIAJrEDU2AjALIAUNASABKAIEIQILIAJB2wBHDQMgASgCHCEEDAILIAFBADYCIAsgAUHbADYCBAsgBCgCJEUNASABKAIUIgIhAwJAA0ACQCABKAIMIAJGBEACQCACIANNDQAgASgCHCgCLEUNACAAIAAoAjAgASgCCCADaiACIANrEDU2AjALIAAQNiABKAIUIgIgASgCDEYNASACIQMLQQEhBSABKAIcKAIkIQQgASABKAIgIgZBAWo2AiAgBCAGai0AACEEIAEgAkEBajYCFCABKAIIIAJqIAQ6AAAgBARAIAEoAhQhAgwCBSADIQIMAwsACwtBACEFCwJAIAEoAhwiBCgCLEUNACABKAIUIgMgAk0NACAAIAAoAjAgASgCCCACaiADIAJrEDU2AjALIAUNASABKAIEIQILIAJB5wBHDQIgASgCHCEEDAELIAFB5wA2AgQLIAQoAiwEQCABKAIUIgVBAmoiAiABKAIMIgRLBH8gABA2IAEoAgwhBCABKAIUIgVBAmoFIAILIARLDQEgACgCMCECIAEgBUEBajYCFCABKAIIIAVqIAI6AAAgACgCMCECIAEgASgCFCIDQQFqNgIUIAMgASgCCGogAkEIdjoAACAAQQBBAEEAEDU2AjAgAUHxADYCBAwBCyABQfEANgIECwJAIAEoAhQEQCAAEDYgACgCEARAIAAoAgQhAgwCCwwECyAAKAIEIgINAEEAIQILAkACQAJAIAEoAgQiA0GaBUYEQCACRQ0BDAULIAINAQsgA0GaBUcNACABKAJ0RQ0BCwJ/AkACQAJAIAEoAogBQX5qDgIAAQILIAEQnQQMAgsgARCcBAwBCyABQQQgASgChAFBDGxBuNcAaigCABEDAAsiAkF+cUECRgRAIAFBmgU2AgQLIAJBfXFFBEBBACECIAAoAhANAgwECyACQQFHDQAgAUEAQQBBABCOAiAAEDYgACgCEA0ADAMLQQEhAiABKAIYIgNBAUgNACAAKAIwIQICQCADQQJGBEAgASABKAIUIgNBAWo2AhQgAyABKAIIaiACOgAAIAAoAjAhAiABIAEoAhQiA0EBajYCFCADIAEoAghqIAJBCHY6AAAgAC8BMiECIAEgASgCFCIDQQFqNgIUIAMgASgCCGogAjoAACAALQAzIQIgASABKAIUIgNBAWo2AhQgAyABKAIIaiACOgAAIAAoAgghAiABIAEoAhQiA0EBajYCFCADIAEoAghqIAI6AAAgACgCCCECIAEgASgCFCIDQQFqNgIUIAMgASgCCGogAkEIdjoAACAALwEKIQIgASABKAIUIgNBAWo2AhQgAyABKAIIaiACOgAAIAAtAAshAiABIAEoAhQiA0EBajYCFCADIAEoAghqIAI6AAAMAQsgASACQRB2EHUgASAALwEwEHULIAAQNiABKAIYIgBBAU4EQCABQQAgAGs2AhgLIAEoAhRFIQILIAIPCyAAQceEATYCGEF7DwsgAUF/NgIoQQAL3QEBBn8CQCAAKAKAgBAiBSAAKAKEgBAiAyAAKAKMgBAiBGpBBGpJDQAgACgClIAQIgIgBSADa0F9aiIGTw0AA0AgACACQf//A3FBAXRqQYCACGogAiAAIAIgA2oQOkECdGoiBCgCAGsiB0H//wMgB0H//wNJGzsBACAEIAI2AgAgAkEBaiICIAZJDQALIAAoAoyAECEECyAAIAQ2ApCAECAAIAM2AoiAECAAQQA2ApyAECAAIAE2AoCAECAAIAUgA2siAjYCjIAQIAAgAjYClIAQIAAgASACazYChIAQC9kDAQR/IwBBEGsiAyQAIAFBADYCACAAKAIAIgIgA0EMaiACKAIAKAIMEQMAIQICQCADKAIMRQ0AIAIsAAAhAiAAKAIAIgRBASAEKAIAKAIQEQQAIAEgASgCACACQf8AcXI2AgACQCACQX9KDQAgACgCACICIANBDGogAigCACgCDBEDACECIAMoAgxFDQEgAiwAACECIAAoAgAiBEEBIAQoAgAoAhARBAAgASABKAIAIAJB/wBxQQd0cjYCACACQX9KDQAgACgCACICIANBDGogAigCACgCDBEDACECIAMoAgxFDQEgAiwAACECIAAoAgAiBEEBIAQoAgAoAhARBAAgASABKAIAIAJB/wBxQQ50cjYCACACQX9KDQAgACgCACICIANBDGogAigCACgCDBEDACECIAMoAgxFDQEgAiwAACECIAAoAgAiBEEBIAQoAgAoAhARBAAgASABKAIAIAJB/wBxQRV0cjYCACACQX9KDQAgACgCACICIANBDGogAigCACgCDBEDACECIAMoAgxFDQEgAiwAACEFIAAoAgAiAEEBIAAoAgAoAhARBAAgASABKAIAIAVBHHRyNgIAIAVBf0oNAEEAIQUMAQtBASEFCyADQRBqJAAgBQvhSQE3fwJAIAAoAoCAECIJIAAoAoSAECILayAAKAKQgBBrIghBgIAETwRAIABBADYCnIAQDAELAkAgCA0AIAMoAgBBgSBIDQAgACAAKAKcgBBBoIAQECoiACABEKwEIAAgBTsBmIAQDAELAkAgBEEATEEAIAZBAkYbDQAgAygCACIIQYCAgPAHSw0AIAAgCCAJajYCgIAQQQkgBSAFQQFIGyIFQQwgBUEMSBsiG0EMbCIJQZQWaigCACEuAkACfyAbQQlNBEAgA0EANgIAIAIgBGoiOkF7aiA6IAZBAkYiOxshKSABIAhqITMgASEoIAIhCQJAIAhBDUgNACAzQXRqIjIgAUkNAEGANCAbdkEBcSE0IDNBe2oiGEF/aiEvIBhBfWohIkEAIRsDQCAAKAKUgBAhBCAAKAKIgBAhEyAAKAKcgBAhFCAoIQwDQCAAKAKQgBAiBSAMIAtrIh9BgYB8aiAFQYCABGogH0sbIRUgACgCjIAQIRAgDCgAACEOIAQgH0kEQANAIAAgBEH//wNxQQF0akGAgAhqIAQgACAEIAtqEDpBAnRqIgUoAgBrIghB//8DIAhB//8DSRs7AQAgBSAENgIAIARBAWoiBCAfSQ0ACwsgACAfNgKUgBAgDEEIaiEhIAxBBGohEkEDIQgCQCAAIAwQOkECdCIjaigCACIHIBVJBEAgLiENDAELIA5B//8DcSAOQRB2RiAOQf8BcSAOQRh2RnEhJCAQIBNqIQ8gCyAQaiIdQQRqIREgDEF/aiEmQQAhJSAuIQ1BACEcA0ACQAJAAn8CQAJAIBAgB00EQCAIICZqLwAAIAcgC2oiCiAIakF/ai8AAEcNBSAOIAooAABHDQUgCkEEaiEEICIgEk0EfyASBSAEKAAAIBIoAABzIgUNAiAEQQRqIQQgIQsiBSAiSQRAA0AgBCgAACAFKAAAcyIWBEAgFhAlIAVqIBJrIQQMBwsgBEEEaiEEIAVBBGoiBSAiSQ0ACwsCQCAFIC9PDQAgBC8AACAFLwAARw0AIARBAmohBCAFQQJqIQULIAUgGEkEfyAFQQFqIAUgBC0AACAFLQAARhsFIAULIBJrIQQMBAsgDiAHIBNqIgQoAABHDQQgBEEEaiEEAn8gEiAYIAwgECAHa2oiICAgIBhLGyIWQX1qIgogEk0NABogBCgAACASKAAAcyIFDQIgBEEEaiEEICELIgUgCkkEQANAIAQoAAAgBSgAAHMiJwRAICcQJSAFaiASawwFCyAEQQRqIQQgBUEEaiIFIApJDQALCwJAIAUgFkF/ak8NACAELwAAIAUvAABHDQAgBEECaiEEIAVBAmohBQsgBSAWSQR/IAVBAWogBSAELQAAIAUtAABGGwUgBQsgEmsMAgsgBRAlIQQMAgsgBRAlCyEEIAcgC2ogHgJ/IARBBGoiCiAMaiAWRyAgIBhPckUEQCAdIQUCfwJAAn8gIiAWIgRLBEAgHSgAACAWKAAAcyIEDQIgESEFIBZBBGohBAsgBCAiSQsEQANAIAUoAAAgBCgAAHMiHgRAIB4QJSAEaiAWawwECyAFQQRqIQUgBEEEaiIEICJJDQALCwJAIAQgL08NACAFLwAAIAQvAABHDQAgBUECaiEFIARBAmohBAsgBCAYSQR/IARBAWogBCAFLQAAIAQtAABGGwUgBAsgFmsMAQsgBBAlCyAKaiEKCyAKIAhKIgQLGyEeIAogCCAEGyEIDAELIARBBGoiBCAIIAQgCEoiBBshCCAKIB4gBBshHgsgDUF/aiENAkACQCA0RSAAIAdB//8DcUEBdGpBgIAIai8BACIEQQFHcg0AICVFBEBBASElICRFDQFBAiElIBIgGCAOEDNBBGohHAsgJUECRyAHQX9qIgUgFUlyDQBBAiElIBAgBRAyRQ0AIA4gEyALIAUgEEkiFhsgBWoiCigAAEcNACAKQQRqIA8gGCAWGyIHIA4QM0EEaiEEIBMgACgCkIAQIiBqIRYCQCAFIBBJBEAgByAEIApqRgRAIB0gGCAEIA4QPRAzIARqIQQLIAogFiAOEDEhBwwBCyAKIAogHSAOEDEiB2sgHUcgICAQT3INACAPIBZBACAHayAOED0QMSAHaiEHCyAFIAUgB2siCiAVIAogFUsbIgprIARqIhYgHEkgBCAcS3JFBEAgBCAFIBxraiIEIBAgECAEEDIbIQcMAgsgECAKEDJFBEAgECEHDAILAkAgCCAWIBwgFiAcSRsiBE8EQCAeIQUgCCEEDAELIAwgCiALaiIFa0H//wNKDQQLIAogACAKQf//A3FBAXRqQYCACGovAQAiCEkEQCAFIR4gBCEIDAQLIAogCGshByAFIR4gBCEIDAELIAcgBGshBwsgDUUNASAHIBVPDQALCwJAIA1FIB8gFWtB/v8DS3INACAfIBQgI2ooAgAiCiAVaiAUKAKAgBAgFCgChIAQIh1rIhFrIg9rQf//A0sNAANAIA1FDQEgDiAKIB1qIgQoAABGBEAgBEEEaiEEAn8CQAJ/IBIgGCAMIBEgCmtqIgUgBSAYSxsiEEF9aiIWIBJNDQAaIAQoAAAgEigAAHMiBQ0BIARBBGohBCAhCyIFIBZJBEADQCAEKAAAIAUoAABzIgcEQCAHECUgBWogEmsMBAsgBEEEaiEEIAVBBGoiBSAWSQ0ACwsCQCAFIBBBf2pPDQAgBC8AACAFLwAARw0AIARBAmohBCAFQQJqIQULIAUgEEkEfyAFQQFqIAUgBC0AACAFLQAARhsFIAULIBJrDAELIAUQJQtBBGoiBCAIIAQgCEoiBBshCCALIA9qIB4gBBshHgsgDUF/aiENIAogFCAKQf//A3FBAXRqQYCACGovAQAiBGshCiAfIA8gBGsiD2tBgIAESQ0ACwsgCEEDSgRAICghHyAJIQ4gDCEdIB4iCSEWIAghEgJ/An8CQAJAAkADQCAJIR4CQCAMIAgiDWoiKCAyTQRAIAAoApCAECIEIChBfmoiESAAKAKEgBAiIWsiIEGBgHxqIARBgIAEaiAgSxshIyAAKAKMgBAhFCAAKAKIgBAhJiAAKAKcgBAhJyARKAAAIRMgACgClIAQIgQgIEkEQANAIAAgBEH//wNxQQF0akGAgAhqIAQgACAEICFqEDpBAnRqIgUoAgBrIghB//8DIAhB//8DSRs7AQAgBSAENgIAIARBAWoiBCAgSQ0ACwsgESAMayEqIAAgIDYClIAQIBFBCGohMCARQQRqIRUgDCARayEkAkAgACAREDpBAnQiLGooAgAiByAjSQRAIC4hECANIQgMAQsgE0H//wNxIBNBEHZGIBNB/wFxIBNBGHZGcSE1IBQgJmohMSAUICFqIhxBBGohJUEAIS1BACAqayE2IAxBf2ohNyANIQggLiEQQQAhCQNAAkACQAJ/AkACQCAUIAdNBEAgCCA3ai8AACAHICFqIgsgNmogCGpBf2ovAABHDQUgEyALKAAARw0FAkAgKkUEQEEAIQoMAQsgJCAcIAtrIgQgJCAEShsiD0EfdSAPcSEFQQAhBANAIAQiCiAPTARAIAUhCgwCCyARIApBf2oiBGotAAAgBCALai0AAEYNAAsLIAtBBGohBCAiIBVNBH8gFQUgBCgAACAVKAAAcyIFDQIgBEEEaiEEIDALIgUgIkkEQANAIAQoAAAgBSgAAHMiDwRAIA8QJSAFaiAVayEEDAcLIARBBGohBCAFQQRqIgUgIkkNAAsLAkAgBSAvTw0AIAQvAAAgBS8AAEcNACAEQQJqIQQgBUECaiEFCyAFIBhJBH8gBUEBaiAFIAQtAAAgBS0AAEYbBSAFCyAVayEEDAQLIBMgByAmaiIKKAAARw0EIApBBGohBCAAKAKQgBAhOAJ/IBUgGCARIBQgB2tqIisgKyAYSxsiC0F9aiIPIBVNDQAaIAQoAAAgFSgAAHMiBQ0CIARBBGohBCAwCyIFIA9JBEADQCAEKAAAIAUoAABzIjkEQCA5ECUgBWogFWsMBQsgBEEEaiEEIAVBBGoiBSAPSQ0ACwsCQCAFIAtBf2pPDQAgBC8AACAFLwAARw0AIARBAmohBCAFQQJqIQULIAUgC0kEfyAFQQFqIAUgBC0AACAFLQAARhsFIAULIBVrDAILIAUQJSEEDAILIAUQJQshBCARIARBBGoiD2ogC0cgKyAYT3JFBEAgHCEFAn8CQAJ/ICIgCyIESwRAIBwoAAAgCygAAHMiBA0CICUhBSALQQRqIQQLIAQgIkkLBEADQCAFKAAAIAQoAABzIisEQCArECUgBGogC2sMBAsgBUEEaiEFIARBBGoiBCAiSQ0ACwsCQCAEIC9PDQAgBS8AACAELwAARw0AIAVBAmohBSAEQQJqIQQLIAQgGEkEfyAEQQFqIAQgBS0AACAELQAARhsFIAQLIAtrDAELIAQQJQsgD2ohDwsCQCAqRQRAQQAhBQwBCyAkICYgOGogCmsiBCAkIARKGyIrQR91ICtxIQtBACEEA0AgBCIFICtMBEAgCyEFDAILIBEgBUF/aiIEai0AACAEIApqLQAARg0ACwsgDyAFayIEIAhMDQEgBSARaiEZIAcgIWogBWohGyAEIQgMAQsgBCAKa0EEaiIEIAhMDQAgCiARaiEZIAogC2ohGyAEIQgLIBBBf2ohEAJAAkAgNEUgACAHQf//A3FBAXRqQYCACGovAQAiBEEBR3INACAtRQRAQQEhLSA1RQ0BQQIhLSAVIBggExAzQQRqIQkLIC1BAkcgB0F/aiIFICNJcg0AQQIhLSAUIAUQMkUNACATICYgISAFIBRJIgobIAVqIgsoAABHDQAgC0EEaiAxIBggChsiByATEDNBBGohBCAmIAAoApCAECIPaiEKAkAgBSAUSQRAIAcgBCALakYEQCAcIBggBCATED0QMyAEaiEECyALIAogExAxIQcMAQsgCyALIBwgExAxIgdrIBxHIA8gFE9yDQAgMSAKQQAgB2sgExA9EDEgB2ohBwsgBSAFIAdrIgsgIyALICNLGyIKayAEaiILIAlJIAQgCUtyRQRAIAQgBSAJa2oiBCAUIBQgBBAyGyEHDAILIAogFCAUIAoQMiIEGyEHICogBEVyDQECQCAIIAsgCSALIAlJGyIETwRAIBkhBSAbIQsgCCEEDAELIBEiBSAKICFqIgtrQf//A0oNBAsgCiAAIApB//8DcUEBdGpBgIAIai8BACIISQRAIAUhGSALIRsgBCEIDAQLIAogCGshByAFIRkgCyEbIAQhCAwBCyAHIARrIQcLIBBFDQEgByAjTw0ACwsCQCAgICNrQf7/A0sEQCAbIQkMAQsgEEUEQCAbIQkMAQsgICAnICxqKAIAIg8gI2ogJygCgIAQICcoAoSAECIHayIlayILa0H//wNLBEAgGyEJDAELIBshCQNAIBBFDQECQCATIAcgD2oiCigAAEcNACAKQQRqIQQCfwJAAn8gFSAYIBEgJSAPa2oiBSAFIBhLGyIbQX1qIhwgFU0NABogBCgAACAVKAAAcyIFDQEgBEEEaiEEIDALIgUgHEkEQANAIAQoAAAgBSgAAHMiFARAIBQQJSAFaiAVawwECyAEQQRqIQQgBUEEaiIFIBxJDQALCwJAIAUgG0F/ak8NACAELwAAIAUvAABHDQAgBEECaiEEIAVBAmohBQsgBSAbSQR/IAVBAWogBSAELQAAIAUtAABGGwUgBQsgFWsMAQsgBRAlC0EEaiEUAkAgKkUEQEEAIQUMAQsgJCAHICcoAoyAEGogCmsiBCAkIARKGyIcQR91IBxxIRtBACEEA0AgBCIFIBxMBEAgGyEFDAILIBEgBUF/aiIEai0AACAEIApqLQAARg0ACwsgFCAFayIEIAhMDQAgBSARaiEZIAsgIWogBWohCSAEIQgLIBBBf2ohECAPICcgD0H//wNxQQF0akGAgAhqLwEAIgRrIQ8gICALIARrIgtrQYCABEkNAAsLIAggDUcNASAJIRsLIAwgH2shBCAGBEAgDiAEQf8BbmogBGpBCWogKUsNBQsgDkEBaiEFAkAgBEEPTwRAIA5B8AE6AAAgBEFxaiIHQf8BTwRAIAVB/wEgBEHyfWoiCEH/AW4iBUEBahAoGiAFQYF+bCAIaiEHIAUgDmpBAmohBQsgBSAHOgAAIAVBAWohBQwBCyAOIARBBHQ6AAALIAUgHyAEIAVqIgkQOyAJIAwgHmtB//8DcRAvIA1BfGohCCAJQQJqIQkgBgRAIAkgCEH/AW5qQQZqIClLDQULIA4tAAAhDCAIQQ9PBEAgDiAMQQ9qOgAAIA1BbWoiB0H+A08EQCAJQf8BIA1B73tqIghB/gNuIglBAXQiDEECahAoGiAJQYJ8bCAIaiEHIAUgBCAMampBBGohCQsgB0H/AU8EQCAJQf8BOgAAIAdBgX5qIQcgCUEBaiEJCyAJIAc6AAAgCUEBaiEJDAQLIA4gCCAMajoAAAwDCyAdIAwgHSAMSSAZIAwgEmpJcSIEGyERIAkhGyAZIgwgEWtBA0gNACASIA0gBBshFSAWIB4gBBshHiAfIRYDQCARIBVqIh9BA2ohNSARIBVBEiAVQRJIGyIwaiExAkACQANAAn8CQCAMIBFrIgRBEUoNACARIAxrIAQgCGpBfGogMCAxIAggDGpBfGpLG2oiBEEBSA0AIAggBGshEiAEIAxqIRkgBCAJagwBCyAMIRkgCCESIAkLIRsCQCASIBlqIiggMk0EQCAAKAKQgBAiBCAoQX1qIg0gACgChIAQIiFrIiBBgYB8aiAEQYCABGogIEsbISMgACgCjIAQIRQgACgCiIAQISYgACgCnIAQIScgDSgAACETIAAoApSAECIEICBJBEADQCAAIARB//8DcUEBdGpBgIAIaiAEIAAgBCAhahA6QQJ0aiIFKAIAayIIQf//AyAIQf//A0kbOwEAIAUgBDYCACAEQQFqIgQgIEkNAAsLIA0gGWshKiAAICA2ApSAECANQQhqIS0gDUEEaiEdIBkgDWshJAJAIAAgDRA6QQJ0IjZqKAIAIgcgI0kEQCAuIRAgEiEIDAELIBNB//8DcSATQRB2RiATQf8BcSATQRh2RnEhNyAUICZqISsgFCAhaiIcQQRqISVBACEMQQAgKmshOCAZQX9qITkgEiEIIC4hEEEAIQkDQAJAAkACfwJAAkAgFCAHTQRAIAggOWovAAAgByAhaiILIDhqIAhqQX9qLwAARw0FIBMgCygAAEcNBQJAICpFBEBBACEKDAELICQgHCALayIEICQgBEobIg9BH3UgD3EhBUEAIQQDQCAEIgogD0wEQCAFIQoMAgsgDSAKQX9qIgRqLQAAIAQgC2otAABGDQALCyALQQRqIQQgIiAdTQR/IB0FIAQoAAAgHSgAAHMiBQ0CIARBBGohBCAtCyIFICJJBEADQCAEKAAAIAUoAABzIg8EQCAPECUgBWogHWshBAwHCyAEQQRqIQQgBUEEaiIFICJJDQALCwJAIAUgL08NACAELwAAIAUvAABHDQAgBEECaiEEIAVBAmohBQsgBSAYSQR/IAVBAWogBSAELQAAIAUtAABGGwUgBQsgHWshBAwECyATIAcgJmoiCigAAEcNBCAKQQRqIQQgACgCkIAQITwCfyAdIBggDSAUIAdraiIsICwgGEsbIgtBfWoiDyAdTQ0AGiAEKAAAIB0oAABzIgUNAiAEQQRqIQQgLQsiBSAPSQRAA0AgBCgAACAFKAAAcyI9BEAgPRAlIAVqIB1rDAULIARBBGohBCAFQQRqIgUgD0kNAAsLAkAgBSALQX9qTw0AIAQvAAAgBS8AAEcNACAEQQJqIQQgBUECaiEFCyAFIAtJBH8gBUEBaiAFIAQtAAAgBS0AAEYbBSAFCyAdawwCCyAFECUhBAwCCyAFECULIQQgDSAEQQRqIg9qIAtHICwgGE9yRQRAIBwhBQJ/AkACfyAiIAsiBEsEQCAcKAAAIAsoAABzIgQNAiAlIQUgC0EEaiEECyAEICJJCwRAA0AgBSgAACAEKAAAcyIsBEAgLBAlIARqIAtrDAQLIAVBBGohBSAEQQRqIgQgIkkNAAsLAkAgBCAvTw0AIAUvAAAgBC8AAEcNACAFQQJqIQUgBEECaiEECyAEIBhJBH8gBEEBaiAEIAUtAAAgBC0AAEYbBSAECyALawwBCyAEECULIA9qIQ8LAkAgKkUEQEEAIQUMAQsgJCAmIDxqIAprIgQgJCAEShsiLEEfdSAscSELQQAhBANAIAQiBSAsTARAIAshBQwCCyANIAVBf2oiBGotAAAgBCAKai0AAEYNAAsLIA8gBWsiBCAITA0BIAUgDWohFyAHICFqIAVqIRogBCEIDAELIAQgCmtBBGoiBCAITA0AIAogDWohFyAKIAtqIRogBCEICyAQQX9qIRACQAJAIDRFIAAgB0H//wNxQQF0akGAgAhqLwEAIgRBAUdyDQAgDEUEQEEBIQwgN0UNAUECIQwgHSAYIBMQM0EEaiEJCyAMQQJHIAdBf2oiBSAjSXINAEECIQwgFCAFEDJFDQAgEyAmICEgBSAUSSIKGyAFaiILKAAARw0AIAtBBGogKyAYIAobIgogExAzQQRqIQQgJiAAKAKQgBAiD2ohDAJAIAUgFEkEQCAKIAQgC2pGBEAgHCAYIAQgExA9EDMgBGohBAsgCyAMIBMQMSEHDAELIAsgCyAcIBMQMSIHayAcRyAPIBRPcg0AICsgDEEAIAdrIBMQPRAxIAdqIQcLIAUgBSAHayIMICMgDCAjSxsiCmsgBGoiCyAJSSAEIAlLckUEQCAEIAUgCWtqIgQgFCAUIAQQMhshB0ECIQwMAgsgCiAUIBQgChAyIgQbIQdBAiEMICogBEVyDQECQCAIIAsgCSALIAlJGyIETwRAIBchBSAaIQsgCCEEDAELIA0iBSAKICFqIgtrQf//A0oNBAsgCiAAIApB//8DcUEBdGpBgIAIai8BACIISQRAIAUhFyALIRogBCEIDAQLIAogCGshByAFIRcgCyEaIAQhCAwBCyAHIARrIQcLIBBFDQEgByAjTw0ACwsCQAJAIBBFICAgI2tB/v8DS3INACAgICcgNmooAgAiDyAjaiAnKAKAgBAgJygChIAQIgprIhxrIgtrQf//A0sNACAXIQwgGiEJA0AgEEUNAgJAIBMgCiAPaiIaKAAARw0AIBpBBGohBAJ/AkACfyAdIBggDSAcIA9raiIFIAUgGEsbIhdBfWoiByAdTQ0AGiAEKAAAIB0oAABzIgUNASAEQQRqIQQgLQsiBSAHSQRAA0AgBCgAACAFKAAAcyIlBEAgJRAlIAVqIB1rDAQLIARBBGohBCAFQQRqIgUgB0kNAAsLAkAgBSAXQX9qTw0AIAQvAAAgBS8AAEcNACAEQQJqIQQgBUECaiEFCyAFIBdJBH8gBUEBaiAFIAQtAAAgBS0AAEYbBSAFCyAdawwBCyAFECULQQRqISUCQCAqRQRAQQAhBQwBCyAkIAogJygCjIAQaiAaayIEICQgBEobIgdBH3UgB3EhF0EAIQQDQCAEIgUgB0wEQCAXIQUMAgsgDSAFQX9qIgRqLQAAIAQgGmotAABGDQALCyAlIAVrIgQgCEwNACAFIA1qIQwgCyAhaiAFaiEJIAQhCAsgEEF/aiEQIA8gJyAPQf//A3FBAXRqQYCACGovAQAiBGshDyAgIAsgBGsiC2tBgIAESQ0ACwwBCyAXIQwgGiEJCyAIIBJHDQEgCSEaIAwhFwsgESAWayEFIAYEQCAOIAVB/wFuaiAFakEJaiApSw0ECyAZIBFrIBUgGSAfSRshCSAOQQFqIQcCQCAFQQ9PBEAgDkHwAToAACAFQXFqIgRB/wFPBEAgB0H/ASAFQfJ9aiIIQf8BbiIEQQFqECgaIAQgDmpBAmohByAEQYF+bCAIaiEECyAHIAQ6AAAgB0EBaiEHDAELIA4gBUEEdDoAAAsgByAWIAUgB2oiBBA7IAQgESAea0H//wNxEC8gCUF8aiEIIARBAmohBCAGBEAgBCAIQf8BbmpBBmogKUsNBAsgDi0AACEMAkAgCEEPTwRAIA4gDEEPajoAACAJQW1qIghB/gNPBEAgBEH/ASAJQe97aiIEQf4DbiIIQQF0IgxBAmoQKBogCEGCfGwgBGohCCAHIAUgDGpqQQRqIQQLIAhB/wFPBEAgBEH/AToAACAIQYF+aiEIIARBAWohBAsgBCAIOgAAIARBAWohBAwBCyAOIAggDGo6AAALIBkgCSARaiIFayEIIAYEQCAEIAhB/wFuaiAIakEJaiApSw0HCyAEQQFqIQcCQCAIQQ9PBEAgBEHwAToAACAIQXFqIg1B/wFPBEAgB0H/ASAIQfJ9aiIMQf8BbiIJQQFqECgaIAQgCWpBAmohByAJQYF+bCAMaiENCyAHIA06AAAgB0EBaiEHDAELIAQgCEEEdDoAAAsgByAFIAcgCGoiCRA7IAkgGSAba0H//wNxEC8gEkF8aiEIIAlBAmohCSAGBEAgCSAIQf8BbmpBBmogKUsNBwsgBC0AACEMIAhBD08EQCAEIAxBD2o6AAACfyASQW1qIgRB/gNPBEAgCUH/ASASQe97aiIEQf4DbiIIQQF0IglBAmoQKBogByAJIBlqIAVrakEEaiEJIAhBgnxsIARqIQQLIARB/wFPCwRAIAlB/wE6AAAgCUEBaiEJIARBgX5qIQQLIAkgBDoAACAJQQFqIQkMCAsgBCAIIAxqOgAADAcLIAwgNU8NASAMIRcgCSEaIAwgH0kNAAsCQCAZIB9PDQAgEiAfIBlrIgRrIhJBA0oEQCAEIBtqIRsgHyEZDAELIAwhGSAJIRsgCCESCyARIBZrIQQgBgRAIA4gBEH/AW5qIARqQQlqIClLDQILIA5BAWohBQJAIARBD08EQCAOQfABOgAAIARBcWoiB0H/AU8EQCAFQf8BIARB8n1qIhdB/wFuIgVBAWoQKBogBUGBfmwgF2ohByAFIA5qQQJqIQULIAUgBzoAACAFQQFqIQUMAQsgDiAEQQR0OgAACyAFIBYgBCAFaiIaEDsgGiARIB5rQf//A3EQLyAVQXxqIRcgGkECaiEHIAYEQCAHIBdB/wFuakEGaiApSw0CCyAOLQAAIRoCfyAXQQ9PBEAgDiAaQQ9qOgAAAn8gFUFtaiINQf4DTwRAIAdB/wEgFUHve2oiF0H+A24iGkEBdCIeQQJqECgaIAUgBCAeampBBGohByAaQYJ8bCAXaiENCyANQf8BTwsEQCAHQf8BOgAAIAdBAWohByANQYF+aiENCyAHIA06AAAgB0EBagwBCyAOIBcgGmo6AAAgBwshDiAMIRcgCSEaIBkhHSAbIRYMAwsCfyAZIB9PBEAgFSENIBIMAQsgEiAZIBFrIg1BEUoNABogEiANIBJqQXxqIDAgMSASIBlqQXxqSxsiDSARIBlraiIEQQFIDQAaIAQgG2ohGyAEIBlqIRkgEiAEawshFSARIBZrIQQgBgRAIA4gBEH/AW5qIARqQQlqIClLDQELIA5BAWohBQJAIARBD08EQCAOQfABOgAAIARBcWoiB0H/AU8EQCAFQf8BIARB8n1qIhdB/wFuIgVBAWoQKBogBUGBfmwgF2ohByAFIA5qQQJqIQULIAUgBzoAACAFQQFqIQUMAQsgDiAEQQR0OgAACyAFIBYgBCAFaiIaEDsgGiARIB5rQf//A3EQLyANQXxqIRcgGkECaiEHIAYEQCAHIBdB/wFuakEGaiApSw0BCyAOLQAAIRoCfyAXQQ9PBEAgDiAaQQ9qOgAAAn8gDUFtaiIQQf4DTwRAIAdB/wEgDUHve2oiF0H+A24iGkEBdCIeQQJqECgaIAUgBCAeampBBGohByAaQYJ8bCAXaiEQCyAQQf8BTwsEQCAHQf8BOgAAIAdBAWohByAQQYF+aiEQCyAHIBA6AAAgDSARaiEWIBkhESAHQQFqDAELIA4gFyAaajoAACANIBFqIRYgGSERIAcLIQ4gGyEeIAwhFyAJIRoMAQsLCyAWDAMLIAUhKCAEDAMLICggMksNBiAAKAKEgBAhCwwFCyAfCyEoIA4LIQlBACEHIAZBAkYNAwwGCyAfIQQgDEEBaiIMIDJNDQALCwsgMyAoayIEQfABakH/AW4hBQJAIAZFDQAgBCAFaiAJakEBaiApQQVqIDogOxsiBU0NAEEAIQcgBkEBRg0DIAlBf3MgBWoiBCAEQfABakH/AW5rIQQLIAQgKGohBgJAIARBD08EQCAJQfABOgAAIAlBAWohBSAEQXFqIghB/wFJBEAgBSIJIAg6AAAMAgsgBUH/ASAEQfJ9aiIIQf8BbiIFQQFqECgaIAUgCWpBAmoiCSAFQYF+bCAIajoAAAwBCyAJIARBBHQ6AAALIAlBAWogKCAEECohBSADIAYgAWs2AgAgBCAFaiACawwBCyAAIAEgAiADIAQgLiAJQZgWaigCACAGIAVBC0pBASAALQCagBBBAEcQkAILIgdBAEoNAQsgAEEBOgCbgBALIAcPCyAAIAEgAiADIAQgBSAGEJECCzAAIAAoApyAEEUEQCAAIAEgAiADIAQgBSAGEJECDwsgACABIAIgAyAEIAUgBhCuBAt+AQF/IAAoAoCAECAAKAKEgBBrIgJBgYCAgARPBEAgAEEAQYCACBAoQYCACGpB/wFBgIAIECgaQQAhAgsgACABNgKAgBAgACACQYCABGoiAjYClIAQIAAgAjYCkIAQIAAgAjYCjIAQIAAgASACayIBNgKEgBAgACABNgKIgBALTwEBfyAALQCbgBAEQCAAEJICGiAAIAEQsAEPCyAAQQA2ApyAECAAKAKEgBAhAiAAQQA2AoSAECAAIAAoAoCAECACazYCgIAQIAAgARCwAQtQAQJ/IwBBEGsiBiQAIAYgAzYCDCAAQQNxRQRAIAAgBRCxBCAAIAEQsAQgACABIAIgBkEMaiAEIAUgAxCTAiAEShCvBCEHCyAGQRBqJAAgBwvyKAETfyAFQQEgBUEBShshBiAAIgVFIABBB3FyBH9BAAUgBUEAQaCAARAoCyEIAkACQAJAAkAgAxCTAiAETARAIANBioAESg0BIANBgICA8AdLDQIgASADaiEMIAgoAoCAASEAIAhBAzsBhoABIAggACADajYCgIABIAggCCgCkIABIANqNgKQgAECQCADQQ1IBEAgAiEDIAEhAAwBCyAMQXVqIRAgDEF0aiEUIAEgASgAAEEDEDAgCEEDIAEgAGsiCxBJIAxBe2oiEUF/aiETIBFBfWohDyAGQQZ0IgVBAXIhEiABQQFqIgQoAABBAxAwIQogASEJIAIhBgNAIARBAWohDSAKIAhBAxBIIQcgBSEOIBIhAwJAA0AgDSgAAEEDEDAhACAEIAtrIAogCEEDEFwgByALaiIKKAAAIAQoAABGDQEgDkEGdSEVIAAgCEEDEEghByADIQ4gA0EBaiEDIAAhCiAVIA0iBGoiDSAQTQ0ACyAGIQMgCSEADAILA0AgCiINIAFNIAQiACAJTXJFBEAgAEF/aiIELQAAIA1Bf2oiCi0AAEYNAQsLIAZBAWohAwJAIAAgCWsiBEEPTwRAIAZB8AE6AAAgBEFxaiIKQf8BTgRAIANB/wEgAEHvAWoiAyAKQf0DIApB/QNIGyIHIAlqa0H/AW5BAWoQKBogBiADIAlrIAdrQf8BbiIHakECaiEDIAQgB0GBfmxqQfJ9aiEKCyADIAo6AAAgA0EBaiEDDAELIAYgBEEEdDoAAAsgAyAJIAMgBGoiChA7A0AgCiAAIA1rQf//A3EQLyANQQRqIQMCfwJAAn8gDyAAQQRqIglNBEAgCQwBCyADKAAAIAkoAABzIgMNASANQQhqIQMgAEEIagsiBCAPSQRAA0AgAygAACAEKAAAcyIHBEAgBxAlIARqIAlrDAQLIANBBGohAyAEQQRqIgQgD0kNAAsLAkAgBCATTw0AIAMvAAAgBC8AAEcNACADQQJqIQMgBEECaiEECyAEIBFJBH8gBEEBaiAEIAMtAAAgBC0AAEYbBSAECyAJawwBCyADECULIQQgCkECaiEDIAAgBGpBBGohACAGLQAAIQkCQCAEQQ9PBEAgBiAJQQ9qOgAAIANBfxA0IARBcWoiBEH8B08EQANAIANBBGoiA0F/EDQgBEGEeGoiBEH7B0sNAAsLIAMgBEH//wNxQf8BbiIGaiIDIAZBgX5sIARqOgAAIANBAWohAwwBCyAGIAQgCWo6AAALIAAgEE8NAiAAQX5qIgQgBCgAAEEDEDAgCEEDIAsQSSAAKAAAQQMQMCIEIAhBAxBIIQYgACALayAEIAhBAxBcIAYgC2oiDSgAACAAKAAARgRAIANBADoAACADQQFqIQogAyEGDAELCyAAQQFqIgQoAABBAxAwIQogACEJIAMhBiAEIBRNDQALCwJAIAwgAGsiBEEPTwRAIANB8AE6AAAgA0EBaiEBIARBcWoiBUH/AUkEQCABIgMgBToAAAwCCyABQf8BIARB8n1qIgFB/wFuQQFqECgaIAFB/wFuIgUgA2pBAmoiAyAFQYF+bCABajoAAAwBCyADIARBBHQ6AAALDAQLIANBioAETARAIANBgICA8AdLDQIgAiAEaiEPIAEgA2ohDCAIKAKAgAEhACAIQQM7AYaAASAIIAAgA2o2AoCAASAIIAgoApCAASADajYCkIABAkAgA0ENSARAIAIhAyABIQAMAQsgDEF1aiERIAxBdGohFSABIAEoAABBAxAwIAhBAyABIABrIgsQSSAMQXtqIhRBf2ohFyAUQX1qIRAgBkEGdCIJQQFyIRIgAUEBaiIEKAAAQQMQMCEKIAEhBSACIQYDQCAEQQFqIQ0gCiAIQQMQSCEHIAkhDiASIQMCQANAIA0oAABBAxAwIQAgBCALayAKIAhBAxBcIAcgC2oiCigAACAEKAAARg0BIA5BBnUhFiAAIAhBAxBIIQcgAyEOIANBAWohAyAAIQogFiANIgRqIg0gEU0NAAsgBiEDIAUhAAwCCwNAIAoiDSABTSAEIgAgBU1yRQRAIABBf2oiBC0AACANQX9qIgotAABGDQELCyAGIAAgBWsiA2ogA0H/AW5qQQlqIA9LBEBBAA8LIAZBAWohBAJAIANBD08EQCAGQfABOgAAIANBcWoiCkH/AU4EQCAEQf8BIABB7wFqIgQgCkH9AyAKQf0DSBsiByAFamtB/wFuQQFqECgaIAYgBCAFayAHa0H/AW4iB2pBAmohBCADIAdBgX5sakHyfWohCgsgBCAKOgAAIARBAWohBAwBCyAGIANBBHQ6AAALIAQgBSADIARqIgoQOwNAIAogACANa0H//wNxEC8gDUEEaiEDIAoCfwJAAn8gECAAQQRqIgVNBEAgBQwBCyADKAAAIAUoAABzIgMNASANQQhqIQMgAEEIagsiBCAQSQRAA0AgAygAACAEKAAAcyIHBEAgBxAlIARqIAVrDAQLIANBBGohAyAEQQRqIgQgEEkNAAsLAkAgBCAXTw0AIAMvAAAgBC8AAEcNACADQQJqIQMgBEECaiEECyAEIBRJBH8gBEEBaiAEIAMtAAAgBC0AAEYbBSAECyAFawwBCyADECULIgRB8AFqQf8BbmpBCGogD0sEQEEADwsgCkECaiEDIAAgBGpBBGohACAGLQAAIQUCQCAEQQ9PBEAgBiAFQQ9qOgAAIANBfxA0IARBcWoiBEH8B08EQANAIANBBGoiA0F/EDQgBEGEeGoiBEH7B0sNAAsLIAMgBEH//wNxQf8BbiIFaiIDIAVBgX5sIARqOgAAIANBAWohAwwBCyAGIAQgBWo6AAALIAAgEU8NAiAAQX5qIgQgBCgAAEEDEDAgCEEDIAsQSSAAKAAAQQMQMCIEIAhBAxBIIQUgACALayAEIAhBAxBcIAUgC2oiDSgAACAAKAAARgRAIANBADoAACADQQFqIQogAyEGDAELCyAAQQFqIgQoAABBAxAwIQogACEFIAMhBiAEIBVNDQALCyADIAwgAGsiBGogBEHwAWpB/wFuakEBaiAPSw0CAkAgBEEPTwRAIANB8AE6AAAgA0EBaiEBIARBcWoiBUH/AUkEQCABIgMgBToAAAwCCyABQf8BIARB8n1qIgFB/wFuQQFqECgaIAFB/wFuIgUgA2pBAmoiAyAFQYF+bCABajoAAAwBCyADIARBBHQ6AAALDAQLIANBgICA8AdLDQEgAiAEaiEPIAEgA2oiEEF1aiERIBBBdGohFSAIKAKAgAEhACAIQQFBAiABQf//A0sbIgs7AYaAASAIIAAgA2o2AoCAASAIIAgoApCAASADajYCkIABIAEgASgAACALEDAgCCALIAEgAGsiDBBJIBBBe2oiF0F/aiEYIBdBfWohFCAGQQZ0IgpBAXIhDSABQQFqIgMoAAAgCxAwIQQgAUGAgARJIRYgAiEFIAEhBgNAAkACQCAWRQRAIAMgFUsNAiADQQFqIQ4gCiEJIA0hBwNAIAQgCBCFASEAIA4oAABBARAwIRIgAyAEIAhBASAMEEkgAEH//wNqIANPBEAgACgAACADKAAARg0DCyAJQQZ1IQAgByEJIAdBAWohByASIQQgACAOIgNqIg4gEU0NAAsMAgsgAyAVSw0BIANBAWohDiAEIAggCxBIIQAgCiEJIA0hBwNAIA4oAAAgCxAwIRIgAyAMayITIAQgCCALEFwgAEH//wNqIBNPBEAgACAMaiIAKAAAIAMoAABGDQILIAlBBnUhEyASIAggCxBIIQAgByEJIAdBAWohByASIQQgEyAOIgNqIg4gEU0NAAsMAQsDQCAAIgQgAU0gAyIJIAZNckUEQCAJQX9qIgMtAAAgBEF/aiIALQAARg0BCwtBACETIAUgCSAGayIDaiADQf8BbmpBCWogD0sNAyAFQQFqIQACQCADQQ9PBEAgBUHwAToAACADQXFqIgdB/wFOBEAgAEH/ASAJQe8BaiIAIAdB/QMgB0H9A0gbIgcgBmprQf8BbkEBahAoGiAFIAAgBmsgB2tB/wFuIgdqQQJqIQAgAyAHQYF+bGpB8n1qIQcLIAAgBzoAACAAQQFqIQAMAQsgBSADQQR0OgAACyAAIAYgACADaiIHEDsgCSEGA0AgByAGIARrQf//A3EQLyAEQQRqIQMgBwJ/AkACfyAUIAZBBGoiAE0EQCAADAELIAMoAAAgACgAAHMiAw0BIARBCGohAyAGQQhqCyIEIBRJBEADQCADKAAAIAQoAABzIgkEQCAJECUgBGogAGsMBAsgA0EEaiEDIARBBGoiBCAUSQ0ACwsCQCAEIBhPDQAgAy8AACAELwAARw0AIANBAmohAyAEQQJqIQQLIAQgF0kEfyAEQQFqIAQgAy0AACAELQAARhsFIAQLIABrDAELIAMQJQsiAEHwAWpB/wFuakEIaiAPSw0EIAdBAmohAyAAIAZqQQRqIQYgBS0AACEEAn8gAEEPTwRAIAUgBEEPajoAACADQX8QNCAAQXFqIgRB/AdPBEADQCADQQRqIgNBfxA0IARBhHhqIgRB+wdLDQALCyADIARB//8DcUH/AW4iAGoiAyAAQYF+bCAEajoAACADQQFqDAELIAUgACAEajoAACADCyEFIAYgEU8NASAGQX5qIgAgACgAACALEDAgCCALIAwQSSAGKAAAIQACQAJAIBZFBEAgAEEBEDAiACAIEIUBIQQgBiAAIAhBASAMEEkgBEH//wNqIAZJDQEgBCgAACAGKAAARw0BDAILIAAgCxAwIgMgCCALEEghACAGIAxrIgQgAyAIIAsQXCAAQf//A2ogBEkNACAAIAxqIgQoAAAgBigAAEYNAQsgBkEBaiIDKAAAIAsQMCEEDAMLIAVBADoAACAFQQFqIQcMAAsACwtBACETIAUgECAGayIBaiABQfABakH/AW5qQQFqIA9LDQECQCABQQ9PBEAgBUHwAToAACAFQQFqIQAgAUFxaiIDQf8BSQRAIAAiBSADOgAADAILIABB/wEgAUHyfWoiAEH/AW5BAWoQKBogAEH/AW4iAyAFakECaiIFIANBgX5sIABqOgAADAELIAUgAUEEdDoAAAsgBUEBaiAGIAEQKiABaiACayETDAELIANBgICA8AdLDQAgASADaiIPQXVqIRAgD0F0aiEUIAgoAoCAASEAIAhBAUECIAFB//8DSxsiCzsBhoABIAggACADajYCgIABIAggCCgCkIABIANqNgKQgAEgASABKAAAIAsQMCAIIAsgASAAayIMEEkgD0F7aiITQX9qIRcgE0F9aiERIAZBBnQiCkEBciENIAFBAWoiAygAACALEDAhBCABQYCABEkhFSACIQUgASEGA0ACQCAVRQRAIAMgFEsNBCADQQFqIQ4gCiEJIA0hBwNAIAQgCBCFASEAIA4oAABBARAwIRIgAyAEIAhBASAMEEkgAEH//wNqIANPBEAgACgAACADKAAARg0DCyAJQQZ1IQAgByEJIAdBAWohByASIQQgACAOIgNqIg4gEE0NAAsMBAsgAyAUSw0DIANBAWohDiAEIAggCxBIIQAgCiEJIA0hBwNAIA4oAAAgCxAwIRIgAyAMayIWIAQgCCALEFwgAEH//wNqIBZPBEAgACAMaiIAKAAAIAMoAABGDQILIAlBBnUhFiASIAggCxBIIQAgByEJIAdBAWohByASIQQgFiAOIgNqIg4gEE0NAAsMAwsDQCAAIgQgAU0gAyIJIAZNckUEQCAJQX9qIgMtAAAgBEF/aiIALQAARg0BCwsgBUEBaiEDAkAgCSAGayIAQQ9PBEAgBUHwAToAACAAQXFqIgdB/wFOBEAgA0H/ASAJQe8BaiIDIAdB/QMgB0H9A0gbIgcgBmprQf8BbkEBahAoGiAFIAMgBmsgB2tB/wFuIgdqQQJqIQMgACAHQYF+bGpB8n1qIQcLIAMgBzoAACADQQFqIQMMAQsgBSAAQQR0OgAACyADIAYgACADaiIHEDsgCSEGA0AgByAGIARrQf//A3EQLyAEQQRqIQMCfwJAAn8gESAGQQRqIgBNBEAgAAwBCyADKAAAIAAoAABzIgMNASAEQQhqIQMgBkEIagsiBCARSQRAA0AgAygAACAEKAAAcyIJBEAgCRAlIARqIABrDAQLIANBBGohAyAEQQRqIgQgEUkNAAsLAkAgBCAXTw0AIAMvAAAgBC8AAEcNACADQQJqIQMgBEECaiEECyAEIBNJBH8gBEEBaiAEIAMtAAAgBC0AAEYbBSAECyAAawwBCyADECULIQAgB0ECaiEDIAAgBmpBBGohBiAFLQAAIQQCfyAAQQ9PBEAgBSAEQQ9qOgAAIANBfxA0IABBcWoiBEH8B08EQANAIANBBGoiA0F/EDQgBEGEeGoiBEH7B0sNAAsLIAMgBEH//wNxQf8BbiIAaiIDIABBgX5sIARqOgAAIANBAWoMAQsgBSAAIARqOgAAIAMLIQUgBiAQTw0DIAZBfmoiACAAKAAAIAsQMCAIIAsgDBBJIAYoAAAhAAJAAkAgFUUEQCAAQQEQMCIAIAgQhQEhBCAGIAAgCEEBIAwQSSAEQf//A2ogBkkNASAEKAAAIAYoAABHDQEMAgsgACALEDAiAyAIIAsQSCEAIAYgDGsiBCADIAggCxBcIABB//8DaiAESQ0AIAAgDGoiBCgAACAGKAAARg0BCyAGQQFqIgMoAAAgCxAwIQQMAgsgBUEAOgAAIAVBAWohBwwACwALAAsgEw8LAkAgDyAGayIBQQ9PBEAgBUHwAToAACAFQQFqIQAgAUFxaiIDQf8BSQRAIAAiBSADOgAADAILIABB/wEgAUHyfWoiAEH/AW5BAWoQKBogAEH/AW4iAyAFakECaiIFIANBgX5sIABqOgAADAELIAUgAUEEdDoAAAsgBUEBaiAGIAEQKiABaiACaw8LIANBAWogACAEECogBGogAmsLJgAgAEEXNgIQIABBGDYCDCAAQRk2AgggAEEaNgIEIABBwBU2AgAL1QgBCX8gBAR/QRBBICAEQRB2IgUbQXhBACAFIAQgBRsiBUEIdiIEG2pBfEEAIAQgBSAEGyIFQQR2IgQbakF+QQAgBCAFIAQbIgVBAnYiBBtqIAQgBSAEG0EBS2sFQSELIQsgACABaiEJAkAgAUEPSQ0AIAlBfGohDCAJQXFqIQ0gACIGQQFqIgEhBANAIAEoAAAhB0EgIQEDQCAEIgUgAUEFdmoiBCANSwRAIAYhAAwDCyADIAdBvc/W8QFsIAt2QQF0aiIILwEAIQogBCgAACEHIAggBSAAazsBACABQQFqIQEgBSgAACAAIApqIgooAABHDQALIAUgBmsiCEF/aiEBAkACQCAIQT1OBEAgAkEBaiEEQQAhBwNAIAQgAToAACAEQQFqIQQgB0EBaiEHIAFBCHYiAQ0ACyACIAdBAnRBbGo6AAAMAQsgAiABQQJ0OgAAIAJBAWohBCAIQRBKDQAgAiAGKAAANgABIAIgBigABDYABSACIAYoAAg2AAkgAiAGKAAMNgANDAELIAQgBiAIECoaCyAEIAhqIQIDQCAKQQRqIQdBACEEAkACQCAMIAVBBGoiAUkNAANAIAEoAAAiBiAEIAdqKAAAIghGBEAgBEEEaiEEIAFBBGoiASAMTQ0BDAILCyAEQXhBACAGIAhzIgRBEHQiASAEIAEbIgZBCHQiBBtBD0EfIAEbakF8QQAgBCAGIAQbIgRBBHQiARtqQX5BACABIAQgARsiBEECdCIBG2ogASAEIAEbQf////8HcUEAR2tBA3VqIQQMAQsgASAJTw0AIAkgBCABa2ohBgNAIAQgB2otAAAgAS0AAEcNASAEQQFqIQQgAUEBaiIBIAlHDQALIAYhBAsgBSAKayEGIARBBGohAQJAIARBwABIBEAgASEHDAELIAEhBANAIAIgBjsAASACQf4BOgAAIAJBA2ohAiAEQYMBSiEIIARBQGoiByEEIAgNAAsLIAdBwQBOBEAgAiAGOwABIAJB7gE6AAAgB0FEaiEHIAJBA2ohAgsgASAFaiEFAn8gB0ELSiAGQf8PS3JFBEAgAiAGOgABIAIgBkEDdkHgAXEgB0ECdGpB8QFqOgAAIAJBAmoMAQsgAiAGOwABIAIgB0ECdEF+ajoAACACQQNqCyECIAUgDU8EQCAFIQAMAwsgAyAFQX9qIgEoAABBvc/W8QFsIAt2QQF0aiAFIABrIgRBf2o7AQAgACADIAUoAABBvc/W8QFsIAt2QQF0aiIGLwEAaiIKKAAAIQcgBiAEOwEAIAcgBSgAAEYNAAsgBUEBaiEEIAFBAmohASAFIQYMAAsACyAAIAlJBH8gCSAAayIDQX9qIQEgAgJ/IANBPU4EQCACQQFqIQRBACEHA0AgBCABOgAAIARBAWohBCAHQQFqIQcgAUEIdiIBDQALIAdBAnRBbGoMAQsgAkEBaiEEIAFBAnQLOgAAIAQgACADECogA2oFIAILC+sCAhV/AX5CsH8hGSACQQdxBH4gGQUgAwRAIAJBA3YhBSADQQN0IQkDQCAFBEAgCEEDdCIGIAVsIQogBkEHciILIAVsIQwgBkEGciINIAVsIQ4gBkEFciIPIAVsIRAgBkEEciIRIAVsIRIgBkEDciITIAVsIRQgBkECciIVIAVsIRYgBkEBciIXIAVsIRhBACEEA0AgASAGIAQgCWwiB2pqIAAgBCAKamotAAA6AAAgASAHIBdqaiAAIAQgGGpqLQAAOgAAIAEgByAVamogACAEIBZqai0AADoAACABIAcgE2pqIAAgBCAUamotAAA6AAAgASAHIBFqaiAAIAQgEmpqLQAAOgAAIAEgByAPamogACAEIBBqai0AADoAACABIAcgDWpqIAAgBCAOamotAAA6AAAgASAHIAtqaiAAIAQgDGpqLQAAOgAAIARBAWoiBCAFRw0ACwsgCEEBaiIIIANHDQALCyACIANsrQsLNAEBfkKwfyEFAkAgAkEHcQ0AIAAgBCACIAMQtgQiBUIAUw0AIAQgASACIAMQuAQhBQsgBQv2AgINfwJ+QrB/IREgAkEHcQR+IBEFIAIgA2whByADQQN0IgUEQCADQQdsIQkgA0EGbCEKIANBBWwhCyADQQJ0IQwgA0EDbCENIANBAXQhDiAFQX9qIAdPIQ8DQCAPRQRAIAZBA3YhEEEAIQggBSECA0AgASAIIBBqIgRqIAAgBiAIamopAwAiEUIHiCARhUKqgaiFoJWA1QCDIhIgEYUgEkIHhoUiEUIOiCARhULMmYOAwJkzgyISIBGFIBJCDoaFIhFCHIggEYVC8OHDhw+DIhIgEYUiETwAACABIAMgBGpqIBFCCIg8AAAgASAEIA5qaiARQhCIPAAAIAEgBCANamogEUIYiDwAACABIAQgDGpqIBEgEkIchoUiEUIgiDwAACABIAQgC2pqIBFCKIg8AAAgASAEIApqaiARQjCIPAAAIAEgBCAJamogEUI4iDwAACACIgggBWoiAkF/aiAHSQ0ACwsgBkEIaiIGIAVJDQALCyAHrQsLVQEBfkKwfyEFAkAgAkEHcQ0AIAAgASACIAMQvAQiBUIAUw0AIAEgBCACIAMQuwQiBUIAUw0AIAJBB3EEfkKwfwUgBCABIAMgAkEDdhC6BAshBQsgBQtZAQN/A0AgAgRAIAIgBGwhBkEAIQUDQCABIAVBA3QgBGogA2xqIAAgBSAGaiADbGogAxAqGiAFQQFqIgUgAkcNAAsLIARBAWoiBEEIRw0ACyACIANsQQN0rQvAAgIHfwJ+QrB/IQsgAiADbCIEQQdxBH4gCwUgBEEDdiICBEAgAkEHbCEFIAJBBmwhBiACQQVsIQcgAkECdCEIIAJBA2whCSACQQF0IQpBACEDA0AgASADaiAAIANBA3RqKQMAIgtCB4ggC4VCqoGohaCVgNUAgyIMIAuFIAxCB4aFIgtCDoggC4VCzJmDgMCZM4MiDCALhSAMQg6GhSILQhyIIAuFQvDhw4cPgyIMIAuFIgs8AAAgASACIANqaiALQgiIPAAAIAEgAyAKamogC0IQiDwAACABIAMgCWpqIAtCGIg8AAAgASADIAhqaiALIAxCHIaFIgtCIIg8AAAgASADIAdqaiALQiiIPAAAIAEgAyAGamogC0IwiDwAACABIAMgBWpqIAtCOIg8AAAgA0EBaiIDIAJHDQALCyAErQsLrQMBEn8CQCACRQ0AIAJBCE8EQANAIAMEQCADIAVsIQcgBUEHciIIIANsIQkgBUEGciIKIANsIQsgBUEFciIMIANsIQ0gBUEEciIOIANsIQ8gBUEDciIQIANsIREgBUECciISIANsIRMgBUEBciIUIANsIRVBACEEA0AgASAFIAIgBGwiBmpqIAAgBCAHamotAAA6AAAgASAGIBRqaiAAIAQgFWpqLQAAOgAAIAEgBiASamogACAEIBNqai0AADoAACABIAYgEGpqIAAgBCARamotAAA6AAAgASAGIA5qaiAAIAQgD2pqLQAAOgAAIAEgBiAMamogACAEIA1qai0AADoAACABIAYgCmpqIAAgBCALamotAAA6AAAgASAGIAhqaiAAIAQgCWpqLQAAOgAAIARBAWoiBCADRw0ACwsgBUEPaiEEIAVBCGohBSAEIAJJDQALCyACQXhxIgUgAk8NAANAIAMEQCADIAVsIQZBACEEA0AgASACIARsIAVqaiAAIAQgBmpqLQAAOgAAIARBAWoiBCADRw0ACwsgBUEBaiIFIAJHDQALCyACIANsrQuCAQEGfyABIAEgAG4iBiAAbGshByAAIAFNBEAgBkEBIAZBAUsbIQgDQCAABEAgACAEbCEJQQAhBQNAIAMgBSAJamogAiAFIAZsIARqai0AADoAACAFQQFqIgUgAEcNAAsLIARBAWoiBCAIRw0ACwsgAyABIAdrIgBqIAAgAmogBxAqGgsNACAAIAEgAiADEL0EC4IBAQZ/IAEgASAAbiIGIABsayEHIAAEQCAGQQEgBkEBSxshCANAIAAgAU0EQCAEIAZsIQlBACEFA0AgAyAFIAlqaiACIAAgBWwgBGpqLQAAOgAAIAVBAWoiBSAIRw0ACwsgBEEBaiIEIABHDQALCyADIAEgB2siAGogACACaiAHECoaC7gBAQN/AkAgAUEBSA0AIAAsAAAiBEH/AHEhAwJAIARBf0oNACABQQJIDQEgACwAASIEQQd0QYD/AHEgA3IhAyAEQX9KDQAgAUEDSA0BIAAsAAIiBEEOdEGAgP8AcSADciEDIARBf0oNACABQQRIDQEgACwAAyIEQRV0QYCAgP8AcSADciEDIARBf0oNACABQQVIDQEgAC0ABCIAQQ9LDQEgAEEcdCADciEDCyACIAM2AgBBASEFCyAFCw0AIAAgASACIAMQvwQLlAIBA38gACABEDcaIAJBA3YiBEH4////AXEhAyABIAJBB3EiBWohAiAAIAVqIQACQAJAAkACQAJAAkACQAJAIARBB3FBf2oOBwYFBAMCAQAHCyAAIAIQNyEAIAJBCGohAgsgACACEDchACACQQhqIQILIAAgAhA3IQAgAkEIaiECCyAAIAIQNyEAIAJBCGohAgsgACACEDchACACQQhqIQILIAAgAhA3IQAgAkEIaiECCyAAIAIQNyEAIAJBCGohAgsgAwRAA0AgACACEDcgAkEIahA3IAJBEGoQNyACQRhqEDcgAkEgahA3IAJBKGoQNyACQTBqEDcgAkE4ahA3IQAgAkFAayECIANBeGoiAw0ACwsgAAstACACBEADQCAAIAEtAAA6AAAgAEEBaiEAIAFBAWohASACQX9qIgINAAsLIAALvQUBA38gACABayIDQQlPBEAgACABIAIQUA8LAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIANBfmpBH3cOEAABDAIMDAwDBAUGBwgJCgsMCyACQQFNDQwDQCAAIAEQeCEAIAJBfmoiAkEBSw0ACwwMCyACQQNNDQsDQCAAIAEQdyEAIAJBfGoiAkEDSw0ACwwLCyACQQdNDQoDQCAAIAEQNyEAIAJBeGoiAkEHSw0ACwwKCyACQQ9NDQkDQCAAIAEQViEAIAJBcGoiAkEPSw0ACwwJCyACQRJJDQggAUEQaiEDA0AgACABEFYgAxB4IQAgAkFuaiICQRFLDQALDAgLIAJBFEkNByABQRBqIQMDQCAAIAEQViADEHchACACQWxqIgJBE0sNAAsMBwsgAkEWSQ0GIAFBFGohAyABQRBqIQQDQCAAIAEQViAEEHcgAxB4IQAgAkFqaiICQRVLDQALDAYLIAJBGEkNBSABQRBqIQMDQCAAIAEQViADEDchACACQWhqIgJBF0sNAAsMBQsgAkEaSQ0EIAFBGGohAyABQRBqIQQDQCAAIAEQViAEEDcgAxB4IQAgAkFmaiICQRlLDQALDAQLIAJBHEkNAyABQRhqIQMgAUEQaiEEA0AgACABEFYgBBA3IAMQdyEAIAJBZGoiAkEbSw0ACwwDCyACQR5JDQIgAUEcaiEDIAFBGGohBCABQRBqIQUDQCAAIAEQViAFEDcgBBB3IAMQeCEAIAJBYmoiAkEdSw0ACwwCCyACQR9NDQEDQCAAIAEQlAIhACACQWBqIgJBH0sNAAsMAQsgAkUNAQNAIAAgAS0AADoAACAAQQFqIQAgAUEBaiEBIAJBf2oiAg0ACwwBCyACRQ0AA0AgACABLQAAOgAAIABBAWohACABQQFqIQEgAkF/aiICDQALCyAAC7EBAgJ/An4gAEF/ai0AACEDAkACQCABQXhqIgQgAE0NACADrUL/AYNCgYKEiJCgwIABfiEFA0AgAikAACIGIAVRBEAgAkEIaiECIABBCGoiACAESQ0BDAILCyAGp0H/AXEgA0cNAQNAIABBAWohACACLQABIQEgAkEBaiECIAEgA0YNAAsMAQsgACABTw0AA0AgAi0AACADRw0BIAJBAWohAiAAQQFqIgAgAUkNAAsLIAALJgEBf0ECIQQgAygCACABEJUCTwR/IAAgASACIAMQlQRBAAUgBAsLC8zcATgAQYAIC4MGTjZzbmFwcHk0U2lua0UAABh0AAAABAAATjZzbmFwcHk2U291cmNlRQAAAAAYdAAAGAQAAAAAAABsBAAAAQAAAAIAAAADAAAABAAAAAUAAABONnNuYXBweTE1Qnl0ZUFycmF5U291cmNlRQAAjHIAAFAEAAAsBAAAAAAAALQEAAAGAAAABwAAAAgAAAAJAAAATjZzbmFwcHkyMlVuY2hlY2tlZEJ5dGVBcnJheVNpbmtFAAAAjHIAAJAEAAAQBAAAAQAECAEQASACAAUIAhACIAMABggDEAMgBAAHCAQQBCAFAAgIBRAFIAYACQgGEAYgBwAKCAcQByAIAAsICBAIIAkABAkJEAkgCgAFCQoQCiALAAYJCxALIAwABwkMEAwgDQAICQ0QDSAOAAkJDhAOIA8ACgkPEA8gEAALCRAQECARAAQKERARIBIABQoSEBIgEwAGChMQEyAUAAcKFBAUIBUACAoVEBUgFgAJChYQFiAXAAoKFxAXIBgACwoYEBggGQAECxkQGSAaAAULGhAaIBsABgsbEBsgHAAHCxwQHCAdAAgLHRAdIB4ACQseEB4gHwAKCx8QHyAgAAsLIBAgICEABAwhECEgIgAFDCIQIiAjAAYMIxAjICQABwwkECQgJQAIDCUQJSAmAAkMJhAmICcACgwnECcgKAALDCgQKCApAAQNKRApICoABQ0qECogKwAGDSsQKyAsAAcNLBAsIC0ACA0tEC0gLgAJDS4QLiAvAAoNLxAvIDAACw0wEDAgMQAEDjEQMSAyAAUOMhAyIDMABg4zEDMgNAAHDjQQNCA1AAgONRA1IDYACQ42EDYgNwAKDjcQNyA4AAsOOBA4IDkABA85EDkgOgAFDzoQOiA7AAYPOxA7IDwABw88EDwgAQgIDz0QPSABEAkPPhA+IAEYCg8/ED8gASALD0AQQCAAAAAA/wAAAP//AAD///8A/////2RlY29tcHJlc3MAY29tcHJlc3MAZnJlZV9yZXN1bHQAdmkAAHhzAABpaWlpaWlpAEGQDgvUBigHAAAwBwAAMAcAAMxzAADMcwAAzHMAABh0AAC2BwAAQHQAAEgHAAAAAAAAAQAAAIgHAAAAAAAATlN0M19fMjEyYmFzaWNfc3RyaW5nSWNOU18xMWNoYXJfdHJhaXRzSWNFRU5TXzlhbGxvY2F0b3JJY0VFRUUAABh0AACQBwAATlN0M19fMjIxX19iYXNpY19zdHJpbmdfY29tbW9uSUxiMUVFRQBOMTBlbXNjcmlwdGVuM3ZhbEUAAAAAGHQAANQHAABOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0loRUUAaWlpAAAoBwAAMAcAABgIAAAgCAAAJAgAACoIAAAxCAAANggAAGJsb3NjbHoAbHo0AGx6NGhjAHNuYXBweQB6bGliAHpzdGQARXJyb3IuICBudGhyZWFkcyBjYW5ub3QgYmUgbGFyZ2VyIHRoYW4gQkxPU0NfTUFYX1RIUkVBRFMgKCVkKQBFcnJvci4gIG50aHJlYWRzIG11c3QgYmUgYSBwb3NpdGl2ZSBpbnRlZ2VyAEVSUk9SOyByZXR1cm4gY29kZSBmcm9tIHB0aHJlYWRfY3JlYXRlKCkgaXMgJWQKAAlFcnJvciBkZXRhaWw6ICVzCgBCbG9zYyBoYXMgbm90IGJlZW4gY29tcGlsZWQgd2l0aCAnJXMnIABjb21wcmVzc2lvbiBzdXBwb3J0LiAgUGxlYXNlIHVzZSBvbmUgaGF2aW5nIGl0LgBFcnJvciBhbGxvY2F0aW5nIG1lbW9yeSEARVJST1I7IHJldHVybiBjb2RlIGZyb20gcHRocmVhZF9qb2luKCkgaXMgJWQKAElucHV0IGJ1ZmZlciBzaXplIGNhbm5vdCBleGNlZWQgJWQgYnl0ZXMKAE91dHB1dCBidWZmZXIgc2l6ZSBzaG91bGQgYmUgbGFyZ2VyIHRoYW4gJWQgYnl0ZXMKAGBjbGV2ZWxgIHBhcmFtZXRlciBtdXN0IGJlIGJldHdlZW4gMCBhbmQgOSEKAGBzaHVmZmxlYCBwYXJhbWV0ZXIgbXVzdCBiZSBlaXRoZXIgMCwgMSBvciAyIQoAAAAAAQAAgAAAAAABAAAAAQAACgoLDA0ODg4O/wAICBAgICAgQABB9hQLUfC/mpmZmZmZuT+amZmZmZnJPzMzMzMzM9M/mpmZmZmZ2T8zMzMzMzPjP83MzMzMzOw/ZmZmZmZm7j8AAAAAAADwPwAAAAAAAPA/Z2VuZXJpYwBB1BULGQEAAAACAAAAAQAAAAAAAAAEAAAABAAAAAQAQfwVC64B//////z///8BAAAAAgAAAAMAAAAAAAAAAgAAABAAAAAAAAAAAgAAABAAAAAAAAAAAgAAABAAAAAAAAAABAAAABAAAAAAAAAACAAAABAAAAAAAAAAEAAAABAAAAAAAAAAIAAAABAAAAAAAAAAQAAAABAAAAAAAAAAgAAAABAAAAAAAAAAAAEAABAAAAABAAAAYAAAAEAAAAABAAAAAAIAAIAAAAABAAAAAEAAAAAQAEG0FwvxQJYwB3csYQ7uulEJmRnEbQeP9GpwNaVj6aOVZJ4yiNsOpLjceR7p1eCI2dKXK0y2Cb18sX4HLbjnkR2/kGQQtx3yILBqSHG5895BvoR91Noa6+TdbVG11PTHhdODVphsE8Coa2R6+WL97Mllik9cARTZbAZjYz0P+vUNCI3IIG47XhBpTORBYNVycWei0eQDPEfUBEv9hQ3Sa7UKpfqotTVsmLJC1sm720D5vKzjbNgydVzfRc8N1txZPdGrrDDZJjoA3lGAUdfIFmHQv7X0tCEjxLNWmZW6zw+lvbieuAIoCIgFX7LZDMYk6Quxh3xvLxFMaFirHWHBPS1mtpBB3HYGcdsBvCDSmCoQ1e+JhbFxH7W2BqXkv58z1LjooskHeDT5AA+OqAmWGJgO4bsNan8tPW0Il2xkkQFcY+b0UWtrYmFsHNgwZYVOAGLy7ZUGbHulARvB9AiCV8QP9cbZsGVQ6bcS6ri+i3yIufzfHd1iSS3aFfN804xlTNT7WGGyTc5RtTp0ALyj4jC71EGl30rXldg9bcTRpPv01tNq6WlD/NluNEaIZ63QuGDacy0EROUdAzNfTAqqyXwN3TxxBVCqQQInEBALvoYgDMkltWhXs4VvIAnUZrmf5GHODvneXpjJ2SkimNCwtKjXxxc9s1mBDbQuO1y9t61susAgg7jttrO/mgzitgOa0rF0OUfV6q930p0VJtsEgxbccxILY+OEO2SUPmptDahaanoLzw7knf8JkyeuAAqxngd9RJMP8NKjCIdo8gEe/sIGaV1XYvfLZ2WAcTZsGecGa252G9T+4CvTiVp62hDMSt1nb9+5+fnvvo5DvrcX1Y6wYOij1tZ+k9GhxMLYOFLy30/xZ7vRZ1e8pt0GtT9LNrJI2isN2EwbCq/2SgM2YHoEQcPvYN9V32eo745uMXm+aUaMs2HLGoNmvKDSbyU24mhSlXcMzANHC7u5FgIiLyYFVb47usUoC72yklq0KwRqs1yn/9fCMc/QtYue2Swdrt5bsMJkmybyY+yco2p1CpNtAqkGCZw/Ng7rhWcHchNXAAWCSr+VFHq44q4rsXs4G7YMm47Skg2+1eW379x8Id/bC9TS04ZC4tTx+LPdaG6D2h/NFr6BWya59uF3sG93R7cY5loIiHBqD//KOwZmXAsBEf+eZY9prmL40/9rYUXPbBZ44gqg7tIN11SDBE7CswM5YSZnp/cWYNBNR2lJ23duPkpq0a7cWtbZZgvfQPA72DdTrrypxZ673n/Pskfp/7UwHPK9vYrCusowk7NTpqO0JAU20LqTBtfNKVfeVL9n2SMuemazuEphxAIbaF2UK28qN74LtKGODMMb3wVaje8CLQAAAABBMRsZgmI2MsNTLSsExWxkRfR3fYanWlbHlkFPCIrZyEm7wtGK6O/6y9n04wxPtaxNfq61ji2Dns8cmIdREsJKECPZU9Nw9HiSQe9hVdeuLhTmtTfXtZgcloSDBVmYG4IYqQCb2/otsJrLNqldXXfmHGxs/98/QdSeDlrNoiSEleMVn4wgRrKnYXepvqbh6PHn0PPoJIPew2Wyxdqqrl1d659GRCjMa29p/XB2rmsxOe9aKiAsCQcLbTgcEvM2Rt+yB13GcVRw7TBla/T38yq7tsIxonWRHIk0oAeQ+7yfF7qNhA553qklOO+yPP9583O+SOhqfRvFQTwq3lgFT3nwRH5i6YctT8LGHFTbAYoVlEC7Do2D6COmwtk4vw3FoDhM9Lshj6eWCs6WjRMJAMxcSDHXRYti+m7KU+F3VF27uhVsoKPWP42Ilw6WkVCY194RqczH0vrh7JPL+vVc12JyHeZ5a961VECfhE9ZWBIOFhkjFQ/acDgkm0EjPadr/WXmWuZ8JQnLV2Q40E6jrpEB4p+KGCHMpzNg/bwqr+Ekre7QP7QtgxKfbLIJhqskSMnqFVPQKUZ++2h3ZeL2eT8vt0gkNnQbCR01KhIE8rxTS7ONSFJw3mV5Me9+YP7z5ue/wv3+fJHQ1T2gy8z6NoqDuweRmnhUvLE5ZaeoS5iDOwqpmCLJ+rUJiMuuEE9d718ObPRGzT/ZbYwOwnRDElrzAiNB6sFwbMGAQXfYR9c2lwbmLY7FtQClhIQbvBqKQXFbu1pomOh3Q9nZbFoeTy0VX342DJwtGyfdHAA+EgCYuVMxg6CQYq6L0VO1khbF9N1X9O/ElKfC79WW2fbpvAeuqI0ct2veMZwq7yqF7XlryqxIcNNvG134LipG4eE23magB8V/Y1ToVCJl803l87ICpMKpG2eRhDAmoJ8puK7F5Pmf3v06zPPWe/3oz7xrqYD9WrKZPgmfsn84hKuwJBws8RUHNTJGKh5zdzEHtOFwSPXQa1E2g0Z6d7JdY07X+ssP5uHSzLXM+Y2E1+BKEpavCyONtshwoJ2JQbuERl0jAwdsOBrEPxUxhQ4OKEKYT2cDqVR+wPp5VYHLYkwfxTiBXvQjmJ2nDrPclhWqGwBU5VoxT/yZYmLX2FN5zhdP4UlWfvpQlS3Xe9QczGITio0tUruWNJHoux/Q2aAG7PN+Xq3CZUdukUhsL6BTdeg2EjqpBwkjalQkCCtlPxHkeaeWpUi8j2YbkaQnKoq94LzL8qGN0Oti3v3AI+/m2b3hvBT80KcNP4OKJn6ykT+5JNBw+BXLaTtG5kJ6d/1btWtl3PRafsU3CVPudjhI97GuCbjwnxKhM8w/inL9JJMAAAAAN2rCAW7UhANZvkYC3KgJB+vCywayfI0EhRZPBbhREw6PO9EP1oWXDeHvVQxk+RoJU5PYCAotngo9R1wLcKMmHEfJ5B0ed6IfKR1gHqwLLxubYe0awt+rGPW1aRnI8jUS/5j3E6YmsRGRTHMQFFo8FSMw/hR6jrgWTeR6F+BGTTjXLI85jpLJO7n4Czo87kQ/C4SGPlI6wDxlUAI9WBdeNm99nDc2w9o1AakYNIS/VzGz1ZUw6mvTMt0BETOQ5Wskp4+pJf4x7yfJWy0mTE1iI3snoCIimeYgFfMkISi0eCof3rorRmD8KXEKPij0HHEtw3azLJrI9S6tojcvwI2acPfnWHGuWR5zmTPcchwlk3crT1F2cvEXdEWb1XV43Il+T7ZLfxYIDX0hYs98pHSAeZMeQnjKoAR6/crGe7AuvGyHRH5t3vo4b+mQ+m5shrVrW+x3agJSMWg1OPNpCH+vYj8VbWNmqythUcHpYNTXpmXjvWRkugMiZo1p4Gcgy9dIF6EVSU4fU0t5dZFK/GPeT8sJHE6St1pMpd2YTZiaxEav8AZH9k5ARcEkgkREMs1Bc1gPQCrmSUIdjItDUGjxVGcCM1U+vHVXCda3VozA+FO7qjpS4hR8UNV+vlHoOeJa31MgW4btZlmxh6RYNJHrXQP7KVxaRW9ebS+tX4AbNeG3cffg7s+x4tmlc+Ncszzma9n+5zJnuOUFDXrkOEom7w8g5O5WnqLsYfRg7eTiL+jTiO3pijar671caerwuBP9x9LR/J5sl/6pBlX/LBAa+ht62PtCxJ75da5c+EjpAPN/g8LyJj2E8BFXRvGUQQn0oyvL9fqVjffN/0/2YF142Vc3utgOifzaOeM+27z1cd6Ln7Pf0iH13eVLN9zYDGvX72ap1rbY79SBsi3VBKRi0DPOoNFqcObTXRok0hD+XsUnlJzEfiraxklAGMfMVlfC+zyVw6KC08GV6BHAqK9Ny5/Fj8rGe8nI8RELyXQHRMxDbYbNGtPAzy25As5Alq+Rd/xtkC5CK5IZKOmTnD6mlqtUZJfy6iKVxYDglPjHvJ/PrX6elhM4nKF5+p0kb7WYEwV3mUq7MZt90fOaMDWJjQdfS4xe4Q2OaYvPj+ydgIrb90KLgkkEibUjxoiIZJqDvw5YguawHoDR2tyBVMyThGOmUYU6GBeHDXLVhqDQ4qmXuiCozgRmqvlupKt8eOuuSxIprxKsb60lxq2sGIHxpy/rM6Z2VXWkQT+3pcQp+KDzQzqhqv18o52XvqLQc8S15xkGtL6nQLaJzYK3DNvNsjuxD7NiD0mxVWWLsGgi17tfSBW6BvZTuDGckbm0it68g+AcvdpeWr/tNJi+AAAAAGVnvLiLyAmq7q+1EleXYo8y8N433F9rJbk4153vKLTFik8IfWTgvW8BhwHXuL/WSt3YavIzd9/gVhBjWJ9XGVD6MKXoFJ8Q+nH4rELIwHvfrafHZ0MIcnUmb87NcH+tlRUYES37t6Q/ntAYhyfozxpCj3OirCDGsMlHegg+rzKgW8iOGLVnOwrQAIeyaThQLwxf7Jfi8FmFh5flPdGHhmW04DrdWk+Pzz8oM3eGEOTq43dYUg3Y7UBov1H4ofgr8MSfl0gqMCJaT1ee4vZvSX+TCPXHfadA1RjA/G1O0J81K7cjjcUYlp+gfyonGUf9unwgQQKSj/QQ9+hIqD1YFJtYP6gjtpAdMdP3oYlqz3YUD6jKrOEHf76EYMMG0nCgXrcXHOZZuKn0PN8VTIXnwtHggH5pDi/Le2tId8OiDw3Lx2ixcynHBGFMoLjZ9ZhvRJD/0/x+UGbuGzfaVk0nuQ4oQAW2xu+wpKOIDBwasNuBf9dnOZF40iv0H26TA/cmO2aQmoOIPy+R7ViTKVRgRLQxB/gM36hNHrrP8abs35L+ibguRmcXm1QCcCfsu0jwcd4vTMkwgPnbVedFY5ygP2v5x4PTF2g2wXIPinnLN13krlDhXED/VE4lmOj2c4iLrhbvNxb4QIIEnSc+vCQf6SFBeFWZr9fgi8qwXDM7tlntXtHlVbB+UEfVGez/bCE7YglGh9rn6TLIgo6OcNSe7Six+VGQX1bkgjoxWDqDCY+n5m4zHwjBhg1tpjq1pOFAvcGG/AUvKUkXSk71r/N2IjKWEZ6KeL4rmB3ZlyBLyfR4Lq5IwMAB/dKlZkFqHF6W93k5Kk+Xlp9d8vEj5QUZa01gftf1jtFi5+u23l9SjgnCN+m1etlGAGi8IbzQ6jHfiI9WYzBh+dYiBJ5qmr2mvQfYwQG/Nm60rVMJCBWaTnId/ynOpRGGe7d04ccPzdkQkqi+rCpGERk4I3algHVmxtgQAXpg/q7PcpvJc8oi8aRXR5YY76k5rf3MXhFFBu5NdmOJ8c6NJkTc6EH4ZFF5L/k0HpNB2rEmU7/WmuvpxvmzjKFFC2IO8BkHaUyhvlGbPNs2J4Q1mZKWUP4uLpm5VCb83uieEnFdjHcW4TTOLjapq0mKEUXmPwMggYO7dpHg4xP2XFv9WelJmD5V8SEGgmxEYT7Uqs6Lxs+pN344QX/WXSbDbrOJdnzW7srEb9YdWQqxoeHkHhTzgXmoS9dpyxOyDnerXKHCuTnGfgGA/qmc5ZkVJAs2oDZuURyOpxZmhsJx2j4s3m8sSbnTlPCBBAmV5rixe0kNox4usRtIPtJDLVlu+8P22+mmkWdRH6mwzHrODHSUYblm8QYF3gAAAAB3BzCW7g5hLJkJUboHbcQZcGr0j+ljpTWeZJWjDtuIMnncuKTg1ekel9LZiAm2TCt+sXy957gtB5C/HZEdtxBkarAg8vO5cUiEvkHeGtrUfW3d5Ov01LVRg9OFxxNsmFZka6jA/WL5eoplyewUAVxPYwZs2foPPWONCA31O24gyExpEF7VYEHkomdxcjwD5NFLBNRH0g2F/aUKtWs1taj6QrKYbNu7ydasvPlAMths40XfXHXc1g3Pq9E9WSbZMKxR3gA6yNdRgL/QYRYhtPS1VrPEI8+6lZm4vaUPKAK4nl8FiAjGDNmysQvpJC9vfIdYaEwRwWEdq7ZmLT123EGQAdtxBpjSILzv1RAqcbGFiQa2tR+fv+Sl6LjUM3gHyaIPAPk0lgmojuEOmBh/ag27CG09LZFkbJfmY1wBa2tR9BxsYWKFZTDY8mIATmwGle0bAaV7ggj0wfUPxFdlsNnGErfpUIu+uOr8uYh8Yt0d3xXaLUmM03zz+9RMZU2yYVg6tVHOo7wAdNS7MOJK36VBPdiV16TRxG3T1vT7Q2npajRu2fytZ4hG2mC40EQELXMzAx3lqgpMX90NfMlQBXE8JwJBqr4LEBDJDCCGV2i1JSBvhbO5ZtQJzmHkn17e+Q4p2cmYsNCYIsfXqLRZsz0XLrQNgbe9XDvAumyt7biDIJq/s7YDtuIMdLHSmurVRzmd0nevBNsmFXPcFoPjYwsSlGQ7hA1taj56alqo5A7PC5MJ/50KAK4nfQeesfAPk0SHCKPSHgHyaGkGwv73YlddgGVnyxlsNnFuawbn/tQbdonTK+AQ2npaZ91KzPm532+Ovu/5F7e+Q2CwjtXW1qPoodGTfjjYwsRP3/JS0btn8aa8V2c/tQbdSLI2S9gNK9qvChtMNgNK9kEEemDfYO/DqGffVTFuju9Gab55y2GzjLxmgxolb9KgUmjiNswMd5W7C0cDIgIWuVUFJi/Fuju+sr0LKCu0WpJcs2oEwtf/p7XQzzEs2Z6LW96uHZtkwrDsY/ImdWqjnAJtkwqcCQap6w42P3IHZ4UFAFcTlb9KguK4ehR7sSuuDLYbOJLSjpvl1b4NfNzvtwvb3yGG09LU8dTiQmjds/gf2oNugb4Wzfa5JltvsHfhGLdHd4gIWub/D2pwZgY7yhEBC1yPZZ7/+GKuaWFr/9MWbM9FoArieNcN0u5OBINUOQOzwqdnJmHQYBb3SWlHTT5ud9uu0WpK2dZa3EDfC2Y32DvwqbyuU967nsVHss9/MLX/6b298hzKusKKU7OTMCS0o6a60DYFzdcGk1TeVykj2We/s2Z6LsRhSrhdaBsCKm8rlLQLvjfDDI6hWgXfGy0C740AAAAAGRsxQTI2YoIrLVPDZGzFBH139EVWWqeGT0GWx8jZigjRwrtJ+u/oiuP02custU8Mta5+TZ6DLY6HmBzPSsISUVPZIxB49HDTYe9Bki6u11U3teYUHJi11wWDhJaCG5hZmwCpGLAt+tupNsua5nddXf9sbBzUQT/fzVoOnpWEJKKMnxXjp7JGIL6pd2Hx6OGm6PPQ58PegyTaxbJlXV2uqkRGn+tva8wodnD9aTkxa64gKlrvCwcJLBIcOG3fRjbzxl0Hsu1wVHH0a2Uwuyrz96IxwraJHJF1kAegNBefvPsOhI26JaneeTyy7zhz83n/auhIvkHFG31Y3io88HlPBelifkTCTy2H21QcxpQVigGNDrtApiPog7842cI4oMUNIbv0TAqWp48TjZbOXMwACUXXMUhu+mKLd+FTyrq7XVSjoGwViI0/1pGWDpfe15hQx8ypEezh+tL1+suTcmLXXGt55h1AVLXeWU+EnxYOElgPFSMZJDhw2j0jQZtl/WunfOZa5lfLCSVO0DhkAZGuoxiKn+Izp8whKrz9YK0k4a+0P9DunxKDLYYJsmzJSCSr0FMV6vt+RiniZXdoLz959jYkSLcdCRt0BBIqNUtTvPJSSI2zeWXecGB+7zHn5vP+/v3Cv9XQkXzMy6A9g4o2+pqRB7uxvFR4qKdlOTuDmEsimKkKCbX6yRCuy4hf711PRvRsDm3ZP810wg6M81oSQ+pBIwLBbHDB2HdBgJc210eOLeYGpQC1xbwbhIRxQYoaaFq7W0N36JhabNnZFS1PHgw2fl8nGy2cPgAc3bmYABKggzFTi65ikJK1U9Hd9MUWxO/0V+/Cp5T22ZbVrge86bccjaicMd5rhSrvKspree3TcEis+F0bb+FGKi5m3jbhf8UHoFToVGNN82UiArLz5RupwqQwhJFnKZ+gJuTFrrj93p/51vPMOs/o/XuAqWu8mbJa/bKfCT6rhDh/LBwksDUHFfEeKkYyBzF3c0hw4bRRa9D1ekaDNmNdsnfL+tdO0uHmD/nMtczg14SNr5YSSraNIwudoHDIhLtBiQMjXUYaOGwHMRU/xCgODoVnT5hCflSpA1V5+sBMYsuBgTjFH5gj9F6zDqedqhWW3OVUABv8TzFa12Jimc55U9hJ4U8XUPp+VnvXLZVizBzULY2KEzSWu1Ifu+iRBqDZ0F5+8+xHZcKtbEiRbnVToC86EjboIwkHqQgkVGoRP2Urlqd55I+8SKWkkRtmvYoqJ/LLvODr0I2hwP3eYtnm7yMUvOG9DafQ/CaKgz8/kbJ+cNAkuWnLFfhC5kY7W/13etxla7XFflr07lMJN/dIOHa4Ca6xoRKf8Io/zDOTJP1yAAAAAAHCajcDhNRuAka+WQcJqNwGy8LrBI18sgVPFoUOE1G4D9E7jw2XhdYMVe/hCRr5ZAjYk1MKni0KC1xHPRwmo3Ad5MlHH6J3Hh5gHSkbLwusGu1hmxir38IZabX1EjXyyBP3mP8RsSamEHNMkRU8WhQU/jAjFriOehd65E04TUbgOY8s1zvJko46C/i5P0TuPD6GhAs8wDpSPQJQZTZeF1g3nH1vNdrDNjQYqQExV7+EMJXVszLTa+ozEQHdJGvlkCWpj6cn7zH+Ji1bySNiTUwioCd7IOaZIiEk8xUqeLQoK7reHyn8YEYoPgpxLXEc9CyzdsMu9ciaLzeirXCajcBxWOf3cx5ZrnLcM5l3kyUcdlFPK3QX8XJ11ZtFfonceH9Ltk99DQgWfM9iIXmAdKR4Qh6TegSgynvGyv1svC6wbX5Eh284+t5u+pDpa7WGbGp37FtoMVICafM4NWKvfwhjbRU/YSurZmDpwVFlptfUZGS942YiA7pn4GmNSNfLIEkVoRdLUx9OSpF1eU/eY/xOHAnLTFq3kk2Y3aVGxJqYRwbwr0VATvZEgiTBQc0yREAPWHNCSeYqQ4uMHVTxaFBVMwJnV3W8Pla31glT+MCMUjqqu1B8FOJRvn7VWuI56FsgU99ZZu2GWKSHsV3rkTRcKfsDXm9FWl+tL23hNRuA4Pdxt+Kxz+7jc6XZ5jyzXOf+2WvluGcy5HoNBe8mSjju5CAP7KKeVu1g9GHoL+Lk6e2I0+urNorqaVy9/RO48PzR0sf+l2ye/1UGqfoaECz72Hob+Z7EQvhcrnXzAOlI8sKDf/CEPSbxRlcR9AlBlPXLK6P3jZX69k//zdl4XWDYujdX2vyJDts+4znecfW837Ofi931IdLcN0vl12sM2NapZu/U79i21S2ygdBipATRoM4z0+ZwatIkGl3FXv4QxJyUJ8baKn7HGEBJwldWzMOVPPvB04KiwBHolctNr6jKj8WfyMl7xskLEfHMRAd0zYZtQ8/A0xrOArktka+WQJBt/HeSK0Iuk+koGZamPpyXZFSrlSLq8pTggMWfvMf4nn6tz5w4E5ad+nmhmLVvJJl3BRObMbtKmvPRfY2JNTCMS18Hjg3hXo/Pi2mKgJ3si0L324kESYKIxiO1g5pkiIJYDr+AHrDmgdza0YSTzFSFUaZjhxcYOobVcg2p4tCgqCC6l6pmBM6rpG75rut4fK8pEkutb6wSrK3GJafxgRimM+svpHVVdqW3P0Gg+CnEoTpD86N8/aqivpedtcRz0LQGGee2QKe+t4LNibLN2wyzD7E7sUkPYrCLZVW71yJouhVIX7hT9ga5kZwxvN6KtL0c4IO/Wl7avpg07QAAAAC4vGdlqgnIixK1r+6PYpdXN97wMiVrX9yd1zi5xbQo730IT4pvveBk1wGHAUrWv7jyatjd4N93M1hjEFZQGVef6KUw+voQnxRCrPhx33vAyGfHp611cghDzc5vJpWtf3AtERgVP6S3+4cY0J4az+gnonOPQrDGIKwIekfJoDKvPhiOyFsKO2e1socA0C9QOGmX7F8MhVnw4j3ll4dlhofR3TrgtM+PT1p3Myg/6uQQhlJYd+NA7dgN+FG/aPAr+KFIl5/EWiIwKuKeV09/SW/2x/UIk9VAp31t/MAYNZ/QTo0jtyuflhjFJyp/oLr9RxkCQSB8EPSPkqhI6PebFFg9I6g/WDEdkLaJoffTFHbPaqzKqA++fwfhBsNghF6gcNLmHBe39Km4WUwV3zzRwueFaX6A4HvLLw7Dd0hryw0PonOxaMdhBMcp2bigTERvmPX80/+Q7mZQflbaNxsOuSdNtgVAKKSw78YcDIijgduwGjln138r0niRk24f9Dsm9wODmpBmkS8/iCmTWO20RGBUDPgHMR5NqN+m8c+6/pLf7EYuuIlUmxdn7CdwAnHwSLvJTC/e2/mAMGNF51VrP6Cc04PH+cE2aBd5ig9y5F03y1zhUK5OVP9A9uiYJa6LiHMWN+8WBIJA+Lw+J50h6R8kmVV4QYvg168zXLDK7Vm2O1Xl0V5HUH6w/+wZ1WI7IWzah0YJyDLp53COjoIo7Z7UkFH5sYLkVl86WDE6p48Jgx8zbuYNhsEItTqmbb1A4aQF/IbBF0kpL6/1TkoyInbzip4Rlpgrvnggl9kdePTJS8BIri7S/QHAakFmpfeWXhxPKjl5XZ+Wl+Uj8fJNaxkF9dd+YOdi0Y5f3rbrwgmOUnq16TdoAEbZ0LwhvIjfMeowY1aPItb5YZpqngQHvaa9vwHB2K20bjYVCAlTHXJOmqXOKf+3e4YRD8fhdJIQ2c0qrL6oOBkRRoCldiPYxmZ1YHoBEHLPrv7Kc8mbV6TxIu8Ylkf9rTmpRRFezHZN7gbO8Ylj3EQmjWT4Qej5L3lRQZMeNFMmsdrrmta/s/nG6QtFoYwZ8A5ioUxpBzybUb6EJzbblpKZNS4u/lAmVLmZnuje/IxdcRI04RZ3qTYuzhGKSasDP+ZFu4OBIOPgkXZbXPYTSelZ/fFVPphsggYh1D5hRMaLzqp+N6nP1n9BOG7DJl18domzxMru1lkd1m/hobEK8xQe5EuoeYETy2nXq3cOsrnCoVwBfsY5nKn+gCQVmeU2oDYLjhxRboZmFqc+2nHCLG/eLJTTuUkJBIHwsbjmlaMNSXsbsS4eQ9I+SPtuWS3p2/bDUWeRpsywqR90DM56ZrlhlN4FBvEAAAAAAAAAAB0AAAAEAAQACAAEAB4AAAAEAAUAEAAIAB4AAAAEAAYAIAAgAB4AAAAEAAQAEAAQAB8AAAAIABAAIAAgAB8AAAAIABAAgACAAB8AAAAIACAAgAAAAR8AAAAgAIAAAgEABB8AAAAgAAIBAgEAEB8AQfDYAAsJAgAAAAMAAAAHAEGC2QALdQUAEAAFAAgABQAYAAUABAAFABQABQAMAAUAHAAFAAIABQASAAUACgAFABoABQAGAAUAFgAFAA4ABQAeAAUAAQAFABEABQAJAAUAGQAFAAUABQAVAAUADQAFAB0ABQADAAUAEwAFAAsABQAbAAUABwAFABcABQBBkNoAC2UBAAAAAQAAAAIAAAACAAAAAwAAAAMAAAAEAAAABAAAAAUAAAAFAAAABgAAAAYAAAAHAAAABwAAAAgAAAAIAAAACQAAAAkAAAAKAAAACgAAAAsAAAALAAAADAAAAAwAAAANAAAADQBBgNsAC/8IDAAIAIwACABMAAgAzAAIACwACACsAAgAbAAIAOwACAAcAAgAnAAIAFwACADcAAgAPAAIALwACAB8AAgA/AAIAAIACACCAAgAQgAIAMIACAAiAAgAogAIAGIACADiAAgAEgAIAJIACABSAAgA0gAIADIACACyAAgAcgAIAPIACAAKAAgAigAIAEoACADKAAgAKgAIAKoACABqAAgA6gAIABoACACaAAgAWgAIANoACAA6AAgAugAIAHoACAD6AAgABgAIAIYACABGAAgAxgAIACYACACmAAgAZgAIAOYACAAWAAgAlgAIAFYACADWAAgANgAIALYACAB2AAgA9gAIAA4ACACOAAgATgAIAM4ACAAuAAgArgAIAG4ACADuAAgAHgAIAJ4ACABeAAgA3gAIAD4ACAC+AAgAfgAIAP4ACAABAAgAgQAIAEEACADBAAgAIQAIAKEACABhAAgA4QAIABEACACRAAgAUQAIANEACAAxAAgAsQAIAHEACADxAAgACQAIAIkACABJAAgAyQAIACkACACpAAgAaQAIAOkACAAZAAgAmQAIAFkACADZAAgAOQAIALkACAB5AAgA+QAIAAUACACFAAgARQAIAMUACAAlAAgApQAIAGUACADlAAgAFQAIAJUACABVAAgA1QAIADUACAC1AAgAdQAIAPUACAANAAgAjQAIAE0ACADNAAgALQAIAK0ACABtAAgA7QAIAB0ACACdAAgAXQAIAN0ACAA9AAgAvQAIAH0ACAD9AAgAEwAJABMBCQCTAAkAkwEJAFMACQBTAQkA0wAJANMBCQAzAAkAMwEJALMACQCzAQkAcwAJAHMBCQDzAAkA8wEJAAsACQALAQkAiwAJAIsBCQBLAAkASwEJAMsACQDLAQkAKwAJACsBCQCrAAkAqwEJAGsACQBrAQkA6wAJAOsBCQAbAAkAGwEJAJsACQCbAQkAWwAJAFsBCQDbAAkA2wEJADsACQA7AQkAuwAJALsBCQB7AAkAewEJAPsACQD7AQkABwAJAAcBCQCHAAkAhwEJAEcACQBHAQkAxwAJAMcBCQAnAAkAJwEJAKcACQCnAQkAZwAJAGcBCQDnAAkA5wEJABcACQAXAQkAlwAJAJcBCQBXAAkAVwEJANcACQDXAQkANwAJADcBCQC3AAkAtwEJAHcACQB3AQkA9wAJAPcBCQAPAAkADwEJAI8ACQCPAQkATwAJAE8BCQDPAAkAzwEJAC8ACQAvAQkArwAJAK8BCQBvAAkAbwEJAO8ACQDvAQkAHwAJAB8BCQCfAAkAnwEJAF8ACQBfAQkA3wAJAN8BCQA/AAkAPwEJAL8ACQC/AQkAfwAJAH8BCQD/AAkA/wEJAAAABwBAAAcAIAAHAGAABwAQAAcAUAAHADAABwBwAAcACAAHAEgABwAoAAcAaAAHABgABwBYAAcAOAAHAHgABwAEAAcARAAHACQABwBkAAcAFAAHAFQABwA0AAcAdAAHAAMACACDAAgAQwAIAMMACAAjAAgAowAIAGMACADjAAgAQaDkAAtNAQAAAAEAAAABAAAAAQAAAAIAAAACAAAAAgAAAAIAAAADAAAAAwAAAAMAAAADAAAABAAAAAQAAAAEAAAABAAAAAUAAAAFAAAABQAAAAUAQYDlAAsTEBESAAgHCQYKBQsEDAMNAg4BDwBBoeUAC+wCAQIDBAUGBwgICQkKCgsLDAwMDA0NDQ0ODg4ODw8PDxAQEBAQEBAQERERERERERESEhISEhISEhMTExMTExMTFBQUFBQUFBQUFBQUFBQUFBUVFRUVFRUVFRUVFRUVFRUWFhYWFhYWFhYWFhYWFhYWFxcXFxcXFxcXFxcXFxcXFxgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxscAAAAAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACgAAAAwAAAAOAAAAEAAAABQAAAAYAAAAHAAAACAAAAAoAAAAMAAAADgAAABAAAAAUAAAAGAAAABwAAAAgAAAAKAAAADAAAAA4ABBoegAC/UEAQIDBAQFBQYGBgYHBwcHCAgICAgICAgJCQkJCQkJCQoKCgoKCgoKCgoKCgoKCgoLCwsLCwsLCwsLCwsLCwsLDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwNDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PAAAQERISExMUFBQUFRUVFRYWFhYWFhYWFxcXFxcXFxcYGBgYGBgYGBgYGBgYGBgYGRkZGRkZGRkZGRkZGRkZGRoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxsbGxscHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHQAAAAABAAAAAgAAAAMAAAAEAAAABgAAAAgAAAAMAAAAEAAAABgAAAAgAAAAMAAAAEAAAABgAAAAgAAAAMAAAAAAAQAAgAEAAAACAAAAAwAAAAQAAAAGAAAACAAAAAwAAAAQAAAAGAAAACAAAAAwAAAAQAAAAGAAQaDtAAvEAwEAAgADAAQABQAHAAkADQARABkAIQAxAEEAYQCBAMEAAQGBAQECAQMBBAEGAQgBDAEQARgBIAEwAUABYAAAAAADAAQABQAGAAcACAAJAAoACwANAA8AEQATABcAGwAfACMAKwAzADsAQwBTAGMAcwCDAKMAwwDjAAIBAAAAAAAAEAAQABAAEAARABEAEgASABMAEwAUABQAFQAVABYAFgAXABcAGAAYABkAGQAaABoAGwAbABwAHAAdAB0AQABAABAAEAAQABAAEAAQABAAEAARABEAEQARABIAEgASABIAEwATABMAEwAUABQAFAAUABUAFQAVABUAEABIAE4AaW5jb3JyZWN0IGhlYWRlciBjaGVjawB1bmtub3duIGNvbXByZXNzaW9uIG1ldGhvZABpbnZhbGlkIHdpbmRvdyBzaXplAHVua25vd24gaGVhZGVyIGZsYWdzIHNldABoZWFkZXIgY3JjIG1pc21hdGNoAGludmFsaWQgYmxvY2sgdHlwZQBpbnZhbGlkIHN0b3JlZCBibG9jayBsZW5ndGhzAHRvbyBtYW55IGxlbmd0aCBvciBkaXN0YW5jZSBzeW1ib2xzAEHw8AAL4xMQABEAEgAAAAgABwAJAAYACgAFAAsABAAMAAMADQACAA4AAQAPAGludmFsaWQgY29kZSBsZW5ndGhzIHNldABpbnZhbGlkIGJpdCBsZW5ndGggcmVwZWF0AGludmFsaWQgY29kZSAtLSBtaXNzaW5nIGVuZC1vZi1ibG9jawBpbnZhbGlkIGxpdGVyYWwvbGVuZ3RocyBzZXQAaW52YWxpZCBkaXN0YW5jZXMgc2V0AGludmFsaWQgbGl0ZXJhbC9sZW5ndGggY29kZQBpbnZhbGlkIGRpc3RhbmNlIGNvZGUAaW52YWxpZCBkaXN0YW5jZSB0b28gZmFyIGJhY2sAaW5jb3JyZWN0IGRhdGEgY2hlY2sAaW5jb3JyZWN0IGxlbmd0aCBjaGVjawAAAAAAYAcAAAAIUAAACBAAFAhzABIHHwAACHAAAAgwAAAJwAAQBwoAAAhgAAAIIAAACaAAAAgAAAAIgAAACEAAAAngABAHBgAACFgAAAgYAAAJkAATBzsAAAh4AAAIOAAACdAAEQcRAAAIaAAACCgAAAmwAAAICAAACIgAAAhIAAAJ8AAQBwQAAAhUAAAIFAAVCOMAEwcrAAAIdAAACDQAAAnIABEHDQAACGQAAAgkAAAJqAAACAQAAAiEAAAIRAAACegAEAcIAAAIXAAACBwAAAmYABQHUwAACHwAAAg8AAAJ2AASBxcAAAhsAAAILAAACbgAAAgMAAAIjAAACEwAAAn4ABAHAwAACFIAAAgSABUIowATByMAAAhyAAAIMgAACcQAEQcLAAAIYgAACCIAAAmkAAAIAgAACIIAAAhCAAAJ5AAQBwcAAAhaAAAIGgAACZQAFAdDAAAIegAACDoAAAnUABIHEwAACGoAAAgqAAAJtAAACAoAAAiKAAAISgAACfQAEAcFAAAIVgAACBYAQAgAABMHMwAACHYAAAg2AAAJzAARBw8AAAhmAAAIJgAACawAAAgGAAAIhgAACEYAAAnsABAHCQAACF4AAAgeAAAJnAAUB2MAAAh+AAAIPgAACdwAEgcbAAAIbgAACC4AAAm8AAAIDgAACI4AAAhOAAAJ/ABgBwAAAAhRAAAIEQAVCIMAEgcfAAAIcQAACDEAAAnCABAHCgAACGEAAAghAAAJogAACAEAAAiBAAAIQQAACeIAEAcGAAAIWQAACBkAAAmSABMHOwAACHkAAAg5AAAJ0gARBxEAAAhpAAAIKQAACbIAAAgJAAAIiQAACEkAAAnyABAHBAAACFUAAAgVABAIAgETBysAAAh1AAAINQAACcoAEQcNAAAIZQAACCUAAAmqAAAIBQAACIUAAAhFAAAJ6gAQBwgAAAhdAAAIHQAACZoAFAdTAAAIfQAACD0AAAnaABIHFwAACG0AAAgtAAAJugAACA0AAAiNAAAITQAACfoAEAcDAAAIUwAACBMAFQjDABMHIwAACHMAAAgzAAAJxgARBwsAAAhjAAAIIwAACaYAAAgDAAAIgwAACEMAAAnmABAHBwAACFsAAAgbAAAJlgAUB0MAAAh7AAAIOwAACdYAEgcTAAAIawAACCsAAAm2AAAICwAACIsAAAhLAAAJ9gAQBwUAAAhXAAAIFwBACAAAEwczAAAIdwAACDcAAAnOABEHDwAACGcAAAgnAAAJrgAACAcAAAiHAAAIRwAACe4AEAcJAAAIXwAACB8AAAmeABQHYwAACH8AAAg/AAAJ3gASBxsAAAhvAAAILwAACb4AAAgPAAAIjwAACE8AAAn+AGAHAAAACFAAAAgQABQIcwASBx8AAAhwAAAIMAAACcEAEAcKAAAIYAAACCAAAAmhAAAIAAAACIAAAAhAAAAJ4QAQBwYAAAhYAAAIGAAACZEAEwc7AAAIeAAACDgAAAnRABEHEQAACGgAAAgoAAAJsQAACAgAAAiIAAAISAAACfEAEAcEAAAIVAAACBQAFQjjABMHKwAACHQAAAg0AAAJyQARBw0AAAhkAAAIJAAACakAAAgEAAAIhAAACEQAAAnpABAHCAAACFwAAAgcAAAJmQAUB1MAAAh8AAAIPAAACdkAEgcXAAAIbAAACCwAAAm5AAAIDAAACIwAAAhMAAAJ+QAQBwMAAAhSAAAIEgAVCKMAEwcjAAAIcgAACDIAAAnFABEHCwAACGIAAAgiAAAJpQAACAIAAAiCAAAIQgAACeUAEAcHAAAIWgAACBoAAAmVABQHQwAACHoAAAg6AAAJ1QASBxMAAAhqAAAIKgAACbUAAAgKAAAIigAACEoAAAn1ABAHBQAACFYAAAgWAEAIAAATBzMAAAh2AAAINgAACc0AEQcPAAAIZgAACCYAAAmtAAAIBgAACIYAAAhGAAAJ7QAQBwkAAAheAAAIHgAACZ0AFAdjAAAIfgAACD4AAAndABIHGwAACG4AAAguAAAJvQAACA4AAAiOAAAITgAACf0AYAcAAAAIUQAACBEAFQiDABIHHwAACHEAAAgxAAAJwwAQBwoAAAhhAAAIIQAACaMAAAgBAAAIgQAACEEAAAnjABAHBgAACFkAAAgZAAAJkwATBzsAAAh5AAAIOQAACdMAEQcRAAAIaQAACCkAAAmzAAAICQAACIkAAAhJAAAJ8wAQBwQAAAhVAAAIFQAQCAIBEwcrAAAIdQAACDUAAAnLABEHDQAACGUAAAglAAAJqwAACAUAAAiFAAAIRQAACesAEAcIAAAIXQAACB0AAAmbABQHUwAACH0AAAg9AAAJ2wASBxcAAAhtAAAILQAACbsAAAgNAAAIjQAACE0AAAn7ABAHAwAACFMAAAgTABUIwwATByMAAAhzAAAIMwAACccAEQcLAAAIYwAACCMAAAmnAAAIAwAACIMAAAhDAAAJ5wAQBwcAAAhbAAAIGwAACZcAFAdDAAAIewAACDsAAAnXABIHEwAACGsAAAgrAAAJtwAACAsAAAiLAAAISwAACfcAEAcFAAAIVwAACBcAQAgAABMHMwAACHcAAAg3AAAJzwARBw8AAAhnAAAIJwAACa8AAAgHAAAIhwAACEcAAAnvABAHCQAACF8AAAgfAAAJnwAUB2MAAAh/AAAIPwAACd8AEgcbAAAIbwAACC8AAAm/AAAIDwAACI8AAAhPAAAJ/wAQBQEAFwUBARMFEQAbBQEQEQUFABkFAQQVBUEAHQUBQBAFAwAYBQECFAUhABwFASASBQkAGgUBCBYFgQBABQAAEAUCABcFgQETBRkAGwUBGBEFBwAZBQEGFQVhAB0FAWAQBQQAGAUBAxQFMQAcBQEwEgUNABoFAQwWBcEAQAUAADEuMi44AHN0cmVhbSBlcnJvcgBpbnN1ZmZpY2llbnQgbWVtb3J5AGJ1ZmZlciBlcnJvcgBB5IQBC6EVazgHAA2yBwCc8gcAcGQIAGCuCgCwcQsAMKoMABMAAAAMAAAADQAAAAEAAAAGAAAAAQAAAAEAAAATAAAADQAAAA4AAAABAAAABwAAAAAAAAABAAAAFAAAAA8AAAAQAAAAAQAAAAYAAAAAAAAAAQAAABUAAAAQAAAAEQAAAAEAAAAFAAAAAAAAAAIAAAAVAAAAEgAAABIAAAABAAAABQAAAAAAAAACAAAAFQAAABIAAAATAAAAAgAAAAUAAAACAAAAAwAAABUAAAATAAAAEwAAAAMAAAAFAAAABAAAAAMAAAAVAAAAEwAAABMAAAADAAAABQAAAAgAAAAEAAAAFQAAABMAAAATAAAAAwAAAAUAAAAQAAAABQAAABUAAAATAAAAFAAAAAQAAAAFAAAAEAAAAAUAAAAWAAAAFAAAABUAAAAEAAAABQAAABAAAAAFAAAAFgAAABUAAAAWAAAABAAAAAUAAAAQAAAABQAAABYAAAAVAAAAFgAAAAUAAAAFAAAAEAAAAAUAAAAWAAAAFQAAABYAAAAFAAAABQAAACAAAAAGAAAAFgAAABYAAAAXAAAABQAAAAUAAAAgAAAABgAAABYAAAAXAAAAFwAAAAYAAAAFAAAAIAAAAAYAAAAWAAAAFgAAABYAAAAFAAAABQAAADAAAAAHAAAAFwAAABcAAAAWAAAABQAAAAQAAABAAAAABwAAABcAAAAXAAAAFgAAAAYAAAADAAAAQAAAAAgAAAAXAAAAGAAAABYAAAAHAAAAAwAAAAABAAAJAAAAGQAAABkAAAAXAAAABwAAAAMAAAAAAQAACQAAABoAAAAaAAAAGAAAAAcAAAADAAAAAAIAAAkAAAAbAAAAGwAAABkAAAAJAAAAAwAAAOcDAAAJAAAAEgAAAAwAAAANAAAAAQAAAAUAAAABAAAAAQAAABIAAAANAAAADgAAAAEAAAAGAAAAAAAAAAEAAAASAAAADgAAAA4AAAABAAAABQAAAAAAAAACAAAAEgAAABAAAAAQAAAAAQAAAAQAAAAAAAAAAgAAABIAAAAQAAAAEQAAAAIAAAAFAAAAAgAAAAMAAAASAAAAEgAAABIAAAADAAAABQAAAAIAAAADAAAAEgAAABIAAAATAAAAAwAAAAUAAAAEAAAABAAAABIAAAASAAAAEwAAAAQAAAAEAAAABAAAAAQAAAASAAAAEgAAABMAAAAEAAAABAAAAAgAAAAFAAAAEgAAABIAAAATAAAABQAAAAQAAAAIAAAABQAAABIAAAASAAAAEwAAAAYAAAAEAAAACAAAAAUAAAASAAAAEgAAABMAAAAFAAAABAAAAAwAAAAGAAAAEgAAABMAAAATAAAABwAAAAQAAAAMAAAABgAAABIAAAASAAAAEwAAAAQAAAAEAAAAEAAAAAcAAAASAAAAEgAAABMAAAAEAAAAAwAAACAAAAAHAAAAEgAAABIAAAATAAAABgAAAAMAAACAAAAABwAAABIAAAATAAAAEwAAAAYAAAADAAAAgAAAAAgAAAASAAAAEwAAABMAAAAIAAAAAwAAAAABAAAIAAAAEgAAABMAAAATAAAABgAAAAMAAACAAAAACQAAABIAAAATAAAAEwAAAAgAAAADAAAAAAEAAAkAAAASAAAAEwAAABMAAAAKAAAAAwAAAAACAAAJAAAAEgAAABMAAAATAAAADAAAAAMAAAAAAgAACQAAABIAAAATAAAAEwAAAA0AAAADAAAA5wMAAAkAAAARAAAADAAAAAwAAAABAAAABQAAAAEAAAABAAAAEQAAAAwAAAANAAAAAQAAAAYAAAAAAAAAAQAAABEAAAANAAAADwAAAAEAAAAFAAAAAAAAAAEAAAARAAAADwAAABAAAAACAAAABQAAAAAAAAACAAAAEQAAABEAAAARAAAAAgAAAAQAAAAAAAAAAgAAABEAAAAQAAAAEQAAAAMAAAAEAAAAAgAAAAMAAAARAAAAEQAAABEAAAADAAAABAAAAAQAAAAEAAAAEQAAABEAAAARAAAAAwAAAAQAAAAIAAAABQAAABEAAAARAAAAEQAAAAQAAAAEAAAACAAAAAUAAAARAAAAEQAAABEAAAAFAAAABAAAAAgAAAAFAAAAEQAAABEAAAARAAAABgAAAAQAAAAIAAAABQAAABEAAAARAAAAEQAAAAUAAAAEAAAACAAAAAYAAAARAAAAEgAAABEAAAAHAAAABAAAAAwAAAAGAAAAEQAAABIAAAARAAAAAwAAAAQAAAAMAAAABwAAABEAAAASAAAAEQAAAAQAAAADAAAAIAAAAAcAAAARAAAAEgAAABEAAAAGAAAAAwAAAAABAAAHAAAAEQAAABIAAAARAAAABgAAAAMAAACAAAAACAAAABEAAAASAAAAEQAAAAgAAAADAAAAAAEAAAgAAAARAAAAEgAAABEAAAAKAAAAAwAAAAACAAAIAAAAEQAAABIAAAARAAAABQAAAAMAAAAAAQAACQAAABEAAAASAAAAEQAAAAcAAAADAAAAAAIAAAkAAAARAAAAEgAAABEAAAAJAAAAAwAAAAACAAAJAAAAEQAAABIAAAARAAAACwAAAAMAAADnAwAACQAAAA4AAAAMAAAADQAAAAEAAAAFAAAAAQAAAAEAAAAOAAAADgAAAA8AAAABAAAABQAAAAAAAAABAAAADgAAAA4AAAAPAAAAAQAAAAQAAAAAAAAAAQAAAA4AAAAOAAAADwAAAAIAAAAEAAAAAAAAAAIAAAAOAAAADgAAAA4AAAAEAAAABAAAAAIAAAADAAAADgAAAA4AAAAOAAAAAwAAAAQAAAAEAAAABAAAAA4AAAAOAAAADgAAAAQAAAAEAAAACAAAAAUAAAAOAAAADgAAAA4AAAAGAAAABAAAAAgAAAAFAAAADgAAAA4AAAAOAAAACAAAAAQAAAAIAAAABQAAAA4AAAAPAAAADgAAAAUAAAAEAAAACAAAAAYAAAAOAAAADwAAAA4AAAAJAAAABAAAAAgAAAAGAAAADgAAAA8AAAAOAAAAAwAAAAQAAAAMAAAABwAAAA4AAAAPAAAADgAAAAQAAAADAAAAGAAAAAcAAAAOAAAADwAAAA4AAAAFAAAAAwAAACAAAAAIAAAADgAAAA8AAAAPAAAABgAAAAMAAABAAAAACAAAAA4AAAAPAAAADwAAAAcAAAADAAAAAAEAAAgAAAAOAAAADwAAAA8AAAAFAAAAAwAAADAAAAAJAAAADgAAAA8AAAAPAAAABgAAAAMAAACAAAAACQAAAA4AAAAPAAAADwAAAAcAAAADAAAAAAEAAAkAAAAOAAAADwAAAA8AAAAIAAAAAwAAAAABAAAJAAAADgAAAA8AAAAPAAAACAAAAAMAAAAAAgAACQAAAA4AAAAPAAAADwAAAAkAAAADAAAAAAIAAAkAAAAOAAAADwAAAA8AAAAKAAAAAwAAAOcDAAAJAAAAIAAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAApAAAAKgAAACsAAAAsAAAALQAAAC4AAAAvAAAAMAAAADAAAAAxAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA4AEGQmgEL+gEEAAMAAgACAAIAAgACAAIAAgACAAIAAgACAAEAAQABAAIAAgACAAIAAgACAAIAAgACAAMAAgABAAEAAQABAAEA//////////8AAAAAAAAAAAEAAQABAAEAAQABAAIAAgACAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAP////////////8AAAAAAAABAAQAAwACAAIAAgACAAIAAgABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAP//////////////////AEGVnAEL+AcIAAAABwAAagYAAAAGAACtBQAAagUAADEFAAAABQAA1AQAAK0EAACKBAAAagQAAEwEAAAxBAAAFwQAAAAEAADpAwAA1AMAAMADAACtAwAAmwMAAIoDAAB5AwAAagMAAFsDAABMAwAAPgMAADEDAAAkAwAAFwMAAAsDAAAAAwAA9AIAAOkCAADeAgAA1AIAAMoCAADAAgAAtgIAAK0CAACkAgAAmwIAAJICAACKAgAAggIAAHkCAAByAgAAagIAAGICAABbAgAAUwIAAEwCAABFAgAAPgIAADcCAAAxAgAAKgIAACQCAAAeAgAAFwIAABECAAALAgAABQIAAAACAAD6AQAA9AEAAO8BAADpAQAA5AEAAN4BAADZAQAA1AEAAM8BAADKAQAAxQEAAMABAAC7AQAAtgEAALIBAACtAQAAqAEAAKQBAACfAQAAmwEAAJcBAACSAQAAjgEAAIoBAACGAQAAggEAAH4BAAB5AQAAdQEAAHIBAABuAQAAagEAAGYBAABiAQAAXgEAAFsBAABXAQAAUwEAAFABAABMAQAASQEAAEUBAABCAQAAPgEAADsBAAA3AQAANAEAADEBAAAuAQAAKgEAACcBAAAkAQAAIQEAAB4BAAAaAQAAFwEAABQBAAARAQAADgEAAAsBAAAIAQAABQEAAAIBAAAAAQAA/QAAAPoAAAD3AAAA9AAAAPEAAADvAAAA7AAAAOkAAADmAAAA5AAAAOEAAADeAAAA3AAAANkAAADXAAAA1AAAANEAAADPAAAAzAAAAMoAAADHAAAAxQAAAMIAAADAAAAAvgAAALsAAAC5AAAAtgAAALQAAACyAAAArwAAAK0AAACrAAAAqAAAAKYAAACkAAAAogAAAJ8AAACdAAAAmwAAAJkAAACXAAAAlQAAAJIAAACQAAAAjgAAAIwAAACKAAAAiAAAAIYAAACEAAAAggAAAIAAAAB+AAAAewAAAHkAAAB3AAAAdQAAAHMAAAByAAAAcAAAAG4AAABsAAAAagAAAGgAAABmAAAAZAAAAGIAAABgAAAAXgAAAF0AAABbAAAAWQAAAFcAAABVAAAAUwAAAFIAAABQAAAATgAAAEwAAABKAAAASQAAAEcAAABFAAAAQwAAAEIAAABAAAAAPgAAAD0AAAA7AAAAOQAAADcAAAA2AAAANAAAADIAAAAxAAAALwAAAC4AAAAsAAAAKgAAACkAAAAnAAAAJQAAACQAAAAiAAAAIQAAAB8AAAAeAAAAHAAAABoAAAAZAAAAFwAAABYAAAAUAAAAEwAAABEAAAAQAAAADgAAAA0AAAALAAAACgAAAAgAAAAHAAAABQAAAAQAAAACAAAAAQBBkKUBC1EBAAAAAQAAAAEAAAABAAAAAgAAAAIAAAADAAAAAwAAAAQAAAAEAAAABQAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0AAAAOAAAADwAAABAAQfGlAQu/AQECAwQFBgcICQoLDA0ODxAQERESEhMTFBQUFBUVFRUWFhYWFhYWFhcXFxcXFxcXGBgYGBgYGBgYGBgYGBgYGAABAgMEBQYHCAkKCwwNDg8QERITFBUWFxgZGhscHR4fICAhISIiIyMkJCQkJSUlJSYmJiYmJiYmJycnJycnJycoKCgoKCgoKCgoKCgoKCgoKSkpKSkpKSkpKSkpKSkpKSoqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqAEHwpwELTQEAAAABAAAAAQAAAAEAAAACAAAAAgAAAAMAAAADAAAABAAAAAYAAAAHAAAACAAAAAkAAAAKAAAACwAAAAwAAAANAAAADgAAAA8AAAAQAEHIqAELDQEAAAABAAAAAgAAAAIAQeCoAQvTBgEAAAABAAAAAgAAAAIAAAAmAAAAggAAACEFAABKAAAAZwgAACYAAADAAQAAgAAAAEkFAABKAAAAvggAACkAAAAsAgAAgAAAAEkFAABKAAAAvggAAC8AAADKAgAAgAAAAIoFAABKAAAAhAkAADUAAABzAwAAgAAAAJ0FAABKAAAAoAkAAD0AAACBAwAAgAAAAOsFAABLAAAAPgoAAEQAAACeAwAAgAAAAE0GAABLAAAAqgoAAEsAAACzAwAAgAAAAMEGAABNAAAAHw0AAE0AAABTBAAAgAAAACMIAABRAAAApg8AAFQAAACZBAAAgAAAAEsJAABXAAAAsRIAAFgAAADaBAAAgAAAAG8JAABdAAAAIxQAAFQAAABFBQAAgAAAAFQKAABqAAAAjBQAAGoAAACvBQAAgAAAAHYJAAB8AAAAThAAAHwAAADSAgAAgAAAAGMHAACRAAAAkAcAAJIAAAAAAAAAAQAAAAIAAAAEAAAAAAAAAAIAAAAEAAAACAAAAAAAAAABAAAAAQAAAAUAAAANAAAAHQAAAD0AAAB9AAAA/QAAAP0BAAD9AwAA/QcAAP0PAAD9HwAA/T8AAP1/AAD9/wAA/f8BAP3/AwD9/wcA/f8PAP3/HwD9/z8A/f9/AP3//wD9//8B/f//A/3//wf9//8P/f//H/3//z/9//9/AAAAAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0AAAAOAAAADwAAABAAAAARAAAAEgAAABMAAAAUAAAAFQAAABYAAAAXAAAAGAAAABkAAAAaAAAAGwAAABwAAAAdAAAAHgAAAB8AAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAlAAAAJwAAACkAAAArAAAALwAAADMAAAA7AAAAQwAAAFMAAABjAAAAgwAAAAMBAAADAgAAAwQAAAMIAAADEAAAAyAAAANAAAADgAAAAwABAEHErwELlQEBAAAAAgAAAAMAAAAEAAAABQAAAAYAAAAHAAAACAAAAAkAAAAKAAAACwAAAAwAAAANAAAADgAAAA8AAAAQAAAAEgAAABQAAAAWAAAAGAAAABwAAAAgAAAAKAAAADAAAABAAAAAgAAAAAABAAAAAgAAAAQAAAAIAAAAEAAAACAAAABAAAAAgAAAAAABAAEAAAAEAAAACABB5LABC4sBAQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABIAAAAUAAAAFgAAABgAAAAcAAAAIAAAACgAAAAwAAAAQAAAAIAAAAAAAQAAAAIAAAAEAAAACAAAABAAAAAgAAAAQAAAAIAAAAAAAQBBsLIBC9YEAQAAAAEAAAABAAAAAQAAAAIAAAACAAAAAwAAAAMAAAAEAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0AAAAOAAAADwAAABAAAAABAAEBBgAAAAAAAAQAAAAAEAAABAAAAAAgAAAFAQAAAAAAAAUDAAAAAAAABQQAAAAAAAAFBgAAAAAAAAUHAAAAAAAABQkAAAAAAAAFCgAAAAAAAAUMAAAAAAAABg4AAAAAAAEFEAAAAAAAAQUUAAAAAAABBRYAAAAAAAIFHAAAAAAAAwUgAAAAAAAEBTAAAAAgAAYFQAAAAAAABwWAAAAAAAAIBgABAAAAAAoGAAQAAAAADAYAEAAAIAAABAAAAAAAAAAEAQAAAAAAAAUCAAAAIAAABQQAAAAAAAAFBQAAACAAAAUHAAAAAAAABQgAAAAgAAAFCgAAAAAAAAULAAAAAAAABg0AAAAgAAEFEAAAAAAAAQUSAAAAIAABBRYAAAAAAAIFGAAAACAAAwUgAAAAAAADBSgAAAAAAAYEQAAAABAABgRAAAAAIAAHBYAAAAAAAAkGAAIAAAAACwYACAAAMAAABAAAAAAQAAAEAQAAACAAAAUCAAAAIAAABQMAAAAgAAAFBQAAACAAAAUGAAAAIAAABQgAAAAgAAAFCQAAACAAAAULAAAAIAAABQwAAAAAAAAGDwAAACAAAQUSAAAAIAABBRQAAAAgAAIFGAAAACAAAgUcAAAAIAADBSgAAAAgAAQFMAAAAAAAEAYAAAEAAAAPBgCAAAAAAA4GAEAAAAAADQYAIABBlLcBC4MEAQAAAAEAAAAFAAAADQAAAB0AAAA9AAAAfQAAAP0AAAD9AQAA/QMAAP0HAAD9DwAA/R8AAP0/AAD9fwAA/f8AAP3/AQD9/wMA/f8HAP3/DwD9/x8A/f8/AP3/fwD9//8A/f//Af3//wP9//8H/f//D/3//x/9//8//f//fwAAAAABAAAAAgAAAAMAAAAEAAAABQAAAAYAAAAHAAAACAAAAAkAAAAKAAAACwAAAAwAAAANAAAADgAAAA8AAAAQAAAAEQAAABIAAAATAAAAFAAAABUAAAAWAAAAFwAAABgAAAAZAAAAGgAAABsAAAAcAAAAHQAAAB4AAAAfAAAAAQABAQUAAAAAAAAFAAAAAAAABgQ9AAAAAAAJBf0BAAAAAA8F/X8AAAAAFQX9/x8AAAADBQUAAAAAAAcEfQAAAAAADAX9DwAAAAASBf3/AwAAABcF/f9/AAAABQUdAAAAAAAIBP0AAAAAAA4F/T8AAAAAFAX9/w8AAAACBQEAAAAQAAcEfQAAAAAACwX9BwAAAAARBf3/AQAAABYF/f8/AAAABAUNAAAAEAAIBP0AAAAAAA0F/R8AAAAAEwX9/wcAAAABBQEAAAAQAAYEPQAAAAAACgX9AwAAAAAQBf3/AAAAABwF/f//DwAAGwX9//8HAAAaBf3//wMAABkF/f//AQAAGAX9//8AQaC7AQvTAQMAAAAEAAAABQAAAAYAAAAHAAAACAAAAAkAAAAKAAAACwAAAAwAAAANAAAADgAAAA8AAAAQAAAAEQAAABIAAAATAAAAFAAAABUAAAAWAAAAFwAAABgAAAAZAAAAGgAAABsAAAAcAAAAHQAAAB4AAAAfAAAAIAAAACEAAAAiAAAAIwAAACUAAAAnAAAAKQAAACsAAAAvAAAAMwAAADsAAABDAAAAUwAAAGMAAACDAAAAAwEAAAMCAAADBAAAAwgAAAMQAAADIAAAA0AAAAOAAAADAAEAQYC+AQtRAQAAAAEAAAABAAAAAQAAAAIAAAACAAAAAwAAAAMAAAAEAAAABAAAAAUAAAAHAAAACAAAAAkAAAAKAAAACwAAAAwAAAANAAAADgAAAA8AAAAQAEHgvgELhgQBAAEBBgAAAAAAAAYDAAAAAAAABAQAAAAgAAAFBQAAAAAAAAUGAAAAAAAABQgAAAAAAAAFCQAAAAAAAAULAAAAAAAABg0AAAAAAAAGEAAAAAAAAAYTAAAAAAAABhYAAAAAAAAGGQAAAAAAAAYcAAAAAAAABh8AAAAAAAAGIgAAAAAAAQYlAAAAAAABBikAAAAAAAIGLwAAAAAAAwY7AAAAAAAEBlMAAAAAAAcGgwAAAAAACQYDAgAAEAAABAQAAAAAAAAEBQAAACAAAAUGAAAAAAAABQcAAAAgAAAFCQAAAAAAAAUKAAAAAAAABgwAAAAAAAAGDwAAAAAAAAYSAAAAAAAABhUAAAAAAAAGGAAAAAAAAAYbAAAAAAAABh4AAAAAAAAGIQAAAAAAAQYjAAAAAAABBicAAAAAAAIGKwAAAAAAAwYzAAAAAAAEBkMAAAAAAAUGYwAAAAAACAYDAQAAIAAABAQAAAAwAAAEBAAAABAAAAQFAAAAIAAABQcAAAAgAAAFCAAAACAAAAUKAAAAIAAABQsAAAAAAAAGDgAAAAAAAAYRAAAAAAAABhQAAAAAAAAGFwAAAAAAAAYaAAAAAAAABh0AAAAAAAAGIAAAAAAAEAYDAAEAAAAPBgOAAAAAAA4GA0AAAAAADQYDIAAAAAAMBgMQAAAAAAsGAwgAAAAACgYDBABB8MIBC5EOCAAAAAgAAAAIAAAABwAAAAgAAAAJAAAACgAAAAsAAAAAAAAAAQAAAAIAAAABAAAABAAAAAQAAAAEAAAABAAAAAAAAAABAAAAAwAAAAcAAAAPAAAAHwAAAD8AAAB/AAAA/wAAAP8BAAD/AwAA/wcAAP8PAAD/HwAA/z8AAP9/AAD//wAA//8BAP//AwD//wcA//8PAP//HwD//z8A//9/AP///wD///8B////A////wf///8P////H////z////9/dm9pZABib29sAGNoYXIAc2lnbmVkIGNoYXIAdW5zaWduZWQgY2hhcgBzaG9ydAB1bnNpZ25lZCBzaG9ydABpbnQAdW5zaWduZWQgaW50AGxvbmcAdW5zaWduZWQgbG9uZwBmbG9hdABkb3VibGUAc3RkOjpzdHJpbmcAc3RkOjpiYXNpY19zdHJpbmc8dW5zaWduZWQgY2hhcj4Ac3RkOjp3c3RyaW5nAHN0ZDo6dTE2c3RyaW5nAHN0ZDo6dTMyc3RyaW5nAGVtc2NyaXB0ZW46OnZhbABlbXNjcmlwdGVuOjptZW1vcnlfdmlldzxjaGFyPgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzxzaWduZWQgY2hhcj4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8dW5zaWduZWQgY2hhcj4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8c2hvcnQ+AGVtc2NyaXB0ZW46Om1lbW9yeV92aWV3PHVuc2lnbmVkIHNob3J0PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzxpbnQ+AGVtc2NyaXB0ZW46Om1lbW9yeV92aWV3PHVuc2lnbmVkIGludD4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8bG9uZz4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8dW5zaWduZWQgbG9uZz4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8aW50OF90PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzx1aW50OF90PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzxpbnQxNl90PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzx1aW50MTZfdD4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8aW50MzJfdD4AZW1zY3JpcHRlbjo6bWVtb3J5X3ZpZXc8dWludDMyX3Q+AGVtc2NyaXB0ZW46Om1lbW9yeV92aWV3PGZsb2F0PgBlbXNjcmlwdGVuOjptZW1vcnlfdmlldzxkb3VibGU+AAAAGHQAAFBlAABOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0lkRUUAABh0AAB4ZQAATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJZkVFAAAYdAAAoGUAAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SW1FRQAAGHQAAMhlAABOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0lsRUUAABh0AADwZQAATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJakVFAAAYdAAAGGYAAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SWlFRQAAGHQAAEBmAABOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0l0RUUAABh0AABoZgAATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJc0VFAAAYdAAAkGYAAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SWFFRQAAGHQAALhmAABOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0ljRUUAAEB0AADwZgAAAAAAAAEAAACIBwAAAAAAAE5TdDNfXzIxMmJhc2ljX3N0cmluZ0lEaU5TXzExY2hhcl90cmFpdHNJRGlFRU5TXzlhbGxvY2F0b3JJRGlFRUVFAAAAQHQAAExnAAAAAAAAAQAAAIgHAAAAAAAATlN0M19fMjEyYmFzaWNfc3RyaW5nSURzTlNfMTFjaGFyX3RyYWl0c0lEc0VFTlNfOWFsbG9jYXRvcklEc0VFRUUAAABAdAAAqGcAAAAAAAABAAAAiAcAAAAAAABOU3QzX18yMTJiYXNpY19zdHJpbmdJd05TXzExY2hhcl90cmFpdHNJd0VFTlNfOWFsbG9jYXRvckl3RUVFRQAAQHQAAABoAAAAAAAAAQAAAIgHAAAAAAAATlN0M19fMjEyYmFzaWNfc3RyaW5nSWhOU18xMWNoYXJfdHJhaXRzSWhFRU5TXzlhbGxvY2F0b3JJaEVFRUUAABEACgAREREAAAAABQAAAAAAAAkAAAAACwAAAAAAAAAAEQAPChEREQMKBwABAAkLCwAACQYLAAALAAYRAAAAERERAEGR0QELIQsAAAAAAAAAABEACgoREREACgAAAgAJCwAAAAkACwAACwBBy9EBCwEMAEHX0QELFQwAAAAADAAAAAAJDAAAAAAADAAADABBhdIBCwEOAEGR0gELFQ0AAAAEDQAAAAAJDgAAAAAADgAADgBBv9IBCwEQAEHL0gELHg8AAAAADwAAAAAJEAAAAAAAEAAAEAAAEgAAABISEgBBgtMBCw4SAAAAEhISAAAAAAAACQBBs9MBCwELAEG/0wELFQoAAAAACgAAAAAJCwAAAAAACwAACwBB7dMBCwEMAEH50wELJwwAAAAADAAAAAAJDAAAAAAADAAADAAALSsgICAwWDB4AChudWxsKQBBsNQBC2cwMTIzNDU2Nzg5QUJDREVGGRJEOwI/LEcUPTMwChsGRktFNw9JDo4XA0AdPGkrNh9KLRwBICUpIQgMFRYiLhA4Pgs0MRhkdHV2L0EJfzkRI0MyQomKiwUEJignDSoeNYwHGkiTE5SVAEGg1QEL9hNJbGxlZ2FsIGJ5dGUgc2VxdWVuY2UARG9tYWluIGVycm9yAFJlc3VsdCBub3QgcmVwcmVzZW50YWJsZQBOb3QgYSB0dHkAUGVybWlzc2lvbiBkZW5pZWQAT3BlcmF0aW9uIG5vdCBwZXJtaXR0ZWQATm8gc3VjaCBmaWxlIG9yIGRpcmVjdG9yeQBObyBzdWNoIHByb2Nlc3MARmlsZSBleGlzdHMAVmFsdWUgdG9vIGxhcmdlIGZvciBkYXRhIHR5cGUATm8gc3BhY2UgbGVmdCBvbiBkZXZpY2UAT3V0IG9mIG1lbW9yeQBSZXNvdXJjZSBidXN5AEludGVycnVwdGVkIHN5c3RlbSBjYWxsAFJlc291cmNlIHRlbXBvcmFyaWx5IHVuYXZhaWxhYmxlAEludmFsaWQgc2VlawBDcm9zcy1kZXZpY2UgbGluawBSZWFkLW9ubHkgZmlsZSBzeXN0ZW0ARGlyZWN0b3J5IG5vdCBlbXB0eQBDb25uZWN0aW9uIHJlc2V0IGJ5IHBlZXIAT3BlcmF0aW9uIHRpbWVkIG91dABDb25uZWN0aW9uIHJlZnVzZWQASG9zdCBpcyBkb3duAEhvc3QgaXMgdW5yZWFjaGFibGUAQWRkcmVzcyBpbiB1c2UAQnJva2VuIHBpcGUASS9PIGVycm9yAE5vIHN1Y2ggZGV2aWNlIG9yIGFkZHJlc3MAQmxvY2sgZGV2aWNlIHJlcXVpcmVkAE5vIHN1Y2ggZGV2aWNlAE5vdCBhIGRpcmVjdG9yeQBJcyBhIGRpcmVjdG9yeQBUZXh0IGZpbGUgYnVzeQBFeGVjIGZvcm1hdCBlcnJvcgBJbnZhbGlkIGFyZ3VtZW50AEFyZ3VtZW50IGxpc3QgdG9vIGxvbmcAU3ltYm9saWMgbGluayBsb29wAEZpbGVuYW1lIHRvbyBsb25nAFRvbyBtYW55IG9wZW4gZmlsZXMgaW4gc3lzdGVtAE5vIGZpbGUgZGVzY3JpcHRvcnMgYXZhaWxhYmxlAEJhZCBmaWxlIGRlc2NyaXB0b3IATm8gY2hpbGQgcHJvY2VzcwBCYWQgYWRkcmVzcwBGaWxlIHRvbyBsYXJnZQBUb28gbWFueSBsaW5rcwBObyBsb2NrcyBhdmFpbGFibGUAUmVzb3VyY2UgZGVhZGxvY2sgd291bGQgb2NjdXIAU3RhdGUgbm90IHJlY292ZXJhYmxlAFByZXZpb3VzIG93bmVyIGRpZWQAT3BlcmF0aW9uIGNhbmNlbGVkAEZ1bmN0aW9uIG5vdCBpbXBsZW1lbnRlZABObyBtZXNzYWdlIG9mIGRlc2lyZWQgdHlwZQBJZGVudGlmaWVyIHJlbW92ZWQARGV2aWNlIG5vdCBhIHN0cmVhbQBObyBkYXRhIGF2YWlsYWJsZQBEZXZpY2UgdGltZW91dABPdXQgb2Ygc3RyZWFtcyByZXNvdXJjZXMATGluayBoYXMgYmVlbiBzZXZlcmVkAFByb3RvY29sIGVycm9yAEJhZCBtZXNzYWdlAEZpbGUgZGVzY3JpcHRvciBpbiBiYWQgc3RhdGUATm90IGEgc29ja2V0AERlc3RpbmF0aW9uIGFkZHJlc3MgcmVxdWlyZWQATWVzc2FnZSB0b28gbGFyZ2UAUHJvdG9jb2wgd3JvbmcgdHlwZSBmb3Igc29ja2V0AFByb3RvY29sIG5vdCBhdmFpbGFibGUAUHJvdG9jb2wgbm90IHN1cHBvcnRlZABTb2NrZXQgdHlwZSBub3Qgc3VwcG9ydGVkAE5vdCBzdXBwb3J0ZWQAUHJvdG9jb2wgZmFtaWx5IG5vdCBzdXBwb3J0ZWQAQWRkcmVzcyBmYW1pbHkgbm90IHN1cHBvcnRlZCBieSBwcm90b2NvbABBZGRyZXNzIG5vdCBhdmFpbGFibGUATmV0d29yayBpcyBkb3duAE5ldHdvcmsgdW5yZWFjaGFibGUAQ29ubmVjdGlvbiByZXNldCBieSBuZXR3b3JrAENvbm5lY3Rpb24gYWJvcnRlZABObyBidWZmZXIgc3BhY2UgYXZhaWxhYmxlAFNvY2tldCBpcyBjb25uZWN0ZWQAU29ja2V0IG5vdCBjb25uZWN0ZWQAQ2Fubm90IHNlbmQgYWZ0ZXIgc29ja2V0IHNodXRkb3duAE9wZXJhdGlvbiBhbHJlYWR5IGluIHByb2dyZXNzAE9wZXJhdGlvbiBpbiBwcm9ncmVzcwBTdGFsZSBmaWxlIGhhbmRsZQBSZW1vdGUgSS9PIGVycm9yAFF1b3RhIGV4Y2VlZGVkAE5vIG1lZGl1bSBmb3VuZABXcm9uZyBtZWRpdW0gdHlwZQBObyBlcnJvciBpbmZvcm1hdGlvbgAAYmFzaWNfc3RyaW5nAHN0ZDo6ZXhjZXB0aW9uAAAAAADccQAAPAAAAD0AAAA+AAAAGHQAAORxAABTdDlleGNlcHRpb24AAAAAAAAAAAhyAAAQAAAAPwAAAEAAAACMcgAAFHIAANxxAABTdDExbG9naWNfZXJyb3IAAAAAADhyAAAQAAAAQQAAAEAAAACMcgAARHIAAAhyAABTdDEybGVuZ3RoX2Vycm9yAFN0OXR5cGVfaW5mbwAAABh0AABVcgAAjHIAAAFzAABkcgAAjHIAAKxyAABscgAAAAAAANByAABCAAAAQwAAAEQAAABFAAAARgAAAEcAAABIAAAASQAAAE4xMF9fY3h4YWJpdjExN19fY2xhc3NfdHlwZV9pbmZvRQAAAIxyAADccgAAeHIAAE4xMF9fY3h4YWJpdjEyMF9fc2lfY2xhc3NfdHlwZV9pbmZvRQBOMTBfX2N4eGFiaXYxMTZfX3NoaW1fdHlwZV9pbmZvRQAAAAAAAABAcwAAQgAAAEoAAABEAAAARQAAAEsAAACMcgAATHMAAGxyAABOMTBfX2N4eGFiaXYxMjNfX2Z1bmRhbWVudGFsX3R5cGVfaW5mb0UAdgAAACxzAAB0cwAAYgAAACxzAACAcwAAYwAAACxzAACMcwAAaAAAACxzAACYcwAAYQAAACxzAACkcwAAcwAAACxzAACwcwAAdAAAACxzAAC8cwAAaQAAACxzAADIcwAAagAAACxzAADUcwAAbAAAACxzAADgcwAAbQAAACxzAADscwAAZgAAACxzAAD4cwAAZAAAACxzAAAEdAAAAAAAAHhyAABCAAAATAAAAEQAAABFAAAARgAAAE0AAABOAAAATwAAAAAAAABgdAAAQgAAAFAAAABEAAAARQAAAEYAAABRAAAAUgAAAFMAAACMcgAAbHQAAHhyAABOMTBfX2N4eGFiaXYxMjFfX3ZtaV9jbGFzc190eXBlX2luZm9FAAAAcHUAQZjpAQtBgC0AAAAyAAABAQAAHgEAAA8AAACALAAAAC0AAAAAAAAeAAAADwAAAAAAAAAwLAAAAAAAABMAAAAHAAAAAAAAAAUAQeTpAQsBOQBB/OkBCwo6AAAAOwAAAC12AEGU6gELAQIAQaPqAQsF//////8AQejqAQsJoH5QAAAAAAAFAEH86gELAVQAQZTrAQsOOgAAAFUAAACYegAAAAQAQazrAQsBAQBBu+sBCwUK/////w==", Lm, Ky;
(function(t) {
  t[t.NOSHUFFLE = 0] = "NOSHUFFLE", t[t.SHUFFLE = 1] = "SHUFFLE", t[t.BITSHUFFLE = 2] = "BITSHUFFLE", t[t.AUTOSHUFFLE = -1] = "AUTOSHUFFLE";
})(Ky || (Ky = {}));
const EDe = /* @__PURE__ */ new Set(["blosclz", "lz4", "lz4hc", "snappy", "zlib", "zstd"]);
let _b;
const yDe = (Lm = class oKe {
  constructor(e = 5, n = "lz4", r = Ky.SHUFFLE, i = 0) {
    if (e < 0 || e > 9)
      throw new Error(`Invalid compression level: '${e}'. It should be between 0 and 9`);
    if (!EDe.has(n))
      throw new Error(`Invalid compressor '${n}'. Valid compressors include
        'blosclz', 'lz4', 'lz4hc','snappy', 'zlib', 'zstd'.`);
    if (r < -1 || r > 2)
      throw new Error(`Invalid shuffle ${r}. Must be one of 0 (NOSHUFFLE),
        1 (SHUFFLE), 2 (BITSHUFFLE), -1 (AUTOSHUFFLE).`);
    this.blocksize = i, this.clevel = e, this.cname = n, this.shuffle = r;
  }
  static fromConfig({ blocksize: e, clevel: n, cname: r, shuffle: i }) {
    return new oKe(n, r, i, e);
  }
  async encode(e) {
    _b || (_b = IDe(mDe, CDe));
    const n = await _b, r = n.compress(e, this.cname, this.clevel, this.shuffle, this.blocksize), i = new Uint8Array(r);
    return n.free_result(), i;
  }
  async decode(e, n) {
    _b || (_b = IDe(mDe, CDe));
    const r = await _b, i = r.decompress(e), o = new Uint8Array(i);
    return r.free_result(), n !== void 0 ? (n.set(o), n) : o;
  }
}, Lm.codecId = "blosc", Lm.COMPRESSORS = [...EDe], Lm.NOSHUFFLE = Ky.NOSHUFFLE, Lm.SHUFFLE = Ky.SHUFFLE, Lm.BITSHUFFLE = Ky.BITSHUFFLE, Lm.AUTOSHUFFLE = Ky.AUTOSHUFFLE, Lm);
Afe(pDe.codecId, () => pDe);
Afe(dDe.codecId, () => dDe);
Afe(yDe.codecId, () => yDe);
const wHn = "__viv", sKe = `${wHn}-offsets`;
function xHn(t) {
  RHn(t, sKe) || console.warn("GeoTIFF source is missing offsets proxy.");
}
function RHn(t, e) {
  return t[e];
}
function DHn(t, e) {
  const n = (r, i) => i === "getImage" ? (o) => {
    if (!(o in r.ifdRequests) && o in e) {
      const s = e[o];
      r.ifdRequests[o] = r.parseFileDirectoryAt(s);
    }
    return r.getImage(o);
  } : i === sKe ? !0 : Reflect.get(r, i);
  return new Proxy(t, { get: n });
}
class THn extends OUn {
  constructor(e) {
    super();
    const n = e.TileWidth || e.ImageWidth, r = e.TileLength || e.ImageLength, i = e.BitsPerSample[0] / 8;
    this.maxUncompressedSize = n * r * i;
  }
  async decodeBlock(e) {
    const n = new Uint8Array(e);
    return (await YUn(n, this.maxUncompressedSize)).buffer;
  }
}
const vDe = {
  uint8: "Uint8",
  uint16: "Uint16",
  uint32: "Uint32",
  float: "Float32",
  double: "Float64",
  int8: "Int8",
  int16: "Int16",
  int32: "Int32"
};
function OD(t) {
  let e = t.length, n = 1 / 0, r = -1 / 0, i = 0;
  for (; e--; )
    t[e] < n && (n = t[e]), t[e] > r && (r = t[e]), i += t[e];
  const o = i / t.length;
  e = t.length;
  let s = 0;
  for (; e--; )
    s += (t[e] - o) ** 2;
  const a = (s / t.length) ** 0.5, A = Math.floor(t.length / 2), l = Math.floor(t.length / 4), c = 3 * Math.floor(t.length / 4);
  D2(t, A);
  const u = t[A];
  D2(t, l, 0, A);
  const f = t[l];
  D2(t, c, A, t.length - 1);
  const h = t[c], d = t.filter((v) => v > 0), I = 5e-4, m = Math.floor(
    d.length * (1 - I)
  ), C = Math.floor(d.length * I);
  D2(d, m), D2(d, C, 0, m);
  const y = [
    d[C] || 0,
    d[m] || 0
  ];
  return {
    mean: o,
    sd: a,
    q1: f,
    q3: h,
    median: u,
    domain: [n, r],
    contrastLimits: y
  };
}
function BDe(t) {
  return Array.isArray(t) ? t : [t];
}
function NHn(t) {
  if (!Number.isInteger(t))
    throw Error("Not an integer.");
  const e = new ArrayBuffer(4);
  new DataView(e).setInt32(0, t, !1);
  const r = new Uint8Array(e);
  return Array.from(r);
}
function dB(t) {
  const e = t[t.length - 1];
  return e === 3 || e === 4;
}
function LHn(t) {
  return t.toLowerCase().split("").reverse();
}
function aKe(t) {
  const e = new Map(t.map((n, r) => [n, r]));
  if (e.size !== t.length)
    throw Error("Labels must be unique, found duplicated label.");
  return (n) => {
    const r = e.get(n);
    if (r === void 0)
      throw Error("Invalid dimension.");
    return r;
  };
}
function h1(t) {
  const e = dB(t.shape), [n, r] = t.shape.slice(e ? -3 : -2);
  return { height: n, width: r };
}
function MHn(t) {
  return 2 ** Math.floor(Math.log2(t));
}
const pfe = "__vivSignalAborted";
function OHn(t) {
  const e = t.getTileWidth(), n = t.getTileHeight(), r = Math.min(e, n);
  return MHn(r);
}
function FHn({ Pixels: t }) {
  const e = LHn(t.DimensionOrder), n = aKe(e), r = Array(e.length).fill(0);
  r[n("t")] = t.SizeT, r[n("c")] = t.SizeC, r[n("z")] = t.SizeZ, t.Interleaved && (e.push("_c"), r.push(3));
  const i = (s) => {
    const a = [...r];
    return a[n("x")] = t.SizeX >> s, a[n("y")] = t.SizeY >> s, a;
  };
  if (!(t.Type in vDe))
    throw Error(`Pixel type ${t.Type} not supported.`);
  const o = vDe[t.Type];
  if (t.PhysicalSizeX && t.PhysicalSizeY) {
    const s = {
      x: {
        size: t.PhysicalSizeX,
        unit: t.PhysicalSizeXUnit
      },
      y: {
        size: t.PhysicalSizeY,
        unit: t.PhysicalSizeYUnit
      }
    };
    return t.PhysicalSizeZ && (s.z = {
      size: t.PhysicalSizeZ,
      unit: t.PhysicalSizeZUnit
    }), { labels: e, getShape: i, physicalSizes: s, dtype: o };
  }
  return { labels: e, getShape: i, dtype: o };
}
const PHn = {
  attributeNamePrefix: "",
  attrNodeName: "attr",
  parseNodeValue: !0,
  parseAttributeValue: !0,
  ignoreAttributes: !1
}, kHn = (t) => dJe.parse(t, PHn);
function GHn(t) {
  const e = kHn(t);
  if (!e.OME)
    throw Error("Failed to parse OME-XML metadata.");
  return BDe(e.OME.Image).map((n) => {
    const r = BDe(n.Pixels.Channel).map((a) => "Color" in a.attr ? { ...a.attr, Color: NHn(a.attr.Color) } : { ...a.attr }), { AquisitionDate: i = "", Description: o = "" } = n, s = {
      ...n.attr,
      AquisitionDate: i,
      Description: o,
      Pixels: {
        ...n.Pixels.attr,
        Channels: r
      }
    };
    return {
      ...s,
      format() {
        const { Pixels: a } = s, A = ["X", "Y", "Z"].map((l) => {
          const c = a[`PhysicalSize${l}`], u = a[`PhysicalSize${l}Unit`];
          return c && u ? `${c} ${u}` : "-";
        }).join(" x ");
        return {
          "Acquisition Date": s.AquisitionDate,
          "Dimensions (XY)": `${a.SizeX} x ${a.SizeY}`,
          "Pixels Type": a.Type,
          "Pixels Size (XYZ)": A,
          "Z-sections/Timepoints": `${a.SizeZ} x ${a.SizeT}`,
          Channels: a.SizeC
        };
      }
    };
  });
}
class UHn {
  constructor(e, n, r, i, o, s, a) {
    this.dtype = n, this.tileSize = r, this.shape = i, this.labels = o, this.meta = s, this.pool = a, this._indexer = e;
  }
  async getRaster({ selection: e, signal: n }) {
    const r = await this._indexer(e);
    return this._readRasters(r, { signal: n });
  }
  async getTile({ x: e, y: n, selection: r, signal: i }) {
    const { height: o, width: s } = this._getTileExtent(e, n), a = e * this.tileSize, A = n * this.tileSize, l = [a, A, a + s, A + o], c = await this._indexer(r);
    return this._readRasters(c, { window: l, width: s, height: o, signal: i });
  }
  async _readRasters(e, n) {
    const r = dB(this.shape), i = await e.readRasters({
      interleave: r,
      ...n,
      pool: this.pool
    });
    if (n?.signal?.aborted)
      throw pfe;
    return {
      data: r ? i : i[0],
      width: i.width,
      height: i.height
    };
  }
  _getTileExtent(e, n) {
    const { height: r, width: i } = h1(this);
    let o = this.tileSize, s = this.tileSize;
    const a = Math.floor(i / this.tileSize), A = Math.floor(r / this.tileSize);
    return e === a && (s = i % this.tileSize), n === A && (o = r % this.tileSize), { height: o, width: s };
  }
  onTileError(e) {
    console.error(e);
  }
}
function HHn(t, e) {
  const { SizeT: n, SizeC: r, SizeZ: i } = e[0].Pixels, o = AKe(e, 0);
  return (s, a) => {
    const A = o(s), l = a * i * n * r;
    return t.getImage(A + l);
  };
}
function $Hn(t, e, n = 0) {
  const r = AKe(e, n), i = /* @__PURE__ */ new Map();
  return async (o, s) => {
    const a = r(o), A = await t.getImage(a);
    if (s === 0)
      return A;
    const { SubIFDs: l } = A.fileDirectory;
    if (!l)
      throw Error("Indexing Error: OME-TIFF is missing SubIFDs.");
    const c = `${o.t}-${o.c}-${o.z}-${s}`;
    if (!i.has(c)) {
      const f = l[s - 1];
      i.set(c, t.parseFileDirectoryAt(f));
    }
    const u = await i.get(c);
    return new fJe(
      u.fileDirectory,
      u.geoKeyDirectory,
      A.dataView,
      t.littleEndian,
      t.cache,
      t.source
    );
  };
}
function AKe(t, e = 0) {
  const { SizeC: n, SizeZ: r, SizeT: i, DimensionOrder: o } = t[e].Pixels;
  let s = 0;
  if (e > 0)
    for (let a = 0; a < e; a += 1) {
      const {
        SizeC: A,
        SizeZ: l,
        SizeT: c
      } = t[a].Pixels;
      s += A * l * c;
    }
  switch (o) {
    case "XYZCT":
      return ({ t: a, c: A, z: l }) => s + a * r * n + A * r + l;
    case "XYZTC":
      return ({ t: a, c: A, z: l }) => s + A * r * i + a * r + l;
    case "XYCTZ":
      return ({ t: a, c: A, z: l }) => s + l * n * i + a * n + A;
    case "XYCZT":
      return ({ t: a, c: A, z: l }) => s + a * n * r + l * n + A;
    case "XYTCZ":
      return ({ t: a, c: A, z: l }) => s + l * i * n + A * i + a;
    case "XYTZC":
      return ({ t: a, c: A, z: l }) => s + A * i * r + l * i + a;
    default:
      throw new Error(`Invalid OME-XML DimensionOrder, got ${o}.`);
  }
}
function qHn(t, e, n, r) {
  return n ? $Hn(t, e, r) : HHn(t, e);
}
async function jHn(t, e) {
  const n = await t.getImage(0), {
    ImageDescription: r,
    SubIFDs: i,
    PhotometricInterpretation: o
  } = n.fileDirectory, s = GHn(r);
  let a = s, A;
  i ? A = i.length + 1 : (A = s.length, a = [s[0]]);
  const l = (c, u, f) => {
    const { labels: h, getShape: d, physicalSizes: I, dtype: m } = FHn(f), C = OHn(n), y = { photometricInterpretation: o, physicalSizes: I }, v = d(c), b = (w) => u(w, c);
    return new UHn(
      b,
      m,
      C,
      v,
      h,
      y,
      e
    );
  };
  return a.map((c, u) => {
    const f = qHn(t, s, i, u);
    return {
      data: Array.from({ length: A }).map(
        (d, I) => l(I, f, c)
      ),
      metadata: c
    };
  });
}
rm(5, () => THn);
const bDe = "file://";
async function q8(t, e = {}) {
  const { headers: n = {}, offsets: r, pool: i, images: o = "first" } = e;
  let s;
  typeof t == "string" ? t.startsWith(bDe) ? s = await UUn(t.slice(bDe.length)) : s = await GUn(t, { headers: n, cacheSize: 1 / 0 }) : s = await HUn(t), r && (s = DHn(s, r)), xHn(s);
  const a = await jHn(s, i);
  return o === "all" ? a : a[0];
}
function YHn(t) {
  const e = t.length, n = aKe(t);
  return (r) => {
    if (Array.isArray(r))
      return [...r];
    const i = Array(e).fill(0);
    for (const [o, s] of Object.entries(r))
      i[n(o)] = s;
    return i;
  };
}
const _De = {
  u1: "Uint8",
  u2: "Uint16",
  u4: "Uint32",
  f4: "Float32",
  f8: "Float64",
  i1: "Int8",
  i2: "Int16",
  i4: "Int32"
};
class zHn {
  constructor(e, n, r) {
    this.labels = n, this.tileSize = r, this._indexer = YHn(n), this._data = e;
    const i = e.chunks[this._xIndex], o = e.chunks[this._xIndex - 1];
    this._readChunks = r === i && r === o;
  }
  get shape() {
    return this._data.shape;
  }
  get dtype() {
    const e = this._data.dtype.slice(1);
    if (!(e in _De))
      throw Error(`Zarr dtype not supported, got ${e}.`);
    return _De[e];
  }
  get _xIndex() {
    const e = dB(this._data.shape);
    return this._data.shape.length - (e ? 2 : 1);
  }
  _chunkIndex(e, n, r) {
    const i = this._indexer(e);
    return i[this._xIndex] = n, i[this._xIndex - 1] = r, i;
  }
  _getSlices(e, n) {
    const { height: r, width: i } = h1(this), [o, s] = [
      e * this.tileSize,
      Math.min((e + 1) * this.tileSize, i)
    ], [a, A] = [
      n * this.tileSize,
      Math.min((n + 1) * this.tileSize, r)
    ];
    if (o === s || a === A)
      throw new P8("Tile slice is zero-sized.");
    return [wRe(o, s), wRe(a, A)];
  }
  async getRaster({ selection: e }) {
    const n = this._chunkIndex(e, null, null), { data: r, shape: i } = await this._data.getRaw(n), [o, s] = i;
    return { data: r, width: s, height: o };
  }
  async getTile(e) {
    const { x: n, y: r, selection: i, signal: o } = e;
    let s;
    if (this._readChunks) {
      const c = this._chunkIndex(i, n, r);
      s = await this._data.getRawChunk(c, { storeOptions: { signal: o } });
    } else {
      const [c, u] = this._getSlices(n, r), f = this._chunkIndex(i, c, u);
      s = await this._data.getRaw(f);
    }
    const {
      data: a,
      shape: [A, l]
    } = s;
    return { data: a, width: l, height: A };
  }
  onTileError(e) {
    if (!(e instanceof P8))
      throw e;
  }
}
const VHn = 255, SDe = [0, 0, 0], wq = 6, JHn = "-apple-system, 'Helvetica Neue', Arial, sans-serif", j8 = {
  Uint8: {
    format: gt.R8UI,
    dataFormat: gt.RED_INTEGER,
    type: gt.UNSIGNED_BYTE,
    max: 2 ** 8 - 1,
    sampler: "usampler2D"
  },
  Uint16: {
    format: gt.R16UI,
    dataFormat: gt.RED_INTEGER,
    type: gt.UNSIGNED_SHORT,
    max: 2 ** 16 - 1,
    sampler: "usampler2D"
  },
  Uint32: {
    format: gt.R32UI,
    dataFormat: gt.RED_INTEGER,
    type: gt.UNSIGNED_INT,
    max: 2 ** 32 - 1,
    sampler: "usampler2D"
  },
  Float32: {
    format: gt.R32F,
    dataFormat: gt.RED,
    type: gt.FLOAT,
    max: 3.4 * 10 ** 38,
    sampler: "sampler2D"
  },
  Int8: {
    format: gt.R8I,
    dataFormat: gt.RED_INTEGER,
    type: gt.BYTE,
    max: 2 ** (8 - 1) - 1,
    sampler: "isampler2D"
  },
  Int16: {
    format: gt.R16I,
    dataFormat: gt.RED_INTEGER,
    type: gt.SHORT,
    max: 2 ** (16 - 1) - 1,
    sampler: "isampler2D"
  },
  Int32: {
    format: gt.R32I,
    dataFormat: gt.RED_INTEGER,
    type: gt.INT,
    max: 2 ** (32 - 1) - 1,
    sampler: "isampler2D"
  },
  Float64: {
    format: gt.R32F,
    dataFormat: gt.RED,
    type: gt.FLOAT,
    max: 3.4 * 10 ** 38,
    sampler: "sampler2D",
    cast: (t) => new Float32Array(t)
  }
};
var Ife = /* @__PURE__ */ ((t) => (t.MAX_INTENSITY_PROJECTION = "Maximum Intensity Projection", t.MIN_INTENSITY_PROJECTION = "Minimum Intensity Projection", t.ADDITIVE = "Additive", t))(Ife || {});
const lKe = `vec4 apply_transparent_color(vec3 color, vec3 transparentColor, bool useTransparentColor, float opacity){
  return vec4(color, (color == transparentColor && useTransparentColor) ? 0. : opacity);
}
`, KHn = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(1,1,1,0);
  const float e1 = 1.0;
  const vec4 v1 = vec4(1,1,1,1);
  float a0 = smoothstep(e0,e1,x);
  return mix(v0,v1,a0)*step(e0,x)*step(x,e1);
}
`, WHn = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(1,0,0,1);
  const float e1 = 1.0;
  const vec4 v1 = vec4(1,1,0,1);
  float a0 = smoothstep(e0,e1,x);
  return mix(v0,v1,a0)*step(e0,x)*step(x,e1);
}
`, XHn = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.1568627450980392,0.10196078431372549,0.17254901960784313,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.23137254901960785,0.19215686274509805,0.35294117647058826,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.25098039215686274,0.2980392156862745,0.5450980392156862,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.24705882352941178,0.43137254901960786,0.592156862745098,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.2823529411764706,0.5568627450980392,0.6196078431372549,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.3333333333333333,0.6823529411764706,0.6392156862745098,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.47058823529411764,0.807843137254902,0.6392156862745098,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.7333333333333333,0.9019607843137255,0.6745098039215687,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9921568627450981,0.996078431372549,0.8,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, ZHn = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0,1);
  const float e1 = 0.2;
  const vec4 v1 = vec4(0.9019607843137255,0,0,1);
  const float e2 = 0.4;
  const vec4 v2 = vec4(0.9019607843137255,0.8235294117647058,0,1);
  const float e3 = 0.7;
  const vec4 v3 = vec4(1,1,1,1);
  const float e4 = 1.0;
  const vec4 v4 = vec4(0.6274509803921569,0.7843137254901961,1,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),mix(v3,v4,a3)*step(e3,x)*step(x,e4)
  )));
}
`, e9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,1,1);
  const float e1 = 1.0;
  const vec4 v1 = vec4(1,0,0,1);
  float a0 = smoothstep(e0,e1,x);
  return mix(v0,v1,a0)*step(e0,x)*step(x,e1);
}
`, t9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0,1);
  const float e1 = 0.376;
  const vec4 v1 = vec4(0.32941176470588235,0.32941176470588235,0.4549019607843137,1);
  const float e2 = 0.753;
  const vec4 v2 = vec4(0.6627450980392157,0.7843137254901961,0.7843137254901961,1);
  const float e3 = 1.0;
  const vec4 v3 = vec4(1,1,1,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),mix(v2,v3,a2)*step(e2,x)*step(x,e3)
  ));
}
`, n9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.1843137254901961,0.058823529411764705,0.24313725490196078,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.3411764705882353,0.09019607843137255,0.33725490196078434,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.5098039215686274,0.10980392156862745,0.38823529411764707,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.6705882352941176,0.1607843137254902,0.3764705882352941,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.807843137254902,0.2627450980392157,0.33725490196078434,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.9019607843137255,0.41568627450980394,0.32941176470588235,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.9490196078431372,0.5843137254901961,0.403921568627451,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.9764705882352941,0.7568627450980392,0.5294117647058824,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.996078431372549,0.9294117647058824,0.6901960784313725,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, r9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.07058823529411765,0.1411764705882353,0.0784313725490196,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.09803921568627451,0.24705882352941178,0.1607843137254902,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.09411764705882353,0.3568627450980392,0.23137254901960785,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.050980392156862744,0.4666666666666667,0.2823529411764706,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.07058823529411765,0.5803921568627451,0.3137254901960784,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.3137254901960784,0.6784313725490196,0.34901960784313724,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.5176470588235295,0.7686274509803922,0.47843137254901963,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.6862745098039216,0.8666666666666667,0.6352941176470588,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.8431372549019608,0.9764705882352941,0.8156862745098039,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, i9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.49019607843137253,0,0.7019607843137254,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.4549019607843137,0,0.8549019607843137,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.3843137254901961,0.2901960784313726,0.9294117647058824,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.26666666666666666,0.5725490196078431,0.9058823529411765,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0,0.8,0.7725490196078432,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0,0.9686274509803922,0.5725490196078431,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0,1,0.34509803921568627,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.1568627450980392,1,0.03137254901960784,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.5764705882352941,1,0,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, o9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0,1);
  const float e1 = 0.804;
  const vec4 v1 = vec4(1,0.6274509803921569,0.4,1);
  const float e2 = 1.0;
  const vec4 v2 = vec4(1,0.7803921568627451,0.4980392156862745,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),mix(v1,v2,a1)*step(e1,x)*step(x,e2)
  );
}
`, s9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0,1);
  const float e1 = 0.07;
  const vec4 v1 = vec4(0.08627450980392157,0.0196078431372549,0.23137254901960785,1);
  const float e2 = 0.13;
  const vec4 v2 = vec4(0.23529411764705882,0.01568627450980392,0.4117647058823529,1);
  const float e3 = 0.2;
  const vec4 v3 = vec4(0.42745098039215684,0.00392156862745098,0.5294117647058824,1);
  const float e4 = 0.27;
  const vec4 v4 = vec4(0.6313725490196078,0,0.5764705882352941,1);
  const float e5 = 0.33;
  const vec4 v5 = vec4(0.8235294117647058,0.00784313725490196,0.5568627450980392,1);
  const float e6 = 0.4;
  const vec4 v6 = vec4(0.984313725490196,0.043137254901960784,0.4823529411764706,1);
  const float e7 = 0.47;
  const vec4 v7 = vec4(1,0.11372549019607843,0.3803921568627451,1);
  const float e8 = 0.53;
  const vec4 v8 = vec4(1,0.21176470588235294,0.27058823529411763,1);
  const float e9 = 0.6;
  const vec4 v9 = vec4(1,0.3333333333333333,0.1803921568627451,1);
  const float e10 = 0.67;
  const vec4 v10 = vec4(1,0.47058823529411764,0.13333333333333333,1);
  const float e11 = 0.73;
  const vec4 v11 = vec4(1,0.615686274509804,0.1450980392156863,1);
  const float e12 = 0.8;
  const vec4 v12 = vec4(0.9450980392156862,0.7490196078431373,0.2235294117647059,1);
  const float e13 = 0.87;
  const vec4 v13 = vec4(0.8784313725490196,0.8627450980392157,0.36470588235294116,1);
  const float e14 = 0.93;
  const vec4 v14 = vec4(0.8549019607843137,0.9450980392156862,0.5568627450980392,1);
  const float e15 = 1.0;
  const vec4 v15 = vec4(0.8901960784313725,0.9921568627450981,0.7764705882352941,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  float a8 = smoothstep(e8,e9,x);
  float a9 = smoothstep(e9,e10,x);
  float a10 = smoothstep(e10,e11,x);
  float a11 = smoothstep(e11,e12,x);
  float a12 = smoothstep(e12,e13,x);
  float a13 = smoothstep(e13,e14,x);
  float a14 = smoothstep(e14,e15,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),
    max(mix(v7,v8,a7)*step(e7,x)*step(x,e8),
    max(mix(v8,v9,a8)*step(e8,x)*step(x,e9),
    max(mix(v9,v10,a9)*step(e9,x)*step(x,e10),
    max(mix(v10,v11,a10)*step(e10,x)*step(x,e11),
    max(mix(v11,v12,a11)*step(e11,x)*step(x,e12),
    max(mix(v12,v13,a12)*step(e12,x)*step(x,e13),
    max(mix(v13,v14,a13)*step(e13,x)*step(x,e14),mix(v14,v15,a14)*step(e14,x)*step(x,e15)
  ))))))))))))));
}
`, a9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.21176470588235294,0.054901960784313725,0.1411764705882353,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.34901960784313724,0.09019607843137255,0.3137254901960784,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.43137254901960786,0.17647058823529413,0.5176470588235295,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.47058823529411764,0.30196078431372547,0.6980392156862745,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.47058823529411764,0.44313725490196076,0.8352941176470589,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.45098039215686275,0.592156862745098,0.8941176470588236,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.5254901960784314,0.7254901960784313,0.8901960784313725,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.6941176470588235,0.8392156862745098,0.8901960784313725,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9019607843137255,0.9450980392156862,0.9450980392156862,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, A9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0.5098039215686274,1);
  const float e1 = 0.1;
  const vec4 v1 = vec4(0,0.7058823529411765,0.7058823529411765,1);
  const float e2 = 0.2;
  const vec4 v2 = vec4(0.1568627450980392,0.8235294117647058,0.1568627450980392,1);
  const float e3 = 0.4;
  const vec4 v3 = vec4(0.9019607843137255,0.9019607843137255,0.19607843137254902,1);
  const float e4 = 0.6;
  const vec4 v4 = vec4(0.47058823529411764,0.27450980392156865,0.0784313725490196,1);
  const float e5 = 1.0;
  const vec4 v5 = vec4(1,1,1,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),mix(v4,v5,a4)*step(e4,x)*step(x,e5)
  ))));
}
`, l9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0,1);
  const float e1 = 0.15;
  const vec4 v1 = vec4(0.11764705882352941,0,0.39215686274509803,1);
  const float e2 = 0.4;
  const vec4 v2 = vec4(0.47058823529411764,0,0.39215686274509803,1);
  const float e3 = 0.6;
  const vec4 v3 = vec4(0.6274509803921569,0.35294117647058826,0,1);
  const float e4 = 0.8;
  const vec4 v4 = vec4(0.9019607843137255,0.7843137254901961,0,1);
  const float e5 = 1.0;
  const vec4 v5 = vec4(1,0.9803921568627451,0.8627450980392157,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),mix(v4,v5,a4)*step(e4,x)*step(x,e5)
  ))));
}
`, c9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.11764705882352941,0.01568627450980392,0.43137254901960786,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.1843137254901961,0.054901960784313725,0.6901960784313725,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.1607843137254902,0.17647058823529413,0.9254901960784314,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.09803921568627451,0.38823529411764707,0.8313725490196079,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.26666666666666666,0.5137254901960784,0.7843137254901961,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.4470588235294118,0.611764705882353,0.7725490196078432,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.615686274509804,0.7098039215686275,0.796078431372549,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.7843137254901961,0.8156862745098039,0.8470588235294118,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9450980392156862,0.9294117647058824,0.9254901960784314,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, u9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.23529411764705882,0.03529411764705882,0.07058823529411765,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.39215686274509803,0.06666666666666667,0.10588235294117647,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.5568627450980392,0.0784313725490196,0.11372549019607843,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.6941176470588235,0.16862745098039217,0.10588235294117647,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.7529411764705882,0.3411764705882353,0.24705882352941178,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.803921568627451,0.49019607843137253,0.4117647058823529,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.8470588235294118,0.6352941176470588,0.5803921568627451,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.8901960784313725,0.7803921568627451,0.7568627450980392,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9450980392156862,0.9294117647058824,0.9254901960784314,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, f9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0.26666666666666666,0.10588235294117647,1);
  const float e1 = 0.125;
  const vec4 v1 = vec4(0,0.42745098039215684,0.17254901960784313,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.13725490196078433,0.5450980392156862,0.27058823529411763,1);
  const float e3 = 0.375;
  const vec4 v3 = vec4(0.2549019607843137,0.6705882352941176,0.36470588235294116,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.4549019607843137,0.7686274509803922,0.4627450980392157,1);
  const float e5 = 0.625;
  const vec4 v5 = vec4(0.6313725490196078,0.8509803921568627,0.6078431372549019,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.7803921568627451,0.9137254901960784,0.7529411764705882,1);
  const float e7 = 0.875;
  const vec4 v7 = vec4(0.8980392156862745,0.9607843137254902,0.8784313725490196,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9686274509803922,0.9882352941176471,0.9607843137254902,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, g9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0,1);
  const float e1 = 1.0;
  const vec4 v1 = vec4(1,1,1,1);
  float a0 = smoothstep(e0,e1,x);
  return mix(v0,v1,a0)*step(e0,x)*step(x,e1);
}
`, h9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0,1);
  const float e1 = 0.3;
  const vec4 v1 = vec4(0.9019607843137255,0,0,1);
  const float e2 = 0.6;
  const vec4 v2 = vec4(1,0.8235294117647058,0,1);
  const float e3 = 1.0;
  const vec4 v3 = vec4(1,1,1,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),mix(v2,v3,a2)*step(e2,x)*step(x,e3)
  ));
}
`, d9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(1,0,0,1);
  const float e1 = 0.169;
  const vec4 v1 = vec4(0.9921568627450981,1,0.00784313725490196,1);
  const float e2 = 0.173;
  const vec4 v2 = vec4(0.9686274509803922,1,0.00784313725490196,1);
  const float e3 = 0.337;
  const vec4 v3 = vec4(0,0.9882352941176471,0.01568627450980392,1);
  const float e4 = 0.341;
  const vec4 v4 = vec4(0,0.9882352941176471,0.0392156862745098,1);
  const float e5 = 0.506;
  const vec4 v5 = vec4(0.00392156862745098,0.9764705882352941,1,1);
  const float e6 = 0.671;
  const vec4 v6 = vec4(0.00784313725490196,0,0.9921568627450981,1);
  const float e7 = 0.675;
  const vec4 v7 = vec4(0.03137254901960784,0,0.9921568627450981,1);
  const float e8 = 0.839;
  const vec4 v8 = vec4(1,0,0.984313725490196,1);
  const float e9 = 0.843;
  const vec4 v9 = vec4(1,0,0.9607843137254902,1);
  const float e10 = 1.0;
  const vec4 v10 = vec4(1,0,0.023529411764705882,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  float a8 = smoothstep(e8,e9,x);
  float a9 = smoothstep(e9,e10,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),
    max(mix(v7,v8,a7)*step(e7,x)*step(x,e8),
    max(mix(v8,v9,a8)*step(e8,x)*step(x,e9),mix(v9,v10,a9)*step(e9,x)*step(x,e10)
  )))))))));
}
`, p9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0.01568627450980392,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.12156862745098039,0.047058823529411764,0.2823529411764706,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.3333333333333333,0.058823529411764705,0.42745098039215684,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.5333333333333333,0.13333333333333333,0.41568627450980394,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.7294117647058823,0.21176470588235294,0.3333333333333333,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.8901960784313725,0.34901960784313724,0.2,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.9764705882352941,0.5490196078431373,0.0392156862745098,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.9764705882352941,0.788235294117647,0.19607843137254902,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9882352941176471,1,0.6431372549019608,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, I9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0.5137254901960784,1);
  const float e1 = 0.125;
  const vec4 v1 = vec4(0,0.23529411764705882,0.6666666666666666,1);
  const float e2 = 0.375;
  const vec4 v2 = vec4(0.0196078431372549,1,1,1);
  const float e3 = 0.625;
  const vec4 v3 = vec4(1,1,0,1);
  const float e4 = 0.875;
  const vec4 v4 = vec4(0.9803921568627451,0,0,1);
  const float e5 = 1.0;
  const vec4 v5 = vec4(0.5019607843137255,0,0,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),mix(v4,v5,a4)*step(e4,x)*step(x,e5)
  ))));
}
`, m9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,0.01568627450980392,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.10980392156862745,0.06274509803921569,0.26666666666666666,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.30980392156862746,0.07058823529411765,0.4823529411764706,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.5058823529411764,0.1450980392156863,0.5058823529411764,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.7098039215686275,0.21176470588235294,0.47843137254901963,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.8980392156862745,0.3137254901960784,0.39215686274509803,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.984313725490196,0.5294117647058824,0.3803921568627451,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.996078431372549,0.7607843137254902,0.5294117647058824,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9882352941176471,0.9921568627450981,0.7490196078431373,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, C9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.25098039215686274,0.0196078431372549,0.0196078431372549,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.41568627450980394,0.023529411764705882,0.058823529411764705,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.5647058823529412,0.10196078431372549,0.027450980392156862,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.6588235294117647,0.25098039215686274,0.011764705882352941,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.7372549019607844,0.39215686274509803,0.01568627450980392,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.807843137254902,0.5333333333333333,0.043137254901960784,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.8627450980392157,0.6823529411764706,0.09803921568627451,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.9058823529411765,0.8431372549019608,0.17254901960784313,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9725490196078431,0.996078431372549,0.4117647058823529,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, E9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.2,0.0784313725490196,0.09411764705882353,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.35294117647058826,0.12549019607843137,0.13725490196078433,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.5058823529411764,0.17254901960784313,0.13333333333333333,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.6235294117647059,0.26666666666666666,0.09803921568627451,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.7137254901960784,0.38823529411764707,0.07450980392156863,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.7803921568627451,0.5254901960784314,0.08627450980392157,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.8313725490196079,0.6705882352941176,0.13725490196078433,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.8666666666666667,0.8235294117647058,0.21176470588235294,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.8823529411764706,0.9921568627450981,0.29411764705882354,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, y9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.5686274509803921,0.4117647058823529,0.07058823529411765,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.7215686274509804,0.2784313725490196,0.14901960784313725,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.7294117647058823,0.22745098039215686,0.45098039215686275,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.6274509803921569,0.2784313725490196,0.7254901960784313,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.43137254901960786,0.3803921568627451,0.8549019607843137,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.19607843137254902,0.4823529411764706,0.6431372549019608,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.12156862745098039,0.5137254901960784,0.43137254901960786,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.30196078431372547,0.5058823529411764,0.13333333333333333,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.5686274509803921,0.4117647058823529,0.07058823529411765,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, v9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,1,1);
  const float e1 = 0.1;
  const vec4 v1 = vec4(0.2,0.6,1,1);
  const float e2 = 0.2;
  const vec4 v2 = vec4(0.4,0.8,1,1);
  const float e3 = 0.3;
  const vec4 v3 = vec4(0.6,0.8,1,1);
  const float e4 = 0.4;
  const vec4 v4 = vec4(0.8,0.8,1,1);
  const float e5 = 0.5;
  const vec4 v5 = vec4(1,1,1,1);
  const float e6 = 0.6;
  const vec4 v6 = vec4(1,0.8,1,1);
  const float e7 = 0.7;
  const vec4 v7 = vec4(1,0.6,1,1);
  const float e8 = 0.8;
  const vec4 v8 = vec4(1,0.4,0.8,1);
  const float e9 = 0.9;
  const vec4 v9 = vec4(1,0.4,0.4,1);
  const float e10 = 1.0;
  const vec4 v10 = vec4(1,0,0,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  float a8 = smoothstep(e8,e9,x);
  float a9 = smoothstep(e9,e10,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),
    max(mix(v7,v8,a7)*step(e7,x)*step(x,e8),
    max(mix(v8,v9,a8)*step(e8,x)*step(x,e9),mix(v9,v10,a9)*step(e9,x)*step(x,e10)
  )))))))));
}
`, B9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.050980392156862744,0.03137254901960784,0.5294117647058824,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.29411764705882354,0.011764705882352941,0.6313725490196078,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.49019607843137253,0.011764705882352941,0.6588235294117647,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.6588235294117647,0.13333333333333333,0.5882352941176471,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.796078431372549,0.27450980392156865,0.4745098039215686,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.8980392156862745,0.4196078431372549,0.36470588235294116,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.9725490196078431,0.5803921568627451,0.2549019607843137,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.9921568627450981,0.7647058823529411,0.1568627450980392,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9411764705882353,0.9764705882352941,0.12941176470588237,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, b9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.047058823529411764,0.2,0.5137254901960784,1);
  const float e1 = 0.25;
  const vec4 v1 = vec4(0.0392156862745098,0.5333333333333333,0.7294117647058823,1);
  const float e2 = 0.5;
  const vec4 v2 = vec4(0.9490196078431372,0.8274509803921568,0.2196078431372549,1);
  const float e3 = 0.75;
  const vec4 v3 = vec4(0.9490196078431372,0.5607843137254902,0.2196078431372549,1);
  const float e4 = 1.0;
  const vec4 v4 = vec4(0.8509803921568627,0.11764705882352941,0.11764705882352941,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),mix(v3,v4,a3)*step(e3,x)*step(x,e4)
  )));
}
`, _9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.49019607843137253,0,0.7019607843137254,1);
  const float e1 = 0.1;
  const vec4 v1 = vec4(0.7803921568627451,0,0.7058823529411765,1);
  const float e2 = 0.2;
  const vec4 v2 = vec4(1,0,0.4745098039215686,1);
  const float e3 = 0.3;
  const vec4 v3 = vec4(1,0.4235294117647059,0,1);
  const float e4 = 0.4;
  const vec4 v4 = vec4(0.8705882352941177,0.7607843137254902,0,1);
  const float e5 = 0.5;
  const vec4 v5 = vec4(0.5882352941176471,1,0,1);
  const float e6 = 0.6;
  const vec4 v6 = vec4(0,1,0.21568627450980393,1);
  const float e7 = 0.7;
  const vec4 v7 = vec4(0,0.9647058823529412,0.5882352941176471,1);
  const float e8 = 0.8;
  const vec4 v8 = vec4(0.19607843137254902,0.6549019607843137,0.8705882352941177,1);
  const float e9 = 0.9;
  const vec4 v9 = vec4(0.403921568627451,0.2,0.9215686274509803,1);
  const float e10 = 1.0;
  const vec4 v10 = vec4(0.48627450980392156,0,0.7294117647058823,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  float a8 = smoothstep(e8,e9,x);
  float a9 = smoothstep(e9,e10,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),
    max(mix(v7,v8,a7)*step(e7,x)*step(x,e8),
    max(mix(v8,v9,a8)*step(e8,x)*step(x,e9),mix(v9,v10,a9)*step(e9,x)*step(x,e10)
  )))))))));
}
`, S9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.5882352941176471,0,0.35294117647058826,1);
  const float e1 = 0.125;
  const vec4 v1 = vec4(0,0,0.7843137254901961,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0,0.09803921568627451,1,1);
  const float e3 = 0.375;
  const vec4 v3 = vec4(0,0.596078431372549,1,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.17254901960784313,1,0.5882352941176471,1);
  const float e5 = 0.625;
  const vec4 v5 = vec4(0.592156862745098,1,0,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(1,0.9176470588235294,0,1);
  const float e7 = 0.875;
  const vec4 v7 = vec4(1,0.43529411764705883,0,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(1,0,0,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, Q9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.0196078431372549,0.0392156862745098,0.6745098039215687,1);
  const float e1 = 0.35;
  const vec4 v1 = vec4(0.41568627450980394,0.5372549019607843,0.9686274509803922,1);
  const float e2 = 0.5;
  const vec4 v2 = vec4(0.7450980392156863,0.7450980392156863,0.7450980392156863,1);
  const float e3 = 0.6;
  const vec4 v3 = vec4(0.8627450980392157,0.6666666666666666,0.5176470588235295,1);
  const float e4 = 0.7;
  const vec4 v4 = vec4(0.9019607843137255,0.5686274509803921,0.35294117647058826,1);
  const float e5 = 1.0;
  const vec4 v5 = vec4(0.6980392156862745,0.0392156862745098,0.10980392156862745,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),mix(v4,v5,a4)*step(e4,x)*step(x,e5)
  ))));
}
`, w9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.16470588235294117,0.09411764705882353,0.4235294117647059,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.12941176470588237,0.19607843137254902,0.6352941176470588,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.058823529411764705,0.35294117647058826,0.5686274509803921,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.1568627450980392,0.4627450980392157,0.5372549019607843,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.23137254901960785,0.5725490196078431,0.5294117647058824,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.30980392156862746,0.6862745098039216,0.49411764705882355,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.47058823529411764,0.796078431372549,0.40784313725490196,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.7568627450980392,0.8666666666666667,0.39215686274509803,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9921568627450981,0.9372549019607843,0.6039215686274509,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, x9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(1,0,1,1);
  const float e1 = 1.0;
  const vec4 v1 = vec4(1,1,0,1);
  float a0 = smoothstep(e0,e1,x);
  return mix(v0,v1,a0)*step(e0,x)*step(x,e1);
}
`, R9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0.5019607843137255,0.4,1);
  const float e1 = 1.0;
  const vec4 v1 = vec4(1,1,0.4,1);
  float a0 = smoothstep(e0,e1,x);
  return mix(v0,v1,a0)*step(e0,x)*step(x,e1);
}
`, D9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.01568627450980392,0.13725490196078433,0.2,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.09019607843137255,0.2,0.47843137254901963,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.3333333333333333,0.23137254901960785,0.615686274509804,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.5058823529411764,0.30980392156862746,0.5607843137254902,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.6862745098039216,0.37254901960784315,0.5098039215686274,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.8705882352941177,0.4392156862745098,0.396078431372549,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.9764705882352941,0.5725490196078431,0.25882352941176473,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.9764705882352941,0.7686274509803922,0.2549019607843137,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9098039215686274,0.9803921568627451,0.3568627450980392,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, T9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.13333333333333333,0.12156862745098039,0.10588235294117647,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.2549019607843137,0.19607843137254902,0.1607843137254902,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.3843137254901961,0.27058823529411763,0.20392156862745098,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.5137254901960784,0.34901960784313724,0.2235294117647059,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.6313725490196078,0.4392156862745098,0.23137254901960785,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.7254901960784313,0.5490196078431373,0.25882352941176473,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.792156862745098,0.6823529411764706,0.34509803921568627,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.8470588235294118,0.8196078431372549,0.49411764705882355,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9137254901960784,0.9647058823529412,0.6705882352941176,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, N9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.06666666666666667,0.12549019607843137,0.25098039215686274,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.13725490196078433,0.20392156862745098,0.4549019607843137,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.11372549019607843,0.3176470588235294,0.611764705882353,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.12156862745098039,0.44313725490196076,0.6352941176470588,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.19607843137254902,0.5647058823529412,0.6627450980392157,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.3411764705882353,0.6784313725490196,0.6901960784313725,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.5843137254901961,0.7686274509803922,0.7411764705882353,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.796078431372549,0.8666666666666667,0.8274509803921568,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.996078431372549,0.984313725490196,0.9019607843137255,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, L9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.09019607843137255,0.13725490196078433,0.07450980392156863,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.09411764705882353,0.25098039215686274,0.14901960784313725,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.043137254901960784,0.37254901960784315,0.17647058823529413,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.15294117647058825,0.4823529411764706,0.13725490196078433,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.37254901960784315,0.5725490196078431,0.047058823529411764,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.596078431372549,0.6470588235294118,0.07058823529411765,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.788235294117647,0.7294117647058823,0.27058823529411763,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.9137254901960784,0.8470588235294118,0.5372549019607843,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(1,0.9921568627450981,0.803921568627451,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, M9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.26666666666666666,0.00392156862745098,0.32941176470588235,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.2784313725490196,0.17254901960784313,0.47843137254901963,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.23137254901960785,0.3176470588235294,0.5450980392156862,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(0.17254901960784313,0.44313725490196076,0.5568627450980392,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.12941176470588237,0.5647058823529412,0.5529411764705883,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(0.15294117647058825,0.6784313725490196,0.5058823529411764,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.3607843137254902,0.7843137254901961,0.38823529411764707,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.6666666666666666,0.8627450980392157,0.19607843137254902,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.9921568627450981,0.9058823529411765,0.1450980392156863,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, O9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.49019607843137253,0,0.7019607843137254,1);
  const float e1 = 0.13;
  const vec4 v1 = vec4(0.6745098039215687,0,0.7333333333333333,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.8588235294117647,0,0.6666666666666666,1);
  const float e3 = 0.38;
  const vec4 v3 = vec4(1,0,0.5098039215686274,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(1,0.24705882352941178,0.2901960784313726,1);
  const float e5 = 0.63;
  const vec4 v5 = vec4(1,0.4823529411764706,0,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.9176470588235294,0.6901960784313725,0,1);
  const float e7 = 0.88;
  const vec4 v7 = vec4(0.7450980392156863,0.8941176470588236,0,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(0.5764705882352941,1,0,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, F9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0,0,1,1);
  const float e1 = 1.0;
  const vec4 v1 = vec4(0,1,0.5019607843137255,1);
  float a0 = smoothstep(e0,e1,x);
  return mix(v0,v1,a0)*step(e0,x)*step(x,e1);
}
`, P9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.03137254901960784,0.11372549019607843,0.34509803921568627,1);
  const float e1 = 0.125;
  const vec4 v1 = vec4(0.1450980392156863,0.20392156862745098,0.5803921568627451,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.13333333333333333,0.3686274509803922,0.6588235294117647,1);
  const float e3 = 0.375;
  const vec4 v3 = vec4(0.11372549019607843,0.5686274509803921,0.7529411764705882,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.2549019607843137,0.7137254901960784,0.7686274509803922,1);
  const float e5 = 0.625;
  const vec4 v5 = vec4(0.4980392156862745,0.803921568627451,0.7333333333333333,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.7803921568627451,0.9137254901960784,0.7058823529411765,1);
  const float e7 = 0.875;
  const vec4 v7 = vec4(0.9294117647058824,0.9725490196078431,0.8509803921568627,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(1,1,0.8509803921568627,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, k9n = `vec4 apply_cmap (float x) {
  const float e0 = 0.0;
  const vec4 v0 = vec4(0.5019607843137255,0,0.14901960784313725,1);
  const float e1 = 0.125;
  const vec4 v1 = vec4(0.7411764705882353,0,0.14901960784313725,1);
  const float e2 = 0.25;
  const vec4 v2 = vec4(0.8901960784313725,0.10196078431372549,0.10980392156862745,1);
  const float e3 = 0.375;
  const vec4 v3 = vec4(0.9882352941176471,0.3058823529411765,0.16470588235294117,1);
  const float e4 = 0.5;
  const vec4 v4 = vec4(0.9921568627450981,0.5529411764705883,0.23529411764705882,1);
  const float e5 = 0.625;
  const vec4 v5 = vec4(0.996078431372549,0.6980392156862745,0.2980392156862745,1);
  const float e6 = 0.75;
  const vec4 v6 = vec4(0.996078431372549,0.8509803921568627,0.4627450980392157,1);
  const float e7 = 0.875;
  const vec4 v7 = vec4(1,0.9294117647058824,0.6274509803921569,1);
  const float e8 = 1.0;
  const vec4 v8 = vec4(1,1,0.8,1);
  float a0 = smoothstep(e0,e1,x);
  float a1 = smoothstep(e1,e2,x);
  float a2 = smoothstep(e2,e3,x);
  float a3 = smoothstep(e3,e4,x);
  float a4 = smoothstep(e4,e5,x);
  float a5 = smoothstep(e5,e6,x);
  float a6 = smoothstep(e6,e7,x);
  float a7 = smoothstep(e7,e8,x);
  return max(mix(v0,v1,a0)*step(e0,x)*step(x,e1),
    max(mix(v1,v2,a1)*step(e1,x)*step(x,e2),
    max(mix(v2,v3,a2)*step(e2,x)*step(x,e3),
    max(mix(v3,v4,a3)*step(e3,x)*step(x,e4),
    max(mix(v4,v5,a4)*step(e4,x)*step(x,e5),
    max(mix(v5,v6,a5)*step(e5,x)*step(x,e6),
    max(mix(v6,v7,a6)*step(e6,x)*step(x,e7),mix(v7,v8,a7)*step(e7,x)*step(x,e8)
  )))))));
}
`, cKe = {
  __proto__: null,
  alpha: KHn,
  autumn: WHn,
  bathymetry: XHn,
  blackbody: ZHn,
  bluered: e9n,
  bone: t9n,
  cdom: n9n,
  chlorophyll: r9n,
  cool: i9n,
  copper: o9n,
  cubehelix: s9n,
  density: a9n,
  earth: A9n,
  electric: l9n,
  freesurface_blue: c9n,
  freesurface_red: u9n,
  greens: f9n,
  greys: g9n,
  hot: h9n,
  hsv: d9n,
  inferno: p9n,
  jet: I9n,
  magma: m9n,
  oxygen: C9n,
  par: E9n,
  phase: y9n,
  picnic: v9n,
  plasma: B9n,
  portland: b9n,
  rainbow_soft: _9n,
  rainbow: S9n,
  rdbu: Q9n,
  salinity: w9n,
  spring: x9n,
  summer: R9n,
  temperature: D9n,
  turbidity: T9n,
  velocity_blue: N9n,
  velocity_green: L9n,
  viridis: M9n,
  warm: O9n,
  winter: F9n,
  yignbu: P9n,
  yiorrd: k9n
};
function G9n(t, e) {
  return {
    name: `additive-colormap-${t}`,
    fs: `uniform float opacity;
uniform bool useTransparentColor;

${lKe}
${e}

vec4 colormap(float intensity) {
  return vec4(apply_transparent_color(apply_cmap(min(1.,intensity)).xyz, apply_cmap(0.).xyz, useTransparentColor, opacity));
}`,
    inject: {
      "fs:DECKGL_MUTATE_COLOR": `  float intensityCombo = 0.;
  intensityCombo += max(0.,intensity0);
  intensityCombo += max(0.,intensity1);
  intensityCombo += max(0.,intensity2);
  intensityCombo += max(0.,intensity3);
  intensityCombo += max(0.,intensity4);
  intensityCombo += max(0.,intensity5);
  rgba = colormap(intensityCombo);`
    }
  };
}
const HG = {
  colormap: { type: "string", value: "viridis", compare: !0 },
  opacity: { type: "number", value: 1, compare: !0 },
  useTransparentColor: { type: "boolean", value: !1, compare: !0 }
}, xq = class extends l0 {
  getShaders() {
    const t = this?.props?.colormap || HG.colormap.value, e = cKe[t];
    if (!e)
      throw Error(`No colormap named ${t} found in registry`);
    return { modules: [G9n(t, e)] };
  }
  updateState({ props: t, oldProps: e, changeFlags: n, ...r }) {
    if (super.updateState({ props: t, oldProps: e, changeFlags: n, ...r }), t.colormap !== e.colormap) {
      const { gl: i } = this.context;
      this.state.model && (this.state.model.delete(), this.setState({ model: this._getModel(i) }));
    }
  }
  draw() {
    const {
      useTransparentColor: t = HG.useTransparentColor.value,
      opacity: e = HG.opacity.value
    } = this.props, n = {
      opacity: e,
      useTransparentColor: t
    };
    this.state.model?.setUniforms(n);
  }
};
xq.extensionName = "AdditiveColormapExtension";
xq.defaultProps = HG;
const U9n = `uniform vec3 transparentColor;
uniform bool useTransparentColor;
uniform float opacity;

uniform vec3 colors[6];

${lKe}

void mutate_color(inout vec3 rgb, float intensity0, float intensity1, float intensity2, float intensity3, float intensity4, float intensity5) { 
  rgb += max(0.0, min(1.0, intensity0)) * vec3(colors[0]);
  rgb += max(0.0, min(1.0, intensity1)) * vec3(colors[1]);
  rgb += max(0.0, min(1.0, intensity2)) * vec3(colors[2]);
  rgb += max(0.0, min(1.0, intensity3)) * vec3(colors[3]);
  rgb += max(0.0, min(1.0, intensity4)) * vec3(colors[4]);
  rgb += max(0.0, min(1.0, intensity5)) * vec3(colors[5]);
}

vec4 apply_opacity(vec3 rgb) {
  return vec4(apply_transparent_color(rgb, transparentColor, useTransparentColor, opacity));
}
`, H9n = `vec3 rgb = rgba.rgb;
mutate_color(rgb, intensity0, intensity1, intensity2, intensity3, intensity4, intensity5);
rgba = apply_opacity(rgb);
`, $9n = {
  name: "color-palette-module",
  fs: U9n,
  inject: {
    "fs:DECKGL_MUTATE_COLOR": H9n
  }
};
function q9n(t, e, n) {
  for (let r = 0; r < n; r += 1)
    t.push(e);
  return t;
}
const QDe = [
  [0, 0, 255],
  [0, 255, 0],
  [255, 0, 255],
  [255, 255, 0],
  [255, 128, 0],
  [0, 255, 255],
  [255, 255, 255],
  [255, 0, 0]
];
function mfe(t) {
  if (t > QDe.length)
    throw new Error("Too many colors");
  return QDe.slice(0, t);
}
function Cfe({ colors: t, channelsVisible: e }) {
  const n = t.map(
    (o, s) => e[s] ? o.map((a) => a / VHn) : SDe
  ), r = wq - n.length;
  return q9n(
    n,
    SDe,
    r
  ).reduce((o, s) => o.concat(s), []);
}
const $G = {
  colors: { type: "array", value: null, compare: !0 },
  opacity: { type: "number", value: 1, compare: !0 },
  transparentColor: { type: "array", value: null, compare: !0 },
  useTransparentColor: { type: "boolean", value: !1, compare: !0 }
}, tx = class extends l0 {
  getShaders() {
    return {
      ...super.getShaders(),
      modules: [$9n]
    };
  }
  draw() {
    const {
      colors: t,
      channelsVisible: e,
      opacity: n = $G.opacity.value,
      transparentColor: r = $G.transparentColor.value,
      useTransparentColor: i = $G.useTransparentColor.value
    } = this.props, s = {
      colors: Cfe({
        channelsVisible: e || this.selections.map(() => !0),
        colors: t || mfe(this.props.selections.length)
      }),
      opacity: n,
      transparentColor: (r || [0, 0, 0]).map((a) => a / 255),
      useTransparentColor: !!i
    };
    this.state.model?.setUniforms(s);
  }
};
tx.extensionName = "ColorPaletteExtension";
tx.defaultProps = $G;
const j9n = `// lens bounds for ellipse
uniform float majorLensAxis;
uniform float minorLensAxis;
uniform vec2 lensCenter;

// lens uniforms
uniform bool lensEnabled;
uniform int lensSelection;
uniform vec3 lensBorderColor;
uniform float lensBorderRadius;

// color palette
uniform vec3 colors[6];

bool frag_in_lens_bounds(vec2 vTexCoord) {
  // Check membership in what is (not visually, but effectively) an ellipse.
  // Since the fragment space is a unit square and the real coordinates could be longer than tall,
  // to get a circle visually we have to treat the check as that of an ellipse to get the effect of a circle.

  // Check membership in ellipse.
  return pow((lensCenter.x - vTexCoord.x) / majorLensAxis, 2.) + pow((lensCenter.y - vTexCoord.y) / minorLensAxis, 2.) < (1. - lensBorderRadius);
}

bool frag_on_lens_bounds(vec2 vTexCoord) {
  // Same as the above, except this checks the boundary.

  float ellipseDistance = pow((lensCenter.x - vTexCoord.x) / majorLensAxis, 2.) + pow((lensCenter.y - vTexCoord.y) / minorLensAxis, 2.);

  // Check membership on "bourndary" of ellipse.
  return ellipseDistance <= 1. && ellipseDistance >= (1. - lensBorderRadius);
}
// Return a float for boolean arithmetic calculation.
float get_use_color_float(vec2 vTexCoord, int channelIndex) {
  bool isFragInLensBounds = frag_in_lens_bounds(vTexCoord);
  bool inLensAndUseLens = lensEnabled && isFragInLensBounds;
  return float(int((inLensAndUseLens && channelIndex == lensSelection) || (!inLensAndUseLens)));
 
}
void mutate_color(inout vec3 rgb, float intensity0, float intensity1, float intensity2, float intensity3, float intensity4, float intensity5, vec2 vTexCoord){
  float useColorValue = 0.;

  useColorValue = get_use_color_float(vTexCoord, 0);
  rgb += max(0., min(1., intensity0)) * max(vec3(colors[0]), (1. - useColorValue) * vec3(1., 1., 1.));

  useColorValue = get_use_color_float(vTexCoord, 1);
  rgb += max(0., min(1., intensity1)) * max(vec3(colors[1]), (1. - useColorValue) * vec3(1., 1., 1.));

  useColorValue = get_use_color_float(vTexCoord, 2);
  rgb += max(0., min(1., intensity2)) * max(vec3(colors[2]), (1. - useColorValue) * vec3(1., 1., 1.));

  useColorValue = get_use_color_float(vTexCoord, 3);
  rgb += max(0., min(1., intensity3)) * max(vec3(colors[3]), (1. - useColorValue) * vec3(1., 1., 1.));

  useColorValue = get_use_color_float(vTexCoord, 4);
  rgb += max(0., min(1., intensity4)) * max(vec3(colors[4]), (1. - useColorValue) * vec3(1., 1., 1.));

  useColorValue = get_use_color_float(vTexCoord, 5);
  rgb += max(0., min(1., intensity5)) * max(vec3(colors[5]), (1. - useColorValue) * vec3(1., 1., 1.));
}
`, Y9n = {
  name: "lens-module",
  fs: j9n,
  inject: {
    "fs:DECKGL_MUTATE_COLOR": `
   vec3 rgb = rgba.rgb;
   mutate_color(rgb, intensity0, intensity1, intensity2, intensity3, intensity4, intensity5, vTexCoord);
   rgba = vec4(rgb, 1.);
  `,
    "fs:#main-end": `
      bool isFragOnLensBounds = frag_on_lens_bounds(vTexCoord);
     gl_FragColor = (lensEnabled && isFragOnLensBounds) ? vec4(lensBorderColor, 1.) : gl_FragColor;
  `
  }
}, t_ = {
  lensEnabled: { type: "boolean", value: !1, compare: !0 },
  lensSelection: { type: "number", value: 0, compare: !0 },
  lensRadius: { type: "number", value: 100, compare: !0 },
  lensBorderColor: { type: "array", value: [255, 255, 255], compare: !0 },
  lensBorderRadius: { type: "number", value: 0.02, compare: !0 },
  colors: { type: "array", value: null, compare: !0 }
}, uKe = class extends l0 {
  getShaders() {
    return {
      ...super.getShaders(),
      modules: [Y9n]
    };
  }
  initializeState() {
    const t = this.getCurrentLayer();
    if (t.isComposite)
      return;
    const e = () => {
      const { viewportId: n } = t.props, { lensRadius: r = t_.lensRadius.value } = this.props;
      if (!n) {
        t.setState({ unprojectLensBounds: [0, 0, 0, 0] });
        return;
      }
      const { mousePosition: i } = t.context, o = t.context.deck.viewManager.views.filter(
        (A) => A.id === n
      )[0], s = t.context.deck.viewManager.viewState[n], a = o.makeViewport({
        ...s,
        viewState: s
      });
      if (i && a.containsPixel(i)) {
        const A = {
          x: i.x - a.x,
          y: i.y - a.y
        }, c = [
          [A.x - r, A.y],
          [A.x, A.y + r],
          [A.x + r, A.y],
          [A.x, A.y - r]
        ].map(
          (u, f) => a.unproject(u)[f % 2]
        );
        t.setState({ unprojectLensBounds: c });
      } else
        t.setState({ unprojectLensBounds: [0, 0, 0, 0] });
    };
    this.context.deck && this.context.deck.eventManager.on({
      pointermove: e,
      pointerleave: e,
      wheel: e
    }), this.setState({ onMouseMove: e, unprojectLensBounds: [0, 0, 0, 0] });
  }
  draw() {
    const { unprojectLensBounds: t = [0, 0, 0, 0] } = this.state, {
      bounds: e,
      lensEnabled: n = t_.lensEnabled.value,
      lensSelection: r = t_.lensSelection.value,
      lensBorderColor: i = t_.lensBorderColor.value,
      lensBorderRadius: o = t_.lensBorderRadius.value,
      colors: s,
      channelsVisible: a
    } = this.props, [A, l, c, u] = t, [f, h, d, I] = e, m = (A - f) / (d - f), C = (l - I) / (h - I), y = (c - f) / (d - f), v = (u - I) / (h - I), b = Cfe({
      channelsVisible: a || this.selections.map(() => !0),
      colors: s || mfe(this.props.selections.length)
    }), Q = {
      majorLensAxis: (y - m) / 2,
      minorLensAxis: (C - v) / 2,
      lensCenter: [
        (y + m) / 2,
        (C + v) / 2
      ],
      lensEnabled: n,
      lensSelection: r,
      lensBorderColor: i,
      lensBorderRadius: o,
      colors: b
    };
    this.state.model?.setUniforms(Q);
  }
  finalizeState() {
    this.context.deck && this.context.deck.eventManager.off({
      pointermove: this.state?.onMouseMove,
      pointerleave: this.state?.onMouseMove,
      wheel: this.state?.onMouseMove
    });
  }
};
uKe.extensionName = "LensExtension";
uKe.defaultProps = t_;
function z9n(t, e) {
  const n = `${e}

vec4 colormap(float intensity, float opacity) {
  return vec4(apply_cmap(min(1.,intensity)).xyz, opacity);
}`;
  return {
    name: `additive-colormap-3d-${t}`,
    fs: n
  };
}
const fKe = {
  colormap: { type: "string", value: "viridis", compare: !0 }
}, nx = class extends l0 {
  constructor(...t) {
    super(t), this.opts = this.opts || {};
  }
  getShaders() {
    const t = this?.props?.colormap || fKe.colormap.value, e = cKe[t];
    return {
      ...super.getShaders(),
      modules: [z9n(t, e)]
    };
  }
  updateState({ props: t, oldProps: e, changeFlags: n, ...r }) {
    if (super.updateState({ props: t, oldProps: e, changeFlags: n, ...r }), t.colormap !== e.colormap) {
      const { gl: i } = this.context;
      this.state.model && (this.state.model.delete(), this.setState({ model: this._getModel(i) }));
    }
  }
};
nx.extensionName = "BaseExtension";
nx.defaultProps = fKe;
const V9n = "", J9n = `  float intensityArray[6] = float[6](intensityValue0, intensityValue1, intensityValue2, intensityValue3, intensityValue4, intensityValue5);
  float total = 0.0;

  for(int i = 0; i < 6; i++) {
    total += intensityArray[i];
  }
  // Do not go past 1 in opacity/colormap value.
  total = min(total, 1.0);

  vec4 val_color = colormap(total, total);

  // Opacity correction
  val_color.a = 1.0 - pow(1.0 - val_color.a, 1.0);
  color.rgb += (1.0 - color.a) * val_color.a * val_color.rgb;
  color.a += (1.0 - color.a) * val_color.a;
  if (color.a >= 0.95) {
    break;
  }
  p += ray_dir * dt;
`, K9n = "", gKe = class extends nx {
  constructor(t) {
    super(t), this.rendering = { _BEFORE_RENDER: V9n, _RENDER: J9n, _AFTER_RENDER: K9n };
  }
};
gKe.extensionName = "AdditiveBlendExtension";
const W9n = `  float maxVals[6] = float[6](-1.0, -1.0, -1.0, -1.0, -1.0, -1.0);
`, X9n = `  float intensityArray[6] = float[6](intensityValue0, intensityValue1, intensityValue2, intensityValue3, intensityValue4, intensityValue5);

  for(int i = 0; i < 6; i++) {
    if(intensityArray[i] > maxVals[i]) {
      maxVals[i] = intensityArray[i];
    }
  }
`, Z9n = `  float total = 0.0;
  for(int i = 0; i < 6; i++) {
    total += maxVals[i];
  }
  // Do not go past 1 in opacity/colormap value.
  total = min(total, 1.0);
  color = colormap(total, total);
`, hKe = class extends nx {
  constructor(t) {
    super(t), this.rendering = { _BEFORE_RENDER: W9n, _RENDER: X9n, _AFTER_RENDER: Z9n };
  }
};
hKe.extensionName = "MaximumIntensityProjectionExtension";
const e$n = `  float minVals[6] = float[6](1. / 0., 1. / 0., 1. / 0., 1. / 0., 1. / 0., 1. / 0.);
`, t$n = `  float intensityArray[6] = float[6](intensityValue0, intensityValue1, intensityValue2, intensityValue3, intensityValue4, intensityValue5);

  for(int i = 0; i < 6; i++) {
    if(intensityArray[i] < minVals[i]) {
      minVals[i] = intensityArray[i];
    }
  }
`, n$n = `  float total = 0.0;
  for(int i = 0; i < 6; i++) {
    total += minVals[i];
  }
  // Do not go past 1 in opacity/colormap value.
  total = min(total, 1.0);
  color = colormap(total, total);
`, dKe = class extends nx {
  constructor(t) {
    super(t), this.rendering = { _BEFORE_RENDER: e$n, _RENDER: t$n, _AFTER_RENDER: n$n };
  }
};
dKe.extensionName = "MinimumIntensityProjectionExtension";
const eS = {
  BaseExtension: nx,
  AdditiveBlendExtension: gKe,
  MaximumIntensityProjectionExtension: hKe,
  MinimumIntensityProjectionExtension: dKe
}, r$n = {
  colors: { type: "array", value: null, compare: !0 }
}, rx = class extends l0 {
  constructor(...t) {
    super(t), this.opts = this.opts || {};
  }
  draw() {
    const { colors: t, channelsVisible: e } = this.props, r = {
      colors: Cfe({
        channelsVisible: e || this.selections.map(() => !0),
        colors: t || mfe(this.props.selections.length)
      })
    };
    this.state.model?.setUniforms(r);
  }
};
rx.extensionName = "BaseExtension";
rx.defaultProps = r$n;
const i$n = "", o$n = `  vec3 rgbCombo = vec3(0.0);
  vec3 hsvCombo = vec3(0.0);
  float intensityArray[6] = float[6](intensityValue0, intensityValue1, intensityValue2, intensityValue3, intensityValue4, intensityValue5);
  float total = 0.0;
  for(int i = 0; i < 6; i++) {
    float intensityValue = intensityArray[i];
    rgbCombo += max(0.0, min(1.0, intensityValue)) * colors[i];
    total += intensityValue;
  }
  // Do not go past 1 in opacity.
  total = min(total, 1.0);
  vec4 val_color = vec4(rgbCombo, total);
  // Opacity correction
  val_color.a = 1.0 - pow(1.0 - val_color.a, 1.0);
  color.rgb += (1.0 - color.a) * val_color.a * val_color.rgb;
  color.a += (1.0 - color.a) * val_color.a;
  if (color.a >= 0.95) {
    break;
  }
`, s$n = "", pKe = class extends rx {
  constructor(t) {
    super(t), this.rendering = { _BEFORE_RENDER: i$n, _RENDER: o$n, _AFTER_RENDER: s$n };
  }
};
pKe.extensionName = "AdditiveBlendExtension";
const a$n = `  float maxVals[6] = float[6](-1.0, -1.0, -1.0, -1.0, -1.0, -1.0);
`, A$n = `  float intensityArray[6] = float[6](intensityValue0, intensityValue1, intensityValue2, intensityValue3, intensityValue4, intensityValue5);

  for(int i = 0; i < 6; i++) {
    if(intensityArray[i] > maxVals[i]) {
      maxVals[i] = intensityArray[i];
    }
  }
`, l$n = `  vec3 rgbCombo = vec3(0.0);
  for(int i = 0; i < 6; i++) {
    rgbCombo += max(0.0, min(1.0, maxVals[i])) * vec3(colors[i]);
  }
  color = vec4(rgbCombo, 1.0);
`, IKe = class extends rx {
  constructor(t) {
    super(t), this.rendering = { _BEFORE_RENDER: a$n, _RENDER: A$n, _AFTER_RENDER: l$n };
  }
};
IKe.extensionName = "MaximumIntensityProjectionExtension";
const c$n = `  float minVals[6] = float[6](1. / 0., 1. / 0., 1. / 0., 1. / 0., 1. / 0., 1. / 0.);
`, u$n = `  float intensityArray[6] = float[6](intensityValue0, intensityValue1, intensityValue2, intensityValue3, intensityValue4, intensityValue5);

  for(int i = 0; i < 6; i++) {
    if(intensityArray[i] < minVals[i]) {
      minVals[i] = intensityArray[i];
    }
  }
`, f$n = `  vec3 rgbCombo = vec3(0.0);
  for(int i = 0; i < 6; i++) {
    rgbCombo += max(0.0, min(1.0, minVals[i])) * vec3(colors[i]);
  }
  color = vec4(rgbCombo, 1.0);
`, mKe = class extends rx {
  constructor(t) {
    super(t), this.rendering = { _BEFORE_RENDER: c$n, _RENDER: u$n, _AFTER_RENDER: f$n };
  }
};
mKe.extensionName = "MinimumIntensityProjectionExtension";
const TC = {
  BaseExtension: rx,
  AdditiveBlendExtension: pKe,
  MaximumIntensityProjectionExtension: IKe,
  MinimumIntensityProjectionExtension: mKe
}, g$n = `float apply_contrast_limits(float intensity, vec2 contrastLimits) {
    return  max(0., (intensity - contrastLimits[0]) / max(0.0005, (contrastLimits[1] - contrastLimits[0])));
}
`, h$n = {
  name: "channel-intensity",
  defines: {
    SAMPLER_TYPE: "usampler2D",
    COLORMAP_FUNCTION: ""
  },
  fs: g$n
};
function d$n(t) {
  return [...Array(t).keys()];
}
function CKe(t, e, n) {
  for (let r = 0; r < n; r += 1)
    t.push(e);
  return t;
}
function Efe(t) {
  const e = j8[t];
  if (!e) {
    const n = Object.keys(j8);
    throw Error(`Dtype not supported, got ${t}. Must be one of ${n}.`);
  }
  return e;
}
function EKe({
  contrastLimits: t = [],
  channelsVisible: e,
  domain: n,
  dtype: r
}) {
  const i = n && n[1] || Efe(r).max, o = t.map(
    (A, l) => e[l] ? A : [i, i]
  ), s = wq - o.length;
  if (s < 0)
    throw Error(
      `${o.lengths} channels passed in, but only 6 are allowed.`
    );
  return CKe(
    o,
    [i, i],
    s
  ).reduce((A, l) => A.concat(l), []);
}
function yKe(t) {
  const { x: e, y: n, z: r } = t?.meta?.physicalSizes ?? {};
  if (e?.size && n?.size && r?.size) {
    const i = Math.min(r.size, e.size, n.size), o = [e.size / i, n.size / i, r.size / i];
    return new pn().scale(o);
  }
  return new pn().identity();
}
function p$n(t) {
  const e = new Ig().makeViewport({
    viewState: t,
    height: t.height,
    width: t.width
  });
  return [
    e.unproject([0, 0]),
    e.unproject([e.width, 0]),
    e.unproject([e.width, e.height]),
    e.unproject([0, e.height])
  ];
}
const Y8 = [1, 2, 3, 4, 5, 10, 20, 25, 50, 100, 200, 250, 500, 1e3], I$n = Y8[0], m$n = Y8[Y8.length - 1], ure = [
  { symbol: "Y", exponent: 24 },
  { symbol: "Z", exponent: 21 },
  { symbol: "E", exponent: 18 },
  { symbol: "P", exponent: 15 },
  { symbol: "T", exponent: 12 },
  { symbol: "G", exponent: 9 },
  { symbol: "M", exponent: 6 },
  { symbol: "k", exponent: 3 },
  { symbol: "h", exponent: 2 },
  { symbol: "da", exponent: 1 },
  { symbol: "", exponent: 0 },
  { symbol: "d", exponent: -1 },
  { symbol: "c", exponent: -2 },
  { symbol: "m", exponent: -3 },
  { symbol: "µ", exponent: -6 },
  { symbol: "n", exponent: -9 },
  { symbol: "p", exponent: -12 },
  { symbol: "f", exponent: -15 },
  { symbol: "a", exponent: -18 },
  { symbol: "z", exponent: -21 },
  { symbol: "y", exponent: -24 }
];
function C$n(t, e) {
  if (!e || e === "m")
    return t;
  if (e.length > 1) {
    let n = e.substring(0, e.length - 1);
    n === "u" && (n = "µ");
    const r = ure.find((i) => i.symbol === n);
    if (r)
      return t * 10 ** r.exponent;
  }
  throw new Error("Received unknown unit");
}
function E$n(t) {
  let e = 0;
  (t < I$n || t > m$n) && (e = Math.floor(Math.log10(t)));
  let n = ure.find(
    (s) => s.exponent % 3 === 0 && s.exponent <= e
  ), r = t / 10 ** n.exponent;
  r > 500 && r <= 1e3 && (n = ure.find(
    (s) => s.exponent % 3 === 0 && s.exponent <= e + 3
  ), r = t / 10 ** n.exponent);
  const i = Y8.find((s) => s > r);
  return [i * 10 ** n.exponent, i, n.symbol];
}
const y$n = `#define SHADER_NAME xr-layer-fragment-shader

precision highp float;
precision highp int;
precision highp SAMPLER_TYPE;

// our texture
uniform SAMPLER_TYPE channel0;
uniform SAMPLER_TYPE channel1;
uniform SAMPLER_TYPE channel2;
uniform SAMPLER_TYPE channel3;
uniform SAMPLER_TYPE channel4;
uniform SAMPLER_TYPE channel5;

in vec2 vTexCoord;

// range
uniform vec2 contrastLimits[6];

void main() {

  float intensity0 = float(texture(channel0, vTexCoord).r);
  DECKGL_PROCESS_INTENSITY(intensity0, contrastLimits[0], 0);
  float intensity1 = float(texture(channel1, vTexCoord).r);
  DECKGL_PROCESS_INTENSITY(intensity1, contrastLimits[1], 1);
  float intensity2 = float(texture(channel2, vTexCoord).r);
  DECKGL_PROCESS_INTENSITY(intensity2, contrastLimits[2], 2);
  float intensity3 = float(texture(channel3, vTexCoord).r);
  DECKGL_PROCESS_INTENSITY(intensity3, contrastLimits[3], 3);
  float intensity4 = float(texture(channel4, vTexCoord).r);
  DECKGL_PROCESS_INTENSITY(intensity4, contrastLimits[4], 4);
  float intensity5 = float(texture(channel5, vTexCoord).r);
  DECKGL_PROCESS_INTENSITY(intensity5, contrastLimits[5], 5);

  DECKGL_MUTATE_COLOR(gl_FragColor, intensity0, intensity1, intensity2, intensity3, intensity4, intensity5, vTexCoord);


  geometry.uv = vTexCoord;
  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`, v$n = `#define SHADER_NAME xr-layer-vertex-shader

attribute vec2 texCoords;
attribute vec3 positions;
attribute vec3 positions64Low;
attribute vec3 instancePickingColors;
varying vec2 vTexCoord;

void main(void) {
  geometry.worldPosition = positions;
  geometry.uv = texCoords;
  geometry.pickingColor = instancePickingColors;
  gl_Position = project_position_to_clipspace(positions, positions64Low, vec3(0.), geometry.position);
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
  vTexCoord = texCoords;
  vec4 color = vec4(0.);
  DECKGL_FILTER_COLOR(color, geometry);
}
`, wDe = { fs: y$n, vs: v$n };
function B$n(t, e) {
  const n = Zv(t, no.TEXTURE_FLOAT), r = Zv(t, no.TEXTURE_FILTER_LINEAR_FLOAT);
  if (!n)
    throw new Error(
      "WebGL1 context does not support floating point textures.  Unable to display raster data."
    );
  return !r && e === gt.LINEAR ? (console.warn(
    "LINEAR filtering not supported in WebGL1 context.  Falling back to NEAREST."
  ), gt.NEAREST) : e;
}
function xDe(t, e, n) {
  if (!Fr(e))
    return {
      format: gt.LUMINANCE,
      dataFormat: gt.LUMINANCE,
      type: gt.FLOAT,
      sampler: "sampler2D",
      shaderModule: wDe,
      filter: B$n(e, n),
      cast: (a) => new Float32Array(a)
    };
  const r = n === gt.LINEAR, i = { ...wDe }, o = `#version 300 es
`;
  i.fs = o.concat(i.fs), i.vs = o.concat(i.vs);
  const s = Efe(r ? "Float32" : t);
  return {
    shaderModule: i,
    filter: n,
    cast: r ? (a) => new Float32Array(a) : (a) => a,
    ...s
  };
}
const b$n = {
  pickable: { type: "boolean", value: !0, compare: !0 },
  coordinateSystem: wn.CARTESIAN,
  channelData: { type: "object", value: {}, compare: !0 },
  bounds: { type: "array", value: [0, 0, 1, 1], compare: !0 },
  contrastLimits: { type: "array", value: [], compare: !0 },
  channelsVisible: { type: "array", value: [], compare: !0 },
  dtype: { type: "string", value: "Uint16", compare: !0 },
  interpolation: {
    type: "number",
    value: gt.NEAREST,
    compare: !0
  }
}, ix = class extends IA {
  getShaders() {
    const { dtype: t, interpolation: e } = this.props, { shaderModule: n, sampler: r } = xDe(
      t,
      this.context.gl,
      e
    ), i = this._isHookDefinedByExtensions("fs:DECKGL_PROCESS_INTENSITY"), o = { ...h$n, inject: {} };
    return i || (o.inject["fs:DECKGL_PROCESS_INTENSITY"] = `
        intensity = apply_contrast_limits(intensity, contrastLimits);
      `), super.getShaders({
      ...n,
      defines: {
        SAMPLER_TYPE: r
      },
      modules: [qA, jA, o]
    });
  }
  _isHookDefinedByExtensions(t) {
    const { extensions: e } = this.props;
    return e?.some((n) => {
      const r = n.getShaders(), { inject: i = {}, modules: o = [] } = r, s = i[t], a = o.some((A) => A?.inject[t]);
      return s || a;
    });
  }
  initializeState() {
    const { gl: t } = this.context;
    t.pixelStorei(gt.UNPACK_ALIGNMENT, 1), t.pixelStorei(gt.PACK_ALIGNMENT, 1), this.getAttributeManager().add({
      positions: {
        size: 3,
        type: gt.DOUBLE,
        fp64: this.use64bitPositions(),
        update: this.calculatePositions,
        noAlloc: !0
      }
    }), this.setState({
      numInstances: 1,
      positions: new Float64Array(12)
    });
    const n = SE.getDefaultProgramManager(t), r = "fs:DECKGL_MUTATE_COLOR(inout vec4 rgba, float intensity0, float intensity1, float intensity2, float intensity3, float intensity4, float intensity5, vec2 vTexCoord)", i = "fs:DECKGL_PROCESS_INTENSITY(inout float intensity, vec2 contrastLimits, int channelIndex)";
    n._hookFunctions.includes(r) || n.addShaderHook(r), n._hookFunctions.includes(i) || n.addShaderHook(i);
  }
  finalizeState() {
    super.finalizeState(), this.state.textures && Object.values(this.state.textures).forEach((t) => t && t.delete());
  }
  updateState({ props: t, oldProps: e, changeFlags: n, ...r }) {
    if (super.updateState({ props: t, oldProps: e, changeFlags: n, ...r }), n.extensionsChanged || t.interpolation !== e.interpolation) {
      const { gl: o } = this.context;
      this.state.model && this.state.model.delete(), this.setState({ model: this._getModel(o) }), this.getAttributeManager().invalidateAll();
    }
    (t.channelData !== e.channelData && t.channelData?.data !== e.channelData?.data || t.interpolation !== e.interpolation) && this.loadChannelTextures(t.channelData);
    const i = this.getAttributeManager();
    t.bounds !== e.bounds && i.invalidate("positions");
  }
  _getModel(t) {
    return t ? new Ta(t, {
      ...this.getShaders(),
      id: this.props.id,
      geometry: new Os({
        drawMode: gt.TRIANGLE_FAN,
        vertexCount: 4,
        attributes: {
          texCoords: new Float32Array([0, 1, 0, 0, 1, 0, 1, 1])
        }
      }),
      isInstanced: !1
    }) : null;
  }
  calculatePositions(t) {
    const { positions: e } = this.state, { bounds: n } = this.props;
    e[0] = n[0], e[1] = n[1], e[2] = 0, e[3] = n[0], e[4] = n[3], e[5] = 0, e[6] = n[2], e[7] = n[3], e[8] = 0, e[9] = n[2], e[10] = n[1], e[11] = 0, t.value = e;
  }
  draw({ uniforms: t }) {
    const { textures: e, model: n } = this.state;
    if (e && n) {
      const { contrastLimits: r, domain: i, dtype: o, channelsVisible: s } = this.props, a = Object.values(e).filter((l) => l).length, A = EKe({
        contrastLimits: r.slice(0, a),
        channelsVisible: s.slice(0, a),
        domain: i,
        dtype: o
      });
      n.setUniforms({
        ...t,
        contrastLimits: A,
        ...e
      }).draw();
    }
  }
  loadChannelTextures(t) {
    const e = {
      channel0: null,
      channel1: null,
      channel2: null,
      channel3: null,
      channel4: null,
      channel5: null
    };
    this.state.textures && Object.values(this.state.textures).forEach((n) => n && n.delete()), t && Object.keys(t).length > 0 && t.data && (t.data.forEach((n, r) => {
      e[`channel${r}`] = this.dataToTexture(
        n,
        t.width,
        t.height
      );
    }, this), this.setState({ textures: e }));
  }
  dataToTexture(t, e, n) {
    const { interpolation: r } = this.props, i = xDe(
      this.props.dtype,
      this.context.gl,
      r
    );
    return new xo(this.context.gl, {
      width: e,
      height: n,
      data: i.cast?.(t) ?? t,
      mipmaps: !1,
      parameters: {
        [gt.TEXTURE_MIN_FILTER]: i.filter,
        [gt.TEXTURE_MAG_FILTER]: i.filter,
        [gt.TEXTURE_WRAP_S]: gt.CLAMP_TO_EDGE,
        [gt.TEXTURE_WRAP_T]: gt.CLAMP_TO_EDGE
      },
      format: i.format,
      dataFormat: i.dataFormat,
      type: i.type
    });
  }
};
ix.layerName = "XRLayer";
ix.defaultProps = b$n;
const oI = {
  WhiteIsZero: 0,
  BlackIsZero: 1,
  RGB: 2,
  Palette: 3,
  TransparencyMask: 4,
  CMYK: 5,
  YCbCr: 6,
  CIELab: 8,
  ICCLab: 9
}, vKe = {
  ...em.defaultProps,
  pickable: { type: "boolean", value: !0, compare: !0 },
  coordinateSystem: wn.CARTESIAN
}, _$n = (t, e) => {
  const n = e ? "true" : "false", r = `vec3(${(e || [0, 0, 0]).map((i) => String(i / 255)).join(",")})`;
  switch (t) {
    case oI.RGB:
      return `color[3] = (${n} && (color.rgb == ${r})) ? 0.0 : color.a;`;
    case oI.WhiteIsZero:
      return `          float value = 1.0 - (color.r / 256.0);
          color = vec4(value, value, value, (${n} && vec3(value, value, value) == ${r}) ? 0.0 : color.a);
        `;
    case oI.BlackIsZero:
      return `          float value = (color.r / 256.0);
          color = vec4(value, value, value, (${n} && vec3(value, value, value) == ${r}) ? 0.0 : color.a);
        `;
    case oI.YCbCr:
      return `          float y = color[0];
          float cb = color[1];
          float cr = color[2];
          color[0] = (y + (1.40200 * (cr - .5)));
          color[1] = (y - (0.34414 * (cb - .5)) - (0.71414 * (cr - .5)));
          color[2] = (y + (1.77200 * (cb - .5)));
          color[3] = (${n} && distance(color.rgb, ${r}) < 0.01) ? 0.0 : color.a;
        `;
    default:
      return console.error(
        "Unsupported photometric interpretation or none provided.  No transformation will be done to image data"
      ), "";
  }
}, S$n = (t) => {
  switch (t) {
    case oI.RGB:
      return [0, 0, 0, 0];
    case oI.WhiteIsZero:
      return [255, 255, 255, 0];
    case oI.BlackIsZero:
      return [0, 0, 0, 0];
    case oI.YCbCr:
      return [16, 128, 128, 0];
    default:
      return console.error(
        "Unsupported photometric interpretation or none provided.  No transformation will be done to image data"
      ), [0, 0, 0, 0];
  }
};
class yfe extends em {
  _getModel(e) {
    const { photometricInterpretation: n, transparentColorInHook: r } = this.props, i = _$n(
      n,
      r
    );
    return e ? new Ta(e, {
      ...this.getShaders(),
      id: this.props.id,
      geometry: new Os({
        drawMode: gt.TRIANGLES,
        vertexCount: 6
      }),
      isInstanced: !1,
      inject: {
        "fs:DECKGL_FILTER_COLOR": i
      }
    }) : null;
  }
}
const YM = class extends mA {
  initializeState(t) {
    const { gl: e } = this.context;
    e.pixelStorei(gt.UNPACK_ALIGNMENT, 1), e.pixelStorei(gt.PACK_ALIGNMENT, 1), super.initializeState(t);
  }
  renderLayers() {
    const {
      photometricInterpretation: t,
      transparentColor: e
    } = this.props, n = S$n(t);
    return new yfe(this.props, {
      transparentColor: n,
      transparentColorInHook: e,
      id: `${this.props.id}-wrapped`
    });
  }
};
YM.layerName = "BitmapLayer";
YM.PHOTOMETRIC_INTERPRETATIONS = oI;
YM.defaultProps = {
  ...vKe,
  image: { type: "object", value: {}, compare: !0 },
  transparentColor: { type: "array", value: [0, 0, 0], compare: !0 },
  photometricInterpretation: { type: "number", value: 2, compare: !0 }
};
yfe.defaultProps = vKe;
yfe.layerName = "BitmapLayerWrapper";
function Q$n(t) {
  const {
    bbox: { left: e, top: n, right: r, bottom: i },
    index: { x: o, y: s, z: a }
  } = t.tile, { data: A, id: l, loader: c, maxZoom: u } = t;
  if ([e, i, r, n].some((m) => m < 0) || !A)
    return null;
  const f = c[0], { height: h, width: d } = h1(f), I = [
    e,
    A.height < f.tileSize ? h : i,
    A.width < f.tileSize ? d : r,
    n
  ];
  if (dB(f.shape)) {
    const { photometricInterpretation: m = 2 } = f.meta;
    return new YM(t, {
      image: A,
      photometricInterpretation: m,
      bounds: I,
      id: `tile-sub-layer-${I}-${l}`,
      tileId: { x: o, y: s, z: a },
      extensions: []
    });
  }
  return new ix(t, {
    channelData: A,
    bounds: I,
    id: `tile-sub-layer-${I}-${l}`,
    tileId: { x: o, y: s, z: a },
    interpolation: a === u ? gt.NEAREST : gt.LINEAR
  });
}
const w$n = {
  pickable: { type: "boolean", value: !0, compare: !0 },
  coordinateSystem: wn.CARTESIAN,
  contrastLimits: { type: "array", value: [], compare: !0 },
  channelsVisible: { type: "array", value: [], compare: !0 },
  renderSubLayers: { type: "function", value: Q$n, compare: !1 },
  dtype: { type: "string", value: "Uint16", compare: !0 },
  domain: { type: "array", value: [], compare: !0 },
  viewportId: { type: "string", value: "", compare: !0 },
  interpolation: { type: "number", value: null, compare: !0 }
};
class vfe extends i1 {
  _updateTileset() {
    this.props.viewportId || super._updateTileset(), (this.props.viewportId && this.context.viewport.id === this.props.viewportId || !this.state.tileset._viewport) && super._updateTileset();
  }
}
vfe.layerName = "MultiscaleImageLayerBase";
vfe.defaultProps = w$n;
const x$n = {
  pickable: { type: "boolean", value: !0, compare: !0 },
  coordinateSystem: wn.CARTESIAN,
  contrastLimits: { type: "array", value: [], compare: !0 },
  channelsVisible: { type: "array", value: [], compare: !0 },
  selections: { type: "array", value: [], compare: !0 },
  domain: { type: "array", value: [], compare: !0 },
  viewportId: { type: "string", value: "", compare: !0 },
  loader: {
    type: "object",
    value: {
      getRaster: async () => ({ data: [], height: 0, width: 0 }),
      dtype: "Uint16",
      shape: []
    },
    compare: !0
  },
  onClick: { type: "function", value: null, compare: !0 },
  onViewportLoad: { type: "function", value: null, compare: !0 },
  interpolation: {
    type: "number",
    value: gt.NEAREST,
    compare: !0
  },
  extensions: {
    type: "array",
    value: [new tx()],
    compare: !0
  }
}, ox = class extends mA {
  finalizeState() {
    this.state.abortController.abort();
  }
  updateState({ props: t, oldProps: e }) {
    const n = t.loader !== e.loader, r = t.selections !== e.selections;
    if (n || r) {
      const { loader: i, selections: o = [], onViewportLoad: s } = this.props, a = new AbortController();
      this.setState({ abortController: a });
      const { signal: A } = a, l = (u) => i.getRaster({ selection: u, signal: A }), c = o.map(l);
      Promise.all(c).then((u) => {
        const f = {
          data: u.map((h) => h.data),
          width: u[0]?.width,
          height: u[0]?.height
        };
        dB(i.shape) && (f.data = f.data[0], f.data.length === f.width * f.height * 3 && (f.format = gt.RGB, f.dataFormat = gt.RGB)), s && s(f), this.setState({ ...f });
      }).catch((u) => {
        if (u !== pfe)
          throw u;
      });
    }
  }
  getPickingInfo({ info: t, sourceLayer: e }) {
    return t.sourceLayer = e, t.tile = e.props.tile, t;
  }
  renderLayers() {
    const { loader: t, id: e } = this.props, { dtype: n } = t, { width: r, height: i, data: o } = this.state;
    if (!(r && i))
      return null;
    const s = [0, i, r, 0];
    if (dB(t.shape)) {
      const { photometricInterpretation: a = 2 } = t.meta;
      return new YM(this.props, {
        image: this.state,
        photometricInterpretation: a,
        bounds: s,
        id: `image-sub-layer-${s}-${e}`,
        extensions: []
      });
    }
    return new ix(this.props, {
      channelData: { data: o, height: i, width: r },
      bounds: s,
      id: `image-sub-layer-${s}-${e}`,
      dtype: n
    });
  }
};
ox.layerName = "ImageLayer";
ox.defaultProps = x$n;
const R$n = {
  pickable: { type: "boolean", value: !0, compare: !0 },
  onHover: { type: "function", value: null, compare: !1 },
  contrastLimits: { type: "array", value: [], compare: !0 },
  channelsVisible: { type: "array", value: [], compare: !0 },
  domain: { type: "array", value: [], compare: !0 },
  viewportId: { type: "string", value: "", compare: !0 },
  maxRequests: { type: "number", value: 10, compare: !0 },
  onClick: { type: "function", value: null, compare: !0 },
  refinementStrategy: { type: "string", value: null, compare: !0 },
  excludeBackground: { type: "boolean", value: !1, compare: !0 },
  extensions: {
    type: "array",
    value: [new tx()],
    compare: !0
  }
}, sx = class extends mA {
  renderLayers() {
    const {
      loader: t,
      selections: e,
      opacity: n,
      viewportId: r,
      onTileError: i,
      onHover: o,
      id: s,
      onClick: a,
      modelMatrix: A,
      excludeBackground: l,
      refinementStrategy: c
    } = this.props, { tileSize: u, dtype: f } = t[0], h = async ({ index: { x: w, y: R, z: M }, signal: O }) => {
      if (!e || e.length === 0)
        return null;
      const L = Math.round(-M), N = (k) => {
        const $ = { x: w, y: R, selection: k, signal: O };
        return t[L].getTile($);
      };
      try {
        const k = await Promise.all(e.map(N)), $ = {
          data: k.map((U) => U.data),
          width: k[0].width,
          height: k[0].height
        };
        return dB(t[L].shape) && ($.data = $.data[0], $.data.length === $.width * $.height * 3 && ($.format = gt.RGB, $.dataFormat = gt.RGB)), $;
      } catch (k) {
        if (k === pfe)
          return null;
        throw k;
      }
    }, { height: d, width: I } = h1(t[0]), m = new vfe(this.props, {
      id: `Tiled-Image-${s}`,
      getTileData: h,
      dtype: f,
      tileSize: u,
      zoomOffset: Math.round(
        Math.log2(A ? A.getScale()[0] : 1)
      ),
      extent: [0, 0, I, d],
      minZoom: Math.round(-(t.length - 1)),
      maxZoom: 0,
      refinementStrategy: c || (n === 1 ? "best-available" : "no-overlap"),
      updateTriggers: {
        getTileData: [t, e]
      },
      onTileError: i || t[0].onTileError
    }), C = t[t.length - 1], y = typeof C.getRaster == "function", v = A ? A.clone() : new pn();
    return [y && !l && new ox(this.props, {
      id: `Background-Image-${s}`,
      loader: C,
      modelMatrix: v.scale(2 ** (t.length - 1)),
      visible: !r || this.context.viewport.id === r,
      onHover: o,
      onClick: a,
      interpolation: gt.LINEAR,
      onViewportLoad: null
    }), m];
  }
};
sx.layerName = "MultiscaleImageLayer";
sx.defaultProps = R$n;
const D$n = {
  pickable: { type: "boolean", value: !0, compare: !0 },
  loader: {
    type: "object",
    value: {
      getRaster: async () => ({ data: [], height: 0, width: 0 }),
      getRasterSize: () => ({ height: 0, width: 0 }),
      dtype: "<u2"
    },
    compare: !0
  },
  id: { type: "string", value: "", compare: !0 },
  boundingBox: {
    type: "array",
    value: [
      [0, 0],
      [0, 1],
      [1, 1],
      [1, 0]
    ],
    compare: !0
  },
  boundingBoxColor: { type: "array", value: [255, 0, 0], compare: !0 },
  boundingBoxOutlineWidth: { type: "number", value: 1, compare: !0 },
  viewportOutlineColor: { type: "array", value: [255, 190, 0], compare: !0 },
  viewportOutlineWidth: { type: "number", value: 2, compare: !0 },
  overviewScale: { type: "number", value: 1, compare: !0 },
  zoom: { type: "number", value: 1, compare: !0 }
}, BKe = class extends mA {
  renderLayers() {
    const {
      loader: t,
      id: e,
      zoom: n,
      boundingBox: r,
      boundingBoxColor: i,
      boundingBoxOutlineWidth: o,
      viewportOutlineColor: s,
      viewportOutlineWidth: a,
      overviewScale: A
    } = this.props, { width: l, height: c } = h1(t[0]), u = t.length - 1, f = t[u], h = new ox(this.props, {
      id: `viewport-${e}`,
      modelMatrix: new pn().scale(2 ** u * A),
      loader: f
    }), d = new Pf({
      id: `bounding-box-overview-${e}`,
      coordinateSystem: wn.CARTESIAN,
      data: [r],
      getPolygon: (C) => C,
      filled: !1,
      stroked: !0,
      getLineColor: i,
      getLineWidth: o * 2 ** n
    }), I = new Pf({
      id: `viewport-outline-${e}`,
      coordinateSystem: wn.CARTESIAN,
      data: [
        [
          [0, 0],
          [l * A, 0],
          [l * A, c * A],
          [0, c * A]
        ]
      ],
      getPolygon: (C) => C,
      filled: !1,
      stroked: !0,
      getLineColor: s,
      getLineWidth: a * 2 ** n
    });
    return [h, d, I];
  }
};
BKe.layerName = "OverviewLayer";
BKe.defaultProps = D$n;
function T$n(t, e, n) {
  const r = t[2][0] - t[0][0], i = t[2][1] - t[0][1];
  switch (e) {
    case "bottom-right": {
      const o = t[2][1] - i * n, s = t[2][0] - r * n;
      return [o, s];
    }
    case "top-right": {
      const o = t[0][1] + i * n, s = t[2][0] - r * n;
      return [o, s];
    }
    case "top-left": {
      const o = t[0][1] + i * n, s = t[0][0] + r * n;
      return [o, s];
    }
    case "bottom-left": {
      const o = t[2][1] - i * n, s = t[0][0] + r * n;
      return [o, s];
    }
    default:
      throw new Error(`Position ${e} not found`);
  }
}
const N$n = {
  pickable: { type: "boolean", value: !0, compare: !0 },
  viewState: {
    type: "object",
    value: { zoom: 0, target: [0, 0, 0] },
    compare: !0
  },
  unit: { type: "string", value: "", compare: !0 },
  size: { type: "number", value: 1, compare: !0 },
  position: { type: "string", value: "bottom-right", compare: !0 },
  length: { type: "number", value: 0.085, compare: !0 },
  snap: { type: "boolean", value: !1, compare: !0 }
}, Rq = class extends mA {
  renderLayers() {
    const { id: t, unit: e, size: n, position: r, viewState: i, length: o, snap: s } = this.props, a = p$n(i), { zoom: A } = i, c = (a[2][0] - a[0][0]) * 0.05, u = Math.max(
      2 ** (-A + 1.5),
      (a[2][1] - a[0][1]) * 7e-3
    );
    let f = c, h = (c * n).toPrecision(5), d = e;
    if (s) {
      const R = C$n(n, e), M = c * R, [O, L, N] = E$n(M);
      f = O / R, h = L, d = `${N}m`;
    }
    const [I, m] = T$n(a, r, o), C = m + c, y = r.endsWith("-left"), v = new q_({
      id: `scale-bar-length-${t}`,
      coordinateSystem: wn.CARTESIAN,
      data: [
        [
          [y ? m : C - f, I],
          [y ? m + f : C, I]
        ]
      ],
      getSourcePosition: (R) => R[0],
      getTargetPosition: (R) => R[1],
      getWidth: 2,
      getColor: [220, 220, 220]
    }), b = new q_({
      id: `scale-bar-height-left-${t}`,
      coordinateSystem: wn.CARTESIAN,
      data: [
        [
          [
            y ? m : C - f,
            I - u
          ],
          [
            y ? m : C - f,
            I + u
          ]
        ]
      ],
      getSourcePosition: (R) => R[0],
      getTargetPosition: (R) => R[1],
      getWidth: 2,
      getColor: [220, 220, 220]
    }), Q = new q_({
      id: `scale-bar-height-right-${t}`,
      coordinateSystem: wn.CARTESIAN,
      data: [
        [
          [
            y ? m + f : C,
            I - u
          ],
          [
            y ? m + f : C,
            I + u
          ]
        ]
      ],
      getSourcePosition: (R) => R[0],
      getTargetPosition: (R) => R[1],
      getWidth: 2,
      getColor: [220, 220, 220]
    }), w = new Eg({
      id: `units-label-layer-${t}`,
      coordinateSystem: wn.CARTESIAN,
      data: [
        {
          text: `${h}${d}`,
          position: [
            y ? m + c * 0.5 : C - c * 0.5,
            I + u * 4
          ]
        }
      ],
      getColor: [220, 220, 220, 255],
      getSize: 12,
      fontFamily: JHn,
      sizeUnits: "meters",
      sizeScale: 2 ** -A,
      characterSet: [
        ...d.split(""),
        ...d$n(10).map((R) => String(R)),
        ".",
        "e",
        "+"
      ]
    });
    return [v, b, Q, w];
  }
};
Rq.layerName = "ScaleBarLayer";
Rq.defaultProps = N$n;
const L$n = `#version 300 es
#define SHADER_NAME xr-layer-vertex-shader

// Unit-cube vertices
in vec3 positions;

// Eye position - last column of the inverted view matrix
uniform vec3 eye_pos;
// Projection matrix
uniform mat4 proj;
// Model Matrix
uniform mat4 model;
// View Matrix
uniform mat4 view;
// A matrix for scaling in the model space before any transformations.
// This projects the unit cube up to match the "pixel size" multiplied by the physical size ratio, if provided.
uniform mat4 scale;
uniform mat4 resolution;


out vec3 vray_dir;
flat out vec3 transformed_eye;

void main() {

  // Step 1: Standard MVP transformation (+ the scale matrix) to place the positions on your 2D screen ready for rasterization + fragment processing.
  gl_Position = proj * view * model * scale * resolution * vec4(positions, 1.);

  // Step 2: Invert the eye back from world space to the normalized 0-1 cube world space because ray casting on the fragment shader runs in 0-1 space.
  // Geometrically, the transformed_eye is a position relative to the 0-1 normalized vertices, which themselves are the inverse of the model + scale trasnformation.
  // See below for an example which does not involve a scale transformation, for simplicity, but motivates geometrically the needed transformation on eye_pos.
  /*
  This first diagram is a skewed volume (i.e a "shear" model matrix applied) top down with the eye marked as #, all in world space
       ^
    ___|__
    \\  |  \\
     \\ |   \\
      \\|____\\
       | 
       | 
       |
       #

  This next diagram shows the volume after the inverse model matrix has placed it back in model coordinates, but the eye still in world space. 
       ^
    ___|___
    |  |  |
    |  |  |
    |__|__|
       |
       |
       |
       #

  Finally, we apply the inverse model matrix transformation to the eye as well to bring it too into world space.
  Notice that the ray here matches the "voxels" through which the first ray also passes, as desired.
         ^
    ____/__
    |  /  |
    | /   |
    |/____|
    /
   /
  /
 #
  */
  transformed_eye = (inverse(resolution) * inverse(scale) * inverse(model) * (vec4(eye_pos, 1.))).xyz;

  // Step 3: Rays are from eye to vertices so that they get interpolated over the fragments.
  vray_dir = positions - transformed_eye;
}
`, M$n = `#version 300 es
precision highp int;
precision highp float;
precision highp SAMPLER_TYPE;

uniform highp SAMPLER_TYPE volume0;
uniform highp SAMPLER_TYPE volume1;
uniform highp SAMPLER_TYPE volume2;
uniform highp SAMPLER_TYPE volume3;
uniform highp SAMPLER_TYPE volume4;
uniform highp SAMPLER_TYPE volume5;

uniform vec3 scaledDimensions;

uniform mat4 scale;

uniform vec3 normals[NUM_PLANES];
uniform float distances[NUM_PLANES];

// color
uniform vec3 colors[6];

// slices
uniform vec2 xSlice;
uniform vec2 ySlice;
uniform vec2 zSlice;

// range
uniform vec2 contrastLimits[6];

in vec3 vray_dir;
flat in vec3 transformed_eye;
out vec4 color;

vec2 intersect_box(vec3 orig, vec3 dir) {
	vec3 box_min = vec3(xSlice[0], ySlice[0], zSlice[0]);
	vec3 box_max = vec3(xSlice[1], ySlice[1], zSlice[1]);
	vec3 inv_dir = 1. / dir;
	vec3 tmin_tmp = (box_min - orig) * inv_dir;
	vec3 tmax_tmp = (box_max - orig) * inv_dir;
	vec3 tmin = min(tmin_tmp, tmax_tmp);
	vec3 tmax = max(tmin_tmp, tmax_tmp);
	float t0 = max(tmin.x, max(tmin.y, tmin.z));
  float t1 = min(tmax.x, min(tmax.y, tmax.z));
  vec2 val = vec2(t0, t1);
	return val;
}

float linear_to_srgb(float x) {
	if (x <= 0.0031308f) {
		return 12.92f * x;
	}
	return 1.055f * pow(x, 1.f / 2.4f) - 0.055f;
}

// Pseudo-random number gen from
// http://www.reedbeta.com/blog/quick-and-easy-gpu-random-numbers-in-d3d11/
// with some tweaks for the range of values
float wang_hash(int seed) {
	seed = (seed ^ 61) ^ (seed >> 16);
	seed *= 9;
	seed = seed ^ (seed >> 4);
	seed *= 0x27d4eb2d;
	seed = seed ^ (seed >> 15);
	return float(seed % 2147483647) / float(2147483647);
}


void main(void) {
	// Step 1: Normalize the view ray
	vec3 ray_dir = normalize(vray_dir);

	// Step 2: Intersect the ray with the volume bounds to find the interval
	// along the ray overlapped by the volume.
	vec2 t_hit = intersect_box(transformed_eye, ray_dir);
	if (t_hit.x > t_hit.y) {
		discard;
	}
	// We don't want to sample voxels behind the eye if it's
	// inside the volume, so keep the starting point at or in front
	// of the eye
	t_hit.x = max(t_hit.x, 0.);

	// Step 3: Compute the step size to march through the volume grid
	vec3 dt_vec = 1. / (scale * vec4(abs(ray_dir), 1.)).xyz;
	float dt = 1. * min(dt_vec.x, min(dt_vec.y, dt_vec.z));

	float offset = wang_hash(int(gl_FragCoord.x + 640. * gl_FragCoord.y));

	// Step 4: Starting from the entry point, march the ray through the volume
	// and sample it
	vec3 p = transformed_eye + (t_hit.x + offset * dt) * ray_dir;

	// TODO: Probably want to stop this process at some point to improve performance when marching down the edges.
	_BEFORE_RENDER
	for (float t = t_hit.x; t < t_hit.y; t += dt) {
		// Check if this point is on the "positive" side or "negative" side of the plane - only show positive.
		float canShow = 1.;
		for (int i = 0; i < NUM_PLANES; i += 1) {
			canShow *= max(0., sign(dot(normals[i], p) + distances[i]));
		}
		// Do not show coordinates outside 0-1 box.
		// Something about the undefined behavior outside the box causes the additive blender to 
		// render some very odd artifacts.
		float canShowXCoordinate = max(p.x - 0., 0.) * max(1. - p.x , 0.);
		float canShowYCoordinate = max(p.y - 0., 0.) * max(1. - p.y , 0.);
		float canShowZCoordinate = max(p.z - 0., 0.) * max(1. - p.z , 0.);
		float canShowCoordinate = float(ceil(canShowXCoordinate * canShowYCoordinate * canShowZCoordinate));
		canShow = canShowCoordinate * canShow;
		float intensityValue0 = float(texture(volume0, p).r);
		DECKGL_PROCESS_INTENSITY(intensityValue0, contrastLimits[0], 0);
		intensityValue0 = canShow * intensityValue0;
		float intensityValue1 = float(texture(volume1, p).r);
		DECKGL_PROCESS_INTENSITY(intensityValue1, contrastLimits[1], 1);
		intensityValue1 = canShow * intensityValue1;
		float intensityValue2 = float(texture(volume2, p).r);
  		DECKGL_PROCESS_INTENSITY(intensityValue2, contrastLimits[2], 2);
		intensityValue2 = canShow * intensityValue2;
		float intensityValue3 = float(texture(volume3, p).r);
  		DECKGL_PROCESS_INTENSITY(intensityValue3, contrastLimits[3], 3);
		intensityValue3 = canShow * intensityValue3;
    	float intensityValue4 = float(texture(volume4, p).r);
  		DECKGL_PROCESS_INTENSITY(intensityValue4, contrastLimits[4], 4);
		intensityValue4 = canShow * intensityValue4;
		float intensityValue5 = float(texture(volume5, p).r);
  		DECKGL_PROCESS_INTENSITY(intensityValue5, contrastLimits[5], 5);
		intensityValue5 = canShow * intensityValue5;

		_RENDER

		p += ray_dir * dt;
	}
	_AFTER_RENDER
  color.r = linear_to_srgb(color.r);
  color.g = linear_to_srgb(color.g);
  color.b = linear_to_srgb(color.b);
}
`, O$n = {
  name: "channel-intensity-module",
  fs: `    float apply_contrast_limits(float intensity, vec2 contrastLimits) {
      float contrastLimitsAppliedToIntensity = (intensity - contrastLimits[0]) / max(0.0005, (contrastLimits[1] - contrastLimits[0]));
      return max(0., contrastLimitsAppliedToIntensity);
    }
  `
}, F$n = [
  1,
  1,
  0,
  0,
  1,
  0,
  1,
  1,
  1,
  0,
  1,
  1,
  0,
  0,
  1,
  0,
  1,
  0,
  0,
  0,
  0,
  1,
  1,
  0,
  1,
  0,
  0,
  1,
  1,
  1,
  1,
  0,
  1,
  0,
  0,
  1,
  1,
  0,
  0,
  0,
  0,
  0
], RDe = 1, P$n = {
  pickable: !1,
  coordinateSystem: wn.CARTESIAN,
  channelData: { type: "object", value: {}, compare: !0 },
  contrastLimits: { type: "array", value: [], compare: !0 },
  dtype: { type: "string", value: "Uint8", compare: !0 },
  xSlice: { type: "array", value: null, compare: !0 },
  ySlice: { type: "array", value: null, compare: !0 },
  zSlice: { type: "array", value: null, compare: !0 },
  clippingPlanes: { type: "array", value: [], compare: !0 },
  resolutionMatrix: { type: "object", value: new pn(), compare: !0 },
  channelsVisible: { type: "array", value: [], compare: !0 },
  extensions: {
    type: "array",
    value: [new TC.AdditiveBlendExtension()],
    compare: !0
  }
};
function DDe() {
  const t = Efe("Float32");
  return {
    ...t,
    sampler: t.sampler.replace("2D", "3D"),
    cast: (e) => new Float32Array(e)
  };
}
function k$n(t) {
  let e = {};
  if (t.forEach((n) => {
    e = n.rendering;
  }), !e._RENDER)
    throw new Error(
      "XR3DLayer requires at least one extension to define opts.rendering as an object with _RENDER as a property at the minimum."
    );
  return e;
}
const Bfe = class extends IA {
  initializeState() {
    const { gl: t } = this.context;
    t.pixelStorei(gt.UNPACK_ALIGNMENT, 1), t.pixelStorei(gt.PACK_ALIGNMENT, 1);
    const e = SE.getDefaultProgramManager(t), n = "fs:DECKGL_PROCESS_INTENSITY(inout float intensity, vec2 contrastLimits, int channelIndex)";
    e._hookFunctions.includes(n) || e.addShaderHook(n);
  }
  _isHookDefinedByExtensions(t) {
    const { extensions: e } = this.props;
    return e?.some((n) => {
      const r = n.getShaders();
      if (r) {
        const { inject: i = {}, modules: o = [] } = r, s = i[t], a = o.some(
          (A) => A.inject && A?.inject[t]
        );
        return s || a;
      }
      return !1;
    });
  }
  getShaders() {
    const { clippingPlanes: t, extensions: e } = this.props, { sampler: n } = DDe(), { _BEFORE_RENDER: r, _RENDER: i, _AFTER_RENDER: o } = k$n(e), s = this._isHookDefinedByExtensions("fs:DECKGL_PROCESS_INTENSITY"), a = { inject: {}, ...O$n };
    return s || (a.inject["fs:DECKGL_PROCESS_INTENSITY"] = `
        intensity = apply_contrast_limits(intensity, contrastLimits);
      `), super.getShaders({
      vs: L$n,
      fs: M$n.replace("_BEFORE_RENDER", r).replace("_RENDER", i).replace("_AFTER_RENDER", o),
      defines: {
        SAMPLER_TYPE: n,
        NUM_PLANES: String(t.length || RDe)
      },
      modules: [a]
    });
  }
  finalizeState() {
    super.finalizeState(), this.state.textures && Object.values(this.state.textures).forEach((t) => t && t.delete());
  }
  updateState({ props: t, oldProps: e, changeFlags: n }) {
    if (n.extensionsChanged || t.colormap !== e.colormap || t.renderingMode !== e.renderingMode || t.clippingPlanes.length !== e.clippingPlanes.length) {
      const { gl: r } = this.context;
      this.state.model && this.state.model.delete(), this.setState({ model: this._getModel(r) });
    }
    t.channelData && t?.channelData?.data !== e?.channelData?.data && this.loadTexture(t.channelData);
  }
  _getModel(t) {
    return t ? new Ta(t, {
      ...this.getShaders(),
      geometry: new Os({
        drawMode: t.TRIANGLE_STRIP,
        attributes: {
          positions: new Float32Array(F$n)
        }
      })
    }) : null;
  }
  draw({ uniforms: t }) {
    const { textures: e, model: n, scaleMatrix: r } = this.state, {
      contrastLimits: i,
      xSlice: o,
      ySlice: s,
      zSlice: a,
      modelMatrix: A,
      channelsVisible: l,
      domain: c,
      dtype: u,
      clippingPlanes: f,
      resolutionMatrix: h
    } = this.props, { viewMatrix: d, viewMatrixInverse: I, projectionMatrix: m } = this.context.viewport;
    if (e && n && r) {
      const C = EKe({
        contrastLimits: i,
        channelsVisible: l,
        domain: c,
        dtype: u
      }), y = r.clone().invert(), v = h.clone().invert(), b = CKe(
        f.map(
          (R) => R.clone().transform(y).transform(v)
        ),
        new Ef([1, 0, 0]),
        f.length || RDe
      ), Q = b.map((R) => R.normal).flat(), w = b.map((R) => R.distance);
      n.setUniforms({
        ...t,
        ...e,
        contrastLimits: C,
        xSlice: new Float32Array(
          o ? o.map((R) => R / r[0] / h[0]) : [0, 1]
        ),
        ySlice: new Float32Array(
          s ? s.map((R) => R / r[5] / h[5]) : [0, 1]
        ),
        zSlice: new Float32Array(
          a ? a.map((R) => R / r[10] / h[10]) : [0, 1]
        ),
        eye_pos: new Float32Array([
          I[12],
          I[13],
          I[14]
        ]),
        view: d,
        proj: m,
        scale: r,
        resolution: h,
        model: A || new pn(),
        normals: Q,
        distances: w
      }).draw();
    }
  }
  loadTexture(t) {
    const e = {
      volume0: null,
      volume1: null,
      volume2: null,
      volume3: null,
      volume4: null,
      volume5: null
    };
    if (this.state.textures && Object.values(this.state.textures).forEach((n) => n && n.delete()), t && Object.keys(t).length > 0 && t.data) {
      const { height: n, width: r, depth: i } = t;
      t.data.forEach((o, s) => {
        e[`volume${s}`] = this.dataToTexture(o, r, n, i);
      }, this), this.setState({
        textures: e,
        scaleMatrix: new pn().scale(
          this.props.physicalSizeScalingMatrix.transformPoint([
            r,
            n,
            i
          ])
        )
      });
    }
  }
  dataToTexture(t, e, n, r) {
    const i = DDe();
    return new yle(this.context.gl, {
      width: e,
      height: n,
      depth: r,
      data: i.cast?.(t) ?? t,
      format: i.dataFormat,
      dataFormat: i.format,
      type: i.type,
      mipmaps: !1,
      parameters: {
        [gt.TEXTURE_MIN_FILTER]: gt.LINEAR,
        [gt.TEXTURE_MAG_FILTER]: gt.LINEAR,
        [gt.TEXTURE_WRAP_S]: gt.CLAMP_TO_EDGE,
        [gt.TEXTURE_WRAP_T]: gt.CLAMP_TO_EDGE,
        [gt.TEXTURE_WRAP_R]: gt.CLAMP_TO_EDGE
      }
    });
  }
};
Bfe.layerName = "XR3DLayer";
Bfe.defaultProps = P$n;
async function G$n({
  source: t,
  selection: e,
  onUpdate: n = () => {
  },
  downsampleDepth: r = 1,
  signal: i
}) {
  const { shape: o, labels: s, dtype: a } = t, { height: A, width: l } = h1(t), c = o[s.indexOf("z")], u = Math.max(1, Math.floor(c / r)), f = A * l, h = `${a}Array`, d = globalThis[h], I = new d(f * u);
  return await Promise.all(
    new Array(u).fill(0).map(async (m, C) => {
      const y = {
        ...e,
        z: C * r
      }, { data: v } = await t.getRaster({
        selection: y,
        signal: i
      });
      let b = 0;
      for (n(); b < f; ) {
        const Q = C * f + (f - b - 1), w = (l - b - 1) % l + l * Math.floor(b / l);
        I[Q] = v[w], b += 1;
      }
      n();
    })
  ), {
    data: I,
    height: A,
    width: l,
    depth: u
  };
}
const TDe = (t, e, n) => new Eg({
  id: `text-${n}`,
  coordinateSystem: wn.CARTESIAN,
  data: [
    {
      text: t,
      position: e.position
    }
  ],
  getColor: [220, 220, 220, 255],
  getSize: 25,
  sizeUnits: "meters",
  sizeScale: 2 ** -e.zoom,
  fontFamily: "Helvetica"
}), U$n = {
  pickable: !1,
  coordinateSystem: wn.CARTESIAN,
  contrastLimits: { type: "array", value: [], compare: !0 },
  channelsVisible: { type: "array", value: [], compare: !0 },
  selections: { type: "array", value: [], compare: !0 },
  resolution: { type: "number", value: 0, compare: !0 },
  domain: { type: "array", value: [], compare: !0 },
  loader: {
    type: "object",
    value: [
      {
        getRaster: async () => ({ data: [], height: 0, width: 0 }),
        dtype: "Uint16",
        shape: [1],
        labels: ["z"]
      }
    ],
    compare: !0
  },
  xSlice: { type: "array", value: null, compare: !0 },
  ySlice: { type: "array", value: null, compare: !0 },
  zSlice: { type: "array", value: null, compare: !0 },
  clippingPlanes: { type: "array", value: [], compare: !0 },
  onUpdate: { type: "function", value: () => {
  }, compare: !0 },
  useProgressIndicator: { type: "boolean", value: !0, compare: !0 },
  useWebGL1Warning: { type: "boolean", value: !0, compare: !0 },
  extensions: {
    type: "array",
    value: [new TC.AdditiveBlendExtension()],
    compare: !0
  }
}, Dq = class extends mA {
  clearState() {
    this.setState({
      height: null,
      width: null,
      depth: null,
      data: null,
      physicalSizeScalingMatrix: null,
      resolutionMatrix: null,
      progress: 0,
      abortController: null
    });
  }
  finalizeState() {
    this.state.abortController.abort();
  }
  updateState({ oldProps: t, props: e }) {
    const n = e.loader !== t.loader, r = e.resolution !== t.resolution, i = e.selections !== t.selections;
    if (r && this.clearState(), n || i || r) {
      const {
        loader: o,
        selections: s = [],
        resolution: a,
        onViewportLoad: A
      } = this.props, l = o[a];
      let c = 0;
      const u = (l.shape[l.labels.indexOf("z")] >> a) * s.length, f = () => {
        c += 0.5 / u, this.props.onUpdate && this.props.onUpdate({ progress: c }), this.setState({ progress: c });
      }, h = new AbortController();
      this.setState({ abortController: h });
      const { signal: d } = h, I = s.map(
        (C) => G$n({
          selection: C,
          source: l,
          onUpdate: f,
          downsampleDepth: 2 ** a,
          signal: d
        })
      ), m = yKe(
        o[a]
      );
      Promise.all(I).then((C) => {
        A && A(C);
        const y = {
          data: C.map((v) => v.data),
          width: C[0]?.width,
          height: C[0]?.height,
          depth: C[0]?.depth
        };
        this.setState({
          ...y,
          physicalSizeScalingMatrix: m,
          resolutionMatrix: new pn().scale(2 ** a)
        });
      });
    }
  }
  renderLayers() {
    const { loader: t, id: e, resolution: n, useProgressIndicator: r, useWebGL1Warning: i } = this.props, { dtype: o } = t[n], {
      data: s,
      width: a,
      height: A,
      depth: l,
      progress: c,
      physicalSizeScalingMatrix: u,
      resolutionMatrix: f
    } = this.state, { gl: h } = this.context;
    if (!Fr(h) && i) {
      const { viewport: d } = this.context;
      return TDe(
        [
          "Volume rendering is only available on browsers that support WebGL2. If you",
          "are using Safari, you can turn on WebGL2 by navigating in the top menubar",
          "to check Develop > Experimental Features > WebGL 2.0 and then refreshing",
          "the page."
        ].join(`
`),
        d,
        e
      );
    }
    if (!(a && A) && r) {
      const { viewport: d } = this.context;
      return TDe(
        `Loading Volume ${String((c || 0) * 100).slice(0, 5)}%...`,
        d,
        e
      );
    }
    return new Bfe(this.props, {
      channelData: { data: s, width: a, height: A, depth: l },
      id: `XR3DLayer-0-${A}-${a}-0-${n}-${e}`,
      physicalSizeScalingMatrix: u,
      parameters: {
        [gt.CULL_FACE]: !0,
        [gt.CULL_FACE_MODE]: gt.FRONT,
        [gt.DEPTH_TEST]: !1,
        blendFunc: [gt.SRC_ALPHA, gt.ONE],
        blend: !0
      },
      resolutionMatrix: f,
      dtype: o
    });
  }
};
Dq.layerName = "VolumeLayer";
Dq.defaultProps = U$n;
function aQ(t, e, n = 0, r = !1, i) {
  const o = Array.isArray(t) ? t[0] : t, { width: s, height: a } = h1(o), A = (i || new pn()).getScale(), [l, c] = [
    A[0] * s,
    A[1] * a
  ], u = o.shape[o.labels.indexOf("z")], f = Math.log2(
    Math.min(e.width / l, e.height / c)
  ) - n, h = yKe(o);
  return {
    target: (i || new pn()).transformPoint(
      (r ? h : new pn()).transformPoint([
        s / 2,
        a / 2,
        r ? u / 2 : 0
      ])
    ),
    zoom: f
  };
}
var H$n = function t(e, n) {
  if (e === n)
    return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    if (e.constructor !== n.constructor)
      return !1;
    var r, i, o;
    if (Array.isArray(e)) {
      if (r = e.length, r != n.length)
        return !1;
      for (i = r; i-- !== 0; )
        if (!t(e[i], n[i]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === n.source && e.flags === n.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === n.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === n.toString();
    if (o = Object.keys(e), r = o.length, r !== Object.keys(n).length)
      return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, o[i]))
        return !1;
    for (i = r; i-- !== 0; ) {
      var s = o[i];
      if (!t(e[s], n[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
};
const bKe = /* @__PURE__ */ ko(H$n), $$n = `
#define SHADER_NAME bitmask-layer-vertex-shader

attribute vec2 texCoords;
attribute vec3 positions;
attribute vec3 positions64Low;
attribute vec3 instancePickingColors;

varying vec2 vTexCoord;

void main(void) {
  geometry.worldPosition = positions;
  geometry.uv = texCoords;
  geometry.pickingColor = instancePickingColors;
  gl_Position = project_position_to_clipspace(positions, positions64Low, vec3(0.0), geometry.position);
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
  vTexCoord = texCoords;
  vec4 color = vec4(0.0);
  DECKGL_FILTER_COLOR(color, geometry);
}
`, q$n = `
#define SHADER_NAME bitmask-layer-fragment-shader
precision highp float;

${kM}

// Data (mask) texture
uniform sampler2D channel0;
uniform sampler2D channel1;
uniform sampler2D channel2;
uniform sampler2D channel3;
uniform sampler2D channel4;
uniform sampler2D channel5;

// Color texture
uniform sampler2D colorTex;
uniform float colorTexHeight;
uniform float colorTexWidth;
uniform float hovered;
// range
uniform bool channelsVisible[6];

// Expression mapping
uniform vec2 uColorScaleRange;
uniform bool uIsExpressionMode;
uniform sampler2D expressionTex;

// opacity
uniform float opacity;

varying vec2 vTexCoord;

vec4 sampleAndGetColor(sampler2D dataTex, vec2 coord, bool isOn){
  float sampledData = texture(dataTex, coord).r;
  vec4 hoveredColor = float(sampledData == hovered && sampledData > 0. && hovered > 0.) * vec4(0., 0., 1., 1.);
  // Colors are laid out corresponding to ids in row-major order in the texture.  So if width of the texture is 10, and you want ID 25,
  // you need coordinate (1, 4) (i.e 2 rows down, and 5 columns over indexed from 0 for a total of 25 units covered in row major order).
  vec2 colorTexCoord = vec2(mod(sampledData, colorTexWidth) / colorTexWidth, floor(sampledData / colorTexWidth) / (colorTexHeight - 1.));
  float expressionValue = texture(expressionTex, colorTexCoord).r / 255.;
  float scaledExpressionValue = (expressionValue - uColorScaleRange[0]) / max(0.005, (uColorScaleRange[1] - uColorScaleRange[0]));
  vec4 sampledColor = float(uIsExpressionMode) * COLORMAP_FUNC(clamp(scaledExpressionValue, 0.0, 1.0)) +  (1. - float(uIsExpressionMode)) * vec4(texture(colorTex, colorTexCoord).rgb, 1.);
  // Only return a color if the data is non-zero.
  return max(0., min(sampledData, 1.)) * float(isOn) * (sampledColor + hoveredColor);
}

void main() {

  gl_FragColor = sampleAndGetColor(channel0, vTexCoord, channelsVisible[0]);

  // If the sampled color and the currently stored color (gl_FragColor) are identical, don't blend and use the sampled color,
  // otherwise just use the currently stored color.  Repeat this for all channels.
  vec4 sampledColor = sampleAndGetColor(channel1, vTexCoord, channelsVisible[1]);
  gl_FragColor = (sampledColor == gl_FragColor || sampledColor == vec4(0.)) ? gl_FragColor : sampledColor;
  sampledColor = sampleAndGetColor(channel2, vTexCoord, channelsVisible[2]);
  gl_FragColor = (sampledColor == gl_FragColor || sampledColor == vec4(0.)) ? gl_FragColor : sampledColor;
  sampledColor = sampleAndGetColor(channel3, vTexCoord, channelsVisible[3]);
  gl_FragColor = (sampledColor == gl_FragColor || sampledColor == vec4(0.)) ? gl_FragColor : sampledColor;
  sampledColor = sampleAndGetColor(channel4, vTexCoord, channelsVisible[4]);
  gl_FragColor = (sampledColor == gl_FragColor || sampledColor == vec4(0.)) ? gl_FragColor : sampledColor;
  sampledColor = sampleAndGetColor(channel5, vTexCoord, channelsVisible[5]);
  gl_FragColor = (sampledColor == gl_FragColor || sampledColor == vec4(0.)) ? gl_FragColor : sampledColor;
  // Apply the opacity if there is pixel data, and if the pixel data is empty i.e no segmentation, use 0 opacity.
  gl_FragColor = vec4(gl_FragColor.rgb, (gl_FragColor.rgb == vec3(0., 0., 0.)) ? 0.0 : opacity);

  geometry.uv = vTexCoord;
  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`;
function j$n(t, e, n) {
  const r = [...t];
  for (let i = 0; i < n; i += 1)
    r.push(e);
  return r;
}
const Y$n = {
  hoveredCell: { type: "number", value: null, compare: !0 },
  // We do not want to deep-compare cellColorData,
  // as it is potentially a TypedArray with millions of elements.
  // For `compare`: "if a number is supplied, indicates the maximum depth to deep-compare,
  // where 0 is shallow comparison and -1 is infinite depth. true is equivalent to 1."
  // Reference: https://deck.gl/docs/developer-guide/custom-layers/prop-types#array
  cellColorData: { type: "object", value: null, compare: 0 },
  colormap: { type: "string", value: u0, compare: !0 },
  // Same as with cellColorData, we do not want to deep-compare expressionData.
  expressionData: { type: "object", value: null, compare: 0 }
};
let bfe = class extends ix {
  // eslint-disable-next-line class-methods-use-this
  getShaders() {
    const { colormap: e } = this.props;
    return {
      fs: q$n,
      vs: $$n,
      modules: [qA, jA],
      defines: {
        [lB]: ME.includes(e) ? e : u0
      }
    };
  }
  updateState({ props: e, oldProps: n, changeFlags: r }) {
    if (super.updateState({ props: e, oldProps: n, changeFlags: r }), e.cellColorData !== n.cellColorData && this.setColorTexture(), e.expressionData !== n.expressionData) {
      const { expressionData: i, cellTexHeight: o, cellTexWidth: s } = this.props, a = this.dataToTexture(i, s, o);
      this.setState({ expressionTex: a });
    }
    if (e.colormap !== n.colormap) {
      const { gl: i } = this.context;
      this.state.model && this.state.model.delete(), this.setState({ model: this._getModel(i) }), this.getAttributeManager().invalidateAll();
    }
  }
  setColorTexture() {
    const { cellColorData: e, cellTexHeight: n, cellTexWidth: r } = this.props, i = new xo(this.context.gl, {
      width: r,
      height: n,
      // Only use Float32 so we don't have to write two shaders
      data: e,
      // we don't want or need mimaps
      mipmaps: !1,
      parameters: {
        // NEAREST for integer data
        [gt.TEXTURE_MIN_FILTER]: gt.NEAREST,
        [gt.TEXTURE_MAG_FILTER]: gt.NEAREST,
        // CLAMP_TO_EDGE to remove tile artifacts
        [gt.TEXTURE_WRAP_S]: gt.CLAMP_TO_EDGE,
        [gt.TEXTURE_WRAP_T]: gt.CLAMP_TO_EDGE
      },
      format: gt.RGB,
      dataFormat: gt.RGB,
      type: gt.UNSIGNED_BYTE
    });
    this.setState({ colorTex: i });
  }
  draw(e) {
    const { uniforms: n } = e, { channelsVisible: r, hoveredCell: i, colorScaleLo: o, colorScaleHi: s, isExpressionMode: a } = this.props, { textures: A, model: l, colorTex: c, expressionTex: u } = this.state;
    A && l && c && l.setUniforms(Object.assign({}, n, {
      hovered: i || 0,
      colorTex: c,
      expressionTex: u,
      colorTexHeight: c.height,
      colorTexWidth: c.width,
      channelsVisible: j$n(
        r,
        !1,
        // There are six texture entries on the shaders
        6 - r.length
      ),
      uColorScaleRange: [o, s],
      uIsExpressionMode: a,
      ...A
    })).draw();
  }
  /**
   * This function creates textures from the data
   */
  dataToTexture(e, n, r) {
    const i = Fr(this.context.gl);
    return new xo(this.context.gl, {
      width: n,
      height: r,
      // Only use Float32 so we don't have to write two shaders
      data: new Float32Array(e),
      // we don't want or need mimaps
      mipmaps: !1,
      parameters: {
        // NEAREST for integer data
        [gt.TEXTURE_MIN_FILTER]: gt.NEAREST,
        [gt.TEXTURE_MAG_FILTER]: gt.NEAREST,
        // CLAMP_TO_EDGE to remove tile artifacts
        [gt.TEXTURE_WRAP_S]: gt.CLAMP_TO_EDGE,
        [gt.TEXTURE_WRAP_T]: gt.CLAMP_TO_EDGE
      },
      format: i ? gt.R32F : gt.LUMINANCE,
      dataFormat: i ? gt.RED : gt.LUMINANCE,
      type: gt.FLOAT
    });
  }
};
bfe.layerName = "BitmaskLayer";
bfe.defaultProps = Y$n;
const z$n = `
#define SHADER_NAME bitmask-layer-vertex-shader

attribute vec2 texCoords;
attribute vec3 positions;
attribute vec3 positions64Low;
attribute vec3 instancePickingColors;

varying vec2 vTexCoord;

void main(void) {
  geometry.worldPosition = positions;
  geometry.uv = texCoords;
  geometry.pickingColor = instancePickingColors;
  gl_Position = project_position_to_clipspace(positions, positions64Low, vec3(0.0), geometry.position);
  DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
  vTexCoord = texCoords;
  vec4 color = vec4(0.0);
  DECKGL_FILTER_COLOR(color, geometry);
}
`, V$n = `
#define SHADER_NAME bitmask-layer-fragment-shader
precision highp float;

${kM}

// Note: can have a maximum of 16 textures in most browsers
// Reference: https://webglreport.com/

// Data (mask) texture
uniform sampler2D channel0;
uniform sampler2D channel1;
uniform sampler2D channel2;
uniform sampler2D channel3;
uniform sampler2D channel4;
uniform sampler2D channel5;
uniform sampler2D channel6;

// Color texture
uniform float hovered;

// Channel-specific properties
uniform bool channelsVisible[7];
uniform float channelOpacities[7];
uniform bool channelIsStaticColorMode[7]; // TODO: should this be a single float?
uniform bool channelIsSetColorMode[7]; // TODO: should this be a single float?

// TODO: can array of tuples/vec2 be used?
uniform float channelColormapRangeStarts[7];
uniform float channelColormapRangeEnds[7];

uniform float multiFeatureTexSize;

// Use one expressionTex for all channels, using an offset mechanism.
uniform sampler2D valueTex;
uniform float valueTexOffsets[7];
uniform float valueTexHeight;

// Textures for set colors, using the same offset mechanism.
uniform sampler2D colorTex;
uniform float colorTexOffsets[7];
uniform float colorTexHeight;


// Static colors
// TODO: For some reason I cannot use uniform vec3 colors[7]; and i cannot figure out why.
uniform vec3 color0;
uniform vec3 color1;
uniform vec3 color2;
uniform vec3 color3;
uniform vec3 color4;
uniform vec3 color5;
uniform vec3 color6;

// Info for edge-only mode
uniform float scaleFactor;
uniform bool channelsFilled[7];
uniform float channelStrokeWidths[7];

// opacity
uniform float opacity;

varying vec2 vTexCoord;

vec3 sampleAndGetData(sampler2D dataTex, vec2 coord, bool isFilled, float strokeWidth, bool isOn) {
  float sampledData = texture(dataTex, coord).r;
  float clampedSampledData = max(0., min(sampledData, 1.));

  bool isEdge = true;

  if(!isFilled) {
    vec2 uTextureSize = vec2(2048.0, 2048.0);
    vec2 onePixel = vec2(1.0, 1.0) / uTextureSize;

    // Vary the edgeSize based on user-defined stroke width.
    float edgeSize = 150.0 * strokeWidth * scaleFactor;

    float pixN = texture(dataTex, coord + vec2(0.0, onePixel.y * edgeSize)).r;
    float pixS = texture(dataTex, coord - vec2(0.0, onePixel.y * edgeSize)).r;
    float pixW = texture(dataTex, coord + vec2(onePixel.x * edgeSize, 0.0)).r;
    float pixE = texture(dataTex, coord - vec2(onePixel.x * edgeSize, 0.0)).r;

    float pixNW = texture(dataTex, coord + vec2(onePixel.y * edgeSize, onePixel.y * edgeSize)).r;
    float pixNE = texture(dataTex, coord + vec2(-1.0 * onePixel.x * edgeSize, onePixel.y * edgeSize)).r;
    float pixSW = texture(dataTex, coord - vec2(onePixel.x * edgeSize, onePixel.y * edgeSize)).r;
    float pixSE = texture(dataTex, coord - vec2(-1.0 * onePixel.x * edgeSize, onePixel.y * edgeSize)).r;

    isEdge = (pixN != sampledData || pixS != sampledData || pixW != sampledData || pixE != sampledData || pixNW != sampledData || pixNE != sampledData || pixSW != sampledData || pixSE != sampledData);
  }
  // Return a tuple of (sampledData, isEdge)
  return vec3(clampedSampledData * float(isOn), sampledData, float(isEdge));
}

vec4 dataToColor(vec3 sampledDataAndIsEdge, bool isStaticColorMode, vec3 channelColor, float channelOpacity, float valueOffset, float rangeStart, float rangeEnd, bool isSetColorMode, float setColorOffset) {
  float clampedSampledDataAndIsOn = sampledDataAndIsEdge.x;
  float sampledData = sampledDataAndIsEdge.y;
  float isEdge = sampledDataAndIsEdge.z;
  

  vec4 hoveredColor = float(sampledData == hovered && sampledData > 0. && hovered > 0.) * vec4(0., 0., 1., 1.);
  
  // Colors are laid out corresponding to ids in row-major order in the texture.  So if width of the texture is 10, and you want ID 25,
  // you need coordinate (1, 4) (i.e 2 rows down, and 5 columns over indexed from 0 for a total of 25 units covered in row major order).
  float offsetSampledData = sampledData + valueOffset - 1.0;
  vec2 colorTexCoord = vec2(mod(offsetSampledData, multiFeatureTexSize) / multiFeatureTexSize, floor(offsetSampledData / multiFeatureTexSize) / (valueTexHeight - 1.));

  // Get expression value
  float expressionValue = texture(valueTex, colorTexCoord).r / 255.;
  float scaledExpressionValue = (expressionValue - rangeStart) / max(0.005, (rangeEnd - rangeStart));


  // Get set color index value
  vec2 setIndicesTexCoord = vec2(mod(offsetSampledData, multiFeatureTexSize) / multiFeatureTexSize, floor(offsetSampledData / multiFeatureTexSize) / (valueTexHeight - 1.));
  float setColorIndex = texture(valueTex, setIndicesTexCoord).r;

  // Initialize to the default "null" color.
  vec3 setColor = vec3(200. / 255., 200. / 255., 200. / 255.);
  if(setColorIndex != 0.) {
    // Subtract one from setColorIndex because we have already checked for the "null" value.
    setColorIndex = setColorIndex - 1.;

    float setColorOffsetR = (setColorIndex + setColorOffset) * 3.0 + 0.0;
    vec2 setColorTexCoordR = vec2(mod(setColorOffsetR, multiFeatureTexSize) / multiFeatureTexSize, floor(setColorOffsetR / multiFeatureTexSize) / (colorTexHeight - 1.));
    float setColorR = texture(colorTex, setColorTexCoordR).r / 255.;

    float setColorOffsetG = (setColorIndex + setColorOffset) * 3.0 + 1.0;
    vec2 setColorTexCoordG = vec2(mod(setColorOffsetG, multiFeatureTexSize) / multiFeatureTexSize, floor(setColorOffsetG / multiFeatureTexSize) / (colorTexHeight - 1.));
    float setColorG = texture(colorTex, setColorTexCoordG).r / 255.;

    float setColorOffsetB = (setColorIndex + setColorOffset) * 3.0 + 2.0;
    vec2 setColorTexCoordB = vec2(mod(setColorOffsetB, multiFeatureTexSize) / multiFeatureTexSize, floor(setColorOffsetB / multiFeatureTexSize) / (colorTexHeight - 1.));
    float setColorB = texture(colorTex, setColorTexCoordB).r / 255.;

    setColor = vec3(setColorR, setColorG, setColorB);
  }

  
  vec4 sampledColor = (1. - (float(isStaticColorMode) + float(isSetColorMode))) * vec4(COLORMAP_FUNC(clamp(scaledExpressionValue, 0.0, 1.0)).rgb, channelOpacity) + float(isStaticColorMode) * vec4(channelColor.rgb, channelOpacity) + float(isSetColorMode) * vec4(setColor, channelOpacity);
  // Only return a color if the data is non-zero.
  
  return clampedSampledDataAndIsOn * isEdge * sampledColor;
}

void main() {

  // Get the color and alpha value for each channel.
  vec3 dat0 = sampleAndGetData(channel0, vTexCoord, channelsFilled[0], channelStrokeWidths[0], channelsVisible[0]);
  vec3 dat1 = sampleAndGetData(channel1, vTexCoord, channelsFilled[1], channelStrokeWidths[1], channelsVisible[1]);
  vec3 dat2 = sampleAndGetData(channel2, vTexCoord, channelsFilled[2], channelStrokeWidths[2], channelsVisible[2]);
  vec3 dat3 = sampleAndGetData(channel3, vTexCoord, channelsFilled[3], channelStrokeWidths[3], channelsVisible[3]);
  vec3 dat4 = sampleAndGetData(channel4, vTexCoord, channelsFilled[4], channelStrokeWidths[4], channelsVisible[4]);
  vec3 dat5 = sampleAndGetData(channel5, vTexCoord, channelsFilled[5], channelStrokeWidths[5], channelsVisible[5]);
  vec3 dat6 = sampleAndGetData(channel6, vTexCoord, channelsFilled[6], channelStrokeWidths[6], channelsVisible[6]);
  
  vec4 val0 = dataToColor(dat0, channelIsStaticColorMode[0], color0, channelOpacities[0], valueTexOffsets[0], channelColormapRangeStarts[0], channelColormapRangeEnds[0], channelIsSetColorMode[0], colorTexOffsets[0]);
  vec4 val1 = dataToColor(dat1, channelIsStaticColorMode[1], color1, channelOpacities[1], valueTexOffsets[1], channelColormapRangeStarts[1], channelColormapRangeEnds[1], channelIsSetColorMode[1], colorTexOffsets[1]);
  vec4 val2 = dataToColor(dat2, channelIsStaticColorMode[2], color2, channelOpacities[2], valueTexOffsets[2], channelColormapRangeStarts[2], channelColormapRangeEnds[2], channelIsSetColorMode[2], colorTexOffsets[2]);
  vec4 val3 = dataToColor(dat3, channelIsStaticColorMode[3], color3, channelOpacities[3], valueTexOffsets[3], channelColormapRangeStarts[3], channelColormapRangeEnds[3], channelIsSetColorMode[3], colorTexOffsets[3]);
  vec4 val4 = dataToColor(dat4, channelIsStaticColorMode[4], color4, channelOpacities[4], valueTexOffsets[4], channelColormapRangeStarts[4], channelColormapRangeEnds[4], channelIsSetColorMode[4], colorTexOffsets[4]);
  vec4 val5 = dataToColor(dat5, channelIsStaticColorMode[5], color5, channelOpacities[5], valueTexOffsets[5], channelColormapRangeStarts[5], channelColormapRangeEnds[5], channelIsSetColorMode[5], colorTexOffsets[5]);
  vec4 val6 = dataToColor(dat6, channelIsStaticColorMode[6], color6, channelOpacities[6], valueTexOffsets[6], channelColormapRangeStarts[6], channelColormapRangeEnds[6], channelIsSetColorMode[6], colorTexOffsets[6]);
  
  // If all of the channels are "empty", then discard this pixel so that it is not considered during picking.
  float emptyDat = 0.;
  if(dat0.x == emptyDat && dat1.x == emptyDat && dat2.x == emptyDat && dat3.x == emptyDat && dat4.x == emptyDat && dat5.x == emptyDat && dat6.x == emptyDat) {
    discard;
  }
  
  // If the next channel color and the currently stored color (gl_FragColor) are identical,
  // or the next channel color is transparent black,
  // just use the currently stored color. Repeat this for all channels.

  // Mix colors where necessary, using the alpha value of the next channel as the weight.
  // Use the maximum alpha value as the resulting alpha value.
  gl_FragColor = val0;
  gl_FragColor = (val1 == gl_FragColor || val1 == vec4(0.)) ? gl_FragColor : vec4(mix(gl_FragColor, val1, val1.a).rgb, max(gl_FragColor.a, val1.a));
  gl_FragColor = (val2 == gl_FragColor || val2 == vec4(0.)) ? gl_FragColor : vec4(mix(gl_FragColor, val2, val2.a).rgb, max(gl_FragColor.a, val2.a));
  gl_FragColor = (val3 == gl_FragColor || val3 == vec4(0.)) ? gl_FragColor : vec4(mix(gl_FragColor, val3, val3.a).rgb, max(gl_FragColor.a, val3.a));
  gl_FragColor = (val4 == gl_FragColor || val4 == vec4(0.)) ? gl_FragColor : vec4(mix(gl_FragColor, val4, val4.a).rgb, max(gl_FragColor.a, val4.a));
  gl_FragColor = (val5 == gl_FragColor || val5 == vec4(0.)) ? gl_FragColor : vec4(mix(gl_FragColor, val5, val5.a).rgb, max(gl_FragColor.a, val5.a));
  gl_FragColor = (val6 == gl_FragColor || val6 == vec4(0.)) ? gl_FragColor : vec4(mix(gl_FragColor, val6, val6.a).rgb, max(gl_FragColor.a, val6.a));

  

  // TODO: multiply the resulting channel-level opacity value by the layer-level opacity value.

  geometry.uv = vTexCoord;
  DECKGL_FILTER_COLOR(gl_FragColor, geometry);
}
`;
function J$n(t) {
  const [e, n] = fa(t), r = 255 / (n - e);
  return new Uint8Array(t.map((o) => Math.floor((o - e) * r)));
}
function K$n(t, e, n, r, i) {
  let o = 0, s = 0;
  r.forEach((I, m) => {
    I ? (s += (n[m]?.setColors?.length || 0) * 3, o += n[m]?.obsIndex ? pve(n[m].obsIndex.map((C) => parseInt(C))) : 0) : o += e[m] ? pve(e[m].map((C) => parseInt(C))) : t[m]?.length || 0;
  });
  const a = Math.max(2, Math.ceil(o / i)), A = Math.max(2, Math.ceil(s / i));
  a > i && console.error("Error: length of concatenated quantitative feature values larger than maximum texture size"), A > i && console.error("Error: length of concatenated quantitative feature values larger than maximum texture size");
  const l = new Uint8Array(i * a), c = new Uint8Array(i * A), u = [], f = [];
  let h = 0, d = 0;
  return r.forEach((I, m) => {
    const C = e[m], y = C === null;
    if (I) {
      const { setColorIndices: v, setColors: b, obsIndex: Q } = n[m] || {};
      if (v && b && Q) {
        for (let w = 0; w < Q.length; w++) {
          let R = String(w + 1), M = w;
          y || (R = Q[w], M = parseInt(R) - 1);
          const O = v.get(R);
          l[h + M] = O === void 0 ? 0 : O + 1;
        }
        for (let w = 0; w < b.length; w++) {
          const { color: [R, M, O] } = b[w];
          c[(d + w) * 3 + 0] = R, c[(d + w) * 3 + 1] = M, c[(d + w) * 3 + 2] = O;
        }
      }
      u.push(h), f.push(d), h += Q?.length || 0, d += b?.length || 0;
    } else {
      const v = t[m], b = J$n(v);
      if (!y && C)
        for (let Q = 0; Q < C.length; Q++) {
          const w = C[Q], R = parseInt(w) - 1;
          l[h + R] = b[Q];
        }
      else
        l.set(b, h);
      u.push(h), h += v.length, f.push(d);
    }
  }), [
    l,
    a,
    u,
    c,
    A,
    f
  ];
}
const yh = 7, t3 = 2048;
function tp(t, e, n) {
  const r = [...t];
  for (let i = 0; i < n; i += 1)
    r.push(e);
  return r;
}
function W$n(t) {
  return t ? t.map((e) => e / 255) : [0, 0, 0];
}
function n3(t, e) {
  return t === e ? !0 : Array.isArray(t) && Array.isArray(e) && t.length === e.length ? !t.some((n, r) => n !== e[r] && (!Array.isArray(n) && !Array.isArray(e[r]) || n.length > 0 || e[r].length > 0)) : t === e;
}
const X$n = {
  channelStrokeWidths: { type: "array", value: null, compare: !0 },
  channelsFilled: { type: "array", value: null, compare: !0 },
  channelOpacities: { type: "array", value: null, compare: !0 },
  channelColors: { type: "array", value: null, compare: !0 },
  hoveredCell: { type: "number", value: null, compare: !0 },
  colormap: { type: "string", value: u0, compare: !0 },
  expressionData: { type: "object", value: null, compare: !0 },
  multiFeatureValues: { type: "array", value: null, compare: !0 },
  multiMatrixObsIndex: { type: "array", value: null, compare: !0 },
  setColorValues: { type: "array", value: null, compare: !0 },
  channelFeatureValueColormaps: { type: "array", value: null, compare: !0 },
  channelFeatureValueColormapRanges: { type: "array", value: null, compare: !0 },
  channelIsStaticColorMode: { type: "array", value: null, compare: !0 },
  channelIsSetColorMode: { type: "array", value: null, compare: !0 }
};
class _fe extends ix {
  // eslint-disable-next-line class-methods-use-this
  getShaders() {
    const { colormap: e } = this.props;
    return {
      fs: V$n,
      vs: z$n,
      modules: [qA, jA],
      defines: {
        [lB]: ME.includes(e) ? e : u0
      }
    };
  }
  /**
   * Override the parent loadChannelTextures to enable
   * up to eight channels (rather than six).
   * Reference: https://github.com/hms-dbmi/viv/blob/v0.13.3/packages/layers/src/xr-layer/xr-layer.js#L316
  */
  loadChannelTextures(e) {
    const n = {
      channel0: null,
      channel1: null,
      channel2: null,
      channel3: null,
      channel4: null,
      channel5: null,
      channel6: null
    };
    this.state.textures && Object.values(this.state.textures).forEach((r) => r && r.delete()), e && Object.keys(e).length > 0 && e.data && (e.data.forEach((r, i) => {
      n[`channel${i}`] = this.dataToTexture(r, e.width, e.height);
    }, this), this.setState({ textures: n }));
  }
  updateState({ props: e, oldProps: n, changeFlags: r }) {
    if (super.updateState({ props: e, oldProps: n, changeFlags: r }), !n3(e.multiFeatureValues, n.multiFeatureValues) || !n3(e.multiMatrixObsIndex, n.multiMatrixObsIndex) || !n3(e.setColorValues, n.setColorValues) || !n3(e.channelIsSetColorMode, n.channelIsSetColorMode)) {
      const { multiFeatureValues: i, multiMatrixObsIndex: o, setColorValues: s, channelIsSetColorMode: a } = this.props, [A, l, c, u, f, h] = this.multiSetsToTexture(i, o, s, a);
      this.setState({
        valueTex: A,
        colorTex: l,
        valueTexOffsets: c,
        colorTexOffsets: u,
        valueTexHeight: f,
        colorTexHeight: h
      });
    }
    if (e.colormap !== n.colormap) {
      const { gl: i } = this.context;
      this.state.model && this.state.model.delete(), this.setState({ model: this._getModel(i) }), this.getAttributeManager().invalidateAll();
    }
  }
  draw(e) {
    const { uniforms: n } = e, {
      channelStrokeWidths: r,
      channelsFilled: i,
      channelOpacities: o,
      channelColors: s,
      channelsVisible: a,
      // TODO: use `channelFeatureValueColormaps` in shader,
      // figure out how to call multiple GLSL colormap functions
      channelFeatureValueColormaps: A,
      channelFeatureValueColormapRanges: l,
      channelIsStaticColorMode: c,
      channelIsSetColorMode: u,
      hoveredCell: f,
      colorScaleLo: h,
      colorScaleHi: d,
      isExpressionMode: I,
      zoom: m,
      minZoom: C,
      maxZoom: y,
      zoomOffset: v
      // TODO: figure out if this needs to be used or not
    } = this.props, {
      textures: b,
      model: Q,
      // Expression and set index (and colors) textures with offsets
      valueTex: w,
      colorTex: R,
      valueTexOffsets: M,
      colorTexOffsets: O,
      valueTexHeight: L,
      colorTexHeight: N
    } = this.state;
    if (b && Q) {
      const k = 1 / 2 ** (y - m), $ = ji(oA(yh).map((U) => [`color${U}`, W$n(s[U])]));
      Q.setUniforms(Object.assign({}, n, {
        ...$,
        // Bitmask image channel data textures
        ...b,
        multiFeatureTexSize: t3,
        // Expression textures with offsets
        valueTex: w,
        valueTexOffsets: tp(M, 0, yh - M.length),
        valueTexHeight: L,
        // Set indices and colors textures with offsets
        colorTex: R,
        colorTexOffsets: tp(O, 0, yh - O.length),
        colorTexHeight: N,
        // Visualization properties
        channelsFilled: tp(
          i,
          !0,
          // There are six texture entries on the shaders
          yh - i.length
        ),
        channelOpacities: tp(
          o,
          0,
          // There are six texture entries on the shaders
          yh - o.length
        ),
        channelStrokeWidths: tp(
          r,
          1,
          // There are six texture entries on the shaders
          yh - r.length
        ),
        channelColormapRangeStarts: tp(
          l.map((U) => U?.[0] || 0),
          0,
          // There are six texture entries on the shaders
          yh - l.length
        ),
        channelColormapRangeEnds: tp(
          l.map((U) => U?.[1] || 1),
          1,
          // There are six texture entries on the shaders
          yh - l.length
        ),
        channelIsStaticColorMode: tp(
          c,
          !0,
          // There are six texture entries on the shaders
          yh - c.length
        ),
        channelIsSetColorMode: tp(
          u,
          !1,
          // There are six texture entries on the shaders
          yh - u.length
        ),
        hovered: f || 0,
        channelsVisible: tp(
          a,
          !1,
          // There are six texture entries on the shaders
          yh - a.length
        ),
        // uColorScaleRange: [colorScaleLo, colorScaleHi],
        // uIsExpressionMode: isExpressionMode,
        // uIsOutlined: false,
        scaleFactor: k
      })).draw();
    }
  }
  /**
   * This function creates textures from the data
   */
  dataToTexture(e, n, r) {
    const i = Fr(this.context.gl);
    return new xo(this.context.gl, {
      width: n,
      height: r,
      // Only use Float32 so we don't have to write two shaders
      data: new Float32Array(e),
      // we don't want or need mimaps
      mipmaps: !1,
      parameters: {
        // NEAREST for integer data
        [gt.TEXTURE_MIN_FILTER]: gt.NEAREST,
        [gt.TEXTURE_MAG_FILTER]: gt.NEAREST,
        // CLAMP_TO_EDGE to remove tile artifacts
        [gt.TEXTURE_WRAP_S]: gt.CLAMP_TO_EDGE,
        [gt.TEXTURE_WRAP_T]: gt.CLAMP_TO_EDGE
      },
      format: i ? gt.R32F : gt.LUMINANCE,
      dataFormat: i ? gt.RED : gt.LUMINANCE,
      type: gt.FLOAT
    });
  }
  multiSetsToTexture(e, n, r, i) {
    const o = Fr(this.context.gl), [s, a, A, l, c, u] = K$n(e, n, r, i, t3);
    return [
      // Color indices texture
      new xo(this.context.gl, {
        width: t3,
        height: a,
        // Only use Float32 so we don't have to write two shaders
        data: new Float32Array(s),
        // we don't want or need mimaps
        mipmaps: !1,
        parameters: {
          // NEAREST for integer data
          [gt.TEXTURE_MIN_FILTER]: gt.NEAREST,
          [gt.TEXTURE_MAG_FILTER]: gt.NEAREST,
          // CLAMP_TO_EDGE to remove tile artifacts
          [gt.TEXTURE_WRAP_S]: gt.CLAMP_TO_EDGE,
          [gt.TEXTURE_WRAP_T]: gt.CLAMP_TO_EDGE
        },
        format: o ? gt.R32F : gt.LUMINANCE,
        dataFormat: o ? gt.RED : gt.LUMINANCE,
        type: gt.FLOAT
      }),
      // Colors texture
      new xo(this.context.gl, {
        width: t3,
        height: c,
        // Only use Float32 so we don't have to write two shaders
        data: new Float32Array(l),
        // we don't want or need mimaps
        mipmaps: !1,
        parameters: {
          // NEAREST for integer data
          [gt.TEXTURE_MIN_FILTER]: gt.NEAREST,
          [gt.TEXTURE_MAG_FILTER]: gt.NEAREST,
          // CLAMP_TO_EDGE to remove tile artifacts
          [gt.TEXTURE_WRAP_S]: gt.CLAMP_TO_EDGE,
          [gt.TEXTURE_WRAP_T]: gt.CLAMP_TO_EDGE
        },
        format: o ? gt.R32F : gt.LUMINANCE,
        dataFormat: o ? gt.RED : gt.LUMINANCE,
        type: gt.FLOAT
      }),
      // Offsets
      A,
      u,
      // Texture heights
      a,
      c
    ];
  }
}
_fe.layerName = "BitmaskLayer";
_fe.defaultProps = X$n;
const Sfe = kr(() => ({
  toolButton: {
    display: "inline-flex",
    "&:active": {
      opacity: ".65",
      extend: "iconClicked"
    }
  },
  tool: {
    position: "absolute",
    display: "inline",
    zIndex: "1000",
    opacity: ".65",
    color: "black",
    "&:hover": {
      opacity: ".90"
    }
  },
  iconClicked: {
    // Styles for the clicked state
    boxShadow: "none",
    transform: "scale(0.98)"
    // make the button slightly smaller
  },
  toolIcon: {
    // btn btn-outline-secondary mr-2 icon
    padding: "0",
    height: "2em",
    width: "2em",
    backgroundColor: "white",
    display: "inline-block",
    fontWeight: "400",
    textAlign: "center",
    verticalAlign: "middle",
    cursor: "pointer",
    userSelect: "none",
    border: "1px solid #6c757d",
    fontSize: "16px",
    lineHeight: "1.5",
    borderRadius: "4px",
    transition: "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    color: "#6c757d",
    marginRight: "8px",
    "& > svg": {
      verticalAlign: "middle",
      color: "black"
    },
    "&:active": {
      extend: "iconClicked"
    }
  },
  toolActive: {
    // active
    color: "#fff",
    backgroundColor: "#6c757d",
    borderColor: "#6c757d",
    boxShadow: "0 0 0 3px rgba(108, 117, 125, 0.5)"
  }
}));
function NDe(t) {
  const { alt: e, onClick: n, isActive: r, children: i } = t, o = Sfe();
  return ne.jsx("button", { className: Xt(o.toolIcon, { [o.toolActive]: r }), onClick: n, type: "button", title: e, children: i });
}
function Z$n(t) {
  const { alt: e, onClick: n, children: r } = t, i = Sfe();
  return ne.jsx("button", { className: Xt(i.toolIcon, i.toolButton), onClick: n, type: "button", title: e, children: r });
}
function eqn(t) {
  const { setActiveTool: e, activeTool: n, visibleTools: r = { pan: !0, selectLasso: !0 }, recenterOnClick: i = () => {
  } } = t, o = Sfe(), s = () => {
    i();
  };
  return ne.jsxs("div", { className: o.tool, children: [r.pan && ne.jsx(NDe, { alt: "pointer tool", onClick: () => e(null), isActive: n === null, children: ne.jsx(U6t, {}) }), r.selectLasso ? ne.jsx(NDe, { alt: "select lasso", onClick: () => e(jU.SELECTION_TYPE.POLYGON), isActive: n === jU.SELECTION_TYPE.POLYGON, children: ne.jsx(H6t, {}) }) : null, ne.jsx(Z$n, { alt: "click to recenter", onClick: () => s(), "aria-label": "Recenter scatterplot view", children: ne.jsx(Jkt, {}) })] });
}
const tqn = () => "crosshair", nqn = (t) => t.isDragging ? "grabbing" : "default";
function _Ke(t, e, n) {
  return (r) => {
    if (n && n(), r.index) {
      const i = t[r.index];
      e && e(i);
    } else
      e && e(null);
  };
}
class Qfe extends ise {
  constructor(e) {
    super(e), this.state = {
      gl: null,
      tool: null
    }, this.viewport = null, this.onViewStateChange = this.onViewStateChange.bind(this), this.onInitializeViewInfo = this.onInitializeViewInfo.bind(this), this.onWebGLInitialized = this.onWebGLInitialized.bind(this), this.onToolChange = this.onToolChange.bind(this), this.onHover = this.onHover.bind(this), this.recenter = this.recenter.bind(this);
  }
  /**
   * Called by DeckGL upon a viewState change,
   * for example zoom or pan interaction.
   * Emit the new viewState to the `setViewState`
   * handler prop.
   * @param {object} params
   * @param {object} params.viewState The next deck.gl viewState.
   */
  onViewStateChange({ viewState: e }) {
    const { setViewState: n, viewState: r, spatialAxisFixed: i } = this.props, o = this.use3d();
    n({
      ...e,
      // If the axis is fixed, just use the current target in state i.e don't change target.
      target: i && o ? r.target : e.target
    });
  }
  /**
   * Called by DeckGL upon viewport
   * initialization.
   * @param {object} viewState
   * @param {object} viewState.viewport
   */
  onInitializeViewInfo({ viewport: e }) {
    this.viewport = e;
  }
  /**
   * Called by DeckGL upon initialization,
   * helps to understand when to pass layers
   * to the DeckGL component.
   * @param {object} gl The WebGL context object.
   */
  onWebGLInitialized(e) {
    this.setState({ gl: e });
  }
  /**
   * Called by the ToolMenu buttons.
   * Emits the new tool value to the
   * `onToolChange` prop.
   * @param {string} tool Name of tool.
   */
  onToolChange(e) {
    const { onToolChange: n } = this.props;
    this.setState({ tool: e }), n && n(e);
  }
  /**
   * Create the DeckGL layers.
   * @returns {object[]} Array of
   * DeckGL layer objects.
   * Intended to be overriden by descendants.
   */
  // eslint-disable-next-line class-methods-use-this
  getLayers() {
    return [];
  }
  // TODO: remove this method and use the layer-level onHover instead.
  // (e.g., see delegateHover in spatial-beta/SpatialSubscriber.js).
  // eslint-disable-next-line consistent-return
  onHover(e) {
    const { coordinate: n, sourceLayer: r, tile: i } = e, { setCellHighlight: o, cellHighlight: s, setComponentHover: a, layers: A, setHoverInfo: l } = this.props, c = (A || []).some((w) => w.type === "bitmask");
    if (!o || !i)
      return null;
    if (!r || !n)
      return s && c && o(null), l && l(null, null), null;
    const { content: u, bbox: f, index: { z: h } } = i;
    if (!u)
      return s && c && o(null), l && l(null, null), null;
    const { data: d, width: I, height: m } = u, { left: C, right: y, top: v, bottom: b } = f, Q = [
      C,
      d.height < r.tileSize ? m : b,
      d.width < r.tileSize ? I : y,
      v
    ];
    if (!d)
      return s && c && o(null), null;
    if (r.id.includes("bitmask")) {
      const w = Math.max(1, 2 ** Math.round(-h)), R = [
        Math.floor((n[0] - Q[0]) / w),
        Math.floor((n[1] - Q[3]) / w)
      ], M = R[1] * I + R[0], O = d.map((N) => N[M]), L = O.find((N) => N > 0);
      L !== Number(s) && (a && a(), o(L ? String(L) : null)), l && (L ? l(O, n) : l(null, null));
    }
  }
  /**
   * Emits a function to project from the
   * cell ID space to the scatterplot or
   * spatial coordinate space, via the
   * `updateViewInfo` prop.
   */
  viewInfoDidUpdate(e, n, r) {
    const { updateViewInfo: i, uuid: o } = this.props, { viewport: s } = this;
    i && s && i({
      uuid: o,
      project: s.project,
      projectFromId: (a) => {
        try {
          if (e && n) {
            const A = r(n), l = e.indexOf(a), c = A(l);
            return s.project(c);
          }
          return [null, null];
        } catch {
          return [null, null];
        }
      }
    });
  }
  /**
   * Intended to be overridden by descendants.
   */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  componentDidUpdate() {
  }
  /** Intended to be overridden by descendants.
   * Resets the view type to its original position.
  */
  // eslint-disable-next-line class-methods-use-this
  recenter() {
  }
  /**
   * Intended to be overridden by descendants.
   * @returns {boolean} Whether or not any layers are 3D.
   */
  // eslint-disable-next-line class-methods-use-this
  use3d() {
    return !1;
  }
  /**
   * A common render function for both Spatial
   * and Scatterplot components.
   */
  render() {
    const { deckRef: e, viewState: n, uuid: r, hideTools: i, orbitAxis: o } = this.props, { gl: s, tool: a } = this.state, A = this.getLayers(), l = this.use3d(), c = this.obsSegmentationsData !== null, u = A.length > 0, f = !l && (this.obsSegmentationsData?.shape?.[0] < 1e5 || this.obsLocationsData?.shape?.[1] < 1e5);
    return ne.jsxs(ne.Fragment, { children: [ne.jsx(eqn, { activeTool: a, setActiveTool: this.onToolChange, visibleTools: {
      pan: u && !i,
      selectLasso: c && !i
    }, recenterOnClick: this.recenter }), ne.jsx(FYe, { id: `deckgl-overlay-${r}`, ref: e, views: [
      l ? new ice({ id: "orbit", controller: !0, orbitAxis: o }) : new Ig({
        id: "ortho"
      })
    ], layers: s && n.target.slice(0, 2).every((h) => typeof h == "number") ? A : [], glOptions: qGn, onWebGLInitialized: this.onWebGLInitialized, onViewStateChange: this.onViewStateChange, viewState: n, useDevicePixels: f, controller: a ? { dragPan: !1 } : !0, getCursor: a ? tqn : nqn, onHover: this.onHover, children: this.onInitializeViewInfo })] });
  }
}
function FD(t, e) {
  return t ? sle().x((r) => e(r)[0]).y((r) => e(r)[1]).addAll(oA(t.shape[1])) : null;
}
function LDe(t) {
  return () => t;
}
function MDe(t) {
  return t + (Math.random() - 0.5) * 1e-6;
}
function rqn() {
  let t, e, n = 1, r = 1, i, o = LDe([0, 0]);
  function s(c) {
    return c.x + c.vx + i[c.index][0] / 2;
  }
  function a(c) {
    return c.y + c.vy + i[c.index][1] / 2;
  }
  function A(c) {
    if (c.data)
      c.size = i[c.data.index];
    else {
      c.size = [0, 0];
      for (let u = 0; u < 4; u++)
        c[u] && c[u].size && (c.size[0] = Math.max(c.size[0], c[u].size[0]), c.size[1] = Math.max(c.size[1], c[u].size[1]));
    }
  }
  function l() {
    let c, u, f, h, d;
    const I = sle(t, s, a).visitAfter(A);
    function m(y, v, b, Q, w) {
      const { data: R } = y, M = (u[0] + y.size[0]) / 2, O = (u[1] + y.size[1]) / 2;
      if (R && R.index > c.index) {
        let L = MDe(h - s(R)), N = MDe(d - a(R));
        const k = Math.abs(L) - M, $ = Math.abs(N) - O;
        if (k < 0 && $ < 0) {
          const U = Math.sqrt(L * L + N * N), X = e[R.index] / (f + e[R.index]);
          Math.abs(k) < Math.abs($) ? (c.vx -= (L *= k / U * n) * X, R.vx += L * (1 - X)) : (c.vy -= (N *= $ / U * n) * X, R.vy += N * (1 - X));
        }
        return v > h + M || Q < h - M || b > d + O || w < d - O;
      }
      return !1;
    }
    function C() {
      for (let y = 0; y < t.length; y++)
        c = t[y], u = i[y], f = e[y], h = s(c), d = a(c), I.visit(m);
    }
    for (let y = 0; y < r; y++)
      C();
  }
  return l.initialize = (c) => {
    t = c, i = t.map(o), e = i.map((u) => u[0] + u[1]);
  }, l.iterations = (...c) => c.length ? (r = +c[0], l) : r, l.strength = (...c) => c.length ? (n = +c[0], l) : n, l.size = (...c) => c.length ? (o = typeof c[0] == "function" ? c[0] : LDe(c[0]), l) : o, l;
}
function SKe(t, e, n, r, i, o) {
  const A = 1 / t, l = 2 ** e, c = 2 / (n * l / i), u = 2 / (r * l / o), f = Math.sqrt(i ** 2 + o ** 2), I = 5e-4 / Math.sqrt(c ** 2 + u ** 2) * f;
  return Su(I, A, 10);
}
function QKe(t, e, n, r, i, o, s) {
  const a = o, [A, l, c, u] = new Ig({ zoom: t }).makeViewport({
    height: i,
    width: r,
    viewState: { zoom: t, target: [0, 0, 0] }
  }).getBounds(), f = u - l, h = c - A, d = e, I = n, m = r, C = i;
  let y = s;
  y || (y = Math.min(1, 1 / 10 ** (Math.log10(a) - 3)));
  const v = y * m * C / a * (I / h) * (d / f);
  return Su(v, 1.01 / 255, 1);
}
const ODe = "scatterplot", iqn = "-apple-system, 'Helvetica Neue', Arial, sans-serif", oqn = 100, sqn = 0.25, aqn = (t, e, n) => (r, { index: i }) => {
  const [o, s, a, A] = t && e && t.get(e[i]) || da(n);
  return [o, s, a, 255 * (A || 1)];
}, FDe = (t) => (e) => [
  t.data[0][e],
  t.data[1][e],
  0
], Aqn = (t) => (e) => [
  t.data[0][e],
  -t.data[1][e],
  0
], lqn = (t, { index: e, data: n, target: r }) => (r[0] = n.src.obsEmbedding.data[0][e], r[1] = -n.src.obsEmbedding.data[1][e], r[2] = 0, r);
class cqn extends Qfe {
  constructor(e) {
    super(e), this.cellsQuadTree = null, this.cellsLayer = null, this.cellsData = null, this.cellSetsForceSimulation = rqn(), this.cellSetsLabelPrevZoom = null, this.cellSetsLayers = [], this.onUpdateCellsData(), this.onUpdateCellsLayer(), this.onUpdateCellSetsLayers();
  }
  createCellsLayer() {
    const {
      obsEmbeddingIndex: e,
      theme: n,
      cellRadius: r = 1,
      cellOpacity: i = 1,
      // cellFilter,
      cellSelection: o,
      setCellHighlight: s,
      setComponentHover: a,
      getCellIsSelected: A,
      cellColors: l,
      getCellColor: c = aqn(l, e, n),
      getExpressionValue: u,
      onCellClick: f,
      geneExpressionColormap: h,
      geneExpressionColormapRange: d = [0, 1],
      cellColorEncoding: I
    } = this.props;
    return new LI({
      id: ODe,
      // Note that the reference for the object passed to the data prop should not change,
      // otherwise DeckGL will need to do a full re-render every time .createCellsLayer is called,
      // which can be very often to handle cellOpacity and cellRadius updates for dynamic opacity.
      data: this.cellsData,
      coordinateSystem: wn.CARTESIAN,
      visible: !0,
      pickable: !0,
      autoHighlight: !0,
      filled: !0,
      stroked: !0,
      backgroundColor: n === "dark" ? [0, 0, 0] : [241, 241, 241],
      getCellIsSelected: A,
      opacity: i,
      radiusScale: r,
      radiusMinPixels: 1,
      radiusMaxPixels: 30,
      // Our radius pixel setters measure in pixels.
      radiusUnits: "pixels",
      lineWidthUnits: "pixels",
      getPosition: lqn,
      getFillColor: c,
      getLineColor: c,
      getRadius: 1,
      getExpressionValue: u,
      getLineWidth: 0,
      extensions: [
        new oQ(),
        new VVe({ instanced: !0 })
      ],
      colorScaleLo: d[0],
      colorScaleHi: d[1],
      isExpressionMode: I === "geneSelection",
      colormap: h,
      onClick: (m) => {
        f && f(m);
      },
      onHover: _Ke(e, s, a),
      updateTriggers: {
        getExpressionValue: u,
        getFillColor: [I, o, l],
        getLineColor: [I, o, l],
        getCellIsSelected: A
      }
    });
  }
  createCellSetsLayers() {
    const { theme: e, cellSetPolygons: n, viewState: r, cellSetPolygonsVisible: i, cellSetLabelsVisible: o, cellSetLabelSize: s } = this.props, a = [];
    if (i && a.push(new Pf({
      id: "cell-sets-polygon-layer",
      data: n,
      stroked: !0,
      filled: !1,
      wireframe: !0,
      lineWidthMaxPixels: 1,
      getPolygon: (A) => A.hull,
      getLineColor: (A) => A.color,
      getLineWidth: 1
    })), o) {
      const { zoom: A } = r, l = n.map((u) => ({
        x: u.centroid[0],
        y: u.centroid[1],
        label: u.name
      })), c = this.cellSetsForceSimulation.size((u) => [
        s * 1 / 2 ** A * 4 * u.label.length,
        s * 1 / 2 ** A * 1.5
      ]);
      vrn().nodes(l).force("collision", c).tick(oqn), a.push(new Eg({
        id: "cell-sets-text-layer",
        data: l,
        getPosition: (u) => [u.x, u.y],
        getText: (u) => u.label,
        getColor: e === "dark" ? [255, 255, 255] : [0, 0, 0],
        getSize: s,
        getAngle: 0,
        getTextAnchor: "middle",
        getAlignmentBaseline: "center",
        fontFamily: iqn,
        fontWeight: "normal"
      }));
    }
    return a;
  }
  createSelectionLayer() {
    const { obsEmbeddingIndex: e, obsEmbedding: n, viewState: r, setCellSelection: i } = this.props, { tool: o } = this.state, { cellsQuadTree: s } = this, a = !0, A = FDe(n);
    return $ue(o, r.zoom, ODe, [
      {
        getObsCoords: A,
        obsIndex: e,
        obsQuadTree: s,
        onSelect: (l) => {
          i(l);
        }
      }
    ], a);
  }
  getLayers() {
    const { cellsLayer: e, cellSetsLayers: n } = this;
    return [
      e,
      ...n,
      this.createSelectionLayer()
    ];
  }
  onUpdateCellsData() {
    const { obsEmbedding: e } = this.props;
    if (e) {
      const n = FDe(e);
      this.cellsQuadTree = FD(e, n), this.cellsData = {
        src: {
          obsEmbedding: e
        },
        length: e.shape[1]
      };
    }
  }
  onUpdateCellsLayer() {
    const { obsEmbeddingIndex: e, obsEmbedding: n } = this.props;
    e && n ? this.cellsLayer = this.createCellsLayer() : this.cellsLayer = null;
  }
  onUpdateCellSetsLayers(e) {
    if (e) {
      const { viewState: n, cellSetLabelsVisible: r } = this.props, { zoom: i } = n, { cellSetsLabelPrevZoom: o } = this;
      r && (o === null || Math.abs(o - i) > sqn) && (this.cellSetsLayers = this.createCellSetsLayers(), this.cellSetsLabelPrevZoom = i);
    } else
      this.cellSetsLayers = this.createCellSetsLayers();
  }
  viewInfoDidUpdate() {
    const { obsEmbeddingIndex: e, obsEmbedding: n } = this.props;
    super.viewInfoDidUpdate(e, n, Aqn);
  }
  /**
   * Here, asynchronously check whether props have
   * updated which require re-computing memoized variables,
   * followed by a re-render.
   * This function does not follow React conventions or paradigms,
   * it is only implemented this way to try to squeeze out
   * performance.
   * @param {object} prevProps The previous props to diff against.
   */
  componentDidUpdate(e) {
    this.viewInfoDidUpdate();
    const n = (i) => e[i] !== this.props[i];
    let r = !1;
    ["obsEmbedding"].some(n) && (this.onUpdateCellsData(), r = !0), [
      "obsEmbeddingIndex",
      "obsEmbedding",
      "cellFilter",
      "cellSelection",
      "cellColors",
      "cellRadius",
      "cellOpacity",
      "cellRadiusMode",
      "geneExpressionColormap",
      "geneExpressionColormapRange",
      "geneSelection",
      "cellColorEncoding",
      "getExpressionValue"
    ].some(n) && (this.onUpdateCellsLayer(), r = !0), [
      "cellSetPolygons",
      "cellSetPolygonsVisible",
      "cellSetLabelsVisible",
      "cellSetLabelSize"
    ].some(n) && (this.onUpdateCellSetsLayers(!1), r = !0), n("viewState") && (this.onUpdateCellSetsLayers(!0), r = !0), r && this.forceUpdate();
  }
  recenter() {
    const { originalViewState: e, setViewState: n } = this.props;
    Array.isArray(e?.target) && typeof e?.zoom == "number" && n(e);
  }
}
const wfe = CE((t, e) => ne.jsx(cqn, { ...t, deckRef: e }));
wfe.displayName = "ScatterplotWrapper";
function wKe(t) {
  const { children: e, observationsLabel: n, cellRadius: r, setCellRadius: i, cellRadiusMode: o, setCellRadiusMode: s, cellOpacity: a, setCellOpacity: A, cellOpacityMode: l, setCellOpacityMode: c, cellSetLabelsVisible: u, setCellSetLabelsVisible: f, tooltipsVisible: h, setTooltipsVisible: d, cellSetLabelSize: I, setCellSetLabelSize: m, cellSetPolygonsVisible: C, setCellSetPolygonsVisible: y, cellColorEncoding: v, setCellColorEncoding: b, geneExpressionColormap: Q, setGeneExpressionColormap: w, geneExpressionColormapRange: R, setGeneExpressionColormapRange: M } = t, O = Jr(), L = Ci(n), N = VI();
  function k(pe) {
    s(pe.target.value);
  }
  function $(pe) {
    c(pe.target.value);
  }
  function U(pe, Ce) {
    i(Ce);
  }
  function X(pe, Ce) {
    A(Ce);
  }
  function K(pe) {
    f(pe.target.checked);
  }
  function z(pe) {
    d(pe.target.checked);
  }
  function Y(pe, Ce) {
    m(Ce);
  }
  function V(pe) {
    y(pe.target.checked);
  }
  function Z(pe) {
    w(pe.target.value);
  }
  function ce(pe, Ce) {
    M(Ce);
  }
  const ee = Qn(Bd(ce, 5, { trailing: !0 }), [ce]);
  return ne.jsxs(NL, { children: [e, ne.jsx(Z8e, { observationsLabel: n, cellColorEncoding: v, setCellColorEncoding: b }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: N.labelCell, variant: "head", scope: "row", children: ne.jsxs("label", { htmlFor: `scatterplot-set-labels-visible-${O}`, children: [L, " Set Labels Visible"] }) }), ne.jsx(br, { className: N.inputCell, variant: "body", children: ne.jsx(ds, { className: N.checkbox, checked: u, onChange: K, name: "scatterplot-option-cell-set-labels", color: "default", inputProps: {
    "aria-label": "Show or hide set labels",
    id: `scatterplot-set-labels-visible-${O}`
  } }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: N.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `scatterplot-set-tooltips-visible-${O}`, children: "Tooltips Visible" }) }), ne.jsx(br, { className: N.inputCell, variant: "body", children: ne.jsx(ds, {
    className: N.checkbox,
    /**
     * We have to use "checked" here, not "value".
     * The checkbox state is not persisting with value.
     * For reference, https://v4.mui.com/api/checkbox/
     */
    checked: h,
    onChange: z,
    name: "scatterplot-option-tooltip-visibility",
    color: "default",
    inputProps: {
      "aria-label": "Show or hide tooltips",
      id: `scatterplot-set-tooltips-visible-${O}`
    }
  }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: N.labelCell, variant: "head", scope: "row", children: ne.jsxs("label", { htmlFor: `scatterplot-set-label-size-${O}`, children: [L, " Set Label Size"] }) }), ne.jsx(br, { className: N.inputCell, variant: "body", children: ne.jsx(ps, { classes: { root: N.slider, valueLabel: N.sliderValueLabel }, disabled: !u, value: I, onChange: Y, "aria-label": "Scatterplot label size slider", id: `scatterplot-set-label-size-${O}`, valueLabelDisplay: "auto", step: 1, min: 8, max: 36 }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: N.labelCell, variant: "head", scope: "row", children: ne.jsxs("label", { htmlFor: `scatterplot-set-polygons-visible-${O}`, children: [L, " Set Polygons Visible"] }) }), ne.jsx(br, { className: N.inputCell, variant: "body", children: ne.jsx(ds, { className: N.checkbox, checked: C, onChange: V, name: "scatterplot-option-cell-set-polygons", color: "default", inputProps: {
    "aria-label": "Show or hide polygons",
    id: `scatterplot-set-polygons-visible-${O}`
  } }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: N.labelCell, variant: "head", scope: "row", children: ne.jsxs("label", { htmlFor: `scatterplot-set-radius-mode-select-${O}`, children: [L, " Radius Mode"] }) }), ne.jsx(br, { className: N.inputCell, variant: "body", children: ne.jsxs(nd, { className: N.select, value: o, onChange: k, inputProps: {
    id: `scatterplot-set-radius-mode-select-${O}`
  }, children: [ne.jsx("option", { value: "auto", children: "Auto" }), ne.jsx("option", { value: "manual", children: "Manual" })] }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: N.labelCell, variant: "head", scope: "row", children: ne.jsxs("label", { htmlFor: `scatterplot-set-radius-size-select-${O}`, children: [L, " Radius Size"] }) }), ne.jsx(br, { className: N.inputCell, variant: "body", children: ne.jsx(ps, { classes: { root: N.slider, valueLabel: N.sliderValueLabel }, disabled: o !== "manual", value: r, onChange: U, "aria-label": "Scatterplot radius size slider", id: `scatterplot-set-radius-size-select-${O}`, valueLabelDisplay: "auto", step: 0.01, min: 0.01, max: 10 }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: N.labelCell, variant: "head", scope: "row", children: ne.jsxs("label", { htmlFor: `scatterplot-set-opacity-mode-${O}`, children: [L, " Opacity Mode"] }) }), ne.jsx(br, { className: N.inputCell, variant: "body", children: ne.jsxs(nd, { className: N.select, value: l, onChange: $, inputProps: {
    id: `scatterplot-set-opacity-mode-${O}`
  }, children: [ne.jsx("option", { value: "auto", children: "Auto" }), ne.jsx("option", { value: "manual", children: "Manual" })] }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: N.labelCell, variant: "head", scope: "row", children: ne.jsxs("label", { htmlFor: `scatterplot-set-opacity-level-${O}`, children: [L, " Opacity Level"] }) }), ne.jsx(br, { className: N.inputCell, variant: "body", children: ne.jsx(ps, { classes: { root: N.slider, valueLabel: N.sliderValueLabel }, disabled: l !== "manual", value: a, onChange: X, "aria-label": "Scatterplot opacity level slider", id: `scatterplot-set-opacity-level-${O}`, valueLabelDisplay: "auto", step: 0.05, min: 0, max: 1 }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: N.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `scatterplot-gene-expression-colormap-${O}`, children: "Gene Expression Colormap" }) }), ne.jsx(br, { className: N.inputCell, variant: "body", children: ne.jsx(nd, { className: N.select, value: Q, onChange: Z, inputProps: {
    id: `scatterplot-gene-expression-colormap-${O}`
  }, children: ME.map((pe) => ne.jsx("option", { value: pe, children: pe }, pe)) }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: N.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `scatterplot-gene-expression-colormap-range-${O}`, children: "Gene Expression Colormap Range" }) }), ne.jsx(br, { className: N.inputCell, variant: "body", children: ne.jsx(ps, { classes: { root: N.slider, valueLabel: N.sliderValueLabel }, value: R, onChange: ee, getAriaLabel: (pe) => `${pe === 0 ? "Low value slider" : "High value slider"} for scatterplot gene expression colormap range`, id: `scatterplot-gene-expression-colormap-range-${O}`, valueLabelDisplay: "auto", step: 5e-3, min: 0, max: 1 }) })] })] });
}
const xKe = kr((t) => ({
  tooltipAnchor: {
    position: "relative",
    width: "0px",
    height: "0px",
    pointerEvents: "none",
    userSelect: "none"
  },
  tooltipContent: {
    opacity: 0.9,
    padding: "5px",
    pointerEvents: "none",
    backgroundColor: t.palette.gridLayoutBackground,
    "& table > tbody > tr > th, & table > tbody > tr > td": {
      border: "none",
      fontSize: "12px",
      lineHeight: 1.43,
      opacity: 0.8,
      outline: 0,
      padding: "0 2px !important",
      textAlign: "left",
      color: t.palette.tooltipText,
      backgroundColor: t.palette.gridLayoutBackground
    },
    "& table > tr:nth-child(2)": {
      backgroundColor: "inherit !important"
    },
    "& table": {
      borderCollapse: "collapse",
      marginBottom: "0px"
    }
  }
}));
function uqn(t) {
  const { x: e, y: n, parentWidth: r, parentHeight: i, children: o } = t, s = Zr(), a = xKe(), [A, l] = mn("start"), [c, u] = mn("bottom"), f = jae(s);
  return Mn(() => {
    if (s && s.current) {
      const h = e > r / 2, d = n > i / 2;
      l(h ? "end" : "start"), u(d ? "top" : "bottom"), s.current.style.left = `${e + (h ? -20 : 5)}px`, s.current.style.top = `${n + (d ? -20 : 5)}px`;
    }
  }, [e, n, r, i]), ne.jsx("div", { ref: s, className: a.tooltipAnchor, children: s && s.current ? ne.jsx(vGe, { open: !0, anchorEl: s.current, container: f, transition: !0, placement: `${c}-${A}`, children: ne.jsx(r0, { elevation: 4, className: a.tooltipContent, children: o }) }) : null });
}
const fqn = kr((t) => ({
  cellEmphasisCrosshair: {
    zIndex: 50,
    position: "absolute",
    pointerEvents: "none",
    boxSizing: "border-box",
    backgroundColor: t.palette.secondaryForeground
  }
}));
function Tq(t) {
  const { parentUuid: e, sourceUuid: n, x: r, y: i, parentWidth: o, parentHeight: s, children: a } = t, A = fqn();
  if (r < 0 || r > o || i < 0 || i > s)
    return null;
  const l = e === n, c = 1;
  return ne.jsx(ne.Fragment, { children: l ? ne.jsx(uqn, { x: r, y: i, parentWidth: o, parentHeight: s, children: a }) : ne.jsxs(ne.Fragment, { children: [r !== null ? ne.jsx("div", { className: A.cellEmphasisCrosshair, style: {
    left: `${r - c / 2}px`,
    top: 0,
    width: `${c}px`,
    height: `${s}px`
  } }) : null, i !== null ? ne.jsx("div", { className: A.cellEmphasisCrosshair, style: {
    left: 0,
    top: `${i - c / 2}px`,
    width: `${o}px`,
    height: `${c}px`
  } }) : null] }) });
}
function Nq(t) {
  const { info: e } = t;
  return ne.jsx("table", { children: ne.jsx("tbody", { children: Object.entries(e).map(([n, r]) => ne.jsxs("tr", { children: [ne.jsx("th", { children: n }), ne.jsx("td", { children: r })] }, n)) }) });
}
function RKe(t) {
  const { parentUuid: e, obsHighlight: n, width: r, height: i, getObsInfo: o } = t, s = JH(), a = KH(e), [A, l, c] = n && o ? [
    o(n),
    ...a && a.projectFromId ? a.projectFromId(n) : [null, null]
  ] : [null, null, null];
  return A ? ne.jsx(Tq, { x: l, y: c, parentUuid: e, sourceUuid: s, parentWidth: r, parentHeight: i, children: ne.jsx(Nq, { info: A }) }) : null;
}
function gqn(t) {
  const { visible: e, message: n } = t;
  return e ? ne.jsx("div", { children: n }) : null;
}
var fre = "http://www.w3.org/1999/xhtml";
const PDe = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: fre,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function DKe(t) {
  var e = t += "", n = e.indexOf(":");
  return n >= 0 && (e = t.slice(0, n)) !== "xmlns" && (t = t.slice(n + 1)), PDe.hasOwnProperty(e) ? { space: PDe[e], local: t } : t;
}
function hqn(t) {
  return function() {
    var e = this.ownerDocument, n = this.namespaceURI;
    return n === fre && e.documentElement.namespaceURI === fre ? e.createElement(t) : e.createElementNS(n, t);
  };
}
function dqn(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function TKe(t) {
  var e = DKe(t);
  return (e.local ? dqn : hqn)(e);
}
function pqn() {
}
function NKe(t) {
  return t == null ? pqn : function() {
    return this.querySelector(t);
  };
}
function Iqn(t) {
  typeof t != "function" && (t = NKe(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var o = e[i], s = o.length, a = r[i] = new Array(s), A, l, c = 0; c < s; ++c)
      (A = o[c]) && (l = t.call(A, A.__data__, c, o)) && ("__data__" in A && (l.__data__ = A.__data__), a[c] = l);
  return new $g(r, this._parents);
}
function mqn(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function Cqn() {
  return [];
}
function Eqn(t) {
  return t == null ? Cqn : function() {
    return this.querySelectorAll(t);
  };
}
function yqn(t) {
  return function() {
    return mqn(t.apply(this, arguments));
  };
}
function vqn(t) {
  typeof t == "function" ? t = yqn(t) : t = Eqn(t);
  for (var e = this._groups, n = e.length, r = [], i = [], o = 0; o < n; ++o)
    for (var s = e[o], a = s.length, A, l = 0; l < a; ++l)
      (A = s[l]) && (r.push(t.call(A, A.__data__, l, s)), i.push(A));
  return new $g(r, i);
}
function Bqn(t) {
  return function() {
    return this.matches(t);
  };
}
function LKe(t) {
  return function(e) {
    return e.matches(t);
  };
}
var bqn = Array.prototype.find;
function _qn(t) {
  return function() {
    return bqn.call(this.children, t);
  };
}
function Sqn() {
  return this.firstElementChild;
}
function Qqn(t) {
  return this.select(t == null ? Sqn : _qn(typeof t == "function" ? t : LKe(t)));
}
var wqn = Array.prototype.filter;
function xqn() {
  return Array.from(this.children);
}
function Rqn(t) {
  return function() {
    return wqn.call(this.children, t);
  };
}
function Dqn(t) {
  return this.selectAll(t == null ? xqn : Rqn(typeof t == "function" ? t : LKe(t)));
}
function Tqn(t) {
  typeof t != "function" && (t = Bqn(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var o = e[i], s = o.length, a = r[i] = [], A, l = 0; l < s; ++l)
      (A = o[l]) && t.call(A, A.__data__, l, o) && a.push(A);
  return new $g(r, this._parents);
}
function MKe(t) {
  return new Array(t.length);
}
function Nqn() {
  return new $g(this._enter || this._groups.map(MKe), this._parents);
}
function z8(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
z8.prototype = {
  constructor: z8,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function Lqn(t) {
  return function() {
    return t;
  };
}
function Mqn(t, e, n, r, i, o) {
  for (var s = 0, a, A = e.length, l = o.length; s < l; ++s)
    (a = e[s]) ? (a.__data__ = o[s], r[s] = a) : n[s] = new z8(t, o[s]);
  for (; s < A; ++s)
    (a = e[s]) && (i[s] = a);
}
function Oqn(t, e, n, r, i, o, s) {
  var a, A, l = /* @__PURE__ */ new Map(), c = e.length, u = o.length, f = new Array(c), h;
  for (a = 0; a < c; ++a)
    (A = e[a]) && (f[a] = h = s.call(A, A.__data__, a, e) + "", l.has(h) ? i[a] = A : l.set(h, A));
  for (a = 0; a < u; ++a)
    h = s.call(t, o[a], a, o) + "", (A = l.get(h)) ? (r[a] = A, A.__data__ = o[a], l.delete(h)) : n[a] = new z8(t, o[a]);
  for (a = 0; a < c; ++a)
    (A = e[a]) && l.get(f[a]) === A && (i[a] = A);
}
function Fqn(t) {
  return t.__data__;
}
function Pqn(t, e) {
  if (!arguments.length)
    return Array.from(this, Fqn);
  var n = e ? Oqn : Mqn, r = this._parents, i = this._groups;
  typeof t != "function" && (t = Lqn(t));
  for (var o = i.length, s = new Array(o), a = new Array(o), A = new Array(o), l = 0; l < o; ++l) {
    var c = r[l], u = i[l], f = u.length, h = kqn(t.call(c, c && c.__data__, l, r)), d = h.length, I = a[l] = new Array(d), m = s[l] = new Array(d), C = A[l] = new Array(f);
    n(c, u, I, m, C, h, e);
    for (var y = 0, v = 0, b, Q; y < d; ++y)
      if (b = I[y]) {
        for (y >= v && (v = y + 1); !(Q = m[v]) && ++v < d; )
          ;
        b._next = Q || null;
      }
  }
  return s = new $g(s, r), s._enter = a, s._exit = A, s;
}
function kqn(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function Gqn() {
  return new $g(this._exit || this._groups.map(MKe), this._parents);
}
function Uqn(t, e, n) {
  var r = this.enter(), i = this, o = this.exit();
  return typeof t == "function" ? (r = t(r), r && (r = r.selection())) : r = r.append(t + ""), e != null && (i = e(i), i && (i = i.selection())), n == null ? o.remove() : n(o), r && i ? r.merge(i).order() : i;
}
function Hqn(t) {
  for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, o = r.length, s = Math.min(i, o), a = new Array(i), A = 0; A < s; ++A)
    for (var l = n[A], c = r[A], u = l.length, f = a[A] = new Array(u), h, d = 0; d < u; ++d)
      (h = l[d] || c[d]) && (f[d] = h);
  for (; A < i; ++A)
    a[A] = n[A];
  return new $g(a, this._parents);
}
function $qn() {
  for (var t = this._groups, e = -1, n = t.length; ++e < n; )
    for (var r = t[e], i = r.length - 1, o = r[i], s; --i >= 0; )
      (s = r[i]) && (o && s.compareDocumentPosition(o) ^ 4 && o.parentNode.insertBefore(s, o), o = s);
  return this;
}
function qqn(t) {
  t || (t = jqn);
  function e(u, f) {
    return u && f ? t(u.__data__, f.__data__) : !u - !f;
  }
  for (var n = this._groups, r = n.length, i = new Array(r), o = 0; o < r; ++o) {
    for (var s = n[o], a = s.length, A = i[o] = new Array(a), l, c = 0; c < a; ++c)
      (l = s[c]) && (A[c] = l);
    A.sort(e);
  }
  return new $g(i, this._parents).order();
}
function jqn(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Yqn() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function zqn() {
  return Array.from(this);
}
function Vqn() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, o = r.length; i < o; ++i) {
      var s = r[i];
      if (s)
        return s;
    }
  return null;
}
function Jqn() {
  let t = 0;
  for (const e of this)
    ++t;
  return t;
}
function Kqn() {
  return !this.node();
}
function Wqn(t) {
  for (var e = this._groups, n = 0, r = e.length; n < r; ++n)
    for (var i = e[n], o = 0, s = i.length, a; o < s; ++o)
      (a = i[o]) && t.call(a, a.__data__, o, i);
  return this;
}
function Xqn(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function Zqn(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function ejn(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function tjn(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function njn(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}
function rjn(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}
function ijn(t, e) {
  var n = DKe(t);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((e == null ? n.local ? Zqn : Xqn : typeof e == "function" ? n.local ? rjn : njn : n.local ? tjn : ejn)(n, e));
}
function OKe(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function ojn(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function sjn(t, e, n) {
  return function() {
    this.style.setProperty(t, e, n);
  };
}
function ajn(t, e, n) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}
function Ajn(t, e, n) {
  return arguments.length > 1 ? this.each((e == null ? ojn : typeof e == "function" ? ajn : sjn)(t, e, n ?? "")) : ljn(this.node(), t);
}
function ljn(t, e) {
  return t.style.getPropertyValue(e) || OKe(t).getComputedStyle(t, null).getPropertyValue(e);
}
function cjn(t) {
  return function() {
    delete this[t];
  };
}
function ujn(t, e) {
  return function() {
    this[t] = e;
  };
}
function fjn(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? delete this[t] : this[t] = n;
  };
}
function gjn(t, e) {
  return arguments.length > 1 ? this.each((e == null ? cjn : typeof e == "function" ? fjn : ujn)(t, e)) : this.node()[t];
}
function FKe(t) {
  return t.trim().split(/^|\s+/);
}
function xfe(t) {
  return t.classList || new PKe(t);
}
function PKe(t) {
  this._node = t, this._names = FKe(t.getAttribute("class") || "");
}
PKe.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function kKe(t, e) {
  for (var n = xfe(t), r = -1, i = e.length; ++r < i; )
    n.add(e[r]);
}
function GKe(t, e) {
  for (var n = xfe(t), r = -1, i = e.length; ++r < i; )
    n.remove(e[r]);
}
function hjn(t) {
  return function() {
    kKe(this, t);
  };
}
function djn(t) {
  return function() {
    GKe(this, t);
  };
}
function pjn(t, e) {
  return function() {
    (e.apply(this, arguments) ? kKe : GKe)(this, t);
  };
}
function Ijn(t, e) {
  var n = FKe(t + "");
  if (arguments.length < 2) {
    for (var r = xfe(this.node()), i = -1, o = n.length; ++i < o; )
      if (!r.contains(n[i]))
        return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? pjn : e ? hjn : djn)(n, e));
}
function mjn() {
  this.textContent = "";
}
function Cjn(t) {
  return function() {
    this.textContent = t;
  };
}
function Ejn(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function yjn(t) {
  return arguments.length ? this.each(t == null ? mjn : (typeof t == "function" ? Ejn : Cjn)(t)) : this.node().textContent;
}
function vjn() {
  this.innerHTML = "";
}
function Bjn(t) {
  return function() {
    this.innerHTML = t;
  };
}
function bjn(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function _jn(t) {
  return arguments.length ? this.each(t == null ? vjn : (typeof t == "function" ? bjn : Bjn)(t)) : this.node().innerHTML;
}
function Sjn() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function Qjn() {
  return this.each(Sjn);
}
function wjn() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function xjn() {
  return this.each(wjn);
}
function Rjn(t) {
  var e = typeof t == "function" ? t : TKe(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function Djn() {
  return null;
}
function Tjn(t, e) {
  var n = typeof t == "function" ? t : TKe(t), r = e == null ? Djn : typeof e == "function" ? e : NKe(e);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function Njn() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function Ljn() {
  return this.each(Njn);
}
function Mjn() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function Ojn() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function Fjn(t) {
  return this.select(t ? Ojn : Mjn);
}
function Pjn(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function kjn(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function Gjn(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var n = "", r = e.indexOf(".");
    return r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), { type: e, name: n };
  });
}
function Ujn(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var n = 0, r = -1, i = e.length, o; n < i; ++n)
        o = e[n], (!t.type || o.type === t.type) && o.name === t.name ? this.removeEventListener(o.type, o.listener, o.options) : e[++r] = o;
      ++r ? e.length = r : delete this.__on;
    }
  };
}
function Hjn(t, e, n) {
  return function() {
    var r = this.__on, i, o = kjn(e);
    if (r) {
      for (var s = 0, a = r.length; s < a; ++s)
        if ((i = r[s]).type === t.type && i.name === t.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = o, i.options = n), i.value = e;
          return;
        }
    }
    this.addEventListener(t.type, o, n), i = { type: t.type, name: t.name, value: e, listener: o, options: n }, r ? r.push(i) : this.__on = [i];
  };
}
function $jn(t, e, n) {
  var r = Gjn(t + ""), i, o = r.length, s;
  if (arguments.length < 2) {
    var a = this.node().__on;
    if (a) {
      for (var A = 0, l = a.length, c; A < l; ++A)
        for (i = 0, c = a[A]; i < o; ++i)
          if ((s = r[i]).type === c.type && s.name === c.name)
            return c.value;
    }
    return;
  }
  for (a = e ? Hjn : Ujn, i = 0; i < o; ++i)
    this.each(a(r[i], e, n));
  return this;
}
function UKe(t, e, n) {
  var r = OKe(t), i = r.CustomEvent;
  typeof i == "function" ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
}
function qjn(t, e) {
  return function() {
    return UKe(this, t, e);
  };
}
function jjn(t, e) {
  return function() {
    return UKe(this, t, e.apply(this, arguments));
  };
}
function Yjn(t, e) {
  return this.each((typeof e == "function" ? jjn : qjn)(t, e));
}
function* zjn() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, o = r.length, s; i < o; ++i)
      (s = r[i]) && (yield s);
}
var Vjn = [null];
function $g(t, e) {
  this._groups = t, this._parents = e;
}
function Jjn() {
  return this;
}
$g.prototype = {
  constructor: $g,
  select: Iqn,
  selectAll: vqn,
  selectChild: Qqn,
  selectChildren: Dqn,
  filter: Tqn,
  data: Pqn,
  enter: Nqn,
  exit: Gqn,
  join: Uqn,
  merge: Hqn,
  selection: Jjn,
  order: $qn,
  sort: qqn,
  call: Yqn,
  nodes: zqn,
  node: Vqn,
  size: Jqn,
  empty: Kqn,
  each: Wqn,
  attr: ijn,
  style: Ajn,
  property: gjn,
  classed: Ijn,
  text: yjn,
  html: _jn,
  raise: Qjn,
  lower: xjn,
  append: Rjn,
  insert: Tjn,
  remove: Ljn,
  clone: Fjn,
  datum: Pjn,
  on: $jn,
  dispatch: Yjn,
  [Symbol.iterator]: zjn
};
function Kjn(t) {
  return typeof t == "string" ? new $g([[document.querySelector(t)]], [document.documentElement]) : new $g([[t]], Vjn);
}
function Wjn(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function Xjn(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
    default: {
      this.domain(t), typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
  }
  return this;
}
function Rfe(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function HKe(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e)
    n[r] = e[r];
  return n;
}
function zM() {
}
var uN = 0.7, V8 = 1 / uN, tS = "\\s*([+-]?\\d+)\\s*", fN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", Lp = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Zjn = /^#([0-9a-f]{3,8})$/, eYn = new RegExp("^rgb\\(" + [tS, tS, tS] + "\\)$"), tYn = new RegExp("^rgb\\(" + [Lp, Lp, Lp] + "\\)$"), nYn = new RegExp("^rgba\\(" + [tS, tS, tS, fN] + "\\)$"), rYn = new RegExp("^rgba\\(" + [Lp, Lp, Lp, fN] + "\\)$"), iYn = new RegExp("^hsl\\(" + [fN, Lp, Lp] + "\\)$"), oYn = new RegExp("^hsla\\(" + [fN, Lp, Lp, fN] + "\\)$"), kDe = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Rfe(zM, gN, {
  copy: function(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: GDe,
  // Deprecated! Use color.formatHex.
  formatHex: GDe,
  formatHsl: sYn,
  formatRgb: UDe,
  toString: UDe
});
function GDe() {
  return this.rgb().formatHex();
}
function sYn() {
  return $Ke(this).formatHsl();
}
function UDe() {
  return this.rgb().formatRgb();
}
function gN(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = Zjn.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), n === 6 ? HDe(e) : n === 3 ? new Rf(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : n === 8 ? r3(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : n === 4 ? r3(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = eYn.exec(t)) ? new Rf(e[1], e[2], e[3], 1) : (e = tYn.exec(t)) ? new Rf(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = nYn.exec(t)) ? r3(e[1], e[2], e[3], e[4]) : (e = rYn.exec(t)) ? r3(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = iYn.exec(t)) ? jDe(e[1], e[2] / 100, e[3] / 100, 1) : (e = oYn.exec(t)) ? jDe(e[1], e[2] / 100, e[3] / 100, e[4]) : kDe.hasOwnProperty(t) ? HDe(kDe[t]) : t === "transparent" ? new Rf(NaN, NaN, NaN, 0) : null;
}
function HDe(t) {
  return new Rf(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function r3(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new Rf(t, e, n, r);
}
function aYn(t) {
  return t instanceof zM || (t = gN(t)), t ? (t = t.rgb(), new Rf(t.r, t.g, t.b, t.opacity)) : new Rf();
}
function J8(t, e, n, r) {
  return arguments.length === 1 ? aYn(t) : new Rf(t, e, n, r ?? 1);
}
function Rf(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
Rfe(Rf, J8, HKe(zM, {
  brighter: function(t) {
    return t = t == null ? V8 : Math.pow(V8, t), new Rf(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker: function(t) {
    return t = t == null ? uN : Math.pow(uN, t), new Rf(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: $De,
  // Deprecated! Use color.formatHex.
  formatHex: $De,
  formatRgb: qDe,
  toString: qDe
}));
function $De() {
  return "#" + iK(this.r) + iK(this.g) + iK(this.b);
}
function qDe() {
  var t = this.opacity;
  return t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t)), (t === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (t === 1 ? ")" : ", " + t + ")");
}
function iK(t) {
  return t = Math.max(0, Math.min(255, Math.round(t) || 0)), (t < 16 ? "0" : "") + t.toString(16);
}
function jDe(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new Cp(t, e, n, r);
}
function $Ke(t) {
  if (t instanceof Cp)
    return new Cp(t.h, t.s, t.l, t.opacity);
  if (t instanceof zM || (t = gN(t)), !t)
    return new Cp();
  if (t instanceof Cp)
    return t;
  t = t.rgb();
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, i = Math.min(e, n, r), o = Math.max(e, n, r), s = NaN, a = o - i, A = (o + i) / 2;
  return a ? (e === o ? s = (n - r) / a + (n < r) * 6 : n === o ? s = (r - e) / a + 2 : s = (e - n) / a + 4, a /= A < 0.5 ? o + i : 2 - o - i, s *= 60) : a = A > 0 && A < 1 ? 0 : s, new Cp(s, a, A, t.opacity);
}
function AYn(t, e, n, r) {
  return arguments.length === 1 ? $Ke(t) : new Cp(t, e, n, r ?? 1);
}
function Cp(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
Rfe(Cp, AYn, HKe(zM, {
  brighter: function(t) {
    return t = t == null ? V8 : Math.pow(V8, t), new Cp(this.h, this.s, this.l * t, this.opacity);
  },
  darker: function(t) {
    return t = t == null ? uN : Math.pow(uN, t), new Cp(this.h, this.s, this.l * t, this.opacity);
  },
  rgb: function() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * e, i = 2 * n - r;
    return new Rf(
      oK(t >= 240 ? t - 240 : t + 120, i, r),
      oK(t, i, r),
      oK(t < 120 ? t + 240 : t - 120, i, r),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function() {
    var t = this.opacity;
    return t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t)), (t === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (t === 1 ? ")" : ", " + t + ")");
  }
}));
function oK(t, e, n) {
  return (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e) * 255;
}
const Dfe = (t) => () => t;
function lYn(t, e) {
  return function(n) {
    return t + n * e;
  };
}
function cYn(t, e, n) {
  return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function(r) {
    return Math.pow(t + r * e, n);
  };
}
function uYn(t) {
  return (t = +t) == 1 ? qKe : function(e, n) {
    return n - e ? cYn(e, n, t) : Dfe(isNaN(e) ? n : e);
  };
}
function qKe(t, e) {
  var n = e - t;
  return n ? lYn(t, n) : Dfe(isNaN(t) ? e : t);
}
const gre = function t(e) {
  var n = uYn(e);
  function r(i, o) {
    var s = n((i = J8(i)).r, (o = J8(o)).r), a = n(i.g, o.g), A = n(i.b, o.b), l = qKe(i.opacity, o.opacity);
    return function(c) {
      return i.r = s(c), i.g = a(c), i.b = A(c), i.opacity = l(c), i + "";
    };
  }
  return r.gamma = t, r;
}(1);
function fYn(t, e) {
  e || (e = []);
  var n = t ? Math.min(e.length, t.length) : 0, r = e.slice(), i;
  return function(o) {
    for (i = 0; i < n; ++i)
      r[i] = t[i] * (1 - o) + e[i] * o;
    return r;
  };
}
function gYn(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function hYn(t, e) {
  var n = e ? e.length : 0, r = t ? Math.min(n, t.length) : 0, i = new Array(r), o = new Array(n), s;
  for (s = 0; s < r; ++s)
    i[s] = ax(t[s], e[s]);
  for (; s < n; ++s)
    o[s] = e[s];
  return function(a) {
    for (s = 0; s < r; ++s)
      o[s] = i[s](a);
    return o;
  };
}
function dYn(t, e) {
  var n = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(r) {
    return n.setTime(t * (1 - r) + e * r), n;
  };
}
function K8(t, e) {
  return t = +t, e = +e, function(n) {
    return t * (1 - n) + e * n;
  };
}
function pYn(t, e) {
  var n = {}, r = {}, i;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (i in e)
    i in t ? n[i] = ax(t[i], e[i]) : r[i] = e[i];
  return function(o) {
    for (i in n)
      r[i] = n[i](o);
    return r;
  };
}
var hre = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, sK = new RegExp(hre.source, "g");
function IYn(t) {
  return function() {
    return t;
  };
}
function mYn(t) {
  return function(e) {
    return t(e) + "";
  };
}
function CYn(t, e) {
  var n = hre.lastIndex = sK.lastIndex = 0, r, i, o, s = -1, a = [], A = [];
  for (t = t + "", e = e + ""; (r = hre.exec(t)) && (i = sK.exec(e)); )
    (o = i.index) > n && (o = e.slice(n, o), a[s] ? a[s] += o : a[++s] = o), (r = r[0]) === (i = i[0]) ? a[s] ? a[s] += i : a[++s] = i : (a[++s] = null, A.push({ i: s, x: K8(r, i) })), n = sK.lastIndex;
  return n < e.length && (o = e.slice(n), a[s] ? a[s] += o : a[++s] = o), a.length < 2 ? A[0] ? mYn(A[0].x) : IYn(e) : (e = A.length, function(l) {
    for (var c = 0, u; c < e; ++c)
      a[(u = A[c]).i] = u.x(l);
    return a.join("");
  });
}
function ax(t, e) {
  var n = typeof e, r;
  return e == null || n === "boolean" ? Dfe(e) : (n === "number" ? K8 : n === "string" ? (r = gN(e)) ? (e = r, gre) : CYn : e instanceof gN ? gre : e instanceof Date ? dYn : gYn(e) ? fYn : Array.isArray(e) ? hYn : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? pYn : K8)(t, e);
}
function jKe(t, e) {
  return t = +t, e = +e, function(n) {
    return Math.round(t * (1 - n) + e * n);
  };
}
function EYn(t, e) {
  e === void 0 && (e = t, t = ax);
  for (var n = 0, r = e.length - 1, i = e[0], o = new Array(r < 0 ? 0 : r); n < r; )
    o[n] = t(i, i = e[++n]);
  return function(s) {
    var a = Math.max(0, Math.min(r - 1, Math.floor(s *= r)));
    return o[a](s - a);
  };
}
function yYn(t, e) {
  for (var n = new Array(e), r = 0; r < e; ++r)
    n[r] = t(r / (e - 1));
  return n;
}
function vYn(t) {
  return function() {
    return t;
  };
}
function BYn(t) {
  return +t;
}
var YDe = [0, 1];
function fC(t) {
  return t;
}
function dre(t, e) {
  return (e -= t = +t) ? function(n) {
    return (n - t) / e;
  } : vYn(isNaN(e) ? NaN : 0.5);
}
function bYn(t, e) {
  var n;
  return t > e && (n = t, t = e, e = n), function(r) {
    return Math.max(t, Math.min(e, r));
  };
}
function _Yn(t, e, n) {
  var r = t[0], i = t[1], o = e[0], s = e[1];
  return i < r ? (r = dre(i, r), o = n(s, o)) : (r = dre(r, i), o = n(o, s)), function(a) {
    return o(r(a));
  };
}
function SYn(t, e, n) {
  var r = Math.min(t.length, e.length) - 1, i = new Array(r), o = new Array(r), s = -1;
  for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++s < r; )
    i[s] = dre(t[s], t[s + 1]), o[s] = n(e[s], e[s + 1]);
  return function(a) {
    var A = SL(t, a, 1, r) - 1;
    return o[A](i[A](a));
  };
}
function QYn(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function wYn() {
  var t = YDe, e = YDe, n = ax, r, i, o, s = fC, a, A, l;
  function c() {
    var f = Math.min(t.length, e.length);
    return s !== fC && (s = bYn(t[0], t[f - 1])), a = f > 2 ? SYn : _Yn, A = l = null, u;
  }
  function u(f) {
    return f == null || isNaN(f = +f) ? o : (A || (A = a(t.map(r), e, n)))(r(s(f)));
  }
  return u.invert = function(f) {
    return s(i((l || (l = a(e, t.map(r), K8)))(f)));
  }, u.domain = function(f) {
    return arguments.length ? (t = Array.from(f, BYn), c()) : t.slice();
  }, u.range = function(f) {
    return arguments.length ? (e = Array.from(f), c()) : e.slice();
  }, u.rangeRound = function(f) {
    return e = Array.from(f), n = jKe, c();
  }, u.clamp = function(f) {
    return arguments.length ? (s = f ? !0 : fC, c()) : s !== fC;
  }, u.interpolate = function(f) {
    return arguments.length ? (n = f, c()) : n;
  }, u.unknown = function(f) {
    return arguments.length ? (o = f, u) : o;
  }, function(f, h) {
    return r = f, i = h, c();
  };
}
function xYn() {
  return wYn()(fC, fC);
}
function RYn(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function W8(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0)
    return null;
  var n, r = t.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +t.slice(n + 1)
  ];
}
function AQ(t) {
  return t = W8(Math.abs(t)), t ? t[1] : NaN;
}
function DYn(t, e) {
  return function(n, r) {
    for (var i = n.length, o = [], s = 0, a = t[0], A = 0; i > 0 && a > 0 && (A + a + 1 > r && (a = Math.max(1, r - A)), o.push(n.substring(i -= a, i + a)), !((A += a + 1) > r)); )
      a = t[s = (s + 1) % t.length];
    return o.reverse().join(e);
  };
}
function TYn(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(n) {
      return t[+n];
    });
  };
}
var NYn = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function X8(t) {
  if (!(e = NYn.exec(t)))
    throw new Error("invalid format: " + t);
  var e;
  return new Tfe({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
X8.prototype = Tfe.prototype;
function Tfe(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
Tfe.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function LYn(t) {
  e:
    for (var e = t.length, n = 1, r = -1, i; n < e; ++n)
      switch (t[n]) {
        case ".":
          r = i = n;
          break;
        case "0":
          r === 0 && (r = n), i = n;
          break;
        default:
          if (!+t[n])
            break e;
          r > 0 && (r = 0);
          break;
      }
  return r > 0 ? t.slice(0, r) + t.slice(i + 1) : t;
}
var YKe;
function MYn(t, e) {
  var n = W8(t, e);
  if (!n)
    return t + "";
  var r = n[0], i = n[1], o = i - (YKe = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, s = r.length;
  return o === s ? r : o > s ? r + new Array(o - s + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + W8(t, Math.max(0, e + o - 1))[0];
}
function zDe(t, e) {
  var n = W8(t, e);
  if (!n)
    return t + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const VDe = {
  "%": function(t, e) {
    return (t * 100).toFixed(e);
  },
  b: function(t) {
    return Math.round(t).toString(2);
  },
  c: function(t) {
    return t + "";
  },
  d: RYn,
  e: function(t, e) {
    return t.toExponential(e);
  },
  f: function(t, e) {
    return t.toFixed(e);
  },
  g: function(t, e) {
    return t.toPrecision(e);
  },
  o: function(t) {
    return Math.round(t).toString(8);
  },
  p: function(t, e) {
    return zDe(t * 100, e);
  },
  r: zDe,
  s: MYn,
  X: function(t) {
    return Math.round(t).toString(16).toUpperCase();
  },
  x: function(t) {
    return Math.round(t).toString(16);
  }
};
function JDe(t) {
  return t;
}
var KDe = Array.prototype.map, WDe = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function OYn(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? JDe : DYn(KDe.call(t.grouping, Number), t.thousands + ""), n = t.currency === void 0 ? "" : t.currency[0] + "", r = t.currency === void 0 ? "" : t.currency[1] + "", i = t.decimal === void 0 ? "." : t.decimal + "", o = t.numerals === void 0 ? JDe : TYn(KDe.call(t.numerals, String)), s = t.percent === void 0 ? "%" : t.percent + "", a = t.minus === void 0 ? "-" : t.minus + "", A = t.nan === void 0 ? "NaN" : t.nan + "";
  function l(u) {
    u = X8(u);
    var f = u.fill, h = u.align, d = u.sign, I = u.symbol, m = u.zero, C = u.width, y = u.comma, v = u.precision, b = u.trim, Q = u.type;
    Q === "n" ? (y = !0, Q = "g") : VDe[Q] || (v === void 0 && (v = 12), b = !0, Q = "g"), (m || f === "0" && h === "=") && (m = !0, f = "0", h = "=");
    var w = I === "$" ? n : I === "#" && /[boxX]/.test(Q) ? "0" + Q.toLowerCase() : "", R = I === "$" ? r : /[%p]/.test(Q) ? s : "", M = VDe[Q], O = /[defgprs%]/.test(Q);
    v = v === void 0 ? 6 : /[gprs]/.test(Q) ? Math.max(1, Math.min(21, v)) : Math.max(0, Math.min(20, v));
    function L(N) {
      var k = w, $ = R, U, X, K;
      if (Q === "c")
        $ = M(N) + $, N = "";
      else {
        N = +N;
        var z = N < 0 || 1 / N < 0;
        if (N = isNaN(N) ? A : M(Math.abs(N), v), b && (N = LYn(N)), z && +N == 0 && d !== "+" && (z = !1), k = (z ? d === "(" ? d : a : d === "-" || d === "(" ? "" : d) + k, $ = (Q === "s" ? WDe[8 + YKe / 3] : "") + $ + (z && d === "(" ? ")" : ""), O) {
          for (U = -1, X = N.length; ++U < X; )
            if (K = N.charCodeAt(U), 48 > K || K > 57) {
              $ = (K === 46 ? i + N.slice(U + 1) : N.slice(U)) + $, N = N.slice(0, U);
              break;
            }
        }
      }
      y && !m && (N = e(N, 1 / 0));
      var Y = k.length + N.length + $.length, V = Y < C ? new Array(C - Y + 1).join(f) : "";
      switch (y && m && (N = e(V + N, V.length ? C - $.length : 1 / 0), V = ""), h) {
        case "<":
          N = k + N + $ + V;
          break;
        case "=":
          N = k + V + N + $;
          break;
        case "^":
          N = V.slice(0, Y = V.length >> 1) + k + N + $ + V.slice(Y);
          break;
        default:
          N = V + k + N + $;
          break;
      }
      return o(N);
    }
    return L.toString = function() {
      return u + "";
    }, L;
  }
  function c(u, f) {
    var h = l((u = X8(u), u.type = "f", u)), d = Math.max(-8, Math.min(8, Math.floor(AQ(f) / 3))) * 3, I = Math.pow(10, -d), m = WDe[8 + d / 3];
    return function(C) {
      return h(I * C) + m;
    };
  }
  return {
    format: l,
    formatPrefix: c
  };
}
var i3, zKe, VKe;
FYn({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});
function FYn(t) {
  return i3 = OYn(t), zKe = i3.format, VKe = i3.formatPrefix, i3;
}
function PYn(t) {
  return Math.max(0, -AQ(Math.abs(t)));
}
function kYn(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(AQ(e) / 3))) * 3 - AQ(Math.abs(t)));
}
function GYn(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, AQ(e) - AQ(t)) + 1;
}
function UYn(t, e, n, r) {
  var i = rU(t, e, n), o;
  switch (r = X8(r ?? ",f"), r.type) {
    case "s": {
      var s = Math.max(Math.abs(t), Math.abs(e));
      return r.precision == null && !isNaN(o = kYn(i, s)) && (r.precision = o), VKe(r, s);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = GYn(i, Math.max(Math.abs(t), Math.abs(e)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = PYn(i)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return zKe(r);
}
function JKe(t) {
  var e = t.domain;
  return t.ticks = function(n) {
    var r = e();
    return nU(r[0], r[r.length - 1], n ?? 10);
  }, t.tickFormat = function(n, r) {
    var i = e();
    return UYn(i[0], i[i.length - 1], n ?? 10, r);
  }, t.nice = function(n) {
    n == null && (n = 10);
    var r = e(), i = 0, o = r.length - 1, s = r[i], a = r[o], A, l, c = 10;
    for (a < s && (l = s, s = a, a = l, l = i, i = o, o = l); c-- > 0; ) {
      if (l = qae(s, a, n), l === A)
        return r[i] = s, r[o] = a, e(r);
      if (l > 0)
        s = Math.floor(s / l) * l, a = Math.ceil(a / l) * l;
      else if (l < 0)
        s = Math.ceil(s * l) / l, a = Math.floor(a * l) / l;
      else
        break;
      A = l;
    }
    return t;
  }, t;
}
function KKe() {
  var t = xYn();
  return t.copy = function() {
    return QYn(t, KKe());
  }, Wjn.apply(t, arguments), JKe(t);
}
function HYn() {
  var t = 0, e = 1, n, r, i, o, s = fC, a = !1, A;
  function l(u) {
    return u == null || isNaN(u = +u) ? A : s(i === 0 ? 0.5 : (u = (o(u) - n) * i, a ? Math.max(0, Math.min(1, u)) : u));
  }
  l.domain = function(u) {
    return arguments.length ? ([t, e] = u, n = o(t = +t), r = o(e = +e), i = n === r ? 0 : 1 / (r - n), l) : [t, e];
  }, l.clamp = function(u) {
    return arguments.length ? (a = !!u, l) : a;
  }, l.interpolator = function(u) {
    return arguments.length ? (s = u, l) : s;
  };
  function c(u) {
    return function(f) {
      var h, d;
      return arguments.length ? ([h, d] = f, s = u(h, d), l) : [s(0), s(1)];
    };
  }
  return l.range = c(ax), l.rangeRound = c(jKe), l.unknown = function(u) {
    return arguments.length ? (A = u, l) : A;
  }, function(u) {
    return o = u, n = u(t), r = u(e), i = n === r ? 0 : 1 / (r - n), l;
  };
}
function $Yn(t, e) {
  return e.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown());
}
function WKe() {
  var t = JKe(HYn()(fC));
  return t.copy = function() {
    return $Yn(t, WKe());
  }, Xjn.apply(t, arguments);
}
function qYn(t) {
  return t;
}
var aK = 1, AK = 2, pre = 3, o3 = 4, XDe = 1e-6;
function jYn(t) {
  return "translate(" + t + ",0)";
}
function YYn(t) {
  return "translate(0," + t + ")";
}
function zYn(t) {
  return (e) => +t(e);
}
function VYn(t, e) {
  return e = Math.max(0, t.bandwidth() - e * 2) / 2, t.round() && (e = Math.round(e)), (n) => +t(n) + e;
}
function JYn() {
  return !this.__axis;
}
function KYn(t, e) {
  var n = [], r = null, i = null, o = 6, s = 6, a = 3, A = typeof window < "u" && window.devicePixelRatio > 1 ? 0 : 0.5, l = t === aK || t === o3 ? -1 : 1, c = t === o3 || t === AK ? "x" : "y", u = t === aK || t === pre ? jYn : YYn;
  function f(h) {
    var d = r ?? (e.ticks ? e.ticks.apply(e, n) : e.domain()), I = i ?? (e.tickFormat ? e.tickFormat.apply(e, n) : qYn), m = Math.max(o, 0) + a, C = e.range(), y = +C[0] + A, v = +C[C.length - 1] + A, b = (e.bandwidth ? VYn : zYn)(e.copy(), A), Q = h.selection ? h.selection() : h, w = Q.selectAll(".domain").data([null]), R = Q.selectAll(".tick").data(d, e).order(), M = R.exit(), O = R.enter().append("g").attr("class", "tick"), L = R.select("line"), N = R.select("text");
    w = w.merge(w.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), R = R.merge(O), L = L.merge(O.append("line").attr("stroke", "currentColor").attr(c + "2", l * o)), N = N.merge(O.append("text").attr("fill", "currentColor").attr(c, l * m).attr("dy", t === aK ? "0em" : t === pre ? "0.71em" : "0.32em")), h !== Q && (w = w.transition(h), R = R.transition(h), L = L.transition(h), N = N.transition(h), M = M.transition(h).attr("opacity", XDe).attr("transform", function(k) {
      return isFinite(k = b(k)) ? u(k + A) : this.getAttribute("transform");
    }), O.attr("opacity", XDe).attr("transform", function(k) {
      var $ = this.parentNode.__axis;
      return u(($ && isFinite($ = $(k)) ? $ : b(k)) + A);
    })), M.remove(), w.attr("d", t === o3 || t === AK ? s ? "M" + l * s + "," + y + "H" + A + "V" + v + "H" + l * s : "M" + A + "," + y + "V" + v : s ? "M" + y + "," + l * s + "V" + A + "H" + v + "V" + l * s : "M" + y + "," + A + "H" + v), R.attr("opacity", 1).attr("transform", function(k) {
      return u(b(k) + A);
    }), L.attr(c + "2", l * o), N.attr(c, l * m).text(I), Q.filter(JYn).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", t === AK ? "start" : t === o3 ? "end" : "middle"), Q.each(function() {
      this.__axis = b;
    });
  }
  return f.scale = function(h) {
    return arguments.length ? (e = h, f) : e;
  }, f.ticks = function() {
    return n = Array.from(arguments), f;
  }, f.tickArguments = function(h) {
    return arguments.length ? (n = h == null ? [] : Array.from(h), f) : n.slice();
  }, f.tickValues = function(h) {
    return arguments.length ? (r = h == null ? null : Array.from(h), f) : r && r.slice();
  }, f.tickFormat = function(h) {
    return arguments.length ? (i = h, f) : i;
  }, f.tickSize = function(h) {
    return arguments.length ? (o = s = +h, f) : o;
  }, f.tickSizeInner = function(h) {
    return arguments.length ? (o = +h, f) : o;
  }, f.tickSizeOuter = function(h) {
    return arguments.length ? (s = +h, f) : s;
  }, f.tickPadding = function(h) {
    return arguments.length ? (a = +h, f) : a;
  }, f.offset = function(h) {
    return arguments.length ? (A = +h, f) : A;
  }, f;
}
function WYn(t) {
  return KYn(pre, t);
}
var XYn = {
  jet: [{ index: 0, rgb: [0, 0, 131] }, { index: 0.125, rgb: [0, 60, 170] }, { index: 0.375, rgb: [5, 255, 255] }, { index: 0.625, rgb: [255, 255, 0] }, { index: 0.875, rgb: [250, 0, 0] }, { index: 1, rgb: [128, 0, 0] }],
  hsv: [{ index: 0, rgb: [255, 0, 0] }, { index: 0.169, rgb: [253, 255, 2] }, { index: 0.173, rgb: [247, 255, 2] }, { index: 0.337, rgb: [0, 252, 4] }, { index: 0.341, rgb: [0, 252, 10] }, { index: 0.506, rgb: [1, 249, 255] }, { index: 0.671, rgb: [2, 0, 253] }, { index: 0.675, rgb: [8, 0, 253] }, { index: 0.839, rgb: [255, 0, 251] }, { index: 0.843, rgb: [255, 0, 245] }, { index: 1, rgb: [255, 0, 6] }],
  hot: [{ index: 0, rgb: [0, 0, 0] }, { index: 0.3, rgb: [230, 0, 0] }, { index: 0.6, rgb: [255, 210, 0] }, { index: 1, rgb: [255, 255, 255] }],
  spring: [{ index: 0, rgb: [255, 0, 255] }, { index: 1, rgb: [255, 255, 0] }],
  summer: [{ index: 0, rgb: [0, 128, 102] }, { index: 1, rgb: [255, 255, 102] }],
  autumn: [{ index: 0, rgb: [255, 0, 0] }, { index: 1, rgb: [255, 255, 0] }],
  winter: [{ index: 0, rgb: [0, 0, 255] }, { index: 1, rgb: [0, 255, 128] }],
  bone: [{ index: 0, rgb: [0, 0, 0] }, { index: 0.376, rgb: [84, 84, 116] }, { index: 0.753, rgb: [169, 200, 200] }, { index: 1, rgb: [255, 255, 255] }],
  copper: [{ index: 0, rgb: [0, 0, 0] }, { index: 0.804, rgb: [255, 160, 102] }, { index: 1, rgb: [255, 199, 127] }],
  greys: [{ index: 0, rgb: [0, 0, 0] }, { index: 1, rgb: [255, 255, 255] }],
  yignbu: [{ index: 0, rgb: [8, 29, 88] }, { index: 0.125, rgb: [37, 52, 148] }, { index: 0.25, rgb: [34, 94, 168] }, { index: 0.375, rgb: [29, 145, 192] }, { index: 0.5, rgb: [65, 182, 196] }, { index: 0.625, rgb: [127, 205, 187] }, { index: 0.75, rgb: [199, 233, 180] }, { index: 0.875, rgb: [237, 248, 217] }, { index: 1, rgb: [255, 255, 217] }],
  greens: [{ index: 0, rgb: [0, 68, 27] }, { index: 0.125, rgb: [0, 109, 44] }, { index: 0.25, rgb: [35, 139, 69] }, { index: 0.375, rgb: [65, 171, 93] }, { index: 0.5, rgb: [116, 196, 118] }, { index: 0.625, rgb: [161, 217, 155] }, { index: 0.75, rgb: [199, 233, 192] }, { index: 0.875, rgb: [229, 245, 224] }, { index: 1, rgb: [247, 252, 245] }],
  yiorrd: [{ index: 0, rgb: [128, 0, 38] }, { index: 0.125, rgb: [189, 0, 38] }, { index: 0.25, rgb: [227, 26, 28] }, { index: 0.375, rgb: [252, 78, 42] }, { index: 0.5, rgb: [253, 141, 60] }, { index: 0.625, rgb: [254, 178, 76] }, { index: 0.75, rgb: [254, 217, 118] }, { index: 0.875, rgb: [255, 237, 160] }, { index: 1, rgb: [255, 255, 204] }],
  bluered: [{ index: 0, rgb: [0, 0, 255] }, { index: 1, rgb: [255, 0, 0] }],
  rdbu: [{ index: 0, rgb: [5, 10, 172] }, { index: 0.35, rgb: [106, 137, 247] }, { index: 0.5, rgb: [190, 190, 190] }, { index: 0.6, rgb: [220, 170, 132] }, { index: 0.7, rgb: [230, 145, 90] }, { index: 1, rgb: [178, 10, 28] }],
  picnic: [{ index: 0, rgb: [0, 0, 255] }, { index: 0.1, rgb: [51, 153, 255] }, { index: 0.2, rgb: [102, 204, 255] }, { index: 0.3, rgb: [153, 204, 255] }, { index: 0.4, rgb: [204, 204, 255] }, { index: 0.5, rgb: [255, 255, 255] }, { index: 0.6, rgb: [255, 204, 255] }, { index: 0.7, rgb: [255, 153, 255] }, { index: 0.8, rgb: [255, 102, 204] }, { index: 0.9, rgb: [255, 102, 102] }, { index: 1, rgb: [255, 0, 0] }],
  rainbow: [{ index: 0, rgb: [150, 0, 90] }, { index: 0.125, rgb: [0, 0, 200] }, { index: 0.25, rgb: [0, 25, 255] }, { index: 0.375, rgb: [0, 152, 255] }, { index: 0.5, rgb: [44, 255, 150] }, { index: 0.625, rgb: [151, 255, 0] }, { index: 0.75, rgb: [255, 234, 0] }, { index: 0.875, rgb: [255, 111, 0] }, { index: 1, rgb: [255, 0, 0] }],
  portland: [{ index: 0, rgb: [12, 51, 131] }, { index: 0.25, rgb: [10, 136, 186] }, { index: 0.5, rgb: [242, 211, 56] }, { index: 0.75, rgb: [242, 143, 56] }, { index: 1, rgb: [217, 30, 30] }],
  blackbody: [{ index: 0, rgb: [0, 0, 0] }, { index: 0.2, rgb: [230, 0, 0] }, { index: 0.4, rgb: [230, 210, 0] }, { index: 0.7, rgb: [255, 255, 255] }, { index: 1, rgb: [160, 200, 255] }],
  earth: [{ index: 0, rgb: [0, 0, 130] }, { index: 0.1, rgb: [0, 180, 180] }, { index: 0.2, rgb: [40, 210, 40] }, { index: 0.4, rgb: [230, 230, 50] }, { index: 0.6, rgb: [120, 70, 20] }, { index: 1, rgb: [255, 255, 255] }],
  electric: [{ index: 0, rgb: [0, 0, 0] }, { index: 0.15, rgb: [30, 0, 100] }, { index: 0.4, rgb: [120, 0, 100] }, { index: 0.6, rgb: [160, 90, 0] }, { index: 0.8, rgb: [230, 200, 0] }, { index: 1, rgb: [255, 250, 220] }],
  alpha: [{ index: 0, rgb: [255, 255, 255, 0] }, { index: 1, rgb: [255, 255, 255, 1] }],
  viridis: [{ index: 0, rgb: [68, 1, 84] }, { index: 0.13, rgb: [71, 44, 122] }, { index: 0.25, rgb: [59, 81, 139] }, { index: 0.38, rgb: [44, 113, 142] }, { index: 0.5, rgb: [33, 144, 141] }, { index: 0.63, rgb: [39, 173, 129] }, { index: 0.75, rgb: [92, 200, 99] }, { index: 0.88, rgb: [170, 220, 50] }, { index: 1, rgb: [253, 231, 37] }],
  inferno: [{ index: 0, rgb: [0, 0, 4] }, { index: 0.13, rgb: [31, 12, 72] }, { index: 0.25, rgb: [85, 15, 109] }, { index: 0.38, rgb: [136, 34, 106] }, { index: 0.5, rgb: [186, 54, 85] }, { index: 0.63, rgb: [227, 89, 51] }, { index: 0.75, rgb: [249, 140, 10] }, { index: 0.88, rgb: [249, 201, 50] }, { index: 1, rgb: [252, 255, 164] }],
  magma: [{ index: 0, rgb: [0, 0, 4] }, { index: 0.13, rgb: [28, 16, 68] }, { index: 0.25, rgb: [79, 18, 123] }, { index: 0.38, rgb: [129, 37, 129] }, { index: 0.5, rgb: [181, 54, 122] }, { index: 0.63, rgb: [229, 80, 100] }, { index: 0.75, rgb: [251, 135, 97] }, { index: 0.88, rgb: [254, 194, 135] }, { index: 1, rgb: [252, 253, 191] }],
  plasma: [{ index: 0, rgb: [13, 8, 135] }, { index: 0.13, rgb: [75, 3, 161] }, { index: 0.25, rgb: [125, 3, 168] }, { index: 0.38, rgb: [168, 34, 150] }, { index: 0.5, rgb: [203, 70, 121] }, { index: 0.63, rgb: [229, 107, 93] }, { index: 0.75, rgb: [248, 148, 65] }, { index: 0.88, rgb: [253, 195, 40] }, { index: 1, rgb: [240, 249, 33] }],
  warm: [{ index: 0, rgb: [125, 0, 179] }, { index: 0.13, rgb: [172, 0, 187] }, { index: 0.25, rgb: [219, 0, 170] }, { index: 0.38, rgb: [255, 0, 130] }, { index: 0.5, rgb: [255, 63, 74] }, { index: 0.63, rgb: [255, 123, 0] }, { index: 0.75, rgb: [234, 176, 0] }, { index: 0.88, rgb: [190, 228, 0] }, { index: 1, rgb: [147, 255, 0] }],
  cool: [{ index: 0, rgb: [125, 0, 179] }, { index: 0.13, rgb: [116, 0, 218] }, { index: 0.25, rgb: [98, 74, 237] }, { index: 0.38, rgb: [68, 146, 231] }, { index: 0.5, rgb: [0, 204, 197] }, { index: 0.63, rgb: [0, 247, 146] }, { index: 0.75, rgb: [0, 255, 88] }, { index: 0.88, rgb: [40, 255, 8] }, { index: 1, rgb: [147, 255, 0] }],
  "rainbow-soft": [{ index: 0, rgb: [125, 0, 179] }, { index: 0.1, rgb: [199, 0, 180] }, { index: 0.2, rgb: [255, 0, 121] }, { index: 0.3, rgb: [255, 108, 0] }, { index: 0.4, rgb: [222, 194, 0] }, { index: 0.5, rgb: [150, 255, 0] }, { index: 0.6, rgb: [0, 255, 55] }, { index: 0.7, rgb: [0, 246, 150] }, { index: 0.8, rgb: [50, 167, 222] }, { index: 0.9, rgb: [103, 51, 235] }, { index: 1, rgb: [124, 0, 186] }],
  bathymetry: [{ index: 0, rgb: [40, 26, 44] }, { index: 0.13, rgb: [59, 49, 90] }, { index: 0.25, rgb: [64, 76, 139] }, { index: 0.38, rgb: [63, 110, 151] }, { index: 0.5, rgb: [72, 142, 158] }, { index: 0.63, rgb: [85, 174, 163] }, { index: 0.75, rgb: [120, 206, 163] }, { index: 0.88, rgb: [187, 230, 172] }, { index: 1, rgb: [253, 254, 204] }],
  cdom: [{ index: 0, rgb: [47, 15, 62] }, { index: 0.13, rgb: [87, 23, 86] }, { index: 0.25, rgb: [130, 28, 99] }, { index: 0.38, rgb: [171, 41, 96] }, { index: 0.5, rgb: [206, 67, 86] }, { index: 0.63, rgb: [230, 106, 84] }, { index: 0.75, rgb: [242, 149, 103] }, { index: 0.88, rgb: [249, 193, 135] }, { index: 1, rgb: [254, 237, 176] }],
  chlorophyll: [{ index: 0, rgb: [18, 36, 20] }, { index: 0.13, rgb: [25, 63, 41] }, { index: 0.25, rgb: [24, 91, 59] }, { index: 0.38, rgb: [13, 119, 72] }, { index: 0.5, rgb: [18, 148, 80] }, { index: 0.63, rgb: [80, 173, 89] }, { index: 0.75, rgb: [132, 196, 122] }, { index: 0.88, rgb: [175, 221, 162] }, { index: 1, rgb: [215, 249, 208] }],
  density: [{ index: 0, rgb: [54, 14, 36] }, { index: 0.13, rgb: [89, 23, 80] }, { index: 0.25, rgb: [110, 45, 132] }, { index: 0.38, rgb: [120, 77, 178] }, { index: 0.5, rgb: [120, 113, 213] }, { index: 0.63, rgb: [115, 151, 228] }, { index: 0.75, rgb: [134, 185, 227] }, { index: 0.88, rgb: [177, 214, 227] }, { index: 1, rgb: [230, 241, 241] }],
  "freesurface-blue": [{ index: 0, rgb: [30, 4, 110] }, { index: 0.13, rgb: [47, 14, 176] }, { index: 0.25, rgb: [41, 45, 236] }, { index: 0.38, rgb: [25, 99, 212] }, { index: 0.5, rgb: [68, 131, 200] }, { index: 0.63, rgb: [114, 156, 197] }, { index: 0.75, rgb: [157, 181, 203] }, { index: 0.88, rgb: [200, 208, 216] }, { index: 1, rgb: [241, 237, 236] }],
  "freesurface-red": [{ index: 0, rgb: [60, 9, 18] }, { index: 0.13, rgb: [100, 17, 27] }, { index: 0.25, rgb: [142, 20, 29] }, { index: 0.38, rgb: [177, 43, 27] }, { index: 0.5, rgb: [192, 87, 63] }, { index: 0.63, rgb: [205, 125, 105] }, { index: 0.75, rgb: [216, 162, 148] }, { index: 0.88, rgb: [227, 199, 193] }, { index: 1, rgb: [241, 237, 236] }],
  oxygen: [{ index: 0, rgb: [64, 5, 5] }, { index: 0.13, rgb: [106, 6, 15] }, { index: 0.25, rgb: [144, 26, 7] }, { index: 0.38, rgb: [168, 64, 3] }, { index: 0.5, rgb: [188, 100, 4] }, { index: 0.63, rgb: [206, 136, 11] }, { index: 0.75, rgb: [220, 174, 25] }, { index: 0.88, rgb: [231, 215, 44] }, { index: 1, rgb: [248, 254, 105] }],
  par: [{ index: 0, rgb: [51, 20, 24] }, { index: 0.13, rgb: [90, 32, 35] }, { index: 0.25, rgb: [129, 44, 34] }, { index: 0.38, rgb: [159, 68, 25] }, { index: 0.5, rgb: [182, 99, 19] }, { index: 0.63, rgb: [199, 134, 22] }, { index: 0.75, rgb: [212, 171, 35] }, { index: 0.88, rgb: [221, 210, 54] }, { index: 1, rgb: [225, 253, 75] }],
  phase: [{ index: 0, rgb: [145, 105, 18] }, { index: 0.13, rgb: [184, 71, 38] }, { index: 0.25, rgb: [186, 58, 115] }, { index: 0.38, rgb: [160, 71, 185] }, { index: 0.5, rgb: [110, 97, 218] }, { index: 0.63, rgb: [50, 123, 164] }, { index: 0.75, rgb: [31, 131, 110] }, { index: 0.88, rgb: [77, 129, 34] }, { index: 1, rgb: [145, 105, 18] }],
  salinity: [{ index: 0, rgb: [42, 24, 108] }, { index: 0.13, rgb: [33, 50, 162] }, { index: 0.25, rgb: [15, 90, 145] }, { index: 0.38, rgb: [40, 118, 137] }, { index: 0.5, rgb: [59, 146, 135] }, { index: 0.63, rgb: [79, 175, 126] }, { index: 0.75, rgb: [120, 203, 104] }, { index: 0.88, rgb: [193, 221, 100] }, { index: 1, rgb: [253, 239, 154] }],
  temperature: [{ index: 0, rgb: [4, 35, 51] }, { index: 0.13, rgb: [23, 51, 122] }, { index: 0.25, rgb: [85, 59, 157] }, { index: 0.38, rgb: [129, 79, 143] }, { index: 0.5, rgb: [175, 95, 130] }, { index: 0.63, rgb: [222, 112, 101] }, { index: 0.75, rgb: [249, 146, 66] }, { index: 0.88, rgb: [249, 196, 65] }, { index: 1, rgb: [232, 250, 91] }],
  turbidity: [{ index: 0, rgb: [34, 31, 27] }, { index: 0.13, rgb: [65, 50, 41] }, { index: 0.25, rgb: [98, 69, 52] }, { index: 0.38, rgb: [131, 89, 57] }, { index: 0.5, rgb: [161, 112, 59] }, { index: 0.63, rgb: [185, 140, 66] }, { index: 0.75, rgb: [202, 174, 88] }, { index: 0.88, rgb: [216, 209, 126] }, { index: 1, rgb: [233, 246, 171] }],
  "velocity-blue": [{ index: 0, rgb: [17, 32, 64] }, { index: 0.13, rgb: [35, 52, 116] }, { index: 0.25, rgb: [29, 81, 156] }, { index: 0.38, rgb: [31, 113, 162] }, { index: 0.5, rgb: [50, 144, 169] }, { index: 0.63, rgb: [87, 173, 176] }, { index: 0.75, rgb: [149, 196, 189] }, { index: 0.88, rgb: [203, 221, 211] }, { index: 1, rgb: [254, 251, 230] }],
  "velocity-green": [{ index: 0, rgb: [23, 35, 19] }, { index: 0.13, rgb: [24, 64, 38] }, { index: 0.25, rgb: [11, 95, 45] }, { index: 0.38, rgb: [39, 123, 35] }, { index: 0.5, rgb: [95, 146, 12] }, { index: 0.63, rgb: [152, 165, 18] }, { index: 0.75, rgb: [201, 186, 69] }, { index: 0.88, rgb: [233, 216, 137] }, { index: 1, rgb: [255, 253, 205] }],
  cubehelix: [{ index: 0, rgb: [0, 0, 0] }, { index: 0.07, rgb: [22, 5, 59] }, { index: 0.13, rgb: [60, 4, 105] }, { index: 0.2, rgb: [109, 1, 135] }, { index: 0.27, rgb: [161, 0, 147] }, { index: 0.33, rgb: [210, 2, 142] }, { index: 0.4, rgb: [251, 11, 123] }, { index: 0.47, rgb: [255, 29, 97] }, { index: 0.53, rgb: [255, 54, 69] }, { index: 0.6, rgb: [255, 85, 46] }, { index: 0.67, rgb: [255, 120, 34] }, { index: 0.73, rgb: [255, 157, 37] }, { index: 0.8, rgb: [241, 191, 57] }, { index: 0.87, rgb: [224, 220, 93] }, { index: 0.93, rgb: [218, 241, 142] }, { index: 1, rgb: [227, 253, 198] }]
};
const ZYn = /* @__PURE__ */ ko(XYn);
function ezn(t) {
  const n = ZYn[t].map((r) => r.rgb).map((r) => J8(...r));
  return EYn(gre, n);
}
function tzn(t, e = 256) {
  const n = document.createElement("canvas");
  n.width = e, n.height = 1;
  const r = n.getContext("2d");
  for (let i = 0; i < e; ++i)
    r.fillStyle = t(i / (e - 1)), r.fillRect(i, 0, 1, 1);
  return n;
}
function XKe(t) {
  const e = ezn(t), n = WKe([0, 100], e);
  let r = 256;
  return n.domain && n.range && (r = Math.min(n.domain().length, n.range().length)), tzn(n.copy().domain(yYn(ax(0, 1), r))).toDataURL();
}
const nzn = kr(() => ({
  legend: {
    top: "2px",
    right: "2px",
    zIndex: "100",
    fontSize: "10px !important",
    flexDirection: "column",
    backgroundColor: "rgba(215, 215, 215, 0.7)",
    borderRadius: "4px",
    padding: "2px",
    lineHeight: "10px !important",
    "& svg": {
      top: 0,
      left: 0,
      position: "relative"
    }
  },
  legendAbsolute: {
    position: "absolute",
    display: "inline-block"
  },
  legendRelative: {
    position: "relative",
    marginBottom: "2px",
    display: "block"
  },
  legendHighContrast: {
    backgroundColor: "rgba(215, 215, 215, 0.7)"
  },
  legendLowContrast: {
    backgroundColor: "rgba(215, 215, 215, 0.2)"
  },
  legendInvisible: {
    display: "none"
  }
})), Sb = 10, Mm = 8, ZDe = 2, rzn = 2;
function nS(t) {
  const { visible: e, positionRelative: n = !1, highContrast: r = !1, obsType: i, featureValueType: o, considerSelections: s = !0, obsColorEncoding: a, featureSelection: A, featureLabelsMap: l, featureValueColormap: c, featureValueColormapRange: u, spatialChannelColor: f, spatialLayerColor: h, obsSetSelection: d, obsSetColor: I, extent: m, width: C = 100, height: y = 36, theme: v, showObsLabel: b = !1 } = t, Q = Zr(), w = nzn(), R = v === "dark", M = a === "spatialChannelColor" || a === "spatialLayerColor", O = a === "cellSetSelection", L = Array.isArray(h) && h.length === 3 ? h : da(v), N = Array.isArray(f) && f.length === 3 ? f : da(v), k = a === "spatialChannelColor" ? N : L, $ = e && (!s || a === "geneSelection" && A && Array.isArray(A) && A.length === 1 || O && d?.length > 0 && I?.length > 0 || M), U = dt(() => Array.from(new Set(d?.map((K) => K[0]) || [])), [d]), X = O ? U.length * Sb + d?.length * (Mm + ZDe) : y;
  return Mn(() => {
    const K = Q.current, z = r ? "black" : R ? "white" : "black", Y = Kjn(K);
    Y.selectAll("g").remove(), Y.attr("width", C).attr("height", X);
    const V = Y.append("g").attr("width", C).attr("height", X);
    if (!s || a === "geneSelection") {
      if (c) {
        const se = XKe(c);
        V.append("image").attr("x", 0).attr("y", Sb).attr("width", C).attr("height", Mm).attr("preserveAspectRatio", "none").attr("href", se);
      }
      const [Ie, Qe] = m || [0, 1], [xe, Se] = u, De = [
        Ie + (Qe - Ie) * xe,
        Qe - (Qe - Ie) * (1 - Se)
      ], Ue = KKe().domain(De).range([0, C - 0.5]), Te = V.append("g").attr("transform", `translate(0,${Sb + Mm})`).style("font-size", "10px").call(WYn(Ue).tickValues(De));
      Te.selectAll("line,path").style("stroke", z), Te.selectAll("text").style("fill", z), Te.selectAll("text").attr("text-anchor", (se, fe) => fe === 0 ? "start" : "end");
    }
    if (M && V.append("rect").attr("x", 0).attr("y", Sb).attr("width", C).attr("height", Mm).attr("fill", `rgb(${k[0]},${k[1]},${k[2]})`), O && d && I) {
      const Ie = {};
      d.forEach((xe) => {
        const Se = xe[0];
        Ie[Se] || (Ie[Se] = []), Ie[Se].push(xe);
      });
      let Qe = 0;
      Object.entries(Ie).forEach(([xe, Se]) => {
        V.append("text").attr("text-anchor", "start").attr("dominant-baseline", "hanging").attr("x", 0).attr("y", Qe).text(xe).style("font-size", "9px").style("fill", z), Qe += Sb, Se.forEach((De) => {
          const Ue = I.find((Te) => gr(Te.path, De)).color;
          V.append("rect").attr("x", 0).attr("y", Qe).attr("width", Mm).attr("height", Mm).attr("fill", `rgb(${Ue[0]},${Ue[1]},${Ue[2]})`), V.append("text").attr("text-anchor", "start").attr("dominant-baseline", "hanging").attr("x", Mm + rzn).attr("y", Qe).text(De.at(-1)).style("font-size", "9px").style("fill", z), Qe += Mm + ZDe;
        });
      });
    }
    const Z = A && A.length >= 1 && !M ? l?.get(A[0]) || A[0] : null, ce = Ci(i), ee = s && Z || Ci(o), pe = b ? ce : ee, Ce = b ? ee : null, Be = Ce !== null;
    O || (V.append("text").attr("text-anchor", Be ? "start" : "end").attr("dominant-baseline", "hanging").attr("x", Be ? 0 : C).attr("y", 0).text(pe).style("font-size", "10px").style("fill", z), Be && V.append("text").attr("text-anchor", "end").attr("dominant-baseline", "hanging").attr("x", C).attr("y", Sb).text(Ce).style("font-size", "9px").style("fill", z));
  }, [
    C,
    y,
    c,
    u,
    s,
    i,
    a,
    A,
    R,
    o,
    m,
    l,
    f,
    I,
    d,
    O
  ]), ne.jsx("div", { className: Xt(w.legend, {
    [w.legendRelative]: n,
    [w.legendAbsolute]: !n,
    [w.legendHighContrast]: r,
    [w.legendLowContrast]: !r,
    [w.legendInvisible]: !$
  }), children: ne.jsx("svg", { ref: Q, style: {
    width: `${C}px`,
    height: `${X}px`
  } }) });
}
const izn = kr(() => ({
  multiLegend: {
    position: "absolute",
    top: "0px",
    right: "0px"
  }
}));
function ozn(t) {
  const {
    theme: e,
    // Segmentations
    segmentationLayerScopes: n,
    segmentationLayerCoordination: r,
    segmentationChannelScopesByLayer: i,
    segmentationChannelCoordination: o,
    segmentationMultiExpressionExtents: s,
    // Spots
    spotLayerScopes: a,
    spotLayerCoordination: A,
    spotMultiExpressionExtents: l,
    // Points
    pointLayerScopes: c,
    pointLayerCoordination: u
  } = t, f = izn(), h = dt(() => [...n || []].reverse(), [n]), d = dt(() => [...a || []].reverse(), [a]), I = dt(() => [...c || []].reverse(), [c]);
  return ne.jsxs("div", { className: f.multiLegend, children: [c ? I.flatMap((m) => {
    const C = u[0][m], { spatialLayerVisible: y, obsColorEncoding: v, obsType: b, featureType: Q, featureValueType: w, spatialLayerColor: R, legendVisible: M } = C, L = v === "spatialLayerColor" ? 20 : 36;
    return y && M ? ne.jsx(nS, {
      positionRelative: !0,
      highContrast: !0,
      showObsLabel: !0,
      visible: y,
      theme: e,
      obsType: b,
      featureType: Q,
      featureValueType: w,
      obsColorEncoding: v,
      spatialLayerColor: R,
      featureSelection: null,
      // featureLabelsMap={featureLabelsMap} // TODO
      featureValueColormap: "viridis",
      featureValueColormapRange: [0, 1],
      extent: null,
      height: L
    }, m) : null;
  }) : null, a ? d.flatMap((m) => {
    const C = A[0][m], { spatialLayerVisible: y, obsColorEncoding: v, featureValueColormap: b, featureValueColormapRange: Q, obsType: w, featureType: R, featureValueType: M, featureSelection: O, spatialLayerColor: L, legendVisible: N, obsSetSelection: k, obsSetColor: $ } = C, X = l?.[m]?.[0], z = v === "spatialLayerColor" ? 20 : 36;
    return y && N ? ne.jsx(nS, {
      positionRelative: !0,
      highContrast: !0,
      showObsLabel: !0,
      visible: y,
      theme: e,
      obsType: w,
      featureType: R,
      featureValueType: M,
      obsColorEncoding: v,
      spatialLayerColor: L,
      featureSelection: O,
      // featureLabelsMap={featureLabelsMap} // TODO
      featureValueColormap: b,
      featureValueColormapRange: Q,
      extent: X,
      height: z,
      obsSetSelection: k,
      obsSetColor: $
    }, m) : null;
  }) : null, n ? h.flatMap((m) => {
    const C = r[0][m], y = i[m], v = o[0][m], { spatialLayerVisible: b } = C, Q = [...y || []].reverse();
    return v && y ? Q.map((w) => {
      const { spatialChannelVisible: R, spatialChannelColor: M, obsColorEncoding: O, featureValueColormap: L, featureValueColormapRange: N, obsType: k, featureType: $, featureValueType: U, featureSelection: X, legendVisible: K, obsSetSelection: z, obsSetColor: Y } = v[w], Z = s?.[m]?.[w]?.[0], ee = O === "spatialChannelColor" ? 20 : 36;
      return b && R && K ? ne.jsx(nS, {
        positionRelative: !0,
        highContrast: !0,
        showObsLabel: !0,
        visible: b && R,
        theme: e,
        obsType: k,
        featureType: $,
        featureValueType: U,
        obsColorEncoding: O,
        featureSelection: X,
        // featureLabelsMap={featureLabelsMap} // TODO
        featureValueColormap: L,
        featureValueColormapRange: N,
        extent: Z,
        height: ee,
        spatialChannelColor: M,
        obsSetSelection: z,
        obsSetColor: Y
      }, `${m}-${w}`) : null;
    }) : null;
  }) : null] });
}
const szn = kr(() => ({
  channelNamesLegendContainer: {
    position: "absolute",
    bottom: "0px",
    left: "0px",
    paddingLeft: "10px",
    paddingBottom: "10px"
  },
  channelNamesLegendLayer: {
    display: "flex"
  },
  channelNamesRow: {
    flexDirection: "column"
  },
  channelNamesCol: {
    flexDirection: "row"
  },
  channelNameText: {
    marginRight: "10px"
  }
}));
function azn(t) {
  const { images: e, imageLayerScopes: n, imageLayerCoordination: r, imageChannelScopesByLayer: i, imageChannelCoordination: o } = t, s = szn(), a = dt(() => [...n || []].reverse(), [n]);
  return ne.jsx("div", { className: s.channelNamesLegendContainer, children: n ? a.map((A) => {
    const l = r[0][A], c = i[A], u = o[0][A], { spatialLayerVisible: f, photometricInterpretation: h, spatialChannelLabelsVisible: d, spatialChannelLabelsOrientation: I, spatialChannelLabelSize: m, spatialLayerColormap: C } = l, y = I === "horizontal";
    return h !== "RGB" && C === null && u && c ? ne.jsx("div", { className: Xt(s.channelNamesLegendLayer, {
      [s.channelNamesCol]: y,
      [s.channelNamesRow]: !y
    }), children: c.map((v) => {
      const { spatialTargetC: b, spatialChannelVisible: Q, spatialChannelColor: w } = u[v], R = Qu(w), O = e?.[A]?.image?.instance.getChannelNames()?.[b];
      return f && Q && d ? ne.jsx(Mu, { variant: "h6", className: s.channelNameText, style: {
        color: R,
        fontSize: `${m}px`
      }, children: O }, `${A}-${v}-${b}-${R}`) : null;
    }) }, A) : null;
  }) : null });
}
function Azn(t) {
  const {
    uuid: e,
    coordinationScopes: n,
    closeButtonVisible: r,
    downloadButtonVisible: i,
    removeGridComponent: o,
    theme: s,
    observationsLabelOverride: a,
    title: A,
    // Average fill density for dynamic opacity calculation.
    averageFillDensity: l
  } = t, c = eu(), u = yL(), f = vL(e), [{ dataset: h, obsType: d, featureType: I, featureValueType: m, embeddingZoom: C, embeddingTargetX: y, embeddingTargetY: v, embeddingTargetZ: b, embeddingType: Q, obsFilter: w, obsHighlight: R, featureSelection: M, obsSetSelection: O, obsSetColor: L, obsColorEncoding: N, additionalObsSets: k, embeddingObsSetPolygonsVisible: $, embeddingObsSetLabelsVisible: U, embeddingObsSetLabelSize: X, embeddingObsRadius: K, embeddingObsRadiusMode: z, embeddingObsOpacity: Y, embeddingObsOpacityMode: V, featureValueColormap: Z, featureValueColormapRange: ce, tooltipsVisible: ee }, { setEmbeddingZoom: pe, setEmbeddingTargetX: Ce, setEmbeddingTargetY: Be, setEmbeddingTargetZ: Ie, setObsFilter: Qe, setObsSetSelection: xe, setObsHighlight: Se, setObsSetColor: De, setObsColorEncoding: Ue, setAdditionalObsSets: Te, setEmbeddingObsSetPolygonsVisible: se, setEmbeddingObsSetLabelsVisible: fe, setEmbeddingObsSetLabelSize: W, setEmbeddingObsRadius: ge, setEmbeddingObsRadiusMode: _e, setEmbeddingObsOpacity: Re, setEmbeddingObsOpacityMode: Ee, setFeatureValueColormap: oe, setFeatureValueColormapRange: ie, setTooltipsVisible: Ae }] = uc(ea[Gn.SCATTERPLOT], n), { embeddingZoom: de, embeddingTargetX: we, embeddingTargetY: Pe } = yae(ea[Gn.SCATTERPLOT], n), qe = a || d, [ke, Xe, rt] = QL(), it = A || `Scatterplot (${Q})`, [ht, mt] = eAe(n, d, c, h), [{ obsIndex: _t, obsEmbedding: Ct }, zt, jt] = gGt(c, h, !0, {}, {}, { obsType: d, embeddingType: Q }), lt = _t?.length || 0, [{ obsSets: Ht, obsSetsMembership: vt }, It, un] = VB(c, h, !1, { setObsSetSelection: xe, setObsSetColor: De }, { obsSetSelection: O, obsSetColor: L }, { obsType: d }), [hn, We, En] = bv(c, h, !1, M, { obsType: d, featureType: I, featureValueType: m }), [{ obsIndex: qn }, Pt, dr] = TL(c, h, !1, { obsType: d, featureType: I, featureValueType: m }), [{ featureLabelsMap: yr }, jn, Ot] = DL(c, h, !1, {}, {}, { featureType: I }), yn = Jc([
    zt,
    It,
    En,
    jn,
    Pt
  ]), Fn = Qd([
    jt,
    un,
    dr,
    Ot
  ]), [xn, vn] = mn(K), [nt, st] = mn(Y), [xt, Me] = mn(null), _ = dt(() => RI(Ht, k), [Ht, k]), ye = Qn((In) => {
    pI(In, k, L, xe, Te, De, Ue);
  }, [
    k,
    L,
    Ue,
    Te,
    De,
    xe
  ]), He = dt(() => ML({
    cellSets: _,
    cellSetSelection: O,
    cellSetColor: L,
    obsIndex: qn,
    theme: s
  }), [
    _,
    s,
    O,
    L,
    qn
  ]), [ze, tt] = mn([]), At = (In, mr) => In.findIndex((Mr) => gr(Mr[0], mr)) !== -1, pt = (In, mr) => In.find((Mr) => gr(Mr[0], mr))?.[1], Bt = dt(() => {
    if ((U || $) && !At(ze, O) && _?.tree?.length && Ct && _t && L?.length) {
      const In = Q5e({
        obsIndex: _t,
        obsEmbedding: Ct,
        cellSets: _,
        cellSetSelection: O,
        cellSetColor: L,
        theme: s
      });
      return tt((mr) => [...mr, [O, In]]), In;
    }
    return pt(ze, O) || [];
  }, [
    $,
    ze,
    U,
    s,
    _t,
    Ct,
    _,
    O,
    L
  ]), Rt = dt(() => Array.from(He.keys()), [He]), [Lt, rn, Wr, pr, Vt] = dt(() => {
    if (Ct && Ct.data && Ct.shape) {
      const In = Ct.shape[1], mr = fa(Ct.data[0]), Mr = fa(Ct.data[1]), $e = mr[1] - mr[0], Ps = Mr[1] - Mr[0];
      return [$e, Ps, mr, Mr, In];
    }
    return [null, null, null, null, null];
  }, [Ct]);
  Mn(() => {
    if (Lt && rn) {
      const In = SKe(window.devicePixelRatio, C, Lt, rn, ke, Xe);
      vn(In);
      const mr = QKe(C, Lt, rn, ke, Xe, Vt, l);
      if (st(mr), typeof we != "number" || typeof Pe != "number") {
        const Mr = Wr[0] + Lt / 2, $e = pr[0] + rn / 2, Ps = Math.log2(Math.min(ke / Lt, Xe / rn)), Wn = typeof y != "number" || typeof v != "number", Is = y === Mr && v === -$e;
        (Wn || Is) && (Ce(Mr), Be(-$e), pe(Ps)), Me({ target: [Mr, -$e, 0], zoom: Ps });
      } else
        xt || Me({ target: [we, Pe, 0], zoom: de });
    }
  }, [
    Lt,
    rn,
    Wr,
    pr,
    Vt,
    ke,
    Xe,
    de,
    C,
    we,
    Pe,
    l
  ]);
  const Sn = Jae(qe, ht, mt, vt), kn = dt(() => new Set(Rt), [Rt]), vr = Qn((In, { index: mr }) => (kn || /* @__PURE__ */ new Set([])).has(_t[mr]) ? 1 : 0, [kn, _t]), Tr = z === "manual" ? K : xn, $t = V === "manual" ? Y : nt, [Ye, en] = zae(hn), Ir = Vae({
    instanceObsIndex: _t,
    matrixObsIndex: qn,
    expressionData: Ye
  }), zr = ({ zoom: In, target: mr }) => {
    pe(In), Ce(mr[0]), Be(mr[1]), Ie(mr[2] || 0);
  };
  return ne.jsxs(fc, { title: it, info: `${fI(lt)} ${Bf(qe, lt)}`, closeButtonVisible: r, downloadButtonVisible: i, removeGridComponent: o, urls: Fn, theme: s, isReady: yn, options: ne.jsx(wKe, { observationsLabel: qe, cellRadius: K, setCellRadius: ge, cellRadiusMode: z, setCellRadiusMode: _e, cellOpacity: Y, setCellOpacity: Re, cellOpacityMode: V, setCellOpacityMode: Ee, cellSetLabelsVisible: U, setCellSetLabelsVisible: fe, tooltipsVisible: ee, setTooltipsVisible: Ae, cellSetLabelSize: X, setCellSetLabelSize: W, cellSetPolygonsVisible: $, setCellSetPolygonsVisible: se, cellColorEncoding: N, setCellColorEncoding: Ue, geneExpressionColormap: Z, setGeneExpressionColormap: oe, geneExpressionColormapRange: ce, setGeneExpressionColormapRange: ie }), children: [ne.jsx(wfe, { ref: rt, uuid: e, theme: s, viewState: { zoom: C, target: [y, v, b] }, setViewState: zr, originalViewState: xt, obsEmbeddingIndex: _t, obsEmbedding: Ct, cellFilter: w, cellSelection: Rt, cellHighlight: R, cellColors: He, cellSetPolygons: Bt, cellSetLabelSize: X, cellSetLabelsVisible: U, cellSetPolygonsVisible: $, setCellFilter: Qe, setCellSelection: ye, setCellHighlight: Se, cellRadius: Tr, cellOpacity: $t, cellColorEncoding: N, geneExpressionColormap: Z, geneExpressionColormapRange: ce, setComponentHover: () => {
    u(e);
  }, updateViewInfo: f, getExpressionValue: Ir, getCellIsSelected: vr }), ee && ne.jsx(RKe, { parentUuid: e, obsHighlight: R, width: ke, height: Xe, getObsInfo: Sn }), ne.jsx(nS, { visible: !0, theme: s, featureType: I, featureValueType: m, obsColorEncoding: N, featureSelection: M, featureLabelsMap: yr, featureValueColormap: Z, featureValueColormapRange: ce, extent: en?.[0] })] });
}
function lzn(t) {
  const { featureType: e, gatingFeatureSelectionX: n, setGatingFeatureSelectionX: r, gatingFeatureSelectionY: i, setGatingFeatureSelectionY: o, gatingFeatureValueTransform: s, setGatingFeatureValueTransform: a, gatingFeatureValueTransformCoefficient: A, setGatingFeatureValueTransformCoefficient: l, geneSelectOptions: c, transformOptions: u } = t, f = Jr(), h = VI(), d = (C) => {
    const { options: y } = C.target, v = [];
    for (let b = 0, Q = y.length; b < Q; b += 1)
      y[b].selected && v.push(y[b].value);
    v.length === 1 && n && !i && v[0] !== n ? o(v[0]) : v.length <= 2 && (r(v[0]), o(v[1]));
  }, I = (C) => {
    a(C.target.value === "" ? null : C.target.value);
  }, m = (C) => {
    const { value: y } = C.target;
    if (!y)
      l(y);
    else {
      const v = Number(y);
      !Number.isNaN(v) && v >= 0 && l(y);
    }
  };
  return ne.jsxs(ne.Fragment, { children: [ne.jsxs(Ko, { children: [ne.jsx(br, { className: h.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `scatterplot-gating-gene-select-${f}`, children: Ci(Bf(e, c?.length)) }) }), ne.jsx(br, { className: h.inputCell, variant: "body", children: ne.jsx(nd, { multiple: !0, className: h.select, value: [n, i].filter((C) => C), onChange: d, inputProps: {
    id: `scatterplot-gating-gene-select-${f}`
  }, children: c.map((C) => ne.jsx("option", { value: C, children: C }, C)) }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: h.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `scatterplot-gating-transform-select-${f}`, children: "Transform" }) }), ne.jsx(br, { className: h.inputCell, variant: "body", children: ne.jsx(nd, { className: h.select, value: s === null ? "" : s, onChange: I, inputProps: {
    id: `scatterplot-gating-transform-select-${f}`
  }, children: u.map((C) => ne.jsx("option", { value: C.value === null ? "" : C.value, children: C.name }, C.name)) }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: h.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `scatterplot-gating-transform-coefficient-${f}`, children: "Transform Coefficient" }) }), ne.jsx(br, { className: h.inputCell, variant: "body", children: ne.jsx(SGe, { label: "Transform Coefficient", type: "number", onChange: m, value: A, InputLabelProps: {
    shrink: !0
  }, id: `scatterplot-gating-transform-coefficient-${f}` }) })] })] });
}
function czn(t) {
  const {
    uuid: e,
    coordinationScopes: n,
    closeButtonVisible: r,
    downloadButtonVisible: i,
    removeGridComponent: o,
    theme: s,
    disableTooltip: a = !1,
    title: A,
    // Average fill density for dynamic opacity calculation.
    averageFillDensity: l
  } = t, c = eu(), u = yL(), f = vL(e), [{ dataset: h, obsType: d, featureType: I, featureValueType: m, embeddingZoom: C, embeddingTargetX: y, embeddingTargetY: v, embeddingTargetZ: b, obsFilter: Q, obsHighlight: w, obsSetSelection: R, obsSetColor: M, obsColorEncoding: O, additionalObsSets: L, embeddingObsSetPolygonsVisible: N, embeddingObsSetLabelsVisible: k, embeddingObsSetLabelSize: $, embeddingObsRadius: U, embeddingObsRadiusMode: X, embeddingObsOpacity: K, embeddingObsOpacityMode: z, featureValueColormap: Y, featureValueColormapRange: V, featureSelection: Z, featureValueTransform: ce, featureValueTransformCoefficient: ee, gatingFeatureSelectionX: pe, gatingFeatureSelectionY: Ce }, { setEmbeddingZoom: Be, setEmbeddingTargetX: Ie, setEmbeddingTargetY: Qe, setEmbeddingTargetZ: xe, setObsFilter: Se, setObsSetSelection: De, setObsHighlight: Ue, setObsSetColor: Te, setObsColorEncoding: se, setAdditionalObsSets: fe, setEmbeddingObsSetPolygonsVisible: W, setEmbeddingObsSetLabelsVisible: ge, setEmbeddingObsSetLabelSize: _e, setEmbeddingObsRadius: Re, setEmbeddingObsRadiusMode: Ee, setEmbeddingObsOpacity: oe, setEmbeddingObsOpacityMode: ie, setFeatureValueColormap: Ae, setFeatureValueColormapRange: de, setFeatureValueTransform: we, setFeatureValueTransformCoefficient: Pe, setGatingFeatureSelectionX: qe, setGatingFeatureSelectionY: ke }] = uc(ea[Gn.GATING], n), [Xe, rt, it] = QL(), ht = dt(() => A || (pe && Ce ? `Gating (${pe} vs ${Ce})` : "Gating"), [A, pe, Ce]), mt = dt(() => pe ? [pe] : null, [pe]), _t = dt(() => Ce ? [Ce] : null, [Ce]), [{ obsSets: Ct }, zt, jt] = VB(c, h, !1, { setObsSetSelection: De, setObsSetColor: Te }, { obsSetSelection: R, obsSetColor: M }, { obsType: d }), [lt, Ht, vt] = bv(c, h, !1, Z, { obsType: d, featureType: I, featureValueType: m }), [It, un, hn] = bv(c, h, !1, mt, { obsType: d, featureType: I, featureValueType: m }), [We, En, qn] = bv(c, h, !1, _t, { obsType: d, featureType: I, featureValueType: m }), [{ obsIndex: Pt, featureIndex: dr }, yr, jn] = TL(c, h, !1, { obsType: d, featureType: I, featureValueType: m }), Ot = Pt?.length || 0, yn = Jc([
    zt,
    vt,
    hn,
    qn,
    yr
  ]), Fn = Qd([
    jt,
    jn
  ]), xn = dt(() => {
    if (!(Ot && It?.[0] && We?.[0] && mt && _t))
      return null;
    let en = 1;
    const Ir = Number(ee);
    !Number.isNaN(Ir) && Ir > 0 && (en = Ir);
    const zr = U3e(ce, en), In = new Float32Array(Ot), mr = new Float32Array(Ot);
    for (let Mr = 0; Mr < Ot; Mr += 1)
      In[Mr] = zr(It[0][Mr]), mr[Mr] = zr(We[0][Mr]);
    return {
      data: [In, mr],
      shape: [2, Ot]
    };
  }, [
    Ot,
    It,
    We,
    ce,
    ee,
    mt,
    _t
  ]), [vn, nt] = mn(U), [st, xt] = mn(K), Me = dt(() => RI(Ct, L), [Ct, L]), _ = Qn((en) => {
    pI(en, L, M, De, fe, Te, se);
  }, [
    L,
    M,
    se,
    fe,
    Te,
    De
  ]), ye = dt(() => ML({
    cellSets: Me,
    cellSetSelection: R,
    cellSetColor: M,
    obsIndex: Pt,
    theme: s
  }), [
    Me,
    s,
    R,
    M,
    Pt
  ]), [He, ze] = mn([]), tt = (en, Ir) => en.findIndex((zr) => gr(zr[0], Ir)) !== -1, At = (en, Ir) => en.find((zr) => gr(zr[0], Ir))?.[1], pt = dt(() => {
    if ((k || N) && !tt(He, R) && Me?.tree?.length && xn && Pt && M?.length) {
      const en = Q5e({
        obsIndex: Pt,
        obsEmbedding: xn,
        cellSets: Me,
        cellSetSelection: R,
        cellSetColor: M,
        theme: s
      });
      return ze((Ir) => [...Ir, [R, en]]), en;
    }
    return At(He, R) || [];
  }, [
    N,
    He,
    k,
    s,
    Pt,
    xn,
    Me,
    R,
    M
  ]), Bt = dt(() => Array.from(ye.keys()), [ye]), [Rt, Lt, rn, Wr, pr] = dt(() => {
    if (xn && xn.data && xn.shape) {
      const en = xn.shape[1], Ir = fa(xn.data[0]), zr = fa(xn.data[1]), In = Ir[1] - Ir[0], mr = zr[1] - zr[0];
      return [In, mr, Ir, zr, en];
    }
    return [null, null, null, null, null];
  }, [xn]);
  Mn(() => {
    if (Rt && Lt) {
      const en = SKe(window.devicePixelRatio, C, Rt, Lt, Xe, rt);
      nt(en);
      const Ir = QKe(C, Rt, Lt, Xe, rt, pr, l);
      if (xt(Ir), typeof y != "number" || typeof v != "number") {
        const zr = rn[0] + Rt / 2, In = Wr[0] + Lt / 2, mr = Math.log2(Math.min(Xe / Rt, rt / Lt));
        Ie(zr), Qe(-In), Be(mr);
      }
    }
  }, [
    Rt,
    Lt,
    rn,
    Wr,
    pr,
    Xe,
    rt,
    C,
    l
  ]);
  const Vt = dt(() => new Set(Bt), [Bt]), Sn = Qn((en, { index: Ir }) => (Vt || /* @__PURE__ */ new Set([])).has(Pt[Ir]) ? 1 : 0, [Vt, Pt]), kn = X === "manual" ? U : vn, vr = z === "manual" ? K : st, [Tr] = zae(lt), $t = Vae({
    instanceObsIndex: Pt,
    matrixObsIndex: Pt,
    expressionData: Tr
  }), Ye = Qn((en) => {
    const Ir = LX.find((Mr) => Mr.value === ce)?.name, zr = ce ? `${Ir} ` : "", In = Pt?.indexOf(en), mr = { [`${Ci(d)} ID`]: en };
    return pe && Ce && (mr[zr + pe] = xn.data[0][In], mr[zr + Ce] = xn.data[1][In]), mr;
  }, [
    xn,
    Pt,
    ce,
    pe,
    Ce,
    d
  ]);
  return ne.jsxs(fc, { title: ht, info: `${fI(Ot)} ${Bf(d, Ot)}`, closeButtonVisible: r, downloadButtonVisible: i, removeGridComponent: o, urls: Fn, theme: s, isReady: yn, options: ne.jsx(wKe, { observationsLabel: d, cellRadius: U, setCellRadius: Re, cellRadiusMode: X, setCellRadiusMode: Ee, cellOpacity: K, setCellOpacity: oe, cellOpacityMode: z, setCellOpacityMode: ie, cellSetLabelsVisible: k, setCellSetLabelsVisible: ge, cellSetLabelSize: $, setCellSetLabelSize: _e, cellSetPolygonsVisible: N, setCellSetPolygonsVisible: W, cellColorEncoding: O, setCellColorEncoding: se, geneExpressionColormap: Y, setGeneExpressionColormap: Ae, geneExpressionColormapRange: V, setGeneExpressionColormapRange: de, children: ne.jsx(lzn, { featureType: I, gatingFeatureSelectionX: pe, setGatingFeatureSelectionX: qe, gatingFeatureSelectionY: Ce, setGatingFeatureSelectionY: ke, gatingFeatureValueTransform: ce, setGatingFeatureValueTransform: (en) => {
    we(en), Ie(null), Qe(null), Be(null);
  }, gatingFeatureValueTransformCoefficient: ee, setGatingFeatureValueTransformCoefficient: Pe, geneSelectOptions: dr, transformOptions: LX }) }), children: [ne.jsx(gqn, { visible: !(pe && Ce), message: `Select two ${Bf(I, 2)} in the plot settings.` }), ne.jsx(wfe, { ref: it, uuid: e, theme: s, hideTools: !(pe && Ce), viewState: { zoom: C, target: [y, v, b] }, setViewState: ({ zoom: en, target: Ir }) => {
    Be(en), Ie(Ir[0]), Qe(Ir[1]), xe(Ir[2] || 0);
  }, obsEmbeddingIndex: Pt, obsEmbedding: xn, cellFilter: Q, cellSelection: Bt, cellHighlight: w, cellColors: ye, cellSetPolygons: pt, cellSetLabelSize: $, cellSetLabelsVisible: k, cellSetPolygonsVisible: N, setCellFilter: Se, setCellSelection: _, setCellHighlight: Ue, cellRadius: kn, cellOpacity: vr, cellColorEncoding: O, geneExpressionColormap: Y, geneExpressionColormapRange: V, setComponentHover: () => {
    u(e);
  }, updateViewInfo: f, getExpressionValue: $t, getCellIsSelected: Sn }), !a && ne.jsx(RKe, { parentUuid: e, obsHighlight: w, width: Xe, height: rt, getObsInfo: Ye })] });
}
var ZKe = {
  // minimum relative difference between two compared values,
  // used by all comparison functions
  epsilon: 1e-12,
  // type of default matrix output. Choose 'matrix' (default) or 'array'
  matrix: "Matrix",
  // type of default number output. Choose 'number' (default) 'BigNumber', or 'Fraction
  number: "number",
  // number of significant digits in BigNumbers
  precision: 64,
  // predictable output type of functions. When true, output type depends only
  // on the input types. When false (default), output type can vary depending
  // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
  // predictable is false, and returns `NaN` when true.
  predictable: !1,
  // random seed for seeded pseudo random number generation
  // null = randomly seed
  randomSeed: null
};
function ga(t) {
  return typeof t == "number";
}
function Jl(t) {
  return !t || typeof t != "object" || typeof t.constructor != "function" ? !1 : t.isBigNumber === !0 && typeof t.constructor.prototype == "object" && t.constructor.prototype.isBigNumber === !0 || typeof t.constructor.isDecimal == "function" && t.constructor.isDecimal(t) === !0;
}
function rS(t) {
  return t && typeof t == "object" && Object.getPrototypeOf(t).isComplex === !0 || !1;
}
function Nfe(t) {
  return t && typeof t == "object" && Object.getPrototypeOf(t).isFraction === !0 || !1;
}
function Lq(t) {
  return t && t.constructor.prototype.isUnit === !0 || !1;
}
function X0(t) {
  return typeof t == "string";
}
var zs = Array.isArray;
function cA(t) {
  return t && t.constructor.prototype.isMatrix === !0 || !1;
}
function eWe(t) {
  return Array.isArray(t) || cA(t);
}
function uzn(t) {
  return t && t.isDenseMatrix && t.constructor.prototype.isMatrix === !0 || !1;
}
function fzn(t) {
  return t && t.isSparseMatrix && t.constructor.prototype.isMatrix === !0 || !1;
}
function tWe(t) {
  return t && t.constructor.prototype.isRange === !0 || !1;
}
function Mq(t) {
  return t && t.constructor.prototype.isIndex === !0 || !1;
}
function gzn(t) {
  return typeof t == "boolean";
}
function nWe(t) {
  return t && t.constructor.prototype.isResultSet === !0 || !1;
}
function rWe(t) {
  return t && t.constructor.prototype.isHelp === !0 || !1;
}
function hzn(t) {
  return typeof t == "function";
}
function dzn(t) {
  return t instanceof Date;
}
function pzn(t) {
  return t instanceof RegExp;
}
function Izn(t) {
  return !!(t && typeof t == "object" && t.constructor === Object && !rS(t) && !Nfe(t));
}
function mzn(t) {
  return t === null;
}
function Czn(t) {
  return t === void 0;
}
function Ezn(t) {
  return t && t.isAccessorNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function yzn(t) {
  return t && t.isArrayNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function vzn(t) {
  return t && t.isAssignmentNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function Bzn(t) {
  return t && t.isBlockNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function bzn(t) {
  return t && t.isConditionalNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function _zn(t) {
  return t && t.isConstantNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function Szn(t) {
  return t && t.isFunctionAssignmentNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function Qzn(t) {
  return t && t.isFunctionNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function wzn(t) {
  return t && t.isIndexNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function iWe(t) {
  return t && t.isNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function xzn(t) {
  return t && t.isObjectNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function Rzn(t) {
  return t && t.isOperatorNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function Dzn(t) {
  return t && t.isParenthesisNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function Tzn(t) {
  return t && t.isRangeNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function Nzn(t) {
  return t && t.isSymbolNode === !0 && t.constructor.prototype.isNode === !0 || !1;
}
function oWe(t) {
  return t && t.constructor.prototype.isChain === !0 || !1;
}
function Sg(t) {
  var e = typeof t;
  return e === "object" ? t === null ? "null" : Array.isArray(t) ? "Array" : t instanceof Date ? "Date" : t instanceof RegExp ? "RegExp" : Jl(t) ? "BigNumber" : rS(t) ? "Complex" : Nfe(t) ? "Fraction" : cA(t) ? "Matrix" : Lq(t) ? "Unit" : Mq(t) ? "Index" : tWe(t) ? "Range" : nWe(t) ? "ResultSet" : iWe(t) ? t.type : oWe(t) ? "Chain" : rWe(t) ? "Help" : "Object" : e === "function" ? "Function" : e;
}
function cs(t) {
  var e = typeof t;
  if (e === "number" || e === "string" || e === "boolean" || t === null || t === void 0)
    return t;
  if (typeof t.clone == "function")
    return t.clone();
  if (Array.isArray(t))
    return t.map(function(n) {
      return cs(n);
    });
  if (t instanceof Date)
    return new Date(t.valueOf());
  if (Jl(t))
    return t;
  if (t instanceof RegExp)
    throw new TypeError("Cannot clone " + t);
  return Lzn(t, cs);
}
function Lzn(t, e) {
  var n = {};
  for (var r in t)
    Mo(t, r) && (n[r] = e(t[r]));
  return n;
}
function sWe(t, e) {
  for (var n in e)
    Mo(e, n) && (t[n] = e[n]);
  return t;
}
function Z8(t, e) {
  var n, r, i;
  if (Array.isArray(t)) {
    if (!Array.isArray(e) || t.length !== e.length)
      return !1;
    for (r = 0, i = t.length; r < i; r++)
      if (!Z8(t[r], e[r]))
        return !1;
    return !0;
  } else {
    if (typeof t == "function")
      return t === e;
    if (t instanceof Object) {
      if (Array.isArray(e) || !(e instanceof Object))
        return !1;
      for (n in t)
        if (!(n in e) || !Z8(t[n], e[n]))
          return !1;
      for (n in e)
        if (!(n in t))
          return !1;
      return !0;
    } else
      return t === e;
  }
}
function Mo(t, e) {
  return t && Object.hasOwnProperty.call(t, e);
}
function Mzn(t, e) {
  for (var n = {}, r = 0; r < e.length; r++) {
    var i = e[r], o = t[i];
    o !== void 0 && (n[i] = o);
  }
  return n;
}
var Ozn = ["Matrix", "Array"], Fzn = ["number", "BigNumber", "Fraction"], Jf = function(e) {
  if (e)
    throw new Error(`The global config is readonly. 
Please create a mathjs instance if you want to change the default configuration. 
Example:

  import { create, all } from 'mathjs';
  const mathjs = create(all);
  mathjs.config({ number: 'BigNumber' });
`);
  return Object.freeze(ZKe);
};
at(Jf, ZKe, {
  MATRIX_OPTIONS: Ozn,
  NUMBER_OPTIONS: Fzn
});
var aWe = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ei, function() {
    function n() {
      return !0;
    }
    function r() {
      return !1;
    }
    function i() {
    }
    function o() {
      var s = [
        { name: "number", test: function(oe) {
          return typeof oe == "number";
        } },
        { name: "string", test: function(oe) {
          return typeof oe == "string";
        } },
        { name: "boolean", test: function(oe) {
          return typeof oe == "boolean";
        } },
        { name: "Function", test: function(oe) {
          return typeof oe == "function";
        } },
        { name: "Array", test: Array.isArray },
        { name: "Date", test: function(oe) {
          return oe instanceof Date;
        } },
        { name: "RegExp", test: function(oe) {
          return oe instanceof RegExp;
        } },
        { name: "Object", test: function(oe) {
          return typeof oe == "object" && oe !== null && oe.constructor === Object;
        } },
        { name: "null", test: function(oe) {
          return oe === null;
        } },
        { name: "undefined", test: function(oe) {
          return oe === void 0;
        } }
      ], a = {
        name: "any",
        test: n
      }, A = [], l = [], c = {
        types: s,
        conversions: l,
        ignore: A
      };
      function u(oe) {
        var ie = W(c.types, function(de) {
          return de.name === oe;
        });
        if (ie)
          return ie;
        if (oe === "any")
          return a;
        var Ae = W(c.types, function(de) {
          return de.name.toLowerCase() === oe.toLowerCase();
        });
        throw new TypeError('Unknown type "' + oe + '"' + (Ae ? '. Did you mean "' + Ae.name + '"?' : ""));
      }
      function f(oe) {
        return oe === a ? 999 : c.types.indexOf(oe);
      }
      function h(oe) {
        var ie = W(c.types, function(Ae) {
          return Ae.test(oe);
        });
        if (ie)
          return ie.name;
        throw new TypeError("Value has unknown type. Value: " + oe);
      }
      function d(oe, ie) {
        if (!oe.signatures)
          throw new TypeError("Function is no typed-function");
        var Ae;
        if (typeof ie == "string") {
          Ae = ie.split(",");
          for (var de = 0; de < Ae.length; de++)
            Ae[de] = Ae[de].trim();
        } else if (Array.isArray(ie))
          Ae = ie;
        else
          throw new TypeError("String array or a comma separated string expected");
        var we = Ae.join(","), Pe = oe.signatures[we];
        if (Pe)
          return Pe;
        throw new TypeError("Signature not found (signature: " + (oe.name || "unnamed") + "(" + Ae.join(", ") + "))");
      }
      function I(oe, ie) {
        var Ae = h(oe);
        if (ie === Ae)
          return oe;
        for (var de = 0; de < c.conversions.length; de++) {
          var we = c.conversions[de];
          if (we.from === Ae && we.to === ie)
            return we.convert(oe);
        }
        throw new Error("Cannot convert from " + Ae + " to " + ie);
      }
      function m(oe) {
        return oe.map(function(ie) {
          var Ae = ie.types.map(O);
          return (ie.restParam ? "..." : "") + Ae.join("|");
        }).join(",");
      }
      function C(oe, ie) {
        var Ae = oe.indexOf("...") === 0, de = Ae ? oe.length > 3 ? oe.slice(3) : "any" : oe, we = de.split("|").map(Ie).filter(Qe).filter(Be), Pe = z(ie, we), qe = we.map(function(Xe) {
          var rt = u(Xe);
          return {
            name: Xe,
            typeIndex: f(rt),
            test: rt.test,
            conversion: null,
            conversionIndex: -1
          };
        }), ke = Pe.map(function(Xe) {
          var rt = u(Xe.from);
          return {
            name: Xe.from,
            typeIndex: f(rt),
            test: rt.test,
            conversion: Xe,
            conversionIndex: ie.indexOf(Xe)
          };
        });
        return {
          types: qe.concat(ke),
          restParam: Ae
        };
      }
      function y(oe, ie, Ae) {
        var de = [];
        return oe.trim() !== "" && (de = oe.split(",").map(Ie).map(function(we, Pe, qe) {
          var ke = C(we, Ae);
          if (ke.restParam && Pe !== qe.length - 1)
            throw new SyntaxError('Unexpected rest parameter "' + we + '": only allowed for the last parameter');
          return ke;
        })), de.some(Se) ? null : {
          params: de,
          fn: ie
        };
      }
      function v(oe) {
        var ie = Ue(oe);
        return ie ? ie.restParam : !1;
      }
      function b(oe) {
        return oe.types.some(function(ie) {
          return ie.conversion != null;
        });
      }
      function Q(oe) {
        if (!oe || oe.types.length === 0)
          return n;
        if (oe.types.length === 1)
          return u(oe.types[0].name).test;
        if (oe.types.length === 2) {
          var ie = u(oe.types[0].name).test, Ae = u(oe.types[1].name).test;
          return function(Pe) {
            return ie(Pe) || Ae(Pe);
          };
        } else {
          var de = oe.types.map(function(we) {
            return u(we.name).test;
          });
          return function(Pe) {
            for (var qe = 0; qe < de.length; qe++)
              if (de[qe](Pe))
                return !0;
            return !1;
          };
        }
      }
      function w(oe) {
        var ie, Ae, de;
        if (v(oe)) {
          ie = De(oe).map(Q);
          var we = ie.length, Pe = Q(Ue(oe)), qe = function(ke) {
            for (var Xe = we; Xe < ke.length; Xe++)
              if (!Pe(ke[Xe]))
                return !1;
            return !0;
          };
          return function(Xe) {
            for (var rt = 0; rt < ie.length; rt++)
              if (!ie[rt](Xe[rt]))
                return !1;
            return qe(Xe) && Xe.length >= we + 1;
          };
        } else
          return oe.length === 0 ? function(Xe) {
            return Xe.length === 0;
          } : oe.length === 1 ? (Ae = Q(oe[0]), function(Xe) {
            return Ae(Xe[0]) && Xe.length === 1;
          }) : oe.length === 2 ? (Ae = Q(oe[0]), de = Q(oe[1]), function(Xe) {
            return Ae(Xe[0]) && de(Xe[1]) && Xe.length === 2;
          }) : (ie = oe.map(Q), function(Xe) {
            for (var rt = 0; rt < ie.length; rt++)
              if (!ie[rt](Xe[rt]))
                return !1;
            return Xe.length === ie.length;
          });
      }
      function R(oe, ie) {
        return ie < oe.params.length ? oe.params[ie] : v(oe.params) ? Ue(oe.params) : null;
      }
      function M(oe, ie, Ae) {
        var de = R(oe, ie), we = de ? Ae ? de.types.filter(L) : de.types : [];
        return we.map(O);
      }
      function O(oe) {
        return oe.name;
      }
      function L(oe) {
        return oe.conversion === null || oe.conversion === void 0;
      }
      function N(oe, ie) {
        var Ae = ge(_e(oe, function(de) {
          return M(de, ie, !1);
        }));
        return Ae.indexOf("any") !== -1 ? ["any"] : Ae;
      }
      function k(oe, ie, Ae) {
        var de, we, Pe = oe || "unnamed", qe = Ae, ke;
        for (ke = 0; ke < ie.length; ke++) {
          var Xe = qe.filter(function(mt) {
            var _t = Q(R(mt, ke));
            return (ke < mt.params.length || v(mt.params)) && _t(ie[ke]);
          });
          if (Xe.length === 0) {
            if (we = N(qe, ke), we.length > 0) {
              var rt = h(ie[ke]);
              return de = new TypeError("Unexpected type of argument in function " + Pe + " (expected: " + we.join(" or ") + ", actual: " + rt + ", index: " + ke + ")"), de.data = {
                category: "wrongType",
                fn: Pe,
                index: ke,
                actual: rt,
                expected: we
              }, de;
            }
          } else
            qe = Xe;
        }
        var it = qe.map(function(mt) {
          return v(mt.params) ? 1 / 0 : mt.params.length;
        });
        if (ie.length < Math.min.apply(null, it))
          return we = N(qe, ke), de = new TypeError("Too few arguments in function " + Pe + " (expected: " + we.join(" or ") + ", index: " + ie.length + ")"), de.data = {
            category: "tooFewArgs",
            fn: Pe,
            index: ie.length,
            expected: we
          }, de;
        var ht = Math.max.apply(null, it);
        return ie.length > ht ? (de = new TypeError("Too many arguments in function " + Pe + " (expected: " + ht + ", actual: " + ie.length + ")"), de.data = {
          category: "tooManyArgs",
          fn: Pe,
          index: ie.length,
          expectedLength: ht
        }, de) : (de = new TypeError('Arguments of type "' + ie.join(", ") + '" do not match any of the defined signatures of function ' + Pe + "."), de.data = {
          category: "mismatch",
          actual: ie.map(h)
        }, de);
      }
      function $(oe) {
        for (var ie = 999, Ae = 0; Ae < oe.types.length; Ae++)
          L(oe.types[Ae]) && (ie = Math.min(ie, oe.types[Ae].typeIndex));
        return ie;
      }
      function U(oe) {
        for (var ie = 999, Ae = 0; Ae < oe.types.length; Ae++)
          L(oe.types[Ae]) || (ie = Math.min(ie, oe.types[Ae].conversionIndex));
        return ie;
      }
      function X(oe, ie) {
        var Ae;
        return Ae = oe.restParam - ie.restParam, Ae !== 0 || (Ae = b(oe) - b(ie), Ae !== 0) || (Ae = $(oe) - $(ie), Ae !== 0) ? Ae : U(oe) - U(ie);
      }
      function K(oe, ie) {
        var Ae = Math.min(oe.params.length, ie.params.length), de, we;
        if (we = oe.params.some(b) - ie.params.some(b), we !== 0)
          return we;
        for (de = 0; de < Ae; de++)
          if (we = b(oe.params[de]) - b(ie.params[de]), we !== 0)
            return we;
        for (de = 0; de < Ae; de++)
          if (we = X(oe.params[de], ie.params[de]), we !== 0)
            return we;
        return oe.params.length - ie.params.length;
      }
      function z(oe, ie) {
        var Ae = {};
        return oe.forEach(function(de) {
          ie.indexOf(de.from) === -1 && ie.indexOf(de.to) !== -1 && !Ae[de.from] && (Ae[de.from] = de);
        }), Object.keys(Ae).map(function(de) {
          return Ae[de];
        });
      }
      function Y(oe, ie) {
        var Ae = ie;
        if (oe.some(b)) {
          var de = v(oe), we = oe.map(V);
          Ae = function() {
            for (var Xe = [], rt = de ? arguments.length - 1 : arguments.length, it = 0; it < rt; it++)
              Xe[it] = we[it](arguments[it]);
            return de && (Xe[rt] = arguments[rt].map(we[rt])), ie.apply(this, Xe);
          };
        }
        var Pe = Ae;
        if (v(oe)) {
          var qe = oe.length - 1;
          Pe = function() {
            return Ae.apply(
              this,
              Te(arguments, 0, qe).concat([Te(arguments, qe)])
            );
          };
        }
        return Pe;
      }
      function V(oe) {
        var ie, Ae, de, we, Pe = [], qe = [];
        switch (oe.types.forEach(function(ke) {
          ke.conversion && (Pe.push(u(ke.conversion.from).test), qe.push(ke.conversion.convert));
        }), qe.length) {
          case 0:
            return function(Xe) {
              return Xe;
            };
          case 1:
            return ie = Pe[0], de = qe[0], function(Xe) {
              return ie(Xe) ? de(Xe) : Xe;
            };
          case 2:
            return ie = Pe[0], Ae = Pe[1], de = qe[0], we = qe[1], function(Xe) {
              return ie(Xe) ? de(Xe) : Ae(Xe) ? we(Xe) : Xe;
            };
          default:
            return function(Xe) {
              for (var rt = 0; rt < qe.length; rt++)
                if (Pe[rt](Xe))
                  return qe[rt](Xe);
              return Xe;
            };
        }
      }
      function Z(oe) {
        var ie = {};
        return oe.forEach(function(Ae) {
          Ae.params.some(b) || ce(Ae.params, !0).forEach(function(de) {
            ie[m(de)] = Ae.fn;
          });
        }), ie;
      }
      function ce(oe, ie) {
        function Ae(de, we, Pe) {
          if (we < de.length) {
            var qe = de[we], ke = ie ? qe.types.filter(L) : qe.types, Xe;
            if (qe.restParam) {
              var rt = ke.filter(L);
              Xe = rt.length < ke.length ? [rt, ke] : [ke];
            } else
              Xe = ke.map(function(ht) {
                return [ht];
              });
            return _e(Xe, function(ht) {
              return Ae(de, we + 1, Pe.concat([ht]));
            });
          } else {
            var it = Pe.map(function(ht, mt) {
              return {
                types: ht,
                restParam: mt === de.length - 1 && v(de)
              };
            });
            return [it];
          }
        }
        return Ae(oe, 0, []);
      }
      function ee(oe, ie) {
        for (var Ae = Math.max(oe.params.length, ie.params.length), de = 0; de < Ae; de++) {
          var we = M(oe, de, !0), Pe = M(ie, de, !0);
          if (!fe(we, Pe))
            return !1;
        }
        var qe = oe.params.length, ke = ie.params.length, Xe = v(oe.params), rt = v(ie.params);
        return Xe ? rt ? qe === ke : ke >= qe : rt ? qe >= ke : qe === ke;
      }
      function pe(oe, ie) {
        if (Object.keys(ie).length === 0)
          throw new SyntaxError("No signatures provided");
        var Ae = [];
        Object.keys(ie).map(function(He) {
          return y(He, ie[He], c.conversions);
        }).filter(xe).forEach(function(He) {
          var ze = W(Ae, function(tt) {
            return ee(tt, He);
          });
          if (ze)
            throw new TypeError('Conflicting signatures "' + m(ze.params) + '" and "' + m(He.params) + '".');
          Ae.push(He);
        });
        var de = _e(Ae, function(He) {
          var ze = He ? ce(He.params, !1) : [];
          return ze.map(function(tt) {
            return {
              params: tt,
              fn: He.fn
            };
          });
        }).filter(xe);
        de.sort(K);
        var we = de[0] && de[0].params.length <= 2 && !v(de[0].params), Pe = de[1] && de[1].params.length <= 2 && !v(de[1].params), qe = de[2] && de[2].params.length <= 2 && !v(de[2].params), ke = de[3] && de[3].params.length <= 2 && !v(de[3].params), Xe = de[4] && de[4].params.length <= 2 && !v(de[4].params), rt = de[5] && de[5].params.length <= 2 && !v(de[5].params), it = we && Pe && qe && ke && Xe && rt, ht = de.map(function(He) {
          return w(He.params);
        }), mt = we ? Q(de[0].params[0]) : r, _t = Pe ? Q(de[1].params[0]) : r, Ct = qe ? Q(de[2].params[0]) : r, zt = ke ? Q(de[3].params[0]) : r, jt = Xe ? Q(de[4].params[0]) : r, lt = rt ? Q(de[5].params[0]) : r, Ht = we ? Q(de[0].params[1]) : r, vt = Pe ? Q(de[1].params[1]) : r, It = qe ? Q(de[2].params[1]) : r, un = ke ? Q(de[3].params[1]) : r, hn = Xe ? Q(de[4].params[1]) : r, We = rt ? Q(de[5].params[1]) : r, En = de.map(function(He) {
          return Y(He.params, He.fn);
        }), qn = we ? En[0] : i, Pt = Pe ? En[1] : i, dr = qe ? En[2] : i, yr = ke ? En[3] : i, jn = Xe ? En[4] : i, Ot = rt ? En[5] : i, yn = we ? de[0].params.length : -1, Fn = Pe ? de[1].params.length : -1, xn = qe ? de[2].params.length : -1, vn = ke ? de[3].params.length : -1, nt = Xe ? de[4].params.length : -1, st = rt ? de[5].params.length : -1, xt = it ? 6 : 0, Me = de.length, _ = function() {
          for (var ze = xt; ze < Me; ze++)
            if (ht[ze](arguments))
              return En[ze].apply(this, arguments);
          return c.onMismatch(oe, arguments, de);
        }, ye = function He(ze, tt) {
          return arguments.length === yn && mt(ze) && Ht(tt) ? qn.apply(He, arguments) : arguments.length === Fn && _t(ze) && vt(tt) ? Pt.apply(He, arguments) : arguments.length === xn && Ct(ze) && It(tt) ? dr.apply(He, arguments) : arguments.length === vn && zt(ze) && un(tt) ? yr.apply(He, arguments) : arguments.length === nt && jt(ze) && hn(tt) ? jn.apply(He, arguments) : arguments.length === st && lt(ze) && We(tt) ? Ot.apply(He, arguments) : _.apply(He, arguments);
        };
        try {
          Object.defineProperty(ye, "name", { value: oe });
        } catch {
        }
        return ye.signatures = Z(de), ye;
      }
      function Ce(oe, ie, Ae) {
        throw k(oe, ie, Ae);
      }
      function Be(oe) {
        return c.ignore.indexOf(oe) === -1;
      }
      function Ie(oe) {
        return oe.trim();
      }
      function Qe(oe) {
        return !!oe;
      }
      function xe(oe) {
        return oe !== null;
      }
      function Se(oe) {
        return oe.types.length === 0;
      }
      function De(oe) {
        return oe.slice(0, oe.length - 1);
      }
      function Ue(oe) {
        return oe[oe.length - 1];
      }
      function Te(oe, ie, Ae) {
        return Array.prototype.slice.call(oe, ie, Ae);
      }
      function se(oe, ie) {
        return oe.indexOf(ie) !== -1;
      }
      function fe(oe, ie) {
        for (var Ae = 0; Ae < oe.length; Ae++)
          if (se(ie, oe[Ae]))
            return !0;
        return !1;
      }
      function W(oe, ie) {
        for (var Ae = 0; Ae < oe.length; Ae++)
          if (ie(oe[Ae]))
            return oe[Ae];
      }
      function ge(oe) {
        for (var ie = {}, Ae = 0; Ae < oe.length; Ae++)
          ie[oe[Ae]] = !0;
        return Object.keys(ie);
      }
      function _e(oe, ie) {
        return Array.prototype.concat.apply([], oe.map(ie));
      }
      function Re(oe) {
        for (var ie = "", Ae = 0; Ae < oe.length; Ae++) {
          var de = oe[Ae];
          if ((typeof de.signatures == "object" || typeof de.signature == "string") && de.name !== "") {
            if (ie === "")
              ie = de.name;
            else if (ie !== de.name) {
              var we = new Error("Function names do not match (expected: " + ie + ", actual: " + de.name + ")");
              throw we.data = {
                actual: de.name,
                expected: ie
              }, we;
            }
          }
        }
        return ie;
      }
      function Ee(oe) {
        var ie, Ae = {};
        function de(ke, Xe) {
          if (Ae.hasOwnProperty(ke) && Xe !== Ae[ke])
            throw ie = new Error('Signature "' + ke + '" is defined twice'), ie.data = { signature: ke }, ie;
        }
        for (var we = 0; we < oe.length; we++) {
          var Pe = oe[we];
          if (typeof Pe.signatures == "object")
            for (var qe in Pe.signatures)
              Pe.signatures.hasOwnProperty(qe) && (de(qe, Pe.signatures[qe]), Ae[qe] = Pe.signatures[qe]);
          else if (typeof Pe.signature == "string")
            de(Pe.signature, Pe), Ae[Pe.signature] = Pe;
          else
            throw ie = new TypeError("Function is no typed-function (index: " + we + ")"), ie.data = { index: we }, ie;
        }
        return Ae;
      }
      return c = pe("typed", {
        "string, Object": pe,
        Object: function(oe) {
          var ie = [];
          for (var Ae in oe)
            oe.hasOwnProperty(Ae) && ie.push(oe[Ae]);
          var de = Re(ie);
          return pe(de, oe);
        },
        "...Function": function(oe) {
          return pe(Re(oe), Ee(oe));
        },
        "string, ...Function": function(oe, ie) {
          return pe(oe, Ee(ie));
        }
      }), c.create = o, c.types = s, c.conversions = l, c.ignore = A, c.onMismatch = Ce, c.throwMismatchError = Ce, c.createError = k, c.convert = I, c.find = d, c.addType = function(oe, ie) {
        if (!oe || typeof oe.name != "string" || typeof oe.test != "function")
          throw new TypeError("Object with properties {name: string, test: function} expected");
        if (ie !== !1) {
          for (var Ae = 0; Ae < c.types.length; Ae++)
            if (c.types[Ae].name === "Object") {
              c.types.splice(Ae, 0, oe);
              return;
            }
        }
        c.types.push(oe);
      }, c.addConversion = function(oe) {
        if (!oe || typeof oe.from != "string" || typeof oe.to != "string" || typeof oe.convert != "function")
          throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
        c.conversions.push(oe);
      }, c;
    }
    return o();
  });
})(aWe);
var Pzn = aWe.exports;
const eTe = /* @__PURE__ */ ko(Pzn);
function Ts(t) {
  return typeof t == "boolean" ? !0 : isFinite(t) ? t === Math.round(t) : !1;
}
function lK(t, e, n) {
  var r = {
    2: "0b",
    8: "0o",
    16: "0x"
  }, i = r[e], o = "";
  if (n) {
    if (n < 1)
      throw new Error("size must be in greater than 0");
    if (!Ts(n))
      throw new Error("size must be an integer");
    if (t > 2 ** (n - 1) - 1 || t < -(2 ** (n - 1)))
      throw new Error("Value must be in range [-2^".concat(n - 1, ", 2^").concat(n - 1, "-1]"));
    if (!Ts(t))
      throw new Error("Value must be an integer");
    t < 0 && (t = t + 2 ** n), o = "i".concat(n);
  }
  var s = "";
  return t < 0 && (t = -t, s = "-"), "".concat(s).concat(i).concat(t.toString(e)).concat(o);
}
function Ire(t, e) {
  if (typeof e == "function")
    return e(t);
  if (t === 1 / 0)
    return "Infinity";
  if (t === -1 / 0)
    return "-Infinity";
  if (isNaN(t))
    return "NaN";
  var n = "auto", r, i;
  if (e && (e.notation && (n = e.notation), ga(e) ? r = e : ga(e.precision) && (r = e.precision), e.wordSize && (i = e.wordSize, typeof i != "number")))
    throw new Error('Option "wordSize" must be a number');
  switch (n) {
    case "fixed":
      return AWe(t, r);
    case "exponential":
      return lWe(t, r);
    case "engineering":
      return kzn(t, r);
    case "bin":
      return lK(t, 2, i);
    case "oct":
      return lK(t, 8, i);
    case "hex":
      return lK(t, 16, i);
    case "auto":
      return Gzn(t, r, e && e).replace(/((\.\d*?)(0+))($|e)/, function() {
        var o = arguments[2], s = arguments[4];
        return o !== "." ? o + s : s;
      });
    default:
      throw new Error('Unknown notation "' + n + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function Oq(t) {
  var e = String(t).toLowerCase().match(/^0*?(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!e)
    throw new SyntaxError("Invalid number " + t);
  var n = e[1], r = e[2], i = parseFloat(e[4] || "0"), o = r.indexOf(".");
  i += o !== -1 ? o - 1 : r.length - 1;
  var s = r.replace(".", "").replace(/^0*/, function(a) {
    return i -= a.length, "";
  }).replace(/0*$/, "").split("").map(function(a) {
    return parseInt(a);
  });
  return s.length === 0 && (s.push(0), i++), {
    sign: n,
    coefficients: s,
    exponent: i
  };
}
function kzn(t, e) {
  if (isNaN(t) || !isFinite(t))
    return String(t);
  var n = Oq(t), r = Fq(n, e), i = r.exponent, o = r.coefficients, s = i % 3 === 0 ? i : i < 0 ? i - 3 - i % 3 : i - i % 3;
  if (ga(e))
    for (; e > o.length || i - s + 1 > o.length; )
      o.push(0);
  else
    for (var a = Math.abs(i - s) - (o.length - 1), A = 0; A < a; A++)
      o.push(0);
  for (var l = Math.abs(i - s), c = 1; l > 0; )
    c++, l--;
  var u = o.slice(c).join(""), f = ga(e) && u.length || u.match(/[1-9]/) ? "." + u : "", h = o.slice(0, c).join("") + f + "e" + (i >= 0 ? "+" : "") + s.toString();
  return r.sign + h;
}
function AWe(t, e) {
  if (isNaN(t) || !isFinite(t))
    return String(t);
  var n = Oq(t), r = typeof e == "number" ? Fq(n, n.exponent + 1 + e) : n, i = r.coefficients, o = r.exponent + 1, s = o + (e || 0);
  return i.length < s && (i = i.concat(iS(s - i.length))), o < 0 && (i = iS(-o + 1).concat(i), o = 1), o < i.length && i.splice(o, 0, o === 0 ? "0." : "."), r.sign + i.join("");
}
function lWe(t, e) {
  if (isNaN(t) || !isFinite(t))
    return String(t);
  var n = Oq(t), r = e ? Fq(n, e) : n, i = r.coefficients, o = r.exponent;
  i.length < e && (i = i.concat(iS(e - i.length)));
  var s = i.shift();
  return r.sign + s + (i.length > 0 ? "." + i.join("") : "") + "e" + (o >= 0 ? "+" : "") + o;
}
function Gzn(t, e, n) {
  if (isNaN(t) || !isFinite(t))
    return String(t);
  var r = n && n.lowerExp !== void 0 ? n.lowerExp : -3, i = n && n.upperExp !== void 0 ? n.upperExp : 5, o = Oq(t), s = e ? Fq(o, e) : o;
  if (s.exponent < r || s.exponent >= i)
    return lWe(t, e);
  var a = s.coefficients, A = s.exponent;
  a.length < e && (a = a.concat(iS(e - a.length))), a = a.concat(iS(A - a.length + 1 + (a.length < e ? e - a.length : 0))), a = iS(-A).concat(a);
  var l = A > 0 ? A : 0;
  return l < a.length - 1 && a.splice(l + 1, 0, "."), s.sign + a.join("");
}
function Fq(t, e) {
  for (var n = {
    sign: t.sign,
    coefficients: t.coefficients,
    exponent: t.exponent
  }, r = n.coefficients; e <= 0; )
    r.unshift(0), n.exponent++, e++;
  if (r.length > e) {
    var i = r.splice(e, r.length - e);
    if (i[0] >= 5) {
      var o = e - 1;
      for (r[o]++; r[o] === 10; )
        r.pop(), o === 0 && (r.unshift(0), n.exponent++, o++), o--, r[o]++;
    }
  }
  return n;
}
function iS(t) {
  for (var e = [], n = 0; n < t; n++)
    e.push(0);
  return e;
}
function Uzn(t) {
  return t.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length;
}
var Hzn = Number.EPSILON || 2220446049250313e-31;
function dd(t, e, n) {
  if (n == null)
    return t === e;
  if (t === e)
    return !0;
  if (isNaN(t) || isNaN(e))
    return !1;
  if (isFinite(t) && isFinite(e)) {
    var r = Math.abs(t - e);
    return r < Hzn ? !0 : r <= Math.max(Math.abs(t), Math.abs(e)) * n;
  }
  return !1;
}
function cK(t, e, n) {
  var r = t.constructor, i = new r(2), o = "";
  if (n) {
    if (n < 1)
      throw new Error("size must be in greater than 0");
    if (!Ts(n))
      throw new Error("size must be an integer");
    if (t.greaterThan(i.pow(n - 1).sub(1)) || t.lessThan(i.pow(n - 1).mul(-1)))
      throw new Error("Value must be in range [-2^".concat(n - 1, ", 2^").concat(n - 1, "-1]"));
    if (!t.isInteger())
      throw new Error("Value must be an integer");
    t.lessThan(0) && (t = t.add(i.pow(n))), o = "i".concat(n);
  }
  switch (e) {
    case 2:
      return "".concat(t.toBinary()).concat(o);
    case 8:
      return "".concat(t.toOctal()).concat(o);
    case 16:
      return "".concat(t.toHexadecimal()).concat(o);
    default:
      throw new Error("Base ".concat(e, " not supported "));
  }
}
function $zn(t, e) {
  if (typeof e == "function")
    return e(t);
  if (!t.isFinite())
    return t.isNaN() ? "NaN" : t.gt(0) ? "Infinity" : "-Infinity";
  var n = "auto", r, i;
  if (e !== void 0 && (e.notation && (n = e.notation), typeof e == "number" ? r = e : e.precision && (r = e.precision), e.wordSize && (i = e.wordSize, typeof i != "number")))
    throw new Error('Option "wordSize" must be a number');
  switch (n) {
    case "fixed":
      return jzn(t, r);
    case "exponential":
      return tTe(t, r);
    case "engineering":
      return qzn(t, r);
    case "bin":
      return cK(t, 2, i);
    case "oct":
      return cK(t, 8, i);
    case "hex":
      return cK(t, 16, i);
    case "auto": {
      var o = e && e.lowerExp !== void 0 ? e.lowerExp : -3, s = e && e.upperExp !== void 0 ? e.upperExp : 5;
      if (t.isZero())
        return "0";
      var a, A = t.toSignificantDigits(r), l = A.e;
      return l >= o && l < s ? a = A.toFixed() : a = tTe(t, r), a.replace(/((\.\d*?)(0+))($|e)/, function() {
        var c = arguments[2], u = arguments[4];
        return c !== "." ? c + u : u;
      });
    }
    default:
      throw new Error('Unknown notation "' + n + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function qzn(t, e) {
  var n = t.e, r = n % 3 === 0 ? n : n < 0 ? n - 3 - n % 3 : n - n % 3, i = t.mul(Math.pow(10, -r)), o = i.toPrecision(e);
  return o.indexOf("e") !== -1 && (o = i.toString()), o + "e" + (n >= 0 ? "+" : "") + r.toString();
}
function tTe(t, e) {
  return e !== void 0 ? t.toExponential(e - 1) : t.toExponential();
}
function jzn(t, e) {
  return t.toFixed(e);
}
function Yzn(t, e) {
  var n = t.length - e.length, r = t.length;
  return t.substring(n, r) === e;
}
function ua(t, e) {
  if (typeof t == "number")
    return Ire(t, e);
  if (Jl(t))
    return $zn(t, e);
  if (zzn(t))
    return !e || e.fraction !== "decimal" ? t.s * t.n + "/" + t.d : t.toString();
  if (Array.isArray(t))
    return cWe(t, e);
  if (X0(t))
    return '"' + t + '"';
  if (typeof t == "function")
    return t.syntax ? String(t.syntax) : "function";
  if (t && typeof t == "object") {
    if (typeof t.format == "function")
      return t.format(e);
    if (t && t.toString(e) !== {}.toString())
      return t.toString(e);
    var n = Object.keys(t).map((r) => '"' + r + '": ' + ua(t[r], e));
    return "{" + n.join(", ") + "}";
  }
  return String(t);
}
function cWe(t, e) {
  if (Array.isArray(t)) {
    for (var n = "[", r = t.length, i = 0; i < r; i++)
      i !== 0 && (n += ", "), n += cWe(t[i], e);
    return n += "]", n;
  } else
    return ua(t, e);
}
function zzn(t) {
  return t && typeof t == "object" && typeof t.s == "number" && typeof t.n == "number" && typeof t.d == "number" || !1;
}
function Qo(t, e, n) {
  if (!(this instanceof Qo))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.actual = t, this.expected = e, this.relation = n, this.message = "Dimension mismatch (" + (Array.isArray(t) ? "[" + t.join(", ") + "]" : t) + " " + (this.relation || "!=") + " " + (Array.isArray(e) ? "[" + e.join(", ") + "]" : e) + ")", this.stack = new Error().stack;
}
Qo.prototype = new RangeError();
Qo.prototype.constructor = RangeError;
Qo.prototype.name = "DimensionError";
Qo.prototype.isDimensionError = !0;
function Ax(t, e, n) {
  if (!(this instanceof Ax))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.index = t, arguments.length < 3 ? (this.min = 0, this.max = e) : (this.min = e, this.max = n), this.min !== void 0 && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : this.max !== void 0 && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = new Error().stack;
}
Ax.prototype = new RangeError();
Ax.prototype.constructor = RangeError;
Ax.prototype.name = "IndexError";
Ax.prototype.isIndexError = !0;
function PI(t) {
  for (var e = []; Array.isArray(t); )
    e.push(t.length), t = t[0];
  return e;
}
function uWe(t, e, n) {
  var r, i = t.length;
  if (i !== e[n])
    throw new Qo(i, e[n]);
  if (n < e.length - 1) {
    var o = n + 1;
    for (r = 0; r < i; r++) {
      var s = t[r];
      if (!Array.isArray(s))
        throw new Qo(e.length - 1, e.length, "<");
      uWe(t[r], e, o);
    }
  } else
    for (r = 0; r < i; r++)
      if (Array.isArray(t[r]))
        throw new Qo(e.length + 1, e.length, ">");
}
function nTe(t, e) {
  var n = e.length === 0;
  if (n) {
    if (Array.isArray(t))
      throw new Qo(t.length, 0);
  } else
    uWe(t, e, 0);
}
function Ga(t, e) {
  if (!ga(t) || !Ts(t))
    throw new TypeError("Index must be an integer (value: " + t + ")");
  if (t < 0 || typeof e == "number" && t >= e)
    throw new Ax(t, e);
}
function e5(t, e, n) {
  if (!Array.isArray(t) || !Array.isArray(e))
    throw new TypeError("Array expected");
  if (e.length === 0)
    throw new Error("Resizing to scalar is not supported");
  e.forEach(function(i) {
    if (!ga(i) || !Ts(i) || i < 0)
      throw new TypeError("Invalid size, must contain positive integers (size: " + ua(e) + ")");
  });
  var r = n !== void 0 ? n : 0;
  return mre(t, e, 0, r), t;
}
function mre(t, e, n, r) {
  var i, o, s = t.length, a = e[n], A = Math.min(s, a);
  if (t.length = a, n < e.length - 1) {
    var l = n + 1;
    for (i = 0; i < A; i++)
      o = t[i], Array.isArray(o) || (o = [o], t[i] = o), mre(o, e, l, r);
    for (i = A; i < a; i++)
      o = [], t[i] = o, mre(o, e, l, r);
  } else {
    for (i = 0; i < A; i++)
      for (; Array.isArray(t[i]); )
        t[i] = t[i][0];
    for (i = A; i < a; i++)
      t[i] = r;
  }
}
function Vzn(t, e) {
  var n = Kzn(t), r = n.length;
  if (!Array.isArray(t) || !Array.isArray(e))
    throw new TypeError("Array expected");
  if (e.length === 0)
    throw new Qo(0, r, "!=");
  e = Lfe(e, r);
  var i = fWe(e);
  if (r !== i)
    throw new Qo(i, r, "!=");
  try {
    return Jzn(n, e);
  } catch (o) {
    throw o instanceof Qo ? new Qo(i, r, "!=") : o;
  }
}
function Lfe(t, e) {
  var n = fWe(t), r = t.slice(), i = -1, o = t.indexOf(i), s = t.indexOf(i, o + 1) >= 0;
  if (s)
    throw new Error("More than one wildcard in sizes");
  var a = o >= 0, A = e % n === 0;
  if (a)
    if (A)
      r[o] = -e / n;
    else
      throw new Error("Could not replace wildcard, since " + e + " is no multiple of " + -n);
  return r;
}
function fWe(t) {
  return t.reduce((e, n) => e * n, 1);
}
function Jzn(t, e) {
  for (var n = t, r, i = e.length - 1; i > 0; i--) {
    var o = e[i];
    r = [];
    for (var s = n.length / o, a = 0; a < s; a++)
      r.push(n.slice(a * o, (a + 1) * o));
    n = r;
  }
  return n;
}
function gWe(t, e, n, r) {
  var i = r || PI(t);
  if (n)
    for (var o = 0; o < n; o++)
      t = [t], i.unshift(1);
  for (t = hWe(t, e, 0); i.length < e; )
    i.push(1);
  return t;
}
function hWe(t, e, n) {
  var r, i;
  if (Array.isArray(t)) {
    var o = n + 1;
    for (r = 0, i = t.length; r < i; r++)
      t[r] = hWe(t[r], e, o);
  } else
    for (var s = n; s < e; s++)
      t = [t];
  return t;
}
function Kzn(t) {
  if (!Array.isArray(t))
    return t;
  var e = [];
  return t.forEach(function n(r) {
    Array.isArray(r) ? r.forEach(n) : e.push(r);
  }), e;
}
function t5(t, e) {
  for (var n, r = 0, i = 0; i < t.length; i++) {
    var o = t[i], s = Array.isArray(o);
    if (i === 0 && s && (r = o.length), s && o.length !== r)
      return;
    var a = s ? t5(o, e) : e(o);
    if (n === void 0)
      n = a;
    else if (n !== a)
      return "mixed";
  }
  return n;
}
function Ar(t, e, n, r) {
  function i(o) {
    var s = Mzn(o, e.map(Zzn));
    return Wzn(t, e, o), n(s);
  }
  return i.isFactory = !0, i.fn = t, i.dependencies = e.slice().sort(), r && (i.meta = r), i;
}
function Wzn(t, e, n) {
  var r = e.filter((o) => !Xzn(o)).every((o) => n[o] !== void 0);
  if (!r) {
    var i = e.filter((o) => n[o] === void 0);
    throw new Error('Cannot create function "'.concat(t, '", ') + "some dependencies are missing: ".concat(i.map((o) => '"'.concat(o, '"')).join(", "), "."));
  }
}
function Xzn(t) {
  return t && t[0] === "?";
}
function Zzn(t) {
  return t && t[0] === "?" ? t.slice(1) : t;
}
function e7n(t, e) {
  if (pWe(t) && dWe(t, e))
    return t[e];
  throw typeof t[e] == "function" && r7n(t, e) ? new Error('Cannot access method "' + e + '" as a property') : new Error('No access to property "' + e + '"');
}
function t7n(t, e, n) {
  if (pWe(t) && dWe(t, e))
    return t[e] = n, n;
  throw new Error('No access to property "' + e + '"');
}
function n7n(t, e) {
  return e in t;
}
function dWe(t, e) {
  return !t || typeof t != "object" ? !1 : Mo(i7n, e) ? !0 : !(e in Object.prototype || e in Function.prototype);
}
function r7n(t, e) {
  return t == null || typeof t[e] != "function" || Mo(t, e) && Object.getPrototypeOf && e in Object.getPrototypeOf(t) ? !1 : Mo(o7n, e) ? !0 : !(e in Object.prototype || e in Function.prototype);
}
function pWe(t) {
  return typeof t == "object" && t && t.constructor === Object;
}
var i7n = {
  length: !0,
  name: !0
}, o7n = {
  toString: !0,
  valueOf: !0,
  toLocaleString: !0
};
class s7n {
  constructor(e) {
    this.wrappedObject = e;
  }
  keys() {
    return Object.keys(this.wrappedObject);
  }
  get(e) {
    return e7n(this.wrappedObject, e);
  }
  set(e, n) {
    return t7n(this.wrappedObject, e, n), this;
  }
  has(e) {
    return n7n(this.wrappedObject, e);
  }
}
function a7n(t) {
  return t ? t instanceof Map || t instanceof s7n || typeof t.set == "function" && typeof t.get == "function" && typeof t.keys == "function" && typeof t.has == "function" : !1;
}
var IWe = function() {
  return IWe = eTe.create, eTe;
}, A7n = ["?BigNumber", "?Complex", "?DenseMatrix", "?Fraction"], l7n = /* @__PURE__ */ Ar("typed", A7n, function(e) {
  var {
    BigNumber: n,
    Complex: r,
    DenseMatrix: i,
    Fraction: o
  } = e, s = IWe();
  return s.types = [
    {
      name: "number",
      test: ga
    },
    {
      name: "Complex",
      test: rS
    },
    {
      name: "BigNumber",
      test: Jl
    },
    {
      name: "Fraction",
      test: Nfe
    },
    {
      name: "Unit",
      test: Lq
    },
    {
      name: "string",
      test: X0
    },
    {
      name: "Chain",
      test: oWe
    },
    {
      name: "Array",
      test: zs
    },
    {
      name: "Matrix",
      test: cA
    },
    {
      name: "DenseMatrix",
      test: uzn
    },
    {
      name: "SparseMatrix",
      test: fzn
    },
    {
      name: "Range",
      test: tWe
    },
    {
      name: "Index",
      test: Mq
    },
    {
      name: "boolean",
      test: gzn
    },
    {
      name: "ResultSet",
      test: nWe
    },
    {
      name: "Help",
      test: rWe
    },
    {
      name: "function",
      test: hzn
    },
    {
      name: "Date",
      test: dzn
    },
    {
      name: "RegExp",
      test: pzn
    },
    {
      name: "null",
      test: mzn
    },
    {
      name: "undefined",
      test: Czn
    },
    {
      name: "AccessorNode",
      test: Ezn
    },
    {
      name: "ArrayNode",
      test: yzn
    },
    {
      name: "AssignmentNode",
      test: vzn
    },
    {
      name: "BlockNode",
      test: Bzn
    },
    {
      name: "ConditionalNode",
      test: bzn
    },
    {
      name: "ConstantNode",
      test: _zn
    },
    {
      name: "FunctionNode",
      test: Qzn
    },
    {
      name: "FunctionAssignmentNode",
      test: Szn
    },
    {
      name: "IndexNode",
      test: wzn
    },
    {
      name: "Node",
      test: iWe
    },
    {
      name: "ObjectNode",
      test: xzn
    },
    {
      name: "OperatorNode",
      test: Rzn
    },
    {
      name: "ParenthesisNode",
      test: Dzn
    },
    {
      name: "RangeNode",
      test: Tzn
    },
    {
      name: "SymbolNode",
      test: Nzn
    },
    {
      name: "Map",
      test: a7n
    },
    {
      name: "Object",
      test: Izn
    }
    // order 'Object' last, it matches on other classes too
  ], s.conversions = [{
    from: "number",
    to: "BigNumber",
    convert: function(A) {
      if (n || uK(A), Uzn(A) > 15)
        throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + A + "). Use function bignumber(x) to convert to BigNumber.");
      return new n(A);
    }
  }, {
    from: "number",
    to: "Complex",
    convert: function(A) {
      return r || s3(A), new r(A, 0);
    }
  }, {
    from: "number",
    to: "string",
    convert: function(A) {
      return A + "";
    }
  }, {
    from: "BigNumber",
    to: "Complex",
    convert: function(A) {
      return r || s3(A), new r(A.toNumber(), 0);
    }
  }, {
    from: "Fraction",
    to: "BigNumber",
    convert: function(A) {
      throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
    }
  }, {
    from: "Fraction",
    to: "Complex",
    convert: function(A) {
      return r || s3(A), new r(A.valueOf(), 0);
    }
  }, {
    from: "number",
    to: "Fraction",
    convert: function(A) {
      o || fK(A);
      var l = new o(A);
      if (l.valueOf() !== A)
        throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + A + "). Use function fraction(x) to convert to Fraction.");
      return l;
    }
  }, {
    // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
    //  from: 'Fraction',
    //  to: 'number',
    //  convert: function (x) {
    //    return x.valueOf()
    //  }
    // }, {
    from: "string",
    to: "number",
    convert: function(A) {
      var l = Number(A);
      if (isNaN(l))
        throw new Error('Cannot convert "' + A + '" to a number');
      return l;
    }
  }, {
    from: "string",
    to: "BigNumber",
    convert: function(A) {
      n || uK(A);
      try {
        return new n(A);
      } catch {
        throw new Error('Cannot convert "' + A + '" to BigNumber');
      }
    }
  }, {
    from: "string",
    to: "Fraction",
    convert: function(A) {
      o || fK(A);
      try {
        return new o(A);
      } catch {
        throw new Error('Cannot convert "' + A + '" to Fraction');
      }
    }
  }, {
    from: "string",
    to: "Complex",
    convert: function(A) {
      r || s3(A);
      try {
        return new r(A);
      } catch {
        throw new Error('Cannot convert "' + A + '" to Complex');
      }
    }
  }, {
    from: "boolean",
    to: "number",
    convert: function(A) {
      return +A;
    }
  }, {
    from: "boolean",
    to: "BigNumber",
    convert: function(A) {
      return n || uK(A), new n(+A);
    }
  }, {
    from: "boolean",
    to: "Fraction",
    convert: function(A) {
      return o || fK(A), new o(+A);
    }
  }, {
    from: "boolean",
    to: "string",
    convert: function(A) {
      return String(A);
    }
  }, {
    from: "Array",
    to: "Matrix",
    convert: function(A) {
      return i || c7n(), new i(A);
    }
  }, {
    from: "Matrix",
    to: "Array",
    convert: function(A) {
      return A.valueOf();
    }
  }], s;
});
function uK(t) {
  throw new Error("Cannot convert value ".concat(t, " into a BigNumber: no class 'BigNumber' provided"));
}
function s3(t) {
  throw new Error("Cannot convert value ".concat(t, " into a Complex number: no class 'Complex' provided"));
}
function c7n() {
  throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function fK(t) {
  throw new Error("Cannot convert value ".concat(t, " into a Fraction, no class 'Fraction' provided."));
}
/*!
 *  decimal.js v10.4.2
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */
var B_ = 9e15, OE = 1e9, Cre = "0123456789abcdef", n5 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", r5 = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", Ere = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -B_,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: B_,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, mWe, sI, Pr = !0, Pq = "[DecimalError] ", XC = Pq + "Invalid argument: ", CWe = Pq + "Precision limit exceeded", EWe = Pq + "crypto unavailable", yWe = "[object Decimal]", sc = Math.floor, iA = Math.pow, u7n = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, f7n = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, g7n = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, vWe = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, id = 1e7, Qr = 7, h7n = 9007199254740991, d7n = n5.length - 1, yre = r5.length - 1, qt = { toStringTag: yWe };
qt.absoluteValue = qt.abs = function() {
  var t = new this.constructor(this);
  return t.s < 0 && (t.s = 1), rr(t);
};
qt.ceil = function() {
  return rr(new this.constructor(this), this.e + 1, 2);
};
qt.clampedTo = qt.clamp = function(t, e) {
  var n, r = this, i = r.constructor;
  if (t = new i(t), e = new i(e), !t.s || !e.s)
    return new i(NaN);
  if (t.gt(e))
    throw Error(XC + e);
  return n = r.cmp(t), n < 0 ? t : r.cmp(e) > 0 ? e : new i(r);
};
qt.comparedTo = qt.cmp = function(t) {
  var e, n, r, i, o = this, s = o.d, a = (t = new o.constructor(t)).d, A = o.s, l = t.s;
  if (!s || !a)
    return !A || !l ? NaN : A !== l ? A : s === a ? 0 : !s ^ A < 0 ? 1 : -1;
  if (!s[0] || !a[0])
    return s[0] ? A : a[0] ? -l : 0;
  if (A !== l)
    return A;
  if (o.e !== t.e)
    return o.e > t.e ^ A < 0 ? 1 : -1;
  for (r = s.length, i = a.length, e = 0, n = r < i ? r : i; e < n; ++e)
    if (s[e] !== a[e])
      return s[e] > a[e] ^ A < 0 ? 1 : -1;
  return r === i ? 0 : r > i ^ A < 0 ? 1 : -1;
};
qt.cosine = qt.cos = function() {
  var t, e, n = this, r = n.constructor;
  return n.d ? n.d[0] ? (t = r.precision, e = r.rounding, r.precision = t + Math.max(n.e, n.sd()) + Qr, r.rounding = 1, n = p7n(r, QWe(r, n)), r.precision = t, r.rounding = e, rr(sI == 2 || sI == 3 ? n.neg() : n, t, e, !0)) : new r(1) : new r(NaN);
};
qt.cubeRoot = qt.cbrt = function() {
  var t, e, n, r, i, o, s, a, A, l, c = this, u = c.constructor;
  if (!c.isFinite() || c.isZero())
    return new u(c);
  for (Pr = !1, o = c.s * iA(c.s * c, 1 / 3), !o || Math.abs(o) == 1 / 0 ? (n = Al(c.d), t = c.e, (o = (t - n.length + 1) % 3) && (n += o == 1 || o == -2 ? "0" : "00"), o = iA(n, 1 / 3), t = sc((t + 1) / 3) - (t % 3 == (t < 0 ? -1 : 2)), o == 1 / 0 ? n = "5e" + t : (n = o.toExponential(), n = n.slice(0, n.indexOf("e") + 1) + t), r = new u(n), r.s = c.s) : r = new u(o.toString()), s = (t = u.precision) + 3; ; )
    if (a = r, A = a.times(a).times(a), l = A.plus(c), r = qo(l.plus(c).times(a), l.plus(A), s + 2, 1), Al(a.d).slice(0, s) === (n = Al(r.d)).slice(0, s))
      if (n = n.slice(s - 3, s + 1), n == "9999" || !i && n == "4999") {
        if (!i && (rr(a, t + 1, 0), a.times(a).times(a).eq(c))) {
          r = a;
          break;
        }
        s += 4, i = 1;
      } else {
        (!+n || !+n.slice(1) && n.charAt(0) == "5") && (rr(r, t + 1, 1), e = !r.times(r).times(r).eq(c));
        break;
      }
  return Pr = !0, rr(r, t, u.rounding, e);
};
qt.decimalPlaces = qt.dp = function() {
  var t, e = this.d, n = NaN;
  if (e) {
    if (t = e.length - 1, n = (t - sc(this.e / Qr)) * Qr, t = e[t], t)
      for (; t % 10 == 0; t /= 10)
        n--;
    n < 0 && (n = 0);
  }
  return n;
};
qt.dividedBy = qt.div = function(t) {
  return qo(this, new this.constructor(t));
};
qt.dividedToIntegerBy = qt.divToInt = function(t) {
  var e = this, n = e.constructor;
  return rr(qo(e, new n(t), 0, 1, 1), n.precision, n.rounding);
};
qt.equals = qt.eq = function(t) {
  return this.cmp(t) === 0;
};
qt.floor = function() {
  return rr(new this.constructor(this), this.e + 1, 3);
};
qt.greaterThan = qt.gt = function(t) {
  return this.cmp(t) > 0;
};
qt.greaterThanOrEqualTo = qt.gte = function(t) {
  var e = this.cmp(t);
  return e == 1 || e === 0;
};
qt.hyperbolicCosine = qt.cosh = function() {
  var t, e, n, r, i, o = this, s = o.constructor, a = new s(1);
  if (!o.isFinite())
    return new s(o.s ? 1 / 0 : NaN);
  if (o.isZero())
    return a;
  n = s.precision, r = s.rounding, s.precision = n + Math.max(o.e, o.sd()) + 4, s.rounding = 1, i = o.d.length, i < 32 ? (t = Math.ceil(i / 3), e = (1 / Gq(4, t)).toString()) : (t = 16, e = "2.3283064365386962890625e-10"), o = lQ(s, 1, o.times(e), new s(1), !0);
  for (var A, l = t, c = new s(8); l--; )
    A = o.times(o), o = a.minus(A.times(c.minus(A.times(c))));
  return rr(o, s.precision = n, s.rounding = r, !0);
};
qt.hyperbolicSine = qt.sinh = function() {
  var t, e, n, r, i = this, o = i.constructor;
  if (!i.isFinite() || i.isZero())
    return new o(i);
  if (e = o.precision, n = o.rounding, o.precision = e + Math.max(i.e, i.sd()) + 4, o.rounding = 1, r = i.d.length, r < 3)
    i = lQ(o, 2, i, i, !0);
  else {
    t = 1.4 * Math.sqrt(r), t = t > 16 ? 16 : t | 0, i = i.times(1 / Gq(5, t)), i = lQ(o, 2, i, i, !0);
    for (var s, a = new o(5), A = new o(16), l = new o(20); t--; )
      s = i.times(i), i = i.times(a.plus(s.times(A.times(s).plus(l))));
  }
  return o.precision = e, o.rounding = n, rr(i, e, n, !0);
};
qt.hyperbolicTangent = qt.tanh = function() {
  var t, e, n = this, r = n.constructor;
  return n.isFinite() ? n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + 7, r.rounding = 1, qo(n.sinh(), n.cosh(), r.precision = t, r.rounding = e)) : new r(n.s);
};
qt.inverseCosine = qt.acos = function() {
  var t, e = this, n = e.constructor, r = e.abs().cmp(1), i = n.precision, o = n.rounding;
  return r !== -1 ? r === 0 ? e.isNeg() ? Jh(n, i, o) : new n(0) : new n(NaN) : e.isZero() ? Jh(n, i + 4, o).times(0.5) : (n.precision = i + 6, n.rounding = 1, e = e.asin(), t = Jh(n, i + 4, o).times(0.5), n.precision = i, n.rounding = o, t.minus(e));
};
qt.inverseHyperbolicCosine = qt.acosh = function() {
  var t, e, n = this, r = n.constructor;
  return n.lte(1) ? new r(n.eq(1) ? 0 : NaN) : n.isFinite() ? (t = r.precision, e = r.rounding, r.precision = t + Math.max(Math.abs(n.e), n.sd()) + 4, r.rounding = 1, Pr = !1, n = n.times(n).minus(1).sqrt().plus(n), Pr = !0, r.precision = t, r.rounding = e, n.ln()) : new r(n);
};
qt.inverseHyperbolicSine = qt.asinh = function() {
  var t, e, n = this, r = n.constructor;
  return !n.isFinite() || n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + 2 * Math.max(Math.abs(n.e), n.sd()) + 6, r.rounding = 1, Pr = !1, n = n.times(n).plus(1).sqrt().plus(n), Pr = !0, r.precision = t, r.rounding = e, n.ln());
};
qt.inverseHyperbolicTangent = qt.atanh = function() {
  var t, e, n, r, i = this, o = i.constructor;
  return i.isFinite() ? i.e >= 0 ? new o(i.abs().eq(1) ? i.s / 0 : i.isZero() ? i : NaN) : (t = o.precision, e = o.rounding, r = i.sd(), Math.max(r, t) < 2 * -i.e - 1 ? rr(new o(i), t, e, !0) : (o.precision = n = r - i.e, i = qo(i.plus(1), new o(1).minus(i), n + t, 1), o.precision = t + 4, o.rounding = 1, i = i.ln(), o.precision = t, o.rounding = e, i.times(0.5))) : new o(NaN);
};
qt.inverseSine = qt.asin = function() {
  var t, e, n, r, i = this, o = i.constructor;
  return i.isZero() ? new o(i) : (e = i.abs().cmp(1), n = o.precision, r = o.rounding, e !== -1 ? e === 0 ? (t = Jh(o, n + 4, r).times(0.5), t.s = i.s, t) : new o(NaN) : (o.precision = n + 6, o.rounding = 1, i = i.div(new o(1).minus(i.times(i)).sqrt().plus(1)).atan(), o.precision = n, o.rounding = r, i.times(2)));
};
qt.inverseTangent = qt.atan = function() {
  var t, e, n, r, i, o, s, a, A, l = this, c = l.constructor, u = c.precision, f = c.rounding;
  if (l.isFinite()) {
    if (l.isZero())
      return new c(l);
    if (l.abs().eq(1) && u + 4 <= yre)
      return s = Jh(c, u + 4, f).times(0.25), s.s = l.s, s;
  } else {
    if (!l.s)
      return new c(NaN);
    if (u + 4 <= yre)
      return s = Jh(c, u + 4, f).times(0.5), s.s = l.s, s;
  }
  for (c.precision = a = u + 10, c.rounding = 1, n = Math.min(28, a / Qr + 2 | 0), t = n; t; --t)
    l = l.div(l.times(l).plus(1).sqrt().plus(1));
  for (Pr = !1, e = Math.ceil(a / Qr), r = 1, A = l.times(l), s = new c(l), i = l; t !== -1; )
    if (i = i.times(A), o = s.minus(i.div(r += 2)), i = i.times(A), s = o.plus(i.div(r += 2)), s.d[e] !== void 0)
      for (t = e; s.d[t] === o.d[t] && t--; )
        ;
  return n && (s = s.times(2 << n - 1)), Pr = !0, rr(s, c.precision = u, c.rounding = f, !0);
};
qt.isFinite = function() {
  return !!this.d;
};
qt.isInteger = qt.isInt = function() {
  return !!this.d && sc(this.e / Qr) > this.d.length - 2;
};
qt.isNaN = function() {
  return !this.s;
};
qt.isNegative = qt.isNeg = function() {
  return this.s < 0;
};
qt.isPositive = qt.isPos = function() {
  return this.s > 0;
};
qt.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
qt.lessThan = qt.lt = function(t) {
  return this.cmp(t) < 0;
};
qt.lessThanOrEqualTo = qt.lte = function(t) {
  return this.cmp(t) < 1;
};
qt.logarithm = qt.log = function(t) {
  var e, n, r, i, o, s, a, A, l = this, c = l.constructor, u = c.precision, f = c.rounding, h = 5;
  if (t == null)
    t = new c(10), e = !0;
  else {
    if (t = new c(t), n = t.d, t.s < 0 || !n || !n[0] || t.eq(1))
      return new c(NaN);
    e = t.eq(10);
  }
  if (n = l.d, l.s < 0 || !n || !n[0] || l.eq(1))
    return new c(n && !n[0] ? -1 / 0 : l.s != 1 ? NaN : n ? 0 : 1 / 0);
  if (e)
    if (n.length > 1)
      o = !0;
    else {
      for (i = n[0]; i % 10 === 0; )
        i /= 10;
      o = i !== 1;
    }
  if (Pr = !1, a = u + h, s = gC(l, a), r = e ? i5(c, a + 10) : gC(t, a), A = qo(s, r, a, 1), hN(A.d, i = u, f))
    do
      if (a += 10, s = gC(l, a), r = e ? i5(c, a + 10) : gC(t, a), A = qo(s, r, a, 1), !o) {
        +Al(A.d).slice(i + 1, i + 15) + 1 == 1e14 && (A = rr(A, u + 1, 0));
        break;
      }
    while (hN(A.d, i += 10, f));
  return Pr = !0, rr(A, u, f);
};
qt.minus = qt.sub = function(t) {
  var e, n, r, i, o, s, a, A, l, c, u, f, h = this, d = h.constructor;
  if (t = new d(t), !h.d || !t.d)
    return !h.s || !t.s ? t = new d(NaN) : h.d ? t.s = -t.s : t = new d(t.d || h.s !== t.s ? h : NaN), t;
  if (h.s != t.s)
    return t.s = -t.s, h.plus(t);
  if (l = h.d, f = t.d, a = d.precision, A = d.rounding, !l[0] || !f[0]) {
    if (f[0])
      t.s = -t.s;
    else if (l[0])
      t = new d(h);
    else
      return new d(A === 3 ? -0 : 0);
    return Pr ? rr(t, a, A) : t;
  }
  if (n = sc(t.e / Qr), c = sc(h.e / Qr), l = l.slice(), o = c - n, o) {
    for (u = o < 0, u ? (e = l, o = -o, s = f.length) : (e = f, n = c, s = l.length), r = Math.max(Math.ceil(a / Qr), s) + 2, o > r && (o = r, e.length = 1), e.reverse(), r = o; r--; )
      e.push(0);
    e.reverse();
  } else {
    for (r = l.length, s = f.length, u = r < s, u && (s = r), r = 0; r < s; r++)
      if (l[r] != f[r]) {
        u = l[r] < f[r];
        break;
      }
    o = 0;
  }
  for (u && (e = l, l = f, f = e, t.s = -t.s), s = l.length, r = f.length - s; r > 0; --r)
    l[s++] = 0;
  for (r = f.length; r > o; ) {
    if (l[--r] < f[r]) {
      for (i = r; i && l[--i] === 0; )
        l[i] = id - 1;
      --l[i], l[r] += id;
    }
    l[r] -= f[r];
  }
  for (; l[--s] === 0; )
    l.pop();
  for (; l[0] === 0; l.shift())
    --n;
  return l[0] ? (t.d = l, t.e = kq(l, n), Pr ? rr(t, a, A) : t) : new d(A === 3 ? -0 : 0);
};
qt.modulo = qt.mod = function(t) {
  var e, n = this, r = n.constructor;
  return t = new r(t), !n.d || !t.s || t.d && !t.d[0] ? new r(NaN) : !t.d || n.d && !n.d[0] ? rr(new r(n), r.precision, r.rounding) : (Pr = !1, r.modulo == 9 ? (e = qo(n, t.abs(), 0, 3, 1), e.s *= t.s) : e = qo(n, t, 0, r.modulo, 1), e = e.times(t), Pr = !0, n.minus(e));
};
qt.naturalExponential = qt.exp = function() {
  return vre(this);
};
qt.naturalLogarithm = qt.ln = function() {
  return gC(this);
};
qt.negated = qt.neg = function() {
  var t = new this.constructor(this);
  return t.s = -t.s, rr(t);
};
qt.plus = qt.add = function(t) {
  var e, n, r, i, o, s, a, A, l, c, u = this, f = u.constructor;
  if (t = new f(t), !u.d || !t.d)
    return !u.s || !t.s ? t = new f(NaN) : u.d || (t = new f(t.d || u.s === t.s ? u : NaN)), t;
  if (u.s != t.s)
    return t.s = -t.s, u.minus(t);
  if (l = u.d, c = t.d, a = f.precision, A = f.rounding, !l[0] || !c[0])
    return c[0] || (t = new f(u)), Pr ? rr(t, a, A) : t;
  if (o = sc(u.e / Qr), r = sc(t.e / Qr), l = l.slice(), i = o - r, i) {
    for (i < 0 ? (n = l, i = -i, s = c.length) : (n = c, r = o, s = l.length), o = Math.ceil(a / Qr), s = o > s ? o + 1 : s + 1, i > s && (i = s, n.length = 1), n.reverse(); i--; )
      n.push(0);
    n.reverse();
  }
  for (s = l.length, i = c.length, s - i < 0 && (i = s, n = c, c = l, l = n), e = 0; i; )
    e = (l[--i] = l[i] + c[i] + e) / id | 0, l[i] %= id;
  for (e && (l.unshift(e), ++r), s = l.length; l[--s] == 0; )
    l.pop();
  return t.d = l, t.e = kq(l, r), Pr ? rr(t, a, A) : t;
};
qt.precision = qt.sd = function(t) {
  var e, n = this;
  if (t !== void 0 && t !== !!t && t !== 1 && t !== 0)
    throw Error(XC + t);
  return n.d ? (e = BWe(n.d), t && n.e + 1 > e && (e = n.e + 1)) : e = NaN, e;
};
qt.round = function() {
  var t = this, e = t.constructor;
  return rr(new e(t), t.e + 1, e.rounding);
};
qt.sine = qt.sin = function() {
  var t, e, n = this, r = n.constructor;
  return n.isFinite() ? n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + Math.max(n.e, n.sd()) + Qr, r.rounding = 1, n = m7n(r, QWe(r, n)), r.precision = t, r.rounding = e, rr(sI > 2 ? n.neg() : n, t, e, !0)) : new r(NaN);
};
qt.squareRoot = qt.sqrt = function() {
  var t, e, n, r, i, o, s = this, a = s.d, A = s.e, l = s.s, c = s.constructor;
  if (l !== 1 || !a || !a[0])
    return new c(!l || l < 0 && (!a || a[0]) ? NaN : a ? s : 1 / 0);
  for (Pr = !1, l = Math.sqrt(+s), l == 0 || l == 1 / 0 ? (e = Al(a), (e.length + A) % 2 == 0 && (e += "0"), l = Math.sqrt(e), A = sc((A + 1) / 2) - (A < 0 || A % 2), l == 1 / 0 ? e = "5e" + A : (e = l.toExponential(), e = e.slice(0, e.indexOf("e") + 1) + A), r = new c(e)) : r = new c(l.toString()), n = (A = c.precision) + 3; ; )
    if (o = r, r = o.plus(qo(s, o, n + 2, 1)).times(0.5), Al(o.d).slice(0, n) === (e = Al(r.d)).slice(0, n))
      if (e = e.slice(n - 3, n + 1), e == "9999" || !i && e == "4999") {
        if (!i && (rr(o, A + 1, 0), o.times(o).eq(s))) {
          r = o;
          break;
        }
        n += 4, i = 1;
      } else {
        (!+e || !+e.slice(1) && e.charAt(0) == "5") && (rr(r, A + 1, 1), t = !r.times(r).eq(s));
        break;
      }
  return Pr = !0, rr(r, A, c.rounding, t);
};
qt.tangent = qt.tan = function() {
  var t, e, n = this, r = n.constructor;
  return n.isFinite() ? n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + 10, r.rounding = 1, n = n.sin(), n.s = 1, n = qo(n, new r(1).minus(n.times(n)).sqrt(), t + 10, 0), r.precision = t, r.rounding = e, rr(sI == 2 || sI == 4 ? n.neg() : n, t, e, !0)) : new r(NaN);
};
qt.times = qt.mul = function(t) {
  var e, n, r, i, o, s, a, A, l, c = this, u = c.constructor, f = c.d, h = (t = new u(t)).d;
  if (t.s *= c.s, !f || !f[0] || !h || !h[0])
    return new u(!t.s || f && !f[0] && !h || h && !h[0] && !f ? NaN : !f || !h ? t.s / 0 : t.s * 0);
  for (n = sc(c.e / Qr) + sc(t.e / Qr), A = f.length, l = h.length, A < l && (o = f, f = h, h = o, s = A, A = l, l = s), o = [], s = A + l, r = s; r--; )
    o.push(0);
  for (r = l; --r >= 0; ) {
    for (e = 0, i = A + r; i > r; )
      a = o[i] + h[r] * f[i - r - 1] + e, o[i--] = a % id | 0, e = a / id | 0;
    o[i] = (o[i] + e) % id | 0;
  }
  for (; !o[--s]; )
    o.pop();
  return e ? ++n : o.shift(), t.d = o, t.e = kq(o, n), Pr ? rr(t, u.precision, u.rounding) : t;
};
qt.toBinary = function(t, e) {
  return Mfe(this, 2, t, e);
};
qt.toDecimalPlaces = qt.toDP = function(t, e) {
  var n = this, r = n.constructor;
  return n = new r(n), t === void 0 ? n : (Pu(t, 0, OE), e === void 0 ? e = r.rounding : Pu(e, 0, 8), rr(n, t + n.e + 1, e));
};
qt.toExponential = function(t, e) {
  var n, r = this, i = r.constructor;
  return t === void 0 ? n = Vp(r, !0) : (Pu(t, 0, OE), e === void 0 ? e = i.rounding : Pu(e, 0, 8), r = rr(new i(r), t + 1, e), n = Vp(r, !0, t + 1)), r.isNeg() && !r.isZero() ? "-" + n : n;
};
qt.toFixed = function(t, e) {
  var n, r, i = this, o = i.constructor;
  return t === void 0 ? n = Vp(i) : (Pu(t, 0, OE), e === void 0 ? e = o.rounding : Pu(e, 0, 8), r = rr(new o(i), t + i.e + 1, e), n = Vp(r, !1, t + r.e + 1)), i.isNeg() && !i.isZero() ? "-" + n : n;
};
qt.toFraction = function(t) {
  var e, n, r, i, o, s, a, A, l, c, u, f, h = this, d = h.d, I = h.constructor;
  if (!d)
    return new I(h);
  if (l = n = new I(1), r = A = new I(0), e = new I(r), o = e.e = BWe(d) - h.e - 1, s = o % Qr, e.d[0] = iA(10, s < 0 ? Qr + s : s), t == null)
    t = o > 0 ? e : l;
  else {
    if (a = new I(t), !a.isInt() || a.lt(l))
      throw Error(XC + a);
    t = a.gt(e) ? o > 0 ? e : l : a;
  }
  for (Pr = !1, a = new I(Al(d)), c = I.precision, I.precision = o = d.length * Qr * 2; u = qo(a, e, 0, 1, 1), i = n.plus(u.times(r)), i.cmp(t) != 1; )
    n = r, r = i, i = l, l = A.plus(u.times(i)), A = i, i = e, e = a.minus(u.times(i)), a = i;
  return i = qo(t.minus(n), r, 0, 1, 1), A = A.plus(i.times(l)), n = n.plus(i.times(r)), A.s = l.s = h.s, f = qo(l, r, o, 1).minus(h).abs().cmp(qo(A, n, o, 1).minus(h).abs()) < 1 ? [l, r] : [A, n], I.precision = c, Pr = !0, f;
};
qt.toHexadecimal = qt.toHex = function(t, e) {
  return Mfe(this, 16, t, e);
};
qt.toNearest = function(t, e) {
  var n = this, r = n.constructor;
  if (n = new r(n), t == null) {
    if (!n.d)
      return n;
    t = new r(1), e = r.rounding;
  } else {
    if (t = new r(t), e === void 0 ? e = r.rounding : Pu(e, 0, 8), !n.d)
      return t.s ? n : t;
    if (!t.d)
      return t.s && (t.s = n.s), t;
  }
  return t.d[0] ? (Pr = !1, n = qo(n, t, 0, e, 1).times(t), Pr = !0, rr(n)) : (t.s = n.s, n = t), n;
};
qt.toNumber = function() {
  return +this;
};
qt.toOctal = function(t, e) {
  return Mfe(this, 8, t, e);
};
qt.toPower = qt.pow = function(t) {
  var e, n, r, i, o, s, a = this, A = a.constructor, l = +(t = new A(t));
  if (!a.d || !t.d || !a.d[0] || !t.d[0])
    return new A(iA(+a, l));
  if (a = new A(a), a.eq(1))
    return a;
  if (r = A.precision, o = A.rounding, t.eq(1))
    return rr(a, r, o);
  if (e = sc(t.e / Qr), e >= t.d.length - 1 && (n = l < 0 ? -l : l) <= h7n)
    return i = bWe(A, a, n, r), t.s < 0 ? new A(1).div(i) : rr(i, r, o);
  if (s = a.s, s < 0) {
    if (e < t.d.length - 1)
      return new A(NaN);
    if (t.d[e] & 1 || (s = 1), a.e == 0 && a.d[0] == 1 && a.d.length == 1)
      return a.s = s, a;
  }
  return n = iA(+a, l), e = n == 0 || !isFinite(n) ? sc(l * (Math.log("0." + Al(a.d)) / Math.LN10 + a.e + 1)) : new A(n + "").e, e > A.maxE + 1 || e < A.minE - 1 ? new A(e > 0 ? s / 0 : 0) : (Pr = !1, A.rounding = a.s = 1, n = Math.min(12, (e + "").length), i = vre(t.times(gC(a, r + n)), r), i.d && (i = rr(i, r + 5, 1), hN(i.d, r, o) && (e = r + 10, i = rr(vre(t.times(gC(a, e + n)), e), e + 5, 1), +Al(i.d).slice(r + 1, r + 15) + 1 == 1e14 && (i = rr(i, r + 1, 0)))), i.s = s, Pr = !0, A.rounding = o, rr(i, r, o));
};
qt.toPrecision = function(t, e) {
  var n, r = this, i = r.constructor;
  return t === void 0 ? n = Vp(r, r.e <= i.toExpNeg || r.e >= i.toExpPos) : (Pu(t, 1, OE), e === void 0 ? e = i.rounding : Pu(e, 0, 8), r = rr(new i(r), t, e), n = Vp(r, t <= r.e || r.e <= i.toExpNeg, t)), r.isNeg() && !r.isZero() ? "-" + n : n;
};
qt.toSignificantDigits = qt.toSD = function(t, e) {
  var n = this, r = n.constructor;
  return t === void 0 ? (t = r.precision, e = r.rounding) : (Pu(t, 1, OE), e === void 0 ? e = r.rounding : Pu(e, 0, 8)), rr(new r(n), t, e);
};
qt.toString = function() {
  var t = this, e = t.constructor, n = Vp(t, t.e <= e.toExpNeg || t.e >= e.toExpPos);
  return t.isNeg() && !t.isZero() ? "-" + n : n;
};
qt.truncated = qt.trunc = function() {
  return rr(new this.constructor(this), this.e + 1, 1);
};
qt.valueOf = qt.toJSON = function() {
  var t = this, e = t.constructor, n = Vp(t, t.e <= e.toExpNeg || t.e >= e.toExpPos);
  return t.isNeg() ? "-" + n : n;
};
function Al(t) {
  var e, n, r, i = t.length - 1, o = "", s = t[0];
  if (i > 0) {
    for (o += s, e = 1; e < i; e++)
      r = t[e] + "", n = Qr - r.length, n && (o += Vm(n)), o += r;
    s = t[e], r = s + "", n = Qr - r.length, n && (o += Vm(n));
  } else if (s === 0)
    return "0";
  for (; s % 10 === 0; )
    s /= 10;
  return o + s;
}
function Pu(t, e, n) {
  if (t !== ~~t || t < e || t > n)
    throw Error(XC + t);
}
function hN(t, e, n, r) {
  var i, o, s, a;
  for (o = t[0]; o >= 10; o /= 10)
    --e;
  return --e < 0 ? (e += Qr, i = 0) : (i = Math.ceil((e + 1) / Qr), e %= Qr), o = iA(10, Qr - e), a = t[i] % o | 0, r == null ? e < 3 ? (e == 0 ? a = a / 100 | 0 : e == 1 && (a = a / 10 | 0), s = n < 4 && a == 99999 || n > 3 && a == 49999 || a == 5e4 || a == 0) : s = (n < 4 && a + 1 == o || n > 3 && a + 1 == o / 2) && (t[i + 1] / o / 100 | 0) == iA(10, e - 2) - 1 || (a == o / 2 || a == 0) && (t[i + 1] / o / 100 | 0) == 0 : e < 4 ? (e == 0 ? a = a / 1e3 | 0 : e == 1 ? a = a / 100 | 0 : e == 2 && (a = a / 10 | 0), s = (r || n < 4) && a == 9999 || !r && n > 3 && a == 4999) : s = ((r || n < 4) && a + 1 == o || !r && n > 3 && a + 1 == o / 2) && (t[i + 1] / o / 1e3 | 0) == iA(10, e - 3) - 1, s;
}
function qG(t, e, n) {
  for (var r, i = [0], o, s = 0, a = t.length; s < a; ) {
    for (o = i.length; o--; )
      i[o] *= e;
    for (i[0] += Cre.indexOf(t.charAt(s++)), r = 0; r < i.length; r++)
      i[r] > n - 1 && (i[r + 1] === void 0 && (i[r + 1] = 0), i[r + 1] += i[r] / n | 0, i[r] %= n);
  }
  return i.reverse();
}
function p7n(t, e) {
  var n, r, i;
  if (e.isZero())
    return e;
  r = e.d.length, r < 32 ? (n = Math.ceil(r / 3), i = (1 / Gq(4, n)).toString()) : (n = 16, i = "2.3283064365386962890625e-10"), t.precision += n, e = lQ(t, 1, e.times(i), new t(1));
  for (var o = n; o--; ) {
    var s = e.times(e);
    e = s.times(s).minus(s).times(8).plus(1);
  }
  return t.precision -= n, e;
}
var qo = function() {
  function t(r, i, o) {
    var s, a = 0, A = r.length;
    for (r = r.slice(); A--; )
      s = r[A] * i + a, r[A] = s % o | 0, a = s / o | 0;
    return a && r.unshift(a), r;
  }
  function e(r, i, o, s) {
    var a, A;
    if (o != s)
      A = o > s ? 1 : -1;
    else
      for (a = A = 0; a < o; a++)
        if (r[a] != i[a]) {
          A = r[a] > i[a] ? 1 : -1;
          break;
        }
    return A;
  }
  function n(r, i, o, s) {
    for (var a = 0; o--; )
      r[o] -= a, a = r[o] < i[o] ? 1 : 0, r[o] = a * s + r[o] - i[o];
    for (; !r[0] && r.length > 1; )
      r.shift();
  }
  return function(r, i, o, s, a, A) {
    var l, c, u, f, h, d, I, m, C, y, v, b, Q, w, R, M, O, L, N, k, $ = r.constructor, U = r.s == i.s ? 1 : -1, X = r.d, K = i.d;
    if (!X || !X[0] || !K || !K[0])
      return new $(
        // Return NaN if either NaN, or both Infinity or 0.
        !r.s || !i.s || (X ? K && X[0] == K[0] : !K) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          X && X[0] == 0 || !K ? U * 0 : U / 0
        )
      );
    for (A ? (h = 1, c = r.e - i.e) : (A = id, h = Qr, c = sc(r.e / h) - sc(i.e / h)), N = K.length, O = X.length, C = new $(U), y = C.d = [], u = 0; K[u] == (X[u] || 0); u++)
      ;
    if (K[u] > (X[u] || 0) && c--, o == null ? (w = o = $.precision, s = $.rounding) : a ? w = o + (r.e - i.e) + 1 : w = o, w < 0)
      y.push(1), d = !0;
    else {
      if (w = w / h + 2 | 0, u = 0, N == 1) {
        for (f = 0, K = K[0], w++; (u < O || f) && w--; u++)
          R = f * A + (X[u] || 0), y[u] = R / K | 0, f = R % K | 0;
        d = f || u < O;
      } else {
        for (f = A / (K[0] + 1) | 0, f > 1 && (K = t(K, f, A), X = t(X, f, A), N = K.length, O = X.length), M = N, v = X.slice(0, N), b = v.length; b < N; )
          v[b++] = 0;
        k = K.slice(), k.unshift(0), L = K[0], K[1] >= A / 2 && ++L;
        do
          f = 0, l = e(K, v, N, b), l < 0 ? (Q = v[0], N != b && (Q = Q * A + (v[1] || 0)), f = Q / L | 0, f > 1 ? (f >= A && (f = A - 1), I = t(K, f, A), m = I.length, b = v.length, l = e(I, v, m, b), l == 1 && (f--, n(I, N < m ? k : K, m, A))) : (f == 0 && (l = f = 1), I = K.slice()), m = I.length, m < b && I.unshift(0), n(v, I, b, A), l == -1 && (b = v.length, l = e(K, v, N, b), l < 1 && (f++, n(v, N < b ? k : K, b, A))), b = v.length) : l === 0 && (f++, v = [0]), y[u++] = f, l && v[0] ? v[b++] = X[M] || 0 : (v = [X[M]], b = 1);
        while ((M++ < O || v[0] !== void 0) && w--);
        d = v[0] !== void 0;
      }
      y[0] || y.shift();
    }
    if (h == 1)
      C.e = c, mWe = d;
    else {
      for (u = 1, f = y[0]; f >= 10; f /= 10)
        u++;
      C.e = u + c * h - 1, rr(C, a ? o + C.e + 1 : o, s, d);
    }
    return C;
  };
}();
function rr(t, e, n, r) {
  var i, o, s, a, A, l, c, u, f, h = t.constructor;
  e:
    if (e != null) {
      if (u = t.d, !u)
        return t;
      for (i = 1, a = u[0]; a >= 10; a /= 10)
        i++;
      if (o = e - i, o < 0)
        o += Qr, s = e, c = u[f = 0], A = c / iA(10, i - s - 1) % 10 | 0;
      else if (f = Math.ceil((o + 1) / Qr), a = u.length, f >= a)
        if (r) {
          for (; a++ <= f; )
            u.push(0);
          c = A = 0, i = 1, o %= Qr, s = o - Qr + 1;
        } else
          break e;
      else {
        for (c = a = u[f], i = 1; a >= 10; a /= 10)
          i++;
        o %= Qr, s = o - Qr + i, A = s < 0 ? 0 : c / iA(10, i - s - 1) % 10 | 0;
      }
      if (r = r || e < 0 || u[f + 1] !== void 0 || (s < 0 ? c : c % iA(10, i - s - 1)), l = n < 4 ? (A || r) && (n == 0 || n == (t.s < 0 ? 3 : 2)) : A > 5 || A == 5 && (n == 4 || r || n == 6 && // Check whether the digit to the left of the rounding digit is odd.
      (o > 0 ? s > 0 ? c / iA(10, i - s) : 0 : u[f - 1]) % 10 & 1 || n == (t.s < 0 ? 8 : 7)), e < 1 || !u[0])
        return u.length = 0, l ? (e -= t.e + 1, u[0] = iA(10, (Qr - e % Qr) % Qr), t.e = -e || 0) : u[0] = t.e = 0, t;
      if (o == 0 ? (u.length = f, a = 1, f--) : (u.length = f + 1, a = iA(10, Qr - o), u[f] = s > 0 ? (c / iA(10, i - s) % iA(10, s) | 0) * a : 0), l)
        for (; ; )
          if (f == 0) {
            for (o = 1, s = u[0]; s >= 10; s /= 10)
              o++;
            for (s = u[0] += a, a = 1; s >= 10; s /= 10)
              a++;
            o != a && (t.e++, u[0] == id && (u[0] = 1));
            break;
          } else {
            if (u[f] += a, u[f] != id)
              break;
            u[f--] = 0, a = 1;
          }
      for (o = u.length; u[--o] === 0; )
        u.pop();
    }
  return Pr && (t.e > h.maxE ? (t.d = null, t.e = NaN) : t.e < h.minE && (t.e = 0, t.d = [0])), t;
}
function Vp(t, e, n) {
  if (!t.isFinite())
    return SWe(t);
  var r, i = t.e, o = Al(t.d), s = o.length;
  return e ? (n && (r = n - s) > 0 ? o = o.charAt(0) + "." + o.slice(1) + Vm(r) : s > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (t.e < 0 ? "e" : "e+") + t.e) : i < 0 ? (o = "0." + Vm(-i - 1) + o, n && (r = n - s) > 0 && (o += Vm(r))) : i >= s ? (o += Vm(i + 1 - s), n && (r = n - i - 1) > 0 && (o = o + "." + Vm(r))) : ((r = i + 1) < s && (o = o.slice(0, r) + "." + o.slice(r)), n && (r = n - s) > 0 && (i + 1 === s && (o += "."), o += Vm(r))), o;
}
function kq(t, e) {
  var n = t[0];
  for (e *= Qr; n >= 10; n /= 10)
    e++;
  return e;
}
function i5(t, e, n) {
  if (e > d7n)
    throw Pr = !0, n && (t.precision = n), Error(CWe);
  return rr(new t(n5), e, 1, !0);
}
function Jh(t, e, n) {
  if (e > yre)
    throw Error(CWe);
  return rr(new t(r5), e, n, !0);
}
function BWe(t) {
  var e = t.length - 1, n = e * Qr + 1;
  if (e = t[e], e) {
    for (; e % 10 == 0; e /= 10)
      n--;
    for (e = t[0]; e >= 10; e /= 10)
      n++;
  }
  return n;
}
function Vm(t) {
  for (var e = ""; t--; )
    e += "0";
  return e;
}
function bWe(t, e, n, r) {
  var i, o = new t(1), s = Math.ceil(r / Qr + 4);
  for (Pr = !1; ; ) {
    if (n % 2 && (o = o.times(e), iTe(o.d, s) && (i = !0)), n = sc(n / 2), n === 0) {
      n = o.d.length - 1, i && o.d[n] === 0 && ++o.d[n];
      break;
    }
    e = e.times(e), iTe(e.d, s);
  }
  return Pr = !0, o;
}
function rTe(t) {
  return t.d[t.d.length - 1] & 1;
}
function _We(t, e, n) {
  for (var r, i = new t(e[0]), o = 0; ++o < e.length; )
    if (r = new t(e[o]), r.s)
      i[n](r) && (i = r);
    else {
      i = r;
      break;
    }
  return i;
}
function vre(t, e) {
  var n, r, i, o, s, a, A, l = 0, c = 0, u = 0, f = t.constructor, h = f.rounding, d = f.precision;
  if (!t.d || !t.d[0] || t.e > 17)
    return new f(t.d ? t.d[0] ? t.s < 0 ? 0 : 1 / 0 : 1 : t.s ? t.s < 0 ? 0 : t : 0 / 0);
  for (e == null ? (Pr = !1, A = d) : A = e, a = new f(0.03125); t.e > -2; )
    t = t.times(a), u += 5;
  for (r = Math.log(iA(2, u)) / Math.LN10 * 2 + 5 | 0, A += r, n = o = s = new f(1), f.precision = A; ; ) {
    if (o = rr(o.times(t), A, 1), n = n.times(++c), a = s.plus(qo(o, n, A, 1)), Al(a.d).slice(0, A) === Al(s.d).slice(0, A)) {
      for (i = u; i--; )
        s = rr(s.times(s), A, 1);
      if (e == null)
        if (l < 3 && hN(s.d, A - r, h, l))
          f.precision = A += 10, n = o = a = new f(1), c = 0, l++;
        else
          return rr(s, f.precision = d, h, Pr = !0);
      else
        return f.precision = d, s;
    }
    s = a;
  }
}
function gC(t, e) {
  var n, r, i, o, s, a, A, l, c, u, f, h = 1, d = 10, I = t, m = I.d, C = I.constructor, y = C.rounding, v = C.precision;
  if (I.s < 0 || !m || !m[0] || !I.e && m[0] == 1 && m.length == 1)
    return new C(m && !m[0] ? -1 / 0 : I.s != 1 ? NaN : m ? 0 : I);
  if (e == null ? (Pr = !1, c = v) : c = e, C.precision = c += d, n = Al(m), r = n.charAt(0), Math.abs(o = I.e) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && n.charAt(1) > 3; )
      I = I.times(t), n = Al(I.d), r = n.charAt(0), h++;
    o = I.e, r > 1 ? (I = new C("0." + n), o++) : I = new C(r + "." + n.slice(1));
  } else
    return l = i5(C, c + 2, v).times(o + ""), I = gC(new C(r + "." + n.slice(1)), c - d).plus(l), C.precision = v, e == null ? rr(I, v, y, Pr = !0) : I;
  for (u = I, A = s = I = qo(I.minus(1), I.plus(1), c, 1), f = rr(I.times(I), c, 1), i = 3; ; ) {
    if (s = rr(s.times(f), c, 1), l = A.plus(qo(s, new C(i), c, 1)), Al(l.d).slice(0, c) === Al(A.d).slice(0, c))
      if (A = A.times(2), o !== 0 && (A = A.plus(i5(C, c + 2, v).times(o + ""))), A = qo(A, new C(h), c, 1), e == null)
        if (hN(A.d, c - d, y, a))
          C.precision = c += d, l = s = I = qo(u.minus(1), u.plus(1), c, 1), f = rr(I.times(I), c, 1), i = a = 1;
        else
          return rr(A, C.precision = v, y, Pr = !0);
      else
        return C.precision = v, A;
    A = l, i += 2;
  }
}
function SWe(t) {
  return String(t.s * t.s / 0);
}
function Bre(t, e) {
  var n, r, i;
  for ((n = e.indexOf(".")) > -1 && (e = e.replace(".", "")), (r = e.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +e.slice(r + 1), e = e.substring(0, r)) : n < 0 && (n = e.length), r = 0; e.charCodeAt(r) === 48; r++)
    ;
  for (i = e.length; e.charCodeAt(i - 1) === 48; --i)
    ;
  if (e = e.slice(r, i), e) {
    if (i -= r, t.e = n = n - r - 1, t.d = [], r = (n + 1) % Qr, n < 0 && (r += Qr), r < i) {
      for (r && t.d.push(+e.slice(0, r)), i -= Qr; r < i; )
        t.d.push(+e.slice(r, r += Qr));
      e = e.slice(r), r = Qr - e.length;
    } else
      r -= i;
    for (; r--; )
      e += "0";
    t.d.push(+e), Pr && (t.e > t.constructor.maxE ? (t.d = null, t.e = NaN) : t.e < t.constructor.minE && (t.e = 0, t.d = [0]));
  } else
    t.e = 0, t.d = [0];
  return t;
}
function I7n(t, e) {
  var n, r, i, o, s, a, A, l, c;
  if (e.indexOf("_") > -1) {
    if (e = e.replace(/(\d)_(?=\d)/g, "$1"), vWe.test(e))
      return Bre(t, e);
  } else if (e === "Infinity" || e === "NaN")
    return +e || (t.s = NaN), t.e = NaN, t.d = null, t;
  if (f7n.test(e))
    n = 16, e = e.toLowerCase();
  else if (u7n.test(e))
    n = 2;
  else if (g7n.test(e))
    n = 8;
  else
    throw Error(XC + e);
  for (o = e.search(/p/i), o > 0 ? (A = +e.slice(o + 1), e = e.substring(2, o)) : e = e.slice(2), o = e.indexOf("."), s = o >= 0, r = t.constructor, s && (e = e.replace(".", ""), a = e.length, o = a - o, i = bWe(r, new r(n), o, o * 2)), l = qG(e, n, id), c = l.length - 1, o = c; l[o] === 0; --o)
    l.pop();
  return o < 0 ? new r(t.s * 0) : (t.e = kq(l, c), t.d = l, Pr = !1, s && (t = qo(t, i, a * 4)), A && (t = t.times(Math.abs(A) < 54 ? iA(2, A) : ZC.pow(2, A))), Pr = !0, t);
}
function m7n(t, e) {
  var n, r = e.d.length;
  if (r < 3)
    return e.isZero() ? e : lQ(t, 2, e, e);
  n = 1.4 * Math.sqrt(r), n = n > 16 ? 16 : n | 0, e = e.times(1 / Gq(5, n)), e = lQ(t, 2, e, e);
  for (var i, o = new t(5), s = new t(16), a = new t(20); n--; )
    i = e.times(e), e = e.times(o.plus(i.times(s.times(i).minus(a))));
  return e;
}
function lQ(t, e, n, r, i) {
  var o, s, a, A, l = t.precision, c = Math.ceil(l / Qr);
  for (Pr = !1, A = n.times(n), a = new t(r); ; ) {
    if (s = qo(a.times(A), new t(e++ * e++), l, 1), a = i ? r.plus(s) : r.minus(s), r = qo(s.times(A), new t(e++ * e++), l, 1), s = a.plus(r), s.d[c] !== void 0) {
      for (o = c; s.d[o] === a.d[o] && o--; )
        ;
      if (o == -1)
        break;
    }
    o = a, a = r, r = s, s = o;
  }
  return Pr = !0, s.d.length = c + 1, s;
}
function Gq(t, e) {
  for (var n = t; --e; )
    n *= t;
  return n;
}
function QWe(t, e) {
  var n, r = e.s < 0, i = Jh(t, t.precision, 1), o = i.times(0.5);
  if (e = e.abs(), e.lte(o))
    return sI = r ? 4 : 1, e;
  if (n = e.divToInt(i), n.isZero())
    sI = r ? 3 : 2;
  else {
    if (e = e.minus(n.times(i)), e.lte(o))
      return sI = rTe(n) ? r ? 2 : 3 : r ? 4 : 1, e;
    sI = rTe(n) ? r ? 1 : 4 : r ? 3 : 2;
  }
  return e.minus(i).abs();
}
function Mfe(t, e, n, r) {
  var i, o, s, a, A, l, c, u, f, h = t.constructor, d = n !== void 0;
  if (d ? (Pu(n, 1, OE), r === void 0 ? r = h.rounding : Pu(r, 0, 8)) : (n = h.precision, r = h.rounding), !t.isFinite())
    c = SWe(t);
  else {
    for (c = Vp(t), s = c.indexOf("."), d ? (i = 2, e == 16 ? n = n * 4 - 3 : e == 8 && (n = n * 3 - 2)) : i = e, s >= 0 && (c = c.replace(".", ""), f = new h(1), f.e = c.length - s, f.d = qG(Vp(f), 10, i), f.e = f.d.length), u = qG(c, 10, i), o = A = u.length; u[--A] == 0; )
      u.pop();
    if (!u[0])
      c = d ? "0p+0" : "0";
    else {
      if (s < 0 ? o-- : (t = new h(t), t.d = u, t.e = o, t = qo(t, f, n, r, 0, i), u = t.d, o = t.e, l = mWe), s = u[n], a = i / 2, l = l || u[n + 1] !== void 0, l = r < 4 ? (s !== void 0 || l) && (r === 0 || r === (t.s < 0 ? 3 : 2)) : s > a || s === a && (r === 4 || l || r === 6 && u[n - 1] & 1 || r === (t.s < 0 ? 8 : 7)), u.length = n, l)
        for (; ++u[--n] > i - 1; )
          u[n] = 0, n || (++o, u.unshift(1));
      for (A = u.length; !u[A - 1]; --A)
        ;
      for (s = 0, c = ""; s < A; s++)
        c += Cre.charAt(u[s]);
      if (d) {
        if (A > 1)
          if (e == 16 || e == 8) {
            for (s = e == 16 ? 4 : 3, --A; A % s; A++)
              c += "0";
            for (u = qG(c, i, e), A = u.length; !u[A - 1]; --A)
              ;
            for (s = 1, c = "1."; s < A; s++)
              c += Cre.charAt(u[s]);
          } else
            c = c.charAt(0) + "." + c.slice(1);
        c = c + (o < 0 ? "p" : "p+") + o;
      } else if (o < 0) {
        for (; ++o; )
          c = "0" + c;
        c = "0." + c;
      } else if (++o > A)
        for (o -= A; o--; )
          c += "0";
      else
        o < A && (c = c.slice(0, o) + "." + c.slice(o));
    }
    c = (e == 16 ? "0x" : e == 2 ? "0b" : e == 8 ? "0o" : "") + c;
  }
  return t.s < 0 ? "-" + c : c;
}
function iTe(t, e) {
  if (t.length > e)
    return t.length = e, !0;
}
function C7n(t) {
  return new this(t).abs();
}
function E7n(t) {
  return new this(t).acos();
}
function y7n(t) {
  return new this(t).acosh();
}
function v7n(t, e) {
  return new this(t).plus(e);
}
function B7n(t) {
  return new this(t).asin();
}
function b7n(t) {
  return new this(t).asinh();
}
function _7n(t) {
  return new this(t).atan();
}
function S7n(t) {
  return new this(t).atanh();
}
function Q7n(t, e) {
  t = new this(t), e = new this(e);
  var n, r = this.precision, i = this.rounding, o = r + 4;
  return !t.s || !e.s ? n = new this(NaN) : !t.d && !e.d ? (n = Jh(this, o, 1).times(e.s > 0 ? 0.25 : 0.75), n.s = t.s) : !e.d || t.isZero() ? (n = e.s < 0 ? Jh(this, r, i) : new this(0), n.s = t.s) : !t.d || e.isZero() ? (n = Jh(this, o, 1).times(0.5), n.s = t.s) : e.s < 0 ? (this.precision = o, this.rounding = 1, n = this.atan(qo(t, e, o, 1)), e = Jh(this, o, 1), this.precision = r, this.rounding = i, n = t.s < 0 ? n.minus(e) : n.plus(e)) : n = this.atan(qo(t, e, o, 1)), n;
}
function w7n(t) {
  return new this(t).cbrt();
}
function x7n(t) {
  return rr(t = new this(t), t.e + 1, 2);
}
function R7n(t, e, n) {
  return new this(t).clamp(e, n);
}
function D7n(t) {
  if (!t || typeof t != "object")
    throw Error(Pq + "Object expected");
  var e, n, r, i = t.defaults === !0, o = [
    "precision",
    1,
    OE,
    "rounding",
    0,
    8,
    "toExpNeg",
    -B_,
    0,
    "toExpPos",
    0,
    B_,
    "maxE",
    0,
    B_,
    "minE",
    -B_,
    0,
    "modulo",
    0,
    9
  ];
  for (e = 0; e < o.length; e += 3)
    if (n = o[e], i && (this[n] = Ere[n]), (r = t[n]) !== void 0)
      if (sc(r) === r && r >= o[e + 1] && r <= o[e + 2])
        this[n] = r;
      else
        throw Error(XC + n + ": " + r);
  if (n = "crypto", i && (this[n] = Ere[n]), (r = t[n]) !== void 0)
    if (r === !0 || r === !1 || r === 0 || r === 1)
      if (r)
        if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[n] = !0;
        else
          throw Error(EWe);
      else
        this[n] = !1;
    else
      throw Error(XC + n + ": " + r);
  return this;
}
function T7n(t) {
  return new this(t).cos();
}
function N7n(t) {
  return new this(t).cosh();
}
function wWe(t) {
  var e, n, r;
  function i(o) {
    var s, a, A, l = this;
    if (!(l instanceof i))
      return new i(o);
    if (l.constructor = i, oTe(o)) {
      l.s = o.s, Pr ? !o.d || o.e > i.maxE ? (l.e = NaN, l.d = null) : o.e < i.minE ? (l.e = 0, l.d = [0]) : (l.e = o.e, l.d = o.d.slice()) : (l.e = o.e, l.d = o.d ? o.d.slice() : o.d);
      return;
    }
    if (A = typeof o, A === "number") {
      if (o === 0) {
        l.s = 1 / o < 0 ? -1 : 1, l.e = 0, l.d = [0];
        return;
      }
      if (o < 0 ? (o = -o, l.s = -1) : l.s = 1, o === ~~o && o < 1e7) {
        for (s = 0, a = o; a >= 10; a /= 10)
          s++;
        Pr ? s > i.maxE ? (l.e = NaN, l.d = null) : s < i.minE ? (l.e = 0, l.d = [0]) : (l.e = s, l.d = [o]) : (l.e = s, l.d = [o]);
        return;
      } else if (o * 0 !== 0) {
        o || (l.s = NaN), l.e = NaN, l.d = null;
        return;
      }
      return Bre(l, o.toString());
    } else if (A !== "string")
      throw Error(XC + o);
    return (a = o.charCodeAt(0)) === 45 ? (o = o.slice(1), l.s = -1) : (a === 43 && (o = o.slice(1)), l.s = 1), vWe.test(o) ? Bre(l, o) : I7n(l, o);
  }
  if (i.prototype = qt, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.EUCLID = 9, i.config = i.set = D7n, i.clone = wWe, i.isDecimal = oTe, i.abs = C7n, i.acos = E7n, i.acosh = y7n, i.add = v7n, i.asin = B7n, i.asinh = b7n, i.atan = _7n, i.atanh = S7n, i.atan2 = Q7n, i.cbrt = w7n, i.ceil = x7n, i.clamp = R7n, i.cos = T7n, i.cosh = N7n, i.div = L7n, i.exp = M7n, i.floor = O7n, i.hypot = F7n, i.ln = P7n, i.log = k7n, i.log10 = U7n, i.log2 = G7n, i.max = H7n, i.min = $7n, i.mod = q7n, i.mul = j7n, i.pow = Y7n, i.random = z7n, i.round = V7n, i.sign = J7n, i.sin = K7n, i.sinh = W7n, i.sqrt = X7n, i.sub = Z7n, i.sum = eVn, i.tan = tVn, i.tanh = nVn, i.trunc = rVn, t === void 0 && (t = {}), t && t.defaults !== !0)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], e = 0; e < r.length; )
      t.hasOwnProperty(n = r[e++]) || (t[n] = this[n]);
  return i.config(t), i;
}
function L7n(t, e) {
  return new this(t).div(e);
}
function M7n(t) {
  return new this(t).exp();
}
function O7n(t) {
  return rr(t = new this(t), t.e + 1, 3);
}
function F7n() {
  var t, e, n = new this(0);
  for (Pr = !1, t = 0; t < arguments.length; )
    if (e = new this(arguments[t++]), e.d)
      n.d && (n = n.plus(e.times(e)));
    else {
      if (e.s)
        return Pr = !0, new this(1 / 0);
      n = e;
    }
  return Pr = !0, n.sqrt();
}
function oTe(t) {
  return t instanceof ZC || t && t.toStringTag === yWe || !1;
}
function P7n(t) {
  return new this(t).ln();
}
function k7n(t, e) {
  return new this(t).log(e);
}
function G7n(t) {
  return new this(t).log(2);
}
function U7n(t) {
  return new this(t).log(10);
}
function H7n() {
  return _We(this, arguments, "lt");
}
function $7n() {
  return _We(this, arguments, "gt");
}
function q7n(t, e) {
  return new this(t).mod(e);
}
function j7n(t, e) {
  return new this(t).mul(e);
}
function Y7n(t, e) {
  return new this(t).pow(e);
}
function z7n(t) {
  var e, n, r, i, o = 0, s = new this(1), a = [];
  if (t === void 0 ? t = this.precision : Pu(t, 1, OE), r = Math.ceil(t / Qr), this.crypto)
    if (crypto.getRandomValues)
      for (e = crypto.getRandomValues(new Uint32Array(r)); o < r; )
        i = e[o], i >= 429e7 ? e[o] = crypto.getRandomValues(new Uint32Array(1))[0] : a[o++] = i % 1e7;
    else if (crypto.randomBytes) {
      for (e = crypto.randomBytes(r *= 4); o < r; )
        i = e[o] + (e[o + 1] << 8) + (e[o + 2] << 16) + ((e[o + 3] & 127) << 24), i >= 214e7 ? crypto.randomBytes(4).copy(e, o) : (a.push(i % 1e7), o += 4);
      o = r / 4;
    } else
      throw Error(EWe);
  else
    for (; o < r; )
      a[o++] = Math.random() * 1e7 | 0;
  for (r = a[--o], t %= Qr, r && t && (i = iA(10, Qr - t), a[o] = (r / i | 0) * i); a[o] === 0; o--)
    a.pop();
  if (o < 0)
    n = 0, a = [0];
  else {
    for (n = -1; a[0] === 0; n -= Qr)
      a.shift();
    for (r = 1, i = a[0]; i >= 10; i /= 10)
      r++;
    r < Qr && (n -= Qr - r);
  }
  return s.e = n, s.d = a, s;
}
function V7n(t) {
  return rr(t = new this(t), t.e + 1, this.rounding);
}
function J7n(t) {
  return t = new this(t), t.d ? t.d[0] ? t.s : 0 * t.s : t.s || NaN;
}
function K7n(t) {
  return new this(t).sin();
}
function W7n(t) {
  return new this(t).sinh();
}
function X7n(t) {
  return new this(t).sqrt();
}
function Z7n(t, e) {
  return new this(t).sub(e);
}
function eVn() {
  var t = 0, e = arguments, n = new this(e[t]);
  for (Pr = !1; n.s && ++t < e.length; )
    n = n.plus(e[t]);
  return Pr = !0, rr(n, this.precision, this.rounding);
}
function tVn(t) {
  return new this(t).tan();
}
function nVn(t) {
  return new this(t).tanh();
}
function rVn(t) {
  return rr(t = new this(t), t.e + 1, 1);
}
qt[Symbol.for("nodejs.util.inspect.custom")] = qt.toString;
qt[Symbol.toStringTag] = "Decimal";
var ZC = qt.constructor = wWe(Ere);
n5 = new ZC(n5);
r5 = new ZC(r5);
var iVn = "BigNumber", oVn = ["?on", "config"], sVn = /* @__PURE__ */ Ar(iVn, oVn, (t) => {
  var {
    on: e,
    config: n
  } = t, r = ZC.clone({
    precision: n.precision,
    modulo: ZC.EUCLID
  });
  return r.prototype = Object.create(r.prototype), r.prototype.type = "BigNumber", r.prototype.isBigNumber = !0, r.prototype.toJSON = function() {
    return {
      mathjs: "BigNumber",
      value: this.toString()
    };
  }, r.fromJSON = function(i) {
    return new r(i.value);
  }, e && e("config", function(i, o) {
    i.precision !== o.precision && r.config({
      precision: i.precision
    });
  }), r;
}, {
  isClass: !0
}), xWe = { exports: {} };
/**
 * @license Complex.js v2.1.1 12/05/2020
 *
 * Copyright (c) 2020, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
(function(t, e) {
  (function(n) {
    var r = Math.cosh || function(u) {
      return Math.abs(u) < 1e-9 ? 1 - u : (Math.exp(u) + Math.exp(-u)) * 0.5;
    }, i = Math.sinh || function(u) {
      return Math.abs(u) < 1e-9 ? u : (Math.exp(u) - Math.exp(-u)) * 0.5;
    }, o = function(u) {
      var f = Math.PI / 4;
      if (-f > u || u > f)
        return Math.cos(u) - 1;
      var h = u * u;
      return h * (h * (h * (h * (h * (h * (h * (h / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 1 / 2);
    }, s = function(u, f) {
      var h = Math.abs(u), d = Math.abs(f);
      return h < 3e3 && d < 3e3 ? Math.sqrt(h * h + d * d) : (h < d ? (h = d, d = u / f) : d = f / u, h * Math.sqrt(1 + d * d));
    }, a = function() {
      throw SyntaxError("Invalid Param");
    };
    function A(u, f) {
      var h = Math.abs(u), d = Math.abs(f);
      return u === 0 ? Math.log(d) : f === 0 ? Math.log(h) : h < 3e3 && d < 3e3 ? Math.log(u * u + f * f) * 0.5 : (u = u / 2, f = f / 2, 0.5 * Math.log(u * u + f * f) + Math.LN2);
    }
    var l = function(u, f) {
      var h = { re: 0, im: 0 };
      if (u == null)
        h.re = h.im = 0;
      else if (f !== void 0)
        h.re = u, h.im = f;
      else
        switch (typeof u) {
          case "object":
            if ("im" in u && "re" in u)
              h.re = u.re, h.im = u.im;
            else if ("abs" in u && "arg" in u) {
              if (!Number.isFinite(u.abs) && Number.isFinite(u.arg))
                return c.INFINITY;
              h.re = u.abs * Math.cos(u.arg), h.im = u.abs * Math.sin(u.arg);
            } else if ("r" in u && "phi" in u) {
              if (!Number.isFinite(u.r) && Number.isFinite(u.phi))
                return c.INFINITY;
              h.re = u.r * Math.cos(u.phi), h.im = u.r * Math.sin(u.phi);
            } else
              u.length === 2 ? (h.re = u[0], h.im = u[1]) : a();
            break;
          case "string":
            h.im = /* void */
            h.re = 0;
            var d = u.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g), I = 1, m = 0;
            d === null && a();
            for (var C = 0; C < d.length; C++) {
              var y = d[C];
              y === " " || y === "	" || y === `
` || (y === "+" ? I++ : y === "-" ? m++ : y === "i" || y === "I" ? (I + m === 0 && a(), d[C + 1] !== " " && !isNaN(d[C + 1]) ? (h.im += parseFloat((m % 2 ? "-" : "") + d[C + 1]), C++) : h.im += parseFloat((m % 2 ? "-" : "") + "1"), I = m = 0) : ((I + m === 0 || isNaN(y)) && a(), d[C + 1] === "i" || d[C + 1] === "I" ? (h.im += parseFloat((m % 2 ? "-" : "") + y), C++) : h.re += parseFloat((m % 2 ? "-" : "") + y), I = m = 0));
            }
            I + m > 0 && a();
            break;
          case "number":
            h.im = 0, h.re = u;
            break;
          default:
            a();
        }
      return isNaN(h.re) || isNaN(h.im), h;
    };
    function c(u, f) {
      if (!(this instanceof c))
        return new c(u, f);
      var h = l(u, f);
      this.re = h.re, this.im = h.im;
    }
    c.prototype = {
      re: 0,
      im: 0,
      /**
       * Calculates the sign of a complex number, which is a normalized complex
       *
       * @returns {Complex}
       */
      sign: function() {
        var u = this.abs();
        return new c(
          this.re / u,
          this.im / u
        );
      },
      /**
       * Adds two complex numbers
       *
       * @returns {Complex}
       */
      add: function(u, f) {
        var h = new c(u, f);
        return this.isInfinite() && h.isInfinite() ? c.NAN : this.isInfinite() || h.isInfinite() ? c.INFINITY : new c(
          this.re + h.re,
          this.im + h.im
        );
      },
      /**
       * Subtracts two complex numbers
       *
       * @returns {Complex}
       */
      sub: function(u, f) {
        var h = new c(u, f);
        return this.isInfinite() && h.isInfinite() ? c.NAN : this.isInfinite() || h.isInfinite() ? c.INFINITY : new c(
          this.re - h.re,
          this.im - h.im
        );
      },
      /**
       * Multiplies two complex numbers
       *
       * @returns {Complex}
       */
      mul: function(u, f) {
        var h = new c(u, f);
        return this.isInfinite() && h.isZero() || this.isZero() && h.isInfinite() ? c.NAN : this.isInfinite() || h.isInfinite() ? c.INFINITY : h.im === 0 && this.im === 0 ? new c(this.re * h.re, 0) : new c(
          this.re * h.re - this.im * h.im,
          this.re * h.im + this.im * h.re
        );
      },
      /**
       * Divides two complex numbers
       *
       * @returns {Complex}
       */
      div: function(u, f) {
        var h = new c(u, f);
        if (this.isZero() && h.isZero() || this.isInfinite() && h.isInfinite())
          return c.NAN;
        if (this.isInfinite() || h.isZero())
          return c.INFINITY;
        if (this.isZero() || h.isInfinite())
          return c.ZERO;
        u = this.re, f = this.im;
        var d = h.re, I = h.im, m, C;
        return I === 0 ? new c(u / d, f / d) : Math.abs(d) < Math.abs(I) ? (C = d / I, m = d * C + I, new c(
          (u * C + f) / m,
          (f * C - u) / m
        )) : (C = I / d, m = I * C + d, new c(
          (u + f * C) / m,
          (f - u * C) / m
        ));
      },
      /**
       * Calculate the power of two complex numbers
       *
       * @returns {Complex}
       */
      pow: function(u, f) {
        var h = new c(u, f);
        if (u = this.re, f = this.im, h.isZero())
          return c.ONE;
        if (h.im === 0) {
          if (f === 0 && u > 0)
            return new c(Math.pow(u, h.re), 0);
          if (u === 0)
            switch ((h.re % 4 + 4) % 4) {
              case 0:
                return new c(Math.pow(f, h.re), 0);
              case 1:
                return new c(0, Math.pow(f, h.re));
              case 2:
                return new c(-Math.pow(f, h.re), 0);
              case 3:
                return new c(0, -Math.pow(f, h.re));
            }
        }
        if (u === 0 && f === 0 && h.re > 0 && h.im >= 0)
          return c.ZERO;
        var d = Math.atan2(f, u), I = A(u, f);
        return u = Math.exp(h.re * I - h.im * d), f = h.im * I + h.re * d, new c(
          u * Math.cos(f),
          u * Math.sin(f)
        );
      },
      /**
       * Calculate the complex square root
       *
       * @returns {Complex}
       */
      sqrt: function() {
        var u = this.re, f = this.im, h = this.abs(), d, I;
        if (u >= 0) {
          if (f === 0)
            return new c(Math.sqrt(u), 0);
          d = 0.5 * Math.sqrt(2 * (h + u));
        } else
          d = Math.abs(f) / Math.sqrt(2 * (h - u));
        return u <= 0 ? I = 0.5 * Math.sqrt(2 * (h - u)) : I = Math.abs(f) / Math.sqrt(2 * (h + u)), new c(d, f < 0 ? -I : I);
      },
      /**
       * Calculate the complex exponent
       *
       * @returns {Complex}
       */
      exp: function() {
        var u = Math.exp(this.re);
        return this.im, new c(
          u * Math.cos(this.im),
          u * Math.sin(this.im)
        );
      },
      /**
       * Calculate the complex exponent and subtracts one.
       *
       * This may be more accurate than `Complex(x).exp().sub(1)` if
       * `x` is small.
       *
       * @returns {Complex}
       */
      expm1: function() {
        var u = this.re, f = this.im;
        return new c(
          Math.expm1(u) * Math.cos(f) + o(f),
          Math.exp(u) * Math.sin(f)
        );
      },
      /**
       * Calculate the natural log
       *
       * @returns {Complex}
       */
      log: function() {
        var u = this.re, f = this.im;
        return new c(
          A(u, f),
          Math.atan2(f, u)
        );
      },
      /**
       * Calculate the magnitude of the complex number
       *
       * @returns {number}
       */
      abs: function() {
        return s(this.re, this.im);
      },
      /**
       * Calculate the angle of the complex number
       *
       * @returns {number}
       */
      arg: function() {
        return Math.atan2(this.im, this.re);
      },
      /**
       * Calculate the sine of the complex number
       *
       * @returns {Complex}
       */
      sin: function() {
        var u = this.re, f = this.im;
        return new c(
          Math.sin(u) * r(f),
          Math.cos(u) * i(f)
        );
      },
      /**
       * Calculate the cosine
       *
       * @returns {Complex}
       */
      cos: function() {
        var u = this.re, f = this.im;
        return new c(
          Math.cos(u) * r(f),
          -Math.sin(u) * i(f)
        );
      },
      /**
       * Calculate the tangent
       *
       * @returns {Complex}
       */
      tan: function() {
        var u = 2 * this.re, f = 2 * this.im, h = Math.cos(u) + r(f);
        return new c(
          Math.sin(u) / h,
          i(f) / h
        );
      },
      /**
       * Calculate the cotangent
       *
       * @returns {Complex}
       */
      cot: function() {
        var u = 2 * this.re, f = 2 * this.im, h = Math.cos(u) - r(f);
        return new c(
          -Math.sin(u) / h,
          i(f) / h
        );
      },
      /**
       * Calculate the secant
       *
       * @returns {Complex}
       */
      sec: function() {
        var u = this.re, f = this.im, h = 0.5 * r(2 * f) + 0.5 * Math.cos(2 * u);
        return new c(
          Math.cos(u) * r(f) / h,
          Math.sin(u) * i(f) / h
        );
      },
      /**
       * Calculate the cosecans
       *
       * @returns {Complex}
       */
      csc: function() {
        var u = this.re, f = this.im, h = 0.5 * r(2 * f) - 0.5 * Math.cos(2 * u);
        return new c(
          Math.sin(u) * r(f) / h,
          -Math.cos(u) * i(f) / h
        );
      },
      /**
       * Calculate the complex arcus sinus
       *
       * @returns {Complex}
       */
      asin: function() {
        var u = this.re, f = this.im, h = new c(
          f * f - u * u + 1,
          -2 * u * f
        ).sqrt(), d = new c(
          h.re - f,
          h.im + u
        ).log();
        return new c(d.im, -d.re);
      },
      /**
       * Calculate the complex arcus cosinus
       *
       * @returns {Complex}
       */
      acos: function() {
        var u = this.re, f = this.im, h = new c(
          f * f - u * u + 1,
          -2 * u * f
        ).sqrt(), d = new c(
          h.re - f,
          h.im + u
        ).log();
        return new c(Math.PI / 2 - d.im, d.re);
      },
      /**
       * Calculate the complex arcus tangent
       *
       * @returns {Complex}
       */
      atan: function() {
        var u = this.re, f = this.im;
        if (u === 0) {
          if (f === 1)
            return new c(0, 1 / 0);
          if (f === -1)
            return new c(0, -1 / 0);
        }
        var h = u * u + (1 - f) * (1 - f), d = new c(
          (1 - f * f - u * u) / h,
          -2 * u / h
        ).log();
        return new c(-0.5 * d.im, 0.5 * d.re);
      },
      /**
       * Calculate the complex arcus cotangent
       *
       * @returns {Complex}
       */
      acot: function() {
        var u = this.re, f = this.im;
        if (f === 0)
          return new c(Math.atan2(1, u), 0);
        var h = u * u + f * f;
        return h !== 0 ? new c(
          u / h,
          -f / h
        ).atan() : new c(
          u !== 0 ? u / 0 : 0,
          f !== 0 ? -f / 0 : 0
        ).atan();
      },
      /**
       * Calculate the complex arcus secant
       *
       * @returns {Complex}
       */
      asec: function() {
        var u = this.re, f = this.im;
        if (u === 0 && f === 0)
          return new c(0, 1 / 0);
        var h = u * u + f * f;
        return h !== 0 ? new c(
          u / h,
          -f / h
        ).acos() : new c(
          u !== 0 ? u / 0 : 0,
          f !== 0 ? -f / 0 : 0
        ).acos();
      },
      /**
       * Calculate the complex arcus cosecans
       *
       * @returns {Complex}
       */
      acsc: function() {
        var u = this.re, f = this.im;
        if (u === 0 && f === 0)
          return new c(Math.PI / 2, 1 / 0);
        var h = u * u + f * f;
        return h !== 0 ? new c(
          u / h,
          -f / h
        ).asin() : new c(
          u !== 0 ? u / 0 : 0,
          f !== 0 ? -f / 0 : 0
        ).asin();
      },
      /**
       * Calculate the complex sinh
       *
       * @returns {Complex}
       */
      sinh: function() {
        var u = this.re, f = this.im;
        return new c(
          i(u) * Math.cos(f),
          r(u) * Math.sin(f)
        );
      },
      /**
       * Calculate the complex cosh
       *
       * @returns {Complex}
       */
      cosh: function() {
        var u = this.re, f = this.im;
        return new c(
          r(u) * Math.cos(f),
          i(u) * Math.sin(f)
        );
      },
      /**
       * Calculate the complex tanh
       *
       * @returns {Complex}
       */
      tanh: function() {
        var u = 2 * this.re, f = 2 * this.im, h = r(u) + Math.cos(f);
        return new c(
          i(u) / h,
          Math.sin(f) / h
        );
      },
      /**
       * Calculate the complex coth
       *
       * @returns {Complex}
       */
      coth: function() {
        var u = 2 * this.re, f = 2 * this.im, h = r(u) - Math.cos(f);
        return new c(
          i(u) / h,
          -Math.sin(f) / h
        );
      },
      /**
       * Calculate the complex coth
       *
       * @returns {Complex}
       */
      csch: function() {
        var u = this.re, f = this.im, h = Math.cos(2 * f) - r(2 * u);
        return new c(
          -2 * i(u) * Math.cos(f) / h,
          2 * r(u) * Math.sin(f) / h
        );
      },
      /**
       * Calculate the complex sech
       *
       * @returns {Complex}
       */
      sech: function() {
        var u = this.re, f = this.im, h = Math.cos(2 * f) + r(2 * u);
        return new c(
          2 * r(u) * Math.cos(f) / h,
          -2 * i(u) * Math.sin(f) / h
        );
      },
      /**
       * Calculate the complex asinh
       *
       * @returns {Complex}
       */
      asinh: function() {
        var u = this.im;
        this.im = -this.re, this.re = u;
        var f = this.asin();
        return this.re = -this.im, this.im = u, u = f.re, f.re = -f.im, f.im = u, f;
      },
      /**
       * Calculate the complex acosh
       *
       * @returns {Complex}
       */
      acosh: function() {
        var u = this.acos();
        if (u.im <= 0) {
          var f = u.re;
          u.re = -u.im, u.im = f;
        } else {
          var f = u.im;
          u.im = -u.re, u.re = f;
        }
        return u;
      },
      /**
       * Calculate the complex atanh
       *
       * @returns {Complex}
       */
      atanh: function() {
        var u = this.re, f = this.im, h = u > 1 && f === 0, d = 1 - u, I = 1 + u, m = d * d + f * f, C = m !== 0 ? new c(
          (I * d - f * f) / m,
          (f * d + I * f) / m
        ) : new c(
          u !== -1 ? u / 0 : 0,
          f !== 0 ? f / 0 : 0
        ), y = C.re;
        return C.re = A(C.re, C.im) / 2, C.im = Math.atan2(C.im, y) / 2, h && (C.im = -C.im), C;
      },
      /**
       * Calculate the complex acoth
       *
       * @returns {Complex}
       */
      acoth: function() {
        var u = this.re, f = this.im;
        if (u === 0 && f === 0)
          return new c(0, Math.PI / 2);
        var h = u * u + f * f;
        return h !== 0 ? new c(
          u / h,
          -f / h
        ).atanh() : new c(
          u !== 0 ? u / 0 : 0,
          f !== 0 ? -f / 0 : 0
        ).atanh();
      },
      /**
       * Calculate the complex acsch
       *
       * @returns {Complex}
       */
      acsch: function() {
        var u = this.re, f = this.im;
        if (f === 0)
          return new c(
            u !== 0 ? Math.log(u + Math.sqrt(u * u + 1)) : 1 / 0,
            0
          );
        var h = u * u + f * f;
        return h !== 0 ? new c(
          u / h,
          -f / h
        ).asinh() : new c(
          u !== 0 ? u / 0 : 0,
          f !== 0 ? -f / 0 : 0
        ).asinh();
      },
      /**
       * Calculate the complex asech
       *
       * @returns {Complex}
       */
      asech: function() {
        var u = this.re, f = this.im;
        if (this.isZero())
          return c.INFINITY;
        var h = u * u + f * f;
        return h !== 0 ? new c(
          u / h,
          -f / h
        ).acosh() : new c(
          u !== 0 ? u / 0 : 0,
          f !== 0 ? -f / 0 : 0
        ).acosh();
      },
      /**
       * Calculate the complex inverse 1/z
       *
       * @returns {Complex}
       */
      inverse: function() {
        if (this.isZero())
          return c.INFINITY;
        if (this.isInfinite())
          return c.ZERO;
        var u = this.re, f = this.im, h = u * u + f * f;
        return new c(u / h, -f / h);
      },
      /**
       * Returns the complex conjugate
       *
       * @returns {Complex}
       */
      conjugate: function() {
        return new c(this.re, -this.im);
      },
      /**
       * Gets the negated complex number
       *
       * @returns {Complex}
       */
      neg: function() {
        return new c(-this.re, -this.im);
      },
      /**
       * Ceils the actual complex number
       *
       * @returns {Complex}
       */
      ceil: function(u) {
        return u = Math.pow(10, u || 0), new c(
          Math.ceil(this.re * u) / u,
          Math.ceil(this.im * u) / u
        );
      },
      /**
       * Floors the actual complex number
       *
       * @returns {Complex}
       */
      floor: function(u) {
        return u = Math.pow(10, u || 0), new c(
          Math.floor(this.re * u) / u,
          Math.floor(this.im * u) / u
        );
      },
      /**
       * Ceils the actual complex number
       *
       * @returns {Complex}
       */
      round: function(u) {
        return u = Math.pow(10, u || 0), new c(
          Math.round(this.re * u) / u,
          Math.round(this.im * u) / u
        );
      },
      /**
       * Compares two complex numbers
       *
       * **Note:** new Complex(Infinity).equals(Infinity) === false
       *
       * @returns {boolean}
       */
      equals: function(u, f) {
        var h = new c(u, f);
        return Math.abs(h.re - this.re) <= c.EPSILON && Math.abs(h.im - this.im) <= c.EPSILON;
      },
      /**
       * Clones the actual object
       *
       * @returns {Complex}
       */
      clone: function() {
        return new c(this.re, this.im);
      },
      /**
       * Gets a string of the actual complex number
       *
       * @returns {string}
       */
      toString: function() {
        var u = this.re, f = this.im, h = "";
        return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(u) < c.EPSILON && (u = 0), Math.abs(f) < c.EPSILON && (f = 0), f === 0 ? h + u : (u !== 0 ? (h += u, h += " ", f < 0 ? (f = -f, h += "-") : h += "+", h += " ") : f < 0 && (f = -f, h += "-"), f !== 1 && (h += f), h + "i"));
      },
      /**
       * Returns the actual number as a vector
       *
       * @returns {Array}
       */
      toVector: function() {
        return [this.re, this.im];
      },
      /**
       * Returns the actual real value of the current object
       *
       * @returns {number|null}
       */
      valueOf: function() {
        return this.im === 0 ? this.re : null;
      },
      /**
       * Determines whether a complex number is not on the Riemann sphere.
       *
       * @returns {boolean}
       */
      isNaN: function() {
        return isNaN(this.re) || isNaN(this.im);
      },
      /**
       * Determines whether or not a complex number is at the zero pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      isZero: function() {
        return this.im === 0 && this.re === 0;
      },
      /**
       * Determines whether a complex number is not at the infinity pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      isFinite: function() {
        return isFinite(this.re) && isFinite(this.im);
      },
      /**
       * Determines whether or not a complex number is at the infinity pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      isInfinite: function() {
        return !(this.isNaN() || this.isFinite());
      }
    }, c.ZERO = new c(0, 0), c.ONE = new c(1, 0), c.I = new c(0, 1), c.PI = new c(Math.PI, 0), c.E = new c(Math.E, 0), c.INFINITY = new c(1 / 0, 1 / 0), c.NAN = new c(NaN, NaN), c.EPSILON = 1e-15, Object.defineProperty(c, "__esModule", { value: !0 }), c.default = c, c.Complex = c, t.exports = c;
  })();
})(xWe);
var aVn = xWe.exports;
const fu = /* @__PURE__ */ ko(aVn);
var AVn = "Complex", lVn = [], cVn = /* @__PURE__ */ Ar(AVn, lVn, () => (fu.prototype.type = "Complex", fu.prototype.isComplex = !0, fu.prototype.toJSON = function() {
  return {
    mathjs: "Complex",
    re: this.re,
    im: this.im
  };
}, fu.prototype.toPolar = function() {
  return {
    r: this.abs(),
    phi: this.arg()
  };
}, fu.prototype.format = function(t) {
  var e = "", n = this.im, r = this.re, i = Ire(this.re, t), o = Ire(this.im, t), s = ga(t) ? t : t ? t.precision : null;
  if (s !== null) {
    var a = Math.pow(10, -s);
    Math.abs(r / n) < a && (r = 0), Math.abs(n / r) < a && (n = 0);
  }
  return n === 0 ? e = i : r === 0 ? n === 1 ? e = "i" : n === -1 ? e = "-i" : e = o + "i" : n < 0 ? n === -1 ? e = i + " - i" : e = i + " - " + o.substring(1) + "i" : n === 1 ? e = i + " + i" : e = i + " + " + o + "i", e;
}, fu.fromPolar = function(t) {
  switch (arguments.length) {
    case 1: {
      var e = arguments[0];
      if (typeof e == "object")
        return fu(e);
      throw new TypeError("Input has to be an object with r and phi keys.");
    }
    case 2: {
      var n = arguments[0], r = arguments[1];
      if (ga(n)) {
        if (Lq(r) && r.hasBase("ANGLE") && (r = r.toNumber("rad")), ga(r))
          return new fu({
            r: n,
            phi: r
          });
        throw new TypeError("Phi is not a number nor an angle unit.");
      } else
        throw new TypeError("Radius r is not a number.");
    }
    default:
      throw new SyntaxError("Wrong number of arguments in function fromPolar");
  }
}, fu.prototype.valueOf = fu.prototype.toString, fu.fromJSON = function(t) {
  return new fu(t);
}, fu.compare = function(t, e) {
  return t.re > e.re ? 1 : t.re < e.re ? -1 : t.im > e.im ? 1 : t.im < e.im ? -1 : 0;
}, fu), {
  isClass: !0
}), RWe = { exports: {} };
/**
 * @license Fraction.js v4.2.0 05/03/2022
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2021, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
(function(t, e) {
  (function(n) {
    var r = 2e3, i = {
      s: 1,
      n: 0,
      d: 1
    };
    function o(d, I) {
      if (isNaN(d = parseInt(d, 10)))
        throw h.InvalidParameter;
      return d * I;
    }
    function s(d, I) {
      if (I === 0)
        throw h.DivisionByZero;
      var m = Object.create(h.prototype);
      m.s = d < 0 ? -1 : 1, d = d < 0 ? -d : d;
      var C = f(d, I);
      return m.n = d / C, m.d = I / C, m;
    }
    function a(d) {
      for (var I = {}, m = d, C = 2, y = 4; y <= m; ) {
        for (; m % C === 0; )
          m /= C, I[C] = (I[C] || 0) + 1;
        y += 1 + 2 * C++;
      }
      return m !== d ? m > 1 && (I[m] = (I[m] || 0) + 1) : I[d] = (I[d] || 0) + 1, I;
    }
    var A = function(d, I) {
      var m = 0, C = 1, y = 1, v = 0, b = 0, Q = 0, w = 1, R = 1, M = 0, O = 1, L = 1, N = 1, k = 1e7, $;
      if (d != null)
        if (I !== void 0) {
          if (m = d, C = I, y = m * C, m % 1 !== 0 || C % 1 !== 0)
            throw h.NonIntegerParameter;
        } else
          switch (typeof d) {
            case "object": {
              if ("d" in d && "n" in d)
                m = d.n, C = d.d, "s" in d && (m *= d.s);
              else if (0 in d)
                m = d[0], 1 in d && (C = d[1]);
              else
                throw h.InvalidParameter;
              y = m * C;
              break;
            }
            case "number": {
              if (d < 0 && (y = d, d = -d), d % 1 === 0)
                m = d;
              else if (d > 0) {
                for (d >= 1 && (R = Math.pow(10, Math.floor(1 + Math.log(d) / Math.LN10)), d /= R); O <= k && N <= k; )
                  if ($ = (M + L) / (O + N), d === $) {
                    O + N <= k ? (m = M + L, C = O + N) : N > O ? (m = L, C = N) : (m = M, C = O);
                    break;
                  } else
                    d > $ ? (M += L, O += N) : (L += M, N += O), O > k ? (m = L, C = N) : (m = M, C = O);
                m *= R;
              } else
                (isNaN(d) || isNaN(I)) && (C = m = NaN);
              break;
            }
            case "string": {
              if (O = d.match(/\d+|./g), O === null)
                throw h.InvalidParameter;
              if (O[M] === "-" ? (y = -1, M++) : O[M] === "+" && M++, O.length === M + 1 ? b = o(O[M++], y) : O[M + 1] === "." || O[M] === "." ? (O[M] !== "." && (v = o(O[M++], y)), M++, (M + 1 === O.length || O[M + 1] === "(" && O[M + 3] === ")" || O[M + 1] === "'" && O[M + 3] === "'") && (b = o(O[M], y), w = Math.pow(10, O[M].length), M++), (O[M] === "(" && O[M + 2] === ")" || O[M] === "'" && O[M + 2] === "'") && (Q = o(O[M + 1], y), R = Math.pow(10, O[M + 1].length) - 1, M += 3)) : O[M + 1] === "/" || O[M + 1] === ":" ? (b = o(O[M], y), w = o(O[M + 2], 1), M += 3) : O[M + 3] === "/" && O[M + 1] === " " && (v = o(O[M], y), b = o(O[M + 2], y), w = o(O[M + 4], 1), M += 5), O.length <= M) {
                C = w * R, y = /* void */
                m = Q + C * v + R * b;
                break;
              }
            }
            default:
              throw h.InvalidParameter;
          }
      if (C === 0)
        throw h.DivisionByZero;
      i.s = y < 0 ? -1 : 1, i.n = Math.abs(m), i.d = Math.abs(C);
    };
    function l(d, I, m) {
      for (var C = 1; I > 0; d = d * d % m, I >>= 1)
        I & 1 && (C = C * d % m);
      return C;
    }
    function c(d, I) {
      for (; I % 2 === 0; I /= 2)
        ;
      for (; I % 5 === 0; I /= 5)
        ;
      if (I === 1)
        return 0;
      for (var m = 10 % I, C = 1; m !== 1; C++)
        if (m = m * 10 % I, C > r)
          return 0;
      return C;
    }
    function u(d, I, m) {
      for (var C = 1, y = l(10, m, I), v = 0; v < 300; v++) {
        if (C === y)
          return v;
        C = C * 10 % I, y = y * 10 % I;
      }
      return 0;
    }
    function f(d, I) {
      if (!d)
        return I;
      if (!I)
        return d;
      for (; ; ) {
        if (d %= I, !d)
          return I;
        if (I %= d, !I)
          return d;
      }
    }
    function h(d, I) {
      if (A(d, I), this instanceof h)
        d = f(i.d, i.n), this.s = i.s, this.n = i.n / d, this.d = i.d / d;
      else
        return s(i.s * i.n, i.d);
    }
    h.DivisionByZero = new Error("Division by Zero"), h.InvalidParameter = new Error("Invalid argument"), h.NonIntegerParameter = new Error("Parameters must be integer"), h.prototype = {
      s: 1,
      n: 0,
      d: 1,
      /**
       * Calculates the absolute value
       *
       * Ex: new Fraction(-4).abs() => 4
       **/
      abs: function() {
        return s(this.n, this.d);
      },
      /**
       * Inverts the sign of the current fraction
       *
       * Ex: new Fraction(-4).neg() => 4
       **/
      neg: function() {
        return s(-this.s * this.n, this.d);
      },
      /**
       * Adds two rational numbers
       *
       * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
       **/
      add: function(d, I) {
        return A(d, I), s(
          this.s * this.n * i.d + i.s * this.d * i.n,
          this.d * i.d
        );
      },
      /**
       * Subtracts two rational numbers
       *
       * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
       **/
      sub: function(d, I) {
        return A(d, I), s(
          this.s * this.n * i.d - i.s * this.d * i.n,
          this.d * i.d
        );
      },
      /**
       * Multiplies two rational numbers
       *
       * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
       **/
      mul: function(d, I) {
        return A(d, I), s(
          this.s * i.s * this.n * i.n,
          this.d * i.d
        );
      },
      /**
       * Divides two rational numbers
       *
       * Ex: new Fraction("-17.(345)").inverse().div(3)
       **/
      div: function(d, I) {
        return A(d, I), s(
          this.s * i.s * this.n * i.d,
          this.d * i.n
        );
      },
      /**
       * Clones the actual object
       *
       * Ex: new Fraction("-17.(345)").clone()
       **/
      clone: function() {
        return s(this.s * this.n, this.d);
      },
      /**
       * Calculates the modulo of two rational numbers - a more precise fmod
       *
       * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
       **/
      mod: function(d, I) {
        if (isNaN(this.n) || isNaN(this.d))
          return new h(NaN);
        if (d === void 0)
          return s(this.s * this.n % this.d, 1);
        if (A(d, I), i.n === 0 && this.d === 0)
          throw h.DivisionByZero;
        return s(
          this.s * (i.d * this.n) % (i.n * this.d),
          i.d * this.d
        );
      },
      /**
       * Calculates the fractional gcd of two rational numbers
       *
       * Ex: new Fraction(5,8).gcd(3,7) => 1/56
       */
      gcd: function(d, I) {
        return A(d, I), s(f(i.n, this.n) * f(i.d, this.d), i.d * this.d);
      },
      /**
       * Calculates the fractional lcm of two rational numbers
       *
       * Ex: new Fraction(5,8).lcm(3,7) => 15
       */
      lcm: function(d, I) {
        return A(d, I), i.n === 0 && this.n === 0 ? s(0, 1) : s(i.n * this.n, f(i.n, this.n) * f(i.d, this.d));
      },
      /**
       * Calculates the ceil of a rational number
       *
       * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
       **/
      ceil: function(d) {
        return d = Math.pow(10, d || 0), isNaN(this.n) || isNaN(this.d) ? new h(NaN) : s(Math.ceil(d * this.s * this.n / this.d), d);
      },
      /**
       * Calculates the floor of a rational number
       *
       * Ex: new Fraction('4.(3)').floor() => (4 / 1)
       **/
      floor: function(d) {
        return d = Math.pow(10, d || 0), isNaN(this.n) || isNaN(this.d) ? new h(NaN) : s(Math.floor(d * this.s * this.n / this.d), d);
      },
      /**
       * Rounds a rational numbers
       *
       * Ex: new Fraction('4.(3)').round() => (4 / 1)
       **/
      round: function(d) {
        return d = Math.pow(10, d || 0), isNaN(this.n) || isNaN(this.d) ? new h(NaN) : s(Math.round(d * this.s * this.n / this.d), d);
      },
      /**
       * Gets the inverse of the fraction, means numerator and denominator are exchanged
       *
       * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
       **/
      inverse: function() {
        return s(this.s * this.d, this.n);
      },
      /**
       * Calculates the fraction to some rational exponent, if possible
       *
       * Ex: new Fraction(-1,2).pow(-3) => -8
       */
      pow: function(d, I) {
        if (A(d, I), i.d === 1)
          return i.s < 0 ? s(Math.pow(this.s * this.d, i.n), Math.pow(this.n, i.n)) : s(Math.pow(this.s * this.n, i.n), Math.pow(this.d, i.n));
        if (this.s < 0)
          return null;
        var m = a(this.n), C = a(this.d), y = 1, v = 1;
        for (var b in m)
          if (b !== "1") {
            if (b === "0") {
              y = 0;
              break;
            }
            if (m[b] *= i.n, m[b] % i.d === 0)
              m[b] /= i.d;
            else
              return null;
            y *= Math.pow(b, m[b]);
          }
        for (var b in C)
          if (b !== "1") {
            if (C[b] *= i.n, C[b] % i.d === 0)
              C[b] /= i.d;
            else
              return null;
            v *= Math.pow(b, C[b]);
          }
        return i.s < 0 ? s(v, y) : s(y, v);
      },
      /**
       * Check if two rational numbers are the same
       *
       * Ex: new Fraction(19.6).equals([98, 5]);
       **/
      equals: function(d, I) {
        return A(d, I), this.s * this.n * i.d === i.s * i.n * this.d;
      },
      /**
       * Check if two rational numbers are the same
       *
       * Ex: new Fraction(19.6).equals([98, 5]);
       **/
      compare: function(d, I) {
        A(d, I);
        var m = this.s * this.n * i.d - i.s * i.n * this.d;
        return (0 < m) - (m < 0);
      },
      simplify: function(d) {
        if (isNaN(this.n) || isNaN(this.d))
          return this;
        d = d || 1e-3;
        for (var I = this.abs(), m = I.toContinued(), C = 1; C < m.length; C++) {
          for (var y = s(m[C - 1], 1), v = C - 2; v >= 0; v--)
            y = y.inverse().add(m[v]);
          if (y.sub(I).abs().valueOf() < d)
            return y.mul(this.s);
        }
        return this;
      },
      /**
       * Check if two rational numbers are divisible
       *
       * Ex: new Fraction(19.6).divisible(1.5);
       */
      divisible: function(d, I) {
        return A(d, I), !(!(i.n * this.d) || this.n * i.d % (i.n * this.d));
      },
      /**
       * Returns a decimal representation of the fraction
       *
       * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
       **/
      valueOf: function() {
        return this.s * this.n / this.d;
      },
      /**
       * Returns a string-fraction representation of a Fraction object
       *
       * Ex: new Fraction("1.'3'").toFraction(true) => "4 1/3"
       **/
      toFraction: function(d) {
        var I, m = "", C = this.n, y = this.d;
        return this.s < 0 && (m += "-"), y === 1 ? m += C : (d && (I = Math.floor(C / y)) > 0 && (m += I, m += " ", C %= y), m += C, m += "/", m += y), m;
      },
      /**
       * Returns a latex representation of a Fraction object
       *
       * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
       **/
      toLatex: function(d) {
        var I, m = "", C = this.n, y = this.d;
        return this.s < 0 && (m += "-"), y === 1 ? m += C : (d && (I = Math.floor(C / y)) > 0 && (m += I, C %= y), m += "\\frac{", m += C, m += "}{", m += y, m += "}"), m;
      },
      /**
       * Returns an array of continued fraction elements
       *
       * Ex: new Fraction("7/8").toContinued() => [0,1,7]
       */
      toContinued: function() {
        var d, I = this.n, m = this.d, C = [];
        if (isNaN(I) || isNaN(m))
          return C;
        do
          C.push(Math.floor(I / m)), d = I % m, I = m, m = d;
        while (I !== 1);
        return C;
      },
      /**
       * Creates a string representation of a fraction with all digits
       *
       * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
       **/
      toString: function(d) {
        var I = this.n, m = this.d;
        if (isNaN(I) || isNaN(m))
          return "NaN";
        d = d || 15;
        var C = c(I, m), y = u(I, m, C), v = this.s < 0 ? "-" : "";
        if (v += I / m | 0, I %= m, I *= 10, I && (v += "."), C) {
          for (var b = y; b--; )
            v += I / m | 0, I %= m, I *= 10;
          v += "(";
          for (var b = C; b--; )
            v += I / m | 0, I %= m, I *= 10;
          v += ")";
        } else
          for (var b = d; I && b--; )
            v += I / m | 0, I %= m, I *= 10;
        return v;
      }
    }, Object.defineProperty(h, "__esModule", { value: !0 }), h.default = h, h.Fraction = h, t.exports = h;
  })();
})(RWe);
var uVn = RWe.exports;
const Qb = /* @__PURE__ */ ko(uVn);
var fVn = "Fraction", gVn = [], hVn = /* @__PURE__ */ Ar(fVn, gVn, () => (Qb.prototype.type = "Fraction", Qb.prototype.isFraction = !0, Qb.prototype.toJSON = function() {
  return {
    mathjs: "Fraction",
    n: this.s * this.n,
    d: this.d
  };
}, Qb.fromJSON = function(t) {
  return new Qb(t);
}, Qb), {
  isClass: !0
}), dVn = "Matrix", pVn = [], IVn = /* @__PURE__ */ Ar(dVn, pVn, () => {
  function t() {
    if (!(this instanceof t))
      throw new SyntaxError("Constructor must be called with the new operator");
  }
  return t.prototype.type = "Matrix", t.prototype.isMatrix = !0, t.prototype.storage = function() {
    throw new Error("Cannot invoke storage on a Matrix interface");
  }, t.prototype.datatype = function() {
    throw new Error("Cannot invoke datatype on a Matrix interface");
  }, t.prototype.create = function(e, n) {
    throw new Error("Cannot invoke create on a Matrix interface");
  }, t.prototype.subset = function(e, n, r) {
    throw new Error("Cannot invoke subset on a Matrix interface");
  }, t.prototype.get = function(e) {
    throw new Error("Cannot invoke get on a Matrix interface");
  }, t.prototype.set = function(e, n, r) {
    throw new Error("Cannot invoke set on a Matrix interface");
  }, t.prototype.resize = function(e, n) {
    throw new Error("Cannot invoke resize on a Matrix interface");
  }, t.prototype.reshape = function(e, n) {
    throw new Error("Cannot invoke reshape on a Matrix interface");
  }, t.prototype.clone = function() {
    throw new Error("Cannot invoke clone on a Matrix interface");
  }, t.prototype.size = function() {
    throw new Error("Cannot invoke size on a Matrix interface");
  }, t.prototype.map = function(e, n) {
    throw new Error("Cannot invoke map on a Matrix interface");
  }, t.prototype.forEach = function(e) {
    throw new Error("Cannot invoke forEach on a Matrix interface");
  }, t.prototype[Symbol.iterator] = function() {
    throw new Error("Cannot iterate a Matrix interface");
  }, t.prototype.toArray = function() {
    throw new Error("Cannot invoke toArray on a Matrix interface");
  }, t.prototype.valueOf = function() {
    throw new Error("Cannot invoke valueOf on a Matrix interface");
  }, t.prototype.format = function(e) {
    throw new Error("Cannot invoke format on a Matrix interface");
  }, t.prototype.toString = function() {
    throw new Error("Cannot invoke toString on a Matrix interface");
  }, t;
}, {
  isClass: !0
}), mVn = "DenseMatrix", CVn = ["Matrix"], EVn = /* @__PURE__ */ Ar(mVn, CVn, (t) => {
  var {
    Matrix: e
  } = t;
  function n(c, u) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (u && !X0(u))
      throw new Error("Invalid datatype: " + u);
    if (cA(c))
      c.type === "DenseMatrix" ? (this._data = cs(c._data), this._size = cs(c._size), this._datatype = u || c._datatype) : (this._data = c.toArray(), this._size = c.size(), this._datatype = u || c._datatype);
    else if (c && zs(c.data) && zs(c.size))
      this._data = c.data, this._size = c.size, nTe(this._data, this._size), this._datatype = u || c.datatype;
    else if (zs(c))
      this._data = l(c), this._size = PI(this._data), nTe(this._data, this._size), this._datatype = u;
    else {
      if (c)
        throw new TypeError("Unsupported type of data (" + Sg(c) + ")");
      this._data = [], this._size = [0], this._datatype = u;
    }
  }
  n.prototype = new e(), n.prototype.createDenseMatrix = function(c, u) {
    return new n(c, u);
  }, n.prototype.type = "DenseMatrix", n.prototype.isDenseMatrix = !0, n.prototype.getDataType = function() {
    return t5(this._data, Sg);
  }, n.prototype.storage = function() {
    return "dense";
  }, n.prototype.datatype = function() {
    return this._datatype;
  }, n.prototype.create = function(c, u) {
    return new n(c, u);
  }, n.prototype.subset = function(c, u, f) {
    switch (arguments.length) {
      case 1:
        return r(this, c);
      case 2:
      case 3:
        return o(this, c, u, f);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, n.prototype.get = function(c) {
    if (!zs(c))
      throw new TypeError("Array expected");
    if (c.length !== this._size.length)
      throw new Qo(c.length, this._size.length);
    for (var u = 0; u < c.length; u++)
      Ga(c[u], this._size[u]);
    for (var f = this._data, h = 0, d = c.length; h < d; h++) {
      var I = c[h];
      Ga(I, f.length), f = f[I];
    }
    return f;
  }, n.prototype.set = function(c, u, f) {
    if (!zs(c))
      throw new TypeError("Array expected");
    if (c.length < this._size.length)
      throw new Qo(c.length, this._size.length, "<");
    var h, d, I, m = c.map(function(y) {
      return y + 1;
    });
    A(this, m, f);
    var C = this._data;
    for (h = 0, d = c.length - 1; h < d; h++)
      I = c[h], Ga(I, C.length), C = C[I];
    return I = c[c.length - 1], Ga(I, C.length), C[I] = u, this;
  };
  function r(c, u) {
    if (!Mq(u))
      throw new TypeError("Invalid index");
    var f = u.isScalar();
    if (f)
      return c.get(u.min());
    var h = u.size();
    if (h.length !== c._size.length)
      throw new Qo(h.length, c._size.length);
    for (var d = u.min(), I = u.max(), m = 0, C = c._size.length; m < C; m++)
      Ga(d[m], c._size[m]), Ga(I[m], c._size[m]);
    return new n(i(c._data, u, h.length, 0), c._datatype);
  }
  function i(c, u, f, h) {
    var d = h === f - 1, I = u.dimension(h);
    return d ? I.map(function(m) {
      return Ga(m, c.length), c[m];
    }).valueOf() : I.map(function(m) {
      Ga(m, c.length);
      var C = c[m];
      return i(C, u, f, h + 1);
    }).valueOf();
  }
  function o(c, u, f, h) {
    if (!u || u.isIndex !== !0)
      throw new TypeError("Invalid index");
    var d = u.size(), I = u.isScalar(), m;
    if (cA(f) ? (m = f.size(), f = f.valueOf()) : m = PI(f), I) {
      if (m.length !== 0)
        throw new TypeError("Scalar expected");
      c.set(u.min(), f, h);
    } else {
      if (d.length < c._size.length)
        throw new Qo(d.length, c._size.length, "<");
      if (m.length < d.length) {
        for (var C = 0, y = 0; d[C] === 1 && m[C] === 1; )
          C++;
        for (; d[C] === 1; )
          y++, C++;
        f = gWe(f, d.length, y, m);
      }
      if (!Z8(d, m))
        throw new Qo(d, m, ">");
      var v = u.max().map(function(w) {
        return w + 1;
      });
      A(c, v, h);
      var b = d.length, Q = 0;
      s(c._data, u, f, b, Q);
    }
    return c;
  }
  function s(c, u, f, h, d) {
    var I = d === h - 1, m = u.dimension(d);
    I ? m.forEach(function(C, y) {
      Ga(C), c[C] = f[y[0]];
    }) : m.forEach(function(C, y) {
      Ga(C), s(c[C], u, f[y[0]], h, d + 1);
    });
  }
  n.prototype.resize = function(c, u, f) {
    if (!eWe(c))
      throw new TypeError("Array or Matrix expected");
    var h = c.valueOf().map((I) => Array.isArray(I) && I.length === 1 ? I[0] : I), d = f ? this.clone() : this;
    return a(d, h, u);
  };
  function a(c, u, f) {
    if (u.length === 0) {
      for (var h = c._data; zs(h); )
        h = h[0];
      return h;
    }
    return c._size = u.slice(0), c._data = e5(c._data, c._size, f), c;
  }
  n.prototype.reshape = function(c, u) {
    var f = u ? this.clone() : this;
    f._data = Vzn(f._data, c);
    var h = f._size.reduce((d, I) => d * I);
    return f._size = Lfe(c, h), f;
  };
  function A(c, u, f) {
    for (var h = c._size.slice(0), d = !1; h.length < u.length; )
      h.push(0), d = !0;
    for (var I = 0, m = u.length; I < m; I++)
      u[I] > h[I] && (h[I] = u[I], d = !0);
    d && a(c, h, f);
  }
  n.prototype.clone = function() {
    var c = new n({
      data: cs(this._data),
      size: cs(this._size),
      datatype: this._datatype
    });
    return c;
  }, n.prototype.size = function() {
    return this._size.slice(0);
  }, n.prototype.map = function(c) {
    var u = this, f = function I(m, C) {
      return zs(m) ? m.map(function(y, v) {
        return I(y, C.concat(v));
      }) : c(m, C, u);
    }, h = f(this._data, []), d = this._datatype !== void 0 ? t5(h, Sg) : void 0;
    return new n(h, d);
  }, n.prototype.forEach = function(c) {
    var u = this, f = function h(d, I) {
      zs(d) ? d.forEach(function(m, C) {
        h(m, I.concat(C));
      }) : c(d, I, u);
    };
    f(this._data, []);
  }, n.prototype[Symbol.iterator] = function* () {
    var c = function* u(f, h) {
      if (zs(f))
        for (var d = 0; d < f.length; d++)
          yield* u(f[d], h.concat(d));
      else
        yield {
          value: f,
          index: h
        };
    };
    yield* c(this._data, []);
  }, n.prototype.rows = function() {
    var c = [], u = this.size();
    if (u.length !== 2)
      throw new TypeError("Rows can only be returned for a 2D matrix.");
    var f = this._data;
    for (var h of f)
      c.push(new n([h], this._datatype));
    return c;
  }, n.prototype.columns = function() {
    var c = this, u = [], f = this.size();
    if (f.length !== 2)
      throw new TypeError("Rows can only be returned for a 2D matrix.");
    for (var h = this._data, d = function(C) {
      var y = h.map((v) => [v[C]]);
      u.push(new n(y, c._datatype));
    }, I = 0; I < f[1]; I++)
      d(I);
    return u;
  }, n.prototype.toArray = function() {
    return cs(this._data);
  }, n.prototype.valueOf = function() {
    return this._data;
  }, n.prototype.format = function(c) {
    return ua(this._data, c);
  }, n.prototype.toString = function() {
    return ua(this._data);
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "DenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, n.prototype.diagonal = function(c) {
    if (c) {
      if (Jl(c) && (c = c.toNumber()), !ga(c) || !Ts(c))
        throw new TypeError("The parameter k must be an integer number");
    } else
      c = 0;
    for (var u = c > 0 ? c : 0, f = c < 0 ? -c : 0, h = this._size[0], d = this._size[1], I = Math.min(h - f, d - u), m = [], C = 0; C < I; C++)
      m[C] = this._data[C + f][C + u];
    return new n({
      data: m,
      size: [I],
      datatype: this._datatype
    });
  }, n.diagonal = function(c, u, f, h) {
    if (!zs(c))
      throw new TypeError("Array expected, size parameter");
    if (c.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (c = c.map(function(R) {
      if (Jl(R) && (R = R.toNumber()), !ga(R) || !Ts(R) || R < 1)
        throw new Error("Size values must be positive integers");
      return R;
    }), f) {
      if (Jl(f) && (f = f.toNumber()), !ga(f) || !Ts(f))
        throw new TypeError("The parameter k must be an integer number");
    } else
      f = 0;
    var d = f > 0 ? f : 0, I = f < 0 ? -f : 0, m = c[0], C = c[1], y = Math.min(m - I, C - d), v;
    if (zs(u)) {
      if (u.length !== y)
        throw new Error("Invalid value array length");
      v = function(M) {
        return u[M];
      };
    } else if (cA(u)) {
      var b = u.size();
      if (b.length !== 1 || b[0] !== y)
        throw new Error("Invalid matrix length");
      v = function(M) {
        return u.get([M]);
      };
    } else
      v = function() {
        return u;
      };
    h || (h = Jl(v(0)) ? v(0).mul(0) : 0);
    var Q = [];
    if (c.length > 0) {
      Q = e5(Q, c, h);
      for (var w = 0; w < y; w++)
        Q[w + I][w + d] = v(w);
    }
    return new n({
      data: Q,
      size: [m, C]
    });
  }, n.fromJSON = function(c) {
    return new n(c);
  }, n.prototype.swapRows = function(c, u) {
    if (!ga(c) || !Ts(c) || !ga(u) || !Ts(u))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return Ga(c, this._size[0]), Ga(u, this._size[0]), n._swapRows(c, u, this._data), this;
  }, n._swapRows = function(c, u, f) {
    var h = f[c];
    f[c] = f[u], f[u] = h;
  };
  function l(c) {
    for (var u = 0, f = c.length; u < f; u++) {
      var h = c[u];
      zs(h) ? c[u] = l(h) : h && h.isMatrix === !0 && (c[u] = l(h.valueOf()));
    }
    return c;
  }
  return n;
}, {
  isClass: !0
});
function ac(t, e, n) {
  return t && typeof t.map == "function" ? t.map(function(r) {
    return ac(r, e);
  }) : e(t);
}
var Ofe = "number", Uq = "number, number";
function DWe(t) {
  return Math.abs(t);
}
DWe.signature = Ofe;
function TWe(t, e) {
  return t + e;
}
TWe.signature = Uq;
function NWe(t, e) {
  return t * e;
}
NWe.signature = Uq;
function LWe(t) {
  return -t;
}
LWe.signature = Ofe;
function MWe(t) {
  return Math.ceil(t);
}
MWe.signature = Ofe;
function OWe(t, e) {
  return t * t < 1 && e === 1 / 0 || t * t > 1 && e === -1 / 0 ? 0 : Math.pow(t, e);
}
OWe.signature = Uq;
function bre(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return parseFloat(AWe(t, e));
}
bre.signature = Uq;
var sTe = "isNumeric", yVn = ["typed"], vVn = /* @__PURE__ */ Ar(sTe, yVn, (t) => {
  var {
    typed: e
  } = t;
  return e(sTe, {
    "number | BigNumber | Fraction | boolean": function() {
      return !0;
    },
    "Complex | Unit | string | null | undefined | Node": function() {
      return !1;
    },
    "Array | Matrix": function(r) {
      return ac(r, this);
    }
  });
});
function eE(t, e, n) {
  if (n == null)
    return t.eq(e);
  if (t.eq(e))
    return !0;
  if (t.isNaN() || e.isNaN())
    return !1;
  if (t.isFinite() && e.isFinite()) {
    var r = t.minus(e).abs();
    if (r.isZero())
      return !0;
    var i = t.constructor.max(t.abs(), e.abs());
    return r.lte(i.times(n));
  }
  return !1;
}
function BVn(t, e, n) {
  return dd(t.re, e.re, n) && dd(t.im, e.im, n);
}
var o5 = "equalScalar", bVn = ["typed", "config"], _Vn = /* @__PURE__ */ Ar(o5, bVn, (t) => {
  var {
    typed: e,
    config: n
  } = t;
  return e(o5, {
    "boolean, boolean": function(i, o) {
      return i === o;
    },
    "number, number": function(i, o) {
      return dd(i, o, n.epsilon);
    },
    "BigNumber, BigNumber": function(i, o) {
      return i.eq(o) || eE(i, o, n.epsilon);
    },
    "Fraction, Fraction": function(i, o) {
      return i.equals(o);
    },
    "Complex, Complex": function(i, o) {
      return BVn(i, o, n.epsilon);
    },
    "Unit, Unit": function(i, o) {
      if (!i.equalBase(o))
        throw new Error("Cannot compare units with different base");
      return this(i.value, o.value);
    }
  });
});
Ar(o5, ["typed", "config"], (t) => {
  var {
    typed: e,
    config: n
  } = t;
  return e(o5, {
    "number, number": function(i, o) {
      return dd(i, o, n.epsilon);
    }
  });
});
var SVn = "SparseMatrix", QVn = ["typed", "equalScalar", "Matrix"], wVn = /* @__PURE__ */ Ar(SVn, QVn, (t) => {
  var {
    typed: e,
    equalScalar: n,
    Matrix: r
  } = t;
  function i(I, m) {
    if (!(this instanceof i))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (m && !X0(m))
      throw new Error("Invalid datatype: " + m);
    if (cA(I))
      o(this, I, m);
    else if (I && zs(I.index) && zs(I.ptr) && zs(I.size))
      this._values = I.values, this._index = I.index, this._ptr = I.ptr, this._size = I.size, this._datatype = m || I.datatype;
    else if (zs(I))
      s(this, I, m);
    else {
      if (I)
        throw new TypeError("Unsupported type of data (" + Sg(I) + ")");
      this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = m;
    }
  }
  function o(I, m, C) {
    m.type === "SparseMatrix" ? (I._values = m._values ? cs(m._values) : void 0, I._index = cs(m._index), I._ptr = cs(m._ptr), I._size = cs(m._size), I._datatype = C || m._datatype) : s(I, m.valueOf(), C || m._datatype);
  }
  function s(I, m, C) {
    I._values = [], I._index = [], I._ptr = [], I._datatype = C;
    var y = m.length, v = 0, b = n, Q = 0;
    if (X0(C) && (b = e.find(n, [C, C]) || n, Q = e.convert(0, C)), y > 0) {
      var w = 0;
      do {
        I._ptr.push(I._index.length);
        for (var R = 0; R < y; R++) {
          var M = m[R];
          if (zs(M)) {
            if (w === 0 && v < M.length && (v = M.length), w < M.length) {
              var O = M[w];
              b(O, Q) || (I._values.push(O), I._index.push(R));
            }
          } else
            w === 0 && v < 1 && (v = 1), b(M, Q) || (I._values.push(M), I._index.push(R));
        }
        w++;
      } while (w < v);
    }
    I._ptr.push(I._index.length), I._size = [y, v];
  }
  i.prototype = new r(), i.prototype.createSparseMatrix = function(I, m) {
    return new i(I, m);
  }, i.prototype.type = "SparseMatrix", i.prototype.isSparseMatrix = !0, i.prototype.getDataType = function() {
    return t5(this._values, Sg);
  }, i.prototype.storage = function() {
    return "sparse";
  }, i.prototype.datatype = function() {
    return this._datatype;
  }, i.prototype.create = function(I, m) {
    return new i(I, m);
  }, i.prototype.density = function() {
    var I = this._size[0], m = this._size[1];
    return I !== 0 && m !== 0 ? this._index.length / (I * m) : 0;
  }, i.prototype.subset = function(I, m, C) {
    if (!this._values)
      throw new Error("Cannot invoke subset on a Pattern only matrix");
    switch (arguments.length) {
      case 1:
        return a(this, I);
      case 2:
      case 3:
        return A(this, I, m, C);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  };
  function a(I, m) {
    if (!Mq(m))
      throw new TypeError("Invalid index");
    var C = m.isScalar();
    if (C)
      return I.get(m.min());
    var y = m.size();
    if (y.length !== I._size.length)
      throw new Qo(y.length, I._size.length);
    var v, b, Q, w, R = m.min(), M = m.max();
    for (v = 0, b = I._size.length; v < b; v++)
      Ga(R[v], I._size[v]), Ga(M[v], I._size[v]);
    var O = I._values, L = I._index, N = I._ptr, k = m.dimension(0), $ = m.dimension(1), U = [], X = [];
    k.forEach(function(V, Z) {
      X[V] = Z[0], U[V] = !0;
    });
    var K = O ? [] : void 0, z = [], Y = [];
    return $.forEach(function(V) {
      for (Y.push(z.length), Q = N[V], w = N[V + 1]; Q < w; Q++)
        v = L[Q], U[v] === !0 && (z.push(X[v]), K && K.push(O[Q]));
    }), Y.push(z.length), new i({
      values: K,
      index: z,
      ptr: Y,
      size: y,
      datatype: I._datatype
    });
  }
  function A(I, m, C, y) {
    if (!m || m.isIndex !== !0)
      throw new TypeError("Invalid index");
    var v = m.size(), b = m.isScalar(), Q;
    if (cA(C) ? (Q = C.size(), C = C.toArray()) : Q = PI(C), b) {
      if (Q.length !== 0)
        throw new TypeError("Scalar expected");
      I.set(m.min(), C, y);
    } else {
      if (v.length !== 1 && v.length !== 2)
        throw new Qo(v.length, I._size.length, "<");
      if (Q.length < v.length) {
        for (var w = 0, R = 0; v[w] === 1 && Q[w] === 1; )
          w++;
        for (; v[w] === 1; )
          R++, w++;
        C = gWe(C, v.length, R, Q);
      }
      if (!Z8(v, Q))
        throw new Qo(v, Q, ">");
      for (var M = m.min()[0], O = m.min()[1], L = Q[0], N = Q[1], k = 0; k < L; k++)
        for (var $ = 0; $ < N; $++) {
          var U = C[k][$];
          I.set([k + M, $ + O], U, y);
        }
    }
    return I;
  }
  i.prototype.get = function(I) {
    if (!zs(I))
      throw new TypeError("Array expected");
    if (I.length !== this._size.length)
      throw new Qo(I.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke get on a Pattern only matrix");
    var m = I[0], C = I[1];
    Ga(m, this._size[0]), Ga(C, this._size[1]);
    var y = l(m, this._ptr[C], this._ptr[C + 1], this._index);
    return y < this._ptr[C + 1] && this._index[y] === m ? this._values[y] : 0;
  }, i.prototype.set = function(I, m, C) {
    if (!zs(I))
      throw new TypeError("Array expected");
    if (I.length !== this._size.length)
      throw new Qo(I.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke set on a Pattern only matrix");
    var y = I[0], v = I[1], b = this._size[0], Q = this._size[1], w = n, R = 0;
    X0(this._datatype) && (w = e.find(n, [this._datatype, this._datatype]) || n, R = e.convert(0, this._datatype)), (y > b - 1 || v > Q - 1) && (f(this, Math.max(y + 1, b), Math.max(v + 1, Q), C), b = this._size[0], Q = this._size[1]), Ga(y, b), Ga(v, Q);
    var M = l(y, this._ptr[v], this._ptr[v + 1], this._index);
    return M < this._ptr[v + 1] && this._index[M] === y ? w(m, R) ? c(M, v, this._values, this._index, this._ptr) : this._values[M] = m : u(M, y, v, m, this._values, this._index, this._ptr), this;
  };
  function l(I, m, C, y) {
    if (C - m === 0)
      return C;
    for (var v = m; v < C; v++)
      if (y[v] === I)
        return v;
    return m;
  }
  function c(I, m, C, y, v) {
    C.splice(I, 1), y.splice(I, 1);
    for (var b = m + 1; b < v.length; b++)
      v[b]--;
  }
  function u(I, m, C, y, v, b, Q) {
    v.splice(I, 0, y), b.splice(I, 0, m);
    for (var w = C + 1; w < Q.length; w++)
      Q[w]++;
  }
  i.prototype.resize = function(I, m, C) {
    if (!eWe(I))
      throw new TypeError("Array or Matrix expected");
    var y = I.valueOf().map((b) => Array.isArray(b) && b.length === 1 ? b[0] : b);
    if (y.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    y.forEach(function(b) {
      if (!ga(b) || !Ts(b) || b < 0)
        throw new TypeError("Invalid size, must contain positive integers (size: " + ua(y) + ")");
    });
    var v = C ? this.clone() : this;
    return f(v, y[0], y[1], m);
  };
  function f(I, m, C, y) {
    var v = y || 0, b = n, Q = 0;
    X0(I._datatype) && (b = e.find(n, [I._datatype, I._datatype]) || n, Q = e.convert(0, I._datatype), v = e.convert(v, I._datatype));
    var w = !b(v, Q), R = I._size[0], M = I._size[1], O, L, N;
    if (C > M) {
      for (L = M; L < C; L++)
        if (I._ptr[L] = I._values.length, w)
          for (O = 0; O < R; O++)
            I._values.push(v), I._index.push(O);
      I._ptr[C] = I._values.length;
    } else
      C < M && (I._ptr.splice(C + 1, M - C), I._values.splice(I._ptr[C], I._values.length), I._index.splice(I._ptr[C], I._index.length));
    if (M = C, m > R) {
      if (w) {
        var k = 0;
        for (L = 0; L < M; L++) {
          I._ptr[L] = I._ptr[L] + k, N = I._ptr[L + 1] + k;
          var $ = 0;
          for (O = R; O < m; O++, $++)
            I._values.splice(N + $, 0, v), I._index.splice(N + $, 0, O), k++;
        }
        I._ptr[M] = I._values.length;
      }
    } else if (m < R) {
      var U = 0;
      for (L = 0; L < M; L++) {
        I._ptr[L] = I._ptr[L] - U;
        var X = I._ptr[L], K = I._ptr[L + 1] - U;
        for (N = X; N < K; N++)
          O = I._index[N], O > m - 1 && (I._values.splice(N, 1), I._index.splice(N, 1), U++);
      }
      I._ptr[L] = I._values.length;
    }
    return I._size[0] = m, I._size[1] = C, I;
  }
  i.prototype.reshape = function(I, m) {
    if (!zs(I))
      throw new TypeError("Array expected");
    if (I.length !== 2)
      throw new Error("Sparse matrices can only be reshaped in two dimensions");
    I.forEach(function(V) {
      if (!ga(V) || !Ts(V) || V <= -2 || V === 0)
        throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + ua(I) + ")");
    });
    var C = this._size[0] * this._size[1];
    I = Lfe(I, C);
    var y = I[0] * I[1];
    if (C !== y)
      throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
    var v = m ? this.clone() : this;
    if (this._size[0] === I[0] && this._size[1] === I[1])
      return v;
    for (var b = [], Q = 0; Q < v._ptr.length; Q++)
      for (var w = 0; w < v._ptr[Q + 1] - v._ptr[Q]; w++)
        b.push(Q);
    for (var R = v._values.slice(), M = v._index.slice(), O = 0; O < v._index.length; O++) {
      var L = M[O], N = b[O], k = L * v._size[1] + N;
      b[O] = k % I[1], M[O] = Math.floor(k / I[1]);
    }
    v._values.length = 0, v._index.length = 0, v._ptr.length = I[1] + 1, v._size = I.slice();
    for (var $ = 0; $ < v._ptr.length; $++)
      v._ptr[$] = 0;
    for (var U = 0; U < R.length; U++) {
      var X = M[U], K = b[U], z = R[U], Y = l(X, v._ptr[K], v._ptr[K + 1], v._index);
      u(Y, X, K, z, v._values, v._index, v._ptr);
    }
    return v;
  }, i.prototype.clone = function() {
    var I = new i({
      values: this._values ? cs(this._values) : void 0,
      index: cs(this._index),
      ptr: cs(this._ptr),
      size: cs(this._size),
      datatype: this._datatype
    });
    return I;
  }, i.prototype.size = function() {
    return this._size.slice(0);
  }, i.prototype.map = function(I, m) {
    if (!this._values)
      throw new Error("Cannot invoke map on a Pattern only matrix");
    var C = this, y = this._size[0], v = this._size[1], b = function(w, R, M) {
      return I(w, [R, M], C);
    };
    return h(this, 0, y - 1, 0, v - 1, b, m);
  };
  function h(I, m, C, y, v, b, Q) {
    var w = [], R = [], M = [], O = n, L = 0;
    X0(I._datatype) && (O = e.find(n, [I._datatype, I._datatype]) || n, L = e.convert(0, I._datatype));
    for (var N = function(pe, Ce, Be) {
      pe = b(pe, Ce, Be), O(pe, L) || (w.push(pe), R.push(Ce));
    }, k = y; k <= v; k++) {
      M.push(w.length);
      var $ = I._ptr[k], U = I._ptr[k + 1];
      if (Q)
        for (var X = $; X < U; X++) {
          var K = I._index[X];
          K >= m && K <= C && N(I._values[X], K - m, k - y);
        }
      else {
        for (var z = {}, Y = $; Y < U; Y++) {
          var V = I._index[Y];
          z[V] = I._values[Y];
        }
        for (var Z = m; Z <= C; Z++) {
          var ce = Z in z ? z[Z] : 0;
          N(ce, Z - m, k - y);
        }
      }
    }
    return M.push(w.length), new i({
      values: w,
      index: R,
      ptr: M,
      size: [C - m + 1, v - y + 1]
    });
  }
  i.prototype.forEach = function(I, m) {
    if (!this._values)
      throw new Error("Cannot invoke forEach on a Pattern only matrix");
    for (var C = this, y = this._size[0], v = this._size[1], b = 0; b < v; b++) {
      var Q = this._ptr[b], w = this._ptr[b + 1];
      if (m)
        for (var R = Q; R < w; R++) {
          var M = this._index[R];
          I(this._values[R], [M, b], C);
        }
      else {
        for (var O = {}, L = Q; L < w; L++) {
          var N = this._index[L];
          O[N] = this._values[L];
        }
        for (var k = 0; k < y; k++) {
          var $ = k in O ? O[k] : 0;
          I($, [k, b], C);
        }
      }
    }
  }, i.prototype[Symbol.iterator] = function* () {
    if (!this._values)
      throw new Error("Cannot iterate a Pattern only matrix");
    for (var I = this._size[1], m = 0; m < I; m++)
      for (var C = this._ptr[m], y = this._ptr[m + 1], v = C; v < y; v++) {
        var b = this._index[v];
        yield {
          value: this._values[v],
          index: [b, m]
        };
      }
  }, i.prototype.toArray = function() {
    return d(this._values, this._index, this._ptr, this._size, !0);
  }, i.prototype.valueOf = function() {
    return d(this._values, this._index, this._ptr, this._size, !1);
  };
  function d(I, m, C, y, v) {
    var b = y[0], Q = y[1], w = [], R, M;
    for (R = 0; R < b; R++)
      for (w[R] = [], M = 0; M < Q; M++)
        w[R][M] = 0;
    for (M = 0; M < Q; M++)
      for (var O = C[M], L = C[M + 1], N = O; N < L; N++)
        R = m[N], w[R][M] = I ? v ? cs(I[N]) : I[N] : 1;
    return w;
  }
  return i.prototype.format = function(I) {
    for (var m = this._size[0], C = this._size[1], y = this.density(), v = "Sparse Matrix [" + ua(m, I) + " x " + ua(C, I) + "] density: " + ua(y, I) + `
`, b = 0; b < C; b++)
      for (var Q = this._ptr[b], w = this._ptr[b + 1], R = Q; R < w; R++) {
        var M = this._index[R];
        v += `
    (` + ua(M, I) + ", " + ua(b, I) + ") ==> " + (this._values ? ua(this._values[R], I) : "X");
      }
    return v;
  }, i.prototype.toString = function() {
    return ua(this.toArray());
  }, i.prototype.toJSON = function() {
    return {
      mathjs: "SparseMatrix",
      values: this._values,
      index: this._index,
      ptr: this._ptr,
      size: this._size,
      datatype: this._datatype
    };
  }, i.prototype.diagonal = function(I) {
    if (I) {
      if (Jl(I) && (I = I.toNumber()), !ga(I) || !Ts(I))
        throw new TypeError("The parameter k must be an integer number");
    } else
      I = 0;
    var m = I > 0 ? I : 0, C = I < 0 ? -I : 0, y = this._size[0], v = this._size[1], b = Math.min(y - C, v - m), Q = [], w = [], R = [];
    R[0] = 0;
    for (var M = m; M < v && Q.length < b; M++)
      for (var O = this._ptr[M], L = this._ptr[M + 1], N = O; N < L; N++) {
        var k = this._index[N];
        if (k === M - m + C) {
          Q.push(this._values[N]), w[Q.length - 1] = k - C;
          break;
        }
      }
    return R.push(Q.length), new i({
      values: Q,
      index: w,
      ptr: R,
      size: [b, 1]
    });
  }, i.fromJSON = function(I) {
    return new i(I);
  }, i.diagonal = function(I, m, C, y, v) {
    if (!zs(I))
      throw new TypeError("Array expected, size parameter");
    if (I.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (I = I.map(function(V) {
      if (Jl(V) && (V = V.toNumber()), !ga(V) || !Ts(V) || V < 1)
        throw new Error("Size values must be positive integers");
      return V;
    }), C) {
      if (Jl(C) && (C = C.toNumber()), !ga(C) || !Ts(C))
        throw new TypeError("The parameter k must be an integer number");
    } else
      C = 0;
    var b = n, Q = 0;
    X0(v) && (b = e.find(n, [v, v]) || n, Q = e.convert(0, v));
    var w = C > 0 ? C : 0, R = C < 0 ? -C : 0, M = I[0], O = I[1], L = Math.min(M - R, O - w), N;
    if (zs(m)) {
      if (m.length !== L)
        throw new Error("Invalid value array length");
      N = function(Z) {
        return m[Z];
      };
    } else if (cA(m)) {
      var k = m.size();
      if (k.length !== 1 || k[0] !== L)
        throw new Error("Invalid matrix length");
      N = function(Z) {
        return m.get([Z]);
      };
    } else
      N = function() {
        return m;
      };
    for (var $ = [], U = [], X = [], K = 0; K < O; K++) {
      X.push($.length);
      var z = K - w;
      if (z >= 0 && z < L) {
        var Y = N(z);
        b(Y, Q) || (U.push(z + R), $.push(Y));
      }
    }
    return X.push($.length), new i({
      values: $,
      index: U,
      ptr: X,
      size: [M, O]
    });
  }, i.prototype.swapRows = function(I, m) {
    if (!ga(I) || !Ts(I) || !ga(m) || !Ts(m))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return Ga(I, this._size[0]), Ga(m, this._size[0]), i._swapRows(I, m, this._size[1], this._values, this._index, this._ptr), this;
  }, i._forEachRow = function(I, m, C, y, v) {
    for (var b = y[I], Q = y[I + 1], w = b; w < Q; w++)
      v(C[w], m[w]);
  }, i._swapRows = function(I, m, C, y, v, b) {
    for (var Q = 0; Q < C; Q++) {
      var w = b[Q], R = b[Q + 1], M = l(I, w, R, v), O = l(m, w, R, v);
      if (M < R && O < R && v[M] === I && v[O] === m) {
        if (y) {
          var L = y[M];
          y[M] = y[O], y[O] = L;
        }
        continue;
      }
      if (M < R && v[M] === I && (O >= R || v[O] !== m)) {
        var N = y ? y[M] : void 0;
        v.splice(O, 0, m), y && y.splice(O, 0, N), v.splice(O <= M ? M + 1 : M, 1), y && y.splice(O <= M ? M + 1 : M, 1);
        continue;
      }
      if (O < R && v[O] === m && (M >= R || v[M] !== I)) {
        var k = y ? y[O] : void 0;
        v.splice(M, 0, I), y && y.splice(M, 0, k), v.splice(M <= O ? O + 1 : O, 1), y && y.splice(M <= O ? O + 1 : O, 1);
      }
    }
  }, i;
}, {
  isClass: !0
}), xVn = "number", RVn = ["typed"];
function DVn(t) {
  var e = t.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
  if (e) {
    var n = {
      "0b": 2,
      "0o": 8,
      "0x": 16
    }[e[1]], r = e[2], i = e[3];
    return {
      input: t,
      radix: n,
      integerPart: r,
      fractionalPart: i
    };
  } else
    return null;
}
function TVn(t) {
  for (var e = parseInt(t.integerPart, t.radix), n = 0, r = 0; r < t.fractionalPart.length; r++) {
    var i = parseInt(t.fractionalPart[r], t.radix);
    n += i / Math.pow(t.radix, r + 1);
  }
  var o = e + n;
  if (isNaN(o))
    throw new SyntaxError('String "' + t.input + '" is no valid number');
  return o;
}
var NVn = /* @__PURE__ */ Ar(xVn, RVn, (t) => {
  var {
    typed: e
  } = t, n = e("number", {
    "": function() {
      return 0;
    },
    number: function(i) {
      return i;
    },
    string: function(i) {
      if (i === "NaN")
        return NaN;
      var o = DVn(i);
      if (o)
        return TVn(o);
      var s = 0, a = i.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
      a && (s = Number(a[2]), i = a[1]);
      var A = Number(i);
      if (isNaN(A))
        throw new SyntaxError('String "' + i + '" is no valid number');
      if (a) {
        if (A > 2 ** s - 1)
          throw new SyntaxError('String "'.concat(i, '" is out of range'));
        A >= 2 ** (s - 1) && (A = A - 2 ** s);
      }
      return A;
    },
    BigNumber: function(i) {
      return i.toNumber();
    },
    Fraction: function(i) {
      return i.valueOf();
    },
    Unit: function(i) {
      throw new Error("Second argument with valueless unit expected");
    },
    null: function(i) {
      return 0;
    },
    "Unit, string | Unit": function(i, o) {
      return i.toNumber(o);
    },
    "Array | Matrix": function(i) {
      return ac(i, this);
    }
  });
  return n.fromJSON = function(r) {
    return parseFloat(r.value);
  }, n;
}), LVn = "bignumber", MVn = ["typed", "BigNumber"], OVn = /* @__PURE__ */ Ar(LVn, MVn, (t) => {
  var {
    typed: e,
    BigNumber: n
  } = t;
  return e("bignumber", {
    "": function() {
      return new n(0);
    },
    number: function(i) {
      return new n(i + "");
    },
    string: function(i) {
      var o = i.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
      if (o) {
        var s = o[2], a = n(o[1]), A = new n(2).pow(Number(s));
        if (a.gt(A.sub(1)))
          throw new SyntaxError('String "'.concat(i, '" is out of range'));
        var l = new n(2).pow(Number(s) - 1);
        return a.gte(l) ? a.sub(A) : a;
      }
      return new n(i);
    },
    BigNumber: function(i) {
      return i;
    },
    Fraction: function(i) {
      return new n(i.n).div(i.d).times(i.s);
    },
    null: function(i) {
      return new n(0);
    },
    "Array | Matrix": function(i) {
      return ac(i, this);
    }
  });
}), FVn = "fraction", PVn = ["typed", "Fraction"], kVn = /* @__PURE__ */ Ar(FVn, PVn, (t) => {
  var {
    typed: e,
    Fraction: n
  } = t;
  return e("fraction", {
    number: function(i) {
      if (!isFinite(i) || isNaN(i))
        throw new Error(i + " cannot be represented as a fraction");
      return new n(i);
    },
    string: function(i) {
      return new n(i);
    },
    "number, number": function(i, o) {
      return new n(i, o);
    },
    null: function(i) {
      return new n(0);
    },
    BigNumber: function(i) {
      return new n(i.toString());
    },
    Fraction: function(i) {
      return i;
    },
    Object: function(i) {
      return new n(i);
    },
    "Array | Matrix": function(i) {
      return ac(i, this);
    }
  });
}), aTe = "matrix", GVn = ["typed", "Matrix", "DenseMatrix", "SparseMatrix"], UVn = /* @__PURE__ */ Ar(aTe, GVn, (t) => {
  var {
    typed: e,
    Matrix: n,
    DenseMatrix: r,
    SparseMatrix: i
  } = t;
  return e(aTe, {
    "": function() {
      return o([]);
    },
    string: function(a) {
      return o([], a);
    },
    "string, string": function(a, A) {
      return o([], a, A);
    },
    Array: function(a) {
      return o(a);
    },
    Matrix: function(a) {
      return o(a, a.storage());
    },
    "Array | Matrix, string": o,
    "Array | Matrix, string, string": o
  });
  function o(s, a, A) {
    if (a === "dense" || a === "default" || a === void 0)
      return new r(s, A);
    if (a === "sparse")
      return new i(s, A);
    throw new TypeError("Unknown matrix type " + JSON.stringify(a) + ".");
  }
}), ATe = "unaryMinus", HVn = ["typed"], $Vn = /* @__PURE__ */ Ar(ATe, HVn, (t) => {
  var {
    typed: e
  } = t;
  return e(ATe, {
    number: LWe,
    Complex: function(r) {
      return r.neg();
    },
    BigNumber: function(r) {
      return r.neg();
    },
    Fraction: function(r) {
      return r.neg();
    },
    Unit: function(r) {
      var i = r.clone();
      return i.value = this(r.value), i;
    },
    "Array | Matrix": function(r) {
      return ac(r, this);
    }
    // TODO: add support for string
  });
}), lTe = "abs", qVn = ["typed"], jVn = /* @__PURE__ */ Ar(lTe, qVn, (t) => {
  var {
    typed: e
  } = t;
  return e(lTe, {
    number: DWe,
    Complex: function(r) {
      return r.abs();
    },
    BigNumber: function(r) {
      return r.abs();
    },
    Fraction: function(r) {
      return r.abs();
    },
    "Array | Matrix": function(r) {
      return ac(r, this);
    },
    Unit: function(r) {
      return r.abs();
    }
  });
}), cTe = "addScalar", YVn = ["typed"], zVn = /* @__PURE__ */ Ar(cTe, YVn, (t) => {
  var {
    typed: e
  } = t;
  return e(cTe, {
    "number, number": TWe,
    "Complex, Complex": function(r, i) {
      return r.add(i);
    },
    "BigNumber, BigNumber": function(r, i) {
      return r.plus(i);
    },
    "Fraction, Fraction": function(r, i) {
      return r.add(i);
    },
    "Unit, Unit": function(r, i) {
      if (r.value === null || r.value === void 0)
        throw new Error("Parameter x contains a unit with undefined value");
      if (i.value === null || i.value === void 0)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!r.equalBase(i))
        throw new Error("Units do not match");
      var o = r.clone();
      return o.value = this(o.value, i.value), o.fixPrefix = !1, o;
    }
  });
}), VVn = "algorithm11", JVn = ["typed", "equalScalar"], VM = /* @__PURE__ */ Ar(VVn, JVn, (t) => {
  var {
    typed: e,
    equalScalar: n
  } = t;
  return function(i, o, s, a) {
    var A = i._values, l = i._index, c = i._ptr, u = i._size, f = i._datatype;
    if (!A)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var h = u[0], d = u[1], I, m = n, C = 0, y = s;
    typeof f == "string" && (I = f, m = e.find(n, [I, I]), C = e.convert(0, I), o = e.convert(o, I), y = e.find(s, [I, I]));
    for (var v = [], b = [], Q = [], w = 0; w < d; w++) {
      Q[w] = b.length;
      for (var R = c[w], M = c[w + 1], O = R; O < M; O++) {
        var L = l[O], N = a ? y(o, A[O]) : y(A[O], o);
        m(N, C) || (b.push(L), v.push(N));
      }
    }
    return Q[d] = b.length, i.createSparseMatrix({
      values: v,
      index: b,
      ptr: Q,
      size: [h, d],
      datatype: I
    });
  };
}), KVn = "algorithm14", WVn = ["typed"], Nd = /* @__PURE__ */ Ar(KVn, WVn, (t) => {
  var {
    typed: e
  } = t;
  return function(i, o, s, a) {
    var A = i._data, l = i._size, c = i._datatype, u, f = s;
    typeof c == "string" && (u = c, o = e.convert(o, u), f = e.find(s, [u, u]));
    var h = l.length > 0 ? n(f, 0, l, l[0], A, o, a) : [];
    return i.createDenseMatrix({
      data: h,
      size: cs(l),
      datatype: u
    });
  };
  function n(r, i, o, s, a, A, l) {
    var c = [];
    if (i === o.length - 1)
      for (var u = 0; u < s; u++)
        c[u] = l ? r(A, a[u]) : r(a[u], A);
    else
      for (var f = 0; f < s; f++)
        c[f] = n(r, i + 1, o, o[i + 1], a[f], A, l);
    return c;
  }
}), XVn = "ceil", ZVn = ["typed", "config", "round", "matrix", "equalScalar"], eJn = /* @__PURE__ */ Ar(XVn, ZVn, (t) => {
  var {
    typed: e,
    config: n,
    round: r,
    matrix: i,
    equalScalar: o
  } = t, s = VM({
    typed: e,
    equalScalar: o
  }), a = Nd({
    typed: e
  });
  return e("ceil", {
    number: function(l) {
      return dd(l, r(l), n.epsilon) ? r(l) : MWe(l);
    },
    "number, number": function(l, c) {
      if (dd(l, r(l, c), n.epsilon))
        return r(l, c);
      var [u, f] = "".concat(l, "e").split("e"), h = Math.ceil(Number("".concat(u, "e").concat(Number(f) + c)));
      return [u, f] = "".concat(h, "e").split("e"), Number("".concat(u, "e").concat(Number(f) - c));
    },
    Complex: function(l) {
      return l.ceil();
    },
    "Complex, number": function(l, c) {
      return l.ceil(c);
    },
    BigNumber: function(l) {
      return eE(l, r(l), n.epsilon) ? r(l) : l.ceil();
    },
    "BigNumber, BigNumber": function(l, c) {
      return eE(l, r(l, c), n.epsilon) ? r(l, c) : l.toDecimalPlaces(c.toNumber(), ZC.ROUND_CEIL);
    },
    Fraction: function(l) {
      return l.ceil();
    },
    "Fraction, number": function(l, c) {
      return l.ceil(c);
    },
    "Array | Matrix": function(l) {
      return ac(l, this);
    },
    "Array | Matrix, number": function(l, c) {
      return ac(l, (u) => this(u, c));
    },
    "SparseMatrix, number | BigNumber": function(l, c) {
      return s(l, c, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(l, c) {
      return a(l, c, this, !1);
    },
    "number | Complex | BigNumber, Array": function(l, c) {
      return a(i(c), l, this, !0).valueOf();
    }
  });
}), tJn = "fix", nJn = ["typed", "Complex", "matrix", "ceil", "floor"], rJn = /* @__PURE__ */ Ar(tJn, nJn, (t) => {
  var {
    typed: e,
    Complex: n,
    matrix: r,
    ceil: i,
    floor: o
  } = t, s = Nd({
    typed: e
  });
  return e("fix", {
    number: function(A) {
      return A > 0 ? o(A) : i(A);
    },
    "number, number | BigNumber": function(A, l) {
      return A > 0 ? o(A, l) : i(A, l);
    },
    Complex: function(A) {
      return new n(A.re > 0 ? Math.floor(A.re) : Math.ceil(A.re), A.im > 0 ? Math.floor(A.im) : Math.ceil(A.im));
    },
    "Complex, number | BigNumber": function(A, l) {
      return new n(A.re > 0 ? o(A.re, l) : i(A.re, l), A.im > 0 ? o(A.im, l) : i(A.im, l));
    },
    BigNumber: function(A) {
      return A.isNegative() ? i(A) : o(A);
    },
    "BigNumber, number | BigNumber": function(A, l) {
      return A.isNegative() ? i(A, l) : o(A, l);
    },
    Fraction: function(A) {
      return A.s < 0 ? A.ceil() : A.floor();
    },
    "Fraction, number | BigNumber": function(A, l) {
      return A.s < 0 ? A.ceil(l) : A.floor(l);
    },
    "Array | Matrix": function(A) {
      return ac(A, this);
    },
    "Array | Matrix, number | BigNumber": function(A, l) {
      return ac(A, (c) => this(c, l));
    },
    "number | Complex | BigNumber, Array": function(A, l) {
      return s(r(l), A, this, !0).valueOf();
    }
  });
}), iJn = "floor", oJn = ["typed", "config", "round", "matrix", "equalScalar"], sJn = /* @__PURE__ */ Ar(iJn, oJn, (t) => {
  var {
    typed: e,
    config: n,
    round: r,
    matrix: i,
    equalScalar: o
  } = t, s = VM({
    typed: e,
    equalScalar: o
  }), a = Nd({
    typed: e
  });
  return e("floor", {
    number: function(l) {
      return dd(l, r(l), n.epsilon) ? r(l) : Math.floor(l);
    },
    "number, number": function(l, c) {
      if (dd(l, r(l, c), n.epsilon))
        return r(l, c);
      var [u, f] = "".concat(l, "e").split("e"), h = Math.floor(Number("".concat(u, "e").concat(Number(f) + c)));
      return [u, f] = "".concat(h, "e").split("e"), Number("".concat(u, "e").concat(Number(f) - c));
    },
    Complex: function(l) {
      return l.floor();
    },
    "Complex, number": function(l, c) {
      return l.floor(c);
    },
    BigNumber: function(l) {
      return eE(l, r(l), n.epsilon) ? r(l) : l.floor();
    },
    "BigNumber, BigNumber": function(l, c) {
      return eE(l, r(l, c), n.epsilon) ? r(l, c) : l.toDecimalPlaces(c.toNumber(), ZC.ROUND_FLOOR);
    },
    Fraction: function(l) {
      return l.floor();
    },
    "Fraction, number": function(l, c) {
      return l.floor(c);
    },
    "Array | Matrix": function(l) {
      return ac(l, this);
    },
    "Array | Matrix, number": function(l, c) {
      return ac(l, (u) => this(u, c));
    },
    "SparseMatrix, number | BigNumber": function(l, c) {
      return s(l, c, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(l, c) {
      return a(l, c, this, !1);
    },
    "number | Complex | BigNumber, Array": function(l, c) {
      return a(i(c), l, this, !0).valueOf();
    }
  });
}), aJn = "algorithm01", AJn = ["typed"], lJn = /* @__PURE__ */ Ar(aJn, AJn, (t) => {
  var {
    typed: e
  } = t;
  return function(r, i, o, s) {
    var a = r._data, A = r._size, l = r._datatype, c = i._values, u = i._index, f = i._ptr, h = i._size, d = i._datatype;
    if (A.length !== h.length)
      throw new Qo(A.length, h.length);
    if (A[0] !== h[0] || A[1] !== h[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + A + ") must match Matrix B (" + h + ")");
    if (!c)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var I = A[0], m = A[1], C = typeof l == "string" && l === d ? l : void 0, y = C ? e.find(o, [C, C]) : o, v, b, Q = [];
    for (v = 0; v < I; v++)
      Q[v] = [];
    var w = [], R = [];
    for (b = 0; b < m; b++) {
      for (var M = b + 1, O = f[b], L = f[b + 1], N = O; N < L; N++)
        v = u[N], w[v] = s ? y(c[N], a[v][b]) : y(a[v][b], c[N]), R[v] = M;
      for (v = 0; v < I; v++)
        R[v] === M ? Q[v][b] = w[v] : Q[v][b] = a[v][b];
    }
    return r.createDenseMatrix({
      data: Q,
      size: [I, m],
      datatype: C
    });
  };
}), cJn = "algorithm10", uJn = ["typed", "DenseMatrix"], fJn = /* @__PURE__ */ Ar(cJn, uJn, (t) => {
  var {
    typed: e,
    DenseMatrix: n
  } = t;
  return function(i, o, s, a) {
    var A = i._values, l = i._index, c = i._ptr, u = i._size, f = i._datatype;
    if (!A)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var h = u[0], d = u[1], I, m = s;
    typeof f == "string" && (I = f, o = e.convert(o, I), m = e.find(s, [I, I]));
    for (var C = [], y = [], v = [], b = 0; b < d; b++) {
      for (var Q = b + 1, w = c[b], R = c[b + 1], M = w; M < R; M++) {
        var O = l[M];
        y[O] = A[M], v[O] = Q;
      }
      for (var L = 0; L < h; L++)
        b === 0 && (C[L] = []), v[L] === Q ? C[L][b] = a ? m(o, y[L]) : m(y[L], o) : C[L][b] = o;
    }
    return new n({
      data: C,
      size: [h, d],
      datatype: I
    });
  };
}), gJn = "algorithm13", hJn = ["typed"], JM = /* @__PURE__ */ Ar(gJn, hJn, (t) => {
  var {
    typed: e
  } = t;
  return function(i, o, s) {
    var a = i._data, A = i._size, l = i._datatype, c = o._data, u = o._size, f = o._datatype, h = [];
    if (A.length !== u.length)
      throw new Qo(A.length, u.length);
    for (var d = 0; d < A.length; d++) {
      if (A[d] !== u[d])
        throw new RangeError("Dimension mismatch. Matrix A (" + A + ") must match Matrix B (" + u + ")");
      h[d] = A[d];
    }
    var I, m = s;
    typeof l == "string" && l === f && (I = l, m = e.find(s, [I, I]));
    var C = h.length > 0 ? n(m, 0, h, h[0], a, c) : [];
    return i.createDenseMatrix({
      data: C,
      size: h,
      datatype: I
    });
  };
  function n(r, i, o, s, a, A) {
    var l = [];
    if (i === o.length - 1)
      for (var c = 0; c < s; c++)
        l[c] = r(a[c], A[c]);
    else
      for (var u = 0; u < s; u++)
        l[u] = n(r, i + 1, o, o[i + 1], a[u], A[u]);
    return l;
  }
}), dJn = "algorithm03", pJn = ["typed"], KM = /* @__PURE__ */ Ar(dJn, pJn, (t) => {
  var {
    typed: e
  } = t;
  return function(r, i, o, s) {
    var a = r._data, A = r._size, l = r._datatype, c = i._values, u = i._index, f = i._ptr, h = i._size, d = i._datatype;
    if (A.length !== h.length)
      throw new Qo(A.length, h.length);
    if (A[0] !== h[0] || A[1] !== h[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + A + ") must match Matrix B (" + h + ")");
    if (!c)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var I = A[0], m = A[1], C, y = 0, v = o;
    typeof l == "string" && l === d && (C = l, y = e.convert(0, C), v = e.find(o, [C, C]));
    for (var b = [], Q = 0; Q < I; Q++)
      b[Q] = [];
    for (var w = [], R = [], M = 0; M < m; M++) {
      for (var O = M + 1, L = f[M], N = f[M + 1], k = L; k < N; k++) {
        var $ = u[k];
        w[$] = s ? v(c[k], a[$][M]) : v(a[$][M], c[k]), R[$] = O;
      }
      for (var U = 0; U < I; U++)
        R[U] === O ? b[U][M] = w[U] : b[U][M] = s ? v(y, a[U][M]) : v(a[U][M], y);
    }
    return r.createDenseMatrix({
      data: b,
      size: [I, m],
      datatype: C
    });
  };
}), IJn = "algorithm05", mJn = ["typed", "equalScalar"], FWe = /* @__PURE__ */ Ar(IJn, mJn, (t) => {
  var {
    typed: e,
    equalScalar: n
  } = t;
  return function(i, o, s) {
    var a = i._values, A = i._index, l = i._ptr, c = i._size, u = i._datatype, f = o._values, h = o._index, d = o._ptr, I = o._size, m = o._datatype;
    if (c.length !== I.length)
      throw new Qo(c.length, I.length);
    if (c[0] !== I[0] || c[1] !== I[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + I + ")");
    var C = c[0], y = c[1], v, b = n, Q = 0, w = s;
    typeof u == "string" && u === m && (v = u, b = e.find(n, [v, v]), Q = e.convert(0, v), w = e.find(s, [v, v]));
    var R = a && f ? [] : void 0, M = [], O = [], L = R ? [] : void 0, N = R ? [] : void 0, k = [], $ = [], U, X, K, z;
    for (X = 0; X < y; X++) {
      O[X] = M.length;
      var Y = X + 1;
      for (K = l[X], z = l[X + 1]; K < z; K++)
        U = A[K], M.push(U), k[U] = Y, L && (L[U] = a[K]);
      for (K = d[X], z = d[X + 1]; K < z; K++)
        U = h[K], k[U] !== Y && M.push(U), $[U] = Y, N && (N[U] = f[K]);
      if (R)
        for (K = O[X]; K < M.length; ) {
          U = M[K];
          var V = k[U], Z = $[U];
          if (V === Y || Z === Y) {
            var ce = V === Y ? L[U] : Q, ee = Z === Y ? N[U] : Q, pe = w(ce, ee);
            b(pe, Q) ? M.splice(K, 1) : (R.push(pe), K++);
          }
        }
    }
    return O[y] = M.length, i.createSparseMatrix({
      values: R,
      index: M,
      ptr: O,
      size: [C, y],
      datatype: v
    });
  };
}), CJn = "algorithm12", EJn = ["typed", "DenseMatrix"], WM = /* @__PURE__ */ Ar(CJn, EJn, (t) => {
  var {
    typed: e,
    DenseMatrix: n
  } = t;
  return function(i, o, s, a) {
    var A = i._values, l = i._index, c = i._ptr, u = i._size, f = i._datatype;
    if (!A)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var h = u[0], d = u[1], I, m = s;
    typeof f == "string" && (I = f, o = e.convert(o, I), m = e.find(s, [I, I]));
    for (var C = [], y = [], v = [], b = 0; b < d; b++) {
      for (var Q = b + 1, w = c[b], R = c[b + 1], M = w; M < R; M++) {
        var O = l[M];
        y[O] = A[M], v[O] = Q;
      }
      for (var L = 0; L < h; L++)
        b === 0 && (C[L] = []), v[L] === Q ? C[L][b] = a ? m(o, y[L]) : m(y[L], o) : C[L][b] = a ? m(o, 0) : m(0, o);
    }
    return new n({
      data: C,
      size: [h, d],
      datatype: I
    });
  };
}), yJn = "multiplyScalar", vJn = ["typed"], BJn = /* @__PURE__ */ Ar(yJn, vJn, (t) => {
  var {
    typed: e
  } = t;
  return e("multiplyScalar", {
    "number, number": NWe,
    "Complex, Complex": function(r, i) {
      return r.mul(i);
    },
    "BigNumber, BigNumber": function(r, i) {
      return r.times(i);
    },
    "Fraction, Fraction": function(r, i) {
      return r.mul(i);
    },
    "number | Fraction | BigNumber | Complex, Unit": function(r, i) {
      var o = i.clone();
      return o.value = o.value === null ? o._normalize(r) : this(o.value, r), o;
    },
    "Unit, number | Fraction | BigNumber | Complex": function(r, i) {
      var o = r.clone();
      return o.value = o.value === null ? o._normalize(i) : this(o.value, i), o;
    },
    "Unit, Unit": function(r, i) {
      return r.multiply(i);
    }
  });
}), uTe = "multiply", bJn = ["typed", "matrix", "addScalar", "multiplyScalar", "equalScalar", "dot"], _Jn = /* @__PURE__ */ Ar(uTe, bJn, (t) => {
  var {
    typed: e,
    matrix: n,
    addScalar: r,
    multiplyScalar: i,
    equalScalar: o,
    dot: s
  } = t, a = VM({
    typed: e,
    equalScalar: o
  }), A = Nd({
    typed: e
  });
  function l(Q, w) {
    switch (Q.length) {
      case 1:
        switch (w.length) {
          case 1:
            if (Q[0] !== w[0])
              throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
            break;
          case 2:
            if (Q[0] !== w[0])
              throw new RangeError("Dimension mismatch in multiplication. Vector length (" + Q[0] + ") must match Matrix rows (" + w[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + w.length + " dimensions)");
        }
        break;
      case 2:
        switch (w.length) {
          case 1:
            if (Q[1] !== w[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + Q[1] + ") must match Vector length (" + w[0] + ")");
            break;
          case 2:
            if (Q[1] !== w[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + Q[1] + ") must match Matrix B rows (" + w[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + w.length + " dimensions)");
        }
        break;
      default:
        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + Q.length + " dimensions)");
    }
  }
  function c(Q, w, R) {
    if (R === 0)
      throw new Error("Cannot multiply two empty vectors");
    return s(Q, w);
  }
  function u(Q, w) {
    if (w.storage() !== "dense")
      throw new Error("Support for SparseMatrix not implemented");
    return f(Q, w);
  }
  function f(Q, w) {
    var R = Q._data, M = Q._size, O = Q._datatype, L = w._data, N = w._size, k = w._datatype, $ = M[0], U = N[1], X, K = r, z = i;
    O && k && O === k && typeof O == "string" && (X = O, K = e.find(r, [X, X]), z = e.find(i, [X, X]));
    for (var Y = [], V = 0; V < U; V++) {
      for (var Z = z(R[0], L[0][V]), ce = 1; ce < $; ce++)
        Z = K(Z, z(R[ce], L[ce][V]));
      Y[V] = Z;
    }
    return Q.createDenseMatrix({
      data: Y,
      size: [U],
      datatype: X
    });
  }
  var h = e("_multiplyMatrixVector", {
    "DenseMatrix, any": I,
    "SparseMatrix, any": y
  }), d = e("_multiplyMatrixMatrix", {
    "DenseMatrix, DenseMatrix": m,
    "DenseMatrix, SparseMatrix": C,
    "SparseMatrix, DenseMatrix": v,
    "SparseMatrix, SparseMatrix": b
  });
  function I(Q, w) {
    var R = Q._data, M = Q._size, O = Q._datatype, L = w._data, N = w._datatype, k = M[0], $ = M[1], U, X = r, K = i;
    O && N && O === N && typeof O == "string" && (U = O, X = e.find(r, [U, U]), K = e.find(i, [U, U]));
    for (var z = [], Y = 0; Y < k; Y++) {
      for (var V = R[Y], Z = K(V[0], L[0]), ce = 1; ce < $; ce++)
        Z = X(Z, K(V[ce], L[ce]));
      z[Y] = Z;
    }
    return Q.createDenseMatrix({
      data: z,
      size: [k],
      datatype: U
    });
  }
  function m(Q, w) {
    var R = Q._data, M = Q._size, O = Q._datatype, L = w._data, N = w._size, k = w._datatype, $ = M[0], U = M[1], X = N[1], K, z = r, Y = i;
    O && k && O === k && typeof O == "string" && (K = O, z = e.find(r, [K, K]), Y = e.find(i, [K, K]));
    for (var V = [], Z = 0; Z < $; Z++) {
      var ce = R[Z];
      V[Z] = [];
      for (var ee = 0; ee < X; ee++) {
        for (var pe = Y(ce[0], L[0][ee]), Ce = 1; Ce < U; Ce++)
          pe = z(pe, Y(ce[Ce], L[Ce][ee]));
        V[Z][ee] = pe;
      }
    }
    return Q.createDenseMatrix({
      data: V,
      size: [$, X],
      datatype: K
    });
  }
  function C(Q, w) {
    var R = Q._data, M = Q._size, O = Q._datatype, L = w._values, N = w._index, k = w._ptr, $ = w._size, U = w._datatype;
    if (!L)
      throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
    var X = M[0], K = $[1], z, Y = r, V = i, Z = o, ce = 0;
    O && U && O === U && typeof O == "string" && (z = O, Y = e.find(r, [z, z]), V = e.find(i, [z, z]), Z = e.find(o, [z, z]), ce = e.convert(0, z));
    for (var ee = [], pe = [], Ce = [], Be = w.createSparseMatrix({
      values: ee,
      index: pe,
      ptr: Ce,
      size: [X, K],
      datatype: z
    }), Ie = 0; Ie < K; Ie++) {
      Ce[Ie] = pe.length;
      var Qe = k[Ie], xe = k[Ie + 1];
      if (xe > Qe)
        for (var Se = 0, De = 0; De < X; De++) {
          for (var Ue = De + 1, Te = void 0, se = Qe; se < xe; se++) {
            var fe = N[se];
            Se !== Ue ? (Te = V(R[De][fe], L[se]), Se = Ue) : Te = Y(Te, V(R[De][fe], L[se]));
          }
          Se === Ue && !Z(Te, ce) && (pe.push(De), ee.push(Te));
        }
    }
    return Ce[K] = pe.length, Be;
  }
  function y(Q, w) {
    var R = Q._values, M = Q._index, O = Q._ptr, L = Q._datatype;
    if (!R)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var N = w._data, k = w._datatype, $ = Q._size[0], U = w._size[0], X = [], K = [], z = [], Y, V = r, Z = i, ce = o, ee = 0;
    L && k && L === k && typeof L == "string" && (Y = L, V = e.find(r, [Y, Y]), Z = e.find(i, [Y, Y]), ce = e.find(o, [Y, Y]), ee = e.convert(0, Y));
    var pe = [], Ce = [];
    z[0] = 0;
    for (var Be = 0; Be < U; Be++) {
      var Ie = N[Be];
      if (!ce(Ie, ee))
        for (var Qe = O[Be], xe = O[Be + 1], Se = Qe; Se < xe; Se++) {
          var De = M[Se];
          Ce[De] ? pe[De] = V(pe[De], Z(Ie, R[Se])) : (Ce[De] = !0, K.push(De), pe[De] = Z(Ie, R[Se]));
        }
    }
    for (var Ue = K.length, Te = 0; Te < Ue; Te++) {
      var se = K[Te];
      X[Te] = pe[se];
    }
    return z[1] = K.length, Q.createSparseMatrix({
      values: X,
      index: K,
      ptr: z,
      size: [$, 1],
      datatype: Y
    });
  }
  function v(Q, w) {
    var R = Q._values, M = Q._index, O = Q._ptr, L = Q._datatype;
    if (!R)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var N = w._data, k = w._datatype, $ = Q._size[0], U = w._size[0], X = w._size[1], K, z = r, Y = i, V = o, Z = 0;
    L && k && L === k && typeof L == "string" && (K = L, z = e.find(r, [K, K]), Y = e.find(i, [K, K]), V = e.find(o, [K, K]), Z = e.convert(0, K));
    for (var ce = [], ee = [], pe = [], Ce = Q.createSparseMatrix({
      values: ce,
      index: ee,
      ptr: pe,
      size: [$, X],
      datatype: K
    }), Be = [], Ie = [], Qe = 0; Qe < X; Qe++) {
      pe[Qe] = ee.length;
      for (var xe = Qe + 1, Se = 0; Se < U; Se++) {
        var De = N[Se][Qe];
        if (!V(De, Z))
          for (var Ue = O[Se], Te = O[Se + 1], se = Ue; se < Te; se++) {
            var fe = M[se];
            Ie[fe] !== xe ? (Ie[fe] = xe, ee.push(fe), Be[fe] = Y(De, R[se])) : Be[fe] = z(Be[fe], Y(De, R[se]));
          }
      }
      for (var W = pe[Qe], ge = ee.length, _e = W; _e < ge; _e++) {
        var Re = ee[_e];
        ce[_e] = Be[Re];
      }
    }
    return pe[X] = ee.length, Ce;
  }
  function b(Q, w) {
    var R = Q._values, M = Q._index, O = Q._ptr, L = Q._datatype, N = w._values, k = w._index, $ = w._ptr, U = w._datatype, X = Q._size[0], K = w._size[1], z = R && N, Y, V = r, Z = i;
    L && U && L === U && typeof L == "string" && (Y = L, V = e.find(r, [Y, Y]), Z = e.find(i, [Y, Y]));
    for (var ce = z ? [] : void 0, ee = [], pe = [], Ce = Q.createSparseMatrix({
      values: ce,
      index: ee,
      ptr: pe,
      size: [X, K],
      datatype: Y
    }), Be = z ? [] : void 0, Ie = [], Qe, xe, Se, De, Ue, Te, se, fe, W = 0; W < K; W++) {
      pe[W] = ee.length;
      var ge = W + 1;
      for (Ue = $[W], Te = $[W + 1], De = Ue; De < Te; De++)
        if (fe = k[De], z)
          for (xe = O[fe], Se = O[fe + 1], Qe = xe; Qe < Se; Qe++)
            se = M[Qe], Ie[se] !== ge ? (Ie[se] = ge, ee.push(se), Be[se] = Z(N[De], R[Qe])) : Be[se] = V(Be[se], Z(N[De], R[Qe]));
        else
          for (xe = O[fe], Se = O[fe + 1], Qe = xe; Qe < Se; Qe++)
            se = M[Qe], Ie[se] !== ge && (Ie[se] = ge, ee.push(se));
      if (z)
        for (var _e = pe[W], Re = ee.length, Ee = _e; Ee < Re; Ee++) {
          var oe = ee[Ee];
          ce[Ee] = Be[oe];
        }
    }
    return pe[K] = ee.length, Ce;
  }
  return e(uTe, sWe({
    // we extend the signatures of multiplyScalar with signatures dealing with matrices
    "Array, Array": function(w, R) {
      l(PI(w), PI(R));
      var M = this(n(w), n(R));
      return cA(M) ? M.valueOf() : M;
    },
    "Matrix, Matrix": function(w, R) {
      var M = w.size(), O = R.size();
      return l(M, O), M.length === 1 ? O.length === 1 ? c(w, R, M[0]) : u(w, R) : O.length === 1 ? h(w, R) : d(w, R);
    },
    "Matrix, Array": function(w, R) {
      return this(w, n(R));
    },
    "Array, Matrix": function(w, R) {
      return this(n(w, R.storage()), R);
    },
    "SparseMatrix, any": function(w, R) {
      return a(w, R, i, !1);
    },
    "DenseMatrix, any": function(w, R) {
      return A(w, R, i, !1);
    },
    "any, SparseMatrix": function(w, R) {
      return a(R, w, i, !0);
    },
    "any, DenseMatrix": function(w, R) {
      return A(R, w, i, !0);
    },
    "Array, any": function(w, R) {
      return A(n(w), R, i, !1).valueOf();
    },
    "any, Array": function(w, R) {
      return A(n(R), w, i, !0).valueOf();
    },
    "any, any": i,
    "any, any, ...any": function(w, R, M) {
      for (var O = this(w, R), L = 0; L < M.length; L++)
        O = this(O, M[L]);
      return O;
    }
  }, i.signatures));
}), fTe = "subtract", SJn = ["typed", "matrix", "equalScalar", "addScalar", "unaryMinus", "DenseMatrix"], QJn = /* @__PURE__ */ Ar(fTe, SJn, (t) => {
  var {
    typed: e,
    matrix: n,
    equalScalar: r,
    addScalar: i,
    unaryMinus: o,
    DenseMatrix: s
  } = t, a = lJn({
    typed: e
  }), A = KM({
    typed: e
  }), l = FWe({
    typed: e,
    equalScalar: r
  }), c = fJn({
    typed: e,
    DenseMatrix: s
  }), u = JM({
    typed: e
  }), f = Nd({
    typed: e
  });
  return e(fTe, {
    "number, number": function(d, I) {
      return d - I;
    },
    "Complex, Complex": function(d, I) {
      return d.sub(I);
    },
    "BigNumber, BigNumber": function(d, I) {
      return d.minus(I);
    },
    "Fraction, Fraction": function(d, I) {
      return d.sub(I);
    },
    "Unit, Unit": function(d, I) {
      if (d.value === null)
        throw new Error("Parameter x contains a unit with undefined value");
      if (I.value === null)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!d.equalBase(I))
        throw new Error("Units do not match");
      var m = d.clone();
      return m.value = this(m.value, I.value), m.fixPrefix = !1, m;
    },
    "SparseMatrix, SparseMatrix": function(d, I) {
      return a3(d, I), l(d, I, this);
    },
    "SparseMatrix, DenseMatrix": function(d, I) {
      return a3(d, I), A(I, d, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(d, I) {
      return a3(d, I), a(d, I, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(d, I) {
      return a3(d, I), u(d, I, this);
    },
    "Array, Array": function(d, I) {
      return this(n(d), n(I)).valueOf();
    },
    "Array, Matrix": function(d, I) {
      return this(n(d), I);
    },
    "Matrix, Array": function(d, I) {
      return this(d, n(I));
    },
    "SparseMatrix, any": function(d, I) {
      return c(d, o(I), i);
    },
    "DenseMatrix, any": function(d, I) {
      return f(d, I, this);
    },
    "any, SparseMatrix": function(d, I) {
      return c(I, d, this, !0);
    },
    "any, DenseMatrix": function(d, I) {
      return f(I, d, this, !0);
    },
    "Array, any": function(d, I) {
      return f(n(d), I, this, !1).valueOf();
    },
    "any, Array": function(d, I) {
      return f(n(I), d, this, !0).valueOf();
    }
  });
});
function a3(t, e) {
  var n = t.size(), r = e.size();
  if (n.length !== r.length)
    throw new Qo(n.length, r.length);
}
var wJn = "algorithm07", xJn = ["typed", "DenseMatrix"], Ffe = /* @__PURE__ */ Ar(wJn, xJn, (t) => {
  var {
    typed: e,
    DenseMatrix: n
  } = t;
  return function(o, s, a) {
    var A = o._size, l = o._datatype, c = s._size, u = s._datatype;
    if (A.length !== c.length)
      throw new Qo(A.length, c.length);
    if (A[0] !== c[0] || A[1] !== c[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + A + ") must match Matrix B (" + c + ")");
    var f = A[0], h = A[1], d, I = 0, m = a;
    typeof l == "string" && l === u && (d = l, I = e.convert(0, d), m = e.find(a, [d, d]));
    var C, y, v = [];
    for (C = 0; C < f; C++)
      v[C] = [];
    var b = [], Q = [], w = [], R = [];
    for (y = 0; y < h; y++) {
      var M = y + 1;
      for (r(o, y, w, b, M), r(s, y, R, Q, M), C = 0; C < f; C++) {
        var O = w[C] === M ? b[C] : I, L = R[C] === M ? Q[C] : I;
        v[C][y] = m(O, L);
      }
    }
    return new n({
      data: v,
      size: [f, h],
      datatype: d
    });
  };
  function r(i, o, s, a, A) {
    for (var l = i._values, c = i._index, u = i._ptr, f = u[o], h = u[o + 1]; f < h; f++) {
      var d = c[f];
      s[d] = A, a[d] = l[f];
    }
  }
}), gTe = "conj", RJn = ["typed"], DJn = /* @__PURE__ */ Ar(gTe, RJn, (t) => {
  var {
    typed: e
  } = t;
  return e(gTe, {
    number: function(r) {
      return r;
    },
    BigNumber: function(r) {
      return r;
    },
    Complex: function(r) {
      return r.conjugate();
    },
    "Array | Matrix": function(r) {
      return ac(r, this);
    }
  });
});
function TJn(t) {
  var e = 0, n = 1, r = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null), o = 0, s = function(A) {
    var l = i[A];
    if (l && (delete r[l], delete i[A], --e, n === l)) {
      if (!e) {
        o = 0, n = 1;
        return;
      }
      for (; !hasOwnProperty.call(r, ++n); )
        ;
    }
  };
  return t = Math.abs(t), {
    hit: function(A) {
      var l = i[A], c = ++o;
      if (r[c] = A, i[A] = c, !l)
        return ++e, e <= t ? void 0 : (A = r[n], s(A), A);
      if (delete r[l], n === l)
        for (; !hasOwnProperty.call(r, ++n); )
          ;
    },
    delete: s,
    clear: function() {
      e = o = 0, n = 1, r = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null);
    }
  };
}
function XM(t) {
  var {
    hasher: e,
    limit: n
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return n = n ?? Number.POSITIVE_INFINITY, e = e ?? JSON.stringify, function r() {
    typeof r.cache != "object" && (r.cache = {
      values: /* @__PURE__ */ new Map(),
      lru: TJn(n || Number.POSITIVE_INFINITY)
    });
    for (var i = [], o = 0; o < arguments.length; o++)
      i[o] = arguments[o];
    var s = e(i);
    if (r.cache.values.has(s))
      return r.cache.lru.hit(s), r.cache.values.get(s);
    var a = t.apply(t, i);
    return r.cache.values.set(s, a), r.cache.values.delete(r.cache.lru.hit(s)), a;
  };
}
var hTe = "identity", NJn = ["typed", "config", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix"], LJn = /* @__PURE__ */ Ar(hTe, NJn, (t) => {
  var {
    typed: e,
    config: n,
    matrix: r,
    BigNumber: i,
    DenseMatrix: o,
    SparseMatrix: s
  } = t;
  return e(hTe, {
    "": function() {
      return n.matrix === "Matrix" ? r([]) : [];
    },
    string: function(c) {
      return r(c);
    },
    "number | BigNumber": function(c) {
      return A(c, c, n.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, string": function(c, u) {
      return A(c, c, u);
    },
    "number | BigNumber, number | BigNumber": function(c, u) {
      return A(c, u, n.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, number | BigNumber, string": function(c, u, f) {
      return A(c, u, f);
    },
    Array: function(c) {
      return a(c);
    },
    "Array, string": function(c, u) {
      return a(c, u);
    },
    Matrix: function(c) {
      return a(c.valueOf(), c.storage());
    },
    "Matrix, string": function(c, u) {
      return a(c.valueOf(), u);
    }
  });
  function a(l, c) {
    switch (l.length) {
      case 0:
        return c ? r(c) : [];
      case 1:
        return A(l[0], l[0], c);
      case 2:
        return A(l[0], l[1], c);
      default:
        throw new Error("Vector containing two values expected");
    }
  }
  function A(l, c, u) {
    var f = Jl(l) || Jl(c) ? i : null;
    if (Jl(l) && (l = l.toNumber()), Jl(c) && (c = c.toNumber()), !Ts(l) || l < 1)
      throw new Error("Parameters in function identity must be positive integers");
    if (!Ts(c) || c < 1)
      throw new Error("Parameters in function identity must be positive integers");
    var h = f ? new i(1) : 1, d = f ? new f(0) : 0, I = [l, c];
    if (u) {
      if (u === "sparse")
        return s.diagonal(I, h, 0, d);
      if (u === "dense")
        return o.diagonal(I, h, 0, d);
      throw new TypeError('Unknown matrix type "'.concat(u, '"'));
    }
    for (var m = e5([], I, d), C = l < c ? l : c, y = 0; y < C; y++)
      m[y][y] = h;
    return m;
  }
});
function MJn() {
  throw new Error('No "bignumber" implementation available');
}
function OJn() {
  throw new Error('No "fraction" implementation available');
}
function FJn() {
  throw new Error('No "matrix" implementation available');
}
var dTe = "size", PJn = ["typed", "config", "?matrix"], kJn = /* @__PURE__ */ Ar(dTe, PJn, (t) => {
  var {
    typed: e,
    config: n,
    matrix: r
  } = t;
  return e(dTe, {
    Matrix: function(o) {
      return o.create(o.size());
    },
    Array: PI,
    string: function(o) {
      return n.matrix === "Array" ? [o.length] : r([o.length]);
    },
    "number | Complex | BigNumber | Unit | boolean | null": function(o) {
      return n.matrix === "Array" ? [] : r ? r([]) : FJn();
    }
  });
}), pTe = "zeros", GJn = ["typed", "config", "matrix", "BigNumber"], UJn = /* @__PURE__ */ Ar(pTe, GJn, (t) => {
  var {
    typed: e,
    config: n,
    matrix: r,
    BigNumber: i
  } = t;
  return e(pTe, {
    "": function() {
      return n.matrix === "Array" ? o([]) : o([], "default");
    },
    // math.zeros(m, n, p, ..., format)
    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
    "...number | BigNumber | string": function(l) {
      var c = l[l.length - 1];
      if (typeof c == "string") {
        var u = l.pop();
        return o(l, u);
      } else
        return n.matrix === "Array" ? o(l) : o(l, "default");
    },
    Array: o,
    Matrix: function(l) {
      var c = l.storage();
      return o(l.valueOf(), c);
    },
    "Array | Matrix, string": function(l, c) {
      return o(l.valueOf(), c);
    }
  });
  function o(A, l) {
    var c = s(A), u = c ? new i(0) : 0;
    if (a(A), l) {
      var f = r(l);
      return A.length > 0 ? f.resize(A, u) : f;
    } else {
      var h = [];
      return A.length > 0 ? e5(h, A, u) : h;
    }
  }
  function s(A) {
    var l = !1;
    return A.forEach(function(c, u, f) {
      Jl(c) && (l = !0, f[u] = c.toNumber());
    }), l;
  }
  function a(A) {
    A.forEach(function(l) {
      if (typeof l != "number" || !Ts(l) || l < 0)
        throw new Error("Parameters in function zeros must be positive integers");
    });
  }
}), ITe = "format", HJn = ["typed"], $Jn = /* @__PURE__ */ Ar(ITe, HJn, (t) => {
  var {
    typed: e
  } = t;
  return e(ITe, {
    any: ua,
    "any, Object | function | number": ua
  });
}), qJn = "numeric", jJn = ["number", "?bignumber", "?fraction"], YJn = /* @__PURE__ */ Ar(qJn, jJn, (t) => {
  var {
    number: e,
    bignumber: n,
    fraction: r
  } = t, i = {
    string: !0,
    number: !0,
    BigNumber: !0,
    Fraction: !0
  }, o = {
    number: (s) => e(s),
    BigNumber: n ? (s) => n(s) : MJn,
    Fraction: r ? (s) => r(s) : OJn
  };
  return function(a, A) {
    var l = Sg(a);
    if (!(l in i))
      throw new TypeError("Cannot convert " + a + ' of type "' + l + '"; valid input types are ' + Object.keys(i).join(", "));
    if (!(A in o))
      throw new TypeError("Cannot convert " + a + ' to type "' + A + '"; valid output types are ' + Object.keys(o).join(", "));
    return A === l ? a : o[A](a);
  };
}), mTe = "divideScalar", zJn = ["typed", "numeric"], VJn = /* @__PURE__ */ Ar(mTe, zJn, (t) => {
  var {
    typed: e,
    numeric: n
  } = t;
  return e(mTe, {
    "number, number": function(i, o) {
      return i / o;
    },
    "Complex, Complex": function(i, o) {
      return i.div(o);
    },
    "BigNumber, BigNumber": function(i, o) {
      return i.div(o);
    },
    "Fraction, Fraction": function(i, o) {
      return i.div(o);
    },
    "Unit, number | Fraction | BigNumber": function(i, o) {
      var s = i.clone(), a = n(1, Sg(o));
      return s.value = this(s.value === null ? s._normalize(a) : s.value, o), s;
    },
    "number | Fraction | BigNumber, Unit": function(i, o) {
      var s = o.clone();
      s = s.pow(-1);
      var a = n(1, Sg(i));
      return s.value = this(i, o.value === null ? o._normalize(a) : o.value), s;
    },
    "Unit, Unit": function(i, o) {
      return i.divide(o);
    }
  });
}), CTe = "pow", JJn = ["typed", "config", "identity", "multiply", "matrix", "fraction", "number", "Complex"], KJn = /* @__PURE__ */ Ar(CTe, JJn, (t) => {
  var {
    typed: e,
    config: n,
    identity: r,
    multiply: i,
    matrix: o,
    number: s,
    fraction: a,
    Complex: A
  } = t;
  return e(CTe, {
    "number, number": l,
    "Complex, Complex": function(h, d) {
      return h.pow(d);
    },
    "BigNumber, BigNumber": function(h, d) {
      return d.isInteger() || h >= 0 || n.predictable ? h.pow(d) : new A(h.toNumber(), 0).pow(d.toNumber(), 0);
    },
    "Fraction, Fraction": function(h, d) {
      var I = h.pow(d);
      if (I != null)
        return I;
      if (n.predictable)
        throw new Error("Result of pow is non-rational and cannot be expressed as a fraction");
      return l(h.valueOf(), d.valueOf());
    },
    "Array, number": c,
    "Array, BigNumber": function(h, d) {
      return c(h, d.toNumber());
    },
    "Matrix, number": u,
    "Matrix, BigNumber": function(h, d) {
      return u(h, d.toNumber());
    },
    "Unit, number | BigNumber": function(h, d) {
      return h.pow(d);
    }
  });
  function l(f, h) {
    if (n.predictable && !Ts(h) && f < 0)
      try {
        var d = a(h), I = s(d);
        if ((h === I || Math.abs((h - I) / h) < 1e-14) && d.d % 2 === 1)
          return (d.n % 2 === 0 ? 1 : -1) * Math.pow(-f, h);
      } catch {
      }
    return n.predictable && (f < -1 && h === 1 / 0 || f > -1 && f < 0 && h === -1 / 0) ? NaN : Ts(h) || f >= 0 || n.predictable ? OWe(f, h) : f * f < 1 && h === 1 / 0 || f * f > 1 && h === -1 / 0 ? 0 : new A(f, 0).pow(h, 0);
  }
  function c(f, h) {
    if (!Ts(h) || h < 0)
      throw new TypeError("For A^b, b must be a positive integer (value is " + h + ")");
    var d = PI(f);
    if (d.length !== 2)
      throw new Error("For A^b, A must be 2 dimensional (A has " + d.length + " dimensions)");
    if (d[0] !== d[1])
      throw new Error("For A^b, A must be square (size is " + d[0] + "x" + d[1] + ")");
    for (var I = r(d[0]).valueOf(), m = f; h >= 1; )
      (h & 1) === 1 && (I = i(m, I)), h >>= 1, m = i(m, m);
    return I;
  }
  function u(f, h) {
    return o(c(f.valueOf(), h));
  }
});
function ETe(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function yTe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ETe(Object(n), !0).forEach(function(r) {
      mo(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ETe(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
var n_ = "Number of decimals in function round must be an integer", vTe = "round", WJn = ["typed", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix"], XJn = /* @__PURE__ */ Ar(vTe, WJn, (t) => {
  var {
    typed: e,
    matrix: n,
    equalScalar: r,
    zeros: i,
    BigNumber: o,
    DenseMatrix: s
  } = t, a = VM({
    typed: e,
    equalScalar: r
  }), A = WM({
    typed: e,
    DenseMatrix: s
  }), l = Nd({
    typed: e
  });
  return e(vTe, yTe(yTe({}, ZJn), {}, {
    Complex: function(u) {
      return u.round();
    },
    "Complex, number": function(u, f) {
      if (f % 1)
        throw new TypeError(n_);
      return u.round(f);
    },
    "Complex, BigNumber": function(u, f) {
      if (!f.isInteger())
        throw new TypeError(n_);
      var h = f.toNumber();
      return u.round(h);
    },
    "number, BigNumber": function(u, f) {
      if (!f.isInteger())
        throw new TypeError(n_);
      return new o(u).toDecimalPlaces(f.toNumber());
    },
    BigNumber: function(u) {
      return u.toDecimalPlaces(0);
    },
    "BigNumber, BigNumber": function(u, f) {
      if (!f.isInteger())
        throw new TypeError(n_);
      return u.toDecimalPlaces(f.toNumber());
    },
    Fraction: function(u) {
      return u.round();
    },
    "Fraction, number": function(u, f) {
      if (f % 1)
        throw new TypeError(n_);
      return u.round(f);
    },
    "Array | Matrix": function(u) {
      return ac(u, this);
    },
    "SparseMatrix, number | BigNumber": function(u, f) {
      return a(u, f, this, !1);
    },
    "DenseMatrix, number | BigNumber": function(u, f) {
      return l(u, f, this, !1);
    },
    "number | Complex | BigNumber, SparseMatrix": function(u, f) {
      return r(u, 0) ? i(f.size(), f.storage()) : A(f, u, this, !0);
    },
    "number | Complex | BigNumber, DenseMatrix": function(u, f) {
      return r(u, 0) ? i(f.size(), f.storage()) : l(f, u, this, !0);
    },
    "Array, number | BigNumber": function(u, f) {
      return l(n(u), f, this, !1).valueOf();
    },
    "number | Complex | BigNumber, Array": function(u, f) {
      return l(n(f), u, this, !0).valueOf();
    }
  }));
}), ZJn = {
  number: bre,
  "number, number": function(e, n) {
    if (!Ts(n))
      throw new TypeError(n_);
    if (n < 0 || n > 15)
      throw new Error("Number of decimals in function round must be in the range of 0-15");
    return bre(e, n);
  }
}, BTe = "compare", eKn = ["typed", "config", "matrix", "equalScalar", "BigNumber", "Fraction", "DenseMatrix"], tKn = /* @__PURE__ */ Ar(BTe, eKn, (t) => {
  var {
    typed: e,
    config: n,
    equalScalar: r,
    matrix: i,
    BigNumber: o,
    Fraction: s,
    DenseMatrix: a
  } = t, A = KM({
    typed: e
  }), l = FWe({
    typed: e,
    equalScalar: r
  }), c = WM({
    typed: e,
    DenseMatrix: a
  }), u = JM({
    typed: e
  }), f = Nd({
    typed: e
  });
  return e(BTe, {
    "boolean, boolean": function(d, I) {
      return d === I ? 0 : d > I ? 1 : -1;
    },
    "number, number": function(d, I) {
      return dd(d, I, n.epsilon) ? 0 : d > I ? 1 : -1;
    },
    "BigNumber, BigNumber": function(d, I) {
      return eE(d, I, n.epsilon) ? new o(0) : new o(d.cmp(I));
    },
    "Fraction, Fraction": function(d, I) {
      return new s(d.compare(I));
    },
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    },
    "Unit, Unit": function(d, I) {
      if (!d.equalBase(I))
        throw new Error("Cannot compare units with different base");
      return this(d.value, I.value);
    },
    "SparseMatrix, SparseMatrix": function(d, I) {
      return l(d, I, this);
    },
    "SparseMatrix, DenseMatrix": function(d, I) {
      return A(I, d, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(d, I) {
      return A(d, I, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(d, I) {
      return u(d, I, this);
    },
    "Array, Array": function(d, I) {
      return this(i(d), i(I)).valueOf();
    },
    "Array, Matrix": function(d, I) {
      return this(i(d), I);
    },
    "Matrix, Array": function(d, I) {
      return this(d, i(I));
    },
    "SparseMatrix, any": function(d, I) {
      return c(d, I, this, !1);
    },
    "DenseMatrix, any": function(d, I) {
      return f(d, I, this, !1);
    },
    "any, SparseMatrix": function(d, I) {
      return c(I, d, this, !0);
    },
    "any, DenseMatrix": function(d, I) {
      return f(I, d, this, !0);
    },
    "Array, any": function(d, I) {
      return f(i(d), I, this, !1).valueOf();
    },
    "any, Array": function(d, I) {
      return f(i(I), d, this, !0).valueOf();
    }
  });
}), s5 = "equal", nKn = ["typed", "matrix", "equalScalar", "DenseMatrix"], rKn = /* @__PURE__ */ Ar(s5, nKn, (t) => {
  var {
    typed: e,
    matrix: n,
    equalScalar: r,
    DenseMatrix: i
  } = t, o = KM({
    typed: e
  }), s = Ffe({
    typed: e,
    DenseMatrix: i
  }), a = WM({
    typed: e,
    DenseMatrix: i
  }), A = JM({
    typed: e
  }), l = Nd({
    typed: e
  });
  return e(s5, {
    "any, any": function(u, f) {
      return u === null ? f === null : f === null ? u === null : u === void 0 ? f === void 0 : f === void 0 ? u === void 0 : r(u, f);
    },
    "SparseMatrix, SparseMatrix": function(u, f) {
      return s(u, f, r);
    },
    "SparseMatrix, DenseMatrix": function(u, f) {
      return o(f, u, r, !0);
    },
    "DenseMatrix, SparseMatrix": function(u, f) {
      return o(u, f, r, !1);
    },
    "DenseMatrix, DenseMatrix": function(u, f) {
      return A(u, f, r);
    },
    "Array, Array": function(u, f) {
      return this(n(u), n(f)).valueOf();
    },
    "Array, Matrix": function(u, f) {
      return this(n(u), f);
    },
    "Matrix, Array": function(u, f) {
      return this(u, n(f));
    },
    "SparseMatrix, any": function(u, f) {
      return a(u, f, r, !1);
    },
    "DenseMatrix, any": function(u, f) {
      return l(u, f, r, !1);
    },
    "any, SparseMatrix": function(u, f) {
      return a(f, u, r, !0);
    },
    "any, DenseMatrix": function(u, f) {
      return l(f, u, r, !0);
    },
    "Array, any": function(u, f) {
      return l(n(u), f, r, !1).valueOf();
    },
    "any, Array": function(u, f) {
      return l(n(f), u, r, !0).valueOf();
    }
  });
});
Ar(s5, ["typed", "equalScalar"], (t) => {
  var {
    typed: e,
    equalScalar: n
  } = t;
  return e(s5, {
    "any, any": function(i, o) {
      return i === null ? o === null : o === null ? i === null : i === void 0 ? o === void 0 : o === void 0 ? i === void 0 : n(i, o);
    }
  });
});
var bTe = "smaller", iKn = ["typed", "config", "matrix", "DenseMatrix"], oKn = /* @__PURE__ */ Ar(bTe, iKn, (t) => {
  var {
    typed: e,
    config: n,
    matrix: r,
    DenseMatrix: i
  } = t, o = KM({
    typed: e
  }), s = Ffe({
    typed: e,
    DenseMatrix: i
  }), a = WM({
    typed: e,
    DenseMatrix: i
  }), A = JM({
    typed: e
  }), l = Nd({
    typed: e
  });
  return e(bTe, {
    "boolean, boolean": function(u, f) {
      return u < f;
    },
    "number, number": function(u, f) {
      return u < f && !dd(u, f, n.epsilon);
    },
    "BigNumber, BigNumber": function(u, f) {
      return u.lt(f) && !eE(u, f, n.epsilon);
    },
    "Fraction, Fraction": function(u, f) {
      return u.compare(f) === -1;
    },
    "Complex, Complex": function(u, f) {
      throw new TypeError("No ordering relation is defined for complex numbers");
    },
    "Unit, Unit": function(u, f) {
      if (!u.equalBase(f))
        throw new Error("Cannot compare units with different base");
      return this(u.value, f.value);
    },
    "SparseMatrix, SparseMatrix": function(u, f) {
      return s(u, f, this);
    },
    "SparseMatrix, DenseMatrix": function(u, f) {
      return o(f, u, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(u, f) {
      return o(u, f, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(u, f) {
      return A(u, f, this);
    },
    "Array, Array": function(u, f) {
      return this(r(u), r(f)).valueOf();
    },
    "Array, Matrix": function(u, f) {
      return this(r(u), f);
    },
    "Matrix, Array": function(u, f) {
      return this(u, r(f));
    },
    "SparseMatrix, any": function(u, f) {
      return a(u, f, this, !1);
    },
    "DenseMatrix, any": function(u, f) {
      return l(u, f, this, !1);
    },
    "any, SparseMatrix": function(u, f) {
      return a(f, u, this, !0);
    },
    "any, DenseMatrix": function(u, f) {
      return l(f, u, this, !0);
    },
    "Array, any": function(u, f) {
      return l(r(u), f, this, !1).valueOf();
    },
    "any, Array": function(u, f) {
      return l(r(f), u, this, !0).valueOf();
    }
  });
}), _Te = "larger", sKn = ["typed", "config", "matrix", "DenseMatrix"], aKn = /* @__PURE__ */ Ar(_Te, sKn, (t) => {
  var {
    typed: e,
    config: n,
    matrix: r,
    DenseMatrix: i
  } = t, o = KM({
    typed: e
  }), s = Ffe({
    typed: e,
    DenseMatrix: i
  }), a = WM({
    typed: e,
    DenseMatrix: i
  }), A = JM({
    typed: e
  }), l = Nd({
    typed: e
  });
  return e(_Te, {
    "boolean, boolean": function(u, f) {
      return u > f;
    },
    "number, number": function(u, f) {
      return u > f && !dd(u, f, n.epsilon);
    },
    "BigNumber, BigNumber": function(u, f) {
      return u.gt(f) && !eE(u, f, n.epsilon);
    },
    "Fraction, Fraction": function(u, f) {
      return u.compare(f) === 1;
    },
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    },
    "Unit, Unit": function(u, f) {
      if (!u.equalBase(f))
        throw new Error("Cannot compare units with different base");
      return this(u.value, f.value);
    },
    "SparseMatrix, SparseMatrix": function(u, f) {
      return s(u, f, this);
    },
    "SparseMatrix, DenseMatrix": function(u, f) {
      return o(f, u, this, !0);
    },
    "DenseMatrix, SparseMatrix": function(u, f) {
      return o(u, f, this, !1);
    },
    "DenseMatrix, DenseMatrix": function(u, f) {
      return A(u, f, this);
    },
    "Array, Array": function(u, f) {
      return this(r(u), r(f)).valueOf();
    },
    "Array, Matrix": function(u, f) {
      return this(r(u), f);
    },
    "Matrix, Array": function(u, f) {
      return this(u, r(f));
    },
    "SparseMatrix, any": function(u, f) {
      return a(u, f, this, !1);
    },
    "DenseMatrix, any": function(u, f) {
      return l(u, f, this, !1);
    },
    "any, SparseMatrix": function(u, f) {
      return a(f, u, this, !0);
    },
    "any, DenseMatrix": function(u, f) {
      return l(f, u, this, !0);
    },
    "Array, any": function(u, f) {
      return l(r(u), f, this, !1).valueOf();
    },
    "any, Array": function(u, f) {
      return l(r(f), u, this, !0).valueOf();
    }
  });
}), AKn = "FibonacciHeap", lKn = ["smaller", "larger"], cKn = /* @__PURE__ */ Ar(AKn, lKn, (t) => {
  var {
    smaller: e,
    larger: n
  } = t, r = 1 / Math.log((1 + Math.sqrt(5)) / 2);
  function i() {
    if (!(this instanceof i))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._minimum = null, this._size = 0;
  }
  i.prototype.type = "FibonacciHeap", i.prototype.isFibonacciHeap = !0, i.prototype.insert = function(c, u) {
    var f = {
      key: c,
      value: u,
      degree: 0
    };
    if (this._minimum) {
      var h = this._minimum;
      f.left = h, f.right = h.right, h.right = f, f.right.left = f, e(c, h.key) && (this._minimum = f);
    } else
      f.left = f, f.right = f, this._minimum = f;
    return this._size++, f;
  }, i.prototype.size = function() {
    return this._size;
  }, i.prototype.clear = function() {
    this._minimum = null, this._size = 0;
  }, i.prototype.isEmpty = function() {
    return this._size === 0;
  }, i.prototype.extractMinimum = function() {
    var c = this._minimum;
    if (c === null)
      return c;
    for (var u = this._minimum, f = c.degree, h = c.child; f > 0; ) {
      var d = h.right;
      h.left.right = h.right, h.right.left = h.left, h.left = u, h.right = u.right, u.right = h, h.right.left = h, h.parent = null, h = d, f--;
    }
    return c.left.right = c.right, c.right.left = c.left, c === c.right ? u = null : (u = c.right, u = l(u, this._size)), this._size--, this._minimum = u, c;
  }, i.prototype.remove = function(c) {
    this._minimum = o(this._minimum, c, -1), this.extractMinimum();
  };
  function o(c, u, f) {
    u.key = f;
    var h = u.parent;
    return h && e(u.key, h.key) && (s(c, u, h), a(c, h)), e(u.key, c.key) && (c = u), c;
  }
  function s(c, u, f) {
    u.left.right = u.right, u.right.left = u.left, f.degree--, f.child === u && (f.child = u.right), f.degree === 0 && (f.child = null), u.left = c, u.right = c.right, c.right = u, u.right.left = u, u.parent = null, u.mark = !1;
  }
  function a(c, u) {
    var f = u.parent;
    f && (u.mark ? (s(c, u, f), a(f)) : u.mark = !0);
  }
  var A = function(u, f) {
    u.left.right = u.right, u.right.left = u.left, u.parent = f, f.child ? (u.left = f.child, u.right = f.child.right, f.child.right = u, u.right.left = u) : (f.child = u, u.right = u, u.left = u), f.degree++, u.mark = !1;
  };
  function l(c, u) {
    var f = Math.floor(Math.log(u) * r) + 1, h = new Array(f), d = 0, I = c;
    if (I)
      for (d++, I = I.right; I !== c; )
        d++, I = I.right;
    for (var m; d > 0; ) {
      for (var C = I.degree, y = I.right; m = h[C], !!m; ) {
        if (n(I.key, m.key)) {
          var v = m;
          m = I, I = v;
        }
        A(m, I), h[C] = null, C++;
      }
      h[C] = I, I = y, d--;
    }
    c = null;
    for (var b = 0; b < f; b++)
      m = h[b], m && (c ? (m.left.right = m.right, m.right.left = m.left, m.left = c, m.right = c.right, c.right = m, m.right.left = m, e(m.key, c.key) && (c = m)) : c = m);
    return c;
  }
  return i;
}, {
  isClass: !0
}), uKn = "Spa", fKn = ["addScalar", "equalScalar", "FibonacciHeap"], gKn = /* @__PURE__ */ Ar(uKn, fKn, (t) => {
  var {
    addScalar: e,
    equalScalar: n,
    FibonacciHeap: r
  } = t;
  function i() {
    if (!(this instanceof i))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._values = [], this._heap = new r();
  }
  return i.prototype.type = "Spa", i.prototype.isSpa = !0, i.prototype.set = function(o, s) {
    if (this._values[o])
      this._values[o].value = s;
    else {
      var a = this._heap.insert(o, s);
      this._values[o] = a;
    }
  }, i.prototype.get = function(o) {
    var s = this._values[o];
    return s ? s.value : 0;
  }, i.prototype.accumulate = function(o, s) {
    var a = this._values[o];
    a ? a.value = e(a.value, s) : (a = this._heap.insert(o, s), this._values[o] = a);
  }, i.prototype.forEach = function(o, s, a) {
    var A = this._heap, l = this._values, c = [], u = A.extractMinimum();
    for (u && c.push(u); u && u.key <= s; )
      u.key >= o && (n(u.value, 0) || a(u.key, u.value, this)), u = A.extractMinimum(), u && c.push(u);
    for (var f = 0; f < c.length; f++) {
      var h = c[f];
      u = A.insert(h.key, h.value), l[u.key] = u;
    }
  }, i.prototype.swap = function(o, s) {
    var a = this._values[o], A = this._values[s];
    if (!a && A)
      a = this._heap.insert(o, A.value), this._heap.remove(A), this._values[o] = a, this._values[s] = void 0;
    else if (a && !A)
      A = this._heap.insert(s, a.value), this._heap.remove(a), this._values[s] = A, this._values[o] = void 0;
    else if (a && A) {
      var l = a.value;
      a.value = A.value, A.value = l;
    }
  }, i;
}, {
  isClass: !0
});
XM(function(t) {
  return new t(1).exp();
}, {
  hasher: Hq
});
XM(function(t) {
  return new t(1).plus(new t(5).sqrt()).div(2);
}, {
  hasher: Hq
});
var PWe = XM(function(t) {
  return t.acos(-1);
}, {
  hasher: Hq
});
XM(function(t) {
  return PWe(t).times(2);
}, {
  hasher: Hq
});
function Hq(t) {
  return t[0].precision;
}
function STe(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gK(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? STe(Object(n), !0).forEach(function(r) {
      mo(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : STe(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
var hKn = "Unit", dKn = ["?on", "config", "addScalar", "subtract", "multiplyScalar", "divideScalar", "pow", "abs", "fix", "round", "equal", "isNumeric", "format", "number", "Complex", "BigNumber", "Fraction"], pKn = /* @__PURE__ */ Ar(hKn, dKn, (t) => {
  var {
    on: e,
    config: n,
    addScalar: r,
    subtract: i,
    multiplyScalar: o,
    divideScalar: s,
    pow: a,
    abs: A,
    fix: l,
    round: c,
    equal: u,
    isNumeric: f,
    format: h,
    number: d,
    Complex: I,
    BigNumber: m,
    Fraction: C
  } = t, y = d;
  function v(W, ge) {
    if (!(this instanceof v))
      throw new Error("Constructor must be called with the new operator");
    if (!(W == null || f(W) || rS(W)))
      throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
    if (ge !== void 0 && (typeof ge != "string" || ge === ""))
      throw new TypeError("Second parameter in Unit constructor must be a string");
    if (ge !== void 0) {
      var _e = v.parse(ge);
      this.units = _e.units, this.dimensions = _e.dimensions;
    } else {
      this.units = [{
        unit: ee,
        prefix: z.NONE,
        // link to a list with supported prefixes
        power: 0
      }], this.dimensions = [];
      for (var Re = 0; Re < Y.length; Re++)
        this.dimensions[Re] = 0;
    }
    this.value = W != null ? this._normalize(W) : null, this.fixPrefix = !1, this.skipAutomaticSimplification = !0;
  }
  v.prototype.type = "Unit", v.prototype.isUnit = !0;
  var b, Q, w;
  function R() {
    for (; w === " " || w === "	"; )
      L();
  }
  function M(W) {
    return W >= "0" && W <= "9" || W === ".";
  }
  function O(W) {
    return W >= "0" && W <= "9";
  }
  function L() {
    Q++, w = b.charAt(Q);
  }
  function N(W) {
    Q = W, w = b.charAt(Q);
  }
  function k() {
    var W = "", ge = Q;
    if (w === "+" ? L() : w === "-" && (W += w, L()), !M(w))
      return N(ge), null;
    if (w === ".") {
      if (W += w, L(), !O(w))
        return N(ge), null;
    } else {
      for (; O(w); )
        W += w, L();
      w === "." && (W += w, L());
    }
    for (; O(w); )
      W += w, L();
    if (w === "E" || w === "e") {
      var _e = "", Re = Q;
      if (_e += w, L(), (w === "+" || w === "-") && (_e += w, L()), !O(w))
        return N(Re), W;
      for (W = W + _e; O(w); )
        W += w, L();
    }
    return W;
  }
  function $() {
    for (var W = ""; O(w) || v.isValidAlpha(w); )
      W += w, L();
    var ge = W.charAt(0);
    return v.isValidAlpha(ge) ? W : null;
  }
  function U(W) {
    return w === W ? (L(), W) : null;
  }
  v.parse = function(W, ge) {
    if (ge = ge || {}, b = W, Q = -1, w = "", typeof b != "string")
      throw new TypeError("Invalid argument in Unit.parse, string expected");
    var _e = new v();
    _e.units = [];
    var Re = 1, Ee = !1;
    L(), R();
    var oe = k(), ie = null;
    if (oe) {
      if (n.number === "BigNumber")
        ie = new m(oe);
      else if (n.number === "Fraction")
        try {
          ie = new C(oe);
        } catch {
          ie = parseFloat(oe);
        }
      else
        ie = parseFloat(oe);
      R(), U("*") ? (Re = 1, Ee = !0) : U("/") && (Re = -1, Ee = !0);
    }
    for (var Ae = [], de = 1; ; ) {
      for (R(); w === "("; )
        Ae.push(Re), de *= Re, Re = 1, L(), R();
      var we = void 0;
      if (w) {
        var Pe = w;
        if (we = $(), we === null)
          throw new SyntaxError('Unexpected "' + Pe + '" in "' + b + '" at index ' + Q.toString());
      } else
        break;
      var qe = X(we);
      if (qe === null)
        throw new SyntaxError('Unit "' + we + '" not found.');
      var ke = Re * de;
      if (R(), U("^")) {
        R();
        var Xe = k();
        if (Xe === null)
          throw new SyntaxError('In "' + W + '", "^" must be followed by a floating-point number');
        ke *= Xe;
      }
      _e.units.push({
        unit: qe.unit,
        prefix: qe.prefix,
        power: ke
      });
      for (var rt = 0; rt < Y.length; rt++)
        _e.dimensions[rt] += (qe.unit.dimensions[rt] || 0) * ke;
      for (R(); w === ")"; ) {
        if (Ae.length === 0)
          throw new SyntaxError('Unmatched ")" in "' + b + '" at index ' + Q.toString());
        de /= Ae.pop(), L(), R();
      }
      if (Ee = !1, U("*") ? (Re = 1, Ee = !0) : U("/") ? (Re = -1, Ee = !0) : Re = 1, qe.unit.base) {
        var it = qe.unit.base.key;
        Ie.auto[it] = {
          unit: qe.unit,
          prefix: qe.prefix
        };
      }
    }
    if (R(), w)
      throw new SyntaxError('Could not parse: "' + W + '"');
    if (Ee)
      throw new SyntaxError('Trailing characters: "' + W + '"');
    if (Ae.length !== 0)
      throw new SyntaxError('Unmatched "(" in "' + b + '"');
    if (_e.units.length === 0 && !ge.allowNoUnits)
      throw new SyntaxError('"' + W + '" contains no units');
    return _e.value = ie !== void 0 ? _e._normalize(ie) : null, _e;
  }, v.prototype.clone = function() {
    var W = new v();
    W.fixPrefix = this.fixPrefix, W.skipAutomaticSimplification = this.skipAutomaticSimplification, W.value = cs(this.value), W.dimensions = this.dimensions.slice(0), W.units = [];
    for (var ge = 0; ge < this.units.length; ge++) {
      W.units[ge] = {};
      for (var _e in this.units[ge])
        Mo(this.units[ge], _e) && (W.units[ge][_e] = this.units[ge][_e]);
    }
    return W;
  }, v.prototype._isDerived = function() {
    return this.units.length === 0 ? !1 : this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15;
  }, v.prototype._normalize = function(W) {
    var ge, _e, Re, Ee, oe;
    if (W == null || this.units.length === 0)
      return W;
    if (this._isDerived()) {
      var ie = W;
      oe = v._getNumberConverter(Sg(W));
      for (var Ae = 0; Ae < this.units.length; Ae++)
        ge = oe(this.units[Ae].unit.value), Ee = oe(this.units[Ae].prefix.value), Re = oe(this.units[Ae].power), ie = o(ie, a(o(ge, Ee), Re));
      return ie;
    } else
      return oe = v._getNumberConverter(Sg(W)), ge = oe(this.units[0].unit.value), _e = oe(this.units[0].unit.offset), Ee = oe(this.units[0].prefix.value), o(r(W, _e), o(ge, Ee));
  }, v.prototype._denormalize = function(W, ge) {
    var _e, Re, Ee, oe, ie;
    if (W == null || this.units.length === 0)
      return W;
    if (this._isDerived()) {
      var Ae = W;
      ie = v._getNumberConverter(Sg(W));
      for (var de = 0; de < this.units.length; de++)
        _e = ie(this.units[de].unit.value), oe = ie(this.units[de].prefix.value), Ee = ie(this.units[de].power), Ae = s(Ae, a(o(_e, oe), Ee));
      return Ae;
    } else
      return ie = v._getNumberConverter(Sg(W)), _e = ie(this.units[0].unit.value), oe = ie(this.units[0].prefix.value), Re = ie(this.units[0].unit.offset), ge == null ? i(s(s(W, _e), oe), Re) : i(s(s(W, _e), ge), Re);
  };
  var X = XM((W) => {
    if (Mo(pe, W)) {
      var ge = pe[W], _e = ge.prefixes[""];
      return {
        unit: ge,
        prefix: _e
      };
    }
    for (var Re in pe)
      if (Mo(pe, Re) && Yzn(W, Re)) {
        var Ee = pe[Re], oe = W.length - Re.length, ie = W.substring(0, oe), Ae = Mo(Ee.prefixes, ie) ? Ee.prefixes[ie] : void 0;
        if (Ae !== void 0)
          return {
            unit: Ee,
            prefix: Ae
          };
      }
    return null;
  }, {
    hasher: (W) => W[0],
    limit: 100
  });
  v.isValuelessUnit = function(W) {
    return X(W) !== null;
  }, v.prototype.hasBase = function(W) {
    if (typeof W == "string" && (W = V[W]), !W)
      return !1;
    for (var ge = 0; ge < Y.length; ge++)
      if (Math.abs((this.dimensions[ge] || 0) - (W.dimensions[ge] || 0)) > 1e-12)
        return !1;
    return !0;
  }, v.prototype.equalBase = function(W) {
    for (var ge = 0; ge < Y.length; ge++)
      if (Math.abs((this.dimensions[ge] || 0) - (W.dimensions[ge] || 0)) > 1e-12)
        return !1;
    return !0;
  }, v.prototype.equals = function(W) {
    return this.equalBase(W) && u(this.value, W.value);
  }, v.prototype.multiply = function(W) {
    for (var ge = this.clone(), _e = 0; _e < Y.length; _e++)
      ge.dimensions[_e] = (this.dimensions[_e] || 0) + (W.dimensions[_e] || 0);
    for (var Re = 0; Re < W.units.length; Re++) {
      var Ee = gK({}, W.units[Re]);
      ge.units.push(Ee);
    }
    if (this.value !== null || W.value !== null) {
      var oe = this.value === null ? this._normalize(1) : this.value, ie = W.value === null ? W._normalize(1) : W.value;
      ge.value = o(oe, ie);
    } else
      ge.value = null;
    return ge.skipAutomaticSimplification = !1, K(ge);
  }, v.prototype.divide = function(W) {
    for (var ge = this.clone(), _e = 0; _e < Y.length; _e++)
      ge.dimensions[_e] = (this.dimensions[_e] || 0) - (W.dimensions[_e] || 0);
    for (var Re = 0; Re < W.units.length; Re++) {
      var Ee = gK(gK({}, W.units[Re]), {}, {
        power: -W.units[Re].power
      });
      ge.units.push(Ee);
    }
    if (this.value !== null || W.value !== null) {
      var oe = this.value === null ? this._normalize(1) : this.value, ie = W.value === null ? W._normalize(1) : W.value;
      ge.value = s(oe, ie);
    } else
      ge.value = null;
    return ge.skipAutomaticSimplification = !1, K(ge);
  }, v.prototype.pow = function(W) {
    for (var ge = this.clone(), _e = 0; _e < Y.length; _e++)
      ge.dimensions[_e] = (this.dimensions[_e] || 0) * W;
    for (var Re = 0; Re < ge.units.length; Re++)
      ge.units[Re].power *= W;
    return ge.value !== null ? ge.value = a(ge.value, W) : ge.value = null, ge.skipAutomaticSimplification = !1, K(ge);
  };
  function K(W) {
    return W.equalBase(V.NONE) && W.value !== null && !n.predictable ? W.value : W;
  }
  v.prototype.abs = function() {
    var W = this.clone();
    W.value = W.value !== null ? A(W.value) : null;
    for (var ge in W.units)
      (W.units[ge].unit.name === "VA" || W.units[ge].unit.name === "VAR") && (W.units[ge].unit = pe.W);
    return W;
  }, v.prototype.to = function(W) {
    var ge, _e = this.value === null ? this._normalize(1) : this.value;
    if (typeof W == "string") {
      if (ge = v.parse(W), !this.equalBase(ge))
        throw new Error("Units do not match ('".concat(ge.toString(), "' != '").concat(this.toString(), "')"));
      if (ge.value !== null)
        throw new Error("Cannot convert to a unit with a value");
      return ge.value = cs(_e), ge.fixPrefix = !0, ge.skipAutomaticSimplification = !0, ge;
    } else if (Lq(W)) {
      if (!this.equalBase(W))
        throw new Error("Units do not match ('".concat(W.toString(), "' != '").concat(this.toString(), "')"));
      if (W.value !== null)
        throw new Error("Cannot convert to a unit with a value");
      return ge = W.clone(), ge.value = cs(_e), ge.fixPrefix = !0, ge.skipAutomaticSimplification = !0, ge;
    } else
      throw new Error("String or Unit expected as parameter");
  }, v.prototype.toNumber = function(W) {
    return y(this.toNumeric(W));
  }, v.prototype.toNumeric = function(W) {
    var ge;
    return W ? ge = this.to(W) : ge = this.clone(), ge._isDerived() || ge.units.length === 0 ? ge._denormalize(ge.value) : ge._denormalize(ge.value, ge.units[0].prefix.value);
  }, v.prototype.toString = function() {
    return this.format();
  }, v.prototype.toJSON = function() {
    return {
      mathjs: "Unit",
      value: this._denormalize(this.value),
      unit: this.formatUnits(),
      fixPrefix: this.fixPrefix
    };
  }, v.fromJSON = function(W) {
    var ge = new v(W.value, W.unit);
    return ge.fixPrefix = W.fixPrefix || !1, ge;
  }, v.prototype.valueOf = v.prototype.toString, v.prototype.simplify = function() {
    var W = this.clone(), ge = [], _e;
    for (var Re in Qe)
      if (Mo(Qe, Re) && W.hasBase(V[Re])) {
        _e = Re;
        break;
      }
    if (_e === "NONE")
      W.units = [];
    else {
      var Ee;
      if (_e && Mo(Qe, _e) && (Ee = Qe[_e]), Ee)
        W.units = [{
          unit: Ee.unit,
          prefix: Ee.prefix,
          power: 1
        }];
      else {
        for (var oe = !1, ie = 0; ie < Y.length; ie++) {
          var Ae = Y[ie];
          Math.abs(W.dimensions[ie] || 0) > 1e-12 && (Mo(Qe, Ae) ? ge.push({
            unit: Qe[Ae].unit,
            prefix: Qe[Ae].prefix,
            power: W.dimensions[ie] || 0
          }) : oe = !0);
        }
        ge.length < W.units.length && !oe && (W.units = ge);
      }
    }
    return W;
  }, v.prototype.toSI = function() {
    for (var W = this.clone(), ge = [], _e = 0; _e < Y.length; _e++) {
      var Re = Y[_e];
      if (Math.abs(W.dimensions[_e] || 0) > 1e-12)
        if (Mo(Ie.si, Re))
          ge.push({
            unit: Ie.si[Re].unit,
            prefix: Ie.si[Re].prefix,
            power: W.dimensions[_e] || 0
          });
        else
          throw new Error("Cannot express custom unit " + Re + " in SI units");
    }
    return W.units = ge, W.fixPrefix = !0, W.skipAutomaticSimplification = !0, W;
  }, v.prototype.formatUnits = function() {
    for (var W = "", ge = "", _e = 0, Re = 0, Ee = 0; Ee < this.units.length; Ee++)
      this.units[Ee].power > 0 ? (_e++, W += " " + this.units[Ee].prefix.name + this.units[Ee].unit.name, Math.abs(this.units[Ee].power - 1) > 1e-15 && (W += "^" + this.units[Ee].power)) : this.units[Ee].power < 0 && Re++;
    if (Re > 0)
      for (var oe = 0; oe < this.units.length; oe++)
        this.units[oe].power < 0 && (_e > 0 ? (ge += " " + this.units[oe].prefix.name + this.units[oe].unit.name, Math.abs(this.units[oe].power + 1) > 1e-15 && (ge += "^" + -this.units[oe].power)) : (ge += " " + this.units[oe].prefix.name + this.units[oe].unit.name, ge += "^" + this.units[oe].power));
    W = W.substr(1), ge = ge.substr(1), _e > 1 && Re > 0 && (W = "(" + W + ")"), Re > 1 && _e > 0 && (ge = "(" + ge + ")");
    var ie = W;
    return _e > 0 && Re > 0 && (ie += " / "), ie += ge, ie;
  }, v.prototype.format = function(W) {
    var ge = this.skipAutomaticSimplification || this.value === null ? this.clone() : this.simplify(), _e = !1;
    typeof ge.value < "u" && ge.value !== null && rS(ge.value) && (_e = Math.abs(ge.value.re) < 1e-14);
    for (var Re in ge.units)
      Mo(ge.units, Re) && ge.units[Re].unit && (ge.units[Re].unit.name === "VA" && _e ? ge.units[Re].unit = pe.VAR : ge.units[Re].unit.name === "VAR" && !_e && (ge.units[Re].unit = pe.VA));
    ge.units.length === 1 && !ge.fixPrefix && Math.abs(ge.units[0].power - Math.round(ge.units[0].power)) < 1e-14 && (ge.units[0].prefix = ge._bestPrefix());
    var Ee = ge._denormalize(ge.value), oe = ge.value !== null ? h(Ee, W || {}) : "", ie = ge.formatUnits();
    return ge.value && rS(ge.value) && (oe = "(" + oe + ")"), ie.length > 0 && oe.length > 0 && (oe += " "), oe += ie, oe;
  }, v.prototype._bestPrefix = function() {
    if (this.units.length !== 1)
      throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14)
      throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    var W = this.value !== null ? A(this.value) : 0, ge = A(this.units[0].unit.value), _e = this.units[0].prefix;
    if (W === 0)
      return _e;
    var Re = this.units[0].power, Ee = Math.log(W / Math.pow(_e.value * ge, Re)) / Math.LN10 - 1.2;
    if (Ee > -2.200001 && Ee < 1.800001)
      return _e;
    Ee = Math.abs(Ee);
    var oe = this.units[0].unit.prefixes;
    for (var ie in oe)
      if (Mo(oe, ie)) {
        var Ae = oe[ie];
        if (Ae.scientific) {
          var de = Math.abs(Math.log(W / Math.pow(Ae.value * ge, Re)) / Math.LN10 - 1.2);
          (de < Ee || de === Ee && Ae.name.length < _e.name.length) && (_e = Ae, Ee = de);
        }
      }
    return _e;
  }, v.prototype.splitUnit = function(W) {
    for (var ge = this.clone(), _e = [], Re = 0; Re < W.length && (ge = ge.to(W[Re]), Re !== W.length - 1); Re++) {
      var Ee = ge.toNumeric(), oe = c(Ee), ie = void 0, Ae = u(oe, Ee);
      Ae ? ie = oe : ie = l(ge.toNumeric());
      var de = new v(ie, W[Re].toString());
      _e.push(de), ge = i(ge, de);
    }
    for (var we = 0, Pe = 0; Pe < _e.length; Pe++)
      we = r(we, _e[Pe].value);
    return u(we, this.value) && (ge.value = 0), _e.push(ge), _e;
  };
  var z = {
    NONE: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      }
    },
    SHORT: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 10,
        scientific: !1
      },
      h: {
        name: "h",
        value: 100,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e3,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e6,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e9,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e12,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e15,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e18,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e21,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e24,
        scientific: !0
      },
      d: {
        name: "d",
        value: 0.1,
        scientific: !1
      },
      c: {
        name: "c",
        value: 0.01,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-3,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-6,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-9,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-12,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-15,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-18,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-21,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-24,
        scientific: !0
      }
    },
    LONG: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      deca: {
        name: "deca",
        value: 10,
        scientific: !1
      },
      hecto: {
        name: "hecto",
        value: 100,
        scientific: !1
      },
      kilo: {
        name: "kilo",
        value: 1e3,
        scientific: !0
      },
      mega: {
        name: "mega",
        value: 1e6,
        scientific: !0
      },
      giga: {
        name: "giga",
        value: 1e9,
        scientific: !0
      },
      tera: {
        name: "tera",
        value: 1e12,
        scientific: !0
      },
      peta: {
        name: "peta",
        value: 1e15,
        scientific: !0
      },
      exa: {
        name: "exa",
        value: 1e18,
        scientific: !0
      },
      zetta: {
        name: "zetta",
        value: 1e21,
        scientific: !0
      },
      yotta: {
        name: "yotta",
        value: 1e24,
        scientific: !0
      },
      deci: {
        name: "deci",
        value: 0.1,
        scientific: !1
      },
      centi: {
        name: "centi",
        value: 0.01,
        scientific: !1
      },
      milli: {
        name: "milli",
        value: 1e-3,
        scientific: !0
      },
      micro: {
        name: "micro",
        value: 1e-6,
        scientific: !0
      },
      nano: {
        name: "nano",
        value: 1e-9,
        scientific: !0
      },
      pico: {
        name: "pico",
        value: 1e-12,
        scientific: !0
      },
      femto: {
        name: "femto",
        value: 1e-15,
        scientific: !0
      },
      atto: {
        name: "atto",
        value: 1e-18,
        scientific: !0
      },
      zepto: {
        name: "zepto",
        value: 1e-21,
        scientific: !0
      },
      yocto: {
        name: "yocto",
        value: 1e-24,
        scientific: !0
      }
    },
    SQUARED: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 100,
        scientific: !1
      },
      h: {
        name: "h",
        value: 1e4,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e6,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e12,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e18,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e24,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e30,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e36,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e42,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e48,
        scientific: !0
      },
      d: {
        name: "d",
        value: 0.01,
        scientific: !1
      },
      c: {
        name: "c",
        value: 1e-4,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-6,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-12,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-18,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-24,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-30,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-36,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-42,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-48,
        scientific: !0
      }
    },
    CUBIC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 1e3,
        scientific: !1
      },
      h: {
        name: "h",
        value: 1e6,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e9,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e18,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e27,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e36,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e45,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e54,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e63,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e72,
        scientific: !0
      },
      d: {
        name: "d",
        value: 1e-3,
        scientific: !1
      },
      c: {
        name: "c",
        value: 1e-6,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-9,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-18,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-27,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-36,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-45,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-54,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-63,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-72,
        scientific: !0
      }
    },
    BINARY_SHORT_SI: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      k: {
        name: "k",
        value: 1e3,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e6,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e9,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e12,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e15,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e18,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e21,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e24,
        scientific: !0
      }
    },
    BINARY_SHORT_IEC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      Ki: {
        name: "Ki",
        value: 1024,
        scientific: !0
      },
      Mi: {
        name: "Mi",
        value: Math.pow(1024, 2),
        scientific: !0
      },
      Gi: {
        name: "Gi",
        value: Math.pow(1024, 3),
        scientific: !0
      },
      Ti: {
        name: "Ti",
        value: Math.pow(1024, 4),
        scientific: !0
      },
      Pi: {
        name: "Pi",
        value: Math.pow(1024, 5),
        scientific: !0
      },
      Ei: {
        name: "Ei",
        value: Math.pow(1024, 6),
        scientific: !0
      },
      Zi: {
        name: "Zi",
        value: Math.pow(1024, 7),
        scientific: !0
      },
      Yi: {
        name: "Yi",
        value: Math.pow(1024, 8),
        scientific: !0
      }
    },
    BINARY_LONG_SI: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      kilo: {
        name: "kilo",
        value: 1e3,
        scientific: !0
      },
      mega: {
        name: "mega",
        value: 1e6,
        scientific: !0
      },
      giga: {
        name: "giga",
        value: 1e9,
        scientific: !0
      },
      tera: {
        name: "tera",
        value: 1e12,
        scientific: !0
      },
      peta: {
        name: "peta",
        value: 1e15,
        scientific: !0
      },
      exa: {
        name: "exa",
        value: 1e18,
        scientific: !0
      },
      zetta: {
        name: "zetta",
        value: 1e21,
        scientific: !0
      },
      yotta: {
        name: "yotta",
        value: 1e24,
        scientific: !0
      }
    },
    BINARY_LONG_IEC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      kibi: {
        name: "kibi",
        value: 1024,
        scientific: !0
      },
      mebi: {
        name: "mebi",
        value: Math.pow(1024, 2),
        scientific: !0
      },
      gibi: {
        name: "gibi",
        value: Math.pow(1024, 3),
        scientific: !0
      },
      tebi: {
        name: "tebi",
        value: Math.pow(1024, 4),
        scientific: !0
      },
      pebi: {
        name: "pebi",
        value: Math.pow(1024, 5),
        scientific: !0
      },
      exi: {
        name: "exi",
        value: Math.pow(1024, 6),
        scientific: !0
      },
      zebi: {
        name: "zebi",
        value: Math.pow(1024, 7),
        scientific: !0
      },
      yobi: {
        name: "yobi",
        value: Math.pow(1024, 8),
        scientific: !0
      }
    },
    BTU: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      MM: {
        name: "MM",
        value: 1e6,
        scientific: !0
      }
    }
  };
  z.SHORTLONG = at({}, z.SHORT, z.LONG), z.BINARY_SHORT = at({}, z.BINARY_SHORT_SI, z.BINARY_SHORT_IEC), z.BINARY_LONG = at({}, z.BINARY_LONG_SI, z.BINARY_LONG_IEC);
  var Y = ["MASS", "LENGTH", "TIME", "CURRENT", "TEMPERATURE", "LUMINOUS_INTENSITY", "AMOUNT_OF_SUBSTANCE", "ANGLE", "BIT"], V = {
    NONE: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    MASS: {
      dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    LENGTH: {
      dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0]
    },
    TIME: {
      dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0]
    },
    CURRENT: {
      dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0]
    },
    TEMPERATURE: {
      dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0]
    },
    LUMINOUS_INTENSITY: {
      dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0]
    },
    AMOUNT_OF_SUBSTANCE: {
      dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0]
    },
    FORCE: {
      dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0]
    },
    SURFACE: {
      dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0]
    },
    VOLUME: {
      dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0]
    },
    ENERGY: {
      dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0]
    },
    POWER: {
      dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0]
    },
    PRESSURE: {
      dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CHARGE: {
      dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CAPACITANCE: {
      dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_POTENTIAL: {
      dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0]
    },
    ELECTRIC_RESISTANCE: {
      dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_INDUCTANCE: {
      dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CONDUCTANCE: {
      dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0]
    },
    MAGNETIC_FLUX: {
      dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0]
    },
    MAGNETIC_FLUX_DENSITY: {
      dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0]
    },
    FREQUENCY: {
      dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0]
    },
    ANGLE: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0]
    },
    BIT: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1]
    }
  };
  for (var Z in V)
    Mo(V, Z) && (V[Z].key = Z);
  var ce = {}, ee = {
    name: "",
    base: ce,
    value: 1,
    offset: 0,
    dimensions: Y.map((W) => 0)
  }, pe = {
    // length
    meter: {
      name: "meter",
      base: V.LENGTH,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    inch: {
      name: "inch",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 0.0254,
      offset: 0
    },
    foot: {
      name: "foot",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 0.3048,
      offset: 0
    },
    yard: {
      name: "yard",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 0.9144,
      offset: 0
    },
    mile: {
      name: "mile",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 1609.344,
      offset: 0
    },
    link: {
      name: "link",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 0.201168,
      offset: 0
    },
    rod: {
      name: "rod",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 5.0292,
      offset: 0
    },
    chain: {
      name: "chain",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 20.1168,
      offset: 0
    },
    angstrom: {
      name: "angstrom",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 1e-10,
      offset: 0
    },
    m: {
      name: "m",
      base: V.LENGTH,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    in: {
      name: "in",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 0.0254,
      offset: 0
    },
    ft: {
      name: "ft",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 0.3048,
      offset: 0
    },
    yd: {
      name: "yd",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 0.9144,
      offset: 0
    },
    mi: {
      name: "mi",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 1609.344,
      offset: 0
    },
    li: {
      name: "li",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 0.201168,
      offset: 0
    },
    rd: {
      name: "rd",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 5.02921,
      offset: 0
    },
    ch: {
      name: "ch",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 20.1168,
      offset: 0
    },
    mil: {
      name: "mil",
      base: V.LENGTH,
      prefixes: z.NONE,
      value: 254e-7,
      offset: 0
    },
    // 1/1000 inch
    // Surface
    m2: {
      name: "m2",
      base: V.SURFACE,
      prefixes: z.SQUARED,
      value: 1,
      offset: 0
    },
    sqin: {
      name: "sqin",
      base: V.SURFACE,
      prefixes: z.NONE,
      value: 64516e-8,
      offset: 0
    },
    // 645.16 mm2
    sqft: {
      name: "sqft",
      base: V.SURFACE,
      prefixes: z.NONE,
      value: 0.09290304,
      offset: 0
    },
    // 0.09290304 m2
    sqyd: {
      name: "sqyd",
      base: V.SURFACE,
      prefixes: z.NONE,
      value: 0.83612736,
      offset: 0
    },
    // 0.83612736 m2
    sqmi: {
      name: "sqmi",
      base: V.SURFACE,
      prefixes: z.NONE,
      value: 2589988110336e-6,
      offset: 0
    },
    // 2.589988110336 km2
    sqrd: {
      name: "sqrd",
      base: V.SURFACE,
      prefixes: z.NONE,
      value: 25.29295,
      offset: 0
    },
    // 25.29295 m2
    sqch: {
      name: "sqch",
      base: V.SURFACE,
      prefixes: z.NONE,
      value: 404.6873,
      offset: 0
    },
    // 404.6873 m2
    sqmil: {
      name: "sqmil",
      base: V.SURFACE,
      prefixes: z.NONE,
      value: 64516e-14,
      offset: 0
    },
    // 6.4516 * 10^-10 m2
    acre: {
      name: "acre",
      base: V.SURFACE,
      prefixes: z.NONE,
      value: 4046.86,
      offset: 0
    },
    // 4046.86 m2
    hectare: {
      name: "hectare",
      base: V.SURFACE,
      prefixes: z.NONE,
      value: 1e4,
      offset: 0
    },
    // 10000 m2
    // Volume
    m3: {
      name: "m3",
      base: V.VOLUME,
      prefixes: z.CUBIC,
      value: 1,
      offset: 0
    },
    L: {
      name: "L",
      base: V.VOLUME,
      prefixes: z.SHORT,
      value: 1e-3,
      offset: 0
    },
    // litre
    l: {
      name: "l",
      base: V.VOLUME,
      prefixes: z.SHORT,
      value: 1e-3,
      offset: 0
    },
    // litre
    litre: {
      name: "litre",
      base: V.VOLUME,
      prefixes: z.LONG,
      value: 1e-3,
      offset: 0
    },
    cuin: {
      name: "cuin",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 16387064e-12,
      offset: 0
    },
    // 1.6387064e-5 m3
    cuft: {
      name: "cuft",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 0.028316846592,
      offset: 0
    },
    // 28.316 846 592 L
    cuyd: {
      name: "cuyd",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 0.764554857984,
      offset: 0
    },
    // 764.554 857 984 L
    teaspoon: {
      name: "teaspoon",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 5e-6,
      offset: 0
    },
    // 5 mL
    tablespoon: {
      name: "tablespoon",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 15e-6,
      offset: 0
    },
    // 15 mL
    // {name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
    drop: {
      name: "drop",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 5e-8,
      offset: 0
    },
    // 0.05 mL = 5e-8 m3
    gtt: {
      name: "gtt",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 5e-8,
      offset: 0
    },
    // 0.05 mL = 5e-8 m3
    // Liquid volume
    minim: {
      name: "minim",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 6161152e-14,
      offset: 0
    },
    // 0.06161152 mL
    fluiddram: {
      name: "fluiddram",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 36966911e-13,
      offset: 0
    },
    // 3.696691 mL
    fluidounce: {
      name: "fluidounce",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 2957353e-11,
      offset: 0
    },
    // 29.57353 mL
    gill: {
      name: "gill",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 1182941e-10,
      offset: 0
    },
    // 118.2941 mL
    cc: {
      name: "cc",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 1e-6,
      offset: 0
    },
    // 1e-6 L
    cup: {
      name: "cup",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 2365882e-10,
      offset: 0
    },
    // 236.5882 mL
    pint: {
      name: "pint",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 4731765e-10,
      offset: 0
    },
    // 473.1765 mL
    quart: {
      name: "quart",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 9463529e-10,
      offset: 0
    },
    // 946.3529 mL
    gallon: {
      name: "gallon",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 3785412e-9,
      offset: 0
    },
    // 3.785412 L
    beerbarrel: {
      name: "beerbarrel",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 0.1173478,
      offset: 0
    },
    // 117.3478 L
    oilbarrel: {
      name: "oilbarrel",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 0.1589873,
      offset: 0
    },
    // 158.9873 L
    hogshead: {
      name: "hogshead",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 0.238481,
      offset: 0
    },
    // 238.4810 L
    // {name: 'min', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.00000006161152, offset: 0}, // 0.06161152 mL // min is already in use as minute
    fldr: {
      name: "fldr",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 36966911e-13,
      offset: 0
    },
    // 3.696691 mL
    floz: {
      name: "floz",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 2957353e-11,
      offset: 0
    },
    // 29.57353 mL
    gi: {
      name: "gi",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 1182941e-10,
      offset: 0
    },
    // 118.2941 mL
    cp: {
      name: "cp",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 2365882e-10,
      offset: 0
    },
    // 236.5882 mL
    pt: {
      name: "pt",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 4731765e-10,
      offset: 0
    },
    // 473.1765 mL
    qt: {
      name: "qt",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 9463529e-10,
      offset: 0
    },
    // 946.3529 mL
    gal: {
      name: "gal",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 3785412e-9,
      offset: 0
    },
    // 3.785412 L
    bbl: {
      name: "bbl",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 0.1173478,
      offset: 0
    },
    // 117.3478 L
    obl: {
      name: "obl",
      base: V.VOLUME,
      prefixes: z.NONE,
      value: 0.1589873,
      offset: 0
    },
    // 158.9873 L
    // {name: 'hogshead', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.2384810, offset: 0}, // 238.4810 L // TODO: hh?
    // Mass
    g: {
      name: "g",
      base: V.MASS,
      prefixes: z.SHORT,
      value: 1e-3,
      offset: 0
    },
    gram: {
      name: "gram",
      base: V.MASS,
      prefixes: z.LONG,
      value: 1e-3,
      offset: 0
    },
    ton: {
      name: "ton",
      base: V.MASS,
      prefixes: z.SHORT,
      value: 907.18474,
      offset: 0
    },
    t: {
      name: "t",
      base: V.MASS,
      prefixes: z.SHORT,
      value: 1e3,
      offset: 0
    },
    tonne: {
      name: "tonne",
      base: V.MASS,
      prefixes: z.LONG,
      value: 1e3,
      offset: 0
    },
    grain: {
      name: "grain",
      base: V.MASS,
      prefixes: z.NONE,
      value: 6479891e-11,
      offset: 0
    },
    dram: {
      name: "dram",
      base: V.MASS,
      prefixes: z.NONE,
      value: 0.0017718451953125,
      offset: 0
    },
    ounce: {
      name: "ounce",
      base: V.MASS,
      prefixes: z.NONE,
      value: 0.028349523125,
      offset: 0
    },
    poundmass: {
      name: "poundmass",
      base: V.MASS,
      prefixes: z.NONE,
      value: 0.45359237,
      offset: 0
    },
    hundredweight: {
      name: "hundredweight",
      base: V.MASS,
      prefixes: z.NONE,
      value: 45.359237,
      offset: 0
    },
    stick: {
      name: "stick",
      base: V.MASS,
      prefixes: z.NONE,
      value: 0.115,
      offset: 0
    },
    stone: {
      name: "stone",
      base: V.MASS,
      prefixes: z.NONE,
      value: 6.35029318,
      offset: 0
    },
    gr: {
      name: "gr",
      base: V.MASS,
      prefixes: z.NONE,
      value: 6479891e-11,
      offset: 0
    },
    dr: {
      name: "dr",
      base: V.MASS,
      prefixes: z.NONE,
      value: 0.0017718451953125,
      offset: 0
    },
    oz: {
      name: "oz",
      base: V.MASS,
      prefixes: z.NONE,
      value: 0.028349523125,
      offset: 0
    },
    lbm: {
      name: "lbm",
      base: V.MASS,
      prefixes: z.NONE,
      value: 0.45359237,
      offset: 0
    },
    cwt: {
      name: "cwt",
      base: V.MASS,
      prefixes: z.NONE,
      value: 45.359237,
      offset: 0
    },
    // Time
    s: {
      name: "s",
      base: V.TIME,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    min: {
      name: "min",
      base: V.TIME,
      prefixes: z.NONE,
      value: 60,
      offset: 0
    },
    h: {
      name: "h",
      base: V.TIME,
      prefixes: z.NONE,
      value: 3600,
      offset: 0
    },
    second: {
      name: "second",
      base: V.TIME,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    sec: {
      name: "sec",
      base: V.TIME,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    minute: {
      name: "minute",
      base: V.TIME,
      prefixes: z.NONE,
      value: 60,
      offset: 0
    },
    hour: {
      name: "hour",
      base: V.TIME,
      prefixes: z.NONE,
      value: 3600,
      offset: 0
    },
    day: {
      name: "day",
      base: V.TIME,
      prefixes: z.NONE,
      value: 86400,
      offset: 0
    },
    week: {
      name: "week",
      base: V.TIME,
      prefixes: z.NONE,
      value: 7 * 86400,
      offset: 0
    },
    month: {
      name: "month",
      base: V.TIME,
      prefixes: z.NONE,
      value: 2629800,
      // 1/12th of Julian year
      offset: 0
    },
    year: {
      name: "year",
      base: V.TIME,
      prefixes: z.NONE,
      value: 31557600,
      // Julian year
      offset: 0
    },
    decade: {
      name: "decade",
      base: V.TIME,
      prefixes: z.NONE,
      value: 315576e3,
      // Julian decade
      offset: 0
    },
    century: {
      name: "century",
      base: V.TIME,
      prefixes: z.NONE,
      value: 315576e4,
      // Julian century
      offset: 0
    },
    millennium: {
      name: "millennium",
      base: V.TIME,
      prefixes: z.NONE,
      value: 315576e5,
      // Julian millennium
      offset: 0
    },
    // Frequency
    hertz: {
      name: "Hertz",
      base: V.FREQUENCY,
      prefixes: z.LONG,
      value: 1,
      offset: 0,
      reciprocal: !0
    },
    Hz: {
      name: "Hz",
      base: V.FREQUENCY,
      prefixes: z.SHORT,
      value: 1,
      offset: 0,
      reciprocal: !0
    },
    // Angle
    rad: {
      name: "rad",
      base: V.ANGLE,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    radian: {
      name: "radian",
      base: V.ANGLE,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
    deg: {
      name: "deg",
      base: V.ANGLE,
      prefixes: z.SHORT,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    degree: {
      name: "degree",
      base: V.ANGLE,
      prefixes: z.LONG,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
    grad: {
      name: "grad",
      base: V.ANGLE,
      prefixes: z.SHORT,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    gradian: {
      name: "gradian",
      base: V.ANGLE,
      prefixes: z.LONG,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
    cycle: {
      name: "cycle",
      base: V.ANGLE,
      prefixes: z.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
    arcsec: {
      name: "arcsec",
      base: V.ANGLE,
      prefixes: z.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
    arcmin: {
      name: "arcmin",
      base: V.ANGLE,
      prefixes: z.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // Electric current
    A: {
      name: "A",
      base: V.CURRENT,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    ampere: {
      name: "ampere",
      base: V.CURRENT,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    // Temperature
    // K(C) = °C + 273.15
    // K(F) = (°F + 459.67) / 1.8
    // K(R) = °R / 1.8
    K: {
      name: "K",
      base: V.TEMPERATURE,
      prefixes: z.NONE,
      value: 1,
      offset: 0
    },
    degC: {
      name: "degC",
      base: V.TEMPERATURE,
      prefixes: z.NONE,
      value: 1,
      offset: 273.15
    },
    degF: {
      name: "degF",
      base: V.TEMPERATURE,
      prefixes: z.NONE,
      value: 1 / 1.8,
      offset: 459.67
    },
    degR: {
      name: "degR",
      base: V.TEMPERATURE,
      prefixes: z.NONE,
      value: 1 / 1.8,
      offset: 0
    },
    kelvin: {
      name: "kelvin",
      base: V.TEMPERATURE,
      prefixes: z.NONE,
      value: 1,
      offset: 0
    },
    celsius: {
      name: "celsius",
      base: V.TEMPERATURE,
      prefixes: z.NONE,
      value: 1,
      offset: 273.15
    },
    fahrenheit: {
      name: "fahrenheit",
      base: V.TEMPERATURE,
      prefixes: z.NONE,
      value: 1 / 1.8,
      offset: 459.67
    },
    rankine: {
      name: "rankine",
      base: V.TEMPERATURE,
      prefixes: z.NONE,
      value: 1 / 1.8,
      offset: 0
    },
    // amount of substance
    mol: {
      name: "mol",
      base: V.AMOUNT_OF_SUBSTANCE,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    mole: {
      name: "mole",
      base: V.AMOUNT_OF_SUBSTANCE,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    // luminous intensity
    cd: {
      name: "cd",
      base: V.LUMINOUS_INTENSITY,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    candela: {
      name: "candela",
      base: V.LUMINOUS_INTENSITY,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    // TODO: units STERADIAN
    // {name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
    // {name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
    // Force
    N: {
      name: "N",
      base: V.FORCE,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    newton: {
      name: "newton",
      base: V.FORCE,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    dyn: {
      name: "dyn",
      base: V.FORCE,
      prefixes: z.SHORT,
      value: 1e-5,
      offset: 0
    },
    dyne: {
      name: "dyne",
      base: V.FORCE,
      prefixes: z.LONG,
      value: 1e-5,
      offset: 0
    },
    lbf: {
      name: "lbf",
      base: V.FORCE,
      prefixes: z.NONE,
      value: 4.4482216152605,
      offset: 0
    },
    poundforce: {
      name: "poundforce",
      base: V.FORCE,
      prefixes: z.NONE,
      value: 4.4482216152605,
      offset: 0
    },
    kip: {
      name: "kip",
      base: V.FORCE,
      prefixes: z.LONG,
      value: 4448.2216,
      offset: 0
    },
    kilogramforce: {
      name: "kilogramforce",
      base: V.FORCE,
      prefixes: z.NONE,
      value: 9.80665,
      offset: 0
    },
    // Energy
    J: {
      name: "J",
      base: V.ENERGY,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    joule: {
      name: "joule",
      base: V.ENERGY,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    erg: {
      name: "erg",
      base: V.ENERGY,
      prefixes: z.NONE,
      value: 1e-7,
      offset: 0
    },
    Wh: {
      name: "Wh",
      base: V.ENERGY,
      prefixes: z.SHORT,
      value: 3600,
      offset: 0
    },
    BTU: {
      name: "BTU",
      base: V.ENERGY,
      prefixes: z.BTU,
      value: 1055.05585262,
      offset: 0
    },
    eV: {
      name: "eV",
      base: V.ENERGY,
      prefixes: z.SHORT,
      value: 1602176565e-28,
      offset: 0
    },
    electronvolt: {
      name: "electronvolt",
      base: V.ENERGY,
      prefixes: z.LONG,
      value: 1602176565e-28,
      offset: 0
    },
    // Power
    W: {
      name: "W",
      base: V.POWER,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    watt: {
      name: "watt",
      base: V.POWER,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    hp: {
      name: "hp",
      base: V.POWER,
      prefixes: z.NONE,
      value: 745.6998715386,
      offset: 0
    },
    // Electrical power units
    VAR: {
      name: "VAR",
      base: V.POWER,
      prefixes: z.SHORT,
      value: I.I,
      offset: 0
    },
    VA: {
      name: "VA",
      base: V.POWER,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    // Pressure
    Pa: {
      name: "Pa",
      base: V.PRESSURE,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    psi: {
      name: "psi",
      base: V.PRESSURE,
      prefixes: z.NONE,
      value: 6894.75729276459,
      offset: 0
    },
    atm: {
      name: "atm",
      base: V.PRESSURE,
      prefixes: z.NONE,
      value: 101325,
      offset: 0
    },
    bar: {
      name: "bar",
      base: V.PRESSURE,
      prefixes: z.SHORTLONG,
      value: 1e5,
      offset: 0
    },
    torr: {
      name: "torr",
      base: V.PRESSURE,
      prefixes: z.NONE,
      value: 133.322,
      offset: 0
    },
    mmHg: {
      name: "mmHg",
      base: V.PRESSURE,
      prefixes: z.NONE,
      value: 133.322,
      offset: 0
    },
    mmH2O: {
      name: "mmH2O",
      base: V.PRESSURE,
      prefixes: z.NONE,
      value: 9.80665,
      offset: 0
    },
    cmH2O: {
      name: "cmH2O",
      base: V.PRESSURE,
      prefixes: z.NONE,
      value: 98.0665,
      offset: 0
    },
    // Electric charge
    coulomb: {
      name: "coulomb",
      base: V.ELECTRIC_CHARGE,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    C: {
      name: "C",
      base: V.ELECTRIC_CHARGE,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    // Electric capacitance
    farad: {
      name: "farad",
      base: V.ELECTRIC_CAPACITANCE,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    F: {
      name: "F",
      base: V.ELECTRIC_CAPACITANCE,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    // Electric potential
    volt: {
      name: "volt",
      base: V.ELECTRIC_POTENTIAL,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    V: {
      name: "V",
      base: V.ELECTRIC_POTENTIAL,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    // Electric resistance
    ohm: {
      name: "ohm",
      base: V.ELECTRIC_RESISTANCE,
      prefixes: z.SHORTLONG,
      // Both Mohm and megaohm are acceptable
      value: 1,
      offset: 0
    },
    /*
     * Unicode breaks in browsers if charset is not specified
    Ω: {
      name: 'Ω',
      base: BASE_UNITS.ELECTRIC_RESISTANCE,
      prefixes: PREFIXES.SHORT,
      value: 1,
      offset: 0
    },
    */
    // Electric inductance
    henry: {
      name: "henry",
      base: V.ELECTRIC_INDUCTANCE,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    H: {
      name: "H",
      base: V.ELECTRIC_INDUCTANCE,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    // Electric conductance
    siemens: {
      name: "siemens",
      base: V.ELECTRIC_CONDUCTANCE,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    S: {
      name: "S",
      base: V.ELECTRIC_CONDUCTANCE,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    // Magnetic flux
    weber: {
      name: "weber",
      base: V.MAGNETIC_FLUX,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    Wb: {
      name: "Wb",
      base: V.MAGNETIC_FLUX,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    // Magnetic flux density
    tesla: {
      name: "tesla",
      base: V.MAGNETIC_FLUX_DENSITY,
      prefixes: z.LONG,
      value: 1,
      offset: 0
    },
    T: {
      name: "T",
      base: V.MAGNETIC_FLUX_DENSITY,
      prefixes: z.SHORT,
      value: 1,
      offset: 0
    },
    // Binary
    b: {
      name: "b",
      base: V.BIT,
      prefixes: z.BINARY_SHORT,
      value: 1,
      offset: 0
    },
    bits: {
      name: "bits",
      base: V.BIT,
      prefixes: z.BINARY_LONG,
      value: 1,
      offset: 0
    },
    B: {
      name: "B",
      base: V.BIT,
      prefixes: z.BINARY_SHORT,
      value: 8,
      offset: 0
    },
    bytes: {
      name: "bytes",
      base: V.BIT,
      prefixes: z.BINARY_LONG,
      value: 8,
      offset: 0
    }
  }, Ce = {
    meters: "meter",
    inches: "inch",
    feet: "foot",
    yards: "yard",
    miles: "mile",
    links: "link",
    rods: "rod",
    chains: "chain",
    angstroms: "angstrom",
    lt: "l",
    litres: "litre",
    liter: "litre",
    liters: "litre",
    teaspoons: "teaspoon",
    tablespoons: "tablespoon",
    minims: "minim",
    fluiddrams: "fluiddram",
    fluidounces: "fluidounce",
    gills: "gill",
    cups: "cup",
    pints: "pint",
    quarts: "quart",
    gallons: "gallon",
    beerbarrels: "beerbarrel",
    oilbarrels: "oilbarrel",
    hogsheads: "hogshead",
    gtts: "gtt",
    grams: "gram",
    tons: "ton",
    tonnes: "tonne",
    grains: "grain",
    drams: "dram",
    ounces: "ounce",
    poundmasses: "poundmass",
    hundredweights: "hundredweight",
    sticks: "stick",
    lb: "lbm",
    lbs: "lbm",
    kips: "kip",
    kgf: "kilogramforce",
    acres: "acre",
    hectares: "hectare",
    sqfeet: "sqft",
    sqyard: "sqyd",
    sqmile: "sqmi",
    sqmiles: "sqmi",
    mmhg: "mmHg",
    mmh2o: "mmH2O",
    cmh2o: "cmH2O",
    seconds: "second",
    secs: "second",
    minutes: "minute",
    mins: "minute",
    hours: "hour",
    hr: "hour",
    hrs: "hour",
    days: "day",
    weeks: "week",
    months: "month",
    years: "year",
    decades: "decade",
    centuries: "century",
    millennia: "millennium",
    hertz: "hertz",
    radians: "radian",
    degrees: "degree",
    gradians: "gradian",
    cycles: "cycle",
    arcsecond: "arcsec",
    arcseconds: "arcsec",
    arcminute: "arcmin",
    arcminutes: "arcmin",
    BTUs: "BTU",
    watts: "watt",
    joules: "joule",
    amperes: "ampere",
    coulombs: "coulomb",
    volts: "volt",
    ohms: "ohm",
    farads: "farad",
    webers: "weber",
    teslas: "tesla",
    electronvolts: "electronvolt",
    moles: "mole",
    bit: "bits",
    byte: "bytes"
  };
  function Be(W) {
    if (W.number === "BigNumber") {
      var ge = PWe(m);
      pe.rad.value = new m(1), pe.deg.value = ge.div(180), pe.grad.value = ge.div(200), pe.cycle.value = ge.times(2), pe.arcsec.value = ge.div(648e3), pe.arcmin.value = ge.div(10800);
    } else
      pe.rad.value = 1, pe.deg.value = Math.PI / 180, pe.grad.value = Math.PI / 200, pe.cycle.value = Math.PI * 2, pe.arcsec.value = Math.PI / 648e3, pe.arcmin.value = Math.PI / 10800;
    pe.radian.value = pe.rad.value, pe.degree.value = pe.deg.value, pe.gradian.value = pe.grad.value;
  }
  Be(n), e && e("config", function(W, ge) {
    W.number !== ge.number && Be(W);
  });
  var Ie = {
    si: {
      // Base units
      NONE: {
        unit: ee,
        prefix: z.NONE[""]
      },
      LENGTH: {
        unit: pe.m,
        prefix: z.SHORT[""]
      },
      MASS: {
        unit: pe.g,
        prefix: z.SHORT.k
      },
      TIME: {
        unit: pe.s,
        prefix: z.SHORT[""]
      },
      CURRENT: {
        unit: pe.A,
        prefix: z.SHORT[""]
      },
      TEMPERATURE: {
        unit: pe.K,
        prefix: z.SHORT[""]
      },
      LUMINOUS_INTENSITY: {
        unit: pe.cd,
        prefix: z.SHORT[""]
      },
      AMOUNT_OF_SUBSTANCE: {
        unit: pe.mol,
        prefix: z.SHORT[""]
      },
      ANGLE: {
        unit: pe.rad,
        prefix: z.SHORT[""]
      },
      BIT: {
        unit: pe.bits,
        prefix: z.SHORT[""]
      },
      // Derived units
      FORCE: {
        unit: pe.N,
        prefix: z.SHORT[""]
      },
      ENERGY: {
        unit: pe.J,
        prefix: z.SHORT[""]
      },
      POWER: {
        unit: pe.W,
        prefix: z.SHORT[""]
      },
      PRESSURE: {
        unit: pe.Pa,
        prefix: z.SHORT[""]
      },
      ELECTRIC_CHARGE: {
        unit: pe.C,
        prefix: z.SHORT[""]
      },
      ELECTRIC_CAPACITANCE: {
        unit: pe.F,
        prefix: z.SHORT[""]
      },
      ELECTRIC_POTENTIAL: {
        unit: pe.V,
        prefix: z.SHORT[""]
      },
      ELECTRIC_RESISTANCE: {
        unit: pe.ohm,
        prefix: z.SHORT[""]
      },
      ELECTRIC_INDUCTANCE: {
        unit: pe.H,
        prefix: z.SHORT[""]
      },
      ELECTRIC_CONDUCTANCE: {
        unit: pe.S,
        prefix: z.SHORT[""]
      },
      MAGNETIC_FLUX: {
        unit: pe.Wb,
        prefix: z.SHORT[""]
      },
      MAGNETIC_FLUX_DENSITY: {
        unit: pe.T,
        prefix: z.SHORT[""]
      },
      FREQUENCY: {
        unit: pe.Hz,
        prefix: z.SHORT[""]
      }
    }
  };
  Ie.cgs = JSON.parse(JSON.stringify(Ie.si)), Ie.cgs.LENGTH = {
    unit: pe.m,
    prefix: z.SHORT.c
  }, Ie.cgs.MASS = {
    unit: pe.g,
    prefix: z.SHORT[""]
  }, Ie.cgs.FORCE = {
    unit: pe.dyn,
    prefix: z.SHORT[""]
  }, Ie.cgs.ENERGY = {
    unit: pe.erg,
    prefix: z.NONE[""]
  }, Ie.us = JSON.parse(JSON.stringify(Ie.si)), Ie.us.LENGTH = {
    unit: pe.ft,
    prefix: z.NONE[""]
  }, Ie.us.MASS = {
    unit: pe.lbm,
    prefix: z.NONE[""]
  }, Ie.us.TEMPERATURE = {
    unit: pe.degF,
    prefix: z.NONE[""]
  }, Ie.us.FORCE = {
    unit: pe.lbf,
    prefix: z.NONE[""]
  }, Ie.us.ENERGY = {
    unit: pe.BTU,
    prefix: z.BTU[""]
  }, Ie.us.POWER = {
    unit: pe.hp,
    prefix: z.NONE[""]
  }, Ie.us.PRESSURE = {
    unit: pe.psi,
    prefix: z.NONE[""]
  }, Ie.auto = JSON.parse(JSON.stringify(Ie.si));
  var Qe = Ie.auto;
  v.setUnitSystem = function(W) {
    if (Mo(Ie, W))
      Qe = Ie[W];
    else
      throw new Error("Unit system " + W + " does not exist. Choices are: " + Object.keys(Ie).join(", "));
  }, v.getUnitSystem = function() {
    for (var W in Ie)
      if (Mo(Ie, W) && Ie[W] === Qe)
        return W;
  }, v.typeConverters = {
    BigNumber: function(ge) {
      return new m(ge + "");
    },
    Fraction: function(ge) {
      return new C(ge);
    },
    Complex: function(ge) {
      return ge;
    },
    number: function(ge) {
      return ge;
    }
  }, v._getNumberConverter = function(W) {
    if (!v.typeConverters[W])
      throw new TypeError('Unsupported type "' + W + '"');
    return v.typeConverters[W];
  };
  for (var xe in pe)
    if (Mo(pe, xe)) {
      var Se = pe[xe];
      Se.dimensions = Se.base.dimensions;
    }
  for (var De in Ce)
    if (Mo(Ce, De)) {
      var Ue = pe[Ce[De]], Te = {};
      for (var se in Ue)
        Mo(Ue, se) && (Te[se] = Ue[se]);
      Te.name = De, pe[De] = Te;
    }
  v.isValidAlpha = function(ge) {
    return /^[a-zA-Z]$/.test(ge);
  };
  function fe(W) {
    for (var ge = 0; ge < W.length; ge++) {
      if (w = W.charAt(ge), ge === 0 && !v.isValidAlpha(w))
        throw new Error('Invalid unit name (must begin with alpha character): "' + W + '"');
      if (ge > 0 && !(v.isValidAlpha(w) || O(w)))
        throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + W + '"');
    }
  }
  return v.createUnit = function(W, ge) {
    if (typeof W != "object")
      throw new TypeError("createUnit expects first parameter to be of type 'Object'");
    if (ge && ge.override) {
      for (var _e in W)
        if (Mo(W, _e) && v.deleteUnit(_e), W[_e].aliases)
          for (var Re = 0; Re < W[_e].aliases.length; Re++)
            v.deleteUnit(W[_e].aliases[Re]);
    }
    var Ee;
    for (var oe in W)
      Mo(W, oe) && (Ee = v.createUnitSingle(oe, W[oe]));
    return Ee;
  }, v.createUnitSingle = function(W, ge, _e) {
    if ((typeof ge > "u" || ge === null) && (ge = {}), typeof W != "string")
      throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
    if (Mo(pe, W))
      throw new Error('Cannot create unit "' + W + '": a unit with that name already exists');
    fe(W);
    var Re = null, Ee = [], oe = 0, ie, Ae, de;
    if (ge && ge.type === "Unit")
      Re = ge.clone();
    else if (typeof ge == "string")
      ge !== "" && (ie = ge);
    else if (typeof ge == "object")
      ie = ge.definition, Ae = ge.prefixes, oe = ge.offset, de = ge.baseName, ge.aliases && (Ee = ge.aliases.valueOf());
    else
      throw new TypeError('Cannot create unit "' + W + '" from "' + ge.toString() + '": expecting "string" or "Unit" or "Object"');
    if (Ee) {
      for (var we = 0; we < Ee.length; we++)
        if (Mo(pe, Ee[we]))
          throw new Error('Cannot create alias "' + Ee[we] + '": a unit with that name already exists');
    }
    if (ie && typeof ie == "string" && !Re)
      try {
        Re = v.parse(ie, {
          allowNoUnits: !0
        });
      } catch (Ht) {
        throw Ht.message = 'Could not create unit "' + W + '" from "' + ie + '": ' + Ht.message, Ht;
      }
    else
      ie && ie.type === "Unit" && (Re = ie.clone());
    Ee = Ee || [], oe = oe || 0, Ae && Ae.toUpperCase ? Ae = z[Ae.toUpperCase()] || z.NONE : Ae = z.NONE;
    var Pe = {};
    if (Re) {
      Pe = {
        name: W,
        value: Re.value,
        dimensions: Re.dimensions.slice(0),
        prefixes: Ae,
        offset: oe
      };
      var rt = !1;
      for (var it in V)
        if (Mo(V, it)) {
          for (var ht = !0, mt = 0; mt < Y.length; mt++)
            if (Math.abs((Pe.dimensions[mt] || 0) - (V[it].dimensions[mt] || 0)) > 1e-12) {
              ht = !1;
              break;
            }
          if (ht) {
            rt = !0, Pe.base = V[it];
            break;
          }
        }
      if (!rt) {
        de = de || W + "_STUFF";
        var _t = {
          dimensions: Re.dimensions.slice(0)
        };
        _t.key = de, V[de] = _t, Qe[de] = {
          unit: Pe,
          prefix: z.NONE[""]
        }, Pe.base = V[de];
      }
    } else {
      if (de = de || W + "_STUFF", Y.indexOf(de) >= 0)
        throw new Error('Cannot create new base unit "' + W + '": a base unit with that name already exists (and cannot be overridden)');
      Y.push(de);
      for (var qe in V)
        Mo(V, qe) && (V[qe].dimensions[Y.length - 1] = 0);
      for (var ke = {
        dimensions: []
      }, Xe = 0; Xe < Y.length; Xe++)
        ke.dimensions[Xe] = 0;
      ke.dimensions[Y.length - 1] = 1, ke.key = de, V[de] = ke, Pe = {
        name: W,
        value: 1,
        dimensions: V[de].dimensions.slice(0),
        prefixes: Ae,
        offset: oe,
        base: V[de]
      }, Qe[de] = {
        unit: Pe,
        prefix: z.NONE[""]
      };
    }
    v.UNITS[W] = Pe;
    for (var Ct = 0; Ct < Ee.length; Ct++) {
      var zt = Ee[Ct], jt = {};
      for (var lt in Pe)
        Mo(Pe, lt) && (jt[lt] = Pe[lt]);
      jt.name = zt, v.UNITS[zt] = jt;
    }
    return delete X.cache, new v(null, W);
  }, v.deleteUnit = function(W) {
    delete v.UNITS[W];
  }, v.PREFIXES = z, v.BASE_DIMENSIONS = Y, v.BASE_UNITS = V, v.UNIT_SYSTEMS = Ie, v.UNITS = pe, v;
}, {
  isClass: !0
}), QTe = "unit", IKn = ["typed", "Unit"], mKn = /* @__PURE__ */ Ar(QTe, IKn, (t) => {
  var {
    typed: e,
    Unit: n
  } = t;
  return e(QTe, {
    Unit: function(i) {
      return i.clone();
    },
    string: function(i) {
      return n.isValuelessUnit(i) ? new n(null, i) : n.parse(i, {
        allowNoUnits: !0
      });
    },
    "number | BigNumber | Fraction | Complex, string": function(i, o) {
      return new n(i, o);
    },
    "Array | Matrix": function(i) {
      return ac(i, this);
    }
  });
}), wTe = "dot", CKn = ["typed", "addScalar", "multiplyScalar", "conj", "size"], EKn = /* @__PURE__ */ Ar(wTe, CKn, (t) => {
  var {
    typed: e,
    addScalar: n,
    multiplyScalar: r,
    conj: i,
    size: o
  } = t;
  return e(wTe, {
    "Array | DenseMatrix, Array | DenseMatrix": a,
    "SparseMatrix, SparseMatrix": A
  });
  function s(c, u) {
    var f = l(c), h = l(u), d, I;
    if (f.length === 1)
      d = f[0];
    else if (f.length === 2 && f[1] === 1)
      d = f[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + f.join(", ") + ")");
    if (h.length === 1)
      I = h[0];
    else if (h.length === 2 && h[1] === 1)
      I = h[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + h.join(", ") + ")");
    if (d !== I)
      throw new RangeError("Vectors must have equal length (" + d + " != " + I + ")");
    if (d === 0)
      throw new RangeError("Cannot calculate the dot product of empty vectors");
    return d;
  }
  function a(c, u) {
    var f = s(c, u), h = cA(c) ? c._data : c, d = cA(c) ? c._datatype : void 0, I = cA(u) ? u._data : u, m = cA(u) ? u._datatype : void 0, C = l(c).length === 2, y = l(u).length === 2, v = n, b = r;
    if (d && m && d === m && typeof d == "string") {
      var Q = d;
      v = e.find(n, [Q, Q]), b = e.find(r, [Q, Q]);
    }
    if (!C && !y) {
      for (var w = b(i(h[0]), I[0]), R = 1; R < f; R++)
        w = v(w, b(i(h[R]), I[R]));
      return w;
    }
    if (!C && y) {
      for (var M = b(i(h[0]), I[0][0]), O = 1; O < f; O++)
        M = v(M, b(i(h[O]), I[O][0]));
      return M;
    }
    if (C && !y) {
      for (var L = b(i(h[0][0]), I[0]), N = 1; N < f; N++)
        L = v(L, b(i(h[N][0]), I[N]));
      return L;
    }
    if (C && y) {
      for (var k = b(i(h[0][0]), I[0][0]), $ = 1; $ < f; $++)
        k = v(k, b(i(h[$][0]), I[$][0]));
      return k;
    }
  }
  function A(c, u) {
    s(c, u);
    for (var f = c._index, h = c._values, d = u._index, I = u._values, m = 0, C = n, y = r, v = 0, b = 0; v < f.length && b < d.length; ) {
      var Q = f[v], w = d[b];
      if (Q < w) {
        v++;
        continue;
      }
      if (Q > w) {
        b++;
        continue;
      }
      Q === w && (m = C(m, y(h[v], I[b])), v++, b++);
    }
    return m;
  }
  function l(c) {
    return cA(c) ? c.size() : o(c);
  }
}), xTe = "lup", yKn = ["typed", "matrix", "abs", "addScalar", "divideScalar", "multiplyScalar", "subtract", "larger", "equalScalar", "unaryMinus", "DenseMatrix", "SparseMatrix", "Spa"], vKn = /* @__PURE__ */ Ar(xTe, yKn, (t) => {
  var {
    typed: e,
    matrix: n,
    abs: r,
    addScalar: i,
    divideScalar: o,
    multiplyScalar: s,
    subtract: a,
    larger: A,
    equalScalar: l,
    unaryMinus: c,
    DenseMatrix: u,
    SparseMatrix: f,
    Spa: h
  } = t;
  return e(xTe, {
    DenseMatrix: function(C) {
      return d(C);
    },
    SparseMatrix: function(C) {
      return I(C);
    },
    Array: function(C) {
      var y = n(C), v = d(y);
      return {
        L: v.L.valueOf(),
        U: v.U.valueOf(),
        p: v.p
      };
    }
  });
  function d(m) {
    var C = m._size[0], y = m._size[1], v = Math.min(C, y), b = cs(m._data), Q = [], w = [C, v], R = [], M = [v, y], O, L, N, k = [];
    for (O = 0; O < C; O++)
      k[O] = O;
    for (L = 0; L < y; L++) {
      if (L > 0)
        for (O = 0; O < C; O++) {
          var $ = Math.min(O, L), U = 0;
          for (N = 0; N < $; N++)
            U = i(U, s(b[O][N], b[N][L]));
          b[O][L] = a(b[O][L], U);
        }
      var X = L, K = 0, z = 0;
      for (O = L; O < C; O++) {
        var Y = b[O][L], V = r(Y);
        A(V, K) && (X = O, K = V, z = Y);
      }
      if (L !== X && (k[L] = [k[X], k[X] = k[L]][0], u._swapRows(L, X, b)), L < C)
        for (O = L + 1; O < C; O++) {
          var Z = b[O][L];
          l(Z, 0) || (b[O][L] = o(b[O][L], z));
        }
    }
    for (L = 0; L < y; L++)
      for (O = 0; O < C; O++) {
        if (L === 0 && (O < y && (R[O] = []), Q[O] = []), O < L) {
          O < y && (R[O][L] = b[O][L]), L < C && (Q[O][L] = 0);
          continue;
        }
        if (O === L) {
          O < y && (R[O][L] = b[O][L]), L < C && (Q[O][L] = 1);
          continue;
        }
        O < y && (R[O][L] = 0), L < C && (Q[O][L] = b[O][L]);
      }
    var ce = new u({
      data: Q,
      size: w
    }), ee = new u({
      data: R,
      size: M
    }), pe = [];
    for (O = 0, v = k.length; O < v; O++)
      pe[k[O]] = O;
    return {
      L: ce,
      U: ee,
      p: pe,
      toString: function() {
        return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
      }
    };
  }
  function I(m) {
    var C = m._size[0], y = m._size[1], v = Math.min(C, y), b = m._values, Q = m._index, w = m._ptr, R = [], M = [], O = [], L = [C, v], N = [], k = [], $ = [], U = [v, y], X, K, z, Y = [], V = [];
    for (X = 0; X < C; X++)
      Y[X] = X, V[X] = X;
    var Z = function(pe, Ce) {
      var Be = V[pe], Ie = V[Ce];
      Y[Be] = Ce, Y[Ie] = pe, V[pe] = Ie, V[Ce] = Be;
    }, ce = function() {
      var pe = new h();
      K < C && (O.push(R.length), R.push(1), M.push(K)), $.push(N.length);
      var Ce = w[K], Be = w[K + 1];
      for (z = Ce; z < Be; z++)
        X = Q[z], pe.set(Y[X], b[z]);
      K > 0 && pe.forEach(0, K - 1, function(Se, De) {
        f._forEachRow(Se, R, M, O, function(Ue, Te) {
          Ue > Se && pe.accumulate(Ue, c(s(Te, De)));
        });
      });
      var Ie = K, Qe = pe.get(K), xe = r(Qe);
      pe.forEach(K + 1, C - 1, function(Se, De) {
        var Ue = r(De);
        A(Ue, xe) && (Ie = Se, xe = Ue, Qe = De);
      }), K !== Ie && (f._swapRows(K, Ie, L[1], R, M, O), f._swapRows(K, Ie, U[1], N, k, $), pe.swap(K, Ie), Z(K, Ie)), pe.forEach(0, C - 1, function(Se, De) {
        Se <= K ? (N.push(De), k.push(Se)) : (De = o(De, Qe), l(De, 0) || (R.push(De), M.push(Se)));
      });
    };
    for (K = 0; K < y; K++)
      ce();
    return $.push(N.length), O.push(R.length), {
      L: new f({
        values: R,
        index: M,
        ptr: O,
        size: L
      }),
      U: new f({
        values: N,
        index: k,
        ptr: $,
        size: U
      }),
      p: Y,
      toString: function() {
        return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
      }
    };
  }
}), RTe = "det", BKn = ["typed", "matrix", "subtract", "multiply", "unaryMinus", "lup"], bKn = /* @__PURE__ */ Ar(RTe, BKn, (t) => {
  var {
    typed: e,
    matrix: n,
    subtract: r,
    multiply: i,
    unaryMinus: o,
    lup: s
  } = t;
  return e(RTe, {
    any: function(l) {
      return cs(l);
    },
    "Array | Matrix": function(l) {
      var c;
      switch (cA(l) ? c = l.size() : Array.isArray(l) ? (l = n(l), c = l.size()) : c = [], c.length) {
        case 0:
          return cs(l);
        case 1:
          if (c[0] === 1)
            return cs(l.valueOf()[0]);
          throw new RangeError("Matrix must be square (size: " + ua(c) + ")");
        case 2: {
          var u = c[0], f = c[1];
          if (u === f)
            return a(l.clone().valueOf(), u);
          throw new RangeError("Matrix must be square (size: " + ua(c) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + ua(c) + ")");
      }
    }
  });
  function a(A, l, c) {
    if (l === 1)
      return cs(A[0][0]);
    if (l === 2)
      return r(i(A[0][0], A[1][1]), i(A[1][0], A[0][1]));
    for (var u = s(A), f = u.U[0][0], h = 1; h < l; h++)
      f = i(f, u.U[h][h]);
    for (var d = 0, I = 0, m = []; ; ) {
      for (; m[I]; )
        I++;
      if (I >= l)
        break;
      for (var C = I, y = 0; !m[u.p[C]]; )
        m[u.p[C]] = !0, C = u.p[C], y++;
      y % 2 === 0 && d++;
    }
    return d % 2 === 0 ? f : o(f);
  }
}), DTe = "inv", _Kn = ["typed", "matrix", "divideScalar", "addScalar", "multiply", "unaryMinus", "det", "identity", "abs"], SKn = /* @__PURE__ */ Ar(DTe, _Kn, (t) => {
  var {
    typed: e,
    matrix: n,
    divideScalar: r,
    addScalar: i,
    multiply: o,
    unaryMinus: s,
    det: a,
    identity: A,
    abs: l
  } = t;
  return e(DTe, {
    "Array | Matrix": function(f) {
      var h = cA(f) ? f.size() : PI(f);
      switch (h.length) {
        case 1:
          if (h[0] === 1)
            return cA(f) ? n([r(1, f.valueOf()[0])]) : [r(1, f[0])];
          throw new RangeError("Matrix must be square (size: " + ua(h) + ")");
        case 2: {
          var d = h[0], I = h[1];
          if (d === I)
            return cA(f) ? n(c(f.valueOf(), d, I), f.storage()) : c(f, d, I);
          throw new RangeError("Matrix must be square (size: " + ua(h) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + ua(h) + ")");
      }
    },
    any: function(f) {
      return r(1, f);
    }
  });
  function c(u, f, h) {
    var d, I, m, C, y;
    if (f === 1) {
      if (C = u[0][0], C === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[r(1, C)]];
    } else if (f === 2) {
      var v = a(u);
      if (v === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[r(u[1][1], v), r(s(u[0][1]), v)], [r(s(u[1][0]), v), r(u[0][0], v)]];
    } else {
      var b = u.concat();
      for (d = 0; d < f; d++)
        b[d] = b[d].concat();
      for (var Q = A(f).valueOf(), w = 0; w < h; w++) {
        var R = l(b[w][w]), M = w;
        for (d = w + 1; d < f; )
          l(b[d][w]) > R && (R = l(b[d][w]), M = d), d++;
        if (R === 0)
          throw Error("Cannot calculate inverse, determinant is zero");
        d = M, d !== w && (y = b[w], b[w] = b[d], b[d] = y, y = Q[w], Q[w] = Q[d], Q[d] = y);
        var O = b[w], L = Q[w];
        for (d = 0; d < f; d++) {
          var N = b[d], k = Q[d];
          if (d !== w) {
            if (N[w] !== 0) {
              for (m = r(s(N[w]), O[w]), I = w; I < h; I++)
                N[I] = i(N[I], o(m, O[I]));
              for (I = 0; I < h; I++)
                k[I] = i(k[I], o(m, L[I]));
            }
          } else {
            for (m = O[w], I = w; I < h; I++)
              N[I] = r(N[I], m);
            for (I = 0; I < h; I++)
              k[I] = r(k[I], m);
          }
        }
      }
      return Q;
    }
  }
}), QKn = "divide", wKn = ["typed", "matrix", "multiply", "equalScalar", "divideScalar", "inv"], xKn = /* @__PURE__ */ Ar(QKn, wKn, (t) => {
  var {
    typed: e,
    matrix: n,
    multiply: r,
    equalScalar: i,
    divideScalar: o,
    inv: s
  } = t, a = VM({
    typed: e,
    equalScalar: i
  }), A = Nd({
    typed: e
  });
  return e("divide", sWe({
    // we extend the signatures of divideScalar with signatures dealing with matrices
    "Array | Matrix, Array | Matrix": function(c, u) {
      return r(c, s(u));
    },
    "DenseMatrix, any": function(c, u) {
      return A(c, u, o, !1);
    },
    "SparseMatrix, any": function(c, u) {
      return a(c, u, o, !1);
    },
    "Array, any": function(c, u) {
      return A(n(c), u, o, !1).valueOf();
    },
    "any, Array | Matrix": function(c, u) {
      return r(c, s(u));
    }
  }, o.signatures));
}), $q = /* @__PURE__ */ cVn({}), d1 = /* @__PURE__ */ sVn({
  config: Jf
}), Pfe = /* @__PURE__ */ IVn({}), qq = /* @__PURE__ */ hVn({}), f0 = /* @__PURE__ */ EVn({
  Matrix: Pfe
}), Ni = /* @__PURE__ */ l7n({
  BigNumber: d1,
  Complex: $q,
  DenseMatrix: f0,
  Fraction: qq
}), RKn = /* @__PURE__ */ vVn({
  typed: Ni
}), Ld = /* @__PURE__ */ _Vn({
  config: Jf,
  typed: Ni
}), kfe = /* @__PURE__ */ NVn({
  typed: Ni
}), jq = /* @__PURE__ */ BJn({
  typed: Ni
}), DKn = /* @__PURE__ */ $Jn({
  typed: Ni
}), kWe = /* @__PURE__ */ kVn({
  Fraction: qq,
  typed: Ni
}), Yq = /* @__PURE__ */ $Vn({
  typed: Ni
}), p1 = /* @__PURE__ */ zVn({
  typed: Ni
}), TKn = /* @__PURE__ */ DJn({
  typed: Ni
}), Gfe = /* @__PURE__ */ wVn({
  Matrix: Pfe,
  equalScalar: Ld,
  typed: Ni
}), YA = /* @__PURE__ */ UVn({
  DenseMatrix: f0,
  Matrix: Pfe,
  SparseMatrix: Gfe,
  typed: Ni
}), Ufe = /* @__PURE__ */ jVn({
  typed: Ni
}), GWe = /* @__PURE__ */ LJn({
  BigNumber: d1,
  DenseMatrix: f0,
  SparseMatrix: Gfe,
  config: Jf,
  matrix: YA,
  typed: Ni
}), NKn = /* @__PURE__ */ kJn({
  matrix: YA,
  config: Jf,
  typed: Ni
}), LKn = /* @__PURE__ */ UJn({
  BigNumber: d1,
  config: Jf,
  matrix: YA,
  typed: Ni
}), Hfe = /* @__PURE__ */ XJn({
  BigNumber: d1,
  DenseMatrix: f0,
  equalScalar: Ld,
  matrix: YA,
  typed: Ni,
  zeros: LKn
}), hK = /* @__PURE__ */ tKn({
  BigNumber: d1,
  DenseMatrix: f0,
  Fraction: qq,
  config: Jf,
  equalScalar: Ld,
  matrix: YA,
  typed: Ni
}), MKn = /* @__PURE__ */ oKn({
  DenseMatrix: f0,
  config: Jf,
  matrix: YA,
  typed: Ni
}), UWe = /* @__PURE__ */ aKn({
  DenseMatrix: f0,
  config: Jf,
  matrix: YA,
  typed: Ni
}), OKn = /* @__PURE__ */ cKn({
  larger: UWe,
  smaller: MKn
}), FKn = /* @__PURE__ */ EKn({
  addScalar: p1,
  conj: TKn,
  multiplyScalar: jq,
  size: NKn,
  typed: Ni
}), PKn = /* @__PURE__ */ sJn({
  config: Jf,
  equalScalar: Ld,
  matrix: YA,
  round: Hfe,
  typed: Ni
}), zq = /* @__PURE__ */ _Jn({
  addScalar: p1,
  dot: FKn,
  equalScalar: Ld,
  matrix: YA,
  multiplyScalar: jq,
  typed: Ni
}), kKn = /* @__PURE__ */ KJn({
  Complex: $q,
  config: Jf,
  fraction: kWe,
  identity: GWe,
  matrix: YA,
  multiply: zq,
  number: kfe,
  typed: Ni
}), GKn = /* @__PURE__ */ OVn({
  BigNumber: d1,
  typed: Ni
}), UKn = /* @__PURE__ */ YJn({
  bignumber: GKn,
  fraction: kWe,
  number: kfe
}), $fe = /* @__PURE__ */ QJn({
  DenseMatrix: f0,
  addScalar: p1,
  equalScalar: Ld,
  matrix: YA,
  typed: Ni,
  unaryMinus: Yq
}), HKn = /* @__PURE__ */ rKn({
  DenseMatrix: f0,
  equalScalar: Ld,
  matrix: YA,
  typed: Ni
}), $Kn = /* @__PURE__ */ eJn({
  config: Jf,
  equalScalar: Ld,
  matrix: YA,
  round: Hfe,
  typed: Ni
}), qKn = /* @__PURE__ */ rJn({
  Complex: $q,
  ceil: $Kn,
  floor: PKn,
  matrix: YA,
  typed: Ni
}), Vq = /* @__PURE__ */ VJn({
  numeric: UKn,
  typed: Ni
}), jKn = /* @__PURE__ */ gKn({
  FibonacciHeap: OKn,
  addScalar: p1,
  equalScalar: Ld
}), YKn = /* @__PURE__ */ vKn({
  DenseMatrix: f0,
  Spa: jKn,
  SparseMatrix: Gfe,
  abs: Ufe,
  addScalar: p1,
  divideScalar: Vq,
  equalScalar: Ld,
  larger: UWe,
  matrix: YA,
  multiplyScalar: jq,
  subtract: $fe,
  typed: Ni,
  unaryMinus: Yq
}), zKn = /* @__PURE__ */ bKn({
  lup: YKn,
  matrix: YA,
  multiply: zq,
  subtract: $fe,
  typed: Ni,
  unaryMinus: Yq
}), VKn = /* @__PURE__ */ SKn({
  abs: Ufe,
  addScalar: p1,
  det: zKn,
  divideScalar: Vq,
  identity: GWe,
  matrix: YA,
  multiply: zq,
  typed: Ni,
  unaryMinus: Yq
}), a5 = /* @__PURE__ */ xKn({
  divideScalar: Vq,
  equalScalar: Ld,
  inv: VKn,
  matrix: YA,
  multiply: zq,
  typed: Ni
}), JKn = /* @__PURE__ */ pKn({
  BigNumber: d1,
  Complex: $q,
  Fraction: qq,
  abs: Ufe,
  addScalar: p1,
  config: Jf,
  divideScalar: Vq,
  equal: HKn,
  fix: qKn,
  format: DKn,
  isNumeric: RKn,
  multiplyScalar: jq,
  number: kfe,
  pow: kKn,
  round: Hfe,
  subtract: $fe
}), up = /* @__PURE__ */ mKn({
  Unit: JKn,
  typed: Ni
});
const A5 = (t, e, n) => `rgb(${t || n === "light" && e?.every((i) => i === 255) ? [220, 220, 220] : e})`;
function PD(t, e) {
  if (!e)
    return e;
  const n = Array.isArray(t) ? t[t.length - 1] : t, { labels: r } = n;
  return ji(Object.entries(e).filter(([i]) => r.includes(i)));
}
async function KKn({ loader: t, selection: e }) {
  const n = Array.isArray(t) ? t[t.length - 1] : t, r = PD(t, e), i = await n.getRaster({ selection: r }), o = OD(i.data), { domain: s, contrastLimits: a } = o;
  return { domain: s, slider: a };
}
async function WKn({ loader: t, selection: e }) {
  const n = t[t.length - 1], r = PD(n, e), { shape: i, labels: o } = n, s = i[o.indexOf("z")] >> t.length - 1, a = await n.getRaster({
    selection: { ...r, z: 0 }
  }), A = await n.getRaster({
    selection: { ...r, z: Math.floor(s / 2) }
  }), l = await n.getRaster({
    selection: { ...r, z: Math.max(0, s - 1) }
  }), c = OD(a.data), u = OD(A.data), f = OD(l.data);
  return {
    domain: [
      Math.min(c.domain[0], u.domain[0], f.domain[0]),
      Math.max(c.domain[1], u.domain[1], f.domain[1])
    ],
    slider: [
      Math.min(c.contrastLimits[0], u.contrastLimits[0], f.contrastLimits[0]),
      Math.max(c.contrastLimits[1], u.contrastLimits[1], f.contrastLimits[1])
    ]
  };
}
const XKn = async ({ loader: t, selection: e, use3d: n }) => (n ? WKn : KKn)({ loader: t, selection: e }), cQ = async ({ loader: t, selections: e, use3d: n }) => {
  const r = await Promise.all(e.map((s) => XKn({ loader: t, selection: s, use3d: n }))), i = r.map((s) => s.domain), o = r.map((s) => s.slider);
  return { domains: i, sliders: o };
};
function ZKn(t) {
  const { x: e, y: n, z: r } = t?.meta?.physicalSizes ?? {};
  if (e?.size && n?.size && r?.size) {
    const i = Math.min(r.size, e.size, n.size), o = [e.size / i, n.size / i, r.size / i];
    return new pn().scale(o);
  }
  return new pn().identity();
}
function HWe(t) {
  const e = Array.isArray(t) ? t[0] : t, { shape: n, labels: r } = e, i = ZKn(e), o = [0, i[0] * n[r.indexOf("x")]], s = [0, i[5] * n[r.indexOf("y")]], a = [
    0,
    i[10] * n[r.indexOf("z")]
  ];
  return [o, s, a];
}
function Jq(t) {
  let n = 5;
  Number.isInteger(t) || --n, t < 1 && --n;
  const r = Intl.NumberFormat("en-US", {
    maximumSignificantDigits: n,
    useGrouping: !1
  }).format(t);
  return r.length <= 5 ? r : t.toExponential(0);
}
function eWn(t, e, n) {
  return [[t, e + n], [t + n, e], [t, e - n], [t - n, e]];
}
const kD = ["z", "t"], $We = "Min/Max", _re = {
  visible: !0,
  colormap: null,
  opacity: 1,
  domainType: $We,
  transparentColor: [0, 0, 0],
  renderingMode: Ife.ADDITIVE,
  use3d: !1
}, tWn = {
  opacity: 1,
  radius: 20,
  visible: !0
}, qWe = {
  opacity: 1,
  radius: 50,
  visible: !0,
  stroked: !1
};
function I1(t, e) {
  const { data: n } = t;
  return Array.isArray(n) ? n[e || n.length - 1] : n;
}
const qfe = (t, e) => {
  const { shape: n, labels: r } = t[e], i = n[r.indexOf("y")], o = n[r.indexOf("x")], s = n[r.indexOf("z")], a = Math.max(1, s >> e), A = 4 * i * o * a;
  return {
    height: i,
    width: o,
    depthDownsampled: a,
    totalBytes: A
  };
}, uQ = (t, e) => {
  const { totalBytes: n, height: r, width: i, depthDownsampled: o } = qfe(t, e), a = window.performance?.memory && window.performance?.memory?.jsHeapSizeLimit / 2 || 2 ** 31 - 1;
  return n < a && r <= 2048 && o <= 2048 && i <= 2048 && o > 1;
};
function oS(t, e) {
  const n = I1(t), { shape: r, dtype: i, labels: o } = n;
  return !!(r[o.includes("channel") ? o.indexOf("channel") : o.indexOf("c")] === 3 && i === "Uint8" || e && e.length === 3 && gr(e[0].color, [255, 0, 0]) && gr(e[1].color, [0, 255, 0]) && gr(e[2].color, [0, 0, 255]));
}
function nWn(t, e, n, r, i, o) {
  const s = !!n && !!o;
  if (!(!!t && !!r) || !(!!e && !!i))
    return new pn().identity();
  const l = [
    up(`${t} ${r}`.replace("µ", "u")),
    up(`${e} ${i}`.replace("µ", "u"))
  ];
  s && l.push(up(`${n} ${o}`.replace("µ", "u")));
  const c = l.map((u) => a5(u, up("1 um")));
  return l[0].equals(l[1]) || (c[1] = a5(l[1], l[0])), c[2] || (c[2] = 1), gr(c, [1, 1, 1]) ? new pn().identity() : new pn().scale([...c]);
}
function rWn(t, e) {
  const n = e.map((o) => I1(o));
  if (t.map((o) => o?.metadata?.transform?.matrix || o?.metadata?.transform?.scale || o?.metadata?.transform?.translate).some(Boolean) || n.every((o) => !o.meta?.physicalSizes?.x || !o.meta?.physicalSizes?.y))
    return t;
  const r = n.reduce((o, s) => {
    const a = s.meta?.physicalSizes?.z?.size, A = [
      up(`${s.meta?.physicalSizes.x.size} ${s.meta?.physicalSizes.x.unit}`.replace("µ", "u")),
      up(`${s.meta?.physicalSizes.y.size} ${s.meta?.physicalSizes.y.unit}`.replace("µ", "u"))
    ];
    return a && A.push(up(`${s.meta?.physicalSizes.z.size} ${s.meta?.physicalSizes.z.unit}`.replace("µ", "u"))), o[0] = o[0] === void 0 || hK(A[0], o[0]) === -1 ? A[0] : o[0], o[1] = o[1] === void 0 || hK(A[1], o[1]) === -1 ? A[1] : o[1], o[2] = o[2] === void 0 || hK(A[2], o[2]) === -1 ? A[2] : o[2], o;
  }, []);
  return t.map((o, s) => {
    const a = n[s], A = a.meta?.physicalSizes?.z?.size, l = [
      up(`${a.meta?.physicalSizes.x.size} ${a.meta?.physicalSizes.x.unit}`.replace("µ", "u")),
      up(`${a.meta?.physicalSizes.y.size} ${a.meta?.physicalSizes.y.unit}`.replace("µ", "u"))
    ];
    A && l.push(up(`${a.meta?.physicalSizes.z.size} ${a.meta?.physicalSizes.z.unit}`.replace("µ", "u")));
    const c = l.map((h, d) => a5(h, r[d]));
    if (l[0].equals(l[1]) || (c[1] = a5(l[1], l[0])), c[2] || (c[2] = 1), gr(c, [1, 1, 1]))
      return o;
    const u = new pn().scale([...c]), f = { ...o };
    return f.metadata = {
      ...f.metadata,
      // We don't want to store matrix objects in the view config.
      transform: { matrix: u.toArray() }
    }, f;
  });
}
function iWn(t) {
  const e = t.labels.filter((r) => kD.includes(r)), n = {};
  return e.forEach((r) => {
    n[r] = Math.floor((t.shape[t.labels.indexOf(r)] || 0) / 2);
  }), n;
}
function oWn(t) {
  const e = [], n = iWn(t), r = t.labels.filter((i) => !kD.includes(i) && t.shape[t.labels.indexOf(i)])[0];
  for (let i = 0; i < Math.min(4, t.shape[t.labels.indexOf(r)]); i += 1)
    e.push({
      [r]: i,
      ...n
    });
  return e;
}
function jfe(t) {
  const e = t[t.length - 1];
  return e === 3 || e === 4;
}
async function Sre(t, e) {
  const n = [], r = I1(t);
  let i = oWn(r);
  i = jfe(r.shape) ? [{ ...i[0], c: 0 }] : i;
  const o = await cQ({
    loader: t.data,
    selections: i,
    use3d: e
  }), s = oS(t, null) ? [[0, 255], [0, 255], [0, 255]] : o.domains, a = oS(t, null) ? [[255, 0, 0], [0, 255, 0], [0, 0, 255]] : null, A = oS(t, null) ? [[0, 255], [0, 255], [0, 255]] : o.sliders;
  return i.forEach((l, c) => {
    const u = s[c], f = A[c], h = {
      selection: l,
      // eslint-disable-next-line no-nested-ternary
      color: a ? a[c] : i.length !== 1 ? Y0[c] : [255, 255, 255],
      visible: !0,
      slider: f || u
    };
    n.push(h);
  }), n;
}
async function Kq(t, e, n) {
  const r = [];
  let i = [];
  const o = [], s = await Promise.all(t.map((A) => A.loaderCreator()));
  for (let A = 0; A < t.length; A++) {
    const l = t[A], c = s[A];
    r[A] = c, i[A] = l;
  }
  if (n && (i = rWn(i, r)), e) {
    const A = e.map((l) => t.findIndex((c) => c.name === l));
    for (let l = 0; l < A.length; l++) {
      const c = A[l], u = r[c], f = Sre(u).then((h) => Promise.resolve({
        type: i[c]?.metadata?.isBitmask ? "bitmask" : "raster",
        index: c,
        ..._re,
        channels: h.map((d, I) => ({
          ...d,
          ...i[c].channels ? i[c].channels[I] : []
        })),
        domainType: "Min/Max",
        modelMatrix: i[c]?.metadata?.transform?.matrix,
        transparentColor: l > 0 ? [0, 0, 0] : null
      }));
      o.push(f);
    }
  } else {
    const A = Math.floor(t.length / 2), l = r[A], c = Sre(l).then((u) => Promise.resolve({
      type: i[A]?.metadata?.isBitmask ? "bitmask" : "raster",
      index: A,
      ..._re,
      channels: u.map((f, h) => ({
        ...f,
        ...i[A].channels ? i[A].channels[h] : []
      })),
      modelMatrix: i[A]?.metadata?.transform?.matrix,
      transparentColor: A > 0 ? [0, 0, 0] : null
    }));
    o.push(c);
  }
  return [await Promise.all(o), r, i];
}
function Qre(t) {
  return t === "t" ? "time" : t === "c" ? "channel" : "space";
}
function Yfe(t) {
  let n = [
    { type: "time", name: "t" },
    { type: "channel", name: "c" },
    { type: "space", name: "z" },
    { type: "space", name: "y" },
    { type: "space", name: "x" }
  ];
  return t && (n = t.map((r) => {
    if (typeof r == "string")
      return { name: r, type: Qre(r) };
    const { name: i, type: o } = r;
    return { name: i, type: o ?? Qre(i) };
  })), n;
}
function zfe(t) {
  return t.toLowerCase().split("").map((e) => ({
    name: e,
    type: Qre(e)
  }));
}
function EI(t, e) {
  let n = new pn().identity();
  if (t && e) {
    const r = ["x", "y", "z"].map((i) => e.findIndex((o) => o.type === "space" && o.name === i));
    t.forEach((i) => {
      if (i.type === "translation") {
        const { translation: o } = i;
        if (o.length !== e.length)
          throw new Error("Length of translation array was expected to match length of axes.");
        const s = 0, a = r.map((l) => l >= 0 ? o[l] : s), A = new pn().translate(a);
        n = n.multiplyLeft(A);
      }
      if (i.type === "scale") {
        const { scale: o } = i;
        if (o.length !== e.length)
          throw new Error("Length of scale array was expected to match length of axes.");
        const s = 1, a = r.map((l) => l >= 0 ? o[l] : s), A = new pn().scale(a);
        n = n.multiplyLeft(A);
      }
    });
  }
  return n;
}
function jWe(t) {
  const e = /^#?([A-F\d]{2})([A-F\d]{2})([A-F\d]{2})$/i.exec(t);
  return [
    parseInt(e[1].toLowerCase(), 16),
    parseInt(e[2].toLowerCase(), 16),
    parseInt(e[3].toLowerCase(), 16)
  ];
}
function sWn(t, e) {
  let n = [];
  return Array.isArray(t) && (n = t.map((r) => {
    if (r.input && r.output) {
      const { type: i } = r;
      if (i === "translation")
        return {
          type: i,
          translation: r.translation
        };
      if (i === "scale")
        return {
          type: i,
          scale: r.scale
        };
      if (i === "identity")
        return { type: i };
      console.warn(`Coordinate transformation type "${i}" is not supported.`);
    }
    return r;
  })), Array.isArray(e?.[0]?.coordinateTransformations) && (n = [
    ...e[0].coordinateTransformations,
    ...n
  ]), n;
}
class ZM extends Error {
  constructor(e) {
    super(e), this.name = "NodeNotFoundError";
  }
}
class aWn extends Error {
  constructor(e) {
    super(e), this.name = "KeyError";
  }
}
var pf;
class YWe {
  constructor(e, n, r) {
    bl(this, pf, void 0);
    typeof e == "number" ? XA(this, pf, new Uint8Array(e)) : e instanceof ArrayBuffer ? XA(this, pf, new Uint8Array(e, n, r)) : XA(this, pf, new Uint8Array(Array.from(e, (i) => i ? 1 : 0)));
  }
  get BYTES_PER_ELEMENT() {
    return 1;
  }
  get byteOffset() {
    return Lo(this, pf).byteOffset;
  }
  get byteLength() {
    return Lo(this, pf).byteLength;
  }
  /** @type {ArrayBuffer} */
  get buffer() {
    return Lo(this, pf).buffer;
  }
  /** @type {number} */
  get length() {
    return Lo(this, pf).length;
  }
  get(e) {
    let n = Lo(this, pf)[e];
    return typeof n == "number" ? n !== 0 : n;
  }
  set(e, n) {
    Lo(this, pf)[e] = n ? 1 : 0;
  }
  fill(e) {
    Lo(this, pf).fill(e ? 1 : 0);
  }
  *[Symbol.iterator]() {
    for (let e = 0; e < this.length; e++)
      yield this.get(e);
  }
}
pf = new WeakMap();
var mS;
class Vfe {
  constructor(e, n, r, i) {
    Sr(this, "_data");
    Sr(this, "chars");
    bl(this, mS, void 0);
    if (this.chars = e, XA(this, mS, new TextEncoder()), typeof n == "number")
      this._data = new Uint8Array(n * e);
    else if (n instanceof ArrayBuffer)
      i && (i = i * e), this._data = new Uint8Array(n, r, i);
    else {
      let o = Array.from(n);
      this._data = new Uint8Array(o.length * e);
      for (let s = 0; s < o.length; s++)
        this.set(s, o[s]);
    }
  }
  get BYTES_PER_ELEMENT() {
    return this.chars;
  }
  get byteOffset() {
    return this._data.byteOffset;
  }
  get byteLength() {
    return this._data.byteLength;
  }
  /** @type {ArrayBuffer} */
  get buffer() {
    return this._data.buffer;
  }
  /** @type {number} */
  get length() {
    return this.byteLength / this.BYTES_PER_ELEMENT;
  }
  get(e) {
    const n = new Uint8Array(this.buffer, this.byteOffset + this.chars * e, this.chars);
    return new TextDecoder().decode(n).replace(/\x00/g, "");
  }
  set(e, n) {
    const r = new Uint8Array(this.buffer, this.byteOffset + this.chars * e, this.chars);
    r.fill(0), r.set(Lo(this, mS).encode(n));
  }
  fill(e) {
    const n = Lo(this, mS).encode(e);
    for (let r = 0; r < this.length; r++)
      this._data.set(n, r * this.chars);
  }
  *[Symbol.iterator]() {
    for (let e = 0; e < this.length; e++)
      yield this.get(e);
  }
}
mS = new WeakMap();
var K6;
const JIe = class {
  constructor(e, n, r, i) {
    Sr(this, "_data");
    Sr(this, "chars");
    bl(this, K6, void 0);
    if (this.chars = e, typeof n == "number")
      this._data = new Int32Array(n * e);
    else if (n instanceof ArrayBuffer)
      i && (i *= e), this._data = new Int32Array(n, r, i);
    else {
      const o = n, s = new JIe(e, 1);
      this._data = new Int32Array(function* () {
        for (let a of o)
          s.set(0, a), yield* s._data;
      }());
    }
    XA(this, K6, new Int32Array(e));
  }
  get BYTES_PER_ELEMENT() {
    return this._data.BYTES_PER_ELEMENT * this.chars;
  }
  get byteLength() {
    return this._data.byteLength;
  }
  get byteOffset() {
    return this._data.byteOffset;
  }
  /** @type {ArrayBuffer} */
  get buffer() {
    return this._data.buffer;
  }
  /** @type {number} */
  get length() {
    return this._data.length / this.chars;
  }
  get(e) {
    const n = this.chars * e;
    let r = "";
    for (let i = 0; i < this.chars; i++)
      r += String.fromCodePoint(this._data[n + i]);
    return r.replace(/\u0000/g, "");
  }
  set(e, n) {
    const r = this.chars * e, i = this._data.subarray(r, r + this.chars);
    i.fill(0);
    for (let o = 0; o < this.chars; o++)
      i[o] = n.codePointAt(o) ?? 0;
  }
  fill(e) {
    this.set(0, e);
    let n = this._data.subarray(0, this.chars);
    for (let r = 1; r < this.length; r++)
      this._data.set(n, r * this.chars);
  }
  *[Symbol.iterator]() {
    for (let e = 0; e < this.length; e++)
      yield this.get(e);
  }
};
let dN = JIe;
K6 = new WeakMap();
function Wq(t) {
  const e = new TextDecoder().decode(t);
  return JSON.parse(e);
}
function TTe(t, e) {
  const n = e / 2, r = e - 1;
  let i = 0;
  for (let o = 0; o < t.length; o += e)
    for (let s = 0; s < n; s += 1)
      i = t[o + s], t[o + s] = t[o + r - s], t[o + r - s] = i;
}
const AWn = {
  int8: Int8Array,
  int16: Int16Array,
  int32: Int32Array,
  int64: globalThis.BigInt64Array,
  uint8: Uint8Array,
  uint16: Uint16Array,
  uint32: Uint32Array,
  uint64: globalThis.BigUint64Array,
  float32: Float32Array,
  float64: Float64Array,
  bool: YWe
}, lWn = /v2:([US])(\d+)/;
function zWe(t) {
  if (t === "v2:object")
    return globalThis.Array;
  let e = t.match(lWn);
  if (e) {
    let [, r, i] = e;
    return (r === "U" ? dN : Vfe).bind(null, Number(i));
  }
  let n = AWn[t];
  if (!n)
    throw new Error(`Unknown or unsupported data_type: ${t}`);
  return n;
}
function fQ(t, e) {
  return (e === "C" ? cWn : uWn)(t);
}
function cWn(t) {
  const e = t.length, n = globalThis.Array(e);
  for (let r = e - 1, i = 1; r >= 0; r--)
    n[r] = i, i *= t[r];
  return n;
}
function uWn(t) {
  const e = t.length, n = globalThis.Array(e);
  for (let r = 0, i = 1; r < e; r++)
    n[r] = i, i *= t[r];
  return n;
}
function fWn({ name: t, configuration: e }) {
  if (t === "default")
    return (n) => ["c", ...n].join(e.separator);
  if (t === "v2")
    return (n) => n.join(e.separator) || "0";
  throw new Error(`Unknown chunk key encoding: ${t}`);
}
function wre(t) {
  return t.find((n) => n.name === "transpose")?.configuration?.order === "F" ? "F" : "C";
}
const gWn = /^([<|>])(.*)$/;
function hWn(t) {
  if (t === "|O")
    return { data_type: "v2:object" };
  let e = t.match(gWn);
  if (!e)
    throw new Error(`Invalid dtype: ${t}`);
  let [, n, r] = e, i = {
    b1: "bool",
    i1: "int8",
    u1: "uint8",
    i2: "int16",
    u2: "uint16",
    i4: "int32",
    u4: "uint32",
    i8: "int64",
    u8: "uint64",
    f4: "float32",
    f8: "float64"
  }[r] ?? (r.startsWith("S") || r.startsWith("U") ? `v2:${r}` : void 0);
  if (!i)
    throw new Error(`Unsupported or unknown dtype: ${t}`);
  return n === "|" ? { data_type: i } : { data_type: i, endian: n === "<" ? "little" : "big" };
}
function dWn(t, e = {}) {
  let n = [], r = hWn(t.dtype);
  t.order === "F" && n.push({ name: "transpose", configuration: { order: "F" } }), "endian" in r && r.endian === "big" && n.push({ name: "bytes", configuration: { endian: "big" } });
  for (let { id: i, ...o } of t.filters ?? [])
    n.push({ name: i, configuration: o });
  if (t.compressor) {
    let { id: i, ...o } = t.compressor;
    n.push({ name: i, configuration: o });
  }
  return {
    zarr_format: 3,
    node_type: "array",
    shape: t.shape,
    data_type: r.data_type,
    chunk_grid: {
      name: "regular",
      configuration: {
        chunk_shape: t.chunks
      }
    },
    chunk_key_encoding: {
      name: "v2",
      configuration: {
        separator: t.dimension_separator ?? "."
      }
    },
    codecs: n,
    fill_value: t.fill_value,
    attributes: e
  };
}
function pWn(t, e = {}) {
  return {
    zarr_format: 3,
    node_type: "group",
    attributes: e
  };
}
function IWn(t, e) {
  if (e !== "number" && e !== "bigint" && e !== "boolean" && e !== "object" && e !== "string")
    return t === e;
  let n = t === "bool";
  if (e === "boolean")
    return n;
  let r = t.startsWith("v2:U") || t.startsWith("v2:S");
  if (e === "string")
    return r;
  let i = t === "int64" || t === "uint64";
  if (e === "bigint")
    return i;
  let o = t === "v2:object";
  return e === "object" ? o : !r && !i && !n && !o;
}
function mWn(t) {
  return t?.name === "sharding_indexed";
}
function CWn(t) {
  return (t.data_type === "uint64" || t.data_type === "int64") && t.fill_value != null ? BigInt(t.fill_value) : t.fill_value;
}
function NTe(t) {
  return t instanceof YWe || t instanceof Vfe || t instanceof dN ? new Proxy(t, {
    get(e, n) {
      return e.get(Number(n));
    },
    set(e, n, r) {
      return e.set(Number(n), r), !0;
    }
  }) : t;
}
function EWn(t, e) {
  let n;
  return t.data instanceof Vfe || t.data instanceof dN ? n = new t.constructor(
    // @ts-expect-error
    t.data.length,
    t.data.chars
  ) : n = new t.constructor(t.data.length), {
    data: n,
    shape: t.shape,
    stride: fQ(t.shape, e)
  };
}
function yWn(t, e) {
  let n = EWn(t, e), r = t.shape.length, i = t.data.length, o = Array(r).fill(0), s = NTe(t.data), a = NTe(n.data);
  for (let A = 0; A < i; A++) {
    let l = 0;
    for (let c = 0; c < r; c++)
      l += o[c] * n.stride[c];
    a[l] = s[A], o[0] += 1;
    for (let c = 0; c < r; c++)
      if (o[c] === t.shape[c]) {
        if (c + 1 === r)
          break;
        o[c] = 0, o[c + 1] += 1;
      }
  }
  return n;
}
function vWn(t) {
  if (!t.stride)
    return "C";
  let e = fQ(t.shape, "C");
  return t.stride.every((n, r) => n === e[r]) ? "C" : "F";
}
class Jfe {
  constructor(e) {
    Sr(this, "configuration");
    Sr(this, "kind", "array_to_array");
    this.configuration = e;
  }
  static fromConfig(e) {
    return new Jfe(e);
  }
  encode(e) {
    return vWn(e) === this.configuration.order ? e : yWn(e, this.configuration.order);
  }
  decode(e) {
    return e;
  }
}
const LTe = BWn();
function BWn() {
  const t = new Uint32Array([305419896]);
  return new Uint8Array(t.buffer, t.byteOffset, t.byteLength)[0] !== 18;
}
function MTe(t) {
  return "BYTES_PER_ELEMENT" in t ? t.BYTES_PER_ELEMENT : 4;
}
var VN, iC, JN, KN, CS;
const KIe = class {
  constructor(e, n) {
    Sr(this, "kind", "array_to_bytes");
    bl(this, VN, void 0);
    bl(this, iC, void 0);
    bl(this, JN, void 0);
    bl(this, KN, void 0);
    bl(this, CS, void 0);
    XA(this, CS, e.endian), XA(this, iC, zWe(n.data_type)), XA(this, KN, n.shape), XA(this, VN, fQ(n.shape, wre(n.codecs)));
    const r = new (Lo(this, iC))(0);
    XA(this, JN, r.BYTES_PER_ELEMENT);
  }
  static fromConfig(e, n) {
    return new KIe(e, n);
  }
  encode(e) {
    let n = new Uint8Array(e.data.buffer);
    return LTe && Lo(this, CS) === "big" && TTe(n, MTe(Lo(this, iC))), n;
  }
  decode(e) {
    return LTe && Lo(this, CS) === "big" && TTe(e, MTe(Lo(this, iC))), {
      data: new (Lo(this, iC))(e.buffer, e.byteOffset, e.byteLength / Lo(this, JN)),
      shape: Lo(this, KN),
      stride: Lo(this, VN)
    };
  }
};
let l5 = KIe;
VN = new WeakMap(), iC = new WeakMap(), JN = new WeakMap(), KN = new WeakMap(), CS = new WeakMap();
class Kfe {
  constructor() {
    Sr(this, "kind", "bytes_to_bytes");
  }
  static fromConfig() {
    return new Kfe();
  }
  encode(e) {
    throw new Error("Not implemented");
  }
  decode(e) {
    return new Uint8Array(e.buffer, e.byteOffset, e.byteLength - 4);
  }
}
var WN, XN;
const WIe = class {
  constructor(e) {
    Sr(this, "kind", "array_to_bytes");
    bl(this, WN, void 0);
    bl(this, XN, void 0);
    XA(this, WN, e), XA(this, XN, fQ(e, "C"));
  }
  static fromConfig(e, n) {
    return new WIe(n.shape);
  }
  encode(e) {
    throw new Error("Method not implemented.");
  }
  decode(e) {
    let n = new TextDecoder(), r = new DataView(e.buffer), i = Array(r.getUint32(0, !0)), o = 4;
    for (let s = 0; s < i.length; s++) {
      let a = r.getUint32(o, !0);
      o += 4, i[s] = n.decode(e.buffer.slice(o, o + a)), o += a;
    }
    return { data: i, shape: Lo(this, WN), stride: Lo(this, XN) };
  }
};
let xre = WIe;
WN = new WeakMap(), XN = new WeakMap();
function bWn() {
  return (/* @__PURE__ */ new Map()).set("blosc", () => import("./blosc-1a207459.js").then((t) => t.default)).set("gzip", () => import("./gzip-f01f0894.js").then((t) => t.default)).set("lz4", () => import("./lz4-cf6d9a58.js").then((t) => t.default)).set("zlib", () => import("./zlib-78d53244.js").then((t) => t.default)).set("zstd", () => import("./zstd-c70336b5.js").then((t) => t.default)).set("transpose", () => Jfe).set("bytes", () => l5).set("crc32c", () => Kfe).set("vlen-utf8", () => xre);
}
const _Wn = bWn();
function Rre(t) {
  let e;
  return {
    async encode(n) {
      e || (e = await OTe(t));
      for (const i of e.array_to_array)
        n = await i.encode(n);
      let r = await e.array_to_bytes.encode(n);
      for (const i of e.bytes_to_bytes)
        r = await i.encode(r);
      return r;
    },
    async decode(n) {
      e || (e = await OTe(t));
      for (let i = e.bytes_to_bytes.length - 1; i >= 0; i--)
        n = await e.bytes_to_bytes[i].decode(n);
      let r = await e.array_to_bytes.decode(n);
      for (let i = e.array_to_array.length - 1; i >= 0; i--)
        r = await e.array_to_array[i].decode(r);
      return r;
    }
  };
}
async function OTe(t) {
  let e = t.codecs.map(async (o) => {
    let s = await _Wn.get(o.name)?.();
    if (!s)
      throw new Error(`Unknown codec: ${o.name}`);
    return { Codec: s, meta: o };
  }), n = [], r, i = [];
  for await (let { Codec: o, meta: s } of e) {
    let a = o.fromConfig(s.configuration, t);
    switch (a.kind) {
      case "array_to_array":
        n.push(a);
        break;
      case "array_to_bytes":
        r = a;
        break;
      default:
        i.push(a);
    }
  }
  if (!r) {
    if (!SWn(t))
      throw new Error(`Cannot encode ${t.data_type} to bytes without a codec`);
    r = l5.fromConfig({ endian: "little" }, t);
  }
  return { array_to_array: n, array_to_bytes: r, bytes_to_bytes: i };
}
function SWn(t) {
  return t.data_type !== "v2:object";
}
const FTe = 18446744073709551615n;
function QWn(t, e, n, r) {
  if (t.store.getRange === void 0)
    throw new Error("Store does not support range requests");
  let i = t.store.getRange.bind(t.store), o = e.map((A, l) => A / r.chunk_shape[l]), s = Rre({
    data_type: "uint64",
    shape: [...o, 2],
    codecs: r.index_codecs
  }), a = {};
  return async (A) => {
    let l = A.map((y, v) => Math.floor(y / o[v])), c = t.resolve(n(l)).path, u;
    if (c in a)
      u = a[c];
    else {
      let y = 4, v = 16 * o.reduce((Q, w) => Q * w, 1), b = await i(c, {
        suffixLength: v + y
      });
      u = a[c] = b ? await s.decode(b) : null;
    }
    if (u === null)
      return;
    let { data: f, shape: h, stride: d } = u, I = A.map((y, v) => y % h[v]).reduce((y, v, b) => y + v * d[b], 0), m = f[I], C = f[I + 1];
    if (!(m === FTe && C === FTe))
      return i(c, {
        offset: Number(m),
        length: Number(C)
      });
  };
}
class m1 {
  constructor(e, n = "/") {
    Sr(this, "store");
    Sr(this, "path");
    this.store = e, this.path = n;
  }
  resolve(e) {
    let n = new URL(`file://${this.path.endsWith("/") ? this.path : `${this.path}/`}`);
    return new m1(this.store, new URL(e, n).pathname);
  }
}
function Wfe(t) {
  return new m1(t ?? /* @__PURE__ */ new Map());
}
var ZN, x3e;
let Xfe = (x3e = class extends m1 {
  constructor(n, r, i) {
    super(n, r);
    Sr(this, "kind", "group");
    bl(this, ZN, void 0);
    XA(this, ZN, i);
  }
  get attrs() {
    return Lo(this, ZN).attributes;
  }
}, ZN = new WeakMap(), x3e);
const GR = Symbol("zarrita.context");
function wWn(t) {
  return t[GR];
}
function xWn(t, e) {
  let { configuration: n } = e.codecs.find(mWn) ?? {}, r = {
    encode_chunk_key: fWn(e.chunk_key_encoding),
    TypedArray: zWe(e.data_type),
    fill_value: e.fill_value
  };
  if (n) {
    let o = wre(n.codecs);
    return {
      ...r,
      kind: "sharded",
      chunk_shape: n.chunk_shape,
      codec: Rre({
        data_type: e.data_type,
        shape: n.chunk_shape,
        codecs: n.codecs
      }),
      get_strides(s, a) {
        return fQ(s, a ?? o);
      },
      get_chunk_bytes: QWn(t, e.chunk_grid.configuration.chunk_shape, r.encode_chunk_key, n)
    };
  }
  let i = wre(e.codecs);
  return {
    ...r,
    kind: "regular",
    chunk_shape: e.chunk_grid.configuration.chunk_shape,
    codec: Rre({
      data_type: e.data_type,
      shape: e.chunk_grid.configuration.chunk_shape,
      codecs: e.codecs
    }),
    get_strides(o, s) {
      return fQ(o, s ?? i);
    },
    async get_chunk_bytes(o, s) {
      let a = r.encode_chunk_key(o), A = t.resolve(a).path;
      return t.store.get(A, s);
    }
  };
}
var Cv, sLr, R3e;
let c5 = (R3e = class extends m1 {
  constructor(n, r, i) {
    super(n, r);
    Sr(this, "kind", "array");
    bl(this, Cv, void 0);
    Sr(this, sLr);
    XA(this, Cv, {
      ...i,
      fill_value: CWn(i)
    }), this[GR] = xWn(this, i);
  }
  get attrs() {
    return Lo(this, Cv).attributes;
  }
  get shape() {
    return Lo(this, Cv).shape;
  }
  get chunks() {
    return this[GR].chunk_shape;
  }
  get dtype() {
    return Lo(this, Cv).data_type;
  }
  async getChunk(n, r) {
    let i = this[GR], o = await i.get_chunk_bytes(n, r);
    if (!o) {
      let s = i.chunk_shape.reduce((A, l) => A * l, 1), a = new i.TypedArray(s);
      return a.fill(i.fill_value), {
        data: a,
        shape: i.chunk_shape,
        stride: i.get_strides(i.chunk_shape)
      };
    }
    return i.codec.decode(o);
  }
  /**
   * A helper method to narrow `zarr.Array` Dtype.
   *
   * ```typescript
   * let arr: zarr.Array<DataType, FetchStore> = zarr.open(store, { kind: "array" });
   *
   * // Option 1: narrow by scalar type (e.g. "bool", "raw", "bigint", "number")
   * if (arr.is("bigint")) {
   *   // zarr.Array<"int64" | "uint64", FetchStore>
   * }
   *
   * // Option 3: exact match
   * if (arr.is("float32")) {
   *   // zarr.Array<"float32", FetchStore, "/">
   * }
   * ```
   */
  is(n) {
    return IWn(this.dtype, n);
  }
}, sLr = GR, Cv = new WeakMap(), R3e);
function RWn() {
  let t = /* @__PURE__ */ new WeakMap();
  function e(n) {
    let r = t.get(n) ?? { v2: 0, v3: 0 };
    return t.set(n, r), r;
  }
  return {
    increment(n, r) {
      e(n)[r] += 1;
    },
    version_max(n) {
      let r = e(n);
      return r.v3 > r.v2 ? "v3" : "v2";
    }
  };
}
let Xq = RWn();
async function DWn(t) {
  let e = await t.store.get(t.resolve(".zattrs").path);
  return e ? Wq(e) : {};
}
async function TWn(t, e = {}) {
  let n = "store" in t ? t : new m1(t), r = {};
  return (e.attrs ?? !0) && (r = await DWn(n)), e.kind === "array" ? PTe(n, r) : e.kind === "group" ? kTe(n, r) : PTe(n, r).catch((i) => {
    if (i instanceof ZM)
      return kTe(n, r);
    throw i;
  });
}
async function PTe(t, e) {
  let { path: n } = t.resolve(".zarray"), r = await t.store.get(n);
  if (!r)
    throw new ZM(n);
  return Xq.increment(t.store, "v2"), new c5(t.store, t.path, dWn(Wq(r), e));
}
async function kTe(t, e) {
  let { path: n } = t.resolve(".zgroup"), r = await t.store.get(n);
  if (!r)
    throw new ZM(n);
  return Xq.increment(t.store, "v2"), new Xfe(t.store, t.path, pWn(Wq(r), e));
}
async function NWn(t) {
  let { store: e, path: n } = t.resolve("zarr.json"), r = await t.store.get(n);
  if (!r)
    throw new ZM(n);
  let i = Wq(r);
  return i.node_type === "array" && (i.data_type === "uint64" || i.data_type === "int64") && i.fill_value != null && (i.fill_value = BigInt(i.fill_value)), i.node_type === "array" ? new c5(e, t.path, i) : new Xfe(e, t.path, i);
}
async function LWn(t, e = {}) {
  let n = "store" in t ? t : new m1(t), r = await NWn(n);
  if (Xq.increment(n.store, "v3"), e.kind === void 0 || e.kind === "array" && r instanceof c5 || e.kind === "group" && r instanceof Xfe)
    return r;
  let i = r instanceof c5 ? "array" : "group";
  throw new Error(`Expected node of kind ${e.kind}, found ${i}.`);
}
async function fs(t, e = {}) {
  const n = "store" in t ? t.store : t, r = Xq.version_max(n);
  let i = r === "v2" ? fs.v2 : fs.v3, o = r === "v2" ? fs.v3 : fs.v2;
  return i(t, e).catch((s) => {
    if (s instanceof ZM)
      return o(t, e);
    throw s;
  });
}
fs.v2 = TWn;
fs.v3 = LWn;
function* MWn(t, e, n = 1) {
  e === void 0 && (e = t, t = 0);
  for (let r = t; r < e; r += n)
    yield r;
}
function* OWn(...t) {
  if (t.length === 0)
    return;
  const e = t.map((r) => r[Symbol.iterator]()), n = e.map((r) => r.next());
  if (n.some((r) => r.done))
    throw new Error("Input contains an empty iterator.");
  for (let r = 0; ; ) {
    if (n[r].done) {
      if (e[r] = t[r][Symbol.iterator](), n[r] = e[r].next(), ++r >= e.length)
        return;
    } else
      yield n.map(({ value: i }) => i), r = 0;
    n[r] = e[r].next();
  }
}
function FWn(t, e, n, r) {
  if (n === 0)
    throw new Error("slice step cannot be zero");
  n = n ?? 1;
  const i = n < 0, [o, s] = i ? [-1, r - 1] : [0, r];
  return t === null ? t = i ? s : o : t < 0 ? (t += r, t < o && (t = o)) : t > s && (t = s), e === null ? e = i ? o : s : e < 0 ? (e += r, e < o && (e = o)) : e > s && (e = s), [t, e, n];
}
function pB(t, e, n = null) {
  return e === void 0 && (e = t, t = null), {
    start: t,
    stop: e,
    step: n,
    indices(r) {
      return FWn(this.start, this.stop, this.step, r);
    }
  };
}
function PWn() {
  const t = [];
  return {
    add: (e) => t.push(e()),
    onIdle: () => Promise.all(t)
  };
}
class Zfe extends Error {
  constructor(e) {
    super(e), this.name = "IndexError";
  }
}
function kWn(t, e) {
  throw new Zfe(`too many indicies for array; expected ${e.length}, got ${t.length}`);
}
function GWn(t) {
  throw new Zfe(`index out of bounds for dimension with length ${t}`);
}
function UWn() {
  throw new Zfe("only slices with step >= 1 are supported");
}
function HWn(t, e) {
  t.length > e.length && kWn(t, e);
}
function $Wn(t, e) {
  return t = Math.trunc(t), t < 0 && (t = e + t), (t >= e || t < 0) && GWn(e), t;
}
class qWn {
  constructor({ dim_sel: e, dim_len: n, dim_chunk_len: r }) {
    Sr(this, "dim_sel");
    Sr(this, "dim_len");
    Sr(this, "dim_chunk_len");
    Sr(this, "nitems");
    e = $Wn(e, n), this.dim_sel = e, this.dim_len = n, this.dim_chunk_len = r, this.nitems = 1;
  }
  *[Symbol.iterator]() {
    const e = Math.floor(this.dim_sel / this.dim_chunk_len), n = e * this.dim_chunk_len, r = this.dim_sel - n;
    yield { dim_chunk_ix: e, dim_chunk_sel: r };
  }
}
class GTe {
  constructor({ dim_sel: e, dim_len: n, dim_chunk_len: r }) {
    Sr(this, "start");
    Sr(this, "stop");
    Sr(this, "step");
    Sr(this, "dim_len");
    Sr(this, "dim_chunk_len");
    Sr(this, "nitems");
    Sr(this, "nchunks");
    const [i, o, s] = e.indices(n);
    this.start = i, this.stop = o, this.step = s, this.step < 1 && UWn(), this.dim_len = n, this.dim_chunk_len = r, this.nitems = Math.max(0, Math.ceil((this.stop - this.start) / this.step)), this.nchunks = Math.ceil(this.dim_len / this.dim_chunk_len);
  }
  *[Symbol.iterator]() {
    const e = Math.floor(this.start / this.dim_chunk_len), n = Math.ceil(this.stop / this.dim_chunk_len);
    for (const r of MWn(e, n)) {
      const i = r * this.dim_chunk_len, o = Math.min(this.dim_len, (r + 1) * this.dim_chunk_len), s = o - i;
      let a = 0, A = 0;
      if (this.start < i) {
        const h = (i - this.start) % this.step;
        h && (A += this.step - h), a = Math.ceil((i - this.start) / this.step);
      } else
        A = this.start - i;
      const l = this.stop > o ? s : this.stop - i, c = [
        A,
        l,
        this.step
      ], u = Math.ceil((l - A) / this.step), f = [
        a,
        a + u,
        1
      ];
      yield { dim_chunk_ix: r, dim_chunk_sel: c, dim_out_sel: f };
    }
  }
}
function jWn(t, e) {
  let n = [];
  return t === null ? n = e.map((r) => pB(null)) : Array.isArray(t) && (n = t.map((r) => r ?? pB(null))), HWn(n, e), n;
}
class YWn {
  constructor({ selection: e, shape: n, chunk_shape: r }) {
    Sr(this, "dim_indexers");
    Sr(this, "shape");
    this.dim_indexers = jWn(e, n).map((i, o) => new (typeof i == "number" ? qWn : GTe)({
      // @ts-expect-error ts inference not strong enough to know correct chunk
      dim_sel: i,
      dim_len: n[o],
      dim_chunk_len: r[o]
    })), this.shape = this.dim_indexers.filter((i) => i instanceof GTe).map((i) => i.nitems);
  }
  *[Symbol.iterator]() {
    for (const e of OWn(...this.dim_indexers)) {
      const n = e.map((i) => i.dim_chunk_ix), r = e.map((i) => "dim_out_sel" in i ? { from: i.dim_chunk_sel, to: i.dim_out_sel } : { from: i.dim_chunk_sel, to: null });
      yield { chunk_coords: n, mapping: r };
    }
  }
}
function zWn(t, e) {
  return "get" in t ? t.get(e) : t[e];
}
async function VWn(t, e, n, r) {
  const i = wWn(t), o = new YWn({
    selection: e,
    shape: t.shape,
    chunk_shape: t.chunks
  }), s = r.prepare(new i.TypedArray(o.shape.reduce((A, l) => A * l, 1)), o.shape, i.get_strides(o.shape, n.order)), a = n.create_queue?.() ?? PWn();
  for (const { chunk_coords: A, mapping: l } of o)
    a.add(() => t.getChunk(A, n.opts).then(({ data: c, shape: u, stride: f }) => {
      const h = r.prepare(c, u, f);
      r.set_from_chunk(s, h, l);
    }).catch((c) => {
      if (!(c instanceof aWn))
        throw c;
      i.fill_value && r.set_scalar(s, l.map((u) => u.to).filter((u) => u !== null), i.fill_value);
    }));
  return await a.onIdle(), o.shape.length === 0 ? zWn(s.data, 0) : s;
}
function ege(t, e = 0, n) {
  let r = n ?? t.length - e;
  return {
    length: r,
    subarray(i, o = r) {
      return ege(t, e + i, o - i);
    },
    set(i, o = 0) {
      for (let s = 0; s < i.length; s++)
        t[e + o + s] = i.get(s);
    },
    get(i) {
      return t[e + i];
    }
  };
}
function dK(t) {
  return t.data instanceof globalThis.Array ? {
    // @ts-expect-error
    data: ege(t.data),
    stride: t.stride,
    bytes_per_element: 1
  } : {
    data: new Uint8Array(t.data.buffer, t.data.byteOffset, t.data.byteLength),
    stride: t.stride,
    bytes_per_element: t.data.BYTES_PER_ELEMENT
  };
}
function JWn(t) {
  return "chars" in t ? t.constructor.bind(null, t.chars) : t.constructor;
}
function KWn(t, e) {
  if (t.data instanceof globalThis.Array)
    return ege([e]);
  let n = JWn(t.data), r = new n([e]);
  return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
}
const WWn = {
  prepare(t, e, n) {
    return { data: t, shape: e, stride: n };
  },
  set_scalar(t, e, n) {
    let r = dK(t);
    Dre(r, e, KWn(t, n), r.bytes_per_element);
  },
  set_from_chunk(t, e, n) {
    let r = dK(t);
    jG(r, dK(e), r.bytes_per_element, n);
  }
};
async function Sp(t, e = null, n = {}) {
  return VWn(t, e, n, WWn);
}
function VWe(t, e, n) {
  return n < 0 && e < t ? Math.floor((t - e - 1) / -n) + 1 : t < e ? Math.floor((e - t - 1) / n) + 1 : 0;
}
function Dre(t, e, n, r) {
  if (e.length === 0) {
    t.data.set(n, 0);
    return;
  }
  const [i, ...o] = e, [s, ...a] = t.stride;
  if (typeof i == "number") {
    const f = t.data.subarray(s * i * r);
    Dre({ data: f, stride: a }, o, n, r);
    return;
  }
  const [A, l, c] = i, u = VWe(A, l, c);
  if (o.length === 0) {
    for (let f = 0; f < u; f++)
      t.data.set(n, s * (A + c * f) * r);
    return;
  }
  for (let f = 0; f < u; f++) {
    const h = t.data.subarray(s * (A + c * f) * r);
    Dre({ data: h, stride: a }, o, n, r);
  }
}
function jG(t, e, n, r) {
  const [i, ...o] = r, [s, ...a] = t.stride, [A, ...l] = e.stride;
  if (i.from === null) {
    if (o.length === 0) {
      t.data.set(e.data.subarray(0, n), i.to * n);
      return;
    }
    jG({
      data: t.data.subarray(s * i.to * n),
      stride: a
    }, e, n, o);
    return;
  }
  if (i.to === null) {
    if (o.length === 0) {
      let C = i.from * n;
      t.data.set(e.data.subarray(C, C + n), 0);
      return;
    }
    jG(t, {
      data: e.data.subarray(A * i.from * n),
      stride: l
    }, n, o);
    return;
  }
  const [c, u, f] = i.to, [h, d, I] = i.from, m = VWe(c, u, f);
  if (o.length === 0) {
    if (f === 1 && I === 1 && s === 1 && A === 1) {
      let C = h * n, y = m * n;
      t.data.set(e.data.subarray(C, C + y), c * n);
      return;
    }
    for (let C = 0; C < m; C++) {
      let y = A * (h + I * C) * n;
      t.data.set(e.data.subarray(y, y + n), s * (c + f * C) * n);
    }
    return;
  }
  for (let C = 0; C < m; C++)
    jG({
      data: t.data.subarray(s * (c + C * f) * n),
      stride: a
    }, {
      data: e.data.subarray(A * (h + C * I) * n),
      stride: l
    }, n, o);
}
function JWe(t, e, n, r = {}) {
  return e !== void 0 && n !== void 0 && (r = {
    ...r,
    headers: {
      ...r.headers,
      Range: `bytes=${e}-${e + n - 1}`
    }
  }), fetch(t, r);
}
function UTe(t, e) {
  const n = typeof t == "string" ? new URL(t) : t;
  n.pathname.endsWith("/") || (n.pathname += "/");
  const r = new URL(e.slice(1), n);
  return r.search = n.search, r;
}
async function HTe(t) {
  if (!(t.status === 404 || t.status === 403)) {
    if (t.status == 200 || t.status == 206)
      return new Uint8Array(await t.arrayBuffer());
    throw new Error(`Unexpected response status ${t.status} ${t.statusText}`);
  }
}
async function XWn(t, e, n, r) {
  if (r)
    return fetch(t, {
      ...n,
      headers: { ...n.headers, Range: `bytes=-${e}` }
    });
  let i = await fetch(t, { ...n, method: "HEAD" });
  if (!i.ok)
    return i;
  let o = i.headers.get("Content-Length"), s = Number(o);
  return JWe(t, s - e, s, n);
}
var ES, eL, tL, Tre;
class ZWn {
  constructor(e, n = {}) {
    bl(this, tL);
    Sr(this, "url");
    bl(this, ES, void 0);
    bl(this, eL, void 0);
    this.url = e, XA(this, ES, n.overrides ?? {}), XA(this, eL, n.useSuffixRequest ?? !1);
  }
  async get(e, n = {}) {
    let r = UTe(this.url, e).href, i = await fetch(r, lz(this, tL, Tre).call(this, n));
    return HTe(i);
  }
  async getRange(e, n, r = {}) {
    let i = UTe(this.url, e), o = lz(this, tL, Tre).call(this, r), s;
    return "suffixLength" in n ? s = await XWn(i, n.suffixLength, o, Lo(this, eL)) : s = await JWe(i, n.offset, n.length, o), HTe(s);
  }
}
ES = new WeakMap(), eL = new WeakMap(), tL = new WeakSet(), Tre = function(e) {
  return {
    ...Lo(this, ES),
    ...e,
    headers: {
      ...Lo(this, ES).headers,
      ...e.headers
    }
  };
};
const KWe = ZWn;
function eXn(t) {
  const e = {
    int8: "|i1",
    uint8: "|u1",
    int16: "<i2",
    uint16: "<u2",
    int32: "<i4",
    uint32: "<u4",
    int64: "<i8",
    uint64: "<u8",
    float32: "<f4",
    float64: "<f8"
  };
  if (!(t in e))
    throw new Error(`Unsupported dtype ${t}`);
  return e[t];
}
function hC(t) {
  return new Proxy(t, {
    get(e, n) {
      if (n === "getRaw")
        return (r) => Sp(e, r ? r.map((i) => typeof i == "object" && i !== null ? pB(i.start, i.stop, i.step) : i) : e.shape.map(() => null));
      if (n === "getRawChunk")
        throw new Error("getRawChunk should not have been called");
      return n === "dtype" ? eXn(e.dtype) : Reflect.get(e, n);
    }
  });
}
function Nre(t, e) {
  const n = new KWe(t, { overrides: e });
  return Wfe(n);
}
function tXn(t) {
  return 2 ** Math.floor(Math.log2(t));
}
function nXn(t) {
  const e = t[t.length - 1];
  return e === 3 || e === 4;
}
function WWe(t) {
  const e = nXn(t.shape), [n, r] = t.chunks.slice(e ? -3 : -2), i = Math.min(n, r);
  return tXn(i);
}
function rXn(t) {
  return typeof t[0] != "string";
}
async function iXn(t) {
  const e = (await fs(t)).attrs;
  let n = ["0"], r = ["t", "c", "z", "y", "x"];
  if ("multiscales" in e) {
    const { datasets: o, axes: s } = e.multiscales[0];
    n = o.map((a) => a.path), s && (rXn(s) ? r = s.map((a) => a.name) : r = s);
  }
  const i = n.map((o) => fs(t.resolve(o), { kind: "array" }));
  return {
    data: await Promise.all(i),
    rootAttrs: e,
    labels: r
  };
}
class Lre extends zHn {
  constructor(e, n, r) {
    super(e, n, r), this._readChunks = !1;
  }
}
async function XWe(t) {
  const { data: e, rootAttrs: n, labels: r } = await iXn(t), i = WWe(e[0]);
  return {
    data: e.map((s) => new Lre(hC(s), r, i)),
    metadata: n
  };
}
function oXn() {
  const t = {}, e = ["Int8", "Int16", "Int32"];
  return Object.keys(j8).forEach((n) => {
    const { max: r } = j8[n], i = e.includes(n) ? -(r + 1) : 0;
    t[n] = [i, r];
  }), t;
}
const u5 = oXn();
var ZWe = { exports: {} };
(function(t, e) {
  (function(n, r) {
    t.exports = r();
  })(ei, function(n) {
    return function(r) {
      if (typeof r != "number")
        throw new TypeError("Expected a number");
      if (r > 1e19)
        throw new RangeError("Input expected to be < 1e19");
      if (r < -1e19)
        throw new RangeError("Input expected to be > 1e19");
      if (Math.abs(r) < 1e3)
        return r;
      var i, o, s, a = r < 0 ? "-" : "", A = {
        K: 6,
        M: 9,
        B: 12,
        T: 16
      };
      r = Math.abs(r), s = Math.floor(r).toString().length, o = s % 3 === 0 ? s - 3 : s - s % 3, i = Math.round(10 * (r / Math.pow(10, o))) / 10;
      for (var l in A)
        if (o < A[l]) {
          i += l;
          break;
        }
      return a + i;
    };
  });
})(ZWe);
var sXn = ZWe.exports;
const aXn = /* @__PURE__ */ ko(sXn);
function AXn({ observationsCount: t, observationsLabel: e, subobservationsCount: n, subobservationsLabel: r, locationsCount: i }) {
  const o = [];
  if (n > 0) {
    let s = `${fI(n)} ${Bf(r, n)}`;
    i > 0 && (s += ` at ${aXn(i)} locations`), o.push(s);
  }
  return t > 0 && o.push(`${fI(t)} ${Bf(e, t)}`), o.join(", ");
}
function lXn({ width: t, height: e, obsCentroids: n, obsSegmentations: r, obsSegmentationsType: i, imageLayerLoaders: o, useRaster: s, use3d: a, modelMatrices: A }) {
  let l = -1 / 0, c = -1 / 0, u = -1 / 0, f = -1 / 0;
  const h = a ? 1.5 : 0.1;
  if (o.length > 0 && s)
    for (let d = 0; d < o.length; d += 1) {
      const I = { height: e, width: t }, { target: m, zoom: C } = aQ(o[d].data, I, h, a, new pn(A[d]));
      m[0] > l && (l = m[0], f = C), m[1] > c && (c = m[1], f = C), m[2] > u ? (u = m[2], f = C) : u = null;
    }
  else if (!s && (i === "polygon" && r || !r && n)) {
    let d, I, m, C;
    n && (d = fa(n.data[0]), I = fa(n.data[1]), m = d[1] - d[0], C = I[1] - I[0]), (!n || m === 0) && (d = fa(r.data, (y) => y[0][0]), m = d[1] - d[0]), (!n || C === 0) && (I = fa(r.data, (y) => y[0][1]), C = I[1] - I[0]), l = d[0] + m / 2, c = I[0] + C / 2, u = null, f = Math.log2(Math.min(t / m, e / C)) - h;
  } else
    return {
      initialTargetX: null,
      initialTargetY: null,
      initialTargetZ: null,
      initialZoom: null
    };
  return {
    initialTargetX: l,
    initialTargetY: c,
    initialZoom: f,
    initialTargetZ: u
  };
}
function cXn(t, e) {
  const n = Array.isArray(t) && t.length > 1 || !Array.isArray(t) ? t : t[0];
  return e ? [Dq, Array.isArray(n) ? n : [n]] : [Array.isArray(t) && t.length > 1 ? sx : ox, n];
}
function uXn(t) {
  const { bbox: { left: e, top: n, right: r, bottom: i }, index: { x: o, y: s, z: a } } = t.tile, { data: A, id: l, loader: c } = t;
  if ([e, i, r, n].some((I) => I < 0) || !A)
    return null;
  const u = c[0], [f, h] = c[0].shape.slice(-2), d = [
    e,
    A.height < u.tileSize ? f : i,
    A.width < u.tileSize ? h : r,
    n
  ];
  return new bfe(t, {
    channelData: A,
    // Uncomment to help debugging - shades the tile being hovered over.
    // autoHighlight: true,
    // highlightColor: [80, 80, 80, 50],
    // Shared props with BitmapLayer:
    bounds: d,
    id: `sub-layer-${d}-${l}`,
    tileId: { x: o, y: s, z: a }
  });
}
const $Te = "cells-layer", fXn = "molecules-layer", gXn = "neighborhoods-layer", hXn = (t, e, n) => (r, { index: i }) => {
  const [o, s, a, A] = t && e && t.get(e[i]) || da(n);
  return [o, s, a, 255 * (A || 1)];
}, dXn = (t) => {
  if (t) {
    const e = new Set(t);
    return (n) => e.has(n[0]) ? 1 : 0;
  }
  return () => 0;
}, pK = (t) => (e) => [
  t.data[0][e],
  t.data[1][e],
  0
];
function pXn(t, e, n) {
  return t ? e ? n === "Minimum Intensity Projection" ? [new eS.MinimumIntensityProjectionExtension()] : n === "Maximum Intensity Projection" ? [new eS.MaximumIntensityProjectionExtension()] : [new eS.AdditiveBlendExtension()] : n === "Minimum Intensity Projection" ? [new TC.MinimumIntensityProjectionExtension()] : n === "Maximum Intensity Projection" ? [new TC.MaximumIntensityProjectionExtension()] : [new TC.AdditiveBlendExtension()] : e ? [new xq()] : [new tx()];
}
let IXn = class extends Qfe {
  constructor(e) {
    super(e), this.obsSegmentationsQuadTree = null, this.obsSegmentationsData = null, this.obsLocationsData = null, this.imageLayers = [], this.obsSegmentationsBitmaskLayers = [], this.obsSegmentationsPolygonLayer = null, this.obsLocationsLayer = null, this.neighborhoodsLayer = null, this.layerLoaderSelections = {}, this.randomColorData = {
      data: new Uint8Array(2048 * 2048 * 3).map((n, r) => r < 4 ? 0 : Math.round(255 * Math.random())),
      // This buffer should be able to hold colors for 2048 x 2048 ~ 4 million cells.
      height: 2048,
      width: 2048
    }, this.color = { ...this.randomColorData }, this.expression = {
      data: new Uint8Array(2048 * 2048),
      // This buffer should be able to hold colors for 2048 x 2048 ~ 4 million cells.
      height: 2048,
      width: 2048
    }, this.onUpdateCellsData(), this.onUpdateCellsLayer(), this.onUpdateMoleculesData(), this.onUpdateMoleculesLayer(), this.onUpdateNeighborhoodsData(), this.onUpdateNeighborhoodsLayer(), this.onUpdateImages();
  }
  createPolygonSegmentationsLayer(e, n) {
    const { stroked: r, visible: i, opacity: o, radius: s } = e, { obsCentroidsIndex: a, obsSegmentationsIndex: A } = this.props, l = n ? A : a, {
      theme: c,
      // cellFilter,
      cellSelection: u,
      setCellHighlight: f,
      setComponentHover: h,
      getCellIsSelected: d = dXn(l.length === u.length ? null : u),
      cellColors: I,
      getCellColor: m = hXn(I, l, c),
      onCellClick: C,
      lineWidthScale: y = 10,
      lineWidthMaxPixels: v = 2,
      geneExpressionColormapRange: b,
      cellColorEncoding: Q,
      getExpressionValue: w,
      geneExpressionColormap: R
    } = this.props, M = n ? (O, { index: L, data: N }) => N.src.obsSegmentations.data[L] : (O, { index: L, data: N }) => {
      const k = N.src.obsCentroids.data[0][L], $ = N.src.obsCentroids.data[1][L], U = s;
      return [[k, $ + U], [k + U, $], [k, $ - U], [k - U, $]];
    };
    return new Pf({
      id: $Te,
      data: this.obsSegmentationsData,
      coordinateSystem: wn.CARTESIAN,
      pickable: !0,
      autoHighlight: !0,
      filled: !0,
      stroked: !0,
      backgroundColor: [0, 0, 0],
      isSelected: d,
      getPolygon: M,
      updateTriggers: {
        getLineWidth: [r],
        isSelected: u,
        getExpressionValue: w,
        getFillColor: [o, Q, u, I],
        getLineColor: [Q, u, I],
        getPolygon: [s]
      },
      getFillColor: (O, { index: L }) => {
        const N = m(O, { index: L });
        return N[3] = o * 255, N;
      },
      getLineColor: (O, { index: L }) => {
        const N = m(O, { index: L });
        return N[3] = 255, N;
      },
      onClick: (O) => {
        C && C(O);
      },
      onHover: _Ke(l, f, h),
      visible: i,
      getLineWidth: r ? 1 : 0,
      lineWidthScale: y,
      lineWidthMaxPixels: v,
      getExpressionValue: w,
      extensions: [new oQ()],
      colorScaleLo: b[0],
      colorScaleHi: b[1],
      isExpressionMode: Q === "geneSelection",
      colormap: R
    });
  }
  createMoleculesLayer(e) {
    const { obsLocations: n, obsLocationsFeatureIndex: r, setMoleculeHighlight: i } = this.props, o = (s, { data: a, index: A }) => {
      const l = a.src.obsLabelsTypes.indexOf(a.src.obsLabels[A]);
      return a.src.PALETTE[l % a.src.PALETTE.length];
    };
    return new LI({
      id: fXn,
      data: this.obsLocationsData,
      coordinateSystem: wn.CARTESIAN,
      pickable: !0,
      autoHighlight: !0,
      radiusMaxPixels: 3,
      opacity: e.opacity,
      visible: e.visible,
      getRadius: e.radius,
      getPosition: (s, { data: a, index: A, target: l }) => (l[0] = a.src.obsLocations.data[0][A], l[1] = a.src.obsLocations.data[1][A], l[2] = 0, l),
      getLineColor: o,
      getFillColor: o,
      onHover: (s) => {
        i && (s.object ? i(s.object[3]) : i(null));
      },
      updateTriggers: {
        getRadius: [e],
        getPosition: [n],
        getLineColor: [r],
        getFillColor: [r]
      }
    });
  }
  createNeighborhoodsLayer(e) {
    const { getNeighborhoodPolygon: n = (i) => i[1].poly } = this.props, { neighborhoodsEntries: r } = this;
    return new Pf({
      id: gXn,
      getPolygon: n,
      coordinateSystem: wn.CARTESIAN,
      data: r,
      pickable: !0,
      autoHighlight: !0,
      stroked: !0,
      filled: !1,
      getElevation: 0,
      getLineWidth: 10,
      visible: e.visible
    });
  }
  createSelectionLayer() {
    const { obsCentroidsIndex: e, obsCentroids: n } = this.props, { viewState: r, setCellSelection: i } = this.props, { tool: o } = this.state, { obsSegmentationsQuadTree: s } = this, a = pK(n);
    return $ue(o, r.zoom, $Te, [
      {
        getObsCoords: a,
        obsIndex: e,
        obsQuadTree: s,
        onSelect: (A) => {
          i(A);
        }
      }
    ]);
  }
  createScaleBarLayer() {
    const { viewState: e, width: n, height: r, imageLayerLoaders: i = {}, imageLayerDefs: o } = this.props, s = (o || []).some((u) => u.use3d), a = Object.values(i);
    if (!e || !n || !r || a.length < 1)
      return null;
    const A = a[0];
    if (!A)
      return null;
    const l = I1(A);
    if (!l.meta)
      return null;
    const { physicalSizes: c } = l.meta;
    if (c && !s) {
      const { x: u } = c, { unit: f, size: h } = u;
      return f && h ? new Rq({
        id: "scalebar-layer",
        unit: f,
        size: h,
        snap: !0,
        viewState: { ...e, width: n, height: r }
      }) : null;
    }
    return null;
  }
  createRasterLayer(e, n, r) {
    const i = {
      ...e,
      channels: e.channels.filter((y) => y.selection && y.color && y.slider)
    };
    let o;
    const s = i.channels.map((y) => y.selection), a = this.layerLoaderSelections[i.index];
    gr(a, s) ? o = a : (o = s, this.layerLoaderSelections[i.index] = s);
    const A = !i.visible && typeof i.visible == "boolean" || !!i.transparentColor, l = A ? [0, 0, 0] : null, c = {
      colormap: i.colormap,
      opacity: i.opacity,
      useTransparentColor: A,
      transparentColor: l,
      colors: i.channels.map((y) => y.color),
      sliders: i.channels.map((y) => y.slider),
      resolution: i.resolution,
      renderingMode: i.renderingMode,
      xSlice: i.xSlice,
      ySlice: i.ySlice,
      zSlice: i.zSlice,
      callback: i.callback,
      visibilities: i.channels.map((y) => !i.visible && typeof i.visible == "boolean" ? !1 : y.visible),
      excludeBackground: A
    };
    if (!n || !c)
      return null;
    const { metadata: { transform: u }, data: f } = n;
    let h;
    if (u) {
      const { scale: y, translate: v } = u;
      h = new pn().translate([v.x, v.y, 0]).scale(y);
    } else
      i.modelMatrix && (h = new pn(i.modelMatrix));
    if (e.type === "bitmask") {
      const { geneExpressionColormap: y, geneExpressionColormapRange: v = [0, 1], cellColorEncoding: b } = this.props;
      return new sx({
        // `bitmask` is used by the AbstractSpatialOrScatterplot
        // https://github.com/vitessce/vitessce/pull/927/files#diff-9cab35a2ca0c5b6d9754b177810d25079a30ca91efa062d5795181360bc3ff2cR111
        id: `bitmask-layer-${i.index}-${r}`,
        channelsVisible: c.visibilities,
        opacity: c.opacity,
        modelMatrix: h,
        hoveredCell: Number(this.props.cellHighlight),
        renderSubLayers: uXn,
        loader: f,
        selections: o,
        // For some reason, deck.gl doesn't recognize the prop diffing
        // unless these are separated out.  I don't think it's a bug, just
        // has to do with the fact that we don't have it in the `defaultProps`,
        // could be wrong though.
        cellColorData: this.color.data,
        cellTexHeight: this.color.height,
        cellTexWidth: this.color.width,
        excludeBackground: !0,
        onViewportLoad: c.callback,
        colorScaleLo: v[0],
        colorScaleHi: v[1],
        isExpressionMode: b === "geneSelection",
        colormap: y,
        expressionData: this.expression.data
        // There is no onHover here,
        // see the onHover method of AbstractSpatialOrScatterplot.
      });
    }
    const [d, I] = cXn(f, i.use3d), m = pXn(i.use3d, c.colormap, c.renderingMode), C = {};
    return jfe((Array.isArray(f) ? f[0] : f).shape) && (C.visible = i.visible), new d({
      loader: I,
      id: `${i.use3d ? "volume" : "image"}-layer-${i.index}-${r}`,
      colors: c.colors,
      contrastLimits: c.sliders,
      selections: o,
      channelsVisible: c.visibilities,
      opacity: c.opacity,
      colormap: c.colormap,
      modelMatrix: h,
      transparentColor: c.transparentColor,
      useTransparentColor: c.useTransparentColor,
      resolution: c.resolution,
      renderingMode: c.renderingMode,
      pickable: !1,
      xSlice: c.xSlice,
      ySlice: c.ySlice,
      zSlice: c.zSlice,
      onViewportLoad: c.callback,
      excludeBackground: c.excludeBackground,
      extensions: m,
      ...C
    });
  }
  use3d() {
    const { imageLayerDefs: e } = this.props;
    return (e || []).some((n) => n.use3d);
  }
  createImageLayers() {
    const { imageLayerDefs: e, imageLayerLoaders: n = {}, imageLayerCallbacks: r = [] } = this.props, i = this.use3d(), o = (e || []).findIndex((s) => s.use3d);
    return (e || []).filter((s) => i ? s.use3d === i : !0).map((s, a) => this.createRasterLayer({ ...s, callback: r[i ? o : a] }, n[s.index], a));
  }
  createBitmaskLayers() {
    const { obsSegmentationsLayerDefs: e, obsSegmentations: n, obsSegmentationsType: r, segmentationLayerCallbacks: i = [] } = this.props;
    if (n && r === "bitmask" && Array.isArray(e)) {
      const { loaders: o = [] } = n, s = e.some((A) => A.use3d), a = e.findIndex((A) => A.use3d);
      return e.filter((A) => s ? A.use3d === s : !0).map((A, l) => this.createRasterLayer({ ...A, callback: i[s ? a : l] }, o[A.index], l));
    }
    return [];
  }
  getLayers() {
    const { imageLayers: e, obsSegmentationsPolygonLayer: n, neighborhoodsLayer: r, obsLocationsLayer: i, obsSegmentationsBitmaskLayers: o } = this;
    return [
      ...e,
      ...o,
      n,
      r,
      i,
      this.createScaleBarLayer(),
      this.createSelectionLayer()
    ];
  }
  onUpdateCellsData() {
    const { obsSegmentations: e, obsSegmentationsType: n, obsCentroids: r } = this.props;
    if (e && n === "polygon" || !e && r) {
      const i = pK(r);
      this.obsSegmentationsQuadTree = FD(r, i), this.obsSegmentationsData = {
        src: {
          obsSegmentations: e,
          obsCentroids: r
        },
        length: e ? e.shape[0] : r.shape[1]
      };
    }
  }
  onUpdateCellsLayer() {
    const { obsSegmentationsLayerDefs: e, obsSegmentationsIndex: n, obsSegmentations: r, obsSegmentationsType: i, obsCentroids: o, obsCentroidsIndex: s, hasSegmentations: a } = this.props;
    e && n && r && i === "polygon" ? this.obsSegmentationsPolygonLayer = this.createPolygonSegmentationsLayer(e, !0) : e && r && i === "bitmask" ? this.obsSegmentationsBitmaskLayers = this.createBitmaskLayers() : !a && e && !r && !n && o && s ? this.obsSegmentationsPolygonLayer = this.createPolygonSegmentationsLayer(e, !1) : this.obsSegmentationsPolygonLayer = null;
  }
  onUpdateCellColors() {
    const e = this.randomColorData, { size: n } = this.props.cellColors;
    if (typeof n == "number") {
      const r = this.props.cellColors.keys();
      e.data = new Uint8Array(e.height * e.width * 3).fill(da(this.props.theme)[0]), e.data[0] = 0, e.data[1] = 0, e.data[2] = 0;
      for (const i of r)
        if (i > 0) {
          const o = this.props.cellColors.get(i);
          o && e.data.set(o.slice(0, 3), Number(i) * 3);
        }
    }
    this.color = e;
  }
  onUpdateExpressionData() {
    const { expressionData: e } = this.props;
    e[0]?.length && (this.expression.data = new Uint8Array(this.expression.height * this.expression.width), this.expression.data.set(e[0]));
  }
  onUpdateMoleculesData() {
    const { obsLocations: e, obsLocationsLabels: n, obsLocationsFeatureIndex: r } = this.props;
    e && n && r && (this.obsLocationsData = {
      src: {
        obsLabels: n,
        obsLocations: e,
        obsLabelsTypes: r,
        PALETTE: Gv
      },
      length: e.shape[1]
    });
  }
  onUpdateMoleculesLayer() {
    const { obsLocationsLayerDefs: e, obsLocations: n, obsLocationsIndex: r, obsLocationsLabels: i, obsLocationsFeatureIndex: o } = this.props;
    e && n?.data && r && i && o ? this.obsLocationsLayer = this.createMoleculesLayer(e) : this.obsLocationsLayer = null;
  }
  onUpdateNeighborhoodsData() {
    const { neighborhoods: e = {} } = this.props, n = Object.entries(e);
    this.neighborhoodsEntries = n;
  }
  onUpdateNeighborhoodsLayer() {
    const { neighborhoodLayerDefs: e } = this.props;
    e ? this.neighborhoodsLayer = this.createNeighborhoodsLayer(e) : this.neighborhoodsLayer = null;
  }
  onUpdateImages() {
    this.imageLayers = this.createImageLayers();
  }
  viewInfoDidUpdate() {
    const { obsCentroidsIndex: e, obsCentroids: n } = this.props;
    super.viewInfoDidUpdate(e, n, pK);
  }
  recenter() {
    const { originalViewState: e, setViewState: n } = this.props;
    Array.isArray(e?.target) && typeof e?.zoom == "number" && n(e);
  }
  /**
   * Here, asynchronously check whether props have
   * updated which require re-computing memoized variables,
   * followed by a re-render.
   * This function does not follow React conventions or paradigms,
   * it is only implemented this way to try to squeeze out
   * performance.
   * @param {object} prevProps The previous props to diff against.
   */
  componentDidUpdate(e) {
    this.viewInfoDidUpdate();
    const n = (i) => e[i] !== this.props[i];
    let r = !1;
    [
      "obsSegmentations",
      "obsSegmentationsType",
      "obsCentroids"
    ].some(n) && (this.onUpdateCellsData(), r = !0), ["cellColors"].some(n) && (this.onUpdateCellColors(), r = !0), ["expressionData"].some(n) && (this.onUpdateExpressionData(), r = !0), [
      "obsSegmentationsLayerDefs",
      "obsSegmentations",
      "obsSegmentationsIndex",
      "obsSegmentationsType",
      "obsCentroids",
      "obsCentroidsIndex",
      "hasSegmentations",
      "cellFilter",
      "cellSelection",
      "geneExpressionColormapRange",
      "expressionData",
      "cellColorEncoding",
      "geneExpressionColormap",
      "segmentationLayerCallbacks"
    ].some(n) && (this.onUpdateCellsLayer(), r = !0), [
      "obsLocations",
      "obsLocationsLabels",
      "obsLocationsFeatureIndex"
    ].some(n) && (this.onUpdateMoleculesData(), r = !0), [
      "obsLocationsLayerDefs",
      "obsLocations",
      "obsLocationsIndex",
      "obsLocationsLabels",
      "obsLocationsFeatureIndex"
    ].some(n) && (this.onUpdateMoleculesLayer(), r = !0), ["neighborhoods"].some(n) && (this.onUpdateNeighborhoodsData(), r = !0), ["neighborhoodLayerDefsDefs", "neighborhoods"].some(n) && (this.onUpdateNeighborhoodsLayer(), r = !0), [
      "imageLayerDefs",
      "imageLayerLoaders",
      "cellColors",
      "cellHighlight",
      "geneExpressionColormapRange",
      "expressionData",
      "imageLayerCallbacks",
      "geneExpressionColormap"
    ].some(n) && (this.onUpdateImages(), r = !0), r && this.forceUpdate();
  }
};
const eXe = CE((t, e) => ne.jsx(IXn, { ...t, deckRef: e }));
eXe.displayName = "SpatialWrapper";
const mXn = kr(() => ({
  cameraLabel: {
    padding: "0px 0px 0px 16px"
  },
  toggleBox: {
    padding: "0px"
  }
})), CXn = ({ setSpatialAxisFixed: t, spatialAxisFixed: e, use3d: n }) => {
  const r = Jr(), i = mXn();
  return ne.jsxs(Ko, { children: [ne.jsx(br, { className: i.cameraLabel, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `spatial-camera-axis-${r}`, children: "Fix Camera Axis" }) }), ne.jsx(br, { className: i.toggleBox, variant: "body", children: ne.jsx(ds, { onClick: () => t(!e), disabled: !n, checked: !!e, inputProps: {
    "aria-label": "Fix or not fix spatial camera axis",
    id: `spatial-camera-axis-${r}`
  } }) })] });
};
function EXn(t) {
  const { observationsLabel: e, cellColorEncoding: n, setCellColorEncoding: r, setSpatialAxisFixed: i, spatialAxisFixed: o, use3d: s, tooltipsVisible: a, setTooltipsVisible: A, geneExpressionColormap: l, setGeneExpressionColormap: c, geneExpressionColormapRange: u, setGeneExpressionColormapRange: f, canShowExpressionOptions: h, canShowColorEncodingOption: d, canShow3DOptions: I } = t, m = Jr();
  function C(w) {
    c(w.target.value);
  }
  function y(w, R) {
    f(R);
  }
  const v = Qn(Bd(y, 5, { trailing: !0 }), [y]);
  function b(w) {
    A(w.target.checked);
  }
  const Q = VI();
  return ne.jsxs(NL, { children: [d ? ne.jsx(Z8e, { observationsLabel: e, cellColorEncoding: n, setCellColorEncoding: r }) : null, I ? ne.jsx(CXn, { setSpatialAxisFixed: i, spatialAxisFixed: o, use3d: s }) : null, ne.jsxs(Ko, { children: [ne.jsx(br, { className: Q.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `gene-expression-colormap-option-tooltip-visibility-${m}`, children: "Tooltips Visible" }) }), ne.jsx(br, { className: Q.inputCell, variant: "body", children: ne.jsx(ds, {
    className: Q.checkbox,
    /**
     * We have to use "checked" here, not "value".
     * The checkbox state is not persisting with value.
     * For reference, https://v4.mui.com/api/checkbox/
     */
    checked: a,
    onChange: b,
    name: "gene-expression-colormap-option-tooltip-visibility",
    color: "default",
    inputProps: {
      "aria-label": "Enable or disable tooltips",
      id: `gene-expression-colormap-option-tooltip-visibility-${m}`
    }
  }) })] }), h ? ne.jsxs(ne.Fragment, { children: [ne.jsxs(Ko, { children: [ne.jsx(br, { className: Q.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `gene-expression-colormap-select-${m}`, children: "Gene Expression Colormap" }) }), ne.jsx(br, { className: Q.inputCell, variant: "body", children: ne.jsx(nd, { className: Q.select, value: l, onChange: C, inputProps: {
    id: `gene-expression-colormap-select-${m}`
  }, children: ME.map((w) => ne.jsx("option", { value: w, children: w }, w)) }, "gene-expression-colormap-select") })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: Q.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `gene-expression-colormap-range-${m}`, children: "Gene Expression Colormap Range" }) }), ne.jsx(br, { className: Q.inputCell, variant: "body", children: ne.jsx(ps, { classes: { root: Q.slider, valueLabel: Q.sliderValueLabel }, value: u, onChange: v, getAriaLabel: (w) => `${w === 0 ? "Low value slider" : "High value slider"} for spatial gene expression colormap range`, id: `gene-expression-colormap-range-${m}`, valueLabelDisplay: "auto", step: 5e-3, min: 0, max: 1 }) })] })] }) : null] });
}
function yXn(t) {
  const { parentUuid: e, obsHighlight: n, width: r, height: i, getObsInfo: o, hoverData: s, hoverCoord: a, useHoverInfoForTooltip: A, getObsIdFromHoverData: l } = t, c = JH(), u = KH(e);
  let [f, h, d] = [null, null, null];
  if (A && l && s && a && e === c) {
    const I = l(s);
    I && ([f, h, d] = [
      o(I),
      ...u && u.project ? u.project(a) : [null, null]
    ]);
  } else if (!A && o && n) {
    const I = n;
    [f, h, d] = [
      o(I),
      ...u && u.projectFromId ? u.projectFromId(I) : [null, null]
    ];
  }
  return f ? ne.jsx(Tq, { x: h, y: d, parentUuid: e, sourceUuid: c, parentWidth: r, parentHeight: i, children: ne.jsx(Nq, { info: f }) }) : null;
}
function vXn(t) {
  const { uuid: e, coordinationScopes: n, closeButtonVisible: r, downloadButtonVisible: i, removeGridComponent: o, observationsLabelOverride: s, subobservationsLabelOverride: a = "molecule", theme: A, title: l = "Spatial", disable3d: c, globalDisable3d: u, useFullResolutionImage: f = {}, channelNamesVisible: h = !1 } = t, d = eu(), I = yL(), m = vL(e), [{ dataset: C, obsType: y, featureType: v, featureValueType: b, spatialZoom: Q, spatialTargetX: w, spatialTargetY: R, spatialTargetZ: M, spatialRotationX: O, spatialRotationY: L, spatialRotationZ: N, spatialRotationOrbit: k, spatialOrbitAxis: $, spatialImageLayer: U, spatialSegmentationLayer: X, spatialPointLayer: K, spatialNeighborhoodLayer: z, obsFilter: Y, obsHighlight: V, featureSelection: Z, obsSetSelection: ce, obsSetColor: ee, obsColorEncoding: pe, additionalObsSets: Ce, spatialAxisFixed: Be, featureValueColormap: Ie, featureValueColormapRange: Qe, tooltipsVisible: xe }, { setSpatialZoom: Se, setSpatialTargetX: De, setSpatialTargetY: Ue, setSpatialTargetZ: Te, setSpatialRotationX: se, setSpatialRotationOrbit: fe, setSpatialOrbitAxis: W, setSpatialImageLayer: ge, setSpatialSegmentationLayer: _e, setSpatialPointLayer: Re, setSpatialNeighborhoodLayer: Ee, setObsFilter: oe, setObsSetSelection: ie, setObsHighlight: Ae, setObsSetColor: de, setObsColorEncoding: we, setAdditionalObsSets: Pe, setMoleculeHighlight: qe, setSpatialAxisFixed: ke, setFeatureValueColormap: Xe, setFeatureValueColormapRange: rt, setTooltipsVisible: it }] = uc(ea[Gn.SPATIAL], n), { spatialZoom: ht, spatialTargetX: mt, spatialTargetY: _t, spatialTargetZ: Ct } = yae(ea[Gn.SPATIAL], n), zt = s || y, [{ imageLayerCallbacks: jt, segmentationLayerCallbacks: lt }] = vae(ea.layerController, n), Ht = U?.some((zn) => zn.use3d), [vt, It, un] = QL(), [hn, We] = eAe(n, y, d, C), En = CF(d, C, tn.OBS_FEATURE_MATRIX, { obsType: y, featureType: v, featureValueType: b }), qn = CF(d, C, tn.OBS_SEGMENTATIONS, { obsType: y }), Pt = CF(d, C, tn.OBS_LOCATIONS, { obsType: y }), dr = CF(d, C, tn.IMAGE, {}), [{ obsIndex: yr, obsLocations: jn }, Ot, yn] = WZ(d, C, !1, { setSpatialPointLayer: Re }, { spatialPointLayer: K }, { obsType: "molecule" }), [{ obsLabels: Fn }, xn, vn] = hGt(d, C, !1, {}, {}, { obsType: "molecule" }), [{ obsIndex: nt, obsLocations: st }, xt, Me] = WZ(d, C, !1, {}, {}, { obsType: y }), [{ obsIndex: _, obsSegmentations: ye, obsSegmentationsType: He }, ze, tt] = P8e(d, C, !1, { setSpatialSegmentationLayer: _e }, { spatialSegmentationLayer: X }, { obsType: y }), At = qn && !(ze === Ra.SUCCESS && !(ye || He)), [{ obsSets: pt, obsSetsMembership: Bt }, Rt, Lt] = VB(d, C, !1, { setObsSetSelection: ie, setObsSetColor: de }, { obsSetSelection: ce, obsSetColor: ee }, { obsType: y }), [rn, Wr, pr] = bv(d, C, !1, Z, { obsType: y, featureType: v, featureValueType: b }), [{ obsIndex: Vt }, Sn, kn] = TL(d, C, !1, { obsType: y, featureType: v, featureValueType: b }), [{ image: vr }, Tr, $t] = Zae(d, C, !1, { setSpatialImageLayer: ge }, { spatialImageLayer: U }, {}), { loaders: Ye = [], meta: en = [] } = vr || {}, [Ir, zr, In] = pGt(d, C, !1, { setSpatialNeighborhoodLayer: Ee }, { spatialNeighborhoodLayer: z }), [{ featureLabelsMap: mr }, Mr, $e] = DL(d, C, !1, {}, {}, { featureType: v }), Ps = Jc([
    Ot,
    xn,
    xt,
    ze,
    Rt,
    pr,
    Sn,
    Tr,
    zr,
    Mr
  ]), Wn = Qd([
    yn,
    vn,
    Me,
    tt,
    Lt,
    kn,
    $t,
    In,
    $e
  ]), Is = dt(() => Fn ? Array.from(new Set(Fn)) : null, [Fn]), Ao = Is?.length || 0, hc = yr?.length || 0, [or, ml] = mn(null), { initialTargetX: dc, initialTargetY: Wa, initialTargetZ: Ki, initialZoom: Ne } = dt(
    () => lXn({
      width: vt,
      height: It,
      obsCentroids: st,
      obsSegmentations: ye,
      obsSegmentationsType: He,
      // TODO: use obsLocations (molecules) here too.
      imageLayerLoaders: Ye,
      useRaster: !!dr,
      use3d: Ht,
      modelMatrices: en.map(({ metadata: zn }) => zn?.transform?.matrix)
    }),
    // Deliberate dependency omissions: imageLayerLoaders and meta - using `image` as
    // an indirect dependency instead.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      vr,
      Ht,
      dr,
      st,
      ye,
      He,
      vt,
      It
    ]
  );
  Mn(() => {
    typeof mt != "number" || typeof _t != "number" ? ((typeof w != "number" || typeof R != "number" || w === dc && R === Wa) && (De(dc), Ue(Wa), Te(Ki), Se(Ne)), ml({ target: [dc, Wa, Ki], zoom: Ne })) : or || ml({
      target: [mt, _t, Ct],
      zoom: ht
    });
  }, [
    dc,
    Wa,
    Ki,
    Ne,
    mt,
    _t,
    Ct,
    ht
  ]);
  const Fe = dt(() => RI(pt, Ce), [pt, Ce]), Ze = Qn((zn) => {
    pI(zn, Ce, ee, ie, Pe, de, we);
  }, [
    Ce,
    ee,
    we,
    Pe,
    de,
    ie
  ]), Ve = dt(() => ML({
    cellSets: Fe,
    cellSetSelection: ce,
    cellSetColor: ee,
    obsIndex: Vt,
    theme: A
  }), [
    Fe,
    A,
    ee,
    ce,
    Vt
  ]), Mt = dt(() => Array.from(Ve.keys()), [Ve]), An = Jae(zt, hn, We, Bt), [lr, lo] = mn(null), [nn, Xn] = mn(null), Zn = !st, Wi = Qn(Bd((zn, Gr) => {
    lo(zn), Xn(Gr);
  }, 10, { trailing: !0 }), [lo, Xn, Zn]), To = Qn((zn) => Zn ? zn?.[0] : null, [Zn]), pm = ({ zoom: zn, target: Gr, rotationX: _r, rotationOrbit: ms, orbitAxis: Mi }) => {
    Se(zn), De(Gr[0]), Ue(Gr[1]), Te(Gr[2] || null), se(_r), fe(ms), W(Mi || null);
  }, na = AXn({
    observationsCount: _?.length || Vt?.length,
    observationsLabel: zt,
    subobservationsCount: Ao,
    subobservationsLabel: a,
    locationsCount: hc
  }), [Cl, La] = zae(rn), ai = dt(() => {
    if (Vt && Cl && He === "bitmask") {
      const zn = Vt.reduce((_r, ms) => Math.max(_r, Number(ms))), Gr = new Uint8Array(zn + 1);
      for (let _r = 0; _r < Vt.length; _r++) {
        const ms = Vt[_r];
        Gr.set(Cl[0].slice(_r, _r + 1), Number(ms));
      }
      return [Gr];
    }
    return [new Uint8Array()];
  }, [Vt, Cl, He]), nh = Vae({
    // eslint-disable-next-line no-unneeded-ternary
    instanceObsIndex: _ || nt,
    matrixObsIndex: Vt,
    expressionData: Cl
  }), pc = Ye.some((zn) => !!Array.from({
    length: zn.data.length
  }).filter((Gr, _r) => uQ(zn.data, _r)).length) && c?.length !== Ye.length && !u, Ic = dt(() => pc || En ? ne.jsx(EXn, { observationsLabel: zt, cellColorEncoding: pe, setCellColorEncoding: we, setSpatialAxisFixed: ke, spatialAxisFixed: Be, use3d: Ht, tooltipsVisible: xe, setTooltipsVisible: it, geneExpressionColormap: Ie, setGeneExpressionColormap: Xe, geneExpressionColormapRange: Qe, setGeneExpressionColormapRange: rt, canShowExpressionOptions: En, canShowColorEncodingOption: (Pt || At) && En, canShow3DOptions: pc }) : null, [
    pc,
    pe,
    Ie,
    Qe,
    Xe,
    Pt,
    At,
    En,
    zt,
    we,
    rt,
    ke,
    Be,
    Ht,
    xe,
    it
  ]);
  Mn(() => {
    !At && X && !ye && !_ && st && nt && console.warn("Rendering cell segmentation diamonds for backwards compatibility.");
  }, [
    At,
    X,
    ye,
    _,
    st,
    nt
  ]);
  const Li = dt(() => {
    const zn = (Gr, _r) => Array.isArray(f) && f.includes(en[_r].name) && Array.isArray(Gr.data);
    return Ye.map((Gr, _r) => zn(Gr, _r) ? { ...Gr, data: Gr.data[0] } : Gr);
  }, [Ye, f, en]), [ks, Vu] = dt(() => {
    let zn = [], Gr = [];
    if (U && U.length > 0 && Ye && Ye.length > 0) {
      const _r = U[0], ms = Ye?.[_r?.index];
      if (_r && !_r.colormap && _r.channels && ms) {
        const Mi = ms.channels;
        zn = _r.channels.map((mc) => Mi[mc.selection.channel === void 0 ? mc.selection.c : mc.selection.channel]), Gr = _r.channels.map((mc) => mc.color);
      }
    }
    return [zn, Gr];
  }, [U, Ye]);
  return ne.jsxs(fc, { title: l, info: na, isSpatial: !0, urls: Wn, theme: A, closeButtonVisible: r, downloadButtonVisible: i, removeGridComponent: o, isReady: Ps, options: Ic, children: [ne.jsx("div", { style: {
    position: "absolute",
    bottom: "5px",
    left: "5px",
    zIndex: 6
  }, children: h && ks ? ks.map((zn, Gr) => ne.jsx(Mu, { variant: "h6", style: {
    color: Qu(Vu[Gr]),
    fontSize: "14px"
  }, children: zn }, `${zn}-${Qu(Vu[Gr])}`)) : null }), ne.jsx(eXe, { ref: un, uuid: e, width: vt, height: It, viewState: {
    zoom: Q,
    target: [w, R, M],
    rotationX: O,
    rotationY: L,
    rotationZ: N,
    rotationOrbit: k,
    orbitAxis: $
  }, setViewState: pm, originalViewState: or, imageLayerDefs: U, obsSegmentationsLayerDefs: X, obsLocationsLayerDefs: K, neighborhoodLayerDefs: z, obsLocationsIndex: yr, obsSegmentationsIndex: _, obsLocations: jn, obsLocationsLabels: Fn, obsLocationsFeatureIndex: Is, hasSegmentations: At, obsSegmentations: ye, obsSegmentationsType: He, obsCentroids: st, obsCentroidsIndex: nt, cellFilter: Y, cellSelection: Mt, cellHighlight: V, cellColors: Ve, neighborhoods: Ir, imageLayerLoaders: Li, setCellFilter: oe, setCellSelection: Ze, setCellHighlight: Ae, setHoverInfo: Wi, setMoleculeHighlight: qe, setComponentHover: () => {
    I(e);
  }, updateViewInfo: m, imageLayerCallbacks: jt, segmentationLayerCallbacks: lt, spatialAxisFixed: Be, geneExpressionColormap: Ie, geneExpressionColormapRange: Qe, expressionData: ai, cellColorEncoding: pe, getExpressionValue: nh, theme: A, useFullResolutionImage: f }), xe && ne.jsx(yXn, { parentUuid: e, obsHighlight: V, width: vt, height: It, getObsInfo: An, useHoverInfoForTooltip: Zn, hoverData: lr, hoverCoord: nn, getObsIdFromHoverData: To }), ne.jsx(nS, {
    visible: !0,
    // Fix to dark theme due to black background of spatial plot.
    theme: "dark",
    featureType: v,
    featureValueType: b,
    obsColorEncoding: pe,
    featureSelection: Z,
    featureLabelsMap: mr,
    featureValueColormap: Ie,
    featureValueColormapRange: Qe,
    extent: La?.[0]
  })] });
}
function BXn({ width: t, height: e, obsPoints: n, obsSpots: r, obsSegmentations: i, obsSegmentationsLocations: o, segmentationChannelScopesByLayer: s, images: a, is3dMode: A, isReady: l }) {
  let c = null, u = null, f = null, h = null, d = null, I = null;
  const m = A ? 1.5 : 0.1;
  if (Object.values(a || {}).forEach((M) => {
    const O = M?.image?.instance.getData(), L = M?.image?.instance.getModelMatrix();
    if (O) {
      const N = { height: e, width: t }, { target: k, zoom: $ } = aQ(O, N, m, A, new pn(L)), U = Math.max(t / 2 ** $, e / 2 ** $), X = k[0] - U / 2, K = k[0] + U / 2, z = k[1] - U / 2, Y = k[1] + U / 2, V = k[2], Z = k[2];
      c = c === null ? X : Math.min(c, X), u = u === null ? K : Math.max(u, K), f = f === null ? z : Math.min(f, z), h = h === null ? Y : Math.max(h, Y), d = d === null ? V : Math.min(d, V), I = I === null ? Z : Math.max(I, Z);
    }
  }), Object.entries(i || {}).forEach(([M, O]) => {
    if (O?.obsSegmentations && O?.obsSegmentationsType) {
      const { obsSegmentationsType: L } = O;
      if (L === "polygon") {
        const N = s?.[M]?.[0], { obsLocations: k } = o?.[M]?.[N] || {};
        if (!!k) {
          const [U, X] = fa(k.data[0]), [K, z] = fa(k.data[1]);
          c = c === null ? U : Math.min(c, U), u = u === null ? X : Math.max(u, X), f = f === null ? K : Math.min(f, K), h = h === null ? z : Math.max(h, z);
        } else {
          const [U, X] = fa(O.obsSegmentations.data, (Y) => Y[0][0]), [K, z] = fa(O.obsSegmentations.data, (Y) => Y[0][1]);
          c = c === null ? U : Math.min(c, U), u = u === null ? X : Math.max(u, X), f = f === null ? K : Math.min(f, K), h = h === null ? z : Math.max(h, z);
        }
      } else if (L === "bitmask") {
        const N = O?.obsSegmentations?.instance.getData(), k = O?.obsSegmentations?.instance.getModelMatrix();
        if (N) {
          const $ = { height: e, width: t }, { target: U, zoom: X } = aQ(N, $, m, A, new pn(k)), K = Math.max(t / 2 ** X, e / 2 ** X), z = U[0] - K / 2, Y = U[0] + K / 2, V = U[1] - K / 2, Z = U[1] + K / 2, ce = U[2], ee = U[2];
          c = c === null ? z : Math.min(c, z), u = u === null ? Y : Math.max(u, Y), f = f === null ? V : Math.min(f, V), h = h === null ? Z : Math.max(h, Z), d = d === null ? ce : Math.min(d, ce), I = I === null ? ee : Math.max(I, ee);
        }
      }
    }
  }), Object.values(n || {}).forEach((M) => {
    if (M?.obsPoints) {
      const [O, L] = fa(M.obsPoints.data[0]), [N, k] = fa(M.obsPoints.data[1]);
      c = c === null ? O : Math.min(c, O), u = u === null ? L : Math.max(u, L), f = f === null ? N : Math.min(f, N), h = h === null ? k : Math.max(h, k);
    }
  }), Object.values(r || {}).forEach((M) => {
    if (M?.obsSpots) {
      const [O, L] = fa(M.obsSpots.data[0]), [N, k] = fa(M.obsSpots.data[1]);
      c = c === null ? O : Math.min(c, O), u = u === null ? L : Math.max(u, L), f = f === null ? N : Math.min(f, N), h = h === null ? k : Math.max(h, k);
    }
  }), !l || c === null || u === null || f === null || h === null)
    return {
      initialTargetX: null,
      initialTargetY: null,
      initialTargetZ: null,
      initialZoom: null
    };
  const C = u - c, y = h - f, v = I - d, b = c + C / 2, Q = f + y / 2, w = d === null || I === null ? null : d + v / 2, R = Math.log2(Math.min(t / C, e / y)) - m;
  return {
    initialTargetX: b,
    initialTargetY: Q,
    initialZoom: R,
    initialTargetZ: w
  };
}
function bXn(t, e) {
  const n = Array.isArray(t) && t.length > 1 || !Array.isArray(t) ? t : t[0];
  return e ? [Dq, Array.isArray(n) ? n : [n]] : [Array.isArray(t) && t.length > 1 ? sx : ox, n];
}
function _Xn(t) {
  const { bbox: { left: e, top: n, right: r, bottom: i }, index: { x: o, y: s, z: a }, zoom: A } = t.tile, { data: l, id: c, loader: u, maxZoom: f, minZoom: h, zoomOffset: d } = t;
  if ([e, i, r, n].some((v) => v < 0) || !l)
    return null;
  const I = u[0], [m, C] = u[0].shape.slice(-2), y = [
    e,
    l.height < I.tileSize ? m : i,
    l.width < I.tileSize ? C : r,
    n
  ];
  return new _fe(t, {
    channelData: l,
    // Uncomment to help debugging - shades the tile being hovered over.
    // autoHighlight: true,
    // highlightColor: [80, 80, 80, 50],
    // Shared props with BitmapLayer:
    bounds: y,
    id: `sub-layer-${y}-${c}`,
    tileId: { x: o, y: s, z: a },
    // The zoom/maxZoom values are used in the computation
    // of the scale factor for the stroke width.
    zoom: A,
    minZoom: h,
    maxZoom: f,
    zoomOffset: d
    // TODO: figure out if this needs to be used or not
  });
}
const SXn = "point-layer-", QXn = "spot-layer-", qTe = "segmentation-layer-", wXn = "image-layer-", xXn = "volume-layer-", IK = !1, RXn = {
  maximumIntensityProjection: "Maximum Intensity Projection",
  minimumIntensityProjection: "Minimum Intensity Projection",
  additive: "Additive"
}, DXn = (t, e, n) => (r, { index: i }) => {
  const [o, s, a, A] = t && e && t.get(e[i]) || da(n);
  return [o, s, a, 255 * (A || 1)];
}, TXn = (t, e, n) => (r, { index: i }) => {
  const { setColorIndices: o, setColors: s } = t || {}, [a, A, l, c] = o && e && s?.[o?.get(e[i])]?.color || da(n);
  return [a, A, l, 255 * (c || 1)];
}, By = (t) => (e) => [
  t.data[0][e],
  t.data[1][e],
  0
];
function NXn(t, e, n) {
  return t ? e ? n === "minimumIntensityProjection" ? [new eS.MinimumIntensityProjectionExtension()] : n === "maximumIntensityProjection" ? [new eS.MaximumIntensityProjectionExtension()] : [new eS.AdditiveBlendExtension()] : n === "minimumIntensityProjection" ? [new TC.MinimumIntensityProjectionExtension()] : n === "maximumIntensityProjection" ? [new TC.MaximumIntensityProjectionExtension()] : [new TC.AdditiveBlendExtension()] : e ? [new xq()] : [new tx()];
}
class LXn extends Qfe {
  constructor(e) {
    super(e), this.obsSegmentationsData = {}, this.obsSegmentationsQuadTree = {}, this.obsSpotsData = {}, this.obsSpotsQuadTree = {}, this.obsPointsData = {}, this.obsPointsQuadTree = {}, this.imageLayers = [], this.obsSegmentationsLayers = [], this.obsSpotsLayers = [], this.obsPointsLayers = [], this.obsPointsLabelsData = {}, this.spotToMatrixIndexMap = {}, this.spotColors = {}, this.spotExpressionGetters = {}, this.prevSpotSetColor = {}, this.prevSpotSetSelection = {}, this.segmentationToMatrixIndexMap = {}, this.segmentationToMatrixIndexArr = {}, this.segmentationColors = {}, this.segmentationExpressionGetters = {}, this.prevSegmentationSetColor = {}, this.prevSegmentationSetSelection = {}, this.imageLayerLoaderSelections = {}, this.segmentationLayerLoaderSelections = {}, this.randomColorData = {
      data: new Uint8Array(2048 * 2048 * 3).map((n, r) => r < 4 ? 0 : Math.round(255 * Math.random())),
      // This buffer should be able to hold colors for 2048 x 2048 ~ 4 million cells.
      height: 2048,
      width: 2048
    }, this.color = { ...this.randomColorData }, this.expression = {
      data: new Uint8Array(2048 * 2048),
      // This buffer should be able to hold colors for 2048 x 2048 ~ 4 million cells.
      height: 2048,
      width: 2048
    }, this.onUpdateAllSegmentationsData(), this.onUpdateAllSegmentationsLocationsData(), this.onUpdateAllSegmentationsSetsData(), this.onUpdateAllSegmentationsIndexData(), this.onUpdateAllSegmentationsExpressionData(), this.onUpdateSegmentationsLayer(), this.onUpdateAllPointsData(), this.onUpdatePointsLayer(), this.onUpdateAllSpotsData(), this.onUpdateAllSpotsSetsData(), this.onUpdateAllSpotsIndexData(), this.onUpdateAllSpotsExpressionData(), this.onUpdateSpotsLayer(), this.onUpdateImages();
  }
  createPolygonSegmentationLayer(e, n, r, i, o, s) {
    const { theme: a, delegateHover: A } = this.props, l = n[re.SPATIAL_LAYER_VISIBLE], c = n[re.SPATIAL_LAYER_OPACITY];
    if (!r.length === 1)
      return null;
    const u = r[0], f = i[u];
    if (!f)
      return null;
    const { obsColorEncoding: h, spatialChannelColor: d, spatialChannelOpacity: I, spatialChannelVisible: m, spatialSegmentationFilled: C, spatialSegmentationStrokeWidth: y, featureValueColormap: v, featureValueColormapRange: b } = f, { obsIndex: Q } = o, w = this.obsSegmentationsData?.[e];
    this.obsSegmentationsQuadTree?.[e]?.[u];
    const R = this.segmentationColors?.[e]?.[u], M = this.segmentationExpressionGetters?.[e]?.[u], O = l && m, L = c * I, N = h === "spatialChannelColor", k = Array.isArray(d) && d.length === 3 ? d : da(a), $ = TXn(R, Q, a), U = (X, { index: K, data: z }) => z.src.obsSegmentations.data[K];
    return new Pf({
      // We do not include channelScope in the ID so that it matches the ID
      // of the equivalent bitmask-based segmentation layer. We also assume
      // only one polygon-based segmentation channel per layer.
      id: `${qTe}${e}`,
      data: w,
      coordinateSystem: wn.CARTESIAN,
      pickable: !0,
      autoHighlight: IK,
      filled: C,
      stroked: !C,
      backgroundColor: [0, 0, 0],
      // isSelected: getCellIsSelected,
      getPolygon: U,
      getFillColor: N ? k : $,
      getLineColor: N ? k : $,
      onClick: (X) => {
      },
      onHover: (X) => A(X, "segmentation-polygon", e),
      visible: O,
      opacity: L,
      getLineWidth: C ? 0 : y,
      // lineWidthScale,
      // lineWidthMaxPixels,
      getExpressionValue: M,
      extensions: [new oQ()],
      colorScaleLo: b[0],
      colorScaleHi: b[1],
      isExpressionMode: h === "geneSelection",
      colormap: v,
      updateTriggers: {
        getFillColor: [h, k, R],
        getLineColor: [h, k, R]
        /*
        getLineWidth: [stroked],
        isSelected: cellSelection,
        getExpressionValue,
        getFillColor: [opacity, cellColorEncoding, cellSelection, cellColors],
        getLineColor: [cellColorEncoding, cellSelection, cellColors],
        getPolygon: [radius],
        */
      }
    });
  }
  createSpotLayer(e, n, r, i) {
    const { theme: o, delegateHover: s } = this.props, a = this.spotColors[e], A = this.spotExpressionGetters[e], l = r?.obsIndex, c = DXn(a, l, o), { spatialLayerVisible: u, spatialLayerOpacity: f, spatialSpotRadius: h, spatialSpotFilled: d, spatialSpotStrokeWidth: I, obsColorEncoding: m, featureValueColormap: C, featureValueColormapRange: y, spatialLayerColor: v } = n, b = m === "spatialLayerColor", Q = Array.isArray(v) && v.length === 3 ? v : da(o);
    return new LI({
      id: `${QXn}${e}`,
      data: this.obsSpotsData[e],
      coordinateSystem: wn.CARTESIAN,
      pickable: !0,
      autoHighlight: IK,
      opacity: f,
      filled: d,
      stroked: !d,
      getLineWidth: d ? 0 : I,
      visible: u,
      getRadius: h,
      getPosition: (w, { data: R, index: M, target: O }) => (O[0] = R.src.obsSpots.data[0][M], O[1] = R.src.obsSpots.data[1][M], O[2] = 0, O),
      getLineColor: b ? Q : c,
      getFillColor: b ? Q : c,
      onHover: (w) => s(w, "spot", e),
      // Expression color mapping extension props
      extensions: [new oQ()],
      getExpressionValue: A,
      colorScaleLo: y[0],
      colorScaleHi: y[1],
      isExpressionMode: m === "geneSelection",
      colormap: C,
      updateTriggers: {
        getRadius: [h],
        getExpressionValue: A,
        getFillColor: [m, a, Q],
        getLineColor: [m, a, Q]
      }
    });
  }
  createPointLayer(e, n, r) {
    const { theme: i, delegateHover: o } = this.props, { spatialLayerVisible: s, spatialLayerOpacity: a, obsColorEncoding: A, spatialLayerColor: l } = n, c = A === "spatialLayerColor", u = Array.isArray(l) && l.length === 3 ? l : da(i), f = (h, { data: d, index: I, target: m }) => {
      const C = d.src.obsIndex[I];
      if (d.src.obsLabelsMap && d.src.uniqueObsLabels && d.src.PALETTE) {
        const y = d.src.obsLabelsMap.get(C), v = d.src.uniqueObsLabels.indexOf(y);
        m[0] = d.src.PALETTE[v % d.src.PALETTE.length]?.[0], m[1] = d.src.PALETTE[v % d.src.PALETTE.length]?.[1], m[2] = d.src.PALETTE[v % d.src.PALETTE.length]?.[2];
      }
      return m;
    };
    return new LI({
      id: `${SXn}${e}`,
      data: this.obsPointsData[e],
      coordinateSystem: wn.CARTESIAN,
      pickable: !0,
      autoHighlight: IK,
      radiusMaxPixels: 3,
      opacity: a,
      visible: s,
      getRadius: 300,
      getPosition: (h, { data: d, index: I, target: m }) => (m[0] = d.src.obsPoints.data[0][I], m[1] = d.src.obsPoints.data[1][I], m[2] = 0, m),
      getLineColor: c ? u : f,
      getFillColor: c ? u : f,
      onHover: (h) => o(h, "point", e),
      updateTriggers: {
        getRadius: [],
        getFillColor: [A, u],
        getLineColor: [A, u]
      }
    });
  }
  createSelectionLayer() {
    const {
      // Spots
      spotLayerScopes: e,
      obsSpots: n,
      spotLayerCoordination: r,
      // Points
      pointLayerScopes: i,
      obsPoints: o,
      pointLayerCoordination: s,
      // Segmentations
      segmentationLayerScopes: a,
      segmentationChannelScopesByLayer: A,
      obsSegmentationsLocations: l,
      segmentationLayerCoordination: c,
      segmentationChannelCoordination: u
    } = this.props, { viewState: f } = this.props, { tool: h } = this.state;
    return $ue(h, f.zoom, "nothing", [
      ...i.filter((d) => s?.[0]?.[d]?.[re.SPATIAL_LAYER_VISIBLE]).map((d) => ({
        getObsCoords: By(o?.[d]?.obsPoints),
        obsIndex: o?.[d]?.obsIndex,
        obsQuadTree: this.obsPointsQuadTree?.[d],
        // eslint-disable-next-line no-unused-vars
        onSelect: (I) => {
        }
      })),
      ...e.filter((d) => r?.[0]?.[d]?.[re.SPATIAL_LAYER_VISIBLE]).map((d) => ({
        getObsCoords: By(n?.[d]?.obsSpots),
        obsIndex: n?.[d]?.obsIndex,
        obsQuadTree: this.obsSpotsQuadTree?.[d],
        onSelect: (I) => {
          const { obsSetColor: m, additionalObsSets: C } = r?.[0]?.[d] || {}, { setObsSetSelection: y, setObsColorEncoding: v, setObsSetColor: b, setAdditionalObsSets: Q } = r?.[1]?.[d] || {};
          pI(I, C, m, y, Q, b, v);
        }
      })),
      ...a.filter((d) => c?.[0]?.[d]?.[re.SPATIAL_LAYER_VISIBLE]).flatMap((d) => A[d].filter((I) => u?.[0]?.[d]?.[I]?.[re.SPATIAL_CHANNEL_VISIBLE] && l?.[d]?.[I]).map((I) => ({
        getObsCoords: By(l?.[d]?.[I]?.obsLocations),
        obsIndex: l?.[d]?.[I]?.obsIndex,
        obsQuadTree: this.obsSegmentationsQuadTree?.[d]?.[I],
        onSelect: (m) => {
          const { obsSetColor: C, additionalObsSets: y } = u?.[0]?.[d]?.[I] || {}, { setObsSetSelection: v, setObsColorEncoding: b, setObsSetColor: Q, setAdditionalObsSets: w } = u?.[1]?.[d]?.[I] || {};
          pI(m, y, C, v, w, Q, b);
        }
      })))
    ]);
  }
  createScaleBarLayer() {
    const { viewState: e, width: n, height: r } = this.props, i = this.use3d();
    return !e || !n || !r || i ? null : new Rq({
      id: "scalebar-layer",
      unit: "um",
      size: 1,
      snap: !0,
      viewState: { ...e, width: n, height: r }
    });
  }
  use3d() {
    const { spatialRenderingMode: e } = this.props;
    return e === "3D";
  }
  // New createImageLayer function.
  createBitmaskSegmentationLayer(e, n, r, i, o, s, a, A) {
    const { delegateHover: l, targetT: c, targetZ: u } = this.props, f = o?.obsSegmentations?.instance?.getData();
    if (!f)
      return null;
    const h = n[re.SPATIAL_LAYER_VISIBLE], d = o?.obsSegmentations?.instance?.getModelMatrix();
    let I;
    const m = r.map((y) => PD(f, {
      z: u,
      t: c,
      c: i[y][re.SPATIAL_TARGET_C]
    })), C = this.segmentationLayerLoaderSelections[e];
    return gr(C, m) ? I = C : (I = m, this.segmentationLayerLoaderSelections[e] = m), new sx({
      // `bitmask` is used by the AbstractSpatialOrScatterplot
      // https://github.com/vitessce/vitessce/pull/927/files#diff-9cab35a2ca0c5b6d9754b177810d25079a30ca91efa062d5795181360bc3ff2cR111
      id: `${qTe}${e}`,
      channelsVisible: r.map((y) => (
        // Layer visible AND channel visible
        h && i[y][re.SPATIAL_CHANNEL_VISIBLE]
      )),
      channelOpacities: r.map((y) => i[y][re.SPATIAL_CHANNEL_OPACITY]),
      channelsFilled: r.map((y) => i[y][re.SPATIAL_SEGMENTATION_FILLED]),
      opacity: n[re.SPATIAL_LAYER_OPACITY],
      channelColors: r.map((y) => i[y][re.SPATIAL_CHANNEL_COLOR]),
      channelStrokeWidths: r.map((y) => i[y][re.SPATIAL_SEGMENTATION_STROKE_WIDTH]),
      channelFeatureValueColormaps: r.map((y) => i[y][re.FEATURE_VALUE_COLORMAP]),
      channelFeatureValueColormapRanges: r.map((y) => i[y][re.FEATURE_VALUE_COLORMAP_RANGE]),
      channelIsStaticColorMode: r.map((y) => i[y][re.OBS_COLOR_ENCODING] === "spatialChannelColor"),
      channelIsSetColorMode: r.map((y) => i[y][re.OBS_COLOR_ENCODING] === "cellSetSelection"),
      modelMatrix: d,
      // hoveredCell: Number(this.props.cellHighlight),
      multiFeatureValues: r.map((y) => s?.[y]?.[0] || []),
      // Pass in the matrixObsIndex to account for the fact that
      // the obsIndex of the obsFeatureMatrix
      // may not be ["1", "2", "3", "4", ... "N"] and
      // instead may be ["3", "20", "4", "6"].
      multiMatrixObsIndex: r.map((y) => A ? null : a?.[y] || null),
      setColorValues: r.map((y) => this.segmentationColors?.[e]?.[y] || []),
      renderSubLayers: _Xn,
      loader: f,
      selections: I,
      // For some reason, deck.gl doesn't recognize the prop diffing
      // unless these are separated out.  I don't think it's a bug, just
      // has to do with the fact that we don't have it in the `defaultProps`,
      // could be wrong though.
      cellColorData: this.color.data,
      cellTexHeight: this.color.height,
      cellTexWidth: this.color.width,
      excludeBackground: !0,
      onViewportLoad: () => {
      },
      colorScaleLo: 0,
      colorScaleHi: 1,
      isExpressionMode: !1,
      colormap: null,
      expressionData: this.expression.data,
      // There is no onHover here,
      // see the onHover method of AbstractSpatialOrScatterplot.
      pickable: !0,
      onHover: (y) => l(y, "segmentation-bitmask", e)
    });
  }
  // New createImageLayer function.
  createImageLayer(e, n, r, i, o) {
    const { delegateHover: s, targetT: a, targetZ: A, spatialRenderingMode: l } = this.props, c = o?.image?.instance?.getData();
    if (!c)
      return null;
    const u = o.image.instance, f = l === "3D", h = n[re.PHOTOMETRIC_INTERPRETATION] === "RGB", [d, I] = bXn(c, f), m = h ? null : n[re.SPATIAL_LAYER_COLORMAP], C = n[re.VOLUMETRIC_RENDERING_ALGORITHM], y = n[re.SPATIAL_LAYER_VISIBLE], v = n[re.SPATIAL_LAYER_TRANSPARENT_COLOR], b = Array.isArray(v) && v.length === 3, Q = NXn(f, m, C), w = {};
    u.isInterleaved() && (w.visible = y);
    const R = o?.image?.instance?.getModelMatrix() || {};
    let M;
    const O = h ? [0, 1, 2].map((K) => PD(c, {
      z: A,
      t: a,
      c: K
    })) : r.map((K) => PD(c, {
      z: A,
      t: a,
      c: i[K][re.SPATIAL_TARGET_C]
    })), L = this.imageLayerLoaderSelections[e];
    gr(L, O) ? M = L : (M = O, this.imageLayerLoaderSelections[e] = O);
    const N = h ? [
      [255, 0, 0],
      [0, 255, 0],
      [0, 0, 255]
    ] : r.map((K) => i[K][re.SPATIAL_CHANNEL_COLOR]), k = h ? [
      [0, 255],
      [0, 255],
      [0, 255]
    ] : r.map((K) => i[K][re.SPATIAL_CHANNEL_WINDOW] || [0, 255]), $ = h ? [
      // Layer visible AND channel visible
      y && !0,
      y && !0,
      y && !0
    ] : r.map((K) => (
      // Layer visible AND channel visible
      y && i[K][re.SPATIAL_CHANNEL_VISIBLE]
    )), U = u.getAutoTargetResolution(), X = n[re.SPATIAL_TARGET_RESOLUTION];
    return new d({
      loader: I,
      id: `${f ? xXn : wXn}${e}`,
      colors: N,
      contrastLimits: k,
      selections: M,
      channelsVisible: $,
      opacity: n[re.SPATIAL_LAYER_OPACITY],
      colormap: m,
      modelMatrix: R,
      transparentColor: v,
      useTransparentColor: b,
      resolution: X === null ? U : X,
      renderingMode: RXn[C],
      xSlice: n[re.SPATIAL_SLICE_X],
      ySlice: n[re.SPATIAL_SLICE_Y],
      zSlice: n[re.SPATIAL_SLICE_Z],
      onViewportLoad: () => {
      },
      excludeBackground: b,
      extensions: Q,
      // Picking / onHover on the root DeckGL component
      //  does not seem to work when there is a
      // bitmask segmentation layer "above"
      // the image layer.
      // This is likely due to the fact that the
      // bitmask layer is overlapping despite
      // having transparent / zero-valued pixels.
      // Instead, we can get the hover info from the layer:
      pickable: !0,
      onHover: (K) => s(K, "image", e),
      ...w
    });
  }
  createImageLayers() {
    const { imageLayerCallbacks: e = [], images: n = {}, imageLayerScopes: r, imageLayerCoordination: i, imageChannelScopesByLayer: o, imageChannelCoordination: s } = this.props;
    return r.map((a) => this.createImageLayer(a, i[0][a], o[a], s[0][a], n[a]));
  }
  createSpotLayers() {
    const { obsSpots: e = {}, spotLayerScopes: n, spotLayerCoordination: r, spotMultiExpressionData: i } = this.props;
    return n.map((o) => e[o] ? this.createSpotLayer(o, r[0][o], e[o], i?.[o]) : null);
  }
  createPointLayers() {
    const { obsPoints: e = {}, pointLayerScopes: n, pointLayerCoordination: r } = this.props;
    return n.map((i) => e[i] ? this.createPointLayer(i, r[0][i], e[i]) : null);
  }
  createSegmentationLayers() {
    const { obsSegmentations: e = {}, segmentationLayerScopes: n, segmentationLayerCoordination: r, segmentationChannelScopesByLayer: i, segmentationChannelCoordination: o, segmentationLayerCallbacks: s = [], segmentationMultiExpressionData: a, bitmaskValueIsIndex: A } = this.props;
    return n.map((l) => {
      if (e[l]) {
        const { obsSegmentationsType: c } = e[l];
        if (c === "bitmask")
          return this.createBitmaskSegmentationLayer(
            l,
            r[0][l],
            i[l],
            o[0][l],
            e[l],
            a?.[l],
            this.segmentationToMatrixIndexArr?.[l],
            // TODO: get this from the layer coordination.
            A
          );
        if (c === "polygon")
          return this.createPolygonSegmentationLayer(l, r[0][l], i[l], o[0][l], e[l], a?.[l]);
      }
      return null;
    });
  }
  getLayers() {
    const {
      imageLayers: e,
      obsSpotsLayers: n,
      obsPointsLayers: r,
      obsSegmentationsLayers: i
      // neighborhoodsLayer,
      // obsLocationsLayer,
    } = this;
    return [
      ...e,
      ...i,
      ...n,
      ...r,
      // neighborhoodsLayer,
      // obsLocationsLayer,
      this.createScaleBarLayer(),
      this.createSelectionLayer()
    ];
  }
  // onUpdate functions:
  // - Spots data onUpdate functions:
  onUpdateSpotsSetsData(e) {
    const { obsSpots: n, obsSpotsSets: r, spotLayerCoordination: i, theme: o } = this.props, { obsSets: s, obsIndex: a } = r?.[e] || {};
    if (s && a) {
      const { obsSetColor: A, obsColorEncoding: l, obsSetSelection: c, additionalObsSets: u } = i[0][e], f = RI(s, u), h = this.prevSpotSetColor[e], d = this.prevSpotSetSelection[e];
      if (A !== h || c !== d) {
        const I = ML({
          cellColorEncoding: l,
          cellSets: f,
          cellSetColor: A,
          cellSetSelection: c,
          theme: o,
          obsIndex: a
        });
        this.spotColors[e] = I, this.prevSpotSetColor[e] = A, this.prevSpotSetColor[e] = c;
      }
    }
  }
  onUpdateAllSpotsSetsData() {
    const { spotLayerScopes: e } = this.props;
    e.forEach((n) => {
      this.onUpdateSpotsSetsData(n);
    });
  }
  // Dependencies: `obsSpots`, `spotMatrixIndices`
  onUpdateSpotsIndexData(e) {
    const { obsSpots: n, spotMatrixIndices: r } = this.props, { obsIndex: i } = n?.[e] || {}, { obsIndex: o } = r?.[e] || {};
    if (i && o) {
      const s = new Map(o.map((a, A) => [a, A]));
      this.spotToMatrixIndexMap[e] = i.map((a) => s.get(a));
    }
  }
  onUpdateAllSpotsIndexData() {
    const { spotLayerScopes: e } = this.props;
    e?.forEach((n) => {
      this.onUpdateSpotsIndexData(n);
    });
  }
  // Dependencies: same as `this.onUpdateSpotsIndexData()` plus `spotMultiExpressionData`
  onUpdateSpotsExpressionData(e) {
    const { spotMultiExpressionData: n } = this.props, r = n?.[e], i = this.spotToMatrixIndexMap[e], o = (s, { index: a }) => {
      if (i && r && r[0]) {
        const A = i[a];
        return r[0][A];
      }
      return 0;
    };
    this.spotExpressionGetters[e] = o;
  }
  onUpdateAllSpotsExpressionData() {
    const { spotLayerScopes: e } = this.props;
    e?.forEach((n) => {
      this.onUpdateSpotsExpressionData(n);
    });
  }
  onUpdateSpotsData(e) {
    const { obsSpots: n } = this.props, { obsSpots: r } = n?.[e] || {};
    if (r) {
      const i = By(r);
      this.obsSpotsQuadTree[e] = FD(r, i), this.obsSpotsData[e] = {
        src: {
          obsSpots: r
        },
        length: r.shape[1]
      };
    }
  }
  onUpdateAllSpotsData() {
    const { spotLayerScopes: e } = this.props;
    e?.forEach((n) => {
      this.onUpdateSpotsData(n);
    });
  }
  // - Segmentations data onUpdate functions:
  onUpdateSegmentationsSetsData(e, n) {
    const { obsSegmentations: r, obsSegmentationsSets: i, segmentationLayerCoordination: o, segmentationChannelCoordination: s, theme: a } = this.props, { obsSets: A, obsIndex: l } = i?.[e]?.[n] || {};
    if (A && l) {
      const { obsSetColor: c, obsColorEncoding: u, obsSetSelection: f, additionalObsSets: h } = s[0][e][n], d = RI(A, h), I = this.prevSegmentationSetColor?.[e]?.[n], m = this.prevSegmentationSetSelection?.[e]?.[n];
      if (c !== I || f !== m) {
        const C = rUt(d, f, c);
        this.segmentationColors[e] || (this.segmentationColors[e] = {}), this.prevSegmentationSetColor[e] || (this.prevSegmentationSetColor[e] = {}), this.prevSegmentationSetSelection[e] || (this.prevSegmentationSetSelection[e] = {}), this.segmentationColors[e][n] = {
          setColorIndices: C,
          setColors: c,
          obsIndex: l
          // TODO: how to ensure obsIndex.length matches the number of cells
        }, this.prevSegmentationSetColor[e][n] = c, this.prevSegmentationSetSelection[e][n] = f;
      }
    }
  }
  onUpdateAllSegmentationsSetsData() {
    const { segmentationLayerScopes: e, segmentationChannelScopesByLayer: n } = this.props;
    e?.forEach((r) => {
      n?.[r]?.forEach((i) => {
        this.onUpdateSegmentationsSetsData(r, i);
      });
    });
  }
  // Dependencies: `obsSegmentations`, `segmentationMatrixIndices`
  onUpdateSegmentationsIndexData(e, n) {
    const { obsSegmentations: r, segmentationMatrixIndices: i } = this.props, { obsIndex: o } = r?.[e] || {}, { obsIndex: s } = i?.[e]?.[n] || {};
    if (o && s) {
      const a = new Map(s.map((A, l) => [A, l]));
      this.segmentationToMatrixIndexMap[e] || (this.segmentationToMatrixIndexMap[e] = {}), this.segmentationToMatrixIndexMap[e][n] = o.map((A) => a.get(A));
    }
    s && (this.segmentationToMatrixIndexArr[e] || (this.segmentationToMatrixIndexArr[e] = {}), this.segmentationToMatrixIndexArr[e][n] = s);
  }
  onUpdateAllSegmentationsIndexData() {
    const { segmentationLayerScopes: e, segmentationChannelScopesByLayer: n } = this.props;
    e?.forEach((r) => {
      n?.[r]?.forEach((i) => {
        this.onUpdateSegmentationsIndexData(r, i);
      });
    });
  }
  // Dependencies: same as `this.onUpdateSpotsIndexData()` plus `spotMultiExpressionData`
  onUpdateSegmentationsExpressionData(e, n) {
    const { segmentationMultiExpressionData: r } = this.props, i = r?.[e]?.[n], o = this.segmentationToMatrixIndexMap?.[e]?.[n], s = (a, { index: A }) => {
      if (i && i[0]) {
        const l = o[A];
        return i[0][l];
      }
      return 0;
    };
    this.segmentationExpressionGetters[e] || (this.segmentationExpressionGetters[e] = {}), this.segmentationExpressionGetters[e][n] = s;
  }
  onUpdateAllSegmentationsExpressionData() {
    const { segmentationLayerScopes: e, segmentationChannelScopesByLayer: n } = this.props;
    e?.forEach((r) => {
      n?.[r]?.forEach((i) => {
        this.onUpdateSegmentationsExpressionData(r, i);
      });
    });
  }
  onUpdateSegmentationsLocationsData(e, n) {
    const { obsSegmentations: r, obsSegmentationsLocations: i } = this.props, { obsSegmentations: o, obsSegmentationsType: s } = r?.[e] || {}, { obsLocations: a } = i?.[e]?.[n] || {};
    if (o && s === "polygon" && a && a.shape[1] === o.shape[0]) {
      const A = By(a);
      this.obsSegmentationsQuadTree[e] || (this.obsSegmentationsQuadTree[e] = {}), this.obsSegmentationsQuadTree[e][n] = FD(a, A);
    }
  }
  onUpdateAllSegmentationsLocationsData() {
    const { segmentationLayerScopes: e, segmentationChannelScopesByLayer: n } = this.props;
    e?.forEach((r) => {
      n?.[r]?.forEach((i) => {
        this.onUpdateSegmentationsLocationsData(r, i);
      });
    });
  }
  onUpdateSegmentationsData(e) {
    const { obsSegmentations: n } = this.props, { obsSegmentations: r, obsSegmentationsType: i } = n?.[e] || {};
    r && i === "polygon" && (this.obsSegmentationsData[e] = {
      src: {
        obsSegmentations: r
      },
      length: r.shape[0]
    });
  }
  onUpdateAllSegmentationsData() {
    const { segmentationLayerScopes: e } = this.props;
    e?.forEach((n) => {
      this.onUpdateSegmentationsData(n);
    });
  }
  onUpdateSpotsLayer() {
    this.obsSpotsLayers = this.createSpotLayers();
  }
  onUpdateSegmentationsLayer() {
    this.obsSegmentationsLayers = this.createSegmentationLayers();
  }
  onUpdatePointsData(e) {
    const { obsPoints: n, pointMultiObsLabels: r } = this.props, { obsIndex: i, obsPoints: o } = n?.[e] || {}, { obsIndex: s, obsLabels: a } = r?.[e] || {};
    if (o) {
      const A = By(o);
      if (this.obsPointsQuadTree[e] = FD(o, A), this.obsPointsData[e] = {
        src: {
          obsIndex: i,
          obsPoints: o,
          obsLabelsMap: null,
          uniqueObsLabels: null,
          PALETTE: null
        },
        length: o.shape[1]
      }, a) {
        const l = new Map(s.map((u, f) => [u, a[f]])), c = Array.from(new Set(a));
        this.obsPointsData[e].src.obsLabelsMap = l, this.obsPointsData[e].src.uniqueObsLabels = c, this.obsPointsData[e].src.PALETTE = Gv;
      }
    }
  }
  onUpdateAllPointsData() {
    const { pointLayerScopes: e } = this.props;
    e?.forEach((n) => {
      this.onUpdatePointsData(n);
    });
  }
  onUpdatePointsLayer() {
    this.obsPointsLayers = this.createPointLayers();
  }
  /*
    onUpdateNeighborhoodsData() {
      const { neighborhoods = {} } = this.props;
      const neighborhoodsEntries = Object.entries(neighborhoods);
      this.neighborhoodsEntries = neighborhoodsEntries;
    }
  
    onUpdateNeighborhoodsLayer() {
      const { neighborhoodLayerDefs: neighborhoodLayerDef } = this.props;
      if (neighborhoodLayerDef) {
        this.neighborhoodsLayer = this.createNeighborhoodsLayer(neighborhoodLayerDef);
      } else {
        this.neighborhoodsLayer = null;
      }
    }
    */
  onUpdateImages() {
    this.imageLayers = this.createImageLayers();
  }
  viewInfoDidUpdate() {
    super.viewInfoDidUpdate(null, null, By);
  }
  recenter() {
    const { originalViewState: e, setViewState: n } = this.props;
    Array.isArray(e?.target) && typeof e?.zoom == "number" && n(e);
  }
  /**
   * Here, asynchronously check whether props have
   * updated which require re-computing memoized variables,
   * followed by a re-render.
   * This function does not follow React conventions or paradigms,
   * it is only implemented this way to try to squeeze out
   * performance.
   * @param {object} prevProps The previous props to diff against.
   */
  componentDidUpdate(e) {
    this.viewInfoDidUpdate();
    const n = (A) => e[A] !== this.props[A], r = (A, l) => e?.[A]?.[l] !== this.props?.[A]?.[l], i = (A, l, c) => e?.[A]?.[l]?.[c] !== this.props?.[A]?.[l]?.[c], o = (A, l) => e?.[A]?.[0]?.[l] !== this.props?.[A]?.[0]?.[l], s = (A, l, c) => e?.[A]?.[0]?.[l]?.[c] !== this.props?.[A]?.[0]?.[l]?.[c];
    let a = !1;
    n("segmentationLayerScopes") ? (this.onUpdateAllSegmentationsData(), a = !0) : this.props.segmentationLayerScopes?.forEach((A) => {
      r("obsSegmentations", A) && (this.onUpdateSegmentationsData(A), a = !0);
    }), ["segmentationLayerScopes", "segmentationChannelScopesByLayer"].some(n) ? (this.onUpdateAllSegmentationsLocationsData(), a = !0) : this.props.segmentationLayerScopes?.forEach((A) => {
      this.props.segmentationChannelScopesByLayer?.[A]?.forEach((l) => {
        i("obsSegmentationsLocations", A, l) && (this.onUpdateSegmentationsLocationsData(A, l), a = !0);
      });
    }), ["segmentationLayerScopes", "segmentationChannelScopesByLayer"].some(n) ? (this.onUpdateAllSegmentationsSetsData(), a = !0) : this.props.segmentationLayerScopes?.forEach((A) => {
      this.props.segmentationChannelScopesByLayer?.[A]?.forEach((l) => {
        (i("obsSegmentationsSets", A, l) || s("segmentationChannelCoordination", A, l)) && (this.onUpdateSegmentationsSetsData(A, l), a = !0);
      });
    }), ["segmentationLayerScopes", "segmentationChannelScopesByLayer"].some(n) ? (this.onUpdateAllSegmentationsIndexData(), a = !0) : this.props.segmentationLayerScopes?.forEach((A) => {
      this.props.segmentationChannelScopesByLayer?.[A]?.forEach((l) => {
        i("segmentationMatrixIndices", A, l) && (this.onUpdateSegmentationsIndexData(A, l), a = !0);
      });
    }), ["segmentationLayerScopes", "segmentationChannelScopesByLayer"].some(n) ? (this.onUpdateAllSegmentationsExpressionData(), a = !0) : this.props.segmentationLayerScopes.forEach((A) => {
      this.props.segmentationChannelScopesByLayer?.[A]?.forEach((l) => {
        (i("segmentationMatrixIndices", A, l) || i("segmentationMultiExpressionData", A, l)) && (this.onUpdateSegmentationsExpressionData(A, l), a = !0);
      });
    }), [
      // 'cellFilter',
      // 'cellSelection',
      "segmentationLayerScopes",
      "segmentationLayerCoordination",
      "segmentationChannelScopesByLayer",
      "segmentationChannelCoordination"
    ].some(n) && (this.onUpdateSegmentationsLayer(), a = !0), n("spotLayerScopes") ? (this.onUpdateAllSpotsData(), a = !0) : this.props.spotLayerScopes.forEach((A) => {
      r("obsSpots", A) && (this.onUpdateSpotsData(A), a = !0);
    }), n("spotLayerScopes") ? (this.onUpdateAllSpotsSetsData(), a = !0) : this.props.spotLayerScopes.forEach((A) => {
      (r("obsSpotsSets", A) || r("obsSpots", A) || o("spotLayerCoordination", A)) && (this.onUpdateSpotsSetsData(A), a = !0);
    }), n("spotLayerScopes") ? (this.onUpdateAllSpotsIndexData(), a = !0) : this.props.spotLayerScopes.forEach((A) => {
      (r("spotMatrixIndices", A) || r("obsSpots", A)) && (this.onUpdateSpotsIndexData(A), a = !0);
    }), n("spotLayerScopes") ? (this.onUpdateAllSpotsExpressionData(), a = !0) : this.props.spotLayerScopes.forEach((A) => {
      (r("spotMatrixIndices", A) || r("obsSpots", A) || r("spotMultiExpressionData", A)) && (this.onUpdateSpotsExpressionData(A), a = !0);
    }), [
      "obsSpots",
      "spotLayerScopes",
      "spotLayerCoordination",
      "spotMultiExpressionData"
    ].some(n) && (this.onUpdateSpotsLayer(), a = !0), n("pointLayerScopes") ? (this.onUpdateAllPointsData(), a = !0) : this.props.pointLayerScopes.forEach((A) => {
      (r("obsPoints", A) || r("pointMultiObsLabels", A)) && (this.onUpdatePointsData(A), a = !0);
    }), [
      "obsPoints",
      "pointLayerScopes",
      "pointLayerCoordination",
      "pointMultiObsLabels"
    ].some(n) && (this.onUpdatePointsLayer(), a = !0), [
      "images",
      "imageLayerScopes",
      "imageLayerCoordination",
      "imageChannelScopesByLayer",
      "imageChannelCoordination"
    ].some(n) && (this.onUpdateImages(), a = !0), a && this.forceUpdate();
  }
}
const MXn = CE((t, e) => ne.jsx(LXn, { ...t, deckRef: e }));
function A3(t) {
  const { x: e, y: n, parentUuid: r, sourceUuid: i, width: o, height: s, info: a, tooltipsVisible: A, tooltipCrosshairsVisible: l } = t;
  return (r === i ? A : l) ? ne.jsx(Tq, { x: e, y: n, parentUuid: r, sourceUuid: i, parentWidth: o, parentHeight: s, children: ne.jsx(Nq, { info: a }) }) : null;
}
function mK(t, e, n, r, i, o) {
  if (!(i ? !0 : n && r))
    return null;
  const a = n?.indexOf(t);
  if (a < 0)
    return null;
  if (i)
    return [o?.[0], o?.[1]];
  const A = [r?.data[0][a] || 0, r?.data[1][a] || 0, 0], l = e?.project(A);
  return [l?.[0], l?.[1]];
}
function OXn(t) {
  const {
    parentUuid: e,
    width: n,
    height: r,
    hoverCoord: i,
    // Points
    obsPoints: o,
    pointLayerScopes: s,
    pointLayerCoordination: a,
    // Spots
    obsSpots: A,
    spotLayerScopes: l,
    spotLayerCoordination: c,
    // Segmentations
    obsSegmentationsLocations: u,
    segmentationLayerScopes: f,
    segmentationChannelScopesByLayer: h,
    segmentationChannelCoordination: d,
    // Images
    imageLayerScopes: I,
    imageLayerCoordination: m
  } = t, C = JH(), y = KH(e), v = C === e && i, b = v ? y?.project(i) : null;
  let Q = -30;
  return ne.jsxs(ne.Fragment, { children: [b && I?.map((w) => {
    const { pixelHighlight: R, tooltipsVisible: M, spatialLayerVisible: O } = m?.[0]?.[w] || {};
    return M && R && O ? ne.jsx(A3, { parentUuid: e, sourceUuid: C, width: n, height: r, info: {
      "Pixel Value": JSON.stringify(R)
    }, x: b?.[0], y: b?.[1] + (Q += 30) }, w) : null;
  }), f?.flatMap((w) => h?.[w]?.map((R) => {
    const { obsType: M, obsHighlight: O, tooltipsVisible: L, tooltipCrosshairsVisible: N, spatialChannelVisible: k } = d?.[0]?.[w]?.[R] || {};
    if (!O || !k || !L && !N)
      return null;
    const { obsIndex: $, obsLocations: U } = u?.[w]?.[R] || {}, X = mK(O, y, $, U, v, b);
    if (!X)
      return null;
    const [K, z] = X;
    return ne.jsx(A3, { parentUuid: e, sourceUuid: C, tooltipsVisible: L, tooltipCrosshairsVisible: N, width: n, height: r, info: {
      [`${Ci(M)} ID`]: O
    }, x: K, y: z + (Q += 30) }, `${w}-${R}`);
  })), l?.map((w) => {
    const { obsType: R, obsHighlight: M, tooltipsVisible: O, tooltipCrosshairsVisible: L, spatialLayerVisible: N } = c?.[0]?.[w] || {};
    if (!M || !N || !O && !L)
      return null;
    const { obsIndex: k, obsSpots: $ } = A?.[w] || {}, U = mK(M, y, k, $, v, b);
    if (!U)
      return null;
    const [X, K] = U;
    return ne.jsx(A3, { parentUuid: e, sourceUuid: C, tooltipsVisible: O, tooltipCrosshairsVisible: L, width: n, height: r, info: {
      [`${Ci(R)} ID`]: M
    }, x: X, y: K + (Q += 30) }, w);
  }), s?.map((w) => {
    const { obsType: R, obsHighlight: M, tooltipsVisible: O, tooltipCrosshairsVisible: L, spatialLayerVisible: N } = a?.[0]?.[w] || {};
    if (!M || !N || !O && !L)
      return null;
    const { obsIndex: k, obsPoints: $ } = o?.[w] || {}, U = mK(M, y, k, $, v, b);
    if (!U)
      return null;
    const [X, K] = U;
    return ne.jsx(A3, { parentUuid: e, sourceUuid: C, tooltipsVisible: O, tooltipCrosshairsVisible: L, width: n, height: r, info: {
      [`${Ci(R)} ID`]: M
    }, x: X, y: K + (Q += 30) }, w);
  })] });
}
const FXn = {
  zoom: 0,
  target: [0, 0, 0],
  rotationX: 0,
  rotationOrbit: 0
}, PXn = () => {
};
function kXn(t, e) {
  const { coordinate: n, sourceLayer: r, tile: i } = t;
  if ((e === "segmentation-bitmask" || e === "image") && n && r && r.id.startsWith("Tiled") && i) {
    const { content: o, bbox: s, index: { z: a } } = i;
    if (o) {
      const { data: A, width: l, height: c } = o, { left: u, right: f, top: h, bottom: d } = s, I = [
        u,
        A.height < r.tileSize ? c : d,
        A.width < r.tileSize ? l : f,
        h
      ], m = Math.max(1, 2 ** Math.round(-a)), C = [
        Math.floor((n[0] - I[0]) / m),
        Math.floor((n[1] - I[3]) / m)
      ], y = C[1] * l + C[0];
      return A.map((b) => b[y]);
    }
  }
  return (e === "segmentation-polygon" || e === "spot" || e === "point") && t.index ? e === "segmentation-polygon" ? [t.index] : t.index : null;
}
function GXn(t) {
  const {
    uuid: e,
    coordinationScopes: n,
    coordinationScopesBy: r,
    closeButtonVisible: i,
    downloadButtonVisible: o,
    removeGridComponent: s,
    observationsLabelOverride: a,
    subobservationsLabelOverride: A = "molecule",
    theme: l,
    disableTooltip: c = !1,
    title: u = "Spatial",
    bitmaskValueIsIndex: f = !1
    // TODO: move to coordination type
  } = t, h = eu(), d = yL(), I = vL(e), m = bUe(), C = yUe(n), y = vUe(C, r), [{ dataset: v, obsType: b, featureType: Q, featureValueType: w, spatialZoom: R, spatialTargetX: M, spatialTargetY: O, spatialTargetZ: L, spatialTargetT: N, spatialRenderingMode: k, spatialRotationX: $, spatialRotationOrbit: U, spatialOrbitAxis: X, spatialAxisFixed: K }, { setSpatialZoom: z, setSpatialTargetX: Y, setSpatialTargetY: V, setSpatialTargetZ: Z, setSpatialRotationX: ce, setSpatialRotationOrbit: ee }] = uc(ea[Gn.SPATIAL_BETA], C), { spatialZoom: pe, spatialTargetX: Ce, spatialTargetY: Be, spatialTargetZ: Ie } = yae(ea[Gn.SPATIAL_BETA], C), [Qe, xe] = U4(re.SEGMENTATION_CHANNEL, re.SEGMENTATION_LAYER, C, y), [Se, De] = U4(re.IMAGE_CHANNEL, re.IMAGE_LAYER, C, y), Ue = G4(re.SPOT_LAYER, C), Te = G4(re.POINT_LAYER, C), se = TA([
    re.FILE_UID,
    re.SEGMENTATION_CHANNEL,
    re.SPATIAL_LAYER_VISIBLE,
    re.SPATIAL_LAYER_OPACITY
  ], C, y, re.SEGMENTATION_LAYER), fe = wI([
    re.OBS_TYPE,
    re.SPATIAL_TARGET_C,
    re.SPATIAL_CHANNEL_VISIBLE,
    re.SPATIAL_CHANNEL_OPACITY,
    re.SPATIAL_CHANNEL_COLOR,
    re.SPATIAL_SEGMENTATION_FILLED,
    re.SPATIAL_SEGMENTATION_STROKE_WIDTH,
    re.OBS_COLOR_ENCODING,
    re.FEATURE_SELECTION,
    re.FEATURE_VALUE_COLORMAP,
    re.FEATURE_VALUE_COLORMAP_RANGE,
    re.OBS_SET_COLOR,
    re.OBS_SET_SELECTION,
    re.ADDITIONAL_OBS_SETS,
    re.OBS_HIGHLIGHT,
    re.TOOLTIPS_VISIBLE,
    re.TOOLTIP_CROSSHAIRS_VISIBLE,
    re.LEGEND_VISIBLE
  ], C, y, re.SEGMENTATION_LAYER, re.SEGMENTATION_CHANNEL), W = TA([
    re.FILE_UID,
    re.IMAGE_CHANNEL,
    re.SPATIAL_LAYER_VISIBLE,
    re.SPATIAL_LAYER_OPACITY,
    re.SPATIAL_LAYER_COLORMAP,
    re.SPATIAL_LAYER_TRANSPARENT_COLOR,
    re.SPATIAL_LAYER_MODEL_MATRIX,
    re.VOLUMETRIC_RENDERING_ALGORITHM,
    re.SPATIAL_TARGET_RESOLUTION,
    re.SPATIAL_SLICE_X,
    re.SPATIAL_SLICE_Y,
    re.SPATIAL_SLICE_Z,
    re.PHOTOMETRIC_INTERPRETATION,
    re.PIXEL_HIGHLIGHT,
    re.TOOLTIPS_VISIBLE,
    re.SPATIAL_CHANNEL_LABELS_VISIBLE,
    re.SPATIAL_CHANNEL_LABELS_ORIENTATION,
    re.SPATIAL_CHANNEL_LABEL_SIZE
  ], C, y, re.IMAGE_LAYER), ge = wI([
    re.SPATIAL_TARGET_C,
    re.SPATIAL_CHANNEL_VISIBLE,
    re.SPATIAL_CHANNEL_COLOR,
    re.SPATIAL_CHANNEL_WINDOW
  ], C, y, re.IMAGE_LAYER, re.IMAGE_CHANNEL), _e = TA([
    re.OBS_TYPE,
    re.SPATIAL_LAYER_VISIBLE,
    re.SPATIAL_LAYER_OPACITY,
    re.SPATIAL_SPOT_RADIUS,
    re.SPATIAL_SPOT_FILLED,
    re.SPATIAL_SPOT_STROKE_WIDTH,
    re.OBS_COLOR_ENCODING,
    re.FEATURE_SELECTION,
    re.FEATURE_VALUE_COLORMAP,
    re.FEATURE_VALUE_COLORMAP_RANGE,
    re.OBS_SET_COLOR,
    re.OBS_SET_SELECTION,
    re.ADDITIONAL_OBS_SETS,
    re.SPATIAL_LAYER_COLOR,
    re.OBS_HIGHLIGHT,
    re.TOOLTIPS_VISIBLE,
    re.TOOLTIP_CROSSHAIRS_VISIBLE,
    re.LEGEND_VISIBLE
  ], C, y, re.SPOT_LAYER), Re = TA([
    re.OBS_TYPE,
    re.SPATIAL_LAYER_VISIBLE,
    re.SPATIAL_LAYER_OPACITY,
    re.OBS_COLOR_ENCODING,
    re.FEATURE_SELECTION,
    re.FEATURE_VALUE_COLORMAP,
    re.FEATURE_VALUE_COLORMAP_RANGE,
    re.SPATIAL_LAYER_COLOR,
    re.OBS_HIGHLIGHT,
    re.TOOLTIPS_VISIBLE,
    re.TOOLTIP_CROSSHAIRS_VISIBLE,
    re.LEGEND_VISIBLE
  ], C, y, re.POINT_LAYER), Ee = k === "3D", [oe, ie, Ae] = QL(), [de, we, Pe] = G8e(C, y, h, v, m, e), [qe, ke] = RGt(C, y, h, v), [Xe, rt, it] = U8e(C, y, h, v, m, e), [ht, mt] = IGt(C, y, h, v), [_t, Ct, zt, jt, lt] = QGt(C, y, h, v), [Ht, vt] = xGt(C, y, h, v), [It, un] = DGt(C, y, h, v), [hn, We, En] = H8e(C, y, h, v, m, e), [qn, Pt] = TGt(C, y, h, v), [dr, yr, jn, Ot, yn] = SGt(C, y, h, v), [Fn, xn] = wGt(C, y, h, v), [vn, nt, st] = $8e(C, y, h, v, m, e), xt = Jc([
    we,
    rt,
    We,
    nt
  ]), Me = Jc([
    // Spots
    rt,
    mt,
    lt,
    vt,
    // Points
    we,
    ke,
    // Segmentations
    We,
    Pt,
    yn,
    xn,
    un,
    // Images
    nt
  ]), _ = Qd([
    Object.values(it || {}).flat(),
    Object.values(Pe || {}).flat(),
    Object.values(En || {}).flat(),
    Object.values(st || {}).flat()
    // TODO: more urls
    // TODO: a bit of memoization
  ]), [ye, He] = mn(null), { initialTargetX: ze, initialTargetY: tt, initialTargetZ: At, initialZoom: pt } = dt(
    () => BXn({
      width: oe,
      height: ie,
      obsPoints: de,
      obsSpots: Xe,
      obsSegmentations: hn,
      obsSegmentationsLocations: It,
      segmentationChannelScopesByLayer: xe,
      images: vn,
      is3dMode: Ee,
      isReady: xt
    }),
    // Deliberate dependency omissions: imageLayerLoaders and meta - using `image` as
    // an indirect dependency instead.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      vn,
      Ee,
      hn,
      oe,
      ie,
      Xe,
      xt,
      It,
      de,
      xe
    ]
  );
  Mn(() => {
    oe && ie && (typeof Ce != "number" || typeof Be != "number" ? ((typeof M != "number" || typeof O != "number" || M === ze && O === tt) && (Y(ze), V(tt), Z(At), z(pt)), He({ target: [ze, tt, At], zoom: pt })) : ye || He({
      target: [Ce, Be, Ie],
      zoom: pe
    }));
  }, [
    ze,
    tt,
    At,
    pt,
    Ce,
    Be,
    Ie,
    pe
  ]);
  const Bt = ({ zoom: Sn, target: kn, rotationX: vr, rotationOrbit: Tr }) => {
    z(Sn), Y(kn[0]), V(kn[1]), Ee && (kn[2] !== void 0 && Z(kn[2]), ce(vr), ee(Tr));
  }, Rt = dt(() => {
    const Sn = Object.values(de || {}).reduce(($t, Ye) => $t + (Ye?.obsIndex?.length || 0), 0), kn = Object.values(Xe || {}).reduce(($t, Ye) => $t + (Ye?.obsIndex?.length || 0), 0), vr = Qe.map(($t) => xe[$t].map((Ye) => [$t, Ye])).flat(1).map(([$t, Ye]) => {
      let en = It?.[$t]?.[Ye]?.obsIndex;
      return en || (en = qn?.[$t]?.[Ye]?.obsIndex, en || (en = Fn?.[$t]?.[Ye]?.obsIndex)), en;
    }).reduce(($t, Ye) => $t + (Ye?.length || 0), 0), Tr = Se?.length || 0;
    return [
      [Sn, "point"],
      [kn, "spot"],
      [vr, "segmentation"],
      [Tr, "image"]
    ].filter(([$t]) => $t > 0).map(([$t, Ye]) => `${fI($t)} ${Bf(Ye, $t)}`).join(", ");
  }, [
    de,
    Xe,
    Qe,
    xe,
    It,
    qn,
    Fn,
    Se
  ]), [Lt, rn] = mn(null), Wr = Ee ? R !== null && M !== null && O !== null && L !== null && $ !== null && U !== null && X !== null : R !== null && M !== null && O !== null, pr = Qn((Sn, kn, vr) => {
    const { coordinate: Tr } = Sn;
    let $t = !1;
    const Ye = kXn(Sn, kn);
    return Se?.forEach((en) => {
      const { setPixelHighlight: Ir } = W?.[1]?.[en] || {};
      Ye && kn === "image" && vr === en ? ($t = !0, Ir(Ye)) : Ir(null);
    }), Qe?.forEach((en) => {
      xe?.[en]?.forEach((zr, In) => {
        const { setObsHighlight: mr } = fe[1][en][zr];
        if (Ye && ["segmentation-bitmask", "segmentation-polygon"].includes(kn) && vr === en) {
          const Mr = Ye[In];
          let $e = Mr;
          if (Mr > 0) {
            let Ps;
            if (kn === "segmentation-bitmask") {
              const { obsIndex: Wn } = Fn?.[en]?.[zr] || {};
              $e -= 1, Wn && f ? Ps = Wn?.[$e] : Ps = String($e);
            } else {
              const { obsIndex: Wn } = hn?.[en] || {};
              Ps = Wn?.[$e];
            }
            Ps ? ($t = !0, mr(Ps)) : mr(null);
          } else
            mr(null);
        } else
          mr(null);
      });
    }), Ue?.forEach((en) => {
      const { setObsHighlight: Ir } = _e?.[1]?.[en] || {};
      if (Ye && kn === "spot" && vr === en) {
        const zr = Ye, { obsIndex: In } = Xe?.[en] || {}, mr = In?.[zr];
        In && mr ? ($t = !0, Ir(mr)) : Ir(null);
      } else
        Ir(null);
    }), Te?.forEach((en) => {
      const { setObsHighlight: Ir } = Re?.[1]?.[en] || {};
      if (Ye && kn === "point" && vr === en) {
        const zr = Ye, { obsIndex: In } = de?.[en] || {}, mr = In?.[zr];
        In && mr ? ($t = !0, Ir(mr)) : Ir(null);
      } else
        Ir(null);
    }), $t ? (rn(Tr), d(e)) : rn(null), !1;
  }), Vt = Ue.length > 0 || Te.length > 0 || Qe.flatMap((Sn) => xe[Sn].map((kn) => It?.[Sn]?.[kn])).length > 0;
  return ne.jsxs(fc, { title: u, info: Rt, isSpatial: !0, urls: _, theme: l, closeButtonVisible: i, downloadButtonVisible: o, removeGridComponent: s, isReady: Me, children: [ne.jsx(MXn, {
    ref: Ae,
    uuid: e,
    width: oe,
    height: ie,
    theme: l,
    hideTools: !Vt,
    // Global view state
    targetT: N,
    targetZ: L,
    viewState: Wr ? {
      zoom: R,
      target: [M, O, L],
      rotationX: $,
      rotationOrbit: U
    } : FXn,
    orbitAxis: X,
    spatialAxisFixed: K,
    setViewState: Wr ? Bt : PXn,
    originalViewState: ye,
    spatialRenderingMode: k,
    updateViewInfo: I,
    delegateHover: pr,
    // Points
    obsPoints: de,
    pointLayerScopes: Te,
    pointLayerCoordination: Re,
    pointMultiObsLabels: qe,
    // Spots
    obsSpots: Xe,
    spotLayerScopes: Ue,
    spotLayerCoordination: _e,
    obsSpotsSets: ht,
    spotMatrixIndices: Ht,
    spotMultiExpressionData: jt,
    // Segmentations
    segmentationLayerScopes: Qe,
    segmentationLayerCoordination: se,
    segmentationChannelScopesByLayer: xe,
    segmentationChannelCoordination: fe,
    obsSegmentations: hn,
    obsSegmentationsLocations: It,
    obsSegmentationsSets: qn,
    segmentationMatrixIndices: Fn,
    segmentationMultiExpressionData: Ot,
    bitmaskValueIsIndex: f,
    // Images
    images: vn,
    imageLayerScopes: Se,
    imageLayerCoordination: W,
    imageChannelScopesByLayer: De,
    imageChannelCoordination: ge
  }), !c && ne.jsx(OXn, {
    parentUuid: e,
    width: oe,
    height: ie,
    hoverCoord: Lt,
    // Points
    obsPoints: de,
    pointLayerScopes: Te,
    pointLayerCoordination: Re,
    // Spots
    obsSpots: Xe,
    spotLayerScopes: Ue,
    spotLayerCoordination: _e,
    // Segmentations
    obsSegmentationsLocations: It,
    segmentationLayerScopes: Qe,
    segmentationChannelScopesByLayer: xe,
    segmentationChannelCoordination: fe,
    // Images
    imageLayerScopes: Se,
    imageLayerCoordination: W
  }), ne.jsx(
    ozn,
    {
      // Fix to dark theme due to black background of spatial plot.
      theme: "dark",
      // Segmentations
      segmentationLayerScopes: Qe,
      segmentationLayerCoordination: se,
      segmentationChannelScopesByLayer: xe,
      segmentationChannelCoordination: fe,
      segmentationMultiExpressionExtents: jn,
      // Spots
      spotLayerScopes: Ue,
      spotLayerCoordination: _e,
      spotMultiExpressionExtents: zt,
      // Points
      pointLayerScopes: Te,
      pointLayerCoordination: Re
    }
  ), ne.jsx(
    azn,
    {
      // Images
      images: vn,
      imageLayerScopes: Se,
      imageLayerCoordination: W,
      imageChannelScopesByLayer: De,
      imageChannelCoordination: ge
    }
  )] });
}
function UXn({ layer: t, viewport: e }) {
  if (e.id === "axisLeft")
    return t.id.startsWith("axisLeft");
  if (e.id === "axisTop")
    return t.id.startsWith("axisTop");
  if (e.id === "cellColorLabel")
    return t.id.startsWith("cellColorLabel");
  if (e.id === "heatmap")
    return t.id.startsWith("heatmap");
  if (e.id.startsWith("colorsLeft")) {
    const n = e.id.match(/-(\d)/);
    if (n)
      return t.id.startsWith(`colorsLeftLayer-${n[1]}`);
  }
  if (e.id.startsWith("colorsTop")) {
    const n = e.id.match(/-(\d)/);
    if (n)
      return t.id.startsWith(`colorsTopLayer-${n[1]}`);
  }
  return !1;
}
function f5(t, e) {
  const r = (f5.canvas || (f5.canvas = document.createElement("canvas"))).getContext("2d");
  return r.font = e, r.measureText(t).width;
}
function HXn(t, e, n, r, i) {
  const o = `${Zb}pt ${e_}`, s = i ? 0 : f5(e, o) + uRe, a = r ? 0 : f5(n, o) + uRe, A = Su(t ? s : a, lRe, cRe), l = Su(t ? a : s, lRe, cRe);
  return [A, l];
}
function $Xn(t, e, { offsetLeft: n, offsetTop: r, targetX: i, targetY: o, scaleFactor: s, matrixWidth: a, matrixHeight: A, numRows: l, numCols: c }) {
  const u = t - n, f = e - r;
  if (u < 0 || f < 0)
    return [null, null];
  const h = i * s + a * s / 2, d = o * s + A * s / 2, I = h - a / 2, m = d - A / 2, C = I / (a * s), y = m / (A * s), v = u / (a * s), b = f / (A * s), Q = C + v, w = y + b, R = Math.floor(w * l);
  return [Math.floor(Q * c), R];
}
function qXn(t, e, { offsetLeft: n, offsetTop: r, targetX: i, targetY: o, scaleFactor: s, matrixWidth: a, matrixHeight: A, numRows: l, numCols: c }) {
  let u = null, f = null;
  if (e !== null) {
    const h = -A * s / 2, I = A * s / 2 - h, m = o * s - A / 2, C = o * s + A / 2, y = C - m, v = (e + 0.5) / l, b = h + v * I;
    m <= b && b <= C && (u = r + (b - m) / y * A);
  }
  if (t !== null) {
    const h = -a * s / 2, I = a * s / 2 - h, m = i * s - a / 2, C = i * s + a / 2, y = C - m, v = (t + 0.5) / c, b = h + v * I;
    m <= b && b <= C && (f = n + (b - m) / y * a);
  }
  return [f, u];
}
function jXn(t, e, { axisOffsetTop: n, axisOffsetLeft: r, offsetTop: i, offsetLeft: o, colorBarSize: s, numCellColorTracks: a, transpose: A, targetX: l, targetY: c, scaleFactor: u, matrixWidth: f, matrixHeight: h, numRows: d, numCols: I }) {
  const m = A ? t - o : e - i, C = A ? e - n : t - r, y = a * s;
  if (m < 0 || C < 0 || C >= y)
    return [null, null];
  const v = Math.floor(C / s);
  let b;
  if (A) {
    const N = t - o, U = (l * u + f * u / 2 - f / 2) / (f * u), X = N / (f * u), K = U + X;
    return b = Math.floor(K * I), [b, v];
  }
  const Q = e - n, M = (c * u + h * u / 2 - h / 2) / (h * u), O = Q / (h * u), L = M + O;
  return b = Math.floor(L * d), [b, v];
}
function YXn(t, e) {
  var n = atob(t);
  if (e) {
    for (var r = new Uint8Array(n.length), i = 0, o = n.length; i < o; ++i)
      r[i] = n.charCodeAt(i);
    return String.fromCharCode.apply(null, new Uint16Array(r.buffer));
  }
  return n;
}
function zXn(t, e, n) {
  var r = e === void 0 ? null : e, i = n === void 0 ? !1 : n, o = YXn(t, i), s = o.indexOf(`
`, 10) + 1, a = o.substring(s) + (r ? "//# sourceMappingURL=" + r : ""), A = new Blob([a], { type: "application/javascript" });
  return URL.createObjectURL(A);
}
function VXn(t, e, n) {
  var r;
  return function(o) {
    return r = r || zXn(t, e, n), new Worker(r, o);
  };
}
var JXn = VXn("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", null, !1);
function KXn() {
  return new JXn();
}
class WXn extends fut {
  constructor() {
    super(KXn);
  }
  /**
   * Process each heatmap tile
   * @param {object} params The arguments passed to the heatmap worker.
   * @param {string} params.curr The current task uuid.
   * @param {number} params.xTiles How many tiles required in the x direction?
   * @param {number} params.yTiles How many tiles required in the y direction?
   * @param {number} params.tileSize How many entries along each tile axis?
   * @param {string[]} params.cellOrdering The current ordering of cells.
   * @param {string[]} params.rows The name of each row (cell ID).
   * Does not take transpose into account (always cells).
   * @param {string[]} params.cols The name of each column (gene ID).
   * Does not take transpose into account (always genes).
   * @param {ArrayBuffer} params.data The array buffer.
   * Need to transfer back to main thread when done.
   * @param {boolean} params.transpose Is the heatmap transposed?
   * @returns {array} [message, transfers]
   * @returns {Promise.<ArrayBuffer>} the decoded result as a `Promise`
   */
  async process(e) {
    const n = await this.waitForWorker();
    return new Promise((r, i) => {
      n.onmessage = (o) => {
        this.finishTask(n), r(o.data);
      }, n.onerror = (o) => {
        this.finishTask(n), i(o);
      }, n.postMessage(["getTile", e], [e.data]);
    });
  }
}
const CK = new Uint8Array(vg * vg);
function M2(t) {
  return t <= vg ** 2;
}
const XXn = CE((t, e) => {
  const { uuid: n, theme: r, viewState: i, setViewState: o, width: s, height: a, uint8ObsFeatureMatrix: A, cellColors: l, cellColorLabels: c = [""], colormap: u, colormapRange: f, setComponentHover: h, setCellHighlight: d = sut("Heatmap"), setGeneHighlight: I = aut("Heatmap"), setTrackHighlight: m = Aut("Heatmap"), updateViewInfo: C = lut("Heatmap"), setIsRendering: y = () => {
  }, transpose: v = !1, variablesTitle: b = "Genes", observationsTitle: Q = "Cells", variablesDashes: w = !0, observationsDashes: R = !0, useDevicePixels: M = 1, hideObservationLabels: O = !1, hideVariableLabels: L = !1, onHeatmapClick: N, setColorEncoding: k, obsIndex: $, featureIndex: U, featureLabelsMap: X } = t, K = {
    ...i,
    target: v ? [i.target[1], i.target[0]] : i.target,
    minZoom: 0
  }, z = v ? b : Q, Y = v ? Q : b, V = dt(() => new WXn(), []), Z = Zr(), ce = Zr(), [ee, pe] = mn([]), [Ce, Be] = mn([]), [Ie, Qe] = mn([]), [xe, Se] = mn("default"), [De, Ue] = T3e((He) => He + 1, 0), [Te, se] = mn([]);
  Mn(() => {
    A && !M2(A.length) && (ce.current = cut(A));
  }, [ce, A]), Mn(() => {
    if (!$)
      return;
    const He = !l || l.size === 0 ? $ : Array.from(l.keys());
    gr(v ? Ce : ee, He) || (v ? Be(He) : pe(He));
  }, [$, l, Ce, ee, v]), Mn(() => {
    U && (v ? pe(U) : Be(U));
  }, [U, v]);
  const [fe, W] = dt(() => !$ || !U ? ["", ""] : [
    _me($),
    _me([...U, ...c])
  ], [U, c, $]), ge = dt(() => {
    const He = /* @__PURE__ */ new Map();
    return $ && $.forEach((ze, tt) => He.set(ze, tt)), He;
  }, [$]), _e = Ce.length, Re = ee.length, [Ee, oe] = HXn(v, W, fe, O, L), [ie, Ae] = mn(null), de = oe + Qh * (v ? Ie : 0), we = Ee + Qh * (v ? 0 : Ie), Pe = s - we, qe = a - de, ke = -Pe / 2, Xe = Pe / 2, rt = -qe / 2, it = qe / 2, ht = Math.ceil(_e / Sa), mt = Math.ceil(Re / Sa), _t = 1 - (Sa - _e % Sa) / (ht * Sa), Ct = 1 - (Sa - Re % Sa) / (mt * Sa), zt = Pe / _t / ht, jt = qe / Ct / mt, lt = 2 ** K.zoom, Ht = qe * lt / Re, vt = Pe * lt / _e, It = Su(2 ** Math.ceil(Math.log2(1 / vt)), sRe, aRe), un = Su(2 ** Math.ceil(Math.log2(1 / Ht)), sRe, aRe), [hn, We] = K.target;
  Mn(() => {
    C({
      uuid: n,
      projectFromId: (He, ze) => {
        const tt = v ? Ce.indexOf(He) : Ce.indexOf(ze), At = v ? ee.indexOf(ze) : ee.indexOf(He);
        return qXn(tt, At, {
          offsetLeft: we,
          offsetTop: de,
          targetX: K.target[0],
          targetY: K.target[1],
          scaleFactor: lt,
          matrixWidth: Pe,
          matrixHeight: qe,
          numRows: Re,
          numCols: _e
        });
      }
    });
  }, [
    n,
    C,
    v,
    Ce,
    ee,
    we,
    de,
    K,
    lt,
    Pe,
    qe,
    Re,
    _e
  ]);
  const En = Qn(({ viewState: He }) => {
    const { zoom: ze } = He, tt = 2 ** ze, At = ze === 0 ? 0 : -(Xe - Xe / tt), pt = -1 * At, Bt = ze === 0 ? 0 : -(it - it / tt), Rt = -1 * Bt, Lt = [
      Su(He.target[0], At, pt),
      Su(He.target[1], Bt, Rt)
    ];
    o({
      zoom: ze,
      target: v ? [Lt[1], Lt[0]] : Lt
    });
  }, [Xe, it, v, o]);
  Mn(() => {
    !A || A.length < vg ** 2 || Ce && ee && ht && mt && se((He) => [...He, BT()]);
  }, [ce, A, Ce, ee, ht, mt]), Mn(() => {
    if (Te.length < 1 || M2(ce.current.length))
      return;
    const He = Te[Te.length - 1];
    if (ce.current && ce.current.buffer.byteLength && ge.size > 0 && !M2(ce.current.length)) {
      const ze = oA(mt).map((At) => oA(ht).map(async (pt) => V.process({
        curr: He,
        tileI: At,
        tileJ: pt,
        tileSize: Sa,
        cellOrdering: v ? Ce : ee,
        cols: U,
        transpose: v,
        data: A.buffer.slice(),
        expressionRowLookUp: ge
      })));
      (async () => {
        const At = await Promise.all(ze.flat());
        Z.current = At.map((Bt) => Bt.tile), Ue(), ce.current = new Uint8Array(At[0].buffer);
        const { curr: pt } = At[0];
        se((Bt) => {
          const Rt = Bt.indexOf(pt);
          return Bt.slice(Rt + 1, Bt.length);
        });
      })();
    }
  }, [
    ee,
    Ce,
    Te,
    A,
    v,
    ht,
    mt,
    V,
    ge,
    U
  ]), Mn(() => {
    y(Te.length > 0);
  }, [Te, y]);
  const qn = dt(() => {
    const He = v ? Ce : ee;
    if (A && He.length && ie && M2(A.length)) {
      let ze = 0;
      for (let tt = 0; tt < He.length; tt += 1) {
        const At = He[tt];
        ze = v ? tt : ze;
        const pt = ge.get(At);
        for (let Bt = 0; Bt < U.length; Bt += 1) {
          const Rt = pt * U.length + Bt;
          CK[ze % (vg * vg)] = A[Rt], ze = v ? ze + He.length : ze + 1;
        }
      }
    }
    return ie ? new xo(ie, {
      data: CK,
      mipmaps: !1,
      parameters: yq,
      // Each color contains a single luminance value.
      // When sampled, rgb are all set to this luminance, alpha is 1.0.
      // Reference: https://luma.gl/docs/api-reference/webgl/texture#texture-formats
      format: gt.LUMINANCE,
      dataFormat: gt.LUMINANCE,
      type: gt.UNSIGNED_BYTE,
      width: vg,
      height: vg
    }) : CK;
  }, [
    v,
    Ce,
    ee,
    A,
    ge,
    U,
    ie
  ]), Pt = dt(() => {
    const He = A && M2(A.length);
    if ((!Z.current || Te.length) && !He)
      return [];
    if (He) {
      let pt = function(Rt, Lt) {
        return new Yue({
          id: `heatmapLayer-${Rt}-${Lt}`,
          image: qn,
          bounds: [
            ke + Lt * zt,
            rt + Rt * jt,
            ke + (Lt + 1) * zt,
            rt + (Rt + 1) * jt
          ],
          tileI: Rt,
          tileJ: Lt,
          numXTiles: ht,
          numYTiles: mt,
          origDataSize: v ? [U.length, At.length] : [At.length, U.length],
          aggSizeX: It,
          aggSizeY: un,
          colormap: u,
          colorScaleLo: f[0],
          colorScaleHi: f[1],
          updateTriggers: {
            image: [ee, Ce],
            bounds: [jt, zt]
          }
        });
      };
      const At = v ? Ce : ee;
      return oA(mt * ht).map((Rt) => pt(Math.floor(Rt / ht), Rt % ht));
    }
    function ze(At, pt, Bt) {
      return new que({
        id: `heatmapLayer-${De}-${At}-${pt}`,
        image: Bt,
        bounds: [
          ke + pt * zt,
          rt + At * jt,
          ke + (pt + 1) * zt,
          rt + (At + 1) * jt
        ],
        aggSizeX: It,
        aggSizeY: un,
        colormap: u,
        colorScaleLo: f[0],
        colorScaleHi: f[1],
        updateTriggers: {
          image: [ee, Ce],
          bounds: [jt, zt]
        }
      });
    }
    return Z.current.map((At, pt) => ze(Math.floor(pt / ht), pt % ht, At));
  }, [
    A,
    Te.length,
    v,
    Ce,
    ee,
    qn,
    ke,
    zt,
    rt,
    jt,
    mt,
    ht,
    It,
    un,
    u,
    f,
    De,
    U
  ]), dr = v ? w : R, yr = v ? R : w, jn = dt(() => (!v && X ? Ce.map((He) => X.get(He) || He) : Ce).map((He, ze) => [ze, yr ? `- ${He}` : He]), [Ce, yr, v, X]), Ot = dt(() => (v && X ? ee.map((He) => X.get(He) || He) : ee).map((He, ze) => [ze, dr ? `${He} -` : He]), [ee, dr, v, X]), yn = dt(() => c.map((He, ze) => [ze, He && (v ? `${He} -` : `- ${He}`)]), [c, v]), Fn = v ? O : L, xn = v ? L : O, vn = [
    new FG({
      axis: "left",
      id: "axisLeftCompositeTextLayer",
      targetX: hn,
      targetY: We,
      scaleFactor: lt,
      axisLeftLabelData: Ot,
      matrixTop: rt,
      height: Re,
      matrixHeight: qe,
      cellHeight: Ht,
      cellWidth: vt,
      axisTopLabelData: jn,
      matrixLeft: ke,
      width: _e,
      matrixWidth: Pe,
      viewHeight: a,
      viewWidth: s,
      theme: r,
      axisLeftTitle: z,
      axisTopTitle: Y,
      axisOffsetLeft: Ee,
      axisOffsetTop: oe,
      hideTopLabels: Fn,
      hideLeftLabels: xn,
      transpose: v
    }),
    new FG({
      axis: "top",
      id: "axisTopCompositeTextLayer",
      targetX: hn,
      targetY: We,
      scaleFactor: lt,
      axisLeftLabelData: Ot,
      matrixTop: rt,
      height: Re,
      matrixHeight: qe,
      cellHeight: Ht,
      cellWidth: vt,
      axisTopLabelData: jn,
      matrixLeft: ke,
      width: _e,
      matrixWidth: Pe,
      viewHeight: a,
      viewWidth: s,
      theme: r,
      axisLeftTitle: z,
      axisTopTitle: Y,
      axisOffsetLeft: Ee,
      axisOffsetTop: oe,
      cellColorLabelsData: yn,
      hideTopLabels: Fn,
      hideLeftLabels: xn,
      transpose: v
    }),
    new FG({
      axis: "corner",
      id: "cellColorLabelCompositeTextLayer",
      targetX: hn,
      targetY: We,
      scaleFactor: lt,
      axisLeftLabelData: Ot,
      matrixTop: rt,
      height: Re,
      matrixHeight: qe,
      cellHeight: Ht,
      cellWidth: vt,
      axisTopLabelData: jn,
      matrixLeft: ke,
      width: _e,
      matrixWidth: Pe,
      viewHeight: a,
      viewWidth: s,
      theme: r,
      axisLeftTitle: z,
      axisTopTitle: Y,
      axisOffsetLeft: Ee,
      axisOffsetTop: oe,
      cellColorLabelsData: yn,
      hideTopLabels: Fn,
      hideLeftLabels: xn,
      transpose: v
    })
  ];
  Mn(() => {
    Qe(c.length);
  }, [c]);
  const nt = dt(() => {
    if (!l)
      return null;
    let He, ze, tt, At;
    const pt = v ? Ce : ee, Bt = v ? Sa : 1, Rt = v ? 1 : Sa;
    return oA(Ie).map((rn) => oA(v ? ht : mt).map((pr) => {
      const Vt = new Uint8ClampedArray(Sa * 1 * 4);
      return oA(Sa).forEach((Sn) => {
        if (At = pr * Sa + Sn, At < pt.length && (He = pt[At], tt = l.get(He), ze = (v ? Sn : Sa - Sn - 1) * 4, tt)) {
          typeof tt[0] != "number" && (tt = tt[rn] ?? da(r));
          const [kn, vr, Tr] = tt;
          Vt[ze + 0] = kn, Vt[ze + 1] = vr, Vt[ze + 2] = Tr, Vt[ze + 3] = 255;
        }
      }), new ImageData(Vt, Bt, Rt);
    }));
  }, [
    l,
    v,
    Ce,
    ee,
    Ie,
    ht,
    mt,
    r
  ]), st = dt(() => nt ? nt.map((ze, tt) => ze ? ze.map((At, pt) => new jue({
    id: `${v ? "colorsTopLayer" : "colorsLeftLayer"}-${tt}-${pt}-${BT()}`,
    image: At,
    bounds: v ? [
      ke + pt * zt,
      -qe / 2,
      ke + (pt + 1) * zt,
      qe / 2
    ] : [
      -Pe / 2,
      rt + pt * jt,
      Pe / 2,
      rt + (pt + 1) * jt
    ]
  })) : []) : [], [
    nt,
    rt,
    ke,
    qe,
    Pe,
    zt,
    jt,
    v
  ]), xt = _e > 0 && Re > 0, Me = Pt.concat(xt ? vn : []).concat(...st);
  function _(He, ze) {
    if (!A)
      return;
    let tt = null, At = null;
    const { x: pt, y: Bt } = ze.offsetCenter, [Rt, Lt] = jXn(pt, Bt, {
      axisOffsetTop: oe,
      axisOffsetLeft: Ee,
      offsetTop: de,
      offsetLeft: we,
      colorBarSize: Qh,
      numCellColorTracks: Ie,
      transpose: v,
      targetX: hn,
      targetY: We,
      scaleFactor: lt,
      matrixWidth: Pe,
      matrixHeight: qe,
      numRows: Re,
      numCols: _e
    });
    if (Lt === null || Rt === null)
      m(null), k("geneSelection");
    else {
      const vr = $.indexOf(v ? Ce[Rt] : ee[Rt]), Tr = $[vr];
      m([Tr, Lt, pt, Bt]), tt = Tr, k("cellSelection");
    }
    const [rn, Wr] = $Xn(pt, Bt, {
      offsetLeft: we,
      offsetTop: de,
      targetX: hn,
      targetY: We,
      scaleFactor: lt,
      matrixWidth: Pe,
      matrixHeight: qe,
      numRows: Re,
      numCols: _e
    }), pr = $.indexOf(v ? Ce[rn] : ee[Wr]), Vt = U.indexOf(v ? ee[Wr] : Ce[rn]), Sn = $[pr], kn = U[Vt];
    h && h(), Sn && (tt = Sn), kn && (At = kn), d(tt), I(At), Se(tt !== null || At !== null ? "pointer" : "default");
  }
  const ye = dt(() => oA(Ie).map((ze) => {
    let tt;
    return v ? tt = new Ig({
      id: `colorsTop-${ze}`,
      controller: !0,
      x: we,
      y: oe + ze * Qh,
      width: Pe,
      height: Qh - zm
    }) : tt = new Ig({
      id: `colorsLeft-${ze}`,
      controller: !0,
      x: Ee + ze * Qh,
      y: de,
      width: Qh - zm,
      height: qe
    }), tt;
  }), [
    Ie,
    v,
    we,
    oe,
    Pe,
    Ee,
    de,
    qe
  ]);
  return ne.jsx(FYe, { id: `deckgl-overlay-${n}`, ref: e, onWebGLInitialized: Ae, views: [
    // Note that there are multiple views here,
    // but only one viewState.
    new Ig({
      id: "heatmap",
      controller: !0,
      x: we,
      y: de,
      width: Pe,
      height: qe
    }),
    new Ig({
      id: "axisLeft",
      controller: !1,
      x: 0,
      y: de,
      width: Ee,
      height: qe
    }),
    new Ig({
      id: "axisTop",
      controller: !1,
      x: we,
      y: 0,
      width: Pe,
      height: oe
    }),
    new Ig({
      id: "cellColorLabel",
      controller: !1,
      x: v ? 0 : Ee,
      y: v ? oe : 0,
      width: v ? Ee : Qh * Ie,
      height: v ? Qh * Ie : oe
    }),
    ...ye
  ], layers: Me, layerFilter: UXn, getCursor: (He) => He.isDragging ? "grabbing" : xe, glOptions: out, onViewStateChange: En, viewState: K, onHover: _, useDevicePixels: M, onClick: N });
});
function ZXn(t) {
  const { parentUuid: e, width: n, height: r, transpose: i, getObsInfo: o, getFeatureInfo: s, obsHighlight: a, featureHighlight: A } = t, l = JH(), c = KH(e), [u, f] = a && o ? [
    o(a),
    c && c.projectFromId ? c.projectFromId(a, null)[i ? 0 : 1] : null
  ] : [null, null], [h, d] = A && s ? [
    s(A),
    c && c.projectFromId ? c.projectFromId(null, A)[i ? 1 : 0] : null
  ] : [null, null], I = i ? f : d, m = i ? d : f;
  return u || h ? ne.jsx(Tq, { x: I, y: m, parentUuid: e, parentWidth: n, parentHeight: r, sourceUuid: l, children: ne.jsx(Nq, { info: { ...h, ...u } }) }) : null;
}
function eZn(t) {
  const { geneExpressionColormap: e, setGeneExpressionColormap: n, geneExpressionColormapRange: r, setGeneExpressionColormapRange: i, tooltipsVisible: o, setTooltipsVisible: s } = t, a = VI(), A = Jr();
  function l(h) {
    n(h.target.value);
  }
  function c(h) {
    s(h.target.checked);
  }
  function u(h, d) {
    i(d);
  }
  const f = Qn(Bd(u, 5, { trailing: !0 }), [u]);
  return ne.jsxs(NL, { children: [ne.jsxs(Ko, { children: [ne.jsx(br, { className: a.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `heatmap-gene-expression-colormap-${A}`, children: "Gene Expression Colormap" }) }), ne.jsx(br, { className: a.inputCell, variant: "body", children: ne.jsx(nd, { className: a.select, value: e, onChange: l, inputProps: {
    "aria-label": "Select gene expression colormap",
    id: `heatmap-gene-expression-colormap-${A}`
  }, children: ME.map((h) => ne.jsx("option", { value: h, children: h }, h)) }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: a.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `heatmap-gene-expression-colormap-tooltip-visibility-${A}`, children: "Tooltips Visible" }) }), ne.jsx(br, { className: a.inputCell, variant: "body", children: ne.jsx(ds, {
    className: a.checkbox,
    /**
     * We have to use "checked" here, not "value".
     * The checkbox state is not persisting with value.
     * For reference, https://v4.mui.com/api/checkbox/
     */
    checked: o,
    onChange: c,
    name: "heatmap-gene-expression-colormap-tooltip-visibility",
    color: "default",
    inputProps: {
      "aria-label": "Show or hide tooltips",
      id: `heatmap-gene-expression-colormap-tooltip-visibility-${A}`
    }
  }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: a.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `heatmap-gene-expression-colormap-range-${A}`, children: "Gene Expression Colormap Range" }) }), ne.jsx(br, { className: a.inputCell, variant: "body", children: ne.jsx(ps, { classes: { root: a.slider, valueLabel: a.sliderValueLabel }, value: r, onChange: f, getAriaLabel: (h) => h === 0 ? "Low value colormap range slider" : "High value colormap range slider", id: `heatmap-gene-expression-colormap-range-${A}`, valueLabelDisplay: "auto", step: 5e-3, min: 0, max: 1 }) })] })] });
}
function tZn(t) {
  const { uuid: e, coordinationScopes: n, closeButtonVisible: r, downloadButtonVisible: i, removeGridComponent: o, theme: s, transpose: a, observationsLabelOverride: A, variablesLabelOverride: l, title: c = "Heatmap" } = t, u = eu(), f = yL(), h = vL(e), [{ dataset: d, obsType: I, featureType: m, featureValueType: C, heatmapZoomX: y, heatmapTargetX: v, heatmapTargetY: b, featureSelection: Q, obsHighlight: w, featureHighlight: R, obsSetSelection: M, obsSetColor: O, additionalObsSets: L, featureValueColormap: N, featureValueColormapRange: k, tooltipsVisible: $ }, { setHeatmapZoomX: U, setHeatmapZoomY: X, setHeatmapTargetX: K, setHeatmapTargetY: z, setObsHighlight: Y, setFeatureSelection: V, setObsColorEncoding: Z, setFeatureHighlight: ce, setObsSetSelection: ee, setObsSetColor: pe, setFeatureValueColormapRange: Ce, setFeatureValueColormap: Be, setTooltipsVisible: Ie }] = uc(ea[Gn.HEATMAP], n), Qe = A || I, xe = Bf(Qe), Se = l || m, De = Bf(Se), Ue = Ci(xe), Te = Ci(De), [se, fe] = mn(!1), [W, ge] = mn("geneSelection"), [_e, Re, Ee] = QL(), [oe, ie] = eAe(n, I, u, d), [{ featureLabelsMap: Ae }, de, we] = DL(u, d, !1, {}, {}, { featureType: m }), [{ obsIndex: Pe, featureIndex: qe, obsFeatureMatrix: ke }, Xe, rt] = k8e(u, d, !0, {}, {}, { obsType: I, featureType: m, featureValueType: C }), [{ obsSets: it, obsSetsMembership: ht }, mt, _t] = VB(u, d, !1, { setObsSetSelection: ee, setObsSetColor: pe }, { obsSetSelection: M, obsSetColor: O }, { obsType: I }), Ct = Jc([
    de,
    Xe,
    mt
  ]), zt = Qd([
    we,
    rt,
    _t
  ]), [jt, lt] = wkt({ obsFeatureMatrix: ke }), Ht = dt(() => RI(it, L), [it, L]), vt = dt(() => ML({
    cellSets: Ht,
    cellSetSelection: M,
    cellSetColor: O,
    obsIndex: Pe,
    theme: s
  }), [
    Ht,
    s,
    O,
    M,
    Pe
  ]), It = Jae(Qe, oe, ie, ht), un = xkt(ht), hn = Qn((jn) => {
    if (jn) {
      const Ot = Ae?.get(jn) || jn;
      return { [`${Ci(Se)} ID`]: Ot };
    }
    return null;
  }, [Se, Ae]), We = Pe ? Pe.length : 0, En = qe ? qe.length : 0, qn = Qn(() => {
  }, []), Pt = () => {
    if (W === "geneSelection" && R)
      V([R]), Z("geneSelection");
    else if (W === "cellSelection" && M) {
      const jn = un(w);
      if (jn?.length > 0) {
        const Ot = AUt(jn, M);
        Ot && (ee([Ot]), Z("cellSelection"));
      }
    }
  }, dr = dt(() => [
    `${Ci(Qe)} Set`
  ], [Qe]), yr = vt.size;
  return ne.jsxs(fc, { title: c, info: `${fI(We)} ${Bf(Qe, We)} × ${fI(En)} ${Bf(Se, En)},
             with ${fI(yr)} ${Bf(Qe, yr)} selected`, urls: zt, theme: s, closeButtonVisible: r, downloadButtonVisible: i, removeGridComponent: o, isReady: Ct && !se, options: ne.jsx(eZn, { geneExpressionColormap: N, setGeneExpressionColormap: Be, geneExpressionColormapRange: k, setGeneExpressionColormapRange: Ce, tooltipsVisible: $, setTooltipsVisible: Ie }), children: [ne.jsx(XXn, { ref: Ee, transpose: a, viewState: { zoom: y, target: [v, b] }, setViewState: ({ zoom: jn, target: Ot }) => {
    U(jn), X(jn), K(Ot[0]), z(Ot[1]);
  }, colormapRange: k, setColormapRange: Ce, height: Re, width: _e, theme: s, uuid: e, uint8ObsFeatureMatrix: jt?.data, cellColors: vt, colormap: N, setIsRendering: fe, setCellHighlight: Y, setGeneHighlight: ce, featureLabelsMap: Ae, obsIndex: Pe, featureIndex: qe, setTrackHighlight: qn, setComponentHover: () => {
    f(e);
  }, updateViewInfo: h, observationsTitle: Ue, variablesTitle: Te, variablesDashes: !1, observationsDashes: !1, cellColorLabels: dr, useDevicePixels: !0, onHeatmapClick: Pt, setColorEncoding: ge }), $ && ne.jsx(ZXn, { parentUuid: e, width: _e, height: Re, transpose: a, getObsInfo: It, getFeatureInfo: hn, obsHighlight: w, featureHighlight: R }), ne.jsx(nS, { visible: !0, theme: s, featureType: m, featureValueType: C, obsColorEncoding: "geneExpression", considerSelections: !1, featureSelection: Q, featureValueColormap: N, featureValueColormapRange: k, extent: lt })] });
}
var tXe = {}, nXe = { exports: {} };
(function(t) {
  function e(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(nXe);
var pl = nXe.exports, EK = {}, yK = { exports: {} }, vK = { exports: {} }, jTe;
function rXe() {
  return jTe || (jTe = 1, function(t) {
    function e(n) {
      "@babel/helpers - typeof";
      return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e(n);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(vK)), vK.exports;
}
var YTe;
function im() {
  return YTe || (YTe = 1, function(t) {
    var e = rXe().default;
    function n(i) {
      if (typeof WeakMap != "function")
        return null;
      var o = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap();
      return (n = function(A) {
        return A ? s : o;
      })(i);
    }
    function r(i, o) {
      if (!o && i && i.__esModule)
        return i;
      if (i === null || e(i) !== "object" && typeof i != "function")
        return {
          default: i
        };
      var s = n(o);
      if (s && s.has(i))
        return s.get(i);
      var a = {}, A = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var l in i)
        if (l !== "default" && Object.prototype.hasOwnProperty.call(i, l)) {
          var c = A ? Object.getOwnPropertyDescriptor(i, l) : null;
          c && (c.get || c.set) ? Object.defineProperty(a, l, c) : a[l] = i[l];
        }
      return a.default = i, s && s.set(i, a), a;
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(yK)), yK.exports;
}
var BK = { exports: {} }, zTe;
function lx() {
  return zTe || (zTe = 1, function(t) {
    function e(n, r) {
      if (!(n instanceof r))
        throw new TypeError("Cannot call a class as a function");
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(BK)), BK.exports;
}
var bK = { exports: {} }, VTe;
function eO() {
  return VTe || (VTe = 1, function(t) {
    function e(r, i) {
      for (var o = 0; o < i.length; o++) {
        var s = i[o];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(r, s.key, s);
      }
    }
    function n(r, i, o) {
      return i && e(r.prototype, i), o && e(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(bK)), bK.exports;
}
var _K = { exports: {} }, SK = { exports: {} }, JTe;
function Zq() {
  return JTe || (JTe = 1, function(t) {
    function e(n) {
      if (n === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return n;
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(SK)), SK.exports;
}
var KTe;
function ej() {
  return KTe || (KTe = 1, function(t) {
    var e = rXe().default, n = Zq();
    function r(i, o) {
      if (o && (e(o) === "object" || typeof o == "function"))
        return o;
      if (o !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return n(i);
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(_K)), _K.exports;
}
var QK = { exports: {} }, WTe;
function tj() {
  return WTe || (WTe = 1, function(t) {
    function e(n) {
      return t.exports = e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
        return i.__proto__ || Object.getPrototypeOf(i);
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e(n);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(QK)), QK.exports;
}
var wK = { exports: {} }, xK = { exports: {} }, XTe;
function nZn() {
  return XTe || (XTe = 1, function(t) {
    function e(n, r) {
      return t.exports = e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, s) {
        return o.__proto__ = s, o;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e(n, r);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(xK)), xK.exports;
}
var ZTe;
function nj() {
  return ZTe || (ZTe = 1, function(t) {
    var e = nZn();
    function n(r, i) {
      if (typeof i != "function" && i !== null)
        throw new TypeError("Super expression must either be null or a function");
      r.prototype = Object.create(i && i.prototype, {
        constructor: {
          value: r,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(r, "prototype", {
        writable: !1
      }), i && e(r, i);
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(wK)), wK.exports;
}
var RK = { exports: {} }, eNe;
function cx() {
  return eNe || (eNe = 1, function(t) {
    function e(n, r, i) {
      return r in n ? Object.defineProperty(n, r, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[r] = i, n;
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(RK)), RK.exports;
}
var DK = {}, tNe;
function rZn() {
  return tNe || (tNe = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = e;
    function e(n, r) {
      var i;
      typeof r < "u" ? i = r : typeof window < "u" ? i = window : typeof self < "u" ? i = self : i = ei;
      var o = typeof i.document < "u" && i.document.attachEvent;
      if (!o) {
        var s = function() {
          var O = i.requestAnimationFrame || i.mozRequestAnimationFrame || i.webkitRequestAnimationFrame || function(L) {
            return i.setTimeout(L, 20);
          };
          return function(L) {
            return O(L);
          };
        }(), a = function() {
          var O = i.cancelAnimationFrame || i.mozCancelAnimationFrame || i.webkitCancelAnimationFrame || i.clearTimeout;
          return function(L) {
            return O(L);
          };
        }(), A = function(L) {
          var N = L.__resizeTriggers__, k = N.firstElementChild, $ = N.lastElementChild, U = k.firstElementChild;
          $.scrollLeft = $.scrollWidth, $.scrollTop = $.scrollHeight, U.style.width = k.offsetWidth + 1 + "px", U.style.height = k.offsetHeight + 1 + "px", k.scrollLeft = k.scrollWidth, k.scrollTop = k.scrollHeight;
        }, l = function(L) {
          return L.offsetWidth != L.__resizeLast__.width || L.offsetHeight != L.__resizeLast__.height;
        }, c = function(L) {
          if (!(L.target.className && typeof L.target.className.indexOf == "function" && L.target.className.indexOf("contract-trigger") < 0 && L.target.className.indexOf("expand-trigger") < 0)) {
            var N = this;
            A(this), this.__resizeRAF__ && a(this.__resizeRAF__), this.__resizeRAF__ = s(function() {
              l(N) && (N.__resizeLast__.width = N.offsetWidth, N.__resizeLast__.height = N.offsetHeight, N.__resizeListeners__.forEach(function(k) {
                k.call(N, L);
              }));
            });
          }
        }, u = !1, f = "", h = "animationstart", d = "Webkit Moz O ms".split(" "), I = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "), m = "";
        {
          var C = i.document.createElement("fakeelement");
          if (C.style.animationName !== void 0 && (u = !0), u === !1) {
            for (var y = 0; y < d.length; y++)
              if (C.style[d[y] + "AnimationName"] !== void 0) {
                m = d[y], f = "-" + m.toLowerCase() + "-", h = I[y], u = !0;
                break;
              }
          }
        }
        var v = "resizeanim", b = "@" + f + "keyframes " + v + " { from { opacity: 0; } to { opacity: 0; } } ", Q = f + "animation: 1ms " + v + "; ";
      }
      var w = function(L) {
        if (!L.getElementById("detectElementResize")) {
          var N = (b || "") + ".resize-triggers { " + (Q || "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', k = L.head || L.getElementsByTagName("head")[0], $ = L.createElement("style");
          $.id = "detectElementResize", $.type = "text/css", n != null && $.setAttribute("nonce", n), $.styleSheet ? $.styleSheet.cssText = N : $.appendChild(L.createTextNode(N)), k.appendChild($);
        }
      }, R = function(L, N) {
        if (o)
          L.attachEvent("onresize", N);
        else {
          if (!L.__resizeTriggers__) {
            var k = L.ownerDocument, $ = i.getComputedStyle(L);
            $ && $.position == "static" && (L.style.position = "relative"), w(k), L.__resizeLast__ = {}, L.__resizeListeners__ = [], (L.__resizeTriggers__ = k.createElement("div")).className = "resize-triggers";
            var U = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
            if (window.trustedTypes) {
              var X = trustedTypes.createPolicy("react-virtualized-auto-sizer", {
                createHTML: function() {
                  return U;
                }
              });
              L.__resizeTriggers__.innerHTML = X.createHTML("");
            } else
              L.__resizeTriggers__.innerHTML = U;
            L.appendChild(L.__resizeTriggers__), A(L), L.addEventListener("scroll", c, !0), h && (L.__resizeTriggers__.__animationListener__ = function(z) {
              z.animationName == v && A(L);
            }, L.__resizeTriggers__.addEventListener(h, L.__resizeTriggers__.__animationListener__));
          }
          L.__resizeListeners__.push(N);
        }
      }, M = function(L, N) {
        if (o)
          L.detachEvent("onresize", N);
        else if (L.__resizeListeners__.splice(L.__resizeListeners__.indexOf(N), 1), !L.__resizeListeners__.length) {
          L.removeEventListener("scroll", c, !0), L.__resizeTriggers__.__animationListener__ && (L.__resizeTriggers__.removeEventListener(h, L.__resizeTriggers__.__animationListener__), L.__resizeTriggers__.__animationListener__ = null);
          try {
            L.__resizeTriggers__ = !L.removeChild(L.__resizeTriggers__);
          } catch {
          }
        }
      };
      return {
        addResizeListener: R,
        removeResizeListener: M
      };
    }
  }(DK)), DK;
}
var nNe;
function iZn() {
  return nNe || (nNe = 1, function(t) {
    var e = pl, n = im();
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = e(lx()), i = e(eO()), o = e(ej()), s = e(tj()), a = e(Zq()), A = e(nj()), l = e(cx()), c = n(St), u = e(rZn());
    e(Ja);
    var f, h;
    function d(C, y) {
      var v = Object.keys(C);
      if (Object.getOwnPropertySymbols) {
        var b = Object.getOwnPropertySymbols(C);
        y && (b = b.filter(function(Q) {
          return Object.getOwnPropertyDescriptor(C, Q).enumerable;
        })), v.push.apply(v, b);
      }
      return v;
    }
    function I(C) {
      for (var y = 1; y < arguments.length; y++) {
        var v = arguments[y] != null ? arguments[y] : {};
        y % 2 ? d(v, !0).forEach(function(b) {
          (0, l.default)(C, b, v[b]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(C, Object.getOwnPropertyDescriptors(v)) : d(v).forEach(function(b) {
          Object.defineProperty(C, b, Object.getOwnPropertyDescriptor(v, b));
        });
      }
      return C;
    }
    var m = (h = f = /* @__PURE__ */ function(C) {
      (0, A.default)(y, C);
      function y() {
        var v, b;
        (0, r.default)(this, y);
        for (var Q = arguments.length, w = new Array(Q), R = 0; R < Q; R++)
          w[R] = arguments[R];
        return b = (0, o.default)(this, (v = (0, s.default)(y)).call.apply(v, [this].concat(w))), (0, l.default)((0, a.default)(b), "state", {
          height: b.props.defaultHeight || 0,
          width: b.props.defaultWidth || 0
        }), (0, l.default)((0, a.default)(b), "_parentNode", void 0), (0, l.default)((0, a.default)(b), "_autoSizer", void 0), (0, l.default)((0, a.default)(b), "_window", void 0), (0, l.default)((0, a.default)(b), "_detectElementResize", void 0), (0, l.default)((0, a.default)(b), "_onResize", function() {
          var M = b.props, O = M.disableHeight, L = M.disableWidth, N = M.onResize;
          if (b._parentNode) {
            var k = b._parentNode.offsetHeight || 0, $ = b._parentNode.offsetWidth || 0, U = b._window || window, X = U.getComputedStyle(b._parentNode) || {}, K = parseInt(X.paddingLeft, 10) || 0, z = parseInt(X.paddingRight, 10) || 0, Y = parseInt(X.paddingTop, 10) || 0, V = parseInt(X.paddingBottom, 10) || 0, Z = k - Y - V, ce = $ - K - z;
            (!O && b.state.height !== Z || !L && b.state.width !== ce) && (b.setState({
              height: k - Y - V,
              width: $ - K - z
            }), N({
              height: k,
              width: $
            }));
          }
        }), (0, l.default)((0, a.default)(b), "_setRef", function(M) {
          b._autoSizer = M;
        }), b;
      }
      return (0, i.default)(y, [{
        key: "componentDidMount",
        value: function() {
          var b = this.props.nonce;
          this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement && (this._parentNode = this._autoSizer.parentNode, this._window = this._autoSizer.parentNode.ownerDocument.defaultView, this._detectElementResize = (0, u.default)(b, this._window), this._detectElementResize.addResizeListener(this._parentNode, this._onResize), this._onResize());
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this._detectElementResize && this._parentNode && this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
        }
      }, {
        key: "render",
        value: function() {
          var b = this.props, Q = b.children, w = b.className, R = b.disableHeight, M = b.disableWidth, O = b.style, L = this.state, N = L.height, k = L.width, $ = {
            overflow: "visible"
          }, U = {};
          return R || ($.height = 0, U.height = N), M || ($.width = 0, U.width = k), c.createElement("div", {
            className: w,
            ref: this._setRef,
            style: I({}, $, {}, O)
          }, Q(U));
        }
      }]), y;
    }(c.Component), (0, l.default)(f, "propTypes", null), h);
    t.default = m, (0, l.default)(m, "defaultProps", {
      onResize: function() {
      },
      disableHeight: !1,
      disableWidth: !1,
      style: {}
    });
  }(EK)), EK;
}
(function(t) {
  var e = pl;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "default", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(t, "AutoSizer", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  });
  var n = e(iZn());
})(tXe);
var iXe = {}, TK = {}, rNe;
function oZn() {
  return rNe || (rNe = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = e;
    function e(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.defaultSortBy, o = r.defaultSortDirection, s = o === void 0 ? {} : o;
      if (!n)
        throw Error('Required parameter "sortCallback" not specified');
      var a = i || [], A = {};
      a.forEach(function(c) {
        A[c] = s[c] !== void 0 ? s[c] : "ASC";
      });
      function l(c) {
        var u = c.defaultSortDirection, f = c.event, h = c.sortBy;
        if (f.shiftKey)
          A[h] !== void 0 ? A[h] = A[h] === "ASC" ? "DESC" : "ASC" : (A[h] = u, a.push(h));
        else if (f.ctrlKey || f.metaKey) {
          var d = a.indexOf(h);
          d >= 0 && (a.splice(d, 1), delete A[h]);
        } else {
          a.length = 0, a.push(h);
          var I = Object.keys(A);
          I.forEach(function(m) {
            m !== h && delete A[m];
          }), A[h] !== void 0 ? A[h] = A[h] === "ASC" ? "DESC" : "ASC" : A[h] = u;
        }
        n({
          sortBy: a,
          sortDirection: A
        });
      }
      return {
        sort: l,
        sortBy: a,
        sortDirection: A
      };
    }
  }(TK)), TK;
}
var NK = {}, ff = {}, iNe;
function tO() {
  if (iNe)
    return ff;
  iNe = 1;
  var t = pl;
  Object.defineProperty(ff, "__esModule", {
    value: !0
  }), ff.bpfrpt_proptype_RowRendererParams = ff.bpfrpt_proptype_HeaderRendererParams = ff.bpfrpt_proptype_HeaderRowRendererParams = ff.bpfrpt_proptype_CellRendererParams = ff.bpfrpt_proptype_CellDataGetterParams = void 0, t(Ja);
  var e = null;
  ff.bpfrpt_proptype_CellDataGetterParams = e;
  var n = null;
  ff.bpfrpt_proptype_CellRendererParams = n;
  var r = null;
  ff.bpfrpt_proptype_HeaderRowRendererParams = r;
  var i = null;
  ff.bpfrpt_proptype_HeaderRendererParams = i;
  var o = null;
  return ff.bpfrpt_proptype_RowRendererParams = o, ff;
}
var oNe;
function oXe() {
  return oNe || (oNe = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = e, tO();
    function e(n) {
      var r = n.dataKey, i = n.rowData;
      return typeof i.get == "function" ? i.get(r) : i[r];
    }
  }(NK)), NK;
}
var LK = {}, sNe;
function sXe() {
  return sNe || (sNe = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = e, tO();
    function e(n) {
      var r = n.cellData;
      return r == null ? "" : String(r);
    }
  }(LK)), LK;
}
var MK = {}, aNe;
function aXe() {
  return aNe || (aNe = 1, function(t) {
    var e = pl, n = im();
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = n(St);
    tO(), e(Ja);
    function i(o) {
      var s = o.className, a = o.columns, A = o.style;
      return r.createElement("div", {
        className: s,
        role: "row",
        style: A
      }, a);
    }
    i.propTypes = null;
  }(MK)), MK;
}
var OK = {}, FK = {}, PK = {}, ANe;
function rj() {
  return ANe || (ANe = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = {
      /**
       * Sort items in ascending order.
       * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
       */
      ASC: "ASC",
      /**
       * Sort items in descending order.
       * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
       */
      DESC: "DESC"
    }, n = e;
    t.default = n;
  }(PK)), PK;
}
var lNe;
function AXe() {
  return lNe || (lNe = 1, function(t) {
    var e = im(), n = pl;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var r = n(jB);
    n(Ja);
    var i = e(St), o = n(rj());
    function s(a) {
      var A = a.sortDirection, l = (0, r.default)("ReactVirtualized__Table__sortableHeaderIcon", {
        "ReactVirtualized__Table__sortableHeaderIcon--ASC": A === o.default.ASC,
        "ReactVirtualized__Table__sortableHeaderIcon--DESC": A === o.default.DESC
      });
      return i.createElement("svg", {
        className: l,
        width: 18,
        height: 18,
        viewBox: "0 0 24 24"
      }, A === o.default.ASC ? i.createElement("path", {
        d: "M7 14l5-5 5 5z"
      }) : i.createElement("path", {
        d: "M7 10l5 5 5-5z"
      }), i.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }));
    }
    s.propTypes = {};
  }(FK)), FK;
}
var cNe;
function lXe() {
  return cNe || (cNe = 1, function(t) {
    var e = pl, n = im();
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(St), i = e(AXe());
    tO(), e(Ja);
    function o(s) {
      var a = s.dataKey, A = s.label, l = s.sortBy, c = s.sortDirection, u = l === a, f = [r.createElement("span", {
        className: "ReactVirtualized__Table__headerTruncatedText",
        key: "label",
        title: typeof A == "string" ? A : null
      }, A)];
      return u && f.push(r.createElement(i.default, {
        key: "SortIndicator",
        sortDirection: c
      })), f;
    }
    o.propTypes = null;
  }(OK)), OK;
}
var kK = {}, GK = { exports: {} }, uNe;
function tge() {
  return uNe || (uNe = 1, function(t) {
    function e() {
      return t.exports = e = Object.assign ? Object.assign.bind() : function(n) {
        for (var r = 1; r < arguments.length; r++) {
          var i = arguments[r];
          for (var o in i)
            Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
        }
        return n;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e.apply(this, arguments);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(GK)), GK.exports;
}
var fNe;
function cXe() {
  return fNe || (fNe = 1, function(t) {
    var e = im(), n = pl;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(tge()), i = e(St);
    tO(), n(Ja);
    function o(s) {
      var a = s.className, A = s.columns, l = s.index, c = s.key, u = s.onRowClick, f = s.onRowDoubleClick, h = s.onRowMouseOut, d = s.onRowMouseOver, I = s.onRowRightClick, m = s.rowData, C = s.style, y = {
        "aria-rowindex": l + 1
      };
      return (u || f || h || d || I) && (y["aria-label"] = "row", y.tabIndex = 0, u && (y.onClick = function(v) {
        return u({
          event: v,
          index: l,
          rowData: m
        });
      }), f && (y.onDoubleClick = function(v) {
        return f({
          event: v,
          index: l,
          rowData: m
        });
      }), h && (y.onMouseOut = function(v) {
        return h({
          event: v,
          index: l,
          rowData: m
        });
      }), d && (y.onMouseOver = function(v) {
        return d({
          event: v,
          index: l,
          rowData: m
        });
      }), I && (y.onContextMenu = function(v) {
        return I({
          event: v,
          index: l,
          rowData: m
        });
      })), i.createElement("div", (0, r.default)({}, y, {
        className: a,
        key: c,
        role: "row",
        style: C
      }), A);
    }
    o.propTypes = null;
  }(kK)), kK;
}
var UK = {}, gNe;
function uXe() {
  return gNe || (gNe = 1, function(t) {
    var e = im(), n = pl;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(lx()), i = n(ej()), o = n(tj()), s = n(nj()), a = n(cx());
    n(Ja);
    var A = e(St), l = n(lXe()), c = n(sXe()), u = n(oXe()), f = n(rj()), h = /* @__PURE__ */ function(d) {
      (0, s.default)(I, d);
      function I() {
        return (0, r.default)(this, I), (0, i.default)(this, (0, o.default)(I).apply(this, arguments));
      }
      return I;
    }(A.Component);
    t.default = h, (0, a.default)(h, "defaultProps", {
      cellDataGetter: u.default,
      cellRenderer: c.default,
      defaultSortDirection: f.default.ASC,
      flexGrow: 0,
      flexShrink: 1,
      headerRenderer: l.default,
      style: {}
    }), h.propTypes = {};
  }(UK)), UK;
}
var HK = {}, $K = {}, qK = {}, jK = {}, hNe;
function sZn() {
  return hNe || (hNe = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = e;
    function e(n) {
      var r = n.cellCount, i = n.cellSize, o = n.computeMetadataCallback, s = n.computeMetadataCallbackProps, a = n.nextCellsCount, A = n.nextCellSize, l = n.nextScrollToIndex, c = n.scrollToIndex, u = n.updateScrollOffsetForScrollToIndex;
      (r !== a || (typeof i == "number" || typeof A == "number") && i !== A) && (o(s), c >= 0 && c === l && u());
    }
  }(jK)), jK;
}
var YK = {}, zK = { exports: {} }, VK = { exports: {} }, dNe;
function aZn() {
  return dNe || (dNe = 1, function(t) {
    function e(n, r) {
      if (n == null)
        return {};
      var i = {}, o = Object.keys(n), s, a;
      for (a = 0; a < o.length; a++)
        s = o[a], !(r.indexOf(s) >= 0) && (i[s] = n[s]);
      return i;
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(VK)), VK.exports;
}
var pNe;
function AZn() {
  return pNe || (pNe = 1, function(t) {
    var e = aZn();
    function n(r, i) {
      if (r == null)
        return {};
      var o = e(r, i), s, a;
      if (Object.getOwnPropertySymbols) {
        var A = Object.getOwnPropertySymbols(r);
        for (a = 0; a < A.length; a++)
          s = A[a], !(i.indexOf(s) >= 0) && Object.prototype.propertyIsEnumerable.call(r, s) && (o[s] = r[s]);
      }
      return o;
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(zK)), zK.exports;
}
var JK = {}, ci = {}, INe;
function FE() {
  if (INe)
    return ci;
  INe = 1;
  var t = pl, e = im();
  Object.defineProperty(ci, "__esModule", {
    value: !0
  }), ci.bpfrpt_proptype_VisibleCellRange = ci.bpfrpt_proptype_Alignment = ci.bpfrpt_proptype_OverscanIndicesGetter = ci.bpfrpt_proptype_OverscanIndices = ci.bpfrpt_proptype_OverscanIndicesGetterParams = ci.bpfrpt_proptype_RenderedSection = ci.bpfrpt_proptype_ScrollbarPresenceChange = ci.bpfrpt_proptype_Scroll = ci.bpfrpt_proptype_NoContentRenderer = ci.bpfrpt_proptype_CellSize = ci.bpfrpt_proptype_CellSizeGetter = ci.bpfrpt_proptype_CellRangeRenderer = ci.bpfrpt_proptype_CellRangeRendererParams = ci.bpfrpt_proptype_StyleCache = ci.bpfrpt_proptype_CellCache = ci.bpfrpt_proptype_CellRenderer = ci.bpfrpt_proptype_CellRendererParams = ci.bpfrpt_proptype_CellPosition = void 0, e(St), t(nge()), t(Ja);
  var n = null;
  ci.bpfrpt_proptype_CellPosition = n;
  var r = null;
  ci.bpfrpt_proptype_CellRendererParams = r;
  var i = null;
  ci.bpfrpt_proptype_CellRenderer = i;
  var o = null;
  ci.bpfrpt_proptype_CellCache = o;
  var s = null;
  ci.bpfrpt_proptype_StyleCache = s;
  var a = null;
  ci.bpfrpt_proptype_CellRangeRendererParams = a;
  var A = null;
  ci.bpfrpt_proptype_CellRangeRenderer = A;
  var l = null;
  ci.bpfrpt_proptype_CellSizeGetter = l;
  var c = null;
  ci.bpfrpt_proptype_CellSize = c;
  var u = null;
  ci.bpfrpt_proptype_NoContentRenderer = u;
  var f = null;
  ci.bpfrpt_proptype_Scroll = f;
  var h = null;
  ci.bpfrpt_proptype_ScrollbarPresenceChange = h;
  var d = null;
  ci.bpfrpt_proptype_RenderedSection = d;
  var I = null;
  ci.bpfrpt_proptype_OverscanIndicesGetterParams = I;
  var m = null;
  ci.bpfrpt_proptype_OverscanIndices = m;
  var C = null;
  ci.bpfrpt_proptype_OverscanIndicesGetter = C;
  var y = null;
  ci.bpfrpt_proptype_Alignment = y;
  var v = null;
  return ci.bpfrpt_proptype_VisibleCellRange = v, ci;
}
var mNe;
function lZn() {
  return mNe || (mNe = 1, function(t) {
    var e = pl;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = e(lx()), r = e(eO()), i = e(cx());
    FE();
    var o = /* @__PURE__ */ function() {
      function s(a) {
        var A = a.cellCount, l = a.cellSizeGetter, c = a.estimatedCellSize;
        (0, n.default)(this, s), (0, i.default)(this, "_cellSizeAndPositionData", {}), (0, i.default)(this, "_lastMeasuredIndex", -1), (0, i.default)(this, "_lastBatchedIndex", -1), (0, i.default)(this, "_cellCount", void 0), (0, i.default)(this, "_cellSizeGetter", void 0), (0, i.default)(this, "_estimatedCellSize", void 0), this._cellSizeGetter = l, this._cellCount = A, this._estimatedCellSize = c;
      }
      return (0, r.default)(s, [{
        key: "areOffsetsAdjusted",
        value: function() {
          return !1;
        }
      }, {
        key: "configure",
        value: function(A) {
          var l = A.cellCount, c = A.estimatedCellSize, u = A.cellSizeGetter;
          this._cellCount = l, this._estimatedCellSize = c, this._cellSizeGetter = u;
        }
      }, {
        key: "getCellCount",
        value: function() {
          return this._cellCount;
        }
      }, {
        key: "getEstimatedCellSize",
        value: function() {
          return this._estimatedCellSize;
        }
      }, {
        key: "getLastMeasuredIndex",
        value: function() {
          return this._lastMeasuredIndex;
        }
      }, {
        key: "getOffsetAdjustment",
        value: function() {
          return 0;
        }
        /**
         * This method returns the size and position for the cell at the specified index.
         * It just-in-time calculates (or used cached values) for cells leading up to the index.
         */
      }, {
        key: "getSizeAndPositionOfCell",
        value: function(A) {
          if (A < 0 || A >= this._cellCount)
            throw Error("Requested index ".concat(A, " is outside of range 0..").concat(this._cellCount));
          if (A > this._lastMeasuredIndex)
            for (var l = this.getSizeAndPositionOfLastMeasuredCell(), c = l.offset + l.size, u = this._lastMeasuredIndex + 1; u <= A; u++) {
              var f = this._cellSizeGetter({
                index: u
              });
              if (f === void 0 || isNaN(f))
                throw Error("Invalid size returned for cell ".concat(u, " of value ").concat(f));
              f === null ? (this._cellSizeAndPositionData[u] = {
                offset: c,
                size: 0
              }, this._lastBatchedIndex = A) : (this._cellSizeAndPositionData[u] = {
                offset: c,
                size: f
              }, c += f, this._lastMeasuredIndex = A);
            }
          return this._cellSizeAndPositionData[A];
        }
      }, {
        key: "getSizeAndPositionOfLastMeasuredCell",
        value: function() {
          return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
            offset: 0,
            size: 0
          };
        }
        /**
         * Total size of all cells being measured.
         * This value will be completely estimated initially.
         * As cells are measured, the estimate will be updated.
         */
      }, {
        key: "getTotalSize",
        value: function() {
          var A = this.getSizeAndPositionOfLastMeasuredCell(), l = A.offset + A.size, c = this._cellCount - this._lastMeasuredIndex - 1, u = c * this._estimatedCellSize;
          return l + u;
        }
        /**
         * Determines a new offset that ensures a certain cell is visible, given the current offset.
         * If the cell is already visible then the current offset will be returned.
         * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
         *
         * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
         * @param containerSize Size (width or height) of the container viewport
         * @param currentOffset Container's current (x or y) offset
         * @param totalSize Total size (width or height) of all cells
         * @return Offset to use to ensure the specified cell is visible
         */
      }, {
        key: "getUpdatedOffsetForIndex",
        value: function(A) {
          var l = A.align, c = l === void 0 ? "auto" : l, u = A.containerSize, f = A.currentOffset, h = A.targetIndex;
          if (u <= 0)
            return 0;
          var d = this.getSizeAndPositionOfCell(h), I = d.offset, m = I - u + d.size, C;
          switch (c) {
            case "start":
              C = I;
              break;
            case "end":
              C = m;
              break;
            case "center":
              C = I - (u - d.size) / 2;
              break;
            default:
              C = Math.max(m, Math.min(I, f));
              break;
          }
          var y = this.getTotalSize();
          return Math.max(0, Math.min(y - u, C));
        }
      }, {
        key: "getVisibleCellRange",
        value: function(A) {
          var l = A.containerSize, c = A.offset, u = this.getTotalSize();
          if (u === 0)
            return {};
          var f = c + l, h = this._findNearestCell(c), d = this.getSizeAndPositionOfCell(h);
          c = d.offset + d.size;
          for (var I = h; c < f && I < this._cellCount - 1; )
            I++, c += this.getSizeAndPositionOfCell(I).size;
          return {
            start: h,
            stop: I
          };
        }
        /**
         * Clear all cached values for cells after the specified index.
         * This method should be called for any cell that has changed its size.
         * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
         */
      }, {
        key: "resetCell",
        value: function(A) {
          this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, A - 1);
        }
      }, {
        key: "_binarySearch",
        value: function(A, l, c) {
          for (; l <= A; ) {
            var u = l + Math.floor((A - l) / 2), f = this.getSizeAndPositionOfCell(u).offset;
            if (f === c)
              return u;
            f < c ? l = u + 1 : f > c && (A = u - 1);
          }
          return l > 0 ? l - 1 : 0;
        }
      }, {
        key: "_exponentialSearch",
        value: function(A, l) {
          for (var c = 1; A < this._cellCount && this.getSizeAndPositionOfCell(A).offset < l; )
            A += c, c *= 2;
          return this._binarySearch(Math.min(A, this._cellCount - 1), Math.floor(A / 2), l);
        }
        /**
         * Searches for the cell (index) nearest the specified offset.
         *
         * If no exact match is found the next lowest cell index will be returned.
         * This allows partially visible cells (with offsets just before/above the fold) to be visible.
         */
      }, {
        key: "_findNearestCell",
        value: function(A) {
          if (isNaN(A))
            throw Error("Invalid offset ".concat(A, " specified"));
          A = Math.max(0, A);
          var l = this.getSizeAndPositionOfLastMeasuredCell(), c = Math.max(0, this._lastMeasuredIndex);
          return l.offset >= A ? this._binarySearch(c, 0, A) : this._exponentialSearch(c, A);
        }
      }]), s;
    }();
    t.default = o;
  }(JK)), JK;
}
var O2 = {}, CNe;
function cZn() {
  if (CNe)
    return O2;
  CNe = 1, Object.defineProperty(O2, "__esModule", {
    value: !0
  }), O2.getMaxElementSize = void 0;
  var t = 15e5, e = 16777100, n = function() {
    return typeof window < "u";
  }, r = function() {
    return !!window.chrome;
  }, i = function() {
    return n() && r() ? e : t;
  };
  return O2.getMaxElementSize = i, O2;
}
var ENe;
function nge() {
  return ENe || (ENe = 1, function(t) {
    var e = pl;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = e(AZn()), r = e(lx()), i = e(eO()), o = e(cx()), s = e(lZn()), a = cZn();
    FE();
    var A = /* @__PURE__ */ function() {
      function l(c) {
        var u = c.maxScrollSize, f = u === void 0 ? (0, a.getMaxElementSize)() : u, h = (0, n.default)(c, ["maxScrollSize"]);
        (0, r.default)(this, l), (0, o.default)(this, "_cellSizeAndPositionManager", void 0), (0, o.default)(this, "_maxScrollSize", void 0), this._cellSizeAndPositionManager = new s.default(h), this._maxScrollSize = f;
      }
      return (0, i.default)(l, [{
        key: "areOffsetsAdjusted",
        value: function() {
          return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
        }
      }, {
        key: "configure",
        value: function(u) {
          this._cellSizeAndPositionManager.configure(u);
        }
      }, {
        key: "getCellCount",
        value: function() {
          return this._cellSizeAndPositionManager.getCellCount();
        }
      }, {
        key: "getEstimatedCellSize",
        value: function() {
          return this._cellSizeAndPositionManager.getEstimatedCellSize();
        }
      }, {
        key: "getLastMeasuredIndex",
        value: function() {
          return this._cellSizeAndPositionManager.getLastMeasuredIndex();
        }
        /**
         * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
         * The offset passed to this function is scaled (safe) as well.
         */
      }, {
        key: "getOffsetAdjustment",
        value: function(u) {
          var f = u.containerSize, h = u.offset, d = this._cellSizeAndPositionManager.getTotalSize(), I = this.getTotalSize(), m = this._getOffsetPercentage({
            containerSize: f,
            offset: h,
            totalSize: I
          });
          return Math.round(m * (I - d));
        }
      }, {
        key: "getSizeAndPositionOfCell",
        value: function(u) {
          return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(u);
        }
      }, {
        key: "getSizeAndPositionOfLastMeasuredCell",
        value: function() {
          return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
        }
        /** See CellSizeAndPositionManager#getTotalSize */
      }, {
        key: "getTotalSize",
        value: function() {
          return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
        }
        /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
      }, {
        key: "getUpdatedOffsetForIndex",
        value: function(u) {
          var f = u.align, h = f === void 0 ? "auto" : f, d = u.containerSize, I = u.currentOffset, m = u.targetIndex;
          I = this._safeOffsetToOffset({
            containerSize: d,
            offset: I
          });
          var C = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
            align: h,
            containerSize: d,
            currentOffset: I,
            targetIndex: m
          });
          return this._offsetToSafeOffset({
            containerSize: d,
            offset: C
          });
        }
        /** See CellSizeAndPositionManager#getVisibleCellRange */
      }, {
        key: "getVisibleCellRange",
        value: function(u) {
          var f = u.containerSize, h = u.offset;
          return h = this._safeOffsetToOffset({
            containerSize: f,
            offset: h
          }), this._cellSizeAndPositionManager.getVisibleCellRange({
            containerSize: f,
            offset: h
          });
        }
      }, {
        key: "resetCell",
        value: function(u) {
          this._cellSizeAndPositionManager.resetCell(u);
        }
      }, {
        key: "_getOffsetPercentage",
        value: function(u) {
          var f = u.containerSize, h = u.offset, d = u.totalSize;
          return d <= f ? 0 : h / (d - f);
        }
      }, {
        key: "_offsetToSafeOffset",
        value: function(u) {
          var f = u.containerSize, h = u.offset, d = this._cellSizeAndPositionManager.getTotalSize(), I = this.getTotalSize();
          if (d === I)
            return h;
          var m = this._getOffsetPercentage({
            containerSize: f,
            offset: h,
            totalSize: d
          });
          return Math.round(m * (I - f));
        }
      }, {
        key: "_safeOffsetToOffset",
        value: function(u) {
          var f = u.containerSize, h = u.offset, d = this._cellSizeAndPositionManager.getTotalSize(), I = this.getTotalSize();
          if (d === I)
            return h;
          var m = this._getOffsetPercentage({
            containerSize: f,
            offset: h,
            totalSize: I
          });
          return Math.round(m * (d - f));
        }
      }]), l;
    }();
    t.default = A;
  }(YK)), YK;
}
var KK = {}, yNe;
function uZn() {
  return yNe || (yNe = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = e;
    function e() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, r = {};
      return function(i) {
        var o = i.callback, s = i.indices, a = Object.keys(s), A = !n || a.every(function(c) {
          var u = s[c];
          return Array.isArray(u) ? u.length > 0 : u >= 0;
        }), l = a.length !== Object.keys(r).length || a.some(function(c) {
          var u = r[c], f = s[c];
          return Array.isArray(f) ? u.join(",") !== f.join(",") : u !== f;
        });
        r = s, A && l && o(s);
      };
    }
  }(KK)), KK;
}
var WK = {}, vNe;
function fXe() {
  return vNe || (vNe = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o, t.SCROLL_DIRECTION_VERTICAL = t.SCROLL_DIRECTION_HORIZONTAL = t.SCROLL_DIRECTION_FORWARD = t.SCROLL_DIRECTION_BACKWARD = void 0, FE();
    var e = -1;
    t.SCROLL_DIRECTION_BACKWARD = e;
    var n = 1;
    t.SCROLL_DIRECTION_FORWARD = n;
    var r = "horizontal";
    t.SCROLL_DIRECTION_HORIZONTAL = r;
    var i = "vertical";
    t.SCROLL_DIRECTION_VERTICAL = i;
    function o(s) {
      var a = s.cellCount, A = s.overscanCellsCount, l = s.scrollDirection, c = s.startIndex, u = s.stopIndex;
      return l === n ? {
        overscanStartIndex: Math.max(0, c),
        overscanStopIndex: Math.min(a - 1, u + A)
      } : {
        overscanStartIndex: Math.max(0, c - A),
        overscanStopIndex: Math.min(a - 1, u)
      };
    }
  }(WK)), WK;
}
var XK = {}, BNe;
function fZn() {
  return BNe || (BNe = 1, function(t) {
    var e = pl;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n, e(nge()), FE();
    function n(r) {
      var i = r.cellSize, o = r.cellSizeAndPositionManager, s = r.previousCellsCount, a = r.previousCellSize, A = r.previousScrollToAlignment, l = r.previousScrollToIndex, c = r.previousSize, u = r.scrollOffset, f = r.scrollToAlignment, h = r.scrollToIndex, d = r.size, I = r.sizeJustIncreasedFromZero, m = r.updateScrollIndexCallback, C = o.getCellCount(), y = h >= 0 && h < C, v = d !== c || I || !a || typeof i == "number" && i !== a;
      y && (v || f !== A || h !== l) ? m(h) : !y && C > 0 && (d < c || C < s) && u > o.getTotalSize() - d && m(C - 1);
    }
  }(XK)), XK;
}
var ZK = {}, bNe;
function gXe() {
  return bNe || (bNe = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = e, FE();
    function e(n) {
      for (var r = n.cellCache, i = n.cellRenderer, o = n.columnSizeAndPositionManager, s = n.columnStartIndex, a = n.columnStopIndex, A = n.deferredMeasurementCache, l = n.horizontalOffsetAdjustment, c = n.isScrolling, u = n.isScrollingOptOut, f = n.parent, h = n.rowSizeAndPositionManager, d = n.rowStartIndex, I = n.rowStopIndex, m = n.styleCache, C = n.verticalOffsetAdjustment, y = n.visibleColumnIndices, v = n.visibleRowIndices, b = [], Q = o.areOffsetsAdjusted() || h.areOffsetsAdjusted(), w = !c && !Q, R = d; R <= I; R++)
        for (var M = h.getSizeAndPositionOfCell(R), O = s; O <= a; O++) {
          var L = o.getSizeAndPositionOfCell(O), N = O >= y.start && O <= y.stop && R >= v.start && R <= v.stop, k = "".concat(R, "-").concat(O), $ = void 0;
          w && m[k] ? $ = m[k] : A && !A.has(R, O) ? $ = {
            height: "auto",
            left: 0,
            position: "absolute",
            top: 0,
            width: "auto"
          } : ($ = {
            height: M.size,
            left: L.offset + l,
            position: "absolute",
            top: M.offset + C,
            width: L.size
          }, m[k] = $);
          var U = {
            columnIndex: O,
            isScrolling: c,
            isVisible: N,
            key: k,
            parent: f,
            rowIndex: R,
            style: $
          }, X = void 0;
          (u || c) && !l && !C ? (r[k] || (r[k] = i(U)), X = r[k]) : X = i(U), !(X == null || X === !1) && b.push(X);
        }
      return b;
    }
  }(ZK)), ZK;
}
const gZn = !!(typeof window < "u" && window.document && window.document.createElement);
var l3;
function hZn(t) {
  if ((!l3 && l3 !== 0 || t) && gZn) {
    var e = document.createElement("div");
    e.style.position = "absolute", e.style.top = "-9999px", e.style.width = "50px", e.style.height = "50px", e.style.overflow = "scroll", document.body.appendChild(e), l3 = e.offsetWidth - e.clientWidth, document.body.removeChild(e);
  }
  return l3;
}
const dZn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hZn
}, Symbol.toStringTag, { value: "Module" })), pZn = /* @__PURE__ */ Fs(dZn), IZn = /* @__PURE__ */ Fs(p6t);
var F0 = {}, by = {}, _Ne;
function mZn() {
  if (_Ne)
    return by;
  _Ne = 1, Object.defineProperty(by, "__esModule", {
    value: !0
  }), by.caf = by.raf = void 0;
  var t;
  typeof window < "u" ? t = window : typeof self < "u" ? t = self : t = {};
  var e = t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.oRequestAnimationFrame || t.msRequestAnimationFrame || function(o) {
    return t.setTimeout(o, 1e3 / 60);
  }, n = t.cancelAnimationFrame || t.webkitCancelAnimationFrame || t.mozCancelAnimationFrame || t.oCancelAnimationFrame || t.msCancelAnimationFrame || function(o) {
    t.clearTimeout(o);
  }, r = e;
  by.raf = r;
  var i = n;
  return by.caf = i, by;
}
var SNe;
function CZn() {
  if (SNe)
    return F0;
  SNe = 1;
  var t = pl;
  Object.defineProperty(F0, "__esModule", {
    value: !0
  }), F0.bpfrpt_proptype_AnimationTimeoutId = F0.requestAnimationTimeout = F0.cancelAnimationTimeout = void 0;
  var e = mZn();
  t(Ja);
  var n = null;
  F0.bpfrpt_proptype_AnimationTimeoutId = n;
  var r = function(s) {
    return (0, e.caf)(s.id);
  };
  F0.cancelAnimationTimeout = r;
  var i = function(s, a) {
    var A;
    Promise.resolve().then(function() {
      A = Date.now();
    });
    var l = function u() {
      Date.now() - A >= a ? s.call() : c.id = (0, e.raf)(u);
    }, c = {
      id: (0, e.raf)(l)
    };
    return c;
  };
  return F0.requestAnimationTimeout = i, F0;
}
var QNe;
function EZn() {
  return QNe || (QNe = 1, function(t) {
    var e = pl, n = im();
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = void 0;
    var r = e(tge()), i = e(lx()), o = e(eO()), s = e(ej()), a = e(tj()), A = e(Zq()), l = e(nj()), c = e(cx()), u = n(St), f = e(jB), h = e(sZn()), d = e(nge()), I = e(uZn()), m = n(fXe()), C = e(fZn()), y = e(gXe()), v = e(pZn), b = IZn, Q = CZn();
    FE(), e(Ja);
    var w, R;
    function M(X, K) {
      var z = Object.keys(X);
      if (Object.getOwnPropertySymbols) {
        var Y = Object.getOwnPropertySymbols(X);
        K && (Y = Y.filter(function(V) {
          return Object.getOwnPropertyDescriptor(X, V).enumerable;
        })), z.push.apply(z, Y);
      }
      return z;
    }
    function O(X) {
      for (var K = 1; K < arguments.length; K++) {
        var z = arguments[K] != null ? arguments[K] : {};
        K % 2 ? M(z, !0).forEach(function(Y) {
          (0, c.default)(X, Y, z[Y]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(X, Object.getOwnPropertyDescriptors(z)) : M(z).forEach(function(Y) {
          Object.defineProperty(X, Y, Object.getOwnPropertyDescriptor(z, Y));
        });
      }
      return X;
    }
    var L = 150;
    t.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = L;
    var N = {
      OBSERVED: "observed",
      REQUESTED: "requested"
    }, k = function() {
      return null;
    }, $ = (R = w = /* @__PURE__ */ function(X) {
      (0, l.default)(K, X);
      function K(z) {
        var Y;
        (0, i.default)(this, K), Y = (0, s.default)(this, (0, a.default)(K).call(this, z)), (0, c.default)((0, A.default)(Y), "_onGridRenderedMemoizer", (0, I.default)()), (0, c.default)((0, A.default)(Y), "_onScrollMemoizer", (0, I.default)(!1)), (0, c.default)((0, A.default)(Y), "_deferredInvalidateColumnIndex", null), (0, c.default)((0, A.default)(Y), "_deferredInvalidateRowIndex", null), (0, c.default)((0, A.default)(Y), "_recomputeScrollLeftFlag", !1), (0, c.default)((0, A.default)(Y), "_recomputeScrollTopFlag", !1), (0, c.default)((0, A.default)(Y), "_horizontalScrollBarSize", 0), (0, c.default)((0, A.default)(Y), "_verticalScrollBarSize", 0), (0, c.default)((0, A.default)(Y), "_scrollbarPresenceChanged", !1), (0, c.default)((0, A.default)(Y), "_scrollingContainer", void 0), (0, c.default)((0, A.default)(Y), "_childrenToDisplay", void 0), (0, c.default)((0, A.default)(Y), "_columnStartIndex", void 0), (0, c.default)((0, A.default)(Y), "_columnStopIndex", void 0), (0, c.default)((0, A.default)(Y), "_rowStartIndex", void 0), (0, c.default)((0, A.default)(Y), "_rowStopIndex", void 0), (0, c.default)((0, A.default)(Y), "_renderedColumnStartIndex", 0), (0, c.default)((0, A.default)(Y), "_renderedColumnStopIndex", 0), (0, c.default)((0, A.default)(Y), "_renderedRowStartIndex", 0), (0, c.default)((0, A.default)(Y), "_renderedRowStopIndex", 0), (0, c.default)((0, A.default)(Y), "_initialScrollTop", void 0), (0, c.default)((0, A.default)(Y), "_initialScrollLeft", void 0), (0, c.default)((0, A.default)(Y), "_disablePointerEventsTimeoutId", void 0), (0, c.default)((0, A.default)(Y), "_styleCache", {}), (0, c.default)((0, A.default)(Y), "_cellCache", {}), (0, c.default)((0, A.default)(Y), "_debounceScrollEndedCallback", function() {
          Y._disablePointerEventsTimeoutId = null, Y.setState({
            isScrolling: !1,
            needToResetStyleCache: !1
          });
        }), (0, c.default)((0, A.default)(Y), "_invokeOnGridRenderedHelper", function() {
          var ce = Y.props.onSectionRendered;
          Y._onGridRenderedMemoizer({
            callback: ce,
            indices: {
              columnOverscanStartIndex: Y._columnStartIndex,
              columnOverscanStopIndex: Y._columnStopIndex,
              columnStartIndex: Y._renderedColumnStartIndex,
              columnStopIndex: Y._renderedColumnStopIndex,
              rowOverscanStartIndex: Y._rowStartIndex,
              rowOverscanStopIndex: Y._rowStopIndex,
              rowStartIndex: Y._renderedRowStartIndex,
              rowStopIndex: Y._renderedRowStopIndex
            }
          });
        }), (0, c.default)((0, A.default)(Y), "_setScrollingContainerRef", function(ce) {
          Y._scrollingContainer = ce;
        }), (0, c.default)((0, A.default)(Y), "_onScroll", function(ce) {
          ce.target === Y._scrollingContainer && Y.handleScrollEvent(ce.target);
        });
        var V = new d.default({
          cellCount: z.columnCount,
          cellSizeGetter: function(ee) {
            return K._wrapSizeGetter(z.columnWidth)(ee);
          },
          estimatedCellSize: K._getEstimatedColumnSize(z)
        }), Z = new d.default({
          cellCount: z.rowCount,
          cellSizeGetter: function(ee) {
            return K._wrapSizeGetter(z.rowHeight)(ee);
          },
          estimatedCellSize: K._getEstimatedRowSize(z)
        });
        return Y.state = {
          instanceProps: {
            columnSizeAndPositionManager: V,
            rowSizeAndPositionManager: Z,
            prevColumnWidth: z.columnWidth,
            prevRowHeight: z.rowHeight,
            prevColumnCount: z.columnCount,
            prevRowCount: z.rowCount,
            prevIsScrolling: z.isScrolling === !0,
            prevScrollToColumn: z.scrollToColumn,
            prevScrollToRow: z.scrollToRow,
            scrollbarSize: 0,
            scrollbarSizeMeasured: !1
          },
          isScrolling: !1,
          scrollDirectionHorizontal: m.SCROLL_DIRECTION_FORWARD,
          scrollDirectionVertical: m.SCROLL_DIRECTION_FORWARD,
          scrollLeft: 0,
          scrollTop: 0,
          scrollPositionChangeReason: null,
          needToResetStyleCache: !1
        }, z.scrollToRow > 0 && (Y._initialScrollTop = Y._getCalculatedScrollTop(z, Y.state)), z.scrollToColumn > 0 && (Y._initialScrollLeft = Y._getCalculatedScrollLeft(z, Y.state)), Y;
      }
      return (0, o.default)(K, [{
        key: "getOffsetForCell",
        value: function() {
          var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, V = Y.alignment, Z = V === void 0 ? this.props.scrollToAlignment : V, ce = Y.columnIndex, ee = ce === void 0 ? this.props.scrollToColumn : ce, pe = Y.rowIndex, Ce = pe === void 0 ? this.props.scrollToRow : pe, Be = O({}, this.props, {
            scrollToAlignment: Z,
            scrollToColumn: ee,
            scrollToRow: Ce
          });
          return {
            scrollLeft: this._getCalculatedScrollLeft(Be),
            scrollTop: this._getCalculatedScrollTop(Be)
          };
        }
        /**
         * Gets estimated total rows' height.
         */
      }, {
        key: "getTotalRowsHeight",
        value: function() {
          return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
        }
        /**
         * Gets estimated total columns' width.
         */
      }, {
        key: "getTotalColumnsWidth",
        value: function() {
          return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
        }
        /**
         * This method handles a scroll event originating from an external scroll control.
         * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
         */
      }, {
        key: "handleScrollEvent",
        value: function(Y) {
          var V = Y.scrollLeft, Z = V === void 0 ? 0 : V, ce = Y.scrollTop, ee = ce === void 0 ? 0 : ce;
          if (!(ee < 0)) {
            this._debounceScrollEnded();
            var pe = this.props, Ce = pe.autoHeight, Be = pe.autoWidth, Ie = pe.height, Qe = pe.width, xe = this.state.instanceProps, Se = xe.scrollbarSize, De = xe.rowSizeAndPositionManager.getTotalSize(), Ue = xe.columnSizeAndPositionManager.getTotalSize(), Te = Math.min(Math.max(0, Ue - Qe + Se), Z), se = Math.min(Math.max(0, De - Ie + Se), ee);
            if (this.state.scrollLeft !== Te || this.state.scrollTop !== se) {
              var fe = Te !== this.state.scrollLeft ? Te > this.state.scrollLeft ? m.SCROLL_DIRECTION_FORWARD : m.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal, W = se !== this.state.scrollTop ? se > this.state.scrollTop ? m.SCROLL_DIRECTION_FORWARD : m.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical, ge = {
                isScrolling: !0,
                scrollDirectionHorizontal: fe,
                scrollDirectionVertical: W,
                scrollPositionChangeReason: N.OBSERVED
              };
              Ce || (ge.scrollTop = se), Be || (ge.scrollLeft = Te), ge.needToResetStyleCache = !1, this.setState(ge);
            }
            this._invokeOnScrollMemoizer({
              scrollLeft: Te,
              scrollTop: se,
              totalColumnsWidth: Ue,
              totalRowsHeight: De
            });
          }
        }
        /**
         * Invalidate Grid size and recompute visible cells.
         * This is a deferred wrapper for recomputeGridSize().
         * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
         * This method is intended for advanced use-cases like CellMeasurer.
         */
        // @TODO (bvaughn) Add automated test coverage for this.
      }, {
        key: "invalidateCellSizeAfterRender",
        value: function(Y) {
          var V = Y.columnIndex, Z = Y.rowIndex;
          this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex == "number" ? Math.min(this._deferredInvalidateColumnIndex, V) : V, this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex == "number" ? Math.min(this._deferredInvalidateRowIndex, Z) : Z;
        }
        /**
         * Pre-measure all columns and rows in a Grid.
         * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
         * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
         */
      }, {
        key: "measureAllCells",
        value: function() {
          var Y = this.props, V = Y.columnCount, Z = Y.rowCount, ce = this.state.instanceProps;
          ce.columnSizeAndPositionManager.getSizeAndPositionOfCell(V - 1), ce.rowSizeAndPositionManager.getSizeAndPositionOfCell(Z - 1);
        }
        /**
         * Forced recompute of row heights and column widths.
         * This function should be called if dynamic column or row sizes have changed but nothing else has.
         * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
         */
      }, {
        key: "recomputeGridSize",
        value: function() {
          var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, V = Y.columnIndex, Z = V === void 0 ? 0 : V, ce = Y.rowIndex, ee = ce === void 0 ? 0 : ce, pe = this.props, Ce = pe.scrollToColumn, Be = pe.scrollToRow, Ie = this.state.instanceProps;
          Ie.columnSizeAndPositionManager.resetCell(Z), Ie.rowSizeAndPositionManager.resetCell(ee), this._recomputeScrollLeftFlag = Ce >= 0 && (this.state.scrollDirectionHorizontal === m.SCROLL_DIRECTION_FORWARD ? Z <= Ce : Z >= Ce), this._recomputeScrollTopFlag = Be >= 0 && (this.state.scrollDirectionVertical === m.SCROLL_DIRECTION_FORWARD ? ee <= Be : ee >= Be), this._styleCache = {}, this._cellCache = {}, this.forceUpdate();
        }
        /**
         * Ensure column and row are visible.
         */
      }, {
        key: "scrollToCell",
        value: function(Y) {
          var V = Y.columnIndex, Z = Y.rowIndex, ce = this.props.columnCount, ee = this.props;
          ce > 1 && V !== void 0 && this._updateScrollLeftForScrollToColumn(O({}, ee, {
            scrollToColumn: V
          })), Z !== void 0 && this._updateScrollTopForScrollToRow(O({}, ee, {
            scrollToRow: Z
          }));
        }
      }, {
        key: "componentDidMount",
        value: function() {
          var Y = this.props, V = Y.getScrollbarSize, Z = Y.height, ce = Y.scrollLeft, ee = Y.scrollToColumn, pe = Y.scrollTop, Ce = Y.scrollToRow, Be = Y.width, Ie = this.state.instanceProps;
          if (this._initialScrollTop = 0, this._initialScrollLeft = 0, this._handleInvalidatedGridSize(), Ie.scrollbarSizeMeasured || this.setState(function(Se) {
            var De = O({}, Se, {
              needToResetStyleCache: !1
            });
            return De.instanceProps.scrollbarSize = V(), De.instanceProps.scrollbarSizeMeasured = !0, De;
          }), typeof ce == "number" && ce >= 0 || typeof pe == "number" && pe >= 0) {
            var Qe = K._getScrollToPositionStateUpdate({
              prevState: this.state,
              scrollLeft: ce,
              scrollTop: pe
            });
            Qe && (Qe.needToResetStyleCache = !1, this.setState(Qe));
          }
          this._scrollingContainer && (this._scrollingContainer.scrollLeft !== this.state.scrollLeft && (this._scrollingContainer.scrollLeft = this.state.scrollLeft), this._scrollingContainer.scrollTop !== this.state.scrollTop && (this._scrollingContainer.scrollTop = this.state.scrollTop));
          var xe = Z > 0 && Be > 0;
          ee >= 0 && xe && this._updateScrollLeftForScrollToColumn(), Ce >= 0 && xe && this._updateScrollTopForScrollToRow(), this._invokeOnGridRenderedHelper(), this._invokeOnScrollMemoizer({
            scrollLeft: ce || 0,
            scrollTop: pe || 0,
            totalColumnsWidth: Ie.columnSizeAndPositionManager.getTotalSize(),
            totalRowsHeight: Ie.rowSizeAndPositionManager.getTotalSize()
          }), this._maybeCallOnScrollbarPresenceChange();
        }
        /**
         * @private
         * This method updates scrollLeft/scrollTop in state for the following conditions:
         * 1) New scroll-to-cell props have been set
         */
      }, {
        key: "componentDidUpdate",
        value: function(Y, V) {
          var Z = this, ce = this.props, ee = ce.autoHeight, pe = ce.autoWidth, Ce = ce.columnCount, Be = ce.height, Ie = ce.rowCount, Qe = ce.scrollToAlignment, xe = ce.scrollToColumn, Se = ce.scrollToRow, De = ce.width, Ue = this.state, Te = Ue.scrollLeft, se = Ue.scrollPositionChangeReason, fe = Ue.scrollTop, W = Ue.instanceProps;
          this._handleInvalidatedGridSize();
          var ge = Ce > 0 && Y.columnCount === 0 || Ie > 0 && Y.rowCount === 0;
          se === N.REQUESTED && (!pe && Te >= 0 && (Te !== this._scrollingContainer.scrollLeft || ge) && (this._scrollingContainer.scrollLeft = Te), !ee && fe >= 0 && (fe !== this._scrollingContainer.scrollTop || ge) && (this._scrollingContainer.scrollTop = fe));
          var _e = (Y.width === 0 || Y.height === 0) && Be > 0 && De > 0;
          if (this._recomputeScrollLeftFlag ? (this._recomputeScrollLeftFlag = !1, this._updateScrollLeftForScrollToColumn(this.props)) : (0, C.default)({
            cellSizeAndPositionManager: W.columnSizeAndPositionManager,
            previousCellsCount: Y.columnCount,
            previousCellSize: Y.columnWidth,
            previousScrollToAlignment: Y.scrollToAlignment,
            previousScrollToIndex: Y.scrollToColumn,
            previousSize: Y.width,
            scrollOffset: Te,
            scrollToAlignment: Qe,
            scrollToIndex: xe,
            size: De,
            sizeJustIncreasedFromZero: _e,
            updateScrollIndexCallback: function() {
              return Z._updateScrollLeftForScrollToColumn(Z.props);
            }
          }), this._recomputeScrollTopFlag ? (this._recomputeScrollTopFlag = !1, this._updateScrollTopForScrollToRow(this.props)) : (0, C.default)({
            cellSizeAndPositionManager: W.rowSizeAndPositionManager,
            previousCellsCount: Y.rowCount,
            previousCellSize: Y.rowHeight,
            previousScrollToAlignment: Y.scrollToAlignment,
            previousScrollToIndex: Y.scrollToRow,
            previousSize: Y.height,
            scrollOffset: fe,
            scrollToAlignment: Qe,
            scrollToIndex: Se,
            size: Be,
            sizeJustIncreasedFromZero: _e,
            updateScrollIndexCallback: function() {
              return Z._updateScrollTopForScrollToRow(Z.props);
            }
          }), this._invokeOnGridRenderedHelper(), Te !== V.scrollLeft || fe !== V.scrollTop) {
            var Re = W.rowSizeAndPositionManager.getTotalSize(), Ee = W.columnSizeAndPositionManager.getTotalSize();
            this._invokeOnScrollMemoizer({
              scrollLeft: Te,
              scrollTop: fe,
              totalColumnsWidth: Ee,
              totalRowsHeight: Re
            });
          }
          this._maybeCallOnScrollbarPresenceChange();
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this._disablePointerEventsTimeoutId && (0, Q.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
        }
        /**
         * This method updates scrollLeft/scrollTop in state for the following conditions:
         * 1) Empty content (0 rows or columns)
         * 2) New scroll props overriding the current state
         * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
         */
      }, {
        key: "render",
        value: function() {
          var Y = this.props, V = Y.autoContainerWidth, Z = Y.autoHeight, ce = Y.autoWidth, ee = Y.className, pe = Y.containerProps, Ce = Y.containerRole, Be = Y.containerStyle, Ie = Y.height, Qe = Y.id, xe = Y.noContentRenderer, Se = Y.role, De = Y.style, Ue = Y.tabIndex, Te = Y.width, se = this.state, fe = se.instanceProps, W = se.needToResetStyleCache, ge = this._isScrolling(), _e = {
            boxSizing: "border-box",
            direction: "ltr",
            height: Z ? "auto" : Ie,
            position: "relative",
            width: ce ? "auto" : Te,
            WebkitOverflowScrolling: "touch",
            willChange: "transform"
          };
          W && (this._styleCache = {}), this.state.isScrolling || this._resetStyleCache(), this._calculateChildrenToRender(this.props, this.state);
          var Re = fe.columnSizeAndPositionManager.getTotalSize(), Ee = fe.rowSizeAndPositionManager.getTotalSize(), oe = Ee > Ie ? fe.scrollbarSize : 0, ie = Re > Te ? fe.scrollbarSize : 0;
          (ie !== this._horizontalScrollBarSize || oe !== this._verticalScrollBarSize) && (this._horizontalScrollBarSize = ie, this._verticalScrollBarSize = oe, this._scrollbarPresenceChanged = !0), _e.overflowX = Re + oe <= Te ? "hidden" : "auto", _e.overflowY = Ee + ie <= Ie ? "hidden" : "auto";
          var Ae = this._childrenToDisplay, de = Ae.length === 0 && Ie > 0 && Te > 0;
          return u.createElement("div", (0, r.default)({
            ref: this._setScrollingContainerRef
          }, pe, {
            "aria-label": this.props["aria-label"],
            "aria-readonly": this.props["aria-readonly"],
            className: (0, f.default)("ReactVirtualized__Grid", ee),
            id: Qe,
            onScroll: this._onScroll,
            role: Se,
            style: O({}, _e, {}, De),
            tabIndex: Ue
          }), Ae.length > 0 && u.createElement("div", {
            className: "ReactVirtualized__Grid__innerScrollContainer",
            role: Ce,
            style: O({
              width: V ? "auto" : Re,
              height: Ee,
              maxWidth: Re,
              maxHeight: Ee,
              overflow: "hidden",
              pointerEvents: ge ? "none" : "",
              position: "relative"
            }, Be)
          }, Ae), de && xe());
        }
        /* ---------------------------- Helper methods ---------------------------- */
      }, {
        key: "_calculateChildrenToRender",
        value: function() {
          var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state, Z = Y.cellRenderer, ce = Y.cellRangeRenderer, ee = Y.columnCount, pe = Y.deferredMeasurementCache, Ce = Y.height, Be = Y.overscanColumnCount, Ie = Y.overscanIndicesGetter, Qe = Y.overscanRowCount, xe = Y.rowCount, Se = Y.width, De = Y.isScrollingOptOut, Ue = V.scrollDirectionHorizontal, Te = V.scrollDirectionVertical, se = V.instanceProps, fe = this._initialScrollTop > 0 ? this._initialScrollTop : V.scrollTop, W = this._initialScrollLeft > 0 ? this._initialScrollLeft : V.scrollLeft, ge = this._isScrolling(Y, V);
          if (this._childrenToDisplay = [], Ce > 0 && Se > 0) {
            var _e = se.columnSizeAndPositionManager.getVisibleCellRange({
              containerSize: Se,
              offset: W
            }), Re = se.rowSizeAndPositionManager.getVisibleCellRange({
              containerSize: Ce,
              offset: fe
            }), Ee = se.columnSizeAndPositionManager.getOffsetAdjustment({
              containerSize: Se,
              offset: W
            }), oe = se.rowSizeAndPositionManager.getOffsetAdjustment({
              containerSize: Ce,
              offset: fe
            });
            this._renderedColumnStartIndex = _e.start, this._renderedColumnStopIndex = _e.stop, this._renderedRowStartIndex = Re.start, this._renderedRowStopIndex = Re.stop;
            var ie = Ie({
              direction: "horizontal",
              cellCount: ee,
              overscanCellsCount: Be,
              scrollDirection: Ue,
              startIndex: typeof _e.start == "number" ? _e.start : 0,
              stopIndex: typeof _e.stop == "number" ? _e.stop : -1
            }), Ae = Ie({
              direction: "vertical",
              cellCount: xe,
              overscanCellsCount: Qe,
              scrollDirection: Te,
              startIndex: typeof Re.start == "number" ? Re.start : 0,
              stopIndex: typeof Re.stop == "number" ? Re.stop : -1
            }), de = ie.overscanStartIndex, we = ie.overscanStopIndex, Pe = Ae.overscanStartIndex, qe = Ae.overscanStopIndex;
            if (pe) {
              if (!pe.hasFixedHeight()) {
                for (var ke = Pe; ke <= qe; ke++)
                  if (!pe.has(ke, 0)) {
                    de = 0, we = ee - 1;
                    break;
                  }
              }
              if (!pe.hasFixedWidth()) {
                for (var Xe = de; Xe <= we; Xe++)
                  if (!pe.has(0, Xe)) {
                    Pe = 0, qe = xe - 1;
                    break;
                  }
              }
            }
            this._childrenToDisplay = ce({
              cellCache: this._cellCache,
              cellRenderer: Z,
              columnSizeAndPositionManager: se.columnSizeAndPositionManager,
              columnStartIndex: de,
              columnStopIndex: we,
              deferredMeasurementCache: pe,
              horizontalOffsetAdjustment: Ee,
              isScrolling: ge,
              isScrollingOptOut: De,
              parent: this,
              rowSizeAndPositionManager: se.rowSizeAndPositionManager,
              rowStartIndex: Pe,
              rowStopIndex: qe,
              scrollLeft: W,
              scrollTop: fe,
              styleCache: this._styleCache,
              verticalOffsetAdjustment: oe,
              visibleColumnIndices: _e,
              visibleRowIndices: Re
            }), this._columnStartIndex = de, this._columnStopIndex = we, this._rowStartIndex = Pe, this._rowStopIndex = qe;
          }
        }
        /**
         * Sets an :isScrolling flag for a small window of time.
         * This flag is used to disable pointer events on the scrollable portion of the Grid.
         * This prevents jerky/stuttery mouse-wheel scrolling.
         */
      }, {
        key: "_debounceScrollEnded",
        value: function() {
          var Y = this.props.scrollingResetTimeInterval;
          this._disablePointerEventsTimeoutId && (0, Q.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId), this._disablePointerEventsTimeoutId = (0, Q.requestAnimationTimeout)(this._debounceScrollEndedCallback, Y);
        }
      }, {
        key: "_handleInvalidatedGridSize",
        /**
         * Check for batched CellMeasurer size invalidations.
         * This will occur the first time one or more previously unmeasured cells are rendered.
         */
        value: function() {
          if (typeof this._deferredInvalidateColumnIndex == "number" && typeof this._deferredInvalidateRowIndex == "number") {
            var Y = this._deferredInvalidateColumnIndex, V = this._deferredInvalidateRowIndex;
            this._deferredInvalidateColumnIndex = null, this._deferredInvalidateRowIndex = null, this.recomputeGridSize({
              columnIndex: Y,
              rowIndex: V
            });
          }
        }
      }, {
        key: "_invokeOnScrollMemoizer",
        value: function(Y) {
          var V = this, Z = Y.scrollLeft, ce = Y.scrollTop, ee = Y.totalColumnsWidth, pe = Y.totalRowsHeight;
          this._onScrollMemoizer({
            callback: function(Be) {
              var Ie = Be.scrollLeft, Qe = Be.scrollTop, xe = V.props, Se = xe.height, De = xe.onScroll, Ue = xe.width;
              De({
                clientHeight: Se,
                clientWidth: Ue,
                scrollHeight: pe,
                scrollLeft: Ie,
                scrollTop: Qe,
                scrollWidth: ee
              });
            },
            indices: {
              scrollLeft: Z,
              scrollTop: ce
            }
          });
        }
      }, {
        key: "_isScrolling",
        value: function() {
          var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
          return Object.hasOwnProperty.call(Y, "isScrolling") ? !!Y.isScrolling : !!V.isScrolling;
        }
      }, {
        key: "_maybeCallOnScrollbarPresenceChange",
        value: function() {
          if (this._scrollbarPresenceChanged) {
            var Y = this.props.onScrollbarPresenceChange;
            this._scrollbarPresenceChanged = !1, Y({
              horizontal: this._horizontalScrollBarSize > 0,
              size: this.state.instanceProps.scrollbarSize,
              vertical: this._verticalScrollBarSize > 0
            });
          }
        }
      }, {
        key: "scrollToPosition",
        /**
         * Scroll to the specified offset(s).
         * Useful for animating position changes.
         */
        value: function(Y) {
          var V = Y.scrollLeft, Z = Y.scrollTop, ce = K._getScrollToPositionStateUpdate({
            prevState: this.state,
            scrollLeft: V,
            scrollTop: Z
          });
          ce && (ce.needToResetStyleCache = !1, this.setState(ce));
        }
      }, {
        key: "_getCalculatedScrollLeft",
        value: function() {
          var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
          return K._getCalculatedScrollLeft(Y, V);
        }
      }, {
        key: "_updateScrollLeftForScrollToColumn",
        value: function() {
          var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state, Z = K._getScrollLeftForScrollToColumnStateUpdate(Y, V);
          Z && (Z.needToResetStyleCache = !1, this.setState(Z));
        }
      }, {
        key: "_getCalculatedScrollTop",
        value: function() {
          var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
          return K._getCalculatedScrollTop(Y, V);
        }
      }, {
        key: "_resetStyleCache",
        value: function() {
          var Y = this._styleCache, V = this._cellCache, Z = this.props.isScrollingOptOut;
          this._cellCache = {}, this._styleCache = {};
          for (var ce = this._rowStartIndex; ce <= this._rowStopIndex; ce++)
            for (var ee = this._columnStartIndex; ee <= this._columnStopIndex; ee++) {
              var pe = "".concat(ce, "-").concat(ee);
              this._styleCache[pe] = Y[pe], Z && (this._cellCache[pe] = V[pe]);
            }
        }
      }, {
        key: "_updateScrollTopForScrollToRow",
        value: function() {
          var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state, Z = K._getScrollTopForScrollToRowStateUpdate(Y, V);
          Z && (Z.needToResetStyleCache = !1, this.setState(Z));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function(Y, V) {
          var Z = {};
          Y.columnCount === 0 && V.scrollLeft !== 0 || Y.rowCount === 0 && V.scrollTop !== 0 ? (Z.scrollLeft = 0, Z.scrollTop = 0) : (Y.scrollLeft !== V.scrollLeft && Y.scrollToColumn < 0 || Y.scrollTop !== V.scrollTop && Y.scrollToRow < 0) && Object.assign(Z, K._getScrollToPositionStateUpdate({
            prevState: V,
            scrollLeft: Y.scrollLeft,
            scrollTop: Y.scrollTop
          }));
          var ce = V.instanceProps;
          Z.needToResetStyleCache = !1, (Y.columnWidth !== ce.prevColumnWidth || Y.rowHeight !== ce.prevRowHeight) && (Z.needToResetStyleCache = !0), ce.columnSizeAndPositionManager.configure({
            cellCount: Y.columnCount,
            estimatedCellSize: K._getEstimatedColumnSize(Y),
            cellSizeGetter: K._wrapSizeGetter(Y.columnWidth)
          }), ce.rowSizeAndPositionManager.configure({
            cellCount: Y.rowCount,
            estimatedCellSize: K._getEstimatedRowSize(Y),
            cellSizeGetter: K._wrapSizeGetter(Y.rowHeight)
          }), (ce.prevColumnCount === 0 || ce.prevRowCount === 0) && (ce.prevColumnCount = 0, ce.prevRowCount = 0), Y.autoHeight && Y.isScrolling === !1 && ce.prevIsScrolling === !0 && Object.assign(Z, {
            isScrolling: !1
          });
          var ee, pe;
          return (0, h.default)({
            cellCount: ce.prevColumnCount,
            cellSize: typeof ce.prevColumnWidth == "number" ? ce.prevColumnWidth : null,
            computeMetadataCallback: function() {
              return ce.columnSizeAndPositionManager.resetCell(0);
            },
            computeMetadataCallbackProps: Y,
            nextCellsCount: Y.columnCount,
            nextCellSize: typeof Y.columnWidth == "number" ? Y.columnWidth : null,
            nextScrollToIndex: Y.scrollToColumn,
            scrollToIndex: ce.prevScrollToColumn,
            updateScrollOffsetForScrollToIndex: function() {
              ee = K._getScrollLeftForScrollToColumnStateUpdate(Y, V);
            }
          }), (0, h.default)({
            cellCount: ce.prevRowCount,
            cellSize: typeof ce.prevRowHeight == "number" ? ce.prevRowHeight : null,
            computeMetadataCallback: function() {
              return ce.rowSizeAndPositionManager.resetCell(0);
            },
            computeMetadataCallbackProps: Y,
            nextCellsCount: Y.rowCount,
            nextCellSize: typeof Y.rowHeight == "number" ? Y.rowHeight : null,
            nextScrollToIndex: Y.scrollToRow,
            scrollToIndex: ce.prevScrollToRow,
            updateScrollOffsetForScrollToIndex: function() {
              pe = K._getScrollTopForScrollToRowStateUpdate(Y, V);
            }
          }), ce.prevColumnCount = Y.columnCount, ce.prevColumnWidth = Y.columnWidth, ce.prevIsScrolling = Y.isScrolling === !0, ce.prevRowCount = Y.rowCount, ce.prevRowHeight = Y.rowHeight, ce.prevScrollToColumn = Y.scrollToColumn, ce.prevScrollToRow = Y.scrollToRow, ce.scrollbarSize = Y.getScrollbarSize(), ce.scrollbarSize === void 0 ? (ce.scrollbarSizeMeasured = !1, ce.scrollbarSize = 0) : ce.scrollbarSizeMeasured = !0, Z.instanceProps = ce, O({}, Z, {}, ee, {}, pe);
        }
      }, {
        key: "_getEstimatedColumnSize",
        value: function(Y) {
          return typeof Y.columnWidth == "number" ? Y.columnWidth : Y.estimatedColumnSize;
        }
      }, {
        key: "_getEstimatedRowSize",
        value: function(Y) {
          return typeof Y.rowHeight == "number" ? Y.rowHeight : Y.estimatedRowSize;
        }
      }, {
        key: "_getScrollToPositionStateUpdate",
        /**
         * Get the updated state after scrolling to
         * scrollLeft and scrollTop
         */
        value: function(Y) {
          var V = Y.prevState, Z = Y.scrollLeft, ce = Y.scrollTop, ee = {
            scrollPositionChangeReason: N.REQUESTED
          };
          return typeof Z == "number" && Z >= 0 && (ee.scrollDirectionHorizontal = Z > V.scrollLeft ? m.SCROLL_DIRECTION_FORWARD : m.SCROLL_DIRECTION_BACKWARD, ee.scrollLeft = Z), typeof ce == "number" && ce >= 0 && (ee.scrollDirectionVertical = ce > V.scrollTop ? m.SCROLL_DIRECTION_FORWARD : m.SCROLL_DIRECTION_BACKWARD, ee.scrollTop = ce), typeof Z == "number" && Z >= 0 && Z !== V.scrollLeft || typeof ce == "number" && ce >= 0 && ce !== V.scrollTop ? ee : {};
        }
      }, {
        key: "_wrapSizeGetter",
        value: function(Y) {
          return typeof Y == "function" ? Y : function() {
            return Y;
          };
        }
      }, {
        key: "_getCalculatedScrollLeft",
        value: function(Y, V) {
          var Z = Y.columnCount, ce = Y.height, ee = Y.scrollToAlignment, pe = Y.scrollToColumn, Ce = Y.width, Be = V.scrollLeft, Ie = V.instanceProps;
          if (Z > 0) {
            var Qe = Z - 1, xe = pe < 0 ? Qe : Math.min(Qe, pe), Se = Ie.rowSizeAndPositionManager.getTotalSize(), De = Ie.scrollbarSizeMeasured && Se > ce ? Ie.scrollbarSize : 0;
            return Ie.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
              align: ee,
              containerSize: Ce - De,
              currentOffset: Be,
              targetIndex: xe
            });
          }
          return 0;
        }
      }, {
        key: "_getScrollLeftForScrollToColumnStateUpdate",
        value: function(Y, V) {
          var Z = V.scrollLeft, ce = K._getCalculatedScrollLeft(Y, V);
          return typeof ce == "number" && ce >= 0 && Z !== ce ? K._getScrollToPositionStateUpdate({
            prevState: V,
            scrollLeft: ce,
            scrollTop: -1
          }) : {};
        }
      }, {
        key: "_getCalculatedScrollTop",
        value: function(Y, V) {
          var Z = Y.height, ce = Y.rowCount, ee = Y.scrollToAlignment, pe = Y.scrollToRow, Ce = Y.width, Be = V.scrollTop, Ie = V.instanceProps;
          if (ce > 0) {
            var Qe = ce - 1, xe = pe < 0 ? Qe : Math.min(Qe, pe), Se = Ie.columnSizeAndPositionManager.getTotalSize(), De = Ie.scrollbarSizeMeasured && Se > Ce ? Ie.scrollbarSize : 0;
            return Ie.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
              align: ee,
              containerSize: Z - De,
              currentOffset: Be,
              targetIndex: xe
            });
          }
          return 0;
        }
      }, {
        key: "_getScrollTopForScrollToRowStateUpdate",
        value: function(Y, V) {
          var Z = V.scrollTop, ce = K._getCalculatedScrollTop(Y, V);
          return typeof ce == "number" && ce >= 0 && Z !== ce ? K._getScrollToPositionStateUpdate({
            prevState: V,
            scrollLeft: -1,
            scrollTop: ce
          }) : {};
        }
      }]), K;
    }(u.PureComponent), (0, c.default)(w, "propTypes", null), R);
    (0, c.default)($, "defaultProps", {
      "aria-label": "grid",
      "aria-readonly": !0,
      autoContainerWidth: !1,
      autoHeight: !1,
      autoWidth: !1,
      cellRangeRenderer: y.default,
      containerRole: "rowgroup",
      containerStyle: {},
      estimatedColumnSize: 100,
      estimatedRowSize: 30,
      getScrollbarSize: v.default,
      noContentRenderer: k,
      onScroll: function() {
      },
      onScrollbarPresenceChange: function() {
      },
      onSectionRendered: function() {
      },
      overscanColumnCount: 0,
      overscanIndicesGetter: m.default,
      overscanRowCount: 10,
      role: "grid",
      scrollingResetTimeInterval: L,
      scrollToAlignment: "auto",
      scrollToColumn: -1,
      scrollToRow: -1,
      style: {},
      tabIndex: 0,
      isScrollingOptOut: !1
    }), (0, b.polyfill)($);
    var U = $;
    t.default = U;
  }(qK)), qK;
}
var eW = {}, wNe;
function yZn() {
  return wNe || (wNe = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o, t.SCROLL_DIRECTION_VERTICAL = t.SCROLL_DIRECTION_HORIZONTAL = t.SCROLL_DIRECTION_FORWARD = t.SCROLL_DIRECTION_BACKWARD = void 0, FE();
    var e = -1;
    t.SCROLL_DIRECTION_BACKWARD = e;
    var n = 1;
    t.SCROLL_DIRECTION_FORWARD = n;
    var r = "horizontal";
    t.SCROLL_DIRECTION_HORIZONTAL = r;
    var i = "vertical";
    t.SCROLL_DIRECTION_VERTICAL = i;
    function o(s) {
      var a = s.cellCount, A = s.overscanCellsCount, l = s.scrollDirection, c = s.startIndex, u = s.stopIndex;
      return A = Math.max(1, A), l === n ? {
        overscanStartIndex: Math.max(0, c - 1),
        overscanStopIndex: Math.min(a - 1, u + A)
      } : {
        overscanStartIndex: Math.max(0, c - A),
        overscanStopIndex: Math.min(a - 1, u + 1)
      };
    }
  }(eW)), eW;
}
var xNe;
function vZn() {
  return xNe || (xNe = 1, function(t) {
    var e = pl;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return n.default;
      }
    }), Object.defineProperty(t, "Grid", {
      enumerable: !0,
      get: function() {
        return n.default;
      }
    }), Object.defineProperty(t, "accessibilityOverscanIndicesGetter", {
      enumerable: !0,
      get: function() {
        return r.default;
      }
    }), Object.defineProperty(t, "defaultCellRangeRenderer", {
      enumerable: !0,
      get: function() {
        return i.default;
      }
    }), Object.defineProperty(t, "defaultOverscanIndicesGetter", {
      enumerable: !0,
      get: function() {
        return o.default;
      }
    }), Object.defineProperty(t, "bpfrpt_proptype_NoContentRenderer", {
      enumerable: !0,
      get: function() {
        return s.bpfrpt_proptype_NoContentRenderer;
      }
    }), Object.defineProperty(t, "bpfrpt_proptype_Alignment", {
      enumerable: !0,
      get: function() {
        return s.bpfrpt_proptype_Alignment;
      }
    }), Object.defineProperty(t, "bpfrpt_proptype_CellPosition", {
      enumerable: !0,
      get: function() {
        return s.bpfrpt_proptype_CellPosition;
      }
    }), Object.defineProperty(t, "bpfrpt_proptype_CellSize", {
      enumerable: !0,
      get: function() {
        return s.bpfrpt_proptype_CellSize;
      }
    }), Object.defineProperty(t, "bpfrpt_proptype_OverscanIndicesGetter", {
      enumerable: !0,
      get: function() {
        return s.bpfrpt_proptype_OverscanIndicesGetter;
      }
    }), Object.defineProperty(t, "bpfrpt_proptype_RenderedSection", {
      enumerable: !0,
      get: function() {
        return s.bpfrpt_proptype_RenderedSection;
      }
    }), Object.defineProperty(t, "bpfrpt_proptype_CellRendererParams", {
      enumerable: !0,
      get: function() {
        return s.bpfrpt_proptype_CellRendererParams;
      }
    }), Object.defineProperty(t, "bpfrpt_proptype_Scroll", {
      enumerable: !0,
      get: function() {
        return s.bpfrpt_proptype_Scroll;
      }
    });
    var n = e(EZn()), r = e(yZn()), i = e(gXe()), o = e(fXe()), s = FE();
  }($K)), $K;
}
var RNe;
function BZn() {
  return RNe || (RNe = 1, function(t) {
    var e = im(), n = pl;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = n(tge()), i = n(lx()), o = n(eO()), s = n(ej()), a = n(tj()), A = n(Zq()), l = n(nj()), c = n(cx()), u = n(jB);
    n(uXe()), n(Ja);
    var f = e(St), h = Sf, d = e(vZn()), I = n(cXe()), m = n(aXe()), C = n(rj());
    function y(Q, w) {
      var R = Object.keys(Q);
      if (Object.getOwnPropertySymbols) {
        var M = Object.getOwnPropertySymbols(Q);
        w && (M = M.filter(function(O) {
          return Object.getOwnPropertyDescriptor(Q, O).enumerable;
        })), R.push.apply(R, M);
      }
      return R;
    }
    function v(Q) {
      for (var w = 1; w < arguments.length; w++) {
        var R = arguments[w] != null ? arguments[w] : {};
        w % 2 ? y(R, !0).forEach(function(M) {
          (0, c.default)(Q, M, R[M]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Q, Object.getOwnPropertyDescriptors(R)) : y(R).forEach(function(M) {
          Object.defineProperty(Q, M, Object.getOwnPropertyDescriptor(R, M));
        });
      }
      return Q;
    }
    var b = /* @__PURE__ */ function(Q) {
      (0, l.default)(w, Q);
      function w(R) {
        var M;
        return (0, i.default)(this, w), M = (0, s.default)(this, (0, a.default)(w).call(this, R)), M.state = {
          scrollbarWidth: 0
        }, M._createColumn = M._createColumn.bind((0, A.default)(M)), M._createRow = M._createRow.bind((0, A.default)(M)), M._onScroll = M._onScroll.bind((0, A.default)(M)), M._onSectionRendered = M._onSectionRendered.bind((0, A.default)(M)), M._setRef = M._setRef.bind((0, A.default)(M)), M;
      }
      return (0, o.default)(w, [{
        key: "forceUpdateGrid",
        value: function() {
          this.Grid && this.Grid.forceUpdate();
        }
        /** See Grid#getOffsetForCell */
      }, {
        key: "getOffsetForRow",
        value: function(M) {
          var O = M.alignment, L = M.index;
          if (this.Grid) {
            var N = this.Grid.getOffsetForCell({
              alignment: O,
              rowIndex: L
            }), k = N.scrollTop;
            return k;
          }
          return 0;
        }
        /** CellMeasurer compatibility */
      }, {
        key: "invalidateCellSizeAfterRender",
        value: function(M) {
          var O = M.columnIndex, L = M.rowIndex;
          this.Grid && this.Grid.invalidateCellSizeAfterRender({
            rowIndex: L,
            columnIndex: O
          });
        }
        /** See Grid#measureAllCells */
      }, {
        key: "measureAllRows",
        value: function() {
          this.Grid && this.Grid.measureAllCells();
        }
        /** CellMeasurer compatibility */
      }, {
        key: "recomputeGridSize",
        value: function() {
          var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, O = M.columnIndex, L = O === void 0 ? 0 : O, N = M.rowIndex, k = N === void 0 ? 0 : N;
          this.Grid && this.Grid.recomputeGridSize({
            rowIndex: k,
            columnIndex: L
          });
        }
        /** See Grid#recomputeGridSize */
      }, {
        key: "recomputeRowHeights",
        value: function() {
          var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          this.Grid && this.Grid.recomputeGridSize({
            rowIndex: M
          });
        }
        /** See Grid#scrollToPosition */
      }, {
        key: "scrollToPosition",
        value: function() {
          var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          this.Grid && this.Grid.scrollToPosition({
            scrollTop: M
          });
        }
        /** See Grid#scrollToCell */
      }, {
        key: "scrollToRow",
        value: function() {
          var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          this.Grid && this.Grid.scrollToCell({
            columnIndex: 0,
            rowIndex: M
          });
        }
      }, {
        key: "getScrollbarWidth",
        value: function() {
          if (this.Grid) {
            var M = (0, h.findDOMNode)(this.Grid), O = M.clientWidth || 0, L = M.offsetWidth || 0;
            return L - O;
          }
          return 0;
        }
      }, {
        key: "componentDidMount",
        value: function() {
          this._setScrollbarWidth();
        }
      }, {
        key: "componentDidUpdate",
        value: function() {
          this._setScrollbarWidth();
        }
      }, {
        key: "render",
        value: function() {
          var M = this, O = this.props, L = O.children, N = O.className, k = O.disableHeader, $ = O.gridClassName, U = O.gridStyle, X = O.headerHeight, K = O.headerRowRenderer, z = O.height, Y = O.id, V = O.noRowsRenderer, Z = O.rowClassName, ce = O.rowStyle, ee = O.scrollToIndex, pe = O.style, Ce = O.width, Be = this.state.scrollbarWidth, Ie = k ? z : z - X, Qe = typeof Z == "function" ? Z({
            index: -1
          }) : Z, xe = typeof ce == "function" ? ce({
            index: -1
          }) : ce;
          return this._cachedColumnStyles = [], f.Children.toArray(L).forEach(function(Se, De) {
            var Ue = M._getFlexStyleForColumn(Se, Se.props.style);
            M._cachedColumnStyles[De] = v({
              overflow: "hidden"
            }, Ue);
          }), f.createElement("div", {
            "aria-label": this.props["aria-label"],
            "aria-labelledby": this.props["aria-labelledby"],
            "aria-colcount": f.Children.toArray(L).length,
            "aria-rowcount": this.props.rowCount,
            className: (0, u.default)("ReactVirtualized__Table", N),
            id: Y,
            role: "grid",
            style: pe
          }, !k && K({
            className: (0, u.default)("ReactVirtualized__Table__headerRow", Qe),
            columns: this._getHeaderColumns(),
            style: v({
              height: X,
              overflow: "hidden",
              paddingRight: Be,
              width: Ce
            }, xe)
          }), f.createElement(d.default, (0, r.default)({}, this.props, {
            "aria-readonly": null,
            autoContainerWidth: !0,
            className: (0, u.default)("ReactVirtualized__Table__Grid", $),
            cellRenderer: this._createRow,
            columnWidth: Ce,
            columnCount: 1,
            height: Ie,
            id: void 0,
            noContentRenderer: V,
            onScroll: this._onScroll,
            onSectionRendered: this._onSectionRendered,
            ref: this._setRef,
            role: "rowgroup",
            scrollbarWidth: Be,
            scrollToRow: ee,
            style: v({}, U, {
              overflowX: "hidden"
            })
          })));
        }
      }, {
        key: "_createColumn",
        value: function(M) {
          var O = M.column, L = M.columnIndex, N = M.isScrolling, k = M.parent, $ = M.rowData, U = M.rowIndex, X = this.props.onColumnClick, K = O.props, z = K.cellDataGetter, Y = K.cellRenderer, V = K.className, Z = K.columnData, ce = K.dataKey, ee = K.id, pe = z({
            columnData: Z,
            dataKey: ce,
            rowData: $
          }), Ce = Y({
            cellData: pe,
            columnData: Z,
            columnIndex: L,
            dataKey: ce,
            isScrolling: N,
            parent: k,
            rowData: $,
            rowIndex: U
          }), Be = function(Se) {
            X && X({
              columnData: Z,
              dataKey: ce,
              event: Se
            });
          }, Ie = this._cachedColumnStyles[L], Qe = typeof Ce == "string" ? Ce : null;
          return f.createElement("div", {
            "aria-colindex": L + 1,
            "aria-describedby": ee,
            className: (0, u.default)("ReactVirtualized__Table__rowColumn", V),
            key: "Row" + U + "-Col" + L,
            onClick: Be,
            role: "gridcell",
            style: Ie,
            title: Qe
          }, Ce);
        }
      }, {
        key: "_createHeader",
        value: function(M) {
          var O = M.column, L = M.index, N = this.props, k = N.headerClassName, $ = N.headerStyle, U = N.onHeaderClick, X = N.sort, K = N.sortBy, z = N.sortDirection, Y = O.props, V = Y.columnData, Z = Y.dataKey, ce = Y.defaultSortDirection, ee = Y.disableSort, pe = Y.headerRenderer, Ce = Y.id, Be = Y.label, Ie = !ee && X, Qe = (0, u.default)("ReactVirtualized__Table__headerColumn", k, O.props.headerClassName, {
            ReactVirtualized__Table__sortableHeaderColumn: Ie
          }), xe = this._getFlexStyleForColumn(O, v({}, $, {}, O.props.headerStyle)), Se = pe({
            columnData: V,
            dataKey: Z,
            disableSort: ee,
            label: Be,
            sortBy: K,
            sortDirection: z
          }), De, Ue, Te, se, fe;
          if (Ie || U) {
            var W = K !== Z, ge = W ? ce : z === C.default.DESC ? C.default.ASC : C.default.DESC, _e = function(oe) {
              Ie && X({
                defaultSortDirection: ce,
                event: oe,
                sortBy: Z,
                sortDirection: ge
              }), U && U({
                columnData: V,
                dataKey: Z,
                event: oe
              });
            }, Re = function(oe) {
              (oe.key === "Enter" || oe.key === " ") && _e(oe);
            };
            fe = O.props["aria-label"] || Be || Z, se = "none", Te = 0, De = _e, Ue = Re;
          }
          return K === Z && (se = z === C.default.ASC ? "ascending" : "descending"), f.createElement("div", {
            "aria-label": fe,
            "aria-sort": se,
            className: Qe,
            id: Ce,
            key: "Header-Col" + L,
            onClick: De,
            onKeyDown: Ue,
            role: "columnheader",
            style: xe,
            tabIndex: Te
          }, Se);
        }
      }, {
        key: "_createRow",
        value: function(M) {
          var O = this, L = M.rowIndex, N = M.isScrolling, k = M.key, $ = M.parent, U = M.style, X = this.props, K = X.children, z = X.onRowClick, Y = X.onRowDoubleClick, V = X.onRowRightClick, Z = X.onRowMouseOver, ce = X.onRowMouseOut, ee = X.rowClassName, pe = X.rowGetter, Ce = X.rowRenderer, Be = X.rowStyle, Ie = this.state.scrollbarWidth, Qe = typeof ee == "function" ? ee({
            index: L
          }) : ee, xe = typeof Be == "function" ? Be({
            index: L
          }) : Be, Se = pe({
            index: L
          }), De = f.Children.toArray(K).map(function(se, fe) {
            return O._createColumn({
              column: se,
              columnIndex: fe,
              isScrolling: N,
              parent: $,
              rowData: Se,
              rowIndex: L,
              scrollbarWidth: Ie
            });
          }), Ue = (0, u.default)("ReactVirtualized__Table__row", Qe), Te = v({}, U, {
            height: this._getRowHeight(L),
            overflow: "hidden",
            paddingRight: Ie
          }, xe);
          return Ce({
            className: Ue,
            columns: De,
            index: L,
            isScrolling: N,
            key: k,
            onRowClick: z,
            onRowDoubleClick: Y,
            onRowRightClick: V,
            onRowMouseOver: Z,
            onRowMouseOut: ce,
            rowData: Se,
            style: Te
          });
        }
        /**
         * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
         */
      }, {
        key: "_getFlexStyleForColumn",
        value: function(M) {
          var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, L = "".concat(M.props.flexGrow, " ").concat(M.props.flexShrink, " ").concat(M.props.width, "px"), N = v({}, O, {
            flex: L,
            msFlex: L,
            WebkitFlex: L
          });
          return M.props.maxWidth && (N.maxWidth = M.props.maxWidth), M.props.minWidth && (N.minWidth = M.props.minWidth), N;
        }
      }, {
        key: "_getHeaderColumns",
        value: function() {
          var M = this, O = this.props, L = O.children, N = O.disableHeader, k = N ? [] : f.Children.toArray(L);
          return k.map(function($, U) {
            return M._createHeader({
              column: $,
              index: U
            });
          });
        }
      }, {
        key: "_getRowHeight",
        value: function(M) {
          var O = this.props.rowHeight;
          return typeof O == "function" ? O({
            index: M
          }) : O;
        }
      }, {
        key: "_onScroll",
        value: function(M) {
          var O = M.clientHeight, L = M.scrollHeight, N = M.scrollTop, k = this.props.onScroll;
          k({
            clientHeight: O,
            scrollHeight: L,
            scrollTop: N
          });
        }
      }, {
        key: "_onSectionRendered",
        value: function(M) {
          var O = M.rowOverscanStartIndex, L = M.rowOverscanStopIndex, N = M.rowStartIndex, k = M.rowStopIndex, $ = this.props.onRowsRendered;
          $({
            overscanStartIndex: O,
            overscanStopIndex: L,
            startIndex: N,
            stopIndex: k
          });
        }
      }, {
        key: "_setRef",
        value: function(M) {
          this.Grid = M;
        }
      }, {
        key: "_setScrollbarWidth",
        value: function() {
          var M = this.getScrollbarWidth();
          this.setState({
            scrollbarWidth: M
          });
        }
      }]), w;
    }(f.PureComponent);
    t.default = b, (0, c.default)(b, "defaultProps", {
      disableHeader: !1,
      estimatedRowSize: 30,
      headerHeight: 0,
      headerStyle: {},
      noRowsRenderer: function() {
        return null;
      },
      onRowsRendered: function() {
        return null;
      },
      onScroll: function() {
        return null;
      },
      overscanIndicesGetter: d.accessibilityOverscanIndicesGetter,
      overscanRowCount: 10,
      rowRenderer: I.default,
      headerRowRenderer: m.default,
      rowStyle: {},
      scrollToAlignment: "auto",
      scrollToIndex: -1,
      style: {}
    }), b.propTypes = {};
  }(HK)), HK;
}
(function(t) {
  var e = pl;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "createMultiSort", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(t, "defaultCellDataGetter", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(t, "defaultCellRenderer", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  }), Object.defineProperty(t, "defaultHeaderRowRenderer", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  }), Object.defineProperty(t, "defaultHeaderRenderer", {
    enumerable: !0,
    get: function() {
      return s.default;
    }
  }), Object.defineProperty(t, "defaultRowRenderer", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(t, "Column", {
    enumerable: !0,
    get: function() {
      return A.default;
    }
  }), Object.defineProperty(t, "SortDirection", {
    enumerable: !0,
    get: function() {
      return l.default;
    }
  }), Object.defineProperty(t, "SortIndicator", {
    enumerable: !0,
    get: function() {
      return c.default;
    }
  }), Object.defineProperty(t, "Table", {
    enumerable: !0,
    get: function() {
      return u.default;
    }
  }), t.default = void 0;
  var n = e(oZn()), r = e(oXe()), i = e(sXe()), o = e(aXe()), s = e(lXe()), a = e(cXe()), A = e(uXe()), l = e(rj()), c = e(AXe()), u = e(BZn()), f = u.default;
  t.default = f;
})(iXe);
const bZn = kr((t) => ({
  selectableTable: {
    flex: "1 1 auto",
    outline: "none"
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
    borderBottom: `1px solid ${t.palette.secondaryBackgroundDim}`
    // map-get($theme-colors, "secondary-background-dim");
  },
  tableItem: {
    cursor: "pointer",
    userSelect: "none",
    "&.row-checked": {
      backgroundColor: t.palette.secondaryBackgroundDim
      // map-get($theme-colors, "secondary-background-dim");
    },
    "&:not(.row-checked):hover": {
      /*
      @if $theme-name == dark {
          background-color: darken(map-get($theme-colors, "secondary-background-dim"), 10%);
      } @else {
          background-color: lighten(map-get($theme-colors, "secondary-background-dim"), 10%);
      }
      */
    }
  },
  tableCell: {
    textAlign: "left",
    flexBasis: 0,
    flexGrow: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  inputContainer: {
    width: "1em",
    "& label": {
      display: "block",
      margin: "0",
      cursor: "pointer"
    },
    "& input": {
      cursor: "pointer"
    }
  },
  hiddenInputColumn: {
    // Class for first column of inputs, to hide them if desired.
    display: "none"
  },
  radioOrCheckbox: {
    appearance: "none",
    /* create custom radiobutton appearance */
    display: "inline-block",
    width: "1em",
    height: "1em",
    margin: "0.3em 0.5em 0.0em 0.5em",
    padding: "6px",
    /* background-color only for content */
    backgroundClip: "content-box",
    border: `2px solid ${t.palette.grayLight}`,
    backgroundColor: t.palette.grayLight,
    "&:checked": {
      backgroundClip: "unset"
    }
  },
  tableRadio: {
    borderRadius: "50%"
  },
  tableCheckbox: {
    borderRadius: "2px"
  }
})), DNe = 16;
function _Zn(t) {
  const { hasColorEncoding: e, columns: n, columnLabels: r, data: i, onChange: o, idKey: s = "id", valueKey: a = "value", allowMultiple: A = !1, allowUncheck: l = !1, showTableHead: c = !0, showTableInputs: u = !1, testHeight: f = void 0, testWidth: h = void 0 } = t, [d, I] = mn(null), [m, C] = mn(!1);
  Mn(() => {
    function L(k) {
      A && k.keyCode === DNe && C(!0);
    }
    function N(k) {
      A && k.keyCode === DNe && C(!1);
    }
    return window.addEventListener("keydown", L), window.addEventListener("keyup", N), () => {
      window.removeEventListener("keydown", L), window.removeEventListener("keyup", N);
    };
  }, [A]);
  const y = Qn((L, N) => {
    (N || l) && (!m && (N || !N && A && d.length > 1) ? I([L]) : I(!A && !N ? [] : N ? sSt(d || [], [L]) : k_t(d || [], [L])));
  }, [A, m, l, d]), v = Qn((L) => {
    const { target: N } = L, { checked: k } = N, { value: $ } = N;
    y($, k);
  }, [y]), b = Qn((L) => L.map((N) => ({
    [s]: N,
    data: i.find((k) => k[s] === N)
  })), [i, s]), Q = Qn((L) => Array.isArray(d) && d.includes(L), [d]);
  Mn(() => {
    const L = i.map((N) => N[a] ? N[s] : null).filter(Boolean);
    gr(L, d) || (L.length > 0 ? I(L) : I(null));
  }, [i, s, a]), Mn(() => {
    if (!o || !d)
      return;
    const L = b(d);
    A ? o(L) : d.length === 1 ? o(L[0]) : d.length === 0 && o(null);
  }, [d, A]);
  const w = bZn(), R = BT(), M = ({ index: L, style: N }) => (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    ne.jsxs("div", { className: Xt(w.tableItem, w.tableRow, { "row-checked": Q(i[L][s]) }), style: N, role: "button", onClick: () => y(i[L][s], !Q(i[L][s]) || !e), children: [ne.jsx("div", { className: Xt(w.inputContainer, w.tableCell, { [w.hiddenInputColumn]: !u }), children: ne.jsx("label", { htmlFor: `${R}_${i[L][s]}`, children: ne.jsx("input", { id: `${R}_${i[L][s]}`, type: "checkbox", className: Xt(w.radioOrCheckbox, m ? w.tableCheckbox : w.tableRadio), name: R, value: i[L][s], onChange: v, checked: Q(i[L][s]) }) }) }), n.map((k) => ne.jsx("div", { className: w.tableCell, children: i[L][k] }, k))] }, i[L][s])
  ), O = ({ style: L }) => ne.jsx("div", { className: w.tableRow, style: L, children: r.map((N) => ne.jsx("div", { className: w.tableCell, style: { fontWeight: "bold" }, children: N }, N)) });
  return ne.jsx("div", { className: w.selectableTable, children: ne.jsx(tXe.AutoSizer, { children: ({ width: L, height: N }) => ne.jsx(iXe.Table, {
    height: f || N,
    gridStyle: { outline: "none" },
    rowCount: i.length,
    // 24 is 1 em + padding in either direction (see _selectable_table.scss).
    rowHeight: 24,
    headerHeight: c ? 24 : void 0,
    rowRenderer: M,
    width: h || L,
    headerRowRenderer: c ? O : void 0,
    rowGetter: ({ index: k }) => i[k]
  }) }) });
}
const SZn = [
  "alphabetical",
  "original"
], hXe = "Alternate ID", QZn = kr(() => ({
  searchBar: {
    marginBottom: "4px",
    border: "0",
    padding: "2px",
    borderRadius: "2px"
  }
}));
function wZn(t) {
  const { hasColorEncoding: e, geneList: n = [], featureLabelsMap: r, geneSelection: i = [], geneFilter: o = null, setGeneSelection: s, enableMultiSelect: a, showFeatureTable: A, featureListSort: l, featureListSortKey: c, hasFeatureLabels: u, primaryColumnName: f } = t, h = QZn(), [d, I] = mn(""), [m, C] = mn(n), y = c === "featureIndex" ? "key" : "name";
  Mn(() => {
    const M = n.filter((O) => O.toLowerCase().includes(d.toLowerCase()) || r?.get(O)?.toLowerCase().includes(d.toLowerCase()));
    C(M);
  }, [d, n, r]);
  function v(M) {
    s && M && (Array.isArray(M) ? M.length > 0 && Q4e(M, (O) => O.key) ? s(M.map((O) => O.key)) : s(null) : M.key && s([M.key]));
  }
  const b = dt(() => {
    const M = m.filter((O) => o ? o.includes(O) : !0).map((O) => ({
      key: O,
      name: r?.get(O) || O,
      value: i ? i.includes(O) : !1
    }));
    return M && l === "alphabetical" && M.length > 0 ? M.sort((O, L) => O[y].localeCompare(L[y])) : M;
  }, [
    l,
    y,
    m,
    o,
    r,
    i
  ]), Q = (M) => {
    I(M.target.value);
  }, [w, R] = dt(() => A && u ? [
    ["name", "key"],
    [f, hXe]
  ] : [
    ["name"],
    [f]
  ], [A, f, u]);
  return ne.jsxs(ne.Fragment, { children: [ne.jsx("input", { className: h.searchBar, type: "text", placeholder: "Search", value: d, onChange: Q }), ne.jsx(_Zn, { columns: w, columnLabels: R, data: b, hasColorEncoding: e, idKey: "key", valueKey: "value", onChange: v, allowMultiple: a, allowUncheck: a, showTableHead: R.length > 1 })] });
}
function xZn(t) {
  const { children: e, featureListSort: n, setFeatureListSort: r, featureListSortKey: i, setFeatureListSortKey: o, showFeatureTable: s, setShowFeatureTable: a, hasFeatureLabels: A, primaryColumnName: l } = t, c = Jr();
  function u(I) {
    r(I.target.value);
  }
  function f(I) {
    o(I.target.value);
  }
  function h(I) {
    a(I.target.checked);
  }
  const d = VI();
  return ne.jsxs(NL, { children: [e, ne.jsxs(Ko, { children: [ne.jsx(br, { className: d.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `feature-list-sort-option-${c}`, children: "Sort Ordering" }) }), ne.jsx(br, { variant: "body", children: ne.jsx(nd, { className: d.select, value: n, onChange: u, inputProps: {
    id: `feature-list-sort-option-${c}`
  }, children: SZn.map((I) => ne.jsx("option", { value: I, children: I }, I)) }) })] }), A ? ne.jsxs(ne.Fragment, { children: [ne.jsxs(Ko, { children: [ne.jsx(br, { className: d.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `feature-list-sort-key-${c}`, children: "Sort Key" }) }), ne.jsx(br, { variant: "body", children: ne.jsx(nd, { className: d.select, disabled: n === "original", value: i, onChange: f, inputProps: {
    "aria-label": "Select the feature list sort key",
    id: `feature-list-sort-key-${c}`
  }, children: A ? ne.jsxs(ne.Fragment, { children: [ne.jsx("option", { value: "featureLabels", children: l }), ne.jsx("option", { value: "featureIndex", children: hXe })] }) : ne.jsx("option", { value: "featureIndex", children: l }) }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: d.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `feature-list-show-alternative-ids-${c}`, children: "Show Alternate IDs" }) }), ne.jsx(br, { className: d.inputCell, variant: "body", children: ne.jsx(ds, { className: d.tableCheckbox, checked: s, onChange: h, name: "feature-list-show-table", color: "default", inputProps: {
    "aria-label": "Show or hide alternative feature ids",
    id: `feature-list-show-alternative-ids-${c}`
  } }) })] })] }) : null] });
}
function RZn(t) {
  const { coordinationScopes: e, removeGridComponent: n, variablesLabelOverride: r, theme: i, title: o, enableMultiSelect: s = !1, showTable: a = !1, sort: A = "alphabetical", sortKey: l = null, closeButtonVisible: c, downloadButtonVisible: u } = t, f = eu(), [{ dataset: h, obsType: d, featureType: I, featureSelection: m, featureFilter: C, obsColorEncoding: y }, { setFeatureSelection: v, setFeatureFilter: b, setFeatureHighlight: Q, setObsColorEncoding: w }] = uc(ea[Gn.FEATURE_LIST], e), R = r || I, M = o || `${Ci(R)} List`, [{ featureLabelsMap: O }, L, N] = DL(f, h, !1, {}, {}, { featureType: I }), [{ featureIndex: k }, $, U] = TL(f, h, !0, { obsType: d, featureType: I }), X = Jc([
    L,
    $
  ]), K = Qd([
    N,
    U
  ]), z = k || [], Y = z.length, V = !!O;
  function Z(Se) {
    v(Se), w("geneSelection");
  }
  const [ce, ee] = mn(a), [pe, Ce] = mn(A), [Be, Ie] = mn(null), Qe = l || (V ? "featureLabels" : "featureIndex"), xe = `${Ci(I)} ID`;
  return ne.jsx(fc, {
    title: M,
    info: `${fI(Y)} ${Bf(R, Y)}`,
    theme: i,
    // Virtual scroll is used but this allows for the same styling as a scroll component
    // even though this no longer uses the TitleInfo component's
    // scroll css (SelectableTable is virtual scroll).
    isScroll: !0,
    closeButtonVisible: c,
    downloadButtonVisible: u,
    removeGridComponent: n,
    isReady: X,
    urls: K,
    options: ne.jsx(xZn, { featureListSort: pe, setFeatureListSort: Ce, featureListSortKey: Be || Qe, setFeatureListSortKey: Ie, showFeatureTable: ce, setShowFeatureTable: ee, hasFeatureLabels: !!O, primaryColumnName: xe }),
    children: ne.jsx(wZn, { hasColorEncoding: y === "geneSelection", showFeatureTable: ce, geneList: z, featureListSort: pe, featureListSortKey: Be || Qe, featureLabelsMap: O, featureType: I, geneSelection: m, geneFilter: C, setGeneSelection: Z, setGeneFilter: b, setGeneHighlight: Q, enableMultiSelect: s, hasFeatureLabels: !!O, primaryColumnName: xe })
  });
}
const DZn = kr(() => ({
  span: {
    width: "70px",
    textAlign: "center",
    paddingLeft: "2px",
    paddingRight: "2px"
  }
})), dXe = kr((t) => ({
  valueLabel: {
    marginTop: "7px",
    "& span": {
      color: t.palette.secondaryForeground,
      backgroundColor: t.palette.secondaryBackgroundDim
      // Change color here
    }
  }
})), Md = kr(() => ({
  selectRoot: {
    padding: 0,
    height: "auto",
    margin: "4px 0",
    fontSize: "14px",
    width: "100%"
  }
})), C1 = kr(() => ({
  layerControllerRoot: {
    width: "100%",
    flexDirection: "column",
    padding: "0px 8px"
  },
  layerControllerGrid: {
    marginTop: "10px"
  }
})), TZn = kr((t) => ({
  accordionDetailsRoot: {
    width: "100%",
    flexDirection: "column",
    padding: "8px 8px 24px 8px"
  },
  accordionSummaryRoot: {
    padding: "0px 8px"
  },
  content: {
    margin: "4px 0px",
    minWidth: "0px"
  },
  expanded: {
    marginBottom: t.spacing(-3),
    top: t.spacing(-1)
  },
  expandIcon: {
    "&$expanded": {
      top: t.spacing(-1.3)
    }
  }
})), NZn = kr(() => ({
  inputLabelRoot: {
    fontSize: "14px"
  }
})), LZn = kr(() => ({
  item: {
    width: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  }
})), MZn = kr(() => ({
  selectionSliderRoot: {
    marginTop: "7px"
  },
  markActive: {
    backgroundColor: "rgba(128, 128, 128, 0.7)"
  }
})), OZn = kr((t) => ({
  paletteContainer: {
    width: "70px",
    height: "40px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap"
  },
  button: {
    padding: "3px",
    width: "16px"
  },
  icon: {
    width: "17px",
    height: "17px",
    stroke: t.palette.action.selected,
    "stroke-width": "1px"
  }
})), FZn = ({ handleChange: t }) => {
  const e = OZn();
  return ne.jsx("div", { className: e.paletteContainer, "aria-label": "Color swatch", children: Y0.map((n) => ne.jsx(KQ, { className: e.button, onClick: () => t(n), "aria-label": `Change color to ${n}`, children: ne.jsx(eGt, { fontSize: "small", style: { color: `rgb(${n})` }, className: e.icon }) }, n)) });
}, PZn = kr(() => ({
  menuButton: {
    backgroundColor: "transparent"
  },
  colors: {
    "&:hover": {
      backgroundColor: "transparent"
    },
    paddingLeft: "2px",
    paddingRight: "2px"
  }
}));
function TNe(t) {
  const { children: e } = t, n = DZn();
  return ne.jsx("span", { className: n.span, children: e });
}
function kZn({ handlePropertyChange: t, handleChannelRemove: e, handleIQRUpdate: n }) {
  const [r, i] = mn(!1), o = PZn(), s = (A) => {
    t("color", A);
  }, a = () => {
    i(!1), e();
  };
  return ne.jsxs(s0, { open: r, setOpen: i, buttonIcon: ne.jsx(fw, { fontSize: "small" }), buttonClassName: o.menuButton, "aria-label": "Open channel options menu", children: [ne.jsx(mi, { dense: !0, disableGutters: !0, onClick: a, "aria-label": "Click to remove channel", children: ne.jsx(TNe, { children: "Remove" }) }), ne.jsx(mi, { dense: !0, disableGutters: !0, onClick: n, "aria-label": "Click to use IQR for channel", children: ne.jsx(TNe, { children: "Use IQR" }) }), ne.jsx(mi, { dense: !0, disableGutters: !0, className: o.colors, "aria-label": "Click to select color for channel", children: ne.jsx(FZn, { handleChange: s }) })] });
}
function pXe({ handleChange: t, disabled: e, channelOptions: n, selectionIndex: r }) {
  const i = Md();
  return ne.jsx(il, { classes: { root: i.selectRoot }, native: !0, value: r, onChange: (o) => t(Number(o.target.value)), inputProps: { "aria-label": "Select a channel" }, children: n.map((o, s) => ne.jsx("option", { disabled: e, value: s, children: o }, o)) });
}
function IXe({ color: t, checked: e, toggle: n, disabled: r }) {
  return ne.jsx(ds, { onChange: n, checked: e, disabled: r, style: { color: t, "&$checked": { color: t } }, inputProps: { "aria-label": "Toggle on or off a channel" } });
}
function GZn({ color: t, slider: e = [0, 0], handleChange: n, domain: r = [0, 0], dtype: i, disabled: o }) {
  const [s, a] = r, A = e.slice();
  e[0] < s && (A[0] = s), e[1] > a && (A[1] = a);
  const l = Qn(Bd(n, 3, { trailing: !0 }), [n]), c = dXe(), u = a - s < 500 && i.startsWith("Float") ? (a - s) / 500 : 1;
  return ne.jsx(ps, { classes: { valueLabel: c.valueLabel }, value: e, valueLabelFormat: Jq, onChange: (f, h) => l(h), valueLabelDisplay: "auto", getAriaLabel: (f) => `${f === 0 ? "Low value slider" : "High value slider"} for ${t} colormap channel`, getAriaValueText: () => `Current colormap values: ${t}-${e}`, min: s, max: a, step: u, orientation: "horizontal", style: { color: t, marginTop: "7px" }, disabled: o });
}
function UZn({ visibility: t = !1, slider: e, color: n, channels: r, channelId: i, domainType: o, dimName: s, theme: a, loader: A, colormapOn: l, channelOptions: c, handlePropertyChange: u, handleChannelRemove: f, handleIQRUpdate: h, selectionIndex: d, isLoading: I, use3d: m }) {
  const { dtype: C } = I1(A), [y, v] = mn(null), [b, Q] = mn(null), [w, R] = mn(null), [M, O] = mn([
    { ...r[i].selection }
  ]), L = A5(l, n, a);
  Mn(() => {
    let k = !0;
    if (C && A && r) {
      const $ = [{ ...r[i].selection }];
      let U;
      const X = o !== b, K = w !== m, z = !gr($, M);
      if (X || z || K)
        if (o === "Full") {
          U = [u5[C]];
          const [Y] = U;
          k && (v(Y), Q(o), z && O($), K && R(m));
        } else
          cQ({
            loader: A.data,
            selections: $,
            use3d: m
          }).then((Y) => {
            U = Y.domains;
            const [V] = U;
            k && (v(V), Q(o), z && O($), K && R(m));
          });
    }
    return () => {
      k = !1;
    };
  }, [
    b,
    r,
    i,
    A,
    C,
    o,
    M,
    m,
    w
  ]);
  const N = (k) => ({ [s]: k });
  return ne.jsxs(cn, { container: !0, direction: "column", m: 1, justifyContent: "center", children: [ne.jsxs(cn, { container: !0, direction: "row", justifyContent: "space-between", children: [ne.jsx(cn, { item: !0, xs: 10, children: ne.jsx(pXe, { handleChange: (k) => u("selection", N(k)), selectionIndex: d, channelOptions: c, disabled: I }) }), ne.jsx(cn, { item: !0, xs: 1, style: { marginTop: "4px" }, children: ne.jsx(kZn, { handlePropertyChange: u, handleChannelRemove: f, handleIQRUpdate: h, disabled: I }) })] }), ne.jsxs(cn, { container: !0, direction: "row", justifyContent: "space-between", children: [ne.jsx(cn, { item: !0, xs: 2, children: ne.jsx(IXe, { color: L, checked: t, toggle: () => u("visible", !t), disabled: I }) }), ne.jsx(cn, { item: !0, xs: 9, children: ne.jsx(GZn, { color: L, slider: e, domain: y || u5[C], dtype: C, handleChange: (k) => u("slider", k), disabled: I }) })] })] });
}
function HZn({ visibility: t = !1, dimName: e, channelOptions: n, handlePropertyChange: r, handleChannelRemove: i, selectionIndex: o, disableOptions: s = !1 }) {
  const a = (A) => ({ [e]: A });
  return ne.jsxs(cn, { container: !0, direction: "row", justifyContent: "space-between", children: [ne.jsx(cn, { item: !0, xs: 2, children: ne.jsx(IXe, { color: [220, 220, 220], checked: t, toggle: () => r("visible", !t) }) }), ne.jsx(cn, { item: !0, xs: 9, children: ne.jsx(pXe, { handleChange: (A) => r("selection", a(A)), selectionIndex: o, disableOptions: s, channelOptions: n }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(KQ, { onClick: i, style: { padding: "6px 6px 6px 0px" }, "aria-label": "Remove channel", children: ne.jsx(tGt, {}) }) })] });
}
function NNe(t) {
  const { label: e, layer: n, layerType: r, handleLayerChange: i } = t, o = n.opacity, s = n.visible;
  function a(c) {
    if (r === "cells") {
      const u = c < 0.7;
      i({ ...n, opacity: c, stroked: u });
    } else
      i({ ...n, opacity: c });
  }
  function A(c) {
    i({ ...n, visible: c });
  }
  const l = C1();
  return ne.jsx(cn, { item: !0, style: { marginTop: "10px" }, children: ne.jsxs(r0, { className: l.layerControllerRoot, children: [ne.jsx(Mu, { style: {
    padding: "15px 8px 0px 8px",
    marginBottom: "-5px"
  }, children: e }), ne.jsxs(cn, { container: !0, direction: "row", justifyContent: "space-between", children: [ne.jsx(cn, { item: !0, xs: 2, children: ne.jsx(ds, { color: "primary", checked: s, onChange: (c, u) => A(u), inputProps: { "aria-label": "Show or hide vector layer" } }) }), ne.jsx(cn, { item: !0, xs: 9, style: { paddingRight: "8px" }, children: ne.jsx(ps, { value: o, min: 0, max: 1, step: 1e-3, onChange: (c, u) => a(u), style: { marginTop: "7px" }, orientation: "horizontal", getAriaLabel: (c) => `${c === 0 ? "Low value slider" : "High value slider"} for ${e} layer controller` }) })] })] }) });
}
const $Zn = ["Full", "Min/Max"];
function qZn({ loader: t, handleMultiPropertyChange: e, resolution: n, disable3d: r, setRasterLayerCallback: i, setAreAllChannelsLoading: o, setViewState: s, spatialHeight: a, spatialWidth: A, channels: l, use3d: c, modelMatrix: u }) {
  const f = Md(), h = l.map((v) => v.selection), { data: d } = t, I = async (v) => {
    const b = typeof v == "number";
    if (o(!0), i(() => {
      o(!1), i(null);
    }), b) {
      const [Q, w, R] = HWe(d), M = {
        resolution: v,
        xSlice: Q,
        ySlice: w,
        zSlice: R,
        use3d: b
      };
      if (!c) {
        const { sliders: L } = await cQ({
          loader: d,
          selections: h,
          use3d: b
        });
        M.channels = [...l], M.channels.forEach((N, k) => {
          N.slider = L[k];
        });
      }
      e(M);
      const O = aQ(d, { height: a, width: A }, 1.5, !0, new pn(u));
      s({
        ...O,
        rotationX: 0,
        rotationOrbit: 0
      });
    } else {
      const { sliders: Q } = await cQ({
        loader: d,
        selections: h,
        use3d: b
      }), w = [...l];
      w.forEach((M, O) => {
        M.slider = Q[O];
      }), e({
        resolution: v,
        use3d: b,
        spatialAxisFixed: !1,
        channels: w
      });
      const R = aQ(d, { height: a, width: A }, 0.5, !1, new pn(u));
      s({
        ...R,
        rotationX: null,
        rotationOrbit: null,
        orbitAxis: null
      });
    }
  }, { labels: m, shape: C } = Array.isArray(d) ? d[0] : d, y = C[m.indexOf("z")] > 1;
  return ne.jsx(ne.Fragment, { children: ne.jsxs(il, { native: !0, value: n, onChange: (v) => I(v.target.value === "2D" ? v.target.value : Number(v.target.value)), inputProps: { "aria-label": "Resolution selector" }, classes: { root: f.selectRoot }, children: [ne.jsx("option", { value: "2D", children: "2D Visualization" }, "2D"), Array.from({ length: d.length }).fill(0).map((v, b) => {
    if (d && uQ(d, b)) {
      const { height: Q, width: w, depthDownsampled: R, totalBytes: M } = qfe(d, b);
      return ne.jsx("option", { value: b, disabled: r || !y, children: `3D: ${b}x Downsampled, ~${G3e(M)} per channel, (${Q}, ${w}, ${R})` }, `(${Q}, ${w}, ${R})`);
    }
    return null;
  })] }) });
}
function jZn({ value: t, inputId: e, handleChange: n }) {
  const r = Md();
  return ne.jsxs(il, { native: !0, onChange: (i) => n(i.target.value === "" ? null : i.target.value), value: t, inputProps: { name: "colormap", id: e, "aria-label": "Colormap selector" }, style: { width: "100%" }, classes: { root: r.selectRoot }, children: [ne.jsx("option", { "aria-label": "None", value: "", children: "None" }), k3e.map((i) => ne.jsx("option", { value: i, children: i }, i))] });
}
function YZn({ value: t, inputId: e, handleChange: n }) {
  return ne.jsx(ds, { style: { float: "left", padding: 0 }, color: "default", onChange: () => {
    n(t ? null : [0, 0, 0]);
  }, checked: !!t, id: e, inputProps: { "aria-label": "Enable or disable color transparency" } });
}
function zZn({ value: t, inputId: e, handleChange: n }) {
  const r = dXe();
  return ne.jsx(ps, { classes: { valueLabel: r.valueLabel }, value: t, onChange: (i, o) => n(o), valueLabelDisplay: "auto", "aria-label": "Layer opacity slider", id: e, min: 0, max: 1, step: 0.01, orientation: "horizontal" });
}
function VZn({ value: t, inputId: e, handleChange: n }) {
  const r = Md();
  return ne.jsx(il, { native: !0, onChange: (i) => n(i.target.value), value: t, id: e, inputProps: { name: "domain-selector", "aria-label": "Domain type selector" }, style: { width: "100%" }, classes: { root: r.selectRoot }, children: $Zn.map((i) => ne.jsx("option", { value: i, children: i }, i)) });
}
function JZn({ field: t, value: e, inputId: n, handleChange: r, possibleValues: i }) {
  const o = MZn();
  return ne.jsx(ps, {
    classes: { root: o.selectionSliderRoot, markActive: o.markActive },
    value: e,
    // See https://github.com/hms-dbmi/viv/issues/176 for why
    // we have the two handlers.
    onChange: (s, a) => {
      r({ selection: { [t]: a }, event: s });
    },
    onChangeCommitted: (s, a) => {
      r({ selection: { [t]: a }, event: s });
    },
    valueLabelDisplay: "auto",
    "aria-label": `${t} slider`,
    id: n,
    marks: i.map((s) => ({ value: s })),
    min: Number(i[0]),
    max: Number(i.slice(-1)),
    orientation: "horizontal",
    step: null
  });
}
function F2({ name: t, inputId: e, children: n }) {
  return ne.jsxs(cn, { container: !0, direction: "row", alignItems: "center", justifyContent: "center", children: [ne.jsx(cn, { item: !0, xs: 6, children: ne.jsxs(EH, { htmlFor: e, children: [t, ":"] }) }), ne.jsx(cn, { item: !0, xs: 6, children: n })] });
}
function KZn({ colormap: t, opacity: e, handleColormapChange: n, handleOpacityChange: r, handleTransparentColorChange: i, globalControlLabels: o, globalLabelValues: s, handleGlobalChannelsSelectionChange: a, handleSliderChange: A, handleDomainChange: l, transparentColor: c, channels: u, domainType: f, disableChannelsIfRgbDetected: h, shouldShowTransparentColor: d, shouldShowDomain: I, shouldShowColormap: m, use3d: C, loader: y, handleMultiPropertyChange: v, resolution: b, disable3d: Q, setRasterLayerCallback: w, setAreAllChannelsLoading: R, setViewState: M, spatialHeight: O, spatialWidth: L, modelMatrix: N }) {
  const { labels: k, shape: $ } = Array.isArray(y.data) ? y.data[0] : y.data, U = k.length > 0 && u.length > 0, X = $[k.indexOf("z")] > 1, K = !!Array.from({
    length: y.data.length
  }).filter((ee, pe) => uQ(y.data, pe)).length, z = Jr(), Y = Jr(), V = Jr(), Z = Jr(), ce = Jr();
  return ne.jsxs(cn, { container: !0, direction: "column", style: { width: "100%" }, children: [X && !Q && K && ne.jsx(qZn, { loader: y, handleSliderChange: A, handleDomainChange: l, channels: u, handleMultiPropertyChange: v, resolution: b, disable3d: Q, setRasterLayerCallback: w, setAreAllChannelsLoading: R, setViewState: M, spatialHeight: O, spatialWidth: L, use3d: C, modelMatrix: N }), U && !C && o.map((ee) => $[k.indexOf(ee)] > 1 && ne.jsx(F2, { name: ee, inputId: `${ee}-${z}`, children: ne.jsx(JZn, { field: ee, inputId: `${ee}-${z}`, value: s[ee], handleChange: a, possibleValues: oA($[k.indexOf(ee)]) }) }, ee)), h ? null : ne.jsxs(ne.Fragment, { children: [m && ne.jsx(cn, { item: !0, children: ne.jsx(F2, { name: "Colormap", inputId: Y, children: ne.jsx(jZn, { value: t || "", inputId: Y, handleChange: n }) }) }), I && ne.jsx(cn, { item: !0, children: ne.jsx(F2, { name: "Domain", inputId: V, children: ne.jsx(VZn, { value: f || $We, inputId: V, handleChange: (ee) => {
    l(ee);
  } }) }) })] }), !C && ne.jsx(cn, { item: !0, children: ne.jsx(F2, { name: "Opacity", inputId: Z, children: ne.jsx(zZn, { value: e, handleChange: r, inputId: Z }) }) }), d && !C && ne.jsx(cn, { item: !0, children: ne.jsx(F2, { name: "Zero Transparent", inputId: ce, children: ne.jsx(YZn, { value: c, handleChange: i, inputId: ce }) }) })] });
}
const WZn = kr((t) => zpt({
  enabled: {},
  disabled: {
    color: t.palette.text.disabled,
    // Because of the .5 opacity of the disabled color in the theme, and the fact
    // that there are multiple overlaid parts to the slider,
    // this needs to be set manually for the desired effect.
    "& .MuiSlider-thumb": {
      color: "rgb(100, 100, 100, 1.0)"
    },
    "&  .MuiSlider-track": {
      color: "rgb(100, 100, 100, 1.0)"
    }
  }
})), XZn = ({ xSlice: t, ySlice: e, zSlice: n, handleSlicerSetting: r, loader: i, use3d: o }) => {
  const [s, a, A] = HWe(i.data), l = [
    [
      t,
      (f) => r("x", f),
      "x",
      s
    ],
    [
      e,
      (f) => r("y", f),
      "y",
      a
    ],
    [
      n,
      (f) => r("z", f),
      "z",
      A
    ]
  ], c = WZn(), u = l.map(([f, h, d, [I, m]]) => ne.jsxs(cn, { container: !0, direction: "row", justifyContent: "flex-start", alignItems: "center", children: [ne.jsx(cn, { item: !0, xs: 1, children: ne.jsxs(Mu, { className: o ? c.enabled : c.disabled, style: { marginBottom: 0 }, children: [d, ":"] }) }), ne.jsx(cn, { item: !0, xs: 11, children: ne.jsx(ps, { disabled: !o, className: o ? c.enabled : c.disabled, value: f, onChange: (C, y) => h(y), valueLabelDisplay: "auto", valueLabelFormat: (C) => Jq(C), "aria-label": `Volume options ${d} slider`, min: I, max: m, step: 5e-3, orientation: "horizontal" }) })] }, d));
  return ne.jsxs(ne.Fragment, { children: [ne.jsxs(Mu, { className: o ? c.enabled : c.disabled, style: { marginTop: 16, marginBottom: 0 }, children: ["Clipping Planes:", " "] }), " ", u] });
}, LNe = Object.values(Ife);
function ZZn({ handleRenderingModeChange: t, renderingMode: e, use3d: n }) {
  const r = Md(), i = n ? LNe : [...LNe, ""];
  return ne.jsxs(Kke, { fullWidth: !0, children: [ne.jsx(EH, { htmlFor: "rendering-mode-select", children: "Rendering Mode" }), ne.jsx(il, { native: !0, onChange: (o) => t(o.target.value), value: n ? e : "", inputProps: {
    name: "rendering-mode",
    id: "rendering-mode-select",
    "aria-label": "Select rendering mode option"
  }, disabled: !n, classes: { root: r.selectRoot }, children: i.map((o) => ne.jsx("option", { value: o, children: o }, o)) })] });
}
const eer = ({ setViewState: t, use3d: e, spatialHeight: n, spatialWidth: r, loader: i, modelMatrix: o }) => ne.jsx(cn, { item: !0, xs: "auto", children: ne.jsx(Dp, { onClick: () => {
  const s = aQ(i.data, { height: n, width: r }, 1.5, e, new pn(o));
  t({
    ...s,
    rotationX: 0,
    rotationOrbit: 0
  });
}, disabled: !e, style: {
  padding: 0,
  marginBottom: 6
}, children: "Re-Center" }) }, "recenter"), ter = ({ handleSlicerSetting: t, handleRenderingModeChange: e, renderingMode: n, xSlice: r, ySlice: i, zSlice: o, use3d: s, loader: a, setViewState: A, spatialHeight: l, spatialWidth: c, modelMatrix: u }) => ne.jsxs(ne.Fragment, { children: [ne.jsx(ZZn, { handleRenderingModeChange: e, renderingMode: n, use3d: s }), ne.jsx(XZn, { xSlice: r, ySlice: i, zSlice: o, handleSlicerSetting: t, use3d: s, loader: a }), ne.jsx(eer, { setViewState: A, use3d: s, spatialHeight: l, spatialWidth: c, loader: a, modelMatrix: u })] });
function MNe(t) {
  const { children: e, value: n, index: r, ...i } = t;
  return ne.jsx("div", { role: "tabpanel", hidden: n !== r, id: `simple-tabpanel-${r}`, "aria-labelledby": `simple-tab-${r}`, ...i, children: n === r && e });
}
async function c3(t, e, n, r) {
  let i;
  const o = await cQ({
    loader: t.data,
    selections: e,
    use3d: r
  }), { sliders: s } = o;
  if (n === "Min/Max" && (i = o.domains), n === "Full") {
    const a = I1(t);
    i = e.map(() => u5[a.dtype]);
  }
  return { domains: i, sliders: s };
}
const ONe = {
  borderStyle: "dashed",
  marginTop: "10px",
  fontWeight: 400
};
function FNe(t) {
  const { layer: e, name: n, loader: r, theme: i, handleLayerRemove: o, handleLayerChange: s, shouldShowTransparentColor: a, shouldShowDomain: A, shouldShowColormap: l, ChannelController: c, setViewState: u, disable3d: f, setImageLayerCallback: h, setAreLayerChannelsLoading: d, areLayerChannelsLoading: I, disabled: m, spatialHeight: C, spatialWidth: y, disableChannelsIfRgbDetected: v, shouldShowRemoveLayerButton: b } = t, { colormap: Q, opacity: w, channels: R, transparentColor: M, renderingMode: O, xSlice: L, ySlice: N, zSlice: k, resolution: $, use3d: U, modelMatrix: X } = e, K = Zr(R);
  Mn(() => {
    K.current = R;
  }, [R]);
  const z = Jr(), Y = R[0]?.selection || {}, { data: V, channels: Z } = r, [ce, ee] = mn(0), pe = (vt, It) => {
    ee(It);
  }, { labels: Ce, shape: Be } = Array.isArray(V) ? V[V.length - 1] : V, [Ie, Qe] = mn(e.domainType), [xe, Se] = mn(!0), [De, Ue] = mn(kD.filter((vt) => typeof Y[vt] == "number").reduce((vt, It) => ({ ...vt, [It]: Y[It] }), {}));
  function Te(vt) {
    s({ ...e, visible: vt });
  }
  function se(vt) {
    s({ ...e, colormap: vt });
  }
  function fe(vt) {
    s({ ...e, opacity: vt });
  }
  function W(vt) {
    s({ ...e, channels: vt });
  }
  function ge(vt) {
    s({ ...e, transparentColor: vt });
  }
  function _e(vt) {
    s({ ...e, renderingMode: vt });
  }
  function Re(vt) {
    s({ ...e, ...vt });
  }
  function Ee(vt, It) {
    s({ ...e, [`${vt}Slice`]: It });
  }
  function oe(vt, It) {
    s({
      ...e,
      channels: vt,
      domainType: It
    });
  }
  function ie(vt, It) {
    const un = [...K.current];
    un[It] = vt, s({ ...e, channels: un });
  }
  function Ae(vt) {
    const It = [...K.current, vt];
    s({ ...e, channels: It });
  }
  function de(vt) {
    const It = [...K.current];
    It.splice(vt, 1), s({ ...e, channels: It });
  }
  const we = (vt) => {
    const It = K.current.map(() => vt);
    d(It);
  }, Pe = async () => {
    const vt = {};
    Ce.forEach((jn) => {
      vt[jn] = kD.includes(jn) && De[jn] || 0;
    });
    const { domains: It, sliders: un } = await c3(r, [vt], Ie, U), We = It[0], En = [255, 255, 255], qn = !0, Pt = R.length, dr = [...I];
    dr[Pt] = !0, d(dr);
    const yr = {
      selection: vt,
      slider: We,
      visible: qn,
      color: En
    };
    h(() => {
      ie({ ...yr, slider: un[0] }, Pt);
      const jn = [...dr];
      jn[Pt] = !1, d(jn), h(null);
    }), Ae(yr);
  }, qe = async (vt) => {
    Qe(vt);
    const It = R.map((En) => En.selection);
    let un = R.map((En) => En.slider);
    const { domains: hn } = await c3(r, It, vt, U);
    un = un.map((En, qn) => {
      const [Pt, dr] = En;
      return [Math.max(Pt, hn[qn][0]), Math.min(dr, hn[qn][1])];
    });
    const We = R.map((En, qn) => ({ ...En, slider: un[qn] }));
    oe(We, vt);
  }, ke = async ({ selection: vt, event: It }) => {
    const un = R.map((We) => ({
      ...We.selection,
      ...vt
    }));
    (It.type === "mouseup" || It.type === "keydown") && (we(!0), c3(r, un, Ie, U).then(({ sliders: We }) => {
      const En = R.map((qn) => ({
        ...qn,
        selection: { ...qn.selection, ...vt }
      }));
      h(() => {
        h(null), we(!1);
        const qn = [...En].map((Pt, dr) => ({
          ...Pt,
          slider: We[dr]
        }));
        W(qn);
      }), W(En);
    })), Ue((We) => ({ ...We, ...vt }));
  };
  let Xe = [];
  if (Ce.length > 0) {
    const vt = Ce.find((It) => It === "channel" || It === "c") || Ce[0];
    Xe = R.map(
      // c is an object like { color, selection, slider, visible }.
      (It, un) => {
        const hn = (Pt) => {
          const dr = [...I];
          dr[un] = Pt, d(dr);
        }, We = (Pt, dr) => {
          const yr = { [Pt]: dr };
          Pt === "selection" ? (hn(!0), yr.selection = {
            ...De,
            ...yr.selection
          }, ie({ ...It, ...yr }, un), h(async () => {
            const jn = [
              { ...R[un][Pt], ...dr }
            ], { sliders: Ot } = await c3(r, jn, Ie, U);
            [yr.slider] = Ot, ie({ ...It, ...yr }, un), h(null), hn(!1);
          })) : ie({ ...It, ...yr }, un);
        }, En = () => {
          de(un);
        }, qn = async () => {
          const { data: Pt } = r, yr = await (Array.isArray(Pt) ? Pt[Pt.length - 1] : Pt).getRaster({
            selection: R[un].selection
          }), jn = OD(yr.data), { q1: Ot, q3: yn } = jn;
          ie({ ...It, slider: [Ot, yn] }, un);
        };
        return ne.jsx(
          c,
          { dimName: vt, visibility: It.visible, selectionIndex: It.selection[vt], slider: It.slider, color: It.color, channels: R, channelId: un, domainType: Ie, loader: r, globalLabelValues: De, theme: i, channelOptions: Z, colormapOn: !!Q, handlePropertyChange: We, handleChannelRemove: En, handleIQRUpdate: qn, setRasterLayerCallback: h, isLoading: I[un], use3d: U },
          `channel-controller-${un}`
        );
      }
    );
  }
  const rt = C1(), it = TZn(), ht = NZn(), mt = LZn(), { visible: _t } = e, zt = (typeof _t == "boolean" ? _t : !0) ? wL : xL, jt = !!Array.from({
    length: r.data.length
  }).filter((vt, It) => uQ(r.data, It)).length, lt = !f && Be[Ce.indexOf("z")] > 1 && jt, Ht = ne.jsxs(ne.Fragment, { children: [ne.jsx(KZn, {
    channels: R,
    opacity: w,
    colormap: Q,
    transparentColor: M,
    domainType: Ie,
    // Only allow for global dimension controllers that
    // exist in the `dimensions` part of the loader.
    globalControlLabels: Ce.filter((vt) => kD.includes(vt)),
    globalLabelValues: De,
    handleOpacityChange: fe,
    handleColormapChange: se,
    handleGlobalChannelsSelectionChange: ke,
    handleTransparentColorChange: ge,
    disableChannelsIfRgbDetected: oS(r, R) && v,
    handleDomainChange: qe,
    shouldShowTransparentColor: a,
    shouldShowDomain: A,
    shouldShowColormap: l,
    use3d: U,
    loader: r,
    handleMultiPropertyChange: Re,
    resolution: $,
    disable3d: f,
    setRasterLayerCallback: h,
    setAreAllChannelsLoading: we,
    setViewState: u,
    spatialHeight: C,
    spatialWidth: y,
    modelMatrix: X
  }), oS(r, R) && v ? null : Xe, oS(r, R) && v ? null : ne.jsx(Dp, { disabled: R.length === wq, onClick: Pe, fullWidth: !0, variant: "outlined", style: ONe, startIcon: ne.jsx(Kae, {}), size: "small", children: "Add Channel" })] });
  return ne.jsxs(v0t, { className: rt.layerControllerRoot, onChange: (vt, It) => !m && Se(It && vt?.target?.attributes?.role?.value === "presentation"), TransitionProps: { enter: !1 }, expanded: !m && xe, id: `layer-controls-accordion-${z}`, children: [ne.jsx(P0t, { classes: {
    root: it.accordionSummaryRoot,
    content: it.content,
    expanded: it.expanded,
    expandIcon: it.expandIcon
  }, expandIcon: ne.jsx(O8e, { role: "presentation" }), "aria-controls": `layer-${n}-controls`, "aria-expanded": xe, children: ne.jsxs(cn, { container: !0, direction: "column", m: 1, justifyContent: "center", children: [ne.jsxs(cn, { item: !0, classes: { item: mt.item }, children: [ne.jsx(Dp, { "aria-label": "Toggle layer visibility", onClick: (vt) => {
    m || (vt.stopPropagation(), Te(typeof _t == "boolean" ? !_t : !1));
  }, style: {
    marginRight: 8,
    marginBottom: 2,
    padding: 0,
    minWidth: 0
  }, children: ne.jsx(zt, {}) }), n] }), !m && !xe && !U && ne.jsxs(cn, { container: !0, direction: "row", alignItems: "center", justifyContent: "center", children: [ne.jsx(cn, { item: !0, xs: 6, children: ne.jsx(EH, { htmlFor: `layer-${n}-opacity-closed`, classes: { root: ht.inputLabelRoot }, children: "Opacity:" }) }), ne.jsx(cn, { item: !0, xs: 6, children: ne.jsx(ps, { id: `layer-${n}-opacity-closed`, value: w, onChange: (vt, It) => fe(It), valueLabelDisplay: "auto", "aria-label": `Adjust opacity for layer ${n}`, min: 0, max: 1, step: 0.01, orientation: "horizontal" }) })] })] }) }), ne.jsxs(_0t, { classes: { root: it.accordionDetailsRoot }, id: `layer-${n}-controls`, children: [lt ? ne.jsxs(ne.Fragment, { children: [ne.jsxs(EEt, { value: ce, onChange: pe, "aria-label": "Change the layer tab type", style: { height: "24px", minHeight: "24px" }, children: [ne.jsx(NCe, { label: "Channels", "aria-label": "Channels tab", style: {
    fontSize: ".75rem",
    bottom: 12,
    width: "50%",
    minWidth: "50%"
  }, disableRipple: !0 }), ne.jsx(NCe, { label: "Volume", "aria-label": "Volume tab", style: {
    fontSize: ".75rem",
    bottom: 12,
    width: "50%",
    minWidth: "50%"
  } })] }), ne.jsx(MNe, { value: ce, index: 0, children: Ht }), ne.jsx(MNe, { value: ce, index: 1, style: { marginTop: 4 }, children: ne.jsx(ter, { loader: r, handleSlicerSetting: Ee, handleRenderingModeChange: _e, renderingMode: O, xSlice: L, ySlice: N, zSlice: k, use3d: U, setViewState: u, spatialHeight: C, spatialWidth: y, modelMatrix: X }) })] }) : Ht, b ? ne.jsx(Dp, { onClick: o, fullWidth: !0, variant: "outlined", style: ONe, size: "small", children: "Remove Image Layer" }) : null] })] });
}
const ner = kr(() => ({
  addButton: {
    marginTop: "10px",
    marginBottom: "10px",
    fontWeight: 400
  }
}));
function rer() {
  return ne.jsxs(ne.Fragment, { children: [ne.jsx(Kae, {}), "Add Image Layer"] });
}
function ier({ imageOptions: t, handleImageAdd: e }) {
  const [n, r] = mn(!1), i = ner(), o = (s) => {
    r((a) => !a), e(s);
  };
  return t ? ne.jsx(s0, { open: n, setOpen: r, buttonIcon: ne.jsx(rer, {}), buttonClassName: i.addButton, placement: "bottom-start", "aria-label": "Add image menu", children: t.map((s, a) => ne.jsx(mi, { dense: !0, onClick: () => o(a), children: ne.jsx("span", { children: s.name }) }, s.name)) }) : null;
}
const oer = St.memo(CE((t, e) => {
  const {
    title: n,
    closeButtonVisible: r,
    downloadButtonVisible: i,
    removeGridComponent: o,
    theme: s,
    isReady: a,
    dataset: A,
    obsType: l,
    moleculesLayer: c,
    setMoleculesLayer: u,
    cellsLayer: f,
    // May be one polygon layer object or an array of bitmask layers.
    setCellsLayer: h,
    rasterLayers: d,
    imageLayerLoaders: I,
    imageLayerMeta: m,
    imageLayerCallbacks: C,
    setImageLayerCallbacks: y,
    areLoadingImageChannels: v,
    setAreLoadingImageChannels: b,
    handleRasterLayerChange: Q,
    handleRasterLayerRemove: w,
    obsSegmentationsType: R,
    segmentationLayerLoaders: M,
    segmentationLayerMeta: O,
    segmentationLayerCallbacks: L,
    setSegmentationLayerCallbacks: N,
    areLoadingSegmentationChannels: k,
    setAreLoadingSegmentationChannels: $,
    handleSegmentationLayerChange: U,
    handleSegmentationLayerRemove: X,
    disable3d: K,
    globalDisable3d: z,
    disableChannelsIfRgbDetected: Y,
    layerIs3DIndex: V,
    setZoom: Z,
    setTargetX: ce,
    setTargetY: ee,
    setTargetZ: pe,
    setRotationX: Ce,
    setRotationOrbit: Be,
    componentHeight: Ie,
    componentWidth: Qe,
    spatialLayout: xe,
    handleImageAdd: Se,
    enableLayerButtonsWithOneLayer: De
  } = t, Ue = !!(De || I?.length > 1);
  return ne.jsx(fc, { title: n, isScroll: !0, closeButtonVisible: r, downloadButtonVisible: i, removeGridComponent: o, theme: s, isReady: a, children: ne.jsxs("div", { className: "layer-controller-container", ref: e, children: [c && ne.jsx(NNe, { label: "Molecules", layerType: "molecules", layer: c, handleLayerChange: u }, `${A}-molecules`), f && R === "polygon" && ne.jsx(NNe, { label: `${Ci(l)} Segmentations`, layerType: "cells", layer: f, handleLayerChange: h }, `${A}-cells`), f && R === "bitmask" && f.map((Te, se) => {
    const { index: fe } = Te, W = M?.[fe], ge = O?.[fe], _e = !1, Re = (ie) => {
      const Ae = [
        ...C || []
      ];
      Ae[se] = ie, N(Ae);
    }, Ee = (k || [])[se] || [], oe = (ie) => {
      const Ae = [
        ...k || []
      ];
      Ae[se] = ie, $(Ae);
    };
    return W && ge ? ne.jsx(
      cn,
      { item: !0, style: { marginTop: "10px" }, children: ne.jsx(FNe, {
        name: ge.name,
        layer: Te,
        loader: W,
        theme: s,
        handleLayerChange: (ie) => U(ie, se),
        handleLayerRemove: () => X(se),
        ChannelController: HZn,
        shouldShowTransparentColor: _e,
        shouldShowDomain: _e,
        shouldShowColormap: _e,
        // Disable 3D if given explicit instructions to do so
        // or if another layer is using 3D mode.
        disable3d: z || (K || []).indexOf(ge.name) >= 0 || typeof V == "number" && V !== -1 && V !== se,
        disabled: typeof V == "number" && V !== -1 && V !== se,
        disableChannelsIfRgbDetected: Y,
        imageLayerCallbacks: C,
        setImageLayerCallback: Re,
        setViewState: ({ zoom: ie, target: Ae, rotationX: de, rotationOrbit: we }) => {
          Z(ie), ce(Ae[0]), ee(Ae[1]), pe(Ae[2]), Ce(de), Be(we);
        },
        setAreLayerChannelsLoading: oe,
        areLayerChannelsLoading: Ee,
        spatialHeight: Ie * (xe ? xe.h : 1) / 12,
        spatialWidth: Qe * (xe ? xe.w : 1) / 12,
        shouldShowRemoveLayerButton: Ue
      }) },
      `${A}-raster-${fe}-${se}`
    ) : null;
  }), d && d.map((Te, se) => {
    const { index: fe } = Te, W = I?.[fe], ge = m?.[fe], _e = !0, Re = (ie) => {
      const Ae = [
        ...C || []
      ];
      Ae[se] = ie, y(Ae);
    }, Ee = (v || [])[se] || [], oe = (ie) => {
      const Ae = [
        ...v || []
      ];
      Ae[se] = ie, b(Ae);
    };
    return W && ge ? ne.jsx(
      cn,
      { item: !0, style: { marginTop: "10px" }, children: ne.jsx(FNe, {
        name: ge.name,
        layer: Te,
        loader: W,
        theme: s,
        handleLayerChange: (ie) => Q(ie, se),
        handleLayerRemove: () => w(se),
        ChannelController: UZn,
        shouldShowTransparentColor: _e,
        shouldShowDomain: _e,
        shouldShowColormap: _e,
        // Disable 3D if given explicit instructions to do so
        // or if another layer is using 3D mode.
        disable3d: z || (K || []).indexOf(ge.name) >= 0 || typeof V == "number" && V !== -1 && V !== se,
        disabled: typeof V == "number" && V !== -1 && V !== se,
        disableChannelsIfRgbDetected: Y,
        imageLayerCallbacks: C,
        setImageLayerCallback: Re,
        setViewState: ({ zoom: ie, target: Ae, rotationX: de, rotationOrbit: we }) => {
          Z(ie), ce(Ae[0]), ee(Ae[1]), pe(Ae[2]), Ce(de), Be(we);
        },
        setAreLayerChannelsLoading: oe,
        areLayerChannelsLoading: Ee,
        spatialHeight: Ie * (xe ? xe.h : 1) / 12,
        spatialWidth: Qe * (xe ? xe.w : 1) / 12,
        shouldShowRemoveLayerButton: Ue
      }) },
      `${A}-raster-${fe}-${se}`
    ) : null;
  }), Ue ? ne.jsx(cn, { item: !0, children: ne.jsx(ier, { imageOptions: m, handleImageAdd: Se }) }) : null] }) });
}));
function ser(t) {
  const { coordinationScopes: e, closeButtonVisible: n, downloadButtonVisible: r, removeGridComponent: i, theme: o, title: s = "Spatial Layers", disable3d: a, globalDisable3d: A, disableChannelsIfRgbDetected: l, enableLayerButtonsWithOneLayer: c } = t, u = eu(), [{ dataset: f, obsType: h, spatialImageLayer: d, spatialSegmentationLayer: I, spatialPointLayer: m }, { setSpatialImageLayer: C, setSpatialSegmentationLayer: y, setSpatialPointLayer: v, setSpatialTargetX: b, setSpatialTargetY: Q, setSpatialTargetZ: w, setSpatialRotationX: R, setSpatialRotationOrbit: M, setSpatialZoom: O }] = uc(ea[Gn.LAYER_CONTROLLER], e), [{ imageLayerCallbacks: L, areLoadingImageChannels: N, segmentationLayerCallbacks: k, areLoadingSegmentationChannels: $ }, { setImageLayerCallbacks: U, setAreLoadingImageChannels: X, setSegmentationLayerCallbacks: K, setAreLoadingSegmentationChannels: z }] = vae(ea.layerController, e), [Y] = pUe("spatial", ["spatialImageLayer"], e), V = Zr(), [Z, ce] = Yae(V), { height: ee, width: pe } = D8e(), [Ce, Be] = WZ(u, f, !1, { setSpatialPointLayer: v }, { spatialPointLayer: m }, {}), [{ obsSegmentations: Ie, obsSegmentationsType: Qe }, xe] = P8e(u, f, !1, { setSpatialSegmentationLayer: y }, { spatialSegmentationLayer: I }, {}), [{ image: Se }, De] = Zae(u, f, !1, { setSpatialImageLayer: C }, { spatialImageLayer: d }, {}), { loaders: Ue, meta: Te } = Se || {}, se = Jc([
    Be,
    xe,
    De
  ]), fe = Ie && Qe === "bitmask" ? Ie.loaders : null, W = Ie && Qe === "bitmask" ? Ie.meta : null, ge = Qn(async (Ae) => {
    const de = Ue[Ae], we = await Sre(de, (d[Ae] || {}).use3d), Pe = {
      index: Ae,
      modelMatrix: Te[Ae]?.metadata?.transform?.matrix,
      ..._re,
      channels: we,
      type: Te[Ae]?.metadata?.isBitmask ? "bitmask" : "raster"
    }, qe = [...d, Pe];
    C(qe);
  }, [Ue, Te, d, C]), _e = Qn((Ae, de) => {
    const we = [...d];
    we[de] = Ae, C(we);
  }, [d, C]), Re = Qn((Ae) => {
    const de = [...d];
    de.splice(Ae, 1), C(de);
  }, [d, C]), Ee = Qn((Ae, de) => {
    const we = [...I];
    we[de] = Ae, y(we);
  }, [I, y]), oe = Qn((Ae) => {
    const de = [...I];
    de.splice(Ae, 1), y(de);
  }, [I, y]), ie = d?.findIndex && d.findIndex((Ae) => Ae.use3d);
  return ne.jsx(oer, {
    ref: V,
    title: s,
    closeButtonVisible: n,
    downloadButtonVisible: r,
    removeGridComponent: i,
    theme: o,
    isReady: se,
    moleculesLayer: m,
    dataset: f,
    obsType: h,
    setMoleculesLayer: v,
    cellsLayer: I,
    setCellsLayer: y,
    rasterLayers: d,
    imageLayerLoaders: Ue,
    imageLayerMeta: Te,
    imageLayerCallbacks: L,
    setImageLayerCallbacks: U,
    areLoadingImageChannels: N,
    setAreLoadingImageChannels: X,
    handleRasterLayerChange: _e,
    handleRasterLayerRemove: Re,
    obsSegmentationsType: Qe,
    segmentationLayerLoaders: fe,
    segmentationLayerMeta: W,
    segmentationLayerCallbacks: k,
    setSegmentationLayerCallbacks: K,
    areLoadingSegmentationChannels: $,
    setAreLoadingSegmentationChannels: z,
    handleSegmentationLayerChange: Ee,
    handleSegmentationLayerRemove: oe,
    disable3d: a,
    globalDisable3d: A,
    layerIs3DIndex: ie,
    disableChannelsIfRgbDetected: l,
    enableLayerButtonsWithOneLayer: c,
    setZoom: O,
    setTargetX: b,
    setTargetY: Q,
    setTargetZ: w,
    setRotationX: R,
    setRotationOrbit: M,
    // Fall back to window for height and width.
    componentHeight: ce || ee,
    componentWidth: Z || pe,
    spatialLayout: Y,
    handleImageAdd: ge
  });
}
const om = kr(() => ({
  imageLayerMenuLabel: {
    margin: "0 5px"
  },
  imageLayerMenuButton: {
    backgroundColor: "transparent",
    padding: "3px 0"
  },
  imageLayerPopperContainer: {
    display: "flex",
    marginTop: "5px",
    justifyContent: "space-around"
  },
  imageLayerVisibleButton: {
    marginLeft: 0,
    height: "100%",
    padding: 0,
    minWidth: 0
  },
  imageLayerName: {
    padding: 0,
    marginBottom: "0 !important",
    marginLeft: "4px",
    marginTop: "10px !important"
  },
  imageLayerOpacitySlider: {
    marginTop: "7px"
  },
  menuItemSlider: {
    width: "100px"
  }
})), aer = kr(() => ({
  colorIcon: {
    width: "18px !important",
    height: "18px !important",
    cursor: "pointer",
    position: "relative",
    outline: "none",
    float: "left",
    borderRadius: "4px",
    margin: "8px"
  },
  colorIconOutline: {
    border: "1px solid silver"
  },
  colorIconButton: {
    height: "100%"
  },
  colorPicker: {
    boxShadow: "none !important",
    margin: "0 auto",
    /* Sets margins around color picker and centers */
    "& > div:nth-child(3)": {
      padding: "6px !important",
      transform: "translate(2px, 0)"
    },
    "& > div > div:nth-of-type(1)": {
      fontSize: "12px",
      width: "20px !important"
    },
    "& input": {
      width: "60px !important",
      fontSize: "12px"
    },
    /* Sets smaller color squares */
    "& > div > span > div": {
      width: "18px !important",
      height: "18px !important"
    },
    '& > div > span > div[title="#ffffff"]': {
      border: "1px solid silver"
    }
  }
}));
function ij(t) {
  const { theme: e, color: n, setColor: r, palette: i = null, isStaticColor: o, isColormap: s, featureValueColormap: a, visible: A } = t, l = i ? i.map(Qu) : iut.map(Qu), [c, u] = mn(!1);
  function f({ rgb: I }) {
    I && r && r([I.r, I.g, I.b]);
  }
  const h = aer(), d = Qu(n || da(e));
  return ne.jsx(s0, { open: o && A ? c : !1, setOpen: u, buttonIcon: o && A ? ne.jsx("div", { className: Xt(h.colorIcon, {
    [h.colorIconOutline]: e === "light" && gr(n, [255, 255, 255])
  }), style: { backgroundColor: d } }) : s && A && a ? ne.jsx("div", { className: h.colorIcon, children: ne.jsx("svg", { width: "18", height: "18", children: ne.jsx("image", { x: 0, y: 0, width: 18, height: 18, preserveAspectRatio: "none", href: XKe(a), clipPath: "inset(0% round 4px)" }) }) }) : ne.jsx("div", { className: h.colorIcon }), buttonClassName: h.colorIconButton, withPaper: !1, "aria-label": "Open color picker menu", children: ne.jsx(XHe, { className: h.colorPicker, disableAlpha: !0, width: 108, triangle: "hide", colors: l, color: d, onChangeComplete: f }) });
}
const mXe = kr(() => ({
  layerTypeSpotIcon: {
    height: "100%",
    marginLeft: "1px",
    fill: "currentColor",
    fontSize: "20px",
    width: "50%",
    maxWidth: "20px"
  }
}));
function Aer(t) {
  const { strokeWidth: e, setStrokeWidth: n, filled: r, setFilled: i, featureSelection: o, obsColorEncoding: s, setObsColorEncoding: a, featureValueColormapRange: A, setFeatureValueColormapRange: l, tooltipsVisible: c, setTooltipsVisible: u, tooltipCrosshairsVisible: f, setTooltipCrosshairsVisible: h, legendVisible: d, setLegendVisible: I } = t, [m, C] = mn(!1);
  mXe();
  const y = Md(), v = om(), b = Jr(), Q = Jr(), w = Jr(), R = Jr(), M = Jr(), O = Jr(), L = Jr();
  return ne.jsxs(s0, { open: m, setOpen: C, buttonIcon: ne.jsx(fw, {}), buttonClassName: v.imageLayerMenuButton, containerClassName: v.imageLayerPopperContainer, withPaper: !0, "aria-label": "Open spot layer options menu", children: [ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: v.imageLayerMenuLabel, htmlFor: b, children: "Filled: " }), ne.jsx(ds, { color: "primary", checked: r, onChange: (N, k) => i(k), inputProps: { id: b, "aria-label": "Toggle between filled and stroked spots" } })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: v.imageLayerMenuLabel, htmlFor: Q, children: "Stroke Width:" }), ne.jsx(ps, { disabled: r, value: e, min: 0.01, max: 5, step: 0.01, onChange: (N, k) => n(k), className: v.menuItemSlider, orientation: "horizontal", id: Q, "aria-label": "Stroke width slider" })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: v.imageLayerMenuLabel, htmlFor: w, children: "Color Encoding: " }), ne.jsxs(il, { native: !0, onChange: (N) => a(N.target.value), value: s, inputProps: { id: w, "aria-label": "Color encoding selector" }, classes: { root: y.selectRoot }, children: [ne.jsx("option", { value: "spatialLayerColor", children: "Static Color" }), ne.jsx("option", { value: "geneSelection", children: "Feature Value" }), ne.jsx("option", { value: "cellSetSelection", children: "Set Selection" })] })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: v.imageLayerMenuLabel, htmlFor: R, children: "Colormap Range: " }), ne.jsx(ps, { disabled: s !== "geneSelection", value: A, min: 0, max: 1, step: 0.01, onChange: (N, k) => l(k), className: v.menuItemSlider, orientation: "horizontal", id: R, getAriaLabel: (N) => N === 0 ? "Low value colormap range slider" : "High value colormap range slider" })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: v.imageLayerMenuLabel, htmlFor: M, children: "Tooltips Visible: " }), ne.jsx(ds, { color: "primary", checked: c, onChange: (N, k) => u(k), inputProps: { id: M, "aria-label": "Toggle tooltip visibility" } })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: v.imageLayerMenuLabel, htmlFor: O, children: "Tooltip Crosshairs Visible: " }), ne.jsx(ds, { color: "primary", checked: f, onChange: (N, k) => h(k), inputProps: { id: O, "aria-label": "Toggle tooltip crosshair visibility" } })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: v.imageLayerMenuLabel, htmlFor: L, children: "Legend Visible: " }), ne.jsx(ds, { color: "primary", checked: d, onChange: (N, k) => I(k), inputProps: { id: L, "aria-label": "Toggle legend visibility" } })] })] });
}
function ler(t) {
  const { theme: e, layerScope: n, layerCoordination: r, setLayerCoordination: i, palette: o = null } = t, { obsType: s, spatialLayerVisible: a, spatialLayerOpacity: A, spatialSpotRadius: l, spatialSpotFilled: c, spatialSpotStrokeWidth: u, spatialLayerColor: f, obsColorEncoding: h, featureSelection: d, featureValueColormap: I, featureValueColormapRange: m, tooltipsVisible: C, tooltipCrosshairsVisible: y, legendVisible: v } = r, { setSpatialLayerVisible: b, setSpatialLayerOpacity: Q, setSpatialSpotRadius: w, setSpatialSpotFilled: R, setSpatialSpotStrokeWidth: M, setSpatialLayerColor: O, setObsColorEncoding: L, setFeatureSelection: N, setFeatureValueColormap: k, setFeatureValueColormapRange: $, setTooltipsVisible: U, setTooltipCrosshairsVisible: X, setLegendVisible: K } = i, z = Ci(s), Y = typeof a == "boolean" ? a : !0, V = dt(() => Y ? wL : xL, [Y]), Z = h === "spatialLayerColor", ce = h === "geneSelection", ee = mXe(), pe = C1(), Ce = om(), Be = Qn(() => {
    b(typeof a == "boolean" ? !a : !1);
  }, [a, b]), Ie = Qn((Qe, xe) => Q(xe), [Q]);
  return ne.jsx(cn, { item: !0, className: pe.layerControllerGrid, children: ne.jsx(r0, { className: pe.layerControllerRoot, children: ne.jsxs(cn, { container: !0, direction: "row", justifyContent: "space-between", children: [ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(Dp, { onClick: Be, className: Ce.imageLayerVisibleButton, "aria-label": "Toggle spot layer visibility", children: ne.jsx(V, {}) }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(ij, { theme: e, color: f, setColor: O, palette: o, isStaticColor: Z, isColormap: ce, featureValueColormap: I, visible: a }) }), ne.jsx(cn, { item: !0, xs: 6, children: ne.jsx(Mu, { className: Ce.imageLayerName, children: z }) }), ne.jsx(cn, { item: !0, xs: 2, children: ne.jsx(ps, { value: A, min: 0, max: 1, step: 1e-3, onChange: Ie, className: Ce.imageLayerOpacitySlider, orientation: "horizontal", "aria-label": `Adjust opacity for layer ${z}` }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(Aer, { filled: c, setFilled: R, strokeWidth: u, setStrokeWidth: M, featureSelection: d, obsColorEncoding: h, setObsColorEncoding: L, featureValueColormapRange: m, setFeatureValueColormapRange: $, tooltipsVisible: C, setTooltipsVisible: U, tooltipCrosshairsVisible: y, setTooltipCrosshairsVisible: X, legendVisible: v, setLegendVisible: K }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(j6t, { className: ee.layerTypeSpotIcon }) })] }) }) });
}
const cer = kr(() => ({
  layerTypePointIcon: {
    height: "100%",
    marginLeft: "1px",
    fill: "currentColor",
    fontSize: "20px",
    width: "50%",
    maxWidth: "20px"
  }
}));
function uer(t) {
  const { featureSelection: e, obsColorEncoding: n, setObsColorEncoding: r, featureValueColormapRange: i, setFeatureValueColormapRange: o, tooltipsVisible: s, setTooltipsVisible: a, tooltipCrosshairsVisible: A, setTooltipCrosshairsVisible: l, legendVisible: c, setLegendVisible: u } = t, [f, h] = mn(!1), d = Md(), I = om(), m = Jr(), C = Jr(), y = Jr(), v = Jr(), b = Jr();
  return ne.jsxs(s0, { open: f, setOpen: h, buttonIcon: ne.jsx(fw, {}), buttonClassName: I.imageLayerMenuButton, containerClassName: I.imageLayerPopperContainer, withPaper: !0, "aria-label": "Open point layer options menu", children: [ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: I.imageLayerMenuLabel, htmlFor: m, children: "Color Encoding: " }), ne.jsxs(il, { native: !0, onChange: (Q) => r(Q.target.value), value: n, inputProps: { id: m, "aria-label": "Color encoding selector" }, classes: { root: d.selectRoot }, children: [ne.jsx("option", { value: "spatialLayerColor", children: "Static Color" }), ne.jsx("option", { value: "obsLabels", children: "Label Value" })] })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: I.imageLayerMenuLabel, htmlFor: C, children: "Colormap Range: " }), ne.jsx(ps, { disabled: n !== "geneSelection", value: i, min: 0, max: 1, step: 0.01, onChange: (Q, w) => o(w), className: I.menuItemSlider, orientation: "horizontal", id: C, getAriaLabel: (Q) => Q === 0 ? "Low value colormap range slider" : "High value colormap range slider" })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: I.imageLayerMenuLabel, htmlFor: y, children: "Tooltips Visible: " }), ne.jsx(ds, { color: "primary", checked: s, onChange: (Q, w) => a(w), inputProps: { id: y, "aria-label": "Toggle tooltip visibility" } })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: I.imageLayerMenuLabel, htmlFor: v, children: "Tooltip Crosshairs Visible: " }), ne.jsx(ds, { color: "primary", checked: A, onChange: (Q, w) => l(w), inputProps: { id: v, "aria-label": "Toggle tooltip crosshair visibility" } })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: I.imageLayerMenuLabel, htmlFor: b, children: "Legend Visible: " }), ne.jsx(ds, { color: "primary", checked: c, onChange: (Q, w) => u(w), inputProps: { id: b, "aria-label": "Toggle legend visibility" } })] })] });
}
function fer(t) {
  const { theme: e, layerScope: n, layerCoordination: r, setLayerCoordination: i, palette: o = null } = t, { obsType: s, spatialLayerVisible: a, spatialLayerOpacity: A, obsColorEncoding: l, featureSelection: c, featureValueColormap: u, featureValueColormapRange: f, spatialLayerColor: h, tooltipsVisible: d, tooltipCrosshairsVisible: I, legendVisible: m } = r, { setSpatialLayerVisible: C, setSpatialLayerOpacity: y, setObsColorEncoding: v, setFeatureSelection: b, setFeatureValueColormap: Q, setFeatureValueColormapRange: w, setSpatialLayerColor: R, setTooltipsVisible: M, setTooltipCrosshairsVisible: O, setLegendVisible: L } = i, N = Ci(s), k = typeof a == "boolean" ? a : !0, $ = dt(() => k ? wL : xL, [k]), U = l === "spatialLayerColor", X = l === "geneSelection", K = cer(), z = C1(), Y = om(), V = Qn(() => {
    C(typeof a == "boolean" ? !a : !1);
  }, [a, C]), Z = Qn((ce, ee) => y(ee), [y]);
  return ne.jsx(cn, { item: !0, className: z.layerControllerGrid, children: ne.jsx(r0, { className: z.layerControllerRoot, children: ne.jsxs(cn, { container: !0, direction: "row", justifyContent: "space-between", children: [ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(Dp, { onClick: V, className: Y.imageLayerVisibleButton, "aria-label": "Toggle layer visibility", children: ne.jsx($, {}) }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(ij, { theme: e, color: h, setColor: R, palette: o, isStaticColor: U, isColormap: X, featureValueColormap: u, visible: a }) }), ne.jsx(cn, { item: !0, xs: 6, children: ne.jsx(Mu, { className: Y.imageLayerName, children: N }) }), ne.jsx(cn, { item: !0, xs: 2, children: ne.jsx(ps, { value: A, min: 0, max: 1, step: 1e-3, onChange: Z, className: Y.imageLayerOpacitySlider, orientation: "horizontal", "aria-label": `Adjust opacity for layer ${N}` }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(uer, { featureSelection: c, obsColorEncoding: l, setObsColorEncoding: v, featureValueColormapRange: f, setFeatureValueColormapRange: w, tooltipsVisible: d, setTooltipsVisible: M, tooltipCrosshairsVisible: I, setTooltipCrosshairsVisible: O, legendVisible: m, setLegendVisible: L }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(Y6t, { className: K.layerTypePointIcon }) })] }) }) });
}
const CXe = kr(() => ({
  layerTypeSegmentationIcon: {
    height: "100%",
    marginLeft: "1px",
    fill: "currentColor",
    fontSize: "24px",
    width: "50%",
    maxWidth: "24px"
  }
}));
function ger(t) {
  const { obsType: e, featureType: n, featureValueType: r, strokeWidth: i, setStrokeWidth: o, filled: s, setFilled: a, featureSelection: A, obsColorEncoding: l, setObsColorEncoding: c, featureValueColormapRange: u, setFeatureValueColormapRange: f, tooltipsVisible: h, setTooltipsVisible: d, tooltipCrosshairsVisible: I, setTooltipCrosshairsVisible: m, legendVisible: C, setLegendVisible: y } = t, [v, b] = mn(!1);
  CXe();
  const Q = Md(), w = om(), R = Jr(), M = Jr(), O = Jr(), L = Jr(), N = Jr(), k = Jr(), $ = Jr();
  return ne.jsxs(s0, { open: v, setOpen: b, buttonIcon: ne.jsx(fw, {}), buttonClassName: w.imageLayerMenuButton, containerClassName: w.imageLayerPopperContainer, withPaper: !0, "aria-label": "Open segmentation channel options menu", children: [ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: w.imageLayerMenuLabel, htmlFor: R, children: "Filled: " }), ne.jsx(ds, { color: "primary", checked: s, onChange: (U, X) => a(X), inputProps: { id: R, "aria-label": "Toggle between filled and stroked segmentations" } })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: w.imageLayerMenuLabel, htmlFor: M, children: "Stroke Width:" }), ne.jsx(ps, { disabled: s, value: i, min: 0.01, max: 5, step: 0.01, onChange: (U, X) => o(X), className: w.menuItemSlider, orientation: "horizontal", id: M, "aria-label": "Stroke width slider" })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: w.imageLayerMenuLabel, htmlFor: O, children: "Color Encoding: " }), ne.jsxs(il, { native: !0, onChange: (U) => c(U.target.value), value: l, inputProps: { id: O, "aria-label": "Color encoding selector" }, classes: { root: Q.selectRoot }, children: [ne.jsx("option", { value: "spatialChannelColor", children: "Static Color" }), ne.jsx("option", { value: "geneSelection", children: "Feature Value" }), ne.jsx("option", { value: "cellSetSelection", children: "Set Selection" })] })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: w.imageLayerMenuLabel, htmlFor: L, children: "Colormap Range: " }), ne.jsx(ps, { disabled: l !== "geneSelection", value: u, min: 0, max: 1, step: 0.01, onChange: (U, X) => f(X), className: w.menuItemSlider, orientation: "horizontal", id: L, getAriaLabel: (U) => U === 0 ? "Low value colormap range slider" : "High value colormap range slider" })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: w.imageLayerMenuLabel, htmlFor: N, children: "Tooltips Visible: " }), ne.jsx(ds, { color: "primary", checked: h, onChange: (U, X) => d(X), inputProps: { id: N, "aria-label": "Toggle tooltip visibility" } })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: w.imageLayerMenuLabel, htmlFor: k, children: "Tooltip Crosshairs Visible: " }), ne.jsx(ds, { color: "primary", checked: I, onChange: (U, X) => m(X), inputProps: { id: k, "aria-label": "Toggle tooltip crosshair visibility" } })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: w.imageLayerMenuLabel, htmlFor: $, children: "Legend Visible: " }), ne.jsx(ds, { color: "primary", checked: C, onChange: (U, X) => y(X), inputProps: { id: $, "aria-label": "Toggle legend visibility" } })] })] });
}
function her(t) {
  const {
    label: e,
    theme: n,
    obsType: r,
    featureType: i,
    featureValueType: o,
    opacity: s,
    setOpacity: a,
    visible: A,
    setVisible: l,
    color: c,
    setColor: u,
    palette: f = null,
    filled: h,
    setFilled: d,
    strokeWidth: I,
    setStrokeWidth: m,
    featureSelection: C,
    obsColorEncoding: y,
    featureValueColormap: v,
    featureValueColormapRange: b,
    setObsColorEncoding: Q,
    // setFeatureValueColormap, // TODO
    setFeatureValueColormapRange: w,
    tooltipsVisible: R,
    setTooltipsVisible: M,
    tooltipCrosshairsVisible: O,
    setTooltipCrosshairsVisible: L,
    legendVisible: N,
    setLegendVisible: k
  } = t, $ = typeof A == "boolean" ? A : !0, U = dt(() => $ ? wL : xL, [$]), X = y === "spatialChannelColor", K = y === "geneSelection", z = CXe(), Y = C1(), V = om(), Z = Qn(() => {
    l(typeof A == "boolean" ? !A : !1);
  }, [A, l]), ce = Qn((ee, pe) => a(pe), [a]);
  return ne.jsx(cn, { item: !0, className: Y.layerControllerGrid, children: ne.jsx(r0, { className: Y.layerControllerRoot, children: ne.jsxs(cn, { container: !0, direction: "row", justifyContent: "space-between", children: [ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(Dp, { onClick: Z, className: V.imageLayerVisibleButton, "aria-label": "Toggle channel visibility", children: ne.jsx(U, {}) }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(ij, { theme: n, color: c, setColor: u, palette: f, isStaticColor: X, isColormap: K, featureValueColormap: v, visible: A }) }), ne.jsx(cn, { item: !0, xs: 6, children: ne.jsx(Mu, { className: V.imageLayerName, children: Ci(e) }) }), ne.jsx(cn, { item: !0, xs: 2, children: ne.jsx(ps, { value: s, min: 0, max: 1, step: 1e-3, onChange: ce, className: V.imageLayerOpacitySlider, orientation: "horizontal", "aria-label": `Adjust opacity for layer ${e}` }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(ger, { obsType: r, featureType: i, featureValueType: o, strokeWidth: I, setStrokeWidth: m, filled: h, setFilled: d, featureSelection: C, obsColorEncoding: y, setObsColorEncoding: Q, featureValueColormapRange: b, setFeatureValueColormapRange: w, tooltipsVisible: R, setTooltipsVisible: M, tooltipCrosshairsVisible: O, setTooltipCrosshairsVisible: L, legendVisible: N, setLegendVisible: k }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(q6t, { className: z.layerTypeSegmentationIcon }) })] }) }) });
}
function der(t) {
  const { theme: e, layerScope: n, layerCoordination: r, setLayerCoordination: i, channelScopes: o, channelCoordination: s, setChannelCoordination: a } = t, A = dt(() => [...o || []].reverse(), [o]);
  return ne.jsx(ne.Fragment, { children: A.map((l) => {
    const { obsType: c, featureType: u, featureValueType: f, spatialChannelVisible: h, spatialChannelOpacity: d, spatialChannelColor: I, spatialSegmentationFilled: m, spatialSegmentationStrokeWidth: C, obsColorEncoding: y, featureSelection: v, featureValueColormap: b, featureValueColormapRange: Q, tooltipsVisible: w, tooltipCrosshairsVisible: R, legendVisible: M } = s[l], { setSpatialChannelVisible: O, setSpatialChannelOpacity: L, setSpatialChannelColor: N, setSpatialSegmentationFilled: k, setSpatialSegmentationStrokeWidth: $, setObsColorEncoding: U, setFeatureValueColormap: X, setFeatureValueColormapRange: K, setTooltipsVisible: z, setTooltipCrosshairsVisible: Y, setLegendVisible: V } = a[l], Z = c;
    return ne.jsx(her, { theme: e, layerScope: n, label: Z, obsType: c, featureType: u, featureValueType: f, opacity: d, setOpacity: L, visible: h, setVisible: O, color: I, setColor: N, filled: m, setFilled: k, strokeWidth: C, setStrokeWidth: $, obsColorEncoding: y, featureSelection: v, featureValueColormap: b, featureValueColormapRange: Q, setObsColorEncoding: U, setFeatureValueColormap: X, setFeatureValueColormapRange: K, tooltipsVisible: w, setTooltipsVisible: z, tooltipCrosshairsVisible: R, setTooltipCrosshairsVisible: Y, legendVisible: M, setLegendVisible: V }, `${n}-${l}`);
  }) });
}
const per = kr(() => ({
  channelMenuButton: {
    backgroundColor: "transparent",
    padding: "3px 0",
    marginTop: "3px"
  },
  menuItemButton: {
    padding: "5px",
    width: "100%"
  }
}));
function Ier(t) {
  const { onRemove: e, onResetWindowUsingIQR: n, showValueExtent: r, setShowValueExtent: i } = t, [o, s] = mn(!1), a = per(), A = Md(), l = om();
  function c() {
    s(!1), e();
  }
  function u(h) {
    i(h.target.value === "Value Min/Max");
  }
  const f = Jr();
  return ne.jsxs(s0, { open: o, setOpen: s, buttonIcon: ne.jsx(fw, { fontSize: "small" }), buttonClassName: a.channelMenuButton, containerClassName: l.imageLayerPopperContainer, placement: "bottom-end", withPaper: !0, "aria-label": "Open channel options menu", children: [ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: l.imageLayerMenuLabel, htmlFor: f, children: "Slider Extent: " }), ne.jsxs(il, { native: !0, onChange: u, value: r ? "Value Min/Max" : "Dtype Min/Max", inputProps: { id: f, "aria-label": "Slider extent selector" }, classes: { root: A.selectRoot }, children: [ne.jsx("option", { value: "Value Min/Max", children: "Value Min/Max" }), ne.jsx("option", { value: "Dtype Min/Max", children: "Dtype Min/Max" })] })] }), ne.jsx(mi, { dense: !0, disableGutters: !0, component: "button", onClick: n, className: a.menuItemButton, "aria-label": "Click to use IQR for channel", children: "Reset window using IQR" }), ne.jsx(mi, { dense: !0, disableGutters: !0, component: "button", onClick: c, className: a.menuItemButton, "aria-label": "Click to remove channel", children: "Remove channel" })] });
}
const mer = kr(() => ({
  channelSlider: {
    marginTop: "7px"
  }
}));
function Cer(t) {
  const { image: e, color: n, window: r, setWindow: i, showValueExtent: o, disabled: s, minMaxDomain: a, colormapOn: A, theme: l } = t, c = A5(A, n, l), u = e?.getDtype(), f = u ? u5[u] : [0, 0], h = mer();
  Mn(() => {
    !r && !s && Array.isArray(a) && i(a);
  }, [a, r, s]);
  const [d, I] = (o ? a : f) || [0, 0], m = I - d < 500 && u?.startsWith("Float") ? (I - d) / 500 : 1, C = Qn(Bd(i || (() => {
  }), 3, { trailing: !0 }), [i]);
  return ne.jsx(ps, { value: r || [0, 0], valueLabelFormat: Jq, onChange: (y, v) => C(v), valueLabelDisplay: "auto", getAriaLabel: (y) => `${y === 0 ? "Low value slider" : "High value slider"} for ${c} colormap channel`, getAriaValueText: () => `Current colormap values: ${c}-${r}`, min: d, max: I, step: m, orientation: "horizontal", className: h.channelSlider, style: { color: c }, disabled: s });
}
const Eer = kr(() => ({
  visibilityCheckbox: {
    padding: "8px 0"
  }
}));
function yer(t, e, n) {
  return n === "light" && gr(e, [255, 255, 255]) ? A5(t, [132, 132, 132], n) : A5(t, e, n);
}
function ver(t) {
  const { color: e, visible: n, setVisible: r, disabled: i, theme: o, colormapOn: s } = t, a = yer(s, e, o), A = Eer();
  return ne.jsx(ds, { onChange: (l, c) => r(c), checked: n, disabled: i, className: A.visibilityCheckbox, style: { color: a, "&$checked": { color: a } }, inputProps: { "aria-label": "Toggle channel visibility" } });
}
const Ber = kr(() => ({
  oneLineChannelSelect: {
    width: "90%",
    marginLeft: "5%",
    fontSize: "12px"
  }
}));
function ber(t) {
  const { featureIndex: e, targetC: n, setTargetC: r, setWindow: i, disabled: o } = t, s = Ber(), a = Md();
  function A(l) {
    r(l.target.value === "" ? null : Number(l.target.value)), i(null);
  }
  return Array.isArray(e) ? ne.jsx(il, { native: !0, classes: { root: a.selectRoot }, className: s.oneLineChannelSelect, value: n === null ? "" : n, onChange: A, inputProps: { "aria-label": "Channel selector" }, children: e.map((l, c) => ne.jsx("option", { disabled: o, value: c, children: l }, l)) }) : null;
}
function _er(t) {
  const {
    theme: e,
    coordinationScopesRaw: n,
    layerScope: r,
    channelScope: i,
    targetT: o,
    targetZ: s,
    targetC: a,
    setTargetC: A,
    visible: l,
    setVisible: c,
    // opacity, // TODO: support per-channel opacity?
    // setOpacity,
    color: u,
    setColor: f,
    window: h,
    setWindow: d,
    colormapOn: I,
    featureIndex: m,
    // The channel names.
    image: C,
    // To get the channel window extent using image metadata.
    spatialRenderingMode: y
  } = t, v = KRt(), [b, Q] = mn(!0), w = !1, R = y === "3D";
  function M() {
    v(n, r, i);
  }
  const O = Yse({
    enabled: !!C?.getData() && !w,
    structuralSharing: !1,
    queryKey: ["minMaxDomain", C?.getName(), o, a, R ? 0 : s, R],
    queryFn: async ($) => {
      const U = $.meta.image?.getData(), X = {
        t: $.queryKey[2],
        c: $.queryKey[3],
        z: Math.floor($.queryKey[4])
      }, K = await cQ({
        loader: U,
        selections: [X],
        use3d: $.queryKey[5]
      }), [z] = K.domains;
      return z;
    },
    meta: { image: C }
  }), L = O.data, N = O.isLoading;
  function k() {
    N || d(L);
  }
  return ne.jsxs(cn, { container: !0, direction: "row", justifyContent: "space-between", children: [ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(ver, { color: u, setColor: f, visible: l, setVisible: c, disabled: w, theme: e, colormapOn: I }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(ij, { color: u, setColor: f, visible: l, setVisible: c, disabled: w, theme: e, isStaticColor: !I, palette: Y0 }) }), ne.jsx(cn, { item: !0, xs: 6, children: ne.jsx(ber, { featureIndex: m, targetC: a, setTargetC: A, setWindow: d, disabled: w }) }), ne.jsx(cn, { item: !0, xs: 3, children: ne.jsx(Cer, { image: C, targetT: o, targetZ: s, targetC: a, window: h, setWindow: d, disabled: N, color: u, theme: e, colormapOn: I, showValueExtent: b, minMaxDomain: L }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(Ier, { onRemove: M, showValueExtent: b, setShowValueExtent: Q, onResetWindowUsingIQR: k }) })] });
}
function tW(t) {
  const { boundingSlice: e, sliceValue: n, setSliceValue: r, label: i } = t, [o, s] = e, a = n || e;
  return ne.jsxs(cn, { container: !0, direction: "row", justifyContent: "flex-start", alignItems: "center", children: [ne.jsx(cn, { item: !0, xs: 1, children: ne.jsxs(Mu, { style: { marginBottom: 0 }, children: [i, ":"] }) }), ne.jsx(cn, { item: !0, xs: 11, children: ne.jsx(ps, { value: a, onChange: (A, l) => r(l), valueLabelDisplay: "auto", valueLabelFormat: (A) => Jq(A), "aria-label": `${i}-axis clipping plane slider`, min: o, max: s, step: 5e-3, orientation: "horizontal" }) })] }, i);
}
function Ser(t) {
  const { image: e, spatialSliceX: n, spatialSliceY: r, spatialSliceZ: i, setSpatialSliceX: o, setSpatialSliceY: s, setSpatialSliceZ: a } = t, [A, l, c] = e.getBoundingCube();
  return ne.jsxs(ne.Fragment, { children: [ne.jsx(tW, { label: "X", boundingSlice: A, sliceValue: n, setSliceValue: o }), ne.jsx(tW, { label: "Y", boundingSlice: l, sliceValue: r, setSliceValue: s }), ne.jsx(tW, { label: "Z", boundingSlice: c, sliceValue: i, setSliceValue: a })] });
}
const Qer = kr(() => ({
  imageLayerButton: {
    borderStyle: "dashed",
    marginTop: "10px",
    marginBottom: "10px",
    fontWeight: 400
  },
  imageChannelControllerGrid: {
    padding: "0",
    flexWrap: "nowrap"
  },
  channelExpansionButton: {
    display: "inline-block",
    margin: 0,
    padding: 0,
    minWidth: 0,
    lineHeight: 1,
    width: "50%"
  },
  layerTypeImageIcon: {
    height: "100%",
    width: "50%",
    maxWidth: "24px"
  },
  clippingPanesLabel: {
    marginBottom: "0 !important"
  },
  clippingSliders: {
    padding: "0 8px"
  }
}));
function wer(t) {
  const { colormap: e, setColormap: n, photometricInterpretation: r, setPhotometricInterpretation: i, spatialTargetResolution: o, setSpatialTargetResolution: s, volumetricRenderingAlgorithm: a, setVolumetricRenderingAlgorithm: A, spatialLayerTransparentColor: l, setSpatialLayerTransparentColor: c, spatialRenderingMode: u, image: f, channelScopes: h, tooltipsVisible: d, setTooltipsVisible: I, channelLabelsVisible: m, setChannelLabelsVisible: C, channelLabelsOrientation: y, setChannelLabelsOrientation: v, channelLabelSize: b, setChannelLabelSize: Q } = t, [w, R] = mn(!1), M = Md(), O = om(), L = u === "3D", N = f?.isMultiResolution(), k = f?.getMultiResolutionStats();
  function $(Qe) {
    n(Qe.target.value === "" ? null : Qe.target.value);
  }
  function U(Qe) {
    i(Qe.target.value);
  }
  function X(Qe) {
    A(Qe.target.value);
  }
  function K(Qe) {
    s(Qe.target.value !== null ? parseInt(Qe.target.value, 10) : null);
  }
  function z(Qe) {
    v(Qe.target.value);
  }
  const Y = Jr(), V = Jr(), Z = Jr(), ce = Jr(), ee = Jr(), pe = Jr(), Ce = Jr(), Be = Jr(), Ie = Jr();
  return ne.jsxs(s0, { open: w, setOpen: R, buttonIcon: ne.jsx(fw, {}), buttonClassName: O.imageLayerMenuButton, containerClassName: O.imageLayerPopperContainer, withPaper: !0, "aria-label": "Open image layer options menu", children: [ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: O.imageLayerMenuLabel, htmlFor: Y, children: "Colormap: " }), ne.jsxs(il, { native: !0, disabled: r === "RGB", onChange: $, value: e === null ? "" : e, inputProps: { id: Y, "aria-label": "Colormap selector" }, classes: { root: M.selectRoot }, children: [ne.jsx("option", { "aria-label": "None", value: "", children: "None" }), k3e.map((Qe) => ne.jsx("option", { value: Qe, children: Qe }, Qe))] })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: O.imageLayerMenuLabel, htmlFor: V, children: "Photometric Interpretation: " }), ne.jsxs(il, { native: !0, onChange: U, value: r, inputProps: { id: V, "aria-label": "Photometric interpretation selector" }, classes: { root: M.selectRoot }, children: [ne.jsx("option", { "aria-label": "RGB", value: "RGB", children: "RGB" }), h.length > 0 ? ne.jsx("option", { "aria-label": "BlackIsZero", value: "BlackIsZero", children: "BlackIsZero" }) : null] })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: O.imageLayerMenuLabel, htmlFor: Z, children: "Zero Transparent: " }), ne.jsx(ds, { color: "primary", checked: l !== null, onChange: (Qe, xe) => c(xe ? [0, 0, 0] : null), inputProps: { id: Z, "aria-label": "Render zero-value pixels as transparent" } })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: O.imageLayerMenuLabel, htmlFor: ce, children: "Volumetric Rendering: " }), ne.jsxs(il, { native: !0, onChange: X, value: a, inputProps: { id: ce, "aria-label": "Volumetric rendering algorithm selector" }, classes: { root: M.selectRoot }, disabled: !L, children: [ne.jsx("option", { "aria-label": "Additive", value: "additive", children: "Additive" }), ne.jsx("option", { "aria-label": "Maximum Intensity Projection", value: "maximumIntensityProjection", children: "Maximum Intensity Projection" })] })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: O.imageLayerMenuLabel, htmlFor: ee, children: "Volume Resolution: " }), ne.jsxs(il, { native: !0, disabled: !L || !N, onChange: K, value: o === null ? "auto" : o, inputProps: { id: ee, "aria-label": "Volumetric resolution selector" }, classes: { root: M.selectRoot }, children: [ne.jsx("option", { value: "auto", children: "Auto" }), Array.isArray(k) ? k.map((Qe, xe) => Qe.canLoad ? ne.jsx("option", { value: xe, children: `3D: ${xe}x Downsampled, ~${G3e(Qe.totalBytes)} per channel, (${Qe.height}, ${Qe.width}, ${Qe.depthDownsampled})` }, `(${Qe.height}, ${Qe.width}, ${Qe.depthDownsampled})`) : null) : null] })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: O.imageLayerMenuLabel, htmlFor: pe, children: "Tooltips Visible: " }), ne.jsx(ds, { color: "primary", checked: d, onChange: (Qe, xe) => I(xe), inputProps: { id: pe, "aria-label": "Render pixel value tooltips" } })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: O.imageLayerMenuLabel, htmlFor: Ce, children: "Channel Labels Visible: " }), ne.jsx(ds, { disabled: r === "RGB", color: "primary", checked: m, onChange: (Qe, xe) => C(xe), inputProps: { id: Ce, "aria-label": "Render channel labels" } })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: O.imageLayerMenuLabel, htmlFor: Be, children: "Channel Labels Orientation: " }), ne.jsxs(il, { native: !0, disabled: r === "RGB", onChange: z, value: y, inputProps: { id: Be, "aria-label": "Channel labels orientation selector" }, classes: { root: M.selectRoot }, children: [ne.jsx("option", { "aria-label": "Vertical", value: "vertical", children: "Vertical" }), ne.jsx("option", { "aria-label": "Horizontal", value: "horizontal", children: "Horizontal" })] })] }), ne.jsxs(mi, { dense: !0, disableGutters: !0, children: [ne.jsx("label", { className: O.imageLayerMenuLabel, htmlFor: Ie, children: "Channel Labels Size: " }), ne.jsx(ps, { disabled: r === "RGB", value: b, min: 8, max: 36, step: 1, onChange: (Qe, xe) => Q(xe), className: O.menuItemSlider, orientation: "horizontal", id: Ie, "aria-label": "Channel labels text size slider" })] })] });
}
function xer(t) {
  const { theme: e, coordinationScopesRaw: n, layerScope: r, layerCoordination: i, setLayerCoordination: o, channelScopes: s, channelCoordination: a, setChannelCoordination: A, image: l, featureIndex: c, targetT: u, targetZ: f, spatialRenderingMode: h } = t, [d, I] = mn(!0), { spatialLayerVisible: m, spatialLayerOpacity: C, spatialLayerColormap: y, photometricInterpretation: v, spatialTargetResolution: b, volumetricRenderingAlgorithm: Q, spatialLayerTransparentColor: w, spatialSliceX: R, spatialSliceY: M, spatialSliceZ: O, tooltipsVisible: L, spatialChannelLabelsVisible: N, spatialChannelLabelsOrientation: k, spatialChannelLabelSize: $ } = i, { setSpatialLayerVisible: U, setSpatialLayerOpacity: X, setSpatialLayerColormap: K, setPhotometricInterpretation: z, setSpatialTargetResolution: Y, setVolumetricRenderingAlgorithm: V, setSpatialLayerTransparentColor: Z, setSpatialSliceX: ce, setSpatialSliceY: ee, setSpatialSliceZ: pe, setTooltipsVisible: Ce, setSpatialChannelLabelsVisible: Be, setSpatialChannelLabelsOrientation: Ie, setSpatialChannelLabelSize: Qe } = o, xe = WRt(), Se = typeof m == "boolean" ? m : !0, De = dt(() => Se ? wL : xL, [Se]), Ue = l?.getName(), Te = l?.getNumChannels(), se = h === "3D", fe = Qn(() => {
    xe(n, r);
  }, [xe, n, r]), W = Qn(() => {
    U(typeof m == "boolean" ? !m : !1);
  }, [m, U]), ge = Qn((Ae, de) => X(de), [X]), _e = Qn(() => I((Ae) => !Ae), []), Re = Qer(), Ee = om(), oe = C1(), ie = v !== "RGB";
  return ne.jsx(cn, { item: !0, className: oe.layerControllerGrid, children: ne.jsxs(r0, { className: oe.layerControllerRoot, children: [ne.jsxs(cn, { container: !0, direction: "row", justifyContent: "space-between", children: [ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(Dp, { className: Ee.imageLayerVisibleButton, onClick: W, "aria-label": "Toggle layer visibility", children: ne.jsx(De, {}) }) }), ne.jsx(cn, { item: !0, xs: 1 }), ne.jsx(cn, { item: !0, xs: 6, children: ne.jsx(Mu, { className: Ee.imageLayerName, children: Ue }) }), ne.jsx(cn, { item: !0, xs: 2, children: ne.jsx(ps, { value: C, min: 0, max: 1, step: 1e-3, onChange: ge, className: Ee.imageLayerOpacitySlider, orientation: "horizontal", "aria-label": `Adjust opacity for layer ${Ue}` }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(wer, { colormap: y, setColormap: K, photometricInterpretation: v, setPhotometricInterpretation: z, spatialTargetResolution: b, setSpatialTargetResolution: Y, volumetricRenderingAlgorithm: Q, setVolumetricRenderingAlgorithm: V, spatialLayerTransparentColor: w, setSpatialLayerTransparentColor: Z, spatialRenderingMode: h, image: l, channelScopes: s, tooltipsVisible: L, setTooltipsVisible: Ce, channelLabelsVisible: N, setChannelLabelsVisible: Be, channelLabelsOrientation: k, setChannelLabelsOrientation: Ie, channelLabelSize: $, setChannelLabelSize: Qe }) }), ne.jsxs(cn, { item: !0, xs: 1, container: !0, direction: "row", children: [ne.jsx(Zkt, { className: Re.layerTypeImageIcon }), ie ? ne.jsx(Dp, { onClick: _e, className: Re.channelExpansionButton, "aria-label": "Expand or collapse channel controls", children: d ? ne.jsx(Xkt, {}) : ne.jsx(O8e, {}) }) : null] })] }), ie && d ? ne.jsxs(cn, { container: !0, direction: "column", justifyContent: "space-between", className: Re.imageChannelControllerGrid, children: [s.map((Ae) => {
    const { spatialTargetC: de, spatialChannelVisible: we, spatialChannelOpacity: Pe, spatialChannelColor: qe, spatialChannelWindow: ke } = a[Ae], { setSpatialTargetC: Xe, setSpatialChannelVisible: rt, setSpatialChannelOpacity: it, setSpatialChannelColor: ht, setSpatialChannelWindow: mt } = A[Ae];
    return ne.jsx(_er, { theme: e, coordinationScopesRaw: n, layerScope: r, channelScope: Ae, targetT: u, targetZ: f, targetC: de, setTargetC: Xe, visible: we, setVisible: rt, opacity: Pe, setOpacity: it, color: qe, setColor: ht, window: ke, setWindow: mt, colormapOn: y !== null, featureIndex: c, image: l, spatialRenderingMode: h }, Ae);
  }), ne.jsx(Dp, { disabled: s.length === wq || s.length === Te, onClick: fe, fullWidth: !0, variant: "outlined", className: Re.imageLayerButton, startIcon: ne.jsx(Kae, {}), size: "small", "aria-label": "Add a channel to this layer", children: "Add Channel" })] }) : null, se && l ? ne.jsxs(cn, { container: !0, direction: "column", justifyContent: "space-between", className: Re.imageChannelControllerGrid, children: [ne.jsx(Mu, { className: Re.clippingPanesLabel, children: "Clipping planes:" }), ne.jsx(cn, { item: !0, xs: 12, className: Re.clippingSliders, children: ne.jsx(Ser, { image: l, spatialSliceX: R, spatialSliceY: M, spatialSliceZ: O, setSpatialSliceX: ce, setSpatialSliceY: ee, setSpatialSliceZ: pe }) })] }) : null] }) });
}
const Rer = kr((t) => ({
  dimensionsIcon: {
    height: "40px",
    width: "40px",
    "& path": {
      fill: t.palette.primaryForeground
    }
  },
  switchFormGroup: {
    float: "right",
    marginTop: "3px"
  },
  dimensionLabel: {
    padding: 0,
    marginBottom: "0 !important",
    marginTop: "12px !important"
  },
  dimensionSlider: {
    marginTop: "9px"
  }
}));
function PNe(t) {
  const { label: e, targetValue: n, setTargetValue: r, min: i = 0, max: o = 0, spatialRenderingMode: s = null, setSpatialRenderingMode: a = null } = t, A = C1(), l = Rer(), c = s !== null;
  function u(f) {
    a(f.target.checked ? "3D" : "2D"), f.target.checked || r(Math.floor(n));
  }
  return ne.jsx(cn, { item: !0, className: A.layerControllerGrid, children: ne.jsx(r0, { className: A.layerControllerRoot, children: ne.jsxs(cn, { container: !0, direction: "row", justifyContent: "space-between", children: [ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx($6t, { className: l.dimensionsIcon }) }), ne.jsx(cn, { item: !0, xs: 1, children: ne.jsx(Mu, { className: l.dimensionLabel, children: e }) }), ne.jsx(cn, { item: !0, xs: 8, children: ne.jsx(ps, { value: n, min: i, max: o, step: 1, onChange: (f, h) => r(h), className: l.dimensionSlider, valueLabelDisplay: "auto", orientation: "horizontal", disabled: s === "3D", "aria-label": `${e}-slice slider` }) }), ne.jsx(cn, { item: !0, xs: 2, children: c ? ne.jsx($It, { row: !0, className: l.switchFormGroup, children: ne.jsx(GIt, { control: ne.jsx(kCt, { color: "primary", checked: s === "3D", onChange: u, name: "is3dMode" }), label: "3D" }) }) : null })] }) }) });
}
function Der(t) {
  const { theme: e, coordinationScopesRaw: n, segmentationLayerScopes: r, segmentationLayerCoordination: i, segmentationChannelScopesByLayer: o, segmentationChannelCoordination: s, images: a, imageLayerScopes: A, imageLayerCoordination: l, targetT: c, targetZ: u, setTargetT: f, setTargetZ: h, spatialRenderingMode: d, setSpatialRenderingMode: I, imageChannelScopesByLayer: m, imageChannelCoordination: C, spotLayerScopes: y, spotLayerCoordination: v, pointLayerScopes: b, pointLayerCoordination: Q } = t, w = Object.values(a || {}).some((U) => U?.image?.instance.hasTStack()), R = Object.values(a || {}).some((U) => U?.image?.instance.hasZStack()), M = Object.values(a || {}).reduce((U, X) => Math.max(U, X?.image?.instance.getNumT()), 1) - 1, O = Object.values(a || {}).reduce((U, X) => Math.max(U, X?.image?.instance.getNumZ()), 1) - 1, L = dt(() => [...A || []].reverse(), [A]), N = dt(() => [...r || []].reverse(), [r]), k = dt(() => [...y || []].reverse(), [y]), $ = dt(() => [...b || []].reverse(), [b]);
  return ne.jsxs("div", { children: [R ? ne.jsx(PNe, { label: "Z", targetValue: u, setTargetValue: h, max: O, spatialRenderingMode: d, setSpatialRenderingMode: I }) : null, w ? ne.jsx(PNe, { label: "T", targetValue: c, setTargetValue: f, max: M }) : null, b && $.map((U) => ne.jsx(fer, { theme: e, layerScope: U, layerCoordination: Q[0][U], setLayerCoordination: Q[1][U] }, U)), y && k.map((U) => ne.jsx(ler, { theme: e, layerScope: U, layerCoordination: v[0][U], setLayerCoordination: v[1][U] }, U)), r && N.map((U) => ne.jsx(der, { theme: e, layerScope: U, layerCoordination: i[0][U], setLayerCoordination: i[1][U], channelScopes: o[U], channelCoordination: s[0][U], setChannelCoordination: s[1][U] }, U)), A && L.map((U) => ne.jsx(xer, { theme: e, coordinationScopesRaw: n, layerScope: U, layerCoordination: l[0][U], setLayerCoordination: l[1][U], channelScopes: m[U], channelCoordination: C[0][U], setChannelCoordination: C[1][U], image: a[U]?.image?.instance, featureIndex: a[U]?.featureIndex, targetT: c, targetZ: u, spatialRenderingMode: d }, U))] });
}
function Ter(t) {
  const { coordinationScopes: e, coordinationScopesBy: n, closeButtonVisible: r, downloadButtonVisible: i, removeGridComponent: o, theme: s, title: a = "Spatial Layers", uuid: A } = t, l = eu(), c = bUe(), u = yUe(e), f = vUe(u, n), [{ dataset: h, spatialTargetT: d, spatialTargetZ: I, spatialRenderingMode: m }, { setSpatialTargetX: C, setSpatialTargetY: y, setSpatialTargetZ: v, setSpatialTargetT: b, setSpatialRotationX: Q, setSpatialRotationOrbit: w, setSpatialZoom: R, setSpatialRenderingMode: M }] = uc(ea[Gn.LAYER_CONTROLLER_BETA], u), [O, L] = U4(re.SEGMENTATION_CHANNEL, re.SEGMENTATION_LAYER, u, f), [N, k] = U4(re.IMAGE_CHANNEL, re.IMAGE_LAYER, u, f), $ = G4(re.SPOT_LAYER, u), U = G4(re.POINT_LAYER, u), X = TA([
    re.FILE_UID,
    re.SEGMENTATION_CHANNEL,
    re.SPATIAL_LAYER_VISIBLE,
    re.SPATIAL_LAYER_OPACITY
  ], u, f, re.SEGMENTATION_LAYER), K = wI([
    re.OBS_TYPE,
    re.SPATIAL_TARGET_C,
    re.SPATIAL_CHANNEL_VISIBLE,
    re.SPATIAL_CHANNEL_OPACITY,
    re.SPATIAL_CHANNEL_COLOR,
    re.SPATIAL_SEGMENTATION_FILLED,
    re.SPATIAL_SEGMENTATION_STROKE_WIDTH,
    re.OBS_COLOR_ENCODING,
    re.FEATURE_SELECTION,
    re.FEATURE_VALUE_COLORMAP,
    re.FEATURE_VALUE_COLORMAP_RANGE,
    re.TOOLTIPS_VISIBLE,
    re.TOOLTIP_CROSSHAIRS_VISIBLE,
    re.LEGEND_VISIBLE
  ], u, f, re.SEGMENTATION_LAYER, re.SEGMENTATION_CHANNEL), z = TA([
    re.FILE_UID,
    re.IMAGE_CHANNEL,
    re.SPATIAL_LAYER_VISIBLE,
    re.SPATIAL_LAYER_OPACITY,
    re.SPATIAL_LAYER_COLORMAP,
    re.SPATIAL_LAYER_TRANSPARENT_COLOR,
    re.SPATIAL_LAYER_MODEL_MATRIX,
    re.PHOTOMETRIC_INTERPRETATION,
    re.VOLUMETRIC_RENDERING_ALGORITHM,
    re.SPATIAL_TARGET_RESOLUTION,
    re.SPATIAL_SLICE_X,
    re.SPATIAL_SLICE_Y,
    re.SPATIAL_SLICE_Z,
    re.TOOLTIPS_VISIBLE,
    re.SPATIAL_CHANNEL_LABELS_VISIBLE,
    re.SPATIAL_CHANNEL_LABELS_ORIENTATION,
    re.SPATIAL_CHANNEL_LABEL_SIZE
  ], u, f, re.IMAGE_LAYER), Y = wI([
    re.SPATIAL_TARGET_C,
    re.SPATIAL_CHANNEL_VISIBLE,
    re.SPATIAL_CHANNEL_COLOR,
    re.SPATIAL_CHANNEL_WINDOW
  ], u, f, re.IMAGE_LAYER, re.IMAGE_CHANNEL), V = TA([
    re.OBS_TYPE,
    re.SPATIAL_LAYER_VISIBLE,
    re.SPATIAL_LAYER_OPACITY,
    re.SPATIAL_SPOT_RADIUS,
    re.SPATIAL_SPOT_FILLED,
    re.SPATIAL_SPOT_STROKE_WIDTH,
    re.OBS_COLOR_ENCODING,
    re.FEATURE_SELECTION,
    re.FEATURE_VALUE_COLORMAP,
    re.FEATURE_VALUE_COLORMAP_RANGE,
    re.SPATIAL_LAYER_COLOR,
    re.TOOLTIPS_VISIBLE,
    re.TOOLTIP_CROSSHAIRS_VISIBLE,
    re.LEGEND_VISIBLE
  ], u, f, re.SPOT_LAYER), Z = TA([
    re.OBS_TYPE,
    re.SPATIAL_LAYER_VISIBLE,
    re.SPATIAL_LAYER_OPACITY,
    re.SPATIAL_SPOT_RADIUS,
    re.OBS_COLOR_ENCODING,
    re.FEATURE_SELECTION,
    re.FEATURE_VALUE_COLORMAP,
    re.FEATURE_VALUE_COLORMAP_RANGE,
    re.SPATIAL_LAYER_COLOR,
    re.TOOLTIPS_VISIBLE,
    re.TOOLTIP_CROSSHAIRS_VISIBLE,
    re.LEGEND_VISIBLE
  ], u, f, re.POINT_LAYER);
  vae(ea.layerController, u), pUe("spatial", ["spatialImageLayer"], u);
  const ce = Zr();
  Yae(ce), D8e();
  const [ee, pe] = H8e(u, f, l, h, c, A), [Ce, Be] = $8e(u, f, l, h, c, A), [Ie, Qe] = U8e(u, f, l, h, c, A), [xe, Se] = G8e(u, f, l, h, c, A), De = Jc([
    Qe,
    Se,
    pe,
    Be
  ]);
  return ne.jsx(fc, { title: a, isScroll: !0, closeButtonVisible: r, downloadButtonVisible: i, removeGridComponent: o, theme: s, isReady: De, children: ne.jsx(Der, { theme: s, coordinationScopesRaw: e, segmentationLayerScopes: O, segmentationLayerCoordination: X, segmentationChannelScopesByLayer: L, segmentationChannelCoordination: K, images: Ce, imageLayerScopes: N, imageLayerCoordination: z, targetT: d, targetZ: I, setTargetT: b, setTargetZ: v, spatialRenderingMode: m, setSpatialRenderingMode: M, imageChannelScopesByLayer: k, imageChannelCoordination: Y, spotLayerScopes: $, spotLayerCoordination: V, pointLayerScopes: U, pointLayerCoordination: Z }) });
}
const Ner = kr(() => ({
  info: {
    // details
    fontSize: "80%",
    opacity: "0.8"
  },
  warn: {
    // alert alert-warning my-0 details
    position: "relative",
    padding: "12px 20px",
    border: "1px solid transparent",
    borderRadius: "4px",
    color: "#856404",
    backgroundColor: "#fff3cd",
    borderColor: "#ffeeba",
    marginTop: "0",
    marginBottom: "0"
  }
}));
function Ler(t) {
  const { info: e, warn: n } = t, r = Ner(), i = [];
  return e && i.push(ne.jsx("p", { className: r.info, children: e }, "info")), n && i.push(ne.jsx("p", { className: Xt(r.info, r.warn), children: n }, "warn")), i;
}
function Mer(t) {
  const { coordinationScopes: e, closeButtonVisible: n, removeGridComponent: r, theme: i, title: o = "Status" } = t, [{ obsHighlight: s, featureHighlight: a, moleculeHighlight: A }] = uc(ea[Gn.STATUS], e), l = _Ue(), u = [
    ...s ? [`Hovered cell ${s}`] : [],
    ...a ? [`Hovered gene ${a}`] : [],
    ...A ? [`Hovered gene ${A}`] : []
  ].join("; ");
  return ne.jsx(fc, { title: o, theme: i, closeButtonVisible: n, removeGridComponent: r, isScroll: !0, isReady: !0, children: ne.jsx(Ler, { warn: l, info: u }) });
}
window.higlassTracks = window.higlassTracks || {};
window.higlassTracksByType = window.higlassTracksByType || {};
window.higlassDataFetchersByType = window.higlassDataFetchersByType || {};
const kNe = () => Math.random().toString(36).substring(2, 8), Oer = (t, { force: e = !1 } = {}) => {
  let n = kNe();
  for (; window.higlassTracks[n]; )
    n = kNe();
  t.name = n, window.higlassTracks[t.name] = t, window.higlassTracksByType[t.config.type] && !e ? console.warn(
    `A track with the same type (${t.config.type}) was already registered. To override it, set force to true.`
  ) : window.higlassTracksByType[t.config.type] = t;
}, Fer = (t, { force: e = !1 } = {}) => {
  window.higlassDataFetchersByType[t.config.type] && !e ? console.warn(
    `A data fetcher with the same type (${t.config.type}) was already registered. To override it, set force to true.`
  ) : window.higlassDataFetchersByType[t.config.type] = t;
}, Per = (t, e = {}) => {
  const { pluginType: n = "track" } = e;
  n === "track" ? Oer(t, e) : n === "dataFetcher" && Fer(t, e);
};
function ker(t, e, n) {
  const r = n ? e[1] : e[0] * e[1], i = new Float32Array(r);
  let o = 0;
  if (n)
    for (const s of t) {
      const a = s.data;
      i.set(a, o), o += a.length;
    }
  else {
    const s = e[0];
    for (let a = 0; a < s; a++)
      for (const A of t) {
        const l = A.data.subarray(a * A.stride[0], (a + 1) * A.stride[0]);
        i.set(l, o), o += l.length;
      }
  }
  return i;
}
var EXe = function(e, ...n) {
  if (!new.target)
    throw new Error(
      'Uncaught TypeError: Class constructor cannot be invoked without "new"'
    );
  const { slugid: r } = e.libraries, {
    absToChr: i,
    parseChromsizesRows: o,
    genomicRangeToChromosomeChunks: s,
    DenseDataExtrema1D: a,
    minNonZero: A,
    maxNonZero: l
  } = e.utils;
  class c {
    constructor(f) {
      this.dataConfig = f, this.trackUid = r.nice(), f.url && (this.store = new KWe(f.url), this.storeRoot = Promise.resolve(Wfe(this.store))), f.row !== void 0 && (this.row = f.row);
    }
    tilesetInfo(f) {
      return this.tilesetInfoLoading = !0, this.storeRoot.then((h) => fs(h)).then((h) => {
        const d = h.attrs;
        this.tilesetInfoLoading = !1;
        const I = d.multiscales.map((b) => [b.name, b.metadata.chromsize]), m = d.multiscales[d.multiscales.length - 1], C = m.metadata.chromoffset + m.metadata.chromsize, y = d.shape[1], v = {
          ...d,
          shape: [d.shape[1], d.shape[0]],
          chromSizes: I,
          tile_size: y,
          max_width: C,
          min_pos: [0],
          max_pos: [C],
          max_zoom: Math.ceil(Math.log(C / y) / Math.log(2))
        };
        return f && f(v), v;
      }).catch((h) => {
        this.tilesetInfoLoading = !1, f && f({
          error: `Error parsing zarr multivec: ${h}`
        });
      });
    }
    fetchTilesDebounced(f, h) {
      const d = {}, I = [], m = [];
      for (const C of h) {
        const y = C.split("."), v = parseInt(y[0], 10), b = parseInt(y[1], 10);
        if (Number.isNaN(b) || Number.isNaN(v)) {
          console.warn("Invalid tile zoom or position:", v, b);
          continue;
        }
        I.push(C), m.push(this.tile(v, b, C));
      }
      return Promise.all(m).then((C) => {
        for (let y = 0; y < C.length; y++) {
          const v = I[y];
          d[v] = C[y], d[v].tilePositionId = v;
        }
        f(d);
      }), d;
    }
    tile(f, h, d) {
      const { storeRoot: I } = this;
      return this.tilesetInfo().then((m) => {
        const C = +m.resolutions[f], y = +m.tile_size, v = C, b = h * y * C, Q = b + y * C, w = m.chromSizes, R = o(w), [M, O] = i(b, R), [L, N] = i(Q, R), U = s(
          w,
          { chr: M, pos: O },
          { chr: L, pos: N },
          v,
          y
        );
        return Promise.all(
          U.map(([X, K, z]) => I.then((Y) => fs(Y.resolve(`/chromosomes/${X}/${C}/`), { kind: "array" })).then((Y) => this.row !== void 0 ? Sp(Y, [this.row, pB(K, z)]) : Sp(Y, [null, pB(K, z)])))
        ).then((X) => {
          const K = ker(X, [m.shape[1], m.shape[0]], this.row !== void 0);
          return Promise.resolve({
            dense: K,
            denseDataExtrema: new a(K),
            dtype: "float32",
            min_value: Math.min.apply(null, K),
            max_value: Math.max.apply(null, K),
            minNonZero: A(K),
            maxNonZero: l(K),
            server: null,
            size: 1,
            shape: m.shape,
            tileId: d,
            tilePos: [h],
            tilePositionId: d,
            tilesetUid: null,
            zoomLevel: f
          });
        });
      });
    }
  }
  return new c(...n);
};
EXe.config = {
  type: "zarr-multivec"
};
var GNe = EXe;
const rge = kr((t) => ({
  higlassTitleWrapper: {
    height: "calc(100% - 20px)",
    "& > div:nth-child(2)": {
      width: "inherit",
      height: "inherit",
      padding: "5px",
      backgroundColor: t.palette.secondaryBackground
      // map-get($theme-colors, "secondary-background");
    }
  },
  higlassLazyWrapper: {
    width: "inherit",
    height: "inherit"
  },
  higlassWrapperParent: {
    display: "block",
    position: "relative",
    boxSizing: "border-box",
    fontSize: "12px",
    color: "#333",
    overflow: "hidden"
  },
  higlassWrapper: {
    width: "inherit",
    height: "inherit",
    position: "relative",
    display: "block",
    textAlign: "left",
    boxSizing: "border-box",
    "@global .higlass": {
      width: "100%",
      height: "100%"
    },
    "@global .higlass .react-grid-layout": {
      backgroundColor: "transparent !important"
    },
    "@global .higlass nav": {
      display: "flex"
    },
    "@global .higlass input": {
      fontSize: "12px"
    },
    "@global .higlass .btn": {
      color: "#999",
      fontSize: "12px"
    }
  }
})), Ger = "higlass-no-github-deps", Uer = "1.11.13", Her = `https://unpkg.com/${Ger}@${Uer}/dist/hglib.css`;
Per({ dataFetcher: GNe, config: GNe.config }, { pluginType: "dataFetcher" });
const $er = St.lazy(async () => {
  const { HiGlassComponent: t } = await import("./hglib-c1cbe05e.js").then((e) => e.h);
  return { default: t };
}), u3 = 800;
function ige(t) {
  const { coordinationScopes: e, theme: n, hgViewConfig: r, hgOptions: i, genomeSize: o, height: s } = t, [{ genomicZoomX: a, genomicZoomY: A, genomicTargetX: l, genomicTargetY: c }, { setGenomicZoomX: u, setGenomicZoomY: f, setGenomicTargetX: h, setGenomicTargetY: d }] = uc(ea.higlass, e), [I, m, C] = uw(), [y, v] = mn(), b = Zr(), Q = dt(() => ({
    ...i,
    theme: n
  }), [i, n]), w = dt(() => {
    const M = l, O = o / 2 ** a, L = I / u3, N = [
      M - O * L / 2,
      M + O * L / 2
    ], k = c, $ = o / 2 ** A, U = s / u3, X = [
      k - $ * U / 2,
      k + $ * U / 2
    ];
    return {
      editable: !1,
      zoomFixed: !1,
      trackSourceServers: [
        "//higlass.io/api/v1"
      ],
      exportViewUrl: "//higlass.io/api/v1/viewconfs",
      views: [
        {
          uid: "main",
          ...r,
          initialXDomain: N,
          initialYDomain: X
        }
      ],
      zoomLocks: {
        locksByViewUid: {},
        locksDict: {}
      },
      locationLocks: {
        locksByViewUid: {},
        locksDict: {}
      },
      valueScaleLocks: {
        locksByViewUid: {},
        locksDict: {}
      }
    };
  }, [
    l,
    o,
    a,
    I,
    c,
    A,
    s,
    r
  ]);
  Mn(() => {
    const M = () => {
      b.current = !0;
    }, O = () => {
      b.current = !1;
    }, L = C.current;
    return L.addEventListener("mouseenter", M), L.addEventListener("mouseleave", O), () => {
      L.removeEventListener("mouseenter", M), L.removeEventListener("mouseenter", O);
    };
  }, [C]), Mn(() => y ? (y.api.on("viewConfig", (M) => {
    if (!b.current)
      return;
    const O = JSON.parse(M), L = O.views[0].initialXDomain, N = O.views[0].initialYDomain, k = Math.log2(o / ((L[1] - L[0]) * (u3 / I))), $ = Math.log2(o / ((N[1] - N[0]) * (u3 / s))), U = L[0] + (L[1] - L[0]) / 2, X = N[0] + (N[1] - N[0]) / 2;
    u(k), f($), h(U), d(X);
  }), () => y.api.off("viewConfig")) : () => {
  }, [
    y,
    o,
    I,
    s,
    u,
    f,
    h,
    d
  ]);
  const R = rge();
  return ne.jsxs("div", { className: R.higlassWrapperParent, children: [ne.jsx("link", { rel: "stylesheet", type: "text/css", href: Her }), ne.jsx("div", { className: R.higlassWrapper, ref: C, style: { height: `${s}px` }, children: ne.jsx(L3e, { fallback: ne.jsx("div", { children: "Loading..." }), children: ne.jsx($er, { ref: v, zoomFixed: !1, viewConfig: w, options: Q }) }) })] });
}
ige.defaultProps = {
  hgOptions: {
    bounded: !0,
    pixelPreciseMarginPadding: !0,
    containerPaddingX: 0,
    containerPaddingY: 0,
    sizeMode: "default"
  },
  genomeSize: 31e8
};
const qer = [];
function jer(t) {
  const { coordinationScopes: e, theme: n, hgViewConfig: r, closeButtonVisible: i, downloadButtonVisible: o, removeGridComponent: s } = t, [a, A, l] = uw(), c = rge();
  return ne.jsx("div", { className: c.higlassTitleWrapper, children: ne.jsx(fc, { title: "HiGlass", closeButtonVisible: i, downloadButtonVisible: o, removeGridComponent: s, theme: n, isReady: !0, urls: qer, children: ne.jsx("div", { className: c.higlassLazyWrapper, ref: l, children: ne.jsx(ige, { coordinationScopes: e, theme: n, hgViewConfig: r, height: A }) }) }) });
}
const UNe = {
  hg38: {
    chromosomes: "NyITQvZsS_mOFNlz5C2LJg",
    genes: "P0PLbQMwTYGy-5uPIQid7A"
  },
  hg19: {
    chromosomes: "N12wVGG9SPiTkk03yUayUw",
    genes: "OHJakQICQD6gTD7skx4EWA"
  },
  mm9: {
    chromosomes: "WAVhNHYxQVueq6KulwgWiQ",
    genes: "GUm5aBiLRCyz2PsBea7Yzg"
  },
  mm10: {
    chromosomes: "EtrWT0VtScixmsmwFSd7zg",
    genes: "QDutvmyiSrec5nX4pA5WGQ"
  }
};
function Yer(t) {
  const { coordinationScopes: e, theme: n, closeButtonVisible: r, downloadButtonVisible: i, removeGridComponent: o, profileTrackUidKey: s = "path", profileTrackNameKey: a = null, higlassServer: A = "https://higlass.io/api/v1", assembly: l = "hg38", title: c = "Genomic Profiles" } = t, [u, f, h] = uw(), d = eu(), [{ dataset: I, obsSetColor: m, obsSetSelection: C }] = uc(ea[Gn.GENOMIC_PROFILES], e), [y, v, b] = dGt(d, I, !0, {}, {}, {}), Q = Jc([v]), w = Qd([b]), R = dt(() => {
    if (!y || w.length !== 1)
      return null;
    const { url: O } = w[0], L = n === "dark" ? "#C0C0C0" : "#000000", N = n === "dark" ? "#000000" : "#f1f1f1", k = n === "dark" ? "dimgray" : "silver", $ = [
      {
        type: "horizontal-chromosome-labels",
        server: A,
        tilesetUid: UNe[l].chromosomes,
        uid: "chromosome-labels",
        options: {
          color: L,
          fontSize: 12,
          fontIsLeftAligned: !1,
          showMousePosition: !0,
          mousePositionColor: L
        },
        height: 30
      },
      {
        type: "horizontal-gene-annotations",
        server: A,
        tilesetUid: UNe[l].genes,
        uid: "gene-annotations",
        options: {
          name: "Gene Annotations (hg38)",
          fontSize: 10,
          labelPosition: "hidden",
          labelLeftMargin: 0,
          labelRightMargin: 0,
          labelTopMargin: 0,
          labelBottomMargin: 0,
          minHeight: 24,
          geneAnnotationHeight: 16,
          geneLabelPosition: "outside",
          geneStrandSpacing: 4,
          showMousePosition: !0,
          mousePositionColor: L,
          plusStrandColor: L,
          minusStrandColor: L,
          labelColor: "black",
          labelBackgroundColor: N,
          trackBorderWidth: 0,
          trackBorderColor: "black"
        },
        height: 70
      }
    ], U = R8e($.map((V) => V.height)), K = (f - U - 10) / y.row_infos.length, z = y.row_infos.map((V, Z) => {
      const ce = V[s], ee = Array.isArray(ce), pe = a ? V[a] : ee ? ce[ce.length - 1] : ce, Ce = ee ? C?.find((xe) => gr(xe, ce)) : !1, Be = ee ? m?.find((xe) => gr(xe.path, ce))?.color : null, Qe = {
        type: "horizontal-bar",
        uid: `bar-track-${ee ? ce.join("__") : ce}`,
        data: {
          type: "zarr-multivec",
          url: O,
          row: Z
        },
        options: {
          name: pe,
          showMousePosition: !0,
          mousePositionColor: L,
          labelColor: n === "dark" ? "white" : "black",
          labelBackgroundColor: n === "dark" ? "black" : "white",
          labelShowAssembly: !1
        },
        height: K
      };
      if (Be && Ce) {
        const xe = Be;
        Qe.options.barFillColor = `rgb(${xe[0]},${xe[1]},${xe[2]})`;
      } else
        Qe.options.barFillColor = k;
      return Qe;
    });
    return {
      tracks: {
        top: [
          ...$,
          ...z
        ],
        left: [],
        center: [],
        right: [],
        bottom: [],
        whole: [],
        gallery: []
      },
      layout: {
        w: 12,
        h: 12,
        x: 0,
        y: 0,
        static: !1
      }
    };
  }, [
    y,
    w,
    n,
    f,
    s,
    a,
    C,
    m,
    A,
    l
  ]), M = rge();
  return ne.jsx("div", { className: M.higlassTitleWrapper, children: ne.jsx(fc, { title: c, closeButtonVisible: r, downloadButtonVisible: i, removeGridComponent: o, theme: n, isReady: Q, urls: w, children: ne.jsx("div", { className: M.higlassLazyWrapper, ref: h, children: R ? ne.jsx(ige, { coordinationScopes: e, theme: n, hgViewConfig: R, height: f }) : null }) }) });
}
function zer(t) {
  const { featureValueTransform: e, setFeatureValueTransform: n, featureValueTransformCoefficient: r, setFeatureValueTransformCoefficient: i, transformOptions: o } = t, s = Jr(), a = VI(), A = (c) => {
    n(c.target.value === "" ? null : c.target.value);
  }, l = (c) => {
    const { value: u } = c.target;
    if (!u)
      i(u);
    else {
      const f = Number(u);
      !Number.isNaN(f) && f >= 0 && i(u);
    }
  };
  return ne.jsxs(NL, { children: [ne.jsxs(Ko, { children: [ne.jsx(br, { className: a.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `cellset-expression-transform-select-${s}`, children: "Transform" }) }), ne.jsx(br, { className: a.inputCell, variant: "body", children: ne.jsx(nd, { className: a.select, value: e === null ? "" : e, onChange: A, inputProps: {
    id: `cellset-expression-transform-select-${s}`
  }, children: o.map((c) => ne.jsx("option", { value: c.value === null ? "" : c.value, children: c.name }, c.name)) }) })] }), ne.jsxs(Ko, { children: [ne.jsx(br, { className: a.labelCell, variant: "head", scope: "row", children: ne.jsx("label", { htmlFor: `cellset-expression-transform-coeff-${s}`, children: "Transform Coefficient" }) }), ne.jsx(br, { className: a.inputCell, variant: "body", children: ne.jsx(SGe, { label: "Transform Coefficient", type: "number", onChange: l, value: r, InputLabelProps: {
    shrink: !0
  }, id: `cellset-expression-transform-coeff-${s}` }) })] })] });
}
function Yu(t, e, n) {
  return t.fields = e || [], t.fname = n, t;
}
function pa(t) {
  return t == null ? null : t.fname;
}
function Zl(t) {
  return t == null ? null : t.fields;
}
function yXe(t) {
  return t.length === 1 ? Ver(t[0]) : Jer(t);
}
const Ver = (t) => function(e) {
  return e[t];
}, Jer = (t) => {
  const e = t.length;
  return function(n) {
    for (let r = 0; r < e; ++r)
      n = n[t[r]];
    return n;
  };
};
function wt(t) {
  throw Error(t);
}
function g0(t) {
  const e = [], n = t.length;
  let r = null, i = 0, o = "", s, a, A;
  t = t + "";
  function l() {
    e.push(o + t.substring(s, a)), o = "", s = a + 1;
  }
  for (s = a = 0; a < n; ++a)
    if (A = t[a], A === "\\")
      o += t.substring(s, a), o += t.substring(++a, ++a), s = a;
    else if (A === r)
      l(), r = null, i = -1;
    else {
      if (r)
        continue;
      s === i && A === '"' || s === i && A === "'" ? (s = a + 1, r = A) : A === "." && !i ? a > s ? l() : s = a + 1 : A === "[" ? (a > s && l(), i = s = a + 1) : A === "]" && (i || wt("Access path missing open bracket: " + t), i > 0 && l(), i = 0, s = a + 1);
    }
  return i && wt("Access path missing closing bracket: " + t), r && wt("Access path missing closing quote: " + t), a > s && (a++, l()), e;
}
function ku(t, e, n) {
  const r = g0(t);
  return t = r.length === 1 ? r[0] : t, Yu((n && n.get || yXe)(r), [t], e || t);
}
const nO = ku("id"), Ac = Yu((t) => t, [], "identity"), nC = Yu(() => 0, [], "zero"), ux = Yu(() => 1, [], "one"), qg = Yu(() => !0, [], "true"), Um = Yu(() => !1, [], "false");
function Ker(t, e, n) {
  const r = [e].concat([].slice.call(n));
  console[t].apply(console, r);
}
const vXe = 0, oge = 1, sge = 2, BXe = 3, bXe = 4;
function age(t, e, n = Ker) {
  let r = t || vXe;
  return {
    level(i) {
      return arguments.length ? (r = +i, this) : r;
    },
    error() {
      return r >= oge && n(e || "error", "ERROR", arguments), this;
    },
    warn() {
      return r >= sge && n(e || "warn", "WARN", arguments), this;
    },
    info() {
      return r >= BXe && n(e || "log", "INFO", arguments), this;
    },
    debug() {
      return r >= bXe && n(e || "log", "DEBUG", arguments), this;
    }
  };
}
var Nt = Array.isArray;
function _n(t) {
  return t === Object(t);
}
const HNe = (t) => t !== "__proto__";
function fx(...t) {
  return t.reduce((e, n) => {
    for (const r in n)
      if (r === "signals")
        e.signals = Wer(e.signals, n.signals);
      else {
        const i = r === "legend" ? {
          layout: 1
        } : r === "style" ? !0 : null;
        gx(e, r, n[r], i);
      }
    return e;
  }, {});
}
function gx(t, e, n, r) {
  if (!HNe(e))
    return;
  let i, o;
  if (_n(n) && !Nt(n)) {
    o = _n(t[e]) ? t[e] : t[e] = {};
    for (i in n)
      r && (r === !0 || r[i]) ? gx(o, i, n[i]) : HNe(i) && (o[i] = n[i]);
  } else
    t[e] = n;
}
function Wer(t, e) {
  if (t == null)
    return e;
  const n = {}, r = [];
  function i(o) {
    n[o.name] || (n[o.name] = 1, r.push(o));
  }
  return e.forEach(i), t.forEach(i), r;
}
function bi(t) {
  return t[t.length - 1];
}
function Kl(t) {
  return t == null || t === "" ? null : +t;
}
const _Xe = (t) => (e) => t * Math.exp(e), SXe = (t) => (e) => Math.log(t * e), QXe = (t) => (e) => Math.sign(e) * Math.log1p(Math.abs(e / t)), wXe = (t) => (e) => Math.sign(e) * Math.expm1(Math.abs(e)) * t, g5 = (t) => (e) => e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
function oj(t, e, n, r) {
  const i = n(t[0]), o = n(bi(t)), s = (o - i) * e;
  return [r(i - s), r(o - s)];
}
function xXe(t, e) {
  return oj(t, e, Kl, Ac);
}
function RXe(t, e) {
  var n = Math.sign(t[0]);
  return oj(t, e, SXe(n), _Xe(n));
}
function DXe(t, e, n) {
  return oj(t, e, g5(n), g5(1 / n));
}
function TXe(t, e, n) {
  return oj(t, e, QXe(n), wXe(n));
}
function sj(t, e, n, r, i) {
  const o = r(t[0]), s = r(bi(t)), a = e != null ? r(e) : (o + s) / 2;
  return [i(a + (o - a) * n), i(a + (s - a) * n)];
}
function Age(t, e, n) {
  return sj(t, e, n, Kl, Ac);
}
function lge(t, e, n) {
  const r = Math.sign(t[0]);
  return sj(t, e, n, SXe(r), _Xe(r));
}
function h5(t, e, n, r) {
  return sj(t, e, n, g5(r), g5(1 / r));
}
function cge(t, e, n, r) {
  return sj(t, e, n, QXe(r), wXe(r));
}
function NXe(t) {
  return 1 + ~~(new Date(t).getMonth() / 3);
}
function LXe(t) {
  return 1 + ~~(new Date(t).getUTCMonth() / 3);
}
function bn(t) {
  return t != null ? Nt(t) ? t : [t] : [];
}
function MXe(t, e, n) {
  let r = t[0], i = t[1], o;
  return i < r && (o = i, i = r, r = o), o = i - r, o >= n - e ? [e, n] : [r = Math.min(Math.max(r, e), n - o), r + o];
}
function ri(t) {
  return typeof t == "function";
}
const Xer = "descending";
function uge(t, e, n) {
  n = n || {}, e = bn(e) || [];
  const r = [], i = [], o = {}, s = n.comparator || Zer;
  return bn(t).forEach((a, A) => {
    a != null && (r.push(e[A] === Xer ? -1 : 1), i.push(a = ri(a) ? a : ku(a, null, n)), (Zl(a) || []).forEach((l) => o[l] = 1));
  }), i.length === 0 ? null : Yu(s(i, r), Object.keys(o));
}
const aj = (t, e) => (t < e || t == null) && e != null ? -1 : (t > e || e == null) && t != null ? 1 : (e = e instanceof Date ? +e : e, (t = t instanceof Date ? +t : t) !== t && e === e ? -1 : e !== e && t === t ? 1 : 0), Zer = (t, e) => t.length === 1 ? etr(t[0], e[0]) : ttr(t, e, t.length), etr = (t, e) => function(n, r) {
  return aj(t(n), t(r)) * e;
}, ttr = (t, e, n) => (e.push(0), function(r, i) {
  let o, s = 0, a = -1;
  for (; s === 0 && ++a < n; )
    o = t[a], s = aj(o(r), o(i));
  return s * e[a];
});
function lc(t) {
  return ri(t) ? t : () => t;
}
function fge(t, e) {
  let n;
  return (r) => {
    n && clearTimeout(n), n = setTimeout(() => (e(r), n = null), t);
  };
}
function ni(t) {
  for (let e, n, r = 1, i = arguments.length; r < i; ++r) {
    e = arguments[r];
    for (n in e)
      t[n] = e[n];
  }
  return t;
}
function Jp(t, e) {
  let n = 0, r, i, o, s;
  if (t && (r = t.length))
    if (e == null) {
      for (i = t[n]; n < r && (i == null || i !== i); i = t[++n])
        ;
      for (o = s = i; n < r; ++n)
        i = t[n], i != null && (i < o && (o = i), i > s && (s = i));
    } else {
      for (i = e(t[n]); n < r && (i == null || i !== i); i = e(t[++n]))
        ;
      for (o = s = i; n < r; ++n)
        i = e(t[n]), i != null && (i < o && (o = i), i > s && (s = i));
    }
  return [o, s];
}
function OXe(t, e) {
  const n = t.length;
  let r = -1, i, o, s, a, A;
  if (e == null) {
    for (; ++r < n; )
      if (o = t[r], o != null && o >= o) {
        i = s = o;
        break;
      }
    if (r === n)
      return [-1, -1];
    for (a = A = r; ++r < n; )
      o = t[r], o != null && (i > o && (i = o, a = r), s < o && (s = o, A = r));
  } else {
    for (; ++r < n; )
      if (o = e(t[r], r, t), o != null && o >= o) {
        i = s = o;
        break;
      }
    if (r === n)
      return [-1, -1];
    for (a = A = r; ++r < n; )
      o = e(t[r], r, t), o != null && (i > o && (i = o, a = r), s < o && (s = o, A = r));
  }
  return [a, A];
}
const ntr = Object.prototype.hasOwnProperty;
function Kn(t, e) {
  return ntr.call(t, e);
}
const f3 = {};
function hx(t) {
  let e = {}, n;
  function r(o) {
    return Kn(e, o) && e[o] !== f3;
  }
  const i = {
    size: 0,
    empty: 0,
    object: e,
    has: r,
    get(o) {
      return r(o) ? e[o] : void 0;
    },
    set(o, s) {
      return r(o) || (++i.size, e[o] === f3 && --i.empty), e[o] = s, this;
    },
    delete(o) {
      return r(o) && (--i.size, ++i.empty, e[o] = f3), this;
    },
    clear() {
      i.size = i.empty = 0, i.object = e = {};
    },
    test(o) {
      return arguments.length ? (n = o, i) : n;
    },
    clean() {
      const o = {};
      let s = 0;
      for (const a in e) {
        const A = e[a];
        A !== f3 && (!n || !n(A)) && (o[a] = A, ++s);
      }
      i.size = s, i.empty = 0, i.object = e = o;
    }
  };
  return t && Object.keys(t).forEach((o) => {
    i.set(o, t[o]);
  }), i;
}
function FXe(t, e, n, r, i, o) {
  if (!n && n !== 0)
    return o;
  const s = +n;
  let a = t[0], A = bi(t), l;
  A < a && (l = a, a = A, A = l), l = Math.abs(e - a);
  const c = Math.abs(A - e);
  return l < c && l <= s ? r : c <= s ? i : o;
}
function on(t, e, n) {
  const r = t.prototype = Object.create(e.prototype);
  return Object.defineProperty(r, "constructor", {
    value: t,
    writable: !0,
    enumerable: !0,
    configurable: !0
  }), ni(r, n);
}
function b_(t, e, n, r) {
  let i = e[0], o = e[e.length - 1], s;
  return i > o && (s = i, i = o, o = s), n = n === void 0 || n, r = r === void 0 || r, (n ? i <= t : i < t) && (r ? t <= o : t < o);
}
function PE(t) {
  return typeof t == "boolean";
}
function NC(t) {
  return Object.prototype.toString.call(t) === "[object Date]";
}
function PXe(t) {
  return t && ri(t[Symbol.iterator]);
}
function Po(t) {
  return typeof t == "number";
}
function kXe(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
function Cn(t) {
  return typeof t == "string";
}
function gge(t, e, n) {
  t && (t = e ? bn(t).map((a) => a.replace(/\\(.)/g, "$1")) : bn(t));
  const r = t && t.length, i = n && n.get || yXe, o = (a) => i(e ? [a] : g0(a));
  let s;
  if (!r)
    s = function() {
      return "";
    };
  else if (r === 1) {
    const a = o(t[0]);
    s = function(A) {
      return "" + a(A);
    };
  } else {
    const a = t.map(o);
    s = function(A) {
      let l = "" + a[0](A), c = 0;
      for (; ++c < r; )
        l += "|" + a[c](A);
      return l;
    };
  }
  return Yu(s, t, "key");
}
function GXe(t, e) {
  const n = t[0], r = bi(t), i = +e;
  return i ? i === 1 ? r : n + i * (r - n) : n;
}
const rtr = 1e4;
function UXe(t) {
  t = +t || rtr;
  let e, n, r;
  const i = () => {
    e = {}, n = {}, r = 0;
  }, o = (s, a) => (++r > t && (n = e, e = {}, r = 1), e[s] = a);
  return i(), {
    clear: i,
    has: (s) => Kn(e, s) || Kn(n, s),
    get: (s) => Kn(e, s) ? e[s] : Kn(n, s) ? o(s, n[s]) : void 0,
    set: (s, a) => Kn(e, s) ? e[s] = a : o(s, a)
  };
}
function HXe(t, e, n, r) {
  const i = e.length, o = n.length;
  if (!o)
    return e;
  if (!i)
    return n;
  const s = r || new e.constructor(i + o);
  let a = 0, A = 0, l = 0;
  for (; a < i && A < o; ++l)
    s[l] = t(e[a], n[A]) > 0 ? n[A++] : e[a++];
  for (; a < i; ++a, ++l)
    s[l] = e[a];
  for (; A < o; ++A, ++l)
    s[l] = n[A];
  return s;
}
function UR(t, e) {
  let n = "";
  for (; --e >= 0; )
    n += t;
  return n;
}
function $Xe(t, e, n, r) {
  const i = n || " ", o = t + "", s = e - o.length;
  return s <= 0 ? o : r === "left" ? UR(i, s) + o : r === "center" ? UR(i, ~~(s / 2)) + o + UR(i, Math.ceil(s / 2)) : o + UR(i, s);
}
function rO(t) {
  return t && bi(t) - t[0] || 0;
}
function an(t) {
  return Nt(t) ? "[" + t.map(an) + "]" : _n(t) || Cn(t) ? (
    // Output valid JSON and JS source strings.
    // See http://timelessrepo.com/json-isnt-a-javascript-subset
    JSON.stringify(t).replace("\u2028", "\\u2028").replace("\u2029", "\\u2029")
  ) : t;
}
function hge(t) {
  return t == null || t === "" ? null : !t || t === "false" || t === "0" ? !1 : !!t;
}
const itr = (t) => Po(t) || NC(t) ? t : Date.parse(t);
function dge(t, e) {
  return e = e || itr, t == null || t === "" ? null : e(t);
}
function pge(t) {
  return t == null || t === "" ? null : t + "";
}
function pd(t) {
  const e = {}, n = t.length;
  for (let r = 0; r < n; ++r)
    e[t[r]] = !0;
  return e;
}
function qXe(t, e, n, r) {
  const i = r ?? "…", o = t + "", s = o.length, a = Math.max(0, e - i.length);
  return s <= e ? o : n === "left" ? i + o.slice(s - a) : n === "center" ? o.slice(0, Math.ceil(a / 2)) + i + o.slice(s - ~~(a / 2)) : o.slice(0, a) + i;
}
function Jm(t, e, n) {
  if (t)
    if (e) {
      const r = t.length;
      for (let i = 0; i < r; ++i) {
        const o = e(t[i]);
        o && n(o, i, t);
      }
    } else
      t.forEach(n);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function otr(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function str(t, e, n) {
  if (Nt(t))
    return `[${t.map((r) => e(Cn(r) ? r : $Ne(r, n))).join(", ")}]`;
  if (_n(t)) {
    let r = "";
    const i = t, { title: o, image: s } = i, a = otr(i, ["title", "image"]);
    o && (r += `<h2>${e(o)}</h2>`), s && (r += `<img src="${e(s)}">`);
    const A = Object.keys(a);
    if (A.length > 0) {
      r += "<table>";
      for (const l of A) {
        let c = a[l];
        c !== void 0 && (_n(c) && (c = $Ne(c, n)), r += `<tr><td class="key">${e(l)}:</td><td class="value">${e(c)}</td></tr>`);
      }
      r += "</table>";
    }
    return r || "{}";
  }
  return e(t);
}
function atr(t) {
  const e = [];
  return function(n, r) {
    if (typeof r != "object" || r === null)
      return r;
    const i = e.indexOf(this) + 1;
    return e.length = i, e.length > t ? "[Object]" : e.indexOf(r) >= 0 ? "[Circular]" : (e.push(r), r);
  };
}
function $Ne(t, e) {
  return JSON.stringify(t, atr(e));
}
var Atr = `#vg-tooltip-element {
  visibility: hidden;
  padding: 8px;
  position: fixed;
  z-index: 1000;
  font-family: sans-serif;
  font-size: 11px;
  border-radius: 3px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  /* The default theme is the light theme. */
  background-color: rgba(255, 255, 255, 0.95);
  border: 1px solid #d9d9d9;
  color: black; }
  #vg-tooltip-element.visible {
    visibility: visible; }
  #vg-tooltip-element h2 {
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 13px; }
  #vg-tooltip-element img {
    max-width: 200px;
    max-height: 200px; }
  #vg-tooltip-element table {
    border-spacing: 0; }
    #vg-tooltip-element table tr {
      border: none; }
      #vg-tooltip-element table tr td {
        overflow: hidden;
        text-overflow: ellipsis;
        padding-top: 2px;
        padding-bottom: 2px; }
        #vg-tooltip-element table tr td.key {
          color: #808080;
          max-width: 150px;
          text-align: right;
          padding-right: 4px; }
        #vg-tooltip-element table tr td.value {
          display: block;
          max-width: 300px;
          max-height: 7em;
          text-align: left; }
  #vg-tooltip-element.dark-theme {
    background-color: rgba(32, 32, 32, 0.9);
    border: 1px solid #f5f5f5;
    color: white; }
    #vg-tooltip-element.dark-theme td.key {
      color: #bfbfbf; }
`;
const jXe = "vg-tooltip-element", ltr = {
  /**
   * X offset.
   */
  offsetX: 10,
  /**
   * Y offset.
   */
  offsetY: 10,
  /**
   * ID of the tooltip element.
   */
  id: jXe,
  /**
   * ID of the tooltip CSS style.
   */
  styleId: "vega-tooltip-style",
  /**
   * The name of the theme. You can use the CSS class called [THEME]-theme to style the tooltips.
   *
   * There are two predefined themes: "light" (default) and "dark".
   */
  theme: "light",
  /**
   * Do not use the default styles provided by Vega Tooltip. If you enable this option, you need to use your own styles. It is not necessary to disable the default style when using a custom theme.
   */
  disableDefaultStyle: !1,
  /**
   * HTML sanitizer function that removes dangerous HTML to prevent XSS.
   *
   * This should be a function from string to string. You may replace it with a formatter such as a markdown formatter.
   */
  sanitize: ctr,
  /**
   * The maximum recursion depth when printing objects in the tooltip.
   */
  maxDepth: 2,
  /**
   * A function to customize the rendered HTML of the tooltip.
   * @param value A value string, or object of value strings keyed by field
   * @param sanitize The `sanitize` function from `options.sanitize`
   * @returns {string} The returned string will become the `innerHTML` of the tooltip element
   */
  formatTooltip: str
};
function ctr(t) {
  return String(t).replace(/&/g, "&amp;").replace(/</g, "&lt;");
}
function utr(t) {
  if (!/^[A-Za-z]+[-:.\w]*$/.test(t))
    throw new Error("Invalid HTML ID");
  return Atr.toString().replace(jXe, t);
}
function ftr(t, e, n, r) {
  let i = t.clientX + n;
  i + e.width > window.innerWidth && (i = +t.clientX - n - e.width);
  let o = t.clientY + r;
  return o + e.height > window.innerHeight && (o = +t.clientY - r - e.height), { x: i, y: o };
}
let gtr = class {
  /**
   * Create the tooltip handler and initialize the element and style.
   *
   * @param options Tooltip Options
   */
  constructor(e) {
    this.options = Object.assign(Object.assign({}, ltr), e);
    const n = this.options.id;
    if (this.el = null, this.call = this.tooltipHandler.bind(this), !this.options.disableDefaultStyle && !document.getElementById(this.options.styleId)) {
      const r = document.createElement("style");
      r.setAttribute("id", this.options.styleId), r.innerHTML = utr(n);
      const i = document.head;
      i.childNodes.length > 0 ? i.insertBefore(r, i.childNodes[0]) : i.appendChild(r);
    }
  }
  /**
   * The tooltip handler function.
   */
  tooltipHandler(e, n, r, i) {
    var o;
    if (this.el = document.getElementById(this.options.id), this.el || (this.el = document.createElement("div"), this.el.setAttribute("id", this.options.id), this.el.classList.add("vg-tooltip"), document.body.appendChild(this.el)), ((o = document.fullscreenElement) !== null && o !== void 0 ? o : document.body).appendChild(this.el), i == null || i === "") {
      this.el.classList.remove("visible", `${this.options.theme}-theme`);
      return;
    }
    this.el.innerHTML = this.options.formatTooltip(i, this.options.sanitize, this.options.maxDepth), this.el.classList.add("visible", `${this.options.theme}-theme`);
    const { x: a, y: A } = ftr(n, this.el.getBoundingClientRect(), this.options.offsetX, this.options.offsetY);
    this.el.setAttribute("style", `top: ${A}px; left: ${a}px`);
  }
};
const qNe = {};
function Mre(t, e) {
  t === void 0 && (t = qNe), e === void 0 && (e = qNe);
  const n = Object.keys(t), r = Object.keys(e);
  return t === e || n.length === r.length && n.every((i) => t[i] === e[i]);
}
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2022 Joachim Wester
 * MIT licensed
 */
var htr = globalThis && globalThis.__extends || function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (r[o] = i[o]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), dtr = Object.prototype.hasOwnProperty;
function Ore(t, e) {
  return dtr.call(t, e);
}
function Fre(t) {
  if (Array.isArray(t)) {
    for (var e = new Array(t.length), n = 0; n < e.length; n++)
      e[n] = "" + n;
    return e;
  }
  if (Object.keys)
    return Object.keys(t);
  var r = [];
  for (var i in t)
    Ore(t, i) && r.push(i);
  return r;
}
function Df(t) {
  switch (typeof t) {
    case "object":
      return JSON.parse(JSON.stringify(t));
    case "undefined":
      return null;
    default:
      return t;
  }
}
function Pre(t) {
  for (var e = 0, n = t.length, r; e < n; ) {
    if (r = t.charCodeAt(e), r >= 48 && r <= 57) {
      e++;
      continue;
    }
    return !1;
  }
  return !0;
}
function $y(t) {
  return t.indexOf("/") === -1 && t.indexOf("~") === -1 ? t : t.replace(/~/g, "~0").replace(/\//g, "~1");
}
function YXe(t) {
  return t.replace(/~1/g, "/").replace(/~0/g, "~");
}
function kre(t) {
  if (t === void 0)
    return !0;
  if (t) {
    if (Array.isArray(t)) {
      for (var e = 0, n = t.length; e < n; e++)
        if (kre(t[e]))
          return !0;
    } else if (typeof t == "object") {
      for (var r = Fre(t), i = r.length, o = 0; o < i; o++)
        if (kre(t[r[o]]))
          return !0;
    }
  }
  return !1;
}
function jNe(t, e) {
  var n = [t];
  for (var r in e) {
    var i = typeof e[r] == "object" ? JSON.stringify(e[r], null, 2) : e[r];
    typeof i < "u" && n.push(r + ": " + i);
  }
  return n.join(`
`);
}
var zXe = (
  /** @class */
  function(t) {
    htr(e, t);
    function e(n, r, i, o, s) {
      var a = this.constructor, A = t.call(this, jNe(n, { name: r, index: i, operation: o, tree: s })) || this;
      return A.name = r, A.index = i, A.operation = o, A.tree = s, Object.setPrototypeOf(A, a.prototype), A.message = jNe(n, { name: r, index: i, operation: o, tree: s }), A;
    }
    return e;
  }(Error)
), ca = zXe, ptr = Df, __ = {
  add: function(t, e, n) {
    return t[e] = this.value, { newDocument: n };
  },
  remove: function(t, e, n) {
    var r = t[e];
    return delete t[e], { newDocument: n, removed: r };
  },
  replace: function(t, e, n) {
    var r = t[e];
    return t[e] = this.value, { newDocument: n, removed: r };
  },
  move: function(t, e, n) {
    var r = d5(n, this.path);
    r && (r = Df(r));
    var i = Dv(n, { op: "remove", path: this.from }).removed;
    return Dv(n, { op: "add", path: this.path, value: i }), { newDocument: n, removed: r };
  },
  copy: function(t, e, n) {
    var r = d5(n, this.from);
    return Dv(n, { op: "add", path: this.path, value: Df(r) }), { newDocument: n };
  },
  test: function(t, e, n) {
    return { newDocument: n, test: pN(t[e], this.value) };
  },
  _get: function(t, e, n) {
    return this.value = t[e], { newDocument: n };
  }
}, Itr = {
  add: function(t, e, n) {
    return Pre(e) ? t.splice(e, 0, this.value) : t[e] = this.value, { newDocument: n, index: e };
  },
  remove: function(t, e, n) {
    var r = t.splice(e, 1);
    return { newDocument: n, removed: r[0] };
  },
  replace: function(t, e, n) {
    var r = t[e];
    return t[e] = this.value, { newDocument: n, removed: r };
  },
  move: __.move,
  copy: __.copy,
  test: __.test,
  _get: __._get
};
function d5(t, e) {
  if (e == "")
    return t;
  var n = { op: "_get", path: e };
  return Dv(t, n), n.value;
}
function Dv(t, e, n, r, i, o) {
  if (n === void 0 && (n = !1), r === void 0 && (r = !0), i === void 0 && (i = !0), o === void 0 && (o = 0), n && (typeof n == "function" ? n(e, 0, t, e.path) : p5(e, 0)), e.path === "") {
    var s = { newDocument: t };
    if (e.op === "add")
      return s.newDocument = e.value, s;
    if (e.op === "replace")
      return s.newDocument = e.value, s.removed = t, s;
    if (e.op === "move" || e.op === "copy")
      return s.newDocument = d5(t, e.from), e.op === "move" && (s.removed = t), s;
    if (e.op === "test") {
      if (s.test = pN(t, e.value), s.test === !1)
        throw new ca("Test operation failed", "TEST_OPERATION_FAILED", o, e, t);
      return s.newDocument = t, s;
    } else {
      if (e.op === "remove")
        return s.removed = t, s.newDocument = null, s;
      if (e.op === "_get")
        return e.value = t, s;
      if (n)
        throw new ca("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", o, e, t);
      return s;
    }
  } else {
    r || (t = Df(t));
    var a = e.path || "", A = a.split("/"), l = t, c = 1, u = A.length, f = void 0, h = void 0, d = void 0;
    for (typeof n == "function" ? d = n : d = p5; ; ) {
      if (h = A[c], h && h.indexOf("~") != -1 && (h = YXe(h)), i && (h == "__proto__" || h == "prototype" && c > 0 && A[c - 1] == "constructor"))
        throw new TypeError("JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
      if (n && f === void 0 && (l[h] === void 0 ? f = A.slice(0, c).join("/") : c == u - 1 && (f = e.path), f !== void 0 && d(e, 0, t, f)), c++, Array.isArray(l)) {
        if (h === "-")
          h = l.length;
        else {
          if (n && !Pre(h))
            throw new ca("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", o, e, t);
          Pre(h) && (h = ~~h);
        }
        if (c >= u) {
          if (n && e.op === "add" && h > l.length)
            throw new ca("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", o, e, t);
          var s = Itr[e.op].call(e, l, h, t);
          if (s.test === !1)
            throw new ca("Test operation failed", "TEST_OPERATION_FAILED", o, e, t);
          return s;
        }
      } else if (c >= u) {
        var s = __[e.op].call(e, l, h, t);
        if (s.test === !1)
          throw new ca("Test operation failed", "TEST_OPERATION_FAILED", o, e, t);
        return s;
      }
      if (l = l[h], n && c < u && (!l || typeof l != "object"))
        throw new ca("Cannot perform operation at the desired path", "OPERATION_PATH_UNRESOLVABLE", o, e, t);
    }
  }
}
function Aj(t, e, n, r, i) {
  if (r === void 0 && (r = !0), i === void 0 && (i = !0), n && !Array.isArray(e))
    throw new ca("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
  r || (t = Df(t));
  for (var o = new Array(e.length), s = 0, a = e.length; s < a; s++)
    o[s] = Dv(t, e[s], n, !0, i, s), t = o[s].newDocument;
  return o.newDocument = t, o;
}
function mtr(t, e, n) {
  var r = Dv(t, e);
  if (r.test === !1)
    throw new ca("Test operation failed", "TEST_OPERATION_FAILED", n, e, t);
  return r.newDocument;
}
function p5(t, e, n, r) {
  if (typeof t != "object" || t === null || Array.isArray(t))
    throw new ca("Operation is not an object", "OPERATION_NOT_AN_OBJECT", e, t, n);
  if (__[t.op]) {
    if (typeof t.path != "string")
      throw new ca("Operation `path` property is not a string", "OPERATION_PATH_INVALID", e, t, n);
    if (t.path.indexOf("/") !== 0 && t.path.length > 0)
      throw new ca('Operation `path` property must start with "/"', "OPERATION_PATH_INVALID", e, t, n);
    if ((t.op === "move" || t.op === "copy") && typeof t.from != "string")
      throw new ca("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", e, t, n);
    if ((t.op === "add" || t.op === "replace" || t.op === "test") && t.value === void 0)
      throw new ca("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", e, t, n);
    if ((t.op === "add" || t.op === "replace" || t.op === "test") && kre(t.value))
      throw new ca("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", e, t, n);
    if (n) {
      if (t.op == "add") {
        var i = t.path.split("/").length, o = r.split("/").length;
        if (i !== o + 1 && i !== o)
          throw new ca("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", e, t, n);
      } else if (t.op === "replace" || t.op === "remove" || t.op === "_get") {
        if (t.path !== r)
          throw new ca("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", e, t, n);
      } else if (t.op === "move" || t.op === "copy") {
        var s = { op: "_get", path: t.from, value: void 0 }, a = VXe([s], n);
        if (a && a.name === "OPERATION_PATH_UNRESOLVABLE")
          throw new ca("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", e, t, n);
      }
    }
  } else
    throw new ca("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", e, t, n);
}
function VXe(t, e, n) {
  try {
    if (!Array.isArray(t))
      throw new ca("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    if (e)
      Aj(Df(e), Df(t), n || !0);
    else {
      n = n || p5;
      for (var r = 0; r < t.length; r++)
        n(t[r], r, e, void 0);
    }
  } catch (i) {
    if (i instanceof ca)
      return i;
    throw i;
  }
}
function pN(t, e) {
  if (t === e)
    return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    var n = Array.isArray(t), r = Array.isArray(e), i, o, s;
    if (n && r) {
      if (o = t.length, o != e.length)
        return !1;
      for (i = o; i-- !== 0; )
        if (!pN(t[i], e[i]))
          return !1;
      return !0;
    }
    if (n != r)
      return !1;
    var a = Object.keys(t);
    if (o = a.length, o !== Object.keys(e).length)
      return !1;
    for (i = o; i-- !== 0; )
      if (!e.hasOwnProperty(a[i]))
        return !1;
    for (i = o; i-- !== 0; )
      if (s = a[i], !pN(t[s], e[s]))
        return !1;
    return !0;
  }
  return t !== t && e !== e;
}
const Ctr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  JsonPatchError: ca,
  _areEquals: pN,
  applyOperation: Dv,
  applyPatch: Aj,
  applyReducer: mtr,
  deepClone: ptr,
  getValueByPointer: d5,
  validate: VXe,
  validator: p5
}, Symbol.toStringTag, { value: "Module" }));
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2021 Joachim Wester
 * MIT license
 */
var Ige = /* @__PURE__ */ new WeakMap(), Etr = (
  /** @class */
  function() {
    function t(e) {
      this.observers = /* @__PURE__ */ new Map(), this.obj = e;
    }
    return t;
  }()
), ytr = (
  /** @class */
  function() {
    function t(e, n) {
      this.callback = e, this.observer = n;
    }
    return t;
  }()
);
function vtr(t) {
  return Ige.get(t);
}
function Btr(t, e) {
  return t.observers.get(e);
}
function btr(t, e) {
  t.observers.delete(e.callback);
}
function _tr(t, e) {
  e.unobserve();
}
function Str(t, e) {
  var n = [], r, i = vtr(t);
  if (!i)
    i = new Etr(t), Ige.set(t, i);
  else {
    var o = Btr(i, e);
    r = o && o.observer;
  }
  if (r)
    return r;
  if (r = {}, i.value = Df(t), e) {
    r.callback = e, r.next = null;
    var s = function() {
      Gre(r);
    }, a = function() {
      clearTimeout(r.next), r.next = setTimeout(s);
    };
    typeof window < "u" && (window.addEventListener("mouseup", a), window.addEventListener("keyup", a), window.addEventListener("mousedown", a), window.addEventListener("keydown", a), window.addEventListener("change", a));
  }
  return r.patches = n, r.object = t, r.unobserve = function() {
    Gre(r), clearTimeout(r.next), btr(i, r), typeof window < "u" && (window.removeEventListener("mouseup", a), window.removeEventListener("keyup", a), window.removeEventListener("mousedown", a), window.removeEventListener("keydown", a), window.removeEventListener("change", a));
  }, i.observers.set(e, new ytr(e, r)), r;
}
function Gre(t, e) {
  e === void 0 && (e = !1);
  var n = Ige.get(t.object);
  mge(n.value, t.object, t.patches, "", e), t.patches.length && Aj(n.value, t.patches);
  var r = t.patches;
  return r.length > 0 && (t.patches = [], t.callback && t.callback(r)), r;
}
function mge(t, e, n, r, i) {
  if (e !== t) {
    typeof e.toJSON == "function" && (e = e.toJSON());
    for (var o = Fre(e), s = Fre(t), a = !1, A = s.length - 1; A >= 0; A--) {
      var l = s[A], c = t[l];
      if (Ore(e, l) && !(e[l] === void 0 && c !== void 0 && Array.isArray(e) === !1)) {
        var u = e[l];
        typeof c == "object" && c != null && typeof u == "object" && u != null && Array.isArray(c) === Array.isArray(u) ? mge(c, u, n, r + "/" + $y(l), i) : c !== u && (i && n.push({ op: "test", path: r + "/" + $y(l), value: Df(c) }), n.push({ op: "replace", path: r + "/" + $y(l), value: Df(u) }));
      } else
        Array.isArray(t) === Array.isArray(e) ? (i && n.push({ op: "test", path: r + "/" + $y(l), value: Df(c) }), n.push({ op: "remove", path: r + "/" + $y(l) }), a = !0) : (i && n.push({ op: "test", path: r, value: t }), n.push({ op: "replace", path: r, value: e }));
    }
    if (!(!a && o.length == s.length))
      for (var A = 0; A < o.length; A++) {
        var l = o[A];
        !Ore(t, l) && e[l] !== void 0 && n.push({ op: "add", path: r + "/" + $y(l), value: Df(e[l]) });
      }
  }
}
function Qtr(t, e, n) {
  n === void 0 && (n = !1);
  var r = [];
  return mge(t, e, r, "", n), r;
}
const wtr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compare: Qtr,
  generate: Gre,
  observe: Str,
  unobserve: _tr
}, Symbol.toStringTag, { value: "Module" }));
Object.assign({}, Ctr, wtr, {
  JsonPatchError: zXe,
  deepClone: Df,
  escapePathComponent: $y,
  unescapePathComponent: YXe
});
var xtr = /("(?:[^\\"]|\\.)*")|[:,]/g, Rtr = function(e, n) {
  var r, i, o;
  return n = n || {}, r = JSON.stringify(
    [1],
    void 0,
    n.indent === void 0 ? 2 : n.indent
  ).slice(2, -3), i = r === "" ? 1 / 0 : n.maxLength === void 0 ? 80 : n.maxLength, o = n.replacer, function s(a, A, l) {
    var c, u, f, h, d, I, m, C, y, v, b, Q;
    if (a && typeof a.toJSON == "function" && (a = a.toJSON()), b = JSON.stringify(a, o), b === void 0)
      return b;
    if (m = i - A.length - l, b.length <= m && (y = b.replace(
      xtr,
      function(w, R) {
        return R || w + " ";
      }
    ), y.length <= m))
      return y;
    if (o != null && (a = JSON.parse(b), o = void 0), typeof a == "object" && a !== null) {
      if (C = A + r, f = [], u = 0, Array.isArray(a))
        for (v = "[", c = "]", m = a.length; u < m; u++)
          f.push(
            s(a[u], C, u === m - 1 ? 0 : 1) || "null"
          );
      else
        for (v = "{", c = "}", I = Object.keys(a), m = I.length; u < m; u++)
          h = I[u], d = JSON.stringify(h) + ": ", Q = s(
            a[h],
            C,
            d.length + (u === m - 1 ? 0 : 1)
          ), Q !== void 0 && f.push(d + Q);
      if (f.length > 0)
        return [v, r + f.join(`,
` + C), c].join(
          `
` + A
        );
    }
    return b;
  }(e, "", 0);
};
const nW = /* @__PURE__ */ ko(Rtr);
var YNe = {}, rW = {}, iW = 34, P2 = 10, oW = 13;
function JXe(t) {
  return new Function("d", "return {" + t.map(function(e, n) {
    return JSON.stringify(e) + ": d[" + n + '] || ""';
  }).join(",") + "}");
}
function Dtr(t, e) {
  var n = JXe(t);
  return function(r, i) {
    return e(n(r), i, t);
  };
}
function zNe(t) {
  var e = /* @__PURE__ */ Object.create(null), n = [];
  return t.forEach(function(r) {
    for (var i in r)
      i in e || n.push(e[i] = i);
  }), n;
}
function pu(t, e) {
  var n = t + "", r = n.length;
  return r < e ? new Array(e - r + 1).join(0) + n : n;
}
function Ttr(t) {
  return t < 0 ? "-" + pu(-t, 6) : t > 9999 ? "+" + pu(t, 6) : pu(t, 4);
}
function Ntr(t) {
  var e = t.getUTCHours(), n = t.getUTCMinutes(), r = t.getUTCSeconds(), i = t.getUTCMilliseconds();
  return isNaN(t) ? "Invalid Date" : Ttr(t.getUTCFullYear()) + "-" + pu(t.getUTCMonth() + 1, 2) + "-" + pu(t.getUTCDate(), 2) + (i ? "T" + pu(e, 2) + ":" + pu(n, 2) + ":" + pu(r, 2) + "." + pu(i, 3) + "Z" : r ? "T" + pu(e, 2) + ":" + pu(n, 2) + ":" + pu(r, 2) + "Z" : n || e ? "T" + pu(e, 2) + ":" + pu(n, 2) + "Z" : "");
}
function Ltr(t) {
  var e = new RegExp('["' + t + `
\r]`), n = t.charCodeAt(0);
  function r(u, f) {
    var h, d, I = i(u, function(m, C) {
      if (h)
        return h(m, C - 1);
      d = m, h = f ? Dtr(m, f) : JXe(m);
    });
    return I.columns = d || [], I;
  }
  function i(u, f) {
    var h = [], d = u.length, I = 0, m = 0, C, y = d <= 0, v = !1;
    u.charCodeAt(d - 1) === P2 && --d, u.charCodeAt(d - 1) === oW && --d;
    function b() {
      if (y)
        return rW;
      if (v)
        return v = !1, YNe;
      var w, R = I, M;
      if (u.charCodeAt(R) === iW) {
        for (; I++ < d && u.charCodeAt(I) !== iW || u.charCodeAt(++I) === iW; )
          ;
        return (w = I) >= d ? y = !0 : (M = u.charCodeAt(I++)) === P2 ? v = !0 : M === oW && (v = !0, u.charCodeAt(I) === P2 && ++I), u.slice(R + 1, w - 1).replace(/""/g, '"');
      }
      for (; I < d; ) {
        if ((M = u.charCodeAt(w = I++)) === P2)
          v = !0;
        else if (M === oW)
          v = !0, u.charCodeAt(I) === P2 && ++I;
        else if (M !== n)
          continue;
        return u.slice(R, w);
      }
      return y = !0, u.slice(R, d);
    }
    for (; (C = b()) !== rW; ) {
      for (var Q = []; C !== YNe && C !== rW; )
        Q.push(C), C = b();
      f && (Q = f(Q, m++)) == null || h.push(Q);
    }
    return h;
  }
  function o(u, f) {
    return u.map(function(h) {
      return f.map(function(d) {
        return c(h[d]);
      }).join(t);
    });
  }
  function s(u, f) {
    return f == null && (f = zNe(u)), [f.map(c).join(t)].concat(o(u, f)).join(`
`);
  }
  function a(u, f) {
    return f == null && (f = zNe(u)), o(u, f).join(`
`);
  }
  function A(u) {
    return u.map(l).join(`
`);
  }
  function l(u) {
    return u.map(c).join(t);
  }
  function c(u) {
    return u == null ? "" : u instanceof Date ? Ntr(u) : e.test(u += "") ? '"' + u.replace(/"/g, '""') + '"' : u;
  }
  return {
    parse: r,
    parseRows: i,
    format: s,
    formatBody: a,
    formatRows: A,
    formatRow: l,
    formatValue: c
  };
}
function Mtr(t) {
  return t;
}
function Otr(t) {
  if (t == null)
    return Mtr;
  var e, n, r = t.scale[0], i = t.scale[1], o = t.translate[0], s = t.translate[1];
  return function(a, A) {
    A || (e = n = 0);
    var l = 2, c = a.length, u = new Array(c);
    for (u[0] = (e += a[0]) * r + o, u[1] = (n += a[1]) * i + s; l < c; )
      u[l] = a[l], ++l;
    return u;
  };
}
function Ftr(t, e) {
  for (var n, r = t.length, i = r - e; i < --r; )
    n = t[i], t[i++] = t[r], t[r] = n;
}
function Ptr(t, e) {
  return typeof e == "string" && (e = t.objects[e]), e.type === "GeometryCollection" ? { type: "FeatureCollection", features: e.geometries.map(function(n) {
    return VNe(t, n);
  }) } : VNe(t, e);
}
function VNe(t, e) {
  var n = e.id, r = e.bbox, i = e.properties == null ? {} : e.properties, o = KXe(t, e);
  return n == null && r == null ? { type: "Feature", properties: i, geometry: o } : r == null ? { type: "Feature", id: n, properties: i, geometry: o } : { type: "Feature", id: n, bbox: r, properties: i, geometry: o };
}
function KXe(t, e) {
  var n = Otr(t.transform), r = t.arcs;
  function i(c, u) {
    u.length && u.pop();
    for (var f = r[c < 0 ? ~c : c], h = 0, d = f.length; h < d; ++h)
      u.push(n(f[h], h));
    c < 0 && Ftr(u, d);
  }
  function o(c) {
    return n(c);
  }
  function s(c) {
    for (var u = [], f = 0, h = c.length; f < h; ++f)
      i(c[f], u);
    return u.length < 2 && u.push(u[0]), u;
  }
  function a(c) {
    for (var u = s(c); u.length < 4; )
      u.push(u[0]);
    return u;
  }
  function A(c) {
    return c.map(a);
  }
  function l(c) {
    var u = c.type, f;
    switch (u) {
      case "GeometryCollection":
        return { type: u, geometries: c.geometries.map(l) };
      case "Point":
        f = o(c.coordinates);
        break;
      case "MultiPoint":
        f = c.coordinates.map(o);
        break;
      case "LineString":
        f = s(c.arcs);
        break;
      case "MultiLineString":
        f = c.arcs.map(s);
        break;
      case "Polygon":
        f = A(c.arcs);
        break;
      case "MultiPolygon":
        f = c.arcs.map(A);
        break;
      default:
        return null;
    }
    return { type: u, coordinates: f };
  }
  return l(e);
}
function ktr(t, e) {
  var n = {}, r = {}, i = {}, o = [], s = -1;
  e.forEach(function(l, c) {
    var u = t.arcs[l < 0 ? ~l : l], f;
    u.length < 3 && !u[1][0] && !u[1][1] && (f = e[++s], e[s] = l, e[c] = f);
  }), e.forEach(function(l) {
    var c = a(l), u = c[0], f = c[1], h, d;
    if (h = i[u])
      if (delete i[h.end], h.push(l), h.end = f, d = r[f]) {
        delete r[d.start];
        var I = d === h ? h : h.concat(d);
        r[I.start = h.start] = i[I.end = d.end] = I;
      } else
        r[h.start] = i[h.end] = h;
    else if (h = r[f])
      if (delete r[h.start], h.unshift(l), h.start = u, d = i[u]) {
        delete i[d.end];
        var m = d === h ? h : d.concat(h);
        r[m.start = d.start] = i[m.end = h.end] = m;
      } else
        r[h.start] = i[h.end] = h;
    else
      h = [l], r[h.start = u] = i[h.end = f] = h;
  });
  function a(l) {
    var c = t.arcs[l < 0 ? ~l : l], u = c[0], f;
    return t.transform ? (f = [0, 0], c.forEach(function(h) {
      f[0] += h[0], f[1] += h[1];
    })) : f = c[c.length - 1], l < 0 ? [f, u] : [u, f];
  }
  function A(l, c) {
    for (var u in l) {
      var f = l[u];
      delete c[f.start], delete f.start, delete f.end, f.forEach(function(h) {
        n[h < 0 ? ~h : h] = 1;
      }), o.push(f);
    }
  }
  return A(i, r), A(r, i), e.forEach(function(l) {
    n[l < 0 ? ~l : l] || o.push([l]);
  }), o;
}
function Gtr(t) {
  return KXe(t, Utr.apply(this, arguments));
}
function Utr(t, e, n) {
  var r, i, o;
  if (arguments.length > 1)
    r = Htr(t, e, n);
  else
    for (i = 0, r = new Array(o = t.arcs.length); i < o; ++i)
      r[i] = i;
  return { type: "MultiLineString", arcs: ktr(t, r) };
}
function Htr(t, e, n) {
  var r = [], i = [], o;
  function s(u) {
    var f = u < 0 ? ~u : u;
    (i[f] || (i[f] = [])).push({ i: u, g: o });
  }
  function a(u) {
    u.forEach(s);
  }
  function A(u) {
    u.forEach(a);
  }
  function l(u) {
    u.forEach(A);
  }
  function c(u) {
    switch (o = u, u.type) {
      case "GeometryCollection":
        u.geometries.forEach(c);
        break;
      case "LineString":
        a(u.arcs);
        break;
      case "MultiLineString":
      case "Polygon":
        A(u.arcs);
        break;
      case "MultiPolygon":
        l(u.arcs);
        break;
    }
  }
  return c(e), i.forEach(n == null ? function(u) {
    r.push(u[0].i);
  } : function(u) {
    n(u[0].g, u[u.length - 1].g) && r.push(u[0].i);
  }), r;
}
function LC(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function $tr(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function lj(t) {
  let e, n, r;
  t.length !== 2 ? (e = LC, n = (a, A) => LC(t(a), A), r = (a, A) => t(a) - A) : (e = t === LC || t === $tr ? t : qtr, n = t, r = t);
  function i(a, A, l = 0, c = a.length) {
    if (l < c) {
      if (e(A, A) !== 0)
        return c;
      do {
        const u = l + c >>> 1;
        n(a[u], A) < 0 ? l = u + 1 : c = u;
      } while (l < c);
    }
    return l;
  }
  function o(a, A, l = 0, c = a.length) {
    if (l < c) {
      if (e(A, A) !== 0)
        return c;
      do {
        const u = l + c >>> 1;
        n(a[u], A) <= 0 ? l = u + 1 : c = u;
      } while (l < c);
    }
    return l;
  }
  function s(a, A, l = 0, c = a.length) {
    const u = i(a, A, l, c - 1);
    return u > l && r(a[u - 1], A) > -r(a[u], A) ? u - 1 : u;
  }
  return { left: i, center: s, right: o };
}
function qtr() {
  return 0;
}
function WXe(t) {
  return t === null ? NaN : +t;
}
function* jtr(t, e) {
  if (e === void 0)
    for (let n of t)
      n != null && (n = +n) >= n && (yield n);
  else {
    let n = -1;
    for (let r of t)
      (r = e(r, ++n, t)) != null && (r = +r) >= r && (yield r);
  }
}
const XXe = lj(LC), I5 = XXe.right, Ytr = XXe.left;
lj(WXe).center;
const ztr = I5;
function Vtr(t, e) {
  let n = 0, r, i = 0, o = 0;
  if (e === void 0)
    for (let s of t)
      s != null && (s = +s) >= s && (r = s - i, i += r / ++n, o += r * (s - i));
  else {
    let s = -1;
    for (let a of t)
      (a = e(a, ++s, t)) != null && (a = +a) >= a && (r = a - i, i += r / ++n, o += r * (a - i));
  }
  if (n > 1)
    return o / (n - 1);
}
function Jtr(t, e) {
  const n = Vtr(t, e);
  return n && Math.sqrt(n);
}
function Ktr(t, e) {
  return Array.from(e, (n) => t[n]);
}
function Wtr(t = LC) {
  if (t === LC)
    return ZXe;
  if (typeof t != "function")
    throw new TypeError("compare is not a function");
  return (e, n) => {
    const r = t(e, n);
    return r || r === 0 ? r : (t(n, n) === 0) - (t(e, e) === 0);
  };
}
function ZXe(t, e) {
  return (t == null || !(t >= t)) - (e == null || !(e >= e)) || (t < e ? -1 : t > e ? 1 : 0);
}
var Xtr = Math.sqrt(50), Ztr = Math.sqrt(10), enr = Math.sqrt(2);
function IN(t, e, n) {
  var r = Math.abs(e - t) / Math.max(0, n), i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)), o = r / i;
  return o >= Xtr ? i *= 10 : o >= Ztr ? i *= 5 : o >= enr && (i *= 2), e < t ? -i : i;
}
function Tv(t, e) {
  let n;
  if (e === void 0)
    for (const r of t)
      r != null && (n < r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let i of t)
      (i = e(i, ++r, t)) != null && (n < i || n === void 0 && i >= i) && (n = i);
  }
  return n;
}
function Ure(t, e) {
  let n;
  if (e === void 0)
    for (const r of t)
      r != null && (n > r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let i of t)
      (i = e(i, ++r, t)) != null && (n > i || n === void 0 && i >= i) && (n = i);
  }
  return n;
}
function eZe(t, e, n = 0, r = t.length - 1, i) {
  for (i = i === void 0 ? ZXe : Wtr(i); r > n; ) {
    if (r - n > 600) {
      const A = r - n + 1, l = e - n + 1, c = Math.log(A), u = 0.5 * Math.exp(2 * c / 3), f = 0.5 * Math.sqrt(c * u * (A - u) / A) * (l - A / 2 < 0 ? -1 : 1), h = Math.max(n, Math.floor(e - l * u / A + f)), d = Math.min(r, Math.floor(e + (A - l) * u / A + f));
      eZe(t, e, h, d, i);
    }
    const o = t[e];
    let s = n, a = r;
    for (k2(t, n, e), i(t[r], o) > 0 && k2(t, n, r); s < a; ) {
      for (k2(t, s, a), ++s, --a; i(t[s], o) < 0; )
        ++s;
      for (; i(t[a], o) > 0; )
        --a;
    }
    i(t[n], o) === 0 ? k2(t, n, a) : (++a, k2(t, a, r)), a <= e && (n = a + 1), e <= a && (r = a - 1);
  }
  return t;
}
function k2(t, e, n) {
  const r = t[e];
  t[e] = t[n], t[n] = r;
}
function Hre(t, e, n) {
  if (t = Float64Array.from(jtr(t, n)), !!(r = t.length)) {
    if ((e = +e) <= 0 || r < 2)
      return Ure(t);
    if (e >= 1)
      return Tv(t);
    var r, i = (r - 1) * e, o = Math.floor(i), s = Tv(eZe(t, o).subarray(0, o + 1)), a = Ure(t.subarray(o + 1));
    return s + (a - s) * (i - o);
  }
}
function tnr(t, e, n = WXe) {
  if (r = t.length) {
    if ((e = +e) <= 0 || r < 2)
      return +n(t[0], 0, t);
    if (e >= 1)
      return +n(t[r - 1], r - 1, t);
    var r, i = (r - 1) * e, o = Math.floor(i), s = +n(t[o], o, t), a = +n(t[o + 1], o + 1, t);
    return s + (a - s) * (i - o);
  }
}
function nnr(t, e) {
  let n = 0, r = 0;
  if (e === void 0)
    for (let i of t)
      i != null && (i = +i) >= i && (++n, r += i);
  else {
    let i = -1;
    for (let o of t)
      (o = e(o, ++i, t)) != null && (o = +o) >= o && (++n, r += o);
  }
  if (n)
    return r / n;
}
function tZe(t, e) {
  return Hre(t, 0.5, e);
}
function E1(t, e, n) {
  t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((e - t) / n)) | 0, o = new Array(i); ++r < i; )
    o[r] = t + r * n;
  return o;
}
function nZe(t, e) {
  let n = 0;
  if (e === void 0)
    for (let r of t)
      (r = +r) && (n += r);
  else {
    let r = -1;
    for (let i of t)
      (i = +e(i, ++r, t)) && (n += i);
  }
  return n;
}
function rnr(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function m5(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0)
    return null;
  var n, r = t.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +t.slice(n + 1)
  ];
}
function gQ(t) {
  return t = m5(Math.abs(t)), t ? t[1] : NaN;
}
function inr(t, e) {
  return function(n, r) {
    for (var i = n.length, o = [], s = 0, a = t[0], A = 0; i > 0 && a > 0 && (A + a + 1 > r && (a = Math.max(1, r - A)), o.push(n.substring(i -= a, i + a)), !((A += a + 1) > r)); )
      a = t[s = (s + 1) % t.length];
    return o.reverse().join(e);
  };
}
function onr(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(n) {
      return t[+n];
    });
  };
}
var snr = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function IB(t) {
  if (!(e = snr.exec(t)))
    throw new Error("invalid format: " + t);
  var e;
  return new Cge({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
IB.prototype = Cge.prototype;
function Cge(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
Cge.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function anr(t) {
  e:
    for (var e = t.length, n = 1, r = -1, i; n < e; ++n)
      switch (t[n]) {
        case ".":
          r = i = n;
          break;
        case "0":
          r === 0 && (r = n), i = n;
          break;
        default:
          if (!+t[n])
            break e;
          r > 0 && (r = 0);
          break;
      }
  return r > 0 ? t.slice(0, r) + t.slice(i + 1) : t;
}
var rZe;
function Anr(t, e) {
  var n = m5(t, e);
  if (!n)
    return t + "";
  var r = n[0], i = n[1], o = i - (rZe = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, s = r.length;
  return o === s ? r : o > s ? r + new Array(o - s + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + m5(t, Math.max(0, e + o - 1))[0];
}
function JNe(t, e) {
  var n = m5(t, e);
  if (!n)
    return t + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const KNe = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: rnr,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => JNe(t * 100, e),
  r: JNe,
  s: Anr,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function WNe(t) {
  return t;
}
var XNe = Array.prototype.map, ZNe = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function iZe(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? WNe : inr(XNe.call(t.grouping, Number), t.thousands + ""), n = t.currency === void 0 ? "" : t.currency[0] + "", r = t.currency === void 0 ? "" : t.currency[1] + "", i = t.decimal === void 0 ? "." : t.decimal + "", o = t.numerals === void 0 ? WNe : onr(XNe.call(t.numerals, String)), s = t.percent === void 0 ? "%" : t.percent + "", a = t.minus === void 0 ? "−" : t.minus + "", A = t.nan === void 0 ? "NaN" : t.nan + "";
  function l(u) {
    u = IB(u);
    var f = u.fill, h = u.align, d = u.sign, I = u.symbol, m = u.zero, C = u.width, y = u.comma, v = u.precision, b = u.trim, Q = u.type;
    Q === "n" ? (y = !0, Q = "g") : KNe[Q] || (v === void 0 && (v = 12), b = !0, Q = "g"), (m || f === "0" && h === "=") && (m = !0, f = "0", h = "=");
    var w = I === "$" ? n : I === "#" && /[boxX]/.test(Q) ? "0" + Q.toLowerCase() : "", R = I === "$" ? r : /[%p]/.test(Q) ? s : "", M = KNe[Q], O = /[defgprs%]/.test(Q);
    v = v === void 0 ? 6 : /[gprs]/.test(Q) ? Math.max(1, Math.min(21, v)) : Math.max(0, Math.min(20, v));
    function L(N) {
      var k = w, $ = R, U, X, K;
      if (Q === "c")
        $ = M(N) + $, N = "";
      else {
        N = +N;
        var z = N < 0 || 1 / N < 0;
        if (N = isNaN(N) ? A : M(Math.abs(N), v), b && (N = anr(N)), z && +N == 0 && d !== "+" && (z = !1), k = (z ? d === "(" ? d : a : d === "-" || d === "(" ? "" : d) + k, $ = (Q === "s" ? ZNe[8 + rZe / 3] : "") + $ + (z && d === "(" ? ")" : ""), O) {
          for (U = -1, X = N.length; ++U < X; )
            if (K = N.charCodeAt(U), 48 > K || K > 57) {
              $ = (K === 46 ? i + N.slice(U + 1) : N.slice(U)) + $, N = N.slice(0, U);
              break;
            }
        }
      }
      y && !m && (N = e(N, 1 / 0));
      var Y = k.length + N.length + $.length, V = Y < C ? new Array(C - Y + 1).join(f) : "";
      switch (y && m && (N = e(V + N, V.length ? C - $.length : 1 / 0), V = ""), h) {
        case "<":
          N = k + N + $ + V;
          break;
        case "=":
          N = k + V + N + $;
          break;
        case "^":
          N = V.slice(0, Y = V.length >> 1) + k + N + $ + V.slice(Y);
          break;
        default:
          N = V + k + N + $;
          break;
      }
      return o(N);
    }
    return L.toString = function() {
      return u + "";
    }, L;
  }
  function c(u, f) {
    var h = l((u = IB(u), u.type = "f", u)), d = Math.max(-8, Math.min(8, Math.floor(gQ(f) / 3))) * 3, I = Math.pow(10, -d), m = ZNe[8 + d / 3];
    return function(C) {
      return h(I * C) + m;
    };
  }
  return {
    format: l,
    formatPrefix: c
  };
}
var g3, cj, Ege;
lnr({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function lnr(t) {
  return g3 = iZe(t), cj = g3.format, Ege = g3.formatPrefix, g3;
}
function oZe(t) {
  return Math.max(0, -gQ(Math.abs(t)));
}
function sZe(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(gQ(e) / 3))) * 3 - gQ(Math.abs(t)));
}
function aZe(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, gQ(e) - gQ(t)) + 1;
}
var sW = /* @__PURE__ */ new Date(), aW = /* @__PURE__ */ new Date();
function zA(t, e, n, r) {
  function i(o) {
    return t(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
  }
  return i.floor = function(o) {
    return t(o = /* @__PURE__ */ new Date(+o)), o;
  }, i.ceil = function(o) {
    return t(o = new Date(o - 1)), e(o, 1), t(o), o;
  }, i.round = function(o) {
    var s = i(o), a = i.ceil(o);
    return o - s < a - o ? s : a;
  }, i.offset = function(o, s) {
    return e(o = /* @__PURE__ */ new Date(+o), s == null ? 1 : Math.floor(s)), o;
  }, i.range = function(o, s, a) {
    var A = [], l;
    if (o = i.ceil(o), a = a == null ? 1 : Math.floor(a), !(o < s) || !(a > 0))
      return A;
    do
      A.push(l = /* @__PURE__ */ new Date(+o)), e(o, a), t(o);
    while (l < o && o < s);
    return A;
  }, i.filter = function(o) {
    return zA(function(s) {
      if (s >= s)
        for (; t(s), !o(s); )
          s.setTime(s - 1);
    }, function(s, a) {
      if (s >= s)
        if (a < 0)
          for (; ++a <= 0; )
            for (; e(s, -1), !o(s); )
              ;
        else
          for (; --a >= 0; )
            for (; e(s, 1), !o(s); )
              ;
    });
  }, n && (i.count = function(o, s) {
    return sW.setTime(+o), aW.setTime(+s), t(sW), t(aW), Math.floor(n(sW, aW));
  }, i.every = function(o) {
    return o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? i.filter(r ? function(s) {
      return r(s) % o === 0;
    } : function(s) {
      return i.count(0, s) % o === 0;
    }) : i;
  }), i;
}
var C5 = zA(function() {
}, function(t, e) {
  t.setTime(+t + e);
}, function(t, e) {
  return e - t;
});
C5.every = function(t) {
  return t = Math.floor(t), !isFinite(t) || !(t > 0) ? null : t > 1 ? zA(function(e) {
    e.setTime(Math.floor(e / t) * t);
  }, function(e, n) {
    e.setTime(+e + n * t);
  }, function(e, n) {
    return (n - e) / t;
  }) : C5;
};
const yge = C5;
C5.range;
const aI = 1e3, Qg = aI * 60, AI = Qg * 60, mB = AI * 24, vge = mB * 7, eLe = mB * 30, AW = mB * 365;
var AZe = zA(function(t) {
  t.setTime(t - t.getMilliseconds());
}, function(t, e) {
  t.setTime(+t + e * aI);
}, function(t, e) {
  return (e - t) / aI;
}, function(t) {
  return t.getUTCSeconds();
});
const dC = AZe;
AZe.range;
var lZe = zA(function(t) {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * aI);
}, function(t, e) {
  t.setTime(+t + e * Qg);
}, function(t, e) {
  return (e - t) / Qg;
}, function(t) {
  return t.getMinutes();
});
const Bge = lZe;
lZe.range;
var cZe = zA(function(t) {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * aI - t.getMinutes() * Qg);
}, function(t, e) {
  t.setTime(+t + e * AI);
}, function(t, e) {
  return (e - t) / AI;
}, function(t) {
  return t.getHours();
});
const bge = cZe;
cZe.range;
var uZe = zA(
  (t) => t.setHours(0, 0, 0, 0),
  (t, e) => t.setDate(t.getDate() + e),
  (t, e) => (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * Qg) / mB,
  (t) => t.getDate() - 1
);
const MC = uZe;
uZe.range;
function y1(t) {
  return zA(function(e) {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setDate(e.getDate() + n * 7);
  }, function(e, n) {
    return (n - e - (n.getTimezoneOffset() - e.getTimezoneOffset()) * Qg) / vge;
  });
}
var dx = y1(0), E5 = y1(1), cnr = y1(2), unr = y1(3), hQ = y1(4), fnr = y1(5), gnr = y1(6);
dx.range;
E5.range;
cnr.range;
unr.range;
hQ.range;
fnr.range;
gnr.range;
var fZe = zA(function(t) {
  t.setDate(1), t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setMonth(t.getMonth() + e);
}, function(t, e) {
  return e.getMonth() - t.getMonth() + (e.getFullYear() - t.getFullYear()) * 12;
}, function(t) {
  return t.getMonth();
});
const y5 = fZe;
fZe.range;
var _ge = zA(function(t) {
  t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setFullYear(t.getFullYear() + e);
}, function(t, e) {
  return e.getFullYear() - t.getFullYear();
}, function(t) {
  return t.getFullYear();
});
_ge.every = function(t) {
  return !isFinite(t = Math.floor(t)) || !(t > 0) ? null : zA(function(e) {
    e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setFullYear(e.getFullYear() + n * t);
  });
};
const tE = _ge;
_ge.range;
var gZe = zA(function(t) {
  t.setUTCSeconds(0, 0);
}, function(t, e) {
  t.setTime(+t + e * Qg);
}, function(t, e) {
  return (e - t) / Qg;
}, function(t) {
  return t.getUTCMinutes();
});
const Sge = gZe;
gZe.range;
var hZe = zA(function(t) {
  t.setUTCMinutes(0, 0, 0);
}, function(t, e) {
  t.setTime(+t + e * AI);
}, function(t, e) {
  return (e - t) / AI;
}, function(t) {
  return t.getUTCHours();
});
const Qge = hZe;
hZe.range;
var dZe = zA(function(t) {
  t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCDate(t.getUTCDate() + e);
}, function(t, e) {
  return (e - t) / mB;
}, function(t) {
  return t.getUTCDate() - 1;
});
const OC = dZe;
dZe.range;
function v1(t) {
  return zA(function(e) {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setUTCDate(e.getUTCDate() + n * 7);
  }, function(e, n) {
    return (n - e) / vge;
  });
}
var px = v1(0), v5 = v1(1), hnr = v1(2), dnr = v1(3), dQ = v1(4), pnr = v1(5), Inr = v1(6);
px.range;
v5.range;
hnr.range;
dnr.range;
dQ.range;
pnr.range;
Inr.range;
var pZe = zA(function(t) {
  t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCMonth(t.getUTCMonth() + e);
}, function(t, e) {
  return e.getUTCMonth() - t.getUTCMonth() + (e.getUTCFullYear() - t.getUTCFullYear()) * 12;
}, function(t) {
  return t.getUTCMonth();
});
const B5 = pZe;
pZe.range;
var wge = zA(function(t) {
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCFullYear(t.getUTCFullYear() + e);
}, function(t, e) {
  return e.getUTCFullYear() - t.getUTCFullYear();
}, function(t) {
  return t.getUTCFullYear();
});
wge.every = function(t) {
  return !isFinite(t = Math.floor(t)) || !(t > 0) ? null : zA(function(e) {
    e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setUTCFullYear(e.getUTCFullYear() + n * t);
  });
};
const nE = wge;
wge.range;
function IZe(t, e, n, r, i, o) {
  const s = [
    [dC, 1, aI],
    [dC, 5, 5 * aI],
    [dC, 15, 15 * aI],
    [dC, 30, 30 * aI],
    [o, 1, Qg],
    [o, 5, 5 * Qg],
    [o, 15, 15 * Qg],
    [o, 30, 30 * Qg],
    [i, 1, AI],
    [i, 3, 3 * AI],
    [i, 6, 6 * AI],
    [i, 12, 12 * AI],
    [r, 1, mB],
    [r, 2, 2 * mB],
    [n, 1, vge],
    [e, 1, eLe],
    [e, 3, 3 * eLe],
    [t, 1, AW]
  ];
  function a(l, c, u) {
    const f = c < l;
    f && ([l, c] = [c, l]);
    const h = u && typeof u.range == "function" ? u : A(l, c, u), d = h ? h.range(l, +c + 1) : [];
    return f ? d.reverse() : d;
  }
  function A(l, c, u) {
    const f = Math.abs(c - l) / u, h = $ae(([, , m]) => m).right(s, f);
    if (h === s.length)
      return t.every(rU(l / AW, c / AW, u));
    if (h === 0)
      return yge.every(Math.max(rU(l, c, u), 1));
    const [d, I] = s[f / s[h - 1][2] < s[h][2] / f ? h - 1 : h];
    return d.every(I);
  }
  return [a, A];
}
const [mnr, Cnr] = IZe(nE, B5, px, OC, Qge, Sge), [Enr, ynr] = IZe(tE, y5, dx, MC, bge, Bge), fl = "year", Gu = "quarter", ec = "month", fA = "week", Uu = "date", Yl = "day", Kp = "dayofyear", Gf = "hours", Uf = "minutes", jg = "seconds", Id = "milliseconds", xge = [fl, Gu, ec, fA, Uu, Yl, Kp, Gf, Uf, jg, Id], lW = xge.reduce((t, e, n) => (t[e] = 1 + n, t), {});
function Rge(t) {
  const e = bn(t).slice(), n = {};
  return e.length || wt("Missing time unit."), e.forEach((i) => {
    Kn(lW, i) ? n[i] = 1 : wt("Invalid time unit: ".concat(i, "."));
  }), (n[fA] || n[Yl] ? 1 : 0) + (n[Gu] || n[ec] || n[Uu] ? 1 : 0) + (n[Kp] ? 1 : 0) > 1 && wt("Incompatible time units: ".concat(t)), e.sort((i, o) => lW[i] - lW[o]), e;
}
const vnr = {
  [fl]: "%Y ",
  [Gu]: "Q%q ",
  [ec]: "%b ",
  [Uu]: "%d ",
  [fA]: "W%U ",
  [Yl]: "%a ",
  [Kp]: "%j ",
  [Gf]: "%H:00",
  [Uf]: "00:%M",
  [jg]: ":%S",
  [Id]: ".%L",
  ["".concat(fl, "-").concat(ec)]: "%Y-%m ",
  ["".concat(fl, "-").concat(ec, "-").concat(Uu)]: "%Y-%m-%d ",
  ["".concat(Gf, "-").concat(Uf)]: "%H:%M"
};
function mZe(t, e) {
  const n = ni({}, vnr, e), r = Rge(t), i = r.length;
  let o = "", s = 0, a, A;
  for (s = 0; s < i; )
    for (a = r.length; a > s; --a)
      if (A = r.slice(s, a).join("-"), n[A] != null) {
        o += n[A], s = a;
        break;
      }
  return o.trim();
}
const Wy = /* @__PURE__ */ new Date();
function Dge(t) {
  return Wy.setFullYear(t), Wy.setMonth(0), Wy.setDate(1), Wy.setHours(0, 0, 0, 0), Wy;
}
function CZe(t) {
  return yZe(new Date(t));
}
function EZe(t) {
  return $re(new Date(t));
}
function yZe(t) {
  return MC.count(Dge(t.getFullYear()) - 1, t);
}
function $re(t) {
  return dx.count(Dge(t.getFullYear()) - 1, t);
}
function qre(t) {
  return Dge(t).getDay();
}
function Bnr(t, e, n, r, i, o, s) {
  if (0 <= t && t < 100) {
    const a = new Date(-1, e, n, r, i, o, s);
    return a.setFullYear(t), a;
  }
  return new Date(t, e, n, r, i, o, s);
}
function vZe(t) {
  return bZe(new Date(t));
}
function BZe(t) {
  return jre(new Date(t));
}
function bZe(t) {
  const e = Date.UTC(t.getUTCFullYear(), 0, 1);
  return OC.count(e - 1, t);
}
function jre(t) {
  const e = Date.UTC(t.getUTCFullYear(), 0, 1);
  return px.count(e - 1, t);
}
function Yre(t) {
  return Wy.setTime(Date.UTC(t, 0, 1)), Wy.getUTCDay();
}
function bnr(t, e, n, r, i, o, s) {
  if (0 <= t && t < 100) {
    const a = new Date(Date.UTC(-1, e, n, r, i, o, s));
    return a.setUTCFullYear(n.y), a;
  }
  return new Date(Date.UTC(t, e, n, r, i, o, s));
}
function _Ze(t, e, n, r, i) {
  const o = e || 1, s = bi(t), a = (C, y, v) => (v = v || C, _nr(n[v], r[v], C === s && o, y)), A = /* @__PURE__ */ new Date(), l = pd(t), c = l[fl] ? a(fl) : lc(2012), u = l[ec] ? a(ec) : l[Gu] ? a(Gu) : nC, f = l[fA] && l[Yl] ? a(Yl, 1, fA + Yl) : l[fA] ? a(fA, 1) : l[Yl] ? a(Yl, 1) : l[Uu] ? a(Uu, 1) : l[Kp] ? a(Kp, 1) : ux, h = l[Gf] ? a(Gf) : nC, d = l[Uf] ? a(Uf) : nC, I = l[jg] ? a(jg) : nC, m = l[Id] ? a(Id) : nC;
  return function(C) {
    A.setTime(+C);
    const y = c(A);
    return i(y, u(A), f(A, y), h(A), d(A), I(A), m(A));
  };
}
function _nr(t, e, n, r) {
  const i = n <= 1 ? t : r ? (o, s) => r + n * Math.floor((t(o, s) - r) / n) : (o, s) => n * Math.floor(t(o, s) / n);
  return e ? (o, s) => e(i(o, s), s) : i;
}
function pQ(t, e, n) {
  return e + t * 7 - (n + 6) % 7;
}
const Snr = {
  [fl]: (t) => t.getFullYear(),
  [Gu]: (t) => Math.floor(t.getMonth() / 3),
  [ec]: (t) => t.getMonth(),
  [Uu]: (t) => t.getDate(),
  [Gf]: (t) => t.getHours(),
  [Uf]: (t) => t.getMinutes(),
  [jg]: (t) => t.getSeconds(),
  [Id]: (t) => t.getMilliseconds(),
  [Kp]: (t) => yZe(t),
  [fA]: (t) => $re(t),
  [fA + Yl]: (t, e) => pQ($re(t), t.getDay(), qre(e)),
  [Yl]: (t, e) => pQ(1, t.getDay(), qre(e))
}, Qnr = {
  [Gu]: (t) => 3 * t,
  [fA]: (t, e) => pQ(t, 0, qre(e))
};
function SZe(t, e) {
  return _Ze(t, e || 1, Snr, Qnr, Bnr);
}
const wnr = {
  [fl]: (t) => t.getUTCFullYear(),
  [Gu]: (t) => Math.floor(t.getUTCMonth() / 3),
  [ec]: (t) => t.getUTCMonth(),
  [Uu]: (t) => t.getUTCDate(),
  [Gf]: (t) => t.getUTCHours(),
  [Uf]: (t) => t.getUTCMinutes(),
  [jg]: (t) => t.getUTCSeconds(),
  [Id]: (t) => t.getUTCMilliseconds(),
  [Kp]: (t) => bZe(t),
  [fA]: (t) => jre(t),
  [Yl]: (t, e) => pQ(1, t.getUTCDay(), Yre(e)),
  [fA + Yl]: (t, e) => pQ(jre(t), t.getUTCDay(), Yre(e))
}, xnr = {
  [Gu]: (t) => 3 * t,
  [fA]: (t, e) => pQ(t, 0, Yre(e))
};
function QZe(t, e) {
  return _Ze(t, e || 1, wnr, xnr, bnr);
}
const Rnr = {
  [fl]: tE,
  [Gu]: y5.every(3),
  [ec]: y5,
  [fA]: dx,
  [Uu]: MC,
  [Yl]: MC,
  [Kp]: MC,
  [Gf]: bge,
  [Uf]: Bge,
  [jg]: dC,
  [Id]: yge
}, Dnr = {
  [fl]: nE,
  [Gu]: B5.every(3),
  [ec]: B5,
  [fA]: px,
  [Uu]: OC,
  [Yl]: OC,
  [Kp]: OC,
  [Gf]: Qge,
  [Uf]: Sge,
  [jg]: dC,
  [Id]: yge
};
function Ix(t) {
  return Rnr[t];
}
function mx(t) {
  return Dnr[t];
}
function wZe(t, e, n) {
  return t ? t.offset(e, n) : void 0;
}
function xZe(t, e, n) {
  return wZe(Ix(t), e, n);
}
function RZe(t, e, n) {
  return wZe(mx(t), e, n);
}
function DZe(t, e, n, r) {
  return t ? t.range(e, n, r) : void 0;
}
function TZe(t, e, n, r) {
  return DZe(Ix(t), e, n, r);
}
function NZe(t, e, n, r) {
  return DZe(mx(t), e, n, r);
}
const HR = 1e3, $R = HR * 60, qR = $R * 60, uj = qR * 24, Tnr = uj * 7, tLe = uj * 30, zre = uj * 365, LZe = [fl, ec, Uu, Gf, Uf, jg, Id], jR = LZe.slice(0, -1), YR = jR.slice(0, -1), zR = YR.slice(0, -1), Nnr = zR.slice(0, -1), Lnr = [fl, fA], nLe = [fl, ec], MZe = [fl], G2 = [[jR, 1, HR], [jR, 5, 5 * HR], [jR, 15, 15 * HR], [jR, 30, 30 * HR], [YR, 1, $R], [YR, 5, 5 * $R], [YR, 15, 15 * $R], [YR, 30, 30 * $R], [zR, 1, qR], [zR, 3, 3 * qR], [zR, 6, 6 * qR], [zR, 12, 12 * qR], [Nnr, 1, uj], [Lnr, 1, Tnr], [nLe, 1, tLe], [nLe, 3, 3 * tLe], [MZe, 1, zre]];
function OZe(t) {
  const e = t.extent, n = t.maxbins || 40, r = Math.abs(rO(e)) / n;
  let i = lj((a) => a[2]).right(G2, r), o, s;
  return i === G2.length ? (o = MZe, s = IN(e[0] / zre, e[1] / zre, n)) : i ? (i = G2[r / G2[i - 1][2] < G2[i][2] / r ? i - 1 : i], o = i[0], s = i[1]) : (o = LZe, s = Math.max(IN(e[0], e[1], n), 1)), {
    units: o,
    step: s
  };
}
function cW(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
    return e.setFullYear(t.y), e;
  }
  return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
}
function uW(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
    return e.setUTCFullYear(t.y), e;
  }
  return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
}
function U2(t, e, n) {
  return { y: t, m: e, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function FZe(t) {
  var e = t.dateTime, n = t.date, r = t.time, i = t.periods, o = t.days, s = t.shortDays, a = t.months, A = t.shortMonths, l = H2(i), c = $2(i), u = H2(o), f = $2(o), h = H2(s), d = $2(s), I = H2(a), m = $2(a), C = H2(A), y = $2(A), v = {
    a: z,
    A: Y,
    b: V,
    B: Z,
    c: null,
    d: ALe,
    e: ALe,
    f: rrr,
    g: grr,
    G: drr,
    H: err,
    I: trr,
    j: nrr,
    L: PZe,
    m: irr,
    M: orr,
    p: ce,
    q: ee,
    Q: uLe,
    s: fLe,
    S: srr,
    u: arr,
    U: Arr,
    V: lrr,
    w: crr,
    W: urr,
    x: null,
    X: null,
    y: frr,
    Y: hrr,
    Z: prr,
    "%": cLe
  }, b = {
    a: pe,
    A: Ce,
    b: Be,
    B: Ie,
    c: null,
    d: lLe,
    e: lLe,
    f: Err,
    g: Rrr,
    G: Trr,
    H: Irr,
    I: mrr,
    j: Crr,
    L: GZe,
    m: yrr,
    M: vrr,
    p: Qe,
    q: xe,
    Q: uLe,
    s: fLe,
    S: Brr,
    u: brr,
    U: _rr,
    V: Srr,
    w: Qrr,
    W: wrr,
    x: null,
    X: null,
    y: xrr,
    Y: Drr,
    Z: Nrr,
    "%": cLe
  }, Q = {
    a: L,
    A: N,
    b: k,
    B: $,
    c: U,
    d: sLe,
    e: sLe,
    f: Knr,
    g: oLe,
    G: iLe,
    H: aLe,
    I: aLe,
    j: Ynr,
    L: Jnr,
    m: jnr,
    M: znr,
    p: O,
    q: qnr,
    Q: Xnr,
    s: Znr,
    S: Vnr,
    u: knr,
    U: Gnr,
    V: Unr,
    w: Pnr,
    W: Hnr,
    x: X,
    X: K,
    y: oLe,
    Y: iLe,
    Z: $nr,
    "%": Wnr
  };
  v.x = w(n, v), v.X = w(r, v), v.c = w(e, v), b.x = w(n, b), b.X = w(r, b), b.c = w(e, b);
  function w(Se, De) {
    return function(Ue) {
      var Te = [], se = -1, fe = 0, W = Se.length, ge, _e, Re;
      for (Ue instanceof Date || (Ue = /* @__PURE__ */ new Date(+Ue)); ++se < W; )
        Se.charCodeAt(se) === 37 && (Te.push(Se.slice(fe, se)), (_e = rLe[ge = Se.charAt(++se)]) != null ? ge = Se.charAt(++se) : _e = ge === "e" ? " " : "0", (Re = De[ge]) && (ge = Re(Ue, _e)), Te.push(ge), fe = se + 1);
      return Te.push(Se.slice(fe, se)), Te.join("");
    };
  }
  function R(Se, De) {
    return function(Ue) {
      var Te = U2(1900, void 0, 1), se = M(Te, Se, Ue += "", 0), fe, W;
      if (se != Ue.length)
        return null;
      if ("Q" in Te)
        return new Date(Te.Q);
      if ("s" in Te)
        return new Date(Te.s * 1e3 + ("L" in Te ? Te.L : 0));
      if (De && !("Z" in Te) && (Te.Z = 0), "p" in Te && (Te.H = Te.H % 12 + Te.p * 12), Te.m === void 0 && (Te.m = "q" in Te ? Te.q : 0), "V" in Te) {
        if (Te.V < 1 || Te.V > 53)
          return null;
        "w" in Te || (Te.w = 1), "Z" in Te ? (fe = uW(U2(Te.y, 0, 1)), W = fe.getUTCDay(), fe = W > 4 || W === 0 ? v5.ceil(fe) : v5(fe), fe = OC.offset(fe, (Te.V - 1) * 7), Te.y = fe.getUTCFullYear(), Te.m = fe.getUTCMonth(), Te.d = fe.getUTCDate() + (Te.w + 6) % 7) : (fe = cW(U2(Te.y, 0, 1)), W = fe.getDay(), fe = W > 4 || W === 0 ? E5.ceil(fe) : E5(fe), fe = MC.offset(fe, (Te.V - 1) * 7), Te.y = fe.getFullYear(), Te.m = fe.getMonth(), Te.d = fe.getDate() + (Te.w + 6) % 7);
      } else
        ("W" in Te || "U" in Te) && ("w" in Te || (Te.w = "u" in Te ? Te.u % 7 : "W" in Te ? 1 : 0), W = "Z" in Te ? uW(U2(Te.y, 0, 1)).getUTCDay() : cW(U2(Te.y, 0, 1)).getDay(), Te.m = 0, Te.d = "W" in Te ? (Te.w + 6) % 7 + Te.W * 7 - (W + 5) % 7 : Te.w + Te.U * 7 - (W + 6) % 7);
      return "Z" in Te ? (Te.H += Te.Z / 100 | 0, Te.M += Te.Z % 100, uW(Te)) : cW(Te);
    };
  }
  function M(Se, De, Ue, Te) {
    for (var se = 0, fe = De.length, W = Ue.length, ge, _e; se < fe; ) {
      if (Te >= W)
        return -1;
      if (ge = De.charCodeAt(se++), ge === 37) {
        if (ge = De.charAt(se++), _e = Q[ge in rLe ? De.charAt(se++) : ge], !_e || (Te = _e(Se, Ue, Te)) < 0)
          return -1;
      } else if (ge != Ue.charCodeAt(Te++))
        return -1;
    }
    return Te;
  }
  function O(Se, De, Ue) {
    var Te = l.exec(De.slice(Ue));
    return Te ? (Se.p = c.get(Te[0].toLowerCase()), Ue + Te[0].length) : -1;
  }
  function L(Se, De, Ue) {
    var Te = h.exec(De.slice(Ue));
    return Te ? (Se.w = d.get(Te[0].toLowerCase()), Ue + Te[0].length) : -1;
  }
  function N(Se, De, Ue) {
    var Te = u.exec(De.slice(Ue));
    return Te ? (Se.w = f.get(Te[0].toLowerCase()), Ue + Te[0].length) : -1;
  }
  function k(Se, De, Ue) {
    var Te = C.exec(De.slice(Ue));
    return Te ? (Se.m = y.get(Te[0].toLowerCase()), Ue + Te[0].length) : -1;
  }
  function $(Se, De, Ue) {
    var Te = I.exec(De.slice(Ue));
    return Te ? (Se.m = m.get(Te[0].toLowerCase()), Ue + Te[0].length) : -1;
  }
  function U(Se, De, Ue) {
    return M(Se, e, De, Ue);
  }
  function X(Se, De, Ue) {
    return M(Se, n, De, Ue);
  }
  function K(Se, De, Ue) {
    return M(Se, r, De, Ue);
  }
  function z(Se) {
    return s[Se.getDay()];
  }
  function Y(Se) {
    return o[Se.getDay()];
  }
  function V(Se) {
    return A[Se.getMonth()];
  }
  function Z(Se) {
    return a[Se.getMonth()];
  }
  function ce(Se) {
    return i[+(Se.getHours() >= 12)];
  }
  function ee(Se) {
    return 1 + ~~(Se.getMonth() / 3);
  }
  function pe(Se) {
    return s[Se.getUTCDay()];
  }
  function Ce(Se) {
    return o[Se.getUTCDay()];
  }
  function Be(Se) {
    return A[Se.getUTCMonth()];
  }
  function Ie(Se) {
    return a[Se.getUTCMonth()];
  }
  function Qe(Se) {
    return i[+(Se.getUTCHours() >= 12)];
  }
  function xe(Se) {
    return 1 + ~~(Se.getUTCMonth() / 3);
  }
  return {
    format: function(Se) {
      var De = w(Se += "", v);
      return De.toString = function() {
        return Se;
      }, De;
    },
    parse: function(Se) {
      var De = R(Se += "", !1);
      return De.toString = function() {
        return Se;
      }, De;
    },
    utcFormat: function(Se) {
      var De = w(Se += "", b);
      return De.toString = function() {
        return Se;
      }, De;
    },
    utcParse: function(Se) {
      var De = R(Se += "", !0);
      return De.toString = function() {
        return Se;
      }, De;
    }
  };
}
var rLe = { "-": "", _: " ", 0: "0" }, VA = /^\s*\d+/, Mnr = /^%/, Onr = /[\\^$*+?|[\]().{}]/g;
function zi(t, e, n) {
  var r = t < 0 ? "-" : "", i = (r ? -t : t) + "", o = i.length;
  return r + (o < n ? new Array(n - o + 1).join(e) + i : i);
}
function Fnr(t) {
  return t.replace(Onr, "\\$&");
}
function H2(t) {
  return new RegExp("^(?:" + t.map(Fnr).join("|") + ")", "i");
}
function $2(t) {
  return new Map(t.map((e, n) => [e.toLowerCase(), n]));
}
function Pnr(t, e, n) {
  var r = VA.exec(e.slice(n, n + 1));
  return r ? (t.w = +r[0], n + r[0].length) : -1;
}
function knr(t, e, n) {
  var r = VA.exec(e.slice(n, n + 1));
  return r ? (t.u = +r[0], n + r[0].length) : -1;
}
function Gnr(t, e, n) {
  var r = VA.exec(e.slice(n, n + 2));
  return r ? (t.U = +r[0], n + r[0].length) : -1;
}
function Unr(t, e, n) {
  var r = VA.exec(e.slice(n, n + 2));
  return r ? (t.V = +r[0], n + r[0].length) : -1;
}
function Hnr(t, e, n) {
  var r = VA.exec(e.slice(n, n + 2));
  return r ? (t.W = +r[0], n + r[0].length) : -1;
}
function iLe(t, e, n) {
  var r = VA.exec(e.slice(n, n + 4));
  return r ? (t.y = +r[0], n + r[0].length) : -1;
}
function oLe(t, e, n) {
  var r = VA.exec(e.slice(n, n + 2));
  return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function $nr(t, e, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
  return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function qnr(t, e, n) {
  var r = VA.exec(e.slice(n, n + 1));
  return r ? (t.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function jnr(t, e, n) {
  var r = VA.exec(e.slice(n, n + 2));
  return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
}
function sLe(t, e, n) {
  var r = VA.exec(e.slice(n, n + 2));
  return r ? (t.d = +r[0], n + r[0].length) : -1;
}
function Ynr(t, e, n) {
  var r = VA.exec(e.slice(n, n + 3));
  return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
}
function aLe(t, e, n) {
  var r = VA.exec(e.slice(n, n + 2));
  return r ? (t.H = +r[0], n + r[0].length) : -1;
}
function znr(t, e, n) {
  var r = VA.exec(e.slice(n, n + 2));
  return r ? (t.M = +r[0], n + r[0].length) : -1;
}
function Vnr(t, e, n) {
  var r = VA.exec(e.slice(n, n + 2));
  return r ? (t.S = +r[0], n + r[0].length) : -1;
}
function Jnr(t, e, n) {
  var r = VA.exec(e.slice(n, n + 3));
  return r ? (t.L = +r[0], n + r[0].length) : -1;
}
function Knr(t, e, n) {
  var r = VA.exec(e.slice(n, n + 6));
  return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function Wnr(t, e, n) {
  var r = Mnr.exec(e.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function Xnr(t, e, n) {
  var r = VA.exec(e.slice(n));
  return r ? (t.Q = +r[0], n + r[0].length) : -1;
}
function Znr(t, e, n) {
  var r = VA.exec(e.slice(n));
  return r ? (t.s = +r[0], n + r[0].length) : -1;
}
function ALe(t, e) {
  return zi(t.getDate(), e, 2);
}
function err(t, e) {
  return zi(t.getHours(), e, 2);
}
function trr(t, e) {
  return zi(t.getHours() % 12 || 12, e, 2);
}
function nrr(t, e) {
  return zi(1 + MC.count(tE(t), t), e, 3);
}
function PZe(t, e) {
  return zi(t.getMilliseconds(), e, 3);
}
function rrr(t, e) {
  return PZe(t, e) + "000";
}
function irr(t, e) {
  return zi(t.getMonth() + 1, e, 2);
}
function orr(t, e) {
  return zi(t.getMinutes(), e, 2);
}
function srr(t, e) {
  return zi(t.getSeconds(), e, 2);
}
function arr(t) {
  var e = t.getDay();
  return e === 0 ? 7 : e;
}
function Arr(t, e) {
  return zi(dx.count(tE(t) - 1, t), e, 2);
}
function kZe(t) {
  var e = t.getDay();
  return e >= 4 || e === 0 ? hQ(t) : hQ.ceil(t);
}
function lrr(t, e) {
  return t = kZe(t), zi(hQ.count(tE(t), t) + (tE(t).getDay() === 4), e, 2);
}
function crr(t) {
  return t.getDay();
}
function urr(t, e) {
  return zi(E5.count(tE(t) - 1, t), e, 2);
}
function frr(t, e) {
  return zi(t.getFullYear() % 100, e, 2);
}
function grr(t, e) {
  return t = kZe(t), zi(t.getFullYear() % 100, e, 2);
}
function hrr(t, e) {
  return zi(t.getFullYear() % 1e4, e, 4);
}
function drr(t, e) {
  var n = t.getDay();
  return t = n >= 4 || n === 0 ? hQ(t) : hQ.ceil(t), zi(t.getFullYear() % 1e4, e, 4);
}
function prr(t) {
  var e = t.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + zi(e / 60 | 0, "0", 2) + zi(e % 60, "0", 2);
}
function lLe(t, e) {
  return zi(t.getUTCDate(), e, 2);
}
function Irr(t, e) {
  return zi(t.getUTCHours(), e, 2);
}
function mrr(t, e) {
  return zi(t.getUTCHours() % 12 || 12, e, 2);
}
function Crr(t, e) {
  return zi(1 + OC.count(nE(t), t), e, 3);
}
function GZe(t, e) {
  return zi(t.getUTCMilliseconds(), e, 3);
}
function Err(t, e) {
  return GZe(t, e) + "000";
}
function yrr(t, e) {
  return zi(t.getUTCMonth() + 1, e, 2);
}
function vrr(t, e) {
  return zi(t.getUTCMinutes(), e, 2);
}
function Brr(t, e) {
  return zi(t.getUTCSeconds(), e, 2);
}
function brr(t) {
  var e = t.getUTCDay();
  return e === 0 ? 7 : e;
}
function _rr(t, e) {
  return zi(px.count(nE(t) - 1, t), e, 2);
}
function UZe(t) {
  var e = t.getUTCDay();
  return e >= 4 || e === 0 ? dQ(t) : dQ.ceil(t);
}
function Srr(t, e) {
  return t = UZe(t), zi(dQ.count(nE(t), t) + (nE(t).getUTCDay() === 4), e, 2);
}
function Qrr(t) {
  return t.getUTCDay();
}
function wrr(t, e) {
  return zi(v5.count(nE(t) - 1, t), e, 2);
}
function xrr(t, e) {
  return zi(t.getUTCFullYear() % 100, e, 2);
}
function Rrr(t, e) {
  return t = UZe(t), zi(t.getUTCFullYear() % 100, e, 2);
}
function Drr(t, e) {
  return zi(t.getUTCFullYear() % 1e4, e, 4);
}
function Trr(t, e) {
  var n = t.getUTCDay();
  return t = n >= 4 || n === 0 ? dQ(t) : dQ.ceil(t), zi(t.getUTCFullYear() % 1e4, e, 4);
}
function Nrr() {
  return "+0000";
}
function cLe() {
  return "%";
}
function uLe(t) {
  return +t;
}
function fLe(t) {
  return Math.floor(+t / 1e3);
}
var wb, Tge, HZe, Nge, $Ze;
Lrr({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function Lrr(t) {
  return wb = FZe(t), Tge = wb.format, HZe = wb.parse, Nge = wb.utcFormat, $Ze = wb.utcParse, wb;
}
function VR(t) {
  const e = {};
  return (n) => e[n] || (e[n] = t(n));
}
function Mrr(t, e) {
  return (n) => {
    const r = t(n), i = r.indexOf(e);
    if (i < 0)
      return r;
    let o = Orr(r, i);
    const s = o < r.length ? r.slice(o) : "";
    for (; --o > i; )
      if (r[o] !== "0") {
        ++o;
        break;
      }
    return r.slice(0, o) + s;
  };
}
function Orr(t, e) {
  let n = t.lastIndexOf("e"), r;
  if (n > 0)
    return n;
  for (n = t.length; --n > e; )
    if (r = t.charCodeAt(n), r >= 48 && r <= 57)
      return n + 1;
}
function qZe(t) {
  const e = VR(t.format), n = t.formatPrefix;
  return {
    format: e,
    formatPrefix: n,
    formatFloat(r) {
      const i = IB(r || ",");
      if (i.precision == null) {
        switch (i.precision = 12, i.type) {
          case "%":
            i.precision -= 2;
            break;
          case "e":
            i.precision -= 1;
            break;
        }
        return Mrr(
          e(i),
          // number format
          e(".1f")(1)[1]
          // decimal point character
        );
      } else
        return e(i);
    },
    formatSpan(r, i, o, s) {
      s = IB(s ?? ",f");
      const a = IN(r, i, o), A = Math.max(Math.abs(r), Math.abs(i));
      let l;
      if (s.precision == null)
        switch (s.type) {
          case "s":
            return isNaN(l = sZe(a, A)) || (s.precision = l), n(s, A);
          case "":
          case "e":
          case "g":
          case "p":
          case "r": {
            isNaN(l = aZe(a, A)) || (s.precision = l - (s.type === "e"));
            break;
          }
          case "f":
          case "%": {
            isNaN(l = oZe(a)) || (s.precision = l - (s.type === "%") * 2);
            break;
          }
        }
      return e(s);
    }
  };
}
let Vre;
jZe();
function jZe() {
  return Vre = qZe({
    format: cj,
    formatPrefix: Ege
  });
}
function YZe(t) {
  return qZe(iZe(t));
}
function b5(t) {
  return arguments.length ? Vre = YZe(t) : Vre;
}
function gLe(t, e, n) {
  n = n || {}, _n(n) || wt("Invalid time multi-format specifier: ".concat(n));
  const r = e(jg), i = e(Uf), o = e(Gf), s = e(Uu), a = e(fA), A = e(ec), l = e(Gu), c = e(fl), u = t(n[Id] || ".%L"), f = t(n[jg] || ":%S"), h = t(n[Uf] || "%I:%M"), d = t(n[Gf] || "%I %p"), I = t(n[Uu] || n[Yl] || "%a %d"), m = t(n[fA] || "%b %d"), C = t(n[ec] || "%B"), y = t(n[Gu] || "%B"), v = t(n[fl] || "%Y");
  return (b) => (r(b) < b ? u : i(b) < b ? f : o(b) < b ? h : s(b) < b ? d : A(b) < b ? a(b) < b ? I : m : c(b) < b ? l(b) < b ? C : y : v)(b);
}
function zZe(t) {
  const e = VR(t.format), n = VR(t.utcFormat);
  return {
    timeFormat: (r) => Cn(r) ? e(r) : gLe(e, Ix, r),
    utcFormat: (r) => Cn(r) ? n(r) : gLe(n, mx, r),
    timeParse: VR(t.parse),
    utcParse: VR(t.utcParse)
  };
}
let Jre;
VZe();
function VZe() {
  return Jre = zZe({
    format: Tge,
    parse: HZe,
    utcFormat: Nge,
    utcParse: $Ze
  });
}
function JZe(t) {
  return zZe(FZe(t));
}
function mN(t) {
  return arguments.length ? Jre = JZe(t) : Jre;
}
const Kre = (t, e) => ni({}, t, e);
function KZe(t, e) {
  const n = t ? YZe(t) : b5(), r = e ? JZe(e) : mN();
  return Kre(n, r);
}
function Lge(t, e) {
  const n = arguments.length;
  return n && n !== 2 && wt("defaultLocale expects either zero or two arguments."), n ? Kre(b5(t), mN(e)) : Kre(b5(), mN());
}
function Frr() {
  return jZe(), VZe(), Lge();
}
const Prr = /^(data:|([A-Za-z]+:)?\/\/)/, krr = /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|file|data):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i, Grr = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g, hLe = "file://";
function Urr(t, e) {
  return (n) => ({
    options: n || {},
    sanitize: $rr,
    load: Hrr,
    fileAccess: !!e,
    file: qrr(e),
    http: Yrr(t)
  });
}
async function Hrr(t, e) {
  const n = await this.sanitize(t, e), r = n.href;
  return n.localFile ? this.file(r) : this.http(r, e);
}
async function $rr(t, e) {
  e = ni({}, this.options, e);
  const n = this.fileAccess, r = {
    href: null
  };
  let i, o, s;
  const a = krr.test(t.replace(Grr, ""));
  (t == null || typeof t != "string" || !a) && wt("Sanitize failure, invalid URI: " + an(t));
  const A = Prr.test(t);
  return (s = e.baseURL) && !A && (!t.startsWith("/") && !s.endsWith("/") && (t = "/" + t), t = s + t), o = (i = t.startsWith(hLe)) || e.mode === "file" || e.mode !== "http" && !A && n, i ? t = t.slice(hLe.length) : t.startsWith("//") && (e.defaultProtocol === "file" ? (t = t.slice(2), o = !0) : t = (e.defaultProtocol || "http") + ":" + t), Object.defineProperty(r, "localFile", {
    value: !!o
  }), r.href = t, e.target && (r.target = e.target + ""), e.rel && (r.rel = e.rel + ""), e.context === "image" && e.crossOrigin && (r.crossOrigin = e.crossOrigin + ""), r;
}
function qrr(t) {
  return t ? (e) => new Promise((n, r) => {
    t.readFile(e, (i, o) => {
      i ? r(i) : n(o);
    });
  }) : jrr;
}
async function jrr() {
  wt("No file system access.");
}
function Yrr(t) {
  return t ? async function(e, n) {
    const r = ni({}, this.options.http, n), i = n && n.response, o = await t(e, r);
    return o.ok ? ri(o[i]) ? o[i]() : o.text() : wt(o.status + "" + o.statusText);
  } : zrr;
}
async function zrr() {
  wt("No HTTP fetch method available.");
}
const Vrr = (t) => t != null && t === t, Jrr = (t) => t === "true" || t === "false" || t === !0 || t === !1, Krr = (t) => !Number.isNaN(Date.parse(t)), WZe = (t) => !Number.isNaN(+t) && !(t instanceof Date), Wrr = (t) => WZe(t) && Number.isInteger(+t), Wre = {
  boolean: hge,
  integer: Kl,
  number: Kl,
  date: dge,
  string: pge,
  unknown: Ac
}, h3 = [Jrr, Wrr, WZe, Krr], Xrr = ["boolean", "integer", "number", "date"];
function XZe(t, e) {
  if (!t || !t.length)
    return "unknown";
  const n = t.length, r = h3.length, i = h3.map((o, s) => s + 1);
  for (let o = 0, s = 0, a, A; o < n; ++o)
    for (A = e ? t[o][e] : t[o], a = 0; a < r; ++a)
      if (i[a] && Vrr(A) && !h3[a](A) && (i[a] = 0, ++s, s === h3.length))
        return "string";
  return Xrr[i.reduce((o, s) => o === 0 ? s : o, 0) - 1];
}
function ZZe(t, e) {
  return e.reduce((n, r) => (n[r] = XZe(t, r), n), {});
}
function dLe(t) {
  const e = function(n, r) {
    const i = {
      delimiter: t
    };
    return Mge(n, r ? ni(r, i) : i);
  };
  return e.responseType = "text", e;
}
function Mge(t, e) {
  return e.header && (t = e.header.map(an).join(e.delimiter) + `
` + t), Ltr(e.delimiter).parse(t + "");
}
Mge.responseType = "text";
function Zrr(t) {
  return typeof Buffer == "function" && ri(Buffer.isBuffer) ? Buffer.isBuffer(t) : !1;
}
function Oge(t, e) {
  const n = e && e.property ? ku(e.property) : Ac;
  return _n(t) && !Zrr(t) ? eir(n(t), e) : n(JSON.parse(t));
}
Oge.responseType = "json";
function eir(t, e) {
  return !Nt(t) && PXe(t) && (t = [...t]), e && e.copy ? JSON.parse(JSON.stringify(t)) : t;
}
const tir = {
  interior: (t, e) => t !== e,
  exterior: (t, e) => t === e
};
function eet(t, e) {
  let n, r, i, o;
  return t = Oge(t, e), e && e.feature ? (n = Ptr, i = e.feature) : e && e.mesh ? (n = Gtr, i = e.mesh, o = tir[e.filter]) : wt("Missing TopoJSON feature or mesh parameter."), r = (r = t.objects[i]) ? n(t, r, o) : wt("Invalid TopoJSON object: " + i), r && r.features || [r];
}
eet.responseType = "json";
const YG = {
  dsv: Mge,
  csv: dLe(","),
  tsv: dLe("	"),
  json: Oge,
  topojson: eet
};
function Fge(t, e) {
  return arguments.length > 1 ? (YG[t] = e, this) : Kn(YG, t) ? YG[t] : null;
}
function tet(t) {
  const e = Fge(t);
  return e && e.responseType || "text";
}
function net(t, e, n, r) {
  e = e || {};
  const i = Fge(e.type || "json");
  return i || wt("Unknown data format type: " + e.type), t = i(t, e), e.parse && nir(t, e.parse, n, r), Kn(t, "columns") && delete t.columns, t;
}
function nir(t, e, n, r) {
  if (!t.length)
    return;
  const i = mN();
  n = n || i.timeParse, r = r || i.utcParse;
  let o = t.columns || Object.keys(t[0]), s, a, A, l, c, u;
  e === "auto" && (e = ZZe(t, o)), o = Object.keys(e);
  const f = o.map((h) => {
    const d = e[h];
    let I, m;
    if (d && (d.startsWith("date:") || d.startsWith("utc:")))
      return I = d.split(/:(.+)?/, 2), m = I[1], (m[0] === "'" && m[m.length - 1] === "'" || m[0] === '"' && m[m.length - 1] === '"') && (m = m.slice(1, -1)), (I[0] === "utc" ? r : n)(m);
    if (!Wre[d])
      throw Error("Illegal format pattern: " + h + ":" + d);
    return Wre[d];
  });
  for (A = 0, c = t.length, u = o.length; A < c; ++A)
    for (s = t[A], l = 0; l < u; ++l)
      a = o[l], s[a] = f[l](s[a]);
}
const fj = Urr(
  typeof fetch < "u" && fetch,
  // use built-in fetch API
  null
  // no file system access
);
function gj(t) {
  const e = t || Ac, n = [], r = {};
  return n.add = (i) => {
    const o = e(i);
    return r[o] || (r[o] = 1, n.push(i)), n;
  }, n.remove = (i) => {
    const o = e(i);
    if (r[o]) {
      r[o] = 0;
      const s = n.indexOf(i);
      s >= 0 && n.splice(s, 1);
    }
    return n;
  }, n;
}
async function zG(t, e) {
  try {
    await e(t);
  } catch (n) {
    t.error(n);
  }
}
const ret = Symbol("vega_id");
let rir = 1;
function hj(t) {
  return !!(t && tr(t));
}
function tr(t) {
  return t[ret];
}
function iet(t, e) {
  return t[ret] = e, t;
}
function so(t) {
  const e = t === Object(t) ? t : {
    data: t
  };
  return tr(e) ? e : iet(e, rir++);
}
function Pge(t) {
  return dj(t, so({}));
}
function dj(t, e) {
  for (const n in t)
    e[n] = t[n];
  return e;
}
function oet(t, e) {
  return iet(e, tr(t));
}
function B1(t, e) {
  return t ? e ? (n, r) => t(n, r) || tr(e(n)) - tr(e(r)) : (n, r) => t(n, r) || tr(n) - tr(r) : null;
}
function set(t) {
  return t && t.constructor === b1;
}
function b1() {
  const t = [], e = [], n = [], r = [], i = [];
  let o = null, s = !1;
  return {
    constructor: b1,
    insert(a) {
      const A = bn(a), l = A.length;
      for (let c = 0; c < l; ++c)
        t.push(A[c]);
      return this;
    },
    remove(a) {
      const A = ri(a) ? r : e, l = bn(a), c = l.length;
      for (let u = 0; u < c; ++u)
        A.push(l[u]);
      return this;
    },
    modify(a, A, l) {
      const c = {
        field: A,
        value: lc(l)
      };
      return ri(a) ? (c.filter = a, i.push(c)) : (c.tuple = a, n.push(c)), this;
    },
    encode(a, A) {
      return ri(a) ? i.push({
        filter: a,
        field: A
      }) : n.push({
        tuple: a,
        field: A
      }), this;
    },
    clean(a) {
      return o = a, this;
    },
    reflow() {
      return s = !0, this;
    },
    pulse(a, A) {
      const l = {}, c = {};
      let u, f, h, d, I, m;
      for (u = 0, f = A.length; u < f; ++u)
        l[tr(A[u])] = 1;
      for (u = 0, f = e.length; u < f; ++u)
        I = e[u], l[tr(I)] = -1;
      for (u = 0, f = r.length; u < f; ++u)
        d = r[u], A.forEach((y) => {
          d(y) && (l[tr(y)] = -1);
        });
      for (u = 0, f = t.length; u < f; ++u)
        I = t[u], m = tr(I), l[m] ? l[m] = 1 : a.add.push(so(t[u]));
      for (u = 0, f = A.length; u < f; ++u)
        I = A[u], l[tr(I)] < 0 && a.rem.push(I);
      function C(y, v, b) {
        b ? y[v] = b(y) : a.encode = v, s || (c[tr(y)] = y);
      }
      for (u = 0, f = n.length; u < f; ++u)
        h = n[u], I = h.tuple, d = h.field, m = l[tr(I)], m > 0 && (C(I, d, h.value), a.modifies(d));
      for (u = 0, f = i.length; u < f; ++u)
        h = i[u], d = h.filter, A.forEach((y) => {
          d(y) && l[tr(y)] > 0 && C(y, h.field, h.value);
        }), a.modifies(h.field);
      if (s)
        a.mod = e.length || r.length ? A.filter((y) => l[tr(y)] > 0) : A.slice();
      else
        for (m in c)
          a.mod.push(c[m]);
      return (o || o == null && (e.length || r.length)) && a.clean(!0), a;
    }
  };
}
const VG = "_:mod:_";
function pj() {
  Object.defineProperty(this, VG, {
    writable: !0,
    value: {}
  });
}
pj.prototype = {
  /**
   * Set a parameter value. If the parameter value changes, the parameter
   * will be recorded as modified.
   * @param {string} name - The parameter name.
   * @param {number} index - The index into an array-value parameter. Ignored if
   *   the argument is undefined, null or less than zero.
   * @param {*} value - The parameter value to set.
   * @param {boolean} [force=false] - If true, records the parameter as modified
   *   even if the value is unchanged.
   * @return {Parameters} - This parameter object.
   */
  set(t, e, n, r) {
    const i = this, o = i[t], s = i[VG];
    return e != null && e >= 0 ? (o[e] !== n || r) && (o[e] = n, s[e + ":" + t] = -1, s[t] = -1) : (o !== n || r) && (i[t] = n, s[t] = Nt(n) ? 1 + n.length : -1), i;
  },
  /**
   * Tests if one or more parameters has been modified. If invoked with no
   * arguments, returns true if any parameter value has changed. If the first
   * argument is array, returns trues if any parameter name in the array has
   * changed. Otherwise, tests if the given name and optional array index has
   * changed.
   * @param {string} name - The parameter name to test.
   * @param {number} [index=undefined] - The parameter array index to test.
   * @return {boolean} - Returns true if a queried parameter was modified.
   */
  modified(t, e) {
    const n = this[VG];
    if (arguments.length) {
      if (Nt(t)) {
        for (let r = 0; r < t.length; ++r)
          if (n[t[r]])
            return !0;
        return !1;
      }
    } else {
      for (const r in n)
        if (n[r])
          return !0;
      return !1;
    }
    return e != null && e >= 0 ? e + 1 < n[t] || !!n[e + ":" + t] : !!n[t];
  },
  /**
   * Clears the modification records. After calling this method,
   * all parameters are considered unmodified.
   */
  clear() {
    return this[VG] = {}, this;
  }
};
let iir = 0;
const oir = "pulse", sir = new pj(), air = 1, Air = 2;
function jo(t, e, n, r) {
  this.id = ++iir, this.value = t, this.stamp = -1, this.rank = -1, this.qrank = -1, this.flags = 0, e && (this._update = e), n && this.parameters(n, r);
}
function pLe(t) {
  return function(e) {
    const n = this.flags;
    return arguments.length === 0 ? !!(n & t) : (this.flags = e ? n | t : n & ~t, this);
  };
}
jo.prototype = {
  /**
   * Returns a list of target operators dependent on this operator.
   * If this list does not exist, it is created and then returned.
   * @return {UniqueList}
   */
  targets() {
    return this._targets || (this._targets = gj(nO));
  },
  /**
   * Sets the value of this operator.
   * @param {*} value - the value to set.
   * @return {Number} Returns 1 if the operator value has changed
   *   according to strict equality, returns 0 otherwise.
   */
  set(t) {
    return this.value !== t ? (this.value = t, 1) : 0;
  },
  /**
   * Indicates that operator evaluation should be skipped on the next pulse.
   * This operator will still propagate incoming pulses, but its update function
   * will not be invoked. The skip flag is reset after every pulse, so calling
   * this method will affect processing of the next pulse only.
   */
  skip: pLe(air),
  /**
   * Indicates that this operator's value has been modified on its most recent
   * pulse. Normally modification is checked via strict equality; however, in
   * some cases it is more efficient to update the internal state of an object.
   * In those cases, the modified flag can be used to trigger propagation. Once
   * set, the modification flag persists across pulses until unset. The flag can
   * be used with the last timestamp to test if a modification is recent.
   */
  modified: pLe(Air),
  /**
   * Sets the parameters for this operator. The parameter values are analyzed for
   * operator instances. If found, this operator will be added as a dependency
   * of the parameterizing operator. Operator values are dynamically marshalled
   * from each operator parameter prior to evaluation. If a parameter value is
   * an array, the array will also be searched for Operator instances. However,
   * the search does not recurse into sub-arrays or object properties.
   * @param {object} params - A hash of operator parameters.
   * @param {boolean} [react=true] - A flag indicating if this operator should
   *   automatically update (react) when parameter values change. In other words,
   *   this flag determines if the operator registers itself as a listener on
   *   any upstream operators included in the parameters.
   * @param {boolean} [initonly=false] - A flag indicating if this operator
   *   should calculate an update only upon its initiatal evaluation, then
   *   deregister dependencies and suppress all future update invocations.
   * @return {Operator[]} - An array of upstream dependencies.
   */
  parameters(t, e, n) {
    e = e !== !1;
    const r = this._argval = this._argval || new pj(), i = this._argops = this._argops || [], o = [];
    let s, a, A, l;
    const c = (u, f, h) => {
      h instanceof jo ? (h !== this && (e && h.targets().add(this), o.push(h)), i.push({
        op: h,
        name: u,
        index: f
      })) : r.set(u, f, h);
    };
    for (s in t)
      if (a = t[s], s === oir)
        bn(a).forEach((u) => {
          u instanceof jo ? u !== this && (u.targets().add(this), o.push(u)) : wt("Pulse parameters must be operator instances.");
        }), this.source = a;
      else if (Nt(a))
        for (r.set(s, -1, Array(A = a.length)), l = 0; l < A; ++l)
          c(s, l, a[l]);
      else
        c(s, -1, a);
    return this.marshall().clear(), n && (i.initonly = !0), o;
  },
  /**
   * Internal method for marshalling parameter values.
   * Visits each operator dependency to pull the latest value.
   * @return {Parameters} A Parameters object to pass to the update function.
   */
  marshall(t) {
    const e = this._argval || sir, n = this._argops;
    let r, i, o, s;
    if (n) {
      const a = n.length;
      for (i = 0; i < a; ++i)
        r = n[i], o = r.op, s = o.modified() && o.stamp === t, e.set(r.name, r.index, o.value, s);
      if (n.initonly) {
        for (i = 0; i < a; ++i)
          r = n[i], r.op.targets().remove(this);
        this._argops = null, this._update = null;
      }
    }
    return e;
  },
  /**
   * Detach this operator from the dataflow.
   * Unregisters listeners on upstream dependencies.
   */
  detach() {
    const t = this._argops;
    let e, n, r, i;
    if (t)
      for (e = 0, n = t.length; e < n; ++e)
        r = t[e], i = r.op, i._targets && i._targets.remove(this);
    this.pulse = null, this.source = null;
  },
  /**
   * Delegate method to perform operator processing.
   * Subclasses can override this method to perform custom processing.
   * By default, it marshalls parameters and calls the update function
   * if that function is defined. If the update function does not
   * change the operator value then StopPropagation is returned.
   * If no update function is defined, this method does nothing.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return The output pulse or StopPropagation. A falsy return value
   *   (including undefined) will let the input pulse pass through.
   */
  evaluate(t) {
    const e = this._update;
    if (e) {
      const n = this.marshall(t.stamp), r = e.call(this, n, t);
      if (n.clear(), r !== this.value)
        this.value = r;
      else if (!this.modified())
        return t.StopPropagation;
    }
  },
  /**
   * Run this operator for the current pulse. If this operator has already
   * been run at (or after) the pulse timestamp, returns StopPropagation.
   * Internally, this method calls {@link evaluate} to perform processing.
   * If {@link evaluate} returns a falsy value, the input pulse is returned.
   * This method should NOT be overridden, instead overrride {@link evaluate}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return the output pulse for this operator (or StopPropagation)
   */
  run(t) {
    if (t.stamp < this.stamp)
      return t.StopPropagation;
    let e;
    return this.skip() ? (this.skip(!1), e = 0) : e = this.evaluate(t), this.pulse = e || t;
  }
};
function lir(t, e, n, r) {
  let i = 1, o;
  return t instanceof jo ? o = t : t && t.prototype instanceof jo ? o = new t() : ri(t) ? o = new jo(null, t) : (i = 0, o = new jo(t, e)), this.rank(o), i && (r = n, n = e), n && this.connect(o, o.parameters(n, r)), this.touch(o), o;
}
function cir(t, e) {
  const n = t.rank, r = e.length;
  for (let i = 0; i < r; ++i)
    if (n < e[i].rank) {
      this.rerank(t);
      return;
    }
}
let uir = 0;
function Ij(t, e, n) {
  this.id = ++uir, this.value = null, n && (this.receive = n), t && (this._filter = t), e && (this._apply = e);
}
function Hm(t, e, n) {
  return new Ij(t, e, n);
}
Ij.prototype = {
  _filter: qg,
  _apply: Ac,
  targets() {
    return this._targets || (this._targets = gj(nO));
  },
  consume(t) {
    return arguments.length ? (this._consume = !!t, this) : !!this._consume;
  },
  receive(t) {
    if (this._filter(t)) {
      const e = this.value = this._apply(t), n = this._targets, r = n ? n.length : 0;
      for (let i = 0; i < r; ++i)
        n[i].receive(e);
      this._consume && (t.preventDefault(), t.stopPropagation());
    }
  },
  filter(t) {
    const e = Hm(t);
    return this.targets().add(e), e;
  },
  apply(t) {
    const e = Hm(null, t);
    return this.targets().add(e), e;
  },
  merge() {
    const t = Hm();
    this.targets().add(t);
    for (let e = 0, n = arguments.length; e < n; ++e)
      arguments[e].targets().add(t);
    return t;
  },
  throttle(t) {
    let e = -1;
    return this.filter(() => {
      const n = Date.now();
      return n - e > t ? (e = n, 1) : 0;
    });
  },
  debounce(t) {
    const e = Hm();
    return this.targets().add(Hm(null, null, fge(t, (n) => {
      const r = n.dataflow;
      e.receive(n), r && r.run && r.run();
    }))), e;
  },
  between(t, e) {
    let n = !1;
    return t.targets().add(Hm(null, null, () => n = !0)), e.targets().add(Hm(null, null, () => n = !1)), this.filter(() => n);
  },
  detach() {
    this._filter = qg, this._targets = null;
  }
};
function fir(t, e, n, r) {
  const i = this, o = Hm(n, r), s = function(l) {
    l.dataflow = i;
    try {
      o.receive(l);
    } catch (c) {
      i.error(c);
    } finally {
      i.run();
    }
  };
  let a;
  typeof t == "string" && typeof document < "u" ? a = document.querySelectorAll(t) : a = bn(t);
  const A = a.length;
  for (let l = 0; l < A; ++l)
    a[l].addEventListener(e, s);
  return o;
}
function gir(t, e) {
  const n = this.locale();
  return net(t, e, n.timeParse, n.utcParse);
}
function hir(t, e, n) {
  return e = this.parse(e, n), this.pulse(t, this.changeset().insert(e));
}
async function dir(t, e) {
  const n = this;
  let r = 0, i;
  try {
    i = await n.loader().load(t, {
      context: "dataflow",
      response: tet(e && e.type)
    });
    try {
      i = n.parse(i, e);
    } catch (o) {
      r = -2, n.warn("Data ingestion failed", t, o);
    }
  } catch (o) {
    r = -1, n.warn("Loading failed", t, o);
  }
  return {
    data: i,
    status: r
  };
}
async function pir(t, e, n) {
  const r = this, i = r._pending || Iir(r);
  i.requests += 1;
  const o = await r.request(e, n);
  return r.pulse(t, r.changeset().remove(qg).insert(o.data || [])), i.done(), o;
}
function Iir(t) {
  let e;
  const n = new Promise((r) => e = r);
  return n.requests = 0, n.done = () => {
    --n.requests === 0 && (t._pending = null, e(t));
  }, t._pending = n;
}
const mir = {
  skip: !0
};
function Cir(t, e, n, r, i) {
  return (t instanceof jo ? yir : Eir)(this, t, e, n, r, i), this;
}
function Eir(t, e, n, r, i, o) {
  const s = ni({}, o, mir);
  let a, A;
  ri(n) || (n = lc(n)), r === void 0 ? a = (l) => t.touch(n(l)) : ri(r) ? (A = new jo(null, r, i, !1), a = (l) => {
    A.evaluate(l);
    const c = n(l), u = A.value;
    set(u) ? t.pulse(c, u, o) : t.update(c, u, s);
  }) : a = (l) => t.update(n(l), r, s), e.apply(a);
}
function yir(t, e, n, r, i, o) {
  if (r === void 0)
    e.targets().add(n);
  else {
    const s = o || {}, a = new jo(null, vir(n, r), i, !1);
    a.modified(s.force), a.rank = e.rank, e.targets().add(a), n && (a.skip(!0), a.value = n.value, a.targets().add(n), t.connect(n, [a]));
  }
}
function vir(t, e) {
  return e = ri(e) ? e : lc(e), t ? function(n, r) {
    const i = e(n, r);
    return t.skip() || (t.skip(i !== this.value).value = i), i;
  } : e;
}
function Bir(t) {
  t.rank = ++this._rank;
}
function bir(t) {
  const e = [t];
  let n, r, i;
  for (; e.length; )
    if (this.rank(n = e.pop()), r = n._targets)
      for (i = r.length; --i >= 0; )
        e.push(n = r[i]), n === t && wt("Cycle detected in dataflow graph.");
}
const _5 = {}, lp = 1, Km = 2, q0 = 4, _ir = lp | Km, ILe = lp | q0, xb = lp | Km | q0, mLe = 8, q2 = 16, CLe = 32, ELe = 64;
function FC(t, e, n) {
  this.dataflow = t, this.stamp = e ?? -1, this.add = [], this.rem = [], this.mod = [], this.fields = null, this.encode = n || null;
}
function fW(t, e) {
  const n = [];
  return Jm(t, e, (r) => n.push(r)), n;
}
function yLe(t, e) {
  const n = {};
  return t.visit(e, (r) => {
    n[tr(r)] = 1;
  }), (r) => n[tr(r)] ? null : r;
}
function d3(t, e) {
  return t ? (n, r) => t(n, r) && e(n, r) : e;
}
FC.prototype = {
  /**
   * Sentinel value indicating pulse propagation should stop.
   */
  StopPropagation: _5,
  /**
   * Boolean flag indicating ADD (added) tuples.
   */
  ADD: lp,
  /**
   * Boolean flag indicating REM (removed) tuples.
   */
  REM: Km,
  /**
   * Boolean flag indicating MOD (modified) tuples.
   */
  MOD: q0,
  /**
   * Boolean flag indicating ADD (added) and REM (removed) tuples.
   */
  ADD_REM: _ir,
  /**
   * Boolean flag indicating ADD (added) and MOD (modified) tuples.
   */
  ADD_MOD: ILe,
  /**
   * Boolean flag indicating ADD, REM and MOD tuples.
   */
  ALL: xb,
  /**
   * Boolean flag indicating all tuples in a data source
   * except for the ADD, REM and MOD tuples.
   */
  REFLOW: mLe,
  /**
   * Boolean flag indicating a 'pass-through' to a
   * backing data source, ignoring ADD, REM and MOD tuples.
   */
  SOURCE: q2,
  /**
   * Boolean flag indicating that source data should be
   * suppressed when creating a forked pulse.
   */
  NO_SOURCE: CLe,
  /**
   * Boolean flag indicating that field modifications should be
   * suppressed when creating a forked pulse.
   */
  NO_FIELDS: ELe,
  /**
   * Creates a new pulse based on the values of this pulse.
   * The dataflow, time stamp and field modification values are copied over.
   * By default, new empty ADD, REM and MOD arrays are created.
   * @param {number} flags - Integer of boolean flags indicating which (if any)
   *   tuple arrays should be copied to the new pulse. The supported flag values
   *   are ADD, REM and MOD. Array references are copied directly: new array
   *   instances are not created.
   * @return {Pulse} - The forked pulse instance.
   * @see init
   */
  fork(t) {
    return new FC(this.dataflow).init(this, t);
  },
  /**
   * Creates a copy of this pulse with new materialized array
   * instances for the ADD, REM, MOD, and SOURCE arrays.
   * The dataflow, time stamp and field modification values are copied over.
   * @return {Pulse} - The cloned pulse instance.
   * @see init
   */
  clone() {
    const t = this.fork(xb);
    return t.add = t.add.slice(), t.rem = t.rem.slice(), t.mod = t.mod.slice(), t.source && (t.source = t.source.slice()), t.materialize(xb | q2);
  },
  /**
   * Returns a pulse that adds all tuples from a backing source. This is
   * useful for cases where operators are added to a dataflow after an
   * upstream data pipeline has already been processed, ensuring that
   * new operators can observe all tuples within a stream.
   * @return {Pulse} - A pulse instance with all source tuples included
   *   in the add array. If the current pulse already has all source
   *   tuples in its add array, it is returned directly. If the current
   *   pulse does not have a backing source, it is returned directly.
   */
  addAll() {
    let t = this;
    return !t.source || t.add === t.rem || !t.rem.length && t.source.length === t.add.length || (t = new FC(this.dataflow).init(this), t.add = t.source, t.rem = []), t;
  },
  /**
   * Initialize this pulse based on the values of another pulse. This method
   * is used internally by {@link fork} to initialize a new forked tuple.
   * The dataflow, time stamp and field modification values are copied over.
   * By default, new empty ADD, REM and MOD arrays are created.
   * @param {Pulse} src - The source pulse to copy from.
   * @param {number} flags - Integer of boolean flags indicating which (if any)
   *   tuple arrays should be copied to the new pulse. The supported flag values
   *   are ADD, REM and MOD. Array references are copied directly: new array
   *   instances are not created. By default, source data arrays are copied
   *   to the new pulse. Use the NO_SOURCE flag to enforce a null source.
   * @return {Pulse} - Returns this Pulse instance.
   */
  init(t, e) {
    const n = this;
    return n.stamp = t.stamp, n.encode = t.encode, t.fields && !(e & ELe) && (n.fields = t.fields), e & lp ? (n.addF = t.addF, n.add = t.add) : (n.addF = null, n.add = []), e & Km ? (n.remF = t.remF, n.rem = t.rem) : (n.remF = null, n.rem = []), e & q0 ? (n.modF = t.modF, n.mod = t.mod) : (n.modF = null, n.mod = []), e & CLe ? (n.srcF = null, n.source = null) : (n.srcF = t.srcF, n.source = t.source, t.cleans && (n.cleans = t.cleans)), n;
  },
  /**
   * Schedules a function to run after pulse propagation completes.
   * @param {function} func - The function to run.
   */
  runAfter(t) {
    this.dataflow.runAfter(t);
  },
  /**
   * Indicates if tuples have been added, removed or modified.
   * @param {number} [flags] - The tuple types (ADD, REM or MOD) to query.
   *   Defaults to ALL, returning true if any tuple type has changed.
   * @return {boolean} - Returns true if one or more queried tuple types have
   *   changed, false otherwise.
   */
  changed(t) {
    const e = t || xb;
    return e & lp && this.add.length || e & Km && this.rem.length || e & q0 && this.mod.length;
  },
  /**
   * Forces a "reflow" of tuple values, such that all tuples in the backing
   * source are added to the MOD set, unless already present in the ADD set.
   * @param {boolean} [fork=false] - If true, returns a forked copy of this
   *   pulse, and invokes reflow on that derived pulse.
   * @return {Pulse} - The reflowed pulse instance.
   */
  reflow(t) {
    if (t)
      return this.fork(xb).reflow();
    const e = this.add.length, n = this.source && this.source.length;
    return n && n !== e && (this.mod = this.source, e && this.filter(q0, yLe(this, lp))), this;
  },
  /**
   * Get/set metadata to pulse requesting garbage collection
   * to reclaim currently unused resources.
   */
  clean(t) {
    return arguments.length ? (this.cleans = !!t, this) : this.cleans;
  },
  /**
   * Marks one or more data field names as modified to assist dependency
   * tracking and incremental processing by transform operators.
   * @param {string|Array<string>} _ - The field(s) to mark as modified.
   * @return {Pulse} - This pulse instance.
   */
  modifies(t) {
    const e = this.fields || (this.fields = {});
    return Nt(t) ? t.forEach((n) => e[n] = !0) : e[t] = !0, this;
  },
  /**
   * Checks if one or more data fields have been modified during this pulse
   * propagation timestamp.
   * @param {string|Array<string>} _ - The field(s) to check for modified.
   * @param {boolean} nomod - If true, will check the modified flag even if
   *   no mod tuples exist. If false (default), mod tuples must be present.
   * @return {boolean} - Returns true if any of the provided fields has been
   *   marked as modified, false otherwise.
   */
  modified(t, e) {
    const n = this.fields;
    return (e || this.mod.length) && n ? arguments.length ? Nt(t) ? t.some((r) => n[r]) : n[t] : !!n : !1;
  },
  /**
   * Adds a filter function to one more tuple sets. Filters are applied to
   * backing tuple arrays, to determine the actual set of tuples considered
   * added, removed or modified. They can be used to delay materialization of
   * a tuple set in order to avoid expensive array copies. In addition, the
   * filter functions can serve as value transformers: unlike standard predicate
   * function (which return boolean values), Pulse filters should return the
   * actual tuple value to process. If a tuple set is already filtered, the
   * new filter function will be appended into a conjuntive ('and') query.
   * @param {number} flags - Flags indicating the tuple set(s) to filter.
   * @param {function(*):object} filter - Filter function that will be applied
   *   to the tuple set array, and should return a data tuple if the value
   *   should be included in the tuple set, and falsy (or null) otherwise.
   * @return {Pulse} - Returns this pulse instance.
   */
  filter(t, e) {
    const n = this;
    return t & lp && (n.addF = d3(n.addF, e)), t & Km && (n.remF = d3(n.remF, e)), t & q0 && (n.modF = d3(n.modF, e)), t & q2 && (n.srcF = d3(n.srcF, e)), n;
  },
  /**
   * Materialize one or more tuple sets in this pulse. If the tuple set(s) have
   * a registered filter function, it will be applied and the tuple set(s) will
   * be replaced with materialized tuple arrays.
   * @param {number} flags - Flags indicating the tuple set(s) to materialize.
   * @return {Pulse} - Returns this pulse instance.
   */
  materialize(t) {
    t = t || xb;
    const e = this;
    return t & lp && e.addF && (e.add = fW(e.add, e.addF), e.addF = null), t & Km && e.remF && (e.rem = fW(e.rem, e.remF), e.remF = null), t & q0 && e.modF && (e.mod = fW(e.mod, e.modF), e.modF = null), t & q2 && e.srcF && (e.source = e.source.filter(e.srcF), e.srcF = null), e;
  },
  /**
   * Visit one or more tuple sets in this pulse.
   * @param {number} flags - Flags indicating the tuple set(s) to visit.
   *   Legal values are ADD, REM, MOD and SOURCE (if a backing data source
   *   has been set).
   * @param {function(object):*} - Visitor function invoked per-tuple.
   * @return {Pulse} - Returns this pulse instance.
   */
  visit(t, e) {
    const n = this, r = e;
    if (t & q2)
      return Jm(n.source, n.srcF, r), n;
    t & lp && Jm(n.add, n.addF, r), t & Km && Jm(n.rem, n.remF, r), t & q0 && Jm(n.mod, n.modF, r);
    const i = n.source;
    if (t & mLe && i) {
      const o = n.add.length + n.mod.length;
      o === i.length || (o ? Jm(i, yLe(n, ILe), r) : Jm(i, n.srcF, r));
    }
    return n;
  }
};
function kge(t, e, n, r) {
  const i = this, o = n.length;
  let s = 0;
  this.dataflow = t, this.stamp = e, this.fields = null, this.encode = r || null, this.pulses = n;
  for (let a = 0; a < o; ++a) {
    const A = n[a];
    if (A.stamp === e) {
      if (A.fields) {
        const l = i.fields || (i.fields = {});
        for (const c in A.fields)
          l[c] = 1;
      }
      A.changed(i.ADD) && (s |= i.ADD), A.changed(i.REM) && (s |= i.REM), A.changed(i.MOD) && (s |= i.MOD);
    }
  }
  this.changes = s;
}
on(kge, FC, {
  /**
   * Creates a new pulse based on the values of this pulse.
   * The dataflow, time stamp and field modification values are copied over.
   * @return {Pulse}
   */
  fork(t) {
    const e = new FC(this.dataflow).init(this, t & this.NO_FIELDS);
    return t !== void 0 && (t & e.ADD && this.visit(e.ADD, (n) => e.add.push(n)), t & e.REM && this.visit(e.REM, (n) => e.rem.push(n)), t & e.MOD && this.visit(e.MOD, (n) => e.mod.push(n))), e;
  },
  changed(t) {
    return this.changes & t;
  },
  modified(t) {
    const e = this, n = e.fields;
    return n && e.changes & e.MOD ? Nt(t) ? t.some((r) => n[r]) : n[t] : 0;
  },
  filter() {
    wt("MultiPulse does not support filtering.");
  },
  materialize() {
    wt("MultiPulse does not support materialization.");
  },
  visit(t, e) {
    const n = this, r = n.pulses, i = r.length;
    let o = 0;
    if (t & n.SOURCE)
      for (; o < i; ++o)
        r[o].visit(t, e);
    else
      for (; o < i; ++o)
        r[o].stamp === n.stamp && r[o].visit(t, e);
    return n;
  }
});
async function Sir(t, e, n) {
  const r = this, i = [];
  if (r._pulse)
    return aet(r);
  if (r._pending && await r._pending, e && await zG(r, e), !r._touched.length)
    return r.debug("Dataflow invoked, but nothing to do."), r;
  const o = ++r._clock;
  r._pulse = new FC(r, o, t), r._touched.forEach((c) => r._enqueue(c, !0)), r._touched = gj(nO);
  let s = 0, a, A, l;
  try {
    for (; r._heap.size() > 0; ) {
      if (a = r._heap.pop(), a.rank !== a.qrank) {
        r._enqueue(a, !0);
        continue;
      }
      A = a.run(r._getPulse(a, t)), A.then ? A = await A : A.async && (i.push(A.async), A = _5), A !== _5 && a._targets && a._targets.forEach((c) => r._enqueue(c)), ++s;
    }
  } catch (c) {
    r._heap.clear(), l = c;
  }
  if (r._input = {}, r._pulse = null, r.debug(`Pulse ${o}: ${s} operators`), l && (r._postrun = [], r.error(l)), r._postrun.length) {
    const c = r._postrun.sort((u, f) => f.priority - u.priority);
    r._postrun = [];
    for (let u = 0; u < c.length; ++u)
      await zG(r, c[u].callback);
  }
  return n && await zG(r, n), i.length && Promise.all(i).then((c) => r.runAsync(null, () => {
    c.forEach((u) => {
      try {
        u(r);
      } catch (f) {
        r.error(f);
      }
    });
  })), r;
}
async function Qir(t, e, n) {
  for (; this._running; )
    await this._running;
  const r = () => this._running = null;
  return (this._running = this.evaluate(t, e, n)).then(r, r), this._running;
}
function wir(t, e, n) {
  return this._pulse ? aet(this) : (this.evaluate(t, e, n), this);
}
function xir(t, e, n) {
  if (this._pulse || e)
    this._postrun.push({
      priority: n || 0,
      callback: t
    });
  else
    try {
      t(this);
    } catch (r) {
      this.error(r);
    }
}
function aet(t) {
  return t.error("Dataflow already running. Use runAsync() to chain invocations."), t;
}
function Rir(t, e) {
  const n = t.stamp < this._clock;
  n && (t.stamp = this._clock), (n || e) && (t.qrank = t.rank, this._heap.push(t));
}
function Dir(t, e) {
  const n = t.source, r = this._clock;
  return n && Nt(n) ? new kge(this, r, n.map((i) => i.pulse), e) : this._input[t.id] || Tir(this._pulse, n && n.pulse);
}
function Tir(t, e) {
  return e && e.stamp === t.stamp ? e : (t = t.fork(), e && e !== _5 && (t.source = e.source), t);
}
const Gge = {
  skip: !1,
  force: !1
};
function Nir(t, e) {
  const n = e || Gge;
  return this._pulse ? this._enqueue(t) : this._touched.add(t), n.skip && t.skip(!0), this;
}
function Lir(t, e, n) {
  const r = n || Gge;
  return (t.set(e) || r.force) && this.touch(t, r), this;
}
function Mir(t, e, n) {
  this.touch(t, n || Gge);
  const r = new FC(this, this._clock + (this._pulse ? 0 : 1)), i = t.pulse && t.pulse.source || [];
  return r.target = t, this._input[t.id] = e.pulse(r, i), this;
}
function Oir(t) {
  let e = [];
  return {
    clear: () => e = [],
    size: () => e.length,
    peek: () => e[0],
    push: (n) => (e.push(n), Aet(e, 0, e.length - 1, t)),
    pop: () => {
      const n = e.pop();
      let r;
      return e.length ? (r = e[0], e[0] = n, Fir(e, 0, t)) : r = n, r;
    }
  };
}
function Aet(t, e, n, r) {
  let i, o;
  const s = t[n];
  for (; n > e; ) {
    if (o = n - 1 >> 1, i = t[o], r(s, i) < 0) {
      t[n] = i, n = o;
      continue;
    }
    break;
  }
  return t[n] = s;
}
function Fir(t, e, n) {
  const r = e, i = t.length, o = t[e];
  let s = (e << 1) + 1, a;
  for (; s < i; )
    a = s + 1, a < i && n(t[s], t[a]) >= 0 && (s = a), t[e] = t[s], e = s, s = (e << 1) + 1;
  return t[e] = o, Aet(t, r, e, n);
}
function sS() {
  this.logger(age()), this.logLevel(oge), this._clock = 0, this._rank = 0, this._locale = Lge();
  try {
    this._loader = fj();
  } catch {
  }
  this._touched = gj(nO), this._input = {}, this._pulse = null, this._heap = Oir((t, e) => t.qrank - e.qrank), this._postrun = [];
}
function j2(t) {
  return function() {
    return this._log[t].apply(this, arguments);
  };
}
sS.prototype = {
  /**
   * The current timestamp of this dataflow. This value reflects the
   * timestamp of the previous dataflow run. The dataflow is initialized
   * with a stamp value of 0. The initial run of the dataflow will have
   * a timestap of 1, and so on. This value will match the
   * {@link Pulse.stamp} property.
   * @return {number} - The current timestamp value.
   */
  stamp() {
    return this._clock;
  },
  /**
   * Gets or sets the loader instance to use for data file loading. A
   * loader object must provide a "load" method for loading files and a
   * "sanitize" method for checking URL/filename validity. Both methods
   * should accept a URI and options hash as arguments, and return a Promise
   * that resolves to the loaded file contents (load) or a hash containing
   * sanitized URI data with the sanitized url assigned to the "href" property
   * (sanitize).
   * @param {object} _ - The loader instance to use.
   * @return {object|Dataflow} - If no arguments are provided, returns
   *   the current loader instance. Otherwise returns this Dataflow instance.
   */
  loader(t) {
    return arguments.length ? (this._loader = t, this) : this._loader;
  },
  /**
   * Gets or sets the locale instance to use for formatting and parsing
   * string values. The locale object should be provided by the
   * vega-format library, and include methods such as format, timeFormat,
   * utcFormat, timeParse, and utcParse.
   * @param {object} _ - The locale instance to use.
   * @return {object|Dataflow} - If no arguments are provided, returns
   *   the current locale instance. Otherwise returns this Dataflow instance.
   */
  locale(t) {
    return arguments.length ? (this._locale = t, this) : this._locale;
  },
  /**
   * Get or set the logger instance used to log messages. If no arguments are
   * provided, returns the current logger instance. Otherwise, sets the logger
   * and return this Dataflow instance. Provided loggers must support the full
   * API of logger objects generated by the vega-util logger method. Note that
   * by default the log level of the new logger will be used; use the logLevel
   * method to adjust the log level as needed.
   */
  logger(t) {
    return arguments.length ? (this._log = t, this) : this._log;
  },
  /**
   * Logs an error message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit error messages.
   */
  error: j2("error"),
  /**
   * Logs a warning message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit warning messages.
   */
  warn: j2("warn"),
  /**
   * Logs a information message. By default, logged messages are written to
   * console output. The message will only be logged if the current log level is
   * high enough to permit information messages.
   */
  info: j2("info"),
  /**
   * Logs a debug message. By default, logged messages are written to console
   * output. The message will only be logged if the current log level is high
   * enough to permit debug messages.
   */
  debug: j2("debug"),
  /**
   * Get or set the current log level. If an argument is provided, it
   * will be used as the new log level.
   * @param {number} [level] - Should be one of None, Warn, Info
   * @return {number} - The current log level.
   */
  logLevel: j2("level"),
  /**
   * Empty entry threshold for garbage cleaning. Map data structures will
   * perform cleaning once the number of empty entries exceeds this value.
   */
  cleanThreshold: 1e4,
  // OPERATOR REGISTRATION
  add: lir,
  connect: cir,
  rank: Bir,
  rerank: bir,
  // OPERATOR UPDATES
  pulse: Mir,
  touch: Nir,
  update: Lir,
  changeset: b1,
  // DATA LOADING
  ingest: hir,
  parse: gir,
  preload: pir,
  request: dir,
  // EVENT HANDLING
  events: fir,
  on: Cir,
  // PULSE PROPAGATION
  evaluate: Sir,
  run: wir,
  runAsync: Qir,
  runAfter: xir,
  _enqueue: Rir,
  _getPulse: Dir
};
function yt(t, e) {
  jo.call(this, t, null, e);
}
on(yt, jo, {
  /**
   * Overrides {@link Operator.evaluate} for transform operators.
   * Internally, this method calls {@link evaluate} to perform processing.
   * If {@link evaluate} returns a falsy value, the input pulse is returned.
   * This method should NOT be overridden, instead overrride {@link evaluate}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return the output pulse for this operator (or StopPropagation)
   */
  run(t) {
    if (t.stamp < this.stamp)
      return t.StopPropagation;
    let e;
    return this.skip() ? this.skip(!1) : e = this.evaluate(t), e = e || t, e.then ? e = e.then((n) => this.pulse = n) : e !== t.StopPropagation && (this.pulse = e), e;
  },
  /**
   * Overrides {@link Operator.evaluate} for transform operators.
   * Marshalls parameter values and then invokes {@link transform}.
   * @param {Pulse} pulse - the current dataflow pulse.
   * @return {Pulse} The output pulse (or StopPropagation). A falsy return
       value (including undefined) will let the input pulse pass through.
  */
  evaluate(t) {
    const e = this.marshall(t.stamp), n = this.transform(e, t);
    return e.clear(), n;
  },
  /**
   * Process incoming pulses.
   * Subclasses should override this method to implement transforms.
   * @param {Parameters} _ - The operator parameter values.
   * @param {Pulse} pulse - The current dataflow pulse.
   * @return {Pulse} The output pulse (or StopPropagation). A falsy return
   *   value (including undefined) will let the input pulse pass through.
   */
  transform() {
  }
});
const IQ = {};
function cet(t) {
  const e = uet(t);
  return e && e.Definition || null;
}
function uet(t) {
  return t = t && t.toLowerCase(), Kn(IQ, t) ? IQ[t] : null;
}
function* fet(t, e) {
  if (e == null)
    for (let n of t)
      n != null && n !== "" && (n = +n) >= n && (yield n);
  else {
    let n = -1;
    for (let r of t)
      r = e(r, ++n, t), r != null && r !== "" && (r = +r) >= r && (yield r);
  }
}
function Uge(t, e, n) {
  const r = Float64Array.from(fet(t, n));
  return r.sort(LC), e.map((i) => tnr(r, i));
}
function Hge(t, e) {
  return Uge(t, [0.25, 0.5, 0.75], e);
}
function $ge(t, e) {
  const n = t.length, r = Jtr(t, e), i = Hge(t, e), o = (i[2] - i[0]) / 1.34;
  return 1.06 * (Math.min(r, o) || r || Math.abs(i[0]) || 1) * Math.pow(n, -0.2);
}
function get(t) {
  const e = t.maxbins || 20, n = t.base || 10, r = Math.log(n), i = t.divide || [5, 2];
  let o = t.extent[0], s = t.extent[1], a, A, l, c, u, f;
  const h = t.span || s - o || Math.abs(o) || 1;
  if (t.step)
    a = t.step;
  else if (t.steps) {
    for (c = h / e, u = 0, f = t.steps.length; u < f && t.steps[u] < c; ++u)
      ;
    a = t.steps[Math.max(0, u - 1)];
  } else {
    for (A = Math.ceil(Math.log(e) / r), l = t.minstep || 0, a = Math.max(l, Math.pow(n, Math.round(Math.log(h) / r) - A)); Math.ceil(h / a) > e; )
      a *= n;
    for (u = 0, f = i.length; u < f; ++u)
      c = a / i[u], c >= l && h / c <= e && (a = c);
  }
  c = Math.log(a);
  const d = c >= 0 ? 0 : ~~(-c / r) + 1, I = Math.pow(n, -d - 1);
  return (t.nice || t.nice === void 0) && (c = Math.floor(o / a + I) * a, o = o < c ? c - a : c, s = Math.ceil(s / a) * a), {
    start: o,
    stop: s === o ? o + a : s,
    step: a
  };
}
var Yg = Math.random;
function Pir(t) {
  Yg = t;
}
function het(t, e, n, r) {
  if (!t.length)
    return [void 0, void 0];
  const i = Float64Array.from(fet(t, r)), o = i.length, s = e;
  let a, A, l, c;
  for (l = 0, c = Array(s); l < s; ++l) {
    for (a = 0, A = 0; A < o; ++A)
      a += i[~~(Yg() * o)];
    c[l] = a / o;
  }
  return c.sort(LC), [Hre(c, n / 2), Hre(c, 1 - n / 2)];
}
function det(t, e, n, r) {
  r = r || ((f) => f);
  const i = t.length, o = new Float64Array(i);
  let s = 0, a = 1, A = r(t[0]), l = A, c = A + e, u;
  for (; a < i; ++a) {
    if (u = r(t[a]), u >= c) {
      for (l = (A + l) / 2; s < a; ++s)
        o[s] = l;
      c = u + e, A = u;
    }
    l = u;
  }
  for (l = (A + l) / 2; s < a; ++s)
    o[s] = l;
  return n ? kir(o, e + e / 4) : o;
}
function kir(t, e) {
  const n = t.length;
  let r = 0, i = 1, o, s;
  for (; t[r] === t[i]; )
    ++i;
  for (; i < n; ) {
    for (o = i + 1; t[i] === t[o]; )
      ++o;
    if (t[i] - t[i - 1] < e) {
      for (s = i + (r + o - i - i >> 1); s < i; )
        t[s++] = t[i];
      for (; s > i; )
        t[s--] = t[r];
    }
    r = i, i = o;
  }
  return t;
}
function Gir(t) {
  return function() {
    return t = (1103515245 * t + 12345) % 2147483647, t / 2147483647;
  };
}
function Uir(t, e) {
  e == null && (e = t, t = 0);
  let n, r, i;
  const o = {
    min(s) {
      return arguments.length ? (n = s || 0, i = r - n, o) : n;
    },
    max(s) {
      return arguments.length ? (r = s || 0, i = r - n, o) : r;
    },
    sample() {
      return n + Math.floor(i * Yg());
    },
    pdf(s) {
      return s === Math.floor(s) && s >= n && s < r ? 1 / i : 0;
    },
    cdf(s) {
      const a = Math.floor(s);
      return a < n ? 0 : a >= r ? 1 : (a - n + 1) / i;
    },
    icdf(s) {
      return s >= 0 && s <= 1 ? n - 1 + Math.floor(s * i) : NaN;
    }
  };
  return o.min(t).max(e);
}
const pet = Math.sqrt(2 * Math.PI), Hir = Math.SQRT2;
let Y2 = NaN;
function mj(t, e) {
  t = t || 0, e = e ?? 1;
  let n = 0, r = 0, i, o;
  if (Y2 === Y2)
    n = Y2, Y2 = NaN;
  else {
    do
      n = Yg() * 2 - 1, r = Yg() * 2 - 1, i = n * n + r * r;
    while (i === 0 || i > 1);
    o = Math.sqrt(-2 * Math.log(i) / i), n *= o, Y2 = r * o;
  }
  return t + n * e;
}
function qge(t, e, n) {
  n = n ?? 1;
  const r = (t - (e || 0)) / n;
  return Math.exp(-0.5 * r * r) / (n * pet);
}
function Cj(t, e, n) {
  e = e || 0, n = n ?? 1;
  const r = (t - e) / n, i = Math.abs(r);
  let o;
  if (i > 37)
    o = 0;
  else {
    const s = Math.exp(-i * i / 2);
    let a;
    i < 7.07106781186547 ? (a = 0.0352624965998911 * i + 0.700383064443688, a = a * i + 6.37396220353165, a = a * i + 33.912866078383, a = a * i + 112.079291497871, a = a * i + 221.213596169931, a = a * i + 220.206867912376, o = s * a, a = 0.0883883476483184 * i + 1.75566716318264, a = a * i + 16.064177579207, a = a * i + 86.7807322029461, a = a * i + 296.564248779674, a = a * i + 637.333633378831, a = a * i + 793.826512519948, a = a * i + 440.413735824752, o = o / a) : (a = i + 0.65, a = i + 4 / a, a = i + 3 / a, a = i + 2 / a, a = i + 1 / a, o = s / a / 2.506628274631);
  }
  return r > 0 ? 1 - o : o;
}
function Ej(t, e, n) {
  return t < 0 || t > 1 ? NaN : (e || 0) + (n ?? 1) * Hir * $ir(2 * t - 1);
}
function $ir(t) {
  let e = -Math.log((1 - t) * (1 + t)), n;
  return e < 6.25 ? (e -= 3.125, n = -364441206401782e-35, n = -16850591381820166e-35 + n * e, n = 128584807152564e-32 + n * e, n = 11157877678025181e-33 + n * e, n = -1333171662854621e-31 + n * e, n = 20972767875968562e-33 + n * e, n = 6637638134358324e-30 + n * e, n = -4054566272975207e-29 + n * e, n = -8151934197605472e-29 + n * e, n = 26335093153082323e-28 + n * e, n = -12975133253453532e-27 + n * e, n = -5415412054294628e-26 + n * e, n = 10512122733215323e-25 + n * e, n = -4112633980346984e-24 + n * e, n = -29070369957882005e-24 + n * e, n = 42347877827932404e-23 + n * e, n = -13654692000834679e-22 + n * e, n = -13882523362786469e-21 + n * e, n = 18673420803405714e-20 + n * e, n = -740702534166267e-18 + n * e, n = -0.006033670871430149 + n * e, n = 0.24015818242558962 + n * e, n = 1.6536545626831027 + n * e) : e < 16 ? (e = Math.sqrt(e) - 3.25, n = 22137376921775787e-25, n = 9075656193888539e-23 + n * e, n = -27517406297064545e-23 + n * e, n = 18239629214389228e-24 + n * e, n = 15027403968909828e-22 + n * e, n = -4013867526981546e-21 + n * e, n = 29234449089955446e-22 + n * e, n = 12475304481671779e-21 + n * e, n = -47318229009055734e-21 + n * e, n = 6828485145957318e-20 + n * e, n = 24031110387097894e-21 + n * e, n = -3550375203628475e-19 + n * e, n = 9532893797373805e-19 + n * e, n = -0.0016882755560235047 + n * e, n = 0.002491442096107851 + n * e, n = -0.003751208507569241 + n * e, n = 0.005370914553590064 + n * e, n = 1.0052589676941592 + n * e, n = 3.0838856104922208 + n * e) : Number.isFinite(e) ? (e = Math.sqrt(e) - 5, n = -27109920616438573e-27, n = -2555641816996525e-25 + n * e, n = 15076572693500548e-25 + n * e, n = -3789465440126737e-24 + n * e, n = 761570120807834e-23 + n * e, n = -1496002662714924e-23 + n * e, n = 2914795345090108e-23 + n * e, n = -6771199775845234e-23 + n * e, n = 22900482228026655e-23 + n * e, n = -99298272942317e-20 + n * e, n = 4526062597223154e-21 + n * e, n = -1968177810553167e-20 + n * e, n = 7599527703001776e-20 + n * e, n = -21503011930044477e-20 + n * e, n = -13871931833623122e-20 + n * e, n = 1.0103004648645344 + n * e, n = 4.849906401408584 + n * e) : n = 1 / 0, n * t;
}
function jge(t, e) {
  let n, r;
  const i = {
    mean(o) {
      return arguments.length ? (n = o || 0, i) : n;
    },
    stdev(o) {
      return arguments.length ? (r = o ?? 1, i) : r;
    },
    sample: () => mj(n, r),
    pdf: (o) => qge(o, n, r),
    cdf: (o) => Cj(o, n, r),
    icdf: (o) => Ej(o, n, r)
  };
  return i.mean(t).stdev(e);
}
function Yge(t, e) {
  const n = jge();
  let r = 0;
  const i = {
    data(o) {
      return arguments.length ? (t = o, r = o ? o.length : 0, i.bandwidth(e)) : t;
    },
    bandwidth(o) {
      return arguments.length ? (e = o, !e && t && (e = $ge(t)), i) : e;
    },
    sample() {
      return t[~~(Yg() * r)] + e * n.sample();
    },
    pdf(o) {
      let s = 0, a = 0;
      for (; a < r; ++a)
        s += n.pdf((o - t[a]) / e);
      return s / e / r;
    },
    cdf(o) {
      let s = 0, a = 0;
      for (; a < r; ++a)
        s += n.cdf((o - t[a]) / e);
      return s / r;
    },
    icdf() {
      throw Error("KDE icdf not supported.");
    }
  };
  return i.data(t);
}
function zge(t, e) {
  return t = t || 0, e = e ?? 1, Math.exp(t + mj() * e);
}
function Vge(t, e, n) {
  if (t <= 0)
    return 0;
  e = e || 0, n = n ?? 1;
  const r = (Math.log(t) - e) / n;
  return Math.exp(-0.5 * r * r) / (n * pet * t);
}
function Jge(t, e, n) {
  return Cj(Math.log(t), e, n);
}
function Kge(t, e, n) {
  return Math.exp(Ej(t, e, n));
}
function Iet(t, e) {
  let n, r;
  const i = {
    mean(o) {
      return arguments.length ? (n = o || 0, i) : n;
    },
    stdev(o) {
      return arguments.length ? (r = o ?? 1, i) : r;
    },
    sample: () => zge(n, r),
    pdf: (o) => Vge(o, n, r),
    cdf: (o) => Jge(o, n, r),
    icdf: (o) => Kge(o, n, r)
  };
  return i.mean(t).stdev(e);
}
function met(t, e) {
  let n = 0, r;
  function i(s) {
    const a = [];
    let A = 0, l;
    for (l = 0; l < n; ++l)
      A += a[l] = s[l] == null ? 1 : +s[l];
    for (l = 0; l < n; ++l)
      a[l] /= A;
    return a;
  }
  const o = {
    weights(s) {
      return arguments.length ? (r = i(e = s || []), o) : e;
    },
    distributions(s) {
      return arguments.length ? (s ? (n = s.length, t = s) : (n = 0, t = []), o.weights(e)) : t;
    },
    sample() {
      const s = Yg();
      let a = t[n - 1], A = r[0], l = 0;
      for (; l < n - 1; A += r[++l])
        if (s < A) {
          a = t[l];
          break;
        }
      return a.sample();
    },
    pdf(s) {
      let a = 0, A = 0;
      for (; A < n; ++A)
        a += r[A] * t[A].pdf(s);
      return a;
    },
    cdf(s) {
      let a = 0, A = 0;
      for (; A < n; ++A)
        a += r[A] * t[A].cdf(s);
      return a;
    },
    icdf() {
      throw Error("Mixture icdf not supported.");
    }
  };
  return o.distributions(t).weights(e);
}
function Wge(t, e) {
  return e == null && (e = t ?? 1, t = 0), t + (e - t) * Yg();
}
function Xge(t, e, n) {
  return n == null && (n = e ?? 1, e = 0), t >= e && t <= n ? 1 / (n - e) : 0;
}
function Zge(t, e, n) {
  return n == null && (n = e ?? 1, e = 0), t < e ? 0 : t > n ? 1 : (t - e) / (n - e);
}
function ehe(t, e, n) {
  return n == null && (n = e ?? 1, e = 0), t >= 0 && t <= 1 ? e + t * (n - e) : NaN;
}
function Cet(t, e) {
  let n, r;
  const i = {
    min(o) {
      return arguments.length ? (n = o || 0, i) : n;
    },
    max(o) {
      return arguments.length ? (r = o ?? 1, i) : r;
    },
    sample: () => Wge(n, r),
    pdf: (o) => Xge(o, n, r),
    cdf: (o) => Zge(o, n, r),
    icdf: (o) => ehe(o, n, r)
  };
  return e == null && (e = t ?? 1, t = 0), i.min(t).max(e);
}
function iO(t, e, n, r) {
  const i = r - t * t, o = Math.abs(i) < 1e-24 ? 0 : (n - t * e) / i;
  return [e - o * t, o];
}
function yj(t, e, n, r) {
  t = t.filter((h) => {
    let d = e(h), I = n(h);
    return d != null && (d = +d) >= d && I != null && (I = +I) >= I;
  }), r && t.sort((h, d) => e(h) - e(d));
  const i = t.length, o = new Float64Array(i), s = new Float64Array(i);
  let a = 0, A = 0, l = 0, c, u, f;
  for (f of t)
    o[a] = c = +e(f), s[a] = u = +n(f), ++a, A += (c - A) / a, l += (u - l) / a;
  for (a = 0; a < i; ++a)
    o[a] -= A, s[a] -= l;
  return [o, s, A, l];
}
function oO(t, e, n, r) {
  let i = -1, o, s;
  for (const a of t)
    o = e(a), s = n(a), o != null && (o = +o) >= o && s != null && (s = +s) >= s && r(o, s, ++i);
}
function Cx(t, e, n, r, i) {
  let o = 0, s = 0;
  return oO(t, e, n, (a, A) => {
    const l = A - i(a), c = A - r;
    o += l * l, s += c * c;
  }), 1 - o / s;
}
function the(t, e, n) {
  let r = 0, i = 0, o = 0, s = 0, a = 0;
  oO(t, e, n, (c, u) => {
    ++a, r += (c - r) / a, i += (u - i) / a, o += (c * u - o) / a, s += (c * c - s) / a;
  });
  const A = iO(r, i, o, s), l = (c) => A[0] + A[1] * c;
  return {
    coef: A,
    predict: l,
    rSquared: Cx(t, e, n, i, l)
  };
}
function Eet(t, e, n) {
  let r = 0, i = 0, o = 0, s = 0, a = 0;
  oO(t, e, n, (c, u) => {
    ++a, c = Math.log(c), r += (c - r) / a, i += (u - i) / a, o += (c * u - o) / a, s += (c * c - s) / a;
  });
  const A = iO(r, i, o, s), l = (c) => A[0] + A[1] * Math.log(c);
  return {
    coef: A,
    predict: l,
    rSquared: Cx(t, e, n, i, l)
  };
}
function yet(t, e, n) {
  const [r, i, o, s] = yj(t, e, n);
  let a = 0, A = 0, l = 0, c = 0, u = 0, f, h, d;
  oO(t, e, n, (y, v) => {
    f = r[u++], h = Math.log(v), d = f * v, a += (v * h - a) / u, A += (d - A) / u, l += (d * h - l) / u, c += (f * d - c) / u;
  });
  const [I, m] = iO(A / s, a / s, l / s, c / s), C = (y) => Math.exp(I + m * (y - o));
  return {
    coef: [Math.exp(I - m * o), m],
    predict: C,
    rSquared: Cx(t, e, n, s, C)
  };
}
function vet(t, e, n) {
  let r = 0, i = 0, o = 0, s = 0, a = 0, A = 0;
  oO(t, e, n, (u, f) => {
    const h = Math.log(u), d = Math.log(f);
    ++A, r += (h - r) / A, i += (d - i) / A, o += (h * d - o) / A, s += (h * h - s) / A, a += (f - a) / A;
  });
  const l = iO(r, i, o, s), c = (u) => l[0] * Math.pow(u, l[1]);
  return l[0] = Math.exp(l[0]), {
    coef: l,
    predict: c,
    rSquared: Cx(t, e, n, a, c)
  };
}
function nhe(t, e, n) {
  const [r, i, o, s] = yj(t, e, n), a = r.length;
  let A = 0, l = 0, c = 0, u = 0, f = 0, h, d, I, m;
  for (h = 0; h < a; )
    d = r[h], I = i[h++], m = d * d, A += (m - A) / h, l += (m * d - l) / h, c += (m * m - c) / h, u += (d * I - u) / h, f += (m * I - f) / h;
  const C = c - A * A, y = A * C - l * l, v = (f * A - u * l) / y, b = (u * C - f * l) / y, Q = -v * A, w = (R) => (R = R - o, v * R * R + b * R + Q + s);
  return {
    coef: [Q - b * o + v * o * o + s, b - 2 * v * o, v],
    predict: w,
    rSquared: Cx(t, e, n, s, w)
  };
}
function Bet(t, e, n, r) {
  if (r === 1)
    return the(t, e, n);
  if (r === 2)
    return nhe(t, e, n);
  const [i, o, s, a] = yj(t, e, n), A = i.length, l = [], c = [], u = r + 1;
  let f, h, d, I, m;
  for (f = 0; f < u; ++f) {
    for (d = 0, I = 0; d < A; ++d)
      I += Math.pow(i[d], f) * o[d];
    for (l.push(I), m = new Float64Array(u), h = 0; h < u; ++h) {
      for (d = 0, I = 0; d < A; ++d)
        I += Math.pow(i[d], f + h);
      m[h] = I;
    }
    c.push(m);
  }
  c.push(l);
  const C = jir(c), y = (v) => {
    v -= s;
    let b = a + C[0] + C[1] * v + C[2] * v * v;
    for (f = 3; f < u; ++f)
      b += C[f] * Math.pow(v, f);
    return b;
  };
  return {
    coef: qir(u, C, -s, a),
    predict: y,
    rSquared: Cx(t, e, n, a, y)
  };
}
function qir(t, e, n, r) {
  const i = Array(t);
  let o, s, a, A;
  for (o = 0; o < t; ++o)
    i[o] = 0;
  for (o = t - 1; o >= 0; --o)
    for (a = e[o], A = 1, i[o] += a, s = 1; s <= o; ++s)
      A *= (o + 1 - s) / s, i[o - s] += a * Math.pow(n, s) * A;
  return i[0] += r, i;
}
function jir(t) {
  const e = t.length - 1, n = [];
  let r, i, o, s, a;
  for (r = 0; r < e; ++r) {
    for (s = r, i = r + 1; i < e; ++i)
      Math.abs(t[r][i]) > Math.abs(t[r][s]) && (s = i);
    for (o = r; o < e + 1; ++o)
      a = t[o][r], t[o][r] = t[o][s], t[o][s] = a;
    for (i = r + 1; i < e; ++i)
      for (o = e; o >= r; o--)
        t[o][i] -= t[o][r] * t[r][i] / t[r][r];
  }
  for (i = e - 1; i >= 0; --i) {
    for (a = 0, o = i + 1; o < e; ++o)
      a += t[o][i] * n[o];
    n[i] = (t[e][i] - a) / t[i][i];
  }
  return n;
}
const vLe = 2, BLe = 1e-12;
function bet(t, e, n, r) {
  const [i, o, s, a] = yj(t, e, n, !0), A = i.length, l = Math.max(2, ~~(r * A)), c = new Float64Array(A), u = new Float64Array(A), f = new Float64Array(A).fill(1);
  for (let h = -1; ++h <= vLe; ) {
    const d = [0, l - 1];
    for (let m = 0; m < A; ++m) {
      const C = i[m], y = d[0], v = d[1], b = C - i[y] > i[v] - C ? y : v;
      let Q = 0, w = 0, R = 0, M = 0, O = 0;
      const L = 1 / Math.abs(i[b] - C || 1);
      for (let $ = y; $ <= v; ++$) {
        const U = i[$], X = o[$], K = Yir(Math.abs(C - U) * L) * f[$], z = U * K;
        Q += K, w += z, R += X * K, M += X * z, O += U * z;
      }
      const [N, k] = iO(w / Q, R / Q, M / Q, O / Q);
      c[m] = N + k * C, u[m] = Math.abs(o[m] - c[m]), zir(i, m + 1, d);
    }
    if (h === vLe)
      break;
    const I = tZe(u);
    if (Math.abs(I) < BLe)
      break;
    for (let m = 0, C, y; m < A; ++m)
      C = u[m] / (6 * I), f[m] = C >= 1 ? BLe : (y = 1 - C * C) * y;
  }
  return Vir(i, c, s, a);
}
function Yir(t) {
  return (t = 1 - t * t * t) * t * t;
}
function zir(t, e, n) {
  const r = t[e];
  let i = n[0], o = n[1] + 1;
  if (!(o >= t.length))
    for (; e > i && t[o] - r <= r - t[i]; )
      n[0] = ++i, n[1] = o, ++o;
}
function Vir(t, e, n, r) {
  const i = t.length, o = [];
  let s = 0, a = 0, A = [], l;
  for (; s < i; ++s)
    l = t[s] + n, A[0] === l ? A[1] += (e[s] - A[1]) / ++a : (a = 0, A[1] += r, A = [l, e[s]], o.push(A));
  return A[1] += r, o;
}
const Jir = 0.5 * Math.PI / 180;
function vj(t, e, n, r) {
  n = n || 25, r = Math.max(n, r || 200);
  const i = (I) => [I, t(I)], o = e[0], s = e[1], a = s - o, A = a / r, l = [i(o)], c = [];
  if (n === r) {
    for (let I = 1; I < r; ++I)
      l.push(i(o + I / n * a));
    return l.push(i(s)), l;
  } else {
    c.push(i(s));
    for (let I = n; --I > 0; )
      c.push(i(o + I / n * a));
  }
  let u = l[0], f = c[c.length - 1];
  const h = 1 / a, d = Kir(u[1], c);
  for (; f; ) {
    const I = i((u[0] + f[0]) / 2);
    I[0] - u[0] >= A && Wir(u, I, f, h, d) > Jir ? c.push(I) : (u = f, l.push(f), c.pop()), f = c[c.length - 1];
  }
  return l;
}
function Kir(t, e) {
  let n = t, r = t;
  const i = e.length;
  for (let o = 0; o < i; ++o) {
    const s = e[o][1];
    s < n && (n = s), s > r && (r = s);
  }
  return 1 / (r - n);
}
function Wir(t, e, n, r, i) {
  const o = Math.atan2(i * (n[1] - t[1]), r * (n[0] - t[0])), s = Math.atan2(i * (e[1] - t[1]), r * (e[0] - t[0]));
  return Math.abs(o - s);
}
function Xir(t) {
  return (e) => {
    const n = t.length;
    let r = 1, i = String(t[0](e));
    for (; r < n; ++r)
      i += "|" + t[r](e);
    return i;
  };
}
function Xre(t) {
  return !t || !t.length ? function() {
    return "";
  } : t.length === 1 ? t[0] : Xir(t);
}
function _et(t, e, n) {
  return n || t + (e ? "_" + e : "");
}
const gW = () => {
}, Zir = {
  init: gW,
  add: gW,
  rem: gW,
  idx: 0
}, CN = {
  values: {
    init: (t) => t.cell.store = !0,
    value: (t) => t.cell.data.values(),
    idx: -1
  },
  count: {
    value: (t) => t.cell.num
  },
  __count__: {
    value: (t) => t.missing + t.valid
  },
  missing: {
    value: (t) => t.missing
  },
  valid: {
    value: (t) => t.valid
  },
  sum: {
    init: (t) => t.sum = 0,
    value: (t) => t.sum,
    add: (t, e) => t.sum += +e,
    rem: (t, e) => t.sum -= e
  },
  product: {
    init: (t) => t.product = 1,
    value: (t) => t.valid ? t.product : void 0,
    add: (t, e) => t.product *= e,
    rem: (t, e) => t.product /= e
  },
  mean: {
    init: (t) => t.mean = 0,
    value: (t) => t.valid ? t.mean : void 0,
    add: (t, e) => (t.mean_d = e - t.mean, t.mean += t.mean_d / t.valid),
    rem: (t, e) => (t.mean_d = e - t.mean, t.mean -= t.valid ? t.mean_d / t.valid : t.mean)
  },
  average: {
    value: (t) => t.valid ? t.mean : void 0,
    req: ["mean"],
    idx: 1
  },
  variance: {
    init: (t) => t.dev = 0,
    value: (t) => t.valid > 1 ? t.dev / (t.valid - 1) : void 0,
    add: (t, e) => t.dev += t.mean_d * (e - t.mean),
    rem: (t, e) => t.dev -= t.mean_d * (e - t.mean),
    req: ["mean"],
    idx: 1
  },
  variancep: {
    value: (t) => t.valid > 1 ? t.dev / t.valid : void 0,
    req: ["variance"],
    idx: 2
  },
  stdev: {
    value: (t) => t.valid > 1 ? Math.sqrt(t.dev / (t.valid - 1)) : void 0,
    req: ["variance"],
    idx: 2
  },
  stdevp: {
    value: (t) => t.valid > 1 ? Math.sqrt(t.dev / t.valid) : void 0,
    req: ["variance"],
    idx: 2
  },
  stderr: {
    value: (t) => t.valid > 1 ? Math.sqrt(t.dev / (t.valid * (t.valid - 1))) : void 0,
    req: ["variance"],
    idx: 2
  },
  distinct: {
    value: (t) => t.cell.data.distinct(t.get),
    req: ["values"],
    idx: 3
  },
  ci0: {
    value: (t) => t.cell.data.ci0(t.get),
    req: ["values"],
    idx: 3
  },
  ci1: {
    value: (t) => t.cell.data.ci1(t.get),
    req: ["values"],
    idx: 3
  },
  median: {
    value: (t) => t.cell.data.q2(t.get),
    req: ["values"],
    idx: 3
  },
  q1: {
    value: (t) => t.cell.data.q1(t.get),
    req: ["values"],
    idx: 3
  },
  q3: {
    value: (t) => t.cell.data.q3(t.get),
    req: ["values"],
    idx: 3
  },
  min: {
    init: (t) => t.min = void 0,
    value: (t) => t.min = Number.isNaN(t.min) ? t.cell.data.min(t.get) : t.min,
    add: (t, e) => {
      (e < t.min || t.min === void 0) && (t.min = e);
    },
    rem: (t, e) => {
      e <= t.min && (t.min = NaN);
    },
    req: ["values"],
    idx: 4
  },
  max: {
    init: (t) => t.max = void 0,
    value: (t) => t.max = Number.isNaN(t.max) ? t.cell.data.max(t.get) : t.max,
    add: (t, e) => {
      (e > t.max || t.max === void 0) && (t.max = e);
    },
    rem: (t, e) => {
      e >= t.max && (t.max = NaN);
    },
    req: ["values"],
    idx: 4
  },
  argmin: {
    init: (t) => t.argmin = void 0,
    value: (t) => t.argmin || t.cell.data.argmin(t.get),
    add: (t, e, n) => {
      e < t.min && (t.argmin = n);
    },
    rem: (t, e) => {
      e <= t.min && (t.argmin = void 0);
    },
    req: ["min", "values"],
    idx: 3
  },
  argmax: {
    init: (t) => t.argmax = void 0,
    value: (t) => t.argmax || t.cell.data.argmax(t.get),
    add: (t, e, n) => {
      e > t.max && (t.argmax = n);
    },
    rem: (t, e) => {
      e >= t.max && (t.argmax = void 0);
    },
    req: ["max", "values"],
    idx: 3
  }
}, sO = Object.keys(CN);
function eor(t, e) {
  return (n) => ni({
    name: t,
    out: n || t
  }, Zir, e);
}
sO.forEach((t) => {
  CN[t] = eor(t, CN[t]);
});
function Qet(t, e) {
  return CN[t](e);
}
function wet(t, e) {
  return t.idx - e.idx;
}
function tor(t) {
  const e = {};
  t.forEach((r) => e[r.name] = r);
  const n = (r) => {
    r.req && r.req.forEach((i) => {
      e[i] || n(e[i] = CN[i]());
    });
  };
  return t.forEach(n), Object.values(e).sort(wet);
}
function nor() {
  this.valid = 0, this.missing = 0, this._ops.forEach((t) => t.init(this));
}
function ror(t, e) {
  if (t == null || t === "") {
    ++this.missing;
    return;
  }
  t === t && (++this.valid, this._ops.forEach((n) => n.add(this, t, e)));
}
function ior(t, e) {
  if (t == null || t === "") {
    --this.missing;
    return;
  }
  t === t && (--this.valid, this._ops.forEach((n) => n.rem(this, t, e)));
}
function oor(t) {
  return this._out.forEach((e) => t[e.out] = e.value(this)), t;
}
function xet(t, e) {
  const n = e || Ac, r = tor(t), i = t.slice().sort(wet);
  function o(s) {
    this._ops = r, this._out = i, this.cell = s, this.init();
  }
  return o.prototype.init = nor, o.prototype.add = ror, o.prototype.rem = ior, o.prototype.set = oor, o.prototype.get = n, o.fields = t.map((s) => s.out), o;
}
function rhe(t) {
  this._key = t ? ku(t) : tr, this.reset();
}
const Il = rhe.prototype;
Il.reset = function() {
  this._add = [], this._rem = [], this._ext = null, this._get = null, this._q = null;
};
Il.add = function(t) {
  this._add.push(t);
};
Il.rem = function(t) {
  this._rem.push(t);
};
Il.values = function() {
  if (this._get = null, this._rem.length === 0)
    return this._add;
  const t = this._add, e = this._rem, n = this._key, r = t.length, i = e.length, o = Array(r - i), s = {};
  let a, A, l;
  for (a = 0; a < i; ++a)
    s[n(e[a])] = 1;
  for (a = 0, A = 0; a < r; ++a)
    s[n(l = t[a])] ? s[n(l)] = 0 : o[A++] = l;
  return this._rem = [], this._add = o;
};
Il.distinct = function(t) {
  const e = this.values(), n = {};
  let r = e.length, i = 0, o;
  for (; --r >= 0; )
    o = t(e[r]) + "", Kn(n, o) || (n[o] = 1, ++i);
  return i;
};
Il.extent = function(t) {
  if (this._get !== t || !this._ext) {
    const e = this.values(), n = OXe(e, t);
    this._ext = [e[n[0]], e[n[1]]], this._get = t;
  }
  return this._ext;
};
Il.argmin = function(t) {
  return this.extent(t)[0] || {};
};
Il.argmax = function(t) {
  return this.extent(t)[1] || {};
};
Il.min = function(t) {
  const e = this.extent(t)[0];
  return e != null ? t(e) : void 0;
};
Il.max = function(t) {
  const e = this.extent(t)[1];
  return e != null ? t(e) : void 0;
};
Il.quartile = function(t) {
  return (this._get !== t || !this._q) && (this._q = Hge(this.values(), t), this._get = t), this._q;
};
Il.q1 = function(t) {
  return this.quartile(t)[0];
};
Il.q2 = function(t) {
  return this.quartile(t)[1];
};
Il.q3 = function(t) {
  return this.quartile(t)[2];
};
Il.ci = function(t) {
  return (this._get !== t || !this._ci) && (this._ci = het(this.values(), 1e3, 0.05, t), this._get = t), this._ci;
};
Il.ci0 = function(t) {
  return this.ci(t)[0];
};
Il.ci1 = function(t) {
  return this.ci(t)[1];
};
function rE(t) {
  yt.call(this, null, t), this._adds = [], this._mods = [], this._alen = 0, this._mlen = 0, this._drop = !0, this._cross = !1, this._dims = [], this._dnames = [], this._measures = [], this._countOnly = !1, this._counts = null, this._prev = null, this._inputs = null, this._outputs = null;
}
rE.Definition = {
  type: "Aggregate",
  metadata: {
    generates: !0,
    changes: !0
  },
  params: [{
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "ops",
    type: "enum",
    array: !0,
    values: sO
  }, {
    name: "fields",
    type: "field",
    null: !0,
    array: !0
  }, {
    name: "as",
    type: "string",
    null: !0,
    array: !0
  }, {
    name: "drop",
    type: "boolean",
    default: !0
  }, {
    name: "cross",
    type: "boolean",
    default: !1
  }, {
    name: "key",
    type: "field"
  }]
};
on(rE, yt, {
  transform(t, e) {
    const n = this, r = e.fork(e.NO_SOURCE | e.NO_FIELDS), i = t.modified();
    return n.stamp = r.stamp, n.value && (i || e.modified(n._inputs, !0)) ? (n._prev = n.value, n.value = i ? n.init(t) : {}, e.visit(e.SOURCE, (o) => n.add(o))) : (n.value = n.value || n.init(t), e.visit(e.REM, (o) => n.rem(o)), e.visit(e.ADD, (o) => n.add(o))), r.modifies(n._outputs), n._drop = t.drop !== !1, t.cross && n._dims.length > 1 && (n._drop = !1, n.cross()), e.clean() && n._drop && r.clean(!0).runAfter(() => this.clean()), n.changes(r);
  },
  cross() {
    const t = this, e = t.value, n = t._dnames, r = n.map(() => ({})), i = n.length;
    function o(a) {
      let A, l, c, u;
      for (A in a)
        for (c = a[A].tuple, l = 0; l < i; ++l)
          r[l][u = c[n[l]]] = u;
    }
    o(t._prev), o(e);
    function s(a, A, l) {
      const c = n[l], u = r[l++];
      for (const f in u) {
        const h = a ? a + "|" + f : f;
        A[c] = u[f], l < i ? s(h, A, l) : e[h] || t.cell(h, A);
      }
    }
    s("", {}, 0);
  },
  init(t) {
    const e = this._inputs = [], n = this._outputs = [], r = {};
    function i(m) {
      const C = bn(Zl(m)), y = C.length;
      let v = 0, b;
      for (; v < y; ++v)
        r[b = C[v]] || (r[b] = 1, e.push(b));
    }
    this._dims = bn(t.groupby), this._dnames = this._dims.map((m) => {
      const C = pa(m);
      return i(m), n.push(C), C;
    }), this.cellkey = t.key ? t.key : Xre(this._dims), this._countOnly = !0, this._counts = [], this._measures = [];
    const o = t.fields || [null], s = t.ops || ["count"], a = t.as || [], A = o.length, l = {};
    let c, u, f, h, d, I;
    for (A !== s.length && wt("Unmatched number of fields and aggregate ops."), I = 0; I < A; ++I) {
      if (c = o[I], u = s[I], c == null && u !== "count" && wt("Null aggregate field specified."), h = pa(c), d = _et(u, h, a[I]), n.push(d), u === "count") {
        this._counts.push(d);
        continue;
      }
      f = l[h], f || (i(c), f = l[h] = [], f.field = c, this._measures.push(f)), u !== "count" && (this._countOnly = !1), f.push(Qet(u, d));
    }
    return this._measures = this._measures.map((m) => xet(m, m.field)), {};
  },
  // -- Cell Management -----
  cellkey: Xre(),
  cell(t, e) {
    let n = this.value[t];
    return n ? n.num === 0 && this._drop && n.stamp < this.stamp ? (n.stamp = this.stamp, this._adds[this._alen++] = n) : n.stamp < this.stamp && (n.stamp = this.stamp, this._mods[this._mlen++] = n) : (n = this.value[t] = this.newcell(t, e), this._adds[this._alen++] = n), n;
  },
  newcell(t, e) {
    const n = {
      key: t,
      num: 0,
      agg: null,
      tuple: this.newtuple(e, this._prev && this._prev[t]),
      stamp: this.stamp,
      store: !1
    };
    if (!this._countOnly) {
      const r = this._measures, i = r.length;
      n.agg = Array(i);
      for (let o = 0; o < i; ++o)
        n.agg[o] = new r[o](n);
    }
    return n.store && (n.data = new rhe()), n;
  },
  newtuple(t, e) {
    const n = this._dnames, r = this._dims, i = r.length, o = {};
    for (let s = 0; s < i; ++s)
      o[n[s]] = r[s](t);
    return e ? oet(e.tuple, o) : so(o);
  },
  clean() {
    const t = this.value;
    for (const e in t)
      t[e].num === 0 && delete t[e];
  },
  // -- Process Tuples -----
  add(t) {
    const e = this.cellkey(t), n = this.cell(e, t);
    if (n.num += 1, this._countOnly)
      return;
    n.store && n.data.add(t);
    const r = n.agg;
    for (let i = 0, o = r.length; i < o; ++i)
      r[i].add(r[i].get(t), t);
  },
  rem(t) {
    const e = this.cellkey(t), n = this.cell(e, t);
    if (n.num -= 1, this._countOnly)
      return;
    n.store && n.data.rem(t);
    const r = n.agg;
    for (let i = 0, o = r.length; i < o; ++i)
      r[i].rem(r[i].get(t), t);
  },
  celltuple(t) {
    const e = t.tuple, n = this._counts;
    t.store && t.data.values();
    for (let r = 0, i = n.length; r < i; ++r)
      e[n[r]] = t.num;
    if (!this._countOnly) {
      const r = t.agg;
      for (let i = 0, o = r.length; i < o; ++i)
        r[i].set(e);
    }
    return e;
  },
  changes(t) {
    const e = this._adds, n = this._mods, r = this._prev, i = this._drop, o = t.add, s = t.rem, a = t.mod;
    let A, l, c, u;
    if (r)
      for (l in r)
        A = r[l], (!i || A.num) && s.push(A.tuple);
    for (c = 0, u = this._alen; c < u; ++c)
      o.push(this.celltuple(e[c])), e[c] = null;
    for (c = 0, u = this._mlen; c < u; ++c)
      A = n[c], (A.num === 0 && i ? s : a).push(this.celltuple(A)), n[c] = null;
    return this._alen = this._mlen = 0, this._prev = null, t;
  }
});
const sor = 1e-14;
function ihe(t) {
  yt.call(this, null, t);
}
ihe.Definition = {
  type: "Bin",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "interval",
    type: "boolean",
    default: !0
  }, {
    name: "anchor",
    type: "number"
  }, {
    name: "maxbins",
    type: "number",
    default: 20
  }, {
    name: "base",
    type: "number",
    default: 10
  }, {
    name: "divide",
    type: "number",
    array: !0,
    default: [5, 2]
  }, {
    name: "extent",
    type: "number",
    array: !0,
    length: 2,
    required: !0
  }, {
    name: "span",
    type: "number"
  }, {
    name: "step",
    type: "number"
  }, {
    name: "steps",
    type: "number",
    array: !0
  }, {
    name: "minstep",
    type: "number",
    default: 0
  }, {
    name: "nice",
    type: "boolean",
    default: !0
  }, {
    name: "name",
    type: "string"
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: ["bin0", "bin1"]
  }]
};
on(ihe, yt, {
  transform(t, e) {
    const n = t.interval !== !1, r = this._bins(t), i = r.start, o = r.step, s = t.as || ["bin0", "bin1"], a = s[0], A = s[1];
    let l;
    return t.modified() ? (e = e.reflow(!0), l = e.SOURCE) : l = e.modified(Zl(t.field)) ? e.ADD_MOD : e.ADD, e.visit(l, n ? (c) => {
      const u = r(c);
      c[a] = u, c[A] = u == null ? null : i + o * (1 + (u - i) / o);
    } : (c) => c[a] = r(c)), e.modifies(n ? s : a);
  },
  _bins(t) {
    if (this.value && !t.modified())
      return this.value;
    const e = t.field, n = get(t), r = n.step;
    let i = n.start, o = i + Math.ceil((n.stop - i) / r) * r, s, a;
    (s = t.anchor) != null && (a = s - (i + r * Math.floor((s - i) / r)), i += a, o += a);
    const A = function(l) {
      let c = Kl(e(l));
      return c == null ? null : c < i ? -1 / 0 : c > o ? 1 / 0 : (c = Math.max(i, Math.min(c, o - r)), i + r * Math.floor(sor + (c - i) / r));
    };
    return A.start = i, A.stop = n.stop, A.step = r, this.value = Yu(A, Zl(e), t.name || "bin_" + pa(e));
  }
});
function Ret(t, e, n) {
  const r = t;
  let i = e || [], o = n || [], s = {}, a = 0;
  return {
    add: (A) => o.push(A),
    remove: (A) => s[r(A)] = ++a,
    size: () => i.length,
    data: (A, l) => (a && (i = i.filter((c) => !s[r(c)]), s = {}, a = 0), l && A && i.sort(A), o.length && (i = A ? HXe(A, i, o.sort(A)) : i.concat(o), o = []), i)
  };
}
function ohe(t) {
  yt.call(this, [], t);
}
ohe.Definition = {
  type: "Collect",
  metadata: {
    source: !0
  },
  params: [{
    name: "sort",
    type: "compare"
  }]
};
on(ohe, yt, {
  transform(t, e) {
    const n = e.fork(e.ALL), r = Ret(tr, this.value, n.materialize(n.ADD).add), i = t.sort, o = e.changed() || i && (t.modified("sort") || e.modified(i.fields));
    return n.visit(n.REM, r.remove), this.modified(o), this.value = n.source = r.data(B1(i), o), e.source && e.source.root && (this.value.root = e.source.root), n;
  }
});
function Det(t) {
  jo.call(this, null, aor, t);
}
on(Det, jo);
function aor(t) {
  return this.value && !t.modified() ? this.value : uge(t.fields, t.orders);
}
function she(t) {
  yt.call(this, null, t);
}
she.Definition = {
  type: "CountPattern",
  metadata: {
    generates: !0,
    changes: !0
  },
  params: [{
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "case",
    type: "enum",
    values: ["upper", "lower", "mixed"],
    default: "mixed"
  }, {
    name: "pattern",
    type: "string",
    default: '[\\w"]+'
  }, {
    name: "stopwords",
    type: "string",
    default: ""
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: ["text", "count"]
  }]
};
function Aor(t, e, n) {
  switch (e) {
    case "upper":
      t = t.toUpperCase();
      break;
    case "lower":
      t = t.toLowerCase();
      break;
  }
  return t.match(n);
}
on(she, yt, {
  transform(t, e) {
    const n = (u) => (f) => {
      for (var h = Aor(a(f), t.case, o) || [], d, I = 0, m = h.length; I < m; ++I)
        s.test(d = h[I]) || u(d);
    }, r = this._parameterCheck(t, e), i = this._counts, o = this._match, s = this._stop, a = t.field, A = t.as || ["text", "count"], l = n((u) => i[u] = 1 + (i[u] || 0)), c = n((u) => i[u] -= 1);
    return r ? e.visit(e.SOURCE, l) : (e.visit(e.ADD, l), e.visit(e.REM, c)), this._finish(e, A);
  },
  _parameterCheck(t, e) {
    let n = !1;
    return (t.modified("stopwords") || !this._stop) && (this._stop = new RegExp("^" + (t.stopwords || "") + "$", "i"), n = !0), (t.modified("pattern") || !this._match) && (this._match = new RegExp(t.pattern || "[\\w']+", "g"), n = !0), (t.modified("field") || e.modified(t.field.fields)) && (n = !0), n && (this._counts = {}), n;
  },
  _finish(t, e) {
    const n = this._counts, r = this._tuples || (this._tuples = {}), i = e[0], o = e[1], s = t.fork(t.NO_SOURCE | t.NO_FIELDS);
    let a, A, l;
    for (a in n)
      A = r[a], l = n[a] || 0, !A && l ? (r[a] = A = so({}), A[i] = a, A[o] = l, s.add.push(A)) : l === 0 ? (A && s.rem.push(A), n[a] = null, r[a] = null) : A[o] !== l && (A[o] = l, s.mod.push(A));
    return s.modifies(e);
  }
});
function ahe(t) {
  yt.call(this, null, t);
}
ahe.Definition = {
  type: "Cross",
  metadata: {
    generates: !0
  },
  params: [{
    name: "filter",
    type: "expr"
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: ["a", "b"]
  }]
};
on(ahe, yt, {
  transform(t, e) {
    const n = e.fork(e.NO_SOURCE), r = t.as || ["a", "b"], i = r[0], o = r[1], s = !this.value || e.changed(e.ADD_REM) || t.modified("as") || t.modified("filter");
    let a = this.value;
    return s ? (a && (n.rem = a), a = e.materialize(e.SOURCE).source, n.add = this.value = lor(a, i, o, t.filter || qg)) : n.mod = a, n.source = this.value, n.modifies(r);
  }
});
function lor(t, e, n, r) {
  for (var i = [], o = {}, s = t.length, a = 0, A, l; a < s; ++a)
    for (o[e] = l = t[a], A = 0; A < s; ++A)
      o[n] = t[A], r(o) && (i.push(so(o)), o = {}, o[e] = l);
  return i;
}
const bLe = {
  kde: Yge,
  mixture: met,
  normal: jge,
  lognormal: Iet,
  uniform: Cet
}, cor = "distributions", _Le = "function", uor = "field";
function Tet(t, e) {
  const n = t[_Le];
  Kn(bLe, n) || wt("Unknown distribution function: " + n);
  const r = bLe[n]();
  for (const i in t)
    i === uor ? r.data((t.from || e()).map(t[i])) : i === cor ? r[i](t[i].map((o) => Tet(o, e))) : typeof r[i] === _Le && r[i](t[i]);
  return r;
}
function Ahe(t) {
  yt.call(this, null, t);
}
const Net = [{
  key: {
    function: "normal"
  },
  params: [{
    name: "mean",
    type: "number",
    default: 0
  }, {
    name: "stdev",
    type: "number",
    default: 1
  }]
}, {
  key: {
    function: "lognormal"
  },
  params: [{
    name: "mean",
    type: "number",
    default: 0
  }, {
    name: "stdev",
    type: "number",
    default: 1
  }]
}, {
  key: {
    function: "uniform"
  },
  params: [{
    name: "min",
    type: "number",
    default: 0
  }, {
    name: "max",
    type: "number",
    default: 1
  }]
}, {
  key: {
    function: "kde"
  },
  params: [{
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "from",
    type: "data"
  }, {
    name: "bandwidth",
    type: "number",
    default: 0
  }]
}], gor = {
  key: {
    function: "mixture"
  },
  params: [{
    name: "distributions",
    type: "param",
    array: !0,
    params: Net
  }, {
    name: "weights",
    type: "number",
    array: !0
  }]
};
Ahe.Definition = {
  type: "Density",
  metadata: {
    generates: !0
  },
  params: [{
    name: "extent",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "steps",
    type: "number"
  }, {
    name: "minsteps",
    type: "number",
    default: 25
  }, {
    name: "maxsteps",
    type: "number",
    default: 200
  }, {
    name: "method",
    type: "string",
    default: "pdf",
    values: ["pdf", "cdf"]
  }, {
    name: "distribution",
    type: "param",
    params: Net.concat(gor)
  }, {
    name: "as",
    type: "string",
    array: !0,
    default: ["value", "density"]
  }]
};
on(Ahe, yt, {
  transform(t, e) {
    const n = e.fork(e.NO_SOURCE | e.NO_FIELDS);
    if (!this.value || e.changed() || t.modified()) {
      const r = Tet(t.distribution, hor(e)), i = t.steps || t.minsteps || 25, o = t.steps || t.maxsteps || 200;
      let s = t.method || "pdf";
      s !== "pdf" && s !== "cdf" && wt("Invalid density method: " + s), !t.extent && !r.data && wt("Missing density extent parameter."), s = r[s];
      const a = t.as || ["value", "density"], A = t.extent || Jp(r.data()), l = vj(s, A, i, o).map((c) => {
        const u = {};
        return u[a[0]] = c[0], u[a[1]] = c[1], so(u);
      });
      this.value && (n.rem = this.value), this.value = n.add = n.source = l;
    }
    return n;
  }
});
function hor(t) {
  return () => t.materialize(t.SOURCE).source;
}
function Let(t, e) {
  return t ? t.map((n, r) => e[r] || pa(n)) : null;
}
function lhe(t, e, n) {
  const r = [], i = (u) => u(A);
  let o, s, a, A, l, c;
  if (e == null)
    r.push(t.map(n));
  else
    for (o = {}, s = 0, a = t.length; s < a; ++s)
      A = t[s], l = e.map(i), c = o[l], c || (o[l] = c = [], c.dims = l, r.push(c)), c.push(n(A));
  return r;
}
const Met = "bin";
function che(t) {
  yt.call(this, null, t);
}
che.Definition = {
  type: "DotBin",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "step",
    type: "number"
  }, {
    name: "smooth",
    type: "boolean",
    default: !1
  }, {
    name: "as",
    type: "string",
    default: Met
  }]
};
const dor = (t, e) => rO(Jp(t, e)) / 30;
on(che, yt, {
  transform(t, e) {
    if (this.value && !(t.modified() || e.changed()))
      return e;
    const n = e.materialize(e.SOURCE).source, r = lhe(e.source, t.groupby, Ac), i = t.smooth || !1, o = t.field, s = t.step || dor(n, o), a = B1((d, I) => o(d) - o(I)), A = t.as || Met, l = r.length;
    let c = 1 / 0, u = -1 / 0, f = 0, h;
    for (; f < l; ++f) {
      const d = r[f].sort(a);
      h = -1;
      for (const I of det(d, s, i, o))
        I < c && (c = I), I > u && (u = I), d[++h][A] = I;
    }
    return this.value = {
      start: c,
      stop: u,
      step: s
    }, e.reflow(!0).modifies(A);
  }
});
function Oet(t) {
  jo.call(this, null, por, t), this.modified(!0);
}
on(Oet, jo);
function por(t) {
  const e = t.expr;
  return this.value && !t.modified("expr") ? this.value : Yu((n) => e(n, t), Zl(e), pa(e));
}
function uhe(t) {
  yt.call(this, [void 0, void 0], t);
}
uhe.Definition = {
  type: "Extent",
  metadata: {},
  params: [{
    name: "field",
    type: "field",
    required: !0
  }]
};
on(uhe, yt, {
  transform(t, e) {
    const n = this.value, r = t.field, i = e.changed() || e.modified(r.fields) || t.modified("field");
    let o = n[0], s = n[1];
    if ((i || o == null) && (o = 1 / 0, s = -1 / 0), e.visit(i ? e.SOURCE : e.ADD, (a) => {
      const A = Kl(r(a));
      A != null && (A < o && (o = A), A > s && (s = A));
    }), !Number.isFinite(o) || !Number.isFinite(s)) {
      let a = pa(r);
      a && (a = ' for field "'.concat(a, '"')), e.dataflow.warn("Infinite extent".concat(a, ": [").concat(o, ", ").concat(s, "]")), o = s = void 0;
    }
    this.value = [o, s];
  }
});
function fhe(t, e) {
  jo.call(this, t), this.parent = e, this.count = 0;
}
on(fhe, jo, {
  /**
   * Routes pulses from this subflow to a target transform.
   * @param {Transform} target - A transform that receives the subflow of tuples.
   */
  connect(t) {
    return this.detachSubflow = t.detachSubflow, this.targets().add(t), t.source = this;
  },
  /**
   * Add an 'add' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being added.
   */
  add(t) {
    this.count += 1, this.value.add.push(t);
  },
  /**
   * Add a 'rem' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being removed.
   */
  rem(t) {
    this.count -= 1, this.value.rem.push(t);
  },
  /**
   * Add a 'mod' tuple to the subflow pulse.
   * @param {Tuple} t - The tuple being modified.
   */
  mod(t) {
    this.value.mod.push(t);
  },
  /**
   * Re-initialize this operator's pulse value.
   * @param {Pulse} pulse - The pulse to copy from.
   * @see Pulse.init
   */
  init(t) {
    this.value.init(t, t.NO_SOURCE);
  },
  /**
   * Evaluate this operator. This method overrides the
   * default behavior to simply return the contained pulse value.
   * @return {Pulse}
   */
  evaluate() {
    return this.value;
  }
});
function Bj(t) {
  yt.call(this, {}, t), this._keys = hx();
  const e = this._targets = [];
  e.active = 0, e.forEach = (n) => {
    for (let r = 0, i = e.active; r < i; ++r)
      n(e[r], r, e);
  };
}
on(Bj, yt, {
  activate(t) {
    this._targets[this._targets.active++] = t;
  },
  // parent argument provided by PreFacet subclass
  subflow(t, e, n, r) {
    const i = this.value;
    let o = Kn(i, t) && i[t], s, a;
    return o ? o.value.stamp < n.stamp && (o.init(n), this.activate(o)) : (a = r || (a = this._group[t]) && a.tuple, s = n.dataflow, o = new fhe(n.fork(n.NO_SOURCE), this), s.add(o).connect(e(s, t, a)), i[t] = o, this.activate(o)), o;
  },
  clean() {
    const t = this.value;
    let e = 0;
    for (const n in t)
      if (t[n].count === 0) {
        const r = t[n].detachSubflow;
        r && r(), delete t[n], ++e;
      }
    if (e) {
      const n = this._targets.filter((r) => r && r.count > 0);
      this.initTargets(n);
    }
  },
  initTargets(t) {
    const e = this._targets, n = e.length, r = t ? t.length : 0;
    let i = 0;
    for (; i < r; ++i)
      e[i] = t[i];
    for (; i < n && e[i] != null; ++i)
      e[i] = null;
    e.active = r;
  },
  transform(t, e) {
    const n = e.dataflow, r = t.key, i = t.subflow, o = this._keys, s = t.modified("key"), a = (A) => this.subflow(A, i, e);
    return this._group = t.group || {}, this.initTargets(), e.visit(e.REM, (A) => {
      const l = tr(A), c = o.get(l);
      c !== void 0 && (o.delete(l), a(c).rem(A));
    }), e.visit(e.ADD, (A) => {
      const l = r(A);
      o.set(tr(A), l), a(l).add(A);
    }), s || e.modified(r.fields) ? e.visit(e.MOD, (A) => {
      const l = tr(A), c = o.get(l), u = r(A);
      c === u ? a(u).mod(A) : (o.set(l, u), a(c).rem(A), a(u).add(A));
    }) : e.changed(e.MOD) && e.visit(e.MOD, (A) => {
      a(o.get(tr(A))).mod(A);
    }), s && e.visit(e.REFLOW, (A) => {
      const l = tr(A), c = o.get(l), u = r(A);
      c !== u && (o.set(l, u), a(c).rem(A), a(u).add(A));
    }), e.clean() ? n.runAfter(() => {
      this.clean(), o.clean();
    }) : o.empty > n.cleanThreshold && n.runAfter(o.clean), e;
  }
});
function Fet(t) {
  jo.call(this, null, Ior, t);
}
on(Fet, jo);
function Ior(t) {
  return this.value && !t.modified() ? this.value : Nt(t.name) ? bn(t.name).map((e) => ku(e)) : ku(t.name, t.as);
}
function ghe(t) {
  yt.call(this, hx(), t);
}
ghe.Definition = {
  type: "Filter",
  metadata: {
    changes: !0
  },
  params: [{
    name: "expr",
    type: "expr",
    required: !0
  }]
};
on(ghe, yt, {
  transform(t, e) {
    const n = e.dataflow, r = this.value, i = e.fork(), o = i.add, s = i.rem, a = i.mod, A = t.expr;
    let l = !0;
    e.visit(e.REM, (u) => {
      const f = tr(u);
      r.has(f) ? r.delete(f) : s.push(u);
    }), e.visit(e.ADD, (u) => {
      A(u, t) ? o.push(u) : r.set(tr(u), 1);
    });
    function c(u) {
      const f = tr(u), h = A(u, t), d = r.get(f);
      h && d ? (r.delete(f), o.push(u)) : !h && !d ? (r.set(f, 1), s.push(u)) : l && h && !d && a.push(u);
    }
    return e.visit(e.MOD, c), t.modified() && (l = !1, e.visit(e.REFLOW, c)), r.empty > n.cleanThreshold && n.runAfter(r.clean), i;
  }
});
function hhe(t) {
  yt.call(this, [], t);
}
hhe.Definition = {
  type: "Flatten",
  metadata: {
    generates: !0
  },
  params: [{
    name: "fields",
    type: "field",
    array: !0,
    required: !0
  }, {
    name: "index",
    type: "string"
  }, {
    name: "as",
    type: "string",
    array: !0
  }]
};
on(hhe, yt, {
  transform(t, e) {
    const n = e.fork(e.NO_SOURCE), r = t.fields, i = Let(r, t.as || []), o = t.index || null, s = i.length;
    return n.rem = this.value, e.visit(e.SOURCE, (a) => {
      const A = r.map((d) => d(a)), l = A.reduce((d, I) => Math.max(d, I.length), 0);
      let c = 0, u, f, h;
      for (; c < l; ++c) {
        for (f = Pge(a), u = 0; u < s; ++u)
          f[i[u]] = (h = A[u][c]) == null ? null : h;
        o && (f[o] = c), n.add.push(f);
      }
    }), this.value = n.source = n.add, o && n.modifies(o), n.modifies(i);
  }
});
function dhe(t) {
  yt.call(this, [], t);
}
dhe.Definition = {
  type: "Fold",
  metadata: {
    generates: !0
  },
  params: [{
    name: "fields",
    type: "field",
    array: !0,
    required: !0
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: ["key", "value"]
  }]
};
on(dhe, yt, {
  transform(t, e) {
    const n = e.fork(e.NO_SOURCE), r = t.fields, i = r.map(pa), o = t.as || ["key", "value"], s = o[0], a = o[1], A = r.length;
    return n.rem = this.value, e.visit(e.SOURCE, (l) => {
      for (let c = 0, u; c < A; ++c)
        u = Pge(l), u[s] = i[c], u[a] = r[c](l), n.add.push(u);
    }), this.value = n.source = n.add, n.modifies(o);
  }
});
function phe(t) {
  yt.call(this, null, t);
}
phe.Definition = {
  type: "Formula",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "expr",
    type: "expr",
    required: !0
  }, {
    name: "as",
    type: "string",
    required: !0
  }, {
    name: "initonly",
    type: "boolean"
  }]
};
on(phe, yt, {
  transform(t, e) {
    const n = t.expr, r = t.as, i = t.modified(), o = t.initonly ? e.ADD : i ? e.SOURCE : e.modified(n.fields) || e.modified(r) ? e.ADD_MOD : e.ADD;
    return i && (e = e.materialize().reflow(!0)), t.initonly || e.modifies(r), e.visit(o, (s) => s[r] = n(s, t));
  }
});
function Pet(t) {
  yt.call(this, [], t);
}
on(Pet, yt, {
  transform(t, e) {
    const n = e.fork(e.ALL), r = t.generator;
    let i = this.value, o = t.size - i.length, s, a, A;
    if (o > 0) {
      for (s = []; --o >= 0; )
        s.push(A = so(r(t))), i.push(A);
      n.add = n.add.length ? n.materialize(n.ADD).add.concat(s) : s;
    } else
      a = i.slice(0, -o), n.rem = n.rem.length ? n.materialize(n.REM).rem.concat(a) : a, i = i.slice(-o);
    return n.source = this.value = i, n;
  }
});
const p3 = {
  value: "value",
  median: tZe,
  mean: nnr,
  min: Ure,
  max: Tv
}, mor = [];
function Ihe(t) {
  yt.call(this, [], t);
}
Ihe.Definition = {
  type: "Impute",
  metadata: {
    changes: !0
  },
  params: [{
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "key",
    type: "field",
    required: !0
  }, {
    name: "keyvals",
    array: !0
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "method",
    type: "enum",
    default: "value",
    values: ["value", "mean", "median", "max", "min"]
  }, {
    name: "value",
    default: 0
  }]
};
function Cor(t) {
  var e = t.method || p3.value, n;
  if (p3[e] == null)
    wt("Unrecognized imputation method: " + e);
  else
    return e === p3.value ? (n = t.value !== void 0 ? t.value : 0, () => n) : p3[e];
}
function Eor(t) {
  const e = t.field;
  return (n) => n ? e(n) : NaN;
}
on(Ihe, yt, {
  transform(t, e) {
    var n = e.fork(e.ALL), r = Cor(t), i = Eor(t), o = pa(t.field), s = pa(t.key), a = (t.groupby || []).map(pa), A = yor(e.source, t.groupby, t.key, t.keyvals), l = [], c = this.value, u = A.domain.length, f, h, d, I, m, C, y, v, b, Q;
    for (m = 0, v = A.length; m < v; ++m)
      for (f = A[m], d = f.values, h = NaN, y = 0; y < u; ++y)
        if (f[y] == null) {
          for (I = A.domain[y], Q = {
            _impute: !0
          }, C = 0, b = d.length; C < b; ++C)
            Q[a[C]] = d[C];
          Q[s] = I, Q[o] = Number.isNaN(h) ? h = r(f, i) : h, l.push(so(Q));
        }
    return l.length && (n.add = n.materialize(n.ADD).add.concat(l)), c.length && (n.rem = n.materialize(n.REM).rem.concat(c)), this.value = l, n;
  }
});
function yor(t, e, n, r) {
  var i = (C) => C(m), o = [], s = r ? r.slice() : [], a = {}, A = {}, l, c, u, f, h, d, I, m;
  for (s.forEach((C, y) => a[C] = y + 1), f = 0, I = t.length; f < I; ++f)
    m = t[f], d = n(m), h = a[d] || (a[d] = s.push(d)), c = (l = e ? e.map(i) : mor) + "", (u = A[c]) || (u = A[c] = [], o.push(u), u.values = l), u[h - 1] = m;
  return o.domain = s, o;
}
function mhe(t) {
  rE.call(this, t);
}
mhe.Definition = {
  type: "JoinAggregate",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "fields",
    type: "field",
    null: !0,
    array: !0
  }, {
    name: "ops",
    type: "enum",
    array: !0,
    values: sO
  }, {
    name: "as",
    type: "string",
    null: !0,
    array: !0
  }, {
    name: "key",
    type: "field"
  }]
};
on(mhe, rE, {
  transform(t, e) {
    const n = this, r = t.modified();
    let i;
    return n.value && (r || e.modified(n._inputs, !0)) ? (i = n.value = r ? n.init(t) : {}, e.visit(e.SOURCE, (o) => n.add(o))) : (i = n.value = n.value || this.init(t), e.visit(e.REM, (o) => n.rem(o)), e.visit(e.ADD, (o) => n.add(o))), n.changes(), e.visit(e.SOURCE, (o) => {
      ni(o, i[n.cellkey(o)].tuple);
    }), e.reflow(r).modifies(this._outputs);
  },
  changes() {
    const t = this._adds, e = this._mods;
    let n, r;
    for (n = 0, r = this._alen; n < r; ++n)
      this.celltuple(t[n]), t[n] = null;
    for (n = 0, r = this._mlen; n < r; ++n)
      this.celltuple(e[n]), e[n] = null;
    this._alen = this._mlen = 0;
  }
});
function Che(t) {
  yt.call(this, null, t);
}
Che.Definition = {
  type: "KDE",
  metadata: {
    generates: !0
  },
  params: [{
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "cumulative",
    type: "boolean",
    default: !1
  }, {
    name: "counts",
    type: "boolean",
    default: !1
  }, {
    name: "bandwidth",
    type: "number",
    default: 0
  }, {
    name: "extent",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "resolve",
    type: "enum",
    values: ["shared", "independent"],
    default: "independent"
  }, {
    name: "steps",
    type: "number"
  }, {
    name: "minsteps",
    type: "number",
    default: 25
  }, {
    name: "maxsteps",
    type: "number",
    default: 200
  }, {
    name: "as",
    type: "string",
    array: !0,
    default: ["value", "density"]
  }]
};
on(Che, yt, {
  transform(t, e) {
    const n = e.fork(e.NO_SOURCE | e.NO_FIELDS);
    if (!this.value || e.changed() || t.modified()) {
      const r = e.materialize(e.SOURCE).source, i = lhe(r, t.groupby, t.field), o = (t.groupby || []).map(pa), s = t.bandwidth, a = t.cumulative ? "cdf" : "pdf", A = t.as || ["value", "density"], l = [];
      let c = t.extent, u = t.steps || t.minsteps || 25, f = t.steps || t.maxsteps || 200;
      a !== "pdf" && a !== "cdf" && wt("Invalid density method: " + a), t.resolve === "shared" && (c || (c = Jp(r, t.field)), u = f = t.steps || f), i.forEach((h) => {
        const d = Yge(h, s)[a], I = t.counts ? h.length : 1, m = c || Jp(h);
        vj(d, m, u, f).forEach((C) => {
          const y = {};
          for (let v = 0; v < o.length; ++v)
            y[o[v]] = h.dims[v];
          y[A[0]] = C[0], y[A[1]] = C[1] * I, l.push(so(y));
        });
      }), this.value && (n.rem = this.value), this.value = n.add = n.source = l;
    }
    return n;
  }
});
function ket(t) {
  jo.call(this, null, vor, t);
}
on(ket, jo);
function vor(t) {
  return this.value && !t.modified() ? this.value : gge(t.fields, t.flat);
}
function Get(t) {
  yt.call(this, [], t), this._pending = null;
}
on(Get, yt, {
  transform(t, e) {
    const n = e.dataflow;
    return this._pending ? hW(this, e, this._pending) : Bor(t) ? e.StopPropagation : t.values ? hW(this, e, n.parse(t.values, t.format)) : t.async ? {
      async: n.request(t.url, t.format).then((i) => (this._pending = bn(i.data), (o) => o.touch(this)))
    } : n.request(t.url, t.format).then((r) => hW(this, e, bn(r.data)));
  }
});
function Bor(t) {
  return t.modified("async") && !(t.modified("values") || t.modified("url") || t.modified("format"));
}
function hW(t, e, n) {
  n.forEach(so);
  const r = e.fork(e.NO_FIELDS & e.NO_SOURCE);
  return r.rem = t.value, t.value = r.source = r.add = n, t._pending = null, r.rem.length && r.clean(!0), r;
}
function Ehe(t) {
  yt.call(this, {}, t);
}
Ehe.Definition = {
  type: "Lookup",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "index",
    type: "index",
    params: [{
      name: "from",
      type: "data",
      required: !0
    }, {
      name: "key",
      type: "field",
      required: !0
    }]
  }, {
    name: "values",
    type: "field",
    array: !0
  }, {
    name: "fields",
    type: "field",
    array: !0,
    required: !0
  }, {
    name: "as",
    type: "string",
    array: !0
  }, {
    name: "default",
    default: null
  }]
};
on(Ehe, yt, {
  transform(t, e) {
    const n = t.fields, r = t.index, i = t.values, o = t.default == null ? null : t.default, s = t.modified(), a = n.length;
    let A = s ? e.SOURCE : e.ADD, l = e, c = t.as, u, f, h;
    return i ? (f = i.length, a > 1 && !c && wt('Multi-field lookup requires explicit "as" parameter.'), c && c.length !== a * f && wt('The "as" parameter has too few output field names.'), c = c || i.map(pa), u = function(d) {
      for (var I = 0, m = 0, C, y; I < a; ++I)
        if (y = r.get(n[I](d)), y == null)
          for (C = 0; C < f; ++C, ++m)
            d[c[m]] = o;
        else
          for (C = 0; C < f; ++C, ++m)
            d[c[m]] = i[C](y);
    }) : (c || wt("Missing output field names."), u = function(d) {
      for (var I = 0, m; I < a; ++I)
        m = r.get(n[I](d)), d[c[I]] = m ?? o;
    }), s ? l = e.reflow(!0) : (h = n.some((d) => e.modified(d.fields)), A |= h ? e.MOD : 0), e.visit(A, u), l.modifies(c);
  }
});
function Uet(t) {
  jo.call(this, null, bor, t);
}
on(Uet, jo);
function bor(t) {
  if (this.value && !t.modified())
    return this.value;
  const e = t.extents, n = e.length;
  let r = 1 / 0, i = -1 / 0, o, s;
  for (o = 0; o < n; ++o)
    s = e[o], s[0] < r && (r = s[0]), s[1] > i && (i = s[1]);
  return [r, i];
}
function Het(t) {
  jo.call(this, null, _or, t);
}
on(Het, jo);
function _or(t) {
  return this.value && !t.modified() ? this.value : t.values.reduce((e, n) => e.concat(n), []);
}
function $et(t) {
  yt.call(this, null, t);
}
on($et, yt, {
  transform(t, e) {
    return this.modified(t.modified()), this.value = t, e.fork(e.NO_SOURCE | e.NO_FIELDS);
  }
});
function yhe(t) {
  rE.call(this, t);
}
yhe.Definition = {
  type: "Pivot",
  metadata: {
    generates: !0,
    changes: !0
  },
  params: [{
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "value",
    type: "field",
    required: !0
  }, {
    name: "op",
    type: "enum",
    values: sO,
    default: "sum"
  }, {
    name: "limit",
    type: "number",
    default: 0
  }, {
    name: "key",
    type: "field"
  }]
};
on(yhe, rE, {
  _transform: rE.prototype.transform,
  transform(t, e) {
    return this._transform(Sor(t, e), e);
  }
});
function Sor(t, e) {
  const n = t.field, r = t.value, i = (t.op === "count" ? "__count__" : t.op) || "sum", o = Zl(n).concat(Zl(r)), s = wor(n, t.limit || 0, e);
  return e.changed() && t.set("__pivot__", null, null, !0), {
    key: t.key,
    groupby: t.groupby,
    ops: s.map(() => i),
    fields: s.map((a) => Qor(a, n, r, o)),
    as: s.map((a) => a + ""),
    modified: t.modified.bind(t)
  };
}
function Qor(t, e, n, r) {
  return Yu((i) => e(i) === t ? n(i) : NaN, r, t + "");
}
function wor(t, e, n) {
  const r = {}, i = [];
  return n.visit(n.SOURCE, (o) => {
    const s = t(o);
    r[s] || (r[s] = 1, i.push(s));
  }), i.sort(aj), e ? i.slice(0, e) : i;
}
function qet(t) {
  Bj.call(this, t);
}
on(qet, Bj, {
  transform(t, e) {
    const n = t.subflow, r = t.field, i = (o) => this.subflow(tr(o), n, e, o);
    return (t.modified("field") || r && e.modified(Zl(r))) && wt("PreFacet does not support field modification."), this.initTargets(), r ? (e.visit(e.MOD, (o) => {
      const s = i(o);
      r(o).forEach((a) => s.mod(a));
    }), e.visit(e.ADD, (o) => {
      const s = i(o);
      r(o).forEach((a) => s.add(so(a)));
    }), e.visit(e.REM, (o) => {
      const s = i(o);
      r(o).forEach((a) => s.rem(a));
    })) : (e.visit(e.MOD, (o) => i(o).mod(o)), e.visit(e.ADD, (o) => i(o).add(o)), e.visit(e.REM, (o) => i(o).rem(o))), e.clean() && e.runAfter(() => this.clean()), e;
  }
});
function vhe(t) {
  yt.call(this, null, t);
}
vhe.Definition = {
  type: "Project",
  metadata: {
    generates: !0,
    changes: !0
  },
  params: [{
    name: "fields",
    type: "field",
    array: !0
  }, {
    name: "as",
    type: "string",
    null: !0,
    array: !0
  }]
};
on(vhe, yt, {
  transform(t, e) {
    const n = e.fork(e.NO_SOURCE), r = t.fields, i = Let(t.fields, t.as || []), o = r ? (a, A) => xor(a, A, r, i) : dj;
    let s;
    return this.value ? s = this.value : (e = e.addAll(), s = this.value = {}), e.visit(e.REM, (a) => {
      const A = tr(a);
      n.rem.push(s[A]), s[A] = null;
    }), e.visit(e.ADD, (a) => {
      const A = o(a, so({}));
      s[tr(a)] = A, n.add.push(A);
    }), e.visit(e.MOD, (a) => {
      n.mod.push(o(a, s[tr(a)]));
    }), n;
  }
});
function xor(t, e, n, r) {
  for (let i = 0, o = n.length; i < o; ++i)
    e[r[i]] = n[i](t);
  return e;
}
function jet(t) {
  yt.call(this, null, t);
}
on(jet, yt, {
  transform(t, e) {
    return this.value = t.value, t.modified("value") ? e.fork(e.NO_SOURCE | e.NO_FIELDS) : e.StopPropagation;
  }
});
function Bhe(t) {
  yt.call(this, null, t);
}
Bhe.Definition = {
  type: "Quantile",
  metadata: {
    generates: !0,
    changes: !0
  },
  params: [{
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "probs",
    type: "number",
    array: !0
  }, {
    name: "step",
    type: "number",
    default: 0.01
  }, {
    name: "as",
    type: "string",
    array: !0,
    default: ["prob", "value"]
  }]
};
const Ror = 1e-14;
on(Bhe, yt, {
  transform(t, e) {
    const n = e.fork(e.NO_SOURCE | e.NO_FIELDS), r = t.as || ["prob", "value"];
    if (this.value && !t.modified() && !e.changed())
      return n.source = this.value, n;
    const i = e.materialize(e.SOURCE).source, o = lhe(i, t.groupby, t.field), s = (t.groupby || []).map(pa), a = [], A = t.step || 0.01, l = t.probs || E1(A / 2, 1 - Ror, A), c = l.length;
    return o.forEach((u) => {
      const f = Uge(u, l);
      for (let h = 0; h < c; ++h) {
        const d = {};
        for (let I = 0; I < s.length; ++I)
          d[s[I]] = u.dims[I];
        d[r[0]] = l[h], d[r[1]] = f[h], a.push(so(d));
      }
    }), this.value && (n.rem = this.value), this.value = n.add = n.source = a, n;
  }
});
function Yet(t) {
  yt.call(this, null, t);
}
on(Yet, yt, {
  transform(t, e) {
    let n, r;
    return this.value ? r = this.value : (n = e = e.addAll(), r = this.value = {}), t.derive && (n = e.fork(e.NO_SOURCE), e.visit(e.REM, (i) => {
      const o = tr(i);
      n.rem.push(r[o]), r[o] = null;
    }), e.visit(e.ADD, (i) => {
      const o = Pge(i);
      r[tr(i)] = o, n.add.push(o);
    }), e.visit(e.MOD, (i) => {
      const o = r[tr(i)];
      for (const s in i)
        o[s] = i[s], n.modifies(s);
      n.mod.push(o);
    })), n;
  }
});
function bhe(t) {
  yt.call(this, [], t), this.count = 0;
}
bhe.Definition = {
  type: "Sample",
  metadata: {},
  params: [{
    name: "size",
    type: "number",
    default: 1e3
  }]
};
on(bhe, yt, {
  transform(t, e) {
    const n = e.fork(e.NO_SOURCE), r = t.modified("size"), i = t.size, o = this.value.reduce((c, u) => (c[tr(u)] = 1, c), {});
    let s = this.value, a = this.count, A = 0;
    function l(c) {
      let u, f;
      s.length < i ? s.push(c) : (f = ~~((a + 1) * Yg()), f < s.length && f >= A && (u = s[f], o[tr(u)] && n.rem.push(u), s[f] = c)), ++a;
    }
    if (e.rem.length && (e.visit(e.REM, (c) => {
      const u = tr(c);
      o[u] && (o[u] = -1, n.rem.push(c)), --a;
    }), s = s.filter((c) => o[tr(c)] !== -1)), (e.rem.length || r) && s.length < i && e.source && (A = a = s.length, e.visit(e.SOURCE, (c) => {
      o[tr(c)] || l(c);
    }), A = -1), r && s.length > i) {
      const c = s.length - i;
      for (let u = 0; u < c; ++u)
        o[tr(s[u])] = -1, n.rem.push(s[u]);
      s = s.slice(c);
    }
    return e.mod.length && e.visit(e.MOD, (c) => {
      o[tr(c)] && n.mod.push(c);
    }), e.add.length && e.visit(e.ADD, l), (e.add.length || A < 0) && (n.add = s.filter((c) => !o[tr(c)])), this.count = a, this.value = n.source = s, n;
  }
});
function _he(t) {
  yt.call(this, null, t);
}
_he.Definition = {
  type: "Sequence",
  metadata: {
    generates: !0,
    changes: !0
  },
  params: [{
    name: "start",
    type: "number",
    required: !0
  }, {
    name: "stop",
    type: "number",
    required: !0
  }, {
    name: "step",
    type: "number",
    default: 1
  }, {
    name: "as",
    type: "string",
    default: "data"
  }]
};
on(_he, yt, {
  transform(t, e) {
    if (this.value && !t.modified())
      return;
    const n = e.materialize().fork(e.MOD), r = t.as || "data";
    return n.rem = this.value ? e.rem.concat(this.value) : e.rem, this.value = E1(t.start, t.stop, t.step || 1).map((i) => {
      const o = {};
      return o[r] = i, so(o);
    }), n.add = e.add.concat(this.value), n;
  }
});
function zet(t) {
  yt.call(this, null, t), this.modified(!0);
}
on(zet, yt, {
  transform(t, e) {
    return this.value = e.source, e.changed() ? e.fork(e.NO_SOURCE | e.NO_FIELDS) : e.StopPropagation;
  }
});
function She(t) {
  yt.call(this, null, t);
}
const Vet = ["unit0", "unit1"];
She.Definition = {
  type: "TimeUnit",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field",
    required: !0
  }, {
    name: "interval",
    type: "boolean",
    default: !0
  }, {
    name: "units",
    type: "enum",
    values: xge,
    array: !0
  }, {
    name: "step",
    type: "number",
    default: 1
  }, {
    name: "maxbins",
    type: "number",
    default: 40
  }, {
    name: "extent",
    type: "date",
    array: !0
  }, {
    name: "timezone",
    type: "enum",
    default: "local",
    values: ["local", "utc"]
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: Vet
  }]
};
on(She, yt, {
  transform(t, e) {
    const n = t.field, r = t.interval !== !1, i = t.timezone === "utc", o = this._floor(t, e), s = (i ? mx : Ix)(o.unit).offset, a = t.as || Vet, A = a[0], l = a[1], c = o.step;
    let u = o.start || 1 / 0, f = o.stop || -1 / 0, h = e.ADD;
    return (t.modified() || e.changed(e.REM) || e.modified(Zl(n))) && (e = e.reflow(!0), h = e.SOURCE, u = 1 / 0, f = -1 / 0), e.visit(h, (d) => {
      const I = n(d);
      let m, C;
      I == null ? (d[A] = null, r && (d[l] = null)) : (d[A] = m = C = o(I), r && (d[l] = C = s(m, c)), m < u && (u = m), C > f && (f = C));
    }), o.start = u, o.stop = f, e.modifies(r ? a : A);
  },
  _floor(t, e) {
    const n = t.timezone === "utc", {
      units: r,
      step: i
    } = t.units ? {
      units: t.units,
      step: t.step || 1
    } : OZe({
      extent: t.extent || Jp(e.materialize(e.SOURCE).source, t.field),
      maxbins: t.maxbins
    }), o = Rge(r), s = this.value || {}, a = (n ? QZe : SZe)(o, i);
    return a.unit = bi(o), a.units = o, a.step = i, a.start = s.start, a.stop = s.stop, this.value = a;
  }
});
function Jet(t) {
  yt.call(this, hx(), t);
}
on(Jet, yt, {
  transform(t, e) {
    const n = e.dataflow, r = t.field, i = this.value, o = (a) => i.set(r(a), a);
    let s = !0;
    return t.modified("field") || e.modified(r.fields) ? (i.clear(), e.visit(e.SOURCE, o)) : e.changed() ? (e.visit(e.REM, (a) => i.delete(r(a))), e.visit(e.ADD, o)) : s = !1, this.modified(s), i.empty > n.cleanThreshold && n.runAfter(i.clean), e.fork();
  }
});
function Ket(t) {
  yt.call(this, null, t);
}
on(Ket, yt, {
  transform(t, e) {
    (!this.value || t.modified("field") || t.modified("sort") || e.changed() || t.sort && e.modified(t.sort.fields)) && (this.value = (t.sort ? e.source.slice().sort(B1(t.sort)) : e.source).map(t.field));
  }
});
function Dor(t, e, n, r) {
  const i = EN[t](e, n);
  return {
    init: i.init || nC,
    update: function(o, s) {
      s[r] = i.next(o);
    }
  };
}
const EN = {
  row_number: function() {
    return {
      next: (t) => t.index + 1
    };
  },
  rank: function() {
    let t;
    return {
      init: () => t = 1,
      next: (e) => {
        const n = e.index, r = e.data;
        return n && e.compare(r[n - 1], r[n]) ? t = n + 1 : t;
      }
    };
  },
  dense_rank: function() {
    let t;
    return {
      init: () => t = 1,
      next: (e) => {
        const n = e.index, r = e.data;
        return n && e.compare(r[n - 1], r[n]) ? ++t : t;
      }
    };
  },
  percent_rank: function() {
    const t = EN.rank(), e = t.next;
    return {
      init: t.init,
      next: (n) => (e(n) - 1) / (n.data.length - 1)
    };
  },
  cume_dist: function() {
    let t;
    return {
      init: () => t = 0,
      next: (e) => {
        const n = e.data, r = e.compare;
        let i = e.index;
        if (t < i) {
          for (; i + 1 < n.length && !r(n[i], n[i + 1]); )
            ++i;
          t = i;
        }
        return (1 + t) / n.length;
      }
    };
  },
  ntile: function(t, e) {
    e = +e, e > 0 || wt("ntile num must be greater than zero.");
    const n = EN.cume_dist(), r = n.next;
    return {
      init: n.init,
      next: (i) => Math.ceil(e * r(i))
    };
  },
  lag: function(t, e) {
    return e = +e || 1, {
      next: (n) => {
        const r = n.index - e;
        return r >= 0 ? t(n.data[r]) : null;
      }
    };
  },
  lead: function(t, e) {
    return e = +e || 1, {
      next: (n) => {
        const r = n.index + e, i = n.data;
        return r < i.length ? t(i[r]) : null;
      }
    };
  },
  first_value: function(t) {
    return {
      next: (e) => t(e.data[e.i0])
    };
  },
  last_value: function(t) {
    return {
      next: (e) => t(e.data[e.i1 - 1])
    };
  },
  nth_value: function(t, e) {
    return e = +e, e > 0 || wt("nth_value nth must be greater than zero."), {
      next: (n) => {
        const r = n.i0 + (e - 1);
        return r < n.i1 ? t(n.data[r]) : null;
      }
    };
  },
  prev_value: function(t) {
    let e;
    return {
      init: () => e = null,
      next: (n) => {
        const r = t(n.data[n.index]);
        return r != null ? e = r : e;
      }
    };
  },
  next_value: function(t) {
    let e, n;
    return {
      init: () => (e = null, n = -1),
      next: (r) => {
        const i = r.data;
        return r.index <= n ? e : (n = Tor(t, i, r.index)) < 0 ? (n = i.length, e = null) : e = t(i[n]);
      }
    };
  }
};
function Tor(t, e, n) {
  for (let r = e.length; n < r; ++n)
    if (t(e[n]) != null)
      return n;
  return -1;
}
const Nor = Object.keys(EN);
function Wet(t) {
  const e = bn(t.ops), n = bn(t.fields), r = bn(t.params), i = bn(t.as), o = this.outputs = [], s = this.windows = [], a = {}, A = {}, l = [], c = [];
  let u = !0;
  function f(h) {
    bn(Zl(h)).forEach((d) => a[d] = 1);
  }
  f(t.sort), e.forEach((h, d) => {
    const I = n[d], m = pa(I), C = _et(h, m, i[d]);
    if (f(I), o.push(C), Kn(EN, h))
      s.push(Dor(h, n[d], r[d], C));
    else {
      if (I == null && h !== "count" && wt("Null aggregate field specified."), h === "count") {
        l.push(C);
        return;
      }
      u = !1;
      let y = A[m];
      y || (y = A[m] = [], y.field = I, c.push(y)), y.push(Qet(h, C));
    }
  }), (l.length || c.length) && (this.cell = Lor(c, l, u)), this.inputs = Object.keys(a);
}
const Xet = Wet.prototype;
Xet.init = function() {
  this.windows.forEach((t) => t.init()), this.cell && this.cell.init();
};
Xet.update = function(t, e) {
  const n = this.cell, r = this.windows, i = t.data, o = r && r.length;
  let s;
  if (n) {
    for (s = t.p0; s < t.i0; ++s)
      n.rem(i[s]);
    for (s = t.p1; s < t.i1; ++s)
      n.add(i[s]);
    n.set(e);
  }
  for (s = 0; s < o; ++s)
    r[s].update(t, e);
};
function Lor(t, e, n) {
  t = t.map((A) => xet(A, A.field));
  const r = {
    num: 0,
    agg: null,
    store: !1,
    count: e
  };
  if (!n)
    for (var i = t.length, o = r.agg = Array(i), s = 0; s < i; ++s)
      o[s] = new t[s](r);
  if (r.store)
    var a = r.data = new rhe();
  return r.add = function(A) {
    if (r.num += 1, !n) {
      a && a.add(A);
      for (let l = 0; l < i; ++l)
        o[l].add(o[l].get(A), A);
    }
  }, r.rem = function(A) {
    if (r.num -= 1, !n) {
      a && a.rem(A);
      for (let l = 0; l < i; ++l)
        o[l].rem(o[l].get(A), A);
    }
  }, r.set = function(A) {
    let l, c;
    for (a && a.values(), l = 0, c = e.length; l < c; ++l)
      A[e[l]] = r.num;
    if (!n)
      for (l = 0, c = o.length; l < c; ++l)
        o[l].set(A);
  }, r.init = function() {
    r.num = 0, a && a.reset();
    for (let A = 0; A < i; ++A)
      o[A].init();
  }, r;
}
function Qhe(t) {
  yt.call(this, {}, t), this._mlen = 0, this._mods = [];
}
Qhe.Definition = {
  type: "Window",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "sort",
    type: "compare"
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "ops",
    type: "enum",
    array: !0,
    values: Nor.concat(sO)
  }, {
    name: "params",
    type: "number",
    null: !0,
    array: !0
  }, {
    name: "fields",
    type: "field",
    null: !0,
    array: !0
  }, {
    name: "as",
    type: "string",
    null: !0,
    array: !0
  }, {
    name: "frame",
    type: "number",
    null: !0,
    array: !0,
    length: 2,
    default: [null, 0]
  }, {
    name: "ignorePeers",
    type: "boolean",
    default: !1
  }]
};
on(Qhe, yt, {
  transform(t, e) {
    this.stamp = e.stamp;
    const n = t.modified(), r = B1(t.sort), i = Xre(t.groupby), o = (a) => this.group(i(a));
    let s = this.state;
    (!s || n) && (s = this.state = new Wet(t)), n || e.modified(s.inputs) ? (this.value = {}, e.visit(e.SOURCE, (a) => o(a).add(a))) : (e.visit(e.REM, (a) => o(a).remove(a)), e.visit(e.ADD, (a) => o(a).add(a)));
    for (let a = 0, A = this._mlen; a < A; ++a)
      Mor(this._mods[a], s, r, t);
    return this._mlen = 0, this._mods = [], e.reflow(n).modifies(s.outputs);
  },
  group(t) {
    let e = this.value[t];
    return e || (e = this.value[t] = Ret(tr), e.stamp = -1), e.stamp < this.stamp && (e.stamp = this.stamp, this._mods[this._mlen++] = e), e;
  }
});
function Mor(t, e, n, r) {
  const i = r.sort, o = i && !r.ignorePeers, s = r.frame || [null, 0], a = t.data(n), A = a.length, l = o ? lj(i) : null, c = {
    i0: 0,
    i1: 0,
    p0: 0,
    p1: 0,
    index: 0,
    data: a,
    compare: i || lc(-1)
  };
  e.init();
  for (let u = 0; u < A; ++u)
    Oor(c, s, u, A), o && For(c, l), e.update(c, a[u]);
}
function Oor(t, e, n, r) {
  t.p0 = t.i0, t.p1 = t.i1, t.i0 = e[0] == null ? 0 : Math.max(0, n - Math.abs(e[0])), t.i1 = e[1] == null ? r : Math.min(r, n + Math.abs(e[1]) + 1), t.index = n;
}
function For(t, e) {
  const n = t.i0, r = t.i1 - 1, i = t.compare, o = t.data, s = o.length - 1;
  n > 0 && !i(o[n], o[n - 1]) && (t.i0 = e.left(o, o[n])), r < s && !i(o[r], o[r + 1]) && (t.i1 = e.right(o, o[r]));
}
const Por = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  aggregate: rE,
  bin: ihe,
  collect: ohe,
  compare: Det,
  countpattern: she,
  cross: ahe,
  density: Ahe,
  dotbin: che,
  expression: Oet,
  extent: uhe,
  facet: Bj,
  field: Fet,
  filter: ghe,
  flatten: hhe,
  fold: dhe,
  formula: phe,
  generate: Pet,
  impute: Ihe,
  joinaggregate: mhe,
  kde: Che,
  key: ket,
  load: Get,
  lookup: Ehe,
  multiextent: Uet,
  multivalues: Het,
  params: $et,
  pivot: yhe,
  prefacet: qet,
  project: vhe,
  proxy: jet,
  quantile: Bhe,
  relay: Yet,
  sample: bhe,
  sequence: _he,
  sieve: zet,
  subflow: fhe,
  timeunit: She,
  tupleindex: Jet,
  values: Ket,
  window: Qhe
}, Symbol.toStringTag, { value: "Module" })), Zre = Math.PI, eie = 2 * Zre, qy = 1e-6, kor = eie - qy;
function tie() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null, this._ = "";
}
function kE() {
  return new tie();
}
tie.prototype = kE.prototype = {
  constructor: tie,
  moveTo: function(t, e) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(t, e) {
    this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
  },
  quadraticCurveTo: function(t, e, n, r) {
    this._ += "Q" + +t + "," + +e + "," + (this._x1 = +n) + "," + (this._y1 = +r);
  },
  bezierCurveTo: function(t, e, n, r, i, o) {
    this._ += "C" + +t + "," + +e + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +o);
  },
  arcTo: function(t, e, n, r, i) {
    t = +t, e = +e, n = +n, r = +r, i = +i;
    var o = this._x1, s = this._y1, a = n - t, A = r - e, l = o - t, c = s - e, u = l * l + c * c;
    if (i < 0)
      throw new Error("negative radius: " + i);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = t) + "," + (this._y1 = e);
    else if (u > qy)
      if (!(Math.abs(c * a - A * l) > qy) || !i)
        this._ += "L" + (this._x1 = t) + "," + (this._y1 = e);
      else {
        var f = n - o, h = r - s, d = a * a + A * A, I = f * f + h * h, m = Math.sqrt(d), C = Math.sqrt(u), y = i * Math.tan((Zre - Math.acos((d + u - I) / (2 * m * C))) / 2), v = y / C, b = y / m;
        Math.abs(v - 1) > qy && (this._ += "L" + (t + v * l) + "," + (e + v * c)), this._ += "A" + i + "," + i + ",0,0," + +(c * f > l * h) + "," + (this._x1 = t + b * a) + "," + (this._y1 = e + b * A);
      }
  },
  arc: function(t, e, n, r, i, o) {
    t = +t, e = +e, n = +n, o = !!o;
    var s = n * Math.cos(r), a = n * Math.sin(r), A = t + s, l = e + a, c = 1 ^ o, u = o ? r - i : i - r;
    if (n < 0)
      throw new Error("negative radius: " + n);
    this._x1 === null ? this._ += "M" + A + "," + l : (Math.abs(this._x1 - A) > qy || Math.abs(this._y1 - l) > qy) && (this._ += "L" + A + "," + l), n && (u < 0 && (u = u % eie + eie), u > kor ? this._ += "A" + n + "," + n + ",0,1," + c + "," + (t - s) + "," + (e - a) + "A" + n + "," + n + ",0,1," + c + "," + (this._x1 = A) + "," + (this._y1 = l) : u > qy && (this._ += "A" + n + "," + n + ",0," + +(u >= Zre) + "," + c + "," + (this._x1 = t + n * Math.cos(i)) + "," + (this._y1 = e + n * Math.sin(i))));
  },
  rect: function(t, e, n, r) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +n + "v" + +r + "h" + -n + "Z";
  },
  toString: function() {
    return this._;
  }
};
function Io(t) {
  return function() {
    return t;
  };
}
const SLe = Math.abs, Dl = Math.atan2, _y = Math.cos, Gor = Math.max, dW = Math.min, np = Math.sin, gv = Math.sqrt, Ol = 1e-12, mQ = Math.PI, S5 = mQ / 2, Zet = 2 * mQ;
function Uor(t) {
  return t > 1 ? 0 : t < -1 ? mQ : Math.acos(t);
}
function QLe(t) {
  return t >= 1 ? S5 : t <= -1 ? -S5 : Math.asin(t);
}
function Hor(t) {
  return t.innerRadius;
}
function $or(t) {
  return t.outerRadius;
}
function qor(t) {
  return t.startAngle;
}
function jor(t) {
  return t.endAngle;
}
function Yor(t) {
  return t && t.padAngle;
}
function zor(t, e, n, r, i, o, s, a) {
  var A = n - t, l = r - e, c = s - i, u = a - o, f = u * A - c * l;
  if (!(f * f < Ol))
    return f = (c * (e - o) - u * (t - i)) / f, [t + f * A, e + f * l];
}
function I3(t, e, n, r, i, o, s) {
  var a = t - n, A = e - r, l = (s ? o : -o) / gv(a * a + A * A), c = l * A, u = -l * a, f = t + c, h = e + u, d = n + c, I = r + u, m = (f + d) / 2, C = (h + I) / 2, y = d - f, v = I - h, b = y * y + v * v, Q = i - o, w = f * I - d * h, R = (v < 0 ? -1 : 1) * gv(Gor(0, Q * Q * b - w * w)), M = (w * v - y * R) / b, O = (-w * y - v * R) / b, L = (w * v + y * R) / b, N = (-w * y + v * R) / b, k = M - m, $ = O - C, U = L - m, X = N - C;
  return k * k + $ * $ > U * U + X * X && (M = L, O = N), {
    cx: M,
    cy: O,
    x01: -c,
    y01: -u,
    x11: M * (i / Q - 1),
    y11: O * (i / Q - 1)
  };
}
function Vor() {
  var t = Hor, e = $or, n = Io(0), r = null, i = qor, o = jor, s = Yor, a = null;
  function A() {
    var l, c, u = +t.apply(this, arguments), f = +e.apply(this, arguments), h = i.apply(this, arguments) - S5, d = o.apply(this, arguments) - S5, I = SLe(d - h), m = d > h;
    if (a || (a = l = kE()), f < u && (c = f, f = u, u = c), !(f > Ol))
      a.moveTo(0, 0);
    else if (I > Zet - Ol)
      a.moveTo(f * _y(h), f * np(h)), a.arc(0, 0, f, h, d, !m), u > Ol && (a.moveTo(u * _y(d), u * np(d)), a.arc(0, 0, u, d, h, m));
    else {
      var C = h, y = d, v = h, b = d, Q = I, w = I, R = s.apply(this, arguments) / 2, M = R > Ol && (r ? +r.apply(this, arguments) : gv(u * u + f * f)), O = dW(SLe(f - u) / 2, +n.apply(this, arguments)), L = O, N = O, k, $;
      if (M > Ol) {
        var U = QLe(M / u * np(R)), X = QLe(M / f * np(R));
        (Q -= U * 2) > Ol ? (U *= m ? 1 : -1, v += U, b -= U) : (Q = 0, v = b = (h + d) / 2), (w -= X * 2) > Ol ? (X *= m ? 1 : -1, C += X, y -= X) : (w = 0, C = y = (h + d) / 2);
      }
      var K = f * _y(C), z = f * np(C), Y = u * _y(b), V = u * np(b);
      if (O > Ol) {
        var Z = f * _y(y), ce = f * np(y), ee = u * _y(v), pe = u * np(v), Ce;
        if (I < mQ && (Ce = zor(K, z, ee, pe, Z, ce, Y, V))) {
          var Be = K - Ce[0], Ie = z - Ce[1], Qe = Z - Ce[0], xe = ce - Ce[1], Se = 1 / np(Uor((Be * Qe + Ie * xe) / (gv(Be * Be + Ie * Ie) * gv(Qe * Qe + xe * xe))) / 2), De = gv(Ce[0] * Ce[0] + Ce[1] * Ce[1]);
          L = dW(O, (u - De) / (Se - 1)), N = dW(O, (f - De) / (Se + 1));
        }
      }
      w > Ol ? N > Ol ? (k = I3(ee, pe, K, z, f, N, m), $ = I3(Z, ce, Y, V, f, N, m), a.moveTo(k.cx + k.x01, k.cy + k.y01), N < O ? a.arc(k.cx, k.cy, N, Dl(k.y01, k.x01), Dl($.y01, $.x01), !m) : (a.arc(k.cx, k.cy, N, Dl(k.y01, k.x01), Dl(k.y11, k.x11), !m), a.arc(0, 0, f, Dl(k.cy + k.y11, k.cx + k.x11), Dl($.cy + $.y11, $.cx + $.x11), !m), a.arc($.cx, $.cy, N, Dl($.y11, $.x11), Dl($.y01, $.x01), !m))) : (a.moveTo(K, z), a.arc(0, 0, f, C, y, !m)) : a.moveTo(K, z), !(u > Ol) || !(Q > Ol) ? a.lineTo(Y, V) : L > Ol ? (k = I3(Y, V, Z, ce, u, -L, m), $ = I3(K, z, ee, pe, u, -L, m), a.lineTo(k.cx + k.x01, k.cy + k.y01), L < O ? a.arc(k.cx, k.cy, L, Dl(k.y01, k.x01), Dl($.y01, $.x01), !m) : (a.arc(k.cx, k.cy, L, Dl(k.y01, k.x01), Dl(k.y11, k.x11), !m), a.arc(0, 0, u, Dl(k.cy + k.y11, k.cx + k.x11), Dl($.cy + $.y11, $.cx + $.x11), m), a.arc($.cx, $.cy, L, Dl($.y11, $.x11), Dl($.y01, $.x01), !m))) : a.arc(0, 0, u, b, v, m);
    }
    if (a.closePath(), l)
      return a = null, l + "" || null;
  }
  return A.centroid = function() {
    var l = (+t.apply(this, arguments) + +e.apply(this, arguments)) / 2, c = (+i.apply(this, arguments) + +o.apply(this, arguments)) / 2 - mQ / 2;
    return [_y(c) * l, np(c) * l];
  }, A.innerRadius = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : Io(+l), A) : t;
  }, A.outerRadius = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Io(+l), A) : e;
  }, A.cornerRadius = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : Io(+l), A) : n;
  }, A.padRadius = function(l) {
    return arguments.length ? (r = l == null ? null : typeof l == "function" ? l : Io(+l), A) : r;
  }, A.startAngle = function(l) {
    return arguments.length ? (i = typeof l == "function" ? l : Io(+l), A) : i;
  }, A.endAngle = function(l) {
    return arguments.length ? (o = typeof l == "function" ? l : Io(+l), A) : o;
  }, A.padAngle = function(l) {
    return arguments.length ? (s = typeof l == "function" ? l : Io(+l), A) : s;
  }, A.context = function(l) {
    return arguments.length ? (a = l ?? null, A) : a;
  }, A;
}
function ett(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function ttt(t) {
  this._context = t;
}
ttt.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(t, e);
        break;
    }
  }
};
function whe(t) {
  return new ttt(t);
}
function ntt(t) {
  return t[0];
}
function rtt(t) {
  return t[1];
}
function itt(t, e) {
  var n = Io(!0), r = null, i = whe, o = null;
  t = typeof t == "function" ? t : t === void 0 ? ntt : Io(t), e = typeof e == "function" ? e : e === void 0 ? rtt : Io(e);
  function s(a) {
    var A, l = (a = ett(a)).length, c, u = !1, f;
    for (r == null && (o = i(f = kE())), A = 0; A <= l; ++A)
      !(A < l && n(c = a[A], A, a)) === u && ((u = !u) ? o.lineStart() : o.lineEnd()), u && o.point(+t(c, A, a), +e(c, A, a));
    if (f)
      return o = null, f + "" || null;
  }
  return s.x = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : Io(+a), s) : t;
  }, s.y = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Io(+a), s) : e;
  }, s.defined = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : Io(!!a), s) : n;
  }, s.curve = function(a) {
    return arguments.length ? (i = a, r != null && (o = i(r)), s) : i;
  }, s.context = function(a) {
    return arguments.length ? (a == null ? r = o = null : o = i(r = a), s) : r;
  }, s;
}
function ott(t, e, n) {
  var r = null, i = Io(!0), o = null, s = whe, a = null;
  t = typeof t == "function" ? t : t === void 0 ? ntt : Io(+t), e = typeof e == "function" ? e : Io(e === void 0 ? 0 : +e), n = typeof n == "function" ? n : n === void 0 ? rtt : Io(+n);
  function A(c) {
    var u, f, h, d = (c = ett(c)).length, I, m = !1, C, y = new Array(d), v = new Array(d);
    for (o == null && (a = s(C = kE())), u = 0; u <= d; ++u) {
      if (!(u < d && i(I = c[u], u, c)) === m)
        if (m = !m)
          f = u, a.areaStart(), a.lineStart();
        else {
          for (a.lineEnd(), a.lineStart(), h = u - 1; h >= f; --h)
            a.point(y[h], v[h]);
          a.lineEnd(), a.areaEnd();
        }
      m && (y[u] = +t(I, u, c), v[u] = +e(I, u, c), a.point(r ? +r(I, u, c) : y[u], n ? +n(I, u, c) : v[u]));
    }
    if (C)
      return a = null, C + "" || null;
  }
  function l() {
    return itt().defined(i).curve(s).context(o);
  }
  return A.x = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Io(+c), r = null, A) : t;
  }, A.x0 = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Io(+c), A) : t;
  }, A.x1 = function(c) {
    return arguments.length ? (r = c == null ? null : typeof c == "function" ? c : Io(+c), A) : r;
  }, A.y = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Io(+c), n = null, A) : e;
  }, A.y0 = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Io(+c), A) : e;
  }, A.y1 = function(c) {
    return arguments.length ? (n = c == null ? null : typeof c == "function" ? c : Io(+c), A) : n;
  }, A.lineX0 = A.lineY0 = function() {
    return l().x(t).y(e);
  }, A.lineY1 = function() {
    return l().x(t).y(n);
  }, A.lineX1 = function() {
    return l().x(r).y(e);
  }, A.defined = function(c) {
    return arguments.length ? (i = typeof c == "function" ? c : Io(!!c), A) : i;
  }, A.curve = function(c) {
    return arguments.length ? (s = c, o != null && (a = s(o)), A) : s;
  }, A.context = function(c) {
    return arguments.length ? (c == null ? o = a = null : a = s(o = c), A) : o;
  }, A;
}
const Jor = {
  draw(t, e) {
    const n = gv(e / mQ);
    t.moveTo(n, 0), t.arc(0, 0, n, 0, Zet);
  }
};
function Kor(t, e) {
  let n = null;
  t = typeof t == "function" ? t : Io(t || Jor), e = typeof e == "function" ? e : Io(e === void 0 ? 64 : +e);
  function r() {
    let i;
    if (n || (n = i = kE()), t.apply(this, arguments).draw(n, +e.apply(this, arguments)), i)
      return n = null, i + "" || null;
  }
  return r.type = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : Io(i), r) : t;
  }, r.size = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Io(+i), r) : e;
  }, r.context = function(i) {
    return arguments.length ? (n = i ?? null, r) : n;
  }, r;
}
function iE() {
}
function Q5(t, e, n) {
  t._context.bezierCurveTo(
    (2 * t._x0 + t._x1) / 3,
    (2 * t._y0 + t._y1) / 3,
    (t._x0 + 2 * t._x1) / 3,
    (t._y0 + 2 * t._y1) / 3,
    (t._x0 + 4 * t._x1 + e) / 6,
    (t._y0 + 4 * t._y1 + n) / 6
  );
}
function bj(t) {
  this._context = t;
}
bj.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        Q5(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        Q5(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function Wor(t) {
  return new bj(t);
}
function stt(t) {
  this._context = t;
}
stt.prototype = {
  areaStart: iE,
  areaEnd: iE,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._x2 = t, this._y2 = e;
        break;
      case 1:
        this._point = 2, this._x3 = t, this._y3 = e;
        break;
      case 2:
        this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
        break;
      default:
        Q5(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function Xor(t) {
  return new stt(t);
}
function att(t) {
  this._context = t;
}
att.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + t) / 6, r = (this._y0 + 4 * this._y1 + e) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      default:
        Q5(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function Zor(t) {
  return new att(t);
}
function Att(t, e) {
  this._basis = new bj(t), this._beta = e;
}
Att.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var t = this._x, e = this._y, n = t.length - 1;
    if (n > 0)
      for (var r = t[0], i = e[0], o = t[n] - r, s = e[n] - i, a = -1, A; ++a <= n; )
        A = a / n, this._basis.point(
          this._beta * t[a] + (1 - this._beta) * (r + A * o),
          this._beta * e[a] + (1 - this._beta) * (i + A * s)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(t, e) {
    this._x.push(+t), this._y.push(+e);
  }
};
const esr = function t(e) {
  function n(r) {
    return e === 1 ? new bj(r) : new Att(r, e);
  }
  return n.beta = function(r) {
    return t(+r);
  }, n;
}(0.85);
function w5(t, e, n) {
  t._context.bezierCurveTo(
    t._x1 + t._k * (t._x2 - t._x0),
    t._y1 + t._k * (t._y2 - t._y0),
    t._x2 + t._k * (t._x1 - e),
    t._y2 + t._k * (t._y1 - n),
    t._x2,
    t._y2
  );
}
function xhe(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
xhe.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        w5(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2, this._x1 = t, this._y1 = e;
        break;
      case 2:
        this._point = 3;
      default:
        w5(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const tsr = function t(e) {
  function n(r) {
    return new xhe(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function Rhe(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
Rhe.prototype = {
  areaStart: iE,
  areaEnd: iE,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._x3 = t, this._y3 = e;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
        break;
      case 2:
        this._point = 3, this._x5 = t, this._y5 = e;
        break;
      default:
        w5(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const nsr = function t(e) {
  function n(r) {
    return new Rhe(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function Dhe(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
Dhe.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        w5(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const rsr = function t(e) {
  function n(r) {
    return new Dhe(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function The(t, e, n) {
  var r = t._x1, i = t._y1, o = t._x2, s = t._y2;
  if (t._l01_a > Ol) {
    var a = 2 * t._l01_2a + 3 * t._l01_a * t._l12_a + t._l12_2a, A = 3 * t._l01_a * (t._l01_a + t._l12_a);
    r = (r * a - t._x0 * t._l12_2a + t._x2 * t._l01_2a) / A, i = (i * a - t._y0 * t._l12_2a + t._y2 * t._l01_2a) / A;
  }
  if (t._l23_a > Ol) {
    var l = 2 * t._l23_2a + 3 * t._l23_a * t._l12_a + t._l12_2a, c = 3 * t._l23_a * (t._l23_a + t._l12_a);
    o = (o * l + t._x1 * t._l23_2a - e * t._l12_2a) / c, s = (s * l + t._y1 * t._l23_2a - n * t._l12_2a) / c;
  }
  t._context.bezierCurveTo(r, i, o, s, t._x2, t._y2);
}
function ltt(t, e) {
  this._context = t, this._alpha = e;
}
ltt.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        The(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const isr = function t(e) {
  function n(r) {
    return e ? new ltt(r, e) : new xhe(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function ctt(t, e) {
  this._context = t, this._alpha = e;
}
ctt.prototype = {
  areaStart: iE,
  areaEnd: iE,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = t, this._y3 = e;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
        break;
      case 2:
        this._point = 3, this._x5 = t, this._y5 = e;
        break;
      default:
        The(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const osr = function t(e) {
  function n(r) {
    return e ? new ctt(r, e) : new Rhe(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function utt(t, e) {
  this._context = t, this._alpha = e;
}
utt.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        The(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const ssr = function t(e) {
  function n(r) {
    return e ? new utt(r, e) : new Dhe(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function ftt(t) {
  this._context = t;
}
ftt.prototype = {
  areaStart: iE,
  areaEnd: iE,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(t, e) {
    t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
  }
};
function asr(t) {
  return new ftt(t);
}
function wLe(t) {
  return t < 0 ? -1 : 1;
}
function xLe(t, e, n) {
  var r = t._x1 - t._x0, i = e - t._x1, o = (t._y1 - t._y0) / (r || i < 0 && -0), s = (n - t._y1) / (i || r < 0 && -0), a = (o * i + s * r) / (r + i);
  return (wLe(o) + wLe(s)) * Math.min(Math.abs(o), Math.abs(s), 0.5 * Math.abs(a)) || 0;
}
function RLe(t, e) {
  var n = t._x1 - t._x0;
  return n ? (3 * (t._y1 - t._y0) / n - e) / 2 : e;
}
function pW(t, e, n) {
  var r = t._x0, i = t._y0, o = t._x1, s = t._y1, a = (o - r) / 3;
  t._context.bezierCurveTo(r + a, i + a * e, o - a, s - a * n, o, s);
}
function x5(t) {
  this._context = t;
}
x5.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        pW(this, this._t0, RLe(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    var n = NaN;
    if (t = +t, e = +e, !(t === this._x1 && e === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, pW(this, RLe(this, n = xLe(this, t, e)), n);
          break;
        default:
          pW(this, this._t0, n = xLe(this, t, e));
          break;
      }
      this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = n;
    }
  }
};
function gtt(t) {
  this._context = new htt(t);
}
(gtt.prototype = Object.create(x5.prototype)).point = function(t, e) {
  x5.prototype.point.call(this, e, t);
};
function htt(t) {
  this._context = t;
}
htt.prototype = {
  moveTo: function(t, e) {
    this._context.moveTo(e, t);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(t, e) {
    this._context.lineTo(e, t);
  },
  bezierCurveTo: function(t, e, n, r, i, o) {
    this._context.bezierCurveTo(e, t, r, n, o, i);
  }
};
function Asr(t) {
  return new x5(t);
}
function lsr(t) {
  return new gtt(t);
}
function dtt(t) {
  this._context = t;
}
dtt.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var t = this._x, e = this._y, n = t.length;
    if (n)
      if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), n === 2)
        this._context.lineTo(t[1], e[1]);
      else
        for (var r = DLe(t), i = DLe(e), o = 0, s = 1; s < n; ++o, ++s)
          this._context.bezierCurveTo(r[0][o], i[0][o], r[1][o], i[1][o], t[s], e[s]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(t, e) {
    this._x.push(+t), this._y.push(+e);
  }
};
function DLe(t) {
  var e, n = t.length - 1, r, i = new Array(n), o = new Array(n), s = new Array(n);
  for (i[0] = 0, o[0] = 2, s[0] = t[0] + 2 * t[1], e = 1; e < n - 1; ++e)
    i[e] = 1, o[e] = 4, s[e] = 4 * t[e] + 2 * t[e + 1];
  for (i[n - 1] = 2, o[n - 1] = 7, s[n - 1] = 8 * t[n - 1] + t[n], e = 1; e < n; ++e)
    r = i[e] / o[e - 1], o[e] -= r, s[e] -= r * s[e - 1];
  for (i[n - 1] = s[n - 1] / o[n - 1], e = n - 2; e >= 0; --e)
    i[e] = (s[e] - i[e + 1]) / o[e];
  for (o[n - 1] = (t[n] + i[n - 1]) / 2, e = 0; e < n - 1; ++e)
    o[e] = 2 * t[e + 1] - i[e + 1];
  return [i, o];
}
function csr(t) {
  return new dtt(t);
}
function _j(t, e) {
  this._context = t, this._t = e;
}
_j.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, e), this._context.lineTo(t, e);
        else {
          var n = this._x * (1 - this._t) + t * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, e);
        }
        break;
      }
    }
    this._x = t, this._y = e;
  }
};
function usr(t) {
  return new _j(t, 0.5);
}
function fsr(t) {
  return new _j(t, 0);
}
function gsr(t) {
  return new _j(t, 1);
}
function PC(t, e) {
  if (typeof document < "u" && document.createElement) {
    const n = document.createElement("canvas");
    if (n && n.getContext)
      return n.width = t, n.height = e, n;
  }
  return null;
}
const hsr = () => typeof Image < "u" ? Image : null;
function h0(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function GE(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
    default: {
      this.domain(t), typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
  }
  return this;
}
const nie = Symbol("implicit");
function Nhe() {
  var t = new hve(), e = [], n = [], r = nie;
  function i(o) {
    let s = t.get(o);
    if (s === void 0) {
      if (r !== nie)
        return r;
      t.set(o, s = e.push(o) - 1);
    }
    return n[s % n.length];
  }
  return i.domain = function(o) {
    if (!arguments.length)
      return e.slice();
    e = [], t = new hve();
    for (const s of o)
      t.has(s) || t.set(s, e.push(s) - 1);
    return i;
  }, i.range = function(o) {
    return arguments.length ? (n = Array.from(o), i) : n.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return Nhe(e, n).unknown(r);
  }, h0.apply(i, arguments), i;
}
function Ex(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function aO(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e)
    n[r] = e[r];
  return n;
}
function UE() {
}
var CB = 0.7, CQ = 1 / CB, aS = "\\s*([+-]?\\d+)\\s*", yN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Mp = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", dsr = /^#([0-9a-f]{3,8})$/, psr = new RegExp(`^rgb\\(${aS},${aS},${aS}\\)$`), Isr = new RegExp(`^rgb\\(${Mp},${Mp},${Mp}\\)$`), msr = new RegExp(`^rgba\\(${aS},${aS},${aS},${yN}\\)$`), Csr = new RegExp(`^rgba\\(${Mp},${Mp},${Mp},${yN}\\)$`), Esr = new RegExp(`^hsl\\(${yN},${Mp},${Mp}\\)$`), ysr = new RegExp(`^hsla\\(${yN},${Mp},${Mp},${yN}\\)$`), TLe = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Ex(UE, vN, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: NLe,
  // Deprecated! Use color.formatHex.
  formatHex: NLe,
  formatHex8: vsr,
  formatHsl: Bsr,
  formatRgb: LLe,
  toString: LLe
});
function NLe() {
  return this.rgb().formatHex();
}
function vsr() {
  return this.rgb().formatHex8();
}
function Bsr() {
  return ptt(this).formatHsl();
}
function LLe() {
  return this.rgb().formatRgb();
}
function vN(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = dsr.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), n === 6 ? MLe(e) : n === 3 ? new NA(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : n === 8 ? m3(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : n === 4 ? m3(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = psr.exec(t)) ? new NA(e[1], e[2], e[3], 1) : (e = Isr.exec(t)) ? new NA(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = msr.exec(t)) ? m3(e[1], e[2], e[3], e[4]) : (e = Csr.exec(t)) ? m3(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = Esr.exec(t)) ? PLe(e[1], e[2] / 100, e[3] / 100, 1) : (e = ysr.exec(t)) ? PLe(e[1], e[2] / 100, e[3] / 100, e[4]) : TLe.hasOwnProperty(t) ? MLe(TLe[t]) : t === "transparent" ? new NA(NaN, NaN, NaN, 0) : null;
}
function MLe(t) {
  return new NA(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function m3(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new NA(t, e, n, r);
}
function Lhe(t) {
  return t instanceof UE || (t = vN(t)), t ? (t = t.rgb(), new NA(t.r, t.g, t.b, t.opacity)) : new NA();
}
function oE(t, e, n, r) {
  return arguments.length === 1 ? Lhe(t) : new NA(t, e, n, r ?? 1);
}
function NA(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
Ex(NA, oE, aO(UE, {
  brighter(t) {
    return t = t == null ? CQ : Math.pow(CQ, t), new NA(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? CB : Math.pow(CB, t), new NA(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new NA(Nv(this.r), Nv(this.g), Nv(this.b), R5(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: OLe,
  // Deprecated! Use color.formatHex.
  formatHex: OLe,
  formatHex8: bsr,
  formatRgb: FLe,
  toString: FLe
}));
function OLe() {
  return `#${hv(this.r)}${hv(this.g)}${hv(this.b)}`;
}
function bsr() {
  return `#${hv(this.r)}${hv(this.g)}${hv(this.b)}${hv((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function FLe() {
  const t = R5(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${Nv(this.r)}, ${Nv(this.g)}, ${Nv(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function R5(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function Nv(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function hv(t) {
  return t = Nv(t), (t < 16 ? "0" : "") + t.toString(16);
}
function PLe(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new Fh(t, e, n, r);
}
function ptt(t) {
  if (t instanceof Fh)
    return new Fh(t.h, t.s, t.l, t.opacity);
  if (t instanceof UE || (t = vN(t)), !t)
    return new Fh();
  if (t instanceof Fh)
    return t;
  t = t.rgb();
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, i = Math.min(e, n, r), o = Math.max(e, n, r), s = NaN, a = o - i, A = (o + i) / 2;
  return a ? (e === o ? s = (n - r) / a + (n < r) * 6 : n === o ? s = (r - e) / a + 2 : s = (e - n) / a + 4, a /= A < 0.5 ? o + i : 2 - o - i, s *= 60) : a = A > 0 && A < 1 ? 0 : s, new Fh(s, a, A, t.opacity);
}
function D5(t, e, n, r) {
  return arguments.length === 1 ? ptt(t) : new Fh(t, e, n, r ?? 1);
}
function Fh(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
Ex(Fh, D5, aO(UE, {
  brighter(t) {
    return t = t == null ? CQ : Math.pow(CQ, t), new Fh(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? CB : Math.pow(CB, t), new Fh(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * e, i = 2 * n - r;
    return new NA(
      IW(t >= 240 ? t - 240 : t + 120, i, r),
      IW(t, i, r),
      IW(t < 120 ? t + 240 : t - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new Fh(kLe(this.h), C3(this.s), C3(this.l), R5(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = R5(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${kLe(this.h)}, ${C3(this.s) * 100}%, ${C3(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function kLe(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function C3(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function IW(t, e, n) {
  return (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e) * 255;
}
const Itt = Math.PI / 180, mtt = 180 / Math.PI, T5 = 18, Ctt = 0.96422, Ett = 1, ytt = 0.82521, vtt = 4 / 29, AS = 6 / 29, Btt = 3 * AS * AS, _sr = AS * AS * AS;
function btt(t) {
  if (t instanceof Op)
    return new Op(t.l, t.a, t.b, t.opacity);
  if (t instanceof lI)
    return _tt(t);
  t instanceof NA || (t = Lhe(t));
  var e = yW(t.r), n = yW(t.g), r = yW(t.b), i = mW((0.2225045 * e + 0.7168786 * n + 0.0606169 * r) / Ett), o, s;
  return e === n && n === r ? o = s = i : (o = mW((0.4360747 * e + 0.3850649 * n + 0.1430804 * r) / Ctt), s = mW((0.0139322 * e + 0.0971045 * n + 0.7141733 * r) / ytt)), new Op(116 * i - 16, 500 * (o - i), 200 * (i - s), t.opacity);
}
function N5(t, e, n, r) {
  return arguments.length === 1 ? btt(t) : new Op(t, e, n, r ?? 1);
}
function Op(t, e, n, r) {
  this.l = +t, this.a = +e, this.b = +n, this.opacity = +r;
}
Ex(Op, N5, aO(UE, {
  brighter(t) {
    return new Op(this.l + T5 * (t ?? 1), this.a, this.b, this.opacity);
  },
  darker(t) {
    return new Op(this.l - T5 * (t ?? 1), this.a, this.b, this.opacity);
  },
  rgb() {
    var t = (this.l + 16) / 116, e = isNaN(this.a) ? t : t + this.a / 500, n = isNaN(this.b) ? t : t - this.b / 200;
    return e = Ctt * CW(e), t = Ett * CW(t), n = ytt * CW(n), new NA(
      EW(3.1338561 * e - 1.6168667 * t - 0.4906146 * n),
      EW(-0.9787684 * e + 1.9161415 * t + 0.033454 * n),
      EW(0.0719453 * e - 0.2289914 * t + 1.4052427 * n),
      this.opacity
    );
  }
}));
function mW(t) {
  return t > _sr ? Math.pow(t, 1 / 3) : t / Btt + vtt;
}
function CW(t) {
  return t > AS ? t * t * t : Btt * (t - vtt);
}
function EW(t) {
  return 255 * (t <= 31308e-7 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - 0.055);
}
function yW(t) {
  return (t /= 255) <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}
function Ssr(t) {
  if (t instanceof lI)
    return new lI(t.h, t.c, t.l, t.opacity);
  if (t instanceof Op || (t = btt(t)), t.a === 0 && t.b === 0)
    return new lI(NaN, 0 < t.l && t.l < 100 ? 0 : NaN, t.l, t.opacity);
  var e = Math.atan2(t.b, t.a) * mtt;
  return new lI(e < 0 ? e + 360 : e, Math.sqrt(t.a * t.a + t.b * t.b), t.l, t.opacity);
}
function L5(t, e, n, r) {
  return arguments.length === 1 ? Ssr(t) : new lI(t, e, n, r ?? 1);
}
function lI(t, e, n, r) {
  this.h = +t, this.c = +e, this.l = +n, this.opacity = +r;
}
function _tt(t) {
  if (isNaN(t.h))
    return new Op(t.l, 0, 0, t.opacity);
  var e = t.h * Itt;
  return new Op(t.l, Math.cos(e) * t.c, Math.sin(e) * t.c, t.opacity);
}
Ex(lI, L5, aO(UE, {
  brighter(t) {
    return new lI(this.h, this.c, this.l + T5 * (t ?? 1), this.opacity);
  },
  darker(t) {
    return new lI(this.h, this.c, this.l - T5 * (t ?? 1), this.opacity);
  },
  rgb() {
    return _tt(this).rgb();
  }
}));
var Stt = -0.14861, Mhe = 1.78277, Ohe = -0.29227, Sj = -0.90649, BN = 1.97294, GLe = BN * Sj, ULe = BN * Mhe, HLe = Mhe * Ohe - Sj * Stt;
function Qsr(t) {
  if (t instanceof Lv)
    return new Lv(t.h, t.s, t.l, t.opacity);
  t instanceof NA || (t = Lhe(t));
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, i = (HLe * r + GLe * e - ULe * n) / (HLe + GLe - ULe), o = r - i, s = (BN * (n - i) - Ohe * o) / Sj, a = Math.sqrt(s * s + o * o) / (BN * i * (1 - i)), A = a ? Math.atan2(s, o) * mtt - 120 : NaN;
  return new Lv(A < 0 ? A + 360 : A, a, i, t.opacity);
}
function rie(t, e, n, r) {
  return arguments.length === 1 ? Qsr(t) : new Lv(t, e, n, r ?? 1);
}
function Lv(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
Ex(Lv, rie, aO(UE, {
  brighter(t) {
    return t = t == null ? CQ : Math.pow(CQ, t), new Lv(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? CB : Math.pow(CB, t), new Lv(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = isNaN(this.h) ? 0 : (this.h + 120) * Itt, e = +this.l, n = isNaN(this.s) ? 0 : this.s * e * (1 - e), r = Math.cos(t), i = Math.sin(t);
    return new NA(
      255 * (e + n * (Stt * r + Mhe * i)),
      255 * (e + n * (Ohe * r + Sj * i)),
      255 * (e + n * (BN * r)),
      this.opacity
    );
  }
}));
function Qtt(t, e, n, r, i) {
  var o = t * t, s = o * t;
  return ((1 - 3 * t + 3 * o - s) * e + (4 - 6 * o + 3 * s) * n + (1 + 3 * t + 3 * o - 3 * s) * r + s * i) / 6;
}
function wtt(t) {
  var e = t.length - 1;
  return function(n) {
    var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, e - 1) : Math.floor(n * e), i = t[r], o = t[r + 1], s = r > 0 ? t[r - 1] : 2 * i - o, a = r < e - 1 ? t[r + 2] : 2 * o - i;
    return Qtt((n - r / e) * e, s, i, o, a);
  };
}
function xtt(t) {
  var e = t.length;
  return function(n) {
    var r = Math.floor(((n %= 1) < 0 ? ++n : n) * e), i = t[(r + e - 1) % e], o = t[r % e], s = t[(r + 1) % e], a = t[(r + 2) % e];
    return Qtt((n - r / e) * e, i, o, s, a);
  };
}
const Qj = (t) => () => t;
function Rtt(t, e) {
  return function(n) {
    return t + n * e;
  };
}
function wsr(t, e, n) {
  return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function(r) {
    return Math.pow(t + r * e, n);
  };
}
function wj(t, e) {
  var n = e - t;
  return n ? Rtt(t, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : Qj(isNaN(t) ? e : t);
}
function xsr(t) {
  return (t = +t) == 1 ? LA : function(e, n) {
    return n - e ? wsr(e, n, t) : Qj(isNaN(e) ? n : e);
  };
}
function LA(t, e) {
  var n = e - t;
  return n ? Rtt(t, n) : Qj(isNaN(t) ? e : t);
}
const iie = function t(e) {
  var n = xsr(e);
  function r(i, o) {
    var s = n((i = oE(i)).r, (o = oE(o)).r), a = n(i.g, o.g), A = n(i.b, o.b), l = LA(i.opacity, o.opacity);
    return function(c) {
      return i.r = s(c), i.g = a(c), i.b = A(c), i.opacity = l(c), i + "";
    };
  }
  return r.gamma = t, r;
}(1);
function Dtt(t) {
  return function(e) {
    var n = e.length, r = new Array(n), i = new Array(n), o = new Array(n), s, a;
    for (s = 0; s < n; ++s)
      a = oE(e[s]), r[s] = a.r || 0, i[s] = a.g || 0, o[s] = a.b || 0;
    return r = t(r), i = t(i), o = t(o), a.opacity = 1, function(A) {
      return a.r = r(A), a.g = i(A), a.b = o(A), a + "";
    };
  };
}
var Rsr = Dtt(wtt), Dsr = Dtt(xtt);
function Fhe(t, e) {
  e || (e = []);
  var n = t ? Math.min(e.length, t.length) : 0, r = e.slice(), i;
  return function(o) {
    for (i = 0; i < n; ++i)
      r[i] = t[i] * (1 - o) + e[i] * o;
    return r;
  };
}
function Ttt(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function Tsr(t, e) {
  return (Ttt(e) ? Fhe : Ntt)(t, e);
}
function Ntt(t, e) {
  var n = e ? e.length : 0, r = t ? Math.min(n, t.length) : 0, i = new Array(r), o = new Array(n), s;
  for (s = 0; s < r; ++s)
    i[s] = HE(t[s], e[s]);
  for (; s < n; ++s)
    o[s] = e[s];
  return function(a) {
    for (s = 0; s < r; ++s)
      o[s] = i[s](a);
    return o;
  };
}
function Ltt(t, e) {
  var n = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(r) {
    return n.setTime(t * (1 - r) + e * r), n;
  };
}
function Nh(t, e) {
  return t = +t, e = +e, function(n) {
    return t * (1 - n) + e * n;
  };
}
function Mtt(t, e) {
  var n = {}, r = {}, i;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (i in e)
    i in t ? n[i] = HE(t[i], e[i]) : r[i] = e[i];
  return function(o) {
    for (i in n)
      r[i] = n[i](o);
    return r;
  };
}
var oie = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, vW = new RegExp(oie.source, "g");
function Nsr(t) {
  return function() {
    return t;
  };
}
function Lsr(t) {
  return function(e) {
    return t(e) + "";
  };
}
function Ott(t, e) {
  var n = oie.lastIndex = vW.lastIndex = 0, r, i, o, s = -1, a = [], A = [];
  for (t = t + "", e = e + ""; (r = oie.exec(t)) && (i = vW.exec(e)); )
    (o = i.index) > n && (o = e.slice(n, o), a[s] ? a[s] += o : a[++s] = o), (r = r[0]) === (i = i[0]) ? a[s] ? a[s] += i : a[++s] = i : (a[++s] = null, A.push({ i: s, x: Nh(r, i) })), n = vW.lastIndex;
  return n < e.length && (o = e.slice(n), a[s] ? a[s] += o : a[++s] = o), a.length < 2 ? A[0] ? Lsr(A[0].x) : Nsr(e) : (e = A.length, function(l) {
    for (var c = 0, u; c < e; ++c)
      a[(u = A[c]).i] = u.x(l);
    return a.join("");
  });
}
function HE(t, e) {
  var n = typeof e, r;
  return e == null || n === "boolean" ? Qj(e) : (n === "number" ? Nh : n === "string" ? (r = vN(e)) ? (e = r, iie) : Ott : e instanceof vN ? iie : e instanceof Date ? Ltt : Ttt(e) ? Fhe : Array.isArray(e) ? Ntt : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? Mtt : Nh)(t, e);
}
function Msr(t) {
  var e = t.length;
  return function(n) {
    return t[Math.max(0, Math.min(e - 1, Math.floor(n * e)))];
  };
}
function Osr(t, e) {
  var n = wj(+t, +e);
  return function(r) {
    var i = n(r);
    return i - 360 * Math.floor(i / 360);
  };
}
function AO(t, e) {
  return t = +t, e = +e, function(n) {
    return Math.round(t * (1 - n) + e * n);
  };
}
var $Le = 180 / Math.PI, sie = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function Ftt(t, e, n, r, i, o) {
  var s, a, A;
  return (s = Math.sqrt(t * t + e * e)) && (t /= s, e /= s), (A = t * n + e * r) && (n -= t * A, r -= e * A), (a = Math.sqrt(n * n + r * r)) && (n /= a, r /= a, A /= a), t * r < e * n && (t = -t, e = -e, A = -A, s = -s), {
    translateX: i,
    translateY: o,
    rotate: Math.atan2(e, t) * $Le,
    skewX: Math.atan(A) * $Le,
    scaleX: s,
    scaleY: a
  };
}
var E3;
function Fsr(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? sie : Ftt(e.a, e.b, e.c, e.d, e.e, e.f);
}
function Psr(t) {
  return t == null || (E3 || (E3 = document.createElementNS("http://www.w3.org/2000/svg", "g")), E3.setAttribute("transform", t), !(t = E3.transform.baseVal.consolidate())) ? sie : (t = t.matrix, Ftt(t.a, t.b, t.c, t.d, t.e, t.f));
}
function Ptt(t, e, n, r) {
  function i(l) {
    return l.length ? l.pop() + " " : "";
  }
  function o(l, c, u, f, h, d) {
    if (l !== u || c !== f) {
      var I = h.push("translate(", null, e, null, n);
      d.push({ i: I - 4, x: Nh(l, u) }, { i: I - 2, x: Nh(c, f) });
    } else
      (u || f) && h.push("translate(" + u + e + f + n);
  }
  function s(l, c, u, f) {
    l !== c ? (l - c > 180 ? c += 360 : c - l > 180 && (l += 360), f.push({ i: u.push(i(u) + "rotate(", null, r) - 2, x: Nh(l, c) })) : c && u.push(i(u) + "rotate(" + c + r);
  }
  function a(l, c, u, f) {
    l !== c ? f.push({ i: u.push(i(u) + "skewX(", null, r) - 2, x: Nh(l, c) }) : c && u.push(i(u) + "skewX(" + c + r);
  }
  function A(l, c, u, f, h, d) {
    if (l !== u || c !== f) {
      var I = h.push(i(h) + "scale(", null, ",", null, ")");
      d.push({ i: I - 4, x: Nh(l, u) }, { i: I - 2, x: Nh(c, f) });
    } else
      (u !== 1 || f !== 1) && h.push(i(h) + "scale(" + u + "," + f + ")");
  }
  return function(l, c) {
    var u = [], f = [];
    return l = t(l), c = t(c), o(l.translateX, l.translateY, c.translateX, c.translateY, u, f), s(l.rotate, c.rotate, u, f), a(l.skewX, c.skewX, u, f), A(l.scaleX, l.scaleY, c.scaleX, c.scaleY, u, f), l = c = null, function(h) {
      for (var d = -1, I = f.length, m; ++d < I; )
        u[(m = f[d]).i] = m.x(h);
      return u.join("");
    };
  };
}
var ksr = Ptt(Fsr, "px, ", "px)", "deg)"), Gsr = Ptt(Psr, ", ", ")", ")"), Usr = 1e-12;
function qLe(t) {
  return ((t = Math.exp(t)) + 1 / t) / 2;
}
function Hsr(t) {
  return ((t = Math.exp(t)) - 1 / t) / 2;
}
function $sr(t) {
  return ((t = Math.exp(2 * t)) - 1) / (t + 1);
}
const qsr = function t(e, n, r) {
  function i(o, s) {
    var a = o[0], A = o[1], l = o[2], c = s[0], u = s[1], f = s[2], h = c - a, d = u - A, I = h * h + d * d, m, C;
    if (I < Usr)
      C = Math.log(f / l) / e, m = function(R) {
        return [
          a + R * h,
          A + R * d,
          l * Math.exp(e * R * C)
        ];
      };
    else {
      var y = Math.sqrt(I), v = (f * f - l * l + r * I) / (2 * l * n * y), b = (f * f - l * l - r * I) / (2 * f * n * y), Q = Math.log(Math.sqrt(v * v + 1) - v), w = Math.log(Math.sqrt(b * b + 1) - b);
      C = (w - Q) / e, m = function(R) {
        var M = R * C, O = qLe(Q), L = l / (n * y) * (O * $sr(e * M + Q) - Hsr(Q));
        return [
          a + L * h,
          A + L * d,
          l * O / qLe(e * M + Q)
        ];
      };
    }
    return m.duration = C * 1e3 * e / Math.SQRT2, m;
  }
  return i.rho = function(o) {
    var s = Math.max(1e-3, +o), a = s * s, A = a * a;
    return t(s, a, A);
  }, i;
}(Math.SQRT2, 2, 4);
function ktt(t) {
  return function(e, n) {
    var r = t((e = D5(e)).h, (n = D5(n)).h), i = LA(e.s, n.s), o = LA(e.l, n.l), s = LA(e.opacity, n.opacity);
    return function(a) {
      return e.h = r(a), e.s = i(a), e.l = o(a), e.opacity = s(a), e + "";
    };
  };
}
const jsr = ktt(wj);
var Ysr = ktt(LA);
function zsr(t, e) {
  var n = LA((t = N5(t)).l, (e = N5(e)).l), r = LA(t.a, e.a), i = LA(t.b, e.b), o = LA(t.opacity, e.opacity);
  return function(s) {
    return t.l = n(s), t.a = r(s), t.b = i(s), t.opacity = o(s), t + "";
  };
}
function Gtt(t) {
  return function(e, n) {
    var r = t((e = L5(e)).h, (n = L5(n)).h), i = LA(e.c, n.c), o = LA(e.l, n.l), s = LA(e.opacity, n.opacity);
    return function(a) {
      return e.h = r(a), e.c = i(a), e.l = o(a), e.opacity = s(a), e + "";
    };
  };
}
const Vsr = Gtt(wj);
var Jsr = Gtt(LA);
function Utt(t) {
  return function e(n) {
    n = +n;
    function r(i, o) {
      var s = t((i = rie(i)).h, (o = rie(o)).h), a = LA(i.s, o.s), A = LA(i.l, o.l), l = LA(i.opacity, o.opacity);
      return function(c) {
        return i.h = s(c), i.s = a(c), i.l = A(Math.pow(c, n)), i.opacity = l(c), i + "";
      };
    }
    return r.gamma = e, r;
  }(1);
}
const Ksr = Utt(wj);
var Wsr = Utt(LA);
function Phe(t, e) {
  e === void 0 && (e = t, t = HE);
  for (var n = 0, r = e.length - 1, i = e[0], o = new Array(r < 0 ? 0 : r); n < r; )
    o[n] = t(i, i = e[++n]);
  return function(s) {
    var a = Math.max(0, Math.min(r - 1, Math.floor(s *= r)));
    return o[a](s - a);
  };
}
function Xsr(t, e) {
  for (var n = new Array(e), r = 0; r < e; ++r)
    n[r] = t(r / (e - 1));
  return n;
}
const Zsr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  interpolate: HE,
  interpolateArray: Tsr,
  interpolateBasis: wtt,
  interpolateBasisClosed: xtt,
  interpolateCubehelix: Ksr,
  interpolateCubehelixLong: Wsr,
  interpolateDate: Ltt,
  interpolateDiscrete: Msr,
  interpolateHcl: Vsr,
  interpolateHclLong: Jsr,
  interpolateHsl: jsr,
  interpolateHslLong: Ysr,
  interpolateHue: Osr,
  interpolateLab: zsr,
  interpolateNumber: Nh,
  interpolateNumberArray: Fhe,
  interpolateObject: Mtt,
  interpolateRgb: iie,
  interpolateRgbBasis: Rsr,
  interpolateRgbBasisClosed: Dsr,
  interpolateRound: AO,
  interpolateString: Ott,
  interpolateTransformCss: ksr,
  interpolateTransformSvg: Gsr,
  interpolateZoom: qsr,
  piecewise: Phe,
  quantize: Xsr
}, Symbol.toStringTag, { value: "Module" }));
function ear(t) {
  return function() {
    return t;
  };
}
function aie(t) {
  return +t;
}
var jLe = [0, 1];
function xu(t) {
  return t;
}
function Aie(t, e) {
  return (e -= t = +t) ? function(n) {
    return (n - t) / e;
  } : ear(isNaN(e) ? NaN : 0.5);
}
function tar(t, e) {
  var n;
  return t > e && (n = t, t = e, e = n), function(r) {
    return Math.max(t, Math.min(e, r));
  };
}
function nar(t, e, n) {
  var r = t[0], i = t[1], o = e[0], s = e[1];
  return i < r ? (r = Aie(i, r), o = n(s, o)) : (r = Aie(r, i), o = n(o, s)), function(a) {
    return o(r(a));
  };
}
function rar(t, e, n) {
  var r = Math.min(t.length, e.length) - 1, i = new Array(r), o = new Array(r), s = -1;
  for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++s < r; )
    i[s] = Aie(t[s], t[s + 1]), o[s] = n(e[s], e[s + 1]);
  return function(a) {
    var A = SL(t, a, 1, r) - 1;
    return o[A](i[A](a));
  };
}
function lO(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function xj() {
  var t = jLe, e = jLe, n = HE, r, i, o, s = xu, a, A, l;
  function c() {
    var f = Math.min(t.length, e.length);
    return s !== xu && (s = tar(t[0], t[f - 1])), a = f > 2 ? rar : nar, A = l = null, u;
  }
  function u(f) {
    return f == null || isNaN(f = +f) ? o : (A || (A = a(t.map(r), e, n)))(r(s(f)));
  }
  return u.invert = function(f) {
    return s(i((l || (l = a(e, t.map(r), Nh)))(f)));
  }, u.domain = function(f) {
    return arguments.length ? (t = Array.from(f, aie), c()) : t.slice();
  }, u.range = function(f) {
    return arguments.length ? (e = Array.from(f), c()) : e.slice();
  }, u.rangeRound = function(f) {
    return e = Array.from(f), n = AO, c();
  }, u.clamp = function(f) {
    return arguments.length ? (s = f ? !0 : xu, c()) : s !== xu;
  }, u.interpolate = function(f) {
    return arguments.length ? (n = f, c()) : n;
  }, u.unknown = function(f) {
    return arguments.length ? (o = f, u) : o;
  }, function(f, h) {
    return r = f, i = h, c();
  };
}
function Htt() {
  return xj()(xu, xu);
}
function $tt(t, e, n, r) {
  var i = rU(t, e, n), o;
  switch (r = IB(r ?? ",f"), r.type) {
    case "s": {
      var s = Math.max(Math.abs(t), Math.abs(e));
      return r.precision == null && !isNaN(o = sZe(i, s)) && (r.precision = o), Ege(r, s);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = aZe(i, Math.max(Math.abs(t), Math.abs(e)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = oZe(i)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return cj(r);
}
function _1(t) {
  var e = t.domain;
  return t.ticks = function(n) {
    var r = e();
    return nU(r[0], r[r.length - 1], n ?? 10);
  }, t.tickFormat = function(n, r) {
    var i = e();
    return $tt(i[0], i[i.length - 1], n ?? 10, r);
  }, t.nice = function(n) {
    n == null && (n = 10);
    var r = e(), i = 0, o = r.length - 1, s = r[i], a = r[o], A, l, c = 10;
    for (a < s && (l = s, s = a, a = l, l = i, i = o, o = l); c-- > 0; ) {
      if (l = qae(s, a, n), l === A)
        return r[i] = s, r[o] = a, e(r);
      if (l > 0)
        s = Math.floor(s / l) * l, a = Math.ceil(a / l) * l;
      else if (l < 0)
        s = Math.ceil(s * l) / l, a = Math.floor(a * l) / l;
      else
        break;
      A = l;
    }
    return t;
  }, t;
}
function qtt() {
  var t = Htt();
  return t.copy = function() {
    return lO(t, qtt());
  }, h0.apply(t, arguments), _1(t);
}
function jtt(t) {
  var e;
  function n(r) {
    return r == null || isNaN(r = +r) ? e : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (t = Array.from(r, aie), n) : t.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (e = r, n) : e;
  }, n.copy = function() {
    return jtt(t).unknown(e);
  }, t = arguments.length ? Array.from(t, aie) : [0, 1], _1(n);
}
function Ytt(t, e) {
  t = t.slice();
  var n = 0, r = t.length - 1, i = t[n], o = t[r], s;
  return o < i && (s = n, n = r, r = s, s = i, i = o, o = s), t[n] = e.floor(i), t[r] = e.ceil(o), t;
}
function YLe(t) {
  return Math.log(t);
}
function zLe(t) {
  return Math.exp(t);
}
function iar(t) {
  return -Math.log(-t);
}
function oar(t) {
  return -Math.exp(-t);
}
function sar(t) {
  return isFinite(t) ? +("1e" + t) : t < 0 ? 0 : t;
}
function aar(t) {
  return t === 10 ? sar : t === Math.E ? Math.exp : (e) => Math.pow(t, e);
}
function Aar(t) {
  return t === Math.E ? Math.log : t === 10 && Math.log10 || t === 2 && Math.log2 || (t = Math.log(t), (e) => Math.log(e) / t);
}
function VLe(t) {
  return (e, n) => -t(-e, n);
}
function khe(t) {
  const e = t(YLe, zLe), n = e.domain;
  let r = 10, i, o;
  function s() {
    return i = Aar(r), o = aar(r), n()[0] < 0 ? (i = VLe(i), o = VLe(o), t(iar, oar)) : t(YLe, zLe), e;
  }
  return e.base = function(a) {
    return arguments.length ? (r = +a, s()) : r;
  }, e.domain = function(a) {
    return arguments.length ? (n(a), s()) : n();
  }, e.ticks = (a) => {
    const A = n();
    let l = A[0], c = A[A.length - 1];
    const u = c < l;
    u && ([l, c] = [c, l]);
    let f = i(l), h = i(c), d, I;
    const m = a == null ? 10 : +a;
    let C = [];
    if (!(r % 1) && h - f < m) {
      if (f = Math.floor(f), h = Math.ceil(h), l > 0) {
        for (; f <= h; ++f)
          for (d = 1; d < r; ++d)
            if (I = f < 0 ? d / o(-f) : d * o(f), !(I < l)) {
              if (I > c)
                break;
              C.push(I);
            }
      } else
        for (; f <= h; ++f)
          for (d = r - 1; d >= 1; --d)
            if (I = f > 0 ? d / o(-f) : d * o(f), !(I < l)) {
              if (I > c)
                break;
              C.push(I);
            }
      C.length * 2 < m && (C = nU(l, c, m));
    } else
      C = nU(f, h, Math.min(h - f, m)).map(o);
    return u ? C.reverse() : C;
  }, e.tickFormat = (a, A) => {
    if (a == null && (a = 10), A == null && (A = r === 10 ? "s" : ","), typeof A != "function" && (!(r % 1) && (A = IB(A)).precision == null && (A.trim = !0), A = cj(A)), a === 1 / 0)
      return A;
    const l = Math.max(1, r * a / e.ticks().length);
    return (c) => {
      let u = c / o(Math.round(i(c)));
      return u * r < r - 0.5 && (u *= r), u <= l ? A(c) : "";
    };
  }, e.nice = () => n(Ytt(n(), {
    floor: (a) => o(Math.floor(i(a))),
    ceil: (a) => o(Math.ceil(i(a)))
  })), e;
}
function ztt() {
  const t = khe(xj()).domain([1, 10]);
  return t.copy = () => lO(t, ztt()).base(t.base()), h0.apply(t, arguments), t;
}
function JLe(t) {
  return function(e) {
    return Math.sign(e) * Math.log1p(Math.abs(e / t));
  };
}
function KLe(t) {
  return function(e) {
    return Math.sign(e) * Math.expm1(Math.abs(e)) * t;
  };
}
function Ghe(t) {
  var e = 1, n = t(JLe(e), KLe(e));
  return n.constant = function(r) {
    return arguments.length ? t(JLe(e = +r), KLe(e)) : e;
  }, _1(n);
}
function Vtt() {
  var t = Ghe(xj());
  return t.copy = function() {
    return lO(t, Vtt()).constant(t.constant());
  }, h0.apply(t, arguments);
}
function WLe(t) {
  return function(e) {
    return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
  };
}
function lar(t) {
  return t < 0 ? -Math.sqrt(-t) : Math.sqrt(t);
}
function car(t) {
  return t < 0 ? -t * t : t * t;
}
function Uhe(t) {
  var e = t(xu, xu), n = 1;
  function r() {
    return n === 1 ? t(xu, xu) : n === 0.5 ? t(lar, car) : t(WLe(n), WLe(1 / n));
  }
  return e.exponent = function(i) {
    return arguments.length ? (n = +i, r()) : n;
  }, _1(e);
}
function Hhe() {
  var t = Uhe(xj());
  return t.copy = function() {
    return lO(t, Hhe()).exponent(t.exponent());
  }, h0.apply(t, arguments), t;
}
function uar() {
  return Hhe.apply(null, arguments).exponent(0.5);
}
function Jtt() {
  var t = [], e = [], n = [], r;
  function i() {
    var s = 0, a = Math.max(1, e.length);
    for (n = new Array(a - 1); ++s < a; )
      n[s - 1] = Skt(t, s / a);
    return o;
  }
  function o(s) {
    return s == null || isNaN(s = +s) ? r : e[SL(n, s)];
  }
  return o.invertExtent = function(s) {
    var a = e.indexOf(s);
    return a < 0 ? [NaN, NaN] : [
      a > 0 ? n[a - 1] : t[0],
      a < n.length ? n[a] : t[t.length - 1]
    ];
  }, o.domain = function(s) {
    if (!arguments.length)
      return t.slice();
    t = [];
    for (let a of s)
      a != null && !isNaN(a = +a) && t.push(a);
    return t.sort(Hae), i();
  }, o.range = function(s) {
    return arguments.length ? (e = Array.from(s), i()) : e.slice();
  }, o.unknown = function(s) {
    return arguments.length ? (r = s, o) : r;
  }, o.quantiles = function() {
    return n.slice();
  }, o.copy = function() {
    return Jtt().domain(t).range(e).unknown(r);
  }, h0.apply(o, arguments);
}
function Ktt() {
  var t = 0, e = 1, n = 1, r = [0.5], i = [0, 1], o;
  function s(A) {
    return A != null && A <= A ? i[SL(r, A, 0, n)] : o;
  }
  function a() {
    var A = -1;
    for (r = new Array(n); ++A < n; )
      r[A] = ((A + 1) * e - (A - n) * t) / (n + 1);
    return s;
  }
  return s.domain = function(A) {
    return arguments.length ? ([t, e] = A, t = +t, e = +e, a()) : [t, e];
  }, s.range = function(A) {
    return arguments.length ? (n = (i = Array.from(A)).length - 1, a()) : i.slice();
  }, s.invertExtent = function(A) {
    var l = i.indexOf(A);
    return l < 0 ? [NaN, NaN] : l < 1 ? [t, r[0]] : l >= n ? [r[n - 1], e] : [r[l - 1], r[l]];
  }, s.unknown = function(A) {
    return arguments.length && (o = A), s;
  }, s.thresholds = function() {
    return r.slice();
  }, s.copy = function() {
    return Ktt().domain([t, e]).range(i).unknown(o);
  }, h0.apply(_1(s), arguments);
}
function Wtt() {
  var t = [0.5], e = [0, 1], n, r = 1;
  function i(o) {
    return o != null && o <= o ? e[SL(t, o, 0, r)] : n;
  }
  return i.domain = function(o) {
    return arguments.length ? (t = Array.from(o), r = Math.min(t.length, e.length - 1), i) : t.slice();
  }, i.range = function(o) {
    return arguments.length ? (e = Array.from(o), r = Math.min(t.length, e.length - 1), i) : e.slice();
  }, i.invertExtent = function(o) {
    var s = e.indexOf(o);
    return [t[s - 1], t[s]];
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.copy = function() {
    return Wtt().domain(t).range(e).unknown(n);
  }, h0.apply(i, arguments);
}
function far(t) {
  return new Date(t);
}
function gar(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function $he(t, e, n, r, i, o, s, a, A, l) {
  var c = Htt(), u = c.invert, f = c.domain, h = l(".%L"), d = l(":%S"), I = l("%I:%M"), m = l("%I %p"), C = l("%a %d"), y = l("%b %d"), v = l("%B"), b = l("%Y");
  function Q(w) {
    return (A(w) < w ? h : a(w) < w ? d : s(w) < w ? I : o(w) < w ? m : r(w) < w ? i(w) < w ? C : y : n(w) < w ? v : b)(w);
  }
  return c.invert = function(w) {
    return new Date(u(w));
  }, c.domain = function(w) {
    return arguments.length ? f(Array.from(w, gar)) : f().map(far);
  }, c.ticks = function(w) {
    var R = f();
    return t(R[0], R[R.length - 1], w ?? 10);
  }, c.tickFormat = function(w, R) {
    return R == null ? Q : l(R);
  }, c.nice = function(w) {
    var R = f();
    return (!w || typeof w.range != "function") && (w = e(R[0], R[R.length - 1], w ?? 10)), w ? f(Ytt(R, w)) : c;
  }, c.copy = function() {
    return lO(c, $he(t, e, n, r, i, o, s, a, A, l));
  }, c;
}
function har() {
  return h0.apply($he(Enr, ynr, tE, y5, dx, MC, bge, Bge, dC, Tge).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function dar() {
  return h0.apply($he(mnr, Cnr, nE, B5, px, OC, Qge, Sge, dC, Nge).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function Rj() {
  var t = 0, e = 1, n, r, i, o, s = xu, a = !1, A;
  function l(u) {
    return u == null || isNaN(u = +u) ? A : s(i === 0 ? 0.5 : (u = (o(u) - n) * i, a ? Math.max(0, Math.min(1, u)) : u));
  }
  l.domain = function(u) {
    return arguments.length ? ([t, e] = u, n = o(t = +t), r = o(e = +e), i = n === r ? 0 : 1 / (r - n), l) : [t, e];
  }, l.clamp = function(u) {
    return arguments.length ? (a = !!u, l) : a;
  }, l.interpolator = function(u) {
    return arguments.length ? (s = u, l) : s;
  };
  function c(u) {
    return function(f) {
      var h, d;
      return arguments.length ? ([h, d] = f, s = u(h, d), l) : [s(0), s(1)];
    };
  }
  return l.range = c(HE), l.rangeRound = c(AO), l.unknown = function(u) {
    return arguments.length ? (A = u, l) : A;
  }, function(u) {
    return o = u, n = u(t), r = u(e), i = n === r ? 0 : 1 / (r - n), l;
  };
}
function $E(t, e) {
  return e.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown());
}
function qhe() {
  var t = _1(Rj()(xu));
  return t.copy = function() {
    return $E(t, qhe());
  }, GE.apply(t, arguments);
}
function Xtt() {
  var t = khe(Rj()).domain([1, 10]);
  return t.copy = function() {
    return $E(t, Xtt()).base(t.base());
  }, GE.apply(t, arguments);
}
function Ztt() {
  var t = Ghe(Rj());
  return t.copy = function() {
    return $E(t, Ztt()).constant(t.constant());
  }, GE.apply(t, arguments);
}
function jhe() {
  var t = Uhe(Rj());
  return t.copy = function() {
    return $E(t, jhe()).exponent(t.exponent());
  }, GE.apply(t, arguments);
}
function par() {
  return jhe.apply(null, arguments).exponent(0.5);
}
function Dj() {
  var t = 0, e = 0.5, n = 1, r = 1, i, o, s, a, A, l = xu, c, u = !1, f;
  function h(I) {
    return isNaN(I = +I) ? f : (I = 0.5 + ((I = +c(I)) - o) * (r * I < r * o ? a : A), l(u ? Math.max(0, Math.min(1, I)) : I));
  }
  h.domain = function(I) {
    return arguments.length ? ([t, e, n] = I, i = c(t = +t), o = c(e = +e), s = c(n = +n), a = i === o ? 0 : 0.5 / (o - i), A = o === s ? 0 : 0.5 / (s - o), r = o < i ? -1 : 1, h) : [t, e, n];
  }, h.clamp = function(I) {
    return arguments.length ? (u = !!I, h) : u;
  }, h.interpolator = function(I) {
    return arguments.length ? (l = I, h) : l;
  };
  function d(I) {
    return function(m) {
      var C, y, v;
      return arguments.length ? ([C, y, v] = m, l = Phe(I, [C, y, v]), h) : [l(0), l(0.5), l(1)];
    };
  }
  return h.range = d(HE), h.rangeRound = d(AO), h.unknown = function(I) {
    return arguments.length ? (f = I, h) : f;
  }, function(I) {
    return c = I, i = I(t), o = I(e), s = I(n), a = i === o ? 0 : 0.5 / (o - i), A = o === s ? 0 : 0.5 / (s - o), r = o < i ? -1 : 1, h;
  };
}
function ent() {
  var t = _1(Dj()(xu));
  return t.copy = function() {
    return $E(t, ent());
  }, GE.apply(t, arguments);
}
function tnt() {
  var t = khe(Dj()).domain([0.1, 1, 10]);
  return t.copy = function() {
    return $E(t, tnt()).base(t.base());
  }, GE.apply(t, arguments);
}
function nnt() {
  var t = Ghe(Dj());
  return t.copy = function() {
    return $E(t, nnt()).constant(t.constant());
  }, GE.apply(t, arguments);
}
function Yhe() {
  var t = Uhe(Dj());
  return t.copy = function() {
    return $E(t, Yhe()).exponent(t.exponent());
  }, GE.apply(t, arguments);
}
function Iar() {
  return Yhe.apply(null, arguments).exponent(0.5);
}
function zhe(t, e, n) {
  const r = t - e + n * 2;
  return t ? r > 0 ? r : 1 : 0;
}
const mar = "identity", EQ = "linear", kI = "log", cO = "pow", uO = "sqrt", Tj = "symlog", EB = "time", yB = "utc", Fp = "sequential", yx = "diverging", yQ = "quantile", Nj = "quantize", Lj = "threshold", Vhe = "ordinal", lie = "point", rnt = "band", Jhe = "bin-ordinal", CA = "continuous", fO = "discrete", gO = "discretizing", Xg = "interpolating", Khe = "temporal";
function Car(t) {
  return function(e) {
    let n = e[0], r = e[1], i;
    return r < n && (i = n, n = r, r = i), [t.invert(n), t.invert(r)];
  };
}
function Ear(t) {
  return function(e) {
    const n = t.range();
    let r = e[0], i = e[1], o = -1, s, a, A, l;
    for (i < r && (a = r, r = i, i = a), A = 0, l = n.length; A < l; ++A)
      n[A] >= r && n[A] <= i && (o < 0 && (o = A), s = A);
    if (!(o < 0))
      return r = t.invertExtent(n[o]), i = t.invertExtent(n[s]), [r[0] === void 0 ? r[1] : r[0], i[1] === void 0 ? i[0] : i[1]];
  };
}
function Whe() {
  const t = Nhe().unknown(void 0), e = t.domain, n = t.range;
  let r = [0, 1], i, o, s = !1, a = 0, A = 0, l = 0.5;
  delete t.unknown;
  function c() {
    const u = e().length, f = r[1] < r[0], h = r[1 - f], d = zhe(u, a, A);
    let I = r[f - 0];
    i = (h - I) / (d || 1), s && (i = Math.floor(i)), I += (h - I - i * (u - a)) * l, o = i * (1 - a), s && (I = Math.round(I), o = Math.round(o));
    const m = E1(u).map((C) => I + i * C);
    return n(f ? m.reverse() : m);
  }
  return t.domain = function(u) {
    return arguments.length ? (e(u), c()) : e();
  }, t.range = function(u) {
    return arguments.length ? (r = [+u[0], +u[1]], c()) : r.slice();
  }, t.rangeRound = function(u) {
    return r = [+u[0], +u[1]], s = !0, c();
  }, t.bandwidth = function() {
    return o;
  }, t.step = function() {
    return i;
  }, t.round = function(u) {
    return arguments.length ? (s = !!u, c()) : s;
  }, t.padding = function(u) {
    return arguments.length ? (A = Math.max(0, Math.min(1, u)), a = A, c()) : a;
  }, t.paddingInner = function(u) {
    return arguments.length ? (a = Math.max(0, Math.min(1, u)), c()) : a;
  }, t.paddingOuter = function(u) {
    return arguments.length ? (A = Math.max(0, Math.min(1, u)), c()) : A;
  }, t.align = function(u) {
    return arguments.length ? (l = Math.max(0, Math.min(1, u)), c()) : l;
  }, t.invertRange = function(u) {
    if (u[0] == null || u[1] == null)
      return;
    const f = r[1] < r[0], h = f ? n().reverse() : n(), d = h.length - 1;
    let I = +u[0], m = +u[1], C, y, v;
    if (!(I !== I || m !== m) && (m < I && (v = I, I = m, m = v), !(m < h[0] || I > r[1 - f])))
      return C = Math.max(0, I5(h, I) - 1), y = I === m ? C : I5(h, m) - 1, I - h[C] > o + 1e-10 && ++C, f && (v = C, C = d - y, y = d - v), C > y ? void 0 : e().slice(C, y + 1);
  }, t.invert = function(u) {
    const f = t.invertRange([u, u]);
    return f && f[0];
  }, t.copy = function() {
    return Whe().domain(e()).range(r).round(s).paddingInner(a).paddingOuter(A).align(l);
  }, c();
}
function int(t) {
  const e = t.copy;
  return t.padding = t.paddingOuter, delete t.paddingInner, t.copy = function() {
    return int(e());
  }, t;
}
function yar() {
  return int(Whe().paddingInner(1));
}
var Bar = Array.prototype.map;
function bar(t) {
  return Bar.call(t, Kl);
}
const _ar = Array.prototype.slice;
function ont() {
  let t = [], e = [];
  function n(r) {
    return r == null || r !== r ? void 0 : e[(ztr(t, r) - 1) % e.length];
  }
  return n.domain = function(r) {
    return arguments.length ? (t = bar(r), n) : t.slice();
  }, n.range = function(r) {
    return arguments.length ? (e = _ar.call(r), n) : e.slice();
  }, n.tickFormat = function(r, i) {
    return $tt(t[0], bi(t), r ?? 10, i);
  }, n.copy = function() {
    return ont().domain(n.domain()).range(n.range());
  }, n;
}
const M5 = {};
function Sar(t, e, n) {
  const r = function() {
    const o = e();
    return o.invertRange || (o.invertRange = o.invert ? Car(o) : o.invertExtent ? Ear(o) : void 0), o.type = t, o;
  };
  return r.metadata = pd(bn(n)), r;
}
function Vi(t, e, n) {
  return arguments.length > 1 ? (M5[t] = Sar(t, e, n), this) : snt(t) ? M5[t] : void 0;
}
Vi(mar, jtt);
Vi(EQ, qtt, CA);
Vi(kI, ztt, [CA, kI]);
Vi(cO, Hhe, CA);
Vi(uO, uar, CA);
Vi(Tj, Vtt, CA);
Vi(EB, har, [CA, Khe]);
Vi(yB, dar, [CA, Khe]);
Vi(Fp, qhe, [CA, Xg]);
Vi("".concat(Fp, "-").concat(EQ), qhe, [CA, Xg]);
Vi("".concat(Fp, "-").concat(kI), Xtt, [CA, Xg, kI]);
Vi("".concat(Fp, "-").concat(cO), jhe, [CA, Xg]);
Vi("".concat(Fp, "-").concat(uO), par, [CA, Xg]);
Vi("".concat(Fp, "-").concat(Tj), Ztt, [CA, Xg]);
Vi("".concat(yx, "-").concat(EQ), ent, [CA, Xg]);
Vi("".concat(yx, "-").concat(kI), tnt, [CA, Xg, kI]);
Vi("".concat(yx, "-").concat(cO), Yhe, [CA, Xg]);
Vi("".concat(yx, "-").concat(uO), Iar, [CA, Xg]);
Vi("".concat(yx, "-").concat(Tj), nnt, [CA, Xg]);
Vi(yQ, Jtt, [gO, yQ]);
Vi(Nj, Ktt, gO);
Vi(Lj, Wtt, gO);
Vi(Jhe, ont, [fO, gO]);
Vi(Vhe, Nhe, fO);
Vi(rnt, Whe, fO);
Vi(lie, yar, fO);
function snt(t) {
  return Kn(M5, t);
}
function S1(t, e) {
  const n = M5[t];
  return n && n.metadata[e];
}
function Xhe(t) {
  return S1(t, CA);
}
function vQ(t) {
  return S1(t, fO);
}
function cie(t) {
  return S1(t, gO);
}
function ant(t) {
  return S1(t, kI);
}
function Qar(t) {
  return S1(t, Khe);
}
function Ant(t) {
  return S1(t, Xg);
}
function lnt(t) {
  return S1(t, yQ);
}
const war = ["clamp", "base", "constant", "exponent"];
function cnt(t, e) {
  const n = e[0], r = bi(e) - n;
  return function(i) {
    return t(n + i * r);
  };
}
function Mj(t, e, n) {
  return Phe(Zhe(e || "rgb", n), t);
}
function unt(t, e) {
  const n = new Array(e), r = e + 1;
  for (let i = 0; i < e; )
    n[i] = t(++i / r);
  return n;
}
function fnt(t, e, n) {
  const r = n - e;
  let i, o, s;
  return !r || !Number.isFinite(r) ? lc(0.5) : (i = (o = t.type).indexOf("-"), o = i < 0 ? o : o.slice(i + 1), s = Vi(o)().domain([e, n]).range([0, 1]), war.forEach((a) => t[a] ? s[a](t[a]()) : 0), s);
}
function Zhe(t, e) {
  const n = Zsr[xar(t)];
  return e != null && n && n.gamma ? n.gamma(e) : n;
}
function xar(t) {
  return "interpolate" + t.toLowerCase().split("-").map((e) => e[0].toUpperCase() + e.slice(1)).join("");
}
const Rar = {
  blues: "cfe1f2bed8eca8cee58fc1de74b2d75ba3cf4592c63181bd206fb2125ca40a4a90",
  greens: "d3eecdc0e6baabdda594d3917bc77d60ba6c46ab5e329a512089430e7735036429",
  greys: "e2e2e2d4d4d4c4c4c4b1b1b19d9d9d8888887575756262624d4d4d3535351e1e1e",
  oranges: "fdd8b3fdc998fdb87bfda55efc9244f87f2cf06b18e4580bd14904b93d029f3303",
  purples: "e2e1efd4d4e8c4c5e0b4b3d6a3a0cc928ec3827cb97566ae684ea25c3696501f8c",
  reds: "fdc9b4fcb49afc9e80fc8767fa7051f6573fec3f2fdc2a25c81b1db21218970b13",
  blueGreen: "d5efedc1e8e0a7ddd18bd2be70c6a958ba9144ad77319c5d2089460e7736036429",
  bluePurple: "ccddecbad0e4a8c2dd9ab0d4919cc98d85be8b6db28a55a6873c99822287730f71",
  greenBlue: "d3eecec5e8c3b1e1bb9bd8bb82cec269c2ca51b2cd3c9fc7288abd1675b10b60a1",
  orangeRed: "fddcaffdcf9bfdc18afdad77fb9562f67d53ee6545e24932d32d1ebf130da70403",
  purpleBlue: "dbdaebc8cee4b1c3de97b7d87bacd15b9fc93a90c01e7fb70b70ab056199045281",
  purpleBlueGreen: "dbd8eac8cee4b0c3de93b7d872acd1549fc83892bb1c88a3097f8702736b016353",
  purpleRed: "dcc9e2d3b3d7ce9eccd186c0da6bb2e14da0e23189d91e6fc61159ab07498f023a",
  redPurple: "fccfccfcbec0faa9b8f98faff571a5ec539ddb3695c41b8aa908808d0179700174",
  yellowGreen: "e4f4acd1eca0b9e2949ed68880c97c62bb6e47aa5e3297502083440e723b036034",
  yellowOrangeBrown: "feeaa1fedd84fecc63feb746fca031f68921eb7215db5e0bc54c05ab3d038f3204",
  yellowOrangeRed: "fee087fed16ffebd59fea849fd903efc7335f9522bee3423de1b20ca0b22af0225",
  blueOrange: "134b852f78b35da2cb9dcae1d2e5eff2f0ebfce0bafbbf74e8932fc5690d994a07",
  brownBlueGreen: "704108a0651ac79548e3c78af3e6c6eef1eac9e9e48ed1c74da79e187a72025147",
  purpleGreen: "5b1667834792a67fb6c9aed3e6d6e8eff0efd9efd5aedda971bb75368e490e5e29",
  purpleOrange: "4114696647968f83b7b9b4d6dadbebf3eeeafce0bafbbf74e8932fc5690d994a07",
  redBlue: "8c0d25bf363adf745ef4ae91fbdbc9f2efeed2e5ef9dcae15da2cb2f78b3134b85",
  redGrey: "8c0d25bf363adf745ef4ae91fcdccbfaf4f1e2e2e2c0c0c0969696646464343434",
  yellowGreenBlue: "eff9bddbf1b4bde5b594d5b969c5be45b4c22c9ec02182b82163aa23479c1c3185",
  redYellowBlue: "a50026d4322cf16e43fcac64fedd90faf8c1dcf1ecabd6e875abd04a74b4313695",
  redYellowGreen: "a50026d4322cf16e43fcac63fedd8df9f7aed7ee8ea4d86e64bc6122964f006837",
  pinkYellowGreen: "8e0152c0267edd72adf0b3d6faddedf5f3efe1f2cab6de8780bb474f9125276419",
  spectral: "9e0142d13c4bf0704afcac63fedd8dfbf8b0e0f3a1a9dda269bda94288b55e4fa2",
  viridis: "440154470e61481a6c482575472f7d443a834144873d4e8a39568c35608d31688e2d708e2a788e27818e23888e21918d1f988b1fa08822a8842ab07f35b77943bf7154c56866cc5d7ad1518fd744a5db36bcdf27d2e21be9e51afde725",
  magma: "0000040404130b0924150e3720114b2c11603b0f704a107957157e651a80721f817f24828c29819a2e80a8327db6377ac43c75d1426fde4968e95462f1605df76f5cfa7f5efc8f65fe9f6dfeaf78febf84fece91fddea0fcedaffcfdbf",
  inferno: "0000040403130c0826170c3b240c4f330a5f420a68500d6c5d126e6b176e781c6d86216b932667a12b62ae305cbb3755c73e4cd24644dd513ae65c30ed6925f3771af8850ffb9506fca50afcb519fac62df6d645f2e661f3f484fcffa4",
  plasma: "0d088723069033059742039d5002a25d01a66a00a87801a88405a7900da49c179ea72198b12a90ba3488c33d80cb4779d35171da5a69e16462e76e5bed7953f2834cf68f44fa9a3dfca636fdb32ffec029fcce25f9dc24f5ea27f0f921",
  cividis: "00205100235800265d002961012b65042e670831690d346b11366c16396d1c3c6e213f6e26426e2c456e31476e374a6e3c4d6e42506e47536d4c566d51586e555b6e5a5e6e5e616e62646f66676f6a6a706e6d717270717573727976737c79747f7c75827f758682768985778c8877908b78938e789691789a94789e9778a19b78a59e77a9a177aea575b2a874b6ab73bbaf71c0b26fc5b66dc9b96acebd68d3c065d8c462ddc85fe2cb5ce7cf58ebd355f0d652f3da4ff7de4cfae249fce647",
  rainbow: "6e40aa883eb1a43db3bf3cafd83fa4ee4395fe4b83ff576eff6659ff7847ff8c38f3a130e2b72fcfcc36bee044aff05b8ff4576ff65b52f6673af27828ea8d1ddfa319d0b81cbecb23abd82f96e03d82e14c6edb5a5dd0664dbf6e40aa",
  sinebow: "ff4040fc582af47218e78d0bd5a703bfbf00a7d5038de70b72f41858fc2a40ff402afc5818f4720be78d03d5a700bfbf03a7d50b8de71872f42a58fc4040ff582afc7218f48d0be7a703d5bf00bfd503a7e70b8df41872fc2a58ff4040",
  turbo: "23171b32204a3e2a71453493493eae4b49c54a53d7485ee44569ee4074f53c7ff8378af93295f72e9ff42ba9ef28b3e926bce125c5d925cdcf27d5c629dcbc2de3b232e9a738ee9d3ff39347f68950f9805afc7765fd6e70fe667cfd5e88fc5795fb51a1f84badf545b9f140c5ec3cd0e637dae034e4d931ecd12ef4c92bfac029ffb626ffad24ffa223ff9821ff8d1fff821dff771cfd6c1af76118f05616e84b14df4111d5380fcb2f0dc0260ab61f07ac1805a313029b0f00950c00910b00",
  browns: "eedbbdecca96e9b97ae4a865dc9856d18954c7784cc0673fb85536ad44339f3632",
  tealBlues: "bce4d89dd3d181c3cb65b3c245a2b9368fae347da0306a932c5985",
  teals: "bbdfdfa2d4d58ac9c975bcbb61b0af4da5a43799982b8b8c1e7f7f127273006667",
  warmGreys: "dcd4d0cec5c1c0b8b4b3aaa7a59c9998908c8b827f7e7673726866665c5a59504e",
  goldGreen: "f4d166d5ca60b6c35c98bb597cb25760a6564b9c533f8f4f33834a257740146c36",
  goldOrange: "f4d166f8be5cf8aa4cf5983bf3852aef701be2621fd65322c54923b142239e3a26",
  goldRed: "f4d166f6be59f9aa51fc964ef6834bee734ae56249db5247cf4244c43141b71d3e",
  lightGreyRed: "efe9e6e1dad7d5cbc8c8bdb9bbaea9cd967ddc7b43e15f19df4011dc000b",
  lightGreyTeal: "e4eaead6dcddc8ced2b7c2c7a6b4bc64b0bf22a6c32295c11f85be1876bc",
  lightMulti: "e0f1f2c4e9d0b0de9fd0e181f6e072f6c053f3993ef77440ef4a3c",
  lightOrange: "f2e7daf7d5baf9c499fab184fa9c73f68967ef7860e8645bde515bd43d5b",
  lightTealBlue: "e3e9e0c0dccf9aceca7abfc859afc0389fb9328dad2f7ca0276b95255988",
  darkBlue: "3232322d46681a5c930074af008cbf05a7ce25c0dd38daed50f3faffffff",
  darkGold: "3c3c3c584b37725e348c7631ae8b2bcfa424ecc31ef9de30fff184ffffff",
  darkGreen: "3a3a3a215748006f4d048942489e4276b340a6c63dd2d836ffeb2cffffaa",
  darkMulti: "3737371f5287197d8c29a86995ce3fffe800ffffff",
  darkRed: "3434347036339e3c38cc4037e75d1eec8620eeab29f0ce32ffeb2c"
}, Dar = {
  category10: "1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf",
  category20: "1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5",
  category20b: "393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6",
  category20c: "3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9",
  tableau10: "4c78a8f58518e4575672b7b254a24beeca3bb279a2ff9da69d755dbab0ac",
  tableau20: "4c78a89ecae9f58518ffbf7954a24b88d27ab79a20f2cf5b43989483bcb6e45756ff9d9879706ebab0acd67195fcbfd2b279a2d6a5c99e765fd8b5a5",
  accent: "7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666",
  dark2: "1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666",
  paired: "a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928",
  pastel1: "fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2",
  pastel2: "b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc",
  set1: "e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999",
  set2: "66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3",
  set3: "8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"
};
function gnt(t) {
  const e = t.length / 6 | 0, n = new Array(e);
  for (let r = 0; r < e; )
    n[r] = "#" + t.slice(r * 6, ++r * 6);
  return n;
}
function hnt(t, e) {
  for (const n in t)
    ede(n, e(t[n]));
}
const XLe = {};
hnt(Dar, gnt);
hnt(Rar, (t) => Mj(gnt(t)));
function ede(t, e) {
  return t = t && t.toLowerCase(), arguments.length > 1 ? (XLe[t] = e, this) : XLe[t];
}
const JG = "symbol", Tar = "discrete", Nar = "gradient", Lar = (t) => Nt(t) ? t.map((e) => String(e)) : String(t), Mar = (t, e) => t[1] - e[1], Oar = (t, e) => e[1] - t[1];
function tde(t, e, n) {
  let r;
  return Po(e) && (t.bins && (e = Math.max(e, t.bins.length)), n != null && (e = Math.min(e, Math.floor(rO(t.domain()) / n || 1)))), _n(e) && (r = e.step, e = e.interval), Cn(e) && (e = t.type === EB ? Ix(e) : t.type == yB ? mx(e) : wt("Only time and utc scales accept interval strings."), r && (e = e.every(r))), e;
}
function dnt(t, e, n) {
  let r = t.range(), i = r[0], o = bi(r), s = Mar;
  if (i > o && (r = o, o = i, i = r, s = Oar), i = Math.floor(i), o = Math.ceil(o), e = e.map((a) => [a, t(a)]).filter((a) => i <= a[1] && a[1] <= o).sort(s).map((a) => a[0]), n > 0 && e.length > 1) {
    const a = [e[0], bi(e)];
    for (; e.length > n && e.length >= 3; )
      e = e.filter((A, l) => !(l % 2));
    e.length < 3 && (e = a);
  }
  return e;
}
function nde(t, e) {
  return t.bins ? dnt(t, t.bins) : t.ticks ? t.ticks(e) : t.domain();
}
function pnt(t, e, n, r, i, o) {
  const s = e.type;
  let a = Lar;
  if (s === EB || i === EB)
    a = t.timeFormat(r);
  else if (s === yB || i === yB)
    a = t.utcFormat(r);
  else if (ant(s)) {
    const A = t.formatFloat(r);
    if (o || e.bins)
      a = A;
    else {
      const l = Int(e, n, !1);
      a = (c) => l(c) ? A(c) : "";
    }
  } else if (e.tickFormat) {
    const A = e.domain();
    a = t.formatSpan(A[0], A[A.length - 1], n, r);
  } else
    r && (a = t.format(r));
  return a;
}
function Int(t, e, n) {
  const r = nde(t, e), i = t.base(), o = Math.log(i), s = Math.max(1, i * e / r.length), a = (A) => {
    let l = A / Math.pow(i, Math.round(Math.log(A) / o));
    return l * i < i - 0.5 && (l *= i), l <= s;
  };
  return n ? r.filter(a) : a;
}
const uie = {
  [yQ]: "quantiles",
  [Nj]: "thresholds",
  [Lj]: "domain"
}, mnt = {
  [yQ]: "quantiles",
  [Nj]: "domain"
};
function Cnt(t, e) {
  return t.bins ? kar(t.bins) : t.type === kI ? Int(t, e, !0) : uie[t.type] ? Par(t[uie[t.type]]()) : nde(t, e);
}
function Far(t, e, n) {
  const r = e[mnt[e.type]](), i = r.length;
  let o = i > 1 ? r[1] - r[0] : r[0], s;
  for (s = 1; s < i; ++s)
    o = Math.min(o, r[s] - r[s - 1]);
  return t.formatSpan(0, o, 3 * 10, n);
}
function Par(t) {
  const e = [-1 / 0].concat(t);
  return e.max = 1 / 0, e;
}
function kar(t) {
  const e = t.slice(0, -1);
  return e.max = bi(t), e;
}
const Gar = (t) => uie[t.type] || t.bins;
function Ent(t, e, n, r, i, o, s) {
  const a = mnt[e.type] && o !== EB && o !== yB ? Far(t, e, i) : pnt(t, e, n, i, o, s);
  return r === JG && Gar(e) ? Uar(a) : r === Tar ? Har(a) : $ar(a);
}
const Uar = (t) => (e, n, r) => {
  const i = ZLe(r[n + 1], ZLe(r.max, 1 / 0)), o = eMe(e, t), s = eMe(i, t);
  return o && s ? o + " – " + s : s ? "< " + s : "≥ " + o;
}, ZLe = (t, e) => t ?? e, Har = (t) => (e, n) => n ? t(e) : null, $ar = (t) => (e) => t(e), eMe = (t, e) => Number.isFinite(t) ? e(t) : null;
function qar(t) {
  const e = t.domain(), n = e.length - 1;
  let r = +e[0], i = +bi(e), o = i - r;
  if (t.type === Lj) {
    const s = n ? o / n : 0.1;
    r -= s, i += s, o = i - r;
  }
  return (s) => (s - r) / o;
}
function jar(t, e, n, r) {
  const i = r || e.type;
  return Cn(n) && Qar(i) && (n = n.replace(/%a/g, "%A").replace(/%b/g, "%B")), !n && i === EB ? t.timeFormat("%A, %d %B %Y, %X") : !n && i === yB ? t.utcFormat("%A, %d %B %Y, %X UTC") : Ent(t, e, 5, null, n, r, !0);
}
function ynt(t, e, n) {
  n = n || {};
  const r = Math.max(3, n.maxlen || 7), i = jar(t, e, n.format, n.formatType);
  if (cie(e.type)) {
    const o = Cnt(e).slice(1).map(i), s = o.length;
    return "".concat(s, " boundar").concat(s === 1 ? "y" : "ies", ": ").concat(o.join(", "));
  } else if (vQ(e.type)) {
    const o = e.domain(), s = o.length, a = s > r ? o.slice(0, r - 2).map(i).join(", ") + ", ending with " + o.slice(-1).map(i) : o.map(i).join(", ");
    return "".concat(s, " value").concat(s === 1 ? "" : "s", ": ").concat(a);
  } else {
    const o = e.domain();
    return "values from ".concat(i(o[0]), " to ").concat(i(bi(o)));
  }
}
let vnt = 0;
function Yar() {
  vnt = 0;
}
const O5 = "p_";
function rde(t) {
  return t && t.gradient;
}
function Bnt(t, e, n) {
  const r = t.gradient;
  let i = t.id, o = r === "radial" ? O5 : "";
  return i || (i = t.id = "gradient_" + vnt++, r === "radial" ? (t.x1 = rp(t.x1, 0.5), t.y1 = rp(t.y1, 0.5), t.r1 = rp(t.r1, 0), t.x2 = rp(t.x2, 0.5), t.y2 = rp(t.y2, 0.5), t.r2 = rp(t.r2, 0.5), o = O5) : (t.x1 = rp(t.x1, 0), t.y1 = rp(t.y1, 0), t.x2 = rp(t.x2, 1), t.y2 = rp(t.y2, 0))), e[i] = t, "url(" + (n || "") + "#" + o + i + ")";
}
function rp(t, e) {
  return t ?? e;
}
function bnt(t, e) {
  var n = [], r;
  return r = {
    gradient: "linear",
    x1: t ? t[0] : 0,
    y1: t ? t[1] : 0,
    x2: e ? e[0] : 1,
    y2: e ? e[1] : 0,
    stops: n,
    stop: function(i, o) {
      return n.push({
        offset: i,
        color: o
      }), r;
    }
  };
}
const tMe = {
  basis: {
    curve: Wor
  },
  "basis-closed": {
    curve: Xor
  },
  "basis-open": {
    curve: Zor
  },
  bundle: {
    curve: esr,
    tension: "beta",
    value: 0.85
  },
  cardinal: {
    curve: tsr,
    tension: "tension",
    value: 0
  },
  "cardinal-open": {
    curve: rsr,
    tension: "tension",
    value: 0
  },
  "cardinal-closed": {
    curve: nsr,
    tension: "tension",
    value: 0
  },
  "catmull-rom": {
    curve: isr,
    tension: "alpha",
    value: 0.5
  },
  "catmull-rom-closed": {
    curve: osr,
    tension: "alpha",
    value: 0.5
  },
  "catmull-rom-open": {
    curve: ssr,
    tension: "alpha",
    value: 0.5
  },
  linear: {
    curve: whe
  },
  "linear-closed": {
    curve: asr
  },
  monotone: {
    horizontal: lsr,
    vertical: Asr
  },
  natural: {
    curve: csr
  },
  step: {
    curve: usr
  },
  "step-after": {
    curve: gsr
  },
  "step-before": {
    curve: fsr
  }
};
function ide(t, e, n) {
  var r = Kn(tMe, t) && tMe[t], i = null;
  return r && (i = r.curve || r[e || "vertical"], r.tension && n != null && (i = i[r.tension](n))), i;
}
const zar = {
  m: 2,
  l: 2,
  h: 1,
  v: 1,
  z: 0,
  c: 6,
  s: 4,
  q: 4,
  t: 2,
  a: 7
}, Var = /[mlhvzcsqta]([^mlhvzcsqta]+|$)/gi, Jar = /^[+-]?(([0-9]*\.[0-9]+)|([0-9]+\.)|([0-9]+))([eE][+-]?[0-9]+)?/, Kar = /^((\s+,?\s*)|(,\s*))/, War = /^[01]/;
function BQ(t) {
  const e = [];
  return (t.match(Var) || []).forEach((r) => {
    let i = r[0];
    const o = i.toLowerCase(), s = zar[o], a = Xar(o, s, r.slice(1).trim()), A = a.length;
    if (A < s || A && A % s !== 0)
      throw Error("Invalid SVG path, incorrect parameter count");
    if (e.push([i, ...a.slice(0, s)]), A !== s) {
      o === "m" && (i = i === "M" ? "L" : "l");
      for (let l = s; l < A; l += s)
        e.push([i, ...a.slice(l, l + s)]);
    }
  }), e;
}
function Xar(t, e, n) {
  const r = [];
  for (let i = 0; e && i < n.length; )
    for (let o = 0; o < e; ++o) {
      const s = t === "a" && (o === 3 || o === 4) ? War : Jar, a = n.slice(i).match(s);
      if (a === null)
        throw Error("Invalid SVG path, incorrect parameter type");
      i += a[0].length, r.push(+a[0]);
      const A = n.slice(i).match(Kar);
      A !== null && (i += A[0].length);
    }
  return r;
}
const sE = Math.PI / 180, Zar = 1e-14, Xy = Math.PI / 2, Ep = Math.PI * 2, Rb = Math.sqrt(3) / 2;
var BW = {}, bW = {}, _nt = [].join;
function eAr(t, e, n, r, i, o, s, a, A) {
  const l = _nt.call(arguments);
  if (BW[l])
    return BW[l];
  const c = s * sE, u = Math.sin(c), f = Math.cos(c);
  n = Math.abs(n), r = Math.abs(r);
  const h = f * (a - t) * 0.5 + u * (A - e) * 0.5, d = f * (A - e) * 0.5 - u * (a - t) * 0.5;
  let I = h * h / (n * n) + d * d / (r * r);
  I > 1 && (I = Math.sqrt(I), n *= I, r *= I);
  const m = f / n, C = u / n, y = -u / r, v = f / r, b = m * a + C * A, Q = y * a + v * A, w = m * t + C * e, R = y * t + v * e;
  let O = 1 / ((w - b) * (w - b) + (R - Q) * (R - Q)) - 0.25;
  O < 0 && (O = 0);
  let L = Math.sqrt(O);
  o == i && (L = -L);
  const N = 0.5 * (b + w) - L * (R - Q), k = 0.5 * (Q + R) + L * (w - b), $ = Math.atan2(Q - k, b - N);
  let X = Math.atan2(R - k, w - N) - $;
  X < 0 && o === 1 ? X += Ep : X > 0 && o === 0 && (X -= Ep);
  const K = Math.ceil(Math.abs(X / (Xy + 1e-3))), z = [];
  for (let Y = 0; Y < K; ++Y) {
    const V = $ + Y * X / K, Z = $ + (Y + 1) * X / K;
    z[Y] = [N, k, V, Z, n, r, u, f];
  }
  return BW[l] = z;
}
function tAr(t) {
  const e = _nt.call(t);
  if (bW[e])
    return bW[e];
  var n = t[0], r = t[1], i = t[2], o = t[3], s = t[4], a = t[5], A = t[6], l = t[7];
  const c = l * s, u = -A * a, f = A * s, h = l * a, d = Math.cos(i), I = Math.sin(i), m = Math.cos(o), C = Math.sin(o), y = 0.5 * (o - i), v = Math.sin(y * 0.5), b = 8 / 3 * v * v / Math.sin(y), Q = n + d - b * I, w = r + I + b * d, R = n + m, M = r + C, O = R + b * C, L = M - b * m;
  return bW[e] = [c * Q + u * w, f * Q + h * w, c * O + u * L, f * O + h * L, c * R + u * M, f * R + h * M];
}
const ig = ["l", 0, 0, 0, 0, 0, 0, 0];
function nAr(t, e, n) {
  const r = ig[0] = t[0];
  if (r === "a" || r === "A")
    ig[1] = e * t[1], ig[2] = n * t[2], ig[3] = t[3], ig[4] = t[4], ig[5] = t[5], ig[6] = e * t[6], ig[7] = n * t[7];
  else if (r === "h" || r === "H")
    ig[1] = e * t[1];
  else if (r === "v" || r === "V")
    ig[1] = n * t[1];
  else
    for (var i = 1, o = t.length; i < o; ++i)
      ig[i] = (i % 2 == 1 ? e : n) * t[i];
  return ig;
}
function bN(t, e, n, r, i, o) {
  var s, a = null, A = 0, l = 0, c = 0, u = 0, f, h, d, I, m = 0, C = 0;
  n == null && (n = 0), r == null && (r = 0), i == null && (i = 1), o == null && (o = i), t.beginPath && t.beginPath();
  for (var y = 0, v = e.length; y < v; ++y) {
    switch (s = e[y], (i !== 1 || o !== 1) && (s = nAr(s, i, o)), s[0]) {
      case "l":
        A += s[1], l += s[2], t.lineTo(A + n, l + r);
        break;
      case "L":
        A = s[1], l = s[2], t.lineTo(A + n, l + r);
        break;
      case "h":
        A += s[1], t.lineTo(A + n, l + r);
        break;
      case "H":
        A = s[1], t.lineTo(A + n, l + r);
        break;
      case "v":
        l += s[1], t.lineTo(A + n, l + r);
        break;
      case "V":
        l = s[1], t.lineTo(A + n, l + r);
        break;
      case "m":
        A += s[1], l += s[2], m = A, C = l, t.moveTo(A + n, l + r);
        break;
      case "M":
        A = s[1], l = s[2], m = A, C = l, t.moveTo(A + n, l + r);
        break;
      case "c":
        f = A + s[5], h = l + s[6], c = A + s[3], u = l + s[4], t.bezierCurveTo(
          A + s[1] + n,
          // x1
          l + s[2] + r,
          // y1
          c + n,
          // x2
          u + r,
          // y2
          f + n,
          h + r
        ), A = f, l = h;
        break;
      case "C":
        A = s[5], l = s[6], c = s[3], u = s[4], t.bezierCurveTo(s[1] + n, s[2] + r, c + n, u + r, A + n, l + r);
        break;
      case "s":
        f = A + s[3], h = l + s[4], c = 2 * A - c, u = 2 * l - u, t.bezierCurveTo(c + n, u + r, A + s[1] + n, l + s[2] + r, f + n, h + r), c = A + s[1], u = l + s[2], A = f, l = h;
        break;
      case "S":
        f = s[3], h = s[4], c = 2 * A - c, u = 2 * l - u, t.bezierCurveTo(c + n, u + r, s[1] + n, s[2] + r, f + n, h + r), A = f, l = h, c = s[1], u = s[2];
        break;
      case "q":
        f = A + s[3], h = l + s[4], c = A + s[1], u = l + s[2], t.quadraticCurveTo(c + n, u + r, f + n, h + r), A = f, l = h;
        break;
      case "Q":
        f = s[3], h = s[4], t.quadraticCurveTo(s[1] + n, s[2] + r, f + n, h + r), A = f, l = h, c = s[1], u = s[2];
        break;
      case "t":
        f = A + s[1], h = l + s[2], a[0].match(/[QqTt]/) === null ? (c = A, u = l) : a[0] === "t" ? (c = 2 * A - d, u = 2 * l - I) : a[0] === "q" && (c = 2 * A - c, u = 2 * l - u), d = c, I = u, t.quadraticCurveTo(c + n, u + r, f + n, h + r), A = f, l = h, c = A + s[1], u = l + s[2];
        break;
      case "T":
        f = s[1], h = s[2], c = 2 * A - c, u = 2 * l - u, t.quadraticCurveTo(c + n, u + r, f + n, h + r), A = f, l = h;
        break;
      case "a":
        nMe(t, A + n, l + r, [s[1], s[2], s[3], s[4], s[5], s[6] + A + n, s[7] + l + r]), A += s[6], l += s[7];
        break;
      case "A":
        nMe(t, A + n, l + r, [s[1], s[2], s[3], s[4], s[5], s[6] + n, s[7] + r]), A = s[6], l = s[7];
        break;
      case "z":
      case "Z":
        A = m, l = C, t.closePath();
        break;
    }
    a = s;
  }
}
function nMe(t, e, n, r) {
  const i = eAr(
    r[5],
    // end x
    r[6],
    // end y
    r[0],
    // radius x
    r[1],
    // radius y
    r[3],
    // large flag
    r[4],
    // sweep flag
    r[2],
    // rotation
    e,
    n
  );
  for (let o = 0; o < i.length; ++o) {
    const s = tAr(i[o]);
    t.bezierCurveTo(s[0], s[1], s[2], s[3], s[4], s[5]);
  }
}
const rMe = 0.5773502691896257, iMe = {
  circle: {
    draw: function(t, e) {
      const n = Math.sqrt(e) / 2;
      t.moveTo(n, 0), t.arc(0, 0, n, 0, Ep);
    }
  },
  cross: {
    draw: function(t, e) {
      var n = Math.sqrt(e) / 2, r = n / 2.5;
      t.moveTo(-n, -r), t.lineTo(-n, r), t.lineTo(-r, r), t.lineTo(-r, n), t.lineTo(r, n), t.lineTo(r, r), t.lineTo(n, r), t.lineTo(n, -r), t.lineTo(r, -r), t.lineTo(r, -n), t.lineTo(-r, -n), t.lineTo(-r, -r), t.closePath();
    }
  },
  diamond: {
    draw: function(t, e) {
      const n = Math.sqrt(e) / 2;
      t.moveTo(-n, 0), t.lineTo(0, -n), t.lineTo(n, 0), t.lineTo(0, n), t.closePath();
    }
  },
  square: {
    draw: function(t, e) {
      var n = Math.sqrt(e), r = -n / 2;
      t.rect(r, r, n, n);
    }
  },
  arrow: {
    draw: function(t, e) {
      var n = Math.sqrt(e) / 2, r = n / 7, i = n / 2.5, o = n / 8;
      t.moveTo(-r, n), t.lineTo(r, n), t.lineTo(r, -o), t.lineTo(i, -o), t.lineTo(0, -n), t.lineTo(-i, -o), t.lineTo(-r, -o), t.closePath();
    }
  },
  wedge: {
    draw: function(t, e) {
      var n = Math.sqrt(e) / 2, r = Rb * n, i = r - n * rMe, o = n / 4;
      t.moveTo(0, -r - i), t.lineTo(-o, r - i), t.lineTo(o, r - i), t.closePath();
    }
  },
  triangle: {
    draw: function(t, e) {
      var n = Math.sqrt(e) / 2, r = Rb * n, i = r - n * rMe;
      t.moveTo(0, -r - i), t.lineTo(-n, r - i), t.lineTo(n, r - i), t.closePath();
    }
  },
  "triangle-up": {
    draw: function(t, e) {
      var n = Math.sqrt(e) / 2, r = Rb * n;
      t.moveTo(0, -r), t.lineTo(-n, r), t.lineTo(n, r), t.closePath();
    }
  },
  "triangle-down": {
    draw: function(t, e) {
      var n = Math.sqrt(e) / 2, r = Rb * n;
      t.moveTo(0, r), t.lineTo(-n, -r), t.lineTo(n, -r), t.closePath();
    }
  },
  "triangle-right": {
    draw: function(t, e) {
      var n = Math.sqrt(e) / 2, r = Rb * n;
      t.moveTo(r, 0), t.lineTo(-r, -n), t.lineTo(-r, n), t.closePath();
    }
  },
  "triangle-left": {
    draw: function(t, e) {
      var n = Math.sqrt(e) / 2, r = Rb * n;
      t.moveTo(-r, 0), t.lineTo(r, -n), t.lineTo(r, n), t.closePath();
    }
  },
  stroke: {
    draw: function(t, e) {
      const n = Math.sqrt(e) / 2;
      t.moveTo(-n, 0), t.lineTo(n, 0);
    }
  }
};
function Snt(t) {
  return Kn(iMe, t) ? iMe[t] : rAr(t);
}
var _W = {};
function rAr(t) {
  if (!Kn(_W, t)) {
    const e = BQ(t);
    _W[t] = {
      draw: function(n, r) {
        bN(n, e, 0, 0, Math.sqrt(r) / 2);
      }
    };
  }
  return _W[t];
}
const Om = 0.448084975506;
function iAr(t) {
  return t.x;
}
function oAr(t) {
  return t.y;
}
function sAr(t) {
  return t.width;
}
function aAr(t) {
  return t.height;
}
function P0(t) {
  return typeof t == "function" ? t : () => +t;
}
function y3(t, e, n) {
  return Math.max(e, Math.min(t, n));
}
function Qnt() {
  var t = iAr, e = oAr, n = sAr, r = aAr, i = P0(0), o = i, s = i, a = i, A = null;
  function l(c, u, f) {
    var h, d = u ?? +t.call(this, c), I = f ?? +e.call(this, c), m = +n.call(this, c), C = +r.call(this, c), y = Math.min(m, C) / 2, v = y3(+i.call(this, c), 0, y), b = y3(+o.call(this, c), 0, y), Q = y3(+s.call(this, c), 0, y), w = y3(+a.call(this, c), 0, y);
    if (A || (A = h = kE()), v <= 0 && b <= 0 && Q <= 0 && w <= 0)
      A.rect(d, I, m, C);
    else {
      var R = d + m, M = I + C;
      A.moveTo(d + v, I), A.lineTo(R - b, I), A.bezierCurveTo(R - Om * b, I, R, I + Om * b, R, I + b), A.lineTo(R, M - w), A.bezierCurveTo(R, M - Om * w, R - Om * w, M, R - w, M), A.lineTo(d + Q, M), A.bezierCurveTo(d + Om * Q, M, d, M - Om * Q, d, M - Q), A.lineTo(d, I + v), A.bezierCurveTo(d, I + Om * v, d + Om * v, I, d + v, I), A.closePath();
    }
    if (h)
      return A = null, h + "" || null;
  }
  return l.x = function(c) {
    return arguments.length ? (t = P0(c), l) : t;
  }, l.y = function(c) {
    return arguments.length ? (e = P0(c), l) : e;
  }, l.width = function(c) {
    return arguments.length ? (n = P0(c), l) : n;
  }, l.height = function(c) {
    return arguments.length ? (r = P0(c), l) : r;
  }, l.cornerRadius = function(c, u, f, h) {
    return arguments.length ? (i = P0(c), o = u != null ? P0(u) : i, a = f != null ? P0(f) : i, s = h != null ? P0(h) : o, l) : i;
  }, l.context = function(c) {
    return arguments.length ? (A = c ?? null, l) : A;
  }, l;
}
function wnt() {
  var t, e, n, r, i = null, o, s, a, A;
  function l(u, f, h) {
    const d = h / 2;
    if (o) {
      var I = a - f, m = u - s;
      if (I || m) {
        var C = Math.sqrt(I * I + m * m), y = (I /= C) * A, v = (m /= C) * A, b = Math.atan2(m, I);
        i.moveTo(s - y, a - v), i.lineTo(u - I * d, f - m * d), i.arc(u, f, d, b - Math.PI, b), i.lineTo(s + y, a + v), i.arc(s, a, A, b, b + Math.PI);
      } else
        i.arc(u, f, d, 0, Ep);
      i.closePath();
    } else
      o = 1;
    s = u, a = f, A = d;
  }
  function c(u) {
    var f, h = u.length, d, I = !1, m;
    for (i == null && (i = m = kE()), f = 0; f <= h; ++f)
      !(f < h && r(d = u[f], f, u)) === I && (I = !I) && (o = 0), I && l(+t(d, f, u), +e(d, f, u), +n(d, f, u));
    if (m)
      return i = null, m + "" || null;
  }
  return c.x = function(u) {
    return arguments.length ? (t = u, c) : t;
  }, c.y = function(u) {
    return arguments.length ? (e = u, c) : e;
  }, c.size = function(u) {
    return arguments.length ? (n = u, c) : n;
  }, c.defined = function(u) {
    return arguments.length ? (r = u, c) : r;
  }, c.context = function(u) {
    return arguments.length ? (u == null ? i = null : i = u, c) : i;
  }, c;
}
function hO(t, e) {
  return t ?? e;
}
const dO = (t) => t.x || 0, pO = (t) => t.y || 0, AAr = (t) => t.width || 0, lAr = (t) => t.height || 0, cAr = (t) => (t.x || 0) + (t.width || 0), uAr = (t) => (t.y || 0) + (t.height || 0), fAr = (t) => t.startAngle || 0, gAr = (t) => t.endAngle || 0, hAr = (t) => t.padAngle || 0, dAr = (t) => t.innerRadius || 0, pAr = (t) => t.outerRadius || 0, IAr = (t) => t.cornerRadius || 0, mAr = (t) => hO(t.cornerRadiusTopLeft, t.cornerRadius) || 0, CAr = (t) => hO(t.cornerRadiusTopRight, t.cornerRadius) || 0, EAr = (t) => hO(t.cornerRadiusBottomRight, t.cornerRadius) || 0, yAr = (t) => hO(t.cornerRadiusBottomLeft, t.cornerRadius) || 0, vAr = (t) => hO(t.size, 64), BAr = (t) => t.size || 1, Oj = (t) => t.defined !== !1, bAr = (t) => Snt(t.shape || "circle"), _Ar = Vor().startAngle(fAr).endAngle(gAr).padAngle(hAr).innerRadius(dAr).outerRadius(pAr).cornerRadius(IAr), SAr = ott().x(dO).y1(pO).y0(uAr).defined(Oj), QAr = ott().y(pO).x1(dO).x0(cAr).defined(Oj), wAr = itt().x(dO).y(pO).defined(Oj), xAr = Qnt().x(dO).y(pO).width(AAr).height(lAr).cornerRadius(mAr, CAr, EAr, yAr), RAr = Kor().type(bAr).size(vAr), DAr = wnt().x(dO).y(pO).defined(Oj).size(BAr);
function ode(t) {
  return t.cornerRadius || t.cornerRadiusTopLeft || t.cornerRadiusTopRight || t.cornerRadiusBottomRight || t.cornerRadiusBottomLeft;
}
function TAr(t, e) {
  return _Ar.context(t)(e);
}
function NAr(t, e) {
  const n = e[0], r = n.interpolate || "linear";
  return (n.orient === "horizontal" ? QAr : SAr).curve(ide(r, n.orient, n.tension)).context(t)(e);
}
function LAr(t, e) {
  const n = e[0], r = n.interpolate || "linear";
  return wAr.curve(ide(r, n.orient, n.tension)).context(t)(e);
}
function vx(t, e, n, r) {
  return xAr.context(t)(e, n, r);
}
function MAr(t, e) {
  return (e.mark.shape || e.shape).context(t)(e);
}
function OAr(t, e) {
  return RAr.context(t)(e);
}
function FAr(t, e) {
  return DAr.context(t)(e);
}
var xnt = 1;
function Rnt() {
  xnt = 1;
}
function sde(t, e, n) {
  var r = e.clip, i = t._defs, o = e.clip_id || (e.clip_id = "clip" + xnt++), s = i.clipping[o] || (i.clipping[o] = {
    id: o
  });
  return ri(r) ? s.path = r(null) : ode(n) ? s.path = vx(null, n, 0, 0) : (s.width = n.width || 0, s.height = n.height || 0), "url(#" + o + ")";
}
function za(t) {
  this.clear(), t && this.union(t);
}
za.prototype = {
  clone() {
    return new za(this);
  },
  clear() {
    return this.x1 = +Number.MAX_VALUE, this.y1 = +Number.MAX_VALUE, this.x2 = -Number.MAX_VALUE, this.y2 = -Number.MAX_VALUE, this;
  },
  empty() {
    return this.x1 === +Number.MAX_VALUE && this.y1 === +Number.MAX_VALUE && this.x2 === -Number.MAX_VALUE && this.y2 === -Number.MAX_VALUE;
  },
  equals(t) {
    return this.x1 === t.x1 && this.y1 === t.y1 && this.x2 === t.x2 && this.y2 === t.y2;
  },
  set(t, e, n, r) {
    return n < t ? (this.x2 = t, this.x1 = n) : (this.x1 = t, this.x2 = n), r < e ? (this.y2 = e, this.y1 = r) : (this.y1 = e, this.y2 = r), this;
  },
  add(t, e) {
    return t < this.x1 && (this.x1 = t), e < this.y1 && (this.y1 = e), t > this.x2 && (this.x2 = t), e > this.y2 && (this.y2 = e), this;
  },
  expand(t) {
    return this.x1 -= t, this.y1 -= t, this.x2 += t, this.y2 += t, this;
  },
  round() {
    return this.x1 = Math.floor(this.x1), this.y1 = Math.floor(this.y1), this.x2 = Math.ceil(this.x2), this.y2 = Math.ceil(this.y2), this;
  },
  scale(t) {
    return this.x1 *= t, this.y1 *= t, this.x2 *= t, this.y2 *= t, this;
  },
  translate(t, e) {
    return this.x1 += t, this.x2 += t, this.y1 += e, this.y2 += e, this;
  },
  rotate(t, e, n) {
    const r = this.rotatedPoints(t, e, n);
    return this.clear().add(r[0], r[1]).add(r[2], r[3]).add(r[4], r[5]).add(r[6], r[7]);
  },
  rotatedPoints(t, e, n) {
    var {
      x1: r,
      y1: i,
      x2: o,
      y2: s
    } = this, a = Math.cos(t), A = Math.sin(t), l = e - e * a + n * A, c = n - e * A - n * a;
    return [a * r - A * i + l, A * r + a * i + c, a * r - A * s + l, A * r + a * s + c, a * o - A * i + l, A * o + a * i + c, a * o - A * s + l, A * o + a * s + c];
  },
  union(t) {
    return t.x1 < this.x1 && (this.x1 = t.x1), t.y1 < this.y1 && (this.y1 = t.y1), t.x2 > this.x2 && (this.x2 = t.x2), t.y2 > this.y2 && (this.y2 = t.y2), this;
  },
  intersect(t) {
    return t.x1 > this.x1 && (this.x1 = t.x1), t.y1 > this.y1 && (this.y1 = t.y1), t.x2 < this.x2 && (this.x2 = t.x2), t.y2 < this.y2 && (this.y2 = t.y2), this;
  },
  encloses(t) {
    return t && this.x1 <= t.x1 && this.x2 >= t.x2 && this.y1 <= t.y1 && this.y2 >= t.y2;
  },
  alignsWith(t) {
    return t && (this.x1 == t.x1 || this.x2 == t.x2 || this.y1 == t.y1 || this.y2 == t.y2);
  },
  intersects(t) {
    return t && !(this.x2 < t.x1 || this.x1 > t.x2 || this.y2 < t.y1 || this.y1 > t.y2);
  },
  contains(t, e) {
    return !(t < this.x1 || t > this.x2 || e < this.y1 || e > this.y2);
  },
  width() {
    return this.x2 - this.x1;
  },
  height() {
    return this.y2 - this.y1;
  }
};
function Fj(t) {
  this.mark = t, this.bounds = this.bounds || new za();
}
function Pj(t) {
  Fj.call(this, t), this.items = this.items || [];
}
on(Pj, Fj);
function ade(t) {
  this._pending = 0, this._loader = t || fj();
}
function oMe(t) {
  t._pending += 1;
}
function z2(t) {
  t._pending -= 1;
}
ade.prototype = {
  pending() {
    return this._pending;
  },
  sanitizeURL(t) {
    const e = this;
    return oMe(e), e._loader.sanitize(t, {
      context: "href"
    }).then((n) => (z2(e), n)).catch(() => (z2(e), null));
  },
  loadImage(t) {
    const e = this, n = hsr();
    return oMe(e), e._loader.sanitize(t, {
      context: "image"
    }).then((r) => {
      const i = r.href;
      if (!i || !n)
        throw {
          url: i
        };
      const o = new n(), s = Kn(r, "crossOrigin") ? r.crossOrigin : "anonymous";
      return s != null && (o.crossOrigin = s), o.onload = () => z2(e), o.onerror = () => z2(e), o.src = i, o;
    }).catch((r) => (z2(e), {
      complete: !1,
      width: 0,
      height: 0,
      src: r && r.url || ""
    }));
  },
  ready() {
    const t = this;
    return new Promise((e) => {
      function n(r) {
        t.pending() ? setTimeout(() => {
          n(!0);
        }, 10) : e(r);
      }
      n(!1);
    });
  }
};
function sm(t, e, n) {
  if (e.stroke && e.opacity !== 0 && e.strokeOpacity !== 0) {
    const r = e.strokeWidth != null ? +e.strokeWidth : 1;
    t.expand(r + (n ? PAr(e, r) : 0));
  }
  return t;
}
function PAr(t, e) {
  return t.strokeJoin && t.strokeJoin !== "miter" ? 0 : e;
}
const kAr = Ep - 1e-8;
let kj, KG, WG, dv, fie, XG, gie, hie;
const pC = (t, e) => kj.add(t, e), ZG = (t, e) => pC(KG = t, WG = e), sMe = (t) => pC(t, kj.y1), aMe = (t) => pC(kj.x1, t), Zy = (t, e) => fie * t + gie * e, ev = (t, e) => XG * t + hie * e, SW = (t, e) => pC(Zy(t, e), ev(t, e)), QW = (t, e) => ZG(Zy(t, e), ev(t, e));
function IO(t, e) {
  return kj = t, e ? (dv = e * sE, fie = hie = Math.cos(dv), XG = Math.sin(dv), gie = -XG) : (fie = hie = 1, dv = XG = gie = 0), GAr;
}
const GAr = {
  beginPath() {
  },
  closePath() {
  },
  moveTo: QW,
  lineTo: QW,
  rect(t, e, n, r) {
    dv ? (SW(t + n, e), SW(t + n, e + r), SW(t, e + r), QW(t, e)) : (pC(t + n, e + r), ZG(t, e));
  },
  quadraticCurveTo(t, e, n, r) {
    const i = Zy(t, e), o = ev(t, e), s = Zy(n, r), a = ev(n, r);
    AMe(KG, i, s, sMe), AMe(WG, o, a, aMe), ZG(s, a);
  },
  bezierCurveTo(t, e, n, r, i, o) {
    const s = Zy(t, e), a = ev(t, e), A = Zy(n, r), l = ev(n, r), c = Zy(i, o), u = ev(i, o);
    lMe(KG, s, A, c, sMe), lMe(WG, a, l, u, aMe), ZG(c, u);
  },
  arc(t, e, n, r, i, o) {
    if (r += dv, i += dv, KG = n * Math.cos(i) + t, WG = n * Math.sin(i) + e, Math.abs(i - r) > kAr)
      pC(t - n, e - n), pC(t + n, e + n);
    else {
      const s = (l) => pC(n * Math.cos(l) + t, n * Math.sin(l) + e);
      let a, A;
      if (s(r), s(i), i !== r)
        if (r = r % Ep, r < 0 && (r += Ep), i = i % Ep, i < 0 && (i += Ep), i < r && (o = !o, a = r, r = i, i = a), o)
          for (i -= Ep, a = r - r % Xy, A = 0; A < 4 && a > i; ++A, a -= Xy)
            s(a);
        else
          for (a = r - r % Xy + Xy, A = 0; A < 4 && a < i; ++A, a = a + Xy)
            s(a);
    }
  }
};
function AMe(t, e, n, r) {
  const i = (t - e) / (t + n - 2 * e);
  0 < i && i < 1 && r(t + (e - t) * i);
}
function lMe(t, e, n, r, i) {
  const o = r - t + 3 * e - 3 * n, s = t + n - 2 * e, a = t - e;
  let A = 0, l = 0, c;
  Math.abs(o) > Zar ? (c = s * s + a * o, c >= 0 && (c = Math.sqrt(c), A = (-s + c) / o, l = (-s - c) / o)) : A = 0.5 * a / s, 0 < A && A < 1 && i(cMe(A, t, e, n, r)), 0 < l && l < 1 && i(cMe(l, t, e, n, r));
}
function cMe(t, e, n, r, i) {
  const o = 1 - t, s = o * o, a = t * t;
  return s * o * e + 3 * s * t * n + 3 * o * a * r + a * t * i;
}
var kC = (kC = PC(1, 1)) ? kC.getContext("2d") : null;
const die = new za();
function Ade(t) {
  return function(e, n) {
    if (!kC)
      return !0;
    t(kC, e), die.clear().union(e.bounds).intersect(n).round();
    const {
      x1: r,
      y1: i,
      x2: o,
      y2: s
    } = die;
    for (let a = i; a <= s; ++a)
      for (let A = r; A <= o; ++A)
        if (kC.isPointInPath(A, a))
          return !0;
    return !1;
  };
}
function lde(t, e) {
  return e.contains(t.x || 0, t.y || 0);
}
function Dnt(t, e) {
  const n = t.x || 0, r = t.y || 0, i = t.width || 0, o = t.height || 0;
  return e.intersects(die.set(n, r, n + i, r + o));
}
function Tnt(t, e) {
  const n = t.x || 0, r = t.y || 0, i = t.x2 != null ? t.x2 : n, o = t.y2 != null ? t.y2 : r;
  return S_(e, n, r, i, o);
}
function S_(t, e, n, r, i) {
  const {
    x1: o,
    y1: s,
    x2: a,
    y2: A
  } = t, l = r - e, c = i - n;
  let u = 0, f = 1, h, d, I, m;
  for (m = 0; m < 4; ++m) {
    if (m === 0 && (h = -l, d = -(o - e)), m === 1 && (h = l, d = a - e), m === 2 && (h = -c, d = -(s - n)), m === 3 && (h = c, d = A - n), Math.abs(h) < 1e-10 && d < 0)
      return !1;
    if (I = d / h, h < 0) {
      if (I > f)
        return !1;
      I > u && (u = I);
    } else if (h > 0) {
      if (I < u)
        return !1;
      I < f && (f = I);
    }
  }
  return !0;
}
function bQ(t, e) {
  t.globalCompositeOperation = e.blend || "source-over";
}
function bh(t, e) {
  return t ?? e;
}
function uMe(t, e) {
  const n = e.length;
  for (let r = 0; r < n; ++r)
    t.addColorStop(e[r].offset, e[r].color);
  return t;
}
function UAr(t, e, n) {
  const r = n.width(), i = n.height();
  let o;
  if (e.gradient === "radial")
    o = t.createRadialGradient(n.x1 + bh(e.x1, 0.5) * r, n.y1 + bh(e.y1, 0.5) * i, Math.max(r, i) * bh(e.r1, 0), n.x1 + bh(e.x2, 0.5) * r, n.y1 + bh(e.y2, 0.5) * i, Math.max(r, i) * bh(e.r2, 0.5));
  else {
    const s = bh(e.x1, 0), a = bh(e.y1, 0), A = bh(e.x2, 1), l = bh(e.y2, 0);
    if (s === A || a === l || r === i)
      o = t.createLinearGradient(n.x1 + s * r, n.y1 + a * i, n.x1 + A * r, n.y1 + l * i);
    else {
      const c = PC(Math.ceil(r), Math.ceil(i)), u = c.getContext("2d");
      return u.scale(r, i), u.fillStyle = uMe(u.createLinearGradient(s, a, A, l), e.stops), u.fillRect(0, 0, r, i), t.createPattern(c, "no-repeat");
    }
  }
  return uMe(o, e.stops);
}
function Nnt(t, e, n) {
  return rde(n) ? UAr(t, n, e.bounds) : n;
}
function F5(t, e, n) {
  return n *= e.fillOpacity == null ? 1 : e.fillOpacity, n > 0 ? (t.globalAlpha = n, t.fillStyle = Nnt(t, e, e.fill), !0) : !1;
}
var HAr = [];
function _Q(t, e, n) {
  var r = (r = e.strokeWidth) != null ? r : 1;
  return r <= 0 ? !1 : (n *= e.strokeOpacity == null ? 1 : e.strokeOpacity, n > 0 ? (t.globalAlpha = n, t.strokeStyle = Nnt(t, e, e.stroke), t.lineWidth = r, t.lineCap = e.strokeCap || "butt", t.lineJoin = e.strokeJoin || "miter", t.miterLimit = e.strokeMiterLimit || 10, t.setLineDash && (t.setLineDash(e.strokeDash || HAr), t.lineDashOffset = e.strokeDashOffset || 0), !0) : !1);
}
function $Ar(t, e) {
  return t.zindex - e.zindex || t.index - e.index;
}
function cde(t) {
  if (!t.zdirty)
    return t.zitems;
  var e = t.items, n = [], r, i, o;
  for (i = 0, o = e.length; i < o; ++i)
    r = e[i], r.index = i, r.zindex && n.push(r);
  return t.zdirty = !1, t.zitems = n.sort($Ar);
}
function md(t, e) {
  var n = t.items, r, i;
  if (!n || !n.length)
    return;
  const o = cde(t);
  if (o && o.length) {
    for (r = 0, i = n.length; r < i; ++r)
      n[r].zindex || e(n[r]);
    n = o;
  }
  for (r = 0, i = n.length; r < i; ++r)
    e(n[r]);
}
function P5(t, e) {
  var n = t.items, r, i;
  if (!n || !n.length)
    return null;
  const o = cde(t);
  for (o && o.length && (n = o), i = n.length; --i >= 0; )
    if (r = e(n[i]))
      return r;
  if (n === o) {
    for (n = t.items, i = n.length; --i >= 0; )
      if (!n[i].zindex && (r = e(n[i])))
        return r;
  }
  return null;
}
function ude(t) {
  return function(e, n, r) {
    md(n, (i) => {
      (!r || r.intersects(i.bounds)) && Lnt(t, e, i, i);
    });
  };
}
function qAr(t) {
  return function(e, n, r) {
    n.items.length && (!r || r.intersects(n.bounds)) && Lnt(t, e, n.items[0], n.items);
  };
}
function Lnt(t, e, n, r) {
  var i = n.opacity == null ? 1 : n.opacity;
  i !== 0 && (t(e, r) || (bQ(e, n), n.fill && F5(e, n, i) && e.fill(), n.stroke && _Q(e, n, i) && e.stroke()));
}
function Gj(t) {
  return t = t || qg, function(e, n, r, i, o, s) {
    return r *= e.pixelRatio, i *= e.pixelRatio, P5(n, (a) => {
      const A = a.bounds;
      if (!(A && !A.contains(o, s) || !A) && t(e, a, r, i, o, s))
        return a;
    });
  };
}
function mO(t, e) {
  return function(n, r, i, o) {
    var s = Array.isArray(r) ? r[0] : r, a = e ?? s.fill, A = s.stroke && n.isPointInStroke, l, c;
    return A && (l = s.strokeWidth, c = s.strokeCap, n.lineWidth = l ?? 1, n.lineCap = c ?? "butt"), t(n, r) ? !1 : a && n.isPointInPath(i, o) || A && n.isPointInStroke(i, o);
  };
}
function fde(t) {
  return Gj(mO(t));
}
function Mv(t, e) {
  return "translate(" + t + "," + e + ")";
}
function gde(t) {
  return "rotate(" + t + ")";
}
function jAr(t, e) {
  return "scale(" + t + "," + e + ")";
}
function Mnt(t) {
  return Mv(t.x || 0, t.y || 0);
}
function YAr(t) {
  return Mv(t.x || 0, t.y || 0) + (t.angle ? " " + gde(t.angle) : "");
}
function zAr(t) {
  return Mv(t.x || 0, t.y || 0) + (t.angle ? " " + gde(t.angle) : "") + (t.scaleX || t.scaleY ? " " + jAr(t.scaleX || 1, t.scaleY || 1) : "");
}
function hde(t, e, n) {
  function r(s, a) {
    s("transform", YAr(a)), s("d", e(null, a));
  }
  function i(s, a) {
    return e(IO(s, a.angle), a), sm(s, a).translate(a.x || 0, a.y || 0);
  }
  function o(s, a) {
    var A = a.x || 0, l = a.y || 0, c = a.angle || 0;
    s.translate(A, l), c && s.rotate(c *= sE), s.beginPath(), e(s, a), c && s.rotate(-c), s.translate(-A, -l);
  }
  return {
    type: t,
    tag: "path",
    nested: !1,
    attr: r,
    bound: i,
    draw: ude(o),
    pick: fde(o),
    isect: n || Ade(o)
  };
}
var VAr = hde("arc", TAr);
function JAr(t, e) {
  for (var n = t[0].orient === "horizontal" ? e[1] : e[0], r = t[0].orient === "horizontal" ? "y" : "x", i = t.length, o = 1 / 0, s, a; --i >= 0; )
    t[i].defined !== !1 && (a = Math.abs(t[i][r] - n), a < o && (o = a, s = t[i]));
  return s;
}
function KAr(t, e) {
  for (var n = Math.pow(t[0].strokeWidth || 1, 2), r = t.length, i, o, s; --r >= 0; )
    if (t[r].defined !== !1 && (i = t[r].x - e[0], o = t[r].y - e[1], s = i * i + o * o, s < n))
      return t[r];
  return null;
}
function WAr(t, e) {
  for (var n = t.length, r, i, o; --n >= 0; )
    if (t[n].defined !== !1 && (r = t[n].x - e[0], i = t[n].y - e[1], o = r * r + i * i, r = t[n].size || 1, o < r * r))
      return t[n];
  return null;
}
function dde(t, e, n) {
  function r(A, l) {
    var c = l.mark.items;
    c.length && A("d", e(null, c));
  }
  function i(A, l) {
    var c = l.items;
    return c.length === 0 ? A : (e(IO(A), c), sm(A, c[0]));
  }
  function o(A, l) {
    A.beginPath(), e(A, l);
  }
  const s = mO(o);
  function a(A, l, c, u, f, h) {
    var d = l.items, I = l.bounds;
    return !d || !d.length || I && !I.contains(f, h) ? null : (c *= A.pixelRatio, u *= A.pixelRatio, s(A, d, c, u) ? d[0] : null);
  }
  return {
    type: t,
    tag: "path",
    nested: !0,
    attr: r,
    bound: i,
    draw: qAr(o),
    pick: a,
    isect: lde,
    tip: n
  };
}
var XAr = dde("area", NAr, JAr);
function ZAr(t, e) {
  var n = e.clip;
  t.save(), ri(n) ? (t.beginPath(), n(t), t.clip()) : Ont(t, e.group);
}
function Ont(t, e) {
  t.beginPath(), ode(e) ? vx(t, e, 0, 0) : t.rect(0, 0, e.width || 0, e.height || 0), t.clip();
}
function Fnt(t) {
  const e = bh(t.strokeWidth, 1);
  return t.strokeOffset != null ? t.strokeOffset : t.stroke && e > 0.5 && e < 1.5 ? 0.5 - Math.abs(e - 1) : 0;
}
function elr(t, e) {
  t("transform", Mnt(e));
}
function Pnt(t, e) {
  const n = Fnt(e);
  t("d", vx(null, e, n, n));
}
function tlr(t, e) {
  t("class", "background"), t("aria-hidden", !0), Pnt(t, e);
}
function nlr(t, e) {
  t("class", "foreground"), t("aria-hidden", !0), e.strokeForeground ? Pnt(t, e) : t("d", "");
}
function rlr(t, e, n) {
  const r = e.clip ? sde(n, e, e) : null;
  t("clip-path", r);
}
function ilr(t, e) {
  if (!e.clip && e.items) {
    const n = e.items, r = n.length;
    for (let i = 0; i < r; ++i)
      t.union(n[i].bounds);
  }
  return (e.clip || e.width || e.height) && !e.noBound && t.add(0, 0).add(e.width || 0, e.height || 0), sm(t, e), t.translate(e.x || 0, e.y || 0);
}
function _N(t, e, n, r) {
  const i = Fnt(e);
  t.beginPath(), vx(t, e, (n || 0) + i, (r || 0) + i);
}
const olr = mO(_N), slr = mO(_N, !1), alr = mO(_N, !0);
function Alr(t, e, n) {
  md(e, (r) => {
    const i = r.x || 0, o = r.y || 0, s = r.strokeForeground, a = r.opacity == null ? 1 : r.opacity;
    (r.stroke || r.fill) && a && (_N(t, r, i, o), bQ(t, r), r.fill && F5(t, r, a) && t.fill(), r.stroke && !s && _Q(t, r, a) && t.stroke()), t.save(), t.translate(i, o), r.clip && Ont(t, r), n && n.translate(-i, -o), md(r, (A) => {
      this.draw(t, A, n);
    }), n && n.translate(i, o), t.restore(), s && r.stroke && a && (_N(t, r, i, o), bQ(t, r), _Q(t, r, a) && t.stroke());
  });
}
function llr(t, e, n, r, i, o) {
  if (e.bounds && !e.bounds.contains(i, o) || !e.items)
    return null;
  const s = n * t.pixelRatio, a = r * t.pixelRatio;
  return P5(e, (A) => {
    let l, c, u;
    const f = A.bounds;
    if (f && !f.contains(i, o))
      return;
    c = A.x || 0, u = A.y || 0;
    const h = c + (A.width || 0), d = u + (A.height || 0), I = A.clip;
    if (I && (i < c || i > h || o < u || o > d))
      return;
    if (t.save(), t.translate(c, u), c = i - c, u = o - u, I && ode(A) && !alr(t, A, s, a))
      return t.restore(), null;
    const m = A.strokeForeground, C = e.interactive !== !1;
    return C && m && A.stroke && slr(t, A, s, a) ? (t.restore(), A) : (l = P5(A, (y) => clr(y, c, u) ? this.pick(y, n, r, c, u) : null), !l && C && (A.fill || !m && A.stroke) && olr(t, A, s, a) && (l = A), t.restore(), l || null);
  });
}
function clr(t, e, n) {
  return (t.interactive !== !1 || t.marktype === "group") && t.bounds && t.bounds.contains(e, n);
}
var ulr = {
  type: "group",
  tag: "g",
  nested: !1,
  attr: elr,
  bound: ilr,
  draw: Alr,
  pick: llr,
  isect: Dnt,
  content: rlr,
  background: tlr,
  foreground: nlr
}, SN = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1"
};
function pde(t, e) {
  var n = t.image;
  return (!n || t.url && t.url !== n.url) && (n = {
    complete: !1,
    width: 0,
    height: 0
  }, e.loadImage(t.url).then((r) => {
    t.image = r, t.image.url = t.url;
  })), n;
}
function Ide(t, e) {
  return t.width != null ? t.width : !e || !e.width ? 0 : t.aspect !== !1 && t.height ? t.height * e.width / e.height : e.width;
}
function mde(t, e) {
  return t.height != null ? t.height : !e || !e.height ? 0 : t.aspect !== !1 && t.width ? t.width * e.height / e.width : e.height;
}
function Uj(t, e) {
  return t === "center" ? e / 2 : t === "right" ? e : 0;
}
function Hj(t, e) {
  return t === "middle" ? e / 2 : t === "bottom" ? e : 0;
}
function flr(t, e, n) {
  const r = pde(e, n), i = Ide(e, r), o = mde(e, r), s = (e.x || 0) - Uj(e.align, i), a = (e.y || 0) - Hj(e.baseline, o), A = !r.src && r.toDataURL ? r.toDataURL() : r.src || "";
  t("href", A, SN["xmlns:xlink"], "xlink:href"), t("transform", Mv(s, a)), t("width", i), t("height", o), t("preserveAspectRatio", e.aspect === !1 ? "none" : "xMidYMid");
}
function glr(t, e) {
  const n = e.image, r = Ide(e, n), i = mde(e, n), o = (e.x || 0) - Uj(e.align, r), s = (e.y || 0) - Hj(e.baseline, i);
  return t.set(o, s, o + r, s + i);
}
function hlr(t, e, n) {
  md(e, (r) => {
    if (n && !n.intersects(r.bounds))
      return;
    const i = pde(r, this);
    let o = Ide(r, i), s = mde(r, i);
    if (o === 0 || s === 0)
      return;
    let a = (r.x || 0) - Uj(r.align, o), A = (r.y || 0) - Hj(r.baseline, s), l, c, u, f;
    r.aspect !== !1 && (c = i.width / i.height, u = r.width / r.height, c === c && u === u && c !== u && (u < c ? (f = o / c, A += (s - f) / 2, s = f) : (f = s * c, a += (o - f) / 2, o = f))), (i.complete || i.toDataURL) && (bQ(t, r), t.globalAlpha = (l = r.opacity) != null ? l : 1, t.imageSmoothingEnabled = r.smooth !== !1, t.drawImage(i, a, A, o, s));
  });
}
var dlr = {
  type: "image",
  tag: "image",
  nested: !1,
  attr: flr,
  bound: glr,
  draw: hlr,
  pick: Gj(),
  isect: qg,
  // bounds check is sufficient
  get: pde,
  xOffset: Uj,
  yOffset: Hj
}, plr = dde("line", LAr, KAr);
function Ilr(t, e) {
  var n = e.scaleX || 1, r = e.scaleY || 1;
  (n !== 1 || r !== 1) && t("vector-effect", "non-scaling-stroke"), t("transform", zAr(e)), t("d", e.path);
}
function e4(t, e) {
  var n = e.path;
  if (n == null)
    return !0;
  var r = e.x || 0, i = e.y || 0, o = e.scaleX || 1, s = e.scaleY || 1, a = (e.angle || 0) * sE, A = e.pathCache;
  (!A || A.path !== n) && ((e.pathCache = A = BQ(n)).path = n), a && t.rotate && t.translate ? (t.translate(r, i), t.rotate(a), bN(t, A, 0, 0, o, s), t.rotate(-a), t.translate(-r, -i)) : bN(t, A, r, i, o, s);
}
function mlr(t, e) {
  return e4(IO(t, e.angle), e) ? t.set(0, 0, 0, 0) : sm(t, e, !0);
}
var Clr = {
  type: "path",
  tag: "path",
  nested: !1,
  attr: Ilr,
  bound: mlr,
  draw: ude(e4),
  pick: fde(e4),
  isect: Ade(e4)
};
function Elr(t, e) {
  t("d", vx(null, e));
}
function ylr(t, e) {
  var n, r;
  return sm(t.set(n = e.x || 0, r = e.y || 0, n + e.width || 0, r + e.height || 0), e);
}
function fMe(t, e) {
  t.beginPath(), vx(t, e);
}
var vlr = {
  type: "rect",
  tag: "path",
  nested: !1,
  attr: Elr,
  bound: ylr,
  draw: ude(fMe),
  pick: fde(fMe),
  isect: Dnt
};
function Blr(t, e) {
  t("transform", Mnt(e)), t("x2", e.x2 != null ? e.x2 - (e.x || 0) : 0), t("y2", e.y2 != null ? e.y2 - (e.y || 0) : 0);
}
function blr(t, e) {
  var n, r;
  return sm(t.set(n = e.x || 0, r = e.y || 0, e.x2 != null ? e.x2 : n, e.y2 != null ? e.y2 : r), e);
}
function knt(t, e, n) {
  var r, i, o, s;
  return e.stroke && _Q(t, e, n) ? (r = e.x || 0, i = e.y || 0, o = e.x2 != null ? e.x2 : r, s = e.y2 != null ? e.y2 : i, t.beginPath(), t.moveTo(r, i), t.lineTo(o, s), !0) : !1;
}
function _lr(t, e, n) {
  md(e, (r) => {
    if (!(n && !n.intersects(r.bounds))) {
      var i = r.opacity == null ? 1 : r.opacity;
      i && knt(t, r, i) && (bQ(t, r), t.stroke());
    }
  });
}
function Slr(t, e, n, r) {
  return t.isPointInStroke ? knt(t, e, 1) && t.isPointInStroke(n, r) : !1;
}
var Qlr = {
  type: "rule",
  tag: "line",
  nested: !1,
  attr: Blr,
  bound: blr,
  draw: _lr,
  pick: Gj(Slr),
  isect: Tnt
}, wlr = hde("shape", MAr), xlr = hde("symbol", OAr, lde);
const gMe = UXe();
var od = {
  height: d0,
  measureWidth: Cde,
  estimateWidth: pie,
  width: pie,
  canvas: Gnt
};
Gnt(!0);
function Gnt(t) {
  od.width = t && kC ? Cde : pie;
}
function pie(t, e) {
  return Unt(AE(t, e), d0(t));
}
function Unt(t, e) {
  return ~~(0.8 * t.length * e);
}
function Cde(t, e) {
  return d0(t) <= 0 || !(e = AE(t, e)) ? 0 : Hnt(e, $j(t));
}
function Hnt(t, e) {
  const n = "(".concat(e, ") ").concat(t);
  let r = gMe.get(n);
  return r === void 0 && (kC.font = e, r = kC.measureText(t).width, gMe.set(n, r)), r;
}
function d0(t) {
  return t.fontSize != null ? +t.fontSize || 0 : 11;
}
function aE(t) {
  return t.lineHeight != null ? t.lineHeight : d0(t) + 2;
}
function Rlr(t) {
  return Nt(t) ? t.length > 1 ? t : t[0] : t;
}
function CO(t) {
  return Rlr(t.lineBreak && t.text && !Nt(t.text) ? t.text.split(t.lineBreak) : t.text);
}
function Ede(t) {
  const e = CO(t);
  return (Nt(e) ? e.length - 1 : 0) * aE(t);
}
function AE(t, e) {
  const n = e == null ? "" : (e + "").trim();
  return t.limit > 0 && n.length ? Tlr(t, n) : n;
}
function Dlr(t) {
  if (od.width === Cde) {
    const e = $j(t);
    return (n) => Hnt(n, e);
  } else {
    const e = d0(t);
    return (n) => Unt(n, e);
  }
}
function Tlr(t, e) {
  var n = +t.limit, r = Dlr(t);
  if (r(e) < n)
    return e;
  var i = t.ellipsis || "…", o = t.dir === "rtl", s = 0, a = e.length, A;
  if (n -= r(i), o) {
    for (; s < a; )
      A = s + a >>> 1, r(e.slice(A)) > n ? s = A + 1 : a = A;
    return i + e.slice(s);
  } else {
    for (; s < a; )
      A = 1 + (s + a >>> 1), r(e.slice(0, A)) < n ? s = A : a = A - 1;
    return e.slice(0, s) + i;
  }
}
function EO(t, e) {
  var n = t.font;
  return (e && n ? String(n).replace(/"/g, "'") : n) || "sans-serif";
}
function $j(t, e) {
  return (t.fontStyle ? t.fontStyle + " " : "") + (t.fontVariant ? t.fontVariant + " " : "") + (t.fontWeight ? t.fontWeight + " " : "") + d0(t) + "px " + EO(t, e);
}
function yde(t) {
  var e = t.baseline, n = d0(t);
  return Math.round(e === "top" ? 0.79 * n : e === "middle" ? 0.3 * n : e === "bottom" ? -0.21 * n : e === "line-top" ? 0.29 * n + 0.5 * aE(t) : e === "line-bottom" ? 0.29 * n - 0.5 * aE(t) : 0);
}
const Nlr = {
  left: "start",
  center: "middle",
  right: "end"
}, GD = new za();
function qj(t) {
  var e = t.x || 0, n = t.y || 0, r = t.radius || 0, i;
  return r && (i = (t.theta || 0) - Xy, e += r * Math.cos(i), n += r * Math.sin(i)), GD.x1 = e, GD.y1 = n, GD;
}
function Llr(t, e) {
  var n = e.dx || 0, r = (e.dy || 0) + yde(e), i = qj(e), o = i.x1, s = i.y1, a = e.angle || 0, A;
  t("text-anchor", Nlr[e.align] || "start"), a ? (A = Mv(o, s) + " " + gde(a), (n || r) && (A += " " + Mv(n, r))) : A = Mv(o + n, s + r), t("transform", A);
}
function vde(t, e, n) {
  var r = od.height(e), i = e.align, o = qj(e), s = o.x1, a = o.y1, A = e.dx || 0, l = (e.dy || 0) + yde(e) - Math.round(0.8 * r), c = CO(e), u;
  if (Nt(c) ? (r += aE(e) * (c.length - 1), u = c.reduce((f, h) => Math.max(f, od.width(e, h)), 0)) : u = od.width(e, c), i === "center" ? A -= u / 2 : i === "right" && (A -= u), t.set(A += s, l += a, A + u, l + r), e.angle && !n)
    t.rotate(e.angle * sE, s, a);
  else if (n === 2)
    return t.rotatedPoints(e.angle * sE, s, a);
  return t;
}
function Mlr(t, e, n) {
  md(e, (r) => {
    var i = r.opacity == null ? 1 : r.opacity, o, s, a, A, l, c, u;
    if (!(n && !n.intersects(r.bounds) || // bounds check
    i === 0 || r.fontSize <= 0 || r.text == null || r.text.length === 0)) {
      if (t.font = $j(r), t.textAlign = r.align || "left", o = qj(r), s = o.x1, a = o.y1, r.angle && (t.save(), t.translate(s, a), t.rotate(r.angle * sE), s = a = 0), s += r.dx || 0, a += (r.dy || 0) + yde(r), c = CO(r), bQ(t, r), Nt(c))
        for (l = aE(r), A = 0; A < c.length; ++A)
          u = AE(r, c[A]), r.fill && F5(t, r, i) && t.fillText(u, s, a), r.stroke && _Q(t, r, i) && t.strokeText(u, s, a), a += l;
      else
        u = AE(r, c), r.fill && F5(t, r, i) && t.fillText(u, s, a), r.stroke && _Q(t, r, i) && t.strokeText(u, s, a);
      r.angle && t.restore();
    }
  });
}
function Olr(t, e, n, r, i, o) {
  if (e.fontSize <= 0)
    return !1;
  if (!e.angle)
    return !0;
  var s = qj(e), a = s.x1, A = s.y1, l = vde(GD, e, 1), c = -e.angle * sE, u = Math.cos(c), f = Math.sin(c), h = u * i - f * o + (a - u * a + f * A), d = f * i + u * o + (A - f * a - u * A);
  return l.contains(h, d);
}
function Flr(t, e) {
  const n = vde(GD, t, 2);
  return S_(e, n[0], n[1], n[2], n[3]) || S_(e, n[0], n[1], n[4], n[5]) || S_(e, n[4], n[5], n[6], n[7]) || S_(e, n[2], n[3], n[6], n[7]);
}
var Plr = {
  type: "text",
  tag: "text",
  nested: !1,
  attr: Llr,
  bound: vde,
  draw: Mlr,
  pick: Gj(Olr),
  isect: Flr
}, klr = dde("trail", FAr, WAr), Hf = {
  arc: VAr,
  area: XAr,
  group: ulr,
  image: dlr,
  line: plr,
  path: Clr,
  rect: vlr,
  rule: Qlr,
  shape: wlr,
  symbol: xlr,
  text: Plr,
  trail: klr
};
function Iie(t, e, n) {
  var r = Hf[t.mark.marktype], i = e || r.bound;
  return r.nested && (t = t.mark), i(t.bounds || (t.bounds = new za()), t, n);
}
var hMe = {
  mark: null
};
function $nt(t, e, n) {
  var r = Hf[t.marktype], i = r.bound, o = t.items, s = o && o.length, a, A, l, c;
  if (r.nested)
    return s ? l = o[0] : (hMe.mark = t, l = hMe), c = Iie(l, i, n), e = e && e.union(c) || c, e;
  if (e = e || t.bounds && t.bounds.clear() || new za(), s)
    for (a = 0, A = o.length; a < A; ++a)
      e.union(Iie(o[a], i, n));
  return t.bounds = e;
}
const Glr = [
  "marktype",
  "name",
  "role",
  "interactive",
  "clip",
  "items",
  "zindex",
  "x",
  "y",
  "width",
  "height",
  "align",
  "baseline",
  // layout
  "fill",
  "fillOpacity",
  "opacity",
  "blend",
  // fill
  "stroke",
  "strokeOpacity",
  "strokeWidth",
  "strokeCap",
  // stroke
  "strokeDash",
  "strokeDashOffset",
  // stroke dash
  "strokeForeground",
  "strokeOffset",
  // group
  "startAngle",
  "endAngle",
  "innerRadius",
  "outerRadius",
  // arc
  "cornerRadius",
  "padAngle",
  // arc, rect
  "cornerRadiusTopLeft",
  "cornerRadiusTopRight",
  // rect, group
  "cornerRadiusBottomLeft",
  "cornerRadiusBottomRight",
  "interpolate",
  "tension",
  "orient",
  "defined",
  // area, line
  "url",
  "aspect",
  "smooth",
  // image
  "path",
  "scaleX",
  "scaleY",
  // path
  "x2",
  "y2",
  // rule
  "size",
  "shape",
  // symbol
  "text",
  "angle",
  "theta",
  "radius",
  "dir",
  "dx",
  "dy",
  // text
  "ellipsis",
  "limit",
  "lineBreak",
  "lineHeight",
  "font",
  "fontSize",
  "fontWeight",
  "fontStyle",
  "fontVariant",
  // font
  "description",
  "aria",
  "ariaRole",
  "ariaRoleDescription"
  // aria
];
function qnt(t, e) {
  return JSON.stringify(t, Glr, e);
}
function jnt(t) {
  const e = typeof t == "string" ? JSON.parse(t) : t;
  return Ynt(e);
}
function Ynt(t) {
  var e = t.marktype, n = t.items, r, i, o;
  if (n)
    for (i = 0, o = n.length; i < o; ++i)
      r = e ? "mark" : "group", n[i][r] = t, n[i].zindex && (n[i][r].zdirty = !0), (e || r) === "group" && Ynt(n[i]);
  return e && $nt(t), t;
}
function Bde(t) {
  arguments.length ? this.root = jnt(t) : (this.root = znt({
    marktype: "group",
    name: "root",
    role: "frame"
  }), this.root.items = [new Pj(this.root)]);
}
Bde.prototype = {
  toJSON(t) {
    return qnt(this.root, t || 0);
  },
  mark(t, e, n) {
    e = e || this.root.items[0];
    const r = znt(t, e);
    return e.items[n] = r, r.zindex && (r.group.zdirty = !0), r;
  }
};
function znt(t, e) {
  const n = {
    bounds: new za(),
    clip: !!t.clip,
    group: e,
    interactive: t.interactive !== !1,
    items: [],
    marktype: t.marktype,
    name: t.name || void 0,
    role: t.role || void 0,
    zindex: t.zindex || 0
  };
  return t.aria != null && (n.aria = t.aria), t.description && (n.description = t.description), n;
}
function IC(t, e, n) {
  return !t && typeof document < "u" && document.createElement && (t = document), t ? n ? t.createElementNS(n, e) : t.createElement(e) : null;
}
function bde(t, e) {
  e = e.toLowerCase();
  for (var n = t.childNodes, r = 0, i = n.length; r < i; ++r)
    if (n[r].tagName.toLowerCase() === e)
      return n[r];
}
function bu(t, e, n, r) {
  var i = t.childNodes[e], o;
  return (!i || i.tagName.toLowerCase() !== n.toLowerCase()) && (o = i || null, i = IC(t.ownerDocument, n, r), t.insertBefore(i, o)), i;
}
function Ph(t, e) {
  for (var n = t.childNodes, r = n.length; r > e; )
    t.removeChild(n[--r]);
  return t;
}
function Vnt(t) {
  return "mark-" + t.marktype + (t.role ? " role-" + t.role : "") + (t.name ? " " + t.name : "");
}
function jj(t, e) {
  const n = e.getBoundingClientRect();
  return [t.clientX - n.left - (e.clientLeft || 0), t.clientY - n.top - (e.clientTop || 0)];
}
function Ulr(t, e, n, r) {
  var i = t && t.mark, o, s;
  if (i && (o = Hf[i.marktype]).tip) {
    for (s = jj(e, n), s[0] -= r[0], s[1] -= r[1]; t = t.mark.group; )
      s[0] -= t.x || 0, s[1] -= t.y || 0;
    t = o.tip(i.items, s);
  }
  return t;
}
function lE(t, e) {
  this._active = null, this._handlers = {}, this._loader = t || fj(), this._tooltip = e || Hlr;
}
function Hlr(t, e, n, r) {
  t.element().setAttribute("title", r || "");
}
lE.prototype = {
  /**
   * Initialize a new Handler instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {object} [obj] - Optional context object that should serve as
   *   the "this" context for event callbacks.
   * @return {Handler} - This handler instance.
   */
  initialize(t, e, n) {
    return this._el = t, this._obj = n || null, this.origin(e);
  },
  /**
   * Returns the parent container element for a visualization.
   * @return {DOMElement} - The containing DOM element.
   */
  element() {
    return this._el;
  },
  /**
   * Returns the scene element (e.g., canvas or SVG) of the visualization
   * Subclasses must override if the first child is not the scene element.
   * @return {DOMElement} - The scene (e.g., canvas or SVG) element.
   */
  canvas() {
    return this._el && this._el.firstChild;
  },
  /**
   * Get / set the origin coordinates of the visualization.
   */
  origin(t) {
    return arguments.length ? (this._origin = t || [0, 0], this) : this._origin.slice();
  },
  /**
   * Get / set the scenegraph root.
   */
  scene(t) {
    return arguments.length ? (this._scene = t, this) : this._scene;
  },
  /**
   * Add an event handler. Subclasses should override this method.
   */
  on() {
  },
  /**
   * Remove an event handler. Subclasses should override this method.
   */
  off() {
  },
  /**
   * Utility method for finding the array index of an event handler.
   * @param {Array} h - An array of registered event handlers.
   * @param {string} type - The event type.
   * @param {function} handler - The event handler instance to find.
   * @return {number} - The handler's array index or -1 if not registered.
   */
  _handlerIndex(t, e, n) {
    for (let r = t ? t.length : 0; --r >= 0; )
      if (t[r].type === e && (!n || t[r].handler === n))
        return r;
    return -1;
  },
  /**
   * Returns an array with registered event handlers.
   * @param {string} [type] - The event type to query. Any annotations
   *   are ignored; for example, for the argument "click.foo", ".foo" will
   *   be ignored and the method returns all "click" handlers. If type is
   *   null or unspecified, this method returns handlers for all types.
   * @return {Array} - A new array containing all registered event handlers.
   */
  handlers(t) {
    const e = this._handlers, n = [];
    if (t)
      n.push(...e[this.eventName(t)]);
    else
      for (const r in e)
        n.push(...e[r]);
    return n;
  },
  /**
   * Parses an event name string to return the specific event type.
   * For example, given "click.foo" returns "click"
   * @param {string} name - The input event type string.
   * @return {string} - A string with the event type only.
   */
  eventName(t) {
    const e = t.indexOf(".");
    return e < 0 ? t : t.slice(0, e);
  },
  /**
   * Handle hyperlink navigation in response to an item.href value.
   * @param {Event} event - The event triggering hyperlink navigation.
   * @param {Item} item - The scenegraph item.
   * @param {string} href - The URL to navigate to.
   */
  handleHref(t, e, n) {
    this._loader.sanitize(n, {
      context: "href"
    }).then((r) => {
      const i = new MouseEvent(t.type, t), o = IC(null, "a");
      for (const s in r)
        o.setAttribute(s, r[s]);
      o.dispatchEvent(i);
    }).catch(() => {
    });
  },
  /**
   * Handle tooltip display in response to an item.tooltip value.
   * @param {Event} event - The event triggering tooltip display.
   * @param {Item} item - The scenegraph item.
   * @param {boolean} show - A boolean flag indicating whether
   *   to show or hide a tooltip for the given item.
   */
  handleTooltip(t, e, n) {
    if (e && e.tooltip != null) {
      e = Ulr(e, t, this.canvas(), this._origin);
      const r = n && e && e.tooltip || null;
      this._tooltip.call(this._obj, this, t, e, r);
    }
  },
  /**
   * Returns the size of a scenegraph item and its position relative
   * to the viewport.
   * @param {Item} item - The scenegraph item.
   * @return {object} - A bounding box object (compatible with the
   *   DOMRect type) consisting of x, y, width, heigh, top, left,
   *   right, and bottom properties.
   */
  getItemBoundingClientRect(t) {
    const e = this.canvas();
    if (!e)
      return;
    const n = e.getBoundingClientRect(), r = this._origin, i = t.bounds, o = i.width(), s = i.height();
    let a = i.x1 + r[0] + n.left, A = i.y1 + r[1] + n.top;
    for (; t.mark && (t = t.mark.group); )
      a += t.x || 0, A += t.y || 0;
    return {
      x: a,
      y: A,
      width: o,
      height: s,
      left: a,
      top: A,
      right: a + o,
      bottom: A + s
    };
  }
};
function p0(t) {
  this._el = null, this._bgcolor = null, this._loader = new ade(t);
}
p0.prototype = {
  /**
   * Initialize a new Renderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {Renderer} - This renderer instance.
   */
  initialize(t, e, n, r, i) {
    return this._el = t, this.resize(e, n, r, i);
  },
  /**
   * Returns the parent container element for a visualization.
   * @return {DOMElement} - The containing DOM element.
   */
  element() {
    return this._el;
  },
  /**
   * Returns the scene element (e.g., canvas or SVG) of the visualization
   * Subclasses must override if the first child is not the scene element.
   * @return {DOMElement} - The scene (e.g., canvas or SVG) element.
   */
  canvas() {
    return this._el && this._el.firstChild;
  },
  /**
   * Get / set the background color.
   */
  background(t) {
    return arguments.length === 0 ? this._bgcolor : (this._bgcolor = t, this);
  },
  /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {Renderer} - This renderer instance;
   */
  resize(t, e, n, r) {
    return this._width = t, this._height = e, this._origin = n || [0, 0], this._scale = r || 1, this;
  },
  /**
   * Report a dirty item whose bounds should be redrawn.
   * This base class method does nothing. Subclasses that perform
   * incremental should implement this method.
   * @param {Item} item - The dirty item whose bounds should be redrawn.
   */
  dirty() {
  },
  /**
   * Render an input scenegraph, potentially with a set of dirty items.
   * This method will perform an immediate rendering with available resources.
   * The renderer may also need to perform image loading to perform a complete
   * render. This process can lead to asynchronous re-rendering of the scene
   * after this method returns. To receive notification when rendering is
   * complete, use the renderAsync method instead.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @return {Renderer} - This renderer instance.
   */
  render(t) {
    const e = this;
    return e._call = function() {
      e._render(t);
    }, e._call(), e._call = null, e;
  },
  /**
   * Internal rendering method. Renderer subclasses should override this
   * method to actually perform rendering.
   * @param {object} scene - The root mark of a scenegraph to render.
   */
  _render() {
  },
  /**
   * Asynchronous rendering method. Similar to render, but returns a Promise
   * that resolves when all rendering is completed. Sometimes a renderer must
   * perform image loading to get a complete rendering. The returned
   * Promise will not resolve until this process completes.
   * @param {object} scene - The root mark of a scenegraph to render.
   * @return {Promise} - A Promise that resolves when rendering is complete.
   */
  renderAsync(t) {
    const e = this.render(t);
    return this._ready ? this._ready.then(() => e) : Promise.resolve(e);
  },
  /**
   * Internal method for asynchronous resource loading.
   * Proxies method calls to the ImageLoader, and tracks loading
   * progress to invoke a re-render once complete.
   * @param {string} method - The method name to invoke on the ImageLoader.
   * @param {string} uri - The URI for the requested resource.
   * @return {Promise} - A Promise that resolves to the requested resource.
   */
  _load(t, e) {
    var n = this, r = n._loader[t](e);
    if (!n._ready) {
      const i = n._call;
      n._ready = n._loader.ready().then((o) => {
        o && i(), n._ready = null;
      });
    }
    return r;
  },
  /**
   * Sanitize a URL to include as a hyperlink in the rendered scene.
   * This method proxies a call to ImageLoader.sanitizeURL, but also tracks
   * image loading progress and invokes a re-render once complete.
   * @param {string} uri - The URI string to sanitize.
   * @return {Promise} - A Promise that resolves to the sanitized URL.
   */
  sanitizeURL(t) {
    return this._load("sanitizeURL", t);
  },
  /**
   * Requests an image to include in the rendered scene.
   * This method proxies a call to ImageLoader.loadImage, but also tracks
   * image loading progress and invokes a re-render once complete.
   * @param {string} uri - The URI string of the image.
   * @return {Promise} - A Promise that resolves to the loaded Image.
   */
  loadImage(t) {
    return this._load("loadImage", t);
  }
};
const $lr = "keydown", qlr = "keypress", jlr = "keyup", Jnt = "dragenter", t4 = "dragleave", Knt = "dragover", mie = "mousedown", Ylr = "mouseup", k5 = "mousemove", UD = "mouseout", Wnt = "mouseover", G5 = "click", zlr = "dblclick", Vlr = "wheel", Xnt = "mousewheel", U5 = "touchstart", H5 = "touchmove", $5 = "touchend", Jlr = [$lr, qlr, jlr, Jnt, t4, Knt, mie, Ylr, k5, UD, Wnt, G5, zlr, Vlr, Xnt, U5, H5, $5], Cie = k5, QN = UD, Eie = G5;
function yO(t, e) {
  lE.call(this, t, e), this._down = null, this._touch = null, this._first = !0, this._events = {};
}
const Klr = (t) => t === U5 || t === H5 || t === $5 ? [U5, H5, $5] : [t];
function dMe(t, e) {
  Klr(e).forEach((n) => Wlr(t, n));
}
function Wlr(t, e) {
  const n = t.canvas();
  n && !t._events[e] && (t._events[e] = 1, n.addEventListener(e, t[e] ? (r) => t[e](r) : (r) => t.fire(e, r)));
}
function pMe(t, e, n) {
  return function(r) {
    const i = this._active, o = this.pickEvent(r);
    o === i ? this.fire(t, r) : ((!i || !i.exit) && this.fire(n, r), this._active = o, this.fire(e, r), this.fire(t, r));
  };
}
function IMe(t) {
  return function(e) {
    this.fire(t, e), this._active = null;
  };
}
on(yO, lE, {
  initialize(t, e, n) {
    return this._canvas = t && bde(t, "canvas"), [G5, mie, k5, UD, t4].forEach((r) => dMe(this, r)), lE.prototype.initialize.call(this, t, e, n);
  },
  // return the backing canvas instance
  canvas() {
    return this._canvas;
  },
  // retrieve the current canvas context
  context() {
    return this._canvas.getContext("2d");
  },
  // supported events
  events: Jlr,
  // to keep old versions of firefox happy
  DOMMouseScroll(t) {
    this.fire(Xnt, t);
  },
  mousemove: pMe(k5, Wnt, UD),
  dragover: pMe(Knt, Jnt, t4),
  mouseout: IMe(UD),
  dragleave: IMe(t4),
  mousedown(t) {
    this._down = this._active, this.fire(mie, t);
  },
  click(t) {
    this._down === this._active && (this.fire(G5, t), this._down = null);
  },
  touchstart(t) {
    this._touch = this.pickEvent(t.changedTouches[0]), this._first && (this._active = this._touch, this._first = !1), this.fire(U5, t, !0);
  },
  touchmove(t) {
    this.fire(H5, t, !0);
  },
  touchend(t) {
    this.fire($5, t, !0), this._touch = null;
  },
  // fire an event
  fire(t, e, n) {
    const r = n ? this._touch : this._active, i = this._handlers[t];
    if (e.vegaType = t, t === Eie && r && r.href ? this.handleHref(e, r, r.href) : (t === Cie || t === QN) && this.handleTooltip(e, r, t !== QN), i)
      for (let o = 0, s = i.length; o < s; ++o)
        i[o].handler.call(this._obj, e, r);
  },
  // add an event handler
  on(t, e) {
    const n = this.eventName(t), r = this._handlers;
    return this._handlerIndex(r[n], t, e) < 0 && (dMe(this, t), (r[n] || (r[n] = [])).push({
      type: t,
      handler: e
    })), this;
  },
  // remove an event handler
  off(t, e) {
    const n = this.eventName(t), r = this._handlers[n], i = this._handlerIndex(r, t, e);
    return i >= 0 && r.splice(i, 1), this;
  },
  pickEvent(t) {
    const e = jj(t, this._canvas), n = this._origin;
    return this.pick(this._scene, e[0], e[1], e[0] - n[0], e[1] - n[1]);
  },
  // find the scenegraph item at the current mouse position
  // x, y -- the absolute x, y mouse coordinates on the canvas element
  // gx, gy -- the relative coordinates within the current group
  pick(t, e, n, r, i) {
    const o = this.context();
    return Hf[t.marktype].pick.call(this, o, t, e, n, r, i);
  }
});
function Xlr() {
  return typeof window < "u" && window.devicePixelRatio || 1;
}
var Zlr = Xlr();
function ecr(t, e, n, r, i, o) {
  const s = typeof HTMLElement < "u" && t instanceof HTMLElement && t.parentNode != null, a = t.getContext("2d"), A = s ? Zlr : i;
  t.width = e * A, t.height = n * A;
  for (const l in o)
    a[l] = o[l];
  return s && A !== 1 && (t.style.width = e + "px", t.style.height = n + "px"), a.pixelRatio = A, a.setTransform(A, 0, 0, A, A * r[0], A * r[1]), t;
}
function q5(t) {
  p0.call(this, t), this._options = {}, this._redraw = !1, this._dirty = new za(), this._tempb = new za();
}
const mMe = p0.prototype, tcr = (t, e, n) => new za().set(0, 0, e, n).translate(-t[0], -t[1]);
function ncr(t, e, n) {
  return e.expand(1).round(), t.pixelRatio % 1 && e.scale(t.pixelRatio).round().scale(1 / t.pixelRatio), e.translate(-(n[0] % 1), -(n[1] % 1)), t.beginPath(), t.rect(e.x1, e.y1, e.width(), e.height()), t.clip(), e;
}
on(q5, p0, {
  initialize(t, e, n, r, i, o) {
    return this._options = o || {}, this._canvas = this._options.externalContext ? null : PC(1, 1, this._options.type), t && this._canvas && (Ph(t, 0).appendChild(this._canvas), this._canvas.setAttribute("class", "marks")), mMe.initialize.call(this, t, e, n, r, i);
  },
  resize(t, e, n, r) {
    if (mMe.resize.call(this, t, e, n, r), this._canvas)
      ecr(this._canvas, this._width, this._height, this._origin, this._scale, this._options.context);
    else {
      const i = this._options.externalContext;
      i || wt("CanvasRenderer is missing a valid canvas or context"), i.scale(this._scale, this._scale), i.translate(this._origin[0], this._origin[1]);
    }
    return this._redraw = !0, this;
  },
  canvas() {
    return this._canvas;
  },
  context() {
    return this._options.externalContext || (this._canvas ? this._canvas.getContext("2d") : null);
  },
  dirty(t) {
    const e = this._tempb.clear().union(t.bounds);
    let n = t.mark.group;
    for (; n; )
      e.translate(n.x || 0, n.y || 0), n = n.mark.group;
    this._dirty.union(e);
  },
  _render(t) {
    const e = this.context(), n = this._origin, r = this._width, i = this._height, o = this._dirty, s = tcr(n, r, i);
    e.save();
    const a = this._redraw || o.empty() ? (this._redraw = !1, s.expand(1)) : ncr(e, s.intersect(o), n);
    return this.clear(-n[0], -n[1], r, i), this.draw(e, t, a), e.restore(), o.clear(), this;
  },
  draw(t, e, n) {
    const r = Hf[e.marktype];
    e.clip && ZAr(t, e), r.draw.call(this, t, e, n), e.clip && t.restore();
  },
  clear(t, e, n, r) {
    const i = this._options, o = this.context();
    i.type !== "pdf" && !i.externalContext && o.clearRect(t, e, n, r), this._bgcolor != null && (o.fillStyle = this._bgcolor, o.fillRect(t, e, n, r));
  }
});
function _de(t, e) {
  lE.call(this, t, e);
  const n = this;
  n._hrefHandler = yie(n, (r, i) => {
    i && i.href && n.handleHref(r, i, i.href);
  }), n._tooltipHandler = yie(n, (r, i) => {
    n.handleTooltip(r, i, r.type !== QN);
  });
}
const yie = (t, e) => (n) => {
  let r = n.target.__data__;
  r = Array.isArray(r) ? r[0] : r, n.vegaType = n.type, e.call(t._obj, n, r);
};
on(_de, lE, {
  initialize(t, e, n) {
    let r = this._svg;
    return r && (r.removeEventListener(Eie, this._hrefHandler), r.removeEventListener(Cie, this._tooltipHandler), r.removeEventListener(QN, this._tooltipHandler)), this._svg = r = t && bde(t, "svg"), r && (r.addEventListener(Eie, this._hrefHandler), r.addEventListener(Cie, this._tooltipHandler), r.addEventListener(QN, this._tooltipHandler)), lE.prototype.initialize.call(this, t, e, n);
  },
  canvas() {
    return this._svg;
  },
  // add an event handler
  on(t, e) {
    const n = this.eventName(t), r = this._handlers;
    if (this._handlerIndex(r[n], t, e) < 0) {
      const o = {
        type: t,
        handler: e,
        listener: yie(this, e)
      };
      (r[n] || (r[n] = [])).push(o), this._svg && this._svg.addEventListener(n, o.listener);
    }
    return this;
  },
  // remove an event handler
  off(t, e) {
    const n = this.eventName(t), r = this._handlers[n], i = this._handlerIndex(r, t, e);
    return i >= 0 && (this._svg && this._svg.removeEventListener(n, r[i].listener), r.splice(i, 1)), this;
  }
});
const Znt = "aria-hidden", Sde = "aria-label", Qde = "role", wde = "aria-roledescription", ert = "graphics-object", xde = "graphics-symbol", trt = (t, e, n) => ({
  [Qde]: t,
  [wde]: e,
  [Sde]: n || void 0
}), rcr = pd(["axis-domain", "axis-grid", "axis-label", "axis-tick", "axis-title", "legend-band", "legend-entry", "legend-gradient", "legend-label", "legend-title", "legend-symbol", "title"]), CMe = {
  axis: {
    desc: "axis",
    caption: scr
  },
  legend: {
    desc: "legend",
    caption: acr
  },
  "title-text": {
    desc: "title",
    caption: (t) => "Title text '".concat(yMe(t), "'")
  },
  "title-subtitle": {
    desc: "subtitle",
    caption: (t) => "Subtitle text '".concat(yMe(t), "'")
  }
}, EMe = {
  ariaRole: Qde,
  ariaRoleDescription: wde,
  description: Sde
};
function nrt(t, e) {
  const n = e.aria === !1;
  if (t(Znt, n || void 0), n || e.description == null)
    for (const r in EMe)
      t(EMe[r], void 0);
  else {
    const r = e.mark.marktype;
    t(Sde, e.description), t(Qde, e.ariaRole || (r === "group" ? ert : xde)), t(wde, e.ariaRoleDescription || "".concat(r, " mark"));
  }
}
function rrt(t) {
  return t.aria === !1 ? {
    [Znt]: !0
  } : rcr[t.role] ? null : CMe[t.role] ? ocr(t, CMe[t.role]) : icr(t);
}
function icr(t) {
  const e = t.marktype, n = e === "group" || e === "text" || t.items.some((r) => r.description != null && r.aria !== !1);
  return trt(n ? ert : xde, "".concat(e, " mark container"), t.description);
}
function ocr(t, e) {
  try {
    const n = t.items[0], r = e.caption || (() => "");
    return trt(e.role || xde, e.desc, n.description || r(n));
  } catch {
    return null;
  }
}
function yMe(t) {
  return bn(t.text).join(" ");
}
function scr(t) {
  const e = t.datum, n = t.orient, r = e.title ? irt(t) : null, i = t.context, o = i.scales[e.scale].value, s = i.dataflow.locale(), a = o.type, A = n === "left" || n === "right" ? "Y" : "X";
  return "".concat(A, "-axis") + (r ? " titled '".concat(r, "'") : "") + " for a ".concat(vQ(a) ? "discrete" : a, " scale") + " with ".concat(ynt(s, o, t));
}
function acr(t) {
  const e = t.datum, n = e.title ? irt(t) : null, r = "".concat(e.type || "", " legend").trim(), i = e.scales, o = Object.keys(i), s = t.context, a = s.scales[i[o[0]]].value, A = s.dataflow.locale();
  return lcr(r) + (n ? " titled '".concat(n, "'") : "") + " for ".concat(Acr(o)) + " with ".concat(ynt(A, a, t));
}
function irt(t) {
  try {
    return bn(bi(t.items).items[0].text).join(" ");
  } catch {
    return null;
  }
}
function Acr(t) {
  return t = t.map((e) => e + (e === "fill" || e === "stroke" ? " color" : "")), t.length < 2 ? t[0] : t.slice(0, -1).join(", ") + " and " + bi(t);
}
function lcr(t) {
  return t.length ? t[0].toUpperCase() + t.slice(1) : t;
}
const ort = (t) => (t + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), ccr = (t) => ort(t).replace(/"/g, "&quot;").replace(/\t/g, "&#x9;").replace(/\n/g, "&#xA;").replace(/\r/g, "&#xD;");
function Rde() {
  let t = "", e = "", n = "";
  const r = [], i = () => e = n = "", o = (A) => {
    e && (t += "".concat(e, ">").concat(n), i()), r.push(A);
  }, s = (A, l) => (l != null && (e += " ".concat(A, '="').concat(ccr(l), '"')), a), a = {
    open(A) {
      o(A), e = "<" + A;
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      for (const f of c)
        for (const h in f)
          s(h, f[h]);
      return a;
    },
    close() {
      const A = r.pop();
      return e ? t += e + (n ? ">".concat(n, "</").concat(A, ">") : "/>") : t += "</".concat(A, ">"), i(), a;
    },
    attr: s,
    text: (A) => (n += ort(A), a),
    toString: () => t
  };
  return a;
}
const srt = (t) => art(Rde(), t) + "";
function art(t, e) {
  if (t.open(e.tagName), e.hasAttributes()) {
    const n = e.attributes, r = n.length;
    for (let i = 0; i < r; ++i)
      t.attr(n[i].name, n[i].value);
  }
  if (e.hasChildNodes()) {
    const n = e.childNodes;
    for (const r of n)
      r.nodeType === 3 ? t.text(r.nodeValue) : art(t, r);
  }
  return t.close();
}
const j5 = {
  fill: "fill",
  fillOpacity: "fill-opacity",
  stroke: "stroke",
  strokeOpacity: "stroke-opacity",
  strokeWidth: "stroke-width",
  strokeCap: "stroke-linecap",
  strokeJoin: "stroke-linejoin",
  strokeDash: "stroke-dasharray",
  strokeDashOffset: "stroke-dashoffset",
  strokeMiterLimit: "stroke-miterlimit",
  opacity: "opacity"
}, Y5 = {
  blend: "mix-blend-mode"
}, Art = {
  fill: "none",
  "stroke-miterlimit": 10
}, V2 = 0, vMe = "http://www.w3.org/2000/xmlns/", aA = SN.xmlns;
function Dde(t) {
  p0.call(this, t), this._dirtyID = 0, this._dirty = [], this._svg = null, this._root = null, this._defs = null;
}
const wW = p0.prototype;
on(Dde, p0, {
  /**
   * Initialize a new SVGRenderer instance.
   * @param {DOMElement} el - The containing DOM element for the display.
   * @param {number} width - The coordinate width of the display, in pixels.
   * @param {number} height - The coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance.
   */
  initialize(t, e, n, r, i) {
    return this._defs = {}, this._clearDefs(), t && (this._svg = bu(t, 0, "svg", aA), this._svg.setAttributeNS(vMe, "xmlns", aA), this._svg.setAttributeNS(vMe, "xmlns:xlink", SN["xmlns:xlink"]), this._svg.setAttribute("version", SN.version), this._svg.setAttribute("class", "marks"), Ph(t, 1), this._root = bu(this._svg, V2, "g", aA), mC(this._root, Art), Ph(this._svg, V2 + 1)), this.background(this._bgcolor), wW.initialize.call(this, t, e, n, r, i);
  },
  /**
   * Get / set the background color.
   */
  background(t) {
    return arguments.length && this._svg && this._svg.style.setProperty("background-color", t), wW.background.apply(this, arguments);
  },
  /**
   * Resize the display.
   * @param {number} width - The new coordinate width of the display, in pixels.
   * @param {number} height - The new coordinate height of the display, in pixels.
   * @param {Array<number>} origin - The new origin of the display, in pixels.
   *   The coordinate system will be translated to this point.
   * @param {number} [scaleFactor=1] - Optional scaleFactor by which to multiply
   *   the width and height to determine the final pixel size.
   * @return {SVGRenderer} - This renderer instance;
   */
  resize(t, e, n, r) {
    return wW.resize.call(this, t, e, n, r), this._svg && (mC(this._svg, {
      width: this._width * this._scale,
      height: this._height * this._scale,
      viewBox: "0 0 ".concat(this._width, " ").concat(this._height)
    }), this._root.setAttribute("transform", "translate(".concat(this._origin, ")"))), this._dirty = [], this;
  },
  /**
   * Returns the SVG element of the visualization.
   * @return {DOMElement} - The SVG element.
   */
  canvas() {
    return this._svg;
  },
  /**
   * Returns an SVG text string for the rendered content,
   * or null if this renderer is currently headless.
   */
  svg() {
    const t = this._svg, e = this._bgcolor;
    if (!t)
      return null;
    let n;
    e && (t.removeAttribute("style"), n = bu(t, V2, "rect", aA), mC(n, {
      width: this._width,
      height: this._height,
      fill: e
    }));
    const r = srt(t);
    return e && (t.removeChild(n), this._svg.style.setProperty("background-color", e)), r;
  },
  /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   */
  _render(t) {
    return this._dirtyCheck() && (this._dirtyAll && this._clearDefs(), this.mark(this._root, t), Ph(this._root, 1)), this.defs(), this._dirty = [], ++this._dirtyID, this;
  },
  // -- Manage rendering of items marked as dirty --
  /**
   * Flag a mark item as dirty.
   * @param {Item} item - The mark item.
   */
  dirty(t) {
    t.dirty !== this._dirtyID && (t.dirty = this._dirtyID, this._dirty.push(t));
  },
  /**
   * Check if a mark item is considered dirty.
   * @param {Item} item - The mark item.
   */
  isDirty(t) {
    return this._dirtyAll || !t._svg || !t._svg.ownerSVGElement || t.dirty === this._dirtyID;
  },
  /**
   * Internal method to check dirty status and, if possible,
   * make targetted updates without a full rendering pass.
   */
  _dirtyCheck() {
    this._dirtyAll = !0;
    const t = this._dirty;
    if (!t.length || !this._dirtyID)
      return !0;
    const e = ++this._dirtyID;
    let n, r, i, o, s, a, A;
    for (s = 0, a = t.length; s < a; ++s)
      if (n = t[s], r = n.mark, r.marktype !== i && (i = r.marktype, o = Hf[i]), r.zdirty && r.dirty !== e && (this._dirtyAll = !1, BMe(n, e), r.items.forEach((l) => {
        l.dirty = e;
      })), !r.zdirty) {
        if (n.exit) {
          o.nested && r.items.length ? (A = r.items[0], A._svg && this._update(o, A._svg, A)) : n._svg && (A = n._svg.parentNode, A && A.removeChild(n._svg)), n._svg = null;
          continue;
        }
        n = o.nested ? r.items[0] : n, n._update !== e && (!n._svg || !n._svg.ownerSVGElement ? (this._dirtyAll = !1, BMe(n, e)) : this._update(o, n._svg, n), n._update = e);
      }
    return !this._dirtyAll;
  },
  // -- Construct & maintain scenegraph to SVG mapping ---
  /**
   * Render a set of mark items.
   * @param {SVGElement} el - The parent element in the SVG tree.
   * @param {object} scene - The mark parent to render.
   * @param {SVGElement} prev - The previous sibling in the SVG tree.
   */
  mark(t, e, n) {
    if (!this.isDirty(e))
      return e._svg;
    const r = this._svg, i = Hf[e.marktype], o = e.interactive === !1 ? "none" : null, s = i.tag === "g", a = bMe(e, t, n, "g", r);
    a.setAttribute("class", Vnt(e));
    const A = rrt(e);
    for (const f in A)
      xc(a, f, A[f]);
    s || xc(a, "pointer-events", o), xc(a, "clip-path", e.clip ? sde(this, e, e.group) : null);
    let l = null, c = 0;
    const u = (f) => {
      const h = this.isDirty(f), d = bMe(f, a, l, i.tag, r);
      h && (this._update(i, d, f), s && gcr(this, d, f)), l = d, ++c;
    };
    return i.nested ? e.items.length && u(e.items[0]) : md(e, u), Ph(a, c), a;
  },
  /**
   * Update the attributes of an SVG element for a mark item.
   * @param {object} mdef - The mark definition object
   * @param {SVGElement} el - The SVG element.
   * @param {Item} item - The mark item.
   */
  _update(t, e, n) {
    cI = e, Pl = e.__values__, nrt(HD, n), t.attr(HD, n, this);
    const r = dcr[t.type];
    r && r.call(this, t, e, n), cI && this.style(cI, n);
  },
  /**
   * Update the presentation attributes of an SVG element for a mark item.
   * @param {SVGElement} el - The SVG element.
   * @param {Item} item - The mark item.
   */
  style(t, e) {
    if (e != null) {
      for (const n in j5) {
        let r = n === "font" ? EO(e) : e[n];
        if (r === Pl[n])
          continue;
        const i = j5[n];
        r == null ? t.removeAttribute(i) : (rde(r) && (r = Bnt(r, this._defs.gradient, lrt())), t.setAttribute(i, r + "")), Pl[n] = r;
      }
      for (const n in Y5)
        n4(t, Y5[n], e[n]);
    }
  },
  /**
   * Render SVG defs, as needed.
   * Must be called *after* marks have been processed to ensure the
   * collected state is current and accurate.
   */
  defs() {
    const t = this._svg, e = this._defs;
    let n = e.el, r = 0;
    for (const i in e.gradient)
      n || (e.el = n = bu(t, V2 + 1, "defs", aA)), r = ucr(n, e.gradient[i], r);
    for (const i in e.clipping)
      n || (e.el = n = bu(t, V2 + 1, "defs", aA)), r = fcr(n, e.clipping[i], r);
    n && (r === 0 ? (t.removeChild(n), e.el = null) : Ph(n, r));
  },
  /**
   * Clear defs caches.
   */
  _clearDefs() {
    const t = this._defs;
    t.gradient = {}, t.clipping = {};
  }
});
function BMe(t, e) {
  for (; t && t.dirty !== e; t = t.mark.group)
    if (t.dirty = e, t.mark && t.mark.dirty !== e)
      t.mark.dirty = e;
    else
      return;
}
function ucr(t, e, n) {
  let r, i, o;
  if (e.gradient === "radial") {
    let s = bu(t, n++, "pattern", aA);
    mC(s, {
      id: O5 + e.id,
      viewBox: "0,0,1,1",
      width: "100%",
      height: "100%",
      preserveAspectRatio: "xMidYMid slice"
    }), s = bu(s, 0, "rect", aA), mC(s, {
      width: 1,
      height: 1,
      fill: "url(".concat(lrt(), "#").concat(e.id, ")")
    }), t = bu(t, n++, "radialGradient", aA), mC(t, {
      id: e.id,
      fx: e.x1,
      fy: e.y1,
      fr: e.r1,
      cx: e.x2,
      cy: e.y2,
      r: e.r2
    });
  } else
    t = bu(t, n++, "linearGradient", aA), mC(t, {
      id: e.id,
      x1: e.x1,
      x2: e.x2,
      y1: e.y1,
      y2: e.y2
    });
  for (r = 0, i = e.stops.length; r < i; ++r)
    o = bu(t, r, "stop", aA), o.setAttribute("offset", e.stops[r].offset), o.setAttribute("stop-color", e.stops[r].color);
  return Ph(t, r), n;
}
function fcr(t, e, n) {
  let r;
  return t = bu(t, n, "clipPath", aA), t.setAttribute("id", e.id), e.path ? (r = bu(t, 0, "path", aA), r.setAttribute("d", e.path)) : (r = bu(t, 0, "rect", aA), mC(r, {
    x: 0,
    y: 0,
    width: e.width,
    height: e.height
  })), Ph(t, 1), n + 1;
}
function gcr(t, e, n) {
  e = e.lastChild.previousSibling;
  let r, i = 0;
  md(n, (o) => {
    r = t.mark(e, o, r), ++i;
  }), Ph(e, 1 + i);
}
function bMe(t, e, n, r, i) {
  let o = t._svg, s;
  if (!o && (s = e.ownerDocument, o = IC(s, r, aA), t._svg = o, t.mark && (o.__data__ = t, o.__values__ = {
    fill: "default"
  }, r === "g"))) {
    const a = IC(s, "path", aA);
    o.appendChild(a), a.__data__ = t;
    const A = IC(s, "g", aA);
    o.appendChild(A), A.__data__ = t;
    const l = IC(s, "path", aA);
    o.appendChild(l), l.__data__ = t, l.__values__ = {
      fill: "default"
    };
  }
  return (o.ownerSVGElement !== i || hcr(o, n)) && e.insertBefore(o, n ? n.nextSibling : e.firstChild), o;
}
function hcr(t, e) {
  return t.parentNode && t.parentNode.childNodes.length > 1 && t.previousSibling != e;
}
let cI = null, Pl = null;
const dcr = {
  group(t, e, n) {
    const r = cI = e.childNodes[2];
    Pl = r.__values__, t.foreground(HD, n, this), Pl = e.__values__, cI = e.childNodes[1], t.content(HD, n, this);
    const i = cI = e.childNodes[0];
    t.background(HD, n, this);
    const o = n.mark.interactive === !1 ? "none" : null;
    if (o !== Pl.events && (xc(r, "pointer-events", o), xc(i, "pointer-events", o), Pl.events = o), n.strokeForeground && n.stroke) {
      const s = n.fill;
      xc(r, "display", null), this.style(i, n), xc(i, "stroke", null), s && (n.fill = null), Pl = r.__values__, this.style(r, n), s && (n.fill = s), cI = null;
    } else
      xc(r, "display", "none");
  },
  image(t, e, n) {
    n.smooth === !1 ? (n4(e, "image-rendering", "optimizeSpeed"), n4(e, "image-rendering", "pixelated")) : n4(e, "image-rendering", null);
  },
  text(t, e, n) {
    const r = CO(n);
    let i, o, s, a;
    Nt(r) ? (o = r.map((A) => AE(n, A)), i = o.join(`
`), i !== Pl.text && (Ph(e, 0), s = e.ownerDocument, a = aE(n), o.forEach((A, l) => {
      const c = IC(s, "tspan", aA);
      c.__data__ = n, c.textContent = A, l && (c.setAttribute("x", 0), c.setAttribute("dy", a)), e.appendChild(c);
    }), Pl.text = i)) : (o = AE(n, r), o !== Pl.text && (e.textContent = o, Pl.text = o)), xc(e, "font-family", EO(n)), xc(e, "font-size", d0(n) + "px"), xc(e, "font-style", n.fontStyle), xc(e, "font-variant", n.fontVariant), xc(e, "font-weight", n.fontWeight);
  }
};
function HD(t, e, n) {
  e !== Pl[t] && (n ? pcr(cI, t, e, n) : xc(cI, t, e), Pl[t] = e);
}
function n4(t, e, n) {
  n !== Pl[e] && (n == null ? t.style.removeProperty(e) : t.style.setProperty(e, n + ""), Pl[e] = n);
}
function mC(t, e) {
  for (const n in e)
    xc(t, n, e[n]);
}
function xc(t, e, n) {
  n != null ? t.setAttribute(e, n) : t.removeAttribute(e);
}
function pcr(t, e, n, r) {
  n != null ? t.setAttributeNS(r, e, n) : t.removeAttributeNS(r, e);
}
function lrt() {
  let t;
  return typeof window > "u" ? "" : (t = window.location).hash ? t.href.slice(0, -t.hash.length) : t.href;
}
function Tde(t) {
  p0.call(this, t), this._text = null, this._defs = {
    gradient: {},
    clipping: {}
  };
}
on(Tde, p0, {
  /**
   * Returns the rendered SVG text string,
   * or null if rendering has not yet occurred.
   */
  svg() {
    return this._text;
  },
  /**
   * Internal rendering method.
   * @param {object} scene - The root mark of a scenegraph to render.
   */
  _render(t) {
    const e = Rde();
    e.open("svg", ni({}, SN, {
      class: "marks",
      width: this._width * this._scale,
      height: this._height * this._scale,
      viewBox: "0 0 ".concat(this._width, " ").concat(this._height)
    }));
    const n = this._bgcolor;
    return n && n !== "transparent" && n !== "none" && e.open("rect", {
      width: this._width,
      height: this._height,
      fill: n
    }).close(), e.open("g", Art, {
      transform: "translate(" + this._origin + ")"
    }), this.mark(e, t), e.close(), this.defs(e), this._text = e.close() + "", this;
  },
  /**
   * Render a set of mark items.
   * @param {object} m - The markup context.
   * @param {object} scene - The mark parent to render.
   */
  mark(t, e) {
    const n = Hf[e.marktype], r = n.tag, i = [nrt, n.attr];
    t.open("g", {
      class: Vnt(e),
      "clip-path": e.clip ? sde(this, e, e.group) : null
    }, rrt(e), {
      "pointer-events": r !== "g" && e.interactive === !1 ? "none" : null
    });
    const o = (s) => {
      const a = this.href(s);
      if (a && t.open("a", a), t.open(r, this.attr(e, s, i, r !== "g" ? r : null)), r === "text") {
        const A = CO(s);
        if (Nt(A)) {
          const l = {
            x: 0,
            dy: aE(s)
          };
          for (let c = 0; c < A.length; ++c)
            t.open("tspan", c ? l : null).text(AE(s, A[c])).close();
        } else
          t.text(AE(s, A));
      } else if (r === "g") {
        const A = s.strokeForeground, l = s.fill, c = s.stroke;
        A && c && (s.stroke = null), t.open("path", this.attr(e, s, n.background, "bgrect")).close(), t.open("g", this.attr(e, s, n.content)), md(s, (u) => this.mark(t, u)), t.close(), A && c ? (l && (s.fill = null), s.stroke = c, t.open("path", this.attr(e, s, n.foreground, "bgrect")).close(), l && (s.fill = l)) : t.open("path", this.attr(e, s, n.foreground, "bgfore")).close();
      }
      t.close(), a && t.close();
    };
    return n.nested ? e.items && e.items.length && o(e.items[0]) : md(e, o), t.close();
  },
  /**
   * Get href attributes for a hyperlinked mark item.
   * @param {Item} item - The mark item.
   */
  href(t) {
    const e = t.href;
    let n;
    if (e) {
      if (n = this._hrefs && this._hrefs[e])
        return n;
      this.sanitizeURL(e).then((r) => {
        r["xlink:href"] = r.href, r.href = null, (this._hrefs || (this._hrefs = {}))[e] = r;
      });
    }
    return null;
  },
  /**
   * Get an object of SVG attributes for a mark item.
   * @param {object} scene - The mark parent.
   * @param {Item} item - The mark item.
   * @param {array|function} attrs - One or more attribute emitters.
   * @param {string} tag - The tag being rendered.
   */
  attr(t, e, n, r) {
    const i = {}, o = (s, a, A, l) => {
      i[l || s] = a;
    };
    return Array.isArray(n) ? n.forEach((s) => s(o, e, this)) : n(o, e, this), r && Icr(i, e, t, r, this._defs), i;
  },
  /**
   * Render SVG defs, as needed.
   * Must be called *after* marks have been processed to ensure the
   * collected state is current and accurate.
   * @param {object} m - The markup context.
   */
  defs(t) {
    const e = this._defs.gradient, n = this._defs.clipping;
    if (Object.keys(e).length + Object.keys(n).length !== 0) {
      t.open("defs");
      for (const i in e) {
        const o = e[i], s = o.stops;
        o.gradient === "radial" ? (t.open("pattern", {
          id: O5 + i,
          viewBox: "0,0,1,1",
          width: "100%",
          height: "100%",
          preserveAspectRatio: "xMidYMid slice"
        }), t.open("rect", {
          width: "1",
          height: "1",
          fill: "url(#" + i + ")"
        }).close(), t.close(), t.open("radialGradient", {
          id: i,
          fx: o.x1,
          fy: o.y1,
          fr: o.r1,
          cx: o.x2,
          cy: o.y2,
          r: o.r2
        })) : t.open("linearGradient", {
          id: i,
          x1: o.x1,
          x2: o.x2,
          y1: o.y1,
          y2: o.y2
        });
        for (let a = 0; a < s.length; ++a)
          t.open("stop", {
            offset: s[a].offset,
            "stop-color": s[a].color
          }).close();
        t.close();
      }
      for (const i in n) {
        const o = n[i];
        t.open("clipPath", {
          id: i
        }), o.path ? t.open("path", {
          d: o.path
        }).close() : t.open("rect", {
          x: 0,
          y: 0,
          width: o.width,
          height: o.height
        }).close(), t.close();
      }
      t.close();
    }
  }
});
function Icr(t, e, n, r, i) {
  let o;
  if (e == null || (r === "bgrect" && n.interactive === !1 && (t["pointer-events"] = "none"), r === "bgfore" && (n.interactive === !1 && (t["pointer-events"] = "none"), t.display = "none", e.fill !== null)))
    return t;
  r === "image" && e.smooth === !1 && (o = ["image-rendering: optimizeSpeed;", "image-rendering: pixelated;"]), r === "text" && (t["font-family"] = EO(e), t["font-size"] = d0(e) + "px", t["font-style"] = e.fontStyle, t["font-variant"] = e.fontVariant, t["font-weight"] = e.fontWeight);
  for (const s in j5) {
    let a = e[s];
    const A = j5[s];
    a === "transparent" && (A === "fill" || A === "stroke") || a != null && (rde(a) && (a = Bnt(a, i.gradient, "")), t[A] = a);
  }
  for (const s in Y5) {
    const a = e[s];
    a != null && (o = o || [], o.push("".concat(Y5[s], ": ").concat(a, ";")));
  }
  return o && (t.style = o.join(" ")), t;
}
const crt = "canvas", urt = "png", frt = "svg", grt = "none", CC = {
  Canvas: crt,
  PNG: urt,
  SVG: frt,
  None: grt
}, SQ = {};
SQ[crt] = SQ[urt] = {
  renderer: q5,
  headless: q5,
  handler: yO
};
SQ[frt] = {
  renderer: Dde,
  headless: Tde,
  handler: _de
};
SQ[grt] = {};
function Yj(t, e) {
  return t = String(t || "").toLowerCase(), arguments.length > 1 ? (SQ[t] = e, this) : SQ[t];
}
function hrt(t, e, n) {
  const r = [], i = new za().union(e), o = t.marktype;
  return o ? drt(t, i, n, r) : o === "group" ? prt(t, i, n, r) : wt("Intersect scene must be mark node or group item.");
}
function drt(t, e, n, r) {
  if (mcr(t, e, n)) {
    const i = t.items, o = t.marktype, s = i.length;
    let a = 0;
    if (o === "group")
      for (; a < s; ++a)
        prt(i[a], e, n, r);
    else
      for (const A = Hf[o].isect; a < s; ++a) {
        const l = i[a];
        Irt(l, e, A) && r.push(l);
      }
  }
  return r;
}
function mcr(t, e, n) {
  return t.bounds && e.intersects(t.bounds) && (t.marktype === "group" || t.interactive !== !1 && (!n || n(t)));
}
function prt(t, e, n, r) {
  n && n(t.mark) && Irt(t, e, Hf.group.isect) && r.push(t);
  const i = t.items, o = i && i.length;
  if (o) {
    const s = t.x || 0, a = t.y || 0;
    e.translate(-s, -a);
    for (let A = 0; A < o; ++A)
      drt(i[A], e, n, r);
    e.translate(s, a);
  }
  return r;
}
function Irt(t, e, n) {
  const r = t.bounds;
  return e.encloses(r) || e.intersects(r) && n(t, e);
}
const xW = new za();
function mrt(t) {
  const e = t.clip;
  if (ri(e))
    e(IO(xW.clear()));
  else if (e)
    xW.set(0, 0, t.group.width, t.group.height);
  else
    return;
  t.bounds.intersect(xW);
}
const Ccr = 1e-9;
function Nde(t, e, n) {
  return t === e ? !0 : n === "path" ? Crt(t, e) : t instanceof Date && e instanceof Date ? +t == +e : Po(t) && Po(e) ? Math.abs(t - e) <= Ccr : !t || !e || !_n(t) && !_n(e) ? t == e : Ecr(t, e);
}
function Crt(t, e) {
  return Nde(BQ(t), BQ(e));
}
function Ecr(t, e) {
  var n = Object.keys(t), r = Object.keys(e), i, o;
  if (n.length !== r.length)
    return !1;
  for (n.sort(), r.sort(), o = n.length - 1; o >= 0; o--)
    if (n[o] != r[o])
      return !1;
  for (o = n.length - 1; o >= 0; o--)
    if (i = n[o], !Nde(t[i], e[i], i))
      return !1;
  return typeof t == typeof e;
}
function ycr() {
  Rnt(), Yar();
}
const QQ = "top", kh = "left", Kh = "right", cE = "bottom", vcr = "top-left", Bcr = "top-right", bcr = "bottom-left", _cr = "bottom-right", Lde = "start", vie = "middle", Rc = "end", Scr = "x", Qcr = "y", zj = "group", Mde = "axis", Ode = "title", wcr = "frame", xcr = "scope", Fde = "legend", Ert = "row-header", yrt = "row-footer", vrt = "row-title", Brt = "column-header", brt = "column-footer", _rt = "column-title", Rcr = "padding", Dcr = "symbol", Srt = "fit", Tcr = "fit-x", Ncr = "fit-y", Lcr = "pad", Pde = "none", v3 = "all", Bie = "each", kde = "flush", EC = "column", yC = "row";
function Qrt(t) {
  yt.call(this, null, t);
}
on(Qrt, yt, {
  transform(t, e) {
    const n = e.dataflow, r = t.mark, i = r.marktype, o = Hf[i], s = o.bound;
    let a = r.bounds, A;
    if (o.nested)
      r.items.length && n.dirty(r.items[0]), a = B3(r, s), r.items.forEach((l) => {
        l.bounds.clear().union(a);
      });
    else if (i === zj || t.modified())
      switch (e.visit(e.MOD, (l) => n.dirty(l)), a.clear(), r.items.forEach((l) => a.union(B3(l, s))), r.role) {
        case Mde:
        case Fde:
        case Ode:
          e.reflow();
      }
    else
      A = e.changed(e.REM), e.visit(e.ADD, (l) => {
        a.union(B3(l, s));
      }), e.visit(e.MOD, (l) => {
        A = A || a.alignsWith(l.bounds), n.dirty(l), a.union(B3(l, s));
      }), A && (a.clear(), r.items.forEach((l) => a.union(l.bounds)));
    return mrt(r), e.modifies("bounds");
  }
});
function B3(t, e, n) {
  return e(t.bounds.clear(), t, n);
}
const _Me = ":vega_identifier:";
function Gde(t) {
  yt.call(this, 0, t);
}
Gde.Definition = {
  type: "Identifier",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "as",
    type: "string",
    required: !0
  }]
};
on(Gde, yt, {
  transform(t, e) {
    const n = Mcr(e.dataflow), r = t.as;
    let i = n.value;
    return e.visit(e.ADD, (o) => o[r] = o[r] || ++i), n.set(this.value = i), e;
  }
});
function Mcr(t) {
  return t._signals[_Me] || (t._signals[_Me] = t.add(0));
}
function wrt(t) {
  yt.call(this, null, t);
}
on(wrt, yt, {
  transform(t, e) {
    let n = this.value;
    n || (n = e.dataflow.scenegraph().mark(t.markdef, Ocr(t), t.index), n.group.context = t.context, t.context.group || (t.context.group = n.group), n.source = this.source, n.clip = t.clip, n.interactive = t.interactive, this.value = n);
    const r = n.marktype === zj ? Pj : Fj;
    return e.visit(e.ADD, (i) => r.call(i, n)), (t.modified("clip") || t.modified("interactive")) && (n.clip = t.clip, n.interactive = !!t.interactive, n.zdirty = !0, e.reflow()), n.items = e.source, e;
  }
});
function Ocr(t) {
  const e = t.groups, n = t.parent;
  return e && e.size === 1 ? e.get(Object.keys(e.object)[0]) : e && n ? e.lookup(n) : null;
}
function xrt(t) {
  yt.call(this, null, t);
}
const SMe = {
  parity: (t) => t.filter((e, n) => n % 2 ? e.opacity = 0 : 1),
  greedy: (t, e) => {
    let n;
    return t.filter((r, i) => !i || !Rrt(n.bounds, r.bounds, e) ? (n = r, 1) : r.opacity = 0);
  }
}, Rrt = (t, e, n) => n > Math.max(e.x1 - t.x2, t.x1 - e.x2, e.y1 - t.y2, t.y1 - e.y2), QMe = (t, e) => {
  for (var n = 1, r = t.length, i = t[0].bounds, o; n < r; i = o, ++n)
    if (Rrt(i, o = t[n].bounds, e))
      return !0;
}, Fcr = (t) => {
  const e = t.bounds;
  return e.width() > 1 && e.height() > 1;
}, Pcr = (t, e, n) => {
  var r = t.range(), i = new za();
  return e === QQ || e === cE ? i.set(r[0], -1 / 0, r[1], 1 / 0) : i.set(-1 / 0, r[0], 1 / 0, r[1]), i.expand(n || 1), (o) => i.encloses(o.bounds);
}, wMe = (t) => (t.forEach((e) => e.opacity = 1), t), xMe = (t, e) => t.reflow(e.modified()).modifies("opacity");
on(xrt, yt, {
  transform(t, e) {
    const n = SMe[t.method] || SMe.parity, r = t.separation || 0;
    let i = e.materialize(e.SOURCE).source, o, s;
    if (!i || !i.length)
      return;
    if (!t.method)
      return t.modified("method") && (wMe(i), e = xMe(e, t)), e;
    if (i = i.filter(Fcr), !i.length)
      return;
    if (t.sort && (i = i.slice().sort(t.sort)), o = wMe(i), e = xMe(e, t), o.length >= 3 && QMe(o, r)) {
      do
        o = n(o, r);
      while (o.length >= 3 && QMe(o, r));
      o.length < 3 && !bi(i).opacity && (o.length > 1 && (bi(o).opacity = 0), bi(i).opacity = 1);
    }
    t.boundScale && t.boundTolerance >= 0 && (s = Pcr(t.boundScale, t.boundOrient, +t.boundTolerance), i.forEach((A) => {
      s(A) || (A.opacity = 0);
    }));
    const a = o[0].mark.bounds.clear();
    return i.forEach((A) => {
      A.opacity && a.union(A.bounds);
    }), e;
  }
});
function Drt(t) {
  yt.call(this, null, t);
}
on(Drt, yt, {
  transform(t, e) {
    const n = e.dataflow;
    if (e.visit(e.ALL, (r) => n.dirty(r)), e.fields && e.fields.zindex) {
      const r = e.source && e.source[0];
      r && (r.mark.zdirty = !0);
    }
  }
});
const Fl = new za();
function Q_(t, e, n) {
  return t[e] === n ? 0 : (t[e] = n, 1);
}
function kcr(t) {
  var e = t.items[0].orient;
  return e === kh || e === Kh;
}
function Gcr(t) {
  let e = +t.grid;
  return [
    t.ticks ? e++ : -1,
    // ticks index
    t.labels ? e++ : -1,
    // labels index
    e + +t.domain
    // title index
  ];
}
function Ucr(t, e, n, r) {
  var i = e.items[0], o = i.datum, s = i.translate != null ? i.translate : 0.5, a = i.orient, A = Gcr(o), l = i.range, c = i.offset, u = i.position, f = i.minExtent, h = i.maxExtent, d = o.title && i.items[A[2]].items[0], I = i.titlePadding, m = i.bounds, C = d && Ede(d), y = 0, v = 0, b, Q;
  switch (Fl.clear().union(m), m.clear(), (b = A[0]) > -1 && m.union(i.items[b].bounds), (b = A[1]) > -1 && m.union(i.items[b].bounds), a) {
    case QQ:
      y = u || 0, v = -c, Q = Math.max(f, Math.min(h, -m.y1)), m.add(0, -Q).add(l, 0), d && b3(t, d, Q, I, C, 0, -1, m);
      break;
    case kh:
      y = -c, v = u || 0, Q = Math.max(f, Math.min(h, -m.x1)), m.add(-Q, 0).add(0, l), d && b3(t, d, Q, I, C, 1, -1, m);
      break;
    case Kh:
      y = n + c, v = u || 0, Q = Math.max(f, Math.min(h, m.x2)), m.add(0, 0).add(Q, l), d && b3(t, d, Q, I, C, 1, 1, m);
      break;
    case cE:
      y = u || 0, v = r + c, Q = Math.max(f, Math.min(h, m.y2)), m.add(0, 0).add(l, Q), d && b3(t, d, Q, I, 0, 0, 1, m);
      break;
    default:
      y = i.x, v = i.y;
  }
  return sm(m.translate(y, v), i), Q_(i, "x", y + s) | Q_(i, "y", v + s) && (i.bounds = Fl, t.dirty(i), i.bounds = m, t.dirty(i)), i.mark.bounds.clear().union(m);
}
function b3(t, e, n, r, i, o, s, a) {
  const A = e.bounds;
  if (e.auto) {
    const l = s * (n + i + r);
    let c = 0, u = 0;
    t.dirty(e), o ? c = (e.x || 0) - (e.x = l) : u = (e.y || 0) - (e.y = l), e.mark.bounds.clear().union(A.translate(-c, -u)), t.dirty(e);
  }
  a.union(A);
}
const RMe = (t, e) => Math.floor(Math.min(t, e)), DMe = (t, e) => Math.ceil(Math.max(t, e));
function Hcr(t) {
  var e = t.items, n = e.length, r = 0, i, o;
  const s = {
    marks: [],
    rowheaders: [],
    rowfooters: [],
    colheaders: [],
    colfooters: [],
    rowtitle: null,
    coltitle: null
  };
  for (; r < n; ++r)
    if (i = e[r], o = i.items, i.marktype === zj)
      switch (i.role) {
        case Mde:
        case Fde:
        case Ode:
          break;
        case Ert:
          s.rowheaders.push(...o);
          break;
        case yrt:
          s.rowfooters.push(...o);
          break;
        case Brt:
          s.colheaders.push(...o);
          break;
        case brt:
          s.colfooters.push(...o);
          break;
        case vrt:
          s.rowtitle = o[0];
          break;
        case _rt:
          s.coltitle = o[0];
          break;
        default:
          s.marks.push(...o);
      }
  return s;
}
function $cr(t) {
  return new za().set(0, 0, t.width || 0, t.height || 0);
}
function qcr(t) {
  const e = t.bounds.clone();
  return e.empty() ? e.set(0, 0, 0, 0) : e.translate(-(t.x || 0), -(t.y || 0));
}
function Rs(t, e, n) {
  const r = _n(t) ? t[e] : t;
  return r ?? (n !== void 0 ? n : 0);
}
function TMe(t) {
  return t < 0 ? Math.ceil(-t) : 0;
}
function Trt(t, e, n) {
  var r = !n.nodirty, i = n.bounds === kde ? $cr : qcr, o = Fl.set(0, 0, 0, 0), s = Rs(n.align, EC), a = Rs(n.align, yC), A = Rs(n.padding, EC), l = Rs(n.padding, yC), c = n.columns || e.length, u = c <= 0 ? 1 : Math.ceil(e.length / c), f = e.length, h = Array(f), d = Array(c), I = 0, m = Array(f), C = Array(u), y = 0, v = Array(f), b = Array(f), Q = Array(f), w, R, M, O, L, N, k, $, U, X, K;
  for (R = 0; R < c; ++R)
    d[R] = 0;
  for (R = 0; R < u; ++R)
    C[R] = 0;
  for (R = 0; R < f; ++R)
    N = e[R], L = Q[R] = i(N), N.x = N.x || 0, v[R] = 0, N.y = N.y || 0, b[R] = 0, M = R % c, O = ~~(R / c), I = Math.max(I, k = Math.ceil(L.x2)), y = Math.max(y, $ = Math.ceil(L.y2)), d[M] = Math.max(d[M], k), C[O] = Math.max(C[O], $), h[R] = A + TMe(L.x1), m[R] = l + TMe(L.y1), r && t.dirty(e[R]);
  for (R = 0; R < f; ++R)
    R % c === 0 && (h[R] = 0), R < c && (m[R] = 0);
  if (s === Bie)
    for (M = 1; M < c; ++M) {
      for (K = 0, R = M; R < f; R += c)
        K < h[R] && (K = h[R]);
      for (R = M; R < f; R += c)
        h[R] = K + d[M - 1];
    }
  else if (s === v3) {
    for (K = 0, R = 0; R < f; ++R)
      R % c && K < h[R] && (K = h[R]);
    for (R = 0; R < f; ++R)
      R % c && (h[R] = K + I);
  } else
    for (s = !1, M = 1; M < c; ++M)
      for (R = M; R < f; R += c)
        h[R] += d[M - 1];
  if (a === Bie)
    for (O = 1; O < u; ++O) {
      for (K = 0, R = O * c, w = R + c; R < w; ++R)
        K < m[R] && (K = m[R]);
      for (R = O * c; R < w; ++R)
        m[R] = K + C[O - 1];
    }
  else if (a === v3) {
    for (K = 0, R = c; R < f; ++R)
      K < m[R] && (K = m[R]);
    for (R = c; R < f; ++R)
      m[R] = K + y;
  } else
    for (a = !1, O = 1; O < u; ++O)
      for (R = O * c, w = R + c; R < w; ++R)
        m[R] += C[O - 1];
  for (U = 0, R = 0; R < f; ++R)
    U = h[R] + (R % c ? U : 0), v[R] += U - e[R].x;
  for (M = 0; M < c; ++M)
    for (X = 0, R = M; R < f; R += c)
      X += m[R], b[R] += X - e[R].y;
  if (s && Rs(n.center, EC) && u > 1)
    for (R = 0; R < f; ++R)
      L = s === v3 ? I : d[R % c], U = L - Q[R].x2 - e[R].x - v[R], U > 0 && (v[R] += U / 2);
  if (a && Rs(n.center, yC) && c !== 1)
    for (R = 0; R < f; ++R)
      L = a === v3 ? y : C[~~(R / c)], X = L - Q[R].y2 - e[R].y - b[R], X > 0 && (b[R] += X / 2);
  for (R = 0; R < f; ++R)
    o.union(Q[R].translate(v[R], b[R]));
  switch (U = Rs(n.anchor, Scr), X = Rs(n.anchor, Qcr), Rs(n.anchor, EC)) {
    case Rc:
      U -= o.width();
      break;
    case vie:
      U -= o.width() / 2;
  }
  switch (Rs(n.anchor, yC)) {
    case Rc:
      X -= o.height();
      break;
    case vie:
      X -= o.height() / 2;
  }
  for (U = Math.round(U), X = Math.round(X), o.clear(), R = 0; R < f; ++R)
    e[R].mark.bounds.clear();
  for (R = 0; R < f; ++R)
    N = e[R], N.x += v[R] += U, N.y += b[R] += X, o.union(N.mark.bounds.union(N.bounds.translate(v[R], b[R]))), r && t.dirty(N);
  return o;
}
function jcr(t, e, n) {
  var r = Hcr(e), i = r.marks, o = n.bounds === kde ? Ycr : zcr, s = n.offset, a = n.columns || i.length, A = a <= 0 ? 1 : Math.ceil(i.length / a), l = A * a, c, u, f, h, d, I, m;
  const C = Trt(t, i, n);
  C.empty() && C.set(0, 0, 0, 0), r.rowheaders && (I = Rs(n.headerBand, yC, null), c = _3(t, r.rowheaders, i, a, A, -Rs(s, "rowHeader"), RMe, 0, o, "x1", 0, a, 1, I)), r.colheaders && (I = Rs(n.headerBand, EC, null), u = _3(t, r.colheaders, i, a, a, -Rs(s, "columnHeader"), RMe, 1, o, "y1", 0, 1, a, I)), r.rowfooters && (I = Rs(n.footerBand, yC, null), f = _3(t, r.rowfooters, i, a, A, Rs(s, "rowFooter"), DMe, 0, o, "x2", a - 1, a, 1, I)), r.colfooters && (I = Rs(n.footerBand, EC, null), h = _3(t, r.colfooters, i, a, a, Rs(s, "columnFooter"), DMe, 1, o, "y2", l - a, 1, a, I)), r.rowtitle && (d = Rs(n.titleAnchor, yC), m = Rs(s, "rowTitle"), m = d === Rc ? f + m : c - m, I = Rs(n.titleBand, yC, 0.5), NMe(t, r.rowtitle, m, 0, C, I)), r.coltitle && (d = Rs(n.titleAnchor, EC), m = Rs(s, "columnTitle"), m = d === Rc ? h + m : u - m, I = Rs(n.titleBand, EC, 0.5), NMe(t, r.coltitle, m, 1, C, I));
}
function Ycr(t, e) {
  return e === "x1" ? t.x || 0 : e === "y1" ? t.y || 0 : e === "x2" ? (t.x || 0) + (t.width || 0) : e === "y2" ? (t.y || 0) + (t.height || 0) : void 0;
}
function zcr(t, e) {
  return t.bounds[e];
}
function _3(t, e, n, r, i, o, s, a, A, l, c, u, f, h) {
  var d = n.length, I = 0, m = 0, C, y, v, b, Q, w, R, M, O;
  if (!d)
    return I;
  for (C = c; C < d; C += u)
    n[C] && (I = s(I, A(n[C], l)));
  if (!e.length)
    return I;
  for (e.length > i && (t.warn("Grid headers exceed limit: " + i), e = e.slice(0, i)), I += o, y = 0, b = e.length; y < b; ++y)
    t.dirty(e[y]), e[y].mark.bounds.clear();
  for (C = c, y = 0, b = e.length; y < b; ++y, C += u) {
    for (w = e[y], Q = w.mark.bounds, v = C; v >= 0 && (R = n[v]) == null; v -= f)
      ;
    a ? (M = h == null ? R.x : Math.round(R.bounds.x1 + h * R.bounds.width()), O = I) : (M = I, O = h == null ? R.y : Math.round(R.bounds.y1 + h * R.bounds.height())), Q.union(w.bounds.translate(M - (w.x || 0), O - (w.y || 0))), w.x = M, w.y = O, t.dirty(w), m = s(m, Q[l]);
  }
  return m;
}
function NMe(t, e, n, r, i, o) {
  if (e) {
    t.dirty(e);
    var s = n, a = n;
    r ? s = Math.round(i.x1 + o * i.width()) : a = Math.round(i.y1 + o * i.height()), e.bounds.translate(s - (e.x || 0), a - (e.y || 0)), e.mark.bounds.clear().union(e.bounds), e.x = s, e.y = a, t.dirty(e);
  }
}
function Vcr(t, e) {
  const n = t[e] || {};
  return (r, i) => n[r] != null ? n[r] : t[r] != null ? t[r] : i;
}
function Jcr(t, e) {
  let n = -1 / 0;
  return t.forEach((r) => {
    r.offset != null && (n = Math.max(n, r.offset));
  }), n > -1 / 0 ? n : e;
}
function Kcr(t, e, n, r, i, o, s) {
  const a = Vcr(n, e), A = Jcr(t, a("offset", 0)), l = a("anchor", Lde), c = l === Rc ? 1 : l === vie ? 0.5 : 0, u = {
    align: Bie,
    bounds: a("bounds", kde),
    columns: a("direction") === "vertical" ? 1 : t.length,
    padding: a("margin", 8),
    center: a("center"),
    nodirty: !0
  };
  switch (e) {
    case kh:
      u.anchor = {
        x: Math.floor(r.x1) - A,
        column: Rc,
        y: c * (s || r.height() + 2 * r.y1),
        row: l
      };
      break;
    case Kh:
      u.anchor = {
        x: Math.ceil(r.x2) + A,
        y: c * (s || r.height() + 2 * r.y1),
        row: l
      };
      break;
    case QQ:
      u.anchor = {
        y: Math.floor(i.y1) - A,
        row: Rc,
        x: c * (o || i.width() + 2 * i.x1),
        column: l
      };
      break;
    case cE:
      u.anchor = {
        y: Math.ceil(i.y2) + A,
        x: c * (o || i.width() + 2 * i.x1),
        column: l
      };
      break;
    case vcr:
      u.anchor = {
        x: A,
        y: A
      };
      break;
    case Bcr:
      u.anchor = {
        x: o - A,
        y: A,
        column: Rc
      };
      break;
    case bcr:
      u.anchor = {
        x: A,
        y: s - A,
        row: Rc
      };
      break;
    case _cr:
      u.anchor = {
        x: o - A,
        y: s - A,
        column: Rc,
        row: Rc
      };
      break;
  }
  return u;
}
function Wcr(t, e) {
  var n = e.items[0], r = n.datum, i = n.orient, o = n.bounds, s = n.x, a = n.y, A, l;
  return n._bounds ? n._bounds.clear().union(o) : n._bounds = o.clone(), o.clear(), Zcr(t, n, n.items[0].items[0]), o = Xcr(n, o), A = 2 * n.padding, l = 2 * n.padding, o.empty() || (A = Math.ceil(o.width() + A), l = Math.ceil(o.height() + l)), r.type === Dcr && eur(n.items[0].items[0].items[0].items), i !== Pde && (n.x = s = 0, n.y = a = 0), n.width = A, n.height = l, sm(o.set(s, a, s + A, a + l), n), n.mark.bounds.clear().union(o), n;
}
function Xcr(t, e) {
  return t.items.forEach((n) => e.union(n.bounds)), e.x1 = t.padding, e.y1 = t.padding, e;
}
function Zcr(t, e, n) {
  var r = e.padding, i = r - n.x, o = r - n.y;
  if (!e.datum.title)
    (i || o) && J2(t, n, i, o);
  else {
    var s = e.items[1].items[0], a = s.anchor, A = e.titlePadding || 0, l = r - s.x, c = r - s.y;
    switch (s.orient) {
      case kh:
        i += Math.ceil(s.bounds.width()) + A;
        break;
      case Kh:
      case cE:
        break;
      default:
        o += s.bounds.height() + A;
    }
    switch ((i || o) && J2(t, n, i, o), s.orient) {
      case kh:
        c += Db(e, n, s, a, 1, 1);
        break;
      case Kh:
        l += Db(e, n, s, Rc, 0, 0) + A, c += Db(e, n, s, a, 1, 1);
        break;
      case cE:
        l += Db(e, n, s, a, 0, 0), c += Db(e, n, s, Rc, -1, 0, 1) + A;
        break;
      default:
        l += Db(e, n, s, a, 0, 0);
    }
    (l || c) && J2(t, s, l, c), (l = Math.round(s.bounds.x1 - r)) < 0 && (J2(t, n, -l, 0), J2(t, s, -l, 0));
  }
}
function Db(t, e, n, r, i, o, s) {
  const a = t.datum.type !== "symbol", A = n.datum.vgrad, l = a && (o || !A) && !s ? e.items[0] : e, c = l.bounds[i ? "y2" : "x2"] - t.padding, u = A && o ? c : 0, f = A && o ? 0 : c, h = i <= 0 ? 0 : Ede(n);
  return Math.round(r === Lde ? u : r === Rc ? f - h : 0.5 * (c - h));
}
function J2(t, e, n, r) {
  e.x += n, e.y += r, e.bounds.translate(n, r), e.mark.bounds.translate(n, r), t.dirty(e);
}
function eur(t) {
  const e = t.reduce((n, r) => (n[r.column] = Math.max(r.bounds.x2 - r.x, n[r.column] || 0), n), {});
  t.forEach((n) => {
    n.width = e[n.column], n.height = n.bounds.y2 - n.y;
  });
}
function tur(t, e, n, r, i) {
  var o = e.items[0], s = o.frame, a = o.orient, A = o.anchor, l = o.offset, c = o.padding, u = o.items[0].items[0], f = o.items[1] && o.items[1].items[0], h = a === kh || a === Kh ? r : n, d = 0, I = 0, m = 0, C = 0, y = 0, v;
  if (s !== zj ? a === kh ? (d = i.y2, h = i.y1) : a === Kh ? (d = i.y1, h = i.y2) : (d = i.x1, h = i.x2) : a === kh && (d = r, h = 0), v = A === Lde ? d : A === Rc ? h : (d + h) / 2, f && f.text) {
    switch (a) {
      case QQ:
      case cE:
        y = u.bounds.height() + c;
        break;
      case kh:
        C = u.bounds.width() + c;
        break;
      case Kh:
        C = -u.bounds.width() - c;
        break;
    }
    Fl.clear().union(f.bounds), Fl.translate(C - (f.x || 0), y - (f.y || 0)), Q_(f, "x", C) | Q_(f, "y", y) && (t.dirty(f), f.bounds.clear().union(Fl), f.mark.bounds.clear().union(Fl), t.dirty(f)), Fl.clear().union(f.bounds);
  } else
    Fl.clear();
  switch (Fl.union(u.bounds), a) {
    case QQ:
      I = v, m = i.y1 - Fl.height() - l;
      break;
    case kh:
      I = i.x1 - Fl.width() - l, m = v;
      break;
    case Kh:
      I = i.x2 + Fl.width() + l, m = v;
      break;
    case cE:
      I = v, m = i.y2 + l;
      break;
    default:
      I = o.x, m = o.y;
  }
  return Q_(o, "x", I) | Q_(o, "y", m) && (Fl.translate(I, m), t.dirty(o), o.bounds.clear().union(Fl), e.bounds.clear().union(Fl), t.dirty(o)), o.bounds;
}
function Nrt(t) {
  yt.call(this, null, t);
}
on(Nrt, yt, {
  transform(t, e) {
    const n = e.dataflow;
    return t.mark.items.forEach((r) => {
      t.layout && jcr(n, r, t.layout), rur(n, r, t);
    }), nur(t.mark.group) ? e.reflow() : e;
  }
});
function nur(t) {
  return t && t.mark.role !== "legend-entry";
}
function rur(t, e, n) {
  var r = e.items, i = Math.max(0, e.width || 0), o = Math.max(0, e.height || 0), s = new za().set(0, 0, i, o), a = s.clone(), A = s.clone(), l = [], c, u, f, h, d, I;
  for (d = 0, I = r.length; d < I; ++d)
    switch (u = r[d], u.role) {
      case Mde:
        h = kcr(u) ? a : A, h.union(Ucr(t, u, i, o));
        break;
      case Ode:
        c = u;
        break;
      case Fde:
        l.push(Wcr(t, u));
        break;
      case wcr:
      case xcr:
      case Ert:
      case yrt:
      case vrt:
      case Brt:
      case brt:
      case _rt:
        a.union(u.bounds), A.union(u.bounds);
        break;
      default:
        s.union(u.bounds);
    }
  if (l.length) {
    const m = {};
    l.forEach((C) => {
      f = C.orient || Kh, f !== Pde && (m[f] || (m[f] = [])).push(C);
    });
    for (const C in m) {
      const y = m[C];
      Trt(t, y, Kcr(y, C, n.legends, a, A, i, o));
    }
    l.forEach((C) => {
      const y = C.bounds;
      if (y.equals(C._bounds) || (C.bounds = C._bounds, t.dirty(C), C.bounds = y, t.dirty(C)), n.autosize && n.autosize.type === Srt)
        switch (C.orient) {
          case kh:
          case Kh:
            s.add(y.x1, 0).add(y.x2, 0);
            break;
          case QQ:
          case cE:
            s.add(0, y.y1).add(0, y.y2);
        }
      else
        s.union(y);
    });
  }
  s.union(a).union(A), c && s.union(tur(t, c, i, o, s)), e.clip && s.set(0, 0, e.width || 0, e.height || 0), iur(t, e, s, n);
}
function iur(t, e, n, r) {
  const i = r.autosize || {}, o = i.type;
  if (t._autosize < 1 || !o)
    return;
  let s = t._width, a = t._height, A = Math.max(0, e.width || 0), l = Math.max(0, Math.ceil(-n.x1)), c = Math.max(0, e.height || 0), u = Math.max(0, Math.ceil(-n.y1));
  const f = Math.max(0, Math.ceil(n.x2 - A)), h = Math.max(0, Math.ceil(n.y2 - c));
  if (i.contains === Rcr) {
    const d = t.padding();
    s -= d.left + d.right, a -= d.top + d.bottom;
  }
  o === Pde ? (l = 0, u = 0, A = s, c = a) : o === Srt ? (A = Math.max(0, s - l - f), c = Math.max(0, a - u - h)) : o === Tcr ? (A = Math.max(0, s - l - f), a = c + u + h) : o === Ncr ? (s = A + l + f, c = Math.max(0, a - u - h)) : o === Lcr && (s = A + l + f, a = c + u + h), t._resizeView(s, a, A, c, [l, u], i.resize);
}
const our = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bound: Qrt,
  identifier: Gde,
  mark: wrt,
  overlap: xrt,
  render: Drt,
  viewlayout: Nrt
}, Symbol.toStringTag, { value: "Module" }));
function Lrt(t) {
  yt.call(this, null, t);
}
on(Lrt, yt, {
  transform(t, e) {
    if (this.value && !t.modified())
      return e.StopPropagation;
    var n = e.dataflow.locale(), r = e.fork(e.NO_SOURCE | e.NO_FIELDS), i = this.value, o = t.scale, s = t.count == null ? t.values ? t.values.length : 10 : t.count, a = tde(o, s, t.minstep), A = t.format || pnt(n, o, a, t.formatSpecifier, t.formatType, !!t.values), l = t.values ? dnt(o, t.values, a) : nde(o, a);
    return i && (r.rem = i), i = l.map((c, u) => so({
      index: u / (l.length - 1 || 1),
      value: c,
      label: A(c)
    })), t.extra && i.length && i.push(so({
      index: -1,
      extra: {
        value: i[0].value
      },
      label: ""
    })), r.source = i, r.add = i, this.value = i, r;
  }
});
function Mrt(t) {
  yt.call(this, null, t);
}
function sur() {
  return so({});
}
function aur(t) {
  const e = hx().test((n) => n.exit);
  return e.lookup = (n) => e.get(t(n)), e;
}
on(Mrt, yt, {
  transform(t, e) {
    var n = e.dataflow, r = e.fork(e.NO_SOURCE | e.NO_FIELDS), i = t.item || sur, o = t.key || tr, s = this.value;
    return Nt(r.encode) && (r.encode = null), s && (t.modified("key") || e.modified(o)) && wt("DataJoin does not support modified key function or fields."), s || (e = e.addAll(), this.value = s = aur(o)), e.visit(e.ADD, (a) => {
      const A = o(a);
      let l = s.get(A);
      l ? l.exit ? (s.empty--, r.add.push(l)) : r.mod.push(l) : (l = i(a), s.set(A, l), r.add.push(l)), l.datum = a, l.exit = !1;
    }), e.visit(e.MOD, (a) => {
      const A = o(a), l = s.get(A);
      l && (l.datum = a, r.mod.push(l));
    }), e.visit(e.REM, (a) => {
      const A = o(a), l = s.get(A);
      a === l.datum && !l.exit && (r.rem.push(l), l.exit = !0, ++s.empty);
    }), e.changed(e.ADD_MOD) && r.modifies("datum"), (e.clean() || t.clean && s.empty > n.cleanThreshold) && n.runAfter(s.clean), r;
  }
});
function Ort(t) {
  yt.call(this, null, t);
}
on(Ort, yt, {
  transform(t, e) {
    var n = e.fork(e.ADD_REM), r = t.mod || !1, i = t.encoders, o = e.encode;
    if (Nt(o))
      if (n.changed() || o.every((u) => i[u]))
        o = o[0], n.encode = null;
      else
        return e.StopPropagation;
    var s = o === "enter", a = i.update || Um, A = i.enter || Um, l = i.exit || Um, c = (o && !s ? i[o] : a) || Um;
    if (e.changed(e.ADD) && (e.visit(e.ADD, (u) => {
      A(u, t), a(u, t);
    }), n.modifies(A.output), n.modifies(a.output), c !== Um && c !== a && (e.visit(e.ADD, (u) => {
      c(u, t);
    }), n.modifies(c.output))), e.changed(e.REM) && l !== Um && (e.visit(e.REM, (u) => {
      l(u, t);
    }), n.modifies(l.output)), s || c !== Um) {
      const u = e.MOD | (t.modified() ? e.REFLOW : 0);
      s ? (e.visit(u, (f) => {
        const h = A(f, t) || r;
        (c(f, t) || h) && n.mod.push(f);
      }), n.mod.length && n.modifies(A.output)) : e.visit(u, (f) => {
        (c(f, t) || r) && n.mod.push(f);
      }), n.mod.length && n.modifies(c.output);
    }
    return n.changed() ? n : e.StopPropagation;
  }
});
function Frt(t) {
  yt.call(this, [], t);
}
on(Frt, yt, {
  transform(t, e) {
    if (this.value != null && !t.modified())
      return e.StopPropagation;
    var n = e.dataflow.locale(), r = e.fork(e.NO_SOURCE | e.NO_FIELDS), i = this.value, o = t.type || JG, s = t.scale, a = +t.limit, A = tde(s, t.count == null ? 5 : t.count, t.minstep), l = !!t.values || o === JG, c = t.format || Ent(n, s, A, o, t.formatSpecifier, t.formatType, l), u = t.values || Cnt(s, A), f, h, d, I, m;
    return i && (r.rem = i), o === JG ? (a && u.length > a ? (e.dataflow.warn("Symbol legend count exceeds limit, filtering items."), i = u.slice(0, a - 1), m = !0) : i = u, ri(d = t.size) ? (!t.values && s(i[0]) === 0 && (i = i.slice(1)), I = i.reduce((C, y) => Math.max(C, d(y, t)), 0)) : d = lc(I = d || 8), i = i.map((C, y) => so({
      index: y,
      label: c(C, y, i),
      value: C,
      offset: I,
      size: d(C, t)
    })), m && (m = u[i.length], i.push(so({
      index: i.length,
      label: "…".concat(u.length - i.length, " entries"),
      value: m,
      offset: I,
      size: d(m, t)
    })))) : o === Nar ? (f = s.domain(), h = fnt(s, f[0], bi(f)), u.length < 3 && !t.values && f[0] !== bi(f) && (u = [f[0], bi(f)]), i = u.map((C, y) => so({
      index: y,
      label: c(C, y, u),
      value: C,
      perc: h(C)
    }))) : (d = u.length - 1, h = qar(s), i = u.map((C, y) => so({
      index: y,
      label: c(C, y, u),
      value: C,
      perc: y ? h(C) : 0,
      perc2: y === d ? 1 : h(u[y + 1])
    }))), r.source = i, r.add = i, this.value = i, r;
  }
});
const Aur = (t) => t.source.x, lur = (t) => t.source.y, cur = (t) => t.target.x, uur = (t) => t.target.y;
function Ude(t) {
  yt.call(this, {}, t);
}
Ude.Definition = {
  type: "LinkPath",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "sourceX",
    type: "field",
    default: "source.x"
  }, {
    name: "sourceY",
    type: "field",
    default: "source.y"
  }, {
    name: "targetX",
    type: "field",
    default: "target.x"
  }, {
    name: "targetY",
    type: "field",
    default: "target.y"
  }, {
    name: "orient",
    type: "enum",
    default: "vertical",
    values: ["horizontal", "vertical", "radial"]
  }, {
    name: "shape",
    type: "enum",
    default: "line",
    values: ["line", "arc", "curve", "diagonal", "orthogonal"]
  }, {
    name: "require",
    type: "signal"
  }, {
    name: "as",
    type: "string",
    default: "path"
  }]
};
on(Ude, yt, {
  transform(t, e) {
    var n = t.sourceX || Aur, r = t.sourceY || lur, i = t.targetX || cur, o = t.targetY || uur, s = t.as || "path", a = t.orient || "vertical", A = t.shape || "line", l = LMe.get(A + "-" + a) || LMe.get(A);
    return l || wt("LinkPath unsupported type: " + t.shape + (t.orient ? "-" + t.orient : "")), e.visit(e.SOURCE, (c) => {
      c[s] = l(n(c), r(c), i(c), o(c));
    }), e.reflow(t.modified()).modifies(s);
  }
});
const Prt = (t, e, n, r) => "M" + t + "," + e + "L" + n + "," + r, fur = (t, e, n, r) => Prt(e * Math.cos(t), e * Math.sin(t), r * Math.cos(n), r * Math.sin(n)), krt = (t, e, n, r) => {
  var i = n - t, o = r - e, s = Math.sqrt(i * i + o * o) / 2, a = 180 * Math.atan2(o, i) / Math.PI;
  return "M" + t + "," + e + "A" + s + "," + s + " " + a + " 0 1 " + n + "," + r;
}, gur = (t, e, n, r) => krt(e * Math.cos(t), e * Math.sin(t), r * Math.cos(n), r * Math.sin(n)), Grt = (t, e, n, r) => {
  const i = n - t, o = r - e, s = 0.2 * (i + o), a = 0.2 * (o - i);
  return "M" + t + "," + e + "C" + (t + s) + "," + (e + a) + " " + (n + a) + "," + (r - s) + " " + n + "," + r;
}, hur = (t, e, n, r) => Grt(e * Math.cos(t), e * Math.sin(t), r * Math.cos(n), r * Math.sin(n)), dur = (t, e, n, r) => "M" + t + "," + e + "V" + r + "H" + n, pur = (t, e, n, r) => "M" + t + "," + e + "H" + n + "V" + r, Iur = (t, e, n, r) => {
  const i = Math.cos(t), o = Math.sin(t), s = Math.cos(n), a = Math.sin(n), A = Math.abs(n - t) > Math.PI ? n <= t : n > t;
  return "M" + e * i + "," + e * o + "A" + e + "," + e + " 0 0," + (A ? 1 : 0) + " " + e * s + "," + e * a + "L" + r * s + "," + r * a;
}, mur = (t, e, n, r) => {
  const i = (t + n) / 2;
  return "M" + t + "," + e + "C" + i + "," + e + " " + i + "," + r + " " + n + "," + r;
}, Cur = (t, e, n, r) => {
  const i = (e + r) / 2;
  return "M" + t + "," + e + "C" + t + "," + i + " " + n + "," + i + " " + n + "," + r;
}, Eur = (t, e, n, r) => {
  const i = Math.cos(t), o = Math.sin(t), s = Math.cos(n), a = Math.sin(n), A = (e + r) / 2;
  return "M" + e * i + "," + e * o + "C" + A * i + "," + A * o + " " + A * s + "," + A * a + " " + r * s + "," + r * a;
}, LMe = hx({
  line: Prt,
  "line-radial": fur,
  arc: krt,
  "arc-radial": gur,
  curve: Grt,
  "curve-radial": hur,
  "orthogonal-horizontal": dur,
  "orthogonal-vertical": pur,
  "orthogonal-radial": Iur,
  "diagonal-horizontal": mur,
  "diagonal-vertical": Cur,
  "diagonal-radial": Eur
});
function Hde(t) {
  yt.call(this, null, t);
}
Hde.Definition = {
  type: "Pie",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "startAngle",
    type: "number",
    default: 0
  }, {
    name: "endAngle",
    type: "number",
    default: 6.283185307179586
  }, {
    name: "sort",
    type: "boolean",
    default: !1
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: ["startAngle", "endAngle"]
  }]
};
on(Hde, yt, {
  transform(t, e) {
    var n = t.as || ["startAngle", "endAngle"], r = n[0], i = n[1], o = t.field || ux, s = t.startAngle || 0, a = t.endAngle != null ? t.endAngle : 2 * Math.PI, A = e.source, l = A.map(o), c = l.length, u = s, f = (a - s) / nZe(l), h = E1(c), d, I, m;
    for (t.sort && h.sort((C, y) => l[C] - l[y]), d = 0; d < c; ++d)
      m = l[h[d]], I = A[h[d]], I[r] = u, I[i] = u += m * f;
    return this.value = l, e.reflow(t.modified()).modifies(n);
  }
});
const yur = 5;
function vur(t) {
  const e = t.type;
  return !t.bins && (e === EQ || e === cO || e === uO);
}
function Urt(t) {
  return Xhe(t) && t !== Fp;
}
const Bur = pd(["set", "modified", "clear", "type", "scheme", "schemeExtent", "schemeCount", "domain", "domainMin", "domainMid", "domainMax", "domainRaw", "domainImplicit", "nice", "zero", "bins", "range", "rangeStep", "round", "reverse", "interpolate", "interpolateGamma"]);
function Hrt(t) {
  yt.call(this, null, t), this.modified(!0);
}
on(Hrt, yt, {
  transform(t, e) {
    var n = e.dataflow, r = this.value, i = bur(t);
    (!r || i !== r.type) && (this.value = r = Vi(i)());
    for (i in t)
      if (!Bur[i]) {
        if (i === "padding" && Urt(r.type))
          continue;
        ri(r[i]) ? r[i](t[i]) : n.warn("Unsupported scale property: " + i);
      }
    return Rur(r, t, xur(r, t, Sur(r, t, n))), e.fork(e.NO_SOURCE | e.NO_FIELDS);
  }
});
function bur(t) {
  var e = t.type, n = "", r;
  return e === Fp ? Fp + "-" + EQ : (_ur(t) && (r = t.rawDomain ? t.rawDomain.length : t.domain ? t.domain.length + +(t.domainMid != null) : 0, n = r === 2 ? Fp + "-" : r === 3 ? yx + "-" : ""), (n + e || EQ).toLowerCase());
}
function _ur(t) {
  const e = t.type;
  return Xhe(e) && e !== EB && e !== yB && (t.scheme || t.range && t.range.length && t.range.every(Cn));
}
function Sur(t, e, n) {
  const r = Qur(t, e.domainRaw, n);
  if (r > -1)
    return r;
  var i = e.domain, o = t.type, s = e.zero || e.zero === void 0 && vur(t), a, A;
  if (!i)
    return 0;
  if (Urt(o) && e.padding && i[0] !== bi(i) && (i = wur(o, i, e.range, e.padding, e.exponent, e.constant)), (s || e.domainMin != null || e.domainMax != null || e.domainMid != null) && (a = (i = i.slice()).length - 1 || 1, s && (i[0] > 0 && (i[0] = 0), i[a] < 0 && (i[a] = 0)), e.domainMin != null && (i[0] = e.domainMin), e.domainMax != null && (i[a] = e.domainMax), e.domainMid != null)) {
    A = e.domainMid;
    const l = A > i[a] ? a + 1 : A < i[0] ? 0 : a;
    l !== a && n.warn("Scale domainMid exceeds domain min or max.", A), i.splice(l, 0, A);
  }
  return t.domain($rt(o, i, n)), o === Vhe && t.unknown(e.domainImplicit ? nie : void 0), e.nice && t.nice && t.nice(e.nice !== !0 && tde(t, e.nice) || null), i.length;
}
function Qur(t, e, n) {
  return e ? (t.domain($rt(t.type, e, n)), e.length) : -1;
}
function wur(t, e, n, r, i, o) {
  var s = Math.abs(bi(n) - n[0]), a = s / (s - 2 * r), A = t === kI ? lge(e, null, a) : t === uO ? h5(e, null, a, 0.5) : t === cO ? h5(e, null, a, i || 1) : t === Tj ? cge(e, null, a, o || 1) : Age(e, null, a);
  return e = e.slice(), e[0] = A[0], e[e.length - 1] = A[1], e;
}
function $rt(t, e, n) {
  if (ant(t)) {
    var r = Math.abs(e.reduce((i, o) => i + (o < 0 ? -1 : o > 0 ? 1 : 0), 0));
    r !== e.length && n.warn("Log scale domain includes zero: " + an(e));
  }
  return e;
}
function xur(t, e, n) {
  let r = e.bins;
  if (r && !Nt(r)) {
    const i = t.domain(), o = i[0], s = bi(i), a = r.step;
    let A = r.start == null ? o : r.start, l = r.stop == null ? s : r.stop;
    a || wt("Scale bins parameter missing step property."), A < o && (A = a * Math.ceil(o / a)), l > s && (l = a * Math.floor(s / a)), r = E1(A, l + a / 2, a);
  }
  return r ? t.bins = r : t.bins && delete t.bins, t.type === Jhe && (r ? !e.domain && !e.domainRaw && (t.domain(r), n = r.length) : t.bins = t.domain()), n;
}
function Rur(t, e, n) {
  var r = t.type, i = e.round || !1, o = e.range;
  if (e.rangeStep != null)
    o = Dur(r, e, n);
  else if (e.scheme && (o = Tur(r, e, n), ri(o))) {
    if (t.interpolator)
      return t.interpolator(o);
    wt("Scale type ".concat(r, " does not support interpolating color schemes."));
  }
  if (o && Ant(r))
    return t.interpolator(Mj(bie(o, e.reverse), e.interpolate, e.interpolateGamma));
  o && e.interpolate && t.interpolate ? t.interpolate(Zhe(e.interpolate, e.interpolateGamma)) : ri(t.round) ? t.round(i) : ri(t.rangeRound) && t.interpolate(i ? AO : HE), o && t.range(bie(o, e.reverse));
}
function Dur(t, e, n) {
  t !== rnt && t !== lie && wt("Only band and point scales support rangeStep.");
  var r = (e.paddingOuter != null ? e.paddingOuter : e.padding) || 0, i = t === lie ? 1 : (e.paddingInner != null ? e.paddingInner : e.padding) || 0;
  return [0, e.rangeStep * zhe(n, i, r)];
}
function Tur(t, e, n) {
  var r = e.schemeExtent, i, o;
  return Nt(e.scheme) ? o = Mj(e.scheme, e.interpolate, e.interpolateGamma) : (i = e.scheme.toLowerCase(), o = ede(i), o || wt("Unrecognized scheme name: ".concat(e.scheme))), n = t === Lj ? n + 1 : t === Jhe ? n - 1 : t === yQ || t === Nj ? +e.schemeCount || yur : n, Ant(t) ? MMe(o, r, e.reverse) : ri(o) ? unt(MMe(o, r), n) : t === Vhe ? o : o.slice(0, n);
}
function MMe(t, e, n) {
  return ri(t) && (e || n) ? cnt(t, bie(e || [0, 1], n)) : t;
}
function bie(t, e) {
  return e ? t.slice().reverse() : t;
}
function qrt(t) {
  yt.call(this, null, t);
}
on(qrt, yt, {
  transform(t, e) {
    const n = t.modified("sort") || e.changed(e.ADD) || e.modified(t.sort.fields) || e.modified("datum");
    return n && e.source.sort(B1(t.sort)), this.modified(n), e;
  }
});
const OMe = "zero", jrt = "center", Yrt = "normalize", zrt = ["y0", "y1"];
function $de(t) {
  yt.call(this, null, t);
}
$de.Definition = {
  type: "Stack",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "sort",
    type: "compare"
  }, {
    name: "offset",
    type: "enum",
    default: OMe,
    values: [OMe, jrt, Yrt]
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: zrt
  }]
};
on($de, yt, {
  transform(t, e) {
    var n = t.as || zrt, r = n[0], i = n[1], o = B1(t.sort), s = t.field || ux, a = t.offset === jrt ? Nur : t.offset === Yrt ? Lur : Mur, A, l, c, u;
    for (A = Our(e.source, t.groupby, o, s), l = 0, c = A.length, u = A.max; l < c; ++l)
      a(A[l], u, s, r, i);
    return e.reflow(t.modified()).modifies(n);
  }
});
function Nur(t, e, n, r, i) {
  for (var o = (e - t.sum) / 2, s = t.length, a = 0, A; a < s; ++a)
    A = t[a], A[r] = o, A[i] = o += Math.abs(n(A));
}
function Lur(t, e, n, r, i) {
  for (var o = 1 / t.sum, s = 0, a = t.length, A = 0, l = 0, c; A < a; ++A)
    c = t[A], c[r] = s, c[i] = s = o * (l += Math.abs(n(c)));
}
function Mur(t, e, n, r, i) {
  for (var o = 0, s = 0, a = t.length, A = 0, l, c; A < a; ++A)
    c = t[A], l = +n(c), l < 0 ? (c[r] = s, c[i] = s += l) : (c[r] = o, c[i] = o += l);
}
function Our(t, e, n, r) {
  var i = [], o = (I) => I(c), s, a, A, l, c, u, f, h, d;
  if (e == null)
    i.push(t.slice());
  else
    for (s = {}, a = 0, A = t.length; a < A; ++a)
      c = t[a], u = e.map(o), f = s[u], f || (s[u] = f = [], i.push(f)), f.push(c);
  for (u = 0, d = 0, l = i.length; u < l; ++u) {
    for (f = i[u], a = 0, h = 0, A = f.length; a < A; ++a)
      h += Math.abs(r(f[a]));
    f.sum = h, h > d && (d = h), n && f.sort(n);
  }
  return i.max = d, i;
}
const Fur = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  axisticks: Lrt,
  datajoin: Mrt,
  encode: Ort,
  legendentries: Frt,
  linkpath: Ude,
  pie: Hde,
  scale: Hrt,
  sortitems: qrt,
  stack: $de
}, Symbol.toStringTag, { value: "Module" }));
var hr = 1e-6, z5 = 1e-12, ui = Math.PI, ha = ui / 2, V5 = ui / 4, Wc = ui * 2, wa = 180 / ui, fi = ui / 180, Ti = Math.abs, Bx = Math.atan, zg = Math.atan2, Er = Math.cos, S3 = Math.ceil, Vrt = Math.exp, _ie = Math.hypot, J5 = Math.log, RW = Math.pow, ir = Math.sin, wg = Math.sign || function(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
}, Xc = Math.sqrt, qde = Math.tan;
function Jrt(t) {
  return t > 1 ? 0 : t < -1 ? ui : Math.acos(t);
}
function Hu(t) {
  return t > 1 ? ha : t < -1 ? -ha : Math.asin(t);
}
function ll() {
}
function K5(t, e) {
  t && PMe.hasOwnProperty(t.type) && PMe[t.type](t, e);
}
var FMe = {
  Feature: function(t, e) {
    K5(t.geometry, e);
  },
  FeatureCollection: function(t, e) {
    for (var n = t.features, r = -1, i = n.length; ++r < i; )
      K5(n[r].geometry, e);
  }
}, PMe = {
  Sphere: function(t, e) {
    e.sphere();
  },
  Point: function(t, e) {
    t = t.coordinates, e.point(t[0], t[1], t[2]);
  },
  MultiPoint: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      t = n[r], e.point(t[0], t[1], t[2]);
  },
  LineString: function(t, e) {
    Sie(t.coordinates, e, 0);
  },
  MultiLineString: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      Sie(n[r], e, 0);
  },
  Polygon: function(t, e) {
    kMe(t.coordinates, e);
  },
  MultiPolygon: function(t, e) {
    for (var n = t.coordinates, r = -1, i = n.length; ++r < i; )
      kMe(n[r], e);
  },
  GeometryCollection: function(t, e) {
    for (var n = t.geometries, r = -1, i = n.length; ++r < i; )
      K5(n[r], e);
  }
};
function Sie(t, e, n) {
  var r = -1, i = t.length - n, o;
  for (e.lineStart(); ++r < i; )
    o = t[r], e.point(o[0], o[1], o[2]);
  e.lineEnd();
}
function kMe(t, e) {
  var n = -1, r = t.length;
  for (e.polygonStart(); ++n < r; )
    Sie(t[n], e, 1);
  e.polygonEnd();
}
function iI(t, e) {
  t && FMe.hasOwnProperty(t.type) ? FMe[t.type](t, e) : K5(t, e);
}
var W5 = new jc(), X5 = new jc(), Krt, Wrt, Qie, wie, xie, Wp = {
  point: ll,
  lineStart: ll,
  lineEnd: ll,
  polygonStart: function() {
    W5 = new jc(), Wp.lineStart = Pur, Wp.lineEnd = kur;
  },
  polygonEnd: function() {
    var t = +W5;
    X5.add(t < 0 ? Wc + t : t), this.lineStart = this.lineEnd = this.point = ll;
  },
  sphere: function() {
    X5.add(Wc);
  }
};
function Pur() {
  Wp.point = Gur;
}
function kur() {
  Xrt(Krt, Wrt);
}
function Gur(t, e) {
  Wp.point = Xrt, Krt = t, Wrt = e, t *= fi, e *= fi, Qie = t, wie = Er(e = e / 2 + V5), xie = ir(e);
}
function Xrt(t, e) {
  t *= fi, e *= fi, e = e / 2 + V5;
  var n = t - Qie, r = n >= 0 ? 1 : -1, i = r * n, o = Er(e), s = ir(e), a = xie * s, A = wie * o + a * Er(i), l = a * r * ir(i);
  W5.add(zg(l, A)), Qie = t, wie = o, xie = s;
}
function Uur(t) {
  return X5 = new jc(), iI(t, Wp), X5 * 2;
}
function Z5(t) {
  return [zg(t[1], t[0]), Hu(t[2])];
}
function vB(t) {
  var e = t[0], n = t[1], r = Er(n);
  return [r * Er(e), r * ir(e), ir(n)];
}
function Q3(t, e) {
  return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
}
function wQ(t, e) {
  return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]];
}
function DW(t, e) {
  t[0] += e[0], t[1] += e[1], t[2] += e[2];
}
function w3(t, e) {
  return [t[0] * e, t[1] * e, t[2] * e];
}
function e6(t) {
  var e = Xc(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
  t[0] /= e, t[1] /= e, t[2] /= e;
}
var Vs, vu, la, vf, jy, Zrt, eit, lS, $D, Wm, GI, Z0 = {
  point: Rie,
  lineStart: GMe,
  lineEnd: UMe,
  polygonStart: function() {
    Z0.point = nit, Z0.lineStart = Hur, Z0.lineEnd = $ur, $D = new jc(), Wp.polygonStart();
  },
  polygonEnd: function() {
    Wp.polygonEnd(), Z0.point = Rie, Z0.lineStart = GMe, Z0.lineEnd = UMe, W5 < 0 ? (Vs = -(la = 180), vu = -(vf = 90)) : $D > hr ? vf = 90 : $D < -hr && (vu = -90), GI[0] = Vs, GI[1] = la;
  },
  sphere: function() {
    Vs = -(la = 180), vu = -(vf = 90);
  }
};
function Rie(t, e) {
  Wm.push(GI = [Vs = t, la = t]), e < vu && (vu = e), e > vf && (vf = e);
}
function tit(t, e) {
  var n = vB([t * fi, e * fi]);
  if (lS) {
    var r = wQ(lS, n), i = [r[1], -r[0], 0], o = wQ(i, r);
    e6(o), o = Z5(o);
    var s = t - jy, a = s > 0 ? 1 : -1, A = o[0] * wa * a, l, c = Ti(s) > 180;
    c ^ (a * jy < A && A < a * t) ? (l = o[1] * wa, l > vf && (vf = l)) : (A = (A + 360) % 360 - 180, c ^ (a * jy < A && A < a * t) ? (l = -o[1] * wa, l < vu && (vu = l)) : (e < vu && (vu = e), e > vf && (vf = e))), c ? t < jy ? Cf(Vs, t) > Cf(Vs, la) && (la = t) : Cf(t, la) > Cf(Vs, la) && (Vs = t) : la >= Vs ? (t < Vs && (Vs = t), t > la && (la = t)) : t > jy ? Cf(Vs, t) > Cf(Vs, la) && (la = t) : Cf(t, la) > Cf(Vs, la) && (Vs = t);
  } else
    Wm.push(GI = [Vs = t, la = t]);
  e < vu && (vu = e), e > vf && (vf = e), lS = n, jy = t;
}
function GMe() {
  Z0.point = tit;
}
function UMe() {
  GI[0] = Vs, GI[1] = la, Z0.point = Rie, lS = null;
}
function nit(t, e) {
  if (lS) {
    var n = t - jy;
    $D.add(Ti(n) > 180 ? n + (n > 0 ? 360 : -360) : n);
  } else
    Zrt = t, eit = e;
  Wp.point(t, e), tit(t, e);
}
function Hur() {
  Wp.lineStart();
}
function $ur() {
  nit(Zrt, eit), Wp.lineEnd(), Ti($D) > hr && (Vs = -(la = 180)), GI[0] = Vs, GI[1] = la, lS = null;
}
function Cf(t, e) {
  return (e -= t) < 0 ? e + 360 : e;
}
function qur(t, e) {
  return t[0] - e[0];
}
function HMe(t, e) {
  return t[0] <= t[1] ? t[0] <= e && e <= t[1] : e < t[0] || t[1] < e;
}
function jur(t) {
  var e, n, r, i, o, s, a;
  if (vf = la = -(Vs = vu = 1 / 0), Wm = [], iI(t, Z0), n = Wm.length) {
    for (Wm.sort(qur), e = 1, r = Wm[0], o = [r]; e < n; ++e)
      i = Wm[e], HMe(r, i[0]) || HMe(r, i[1]) ? (Cf(r[0], i[1]) > Cf(r[0], r[1]) && (r[1] = i[1]), Cf(i[0], r[1]) > Cf(r[0], r[1]) && (r[0] = i[0])) : o.push(r = i);
    for (s = -1 / 0, n = o.length - 1, e = 0, r = o[n]; e <= n; r = i, ++e)
      i = o[e], (a = Cf(r[1], i[0])) > s && (s = a, Vs = i[0], la = r[1]);
  }
  return Wm = GI = null, Vs === 1 / 0 || vu === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[Vs, vu], [la, vf]];
}
var JR, t6, n6, r6, i6, o6, s6, a6, Die, Tie, Nie, rit, iit, Mc, Oc, Fc, Wh = {
  sphere: ll,
  point: jde,
  lineStart: $Me,
  lineEnd: qMe,
  polygonStart: function() {
    Wh.lineStart = Vur, Wh.lineEnd = Jur;
  },
  polygonEnd: function() {
    Wh.lineStart = $Me, Wh.lineEnd = qMe;
  }
};
function jde(t, e) {
  t *= fi, e *= fi;
  var n = Er(e);
  vO(n * Er(t), n * ir(t), ir(e));
}
function vO(t, e, n) {
  ++JR, n6 += (t - n6) / JR, r6 += (e - r6) / JR, i6 += (n - i6) / JR;
}
function $Me() {
  Wh.point = Yur;
}
function Yur(t, e) {
  t *= fi, e *= fi;
  var n = Er(e);
  Mc = n * Er(t), Oc = n * ir(t), Fc = ir(e), Wh.point = zur, vO(Mc, Oc, Fc);
}
function zur(t, e) {
  t *= fi, e *= fi;
  var n = Er(e), r = n * Er(t), i = n * ir(t), o = ir(e), s = zg(Xc((s = Oc * o - Fc * i) * s + (s = Fc * r - Mc * o) * s + (s = Mc * i - Oc * r) * s), Mc * r + Oc * i + Fc * o);
  t6 += s, o6 += s * (Mc + (Mc = r)), s6 += s * (Oc + (Oc = i)), a6 += s * (Fc + (Fc = o)), vO(Mc, Oc, Fc);
}
function qMe() {
  Wh.point = jde;
}
function Vur() {
  Wh.point = Kur;
}
function Jur() {
  oit(rit, iit), Wh.point = jde;
}
function Kur(t, e) {
  rit = t, iit = e, t *= fi, e *= fi, Wh.point = oit;
  var n = Er(e);
  Mc = n * Er(t), Oc = n * ir(t), Fc = ir(e), vO(Mc, Oc, Fc);
}
function oit(t, e) {
  t *= fi, e *= fi;
  var n = Er(e), r = n * Er(t), i = n * ir(t), o = ir(e), s = Oc * o - Fc * i, a = Fc * r - Mc * o, A = Mc * i - Oc * r, l = _ie(s, a, A), c = Hu(l), u = l && -c / l;
  Die.add(u * s), Tie.add(u * a), Nie.add(u * A), t6 += c, o6 += c * (Mc + (Mc = r)), s6 += c * (Oc + (Oc = i)), a6 += c * (Fc + (Fc = o)), vO(Mc, Oc, Fc);
}
function Wur(t) {
  JR = t6 = n6 = r6 = i6 = o6 = s6 = a6 = 0, Die = new jc(), Tie = new jc(), Nie = new jc(), iI(t, Wh);
  var e = +Die, n = +Tie, r = +Nie, i = _ie(e, n, r);
  return i < z5 && (e = o6, n = s6, r = a6, t6 < hr && (e = n6, n = r6, r = i6), i = _ie(e, n, r), i < z5) ? [NaN, NaN] : [zg(n, e) * wa, Hu(r / i) * wa];
}
function Lie(t, e) {
  function n(r, i) {
    return r = t(r, i), e(r[0], r[1]);
  }
  return t.invert && e.invert && (n.invert = function(r, i) {
    return r = e.invert(r, i), r && t.invert(r[0], r[1]);
  }), n;
}
function Mie(t, e) {
  return [Ti(t) > ui ? t + Math.round(-t / Wc) * Wc : t, e];
}
Mie.invert = Mie;
function sit(t, e, n) {
  return (t %= Wc) ? e || n ? Lie(YMe(t), zMe(e, n)) : YMe(t) : e || n ? zMe(e, n) : Mie;
}
function jMe(t) {
  return function(e, n) {
    return e += t, [e > ui ? e - Wc : e < -ui ? e + Wc : e, n];
  };
}
function YMe(t) {
  var e = jMe(t);
  return e.invert = jMe(-t), e;
}
function zMe(t, e) {
  var n = Er(t), r = ir(t), i = Er(e), o = ir(e);
  function s(a, A) {
    var l = Er(A), c = Er(a) * l, u = ir(a) * l, f = ir(A), h = f * n + c * r;
    return [
      zg(u * i - h * o, c * n - f * r),
      Hu(h * i + u * o)
    ];
  }
  return s.invert = function(a, A) {
    var l = Er(A), c = Er(a) * l, u = ir(a) * l, f = ir(A), h = f * i - u * o;
    return [
      zg(u * i + f * o, c * n + h * r),
      Hu(h * n - c * r)
    ];
  }, s;
}
function Xur(t) {
  t = sit(t[0] * fi, t[1] * fi, t.length > 2 ? t[2] * fi : 0);
  function e(n) {
    return n = t(n[0] * fi, n[1] * fi), n[0] *= wa, n[1] *= wa, n;
  }
  return e.invert = function(n) {
    return n = t.invert(n[0] * fi, n[1] * fi), n[0] *= wa, n[1] *= wa, n;
  }, e;
}
function Zur(t, e, n, r, i, o) {
  if (n) {
    var s = Er(e), a = ir(e), A = r * n;
    i == null ? (i = e + r * Wc, o = e - A / 2) : (i = VMe(s, i), o = VMe(s, o), (r > 0 ? i < o : i > o) && (i += r * Wc));
    for (var l, c = i; r > 0 ? c > o : c < o; c -= A)
      l = Z5([s, -a * Er(c), -a * ir(c)]), t.point(l[0], l[1]);
  }
}
function VMe(t, e) {
  e = vB(e), e[0] -= t, e6(e);
  var n = Jrt(-e[1]);
  return ((-e[2] < 0 ? -n : n) + Wc - hr) % Wc;
}
function ait() {
  var t = [], e;
  return {
    point: function(n, r, i) {
      e.push([n, r, i]);
    },
    lineStart: function() {
      t.push(e = []);
    },
    lineEnd: ll,
    rejoin: function() {
      t.length > 1 && t.push(t.pop().concat(t.shift()));
    },
    result: function() {
      var n = t;
      return t = [], e = null, n;
    }
  };
}
function r4(t, e) {
  return Ti(t[0] - e[0]) < hr && Ti(t[1] - e[1]) < hr;
}
function x3(t, e, n, r) {
  this.x = t, this.z = e, this.o = n, this.e = r, this.v = !1, this.n = this.p = null;
}
function Ait(t, e, n, r, i) {
  var o = [], s = [], a, A;
  if (t.forEach(function(d) {
    if (!((I = d.length - 1) <= 0)) {
      var I, m = d[0], C = d[I], y;
      if (r4(m, C)) {
        if (!m[2] && !C[2]) {
          for (i.lineStart(), a = 0; a < I; ++a)
            i.point((m = d[a])[0], m[1]);
          i.lineEnd();
          return;
        }
        C[0] += 2 * hr;
      }
      o.push(y = new x3(m, d, null, !0)), s.push(y.o = new x3(m, null, y, !1)), o.push(y = new x3(C, d, null, !1)), s.push(y.o = new x3(C, null, y, !0));
    }
  }), !!o.length) {
    for (s.sort(e), JMe(o), JMe(s), a = 0, A = s.length; a < A; ++a)
      s[a].e = n = !n;
    for (var l = o[0], c, u; ; ) {
      for (var f = l, h = !0; f.v; )
        if ((f = f.n) === l)
          return;
      c = f.z, i.lineStart();
      do {
        if (f.v = f.o.v = !0, f.e) {
          if (h)
            for (a = 0, A = c.length; a < A; ++a)
              i.point((u = c[a])[0], u[1]);
          else
            r(f.x, f.n.x, 1, i);
          f = f.n;
        } else {
          if (h)
            for (c = f.p.z, a = c.length - 1; a >= 0; --a)
              i.point((u = c[a])[0], u[1]);
          else
            r(f.x, f.p.x, -1, i);
          f = f.p;
        }
        f = f.o, c = f.z, h = !h;
      } while (!f.v);
      i.lineEnd();
    }
  }
}
function JMe(t) {
  if (e = t.length) {
    for (var e, n = 0, r = t[0], i; ++n < e; )
      r.n = i = t[n], i.p = r, r = i;
    r.n = i = t[0], i.p = r;
  }
}
function TW(t) {
  return Ti(t[0]) <= ui ? t[0] : wg(t[0]) * ((Ti(t[0]) + ui) % Wc - ui);
}
function efr(t, e) {
  var n = TW(e), r = e[1], i = ir(r), o = [ir(n), -Er(n), 0], s = 0, a = 0, A = new jc();
  i === 1 ? r = ha + hr : i === -1 && (r = -ha - hr);
  for (var l = 0, c = t.length; l < c; ++l)
    if (f = (u = t[l]).length)
      for (var u, f, h = u[f - 1], d = TW(h), I = h[1] / 2 + V5, m = ir(I), C = Er(I), y = 0; y < f; ++y, d = b, m = w, C = R, h = v) {
        var v = u[y], b = TW(v), Q = v[1] / 2 + V5, w = ir(Q), R = Er(Q), M = b - d, O = M >= 0 ? 1 : -1, L = O * M, N = L > ui, k = m * w;
        if (A.add(zg(k * O * ir(L), C * R + k * Er(L))), s += N ? M + O * Wc : M, N ^ d >= n ^ b >= n) {
          var $ = wQ(vB(h), vB(v));
          e6($);
          var U = wQ(o, $);
          e6(U);
          var X = (N ^ M >= 0 ? -1 : 1) * Hu(U[2]);
          (r > X || r === X && ($[0] || $[1])) && (a += N ^ M >= 0 ? 1 : -1);
        }
      }
  return (s < -hr || s < hr && A < -z5) ^ a & 1;
}
function lit(t, e, n, r) {
  return function(i) {
    var o = e(i), s = ait(), a = e(s), A = !1, l, c, u, f = {
      point: h,
      lineStart: I,
      lineEnd: m,
      polygonStart: function() {
        f.point = C, f.lineStart = y, f.lineEnd = v, c = [], l = [];
      },
      polygonEnd: function() {
        f.point = h, f.lineStart = I, f.lineEnd = m, c = x8e(c);
        var b = efr(l, r);
        c.length ? (A || (i.polygonStart(), A = !0), Ait(c, nfr, b, n, i)) : b && (A || (i.polygonStart(), A = !0), i.lineStart(), n(null, null, 1, i), i.lineEnd()), A && (i.polygonEnd(), A = !1), c = l = null;
      },
      sphere: function() {
        i.polygonStart(), i.lineStart(), n(null, null, 1, i), i.lineEnd(), i.polygonEnd();
      }
    };
    function h(b, Q) {
      t(b, Q) && i.point(b, Q);
    }
    function d(b, Q) {
      o.point(b, Q);
    }
    function I() {
      f.point = d, o.lineStart();
    }
    function m() {
      f.point = h, o.lineEnd();
    }
    function C(b, Q) {
      u.push([b, Q]), a.point(b, Q);
    }
    function y() {
      a.lineStart(), u = [];
    }
    function v() {
      C(u[0][0], u[0][1]), a.lineEnd();
      var b = a.clean(), Q = s.result(), w, R = Q.length, M, O, L;
      if (u.pop(), l.push(u), u = null, !!R) {
        if (b & 1) {
          if (O = Q[0], (M = O.length - 1) > 0) {
            for (A || (i.polygonStart(), A = !0), i.lineStart(), w = 0; w < M; ++w)
              i.point((L = O[w])[0], L[1]);
            i.lineEnd();
          }
          return;
        }
        R > 1 && b & 2 && Q.push(Q.pop().concat(Q.shift())), c.push(Q.filter(tfr));
      }
    }
    return f;
  };
}
function tfr(t) {
  return t.length > 1;
}
function nfr(t, e) {
  return ((t = t.x)[0] < 0 ? t[1] - ha - hr : ha - t[1]) - ((e = e.x)[0] < 0 ? e[1] - ha - hr : ha - e[1]);
}
const KMe = lit(
  function() {
    return !0;
  },
  rfr,
  ofr,
  [-ui, -ha]
);
function rfr(t) {
  var e = NaN, n = NaN, r = NaN, i;
  return {
    lineStart: function() {
      t.lineStart(), i = 1;
    },
    point: function(o, s) {
      var a = o > 0 ? ui : -ui, A = Ti(o - e);
      Ti(A - ui) < hr ? (t.point(e, n = (n + s) / 2 > 0 ? ha : -ha), t.point(r, n), t.lineEnd(), t.lineStart(), t.point(a, n), t.point(o, n), i = 0) : r !== a && A >= ui && (Ti(e - r) < hr && (e -= r * hr), Ti(o - a) < hr && (o -= a * hr), n = ifr(e, n, o, s), t.point(r, n), t.lineEnd(), t.lineStart(), t.point(a, n), i = 0), t.point(e = o, n = s), r = a;
    },
    lineEnd: function() {
      t.lineEnd(), e = n = NaN;
    },
    clean: function() {
      return 2 - i;
    }
  };
}
function ifr(t, e, n, r) {
  var i, o, s = ir(t - n);
  return Ti(s) > hr ? Bx((ir(e) * (o = Er(r)) * ir(n) - ir(r) * (i = Er(e)) * ir(t)) / (i * o * s)) : (e + r) / 2;
}
function ofr(t, e, n, r) {
  var i;
  if (t == null)
    i = n * ha, r.point(-ui, i), r.point(0, i), r.point(ui, i), r.point(ui, 0), r.point(ui, -i), r.point(0, -i), r.point(-ui, -i), r.point(-ui, 0), r.point(-ui, i);
  else if (Ti(t[0] - e[0]) > hr) {
    var o = t[0] < e[0] ? ui : -ui;
    i = n * o / 2, r.point(-o, i), r.point(0, i), r.point(o, i);
  } else
    r.point(e[0], e[1]);
}
function sfr(t) {
  var e = Er(t), n = 6 * fi, r = e > 0, i = Ti(e) > hr;
  function o(c, u, f, h) {
    Zur(h, t, n, f, c, u);
  }
  function s(c, u) {
    return Er(c) * Er(u) > e;
  }
  function a(c) {
    var u, f, h, d, I;
    return {
      lineStart: function() {
        d = h = !1, I = 1;
      },
      point: function(m, C) {
        var y = [m, C], v, b = s(m, C), Q = r ? b ? 0 : l(m, C) : b ? l(m + (m < 0 ? ui : -ui), C) : 0;
        if (!u && (d = h = b) && c.lineStart(), b !== h && (v = A(u, y), (!v || r4(u, v) || r4(y, v)) && (y[2] = 1)), b !== h)
          I = 0, b ? (c.lineStart(), v = A(y, u), c.point(v[0], v[1])) : (v = A(u, y), c.point(v[0], v[1], 2), c.lineEnd()), u = v;
        else if (i && u && r ^ b) {
          var w;
          !(Q & f) && (w = A(y, u, !0)) && (I = 0, r ? (c.lineStart(), c.point(w[0][0], w[0][1]), c.point(w[1][0], w[1][1]), c.lineEnd()) : (c.point(w[1][0], w[1][1]), c.lineEnd(), c.lineStart(), c.point(w[0][0], w[0][1], 3)));
        }
        b && (!u || !r4(u, y)) && c.point(y[0], y[1]), u = y, h = b, f = Q;
      },
      lineEnd: function() {
        h && c.lineEnd(), u = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return I | (d && h) << 1;
      }
    };
  }
  function A(c, u, f) {
    var h = vB(c), d = vB(u), I = [1, 0, 0], m = wQ(h, d), C = Q3(m, m), y = m[0], v = C - y * y;
    if (!v)
      return !f && c;
    var b = e * C / v, Q = -e * y / v, w = wQ(I, m), R = w3(I, b), M = w3(m, Q);
    DW(R, M);
    var O = w, L = Q3(R, O), N = Q3(O, O), k = L * L - N * (Q3(R, R) - 1);
    if (!(k < 0)) {
      var $ = Xc(k), U = w3(O, (-L - $) / N);
      if (DW(U, R), U = Z5(U), !f)
        return U;
      var X = c[0], K = u[0], z = c[1], Y = u[1], V;
      K < X && (V = X, X = K, K = V);
      var Z = K - X, ce = Ti(Z - ui) < hr, ee = ce || Z < hr;
      if (!ce && Y < z && (V = z, z = Y, Y = V), ee ? ce ? z + Y > 0 ^ U[1] < (Ti(U[0] - X) < hr ? z : Y) : z <= U[1] && U[1] <= Y : Z > ui ^ (X <= U[0] && U[0] <= K)) {
        var pe = w3(O, (-L + $) / N);
        return DW(pe, R), [U, Z5(pe)];
      }
    }
  }
  function l(c, u) {
    var f = r ? t : ui - t, h = 0;
    return c < -f ? h |= 1 : c > f && (h |= 2), u < -f ? h |= 4 : u > f && (h |= 8), h;
  }
  return lit(s, a, o, r ? [0, -t] : [-ui, t - ui]);
}
function afr(t, e, n, r, i, o) {
  var s = t[0], a = t[1], A = e[0], l = e[1], c = 0, u = 1, f = A - s, h = l - a, d;
  if (d = n - s, !(!f && d > 0)) {
    if (d /= f, f < 0) {
      if (d < c)
        return;
      d < u && (u = d);
    } else if (f > 0) {
      if (d > u)
        return;
      d > c && (c = d);
    }
    if (d = i - s, !(!f && d < 0)) {
      if (d /= f, f < 0) {
        if (d > u)
          return;
        d > c && (c = d);
      } else if (f > 0) {
        if (d < c)
          return;
        d < u && (u = d);
      }
      if (d = r - a, !(!h && d > 0)) {
        if (d /= h, h < 0) {
          if (d < c)
            return;
          d < u && (u = d);
        } else if (h > 0) {
          if (d > u)
            return;
          d > c && (c = d);
        }
        if (d = o - a, !(!h && d < 0)) {
          if (d /= h, h < 0) {
            if (d > u)
              return;
            d > c && (c = d);
          } else if (h > 0) {
            if (d < c)
              return;
            d < u && (u = d);
          }
          return c > 0 && (t[0] = s + c * f, t[1] = a + c * h), u < 1 && (e[0] = s + u * f, e[1] = a + u * h), !0;
        }
      }
    }
  }
}
var KR = 1e9, R3 = -KR;
function cit(t, e, n, r) {
  function i(l, c) {
    return t <= l && l <= n && e <= c && c <= r;
  }
  function o(l, c, u, f) {
    var h = 0, d = 0;
    if (l == null || (h = s(l, u)) !== (d = s(c, u)) || A(l, c) < 0 ^ u > 0)
      do
        f.point(h === 0 || h === 3 ? t : n, h > 1 ? r : e);
      while ((h = (h + u + 4) % 4) !== d);
    else
      f.point(c[0], c[1]);
  }
  function s(l, c) {
    return Ti(l[0] - t) < hr ? c > 0 ? 0 : 3 : Ti(l[0] - n) < hr ? c > 0 ? 2 : 1 : Ti(l[1] - e) < hr ? c > 0 ? 1 : 0 : c > 0 ? 3 : 2;
  }
  function a(l, c) {
    return A(l.x, c.x);
  }
  function A(l, c) {
    var u = s(l, 1), f = s(c, 1);
    return u !== f ? u - f : u === 0 ? c[1] - l[1] : u === 1 ? l[0] - c[0] : u === 2 ? l[1] - c[1] : c[0] - l[0];
  }
  return function(l) {
    var c = l, u = ait(), f, h, d, I, m, C, y, v, b, Q, w, R = {
      point: M,
      lineStart: k,
      lineEnd: $,
      polygonStart: L,
      polygonEnd: N
    };
    function M(X, K) {
      i(X, K) && c.point(X, K);
    }
    function O() {
      for (var X = 0, K = 0, z = h.length; K < z; ++K)
        for (var Y = h[K], V = 1, Z = Y.length, ce = Y[0], ee, pe, Ce = ce[0], Be = ce[1]; V < Z; ++V)
          ee = Ce, pe = Be, ce = Y[V], Ce = ce[0], Be = ce[1], pe <= r ? Be > r && (Ce - ee) * (r - pe) > (Be - pe) * (t - ee) && ++X : Be <= r && (Ce - ee) * (r - pe) < (Be - pe) * (t - ee) && --X;
      return X;
    }
    function L() {
      c = u, f = [], h = [], w = !0;
    }
    function N() {
      var X = O(), K = w && X, z = (f = x8e(f)).length;
      (K || z) && (l.polygonStart(), K && (l.lineStart(), o(null, null, 1, l), l.lineEnd()), z && Ait(f, a, X, o, l), l.polygonEnd()), c = l, f = h = d = null;
    }
    function k() {
      R.point = U, h && h.push(d = []), Q = !0, b = !1, y = v = NaN;
    }
    function $() {
      f && (U(I, m), C && b && u.rejoin(), f.push(u.result())), R.point = M, b && c.lineEnd();
    }
    function U(X, K) {
      var z = i(X, K);
      if (h && d.push([X, K]), Q)
        I = X, m = K, C = z, Q = !1, z && (c.lineStart(), c.point(X, K));
      else if (z && b)
        c.point(X, K);
      else {
        var Y = [y = Math.max(R3, Math.min(KR, y)), v = Math.max(R3, Math.min(KR, v))], V = [X = Math.max(R3, Math.min(KR, X)), K = Math.max(R3, Math.min(KR, K))];
        afr(Y, V, t, e, n, r) ? (b || (c.lineStart(), c.point(Y[0], Y[1])), c.point(V[0], V[1]), z || c.lineEnd(), w = !1) : z && (c.lineStart(), c.point(X, K), w = !1);
      }
      y = X, v = K, b = z;
    }
    return R;
  };
}
function WMe(t, e, n) {
  var r = A_(t, e - hr, n).concat(e);
  return function(i) {
    return r.map(function(o) {
      return [i, o];
    });
  };
}
function XMe(t, e, n) {
  var r = A_(t, e - hr, n).concat(e);
  return function(i) {
    return r.map(function(o) {
      return [o, i];
    });
  };
}
function Afr() {
  var t, e, n, r, i, o, s, a, A = 10, l = A, c = 90, u = 360, f, h, d, I, m = 2.5;
  function C() {
    return { type: "MultiLineString", coordinates: y() };
  }
  function y() {
    return A_(S3(r / c) * c, n, c).map(d).concat(A_(S3(a / u) * u, s, u).map(I)).concat(A_(S3(e / A) * A, t, A).filter(function(v) {
      return Ti(v % c) > hr;
    }).map(f)).concat(A_(S3(o / l) * l, i, l).filter(function(v) {
      return Ti(v % u) > hr;
    }).map(h));
  }
  return C.lines = function() {
    return y().map(function(v) {
      return { type: "LineString", coordinates: v };
    });
  }, C.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        d(r).concat(
          I(s).slice(1),
          d(n).reverse().slice(1),
          I(a).reverse().slice(1)
        )
      ]
    };
  }, C.extent = function(v) {
    return arguments.length ? C.extentMajor(v).extentMinor(v) : C.extentMinor();
  }, C.extentMajor = function(v) {
    return arguments.length ? (r = +v[0][0], n = +v[1][0], a = +v[0][1], s = +v[1][1], r > n && (v = r, r = n, n = v), a > s && (v = a, a = s, s = v), C.precision(m)) : [[r, a], [n, s]];
  }, C.extentMinor = function(v) {
    return arguments.length ? (e = +v[0][0], t = +v[1][0], o = +v[0][1], i = +v[1][1], e > t && (v = e, e = t, t = v), o > i && (v = o, o = i, i = v), C.precision(m)) : [[e, o], [t, i]];
  }, C.step = function(v) {
    return arguments.length ? C.stepMajor(v).stepMinor(v) : C.stepMinor();
  }, C.stepMajor = function(v) {
    return arguments.length ? (c = +v[0], u = +v[1], C) : [c, u];
  }, C.stepMinor = function(v) {
    return arguments.length ? (A = +v[0], l = +v[1], C) : [A, l];
  }, C.precision = function(v) {
    return arguments.length ? (m = +v, f = WMe(o, i, 90), h = XMe(e, t, m), d = WMe(a, s, 90), I = XMe(r, n, m), C) : m;
  }, C.extentMajor([[-180, -90 + hr], [180, 90 - hr]]).extentMinor([[-180, -80 - hr], [180, 80 + hr]]);
}
const wN = (t) => t;
var NW = new jc(), Oie = new jc(), uit, fit, Fie, Pie, rC = {
  point: ll,
  lineStart: ll,
  lineEnd: ll,
  polygonStart: function() {
    rC.lineStart = lfr, rC.lineEnd = ufr;
  },
  polygonEnd: function() {
    rC.lineStart = rC.lineEnd = rC.point = ll, NW.add(Ti(Oie)), Oie = new jc();
  },
  result: function() {
    var t = NW / 2;
    return NW = new jc(), t;
  }
};
function lfr() {
  rC.point = cfr;
}
function cfr(t, e) {
  rC.point = git, uit = Fie = t, fit = Pie = e;
}
function git(t, e) {
  Oie.add(Pie * t - Fie * e), Fie = t, Pie = e;
}
function ufr() {
  git(uit, fit);
}
const ZMe = rC;
var xQ = 1 / 0, A6 = xQ, xN = -xQ, l6 = xN, ffr = {
  point: gfr,
  lineStart: ll,
  lineEnd: ll,
  polygonStart: ll,
  polygonEnd: ll,
  result: function() {
    var t = [[xQ, A6], [xN, l6]];
    return xN = l6 = -(A6 = xQ = 1 / 0), t;
  }
};
function gfr(t, e) {
  t < xQ && (xQ = t), t > xN && (xN = t), e < A6 && (A6 = e), e > l6 && (l6 = e);
}
const c6 = ffr;
var kie = 0, Gie = 0, WR = 0, u6 = 0, f6 = 0, w_ = 0, Uie = 0, Hie = 0, XR = 0, hit, dit, yp, vp, Gh = {
  point: BB,
  lineStart: eOe,
  lineEnd: tOe,
  polygonStart: function() {
    Gh.lineStart = pfr, Gh.lineEnd = Ifr;
  },
  polygonEnd: function() {
    Gh.point = BB, Gh.lineStart = eOe, Gh.lineEnd = tOe;
  },
  result: function() {
    var t = XR ? [Uie / XR, Hie / XR] : w_ ? [u6 / w_, f6 / w_] : WR ? [kie / WR, Gie / WR] : [NaN, NaN];
    return kie = Gie = WR = u6 = f6 = w_ = Uie = Hie = XR = 0, t;
  }
};
function BB(t, e) {
  kie += t, Gie += e, ++WR;
}
function eOe() {
  Gh.point = hfr;
}
function hfr(t, e) {
  Gh.point = dfr, BB(yp = t, vp = e);
}
function dfr(t, e) {
  var n = t - yp, r = e - vp, i = Xc(n * n + r * r);
  u6 += i * (yp + t) / 2, f6 += i * (vp + e) / 2, w_ += i, BB(yp = t, vp = e);
}
function tOe() {
  Gh.point = BB;
}
function pfr() {
  Gh.point = mfr;
}
function Ifr() {
  pit(hit, dit);
}
function mfr(t, e) {
  Gh.point = pit, BB(hit = yp = t, dit = vp = e);
}
function pit(t, e) {
  var n = t - yp, r = e - vp, i = Xc(n * n + r * r);
  u6 += i * (yp + t) / 2, f6 += i * (vp + e) / 2, w_ += i, i = vp * t - yp * e, Uie += i * (yp + t), Hie += i * (vp + e), XR += i * 3, BB(yp = t, vp = e);
}
const nOe = Gh;
function Iit(t) {
  this._context = t;
}
Iit.prototype = {
  _radius: 4.5,
  pointRadius: function(t) {
    return this._radius = t, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._context.closePath(), this._point = NaN;
  },
  point: function(t, e) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(t, e), this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(t, e);
        break;
      }
      default: {
        this._context.moveTo(t + this._radius, e), this._context.arc(t, e, this._radius, 0, Wc);
        break;
      }
    }
  },
  result: ll
};
var $ie = new jc(), LW, mit, Cit, ZR, eD, g6 = {
  point: ll,
  lineStart: function() {
    g6.point = Cfr;
  },
  lineEnd: function() {
    LW && Eit(mit, Cit), g6.point = ll;
  },
  polygonStart: function() {
    LW = !0;
  },
  polygonEnd: function() {
    LW = null;
  },
  result: function() {
    var t = +$ie;
    return $ie = new jc(), t;
  }
};
function Cfr(t, e) {
  g6.point = Eit, mit = ZR = t, Cit = eD = e;
}
function Eit(t, e) {
  ZR -= t, eD -= e, $ie.add(Xc(ZR * ZR + eD * eD)), ZR = t, eD = e;
}
const rOe = g6;
function yit() {
  this._string = [];
}
yit.prototype = {
  _radius: 4.5,
  _circle: iOe(4.5),
  pointRadius: function(t) {
    return (t = +t) !== this._radius && (this._radius = t, this._circle = null), this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._string.push("Z"), this._point = NaN;
  },
  point: function(t, e) {
    switch (this._point) {
      case 0: {
        this._string.push("M", t, ",", e), this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", t, ",", e);
        break;
      }
      default: {
        this._circle == null && (this._circle = iOe(this._radius)), this._string.push("M", t, ",", e, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var t = this._string.join("");
      return this._string = [], t;
    } else
      return null;
  }
};
function iOe(t) {
  return "m0," + t + "a" + t + "," + t + " 0 1,1 0," + -2 * t + "a" + t + "," + t + " 0 1,1 0," + 2 * t + "z";
}
function vit(t, e) {
  var n = 4.5, r, i;
  function o(s) {
    return s && (typeof n == "function" && i.pointRadius(+n.apply(this, arguments)), iI(s, r(i))), i.result();
  }
  return o.area = function(s) {
    return iI(s, r(ZMe)), ZMe.result();
  }, o.measure = function(s) {
    return iI(s, r(rOe)), rOe.result();
  }, o.bounds = function(s) {
    return iI(s, r(c6)), c6.result();
  }, o.centroid = function(s) {
    return iI(s, r(nOe)), nOe.result();
  }, o.projection = function(s) {
    return arguments.length ? (r = s == null ? (t = null, wN) : (t = s).stream, o) : t;
  }, o.context = function(s) {
    return arguments.length ? (i = s == null ? (e = null, new yit()) : new Iit(e = s), typeof n != "function" && i.pointRadius(n), o) : e;
  }, o.pointRadius = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : (i.pointRadius(+s), +s), o) : n;
  }, o.projection(t).context(e);
}
function Vj(t) {
  return function(e) {
    var n = new qie();
    for (var r in t)
      n[r] = t[r];
    return n.stream = e, n;
  };
}
function qie() {
}
qie.prototype = {
  constructor: qie,
  point: function(t, e) {
    this.stream.point(t, e);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function Yde(t, e, n) {
  var r = t.clipExtent && t.clipExtent();
  return t.scale(150).translate([0, 0]), r != null && t.clipExtent(null), iI(n, t.stream(c6)), e(c6.result()), r != null && t.clipExtent(r), t;
}
function Jj(t, e, n) {
  return Yde(t, function(r) {
    var i = e[1][0] - e[0][0], o = e[1][1] - e[0][1], s = Math.min(i / (r[1][0] - r[0][0]), o / (r[1][1] - r[0][1])), a = +e[0][0] + (i - s * (r[1][0] + r[0][0])) / 2, A = +e[0][1] + (o - s * (r[1][1] + r[0][1])) / 2;
    t.scale(150 * s).translate([a, A]);
  }, n);
}
function zde(t, e, n) {
  return Jj(t, [[0, 0], e], n);
}
function Vde(t, e, n) {
  return Yde(t, function(r) {
    var i = +e, o = i / (r[1][0] - r[0][0]), s = (i - o * (r[1][0] + r[0][0])) / 2, a = -o * r[0][1];
    t.scale(150 * o).translate([s, a]);
  }, n);
}
function Jde(t, e, n) {
  return Yde(t, function(r) {
    var i = +e, o = i / (r[1][1] - r[0][1]), s = -o * r[0][0], a = (i - o * (r[1][1] + r[0][1])) / 2;
    t.scale(150 * o).translate([s, a]);
  }, n);
}
var oOe = 16, Efr = Er(30 * fi);
function sOe(t, e) {
  return +e ? vfr(t, e) : yfr(t);
}
function yfr(t) {
  return Vj({
    point: function(e, n) {
      e = t(e, n), this.stream.point(e[0], e[1]);
    }
  });
}
function vfr(t, e) {
  function n(r, i, o, s, a, A, l, c, u, f, h, d, I, m) {
    var C = l - r, y = c - i, v = C * C + y * y;
    if (v > 4 * e && I--) {
      var b = s + f, Q = a + h, w = A + d, R = Xc(b * b + Q * Q + w * w), M = Hu(w /= R), O = Ti(Ti(w) - 1) < hr || Ti(o - u) < hr ? (o + u) / 2 : zg(Q, b), L = t(O, M), N = L[0], k = L[1], $ = N - r, U = k - i, X = y * $ - C * U;
      (X * X / v > e || Ti((C * $ + y * U) / v - 0.5) > 0.3 || s * f + a * h + A * d < Efr) && (n(r, i, o, s, a, A, N, k, O, b /= R, Q /= R, w, I, m), m.point(N, k), n(N, k, O, b, Q, w, l, c, u, f, h, d, I, m));
    }
  }
  return function(r) {
    var i, o, s, a, A, l, c, u, f, h, d, I, m = {
      point: C,
      lineStart: y,
      lineEnd: b,
      polygonStart: function() {
        r.polygonStart(), m.lineStart = Q;
      },
      polygonEnd: function() {
        r.polygonEnd(), m.lineStart = y;
      }
    };
    function C(M, O) {
      M = t(M, O), r.point(M[0], M[1]);
    }
    function y() {
      u = NaN, m.point = v, r.lineStart();
    }
    function v(M, O) {
      var L = vB([M, O]), N = t(M, O);
      n(u, f, c, h, d, I, u = N[0], f = N[1], c = M, h = L[0], d = L[1], I = L[2], oOe, r), r.point(u, f);
    }
    function b() {
      m.point = C, r.lineEnd();
    }
    function Q() {
      y(), m.point = w, m.lineEnd = R;
    }
    function w(M, O) {
      v(i = M, O), o = u, s = f, a = h, A = d, l = I, m.point = v;
    }
    function R() {
      n(u, f, c, h, d, I, o, s, i, a, A, l, oOe, r), m.lineEnd = b, b();
    }
    return m;
  };
}
var Bfr = Vj({
  point: function(t, e) {
    this.stream.point(t * fi, e * fi);
  }
});
function bfr(t) {
  return Vj({
    point: function(e, n) {
      var r = t(e, n);
      return this.stream.point(r[0], r[1]);
    }
  });
}
function _fr(t, e, n, r, i) {
  function o(s, a) {
    return s *= r, a *= i, [e + t * s, n - t * a];
  }
  return o.invert = function(s, a) {
    return [(s - e) / t * r, (n - a) / t * i];
  }, o;
}
function aOe(t, e, n, r, i, o) {
  if (!o)
    return _fr(t, e, n, r, i);
  var s = Er(o), a = ir(o), A = s * t, l = a * t, c = s / t, u = a / t, f = (a * n - s * e) / t, h = (a * e + s * n) / t;
  function d(I, m) {
    return I *= r, m *= i, [A * I - l * m + e, n - l * I - A * m];
  }
  return d.invert = function(I, m) {
    return [r * (c * I - u * m + f), i * (h - u * I - c * m)];
  }, d;
}
function I0(t) {
  return Bit(function() {
    return t;
  })();
}
function Bit(t) {
  var e, n = 150, r = 480, i = 250, o = 0, s = 0, a = 0, A = 0, l = 0, c, u = 0, f = 1, h = 1, d = null, I = KMe, m = null, C, y, v, b = wN, Q = 0.5, w, R, M, O, L;
  function N(X) {
    return M(X[0] * fi, X[1] * fi);
  }
  function k(X) {
    return X = M.invert(X[0], X[1]), X && [X[0] * wa, X[1] * wa];
  }
  N.stream = function(X) {
    return O && L === X ? O : O = Bfr(bfr(c)(I(w(b(L = X)))));
  }, N.preclip = function(X) {
    return arguments.length ? (I = X, d = void 0, U()) : I;
  }, N.postclip = function(X) {
    return arguments.length ? (b = X, m = C = y = v = null, U()) : b;
  }, N.clipAngle = function(X) {
    return arguments.length ? (I = +X ? sfr(d = X * fi) : (d = null, KMe), U()) : d * wa;
  }, N.clipExtent = function(X) {
    return arguments.length ? (b = X == null ? (m = C = y = v = null, wN) : cit(m = +X[0][0], C = +X[0][1], y = +X[1][0], v = +X[1][1]), U()) : m == null ? null : [[m, C], [y, v]];
  }, N.scale = function(X) {
    return arguments.length ? (n = +X, $()) : n;
  }, N.translate = function(X) {
    return arguments.length ? (r = +X[0], i = +X[1], $()) : [r, i];
  }, N.center = function(X) {
    return arguments.length ? (o = X[0] % 360 * fi, s = X[1] % 360 * fi, $()) : [o * wa, s * wa];
  }, N.rotate = function(X) {
    return arguments.length ? (a = X[0] % 360 * fi, A = X[1] % 360 * fi, l = X.length > 2 ? X[2] % 360 * fi : 0, $()) : [a * wa, A * wa, l * wa];
  }, N.angle = function(X) {
    return arguments.length ? (u = X % 360 * fi, $()) : u * wa;
  }, N.reflectX = function(X) {
    return arguments.length ? (f = X ? -1 : 1, $()) : f < 0;
  }, N.reflectY = function(X) {
    return arguments.length ? (h = X ? -1 : 1, $()) : h < 0;
  }, N.precision = function(X) {
    return arguments.length ? (w = sOe(R, Q = X * X), U()) : Xc(Q);
  }, N.fitExtent = function(X, K) {
    return Jj(N, X, K);
  }, N.fitSize = function(X, K) {
    return zde(N, X, K);
  }, N.fitWidth = function(X, K) {
    return Vde(N, X, K);
  }, N.fitHeight = function(X, K) {
    return Jde(N, X, K);
  };
  function $() {
    var X = aOe(n, 0, 0, f, h, u).apply(null, e(o, s)), K = aOe(n, r - X[0], i - X[1], f, h, u);
    return c = sit(a, A, l), R = Lie(e, K), M = Lie(c, R), w = sOe(R, Q), U();
  }
  function U() {
    return O = L = null, N;
  }
  return function() {
    return e = t.apply(this, arguments), N.invert = e.invert && k, $();
  };
}
function Kde(t) {
  var e = 0, n = ui / 3, r = Bit(t), i = r(e, n);
  return i.parallels = function(o) {
    return arguments.length ? r(e = o[0] * fi, n = o[1] * fi) : [e * wa, n * wa];
  }, i;
}
function Sfr(t) {
  var e = Er(t);
  function n(r, i) {
    return [r * e, ir(i) / e];
  }
  return n.invert = function(r, i) {
    return [r / e, Hu(i * e)];
  }, n;
}
function Qfr(t, e) {
  var n = ir(t), r = (n + ir(e)) / 2;
  if (Ti(r) < hr)
    return Sfr(t);
  var i = 1 + n * (2 * r - n), o = Xc(i) / r;
  function s(a, A) {
    var l = Xc(i - 2 * r * ir(A)) / r;
    return [l * ir(a *= r), o - l * Er(a)];
  }
  return s.invert = function(a, A) {
    var l = o - A, c = zg(a, Ti(l)) * wg(l);
    return l * r < 0 && (c -= ui * wg(a) * wg(l)), [c / r, Hu((i - (a * a + l * l) * r * r) / (2 * r))];
  }, s;
}
function h6() {
  return Kde(Qfr).scale(155.424).center([0, 33.6442]);
}
function bit() {
  return h6().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function wfr(t) {
  var e = t.length;
  return {
    point: function(n, r) {
      for (var i = -1; ++i < e; )
        t[i].point(n, r);
    },
    sphere: function() {
      for (var n = -1; ++n < e; )
        t[n].sphere();
    },
    lineStart: function() {
      for (var n = -1; ++n < e; )
        t[n].lineStart();
    },
    lineEnd: function() {
      for (var n = -1; ++n < e; )
        t[n].lineEnd();
    },
    polygonStart: function() {
      for (var n = -1; ++n < e; )
        t[n].polygonStart();
    },
    polygonEnd: function() {
      for (var n = -1; ++n < e; )
        t[n].polygonEnd();
    }
  };
}
function xfr() {
  var t, e, n = bit(), r, i = h6().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), o, s = h6().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), a, A, l = { point: function(f, h) {
    A = [f, h];
  } };
  function c(f) {
    var h = f[0], d = f[1];
    return A = null, r.point(h, d), A || (o.point(h, d), A) || (a.point(h, d), A);
  }
  c.invert = function(f) {
    var h = n.scale(), d = n.translate(), I = (f[0] - d[0]) / h, m = (f[1] - d[1]) / h;
    return (m >= 0.12 && m < 0.234 && I >= -0.425 && I < -0.214 ? i : m >= 0.166 && m < 0.234 && I >= -0.214 && I < -0.115 ? s : n).invert(f);
  }, c.stream = function(f) {
    return t && e === f ? t : t = wfr([n.stream(e = f), i.stream(f), s.stream(f)]);
  }, c.precision = function(f) {
    return arguments.length ? (n.precision(f), i.precision(f), s.precision(f), u()) : n.precision();
  }, c.scale = function(f) {
    return arguments.length ? (n.scale(f), i.scale(f * 0.35), s.scale(f), c.translate(n.translate())) : n.scale();
  }, c.translate = function(f) {
    if (!arguments.length)
      return n.translate();
    var h = n.scale(), d = +f[0], I = +f[1];
    return r = n.translate(f).clipExtent([[d - 0.455 * h, I - 0.238 * h], [d + 0.455 * h, I + 0.238 * h]]).stream(l), o = i.translate([d - 0.307 * h, I + 0.201 * h]).clipExtent([[d - 0.425 * h + hr, I + 0.12 * h + hr], [d - 0.214 * h - hr, I + 0.234 * h - hr]]).stream(l), a = s.translate([d - 0.205 * h, I + 0.212 * h]).clipExtent([[d - 0.214 * h + hr, I + 0.166 * h + hr], [d - 0.115 * h - hr, I + 0.234 * h - hr]]).stream(l), u();
  }, c.fitExtent = function(f, h) {
    return Jj(c, f, h);
  }, c.fitSize = function(f, h) {
    return zde(c, f, h);
  }, c.fitWidth = function(f, h) {
    return Vde(c, f, h);
  }, c.fitHeight = function(f, h) {
    return Jde(c, f, h);
  };
  function u() {
    return t = e = null, c;
  }
  return c.scale(1070);
}
function _it(t) {
  return function(e, n) {
    var r = Er(e), i = Er(n), o = t(r * i);
    return o === 1 / 0 ? [2, 0] : [
      o * i * ir(e),
      o * ir(n)
    ];
  };
}
function BO(t) {
  return function(e, n) {
    var r = Xc(e * e + n * n), i = t(r), o = ir(i), s = Er(i);
    return [
      zg(e * o, r * s),
      Hu(r && n * o / r)
    ];
  };
}
var Sit = _it(function(t) {
  return Xc(2 / (1 + t));
});
Sit.invert = BO(function(t) {
  return 2 * Hu(t / 2);
});
function Rfr() {
  return I0(Sit).scale(124.75).clipAngle(180 - 1e-3);
}
var Qit = _it(function(t) {
  return (t = Jrt(t)) && t / ir(t);
});
Qit.invert = BO(function(t) {
  return t;
});
function Dfr() {
  return I0(Qit).scale(79.4188).clipAngle(180 - 1e-3);
}
function Kj(t, e) {
  return [t, J5(qde((ha + e) / 2))];
}
Kj.invert = function(t, e) {
  return [t, 2 * Bx(Vrt(e)) - ha];
};
function Tfr() {
  return wit(Kj).scale(961 / Wc);
}
function wit(t) {
  var e = I0(t), n = e.center, r = e.scale, i = e.translate, o = e.clipExtent, s = null, a, A, l;
  e.scale = function(u) {
    return arguments.length ? (r(u), c()) : r();
  }, e.translate = function(u) {
    return arguments.length ? (i(u), c()) : i();
  }, e.center = function(u) {
    return arguments.length ? (n(u), c()) : n();
  }, e.clipExtent = function(u) {
    return arguments.length ? (u == null ? s = a = A = l = null : (s = +u[0][0], a = +u[0][1], A = +u[1][0], l = +u[1][1]), c()) : s == null ? null : [[s, a], [A, l]];
  };
  function c() {
    var u = ui * r(), f = e(Xur(e.rotate()).invert([0, 0]));
    return o(s == null ? [[f[0] - u, f[1] - u], [f[0] + u, f[1] + u]] : t === Kj ? [[Math.max(f[0] - u, s), a], [Math.min(f[0] + u, A), l]] : [[s, Math.max(f[1] - u, a)], [A, Math.min(f[1] + u, l)]]);
  }
  return c();
}
function D3(t) {
  return qde((ha + t) / 2);
}
function Nfr(t, e) {
  var n = Er(t), r = t === e ? ir(t) : J5(n / Er(e)) / J5(D3(e) / D3(t)), i = n * RW(D3(t), r) / r;
  if (!r)
    return Kj;
  function o(s, a) {
    i > 0 ? a < -ha + hr && (a = -ha + hr) : a > ha - hr && (a = ha - hr);
    var A = i / RW(D3(a), r);
    return [A * ir(r * s), i - A * Er(r * s)];
  }
  return o.invert = function(s, a) {
    var A = i - a, l = wg(r) * Xc(s * s + A * A), c = zg(s, Ti(A)) * wg(A);
    return A * r < 0 && (c -= ui * wg(s) * wg(A)), [c / r, 2 * Bx(RW(i / l, 1 / r)) - ha];
  }, o;
}
function Lfr() {
  return Kde(Nfr).scale(109.5).parallels([30, 30]);
}
function d6(t, e) {
  return [t, e];
}
d6.invert = d6;
function Mfr() {
  return I0(d6).scale(152.63);
}
function Ofr(t, e) {
  var n = Er(t), r = t === e ? ir(t) : (n - Er(e)) / (e - t), i = n / r + t;
  if (Ti(r) < hr)
    return d6;
  function o(s, a) {
    var A = i - a, l = r * s;
    return [A * ir(l), i - A * Er(l)];
  }
  return o.invert = function(s, a) {
    var A = i - a, l = zg(s, Ti(A)) * wg(A);
    return A * r < 0 && (l -= ui * wg(s) * wg(A)), [l / r, i - wg(r) * Xc(s * s + A * A)];
  }, o;
}
function Ffr() {
  return Kde(Ofr).scale(131.154).center([0, 13.9389]);
}
var qD = 1.340264, jD = -0.081106, YD = 893e-6, zD = 3796e-6, p6 = Xc(3) / 2, Pfr = 12;
function xit(t, e) {
  var n = Hu(p6 * ir(e)), r = n * n, i = r * r * r;
  return [
    t * Er(n) / (p6 * (qD + 3 * jD * r + i * (7 * YD + 9 * zD * r))),
    n * (qD + jD * r + i * (YD + zD * r))
  ];
}
xit.invert = function(t, e) {
  for (var n = e, r = n * n, i = r * r * r, o = 0, s, a, A; o < Pfr && (a = n * (qD + jD * r + i * (YD + zD * r)) - e, A = qD + 3 * jD * r + i * (7 * YD + 9 * zD * r), n -= s = a / A, r = n * n, i = r * r * r, !(Ti(s) < z5)); ++o)
    ;
  return [
    p6 * t * (qD + 3 * jD * r + i * (7 * YD + 9 * zD * r)) / Er(n),
    Hu(ir(n) / p6)
  ];
};
function kfr() {
  return I0(xit).scale(177.158);
}
function Rit(t, e) {
  var n = Er(e), r = Er(t) * n;
  return [n * ir(t) / r, ir(e) / r];
}
Rit.invert = BO(Bx);
function Gfr() {
  return I0(Rit).scale(144.049).clipAngle(60);
}
function Ufr() {
  var t = 1, e = 0, n = 0, r = 1, i = 1, o = 0, s, a, A = null, l, c, u, f = 1, h = 1, d = Vj({
    point: function(b, Q) {
      var w = v([b, Q]);
      this.stream.point(w[0], w[1]);
    }
  }), I = wN, m, C;
  function y() {
    return f = t * r, h = t * i, m = C = null, v;
  }
  function v(b) {
    var Q = b[0] * f, w = b[1] * h;
    if (o) {
      var R = w * s - Q * a;
      Q = Q * s + w * a, w = R;
    }
    return [Q + e, w + n];
  }
  return v.invert = function(b) {
    var Q = b[0] - e, w = b[1] - n;
    if (o) {
      var R = w * s + Q * a;
      Q = Q * s - w * a, w = R;
    }
    return [Q / f, w / h];
  }, v.stream = function(b) {
    return m && C === b ? m : m = d(I(C = b));
  }, v.postclip = function(b) {
    return arguments.length ? (I = b, A = l = c = u = null, y()) : I;
  }, v.clipExtent = function(b) {
    return arguments.length ? (I = b == null ? (A = l = c = u = null, wN) : cit(A = +b[0][0], l = +b[0][1], c = +b[1][0], u = +b[1][1]), y()) : A == null ? null : [[A, l], [c, u]];
  }, v.scale = function(b) {
    return arguments.length ? (t = +b, y()) : t;
  }, v.translate = function(b) {
    return arguments.length ? (e = +b[0], n = +b[1], y()) : [e, n];
  }, v.angle = function(b) {
    return arguments.length ? (o = b % 360 * fi, a = ir(o), s = Er(o), y()) : o * wa;
  }, v.reflectX = function(b) {
    return arguments.length ? (r = b ? -1 : 1, y()) : r < 0;
  }, v.reflectY = function(b) {
    return arguments.length ? (i = b ? -1 : 1, y()) : i < 0;
  }, v.fitExtent = function(b, Q) {
    return Jj(v, b, Q);
  }, v.fitSize = function(b, Q) {
    return zde(v, b, Q);
  }, v.fitWidth = function(b, Q) {
    return Vde(v, b, Q);
  }, v.fitHeight = function(b, Q) {
    return Jde(v, b, Q);
  }, v;
}
function Dit(t, e) {
  var n = e * e, r = n * n;
  return [
    t * (0.8707 - 0.131979 * n + r * (-0.013791 + r * (3971e-6 * n - 1529e-6 * r))),
    e * (1.007226 + n * (0.015085 + r * (-0.044475 + 0.028874 * n - 5916e-6 * r)))
  ];
}
Dit.invert = function(t, e) {
  var n = e, r = 25, i;
  do {
    var o = n * n, s = o * o;
    n -= i = (n * (1.007226 + o * (0.015085 + s * (-0.044475 + 0.028874 * o - 5916e-6 * s))) - e) / (1.007226 + o * (0.015085 * 3 + s * (-0.044475 * 7 + 0.028874 * 9 * o - 5916e-6 * 11 * s)));
  } while (Ti(i) > hr && --r > 0);
  return [
    t / (0.8707 + (o = n * n) * (-0.131979 + o * (-0.013791 + o * o * o * (3971e-6 - 1529e-6 * o)))),
    n
  ];
};
function Hfr() {
  return I0(Dit).scale(175.295);
}
function Tit(t, e) {
  return [Er(e) * ir(t), ir(e)];
}
Tit.invert = BO(Hu);
function $fr() {
  return I0(Tit).scale(249.5).clipAngle(90 + hr);
}
function Nit(t, e) {
  var n = Er(e), r = 1 + Er(t) * n;
  return [n * ir(t) / r, ir(e) / r];
}
Nit.invert = BO(function(t) {
  return 2 * Bx(t);
});
function qfr() {
  return I0(Nit).scale(250).clipAngle(142);
}
function Lit(t, e) {
  return [J5(qde((ha + e) / 2)), -t];
}
Lit.invert = function(t, e) {
  return [-e, 2 * Bx(Vrt(t)) - ha];
};
function jfr() {
  var t = wit(Lit), e = t.center, n = t.rotate;
  return t.center = function(r) {
    return arguments.length ? e([-r[1], r[0]]) : (r = e(), [r[1], -r[0]]);
  }, t.rotate = function(r) {
    return arguments.length ? n([r[0], r[1], r.length > 2 ? r[2] + 90 : 90]) : (r = n(), [r[0], r[1], r[2] - 90]);
  }, n([0, 0, 90]).scale(159.155);
}
var Yfr = Math.abs, jie = Math.cos, I6 = Math.sin, zfr = 1e-6, Mit = Math.PI, Yie = Mit / 2, AOe = Vfr(2);
function lOe(t) {
  return t > 1 ? Yie : t < -1 ? -Yie : Math.asin(t);
}
function Vfr(t) {
  return t > 0 ? Math.sqrt(t) : 0;
}
function Jfr(t, e) {
  var n = t * I6(e), r = 30, i;
  do
    e -= i = (e + I6(e) - n) / (1 + jie(e));
  while (Yfr(i) > zfr && --r > 0);
  return e / 2;
}
function Kfr(t, e, n) {
  function r(i, o) {
    return [t * i * jie(o = Jfr(n, o)), e * I6(o)];
  }
  return r.invert = function(i, o) {
    return o = lOe(o / e), [i / (t * jie(o)), lOe((2 * o + I6(2 * o)) / n)];
  }, r;
}
var Wfr = Kfr(AOe / Yie, AOe, Mit);
function Xfr() {
  return I0(Wfr).scale(169.529);
}
const Zfr = vit(), zie = [
  // standard properties in d3-geo
  "clipAngle",
  "clipExtent",
  "scale",
  "translate",
  "center",
  "rotate",
  "parallels",
  "precision",
  "reflectX",
  "reflectY",
  // extended properties in d3-geo-projections
  "coefficient",
  "distance",
  "fraction",
  "lobes",
  "parallel",
  "radius",
  "ratio",
  "spacing",
  "tilt"
];
function egr(t, e) {
  return function n() {
    const r = e();
    return r.type = t, r.path = vit().projection(r), r.copy = r.copy || function() {
      const i = n();
      return zie.forEach((o) => {
        r[o] && i[o](r[o]());
      }), i.path.pointRadius(r.path.pointRadius()), i;
    }, r;
  };
}
function Wde(t, e) {
  if (!t || typeof t != "string")
    throw new Error("Projection type must be a name string.");
  return t = t.toLowerCase(), arguments.length > 1 ? (m6[t] = egr(t, e), this) : m6[t] || null;
}
function Oit(t) {
  return t && t.path || Zfr;
}
const m6 = {
  // base d3-geo projection types
  albers: bit,
  albersusa: xfr,
  azimuthalequalarea: Rfr,
  azimuthalequidistant: Dfr,
  conicconformal: Lfr,
  conicequalarea: h6,
  conicequidistant: Ffr,
  equalEarth: kfr,
  equirectangular: Mfr,
  gnomonic: Gfr,
  identity: Ufr,
  mercator: Tfr,
  mollweide: Xfr,
  naturalEarth1: Hfr,
  orthographic: $fr,
  stereographic: qfr,
  transversemercator: jfr
};
for (const t in m6)
  Wde(t, m6[t]);
function tgr() {
}
const k0 = [[], [[[1, 1.5], [0.5, 1]]], [[[1.5, 1], [1, 1.5]]], [[[1.5, 1], [0.5, 1]]], [[[1, 0.5], [1.5, 1]]], [[[1, 1.5], [0.5, 1]], [[1, 0.5], [1.5, 1]]], [[[1, 0.5], [1, 1.5]]], [[[1, 0.5], [0.5, 1]]], [[[0.5, 1], [1, 0.5]]], [[[1, 1.5], [1, 0.5]]], [[[0.5, 1], [1, 0.5]], [[1.5, 1], [1, 1.5]]], [[[1.5, 1], [1, 0.5]]], [[[0.5, 1], [1.5, 1]]], [[[1, 1.5], [1.5, 1]]], [[[0.5, 1], [1, 1.5]]], []];
function Fit() {
  var t = 1, e = 1, n = a;
  function r(A, l) {
    return l.map((c) => i(A, c));
  }
  function i(A, l) {
    var c = [], u = [];
    return o(A, l, (f) => {
      n(f, A, l), ngr(f) > 0 ? c.push([f]) : u.push(f);
    }), u.forEach((f) => {
      for (var h = 0, d = c.length, I; h < d; ++h)
        if (rgr((I = c[h])[0], f) !== -1) {
          I.push(f);
          return;
        }
    }), {
      type: "MultiPolygon",
      value: l,
      coordinates: c
    };
  }
  function o(A, l, c) {
    var u = new Array(), f = new Array(), h, d, I, m, C, y;
    for (h = d = -1, m = A[0] >= l, k0[m << 1].forEach(v); ++h < t - 1; )
      I = m, m = A[h + 1] >= l, k0[I | m << 1].forEach(v);
    for (k0[m << 0].forEach(v); ++d < e - 1; ) {
      for (h = -1, m = A[d * t + t] >= l, C = A[d * t] >= l, k0[m << 1 | C << 2].forEach(v); ++h < t - 1; )
        I = m, m = A[d * t + t + h + 1] >= l, y = C, C = A[d * t + h + 1] >= l, k0[I | m << 1 | C << 2 | y << 3].forEach(v);
      k0[m | C << 3].forEach(v);
    }
    for (h = -1, C = A[d * t] >= l, k0[C << 2].forEach(v); ++h < t - 1; )
      y = C, C = A[d * t + h + 1] >= l, k0[C << 2 | y << 3].forEach(v);
    k0[C << 3].forEach(v);
    function v(b) {
      var Q = [b[0][0] + h, b[0][1] + d], w = [b[1][0] + h, b[1][1] + d], R = s(Q), M = s(w), O, L;
      (O = f[R]) ? (L = u[M]) ? (delete f[O.end], delete u[L.start], O === L ? (O.ring.push(w), c(O.ring)) : u[O.start] = f[L.end] = {
        start: O.start,
        end: L.end,
        ring: O.ring.concat(L.ring)
      }) : (delete f[O.end], O.ring.push(w), f[O.end = M] = O) : (O = u[M]) ? (L = f[R]) ? (delete u[O.start], delete f[L.end], O === L ? (O.ring.push(w), c(O.ring)) : u[L.start] = f[O.end] = {
        start: L.start,
        end: O.end,
        ring: L.ring.concat(O.ring)
      }) : (delete u[O.start], O.ring.unshift(Q), u[O.start = R] = O) : u[R] = f[M] = {
        start: R,
        end: M,
        ring: [Q, w]
      };
    }
  }
  function s(A) {
    return A[0] * 2 + A[1] * (t + 1) * 4;
  }
  function a(A, l, c) {
    A.forEach((u) => {
      var f = u[0], h = u[1], d = f | 0, I = h | 0, m, C = l[I * t + d];
      f > 0 && f < t && d === f && (m = l[I * t + d - 1], u[0] = f + (c - m) / (C - m) - 0.5), h > 0 && h < e && I === h && (m = l[(I - 1) * t + d], u[1] = h + (c - m) / (C - m) - 0.5);
    });
  }
  return r.contour = i, r.size = function(A) {
    if (!arguments.length)
      return [t, e];
    var l = Math.floor(A[0]), c = Math.floor(A[1]);
    return l >= 0 && c >= 0 || wt("invalid size"), t = l, e = c, r;
  }, r.smooth = function(A) {
    return arguments.length ? (n = A ? a : tgr, r) : n === a;
  }, r;
}
function ngr(t) {
  for (var e = 0, n = t.length, r = t[n - 1][1] * t[0][0] - t[n - 1][0] * t[0][1]; ++e < n; )
    r += t[e - 1][1] * t[e][0] - t[e - 1][0] * t[e][1];
  return r;
}
function rgr(t, e) {
  for (var n = -1, r = e.length, i; ++n < r; )
    if (i = igr(t, e[n]))
      return i;
  return 0;
}
function igr(t, e) {
  for (var n = e[0], r = e[1], i = -1, o = 0, s = t.length, a = s - 1; o < s; a = o++) {
    var A = t[o], l = A[0], c = A[1], u = t[a], f = u[0], h = u[1];
    if (ogr(A, u, e))
      return 0;
    c > r != h > r && n < (f - l) * (r - c) / (h - c) + l && (i = -i);
  }
  return i;
}
function ogr(t, e, n) {
  var r;
  return sgr(t, e, n) && agr(t[r = +(t[0] === e[0])], n[r], e[r]);
}
function sgr(t, e, n) {
  return (e[0] - t[0]) * (n[1] - t[1]) === (n[0] - t[0]) * (e[1] - t[1]);
}
function agr(t, e, n) {
  return t <= e && e <= n || n <= e && e <= t;
}
function Pit(t, e, n) {
  return function(r) {
    var i = Jp(r), o = n ? Math.min(i[0], 0) : i[0], s = i[1], a = s - o, A = e ? IN(o, s, t) : a / (t + 1);
    return E1(o + A, s, A);
  };
}
function Xde(t) {
  yt.call(this, null, t);
}
Xde.Definition = {
  type: "Isocontour",
  metadata: {
    generates: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "thresholds",
    type: "number",
    array: !0
  }, {
    name: "levels",
    type: "number"
  }, {
    name: "nice",
    type: "boolean",
    default: !1
  }, {
    name: "resolve",
    type: "enum",
    values: ["shared", "independent"],
    default: "independent"
  }, {
    name: "zero",
    type: "boolean",
    default: !0
  }, {
    name: "smooth",
    type: "boolean",
    default: !0
  }, {
    name: "scale",
    type: "number",
    expr: !0
  }, {
    name: "translate",
    type: "number",
    array: !0,
    expr: !0
  }, {
    name: "as",
    type: "string",
    null: !0,
    default: "contour"
  }]
};
on(Xde, yt, {
  transform(t, e) {
    if (this.value && !e.changed() && !t.modified())
      return e.StopPropagation;
    var n = e.fork(e.NO_SOURCE | e.NO_FIELDS), r = e.materialize(e.SOURCE).source, i = t.field || Ac, o = Fit().smooth(t.smooth !== !1), s = t.thresholds || Agr(r, i, t), a = t.as === null ? null : t.as || "contour", A = [];
    return r.forEach((l) => {
      const c = i(l), u = o.size([c.width, c.height])(c.values, Nt(s) ? s : s(c.values));
      lgr(u, c, l, t), u.forEach((f) => {
        A.push(dj(l, so(a != null ? {
          [a]: f
        } : f)));
      });
    }), this.value && (n.rem = this.value), this.value = n.source = n.add = A, n;
  }
});
function Agr(t, e, n) {
  const r = Pit(n.levels || 10, n.nice, n.zero !== !1);
  return n.resolve !== "shared" ? r : r(t.map((i) => Tv(e(i).values)));
}
function lgr(t, e, n, r) {
  let i = r.scale || e.scale, o = r.translate || e.translate;
  if (ri(i) && (i = i(n, r)), ri(o) && (o = o(n, r)), (i === 1 || i == null) && !o)
    return;
  const s = (Po(i) ? i : i[0]) || 1, a = (Po(i) ? i : i[1]) || 1, A = o && o[0] || 0, l = o && o[1] || 0;
  t.forEach(kit(e, s, a, A, l));
}
function kit(t, e, n, r, i) {
  const o = t.x1 || 0, s = t.y1 || 0, a = e * n < 0;
  function A(u) {
    u.forEach(l);
  }
  function l(u) {
    a && u.reverse(), u.forEach(c);
  }
  function c(u) {
    u[0] = (u[0] - o) * e + r, u[1] = (u[1] - s) * n + i;
  }
  return function(u) {
    return u.coordinates.forEach(A), u;
  };
}
function cOe(t, e, n) {
  const r = t >= 0 ? t : $ge(e, n);
  return Math.round((Math.sqrt(4 * r * r + 1) - 1) / 2);
}
function MW(t) {
  return ri(t) ? t : lc(+t);
}
function Git() {
  var t = (A) => A[0], e = (A) => A[1], n = ux, r = [-1, -1], i = 960, o = 500, s = 2;
  function a(A, l) {
    const c = cOe(r[0], A, t) >> s, u = cOe(r[1], A, e) >> s, f = c ? c + 2 : 0, h = u ? u + 2 : 0, d = 2 * f + (i >> s), I = 2 * h + (o >> s), m = new Float32Array(d * I), C = new Float32Array(d * I);
    let y = m;
    A.forEach((b) => {
      const Q = f + (+t(b) >> s), w = h + (+e(b) >> s);
      Q >= 0 && Q < d && w >= 0 && w < I && (m[Q + w * d] += +n(b));
    }), c > 0 && u > 0 ? (Tb(d, I, m, C, c), Nb(d, I, C, m, u), Tb(d, I, m, C, c), Nb(d, I, C, m, u), Tb(d, I, m, C, c), Nb(d, I, C, m, u)) : c > 0 ? (Tb(d, I, m, C, c), Tb(d, I, C, m, c), Tb(d, I, m, C, c), y = C) : u > 0 && (Nb(d, I, m, C, u), Nb(d, I, C, m, u), Nb(d, I, m, C, u), y = C);
    const v = l ? Math.pow(2, -2 * s) : 1 / nZe(y);
    for (let b = 0, Q = d * I; b < Q; ++b)
      y[b] *= v;
    return {
      values: y,
      scale: 1 << s,
      width: d,
      height: I,
      x1: f,
      y1: h,
      x2: f + (i >> s),
      y2: h + (o >> s)
    };
  }
  return a.x = function(A) {
    return arguments.length ? (t = MW(A), a) : t;
  }, a.y = function(A) {
    return arguments.length ? (e = MW(A), a) : e;
  }, a.weight = function(A) {
    return arguments.length ? (n = MW(A), a) : n;
  }, a.size = function(A) {
    if (!arguments.length)
      return [i, o];
    var l = +A[0], c = +A[1];
    return l >= 0 && c >= 0 || wt("invalid size"), i = l, o = c, a;
  }, a.cellSize = function(A) {
    return arguments.length ? ((A = +A) >= 1 || wt("invalid cell size"), s = Math.floor(Math.log(A) / Math.LN2), a) : 1 << s;
  }, a.bandwidth = function(A) {
    return arguments.length ? (A = bn(A), A.length === 1 && (A = [+A[0], +A[0]]), A.length !== 2 && wt("invalid bandwidth"), r = A, a) : r;
  }, a;
}
function Tb(t, e, n, r, i) {
  const o = (i << 1) + 1;
  for (let s = 0; s < e; ++s)
    for (let a = 0, A = 0; a < t + i; ++a)
      a < t && (A += n[a + s * t]), a >= i && (a >= o && (A -= n[a - o + s * t]), r[a - i + s * t] = A / Math.min(a + 1, t - 1 + o - a, o));
}
function Nb(t, e, n, r, i) {
  const o = (i << 1) + 1;
  for (let s = 0; s < t; ++s)
    for (let a = 0, A = 0; a < e + i; ++a)
      a < e && (A += n[s + a * t]), a >= i && (a >= o && (A -= n[s + (a - o) * t]), r[s + (a - i) * t] = A / Math.min(a + 1, e - 1 + o - a, o));
}
function Zde(t) {
  yt.call(this, null, t);
}
Zde.Definition = {
  type: "KDE2D",
  metadata: {
    generates: !0
  },
  params: [{
    name: "size",
    type: "number",
    array: !0,
    length: 2,
    required: !0
  }, {
    name: "x",
    type: "field",
    required: !0
  }, {
    name: "y",
    type: "field",
    required: !0
  }, {
    name: "weight",
    type: "field"
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "cellSize",
    type: "number"
  }, {
    name: "bandwidth",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "counts",
    type: "boolean",
    default: !1
  }, {
    name: "as",
    type: "string",
    default: "grid"
  }]
};
const cgr = ["x", "y", "weight", "size", "cellSize", "bandwidth"];
function Uit(t, e) {
  return cgr.forEach((n) => e[n] != null ? t[n](e[n]) : 0), t;
}
on(Zde, yt, {
  transform(t, e) {
    if (this.value && !e.changed() && !t.modified())
      return e.StopPropagation;
    var n = e.fork(e.NO_SOURCE | e.NO_FIELDS), r = e.materialize(e.SOURCE).source, i = ugr(r, t.groupby), o = (t.groupby || []).map(pa), s = Uit(Git(), t), a = t.as || "grid", A = [];
    function l(c, u) {
      for (let f = 0; f < o.length; ++f)
        c[o[f]] = u[f];
      return c;
    }
    return A = i.map((c) => so(l({
      [a]: s(c, t.counts)
    }, c.dims))), this.value && (n.rem = this.value), this.value = n.source = n.add = A, n;
  }
});
function ugr(t, e) {
  var n = [], r = (c) => c(a), i, o, s, a, A, l;
  if (e == null)
    n.push(t);
  else
    for (i = {}, o = 0, s = t.length; o < s; ++o)
      a = t[o], A = e.map(r), l = i[A], l || (i[A] = l = [], l.dims = A, n.push(l)), l.push(a);
  return n;
}
function epe(t) {
  yt.call(this, null, t);
}
epe.Definition = {
  type: "Contour",
  metadata: {
    generates: !0
  },
  params: [{
    name: "size",
    type: "number",
    array: !0,
    length: 2,
    required: !0
  }, {
    name: "values",
    type: "number",
    array: !0
  }, {
    name: "x",
    type: "field"
  }, {
    name: "y",
    type: "field"
  }, {
    name: "weight",
    type: "field"
  }, {
    name: "cellSize",
    type: "number"
  }, {
    name: "bandwidth",
    type: "number"
  }, {
    name: "count",
    type: "number"
  }, {
    name: "nice",
    type: "boolean",
    default: !1
  }, {
    name: "thresholds",
    type: "number",
    array: !0
  }, {
    name: "smooth",
    type: "boolean",
    default: !0
  }]
};
on(epe, yt, {
  transform(t, e) {
    if (this.value && !e.changed() && !t.modified())
      return e.StopPropagation;
    var n = e.fork(e.NO_SOURCE | e.NO_FIELDS), r = Fit().smooth(t.smooth !== !1), i = t.values, o = t.thresholds || Pit(t.count || 10, t.nice, !!i), s = t.size, a, A;
    return i || (i = e.materialize(e.SOURCE).source, a = Uit(Git(), t)(i, !0), A = kit(a, a.scale || 1, a.scale || 1, 0, 0), s = [a.width, a.height], i = a.values), o = Nt(o) ? o : o(i), i = r.size(s)(i, o), A && i.forEach(A), this.value && (n.rem = this.value), this.value = n.source = n.add = (i || []).map(so), n;
  }
});
const Vie = "Feature", tpe = "FeatureCollection", fgr = "MultiPoint";
function npe(t) {
  yt.call(this, null, t);
}
npe.Definition = {
  type: "GeoJSON",
  metadata: {},
  params: [{
    name: "fields",
    type: "field",
    array: !0,
    length: 2
  }, {
    name: "geojson",
    type: "field"
  }]
};
on(npe, yt, {
  transform(t, e) {
    var n = this._features, r = this._points, i = t.fields, o = i && i[0], s = i && i[1], a = t.geojson || !i && Ac, A = e.ADD, l;
    l = t.modified() || e.changed(e.REM) || e.modified(Zl(a)) || o && e.modified(Zl(o)) || s && e.modified(Zl(s)), (!this.value || l) && (A = e.SOURCE, this._features = n = [], this._points = r = []), a && e.visit(A, (c) => n.push(a(c))), o && s && (e.visit(A, (c) => {
      var u = o(c), f = s(c);
      u != null && f != null && (u = +u) === u && (f = +f) === f && r.push([u, f]);
    }), n = n.concat({
      type: Vie,
      geometry: {
        type: fgr,
        coordinates: r
      }
    })), this.value = {
      type: tpe,
      features: n
    };
  }
});
function rpe(t) {
  yt.call(this, null, t);
}
rpe.Definition = {
  type: "GeoPath",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "projection",
    type: "projection"
  }, {
    name: "field",
    type: "field"
  }, {
    name: "pointRadius",
    type: "number",
    expr: !0
  }, {
    name: "as",
    type: "string",
    default: "path"
  }]
};
on(rpe, yt, {
  transform(t, e) {
    var n = e.fork(e.ALL), r = this.value, i = t.field || Ac, o = t.as || "path", s = n.SOURCE;
    !r || t.modified() ? (this.value = r = Oit(t.projection), n.materialize().reflow()) : s = i === Ac || e.modified(i.fields) ? n.ADD_MOD : n.ADD;
    const a = ggr(r, t.pointRadius);
    return n.visit(s, (A) => A[o] = r(i(A))), r.pointRadius(a), n.modifies(o);
  }
});
function ggr(t, e) {
  const n = t.pointRadius();
  return t.context(null), e != null && t.pointRadius(e), n;
}
function ipe(t) {
  yt.call(this, null, t);
}
ipe.Definition = {
  type: "GeoPoint",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "projection",
    type: "projection",
    required: !0
  }, {
    name: "fields",
    type: "field",
    array: !0,
    required: !0,
    length: 2
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 2,
    default: ["x", "y"]
  }]
};
on(ipe, yt, {
  transform(t, e) {
    var n = t.projection, r = t.fields[0], i = t.fields[1], o = t.as || ["x", "y"], s = o[0], a = o[1], A;
    function l(c) {
      const u = n([r(c), i(c)]);
      u ? (c[s] = u[0], c[a] = u[1]) : (c[s] = void 0, c[a] = void 0);
    }
    return t.modified() ? e = e.materialize().reflow(!0).visit(e.SOURCE, l) : (A = e.modified(r.fields) || e.modified(i.fields), e.visit(A ? e.ADD_MOD : e.ADD, l)), e.modifies(o);
  }
});
function ope(t) {
  yt.call(this, null, t);
}
ope.Definition = {
  type: "GeoShape",
  metadata: {
    modifies: !0,
    nomod: !0
  },
  params: [{
    name: "projection",
    type: "projection"
  }, {
    name: "field",
    type: "field",
    default: "datum"
  }, {
    name: "pointRadius",
    type: "number",
    expr: !0
  }, {
    name: "as",
    type: "string",
    default: "shape"
  }]
};
on(ope, yt, {
  transform(t, e) {
    var n = e.fork(e.ALL), r = this.value, i = t.as || "shape", o = n.ADD;
    return (!r || t.modified()) && (this.value = r = hgr(Oit(t.projection), t.field || ku("datum"), t.pointRadius), n.materialize().reflow(), o = n.SOURCE), n.visit(o, (s) => s[i] = r), n.modifies(i);
  }
});
function hgr(t, e, n) {
  const r = n == null ? (i) => t(e(i)) : (i) => {
    var o = t.pointRadius(), s = t.pointRadius(n)(e(i));
    return t.pointRadius(o), s;
  };
  return r.context = (i) => (t.context(i), r), r;
}
function spe(t) {
  yt.call(this, [], t), this.generator = Afr();
}
spe.Definition = {
  type: "Graticule",
  metadata: {
    changes: !0,
    generates: !0
  },
  params: [{
    name: "extent",
    type: "array",
    array: !0,
    length: 2,
    content: {
      type: "number",
      array: !0,
      length: 2
    }
  }, {
    name: "extentMajor",
    type: "array",
    array: !0,
    length: 2,
    content: {
      type: "number",
      array: !0,
      length: 2
    }
  }, {
    name: "extentMinor",
    type: "array",
    array: !0,
    length: 2,
    content: {
      type: "number",
      array: !0,
      length: 2
    }
  }, {
    name: "step",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "stepMajor",
    type: "number",
    array: !0,
    length: 2,
    default: [90, 360]
  }, {
    name: "stepMinor",
    type: "number",
    array: !0,
    length: 2,
    default: [10, 10]
  }, {
    name: "precision",
    type: "number",
    default: 2.5
  }]
};
on(spe, yt, {
  transform(t, e) {
    var n = this.value, r = this.generator, i;
    if (!n.length || t.modified())
      for (const o in t)
        ri(r[o]) && r[o](t[o]);
    return i = r(), n.length ? e.mod.push(oet(n[0], i)) : e.add.push(so(i)), n[0] = i, e;
  }
});
function ape(t) {
  yt.call(this, null, t);
}
ape.Definition = {
  type: "heatmap",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "color",
    type: "string",
    expr: !0
  }, {
    name: "opacity",
    type: "number",
    expr: !0
  }, {
    name: "resolve",
    type: "enum",
    values: ["shared", "independent"],
    default: "independent"
  }, {
    name: "as",
    type: "string",
    default: "image"
  }]
};
on(ape, yt, {
  transform(t, e) {
    if (!e.changed() && !t.modified())
      return e.StopPropagation;
    var n = e.materialize(e.SOURCE).source, r = t.resolve === "shared", i = t.field || Ac, o = pgr(t.opacity, t), s = dgr(t.color, t), a = t.as || "image", A = {
      $x: 0,
      $y: 0,
      $value: 0,
      $max: r ? Tv(n.map((l) => Tv(i(l).values))) : 0
    };
    return n.forEach((l) => {
      const c = i(l), u = ni({}, l, A);
      r || (u.$max = Tv(c.values || [])), l[a] = Igr(c, u, s.dep ? s : lc(s(u)), o.dep ? o : lc(o(u)));
    }), e.reflow(!0).modifies(a);
  }
});
function dgr(t, e) {
  let n;
  return ri(t) ? (n = (r) => oE(t(r, e)), n.dep = Hit(t)) : n = lc(oE(t || "#888")), n;
}
function pgr(t, e) {
  let n;
  return ri(t) ? (n = (r) => t(r, e), n.dep = Hit(t)) : t ? n = lc(t) : (n = (r) => r.$value / r.$max || 0, n.dep = !0), n;
}
function Hit(t) {
  if (!ri(t))
    return !1;
  const e = pd(Zl(t));
  return e.$x || e.$y || e.$value || e.$max;
}
function Igr(t, e, n, r) {
  const i = t.width, o = t.height, s = t.x1 || 0, a = t.y1 || 0, A = t.x2 || i, l = t.y2 || o, c = t.values, u = c ? (m) => c[m] : nC, f = PC(A - s, l - a), h = f.getContext("2d"), d = h.getImageData(0, 0, A - s, l - a), I = d.data;
  for (let m = a, C = 0; m < l; ++m) {
    e.$y = m - a;
    for (let y = s, v = m * i; y < A; ++y, C += 4) {
      e.$x = y - s, e.$value = u(y + v);
      const b = n(e);
      I[C + 0] = b.r, I[C + 1] = b.g, I[C + 2] = b.b, I[C + 3] = ~~(255 * r(e));
    }
  }
  return h.putImageData(d, 0, 0), f;
}
function $it(t) {
  yt.call(this, null, t), this.modified(!0);
}
on($it, yt, {
  transform(t, e) {
    let n = this.value;
    return !n || t.modified("type") ? (this.value = n = Cgr(t.type), zie.forEach((r) => {
      t[r] != null && uOe(n, r, t[r]);
    })) : zie.forEach((r) => {
      t.modified(r) && uOe(n, r, t[r]);
    }), t.pointRadius != null && n.path.pointRadius(t.pointRadius), t.fit && mgr(n, t), e.fork(e.NO_SOURCE | e.NO_FIELDS);
  }
});
function mgr(t, e) {
  const n = Egr(e.fit);
  e.extent ? t.fitExtent(e.extent, n) : e.size && t.fitSize(e.size, n);
}
function Cgr(t) {
  const e = Wde((t || "mercator").toLowerCase());
  return e || wt("Unrecognized projection type: " + t), e();
}
function uOe(t, e, n) {
  ri(t[e]) && t[e](n);
}
function Egr(t) {
  return t = bn(t), t.length === 1 ? t[0] : {
    type: tpe,
    features: t.reduce((e, n) => e.concat(ygr(n)), [])
  };
}
function ygr(t) {
  return t.type === tpe ? t.features : bn(t).filter((e) => e != null).map((e) => e.type === Vie ? e : {
    type: Vie,
    geometry: e
  });
}
const vgr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  contour: epe,
  geojson: npe,
  geopath: rpe,
  geopoint: ipe,
  geoshape: ope,
  graticule: spe,
  heatmap: ape,
  isocontour: Xde,
  kde2d: Zde,
  projection: $it
}, Symbol.toStringTag, { value: "Module" }));
function Bgr(t, e) {
  var n, r = 1;
  t == null && (t = 0), e == null && (e = 0);
  function i() {
    var o, s = n.length, a, A = 0, l = 0;
    for (o = 0; o < s; ++o)
      a = n[o], A += a.x, l += a.y;
    for (A = (A / s - t) * r, l = (l / s - e) * r, o = 0; o < s; ++o)
      a = n[o], a.x -= A, a.y -= l;
  }
  return i.initialize = function(o) {
    n = o;
  }, i.x = function(o) {
    return arguments.length ? (t = +o, i) : t;
  }, i.y = function(o) {
    return arguments.length ? (e = +o, i) : e;
  }, i.strength = function(o) {
    return arguments.length ? (r = +o, i) : r;
  }, i;
}
function bgr(t) {
  const e = +this._x.call(null, t), n = +this._y.call(null, t);
  return qit(this.cover(e, n), e, n, t);
}
function qit(t, e, n, r) {
  if (isNaN(e) || isNaN(n))
    return t;
  var i, o = t._root, s = { data: r }, a = t._x0, A = t._y0, l = t._x1, c = t._y1, u, f, h, d, I, m, C, y;
  if (!o)
    return t._root = s, t;
  for (; o.length; )
    if ((I = e >= (u = (a + l) / 2)) ? a = u : l = u, (m = n >= (f = (A + c) / 2)) ? A = f : c = f, i = o, !(o = o[C = m << 1 | I]))
      return i[C] = s, t;
  if (h = +t._x.call(null, o.data), d = +t._y.call(null, o.data), e === h && n === d)
    return s.next = o, i ? i[C] = s : t._root = s, t;
  do
    i = i ? i[C] = new Array(4) : t._root = new Array(4), (I = e >= (u = (a + l) / 2)) ? a = u : l = u, (m = n >= (f = (A + c) / 2)) ? A = f : c = f;
  while ((C = m << 1 | I) === (y = (d >= f) << 1 | h >= u));
  return i[y] = o, i[C] = s, t;
}
function _gr(t) {
  var e, n, r = t.length, i, o, s = new Array(r), a = new Array(r), A = 1 / 0, l = 1 / 0, c = -1 / 0, u = -1 / 0;
  for (n = 0; n < r; ++n)
    isNaN(i = +this._x.call(null, e = t[n])) || isNaN(o = +this._y.call(null, e)) || (s[n] = i, a[n] = o, i < A && (A = i), i > c && (c = i), o < l && (l = o), o > u && (u = o));
  if (A > c || l > u)
    return this;
  for (this.cover(A, l).cover(c, u), n = 0; n < r; ++n)
    qit(this, s[n], a[n], t[n]);
  return this;
}
function Sgr(t, e) {
  if (isNaN(t = +t) || isNaN(e = +e))
    return this;
  var n = this._x0, r = this._y0, i = this._x1, o = this._y1;
  if (isNaN(n))
    i = (n = Math.floor(t)) + 1, o = (r = Math.floor(e)) + 1;
  else {
    for (var s = i - n || 1, a = this._root, A, l; n > t || t >= i || r > e || e >= o; )
      switch (l = (e < r) << 1 | t < n, A = new Array(4), A[l] = a, a = A, s *= 2, l) {
        case 0:
          i = n + s, o = r + s;
          break;
        case 1:
          n = i - s, o = r + s;
          break;
        case 2:
          i = n + s, r = o - s;
          break;
        case 3:
          n = i - s, r = o - s;
          break;
      }
    this._root && this._root.length && (this._root = a);
  }
  return this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = o, this;
}
function Qgr() {
  var t = [];
  return this.visit(function(e) {
    if (!e.length)
      do
        t.push(e.data);
      while (e = e.next);
  }), t;
}
function wgr(t) {
  return arguments.length ? this.cover(+t[0][0], +t[0][1]).cover(+t[1][0], +t[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function Uc(t, e, n, r, i) {
  this.node = t, this.x0 = e, this.y0 = n, this.x1 = r, this.y1 = i;
}
function xgr(t, e, n) {
  var r, i = this._x0, o = this._y0, s, a, A, l, c = this._x1, u = this._y1, f = [], h = this._root, d, I;
  for (h && f.push(new Uc(h, i, o, c, u)), n == null ? n = 1 / 0 : (i = t - n, o = e - n, c = t + n, u = e + n, n *= n); d = f.pop(); )
    if (!(!(h = d.node) || (s = d.x0) > c || (a = d.y0) > u || (A = d.x1) < i || (l = d.y1) < o))
      if (h.length) {
        var m = (s + A) / 2, C = (a + l) / 2;
        f.push(
          new Uc(h[3], m, C, A, l),
          new Uc(h[2], s, C, m, l),
          new Uc(h[1], m, a, A, C),
          new Uc(h[0], s, a, m, C)
        ), (I = (e >= C) << 1 | t >= m) && (d = f[f.length - 1], f[f.length - 1] = f[f.length - 1 - I], f[f.length - 1 - I] = d);
      } else {
        var y = t - +this._x.call(null, h.data), v = e - +this._y.call(null, h.data), b = y * y + v * v;
        if (b < n) {
          var Q = Math.sqrt(n = b);
          i = t - Q, o = e - Q, c = t + Q, u = e + Q, r = h.data;
        }
      }
  return r;
}
function Rgr(t) {
  if (isNaN(c = +this._x.call(null, t)) || isNaN(u = +this._y.call(null, t)))
    return this;
  var e, n = this._root, r, i, o, s = this._x0, a = this._y0, A = this._x1, l = this._y1, c, u, f, h, d, I, m, C;
  if (!n)
    return this;
  if (n.length)
    for (; ; ) {
      if ((d = c >= (f = (s + A) / 2)) ? s = f : A = f, (I = u >= (h = (a + l) / 2)) ? a = h : l = h, e = n, !(n = n[m = I << 1 | d]))
        return this;
      if (!n.length)
        break;
      (e[m + 1 & 3] || e[m + 2 & 3] || e[m + 3 & 3]) && (r = e, C = m);
    }
  for (; n.data !== t; )
    if (i = n, !(n = n.next))
      return this;
  return (o = n.next) && delete n.next, i ? (o ? i.next = o : delete i.next, this) : e ? (o ? e[m] = o : delete e[m], (n = e[0] || e[1] || e[2] || e[3]) && n === (e[3] || e[2] || e[1] || e[0]) && !n.length && (r ? r[C] = n : this._root = n), this) : (this._root = o, this);
}
function Dgr(t) {
  for (var e = 0, n = t.length; e < n; ++e)
    this.remove(t[e]);
  return this;
}
function Tgr() {
  return this._root;
}
function Ngr() {
  var t = 0;
  return this.visit(function(e) {
    if (!e.length)
      do
        ++t;
      while (e = e.next);
  }), t;
}
function Lgr(t) {
  var e = [], n, r = this._root, i, o, s, a, A;
  for (r && e.push(new Uc(r, this._x0, this._y0, this._x1, this._y1)); n = e.pop(); )
    if (!t(r = n.node, o = n.x0, s = n.y0, a = n.x1, A = n.y1) && r.length) {
      var l = (o + a) / 2, c = (s + A) / 2;
      (i = r[3]) && e.push(new Uc(i, l, c, a, A)), (i = r[2]) && e.push(new Uc(i, o, c, l, A)), (i = r[1]) && e.push(new Uc(i, l, s, a, c)), (i = r[0]) && e.push(new Uc(i, o, s, l, c));
    }
  return this;
}
function Mgr(t) {
  var e = [], n = [], r;
  for (this._root && e.push(new Uc(this._root, this._x0, this._y0, this._x1, this._y1)); r = e.pop(); ) {
    var i = r.node;
    if (i.length) {
      var o, s = r.x0, a = r.y0, A = r.x1, l = r.y1, c = (s + A) / 2, u = (a + l) / 2;
      (o = i[0]) && e.push(new Uc(o, s, a, c, u)), (o = i[1]) && e.push(new Uc(o, c, a, A, u)), (o = i[2]) && e.push(new Uc(o, s, u, c, l)), (o = i[3]) && e.push(new Uc(o, c, u, A, l));
    }
    n.push(r);
  }
  for (; r = n.pop(); )
    t(r.node, r.x0, r.y0, r.x1, r.y1);
  return this;
}
function Ogr(t) {
  return t[0];
}
function Fgr(t) {
  return arguments.length ? (this._x = t, this) : this._x;
}
function Pgr(t) {
  return t[1];
}
function kgr(t) {
  return arguments.length ? (this._y = t, this) : this._y;
}
function Ape(t, e, n) {
  var r = new lpe(e ?? Ogr, n ?? Pgr, NaN, NaN, NaN, NaN);
  return t == null ? r : r.addAll(t);
}
function lpe(t, e, n, r, i, o) {
  this._x = t, this._y = e, this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = o, this._root = void 0;
}
function fOe(t) {
  for (var e = { data: t.data }, n = e; t = t.next; )
    n = n.next = { data: t.data };
  return e;
}
var ru = Ape.prototype = lpe.prototype;
ru.copy = function() {
  var t = new lpe(this._x, this._y, this._x0, this._y0, this._x1, this._y1), e = this._root, n, r;
  if (!e)
    return t;
  if (!e.length)
    return t._root = fOe(e), t;
  for (n = [{ source: e, target: t._root = new Array(4) }]; e = n.pop(); )
    for (var i = 0; i < 4; ++i)
      (r = e.source[i]) && (r.length ? n.push({ source: r, target: e.target[i] = new Array(4) }) : e.target[i] = fOe(r));
  return t;
};
ru.add = bgr;
ru.addAll = _gr;
ru.cover = Sgr;
ru.data = Qgr;
ru.extent = wgr;
ru.find = xgr;
ru.remove = Rgr;
ru.removeAll = Dgr;
ru.root = Tgr;
ru.size = Ngr;
ru.visit = Lgr;
ru.visitAfter = Mgr;
ru.x = Fgr;
ru.y = kgr;
function qc(t) {
  return function() {
    return t;
  };
}
function vC(t) {
  return (t() - 0.5) * 1e-6;
}
function Ggr(t) {
  return t.x + t.vx;
}
function Ugr(t) {
  return t.y + t.vy;
}
function Hgr(t) {
  var e, n, r, i = 1, o = 1;
  typeof t != "function" && (t = qc(t == null ? 1 : +t));
  function s() {
    for (var l, c = e.length, u, f, h, d, I, m, C = 0; C < o; ++C)
      for (u = Ape(e, Ggr, Ugr).visitAfter(a), l = 0; l < c; ++l)
        f = e[l], I = n[f.index], m = I * I, h = f.x + f.vx, d = f.y + f.vy, u.visit(y);
    function y(v, b, Q, w, R) {
      var M = v.data, O = v.r, L = I + O;
      if (M) {
        if (M.index > f.index) {
          var N = h - M.x - M.vx, k = d - M.y - M.vy, $ = N * N + k * k;
          $ < L * L && (N === 0 && (N = vC(r), $ += N * N), k === 0 && (k = vC(r), $ += k * k), $ = (L - ($ = Math.sqrt($))) / $ * i, f.vx += (N *= $) * (L = (O *= O) / (m + O)), f.vy += (k *= $) * L, M.vx -= N * (L = 1 - L), M.vy -= k * L);
        }
        return;
      }
      return b > h + L || w < h - L || Q > d + L || R < d - L;
    }
  }
  function a(l) {
    if (l.data)
      return l.r = n[l.data.index];
    for (var c = l.r = 0; c < 4; ++c)
      l[c] && l[c].r > l.r && (l.r = l[c].r);
  }
  function A() {
    if (e) {
      var l, c = e.length, u;
      for (n = new Array(c), l = 0; l < c; ++l)
        u = e[l], n[u.index] = +t(u, l, e);
    }
  }
  return s.initialize = function(l, c) {
    e = l, r = c, A();
  }, s.iterations = function(l) {
    return arguments.length ? (o = +l, s) : o;
  }, s.strength = function(l) {
    return arguments.length ? (i = +l, s) : i;
  }, s.radius = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : qc(+l), A(), s) : t;
  }, s;
}
function $gr(t) {
  return t.index;
}
function gOe(t, e) {
  var n = t.get(e);
  if (!n)
    throw new Error("node not found: " + e);
  return n;
}
function qgr(t) {
  var e = $gr, n = u, r, i = qc(30), o, s, a, A, l, c = 1;
  t == null && (t = []);
  function u(m) {
    return 1 / Math.min(a[m.source.index], a[m.target.index]);
  }
  function f(m) {
    for (var C = 0, y = t.length; C < c; ++C)
      for (var v = 0, b, Q, w, R, M, O, L; v < y; ++v)
        b = t[v], Q = b.source, w = b.target, R = w.x + w.vx - Q.x - Q.vx || vC(l), M = w.y + w.vy - Q.y - Q.vy || vC(l), O = Math.sqrt(R * R + M * M), O = (O - o[v]) / O * m * r[v], R *= O, M *= O, w.vx -= R * (L = A[v]), w.vy -= M * L, Q.vx += R * (L = 1 - L), Q.vy += M * L;
  }
  function h() {
    if (s) {
      var m, C = s.length, y = t.length, v = new Map(s.map((Q, w) => [e(Q, w, s), Q])), b;
      for (m = 0, a = new Array(C); m < y; ++m)
        b = t[m], b.index = m, typeof b.source != "object" && (b.source = gOe(v, b.source)), typeof b.target != "object" && (b.target = gOe(v, b.target)), a[b.source.index] = (a[b.source.index] || 0) + 1, a[b.target.index] = (a[b.target.index] || 0) + 1;
      for (m = 0, A = new Array(y); m < y; ++m)
        b = t[m], A[m] = a[b.source.index] / (a[b.source.index] + a[b.target.index]);
      r = new Array(y), d(), o = new Array(y), I();
    }
  }
  function d() {
    if (s)
      for (var m = 0, C = t.length; m < C; ++m)
        r[m] = +n(t[m], m, t);
  }
  function I() {
    if (s)
      for (var m = 0, C = t.length; m < C; ++m)
        o[m] = +i(t[m], m, t);
  }
  return f.initialize = function(m, C) {
    s = m, l = C, h();
  }, f.links = function(m) {
    return arguments.length ? (t = m, h(), f) : t;
  }, f.id = function(m) {
    return arguments.length ? (e = m, f) : e;
  }, f.iterations = function(m) {
    return arguments.length ? (c = +m, f) : c;
  }, f.strength = function(m) {
    return arguments.length ? (n = typeof m == "function" ? m : qc(+m), d(), f) : n;
  }, f.distance = function(m) {
    return arguments.length ? (i = typeof m == "function" ? m : qc(+m), I(), f) : i;
  }, f;
}
var jgr = { value: () => {
} };
function jit() {
  for (var t = 0, e = arguments.length, n = {}, r; t < e; ++t) {
    if (!(r = arguments[t] + "") || r in n || /[\s.]/.test(r))
      throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new i4(n);
}
function i4(t) {
  this._ = t;
}
function Ygr(t, e) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !e.hasOwnProperty(n))
      throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
i4.prototype = jit.prototype = {
  constructor: i4,
  on: function(t, e) {
    var n = this._, r = Ygr(t + "", n), i, o = -1, s = r.length;
    if (arguments.length < 2) {
      for (; ++o < s; )
        if ((i = (t = r[o]).type) && (i = zgr(n[i], t.name)))
          return i;
      return;
    }
    if (e != null && typeof e != "function")
      throw new Error("invalid callback: " + e);
    for (; ++o < s; )
      if (i = (t = r[o]).type)
        n[i] = hOe(n[i], t.name, e);
      else if (e == null)
        for (i in n)
          n[i] = hOe(n[i], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var n in e)
      t[n] = e[n].slice();
    return new i4(t);
  },
  call: function(t, e) {
    if ((i = arguments.length - 2) > 0)
      for (var n = new Array(i), r = 0, i, o; r < i; ++r)
        n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (o = this._[t], r = 0, i = o.length; r < i; ++r)
      o[r].value.apply(e, n);
  },
  apply: function(t, e, n) {
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (var r = this._[t], i = 0, o = r.length; i < o; ++i)
      r[i].value.apply(e, n);
  }
};
function zgr(t, e) {
  for (var n = 0, r = t.length, i; n < r; ++n)
    if ((i = t[n]).name === e)
      return i.value;
}
function hOe(t, e, n) {
  for (var r = 0, i = t.length; r < i; ++r)
    if (t[r].name === e) {
      t[r] = jgr, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return n != null && t.push({ name: e, value: n }), t;
}
var RQ = 0, tD = 0, K2 = 0, Yit = 1e3, C6, nD, E6 = 0, bB = 0, Wj = 0, RN = typeof performance == "object" && performance.now ? performance : Date, zit = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function cpe() {
  return bB || (zit(Vgr), bB = RN.now() + Wj);
}
function Vgr() {
  bB = 0;
}
function y6() {
  this._call = this._time = this._next = null;
}
y6.prototype = Vit.prototype = {
  constructor: y6,
  restart: function(t, e, n) {
    if (typeof t != "function")
      throw new TypeError("callback is not a function");
    n = (n == null ? cpe() : +n) + (e == null ? 0 : +e), !this._next && nD !== this && (nD ? nD._next = this : C6 = this, nD = this), this._call = t, this._time = n, Jie();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, Jie());
  }
};
function Vit(t, e, n) {
  var r = new y6();
  return r.restart(t, e, n), r;
}
function Jgr() {
  cpe(), ++RQ;
  for (var t = C6, e; t; )
    (e = bB - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --RQ;
}
function dOe() {
  bB = (E6 = RN.now()) + Wj, RQ = tD = 0;
  try {
    Jgr();
  } finally {
    RQ = 0, Wgr(), bB = 0;
  }
}
function Kgr() {
  var t = RN.now(), e = t - E6;
  e > Yit && (Wj -= e, E6 = t);
}
function Wgr() {
  for (var t, e = C6, n, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), t = e, e = e._next) : (n = e._next, e._next = null, e = t ? t._next = n : C6 = n);
  nD = t, Jie(r);
}
function Jie(t) {
  if (!RQ) {
    tD && (tD = clearTimeout(tD));
    var e = t - bB;
    e > 24 ? (t < 1 / 0 && (tD = setTimeout(dOe, t - RN.now() - Wj)), K2 && (K2 = clearInterval(K2))) : (K2 || (E6 = RN.now(), K2 = setInterval(Kgr, Yit)), RQ = 1, zit(dOe));
  }
}
function Xgr(t, e, n) {
  var r = new y6(), i = e;
  return e == null ? (r.restart(t, e, n), r) : (r._restart = r.restart, r.restart = function(o, s, a) {
    s = +s, a = a == null ? cpe() : +a, r._restart(function A(l) {
      l += i, r._restart(A, i += s, a), o(l);
    }, s, a);
  }, r.restart(t, e, n), r);
}
const Zgr = 1664525, ehr = 1013904223, pOe = 4294967296;
function thr() {
  let t = 1;
  return () => (t = (Zgr * t + ehr) % pOe) / pOe;
}
function nhr(t) {
  return t.x;
}
function rhr(t) {
  return t.y;
}
var ihr = 10, ohr = Math.PI * (3 - Math.sqrt(5));
function shr(t) {
  var e, n = 1, r = 1e-3, i = 1 - Math.pow(r, 1 / 300), o = 0, s = 0.6, a = /* @__PURE__ */ new Map(), A = Vit(u), l = jit("tick", "end"), c = thr();
  t == null && (t = []);
  function u() {
    f(), l.call("tick", e), n < r && (A.stop(), l.call("end", e));
  }
  function f(I) {
    var m, C = t.length, y;
    I === void 0 && (I = 1);
    for (var v = 0; v < I; ++v)
      for (n += (o - n) * i, a.forEach(function(b) {
        b(n);
      }), m = 0; m < C; ++m)
        y = t[m], y.fx == null ? y.x += y.vx *= s : (y.x = y.fx, y.vx = 0), y.fy == null ? y.y += y.vy *= s : (y.y = y.fy, y.vy = 0);
    return e;
  }
  function h() {
    for (var I = 0, m = t.length, C; I < m; ++I) {
      if (C = t[I], C.index = I, C.fx != null && (C.x = C.fx), C.fy != null && (C.y = C.fy), isNaN(C.x) || isNaN(C.y)) {
        var y = ihr * Math.sqrt(0.5 + I), v = I * ohr;
        C.x = y * Math.cos(v), C.y = y * Math.sin(v);
      }
      (isNaN(C.vx) || isNaN(C.vy)) && (C.vx = C.vy = 0);
    }
  }
  function d(I) {
    return I.initialize && I.initialize(t, c), I;
  }
  return h(), e = {
    tick: f,
    restart: function() {
      return A.restart(u), e;
    },
    stop: function() {
      return A.stop(), e;
    },
    nodes: function(I) {
      return arguments.length ? (t = I, h(), a.forEach(d), e) : t;
    },
    alpha: function(I) {
      return arguments.length ? (n = +I, e) : n;
    },
    alphaMin: function(I) {
      return arguments.length ? (r = +I, e) : r;
    },
    alphaDecay: function(I) {
      return arguments.length ? (i = +I, e) : +i;
    },
    alphaTarget: function(I) {
      return arguments.length ? (o = +I, e) : o;
    },
    velocityDecay: function(I) {
      return arguments.length ? (s = 1 - I, e) : 1 - s;
    },
    randomSource: function(I) {
      return arguments.length ? (c = I, a.forEach(d), e) : c;
    },
    force: function(I, m) {
      return arguments.length > 1 ? (m == null ? a.delete(I) : a.set(I, d(m)), e) : a.get(I);
    },
    find: function(I, m, C) {
      var y = 0, v = t.length, b, Q, w, R, M;
      for (C == null ? C = 1 / 0 : C *= C, y = 0; y < v; ++y)
        R = t[y], b = I - R.x, Q = m - R.y, w = b * b + Q * Q, w < C && (M = R, C = w);
      return M;
    },
    on: function(I, m) {
      return arguments.length > 1 ? (l.on(I, m), e) : l.on(I);
    }
  };
}
function ahr() {
  var t, e, n, r, i = qc(-30), o, s = 1, a = 1 / 0, A = 0.81;
  function l(h) {
    var d, I = t.length, m = Ape(t, nhr, rhr).visitAfter(u);
    for (r = h, d = 0; d < I; ++d)
      e = t[d], m.visit(f);
  }
  function c() {
    if (t) {
      var h, d = t.length, I;
      for (o = new Array(d), h = 0; h < d; ++h)
        I = t[h], o[I.index] = +i(I, h, t);
    }
  }
  function u(h) {
    var d = 0, I, m, C = 0, y, v, b;
    if (h.length) {
      for (y = v = b = 0; b < 4; ++b)
        (I = h[b]) && (m = Math.abs(I.value)) && (d += I.value, C += m, y += m * I.x, v += m * I.y);
      h.x = y / C, h.y = v / C;
    } else {
      I = h, I.x = I.data.x, I.y = I.data.y;
      do
        d += o[I.data.index];
      while (I = I.next);
    }
    h.value = d;
  }
  function f(h, d, I, m) {
    if (!h.value)
      return !0;
    var C = h.x - e.x, y = h.y - e.y, v = m - d, b = C * C + y * y;
    if (v * v / A < b)
      return b < a && (C === 0 && (C = vC(n), b += C * C), y === 0 && (y = vC(n), b += y * y), b < s && (b = Math.sqrt(s * b)), e.vx += C * h.value * r / b, e.vy += y * h.value * r / b), !0;
    if (h.length || b >= a)
      return;
    (h.data !== e || h.next) && (C === 0 && (C = vC(n), b += C * C), y === 0 && (y = vC(n), b += y * y), b < s && (b = Math.sqrt(s * b)));
    do
      h.data !== e && (v = o[h.data.index] * r / b, e.vx += C * v, e.vy += y * v);
    while (h = h.next);
  }
  return l.initialize = function(h, d) {
    t = h, n = d, c();
  }, l.strength = function(h) {
    return arguments.length ? (i = typeof h == "function" ? h : qc(+h), c(), l) : i;
  }, l.distanceMin = function(h) {
    return arguments.length ? (s = h * h, l) : Math.sqrt(s);
  }, l.distanceMax = function(h) {
    return arguments.length ? (a = h * h, l) : Math.sqrt(a);
  }, l.theta = function(h) {
    return arguments.length ? (A = h * h, l) : Math.sqrt(A);
  }, l;
}
function Ahr(t) {
  var e = qc(0.1), n, r, i;
  typeof t != "function" && (t = qc(t == null ? 0 : +t));
  function o(a) {
    for (var A = 0, l = n.length, c; A < l; ++A)
      c = n[A], c.vx += (i[A] - c.x) * r[A] * a;
  }
  function s() {
    if (n) {
      var a, A = n.length;
      for (r = new Array(A), i = new Array(A), a = 0; a < A; ++a)
        r[a] = isNaN(i[a] = +t(n[a], a, n)) ? 0 : +e(n[a], a, n);
    }
  }
  return o.initialize = function(a) {
    n = a, s();
  }, o.strength = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : qc(+a), s(), o) : e;
  }, o.x = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : qc(+a), s(), o) : t;
  }, o;
}
function lhr(t) {
  var e = qc(0.1), n, r, i;
  typeof t != "function" && (t = qc(t == null ? 0 : +t));
  function o(a) {
    for (var A = 0, l = n.length, c; A < l; ++A)
      c = n[A], c.vy += (i[A] - c.y) * r[A] * a;
  }
  function s() {
    if (n) {
      var a, A = n.length;
      for (r = new Array(A), i = new Array(A), a = 0; a < A; ++a)
        r[a] = isNaN(i[a] = +t(n[a], a, n)) ? 0 : +e(n[a], a, n);
    }
  }
  return o.initialize = function(a) {
    n = a, s();
  }, o.strength = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : qc(+a), s(), o) : e;
  }, o.y = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : qc(+a), s(), o) : t;
  }, o;
}
const IOe = {
  center: Bgr,
  collide: Hgr,
  nbody: ahr,
  link: qgr,
  x: Ahr,
  y: lhr
}, rD = "forces", Kie = ["alpha", "alphaMin", "alphaTarget", "velocityDecay", "forces"], chr = ["static", "iterations"], Jit = ["x", "y", "vx", "vy"];
function upe(t) {
  yt.call(this, null, t);
}
upe.Definition = {
  type: "Force",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "static",
    type: "boolean",
    default: !1
  }, {
    name: "restart",
    type: "boolean",
    default: !1
  }, {
    name: "iterations",
    type: "number",
    default: 300
  }, {
    name: "alpha",
    type: "number",
    default: 1
  }, {
    name: "alphaMin",
    type: "number",
    default: 1e-3
  }, {
    name: "alphaTarget",
    type: "number",
    default: 0
  }, {
    name: "velocityDecay",
    type: "number",
    default: 0.4
  }, {
    name: "forces",
    type: "param",
    array: !0,
    params: [{
      key: {
        force: "center"
      },
      params: [{
        name: "x",
        type: "number",
        default: 0
      }, {
        name: "y",
        type: "number",
        default: 0
      }]
    }, {
      key: {
        force: "collide"
      },
      params: [{
        name: "radius",
        type: "number",
        expr: !0
      }, {
        name: "strength",
        type: "number",
        default: 0.7
      }, {
        name: "iterations",
        type: "number",
        default: 1
      }]
    }, {
      key: {
        force: "nbody"
      },
      params: [{
        name: "strength",
        type: "number",
        default: -30
      }, {
        name: "theta",
        type: "number",
        default: 0.9
      }, {
        name: "distanceMin",
        type: "number",
        default: 1
      }, {
        name: "distanceMax",
        type: "number"
      }]
    }, {
      key: {
        force: "link"
      },
      params: [{
        name: "links",
        type: "data"
      }, {
        name: "id",
        type: "field"
      }, {
        name: "distance",
        type: "number",
        default: 30,
        expr: !0
      }, {
        name: "strength",
        type: "number",
        expr: !0
      }, {
        name: "iterations",
        type: "number",
        default: 1
      }]
    }, {
      key: {
        force: "x"
      },
      params: [{
        name: "strength",
        type: "number",
        default: 0.1
      }, {
        name: "x",
        type: "field"
      }]
    }, {
      key: {
        force: "y"
      },
      params: [{
        name: "strength",
        type: "number",
        default: 0.1
      }, {
        name: "y",
        type: "field"
      }]
    }]
  }, {
    name: "as",
    type: "string",
    array: !0,
    modify: !1,
    default: Jit
  }]
};
on(upe, yt, {
  transform(t, e) {
    var n = this.value, r = e.changed(e.ADD_REM), i = t.modified(Kie), o = t.iterations || 300;
    if (n ? (r && (e.modifies("index"), n.nodes(e.source)), (i || e.changed(e.MOD)) && Kit(n, t, 0, e)) : (this.value = n = fhr(e.source, t), n.on("tick", uhr(e.dataflow, this)), t.static || (r = !0, n.tick()), e.modifies("index")), i || r || t.modified(chr) || e.changed() && t.restart) {
      if (n.alpha(Math.max(n.alpha(), t.alpha || 1)).alphaDecay(1 - Math.pow(n.alphaMin(), 1 / o)), t.static)
        for (n.stop(); --o >= 0; )
          n.tick();
      else if (n.stopped() && n.restart(), !r)
        return e.StopPropagation;
    }
    return this.finish(t, e);
  },
  finish(t, e) {
    const n = e.dataflow;
    for (let a = this._argops, A = 0, l = a.length, c; A < l; ++A)
      if (c = a[A], !(c.name !== rD || c.op._argval.force !== "link")) {
        for (var r = c.op._argops, i = 0, o = r.length, s; i < o; ++i)
          if (r[i].name === "links" && (s = r[i].op.source)) {
            n.pulse(s, n.changeset().reflow());
            break;
          }
      }
    return e.reflow(t.modified()).modifies(Jit);
  }
});
function uhr(t, e) {
  return () => t.touch(e).run();
}
function fhr(t, e) {
  const n = shr(t), r = n.stop, i = n.restart;
  let o = !1;
  return n.stopped = () => o, n.restart = () => (o = !1, i()), n.stop = () => (o = !0, r()), Kit(n, e, !0).on("end", () => o = !0);
}
function Kit(t, e, n, r) {
  var i = bn(e.forces), o, s, a, A;
  for (o = 0, s = Kie.length; o < s; ++o)
    a = Kie[o], a !== rD && e.modified(a) && t[a](e[a]);
  for (o = 0, s = i.length; o < s; ++o)
    A = rD + o, a = n || e.modified(rD, o) ? hhr(i[o]) : r && ghr(i[o], r) ? t.force(A) : null, a && t.force(A, a);
  for (s = t.numForces || 0; o < s; ++o)
    t.force(rD + o, null);
  return t.numForces = i.length, t;
}
function ghr(t, e) {
  var n, r;
  for (n in t)
    if (ri(r = t[n]) && e.modified(Zl(r)))
      return 1;
  return 0;
}
function hhr(t) {
  var e, n;
  Kn(IOe, t.force) || wt("Unrecognized force: " + t.force), e = IOe[t.force]();
  for (n in t)
    ri(e[n]) && dhr(e[n], t[n], t);
  return e;
}
function dhr(t, e, n) {
  t(ri(e) ? (r) => e(r, n) : e);
}
const phr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  force: upe
}, Symbol.toStringTag, { value: "Module" }));
function Ihr(t, e) {
  return t.parent === e.parent ? 1 : 2;
}
function mhr(t) {
  return t.reduce(Chr, 0) / t.length;
}
function Chr(t, e) {
  return t + e.x;
}
function Ehr(t) {
  return 1 + t.reduce(yhr, 0);
}
function yhr(t, e) {
  return Math.max(t, e.y);
}
function vhr(t) {
  for (var e; e = t.children; )
    t = e[0];
  return t;
}
function Bhr(t) {
  for (var e; e = t.children; )
    t = e[e.length - 1];
  return t;
}
function bhr() {
  var t = Ihr, e = 1, n = 1, r = !1;
  function i(o) {
    var s, a = 0;
    o.eachAfter(function(f) {
      var h = f.children;
      h ? (f.x = mhr(h), f.y = Ehr(h)) : (f.x = s ? a += t(f, s) : 0, f.y = 0, s = f);
    });
    var A = vhr(o), l = Bhr(o), c = A.x - t(A, l) / 2, u = l.x + t(l, A) / 2;
    return o.eachAfter(r ? function(f) {
      f.x = (f.x - o.x) * e, f.y = (o.y - f.y) * n;
    } : function(f) {
      f.x = (f.x - c) / (u - c) * e, f.y = (1 - (o.y ? f.y / o.y : 1)) * n;
    });
  }
  return i.separation = function(o) {
    return arguments.length ? (t = o, i) : t;
  }, i.size = function(o) {
    return arguments.length ? (r = !1, e = +o[0], n = +o[1], i) : r ? null : [e, n];
  }, i.nodeSize = function(o) {
    return arguments.length ? (r = !0, e = +o[0], n = +o[1], i) : r ? [e, n] : null;
  }, i;
}
function _hr(t) {
  var e = 0, n = t.children, r = n && n.length;
  if (!r)
    e = 1;
  else
    for (; --r >= 0; )
      e += n[r].value;
  t.value = e;
}
function Shr() {
  return this.eachAfter(_hr);
}
function Qhr(t, e) {
  let n = -1;
  for (const r of this)
    t.call(e, r, ++n, this);
  return this;
}
function whr(t, e) {
  for (var n = this, r = [n], i, o, s = -1; n = r.pop(); )
    if (t.call(e, n, ++s, this), i = n.children)
      for (o = i.length - 1; o >= 0; --o)
        r.push(i[o]);
  return this;
}
function xhr(t, e) {
  for (var n = this, r = [n], i = [], o, s, a, A = -1; n = r.pop(); )
    if (i.push(n), o = n.children)
      for (s = 0, a = o.length; s < a; ++s)
        r.push(o[s]);
  for (; n = i.pop(); )
    t.call(e, n, ++A, this);
  return this;
}
function Rhr(t, e) {
  let n = -1;
  for (const r of this)
    if (t.call(e, r, ++n, this))
      return r;
}
function Dhr(t) {
  return this.eachAfter(function(e) {
    for (var n = +t(e.data) || 0, r = e.children, i = r && r.length; --i >= 0; )
      n += r[i].value;
    e.value = n;
  });
}
function Thr(t) {
  return this.eachBefore(function(e) {
    e.children && e.children.sort(t);
  });
}
function Nhr(t) {
  for (var e = this, n = Lhr(e, t), r = [e]; e !== n; )
    e = e.parent, r.push(e);
  for (var i = r.length; t !== n; )
    r.splice(i, 0, t), t = t.parent;
  return r;
}
function Lhr(t, e) {
  if (t === e)
    return t;
  var n = t.ancestors(), r = e.ancestors(), i = null;
  for (t = n.pop(), e = r.pop(); t === e; )
    i = t, t = n.pop(), e = r.pop();
  return i;
}
function Mhr() {
  for (var t = this, e = [t]; t = t.parent; )
    e.push(t);
  return e;
}
function Ohr() {
  return Array.from(this);
}
function Fhr() {
  var t = [];
  return this.eachBefore(function(e) {
    e.children || t.push(e);
  }), t;
}
function Phr() {
  var t = this, e = [];
  return t.each(function(n) {
    n !== t && e.push({ source: n.parent, target: n });
  }), e;
}
function* khr() {
  var t = this, e, n = [t], r, i, o;
  do
    for (e = n.reverse(), n = []; t = e.pop(); )
      if (yield t, r = t.children)
        for (i = 0, o = r.length; i < o; ++i)
          n.push(r[i]);
  while (n.length);
}
function fpe(t, e) {
  t instanceof Map ? (t = [void 0, t], e === void 0 && (e = Hhr)) : e === void 0 && (e = Uhr);
  for (var n = new DQ(t), r, i = [n], o, s, a, A; r = i.pop(); )
    if ((s = e(r.data)) && (A = (s = Array.from(s)).length))
      for (r.children = s, a = A - 1; a >= 0; --a)
        i.push(o = s[a] = new DQ(s[a])), o.parent = r, o.depth = r.depth + 1;
  return n.eachBefore(Wit);
}
function Ghr() {
  return fpe(this).eachBefore($hr);
}
function Uhr(t) {
  return t.children;
}
function Hhr(t) {
  return Array.isArray(t) ? t[1] : null;
}
function $hr(t) {
  t.data.value !== void 0 && (t.value = t.data.value), t.data = t.data.data;
}
function Wit(t) {
  var e = 0;
  do
    t.height = e;
  while ((t = t.parent) && t.height < ++e);
}
function DQ(t) {
  this.data = t, this.depth = this.height = 0, this.parent = null;
}
DQ.prototype = fpe.prototype = {
  constructor: DQ,
  count: Shr,
  each: Qhr,
  eachAfter: xhr,
  eachBefore: whr,
  find: Rhr,
  sum: Dhr,
  sort: Thr,
  path: Nhr,
  ancestors: Mhr,
  descendants: Ohr,
  leaves: Fhr,
  links: Phr,
  copy: Ghr,
  [Symbol.iterator]: khr
};
function o4(t) {
  return t == null ? null : Xit(t);
}
function Xit(t) {
  if (typeof t != "function")
    throw new Error();
  return t;
}
function tv() {
  return 0;
}
function r_(t) {
  return function() {
    return t;
  };
}
const qhr = 1664525, jhr = 1013904223, mOe = 4294967296;
function Yhr() {
  let t = 1;
  return () => (t = (qhr * t + jhr) % mOe) / mOe;
}
function zhr(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function Vhr(t, e) {
  let n = t.length, r, i;
  for (; n; )
    i = e() * n-- | 0, r = t[n], t[n] = t[i], t[i] = r;
  return t;
}
function Jhr(t, e) {
  for (var n = 0, r = (t = Vhr(Array.from(t), e)).length, i = [], o, s; n < r; )
    o = t[n], s && Zit(s, o) ? ++n : (s = Whr(i = Khr(i, o)), n = 0);
  return s;
}
function Khr(t, e) {
  var n, r;
  if (OW(e, t))
    return [e];
  for (n = 0; n < t.length; ++n)
    if (T3(e, t[n]) && OW(iD(t[n], e), t))
      return [t[n], e];
  for (n = 0; n < t.length - 1; ++n)
    for (r = n + 1; r < t.length; ++r)
      if (T3(iD(t[n], t[r]), e) && T3(iD(t[n], e), t[r]) && T3(iD(t[r], e), t[n]) && OW(eot(t[n], t[r], e), t))
        return [t[n], t[r], e];
  throw new Error();
}
function T3(t, e) {
  var n = t.r - e.r, r = e.x - t.x, i = e.y - t.y;
  return n < 0 || n * n < r * r + i * i;
}
function Zit(t, e) {
  var n = t.r - e.r + Math.max(t.r, e.r, 1) * 1e-9, r = e.x - t.x, i = e.y - t.y;
  return n > 0 && n * n > r * r + i * i;
}
function OW(t, e) {
  for (var n = 0; n < e.length; ++n)
    if (!Zit(t, e[n]))
      return !1;
  return !0;
}
function Whr(t) {
  switch (t.length) {
    case 1:
      return Xhr(t[0]);
    case 2:
      return iD(t[0], t[1]);
    case 3:
      return eot(t[0], t[1], t[2]);
  }
}
function Xhr(t) {
  return {
    x: t.x,
    y: t.y,
    r: t.r
  };
}
function iD(t, e) {
  var n = t.x, r = t.y, i = t.r, o = e.x, s = e.y, a = e.r, A = o - n, l = s - r, c = a - i, u = Math.sqrt(A * A + l * l);
  return {
    x: (n + o + A / u * c) / 2,
    y: (r + s + l / u * c) / 2,
    r: (u + i + a) / 2
  };
}
function eot(t, e, n) {
  var r = t.x, i = t.y, o = t.r, s = e.x, a = e.y, A = e.r, l = n.x, c = n.y, u = n.r, f = r - s, h = r - l, d = i - a, I = i - c, m = A - o, C = u - o, y = r * r + i * i - o * o, v = y - s * s - a * a + A * A, b = y - l * l - c * c + u * u, Q = h * d - f * I, w = (d * b - I * v) / (Q * 2) - r, R = (I * m - d * C) / Q, M = (h * v - f * b) / (Q * 2) - i, O = (f * C - h * m) / Q, L = R * R + O * O - 1, N = 2 * (o + w * R + M * O), k = w * w + M * M - o * o, $ = -(Math.abs(L) > 1e-6 ? (N + Math.sqrt(N * N - 4 * L * k)) / (2 * L) : k / N);
  return {
    x: r + w + R * $,
    y: i + M + O * $,
    r: $
  };
}
function COe(t, e, n) {
  var r = t.x - e.x, i, o, s = t.y - e.y, a, A, l = r * r + s * s;
  l ? (o = e.r + n.r, o *= o, A = t.r + n.r, A *= A, o > A ? (i = (l + A - o) / (2 * l), a = Math.sqrt(Math.max(0, A / l - i * i)), n.x = t.x - i * r - a * s, n.y = t.y - i * s + a * r) : (i = (l + o - A) / (2 * l), a = Math.sqrt(Math.max(0, o / l - i * i)), n.x = e.x + i * r - a * s, n.y = e.y + i * s + a * r)) : (n.x = e.x + n.r, n.y = e.y);
}
function EOe(t, e) {
  var n = t.r + e.r - 1e-6, r = e.x - t.x, i = e.y - t.y;
  return n > 0 && n * n > r * r + i * i;
}
function yOe(t) {
  var e = t._, n = t.next._, r = e.r + n.r, i = (e.x * n.r + n.x * e.r) / r, o = (e.y * n.r + n.y * e.r) / r;
  return i * i + o * o;
}
function N3(t) {
  this._ = t, this.next = null, this.previous = null;
}
function Zhr(t, e) {
  if (!(o = (t = zhr(t)).length))
    return 0;
  var n, r, i, o, s, a, A, l, c, u, f;
  if (n = t[0], n.x = 0, n.y = 0, !(o > 1))
    return n.r;
  if (r = t[1], n.x = -r.r, r.x = n.r, r.y = 0, !(o > 2))
    return n.r + r.r;
  COe(r, n, i = t[2]), n = new N3(n), r = new N3(r), i = new N3(i), n.next = i.previous = r, r.next = n.previous = i, i.next = r.previous = n;
  e:
    for (A = 3; A < o; ++A) {
      COe(n._, r._, i = t[A]), i = new N3(i), l = r.next, c = n.previous, u = r._.r, f = n._.r;
      do
        if (u <= f) {
          if (EOe(l._, i._)) {
            r = l, n.next = r, r.previous = n, --A;
            continue e;
          }
          u += l._.r, l = l.next;
        } else {
          if (EOe(c._, i._)) {
            n = c, n.next = r, r.previous = n, --A;
            continue e;
          }
          f += c._.r, c = c.previous;
        }
      while (l !== c.next);
      for (i.previous = n, i.next = r, n.next = r.previous = r = i, s = yOe(n); (i = i.next) !== r; )
        (a = yOe(i)) < s && (n = i, s = a);
      r = n.next;
    }
  for (n = [r._], i = r; (i = i.next) !== r; )
    n.push(i._);
  for (i = Jhr(n, e), A = 0; A < o; ++A)
    n = t[A], n.x -= i.x, n.y -= i.y;
  return i.r;
}
function edr(t) {
  return Math.sqrt(t.value);
}
function tdr() {
  var t = null, e = 1, n = 1, r = tv;
  function i(o) {
    const s = Yhr();
    return o.x = e / 2, o.y = n / 2, t ? o.eachBefore(vOe(t)).eachAfter(FW(r, 0.5, s)).eachBefore(BOe(1)) : o.eachBefore(vOe(edr)).eachAfter(FW(tv, 1, s)).eachAfter(FW(r, o.r / Math.min(e, n), s)).eachBefore(BOe(Math.min(e, n) / (2 * o.r))), o;
  }
  return i.radius = function(o) {
    return arguments.length ? (t = o4(o), i) : t;
  }, i.size = function(o) {
    return arguments.length ? (e = +o[0], n = +o[1], i) : [e, n];
  }, i.padding = function(o) {
    return arguments.length ? (r = typeof o == "function" ? o : r_(+o), i) : r;
  }, i;
}
function vOe(t) {
  return function(e) {
    e.children || (e.r = Math.max(0, +t(e) || 0));
  };
}
function FW(t, e, n) {
  return function(r) {
    if (i = r.children) {
      var i, o, s = i.length, a = t(r) * e || 0, A;
      if (a)
        for (o = 0; o < s; ++o)
          i[o].r += a;
      if (A = Zhr(i, n), a)
        for (o = 0; o < s; ++o)
          i[o].r -= a;
      r.r = A + a;
    }
  };
}
function BOe(t) {
  return function(e) {
    var n = e.parent;
    e.r *= t, n && (e.x = n.x + t * e.x, e.y = n.y + t * e.y);
  };
}
function tot(t) {
  t.x0 = Math.round(t.x0), t.y0 = Math.round(t.y0), t.x1 = Math.round(t.x1), t.y1 = Math.round(t.y1);
}
function bO(t, e, n, r, i) {
  for (var o = t.children, s, a = -1, A = o.length, l = t.value && (r - e) / t.value; ++a < A; )
    s = o[a], s.y0 = n, s.y1 = i, s.x0 = e, s.x1 = e += s.value * l;
}
function ndr() {
  var t = 1, e = 1, n = 0, r = !1;
  function i(s) {
    var a = s.height + 1;
    return s.x0 = s.y0 = n, s.x1 = t, s.y1 = e / a, s.eachBefore(o(e, a)), r && s.eachBefore(tot), s;
  }
  function o(s, a) {
    return function(A) {
      A.children && bO(A, A.x0, s * (A.depth + 1) / a, A.x1, s * (A.depth + 2) / a);
      var l = A.x0, c = A.y0, u = A.x1 - n, f = A.y1 - n;
      u < l && (l = u = (l + u) / 2), f < c && (c = f = (c + f) / 2), A.x0 = l, A.y0 = c, A.x1 = u, A.y1 = f;
    };
  }
  return i.round = function(s) {
    return arguments.length ? (r = !!s, i) : r;
  }, i.size = function(s) {
    return arguments.length ? (t = +s[0], e = +s[1], i) : [t, e];
  }, i.padding = function(s) {
    return arguments.length ? (n = +s, i) : n;
  }, i;
}
var rdr = { depth: -1 }, bOe = {}, PW = {};
function idr(t) {
  return t.id;
}
function odr(t) {
  return t.parentId;
}
function _Oe() {
  var t = idr, e = odr, n;
  function r(i) {
    var o = Array.from(i), s = t, a = e, A, l, c, u, f, h, d, I, m = /* @__PURE__ */ new Map();
    if (n != null) {
      const C = o.map((b, Q) => sdr(n(b, Q, i))), y = C.map(SOe), v = new Set(C).add("");
      for (const b of y)
        v.has(b) || (v.add(b), C.push(b), y.push(SOe(b)), o.push(PW));
      s = (b, Q) => C[Q], a = (b, Q) => y[Q];
    }
    for (c = 0, A = o.length; c < A; ++c)
      l = o[c], h = o[c] = new DQ(l), (d = s(l, c, i)) != null && (d += "") && (I = h.id = d, m.set(I, m.has(I) ? bOe : h)), (d = a(l, c, i)) != null && (d += "") && (h.parent = d);
    for (c = 0; c < A; ++c)
      if (h = o[c], d = h.parent) {
        if (f = m.get(d), !f)
          throw new Error("missing: " + d);
        if (f === bOe)
          throw new Error("ambiguous: " + d);
        f.children ? f.children.push(h) : f.children = [h], h.parent = f;
      } else {
        if (u)
          throw new Error("multiple roots");
        u = h;
      }
    if (!u)
      throw new Error("no root");
    if (n != null) {
      for (; u.data === PW && u.children.length === 1; )
        u = u.children[0], --A;
      for (let C = o.length - 1; C >= 0 && (h = o[C], h.data === PW); --C)
        h.data = null;
    }
    if (u.parent = rdr, u.eachBefore(function(C) {
      C.depth = C.parent.depth + 1, --A;
    }).eachBefore(Wit), u.parent = null, A > 0)
      throw new Error("cycle");
    return u;
  }
  return r.id = function(i) {
    return arguments.length ? (t = o4(i), r) : t;
  }, r.parentId = function(i) {
    return arguments.length ? (e = o4(i), r) : e;
  }, r.path = function(i) {
    return arguments.length ? (n = o4(i), r) : n;
  }, r;
}
function sdr(t) {
  t = `${t}`;
  let e = t.length;
  return Wie(t, e - 1) && !Wie(t, e - 2) && (t = t.slice(0, -1)), t[0] === "/" ? t : `/${t}`;
}
function SOe(t) {
  let e = t.length;
  if (e < 2)
    return "";
  for (; --e > 1 && !Wie(t, e); )
    ;
  return t.slice(0, e);
}
function Wie(t, e) {
  if (t[e] === "/") {
    let n = 0;
    for (; e > 0 && t[--e] === "\\"; )
      ++n;
    if (!(n & 1))
      return !0;
  }
  return !1;
}
function adr(t, e) {
  return t.parent === e.parent ? 1 : 2;
}
function kW(t) {
  var e = t.children;
  return e ? e[0] : t.t;
}
function GW(t) {
  var e = t.children;
  return e ? e[e.length - 1] : t.t;
}
function Adr(t, e, n) {
  var r = n / (e.i - t.i);
  e.c -= r, e.s += n, t.c += r, e.z += n, e.m += n;
}
function ldr(t) {
  for (var e = 0, n = 0, r = t.children, i = r.length, o; --i >= 0; )
    o = r[i], o.z += e, o.m += e, e += o.s + (n += o.c);
}
function cdr(t, e, n) {
  return t.a.parent === e.parent ? t.a : n;
}
function s4(t, e) {
  this._ = t, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = e;
}
s4.prototype = Object.create(DQ.prototype);
function udr(t) {
  for (var e = new s4(t, 0), n, r = [e], i, o, s, a; n = r.pop(); )
    if (o = n._.children)
      for (n.children = new Array(a = o.length), s = a - 1; s >= 0; --s)
        r.push(i = n.children[s] = new s4(o[s], s)), i.parent = n;
  return (e.parent = new s4(null, 0)).children = [e], e;
}
function fdr() {
  var t = adr, e = 1, n = 1, r = null;
  function i(l) {
    var c = udr(l);
    if (c.eachAfter(o), c.parent.m = -c.z, c.eachBefore(s), r)
      l.eachBefore(A);
    else {
      var u = l, f = l, h = l;
      l.eachBefore(function(y) {
        y.x < u.x && (u = y), y.x > f.x && (f = y), y.depth > h.depth && (h = y);
      });
      var d = u === f ? 1 : t(u, f) / 2, I = d - u.x, m = e / (f.x + d + I), C = n / (h.depth || 1);
      l.eachBefore(function(y) {
        y.x = (y.x + I) * m, y.y = y.depth * C;
      });
    }
    return l;
  }
  function o(l) {
    var c = l.children, u = l.parent.children, f = l.i ? u[l.i - 1] : null;
    if (c) {
      ldr(l);
      var h = (c[0].z + c[c.length - 1].z) / 2;
      f ? (l.z = f.z + t(l._, f._), l.m = l.z - h) : l.z = h;
    } else
      f && (l.z = f.z + t(l._, f._));
    l.parent.A = a(l, f, l.parent.A || u[0]);
  }
  function s(l) {
    l._.x = l.z + l.parent.m, l.m += l.parent.m;
  }
  function a(l, c, u) {
    if (c) {
      for (var f = l, h = l, d = c, I = f.parent.children[0], m = f.m, C = h.m, y = d.m, v = I.m, b; d = GW(d), f = kW(f), d && f; )
        I = kW(I), h = GW(h), h.a = l, b = d.z + y - f.z - m + t(d._, f._), b > 0 && (Adr(cdr(d, l, u), l, b), m += b, C += b), y += d.m, m += f.m, v += I.m, C += h.m;
      d && !GW(h) && (h.t = d, h.m += y - C), f && !kW(I) && (I.t = f, I.m += m - v, u = l);
    }
    return u;
  }
  function A(l) {
    l.x *= e, l.y = l.depth * n;
  }
  return i.separation = function(l) {
    return arguments.length ? (t = l, i) : t;
  }, i.size = function(l) {
    return arguments.length ? (r = !1, e = +l[0], n = +l[1], i) : r ? null : [e, n];
  }, i.nodeSize = function(l) {
    return arguments.length ? (r = !0, e = +l[0], n = +l[1], i) : r ? [e, n] : null;
  }, i;
}
function Xj(t, e, n, r, i) {
  for (var o = t.children, s, a = -1, A = o.length, l = t.value && (i - n) / t.value; ++a < A; )
    s = o[a], s.x0 = e, s.x1 = r, s.y0 = n, s.y1 = n += s.value * l;
}
var not = (1 + Math.sqrt(5)) / 2;
function rot(t, e, n, r, i, o) {
  for (var s = [], a = e.children, A, l, c = 0, u = 0, f = a.length, h, d, I = e.value, m, C, y, v, b, Q, w; c < f; ) {
    h = i - n, d = o - r;
    do
      m = a[u++].value;
    while (!m && u < f);
    for (C = y = m, Q = Math.max(d / h, h / d) / (I * t), w = m * m * Q, b = Math.max(y / w, w / C); u < f; ++u) {
      if (m += l = a[u].value, l < C && (C = l), l > y && (y = l), w = m * m * Q, v = Math.max(y / w, w / C), v > b) {
        m -= l;
        break;
      }
      b = v;
    }
    s.push(A = { value: m, dice: h < d, children: a.slice(c, u) }), A.dice ? bO(A, n, r, i, I ? r += d * m / I : o) : Xj(A, n, r, I ? n += h * m / I : i, o), I -= m, c = u;
  }
  return s;
}
const iot = function t(e) {
  function n(r, i, o, s, a) {
    rot(e, r, i, o, s, a);
  }
  return n.ratio = function(r) {
    return t((r = +r) > 1 ? r : 1);
  }, n;
}(not);
function gdr() {
  var t = iot, e = !1, n = 1, r = 1, i = [0], o = tv, s = tv, a = tv, A = tv, l = tv;
  function c(f) {
    return f.x0 = f.y0 = 0, f.x1 = n, f.y1 = r, f.eachBefore(u), i = [0], e && f.eachBefore(tot), f;
  }
  function u(f) {
    var h = i[f.depth], d = f.x0 + h, I = f.y0 + h, m = f.x1 - h, C = f.y1 - h;
    m < d && (d = m = (d + m) / 2), C < I && (I = C = (I + C) / 2), f.x0 = d, f.y0 = I, f.x1 = m, f.y1 = C, f.children && (h = i[f.depth + 1] = o(f) / 2, d += l(f) - h, I += s(f) - h, m -= a(f) - h, C -= A(f) - h, m < d && (d = m = (d + m) / 2), C < I && (I = C = (I + C) / 2), t(f, d, I, m, C));
  }
  return c.round = function(f) {
    return arguments.length ? (e = !!f, c) : e;
  }, c.size = function(f) {
    return arguments.length ? (n = +f[0], r = +f[1], c) : [n, r];
  }, c.tile = function(f) {
    return arguments.length ? (t = Xit(f), c) : t;
  }, c.padding = function(f) {
    return arguments.length ? c.paddingInner(f).paddingOuter(f) : c.paddingInner();
  }, c.paddingInner = function(f) {
    return arguments.length ? (o = typeof f == "function" ? f : r_(+f), c) : o;
  }, c.paddingOuter = function(f) {
    return arguments.length ? c.paddingTop(f).paddingRight(f).paddingBottom(f).paddingLeft(f) : c.paddingTop();
  }, c.paddingTop = function(f) {
    return arguments.length ? (s = typeof f == "function" ? f : r_(+f), c) : s;
  }, c.paddingRight = function(f) {
    return arguments.length ? (a = typeof f == "function" ? f : r_(+f), c) : a;
  }, c.paddingBottom = function(f) {
    return arguments.length ? (A = typeof f == "function" ? f : r_(+f), c) : A;
  }, c.paddingLeft = function(f) {
    return arguments.length ? (l = typeof f == "function" ? f : r_(+f), c) : l;
  }, c;
}
function hdr(t, e, n, r, i) {
  var o = t.children, s, a = o.length, A, l = new Array(a + 1);
  for (l[0] = A = s = 0; s < a; ++s)
    l[s + 1] = A += o[s].value;
  c(0, a, t.value, e, n, r, i);
  function c(u, f, h, d, I, m, C) {
    if (u >= f - 1) {
      var y = o[u];
      y.x0 = d, y.y0 = I, y.x1 = m, y.y1 = C;
      return;
    }
    for (var v = l[u], b = h / 2 + v, Q = u + 1, w = f - 1; Q < w; ) {
      var R = Q + w >>> 1;
      l[R] < b ? Q = R + 1 : w = R;
    }
    b - l[Q - 1] < l[Q] - b && u + 1 < Q && --Q;
    var M = l[Q] - v, O = h - M;
    if (m - d > C - I) {
      var L = h ? (d * O + m * M) / h : m;
      c(u, Q, M, d, I, L, C), c(Q, f, O, L, I, m, C);
    } else {
      var N = h ? (I * O + C * M) / h : C;
      c(u, Q, M, d, I, m, N), c(Q, f, O, d, N, m, C);
    }
  }
}
function ddr(t, e, n, r, i) {
  (t.depth & 1 ? Xj : bO)(t, e, n, r, i);
}
const pdr = function t(e) {
  function n(r, i, o, s, a) {
    if ((A = r._squarify) && A.ratio === e)
      for (var A, l, c, u, f = -1, h, d = A.length, I = r.value; ++f < d; ) {
        for (l = A[f], c = l.children, u = l.value = 0, h = c.length; u < h; ++u)
          l.value += c[u].value;
        l.dice ? bO(l, i, o, s, I ? o += (a - o) * l.value / I : a) : Xj(l, i, o, I ? i += (s - i) * l.value / I : s, a), I -= l.value;
      }
    else
      r._squarify = A = rot(e, r, i, o, s, a), A.ratio = e;
  }
  return n.ratio = function(r) {
    return t((r = +r) > 1 ? r : 1);
  }, n;
}(not);
function Xie(t, e, n) {
  const r = {};
  return t.each((i) => {
    const o = i.data;
    n(o) && (r[e(o)] = i);
  }), t.lookup = r, t;
}
function gpe(t) {
  yt.call(this, null, t);
}
gpe.Definition = {
  type: "Nest",
  metadata: {
    treesource: !0,
    changes: !0
  },
  params: [{
    name: "keys",
    type: "field",
    array: !0
  }, {
    name: "generate",
    type: "boolean"
  }]
};
const Idr = (t) => t.values;
on(gpe, yt, {
  transform(t, e) {
    e.source || wt("Nest transform requires an upstream data source.");
    var n = t.generate, r = t.modified(), i = e.clone(), o = this.value;
    return (!o || r || e.changed()) && (o && o.each((s) => {
      s.children && hj(s.data) && i.rem.push(s.data);
    }), this.value = o = fpe({
      values: bn(t.keys).reduce((s, a) => (s.key(a), s), mdr()).entries(i.source)
    }, Idr), n && o.each((s) => {
      s.children && (s = so(s.data), i.add.push(s), i.source.push(s));
    }), Xie(o, tr, tr)), i.source.root = o, i;
  }
});
function mdr() {
  const t = [], e = {
    entries: (i) => r(n(i, 0), 0),
    key: (i) => (t.push(i), e)
  };
  function n(i, o) {
    if (o >= t.length)
      return i;
    const s = i.length, a = t[o++], A = {}, l = {};
    let c = -1, u, f, h;
    for (; ++c < s; )
      u = a(f = i[c]) + "", (h = A[u]) ? h.push(f) : A[u] = [f];
    for (u in A)
      l[u] = n(A[u], o);
    return l;
  }
  function r(i, o) {
    if (++o > t.length)
      return i;
    const s = [];
    for (const a in i)
      s.push({
        key: a,
        values: r(i[a], o)
      });
    return s;
  }
  return e;
}
function am(t) {
  yt.call(this, null, t);
}
const Cdr = (t, e) => t.parent === e.parent ? 1 : 2;
on(am, yt, {
  transform(t, e) {
    (!e.source || !e.source.root) && wt(this.constructor.name + " transform requires a backing tree data source.");
    const n = this.layout(t.method), r = this.fields, i = e.source.root, o = t.as || r;
    t.field ? i.sum(t.field) : i.count(), t.sort && i.sort(B1(t.sort, (s) => s.data)), Edr(n, this.params, t), n.separation && n.separation(t.separation !== !1 ? Cdr : ux);
    try {
      this.value = n(i);
    } catch (s) {
      wt(s);
    }
    return i.each((s) => ydr(s, r, o)), e.reflow(t.modified()).modifies(o).modifies("leaf");
  }
});
function Edr(t, e, n) {
  for (let r, i = 0, o = e.length; i < o; ++i)
    r = e[i], r in n && t[r](n[r]);
}
function ydr(t, e, n) {
  const r = t.data, i = e.length - 1;
  for (let o = 0; o < i; ++o)
    r[n[o]] = t[e[o]];
  r[n[i]] = t.children ? t.children.length : 0;
}
const Zie = ["x", "y", "r", "depth", "children"];
function hpe(t) {
  am.call(this, t);
}
hpe.Definition = {
  type: "Pack",
  metadata: {
    tree: !0,
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "sort",
    type: "compare"
  }, {
    name: "padding",
    type: "number",
    default: 0
  }, {
    name: "radius",
    type: "field",
    default: null
  }, {
    name: "size",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: Zie.length,
    default: Zie
  }]
};
on(hpe, am, {
  layout: tdr,
  params: ["radius", "size", "padding"],
  fields: Zie
});
const eoe = ["x0", "y0", "x1", "y1", "depth", "children"];
function dpe(t) {
  am.call(this, t);
}
dpe.Definition = {
  type: "Partition",
  metadata: {
    tree: !0,
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "sort",
    type: "compare"
  }, {
    name: "padding",
    type: "number",
    default: 0
  }, {
    name: "round",
    type: "boolean",
    default: !1
  }, {
    name: "size",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: eoe.length,
    default: eoe
  }]
};
on(dpe, am, {
  layout: ndr,
  params: ["size", "round", "padding"],
  fields: eoe
});
function ppe(t) {
  yt.call(this, null, t);
}
ppe.Definition = {
  type: "Stratify",
  metadata: {
    treesource: !0
  },
  params: [{
    name: "key",
    type: "field",
    required: !0
  }, {
    name: "parentKey",
    type: "field",
    required: !0
  }]
};
on(ppe, yt, {
  transform(t, e) {
    e.source || wt("Stratify transform requires an upstream data source.");
    let n = this.value;
    const r = t.modified(), i = e.fork(e.ALL).materialize(e.SOURCE), o = !n || r || e.changed(e.ADD_REM) || e.modified(t.key.fields) || e.modified(t.parentKey.fields);
    return i.source = i.source.slice(), o && (n = i.source.length ? Xie(_Oe().id(t.key).parentId(t.parentKey)(i.source), t.key, qg) : Xie(_Oe()([{}]), t.key, t.key)), i.source.root = this.value = n, i;
  }
});
const QOe = {
  tidy: fdr,
  cluster: bhr
}, toe = ["x", "y", "depth", "children"];
function Ipe(t) {
  am.call(this, t);
}
Ipe.Definition = {
  type: "Tree",
  metadata: {
    tree: !0,
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "sort",
    type: "compare"
  }, {
    name: "method",
    type: "enum",
    default: "tidy",
    values: ["tidy", "cluster"]
  }, {
    name: "size",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "nodeSize",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "separation",
    type: "boolean",
    default: !0
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: toe.length,
    default: toe
  }]
};
on(Ipe, am, {
  /**
   * Tree layout generator. Supports both 'tidy' and 'cluster' layouts.
   */
  layout(t) {
    const e = t || "tidy";
    if (Kn(QOe, e))
      return QOe[e]();
    wt("Unrecognized Tree layout method: " + e);
  },
  params: ["size", "nodeSize"],
  fields: toe
});
function mpe(t) {
  yt.call(this, [], t);
}
mpe.Definition = {
  type: "TreeLinks",
  metadata: {
    tree: !0,
    generates: !0,
    changes: !0
  },
  params: []
};
on(mpe, yt, {
  transform(t, e) {
    const n = this.value, r = e.source && e.source.root, i = e.fork(e.NO_SOURCE), o = {};
    return r || wt("TreeLinks transform requires a tree data source."), e.changed(e.ADD_REM) ? (i.rem = n, e.visit(e.SOURCE, (s) => o[tr(s)] = 1), r.each((s) => {
      const a = s.data, A = s.parent && s.parent.data;
      A && o[tr(a)] && o[tr(A)] && i.add.push(so({
        source: A,
        target: a
      }));
    }), this.value = i.add) : e.changed(e.MOD) && (e.visit(e.MOD, (s) => o[tr(s)] = 1), n.forEach((s) => {
      (o[tr(s.source)] || o[tr(s.target)]) && i.mod.push(s);
    })), i;
  }
});
const wOe = {
  binary: hdr,
  dice: bO,
  slice: Xj,
  slicedice: ddr,
  squarify: iot,
  resquarify: pdr
}, noe = ["x0", "y0", "x1", "y1", "depth", "children"];
function Cpe(t) {
  am.call(this, t);
}
Cpe.Definition = {
  type: "Treemap",
  metadata: {
    tree: !0,
    modifies: !0
  },
  params: [{
    name: "field",
    type: "field"
  }, {
    name: "sort",
    type: "compare"
  }, {
    name: "method",
    type: "enum",
    default: "squarify",
    values: ["squarify", "resquarify", "binary", "dice", "slice", "slicedice"]
  }, {
    name: "padding",
    type: "number",
    default: 0
  }, {
    name: "paddingInner",
    type: "number",
    default: 0
  }, {
    name: "paddingOuter",
    type: "number",
    default: 0
  }, {
    name: "paddingTop",
    type: "number",
    default: 0
  }, {
    name: "paddingRight",
    type: "number",
    default: 0
  }, {
    name: "paddingBottom",
    type: "number",
    default: 0
  }, {
    name: "paddingLeft",
    type: "number",
    default: 0
  }, {
    name: "ratio",
    type: "number",
    default: 1.618033988749895
  }, {
    name: "round",
    type: "boolean",
    default: !1
  }, {
    name: "size",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: noe.length,
    default: noe
  }]
};
on(Cpe, am, {
  /**
   * Treemap layout generator. Adds 'method' and 'ratio' parameters
   * to configure the underlying tile method.
   */
  layout() {
    const t = gdr();
    return t.ratio = (e) => {
      const n = t.tile();
      n.ratio && t.tile(n.ratio(e));
    }, t.method = (e) => {
      Kn(wOe, e) ? t.tile(wOe[e]) : wt("Unrecognized Treemap layout method: " + e);
    }, t;
  },
  params: ["method", "ratio", "size", "round", "padding", "paddingInner", "paddingOuter", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"],
  fields: noe
});
const vdr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  nest: gpe,
  pack: hpe,
  partition: dpe,
  stratify: ppe,
  tree: Ipe,
  treelinks: mpe,
  treemap: Cpe
}, Symbol.toStringTag, { value: "Module" })), UW = 4278190080;
function Bdr(t, e) {
  const n = t.bitmap();
  return (e || []).forEach((r) => n.set(t(r.boundary[0]), t(r.boundary[3]))), [n, void 0];
}
function bdr(t, e, n, r, i) {
  const o = t.width, s = t.height, a = r || i, A = PC(o, s).getContext("2d"), l = PC(o, s).getContext("2d"), c = a && PC(o, s).getContext("2d");
  n.forEach((M) => a4(A, M, !1)), a4(l, e, !1), a && a4(c, e, !0);
  const u = HW(A, o, s), f = HW(l, o, s), h = a && HW(c, o, s), d = t.bitmap(), I = a && t.bitmap();
  let m, C, y, v, b, Q, w, R;
  for (C = 0; C < s; ++C)
    for (m = 0; m < o; ++m)
      b = C * o + m, Q = u[b] & UW, R = f[b] & UW, w = a && h[b] & UW, (Q || w || R) && (y = t(m), v = t(C), !i && (Q || R) && d.set(y, v), a && (Q || w) && I.set(y, v));
  return [d, I];
}
function HW(t, e, n) {
  return new Uint32Array(t.getImageData(0, 0, e, n).data.buffer);
}
function a4(t, e, n) {
  if (!e.length)
    return;
  const r = e[0].mark.marktype;
  r === "group" ? e.forEach((i) => {
    i.items.forEach((o) => a4(t, o.items, n));
  }) : Hf[r].draw(t, {
    items: n ? e.map(_dr) : e
  });
}
function _dr(t) {
  const e = dj(t, {});
  return e.stroke && e.strokeOpacity !== 0 || e.fill && e.fillOpacity !== 0 ? {
    ...e,
    strokeOpacity: 1,
    stroke: "#000",
    fillOpacity: 0
  } : e;
}
const G0 = 5, Sc = 31, DN = 32, Xm = new Uint32Array(DN + 1), Lh = new Uint32Array(DN + 1);
Lh[0] = 0;
Xm[0] = ~Lh[0];
for (let t = 1; t <= DN; ++t)
  Lh[t] = Lh[t - 1] << 1 | 1, Xm[t] = ~Lh[t];
function Sdr(t, e) {
  const n = new Uint32Array(~~((t * e + DN) / DN));
  function r(o, s) {
    n[o] |= s;
  }
  function i(o, s) {
    n[o] &= s;
  }
  return {
    array: n,
    get: (o, s) => {
      const a = s * t + o;
      return n[a >>> G0] & 1 << (a & Sc);
    },
    set: (o, s) => {
      const a = s * t + o;
      r(a >>> G0, 1 << (a & Sc));
    },
    clear: (o, s) => {
      const a = s * t + o;
      i(a >>> G0, ~(1 << (a & Sc)));
    },
    getRange: (o, s, a, A) => {
      let l = A, c, u, f, h;
      for (; l >= s; --l)
        if (c = l * t + o, u = l * t + a, f = c >>> G0, h = u >>> G0, f === h) {
          if (n[f] & Xm[c & Sc] & Lh[(u & Sc) + 1])
            return !0;
        } else {
          if (n[f] & Xm[c & Sc] || n[h] & Lh[(u & Sc) + 1])
            return !0;
          for (let d = f + 1; d < h; ++d)
            if (n[d])
              return !0;
        }
      return !1;
    },
    setRange: (o, s, a, A) => {
      let l, c, u, f, h;
      for (; s <= A; ++s)
        if (l = s * t + o, c = s * t + a, u = l >>> G0, f = c >>> G0, u === f)
          r(u, Xm[l & Sc] & Lh[(c & Sc) + 1]);
        else
          for (r(u, Xm[l & Sc]), r(f, Lh[(c & Sc) + 1]), h = u + 1; h < f; ++h)
            r(h, 4294967295);
    },
    clearRange: (o, s, a, A) => {
      let l, c, u, f, h;
      for (; s <= A; ++s)
        if (l = s * t + o, c = s * t + a, u = l >>> G0, f = c >>> G0, u === f)
          i(u, Lh[l & Sc] | Xm[(c & Sc) + 1]);
        else
          for (i(u, Lh[l & Sc]), i(f, Xm[(c & Sc) + 1]), h = u + 1; h < f; ++h)
            i(h, 0);
    },
    outOfBounds: (o, s, a, A) => o < 0 || s < 0 || A >= e || a >= t
  };
}
function Qdr(t, e, n) {
  const r = Math.max(1, Math.sqrt(t * e / 1e6)), i = ~~((t + 2 * n + r) / r), o = ~~((e + 2 * n + r) / r), s = (a) => ~~((a + n) / r);
  return s.invert = (a) => a * r - n, s.bitmap = () => Sdr(i, o), s.ratio = r, s.padding = n, s.width = t, s.height = e, s;
}
function wdr(t, e, n, r) {
  const i = t.width, o = t.height;
  return function(s) {
    const a = s.datum.datum.items[r].items, A = a.length, l = s.datum.fontSize, c = od.width(s.datum, s.datum.text);
    let u = 0, f, h, d, I, m, C, y;
    for (let v = 0; v < A; ++v)
      f = a[v].x, d = a[v].y, h = a[v].x2 === void 0 ? f : a[v].x2, I = a[v].y2 === void 0 ? d : a[v].y2, m = (f + h) / 2, C = (d + I) / 2, y = Math.abs(h - f + I - d), y >= u && (u = y, s.x = m, s.y = C);
    return m = c / 2, C = l / 2, f = s.x - m, h = s.x + m, d = s.y - C, I = s.y + C, s.align = "center", f < 0 && h <= i ? s.align = "left" : 0 <= f && i < h && (s.align = "right"), s.baseline = "middle", d < 0 && I <= o ? s.baseline = "top" : 0 <= d && o < I && (s.baseline = "bottom"), !0;
  };
}
function v6(t, e, n, r, i, o) {
  let s = n / 2;
  return t - s < 0 || t + s > i || e - (s = r / 2) < 0 || e + s > o;
}
function BC(t, e, n, r, i, o, s, a) {
  const A = i * o / (r * 2), l = t(e - A), c = t(e + A), u = t(n - (o = o / 2)), f = t(n + o);
  return s.outOfBounds(l, u, c, f) || s.getRange(l, u, c, f) || a && a.getRange(l, u, c, f);
}
function xdr(t, e, n, r) {
  const i = t.width, o = t.height, s = e[0], a = e[1];
  function A(l, c, u, f, h) {
    const d = t.invert(l), I = t.invert(c);
    let m = u, C = o, y;
    if (!v6(d, I, f, h, i, o) && !BC(t, d, I, h, f, m, s, a) && !BC(t, d, I, h, f, h, s, null)) {
      for (; C - m >= 1; )
        y = (m + C) / 2, BC(t, d, I, h, f, y, s, a) ? C = y : m = y;
      if (m > u)
        return [d, I, m, !0];
    }
  }
  return function(l) {
    const c = l.datum.datum.items[r].items, u = c.length, f = l.datum.fontSize, h = od.width(l.datum, l.datum.text);
    let d = n ? f : 0, I = !1, m = !1, C = 0, y, v, b, Q, w, R, M, O, L, N, k, $, U, X, K, z, Y;
    for (let V = 0; V < u; ++V) {
      for (y = c[V].x, b = c[V].y, v = c[V].x2 === void 0 ? y : c[V].x2, Q = c[V].y2 === void 0 ? b : c[V].y2, y > v && (Y = y, y = v, v = Y), b > Q && (Y = b, b = Q, Q = Y), L = t(y), k = t(v), N = ~~((L + k) / 2), $ = t(b), X = t(Q), U = ~~(($ + X) / 2), M = N; M >= L; --M)
        for (O = U; O >= $; --O)
          z = A(M, O, d, h, f), z && ([l.x, l.y, d, I] = z);
      for (M = N; M <= k; ++M)
        for (O = U; O <= X; ++O)
          z = A(M, O, d, h, f), z && ([l.x, l.y, d, I] = z);
      !I && !n && (K = Math.abs(v - y + Q - b), w = (y + v) / 2, R = (b + Q) / 2, K >= C && !v6(w, R, h, f, i, o) && !BC(t, w, R, f, h, f, s, null) && (C = K, l.x = w, l.y = R, m = !0));
    }
    return I || m ? (w = h / 2, R = f / 2, s.setRange(t(l.x - w), t(l.y - R), t(l.x + w), t(l.y + R)), l.align = "center", l.baseline = "middle", !0) : !1;
  };
}
const Rdr = [-1, -1, 1, 1], Ddr = [-1, 1, -1, 1];
function Tdr(t, e, n, r) {
  const i = t.width, o = t.height, s = e[0], a = e[1], A = t.bitmap();
  return function(l) {
    const c = l.datum.datum.items[r].items, u = c.length, f = l.datum.fontSize, h = od.width(l.datum, l.datum.text), d = [];
    let I = n ? f : 0, m = !1, C = !1, y = 0, v, b, Q, w, R, M, O, L, N, k, $, U;
    for (let X = 0; X < u; ++X) {
      for (v = c[X].x, Q = c[X].y, b = c[X].x2 === void 0 ? v : c[X].x2, w = c[X].y2 === void 0 ? Q : c[X].y2, d.push([t((v + b) / 2), t((Q + w) / 2)]); d.length; )
        if ([O, L] = d.pop(), !(s.get(O, L) || a.get(O, L) || A.get(O, L))) {
          A.set(O, L);
          for (let K = 0; K < 4; ++K)
            R = O + Rdr[K], M = L + Ddr[K], A.outOfBounds(R, M, R, M) || d.push([R, M]);
          if (R = t.invert(O), M = t.invert(L), N = I, k = o, !v6(R, M, h, f, i, o) && !BC(t, R, M, f, h, N, s, a) && !BC(t, R, M, f, h, f, s, null)) {
            for (; k - N >= 1; )
              $ = (N + k) / 2, BC(t, R, M, f, h, $, s, a) ? k = $ : N = $;
            N > I && (l.x = R, l.y = M, I = N, m = !0);
          }
        }
      !m && !n && (U = Math.abs(b - v + w - Q), R = (v + b) / 2, M = (Q + w) / 2, U >= y && !v6(R, M, h, f, i, o) && !BC(t, R, M, f, h, f, s, null) && (y = U, l.x = R, l.y = M, C = !0));
    }
    return m || C ? (R = h / 2, M = f / 2, s.setRange(t(l.x - R), t(l.y - M), t(l.x + R), t(l.y + M)), l.align = "center", l.baseline = "middle", !0) : !1;
  };
}
const Ndr = ["right", "center", "left"], Ldr = ["bottom", "middle", "top"];
function Mdr(t, e, n, r) {
  const i = t.width, o = t.height, s = e[0], a = e[1], A = r.length;
  return function(l) {
    var c;
    const u = l.boundary, f = l.datum.fontSize;
    if (u[2] < 0 || u[5] < 0 || u[0] > i || u[3] > o)
      return !1;
    let h = (c = l.textWidth) !== null && c !== void 0 ? c : 0, d, I, m, C, y, v, b, Q, w, R, M, O, L, N, k;
    for (let $ = 0; $ < A; ++$) {
      if (d = (n[$] & 3) - 1, I = (n[$] >>> 2 & 3) - 1, m = d === 0 && I === 0 || r[$] < 0, C = d && I ? Math.SQRT1_2 : 1, y = r[$] < 0 ? -1 : 1, v = u[1 + d] + r[$] * d * C, M = u[4 + I] + y * f * I / 2 + r[$] * I * C, Q = M - f / 2, w = M + f / 2, O = t(v), N = t(Q), k = t(w), !h)
        if (xOe(O, O, N, k, s, a, v, v, Q, w, u, m))
          h = od.width(l.datum, l.datum.text);
        else
          continue;
      if (R = v + y * h * d / 2, v = R - h / 2, b = R + h / 2, O = t(v), L = t(b), xOe(O, L, N, k, s, a, v, b, Q, w, u, m))
        return l.x = d ? d * y < 0 ? b : v : R, l.y = I ? I * y < 0 ? w : Q : M, l.align = Ndr[d * y + 1], l.baseline = Ldr[I * y + 1], s.setRange(O, N, L, k), !0;
    }
    return !1;
  };
}
function xOe(t, e, n, r, i, o, s, a, A, l, c, u) {
  return !(i.outOfBounds(t, n, e, r) || (u && o || i).getRange(t, n, e, r));
}
const $W = 0, qW = 4, jW = 8, YW = 0, zW = 1, VW = 2, Odr = {
  "top-left": $W + YW,
  top: $W + zW,
  "top-right": $W + VW,
  left: qW + YW,
  middle: qW + zW,
  right: qW + VW,
  "bottom-left": jW + YW,
  bottom: jW + zW,
  "bottom-right": jW + VW
}, Fdr = {
  naive: wdr,
  "reduced-search": xdr,
  floodfill: Tdr
};
function Pdr(t, e, n, r, i, o, s, a, A, l, c) {
  if (!t.length)
    return t;
  const u = Math.max(r.length, i.length), f = kdr(r, u), h = Gdr(i, u), d = Udr(t[0].datum), I = d === "group" && t[0].datum.items[A].marktype, m = I === "area", C = Hdr(d, I, a, A), y = l === null || l === 1 / 0, v = m && c === "naive";
  let b = -1, Q = -1;
  const w = t.map((L) => {
    const N = y ? od.width(L, L.text) : void 0;
    return b = Math.max(b, N), Q = Math.max(Q, L.fontSize), {
      datum: L,
      opacity: 0,
      x: void 0,
      y: void 0,
      align: void 0,
      baseline: void 0,
      boundary: C(L),
      textWidth: N
    };
  });
  l = l === null || l === 1 / 0 ? Math.max(b, Q) + Math.max(...r) : l;
  const R = Qdr(e[0], e[1], l);
  let M;
  if (!v) {
    n && w.sort((k, $) => n(k.datum, $.datum));
    let L = !1;
    for (let k = 0; k < h.length && !L; ++k)
      L = h[k] === 5 || f[k] < 0;
    const N = (d && s || m) && t.map((k) => k.datum);
    M = o.length || N ? bdr(R, N || [], o, L, m) : Bdr(R, s && w);
  }
  const O = m ? Fdr[c](R, M, s, A) : Mdr(R, M, h, f);
  return w.forEach((L) => L.opacity = +O(L)), w;
}
function kdr(t, e) {
  const n = new Float64Array(e), r = t.length;
  for (let i = 0; i < r; ++i)
    n[i] = t[i] || 0;
  for (let i = r; i < e; ++i)
    n[i] = n[r - 1];
  return n;
}
function Gdr(t, e) {
  const n = new Int8Array(e), r = t.length;
  for (let i = 0; i < r; ++i)
    n[i] |= Odr[t[i]];
  for (let i = r; i < e; ++i)
    n[i] = n[r - 1];
  return n;
}
function Udr(t) {
  return t && t.mark && t.mark.marktype;
}
function Hdr(t, e, n, r) {
  const i = (o) => [o.x, o.x, o.x, o.y, o.y, o.y];
  return t ? t === "line" || t === "area" ? (o) => i(o.datum) : e === "line" ? (o) => {
    const s = o.datum.items[r].items;
    return i(s.length ? s[n === "start" ? 0 : s.length - 1] : {
      x: NaN,
      y: NaN
    });
  } : (o) => {
    const s = o.datum.bounds;
    return [s.x1, (s.x1 + s.x2) / 2, s.x2, s.y1, (s.y1 + s.y2) / 2, s.y2];
  } : i;
}
const roe = ["x", "y", "opacity", "align", "baseline"], oot = ["top-left", "left", "bottom-left", "top", "bottom", "top-right", "right", "bottom-right"];
function Epe(t) {
  yt.call(this, null, t);
}
Epe.Definition = {
  type: "Label",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "size",
    type: "number",
    array: !0,
    length: 2,
    required: !0
  }, {
    name: "sort",
    type: "compare"
  }, {
    name: "anchor",
    type: "string",
    array: !0,
    default: oot
  }, {
    name: "offset",
    type: "number",
    array: !0,
    default: [1]
  }, {
    name: "padding",
    type: "number",
    default: 0,
    null: !0
  }, {
    name: "lineAnchor",
    type: "string",
    values: ["start", "end"],
    default: "end"
  }, {
    name: "markIndex",
    type: "number",
    default: 0
  }, {
    name: "avoidBaseMark",
    type: "boolean",
    default: !0
  }, {
    name: "avoidMarks",
    type: "data",
    array: !0
  }, {
    name: "method",
    type: "string",
    default: "naive"
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: roe.length,
    default: roe
  }]
};
on(Epe, yt, {
  transform(t, e) {
    function n(o) {
      const s = t[o];
      return ri(s) && e.modified(s.fields);
    }
    const r = t.modified();
    if (!(r || e.changed(e.ADD_REM) || n("sort")))
      return;
    (!t.size || t.size.length !== 2) && wt("Size parameter should be specified as a [width, height] array.");
    const i = t.as || roe;
    return Pdr(e.materialize(e.SOURCE).source || [], t.size, t.sort, bn(t.offset == null ? 1 : t.offset), bn(t.anchor || oot), t.avoidMarks || [], t.avoidBaseMark !== !1, t.lineAnchor || "end", t.markIndex || 0, t.padding === void 0 ? 0 : t.padding, t.method || "naive").forEach((o) => {
      const s = o.datum;
      s[i[0]] = o.x, s[i[1]] = o.y, s[i[2]] = o.opacity, s[i[3]] = o.align, s[i[4]] = o.baseline;
    }), e.reflow(r).modifies(i);
  }
});
const $dr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  label: Epe
}, Symbol.toStringTag, { value: "Module" }));
function sot(t, e) {
  var n = [], r = function(c) {
    return c(a);
  }, i, o, s, a, A, l;
  if (e == null)
    n.push(t);
  else
    for (i = {}, o = 0, s = t.length; o < s; ++o)
      a = t[o], A = e.map(r), l = i[A], l || (i[A] = l = [], l.dims = A, n.push(l)), l.push(a);
  return n;
}
function ype(t) {
  yt.call(this, null, t);
}
ype.Definition = {
  type: "Loess",
  metadata: {
    generates: !0
  },
  params: [{
    name: "x",
    type: "field",
    required: !0
  }, {
    name: "y",
    type: "field",
    required: !0
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "bandwidth",
    type: "number",
    default: 0.3
  }, {
    name: "as",
    type: "string",
    array: !0
  }]
};
on(ype, yt, {
  transform(t, e) {
    const n = e.fork(e.NO_SOURCE | e.NO_FIELDS);
    if (!this.value || e.changed() || t.modified()) {
      const r = e.materialize(e.SOURCE).source, i = sot(r, t.groupby), o = (t.groupby || []).map(pa), s = o.length, a = t.as || [pa(t.x), pa(t.y)], A = [];
      i.forEach((l) => {
        bet(l, t.x, t.y, t.bandwidth || 0.3).forEach((c) => {
          const u = {};
          for (let f = 0; f < s; ++f)
            u[o[f]] = l.dims[f];
          u[a[0]] = c[0], u[a[1]] = c[1], A.push(so(u));
        });
      }), this.value && (n.rem = this.value), this.value = n.add = n.source = A;
    }
    return n;
  }
});
const ioe = {
  linear: the,
  log: Eet,
  exp: yet,
  pow: vet,
  quad: nhe,
  poly: Bet
}, qdr = (t, e) => t === "poly" ? e : t === "quad" ? 2 : 1;
function vpe(t) {
  yt.call(this, null, t);
}
vpe.Definition = {
  type: "Regression",
  metadata: {
    generates: !0
  },
  params: [{
    name: "x",
    type: "field",
    required: !0
  }, {
    name: "y",
    type: "field",
    required: !0
  }, {
    name: "groupby",
    type: "field",
    array: !0
  }, {
    name: "method",
    type: "string",
    default: "linear",
    values: Object.keys(ioe)
  }, {
    name: "order",
    type: "number",
    default: 3
  }, {
    name: "extent",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "params",
    type: "boolean",
    default: !1
  }, {
    name: "as",
    type: "string",
    array: !0
  }]
};
on(vpe, yt, {
  transform(t, e) {
    const n = e.fork(e.NO_SOURCE | e.NO_FIELDS);
    if (!this.value || e.changed() || t.modified()) {
      const r = e.materialize(e.SOURCE).source, i = sot(r, t.groupby), o = (t.groupby || []).map(pa), s = t.method || "linear", a = t.order || 3, A = qdr(s, a), l = t.as || [pa(t.x), pa(t.y)], c = ioe[s], u = [];
      let f = t.extent;
      Kn(ioe, s) || wt("Invalid regression method: " + s), f != null && s === "log" && f[0] <= 0 && (e.dataflow.warn("Ignoring extent with values <= 0 for log regression."), f = null), i.forEach((h) => {
        if (h.length <= A) {
          e.dataflow.warn("Skipping regression with more parameters than data points.");
          return;
        }
        const I = c(h, t.x, t.y, a);
        if (t.params) {
          u.push(so({
            keys: h.dims,
            coef: I.coef,
            rSquared: I.rSquared
          }));
          return;
        }
        const m = f || Jp(h, t.x), C = (y) => {
          const v = {};
          for (let b = 0; b < o.length; ++b)
            v[o[b]] = h.dims[b];
          v[l[0]] = y[0], v[l[1]] = y[1], u.push(so(v));
        };
        s === "linear" ? m.forEach((y) => C([y, I.predict(y)])) : vj(I.predict, m, 25, 200).forEach(C);
      }), this.value && (n.rem = this.value), this.value = n.add = n.source = u;
    }
    return n;
  }
});
const jdr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  loess: ype,
  regression: vpe
}, Symbol.toStringTag, { value: "Module" })), yI = 11102230246251565e-32, Tl = 134217729, Ydr = (3 + 8 * yI) * yI;
function JW(t, e, n, r, i) {
  let o, s, a, A, l = e[0], c = r[0], u = 0, f = 0;
  c > l == c > -l ? (o = l, l = e[++u]) : (o = c, c = r[++f]);
  let h = 0;
  if (u < t && f < n)
    for (c > l == c > -l ? (s = l + o, a = o - (s - l), l = e[++u]) : (s = c + o, a = o - (s - c), c = r[++f]), o = s, a !== 0 && (i[h++] = a); u < t && f < n; )
      c > l == c > -l ? (s = o + l, A = s - o, a = o - (s - A) + (l - A), l = e[++u]) : (s = o + c, A = s - o, a = o - (s - A) + (c - A), c = r[++f]), o = s, a !== 0 && (i[h++] = a);
  for (; u < t; )
    s = o + l, A = s - o, a = o - (s - A) + (l - A), l = e[++u], o = s, a !== 0 && (i[h++] = a);
  for (; f < n; )
    s = o + c, A = s - o, a = o - (s - A) + (c - A), c = r[++f], o = s, a !== 0 && (i[h++] = a);
  return (o !== 0 || h === 0) && (i[h++] = o), h;
}
function zdr(t, e) {
  let n = e[0];
  for (let r = 1; r < t; r++)
    n += e[r];
  return n;
}
function _O(t) {
  return new Float64Array(t);
}
const Vdr = (3 + 16 * yI) * yI, Jdr = (2 + 12 * yI) * yI, Kdr = (9 + 64 * yI) * yI * yI, Lb = _O(4), ROe = _O(8), DOe = _O(12), TOe = _O(16), Qc = _O(4);
function Wdr(t, e, n, r, i, o, s) {
  let a, A, l, c, u, f, h, d, I, m, C, y, v, b, Q, w, R, M;
  const O = t - i, L = n - i, N = e - o, k = r - o;
  b = O * k, f = Tl * O, h = f - (f - O), d = O - h, f = Tl * k, I = f - (f - k), m = k - I, Q = d * m - (b - h * I - d * I - h * m), w = N * L, f = Tl * N, h = f - (f - N), d = N - h, f = Tl * L, I = f - (f - L), m = L - I, R = d * m - (w - h * I - d * I - h * m), C = Q - R, u = Q - C, Lb[0] = Q - (C + u) + (u - R), y = b + C, u = y - b, v = b - (y - u) + (C - u), C = v - w, u = v - C, Lb[1] = v - (C + u) + (u - w), M = y + C, u = M - y, Lb[2] = y - (M - u) + (C - u), Lb[3] = M;
  let $ = zdr(4, Lb), U = Jdr * s;
  if ($ >= U || -$ >= U || (u = t - O, a = t - (O + u) + (u - i), u = n - L, l = n - (L + u) + (u - i), u = e - N, A = e - (N + u) + (u - o), u = r - k, c = r - (k + u) + (u - o), a === 0 && A === 0 && l === 0 && c === 0) || (U = Kdr * s + Ydr * Math.abs($), $ += O * c + k * a - (N * l + L * A), $ >= U || -$ >= U))
    return $;
  b = a * k, f = Tl * a, h = f - (f - a), d = a - h, f = Tl * k, I = f - (f - k), m = k - I, Q = d * m - (b - h * I - d * I - h * m), w = A * L, f = Tl * A, h = f - (f - A), d = A - h, f = Tl * L, I = f - (f - L), m = L - I, R = d * m - (w - h * I - d * I - h * m), C = Q - R, u = Q - C, Qc[0] = Q - (C + u) + (u - R), y = b + C, u = y - b, v = b - (y - u) + (C - u), C = v - w, u = v - C, Qc[1] = v - (C + u) + (u - w), M = y + C, u = M - y, Qc[2] = y - (M - u) + (C - u), Qc[3] = M;
  const X = JW(4, Lb, 4, Qc, ROe);
  b = O * c, f = Tl * O, h = f - (f - O), d = O - h, f = Tl * c, I = f - (f - c), m = c - I, Q = d * m - (b - h * I - d * I - h * m), w = N * l, f = Tl * N, h = f - (f - N), d = N - h, f = Tl * l, I = f - (f - l), m = l - I, R = d * m - (w - h * I - d * I - h * m), C = Q - R, u = Q - C, Qc[0] = Q - (C + u) + (u - R), y = b + C, u = y - b, v = b - (y - u) + (C - u), C = v - w, u = v - C, Qc[1] = v - (C + u) + (u - w), M = y + C, u = M - y, Qc[2] = y - (M - u) + (C - u), Qc[3] = M;
  const K = JW(X, ROe, 4, Qc, DOe);
  b = a * c, f = Tl * a, h = f - (f - a), d = a - h, f = Tl * c, I = f - (f - c), m = c - I, Q = d * m - (b - h * I - d * I - h * m), w = A * l, f = Tl * A, h = f - (f - A), d = A - h, f = Tl * l, I = f - (f - l), m = l - I, R = d * m - (w - h * I - d * I - h * m), C = Q - R, u = Q - C, Qc[0] = Q - (C + u) + (u - R), y = b + C, u = y - b, v = b - (y - u) + (C - u), C = v - w, u = v - C, Qc[1] = v - (C + u) + (u - w), M = y + C, u = M - y, Qc[2] = y - (M - u) + (C - u), Qc[3] = M;
  const z = JW(K, DOe, 4, Qc, TOe);
  return TOe[z - 1];
}
function L3(t, e, n, r, i, o) {
  const s = (e - o) * (n - i), a = (t - i) * (r - o), A = s - a;
  if (s === 0 || a === 0 || s > 0 != a > 0)
    return A;
  const l = Math.abs(s + a);
  return Math.abs(A) >= Vdr * l ? A : -Wdr(t, e, n, r, i, o, l);
}
const NOe = Math.pow(2, -52), M3 = new Uint32Array(512);
class B6 {
  static from(e, n = npr, r = rpr) {
    const i = e.length, o = new Float64Array(i * 2);
    for (let s = 0; s < i; s++) {
      const a = e[s];
      o[2 * s] = n(a), o[2 * s + 1] = r(a);
    }
    return new B6(o);
  }
  constructor(e) {
    const n = e.length >> 1;
    if (n > 0 && typeof e[0] != "number")
      throw new Error("Expected coords to contain numbers.");
    this.coords = e;
    const r = Math.max(2 * n - 5, 0);
    this._triangles = new Uint32Array(r * 3), this._halfedges = new Int32Array(r * 3), this._hashSize = Math.ceil(Math.sqrt(n)), this._hullPrev = new Uint32Array(n), this._hullNext = new Uint32Array(n), this._hullTri = new Uint32Array(n), this._hullHash = new Int32Array(this._hashSize).fill(-1), this._ids = new Uint32Array(n), this._dists = new Float64Array(n), this.update();
  }
  update() {
    const { coords: e, _hullPrev: n, _hullNext: r, _hullTri: i, _hullHash: o } = this, s = e.length >> 1;
    let a = 1 / 0, A = 1 / 0, l = -1 / 0, c = -1 / 0;
    for (let L = 0; L < s; L++) {
      const N = e[2 * L], k = e[2 * L + 1];
      N < a && (a = N), k < A && (A = k), N > l && (l = N), k > c && (c = k), this._ids[L] = L;
    }
    const u = (a + l) / 2, f = (A + c) / 2;
    let h = 1 / 0, d, I, m;
    for (let L = 0; L < s; L++) {
      const N = KW(u, f, e[2 * L], e[2 * L + 1]);
      N < h && (d = L, h = N);
    }
    const C = e[2 * d], y = e[2 * d + 1];
    h = 1 / 0;
    for (let L = 0; L < s; L++) {
      if (L === d)
        continue;
      const N = KW(C, y, e[2 * L], e[2 * L + 1]);
      N < h && N > 0 && (I = L, h = N);
    }
    let v = e[2 * I], b = e[2 * I + 1], Q = 1 / 0;
    for (let L = 0; L < s; L++) {
      if (L === d || L === I)
        continue;
      const N = epr(C, y, v, b, e[2 * L], e[2 * L + 1]);
      N < Q && (m = L, Q = N);
    }
    let w = e[2 * m], R = e[2 * m + 1];
    if (Q === 1 / 0) {
      for (let k = 0; k < s; k++)
        this._dists[k] = e[2 * k] - e[0] || e[2 * k + 1] - e[1];
      x_(this._ids, this._dists, 0, s - 1);
      const L = new Uint32Array(s);
      let N = 0;
      for (let k = 0, $ = -1 / 0; k < s; k++) {
        const U = this._ids[k];
        this._dists[U] > $ && (L[N++] = U, $ = this._dists[U]);
      }
      this.hull = L.subarray(0, N), this.triangles = new Uint32Array(0), this.halfedges = new Uint32Array(0);
      return;
    }
    if (L3(C, y, v, b, w, R) < 0) {
      const L = I, N = v, k = b;
      I = m, v = w, b = R, m = L, w = N, R = k;
    }
    const M = tpr(C, y, v, b, w, R);
    this._cx = M.x, this._cy = M.y;
    for (let L = 0; L < s; L++)
      this._dists[L] = KW(e[2 * L], e[2 * L + 1], M.x, M.y);
    x_(this._ids, this._dists, 0, s - 1), this._hullStart = d;
    let O = 3;
    r[d] = n[m] = I, r[I] = n[d] = m, r[m] = n[I] = d, i[d] = 0, i[I] = 1, i[m] = 2, o.fill(-1), o[this._hashKey(C, y)] = d, o[this._hashKey(v, b)] = I, o[this._hashKey(w, R)] = m, this.trianglesLen = 0, this._addTriangle(d, I, m, -1, -1, -1);
    for (let L = 0, N, k; L < this._ids.length; L++) {
      const $ = this._ids[L], U = e[2 * $], X = e[2 * $ + 1];
      if (L > 0 && Math.abs(U - N) <= NOe && Math.abs(X - k) <= NOe || (N = U, k = X, $ === d || $ === I || $ === m))
        continue;
      let K = 0;
      for (let ce = 0, ee = this._hashKey(U, X); ce < this._hashSize && (K = o[(ee + ce) % this._hashSize], !(K !== -1 && K !== r[K])); ce++)
        ;
      K = n[K];
      let z = K, Y;
      for (; Y = r[z], L3(U, X, e[2 * z], e[2 * z + 1], e[2 * Y], e[2 * Y + 1]) >= 0; )
        if (z = Y, z === K) {
          z = -1;
          break;
        }
      if (z === -1)
        continue;
      let V = this._addTriangle(z, $, r[z], -1, -1, i[z]);
      i[$] = this._legalize(V + 2), i[z] = V, O++;
      let Z = r[z];
      for (; Y = r[Z], L3(U, X, e[2 * Z], e[2 * Z + 1], e[2 * Y], e[2 * Y + 1]) < 0; )
        V = this._addTriangle(Z, $, Y, i[$], -1, i[Z]), i[$] = this._legalize(V + 2), r[Z] = Z, O--, Z = Y;
      if (z === K)
        for (; Y = n[z], L3(U, X, e[2 * Y], e[2 * Y + 1], e[2 * z], e[2 * z + 1]) < 0; )
          V = this._addTriangle(Y, $, z, -1, i[z], i[Y]), this._legalize(V + 2), i[Y] = V, r[z] = z, O--, z = Y;
      this._hullStart = n[$] = z, r[z] = n[Z] = $, r[$] = Z, o[this._hashKey(U, X)] = $, o[this._hashKey(e[2 * z], e[2 * z + 1])] = z;
    }
    this.hull = new Uint32Array(O);
    for (let L = 0, N = this._hullStart; L < O; L++)
      this.hull[L] = N, N = r[N];
    this.triangles = this._triangles.subarray(0, this.trianglesLen), this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
  }
  _hashKey(e, n) {
    return Math.floor(Xdr(e - this._cx, n - this._cy) * this._hashSize) % this._hashSize;
  }
  _legalize(e) {
    const { _triangles: n, _halfedges: r, coords: i } = this;
    let o = 0, s = 0;
    for (; ; ) {
      const a = r[e], A = e - e % 3;
      if (s = A + (e + 2) % 3, a === -1) {
        if (o === 0)
          break;
        e = M3[--o];
        continue;
      }
      const l = a - a % 3, c = A + (e + 1) % 3, u = l + (a + 2) % 3, f = n[s], h = n[e], d = n[c], I = n[u];
      if (Zdr(
        i[2 * f],
        i[2 * f + 1],
        i[2 * h],
        i[2 * h + 1],
        i[2 * d],
        i[2 * d + 1],
        i[2 * I],
        i[2 * I + 1]
      )) {
        n[e] = I, n[a] = f;
        const C = r[u];
        if (C === -1) {
          let v = this._hullStart;
          do {
            if (this._hullTri[v] === u) {
              this._hullTri[v] = e;
              break;
            }
            v = this._hullPrev[v];
          } while (v !== this._hullStart);
        }
        this._link(e, C), this._link(a, r[s]), this._link(s, u);
        const y = l + (a + 1) % 3;
        o < M3.length && (M3[o++] = y);
      } else {
        if (o === 0)
          break;
        e = M3[--o];
      }
    }
    return s;
  }
  _link(e, n) {
    this._halfedges[e] = n, n !== -1 && (this._halfedges[n] = e);
  }
  // add a new triangle given vertex indices and adjacent half-edge ids
  _addTriangle(e, n, r, i, o, s) {
    const a = this.trianglesLen;
    return this._triangles[a] = e, this._triangles[a + 1] = n, this._triangles[a + 2] = r, this._link(a, i), this._link(a + 1, o), this._link(a + 2, s), this.trianglesLen += 3, a;
  }
}
function Xdr(t, e) {
  const n = t / (Math.abs(t) + Math.abs(e));
  return (e > 0 ? 3 - n : 1 + n) / 4;
}
function KW(t, e, n, r) {
  const i = t - n, o = e - r;
  return i * i + o * o;
}
function Zdr(t, e, n, r, i, o, s, a) {
  const A = t - s, l = e - a, c = n - s, u = r - a, f = i - s, h = o - a, d = A * A + l * l, I = c * c + u * u, m = f * f + h * h;
  return A * (u * m - I * h) - l * (c * m - I * f) + d * (c * h - u * f) < 0;
}
function epr(t, e, n, r, i, o) {
  const s = n - t, a = r - e, A = i - t, l = o - e, c = s * s + a * a, u = A * A + l * l, f = 0.5 / (s * l - a * A), h = (l * c - a * u) * f, d = (s * u - A * c) * f;
  return h * h + d * d;
}
function tpr(t, e, n, r, i, o) {
  const s = n - t, a = r - e, A = i - t, l = o - e, c = s * s + a * a, u = A * A + l * l, f = 0.5 / (s * l - a * A), h = t + (l * c - a * u) * f, d = e + (s * u - A * c) * f;
  return { x: h, y: d };
}
function x_(t, e, n, r) {
  if (r - n <= 20)
    for (let i = n + 1; i <= r; i++) {
      const o = t[i], s = e[o];
      let a = i - 1;
      for (; a >= n && e[t[a]] > s; )
        t[a + 1] = t[a--];
      t[a + 1] = o;
    }
  else {
    const i = n + r >> 1;
    let o = n + 1, s = r;
    W2(t, i, o), e[t[n]] > e[t[r]] && W2(t, n, r), e[t[o]] > e[t[r]] && W2(t, o, r), e[t[n]] > e[t[o]] && W2(t, n, o);
    const a = t[o], A = e[a];
    for (; ; ) {
      do
        o++;
      while (e[t[o]] < A);
      do
        s--;
      while (e[t[s]] > A);
      if (s < o)
        break;
      W2(t, o, s);
    }
    t[n + 1] = t[s], t[s] = a, r - o + 1 >= s - n ? (x_(t, e, o, r), x_(t, e, n, s - 1)) : (x_(t, e, n, s - 1), x_(t, e, o, r));
  }
}
function W2(t, e, n) {
  const r = t[e];
  t[e] = t[n], t[n] = r;
}
function npr(t) {
  return t[0];
}
function rpr(t) {
  return t[1];
}
const LOe = 1e-6;
class pv {
  constructor() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "";
  }
  moveTo(e, n) {
    this._ += `M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  }
  lineTo(e, n) {
    this._ += `L${this._x1 = +e},${this._y1 = +n}`;
  }
  arc(e, n, r) {
    e = +e, n = +n, r = +r;
    const i = e + r, o = n;
    if (r < 0)
      throw new Error("negative radius");
    this._x1 === null ? this._ += `M${i},${o}` : (Math.abs(this._x1 - i) > LOe || Math.abs(this._y1 - o) > LOe) && (this._ += "L" + i + "," + o), r && (this._ += `A${r},${r},0,1,1,${e - r},${n}A${r},${r},0,1,1,${this._x1 = i},${this._y1 = o}`);
  }
  rect(e, n, r, i) {
    this._ += `M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +n}h${+r}v${+i}h${-r}Z`;
  }
  value() {
    return this._ || null;
  }
}
class ooe {
  constructor() {
    this._ = [];
  }
  moveTo(e, n) {
    this._.push([e, n]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(e, n) {
    this._.push([e, n]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}
let ipr = class {
  constructor(e, [n, r, i, o] = [0, 0, 960, 500]) {
    if (!((i = +i) >= (n = +n)) || !((o = +o) >= (r = +r)))
      throw new Error("invalid bounds");
    this.delaunay = e, this._circumcenters = new Float64Array(e.points.length * 2), this.vectors = new Float64Array(e.points.length * 2), this.xmax = i, this.xmin = n, this.ymax = o, this.ymin = r, this._init();
  }
  update() {
    return this.delaunay.update(), this._init(), this;
  }
  _init() {
    const { delaunay: { points: e, hull: n, triangles: r }, vectors: i } = this, o = this.circumcenters = this._circumcenters.subarray(0, r.length / 3 * 2);
    for (let h = 0, d = 0, I = r.length, m, C; h < I; h += 3, d += 2) {
      const y = r[h] * 2, v = r[h + 1] * 2, b = r[h + 2] * 2, Q = e[y], w = e[y + 1], R = e[v], M = e[v + 1], O = e[b], L = e[b + 1], N = R - Q, k = M - w, $ = O - Q, U = L - w, X = (N * U - k * $) * 2;
      if (Math.abs(X) < 1e-9) {
        let K = 1e9;
        const z = r[0] * 2;
        K *= Math.sign((e[z] - Q) * U - (e[z + 1] - w) * $), m = (Q + O) / 2 - K * U, C = (w + L) / 2 + K * $;
      } else {
        const K = 1 / X, z = N * N + k * k, Y = $ * $ + U * U;
        m = Q + (U * z - k * Y) * K, C = w + (N * Y - $ * z) * K;
      }
      o[d] = m, o[d + 1] = C;
    }
    let s = n[n.length - 1], a, A = s * 4, l, c = e[2 * s], u, f = e[2 * s + 1];
    i.fill(0);
    for (let h = 0; h < n.length; ++h)
      s = n[h], a = A, l = c, u = f, A = s * 4, c = e[2 * s], f = e[2 * s + 1], i[a + 2] = i[A] = u - f, i[a + 3] = i[A + 1] = c - l;
  }
  render(e) {
    const n = e == null ? e = new pv() : void 0, { delaunay: { halfedges: r, inedges: i, hull: o }, circumcenters: s, vectors: a } = this;
    if (o.length <= 1)
      return null;
    for (let c = 0, u = r.length; c < u; ++c) {
      const f = r[c];
      if (f < c)
        continue;
      const h = Math.floor(c / 3) * 2, d = Math.floor(f / 3) * 2, I = s[h], m = s[h + 1], C = s[d], y = s[d + 1];
      this._renderSegment(I, m, C, y, e);
    }
    let A, l = o[o.length - 1];
    for (let c = 0; c < o.length; ++c) {
      A = l, l = o[c];
      const u = Math.floor(i[l] / 3) * 2, f = s[u], h = s[u + 1], d = A * 4, I = this._project(f, h, a[d + 2], a[d + 3]);
      I && this._renderSegment(f, h, I[0], I[1], e);
    }
    return n && n.value();
  }
  renderBounds(e) {
    const n = e == null ? e = new pv() : void 0;
    return e.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin), n && n.value();
  }
  renderCell(e, n) {
    const r = n == null ? n = new pv() : void 0, i = this._clip(e);
    if (i === null || !i.length)
      return;
    n.moveTo(i[0], i[1]);
    let o = i.length;
    for (; i[0] === i[o - 2] && i[1] === i[o - 1] && o > 1; )
      o -= 2;
    for (let s = 2; s < o; s += 2)
      (i[s] !== i[s - 2] || i[s + 1] !== i[s - 1]) && n.lineTo(i[s], i[s + 1]);
    return n.closePath(), r && r.value();
  }
  *cellPolygons() {
    const { delaunay: { points: e } } = this;
    for (let n = 0, r = e.length / 2; n < r; ++n) {
      const i = this.cellPolygon(n);
      i && (i.index = n, yield i);
    }
  }
  cellPolygon(e) {
    const n = new ooe();
    return this.renderCell(e, n), n.value();
  }
  _renderSegment(e, n, r, i, o) {
    let s;
    const a = this._regioncode(e, n), A = this._regioncode(r, i);
    a === 0 && A === 0 ? (o.moveTo(e, n), o.lineTo(r, i)) : (s = this._clipSegment(e, n, r, i, a, A)) && (o.moveTo(s[0], s[1]), o.lineTo(s[2], s[3]));
  }
  contains(e, n, r) {
    return n = +n, n !== n || (r = +r, r !== r) ? !1 : this.delaunay._step(e, n, r) === e;
  }
  *neighbors(e) {
    const n = this._clip(e);
    if (n)
      for (const r of this.delaunay.neighbors(e)) {
        const i = this._clip(r);
        if (i) {
          e:
            for (let o = 0, s = n.length; o < s; o += 2)
              for (let a = 0, A = i.length; a < A; a += 2)
                if (n[o] == i[a] && n[o + 1] == i[a + 1] && n[(o + 2) % s] == i[(a + A - 2) % A] && n[(o + 3) % s] == i[(a + A - 1) % A]) {
                  yield r;
                  break e;
                }
        }
      }
  }
  _cell(e) {
    const { circumcenters: n, delaunay: { inedges: r, halfedges: i, triangles: o } } = this, s = r[e];
    if (s === -1)
      return null;
    const a = [];
    let A = s;
    do {
      const l = Math.floor(A / 3);
      if (a.push(n[l * 2], n[l * 2 + 1]), A = A % 3 === 2 ? A - 2 : A + 1, o[A] !== e)
        break;
      A = i[A];
    } while (A !== s && A !== -1);
    return a;
  }
  _clip(e) {
    if (e === 0 && this.delaunay.hull.length === 1)
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    const n = this._cell(e);
    if (n === null)
      return null;
    const { vectors: r } = this, i = e * 4;
    return r[i] || r[i + 1] ? this._clipInfinite(e, n, r[i], r[i + 1], r[i + 2], r[i + 3]) : this._clipFinite(e, n);
  }
  _clipFinite(e, n) {
    const r = n.length;
    let i = null, o, s, a = n[r - 2], A = n[r - 1], l, c = this._regioncode(a, A), u, f = 0;
    for (let h = 0; h < r; h += 2)
      if (o = a, s = A, a = n[h], A = n[h + 1], l = c, c = this._regioncode(a, A), l === 0 && c === 0)
        u = f, f = 0, i ? i.push(a, A) : i = [a, A];
      else {
        let d, I, m, C, y;
        if (l === 0) {
          if ((d = this._clipSegment(o, s, a, A, l, c)) === null)
            continue;
          [I, m, C, y] = d;
        } else {
          if ((d = this._clipSegment(a, A, o, s, c, l)) === null)
            continue;
          [C, y, I, m] = d, u = f, f = this._edgecode(I, m), u && f && this._edge(e, u, f, i, i.length), i ? i.push(I, m) : i = [I, m];
        }
        u = f, f = this._edgecode(C, y), u && f && this._edge(e, u, f, i, i.length), i ? i.push(C, y) : i = [C, y];
      }
    if (i)
      u = f, f = this._edgecode(i[0], i[1]), u && f && this._edge(e, u, f, i, i.length);
    else if (this.contains(e, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2))
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    return i;
  }
  _clipSegment(e, n, r, i, o, s) {
    for (; ; ) {
      if (o === 0 && s === 0)
        return [e, n, r, i];
      if (o & s)
        return null;
      let a, A, l = o || s;
      l & 8 ? (a = e + (r - e) * (this.ymax - n) / (i - n), A = this.ymax) : l & 4 ? (a = e + (r - e) * (this.ymin - n) / (i - n), A = this.ymin) : l & 2 ? (A = n + (i - n) * (this.xmax - e) / (r - e), a = this.xmax) : (A = n + (i - n) * (this.xmin - e) / (r - e), a = this.xmin), o ? (e = a, n = A, o = this._regioncode(e, n)) : (r = a, i = A, s = this._regioncode(r, i));
    }
  }
  _clipInfinite(e, n, r, i, o, s) {
    let a = Array.from(n), A;
    if ((A = this._project(a[0], a[1], r, i)) && a.unshift(A[0], A[1]), (A = this._project(a[a.length - 2], a[a.length - 1], o, s)) && a.push(A[0], A[1]), a = this._clipFinite(e, a))
      for (let l = 0, c = a.length, u, f = this._edgecode(a[c - 2], a[c - 1]); l < c; l += 2)
        u = f, f = this._edgecode(a[l], a[l + 1]), u && f && (l = this._edge(e, u, f, a, l), c = a.length);
    else
      this.contains(e, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2) && (a = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax]);
    return a;
  }
  _edge(e, n, r, i, o) {
    for (; n !== r; ) {
      let s, a;
      switch (n) {
        case 5:
          n = 4;
          continue;
        case 4:
          n = 6, s = this.xmax, a = this.ymin;
          break;
        case 6:
          n = 2;
          continue;
        case 2:
          n = 10, s = this.xmax, a = this.ymax;
          break;
        case 10:
          n = 8;
          continue;
        case 8:
          n = 9, s = this.xmin, a = this.ymax;
          break;
        case 9:
          n = 1;
          continue;
        case 1:
          n = 5, s = this.xmin, a = this.ymin;
          break;
      }
      (i[o] !== s || i[o + 1] !== a) && this.contains(e, s, a) && (i.splice(o, 0, s, a), o += 2);
    }
    if (i.length > 4)
      for (let s = 0; s < i.length; s += 2) {
        const a = (s + 2) % i.length, A = (s + 4) % i.length;
        (i[s] === i[a] && i[a] === i[A] || i[s + 1] === i[a + 1] && i[a + 1] === i[A + 1]) && (i.splice(a, 2), s -= 2);
      }
    return o;
  }
  _project(e, n, r, i) {
    let o = 1 / 0, s, a, A;
    if (i < 0) {
      if (n <= this.ymin)
        return null;
      (s = (this.ymin - n) / i) < o && (A = this.ymin, a = e + (o = s) * r);
    } else if (i > 0) {
      if (n >= this.ymax)
        return null;
      (s = (this.ymax - n) / i) < o && (A = this.ymax, a = e + (o = s) * r);
    }
    if (r > 0) {
      if (e >= this.xmax)
        return null;
      (s = (this.xmax - e) / r) < o && (a = this.xmax, A = n + (o = s) * i);
    } else if (r < 0) {
      if (e <= this.xmin)
        return null;
      (s = (this.xmin - e) / r) < o && (a = this.xmin, A = n + (o = s) * i);
    }
    return [a, A];
  }
  _edgecode(e, n) {
    return (e === this.xmin ? 1 : e === this.xmax ? 2 : 0) | (n === this.ymin ? 4 : n === this.ymax ? 8 : 0);
  }
  _regioncode(e, n) {
    return (e < this.xmin ? 1 : e > this.xmax ? 2 : 0) | (n < this.ymin ? 4 : n > this.ymax ? 8 : 0);
  }
};
const opr = 2 * Math.PI, Mb = Math.pow;
function spr(t) {
  return t[0];
}
function apr(t) {
  return t[1];
}
function Apr(t) {
  const { triangles: e, coords: n } = t;
  for (let r = 0; r < e.length; r += 3) {
    const i = 2 * e[r], o = 2 * e[r + 1], s = 2 * e[r + 2];
    if ((n[s] - n[i]) * (n[o + 1] - n[i + 1]) - (n[o] - n[i]) * (n[s + 1] - n[i + 1]) > 1e-10)
      return !1;
  }
  return !0;
}
function lpr(t, e, n) {
  return [t + Math.sin(t + e) * n, e + Math.cos(t - e) * n];
}
class Bpe {
  static from(e, n = spr, r = apr, i) {
    return new Bpe("length" in e ? cpr(e, n, r, i) : Float64Array.from(upr(e, n, r, i)));
  }
  constructor(e) {
    this._delaunator = new B6(e), this.inedges = new Int32Array(e.length / 2), this._hullIndex = new Int32Array(e.length / 2), this.points = this._delaunator.coords, this._init();
  }
  update() {
    return this._delaunator.update(), this._init(), this;
  }
  _init() {
    const e = this._delaunator, n = this.points;
    if (e.hull && e.hull.length > 2 && Apr(e)) {
      this.collinear = Int32Array.from({ length: n.length / 2 }, (f, h) => h).sort((f, h) => n[2 * f] - n[2 * h] || n[2 * f + 1] - n[2 * h + 1]);
      const A = this.collinear[0], l = this.collinear[this.collinear.length - 1], c = [n[2 * A], n[2 * A + 1], n[2 * l], n[2 * l + 1]], u = 1e-8 * Math.hypot(c[3] - c[1], c[2] - c[0]);
      for (let f = 0, h = n.length / 2; f < h; ++f) {
        const d = lpr(n[2 * f], n[2 * f + 1], u);
        n[2 * f] = d[0], n[2 * f + 1] = d[1];
      }
      this._delaunator = new B6(n);
    } else
      delete this.collinear;
    const r = this.halfedges = this._delaunator.halfedges, i = this.hull = this._delaunator.hull, o = this.triangles = this._delaunator.triangles, s = this.inedges.fill(-1), a = this._hullIndex.fill(-1);
    for (let A = 0, l = r.length; A < l; ++A) {
      const c = o[A % 3 === 2 ? A - 2 : A + 1];
      (r[A] === -1 || s[c] === -1) && (s[c] = A);
    }
    for (let A = 0, l = i.length; A < l; ++A)
      a[i[A]] = A;
    i.length <= 2 && i.length > 0 && (this.triangles = new Int32Array(3).fill(-1), this.halfedges = new Int32Array(3).fill(-1), this.triangles[0] = i[0], s[i[0]] = 1, i.length === 2 && (s[i[1]] = 0, this.triangles[1] = i[1], this.triangles[2] = i[1]));
  }
  voronoi(e) {
    return new ipr(this, e);
  }
  *neighbors(e) {
    const { inedges: n, hull: r, _hullIndex: i, halfedges: o, triangles: s, collinear: a } = this;
    if (a) {
      const u = a.indexOf(e);
      u > 0 && (yield a[u - 1]), u < a.length - 1 && (yield a[u + 1]);
      return;
    }
    const A = n[e];
    if (A === -1)
      return;
    let l = A, c = -1;
    do {
      if (yield c = s[l], l = l % 3 === 2 ? l - 2 : l + 1, s[l] !== e)
        return;
      if (l = o[l], l === -1) {
        const u = r[(i[e] + 1) % r.length];
        u !== c && (yield u);
        return;
      }
    } while (l !== A);
  }
  find(e, n, r = 0) {
    if (e = +e, e !== e || (n = +n, n !== n))
      return -1;
    const i = r;
    let o;
    for (; (o = this._step(r, e, n)) >= 0 && o !== r && o !== i; )
      r = o;
    return o;
  }
  _step(e, n, r) {
    const { inedges: i, hull: o, _hullIndex: s, halfedges: a, triangles: A, points: l } = this;
    if (i[e] === -1 || !l.length)
      return (e + 1) % (l.length >> 1);
    let c = e, u = Mb(n - l[e * 2], 2) + Mb(r - l[e * 2 + 1], 2);
    const f = i[e];
    let h = f;
    do {
      let d = A[h];
      const I = Mb(n - l[d * 2], 2) + Mb(r - l[d * 2 + 1], 2);
      if (I < u && (u = I, c = d), h = h % 3 === 2 ? h - 2 : h + 1, A[h] !== e)
        break;
      if (h = a[h], h === -1) {
        if (h = o[(s[e] + 1) % o.length], h !== d && Mb(n - l[h * 2], 2) + Mb(r - l[h * 2 + 1], 2) < u)
          return h;
        break;
      }
    } while (h !== f);
    return c;
  }
  render(e) {
    const n = e == null ? e = new pv() : void 0, { points: r, halfedges: i, triangles: o } = this;
    for (let s = 0, a = i.length; s < a; ++s) {
      const A = i[s];
      if (A < s)
        continue;
      const l = o[s] * 2, c = o[A] * 2;
      e.moveTo(r[l], r[l + 1]), e.lineTo(r[c], r[c + 1]);
    }
    return this.renderHull(e), n && n.value();
  }
  renderPoints(e, n) {
    n === void 0 && (!e || typeof e.moveTo != "function") && (n = e, e = null), n = n == null ? 2 : +n;
    const r = e == null ? e = new pv() : void 0, { points: i } = this;
    for (let o = 0, s = i.length; o < s; o += 2) {
      const a = i[o], A = i[o + 1];
      e.moveTo(a + n, A), e.arc(a, A, n, 0, opr);
    }
    return r && r.value();
  }
  renderHull(e) {
    const n = e == null ? e = new pv() : void 0, { hull: r, points: i } = this, o = r[0] * 2, s = r.length;
    e.moveTo(i[o], i[o + 1]);
    for (let a = 1; a < s; ++a) {
      const A = 2 * r[a];
      e.lineTo(i[A], i[A + 1]);
    }
    return e.closePath(), n && n.value();
  }
  hullPolygon() {
    const e = new ooe();
    return this.renderHull(e), e.value();
  }
  renderTriangle(e, n) {
    const r = n == null ? n = new pv() : void 0, { points: i, triangles: o } = this, s = o[e *= 3] * 2, a = o[e + 1] * 2, A = o[e + 2] * 2;
    return n.moveTo(i[s], i[s + 1]), n.lineTo(i[a], i[a + 1]), n.lineTo(i[A], i[A + 1]), n.closePath(), r && r.value();
  }
  *trianglePolygons() {
    const { triangles: e } = this;
    for (let n = 0, r = e.length / 3; n < r; ++n)
      yield this.trianglePolygon(n);
  }
  trianglePolygon(e) {
    const n = new ooe();
    return this.renderTriangle(e, n), n.value();
  }
}
function cpr(t, e, n, r) {
  const i = t.length, o = new Float64Array(i * 2);
  for (let s = 0; s < i; ++s) {
    const a = t[s];
    o[s * 2] = e.call(r, a, s, t), o[s * 2 + 1] = n.call(r, a, s, t);
  }
  return o;
}
function* upr(t, e, n, r) {
  let i = 0;
  for (const o of t)
    yield e.call(r, o, i, t), yield n.call(r, o, i, t), ++i;
}
function bpe(t) {
  yt.call(this, null, t);
}
bpe.Definition = {
  type: "Voronoi",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "x",
    type: "field",
    required: !0
  }, {
    name: "y",
    type: "field",
    required: !0
  }, {
    name: "size",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "extent",
    type: "array",
    array: !0,
    length: 2,
    default: [[-1e5, -1e5], [1e5, 1e5]],
    content: {
      type: "number",
      array: !0,
      length: 2
    }
  }, {
    name: "as",
    type: "string",
    default: "path"
  }]
};
const fpr = [-1e5, -1e5, 1e5, 1e5];
on(bpe, yt, {
  transform(t, e) {
    const n = t.as || "path", r = e.source;
    if (!r || !r.length)
      return e;
    let i = t.size;
    i = i ? [0, 0, i[0], i[1]] : (i = t.extent) ? [i[0][0], i[0][1], i[1][0], i[1][1]] : fpr;
    const o = this.value = Bpe.from(r, t.x, t.y).voronoi(i);
    for (let s = 0, a = r.length; s < a; ++s) {
      const A = o.cellPolygon(s);
      r[s][n] = A ? gpr(A) : null;
    }
    return e.reflow(t.modified()).modifies(n);
  }
});
function gpr(t) {
  const e = t[0][0], n = t[0][1];
  let r = t.length - 1;
  for (; t[r][0] === e && t[r][1] === n; --r)
    ;
  return "M" + t.slice(0, r + 1).join("L") + "Z";
}
const hpr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  voronoi: bpe
}, Symbol.toStringTag, { value: "Module" }));
var WW = Math.PI / 180, oD = 64, A4 = 2048;
function dpr() {
  var t = [256, 256], e, n, r, i, o, s, a, A = aot, l = [], c = Math.random, u = {};
  u.layout = function() {
    for (var d = f(PC()), I = ypr((t[0] >> 5) * t[1]), m = null, C = l.length, y = -1, v = [], b = l.map((w) => ({
      text: e(w),
      font: n(w),
      style: i(w),
      weight: o(w),
      rotate: s(w),
      size: ~~(r(w) + 1e-14),
      padding: a(w),
      xoff: 0,
      yoff: 0,
      x1: 0,
      y1: 0,
      x0: 0,
      y0: 0,
      hasText: !1,
      sprite: null,
      datum: w
    })).sort((w, R) => R.size - w.size); ++y < C; ) {
      var Q = b[y];
      Q.x = t[0] * (c() + 0.5) >> 1, Q.y = t[1] * (c() + 0.5) >> 1, ppr(d, Q, b, y), Q.hasText && h(I, Q, m) && (v.push(Q), m ? mpr(m, Q) : m = [{
        x: Q.x + Q.x0,
        y: Q.y + Q.y0
      }, {
        x: Q.x + Q.x1,
        y: Q.y + Q.y1
      }], Q.x -= t[0] >> 1, Q.y -= t[1] >> 1);
    }
    return v;
  };
  function f(d) {
    d.width = d.height = 1;
    var I = Math.sqrt(d.getContext("2d").getImageData(0, 0, 1, 1).data.length >> 2);
    d.width = (oD << 5) / I, d.height = A4 / I;
    var m = d.getContext("2d");
    return m.fillStyle = m.strokeStyle = "red", m.textAlign = "center", {
      context: m,
      ratio: I
    };
  }
  function h(d, I, m) {
    for (var C = I.x, y = I.y, v = Math.sqrt(t[0] * t[0] + t[1] * t[1]), b = A(t), Q = c() < 0.5 ? 1 : -1, w = -Q, R, M, O; (R = b(w += Q)) && (M = ~~R[0], O = ~~R[1], !(Math.min(Math.abs(M), Math.abs(O)) >= v)); )
      if (I.x = C + M, I.y = y + O, !(I.x + I.x0 < 0 || I.y + I.y0 < 0 || I.x + I.x1 > t[0] || I.y + I.y1 > t[1]) && (!m || !Ipr(I, d, t[0])) && (!m || Cpr(I, m))) {
        for (var L = I.sprite, N = I.width >> 5, k = t[0] >> 5, $ = I.x - (N << 4), U = $ & 127, X = 32 - U, K = I.y1 - I.y0, z = (I.y + I.y0) * k + ($ >> 5), Y, V = 0; V < K; V++) {
          Y = 0;
          for (var Z = 0; Z <= N; Z++)
            d[z + Z] |= Y << X | (Z < N ? (Y = L[V * N + Z]) >>> U : 0);
          z += k;
        }
        return I.sprite = null, !0;
      }
    return !1;
  }
  return u.words = function(d) {
    return arguments.length ? (l = d, u) : l;
  }, u.size = function(d) {
    return arguments.length ? (t = [+d[0], +d[1]], u) : t;
  }, u.font = function(d) {
    return arguments.length ? (n = Sy(d), u) : n;
  }, u.fontStyle = function(d) {
    return arguments.length ? (i = Sy(d), u) : i;
  }, u.fontWeight = function(d) {
    return arguments.length ? (o = Sy(d), u) : o;
  }, u.rotate = function(d) {
    return arguments.length ? (s = Sy(d), u) : s;
  }, u.text = function(d) {
    return arguments.length ? (e = Sy(d), u) : e;
  }, u.spiral = function(d) {
    return arguments.length ? (A = vpr[d] || d, u) : A;
  }, u.fontSize = function(d) {
    return arguments.length ? (r = Sy(d), u) : r;
  }, u.padding = function(d) {
    return arguments.length ? (a = Sy(d), u) : a;
  }, u.random = function(d) {
    return arguments.length ? (c = d, u) : c;
  }, u;
}
function ppr(t, e, n, r) {
  if (!e.sprite) {
    var i = t.context, o = t.ratio;
    i.clearRect(0, 0, (oD << 5) / o, A4 / o);
    var s = 0, a = 0, A = 0, l = n.length, c, u, f, h, d;
    for (--r; ++r < l; ) {
      if (e = n[r], i.save(), i.font = e.style + " " + e.weight + " " + ~~((e.size + 1) / o) + "px " + e.font, c = i.measureText(e.text + "m").width * o, f = e.size << 1, e.rotate) {
        var I = Math.sin(e.rotate * WW), m = Math.cos(e.rotate * WW), C = c * m, y = c * I, v = f * m, b = f * I;
        c = Math.max(Math.abs(C + b), Math.abs(C - b)) + 31 >> 5 << 5, f = ~~Math.max(Math.abs(y + v), Math.abs(y - v));
      } else
        c = c + 31 >> 5 << 5;
      if (f > A && (A = f), s + c >= oD << 5 && (s = 0, a += A, A = 0), a + f >= A4)
        break;
      i.translate((s + (c >> 1)) / o, (a + (f >> 1)) / o), e.rotate && i.rotate(e.rotate * WW), i.fillText(e.text, 0, 0), e.padding && (i.lineWidth = 2 * e.padding, i.strokeText(e.text, 0, 0)), i.restore(), e.width = c, e.height = f, e.xoff = s, e.yoff = a, e.x1 = c >> 1, e.y1 = f >> 1, e.x0 = -e.x1, e.y0 = -e.y1, e.hasText = !0, s += c;
    }
    for (var Q = i.getImageData(0, 0, (oD << 5) / o, A4 / o).data, w = []; --r >= 0; )
      if (e = n[r], !!e.hasText) {
        for (c = e.width, u = c >> 5, f = e.y1 - e.y0, h = 0; h < f * u; h++)
          w[h] = 0;
        if (s = e.xoff, s == null)
          return;
        a = e.yoff;
        var R = 0, M = -1;
        for (d = 0; d < f; d++) {
          for (h = 0; h < c; h++) {
            var O = u * d + (h >> 5), L = Q[(a + d) * (oD << 5) + (s + h) << 2] ? 1 << 31 - h % 32 : 0;
            w[O] |= L, R |= L;
          }
          R ? M = d : (e.y0++, f--, d--, a++);
        }
        e.y1 = e.y0 + M, e.sprite = w.slice(0, (e.y1 - e.y0) * u);
      }
  }
}
function Ipr(t, e, n) {
  n >>= 5;
  for (var r = t.sprite, i = t.width >> 5, o = t.x - (i << 4), s = o & 127, a = 32 - s, A = t.y1 - t.y0, l = (t.y + t.y0) * n + (o >> 5), c, u = 0; u < A; u++) {
    c = 0;
    for (var f = 0; f <= i; f++)
      if ((c << a | (f < i ? (c = r[u * i + f]) >>> s : 0)) & e[l + f])
        return !0;
    l += n;
  }
  return !1;
}
function mpr(t, e) {
  var n = t[0], r = t[1];
  e.x + e.x0 < n.x && (n.x = e.x + e.x0), e.y + e.y0 < n.y && (n.y = e.y + e.y0), e.x + e.x1 > r.x && (r.x = e.x + e.x1), e.y + e.y1 > r.y && (r.y = e.y + e.y1);
}
function Cpr(t, e) {
  return t.x + t.x1 > e[0].x && t.x + t.x0 < e[1].x && t.y + t.y1 > e[0].y && t.y + t.y0 < e[1].y;
}
function aot(t) {
  var e = t[0] / t[1];
  return function(n) {
    return [e * (n *= 0.1) * Math.cos(n), n * Math.sin(n)];
  };
}
function Epr(t) {
  var e = 4, n = e * t[0] / t[1], r = 0, i = 0;
  return function(o) {
    var s = o < 0 ? -1 : 1;
    switch (Math.sqrt(1 + 4 * s * o) - s & 3) {
      case 0:
        r += n;
        break;
      case 1:
        i += e;
        break;
      case 2:
        r -= n;
        break;
      default:
        i -= e;
        break;
    }
    return [r, i];
  };
}
function ypr(t) {
  for (var e = [], n = -1; ++n < t; )
    e[n] = 0;
  return e;
}
function Sy(t) {
  return typeof t == "function" ? t : function() {
    return t;
  };
}
var vpr = {
  archimedean: aot,
  rectangular: Epr
};
const Aot = ["x", "y", "font", "fontSize", "fontStyle", "fontWeight", "angle"], Bpr = ["text", "font", "rotate", "fontSize", "fontStyle", "fontWeight"];
function _pe(t) {
  yt.call(this, dpr(), t);
}
_pe.Definition = {
  type: "Wordcloud",
  metadata: {
    modifies: !0
  },
  params: [{
    name: "size",
    type: "number",
    array: !0,
    length: 2
  }, {
    name: "font",
    type: "string",
    expr: !0,
    default: "sans-serif"
  }, {
    name: "fontStyle",
    type: "string",
    expr: !0,
    default: "normal"
  }, {
    name: "fontWeight",
    type: "string",
    expr: !0,
    default: "normal"
  }, {
    name: "fontSize",
    type: "number",
    expr: !0,
    default: 14
  }, {
    name: "fontSizeRange",
    type: "number",
    array: "nullable",
    default: [10, 50]
  }, {
    name: "rotate",
    type: "number",
    expr: !0,
    default: 0
  }, {
    name: "text",
    type: "field"
  }, {
    name: "spiral",
    type: "string",
    values: ["archimedean", "rectangular"]
  }, {
    name: "padding",
    type: "number",
    expr: !0
  }, {
    name: "as",
    type: "string",
    array: !0,
    length: 7,
    default: Aot
  }]
};
on(_pe, yt, {
  transform(t, e) {
    t.size && !(t.size[0] && t.size[1]) && wt("Wordcloud size dimensions must be non-zero.");
    function n(d) {
      const I = t[d];
      return ri(I) && e.modified(I.fields);
    }
    const r = t.modified();
    if (!(r || e.changed(e.ADD_REM) || Bpr.some(n)))
      return;
    const i = e.materialize(e.SOURCE).source, o = this.value, s = t.as || Aot;
    let a = t.fontSize || 14, A;
    if (ri(a) ? A = t.fontSizeRange : a = lc(a), A) {
      const d = a, I = Vi("sqrt")().domain(Jp(i, d)).range(A);
      a = (m) => I(d(m));
    }
    i.forEach((d) => {
      d[s[0]] = NaN, d[s[1]] = NaN, d[s[3]] = 0;
    });
    const l = o.words(i).text(t.text).size(t.size || [500, 500]).padding(t.padding || 1).spiral(t.spiral || "archimedean").rotate(t.rotate || 0).font(t.font || "sans-serif").fontStyle(t.fontStyle || "normal").fontWeight(t.fontWeight || "normal").fontSize(a).random(Yg).layout(), c = o.size(), u = c[0] >> 1, f = c[1] >> 1, h = l.length;
    for (let d = 0, I, m; d < h; ++d)
      I = l[d], m = I.datum, m[s[0]] = I.x + u, m[s[1]] = I.y + f, m[s[2]] = I.font, m[s[3]] = I.size, m[s[4]] = I.style, m[s[5]] = I.weight, m[s[6]] = I.rotate;
    return e.reflow(r).modifies(s);
  }
});
const bpr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  wordcloud: _pe
}, Symbol.toStringTag, { value: "Module" })), _pr = (t) => new Uint8Array(t), Spr = (t) => new Uint16Array(t), VD = (t) => new Uint32Array(t);
function Qpr() {
  let t = 8, e = [], n = VD(0), r = O3(0, t), i = O3(0, t);
  return {
    data: () => e,
    seen: () => n = wpr(n, e.length),
    add(o) {
      for (let s = 0, a = e.length, A = o.length, l; s < A; ++s)
        l = o[s], l._index = a++, e.push(l);
    },
    remove(o, s) {
      const a = e.length, A = Array(a - o), l = e;
      let c, u, f;
      for (u = 0; !s[u] && u < a; ++u)
        A[u] = e[u], l[u] = u;
      for (f = u; u < a; ++u)
        c = e[u], s[u] ? l[u] = -1 : (l[u] = f, r[f] = r[u], i[f] = i[u], A[f] = c, c._index = f++), r[u] = 0;
      return e = A, l;
    },
    size: () => e.length,
    curr: () => r,
    prev: () => i,
    reset: (o) => i[o] = r[o],
    all: () => t < 257 ? 255 : t < 65537 ? 65535 : 4294967295,
    set(o, s) {
      r[o] |= s;
    },
    clear(o, s) {
      r[o] &= ~s;
    },
    resize(o, s) {
      const a = r.length;
      (o > a || s > t) && (t = Math.max(s, t), r = O3(o, t, r), i = O3(o, t));
    }
  };
}
function wpr(t, e, n) {
  return t.length >= e ? t : (n = n || new t.constructor(e), n.set(t), n);
}
function O3(t, e, n) {
  const r = (e < 257 ? _pr : e < 65537 ? Spr : VD)(t);
  return n && r.set(n), r;
}
function MOe(t, e, n) {
  const r = 1 << e;
  return {
    one: r,
    zero: ~r,
    range: n.slice(),
    bisect: t.bisect,
    index: t.index,
    size: t.size,
    onAdd(i, o) {
      const s = this, a = s.bisect(s.range, i.value), A = i.index, l = a[0], c = a[1], u = A.length;
      let f;
      for (f = 0; f < l; ++f)
        o[A[f]] |= r;
      for (f = c; f < u; ++f)
        o[A[f]] |= r;
      return s;
    }
  };
}
function OOe() {
  let t = VD(0), e = [], n = 0;
  function r(a, A, l) {
    if (!A.length)
      return [];
    const c = n, u = A.length, f = VD(u);
    let h = Array(u), d, I, m;
    for (m = 0; m < u; ++m)
      h[m] = a(A[m]), f[m] = m;
    if (h = xpr(h, f), c)
      d = e, I = t, e = Array(c + u), t = VD(c + u), Rpr(l, d, I, c, h, f, u, e, t);
    else {
      if (l > 0)
        for (m = 0; m < u; ++m)
          f[m] += l;
      e = h, t = f;
    }
    return n = c + u, {
      index: f,
      value: h
    };
  }
  function i(a, A) {
    const l = n;
    let c, u, f;
    for (u = 0; !A[t[u]] && u < l; ++u)
      ;
    for (f = u; u < l; ++u)
      A[c = t[u]] || (t[f] = c, e[f] = e[u], ++f);
    n = l - a;
  }
  function o(a) {
    for (let A = 0, l = n; A < l; ++A)
      t[A] = a[t[A]];
  }
  function s(a, A) {
    let l;
    return A ? l = A.length : (A = e, l = n), [Ytr(A, a[0], 0, l), I5(A, a[1], 0, l)];
  }
  return {
    insert: r,
    remove: i,
    bisect: s,
    reindex: o,
    index: () => t,
    size: () => n
  };
}
function xpr(t, e) {
  return t.sort.call(e, (n, r) => {
    const i = t[n], o = t[r];
    return i < o ? -1 : i > o ? 1 : 0;
  }), Ktr(t, e);
}
function Rpr(t, e, n, r, i, o, s, a, A) {
  let l = 0, c = 0, u;
  for (u = 0; l < r && c < s; ++u)
    e[l] < i[c] ? (a[u] = e[l], A[u] = n[l++]) : (a[u] = i[c], A[u] = o[c++] + t);
  for (; l < r; ++l, ++u)
    a[u] = e[l], A[u] = n[l];
  for (; c < s; ++c, ++u)
    a[u] = i[c], A[u] = o[c] + t;
}
function Spe(t) {
  yt.call(this, Qpr(), t), this._indices = null, this._dims = null;
}
Spe.Definition = {
  type: "CrossFilter",
  metadata: {},
  params: [{
    name: "fields",
    type: "field",
    array: !0,
    required: !0
  }, {
    name: "query",
    type: "array",
    array: !0,
    required: !0,
    content: {
      type: "number",
      array: !0,
      length: 2
    }
  }]
};
on(Spe, yt, {
  transform(t, e) {
    if (this._dims) {
      var n = t.modified("fields") || t.fields.some((r) => e.modified(r.fields));
      return n ? this.reinit(t, e) : this.eval(t, e);
    } else
      return this.init(t, e);
  },
  init(t, e) {
    const n = t.fields, r = t.query, i = this._indices = {}, o = this._dims = [], s = r.length;
    let a = 0, A, l;
    for (; a < s; ++a)
      A = n[a].fname, l = i[A] || (i[A] = OOe()), o.push(MOe(l, a, r[a]));
    return this.eval(t, e);
  },
  reinit(t, e) {
    const n = e.materialize().fork(), r = t.fields, i = t.query, o = this._indices, s = this._dims, a = this.value, A = a.curr(), l = a.prev(), c = a.all(), u = n.rem = n.add, f = n.mod, h = i.length, d = {};
    let I, m, C, y, v, b, Q, w, R;
    if (l.set(A), e.rem.length && (v = this.remove(t, e, n)), e.add.length && a.add(e.add), e.mod.length)
      for (b = {}, y = e.mod, Q = 0, w = y.length; Q < w; ++Q)
        b[y[Q]._index] = 1;
    for (Q = 0; Q < h; ++Q)
      R = r[Q], (!s[Q] || t.modified("fields", Q) || e.modified(R.fields)) && (C = R.fname, (I = d[C]) || (o[C] = m = OOe(), d[C] = I = m.insert(R, e.source, 0)), s[Q] = MOe(m, Q, i[Q]).onAdd(I, A));
    for (Q = 0, w = a.data().length; Q < w; ++Q)
      v[Q] || (l[Q] !== A[Q] ? u.push(Q) : b[Q] && A[Q] !== c && f.push(Q));
    return a.mask = (1 << h) - 1, n;
  },
  eval(t, e) {
    const n = e.materialize().fork(), r = this._dims.length;
    let i = 0;
    return e.rem.length && (this.remove(t, e, n), i |= (1 << r) - 1), t.modified("query") && !t.modified("fields") && (i |= this.update(t, e, n)), e.add.length && (this.insert(t, e, n), i |= (1 << r) - 1), e.mod.length && (this.modify(e, n), i |= (1 << r) - 1), this.value.mask = i, n;
  },
  insert(t, e, n) {
    const r = e.add, i = this.value, o = this._dims, s = this._indices, a = t.fields, A = {}, l = n.add, c = i.size() + r.length, u = o.length;
    let f = i.size(), h, d, I;
    i.resize(c, u), i.add(r);
    const m = i.curr(), C = i.prev(), y = i.all();
    for (h = 0; h < u; ++h)
      d = a[h].fname, I = A[d] || (A[d] = s[d].insert(a[h], r, f)), o[h].onAdd(I, m);
    for (; f < c; ++f)
      C[f] = y, m[f] !== y && l.push(f);
  },
  modify(t, e) {
    const n = e.mod, r = this.value, i = r.curr(), o = r.all(), s = t.mod;
    let a, A, l;
    for (a = 0, A = s.length; a < A; ++a)
      l = s[a]._index, i[l] !== o && n.push(l);
  },
  remove(t, e, n) {
    const r = this._indices, i = this.value, o = i.curr(), s = i.prev(), a = i.all(), A = {}, l = n.rem, c = e.rem;
    let u, f, h, d;
    for (u = 0, f = c.length; u < f; ++u)
      h = c[u]._index, A[h] = 1, s[h] = d = o[h], o[h] = a, d !== a && l.push(h);
    for (h in r)
      r[h].remove(f, A);
    return this.reindex(e, f, A), A;
  },
  // reindex filters and indices after propagation completes
  reindex(t, e, n) {
    const r = this._indices, i = this.value;
    t.runAfter(() => {
      const o = i.remove(e, n);
      for (const s in r)
        r[s].reindex(o);
    });
  },
  update(t, e, n) {
    const r = this._dims, i = t.query, o = e.stamp, s = r.length;
    let a = 0, A, l;
    for (n.filters = 0, l = 0; l < s; ++l)
      t.modified("query", l) && (A = l, ++a);
    if (a === 1)
      a = r[A].one, this.incrementOne(r[A], i[A], n.add, n.rem);
    else
      for (l = 0, a = 0; l < s; ++l)
        t.modified("query", l) && (a |= r[l].one, this.incrementAll(r[l], i[l], o, n.add), n.rem = n.add);
    return a;
  },
  incrementAll(t, e, n, r) {
    const i = this.value, o = i.seen(), s = i.curr(), a = i.prev(), A = t.index(), l = t.bisect(t.range), c = t.bisect(e), u = c[0], f = c[1], h = l[0], d = l[1], I = t.one;
    let m, C, y;
    if (u < h)
      for (m = u, C = Math.min(h, f); m < C; ++m)
        y = A[m], o[y] !== n && (a[y] = s[y], o[y] = n, r.push(y)), s[y] ^= I;
    else if (u > h)
      for (m = h, C = Math.min(u, d); m < C; ++m)
        y = A[m], o[y] !== n && (a[y] = s[y], o[y] = n, r.push(y)), s[y] ^= I;
    if (f > d)
      for (m = Math.max(u, d), C = f; m < C; ++m)
        y = A[m], o[y] !== n && (a[y] = s[y], o[y] = n, r.push(y)), s[y] ^= I;
    else if (f < d)
      for (m = Math.max(h, f), C = d; m < C; ++m)
        y = A[m], o[y] !== n && (a[y] = s[y], o[y] = n, r.push(y)), s[y] ^= I;
    t.range = e.slice();
  },
  incrementOne(t, e, n, r) {
    const i = this.value, o = i.curr(), s = t.index(), a = t.bisect(t.range), A = t.bisect(e), l = A[0], c = A[1], u = a[0], f = a[1], h = t.one;
    let d, I, m;
    if (l < u)
      for (d = l, I = Math.min(u, c); d < I; ++d)
        m = s[d], o[m] ^= h, n.push(m);
    else if (l > u)
      for (d = u, I = Math.min(l, f); d < I; ++d)
        m = s[d], o[m] ^= h, r.push(m);
    if (c > f)
      for (d = Math.max(l, f), I = c; d < I; ++d)
        m = s[d], o[m] ^= h, n.push(m);
    else if (c < f)
      for (d = Math.max(u, c), I = f; d < I; ++d)
        m = s[d], o[m] ^= h, r.push(m);
    t.range = e.slice();
  }
});
function Qpe(t) {
  yt.call(this, null, t);
}
Qpe.Definition = {
  type: "ResolveFilter",
  metadata: {},
  params: [{
    name: "ignore",
    type: "number",
    required: !0,
    description: "A bit mask indicating which filters to ignore."
  }, {
    name: "filter",
    type: "object",
    required: !0,
    description: "Per-tuple filter bitmaps from a CrossFilter transform."
  }]
};
on(Qpe, yt, {
  transform(t, e) {
    const n = ~(t.ignore || 0), r = t.filter, i = r.mask;
    if (!(i & n))
      return e.StopPropagation;
    const o = e.fork(e.ALL), s = r.data(), a = r.curr(), A = r.prev(), l = (c) => a[c] & n ? null : s[c];
    return o.filter(o.MOD, l), i & i - 1 ? (o.filter(o.ADD, (c) => {
      const u = a[c] & n;
      return !u && u ^ A[c] & n ? s[c] : null;
    }), o.filter(o.REM, (c) => {
      const u = a[c] & n;
      return u && !(u ^ (u ^ A[c] & n)) ? s[c] : null;
    })) : (o.filter(o.ADD, l), o.filter(o.REM, (c) => (a[c] & n) === i ? s[c] : null)), o.filter(o.SOURCE, (c) => l(c._index));
  }
});
const Dpr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  crossfilter: Spe,
  resolvefilter: Qpe
}, Symbol.toStringTag, { value: "Module" })), Tpr = "RawCode", _B = "Literal", Npr = "Property", Lpr = "Identifier", Mpr = "ArrayExpression", Opr = "BinaryExpression", lot = "CallExpression", Fpr = "ConditionalExpression", Ppr = "LogicalExpression", kpr = "MemberExpression", Gpr = "ObjectExpression", Upr = "UnaryExpression";
function Od(t) {
  this.type = t;
}
Od.prototype.visit = function(t) {
  let e, n, r;
  if (t(this))
    return 1;
  for (e = Hpr(this), n = 0, r = e.length; n < r; ++n)
    if (e[n].visit(t))
      return 1;
};
function Hpr(t) {
  switch (t.type) {
    case Mpr:
      return t.elements;
    case Opr:
    case Ppr:
      return [t.left, t.right];
    case lot:
      return [t.callee].concat(t.arguments);
    case Fpr:
      return [t.test, t.consequent, t.alternate];
    case kpr:
      return [t.object, t.property];
    case Gpr:
      return t.properties;
    case Npr:
      return [t.key, t.value];
    case Upr:
      return [t.argument];
    case Lpr:
    case _B:
    case Tpr:
    default:
      return [];
  }
}
var m0, Hn, Qt, tc, wo, Zj = 1, SO = 2, SB = 3, qE = 4, eY = 5, Q1 = 6, mu = 7, QO = 8, $pr = 9;
m0 = {};
m0[Zj] = "Boolean";
m0[SO] = "<end>";
m0[SB] = "Identifier";
m0[qE] = "Keyword";
m0[eY] = "Null";
m0[Q1] = "Numeric";
m0[mu] = "Punctuator";
m0[QO] = "String";
m0[$pr] = "RegularExpression";
var qpr = "ArrayExpression", jpr = "BinaryExpression", Ypr = "CallExpression", zpr = "ConditionalExpression", cot = "Identifier", Vpr = "Literal", Jpr = "LogicalExpression", Kpr = "MemberExpression", Wpr = "ObjectExpression", Xpr = "Property", Zpr = "UnaryExpression", MA = "Unexpected token %0", e0r = "Unexpected number", t0r = "Unexpected string", n0r = "Unexpected identifier", r0r = "Unexpected reserved word", i0r = "Unexpected end of input", soe = "Invalid regular expression", XW = "Invalid regular expression: missing /", uot = "Octal literals are not allowed in strict mode.", o0r = "Duplicate data property in object literal not allowed in strict mode", cl = "ILLEGAL", TN = "Disabled.", s0r = new RegExp("[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0-\\u08B2\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]"), a0r = new RegExp("[\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0300-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u0483-\\u0487\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u0591-\\u05BD\\u05BF\\u05C1\\u05C2\\u05C4\\u05C5\\u05C7\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0610-\\u061A\\u0620-\\u0669\\u066E-\\u06D3\\u06D5-\\u06DC\\u06DF-\\u06E8\\u06EA-\\u06FC\\u06FF\\u0710-\\u074A\\u074D-\\u07B1\\u07C0-\\u07F5\\u07FA\\u0800-\\u082D\\u0840-\\u085B\\u08A0-\\u08B2\\u08E4-\\u0963\\u0966-\\u096F\\u0971-\\u0983\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BC-\\u09C4\\u09C7\\u09C8\\u09CB-\\u09CE\\u09D7\\u09DC\\u09DD\\u09DF-\\u09E3\\u09E6-\\u09F1\\u0A01-\\u0A03\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A3C\\u0A3E-\\u0A42\\u0A47\\u0A48\\u0A4B-\\u0A4D\\u0A51\\u0A59-\\u0A5C\\u0A5E\\u0A66-\\u0A75\\u0A81-\\u0A83\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABC-\\u0AC5\\u0AC7-\\u0AC9\\u0ACB-\\u0ACD\\u0AD0\\u0AE0-\\u0AE3\\u0AE6-\\u0AEF\\u0B01-\\u0B03\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3C-\\u0B44\\u0B47\\u0B48\\u0B4B-\\u0B4D\\u0B56\\u0B57\\u0B5C\\u0B5D\\u0B5F-\\u0B63\\u0B66-\\u0B6F\\u0B71\\u0B82\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BBE-\\u0BC2\\u0BC6-\\u0BC8\\u0BCA-\\u0BCD\\u0BD0\\u0BD7\\u0BE6-\\u0BEF\\u0C00-\\u0C03\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D-\\u0C44\\u0C46-\\u0C48\\u0C4A-\\u0C4D\\u0C55\\u0C56\\u0C58\\u0C59\\u0C60-\\u0C63\\u0C66-\\u0C6F\\u0C81-\\u0C83\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBC-\\u0CC4\\u0CC6-\\u0CC8\\u0CCA-\\u0CCD\\u0CD5\\u0CD6\\u0CDE\\u0CE0-\\u0CE3\\u0CE6-\\u0CEF\\u0CF1\\u0CF2\\u0D01-\\u0D03\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D-\\u0D44\\u0D46-\\u0D48\\u0D4A-\\u0D4E\\u0D57\\u0D60-\\u0D63\\u0D66-\\u0D6F\\u0D7A-\\u0D7F\\u0D82\\u0D83\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0DCA\\u0DCF-\\u0DD4\\u0DD6\\u0DD8-\\u0DDF\\u0DE6-\\u0DEF\\u0DF2\\u0DF3\\u0E01-\\u0E3A\\u0E40-\\u0E4E\\u0E50-\\u0E59\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB9\\u0EBB-\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EC8-\\u0ECD\\u0ED0-\\u0ED9\\u0EDC-\\u0EDF\\u0F00\\u0F18\\u0F19\\u0F20-\\u0F29\\u0F35\\u0F37\\u0F39\\u0F3E-\\u0F47\\u0F49-\\u0F6C\\u0F71-\\u0F84\\u0F86-\\u0F97\\u0F99-\\u0FBC\\u0FC6\\u1000-\\u1049\\u1050-\\u109D\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u135D-\\u135F\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F8\\u1700-\\u170C\\u170E-\\u1714\\u1720-\\u1734\\u1740-\\u1753\\u1760-\\u176C\\u176E-\\u1770\\u1772\\u1773\\u1780-\\u17D3\\u17D7\\u17DC\\u17DD\\u17E0-\\u17E9\\u180B-\\u180D\\u1810-\\u1819\\u1820-\\u1877\\u1880-\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1920-\\u192B\\u1930-\\u193B\\u1946-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19B0-\\u19C9\\u19D0-\\u19D9\\u1A00-\\u1A1B\\u1A20-\\u1A5E\\u1A60-\\u1A7C\\u1A7F-\\u1A89\\u1A90-\\u1A99\\u1AA7\\u1AB0-\\u1ABD\\u1B00-\\u1B4B\\u1B50-\\u1B59\\u1B6B-\\u1B73\\u1B80-\\u1BF3\\u1C00-\\u1C37\\u1C40-\\u1C49\\u1C4D-\\u1C7D\\u1CD0-\\u1CD2\\u1CD4-\\u1CF6\\u1CF8\\u1CF9\\u1D00-\\u1DF5\\u1DFC-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u200C\\u200D\\u203F\\u2040\\u2054\\u2071\\u207F\\u2090-\\u209C\\u20D0-\\u20DC\\u20E1\\u20E5-\\u20F0\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D7F-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2DE0-\\u2DFF\\u2E2F\\u3005-\\u3007\\u3021-\\u302F\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u3099\\u309A\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA62B\\uA640-\\uA66F\\uA674-\\uA67D\\uA67F-\\uA69D\\uA69F-\\uA6F1\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA7AD\\uA7B0\\uA7B1\\uA7F7-\\uA827\\uA840-\\uA873\\uA880-\\uA8C4\\uA8D0-\\uA8D9\\uA8E0-\\uA8F7\\uA8FB\\uA900-\\uA92D\\uA930-\\uA953\\uA960-\\uA97C\\uA980-\\uA9C0\\uA9CF-\\uA9D9\\uA9E0-\\uA9FE\\uAA00-\\uAA36\\uAA40-\\uAA4D\\uAA50-\\uAA59\\uAA60-\\uAA76\\uAA7A-\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEF\\uAAF2-\\uAAF6\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB5F\\uAB64\\uAB65\\uABC0-\\uABEA\\uABEC\\uABED\\uABF0-\\uABF9\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE00-\\uFE0F\\uFE20-\\uFE2D\\uFE33\\uFE34\\uFE4D-\\uFE4F\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF10-\\uFF19\\uFF21-\\uFF3A\\uFF3F\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]");
function tY(t, e) {
  if (!t)
    throw new Error("ASSERT: " + e);
}
function eI(t) {
  return t >= 48 && t <= 57;
}
function wpe(t) {
  return "0123456789abcdefABCDEF".indexOf(t) >= 0;
}
function JD(t) {
  return "01234567".indexOf(t) >= 0;
}
function A0r(t) {
  return t === 32 || t === 9 || t === 11 || t === 12 || t === 160 || t >= 5760 && [5760, 6158, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279].indexOf(t) >= 0;
}
function NN(t) {
  return t === 10 || t === 13 || t === 8232 || t === 8233;
}
function wO(t) {
  return t === 36 || t === 95 || t >= 65 && t <= 90 || t >= 97 && t <= 122 || t === 92 || t >= 128 && s0r.test(String.fromCharCode(t));
}
function b6(t) {
  return t === 36 || t === 95 || t >= 65 && t <= 90 || t >= 97 && t <= 122 || t >= 48 && t <= 57 || t === 92 || t >= 128 && a0r.test(String.fromCharCode(t));
}
const l0r = {
  if: 1,
  in: 1,
  do: 1,
  var: 1,
  for: 1,
  new: 1,
  try: 1,
  let: 1,
  this: 1,
  else: 1,
  case: 1,
  void: 1,
  with: 1,
  enum: 1,
  while: 1,
  break: 1,
  catch: 1,
  throw: 1,
  const: 1,
  yield: 1,
  class: 1,
  super: 1,
  return: 1,
  typeof: 1,
  delete: 1,
  switch: 1,
  export: 1,
  import: 1,
  public: 1,
  static: 1,
  default: 1,
  finally: 1,
  extends: 1,
  package: 1,
  private: 1,
  function: 1,
  continue: 1,
  debugger: 1,
  interface: 1,
  protected: 1,
  instanceof: 1,
  implements: 1
};
function fot() {
  for (; Qt < tc; ) {
    const t = Hn.charCodeAt(Qt);
    if (A0r(t) || NN(t))
      ++Qt;
    else
      break;
  }
}
function aoe(t) {
  var e, n, r, i = 0;
  for (n = t === "u" ? 4 : 2, e = 0; e < n; ++e)
    Qt < tc && wpe(Hn[Qt]) ? (r = Hn[Qt++], i = i * 16 + "0123456789abcdef".indexOf(r.toLowerCase())) : qi({}, MA, cl);
  return String.fromCharCode(i);
}
function c0r() {
  var t, e, n, r;
  for (t = Hn[Qt], e = 0, t === "}" && qi({}, MA, cl); Qt < tc && (t = Hn[Qt++], !!wpe(t)); )
    e = e * 16 + "0123456789abcdef".indexOf(t.toLowerCase());
  return (e > 1114111 || t !== "}") && qi({}, MA, cl), e <= 65535 ? String.fromCharCode(e) : (n = (e - 65536 >> 10) + 55296, r = (e - 65536 & 1023) + 56320, String.fromCharCode(n, r));
}
function got() {
  var t, e;
  for (t = Hn.charCodeAt(Qt++), e = String.fromCharCode(t), t === 92 && (Hn.charCodeAt(Qt) !== 117 && qi({}, MA, cl), ++Qt, t = aoe("u"), (!t || t === "\\" || !wO(t.charCodeAt(0))) && qi({}, MA, cl), e = t); Qt < tc && (t = Hn.charCodeAt(Qt), !!b6(t)); )
    ++Qt, e += String.fromCharCode(t), t === 92 && (e = e.substr(0, e.length - 1), Hn.charCodeAt(Qt) !== 117 && qi({}, MA, cl), ++Qt, t = aoe("u"), (!t || t === "\\" || !b6(t.charCodeAt(0))) && qi({}, MA, cl), e += t);
  return e;
}
function u0r() {
  var t, e;
  for (t = Qt++; Qt < tc; ) {
    if (e = Hn.charCodeAt(Qt), e === 92)
      return Qt = t, got();
    if (b6(e))
      ++Qt;
    else
      break;
  }
  return Hn.slice(t, Qt);
}
function f0r() {
  var t, e, n;
  return t = Qt, e = Hn.charCodeAt(Qt) === 92 ? got() : u0r(), e.length === 1 ? n = SB : l0r.hasOwnProperty(e) ? n = qE : e === "null" ? n = eY : e === "true" || e === "false" ? n = Zj : n = SB, {
    type: n,
    value: e,
    start: t,
    end: Qt
  };
}
function ZW() {
  var t = Qt, e = Hn.charCodeAt(Qt), n, r = Hn[Qt], i, o, s;
  switch (e) {
    case 46:
    case 40:
    case 41:
    case 59:
    case 44:
    case 123:
    case 125:
    case 91:
    case 93:
    case 58:
    case 63:
    case 126:
      return ++Qt, {
        type: mu,
        value: String.fromCharCode(e),
        start: t,
        end: Qt
      };
    default:
      if (n = Hn.charCodeAt(Qt + 1), n === 61)
        switch (e) {
          case 43:
          case 45:
          case 47:
          case 60:
          case 62:
          case 94:
          case 124:
          case 37:
          case 38:
          case 42:
            return Qt += 2, {
              type: mu,
              value: String.fromCharCode(e) + String.fromCharCode(n),
              start: t,
              end: Qt
            };
          case 33:
          case 61:
            return Qt += 2, Hn.charCodeAt(Qt) === 61 && ++Qt, {
              type: mu,
              value: Hn.slice(t, Qt),
              start: t,
              end: Qt
            };
        }
  }
  if (s = Hn.substr(Qt, 4), s === ">>>=")
    return Qt += 4, {
      type: mu,
      value: s,
      start: t,
      end: Qt
    };
  if (o = s.substr(0, 3), o === ">>>" || o === "<<=" || o === ">>=")
    return Qt += 3, {
      type: mu,
      value: o,
      start: t,
      end: Qt
    };
  if (i = o.substr(0, 2), r === i[1] && "+-<>&|".indexOf(r) >= 0 || i === "=>")
    return Qt += 2, {
      type: mu,
      value: i,
      start: t,
      end: Qt
    };
  if (i === "//" && qi({}, MA, cl), "<>=!+-*%&|^/".indexOf(r) >= 0)
    return ++Qt, {
      type: mu,
      value: r,
      start: t,
      end: Qt
    };
  qi({}, MA, cl);
}
function g0r(t) {
  let e = "";
  for (; Qt < tc && wpe(Hn[Qt]); )
    e += Hn[Qt++];
  return e.length === 0 && qi({}, MA, cl), wO(Hn.charCodeAt(Qt)) && qi({}, MA, cl), {
    type: Q1,
    value: parseInt("0x" + e, 16),
    start: t,
    end: Qt
  };
}
function h0r(t) {
  let e = "0" + Hn[Qt++];
  for (; Qt < tc && JD(Hn[Qt]); )
    e += Hn[Qt++];
  return (wO(Hn.charCodeAt(Qt)) || eI(Hn.charCodeAt(Qt))) && qi({}, MA, cl), {
    type: Q1,
    value: parseInt(e, 8),
    octal: !0,
    start: t,
    end: Qt
  };
}
function FOe() {
  var t, e, n;
  if (n = Hn[Qt], tY(eI(n.charCodeAt(0)) || n === ".", "Numeric literal must start with a decimal digit or a decimal point"), e = Qt, t = "", n !== ".") {
    if (t = Hn[Qt++], n = Hn[Qt], t === "0") {
      if (n === "x" || n === "X")
        return ++Qt, g0r(e);
      if (JD(n))
        return h0r(e);
      n && eI(n.charCodeAt(0)) && qi({}, MA, cl);
    }
    for (; eI(Hn.charCodeAt(Qt)); )
      t += Hn[Qt++];
    n = Hn[Qt];
  }
  if (n === ".") {
    for (t += Hn[Qt++]; eI(Hn.charCodeAt(Qt)); )
      t += Hn[Qt++];
    n = Hn[Qt];
  }
  if (n === "e" || n === "E")
    if (t += Hn[Qt++], n = Hn[Qt], (n === "+" || n === "-") && (t += Hn[Qt++]), eI(Hn.charCodeAt(Qt)))
      for (; eI(Hn.charCodeAt(Qt)); )
        t += Hn[Qt++];
    else
      qi({}, MA, cl);
  return wO(Hn.charCodeAt(Qt)) && qi({}, MA, cl), {
    type: Q1,
    value: parseFloat(t),
    start: e,
    end: Qt
  };
}
function d0r() {
  var t = "", e, n, r, i, o = !1;
  for (e = Hn[Qt], tY(e === "'" || e === '"', "String literal must starts with a quote"), n = Qt, ++Qt; Qt < tc; )
    if (r = Hn[Qt++], r === e) {
      e = "";
      break;
    } else if (r === "\\")
      if (r = Hn[Qt++], !r || !NN(r.charCodeAt(0)))
        switch (r) {
          case "u":
          case "x":
            Hn[Qt] === "{" ? (++Qt, t += c0r()) : t += aoe(r);
            break;
          case "n":
            t += `
`;
            break;
          case "r":
            t += "\r";
            break;
          case "t":
            t += "	";
            break;
          case "b":
            t += "\b";
            break;
          case "f":
            t += "\f";
            break;
          case "v":
            t += "\v";
            break;
          default:
            JD(r) ? (i = "01234567".indexOf(r), i !== 0 && (o = !0), Qt < tc && JD(Hn[Qt]) && (o = !0, i = i * 8 + "01234567".indexOf(Hn[Qt++]), "0123".indexOf(r) >= 0 && Qt < tc && JD(Hn[Qt]) && (i = i * 8 + "01234567".indexOf(Hn[Qt++]))), t += String.fromCharCode(i)) : t += r;
            break;
        }
      else
        r === "\r" && Hn[Qt] === `
` && ++Qt;
    else {
      if (NN(r.charCodeAt(0)))
        break;
      t += r;
    }
  return e !== "" && qi({}, MA, cl), {
    type: QO,
    value: t,
    octal: o,
    start: n,
    end: Qt
  };
}
function p0r(t, e) {
  let n = t;
  e.indexOf("u") >= 0 && (n = n.replace(/\\u\{([0-9a-fA-F]+)\}/g, (r, i) => {
    if (parseInt(i, 16) <= 1114111)
      return "x";
    qi({}, soe);
  }).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "x"));
  try {
    new RegExp(n);
  } catch {
    qi({}, soe);
  }
  try {
    return new RegExp(t, e);
  } catch {
    return null;
  }
}
function I0r() {
  var t, e, n, r, i;
  for (t = Hn[Qt], tY(t === "/", "Regular expression literal must start with a slash"), e = Hn[Qt++], n = !1, r = !1; Qt < tc; )
    if (t = Hn[Qt++], e += t, t === "\\")
      t = Hn[Qt++], NN(t.charCodeAt(0)) && qi({}, XW), e += t;
    else if (NN(t.charCodeAt(0)))
      qi({}, XW);
    else if (n)
      t === "]" && (n = !1);
    else if (t === "/") {
      r = !0;
      break;
    } else
      t === "[" && (n = !0);
  return r || qi({}, XW), i = e.substr(1, e.length - 2), {
    value: i,
    literal: e
  };
}
function m0r() {
  var t, e, n;
  for (e = "", n = ""; Qt < tc && (t = Hn[Qt], !!b6(t.charCodeAt(0))); )
    ++Qt, t === "\\" && Qt < tc ? qi({}, MA, cl) : (n += t, e += t);
  return n.search(/[^gimuy]/g) >= 0 && qi({}, soe, n), {
    value: n,
    literal: e
  };
}
function C0r() {
  var t, e, n, r;
  return wo = null, fot(), t = Qt, e = I0r(), n = m0r(), r = p0r(e.value, n.value), {
    literal: e.literal + n.literal,
    value: r,
    regex: {
      pattern: e.value,
      flags: n.value
    },
    start: t,
    end: Qt
  };
}
function E0r(t) {
  return t.type === SB || t.type === qE || t.type === Zj || t.type === eY;
}
function hot() {
  if (fot(), Qt >= tc)
    return {
      type: SO,
      start: Qt,
      end: Qt
    };
  const t = Hn.charCodeAt(Qt);
  return wO(t) ? f0r() : t === 40 || t === 41 || t === 59 ? ZW() : t === 39 || t === 34 ? d0r() : t === 46 ? eI(Hn.charCodeAt(Qt + 1)) ? FOe() : ZW() : eI(t) ? FOe() : ZW();
}
function _u() {
  const t = wo;
  return Qt = t.end, wo = hot(), Qt = t.end, t;
}
function dot() {
  const t = Qt;
  wo = hot(), Qt = t;
}
function y0r(t) {
  const e = new Od(qpr);
  return e.elements = t, e;
}
function POe(t, e, n) {
  const r = new Od(t === "||" || t === "&&" ? Jpr : jpr);
  return r.operator = t, r.left = e, r.right = n, r;
}
function v0r(t, e) {
  const n = new Od(Ypr);
  return n.callee = t, n.arguments = e, n;
}
function B0r(t, e, n) {
  const r = new Od(zpr);
  return r.test = t, r.consequent = e, r.alternate = n, r;
}
function xpe(t) {
  const e = new Od(cot);
  return e.name = t, e;
}
function sD(t) {
  const e = new Od(Vpr);
  return e.value = t.value, e.raw = Hn.slice(t.start, t.end), t.regex && (e.raw === "//" && (e.raw = "/(?:)/"), e.regex = t.regex), e;
}
function kOe(t, e, n) {
  const r = new Od(Kpr);
  return r.computed = t === "[", r.object = e, r.property = n, r.computed || (n.member = !0), r;
}
function b0r(t) {
  const e = new Od(Wpr);
  return e.properties = t, e;
}
function GOe(t, e, n) {
  const r = new Od(Xpr);
  return r.key = e, r.value = n, r.kind = t, r;
}
function _0r(t, e) {
  const n = new Od(Zpr);
  return n.operator = t, n.argument = e, n.prefix = !0, n;
}
function qi(t, e) {
  var n, r = Array.prototype.slice.call(arguments, 2), i = e.replace(/%(\d)/g, (o, s) => (tY(s < r.length, "Message reference must be in range"), r[s]));
  throw n = new Error(i), n.index = Qt, n.description = i, n;
}
function nY(t) {
  t.type === SO && qi(t, i0r), t.type === Q1 && qi(t, e0r), t.type === QO && qi(t, t0r), t.type === SB && qi(t, n0r), t.type === qE && qi(t, r0r), qi(t, MA, t.value);
}
function nc(t) {
  const e = _u();
  (e.type !== mu || e.value !== t) && nY(e);
}
function gs(t) {
  return wo.type === mu && wo.value === t;
}
function eX(t) {
  return wo.type === qE && wo.value === t;
}
function S0r() {
  const t = [];
  for (Qt = wo.start, nc("["); !gs("]"); )
    gs(",") ? (_u(), t.push(null)) : (t.push(QB()), gs("]") || nc(","));
  return _u(), y0r(t);
}
function UOe() {
  Qt = wo.start;
  const t = _u();
  return t.type === QO || t.type === Q1 ? (t.octal && qi(t, uot), sD(t)) : xpe(t.value);
}
function Q0r() {
  var t, e, n, r;
  if (Qt = wo.start, t = wo, t.type === SB)
    return n = UOe(), nc(":"), r = QB(), GOe("init", n, r);
  if (t.type === SO || t.type === mu)
    nY(t);
  else
    return e = UOe(), nc(":"), r = QB(), GOe("init", e, r);
}
function w0r() {
  var t = [], e, n, r, i = {}, o = String;
  for (Qt = wo.start, nc("{"); !gs("}"); )
    e = Q0r(), e.key.type === cot ? n = e.key.name : n = o(e.key.value), r = "$" + n, Object.prototype.hasOwnProperty.call(i, r) ? qi({}, o0r) : i[r] = !0, t.push(e), gs("}") || nc(",");
  return nc("}"), b0r(t);
}
function x0r() {
  nc("(");
  const t = Rpe();
  return nc(")"), t;
}
const R0r = {
  if: 1
};
function D0r() {
  var t, e, n;
  if (gs("("))
    return x0r();
  if (gs("["))
    return S0r();
  if (gs("{"))
    return w0r();
  if (t = wo.type, Qt = wo.start, t === SB || R0r[wo.value])
    n = xpe(_u().value);
  else if (t === QO || t === Q1)
    wo.octal && qi(wo, uot), n = sD(_u());
  else {
    if (t === qE)
      throw new Error(TN);
    t === Zj ? (e = _u(), e.value = e.value === "true", n = sD(e)) : t === eY ? (e = _u(), e.value = null, n = sD(e)) : gs("/") || gs("/=") ? (n = sD(C0r()), dot()) : nY(_u());
  }
  return n;
}
function T0r() {
  const t = [];
  if (nc("("), !gs(")"))
    for (; Qt < tc && (t.push(QB()), !gs(")")); )
      nc(",");
  return nc(")"), t;
}
function N0r() {
  Qt = wo.start;
  const t = _u();
  return E0r(t) || nY(t), xpe(t.value);
}
function L0r() {
  return nc("."), N0r();
}
function M0r() {
  nc("[");
  const t = Rpe();
  return nc("]"), t;
}
function O0r() {
  var t, e, n;
  for (t = D0r(); ; )
    if (gs("."))
      n = L0r(), t = kOe(".", t, n);
    else if (gs("("))
      e = T0r(), t = v0r(t, e);
    else if (gs("["))
      n = M0r(), t = kOe("[", t, n);
    else
      break;
  return t;
}
function HOe() {
  const t = O0r();
  if (wo.type === mu && (gs("++") || gs("--")))
    throw new Error(TN);
  return t;
}
function l4() {
  var t, e;
  if (wo.type !== mu && wo.type !== qE)
    e = HOe();
  else {
    if (gs("++") || gs("--"))
      throw new Error(TN);
    if (gs("+") || gs("-") || gs("~") || gs("!"))
      t = _u(), e = l4(), e = _0r(t.value, e);
    else {
      if (eX("delete") || eX("void") || eX("typeof"))
        throw new Error(TN);
      e = HOe();
    }
  }
  return e;
}
function $Oe(t) {
  let e = 0;
  if (t.type !== mu && t.type !== qE)
    return 0;
  switch (t.value) {
    case "||":
      e = 1;
      break;
    case "&&":
      e = 2;
      break;
    case "|":
      e = 3;
      break;
    case "^":
      e = 4;
      break;
    case "&":
      e = 5;
      break;
    case "==":
    case "!=":
    case "===":
    case "!==":
      e = 6;
      break;
    case "<":
    case ">":
    case "<=":
    case ">=":
    case "instanceof":
    case "in":
      e = 7;
      break;
    case "<<":
    case ">>":
    case ">>>":
      e = 8;
      break;
    case "+":
    case "-":
      e = 9;
      break;
    case "*":
    case "/":
    case "%":
      e = 11;
      break;
  }
  return e;
}
function F0r() {
  var t, e, n, r, i, o, s, a, A, l;
  if (t = wo, A = l4(), r = wo, i = $Oe(r), i === 0)
    return A;
  for (r.prec = i, _u(), e = [t, wo], s = l4(), o = [A, r, s]; (i = $Oe(wo)) > 0; ) {
    for (; o.length > 2 && i <= o[o.length - 2].prec; )
      s = o.pop(), a = o.pop().value, A = o.pop(), e.pop(), n = POe(a, A, s), o.push(n);
    r = _u(), r.prec = i, o.push(r), e.push(wo), n = l4(), o.push(n);
  }
  for (l = o.length - 1, n = o[l], e.pop(); l > 1; )
    e.pop(), n = POe(o[l - 1].value, o[l - 2], n), l -= 2;
  return n;
}
function QB() {
  var t, e, n;
  return t = F0r(), gs("?") && (_u(), e = QB(), nc(":"), n = QB(), t = B0r(t, e, n)), t;
}
function Rpe() {
  const t = QB();
  if (gs(","))
    throw new Error(TN);
  return t;
}
function Dpe(t) {
  Hn = t, Qt = 0, tc = Hn.length, wo = null, dot();
  const e = Rpe();
  if (wo.type !== SO)
    throw new Error("Unexpect token after expression.");
  return e;
}
var pot = {
  NaN: "NaN",
  E: "Math.E",
  LN2: "Math.LN2",
  LN10: "Math.LN10",
  LOG2E: "Math.LOG2E",
  LOG10E: "Math.LOG10E",
  PI: "Math.PI",
  SQRT1_2: "Math.SQRT1_2",
  SQRT2: "Math.SQRT2",
  MIN_VALUE: "Number.MIN_VALUE",
  MAX_VALUE: "Number.MAX_VALUE"
};
function Iot(t) {
  function e(s, a, A, l) {
    let c = t(a[0]);
    return A && (c = A + "(" + c + ")", A.lastIndexOf("new ", 0) === 0 && (c = "(" + c + ")")), c + "." + s + (l < 0 ? "" : l === 0 ? "()" : "(" + a.slice(1).map(t).join(",") + ")");
  }
  function n(s, a, A) {
    return (l) => e(s, l, a, A);
  }
  const r = "new Date", i = "String", o = "RegExp";
  return {
    // MATH functions
    isNaN: "Number.isNaN",
    isFinite: "Number.isFinite",
    abs: "Math.abs",
    acos: "Math.acos",
    asin: "Math.asin",
    atan: "Math.atan",
    atan2: "Math.atan2",
    ceil: "Math.ceil",
    cos: "Math.cos",
    exp: "Math.exp",
    floor: "Math.floor",
    log: "Math.log",
    max: "Math.max",
    min: "Math.min",
    pow: "Math.pow",
    random: "Math.random",
    round: "Math.round",
    sin: "Math.sin",
    sqrt: "Math.sqrt",
    tan: "Math.tan",
    clamp: function(s) {
      s.length < 3 && wt("Missing arguments to clamp function."), s.length > 3 && wt("Too many arguments to clamp function.");
      const a = s.map(t);
      return "Math.max(" + a[1] + ", Math.min(" + a[2] + "," + a[0] + "))";
    },
    // DATE functions
    now: "Date.now",
    utc: "Date.UTC",
    datetime: r,
    date: n("getDate", r, 0),
    day: n("getDay", r, 0),
    year: n("getFullYear", r, 0),
    month: n("getMonth", r, 0),
    hours: n("getHours", r, 0),
    minutes: n("getMinutes", r, 0),
    seconds: n("getSeconds", r, 0),
    milliseconds: n("getMilliseconds", r, 0),
    time: n("getTime", r, 0),
    timezoneoffset: n("getTimezoneOffset", r, 0),
    utcdate: n("getUTCDate", r, 0),
    utcday: n("getUTCDay", r, 0),
    utcyear: n("getUTCFullYear", r, 0),
    utcmonth: n("getUTCMonth", r, 0),
    utchours: n("getUTCHours", r, 0),
    utcminutes: n("getUTCMinutes", r, 0),
    utcseconds: n("getUTCSeconds", r, 0),
    utcmilliseconds: n("getUTCMilliseconds", r, 0),
    // sequence functions
    length: n("length", null, -1),
    // STRING functions
    parseFloat: "parseFloat",
    parseInt: "parseInt",
    upper: n("toUpperCase", i, 0),
    lower: n("toLowerCase", i, 0),
    substring: n("substring", i),
    split: n("split", i),
    trim: n("trim", i, 0),
    // REGEXP functions
    regexp: o,
    test: n("test", o),
    // Control Flow functions
    if: function(s) {
      s.length < 3 && wt("Missing arguments to if function."), s.length > 3 && wt("Too many arguments to if function.");
      const a = s.map(t);
      return "(" + a[0] + "?" + a[1] + ":" + a[2] + ")";
    }
  };
}
function P0r(t) {
  const e = t && t.length - 1;
  return e && (t[0] === '"' && t[e] === '"' || t[0] === "'" && t[e] === "'") ? t.slice(1, -1) : t;
}
function mot(t) {
  t = t || {};
  const e = t.allowed ? pd(t.allowed) : {}, n = t.forbidden ? pd(t.forbidden) : {}, r = t.constants || pot, i = (t.functions || Iot)(u), o = t.globalvar, s = t.fieldvar, a = ri(o) ? o : (d) => `${o}["${d}"]`;
  let A = {}, l = {}, c = 0;
  function u(d) {
    if (Cn(d))
      return d;
    const I = f[d.type];
    return I == null && wt("Unsupported type: " + d.type), I(d);
  }
  const f = {
    Literal: (d) => d.raw,
    Identifier: (d) => {
      const I = d.name;
      return c > 0 ? I : Kn(n, I) ? wt("Illegal identifier: " + I) : Kn(r, I) ? r[I] : Kn(e, I) ? I : (A[I] = 1, a(I));
    },
    MemberExpression: (d) => {
      const I = !d.computed, m = u(d.object);
      I && (c += 1);
      const C = u(d.property);
      return m === s && (l[P0r(C)] = 1), I && (c -= 1), m + (I ? "." + C : "[" + C + "]");
    },
    CallExpression: (d) => {
      d.callee.type !== "Identifier" && wt("Illegal callee type: " + d.callee.type);
      const I = d.callee.name, m = d.arguments, C = Kn(i, I) && i[I];
      return C || wt("Unrecognized function: " + I), ri(C) ? C(m) : C + "(" + m.map(u).join(",") + ")";
    },
    ArrayExpression: (d) => "[" + d.elements.map(u).join(",") + "]",
    BinaryExpression: (d) => "(" + u(d.left) + " " + d.operator + " " + u(d.right) + ")",
    UnaryExpression: (d) => "(" + d.operator + u(d.argument) + ")",
    ConditionalExpression: (d) => "(" + u(d.test) + "?" + u(d.consequent) + ":" + u(d.alternate) + ")",
    LogicalExpression: (d) => "(" + u(d.left) + d.operator + u(d.right) + ")",
    ObjectExpression: (d) => "{" + d.properties.map(u).join(",") + "}",
    Property: (d) => {
      c += 1;
      const I = u(d.key);
      return c -= 1, I + ":" + u(d.value);
    }
  };
  function h(d) {
    const I = {
      code: u(d),
      globals: Object.keys(A),
      fields: Object.keys(l)
    };
    return A = {}, l = {}, I;
  }
  return h.functions = i, h.constants = r, h;
}
function qOe(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function k0r(t) {
  let e = t, n = t, r = t;
  t.length !== 2 && (e = (a, A) => t(a) - A, n = qOe, r = (a, A) => qOe(t(a), A));
  function i(a, A, l = 0, c = a.length) {
    if (l < c) {
      if (n(A, A) !== 0)
        return c;
      do {
        const u = l + c >>> 1;
        r(a[u], A) < 0 ? l = u + 1 : c = u;
      } while (l < c);
    }
    return l;
  }
  function o(a, A, l = 0, c = a.length) {
    if (l < c) {
      if (n(A, A) !== 0)
        return c;
      do {
        const u = l + c >>> 1;
        r(a[u], A) <= 0 ? l = u + 1 : c = u;
      } while (l < c);
    }
    return l;
  }
  function s(a, A, l = 0, c = a.length) {
    const u = i(a, A, l, c - 1);
    return u > l && e(a[u - 1], A) > -e(a[u], A) ? u - 1 : u;
  }
  return { left: i, center: s, right: o };
}
function G0r(t, ...e) {
  t = new tU(t), e = e.map(U0r);
  e:
    for (const n of t)
      for (const r of e)
        if (!r.has(n)) {
          t.delete(n);
          continue e;
        }
  return t;
}
function U0r(t) {
  return t instanceof tU ? t : new tU(t);
}
function H0r(...t) {
  const e = new tU();
  for (const n of t)
    for (const r of n)
      e.add(r);
  return e;
}
const Tpe = "intersect", jOe = "union", $0r = "vlMulti", q0r = "vlPoint", YOe = "or", j0r = "and", fp = "_vgsid_", LN = ku(fp), Y0r = "E", z0r = "R", V0r = "R-E", J0r = "R-LE", K0r = "R-RE", _6 = "index:unit";
function zOe(t, e) {
  for (var n = e.fields, r = e.values, i = n.length, o = 0, s, a; o < i; ++o)
    if (a = n[o], a.getter = ku.getter || ku(a.field), s = a.getter(t), NC(s) && (s = Kl(s)), NC(r[o]) && (r[o] = Kl(r[o])), NC(r[o][0]) && (r[o] = r[o].map(Kl)), a.type === Y0r) {
      if (Nt(r[o]) ? r[o].indexOf(s) < 0 : s !== r[o])
        return !1;
    } else if (a.type === z0r) {
      if (!b_(s, r[o]))
        return !1;
    } else if (a.type === K0r) {
      if (!b_(s, r[o], !0, !1))
        return !1;
    } else if (a.type === V0r) {
      if (!b_(s, r[o], !1, !1))
        return !1;
    } else if (a.type === J0r && !b_(s, r[o], !1, !0))
      return !1;
  return !0;
}
function W0r(t, e, n) {
  for (var r = this.context.data[t], i = r ? r.values.value : [], o = r ? r[_6] && r[_6].value : void 0, s = n === Tpe, a = i.length, A = 0, l, c, u, f, h; A < a; ++A)
    if (l = i[A], o && s) {
      if (c = c || {}, u = c[f = l.unit] || 0, u === -1)
        continue;
      if (h = zOe(e, l), c[f] = h ? -1 : ++u, h && o.size === 1)
        return !0;
      if (!h && u === o.get(f).count)
        return !1;
    } else if (h = zOe(e, l), s ^ h)
      return h;
  return a && s;
}
const Cot = k0r(LN), X0r = Cot.left, Z0r = Cot.right;
function eIr(t, e, n) {
  const r = this.context.data[t], i = r ? r.values.value : [], o = r ? r[_6] && r[_6].value : void 0, s = n === Tpe, a = LN(e), A = X0r(i, a);
  if (A === i.length || LN(i[A]) !== a)
    return !1;
  if (o && s) {
    if (o.size === 1)
      return !0;
    if (Z0r(i, a) - A < o.size)
      return !1;
  }
  return !0;
}
function tIr(t, e) {
  return t.map((n) => ni(e.fields ? {
    values: e.fields.map((r) => (r.getter || (r.getter = ku(r.field)))(n.datum))
  } : {
    [fp]: LN(n.datum)
  }, e));
}
function nIr(t, e, n, r) {
  for (var i = this.context.data[t], o = i ? i.values.value : [], s = {}, a = {}, A = {}, l, c, u, f, h, d, I, m, C, y, v = o.length, b = 0, Q, w; b < v; ++b)
    if (l = o[b], f = l.unit, c = l.fields, u = l.values, c && u) {
      for (Q = 0, w = c.length; Q < w; ++Q)
        h = c[Q], I = s[h.field] || (s[h.field] = {}), m = I[f] || (I[f] = []), A[h.field] = C = h.type.charAt(0), y = tX["".concat(C, "_union")], I[f] = y(m, bn(u[Q]));
      n && (m = a[f] || (a[f] = []), m.push(bn(u).reduce((R, M, O) => (R[c[O].field] = M, R), {})));
    } else
      h = fp, d = LN(l), I = s[h] || (s[h] = {}), m = I[f] || (I[f] = []), m.push(d), n && (m = a[f] || (a[f] = []), m.push({
        [fp]: d
      }));
  if (e = e || jOe, s[fp] ? s[fp] = tX["".concat(fp, "_").concat(e)](...Object.values(s[fp])) : Object.keys(s).forEach((R) => {
    s[R] = Object.keys(s[R]).map((M) => s[R][M]).reduce((M, O) => M === void 0 ? O : tX["".concat(A[R], "_").concat(e)](M, O));
  }), o = Object.keys(a), n && o.length) {
    const R = r ? q0r : $0r;
    s[R] = e === jOe ? {
      [YOe]: o.reduce((M, O) => (M.push(...a[O]), M), [])
    } : {
      [j0r]: o.map((M) => ({
        [YOe]: a[M]
      }))
    };
  }
  return s;
}
var tX = {
  ["".concat(fp, "_union")]: H0r,
  ["".concat(fp, "_intersect")]: G0r,
  E_union: function(t, e) {
    if (!t.length)
      return e;
    for (var n = 0, r = e.length; n < r; ++n)
      t.indexOf(e[n]) < 0 && t.push(e[n]);
    return t;
  },
  E_intersect: function(t, e) {
    return t.length ? t.filter((n) => e.indexOf(n) >= 0) : e;
  },
  R_union: function(t, e) {
    var n = Kl(e[0]), r = Kl(e[1]);
    return n > r && (n = e[1], r = e[0]), t.length ? (t[0] > n && (t[0] = n), t[1] < r && (t[1] = r), t) : [n, r];
  },
  R_intersect: function(t, e) {
    var n = Kl(e[0]), r = Kl(e[1]);
    return n > r && (n = e[1], r = e[0]), t.length ? r < t[0] || t[1] < n ? [] : (t[0] < n && (t[0] = n), t[1] > r && (t[1] = r), t) : [n, r];
  }
};
const rIr = ":", iIr = "@";
function Npe(t, e, n, r) {
  e[0].type !== _B && wt("First argument to selection functions must be a string literal.");
  const i = e[0].value, o = e.length >= 2 && bi(e).value, s = "unit", a = iIr + s, A = rIr + i;
  o === Tpe && !Kn(r, a) && (r[a] = n.getData(i).indataRef(n, s)), Kn(r, A) || (r[A] = n.getData(i).tuplesRef());
}
function Eot(t) {
  const e = this.context.data[t];
  return e ? e.values.value : [];
}
function oIr(t, e, n) {
  const r = this.context.data[t]["index:" + e], i = r ? r.value.get(n) : void 0;
  return i && i.count;
}
function sIr(t, e) {
  const n = this.context.dataflow, r = this.context.data[t], i = r.input;
  return n.pulse(i, n.changeset().remove(qg).insert(e)), 1;
}
function aIr(t, e, n) {
  if (t) {
    const r = this.context.dataflow, i = t.mark.source;
    r.pulse(i, r.changeset().encode(t, e));
  }
  return n !== void 0 ? n : t;
}
const xO = (t) => function(e, n) {
  return this.context.dataflow.locale()[t](n)(e);
}, AIr = xO("format"), yot = xO("timeFormat"), lIr = xO("utcFormat"), cIr = xO("timeParse"), uIr = xO("utcParse"), F3 = new Date(2e3, 0, 1);
function rY(t, e, n) {
  return !Number.isInteger(t) || !Number.isInteger(e) ? "" : (F3.setYear(2e3), F3.setMonth(t), F3.setDate(e), yot.call(this, F3, n));
}
function fIr(t) {
  return rY.call(this, t, 1, "%B");
}
function gIr(t) {
  return rY.call(this, t, 1, "%b");
}
function hIr(t) {
  return rY.call(this, 0, 2 + t, "%A");
}
function dIr(t) {
  return rY.call(this, 0, 2 + t, "%a");
}
const pIr = ":", IIr = "@", Aoe = "%", vot = "$";
function Lpe(t, e, n, r) {
  e[0].type !== _B && wt("First argument to data functions must be a string literal.");
  const i = e[0].value, o = pIr + i;
  if (!Kn(o, r))
    try {
      r[o] = n.getData(i).tuplesRef();
    } catch {
    }
}
function mIr(t, e, n, r) {
  e[0].type !== _B && wt("First argument to indata must be a string literal."), e[1].type !== _B && wt("Second argument to indata must be a string literal.");
  const i = e[0].value, o = e[1].value, s = IIr + o;
  Kn(s, r) || (r[s] = n.getData(i).indataRef(n, o));
}
function Tu(t, e, n, r) {
  if (e[0].type === _B)
    VOe(n, r, e[0].value);
  else
    for (t in n.scales)
      VOe(n, r, t);
}
function VOe(t, e, n) {
  const r = Aoe + n;
  if (!Kn(e, r))
    try {
      e[r] = t.scaleRef(n);
    } catch {
    }
}
function Am(t, e) {
  let n;
  return ri(t) ? t : Cn(t) ? (n = e.scales[t]) && n.value : void 0;
}
function CIr(t, e, n) {
  e.__bandwidth = (i) => i && i.bandwidth ? i.bandwidth() : 0, n._bandwidth = Tu, n._range = Tu, n._scale = Tu;
  const r = (i) => "_[" + (i.type === _B ? an(Aoe + i.value) : an(Aoe) + "+" + t(i)) + "]";
  return {
    _bandwidth: (i) => "this.__bandwidth(".concat(r(i[0]), ")"),
    _range: (i) => "".concat(r(i[0]), ".range()"),
    _scale: (i) => "".concat(r(i[0]), "(").concat(t(i[1]), ")")
  };
}
function Mpe(t, e) {
  return function(n, r, i) {
    if (n) {
      const o = Am(n, (i || this).context);
      return o && o.path[t](r);
    } else
      return e(r);
  };
}
const EIr = Mpe("area", Uur), yIr = Mpe("bounds", jur), vIr = Mpe("centroid", Wur);
function BIr(t) {
  const e = this.context.group;
  let n = !1;
  if (e)
    for (; t; ) {
      if (t === e) {
        n = !0;
        break;
      }
      t = t.mark.group;
    }
  return n;
}
function Ope(t, e, n) {
  try {
    t[e].apply(t, ["EXPRESSION"].concat([].slice.call(n)));
  } catch (r) {
    t.warn(r);
  }
  return n[n.length - 1];
}
function bIr() {
  return Ope(this.context.dataflow, "warn", arguments);
}
function _Ir() {
  return Ope(this.context.dataflow, "info", arguments);
}
function SIr() {
  return Ope(this.context.dataflow, "debug", arguments);
}
function nX(t) {
  const e = t / 255;
  return e <= 0.03928 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
}
function loe(t) {
  const e = oE(t), n = nX(e.r), r = nX(e.g), i = nX(e.b);
  return 0.2126 * n + 0.7152 * r + 0.0722 * i;
}
function QIr(t, e) {
  const n = loe(t), r = loe(e), i = Math.max(n, r), o = Math.min(n, r);
  return (i + 0.05) / (o + 0.05);
}
function wIr() {
  const t = [].slice.call(arguments);
  return t.unshift({}), ni(...t);
}
function Bot(t, e) {
  return t === e || t !== t && e !== e ? !0 : Nt(t) ? Nt(e) && t.length === e.length ? xIr(t, e) : !1 : _n(t) && _n(e) ? bot(t, e) : !1;
}
function xIr(t, e) {
  for (let n = 0, r = t.length; n < r; ++n)
    if (!Bot(t[n], e[n]))
      return !1;
  return !0;
}
function bot(t, e) {
  for (const n in t)
    if (!Bot(t[n], e[n]))
      return !1;
  return !0;
}
function JOe(t) {
  return (e) => bot(t, e);
}
function RIr(t, e, n, r, i, o) {
  const s = this.context.dataflow, a = this.context.data[t], A = a.input, l = s.stamp();
  let c = a.changes, u, f;
  if (s._trigger === !1 || !(A.value.length || e || r))
    return 0;
  if ((!c || c.stamp < l) && (a.changes = c = s.changeset(), c.stamp = l, s.runAfter(() => {
    a.modified = !0, s.pulse(A, c).run();
  }, !0, 1)), n && (u = n === !0 ? qg : Nt(n) || hj(n) ? n : JOe(n), c.remove(u)), e && c.insert(e), r && (u = JOe(r), A.value.some(u) ? c.remove(u) : c.insert(r)), i)
    for (f in o)
      c.modify(i, f, o[f]);
  return 1;
}
function DIr(t) {
  const e = t.touches, n = e[0].clientX - e[1].clientX, r = e[0].clientY - e[1].clientY;
  return Math.sqrt(n * n + r * r);
}
function TIr(t) {
  const e = t.touches;
  return Math.atan2(e[0].clientY - e[1].clientY, e[0].clientX - e[1].clientX);
}
const KOe = {};
function NIr(t, e) {
  const n = KOe[e] || (KOe[e] = ku(e));
  return Nt(t) ? t.map(n) : n(t);
}
function Fpe(t) {
  return Nt(t) || ArrayBuffer.isView(t) ? t : null;
}
function Ppe(t) {
  return Fpe(t) || (Cn(t) ? t : null);
}
function LIr(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  return Fpe(t).join(...n);
}
function MIr(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  return Ppe(t).indexOf(...n);
}
function OIr(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  return Ppe(t).lastIndexOf(...n);
}
function FIr(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  return Ppe(t).slice(...n);
}
function PIr(t, e, n) {
  return ri(n) && wt("Function argument passed to replace."), String(t).replace(e, n);
}
function kIr(t) {
  return Fpe(t).slice().reverse();
}
function GIr(t, e, n) {
  return zhe(t || 0, e || 0, n || 0);
}
function UIr(t, e) {
  const n = Am(t, (e || this).context);
  return n && n.bandwidth ? n.bandwidth() : 0;
}
function HIr(t, e) {
  const n = Am(t, (e || this).context);
  return n ? n.copy() : void 0;
}
function $Ir(t, e) {
  const n = Am(t, (e || this).context);
  return n ? n.domain() : [];
}
function qIr(t, e, n) {
  const r = Am(t, (n || this).context);
  return r ? Nt(e) ? (r.invertRange || r.invert)(e) : (r.invert || r.invertExtent)(e) : void 0;
}
function jIr(t, e) {
  const n = Am(t, (e || this).context);
  return n && n.range ? n.range() : [];
}
function YIr(t, e, n) {
  const r = Am(t, (n || this).context);
  return r ? r(e) : void 0;
}
function zIr(t, e, n, r, i) {
  t = Am(t, (i || this).context);
  const o = bnt(e, n);
  let s = t.domain(), a = s[0], A = bi(s), l = Ac;
  return A - a ? l = fnt(t, a, A) : t = (t.interpolator ? Vi("sequential")().interpolator(t.interpolator()) : Vi("linear")().interpolate(t.interpolate()).range(t.range())).domain([a = 0, A = 1]), t.ticks && (s = t.ticks(+r || 15), a !== s[0] && s.unshift(a), A !== bi(s) && s.push(A)), s.forEach((c) => o.stop(l(c), t(c))), o;
}
function VIr(t, e, n) {
  const r = Am(t, (n || this).context);
  return function(i) {
    return r ? r.path.context(i)(e) : "";
  };
}
function JIr(t) {
  let e = null;
  return function(n) {
    return n ? bN(n, e = e || BQ(t)) : t;
  };
}
const _ot = (t) => t.data;
function Sot(t, e) {
  const n = Eot.call(e, t);
  return n.root && n.root.lookup || {};
}
function KIr(t, e, n) {
  const r = Sot(t, this), i = r[e], o = r[n];
  return i && o ? i.path(o).map(_ot) : void 0;
}
function WIr(t, e) {
  const n = Sot(t, this)[e];
  return n ? n.ancestors().map(_ot) : void 0;
}
const Qot = () => typeof window < "u" && window || null;
function XIr() {
  const t = Qot();
  return t ? t.screen : {};
}
function ZIr() {
  const t = Qot();
  return t ? [t.innerWidth, t.innerHeight] : [void 0, void 0];
}
function emr() {
  const t = this.context.dataflow, e = t.container && t.container();
  return e ? [e.clientWidth, e.clientHeight] : [void 0, void 0];
}
function wot(t, e, n) {
  if (!t)
    return [];
  const [r, i] = t, o = new za().set(r[0], r[1], i[0], i[1]), s = n || this.context.dataflow.scenegraph().root;
  return hrt(s, o, tmr(e));
}
function tmr(t) {
  let e = null;
  if (t) {
    const n = bn(t.marktype), r = bn(t.markname);
    e = (i) => (!n.length || n.some((o) => i.marktype === o)) && (!r.length || r.some((o) => i.name === o));
  }
  return e;
}
function nmr(t, e, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 5;
  const i = t[t.length - 1];
  return i === void 0 || Math.sqrt((i[0] - e) ** 2 + (i[1] - n) ** 2) > r ? (t.push([e, n]), [...t]) : t;
}
function rmr(t) {
  return (t ?? []).reduce((e, n, r) => {
    let [i, o] = n;
    return e += r == 0 ? "M ".concat(i, ",").concat(o, " ") : r === t.length - 1 ? " Z" : "L ".concat(i, ",").concat(o, " ");
  }, "");
}
function imr(t, e, n) {
  const {
    x: r,
    y: i,
    mark: o
  } = n, s = new za().set(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER);
  for (const [A, l] of e)
    A < s.x1 && (s.x1 = A), A > s.x2 && (s.x2 = A), l < s.y1 && (s.y1 = l), l > s.y2 && (s.y2 = l);
  return s.translate(r, i), wot([[s.x1, s.y1], [s.x2, s.y2]], t, o).filter((A) => omr(A.x, A.y, e));
}
function omr(t, e, n) {
  let r = 0;
  for (let i = 0, o = n.length - 1; i < n.length; o = i++) {
    const [s, a] = n[o], [A, l] = n[i];
    l > e != a > e && t < (s - A) * (e - l) / (a - l) + A && r++;
  }
  return r & 1;
}
const MN = {
  random() {
    return Yg();
  },
  // override default
  cumulativeNormal: Cj,
  cumulativeLogNormal: Jge,
  cumulativeUniform: Zge,
  densityNormal: qge,
  densityLogNormal: Vge,
  densityUniform: Xge,
  quantileNormal: Ej,
  quantileLogNormal: Kge,
  quantileUniform: ehe,
  sampleNormal: mj,
  sampleLogNormal: zge,
  sampleUniform: Wge,
  isArray: Nt,
  isBoolean: PE,
  isDate: NC,
  isDefined(t) {
    return t !== void 0;
  },
  isNumber: Po,
  isObject: _n,
  isRegExp: kXe,
  isString: Cn,
  isTuple: hj,
  isValid(t) {
    return t != null && t === t;
  },
  toBoolean: hge,
  toDate(t) {
    return dge(t);
  },
  // suppress extra arguments
  toNumber: Kl,
  toString: pge,
  indexof: MIr,
  join: LIr,
  lastindexof: OIr,
  replace: PIr,
  reverse: kIr,
  slice: FIr,
  flush: FXe,
  lerp: GXe,
  merge: wIr,
  pad: $Xe,
  peek: bi,
  pluck: NIr,
  span: rO,
  inrange: b_,
  truncate: qXe,
  rgb: oE,
  lab: N5,
  hcl: L5,
  hsl: D5,
  luminance: loe,
  contrast: QIr,
  sequence: E1,
  format: AIr,
  utcFormat: lIr,
  utcParse: uIr,
  utcOffset: RZe,
  utcSequence: NZe,
  timeFormat: yot,
  timeParse: cIr,
  timeOffset: xZe,
  timeSequence: TZe,
  timeUnitSpecifier: mZe,
  monthFormat: fIr,
  monthAbbrevFormat: gIr,
  dayFormat: hIr,
  dayAbbrevFormat: dIr,
  quarter: NXe,
  utcquarter: LXe,
  week: EZe,
  utcweek: BZe,
  dayofyear: CZe,
  utcdayofyear: vZe,
  warn: bIr,
  info: _Ir,
  debug: SIr,
  extent(t) {
    return Jp(t);
  },
  // suppress extra arguments
  inScope: BIr,
  intersect: wot,
  clampRange: MXe,
  pinchDistance: DIr,
  pinchAngle: TIr,
  screen: XIr,
  containerSize: emr,
  windowSize: ZIr,
  bandspace: GIr,
  setdata: sIr,
  pathShape: JIr,
  panLinear: xXe,
  panLog: RXe,
  panPow: DXe,
  panSymlog: TXe,
  zoomLinear: Age,
  zoomLog: lge,
  zoomPow: h5,
  zoomSymlog: cge,
  encode: aIr,
  modify: RIr,
  lassoAppend: nmr,
  lassoPath: rmr,
  intersectLasso: imr
}, smr = ["view", "item", "group", "xy", "x", "y"], amr = "event.vega.", xot = "this.", kpe = {}, Rot = {
  forbidden: ["_"],
  allowed: ["datum", "event", "item"],
  fieldvar: "datum",
  globalvar: (t) => "_[".concat(an(vot + t), "]"),
  functions: Amr,
  constants: pot,
  visitors: kpe
}, coe = mot(Rot);
function Amr(t) {
  const e = Iot(t);
  smr.forEach((n) => e[n] = amr + n);
  for (const n in MN)
    e[n] = xot + n;
  return ni(e, CIr(t, MN, kpe)), e;
}
function Ka(t, e, n) {
  return arguments.length === 1 ? MN[t] : (MN[t] = e, n && (kpe[t] = n), coe && (coe.functions[t] = xot + t), this);
}
Ka("bandwidth", UIr, Tu);
Ka("copy", HIr, Tu);
Ka("domain", $Ir, Tu);
Ka("range", jIr, Tu);
Ka("invert", qIr, Tu);
Ka("scale", YIr, Tu);
Ka("gradient", zIr, Tu);
Ka("geoArea", EIr, Tu);
Ka("geoBounds", yIr, Tu);
Ka("geoCentroid", vIr, Tu);
Ka("geoShape", VIr, Tu);
Ka("indata", oIr, mIr);
Ka("data", Eot, Lpe);
Ka("treePath", KIr, Lpe);
Ka("treeAncestors", WIr, Lpe);
Ka("vlSelectionTest", W0r, Npe);
Ka("vlSelectionIdTest", eIr, Npe);
Ka("vlSelectionResolve", nIr, Npe);
Ka("vlSelectionTuples", tIr);
function Xp(t, e) {
  const n = {};
  let r;
  try {
    t = Cn(t) ? t : an(t) + "", r = Dpe(t);
  } catch {
    wt("Expression parse error: " + t);
  }
  r.visit((o) => {
    if (o.type !== lot)
      return;
    const s = o.callee.name, a = Rot.visitors[s];
    a && a(s, o.arguments, e, n);
  });
  const i = coe(r);
  return i.globals.forEach((o) => {
    const s = vot + o;
    !Kn(n, s) && e.getSignal(o) && (n[s] = e.signalRef(o));
  }), {
    $expr: ni({
      code: i.code
    }, e.options.ast ? {
      ast: r
    } : null),
    $fields: i.fields,
    $params: n
  };
}
function lmr(t) {
  const e = this, n = t.operators || [];
  return t.background && (e.background = t.background), t.eventConfig && (e.eventConfig = t.eventConfig), t.locale && (e.locale = t.locale), n.forEach((r) => e.parseOperator(r)), n.forEach((r) => e.parseOperatorParameters(r)), (t.streams || []).forEach((r) => e.parseStream(r)), (t.updates || []).forEach((r) => e.parseUpdate(r)), e.resolve();
}
const cmr = pd(["rule"]), WOe = pd(["group", "image", "rect"]);
function umr(t, e) {
  let n = "";
  return cmr[e] || (t.x2 && (t.x ? (WOe[e] && (n += "if(o.x>o.x2)$=o.x,o.x=o.x2,o.x2=$;"), n += "o.width=o.x2-o.x;") : n += "o.x=o.x2-(o.width||0);"), t.xc && (n += "o.x=o.xc-(o.width||0)/2;"), t.y2 && (t.y ? (WOe[e] && (n += "if(o.y>o.y2)$=o.y,o.y=o.y2,o.y2=$;"), n += "o.height=o.y2-o.y;") : n += "o.y=o.y2-(o.height||0);"), t.yc && (n += "o.y=o.yc-(o.height||0)/2;")), n;
}
function Gpe(t) {
  return (t + "").toLowerCase();
}
function fmr(t) {
  return Gpe(t) === "operator";
}
function gmr(t) {
  return Gpe(t) === "collect";
}
function X2(t, e, n) {
  n[n.length - 1] !== ";" && (n = "return(" + n + ");");
  const r = Function(...e.concat(n));
  return t && t.functions ? r.bind(t.functions) : r;
}
function hmr(t, e, n, r) {
  return "((u = ".concat(t, ") < (v = ").concat(e, ") || u == null) && v != null ? ").concat(n, `
  : (u > v || v == null) && u != null ? `).concat(r, `
  : ((v = v instanceof Date ? +v : v), (u = u instanceof Date ? +u : u)) !== u && v === v ? `).concat(n, `
  : v !== v && u === u ? `).concat(r, " : ");
}
var dmr = {
  /**
   * Parse an expression used to update an operator value.
   */
  operator: (t, e) => X2(t, ["_"], e.code),
  /**
   * Parse an expression provided as an operator parameter value.
   */
  parameter: (t, e) => X2(t, ["datum", "_"], e.code),
  /**
   * Parse an expression applied to an event stream.
   */
  event: (t, e) => X2(t, ["event"], e.code),
  /**
   * Parse an expression used to handle an event-driven operator update.
   */
  handler: (t, e) => {
    const n = "var datum=event.item&&event.item.datum;return ".concat(e.code, ";");
    return X2(t, ["_", "event"], n);
  },
  /**
   * Parse an expression that performs visual encoding.
   */
  encode: (t, e) => {
    const {
      marktype: n,
      channels: r
    } = e;
    let i = "var o=item,datum=o.datum,m=0,$;";
    for (const o in r) {
      const s = "o[" + an(o) + "]";
      i += "$=".concat(r[o].code, ";if(").concat(s, "!==$)").concat(s, "=$,m=1;");
    }
    return i += umr(r, n), i += "return m;", X2(t, ["item", "_"], i);
  },
  /**
   * Optimized code generators for access and comparison.
   */
  codegen: {
    get(t) {
      const e = "[".concat(t.map(an).join("]["), "]"), n = Function("_", "return _".concat(e, ";"));
      return n.path = e, n;
    },
    comparator(t, e) {
      let n;
      const r = (o, s) => {
        const a = e[s];
        let A, l;
        return o.path ? (A = "a".concat(o.path), l = "b".concat(o.path)) : ((n = n || {})["f" + s] = o, A = "this.f".concat(s, "(a)"), l = "this.f".concat(s, "(b)")), hmr(A, l, -a, a);
      }, i = Function("a", "b", "var u, v; return " + t.map(r).join("") + "0;");
      return n ? i.bind(n) : i;
    }
  }
};
function pmr(t) {
  const e = this;
  fmr(t.type) || !t.type ? e.operator(t, t.update ? e.operatorExpression(t.update) : null) : e.transform(t, t.type);
}
function Imr(t) {
  const e = this;
  if (t.params) {
    const n = e.get(t.id);
    n || wt("Invalid operator id: " + t.id), e.dataflow.connect(n, n.parameters(e.parseParameters(t.params), t.react, t.initonly));
  }
}
function mmr(t, e) {
  e = e || {};
  const n = this;
  for (const r in t) {
    const i = t[r];
    e[r] = Nt(i) ? i.map((o) => XOe(o, n, e)) : XOe(i, n, e);
  }
  return e;
}
function XOe(t, e, n) {
  if (!t || !_n(t))
    return t;
  for (let r = 0, i = ZOe.length, o; r < i; ++r)
    if (o = ZOe[r], Kn(t, o.key))
      return o.parse(t, e, n);
  return t;
}
var ZOe = [{
  key: "$ref",
  parse: Cmr
}, {
  key: "$key",
  parse: ymr
}, {
  key: "$expr",
  parse: Emr
}, {
  key: "$field",
  parse: vmr
}, {
  key: "$encode",
  parse: bmr
}, {
  key: "$compare",
  parse: Bmr
}, {
  key: "$context",
  parse: _mr
}, {
  key: "$subflow",
  parse: Smr
}, {
  key: "$tupleid",
  parse: Qmr
}];
function Cmr(t, e) {
  return e.get(t.$ref) || wt("Operator not defined: " + t.$ref);
}
function Emr(t, e, n) {
  t.$params && e.parseParameters(t.$params, n);
  const r = "e:" + t.$expr.code + "_" + t.$name;
  return e.fn[r] || (e.fn[r] = Yu(e.parameterExpression(t.$expr), t.$fields, t.$name));
}
function ymr(t, e) {
  const n = "k:" + t.$key + "_" + !!t.$flat;
  return e.fn[n] || (e.fn[n] = gge(t.$key, t.$flat, e.expr.codegen));
}
function vmr(t, e) {
  if (!t.$field)
    return null;
  const n = "f:" + t.$field + "_" + t.$name;
  return e.fn[n] || (e.fn[n] = ku(t.$field, t.$name, e.expr.codegen));
}
function Bmr(t, e) {
  const n = "c:" + t.$compare + "_" + t.$order, r = bn(t.$compare).map((i) => i && i.$tupleid ? tr : i);
  return e.fn[n] || (e.fn[n] = uge(r, t.$order, e.expr.codegen));
}
function bmr(t, e) {
  const n = t.$encode, r = {};
  for (const i in n) {
    const o = n[i];
    r[i] = Yu(e.encodeExpression(o.$expr), o.$fields), r[i].output = o.$output;
  }
  return r;
}
function _mr(t, e) {
  return e;
}
function Smr(t, e) {
  const n = t.$subflow;
  return function(r, i, o) {
    const s = e.fork().parse(n), a = s.get(n.operators[0].id), A = s.signals.parent;
    return A && A.set(o), a.detachSubflow = () => e.detach(s), a;
  };
}
function Qmr() {
  return tr;
}
function wmr(t) {
  var e = this, n = t.filter != null ? e.eventExpression(t.filter) : void 0, r = t.stream != null ? e.get(t.stream) : void 0, i;
  t.source ? r = e.events(t.source, t.type, n) : t.merge && (i = t.merge.map((o) => e.get(o)), r = i[0].merge.apply(i[0], i.slice(1))), t.between && (i = t.between.map((o) => e.get(o)), r = r.between(i[0], i[1])), t.filter && (r = r.filter(n)), t.throttle != null && (r = r.throttle(+t.throttle)), t.debounce != null && (r = r.debounce(+t.debounce)), r == null && wt("Invalid stream definition: " + JSON.stringify(t)), t.consume && r.consume(!0), e.stream(t, r);
}
function xmr(t) {
  var e = this, n = _n(n = t.source) ? n.$ref : n, r = e.get(n), i = null, o = t.update, s = void 0;
  r || wt("Source not defined: " + t.source), i = t.target && t.target.$expr ? e.eventExpression(t.target.$expr) : e.get(t.target), o && o.$expr && (o.$params && (s = e.parseParameters(o.$params)), o = e.handlerExpression(o.$expr)), e.update(t, r, i, o, s);
}
const Rmr = {
  skip: !0
};
function Dmr(t) {
  var e = this, n = {};
  if (t.signals) {
    var r = n.signals = {};
    Object.keys(e.signals).forEach((o) => {
      const s = e.signals[o];
      t.signals(o, s) && (r[o] = s.value);
    });
  }
  if (t.data) {
    var i = n.data = {};
    Object.keys(e.data).forEach((o) => {
      const s = e.data[o];
      t.data(o, s) && (i[o] = s.input.value);
    });
  }
  return e.subcontext && t.recurse !== !1 && (n.subcontext = e.subcontext.map((o) => o.getState(t))), n;
}
function Tmr(t) {
  var e = this, n = e.dataflow, r = t.data, i = t.signals;
  Object.keys(i || {}).forEach((o) => {
    n.update(e.signals[o], i[o], Rmr);
  }), Object.keys(r || {}).forEach((o) => {
    n.pulse(e.data[o].input, n.changeset().remove(qg).insert(r[o]));
  }), (t.subcontext || []).forEach((o, s) => {
    const a = e.subcontext[s];
    a && a.setState(o);
  });
}
function Dot(t, e, n, r) {
  return new Tot(t, e, n, r);
}
function Tot(t, e, n, r) {
  this.dataflow = t, this.transforms = e, this.events = t.events.bind(t), this.expr = r || dmr, this.signals = {}, this.scales = {}, this.nodes = {}, this.data = {}, this.fn = {}, n && (this.functions = Object.create(n), this.functions.context = this);
}
function eFe(t) {
  this.dataflow = t.dataflow, this.transforms = t.transforms, this.events = t.events, this.expr = t.expr, this.signals = Object.create(t.signals), this.scales = Object.create(t.scales), this.nodes = Object.create(t.nodes), this.data = Object.create(t.data), this.fn = Object.create(t.fn), t.functions && (this.functions = Object.create(t.functions), this.functions.context = this);
}
Tot.prototype = eFe.prototype = {
  fork() {
    const t = new eFe(this);
    return (this.subcontext || (this.subcontext = [])).push(t), t;
  },
  detach(t) {
    this.subcontext = this.subcontext.filter((n) => n !== t);
    const e = Object.keys(t.nodes);
    for (const n of e)
      t.nodes[n]._targets = null;
    for (const n of e)
      t.nodes[n].detach();
    t.nodes = null;
  },
  get(t) {
    return this.nodes[t];
  },
  set(t, e) {
    return this.nodes[t] = e;
  },
  add(t, e) {
    const n = this, r = n.dataflow, i = t.value;
    if (n.set(t.id, e), gmr(t.type) && i && (i.$ingest ? r.ingest(e, i.$ingest, i.$format) : i.$request ? r.preload(e, i.$request, i.$format) : r.pulse(e, r.changeset().insert(i))), t.root && (n.root = e), t.parent) {
      let o = n.get(t.parent.$ref);
      o ? (r.connect(o, [e]), e.targets().add(o)) : (n.unresolved = n.unresolved || []).push(() => {
        o = n.get(t.parent.$ref), r.connect(o, [e]), e.targets().add(o);
      });
    }
    if (t.signal && (n.signals[t.signal] = e), t.scale && (n.scales[t.scale] = e), t.data)
      for (const o in t.data) {
        const s = n.data[o] || (n.data[o] = {});
        t.data[o].forEach((a) => s[a] = e);
      }
  },
  resolve() {
    return (this.unresolved || []).forEach((t) => t()), delete this.unresolved, this;
  },
  operator(t, e) {
    this.add(t, this.dataflow.add(t.value, e));
  },
  transform(t, e) {
    this.add(t, this.dataflow.add(this.transforms[Gpe(e)]));
  },
  stream(t, e) {
    this.set(t.id, e);
  },
  update(t, e, n, r, i) {
    this.dataflow.on(e, n, r, i, t.options);
  },
  // expression parsing
  operatorExpression(t) {
    return this.expr.operator(this, t);
  },
  parameterExpression(t) {
    return this.expr.parameter(this, t);
  },
  eventExpression(t) {
    return this.expr.event(this, t);
  },
  handlerExpression(t) {
    return this.expr.handler(this, t);
  },
  encodeExpression(t) {
    return this.expr.encode(this, t);
  },
  // parse methods
  parse: lmr,
  parseOperator: pmr,
  parseOperatorParameters: Imr,
  parseParameters: mmr,
  parseStream: wmr,
  parseUpdate: xmr,
  // state methods
  getState: Dmr,
  setState: Tmr
};
function Nmr(t) {
  const e = t.container();
  e && (e.setAttribute("role", "graphics-document"), e.setAttribute("aria-roleDescription", "visualization"), Not(e, t.description()));
}
function Not(t, e) {
  t && (e == null ? t.removeAttribute("aria-label") : t.setAttribute("aria-label", e));
}
function Lmr(t) {
  t.add(null, (e) => (t._background = e.bg, t._resize = 1, e.bg), {
    bg: t._signals.background
  });
}
const rX = "default";
function Mmr(t) {
  const e = t._signals.cursor || (t._signals.cursor = t.add({
    user: rX,
    item: null
  }));
  t.on(t.events("view", "mousemove"), e, (n, r) => {
    const i = e.value, o = i ? Cn(i) ? i : i.user : rX, s = r.item && r.item.cursor || null;
    return i && o === i.user && s == i.item ? i : {
      user: o,
      item: s
    };
  }), t.add(null, function(n) {
    let r = n.cursor, i = this.value;
    return Cn(r) || (i = r.item, r = r.user), uoe(t, r && r !== rX ? r : i || r), i;
  }, {
    cursor: e
  });
}
function uoe(t, e) {
  const n = t.globalCursor() ? typeof document < "u" && document.body : t.container();
  if (n)
    return e == null ? n.style.removeProperty("cursor") : n.style.cursor = e;
}
function S6(t, e) {
  var n = t._runtime.data;
  return Kn(n, e) || wt("Unrecognized data set: " + e), n[e];
}
function Omr(t, e) {
  return arguments.length < 2 ? S6(this, t).values.value : iY.call(this, t, b1().remove(qg).insert(e));
}
function iY(t, e) {
  set(e) || wt("Second argument to changes must be a changeset.");
  const n = S6(this, t);
  return n.modified = !0, this.pulse(n.input, e);
}
function Fmr(t, e) {
  return iY.call(this, t, b1().insert(e));
}
function Pmr(t, e) {
  return iY.call(this, t, b1().remove(e));
}
function Lot(t) {
  var e = t.padding();
  return Math.max(0, t._viewWidth + e.left + e.right);
}
function Mot(t) {
  var e = t.padding();
  return Math.max(0, t._viewHeight + e.top + e.bottom);
}
function oY(t) {
  var e = t.padding(), n = t._origin;
  return [e.left + n[0], e.top + n[1]];
}
function kmr(t) {
  var e = oY(t), n = Lot(t), r = Mot(t);
  t._renderer.background(t.background()), t._renderer.resize(n, r, e), t._handler.origin(e), t._resizeListeners.forEach((i) => {
    try {
      i(n, r);
    } catch (o) {
      t.error(o);
    }
  });
}
function Gmr(t, e, n) {
  var r = t._renderer, i = r && r.canvas(), o, s, a;
  return i && (a = oY(t), s = e.changedTouches ? e.changedTouches[0] : e, o = jj(s, i), o[0] -= a[0], o[1] -= a[1]), e.dataflow = t, e.item = n, e.vega = Umr(t, n, o), e;
}
function Umr(t, e, n) {
  const r = e ? e.mark.marktype === "group" ? e : e.mark.group : null;
  function i(s) {
    var a = r, A;
    if (s) {
      for (A = e; A; A = A.mark.group)
        if (A.mark.name === s) {
          a = A;
          break;
        }
    }
    return a && a.mark && a.mark.interactive ? a : {};
  }
  function o(s) {
    if (!s)
      return n;
    Cn(s) && (s = i(s));
    const a = n.slice();
    for (; s; )
      a[0] -= s.x || 0, a[1] -= s.y || 0, s = s.mark && s.mark.group;
    return a;
  }
  return {
    view: lc(t),
    item: lc(e || {}),
    group: i,
    xy: o,
    x: (s) => o(s)[0],
    y: (s) => o(s)[1]
  };
}
const tFe = "view", Hmr = "timer", $mr = "window", qmr = {
  trap: !1
};
function jmr(t) {
  const e = ni({
    defaults: {}
  }, t), n = (r, i) => {
    i.forEach((o) => {
      Nt(r[o]) && (r[o] = pd(r[o]));
    });
  };
  return n(e.defaults, ["prevent", "allow"]), n(e, ["view", "window", "selector"]), e;
}
function Oot(t, e, n, r) {
  t._eventListeners.push({
    type: n,
    sources: bn(e),
    handler: r
  });
}
function Ymr(t, e) {
  var n = t._eventConfig.defaults, r = n.prevent, i = n.allow;
  return r === !1 || i === !0 ? !1 : r === !0 || i === !1 ? !0 : r ? r[e] : i ? !i[e] : t.preventDefault();
}
function P3(t, e, n) {
  const r = t._eventConfig && t._eventConfig[e];
  return r === !1 || _n(r) && !r[n] ? (t.warn("Blocked ".concat(e, " ").concat(n, " event listener.")), !1) : !0;
}
function zmr(t, e, n) {
  var r = this, i = new Ij(n), o = function(l, c) {
    r.runAsync(null, () => {
      t === tFe && Ymr(r, e) && l.preventDefault(), i.receive(Gmr(r, l, c));
    });
  }, s;
  if (t === Hmr)
    P3(r, "timer", e) && r.timer(o, e);
  else if (t === tFe)
    P3(r, "view", e) && r.addEventListener(e, o, qmr);
  else if (t === $mr ? P3(r, "window", e) && typeof window < "u" && (s = [window]) : typeof document < "u" && P3(r, "selector", e) && (s = document.querySelectorAll(t)), !s)
    r.warn("Can not resolve event source: " + t);
  else {
    for (var a = 0, A = s.length; a < A; ++a)
      s[a].addEventListener(e, o);
    Oot(r, s, e, o);
  }
  return i;
}
function nFe(t) {
  return t.item;
}
function rFe(t) {
  return t.item.mark.source;
}
function iFe(t) {
  return function(e, n) {
    return n.vega.view().changeset().encode(n.item, t);
  };
}
function Vmr(t, e) {
  return t = [t || "hover"], e = [e || "update", t[0]], this.on(this.events("view", "mouseover", nFe), rFe, iFe(t)), this.on(this.events("view", "mouseout", nFe), rFe, iFe(e)), this;
}
function Jmr() {
  var t = this._tooltip, e = this._timers, n = this._eventListeners, r, i, o;
  for (r = e.length; --r >= 0; )
    e[r].stop();
  for (r = n.length; --r >= 0; )
    for (o = n[r], i = o.sources.length; --i >= 0; )
      o.sources[i].removeEventListener(o.type, o.handler);
  return t && t.call(this, this._handler, null, null, null), this;
}
function Of(t, e, n) {
  const r = document.createElement(t);
  for (const i in e)
    r.setAttribute(i, e[i]);
  return n != null && (r.textContent = n), r;
}
const Kmr = "vega-bind", Wmr = "vega-bind-name", Xmr = "vega-bind-radio";
function Zmr(t, e, n) {
  if (!e)
    return;
  const r = n.param;
  let i = n.state;
  return i || (i = n.state = {
    elements: null,
    active: !1,
    set: null,
    update: (s) => {
      s != t.signal(r.signal) && t.runAsync(null, () => {
        i.source = !0, t.signal(r.signal, s);
      });
    }
  }, r.debounce && (i.update = fge(r.debounce, i.update))), (r.input == null && r.element ? eCr : nCr)(i, e, r, t), i.active || (t.on(t._signals[r.signal], null, () => {
    i.source ? i.source = !1 : i.set(t.signal(r.signal));
  }), i.active = !0), i;
}
function eCr(t, e, n, r) {
  const i = n.event || "input", o = () => t.update(e.value);
  r.signal(n.signal, e.value), e.addEventListener(i, o), Oot(r, e, i, o), t.set = (s) => {
    e.value = s, e.dispatchEvent(tCr(i));
  };
}
function tCr(t) {
  return typeof Event < "u" ? new Event(t) : {
    type: t
  };
}
function nCr(t, e, n, r) {
  const i = r.signal(n.signal), o = Of("div", {
    class: Kmr
  }), s = n.input === "radio" ? o : o.appendChild(Of("label"));
  s.appendChild(Of("span", {
    class: Wmr
  }, n.name || n.signal)), e.appendChild(o);
  let a = rCr;
  switch (n.input) {
    case "checkbox":
      a = iCr;
      break;
    case "select":
      a = oCr;
      break;
    case "radio":
      a = sCr;
      break;
    case "range":
      a = aCr;
      break;
  }
  a(t, s, n, i);
}
function rCr(t, e, n, r) {
  const i = Of("input");
  for (const o in n)
    o !== "signal" && o !== "element" && i.setAttribute(o === "input" ? "type" : o, n[o]);
  i.setAttribute("name", n.signal), i.value = r, e.appendChild(i), i.addEventListener("input", () => t.update(i.value)), t.elements = [i], t.set = (o) => i.value = o;
}
function iCr(t, e, n, r) {
  const i = {
    type: "checkbox",
    name: n.signal
  };
  r && (i.checked = !0);
  const o = Of("input", i);
  e.appendChild(o), o.addEventListener("change", () => t.update(o.checked)), t.elements = [o], t.set = (s) => o.checked = !!s || null;
}
function oCr(t, e, n, r) {
  const i = Of("select", {
    name: n.signal
  }), o = n.labels || [];
  n.options.forEach((s, a) => {
    const A = {
      value: s
    };
    Q6(s, r) && (A.selected = !0), i.appendChild(Of("option", A, (o[a] || s) + ""));
  }), e.appendChild(i), i.addEventListener("change", () => {
    t.update(n.options[i.selectedIndex]);
  }), t.elements = [i], t.set = (s) => {
    for (let a = 0, A = n.options.length; a < A; ++a)
      if (Q6(n.options[a], s)) {
        i.selectedIndex = a;
        return;
      }
  };
}
function sCr(t, e, n, r) {
  const i = Of("span", {
    class: Xmr
  }), o = n.labels || [];
  e.appendChild(i), t.elements = n.options.map((s, a) => {
    const A = {
      type: "radio",
      name: n.signal,
      value: s
    };
    Q6(s, r) && (A.checked = !0);
    const l = Of("input", A);
    l.addEventListener("change", () => t.update(s));
    const c = Of("label", {}, (o[a] || s) + "");
    return c.prepend(l), i.appendChild(c), l;
  }), t.set = (s) => {
    const a = t.elements, A = a.length;
    for (let l = 0; l < A; ++l)
      Q6(a[l].value, s) && (a[l].checked = !0);
  };
}
function aCr(t, e, n, r) {
  r = r !== void 0 ? r : (+n.max + +n.min) / 2;
  const i = n.max != null ? n.max : Math.max(100, +r) || 100, o = n.min || Math.min(0, i, +r) || 0, s = n.step || IN(o, i, 100), a = Of("input", {
    type: "range",
    name: n.signal,
    min: o,
    max: i,
    step: s
  });
  a.value = r;
  const A = Of("span", {}, +r);
  e.appendChild(a), e.appendChild(A);
  const l = () => {
    A.textContent = a.value, t.update(+a.value);
  };
  a.addEventListener("input", l), a.addEventListener("change", l), t.elements = [a], t.set = (c) => {
    a.value = c, A.textContent = c;
  };
}
function Q6(t, e) {
  return t === e || t + "" == e + "";
}
function Fot(t, e, n, r, i, o) {
  return e = e || new r(t.loader()), e.initialize(n, Lot(t), Mot(t), oY(t), i, o).background(t.background());
}
function Upe(t, e) {
  return e ? function() {
    try {
      e.apply(this, arguments);
    } catch (n) {
      t.error(n);
    }
  } : null;
}
function ACr(t, e, n, r) {
  const i = new r(t.loader(), Upe(t, t.tooltip())).scene(t.scenegraph().root).initialize(n, oY(t), t);
  return e && e.handlers().forEach((o) => {
    i.on(o.type, o.handler);
  }), i;
}
function lCr(t, e) {
  const n = this, r = n._renderType, i = n._eventConfig.bind, o = Yj(r);
  t = n._el = t ? iX(n, t, !0) : null, Nmr(n), o || n.error("Unrecognized renderer type: " + r);
  const s = o.handler || yO, a = t ? o.renderer : o.headless;
  return n._renderer = a ? Fot(n, n._renderer, t, a) : null, n._handler = ACr(n, n._handler, t, s), n._redraw = !0, t && i !== "none" && (e = e ? n._elBind = iX(n, e, !0) : t.appendChild(Of("form", {
    class: "vega-bindings"
  })), n._bind.forEach((A) => {
    A.param.element && i !== "container" && (A.element = iX(n, A.param.element, !!A.param.input));
  }), n._bind.forEach((A) => {
    Zmr(n, A.element || e, A);
  })), n;
}
function iX(t, e, n) {
  if (typeof e == "string")
    if (typeof document < "u") {
      if (e = document.querySelector(e), !e)
        return t.error("Signal bind element not found: " + e), null;
    } else
      return t.error("DOM document instance not found."), null;
  if (e && n)
    try {
      e.textContent = "";
    } catch (r) {
      e = null, t.error(r);
    }
  return e;
}
const Z2 = (t) => +t || 0, cCr = (t) => ({
  top: t,
  bottom: t,
  left: t,
  right: t
});
function oFe(t) {
  return _n(t) ? {
    top: Z2(t.top),
    bottom: Z2(t.bottom),
    left: Z2(t.left),
    right: Z2(t.right)
  } : cCr(Z2(t));
}
async function Hpe(t, e, n, r) {
  const i = Yj(e), o = i && i.headless;
  return o || wt("Unrecognized renderer type: " + e), await t.runAsync(), Fot(t, null, null, o, n, r).renderAsync(t._scenegraph.root);
}
async function uCr(t, e) {
  t !== CC.Canvas && t !== CC.SVG && t !== CC.PNG && wt("Unrecognized image type: " + t);
  const n = await Hpe(this, t, e);
  return t === CC.SVG ? fCr(n.svg(), "image/svg+xml") : n.canvas().toDataURL("image/png");
}
function fCr(t, e) {
  const n = new Blob([t], {
    type: e
  });
  return window.URL.createObjectURL(n);
}
async function gCr(t, e) {
  return (await Hpe(this, CC.Canvas, t, e)).canvas();
}
async function hCr(t) {
  return (await Hpe(this, CC.SVG, t)).svg();
}
function dCr(t, e, n) {
  return Dot(t, IQ, MN, n).parse(e);
}
function pCr(t) {
  var e = this._runtime.scales;
  return Kn(e, t) || wt("Unrecognized scale or projection: " + t), e[t].value;
}
var Pot = "width", kot = "height", $pe = "padding", sFe = {
  skip: !0
};
function Got(t, e) {
  var n = t.autosize(), r = t.padding();
  return e - (n && n.contains === $pe ? r.left + r.right : 0);
}
function Uot(t, e) {
  var n = t.autosize(), r = t.padding();
  return e - (n && n.contains === $pe ? r.top + r.bottom : 0);
}
function ICr(t) {
  var e = t._signals, n = e[Pot], r = e[kot], i = e[$pe];
  function o() {
    t._autosize = t._resize = 1;
  }
  t._resizeWidth = t.add(null, (a) => {
    t._width = a.size, t._viewWidth = Got(t, a.size), o();
  }, {
    size: n
  }), t._resizeHeight = t.add(null, (a) => {
    t._height = a.size, t._viewHeight = Uot(t, a.size), o();
  }, {
    size: r
  });
  const s = t.add(null, o, {
    pad: i
  });
  t._resizeWidth.rank = n.rank + 1, t._resizeHeight.rank = r.rank + 1, s.rank = i.rank + 1;
}
function mCr(t, e, n, r, i, o) {
  this.runAfter((s) => {
    let a = 0;
    s._autosize = 0, s.width() !== n && (a = 1, s.signal(Pot, n, sFe), s._resizeWidth.skip(!0)), s.height() !== r && (a = 1, s.signal(kot, r, sFe), s._resizeHeight.skip(!0)), s._viewWidth !== t && (s._resize = 1, s._viewWidth = t), s._viewHeight !== e && (s._resize = 1, s._viewHeight = e), (s._origin[0] !== i[0] || s._origin[1] !== i[1]) && (s._resize = 1, s._origin = i), a && s.run("enter"), o && s.runAfter((A) => A.resize());
  }, !1, 1);
}
function CCr(t) {
  return this._runtime.getState(t || {
    data: ECr,
    signals: yCr,
    recurse: !0
  });
}
function ECr(t, e) {
  return e.modified && Nt(e.input.value) && t.indexOf("_:vega:_");
}
function yCr(t, e) {
  return !(t === "parent" || e instanceof IQ.proxy);
}
function vCr(t) {
  return this.runAsync(null, (e) => {
    e._trigger = !1, e._runtime.setState(t);
  }, (e) => {
    e._trigger = !0;
  }), this;
}
function BCr(t, e) {
  function n(r) {
    t({
      timestamp: Date.now(),
      elapsed: r
    });
  }
  this._timers.push(Xgr(n, e));
}
function bCr(t, e, n, r) {
  const i = t.element();
  i && i.setAttribute("title", _Cr(r));
}
function _Cr(t) {
  return t == null ? "" : Nt(t) ? Hot(t) : _n(t) && !NC(t) ? SCr(t) : t + "";
}
function SCr(t) {
  return Object.keys(t).map((e) => {
    const n = t[e];
    return e + ": " + (Nt(n) ? Hot(n) : $ot(n));
  }).join(`
`);
}
function Hot(t) {
  return "[" + t.map($ot).join(", ") + "]";
}
function $ot(t) {
  return Nt(t) ? "[…]" : _n(t) && !NC(t) ? "{…}" : t;
}
function qot(t, e) {
  const n = this;
  if (e = e || {}, sS.call(n), e.loader && n.loader(e.loader), e.logger && n.logger(e.logger), e.logLevel != null && n.logLevel(e.logLevel), e.locale || t.locale) {
    const o = ni({}, t.locale, e.locale);
    n.locale(KZe(o.number, o.time));
  }
  n._el = null, n._elBind = null, n._renderType = e.renderer || CC.Canvas, n._scenegraph = new Bde();
  const r = n._scenegraph.root;
  n._renderer = null, n._tooltip = e.tooltip || bCr, n._redraw = !0, n._handler = new yO().scene(r), n._globalCursor = !1, n._preventDefault = !1, n._timers = [], n._eventListeners = [], n._resizeListeners = [], n._eventConfig = jmr(t.eventConfig), n.globalCursor(n._eventConfig.globalCursor);
  const i = dCr(n, t, e.expr);
  n._runtime = i, n._signals = i.signals, n._bind = (t.bindings || []).map((o) => ({
    state: null,
    param: ni({}, o)
  })), i.root && i.root.set(r), r.source = i.data.root.input, n.pulse(i.data.root.input, n.changeset().insert(r.items)), n._width = n.width(), n._height = n.height(), n._viewWidth = Got(n, n._width), n._viewHeight = Uot(n, n._height), n._origin = [0, 0], n._resize = 0, n._autosize = 1, ICr(n), Lmr(n), Mmr(n), n.description(t.description), e.hover && n.hover(), e.container && n.initialize(e.container, e.bind);
}
function k3(t, e) {
  return Kn(t._signals, e) ? t._signals[e] : wt("Unrecognized signal name: " + an(e));
}
function jot(t, e) {
  const n = (t._targets || []).filter((r) => r._update && r._update.handler === e);
  return n.length ? n[0] : null;
}
function aFe(t, e, n, r) {
  let i = jot(n, r);
  return i || (i = Upe(t, () => r(e, n.value)), i.handler = r, t.on(n, null, i)), t;
}
function AFe(t, e, n) {
  const r = jot(e, n);
  return r && e._targets.remove(r), t;
}
on(qot, sS, {
  // -- DATAFLOW / RENDERING ----
  async evaluate(t, e, n) {
    if (await sS.prototype.evaluate.call(this, t, e), this._redraw || this._resize)
      try {
        this._renderer && (this._resize && (this._resize = 0, kmr(this)), await this._renderer.renderAsync(this._scenegraph.root)), this._redraw = !1;
      } catch (r) {
        this.error(r);
      }
    return n && zG(this, n), this;
  },
  dirty(t) {
    this._redraw = !0, this._renderer && this._renderer.dirty(t);
  },
  // -- GET / SET ----
  description(t) {
    if (arguments.length) {
      const e = t != null ? t + "" : null;
      return e !== this._desc && Not(this._el, this._desc = e), this;
    }
    return this._desc;
  },
  container() {
    return this._el;
  },
  scenegraph() {
    return this._scenegraph;
  },
  origin() {
    return this._origin.slice();
  },
  signal(t, e, n) {
    const r = k3(this, t);
    return arguments.length === 1 ? r.value : this.update(r, e, n);
  },
  width(t) {
    return arguments.length ? this.signal("width", t) : this.signal("width");
  },
  height(t) {
    return arguments.length ? this.signal("height", t) : this.signal("height");
  },
  padding(t) {
    return arguments.length ? this.signal("padding", oFe(t)) : oFe(this.signal("padding"));
  },
  autosize(t) {
    return arguments.length ? this.signal("autosize", t) : this.signal("autosize");
  },
  background(t) {
    return arguments.length ? this.signal("background", t) : this.signal("background");
  },
  renderer(t) {
    return arguments.length ? (Yj(t) || wt("Unrecognized renderer type: " + t), t !== this._renderType && (this._renderType = t, this._resetRenderer()), this) : this._renderType;
  },
  tooltip(t) {
    return arguments.length ? (t !== this._tooltip && (this._tooltip = t, this._resetRenderer()), this) : this._tooltip;
  },
  loader(t) {
    return arguments.length ? (t !== this._loader && (sS.prototype.loader.call(this, t), this._resetRenderer()), this) : this._loader;
  },
  resize() {
    return this._autosize = 1, this.touch(k3(this, "autosize"));
  },
  _resetRenderer() {
    this._renderer && (this._renderer = null, this.initialize(this._el, this._elBind));
  },
  // -- SIZING ----
  _resizeView: mCr,
  // -- EVENT HANDLING ----
  addEventListener(t, e, n) {
    let r = e;
    return n && n.trap === !1 || (r = Upe(this, e), r.raw = e), this._handler.on(t, r), this;
  },
  removeEventListener(t, e) {
    for (var n = this._handler.handlers(t), r = n.length, i, o; --r >= 0; )
      if (o = n[r].type, i = n[r].handler, t === o && (e === i || e === i.raw)) {
        this._handler.off(o, i);
        break;
      }
    return this;
  },
  addResizeListener(t) {
    const e = this._resizeListeners;
    return e.indexOf(t) < 0 && e.push(t), this;
  },
  removeResizeListener(t) {
    var e = this._resizeListeners, n = e.indexOf(t);
    return n >= 0 && e.splice(n, 1), this;
  },
  addSignalListener(t, e) {
    return aFe(this, t, k3(this, t), e);
  },
  removeSignalListener(t, e) {
    return AFe(this, k3(this, t), e);
  },
  addDataListener(t, e) {
    return aFe(this, t, S6(this, t).values, e);
  },
  removeDataListener(t, e) {
    return AFe(this, S6(this, t).values, e);
  },
  globalCursor(t) {
    if (arguments.length) {
      if (this._globalCursor !== !!t) {
        const e = uoe(this, null);
        this._globalCursor = !!t, e && uoe(this, e);
      }
      return this;
    } else
      return this._globalCursor;
  },
  preventDefault(t) {
    return arguments.length ? (this._preventDefault = t, this) : this._preventDefault;
  },
  timer: BCr,
  events: zmr,
  finalize: Jmr,
  hover: Vmr,
  // -- DATA ----
  data: Omr,
  change: iY,
  insert: Fmr,
  remove: Pmr,
  // -- SCALES --
  scale: pCr,
  // -- INITIALIZATION ----
  initialize: lCr,
  // -- HEADLESS RENDERING ----
  toImageURL: uCr,
  toCanvas: gCr,
  toSVG: hCr,
  // -- SAVE / RESTORE STATE ----
  getState: CCr,
  setState: vCr
});
const QCr = "view", w6 = "[", x6 = "]", Yot = "{", zot = "}", wCr = ":", Vot = ",", xCr = "@", RCr = ">", DCr = /[[\]{}]/, TCr = {
  "*": 1,
  arc: 1,
  area: 1,
  group: 1,
  image: 1,
  line: 1,
  path: 1,
  rect: 1,
  rule: 1,
  shape: 1,
  symbol: 1,
  text: 1,
  trail: 1
};
let Jot, Kot;
function jE(t, e, n) {
  return Jot = e || QCr, Kot = n || TCr, Wot(t.trim()).map(foe);
}
function NCr(t) {
  return Kot[t];
}
function KD(t, e, n, r, i) {
  const o = t.length;
  let s = 0, a;
  for (; e < o; ++e) {
    if (a = t[e], !s && a === n)
      return e;
    i && i.indexOf(a) >= 0 ? --s : r && r.indexOf(a) >= 0 && ++s;
  }
  return e;
}
function Wot(t) {
  const e = [], n = t.length;
  let r = 0, i = 0;
  for (; i < n; )
    i = KD(t, i, Vot, w6 + Yot, x6 + zot), e.push(t.substring(r, i).trim()), r = ++i;
  if (e.length === 0)
    throw "Empty event selector: " + t;
  return e;
}
function foe(t) {
  return t[0] === "[" ? LCr(t) : MCr(t);
}
function LCr(t) {
  const e = t.length;
  let n = 1, r;
  if (n = KD(t, n, x6, w6, x6), n === e)
    throw "Empty between selector: " + t;
  if (r = Wot(t.substring(1, n)), r.length !== 2)
    throw "Between selector must have two elements: " + t;
  if (t = t.slice(n + 1).trim(), t[0] !== RCr)
    throw "Expected '>' after between selector: " + t;
  r = r.map(foe);
  const i = foe(t.slice(1).trim());
  return i.between ? {
    between: r,
    stream: i
  } : (i.between = r, i);
}
function MCr(t) {
  const e = {
    source: Jot
  }, n = [];
  let r = [0, 0], i = 0, o = 0, s = t.length, a = 0, A, l;
  if (t[s - 1] === zot) {
    if (a = t.lastIndexOf(Yot), a >= 0) {
      try {
        r = OCr(t.substring(a + 1, s - 1));
      } catch {
        throw "Invalid throttle specification: " + t;
      }
      t = t.slice(0, a).trim(), s = t.length;
    } else
      throw "Unmatched right brace: " + t;
    a = 0;
  }
  if (!s)
    throw t;
  if (t[0] === xCr && (i = ++a), A = KD(t, a, wCr), A < s && (n.push(t.substring(o, A).trim()), o = a = ++A), a = KD(t, a, w6), a === s)
    n.push(t.substring(o, s).trim());
  else if (n.push(t.substring(o, a).trim()), l = [], o = ++a, o === s)
    throw "Unmatched left bracket: " + t;
  for (; a < s; ) {
    if (a = KD(t, a, x6), a === s)
      throw "Unmatched left bracket: " + t;
    if (l.push(t.substring(o, a).trim()), a < s - 1 && t[++a] !== w6)
      throw "Expected left bracket: " + t;
    o = ++a;
  }
  if (!(s = n.length) || DCr.test(n[s - 1]))
    throw "Invalid event selector: " + t;
  return s > 1 ? (e.type = n[1], i ? e.markname = n[0].slice(1) : NCr(n[0]) ? e.marktype = n[0] : e.source = n[0]) : e.type = n[0], e.type.slice(-1) === "!" && (e.consume = !0, e.type = e.type.slice(0, -1)), l != null && (e.filter = l), r[0] && (e.throttle = r[0]), r[1] && (e.debounce = r[1]), e;
}
function OCr(t) {
  const e = t.split(Vot);
  if (!t.length || e.length > 2)
    throw t;
  return e.map((n) => {
    const r = +n;
    if (r !== r)
      throw t;
    return r;
  });
}
function FCr(t) {
  return _n(t) ? t : {
    type: t || "pad"
  };
}
const eR = (t) => +t || 0, PCr = (t) => ({
  top: t,
  bottom: t,
  left: t,
  right: t
});
function kCr(t) {
  return _n(t) ? t.signal ? t : {
    top: eR(t.top),
    bottom: eR(t.bottom),
    left: eR(t.left),
    right: eR(t.right)
  } : PCr(eR(t));
}
const OA = (t) => _n(t) && !Nt(t) ? ni({}, t) : {
  value: t
};
function lFe(t, e, n, r) {
  return n != null ? (_n(n) && !Nt(n) || Nt(n) && n.length && _n(n[0]) ? t.update[e] = n : t[r || "enter"][e] = {
    value: n
  }, 1) : 0;
}
function gl(t, e, n) {
  for (const r in e)
    lFe(t, r, e[r]);
  for (const r in n)
    lFe(t, r, n[r], "update");
}
function bx(t, e, n) {
  for (const r in e)
    n && Kn(n, r) || (t[r] = ni(t[r] || {}, e[r]));
  return t;
}
function i_(t, e) {
  return e && (e.enter && e.enter[t] || e.update && e.update[t]);
}
const qpe = "mark", jpe = "frame", Ype = "scope", GCr = "axis", UCr = "axis-domain", HCr = "axis-grid", $Cr = "axis-label", qCr = "axis-tick", jCr = "axis-title", YCr = "legend", zCr = "legend-band", VCr = "legend-entry", JCr = "legend-gradient", Xot = "legend-label", KCr = "legend-symbol", WCr = "legend-title", XCr = "title", ZCr = "title-text", eEr = "title-subtitle";
function tEr(t, e, n, r, i) {
  const o = {}, s = {};
  let a, A, l, c;
  A = "lineBreak", e === "text" && i[A] != null && !i_(A, t) && oX(o, A, i[A]), (n == "legend" || String(n).startsWith("axis")) && (n = null), c = n === jpe ? i.group : n === qpe ? ni({}, i.mark, i[e]) : null;
  for (A in c)
    l = i_(A, t) || (A === "fill" || A === "stroke") && (i_("fill", t) || i_("stroke", t)), l || oX(o, A, c[A]);
  bn(r).forEach((u) => {
    const f = i.style && i.style[u];
    for (const h in f)
      i_(h, t) || oX(o, h, f[h]);
  }), t = ni({}, t);
  for (A in o)
    c = o[A], c.signal ? (a = a || {})[A] = c : s[A] = c;
  return t.enter = ni(s, t.enter), a && (t.update = ni(a, t.update)), t;
}
function oX(t, e, n) {
  t[e] = n && n.signal ? {
    signal: n.signal
  } : {
    value: n
  };
}
const Zot = (t) => Cn(t) ? an(t) : t.signal ? `(${t.signal})` : est(t);
function sY(t) {
  if (t.gradient != null)
    return rEr(t);
  let e = t.signal ? `(${t.signal})` : t.color ? nEr(t.color) : t.field != null ? est(t.field) : t.value !== void 0 ? an(t.value) : void 0;
  return t.scale != null && (e = iEr(t, e)), e === void 0 && (e = null), t.exponent != null && (e = `pow(${e},${c4(t.exponent)})`), t.mult != null && (e += `*${c4(t.mult)}`), t.offset != null && (e += `+${c4(t.offset)}`), t.round && (e = `round(${e})`), e;
}
const G3 = (t, e, n, r) => `(${t}(${[e, n, r].map(sY).join(",")})+'')`;
function nEr(t) {
  return t.c ? G3("hcl", t.h, t.c, t.l) : t.h || t.s ? G3("hsl", t.h, t.s, t.l) : t.l || t.a ? G3("lab", t.l, t.a, t.b) : t.r || t.g || t.b ? G3("rgb", t.r, t.g, t.b) : null;
}
function rEr(t) {
  const e = [t.start, t.stop, t.count].map((n) => n == null ? null : an(n));
  for (; e.length && bi(e) == null; )
    e.pop();
  return e.unshift(Zot(t.gradient)), `gradient(${e.join(",")})`;
}
function c4(t) {
  return _n(t) ? "(" + sY(t) + ")" : t;
}
function est(t) {
  return tst(_n(t) ? t : {
    datum: t
  });
}
function tst(t) {
  let e, n, r;
  if (t.signal)
    e = "datum", r = t.signal;
  else if (t.group || t.parent) {
    for (n = Math.max(1, t.level || 1), e = "item"; n-- > 0; )
      e += ".mark.group";
    t.parent ? (r = t.parent, e += ".datum") : r = t.group;
  } else
    t.datum ? (e = "datum", r = t.datum) : wt("Invalid field reference: " + an(t));
  return t.signal || (r = Cn(r) ? g0(r).map(an).join("][") : tst(r)), e + "[" + r + "]";
}
function iEr(t, e) {
  const n = Zot(t.scale);
  return t.range != null ? e = `lerp(_range(${n}), ${+t.range})` : (e !== void 0 && (e = `_scale(${n}, ${e})`), t.band && (e = (e ? e + "+" : "") + `_bandwidth(${n})` + (+t.band == 1 ? "" : "*" + c4(t.band)), t.extra && (e = `(datum.extra ? _scale(${n}, datum.extra.value) : ${e})`)), e == null && (e = "0")), e;
}
function oEr(t) {
  let e = "";
  return t.forEach((n) => {
    const r = sY(n);
    e += n.test ? `(${n.test})?${r}:` : r;
  }), bi(e) === ":" && (e += "null"), e;
}
function nst(t, e, n, r, i, o) {
  const s = {};
  o = o || {}, o.encoders = {
    $encode: s
  }, t = tEr(t, e, n, r, i.config);
  for (const a in t)
    s[a] = sEr(t[a], e, o, i);
  return o;
}
function sEr(t, e, n, r) {
  const i = {}, o = {};
  for (const s in t)
    t[s] != null && (i[s] = AEr(aEr(t[s]), r, n, o));
  return {
    $expr: {
      marktype: e,
      channels: i
    },
    $fields: Object.keys(o),
    $output: Object.keys(t)
  };
}
function aEr(t) {
  return Nt(t) ? oEr(t) : sY(t);
}
function AEr(t, e, n, r) {
  const i = Xp(t, e);
  return i.$fields.forEach((o) => r[o] = 1), ni(n, i.$params), i.$expr;
}
const lEr = "outer", cEr = ["value", "update", "init", "react", "bind"];
function cFe(t, e) {
  wt(t + ' for "outer" push: ' + an(e));
}
function rst(t, e) {
  const n = t.name;
  if (t.push === lEr)
    e.signals[n] || cFe("No prior signal definition", n), cEr.forEach((r) => {
      t[r] !== void 0 && cFe("Invalid property ", r);
    });
  else {
    const r = e.addSignal(n, t.value);
    t.react === !1 && (r.react = !1), t.bind && e.addBinding(n, t.bind);
  }
}
function goe(t, e, n, r) {
  this.id = -1, this.type = t, this.value = e, this.params = n, r && (this.parent = r);
}
function aY(t, e, n, r) {
  return new goe(t, e, n, r);
}
function R6(t, e) {
  return aY("operator", t, e);
}
function er(t) {
  const e = {
    $ref: t.id
  };
  return t.id < 0 && (t.refs = t.refs || []).push(e), e;
}
function ON(t, e) {
  return e ? {
    $field: t,
    $name: e
  } : {
    $field: t
  };
}
const hoe = ON("key");
function uFe(t, e) {
  return {
    $compare: t,
    $order: e
  };
}
function uEr(t, e) {
  const n = {
    $key: t
  };
  return e && (n.$flat = !0), n;
}
const fEr = "ascending", gEr = "descending";
function hEr(t) {
  return _n(t) ? (t.order === gEr ? "-" : "+") + AY(t.op, t.field) : "";
}
function AY(t, e) {
  return (t && t.signal ? "$" + t.signal : t || "") + (t && e ? "_" : "") + (e && e.signal ? "$" + e.signal : e || "");
}
const zpe = "scope", doe = "view";
function hA(t) {
  return t && t.signal;
}
function dEr(t) {
  return t && t.expr;
}
function u4(t) {
  if (hA(t))
    return !0;
  if (_n(t)) {
    for (const e in t)
      if (u4(t[e]))
        return !0;
  }
  return !1;
}
function Th(t, e) {
  return t ?? e;
}
function Ov(t) {
  return t && t.signal || t;
}
const fFe = "timer";
function FN(t, e) {
  return (t.merge ? IEr : t.stream ? mEr : t.type ? CEr : wt("Invalid stream specification: " + an(t)))(t, e);
}
function pEr(t) {
  return t === zpe ? doe : t || doe;
}
function IEr(t, e) {
  const n = t.merge.map((i) => FN(i, e)), r = Vpe({
    merge: n
  }, t, e);
  return e.addStream(r).id;
}
function mEr(t, e) {
  const n = FN(t.stream, e), r = Vpe({
    stream: n
  }, t, e);
  return e.addStream(r).id;
}
function CEr(t, e) {
  let n;
  t.type === fFe ? (n = e.event(fFe, t.throttle), t = {
    between: t.between,
    filter: t.filter
  }) : n = e.event(pEr(t.source), t.type);
  const r = Vpe({
    stream: n
  }, t, e);
  return Object.keys(r).length === 1 ? n : e.addStream(r).id;
}
function Vpe(t, e, n) {
  let r = e.between;
  return r && (r.length !== 2 && wt('Stream "between" parameter must have 2 entries: ' + an(e)), t.between = [FN(r[0], n), FN(r[1], n)]), r = e.filter ? [].concat(e.filter) : [], (e.marktype || e.markname || e.markrole) && r.push(EEr(e.marktype, e.markname, e.markrole)), e.source === zpe && r.push("inScope(event.item)"), r.length && (t.filter = Xp("(" + r.join(")&&(") + ")", n).$expr), (r = e.throttle) != null && (t.throttle = +r), (r = e.debounce) != null && (t.debounce = +r), e.consume && (t.consume = !0), t;
}
function EEr(t, e, n) {
  const r = "event.item";
  return r + (t && t !== "*" ? "&&" + r + ".mark.marktype==='" + t + "'" : "") + (n ? "&&" + r + ".mark.role==='" + n + "'" : "") + (e ? "&&" + r + ".mark.name==='" + e + "'" : "");
}
const yEr = {
  code: "_.$value",
  ast: {
    type: "Identifier",
    value: "value"
  }
};
function vEr(t, e, n) {
  const r = t.encode, i = {
    target: n
  };
  let o = t.events, s = t.update, a = [];
  o || wt("Signal update missing events specification."), Cn(o) && (o = jE(o, e.isSubscope() ? zpe : doe)), o = bn(o).filter((A) => A.signal || A.scale ? (a.push(A), 0) : 1), a.length > 1 && (a = [bEr(a)]), o.length && a.push(o.length > 1 ? {
    merge: o
  } : o[0]), r != null && (s && wt("Signal encode and update are mutually exclusive."), s = "encode(item()," + an(r) + ")"), i.update = Cn(s) ? Xp(s, e) : s.expr != null ? Xp(s.expr, e) : s.value != null ? s.value : s.signal != null ? {
    $expr: yEr,
    $params: {
      $value: e.signalRef(s.signal)
    }
  } : wt("Invalid signal update specification."), t.force && (i.options = {
    force: !0
  }), a.forEach((A) => e.addUpdate(ni(BEr(A, e), i)));
}
function BEr(t, e) {
  return {
    source: t.signal ? e.signalRef(t.signal) : t.scale ? e.scaleRef(t.scale) : FN(t, e)
  };
}
function bEr(t) {
  return {
    signal: "[" + t.map((e) => e.scale ? 'scale("' + e.scale + '")' : e.signal) + "]"
  };
}
function _Er(t, e) {
  const n = e.getSignal(t.name);
  let r = t.update;
  t.init && (r ? wt("Signals can not include both init and update expressions.") : (r = t.init, n.initonly = !0)), r && (r = Xp(r, e), n.update = r.$expr, n.params = r.$params), t.on && t.on.forEach((i) => vEr(i, e, n.id));
}
const Go = (t) => (e, n, r) => aY(t, n, e || void 0, r), ist = Go("aggregate"), SEr = Go("axisticks"), ost = Go("bound"), Fd = Go("collect"), gFe = Go("compare"), QEr = Go("datajoin"), sst = Go("encode"), wEr = Go("expression"), xEr = Go("facet"), REr = Go("field"), DEr = Go("key"), TEr = Go("legendentries"), NEr = Go("load"), LEr = Go("mark"), MEr = Go("multiextent"), OEr = Go("multivalues"), FEr = Go("overlap"), PEr = Go("params"), ast = Go("prefacet"), kEr = Go("projection"), GEr = Go("proxy"), UEr = Go("relay"), Ast = Go("render"), HEr = Go("scale"), w1 = Go("sieve"), $Er = Go("sortitems"), lst = Go("viewlayout"), qEr = Go("values");
let jEr = 0;
const cst = {
  min: "min",
  max: "max",
  count: "sum"
};
function YEr(t, e) {
  const n = t.type || "linear";
  snt(n) || wt("Unrecognized scale type: " + an(n)), e.addScale(t.name, {
    type: n,
    domain: void 0
  });
}
function zEr(t, e) {
  const n = e.getScale(t.name).params;
  let r;
  n.domain = ust(t.domain, t, e), t.range != null && (n.range = gst(t, e, n)), t.interpolate != null && ryr(t.interpolate, n), t.nice != null && (n.nice = nyr(t.nice)), t.bins != null && (n.bins = tyr(t.bins, e));
  for (r in t)
    Kn(n, r) || r === "name" || (n[r] = xg(t[r], e));
}
function xg(t, e) {
  return _n(t) ? t.signal ? e.signalRef(t.signal) : wt("Unsupported object: " + an(t)) : t;
}
function f4(t, e) {
  return t.signal ? e.signalRef(t.signal) : t.map((n) => xg(n, e));
}
function lY(t) {
  wt("Can not find data set: " + an(t));
}
function ust(t, e, n) {
  if (!t) {
    (e.domainMin != null || e.domainMax != null) && wt("No scale domain defined for domainMin/domainMax to override.");
    return;
  }
  return t.signal ? n.signalRef(t.signal) : (Nt(t) ? VEr : t.fields ? KEr : JEr)(t, e, n);
}
function VEr(t, e, n) {
  return t.map((r) => xg(r, n));
}
function JEr(t, e, n) {
  const r = n.getData(t.data);
  return r || lY(t.data), vQ(e.type) ? r.valuesRef(n, t.field, fst(t.sort, !1)) : lnt(e.type) ? r.domainRef(n, t.field) : r.extentRef(n, t.field);
}
function KEr(t, e, n) {
  const r = t.data, i = t.fields.reduce((o, s) => (s = Cn(s) ? {
    data: r,
    field: s
  } : Nt(s) || s.signal ? WEr(s, n) : s, o.push(s), o), []);
  return (vQ(e.type) ? XEr : lnt(e.type) ? ZEr : eyr)(t, n, i);
}
function WEr(t, e) {
  const n = "_:vega:_" + jEr++, r = Fd({});
  if (Nt(t))
    r.value = {
      $ingest: t
    };
  else if (t.signal) {
    const i = "setdata(" + an(n) + "," + t.signal + ")";
    r.params.input = e.signalRef(i);
  }
  return e.addDataPipeline(n, [r, w1({})]), {
    data: n,
    field: "data"
  };
}
function XEr(t, e, n) {
  const r = fst(t.sort, !0);
  let i, o;
  const s = n.map((l) => {
    const c = e.getData(l.data);
    return c || lY(l.data), c.countsRef(e, l.field, r);
  }), a = {
    groupby: hoe,
    pulse: s
  };
  r && (i = r.op || "count", o = r.field ? AY(i, r.field) : "count", a.ops = [cst[i]], a.fields = [e.fieldRef(o)], a.as = [o]), i = e.add(ist(a));
  const A = e.add(Fd({
    pulse: er(i)
  }));
  return o = e.add(qEr({
    field: hoe,
    sort: e.sortRef(r),
    pulse: er(A)
  })), er(o);
}
function fst(t, e) {
  return t && (!t.field && !t.op ? _n(t) ? t.field = "key" : t = {
    field: "key"
  } : !t.field && t.op !== "count" ? wt("No field provided for sort aggregate op: " + t.op) : e && t.field && t.op && !cst[t.op] && wt("Multiple domain scales can not be sorted using " + t.op)), t;
}
function ZEr(t, e, n) {
  const r = n.map((i) => {
    const o = e.getData(i.data);
    return o || lY(i.data), o.domainRef(e, i.field);
  });
  return er(e.add(OEr({
    values: r
  })));
}
function eyr(t, e, n) {
  const r = n.map((i) => {
    const o = e.getData(i.data);
    return o || lY(i.data), o.extentRef(e, i.field);
  });
  return er(e.add(MEr({
    extents: r
  })));
}
function tyr(t, e) {
  return t.signal || Nt(t) ? f4(t, e) : e.objectProperty(t);
}
function nyr(t) {
  return _n(t) ? {
    interval: xg(t.interval),
    step: xg(t.step)
  } : xg(t);
}
function ryr(t, e) {
  e.interpolate = xg(t.type || t), t.gamma != null && (e.interpolateGamma = xg(t.gamma));
}
function gst(t, e, n) {
  const r = e.config.range;
  let i = t.range;
  if (i.signal)
    return e.signalRef(i.signal);
  if (Cn(i)) {
    if (r && Kn(r, i))
      return t = ni({}, t, {
        range: r[i]
      }), gst(t, e, n);
    i === "width" ? i = [0, {
      signal: "width"
    }] : i === "height" ? i = vQ(t.type) ? [0, {
      signal: "height"
    }] : [{
      signal: "height"
    }, 0] : wt("Unrecognized scale range value: " + an(i));
  } else if (i.scheme) {
    n.scheme = Nt(i.scheme) ? f4(i.scheme, e) : xg(i.scheme, e), i.extent && (n.schemeExtent = f4(i.extent, e)), i.count && (n.schemeCount = xg(i.count, e));
    return;
  } else if (i.step) {
    n.rangeStep = xg(i.step, e);
    return;
  } else {
    if (vQ(t.type) && !Nt(i))
      return ust(i, t, e);
    Nt(i) || wt("Unsupported range type: " + an(i));
  }
  return i.map((o) => (Nt(o) ? f4 : xg)(o, e));
}
function iyr(t, e) {
  const n = e.config.projection || {}, r = {};
  for (const i in t)
    i !== "name" && (r[i] = poe(t[i], i, e));
  for (const i in n)
    r[i] == null && (r[i] = poe(n[i], i, e));
  e.addProjection(t.name, r);
}
function poe(t, e, n) {
  return Nt(t) ? t.map((r) => poe(r, e, n)) : _n(t) ? t.signal ? n.signalRef(t.signal) : e === "fit" ? t : wt("Unsupported parameter object: " + an(t)) : t;
}
const Pd = "top", _x = "left", Sx = "right", uE = "bottom", hst = "center", oyr = "vertical", syr = "start", ayr = "middle", Ayr = "end", Ioe = "index", Jpe = "label", lyr = "offset", TQ = "perc", cyr = "perc2", Lg = "value", RO = "guide-label", Kpe = "guide-title", uyr = "group-title", fyr = "group-subtitle", hFe = "symbol", g4 = "gradient", moe = "discrete", Coe = "size", gyr = "shape", hyr = "fill", dyr = "stroke", pyr = "strokeWidth", Iyr = "strokeDash", myr = "opacity", Wpe = [Coe, gyr, hyr, dyr, pyr, Iyr, myr], DO = {
  name: 1,
  style: 1,
  interactive: 1
}, Di = {
  value: 0
}, Mg = {
  value: 1
}, cY = "group", dst = "rect", Xpe = "rule", Cyr = "symbol", x1 = "text";
function PN(t) {
  return t.type = cY, t.interactive = t.interactive || !1, t;
}
function zu(t, e) {
  const n = (r, i) => Th(t[r], Th(e[r], i));
  return n.isVertical = (r) => oyr === Th(t.direction, e.direction || (r ? e.symbolDirection : e.gradientDirection)), n.gradientLength = () => Th(t.gradientLength, e.gradientLength || e.gradientWidth), n.gradientThickness = () => Th(t.gradientThickness, e.gradientThickness || e.gradientHeight), n.entryColumns = () => Th(t.columns, Th(e.columns, +n.isVertical(!0))), n;
}
function pst(t, e) {
  const n = e && (e.update && e.update[t] || e.enter && e.enter[t]);
  return n && n.signal ? n : n ? n.value : null;
}
function Eyr(t, e, n) {
  const r = e.config.style[n];
  return r && r[t];
}
function uY(t, e, n) {
  return `item.anchor === '${syr}' ? ${t} : item.anchor === '${Ayr}' ? ${e} : ${n}`;
}
const Zpe = uY(an(_x), an(Sx), an(hst));
function yyr(t) {
  const e = t("tickBand");
  let n = t("tickOffset"), r, i;
  return e ? e.signal ? (r = {
    signal: `(${e.signal}) === 'extent' ? 1 : 0.5`
  }, i = {
    signal: `(${e.signal}) === 'extent'`
  }, _n(n) || (n = {
    signal: `(${e.signal}) === 'extent' ? 0 : ${n}`
  })) : e === "extent" ? (r = 1, i = !0, n = 0) : (r = 0.5, i = !1) : (r = t("bandPosition"), i = t("tickExtra")), {
    extra: i,
    band: r,
    offset: n
  };
}
function Ist(t, e) {
  return e ? t ? _n(t) ? Object.assign({}, t, {
    offset: Ist(t.offset, e)
  }) : {
    value: t,
    offset: e
  } : e : t;
}
function $f(t, e) {
  return e ? (t.name = e.name, t.style = e.style || t.style, t.interactive = !!e.interactive, t.encode = bx(t.encode, e, DO)) : t.interactive = !1, t;
}
function vyr(t, e, n, r) {
  const i = zu(t, n), o = i.isVertical(), s = i.gradientThickness(), a = i.gradientLength();
  let A, l, c, u, f;
  o ? (l = [0, 1], c = [0, 0], u = s, f = a) : (l = [0, 0], c = [1, 0], u = a, f = s);
  const h = {
    enter: A = {
      opacity: Di,
      x: Di,
      y: Di,
      width: OA(u),
      height: OA(f)
    },
    update: ni({}, A, {
      opacity: Mg,
      fill: {
        gradient: e,
        start: l,
        stop: c
      }
    }),
    exit: {
      opacity: Di
    }
  };
  return gl(h, {
    stroke: i("gradientStrokeColor"),
    strokeWidth: i("gradientStrokeWidth")
  }, {
    // update
    opacity: i("gradientOpacity")
  }), $f({
    type: dst,
    role: JCr,
    encode: h
  }, r);
}
function Byr(t, e, n, r, i) {
  const o = zu(t, n), s = o.isVertical(), a = o.gradientThickness(), A = o.gradientLength();
  let l, c, u, f, h = "";
  s ? (l = "y", u = "y2", c = "x", f = "width", h = "1-") : (l = "x", u = "x2", c = "y", f = "height");
  const d = {
    opacity: Di,
    fill: {
      scale: e,
      field: Lg
    }
  };
  d[l] = {
    signal: h + "datum." + TQ,
    mult: A
  }, d[c] = Di, d[u] = {
    signal: h + "datum." + cyr,
    mult: A
  }, d[f] = OA(a);
  const I = {
    enter: d,
    update: ni({}, d, {
      opacity: Mg
    }),
    exit: {
      opacity: Di
    }
  };
  return gl(I, {
    stroke: o("gradientStrokeColor"),
    strokeWidth: o("gradientStrokeWidth")
  }, {
    // update
    opacity: o("gradientOpacity")
  }), $f({
    type: dst,
    role: zCr,
    key: Lg,
    from: i,
    encode: I
  }, r);
}
const byr = `datum.${TQ}<=0?"${_x}":datum.${TQ}>=1?"${Sx}":"${hst}"`, _yr = `datum.${TQ}<=0?"${uE}":datum.${TQ}>=1?"${Pd}":"${ayr}"`;
function dFe(t, e, n, r) {
  const i = zu(t, e), o = i.isVertical(), s = OA(i.gradientThickness()), a = i.gradientLength();
  let A = i("labelOverlap"), l, c, u, f, h = "";
  const d = {
    enter: l = {
      opacity: Di
    },
    update: c = {
      opacity: Mg,
      text: {
        field: Jpe
      }
    },
    exit: {
      opacity: Di
    }
  };
  return gl(d, {
    fill: i("labelColor"),
    fillOpacity: i("labelOpacity"),
    font: i("labelFont"),
    fontSize: i("labelFontSize"),
    fontStyle: i("labelFontStyle"),
    fontWeight: i("labelFontWeight"),
    limit: Th(t.labelLimit, e.gradientLabelLimit)
  }), o ? (l.align = {
    value: "left"
  }, l.baseline = c.baseline = {
    signal: _yr
  }, u = "y", f = "x", h = "1-") : (l.align = c.align = {
    signal: byr
  }, l.baseline = {
    value: "top"
  }, u = "x", f = "y"), l[u] = c[u] = {
    signal: h + "datum." + TQ,
    mult: a
  }, l[f] = c[f] = s, s.offset = Th(t.labelOffset, e.gradientLabelOffset) || 0, A = A ? {
    separation: i("labelSeparation"),
    method: A,
    order: "datum." + Ioe
  } : void 0, $f({
    type: x1,
    role: Xot,
    style: RO,
    key: Lg,
    from: r,
    encode: d,
    overlap: A
  }, n);
}
function Syr(t, e, n, r, i) {
  const o = zu(t, e), s = n.entries, a = !!(s && s.interactive), A = s ? s.name : void 0, l = o("clipHeight"), c = o("symbolOffset"), u = {
    data: "value"
  }, f = `(${i}) ? datum.${lyr} : datum.${Coe}`, h = l ? OA(l) : {
    field: Coe
  }, d = `datum.${Ioe}`, I = `max(1, ${i})`;
  let m, C, y, v, b;
  h.mult = 0.5, m = {
    enter: C = {
      opacity: Di,
      x: {
        signal: f,
        mult: 0.5,
        offset: c
      },
      y: h
    },
    update: y = {
      opacity: Mg,
      x: C.x,
      y: C.y
    },
    exit: {
      opacity: Di
    }
  };
  let Q = null, w = null;
  t.fill || (Q = e.symbolBaseFillColor, w = e.symbolBaseStrokeColor), gl(m, {
    fill: o("symbolFillColor", Q),
    shape: o("symbolType"),
    size: o("symbolSize"),
    stroke: o("symbolStrokeColor", w),
    strokeDash: o("symbolDash"),
    strokeDashOffset: o("symbolDashOffset"),
    strokeWidth: o("symbolStrokeWidth")
  }, {
    // update
    opacity: o("symbolOpacity")
  }), Wpe.forEach((L) => {
    t[L] && (y[L] = C[L] = {
      scale: t[L],
      field: Lg
    });
  });
  const R = $f({
    type: Cyr,
    role: KCr,
    key: Lg,
    from: u,
    clip: l ? !0 : void 0,
    encode: m
  }, n.symbols), M = OA(c);
  M.offset = o("labelOffset"), m = {
    enter: C = {
      opacity: Di,
      x: {
        signal: f,
        offset: M
      },
      y: h
    },
    update: y = {
      opacity: Mg,
      text: {
        field: Jpe
      },
      x: C.x,
      y: C.y
    },
    exit: {
      opacity: Di
    }
  }, gl(m, {
    align: o("labelAlign"),
    baseline: o("labelBaseline"),
    fill: o("labelColor"),
    fillOpacity: o("labelOpacity"),
    font: o("labelFont"),
    fontSize: o("labelFontSize"),
    fontStyle: o("labelFontStyle"),
    fontWeight: o("labelFontWeight"),
    limit: o("labelLimit")
  });
  const O = $f({
    type: x1,
    role: Xot,
    style: RO,
    key: Lg,
    from: u,
    encode: m
  }, n.labels);
  return m = {
    enter: {
      noBound: {
        value: !l
      },
      // ignore width/height in bounds calc
      width: Di,
      height: l ? OA(l) : Di,
      opacity: Di
    },
    exit: {
      opacity: Di
    },
    update: y = {
      opacity: Mg,
      row: {
        signal: null
      },
      column: {
        signal: null
      }
    }
  }, o.isVertical(!0) ? (v = `ceil(item.mark.items.length / ${I})`, y.row.signal = `${d}%${v}`, y.column.signal = `floor(${d} / ${v})`, b = {
    field: ["row", d]
  }) : (y.row.signal = `floor(${d} / ${I})`, y.column.signal = `${d} % ${I}`, b = {
    field: d
  }), y.column.signal = `(${i})?${y.column.signal}:${d}`, r = {
    facet: {
      data: r,
      name: "value",
      groupby: Ioe
    }
  }, PN({
    role: Ype,
    from: r,
    encode: bx(m, s, DO),
    marks: [R, O],
    name: A,
    interactive: a,
    sort: b
  });
}
function Qyr(t, e) {
  const n = zu(t, e);
  return {
    align: n("gridAlign"),
    columns: n.entryColumns(),
    center: {
      row: !0,
      column: !1
    },
    padding: {
      row: n("rowPadding"),
      column: n("columnPadding")
    }
  };
}
const e0e = 'item.orient === "left"', t0e = 'item.orient === "right"', fY = `(${e0e} || ${t0e})`, wyr = `datum.vgrad && ${fY}`, xyr = uY('"top"', '"bottom"', '"middle"'), Ryr = uY('"right"', '"left"', '"center"'), Dyr = `datum.vgrad && ${t0e} ? (${Ryr}) : (${fY} && !(datum.vgrad && ${e0e})) ? "left" : ${Zpe}`, Tyr = `item._anchor || (${fY} ? "middle" : "start")`, Nyr = `${wyr} ? (${e0e} ? -90 : 90) : 0`, Lyr = `${fY} ? (datum.vgrad ? (${t0e} ? "bottom" : "top") : ${xyr}) : "top"`;
function Myr(t, e, n, r) {
  const i = zu(t, e), o = {
    enter: {
      opacity: Di
    },
    update: {
      opacity: Mg,
      x: {
        field: {
          group: "padding"
        }
      },
      y: {
        field: {
          group: "padding"
        }
      }
    },
    exit: {
      opacity: Di
    }
  };
  return gl(o, {
    orient: i("titleOrient"),
    _anchor: i("titleAnchor"),
    anchor: {
      signal: Tyr
    },
    angle: {
      signal: Nyr
    },
    align: {
      signal: Dyr
    },
    baseline: {
      signal: Lyr
    },
    text: t.title,
    fill: i("titleColor"),
    fillOpacity: i("titleOpacity"),
    font: i("titleFont"),
    fontSize: i("titleFontSize"),
    fontStyle: i("titleFontStyle"),
    fontWeight: i("titleFontWeight"),
    limit: i("titleLimit"),
    lineHeight: i("titleLineHeight")
  }, {
    // require update
    align: i("titleAlign"),
    baseline: i("titleBaseline")
  }), $f({
    type: x1,
    role: WCr,
    style: Kpe,
    from: r,
    encode: o
  }, n);
}
function Oyr(t, e) {
  let n;
  return _n(t) && (t.signal ? n = t.signal : t.path ? n = "pathShape(" + pFe(t.path) + ")" : t.sphere && (n = "geoShape(" + pFe(t.sphere) + ', {type: "Sphere"})')), n ? e.signalRef(n) : !!t;
}
function pFe(t) {
  return _n(t) && t.signal ? t.signal : an(t);
}
function mst(t) {
  const e = t.role || "";
  return !e.indexOf("axis") || !e.indexOf("legend") || !e.indexOf("title") ? e : t.type === cY ? Ype : e || qpe;
}
function Fyr(t) {
  return {
    marktype: t.type,
    name: t.name || void 0,
    role: t.role || mst(t),
    zindex: +t.zindex || void 0,
    aria: t.aria,
    description: t.description
  };
}
function Pyr(t, e) {
  return t && t.signal ? e.signalRef(t.signal) : t !== !1;
}
function n0e(t, e) {
  const n = cet(t.type);
  n || wt("Unrecognized transform type: " + an(t.type));
  const r = aY(n.type.toLowerCase(), null, Cst(n, t, e));
  return t.signal && e.addSignal(t.signal, e.proxy(r)), r.metadata = n.metadata || {}, r;
}
function Cst(t, e, n) {
  const r = {}, i = t.params.length;
  for (let o = 0; o < i; ++o) {
    const s = t.params[o];
    r[s.name] = kyr(s, e, n);
  }
  return r;
}
function kyr(t, e, n) {
  const r = t.type, i = e[t.name];
  if (r === "index")
    return Gyr(t, e, n);
  if (i === void 0) {
    t.required && wt("Missing required " + an(e.type) + " parameter: " + an(t.name));
    return;
  } else {
    if (r === "param")
      return Uyr(t, e, n);
    if (r === "projection")
      return n.projectionRef(e[t.name]);
  }
  return t.array && !hA(i) ? i.map((o) => IFe(t, o, n)) : IFe(t, i, n);
}
function IFe(t, e, n) {
  const r = t.type;
  if (hA(e))
    return CFe(r) ? wt("Expression references can not be signals.") : sX(r) ? n.fieldRef(e) : EFe(r) ? n.compareRef(e) : n.signalRef(e.signal);
  {
    const i = t.expr || sX(r);
    return i && Hyr(e) ? n.exprRef(e.expr, e.as) : i && $yr(e) ? ON(e.field, e.as) : CFe(r) ? Xp(e, n) : qyr(r) ? er(n.getData(e).values) : sX(r) ? ON(e) : EFe(r) ? n.compareRef(e) : e;
  }
}
function Gyr(t, e, n) {
  return Cn(e.from) || wt('Lookup "from" parameter must be a string literal.'), n.getData(e.from).lookupRef(n, e.key);
}
function Uyr(t, e, n) {
  const r = e[t.name];
  return t.array ? (Nt(r) || wt("Expected an array of sub-parameters. Instead: " + an(r)), r.map((i) => mFe(t, i, n))) : mFe(t, r, n);
}
function mFe(t, e, n) {
  const r = t.params.length;
  let i;
  for (let s = 0; s < r; ++s) {
    i = t.params[s];
    for (const a in i.key)
      if (i.key[a] !== e[a]) {
        i = null;
        break;
      }
    if (i)
      break;
  }
  i || wt("Unsupported parameter: " + an(e));
  const o = ni(Cst(i, e, n), i.key);
  return er(n.add(PEr(o)));
}
const Hyr = (t) => t && t.expr, $yr = (t) => t && t.field, qyr = (t) => t === "data", CFe = (t) => t === "expr", sX = (t) => t === "field", EFe = (t) => t === "compare";
function jyr(t, e, n) {
  let r, i, o, s, a;
  return t ? (r = t.facet) && (e || wt("Only group marks can be faceted."), r.field != null ? s = a = h4(r, n) : (t.data ? a = er(n.getData(t.data).aggregate) : (o = n0e(ni({
    type: "aggregate",
    groupby: bn(r.groupby)
  }, r.aggregate), n), o.params.key = n.keyRef(r.groupby), o.params.pulse = h4(r, n), s = a = er(n.add(o))), i = n.keyRef(r.groupby, !0))) : s = er(n.add(Fd(null, [{}]))), s || (s = h4(t, n)), {
    key: i,
    pulse: s,
    parent: a
  };
}
function h4(t, e) {
  return t.$ref ? t : t.data && t.data.$ref ? t.data : er(e.getData(t.data).output);
}
function wB(t, e, n, r, i) {
  this.scope = t, this.input = e, this.output = n, this.values = r, this.aggregate = i, this.index = {};
}
wB.fromEntries = function(t, e) {
  const n = e.length, r = e[n - 1], i = e[n - 2];
  let o = e[0], s = null, a = 1;
  for (o && o.type === "load" && (o = e[1]), t.add(e[0]); a < n; ++a)
    e[a].params.pulse = er(e[a - 1]), t.add(e[a]), e[a].type === "aggregate" && (s = e[a]);
  return new wB(t, o, i, r, s);
};
function Est(t) {
  return Cn(t) ? t : null;
}
function yFe(t, e, n) {
  const r = AY(n.op, n.field);
  let i;
  if (e.ops) {
    for (let o = 0, s = e.as.length; o < s; ++o)
      if (e.as[o] === r)
        return;
  } else
    e.ops = ["count"], e.fields = [null], e.as = ["count"];
  n.op && (e.ops.push((i = n.op.signal) ? t.signalRef(i) : n.op), e.fields.push(t.fieldRef(n.field)), e.as.push(r));
}
function tR(t, e, n, r, i, o, s) {
  const a = e[n] || (e[n] = {}), A = hEr(o);
  let l = Est(i), c, u;
  if (l != null && (t = e.scope, l = l + (A ? "|" + A : ""), c = a[l]), !c) {
    const f = o ? {
      field: hoe,
      pulse: e.countsRef(t, i, o)
    } : {
      field: t.fieldRef(i),
      pulse: er(e.output)
    };
    A && (f.sort = t.sortRef(o)), u = t.add(aY(r, void 0, f)), s && (e.index[i] = u), c = er(u), l != null && (a[l] = c);
  }
  return c;
}
wB.prototype = {
  countsRef(t, e, n) {
    const r = this, i = r.counts || (r.counts = {}), o = Est(e);
    let s, a, A;
    return o != null && (t = r.scope, s = i[o]), s ? n && n.field && yFe(t, s.agg.params, n) : (A = {
      groupby: t.fieldRef(e, "key"),
      pulse: er(r.output)
    }, n && n.field && yFe(t, A, n), a = t.add(ist(A)), s = t.add(Fd({
      pulse: er(a)
    })), s = {
      agg: a,
      ref: er(s)
    }, o != null && (i[o] = s)), s.ref;
  },
  tuplesRef() {
    return er(this.values);
  },
  extentRef(t, e) {
    return tR(t, this, "extent", "extent", e, !1);
  },
  domainRef(t, e) {
    return tR(t, this, "domain", "values", e, !1);
  },
  valuesRef(t, e, n) {
    return tR(t, this, "vals", "values", e, n || !0);
  },
  lookupRef(t, e) {
    return tR(t, this, "lookup", "tupleindex", e, !1);
  },
  indataRef(t, e) {
    return tR(t, this, "indata", "tupleindex", e, !0, !0);
  }
};
function Yyr(t, e, n) {
  const r = t.from.facet, i = r.name, o = h4(r, e);
  let s;
  r.name || wt("Facet must have a name: " + an(r)), r.data || wt("Facet must reference a data set: " + an(r)), r.field ? s = e.add(ast({
    field: e.fieldRef(r.field),
    pulse: o
  })) : r.groupby ? s = e.add(xEr({
    key: e.keyRef(r.groupby),
    group: er(e.proxy(n.parent)),
    pulse: o
  })) : wt("Facet must specify groupby or field: " + an(r));
  const a = e.fork(), A = a.add(Fd()), l = a.add(w1({
    pulse: er(A)
  }));
  a.addData(i, new wB(a, A, A, l)), a.addSignal("parent", null), s.params.subflow = {
    $subflow: a.parse(t).toRuntime()
  };
}
function zyr(t, e, n) {
  const r = e.add(ast({
    pulse: n.pulse
  })), i = e.fork();
  i.add(w1()), i.addSignal("parent", null), r.params.subflow = {
    $subflow: i.parse(t).toRuntime()
  };
}
function yst(t, e, n) {
  const r = t.remove, i = t.insert, o = t.toggle, s = t.modify, a = t.values, A = e.add(R6()), l = "if(" + t.trigger + ',modify("' + n + '",' + [i, r, o, s, a].map((u) => u ?? "null").join(",") + "),0)", c = Xp(l, e);
  A.update = c.$expr, A.params = c.$params;
}
function gY(t, e) {
  const n = mst(t), r = t.type === cY, i = t.from && t.from.facet, o = t.overlap;
  let s = t.layout || n === Ype || n === jpe, a, A, l, c, u, f, h;
  const d = n === qpe || s || i, I = jyr(t.from, r, e);
  A = e.add(QEr({
    key: I.key || (t.key ? ON(t.key) : void 0),
    pulse: I.pulse,
    clean: !r
  }));
  const m = er(A);
  A = l = e.add(Fd({
    pulse: m
  })), A = e.add(LEr({
    markdef: Fyr(t),
    interactive: Pyr(t.interactive, e),
    clip: Oyr(t.clip, e),
    context: {
      $context: !0
    },
    groups: e.lookup(),
    parent: e.signals.parent ? e.signalRef("parent") : null,
    index: e.markpath(),
    pulse: er(A)
  }));
  const C = er(A);
  A = c = e.add(sst(nst(t.encode, t.type, n, t.style, e, {
    mod: !1,
    pulse: C
  }))), A.params.parent = e.encode(), t.transform && t.transform.forEach((w) => {
    const R = n0e(w, e), M = R.metadata;
    (M.generates || M.changes) && wt("Mark transforms should not generate new data."), M.nomod || (c.params.mod = !0), R.params.pulse = er(A), e.add(A = R);
  }), t.sort && (A = e.add($Er({
    sort: e.compareRef(t.sort),
    pulse: er(A)
  })));
  const y = er(A);
  (i || s) && (s = e.add(lst({
    layout: e.objectProperty(t.layout),
    legends: e.legends,
    mark: C,
    pulse: y
  })), f = er(s));
  const v = e.add(ost({
    mark: C,
    pulse: f || y
  }));
  h = er(v), r && (d && (a = e.operators, a.pop(), s && a.pop()), e.pushState(y, f || h, m), i ? Yyr(t, e, I) : d ? zyr(t, e, I) : e.parse(t), e.popState(), d && (s && a.push(s), a.push(v))), o && (h = Vyr(o, h, e));
  const b = e.add(Ast({
    pulse: h
  })), Q = e.add(w1({
    pulse: er(b)
  }, void 0, e.parent()));
  t.name != null && (u = t.name, e.addData(u, new wB(e, l, b, Q)), t.on && t.on.forEach((w) => {
    (w.insert || w.remove || w.toggle) && wt("Marks only support modify triggers."), yst(w, e, u);
  }));
}
function Vyr(t, e, n) {
  const r = t.method, i = t.bound, o = t.separation, s = {
    separation: hA(o) ? n.signalRef(o.signal) : o,
    method: hA(r) ? n.signalRef(r.signal) : r,
    pulse: e
  };
  if (t.order && (s.sort = n.compareRef({
    field: t.order
  })), i) {
    const a = i.tolerance;
    s.boundTolerance = hA(a) ? n.signalRef(a.signal) : +a, s.boundScale = n.scaleRef(i.scale), s.boundOrient = i.orient;
  }
  return er(n.add(FEr(s)));
}
function Jyr(t, e) {
  const n = e.config.legend, r = t.encode || {}, i = zu(t, n), o = r.legend || {}, s = o.name || void 0, a = o.interactive, A = o.style, l = {};
  let c = 0, u, f, h;
  Wpe.forEach((v) => t[v] ? (l[v] = t[v], c = c || t[v]) : 0), c || wt("Missing valid scale for legend.");
  const d = Kyr(t, e.scaleType(c)), I = {
    title: t.title != null,
    scales: l,
    type: d,
    vgrad: d !== "symbol" && i.isVertical()
  }, m = er(e.add(Fd(null, [I]))), C = {
    enter: {
      x: {
        value: 0
      },
      y: {
        value: 0
      }
    }
  }, y = er(e.add(TEr(f = {
    type: d,
    scale: e.scaleRef(c),
    count: e.objectProperty(i("tickCount")),
    limit: e.property(i("symbolLimit")),
    values: e.objectProperty(t.values),
    minstep: e.property(t.tickMinStep),
    formatType: e.property(t.formatType),
    formatSpecifier: e.property(t.format)
  })));
  return d === g4 ? (h = [vyr(t, c, n, r.gradient), dFe(t, n, r.labels, y)], f.count = f.count || e.signalRef(`max(2,2*floor((${Ov(i.gradientLength())})/100))`)) : d === moe ? h = [Byr(t, c, n, r.gradient, y), dFe(t, n, r.labels, y)] : (u = Qyr(t, n), h = [Syr(t, n, r, y, Ov(u.columns))], f.size = Zyr(t, e, h[0].marks)), h = [PN({
    role: VCr,
    from: m,
    encode: C,
    marks: h,
    layout: u,
    interactive: a
  })], I.title && h.push(Myr(t, n, r.title, m)), gY(PN({
    role: YCr,
    from: m,
    encode: bx(Xyr(i, t, n), o, DO),
    marks: h,
    aria: i("aria"),
    description: i("description"),
    zindex: i("zindex"),
    name: s,
    interactive: a,
    style: A
  }), e);
}
function Kyr(t, e) {
  let n = t.type || hFe;
  return !t.type && Wyr(t) === 1 && (t.fill || t.stroke) && (n = Xhe(e) ? g4 : cie(e) ? moe : hFe), n !== g4 ? n : cie(e) ? moe : g4;
}
function Wyr(t) {
  return Wpe.reduce((e, n) => e + (t[n] ? 1 : 0), 0);
}
function Xyr(t, e, n) {
  const r = {
    enter: {},
    update: {}
  };
  return gl(r, {
    orient: t("orient"),
    offset: t("offset"),
    padding: t("padding"),
    titlePadding: t("titlePadding"),
    cornerRadius: t("cornerRadius"),
    fill: t("fillColor"),
    stroke: t("strokeColor"),
    strokeWidth: n.strokeWidth,
    strokeDash: n.strokeDash,
    x: t("legendX"),
    y: t("legendY"),
    // accessibility support
    format: e.format,
    formatType: e.formatType
  }), r;
}
function Zyr(t, e, n) {
  const r = Ov(vFe("size", t, n)), i = Ov(vFe("strokeWidth", t, n)), o = Ov(evr(n[1].encode, e, RO));
  return Xp(`max(ceil(sqrt(${r})+${i}),${o})`, e);
}
function vFe(t, e, n) {
  return e[t] ? `scale("${e[t]}",datum)` : pst(t, n[0].encode);
}
function evr(t, e, n) {
  return pst("fontSize", t) || Eyr("fontSize", e, n);
}
const tvr = `item.orient==="${_x}"?-90:item.orient==="${Sx}"?90:0`;
function nvr(t, e) {
  t = Cn(t) ? {
    text: t
  } : t;
  const n = zu(t, e.config.title), r = t.encode || {}, i = r.group || {}, o = i.name || void 0, s = i.interactive, a = i.style, A = [], l = {}, c = er(e.add(Fd(null, [l])));
  return A.push(ovr(t, n, rvr(t), c)), t.subtitle && A.push(svr(t, n, r.subtitle, c)), gY(PN({
    role: XCr,
    from: c,
    encode: ivr(n, i),
    marks: A,
    aria: n("aria"),
    description: n("description"),
    zindex: n("zindex"),
    name: o,
    interactive: s,
    style: a
  }), e);
}
function rvr(t) {
  const e = t.encode;
  return e && e.title || ni({
    name: t.name,
    interactive: t.interactive,
    style: t.style
  }, e);
}
function ivr(t, e) {
  const n = {
    enter: {},
    update: {}
  };
  return gl(n, {
    orient: t("orient"),
    anchor: t("anchor"),
    align: {
      signal: Zpe
    },
    angle: {
      signal: tvr
    },
    limit: t("limit"),
    frame: t("frame"),
    offset: t("offset") || 0,
    padding: t("subtitlePadding")
  }), bx(n, e, DO);
}
function ovr(t, e, n, r) {
  const i = {
    value: 0
  }, o = t.text, s = {
    enter: {
      opacity: i
    },
    update: {
      opacity: {
        value: 1
      }
    },
    exit: {
      opacity: i
    }
  };
  return gl(s, {
    text: o,
    align: {
      signal: "item.mark.group.align"
    },
    angle: {
      signal: "item.mark.group.angle"
    },
    limit: {
      signal: "item.mark.group.limit"
    },
    baseline: "top",
    dx: e("dx"),
    dy: e("dy"),
    fill: e("color"),
    font: e("font"),
    fontSize: e("fontSize"),
    fontStyle: e("fontStyle"),
    fontWeight: e("fontWeight"),
    lineHeight: e("lineHeight")
  }, {
    // update
    align: e("align"),
    angle: e("angle"),
    baseline: e("baseline")
  }), $f({
    type: x1,
    role: ZCr,
    style: uyr,
    from: r,
    encode: s
  }, n);
}
function svr(t, e, n, r) {
  const i = {
    value: 0
  }, o = t.subtitle, s = {
    enter: {
      opacity: i
    },
    update: {
      opacity: {
        value: 1
      }
    },
    exit: {
      opacity: i
    }
  };
  return gl(s, {
    text: o,
    align: {
      signal: "item.mark.group.align"
    },
    angle: {
      signal: "item.mark.group.angle"
    },
    limit: {
      signal: "item.mark.group.limit"
    },
    baseline: "top",
    dx: e("dx"),
    dy: e("dy"),
    fill: e("subtitleColor"),
    font: e("subtitleFont"),
    fontSize: e("subtitleFontSize"),
    fontStyle: e("subtitleFontStyle"),
    fontWeight: e("subtitleFontWeight"),
    lineHeight: e("subtitleLineHeight")
  }, {
    // update
    align: e("align"),
    angle: e("angle"),
    baseline: e("baseline")
  }), $f({
    type: x1,
    role: eEr,
    style: fyr,
    from: r,
    encode: s
  }, n);
}
function avr(t, e) {
  const n = [];
  t.transform && t.transform.forEach((r) => {
    n.push(n0e(r, e));
  }), t.on && t.on.forEach((r) => {
    yst(r, e, t.name);
  }), e.addDataPipeline(t.name, Avr(t, e, n));
}
function Avr(t, e, n) {
  const r = [];
  let i = null, o = !1, s = !1, a, A, l, c, u;
  for (t.values ? hA(t.values) || u4(t.format) ? (r.push(BFe(e, t)), r.push(i = Qy())) : r.push(i = Qy({
    $ingest: t.values,
    $format: t.format
  })) : t.url ? u4(t.url) || u4(t.format) ? (r.push(BFe(e, t)), r.push(i = Qy())) : r.push(i = Qy({
    $request: t.url,
    $format: t.format
  })) : t.source && (i = a = bn(t.source).map((f) => er(e.getData(f).output)), r.push(null)), A = 0, l = n.length; A < l; ++A)
    c = n[A], u = c.metadata, !i && !u.source && r.push(i = Qy()), r.push(c), u.generates && (s = !0), u.modifies && !s && (o = !0), u.source ? i = c : u.changes && (i = null);
  return a && (l = a.length - 1, r[0] = UEr({
    derive: o,
    pulse: l ? a : a[0]
  }), (o || l) && r.splice(1, 0, Qy())), i || r.push(Qy()), r.push(w1({})), r;
}
function Qy(t) {
  const e = Fd({}, t);
  return e.metadata = {
    source: !0
  }, e;
}
function BFe(t, e) {
  return NEr({
    url: e.url ? t.property(e.url) : void 0,
    async: e.async ? t.property(e.async) : void 0,
    values: e.values ? t.property(e.values) : void 0,
    format: t.objectProperty(e.format)
  });
}
const vst = (t) => t === uE || t === Pd, hY = (t, e, n) => hA(t) ? fvr(t.signal, e, n) : t === _x || t === Pd ? e : n, FA = (t, e, n) => hA(t) ? cvr(t.signal, e, n) : vst(t) ? e : n, sd = (t, e, n) => hA(t) ? uvr(t.signal, e, n) : vst(t) ? n : e, Bst = (t, e, n) => hA(t) ? gvr(t.signal, e, n) : t === Pd ? {
  value: e
} : {
  value: n
}, lvr = (t, e, n) => hA(t) ? hvr(t.signal, e, n) : t === Sx ? {
  value: e
} : {
  value: n
}, cvr = (t, e, n) => bst(`${t} === '${Pd}' || ${t} === '${uE}'`, e, n), uvr = (t, e, n) => bst(`${t} !== '${Pd}' && ${t} !== '${uE}'`, e, n), fvr = (t, e, n) => r0e(`${t} === '${_x}' || ${t} === '${Pd}'`, e, n), gvr = (t, e, n) => r0e(`${t} === '${Pd}'`, e, n), hvr = (t, e, n) => r0e(`${t} === '${Sx}'`, e, n), bst = (t, e, n) => (e = e != null ? OA(e) : e, n = n != null ? OA(n) : n, bFe(e) && bFe(n) ? (e = e ? e.signal || an(e.value) : null, n = n ? n.signal || an(n.value) : null, {
  signal: `${t} ? (${e}) : (${n})`
}) : [ni({
  test: t
}, e)].concat(n || [])), bFe = (t) => t == null || Object.keys(t).length === 1, r0e = (t, e, n) => ({
  signal: `${t} ? (${R_(e)}) : (${R_(n)})`
}), dvr = (t, e, n, r, i) => ({
  signal: (r != null ? `${t} === '${_x}' ? (${R_(r)}) : ` : "") + (n != null ? `${t} === '${uE}' ? (${R_(n)}) : ` : "") + (i != null ? `${t} === '${Sx}' ? (${R_(i)}) : ` : "") + (e != null ? `${t} === '${Pd}' ? (${R_(e)}) : ` : "") + "(null)"
}), R_ = (t) => hA(t) ? t.signal : t == null ? null : an(t), pvr = (t, e) => e === 0 ? 0 : hA(t) ? {
  signal: `(${t.signal}) * ${e}`
} : {
  value: t * e
}, cS = (t, e) => {
  const n = t.signal;
  return n && n.endsWith("(null)") ? {
    signal: n.slice(0, -6) + e.signal
  } : t;
};
function Ob(t, e, n, r) {
  let i;
  if (e && Kn(e, t))
    return e[t];
  if (Kn(n, t))
    return n[t];
  if (t.startsWith("title")) {
    switch (t) {
      case "titleColor":
        i = "fill";
        break;
      case "titleFont":
      case "titleFontSize":
      case "titleFontWeight":
        i = t[5].toLowerCase() + t.slice(6);
    }
    return r[Kpe][i];
  } else if (t.startsWith("label")) {
    switch (t) {
      case "labelColor":
        i = "fill";
        break;
      case "labelFont":
      case "labelFontSize":
        i = t[5].toLowerCase() + t.slice(6);
    }
    return r[RO][i];
  }
  return null;
}
function _Fe(t) {
  const e = {};
  for (const n of t)
    if (n)
      for (const r in n)
        e[r] = 1;
  return Object.keys(e);
}
function Ivr(t, e) {
  var n = e.config, r = n.style, i = n.axis, o = e.scaleType(t.scale) === "band" && n.axisBand, s = t.orient, a, A, l;
  if (hA(s)) {
    const u = _Fe([n.axisX, n.axisY]), f = _Fe([n.axisTop, n.axisBottom, n.axisLeft, n.axisRight]);
    a = {};
    for (l of u)
      a[l] = FA(s, Ob(l, n.axisX, i, r), Ob(l, n.axisY, i, r));
    A = {};
    for (l of f)
      A[l] = dvr(s.signal, Ob(l, n.axisTop, i, r), Ob(l, n.axisBottom, i, r), Ob(l, n.axisLeft, i, r), Ob(l, n.axisRight, i, r));
  } else
    a = s === Pd || s === uE ? n.axisX : n.axisY, A = n["axis" + s[0].toUpperCase() + s.slice(1)];
  return a || A || o ? ni({}, i, a, A, o) : i;
}
function mvr(t, e, n, r) {
  const i = zu(t, e), o = t.orient;
  let s, a;
  const A = {
    enter: s = {
      opacity: Di
    },
    update: a = {
      opacity: Mg
    },
    exit: {
      opacity: Di
    }
  };
  gl(A, {
    stroke: i("domainColor"),
    strokeCap: i("domainCap"),
    strokeDash: i("domainDash"),
    strokeDashOffset: i("domainDashOffset"),
    strokeWidth: i("domainWidth"),
    strokeOpacity: i("domainOpacity")
  });
  const l = SFe(t, 0), c = SFe(t, 1);
  return s.x = a.x = FA(o, l, Di), s.x2 = a.x2 = FA(o, c), s.y = a.y = sd(o, l, Di), s.y2 = a.y2 = sd(o, c), $f({
    type: Xpe,
    role: UCr,
    from: r,
    encode: A
  }, n);
}
function SFe(t, e) {
  return {
    scale: t.scale,
    range: e
  };
}
function Cvr(t, e, n, r, i) {
  const o = zu(t, e), s = t.orient, a = t.gridScale, A = hY(s, 1, -1), l = Evr(t.offset, A);
  let c, u, f;
  const h = {
    enter: c = {
      opacity: Di
    },
    update: f = {
      opacity: Mg
    },
    exit: u = {
      opacity: Di
    }
  };
  gl(h, {
    stroke: o("gridColor"),
    strokeCap: o("gridCap"),
    strokeDash: o("gridDash"),
    strokeDashOffset: o("gridDashOffset"),
    strokeOpacity: o("gridOpacity"),
    strokeWidth: o("gridWidth")
  });
  const d = {
    scale: t.scale,
    field: Lg,
    band: i.band,
    extra: i.extra,
    offset: i.offset,
    round: o("tickRound")
  }, I = FA(s, {
    signal: "height"
  }, {
    signal: "width"
  }), m = a ? {
    scale: a,
    range: 0,
    mult: A,
    offset: l
  } : {
    value: 0,
    offset: l
  }, C = a ? {
    scale: a,
    range: 1,
    mult: A,
    offset: l
  } : ni(I, {
    mult: A,
    offset: l
  });
  return c.x = f.x = FA(s, d, m), c.y = f.y = sd(s, d, m), c.x2 = f.x2 = sd(s, C), c.y2 = f.y2 = FA(s, C), u.x = FA(s, d), u.y = sd(s, d), $f({
    type: Xpe,
    role: HCr,
    key: Lg,
    from: r,
    encode: h
  }, n);
}
function Evr(t, e) {
  if (e !== 1)
    if (!_n(t))
      t = hA(e) ? {
        signal: `(${e.signal}) * (${t || 0})`
      } : e * (t || 0);
    else {
      let n = t = ni({}, t);
      for (; n.mult != null; )
        if (_n(n.mult))
          n = n.mult = ni({}, n.mult);
        else
          return n.mult = hA(e) ? {
            signal: `(${n.mult}) * (${e.signal})`
          } : n.mult * e, t;
      n.mult = e;
    }
  return t;
}
function yvr(t, e, n, r, i, o) {
  const s = zu(t, e), a = t.orient, A = hY(a, -1, 1);
  let l, c, u;
  const f = {
    enter: l = {
      opacity: Di
    },
    update: u = {
      opacity: Mg
    },
    exit: c = {
      opacity: Di
    }
  };
  gl(f, {
    stroke: s("tickColor"),
    strokeCap: s("tickCap"),
    strokeDash: s("tickDash"),
    strokeDashOffset: s("tickDashOffset"),
    strokeOpacity: s("tickOpacity"),
    strokeWidth: s("tickWidth")
  });
  const h = OA(i);
  h.mult = A;
  const d = {
    scale: t.scale,
    field: Lg,
    band: o.band,
    extra: o.extra,
    offset: o.offset,
    round: s("tickRound")
  };
  return u.y = l.y = FA(a, Di, d), u.y2 = l.y2 = FA(a, h), c.x = FA(a, d), u.x = l.x = sd(a, Di, d), u.x2 = l.x2 = sd(a, h), c.y = sd(a, d), $f({
    type: Xpe,
    role: qCr,
    key: Lg,
    from: r,
    encode: f
  }, n);
}
function aX(t, e, n, r, i) {
  return {
    signal: 'flush(range("' + t + '"), scale("' + t + '", datum.value), ' + e + "," + n + "," + r + "," + i + ")"
  };
}
function vvr(t, e, n, r, i, o) {
  const s = zu(t, e), a = t.orient, A = t.scale, l = hY(a, -1, 1), c = Ov(s("labelFlush")), u = Ov(s("labelFlushOffset")), f = s("labelAlign"), h = s("labelBaseline");
  let d = c === 0 || !!c, I;
  const m = OA(i);
  m.mult = l, m.offset = OA(s("labelPadding") || 0), m.offset.mult = l;
  const C = {
    scale: A,
    field: Lg,
    band: 0.5,
    offset: Ist(o.offset, s("labelOffset"))
  }, y = FA(a, d ? aX(A, c, '"left"', '"right"', '"center"') : {
    value: "center"
  }, lvr(a, "left", "right")), v = FA(a, Bst(a, "bottom", "top"), d ? aX(A, c, '"top"', '"bottom"', '"middle"') : {
    value: "middle"
  }), b = aX(A, c, `-(${u})`, u, 0);
  d = d && u;
  const Q = {
    opacity: Di,
    x: FA(a, C, m),
    y: sd(a, C, m)
  }, w = {
    enter: Q,
    update: I = {
      opacity: Mg,
      text: {
        field: Jpe
      },
      x: Q.x,
      y: Q.y,
      align: y,
      baseline: v
    },
    exit: {
      opacity: Di,
      x: Q.x,
      y: Q.y
    }
  };
  gl(w, {
    dx: !f && d ? FA(a, b) : null,
    dy: !h && d ? sd(a, b) : null
  }), gl(w, {
    angle: s("labelAngle"),
    fill: s("labelColor"),
    fillOpacity: s("labelOpacity"),
    font: s("labelFont"),
    fontSize: s("labelFontSize"),
    fontWeight: s("labelFontWeight"),
    fontStyle: s("labelFontStyle"),
    limit: s("labelLimit"),
    lineHeight: s("labelLineHeight")
  }, {
    align: f,
    baseline: h
  });
  const R = s("labelBound");
  let M = s("labelOverlap");
  return M = M || R ? {
    separation: s("labelSeparation"),
    method: M,
    order: "datum.index",
    bound: R ? {
      scale: A,
      orient: a,
      tolerance: R
    } : null
  } : void 0, I.align !== y && (I.align = cS(I.align, y)), I.baseline !== v && (I.baseline = cS(I.baseline, v)), $f({
    type: x1,
    role: $Cr,
    style: RO,
    key: Lg,
    from: r,
    encode: w,
    overlap: M
  }, n);
}
function Bvr(t, e, n, r) {
  const i = zu(t, e), o = t.orient, s = hY(o, -1, 1);
  let a, A;
  const l = {
    enter: a = {
      opacity: Di,
      anchor: OA(i("titleAnchor", null)),
      align: {
        signal: Zpe
      }
    },
    update: A = ni({}, a, {
      opacity: Mg,
      text: OA(t.title)
    }),
    exit: {
      opacity: Di
    }
  }, c = {
    signal: `lerp(range("${t.scale}"), ${uY(0, 1, 0.5)})`
  };
  return A.x = FA(o, c), A.y = sd(o, c), a.angle = FA(o, Di, pvr(s, 90)), a.baseline = FA(o, Bst(o, uE, Pd), {
    value: uE
  }), A.angle = a.angle, A.baseline = a.baseline, gl(l, {
    fill: i("titleColor"),
    fillOpacity: i("titleOpacity"),
    font: i("titleFont"),
    fontSize: i("titleFontSize"),
    fontStyle: i("titleFontStyle"),
    fontWeight: i("titleFontWeight"),
    limit: i("titleLimit"),
    lineHeight: i("titleLineHeight")
  }, {
    // require update
    align: i("titleAlign"),
    angle: i("titleAngle"),
    baseline: i("titleBaseline")
  }), bvr(i, o, l, n), l.update.align = cS(l.update.align, a.align), l.update.angle = cS(l.update.angle, a.angle), l.update.baseline = cS(l.update.baseline, a.baseline), $f({
    type: x1,
    role: jCr,
    style: Kpe,
    from: r,
    encode: l
  }, n);
}
function bvr(t, e, n, r) {
  const i = (a, A) => a != null ? (n.update[A] = cS(OA(a), n.update[A]), !1) : !i_(A, r), o = i(t("titleX"), "x"), s = i(t("titleY"), "y");
  n.enter.auto = s === o ? OA(s) : FA(e, OA(s), OA(o));
}
function _vr(t, e) {
  const n = Ivr(t, e), r = t.encode || {}, i = r.axis || {}, o = i.name || void 0, s = i.interactive, a = i.style, A = zu(t, n), l = yyr(A), c = {
    scale: t.scale,
    ticks: !!A("ticks"),
    labels: !!A("labels"),
    grid: !!A("grid"),
    domain: !!A("domain"),
    title: t.title != null
  }, u = er(e.add(Fd({}, [c]))), f = er(e.add(SEr({
    scale: e.scaleRef(t.scale),
    extra: e.property(l.extra),
    count: e.objectProperty(t.tickCount),
    values: e.objectProperty(t.values),
    minstep: e.property(t.tickMinStep),
    formatType: e.property(t.formatType),
    formatSpecifier: e.property(t.format)
  }))), h = [];
  let d;
  return c.grid && h.push(Cvr(t, n, r.grid, f, l)), c.ticks && (d = A("tickSize"), h.push(yvr(t, n, r.ticks, f, d, l))), c.labels && (d = c.ticks ? d : 0, h.push(vvr(t, n, r.labels, f, d, l))), c.domain && h.push(mvr(t, n, r.domain, u)), c.title && h.push(Bvr(t, n, r.title, u)), gY(PN({
    role: GCr,
    from: u,
    encode: bx(Svr(A, t), i, DO),
    marks: h,
    aria: A("aria"),
    description: A("description"),
    zindex: A("zindex"),
    name: o,
    interactive: s,
    style: a
  }), e);
}
function Svr(t, e) {
  const n = {
    enter: {},
    update: {}
  };
  return gl(n, {
    orient: t("orient"),
    offset: t("offset") || 0,
    position: Th(e.position, 0),
    titlePadding: t("titlePadding"),
    minExtent: t("minExtent"),
    maxExtent: t("maxExtent"),
    range: {
      signal: `abs(span(range("${e.scale}")))`
    },
    translate: t("translate"),
    // accessibility support
    format: e.format,
    formatType: e.formatType
  }), n;
}
function _st(t, e, n) {
  const r = bn(t.signals), i = bn(t.scales);
  return n || r.forEach((o) => rst(o, e)), bn(t.projections).forEach((o) => iyr(o, e)), i.forEach((o) => YEr(o, e)), bn(t.data).forEach((o) => avr(o, e)), i.forEach((o) => zEr(o, e)), (n || r).forEach((o) => _Er(o, e)), bn(t.axes).forEach((o) => _vr(o, e)), bn(t.marks).forEach((o) => gY(o, e)), bn(t.legends).forEach((o) => Jyr(o, e)), t.title && nvr(t.title, e), e.parseLambdas(), e;
}
const Qvr = (t) => bx({
  enter: {
    x: {
      value: 0
    },
    y: {
      value: 0
    }
  },
  update: {
    width: {
      signal: "width"
    },
    height: {
      signal: "height"
    }
  }
}, t);
function wvr(t, e) {
  const n = e.config, r = er(e.root = e.add(R6())), i = xvr(t, n);
  i.forEach((l) => rst(l, e)), e.description = t.description || n.description, e.eventConfig = n.events, e.legends = e.objectProperty(n.legend && n.legend.layout), e.locale = n.locale;
  const o = e.add(Fd()), s = e.add(sst(nst(Qvr(t.encode), cY, jpe, t.style, e, {
    pulse: er(o)
  }))), a = e.add(lst({
    layout: e.objectProperty(t.layout),
    legends: e.legends,
    autosize: e.signalRef("autosize"),
    mark: r,
    pulse: er(s)
  }));
  e.operators.pop(), e.pushState(er(s), er(a), null), _st(t, e, i), e.operators.push(a);
  let A = e.add(ost({
    mark: r,
    pulse: er(a)
  }));
  return A = e.add(Ast({
    pulse: er(A)
  })), A = e.add(w1({
    pulse: er(A)
  })), e.addData("root", new wB(e, o, o, A)), e;
}
function nR(t, e) {
  return e && e.signal ? {
    name: t,
    update: e.signal
  } : {
    name: t,
    value: e
  };
}
function xvr(t, e) {
  const n = (s) => Th(t[s], e[s]), r = [nR("background", n("background")), nR("autosize", FCr(n("autosize"))), nR("padding", kCr(n("padding"))), nR("width", n("width") || 0), nR("height", n("height") || 0)], i = r.reduce((s, a) => (s[a.name] = a, s), {}), o = {};
  return bn(t.signals).forEach((s) => {
    Kn(i, s.name) ? s = ni(i[s.name], s) : r.push(s), o[s.name] = s;
  }), bn(e.signals).forEach((s) => {
    !Kn(o, s.name) && !Kn(i, s.name) && r.push(s);
  }), r;
}
function Sst(t, e) {
  this.config = t || {}, this.options = e || {}, this.bindings = [], this.field = {}, this.signals = {}, this.lambdas = {}, this.scales = {}, this.events = {}, this.data = {}, this.streams = [], this.updates = [], this.operators = [], this.eventConfig = null, this.locale = null, this._id = 0, this._subid = 0, this._nextsub = [0], this._parent = [], this._encode = [], this._lookup = [], this._markpath = [];
}
function QFe(t) {
  this.config = t.config, this.options = t.options, this.legends = t.legends, this.field = Object.create(t.field), this.signals = Object.create(t.signals), this.lambdas = Object.create(t.lambdas), this.scales = Object.create(t.scales), this.events = Object.create(t.events), this.data = Object.create(t.data), this.streams = [], this.updates = [], this.operators = [], this._id = 0, this._subid = ++t._nextsub[0], this._nextsub = t._nextsub, this._parent = t._parent.slice(), this._encode = t._encode.slice(), this._lookup = t._lookup.slice(), this._markpath = t._markpath;
}
Sst.prototype = QFe.prototype = {
  parse(t) {
    return _st(t, this);
  },
  fork() {
    return new QFe(this);
  },
  isSubscope() {
    return this._subid > 0;
  },
  toRuntime() {
    return this.finish(), {
      description: this.description,
      operators: this.operators,
      streams: this.streams,
      updates: this.updates,
      bindings: this.bindings,
      eventConfig: this.eventConfig,
      locale: this.locale
    };
  },
  id() {
    return (this._subid ? this._subid + ":" : 0) + this._id++;
  },
  add(t) {
    return this.operators.push(t), t.id = this.id(), t.refs && (t.refs.forEach((e) => {
      e.$ref = t.id;
    }), t.refs = null), t;
  },
  proxy(t) {
    const e = t instanceof goe ? er(t) : t;
    return this.add(GEr({
      value: e
    }));
  },
  addStream(t) {
    return this.streams.push(t), t.id = this.id(), t;
  },
  addUpdate(t) {
    return this.updates.push(t), t;
  },
  // Apply metadata
  finish() {
    let t, e;
    this.root && (this.root.root = !0);
    for (t in this.signals)
      this.signals[t].signal = t;
    for (t in this.scales)
      this.scales[t].scale = t;
    function n(r, i, o) {
      let s, a;
      r && (s = r.data || (r.data = {}), a = s[i] || (s[i] = []), a.push(o));
    }
    for (t in this.data) {
      e = this.data[t], n(e.input, t, "input"), n(e.output, t, "output"), n(e.values, t, "values");
      for (const r in e.index)
        n(e.index[r], t, "index:" + r);
    }
    return this;
  },
  // ----
  pushState(t, e, n) {
    this._encode.push(er(this.add(w1({
      pulse: t
    })))), this._parent.push(e), this._lookup.push(n ? er(this.proxy(n)) : null), this._markpath.push(-1);
  },
  popState() {
    this._encode.pop(), this._parent.pop(), this._lookup.pop(), this._markpath.pop();
  },
  parent() {
    return bi(this._parent);
  },
  encode() {
    return bi(this._encode);
  },
  lookup() {
    return bi(this._lookup);
  },
  markpath() {
    const t = this._markpath;
    return ++t[t.length - 1];
  },
  // ----
  fieldRef(t, e) {
    if (Cn(t))
      return ON(t, e);
    t.signal || wt("Unsupported field reference: " + an(t));
    const n = t.signal;
    let r = this.field[n];
    if (!r) {
      const i = {
        name: this.signalRef(n)
      };
      e && (i.as = e), this.field[n] = r = er(this.add(REr(i)));
    }
    return r;
  },
  compareRef(t) {
    let e = !1;
    const n = (o) => hA(o) ? (e = !0, this.signalRef(o.signal)) : dEr(o) ? (e = !0, this.exprRef(o.expr)) : o, r = bn(t.field).map(n), i = bn(t.order).map(n);
    return e ? er(this.add(gFe({
      fields: r,
      orders: i
    }))) : uFe(r, i);
  },
  keyRef(t, e) {
    let n = !1;
    const r = (o) => hA(o) ? (n = !0, er(i[o.signal])) : o, i = this.signals;
    return t = bn(t).map(r), n ? er(this.add(DEr({
      fields: t,
      flat: e
    }))) : uEr(t, e);
  },
  sortRef(t) {
    if (!t)
      return t;
    const e = AY(t.op, t.field), n = t.order || fEr;
    return n.signal ? er(this.add(gFe({
      fields: e,
      orders: this.signalRef(n.signal)
    }))) : uFe(e, n);
  },
  // ----
  event(t, e) {
    const n = t + ":" + e;
    if (!this.events[n]) {
      const r = this.id();
      this.streams.push({
        id: r,
        source: t,
        type: e
      }), this.events[n] = r;
    }
    return this.events[n];
  },
  // ----
  hasOwnSignal(t) {
    return Kn(this.signals, t);
  },
  addSignal(t, e) {
    this.hasOwnSignal(t) && wt("Duplicate signal name: " + an(t));
    const n = e instanceof goe ? e : this.add(R6(e));
    return this.signals[t] = n;
  },
  getSignal(t) {
    return this.signals[t] || wt("Unrecognized signal name: " + an(t)), this.signals[t];
  },
  signalRef(t) {
    return this.signals[t] ? er(this.signals[t]) : (Kn(this.lambdas, t) || (this.lambdas[t] = this.add(R6(null))), er(this.lambdas[t]));
  },
  parseLambdas() {
    const t = Object.keys(this.lambdas);
    for (let e = 0, n = t.length; e < n; ++e) {
      const r = t[e], i = Xp(r, this), o = this.lambdas[r];
      o.params = i.$params, o.update = i.$expr;
    }
  },
  property(t) {
    return t && t.signal ? this.signalRef(t.signal) : t;
  },
  objectProperty(t) {
    return !t || !_n(t) ? t : this.signalRef(t.signal || i0e(t));
  },
  exprRef(t, e) {
    const n = {
      expr: Xp(t, this)
    };
    return e && (n.expr.$name = e), er(this.add(wEr(n)));
  },
  addBinding(t, e) {
    this.bindings || wt("Nested signals do not support binding: " + an(t)), this.bindings.push(ni({
      signal: t
    }, e));
  },
  // ----
  addScaleProj(t, e) {
    Kn(this.scales, t) && wt("Duplicate scale or projection name: " + an(t)), this.scales[t] = this.add(e);
  },
  addScale(t, e) {
    this.addScaleProj(t, HEr(e));
  },
  addProjection(t, e) {
    this.addScaleProj(t, kEr(e));
  },
  getScale(t) {
    return this.scales[t] || wt("Unrecognized scale name: " + an(t)), this.scales[t];
  },
  scaleRef(t) {
    return er(this.getScale(t));
  },
  scaleType(t) {
    return this.getScale(t).params.type;
  },
  projectionRef(t) {
    return this.scaleRef(t);
  },
  projectionType(t) {
    return this.scaleType(t);
  },
  // ----
  addData(t, e) {
    return Kn(this.data, t) && wt("Duplicate data set name: " + an(t)), this.data[t] = e;
  },
  getData(t) {
    return this.data[t] || wt("Undefined data set name: " + an(t)), this.data[t];
  },
  addDataPipeline(t, e) {
    return Kn(this.data, t) && wt("Duplicate data set name: " + an(t)), this.addData(t, wB.fromEntries(this, e));
  }
};
function i0e(t) {
  return (Nt(t) ? Rvr : Dvr)(t);
}
function Rvr(t) {
  const e = t.length;
  let n = "[";
  for (let r = 0; r < e; ++r) {
    const i = t[r];
    n += (r > 0 ? "," : "") + (_n(i) ? i.signal || i0e(i) : an(i));
  }
  return n + "]";
}
function Dvr(t) {
  let e = "{", n = 0, r, i;
  for (r in t)
    i = t[r], e += (++n > 1 ? "," : "") + an(r) + ":" + (_n(i) ? i.signal || i0e(i) : an(i));
  return e + "}";
}
function Tvr() {
  const t = "sans-serif", r = "#4c78a8", i = "#000", o = "#888", s = "#ddd";
  return {
    // default visualization description
    description: "Vega visualization",
    // default padding around visualization
    padding: 0,
    // default for automatic sizing; options: 'none', 'pad', 'fit'
    // or provide an object (e.g., {'type': 'pad', 'resize': true})
    autosize: "pad",
    // default view background color
    // covers the entire view component
    background: null,
    // default event handling configuration
    // preventDefault for view-sourced event types except 'wheel'
    events: {
      defaults: {
        allow: ["wheel"]
      }
    },
    // defaults for top-level group marks
    // accepts mark properties (fill, stroke, etc)
    // covers the data rectangle within group width/height
    group: null,
    // defaults for basic mark types
    // each subset accepts mark properties (fill, stroke, etc)
    mark: null,
    arc: {
      fill: r
    },
    area: {
      fill: r
    },
    image: null,
    line: {
      stroke: r,
      strokeWidth: 2
    },
    path: {
      stroke: r
    },
    rect: {
      fill: r
    },
    rule: {
      stroke: i
    },
    shape: {
      stroke: r
    },
    symbol: {
      fill: r,
      size: 64
    },
    text: {
      fill: i,
      font: t,
      fontSize: 11
    },
    trail: {
      fill: r,
      size: 2
    },
    // style definitions
    style: {
      // axis & legend labels
      "guide-label": {
        fill: i,
        font: t,
        fontSize: 10
      },
      // axis & legend titles
      "guide-title": {
        fill: i,
        font: t,
        fontSize: 11,
        fontWeight: "bold"
      },
      // headers, including chart title
      "group-title": {
        fill: i,
        font: t,
        fontSize: 13,
        fontWeight: "bold"
      },
      // chart subtitle
      "group-subtitle": {
        fill: i,
        font: t,
        fontSize: 12
      },
      // defaults for styled point marks in Vega-Lite
      point: {
        size: 30,
        strokeWidth: 2,
        shape: "circle"
      },
      circle: {
        size: 30,
        strokeWidth: 2
      },
      square: {
        size: 30,
        strokeWidth: 2,
        shape: "square"
      },
      // defaults for styled group marks in Vega-Lite
      cell: {
        fill: "transparent",
        stroke: s
      }
    },
    // defaults for title
    title: {
      orient: "top",
      anchor: "middle",
      offset: 4,
      subtitlePadding: 3
    },
    // defaults for axes
    axis: {
      minExtent: 0,
      maxExtent: 200,
      bandPosition: 0.5,
      domain: !0,
      domainWidth: 1,
      domainColor: o,
      grid: !1,
      gridWidth: 1,
      gridColor: s,
      labels: !0,
      labelAngle: 0,
      labelLimit: 180,
      labelOffset: 0,
      labelPadding: 2,
      ticks: !0,
      tickColor: o,
      tickOffset: 0,
      tickRound: !0,
      tickSize: 5,
      tickWidth: 1,
      titlePadding: 4
    },
    // correction for centering bias
    axisBand: {
      tickOffset: -0.5
    },
    // defaults for cartographic projection
    projection: {
      type: "mercator"
    },
    // defaults for legends
    legend: {
      orient: "right",
      padding: 0,
      gridAlign: "each",
      columnPadding: 10,
      rowPadding: 2,
      symbolDirection: "vertical",
      gradientDirection: "vertical",
      gradientLength: 200,
      gradientThickness: 16,
      gradientStrokeColor: s,
      gradientStrokeWidth: 0,
      gradientLabelOffset: 2,
      labelAlign: "left",
      labelBaseline: "middle",
      labelLimit: 160,
      labelOffset: 4,
      labelOverlap: !0,
      symbolLimit: 30,
      symbolType: "circle",
      symbolSize: 100,
      symbolOffset: 0,
      symbolStrokeWidth: 1.5,
      symbolBaseFillColor: "transparent",
      symbolBaseStrokeColor: o,
      titleLimit: 180,
      titleOrient: "top",
      titlePadding: 5,
      layout: {
        offset: 18,
        direction: "horizontal",
        left: {
          direction: "vertical"
        },
        right: {
          direction: "vertical"
        }
      }
    },
    // defaults for scale ranges
    range: {
      category: {
        scheme: "tableau10"
      },
      ordinal: {
        scheme: "blues"
      },
      heatmap: {
        scheme: "yellowgreenblue"
      },
      ramp: {
        scheme: "blues"
      },
      diverging: {
        scheme: "blueorange",
        extent: [1, 0]
      },
      symbol: ["circle", "square", "triangle-up", "cross", "diamond", "triangle-right", "triangle-down", "triangle-left"]
    }
  };
}
function Nvr(t, e, n) {
  return _n(t) || wt("Input Vega specification must be an object."), e = fx(Tvr(), e, t.config), wvr(t, new Sst(e, n)).toRuntime();
}
var Lvr = "5.22.1";
ni(IQ, Por, our, Fur, vgr, phr, $dr, vdr, jdr, hpr, bpr, Dpr);
const Mvr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Bounds: za,
  CanvasHandler: yO,
  CanvasRenderer: q5,
  DATE: Uu,
  DAY: Yl,
  DAYOFYEAR: Kp,
  Dataflow: sS,
  Debug: bXe,
  Error: oge,
  EventStream: Ij,
  Gradient: bnt,
  GroupItem: Pj,
  HOURS: Gf,
  Handler: lE,
  Info: BXe,
  Item: Fj,
  MILLISECONDS: Id,
  MINUTES: Uf,
  MONTH: ec,
  Marks: Hf,
  MultiPulse: kge,
  None: vXe,
  Operator: jo,
  Parameters: pj,
  Pulse: FC,
  QUARTER: Gu,
  RenderType: CC,
  Renderer: p0,
  ResourceLoader: ade,
  SECONDS: jg,
  SVGHandler: _de,
  SVGRenderer: Dde,
  SVGStringRenderer: Tde,
  Scenegraph: Bde,
  TIME_UNITS: xge,
  Transform: yt,
  View: qot,
  WEEK: fA,
  Warn: sge,
  YEAR: fl,
  accessor: Yu,
  accessorFields: Zl,
  accessorName: pa,
  array: bn,
  ascending: aj,
  bandwidthNRD: $ge,
  bin: get,
  bootstrapCI: het,
  boundClip: mrt,
  boundContext: IO,
  boundItem: Iie,
  boundMark: $nt,
  boundStroke: sm,
  changeset: b1,
  clampRange: MXe,
  codegenExpression: mot,
  compare: uge,
  constant: lc,
  cumulativeLogNormal: Jge,
  cumulativeNormal: Cj,
  cumulativeUniform: Zge,
  dayofyear: CZe,
  debounce: fge,
  defaultLocale: Lge,
  definition: cet,
  densityLogNormal: Vge,
  densityNormal: qge,
  densityUniform: Xge,
  domChild: bu,
  domClear: Ph,
  domCreate: IC,
  domFind: bde,
  dotbin: det,
  error: wt,
  expressionFunction: Ka,
  extend: ni,
  extent: Jp,
  extentIndex: OXe,
  falsy: Um,
  fastmap: hx,
  field: ku,
  flush: FXe,
  font: $j,
  fontFamily: EO,
  fontSize: d0,
  format: YG,
  formatLocale: b5,
  formats: Fge,
  hasOwnProperty: Kn,
  id: nO,
  identity: Ac,
  inferType: XZe,
  inferTypes: ZZe,
  ingest: so,
  inherits: on,
  inrange: b_,
  interpolate: Zhe,
  interpolateColors: Mj,
  interpolateRange: cnt,
  intersect: hrt,
  intersectBoxLine: S_,
  intersectPath: Ade,
  intersectPoint: lde,
  intersectRule: Tnt,
  isArray: Nt,
  isBoolean: PE,
  isDate: NC,
  isFunction: ri,
  isIterable: PXe,
  isNumber: Po,
  isObject: _n,
  isRegExp: kXe,
  isString: Cn,
  isTuple: hj,
  key: gge,
  lerp: GXe,
  lineHeight: aE,
  loader: fj,
  locale: KZe,
  logger: age,
  lruCache: UXe,
  markup: Rde,
  merge: HXe,
  mergeConfig: fx,
  multiLineOffset: Ede,
  one: ux,
  pad: $Xe,
  panLinear: xXe,
  panLog: RXe,
  panPow: DXe,
  panSymlog: TXe,
  parse: Nvr,
  parseExpression: Dpe,
  parseSelector: jE,
  path: kE,
  pathCurves: ide,
  pathEqual: Crt,
  pathParse: BQ,
  pathRectangle: Qnt,
  pathRender: bN,
  pathSymbols: Snt,
  pathTrail: wnt,
  peek: bi,
  point: jj,
  projection: Wde,
  quantileLogNormal: Kge,
  quantileNormal: Ej,
  quantileUniform: ehe,
  quantiles: Uge,
  quantizeInterpolator: unt,
  quarter: NXe,
  quartiles: Hge,
  get random() {
    return Yg;
  },
  randomInteger: Uir,
  randomKDE: Yge,
  randomLCG: Gir,
  randomLogNormal: Iet,
  randomMixture: met,
  randomNormal: jge,
  randomUniform: Cet,
  read: net,
  regressionExp: yet,
  regressionLinear: the,
  regressionLoess: bet,
  regressionLog: Eet,
  regressionPoly: Bet,
  regressionPow: vet,
  regressionQuad: nhe,
  renderModule: Yj,
  repeat: UR,
  resetDefaultLocale: Frr,
  resetSVGClipId: Rnt,
  resetSVGDefIds: ycr,
  responseType: tet,
  runtimeContext: Dot,
  sampleCurve: vj,
  sampleLogNormal: zge,
  sampleNormal: mj,
  sampleUniform: Wge,
  scale: Vi,
  sceneEqual: Nde,
  sceneFromJSON: jnt,
  scenePickVisit: P5,
  sceneToJSON: qnt,
  sceneVisit: md,
  sceneZOrder: cde,
  scheme: ede,
  serializeXML: srt,
  setRandom: Pir,
  span: rO,
  splitAccessPath: g0,
  stringValue: an,
  textMetrics: od,
  timeBin: OZe,
  timeFloor: SZe,
  timeFormatLocale: mN,
  timeInterval: Ix,
  timeOffset: xZe,
  timeSequence: TZe,
  timeUnitSpecifier: mZe,
  timeUnits: Rge,
  toBoolean: hge,
  toDate: dge,
  toNumber: Kl,
  toSet: pd,
  toString: pge,
  transform: uet,
  transforms: IQ,
  truncate: qXe,
  truthy: qg,
  tupleid: tr,
  typeParsers: Wre,
  utcFloor: QZe,
  utcInterval: mx,
  utcOffset: RZe,
  utcSequence: NZe,
  utcdayofyear: vZe,
  utcquarter: LXe,
  utcweek: BZe,
  version: Lvr,
  visitArray: Jm,
  week: EZe,
  writeConfig: gx,
  zero: nC,
  zoomLinear: Age,
  zoomLog: lge,
  zoomPow: h5,
  zoomSymlog: cge
}, Symbol.toStringTag, { value: "Module" }));
function Ovr(t, e, n) {
  let r;
  e.x2 && (e.x ? (n && t.x > t.x2 && (r = t.x, t.x = t.x2, t.x2 = r), t.width = t.x2 - t.x) : t.x = t.x2 - (t.width || 0)), e.xc && (t.x = t.xc - (t.width || 0) / 2), e.y2 && (e.y ? (n && t.y > t.y2 && (r = t.y, t.y = t.y2, t.y2 = r), t.height = t.y2 - t.y) : t.y = t.y2 - (t.height || 0)), e.yc && (t.y = t.yc - (t.height || 0) / 2);
}
var Fvr = {
  NaN: NaN,
  E: Math.E,
  LN2: Math.LN2,
  LN10: Math.LN10,
  LOG2E: Math.LOG2E,
  LOG10E: Math.LOG10E,
  PI: Math.PI,
  SQRT1_2: Math.SQRT1_2,
  SQRT2: Math.SQRT2,
  MIN_VALUE: Number.MIN_VALUE,
  MAX_VALUE: Number.MAX_VALUE
}, Pvr = {
  "*": (t, e) => t * e,
  "+": (t, e) => t + e,
  "-": (t, e) => t - e,
  "/": (t, e) => t / e,
  "%": (t, e) => t % e,
  ">": (t, e) => t > e,
  "<": (t, e) => t < e,
  "<=": (t, e) => t <= e,
  ">=": (t, e) => t >= e,
  "==": (t, e) => t == e,
  "!=": (t, e) => t != e,
  "===": (t, e) => t === e,
  "!==": (t, e) => t !== e,
  "&": (t, e) => t & e,
  "|": (t, e) => t | e,
  "^": (t, e) => t ^ e,
  "<<": (t, e) => t << e,
  ">>": (t, e) => t >> e,
  ">>>": (t, e) => t >>> e
}, kvr = {
  "+": (t) => +t,
  "-": (t) => -t,
  "~": (t) => ~t,
  "!": (t) => !t
};
const Gvr = Array.prototype.slice, wy = (t, e, n) => {
  const r = n ? n(e[0]) : e[0];
  return r[t].apply(r, Gvr.call(e, 1));
}, Uvr = (t, e, n, r, i, o, s) => new Date(t, e || 0, n ?? 1, r || 0, i || 0, o || 0, s || 0);
var Hvr = {
  // math functions
  isNaN: Number.isNaN,
  isFinite: Number.isFinite,
  abs: Math.abs,
  acos: Math.acos,
  asin: Math.asin,
  atan: Math.atan,
  atan2: Math.atan2,
  ceil: Math.ceil,
  cos: Math.cos,
  exp: Math.exp,
  floor: Math.floor,
  log: Math.log,
  max: Math.max,
  min: Math.min,
  pow: Math.pow,
  random: Math.random,
  round: Math.round,
  sin: Math.sin,
  sqrt: Math.sqrt,
  tan: Math.tan,
  clamp: (t, e, n) => Math.max(e, Math.min(n, t)),
  // date functions
  now: Date.now,
  utc: Date.UTC,
  datetime: Uvr,
  date: (t) => new Date(t).getDate(),
  day: (t) => new Date(t).getDay(),
  year: (t) => new Date(t).getFullYear(),
  month: (t) => new Date(t).getMonth(),
  hours: (t) => new Date(t).getHours(),
  minutes: (t) => new Date(t).getMinutes(),
  seconds: (t) => new Date(t).getSeconds(),
  milliseconds: (t) => new Date(t).getMilliseconds(),
  time: (t) => new Date(t).getTime(),
  timezoneoffset: (t) => new Date(t).getTimezoneOffset(),
  utcdate: (t) => new Date(t).getUTCDate(),
  utcday: (t) => new Date(t).getUTCDay(),
  utcyear: (t) => new Date(t).getUTCFullYear(),
  utcmonth: (t) => new Date(t).getUTCMonth(),
  utchours: (t) => new Date(t).getUTCHours(),
  utcminutes: (t) => new Date(t).getUTCMinutes(),
  utcseconds: (t) => new Date(t).getUTCSeconds(),
  utcmilliseconds: (t) => new Date(t).getUTCMilliseconds(),
  // sequence functions
  length: (t) => t.length,
  join: function() {
    return wy("join", arguments);
  },
  indexof: function() {
    return wy("indexOf", arguments);
  },
  lastindexof: function() {
    return wy("lastIndexOf", arguments);
  },
  slice: function() {
    return wy("slice", arguments);
  },
  reverse: (t) => t.slice().reverse(),
  // string functions
  parseFloat,
  parseInt,
  upper: (t) => String(t).toUpperCase(),
  lower: (t) => String(t).toLowerCase(),
  substring: function() {
    return wy("substring", arguments, String);
  },
  split: function() {
    return wy("split", arguments, String);
  },
  replace: function() {
    return wy("replace", arguments, String);
  },
  trim: (t) => String(t).trim(),
  // regexp functions
  regexp: RegExp,
  test: (t, e) => RegExp(t).test(e)
};
const $vr = ["view", "item", "group", "xy", "x", "y"], qvr = {
  Literal: (t, e) => e.value,
  Identifier: (t, e) => {
    const n = e.name;
    return t.memberDepth > 0 ? n : n === "datum" ? t.datum : n === "event" ? t.event : n === "item" ? t.item : Fvr[n] || t.params["$" + n];
  },
  MemberExpression: (t, e) => {
    const n = !e.computed, r = t(e.object);
    n && (t.memberDepth += 1);
    const i = t(e.property);
    return n && (t.memberDepth -= 1), r[i];
  },
  CallExpression: (t, e) => {
    const n = e.arguments;
    let r = e.callee.name;
    return r.startsWith("_") && (r = r.slice(1)), r === "if" ? t(n[0]) ? t(n[1]) : t(n[2]) : (t.fn[r] || Hvr[r]).apply(t.fn, n.map(t));
  },
  ArrayExpression: (t, e) => e.elements.map(t),
  BinaryExpression: (t, e) => Pvr[e.operator](t(e.left), t(e.right)),
  UnaryExpression: (t, e) => kvr[e.operator](t(e.argument)),
  ConditionalExpression: (t, e) => t(e.test) ? t(e.consequent) : t(e.alternate),
  LogicalExpression: (t, e) => e.operator === "&&" ? t(e.left) && t(e.right) : t(e.left) || t(e.right),
  ObjectExpression: (t, e) => e.properties.reduce((n, r) => {
    t.memberDepth += 1;
    const i = t(r.key);
    return t.memberDepth -= 1, n[i] = t(r.value), n;
  }, {})
};
function rR(t, e, n, r, i, o) {
  const s = (a) => qvr[a.type](s, a);
  return s.memberDepth = 0, s.fn = Object.create(e), s.params = n, s.datum = r, s.event = i, s.item = o, $vr.forEach((a) => s.fn[a] = (...A) => i.vega[a](...A)), s(t);
}
var jvr = {
  /**
   * Parse an expression used to update an operator value.
   */
  operator(t, e) {
    const n = e.ast, r = t.functions;
    return (i) => rR(n, r, i);
  },
  /**
   * Parse an expression provided as an operator parameter value.
   */
  parameter(t, e) {
    const n = e.ast, r = t.functions;
    return (i, o) => rR(n, r, o, i);
  },
  /**
   * Parse an expression applied to an event stream.
   */
  event(t, e) {
    const n = e.ast, r = t.functions;
    return (i) => rR(n, r, void 0, void 0, i);
  },
  /**
   * Parse an expression used to handle an event-driven operator update.
   */
  handler(t, e) {
    const n = e.ast, r = t.functions;
    return (i, o) => {
      const s = o.item && o.item.datum;
      return rR(n, r, i, s, o);
    };
  },
  /**
   * Parse an expression that performs visual encoding.
   */
  encode(t, e) {
    const {
      marktype: n,
      channels: r
    } = e, i = t.functions, o = n === "group" || n === "image" || n === "rect";
    return (s, a) => {
      const A = s.datum;
      let l = 0, c;
      for (const u in r)
        c = rR(r[u].ast, i, a, A, void 0, s), s[u] !== c && (s[u] = c, l = 1);
      return n !== "rule" && Ovr(s, r, o), l;
    };
  }
};
const Yvr = "vega-lite", zvr = 'Dominik Moritz, Kanit "Ham" Wongsuphasawat, Arvind Satyanarayan, Jeffrey Heer', Vvr = "5.2.0", Jvr = [
  "Kanit Wongsuphasawat (http://kanitw.yellowpigz.com)",
  "Dominik Moritz (https://www.domoritz.de)",
  "Arvind Satyanarayan (https://arvindsatya.com)",
  "Jeffrey Heer (https://jheer.org)"
], Kvr = "https://vega.github.io/vega-lite/", Wvr = "Vega-Lite is a concise high-level language for interactive visualization.", Xvr = [
  "vega",
  "chart",
  "visualization"
], Zvr = "build/vega-lite.js", eBr = "build/vega-lite.min.js", tBr = "build/vega-lite.min.js", nBr = "build/src/index", rBr = "build/src/index.d.ts", iBr = {
  vl2png: "./bin/vl2png",
  vl2svg: "./bin/vl2svg",
  vl2pdf: "./bin/vl2pdf",
  vl2vg: "./bin/vl2vg"
}, oBr = [
  "bin",
  "build",
  "src",
  "vega-lite*",
  "tsconfig.json"
], sBr = {
  changelog: "conventional-changelog -p angular -r 2",
  prebuild: "yarn clean:build",
  build: "yarn build:only",
  "build:only": "tsc -p tsconfig.build.json && rollup -c",
  "prebuild:examples": "yarn build:only",
  "build:examples": "yarn data && TZ=America/Los_Angeles scripts/build-examples.sh",
  "prebuild:examples-full": "yarn build:only",
  "build:examples-full": "TZ=America/Los_Angeles scripts/build-examples.sh 1",
  "build:example": "TZ=America/Los_Angeles scripts/build-example.sh",
  "build:toc": "yarn build:jekyll && scripts/generate-toc",
  "build:site": "rollup -c site/rollup.config.js",
  "build:jekyll": "pushd site && bundle exec jekyll build -q && popd",
  "build:versions": "scripts/update-version.sh",
  clean: "yarn clean:build && del-cli 'site/data/*' 'examples/compiled/*.png' && find site/examples ! -name 'index.md' ! -name 'data' -type f -delete",
  "clean:build": "del-cli 'build/*' !build/vega-lite-schema.json",
  "predeploy:site": "yarn presite",
  "deploy:site": "gh-pages -d site",
  data: "rsync -r node_modules/vega-datasets/data/* site/data",
  schema: "mkdir -p build && ts-json-schema-generator -f tsconfig.json -p src/index.ts -t TopLevelSpec --no-type-check --no-ref-encode > build/vega-lite-schema.json && yarn renameschema && cp build/vega-lite-schema.json site/_data/",
  renameschema: "scripts/rename-schema.sh",
  presite: "yarn data && yarn schema && yarn build:site && yarn build:versions && scripts/create-example-pages.sh",
  site: "yarn site:only",
  "site:only": "pushd site && bundle exec jekyll serve -I -l && popd",
  prettierbase: "prettier '**/*.{md,css,yml}'",
  eslintbase: "eslint .",
  format: "yarn eslintbase --fix && yarn prettierbase --write",
  lint: "yarn eslintbase && yarn prettierbase --check",
  jest: "NODE_OPTIONS=--experimental-vm-modules npx jest",
  test: "yarn jest test/ && yarn lint && yarn schema && yarn jest examples/ && yarn test:runtime",
  "test:cover": "yarn jest --collectCoverage test/",
  "test:inspect": "node --inspect-brk --experimental-vm-modules ./node_modules/.bin/jest --runInBand test",
  "test:runtime": "NODE_OPTIONS=--experimental-vm-modules TZ=America/Los_Angeles npx jest test-runtime/ --config test-runtime/jest-config.json",
  "test:runtime:generate": "yarn build:only && del-cli test-runtime/resources && VL_GENERATE_TESTS=true yarn test:runtime",
  watch: "tsc -p tsconfig.build.json -w",
  "watch:site": "yarn build:site -w",
  "watch:test": "yarn jest --watch test/",
  "watch:test:runtime": "NODE_OPTIONS=--experimental-vm-modules TZ=America/Los_Angeles npx jest --watch test-runtime/ --config test-runtime/jest-config.json",
  release: "yarn run prebuild && yarn build && yarn shipit",
  shipit: "auto shipit"
}, aBr = {
  type: "git",
  url: "https://github.com/vega/vega-lite.git"
}, ABr = "BSD-3-Clause", lBr = {
  url: "https://github.com/vega/vega-lite/issues"
}, cBr = {
  "@auto-it/conventional-commits": "^10.34.1",
  "@auto-it/first-time-contributor": "^10.34.1",
  "@babel/core": "^7.17.5",
  "@babel/preset-env": "^7.16.11",
  "@babel/preset-typescript": "^7.16.7",
  "@rollup/plugin-alias": "^3.1.9",
  "@rollup/plugin-babel": "^5.3.1",
  "@rollup/plugin-commonjs": "^22.0.0",
  "@rollup/plugin-json": "^4.1.0",
  "@rollup/plugin-node-resolve": "^13.1.3",
  "@types/chai": "^4.3.0",
  "@types/d3": "^7.1.0",
  "@types/jest": "^27.4.1",
  "@types/mkdirp": "^1.0.2",
  "@types/pako": "^2.0.0",
  "@typescript-eslint/eslint-plugin": "^5.14.0",
  "@typescript-eslint/parser": "^5.14.0",
  ajv: "^8.10.0",
  "ajv-formats": "^2.1.1",
  auto: "^10.34.1",
  chai: "^4.3.6",
  cheerio: "^1.0.0-rc.10",
  "conventional-changelog-cli": "^2.2.2",
  d3: "^7.4.4",
  "del-cli": "^5.0.0",
  eslint: "^8.11.0",
  "eslint-config-prettier": "^8.5.0",
  "eslint-plugin-jest": "^26.1.1",
  "eslint-plugin-prettier": "^4.0.0",
  "gh-pages": "^4.0.0",
  "highlight.js": "^11.5.0",
  jest: "^27.5.1",
  "jest-dev-server": "^6.0.3",
  mkdirp: "^1.0.4",
  pako: "^2.0.4",
  prettier: "^2.5.1",
  puppeteer: "^15.0.0",
  rollup: "^2.70.1",
  "rollup-plugin-bundle-size": "^1.0.3",
  "rollup-plugin-sourcemaps": "^0.6.3",
  "rollup-plugin-terser": "^7.0.2",
  serve: "^14.0.1",
  terser: "^5.12.1",
  "ts-jest": "^27.1.3",
  "ts-json-schema-generator": "^1.0.0",
  "vega-cli": "^5.22.0",
  typescript: "~4.7.2",
  "vega-datasets": "~2.4.0",
  "vega-embed": "^6.20.8",
  "vega-tooltip": "^0.28.0",
  "yaml-front-matter": "^4.1.1"
}, uBr = {
  "@types/clone": "~2.1.1",
  "array-flat-polyfill": "^1.0.1",
  clone: "~2.1.2",
  "fast-deep-equal": "~3.1.3",
  "fast-json-stable-stringify": "~2.1.0",
  "json-stringify-pretty-compact": "~3.0.0",
  tslib: "~2.4.0",
  "vega-event-selector": "~3.0.0",
  "vega-expression": "~5.0.0",
  "vega-util": "~1.17.0",
  yargs: "~17.5.1"
}, fBr = {
  vega: "^5.22.0"
}, gBr = {
  node: ">=12"
}, hBr = {
  name: Yvr,
  author: zvr,
  version: Vvr,
  collaborators: Jvr,
  homepage: Kvr,
  description: Wvr,
  keywords: Xvr,
  main: Zvr,
  unpkg: eBr,
  jsdelivr: tBr,
  module: nBr,
  types: rBr,
  bin: iBr,
  files: oBr,
  scripts: sBr,
  repository: aBr,
  license: ABr,
  bugs: lBr,
  devDependencies: cBr,
  dependencies: uBr,
  peerDependencies: fBr,
  engines: gBr
};
Array.prototype.flat || Object.defineProperty(Array.prototype, "flat", { configurable: !0, value: function t() {
  var e = isNaN(arguments[0]) ? 1 : Number(arguments[0]);
  return e ? Array.prototype.reduce.call(this, function(n, r) {
    return Array.isArray(r) ? n.push.apply(n, t.call(r, e - 1)) : n.push(r), n;
  }, []) : Array.prototype.slice.call(this);
}, writable: !0 }), Array.prototype.flatMap || Object.defineProperty(Array.prototype, "flatMap", { configurable: !0, value: function(t) {
  return Array.prototype.map.apply(this, arguments).flat();
}, writable: !0 });
var Qst = { exports: {} };
(function(t) {
  var e = function() {
    function n(f, h) {
      return h != null && f instanceof h;
    }
    var r;
    try {
      r = Map;
    } catch {
      r = function() {
      };
    }
    var i;
    try {
      i = Set;
    } catch {
      i = function() {
      };
    }
    var o;
    try {
      o = Promise;
    } catch {
      o = function() {
      };
    }
    function s(f, h, d, I, m) {
      typeof h == "object" && (d = h.depth, I = h.prototype, m = h.includeNonEnumerable, h = h.circular);
      var C = [], y = [], v = typeof Buffer < "u";
      typeof h > "u" && (h = !0), typeof d > "u" && (d = 1 / 0);
      function b(Q, w) {
        if (Q === null)
          return null;
        if (w === 0)
          return Q;
        var R, M;
        if (typeof Q != "object")
          return Q;
        if (n(Q, r))
          R = new r();
        else if (n(Q, i))
          R = new i();
        else if (n(Q, o))
          R = new o(function(z, Y) {
            Q.then(function(V) {
              z(b(V, w - 1));
            }, function(V) {
              Y(b(V, w - 1));
            });
          });
        else if (s.__isArray(Q))
          R = [];
        else if (s.__isRegExp(Q))
          R = new RegExp(Q.source, u(Q)), Q.lastIndex && (R.lastIndex = Q.lastIndex);
        else if (s.__isDate(Q))
          R = new Date(Q.getTime());
        else {
          if (v && Buffer.isBuffer(Q))
            return Buffer.allocUnsafe ? R = Buffer.allocUnsafe(Q.length) : R = new Buffer(Q.length), Q.copy(R), R;
          n(Q, Error) ? R = Object.create(Q) : typeof I > "u" ? (M = Object.getPrototypeOf(Q), R = Object.create(M)) : (R = Object.create(I), M = I);
        }
        if (h) {
          var O = C.indexOf(Q);
          if (O != -1)
            return y[O];
          C.push(Q), y.push(R);
        }
        n(Q, r) && Q.forEach(function(z, Y) {
          var V = b(Y, w - 1), Z = b(z, w - 1);
          R.set(V, Z);
        }), n(Q, i) && Q.forEach(function(z) {
          var Y = b(z, w - 1);
          R.add(Y);
        });
        for (var L in Q) {
          var N;
          M && (N = Object.getOwnPropertyDescriptor(M, L)), !(N && N.set == null) && (R[L] = b(Q[L], w - 1));
        }
        if (Object.getOwnPropertySymbols)
          for (var k = Object.getOwnPropertySymbols(Q), L = 0; L < k.length; L++) {
            var $ = k[L], U = Object.getOwnPropertyDescriptor(Q, $);
            U && !U.enumerable && !m || (R[$] = b(Q[$], w - 1), U.enumerable || Object.defineProperty(R, $, {
              enumerable: !1
            }));
          }
        if (m)
          for (var X = Object.getOwnPropertyNames(Q), L = 0; L < X.length; L++) {
            var K = X[L], U = Object.getOwnPropertyDescriptor(Q, K);
            U && U.enumerable || (R[K] = b(Q[K], w - 1), Object.defineProperty(R, K, {
              enumerable: !1
            }));
          }
        return R;
      }
      return b(f, d);
    }
    s.clonePrototype = function(h) {
      if (h === null)
        return null;
      var d = function() {
      };
      return d.prototype = h, new d();
    };
    function a(f) {
      return Object.prototype.toString.call(f);
    }
    s.__objToStr = a;
    function A(f) {
      return typeof f == "object" && a(f) === "[object Date]";
    }
    s.__isDate = A;
    function l(f) {
      return typeof f == "object" && a(f) === "[object Array]";
    }
    s.__isArray = l;
    function c(f) {
      return typeof f == "object" && a(f) === "[object RegExp]";
    }
    s.__isRegExp = c;
    function u(f) {
      var h = "";
      return f.global && (h += "g"), f.ignoreCase && (h += "i"), f.multiline && (h += "m"), h;
    }
    return s.__getRegExpFlags = u, s;
  }();
  t.exports && (t.exports = e);
})(Qst);
var dBr = Qst.exports;
const pBr = /* @__PURE__ */ ko(dBr);
var IBr = function(t, e) {
  e || (e = {}), typeof e == "function" && (e = { cmp: e });
  var n = typeof e.cycles == "boolean" ? e.cycles : !1, r = e.cmp && function(o) {
    return function(s) {
      return function(a, A) {
        var l = { key: a, value: s[a] }, c = { key: A, value: s[A] };
        return o(l, c);
      };
    };
  }(e.cmp), i = [];
  return function o(s) {
    if (s && s.toJSON && typeof s.toJSON == "function" && (s = s.toJSON()), s !== void 0) {
      if (typeof s == "number")
        return isFinite(s) ? "" + s : "null";
      if (typeof s != "object")
        return JSON.stringify(s);
      var a, A;
      if (Array.isArray(s)) {
        for (A = "[", a = 0; a < s.length; a++)
          a && (A += ","), A += o(s[a]) || "null";
        return A + "]";
      }
      if (s === null)
        return "null";
      if (i.indexOf(s) !== -1) {
        if (n)
          return JSON.stringify("__cycle__");
        throw new TypeError("Converting circular structure to JSON");
      }
      var l = i.push(s) - 1, c = Object.keys(s).sort(r && r(s));
      for (A = "", a = 0; a < c.length; a++) {
        var u = c[a], f = o(s[u]);
        f && (A && (A += ","), A += JSON.stringify(u) + ":" + f);
      }
      return i.splice(l, 1), "{" + A + "}";
    }
  }(t);
};
const o0e = /* @__PURE__ */ ko(IBr);
function s0e(t) {
  return !!t.or;
}
function a0e(t) {
  return !!t.and;
}
function A0e(t) {
  return !!t.not;
}
function d4(t, e) {
  if (A0e(t))
    d4(t.not, e);
  else if (a0e(t))
    for (const n of t.and)
      d4(n, e);
  else if (s0e(t))
    for (const n of t.or)
      d4(n, e);
  else
    e(t);
}
function uS(t, e) {
  return A0e(t) ? { not: uS(t.not, e) } : a0e(t) ? { and: t.and.map((n) => uS(n, e)) } : s0e(t) ? { or: t.or.map((n) => uS(n, e)) } : e(t);
}
const Qp = bKe, Kr = pBr;
function wst(t) {
  throw new Error(t);
}
function NQ(t, e) {
  const n = {};
  for (const r of e)
    Kn(t, r) && (n[r] = t[r]);
  return n;
}
function Ff(t, e) {
  const n = Object.assign({}, t);
  for (const r of e)
    delete n[r];
  return n;
}
Set.prototype.toJSON = function() {
  return `Set(${[...this].map((t) => o0e(t)).join(",")})`;
};
const Xo = o0e;
function _i(t) {
  if (Po(t))
    return t;
  const e = Cn(t) ? t : o0e(t);
  if (e.length < 250)
    return e;
  let n = 0;
  for (let r = 0; r < e.length; r++) {
    const i = e.charCodeAt(r);
    n = (n << 5) - n + i, n = n & n;
  }
  return n;
}
function Eoe(t) {
  return t === !1 || t === null;
}
function wi(t, e) {
  return t.includes(e);
}
function xB(t, e) {
  let n = 0;
  for (const [r, i] of t.entries())
    if (e(i, r, n++))
      return !0;
  return !1;
}
function l0e(t, e) {
  let n = 0;
  for (const [r, i] of t.entries())
    if (!e(i, r, n++))
      return !1;
  return !0;
}
function xst(t, ...e) {
  for (const n of e)
    mBr(t, n ?? {});
  return t;
}
function mBr(t, e) {
  for (const n of Kt(e))
    gx(t, n, e[n], !0);
}
function wp(t, e) {
  const n = [], r = {};
  let i;
  for (const o of t)
    i = e(o), !(i in r) && (r[i] = 1, n.push(o));
  return n;
}
function CBr(t, e) {
  const n = Kt(t), r = Kt(e);
  if (n.length !== r.length)
    return !1;
  for (const i of n)
    if (t[i] !== e[i])
      return !1;
  return !0;
}
function Rst(t, e) {
  if (t.size !== e.size)
    return !1;
  for (const n of t)
    if (!e.has(n))
      return !1;
  return !0;
}
function c0e(t, e) {
  for (const n of t)
    if (e.has(n))
      return !0;
  return !1;
}
function yoe(t) {
  const e = /* @__PURE__ */ new Set();
  for (const n of t) {
    const i = g0(n).map((s, a) => a === 0 ? s : `[${s}]`), o = i.map((s, a) => i.slice(0, a + 1).join(""));
    for (const s of o)
      e.add(s);
  }
  return e;
}
function u0e(t, e) {
  return t === void 0 || e === void 0 ? !0 : c0e(yoe(t), yoe(e));
}
function Oo(t) {
  return Kt(t).length === 0;
}
const Kt = Object.keys, rc = Object.values, fE = Object.entries;
function kN(t) {
  return t === !0 || t === !1;
}
function Ls(t) {
  const e = t.replace(/\W/g, "_");
  return (t.match(/^\d+/) ? "_" : "") + e;
}
function WD(t, e) {
  return A0e(t) ? `!(${WD(t.not, e)})` : a0e(t) ? `(${t.and.map((n) => WD(n, e)).join(") && (")})` : s0e(t) ? `(${t.or.map((n) => WD(n, e)).join(") || (")})` : e(t);
}
function D6(t, e) {
  if (e.length === 0)
    return !0;
  const n = e.shift();
  return n in t && D6(t[n], e) && delete t[n], Oo(t);
}
function TO(t) {
  return t.charAt(0).toUpperCase() + t.substr(1);
}
function f0e(t, e = "datum") {
  const n = g0(t), r = [];
  for (let i = 1; i <= n.length; i++) {
    const o = `[${n.slice(0, i).map(an).join("][")}]`;
    r.push(`${e}${o}`);
  }
  return r.join(" && ");
}
function Dst(t, e = "datum") {
  return `${e}[${an(g0(t).join("."))}]`;
}
function EBr(t) {
  return t.replace(/(\[|\]|\.|'|")/g, "\\$1");
}
function Vg(t) {
  return `${g0(t).map(EBr).join("\\.")}`;
}
function RB(t, e, n) {
  return t.replace(new RegExp(e.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "g"), n);
}
function g0e(t) {
  return `${g0(t).join(".")}`;
}
function LQ(t) {
  return t ? g0(t).length : 0;
}
function Va(...t) {
  for (const e of t)
    if (e !== void 0)
      return e;
}
let Tst = 42;
function Nst(t) {
  const e = ++Tst;
  return t ? String(t) + e : e;
}
function yBr() {
  Tst = 42;
}
function Lst(t) {
  return Mst(t) ? t : `__${t}`;
}
function Mst(t) {
  return t.startsWith("__");
}
function GN(t) {
  if (t !== void 0)
    return (t % 360 + 360) % 360;
}
function dY(t) {
  return Po(t) ? !0 : !isNaN(t) && !isNaN(parseFloat(t));
}
var NO = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
const vI = "row", BI = "column", pY = "facet", ta = "x", kA = "y", kd = "x2", C0 = "y2", YE = "xOffset", Qx = "yOffset", Gd = "radius", lm = "radius2", Zg = "theta", cm = "theta2", E0 = "latitude", y0 = "longitude", Ud = "latitude2", Jg = "longitude2", $u = "color", v0 = "fill", B0 = "stroke", qu = "shape", um = "size", R1 = "angle", fm = "opacity", zE = "fillOpacity", VE = "strokeOpacity", JE = "strokeWidth", KE = "strokeDash", LO = "text", MO = "order", OO = "detail", IY = "key", DB = "tooltip", mY = "href", CY = "url", EY = "description", vBr = {
  x: 1,
  y: 1,
  x2: 1,
  y2: 1
}, Ost = {
  theta: 1,
  theta2: 1,
  radius: 1,
  radius2: 1
};
function Fst(t) {
  return t in Ost;
}
const h0e = {
  longitude: 1,
  longitude2: 1,
  latitude: 1,
  latitude2: 1
};
function BBr(t) {
  switch (t) {
    case E0:
      return "y";
    case Ud:
      return "y2";
    case y0:
      return "x";
    case Jg:
      return "x2";
  }
}
function bBr(t) {
  return t in h0e;
}
const _Br = Kt(h0e), d0e = Object.assign(Object.assign(Object.assign(Object.assign({}, vBr), Ost), h0e), {
  xOffset: 1,
  yOffset: 1,
  // color
  color: 1,
  fill: 1,
  stroke: 1,
  // other non-position with scale
  opacity: 1,
  fillOpacity: 1,
  strokeOpacity: 1,
  strokeWidth: 1,
  strokeDash: 1,
  size: 1,
  angle: 1,
  shape: 1,
  // channels without scales
  order: 1,
  text: 1,
  detail: 1,
  key: 1,
  tooltip: 1,
  href: 1,
  url: 1,
  description: 1
});
function fS(t) {
  return t === $u || t === v0 || t === B0;
}
const Pst = {
  row: 1,
  column: 1,
  facet: 1
}, Rg = Kt(Pst), p0e = Object.assign(Object.assign({}, d0e), Pst), SBr = Kt(p0e), QBr = NO(p0e, ["order", "detail", "tooltip"]), wBr = NO(QBr, ["row", "column", "facet"]);
function xBr(t) {
  return !!wBr[t];
}
function kst(t) {
  return !!p0e[t];
}
const RBr = [kd, C0, Ud, Jg, cm, lm];
function Gst(t) {
  return D1(t) !== t;
}
function D1(t) {
  switch (t) {
    case kd:
      return ta;
    case C0:
      return kA;
    case Ud:
      return E0;
    case Jg:
      return y0;
    case cm:
      return Zg;
    case lm:
      return Gd;
  }
  return t;
}
function gE(t) {
  if (Fst(t))
    switch (t) {
      case Zg:
        return "startAngle";
      case cm:
        return "endAngle";
      case Gd:
        return "outerRadius";
      case lm:
        return "innerRadius";
    }
  return t;
}
function gm(t) {
  switch (t) {
    case ta:
      return kd;
    case kA:
      return C0;
    case E0:
      return Ud;
    case y0:
      return Jg;
    case Zg:
      return cm;
    case Gd:
      return lm;
  }
}
function ju(t) {
  switch (t) {
    case ta:
    case kd:
      return "width";
    case kA:
    case C0:
      return "height";
  }
}
function DBr(t) {
  switch (t) {
    case ta:
      return "xOffset";
    case kA:
      return "yOffset";
    case kd:
      return "x2Offset";
    case C0:
      return "y2Offset";
    case Zg:
      return "thetaOffset";
    case Gd:
      return "radiusOffset";
    case cm:
      return "theta2Offset";
    case lm:
      return "radius2Offset";
  }
}
function Ust(t) {
  switch (t) {
    case ta:
      return "xOffset";
    case kA:
      return "yOffset";
  }
}
function Hst(t) {
  switch (t) {
    case "xOffset":
      return "x";
    case "yOffset":
      return "y";
  }
}
const TBr = Kt(d0e), I0e = NO(d0e, ["x", "y", "x2", "y2", "xOffset", "yOffset", "latitude", "longitude", "latitude2", "longitude2", "theta", "theta2", "radius", "radius2"]), NBr = Kt(I0e), m0e = {
  x: 1,
  y: 1
}, b0 = Kt(m0e);
function GA(t) {
  return t in m0e;
}
const C0e = {
  theta: 1,
  radius: 1
}, LBr = Kt(C0e);
function yY(t) {
  return t === "width" ? ta : kA;
}
const $st = { xOffset: 1, yOffset: 1 };
function wx(t) {
  return t in $st;
}
const qst = NO(I0e, ["text", "tooltip", "href", "url", "description", "detail", "key", "order"]), MBr = Kt(qst);
function OBr(t) {
  return !!I0e[t];
}
function FBr(t) {
  switch (t) {
    case $u:
    case v0:
    case B0:
    case um:
    case qu:
    case fm:
    case JE:
    case KE:
      return !0;
    case zE:
    case VE:
    case R1:
      return !1;
  }
}
const jst = Object.assign(Object.assign(Object.assign(Object.assign({}, m0e), C0e), $st), qst), vY = Kt(jst);
function WE(t) {
  return !!jst[t];
}
function PBr(t, e) {
  return GBr(t)[e];
}
const Yst = {
  // all marks
  arc: "always",
  area: "always",
  bar: "always",
  circle: "always",
  geoshape: "always",
  image: "always",
  line: "always",
  rule: "always",
  point: "always",
  rect: "always",
  square: "always",
  trail: "always",
  text: "always",
  tick: "always"
}, kBr = NO(Yst, ["geoshape"]);
function GBr(t) {
  switch (t) {
    case $u:
    case v0:
    case B0:
    case EY:
    case OO:
    case IY:
    case DB:
    case mY:
    case MO:
    case fm:
    case zE:
    case VE:
    case JE:
    case pY:
    case vI:
    case BI:
      return Yst;
    case ta:
    case kA:
    case YE:
    case Qx:
    case E0:
    case y0:
      return kBr;
    case kd:
    case C0:
    case Ud:
    case Jg:
      return {
        area: "always",
        bar: "always",
        image: "always",
        rect: "always",
        rule: "always",
        circle: "binned",
        point: "binned",
        square: "binned",
        tick: "binned",
        line: "binned",
        trail: "binned"
      };
    case um:
      return {
        point: "always",
        tick: "always",
        rule: "always",
        circle: "always",
        square: "always",
        bar: "always",
        text: "always",
        line: "always",
        trail: "always"
      };
    case KE:
      return {
        line: "always",
        point: "always",
        tick: "always",
        rule: "always",
        circle: "always",
        square: "always",
        bar: "always",
        geoshape: "always"
      };
    case qu:
      return { point: "always", geoshape: "always" };
    case LO:
      return { text: "always" };
    case R1:
      return { point: "always", square: "always", text: "always" };
    case CY:
      return { image: "always" };
    case Zg:
      return { text: "always", arc: "always" };
    case Gd:
      return { text: "always", arc: "always" };
    case cm:
    case lm:
      return { arc: "always" };
  }
}
function AX(t) {
  switch (t) {
    case ta:
    case kA:
    case Zg:
    case Gd:
    case YE:
    case Qx:
    case um:
    case R1:
    case JE:
    case fm:
    case zE:
    case VE:
    case kd:
    case C0:
    case cm:
    case lm:
      return;
    case pY:
    case vI:
    case BI:
    case qu:
    case KE:
    case LO:
    case DB:
    case mY:
    case CY:
    case EY:
      return "discrete";
    case $u:
    case v0:
    case B0:
      return "flexible";
    case E0:
    case y0:
    case Ud:
    case Jg:
    case OO:
    case IY:
    case MO:
      return;
  }
}
const UBr = {
  argmax: 1,
  argmin: 1,
  average: 1,
  count: 1,
  distinct: 1,
  product: 1,
  max: 1,
  mean: 1,
  median: 1,
  min: 1,
  missing: 1,
  q1: 1,
  q3: 1,
  ci0: 1,
  ci1: 1,
  stderr: 1,
  stdev: 1,
  stdevp: 1,
  sum: 1,
  valid: 1,
  values: 1,
  variance: 1,
  variancep: 1
}, HBr = {
  count: 1,
  min: 1,
  max: 1
};
function UI(t) {
  return !!t && !!t.argmin;
}
function XE(t) {
  return !!t && !!t.argmax;
}
function E0e(t) {
  return Cn(t) && !!UBr[t];
}
const $Br = /* @__PURE__ */ new Set([
  "count",
  "valid",
  "missing",
  "distinct"
]);
function zst(t) {
  return Cn(t) && $Br.has(t);
}
function qBr(t) {
  return Cn(t) && wi(["min", "max"], t);
}
const jBr = /* @__PURE__ */ new Set([
  "count",
  "sum",
  "distinct",
  "valid",
  "missing"
]), YBr = /* @__PURE__ */ new Set([
  "mean",
  "average",
  "median",
  "q1",
  "q3",
  "min",
  "max"
]);
function Vst(t) {
  return PE(t) && (t = NY(t, void 0)), "bin" + Kt(t).map((e) => BY(t[e]) ? Ls(`_${e}_${fE(t[e])}`) : Ls(`_${e}_${t[e]}`)).join("");
}
function Zo(t) {
  return t === !0 || T1(t) && !t.binned;
}
function Pc(t) {
  return t === "binned" || T1(t) && t.binned === !0;
}
function T1(t) {
  return _n(t);
}
function BY(t) {
  return t?.param;
}
function wFe(t) {
  switch (t) {
    case vI:
    case BI:
    case um:
    case $u:
    case v0:
    case B0:
    case JE:
    case fm:
    case zE:
    case VE:
    case qu:
      return 6;
    case KE:
      return 4;
    default:
      return 10;
  }
}
function FO(t) {
  return !!t?.expr;
}
function Bu(t) {
  const e = Kt(t || {}), n = {};
  for (const r of e)
    n[r] = _f(t[r]);
  return n;
}
var zBr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function Jst(t) {
  const {
    // These are non-mark title config that need to be hardcoded
    anchor: e,
    frame: n,
    offset: r,
    orient: i,
    angle: o,
    limit: s,
    // color needs to be redirect to fill
    color: a,
    // subtitle properties
    subtitleColor: A,
    subtitleFont: l,
    subtitleFontSize: c,
    subtitleFontStyle: u,
    subtitleFontWeight: f,
    subtitleLineHeight: h,
    subtitlePadding: d
  } = t, I = zBr(t, ["anchor", "frame", "offset", "orient", "angle", "limit", "color", "subtitleColor", "subtitleFont", "subtitleFontSize", "subtitleFontStyle", "subtitleFontWeight", "subtitleLineHeight", "subtitlePadding"]), m = Object.assign(Object.assign({}, I), a ? { fill: a } : {}), C = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e ? { anchor: e } : {}), n ? { frame: n } : {}), r ? { offset: r } : {}), i ? { orient: i } : {}), o !== void 0 ? { angle: o } : {}), s !== void 0 ? { limit: s } : {}), y = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, A ? { subtitleColor: A } : {}), l ? { subtitleFont: l } : {}), c ? { subtitleFontSize: c } : {}), u ? { subtitleFontStyle: u } : {}), f ? { subtitleFontWeight: f } : {}), h ? { subtitleLineHeight: h } : {}), d ? { subtitlePadding: d } : {}), v = NQ(t, ["align", "baseline", "dx", "dy", "limit"]);
  return { titleMarkConfig: m, subtitleMarkConfig: v, nonMarkTitleProperties: C, subtitle: y };
}
function Zm(t) {
  return Cn(t) || Nt(t) && Cn(t[0]);
}
function Jn(t) {
  return !!t?.signal;
}
function ZE(t) {
  return !!t.step;
}
function VBr(t) {
  return Nt(t) ? !1 : "fields" in t && !("data" in t);
}
function JBr(t) {
  return Nt(t) ? !1 : "fields" in t && "data" in t;
}
function uI(t) {
  return Nt(t) ? !1 : "field" in t && "data" in t;
}
const KBr = {
  aria: 1,
  description: 1,
  ariaRole: 1,
  ariaRoleDescription: 1,
  blend: 1,
  opacity: 1,
  fill: 1,
  fillOpacity: 1,
  stroke: 1,
  strokeCap: 1,
  strokeWidth: 1,
  strokeOpacity: 1,
  strokeDash: 1,
  strokeDashOffset: 1,
  strokeJoin: 1,
  strokeOffset: 1,
  strokeMiterLimit: 1,
  startAngle: 1,
  endAngle: 1,
  padAngle: 1,
  innerRadius: 1,
  outerRadius: 1,
  size: 1,
  shape: 1,
  interpolate: 1,
  tension: 1,
  orient: 1,
  align: 1,
  baseline: 1,
  text: 1,
  dir: 1,
  dx: 1,
  dy: 1,
  ellipsis: 1,
  limit: 1,
  radius: 1,
  theta: 1,
  angle: 1,
  font: 1,
  fontSize: 1,
  fontWeight: 1,
  fontStyle: 1,
  lineBreak: 1,
  lineHeight: 1,
  cursor: 1,
  href: 1,
  tooltip: 1,
  cornerRadius: 1,
  cornerRadiusTopLeft: 1,
  cornerRadiusTopRight: 1,
  cornerRadiusBottomLeft: 1,
  cornerRadiusBottomRight: 1,
  aspect: 1,
  width: 1,
  height: 1,
  url: 1,
  smooth: 1
  // commented below are vg channel that do not have mark config.
  // x: 1,
  // y: 1,
  // x2: 1,
  // y2: 1,
  // xc'|'yc'
  // clip: 1,
  // path: 1,
  // url: 1,
}, WBr = Kt(KBr), XBr = {
  arc: 1,
  area: 1,
  group: 1,
  image: 1,
  line: 1,
  path: 1,
  rect: 1,
  rule: 1,
  shape: 1,
  symbol: 1,
  text: 1,
  trail: 1
}, voe = [
  "cornerRadius",
  "cornerRadiusTopLeft",
  "cornerRadiusTopRight",
  "cornerRadiusBottomLeft",
  "cornerRadiusBottomRight"
];
var y0e = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function Kst(t) {
  const e = Nt(t.condition) ? t.condition.map(xFe) : xFe(t.condition);
  return Object.assign(Object.assign({}, _f(t)), { condition: e });
}
function _f(t) {
  if (FO(t)) {
    const { expr: e } = t, n = y0e(t, ["expr"]);
    return Object.assign({ signal: e }, n);
  }
  return t;
}
function xFe(t) {
  if (FO(t)) {
    const { expr: e } = t, n = y0e(t, ["expr"]);
    return Object.assign({ signal: e }, n);
  }
  return t;
}
function hs(t) {
  if (FO(t)) {
    const { expr: e } = t, n = y0e(t, ["expr"]);
    return Object.assign({ signal: e }, n);
  }
  return Jn(t) ? t : t !== void 0 ? { value: t } : void 0;
}
function ZBr(t) {
  return Jn(t) ? t.signal : an(t);
}
function RFe(t) {
  return Jn(t) ? t.signal : an(t.value);
}
function bI(t) {
  return Jn(t) ? t.signal : t == null ? null : an(t);
}
function e1r(t, e, n) {
  for (const r of n) {
    const i = TB(r, e.markDef, e.config);
    i !== void 0 && (t[r] = hs(i));
  }
  return t;
}
function Wst(t) {
  var e;
  return [].concat(t.type, (e = t.style) !== null && e !== void 0 ? e : []);
}
function Co(t, e, n, r = {}) {
  const { vgChannel: i, ignoreVgConfig: o } = r;
  return i && e[i] !== void 0 ? e[i] : e[t] !== void 0 ? e[t] : o && (!i || i === t) ? void 0 : TB(t, e, n, r);
}
function TB(t, e, n, { vgChannel: r } = {}) {
  return Va(
    // style config has highest precedence
    r ? T6(t, e, n.style) : void 0,
    T6(t, e, n.style),
    // then mark-specific config
    r ? n[e.type][r] : void 0,
    n[e.type][t],
    // Need to cast because MarkDef doesn't perfectly match with AnyMarkConfig, but if the type isn't available, we'll get nothing here, which is fine
    // If there is vgChannel, skip vl channel.
    // For example, vl size for text is vg fontSize, but config.mark.size is only for point size.
    r ? n.mark[r] : n.mark[t]
    // Need to cast for the same reason as above
  );
}
function T6(t, e, n) {
  return Xst(t, Wst(e), n);
}
function Xst(t, e, n) {
  e = bn(e);
  let r;
  for (const i of e) {
    const o = n[i];
    o && o[t] !== void 0 && (r = o[t]);
  }
  return r;
}
function Zst(t, e) {
  return bn(t).reduce((n, r) => {
    var i;
    return n.field.push(fn(r, e)), n.order.push((i = r.sort) !== null && i !== void 0 ? i : "ascending"), n;
  }, { field: [], order: [] });
}
function eat(t, e) {
  const n = [...t];
  return e.forEach((r) => {
    for (const i of n)
      if (Qp(i, r))
        return;
    n.push(r);
  }), n;
}
function tat(t, e) {
  return Qp(t, e) || !e ? t : t ? [...bn(t), ...bn(e)].join(", ") : e;
}
function nat(t, e) {
  const n = t.value, r = e.value;
  if (n == null || r === null)
    return {
      explicit: t.explicit,
      value: null
    };
  if ((Zm(n) || Jn(n)) && (Zm(r) || Jn(r)))
    return {
      explicit: t.explicit,
      value: tat(n, r)
    };
  if (Zm(n) || Jn(n))
    return {
      explicit: t.explicit,
      value: n
    };
  if (Zm(r) || Jn(r))
    return {
      explicit: t.explicit,
      value: r
    };
  if (!Zm(n) && !Jn(n) && !Zm(r) && !Jn(r))
    return {
      explicit: t.explicit,
      value: eat(n, r)
    };
  throw new Error("It should never reach here");
}
function v0e(t) {
  return `Invalid specification ${Xo(t)}. Make sure the specification includes at least one of the following properties: "mark", "layer", "facet", "hconcat", "vconcat", "concat", or "repeat".`;
}
const t1r = 'Autosize "fit" only works for single views and layered views.';
function DFe(t) {
  return `${t == "width" ? "Width" : "Height"} "container" only works for single views and layered views.`;
}
function TFe(t) {
  const e = t == "width" ? "Width" : "Height", n = t == "width" ? "x" : "y";
  return `${e} "container" only works well with autosize "fit" or "fit-${n}".`;
}
function NFe(t) {
  return t ? `Dropping "fit-${t}" because spec has discrete ${ju(t)}.` : 'Dropping "fit" because spec has discrete size.';
}
function B0e(t) {
  return `Unknown field for ${t}. Cannot calculate view size.`;
}
function LFe(t) {
  return `Cannot project a selection on encoding channel "${t}", which has no field.`;
}
function n1r(t, e) {
  return `Cannot project a selection on encoding channel "${t}" as it uses an aggregate function ("${e}").`;
}
function r1r(t) {
  return `The "nearest" transform is not supported for ${t} marks.`;
}
function rat(t) {
  return `Selection not supported for ${t} yet.`;
}
function i1r(t) {
  return `Cannot find a selection named "${t}".`;
}
const o1r = "Scale bindings are currently only supported for scales with unbinned, continuous domains.", s1r = "Legend bindings are only supported for selections over an individual field or encoding channel.";
function a1r(t) {
  return `Lookups can only be performed on selection parameters. "${t}" is a variable parameter.`;
}
function A1r(t) {
  return `Cannot define and lookup the "${t}" selection in the same view. Try moving the lookup into a second, layered view?`;
}
const l1r = "The same selection must be used to override scale domains in a layered view.", c1r = 'Interval selections should be initialized using "x" and/or "y" keys.';
function u1r(t) {
  return `Unknown repeated value "${t}".`;
}
function MFe(t) {
  return `The "columns" property cannot be used when "${t}" has nested row/column.`;
}
const f1r = "Axes cannot be shared in concatenated or repeated views yet (https://github.com/vega/vega-lite/issues/2415).";
function g1r(t) {
  return `Unrecognized parse "${t}".`;
}
function OFe(t, e, n) {
  return `An ancestor parsed field "${t}" as ${n} but a child wants to parse the field as ${e}.`;
}
const h1r = "Attempt to add the same child twice.";
function d1r(t) {
  return `Ignoring an invalid transform: ${Xo(t)}.`;
}
const p1r = 'If "from.fields" is not specified, "as" has to be a string that specifies the key to be used for the data from the secondary source.';
function FFe(t) {
  return `Config.customFormatTypes is not true, thus custom format type and format for channel ${t} are dropped.`;
}
function I1r(t) {
  const { parentProjection: e, projection: n } = t;
  return `Layer's shared projection ${Xo(e)} is overridden by a child projection ${Xo(n)}.`;
}
const m1r = "Arc marks uses theta channel rather than angle, replacing angle with theta.";
function C1r(t) {
  return `${t}Offset dropped because ${t} is continuous`;
}
function E1r(t) {
  return `There is no ${t} encoding. Replacing ${t}Offset encoding as ${t}.`;
}
function y1r(t, e, n) {
  return `Channel ${t} is a ${e}. Converted to {value: ${Xo(n)}}.`;
}
function iat(t) {
  return `Invalid field type "${t}".`;
}
function v1r(t, e) {
  return `Invalid field type "${t}" for aggregate: "${e}", using "quantitative" instead.`;
}
function B1r(t) {
  return `Invalid aggregation operator "${t}".`;
}
function oat(t, e) {
  const { fill: n, stroke: r } = e;
  return `Dropping color ${t} as the plot also has ${n && r ? "fill and stroke" : n ? "fill" : "stroke"}.`;
}
function b1r(t) {
  return `Position range does not support relative band size for ${t}.`;
}
function Boe(t, e) {
  return `Dropping ${Xo(t)} from channel "${e}" since it does not contain any data field, datum, value, or signal.`;
}
const _1r = "Line marks cannot encode size with a non-groupby field. You may want to use trail marks instead.";
function bY(t, e, n) {
  return `${t} dropped as it is incompatible with "${e}"${n ? ` when ${n}` : ""}.`;
}
function S1r(t) {
  return `${t} encoding has no scale, so specified scale is ignored.`;
}
function Q1r(t) {
  return `${t}-encoding is dropped as ${t} is not a valid encoding channel.`;
}
function w1r(t) {
  return `${t} encoding should be discrete (ordinal / nominal / binned).`;
}
function x1r(t) {
  return `${t} encoding should be discrete (ordinal / nominal / binned) or use a discretizing scale (e.g. threshold).`;
}
function R1r(t) {
  return `Facet encoding dropped as ${t.join(" and ")} ${t.length > 1 ? "are" : "is"} also specified.`;
}
function lX(t, e) {
  return `Using discrete channel "${t}" to encode "${e}" field can be misleading as it does not encode ${e === "ordinal" ? "order" : "magnitude"}.`;
}
function D1r(t) {
  return `The ${t} for range marks cannot be an expression`;
}
function T1r(t, e) {
  return `Line mark is for continuous lines and thus cannot be used with ${t && e ? "x2 and y2" : t ? "x2" : "y2"}. We will use the rule mark (line segments) instead.`;
}
function N1r(t, e) {
  return `Specified orient "${t}" overridden with "${e}".`;
}
function L1r(t) {
  return `Cannot use the scale property "${t}" with non-color channel.`;
}
function M1r(t) {
  return `Cannot use the relative band size with ${t} scale.`;
}
function O1r(t) {
  return `Using unaggregated domain with raw field has no effect (${Xo(t)}).`;
}
function F1r(t) {
  return `Unaggregated domain not applicable for "${t}" since it produces values outside the origin domain of the source data.`;
}
function P1r(t) {
  return `Unaggregated domain is currently unsupported for log scale (${Xo(t)}).`;
}
function k1r(t) {
  return `Cannot apply size to non-oriented mark "${t}".`;
}
function G1r(t, e, n) {
  return `Channel "${t}" does not work with "${e}" scale. We are using "${n}" scale instead.`;
}
function U1r(t, e) {
  return `FieldDef does not work with "${t}" scale. We are using "${e}" scale instead.`;
}
function sat(t, e, n) {
  return `${n}-scale's "${e}" is dropped as it does not work with ${t} scale.`;
}
function aat(t) {
  return `The step for "${t}" is dropped because the ${t === "width" ? "x" : "y"} is continuous.`;
}
function H1r(t, e, n, r) {
  return `Conflicting ${e.toString()} property "${t.toString()}" (${Xo(n)} and ${Xo(r)}). Using ${Xo(n)}.`;
}
function $1r(t, e, n, r) {
  return `Conflicting ${e.toString()} property "${t.toString()}" (${Xo(n)} and ${Xo(r)}). Using the union of the two domains.`;
}
function q1r(t) {
  return `Setting the scale to be independent for "${t}" means we also have to set the guide (axis or legend) to be independent.`;
}
function j1r(t) {
  return `Dropping sort property ${Xo(t)} as unioned domains only support boolean or op "count", "min", and "max".`;
}
const PFe = "Domains that should be unioned has conflicting sort properties. Sort will be set to true.", Y1r = "Detected faceted independent scales that union domain of multiple fields from different data sources. We will use the first field. The result view size may be incorrect.", z1r = "Detected faceted independent scales that union domain of the same fields from different source. We will assume that this is the same field from a different fork of the same data source. However, if this is not the case, the result view size may be incorrect.", V1r = "Detected faceted independent scales that union domain of multiple fields from the same data source. We will use the first field. The result view size may be incorrect.";
function J1r(t) {
  return `Cannot stack "${t}" if there is already "${t}2".`;
}
function K1r(t) {
  return `Cannot stack non-linear scale (${t}).`;
}
function W1r(t) {
  return `Stacking is applied even though the aggregate function is non-summative ("${t}").`;
}
function N6(t, e) {
  return `Invalid ${t}: ${Xo(e)}.`;
}
function X1r(t) {
  return `Dropping day from datetime ${Xo(t)} as day cannot be combined with other units.`;
}
function Z1r(t, e) {
  return `${e ? "extent " : ""}${e && t ? "and " : ""}${t ? "center " : ""}${e && t ? "are " : "is "}not needed when data are aggregated.`;
}
function ebr(t, e, n) {
  return `${t} is not usually used with ${e} for ${n}.`;
}
function tbr(t, e) {
  return `Continuous axis should not have customized aggregation function ${t}; ${e} already agregates the axis.`;
}
function kFe(t) {
  return `1D error band does not support ${t}.`;
}
function Aat(t) {
  return `Channel ${t} is required for "binned" bin.`;
}
function nbr(t) {
  return `Channel ${t} should not be used with "binned" bin.`;
}
function rbr(t) {
  return `Domain for ${t} is required for threshold scale.`;
}
globalThis && globalThis.__classPrivateFieldSet;
globalThis && globalThis.__classPrivateFieldGet;
const lat = age(sge);
let MQ = lat;
function ibr(t) {
  return MQ = t, MQ;
}
function obr() {
  return MQ = lat, MQ;
}
function Zt(...t) {
  MQ.warn(...t);
}
function sbr(...t) {
  MQ.debug(...t);
}
function N1(t) {
  if (t && _n(t)) {
    for (const e of _0e)
      if (e in t)
        return !0;
  }
  return !1;
}
const cat = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december"
], abr = cat.map((t) => t.substr(0, 3)), uat = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"], Abr = uat.map((t) => t.substr(0, 3));
function lbr(t) {
  if (dY(t) && (t = +t), Po(t))
    return t > 4 && Zt(N6("quarter", t)), t - 1;
  throw new Error(N6("quarter", t));
}
function cbr(t) {
  if (dY(t) && (t = +t), Po(t))
    return t - 1;
  {
    const e = t.toLowerCase(), n = cat.indexOf(e);
    if (n !== -1)
      return n;
    const r = e.substr(0, 3), i = abr.indexOf(r);
    if (i !== -1)
      return i;
    throw new Error(N6("month", t));
  }
}
function ubr(t) {
  if (dY(t) && (t = +t), Po(t))
    return t % 7;
  {
    const e = t.toLowerCase(), n = uat.indexOf(e);
    if (n !== -1)
      return n;
    const r = e.substr(0, 3), i = Abr.indexOf(r);
    if (i !== -1)
      return i;
    throw new Error(N6("day", t));
  }
}
function b0e(t, e) {
  const n = [];
  if (e && t.day !== void 0 && Kt(t).length > 1 && (Zt(X1r(t)), t = Kr(t), delete t.day), t.year !== void 0 ? n.push(t.year) : n.push(2012), t.month !== void 0) {
    const r = e ? cbr(t.month) : t.month;
    n.push(r);
  } else if (t.quarter !== void 0) {
    const r = e ? lbr(t.quarter) : t.quarter;
    n.push(Po(r) ? r * 3 : `${r}*3`);
  } else
    n.push(0);
  if (t.date !== void 0)
    n.push(t.date);
  else if (t.day !== void 0) {
    const r = e ? ubr(t.day) : t.day;
    n.push(Po(r) ? r + 1 : `${r}+1`);
  } else
    n.push(1);
  for (const r of ["hours", "minutes", "seconds", "milliseconds"]) {
    const i = t[r];
    n.push(typeof i > "u" ? 0 : i);
  }
  return n;
}
function UN(t) {
  const n = b0e(t, !0).join(", ");
  return t.utc ? `utc(${n})` : `datetime(${n})`;
}
function fbr(t) {
  const n = b0e(t, !1).join(", ");
  return t.utc ? `utc(${n})` : `datetime(${n})`;
}
function gbr(t) {
  const e = b0e(t, !0);
  return t.utc ? +new Date(Date.UTC(...e)) : +new Date(...e);
}
var hbr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
const fat = {
  year: 1,
  quarter: 1,
  month: 1,
  week: 1,
  day: 1,
  dayofyear: 1,
  date: 1,
  hours: 1,
  minutes: 1,
  seconds: 1,
  milliseconds: 1
}, _0e = Kt(fat);
function dbr(t) {
  return !!fat[t];
}
function S0e(t) {
  return t.startsWith("utc");
}
function pbr(t) {
  return t.substr(3);
}
const Ibr = {
  "year-month": "%b %Y ",
  "year-month-date": "%b %d, %Y "
};
function Q0e(t) {
  return _0e.filter((e) => gat(t, e));
}
function gat(t, e) {
  const n = t.indexOf(e);
  return !(n < 0 || n > 0 && e === "seconds" && t.charAt(n - 1) === "i" || t.length > n + 3 && e === "day" && t.charAt(n + 3) === "o" || n > 0 && e === "year" && t.charAt(n - 1) === "f");
}
function mbr(t, e, { end: n } = { end: !1 }) {
  const r = f0e(e), i = S0e(t) ? "utc" : "";
  function o(A) {
    return A === "quarter" ? `(${i}quarter(${r})-1)` : `${i}${A}(${r})`;
  }
  let s;
  const a = {};
  for (const A of _0e)
    gat(t, A) && (a[A] = o(A), s = A);
  return n && (a[s] += "+1"), fbr(a);
}
function hat(t) {
  if (!t)
    return;
  const e = Q0e(t);
  return `timeUnitSpecifier(${Xo(e)}, ${Xo(Ibr)})`;
}
function Cbr(t, e, n) {
  if (!t)
    return;
  const r = hat(t);
  return `${n || S0e(t) ? "utc" : "time"}Format(${e}, ${r})`;
}
function cc(t) {
  if (!t)
    return;
  let e;
  return Cn(t) ? e = {
    unit: t
  } : _n(t) && (e = Object.assign(Object.assign({}, t), t.unit ? { unit: t.unit } : {})), S0e(e.unit) && (e.utc = !0, e.unit = pbr(e.unit)), e;
}
function Ebr(t) {
  const e = cc(t), { utc: n } = e, r = hbr(e, ["utc"]);
  return r.unit ? (n ? "utc" : "") + Kt(r).map((i) => Ls(`${i === "unit" ? "" : `_${i}_`}${r[i]}`)).join("") : (n ? "utc" : "") + "timeunit" + Kt(r).map((i) => Ls(`_${i}_${r[i]}`)).join("");
}
function ybr(t) {
  return t?.param;
}
function w0e(t) {
  return !!t?.field && t.equal !== void 0;
}
function x0e(t) {
  return !!t?.field && t.lt !== void 0;
}
function R0e(t) {
  return !!t?.field && t.lte !== void 0;
}
function D0e(t) {
  return !!t?.field && t.gt !== void 0;
}
function T0e(t) {
  return !!t?.field && t.gte !== void 0;
}
function N0e(t) {
  if (t?.field) {
    if (Nt(t.range) && t.range.length === 2)
      return !0;
    if (Jn(t.range))
      return !0;
  }
  return !1;
}
function L0e(t) {
  return !!t?.field && (Nt(t.oneOf) || Nt(t.in));
}
function vbr(t) {
  return !!t?.field && t.valid !== void 0;
}
function dat(t) {
  return L0e(t) || w0e(t) || N0e(t) || x0e(t) || D0e(t) || R0e(t) || T0e(t);
}
function ap(t, e) {
  return LY(t, { timeUnit: e, wrapTime: !0 });
}
function Bbr(t, e) {
  return t.map((n) => ap(n, e));
}
function pat(t, e = !0) {
  var n;
  const { field: r } = t, i = (n = cc(t.timeUnit)) === null || n === void 0 ? void 0 : n.unit, o = i ? (
    // For timeUnit, cast into integer with time() so we can use ===, inrange, indexOf to compare values directly.
    // TODO: We calculate timeUnit on the fly here. Consider if we would like to consolidate this with timeUnit pipeline
    // TODO: support utc
    `time(${mbr(i, r)})`
  ) : fn(t, { expr: "datum" });
  if (w0e(t))
    return `${o}===${ap(t.equal, i)}`;
  if (x0e(t)) {
    const s = t.lt;
    return `${o}<${ap(s, i)}`;
  } else if (D0e(t)) {
    const s = t.gt;
    return `${o}>${ap(s, i)}`;
  } else if (R0e(t)) {
    const s = t.lte;
    return `${o}<=${ap(s, i)}`;
  } else if (T0e(t)) {
    const s = t.gte;
    return `${o}>=${ap(s, i)}`;
  } else {
    if (L0e(t))
      return `indexof([${Bbr(t.oneOf, i).join(",")}], ${o}) !== -1`;
    if (vbr(t))
      return M0e(o, t.valid);
    if (N0e(t)) {
      const { range: s } = t, a = Jn(s) ? { signal: `${s.signal}[0]` } : s[0], A = Jn(s) ? { signal: `${s.signal}[1]` } : s[1];
      if (a !== null && A !== null && e)
        return "inrange(" + o + ", [" + ap(a, i) + ", " + ap(A, i) + "])";
      const l = [];
      return a !== null && l.push(`${o} >= ${ap(a, i)}`), A !== null && l.push(`${o} <= ${ap(A, i)}`), l.length > 0 ? l.join(" && ") : "true";
    }
  }
  throw new Error(`Invalid field predicate: ${Xo(t)}`);
}
function M0e(t, e = !0) {
  return e ? `isValid(${t}) && isFinite(+${t})` : `!isValid(${t}) || !isFinite(+${t})`;
}
function bbr(t) {
  var e;
  return dat(t) && t.timeUnit ? Object.assign(Object.assign({}, t), { timeUnit: (e = cc(t.timeUnit)) === null || e === void 0 ? void 0 : e.unit }) : t;
}
const PO = {
  quantitative: "quantitative",
  ordinal: "ordinal",
  temporal: "temporal",
  nominal: "nominal",
  geojson: "geojson"
};
function _br(t) {
  return t === "quantitative" || t === "temporal";
}
function Iat(t) {
  return t === "ordinal" || t === "nominal";
}
const NB = PO.quantitative, O0e = PO.ordinal, OQ = PO.temporal, F0e = PO.nominal, xx = PO.geojson;
function Sbr(t) {
  if (t)
    switch (t = t.toLowerCase(), t) {
      case "q":
      case NB:
        return "quantitative";
      case "t":
      case OQ:
        return "temporal";
      case "o":
      case O0e:
        return "ordinal";
      case "n":
      case F0e:
        return "nominal";
      case xx:
        return "geojson";
    }
}
var Qbr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
const Nu = {
  // Continuous - Quantitative
  LINEAR: "linear",
  LOG: "log",
  POW: "pow",
  SQRT: "sqrt",
  SYMLOG: "symlog",
  IDENTITY: "identity",
  SEQUENTIAL: "sequential",
  // Continuous - Time
  TIME: "time",
  UTC: "utc",
  // Discretizing scales
  QUANTILE: "quantile",
  QUANTIZE: "quantize",
  THRESHOLD: "threshold",
  BIN_ORDINAL: "bin-ordinal",
  // Discrete scales
  ORDINAL: "ordinal",
  POINT: "point",
  BAND: "band"
}, boe = {
  linear: "numeric",
  log: "numeric",
  pow: "numeric",
  sqrt: "numeric",
  symlog: "numeric",
  identity: "numeric",
  sequential: "numeric",
  time: "time",
  utc: "time",
  ordinal: "ordinal",
  "bin-ordinal": "bin-ordinal",
  point: "ordinal-position",
  band: "ordinal-position",
  quantile: "discretizing",
  quantize: "discretizing",
  threshold: "discretizing"
};
function wbr(t, e) {
  const n = boe[t], r = boe[e];
  return n === r || n === "ordinal-position" && r === "time" || r === "ordinal-position" && n === "time";
}
const xbr = {
  // numeric
  linear: 0,
  log: 1,
  pow: 1,
  sqrt: 1,
  symlog: 1,
  identity: 1,
  sequential: 1,
  // time
  time: 0,
  utc: 0,
  // ordinal-position -- these have higher precedence than continuous scales as they support more types of data
  point: 10,
  band: 11,
  // non grouped types
  ordinal: 0,
  "bin-ordinal": 0,
  quantile: 0,
  quantize: 0,
  threshold: 0
};
function GFe(t) {
  return xbr[t];
}
const mat = /* @__PURE__ */ new Set([
  "linear",
  "log",
  "pow",
  "sqrt",
  "symlog"
]), Cat = /* @__PURE__ */ new Set([
  ...mat,
  "time",
  "utc"
]);
function Eat(t) {
  return mat.has(t);
}
const yat = /* @__PURE__ */ new Set([
  "quantile",
  "quantize",
  "threshold"
]), Rbr = /* @__PURE__ */ new Set([
  ...Cat,
  ...yat,
  "sequential",
  "identity"
]), Dbr = /* @__PURE__ */ new Set([
  "ordinal",
  "bin-ordinal",
  "point",
  "band"
]);
function UA(t) {
  return Dbr.has(t);
}
function qf(t) {
  return Rbr.has(t);
}
function Xh(t) {
  return Cat.has(t);
}
function FQ(t) {
  return yat.has(t);
}
const Tbr = {
  pointPadding: 0.5,
  barBandPaddingInner: 0.1,
  rectBandPaddingInner: 0,
  bandWithNestedOffsetPaddingInner: 0.2,
  bandWithNestedOffsetPaddingOuter: 0.2,
  minBandSize: 2,
  minFontSize: 8,
  maxFontSize: 40,
  minOpacity: 0.3,
  maxOpacity: 0.8,
  // FIXME: revise if these *can* become ratios of width/height step
  minSize: 9,
  minStrokeWidth: 1,
  maxStrokeWidth: 4,
  quantileCount: 4,
  quantizeCount: 4
};
function Nbr(t) {
  return !Cn(t) && !!t.name;
}
function vat(t) {
  return t?.param;
}
function Lbr(t) {
  return t?.unionWith;
}
function Mbr(t) {
  return _n(t) && "field" in t;
}
const Obr = {
  type: 1,
  domain: 1,
  domainMax: 1,
  domainMin: 1,
  domainMid: 1,
  align: 1,
  range: 1,
  rangeMax: 1,
  rangeMin: 1,
  scheme: 1,
  bins: 1,
  // Other properties
  reverse: 1,
  round: 1,
  // quantitative / time
  clamp: 1,
  nice: 1,
  // quantitative
  base: 1,
  exponent: 1,
  constant: 1,
  interpolate: 1,
  zero: 1,
  // band/point
  padding: 1,
  paddingInner: 1,
  paddingOuter: 1
}, Fbr = Qbr(Obr, ["type", "domain", "range", "rangeMax", "rangeMin", "scheme"]), Pbr = Kt(Fbr);
function _oe(t, e) {
  switch (e) {
    case "type":
    case "domain":
    case "reverse":
    case "range":
      return !0;
    case "scheme":
    case "interpolate":
      return !["point", "band", "identity"].includes(t);
    case "bins":
      return !["point", "band", "identity", "ordinal"].includes(t);
    case "round":
      return Xh(t) || t === "band" || t === "point";
    case "padding":
    case "rangeMin":
    case "rangeMax":
      return Xh(t) || ["point", "band"].includes(t);
    case "paddingOuter":
    case "align":
      return ["point", "band"].includes(t);
    case "paddingInner":
      return t === "band";
    case "domainMax":
    case "domainMid":
    case "domainMin":
    case "clamp":
      return Xh(t);
    case "nice":
      return Xh(t) || t === "quantize" || t === "threshold";
    case "exponent":
      return t === "pow";
    case "base":
      return t === "log";
    case "constant":
      return t === "symlog";
    case "zero":
      return qf(t) && !wi([
        "log",
        "time",
        "utc",
        "threshold",
        "quantile"
        // quantile depends on distribution so zero does not matter
      ], t);
  }
}
function Bat(t, e) {
  switch (e) {
    case "interpolate":
    case "scheme":
    case "domainMid":
      return fS(t) ? void 0 : L1r(e);
    case "align":
    case "type":
    case "bins":
    case "domain":
    case "domainMax":
    case "domainMin":
    case "range":
    case "base":
    case "exponent":
    case "constant":
    case "nice":
    case "padding":
    case "paddingInner":
    case "paddingOuter":
    case "rangeMax":
    case "rangeMin":
    case "reverse":
    case "round":
    case "clamp":
    case "zero":
      return;
  }
}
function kbr(t, e) {
  return wi([O0e, F0e], e) ? t === void 0 || UA(t) : e === OQ ? wi([Nu.TIME, Nu.UTC, void 0], t) : e === NB ? Eat(t) || FQ(t) || t === void 0 : !0;
}
function Gbr(t, e, n = !1) {
  if (!WE(t))
    return !1;
  switch (t) {
    case ta:
    case kA:
    case YE:
    case Qx:
    case Zg:
    case Gd:
      return Xh(e) || e === "band" ? !0 : e === "point" ? !n : !1;
    case um:
    case JE:
    case fm:
    case zE:
    case VE:
    case R1:
      return Xh(e) || FQ(e) || wi(["band", "point", "ordinal"], e);
    case $u:
    case v0:
    case B0:
      return e !== "band";
    case KE:
    case qu:
      return e === "ordinal" || FQ(e);
  }
}
const iu = {
  arc: "arc",
  area: "area",
  bar: "bar",
  image: "image",
  line: "line",
  point: "point",
  rect: "rect",
  rule: "rule",
  text: "text",
  tick: "tick",
  trail: "trail",
  circle: "circle",
  square: "square",
  geoshape: "geoshape"
}, bat = iu.arc, _Y = iu.area, SY = iu.bar, Ubr = iu.image, QY = iu.line, wY = iu.point, Hbr = iu.rect, L6 = iu.rule, _at = iu.text, P0e = iu.tick, $br = iu.trail, k0e = iu.circle, G0e = iu.square, Sat = iu.geoshape;
function ey(t) {
  return ["line", "area", "trail"].includes(t);
}
function Qat(t) {
  return [
    "rect",
    "bar",
    "image",
    "arc"
    /* arc is rect/interval in polar coordinate */
  ].includes(t);
}
const qbr = new Set(Kt(iu));
function Zp(t) {
  return t.type;
}
const jbr = [
  "stroke",
  "strokeWidth",
  "strokeDash",
  "strokeDashOffset",
  "strokeOpacity",
  "strokeJoin",
  "strokeMiterLimit"
], Ybr = ["fill", "fillOpacity"], zbr = [...jbr, ...Ybr], Vbr = {
  color: 1,
  filled: 1,
  invalid: 1,
  order: 1,
  radius2: 1,
  theta2: 1,
  timeUnitBandSize: 1,
  timeUnitBandPosition: 1
}, UFe = Kt(Vbr), Jbr = {
  area: ["line", "point"],
  bar: ["binSpacing", "continuousBandSize", "discreteBandSize"],
  rect: ["binSpacing", "continuousBandSize", "discreteBandSize"],
  line: ["point"],
  tick: ["bandSize", "thickness"]
}, Kbr = {
  color: "#4c78a8",
  invalid: "filter",
  timeUnitBandSize: 1
}, Wbr = {
  mark: 1,
  arc: 1,
  area: 1,
  bar: 1,
  circle: 1,
  image: 1,
  line: 1,
  point: 1,
  rect: 1,
  rule: 1,
  square: 1,
  text: 1,
  tick: 1,
  trail: 1,
  geoshape: 1
}, wat = Kt(Wbr);
function LB(t) {
  return t && t.band != null;
}
const Xbr = {
  horizontal: ["cornerRadiusTopRight", "cornerRadiusBottomRight"],
  vertical: ["cornerRadiusTopLeft", "cornerRadiusTopRight"]
}, xat = 5, Zbr = {
  binSpacing: 1,
  continuousBandSize: xat,
  timeUnitBandPosition: 0.5
}, e_r = {
  binSpacing: 0,
  continuousBandSize: xat,
  timeUnitBandPosition: 0.5
}, t_r = {
  thickness: 1
};
function n_r(t) {
  return Zp(t) ? t.type : t;
}
function U0e(t) {
  const { channel: e, channelDef: n, markDef: r, scale: i, config: o } = t, s = $0e(t);
  return (
    // Only this for field def without counting aggregate (as count wouldn't be null)
    sn(n) && !zst(n.aggregate) && // and only for continuous scale
    i && Xh(i.get("type")) ? r_r({
      fieldDef: n,
      channel: e,
      markDef: r,
      ref: s,
      config: o
    }) : s
  );
}
function r_r({ fieldDef: t, channel: e, markDef: n, ref: r, config: i }) {
  return ey(n.type) ? r : Co("invalid", n, i) === null ? [i_r(t, e), r] : r;
}
function i_r(t, e) {
  const n = H0e(t, !0), i = D1(e) === "y" ? { field: { group: "height" } } : (
    // x / angle / radius can all use 0
    { value: 0 }
  );
  return Object.assign({ test: n }, i);
}
function H0e(t, e = !0) {
  return M0e(Cn(t) ? t : fn(t, { expr: "datum" }), !e);
}
function o_r(t) {
  const { datum: e } = t;
  return N1(e) ? UN(e) : `${Xo(e)}`;
}
function Fv(t, e, n, r) {
  const i = {};
  if (e && (i.scale = e), _0(t)) {
    const { datum: o } = t;
    N1(o) ? i.signal = UN(o) : Jn(o) ? i.signal = o.signal : FO(o) ? i.signal = o.expr : i.value = o;
  } else
    i.field = fn(t, n);
  if (r) {
    const { offset: o, band: s } = r;
    o && (i.offset = o), s && (i.band = s);
  }
  return i;
}
function M6({ scaleName: t, fieldOrDatumDef: e, fieldOrDatumDef2: n, offset: r, startSuffix: i, bandPosition: o = 0.5 }) {
  const s = 0 < o && o < 1 ? "datum" : void 0, a = fn(e, { expr: s, suffix: i }), A = n !== void 0 ? fn(n, { expr: s }) : fn(e, { suffix: "end", expr: s }), l = {};
  if (o === 0 || o === 1) {
    l.scale = t;
    const c = o === 0 ? a : A;
    l.field = c;
  } else {
    const c = Jn(o) ? `${o.signal} * ${a} + (1-${o.signal}) * ${A}` : `${o} * ${a} + ${1 - o} * ${A}`;
    l.signal = `scale("${t}", ${c})`;
  }
  return r && (l.offset = r), l;
}
function $0e({ channel: t, channelDef: e, channel2Def: n, markDef: r, config: i, scaleName: o, scale: s, stack: a, offset: A, defaultRef: l, bandPosition: c }) {
  var u;
  if (e) {
    if ($r(e)) {
      const f = s?.get("type");
      if (Kg(e)) {
        c ?? (c = Fat({
          fieldDef: e,
          fieldDef2: n,
          markDef: r,
          config: i
        }));
        const { bin: h, timeUnit: d, type: I } = e;
        if (Zo(h) || c && d && I === OQ)
          return a?.impute ? Fv(e, o, { binSuffix: "mid" }, { offset: A }) : c && !UA(f) ? M6({ scaleName: o, fieldOrDatumDef: e, bandPosition: c, offset: A }) : Fv(e, o, HO(e, t) ? { binSuffix: "range" } : {}, {
            offset: A
          });
        if (Pc(h)) {
          if (sn(n))
            return M6({
              scaleName: o,
              fieldOrDatumDef: e,
              fieldOrDatumDef2: n,
              bandPosition: c,
              offset: A
            });
          Zt(Aat(t === ta ? kd : C0));
        }
      }
      return Fv(
        e,
        o,
        UA(f) ? { binSuffix: "range" } : {},
        // no need for bin suffix if there is no scale
        {
          offset: A,
          // For band, to get mid point, need to offset by half of the band
          band: f === "band" ? (u = c ?? e.bandPosition) !== null && u !== void 0 ? u : 0.5 : void 0
        }
      );
    } else if (Cd(e)) {
      const f = e.value, h = A ? { offset: A } : {};
      return Object.assign(Object.assign({}, XD(t, f)), h);
    }
  }
  return ri(l) && (l = l()), l && Object.assign(Object.assign({}, l), A ? { offset: A } : {});
}
function XD(t, e) {
  return wi(["x", "x2"], t) && e === "width" ? { field: { group: "width" } } : wi(["y", "y2"], t) && e === "height" ? { field: { group: "height" } } : hs(e);
}
function MB(t) {
  return t && t !== "number" && t !== "time";
}
function Rat(t, e, n) {
  return `${t}(${e}${n ? `, ${Xo(n)}` : ""})`;
}
const s_r = " – ";
function q0e({ fieldOrDatumDef: t, format: e, formatType: n, expr: r, normalizeStack: i, config: o }) {
  var s, a;
  if (MB(n))
    return Zh({
      fieldOrDatumDef: t,
      format: e,
      formatType: n,
      expr: r,
      config: o
    });
  const A = Dat(t, r, i), l = PQ(t);
  if (e === void 0 && n === void 0 && o.customFormatTypes) {
    if (l === "quantitative") {
      if (i && o.normalizedNumberFormatType)
        return Zh({
          fieldOrDatumDef: t,
          format: o.normalizedNumberFormat,
          formatType: o.normalizedNumberFormatType,
          expr: r,
          config: o
        });
      if (o.numberFormatType)
        return Zh({
          fieldOrDatumDef: t,
          format: o.numberFormat,
          formatType: o.numberFormatType,
          expr: r,
          config: o
        });
    }
    if (l === "temporal" && o.timeFormatType && sn(t) && t.timeUnit === void 0)
      return Zh({
        fieldOrDatumDef: t,
        format: o.timeFormat,
        formatType: o.timeFormatType,
        expr: r,
        config: o
      });
  }
  if (GQ(t)) {
    const c = A_r({
      field: A,
      timeUnit: sn(t) ? (s = cc(t.timeUnit)) === null || s === void 0 ? void 0 : s.unit : void 0,
      format: e,
      formatType: o.timeFormatType,
      rawTimeFormat: o.timeFormat,
      isUTCScale: L1(t) && ((a = t.scale) === null || a === void 0 ? void 0 : a.type) === Nu.UTC
    });
    return c ? { signal: c } : void 0;
  }
  if (e = Soe({ type: l, specifiedFormat: e, config: o, normalizeStack: i }), sn(t) && Zo(t.bin)) {
    const c = fn(t, { expr: r, binSuffix: "end" });
    return {
      signal: kO(A, c, e, n, o)
    };
  } else
    return e || PQ(t) === "quantitative" ? {
      signal: `${Lat(A, e)}`
    } : { signal: `isValid(${A}) ? ${A} : ""+${A}` };
}
function Dat(t, e, n) {
  return sn(t) ? n ? `${fn(t, { expr: e, suffix: "end" })}-${fn(t, {
    expr: e,
    suffix: "start"
  })}` : fn(t, { expr: e }) : o_r(t);
}
function Zh({ fieldOrDatumDef: t, format: e, formatType: n, expr: r, normalizeStack: i, config: o, field: s }) {
  if (s ?? (s = Dat(t, r, i)), s !== "datum.value" && // For axis/legend, we can't correctly know the end of the bin from `datum`
  sn(t) && Zo(t.bin)) {
    const a = fn(t, { expr: r, binSuffix: "end" });
    return {
      signal: kO(s, a, e, n, o)
    };
  }
  return { signal: Rat(n, s, e) };
}
function Tat(t, e, n, r, i, o) {
  var s;
  if (!MB(r) && !(n === void 0 && r === void 0 && i.customFormatTypes && PQ(t) === "quantitative" && (i.normalizedNumberFormatType && kQ(t) && t.stack === "normalize" || i.numberFormatType))) {
    if (kQ(t) && t.stack === "normalize" && i.normalizedNumberFormat)
      return Soe({
        type: "quantitative",
        config: i,
        normalizeStack: !0
      });
    if (GQ(t)) {
      const a = sn(t) ? (s = cc(t.timeUnit)) === null || s === void 0 ? void 0 : s.unit : void 0;
      return a === void 0 && i.customFormatTypes && i.timeFormatType ? void 0 : a_r({ specifiedFormat: n, timeUnit: a, config: i, omitTimeFormatConfig: o });
    }
    return Soe({ type: e, specifiedFormat: n, config: i });
  }
}
function Nat(t, e, n) {
  var r;
  if (t && (Jn(t) || t === "number" || t === "time"))
    return t;
  if (GQ(e) && n !== "time" && n !== "utc")
    return sn(e) && (!((r = cc(e?.timeUnit)) === null || r === void 0) && r.utc) ? "utc" : "time";
}
function Soe({ type: t, specifiedFormat: e, config: n, normalizeStack: r }) {
  if (Cn(e))
    return e;
  if (t === NB)
    return r ? n.normalizedNumberFormat : n.numberFormat;
}
function a_r({ specifiedFormat: t, timeUnit: e, config: n, omitTimeFormatConfig: r }) {
  return t || (e ? {
    signal: hat(e)
  } : r ? void 0 : n.timeFormat);
}
function Lat(t, e) {
  return `format(${t}, "${e || ""}")`;
}
function HFe(t, e, n, r) {
  var i;
  return MB(n) ? Rat(n, t, e) : Lat(t, (i = Cn(e) ? e : void 0) !== null && i !== void 0 ? i : r.numberFormat);
}
function kO(t, e, n, r, i) {
  if (n === void 0 && r === void 0 && i.customFormatTypes && i.numberFormatType)
    return kO(t, e, i.numberFormat, i.numberFormatType, i);
  const o = HFe(t, n, r, i), s = HFe(e, n, r, i);
  return `${M0e(t, !1)} ? "null" : ${o} + "${s_r}" + ${s}`;
}
function A_r({ field: t, timeUnit: e, format: n, formatType: r, rawTimeFormat: i, isUTCScale: o }) {
  return !e || n ? !e && r ? `${r}(${t}, '${n}')` : (n = Cn(n) ? n : i, `${o ? "utc" : "time"}Format(${t}, '${n}')`) : Cbr(e, t, o);
}
const xY = "min", l_r = {
  x: 1,
  y: 1,
  color: 1,
  fill: 1,
  stroke: 1,
  strokeWidth: 1,
  size: 1,
  shape: 1,
  fillOpacity: 1,
  strokeOpacity: 1,
  opacity: 1,
  text: 1
};
function $Fe(t) {
  return t in l_r;
}
function Mat(t) {
  return !!t?.encoding;
}
function Pp(t) {
  return t && (t.op === "count" || !!t.field);
}
function Oat(t) {
  return t && Nt(t);
}
function GO(t) {
  return "row" in t || "column" in t;
}
function j0e(t) {
  return !!t && "header" in t;
}
function RY(t) {
  return "facet" in t;
}
var Qoe = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function c_r(t) {
  return t.param;
}
function u_r(t) {
  return t && !Cn(t) && "repeat" in t;
}
function qFe(t) {
  const { field: e, timeUnit: n, bin: r, aggregate: i } = t;
  return Object.assign(Object.assign(Object.assign(Object.assign({}, n ? { timeUnit: n } : {}), r ? { bin: r } : {}), i ? { aggregate: i } : {}), { field: e });
}
function Y0e(t) {
  return "sort" in t;
}
function Fat({ fieldDef: t, fieldDef2: e, markDef: n, config: r }) {
  if ($r(t) && t.bandPosition !== void 0)
    return t.bandPosition;
  if (sn(t)) {
    const { timeUnit: i, bin: o } = t;
    if (i && !e)
      return Qat(n.type) ? 0 : TB("timeUnitBandPosition", n, r);
    if (Zo(o))
      return 0.5;
  }
}
function Pat({ channel: t, fieldDef: e, fieldDef2: n, markDef: r, config: i, scaleType: o, useVlSizeChannel: s }) {
  var a, A, l;
  const c = ju(t), u = Co(s ? "size" : c, r, i, {
    vgChannel: c
  });
  if (u !== void 0)
    return u;
  if (sn(e)) {
    const { timeUnit: f, bin: h } = e;
    if (f && !n)
      return { band: TB("timeUnitBandSize", r, i) };
    if (Zo(h) && !UA(o))
      return { band: 1 };
  }
  if (Qat(r.type))
    return o ? UA(o) ? ((a = i[r.type]) === null || a === void 0 ? void 0 : a.discreteBandSize) || { band: 1 } : (A = i[r.type]) === null || A === void 0 ? void 0 : A.continuousBandSize : (l = i[r.type]) === null || l === void 0 ? void 0 : l.discreteBandSize;
}
function kat(t, e, n, r) {
  return Zo(t.bin) || t.timeUnit && Kg(t) && t.type === "temporal" ? Fat({ fieldDef: t, fieldDef2: e, markDef: n, config: r }) !== void 0 : !1;
}
function DY(t) {
  return t && "condition" in t;
}
function TY(t) {
  const e = t?.condition;
  return !!e && !Nt(e) && sn(e);
}
function UO(t) {
  const e = t?.condition;
  return !!e && !Nt(e) && $r(e);
}
function f_r(t) {
  const e = t?.condition;
  return !!e && (Nt(e) || Cd(e));
}
function sn(t) {
  return t && (!!t.field || t.aggregate === "count");
}
function PQ(t) {
  return t?.type;
}
function _0(t) {
  return t && "datum" in t;
}
function xp(t) {
  return Kg(t) && !O6(t) || woe(t);
}
function woe(t) {
  return _0(t) && Po(t.datum);
}
function $r(t) {
  return sn(t) || _0(t);
}
function Kg(t) {
  return t && ("field" in t || t.aggregate === "count") && "type" in t;
}
function Cd(t) {
  return t && "value" in t && "value" in t;
}
function L1(t) {
  return t && ("scale" in t || "sort" in t);
}
function kQ(t) {
  return t && ("axis" in t || "stack" in t || "impute" in t);
}
function Gat(t) {
  return t && "legend" in t;
}
function Uat(t) {
  return t && ("format" in t || "formatType" in t);
}
function g_r(t) {
  return Ff(t, ["legend", "axis", "header", "scale"]);
}
function h_r(t) {
  return "op" in t;
}
function fn(t, e = {}) {
  var n, r, i;
  let o = t.field;
  const s = e.prefix;
  let a = e.suffix, A = "";
  if (p_r(t))
    o = Lst("count");
  else {
    let l;
    if (!e.nofn)
      if (h_r(t))
        l = t.op;
      else {
        const { bin: c, aggregate: u, timeUnit: f } = t;
        Zo(c) ? (l = Vst(c), a = ((n = e.binSuffix) !== null && n !== void 0 ? n : "") + ((r = e.suffix) !== null && r !== void 0 ? r : "")) : u ? XE(u) ? (A = `["${o}"]`, o = `argmax_${u.argmax}`) : UI(u) ? (A = `["${o}"]`, o = `argmin_${u.argmin}`) : l = String(u) : f && (l = Ebr(f), a = (!["range", "mid"].includes(e.binSuffix) && e.binSuffix || "") + ((i = e.suffix) !== null && i !== void 0 ? i : ""));
      }
    l && (o = o ? `${l}_${o}` : l);
  }
  return a && (o = `${o}_${a}`), s && (o = `${s}_${o}`), e.forAs ? g0e(o) : e.expr ? Dst(o, e.expr) + A : Vg(o) + A;
}
function O6(t) {
  switch (t.type) {
    case "nominal":
    case "ordinal":
    case "geojson":
      return !0;
    case "quantitative":
      return sn(t) && !!t.bin;
    case "temporal":
      return !1;
  }
  throw new Error(iat(t.type));
}
function d_r(t) {
  var e;
  return L1(t) && FQ((e = t.scale) === null || e === void 0 ? void 0 : e.type);
}
function p_r(t) {
  return t.aggregate === "count";
}
function I_r(t, e) {
  var n;
  const { field: r, bin: i, timeUnit: o, aggregate: s } = t;
  if (s === "count")
    return e.countTitle;
  if (Zo(i))
    return `${r} (binned)`;
  if (o) {
    const a = (n = cc(o)) === null || n === void 0 ? void 0 : n.unit;
    if (a)
      return `${r} (${Q0e(a).join("-")})`;
  } else if (s)
    return XE(s) ? `${r} for max ${s.argmax}` : UI(s) ? `${r} for min ${s.argmin}` : `${TO(s)} of ${r}`;
  return r;
}
function m_r(t) {
  const { aggregate: e, bin: n, timeUnit: r, field: i } = t;
  if (XE(e))
    return `${i} for argmax(${e.argmax})`;
  if (UI(e))
    return `${i} for argmin(${e.argmin})`;
  const o = cc(r), s = e || o?.unit || o?.maxbins && "timeunit" || Zo(n) && "bin";
  return s ? `${s.toUpperCase()}(${i})` : i;
}
const Hat = (t, e) => {
  switch (e.fieldTitle) {
    case "plain":
      return t.field;
    case "functional":
      return m_r(t);
    default:
      return I_r(t, e);
  }
};
let $at = Hat;
function qat(t) {
  $at = t;
}
function C_r() {
  qat(Hat);
}
function gS(t, e, { allowDisabling: n, includeDefault: r = !0 }) {
  var i, o;
  const s = (i = z0e(t)) === null || i === void 0 ? void 0 : i.title;
  if (!sn(t))
    return s ?? t.title;
  const a = t, A = r ? V0e(a, e) : void 0;
  return n ? Va(s, a.title, A) : (o = s ?? a.title) !== null && o !== void 0 ? o : A;
}
function z0e(t) {
  if (kQ(t) && t.axis)
    return t.axis;
  if (Gat(t) && t.legend)
    return t.legend;
  if (j0e(t) && t.header)
    return t.header;
}
function V0e(t, e) {
  return $at(t, e);
}
function F6(t) {
  var e;
  if (Uat(t)) {
    const { format: n, formatType: r } = t;
    return { format: n, formatType: r };
  } else {
    const n = (e = z0e(t)) !== null && e !== void 0 ? e : {}, { format: r, formatType: i } = n;
    return { format: r, formatType: i };
  }
}
function E_r(t, e) {
  var n;
  switch (e) {
    case "latitude":
    case "longitude":
      return "quantitative";
    case "row":
    case "column":
    case "facet":
    case "shape":
    case "strokeDash":
      return "nominal";
    case "order":
      return "ordinal";
  }
  if (Y0e(t) && Nt(t.sort))
    return "ordinal";
  const { aggregate: r, bin: i, timeUnit: o } = t;
  if (o)
    return "temporal";
  if (i || r && !XE(r) && !UI(r))
    return "quantitative";
  if (L1(t) && (!((n = t.scale) === null || n === void 0) && n.type))
    switch (boe[t.scale.type]) {
      case "numeric":
      case "discretizing":
        return "quantitative";
      case "time":
        return "temporal";
    }
  return "nominal";
}
function e0(t) {
  if (sn(t))
    return t;
  if (TY(t))
    return t.condition;
}
function gA(t) {
  if ($r(t))
    return t;
  if (UO(t))
    return t.condition;
}
function jat(t, e, n, r = {}) {
  if (Cn(t) || Po(t) || PE(t)) {
    const i = Cn(t) ? "string" : Po(t) ? "number" : "boolean";
    return Zt(y1r(e, i, t)), { value: t };
  }
  return $r(t) ? P6(t, e, n, r) : UO(t) ? Object.assign(Object.assign({}, t), {
    // Need to cast as normalizeFieldDef normally return FieldDef, but here we know that it is definitely Condition<FieldDef>
    condition: P6(t.condition, e, n, r)
  }) : t;
}
function P6(t, e, n, r) {
  if (Uat(t)) {
    const { format: i, formatType: o } = t, s = Qoe(t, ["format", "formatType"]);
    if (MB(o) && !n.customFormatTypes)
      return Zt(FFe(e)), P6(s, e, n, r);
  } else {
    const i = kQ(t) ? "axis" : Gat(t) ? "legend" : j0e(t) ? "header" : null;
    if (i && t[i]) {
      const o = t[i], { format: s, formatType: a } = o, A = Qoe(o, ["format", "formatType"]);
      if (MB(a) && !n.customFormatTypes)
        return Zt(FFe(e)), P6(Object.assign(Object.assign({}, t), { [i]: A }), e, n, r);
    }
  }
  return sn(t) ? J0e(t, e, r) : y_r(t);
}
function y_r(t) {
  let e = t.type;
  if (e)
    return t;
  const { datum: n } = t;
  return e = Po(n) ? "quantitative" : Cn(n) ? "nominal" : N1(n) ? "temporal" : void 0, Object.assign(Object.assign({}, t), { type: e });
}
function J0e(t, e, { compositeMark: n = !1 } = {}) {
  const { aggregate: r, timeUnit: i, bin: o, field: s } = t, a = Object.assign({}, t);
  if (!n && r && !E0e(r) && !XE(r) && !UI(r) && (Zt(B1r(r)), delete a.aggregate), i && (a.timeUnit = cc(i)), s && (a.field = `${s}`), Zo(o) && (a.bin = NY(o, e)), Pc(o) && !GA(e) && Zt(nbr(e)), Kg(a)) {
    const { type: A } = a, l = Sbr(A);
    A !== l && (a.type = l), A !== "quantitative" && zst(r) && (Zt(v1r(A, r)), a.type = "quantitative");
  } else if (!Gst(e)) {
    const A = E_r(a, e);
    a.type = A;
  }
  if (Kg(a)) {
    const { compatible: A, warning: l } = v_r(a, e) || {};
    A === !1 && Zt(l);
  }
  if (Y0e(a) && Cn(a.sort)) {
    const { sort: A } = a;
    if ($Fe(A))
      return Object.assign(Object.assign({}, a), { sort: { encoding: A } });
    const l = A.substr(1);
    if (A.charAt(0) === "-" && $Fe(l))
      return Object.assign(Object.assign({}, a), { sort: { encoding: l, order: "descending" } });
  }
  if (j0e(a)) {
    const { header: A } = a;
    if (A) {
      const { orient: l } = A, c = Qoe(A, ["orient"]);
      if (l)
        return Object.assign(Object.assign({}, a), { header: Object.assign(Object.assign({}, c), { labelOrient: A.labelOrient || l, titleOrient: A.titleOrient || l }) });
    }
  }
  return a;
}
function NY(t, e) {
  return PE(t) ? { maxbins: wFe(e) } : t === "binned" ? {
    binned: !0
  } : !t.maxbins && !t.step ? Object.assign(Object.assign({}, t), { maxbins: wFe(e) }) : t;
}
const Fb = { compatible: !0 };
function v_r(t, e) {
  const n = t.type;
  if (n === "geojson" && e !== "shape")
    return {
      compatible: !1,
      warning: `Channel ${e} should not be used with a geojson data.`
    };
  switch (e) {
    case vI:
    case BI:
    case pY:
      return O6(t) ? Fb : {
        compatible: !1,
        warning: w1r(e)
      };
    case ta:
    case kA:
    case YE:
    case Qx:
    case $u:
    case v0:
    case B0:
    case LO:
    case OO:
    case IY:
    case DB:
    case mY:
    case CY:
    case R1:
    case Zg:
    case Gd:
    case EY:
      return Fb;
    case y0:
    case Jg:
    case E0:
    case Ud:
      return n !== NB ? {
        compatible: !1,
        warning: `Channel ${e} should be used with a quantitative field only, not ${t.type} field.`
      } : Fb;
    case fm:
    case zE:
    case VE:
    case JE:
    case um:
    case cm:
    case lm:
    case kd:
    case C0:
      return n === "nominal" && !t.sort ? {
        compatible: !1,
        warning: `Channel ${e} should not be used with an unsorted discrete field.`
      } : Fb;
    case qu:
    case KE:
      return !O6(t) && !d_r(t) ? {
        compatible: !1,
        warning: x1r(e)
      } : Fb;
    case MO:
      return t.type === "nominal" && !("sort" in t) ? {
        compatible: !1,
        warning: "Channel order is inappropriate for nominal field, which has no inherent order."
      } : Fb;
  }
}
function GQ(t) {
  const { formatType: e } = F6(t);
  return e === "time" || !e && B_r(t);
}
function B_r(t) {
  return t && (t.type === "temporal" || sn(t) && !!t.timeUnit);
}
function LY(t, { timeUnit: e, type: n, wrapTime: r, undefinedIfExprNotRequired: i }) {
  var o;
  const s = e && ((o = cc(e)) === null || o === void 0 ? void 0 : o.unit);
  let a = s || n === "temporal", A;
  return FO(t) ? A = t.expr : Jn(t) ? A = t.signal : N1(t) ? (a = !0, A = UN(t)) : (Cn(t) || Po(t)) && a && (A = `datetime(${Xo(t)})`, dbr(s) && (Po(t) && t < 1e4 || Cn(t) && isNaN(Date.parse(t))) && (A = UN({ [s]: t }))), A ? r && a ? `time(${A})` : A : i ? void 0 : Xo(t);
}
function Yat(t, e) {
  const { type: n } = t;
  return e.map((r) => {
    const i = LY(r, {
      timeUnit: sn(t) ? t.timeUnit : void 0,
      type: n,
      undefinedIfExprNotRequired: !0
    });
    return i !== void 0 ? { signal: i } : r;
  });
}
function HO(t, e) {
  return Zo(t.bin) ? WE(e) && ["ordinal", "nominal"].includes(t.type) : (console.warn("Only call this method for binned field defs."), !1);
}
const jFe = {
  labelAlign: {
    part: "labels",
    vgProp: "align"
  },
  labelBaseline: {
    part: "labels",
    vgProp: "baseline"
  },
  labelColor: {
    part: "labels",
    vgProp: "fill"
  },
  labelFont: {
    part: "labels",
    vgProp: "font"
  },
  labelFontSize: {
    part: "labels",
    vgProp: "fontSize"
  },
  labelFontStyle: {
    part: "labels",
    vgProp: "fontStyle"
  },
  labelFontWeight: {
    part: "labels",
    vgProp: "fontWeight"
  },
  labelOpacity: {
    part: "labels",
    vgProp: "opacity"
  },
  labelOffset: null,
  labelPadding: null,
  gridColor: {
    part: "grid",
    vgProp: "stroke"
  },
  gridDash: {
    part: "grid",
    vgProp: "strokeDash"
  },
  gridDashOffset: {
    part: "grid",
    vgProp: "strokeDashOffset"
  },
  gridOpacity: {
    part: "grid",
    vgProp: "opacity"
  },
  gridWidth: {
    part: "grid",
    vgProp: "strokeWidth"
  },
  tickColor: {
    part: "ticks",
    vgProp: "stroke"
  },
  tickDash: {
    part: "ticks",
    vgProp: "strokeDash"
  },
  tickDashOffset: {
    part: "ticks",
    vgProp: "strokeDashOffset"
  },
  tickOpacity: {
    part: "ticks",
    vgProp: "opacity"
  },
  tickSize: null,
  tickWidth: {
    part: "ticks",
    vgProp: "strokeWidth"
  }
};
function $O(t) {
  return t?.condition;
}
const zat = ["domain", "grid", "labels", "ticks", "title"], b_r = {
  grid: "grid",
  gridCap: "grid",
  gridColor: "grid",
  gridDash: "grid",
  gridDashOffset: "grid",
  gridOpacity: "grid",
  gridScale: "grid",
  gridWidth: "grid",
  orient: "main",
  bandPosition: "both",
  aria: "main",
  description: "main",
  domain: "main",
  domainCap: "main",
  domainColor: "main",
  domainDash: "main",
  domainDashOffset: "main",
  domainOpacity: "main",
  domainWidth: "main",
  format: "main",
  formatType: "main",
  labelAlign: "main",
  labelAngle: "main",
  labelBaseline: "main",
  labelBound: "main",
  labelColor: "main",
  labelFlush: "main",
  labelFlushOffset: "main",
  labelFont: "main",
  labelFontSize: "main",
  labelFontStyle: "main",
  labelFontWeight: "main",
  labelLimit: "main",
  labelLineHeight: "main",
  labelOffset: "main",
  labelOpacity: "main",
  labelOverlap: "main",
  labelPadding: "main",
  labels: "main",
  labelSeparation: "main",
  maxExtent: "main",
  minExtent: "main",
  offset: "both",
  position: "main",
  tickCap: "main",
  tickColor: "main",
  tickDash: "main",
  tickDashOffset: "main",
  tickMinStep: "both",
  tickOffset: "both",
  tickOpacity: "main",
  tickRound: "both",
  ticks: "main",
  tickSize: "main",
  tickWidth: "both",
  title: "main",
  titleAlign: "main",
  titleAnchor: "main",
  titleAngle: "main",
  titleBaseline: "main",
  titleColor: "main",
  titleFont: "main",
  titleFontSize: "main",
  titleFontStyle: "main",
  titleFontWeight: "main",
  titleLimit: "main",
  titleLineHeight: "main",
  titleOpacity: "main",
  titlePadding: "main",
  titleX: "main",
  titleY: "main",
  encode: "both",
  scale: "both",
  tickBand: "both",
  tickCount: "both",
  tickExtra: "both",
  translate: "both",
  values: "both",
  zindex: "both"
  // this is actually set afterward, so it doesn't matter
}, Vat = {
  orient: 1,
  aria: 1,
  bandPosition: 1,
  description: 1,
  domain: 1,
  domainCap: 1,
  domainColor: 1,
  domainDash: 1,
  domainDashOffset: 1,
  domainOpacity: 1,
  domainWidth: 1,
  format: 1,
  formatType: 1,
  grid: 1,
  gridCap: 1,
  gridColor: 1,
  gridDash: 1,
  gridDashOffset: 1,
  gridOpacity: 1,
  gridWidth: 1,
  labelAlign: 1,
  labelAngle: 1,
  labelBaseline: 1,
  labelBound: 1,
  labelColor: 1,
  labelFlush: 1,
  labelFlushOffset: 1,
  labelFont: 1,
  labelFontSize: 1,
  labelFontStyle: 1,
  labelFontWeight: 1,
  labelLimit: 1,
  labelLineHeight: 1,
  labelOffset: 1,
  labelOpacity: 1,
  labelOverlap: 1,
  labelPadding: 1,
  labels: 1,
  labelSeparation: 1,
  maxExtent: 1,
  minExtent: 1,
  offset: 1,
  position: 1,
  tickBand: 1,
  tickCap: 1,
  tickColor: 1,
  tickCount: 1,
  tickDash: 1,
  tickDashOffset: 1,
  tickExtra: 1,
  tickMinStep: 1,
  tickOffset: 1,
  tickOpacity: 1,
  tickRound: 1,
  ticks: 1,
  tickSize: 1,
  tickWidth: 1,
  title: 1,
  titleAlign: 1,
  titleAnchor: 1,
  titleAngle: 1,
  titleBaseline: 1,
  titleColor: 1,
  titleFont: 1,
  titleFontSize: 1,
  titleFontStyle: 1,
  titleFontWeight: 1,
  titleLimit: 1,
  titleLineHeight: 1,
  titleOpacity: 1,
  titlePadding: 1,
  titleX: 1,
  titleY: 1,
  translate: 1,
  values: 1,
  zindex: 1
}, __r = Object.assign(Object.assign({}, Vat), { style: 1, labelExpr: 1, encoding: 1 });
function YFe(t) {
  return !!__r[t];
}
const S_r = {
  axis: 1,
  axisBand: 1,
  axisBottom: 1,
  axisDiscrete: 1,
  axisLeft: 1,
  axisPoint: 1,
  axisQuantitative: 1,
  axisRight: 1,
  axisTemporal: 1,
  axisTop: 1,
  axisX: 1,
  axisXBand: 1,
  axisXDiscrete: 1,
  axisXPoint: 1,
  axisXQuantitative: 1,
  axisXTemporal: 1,
  axisY: 1,
  axisYBand: 1,
  axisYDiscrete: 1,
  axisYPoint: 1,
  axisYQuantitative: 1,
  axisYTemporal: 1
}, Jat = Kt(S_r);
function hm(t) {
  return "mark" in t;
}
class MY {
  constructor(e, n) {
    this.name = e, this.run = n;
  }
  hasMatchingType(e) {
    return hm(e) ? n_r(e.mark) === this.name : !1;
  }
}
var Q_r = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function Pv(t, e) {
  const n = t && t[e];
  return n ? Nt(n) ? xB(n, (r) => !!r.field) : sn(n) || TY(n) : !1;
}
function Kat(t, e) {
  const n = t && t[e];
  return n ? Nt(n) ? xB(n, (r) => !!r.field) : sn(n) || _0(n) || UO(n) : !1;
}
function xoe(t, e) {
  if (GA(e)) {
    const n = t[e];
    if ((sn(n) || _0(n)) && Iat(n.type)) {
      const r = Ust(e);
      return Kat(t, r);
    }
  }
  return !1;
}
function K0e(t) {
  return xB(SBr, (e) => {
    if (Pv(t, e)) {
      const n = t[e];
      if (Nt(n))
        return xB(n, (r) => !!r.aggregate);
      {
        const r = e0(n);
        return r && !!r.aggregate;
      }
    }
    return !1;
  });
}
function Wat(t, e) {
  const n = [], r = [], i = [], o = [], s = {};
  return W0e(t, (a, A) => {
    if (sn(a)) {
      const { field: l, aggregate: c, bin: u, timeUnit: f } = a, h = Q_r(a, ["field", "aggregate", "bin", "timeUnit"]);
      if (c || f || u) {
        const d = z0e(a), I = d?.title;
        let m = fn(a, { forAs: !0 });
        const C = Object.assign(Object.assign(Object.assign({}, I ? [] : { title: gS(a, e, { allowDisabling: !0 }) }), h), {
          // Always overwrite field
          field: m
        });
        if (c) {
          let y;
          if (XE(c) ? (y = "argmax", m = fn({ op: "argmax", field: c.argmax }, { forAs: !0 }), C.field = `${m}.${l}`) : UI(c) ? (y = "argmin", m = fn({ op: "argmin", field: c.argmin }, { forAs: !0 }), C.field = `${m}.${l}`) : c !== "boxplot" && c !== "errorbar" && c !== "errorband" && (y = c), y) {
            const v = {
              op: y,
              as: m
            };
            l && (v.field = l), o.push(v);
          }
        } else if (n.push(m), Kg(a) && Zo(u)) {
          if (r.push({ bin: u, field: l, as: m }), n.push(fn(a, { binSuffix: "end" })), HO(a, A) && n.push(fn(a, { binSuffix: "range" })), GA(A)) {
            const y = {
              field: `${m}_end`
            };
            s[`${A}2`] = y;
          }
          C.bin = "binned", Gst(A) || (C.type = NB);
        } else if (f) {
          i.push({
            timeUnit: f,
            field: l,
            as: m
          });
          const y = Kg(a) && a.type !== OQ && "time";
          y && (A === LO || A === DB ? C.formatType = y : OBr(A) ? C.legend = Object.assign({ formatType: y }, C.legend) : GA(A) && (C.axis = Object.assign({ formatType: y }, C.axis)));
        }
        s[A] = C;
      } else
        n.push(l), s[A] = t[A];
    } else
      s[A] = t[A];
  }), {
    bins: r,
    timeUnits: i,
    aggregate: o,
    groupby: n,
    encoding: s
  };
}
function w_r(t, e, n) {
  const r = PBr(e, n);
  if (r) {
    if (r === "binned") {
      const i = t[e === kd ? ta : kA];
      return !!(sn(i) && sn(t[e]) && Pc(i.bin));
    }
  } else
    return !1;
  return !0;
}
function x_r(t, e, n, r) {
  const i = {};
  for (const o of Kt(t))
    kst(o) || Zt(Q1r(o));
  for (let o of TBr) {
    if (!t[o])
      continue;
    const s = t[o];
    if (wx(o)) {
      const a = Hst(o), A = i[a];
      if (sn(A)) {
        if (_br(A.type) && sn(s)) {
          Zt(C1r(a));
          continue;
        }
      } else
        o = a, Zt(E1r(a));
    }
    if (o === "angle" && e === "arc" && !t.theta && (Zt(m1r), o = Zg), !w_r(t, o, e)) {
      Zt(bY(o, e));
      continue;
    }
    if (o === um && e === "line") {
      const a = e0(t[o]);
      if (a?.aggregate) {
        Zt(_1r);
        continue;
      }
    }
    if (o === $u && (n ? "fill" in t : "stroke" in t)) {
      Zt(oat("encoding", { fill: "fill" in t, stroke: "stroke" in t }));
      continue;
    }
    if (o === OO || o === MO && !Nt(s) && !Cd(s) || o === DB && Nt(s))
      s && (i[o] = bn(s).reduce((a, A) => (sn(A) ? a.push(J0e(A, o)) : Zt(Boe(A, o)), a), []));
    else {
      if (o === DB && s === null)
        i[o] = null;
      else if (!sn(s) && !_0(s) && !Cd(s) && !DY(s) && !Jn(s)) {
        Zt(Boe(s, o));
        continue;
      }
      i[o] = jat(s, o, r);
    }
  }
  return i;
}
function OY(t, e) {
  const n = {};
  for (const r of Kt(t)) {
    const i = jat(t[r], r, e, { compositeMark: !0 });
    n[r] = i;
  }
  return n;
}
function R_r(t) {
  const e = [];
  for (const n of Kt(t))
    if (Pv(t, n)) {
      const r = t[n], i = bn(r);
      for (const o of i)
        sn(o) ? e.push(o) : TY(o) && e.push(o.condition);
    }
  return e;
}
function W0e(t, e, n) {
  if (t)
    for (const r of Kt(t)) {
      const i = t[r];
      if (Nt(i))
        for (const o of i)
          e.call(n, o, r);
      else
        e.call(n, i, r);
    }
}
function D_r(t, e, n, r) {
  return t ? Kt(t).reduce((i, o) => {
    const s = t[o];
    return Nt(s) ? s.reduce((a, A) => e.call(r, a, A, o), i) : e.call(r, i, s, o);
  }, n) : n;
}
function Xat(t, e) {
  return Kt(e).reduce((n, r) => {
    switch (r) {
      case ta:
      case kA:
      case mY:
      case EY:
      case CY:
      case kd:
      case C0:
      case YE:
      case Qx:
      case Zg:
      case cm:
      case Gd:
      case lm:
      case E0:
      case y0:
      case Ud:
      case Jg:
      case LO:
      case qu:
      case R1:
      case DB:
        return n;
      case MO:
        if (t === "line" || t === "trail")
          return n;
      case OO:
      case IY: {
        const i = e[r];
        if (Nt(i) || sn(i))
          for (const o of bn(i))
            o.aggregate || n.push(fn(o, {}));
        return n;
      }
      case um:
        if (t === "trail")
          return n;
      case $u:
      case v0:
      case B0:
      case fm:
      case zE:
      case VE:
      case KE:
      case JE: {
        const i = e0(e[r]);
        return i && !i.aggregate && n.push(fn(i, {})), n;
      }
    }
  }, []);
}
var Zat = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function T_r(t) {
  const { tooltip: e } = t, n = Zat(t, ["tooltip"]);
  if (!e)
    return { filteredEncoding: n };
  let r, i;
  if (Nt(e)) {
    for (const o of e)
      o.aggregate ? (r || (r = []), r.push(o)) : (i || (i = []), i.push(o));
    r && (n.tooltip = r);
  } else
    e.aggregate ? n.tooltip = e : i = e;
  return Nt(i) && i.length === 1 && (i = i[0]), { customTooltipWithoutAggregatedField: i, filteredEncoding: n };
}
function Roe(t, e, n, r = !0) {
  if ("tooltip" in n)
    return { tooltip: n.tooltip };
  const i = t.map(({ fieldPrefix: s, titlePrefix: a }) => {
    const A = r ? ` of ${X0e(e)}` : "";
    return {
      field: s + e.field,
      type: e.type,
      title: Jn(a) ? { signal: `${a}"${escape(A)}"` } : a + A
    };
  }), o = R_r(n).map(g_r);
  return {
    tooltip: [
      ...i,
      // need to cast because TextFieldDef supports fewer types of bin
      ...wp(o, _i)
    ]
  };
}
function X0e(t) {
  const { title: e, field: n } = t;
  return Va(e, n);
}
function Z0e(t, e, n, r, i) {
  const { scale: o, axis: s } = n;
  return ({ partName: a, mark: A, positionPrefix: l, endPositionPrefix: c = void 0, extraEncoding: u = {} }) => {
    const f = X0e(n);
    return eAt(t, a, i, {
      mark: A,
      encoding: Object.assign(Object.assign(Object.assign({ [e]: Object.assign(Object.assign(Object.assign({ field: `${l}_${n.field}`, type: n.type }, f !== void 0 ? { title: f } : {}), o !== void 0 ? { scale: o } : {}), s !== void 0 ? { axis: s } : {}) }, Cn(c) ? {
        [`${e}2`]: {
          field: `${c}_${n.field}`
        }
      } : {}), r), u)
    });
  };
}
function eAt(t, e, n, r) {
  const { clip: i, color: o, opacity: s } = t, a = t.type;
  return t[e] || t[e] === void 0 && n[e] ? [
    Object.assign(Object.assign({}, r), { mark: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, n[e]), i ? { clip: i } : {}), o ? { color: o } : {}), s ? { opacity: s } : {}), Zp(r.mark) ? r.mark : { type: r.mark }), { style: `${a}-${String(e)}` }), PE(t[e]) ? {} : t[e]) })
  ] : [];
}
function tAt(t, e, n) {
  const { encoding: r } = t, i = e === "vertical" ? "y" : "x", o = r[i], s = r[`${i}2`], a = r[`${i}Error`], A = r[`${i}Error2`];
  return {
    continuousAxisChannelDef: U3(o, n),
    continuousAxisChannelDef2: U3(s, n),
    continuousAxisChannelDefError: U3(a, n),
    continuousAxisChannelDefError2: U3(A, n),
    continuousAxis: i
  };
}
function U3(t, e) {
  if (t?.aggregate) {
    const { aggregate: n } = t, r = Zat(t, ["aggregate"]);
    return n !== e && Zt(tbr(n, e)), r;
  } else
    return t;
}
function nAt(t, e) {
  const { mark: n, encoding: r } = t, { x: i, y: o } = r;
  if (Zp(n) && n.orient)
    return n.orient;
  if (xp(i)) {
    if (xp(o)) {
      const s = sn(i) && i.aggregate, a = sn(o) && o.aggregate;
      if (!s && a === e)
        return "vertical";
      if (!a && s === e)
        return "horizontal";
      if (s === e && a === e)
        throw new Error("Both x and y cannot have aggregate");
      return GQ(o) && !GQ(i) ? "horizontal" : "vertical";
    }
    return "horizontal";
  } else {
    if (xp(o))
      return "vertical";
    throw new Error(`Need a valid continuous axis for ${e}s`);
  }
}
var p4 = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
const k6 = "boxplot", N_r = ["box", "median", "outliers", "rule", "ticks"], L_r = new MY(k6, iAt);
function rAt(t) {
  return Po(t) ? "tukey" : t;
}
function iAt(t, { config: e }) {
  var n, r;
  t = Object.assign(Object.assign({}, t), { encoding: OY(t.encoding, e) });
  const { mark: i, encoding: o, params: s, projection: a } = t, A = p4(t, ["mark", "encoding", "params", "projection"]), l = Zp(i) ? i : { type: i };
  s && Zt(rat("boxplot"));
  const c = (n = l.extent) !== null && n !== void 0 ? n : e.boxplot.extent, u = Co(
    "size",
    l,
    // TODO: https://github.com/vega/vega-lite/issues/6245
    e
  ), f = rAt(c), { bins: h, timeUnits: d, transform: I, continuousAxisChannelDef: m, continuousAxis: C, groupby: y, aggregate: v, encodingWithoutContinuousAxis: b, ticksOrient: Q, boxOrient: w, customTooltipWithoutAggregatedField: R } = M_r(t, c, e), { color: M, size: O } = b, L = p4(b, ["color", "size"]), N = (ge) => Z0e(l, C, m, ge, e.boxplot), k = N(L), $ = N(b), U = N(Object.assign(Object.assign({}, L), O ? { size: O } : {})), X = Roe([
    { fieldPrefix: f === "min-max" ? "upper_whisker_" : "max_", titlePrefix: "Max" },
    { fieldPrefix: "upper_box_", titlePrefix: "Q3" },
    { fieldPrefix: "mid_box_", titlePrefix: "Median" },
    { fieldPrefix: "lower_box_", titlePrefix: "Q1" },
    { fieldPrefix: f === "min-max" ? "lower_whisker_" : "min_", titlePrefix: "Min" }
  ], m, b), K = { type: "tick", color: "black", opacity: 1, orient: Q, invalid: null, aria: !1 }, z = f === "min-max" ? X : (
    // for tukey / k-IQR, just show upper/lower-whisker
    Roe([
      { fieldPrefix: "upper_whisker_", titlePrefix: "Upper Whisker" },
      { fieldPrefix: "lower_whisker_", titlePrefix: "Lower Whisker" }
    ], m, b)
  ), Y = [
    ...k({
      partName: "rule",
      mark: { type: "rule", invalid: null, aria: !1 },
      positionPrefix: "lower_whisker",
      endPositionPrefix: "lower_box",
      extraEncoding: z
    }),
    ...k({
      partName: "rule",
      mark: { type: "rule", invalid: null, aria: !1 },
      positionPrefix: "upper_box",
      endPositionPrefix: "upper_whisker",
      extraEncoding: z
    }),
    ...k({
      partName: "ticks",
      mark: K,
      positionPrefix: "lower_whisker",
      extraEncoding: z
    }),
    ...k({
      partName: "ticks",
      mark: K,
      positionPrefix: "upper_whisker",
      extraEncoding: z
    })
  ], V = [
    ...f !== "tukey" ? Y : [],
    ...$({
      partName: "box",
      mark: Object.assign(Object.assign({ type: "bar" }, u ? { size: u } : {}), { orient: w, invalid: null, ariaRoleDescription: "box" }),
      positionPrefix: "lower_box",
      endPositionPrefix: "upper_box",
      extraEncoding: X
    }),
    ...U({
      partName: "median",
      mark: Object.assign(Object.assign(Object.assign({ type: "tick", invalid: null }, _n(e.boxplot.median) && e.boxplot.median.color ? { color: e.boxplot.median.color } : {}), u ? { size: u } : {}), { orient: Q, aria: !1 }),
      positionPrefix: "mid_box",
      extraEncoding: X
    })
  ];
  if (f === "min-max")
    return Object.assign(Object.assign({}, A), { transform: ((r = A.transform) !== null && r !== void 0 ? r : []).concat(I), layer: V });
  const Z = `datum["lower_box_${m.field}"]`, ce = `datum["upper_box_${m.field}"]`, ee = `(${ce} - ${Z})`, pe = `${Z} - ${c} * ${ee}`, Ce = `${ce} + ${c} * ${ee}`, Be = `datum["${m.field}"]`, Ie = {
    joinaggregate: oAt(m.field),
    groupby: y
  }, Qe = {
    transform: [
      {
        filter: `(${pe} <= ${Be}) && (${Be} <= ${Ce})`
      },
      {
        aggregate: [
          {
            op: "min",
            field: m.field,
            as: `lower_whisker_${m.field}`
          },
          {
            op: "max",
            field: m.field,
            as: `upper_whisker_${m.field}`
          },
          // preserve lower_box / upper_box
          {
            op: "min",
            field: `lower_box_${m.field}`,
            as: `lower_box_${m.field}`
          },
          {
            op: "max",
            field: `upper_box_${m.field}`,
            as: `upper_box_${m.field}`
          },
          ...v
        ],
        groupby: y
      }
    ],
    layer: Y
  }, xe = p4(L, ["tooltip"]), { scale: Se, axis: De } = m, Ue = X0e(m), Te = Ff(De, ["title"]), se = eAt(l, "outliers", e.boxplot, {
    transform: [{ filter: `(${Be} < ${pe}) || (${Be} > ${Ce})` }],
    mark: "point",
    encoding: Object.assign(Object.assign(Object.assign({ [C]: Object.assign(Object.assign(Object.assign({ field: m.field, type: m.type }, Ue !== void 0 ? { title: Ue } : {}), Se !== void 0 ? { scale: Se } : {}), Oo(Te) ? {} : { axis: Te }) }, xe), M ? { color: M } : {}), R ? { tooltip: R } : {})
  })[0];
  let fe;
  const W = [...h, ...d, Ie];
  return se ? fe = {
    transform: W,
    layer: [se, Qe]
  } : (fe = Qe, fe.transform.unshift(...W)), Object.assign(Object.assign({}, A), { layer: [
    fe,
    {
      // boxplot
      transform: I,
      layer: V
    }
  ] });
}
function oAt(t) {
  return [
    {
      op: "q1",
      field: t,
      as: `lower_box_${t}`
    },
    {
      op: "q3",
      field: t,
      as: `upper_box_${t}`
    }
  ];
}
function M_r(t, e, n) {
  const r = nAt(t, k6), { continuousAxisChannelDef: i, continuousAxis: o } = tAt(t, r, k6), s = i.field, a = rAt(e), A = [
    ...oAt(s),
    {
      op: "median",
      field: s,
      as: `mid_box_${s}`
    },
    {
      op: "min",
      field: s,
      as: (a === "min-max" ? "lower_whisker_" : "min_") + s
    },
    {
      op: "max",
      field: s,
      as: (a === "min-max" ? "upper_whisker_" : "max_") + s
    }
  ], l = a === "min-max" || a === "tukey" ? [] : [
    // This is for the  original k-IQR, which we do not expose
    {
      calculate: `datum["upper_box_${s}"] - datum["lower_box_${s}"]`,
      as: `iqr_${s}`
    },
    {
      calculate: `min(datum["upper_box_${s}"] + datum["iqr_${s}"] * ${e}, datum["max_${s}"])`,
      as: `upper_whisker_${s}`
    },
    {
      calculate: `max(datum["lower_box_${s}"] - datum["iqr_${s}"] * ${e}, datum["min_${s}"])`,
      as: `lower_whisker_${s}`
    }
  ], c = t.encoding, u = o;
  c[u];
  const f = p4(c, [typeof u == "symbol" ? u : u + ""]), { customTooltipWithoutAggregatedField: h, filteredEncoding: d } = T_r(f), { bins: I, timeUnits: m, aggregate: C, groupby: y, encoding: v } = Wat(d, n), b = r === "vertical" ? "horizontal" : "vertical", Q = r, w = [
    ...I,
    ...m,
    {
      aggregate: [...C, ...A],
      groupby: y
    },
    ...l
  ];
  return {
    bins: I,
    timeUnits: m,
    transform: w,
    groupby: y,
    aggregate: C,
    continuousAxisChannelDef: i,
    continuousAxis: o,
    encodingWithoutContinuousAxis: v,
    ticksOrient: b,
    boxOrient: Q,
    customTooltipWithoutAggregatedField: h
  };
}
var zFe = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
const eIe = "errorbar", O_r = ["ticks", "rule"], F_r = new MY(eIe, sAt);
function sAt(t, { config: e }) {
  t = Object.assign(Object.assign({}, t), { encoding: OY(t.encoding, e) });
  const { transform: n, continuousAxisChannelDef: r, continuousAxis: i, encodingWithoutContinuousAxis: o, ticksOrient: s, markDef: a, outerSpec: A, tooltipEncoding: l } = aAt(t, eIe, e);
  delete o.size;
  const c = Z0e(a, i, r, o, e.errorbar), u = a.thickness, f = a.size, h = Object.assign(Object.assign({ type: "tick", orient: s, aria: !1 }, u !== void 0 ? { thickness: u } : {}), f !== void 0 ? { size: f } : {}), d = [
    ...c({
      partName: "ticks",
      mark: h,
      positionPrefix: "lower",
      extraEncoding: l
    }),
    ...c({
      partName: "ticks",
      mark: h,
      positionPrefix: "upper",
      extraEncoding: l
    }),
    ...c({
      partName: "rule",
      mark: Object.assign({ type: "rule", ariaRoleDescription: "errorbar" }, u !== void 0 ? { size: u } : {}),
      positionPrefix: "lower",
      endPositionPrefix: "upper",
      extraEncoding: l
    })
  ];
  return Object.assign(Object.assign(Object.assign({}, A), { transform: n }), d.length > 1 ? { layer: d } : Object.assign({}, d[0]));
}
function P_r(t, e) {
  const { encoding: n } = t;
  if (k_r(n))
    return {
      orient: nAt(t, e),
      inputType: "raw"
    };
  const r = G_r(n), i = U_r(n), o = n.x, s = n.y;
  if (r) {
    if (i)
      throw new Error(`${e} cannot be both type aggregated-upper-lower and aggregated-error`);
    const a = n.x2, A = n.y2;
    if ($r(a) && $r(A))
      throw new Error(`${e} cannot have both x2 and y2`);
    if ($r(a)) {
      if (xp(o))
        return { orient: "horizontal", inputType: "aggregated-upper-lower" };
      throw new Error(`Both x and x2 have to be quantitative in ${e}`);
    } else if ($r(A)) {
      if (xp(s))
        return { orient: "vertical", inputType: "aggregated-upper-lower" };
      throw new Error(`Both y and y2 have to be quantitative in ${e}`);
    }
    throw new Error("No ranged axis");
  } else {
    const a = n.xError, A = n.xError2, l = n.yError, c = n.yError2;
    if ($r(A) && !$r(a))
      throw new Error(`${e} cannot have xError2 without xError`);
    if ($r(c) && !$r(l))
      throw new Error(`${e} cannot have yError2 without yError`);
    if ($r(a) && $r(l))
      throw new Error(`${e} cannot have both xError and yError with both are quantiative`);
    if ($r(a)) {
      if (xp(o))
        return { orient: "horizontal", inputType: "aggregated-error" };
      throw new Error("All x, xError, and xError2 (if exist) have to be quantitative");
    } else if ($r(l)) {
      if (xp(s))
        return { orient: "vertical", inputType: "aggregated-error" };
      throw new Error("All y, yError, and yError2 (if exist) have to be quantitative");
    }
    throw new Error("No ranged axis");
  }
}
function k_r(t) {
  return ($r(t.x) || $r(t.y)) && !$r(t.x2) && !$r(t.y2) && !$r(t.xError) && !$r(t.xError2) && !$r(t.yError) && !$r(t.yError2);
}
function G_r(t) {
  return $r(t.x2) || $r(t.y2);
}
function U_r(t) {
  return $r(t.xError) || $r(t.xError2) || $r(t.yError) || $r(t.yError2);
}
function aAt(t, e, n) {
  var r;
  const { mark: i, encoding: o, params: s, projection: a } = t, A = zFe(t, ["mark", "encoding", "params", "projection"]), l = Zp(i) ? i : { type: i };
  s && Zt(rat(e));
  const { orient: c, inputType: u } = P_r(t, e), { continuousAxisChannelDef: f, continuousAxisChannelDef2: h, continuousAxisChannelDefError: d, continuousAxisChannelDefError2: I, continuousAxis: m } = tAt(t, c, e), { errorBarSpecificAggregate: C, postAggregateCalculates: y, tooltipSummary: v, tooltipTitleWithFieldName: b } = H_r(l, f, h, d, I, u, e, n), Q = o, w = m;
  Q[w];
  const R = m === "x" ? "x2" : "y2";
  Q[R];
  const M = m === "x" ? "xError" : "yError";
  Q[M];
  const O = m === "x" ? "xError2" : "yError2";
  Q[O];
  const L = zFe(Q, [typeof w == "symbol" ? w : w + "", typeof R == "symbol" ? R : R + "", typeof M == "symbol" ? M : M + "", typeof O == "symbol" ? O : O + ""]), { bins: N, timeUnits: k, aggregate: $, groupby: U, encoding: X } = Wat(L, n), K = [...$, ...C], z = u !== "raw" ? [] : U, Y = Roe(v, f, X, b);
  return {
    transform: [
      ...(r = A.transform) !== null && r !== void 0 ? r : [],
      ...N,
      ...k,
      ...K.length === 0 ? [] : [{ aggregate: K, groupby: z }],
      ...y
    ],
    groupby: z,
    continuousAxisChannelDef: f,
    continuousAxis: m,
    encodingWithoutContinuousAxis: X,
    ticksOrient: c === "vertical" ? "horizontal" : "vertical",
    markDef: l,
    outerSpec: A,
    tooltipEncoding: Y
  };
}
function H_r(t, e, n, r, i, o, s, a) {
  let A = [], l = [];
  const c = e.field;
  let u, f = !1;
  if (o === "raw") {
    const h = t.center ? t.center : t.extent ? t.extent === "iqr" ? "median" : "mean" : a.errorbar.center, d = t.extent ? t.extent : h === "mean" ? "stderr" : "iqr";
    if (h === "median" != (d === "iqr") && Zt(ebr(h, d, s)), d === "stderr" || d === "stdev")
      A = [
        { op: d, field: c, as: `extent_${c}` },
        { op: h, field: c, as: `center_${c}` }
      ], l = [
        {
          calculate: `datum["center_${c}"] + datum["extent_${c}"]`,
          as: `upper_${c}`
        },
        {
          calculate: `datum["center_${c}"] - datum["extent_${c}"]`,
          as: `lower_${c}`
        }
      ], u = [
        { fieldPrefix: "center_", titlePrefix: TO(h) },
        { fieldPrefix: "upper_", titlePrefix: VFe(h, d, "+") },
        { fieldPrefix: "lower_", titlePrefix: VFe(h, d, "-") }
      ], f = !0;
    else {
      let I, m, C;
      d === "ci" ? (I = "mean", m = "ci0", C = "ci1") : (I = "median", m = "q1", C = "q3"), A = [
        { op: m, field: c, as: `lower_${c}` },
        { op: C, field: c, as: `upper_${c}` },
        { op: I, field: c, as: `center_${c}` }
      ], u = [
        {
          fieldPrefix: "upper_",
          titlePrefix: gS({ field: c, aggregate: C, type: "quantitative" }, a, {
            allowDisabling: !1
          })
        },
        {
          fieldPrefix: "lower_",
          titlePrefix: gS({ field: c, aggregate: m, type: "quantitative" }, a, {
            allowDisabling: !1
          })
        },
        {
          fieldPrefix: "center_",
          titlePrefix: gS({ field: c, aggregate: I, type: "quantitative" }, a, {
            allowDisabling: !1
          })
        }
      ];
    }
  } else {
    (t.center || t.extent) && Zt(Z1r(t.center, t.extent)), o === "aggregated-upper-lower" ? (u = [], l = [
      { calculate: `datum["${n.field}"]`, as: `upper_${c}` },
      { calculate: `datum["${c}"]`, as: `lower_${c}` }
    ]) : o === "aggregated-error" && (u = [{ fieldPrefix: "", titlePrefix: c }], l = [
      {
        calculate: `datum["${c}"] + datum["${r.field}"]`,
        as: `upper_${c}`
      }
    ], i ? l.push({
      calculate: `datum["${c}"] + datum["${i.field}"]`,
      as: `lower_${c}`
    }) : l.push({
      calculate: `datum["${c}"] - datum["${r.field}"]`,
      as: `lower_${c}`
    }));
    for (const h of l)
      u.push({
        fieldPrefix: h.as.substring(0, 6),
        titlePrefix: RB(RB(h.calculate, 'datum["', ""), '"]', "")
      });
  }
  return { postAggregateCalculates: l, errorBarSpecificAggregate: A, tooltipSummary: u, tooltipTitleWithFieldName: f };
}
function VFe(t, e, n) {
  return `${TO(t)} ${n} ${e}`;
}
const tIe = "errorband", $_r = ["band", "borders"], q_r = new MY(tIe, AAt);
function AAt(t, { config: e }) {
  t = Object.assign(Object.assign({}, t), { encoding: OY(t.encoding, e) });
  const { transform: n, continuousAxisChannelDef: r, continuousAxis: i, encodingWithoutContinuousAxis: o, markDef: s, outerSpec: a, tooltipEncoding: A } = aAt(t, tIe, e), l = s, c = Z0e(l, i, r, o, e.errorband), u = t.encoding.x !== void 0 && t.encoding.y !== void 0;
  let f = { type: u ? "area" : "rect" }, h = { type: u ? "line" : "rule" };
  const d = Object.assign(Object.assign({}, l.interpolate ? { interpolate: l.interpolate } : {}), l.tension && l.interpolate ? { tension: l.tension } : {});
  return u ? (f = Object.assign(Object.assign(Object.assign({}, f), d), { ariaRoleDescription: "errorband" }), h = Object.assign(Object.assign(Object.assign({}, h), d), { aria: !1 })) : l.interpolate ? Zt(kFe("interpolate")) : l.tension && Zt(kFe("tension")), Object.assign(Object.assign({}, a), { transform: n, layer: [
    ...c({
      partName: "band",
      mark: f,
      positionPrefix: "lower",
      endPositionPrefix: "upper",
      extraEncoding: A
    }),
    ...c({
      partName: "borders",
      mark: h,
      positionPrefix: "lower",
      extraEncoding: A
    }),
    ...c({
      partName: "borders",
      mark: h,
      positionPrefix: "upper",
      extraEncoding: A
    })
  ] });
}
const lAt = {};
function nIe(t, e, n) {
  const r = new MY(t, e);
  lAt[t] = { normalizer: r, parts: n };
}
function j_r() {
  return Kt(lAt);
}
nIe(k6, iAt, N_r);
nIe(eIe, sAt, O_r);
nIe(tIe, AAt, $_r);
const Y_r = [
  "gradientHorizontalMaxLength",
  "gradientHorizontalMinLength",
  "gradientVerticalMaxLength",
  "gradientVerticalMinLength",
  "unselectedOpacity"
], cAt = {
  titleAlign: "align",
  titleAnchor: "anchor",
  titleAngle: "angle",
  titleBaseline: "baseline",
  titleColor: "color",
  titleFont: "font",
  titleFontSize: "fontSize",
  titleFontStyle: "fontStyle",
  titleFontWeight: "fontWeight",
  titleLimit: "limit",
  titleLineHeight: "lineHeight",
  titleOrient: "orient",
  titlePadding: "offset"
}, uAt = {
  labelAlign: "align",
  labelAnchor: "anchor",
  labelAngle: "angle",
  labelBaseline: "baseline",
  labelColor: "color",
  labelFont: "font",
  labelFontSize: "fontSize",
  labelFontStyle: "fontStyle",
  labelFontWeight: "fontWeight",
  labelLimit: "limit",
  labelLineHeight: "lineHeight",
  labelOrient: "orient",
  labelPadding: "offset"
}, z_r = Kt(cAt), V_r = Kt(uAt), J_r = {
  header: 1,
  headerRow: 1,
  headerColumn: 1,
  headerFacet: 1
}, fAt = Kt(J_r), gAt = [
  "size",
  "shape",
  "fill",
  "stroke",
  "strokeDash",
  "strokeWidth",
  "opacity"
], K_r = {
  gradientHorizontalMaxLength: 200,
  gradientHorizontalMinLength: 100,
  gradientVerticalMaxLength: 200,
  gradientVerticalMinLength: 64,
  unselectedOpacity: 0.35
}, W_r = {
  aria: 1,
  clipHeight: 1,
  columnPadding: 1,
  columns: 1,
  cornerRadius: 1,
  description: 1,
  direction: 1,
  fillColor: 1,
  format: 1,
  formatType: 1,
  gradientLength: 1,
  gradientOpacity: 1,
  gradientStrokeColor: 1,
  gradientStrokeWidth: 1,
  gradientThickness: 1,
  gridAlign: 1,
  labelAlign: 1,
  labelBaseline: 1,
  labelColor: 1,
  labelFont: 1,
  labelFontSize: 1,
  labelFontStyle: 1,
  labelFontWeight: 1,
  labelLimit: 1,
  labelOffset: 1,
  labelOpacity: 1,
  labelOverlap: 1,
  labelPadding: 1,
  labelSeparation: 1,
  legendX: 1,
  legendY: 1,
  offset: 1,
  orient: 1,
  padding: 1,
  rowPadding: 1,
  strokeColor: 1,
  symbolDash: 1,
  symbolDashOffset: 1,
  symbolFillColor: 1,
  symbolLimit: 1,
  symbolOffset: 1,
  symbolOpacity: 1,
  symbolSize: 1,
  symbolStrokeColor: 1,
  symbolStrokeWidth: 1,
  symbolType: 1,
  tickCount: 1,
  tickMinStep: 1,
  title: 1,
  titleAlign: 1,
  titleAnchor: 1,
  titleBaseline: 1,
  titleColor: 1,
  titleFont: 1,
  titleFontSize: 1,
  titleFontStyle: 1,
  titleFontWeight: 1,
  titleLimit: 1,
  titleLineHeight: 1,
  titleOpacity: 1,
  titleOrient: 1,
  titlePadding: 1,
  type: 1,
  values: 1,
  zindex: 1
}, t0 = "_vgsid_", X_r = {
  point: {
    on: "click",
    fields: [t0],
    toggle: "event.shiftKey",
    resolve: "global",
    clear: "dblclick"
  },
  interval: {
    on: "[mousedown, window:mouseup] > window:mousemove!",
    encodings: ["x", "y"],
    translate: "[mousedown, window:mouseup] > window:mousemove!",
    zoom: "wheel!",
    mark: { fill: "#333", fillOpacity: 0.125, stroke: "white" },
    resolve: "global",
    clear: "dblclick"
  }
};
function rIe(t) {
  return t === "legend" || !!t?.legend;
}
function cX(t) {
  return rIe(t) && _n(t);
}
function iIe(t) {
  return !!t?.select;
}
var Z_r = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function hAt(t) {
  const e = [];
  for (const n of t || []) {
    if (iIe(n))
      continue;
    const { expr: r, bind: i } = n, o = Z_r(n, ["expr", "bind"]);
    if (i && r) {
      const s = Object.assign(Object.assign({}, o), { bind: i, init: r });
      e.push(s);
    } else {
      const s = Object.assign(Object.assign(Object.assign({}, o), r ? { update: r } : {}), i ? { bind: i } : {});
      e.push(s);
    }
  }
  return e;
}
function eSr(t) {
  return FY(t) || sIe(t) || oIe(t);
}
function oIe(t) {
  return "concat" in t;
}
function FY(t) {
  return "vconcat" in t;
}
function sIe(t) {
  return "hconcat" in t;
}
function dAt({ step: t, offsetIsDiscrete: e }) {
  var n;
  return e ? (n = t.for) !== null && n !== void 0 ? n : "offset" : "position";
}
function n0(t) {
  return _n(t) && t.step !== void 0;
}
function JFe(t) {
  return t.view || t.width || t.height;
}
const KFe = 20, tSr = {
  align: 1,
  bounds: 1,
  center: 1,
  columns: 1,
  spacing: 1
}, nSr = Kt(tSr);
function rSr(t, e, n) {
  var r, i;
  const o = n[e], s = {}, { spacing: a, columns: A } = o;
  a !== void 0 && (s.spacing = a), A !== void 0 && (RY(t) && !GO(t.facet) || oIe(t)) && (s.columns = A), FY(t) && (s.columns = 1);
  for (const l of nSr)
    if (t[l] !== void 0)
      if (l === "spacing") {
        const c = t[l];
        s[l] = Po(c) ? c : {
          row: (r = c.row) !== null && r !== void 0 ? r : a,
          column: (i = c.column) !== null && i !== void 0 ? i : a
        };
      } else
        s[l] = t[l];
  return s;
}
var iSr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function Doe(t, e) {
  var n;
  return (n = t[e]) !== null && n !== void 0 ? n : t[e === "width" ? "continuousWidth" : "continuousHeight"];
}
function G6(t, e) {
  const n = U6(t, e);
  return n0(n) ? n.step : pAt;
}
function U6(t, e) {
  var n;
  const r = (n = t[e]) !== null && n !== void 0 ? n : t[e === "width" ? "discreteWidth" : "discreteHeight"];
  return Va(r, { step: t.step });
}
const pAt = 20, oSr = {
  continuousWidth: 200,
  continuousHeight: 200,
  step: pAt
}, sSr = {
  background: "white",
  padding: 5,
  timeFormat: "%b %d, %Y",
  countTitle: "Count of Records",
  view: oSr,
  mark: Kbr,
  arc: {},
  area: {},
  bar: Zbr,
  circle: {},
  geoshape: {},
  image: {},
  line: {},
  point: {},
  rect: e_r,
  rule: { color: "black" },
  square: {},
  text: { color: "black" },
  tick: t_r,
  trail: {},
  boxplot: {
    size: 14,
    extent: 1.5,
    box: {},
    median: { color: "white" },
    outliers: {},
    rule: {},
    ticks: null
  },
  errorbar: {
    center: "mean",
    rule: !0,
    ticks: !1
  },
  errorband: {
    band: {
      opacity: 0.3
    },
    borders: !1
  },
  scale: Tbr,
  projection: {},
  legend: K_r,
  header: { titlePadding: 10, labelPadding: 10 },
  headerColumn: {},
  headerRow: {},
  headerFacet: {},
  selection: X_r,
  style: {},
  title: {},
  facet: { spacing: KFe },
  concat: { spacing: KFe },
  normalizedNumberFormat: ".0%"
}, U0 = [
  "#4c78a8",
  "#f58518",
  "#e45756",
  "#72b7b2",
  "#54a24b",
  "#eeca3b",
  "#b279a2",
  "#ff9da6",
  "#9d755d",
  "#bab0ac"
], WFe = {
  text: 11,
  guideLabel: 10,
  guideTitle: 11,
  groupTitle: 13,
  groupSubtitle: 12
}, XFe = {
  blue: U0[0],
  orange: U0[1],
  red: U0[2],
  teal: U0[3],
  green: U0[4],
  yellow: U0[5],
  purple: U0[6],
  pink: U0[7],
  brown: U0[8],
  gray0: "#000",
  gray1: "#111",
  gray2: "#222",
  gray3: "#333",
  gray4: "#444",
  gray5: "#555",
  gray6: "#666",
  gray7: "#777",
  gray8: "#888",
  gray9: "#999",
  gray10: "#aaa",
  gray11: "#bbb",
  gray12: "#ccc",
  gray13: "#ddd",
  gray14: "#eee",
  gray15: "#fff"
};
function aSr(t = {}) {
  return {
    signals: [
      {
        name: "color",
        value: _n(t) ? Object.assign(Object.assign({}, XFe), t) : XFe
      }
    ],
    mark: { color: { signal: "color.blue" } },
    rule: { color: { signal: "color.gray0" } },
    text: {
      color: { signal: "color.gray0" }
    },
    style: {
      "guide-label": {
        fill: { signal: "color.gray0" }
      },
      "guide-title": {
        fill: { signal: "color.gray0" }
      },
      "group-title": {
        fill: { signal: "color.gray0" }
      },
      "group-subtitle": {
        fill: { signal: "color.gray0" }
      },
      cell: {
        stroke: { signal: "color.gray8" }
      }
    },
    axis: {
      domainColor: { signal: "color.gray13" },
      gridColor: { signal: "color.gray8" },
      tickColor: { signal: "color.gray13" }
    },
    range: {
      category: [
        { signal: "color.blue" },
        { signal: "color.orange" },
        { signal: "color.red" },
        { signal: "color.teal" },
        { signal: "color.green" },
        { signal: "color.yellow" },
        { signal: "color.purple" },
        { signal: "color.pink" },
        { signal: "color.brown" },
        { signal: "color.grey8" }
      ]
    }
  };
}
function ASr(t) {
  return {
    signals: [
      {
        name: "fontSize",
        value: _n(t) ? Object.assign(Object.assign({}, WFe), t) : WFe
      }
    ],
    text: {
      fontSize: { signal: "fontSize.text" }
    },
    style: {
      "guide-label": {
        fontSize: { signal: "fontSize.guideLabel" }
      },
      "guide-title": {
        fontSize: { signal: "fontSize.guideTitle" }
      },
      "group-title": {
        fontSize: { signal: "fontSize.groupTitle" }
      },
      "group-subtitle": {
        fontSize: { signal: "fontSize.groupSubtitle" }
      }
    }
  };
}
function lSr(t) {
  return {
    text: { font: t },
    style: {
      "guide-label": { font: t },
      "guide-title": { font: t },
      "group-title": { font: t },
      "group-subtitle": { font: t }
    }
  };
}
function IAt(t) {
  const e = Kt(t || {}), n = {};
  for (const r of e) {
    const i = t[r];
    n[r] = $O(i) ? Kst(i) : _f(i);
  }
  return n;
}
function cSr(t) {
  const e = Kt(t), n = {};
  for (const r of e)
    n[r] = IAt(t[r]);
  return n;
}
const uSr = [
  ...wat,
  ...Jat,
  ...fAt,
  "background",
  "padding",
  "legend",
  "lineBreak",
  "scale",
  "style",
  "title",
  "view"
];
function mAt(t = {}) {
  const { color: e, font: n, fontSize: r, selection: i } = t, o = iSr(t, ["color", "font", "fontSize", "selection"]), s = fx({}, Kr(sSr), n ? lSr(n) : {}, e ? aSr(e) : {}, r ? ASr(r) : {}, o || {});
  i && gx(s, "selection", i, !0);
  const a = Ff(s, uSr);
  for (const A of ["background", "lineBreak", "padding"])
    s[A] && (a[A] = _f(s[A]));
  for (const A of wat)
    s[A] && (a[A] = Bu(s[A]));
  for (const A of Jat)
    s[A] && (a[A] = IAt(s[A]));
  for (const A of fAt)
    s[A] && (a[A] = Bu(s[A]));
  return s.legend && (a.legend = Bu(s.legend)), s.scale && (a.scale = Bu(s.scale)), s.style && (a.style = cSr(s.style)), s.title && (a.title = Bu(s.title)), s.view && (a.view = Bu(s.view)), a;
}
const fSr = /* @__PURE__ */ new Set(["view", ...qbr]), gSr = [
  "color",
  "fontSize",
  "background",
  "padding",
  "facet",
  "concat",
  "numberFormat",
  "numberFormatType",
  "normalizedNumberFormat",
  "normalizedNumberFormatType",
  "timeFormat",
  "countTitle",
  "header",
  "axisQuantitative",
  "axisTemporal",
  "axisDiscrete",
  "axisPoint",
  "axisXBand",
  "axisXPoint",
  "axisXDiscrete",
  "axisXQuantitative",
  "axisXTemporal",
  "axisYBand",
  "axisYPoint",
  "axisYDiscrete",
  "axisYQuantitative",
  "axisYTemporal",
  "scale",
  "selection",
  "overlay"
  // FIXME: Redesign and unhide this
], hSr = Object.assign({ view: ["continuousWidth", "continuousHeight", "discreteWidth", "discreteHeight", "step"] }, Jbr);
function dSr(t) {
  t = Kr(t);
  for (const e of gSr)
    delete t[e];
  if (t.axis)
    for (const e in t.axis)
      $O(t.axis[e]) && delete t.axis[e];
  if (t.legend)
    for (const e of Y_r)
      delete t.legend[e];
  if (t.mark) {
    for (const e of UFe)
      delete t.mark[e];
    t.mark.tooltip && _n(t.mark.tooltip) && delete t.mark.tooltip;
  }
  t.params && (t.signals = (t.signals || []).concat(hAt(t.params)), delete t.params);
  for (const e of fSr) {
    for (const r of UFe)
      delete t[e][r];
    const n = hSr[e];
    if (n)
      for (const r of n)
        delete t[e][r];
    ISr(t, e);
  }
  for (const e of j_r())
    delete t[e];
  pSr(t);
  for (const e in t)
    _n(t[e]) && Oo(t[e]) && delete t[e];
  return Oo(t) ? void 0 : t;
}
function pSr(t) {
  const { titleMarkConfig: e, subtitleMarkConfig: n, subtitle: r } = Jst(t.title);
  Oo(e) || (t.style["group-title"] = Object.assign(
    Object.assign({}, t.style["group-title"]),
    e
    // config.title has higher precedence than config.style.group-title in Vega
  )), Oo(n) || (t.style["group-subtitle"] = Object.assign(Object.assign({}, t.style["group-subtitle"]), n)), Oo(r) ? delete t.title : t.title = r;
}
function ISr(t, e, n, r) {
  const i = r ? t[e][r] : t[e];
  e === "view" && (n = "cell");
  const o = Object.assign(Object.assign({}, i), t.style[n ?? e]);
  Oo(o) || (t.style[n ?? e] = o), r || delete t[e];
}
function PY(t) {
  return "layer" in t;
}
function mSr(t) {
  return "repeat" in t;
}
function CSr(t) {
  return !Nt(t.repeat) && t.repeat.layer;
}
var ESr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
class aIe {
  map(e, n) {
    return RY(e) ? this.mapFacet(e, n) : mSr(e) ? this.mapRepeat(e, n) : sIe(e) ? this.mapHConcat(e, n) : FY(e) ? this.mapVConcat(e, n) : oIe(e) ? this.mapConcat(e, n) : this.mapLayerOrUnit(e, n);
  }
  mapLayerOrUnit(e, n) {
    if (PY(e))
      return this.mapLayer(e, n);
    if (hm(e))
      return this.mapUnit(e, n);
    throw new Error(v0e(e));
  }
  mapLayer(e, n) {
    return Object.assign(Object.assign({}, e), { layer: e.layer.map((r) => this.mapLayerOrUnit(r, n)) });
  }
  mapHConcat(e, n) {
    return Object.assign(Object.assign({}, e), { hconcat: e.hconcat.map((r) => this.map(r, n)) });
  }
  mapVConcat(e, n) {
    return Object.assign(Object.assign({}, e), { vconcat: e.vconcat.map((r) => this.map(r, n)) });
  }
  mapConcat(e, n) {
    const { concat: r } = e, i = ESr(e, ["concat"]);
    return Object.assign(Object.assign({}, i), { concat: r.map((o) => this.map(o, n)) });
  }
  mapFacet(e, n) {
    return Object.assign(Object.assign({}, e), {
      // TODO: remove "any" once we support all facet listed in https://github.com/vega/vega-lite/issues/2760
      spec: this.map(e.spec, n)
    });
  }
  mapRepeat(e, n) {
    return Object.assign(Object.assign({}, e), {
      // as any is required here since TS cannot infer that the output type satisfies the input type
      spec: this.map(e.spec, n)
    });
  }
}
const ySr = {
  zero: 1,
  center: 1,
  normalize: 1
};
function vSr(t) {
  return t in ySr;
}
const BSr = /* @__PURE__ */ new Set([bat, SY, _Y, L6, wY, k0e, G0e, QY, _at, P0e]), bSr = /* @__PURE__ */ new Set([SY, _Y, bat]);
function Pb(t) {
  return sn(t) && PQ(t) === "quantitative" && !t.bin;
}
function ZFe(t, e) {
  var n, r;
  const i = e === "x" ? "y" : "radius", o = t[e], s = t[i];
  if (sn(o) && sn(s))
    if (Pb(o) && Pb(s)) {
      if (o.stack)
        return e;
      if (s.stack)
        return i;
      const a = sn(o) && !!o.aggregate, A = sn(s) && !!s.aggregate;
      if (a !== A)
        return a ? e : i;
      {
        const l = (n = o.scale) === null || n === void 0 ? void 0 : n.type, c = (r = s.scale) === null || r === void 0 ? void 0 : r.type;
        if (l && l !== "linear")
          return i;
        if (c && c !== "linear")
          return e;
      }
    } else {
      if (Pb(o))
        return e;
      if (Pb(s))
        return i;
    }
  else {
    if (Pb(o))
      return e;
    if (Pb(s))
      return i;
  }
}
function _Sr(t) {
  switch (t) {
    case "x":
      return "y";
    case "y":
      return "x";
    case "theta":
      return "radius";
    case "radius":
      return "theta";
  }
}
function CAt(t, e) {
  var n, r;
  const i = Zp(t) ? t.type : t;
  if (!BSr.has(i))
    return null;
  const o = ZFe(e, "x") || ZFe(e, "theta");
  if (!o)
    return null;
  const s = e[o], a = sn(s) ? fn(s, {}) : void 0, A = _Sr(o), l = [], c = /* @__PURE__ */ new Set();
  if (e[A]) {
    const h = e[A], d = sn(h) ? fn(h, {}) : void 0;
    d && d !== a && (l.push(A), c.add(d));
    const I = A === "x" ? "xOffset" : "yOffset", m = e[I], C = sn(m) ? fn(m, {}) : void 0;
    C && C !== a && (l.push(I), c.add(C));
  }
  const u = NBr.reduce((h, d) => {
    if (d !== "tooltip" && Pv(e, d)) {
      const I = e[d];
      for (const m of bn(I)) {
        const C = e0(m);
        if (C.aggregate)
          continue;
        const y = fn(C, {});
        // if fielddef is a repeat, just include it in the stack by
        (!y || // otherwise, the field must be different from the groupBy fields.
        !c.has(y)) && h.push({ channel: d, fieldDef: C });
      }
    }
    return h;
  }, []);
  let f;
  return s.stack !== void 0 ? PE(s.stack) ? f = s.stack ? "zero" : null : f = s.stack : bSr.has(i) && (f = "zero"), !f || !vSr(f) || K0e(e) && u.length === 0 ? null : !((n = s?.scale) === null || n === void 0) && n.type && ((r = s?.scale) === null || r === void 0 ? void 0 : r.type) !== Nu.LINEAR ? (Zt(K1r(s.scale.type)), null) : $r(e[gm(o)]) ? (s.stack !== void 0 && Zt(J1r(o)), null) : (sn(s) && s.aggregate && !jBr.has(s.aggregate) && Zt(W1r(s.aggregate)), {
    groupbyChannels: l,
    groupbyFields: c,
    fieldChannel: o,
    impute: s.impute === null ? !1 : ey(i),
    stackBy: u,
    offset: f
  });
}
var EAt = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function SSr(t) {
  const e = EAt(t, ["point", "line"]);
  return Kt(e).length > 1 ? e : e.type;
}
function QSr(t) {
  for (const e of ["line", "area", "rule", "trail"])
    t[e] && (t = Object.assign(Object.assign({}, t), {
      // TODO: remove as any
      [e]: Ff(t[e], ["point", "line"])
    }));
  return t;
}
function uX(t, e = {}, n) {
  return t.point === "transparent" ? { opacity: 0 } : t.point ? _n(t.point) ? t.point : {} : t.point !== void 0 ? null : e.point || n.shape ? _n(e.point) ? e.point : {} : void 0;
}
function ePe(t, e = {}) {
  return t.line ? t.line === !0 ? {} : t.line : t.line !== void 0 ? null : e.line ? e.line === !0 ? {} : e.line : void 0;
}
class wSr {
  constructor() {
    this.name = "path-overlay";
  }
  hasMatchingType(e, n) {
    if (hm(e)) {
      const { mark: r, encoding: i } = e, o = Zp(r) ? r : { type: r };
      switch (o.type) {
        case "line":
        case "rule":
        case "trail":
          return !!uX(o, n[o.type], i);
        case "area":
          return (
            // false / null are also included as we want to remove the properties
            !!uX(o, n[o.type], i) || !!ePe(o, n[o.type])
          );
      }
    }
    return !1;
  }
  run(e, n, r) {
    const { config: i } = n, { params: o, projection: s, mark: a, encoding: A } = e, l = EAt(e, ["params", "projection", "mark", "encoding"]), c = OY(A, i), u = Zp(a) ? a : { type: a }, f = uX(u, i[u.type], c), h = u.type === "area" && ePe(u, i[u.type]), d = [
      Object.assign(Object.assign({}, o ? { params: o } : {}), {
        mark: SSr(Object.assign(Object.assign({}, u.type === "area" && u.opacity === void 0 && u.fillOpacity === void 0 ? { opacity: 0.7 } : {}), u)),
        // drop shape from encoding as this might be used to trigger point overlay
        encoding: Ff(c, ["shape"])
      })
    ], I = CAt(u, c);
    let m = c;
    if (I) {
      const { fieldChannel: C, offset: y } = I;
      m = Object.assign(Object.assign({}, c), { [C]: Object.assign(Object.assign({}, c[C]), y ? { stack: y } : {}) });
    }
    return h && d.push(Object.assign(Object.assign({}, s ? { projection: s } : {}), { mark: Object.assign(Object.assign({ type: "line" }, NQ(u, ["clip", "interpolate", "tension", "tooltip"])), h), encoding: m })), f && d.push(Object.assign(Object.assign({}, s ? { projection: s } : {}), { mark: Object.assign(Object.assign({ type: "point", opacity: 1, filled: !0 }, NQ(u, ["clip", "tooltip"])), f), encoding: m })), r(Object.assign(Object.assign({}, l), { layer: d }), Object.assign(Object.assign({}, n), { config: QSr(i) }));
  }
}
var xSr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function RSr(t, e) {
  return e ? GO(t) ? vAt(t, e) : yAt(t, e) : t;
}
function fX(t, e) {
  return e ? vAt(t, e) : t;
}
function Toe(t, e, n) {
  const r = e[t];
  if (u_r(r)) {
    if (r.repeat in n)
      return Object.assign(Object.assign({}, e), { [t]: n[r.repeat] });
    Zt(u1r(r.repeat));
    return;
  }
  return e;
}
function yAt(t, e) {
  if (t = Toe("field", t, e), t !== void 0) {
    if (t === null)
      return null;
    if (Y0e(t) && Pp(t.sort)) {
      const n = Toe("field", t.sort, e);
      t = Object.assign(Object.assign({}, t), n ? { sort: n } : {});
    }
    return t;
  }
}
function tPe(t, e) {
  if (sn(t))
    return yAt(t, e);
  {
    const n = Toe("datum", t, e);
    return n !== t && !n.type && (n.type = "nominal"), n;
  }
}
function nPe(t, e) {
  if ($r(t)) {
    const n = tPe(t, e);
    if (n)
      return n;
    if (DY(t))
      return { condition: t.condition };
  } else {
    if (UO(t)) {
      const n = tPe(t.condition, e);
      return n ? Object.assign(Object.assign({}, t), { condition: n }) : xSr(t, ["condition"]);
    }
    return t;
  }
}
function vAt(t, e) {
  const n = {};
  for (const r in t)
    if (Kn(t, r)) {
      const i = t[r];
      if (Nt(i))
        n[r] = i.map((o) => nPe(o, e)).filter((o) => o);
      else {
        const o = nPe(i, e);
        o !== void 0 && (n[r] = o);
      }
    }
  return n;
}
class DSr {
  constructor() {
    this.name = "RuleForRangedLine";
  }
  hasMatchingType(e) {
    if (hm(e)) {
      const { encoding: n, mark: r } = e;
      if (r === "line" || Zp(r) && r.type === "line")
        for (const i of RBr) {
          const o = D1(i), s = n[o];
          if (n[i] && (sn(s) && !Pc(s.bin) || _0(s)))
            return !0;
        }
    }
    return !1;
  }
  run(e, n, r) {
    const { encoding: i, mark: o } = e;
    return Zt(T1r(!!i.x2, !!i.y2)), r(Object.assign(Object.assign({}, e), { mark: _n(o) ? Object.assign(Object.assign({}, o), { type: "rule" }) : "rule" }), n);
  }
}
var Fm = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
class TSr extends aIe {
  constructor() {
    super(...arguments), this.nonFacetUnitNormalizers = [
      L_r,
      F_r,
      q_r,
      new wSr(),
      new DSr()
    ];
  }
  map(e, n) {
    if (hm(e)) {
      const r = Pv(e.encoding, vI), i = Pv(e.encoding, BI), o = Pv(e.encoding, pY);
      if (r || i || o)
        return this.mapFacetedUnit(e, n);
    }
    return super.map(e, n);
  }
  // This is for normalizing non-facet unit
  mapUnit(e, n) {
    const { parentEncoding: r, parentProjection: i } = n, o = fX(e.encoding, n.repeater), s = Object.assign(Object.assign({}, e), o ? { encoding: o } : {});
    if (r || i)
      return this.mapUnitWithParentEncodingOrProjection(s, n);
    const a = this.mapLayerOrUnit.bind(this);
    for (const A of this.nonFacetUnitNormalizers)
      if (A.hasMatchingType(s, n.config))
        return A.run(s, n, a);
    return s;
  }
  mapRepeat(e, n) {
    return CSr(e) ? this.mapLayerRepeat(e, n) : this.mapNonLayerRepeat(e, n);
  }
  mapLayerRepeat(e, n) {
    const { repeat: r, spec: i } = e, o = Fm(e, ["repeat", "spec"]), { row: s, column: a, layer: A } = r, { repeater: l = {}, repeaterPrefix: c = "" } = n;
    return s || a ? this.mapRepeat(Object.assign(Object.assign({}, e), { repeat: Object.assign(Object.assign({}, s ? { row: s } : {}), a ? { column: a } : {}), spec: {
      repeat: { layer: A },
      spec: i
    } }), n) : Object.assign(Object.assign({}, o), { layer: A.map((u) => {
      const f = Object.assign(Object.assign({}, l), { layer: u }), h = `${(i.name || "") + c}child__layer_${Ls(u)}`, d = this.mapLayerOrUnit(i, Object.assign(Object.assign({}, n), { repeater: f, repeaterPrefix: h }));
      return d.name = h, d;
    }) });
  }
  mapNonLayerRepeat(e, n) {
    var r;
    const { repeat: i, spec: o, data: s } = e, a = Fm(e, ["repeat", "spec", "data"]);
    !Nt(i) && e.columns && (e = Ff(e, ["columns"]), Zt(MFe("repeat")));
    const A = [], { repeater: l = {}, repeaterPrefix: c = "" } = n, u = !Nt(i) && i.row || [l ? l.row : null], f = !Nt(i) && i.column || [l ? l.column : null], h = Nt(i) && i || [l ? l.repeat : null];
    for (const I of h)
      for (const m of u)
        for (const C of f) {
          const y = {
            repeat: I,
            row: m,
            column: C,
            layer: l.layer
          }, v = (o.name || "") + c + "child__" + (Nt(i) ? `${Ls(I)}` : (i.row ? `row_${Ls(m)}` : "") + (i.column ? `column_${Ls(C)}` : "")), b = this.map(o, Object.assign(Object.assign({}, n), { repeater: y, repeaterPrefix: v }));
          b.name = v, A.push(Ff(b, ["data"]));
        }
    const d = Nt(i) ? e.columns : i.column ? i.column.length : 1;
    return Object.assign(Object.assign({ data: (r = o.data) !== null && r !== void 0 ? r : s, align: "all" }, a), {
      columns: d,
      concat: A
    });
  }
  mapFacet(e, n) {
    const { facet: r } = e;
    return GO(r) && e.columns && (e = Ff(e, ["columns"]), Zt(MFe("facet"))), super.mapFacet(e, n);
  }
  mapUnitWithParentEncodingOrProjection(e, n) {
    const { encoding: r, projection: i } = e, { parentEncoding: o, parentProjection: s, config: a } = n, A = iPe({ parentProjection: s, projection: i }), l = rPe({
      parentEncoding: o,
      encoding: fX(r, n.repeater)
    });
    return this.mapUnit(Object.assign(Object.assign(Object.assign({}, e), A ? { projection: A } : {}), l ? { encoding: l } : {}), { config: a });
  }
  mapFacetedUnit(e, n) {
    const r = e.encoding, { row: i, column: o, facet: s } = r, a = Fm(r, ["row", "column", "facet"]), { mark: A, width: l, projection: c, height: u, view: f, params: h, encoding: d } = e, I = Fm(e, ["mark", "width", "projection", "height", "view", "params", "encoding"]), { facetMapping: m, layout: C } = this.getFacetMappingAndLayout({ row: i, column: o, facet: s }, n), y = fX(a, n.repeater);
    return this.mapFacet(Object.assign(Object.assign(Object.assign({}, I), C), {
      // row / column has higher precedence than facet
      facet: m,
      spec: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, l ? { width: l } : {}), u ? { height: u } : {}), f ? { view: f } : {}), c ? { projection: c } : {}), { mark: A, encoding: y }), h ? { params: h } : {})
    }), n);
  }
  getFacetMappingAndLayout(e, n) {
    var r;
    const { row: i, column: o, facet: s } = e;
    if (i || o) {
      s && Zt(R1r([...i ? [vI] : [], ...o ? [BI] : []]));
      const a = {}, A = {};
      for (const l of [vI, BI]) {
        const c = e[l];
        if (c) {
          const u = Fm(c, ["align", "center", "spacing", "columns"]);
          a[l] = u;
          for (const f of ["align", "center", "spacing"])
            c[f] !== void 0 && ((r = A[f]) !== null && r !== void 0 || (A[f] = {}), A[f][l] = c[f]);
        }
      }
      return { facetMapping: a, layout: A };
    } else {
      const { align: a, center: A, spacing: l, columns: c } = s, u = Fm(s, ["align", "center", "spacing", "columns"]);
      return {
        facetMapping: RSr(u, n.repeater),
        layout: Object.assign(Object.assign(Object.assign(Object.assign({}, a ? { align: a } : {}), A ? { center: A } : {}), l ? { spacing: l } : {}), c ? { columns: c } : {})
      };
    }
  }
  mapLayer(e, n) {
    var { parentEncoding: r, parentProjection: i } = n, o = Fm(n, ["parentEncoding", "parentProjection"]);
    const { encoding: s, projection: a } = e, A = Fm(e, ["encoding", "projection"]), l = Object.assign(Object.assign({}, o), { parentEncoding: rPe({ parentEncoding: r, encoding: s, layer: !0 }), parentProjection: iPe({ parentProjection: i, projection: a }) });
    return super.mapLayer(A, l);
  }
}
function rPe({ parentEncoding: t, encoding: e = {}, layer: n }) {
  let r = {};
  if (t) {
    const i = /* @__PURE__ */ new Set([...Kt(t), ...Kt(e)]);
    for (const o of i) {
      const s = e[o], a = t[o];
      if ($r(s)) {
        const A = Object.assign(Object.assign({}, a), s);
        r[o] = A;
      } else
        UO(s) ? r[o] = Object.assign(Object.assign({}, s), { condition: Object.assign(Object.assign({}, a), s.condition) }) : s || s === null ? r[o] = s : (n || Cd(a) || Jn(a) || $r(a) || Nt(a)) && (r[o] = a);
    }
  } else
    r = e;
  return !r || Oo(r) ? void 0 : r;
}
function iPe(t) {
  const { parentProjection: e, projection: n } = t;
  return e && n && Zt(I1r({ parentProjection: e, projection: n })), n ?? e;
}
function AIe(t) {
  return "filter" in t;
}
function NSr(t) {
  return t?.stop !== void 0;
}
function BAt(t) {
  return "lookup" in t;
}
function LSr(t) {
  return "data" in t;
}
function MSr(t) {
  return "param" in t;
}
function OSr(t) {
  return "pivot" in t;
}
function FSr(t) {
  return "density" in t;
}
function PSr(t) {
  return "quantile" in t;
}
function kSr(t) {
  return "regression" in t;
}
function GSr(t) {
  return "loess" in t;
}
function USr(t) {
  return "sample" in t;
}
function HSr(t) {
  return "window" in t;
}
function $Sr(t) {
  return "joinaggregate" in t;
}
function qSr(t) {
  return "flatten" in t;
}
function jSr(t) {
  return "calculate" in t;
}
function bAt(t) {
  return "bin" in t;
}
function YSr(t) {
  return "impute" in t;
}
function zSr(t) {
  return "timeUnit" in t;
}
function VSr(t) {
  return "aggregate" in t;
}
function JSr(t) {
  return "stack" in t;
}
function KSr(t) {
  return "fold" in t;
}
function WSr(t) {
  return t.map((e) => AIe(e) ? {
    filter: uS(e.filter, bbr)
  } : e);
}
var GC = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
class XSr extends aIe {
  map(e, n) {
    var r, i;
    return (r = n.emptySelections) !== null && r !== void 0 || (n.emptySelections = {}), (i = n.selectionPredicates) !== null && i !== void 0 || (n.selectionPredicates = {}), e = oPe(e, n), super.map(e, n);
  }
  mapLayerOrUnit(e, n) {
    if (e = oPe(e, n), e.encoding) {
      const r = {};
      for (const [i, o] of fE(e.encoding))
        r[i] = _At(o, n);
      e = Object.assign(Object.assign({}, e), { encoding: r });
    }
    return super.mapLayerOrUnit(e, n);
  }
  mapUnit(e, n) {
    const r = e, { selection: i } = r, o = GC(r, ["selection"]);
    return i ? Object.assign(Object.assign({}, o), { params: fE(i).map(([s, a]) => {
      var A;
      const l = a, { init: c, bind: u, empty: f } = l, h = GC(l, ["init", "bind", "empty"]);
      h.type === "single" ? (h.type = "point", h.toggle = !1) : h.type === "multi" && (h.type = "point"), n.emptySelections[s] = f !== "none";
      for (const d of rc((A = n.selectionPredicates[s]) !== null && A !== void 0 ? A : {}))
        d.empty = f !== "none";
      return { name: s, value: c, select: h, bind: u };
    }) }) : e;
  }
}
function oPe(t, e) {
  const { transform: n } = t, r = GC(t, ["transform"]);
  if (n) {
    const i = n.map((o) => {
      if (AIe(o))
        return { filter: Noe(o, e) };
      if (bAt(o) && T1(o.bin))
        return Object.assign(Object.assign({}, o), { bin: SAt(o.bin) });
      if (BAt(o)) {
        const s = o.from, { selection: a } = s, A = GC(s, ["selection"]);
        return a ? Object.assign(Object.assign({}, o), { from: Object.assign({ param: a }, A) }) : o;
      }
      return o;
    });
    return Object.assign(Object.assign({}, r), { transform: i });
  }
  return t;
}
function _At(t, e) {
  var n, r;
  const i = Kr(t);
  if (sn(i) && T1(i.bin) && (i.bin = SAt(i.bin)), L1(i) && (!((r = (n = i.scale) === null || n === void 0 ? void 0 : n.domain) === null || r === void 0) && r.selection)) {
    const o = i.scale.domain, { selection: s } = o, a = GC(o, ["selection"]);
    i.scale.domain = Object.assign(Object.assign({}, a), s ? { param: s } : {});
  }
  if (DY(i))
    if (Nt(i.condition))
      i.condition = i.condition.map((o) => {
        const { selection: s, param: a, test: A } = o, l = GC(o, ["selection", "param", "test"]);
        return a ? o : Object.assign(Object.assign({}, l), { test: Noe(o, e) });
      });
    else {
      const o = _At(i.condition, e), { selection: s, param: a, test: A } = o, l = GC(o, ["selection", "param", "test"]);
      i.condition = a ? i.condition : Object.assign(Object.assign({}, l), { test: Noe(i.condition, e) });
    }
  return i;
}
function SAt(t) {
  const e = t.extent;
  if (e?.selection) {
    const { selection: n } = e, r = GC(e, ["selection"]);
    return Object.assign(Object.assign({}, t), { extent: Object.assign(Object.assign({}, r), { param: n }) });
  }
  return t;
}
function Noe(t, e) {
  const n = (r) => uS(r, (i) => {
    var o, s, a;
    const A = (o = e.emptySelections[i]) !== null && o !== void 0 ? o : !0, l = { param: i, empty: A };
    return (s = (a = e.selectionPredicates)[i]) !== null && s !== void 0 || (a[i] = []), e.selectionPredicates[i].push(l), l;
  });
  return t.selection ? n(t.selection) : uS(t.test || t.filter, (r) => r.selection ? n(r.selection) : r);
}
class Loe extends aIe {
  map(e, n) {
    var r;
    const i = (r = n.selections) !== null && r !== void 0 ? r : [];
    if (e.params && !hm(e)) {
      const o = [];
      for (const s of e.params)
        iIe(s) ? i.push(s) : o.push(s);
      e.params = o;
    }
    return n.selections = i, super.map(e, QAt(e, n));
  }
  mapUnit(e, n) {
    var r;
    const i = n.selections;
    if (!i || !i.length)
      return e;
    const o = ((r = n.path) !== null && r !== void 0 ? r : []).concat(e.name), s = [];
    for (const a of i)
      if (!a.views || !a.views.length)
        s.push(a);
      else
        for (const A of a.views)
          (Cn(A) && (A === e.name || o.indexOf(A) >= 0) || Nt(A) && A.map((l) => o.indexOf(l)).every((l, c, u) => l !== -1 && (c === 0 || l > u[c - 1]))) && s.push(a);
    return s.length && (e.params = s), e;
  }
}
for (const t of ["mapFacet", "mapRepeat", "mapHConcat", "mapVConcat", "mapLayer"]) {
  const e = Loe.prototype[t];
  Loe.prototype[t] = function(n, r) {
    return e.call(this, n, QAt(n, r));
  };
}
function QAt(t, e) {
  var n;
  return t.name ? Object.assign(Object.assign({}, e), { path: ((n = e.path) !== null && n !== void 0 ? n : []).concat(t.name) }) : e;
}
function wAt(t, e) {
  e === void 0 && (e = mAt(t.config));
  const n = nQr(t, e), { width: r, height: i } = t, o = rQr(n, { width: r, height: i, autosize: t.autosize }, e);
  return Object.assign(Object.assign({}, n), o ? { autosize: o } : {});
}
const ZSr = new TSr(), eQr = new XSr(), tQr = new Loe();
function nQr(t, e = {}) {
  const n = { config: e };
  return tQr.map(ZSr.map(eQr.map(t, n), n), n);
}
function sPe(t) {
  return Cn(t) ? { type: t } : t ?? {};
}
function rQr(t, e, n) {
  let { width: r, height: i } = e;
  const o = hm(t) || PY(t), s = {};
  o ? r == "container" && i == "container" ? (s.type = "fit", s.contains = "padding") : r == "container" ? (s.type = "fit-x", s.contains = "padding") : i == "container" && (s.type = "fit-y", s.contains = "padding") : (r == "container" && (Zt(DFe("width")), r = void 0), i == "container" && (Zt(DFe("height")), i = void 0));
  const a = Object.assign(Object.assign(Object.assign({ type: "pad" }, s), n ? sPe(n.autosize) : {}), sPe(t.autosize));
  if (a.type === "fit" && !o && (Zt(t1r), a.type = "pad"), r == "container" && !(a.type == "fit" || a.type == "fit-x") && Zt(TFe("width")), i == "container" && !(a.type == "fit" || a.type == "fit-y") && Zt(TFe("height")), !Qp(a, { type: "pad" }))
    return a;
}
function iQr(t) {
  return t === "fit" || t === "fit-x" || t === "fit-y";
}
function oQr(t) {
  return t ? `fit-${yY(t)}` : "fit";
}
const sQr = [
  "background",
  "padding"
  // We do not include "autosize" here as it is supported by only unit and layer specs and thus need to be normalized
];
function aPe(t, e) {
  const n = {};
  for (const r of sQr)
    t && t[r] !== void 0 && (n[r] = _f(t[r]));
  return e && (n.params = t.params), n;
}
class dm {
  constructor(e = {}, n = {}) {
    this.explicit = e, this.implicit = n;
  }
  clone() {
    return new dm(Kr(this.explicit), Kr(this.implicit));
  }
  combine() {
    return Object.assign(Object.assign({}, this.explicit), this.implicit);
  }
  get(e) {
    return Va(this.explicit[e], this.implicit[e]);
  }
  getWithExplicit(e) {
    return this.explicit[e] !== void 0 ? { explicit: !0, value: this.explicit[e] } : this.implicit[e] !== void 0 ? { explicit: !1, value: this.implicit[e] } : { explicit: !1, value: void 0 };
  }
  setWithExplicit(e, { value: n, explicit: r }) {
    n !== void 0 && this.set(e, n, r);
  }
  set(e, n, r) {
    return delete this[r ? "implicit" : "explicit"][e], this[r ? "explicit" : "implicit"][e] = n, this;
  }
  copyKeyFromSplit(e, { explicit: n, implicit: r }) {
    n[e] !== void 0 ? this.set(e, n[e], !0) : r[e] !== void 0 && this.set(e, r[e], !1);
  }
  copyKeyFromObject(e, n) {
    n[e] !== void 0 && this.set(e, n[e], !0);
  }
  /**
   * Merge split object into this split object. Properties from the other split
   * overwrite properties from this split.
   */
  copyAll(e) {
    for (const n of Kt(e.combine())) {
      const r = e.getWithExplicit(n);
      this.setWithExplicit(n, r);
    }
  }
}
function cp(t) {
  return {
    explicit: !0,
    value: t
  };
}
function df(t) {
  return {
    explicit: !1,
    value: t
  };
}
function xAt(t) {
  return (e, n, r, i) => {
    const o = t(e.value, n.value);
    return o > 0 ? e : o < 0 ? n : kY(e, n, r, i);
  };
}
function kY(t, e, n, r) {
  return t.explicit && e.explicit && Zt(H1r(n, r, t.value, e.value)), t;
}
function hE(t, e, n, r, i = kY) {
  return t === void 0 || t.value === void 0 ? e : t.explicit && !e.explicit ? t : e.explicit && !t.explicit ? e : Qp(t.value, e.value) ? t : i(t, e, n, r);
}
class aQr extends dm {
  constructor(e = {}, n = {}, r = !1) {
    super(e, n), this.explicit = e, this.implicit = n, this.parseNothing = r;
  }
  clone() {
    const e = super.clone();
    return e.parseNothing = this.parseNothing, e;
  }
}
function UQ(t) {
  return "url" in t;
}
function HN(t) {
  return "values" in t;
}
function RAt(t) {
  return "name" in t && !UQ(t) && !HN(t) && !UC(t);
}
function UC(t) {
  return t && (DAt(t) || TAt(t) || lIe(t));
}
function DAt(t) {
  return "sequence" in t;
}
function TAt(t) {
  return "sphere" in t;
}
function lIe(t) {
  return "graticule" in t;
}
var Wo;
(function(t) {
  t[t.Raw = 0] = "Raw", t[t.Main = 1] = "Main", t[t.Row = 2] = "Row", t[t.Column = 3] = "Column", t[t.Lookup = 4] = "Lookup";
})(Wo || (Wo = {}));
var AQr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function OB(t, e = !0, n = Ac) {
  if (Nt(t)) {
    const r = t.map((i) => OB(i, e, n));
    return e ? `[${r.join(", ")}]` : r;
  } else if (N1(t))
    return n(e ? UN(t) : gbr(t));
  return e ? n(Xo(t)) : t;
}
function lQr(t, e) {
  var n;
  for (const r of rc((n = t.component.selection) !== null && n !== void 0 ? n : {})) {
    const i = r.name;
    let o = `${i}${IE}, ${r.resolve === "global" ? "true" : `{unit: ${HQ(t)}}`}`;
    for (const s of UY)
      s.defined(r) && (s.signals && (e = s.signals(t, r, e)), s.modifyExpr && (o = s.modifyExpr(t, r, o)));
    e.push({
      name: i + HQr,
      on: [
        {
          events: { signal: r.name + IE },
          update: `modify(${an(r.name + FB)}, ${o})`
        }
      ]
    });
  }
  return cIe(e);
}
function cQr(t, e) {
  if (t.component.selection && Kt(t.component.selection).length) {
    const n = an(t.getName("cell"));
    e.unshift({
      name: "facet",
      value: {},
      on: [
        {
          events: jE("mousemove", "scope"),
          update: `isTuple(facet) ? facet : group(${n}).datum`
        }
      ]
    });
  }
  return cIe(e);
}
function uQr(t, e) {
  var n;
  let r = !1;
  for (const i of rc((n = t.component.selection) !== null && n !== void 0 ? n : {})) {
    const o = i.name, s = an(o + FB);
    if (e.filter((A) => A.name === o).length === 0) {
      const A = i.resolve === "global" ? "union" : i.resolve, l = i.type === "point" ? ", true, true)" : ")";
      e.push({
        name: i.name,
        update: `${VAt}(${s}, ${an(A)}${l}`
      });
    }
    r = !0;
    for (const A of UY)
      A.defined(i) && A.topLevelSignals && (e = A.topLevelSignals(t, i, e));
  }
  return r && e.filter((o) => o.name === "unit").length === 0 && e.unshift({
    name: "unit",
    value: {},
    on: [{ events: "mousemove", update: "isTuple(group()) ? group() : unit" }]
  }), cIe(e);
}
function fQr(t, e) {
  var n;
  const r = [...e], i = HQ(t, { escape: !1 });
  for (const o of rc((n = t.component.selection) !== null && n !== void 0 ? n : {})) {
    const s = { name: o.name + FB };
    if (o.project.hasSelectionId && (s.transform = [{ type: "collect", sort: { field: t0 } }]), o.init) {
      const A = o.project.items.map((l) => AQr(l, ["signals"]));
      s.values = o.project.hasSelectionId ? o.init.map((l) => ({ unit: i, [t0]: OB(l, !1)[0] })) : o.init.map((l) => ({ unit: i, fields: A, values: OB(l, !1) }));
    }
    r.filter((A) => A.name === o.name + FB).length || r.push(s);
  }
  return r;
}
function NAt(t, e) {
  var n;
  for (const r of rc((n = t.component.selection) !== null && n !== void 0 ? n : {}))
    for (const i of UY)
      i.defined(r) && i.marks && (e = i.marks(t, r, e));
  return e;
}
function gQr(t, e) {
  for (const n of t.children)
    $a(n) && (e = NAt(n, e));
  return e;
}
function hQr(t, e, n, r) {
  const i = ZAt(t, e.param, e);
  return {
    signal: qf(n.get("type")) && Nt(r) && r[0] > r[1] ? `isValid(${i}) && reverse(${i})` : i
  };
}
function cIe(t) {
  return t.map((e) => (e.on && !e.on.length && delete e.on, e));
}
class Uo {
  constructor(e, n) {
    this.debugName = n, this._children = [], this._parent = null, e && (this.parent = e);
  }
  /**
   * Clone this node with a deep copy but don't clone links to children or parents.
   */
  clone() {
    throw new Error("Cannot clone node");
  }
  get parent() {
    return this._parent;
  }
  /**
   * Set the parent of the node and also add this node to the parent's children.
   */
  set parent(e) {
    this._parent = e, e && e.addChild(this);
  }
  get children() {
    return this._children;
  }
  numChildren() {
    return this._children.length;
  }
  addChild(e, n) {
    if (this._children.includes(e)) {
      Zt(h1r);
      return;
    }
    n !== void 0 ? this._children.splice(n, 0, e) : this._children.push(e);
  }
  removeChild(e) {
    const n = this._children.indexOf(e);
    return this._children.splice(n, 1), n;
  }
  /**
   * Remove node from the dataflow.
   */
  remove() {
    let e = this._parent.removeChild(this);
    for (const n of this._children)
      n._parent = this._parent, this._parent.addChild(n, e++);
  }
  /**
   * Insert another node as a parent of this node.
   */
  insertAsParentOf(e) {
    const n = e.parent;
    n.removeChild(this), this.parent = n, e.parent = this;
  }
  swapWithParent() {
    const e = this._parent, n = e.parent;
    for (const i of this._children)
      i.parent = e;
    this._children = [], e.removeChild(this);
    const r = e.parent.removeChild(e);
    this._parent = n, n.addChild(this, r), e.parent = this;
  }
}
class zc extends Uo {
  /**
   * @param source The name of the source. Will change in assemble.
   * @param type The type of the output node.
   * @param refCounts A global ref counter map.
   */
  constructor(e, n, r, i) {
    super(e, n), this.type = r, this.refCounts = i, this._source = this._name = n, this.refCounts && !(this._name in this.refCounts) && (this.refCounts[this._name] = 0);
  }
  clone() {
    const e = new this.constructor();
    return e.debugName = `clone_${this.debugName}`, e._source = this._source, e._name = `clone_${this._name}`, e.type = this.type, e.refCounts = this.refCounts, e.refCounts[e._name] = 0, e;
  }
  dependentFields() {
    return /* @__PURE__ */ new Set();
  }
  producedFields() {
    return /* @__PURE__ */ new Set();
  }
  hash() {
    return this._hash === void 0 && (this._hash = `Output ${Nst()}`), this._hash;
  }
  /**
   * Request the datasource name and increase the ref counter.
   *
   * During the parsing phase, this will return the simple name such as 'main' or 'raw'.
   * It is crucial to request the name from an output node to mark it as a required node.
   * If nobody ever requests the name, this datasource will not be instantiated in the assemble phase.
   *
   * In the assemble phase, this will return the correct name.
   */
  getSource() {
    return this.refCounts[this._name]++, this._source;
  }
  isRequired() {
    return !!this.refCounts[this._name];
  }
  setSource(e) {
    this._source = e;
  }
}
var APe = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
class kp extends Uo {
  constructor(e, n) {
    super(e), this.formula = n;
  }
  clone() {
    return new kp(null, Kr(this.formula));
  }
  static makeFromEncoding(e, n) {
    const r = n.reduceFieldDef((i, o) => {
      const { field: s, timeUnit: a } = o;
      if (a) {
        const A = fn(o, { forAs: !0 });
        i[_i({
          as: A,
          field: s,
          timeUnit: a
        })] = {
          as: A,
          field: s,
          timeUnit: a
        };
      }
      return i;
    }, {});
    return Oo(r) ? null : new kp(e, r);
  }
  static makeFromTransform(e, n) {
    const r = Object.assign({}, n), { timeUnit: i } = r, o = APe(r, ["timeUnit"]), s = cc(i), a = Object.assign(Object.assign({}, o), { timeUnit: s });
    return new kp(e, {
      [_i(a)]: a
    });
  }
  /**
   * Merge together TimeUnitNodes assigning the children of `other` to `this`
   * and removing `other`.
   */
  merge(e) {
    this.formula = Object.assign({}, this.formula);
    for (const n in e.formula)
      this.formula[n] || (this.formula[n] = e.formula[n]);
    for (const n of e.children)
      e.removeChild(n), n.parent = this;
    e.remove();
  }
  /**
   * Remove time units coming from the other node.
   */
  removeFormulas(e) {
    const n = {};
    for (const [r, i] of fE(this.formula))
      e.has(i.as) || (n[r] = i);
    this.formula = n;
  }
  producedFields() {
    return new Set(rc(this.formula).map((e) => e.as));
  }
  dependentFields() {
    return new Set(rc(this.formula).map((e) => e.field));
  }
  hash() {
    return `TimeUnit ${_i(this.formula)}`;
  }
  assemble() {
    const e = [];
    for (const n of rc(this.formula)) {
      const { field: r, as: i, timeUnit: o } = n, s = cc(o), { unit: a, utc: A } = s, l = APe(s, ["unit", "utc"]);
      e.push(Object.assign(Object.assign(Object.assign(Object.assign({ field: Vg(r), type: "timeunit" }, a ? { units: Q0e(a) } : {}), A ? { timezone: "utc" } : {}), l), { as: [i, `${i}_end`] }));
    }
    return e;
  }
}
var dQr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
const qO = "_tuple_fields";
class pQr {
  constructor(...e) {
    this.items = e, this.hasChannel = {}, this.hasField = {}, this.hasSelectionId = !1;
  }
}
const IQr = {
  defined: () => !0,
  parse: (t, e, n) => {
    var r;
    const i = e.name, o = (r = e.project) !== null && r !== void 0 ? r : e.project = new pQr(), s = {}, a = {}, A = /* @__PURE__ */ new Set(), l = (I, m) => {
      const C = m === "visual" ? I.channel : I.field;
      let y = Ls(`${i}_${C}`);
      for (let v = 1; A.has(y); v++)
        y = Ls(`${i}_${C}_${v}`);
      return A.add(y), { [m]: y };
    }, c = e.type, u = t.config.selection[c], f = n.value !== void 0 ? bn(n.value) : null;
    let { fields: h, encodings: d } = _n(n.select) ? n.select : {};
    if (!h && !d && f) {
      for (const I of f)
        if (_n(I))
          for (const m of Kt(I))
            xBr(m) ? (d || (d = [])).push(m) : c === "interval" ? (Zt(c1r), d = u.encodings) : (h || (h = [])).push(m);
    }
    !h && !d && (d = u.encodings, "fields" in u && (h = u.fields));
    for (const I of d ?? []) {
      const m = t.fieldDef(I);
      if (m) {
        let C = m.field;
        if (m.aggregate) {
          Zt(n1r(I, m.aggregate));
          continue;
        } else if (!C) {
          Zt(LFe(I));
          continue;
        }
        if (m.timeUnit) {
          C = t.vgField(I);
          const y = {
            timeUnit: m.timeUnit,
            as: C,
            field: m.field
          };
          a[_i(y)] = y;
        }
        if (!s[C]) {
          let y = "E";
          if (c === "interval") {
            const b = t.getScaleComponent(I).get("type");
            qf(b) && (y = "R");
          } else
            m.bin && (y = "R-RE");
          const v = { field: C, channel: I, type: y };
          v.signals = Object.assign(Object.assign({}, l(v, "data")), l(v, "visual")), o.items.push(s[C] = v), o.hasField[C] = o.hasChannel[I] = s[C], o.hasSelectionId = o.hasSelectionId || C === t0;
        }
      } else
        Zt(LFe(I));
    }
    for (const I of h ?? []) {
      if (o.hasField[I])
        continue;
      const m = { type: "E", field: I };
      m.signals = Object.assign({}, l(m, "data")), o.items.push(m), o.hasField[I] = m, o.hasSelectionId = o.hasSelectionId || I === t0;
    }
    f && (e.init = f.map((I) => o.items.map((m) => _n(I) ? I[m.channel] !== void 0 ? I[m.channel] : I[m.field] : I))), Oo(a) || (o.timeUnit = new kp(null, a));
  },
  signals: (t, e, n) => {
    const r = e.name + qO;
    return n.filter((o) => o.name === r).length > 0 || e.project.hasSelectionId ? n : n.concat({
      name: r,
      value: e.project.items.map((o) => {
        const s = dQr(o, ["signals", "hasLegend"]);
        return s.field = Vg(s.field), s;
      })
    });
  }
}, dE = {
  defined: (t) => t.type === "interval" && t.resolve === "global" && t.bind && t.bind === "scales",
  parse: (t, e) => {
    const n = e.scales = [];
    for (const r of e.project.items) {
      const i = r.channel;
      if (!WE(i))
        continue;
      const o = t.getScaleComponent(i), s = o ? o.get("type") : void 0;
      if (!o || !qf(s)) {
        Zt(o1r);
        continue;
      }
      o.set("selectionExtent", { param: e.name, field: r.field }, !0), n.push(r);
    }
  },
  topLevelSignals: (t, e, n) => {
    const r = e.scales.filter((s) => n.filter((a) => a.name === s.signals.data).length === 0);
    if (!t.parent || Ooe(t) || r.length === 0)
      return n;
    const i = n.filter((s) => s.name === e.name)[0];
    let o = i.update;
    if (o.indexOf(VAt) >= 0)
      i.update = `{${r.map((s) => `${an(Vg(s.field))}: ${s.signals.data}`).join(", ")}}`;
    else {
      for (const s of r) {
        const a = `${an(Vg(s.field))}: ${s.signals.data}`;
        o.includes(a) || (o = `${o.substring(0, o.length - 1)}, ${a}}`);
      }
      i.update = o;
    }
    return n.concat(r.map((s) => ({ name: s.signals.data })));
  },
  signals: (t, e, n) => {
    if (t.parent && !Ooe(t))
      for (const r of e.scales) {
        const i = n.filter((o) => o.name === r.signals.data)[0];
        i.push = "outer", delete i.value, delete i.update;
      }
    return n;
  }
};
function Moe(t, e) {
  return `domain(${an(t.scaleName(e))})`;
}
function Ooe(t) {
  var e;
  return t.parent && Lx(t.parent) && ((e = !t.parent.parent) !== null && e !== void 0 ? e : Ooe(t.parent.parent));
}
var mQr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
const hS = "_brush", Foe = "_scale_trigger", CQr = {
  defined: (t) => t.type === "interval",
  signals: (t, e, n) => {
    const r = e.name, i = r + qO, o = dE.defined(e), s = e.init ? e.init[0] : null, a = [], A = [];
    if (e.translate && !o) {
      const c = `!event.item || event.item.mark.name !== ${an(r + hS)}`;
      LAt(e, (u, f) => {
        var h, d;
        const I = bn((h = (d = f.between[0]).filter) !== null && h !== void 0 ? h : d.filter = []);
        return I.includes(c) || I.push(c), u;
      });
    }
    e.project.items.forEach((c, u) => {
      const f = c.channel;
      if (f !== ta && f !== kA) {
        Zt("Interval selections only support x and y encoding channels.");
        return;
      }
      const h = s ? s[u] : null, d = EQr(t, e, c, h), I = c.signals.data, m = c.signals.visual, C = an(t.scaleName(f)), y = t.getScaleComponent(f).get("type"), v = qf(y) ? "+" : "";
      n.push(...d), a.push(I), A.push({
        scaleName: t.scaleName(f),
        expr: `(!isArray(${I}) || (${v}invert(${C}, ${m})[0] === ${v}${I}[0] && ${v}invert(${C}, ${m})[1] === ${v}${I}[1]))`
      });
    }), !o && A.length && n.push({
      name: r + Foe,
      value: {},
      on: [
        {
          events: A.map((c) => ({ scale: c.scaleName })),
          update: `${A.map((c) => c.expr).join(" && ")} ? ${r + Foe} : {}`
        }
      ]
    });
    const l = `unit: ${HQ(t)}, fields: ${i}, values`;
    return n.concat(Object.assign(Object.assign({ name: r + IE }, s ? { init: `{${l}: ${OB(s)}}` } : {}), a.length ? {
      on: [
        {
          events: [{ signal: a.join(" || ") }],
          update: `${a.join(" && ")} ? {${l}: [${a}]} : null`
        }
      ]
    } : {}));
  },
  marks: (t, e, n) => {
    const r = e.name, { x: i, y: o } = e.project.hasChannel, s = i?.signals.visual, a = o?.signals.visual, A = `data(${an(e.name + FB)})`;
    if (dE.defined(e) || !i && !o)
      return n;
    const l = {
      x: i !== void 0 ? { signal: `${s}[0]` } : { value: 0 },
      y: o !== void 0 ? { signal: `${a}[0]` } : { value: 0 },
      x2: i !== void 0 ? { signal: `${s}[1]` } : { field: { group: "width" } },
      y2: o !== void 0 ? { signal: `${a}[1]` } : { field: { group: "height" } }
    };
    if (e.resolve === "global")
      for (const m of Kt(l))
        l[m] = [
          Object.assign({ test: `${A}.length && ${A}[0].unit === ${HQ(t)}` }, l[m]),
          { value: 0 }
        ];
    const c = e.mark, { fill: u, fillOpacity: f, cursor: h } = c, d = mQr(c, ["fill", "fillOpacity", "cursor"]), I = Kt(d).reduce((m, C) => (m[C] = [
      {
        test: [i !== void 0 && `${s}[0] !== ${s}[1]`, o !== void 0 && `${a}[0] !== ${a}[1]`].filter((y) => y).join(" && "),
        value: d[C]
      },
      { value: null }
    ], m), {});
    return [
      {
        name: `${r + hS}_bg`,
        type: "rect",
        clip: !0,
        encode: {
          enter: {
            fill: { value: u },
            fillOpacity: { value: f }
          },
          update: l
        }
      },
      ...n,
      {
        name: r + hS,
        type: "rect",
        clip: !0,
        encode: {
          enter: Object.assign(Object.assign({}, h ? { cursor: { value: h } } : {}), { fill: { value: "transparent" } }),
          update: Object.assign(Object.assign({}, l), I)
        }
      }
    ];
  }
};
function EQr(t, e, n, r) {
  const i = n.channel, o = n.signals.visual, s = n.signals.data, a = dE.defined(e), A = an(t.scaleName(i)), l = t.getScaleComponent(i), c = l ? l.get("type") : void 0, u = (I) => `scale(${A}, ${I})`, f = t.getSizeSignalRef(i === ta ? "width" : "height").signal, h = `${i}(unit)`, d = LAt(e, (I, m) => [
    ...I,
    { events: m.between[0], update: `[${h}, ${h}]` },
    { events: m, update: `[${o}[0], clamp(${h}, 0, ${f})]` }
    // Brush End
  ]);
  return d.push({
    events: { signal: e.name + Foe },
    update: qf(c) ? `[${u(`${s}[0]`)}, ${u(`${s}[1]`)}]` : "[0, 0]"
  }), a ? [{ name: s, on: [] }] : [
    Object.assign(Object.assign({ name: o }, r ? { init: OB(r, !0, u) } : { value: [] }), { on: d }),
    Object.assign(Object.assign({ name: s }, r ? { init: OB(r) } : {}), { on: [
      {
        events: { signal: o },
        update: `${o}[0] === ${o}[1] ? null : invert(${A}, ${o})`
      }
    ] })
  ];
}
function LAt(t, e) {
  return t.events.reduce((n, r) => r.between ? e(n, r) : (Zt(`${r} is not an ordered event stream for interval selections.`), n), []);
}
const yQr = {
  defined: (t) => t.type === "point",
  signals: (t, e, n) => {
    var r;
    const i = e.name, o = i + qO, s = e.project, a = "(item().isVoronoi ? datum.datum : datum)", A = rc((r = t.component.selection) !== null && r !== void 0 ? r : {}).reduce((f, h) => h.type === "interval" ? f.concat(h.name + hS) : f, []).map((f) => `indexof(item().mark.name, '${f}') < 0`).join(" && "), l = `datum && item().mark.marktype !== 'group' && indexof(item().mark.role, 'legend') < 0${A ? ` && ${A}` : ""}`;
    let c = `unit: ${HQ(t)}, `;
    if (e.project.hasSelectionId)
      c += `${t0}: ${a}[${an(t0)}]`;
    else {
      const f = s.items.map((h) => {
        const d = t.fieldDef(h.channel);
        return d?.bin ? `[${a}[${an(t.vgField(h.channel, {}))}], ${a}[${an(t.vgField(h.channel, { binSuffix: "end" }))}]]` : `${a}[${an(h.field)}]`;
      }).join(", ");
      c += `fields: ${o}, values: [${f}]`;
    }
    const u = e.events;
    return n.concat([
      {
        name: i + IE,
        on: u ? [
          {
            events: u,
            update: `${l} ? {${c}} : null`,
            force: !0
          }
        ] : []
      }
    ]);
  }
};
function Rx(t, e, n, r) {
  const i = DY(e) && e.condition, o = r(e);
  if (i) {
    const a = bn(i).map((A) => {
      const l = r(A);
      if (c_r(A)) {
        const { param: c, empty: u } = A, f = XAt(t, { param: c, empty: u });
        return Object.assign({ test: f }, l);
      } else {
        const c = q6(t, A.test);
        return Object.assign({ test: c }, l);
      }
    });
    return {
      [n]: [...a, ...o !== void 0 ? [o] : []]
    };
  } else
    return o !== void 0 ? { [n]: o } : {};
}
function uIe(t, e = "text") {
  const n = t.encoding[e];
  return Rx(t, n, e, (r) => GY(r, t.config));
}
function GY(t, e, n = "datum") {
  if (t) {
    if (Cd(t))
      return hs(t.value);
    if ($r(t)) {
      const { format: r, formatType: i } = F6(t);
      return q0e({ fieldOrDatumDef: t, format: r, formatType: i, expr: n, config: e });
    }
  }
}
function MAt(t, e = {}) {
  const { encoding: n, markDef: r, config: i, stack: o } = t, s = n.tooltip;
  if (Nt(s))
    return { tooltip: lPe({ tooltip: s }, o, i, e) };
  {
    const a = e.reactiveGeom ? "datum.datum" : "datum";
    return Rx(t, s, "tooltip", (A) => {
      const l = GY(A, i, a);
      if (l)
        return l;
      if (A === null)
        return;
      let c = Co("tooltip", r, i);
      if (c === !0 && (c = { content: "encoding" }), Cn(c))
        return { value: c };
      if (_n(c))
        return Jn(c) ? c : c.content === "encoding" ? lPe(n, o, i, e) : { signal: a };
    });
  }
}
function OAt(t, e, n, { reactiveGeom: r } = {}) {
  const i = {}, o = r ? "datum.datum" : "datum", s = [];
  function a(l, c) {
    const u = D1(c), f = Kg(l) ? l : Object.assign(Object.assign({}, l), {
      type: t[u].type
      // for secondary field def, copy type from main channel
    }), h = f.title || V0e(f, n), d = bn(h).join(", ");
    let I;
    if (GA(c)) {
      const m = c === "x" ? "x2" : "y2", C = e0(t[m]);
      if (Pc(f.bin) && C) {
        const y = fn(f, { expr: o }), v = fn(C, { expr: o }), { format: b, formatType: Q } = F6(f);
        I = kO(y, v, b, Q, n), i[m] = !0;
      }
    }
    if ((GA(c) || c === Zg || c === Gd) && e && e.fieldChannel === c && e.offset === "normalize") {
      const { format: m, formatType: C } = F6(f);
      I = q0e({
        fieldOrDatumDef: f,
        format: m,
        formatType: C,
        expr: o,
        config: n,
        normalizeStack: !0
      }).signal;
    }
    I ?? (I = GY(f, n, o).signal), s.push({ channel: c, key: d, value: I });
  }
  W0e(t, (l, c) => {
    sn(l) ? a(l, c) : TY(l) && a(l.condition, c);
  });
  const A = {};
  for (const { channel: l, key: c, value: u } of s)
    !i[l] && !A[c] && (A[c] = u);
  return A;
}
function lPe(t, e, n, { reactiveGeom: r } = {}) {
  const i = OAt(t, e, n, { reactiveGeom: r }), o = fE(i).map(([s, a]) => `"${s}": ${a}`);
  return o.length > 0 ? { signal: `{${o.join(", ")}}` } : void 0;
}
function vQr(t) {
  const { markDef: e, config: n } = t, r = Co("aria", e, n);
  return r === !1 ? {} : Object.assign(Object.assign(Object.assign({}, r ? { aria: r } : {}), BQr(t)), bQr(t));
}
function BQr(t) {
  const { mark: e, markDef: n, config: r } = t;
  if (r.aria === !1)
    return {};
  const i = Co("ariaRoleDescription", n, r);
  return i != null ? { ariaRoleDescription: { value: i } } : e in XBr ? {} : { ariaRoleDescription: { value: e } };
}
function bQr(t) {
  const { encoding: e, markDef: n, config: r, stack: i } = t, o = e.description;
  if (o)
    return Rx(t, o, "description", (A) => GY(A, t.config));
  const s = Co("description", n, r);
  if (s != null)
    return {
      description: hs(s)
    };
  if (r.aria === !1)
    return {};
  const a = OAt(e, i, r);
  if (!Oo(a))
    return {
      description: {
        signal: fE(a).map(([A, l], c) => `"${c > 0 ? "; " : ""}${A}: " + (${l})`).join(" + ")
      }
    };
}
function DA(t, e, n = {}) {
  const { markDef: r, encoding: i, config: o } = e, { vgChannel: s } = n;
  let { defaultRef: a, defaultValue: A } = n;
  a === void 0 && (A ?? (A = Co(t, r, o, { vgChannel: s, ignoreVgConfig: !0 })), A !== void 0 && (a = hs(A)));
  const l = i[t];
  return Rx(e, l, s ?? t, (c) => $0e({
    channel: t,
    channelDef: c,
    markDef: r,
    config: o,
    scaleName: e.scaleName(t),
    scale: e.getScaleComponent(t),
    stack: null,
    defaultRef: a
  }));
}
function FAt(t, e = { filled: void 0 }) {
  var n, r, i, o;
  const { markDef: s, encoding: a, config: A } = t, { type: l } = s, c = (n = e.filled) !== null && n !== void 0 ? n : Co("filled", s, A), u = wi(["bar", "point", "circle", "square", "geoshape"], l) ? "transparent" : void 0, f = (i = (r = Co(c === !0 ? "color" : void 0, s, A, { vgChannel: "fill" })) !== null && r !== void 0 ? r : (
    // need to add this manually as getMarkConfig normally drops config.mark[channel] if vgChannel is specified
    A.mark[c === !0 && "color"]
  )) !== null && i !== void 0 ? i : (
    // If there is no fill, always fill symbols, bar, geoshape
    // with transparent fills https://github.com/vega/vega-lite/issues/1316
    u
  ), h = (o = Co(c === !1 ? "color" : void 0, s, A, { vgChannel: "stroke" })) !== null && o !== void 0 ? o : (
    // need to add this manually as getMarkConfig normally drops config.mark[channel] if vgChannel is specified
    A.mark[c === !1 && "color"]
  ), d = c ? "fill" : "stroke", I = Object.assign(Object.assign({}, f ? { fill: hs(f) } : {}), h ? { stroke: hs(h) } : {});
  return s.color && (c ? s.fill : s.stroke) && Zt(oat("property", { fill: "fill" in s, stroke: "stroke" in s })), Object.assign(Object.assign(Object.assign(Object.assign({}, I), DA("color", t, {
    vgChannel: d,
    defaultValue: c ? f : h
  })), DA("fill", t, {
    // if there is encoding.fill, include default fill just in case we have conditional-only fill encoding
    defaultValue: a.fill ? f : void 0
  })), DA("stroke", t, {
    // if there is encoding.stroke, include default fill just in case we have conditional-only stroke encoding
    defaultValue: a.stroke ? h : void 0
  }));
}
function _Qr(t) {
  const { encoding: e, mark: n } = t, r = e.order;
  return !ey(n) && Cd(r) ? Rx(t, r, "zindex", (i) => hs(i.value)) : {};
}
function $N({ channel: t, markDef: e, encoding: n = {}, model: r, bandPosition: i }) {
  const o = `${t}Offset`, s = e[o], a = n[o];
  if ((o === "xOffset" || o === "yOffset") && a)
    return { offsetType: "encoding", offset: $0e({
      channel: o,
      channelDef: a,
      markDef: e,
      config: r?.config,
      scaleName: r.scaleName(o),
      scale: r.getScaleComponent(o),
      stack: null,
      defaultRef: hs(s),
      bandPosition: i
    }) };
  const A = e[o];
  return A ? { offsetType: "visual", offset: A } : {};
}
function Wl(t, e, { defaultPos: n, vgChannel: r }) {
  const { encoding: i, markDef: o, config: s, stack: a } = e, A = i[t], l = i[gm(t)], c = e.scaleName(t), u = e.getScaleComponent(t), { offset: f, offsetType: h } = $N({
    channel: t,
    markDef: o,
    encoding: i,
    model: e,
    bandPosition: 0.5
  }), d = fIe({
    model: e,
    defaultPos: n,
    channel: t,
    scaleName: c,
    scale: u
  }), I = !A && GA(t) && (i.latitude || i.longitude) ? (
    // use geopoint output if there are lat/long and there is no point position overriding lat/long.
    { field: e.getName(t) }
  ) : SQr({
    channel: t,
    channelDef: A,
    channel2Def: l,
    markDef: o,
    config: s,
    scaleName: c,
    scale: u,
    stack: a,
    offset: f,
    defaultRef: d,
    bandPosition: h === "encoding" ? 0 : void 0
  });
  return I ? { [r || t]: I } : void 0;
}
function SQr(t) {
  const { channel: e, channelDef: n, scaleName: r, stack: i, offset: o, markDef: s } = t;
  if ($r(n) && i && e === i.fieldChannel) {
    if (sn(n)) {
      let a = n.bandPosition;
      if (a === void 0 && s.type === "text" && (e === "radius" || e === "theta") && (a = 0.5), a !== void 0)
        return M6({
          scaleName: r,
          fieldOrDatumDef: n,
          startSuffix: "start",
          bandPosition: a,
          offset: o
        });
    }
    return Fv(n, r, { suffix: "end" }, { offset: o });
  }
  return U0e(t);
}
function fIe({ model: t, defaultPos: e, channel: n, scaleName: r, scale: i }) {
  const { markDef: o, config: s } = t;
  return () => {
    const a = D1(n), A = gE(n), l = Co(n, o, s, { vgChannel: A });
    if (l !== void 0)
      return XD(n, l);
    switch (e) {
      case "zeroOrMin":
      case "zeroOrMax":
        if (r) {
          const c = i.get("type");
          if (!wi([Nu.LOG, Nu.TIME, Nu.UTC], c)) {
            if (i.domainDefinitelyIncludesZero())
              return {
                scale: r,
                value: 0
              };
          }
        }
        if (e === "zeroOrMin")
          return a === "y" ? { field: { group: "height" } } : { value: 0 };
        switch (a) {
          case "radius":
            return {
              signal: `min(${t.width.signal},${t.height.signal})/2`
            };
          case "theta":
            return { signal: "2*PI" };
          case "x":
            return { field: { group: "width" } };
          case "y":
            return { value: 0 };
        }
        break;
      case "mid": {
        const c = t[ju(n)];
        return Object.assign(Object.assign({}, c), { mult: 0.5 });
      }
    }
  };
}
const QQr = {
  left: "x",
  center: "xc",
  right: "x2"
}, wQr = {
  top: "y",
  middle: "yc",
  bottom: "y2"
};
function PAt(t, e, n, r = "middle") {
  if (t === "radius" || t === "theta")
    return gE(t);
  const i = t === "x" ? "align" : "baseline", o = Co(i, e, n);
  let s;
  return Jn(o) ? (Zt(D1r(i)), s = void 0) : s = o, t === "x" ? QQr[s || (r === "top" ? "left" : "center")] : wQr[s || r];
}
function H6(t, e, { defaultPos: n, defaultPos2: r, range: i }) {
  return i ? kAt(t, e, { defaultPos: n, defaultPos2: r }) : Wl(t, e, { defaultPos: n });
}
function kAt(t, e, { defaultPos: n, defaultPos2: r }) {
  const { markDef: i, config: o } = e, s = gm(t), a = ju(t), A = xQr(e, r, s), l = A[a] ? (
    // If there is width/height, we need to position the marks based on the alignment.
    PAt(t, i, o)
  ) : (
    // Otherwise, make sure to apply to the right Vg Channel (for arc mark)
    gE(t)
  );
  return Object.assign(Object.assign({}, Wl(t, e, { defaultPos: n, vgChannel: l })), A);
}
function xQr(t, e, n) {
  const { encoding: r, mark: i, markDef: o, stack: s, config: a } = t, A = D1(n), l = ju(n), c = gE(n), u = r[A], f = t.scaleName(A), h = t.getScaleComponent(A), { offset: d } = n in r || n in o ? $N({ channel: n, markDef: o, encoding: r, model: t }) : $N({ channel: A, markDef: o, encoding: r, model: t });
  if (!u && (n === "x2" || n === "y2") && (r.latitude || r.longitude)) {
    const m = ju(n), C = t.markDef[m];
    return C != null ? {
      [m]: { value: C }
    } : {
      [c]: { field: t.getName(n) }
    };
  }
  const I = RQr({
    channel: n,
    channelDef: u,
    channel2Def: r[n],
    markDef: o,
    config: a,
    scaleName: f,
    scale: h,
    stack: s,
    offset: d,
    defaultRef: void 0
  });
  return I !== void 0 ? { [c]: I } : H3(n, o) || H3(n, {
    [n]: T6(n, o, a.style),
    [l]: T6(l, o, a.style)
  }) || H3(n, a[i]) || H3(n, a.mark) || {
    [c]: fIe({
      model: t,
      defaultPos: e,
      channel: n,
      scaleName: f,
      scale: h
    })()
  };
}
function RQr({ channel: t, channelDef: e, channel2Def: n, markDef: r, config: i, scaleName: o, scale: s, stack: a, offset: A, defaultRef: l }) {
  return $r(e) && a && // If fieldChannel is X and channel is X2 (or Y and Y2)
  t.charAt(0) === a.fieldChannel.charAt(0) ? Fv(e, o, { suffix: "start" }, { offset: A }) : U0e({
    channel: t,
    channelDef: n,
    scaleName: o,
    scale: s,
    stack: a,
    markDef: r,
    config: i,
    offset: A,
    defaultRef: l
  });
}
function H3(t, e) {
  const n = ju(t), r = gE(t);
  if (e[r] !== void 0)
    return { [r]: XD(t, e[r]) };
  if (e[t] !== void 0)
    return { [r]: XD(t, e[t]) };
  if (e[n]) {
    const i = e[n];
    if (LB(i))
      Zt(b1r(n));
    else
      return { [n]: XD(t, i) };
  }
}
function pE(t, e) {
  var n, r;
  const { config: i, encoding: o, markDef: s } = t, a = s.type, A = gm(e), l = ju(e), c = o[e], u = o[A], f = t.getScaleComponent(e), h = f ? f.get("type") : void 0, d = s.orient, I = (r = (n = o[l]) !== null && n !== void 0 ? n : o.size) !== null && r !== void 0 ? r : Co("size", s, i, { vgChannel: l }), m = a === "bar" && (e === "x" ? d === "vertical" : d === "horizontal");
  return sn(c) && (Zo(c.bin) || Pc(c.bin) || c.timeUnit && !u) && !(I && !LB(I)) && !UA(h) ? NQr({
    fieldDef: c,
    fieldDef2: u,
    channel: e,
    model: t
  }) : ($r(c) && UA(h) || m) && !u ? TQr(c, e, t) : kAt(e, t, { defaultPos: "zeroOrMax", defaultPos2: "zeroOrMin" });
}
function DQr(t, e, n, r, i) {
  if (LB(i))
    if (n) {
      const s = n.get("type");
      if (s === "band") {
        let a = `bandwidth('${e}')`;
        return i.band !== 1 && (a = `${i.band} * ${a}`), { signal: `max(0.25, ${a})` };
      } else
        i.band !== 1 && (Zt(M1r(s)), i = void 0);
    } else
      return {
        mult: i.band,
        field: { group: t }
      };
  else {
    if (Jn(i))
      return i;
    if (i)
      return { value: i };
  }
  if (n) {
    const s = n.get("range");
    if (ZE(s) && Po(s.step))
      return { value: s.step - 2 };
  }
  return { value: G6(r.view, t) - 2 };
}
function TQr(t, e, n) {
  const { markDef: r, encoding: i, config: o, stack: s } = n, a = r.orient, A = n.scaleName(e), l = n.getScaleComponent(e), c = ju(e), u = gm(e), f = DBr(e), h = n.scaleName(f), d = a === "horizontal" && e === "y" || a === "vertical" && e === "x";
  let I;
  (i.size || r.size) && (d ? I = DA("size", n, {
    vgChannel: c,
    defaultRef: hs(r.size)
  }) : Zt(k1r(r.type)));
  const m = !!I, C = Pat({ channel: e, fieldDef: t, markDef: r, config: o, scaleType: l?.get("type"), useVlSizeChannel: d });
  I = I || {
    [c]: DQr(c, h || A, l, o, C)
  };
  const y = l?.get("type") === "band" && LB(C) && !m ? "top" : "middle", v = PAt(e, r, o, y), b = v === "xc" || v === "yc", { offset: Q, offsetType: w } = $N({ channel: e, markDef: r, encoding: i, model: n, bandPosition: b ? 0.5 : 0 }), R = U0e({
    channel: e,
    channelDef: t,
    markDef: r,
    config: o,
    scaleName: A,
    scale: l,
    stack: s,
    offset: Q,
    defaultRef: fIe({ model: n, defaultPos: "mid", channel: e, scaleName: A, scale: l }),
    bandPosition: b ? w === "encoding" ? 0 : 0.5 : Jn(C) ? { signal: `(1-${C})/2` } : LB(C) ? (1 - C.band) / 2 : 0
  });
  if (c)
    return Object.assign({ [v]: R }, I);
  {
    const M = gE(u), O = I[c], L = Q ? Object.assign(Object.assign({}, O), { offset: Q }) : O;
    return {
      [v]: R,
      // posRef might be an array that wraps position invalid test
      [M]: Nt(R) ? [R[0], Object.assign(Object.assign({}, R[1]), { offset: L })] : Object.assign(Object.assign({}, R), { offset: L })
    };
  }
}
function iR(t, e, n, r, i) {
  if (Fst(t))
    return 0;
  const o = t === "x" || t === "y2" ? -e / 2 : e / 2;
  if (Jn(n) || Jn(i) || Jn(r)) {
    const s = bI(n), a = bI(i), A = bI(r), l = A ? `${A} + ` : "", c = s ? `(${s} ? -1 : 1) * ` : "", u = a ? `(${a} + ${o})` : o;
    return {
      signal: l + c + u
    };
  } else
    return i = i || 0, r + (n ? -i - o : +i + o);
}
function NQr({ fieldDef: t, fieldDef2: e, channel: n, model: r }) {
  var i, o, s;
  const { config: a, markDef: A, encoding: l } = r, c = r.getScaleComponent(n), u = r.scaleName(n), f = c ? c.get("type") : void 0, h = c.get("reverse"), d = Pat({ channel: n, fieldDef: t, markDef: A, config: a, scaleType: f }), I = (i = r.component.axes[n]) === null || i === void 0 ? void 0 : i[0], m = (o = I?.get("translate")) !== null && o !== void 0 ? o : 0.5, C = GA(n) && (s = Co("binSpacing", A, a)) !== null && s !== void 0 ? s : 0, y = gm(n), v = gE(n), b = gE(y), { offset: Q } = $N({ channel: n, markDef: A, encoding: l, model: r, bandPosition: 0 }), w = Jn(d) ? { signal: `(1-${d.signal})/2` } : LB(d) ? (1 - d.band) / 2 : 0.5;
  if (Zo(t.bin) || t.timeUnit)
    return {
      [b]: cPe({
        fieldDef: t,
        scaleName: u,
        bandPosition: w,
        offset: iR(y, C, h, m, Q)
      }),
      [v]: cPe({
        fieldDef: t,
        scaleName: u,
        bandPosition: Jn(w) ? { signal: `1-${w.signal}` } : 1 - w,
        offset: iR(n, C, h, m, Q)
      })
    };
  if (Pc(t.bin)) {
    const R = Fv(t, u, {}, { offset: iR(y, C, h, m, Q) });
    if (sn(e))
      return {
        [b]: R,
        [v]: Fv(e, u, {}, { offset: iR(n, C, h, m, Q) })
      };
    if (T1(t.bin) && t.bin.step)
      return {
        [b]: R,
        [v]: {
          signal: `scale("${u}", ${fn(t, { expr: "datum" })} + ${t.bin.step})`,
          offset: iR(n, C, h, m, Q)
        }
      };
  }
  Zt(Aat(y));
}
function cPe({ fieldDef: t, scaleName: e, bandPosition: n, offset: r }) {
  return M6({
    scaleName: e,
    fieldOrDatumDef: t,
    bandPosition: n,
    offset: r
  });
}
const LQr = /* @__PURE__ */ new Set(["aria", "width", "height"]);
function eh(t, e) {
  const { fill: n = void 0, stroke: r = void 0 } = e.color === "include" ? FAt(t) : {};
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, MQr(t.markDef, e)), uPe(t, "fill", n)), uPe(t, "stroke", r)), DA("opacity", t)), DA("fillOpacity", t)), DA("strokeOpacity", t)), DA("strokeWidth", t)), DA("strokeDash", t)), _Qr(t)), MAt(t)), uIe(t, "href")), vQr(t));
}
function uPe(t, e, n) {
  const { config: r, mark: i, markDef: o } = t;
  if (Co("invalid", o, r) === "hide" && n && !ey(i)) {
    const a = OQr(t, { invalid: !0, channels: vY });
    if (a)
      return {
        [e]: [
          // prepend the invalid case
          // TODO: support custom value
          { test: a, value: null },
          ...bn(n)
        ]
      };
  }
  return n ? { [e]: n } : {};
}
function MQr(t, e) {
  return WBr.reduce((n, r) => (!LQr.has(r) && t[r] !== void 0 && e[r] !== "ignore" && (n[r] = hs(t[r])), n), {});
}
function OQr(t, { invalid: e = !1, channels: n }) {
  const r = n.reduce((o, s) => {
    const a = t.getScaleComponent(s);
    if (a) {
      const A = a.get("type"), l = t.vgField(s, { expr: "datum" });
      l && qf(A) && (o[l] = !0);
    }
    return o;
  }, {}), i = Kt(r);
  if (i.length > 0) {
    const o = e ? "||" : "&&";
    return i.map((s) => H0e(s, e)).join(` ${o} `);
  }
}
function gIe(t) {
  const { config: e, markDef: n } = t;
  if (Co("invalid", n, e)) {
    const i = FQr(t, { channels: b0 });
    if (i)
      return { defined: { signal: i } };
  }
  return {};
}
function FQr(t, { invalid: e = !1, channels: n }) {
  const r = n.reduce((o, s) => {
    var a;
    const A = t.getScaleComponent(s);
    if (A) {
      const l = A.get("type"), c = t.vgField(s, { expr: "datum", binSuffix: !((a = t.stack) === null || a === void 0) && a.impute ? "mid" : void 0 });
      c && qf(l) && (o[c] = !0);
    }
    return o;
  }, {}), i = Kt(r);
  if (i.length > 0) {
    const o = e ? "||" : "&&";
    return i.map((s) => H0e(s, e)).join(` ${o} `);
  }
}
function fPe(t, e) {
  if (e !== void 0)
    return { [t]: hs(e) };
}
const gX = "voronoi", GAt = {
  defined: (t) => t.type === "point" && t.nearest,
  parse: (t, e) => {
    if (e.events)
      for (const n of e.events)
        n.markname = t.getName(gX);
  },
  marks: (t, e, n) => {
    const { x: r, y: i } = e.project.hasChannel, o = t.mark;
    if (ey(o))
      return Zt(r1r(o)), n;
    const s = {
      name: t.getName(gX),
      type: "path",
      interactive: !0,
      from: { data: t.getName("marks") },
      encode: {
        update: Object.assign({ fill: { value: "transparent" }, strokeWidth: { value: 0.35 }, stroke: { value: "transparent" }, isVoronoi: { value: !0 } }, MAt(t, { reactiveGeom: !0 }))
      },
      transform: [
        {
          type: "voronoi",
          x: { expr: r || !i ? "datum.datum.x || 0" : "0" },
          y: { expr: i || !r ? "datum.datum.y || 0" : "0" },
          size: [t.getSizeSignalRef("width"), t.getSizeSignalRef("height")]
        }
      ]
    };
    let a = 0, A = !1;
    return n.forEach((l, c) => {
      var u;
      const f = (u = l.name) !== null && u !== void 0 ? u : "";
      f === t.component.mark[0].name ? a = c : f.indexOf(gX) >= 0 && (A = !0);
    }), A || n.splice(a + 1, 0, s), n;
  }
}, UAt = {
  defined: (t) => t.type === "point" && t.resolve === "global" && t.bind && t.bind !== "scales" && !rIe(t.bind),
  parse: (t, e, n) => JAt(e, n),
  topLevelSignals: (t, e, n) => {
    const r = e.name, i = e.project, o = e.bind, s = e.init && e.init[0], a = GAt.defined(e) ? "(item().isVoronoi ? datum.datum : datum)" : "datum";
    return i.items.forEach((A, l) => {
      var c, u;
      const f = Ls(`${r}_${A.field}`);
      n.filter((d) => d.name === f).length || n.unshift(Object.assign(Object.assign({ name: f }, s ? { init: OB(s[l]) } : { value: null }), { on: e.events ? [
        {
          events: e.events,
          update: `datum && item().mark.marktype !== 'group' ? ${a}[${an(A.field)}] : null`
        }
      ] : [], bind: (u = (c = o[A.field]) !== null && c !== void 0 ? c : o[A.channel]) !== null && u !== void 0 ? u : o }));
    }), n;
  },
  signals: (t, e, n) => {
    const r = e.name, i = e.project, o = n.filter((l) => l.name === r + IE)[0], s = r + qO, a = i.items.map((l) => Ls(`${r}_${l.field}`)), A = a.map((l) => `${l} !== null`).join(" && ");
    return a.length && (o.update = `${A} ? {fields: ${s}, values: [${a.join(", ")}]} : null`), delete o.value, delete o.on, n;
  }
}, $6 = "_toggle", HAt = {
  defined: (t) => t.type === "point" && !!t.toggle,
  signals: (t, e, n) => n.concat({
    name: e.name + $6,
    value: !1,
    on: [{ events: e.events, update: e.toggle }]
  }),
  modifyExpr: (t, e) => {
    const n = e.name + IE, r = e.name + $6;
    return `${r} ? null : ${n}, ` + (e.resolve === "global" ? `${r} ? null : true, ` : `${r} ? null : {unit: ${HQ(t)}}, `) + `${r} ? ${n} : null`;
  }
}, PQr = {
  defined: (t) => t.clear !== void 0 && t.clear !== !1,
  parse: (t, e) => {
    e.clear && (e.clear = Cn(e.clear) ? jE(e.clear, "view") : e.clear);
  },
  topLevelSignals: (t, e, n) => {
    if (UAt.defined(e))
      for (const r of e.project.items) {
        const i = n.findIndex((o) => o.name === Ls(`${e.name}_${r.field}`));
        i !== -1 && n[i].on.push({ events: e.clear, update: "null" });
      }
    return n;
  },
  signals: (t, e, n) => {
    function r(i, o) {
      i !== -1 && n[i].on && n[i].on.push({ events: e.clear, update: o });
    }
    if (e.type === "interval")
      for (const i of e.project.items) {
        const o = n.findIndex((s) => s.name === i.signals.visual);
        if (r(o, "[0, 0]"), o === -1) {
          const s = n.findIndex((a) => a.name === i.signals.data);
          r(s, "null");
        }
      }
    else {
      let i = n.findIndex((o) => o.name === e.name + IE);
      r(i, "null"), HAt.defined(e) && (i = n.findIndex((o) => o.name === e.name + $6), r(i, "false"));
    }
    return n;
  }
}, $At = {
  defined: (t) => {
    const e = t.resolve === "global" && t.bind && rIe(t.bind), n = t.project.items.length === 1 && t.project.items[0].field !== t0;
    return e && !n && Zt(s1r), e && n;
  },
  parse: (t, e, n) => {
    var r;
    const i = Kr(n);
    if (i.select = Cn(i.select) ? { type: i.select, toggle: e.toggle } : Object.assign(Object.assign({}, i.select), { toggle: e.toggle }), JAt(e, i), _n(n.select) && (n.select.on || n.select.clear)) {
      const a = 'event.item && indexof(event.item.mark.role, "legend") < 0';
      for (const A of e.events)
        A.filter = bn((r = A.filter) !== null && r !== void 0 ? r : []), A.filter.includes(a) || A.filter.push(a);
    }
    const o = cX(e.bind) ? e.bind.legend : "click", s = Cn(o) ? jE(o, "view") : bn(o);
    e.bind = { legend: { merge: s } };
  },
  topLevelSignals: (t, e, n) => {
    const r = e.name, i = cX(e.bind) && e.bind.legend, o = (s) => (a) => {
      const A = Kr(a);
      return A.markname = s, A;
    };
    for (const s of e.project.items) {
      if (!s.hasLegend)
        continue;
      const a = `${Ls(s.field)}_legend`, A = `${r}_${a}`;
      if (n.filter((c) => c.name === A).length === 0) {
        const c = i.merge.map(o(`${a}_symbols`)).concat(i.merge.map(o(`${a}_labels`))).concat(i.merge.map(o(`${a}_entries`)));
        n.unshift(Object.assign(Object.assign({ name: A }, e.init ? {} : { value: null }), { on: [
          // Legend entries do not store values, so we need to walk the scenegraph to the symbol datum.
          { events: c, update: "datum.value || item().items[0].items[0].datum.value", force: !0 },
          { events: i.merge, update: `!event.item || !datum ? null : ${A}`, force: !0 }
        ] }));
      }
    }
    return n;
  },
  signals: (t, e, n) => {
    const r = e.name, i = e.project, o = n.find((f) => f.name === r + IE), s = r + qO, a = i.items.filter((f) => f.hasLegend).map((f) => Ls(`${r}_${Ls(f.field)}_legend`)), l = `${a.map((f) => `${f} !== null`).join(" && ")} ? {fields: ${s}, values: [${a.join(", ")}]} : null`;
    e.events && a.length > 0 ? o.on.push({
      events: a.map((f) => ({ signal: f })),
      update: l
    }) : a.length > 0 && (o.update = l, delete o.value, delete o.on);
    const c = n.find((f) => f.name === r + $6), u = cX(e.bind) && e.bind.legend;
    return c && (e.events ? c.on.push(Object.assign(Object.assign({}, c.on[0]), { events: u })) : c.on[0].events = u), n;
  }
};
function kQr(t, e, n) {
  var r, i, o, s;
  const a = (r = t.fieldDef(e)) === null || r === void 0 ? void 0 : r.field;
  for (const A of rc((i = t.component.selection) !== null && i !== void 0 ? i : {})) {
    const l = (o = A.project.hasField[a]) !== null && o !== void 0 ? o : A.project.hasChannel[e];
    if (l && $At.defined(A)) {
      const c = (s = n.get("selections")) !== null && s !== void 0 ? s : [];
      c.push(A.name), n.set("selections", c, !1), l.hasLegend = !0;
    }
  }
}
const qAt = "_translate_anchor", jAt = "_translate_delta", GQr = {
  defined: (t) => t.type === "interval" && t.translate,
  signals: (t, e, n) => {
    const r = e.name, i = dE.defined(e), o = r + qAt, { x: s, y: a } = e.project.hasChannel;
    let A = jE(e.translate, "scope");
    return i || (A = A.map((l) => (l.between[0].markname = r + hS, l))), n.push({
      name: o,
      value: {},
      on: [
        {
          events: A.map((l) => l.between[0]),
          update: "{x: x(unit), y: y(unit)" + (s !== void 0 ? `, extent_x: ${i ? Moe(t, ta) : `slice(${s.signals.visual})`}` : "") + (a !== void 0 ? `, extent_y: ${i ? Moe(t, kA) : `slice(${a.signals.visual})`}` : "") + "}"
        }
      ]
    }, {
      name: r + jAt,
      value: {},
      on: [
        {
          events: A,
          update: `{x: ${o}.x - x(unit), y: ${o}.y - y(unit)}`
        }
      ]
    }), s !== void 0 && gPe(t, e, s, "width", n), a !== void 0 && gPe(t, e, a, "height", n), n;
  }
};
function gPe(t, e, n, r, i) {
  var o, s;
  const a = e.name, A = a + qAt, l = a + jAt, c = n.channel, u = dE.defined(e), f = i.filter((R) => R.name === n.signals[u ? "data" : "visual"])[0], h = t.getSizeSignalRef(r).signal, d = t.getScaleComponent(c), I = d.get("type"), m = d.get("reverse"), C = u ? c === ta ? m ? "" : "-" : m ? "-" : "" : "", y = `${A}.extent_${c}`, v = `${C}${l}.${c} / ${u ? `${h}` : `span(${y})`}`, b = u ? I === "log" ? "panLog" : I === "symlog" ? "panSymlog" : I === "pow" ? "panPow" : "panLinear" : "panLinear", Q = u ? I === "pow" ? `, ${(o = d.get("exponent")) !== null && o !== void 0 ? o : 1}` : I === "symlog" ? `, ${(s = d.get("constant")) !== null && s !== void 0 ? s : 1}` : "" : "", w = `${b}(${y}, ${v}${Q})`;
  f.on.push({
    events: { signal: l },
    update: u ? w : `clampRange(${w}, 0, ${h})`
  });
}
const YAt = "_zoom_anchor", zAt = "_zoom_delta", UQr = {
  defined: (t) => t.type === "interval" && t.zoom,
  signals: (t, e, n) => {
    const r = e.name, i = dE.defined(e), o = r + zAt, { x: s, y: a } = e.project.hasChannel, A = an(t.scaleName(ta)), l = an(t.scaleName(kA));
    let c = jE(e.zoom, "scope");
    return i || (c = c.map((u) => (u.markname = r + hS, u))), n.push({
      name: r + YAt,
      on: [
        {
          events: c,
          update: i ? "{" + [A ? `x: invert(${A}, x(unit))` : "", l ? `y: invert(${l}, y(unit))` : ""].filter((u) => !!u).join(", ") + "}" : "{x: x(unit), y: y(unit)}"
        }
      ]
    }, {
      name: o,
      on: [
        {
          events: c,
          force: !0,
          update: "pow(1.001, event.deltaY * pow(16, event.deltaMode))"
        }
      ]
    }), s !== void 0 && hPe(t, e, s, "width", n), a !== void 0 && hPe(t, e, a, "height", n), n;
  }
};
function hPe(t, e, n, r, i) {
  var o, s;
  const a = e.name, A = n.channel, l = dE.defined(e), c = i.filter((b) => b.name === n.signals[l ? "data" : "visual"])[0], u = t.getSizeSignalRef(r).signal, f = t.getScaleComponent(A), h = f.get("type"), d = l ? Moe(t, A) : c.name, I = a + zAt, m = `${a}${YAt}.${A}`, C = l ? h === "log" ? "zoomLog" : h === "symlog" ? "zoomSymlog" : h === "pow" ? "zoomPow" : "zoomLinear" : "zoomLinear", y = l ? h === "pow" ? `, ${(o = f.get("exponent")) !== null && o !== void 0 ? o : 1}` : h === "symlog" ? `, ${(s = f.get("constant")) !== null && s !== void 0 ? s : 1}` : "" : "", v = `${C}(${d}, ${m}, ${I}${y})`;
  c.on.push({
    events: { signal: I },
    update: l ? v : `clampRange(${v}, 0, ${u})`
  });
}
const FB = "_store", IE = "_tuple", HQr = "_modify", VAt = "vlSelectionResolve", UY = [
  yQr,
  CQr,
  IQr,
  HAt,
  // Bindings may disable direct manipulation.
  UAt,
  dE,
  $At,
  PQr,
  GQr,
  UQr,
  GAt
];
function $Qr(t) {
  let e = t.parent;
  for (; e && !Ad(e); )
    e = e.parent;
  return e;
}
function HQ(t, { escape: e } = { escape: !0 }) {
  let n = e ? an(t.name) : t.name;
  const r = $Qr(t);
  if (r) {
    const { facet: i } = r;
    for (const o of Rg)
      i[o] && (n += ` + '__facet_${o}_' + (facet[${an(r.vgField(o))}])`);
  }
  return n;
}
function hIe(t) {
  var e;
  return rc((e = t.component.selection) !== null && e !== void 0 ? e : {}).reduce((n, r) => n || r.project.hasSelectionId, !1);
}
function JAt(t, e) {
  (Cn(e.select) || !e.select.on) && delete t.events, (Cn(e.select) || !e.select.clear) && delete t.clear, (Cn(e.select) || !e.select.toggle) && delete t.toggle;
}
function Poe(t) {
  const e = [];
  return t.type === "Identifier" ? [t.name] : t.type === "Literal" ? [t.value] : (t.type === "MemberExpression" && (e.push(...Poe(t.object)), e.push(...Poe(t.property))), e);
}
function KAt(t) {
  return t.object.type === "MemberExpression" ? KAt(t.object) : t.object.name === "datum";
}
function WAt(t) {
  const e = Dpe(t), n = /* @__PURE__ */ new Set();
  return e.visit((r) => {
    r.type === "MemberExpression" && KAt(r) && n.add(Poe(r).slice(1).join("."));
  }), n;
}
class Dx extends Uo {
  constructor(e, n, r) {
    super(e), this.model = n, this.filter = r, this.expr = q6(this.model, this.filter, this), this._dependentFields = WAt(this.expr);
  }
  clone() {
    return new Dx(null, this.model, Kr(this.filter));
  }
  dependentFields() {
    return this._dependentFields;
  }
  producedFields() {
    return /* @__PURE__ */ new Set();
  }
  assemble() {
    return {
      type: "filter",
      expr: this.expr
    };
  }
  hash() {
    return `Filter ${this.expr}`;
  }
}
function qQr(t, e) {
  var n;
  const r = {}, i = t.config.selection;
  if (!e || !e.length)
    return r;
  for (const o of e) {
    const s = Ls(o.name), a = o.select, A = Cn(a) ? a : a.type, l = _n(a) ? Kr(a) : { type: A }, c = i[A];
    for (const f in c)
      f === "fields" || f === "encodings" || (f === "mark" && (l[f] = Object.assign(Object.assign({}, c[f]), l[f])), (l[f] === void 0 || l[f] === !0) && (l[f] = (n = c[f]) !== null && n !== void 0 ? n : l[f]));
    const u = r[s] = Object.assign(Object.assign({}, l), {
      name: s,
      type: A,
      init: o.value,
      bind: o.bind,
      events: Cn(l.on) ? jE(l.on, "scope") : bn(Kr(l.on))
    });
    for (const f of UY)
      f.defined(u) && f.parse && f.parse(t, u, o);
  }
  return r;
}
function XAt(t, e, n, r = "datum") {
  const i = Cn(e) ? e : e.param, o = Ls(i), s = an(o + FB);
  let a;
  try {
    a = t.getSelectionComponent(o, i);
  } catch {
    return `!!${o}`;
  }
  if (a.project.timeUnit) {
    const f = n ?? t.component.data.raw, h = a.project.timeUnit.clone();
    f.parent ? h.insertAsParentOf(f) : f.parent = h;
  }
  const A = a.project.hasSelectionId ? "vlSelectionIdTest(" : "vlSelectionTest(", l = a.resolve === "global" ? ")" : `, ${an(a.resolve)})`, c = `${A}${s}, ${r}${l}`, u = `length(data(${s}))`;
  return e.empty === !1 ? `${u} && ${c}` : `!${u} || ${c}`;
}
function ZAt(t, e, n) {
  const r = Ls(e), i = n.encoding;
  let o = n.field, s;
  try {
    s = t.getSelectionComponent(r, e);
  } catch {
    return r;
  }
  if (!i && !o)
    o = s.project.items[0].field, s.project.items.length > 1 && Zt(`A "field" or "encoding" must be specified when using a selection as a scale domain. Using "field": ${an(o)}.`);
  else if (i && !o) {
    const a = s.project.items.filter((A) => A.channel === i);
    !a.length || a.length > 1 ? (o = s.project.items[0].field, Zt((a.length ? "Multiple " : "No ") + `matching ${an(i)} encoding found for selection ${an(n.param)}. Using "field": ${an(o)}.`)) : o = a[0].field;
  }
  return `${s.name}[${an(Vg(o))}]`;
}
function jQr(t, e) {
  var n;
  for (const [r, i] of fE((n = t.component.selection) !== null && n !== void 0 ? n : {})) {
    const o = t.getName(`lookup_${r}`);
    t.component.data.outputNodes[o] = i.materialized = new zc(new Dx(e, t, { param: r }), o, Wo.Lookup, t.component.data.outputNodeRefCounts);
  }
}
function q6(t, e, n) {
  return WD(e, (r) => Cn(r) ? r : ybr(r) ? XAt(t, r, n) : pat(r));
}
var $3 = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function YQr(t, e) {
  if (t)
    return Nt(t) && !Zm(t) ? t.map((n) => V0e(n, e)).join(", ") : t;
}
function hX(t, e, n, r) {
  var i, o, s, a, A;
  (i = t.encode) !== null && i !== void 0 || (t.encode = {}), (o = (a = t.encode)[e]) !== null && o !== void 0 || (a[e] = {}), (s = (A = t.encode[e]).update) !== null && s !== void 0 || (A.update = {}), t.encode[e].update[n] = r;
}
function aD(t, e, n, r = { header: !1 }) {
  var i, o;
  const s = t.combine(), { disable: a, orient: A, scale: l, labelExpr: c, title: u, zindex: f } = s, h = $3(s, ["disable", "orient", "scale", "labelExpr", "title", "zindex"]);
  if (!a) {
    for (const d in h) {
      const I = b_r[d], m = h[d];
      if (I && I !== e && I !== "both")
        delete h[d];
      else if ($O(m)) {
        const { condition: C } = m, y = $3(m, ["condition"]), v = bn(C), b = jFe[d];
        if (b) {
          const { vgProp: Q, part: w } = b, R = [
            ...v.map((M) => {
              const { test: O } = M, L = $3(M, ["test"]);
              return Object.assign({ test: q6(null, O) }, L);
            }),
            y
          ];
          hX(h, w, Q, R), delete h[d];
        } else if (b === null) {
          const Q = {
            signal: v.map((w) => {
              const { test: R } = w, M = $3(w, ["test"]);
              return `${q6(null, R)} ? ${RFe(M)} : `;
            }).join("") + RFe(y)
          };
          h[d] = Q;
        }
      } else if (Jn(m)) {
        const C = jFe[d];
        if (C) {
          const { vgProp: y, part: v } = C;
          hX(h, v, y, m), delete h[d];
        }
      }
      wi(["labelAlign", "labelBaseline"], d) && h[d] === null && delete h[d];
    }
    if (e === "grid") {
      if (!h.grid)
        return;
      if (h.encode) {
        const { grid: d } = h.encode;
        h.encode = Object.assign({}, d ? { grid: d } : {}), Oo(h.encode) && delete h.encode;
      }
      return Object.assign(Object.assign({
        scale: l,
        orient: A
      }, h), {
        domain: !1,
        labels: !1,
        aria: !1,
        // Always set min/maxExtent to 0 to ensure that `config.axis*.minExtent` and `config.axis*.maxExtent`
        // would not affect gridAxis
        maxExtent: 0,
        minExtent: 0,
        ticks: !1,
        zindex: Va(f, 0)
        // put grid behind marks by default
      });
    } else {
      if (!r.header && t.mainExtracted)
        return;
      if (c !== void 0) {
        let I = c;
        !((o = (i = h.encode) === null || i === void 0 ? void 0 : i.labels) === null || o === void 0) && o.update && Jn(h.encode.labels.update.text) && (I = RB(c, "datum.label", h.encode.labels.update.text.signal)), hX(h, "labels", "text", { signal: I });
      }
      if (h.labelAlign === null && delete h.labelAlign, h.encode) {
        for (const I of zat)
          t.hasAxisPart(I) || delete h.encode[I];
        Oo(h.encode) && delete h.encode;
      }
      const d = YQr(u, n);
      return Object.assign(Object.assign(Object.assign(Object.assign({
        scale: l,
        orient: A,
        grid: !1
      }, d ? { title: d } : {}), h), n.aria === !1 ? { aria: !1 } : {}), {
        zindex: Va(f, 0)
        // put axis line above marks by default
      });
    }
  }
}
function elt(t) {
  const { axes: e } = t.component, n = [];
  for (const r of b0)
    if (e[r]) {
      for (const i of e[r])
        if (!i.get("disable") && !i.get("gridScale")) {
          const o = r === "x" ? "height" : "width", s = t.getSizeSignalRef(o).signal;
          o !== s && n.push({
            name: o,
            update: s
          });
        }
    }
  return n;
}
function zQr(t, e) {
  const { x: n = [], y: r = [] } = t;
  return [
    ...n.map((i) => aD(i, "grid", e)),
    ...r.map((i) => aD(i, "grid", e)),
    ...n.map((i) => aD(i, "main", e)),
    ...r.map((i) => aD(i, "main", e))
  ].filter((i) => i);
}
function dPe(t, e, n, r) {
  return Object.assign.apply(null, [
    {},
    ...t.map((i) => {
      if (i === "axisOrient") {
        const o = n === "x" ? "bottom" : "left", s = e[n === "x" ? "axisBottom" : "axisLeft"] || {}, a = e[n === "x" ? "axisTop" : "axisRight"] || {}, A = /* @__PURE__ */ new Set([...Kt(s), ...Kt(a)]), l = {};
        for (const c of A.values())
          l[c] = {
            // orient is surely signal in this case
            signal: `${r.signal} === "${o}" ? ${bI(s[c])} : ${bI(a[c])}`
          };
        return l;
      }
      return e[i];
    })
  ]);
}
function VQr(t, e, n, r) {
  const i = e === "band" ? ["axisDiscrete", "axisBand"] : e === "point" ? ["axisDiscrete", "axisPoint"] : Eat(e) ? ["axisQuantitative"] : e === "time" || e === "utc" ? ["axisTemporal"] : [], o = t === "x" ? "axisX" : "axisY", s = Jn(n) ? "axisOrient" : `axis${TO(n)}`, a = [
    // technically Vega does have axisBand, but if we make another separation here,
    // it will further introduce complexity in the code
    ...i,
    ...i.map((l) => o + l.substr(4))
  ], A = ["axis", s, o];
  return {
    vlOnlyAxisConfig: dPe(a, r, t, n),
    vgAxisConfig: dPe(A, r, t, n),
    axisConfigStyle: JQr([...A, ...a], r)
  };
}
function JQr(t, e) {
  var n;
  const r = [{}];
  for (const i of t) {
    let o = (n = e[i]) === null || n === void 0 ? void 0 : n.style;
    if (o) {
      o = bn(o);
      for (const s of o)
        r.push(e.style[s]);
    }
  }
  return Object.assign.apply(null, r);
}
function koe(t, e, n, r = {}) {
  var i;
  const o = Xst(t, n, e);
  if (o !== void 0)
    return {
      configFrom: "style",
      configValue: o
    };
  for (const s of ["vlOnlyAxisConfig", "vgAxisConfig", "axisConfigStyle"])
    if (((i = r[s]) === null || i === void 0 ? void 0 : i[t]) !== void 0)
      return { configFrom: s, configValue: r[s][t] };
  return {};
}
const pPe = {
  scale: ({ model: t, channel: e }) => t.scaleName(e),
  format: ({ fieldOrDatumDef: t, config: e, axis: n }) => {
    const { format: r, formatType: i } = n;
    return Tat(t, t.type, r, i, e, !0);
  },
  formatType: ({ axis: t, fieldOrDatumDef: e, scaleType: n }) => {
    const { formatType: r } = t;
    return Nat(r, e, n);
  },
  grid: ({ fieldOrDatumDef: t, axis: e, scaleType: n }) => {
    var r;
    return (r = e.grid) !== null && r !== void 0 ? r : KQr(n, t);
  },
  gridScale: ({ model: t, channel: e }) => WQr(t, e),
  labelAlign: ({ axis: t, labelAngle: e, orient: n, channel: r }) => t.labelAlign || nlt(e, n, r),
  labelAngle: ({ labelAngle: t }) => t,
  labelBaseline: ({ axis: t, labelAngle: e, orient: n, channel: r }) => t.labelBaseline || tlt(e, n, r),
  labelFlush: ({ axis: t, fieldOrDatumDef: e, channel: n }) => {
    var r;
    return (r = t.labelFlush) !== null && r !== void 0 ? r : ZQr(e.type, n);
  },
  labelOverlap: ({ axis: t, fieldOrDatumDef: e, scaleType: n }) => {
    var r;
    return (r = t.labelOverlap) !== null && r !== void 0 ? r : ewr(e.type, n, sn(e) && !!e.timeUnit, sn(e) ? e.sort : void 0);
  },
  // we already calculate orient in parse
  orient: ({ orient: t }) => t,
  tickCount: ({ channel: t, model: e, axis: n, fieldOrDatumDef: r, scaleType: i }) => {
    var o;
    const s = t === "x" ? "width" : t === "y" ? "height" : void 0, a = s ? e.getSizeSignalRef(s) : void 0;
    return (o = n.tickCount) !== null && o !== void 0 ? o : nwr({ fieldOrDatumDef: r, scaleType: i, size: a, values: n.values });
  },
  title: ({ axis: t, model: e, channel: n }) => {
    if (t.title !== void 0)
      return t.title;
    const r = rlt(e, n);
    if (r !== void 0)
      return r;
    const i = e.typedFieldDef(n), o = n === "x" ? "x2" : "y2", s = e.fieldDef(o);
    return eat(i ? [qFe(i)] : [], sn(s) ? [qFe(s)] : []);
  },
  values: ({ axis: t, fieldOrDatumDef: e }) => rwr(t, e),
  zindex: ({ axis: t, fieldOrDatumDef: e, mark: n }) => {
    var r;
    return (r = t.zindex) !== null && r !== void 0 ? r : iwr(n, e);
  }
};
function KQr(t, e) {
  return !UA(t) && sn(e) && !Zo(e?.bin) && !Pc(e?.bin);
}
function WQr(t, e) {
  const n = e === "x" ? "y" : "x";
  if (t.getScaleComponent(n))
    return t.scaleName(n);
}
function XQr(t, e, n, r, i) {
  const o = e?.labelAngle;
  if (o !== void 0)
    return Jn(o) ? o : GN(o);
  {
    const { configValue: s } = koe("labelAngle", r, e?.style, i);
    return s !== void 0 ? GN(s) : n === ta && wi([F0e, O0e], t.type) && !(sn(t) && t.timeUnit) ? 270 : void 0;
  }
}
function Goe(t) {
  return `(((${t.signal} % 360) + 360) % 360)`;
}
function tlt(t, e, n, r) {
  if (t !== void 0)
    if (n === "x") {
      if (Jn(t)) {
        const i = Goe(t), o = Jn(e) ? `(${e.signal} === "top")` : e === "top";
        return {
          signal: `(45 < ${i} && ${i} < 135) || (225 < ${i} && ${i} < 315) ? "middle" :(${i} <= 45 || 315 <= ${i}) === ${o} ? "bottom" : "top"`
        };
      }
      if (45 < t && t < 135 || 225 < t && t < 315)
        return "middle";
      if (Jn(e)) {
        const i = t <= 45 || 315 <= t ? "===" : "!==";
        return { signal: `${e.signal} ${i} "top" ? "bottom" : "top"` };
      }
      return (t <= 45 || 315 <= t) == (e === "top") ? "bottom" : "top";
    } else {
      if (Jn(t)) {
        const i = Goe(t), o = Jn(e) ? `(${e.signal} === "left")` : e === "left";
        return {
          signal: `${i} <= 45 || 315 <= ${i} || (135 <= ${i} && ${i} <= 225) ? ${r ? '"middle"' : "null"} : (45 <= ${i} && ${i} <= 135) === ${o} ? "top" : "bottom"`
        };
      }
      if (t <= 45 || 315 <= t || 135 <= t && t <= 225)
        return r ? "middle" : null;
      if (Jn(e)) {
        const i = 45 <= t && t <= 135 ? "===" : "!==";
        return { signal: `${e.signal} ${i} "left" ? "top" : "bottom"` };
      }
      return (45 <= t && t <= 135) == (e === "left") ? "top" : "bottom";
    }
}
function nlt(t, e, n) {
  if (t === void 0)
    return;
  const r = n === "x", i = r ? 0 : 90, o = r ? "bottom" : "left";
  if (Jn(t)) {
    const s = Goe(t), a = Jn(e) ? `(${e.signal} === "${o}")` : e === o;
    return {
      signal: `(${i ? `(${s} + 90)` : s} % 180 === 0) ? ${r ? null : '"center"'} :(${i} < ${s} && ${s} < ${180 + i}) === ${a} ? "left" : "right"`
    };
  }
  if ((t + i) % 180 === 0)
    return r ? null : "center";
  if (Jn(e)) {
    const s = i < t && t < 180 + i ? "===" : "!==";
    return {
      signal: `${`${e.signal} ${s} "${o}"`} ? "left" : "right"`
    };
  }
  return (i < t && t < 180 + i) == (e === o) ? "left" : "right";
}
function ZQr(t, e) {
  if (e === "x" && wi(["quantitative", "temporal"], t))
    return !0;
}
function ewr(t, e, n, r) {
  if (n && !_n(r) || t !== "nominal" && t !== "ordinal")
    return e === "log" || e === "symlog" ? "greedy" : !0;
}
function twr(t) {
  return t === "x" ? "bottom" : "left";
}
function nwr({ fieldOrDatumDef: t, scaleType: e, size: n, values: r }) {
  var i;
  if (!r && !UA(e) && e !== "log") {
    if (sn(t)) {
      if (Zo(t.bin))
        return { signal: `ceil(${n.signal}/10)` };
      if (t.timeUnit && wi(["month", "hours", "day", "quarter"], (i = cc(t.timeUnit)) === null || i === void 0 ? void 0 : i.unit))
        return;
    }
    return { signal: `ceil(${n.signal}/40)` };
  }
}
function rlt(t, e) {
  const n = e === "x" ? "x2" : "y2", r = t.fieldDef(e), i = t.fieldDef(n), o = r ? r.title : void 0, s = i ? i.title : void 0;
  if (o && s)
    return tat(o, s);
  if (o)
    return o;
  if (s)
    return s;
  if (o !== void 0)
    return o;
  if (s !== void 0)
    return s;
}
function rwr(t, e) {
  const n = t.values;
  if (Nt(n))
    return Yat(e, n);
  if (Jn(n))
    return n;
}
function iwr(t, e) {
  return t === "rect" && O6(e) ? 1 : 0;
}
class $Q extends Uo {
  constructor(e, n) {
    super(e), this.transform = n, this._dependentFields = WAt(this.transform.calculate);
  }
  clone() {
    return new $Q(null, Kr(this.transform));
  }
  static parseAllForSortIndex(e, n) {
    return n.forEachFieldDef((r, i) => {
      if (L1(r) && Oat(r.sort)) {
        const { field: o, timeUnit: s } = r, a = r.sort, A = a.map((l, c) => `${pat({ field: o, timeUnit: s, equal: l })} ? ${c} : `).join("") + a.length;
        e = new $Q(e, {
          calculate: A,
          as: qQ(r, i, { forAs: !0 })
        });
      }
    }), e;
  }
  producedFields() {
    return /* @__PURE__ */ new Set([this.transform.as]);
  }
  dependentFields() {
    return this._dependentFields;
  }
  assemble() {
    return {
      type: "formula",
      expr: this.transform.calculate,
      as: this.transform.as
    };
  }
  hash() {
    return `Calculate ${_i(this.transform)}`;
  }
}
function qQ(t, e, n) {
  return fn(t, Object.assign({ prefix: e, suffix: "sort_index" }, n ?? {}));
}
function HY(t, e) {
  return wi(["top", "bottom"], e) ? "column" : wi(["left", "right"], e) || t === "row" ? "row" : "column";
}
function jQ(t, e, n, r) {
  const i = r === "row" ? n.headerRow : r === "column" ? n.headerColumn : n.headerFacet;
  return Va((e || {})[t], i[t], n.header[t]);
}
function $Y(t, e, n, r) {
  const i = {};
  for (const o of t) {
    const s = jQ(o, e || {}, n, r);
    s !== void 0 && (i[o] = s);
  }
  return i;
}
const dIe = ["row", "column"], pIe = ["header", "footer"];
function owr(t, e) {
  const n = t.component.layoutHeaders[e].title, r = t.config ? t.config : void 0, i = t.component.layoutHeaders[e].facetFieldDef ? t.component.layoutHeaders[e].facetFieldDef : void 0, { titleAnchor: o, titleAngle: s, titleOrient: a } = $Y(["titleAnchor", "titleAngle", "titleOrient"], i.header, r, e), A = HY(e, a), l = GN(s);
  return {
    name: `${e}-title`,
    type: "group",
    role: `${A}-title`,
    title: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ text: n }, e === "row" ? { orient: "left" } : {}), { style: "guide-title" }), olt(l, A)), ilt(A, l, o)), slt(r, i, e, z_r, cAt))
  };
}
function ilt(t, e, n = "middle") {
  switch (n) {
    case "start":
      return { align: "left" };
    case "end":
      return { align: "right" };
  }
  const r = nlt(e, t === "row" ? "left" : "top", t === "row" ? "y" : "x");
  return r ? { align: r } : {};
}
function olt(t, e) {
  const n = tlt(t, e === "row" ? "left" : "top", e === "row" ? "y" : "x", !0);
  return n ? { baseline: n } : {};
}
function swr(t, e) {
  const n = t.component.layoutHeaders[e], r = [];
  for (const i of pIe)
    if (n[i])
      for (const o of n[i]) {
        const s = Awr(t, e, i, n, o);
        s != null && r.push(s);
      }
  return r;
}
function awr(t, e) {
  var n;
  const { sort: r } = t;
  return Pp(r) ? {
    field: fn(r, { expr: "datum" }),
    order: (n = r.order) !== null && n !== void 0 ? n : "ascending"
  } : Nt(r) ? {
    field: qQ(t, e, { expr: "datum" }),
    order: "ascending"
  } : {
    field: fn(t, { expr: "datum" }),
    order: r ?? "ascending"
  };
}
function Uoe(t, e, n) {
  const { format: r, formatType: i, labelAngle: o, labelAnchor: s, labelOrient: a, labelExpr: A } = $Y(["format", "formatType", "labelAngle", "labelAnchor", "labelOrient", "labelExpr"], t.header, n, e), l = q0e({
    fieldOrDatumDef: t,
    format: r,
    formatType: i,
    expr: "parent",
    config: n
  }).signal, c = HY(e, a);
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ text: {
    signal: A ? RB(RB(A, "datum.label", l), "datum.value", fn(t, { expr: "parent" })) : l
  } }, e === "row" ? { orient: "left" } : {}), { style: "guide-label", frame: "group" }), olt(o, c)), ilt(c, o, s)), slt(n, t, e, V_r, uAt));
}
function Awr(t, e, n, r, i) {
  if (i) {
    let o = null;
    const { facetFieldDef: s } = r, a = t.config ? t.config : void 0;
    if (s && i.labels) {
      const { labelOrient: u } = $Y(["labelOrient"], s.header, a, e);
      (e === "row" && !wi(["top", "bottom"], u) || e === "column" && !wi(["left", "right"], u)) && (o = Uoe(s, e, a));
    }
    const A = Ad(t) && !GO(t.facet), l = i.axes, c = l?.length > 0;
    if (o || c) {
      const u = e === "row" ? "height" : "width";
      return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ name: t.getName(`${e}_${n}`), type: "group", role: `${e}-${n}` }, r.facetFieldDef ? {
        from: { data: t.getName(`${e}_domain`) },
        sort: awr(s, e)
      } : {}), c && A ? {
        from: { data: t.getName(`facet_domain_${e}`) }
      } : {}), o ? { title: o } : {}), i.sizeSignal ? {
        encode: {
          update: {
            [u]: i.sizeSignal
          }
        }
      } : {}), c ? { axes: l } : {});
    }
  }
  return null;
}
const lwr = {
  column: {
    start: 0,
    end: 1
  },
  row: {
    start: 1,
    end: 0
  }
};
function cwr(t, e) {
  return lwr[e][t];
}
function uwr(t, e) {
  const n = {};
  for (const r of Rg) {
    const i = t[r];
    if (i?.facetFieldDef) {
      const { titleAnchor: o, titleOrient: s } = $Y(["titleAnchor", "titleOrient"], i.facetFieldDef.header, e, r), a = HY(r, s), A = cwr(o, a);
      A !== void 0 && (n[a] = A);
    }
  }
  return Oo(n) ? void 0 : n;
}
function slt(t, e, n, r, i) {
  const o = {};
  for (const s of r) {
    if (!i[s])
      continue;
    const a = jQ(s, e?.header, t, n);
    a !== void 0 && (o[i[s]] = a);
  }
  return o;
}
function IIe(t) {
  return [
    ...q3(t, "width"),
    ...q3(t, "height"),
    ...q3(t, "childWidth"),
    ...q3(t, "childHeight")
  ];
}
function q3(t, e) {
  const n = e === "width" ? "x" : "y", r = t.component.layoutSize.get(e);
  if (!r || r === "merged")
    return [];
  const i = t.getSizeSignalRef(e).signal;
  if (r === "step") {
    const o = t.getScaleComponent(n);
    if (o) {
      const s = o.get("type"), a = o.get("range");
      if (UA(s) && ZE(a)) {
        const A = t.scaleName(n);
        return Ad(t.parent) && t.parent.component.resolve.scale[n] === "independent" ? [IPe(A, a)] : [
          IPe(A, a),
          {
            name: i,
            update: alt(A, o, `domain('${A}').length`)
          }
        ];
      }
    }
    throw new Error("layout size is step although width/height is not step.");
  } else if (r == "container") {
    const o = i.endsWith("width"), s = o ? "containerSize()[0]" : "containerSize()[1]", a = Doe(t.config.view, o ? "width" : "height"), A = `isFinite(${s}) ? ${s} : ${a}`;
    return [{ name: i, init: A, on: [{ update: A, events: "window:resize" }] }];
  } else
    return [
      {
        name: i,
        value: r
      }
    ];
}
function IPe(t, e) {
  const n = `${t}_step`;
  return Jn(e.step) ? { name: n, update: e.step.signal } : { name: n, value: e.step };
}
function alt(t, e, n) {
  const r = e.get("type"), i = e.get("padding"), o = Va(e.get("paddingOuter"), i);
  let s = e.get("paddingInner");
  return s = r === "band" ? (
    // only band has real paddingInner
    s !== void 0 ? s : i
  ) : (
    // For point, as calculated in https://github.com/vega/vega-scale/blob/master/src/band.js#L128,
    // it's equivalent to have paddingInner = 1 since there is only n-1 steps between n points.
    1
  ), `bandspace(${n}, ${bI(s)}, ${bI(o)}) * ${t}_step`;
}
function Alt(t) {
  return t === "childWidth" ? "width" : t === "childHeight" ? "height" : t;
}
function llt(t, e) {
  return Kt(t).reduce((n, r) => {
    const i = t[r];
    return Object.assign(Object.assign({}, n), Rx(e, i, r, (o) => hs(o.value)));
  }, {});
}
function clt(t, e) {
  if (Ad(e))
    return t === "theta" ? "independent" : "shared";
  if (Lx(e))
    return "shared";
  if (bIe(e))
    return GA(t) || t === "theta" || t === "radius" ? "independent" : "shared";
  throw new Error("invalid model type for resolve");
}
function mIe(t, e) {
  const n = t.scale[e], r = GA(e) ? "axis" : "legend";
  return n === "independent" ? (t[r][e] === "shared" && Zt(q1r(e)), "independent") : t[r][e] || "shared";
}
const fwr = Object.assign(Object.assign({}, W_r), {
  disable: 1,
  labelExpr: 1,
  selections: 1,
  // channel scales
  opacity: 1,
  shape: 1,
  stroke: 1,
  fill: 1,
  size: 1,
  strokeWidth: 1,
  strokeDash: 1,
  // encode
  encode: 1
}), ult = Kt(fwr);
class gwr extends dm {
}
const mPe = {
  symbols: hwr,
  gradient: dwr,
  labels: pwr,
  entries: Iwr
};
function hwr(t, { fieldOrDatumDef: e, model: n, channel: r, legendCmpt: i, legendType: o }) {
  var s, a, A, l, c, u, f, h;
  if (o !== "symbol")
    return;
  const { markDef: d, encoding: I, config: m, mark: C } = n, y = d.filled && C !== "trail";
  let v = Object.assign(Object.assign({}, e1r({}, n, zbr)), FAt(n, { filled: y }));
  const b = (s = i.get("symbolOpacity")) !== null && s !== void 0 ? s : m.legend.symbolOpacity, Q = (a = i.get("symbolFillColor")) !== null && a !== void 0 ? a : m.legend.symbolFillColor, w = (A = i.get("symbolStrokeColor")) !== null && A !== void 0 ? A : m.legend.symbolStrokeColor, R = b === void 0 ? (l = flt(I.opacity)) !== null && l !== void 0 ? l : d.opacity : void 0;
  if (v.fill) {
    if (r === "fill" || y && r === $u)
      delete v.fill;
    else if (v.fill.field)
      Q ? delete v.fill : (v.fill = hs((c = m.legend.symbolBaseFillColor) !== null && c !== void 0 ? c : "black"), v.fillOpacity = hs(R ?? 1));
    else if (Nt(v.fill)) {
      const M = (h = (f = Hoe((u = I.fill) !== null && u !== void 0 ? u : I.color)) !== null && f !== void 0 ? f : d.fill) !== null && h !== void 0 ? h : y && d.color;
      M && (v.fill = hs(M));
    }
  }
  if (v.stroke) {
    if (r === "stroke" || !y && r === $u)
      delete v.stroke;
    else if (v.stroke.field || w)
      delete v.stroke;
    else if (Nt(v.stroke)) {
      const M = Va(Hoe(I.stroke || I.color), d.stroke, y ? d.color : void 0);
      M && (v.stroke = { value: M });
    }
  }
  if (r !== fm) {
    const M = sn(e) && hlt(n, i, e);
    M ? v.opacity = [
      Object.assign({ test: M }, hs(R ?? 1)),
      hs(m.legend.unselectedOpacity)
    ] : R && (v.opacity = hs(R));
  }
  return v = Object.assign(Object.assign({}, v), t), Oo(v) ? void 0 : v;
}
function dwr(t, { model: e, legendType: n, legendCmpt: r }) {
  var i;
  if (n !== "gradient")
    return;
  const { config: o, markDef: s, encoding: a } = e;
  let A = {};
  const c = ((i = r.get("gradientOpacity")) !== null && i !== void 0 ? i : o.legend.gradientOpacity) === void 0 ? flt(a.opacity) || s.opacity : void 0;
  return c && (A.opacity = hs(c)), A = Object.assign(Object.assign({}, A), t), Oo(A) ? void 0 : A;
}
function pwr(t, { fieldOrDatumDef: e, model: n, channel: r, legendCmpt: i }) {
  const o = n.legend(r) || {}, s = n.config, a = sn(e) ? hlt(n, i, e) : void 0, A = a ? [{ test: a, value: 1 }, { value: s.legend.unselectedOpacity }] : void 0, { format: l, formatType: c } = o;
  let u;
  MB(c) ? u = Zh({
    fieldOrDatumDef: e,
    field: "datum.value",
    format: l,
    formatType: c,
    config: s
  }) : l === void 0 && c === void 0 && s.customFormatTypes && (e.type === "quantitative" && s.numberFormatType ? u = Zh({
    fieldOrDatumDef: e,
    field: "datum.value",
    format: s.numberFormat,
    formatType: s.numberFormatType,
    config: s
  }) : e.type === "temporal" && s.timeFormatType && sn(e) && e.timeUnit === void 0 && (u = Zh({
    fieldOrDatumDef: e,
    field: "datum.value",
    format: s.timeFormat,
    formatType: s.timeFormatType,
    config: s
  })));
  const f = Object.assign(Object.assign(Object.assign({}, A ? { opacity: A } : {}), u ? { text: u } : {}), t);
  return Oo(f) ? void 0 : f;
}
function Iwr(t, { legendCmpt: e }) {
  const n = e.get("selections");
  return n?.length ? Object.assign(Object.assign({}, t), { fill: { value: "transparent" } }) : t;
}
function flt(t) {
  return glt(t, (e, n) => Math.max(e, n.value));
}
function Hoe(t) {
  return glt(t, (e, n) => Va(e, n.value));
}
function glt(t, e) {
  if (f_r(t))
    return bn(t.condition).reduce(e, t.value);
  if (Cd(t))
    return t.value;
}
function hlt(t, e, n) {
  const r = e.get("selections");
  if (!r?.length)
    return;
  const i = an(n.field);
  return r.map((o) => `(!length(data(${an(Ls(o) + FB)})) || (${o}[${i}] && indexof(${o}[${i}], datum.value) >= 0))`).join(" || ");
}
const CPe = {
  direction: ({ direction: t }) => t,
  format: ({ fieldOrDatumDef: t, legend: e, config: n }) => {
    const { format: r, formatType: i } = e;
    return Tat(t, t.type, r, i, n, !1);
  },
  formatType: ({ legend: t, fieldOrDatumDef: e, scaleType: n }) => {
    const { formatType: r } = t;
    return Nat(r, e, n);
  },
  gradientLength: (t) => {
    var e, n;
    const { legend: r, legendConfig: i } = t;
    return (n = (e = r.gradientLength) !== null && e !== void 0 ? e : i.gradientLength) !== null && n !== void 0 ? n : bwr(t);
  },
  labelOverlap: ({ legend: t, legendConfig: e, scaleType: n }) => {
    var r, i;
    return (i = (r = t.labelOverlap) !== null && r !== void 0 ? r : e.labelOverlap) !== null && i !== void 0 ? i : _wr(n);
  },
  symbolType: ({ legend: t, markDef: e, channel: n, encoding: r }) => {
    var i;
    return (i = t.symbolType) !== null && i !== void 0 ? i : Cwr(e.type, n, r.shape, e.shape);
  },
  title: ({ fieldOrDatumDef: t, config: e }) => gS(t, e, { allowDisabling: !0 }),
  type: ({ legendType: t, scaleType: e, channel: n }) => {
    if (fS(n) && Xh(e)) {
      if (t === "gradient")
        return;
    } else if (t === "symbol")
      return;
    return t;
  },
  values: ({ fieldOrDatumDef: t, legend: e }) => mwr(e, t)
};
function mwr(t, e) {
  const n = t.values;
  if (Nt(n))
    return Yat(e, n);
  if (Jn(n))
    return n;
}
function Cwr(t, e, n, r) {
  var i;
  if (e !== "shape") {
    const o = (i = Hoe(n)) !== null && i !== void 0 ? i : r;
    if (o)
      return o;
  }
  switch (t) {
    case "bar":
    case "rect":
    case "image":
    case "square":
      return "square";
    case "line":
    case "trail":
    case "rule":
      return "stroke";
    case "arc":
    case "point":
    case "circle":
    case "tick":
    case "geoshape":
    case "area":
    case "text":
      return "circle";
  }
}
function Ewr(t) {
  const { legend: e } = t;
  return Va(e.type, ywr(t));
}
function ywr({ channel: t, timeUnit: e, scaleType: n }) {
  if (fS(t)) {
    if (wi(["quarter", "month", "day"], e))
      return "symbol";
    if (Xh(n))
      return "gradient";
  }
  return "symbol";
}
function vwr({ legendConfig: t, legendType: e, orient: n, legend: r }) {
  var i, o;
  return (o = (i = r.direction) !== null && i !== void 0 ? i : t[e ? "gradientDirection" : "symbolDirection"]) !== null && o !== void 0 ? o : Bwr(n, e);
}
function Bwr(t, e) {
  switch (t) {
    case "top":
    case "bottom":
      return "horizontal";
    case "left":
    case "right":
    case "none":
    case void 0:
      return;
    default:
      return e === "gradient" ? "horizontal" : void 0;
  }
}
function bwr({ legendConfig: t, model: e, direction: n, orient: r, scaleType: i }) {
  const { gradientHorizontalMaxLength: o, gradientHorizontalMinLength: s, gradientVerticalMaxLength: a, gradientVerticalMinLength: A } = t;
  if (Xh(i))
    return n === "horizontal" ? r === "top" || r === "bottom" ? EPe(e, "width", s, o) : s : EPe(e, "height", A, a);
}
function EPe(t, e, n, r) {
  return { signal: `clamp(${t.getSizeSignalRef(e).signal}, ${n}, ${r})` };
}
function _wr(t) {
  if (wi(["quantile", "threshold", "log", "symlog"], t))
    return "greedy";
}
function dlt(t) {
  const e = $a(t) ? Swr(t) : Rwr(t);
  return t.component.legends = e, e;
}
function Swr(t) {
  const { encoding: e } = t, n = {};
  for (const r of [$u, ...gAt]) {
    const i = gA(e[r]);
    !i || !t.getScaleComponent(r) || r === qu && sn(i) && i.type === xx || (n[r] = xwr(t, r));
  }
  return n;
}
function Qwr(t, e) {
  const n = t.scaleName(e);
  if (t.mark === "trail") {
    if (e === "color")
      return { stroke: n };
    if (e === "size")
      return { strokeWidth: n };
  }
  return e === "color" ? t.markDef.filled ? { fill: n } : { stroke: n } : { [e]: n };
}
function wwr(t, e, n, r) {
  switch (e) {
    case "disable":
      return n !== void 0;
    case "values":
      return !!n?.values;
    case "title":
      if (e === "title" && t === r?.title)
        return !0;
  }
  return t === (n || {})[e];
}
function xwr(t, e) {
  var n, r, i;
  let o = t.legend(e);
  const { markDef: s, encoding: a, config: A } = t, l = A.legend, c = new gwr({}, Qwr(t, e));
  kQr(t, e, c);
  const u = o !== void 0 ? !o : l.disable;
  if (c.set("disable", u, o !== void 0), u)
    return c;
  o = o || {};
  const f = t.getScaleComponent(e).get("type"), h = gA(a[e]), d = sn(h) ? (n = cc(h.timeUnit)) === null || n === void 0 ? void 0 : n.unit : void 0, I = o.orient || A.legend.orient || "right", m = Ewr({ legend: o, channel: e, timeUnit: d, scaleType: f }), C = vwr({ legend: o, legendType: m, orient: I, legendConfig: l }), y = {
    legend: o,
    channel: e,
    model: t,
    markDef: s,
    encoding: a,
    fieldOrDatumDef: h,
    legendConfig: l,
    config: A,
    scaleType: f,
    orient: I,
    legendType: m,
    direction: C
  };
  for (const R of ult) {
    if (m === "gradient" && R.startsWith("symbol") || m === "symbol" && R.startsWith("gradient"))
      continue;
    const M = R in CPe ? CPe[R](y) : o[R];
    if (M !== void 0) {
      const O = wwr(M, R, o, t.fieldDef(e));
      (O || A.legend[R] === void 0) && c.set(R, M, O);
    }
  }
  const v = (r = o?.encoding) !== null && r !== void 0 ? r : {}, b = c.get("selections"), Q = {}, w = { fieldOrDatumDef: h, model: t, channel: e, legendCmpt: c, legendType: m };
  for (const R of ["labels", "legend", "title", "symbols", "gradient", "entries"]) {
    const M = llt((i = v[R]) !== null && i !== void 0 ? i : {}, t), O = R in mPe ? mPe[R](M, w) : M;
    O !== void 0 && !Oo(O) && (Q[R] = Object.assign(Object.assign(Object.assign({}, b?.length && sn(h) ? { name: `${Ls(h.field)}_legend_${R}` } : {}), b?.length ? { interactive: !!b } : {}), { update: O }));
  }
  return Oo(Q) || c.set("encode", Q, !!o?.encoding), c;
}
function Rwr(t) {
  const { legends: e, resolve: n } = t.component;
  for (const r of t.children) {
    dlt(r);
    for (const i of Kt(r.component.legends))
      n.legend[i] = mIe(t.component.resolve, i), n.legend[i] === "shared" && (e[i] = plt(e[i], r.component.legends[i]), e[i] || (n.legend[i] = "independent", delete e[i]));
  }
  for (const r of Kt(e))
    for (const i of t.children)
      i.component.legends[r] && n.legend[r] === "shared" && delete i.component.legends[r];
  return e;
}
function plt(t, e) {
  var n, r, i, o;
  if (!t)
    return e.clone();
  const s = t.getWithExplicit("orient"), a = e.getWithExplicit("orient");
  if (s.explicit && a.explicit && s.value !== a.value)
    return;
  let A = !1;
  for (const l of ult) {
    const c = hE(
      t.getWithExplicit(l),
      e.getWithExplicit(l),
      l,
      "legend",
      // Tie breaker function
      (u, f) => {
        switch (l) {
          case "symbolType":
            return Dwr(u, f);
          case "title":
            return nat(u, f);
          case "type":
            return A = !0, df("symbol");
        }
        return kY(u, f, l, "legend");
      }
    );
    t.setWithExplicit(l, c);
  }
  return A && (!((r = (n = t.implicit) === null || n === void 0 ? void 0 : n.encode) === null || r === void 0) && r.gradient && D6(t.implicit, ["encode", "gradient"]), !((o = (i = t.explicit) === null || i === void 0 ? void 0 : i.encode) === null || o === void 0) && o.gradient && D6(t.explicit, ["encode", "gradient"])), t;
}
function Dwr(t, e) {
  return e.value === "circle" ? e : t;
}
var Twr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function Nwr(t, e, n, r) {
  var i, o, s, a, A;
  (i = t.encode) !== null && i !== void 0 || (t.encode = {}), (o = (a = t.encode)[e]) !== null && o !== void 0 || (a[e] = {}), (s = (A = t.encode[e]).update) !== null && s !== void 0 || (A.update = {}), t.encode[e].update[n] = r;
}
function Ilt(t) {
  const e = t.component.legends, n = {};
  for (const i of Kt(e)) {
    const o = t.getScaleComponent(i), s = Xo(o.get("domains"));
    if (n[s])
      for (const a of n[s])
        plt(a, e[i]) || n[s].push(e[i]);
    else
      n[s] = [e[i].clone()];
  }
  return rc(n).flat().map((i) => Lwr(i, t.config)).filter((i) => i !== void 0);
}
function Lwr(t, e) {
  var n, r, i;
  const o = t.combine(), { disable: s, labelExpr: a, selections: A } = o, l = Twr(o, ["disable", "labelExpr", "selections"]);
  if (!s) {
    if (e.aria === !1 && l.aria == null && (l.aria = !1), !((n = l.encode) === null || n === void 0) && n.symbols) {
      const c = l.encode.symbols.update;
      c.fill && c.fill.value !== "transparent" && !c.stroke && !l.stroke && (c.stroke = { value: "transparent" });
      for (const u of gAt)
        l[u] && delete c[u];
    }
    if (l.title || delete l.title, a !== void 0) {
      let c = a;
      !((i = (r = l.encode) === null || r === void 0 ? void 0 : r.labels) === null || i === void 0) && i.update && Jn(l.encode.labels.update.text) && (c = RB(a, "datum.label", l.encode.labels.update.text.signal)), Nwr(l, "labels", "text", { signal: c });
    }
    return l;
  }
}
function Mwr(t) {
  return Lx(t) || bIe(t) ? Owr(t) : mlt(t);
}
function Owr(t) {
  return t.children.reduce((e, n) => e.concat(n.assembleProjections()), mlt(t));
}
function mlt(t) {
  const e = t.component.projection;
  if (!e || e.merged)
    return [];
  const n = e.combine(), { name: r } = n;
  if (e.data) {
    const i = {
      signal: `[${e.size.map((s) => s.signal).join(", ")}]`
    }, o = e.data.reduce((s, a) => {
      const A = Jn(a) ? a.signal : `data('${t.lookupDataSource(a)}')`;
      return wi(s, A) || s.push(A), s;
    }, []);
    if (o.length <= 0)
      throw new Error("Projection's fit didn't find any data sources");
    return [
      Object.assign({
        name: r,
        size: i,
        fit: {
          signal: o.length > 1 ? `[${o.join(", ")}]` : o[0]
        }
      }, n)
    ];
  } else
    return [
      Object.assign(Object.assign({ name: r }, { translate: { signal: "[width / 2, height / 2]" } }), n)
    ];
}
const Fwr = [
  "type",
  "clipAngle",
  "clipExtent",
  "center",
  "rotate",
  "precision",
  "reflectX",
  "reflectY",
  "coefficient",
  "distance",
  "fraction",
  "lobes",
  "parallel",
  "radius",
  "ratio",
  "spacing",
  "tilt"
];
class Clt extends dm {
  constructor(e, n, r, i) {
    super(
      Object.assign({}, n),
      // all explicit properties of projection
      { name: e }
      // name as initial implicit property
    ), this.specifiedProjection = n, this.size = r, this.data = i, this.merged = !1;
  }
  /**
   * Whether the projection parameters should fit provided data.
   */
  get isFit() {
    return !!this.data;
  }
}
function Elt(t) {
  t.component.projection = $a(t) ? Pwr(t) : Uwr(t);
}
function Pwr(t) {
  var e;
  if (t.hasProjection) {
    const n = Bu(t.specifiedProjection), r = !(n && (n.scale != null || n.translate != null)), i = r ? [t.getSizeSignalRef("width"), t.getSizeSignalRef("height")] : void 0, o = r ? kwr(t) : void 0, s = new Clt(t.projectionName(!0), Object.assign(Object.assign({}, (e = Bu(t.config.projection)) !== null && e !== void 0 ? e : {}), n ?? {}), i, o);
    return s.get("type") || s.set("type", "equalEarth", !1), s;
  }
}
function kwr(t) {
  const e = [], { encoding: n } = t;
  for (const r of [
    [y0, E0],
    [Jg, Ud]
  ])
    (gA(n[r[0]]) || gA(n[r[1]])) && e.push({
      signal: t.getName(`geojson_${e.length}`)
    });
  return t.channelHasField(qu) && t.typedFieldDef(qu).type === xx && e.push({
    signal: t.getName(`geojson_${e.length}`)
  }), e.length === 0 && e.push(t.requestDataName(Wo.Main)), e;
}
function Gwr(t, e) {
  const n = l0e(Fwr, (i) => !!(!Kn(t.explicit, i) && !Kn(e.explicit, i) || Kn(t.explicit, i) && Kn(e.explicit, i) && // some properties might be signals or objects and require hashing for comparison
  Qp(t.get(i), e.get(i))));
  if (Qp(t.size, e.size)) {
    if (n)
      return t;
    if (Qp(t.explicit, {}))
      return e;
    if (Qp(e.explicit, {}))
      return t;
  }
  return null;
}
function Uwr(t) {
  if (t.children.length === 0)
    return;
  let e;
  for (const r of t.children)
    Elt(r);
  const n = l0e(t.children, (r) => {
    const i = r.component.projection;
    if (i)
      if (e) {
        const o = Gwr(e, i);
        return o && (e = o), !!o;
      } else
        return e = i, !0;
    else
      return !0;
  });
  if (e && n) {
    const r = t.projectionName(!0), i = new Clt(r, e.specifiedProjection, e.size, Kr(e.data));
    for (const o of t.children) {
      const s = o.component.projection;
      s && (s.isFit && i.data.push(...o.component.projection.data), o.renameProjection(s.get("name"), r), s.merged = !0);
    }
    return i;
  }
}
var Hwr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function $wr(t, e, n, r) {
  var i, o;
  if (HO(e, n)) {
    const s = $a(t) ? (o = (i = t.axis(n)) !== null && i !== void 0 ? i : t.legend(n)) !== null && o !== void 0 ? o : {} : {}, a = fn(e, { expr: "datum" }), A = fn(e, { expr: "datum", binSuffix: "end" });
    return {
      formulaAs: fn(e, { binSuffix: "range", forAs: !0 }),
      formula: kO(a, A, s.format, s.formatType, r)
    };
  }
  return {};
}
function ylt(t, e) {
  return `${Vst(t)}_${e}`;
}
function qwr(t, e) {
  return {
    signal: t.getName(`${e}_bins`),
    extentSignal: t.getName(`${e}_extent`)
  };
}
function CIe(t, e, n) {
  var r;
  const i = (r = NY(n, void 0)) !== null && r !== void 0 ? r : {}, o = ylt(i, e);
  return t.getName(`${o}_bins`);
}
function jwr(t) {
  return "as" in t;
}
function yPe(t, e, n) {
  let r, i;
  jwr(t) ? r = Cn(t.as) ? [t.as, `${t.as}_end`] : [t.as[0], t.as[1]] : r = [fn(t, { forAs: !0 }), fn(t, { binSuffix: "end", forAs: !0 })];
  const o = Object.assign({}, NY(e, void 0)), s = ylt(o, t.field), { signal: a, extentSignal: A } = qwr(n, s);
  if (BY(o.extent)) {
    const c = o.extent;
    i = ZAt(n, c.param, c), delete o.extent;
  }
  const l = Object.assign(Object.assign(Object.assign({ bin: o, field: t.field, as: [r] }, a ? { signal: a } : {}), A ? { extentSignal: A } : {}), i ? { span: i } : {});
  return { key: s, binComponent: l };
}
class Gp extends Uo {
  constructor(e, n) {
    super(e), this.bins = n;
  }
  clone() {
    return new Gp(null, Kr(this.bins));
  }
  static makeFromEncoding(e, n) {
    const r = n.reduceFieldDef((i, o, s) => {
      if (Kg(o) && Zo(o.bin)) {
        const { key: a, binComponent: A } = yPe(o, o.bin, n);
        i[a] = Object.assign(Object.assign(Object.assign({}, A), i[a]), $wr(n, o, s, n.config));
      }
      return i;
    }, {});
    return Oo(r) ? null : new Gp(e, r);
  }
  /**
   * Creates a bin node from BinTransform.
   * The optional parameter should provide
   */
  static makeFromTransform(e, n, r) {
    const { key: i, binComponent: o } = yPe(n, n.bin, r);
    return new Gp(e, {
      [i]: o
    });
  }
  /**
   * Merge bin nodes. This method either integrates the bin config from the other node
   * or if this node already has a bin config, renames the corresponding signal in the model.
   */
  merge(e, n) {
    for (const r of Kt(e.bins))
      r in this.bins ? (n(e.bins[r].signal, this.bins[r].signal), this.bins[r].as = wp([...this.bins[r].as, ...e.bins[r].as], _i)) : this.bins[r] = e.bins[r];
    for (const r of e.children)
      e.removeChild(r), r.parent = this;
    e.remove();
  }
  producedFields() {
    return new Set(rc(this.bins).map((e) => e.as).flat(2));
  }
  dependentFields() {
    return new Set(rc(this.bins).map((e) => e.field));
  }
  hash() {
    return `Bin ${_i(this.bins)}`;
  }
  assemble() {
    return rc(this.bins).flatMap((e) => {
      const n = [], [r, ...i] = e.as, o = e.bin, { extent: s } = o, a = Hwr(o, ["extent"]), A = Object.assign(Object.assign(Object.assign({ type: "bin", field: Vg(e.field), as: r, signal: e.signal }, BY(s) ? { extent: null } : { extent: s }), e.span ? { span: { signal: `span(${e.span})` } } : {}), a);
      !s && e.extentSignal && (n.push({
        type: "extent",
        field: Vg(e.field),
        signal: e.extentSignal
      }), A.extent = { signal: e.extentSignal }), n.push(A);
      for (const l of i)
        for (let c = 0; c < 2; c++)
          n.push({
            type: "formula",
            expr: fn({ field: r[c] }, { expr: "datum" }),
            as: l[c]
          });
      return e.formula && n.push({
        type: "formula",
        expr: e.formula,
        as: e.formulaAs
      }), n;
    });
  }
}
function Ywr(t, e, n, r) {
  var i;
  const o = $a(r) ? r.encoding[gm(e)] : void 0;
  if (Kg(n) && $a(r) && kat(n, o, r.markDef, r.config))
    t.add(fn(n, {})), t.add(fn(n, { suffix: "end" })), n.bin && HO(n, e) && t.add(fn(n, { binSuffix: "range" }));
  else if (bBr(e)) {
    const s = BBr(e);
    t.add(r.getName(s));
  } else
    t.add(fn(n));
  return L1(n) && Mbr((i = n.scale) === null || i === void 0 ? void 0 : i.range) && t.add(n.scale.range.field), t;
}
function zwr(t, e) {
  var n;
  for (const r of Kt(e)) {
    const i = e[r];
    for (const o of Kt(i))
      r in t ? t[r][o] = /* @__PURE__ */ new Set([...(n = t[r][o]) !== null && n !== void 0 ? n : [], ...i[o]]) : t[r] = { [o]: i[o] };
  }
}
class ad extends Uo {
  /**
   * @param dimensions string set for dimensions
   * @param measures dictionary mapping field name => dict of aggregation functions and names to use
   */
  constructor(e, n, r) {
    super(e), this.dimensions = n, this.measures = r;
  }
  clone() {
    return new ad(null, new Set(this.dimensions), Kr(this.measures));
  }
  get groupBy() {
    return this.dimensions;
  }
  static makeFromEncoding(e, n) {
    let r = !1;
    n.forEachFieldDef((s) => {
      s.aggregate && (r = !0);
    });
    const i = {}, o = /* @__PURE__ */ new Set();
    return !r || (n.forEachFieldDef((s, a) => {
      var A, l, c, u;
      const { aggregate: f, field: h } = s;
      if (f)
        if (f === "count")
          (A = i["*"]) !== null && A !== void 0 || (i["*"] = {}), i["*"].count = /* @__PURE__ */ new Set([fn(s, { forAs: !0 })]);
        else {
          if (UI(f) || XE(f)) {
            const d = UI(f) ? "argmin" : "argmax", I = f[d];
            (l = i[I]) !== null && l !== void 0 || (i[I] = {}), i[I][d] = /* @__PURE__ */ new Set([fn({ op: d, field: I }, { forAs: !0 })]);
          } else
            (c = i[h]) !== null && c !== void 0 || (i[h] = {}), i[h][f] = /* @__PURE__ */ new Set([fn(s, { forAs: !0 })]);
          WE(a) && n.scaleDomain(a) === "unaggregated" && ((u = i[h]) !== null && u !== void 0 || (i[h] = {}), i[h].min = /* @__PURE__ */ new Set([fn({ field: h, aggregate: "min" }, { forAs: !0 })]), i[h].max = /* @__PURE__ */ new Set([fn({ field: h, aggregate: "max" }, { forAs: !0 })]));
        }
      else
        Ywr(o, a, s, n);
    }), o.size + Kt(i).length === 0) ? null : new ad(e, o, i);
  }
  static makeFromTransform(e, n) {
    var r, i, o;
    const s = /* @__PURE__ */ new Set(), a = {};
    for (const A of n.aggregate) {
      const { op: l, field: c, as: u } = A;
      l && (l === "count" ? ((r = a["*"]) !== null && r !== void 0 || (a["*"] = {}), a["*"].count = /* @__PURE__ */ new Set([u || fn(A, { forAs: !0 })])) : ((i = a[c]) !== null && i !== void 0 || (a[c] = {}), a[c][l] = /* @__PURE__ */ new Set([u || fn(A, { forAs: !0 })])));
    }
    for (const A of (o = n.groupby) !== null && o !== void 0 ? o : [])
      s.add(A);
    return s.size + Kt(a).length === 0 ? null : new ad(e, s, a);
  }
  merge(e) {
    return Rst(this.dimensions, e.dimensions) ? (zwr(this.measures, e.measures), !0) : (sbr("different dimensions, cannot merge"), !1);
  }
  addDimensions(e) {
    e.forEach(this.dimensions.add, this.dimensions);
  }
  dependentFields() {
    return /* @__PURE__ */ new Set([...this.dimensions, ...Kt(this.measures)]);
  }
  producedFields() {
    const e = /* @__PURE__ */ new Set();
    for (const n of Kt(this.measures))
      for (const r of Kt(this.measures[n])) {
        const i = this.measures[n][r];
        i.size === 0 ? e.add(`${r}_${n}`) : i.forEach(e.add, e);
      }
    return e;
  }
  hash() {
    return `Aggregate ${_i({ dimensions: this.dimensions, measures: this.measures })}`;
  }
  assemble() {
    const e = [], n = [], r = [];
    for (const o of Kt(this.measures))
      for (const s of Kt(this.measures[o]))
        for (const a of this.measures[o][s])
          r.push(a), e.push(s), n.push(o === "*" ? null : Vg(o));
    return {
      type: "aggregate",
      groupby: [...this.dimensions].map(Vg),
      ops: e,
      fields: n,
      as: r
    };
  }
}
class Tx extends Uo {
  /**
   * @param model The facet model.
   * @param name The name that this facet source will have.
   * @param data The source data for this facet data.
   */
  constructor(e, n, r, i) {
    super(e), this.model = n, this.name = r, this.data = i;
    for (const o of Rg) {
      const s = n.facet[o];
      if (s) {
        const { bin: a, sort: A } = s;
        this[o] = Object.assign({ name: n.getName(`${o}_domain`), fields: [fn(s), ...Zo(a) ? [fn(s, { binSuffix: "end" })] : []] }, Pp(A) ? { sortField: A } : Nt(A) ? { sortIndexField: qQ(s, o) } : {});
      }
    }
    this.childModel = n.child;
  }
  hash() {
    let e = "Facet";
    for (const n of Rg)
      this[n] && (e += ` ${n.charAt(0)}:${_i(this[n])}`);
    return e;
  }
  get fields() {
    var e;
    const n = [];
    for (const r of Rg)
      !((e = this[r]) === null || e === void 0) && e.fields && n.push(...this[r].fields);
    return n;
  }
  dependentFields() {
    const e = new Set(this.fields);
    for (const n of Rg)
      this[n] && (this[n].sortField && e.add(this[n].sortField.field), this[n].sortIndexField && e.add(this[n].sortIndexField));
    return e;
  }
  producedFields() {
    return /* @__PURE__ */ new Set();
  }
  /**
   * The name to reference this source is its name.
   */
  getSource() {
    return this.name;
  }
  getChildIndependentFieldsWithStep() {
    const e = {};
    for (const n of b0) {
      const r = this.childModel.component.scales[n];
      if (r && !r.merged) {
        const i = r.get("type"), o = r.get("range");
        if (UA(i) && ZE(o)) {
          const s = qY(this.childModel, n), a = BIe(s);
          a ? e[n] = a : Zt(B0e(n));
        }
      }
    }
    return e;
  }
  assembleRowColumnHeaderData(e, n, r) {
    const i = { row: "y", column: "x", facet: void 0 }[e], o = [], s = [], a = [];
    i && r && r[i] && (n ? (o.push(`distinct_${r[i]}`), s.push("max")) : (o.push(r[i]), s.push("distinct")), a.push(`distinct_${r[i]}`));
    const { sortField: A, sortIndexField: l } = this[e];
    if (A) {
      const { op: c = xY, field: u } = A;
      o.push(u), s.push(c), a.push(fn(A, { forAs: !0 }));
    } else
      l && (o.push(l), s.push("max"), a.push(l));
    return {
      name: this[e].name,
      // Use data from the crossed one if it exist
      source: n ?? this.data,
      transform: [
        Object.assign({ type: "aggregate", groupby: this[e].fields }, o.length ? {
          fields: o,
          ops: s,
          as: a
        } : {})
      ]
    };
  }
  assembleFacetHeaderData(e) {
    var n, r;
    const { columns: i } = this.model.layout, { layoutHeaders: o } = this.model.component, s = [], a = {};
    for (const c of dIe) {
      for (const u of pIe) {
        const f = (n = o[c] && o[c][u]) !== null && n !== void 0 ? n : [];
        for (const h of f)
          if (((r = h.axes) === null || r === void 0 ? void 0 : r.length) > 0) {
            a[c] = !0;
            break;
          }
      }
      if (a[c]) {
        const u = `length(data("${this.facet.name}"))`, f = c === "row" ? i ? { signal: `ceil(${u} / ${i})` } : 1 : i ? { signal: `min(${u}, ${i})` } : { signal: u };
        s.push({
          name: `${this.facet.name}_${c}`,
          transform: [
            {
              type: "sequence",
              start: 0,
              stop: f
            }
          ]
        });
      }
    }
    const { row: A, column: l } = a;
    return (A || l) && s.unshift(this.assembleRowColumnHeaderData("facet", null, e)), s;
  }
  assemble() {
    var e, n;
    const r = [];
    let i = null;
    const o = this.getChildIndependentFieldsWithStep(), { column: s, row: a, facet: A } = this;
    if (s && a && (o.x || o.y)) {
      i = `cross_${this.column.name}_${this.row.name}`;
      const l = [].concat((e = o.x) !== null && e !== void 0 ? e : [], (n = o.y) !== null && n !== void 0 ? n : []), c = l.map(() => "distinct");
      r.push({
        name: i,
        source: this.data,
        transform: [
          {
            type: "aggregate",
            groupby: this.fields,
            fields: l,
            ops: c
          }
        ]
      });
    }
    for (const l of [BI, vI])
      this[l] && r.push(this.assembleRowColumnHeaderData(l, i, o));
    if (A) {
      const l = this.assembleFacetHeaderData(o);
      l && r.push(...l);
    }
    return r;
  }
}
function vPe(t) {
  return t.startsWith("'") && t.endsWith("'") || t.startsWith('"') && t.endsWith('"') ? t.slice(1, -1) : t;
}
function Vwr(t, e) {
  const n = f0e(t);
  if (e === "number")
    return `toNumber(${n})`;
  if (e === "boolean")
    return `toBoolean(${n})`;
  if (e === "string")
    return `toString(${n})`;
  if (e === "date")
    return `toDate(${n})`;
  if (e === "flatten")
    return n;
  if (e.startsWith("date:")) {
    const r = vPe(e.slice(5, e.length));
    return `timeParse(${n},'${r}')`;
  } else if (e.startsWith("utc:")) {
    const r = vPe(e.slice(4, e.length));
    return `utcParse(${n},'${r}')`;
  } else
    return Zt(g1r(e)), null;
}
function Jwr(t) {
  const e = {};
  return d4(t.filter, (n) => {
    var r;
    if (dat(n)) {
      let i = null;
      w0e(n) ? i = _f(n.equal) : R0e(n) ? i = _f(n.lte) : x0e(n) ? i = _f(n.lt) : D0e(n) ? i = _f(n.gt) : T0e(n) ? i = _f(n.gte) : N0e(n) ? i = n.range[0] : L0e(n) && (i = ((r = n.oneOf) !== null && r !== void 0 ? r : n.in)[0]), i && (N1(i) ? e[n.field] = "date" : Po(i) ? e[n.field] = "number" : Cn(i) && (e[n.field] = "string")), n.timeUnit && (e[n.field] = "date");
    }
  }), e;
}
function Kwr(t) {
  const e = {};
  function n(r) {
    GQ(r) ? e[r.field] = "date" : r.type === "quantitative" && qBr(r.aggregate) ? e[r.field] = "number" : LQ(r.field) > 1 ? r.field in e || (e[r.field] = "flatten") : L1(r) && Pp(r.sort) && LQ(r.sort.field) > 1 && (r.sort.field in e || (e[r.sort.field] = "flatten"));
  }
  if (($a(t) || Ad(t)) && t.forEachFieldDef((r, i) => {
    if (Kg(r))
      n(r);
    else {
      const o = D1(i), s = t.fieldDef(o);
      n(Object.assign(Object.assign({}, r), { type: s.type }));
    }
  }), $a(t)) {
    const { mark: r, markDef: i, encoding: o } = t;
    if (ey(r) && // No need to sort by dimension if we have a connected scatterplot (order channel is present)
    !t.encoding.order) {
      const s = i.orient === "horizontal" ? "y" : "x", a = o[s];
      sn(a) && a.type === "quantitative" && !(a.field in e) && (e[a.field] = "number");
    }
  }
  return e;
}
function Wwr(t) {
  const e = {};
  if ($a(t) && t.component.selection)
    for (const n of Kt(t.component.selection)) {
      const r = t.component.selection[n];
      for (const i of r.project.items)
        !i.channel && LQ(i.field) > 1 && (e[i.field] = "flatten");
    }
  return e;
}
class Xl extends Uo {
  constructor(e, n) {
    super(e), this._parse = n;
  }
  clone() {
    return new Xl(null, Kr(this._parse));
  }
  hash() {
    return `Parse ${_i(this._parse)}`;
  }
  /**
   * Creates a parse node from a data.format.parse and updates ancestorParse.
   */
  static makeExplicit(e, n, r) {
    var i;
    let o = {};
    const s = n.data;
    return !UC(s) && (!((i = s?.format) === null || i === void 0) && i.parse) && (o = s.format.parse), this.makeWithAncestors(e, o, {}, r);
  }
  /**
   * Creates a parse node from "explicit" parse and "implicit" parse and updates ancestorParse.
   */
  static makeWithAncestors(e, n, r, i) {
    for (const a of Kt(r)) {
      const A = i.getWithExplicit(a);
      A.value !== void 0 && (A.explicit || A.value === r[a] || A.value === "derived" || r[a] === "flatten" ? delete r[a] : Zt(OFe(a, r[a], A.value)));
    }
    for (const a of Kt(n)) {
      const A = i.get(a);
      A !== void 0 && (A === n[a] ? delete n[a] : Zt(OFe(a, n[a], A)));
    }
    const o = new dm(n, r);
    i.copyAll(o);
    const s = {};
    for (const a of Kt(o.combine())) {
      const A = o.get(a);
      A !== null && (s[a] = A);
    }
    return Kt(s).length === 0 || i.parseNothing ? null : new Xl(e, s);
  }
  get parse() {
    return this._parse;
  }
  merge(e) {
    this._parse = Object.assign(Object.assign({}, this._parse), e.parse), e.remove();
  }
  /**
   * Assemble an object for Vega's format.parse property.
   */
  assembleFormatParse() {
    const e = {};
    for (const n of Kt(this._parse)) {
      const r = this._parse[n];
      LQ(n) === 1 && (e[n] = r);
    }
    return e;
  }
  // format parse depends and produces all fields in its parse
  producedFields() {
    return new Set(Kt(this._parse));
  }
  dependentFields() {
    return new Set(Kt(this._parse));
  }
  assembleTransforms(e = !1) {
    return Kt(this._parse).filter((n) => e ? LQ(n) > 1 : !0).map((n) => {
      const r = Vwr(n, this._parse[n]);
      return r ? {
        type: "formula",
        expr: r,
        as: g0e(n)
        // Vega output is always flattened
      } : null;
    }).filter((n) => n !== null);
  }
}
class mE extends Uo {
  clone() {
    return new mE(null);
  }
  constructor(e) {
    super(e);
  }
  dependentFields() {
    return /* @__PURE__ */ new Set();
  }
  producedFields() {
    return /* @__PURE__ */ new Set([t0]);
  }
  hash() {
    return "Identifier";
  }
  assemble() {
    return { type: "identifier", as: t0 };
  }
}
class jO extends Uo {
  constructor(e, n) {
    super(e), this.params = n;
  }
  clone() {
    return new jO(null, this.params);
  }
  dependentFields() {
    return /* @__PURE__ */ new Set();
  }
  producedFields() {
  }
  hash() {
    return `Graticule ${_i(this.params)}`;
  }
  assemble() {
    return Object.assign({ type: "graticule" }, this.params === !0 ? {} : this.params);
  }
}
class YO extends Uo {
  constructor(e, n) {
    super(e), this.params = n;
  }
  clone() {
    return new YO(null, this.params);
  }
  dependentFields() {
    return /* @__PURE__ */ new Set();
  }
  producedFields() {
    var e;
    return /* @__PURE__ */ new Set([(e = this.params.as) !== null && e !== void 0 ? e : "data"]);
  }
  hash() {
    return `Hash ${_i(this.params)}`;
  }
  assemble() {
    return Object.assign({ type: "sequence" }, this.params);
  }
}
class PB extends Uo {
  constructor(e) {
    super(null), e ?? (e = { name: "source" });
    let n;
    if (UC(e) || (n = e.format ? Object.assign({}, Ff(e.format, ["parse"])) : {}), HN(e))
      this._data = { values: e.values };
    else if (UQ(e)) {
      if (this._data = { url: e.url }, !n.type) {
        let r = /(?:\.([^.]+))?$/.exec(e.url)[1];
        wi(["json", "csv", "tsv", "dsv", "topojson"], r) || (r = "json"), n.type = r;
      }
    } else
      TAt(e) ? this._data = { values: [{ type: "Sphere" }] } : (RAt(e) || UC(e)) && (this._data = {});
    this._generator = UC(e), e.name && (this._name = e.name), n && !Oo(n) && (this._data.format = n);
  }
  dependentFields() {
    return /* @__PURE__ */ new Set();
  }
  producedFields() {
  }
  get data() {
    return this._data;
  }
  hasName() {
    return !!this._name;
  }
  get isGenerator() {
    return this._generator;
  }
  get dataName() {
    return this._name;
  }
  set dataName(e) {
    this._name = e;
  }
  set parent(e) {
    throw new Error("Source nodes have to be roots.");
  }
  remove() {
    throw new Error("Source nodes are roots and cannot be removed.");
  }
  hash() {
    throw new Error("Cannot hash sources");
  }
  assemble() {
    return Object.assign(Object.assign({ name: this._name }, this._data), { transform: [] });
  }
}
var BPe = globalThis && globalThis.__classPrivateFieldSet || function(t, e, n, r, i) {
  if (r === "m")
    throw new TypeError("Private method is not writable");
  if (r === "a" && !i)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return r === "a" ? i.call(t, n) : i ? i.value = n : e.set(t, n), n;
}, Xwr = globalThis && globalThis.__classPrivateFieldGet || function(t, e, n, r) {
  if (n === "a" && !r)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !r : !e.has(t))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(t) : r ? r.value : e.get(t);
}, AD;
function EIe(t) {
  return t instanceof PB || t instanceof jO || t instanceof YO;
}
class yIe {
  constructor() {
    AD.set(this, void 0), BPe(this, AD, !1, "f");
  }
  // Once true, #modified is never set to false
  setModified() {
    BPe(this, AD, !0, "f");
  }
  get modifiedFlag() {
    return Xwr(this, AD, "f");
  }
}
AD = /* @__PURE__ */ new WeakMap();
class M1 extends yIe {
  /**
   * Compute a map of node depths that we can use to determine a topological sort order.
   */
  getNodeDepths(e, n, r) {
    r.set(e, n);
    for (const i of e.children)
      this.getNodeDepths(i, n + 1, r);
    return r;
  }
  /**
   * Run the optimizer on all nodes starting from the leaves.
   */
  optimize(e) {
    const r = [...this.getNodeDepths(e, 0, /* @__PURE__ */ new Map()).entries()].sort((i, o) => o[1] - i[1]);
    for (const i of r)
      this.run(i[0]);
    return this.modifiedFlag;
  }
}
class vIe extends yIe {
  /**
   * Run the optimizer depth first on all nodes starting from the roots.
   */
  optimize(e) {
    this.run(e);
    for (const n of e.children)
      this.optimize(n);
    return this.modifiedFlag;
  }
}
class Zwr extends vIe {
  mergeNodes(e, n) {
    const r = n.shift();
    for (const i of n)
      e.removeChild(i), i.parent = r, i.remove();
  }
  run(e) {
    const n = e.children.map((i) => i.hash()), r = {};
    for (let i = 0; i < n.length; i++)
      r[n[i]] === void 0 ? r[n[i]] = [e.children[i]] : r[n[i]].push(e.children[i]);
    for (const i of Kt(r))
      r[i].length > 1 && (this.setModified(), this.mergeNodes(e, r[i]));
  }
}
class exr extends vIe {
  constructor(e) {
    super(), this.requiresSelectionId = e && hIe(e);
  }
  run(e) {
    e instanceof mE && (this.requiresSelectionId && (EIe(e.parent) || e.parent instanceof ad || e.parent instanceof Xl) || (this.setModified(), e.remove()));
  }
}
class txr extends yIe {
  optimize(e) {
    return this.run(e, /* @__PURE__ */ new Set()), this.modifiedFlag;
  }
  run(e, n) {
    let r = /* @__PURE__ */ new Set();
    e instanceof kp && (r = e.producedFields(), c0e(r, n) && (this.setModified(), e.removeFormulas(n), e.producedFields.length === 0 && e.remove()));
    for (const i of e.children)
      this.run(i, /* @__PURE__ */ new Set([...n, ...r]));
  }
}
class nxr extends vIe {
  constructor() {
    super();
  }
  run(e) {
    e instanceof zc && !e.isRequired() && (this.setModified(), e.remove());
  }
}
class rxr extends M1 {
  run(e) {
    if (!EIe(e) && !(e.numChildren() > 1)) {
      for (const n of e.children)
        if (n instanceof Xl)
          if (e instanceof Xl)
            this.setModified(), e.merge(n);
          else {
            if (u0e(e.producedFields(), n.dependentFields()))
              continue;
            this.setModified(), n.swapWithParent();
          }
    }
  }
}
class ixr extends M1 {
  run(e) {
    const n = [...e.children], r = e.children.filter((i) => i instanceof Xl);
    if (e.numChildren() > 1 && r.length >= 1) {
      const i = {}, o = /* @__PURE__ */ new Set();
      for (const s of r) {
        const a = s.parse;
        for (const A of Kt(a))
          A in i ? i[A] !== a[A] && o.add(A) : i[A] = a[A];
      }
      for (const s of o)
        delete i[s];
      if (!Oo(i)) {
        this.setModified();
        const s = new Xl(e, i);
        for (const a of n) {
          if (a instanceof Xl)
            for (const A of Kt(i))
              delete a.parse[A];
          e.removeChild(a), a.parent = s, a instanceof Xl && Kt(a.parse).length === 0 && a.remove();
        }
      }
    }
  }
}
class oxr extends M1 {
  run(e) {
    e instanceof zc || e.numChildren() > 0 || e instanceof Tx || e instanceof PB || (this.setModified(), e.remove());
  }
}
class sxr extends M1 {
  run(e) {
    const n = e.children.filter((i) => i instanceof kp), r = n.pop();
    for (const i of n)
      this.setModified(), r.merge(i);
  }
}
class axr extends M1 {
  run(e) {
    const n = e.children.filter((i) => i instanceof ad), r = {};
    for (const i of n) {
      const o = _i(i.groupBy);
      o in r || (r[o] = []), r[o].push(i);
    }
    for (const i of Kt(r)) {
      const o = r[i];
      if (o.length > 1) {
        const s = o.pop();
        for (const a of o)
          s.merge(a) && (e.removeChild(a), a.parent = s, a.remove(), this.setModified());
      }
    }
  }
}
class Axr extends M1 {
  constructor(e) {
    super(), this.model = e;
  }
  run(e) {
    const n = !(EIe(e) || e instanceof Dx || e instanceof Xl || e instanceof mE), r = [], i = [];
    for (const o of e.children)
      o instanceof Gp && (n && !u0e(e.producedFields(), o.dependentFields()) ? r.push(o) : i.push(o));
    if (r.length > 0) {
      const o = r.pop();
      for (const s of r)
        o.merge(s, this.model.renameSignal.bind(this.model));
      this.setModified(), e instanceof Gp ? e.merge(o, this.model.renameSignal.bind(this.model)) : o.swapWithParent();
    }
    if (i.length > 1) {
      const o = i.pop();
      for (const s of i)
        o.merge(s, this.model.renameSignal.bind(this.model));
      this.setModified();
    }
  }
}
class lxr extends M1 {
  run(e) {
    const n = [...e.children];
    if (!xB(n, (s) => s instanceof zc) || e.numChildren() <= 1)
      return;
    const i = [];
    let o;
    for (const s of n)
      if (s instanceof zc) {
        let a = s;
        for (; a.numChildren() === 1; ) {
          const [A] = a.children;
          if (A instanceof zc)
            a = A;
          else
            break;
        }
        i.push(...a.children), o ? (e.removeChild(s), s.parent = o.parent, o.parent.removeChild(o), o.parent = a, this.setModified()) : o = a;
      } else
        i.push(s);
    if (i.length) {
      this.setModified();
      for (const s of i)
        s.parent.removeChild(s), s.parent = o;
    }
  }
}
class O1 extends Uo {
  constructor(e, n) {
    super(e), this.transform = n;
  }
  clone() {
    return new O1(null, Kr(this.transform));
  }
  addDimensions(e) {
    this.transform.groupby = wp(this.transform.groupby.concat(e), (n) => n);
  }
  dependentFields() {
    const e = /* @__PURE__ */ new Set();
    return this.transform.groupby && this.transform.groupby.forEach(e.add, e), this.transform.joinaggregate.map((n) => n.field).filter((n) => n !== void 0).forEach(e.add, e), e;
  }
  producedFields() {
    return new Set(this.transform.joinaggregate.map(this.getDefaultName));
  }
  getDefaultName(e) {
    var n;
    return (n = e.as) !== null && n !== void 0 ? n : fn(e);
  }
  hash() {
    return `JoinAggregateTransform ${_i(this.transform)}`;
  }
  assemble() {
    const e = [], n = [], r = [];
    for (const o of this.transform.joinaggregate)
      n.push(o.op), r.push(this.getDefaultName(o)), e.push(o.field === void 0 ? null : o.field);
    const i = this.transform.groupby;
    return Object.assign({
      type: "joinaggregate",
      as: r,
      ops: n,
      fields: e
    }, i !== void 0 ? { groupby: i } : {});
  }
}
function cxr(t) {
  return t.stack.stackBy.reduce((e, n) => {
    const r = n.fieldDef, i = fn(r);
    return i && e.push(i), e;
  }, []);
}
function uxr(t) {
  return Nt(t) && t.every((e) => Cn(e)) && t.length > 1;
}
class _I extends Uo {
  constructor(e, n) {
    super(e), this._stack = n;
  }
  clone() {
    return new _I(null, Kr(this._stack));
  }
  static makeFromTransform(e, n) {
    const { stack: r, groupby: i, as: o, offset: s = "zero" } = n, a = [], A = [];
    if (n.sort !== void 0)
      for (const u of n.sort)
        a.push(u.field), A.push(Va(u.order, "ascending"));
    const l = {
      field: a,
      order: A
    };
    let c;
    return uxr(o) ? c = o : Cn(o) ? c = [o, `${o}_end`] : c = [`${n.stack}_start`, `${n.stack}_end`], new _I(e, {
      dimensionFieldDefs: [],
      stackField: r,
      groupby: i,
      offset: s,
      sort: l,
      facetby: [],
      as: c
    });
  }
  static makeFromEncoding(e, n) {
    const r = n.stack, { encoding: i } = n;
    if (!r)
      return null;
    const { groupbyChannels: o, fieldChannel: s, offset: a, impute: A } = r, l = o.map((h) => {
      const d = i[h];
      return e0(d);
    }).filter((h) => !!h), c = cxr(n), u = n.encoding.order;
    let f;
    return Nt(u) || sn(u) ? f = Zst(u) : f = c.reduce((h, d) => (h.field.push(d), h.order.push(s === "y" ? "descending" : "ascending"), h), { field: [], order: [] }), new _I(e, {
      dimensionFieldDefs: l,
      stackField: n.vgField(s),
      facetby: [],
      stackby: c,
      sort: f,
      offset: a,
      impute: A,
      as: [
        n.vgField(s, { suffix: "start", forAs: !0 }),
        n.vgField(s, { suffix: "end", forAs: !0 })
      ]
    });
  }
  get stack() {
    return this._stack;
  }
  addDimensions(e) {
    this._stack.facetby.push(...e);
  }
  dependentFields() {
    const e = /* @__PURE__ */ new Set();
    return e.add(this._stack.stackField), this.getGroupbyFields().forEach(e.add, e), this._stack.facetby.forEach(e.add, e), this._stack.sort.field.forEach(e.add, e), e;
  }
  producedFields() {
    return new Set(this._stack.as);
  }
  hash() {
    return `Stack ${_i(this._stack)}`;
  }
  getGroupbyFields() {
    const { dimensionFieldDefs: e, impute: n, groupby: r } = this._stack;
    return e.length > 0 ? e.map((i) => i.bin ? n ? [fn(i, { binSuffix: "mid" })] : [
      // For binned group by field without impute, we need both bin (start) and bin_end
      fn(i, {}),
      fn(i, { binSuffix: "end" })
    ] : [fn(i)]).flat() : r ?? [];
  }
  assemble() {
    const e = [], { facetby: n, dimensionFieldDefs: r, stackField: i, stackby: o, sort: s, offset: a, impute: A, as: l } = this._stack;
    if (A)
      for (const c of r) {
        const { bandPosition: u = 0.5, bin: f } = c;
        if (f) {
          const h = fn(c, { expr: "datum" }), d = fn(c, { expr: "datum", binSuffix: "end" });
          e.push({
            type: "formula",
            expr: `${u}*${h}+${1 - u}*${d}`,
            as: fn(c, { binSuffix: "mid", forAs: !0 })
          });
        }
        e.push({
          type: "impute",
          field: i,
          groupby: [...o, ...n],
          key: fn(c, { binSuffix: "mid" }),
          method: "value",
          value: 0
        });
      }
    return e.push({
      type: "stack",
      groupby: [...this.getGroupbyFields(), ...n],
      field: i,
      sort: s,
      as: l,
      offset: a
    }), e;
  }
}
class Nx extends Uo {
  constructor(e, n) {
    super(e), this.transform = n;
  }
  clone() {
    return new Nx(null, Kr(this.transform));
  }
  addDimensions(e) {
    this.transform.groupby = wp(this.transform.groupby.concat(e), (n) => n);
  }
  dependentFields() {
    var e, n;
    const r = /* @__PURE__ */ new Set();
    return ((e = this.transform.groupby) !== null && e !== void 0 ? e : []).forEach(r.add, r), ((n = this.transform.sort) !== null && n !== void 0 ? n : []).forEach((i) => r.add(i.field)), this.transform.window.map((i) => i.field).filter((i) => i !== void 0).forEach(r.add, r), r;
  }
  producedFields() {
    return new Set(this.transform.window.map(this.getDefaultName));
  }
  getDefaultName(e) {
    var n;
    return (n = e.as) !== null && n !== void 0 ? n : fn(e);
  }
  hash() {
    return `WindowTransform ${_i(this.transform)}`;
  }
  assemble() {
    var e;
    const n = [], r = [], i = [], o = [];
    for (const f of this.transform.window)
      r.push(f.op), i.push(this.getDefaultName(f)), o.push(f.param === void 0 ? null : f.param), n.push(f.field === void 0 ? null : f.field);
    const s = this.transform.frame, a = this.transform.groupby;
    if (s && s[0] === null && s[1] === null && r.every((f) => E0e(f)))
      return Object.assign({ type: "joinaggregate", as: i, ops: r, fields: n }, a !== void 0 ? { groupby: a } : {});
    const A = [], l = [];
    if (this.transform.sort !== void 0)
      for (const f of this.transform.sort)
        A.push(f.field), l.push((e = f.order) !== null && e !== void 0 ? e : "ascending");
    const c = {
      field: A,
      order: l
    }, u = this.transform.ignorePeers;
    return Object.assign(Object.assign(Object.assign({
      type: "window",
      params: o,
      as: i,
      ops: r,
      fields: n,
      sort: c
    }, u !== void 0 ? { ignorePeers: u } : {}), a !== void 0 ? { groupby: a } : {}), s !== void 0 ? { frame: s } : {});
  }
}
function fxr(t) {
  function e(n) {
    if (!(n instanceof Tx)) {
      const r = n.clone();
      if (r instanceof zc) {
        const i = qoe + r.getSource();
        r.setSource(i), t.model.component.data.outputNodes[i] = r;
      } else
        (r instanceof ad || r instanceof _I || r instanceof Nx || r instanceof O1) && r.addDimensions(t.fields);
      for (const i of n.children.flatMap(e))
        i.parent = r;
      return [r];
    }
    return n.children.flatMap(e);
  }
  return e;
}
function $oe(t) {
  if (t instanceof Tx)
    if (t.numChildren() === 1 && !(t.children[0] instanceof zc)) {
      const e = t.children[0];
      (e instanceof ad || e instanceof _I || e instanceof Nx || e instanceof O1) && e.addDimensions(t.fields), e.swapWithParent(), $oe(t);
    } else {
      const e = t.model.component.data.main;
      vlt(e);
      const n = fxr(t), r = t.children.map(n).flat();
      for (const i of r)
        i.parent = e;
    }
  else
    t.children.map($oe);
}
function vlt(t) {
  if (t instanceof zc && t.type === Wo.Main && t.numChildren() === 1) {
    const e = t.children[0];
    e instanceof Tx || (e.swapWithParent(), vlt(t));
  }
}
const qoe = "scale_", j3 = 5;
function joe(t) {
  for (const e of t) {
    for (const n of e.children)
      if (n.parent !== e)
        return !1;
    if (!joe(e.children))
      return !1;
  }
  return !0;
}
function vh(t, e) {
  let n = !1;
  for (const r of e)
    n = t.optimize(r) || n;
  return n;
}
function bPe(t, e, n) {
  let r = t.sources, i = !1;
  return i = vh(new nxr(), r) || i, i = vh(new exr(e), r) || i, r = r.filter((o) => o.numChildren() > 0), i = vh(new oxr(), r) || i, r = r.filter((o) => o.numChildren() > 0), n || (i = vh(new rxr(), r) || i, i = vh(new Axr(e), r) || i, i = vh(new txr(), r) || i, i = vh(new ixr(), r) || i, i = vh(new axr(), r) || i, i = vh(new sxr(), r) || i, i = vh(new Zwr(), r) || i, i = vh(new lxr(), r) || i), t.sources = r, i;
}
function gxr(t, e) {
  joe(t.sources);
  let n = 0, r = 0;
  for (let i = 0; i < j3 && bPe(t, e, !0); i++)
    n++;
  t.sources.map($oe);
  for (let i = 0; i < j3 && bPe(t, e, !1); i++)
    r++;
  joe(t.sources), Math.max(n, r) === j3 && Zt(`Maximum optimization runs(${j3}) reached.`);
}
class Lu {
  constructor(e) {
    Object.defineProperty(this, "signal", {
      enumerable: !0,
      get: e
    });
  }
  static fromName(e, n) {
    return new Lu(() => e(n));
  }
}
var hxr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function Blt(t) {
  $a(t) ? dxr(t) : pxr(t);
}
function dxr(t) {
  const e = t.component.scales;
  for (const n of Kt(e)) {
    const r = mxr(t, n);
    if (e[n].setWithExplicit("domains", r), Exr(t, n), t.component.data.isFaceted) {
      let o = t;
      for (; !Ad(o) && o.parent; )
        o = o.parent;
      if (o.component.resolve.scale[n] === "shared")
        for (const a of r.value)
          uI(a) && (a.data = qoe + a.data.replace(qoe, ""));
    }
  }
}
function pxr(t) {
  for (const n of t.children)
    Blt(n);
  const e = t.component.scales;
  for (const n of Kt(e)) {
    let r, i = null;
    for (const o of t.children) {
      const s = o.component.scales[n];
      if (s) {
        r === void 0 ? r = s.getWithExplicit("domains") : r = hE(r, s.getWithExplicit("domains"), "domains", "scale", Yoe);
        const a = s.get("selectionExtent");
        i && a && i.param !== a.param && Zt(l1r), i = a;
      }
    }
    e[n].setWithExplicit("domains", r), i && e[n].set("selectionExtent", i, !0);
  }
}
function Ixr(t, e, n, r) {
  if (t === "unaggregated") {
    const { valid: i, reason: o } = _Pe(e, n);
    if (!i) {
      Zt(o);
      return;
    }
  } else if (t === void 0 && r.useUnaggregatedDomain) {
    const { valid: i } = _Pe(e, n);
    if (i)
      return "unaggregated";
  }
  return t;
}
function mxr(t, e) {
  const n = t.getScaleComponent(e).get("type"), { encoding: r } = t, i = Ixr(t.scaleDomain(e), t.typedFieldDef(e), n, t.config.scale);
  return i !== t.scaleDomain(e) && (t.specifiedScales[e] = Object.assign(Object.assign({}, t.specifiedScales[e]), { domain: i })), e === "x" && gA(r.x2) ? gA(r.x) ? hE($m(n, i, t, "x"), $m(n, i, t, "x2"), "domain", "scale", Yoe) : $m(n, i, t, "x2") : e === "y" && gA(r.y2) ? gA(r.y) ? hE($m(n, i, t, "y"), $m(n, i, t, "y2"), "domain", "scale", Yoe) : $m(n, i, t, "y2") : $m(n, i, t, e);
}
function Cxr(t, e, n) {
  return t.map((r) => ({ signal: `{data: ${LY(r, { timeUnit: n, type: e })}}` }));
}
function dX(t, e, n) {
  var r;
  const i = (r = cc(n)) === null || r === void 0 ? void 0 : r.unit;
  return e === "temporal" || i ? Cxr(t, e, i) : [t];
}
function $m(t, e, n, r) {
  const { encoding: i } = n, o = gA(i[r]), { type: s } = o, a = o.timeUnit;
  if (Lbr(e)) {
    const u = $m(t, void 0, n, r), f = dX(e.unionWith, s, a);
    return cp([...u.value, ...f]);
  } else {
    if (Jn(e))
      return cp([e]);
    if (e && e !== "unaggregated" && !vat(e))
      return cp(dX(e, s, a));
  }
  const A = n.stack;
  if (A && r === A.fieldChannel) {
    if (A.offset === "normalize")
      return df([[0, 1]]);
    const u = n.requestDataName(Wo.Main);
    return df([
      {
        data: u,
        field: n.vgField(r, { suffix: "start" })
      },
      {
        data: u,
        field: n.vgField(r, { suffix: "end" })
      }
    ]);
  }
  const l = WE(r) && sn(o) ? yxr(n, r, t) : void 0;
  if (_0(o)) {
    const u = dX([o.datum], s, a);
    return df(u);
  }
  const c = o;
  if (e === "unaggregated") {
    const u = n.requestDataName(Wo.Main), { field: f } = o;
    return df([
      {
        data: u,
        field: fn({ field: f, aggregate: "min" })
      },
      {
        data: u,
        field: fn({ field: f, aggregate: "max" })
      }
    ]);
  } else if (Zo(c.bin)) {
    if (UA(t))
      return df(t === "bin-ordinal" ? [] : [
        {
          // If sort by aggregation of a specified sort field, we need to use RAW table,
          // so we can aggregate values for the scale independently from the main aggregation.
          data: kN(l) ? n.requestDataName(Wo.Main) : n.requestDataName(Wo.Raw),
          // Use range if we added it and the scale does not support computing a range as a signal.
          field: n.vgField(r, HO(c, r) ? { binSuffix: "range" } : {}),
          // we have to use a sort object if sort = true to make the sort correct by bin start
          sort: l === !0 || !_n(l) ? {
            field: n.vgField(r, {}),
            op: "min"
            // min or max doesn't matter since we sort by the start of the bin range
          } : l
        }
      ]);
    {
      const { bin: u } = c;
      if (Zo(u)) {
        const f = CIe(n, c.field, u);
        return df([
          new Lu(() => {
            const h = n.getSignalName(f);
            return `[${h}.start, ${h}.stop]`;
          })
        ]);
      } else
        return df([
          {
            data: n.requestDataName(Wo.Main),
            field: n.vgField(r, {})
          }
        ]);
    }
  } else if (c.timeUnit && wi(["time", "utc"], t) && kat(c, $a(n) ? n.encoding[gm(r)] : void 0, n.markDef, n.config)) {
    const u = n.requestDataName(Wo.Main);
    return df([
      {
        data: u,
        field: n.vgField(r)
      },
      {
        data: u,
        field: n.vgField(r, { suffix: "end" })
      }
    ]);
  } else
    return df(l ? [
      {
        // If sort by aggregation of a specified sort field, we need to use RAW table,
        // so we can aggregate values for the scale independently from the main aggregation.
        data: kN(l) ? n.requestDataName(Wo.Main) : n.requestDataName(Wo.Raw),
        field: n.vgField(r),
        sort: l
      }
    ] : [
      {
        data: n.requestDataName(Wo.Main),
        field: n.vgField(r)
      }
    ]);
}
function pX(t, e) {
  const { op: n, field: r, order: i } = t;
  return Object.assign(Object.assign({
    // Apply default op
    op: n ?? (e ? "sum" : xY)
  }, r ? { field: Vg(r) } : {}), i ? { order: i } : {});
}
function Exr(t, e) {
  var n;
  const r = t.component.scales[e], i = t.specifiedScales[e].domain, o = (n = t.fieldDef(e)) === null || n === void 0 ? void 0 : n.bin, s = vat(i) && i, a = T1(o) && BY(o.extent) && o.extent;
  (s || a) && r.set("selectionExtent", s ?? a, !0);
}
function yxr(t, e, n) {
  if (!UA(n))
    return;
  const r = t.fieldDef(e), i = r.sort;
  if (Oat(i))
    return {
      op: "min",
      field: qQ(r, e),
      order: "ascending"
    };
  const { stack: o } = t, s = o ? /* @__PURE__ */ new Set([...o.groupbyFields, ...o.stackBy.map((a) => a.fieldDef.field)]) : void 0;
  if (Pp(i)) {
    const a = o && !s.has(i.field);
    return pX(i, a);
  } else if (Mat(i)) {
    const { encoding: a, order: A } = i, l = t.fieldDef(a), { aggregate: c, field: u } = l, f = o && !s.has(u);
    if (UI(c) || XE(c))
      return pX({
        field: fn(l),
        order: A
      }, f);
    if (E0e(c) || !c)
      return pX({
        op: c,
        field: u,
        order: A
      }, f);
  } else {
    if (i === "descending")
      return {
        op: "min",
        field: t.vgField(e),
        order: "descending"
      };
    if (wi([
      "ascending",
      void 0
      /* default =ascending*/
    ], i))
      return !0;
  }
}
function _Pe(t, e) {
  const { aggregate: n, type: r } = t;
  return n ? Cn(n) && !YBr.has(n) ? {
    valid: !1,
    reason: F1r(n)
  } : r === "quantitative" && e === "log" ? {
    valid: !1,
    reason: P1r(t)
  } : { valid: !0 } : {
    valid: !1,
    reason: O1r(t)
  };
}
function Yoe(t, e, n, r) {
  return t.explicit && e.explicit && Zt($1r(n, r, t.value, e.value)), { explicit: t.explicit, value: [...t.value, ...e.value] };
}
function vxr(t) {
  const e = wp(t.map((s) => uI(s) ? hxr(s, ["sort"]) : s), _i), n = wp(t.map((s) => {
    if (uI(s)) {
      const a = s.sort;
      return a !== void 0 && !kN(a) && ("op" in a && a.op === "count" && delete a.field, a.order === "ascending" && delete a.order), a;
    }
  }).filter((s) => s !== void 0), _i);
  if (e.length === 0)
    return;
  if (e.length === 1) {
    const s = t[0];
    if (uI(s) && n.length > 0) {
      let a = n[0];
      if (n.length > 1)
        Zt(PFe), a = !0;
      else if (_n(a) && "field" in a) {
        const A = a.field;
        s.field === A && (a = a.order ? { order: a.order } : !0);
      }
      return Object.assign(Object.assign({}, s), { sort: a });
    }
    return s;
  }
  const r = wp(n.map((s) => kN(s) || !("op" in s) || Cn(s.op) && s.op in HBr ? s : (Zt(j1r(s)), !0)), _i);
  let i;
  r.length === 1 ? i = r[0] : r.length > 1 && (Zt(PFe), i = !0);
  const o = wp(t.map((s) => uI(s) ? s.data : null), (s) => s);
  return o.length === 1 && o[0] !== null ? Object.assign({ data: o[0], fields: e.map((a) => a.field) }, i ? { sort: i } : {}) : Object.assign({ fields: e }, i ? { sort: i } : {});
}
function BIe(t) {
  if (uI(t) && Cn(t.field))
    return t.field;
  if (VBr(t)) {
    let e;
    for (const n of t.fields)
      if (uI(n) && Cn(n.field)) {
        if (!e)
          e = n.field;
        else if (e !== n.field)
          return Zt(Y1r), e;
      }
    return Zt(z1r), e;
  } else if (JBr(t)) {
    Zt(V1r);
    const e = t.fields[0];
    return Cn(e) ? e : void 0;
  }
}
function qY(t, e) {
  const r = t.component.scales[e].get("domains").map((i) => (uI(i) && (i.data = t.lookupDataSource(i.data)), i));
  return vxr(r);
}
var Bxr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function blt(t) {
  return Lx(t) || bIe(t) ? t.children.reduce((e, n) => e.concat(blt(n)), SPe(t)) : SPe(t);
}
function SPe(t) {
  return Kt(t.component.scales).reduce((e, n) => {
    const r = t.component.scales[n];
    if (r.merged)
      return e;
    const i = r.combine(), { name: o, type: s, selectionExtent: a, domains: A, range: l, reverse: c } = i, u = Bxr(i, ["name", "type", "selectionExtent", "domains", "range", "reverse"]), f = bxr(i.range, o, n, t), h = qY(t, n), d = a ? hQr(t, a, r, h) : null;
    return e.push(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      name: o,
      type: s
    }, h ? { domain: h } : {}), d ? { domainRaw: d } : {}), { range: f }), c !== void 0 ? { reverse: c } : {}), u)), e;
  }, []);
}
function bxr(t, e, n, r) {
  if (GA(n)) {
    if (ZE(t))
      return {
        step: { signal: `${e}_step` }
      };
  } else if (_n(t) && uI(t))
    return Object.assign(Object.assign({}, t), { data: r.lookupDataSource(t.data) });
  return t;
}
class _lt extends dm {
  constructor(e, n) {
    super(
      {},
      // no initial explicit property
      { name: e }
      // name as initial implicit property
    ), this.merged = !1, this.setWithExplicit("type", n);
  }
  /**
   * Whether the scale definitely includes zero in the domain
   */
  domainDefinitelyIncludesZero() {
    return this.get("zero") !== !1 ? !0 : xB(this.get("domains"), (e) => Nt(e) && e.length === 2 && e[0] <= 0 && e[1] >= 0);
  }
}
const _xr = ["range", "scheme"];
function Sxr(t) {
  const e = t.component.scales;
  for (const n of vY) {
    const r = e[n];
    if (!r)
      continue;
    const i = Qxr(n, t);
    r.setWithExplicit("range", i);
  }
}
function QPe(t, e) {
  const n = t.fieldDef(e);
  if (n?.bin) {
    const { bin: r, field: i } = n, o = ju(e), s = t.getName(o);
    if (_n(r) && r.binned && r.step !== void 0)
      return new Lu(() => {
        const a = t.scaleName(e), A = `(domain("${a}")[1] - domain("${a}")[0]) / ${r.step}`;
        return `${t.getSignalName(s)} / (${A})`;
      });
    if (Zo(r)) {
      const a = CIe(t, i, r);
      return new Lu(() => {
        const A = t.getSignalName(a), l = `(${A}.stop - ${A}.start) / ${A}.step`;
        return `${t.getSignalName(s)} / (${l})`;
      });
    }
  }
}
function Qxr(t, e) {
  const n = e.specifiedScales[t], { size: r } = e, o = e.getScaleComponent(t).get("type");
  for (const u of _xr)
    if (n[u] !== void 0) {
      const f = _oe(o, u), h = Bat(t, u);
      if (!f)
        Zt(sat(o, u, t));
      else if (h)
        Zt(h);
      else
        switch (u) {
          case "range": {
            const d = n.range;
            if (Nt(d)) {
              if (GA(t))
                return cp(d.map((I) => {
                  if (I === "width" || I === "height") {
                    const m = e.getName(I), C = e.getSignalName.bind(e);
                    return Lu.fromName(C, m);
                  }
                  return I;
                }));
            } else if (_n(d))
              return cp({
                data: e.requestDataName(Wo.Main),
                field: d.field,
                sort: { op: "min", field: e.vgField(t) }
              });
            return cp(d);
          }
          case "scheme":
            return cp(wxr(n[u]));
        }
    }
  const s = t === ta || t === "xOffset" ? "width" : "height", a = r[s];
  if (n0(a)) {
    if (GA(t))
      if (UA(o)) {
        const u = Slt(a, e, t);
        if (u)
          return cp({ step: u });
      } else
        Zt(aat(s));
    else if (wx(t)) {
      const u = t === YE ? "x" : "y";
      if (e.getScaleComponent(u).get("type") === "band") {
        const d = Qlt(a, o);
        if (d)
          return cp(d);
      }
    }
  }
  const { rangeMin: A, rangeMax: l } = n, c = xxr(t, e);
  return (A !== void 0 || l !== void 0) && // it's ok to check just rangeMin's compatibility since rangeMin/rangeMax are the same
  _oe(o, "rangeMin") && Nt(c) && c.length === 2 ? cp([A ?? c[0], l ?? c[1]]) : df(c);
}
function wxr(t) {
  return Nbr(t) ? Object.assign({ scheme: t.name }, Ff(t, ["name"])) : { scheme: t };
}
function xxr(t, e) {
  const { size: n, config: r, mark: i, encoding: o } = e, s = e.getSignalName.bind(e), { type: a } = gA(o[t]), l = e.getScaleComponent(t).get("type"), { domain: c, domainMid: u } = e.specifiedScales[t];
  switch (t) {
    case ta:
    case kA: {
      if (wi(["point", "band"], l)) {
        const d = wlt(t, n, r.view);
        if (n0(d))
          return { step: Slt(d, e, t) };
      }
      const f = ju(t), h = e.getName(f);
      return t === kA && qf(l) ? [Lu.fromName(s, h), 0] : [0, Lu.fromName(s, h)];
    }
    case YE:
    case Qx:
      return Rxr(t, e, l);
    case um: {
      const f = e.component.scales[t].get("zero"), h = xlt(i, f, r), d = Nxr(i, n, e, r);
      return FQ(l) ? Txr(h, d, Dxr(l, r, c, t)) : [h, d];
    }
    case Zg:
      return [0, Math.PI * 2];
    case R1:
      return [0, 360];
    case Gd:
      return [
        0,
        new Lu(() => {
          const f = e.getSignalName("width"), h = e.getSignalName("height");
          return `min(${f},${h})/2`;
        })
      ];
    case JE:
      return [r.scale.minStrokeWidth, r.scale.maxStrokeWidth];
    case KE:
      return [
        // TODO: add this to Vega's config.range?
        [1, 0],
        [4, 2],
        [2, 1],
        [1, 1],
        [1, 2, 4, 2]
      ];
    case qu:
      return "symbol";
    case $u:
    case v0:
    case B0:
      return l === "ordinal" ? a === "nominal" ? "category" : "ordinal" : u !== void 0 ? "diverging" : i === "rect" || i === "geoshape" ? "heatmap" : "ramp";
    case fm:
    case zE:
    case VE:
      return [r.scale.minOpacity, r.scale.maxOpacity];
  }
}
function Slt(t, e, n) {
  var r, i, o, s, a;
  const { encoding: A } = e, l = e.getScaleComponent(n), c = Ust(n), u = A[c];
  if (dAt({ step: t, offsetIsDiscrete: $r(u) && Iat(u.type) }) === "offset" && Kat(A, c)) {
    const h = e.getScaleComponent(c);
    let I = `domain('${e.scaleName(c)}').length`;
    if (h.get("type") === "band") {
      const C = (i = (r = h.get("paddingInner")) !== null && r !== void 0 ? r : h.get("padding")) !== null && i !== void 0 ? i : 0, y = (s = (o = h.get("paddingOuter")) !== null && o !== void 0 ? o : h.get("padding")) !== null && s !== void 0 ? s : 0;
      I = `bandspace(${I}, ${C}, ${y})`;
    }
    const m = (a = l.get("paddingInner")) !== null && a !== void 0 ? a : l.get("padding");
    return {
      signal: `${t.step} * ${I} / (1-${ZBr(m)})`
    };
  } else
    return t.step;
}
function Qlt(t, e) {
  if (dAt({ step: t, offsetIsDiscrete: UA(e) }) === "offset")
    return { step: t.step };
}
function Rxr(t, e, n) {
  const r = t === YE ? "x" : "y", o = e.getScaleComponent(r).get("type"), s = e.scaleName(r);
  if (o === "band") {
    const a = wlt(r, e.size, e.config.view);
    if (n0(a)) {
      const A = Qlt(a, n);
      if (A)
        return A;
    }
    return [0, { signal: `bandwidth('${s}')` }];
  } else
    return wst(`Cannot use ${t} scale if ${r} scale is not discrete.`);
}
function wlt(t, e, n) {
  const r = t === ta ? "width" : "height", i = e[r];
  return i || U6(n, r);
}
function Dxr(t, e, n, r) {
  switch (t) {
    case "quantile":
      return e.scale.quantileCount;
    case "quantize":
      return e.scale.quantizeCount;
    case "threshold":
      return n !== void 0 && Nt(n) ? n.length + 1 : (Zt(rbr(r)), 3);
  }
}
function Txr(t, e, n) {
  const r = () => {
    const i = bI(e), o = bI(t), s = `(${i} - ${o}) / (${n} - 1)`;
    return `sequence(${o}, ${i} + ${s}, ${s})`;
  };
  return Jn(e) ? new Lu(r) : { signal: r() };
}
function xlt(t, e, n) {
  if (e)
    return Jn(e) ? { signal: `${e.signal} ? 0 : ${xlt(t, !1, n)}` } : 0;
  switch (t) {
    case "bar":
    case "tick":
      return n.scale.minBandSize;
    case "line":
    case "trail":
    case "rule":
      return n.scale.minStrokeWidth;
    case "text":
      return n.scale.minFontSize;
    case "point":
    case "square":
    case "circle":
      return n.scale.minSize;
  }
  throw new Error(bY("size", t));
}
const wPe = 0.95;
function Nxr(t, e, n, r) {
  const i = {
    x: QPe(n, "x"),
    y: QPe(n, "y")
  };
  switch (t) {
    case "bar":
    case "tick": {
      if (r.scale.maxBandSize !== void 0)
        return r.scale.maxBandSize;
      const o = xPe(e, i, r.view);
      return Po(o) ? o - 1 : new Lu(() => `${o.signal} - 1`);
    }
    case "line":
    case "trail":
    case "rule":
      return r.scale.maxStrokeWidth;
    case "text":
      return r.scale.maxFontSize;
    case "point":
    case "square":
    case "circle": {
      if (r.scale.maxSize)
        return r.scale.maxSize;
      const o = xPe(e, i, r.view);
      return Po(o) ? Math.pow(wPe * o, 2) : new Lu(() => `pow(${wPe} * ${o.signal}, 2)`);
    }
  }
  throw new Error(bY("size", t));
}
function xPe(t, e, n) {
  const r = n0(t.width) ? t.width.step : G6(n, "width"), i = n0(t.height) ? t.height.step : G6(n, "height");
  return e.x || e.y ? new Lu(() => `min(${[
    e.x ? e.x.signal : r,
    e.y ? e.y.signal : i
  ].join(", ")})`) : Math.min(r, i);
}
function Rlt(t, e) {
  $a(t) ? Lxr(t, e) : Tlt(t, e);
}
function Lxr(t, e) {
  const n = t.component.scales, { config: r, encoding: i, markDef: o, specifiedScales: s } = t;
  for (const a of Kt(n)) {
    const A = s[a], l = n[a], c = t.getScaleComponent(a), u = gA(i[a]), f = A[e], h = c.get("type"), d = c.get("padding"), I = c.get("paddingInner"), m = _oe(h, e), C = Bat(a, e);
    if (f !== void 0 && (m ? C && Zt(C) : Zt(sat(h, e, a))), m && C === void 0)
      if (f !== void 0) {
        const y = u.timeUnit, v = u.type;
        switch (e) {
          case "domainMax":
          case "domainMin":
            N1(A[e]) || v === "temporal" || y ? l.set(e, { signal: LY(A[e], { type: v, timeUnit: y }) }, !0) : l.set(e, A[e], !0);
            break;
          default:
            l.copyKeyFromObject(e, A);
        }
      } else {
        const y = e in RPe ? RPe[e]({
          model: t,
          channel: a,
          fieldOrDatumDef: u,
          scaleType: h,
          scalePadding: d,
          scalePaddingInner: I,
          domain: A.domain,
          domainMin: A.domainMin,
          domainMax: A.domainMax,
          markDef: o,
          config: r,
          hasNestedOffsetScale: xoe(i, a)
        }) : r.scale[e];
        y !== void 0 && l.set(e, y, !1);
      }
  }
}
const RPe = {
  bins: ({ model: t, fieldOrDatumDef: e }) => sn(e) ? Mxr(t, e) : void 0,
  interpolate: ({ channel: t, fieldOrDatumDef: e }) => Oxr(t, e.type),
  nice: ({ scaleType: t, channel: e, domain: n, domainMin: r, domainMax: i, fieldOrDatumDef: o }) => Fxr(t, e, n, r, i, o),
  padding: ({ channel: t, scaleType: e, fieldOrDatumDef: n, markDef: r, config: i }) => Pxr(t, e, i.scale, n, r, i.bar),
  paddingInner: ({ scalePadding: t, channel: e, markDef: n, scaleType: r, config: i, hasNestedOffsetScale: o }) => kxr(t, e, n.type, r, i.scale, o),
  paddingOuter: ({ scalePadding: t, channel: e, scaleType: n, scalePaddingInner: r, config: i, hasNestedOffsetScale: o }) => Gxr(t, e, n, r, i.scale, o),
  reverse: ({ fieldOrDatumDef: t, scaleType: e, channel: n, config: r }) => {
    const i = sn(t) ? t.sort : void 0;
    return Uxr(e, i, n, r.scale);
  },
  zero: ({ channel: t, fieldOrDatumDef: e, domain: n, markDef: r, scaleType: i }) => Hxr(t, e, n, r, i)
};
function Dlt(t) {
  $a(t) ? Sxr(t) : Tlt(t, "range");
}
function Tlt(t, e) {
  const n = t.component.scales;
  for (const r of t.children)
    e === "range" ? Dlt(r) : Rlt(r, e);
  for (const r of Kt(n)) {
    let i;
    for (const o of t.children) {
      const s = o.component.scales[r];
      if (s) {
        const a = s.getWithExplicit(e);
        i = hE(i, a, e, "scale", xAt((A, l) => {
          switch (e) {
            case "range":
              return A.step && l.step ? A.step - l.step : 0;
          }
          return 0;
        }));
      }
    }
    n[r].setWithExplicit(e, i);
  }
}
function Mxr(t, e) {
  const n = e.bin;
  if (Zo(n)) {
    const r = CIe(t, e.field, n);
    return new Lu(() => t.getSignalName(r));
  } else if (Pc(n) && T1(n) && n.step !== void 0)
    return {
      step: n.step
    };
}
function Oxr(t, e) {
  if (wi([$u, v0, B0], t) && e !== "nominal")
    return "hcl";
}
function Fxr(t, e, n, r, i, o) {
  var s;
  if (!(!((s = e0(o)) === null || s === void 0) && s.bin || Nt(n) || i != null || r != null || wi([Nu.TIME, Nu.UTC], t)))
    return GA(e) ? !0 : void 0;
}
function Pxr(t, e, n, r, i, o) {
  if (GA(t)) {
    if (Xh(e)) {
      if (n.continuousPadding !== void 0)
        return n.continuousPadding;
      const { type: s, orient: a } = i;
      if (s === "bar" && !(sn(r) && (r.bin || r.timeUnit)) && (a === "vertical" && t === "x" || a === "horizontal" && t === "y"))
        return o.continuousBandSize;
    }
    if (e === Nu.POINT)
      return n.pointPadding;
  }
}
function kxr(t, e, n, r, i, o = !1) {
  if (t === void 0) {
    if (GA(e)) {
      const { bandPaddingInner: s, barBandPaddingInner: a, rectBandPaddingInner: A, bandWithNestedOffsetPaddingInner: l } = i;
      return o ? l : Va(s, n === "bar" ? a : A);
    } else if (wx(e) && r === Nu.BAND)
      return i.offsetBandPaddingInner;
  }
}
function Gxr(t, e, n, r, i, o = !1) {
  if (t === void 0) {
    if (GA(e)) {
      const { bandPaddingOuter: s, bandWithNestedOffsetPaddingOuter: a } = i;
      if (o)
        return a;
      if (n === Nu.BAND)
        return Va(
          s,
          /* By default, paddingOuter is paddingInner / 2. The reason is that
            size (width/height) = step * (cardinality - paddingInner + 2 * paddingOuter).
            and we want the width/height to be integer by default.
            Note that step (by default) and cardinality are integers.) */
          Jn(r) ? { signal: `${r.signal}/2` } : r / 2
        );
    } else if (wx(e)) {
      if (n === Nu.POINT)
        return 0.5;
      if (n === Nu.BAND)
        return i.offsetBandPaddingOuter;
    }
  }
}
function Uxr(t, e, n, r) {
  if (n === "x" && r.xReverse !== void 0)
    return qf(t) && e === "descending" ? Jn(r.xReverse) ? { signal: `!${r.xReverse.signal}` } : !r.xReverse : r.xReverse;
  if (qf(t) && e === "descending")
    return !0;
}
function Hxr(t, e, n, r, i) {
  if (!!n && n !== "unaggregated" && qf(i)) {
    if (Nt(n)) {
      const s = n[0], a = n[n.length - 1];
      if (s <= 0 && a >= 0)
        return !0;
    }
    return !1;
  }
  if (t === "size" && e.type === "quantitative" && !FQ(i))
    return !0;
  if (!(sn(e) && e.bin) && wi([...b0, ...LBr], t)) {
    const { orient: s, type: a } = r;
    return !(wi(["bar", "area", "line", "trail"], a) && (s === "horizontal" && t === "y" || s === "vertical" && t === "x"));
  }
  return !1;
}
function $xr(t, e, n, r, i = !1) {
  const o = qxr(e, n, r, i), { type: s } = t;
  return WE(e) ? s !== void 0 ? Gbr(e, s) ? sn(n) && !kbr(s, n.type) ? (Zt(U1r(s, o)), o) : s : (Zt(G1r(e, s, o)), o) : o : null;
}
function qxr(t, e, n, r) {
  var i;
  switch (e.type) {
    case "nominal":
    case "ordinal": {
      if (fS(t) || AX(t) === "discrete")
        return t === "shape" && e.type === "ordinal" && Zt(lX(t, "ordinal")), "ordinal";
      if (GA(t) || wx(t)) {
        if (wi(["rect", "bar", "image", "rule"], n.type) || r)
          return "band";
      } else if (n.type === "arc" && t in C0e)
        return "band";
      const o = n[ju(t)];
      return LB(o) || kQ(e) && (!((i = e.axis) === null || i === void 0) && i.tickBand) ? "band" : "point";
    }
    case "temporal":
      return fS(t) ? "time" : AX(t) === "discrete" ? (Zt(lX(t, "temporal")), "ordinal") : sn(e) && e.timeUnit && cc(e.timeUnit).utc ? "utc" : "time";
    case "quantitative":
      return fS(t) ? sn(e) && Zo(e.bin) ? "bin-ordinal" : "linear" : AX(t) === "discrete" ? (Zt(lX(t, "quantitative")), "ordinal") : "linear";
    case "geojson":
      return;
  }
  throw new Error(iat(e.type));
}
function jxr(t, { ignoreRange: e } = {}) {
  Nlt(t), Blt(t);
  for (const n of Pbr)
    Rlt(t, n);
  e || Dlt(t);
}
function Nlt(t) {
  $a(t) ? t.component.scales = Yxr(t) : t.component.scales = Vxr(t);
}
function Yxr(t) {
  const { encoding: e, mark: n, markDef: r } = t, i = {};
  for (const o of vY) {
    const s = gA(e[o]);
    if (s && n === Sat && o === qu && s.type === xx)
      continue;
    let a = s && s.scale;
    if (wx(o)) {
      const A = Hst(o);
      if (!xoe(e, A)) {
        a && Zt(S1r(o));
        continue;
      }
    }
    if (s && a !== null && a !== !1) {
      a ?? (a = {});
      const A = xoe(e, o), l = $xr(a, o, s, r, A);
      i[o] = new _lt(t.scaleName(`${o}`, !0), {
        value: l,
        explicit: a.type === l
      });
    }
  }
  return i;
}
const zxr = xAt((t, e) => GFe(t) - GFe(e));
function Vxr(t) {
  var e, n;
  const r = t.component.scales = {}, i = {}, o = t.component.resolve;
  for (const s of t.children) {
    Nlt(s);
    for (const a of Kt(s.component.scales))
      if ((e = (n = o.scale)[a]) !== null && e !== void 0 || (n[a] = clt(a, t)), o.scale[a] === "shared") {
        const A = i[a], l = s.component.scales[a].getWithExplicit("type");
        A ? wbr(A.value, l.value) ? i[a] = hE(A, l, "type", "scale", zxr) : (o.scale[a] = "independent", delete i[a]) : i[a] = l;
      }
  }
  for (const s of Kt(i)) {
    const a = t.scaleName(s, !0), A = i[s];
    r[s] = new _lt(a, A);
    for (const l of t.children) {
      const c = l.component.scales[s];
      c && (l.renameScale(c.get("name"), a), c.merged = !0);
    }
  }
  return r;
}
var IX = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
class mX {
  constructor() {
    this.nameMap = {};
  }
  rename(e, n) {
    this.nameMap[e] = n;
  }
  has(e) {
    return this.nameMap[e] !== void 0;
  }
  get(e) {
    for (; this.nameMap[e] && e !== this.nameMap[e]; )
      e = this.nameMap[e];
    return e;
  }
}
function $a(t) {
  return t?.type === "unit";
}
function Ad(t) {
  return t?.type === "facet";
}
function bIe(t) {
  return t?.type === "concat";
}
function Lx(t) {
  return t?.type === "layer";
}
class _Ie {
  constructor(e, n, r, i, o, s, a) {
    var A, l;
    this.type = n, this.parent = r, this.config = o, this.correctDataNames = (c) => {
      var u, f, h;
      return !((u = c.from) === null || u === void 0) && u.data && (c.from.data = this.lookupDataSource(c.from.data)), !((h = (f = c.from) === null || f === void 0 ? void 0 : f.facet) === null || h === void 0) && h.data && (c.from.facet.data = this.lookupDataSource(c.from.facet.data)), c;
    }, this.parent = r, this.config = o, this.view = Bu(a), this.name = (A = e.name) !== null && A !== void 0 ? A : i, this.title = Zm(e.title) ? { text: e.title } : e.title ? Bu(e.title) : void 0, this.scaleNameMap = r ? r.scaleNameMap : new mX(), this.projectionNameMap = r ? r.projectionNameMap : new mX(), this.signalNameMap = r ? r.signalNameMap : new mX(), this.data = e.data, this.description = e.description, this.transforms = WSr((l = e.transform) !== null && l !== void 0 ? l : []), this.layout = n === "layer" || n === "unit" ? {} : rSr(e, n, o), this.component = {
      data: {
        sources: r ? r.component.data.sources : [],
        outputNodes: r ? r.component.data.outputNodes : {},
        outputNodeRefCounts: r ? r.component.data.outputNodeRefCounts : {},
        // data is faceted if the spec is a facet spec or the parent has faceted data and data is undefined
        isFaceted: RY(e) || r?.component.data.isFaceted && e.data === void 0
      },
      layoutSize: new dm(),
      layoutHeaders: { row: {}, column: {}, facet: {} },
      mark: null,
      resolve: Object.assign({ scale: {}, axis: {}, legend: {} }, s ? Kr(s) : {}),
      selection: null,
      scales: null,
      projection: null,
      axes: {},
      legends: {}
    };
  }
  get width() {
    return this.getSizeSignalRef("width");
  }
  get height() {
    return this.getSizeSignalRef("height");
  }
  parse() {
    this.parseScale(), this.parseLayoutSize(), this.renameTopLevelLayoutSizeSignal(), this.parseSelections(), this.parseProjection(), this.parseData(), this.parseAxesAndHeaders(), this.parseLegends(), this.parseMarkGroup();
  }
  parseScale() {
    jxr(this);
  }
  parseProjection() {
    Elt(this);
  }
  /**
   * Rename top-level spec's size to be just width / height, ignoring model name.
   * This essentially merges the top-level spec's width/height signals with the width/height signals
   * to help us reduce redundant signals declaration.
   */
  renameTopLevelLayoutSizeSignal() {
    this.getName("width") !== "width" && this.renameSignal(this.getName("width"), "width"), this.getName("height") !== "height" && this.renameSignal(this.getName("height"), "height");
  }
  parseLegends() {
    dlt(this);
  }
  assembleEncodeFromView(e) {
    const n = IX(e, ["style"]), r = {};
    for (const i of Kt(n)) {
      const o = n[i];
      o !== void 0 && (r[i] = hs(o));
    }
    return r;
  }
  assembleGroupEncodeEntry(e) {
    let n = {};
    return this.view && (n = this.assembleEncodeFromView(this.view)), !e && (this.description && (n.description = hs(this.description)), this.type === "unit" || this.type === "layer") ? Object.assign({ width: this.getSizeSignalRef("width"), height: this.getSizeSignalRef("height") }, n ?? {}) : Oo(n) ? void 0 : n;
  }
  assembleLayout() {
    if (!this.layout)
      return;
    const e = this.layout, { spacing: n } = e, r = IX(e, ["spacing"]), { component: i, config: o } = this, s = uwr(i.layoutHeaders, o);
    return Object.assign(Object.assign(Object.assign({ padding: n }, this.assembleDefaultLayout()), r), s ? { titleBand: s } : {});
  }
  assembleDefaultLayout() {
    return {};
  }
  assembleHeaderMarks() {
    const { layoutHeaders: e } = this.component;
    let n = [];
    for (const r of Rg)
      e[r].title && n.push(owr(this, r));
    for (const r of dIe)
      n = n.concat(swr(this, r));
    return n;
  }
  assembleAxes() {
    return zQr(this.component.axes, this.config);
  }
  assembleLegends() {
    return Ilt(this);
  }
  assembleProjections() {
    return Mwr(this);
  }
  assembleTitle() {
    var e, n, r;
    const i = (e = this.title) !== null && e !== void 0 ? e : {}, { encoding: o } = i, s = IX(i, ["encoding"]), a = Object.assign(Object.assign(Object.assign({}, Jst(this.config.title).nonMarkTitleProperties), s), o ? { encode: { update: o } } : {});
    if (a.text)
      return wi(["unit", "layer"], this.type) ? wi(["middle", void 0], a.anchor) && ((n = a.frame) !== null && n !== void 0 || (a.frame = "group")) : (r = a.anchor) !== null && r !== void 0 || (a.anchor = "start"), Oo(a) ? void 0 : a;
  }
  /**
   * Assemble the mark group for this model. We accept optional `signals` so that we can include concat top-level signals with the top-level model's local signals.
   */
  assembleGroup(e = []) {
    const n = {};
    e = e.concat(this.assembleSignals()), e.length > 0 && (n.signals = e);
    const r = this.assembleLayout();
    r && (n.layout = r), n.marks = [].concat(this.assembleHeaderMarks(), this.assembleMarks());
    const i = !this.parent || Ad(this.parent) ? blt(this) : [];
    i.length > 0 && (n.scales = i);
    const o = this.assembleAxes();
    o.length > 0 && (n.axes = o);
    const s = this.assembleLegends();
    return s.length > 0 && (n.legends = s), n;
  }
  getName(e) {
    return Ls((this.name ? `${this.name}_` : "") + e);
  }
  getDataName(e) {
    return this.getName(Wo[e].toLowerCase());
  }
  /**
   * Request a data source name for the given data source type and mark that data source as required.
   * This method should be called in parse, so that all used data source can be correctly instantiated in assembleData().
   * You can lookup the correct dataset name in assemble with `lookupDataSource`.
   */
  requestDataName(e) {
    const n = this.getDataName(e), r = this.component.data.outputNodeRefCounts;
    return r[n] = (r[n] || 0) + 1, n;
  }
  getSizeSignalRef(e) {
    if (Ad(this.parent)) {
      const n = Alt(e), r = yY(n), i = this.component.scales[r];
      if (i && !i.merged) {
        const o = i.get("type"), s = i.get("range");
        if (UA(o) && ZE(s)) {
          const a = i.get("name"), A = qY(this, r), l = BIe(A);
          if (l) {
            const c = fn({ aggregate: "distinct", field: l }, { expr: "datum" });
            return {
              signal: alt(a, i, c)
            };
          } else
            return Zt(B0e(r)), null;
        }
      }
    }
    return {
      signal: this.signalNameMap.get(this.getName(e))
    };
  }
  /**
   * Lookup the name of the datasource for an output node. You probably want to call this in assemble.
   */
  lookupDataSource(e) {
    const n = this.component.data.outputNodes[e];
    return n ? n.getSource() : e;
  }
  getSignalName(e) {
    return this.signalNameMap.get(e);
  }
  renameSignal(e, n) {
    this.signalNameMap.rename(e, n);
  }
  renameScale(e, n) {
    this.scaleNameMap.rename(e, n);
  }
  renameProjection(e, n) {
    this.projectionNameMap.rename(e, n);
  }
  /**
   * @return scale name for a given channel after the scale has been parsed and named.
   */
  scaleName(e, n) {
    if (n)
      return this.getName(e);
    if (
      // If there is a scale for the channel, there should be a local scale component for it
      kst(e) && WE(e) && this.component.scales[e] || // in the scale name map (the scale get merged by its parent)
      this.scaleNameMap.has(this.getName(e))
    )
      return this.scaleNameMap.get(this.getName(e));
  }
  /**
   * @return projection name after the projection has been parsed and named.
   */
  projectionName(e) {
    if (e)
      return this.getName("projection");
    if (this.component.projection && !this.component.projection.merged || this.projectionNameMap.has(this.getName("projection")))
      return this.projectionNameMap.get(this.getName("projection"));
  }
  /**
   * Traverse a model's hierarchy to get the scale component for a particular channel.
   */
  getScaleComponent(e) {
    if (!this.component.scales)
      throw new Error("getScaleComponent cannot be called before parseScale(). Make sure you have called parseScale or use parseUnitModelWithScale().");
    const n = this.component.scales[e];
    return n && !n.merged ? n : this.parent ? this.parent.getScaleComponent(e) : void 0;
  }
  /**
   * Traverse a model's hierarchy to get a particular selection component.
   */
  getSelectionComponent(e, n) {
    let r = this.component.selection[e];
    if (!r && this.parent && (r = this.parent.getSelectionComponent(e, n)), !r)
      throw new Error(i1r(n));
    return r;
  }
  /**
   * Returns true if the model has a signalRef for an axis orient.
   */
  hasAxisOrientSignalRef() {
    var e, n;
    return ((e = this.component.axes.x) === null || e === void 0 ? void 0 : e.some((r) => r.hasOrientSignalRef())) || ((n = this.component.axes.y) === null || n === void 0 ? void 0 : n.some((r) => r.hasOrientSignalRef()));
  }
}
class Llt extends _Ie {
  /** Get "field" reference for Vega */
  vgField(e, n = {}) {
    const r = this.fieldDef(e);
    if (r)
      return fn(r, n);
  }
  reduceFieldDef(e, n) {
    return D_r(this.getMapping(), (r, i, o) => {
      const s = e0(i);
      return s ? e(r, s, o) : r;
    }, n);
  }
  forEachFieldDef(e, n) {
    W0e(this.getMapping(), (r, i) => {
      const o = e0(r);
      o && e(o, i);
    }, n);
  }
}
var Jxr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
class jY extends Uo {
  constructor(e, n) {
    var r, i, o;
    super(e), this.transform = n, this.transform = Kr(n);
    const s = (r = this.transform.as) !== null && r !== void 0 ? r : [void 0, void 0];
    this.transform.as = [(i = s[0]) !== null && i !== void 0 ? i : "value", (o = s[1]) !== null && o !== void 0 ? o : "density"], n.groupby && n.minsteps == null && n.maxsteps == null && n.steps == null && (this.transform.steps = 200);
  }
  clone() {
    return new jY(null, Kr(this.transform));
  }
  dependentFields() {
    var e;
    return /* @__PURE__ */ new Set([this.transform.density, ...(e = this.transform.groupby) !== null && e !== void 0 ? e : []]);
  }
  producedFields() {
    return new Set(this.transform.as);
  }
  hash() {
    return `DensityTransform ${_i(this.transform)}`;
  }
  assemble() {
    const e = this.transform, { density: n } = e, r = Jxr(e, ["density"]);
    return Object.assign({ type: "kde", field: n }, r);
  }
}
class qN extends Uo {
  constructor(e, n) {
    super(e), this.filter = n;
  }
  clone() {
    return new qN(null, Object.assign({}, this.filter));
  }
  static make(e, n) {
    const { config: r, mark: i, markDef: o } = n;
    if (Co("invalid", o, r) !== "filter")
      return null;
    const a = n.reduceFieldDef((A, l, c) => {
      const u = WE(c) && n.getScaleComponent(c);
      if (u) {
        const f = u.get("type");
        qf(f) && l.aggregate !== "count" && !ey(i) && (A[l.field] = l);
      }
      return A;
    }, {});
    return Kt(a).length ? new qN(e, a) : null;
  }
  dependentFields() {
    return new Set(Kt(this.filter));
  }
  producedFields() {
    return /* @__PURE__ */ new Set();
  }
  hash() {
    return `FilterInvalid ${_i(this.filter)}`;
  }
  /**
   * Create the VgTransforms for each of the filtered fields.
   */
  assemble() {
    const e = Kt(this.filter).reduce((n, r) => {
      const i = this.filter[r], o = fn(i, { expr: "datum" });
      return i !== null && (i.type === "temporal" ? n.push(`(isDate(${o}) || (isValid(${o}) && isFinite(+${o})))`) : i.type === "quantitative" && (n.push(`isValid(${o})`), n.push(`isFinite(+${o})`))), n;
    }, []);
    return e.length > 0 ? {
      type: "filter",
      expr: e.join(" && ")
    } : null;
  }
}
class YY extends Uo {
  constructor(e, n) {
    super(e), this.transform = n, this.transform = Kr(n);
    const { flatten: r, as: i = [] } = this.transform;
    this.transform.as = r.map((o, s) => {
      var a;
      return (a = i[s]) !== null && a !== void 0 ? a : o;
    });
  }
  clone() {
    return new YY(this.parent, Kr(this.transform));
  }
  dependentFields() {
    return new Set(this.transform.flatten);
  }
  producedFields() {
    return new Set(this.transform.as);
  }
  hash() {
    return `FlattenTransform ${_i(this.transform)}`;
  }
  assemble() {
    const { flatten: e, as: n } = this.transform;
    return {
      type: "flatten",
      fields: e,
      as: n
    };
  }
}
class zY extends Uo {
  constructor(e, n) {
    var r, i, o;
    super(e), this.transform = n, this.transform = Kr(n);
    const s = (r = this.transform.as) !== null && r !== void 0 ? r : [void 0, void 0];
    this.transform.as = [(i = s[0]) !== null && i !== void 0 ? i : "key", (o = s[1]) !== null && o !== void 0 ? o : "value"];
  }
  clone() {
    return new zY(null, Kr(this.transform));
  }
  dependentFields() {
    return new Set(this.transform.fold);
  }
  producedFields() {
    return new Set(this.transform.as);
  }
  hash() {
    return `FoldTransform ${_i(this.transform)}`;
  }
  assemble() {
    const { fold: e, as: n } = this.transform;
    return {
      type: "fold",
      fields: e,
      as: n
    };
  }
}
class dS extends Uo {
  constructor(e, n, r, i) {
    super(e), this.fields = n, this.geojson = r, this.signal = i;
  }
  clone() {
    return new dS(null, Kr(this.fields), this.geojson, this.signal);
  }
  static parseAll(e, n) {
    if (n.component.projection && !n.component.projection.isFit)
      return e;
    let r = 0;
    for (const i of [
      [y0, E0],
      [Jg, Ud]
    ]) {
      const o = i.map((s) => {
        const a = gA(n.encoding[s]);
        return sn(a) ? a.field : _0(a) ? { expr: `${a.datum}` } : Cd(a) ? { expr: `${a.value}` } : void 0;
      });
      (o[0] || o[1]) && (e = new dS(e, o, null, n.getName(`geojson_${r++}`)));
    }
    if (n.channelHasField(qu)) {
      const i = n.typedFieldDef(qu);
      i.type === xx && (e = new dS(e, null, i.field, n.getName(`geojson_${r++}`)));
    }
    return e;
  }
  dependentFields() {
    var e;
    const n = ((e = this.fields) !== null && e !== void 0 ? e : []).filter(Cn);
    return /* @__PURE__ */ new Set([...this.geojson ? [this.geojson] : [], ...n]);
  }
  producedFields() {
    return /* @__PURE__ */ new Set();
  }
  hash() {
    return `GeoJSON ${this.geojson} ${this.signal} ${_i(this.fields)}`;
  }
  assemble() {
    return [
      ...this.geojson ? [
        {
          type: "filter",
          expr: `isValid(datum["${this.geojson}"])`
        }
      ] : [],
      Object.assign(Object.assign(Object.assign({ type: "geojson" }, this.fields ? { fields: this.fields } : {}), this.geojson ? { geojson: this.geojson } : {}), { signal: this.signal })
    ];
  }
}
class jN extends Uo {
  constructor(e, n, r, i) {
    super(e), this.projection = n, this.fields = r, this.as = i;
  }
  clone() {
    return new jN(null, this.projection, Kr(this.fields), Kr(this.as));
  }
  static parseAll(e, n) {
    if (!n.projectionName())
      return e;
    for (const r of [
      [y0, E0],
      [Jg, Ud]
    ]) {
      const i = r.map((s) => {
        const a = gA(n.encoding[s]);
        return sn(a) ? a.field : _0(a) ? { expr: `${a.datum}` } : Cd(a) ? { expr: `${a.value}` } : void 0;
      }), o = r[0] === Jg ? "2" : "";
      (i[0] || i[1]) && (e = new jN(e, n.projectionName(), i, [
        n.getName(`x${o}`),
        n.getName(`y${o}`)
      ]));
    }
    return e;
  }
  dependentFields() {
    return new Set(this.fields.filter(Cn));
  }
  producedFields() {
    return new Set(this.as);
  }
  hash() {
    return `Geopoint ${this.projection} ${_i(this.fields)} ${_i(this.as)}`;
  }
  assemble() {
    return {
      type: "geopoint",
      projection: this.projection,
      fields: this.fields,
      as: this.as
    };
  }
}
class kv extends Uo {
  constructor(e, n) {
    super(e), this.transform = n;
  }
  clone() {
    return new kv(null, Kr(this.transform));
  }
  dependentFields() {
    var e;
    return /* @__PURE__ */ new Set([this.transform.impute, this.transform.key, ...(e = this.transform.groupby) !== null && e !== void 0 ? e : []]);
  }
  producedFields() {
    return /* @__PURE__ */ new Set([this.transform.impute]);
  }
  processSequence(e) {
    const { start: n = 0, stop: r, step: i } = e;
    return { signal: `sequence(${[n, r, ...i ? [i] : []].join(",")})` };
  }
  static makeFromTransform(e, n) {
    return new kv(e, n);
  }
  static makeFromEncoding(e, n) {
    const r = n.encoding, i = r.x, o = r.y;
    if (sn(i) && sn(o)) {
      const s = i.impute ? i : o.impute ? o : void 0;
      if (s === void 0)
        return;
      const a = i.impute ? o : o.impute ? i : void 0, { method: A, value: l, frame: c, keyvals: u } = s.impute, f = Xat(n.mark, r);
      return new kv(e, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ impute: s.field, key: a.field }, A ? { method: A } : {}), l !== void 0 ? { value: l } : {}), c ? { frame: c } : {}), u !== void 0 ? { keyvals: u } : {}), f.length ? { groupby: f } : {}));
    }
    return null;
  }
  hash() {
    return `Impute ${_i(this.transform)}`;
  }
  assemble() {
    const { impute: e, key: n, keyvals: r, method: i, groupby: o, value: s, frame: a = [null, null] } = this.transform, A = Object.assign(Object.assign(Object.assign(Object.assign({ type: "impute", field: e, key: n }, r ? { keyvals: NSr(r) ? this.processSequence(r) : r } : {}), { method: "value" }), o ? { groupby: o } : {}), { value: !i || i === "value" ? s : null });
    if (i && i !== "value") {
      const l = Object.assign({ type: "window", as: [`imputed_${e}_value`], ops: [i], fields: [e], frame: a, ignorePeers: !1 }, o ? { groupby: o } : {}), c = {
        type: "formula",
        expr: `datum.${e} === null ? datum.imputed_${e}_value : datum.${e}`,
        as: e
      };
      return [A, l, c];
    } else
      return [A];
  }
}
var Kxr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
class VY extends Uo {
  constructor(e, n) {
    var r, i, o;
    super(e), this.transform = n, this.transform = Kr(n);
    const s = (r = this.transform.as) !== null && r !== void 0 ? r : [void 0, void 0];
    this.transform.as = [(i = s[0]) !== null && i !== void 0 ? i : n.on, (o = s[1]) !== null && o !== void 0 ? o : n.loess];
  }
  clone() {
    return new VY(null, Kr(this.transform));
  }
  dependentFields() {
    var e;
    return /* @__PURE__ */ new Set([this.transform.loess, this.transform.on, ...(e = this.transform.groupby) !== null && e !== void 0 ? e : []]);
  }
  producedFields() {
    return new Set(this.transform.as);
  }
  hash() {
    return `LoessTransform ${_i(this.transform)}`;
  }
  assemble() {
    const e = this.transform, { loess: n, on: r } = e, i = Kxr(e, ["loess", "on"]);
    return Object.assign({ type: "loess", x: r, y: n }, i);
  }
}
class YN extends Uo {
  constructor(e, n, r) {
    super(e), this.transform = n, this.secondary = r;
  }
  clone() {
    return new YN(null, Kr(this.transform), this.secondary);
  }
  static make(e, n, r, i) {
    const o = n.component.data.sources, { from: s } = r;
    let a = null;
    if (LSr(s)) {
      let A = Flt(s.data, o);
      A || (A = new PB(s.data), o.push(A));
      const l = n.getName(`lookup_${i}`);
      a = new zc(A, l, Wo.Lookup, n.component.data.outputNodeRefCounts), n.component.data.outputNodes[l] = a;
    } else if (MSr(s)) {
      const A = s.param;
      r = Object.assign({ as: A }, r);
      let l;
      try {
        l = n.getSelectionComponent(Ls(A), A);
      } catch {
        throw new Error(a1r(A));
      }
      if (a = l.materialized, !a)
        throw new Error(A1r(A));
    }
    return new YN(e, r, a.getSource());
  }
  dependentFields() {
    return /* @__PURE__ */ new Set([this.transform.lookup]);
  }
  producedFields() {
    return new Set(this.transform.as ? bn(this.transform.as) : this.transform.from.fields);
  }
  hash() {
    return `Lookup ${_i({ transform: this.transform, secondary: this.secondary })}`;
  }
  assemble() {
    let e;
    if (this.transform.from.fields)
      e = Object.assign({ values: this.transform.from.fields }, this.transform.as ? { as: bn(this.transform.as) } : {});
    else {
      let n = this.transform.as;
      Cn(n) || (Zt(p1r), n = "_lookup"), e = {
        as: [n]
      };
    }
    return Object.assign(Object.assign({ type: "lookup", from: this.secondary, key: this.transform.from.key, fields: [this.transform.lookup] }, e), this.transform.default ? { default: this.transform.default } : {});
  }
}
var Wxr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
class JY extends Uo {
  constructor(e, n) {
    var r, i, o;
    super(e), this.transform = n, this.transform = Kr(n);
    const s = (r = this.transform.as) !== null && r !== void 0 ? r : [void 0, void 0];
    this.transform.as = [(i = s[0]) !== null && i !== void 0 ? i : "prob", (o = s[1]) !== null && o !== void 0 ? o : "value"];
  }
  clone() {
    return new JY(null, Kr(this.transform));
  }
  dependentFields() {
    var e;
    return /* @__PURE__ */ new Set([this.transform.quantile, ...(e = this.transform.groupby) !== null && e !== void 0 ? e : []]);
  }
  producedFields() {
    return new Set(this.transform.as);
  }
  hash() {
    return `QuantileTransform ${_i(this.transform)}`;
  }
  assemble() {
    const e = this.transform, { quantile: n } = e, r = Wxr(e, ["quantile"]);
    return Object.assign({ type: "quantile", field: n }, r);
  }
}
var Xxr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
class KY extends Uo {
  constructor(e, n) {
    var r, i, o;
    super(e), this.transform = n, this.transform = Kr(n);
    const s = (r = this.transform.as) !== null && r !== void 0 ? r : [void 0, void 0];
    this.transform.as = [(i = s[0]) !== null && i !== void 0 ? i : n.on, (o = s[1]) !== null && o !== void 0 ? o : n.regression];
  }
  clone() {
    return new KY(null, Kr(this.transform));
  }
  dependentFields() {
    var e;
    return /* @__PURE__ */ new Set([this.transform.regression, this.transform.on, ...(e = this.transform.groupby) !== null && e !== void 0 ? e : []]);
  }
  producedFields() {
    return new Set(this.transform.as);
  }
  hash() {
    return `RegressionTransform ${_i(this.transform)}`;
  }
  assemble() {
    const e = this.transform, { regression: n, on: r } = e, i = Xxr(e, ["regression", "on"]);
    return Object.assign({ type: "regression", x: r, y: n }, i);
  }
}
class WY extends Uo {
  constructor(e, n) {
    super(e), this.transform = n;
  }
  clone() {
    return new WY(null, Kr(this.transform));
  }
  addDimensions(e) {
    var n;
    this.transform.groupby = wp(((n = this.transform.groupby) !== null && n !== void 0 ? n : []).concat(e), (r) => r);
  }
  producedFields() {
  }
  dependentFields() {
    var e;
    return /* @__PURE__ */ new Set([this.transform.pivot, this.transform.value, ...(e = this.transform.groupby) !== null && e !== void 0 ? e : []]);
  }
  hash() {
    return `PivotTransform ${_i(this.transform)}`;
  }
  assemble() {
    const { pivot: e, value: n, groupby: r, limit: i, op: o } = this.transform;
    return Object.assign(Object.assign(Object.assign({ type: "pivot", field: e, value: n }, i !== void 0 ? { limit: i } : {}), o !== void 0 ? { op: o } : {}), r !== void 0 ? { groupby: r } : {});
  }
}
class XY extends Uo {
  constructor(e, n) {
    super(e), this.transform = n;
  }
  clone() {
    return new XY(null, Kr(this.transform));
  }
  dependentFields() {
    return /* @__PURE__ */ new Set();
  }
  producedFields() {
    return /* @__PURE__ */ new Set();
  }
  hash() {
    return `SampleTransform ${_i(this.transform)}`;
  }
  assemble() {
    return {
      type: "sample",
      size: this.transform.sample
    };
  }
}
function Mlt(t) {
  let e = 0;
  function n(r, i) {
    var o;
    if (r instanceof PB && !r.isGenerator && !UQ(r.data) && (t.push(i), i = {
      name: null,
      source: i.name,
      transform: []
    }), r instanceof Xl && (r.parent instanceof PB && !i.source ? (i.format = Object.assign(Object.assign({}, (o = i.format) !== null && o !== void 0 ? o : {}), { parse: r.assembleFormatParse() }), i.transform.push(...r.assembleTransforms(!0))) : i.transform.push(...r.assembleTransforms())), r instanceof Tx) {
      i.name || (i.name = `data_${e++}`), !i.source || i.transform.length > 0 ? (t.push(i), r.data = i.name) : r.data = i.source, t.push(...r.assemble());
      return;
    }
    switch ((r instanceof jO || r instanceof YO || r instanceof qN || r instanceof Dx || r instanceof $Q || r instanceof jN || r instanceof ad || r instanceof YN || r instanceof Nx || r instanceof O1 || r instanceof zY || r instanceof YY || r instanceof jY || r instanceof VY || r instanceof JY || r instanceof KY || r instanceof mE || r instanceof XY || r instanceof WY) && i.transform.push(r.assemble()), (r instanceof Gp || r instanceof kp || r instanceof kv || r instanceof _I || r instanceof dS) && i.transform.push(...r.assemble()), r instanceof zc && (i.source && i.transform.length === 0 ? r.setSource(i.source) : r.parent instanceof zc ? r.setSource(i.name) : (i.name || (i.name = `data_${e++}`), r.setSource(i.name), r.numChildren() === 1 && (t.push(i), i = {
      name: null,
      source: i.name,
      transform: []
    }))), r.numChildren()) {
      case 0:
        r instanceof zc && (!i.source || i.transform.length > 0) && t.push(i);
        break;
      case 1:
        n(r.children[0], i);
        break;
      default: {
        i.name || (i.name = `data_${e++}`);
        let s = i.name;
        !i.source || i.transform.length > 0 ? t.push(i) : s = i.source;
        for (const a of r.children)
          n(a, {
            name: null,
            source: s,
            transform: []
          });
        break;
      }
    }
  }
  return n;
}
function Zxr(t) {
  const e = [], n = Mlt(e);
  for (const r of t.children)
    n(r, {
      source: t.name,
      name: null,
      transform: []
    });
  return e;
}
function e2r(t, e) {
  var n, r;
  const i = [], o = Mlt(i);
  let s = 0;
  for (const A of t.sources) {
    A.hasName() || (A.dataName = `source_${s++}`);
    const l = A.assemble();
    o(A, l);
  }
  for (const A of i)
    A.transform.length === 0 && delete A.transform;
  let a = 0;
  for (const [A, l] of i.entries())
    ((n = l.transform) !== null && n !== void 0 ? n : []).length === 0 && !l.source && i.splice(a++, 0, i.splice(A, 1)[0]);
  for (const A of i)
    for (const l of (r = A.transform) !== null && r !== void 0 ? r : [])
      l.type === "lookup" && (l.from = t.outputNodes[l.from].getSource());
  for (const A of i)
    A.name in e && (A.values = e[A.name]);
  return i;
}
function t2r(t) {
  return t === "top" || t === "left" || Jn(t) ? "header" : "footer";
}
function n2r(t) {
  for (const e of Rg)
    r2r(t, e);
  DPe(t, "x"), DPe(t, "y");
}
function r2r(t, e) {
  var n;
  const { facet: r, config: i, child: o, component: s } = t;
  if (t.channelHasField(e)) {
    const a = r[e], A = jQ("title", null, i, e);
    let l = gS(a, i, {
      allowDisabling: !0,
      includeDefault: A === void 0 || !!A
    });
    o.component.layoutHeaders[e].title && (l = Nt(l) ? l.join(", ") : l, l += ` / ${o.component.layoutHeaders[e].title}`, o.component.layoutHeaders[e].title = null);
    const c = jQ("labelOrient", a.header, i, e), u = a.header !== null ? Va((n = a.header) === null || n === void 0 ? void 0 : n.labels, i.header.labels, !0) : !1, f = wi(["bottom", "right"], c) ? "footer" : "header";
    s.layoutHeaders[e] = {
      title: a.header !== null ? l : null,
      facetFieldDef: a,
      [f]: e === "facet" ? [] : [Olt(t, e, u)]
    };
  }
}
function Olt(t, e, n) {
  const r = e === "row" ? "height" : "width";
  return {
    labels: n,
    sizeSignal: t.child.component.layoutSize.get(r) ? t.child.getSizeSignalRef(r) : void 0,
    axes: []
  };
}
function DPe(t, e) {
  var n;
  const { child: r } = t;
  if (r.component.axes[e]) {
    const { layoutHeaders: i, resolve: o } = t.component;
    if (o.axis[e] = mIe(o, e), o.axis[e] === "shared") {
      const s = e === "x" ? "column" : "row", a = i[s];
      for (const A of r.component.axes[e]) {
        const l = t2r(A.get("orient"));
        (n = a[l]) !== null && n !== void 0 || (a[l] = [Olt(t, s, !1)]);
        const c = aD(A, "main", t.config, { header: !0 });
        c && a[l][0].axes.push(c), A.mainExtracted = !0;
      }
    }
  }
}
function i2r(t) {
  SIe(t), j6(t, "width"), j6(t, "height");
}
function o2r(t) {
  SIe(t);
  const e = t.layout.columns === 1 ? "width" : "childWidth", n = t.layout.columns === void 0 ? "height" : "childHeight";
  j6(t, e), j6(t, n);
}
function SIe(t) {
  for (const e of t.children)
    e.parseLayoutSize();
}
function j6(t, e) {
  var n;
  const r = Alt(e), i = yY(r), o = t.component.resolve, s = t.component.layoutSize;
  let a;
  for (const A of t.children) {
    const l = A.component.layoutSize.getWithExplicit(r), c = (n = o.scale[i]) !== null && n !== void 0 ? n : clt(i, t);
    if (c === "independent" && l.value === "step") {
      a = void 0;
      break;
    }
    if (a) {
      if (c === "independent" && a.value !== l.value) {
        a = void 0;
        break;
      }
      a = hE(a, l, r, "");
    } else
      a = l;
  }
  if (a) {
    for (const A of t.children)
      t.renameSignal(A.getName(r), t.getName(e)), A.component.layoutSize.set(r, "merged", !1);
    s.setWithExplicit(e, a);
  } else
    s.setWithExplicit(e, {
      explicit: !1,
      value: void 0
    });
}
function s2r(t) {
  const { size: e, component: n } = t;
  for (const r of b0) {
    const i = ju(r);
    if (e[i]) {
      const o = e[i];
      n.layoutSize.set(i, n0(o) ? "step" : o, !0);
    } else {
      const o = a2r(t, i);
      n.layoutSize.set(i, o, !1);
    }
  }
}
function a2r(t, e) {
  const n = e === "width" ? "x" : "y", r = t.config, i = t.getScaleComponent(n);
  if (i) {
    const o = i.get("type"), s = i.get("range");
    if (UA(o)) {
      const a = U6(r.view, e);
      return ZE(s) || n0(a) ? "step" : a;
    } else
      return Doe(r.view, e);
  } else {
    if (t.hasProjection || t.mark === "arc")
      return Doe(r.view, e);
    {
      const o = U6(r.view, e);
      return n0(o) ? o.step : o;
    }
  }
}
function zoe(t, e, n) {
  return fn(e, Object.assign({ suffix: `by_${fn(t)}` }, n ?? {}));
}
class ZD extends Llt {
  constructor(e, n, r, i) {
    super(e, "facet", n, r, i, e.resolve), this.child = DIe(e.spec, this, this.getName("child"), void 0, i), this.children = [this.child], this.facet = this.initFacet(e.facet);
  }
  initFacet(e) {
    if (!GO(e))
      return { facet: this.initFacetFieldDef(e, "facet") };
    const n = Kt(e), r = {};
    for (const i of n) {
      if (![vI, BI].includes(i)) {
        Zt(bY(i, "facet"));
        break;
      }
      const o = e[i];
      if (o.field === void 0) {
        Zt(Boe(o, i));
        break;
      }
      r[i] = this.initFacetFieldDef(o, i);
    }
    return r;
  }
  initFacetFieldDef(e, n) {
    const r = J0e(e, n);
    return r.header ? r.header = Bu(r.header) : r.header === null && (r.header = null), r;
  }
  channelHasField(e) {
    return !!this.facet[e];
  }
  fieldDef(e) {
    return this.facet[e];
  }
  parseData() {
    this.component.data = ZY(this), this.child.parseData();
  }
  parseLayoutSize() {
    SIe(this);
  }
  parseSelections() {
    this.child.parseSelections(), this.component.selection = this.child.component.selection;
  }
  parseMarkGroup() {
    this.child.parseMarkGroup();
  }
  parseAxesAndHeaders() {
    this.child.parseAxesAndHeaders(), n2r(this);
  }
  assembleSelectionTopLevelSignals(e) {
    return this.child.assembleSelectionTopLevelSignals(e);
  }
  assembleSignals() {
    return this.child.assembleSignals(), [];
  }
  assembleSelectionData(e) {
    return this.child.assembleSelectionData(e);
  }
  getHeaderLayoutMixins() {
    var e, n, r;
    const i = {};
    for (const o of Rg)
      for (const s of pIe) {
        const a = this.component.layoutHeaders[o], A = a[s], { facetFieldDef: l } = a;
        if (l) {
          const c = jQ("titleOrient", l.header, this.config, o);
          if (["right", "bottom"].includes(c)) {
            const u = HY(o, c);
            (e = i.titleAnchor) !== null && e !== void 0 || (i.titleAnchor = {}), i.titleAnchor[u] = "end";
          }
        }
        if (A?.[0]) {
          const c = o === "row" ? "height" : "width", u = s === "header" ? "headerBand" : "footerBand";
          o !== "facet" && !this.child.component.layoutSize.get(c) && ((n = i[u]) !== null && n !== void 0 || (i[u] = {}), i[u][o] = 0.5), a.title && ((r = i.offset) !== null && r !== void 0 || (i.offset = {}), i.offset[o === "row" ? "rowTitle" : "columnTitle"] = 10);
        }
      }
    return i;
  }
  assembleDefaultLayout() {
    const { column: e, row: n } = this.facet, r = e ? this.columnDistinctSignal() : n ? 1 : void 0;
    let i = "all";
    return (!n && this.component.resolve.scale.x === "independent" || !e && this.component.resolve.scale.y === "independent") && (i = "none"), Object.assign(Object.assign(Object.assign({}, this.getHeaderLayoutMixins()), r ? { columns: r } : {}), { bounds: "full", align: i });
  }
  assembleLayoutSignals() {
    return this.child.assembleLayoutSignals();
  }
  columnDistinctSignal() {
    if (!(this.parent && this.parent instanceof ZD))
      return { signal: `length(data('${this.getName("column_domain")}'))` };
  }
  assembleGroupStyle() {
  }
  assembleGroup(e) {
    return this.parent && this.parent instanceof ZD ? Object.assign(Object.assign({}, this.channelHasField("column") ? {
      encode: {
        update: {
          // TODO(https://github.com/vega/vega-lite/issues/2759):
          // Correct the signal for facet of concat of facet_column
          columns: { field: fn(this.facet.column, { prefix: "distinct" }) }
        }
      }
    } : {}), super.assembleGroup(e)) : super.assembleGroup(e);
  }
  /**
   * Aggregate cardinality for calculating size
   */
  getCardinalityAggregateForChild() {
    const e = [], n = [], r = [];
    if (this.child instanceof ZD) {
      if (this.child.channelHasField("column")) {
        const i = fn(this.child.facet.column);
        e.push(i), n.push("distinct"), r.push(`distinct_${i}`);
      }
    } else
      for (const i of b0) {
        const o = this.child.component.scales[i];
        if (o && !o.merged) {
          const s = o.get("type"), a = o.get("range");
          if (UA(s) && ZE(a)) {
            const A = qY(this.child, i), l = BIe(A);
            l ? (e.push(l), n.push("distinct"), r.push(`distinct_${l}`)) : Zt(B0e(i));
          }
        }
      }
    return { fields: e, ops: n, as: r };
  }
  assembleFacet() {
    const { name: e, data: n } = this.component.data.facetRoot, { row: r, column: i } = this.facet, { fields: o, ops: s, as: a } = this.getCardinalityAggregateForChild(), A = [];
    for (const c of Rg) {
      const u = this.facet[c];
      if (u) {
        A.push(fn(u));
        const { bin: f, sort: h } = u;
        if (Zo(f) && A.push(fn(u, { binSuffix: "end" })), Pp(h)) {
          const { field: d, op: I = xY } = h, m = zoe(u, h);
          r && i ? (o.push(m), s.push("max"), a.push(m)) : (o.push(d), s.push(I), a.push(m));
        } else if (Nt(h)) {
          const d = qQ(u, c);
          o.push(d), s.push("max"), a.push(d);
        }
      }
    }
    const l = !!r && !!i;
    return Object.assign({
      name: e,
      data: n,
      groupby: A
    }, l || o.length > 0 ? {
      aggregate: Object.assign(Object.assign({}, l ? { cross: l } : {}), o.length ? { fields: o, ops: s, as: a } : {})
    } : {});
  }
  facetSortFields(e) {
    const { facet: n } = this, r = n[e];
    return r ? Pp(r.sort) ? [zoe(r, r.sort, { expr: "datum" })] : Nt(r.sort) ? [qQ(r, e, { expr: "datum" })] : [fn(r, { expr: "datum" })] : [];
  }
  facetSortOrder(e) {
    const { facet: n } = this, r = n[e];
    if (r) {
      const { sort: i } = r;
      return [(Pp(i) ? i.order : !Nt(i) && i) || "ascending"];
    }
    return [];
  }
  assembleLabelTitle() {
    var e;
    const { facet: n, config: r } = this;
    if (n.facet)
      return Uoe(n.facet, "facet", r);
    const i = {
      row: ["top", "bottom"],
      column: ["left", "right"]
    };
    for (const o of dIe)
      if (n[o]) {
        const s = jQ("labelOrient", (e = n[o]) === null || e === void 0 ? void 0 : e.header, r, o);
        if (i[o].includes(s))
          return Uoe(n[o], o, r);
      }
  }
  assembleMarks() {
    const { child: e } = this, n = this.component.data.facetRoot, r = Zxr(n), i = e.assembleGroupEncodeEntry(!1), o = this.assembleLabelTitle() || e.assembleTitle(), s = e.assembleGroupStyle();
    return [Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ name: this.getName("cell"), type: "group" }, o ? { title: o } : {}), s ? { style: s } : {}), {
      from: {
        facet: this.assembleFacet()
      },
      // TODO: move this to after data
      sort: {
        field: Rg.map((A) => this.facetSortFields(A)).flat(),
        order: Rg.map((A) => this.facetSortOrder(A)).flat()
      }
    }), r.length > 0 ? { data: r } : {}), i ? { encode: { update: i } } : {}), e.assembleGroup(cQr(this, [])))];
  }
  getMapping() {
    return this.facet;
  }
}
function A2r(t, e) {
  const { row: n, column: r } = e;
  if (n && r) {
    let i = null;
    for (const o of [n, r])
      if (Pp(o.sort)) {
        const { field: s, op: a = xY } = o.sort;
        t = i = new O1(t, {
          joinaggregate: [
            {
              op: a,
              field: s,
              as: zoe(o, o.sort, { forAs: !0 })
            }
          ],
          groupby: [fn(o)]
        });
      }
    return i;
  }
  return null;
}
function Flt(t, e) {
  var n, r, i, o;
  for (const s of e) {
    const a = s.data;
    if (t.name && s.hasName() && t.name !== s.dataName)
      continue;
    const A = (n = t.format) === null || n === void 0 ? void 0 : n.mesh, l = (r = a.format) === null || r === void 0 ? void 0 : r.feature;
    if (A && l)
      continue;
    const c = (i = t.format) === null || i === void 0 ? void 0 : i.feature;
    if ((c || l) && c !== l)
      continue;
    const u = (o = a.format) === null || o === void 0 ? void 0 : o.mesh;
    if (!((A || u) && A !== u)) {
      if (HN(t) && HN(a)) {
        if (Qp(t.values, a.values))
          return s;
      } else if (UQ(t) && UQ(a)) {
        if (t.url === a.url)
          return s;
      } else if (RAt(t) && t.name === s.dataName)
        return s;
    }
  }
  return null;
}
function l2r(t, e) {
  if (t.data || !t.parent) {
    if (t.data === null) {
      const r = new PB({ values: [] });
      return e.push(r), r;
    }
    const n = Flt(t.data, e);
    if (n)
      return UC(t.data) || (n.data.format = xst({}, t.data.format, n.data.format)), !n.hasName() && t.data.name && (n.dataName = t.data.name), n;
    {
      const r = new PB(t.data);
      return e.push(r), r;
    }
  } else
    return t.parent.component.data.facetRoot ? t.parent.component.data.facetRoot : t.parent.component.data.main;
}
function c2r(t, e, n) {
  var r, i;
  let o = 0;
  for (const s of e.transforms) {
    let a, A;
    if (jSr(s))
      A = t = new $Q(t, s), a = "derived";
    else if (AIe(s)) {
      const l = Jwr(s);
      A = t = (r = Xl.makeWithAncestors(t, {}, l, n)) !== null && r !== void 0 ? r : t, t = new Dx(t, e, s.filter);
    } else if (bAt(s))
      A = t = Gp.makeFromTransform(t, s, e), a = "number";
    else if (zSr(s))
      a = "date", n.getWithExplicit(s.field).value === void 0 && (t = new Xl(t, { [s.field]: a }), n.set(s.field, a, !1)), A = t = kp.makeFromTransform(t, s);
    else if (VSr(s))
      A = t = ad.makeFromTransform(t, s), a = "number", hIe(e) && (t = new mE(t));
    else if (BAt(s))
      A = t = YN.make(t, e, s, o++), a = "derived";
    else if (HSr(s))
      A = t = new Nx(t, s), a = "number";
    else if ($Sr(s))
      A = t = new O1(t, s), a = "number";
    else if (JSr(s))
      A = t = _I.makeFromTransform(t, s), a = "derived";
    else if (KSr(s))
      A = t = new zY(t, s), a = "derived";
    else if (qSr(s))
      A = t = new YY(t, s), a = "derived";
    else if (OSr(s))
      A = t = new WY(t, s), a = "derived";
    else if (USr(s))
      t = new XY(t, s);
    else if (YSr(s))
      A = t = kv.makeFromTransform(t, s), a = "derived";
    else if (FSr(s))
      A = t = new jY(t, s), a = "derived";
    else if (PSr(s))
      A = t = new JY(t, s), a = "derived";
    else if (kSr(s))
      A = t = new KY(t, s), a = "derived";
    else if (GSr(s))
      A = t = new VY(t, s), a = "derived";
    else {
      Zt(d1r(s));
      continue;
    }
    if (A && a !== void 0)
      for (const l of (i = A.producedFields()) !== null && i !== void 0 ? i : [])
        n.set(l, a, !1);
  }
  return t;
}
function ZY(t) {
  var e, n, r, i, o, s, a, A, l, c;
  let u = l2r(t, t.component.data.sources);
  const { outputNodes: f, outputNodeRefCounts: h } = t.component.data, d = t.data, m = !(d && (UC(d) || UQ(d) || HN(d))) && t.parent ? t.parent.component.data.ancestorParse.clone() : new aQr();
  UC(d) ? (DAt(d) ? u = new YO(u, d.sequence) : lIe(d) && (u = new jO(u, d.graticule)), m.parseNothing = !0) : ((e = d?.format) === null || e === void 0 ? void 0 : e.parse) === null && (m.parseNothing = !0), u = (n = Xl.makeExplicit(u, t, m)) !== null && n !== void 0 ? n : u, u = new mE(u);
  const C = t.parent && Lx(t.parent);
  ($a(t) || Ad(t)) && C && (u = (r = Gp.makeFromEncoding(u, t)) !== null && r !== void 0 ? r : u), t.transforms.length > 0 && (u = c2r(u, t, m));
  const y = Wwr(t), v = Kwr(t);
  u = (i = Xl.makeWithAncestors(u, {}, Object.assign(Object.assign({}, y), v), m)) !== null && i !== void 0 ? i : u, $a(t) && (u = dS.parseAll(u, t), u = jN.parseAll(u, t)), ($a(t) || Ad(t)) && (C || (u = (o = Gp.makeFromEncoding(u, t)) !== null && o !== void 0 ? o : u), u = (s = kp.makeFromEncoding(u, t)) !== null && s !== void 0 ? s : u, u = $Q.parseAllForSortIndex(u, t));
  const b = t.getDataName(Wo.Raw), Q = new zc(u, b, Wo.Raw, h);
  if (f[b] = Q, u = Q, $a(t)) {
    const O = ad.makeFromEncoding(u, t);
    O && (u = O, hIe(t) && (u = new mE(u))), u = (a = kv.makeFromEncoding(u, t)) !== null && a !== void 0 ? a : u, u = (A = _I.makeFromEncoding(u, t)) !== null && A !== void 0 ? A : u;
  }
  $a(t) && (u = (l = qN.make(u, t)) !== null && l !== void 0 ? l : u);
  const w = t.getDataName(Wo.Main), R = new zc(u, w, Wo.Main, h);
  f[w] = R, u = R, $a(t) && jQr(t, R);
  let M = null;
  if (Ad(t)) {
    const O = t.getName("facet");
    u = (c = A2r(u, t.facet)) !== null && c !== void 0 ? c : u, M = new Tx(u, t, O, R.getSource()), f[O] = M;
  }
  return Object.assign(Object.assign({}, t.component.data), {
    outputNodes: f,
    outputNodeRefCounts: h,
    raw: Q,
    main: R,
    facetRoot: M,
    ancestorParse: m
  });
}
class u2r extends _Ie {
  constructor(e, n, r, i) {
    var o, s, a, A;
    super(e, "concat", n, r, i, e.resolve), (((s = (o = e.resolve) === null || o === void 0 ? void 0 : o.axis) === null || s === void 0 ? void 0 : s.x) === "shared" || ((A = (a = e.resolve) === null || a === void 0 ? void 0 : a.axis) === null || A === void 0 ? void 0 : A.y) === "shared") && Zt(f1r), this.children = this.getChildren(e).map((l, c) => DIe(l, this, this.getName(`concat_${c}`), void 0, i));
  }
  parseData() {
    this.component.data = ZY(this);
    for (const e of this.children)
      e.parseData();
  }
  parseSelections() {
    this.component.selection = {};
    for (const e of this.children) {
      e.parseSelections();
      for (const n of Kt(e.component.selection))
        this.component.selection[n] = e.component.selection[n];
    }
  }
  parseMarkGroup() {
    for (const e of this.children)
      e.parseMarkGroup();
  }
  parseAxesAndHeaders() {
    for (const e of this.children)
      e.parseAxesAndHeaders();
  }
  getChildren(e) {
    return FY(e) ? e.vconcat : sIe(e) ? e.hconcat : e.concat;
  }
  parseLayoutSize() {
    o2r(this);
  }
  parseAxisGroup() {
    return null;
  }
  assembleSelectionTopLevelSignals(e) {
    return this.children.reduce((n, r) => r.assembleSelectionTopLevelSignals(n), e);
  }
  assembleSignals() {
    return this.children.forEach((e) => e.assembleSignals()), [];
  }
  assembleLayoutSignals() {
    const e = IIe(this);
    for (const n of this.children)
      e.push(...n.assembleLayoutSignals());
    return e;
  }
  assembleSelectionData(e) {
    return this.children.reduce((n, r) => r.assembleSelectionData(n), e);
  }
  assembleMarks() {
    return this.children.map((e) => {
      const n = e.assembleTitle(), r = e.assembleGroupStyle(), i = e.assembleGroupEncodeEntry(!1);
      return Object.assign(Object.assign(Object.assign(Object.assign({ type: "group", name: e.getName("group") }, n ? { title: n } : {}), r ? { style: r } : {}), i ? { encode: { update: i } } : {}), e.assembleGroup());
    });
  }
  assembleGroupStyle() {
  }
  assembleDefaultLayout() {
    const e = this.layout.columns;
    return Object.assign(Object.assign({}, e != null ? { columns: e } : {}), {
      bounds: "full",
      // Use align each so it can work with multiple plots with different size
      align: "each"
    });
  }
}
function f2r(t) {
  return t === !1 || t === null;
}
const g2r = Object.assign(Object.assign({ disable: 1, gridScale: 1, scale: 1 }, Vat), { labelExpr: 1, encode: 1 }), Plt = Kt(g2r);
class QIe extends dm {
  constructor(e = {}, n = {}, r = !1) {
    super(), this.explicit = e, this.implicit = n, this.mainExtracted = r;
  }
  clone() {
    return new QIe(Kr(this.explicit), Kr(this.implicit), this.mainExtracted);
  }
  hasAxisPart(e) {
    return e === "axis" ? !0 : e === "grid" || e === "title" ? !!this.get(e) : !f2r(this.get(e));
  }
  hasOrientSignalRef() {
    return Jn(this.explicit.orient);
  }
}
function h2r(t, e, n) {
  var r;
  const { encoding: i, config: o } = t, s = (r = gA(i[e])) !== null && r !== void 0 ? r : gA(i[gm(e)]), a = t.axis(e) || {}, { format: A, formatType: l } = a;
  if (MB(l))
    return Object.assign({ text: Zh({
      fieldOrDatumDef: s,
      field: "datum.value",
      format: A,
      formatType: l,
      config: o
    }) }, n);
  if (A === void 0 && l === void 0 && o.customFormatTypes) {
    if (PQ(s) === "quantitative") {
      if (kQ(s) && s.stack === "normalize" && o.normalizedNumberFormatType)
        return Object.assign({ text: Zh({
          fieldOrDatumDef: s,
          field: "datum.value",
          format: o.normalizedNumberFormat,
          formatType: o.normalizedNumberFormatType,
          config: o
        }) }, n);
      if (o.numberFormatType)
        return Object.assign({ text: Zh({
          fieldOrDatumDef: s,
          field: "datum.value",
          format: o.numberFormat,
          formatType: o.numberFormatType,
          config: o
        }) }, n);
    }
    if (PQ(s) === "temporal" && o.timeFormatType && sn(s) && !s.timeUnit)
      return Object.assign({ text: Zh({
        fieldOrDatumDef: s,
        field: "datum.value",
        format: o.timeFormat,
        formatType: o.timeFormatType,
        config: o
      }) }, n);
  }
  return n;
}
function d2r(t) {
  return b0.reduce((e, n) => (t.component.scales[n] && (e[n] = [v2r(n, t)]), e), {});
}
const p2r = {
  bottom: "top",
  top: "bottom",
  left: "right",
  right: "left"
};
function I2r(t) {
  var e;
  const { axes: n, resolve: r } = t.component, i = { top: 0, bottom: 0, right: 0, left: 0 };
  for (const o of t.children) {
    o.parseAxesAndHeaders();
    for (const s of Kt(o.component.axes))
      r.axis[s] = mIe(t.component.resolve, s), r.axis[s] === "shared" && (n[s] = m2r(n[s], o.component.axes[s]), n[s] || (r.axis[s] = "independent", delete n[s]));
  }
  for (const o of b0) {
    for (const s of t.children)
      if (s.component.axes[o]) {
        if (r.axis[o] === "independent") {
          n[o] = ((e = n[o]) !== null && e !== void 0 ? e : []).concat(s.component.axes[o]);
          for (const a of s.component.axes[o]) {
            const { value: A, explicit: l } = a.getWithExplicit("orient");
            if (!Jn(A)) {
              if (i[A] > 0 && !l) {
                const c = p2r[A];
                i[A] > i[c] && a.set("orient", c, !1);
              }
              i[A]++;
            }
          }
        }
        delete s.component.axes[o];
      }
    if (r.axis[o] === "independent" && n[o] && n[o].length > 1)
      for (const s of n[o])
        s.get("grid") && !s.explicit.grid && (s.implicit.grid = !1);
  }
}
function m2r(t, e) {
  if (t) {
    if (t.length !== e.length)
      return;
    const n = t.length;
    for (let r = 0; r < n; r++) {
      const i = t[r], o = e[r];
      if (!!i != !!o)
        return;
      if (i && o) {
        const s = i.getWithExplicit("orient"), a = o.getWithExplicit("orient");
        if (s.explicit && a.explicit && s.value !== a.value)
          return;
        t[r] = C2r(i, o);
      }
    }
  } else
    return e.map((n) => n.clone());
  return t;
}
function C2r(t, e) {
  for (const n of Plt) {
    const r = hE(
      t.getWithExplicit(n),
      e.getWithExplicit(n),
      n,
      "axis",
      // Tie breaker function
      (i, o) => {
        switch (n) {
          case "title":
            return nat(i, o);
          case "gridScale":
            return {
              explicit: i.explicit,
              value: Va(i.value, o.value)
            };
        }
        return kY(i, o, n, "axis");
      }
    );
    t.setWithExplicit(n, r);
  }
  return t;
}
function E2r(t, e, n, r, i) {
  if (e === "disable")
    return n !== void 0;
  switch (n = n || {}, e) {
    case "titleAngle":
    case "labelAngle":
      return t === (Jn(n.labelAngle) ? n.labelAngle : GN(n.labelAngle));
    case "values":
      return !!n.values;
    case "encode":
      return !!n.encoding || !!n.labelAngle;
    case "title":
      if (t === rlt(r, i))
        return !0;
  }
  return t === n[e];
}
const y2r = /* @__PURE__ */ new Set([
  "grid",
  "translate",
  // the rest are not axis configs in Vega, but are in VL, so we need to set too.
  "format",
  "formatType",
  "orient",
  "labelExpr",
  "tickCount",
  "position",
  "tickMinStep"
]);
function v2r(t, e) {
  var n, r, i;
  let o = e.axis(t);
  const s = new QIe(), a = gA(e.encoding[t]), { mark: A, config: l } = e, c = o?.orient || ((n = l[t === "x" ? "axisX" : "axisY"]) === null || n === void 0 ? void 0 : n.orient) || ((r = l.axis) === null || r === void 0 ? void 0 : r.orient) || twr(t), u = e.getScaleComponent(t).get("type"), f = VQr(t, u, c, e.config), h = o !== void 0 ? !o : koe("disable", l.style, o?.style, f).configValue;
  if (s.set("disable", h, o !== void 0), h)
    return s;
  o = o || {};
  const d = XQr(a, o, t, l.style, f), I = {
    fieldOrDatumDef: a,
    axis: o,
    channel: t,
    model: e,
    scaleType: u,
    orient: c,
    labelAngle: d,
    mark: A,
    config: l
  };
  for (const y of Plt) {
    const v = y in pPe ? pPe[y](I) : YFe(y) ? o[y] : void 0, b = v !== void 0, Q = E2r(v, y, o, e, t);
    if (b && Q)
      s.set(y, v, Q);
    else {
      const { configValue: w = void 0, configFrom: R = void 0 } = YFe(y) && y !== "values" ? koe(y, l.style, o.style, f) : {}, M = w !== void 0;
      b && !M ? s.set(y, v, Q) : (
        // Cases need implicit values
        // 1. Axis config that aren't available in Vega
        (R !== "vgAxisConfig" || // 2. Certain properties are always included (see `propsToAlwaysIncludeConfig`'s declaration for more details)
        y2r.has(y) && M || // 3. Conditional axis values and signals
        $O(w) || Jn(w)) && s.set(y, w, !1)
      );
    }
  }
  const m = (i = o.encoding) !== null && i !== void 0 ? i : {}, C = zat.reduce((y, v) => {
    var b;
    if (!s.hasAxisPart(v))
      return y;
    const Q = llt((b = m[v]) !== null && b !== void 0 ? b : {}, e), w = v === "labels" ? h2r(e, t, Q) : Q;
    return w !== void 0 && !Oo(w) && (y[v] = { update: w }), y;
  }, {});
  return Oo(C) || s.set("encode", C, !!o.encoding || o.labelAngle !== void 0), s;
}
function B2r({ encoding: t, size: e }) {
  for (const n of b0) {
    const r = ju(n);
    n0(e[r]) && xp(t[n]) && (delete e[r], Zt(aat(r)));
  }
  return e;
}
function b2r(t, e, n) {
  const r = Bu(t), i = Co("orient", r, n);
  if (r.orient = w2r(r.type, e, i), i !== void 0 && i !== r.orient && Zt(N1r(r.orient, i)), r.type === "bar" && r.orient) {
    const a = Co("cornerRadiusEnd", r, n);
    if (a !== void 0) {
      const A = r.orient === "horizontal" && e.x2 || r.orient === "vertical" && e.y2 ? ["cornerRadius"] : Xbr[r.orient];
      for (const l of A)
        r[l] = a;
      r.cornerRadiusEnd !== void 0 && delete r.cornerRadiusEnd;
    }
  }
  return Co("opacity", r, n) === void 0 && (r.opacity = S2r(r.type, e)), Co("cursor", r, n) === void 0 && (r.cursor = _2r(r, e, n)), r;
}
function _2r(t, e, n) {
  return e.href || t.href || Co("href", t, n) ? "pointer" : t.cursor;
}
function S2r(t, e) {
  if (wi([wY, P0e, k0e, G0e], t) && !K0e(e))
    return 0.7;
}
function Q2r(t, e, { graticule: n }) {
  if (n)
    return !1;
  const r = TB("filled", t, e), i = t.type;
  return Va(r, i !== wY && i !== QY && i !== L6);
}
function w2r(t, e, n) {
  switch (t) {
    case wY:
    case k0e:
    case G0e:
    case _at:
    case Hbr:
    case Ubr:
      return;
  }
  const { x: r, y: i, x2: o, y2: s } = e;
  switch (t) {
    case SY:
      if (sn(r) && (Pc(r.bin) || sn(i) && i.aggregate && !r.aggregate))
        return "vertical";
      if (sn(i) && (Pc(i.bin) || sn(r) && r.aggregate && !i.aggregate))
        return "horizontal";
      if (s || o) {
        if (n)
          return n;
        if (!o && (sn(r) && r.type === NB && !Zo(r.bin) || woe(r)))
          return "horizontal";
        if (!s && (sn(i) && i.type === NB && !Zo(i.bin) || woe(i)))
          return "vertical";
      }
    case L6:
      if (o && !(sn(r) && Pc(r.bin)) && s && !(sn(i) && Pc(i.bin)))
        return;
    case _Y:
      if (s)
        return sn(i) && Pc(i.bin) ? "horizontal" : "vertical";
      if (o)
        return sn(r) && Pc(r.bin) ? "vertical" : "horizontal";
      if (t === L6) {
        if (r && !i)
          return "vertical";
        if (i && !r)
          return "horizontal";
      }
    case QY:
    case P0e: {
      const a = xp(r), A = xp(i);
      if (n)
        return n;
      if (a && !A)
        return t !== "tick" ? "horizontal" : "vertical";
      if (!a && A)
        return t !== "tick" ? "vertical" : "horizontal";
      if (a && A) {
        const l = r, c = i, u = l.type === OQ, f = c.type === OQ;
        return u && !f ? t !== "tick" ? "vertical" : "horizontal" : !u && f ? t !== "tick" ? "horizontal" : "vertical" : !l.aggregate && c.aggregate ? t !== "tick" ? "vertical" : "horizontal" : l.aggregate && !c.aggregate && t !== "tick" ? "horizontal" : "vertical";
      } else
        return;
    }
  }
  return "vertical";
}
const x2r = {
  vgMark: "arc",
  encodeEntry: (t) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, eh(t, {
    align: "ignore",
    baseline: "ignore",
    color: "include",
    size: "ignore",
    orient: "ignore",
    theta: "ignore"
  })), Wl("x", t, { defaultPos: "mid" })), Wl("y", t, { defaultPos: "mid" })), pE(t, "radius")), pE(t, "theta"))
}, R2r = {
  vgMark: "area",
  encodeEntry: (t) => Object.assign(Object.assign(Object.assign(Object.assign({}, eh(t, {
    align: "ignore",
    baseline: "ignore",
    color: "include",
    orient: "include",
    size: "ignore",
    theta: "ignore"
  })), H6("x", t, {
    defaultPos: "zeroOrMin",
    defaultPos2: "zeroOrMin",
    range: t.markDef.orient === "horizontal"
  })), H6("y", t, {
    defaultPos: "zeroOrMin",
    defaultPos2: "zeroOrMin",
    range: t.markDef.orient === "vertical"
  })), gIe(t))
}, D2r = {
  vgMark: "rect",
  encodeEntry: (t) => Object.assign(Object.assign(Object.assign({}, eh(t, {
    align: "ignore",
    baseline: "ignore",
    color: "include",
    orient: "ignore",
    size: "ignore",
    theta: "ignore"
  })), pE(t, "x")), pE(t, "y"))
}, T2r = {
  vgMark: "shape",
  encodeEntry: (t) => Object.assign({}, eh(t, {
    align: "ignore",
    baseline: "ignore",
    color: "include",
    size: "ignore",
    orient: "ignore",
    theta: "ignore"
  })),
  postEncodingTransform: (t) => {
    const { encoding: e } = t, n = e.shape;
    return [Object.assign({ type: "geoshape", projection: t.projectionName() }, n && sn(n) && n.type === xx ? { field: fn(n, { expr: "datum" }) } : {})];
  }
}, N2r = {
  vgMark: "image",
  encodeEntry: (t) => Object.assign(Object.assign(Object.assign(Object.assign({}, eh(t, {
    align: "ignore",
    baseline: "ignore",
    color: "ignore",
    orient: "ignore",
    size: "ignore",
    theta: "ignore"
  })), pE(t, "x")), pE(t, "y")), uIe(t, "url"))
}, L2r = {
  vgMark: "line",
  encodeEntry: (t) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, eh(t, {
    align: "ignore",
    baseline: "ignore",
    color: "include",
    size: "ignore",
    orient: "ignore",
    theta: "ignore"
  })), Wl("x", t, { defaultPos: "mid" })), Wl("y", t, { defaultPos: "mid" })), DA("size", t, {
    vgChannel: "strokeWidth"
    // VL's line size is strokeWidth
  })), gIe(t))
}, M2r = {
  vgMark: "trail",
  encodeEntry: (t) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, eh(t, {
    align: "ignore",
    baseline: "ignore",
    color: "include",
    size: "include",
    orient: "ignore",
    theta: "ignore"
  })), Wl("x", t, { defaultPos: "mid" })), Wl("y", t, { defaultPos: "mid" })), DA("size", t)), gIe(t))
};
function wIe(t, e) {
  const { config: n } = t;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, eh(t, {
    align: "ignore",
    baseline: "ignore",
    color: "include",
    size: "include",
    orient: "ignore",
    theta: "ignore"
  })), Wl("x", t, { defaultPos: "mid" })), Wl("y", t, { defaultPos: "mid" })), DA("size", t)), DA("angle", t)), O2r(t, n, e));
}
function O2r(t, e, n) {
  return n ? { shape: { value: n } } : DA("shape", t);
}
const F2r = {
  vgMark: "symbol",
  encodeEntry: (t) => wIe(t)
}, P2r = {
  vgMark: "symbol",
  encodeEntry: (t) => wIe(t, "circle")
}, k2r = {
  vgMark: "symbol",
  encodeEntry: (t) => wIe(t, "square")
}, G2r = {
  vgMark: "rect",
  encodeEntry: (t) => Object.assign(Object.assign(Object.assign({}, eh(t, {
    align: "ignore",
    baseline: "ignore",
    color: "include",
    orient: "ignore",
    size: "ignore",
    theta: "ignore"
  })), pE(t, "x")), pE(t, "y"))
}, U2r = {
  vgMark: "rule",
  encodeEntry: (t) => {
    const { markDef: e } = t, n = e.orient;
    return !t.encoding.x && !t.encoding.y && !t.encoding.latitude && !t.encoding.longitude ? {} : Object.assign(Object.assign(Object.assign(Object.assign({}, eh(t, {
      align: "ignore",
      baseline: "ignore",
      color: "include",
      orient: "ignore",
      size: "ignore",
      theta: "ignore"
    })), H6("x", t, {
      defaultPos: n === "horizontal" ? "zeroOrMax" : "mid",
      defaultPos2: "zeroOrMin",
      range: n !== "vertical"
      // include x2 for horizontal or line segment rule
    })), H6("y", t, {
      defaultPos: n === "vertical" ? "zeroOrMax" : "mid",
      defaultPos2: "zeroOrMin",
      range: n !== "horizontal"
      // include y2 for vertical or line segment rule
    })), DA("size", t, {
      vgChannel: "strokeWidth"
      // VL's rule size is strokeWidth
    }));
  }
}, H2r = {
  vgMark: "text",
  encodeEntry: (t) => {
    const { config: e, encoding: n } = t;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, eh(t, {
      align: "include",
      baseline: "include",
      color: "include",
      size: "ignore",
      orient: "ignore",
      theta: "include"
    })), Wl("x", t, { defaultPos: "mid" })), Wl("y", t, { defaultPos: "mid" })), uIe(t)), DA("size", t, {
      vgChannel: "fontSize"
      // VL's text size is fontSize
    })), DA("angle", t)), fPe("align", $2r(t.markDef, n, e))), fPe("baseline", q2r(t.markDef, n, e))), Wl("radius", t, { defaultPos: null })), Wl("theta", t, { defaultPos: null }));
  }
};
function $2r(t, e, n) {
  if (Co("align", t, n) === void 0)
    return "center";
}
function q2r(t, e, n) {
  if (Co("baseline", t, n) === void 0)
    return "middle";
}
const j2r = {
  vgMark: "rect",
  encodeEntry: (t) => {
    const { config: e, markDef: n } = t, r = n.orient, i = r === "horizontal" ? "width" : "height", o = r === "horizontal" ? "height" : "width";
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, eh(t, {
      align: "ignore",
      baseline: "ignore",
      color: "include",
      orient: "ignore",
      size: "ignore",
      theta: "ignore"
    })), Wl("x", t, { defaultPos: "mid", vgChannel: "xc" })), Wl("y", t, { defaultPos: "mid", vgChannel: "yc" })), DA("size", t, {
      defaultValue: Y2r(t),
      vgChannel: i
    })), { [o]: hs(Co("thickness", n, e)) });
  }
};
function Y2r(t) {
  var e;
  const { config: n, markDef: r } = t, { orient: i } = r, o = i === "horizontal" ? "width" : "height", s = t.getScaleComponent(i === "horizontal" ? "x" : "y"), a = (e = Co("size", r, n, { vgChannel: o })) !== null && e !== void 0 ? e : n.tick.bandSize;
  if (a !== void 0)
    return a;
  {
    const A = s ? s.get("range") : void 0;
    return A && ZE(A) && Po(A.step) ? A.step * 3 / 4 : G6(n.view, o) * 3 / 4;
  }
}
const Y3 = {
  arc: x2r,
  area: R2r,
  bar: D2r,
  circle: P2r,
  geoshape: T2r,
  image: N2r,
  line: L2r,
  point: F2r,
  rect: G2r,
  rule: U2r,
  square: k2r,
  text: H2r,
  tick: j2r,
  trail: M2r
};
function z2r(t) {
  if (wi([QY, _Y, $br], t.mark)) {
    const e = Xat(t.mark, t.encoding);
    if (e.length > 0)
      return V2r(t, e);
  } else if (t.mark === SY) {
    const e = voe.some((n) => Co(n, t.markDef, t.config));
    if (t.stack && !t.fieldDef("size") && e)
      return J2r(t);
  }
  return xIe(t);
}
const TPe = "faceted_path_";
function V2r(t, e) {
  return [
    {
      name: t.getName("pathgroup"),
      type: "group",
      from: {
        facet: {
          name: TPe + t.requestDataName(Wo.Main),
          data: t.requestDataName(Wo.Main),
          groupby: e
        }
      },
      encode: {
        update: {
          width: { field: { group: "width" } },
          height: { field: { group: "height" } }
        }
      },
      // With subfacet for line/area group, need to use faceted data from above.
      marks: xIe(t, { fromPrefix: TPe })
    }
  ];
}
const NPe = "stack_group_";
function J2r(t) {
  var e;
  const [n] = xIe(t, { fromPrefix: NPe }), r = t.scaleName(t.stack.fieldChannel), i = (c = {}) => t.vgField(t.stack.fieldChannel, c), o = (c, u) => {
    const f = [
      i({ prefix: "min", suffix: "start", expr: u }),
      i({ prefix: "max", suffix: "start", expr: u }),
      i({ prefix: "min", suffix: "end", expr: u }),
      i({ prefix: "max", suffix: "end", expr: u })
    ];
    return `${c}(${f.map((h) => `scale('${r}',${h})`).join(",")})`;
  };
  let s, a;
  t.stack.fieldChannel === "x" ? (s = Object.assign(Object.assign({}, NQ(n.encode.update, ["y", "yc", "y2", "height", ...voe])), { x: { signal: o("min", "datum") }, x2: { signal: o("max", "datum") }, clip: { value: !0 } }), a = {
    x: { field: { group: "x" }, mult: -1 },
    height: { field: { group: "height" } }
  }, n.encode.update = Object.assign(Object.assign({}, Ff(n.encode.update, ["y", "yc", "y2"])), { height: { field: { group: "height" } } })) : (s = Object.assign(Object.assign({}, NQ(n.encode.update, ["x", "xc", "x2", "width"])), { y: { signal: o("min", "datum") }, y2: { signal: o("max", "datum") }, clip: { value: !0 } }), a = {
    y: { field: { group: "y" }, mult: -1 },
    width: { field: { group: "width" } }
  }, n.encode.update = Object.assign(Object.assign({}, Ff(n.encode.update, ["x", "xc", "x2"])), { width: { field: { group: "width" } } }));
  for (const c of voe) {
    const u = TB(c, t.markDef, t.config);
    n.encode.update[c] ? (s[c] = n.encode.update[c], delete n.encode.update[c]) : u && (s[c] = hs(u)), u && (n.encode.update[c] = { value: 0 });
  }
  const A = [];
  if (((e = t.stack.groupbyChannels) === null || e === void 0 ? void 0 : e.length) > 0)
    for (const c of t.stack.groupbyChannels) {
      const u = t.fieldDef(c), f = fn(u);
      f && A.push(f), (u?.bin || u?.timeUnit) && A.push(fn(u, { binSuffix: "end" }));
    }
  return s = [
    "stroke",
    "strokeWidth",
    "strokeJoin",
    "strokeCap",
    "strokeDash",
    "strokeDashOffset",
    "strokeMiterLimit",
    "strokeOpacity"
  ].reduce((c, u) => {
    if (n.encode.update[u])
      return Object.assign(Object.assign({}, c), { [u]: n.encode.update[u] });
    {
      const f = TB(u, t.markDef, t.config);
      return f !== void 0 ? Object.assign(Object.assign({}, c), { [u]: hs(f) }) : c;
    }
  }, s), s.stroke && (s.strokeForeground = { value: !0 }, s.strokeOffset = { value: 0 }), [
    {
      type: "group",
      from: {
        facet: {
          data: t.requestDataName(Wo.Main),
          name: NPe + t.requestDataName(Wo.Main),
          groupby: A,
          aggregate: {
            fields: [
              i({ suffix: "start" }),
              i({ suffix: "start" }),
              i({ suffix: "end" }),
              i({ suffix: "end" })
            ],
            ops: ["min", "max", "min", "max"]
          }
        }
      },
      encode: {
        update: s
      },
      marks: [
        {
          type: "group",
          encode: { update: a },
          marks: [n]
        }
      ]
    }
  ];
}
function K2r(t) {
  var e;
  const { encoding: n, stack: r, mark: i, markDef: o, config: s } = t, a = n.order;
  if (!(!Nt(a) && Cd(a) && Eoe(a.value) || !a && Eoe(Co("order", o, s)))) {
    if ((Nt(a) || sn(a)) && !r)
      return Zst(a, { expr: "datum" });
    if (ey(i)) {
      const A = o.orient === "horizontal" ? "y" : "x", l = n[A];
      if (sn(l)) {
        const c = l.sort;
        if (Nt(c))
          return {
            field: fn(l, { prefix: A, suffix: "sort_index", expr: "datum" })
          };
        if (Pp(c))
          return {
            field: fn({
              // FIXME: this op might not already exist?
              // FIXME: what if dimensionChannel (x or y) contains custom domain?
              aggregate: K0e(t.encoding) ? c.op : void 0,
              field: c.field
            }, { expr: "datum" })
          };
        if (Mat(c)) {
          const u = t.fieldDef(c.encoding);
          return {
            field: fn(u, { expr: "datum" }),
            order: c.order
          };
        } else
          return c === null ? void 0 : {
            field: fn(l, {
              // For stack with imputation, we only have bin_mid
              binSuffix: !((e = t.stack) === null || e === void 0) && e.impute ? "mid" : void 0,
              expr: "datum"
            })
          };
      }
      return;
    }
  }
}
function xIe(t, e = { fromPrefix: "" }) {
  const { mark: n, markDef: r, encoding: i, config: o } = t, s = Va(r.clip, W2r(t), X2r(t)), a = Wst(r), A = i.key, l = K2r(t), c = Z2r(t), u = Co("aria", r, o), f = Y3[n].postEncodingTransform ? Y3[n].postEncodingTransform(t) : null;
  return [
    Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ name: t.getName("marks"), type: Y3[n].vgMark }, s ? { clip: !0 } : {}), a ? { style: a } : {}), A ? { key: A.field } : {}), l ? { sort: l } : {}), c || {}), u === !1 ? { aria: u } : {}), { from: { data: e.fromPrefix + t.requestDataName(Wo.Main) }, encode: {
      update: Y3[n].encodeEntry(t)
    } }), f ? {
      transform: f
    } : {})
  ];
}
function W2r(t) {
  const e = t.getScaleComponent("x"), n = t.getScaleComponent("y");
  return e?.get("selectionExtent") || n?.get("selectionExtent") ? !0 : void 0;
}
function X2r(t) {
  const e = t.component.projection;
  return e && !e.isFit ? !0 : void 0;
}
function Z2r(t) {
  if (!t.component.selection)
    return null;
  const e = Kt(t.component.selection).length;
  let n = e, r = t.parent;
  for (; r && n === 0; )
    n = Kt(r.component.selection).length, r = r.parent;
  return n ? {
    interactive: e > 0 || !!t.encoding.tooltip
  } : null;
}
class klt extends Llt {
  constructor(e, n, r, i = {}, o) {
    var s;
    super(e, "unit", n, r, o, void 0, JFe(e) ? e.view : void 0), this.specifiedScales = {}, this.specifiedAxes = {}, this.specifiedLegends = {}, this.specifiedProjection = {}, this.selection = [], this.children = [];
    const a = Zp(e.mark) ? Object.assign({}, e.mark) : { type: e.mark }, A = a.type;
    a.filled === void 0 && (a.filled = Q2r(a, o, {
      graticule: e.data && lIe(e.data)
    }));
    const l = this.encoding = x_r(e.encoding || {}, A, a.filled, o);
    this.markDef = b2r(a, l, o), this.size = B2r({
      encoding: l,
      size: JFe(e) ? Object.assign(Object.assign(Object.assign({}, i), e.width ? { width: e.width } : {}), e.height ? { height: e.height } : {}) : i
    }), this.stack = CAt(A, l), this.specifiedScales = this.initScales(A, l), this.specifiedAxes = this.initAxes(l), this.specifiedLegends = this.initLegends(l), this.specifiedProjection = e.projection, this.selection = ((s = e.params) !== null && s !== void 0 ? s : []).filter((c) => iIe(c));
  }
  get hasProjection() {
    const { encoding: e } = this, n = this.mark === Sat, r = e && _Br.some((i) => $r(e[i]));
    return n || r;
  }
  /**
   * Return specified Vega-Lite scale domain for a particular channel
   * @param channel
   */
  scaleDomain(e) {
    const n = this.specifiedScales[e];
    return n ? n.domain : void 0;
  }
  axis(e) {
    return this.specifiedAxes[e];
  }
  legend(e) {
    return this.specifiedLegends[e];
  }
  initScales(e, n) {
    return vY.reduce((r, i) => {
      var o;
      const s = gA(n[i]);
      return s && (r[i] = this.initScale((o = s.scale) !== null && o !== void 0 ? o : {})), r;
    }, {});
  }
  initScale(e) {
    const { domain: n, range: r } = e, i = Bu(e);
    return Nt(n) && (i.domain = n.map(_f)), Nt(r) && (i.range = r.map(_f)), i;
  }
  initAxes(e) {
    return b0.reduce((n, r) => {
      const i = e[r];
      if ($r(i) || r === ta && $r(e.x2) || r === kA && $r(e.y2)) {
        const o = $r(i) ? i.axis : void 0;
        n[r] = o && this.initAxis(Object.assign({}, o));
      }
      return n;
    }, {});
  }
  initAxis(e) {
    const n = Kt(e), r = {};
    for (const i of n) {
      const o = e[i];
      r[i] = $O(o) ? Kst(o) : _f(o);
    }
    return r;
  }
  initLegends(e) {
    return MBr.reduce((n, r) => {
      const i = gA(e[r]);
      if (i && FBr(r)) {
        const o = i.legend;
        n[r] = o && Bu(o);
      }
      return n;
    }, {});
  }
  parseData() {
    this.component.data = ZY(this);
  }
  parseLayoutSize() {
    s2r(this);
  }
  parseSelections() {
    this.component.selection = qQr(this, this.selection);
  }
  parseMarkGroup() {
    this.component.mark = z2r(this);
  }
  parseAxesAndHeaders() {
    this.component.axes = d2r(this);
  }
  assembleSelectionTopLevelSignals(e) {
    return uQr(this, e);
  }
  assembleSignals() {
    return [...elt(this), ...lQr(this, [])];
  }
  assembleSelectionData(e) {
    return fQr(this, e);
  }
  assembleLayout() {
    return null;
  }
  assembleLayoutSignals() {
    return IIe(this);
  }
  assembleMarks() {
    var e;
    let n = (e = this.component.mark) !== null && e !== void 0 ? e : [];
    return (!this.parent || !Lx(this.parent)) && (n = NAt(this, n)), n.map(this.correctDataNames);
  }
  assembleGroupStyle() {
    const { style: e } = this.view || {};
    if (e !== void 0)
      return e;
    if (this.encoding.x || this.encoding.y)
      return "cell";
  }
  getMapping() {
    return this.encoding;
  }
  get mark() {
    return this.markDef.type;
  }
  channelHasField(e) {
    return Pv(this.encoding, e);
  }
  fieldDef(e) {
    const n = this.encoding[e];
    return e0(n);
  }
  typedFieldDef(e) {
    const n = this.fieldDef(e);
    return Kg(n) ? n : null;
  }
}
class RIe extends _Ie {
  constructor(e, n, r, i, o) {
    super(e, "layer", n, r, o, e.resolve, e.view);
    const s = Object.assign(Object.assign(Object.assign({}, i), e.width ? { width: e.width } : {}), e.height ? { height: e.height } : {});
    this.children = e.layer.map((a, A) => {
      if (PY(a))
        return new RIe(a, this, this.getName(`layer_${A}`), s, o);
      if (hm(a))
        return new klt(a, this, this.getName(`layer_${A}`), s, o);
      throw new Error(v0e(a));
    });
  }
  parseData() {
    this.component.data = ZY(this);
    for (const e of this.children)
      e.parseData();
  }
  parseLayoutSize() {
    i2r(this);
  }
  parseSelections() {
    this.component.selection = {};
    for (const e of this.children) {
      e.parseSelections();
      for (const n of Kt(e.component.selection))
        this.component.selection[n] = e.component.selection[n];
    }
  }
  parseMarkGroup() {
    for (const e of this.children)
      e.parseMarkGroup();
  }
  parseAxesAndHeaders() {
    I2r(this);
  }
  assembleSelectionTopLevelSignals(e) {
    return this.children.reduce((n, r) => r.assembleSelectionTopLevelSignals(n), e);
  }
  // TODO: Support same named selections across children.
  assembleSignals() {
    return this.children.reduce((e, n) => e.concat(n.assembleSignals()), elt(this));
  }
  assembleLayoutSignals() {
    return this.children.reduce((e, n) => e.concat(n.assembleLayoutSignals()), IIe(this));
  }
  assembleSelectionData(e) {
    return this.children.reduce((n, r) => r.assembleSelectionData(n), e);
  }
  assembleGroupStyle() {
    const e = /* @__PURE__ */ new Set();
    for (const r of this.children)
      for (const i of bn(r.assembleGroupStyle()))
        e.add(i);
    const n = Array.from(e);
    return n.length > 1 ? n : n.length === 1 ? n[0] : void 0;
  }
  assembleTitle() {
    let e = super.assembleTitle();
    if (e)
      return e;
    for (const n of this.children)
      if (e = n.assembleTitle(), e)
        return e;
  }
  assembleLayout() {
    return null;
  }
  assembleMarks() {
    return gQr(this, this.children.flatMap((e) => e.assembleMarks()));
  }
  assembleLegends() {
    return this.children.reduce((e, n) => e.concat(n.assembleLegends()), Ilt(this));
  }
}
function DIe(t, e, n, r, i) {
  if (RY(t))
    return new ZD(t, e, n, i);
  if (PY(t))
    return new RIe(t, e, n, r, i);
  if (hm(t))
    return new klt(t, e, n, r, i);
  if (eSr(t))
    return new u2r(t, e, n, i);
  throw new Error(v0e(t));
}
var eRr = globalThis && globalThis.__rest || function(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
};
function tRr(t, e = {}) {
  e.logger && ibr(e.logger), e.fieldTitle && qat(e.fieldTitle);
  try {
    const n = mAt(fx(e.config, t.config)), r = wAt(t, n), i = DIe(r, null, "", void 0, n);
    return i.parse(), gxr(i.component.data, i), {
      spec: rRr(i, nRr(t, r.autosize, n, i), t.datasets, t.usermeta),
      normalized: r
    };
  } finally {
    e.logger && obr(), e.fieldTitle && C_r();
  }
}
function nRr(t, e, n, r) {
  const i = r.component.layoutSize.get("width"), o = r.component.layoutSize.get("height");
  if (e === void 0 ? (e = { type: "pad" }, r.hasAxisOrientSignalRef() && (e.resize = !0)) : Cn(e) && (e = { type: e }), i && o && iQr(e.type)) {
    if (i === "step" && o === "step")
      Zt(NFe()), e.type = "pad";
    else if (i === "step" || o === "step") {
      const s = i === "step" ? "width" : "height";
      Zt(NFe(yY(s)));
      const a = s === "width" ? "height" : "width";
      e.type = oQr(a);
    }
  }
  return Object.assign(Object.assign(Object.assign({}, Kt(e).length === 1 && e.type ? e.type === "pad" ? {} : { autosize: e.type } : { autosize: e }), aPe(n, !1)), aPe(t, !0));
}
function rRr(t, e, n = {}, r) {
  const i = t.config ? dSr(t.config) : void 0, o = [].concat(
    t.assembleSelectionData([]),
    // only assemble data in the root
    e2r(t.component.data, n)
  ), s = t.assembleProjections(), a = t.assembleTitle(), A = t.assembleGroupStyle(), l = t.assembleGroupEncodeEntry(!0);
  let c = t.assembleLayoutSignals();
  c = c.filter((h) => (h.name === "width" || h.name === "height") && h.value !== void 0 ? (e[h.name] = +h.value, !1) : !0);
  const { params: u } = e, f = eRr(e, ["params"]);
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ $schema: "https://vega.github.io/schema/vega/v5.json" }, t.description ? { description: t.description } : {}), f), a ? { title: a } : {}), A ? { style: A } : {}), l ? { encode: { update: l } } : {}), { data: o }), s.length > 0 ? { projections: s } : {}), t.assembleGroup([
    ...c,
    ...t.assembleSelectionTopLevelSignals([]),
    ...hAt(u)
  ])), i ? { config: i } : {}), r ? { usermeta: r } : {});
}
const iRr = hBr.version, oRr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accessPathDepth: LQ,
  accessPathWithDatum: f0e,
  compile: tRr,
  contains: wi,
  deepEqual: Qp,
  deleteNestedProperty: D6,
  duplicate: Kr,
  entries: fE,
  every: l0e,
  fieldIntersection: u0e,
  flatAccessWithDatum: Dst,
  getFirstDefined: Va,
  hasIntersection: c0e,
  hash: _i,
  internalField: Lst,
  isBoolean: kN,
  isEmpty: Oo,
  isEqual: CBr,
  isInternalField: Mst,
  isNullOrFalse: Eoe,
  isNumeric: dY,
  keys: Kt,
  logicalExpr: WD,
  mergeDeep: xst,
  never: wst,
  normalize: wAt,
  normalizeAngle: GN,
  omit: Ff,
  pick: NQ,
  prefixGenerator: yoe,
  removePathFromField: g0e,
  replaceAll: RB,
  replacePathInField: Vg,
  resetIdCounter: yBr,
  setEqual: Rst,
  some: xB,
  stringify: Xo,
  titleCase: TO,
  unique: wp,
  uniqueId: Nst,
  vals: rc,
  varName: Ls,
  version: iRr
}, Symbol.toStringTag, { value: "Module" }));
function Glt(t) {
  const [e, n] = /schema\/([\w-]+)\/([\w\.\-]+)\.json$/g.exec(t).slice(1, 3);
  return { library: e, version: n };
}
var sRr = "vega-themes", aRr = "2.10.0", ARr = "Themes for stylized Vega and Vega-Lite visualizations.", lRr = [
  "vega",
  "vega-lite",
  "themes",
  "style"
], cRr = "BSD-3-Clause", uRr = {
  name: "UW Interactive Data Lab",
  url: "https://idl.cs.washington.edu"
}, fRr = [
  {
    name: "Emily Gu",
    url: "https://github.com/emilygu"
  },
  {
    name: "Arvind Satyanarayan",
    url: "http://arvindsatya.com"
  },
  {
    name: "Jeffrey Heer",
    url: "https://idl.cs.washington.edu"
  },
  {
    name: "Dominik Moritz",
    url: "https://www.domoritz.de"
  }
], gRr = "build/vega-themes.js", hRr = "build/vega-themes.module.js", dRr = "build/vega-themes.min.js", pRr = "build/vega-themes.min.js", IRr = "build/vega-themes.module.d.ts", mRr = {
  type: "git",
  url: "https://github.com/vega/vega-themes.git"
}, CRr = [
  "src",
  "build"
], ERr = {
  prebuild: "yarn clean",
  build: "rollup -c",
  clean: "rimraf build && rimraf examples/build",
  "copy:data": "rsync -r node_modules/vega-datasets/data/* examples/data",
  "copy:build": "rsync -r build/* examples/build",
  "deploy:gh": "yarn build && mkdir -p examples/build && rsync -r build/* examples/build && gh-pages -d examples",
  preversion: "yarn lint",
  serve: "browser-sync start -s -f build examples --serveStatic examples",
  start: "yarn build && concurrently --kill-others -n Server,Rollup 'yarn serve' 'rollup -c -w'",
  prepare: "beemo create-config",
  eslintbase: "beemo eslint .",
  format: "yarn eslintbase --fix",
  lint: "yarn eslintbase",
  release: "auto shipit"
}, yRr = {
  "@auto-it/conventional-commits": "^10.32.2",
  "@auto-it/first-time-contributor": "^10.32.2",
  "@rollup/plugin-json": "^4.1.0",
  "@rollup/plugin-node-resolve": "^13.0.6",
  "rollup-plugin-ts": "^1.4.7",
  auto: "^10.32.2",
  "browser-sync": "^2.27.7",
  concurrently: "^6.4.0",
  "gh-pages": "^3.2.3",
  rollup: "^2.60.0",
  "rollup-plugin-bundle-size": "^1.0.3",
  "rollup-plugin-terser": "^7.0.2",
  typescript: "^4.4.4",
  vega: "^5.19.1",
  "vega-lite": "^5.0.0",
  "vega-lite-dev-config": "^0.20.0"
}, vRr = {
  vega: "*",
  "vega-lite": "*"
}, BRr = {
  name: sRr,
  version: aRr,
  description: ARr,
  keywords: lRr,
  license: cRr,
  author: uRr,
  contributors: fRr,
  main: gRr,
  module: hRr,
  unpkg: dRr,
  jsdelivr: pRr,
  types: IRr,
  repository: mRr,
  files: CRr,
  scripts: ERr,
  devDependencies: yRr,
  peerDependencies: vRr
};
const kb = "#fff", bRr = "#888", _Rr = {
  background: "#333",
  title: {
    color: kb,
    subtitleColor: kb
  },
  style: {
    "guide-label": {
      fill: kb
    },
    "guide-title": {
      fill: kb
    }
  },
  axis: {
    domainColor: kb,
    gridColor: bRr,
    tickColor: kb
  }
}, xy = "#4572a7", SRr = {
  background: "#fff",
  arc: { fill: xy },
  area: { fill: xy },
  line: { stroke: xy, strokeWidth: 2 },
  path: { stroke: xy },
  rect: { fill: xy },
  shape: { stroke: xy },
  symbol: { fill: xy, strokeWidth: 1.5, size: 50 },
  axis: {
    bandPosition: 0.5,
    grid: !0,
    gridColor: "#000000",
    gridOpacity: 1,
    gridWidth: 0.5,
    labelPadding: 10,
    tickSize: 5,
    tickWidth: 0.5
  },
  axisBand: {
    grid: !1,
    tickExtra: !0
  },
  legend: {
    labelBaseline: "middle",
    labelFontSize: 11,
    symbolSize: 50,
    symbolType: "square"
  },
  range: {
    category: [
      "#4572a7",
      "#aa4643",
      "#8aa453",
      "#71598e",
      "#4598ae",
      "#d98445",
      "#94aace",
      "#d09393",
      "#b9cc98",
      "#a99cbc"
    ]
  }
}, Ry = "#30a2da", CX = "#cbcbcb", QRr = "#999", wRr = "#333", LPe = "#f0f0f0", MPe = "#333", xRr = {
  arc: { fill: Ry },
  area: { fill: Ry },
  axis: {
    domainColor: CX,
    grid: !0,
    gridColor: CX,
    gridWidth: 1,
    labelColor: QRr,
    labelFontSize: 10,
    titleColor: wRr,
    tickColor: CX,
    tickSize: 10,
    titleFontSize: 14,
    titlePadding: 10,
    labelPadding: 4
  },
  axisBand: {
    grid: !1
  },
  background: LPe,
  group: {
    fill: LPe
  },
  legend: {
    labelColor: MPe,
    labelFontSize: 11,
    padding: 1,
    symbolSize: 30,
    symbolType: "square",
    titleColor: MPe,
    titleFontSize: 14,
    titlePadding: 10
  },
  line: {
    stroke: Ry,
    strokeWidth: 2
  },
  path: { stroke: Ry, strokeWidth: 0.5 },
  rect: { fill: Ry },
  range: {
    category: [
      "#30a2da",
      "#fc4f30",
      "#e5ae38",
      "#6d904f",
      "#8b8b8b",
      "#b96db8",
      "#ff9e27",
      "#56cc60",
      "#52d2ca",
      "#52689e",
      "#545454",
      "#9fe4f8"
    ],
    diverging: ["#cc0020", "#e77866", "#f6e7e1", "#d6e8ed", "#91bfd9", "#1d78b5"],
    heatmap: ["#d6e8ed", "#cee0e5", "#91bfd9", "#549cc6", "#1d78b5"]
  },
  point: {
    filled: !0,
    shape: "circle"
  },
  shape: { stroke: Ry },
  bar: {
    binSpacing: 2,
    fill: Ry,
    stroke: null
  },
  title: {
    anchor: "start",
    fontSize: 24,
    fontWeight: 600,
    offset: 20
  }
}, Dy = "#000", RRr = {
  group: {
    fill: "#e5e5e5"
  },
  arc: { fill: Dy },
  area: { fill: Dy },
  line: { stroke: Dy },
  path: { stroke: Dy },
  rect: { fill: Dy },
  shape: { stroke: Dy },
  symbol: { fill: Dy, size: 40 },
  axis: {
    domain: !1,
    grid: !0,
    gridColor: "#FFFFFF",
    gridOpacity: 1,
    labelColor: "#7F7F7F",
    labelPadding: 4,
    tickColor: "#7F7F7F",
    tickSize: 5.67,
    titleFontSize: 16,
    titleFontWeight: "normal"
  },
  legend: {
    labelBaseline: "middle",
    labelFontSize: 11,
    symbolSize: 40
  },
  range: {
    category: [
      "#000000",
      "#7F7F7F",
      "#1A1A1A",
      "#999999",
      "#333333",
      "#B0B0B0",
      "#4D4D4D",
      "#C9C9C9",
      "#666666",
      "#DCDCDC"
    ]
  }
}, DRr = 22, TRr = "normal", OPe = "Benton Gothic, sans-serif", FPe = 11.5, NRr = "normal", Ty = "#82c6df", EX = "Benton Gothic Bold, sans-serif", PPe = "normal", kPe = 13, oR = {
  "category-6": ["#ec8431", "#829eb1", "#c89d29", "#3580b1", "#adc839", "#ab7fb4"],
  "fire-7": ["#fbf2c7", "#f9e39c", "#f8d36e", "#f4bb6a", "#e68a4f", "#d15a40", "#ab4232"],
  "fireandice-6": ["#e68a4f", "#f4bb6a", "#f9e39c", "#dadfe2", "#a6b7c6", "#849eae"],
  "ice-7": ["#edefee", "#dadfe2", "#c4ccd2", "#a6b7c6", "#849eae", "#607785", "#47525d"]
}, LRr = {
  background: "#ffffff",
  title: {
    anchor: "start",
    color: "#000000",
    font: EX,
    fontSize: DRr,
    fontWeight: TRr
  },
  arc: { fill: Ty },
  area: { fill: Ty },
  line: { stroke: Ty, strokeWidth: 2 },
  path: { stroke: Ty },
  rect: { fill: Ty },
  shape: { stroke: Ty },
  symbol: { fill: Ty, size: 30 },
  axis: {
    labelFont: OPe,
    labelFontSize: FPe,
    labelFontWeight: NRr,
    titleFont: EX,
    titleFontSize: kPe,
    titleFontWeight: PPe
  },
  axisX: {
    labelAngle: 0,
    labelPadding: 4,
    tickSize: 3
  },
  axisY: {
    labelBaseline: "middle",
    maxExtent: 45,
    minExtent: 45,
    tickSize: 2,
    titleAlign: "left",
    titleAngle: 0,
    titleX: -45,
    titleY: -11
  },
  legend: {
    labelFont: OPe,
    labelFontSize: FPe,
    symbolType: "square",
    titleFont: EX,
    titleFontSize: kPe,
    titleFontWeight: PPe
  },
  range: {
    category: oR["category-6"],
    diverging: oR["fireandice-6"],
    heatmap: oR["fire-7"],
    ordinal: oR["fire-7"],
    ramp: oR["fire-7"]
  }
}, Ny = "#ab5787", z3 = "#979797", MRr = {
  background: "#f9f9f9",
  arc: { fill: Ny },
  area: { fill: Ny },
  line: { stroke: Ny },
  path: { stroke: Ny },
  rect: { fill: Ny },
  shape: { stroke: Ny },
  symbol: { fill: Ny, size: 30 },
  axis: {
    domainColor: z3,
    domainWidth: 0.5,
    gridWidth: 0.2,
    labelColor: z3,
    tickColor: z3,
    tickWidth: 0.2,
    titleColor: z3
  },
  axisBand: {
    grid: !1
  },
  axisX: {
    grid: !0,
    tickSize: 10
  },
  axisY: {
    domain: !1,
    grid: !0,
    tickSize: 0
  },
  legend: {
    labelFontSize: 11,
    padding: 1,
    symbolSize: 30,
    symbolType: "square"
  },
  range: {
    category: [
      "#ab5787",
      "#51b2e5",
      "#703c5c",
      "#168dd9",
      "#d190b6",
      "#00609f",
      "#d365ba",
      "#154866",
      "#666666",
      "#c4c4c4"
    ]
  }
}, Ly = "#3e5c69", ORr = {
  background: "#fff",
  arc: { fill: Ly },
  area: { fill: Ly },
  line: { stroke: Ly },
  path: { stroke: Ly },
  rect: { fill: Ly },
  shape: { stroke: Ly },
  symbol: { fill: Ly },
  axis: {
    domainWidth: 0.5,
    grid: !0,
    labelPadding: 2,
    tickSize: 5,
    tickWidth: 0.5,
    titleFontWeight: "normal"
  },
  axisBand: {
    grid: !1
  },
  axisX: {
    gridWidth: 0.2
  },
  axisY: {
    gridDash: [3],
    gridWidth: 0.4
  },
  legend: {
    labelFontSize: 11,
    padding: 1,
    symbolType: "square"
  },
  range: {
    category: ["#3e5c69", "#6793a6", "#182429", "#0570b0", "#3690c0", "#74a9cf", "#a6bddb", "#e2ddf2"]
  }
}, og = "#1696d2", GPe = "#000000", FRr = "#FFFFFF", V3 = "Lato", yX = "Lato", PRr = "Lato", kRr = "#DEDDDD", GRr = 18, sR = {
  "main-colors": ["#1696d2", "#d2d2d2", "#000000", "#fdbf11", "#ec008b", "#55b748", "#5c5859", "#db2b27"],
  "shades-blue": ["#CFE8F3", "#A2D4EC", "#73BFE2", "#46ABDB", "#1696D2", "#12719E", "#0A4C6A", "#062635"],
  "shades-gray": ["#F5F5F5", "#ECECEC", "#E3E3E3", "#DCDBDB", "#D2D2D2", "#9D9D9D", "#696969", "#353535"],
  "shades-yellow": ["#FFF2CF", "#FCE39E", "#FDD870", "#FCCB41", "#FDBF11", "#E88E2D", "#CA5800", "#843215"],
  "shades-magenta": ["#F5CBDF", "#EB99C2", "#E46AA7", "#E54096", "#EC008B", "#AF1F6B", "#761548", "#351123"],
  "shades-green": ["#DCEDD9", "#BCDEB4", "#98CF90", "#78C26D", "#55B748", "#408941", "#2C5C2D", "#1A2E19"],
  "shades-black": ["#D5D5D4", "#ADABAC", "#848081", "#5C5859", "#332D2F", "#262223", "#1A1717", "#0E0C0D"],
  "shades-red": ["#F8D5D4", "#F1AAA9", "#E9807D", "#E25552", "#DB2B27", "#A4201D", "#6E1614", "#370B0A"],
  "one-group": ["#1696d2", "#000000"],
  "two-groups-cat-1": ["#1696d2", "#000000"],
  "two-groups-cat-2": ["#1696d2", "#fdbf11"],
  "two-groups-cat-3": ["#1696d2", "#db2b27"],
  "two-groups-seq": ["#a2d4ec", "#1696d2"],
  "three-groups-cat": ["#1696d2", "#fdbf11", "#000000"],
  "three-groups-seq": ["#a2d4ec", "#1696d2", "#0a4c6a"],
  "four-groups-cat-1": ["#000000", "#d2d2d2", "#fdbf11", "#1696d2"],
  "four-groups-cat-2": ["#1696d2", "#ec0008b", "#fdbf11", "#5c5859"],
  "four-groups-seq": ["#cfe8f3", "#73bf42", "#1696d2", "#0a4c6a"],
  "five-groups-cat-1": ["#1696d2", "#fdbf11", "#d2d2d2", "#ec008b", "#000000"],
  "five-groups-cat-2": ["#1696d2", "#0a4c6a", "#d2d2d2", "#fdbf11", "#332d2f"],
  "five-groups-seq": ["#cfe8f3", "#73bf42", "#1696d2", "#0a4c6a", "#000000"],
  "six-groups-cat-1": ["#1696d2", "#ec008b", "#fdbf11", "#000000", "#d2d2d2", "#55b748"],
  "six-groups-cat-2": ["#1696d2", "#d2d2d2", "#ec008b", "#fdbf11", "#332d2f", "#0a4c6a"],
  "six-groups-seq": ["#cfe8f3", "#a2d4ec", "#73bfe2", "#46abdb", "#1696d2", "#12719e"],
  "diverging-colors": ["#ca5800", "#fdbf11", "#fdd870", "#fff2cf", "#cfe8f3", "#73bfe2", "#1696d2", "#0a4c6a"]
}, URr = {
  background: FRr,
  title: {
    anchor: "start",
    fontSize: GRr,
    font: V3
  },
  axisX: {
    domain: !0,
    domainColor: GPe,
    domainWidth: 1,
    grid: !1,
    labelFontSize: 12,
    labelFont: yX,
    labelAngle: 0,
    tickColor: GPe,
    tickSize: 5,
    titleFontSize: 12,
    titlePadding: 10,
    titleFont: V3
  },
  axisY: {
    domain: !1,
    domainWidth: 1,
    grid: !0,
    gridColor: kRr,
    gridWidth: 1,
    labelFontSize: 12,
    labelFont: yX,
    labelPadding: 8,
    ticks: !1,
    titleFontSize: 12,
    titlePadding: 10,
    titleFont: V3,
    titleAngle: 0,
    titleY: -10,
    titleX: 18
  },
  legend: {
    labelFontSize: 12,
    labelFont: yX,
    symbolSize: 100,
    titleFontSize: 12,
    titlePadding: 10,
    titleFont: V3,
    orient: "right",
    offset: 10
  },
  view: {
    stroke: "transparent"
  },
  range: {
    category: sR["six-groups-cat-1"],
    diverging: sR["diverging-colors"],
    heatmap: sR["diverging-colors"],
    ordinal: sR["six-groups-seq"],
    ramp: sR["shades-blue"]
  },
  area: {
    fill: og
  },
  rect: {
    fill: og
  },
  line: {
    color: og,
    stroke: og,
    strokeWidth: 5
  },
  trail: {
    color: og,
    stroke: og,
    strokeWidth: 0,
    size: 1
  },
  path: {
    stroke: og,
    strokeWidth: 0.5
  },
  point: {
    filled: !0
  },
  text: {
    font: PRr,
    color: og,
    fontSize: 11,
    align: "center",
    fontWeight: 400,
    size: 11
  },
  style: {
    bar: {
      fill: og,
      stroke: null
    }
  },
  arc: { fill: og },
  shape: { stroke: og },
  symbol: { fill: og, size: 30 }
}, My = "#3366CC", UPe = "#ccc", J3 = "Arial, sans-serif", HRr = {
  arc: { fill: My },
  area: { fill: My },
  path: { stroke: My },
  rect: { fill: My },
  shape: { stroke: My },
  symbol: { stroke: My },
  circle: { fill: My },
  background: "#fff",
  padding: {
    top: 10,
    right: 10,
    bottom: 10,
    left: 10
  },
  style: {
    "guide-label": {
      font: J3,
      fontSize: 12
    },
    "guide-title": {
      font: J3,
      fontSize: 12
    },
    "group-title": {
      font: J3,
      fontSize: 12
    }
  },
  title: {
    font: J3,
    fontSize: 14,
    fontWeight: "bold",
    dy: -3,
    anchor: "start"
  },
  axis: {
    gridColor: UPe,
    tickColor: UPe,
    domain: !1,
    grid: !0
  },
  range: {
    category: [
      "#4285F4",
      "#DB4437",
      "#F4B400",
      "#0F9D58",
      "#AB47BC",
      "#00ACC1",
      "#FF7043",
      "#9E9D24",
      "#5C6BC0",
      "#F06292",
      "#00796B",
      "#C2185B"
    ],
    heatmap: ["#c6dafc", "#5e97f6", "#2a56c6"]
  }
}, TIe = (t) => t * (1 / 3 + 1), HPe = TIe(9), $Pe = TIe(10), qPe = TIe(12), aR = "Segoe UI", jPe = "wf_standard-font, helvetica, arial, sans-serif", YPe = "#252423", AR = "#605E5C", zPe = "transparent", $Rr = "#C8C6C4", _h = "#118DFF", qRr = "#12239E", jRr = "#E66C37", YRr = "#6B007B", zRr = "#E044A7", VRr = "#744EC2", JRr = "#D9B300", KRr = "#D64550", Ult = _h, Hlt = "#DEEFFF", VPe = [Hlt, Ult], WRr = [
  Hlt,
  "#c7e4ff",
  "#b0d9ff",
  "#9aceff",
  "#83c3ff",
  "#6cb9ff",
  "#55aeff",
  "#3fa3ff",
  "#2898ff",
  Ult
], XRr = {
  view: { stroke: zPe },
  background: zPe,
  font: aR,
  header: {
    titleFont: jPe,
    titleFontSize: qPe,
    titleColor: YPe,
    labelFont: aR,
    labelFontSize: $Pe,
    labelColor: AR
  },
  axis: {
    ticks: !1,
    grid: !1,
    domain: !1,
    labelColor: AR,
    labelFontSize: HPe,
    titleFont: jPe,
    titleColor: YPe,
    titleFontSize: qPe,
    titleFontWeight: "normal"
  },
  axisQuantitative: {
    tickCount: 3,
    grid: !0,
    gridColor: $Rr,
    gridDash: [1, 5],
    labelFlush: !1
  },
  axisBand: { tickExtra: !0 },
  axisX: { labelPadding: 5 },
  axisY: { labelPadding: 10 },
  bar: { fill: _h },
  line: {
    stroke: _h,
    strokeWidth: 3,
    strokeCap: "round",
    strokeJoin: "round"
  },
  text: { font: aR, fontSize: HPe, fill: AR },
  arc: { fill: _h },
  area: { fill: _h, line: !0, opacity: 0.6 },
  path: { stroke: _h },
  rect: { fill: _h },
  point: { fill: _h, filled: !0, size: 75 },
  shape: { stroke: _h },
  symbol: { fill: _h, strokeWidth: 1.5, size: 50 },
  legend: {
    titleFont: aR,
    titleFontWeight: "bold",
    titleColor: AR,
    labelFont: aR,
    labelFontSize: $Pe,
    labelColor: AR,
    symbolType: "circle",
    symbolSize: 75
  },
  range: {
    category: [
      _h,
      qRr,
      jRr,
      YRr,
      zRr,
      VRr,
      JRr,
      KRr
    ],
    diverging: VPe,
    heatmap: VPe,
    ordinal: WRr
  }
}, ZRr = BRr.version, eDr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  dark: _Rr,
  excel: SRr,
  fivethirtyeight: xRr,
  ggplot2: RRr,
  googlecharts: HRr,
  latimes: LRr,
  powerbi: XRr,
  quartz: MRr,
  urbaninstitute: URr,
  version: ZRr,
  vox: ORr
}, Symbol.toStringTag, { value: "Module" }));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function tDr(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function nDr(t, e, n) {
  if (Nt(t))
    return `[${t.map((r) => e(Cn(r) ? r : JPe(r, n))).join(", ")}]`;
  if (_n(t)) {
    let r = "";
    const i = t, { title: o, image: s } = i, a = tDr(i, ["title", "image"]);
    o && (r += `<h2>${e(o)}</h2>`), s && (r += `<img src="${e(s)}">`);
    const A = Object.keys(a);
    if (A.length > 0) {
      r += "<table>";
      for (const l of A) {
        let c = a[l];
        c !== void 0 && (_n(c) && (c = JPe(c, n)), r += `<tr><td class="key">${e(l)}:</td><td class="value">${e(c)}</td></tr>`);
      }
      r += "</table>";
    }
    return r || "{}";
  }
  return e(t);
}
function rDr(t) {
  const e = [];
  return function(n, r) {
    if (typeof r != "object" || r === null)
      return r;
    const i = e.indexOf(this) + 1;
    return e.length = i, e.length > t ? "[Object]" : e.indexOf(r) >= 0 ? "[Circular]" : (e.push(r), r);
  };
}
function JPe(t, e) {
  return JSON.stringify(t, rDr(e));
}
var iDr = `#vg-tooltip-element {
  visibility: hidden;
  padding: 8px;
  position: fixed;
  z-index: 1000;
  font-family: sans-serif;
  font-size: 11px;
  border-radius: 3px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  /* The default theme is the light theme. */
  background-color: rgba(255, 255, 255, 0.95);
  border: 1px solid #d9d9d9;
  color: black;
}
#vg-tooltip-element.visible {
  visibility: visible;
}
#vg-tooltip-element h2 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 13px;
}
#vg-tooltip-element img {
  max-width: 200px;
  max-height: 200px;
}
#vg-tooltip-element table {
  border-spacing: 0;
}
#vg-tooltip-element table tr {
  border: none;
}
#vg-tooltip-element table tr td {
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 2px;
  padding-bottom: 2px;
}
#vg-tooltip-element table tr td.key {
  color: #808080;
  max-width: 150px;
  text-align: right;
  padding-right: 4px;
}
#vg-tooltip-element table tr td.value {
  display: block;
  max-width: 300px;
  max-height: 7em;
  text-align: left;
}
#vg-tooltip-element.dark-theme {
  background-color: rgba(32, 32, 32, 0.9);
  border: 1px solid #f5f5f5;
  color: white;
}
#vg-tooltip-element.dark-theme td.key {
  color: #bfbfbf;
}
`;
const $lt = "vg-tooltip-element", oDr = {
  /**
   * X offset.
   */
  offsetX: 10,
  /**
   * Y offset.
   */
  offsetY: 10,
  /**
   * ID of the tooltip element.
   */
  id: $lt,
  /**
   * ID of the tooltip CSS style.
   */
  styleId: "vega-tooltip-style",
  /**
   * The name of the theme. You can use the CSS class called [THEME]-theme to style the tooltips.
   *
   * There are two predefined themes: "light" (default) and "dark".
   */
  theme: "light",
  /**
   * Do not use the default styles provided by Vega Tooltip. If you enable this option, you need to use your own styles. It is not necessary to disable the default style when using a custom theme.
   */
  disableDefaultStyle: !1,
  /**
   * HTML sanitizer function that removes dangerous HTML to prevent XSS.
   *
   * This should be a function from string to string. You may replace it with a formatter such as a markdown formatter.
   */
  sanitize: sDr,
  /**
   * The maximum recursion depth when printing objects in the tooltip.
   */
  maxDepth: 2,
  /**
   * A function to customize the rendered HTML of the tooltip.
   * @param value A value string, or object of value strings keyed by field
   * @param sanitize The `sanitize` function from `options.sanitize`
   * @returns {string} The returned string will become the `innerHTML` of the tooltip element
   */
  formatTooltip: nDr
};
function sDr(t) {
  return String(t).replace(/&/g, "&amp;").replace(/</g, "&lt;");
}
function aDr(t) {
  if (!/^[A-Za-z]+[-:.\w]*$/.test(t))
    throw new Error("Invalid HTML ID");
  return iDr.toString().replace($lt, t);
}
function ADr(t, e, n, r) {
  let i = t.clientX + n;
  i + e.width > window.innerWidth && (i = +t.clientX - n - e.width);
  let o = t.clientY + r;
  return o + e.height > window.innerHeight && (o = +t.clientY - r - e.height), { x: i, y: o };
}
class lDr {
  /**
   * Create the tooltip handler and initialize the element and style.
   *
   * @param options Tooltip Options
   */
  constructor(e) {
    this.options = Object.assign(Object.assign({}, oDr), e);
    const n = this.options.id;
    if (this.el = null, this.call = this.tooltipHandler.bind(this), !this.options.disableDefaultStyle && !document.getElementById(this.options.styleId)) {
      const r = document.createElement("style");
      r.setAttribute("id", this.options.styleId), r.innerHTML = aDr(n);
      const i = document.head;
      i.childNodes.length > 0 ? i.insertBefore(r, i.childNodes[0]) : i.appendChild(r);
    }
  }
  /**
   * The tooltip handler function.
   */
  tooltipHandler(e, n, r, i) {
    var o;
    if (this.el = document.getElementById(this.options.id), this.el || (this.el = document.createElement("div"), this.el.setAttribute("id", this.options.id), this.el.classList.add("vg-tooltip"), ((o = document.fullscreenElement) !== null && o !== void 0 ? o : document.body).appendChild(this.el)), i == null || i === "") {
      this.el.classList.remove("visible", `${this.options.theme}-theme`);
      return;
    }
    this.el.innerHTML = this.options.formatTooltip(i, this.options.sanitize, this.options.maxDepth), this.el.classList.add("visible", `${this.options.theme}-theme`);
    const { x: s, y: a } = ADr(n, this.el.getBoundingClientRect(), this.options.offsetX, this.options.offsetY);
    this.el.setAttribute("style", `top: ${a}px; left: ${s}px`);
  }
}
function cDr(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function KPe(t, e, n, r, i, o, s) {
  try {
    var a = t[o](s), A = a.value;
  } catch (l) {
    n(l);
    return;
  }
  a.done ? e(A) : Promise.resolve(A).then(r, i);
}
function Y6(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(r, i) {
      var o = t.apply(e, n);
      function s(A) {
        KPe(o, r, i, s, a, "next", A);
      }
      function a(A) {
        KPe(o, r, i, s, a, "throw", A);
      }
      s(void 0);
    });
  };
}
var qlt = Object.prototype, Iv = qlt.hasOwnProperty, Bp, NIe = typeof Symbol == "function" ? Symbol : {}, ez = NIe.iterator || "@@iterator", uDr = NIe.asyncIterator || "@@asyncIterator", z6 = NIe.toStringTag || "@@toStringTag";
function jlt(t, e, n, r) {
  var i = e && e.prototype instanceof Voe ? e : Voe, o = Object.create(i.prototype), s = new Joe(r || []);
  return o._invoke = pDr(t, n, s), o;
}
function LIe(t, e, n) {
  try {
    return {
      type: "normal",
      arg: t.call(e, n)
    };
  } catch (r) {
    return {
      type: "throw",
      arg: r
    };
  }
}
var WPe = "suspendedStart", fDr = "suspendedYield", XPe = "executing", K3 = "completed", Uh = {};
function Voe() {
}
function tz() {
}
function YQ() {
}
var MIe = {};
MIe[ez] = function() {
  return this;
};
var vX = Object.getPrototypeOf, W3 = vX && vX(vX(OIe([])));
W3 && W3 !== qlt && Iv.call(W3, ez) && (MIe = W3);
var Mx = YQ.prototype = Voe.prototype = Object.create(MIe);
tz.prototype = Mx.constructor = YQ;
YQ.constructor = tz;
YQ[z6] = tz.displayName = "GeneratorFunction";
function Ylt(t) {
  ["next", "throw", "return"].forEach(function(e) {
    t[e] = function(n) {
      return this._invoke(e, n);
    };
  });
}
function zlt(t) {
  var e = typeof t == "function" && t.constructor;
  return e ? e === tz || // For the native GeneratorFunction constructor, the best we can
  // do is to check its .name property.
  (e.displayName || e.name) === "GeneratorFunction" : !1;
}
function gDr(t) {
  return Object.setPrototypeOf ? Object.setPrototypeOf(t, YQ) : (t.__proto__ = YQ, z6 in t || (t[z6] = "GeneratorFunction")), t.prototype = Object.create(Mx), t;
}
function hDr(t) {
  return {
    __await: t
  };
}
function nz(t, e) {
  function n(o, s, a, A) {
    var l = LIe(t[o], t, s);
    if (l.type === "throw")
      A(l.arg);
    else {
      var c = l.arg, u = c.value;
      return u && typeof u == "object" && Iv.call(u, "__await") ? e.resolve(u.__await).then(function(f) {
        n("next", f, a, A);
      }, function(f) {
        n("throw", f, a, A);
      }) : e.resolve(u).then(function(f) {
        c.value = f, a(c);
      }, function(f) {
        return n("throw", f, a, A);
      });
    }
  }
  var r;
  function i(o, s) {
    function a() {
      return new e(function(A, l) {
        n(o, s, A, l);
      });
    }
    return r = // If enqueue has been called before, then we want to wait until
    // all previous Promises have been resolved before calling invoke,
    // so that results are always delivered in the correct order. If
    // enqueue has not been called before, then it is important to
    // call invoke immediately, without waiting on a callback to fire,
    // so that the async generator function has the opportunity to do
    // any necessary setup in a predictable way. This predictability
    // is why the Promise constructor synchronously invokes its
    // executor callback, and why async functions synchronously
    // execute code before the first await. Since we implement simple
    // async functions in terms of async generators, it is especially
    // important to get this right, even though it requires care.
    r ? r.then(
      a,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      a
    ) : a();
  }
  this._invoke = i;
}
Ylt(nz.prototype);
nz.prototype[uDr] = function() {
  return this;
};
function dDr(t, e, n, r, i) {
  i === void 0 && (i = Promise);
  var o = new nz(jlt(t, e, n, r), i);
  return zlt(e) ? o : o.next().then(function(s) {
    return s.done ? s.value : o.next();
  });
}
function pDr(t, e, n) {
  var r = WPe;
  return function(o, s) {
    if (r === XPe)
      throw new Error("Generator is already running");
    if (r === K3) {
      if (o === "throw")
        throw s;
      return Jlt();
    }
    for (n.method = o, n.arg = s; ; ) {
      var a = n.delegate;
      if (a) {
        var A = Vlt(a, n);
        if (A) {
          if (A === Uh)
            continue;
          return A;
        }
      }
      if (n.method === "next")
        n.sent = n._sent = n.arg;
      else if (n.method === "throw") {
        if (r === WPe)
          throw r = K3, n.arg;
        n.dispatchException(n.arg);
      } else
        n.method === "return" && n.abrupt("return", n.arg);
      r = XPe;
      var l = LIe(t, e, n);
      if (l.type === "normal") {
        if (r = n.done ? K3 : fDr, l.arg === Uh)
          continue;
        return {
          value: l.arg,
          done: n.done
        };
      } else
        l.type === "throw" && (r = K3, n.method = "throw", n.arg = l.arg);
    }
  };
}
function Vlt(t, e) {
  var n = t.iterator[e.method];
  if (n === Bp) {
    if (e.delegate = null, e.method === "throw") {
      if (t.iterator.return && (e.method = "return", e.arg = Bp, Vlt(t, e), e.method === "throw"))
        return Uh;
      e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
    }
    return Uh;
  }
  var r = LIe(n, t.iterator, e.arg);
  if (r.type === "throw")
    return e.method = "throw", e.arg = r.arg, e.delegate = null, Uh;
  var i = r.arg;
  if (!i)
    return e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, Uh;
  if (i.done)
    e[t.resultName] = i.value, e.next = t.nextLoc, e.method !== "return" && (e.method = "next", e.arg = Bp);
  else
    return i;
  return e.delegate = null, Uh;
}
Ylt(Mx);
Mx[z6] = "Generator";
Mx[ez] = function() {
  return this;
};
Mx.toString = function() {
  return "[object Generator]";
};
function IDr(t) {
  var e = {
    tryLoc: t[0]
  };
  1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
}
function BX(t) {
  var e = t.completion || {};
  e.type = "normal", delete e.arg, t.completion = e;
}
function Joe(t) {
  this.tryEntries = [{
    tryLoc: "root"
  }], t.forEach(IDr, this), this.reset(!0);
}
function mDr(t) {
  var e = [];
  for (var n in t)
    e.push(n);
  return e.reverse(), function r() {
    for (; e.length; ) {
      var i = e.pop();
      if (i in t)
        return r.value = i, r.done = !1, r;
    }
    return r.done = !0, r;
  };
}
function OIe(t) {
  if (t) {
    var e = t[ez];
    if (e)
      return e.call(t);
    if (typeof t.next == "function")
      return t;
    if (!isNaN(t.length)) {
      var n = -1, r = function i() {
        for (; ++n < t.length; )
          if (Iv.call(t, n))
            return i.value = t[n], i.done = !1, i;
        return i.value = Bp, i.done = !0, i;
      };
      return r.next = r;
    }
  }
  return {
    next: Jlt
  };
}
function Jlt() {
  return {
    value: Bp,
    done: !0
  };
}
Joe.prototype = {
  constructor: Joe,
  reset: function(e) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = Bp, this.done = !1, this.delegate = null, this.method = "next", this.arg = Bp, this.tryEntries.forEach(BX), !e)
      for (var n in this)
        n.charAt(0) === "t" && Iv.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = Bp);
  },
  stop: function() {
    this.done = !0;
    var e = this.tryEntries[0], n = e.completion;
    if (n.type === "throw")
      throw n.arg;
    return this.rval;
  },
  dispatchException: function(e) {
    if (this.done)
      throw e;
    var n = this;
    function r(l, c) {
      return s.type = "throw", s.arg = e, n.next = l, c && (n.method = "next", n.arg = Bp), !!c;
    }
    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
      var o = this.tryEntries[i], s = o.completion;
      if (o.tryLoc === "root")
        return r("end");
      if (o.tryLoc <= this.prev) {
        var a = Iv.call(o, "catchLoc"), A = Iv.call(o, "finallyLoc");
        if (a && A) {
          if (this.prev < o.catchLoc)
            return r(o.catchLoc, !0);
          if (this.prev < o.finallyLoc)
            return r(o.finallyLoc);
        } else if (a) {
          if (this.prev < o.catchLoc)
            return r(o.catchLoc, !0);
        } else if (A) {
          if (this.prev < o.finallyLoc)
            return r(o.finallyLoc);
        } else
          throw new Error("try statement without catch or finally");
      }
    }
  },
  abrupt: function(e, n) {
    for (var r = this.tryEntries.length - 1; r >= 0; --r) {
      var i = this.tryEntries[r];
      if (i.tryLoc <= this.prev && Iv.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
        var o = i;
        break;
      }
    }
    o && (e === "break" || e === "continue") && o.tryLoc <= n && n <= o.finallyLoc && (o = null);
    var s = o ? o.completion : {};
    return s.type = e, s.arg = n, o ? (this.method = "next", this.next = o.finallyLoc, Uh) : this.complete(s);
  },
  complete: function(e, n) {
    if (e.type === "throw")
      throw e.arg;
    return e.type === "break" || e.type === "continue" ? this.next = e.arg : e.type === "return" ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : e.type === "normal" && n && (this.next = n), Uh;
  },
  finish: function(e) {
    for (var n = this.tryEntries.length - 1; n >= 0; --n) {
      var r = this.tryEntries[n];
      if (r.finallyLoc === e)
        return this.complete(r.completion, r.afterLoc), BX(r), Uh;
    }
  },
  catch: function(e) {
    for (var n = this.tryEntries.length - 1; n >= 0; --n) {
      var r = this.tryEntries[n];
      if (r.tryLoc === e) {
        var i = r.completion;
        if (i.type === "throw") {
          var o = i.arg;
          BX(r);
        }
        return o;
      }
    }
    throw new Error("illegal catch attempt");
  },
  delegateYield: function(e, n, r) {
    return this.delegate = {
      iterator: OIe(e),
      resultName: n,
      nextLoc: r
    }, this.method === "next" && (this.arg = Bp), Uh;
  }
};
var Rp = {
  wrap: jlt,
  isGeneratorFunction: zlt,
  AsyncIterator: nz,
  mark: gDr,
  awrap: hDr,
  async: dDr,
  keys: mDr,
  values: OIe
}, CDr = Ji;
Ji.Node = kB;
Ji.create = Ji;
function Ji(t) {
  var e = this;
  if (e instanceof Ji || (e = new Ji()), e.tail = null, e.head = null, e.length = 0, t && typeof t.forEach == "function")
    t.forEach(function(i) {
      e.push(i);
    });
  else if (arguments.length > 0)
    for (var n = 0, r = arguments.length; n < r; n++)
      e.push(arguments[n]);
  return e;
}
Ji.prototype.removeNode = function(t) {
  if (t.list !== this)
    throw new Error("removing node which does not belong to this list");
  var e = t.next, n = t.prev;
  return e && (e.prev = n), n && (n.next = e), t === this.head && (this.head = e), t === this.tail && (this.tail = n), t.list.length--, t.next = null, t.prev = null, t.list = null, e;
};
Ji.prototype.unshiftNode = function(t) {
  if (t !== this.head) {
    t.list && t.list.removeNode(t);
    var e = this.head;
    t.list = this, t.next = e, e && (e.prev = t), this.head = t, this.tail || (this.tail = t), this.length++;
  }
};
Ji.prototype.pushNode = function(t) {
  if (t !== this.tail) {
    t.list && t.list.removeNode(t);
    var e = this.tail;
    t.list = this, t.prev = e, e && (e.next = t), this.tail = t, this.head || (this.head = t), this.length++;
  }
};
Ji.prototype.push = function() {
  for (var t = 0, e = arguments.length; t < e; t++)
    yDr(this, arguments[t]);
  return this.length;
};
Ji.prototype.unshift = function() {
  for (var t = 0, e = arguments.length; t < e; t++)
    vDr(this, arguments[t]);
  return this.length;
};
Ji.prototype.pop = function() {
  if (this.tail) {
    var t = this.tail.value;
    return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, t;
  }
};
Ji.prototype.shift = function() {
  if (this.head) {
    var t = this.head.value;
    return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, t;
  }
};
Ji.prototype.forEach = function(t, e) {
  e = e || this;
  for (var n = this.head, r = 0; n !== null; r++)
    t.call(e, n.value, r, this), n = n.next;
};
Ji.prototype.forEachReverse = function(t, e) {
  e = e || this;
  for (var n = this.tail, r = this.length - 1; n !== null; r--)
    t.call(e, n.value, r, this), n = n.prev;
};
Ji.prototype.get = function(t) {
  for (var e = 0, n = this.head; n !== null && e < t; e++)
    n = n.next;
  if (e === t && n !== null)
    return n.value;
};
Ji.prototype.getReverse = function(t) {
  for (var e = 0, n = this.tail; n !== null && e < t; e++)
    n = n.prev;
  if (e === t && n !== null)
    return n.value;
};
Ji.prototype.map = function(t, e) {
  e = e || this;
  for (var n = new Ji(), r = this.head; r !== null; )
    n.push(t.call(e, r.value, this)), r = r.next;
  return n;
};
Ji.prototype.mapReverse = function(t, e) {
  e = e || this;
  for (var n = new Ji(), r = this.tail; r !== null; )
    n.push(t.call(e, r.value, this)), r = r.prev;
  return n;
};
Ji.prototype.reduce = function(t, e) {
  var n, r = this.head;
  if (arguments.length > 1)
    n = e;
  else if (this.head)
    r = this.head.next, n = this.head.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var i = 0; r !== null; i++)
    n = t(n, r.value, i), r = r.next;
  return n;
};
Ji.prototype.reduceReverse = function(t, e) {
  var n, r = this.tail;
  if (arguments.length > 1)
    n = e;
  else if (this.tail)
    r = this.tail.prev, n = this.tail.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var i = this.length - 1; r !== null; i--)
    n = t(n, r.value, i), r = r.prev;
  return n;
};
Ji.prototype.toArray = function() {
  for (var t = new Array(this.length), e = 0, n = this.head; n !== null; e++)
    t[e] = n.value, n = n.next;
  return t;
};
Ji.prototype.toArrayReverse = function() {
  for (var t = new Array(this.length), e = 0, n = this.tail; n !== null; e++)
    t[e] = n.value, n = n.prev;
  return t;
};
Ji.prototype.slice = function(t, e) {
  e = e || this.length, e < 0 && (e += this.length), t = t || 0, t < 0 && (t += this.length);
  var n = new Ji();
  if (e < t || e < 0)
    return n;
  t < 0 && (t = 0), e > this.length && (e = this.length);
  for (var r = 0, i = this.head; i !== null && r < t; r++)
    i = i.next;
  for (; i !== null && r < e; r++, i = i.next)
    n.push(i.value);
  return n;
};
Ji.prototype.sliceReverse = function(t, e) {
  e = e || this.length, e < 0 && (e += this.length), t = t || 0, t < 0 && (t += this.length);
  var n = new Ji();
  if (e < t || e < 0)
    return n;
  t < 0 && (t = 0), e > this.length && (e = this.length);
  for (var r = this.length, i = this.tail; i !== null && r > e; r--)
    i = i.prev;
  for (; i !== null && r > t; r--, i = i.prev)
    n.push(i.value);
  return n;
};
Ji.prototype.splice = function(t, e) {
  t > this.length && (t = this.length - 1), t < 0 && (t = this.length + t);
  for (var n = 0, r = this.head; r !== null && n < t; n++)
    r = r.next;
  for (var i = [], n = 0; r && n < e; n++)
    i.push(r.value), r = this.removeNode(r);
  r === null && (r = this.tail), r !== this.head && r !== this.tail && (r = r.prev);
  for (var n = 0; n < (arguments.length <= 2 ? 0 : arguments.length - 2); n++)
    r = EDr(this, r, n + 2 < 2 || arguments.length <= n + 2 ? void 0 : arguments[n + 2]);
  return i;
};
Ji.prototype.reverse = function() {
  for (var t = this.head, e = this.tail, n = t; n !== null; n = n.prev) {
    var r = n.prev;
    n.prev = n.next, n.next = r;
  }
  return this.head = e, this.tail = t, this;
};
function EDr(t, e, n) {
  var r = e === t.head ? new kB(n, null, e, t) : new kB(n, e, e.next, t);
  return r.next === null && (t.tail = r), r.prev === null && (t.head = r), t.length++, r;
}
function yDr(t, e) {
  t.tail = new kB(e, t.tail, null, t), t.head || (t.head = t.tail), t.length++;
}
function vDr(t, e) {
  t.head = new kB(e, null, t.head, t), t.tail || (t.tail = t.head), t.length++;
}
function kB(t, e, n, r) {
  if (!(this instanceof kB))
    return new kB(t, e, n, r);
  this.list = r, this.value = t, e ? (e.next = this, this.prev = e) : this.prev = null, n ? (n.prev = this, this.next = n) : this.next = null;
}
try {
  Ji.prototype[Symbol.iterator] = /* @__PURE__ */ Rp.mark(function t() {
    var e;
    return Rp.wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            e = this.head;
          case 1:
            if (!e) {
              r.next = 7;
              break;
            }
            return r.next = 4, e.value;
          case 4:
            e = e.next, r.next = 1;
            break;
          case 7:
          case "end":
            return r.stop();
        }
    }, t, this);
  });
} catch {
}
var BDr = CDr, nv = Symbol("max"), tI = Symbol("length"), Gb = Symbol("lengthCalculator"), eT = Symbol("allowStale"), mv = Symbol("maxAge"), j0 = Symbol("dispose"), ZPe = Symbol("noDisposeOnSet"), SA = Symbol("lruList"), wh = Symbol("cache"), Klt = Symbol("updateAgeOnGet"), bX = () => 1;
class bDr {
  constructor(e) {
    if (typeof e == "number" && (e = {
      max: e
    }), e || (e = {}), e.max && (typeof e.max != "number" || e.max < 0))
      throw new TypeError("max must be a non-negative number");
    this[nv] = e.max || 1 / 0;
    var n = e.length || bX;
    if (this[Gb] = typeof n != "function" ? bX : n, this[eT] = e.stale || !1, e.maxAge && typeof e.maxAge != "number")
      throw new TypeError("maxAge must be a number");
    this[mv] = e.maxAge || 0, this[j0] = e.dispose, this[ZPe] = e.noDisposeOnSet || !1, this[Klt] = e.updateAgeOnGet || !1, this.reset();
  }
  // resize the cache when the max changes.
  set max(e) {
    if (typeof e != "number" || e < 0)
      throw new TypeError("max must be a non-negative number");
    this[nv] = e || 1 / 0, lR(this);
  }
  get max() {
    return this[nv];
  }
  set allowStale(e) {
    this[eT] = !!e;
  }
  get allowStale() {
    return this[eT];
  }
  set maxAge(e) {
    if (typeof e != "number")
      throw new TypeError("maxAge must be a non-negative number");
    this[mv] = e, lR(this);
  }
  get maxAge() {
    return this[mv];
  }
  // resize the cache when the lengthCalculator changes.
  set lengthCalculator(e) {
    typeof e != "function" && (e = bX), e !== this[Gb] && (this[Gb] = e, this[tI] = 0, this[SA].forEach((n) => {
      n.length = this[Gb](n.value, n.key), this[tI] += n.length;
    })), lR(this);
  }
  get lengthCalculator() {
    return this[Gb];
  }
  get length() {
    return this[tI];
  }
  get itemCount() {
    return this[SA].length;
  }
  rforEach(e, n) {
    n = n || this;
    for (var r = this[SA].tail; r !== null; ) {
      var i = r.prev;
      e3e(this, e, r, n), r = i;
    }
  }
  forEach(e, n) {
    n = n || this;
    for (var r = this[SA].head; r !== null; ) {
      var i = r.next;
      e3e(this, e, r, n), r = i;
    }
  }
  keys() {
    return this[SA].toArray().map((e) => e.key);
  }
  values() {
    return this[SA].toArray().map((e) => e.value);
  }
  reset() {
    this[j0] && this[SA] && this[SA].length && this[SA].forEach((e) => this[j0](e.key, e.value)), this[wh] = /* @__PURE__ */ new Map(), this[SA] = new BDr(), this[tI] = 0;
  }
  dump() {
    return this[SA].map((e) => V6(this, e) ? !1 : {
      k: e.key,
      v: e.value,
      e: e.now + (e.maxAge || 0)
    }).toArray().filter((e) => e);
  }
  dumpLru() {
    return this[SA];
  }
  set(e, n, r) {
    if (r = r || this[mv], r && typeof r != "number")
      throw new TypeError("maxAge must be a number");
    var i = r ? Date.now() : 0, o = this[Gb](n, e);
    if (this[wh].has(e)) {
      if (o > this[nv])
        return pS(this, this[wh].get(e)), !1;
      var s = this[wh].get(e), a = s.value;
      return this[j0] && (this[ZPe] || this[j0](e, a.value)), a.now = i, a.maxAge = r, a.value = n, this[tI] += o - a.length, a.length = o, this.get(e), lR(this), !0;
    }
    var A = new _Dr(e, n, o, i, r);
    return A.length > this[nv] ? (this[j0] && this[j0](e, n), !1) : (this[tI] += A.length, this[SA].unshift(A), this[wh].set(e, this[SA].head), lR(this), !0);
  }
  has(e) {
    if (!this[wh].has(e))
      return !1;
    var n = this[wh].get(e).value;
    return !V6(this, n);
  }
  get(e) {
    return _X(this, e, !0);
  }
  peek(e) {
    return _X(this, e, !1);
  }
  pop() {
    var e = this[SA].tail;
    return e ? (pS(this, e), e.value) : null;
  }
  del(e) {
    pS(this, this[wh].get(e));
  }
  load(e) {
    this.reset();
    for (var n = Date.now(), r = e.length - 1; r >= 0; r--) {
      var i = e[r], o = i.e || 0;
      if (o === 0)
        this.set(i.k, i.v);
      else {
        var s = o - n;
        s > 0 && this.set(i.k, i.v, s);
      }
    }
  }
  prune() {
    this[wh].forEach((e, n) => _X(this, n, !1));
  }
}
var _X = (t, e, n) => {
  var r = t[wh].get(e);
  if (r) {
    var i = r.value;
    if (V6(t, i)) {
      if (pS(t, r), !t[eT])
        return;
    } else
      n && (t[Klt] && (r.value.now = Date.now()), t[SA].unshiftNode(r));
    return i.value;
  }
}, V6 = (t, e) => {
  if (!e || !e.maxAge && !t[mv])
    return !1;
  var n = Date.now() - e.now;
  return e.maxAge ? n > e.maxAge : t[mv] && n > t[mv];
}, lR = (t) => {
  if (t[tI] > t[nv])
    for (var e = t[SA].tail; t[tI] > t[nv] && e !== null; ) {
      var n = e.prev;
      pS(t, e), e = n;
    }
}, pS = (t, e) => {
  if (e) {
    var n = e.value;
    t[j0] && t[j0](n.key, n.value), t[tI] -= n.length, t[wh].delete(n.key), t[SA].removeNode(e);
  }
};
class _Dr {
  constructor(e, n, r, i, o) {
    this.key = e, this.value = n, this.length = r, this.now = i, this.maxAge = o || 0;
  }
}
var e3e = (t, e, n, r) => {
  var i = n.value;
  V6(t, i) && (pS(t, n), t[eT] || (i = void 0)), i && e.call(r, i.value, i.key, t);
}, SDr = bDr, QDr = ["includePrerelease", "loose", "rtl"], wDr = (t) => t ? typeof t != "object" ? {
  loose: !0
} : QDr.filter((e) => t[e]).reduce((e, n) => (e[n] = !0, e), {}) : {}, FIe = wDr, Hh = { exports: {} }, xDr = "2.0.0", RDr = 256, DDr = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
9007199254740991, TDr = 16, PIe = {
  SEMVER_SPEC_VERSION: xDr,
  MAX_LENGTH: RDr,
  MAX_SAFE_INTEGER: DDr,
  MAX_SAFE_COMPONENT_LENGTH: TDr
}, NDr = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? function() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return console.error("SEMVER", ...e);
} : () => {
}, rz = NDr;
(function(t, e) {
  var n = PIe.MAX_SAFE_COMPONENT_LENGTH, r = rz;
  e = t.exports = {};
  var i = e.re = [], o = e.src = [], s = e.t = {}, a = 0, A = (l, c, u) => {
    var f = a++;
    r(l, f, c), s[l] = f, o[f] = c, i[f] = new RegExp(c, u ? "g" : void 0);
  };
  A("NUMERICIDENTIFIER", "0|[1-9]\\d*"), A("NUMERICIDENTIFIERLOOSE", "[0-9]+"), A("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), A("MAINVERSION", "(".concat(o[s.NUMERICIDENTIFIER], ")\\.") + "(".concat(o[s.NUMERICIDENTIFIER], ")\\.") + "(".concat(o[s.NUMERICIDENTIFIER], ")")), A("MAINVERSIONLOOSE", "(".concat(o[s.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(o[s.NUMERICIDENTIFIERLOOSE], ")\\.") + "(".concat(o[s.NUMERICIDENTIFIERLOOSE], ")")), A("PRERELEASEIDENTIFIER", "(?:".concat(o[s.NUMERICIDENTIFIER], "|").concat(o[s.NONNUMERICIDENTIFIER], ")")), A("PRERELEASEIDENTIFIERLOOSE", "(?:".concat(o[s.NUMERICIDENTIFIERLOOSE], "|").concat(o[s.NONNUMERICIDENTIFIER], ")")), A("PRERELEASE", "(?:-(".concat(o[s.PRERELEASEIDENTIFIER], "(?:\\.").concat(o[s.PRERELEASEIDENTIFIER], ")*))")), A("PRERELEASELOOSE", "(?:-?(".concat(o[s.PRERELEASEIDENTIFIERLOOSE], "(?:\\.").concat(o[s.PRERELEASEIDENTIFIERLOOSE], ")*))")), A("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), A("BUILD", "(?:\\+(".concat(o[s.BUILDIDENTIFIER], "(?:\\.").concat(o[s.BUILDIDENTIFIER], ")*))")), A("FULLPLAIN", "v?".concat(o[s.MAINVERSION]).concat(o[s.PRERELEASE], "?").concat(o[s.BUILD], "?")), A("FULL", "^".concat(o[s.FULLPLAIN], "$")), A("LOOSEPLAIN", "[v=\\s]*".concat(o[s.MAINVERSIONLOOSE]).concat(o[s.PRERELEASELOOSE], "?").concat(o[s.BUILD], "?")), A("LOOSE", "^".concat(o[s.LOOSEPLAIN], "$")), A("GTLT", "((?:<|>)?=?)"), A("XRANGEIDENTIFIERLOOSE", "".concat(o[s.NUMERICIDENTIFIERLOOSE], "|x|X|\\*")), A("XRANGEIDENTIFIER", "".concat(o[s.NUMERICIDENTIFIER], "|x|X|\\*")), A("XRANGEPLAIN", "[v=\\s]*(".concat(o[s.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(o[s.XRANGEIDENTIFIER], ")") + "(?:\\.(".concat(o[s.XRANGEIDENTIFIER], ")") + "(?:".concat(o[s.PRERELEASE], ")?").concat(o[s.BUILD], "?") + ")?)?"), A("XRANGEPLAINLOOSE", "[v=\\s]*(".concat(o[s.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(o[s.XRANGEIDENTIFIERLOOSE], ")") + "(?:\\.(".concat(o[s.XRANGEIDENTIFIERLOOSE], ")") + "(?:".concat(o[s.PRERELEASELOOSE], ")?").concat(o[s.BUILD], "?") + ")?)?"), A("XRANGE", "^".concat(o[s.GTLT], "\\s*").concat(o[s.XRANGEPLAIN], "$")), A("XRANGELOOSE", "^".concat(o[s.GTLT], "\\s*").concat(o[s.XRANGEPLAINLOOSE], "$")), A("COERCE", "".concat("(^|[^\\d])(\\d{1,").concat(n, "})") + "(?:\\.(\\d{1,".concat(n, "}))?") + "(?:\\.(\\d{1,".concat(n, "}))?") + "(?:$|[^\\d])"), A("COERCERTL", o[s.COERCE], !0), A("LONETILDE", "(?:~>?)"), A("TILDETRIM", "(\\s*)".concat(o[s.LONETILDE], "\\s+"), !0), e.tildeTrimReplace = "$1~", A("TILDE", "^".concat(o[s.LONETILDE]).concat(o[s.XRANGEPLAIN], "$")), A("TILDELOOSE", "^".concat(o[s.LONETILDE]).concat(o[s.XRANGEPLAINLOOSE], "$")), A("LONECARET", "(?:\\^)"), A("CARETTRIM", "(\\s*)".concat(o[s.LONECARET], "\\s+"), !0), e.caretTrimReplace = "$1^", A("CARET", "^".concat(o[s.LONECARET]).concat(o[s.XRANGEPLAIN], "$")), A("CARETLOOSE", "^".concat(o[s.LONECARET]).concat(o[s.XRANGEPLAINLOOSE], "$")), A("COMPARATORLOOSE", "^".concat(o[s.GTLT], "\\s*(").concat(o[s.LOOSEPLAIN], ")$|^$")), A("COMPARATOR", "^".concat(o[s.GTLT], "\\s*(").concat(o[s.FULLPLAIN], ")$|^$")), A("COMPARATORTRIM", "(\\s*)".concat(o[s.GTLT], "\\s*(").concat(o[s.LOOSEPLAIN], "|").concat(o[s.XRANGEPLAIN], ")"), !0), e.comparatorTrimReplace = "$1$2$3", A("HYPHENRANGE", "^\\s*(".concat(o[s.XRANGEPLAIN], ")") + "\\s+-\\s+" + "(".concat(o[s.XRANGEPLAIN], ")") + "\\s*$"), A("HYPHENRANGELOOSE", "^\\s*(".concat(o[s.XRANGEPLAINLOOSE], ")") + "\\s+-\\s+" + "(".concat(o[s.XRANGEPLAINLOOSE], ")") + "\\s*$"), A("STAR", "(<|>)?=?\\s*\\*"), A("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), A("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(Hh, Hh.exports);
var t3e = /^[0-9]+$/, Wlt = (t, e) => {
  var n = t3e.test(t), r = t3e.test(e);
  return n && r && (t = +t, e = +e), t === e ? 0 : n && !r ? -1 : r && !n ? 1 : t < e ? -1 : 1;
}, LDr = (t, e) => Wlt(e, t), MDr = {
  compareIdentifiers: Wlt,
  rcompareIdentifiers: LDr
}, X3 = rz, n3e = PIe.MAX_LENGTH, Z3 = PIe.MAX_SAFE_INTEGER, r3e = Hh.exports.re, i3e = Hh.exports.t, ODr = FIe, Ub = MDr.compareIdentifiers;
class xh {
  constructor(e, n) {
    if (n = ODr(n), e instanceof xh) {
      if (e.loose === !!n.loose && e.includePrerelease === !!n.includePrerelease)
        return e;
      e = e.version;
    } else if (typeof e != "string")
      throw new TypeError("Invalid Version: ".concat(e));
    if (e.length > n3e)
      throw new TypeError("version is longer than ".concat(n3e, " characters"));
    X3("SemVer", e, n), this.options = n, this.loose = !!n.loose, this.includePrerelease = !!n.includePrerelease;
    var r = e.trim().match(n.loose ? r3e[i3e.LOOSE] : r3e[i3e.FULL]);
    if (!r)
      throw new TypeError("Invalid Version: ".concat(e));
    if (this.raw = e, this.major = +r[1], this.minor = +r[2], this.patch = +r[3], this.major > Z3 || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > Z3 || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > Z3 || this.patch < 0)
      throw new TypeError("Invalid patch version");
    r[4] ? this.prerelease = r[4].split(".").map((i) => {
      if (/^[0-9]+$/.test(i)) {
        var o = +i;
        if (o >= 0 && o < Z3)
          return o;
      }
      return i;
    }) : this.prerelease = [], this.build = r[5] ? r[5].split(".") : [], this.format();
  }
  format() {
    return this.version = "".concat(this.major, ".").concat(this.minor, ".").concat(this.patch), this.prerelease.length && (this.version += "-".concat(this.prerelease.join("."))), this.version;
  }
  toString() {
    return this.version;
  }
  compare(e) {
    if (X3("SemVer.compare", this.version, this.options, e), !(e instanceof xh)) {
      if (typeof e == "string" && e === this.version)
        return 0;
      e = new xh(e, this.options);
    }
    return e.version === this.version ? 0 : this.compareMain(e) || this.comparePre(e);
  }
  compareMain(e) {
    return e instanceof xh || (e = new xh(e, this.options)), Ub(this.major, e.major) || Ub(this.minor, e.minor) || Ub(this.patch, e.patch);
  }
  comparePre(e) {
    if (e instanceof xh || (e = new xh(e, this.options)), this.prerelease.length && !e.prerelease.length)
      return -1;
    if (!this.prerelease.length && e.prerelease.length)
      return 1;
    if (!this.prerelease.length && !e.prerelease.length)
      return 0;
    var n = 0;
    do {
      var r = this.prerelease[n], i = e.prerelease[n];
      if (X3("prerelease compare", n, r, i), r === void 0 && i === void 0)
        return 0;
      if (i === void 0)
        return 1;
      if (r === void 0)
        return -1;
      if (r === i)
        continue;
      return Ub(r, i);
    } while (++n);
  }
  compareBuild(e) {
    e instanceof xh || (e = new xh(e, this.options));
    var n = 0;
    do {
      var r = this.build[n], i = e.build[n];
      if (X3("prerelease compare", n, r, i), r === void 0 && i === void 0)
        return 0;
      if (i === void 0)
        return 1;
      if (r === void 0)
        return -1;
      if (r === i)
        continue;
      return Ub(r, i);
    } while (++n);
  }
  // preminor will bump the version up to the next minor release, and immediately
  // down to pre-release. premajor and prepatch work the same way.
  inc(e, n) {
    switch (e) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", n);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", n);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", n), this.inc("pre", n);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", n), this.inc("pre", n);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre":
        if (this.prerelease.length === 0)
          this.prerelease = [0];
        else {
          for (var r = this.prerelease.length; --r >= 0; )
            typeof this.prerelease[r] == "number" && (this.prerelease[r]++, r = -2);
          r === -1 && this.prerelease.push(0);
        }
        n && (Ub(this.prerelease[0], n) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [n, 0]) : this.prerelease = [n, 0]);
        break;
      default:
        throw new Error("invalid increment argument: ".concat(e));
    }
    return this.format(), this.raw = this.version, this;
  }
}
var kIe = xh, o3e = kIe, FDr = (t, e, n) => new o3e(t, n).compare(new o3e(e, n)), Ox = FDr, PDr = Ox, kDr = (t, e, n) => PDr(t, e, n) === 0, GDr = kDr, UDr = Ox, HDr = (t, e, n) => UDr(t, e, n) !== 0, $Dr = HDr, qDr = Ox, jDr = (t, e, n) => qDr(t, e, n) > 0, YDr = jDr, zDr = Ox, VDr = (t, e, n) => zDr(t, e, n) >= 0, JDr = VDr, KDr = Ox, WDr = (t, e, n) => KDr(t, e, n) < 0, XDr = WDr, ZDr = Ox, eTr = (t, e, n) => ZDr(t, e, n) <= 0, tTr = eTr, nTr = GDr, rTr = $Dr, iTr = YDr, oTr = JDr, sTr = XDr, aTr = tTr, ATr = (t, e, n, r) => {
  switch (e) {
    case "===":
      return typeof t == "object" && (t = t.version), typeof n == "object" && (n = n.version), t === n;
    case "!==":
      return typeof t == "object" && (t = t.version), typeof n == "object" && (n = n.version), t !== n;
    case "":
    case "=":
    case "==":
      return nTr(t, n, r);
    case "!=":
      return rTr(t, n, r);
    case ">":
      return iTr(t, n, r);
    case ">=":
      return oTr(t, n, r);
    case "<":
      return sTr(t, n, r);
    case "<=":
      return aTr(t, n, r);
    default:
      throw new TypeError("Invalid operator: ".concat(e));
  }
}, lTr = ATr, SX, s3e;
function cTr() {
  if (s3e)
    return SX;
  s3e = 1;
  var t = Symbol("SemVer ANY");
  class e {
    static get ANY() {
      return t;
    }
    constructor(c, u) {
      if (u = n(u), c instanceof e) {
        if (c.loose === !!u.loose)
          return c;
        c = c.value;
      }
      s("comparator", c, u), this.options = u, this.loose = !!u.loose, this.parse(c), this.semver === t ? this.value = "" : this.value = this.operator + this.semver.version, s("comp", this);
    }
    parse(c) {
      var u = this.options.loose ? r[i.COMPARATORLOOSE] : r[i.COMPARATOR], f = c.match(u);
      if (!f)
        throw new TypeError("Invalid comparator: ".concat(c));
      this.operator = f[1] !== void 0 ? f[1] : "", this.operator === "=" && (this.operator = ""), f[2] ? this.semver = new a(f[2], this.options.loose) : this.semver = t;
    }
    toString() {
      return this.value;
    }
    test(c) {
      if (s("Comparator.test", c, this.options.loose), this.semver === t || c === t)
        return !0;
      if (typeof c == "string")
        try {
          c = new a(c, this.options);
        } catch {
          return !1;
        }
      return o(c, this.operator, this.semver, this.options);
    }
    intersects(c, u) {
      if (!(c instanceof e))
        throw new TypeError("a Comparator is required");
      if ((!u || typeof u != "object") && (u = {
        loose: !!u,
        includePrerelease: !1
      }), this.operator === "")
        return this.value === "" ? !0 : new A(c.value, u).test(this.value);
      if (c.operator === "")
        return c.value === "" ? !0 : new A(this.value, u).test(c.semver);
      var f = (this.operator === ">=" || this.operator === ">") && (c.operator === ">=" || c.operator === ">"), h = (this.operator === "<=" || this.operator === "<") && (c.operator === "<=" || c.operator === "<"), d = this.semver.version === c.semver.version, I = (this.operator === ">=" || this.operator === "<=") && (c.operator === ">=" || c.operator === "<="), m = o(this.semver, "<", c.semver, u) && (this.operator === ">=" || this.operator === ">") && (c.operator === "<=" || c.operator === "<"), C = o(this.semver, ">", c.semver, u) && (this.operator === "<=" || this.operator === "<") && (c.operator === ">=" || c.operator === ">");
      return f || h || d && I || m || C;
    }
  }
  SX = e;
  var n = FIe, r = Hh.exports.re, i = Hh.exports.t, o = lTr, s = rz, a = kIe, A = Xlt();
  return SX;
}
function a3e(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = uTr(t)) || e && t && typeof t.length == "number") {
      n && (t = n);
      var r = 0, i = function() {
      };
      return { s: i, n: function() {
        return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
      }, e: function(l) {
        throw l;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o = !0, s = !1, a;
  return { s: function() {
    n = n.call(t);
  }, n: function() {
    var l = n.next();
    return o = l.done, l;
  }, e: function(l) {
    s = !0, a = l;
  }, f: function() {
    try {
      !o && n.return != null && n.return();
    } finally {
      if (s)
        throw a;
    }
  } };
}
function uTr(t, e) {
  if (t) {
    if (typeof t == "string")
      return A3e(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return A3e(t, e);
  }
}
function A3e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
var QX, l3e;
function Xlt() {
  if (l3e)
    return QX;
  l3e = 1;
  class t {
    constructor(k, $) {
      if ($ = r($), k instanceof t)
        return k.loose === !!$.loose && k.includePrerelease === !!$.includePrerelease ? k : new t(k.raw, $);
      if (k instanceof i)
        return this.raw = k.value, this.set = [[k]], this.format(), this;
      if (this.options = $, this.loose = !!$.loose, this.includePrerelease = !!$.includePrerelease, this.raw = k, this.set = k.split("||").map((Y) => this.parseRange(Y.trim())).filter((Y) => Y.length), !this.set.length)
        throw new TypeError("Invalid SemVer Range: ".concat(k));
      if (this.set.length > 1) {
        var U = this.set[0];
        if (this.set = this.set.filter((Y) => !f(Y[0])), this.set.length === 0)
          this.set = [U];
        else if (this.set.length > 1) {
          var X = a3e(this.set), K;
          try {
            for (X.s(); !(K = X.n()).done; ) {
              var z = K.value;
              if (z.length === 1 && h(z[0])) {
                this.set = [z];
                break;
              }
            }
          } catch (Y) {
            X.e(Y);
          } finally {
            X.f();
          }
        }
      }
      this.format();
    }
    format() {
      return this.range = this.set.map((k) => k.join(" ").trim()).join("||").trim(), this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(k) {
      k = k.trim();
      var $ = Object.keys(this.options).join(","), U = "parseRange:".concat($, ":").concat(k), X = n.get(U);
      if (X)
        return X;
      var K = this.options.loose, z = K ? a[A.HYPHENRANGELOOSE] : a[A.HYPHENRANGE];
      k = k.replace(z, O(this.options.includePrerelease)), o("hyphen replace", k), k = k.replace(a[A.COMPARATORTRIM], l), o("comparator trim", k), k = k.replace(a[A.TILDETRIM], c), k = k.replace(a[A.CARETTRIM], u), k = k.split(/\s+/).join(" ");
      var Y = k.split(" ").map((Be) => I(Be, this.options)).join(" ").split(/\s+/).map((Be) => M(Be, this.options));
      K && (Y = Y.filter((Be) => (o("loose invalid filter", Be, this.options), !!Be.match(a[A.COMPARATORLOOSE])))), o("range list", Y);
      var V = /* @__PURE__ */ new Map(), Z = Y.map((Be) => new i(Be, this.options)), ce = a3e(Z), ee;
      try {
        for (ce.s(); !(ee = ce.n()).done; ) {
          var pe = ee.value;
          if (f(pe))
            return [pe];
          V.set(pe.value, pe);
        }
      } catch (Be) {
        ce.e(Be);
      } finally {
        ce.f();
      }
      V.size > 1 && V.has("") && V.delete("");
      var Ce = [...V.values()];
      return n.set(U, Ce), Ce;
    }
    intersects(k, $) {
      if (!(k instanceof t))
        throw new TypeError("a Range is required");
      return this.set.some((U) => d(U, $) && k.set.some((X) => d(X, $) && U.every((K) => X.every((z) => K.intersects(z, $)))));
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(k) {
      if (!k)
        return !1;
      if (typeof k == "string")
        try {
          k = new s(k, this.options);
        } catch {
          return !1;
        }
      for (var $ = 0; $ < this.set.length; $++)
        if (L(this.set[$], k, this.options))
          return !0;
      return !1;
    }
  }
  QX = t;
  var e = SDr, n = new e({
    max: 1e3
  }), r = FIe, i = cTr(), o = rz, s = kIe, a = Hh.exports.re, A = Hh.exports.t, l = Hh.exports.comparatorTrimReplace, c = Hh.exports.tildeTrimReplace, u = Hh.exports.caretTrimReplace, f = (N) => N.value === "<0.0.0-0", h = (N) => N.value === "", d = (N, k) => {
    for (var $ = !0, U = N.slice(), X = U.pop(); $ && U.length; )
      $ = U.every((K) => X.intersects(K, k)), X = U.pop();
    return $;
  }, I = (N, k) => (o("comp", N, k), N = v(N, k), o("caret", N), N = C(N, k), o("tildes", N), N = Q(N, k), o("xrange", N), N = R(N, k), o("stars", N), N), m = (N) => !N || N.toLowerCase() === "x" || N === "*", C = (N, k) => N.trim().split(/\s+/).map(($) => y($, k)).join(" "), y = (N, k) => {
    var $ = k.loose ? a[A.TILDELOOSE] : a[A.TILDE];
    return N.replace($, (U, X, K, z, Y) => {
      o("tilde", N, U, X, K, z, Y);
      var V;
      return m(X) ? V = "" : m(K) ? V = ">=".concat(X, ".0.0 <").concat(+X + 1, ".0.0-0") : m(z) ? V = ">=".concat(X, ".").concat(K, ".0 <").concat(X, ".").concat(+K + 1, ".0-0") : Y ? (o("replaceTilde pr", Y), V = ">=".concat(X, ".").concat(K, ".").concat(z, "-").concat(Y, " <").concat(X, ".").concat(+K + 1, ".0-0")) : V = ">=".concat(X, ".").concat(K, ".").concat(z, " <").concat(X, ".").concat(+K + 1, ".0-0"), o("tilde return", V), V;
    });
  }, v = (N, k) => N.trim().split(/\s+/).map(($) => b($, k)).join(" "), b = (N, k) => {
    o("caret", N, k);
    var $ = k.loose ? a[A.CARETLOOSE] : a[A.CARET], U = k.includePrerelease ? "-0" : "";
    return N.replace($, (X, K, z, Y, V) => {
      o("caret", N, X, K, z, Y, V);
      var Z;
      return m(K) ? Z = "" : m(z) ? Z = ">=".concat(K, ".0.0").concat(U, " <").concat(+K + 1, ".0.0-0") : m(Y) ? K === "0" ? Z = ">=".concat(K, ".").concat(z, ".0").concat(U, " <").concat(K, ".").concat(+z + 1, ".0-0") : Z = ">=".concat(K, ".").concat(z, ".0").concat(U, " <").concat(+K + 1, ".0.0-0") : V ? (o("replaceCaret pr", V), K === "0" ? z === "0" ? Z = ">=".concat(K, ".").concat(z, ".").concat(Y, "-").concat(V, " <").concat(K, ".").concat(z, ".").concat(+Y + 1, "-0") : Z = ">=".concat(K, ".").concat(z, ".").concat(Y, "-").concat(V, " <").concat(K, ".").concat(+z + 1, ".0-0") : Z = ">=".concat(K, ".").concat(z, ".").concat(Y, "-").concat(V, " <").concat(+K + 1, ".0.0-0")) : (o("no pr"), K === "0" ? z === "0" ? Z = ">=".concat(K, ".").concat(z, ".").concat(Y).concat(U, " <").concat(K, ".").concat(z, ".").concat(+Y + 1, "-0") : Z = ">=".concat(K, ".").concat(z, ".").concat(Y).concat(U, " <").concat(K, ".").concat(+z + 1, ".0-0") : Z = ">=".concat(K, ".").concat(z, ".").concat(Y, " <").concat(+K + 1, ".0.0-0")), o("caret return", Z), Z;
    });
  }, Q = (N, k) => (o("replaceXRanges", N, k), N.split(/\s+/).map(($) => w($, k)).join(" ")), w = (N, k) => {
    N = N.trim();
    var $ = k.loose ? a[A.XRANGELOOSE] : a[A.XRANGE];
    return N.replace($, (U, X, K, z, Y, V) => {
      o("xRange", N, U, X, K, z, Y, V);
      var Z = m(K), ce = Z || m(z), ee = ce || m(Y), pe = ee;
      return X === "=" && pe && (X = ""), V = k.includePrerelease ? "-0" : "", Z ? X === ">" || X === "<" ? U = "<0.0.0-0" : U = "*" : X && pe ? (ce && (z = 0), Y = 0, X === ">" ? (X = ">=", ce ? (K = +K + 1, z = 0, Y = 0) : (z = +z + 1, Y = 0)) : X === "<=" && (X = "<", ce ? K = +K + 1 : z = +z + 1), X === "<" && (V = "-0"), U = "".concat(X + K, ".").concat(z, ".").concat(Y).concat(V)) : ce ? U = ">=".concat(K, ".0.0").concat(V, " <").concat(+K + 1, ".0.0-0") : ee && (U = ">=".concat(K, ".").concat(z, ".0").concat(V, " <").concat(K, ".").concat(+z + 1, ".0-0")), o("xRange return", U), U;
    });
  }, R = (N, k) => (o("replaceStars", N, k), N.trim().replace(a[A.STAR], "")), M = (N, k) => (o("replaceGTE0", N, k), N.trim().replace(a[k.includePrerelease ? A.GTE0PRE : A.GTE0], "")), O = (N) => (k, $, U, X, K, z, Y, V, Z, ce, ee, pe, Ce) => (m(U) ? $ = "" : m(X) ? $ = ">=".concat(U, ".0.0").concat(N ? "-0" : "") : m(K) ? $ = ">=".concat(U, ".").concat(X, ".0").concat(N ? "-0" : "") : z ? $ = ">=".concat($) : $ = ">=".concat($).concat(N ? "-0" : ""), m(Z) ? V = "" : m(ce) ? V = "<".concat(+Z + 1, ".0.0-0") : m(ee) ? V = "<".concat(Z, ".").concat(+ce + 1, ".0-0") : pe ? V = "<=".concat(Z, ".").concat(ce, ".").concat(ee, "-").concat(pe) : N ? V = "<".concat(Z, ".").concat(ce, ".").concat(+ee + 1, "-0") : V = "<=".concat(V), "".concat($, " ").concat(V).trim()), L = (N, k, $) => {
    for (var U = 0; U < N.length; U++)
      if (!N[U].test(k))
        return !1;
    if (k.prerelease.length && !$.includePrerelease) {
      for (var X = 0; X < N.length; X++)
        if (o(N[X].semver), N[X].semver !== i.ANY && N[X].semver.prerelease.length > 0) {
          var K = N[X].semver;
          if (K.major === k.major && K.minor === k.minor && K.patch === k.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  };
  return QX;
}
var fTr = Xlt(), gTr = (t, e, n) => {
  try {
    e = new fTr(e, n);
  } catch {
    return !1;
  }
  return e.test(t);
}, Zlt = gTr;
function hTr(t, e, n) {
  var r = t.open(e), i = 1e4, o = 250, s = new URL(e), a = s.origin, A = ~~(i / o);
  function l(u) {
    u.source === r && (A = 0, t.removeEventListener("message", l, !1));
  }
  t.addEventListener("message", l, !1);
  function c() {
    A <= 0 || (r.postMessage(n, a), setTimeout(c, o), A -= 1);
  }
  setTimeout(c, o);
}
var dTr = `.vega-embed {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
}
.vega-embed.has-actions {
  padding-right: 38px;
}
.vega-embed details:not([open]) > :not(summary) {
  display: none !important;
}
.vega-embed summary {
  list-style: none;
  position: absolute;
  top: 0;
  right: 0;
  padding: 6px;
  z-index: 1000;
  background: white;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
  color: #1b1e23;
  border: 1px solid #aaa;
  border-radius: 999px;
  opacity: 0.2;
  transition: opacity 0.4s ease-in;
  cursor: pointer;
  line-height: 0px;
}
.vega-embed summary::-webkit-details-marker {
  display: none;
}
.vega-embed summary:active {
  box-shadow: #aaa 0px 0px 0px 1px inset;
}
.vega-embed summary svg {
  width: 14px;
  height: 14px;
}
.vega-embed details[open] summary {
  opacity: 0.7;
}
.vega-embed:hover summary, .vega-embed:focus-within summary {
  opacity: 1 !important;
  transition: opacity 0.2s ease;
}
.vega-embed .vega-actions {
  position: absolute;
  z-index: 1001;
  top: 35px;
  right: -9px;
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
  padding-top: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid #d9d9d9;
  background: white;
  animation-duration: 0.15s;
  animation-name: scale-in;
  animation-timing-function: cubic-bezier(0.2, 0, 0.13, 1.5);
  text-align: left;
}
.vega-embed .vega-actions a {
  padding: 8px 16px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  color: #434a56;
  text-decoration: none;
}
.vega-embed .vega-actions a:hover, .vega-embed .vega-actions a:focus {
  background-color: #f7f7f9;
  color: black;
}
.vega-embed .vega-actions::before, .vega-embed .vega-actions::after {
  content: "";
  display: inline-block;
  position: absolute;
}
.vega-embed .vega-actions::before {
  left: auto;
  right: 14px;
  top: -16px;
  border: 8px solid rgba(0, 0, 0, 0);
  border-bottom-color: #d9d9d9;
}
.vega-embed .vega-actions::after {
  left: auto;
  right: 15px;
  top: -14px;
  border: 7px solid rgba(0, 0, 0, 0);
  border-bottom-color: #fff;
}
.vega-embed .chart-wrapper.fit-x {
  width: 100%;
}
.vega-embed .chart-wrapper.fit-y {
  height: 100%;
}

.vega-embed-wrapper {
  max-width: 100%;
  overflow: auto;
  padding-right: 14px;
}

@keyframes scale-in {
  from {
    opacity: 0;
    transform: scale(0.6);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`;
String.prototype.startsWith || (String.prototype.startsWith = function(t, e) {
  return this.substr(!e || e < 0 ? 0 : +e, t.length) === t;
});
function ect(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  for (var i = 0, o = n; i < o.length; i++) {
    var s = o[i];
    pTr(t, s);
  }
  return t;
}
function pTr(t, e) {
  for (var n = 0, r = Object.keys(e); n < r.length; n++) {
    var i = r[n];
    gx(t, i, e[i], !0);
  }
}
var wX;
function ITr(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = mTr(t)) || e && t && typeof t.length == "number") {
      n && (t = n);
      var r = 0, i = function() {
      };
      return { s: i, n: function() {
        return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
      }, e: function(l) {
        throw l;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o = !0, s = !1, a;
  return { s: function() {
    n = n.call(t);
  }, n: function() {
    var l = n.next();
    return o = l.done, l;
  }, e: function(l) {
    s = !0, a = l;
  }, f: function() {
    try {
      !o && n.return != null && n.return();
    } finally {
      if (s)
        throw a;
    }
  } };
}
function mTr(t, e) {
  if (t) {
    if (typeof t == "string")
      return c3e(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return c3e(t, e);
  }
}
function c3e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function u3e(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function HC(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? u3e(Object(n), !0).forEach(function(r) {
      cDr(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u3e(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
var Dh = Mvr, zN = oRr, ek = typeof window < "u" ? window : void 0;
zN === void 0 && ek !== null && ek !== void 0 && (wX = ek.vl) !== null && wX !== void 0 && wX.compile && (zN = ek.vl);
var CTr = {
  export: {
    svg: !0,
    png: !0
  },
  source: !0,
  compiled: !0,
  editor: !0
}, ETr = {
  CLICK_TO_VIEW_ACTIONS: "Click to view actions",
  COMPILED_ACTION: "View Compiled Vega",
  EDITOR_ACTION: "Open in Vega Editor",
  PNG_ACTION: "Save as PNG",
  SOURCE_ACTION: "View Source",
  SVG_ACTION: "Save as SVG"
}, lD = {
  vega: "Vega",
  "vega-lite": "Vega-Lite"
}, J6 = {
  vega: Dh.version,
  "vega-lite": zN ? zN.version : "not available"
}, yTr = {
  vega: (t) => t,
  "vega-lite": (t, e) => zN.compile(t, {
    config: e
  }).spec
}, vTr = `
<svg viewBox="0 0 16 16" fill="currentColor" stroke="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
  <circle r="2" cy="8" cx="2"></circle>
  <circle r="2" cy="8" cx="8"></circle>
  <circle r="2" cy="8" cx="14"></circle>
</svg>`, BTr = "chart-wrapper";
function bTr(t) {
  return typeof t == "function";
}
function f3e(t, e, n, r) {
  var i = "<html><head>".concat(e, '</head><body><pre><code class="json">'), o = "</code></pre>".concat(n, "</body></html>"), s = window.open("");
  s.document.write(i + t + o), s.document.title = "".concat(lD[r], " JSON Source");
}
function _Tr(t, e) {
  if (t.$schema) {
    var n = Glt(t.$schema);
    if (e && e !== n.library) {
      var r;
      console.warn("The given visualization spec is written in ".concat(lD[n.library], ", but mode argument sets ").concat((r = lD[e]) !== null && r !== void 0 ? r : e, "."));
    }
    var i = n.library;
    return Zlt(J6[i], "^".concat(n.version.slice(1))) || console.warn("The input spec uses ".concat(lD[i], " ").concat(n.version, ", but the current version of ").concat(lD[i], " is v").concat(J6[i], ".")), i;
  }
  return "mark" in t || "encoding" in t || "layer" in t || "hconcat" in t || "vconcat" in t || "facet" in t || "repeat" in t ? "vega-lite" : "marks" in t || "signals" in t || "scales" in t || "axes" in t ? "vega" : e ?? "vega";
}
function STr(t) {
  return !!(t && "load" in t);
}
function g3e(t) {
  return STr(t) ? t : Dh.loader(t);
}
function QTr(t) {
  var e, n, r = (e = (n = t.usermeta) === null || n === void 0 ? void 0 : n.embedOptions) !== null && e !== void 0 ? e : {};
  return Cn(r.defaultStyle) && (r.defaultStyle = !1), r;
}
function wTr(t, e) {
  return Koe.apply(this, arguments);
}
function Koe() {
  return Koe = Y6(/* @__PURE__ */ Rp.mark(function t(e, n) {
    var r, i, o, s, a, A, l, c, u, f, h, d = arguments;
    return Rp.wrap(function(m) {
      for (; ; )
        switch (m.prev = m.next) {
          case 0:
            if (o = d.length > 2 && d[2] !== void 0 ? d[2] : {}, !Cn(n)) {
              m.next = 10;
              break;
            }
            return a = g3e(o.loader), m.t0 = JSON, m.next = 6, a.load(n);
          case 6:
            m.t1 = m.sent, s = m.t0.parse.call(m.t0, m.t1), m.next = 11;
            break;
          case 10:
            s = n;
          case 11:
            return A = QTr(s), l = A.loader, (!a || l) && (a = g3e((c = o.loader) !== null && c !== void 0 ? c : l)), m.next = 16, h3e(A, a);
          case 16:
            return u = m.sent, m.next = 19, h3e(o, a);
          case 19:
            return f = m.sent, h = HC(HC({}, ect(f, u)), {}, {
              config: fx((r = f.config) !== null && r !== void 0 ? r : {}, (i = u.config) !== null && i !== void 0 ? i : {})
            }), m.next = 23, RTr(e, s, h, a);
          case 23:
            return m.abrupt("return", m.sent);
          case 24:
          case "end":
            return m.stop();
        }
    }, t);
  })), Koe.apply(this, arguments);
}
function h3e(t, e) {
  return Woe.apply(this, arguments);
}
function Woe() {
  return Woe = Y6(/* @__PURE__ */ Rp.mark(function t(e, n) {
    var r, i, o;
    return Rp.wrap(function(a) {
      for (; ; )
        switch (a.prev = a.next) {
          case 0:
            if (!Cn(e.config)) {
              a.next = 8;
              break;
            }
            return a.t1 = JSON, a.next = 4, n.load(e.config);
          case 4:
            a.t2 = a.sent, a.t0 = a.t1.parse.call(a.t1, a.t2), a.next = 9;
            break;
          case 8:
            a.t0 = (r = e.config) !== null && r !== void 0 ? r : {};
          case 9:
            if (i = a.t0, !Cn(e.patch)) {
              a.next = 18;
              break;
            }
            return a.t4 = JSON, a.next = 14, n.load(e.patch);
          case 14:
            a.t5 = a.sent, a.t3 = a.t4.parse.call(a.t4, a.t5), a.next = 19;
            break;
          case 18:
            a.t3 = e.patch;
          case 19:
            return o = a.t3, a.abrupt("return", HC(HC(HC({}, e), o ? {
              patch: o
            } : {}), i ? {
              config: i
            } : {}));
          case 21:
          case "end":
            return a.stop();
        }
    }, t);
  })), Woe.apply(this, arguments);
}
function xTr(t) {
  var e, n = t.getRootNode ? t.getRootNode() : document;
  return n instanceof ShadowRoot ? {
    root: n,
    rootContainer: n
  } : {
    root: document,
    rootContainer: (e = document.head) !== null && e !== void 0 ? e : document.body
  };
}
function RTr(t, e) {
  return Xoe.apply(this, arguments);
}
function Xoe() {
  return Xoe = Y6(/* @__PURE__ */ Rp.mark(function t(e, n) {
    var r, i, o, s, a, A, l, c, u, f, h, d, I, m, C, y, v, b, Q, w, R, M, O, L, N, k, $, U, X, K, z, Y, V, Z, ce, ee, pe, Ce, Be, Ie, Qe, xe, Se, De, Ue, Te, se, fe, W, ge, _e, Re = arguments;
    return Rp.wrap(function(oe) {
      for (; ; )
        switch (oe.prev = oe.next) {
          case 0:
            if (_e = function() {
              Ce && document.removeEventListener("click", Ce), Y.finalize();
            }, c = Re.length > 2 && Re[2] !== void 0 ? Re[2] : {}, u = Re.length > 3 ? Re[3] : void 0, f = c.theme ? fx(eDr[c.theme], (r = c.config) !== null && r !== void 0 ? r : {}) : c.config, h = PE(c.actions) ? c.actions : ect({}, CTr, (i = c.actions) !== null && i !== void 0 ? i : {}), d = HC(HC({}, ETr), c.i18n), I = (o = c.renderer) !== null && o !== void 0 ? o : "canvas", m = (s = c.logLevel) !== null && s !== void 0 ? s : Dh.Warn, C = (a = c.downloadFileName) !== null && a !== void 0 ? a : "visualization", y = typeof e == "string" ? document.querySelector(e) : e, y) {
              oe.next = 12;
              break;
            }
            throw new Error("".concat(e, " does not exist"));
          case 12:
            if (c.defaultStyle !== !1 && (v = "vega-embed-style", b = xTr(y), Q = b.root, w = b.rootContainer, Q.getElementById(v) || (R = document.createElement("style"), R.id = v, R.innerHTML = c.defaultStyle === void 0 || c.defaultStyle === !0 ? dTr.toString() : c.defaultStyle, w.appendChild(R))), M = _Tr(n, c.mode), O = yTr[M](n, f), M === "vega-lite" && O.$schema && (L = Glt(O.$schema), Zlt(J6.vega, "^".concat(L.version.slice(1))) || console.warn("The compiled spec uses Vega ".concat(L.version, ", but current version is v").concat(J6.vega, "."))), y.classList.add("vega-embed"), h && y.classList.add("has-actions"), y.innerHTML = "", N = y, h && (k = document.createElement("div"), k.classList.add(BTr), y.appendChild(k), N = k), $ = c.patch, $ && (O = $ instanceof Function ? $(O) : Aj(O, $, !0, !1).newDocument), c.formatLocale && Dh.formatLocale(c.formatLocale), c.timeFormatLocale && Dh.timeFormatLocale(c.timeFormatLocale), c.expressionFunctions)
              for (U in c.expressionFunctions)
                X = c.expressionFunctions[U], "fn" in X ? Dh.expressionFunction(U, X.fn, X.visitor) : X instanceof Function && Dh.expressionFunction(U, X);
            return K = c.ast, z = Dh.parse(O, M === "vega-lite" ? {} : f, {
              ast: K
            }), Y = new (c.viewClass || Dh.View)(z, HC({
              loader: u,
              logLevel: m,
              renderer: I
            }, K ? {
              expr: (A = (l = Dh.expressionInterpreter) !== null && l !== void 0 ? l : c.expr) !== null && A !== void 0 ? A : jvr
            } : {})), Y.addSignalListener("autosize", (ie, Ae) => {
              var de = Ae.type;
              de == "fit-x" ? (N.classList.add("fit-x"), N.classList.remove("fit-y")) : de == "fit-y" ? (N.classList.remove("fit-x"), N.classList.add("fit-y")) : de == "fit" ? N.classList.add("fit-x", "fit-y") : N.classList.remove("fit-x", "fit-y");
            }), c.tooltip !== !1 && (V = bTr(c.tooltip) ? c.tooltip : (
              // user provided boolean true or tooltip options
              new lDr(c.tooltip === !0 ? {} : c.tooltip).call
            ), Y.tooltip(V)), Z = c.hover, Z === void 0 && (Z = M === "vega"), Z && (ce = typeof Z == "boolean" ? {} : Z, ee = ce.hoverSet, pe = ce.updateSet, Y.hover(ee, pe)), c && (c.width != null && Y.width(c.width), c.height != null && Y.height(c.height), c.padding != null && Y.padding(c.padding)), oe.next = 37, Y.initialize(N, c.bind).runAsync();
          case 37:
            if (h !== !1) {
              if (Be = y, c.defaultStyle !== !1 && (Ie = document.createElement("details"), Ie.title = d.CLICK_TO_VIEW_ACTIONS, y.append(Ie), Be = Ie, Qe = document.createElement("summary"), Qe.innerHTML = vTr, Ie.append(Qe), Ce = (ie) => {
                Ie.contains(ie.target) || Ie.removeAttribute("open");
              }, document.addEventListener("click", Ce)), xe = document.createElement("div"), Be.append(xe), xe.classList.add("vega-actions"), h === !0 || h.export !== !1) {
                Se = ITr(["svg", "png"]);
                try {
                  for (Ue = function() {
                    var Ae = De.value;
                    if (h === !0 || h.export === !0 || h.export[Ae]) {
                      var de = d["".concat(Ae.toUpperCase(), "_ACTION")], we = document.createElement("a");
                      we.text = de, we.href = "#", we.target = "_blank", we.download = "".concat(C, ".").concat(Ae), we.addEventListener("mousedown", /* @__PURE__ */ function() {
                        var Pe = Y6(/* @__PURE__ */ Rp.mark(function qe(ke) {
                          var Xe;
                          return Rp.wrap(function(it) {
                            for (; ; )
                              switch (it.prev = it.next) {
                                case 0:
                                  return ke.preventDefault(), it.next = 3, Y.toImageURL(Ae, c.scaleFactor);
                                case 3:
                                  Xe = it.sent, this.href = Xe;
                                case 5:
                                case "end":
                                  return it.stop();
                              }
                          }, qe, this);
                        }));
                        return function(qe) {
                          return Pe.apply(this, arguments);
                        };
                      }()), xe.append(we);
                    }
                  }, Se.s(); !(De = Se.n()).done; )
                    Ue();
                } catch (ie) {
                  Se.e(ie);
                } finally {
                  Se.f();
                }
              }
              (h === !0 || h.source !== !1) && (Te = document.createElement("a"), Te.text = d.SOURCE_ACTION, Te.href = "#", Te.addEventListener("click", function(ie) {
                var Ae, de;
                f3e(nW(n), (Ae = c.sourceHeader) !== null && Ae !== void 0 ? Ae : "", (de = c.sourceFooter) !== null && de !== void 0 ? de : "", M), ie.preventDefault();
              }), xe.append(Te)), M === "vega-lite" && (h === !0 || h.compiled !== !1) && (se = document.createElement("a"), se.text = d.COMPILED_ACTION, se.href = "#", se.addEventListener("click", function(ie) {
                var Ae, de;
                f3e(nW(O), (Ae = c.sourceHeader) !== null && Ae !== void 0 ? Ae : "", (de = c.sourceFooter) !== null && de !== void 0 ? de : "", "vega"), ie.preventDefault();
              }), xe.append(se)), (h === !0 || h.editor !== !1) && (W = (fe = c.editorUrl) !== null && fe !== void 0 ? fe : "https://vega.github.io/editor/", ge = document.createElement("a"), ge.text = d.EDITOR_ACTION, ge.href = "#", ge.addEventListener("click", function(ie) {
                hTr(window, W, {
                  config: f,
                  mode: M,
                  renderer: I,
                  spec: nW(n)
                }), ie.preventDefault();
              }), xe.append(ge));
            }
            return oe.abrupt("return", {
              view: Y,
              spec: n,
              vgSpec: O,
              finalize: _e,
              embedOptions: c
            });
          case 39:
          case "end":
            return oe.stop();
        }
    }, t);
  })), Xoe.apply(this, arguments);
}
function DTr(t) {
  return !!t && {}.toString.call(t) === "[object Function]";
}
function TTr(t, e, n) {
  n && (DTr(n) ? n(t.data(e)) : t.change(e, Dh.changeset().remove(() => !0).insert(n)));
}
function NTr(t, e) {
  Object.keys(e).forEach((n) => {
    TTr(t, n, e[n]);
  });
}
function tct(t) {
  const e = /* @__PURE__ */ new Set();
  return t.forEach((n) => {
    Object.keys(n).forEach((r) => {
      e.add(r);
    });
  }), e;
}
const nct = () => {
};
function xX(t, e) {
  const n = Object.keys(e);
  return n.forEach((r) => {
    try {
      t.addSignalListener(r, e[r]);
    } catch (i) {
      console.warn("Cannot add invalid signal listener.", i);
    }
  }), n.length > 0;
}
function LTr(t, e) {
  if (t === e)
    return !1;
  const n = {
    width: !1,
    height: !1,
    isExpensive: !1
  }, r = tct([t, e]);
  return r.has("width") && (!("width" in t) || !("width" in e) || t.width !== e.width) && ("width" in t && typeof t.width == "number" ? n.width = t.width : n.isExpensive = !0), r.has("height") && (!("height" in t) || !("height" in e) || t.height !== e.height) && ("height" in t && typeof t.height == "number" ? n.height = t.height : n.isExpensive = !0), r.delete("width"), r.delete("height"), [...r].some((i) => !(i in t) || !(i in e) || !bKe(t[i], e[i])) && (n.isExpensive = !0), n.width !== !1 || n.height !== !1 || n.isExpensive ? n : !1;
}
function d3e(t, e) {
  const n = Object.keys(e);
  return n.forEach((r) => {
    try {
      t.removeSignalListener(r, e[r]);
    } catch (i) {
      console.warn("Cannot remove invalid signal listener.", i);
    }
  }), n.length > 0;
}
function RX(t) {
  const {
    spec: e,
    width: n,
    height: r
  } = t;
  return typeof n < "u" && typeof r < "u" ? {
    ...e,
    width: n,
    height: r
  } : typeof n < "u" ? {
    ...e,
    width: n
  } : typeof r < "u" ? {
    ...e,
    height: r
  } : e;
}
function cD(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
class rct extends St.PureComponent {
  constructor() {
    super(...arguments), cD(this, "containerRef", /* @__PURE__ */ St.createRef()), cD(this, "resultPromise", void 0), cD(this, "handleError", (e) => {
      const {
        onError: n = nct
      } = this.props;
      n(e, this.containerRef.current), console.warn(e);
    }), cD(this, "modifyView", (e) => {
      this.resultPromise && this.resultPromise.then((n) => (n && e(n.view), !0)).catch(this.handleError);
    });
  }
  componentDidMount() {
    this.createView();
  }
  componentDidUpdate(e) {
    const n = tct([this.props, e]);
    if (n.delete("className"), n.delete("signalListeners"), n.delete("spec"), n.delete("style"), n.delete("width"), n.delete("height"), Array.from(n).some((r) => this.props[r] !== e[r]))
      this.clearView(), this.createView();
    else {
      const r = LTr(RX(this.props), RX(e)), {
        signalListeners: i
      } = this.props, {
        signalListeners: o
      } = e;
      if (r)
        if (r.isExpensive)
          this.clearView(), this.createView();
        else {
          const s = !Mre(i, o);
          this.modifyView((a) => {
            r.width !== !1 && a.width(r.width), r.height !== !1 && a.height(r.height), s && (o && d3e(a, o), i && xX(a, i)), a.run();
          });
        }
      else
        Mre(i, o) || this.modifyView((s) => {
          o && d3e(s, o), i && xX(s, i), s.run();
        });
    }
  }
  componentWillUnmount() {
    this.clearView();
  }
  createView() {
    const {
      spec: e,
      onNewView: n,
      signalListeners: r = {},
      width: i,
      height: o,
      ...s
    } = this.props;
    if (this.containerRef.current) {
      const a = RX(this.props);
      this.resultPromise = wTr(this.containerRef.current, a, s).then((A) => {
        if (A) {
          const {
            view: l
          } = A;
          xX(l, r) && l.run();
        }
        return A;
      }).catch(this.handleError), n && this.modifyView(n);
    }
  }
  clearView() {
    return this.resultPromise && this.resultPromise.then((e) => {
      e && e.finalize();
    }).catch(this.handleError), this.resultPromise = void 0, this;
  }
  render() {
    const {
      className: e,
      style: n
    } = this.props;
    return /* @__PURE__ */ St.createElement("div", {
      ref: this.containerRef,
      className: e,
      style: n
    });
  }
}
cD(rct, "propTypes", {
  className: ut.string,
  onError: ut.func
});
function Zoe() {
  return Zoe = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Zoe.apply(this, arguments);
}
function ese(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
const MTr = {};
class ict extends St.PureComponent {
  constructor() {
    super(...arguments), ese(this, "vegaEmbed", /* @__PURE__ */ St.createRef()), ese(this, "handleNewView", (e) => {
      this.update();
      const {
        onNewView: n = nct
      } = this.props;
      n(e);
    });
  }
  componentDidMount() {
    this.update();
  }
  componentDidUpdate(e) {
    Mre(this.props.data, e.data) || this.update();
  }
  update() {
    const {
      data: e
    } = this.props;
    this.vegaEmbed.current && e && Object.keys(e).length > 0 && this.vegaEmbed.current.modifyView((n) => {
      NTr(n, e), n.resize().run();
    });
  }
  render() {
    const {
      data: e,
      ...n
    } = this.props;
    return /* @__PURE__ */ St.createElement(rct, Zoe({
      ref: this.vegaEmbed
    }, n, {
      onNewView: this.handleNewView
    }));
  }
}
ese(ict, "defaultProps", {
  data: MTr
});
const GIe = {
  dark: {
    // The vega-themes dark theme.
    // Reference: https://github.com/vega/vega-themes/blob/master/src/theme-dark.ts
    background: null,
    title: { color: "#fff" },
    style: {
      "guide-label": {
        fill: "#fff"
      },
      "guide-title": {
        fill: "#fff"
      }
    },
    axis: {
      domainColor: "#fff",
      gridColor: "#888",
      tickColor: "#fff"
    }
  },
  light: {
    // The default vega theme.
    background: null
  }
}, IS = "table", OTr = kr((t) => ({
  "@global": {
    "#vg-tooltip-element.vg-tooltip.custom-theme": {
      boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
      padding: "0px",
      backgroundColor: t.palette.gridLayoutBackground,
      color: t.palette.secondaryForeground,
      border: "none",
      opacity: 0.9,
      fontSize: "12px",
      borderRadius: "4px",
      "& > div": {
        backgroundColor: "transparent"
      }
    }
  }
}));
function FTr(t) {
  return t.$schema === "https://vega.github.io/schema/vega/v5.json";
}
function PTr(t) {
  return `<table>
      <tbody>
        ${Object.entries(t).map(([n, r]) => `<tr key=${n}>
        <th>${n}</th>
        <td>${r}</td>
      </tr>`).join("")}
      </tbody>
    </table>`;
}
function UIe(t) {
  const { spec: e, data: n, getTooltipText: r, signalListeners: i } = t, o = OTr(), s = xKe(), a = dt(() => {
    if (typeof r == "function") {
      const c = {
        theme: "custom",
        offsetX: 10,
        offsetY: 10,
        // Use table element to match packages/tooltip/TooltipContent implementation.
        formatTooltip: (h) => `
          <div class="${Xt(o.tooltipContainer, s.tooltipContent)}">
            ${PTr(h)}
          </div>
        `
      }, u = new gtr(c), f = u.call;
      return u.call = (h, d, I, m) => {
        if (I && I.datum && m) {
          const C = r(I);
          f.call(this, h, d, I, C);
        } else
          f.call(this, h, d, I, m);
      }, u.call;
    }
    return !1;
  }, [r, o.tooltipContainer, s.tooltipContent]), A = dt(() => ({
    ...e,
    data: FTr(e) ? [
      { name: IS },
      ...e.data
    ] : { name: IS }
  }), [e]), l = dt(() => ne.jsx(ict, { spec: A, data: {
    [IS]: n
  }, signalListeners: i, tooltip: a, renderer: "canvas", scaleFactor: 3 }), [A, n, i, a]);
  return A && n && n.length > 0 ? ne.jsx(L3e, { fallback: ne.jsx("div", { children: "Loading..." }), children: l }) : null;
}
function kTr(t) {
  const { domainMax: e = 100, colors: n, data: r, theme: i, width: o, height: s, marginRight: a = 90, marginBottom: A, obsType: l, featureValueType: c, featureValueTransformName: u } = t, f = r.reduce((Q, w) => (Q = Q === void 0 || w.set.length > Q ? w.set.length : Q, Q), 0), h = A || 30 + Math.sqrt(f / 2) * 30, d = {
    domain: n.map((Q) => Q.name),
    range: n.map((Q) => Qu(Q.color))
  }, I = Su(o - a, 10, 1 / 0), m = Su(s - h, 10, 1 / 0), C = n.length, y = I / C, v = i === "dark" ? "white" : "black", b = {
    $schema: "https://vega.github.io/schema/vega/v5.json",
    description: `A violin plot showing distributions of expression levels for selected ${l} sets.`,
    width: I,
    height: m,
    config: {
      ...GIe[i],
      axisBand: {
        bandPosition: 1,
        tickExtra: !0,
        tickOffset: 0
      }
    },
    signals: [
      { name: "bandWidth", value: y },
      { name: "width", value: I },
      { name: "height", value: m },
      { name: "trim", value: !0 }
    ],
    data: [
      {
        name: "density",
        source: IS,
        transform: [
          {
            type: "kde",
            field: "value",
            groupby: ["set"],
            bandwidth: 0,
            extent: [0, e]
          }
        ]
      },
      {
        name: "stats",
        source: IS,
        transform: [
          {
            type: "aggregate",
            groupby: ["set"],
            fields: ["value", "value", "value"],
            ops: ["q1", "median", "q3"],
            as: ["q1", "median", "q3"]
          }
        ]
      }
    ],
    scales: [
      {
        name: "layout",
        type: "band",
        range: "width",
        domain: { data: IS, field: "set" }
      },
      {
        name: "yscale",
        type: "linear",
        range: "height",
        domain: [0, e]
      },
      {
        name: "wscale",
        type: "linear",
        range: [0, { signal: "bandWidth" }],
        domain: { data: "density", field: "density" }
      },
      {
        name: "wscaleReversed",
        type: "linear",
        reverse: !0,
        range: [0, { signal: "bandWidth" }],
        domain: { data: "density", field: "density" }
      },
      {
        name: "color",
        type: "ordinal",
        ...d
      }
    ],
    axes: [
      {
        orient: "left",
        scale: "yscale",
        zindex: 1,
        title: u && u !== "None" ? [`${u}-Transformed`, `${Ci(c)} Values`] : `${Ci(c)} Values`
      },
      {
        orient: "bottom",
        scale: "layout",
        tickCount: 5,
        zindex: 1,
        title: `${Ci(l)} Set`,
        labelAngle: -45,
        labelAlign: "right"
      }
    ],
    marks: [
      {
        type: "group",
        from: {
          facet: {
            data: "density",
            name: "violin",
            groupby: "set"
          }
        },
        encode: {
          enter: {
            xc: { scale: "layout", field: "set", band: 0.5 },
            width: { signal: "bandWidth" },
            height: { signal: "height" }
          }
        },
        data: [
          {
            name: "summary",
            source: "stats",
            transform: [
              {
                type: "filter",
                expr: "datum.set === parent.set"
              }
            ]
          }
        ],
        marks: [
          {
            type: "area",
            orient: "vertical",
            from: { data: "violin" },
            encode: {
              enter: {
                fill: { scale: "color", field: { parent: "set" } }
              },
              update: {
                width: { scale: "wscale", field: "density" },
                xc: { signal: "bandWidth / 2" },
                y2: { scale: "yscale", field: "value" },
                y: { scale: "yscale", value: 0 }
              }
            }
          },
          {
            type: "area",
            orient: "vertical",
            from: { data: "violin" },
            encode: {
              enter: {
                fill: { scale: "color", field: { parent: "set" } }
              },
              update: {
                width: { scale: "wscaleReversed", field: "density" },
                xc: { signal: "bandWidth" },
                y2: { scale: "yscale", field: "value" },
                y: { scale: "yscale", value: 0 }
              }
            }
          },
          {
            type: "rect",
            from: { data: "summary" },
            encode: {
              enter: {
                fill: { value: v },
                width: { value: 2 }
              },
              update: {
                y: { scale: "yscale", field: "q1" },
                y2: { scale: "yscale", field: "q3" },
                xc: { signal: "bandWidth / 2" }
              }
            }
          },
          {
            type: "rect",
            from: { data: "summary" },
            encode: {
              enter: {
                fill: { value: v },
                height: { value: 2 },
                width: { value: 8 }
              },
              update: {
                y: { scale: "yscale", field: "median" },
                xc: { signal: "bandWidth / 2" }
              }
            }
          }
        ]
      }
    ]
  };
  return ne.jsx(UIe, { data: r, spec: b });
}
const HIe = kr(() => ({
  vegaContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden"
  }
}));
function GTr(t, e, n, r, i, o, s, a, A, l) {
  const c = dt(() => RI(n, r), [n, r]), [u, f] = dt(() => {
    if (c && o && i && i.length >= 1 && t) {
      const d = iUt(c, o, s, l), I = i[0];
      let m = -1 / 0;
      const C = {};
      for (let v = 0; v < e.length; v += 1)
        C[e[v]] = v;
      return [d.map((v) => {
        const b = C[v.obsId], Q = t[0][b], R = U3e(a, A)(Q);
        return m = Math.max(R, m), { value: R, gene: I, set: v.name };
      }), m];
    }
    return [null, null];
  }, [
    t,
    e,
    i,
    l,
    c,
    o,
    s,
    a,
    A
  ]), h = dt(() => c && o && s ? S5e(c, o, o, s, l) : [], [c, o, s, l]);
  return [u, h, f];
}
function UTr(t) {
  const { coordinationScopes: e, closeButtonVisible: n, downloadButtonVisible: r, removeGridComponent: i, theme: o } = t, s = HIe(), a = eu(), [{ dataset: A, obsType: l, featureType: c, featureValueType: u, featureSelection: f, featureValueTransform: h, featureValueTransformCoefficient: d, obsSetSelection: I, obsSetColor: m, additionalObsSets: C }, { setFeatureValueTransform: y, setFeatureValueTransformCoefficient: v }] = uc(ea[Gn.OBS_SET_FEATURE_VALUE_DISTRIBUTION], e), [b, Q, w] = uw(), R = LX, [M, O, L] = bv(a, A, !1, f, { obsType: l, featureType: c, featureValueType: u }), [{ featureLabelsMap: N }, k, $] = DL(a, A, !1, {}, {}, { featureType: c }), [{ obsIndex: U }, X, K] = TL(a, A, !1, { obsType: l, featureType: c, featureValueType: u }), [{ obsSets: z }, Y, V] = VB(a, A, !0, {}, {}, { obsType: l }), Z = Jc([
    L,
    X,
    Y,
    k
  ]), ce = Qd([
    $,
    K,
    V
  ]), [ee, pe, Ce] = GTr(M, U, z, C, f, I, m, h, d, o), Be = f && f.length >= 1 ? N?.get(f[0]) || f[0] : null, Ie = R.find((Qe) => Qe.value === h)?.name;
  return ne.jsx(fc, { title: `Expression by ${Ci(l)} Set${Be ? ` (${Be})` : ""}`, closeButtonVisible: n, downloadButtonVisible: r, removeGridComponent: i, urls: ce, theme: o, isReady: Z, options: ne.jsx(zer, { featureValueTransform: h, setFeatureValueTransform: y, featureValueTransformCoefficient: d, setFeatureValueTransformCoefficient: v, transformOptions: R }), children: ne.jsx("div", { ref: w, className: s.vegaContainer, children: ee ? ne.jsx(kTr, { domainMax: Ce, colors: pe, data: ee, theme: o, width: b, height: Q, obsType: l, featureValueType: u, featureValueTransformName: Ie }) : ne.jsxs("span", { children: ["Select a ", c, "."] }) }) });
}
function HTr(t) {
  const { data: e, theme: n, width: r, height: i, marginRight: o = 90, marginBottom: s = 120, keyLength: a = 36, obsType: A, onBarSelect: l } = t, c = e.map((y) => ({
    ...y,
    keyName: y.key + y.name,
    colorString: Qu(y.color)
  })), u = c.map((y) => y.keyName), f = {
    // Manually set the color scale so that Vega-Lite does
    // not choose the colors automatically.
    domain: c.map((y) => y.key),
    range: c.map((y) => {
      const [v, b, Q] = y.isGrayedOut ? da(n) : y.color;
      return `rgba(${v}, ${b}, ${Q}, 1)`;
    })
  }, h = Ci(A), d = {
    mark: { type: "bar", stroke: "black", cursor: "pointer" },
    params: [
      {
        name: "highlight",
        select: {
          type: "point",
          on: "mouseover"
        }
      },
      {
        name: "select",
        select: "point"
      },
      {
        name: "bar_select",
        select: {
          type: "point",
          on: "click[event.shiftKey === false]",
          fields: ["setNamePath", "isGrayedOut"],
          empty: "none"
        }
      },
      {
        name: "shift_bar_select",
        select: {
          type: "point",
          on: "click[event.shiftKey]",
          fields: ["setNamePath", "isGrayedOut"],
          empty: "none"
        }
      }
    ],
    encoding: {
      x: {
        field: "keyName",
        type: "nominal",
        axis: { labelExpr: `substring(datum.label, ${a})` },
        title: "Cell Set",
        sort: u
      },
      y: {
        field: "size",
        type: "quantitative",
        title: `${h} Set Size`
      },
      color: {
        field: "key",
        type: "nominal",
        scale: f,
        legend: null
      },
      tooltip: {
        field: "size",
        type: "quantitative"
      },
      fillOpacity: {
        condition: {
          param: "select",
          value: 1
        },
        value: 0.3
      },
      strokeWidth: {
        condition: [
          {
            param: "select",
            empty: !1,
            value: 1
          },
          {
            param: "highlight",
            empty: !1,
            value: 2
          }
        ],
        value: 0
      }
    },
    width: Su(r - o, 10, 1 / 0),
    height: Su(i - s, 10, 1 / 0),
    config: GIe[n]
  }, I = (y, v) => {
    y === "bar_select" ? l(v.setNamePath, v.isGrayedOut[0]) : y === "shift_bar_select" && l(v.setNamePath, !1, !0);
  }, m = { bar_select: I, shift_bar_select: I }, C = Qn((y) => ({
    [`${h} Set`]: y.datum.name,
    [`${h} Set Size`]: y.datum.size
  }), [h]);
  return ne.jsx(UIe, { data: c, spec: d, signalListeners: m, getTooltipText: C });
}
function $Tr(t) {
  const { coordinationScopes: e, closeButtonVisible: n, downloadButtonVisible: r, removeGridComponent: i, theme: o, title: s } = t, a = HIe(), A = eu(), [{ dataset: l, obsType: c, obsSetSelection: u, obsSetColor: f, additionalObsSets: h, obsSetExpansion: d }, { setObsSetSelection: I, setObsSetColor: m }] = uc(ea[Gn.OBS_SET_SIZES], e), C = s || `${Ci(c)} Set Sizes`, [y, v, b] = uw(), [Q, w] = mn([]), [R, M] = mn([]), [{ obsSets: O }, L, N] = VB(A, l, !0, { setObsSetSelection: I, setObsSetColor: m }, { obsSetSelection: u, obsSetColor: f }, { obsType: c }), k = Jc([L]), $ = Qd([N]), U = dt(() => RI(O, h), [O, h]), X = dt(() => {
    if (u && f && U && O) {
      let z = Q;
      if (u) {
        const V = cUt(R, u);
        M(u), V && (w(V), z = V);
      }
      const Y = lUt(U, z, d, u);
      if (U && O && u && f)
        return S5e(U, Y, u, f, o);
    }
    return [];
  }, [
    U,
    u,
    d,
    f,
    o
  ]), K = (z, Y, V = !1) => {
    if (V) {
      I([z]);
      return;
    }
    Y ? Y && I([...u, z]) : I(u.filter((Z) => !gr(Z, z)));
  };
  return ne.jsx(fc, { title: C, closeButtonVisible: n, downloadButtonVisible: r, removeGridComponent: i, urls: $, theme: o, isReady: k, children: ne.jsx("div", { ref: b, className: a.vegaContainer, children: ne.jsx(HTr, { data: X, onBarSelect: K, theme: o, width: y, height: v, obsType: c }) }) });
}
function qTr(t) {
  const { geneSelection: e, data: n, theme: r, width: i, height: o, marginRight: s = 90, marginBottom: a = 50, onSelect: A } = t, [l, c] = mn([]), u = e && e.length >= 1 ? "Normalized Expression Value" : "Total Normalized Transcript Count", f = {
    data: { values: n },
    mark: "bar",
    encoding: {
      x: {
        field: "value",
        type: "quantitative",
        bin: { maxbins: 50 },
        title: u
      },
      y: {
        type: "quantitative",
        aggregate: "count",
        title: "Number of Cells"
      },
      color: { value: "gray" },
      opacity: {
        condition: { selection: "brush", value: 1 },
        value: 0.7
      }
    },
    params: [
      {
        name: "brush",
        select: { type: "interval", encodings: ["x"] }
      }
    ],
    width: Su(i - s, 10, 1 / 0),
    height: Su(o - a, 10, 1 / 0),
    config: GIe[r]
  }, h = (m, C) => {
    m === "brush" && c(C.value);
  }, d = Qn(Bd((m, C) => {
    C(m);
  }, 1e3), []);
  Mn(() => !l || l.length === 0 ? () => {
  } : (d(l, A), () => {
    d.cancel();
  }), [l]);
  const I = { brush: h };
  return ne.jsx(UIe, { data: n, signalListeners: I, spec: f });
}
function jTr(t) {
  const { coordinationScopes: e, closeButtonVisible: n, downloadButtonVisible: r, removeGridComponent: i, theme: o } = t, s = HIe(), a = eu(), [{ dataset: A, obsType: l, featureType: c, featureValueType: u, featureSelection: f, additionalObsSets: h, obsSetColor: d }, { setAdditionalObsSets: I, setObsSetColor: m, setObsColorEncoding: C, setObsSetSelection: y }] = uc(ea[Gn.FEATURE_VALUE_HISTOGRAM], e), [v, b, Q] = uw(), [{ obsIndex: w, featureIndex: R, obsFeatureMatrix: M }, O, L] = k8e(a, A, !0, {}, {}, { obsType: l, featureType: c, featureValueType: u }), [N, k, $] = bv(a, A, !1, f, { obsType: l, featureType: c, featureValueType: u }), U = Jc([
    O,
    $
  ]), X = Qd([
    L
  ]), K = f && f.length >= 1 ? f[0] : null, z = dt(() => {
    if (K && M && N)
      return w.map((V, Z) => ({ value: N[0][Z] * 100 / 255, gene: K, cellId: V }));
    if (M) {
      const V = R.length;
      return w.map((Z, ce) => {
        const ee = M.data.subarray(ce * V, (ce + 1) * V);
        return { value: R8e(ee) * 100 / 255, gene: null, cellId: Z };
      });
    }
    return null;
  }, [w, R, M, K, N]), Y = Qn((V) => {
    const Z = K ? [K, "values"].join(" ") : "transcript count", ce = Y4t(V, z);
    pI(ce, h, d, y, I, m, C, "Selection ", `: based on ${Z} in range [${V[0].toFixed(1)}, ${V[1].toFixed(1)}] `);
  }, [
    h,
    d,
    z,
    I,
    C,
    m,
    y,
    K
  ]);
  return ne.jsx(fc, { title: `Expression Histogram${K ? ` (${K})` : ""}`, closeButtonVisible: n, downloadButtonVisible: r, removeGridComponent: i, urls: X, theme: o, isReady: U, children: ne.jsx("div", { ref: Q, className: s.vegaContainer, children: ne.jsx(qTr, { geneSelection: f, onSelect: Y, data: z, theme: o, width: v, height: b }) }) });
}
class Pm {
  constructor({ url: e, requestInit: n }) {
    this.url = e, this.requestInit = n;
  }
  get data() {
    return this._data ? this._data : (this._data = fetch(this.url, this.requestInit).then((e) => e.ok ? e.text() : Promise.reject(new iU("CsvSource", this.url, e.headers))).catch(() => Promise.reject(new iU("CsvSource", this.url, {}))).then((e) => e instanceof Ei ? Promise.reject(e) : dUt(e)), this._data);
  }
}
class ty extends gc {
  getSourceData() {
    const { url: e } = this;
    return this.data ? this.data : (this.data = this.dataSource.data.then((n) => n instanceof Ei ? Promise.reject(n) : Promise.resolve(new Si(n, e))), this.data);
  }
  async load() {
    const e = await this.getSourceData().catch((o) => Promise.resolve(o));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n, url: r } = e, i = this.loadFromCache(n);
    return Promise.resolve(new Si(i, r));
  }
}
class YTr extends ty {
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const { featureIndex: n, featureLabels: r } = this.options, i = e.map((s) => String(s[n])), o = e.map((s) => String(s[r]));
    return this.cachedResult = { featureIndex: i, featureLabels: o }, this.cachedResult;
  }
}
class zTr extends ty {
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const { obsIndex: n, obsEmbedding: [r, i] } = this.options, o = e.map((l) => String(l[n])), s = Float32Array.from(e.map((l) => l[r])), a = Float32Array.from(e.map((l) => l[i])), A = {
      data: [s, a],
      shape: [2, s.length]
    };
    return this.cachedResult = { obsIndex: o, obsEmbedding: A }, this.cachedResult;
  }
}
class VTr extends ty {
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const n = e.map((a) => String(a[e.columns[0]])), r = [...e.columns];
    r.shift();
    const i = [n.length, r.length], o = new Float32Array(i[0] * i[1]);
    e.forEach((a, A) => {
      const l = r.map((c) => parseFloat(a[c]));
      o.set(l, A * i[1]);
    });
    const s = { data: o };
    return this.cachedResult = { obsIndex: n, featureIndex: r, obsFeatureMatrix: s }, this.cachedResult;
  }
}
class JTr extends ty {
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const { obsIndex: n, obsLabels: r } = this.options, i = e.map((s) => String(s[n])), o = e.map((s) => String(s[r]));
    return this.cachedResult = { obsIndex: i, obsLabels: o }, this.cachedResult;
  }
}
class KTr extends ty {
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const { obsIndex: n, obsSpots: [r, i] } = this.options, o = e.map((l) => String(l[n])), s = Float32Array.from(e.map((l) => l[r])), a = Float32Array.from(e.map((l) => l[i])), A = {
      data: [s, a],
      shape: [2, s.length]
    };
    return this.cachedResult = { obsIndex: o, obsSpots: A }, this.cachedResult;
  }
  async load() {
    const e = await this.getSourceData().catch((s) => Promise.resolve(s));
    if (e instanceof Ei)
      return Promise.reject(e);
    const n = {
      spotLayer: dA({
        obsType: "spot",
        // obsColorEncoding: 'spatialLayerColor',
        // spatialLayerColor: [255, 255, 255],
        spatialLayerVisible: !0,
        spatialLayerOpacity: 1,
        spatialSpotRadius: 10
        // TODO: spatialSpotRadiusUnit: 'µm' or 'um'
        // after resolving https://github.com/vitessce/vitessce/issues/1760
        // featureValueColormapRange: [0, 1],
        // obsHighlight: null,
        // obsSetColor: null,
        // obsSetSelection: null,
        // additionalObsSets: null,
      })
    }, { data: r, url: i } = e, o = this.loadFromCache(r);
    return Promise.resolve(new Si(o, i, n));
  }
}
class WTr extends ty {
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const { obsIndex: n, obsPoints: [r, i] } = this.options, o = e.map((l) => String(l[n])), s = Float32Array.from(e.map((l) => l[r])), a = Float32Array.from(e.map((l) => l[i])), A = {
      data: [s, a],
      shape: [2, s.length]
    };
    return this.cachedResult = { obsIndex: o, obsPoints: A }, this.cachedResult;
  }
  async load() {
    const e = await this.getSourceData().catch((s) => Promise.resolve(s));
    if (e instanceof Ei)
      return Promise.reject(e);
    const n = {
      pointLayer: dA({
        obsType: "point",
        // obsColorEncoding: 'spatialLayerColor',
        // spatialLayerColor: [255, 255, 255],
        spatialLayerVisible: !0,
        spatialLayerOpacity: 1
        // TODO: support a point radius?
        // featureValueColormapRange: [0, 1],
        // obsHighlight: null,
        // obsSetColor: null,
        // obsSetSelection: null,
        // additionalObsSets: null,
        // obsLabelsType: null,
      })
    }, { data: r, url: i } = e, o = this.loadFromCache(r);
    return Promise.resolve(new Si(o, i, n));
  }
}
class XTr extends ty {
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const { obsIndex: n, obsLocations: [r, i] } = this.options, o = e.map((l) => String(l[n])), s = Float32Array.from(e.map((l) => l[r])), a = Float32Array.from(e.map((l) => l[i])), A = {
      data: [s, a],
      shape: [2, s.length]
    };
    return this.cachedResult = { obsIndex: o, obsLocations: A }, this.cachedResult;
  }
}
class ZTr extends ty {
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const { obsIndex: n, obsSets: r } = this.options, i = e.map((C) => String(C[n])), s = r.map(({ column: C }) => C).map((C) => Array.isArray(C) ? C.map((y) => e.map((v) => v[y])) : e.map((y) => y[C])), A = r.map((C) => C.scorePath || void 0).map((C) => C ? e.map((y) => y[C]) : void 0), l = s.map(() => i), c = D5e([
      l,
      s,
      A
    ], r), u = sAe(c), f = {}, { tree: h } = c, d = h[0].name, I = h[0].children.map((C) => [
      d,
      C.name
    ]), m = y9(c, []);
    return f.obsSetSelection = I, f.obsSetColor = m, [i, c, u, f];
  }
  async load() {
    const e = await this.getSourceData().catch((A) => Promise.resolve(A));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n, url: r } = e, [i, o, s, a] = this.loadFromCache(n);
    return Promise.resolve(new Si({
      obsIndex: i,
      obsSets: o,
      obsSetsMembership: s
    }, r, a));
  }
}
class gu {
  constructor({ url: e, requestInit: n }) {
    this.url = e, this.requestInit = n;
  }
  get data() {
    return this._data ? this._data : (this._data = fetch(this.url, this.requestInit).then((e) => e.ok ? e.json() : Promise.reject(new iU("JsonSource", this.url, e.headers))).catch(() => Promise.reject(new iU("JsonSource", this.url, {}))), this._data);
  }
}
const DX = me.array(me.number()).length(2), zO = me.record(me.object({
  xy: DX,
  genes: me.record(me.number()),
  factors: me.record(me.string()),
  poly: me.array(DX),
  mappings: me.record(DX)
}).strict().partial()), $Ie = me.record(me.array(
  // XY coordinate
  me.array(me.number()).length(2)
)), eNr = me.record(me.object({
  poly: me.array(
    // Coordinate
    me.array(me.number()).length(2)
  )
}).strict()), tNr = {
  [Ft.CELLS_JSON]: zO,
  [Ft.MOLECULES_JSON]: $Ie,
  [Ft.NEIGHBORHOODS_JSON]: eNr,
  [Ft.RASTER_JSON]: bT,
  [Ft.CELL_SETS_JSON]: FH
};
class th extends gc {
  constructor(e, n) {
    super(e, n);
    const { fileType: r } = n;
    this.schema = tNr[r];
  }
  load() {
    const { url: e, type: n, fileType: r } = this;
    return this.data ? this.data : (this.data = this.dataSource.data.then((i) => {
      if (i instanceof Ei)
        return Promise.reject(i);
      const [o, s] = this.validate(i);
      return o ? Promise.resolve(new Si(i, e)) : Promise.reject(new uGt(n, r, e, s));
    }), this.data);
  }
  validate(e) {
    const { schema: n } = this;
    if (!n)
      return [!0, null];
    const r = n.safeParse(e), i = r.success;
    let o;
    return i || (o = r.error.message), [i, o];
  }
}
class nNr extends th {
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const n = Object.keys(e), r = Object.values(e), i = {
      data: r,
      shape: [r.length, r[0].length]
    };
    return this.cachedResult = { obsIndex: n, obsSegmentations: i, obsSegmentationsType: "polygon" }, this.cachedResult;
  }
  async load() {
    const e = await super.load().catch((a) => Promise.resolve(a));
    if (e instanceof Ei)
      return Promise.reject(e);
    const n = [{
      // obsType: null,
      spatialChannelColor: [255, 255, 255],
      spatialChannelVisible: !0,
      spatialChannelOpacity: 1,
      spatialChannelWindow: null,
      // featureType: 'feature',
      // featureValueType: 'value',
      obsColorEncoding: "spatialChannelColor",
      spatialSegmentationFilled: !0,
      spatialSegmentationStrokeWidth: 1,
      obsHighlight: null
    }], r = {
      // spatialTargetZ: imageWrapper.getDefaultTargetZ(),
      // spatialTargetT: imageWrapper.getDefaultTargetT(),
      segmentationLayer: dA([
        {
          fileUid: this.coordinationValues?.fileUid || null,
          spatialLayerOpacity: 1,
          spatialLayerVisible: !0,
          segmentationChannel: dA(n)
        }
      ])
    }, { data: i, url: o } = e, s = this.loadFromCache(i);
    return Promise.resolve(new Si(s, o, r));
  }
}
class p3e extends th {
  constructor(e, n) {
    super(e, n), this.schema = FH;
  }
  async load() {
    const e = await super.load().catch((A) => Promise.resolve(A));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n, url: r } = e;
    this.fileType.endsWith("cell-sets.json");
    const [i] = aAe(n);
    let o = [];
    const s = {
      obsSetSelection: [],
      obsSetColor: []
    };
    let a = /* @__PURE__ */ new Map();
    if (i && i.tree.length >= 1) {
      const { tree: A } = i;
      a = sAe(i);
      const l = A[0].name, c = A[0].children.map((f) => [l, f.name]), u = y9(i, []);
      s.obsSetSelection = c, s.obsSetColor = u, o = wd(A[0]).map((f) => f[0]);
    }
    return Promise.resolve(new Si({
      obsIndex: o,
      obsSets: i,
      obsSetsMembership: a
    }, r, s));
  }
}
class rNr extends th {
  constructor(e, n) {
    super(e, n), this.schema = zO;
  }
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const { embeddingType: n } = this.coordinationValues, r = Object.values(e);
    if (r.length > 0 && (!r[0].mappings || !Array.isArray(r[0].mappings[n])))
      this.cachedResult = null;
    else {
      const i = Object.keys(e), o = Float32Array.from(r.map((A) => A.mappings[n][0])), s = Float32Array.from(r.map((A) => A.mappings[n][1])), a = {
        data: [o, s],
        shape: [2, o.length]
      };
      this.cachedResult = { obsIndex: i, obsEmbedding: a };
    }
    return this.cachedResult;
  }
  async load() {
    const e = await super.load().catch((o) => Promise.resolve(o));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n, url: r } = e, i = this.loadFromCache(n);
    return Promise.resolve(new Si(i, r));
  }
}
class iNr extends th {
  constructor(e, n) {
    super(e, n), this.schema = zO;
  }
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const { obsLabelsType: n } = this.coordinationValues, r = Object.keys(e), i = Object.values(e).map((o) => o.factors[n]);
    return this.cachedResult = { obsIndex: r, obsLabels: i }, this.cachedResult;
  }
  async load() {
    const e = await super.load().catch((o) => Promise.resolve(o));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n, url: r } = e, i = this.loadFromCache(n);
    return Promise.resolve(new Si(i, r));
  }
}
class oNr extends th {
  constructor(e, n) {
    super(e, n), this.schema = zO;
  }
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const n = Object.values(e);
    if (n.length > 0 && !Array.isArray(n[0].xy))
      this.cachedResult = null;
    else {
      const r = Object.keys(e), i = Float32Array.from(n.map((a) => a.xy[0])), o = Float32Array.from(n.map((a) => a.xy[1])), s = {
        data: [i, o],
        shape: [2, i.length]
      };
      this.cachedResult = { obsIndex: r, obsLocations: s };
    }
    return this.cachedResult;
  }
  async load() {
    const e = await super.load().catch((o) => Promise.resolve(o));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n, url: r } = e, i = this.loadFromCache(n);
    return Promise.resolve(new Si(i, r));
  }
}
class sNr extends th {
  constructor(e, n) {
    super(e, n), this.schema = zO;
  }
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const n = Object.keys(e), r = Object.values(e);
    if (r.length > 0 && !Array.isArray(r[0].poly) && !Array.isArray(r[0].xy))
      this.cachedResult = null;
    else {
      let i;
      !Array.isArray(r[0].poly) || !r[0].poly?.length ? i = r.map((a) => eWn(a.xy[0], a.xy[1], 50)) : i = r.map((s) => s.poly);
      const o = {
        data: i,
        shape: [i.length, i[0].length]
      };
      this.cachedResult = { obsIndex: n, obsSegmentations: o };
    }
    return this.cachedResult;
  }
  async load() {
    const e = await super.load().catch((s) => Promise.resolve(s));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n, url: r } = e, i = this.loadFromCache(n), o = {
      spatialSegmentationLayer: qWe
    };
    return Promise.resolve(new Si({
      ...i,
      obsSegmentationsType: "polygon"
    }, r, o));
  }
}
const aNr = me.object({
  rows: me.array(me.string()),
  cols: me.array(me.string()),
  matrix: me.array(me.array(me.number()))
}).strict();
class ANr extends th {
  constructor(e, n) {
    super(e, n), this.schema = aNr;
  }
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const { rows: n, cols: r, matrix: i } = e, o = {
      rows: r,
      cols: n
    }, s = [o.rows.length, o.cols.length], a = i.map((u) => {
      const [f, h] = fa(u), d = (I) => Math.floor((I - f) / (h - f) * 255);
      return u.map(d);
    }), l = oA(s[0]).map((u) => oA(s[1]).map((f) => a[f][u])).flat(), c = { data: Uint8Array.from(l) };
    return this.cachedResult = { obsIndex: r, featureIndex: n, obsFeatureMatrix: c }, this.cachedResult;
  }
  async load() {
    const e = await super.load().catch((o) => Promise.resolve(o));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n, url: r } = e, i = this.loadFromCache(n);
    return Promise.resolve(new Si(i, r));
  }
}
const lNr = me.record(me.object({
  max: me.number(),
  cells: me.record(me.number())
}));
class cNr extends th {
  constructor(e, n) {
    super(e, n), this.schema = lNr;
  }
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const n = Object.keys(e), r = n.length > 0 ? Object.keys(e[n[0]].cells) : [], i = r.flatMap((A) => n.map((l) => e[l].cells[A] / e[l].max * 255)), o = n, s = r, a = { data: Uint8Array.from(i) };
    return this.cachedResult = { obsIndex: s, featureIndex: o, obsFeatureMatrix: a }, this.cachedResult;
  }
  async load() {
    const e = await super.load().catch((o) => Promise.resolve(o));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n, url: r } = e, i = this.loadFromCache(n);
    return Promise.resolve(new Si(i, r));
  }
}
class uNr extends th {
  constructor(e, n) {
    super(e, n), this.schema = $Ie;
  }
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const n = oA(w4e(Object.values(e).map((i) => i.length))).map((i) => String(i));
    let r = [];
    return Object.entries(e).forEach(([i, o]) => {
      r = [
        ...r,
        ...oA(o.length).map(() => i)
      ];
    }), this.cachedResult = { obsIndex: n, obsLabels: r }, this.cachedResult;
  }
  async load() {
    const e = await super.load().catch((o) => Promise.resolve(o));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n, url: r } = e, i = this.loadFromCache(n);
    return Promise.resolve(new Si(i, r));
  }
}
class fNr extends th {
  constructor(e, n) {
    super(e, n), this.schema = $Ie;
  }
  loadFromCache(e) {
    if (this.cachedResult)
      return this.cachedResult;
    const n = Object.values(e), r = oA(w4e(n.map((A) => A.length))).map((A) => String(A)), i = new Float32Array(r.length), o = new Float32Array(r.length);
    let s = 0;
    n.forEach((A) => {
      i.set(A.map((l) => l[0]), s), o.set(A.map((l) => l[1]), s), s += A.length;
    });
    const a = {
      data: [i, o],
      shape: [2, i.length]
    };
    return this.cachedResult = { obsIndex: r, obsLocations: a }, this.cachedResult;
  }
  async load() {
    const e = await super.load().catch((s) => Promise.resolve(s));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n, url: r } = e, i = this.loadFromCache(n), o = {
      // TODO: do this for anndata segmentation loader
      spatialPointLayer: tWn
    };
    return Promise.resolve(new Si(i, r, o));
  }
}
async function gNr(t) {
  const { type: e, url: n, metadata: r, requestInit: i } = t;
  switch (e) {
    case "zarr": {
      const { dimensions: o, isPyramid: s, transform: a } = r || {}, A = o.map((u) => u.field);
      let l;
      const c = await Nre(n, i);
      if (s) {
        const u = `${n}${n.slice(-1) === "/" ? "" : "/"}.zmetadata`, f = await fetch(u), { metadata: h } = await f.json(), d = Object.keys(h).filter((C) => C.includes(".zarray")).map((C) => C.slice(0, -7)), I = await Promise.all(d.map((C) => fs(c.resolve(C), { kind: "array" }))), m = WWe(I[0]);
        l = I.map((C) => new Lre(hC(C), A, m));
      } else {
        const u = await fs(c, { kind: "array" });
        l = new Lre(hC(u), A);
      }
      return { data: l, metadata: { dimensions: o, transform: a }, channels: (o.find((u) => u.field === "channel") || o[0]).values };
    }
    case "ome-tiff": {
      let o;
      if (r && "omeTiffOffsetsUrl" in r) {
        const { omeTiffOffsetsUrl: A } = r, l = await fetch(A, i || {});
        if (l.ok) {
          const c = await l.json();
          o = await q8(n, {
            offsets: c,
            headers: i?.headers
          });
        } else
          throw new Error(`Offsets not found but provided: ${l.status} from ${l.url}`);
      } else
        o = await q8(n, { headers: i?.headers });
      const { Pixels: { Channels: s } } = o.metadata, a = Array.isArray(s) ? s.map((A, l) => A.Name || `Channel ${l}`) : [s.Name || "Channel 0"];
      return { ...o, channels: a };
    }
    case "ome-zarr": {
      const { coordinateTransformations: o } = r || {}, s = await Nre(n, i), a = await XWe(s), { metadata: A } = a, { omero: l, multiscales: c } = A;
      (!Array.isArray(c) || c.length === 0) && console.error("Multiscales array must exist and have at least one element");
      const { coordinateTransformations: u } = c[0], f = Yfe(c[0].axes), h = EI(o, f), I = EI(u, f).multiplyLeft(h), { channels: m, name: C } = l;
      return {
        name: C || "Image",
        channels: m.map((y, v) => y.label || `Channel ${v}`),
        ...I ? {
          metadata: {
            transform: {
              matrix: I
            }
          }
        } : {},
        ...a
      };
    }
    default:
      throw Error(`Image type (${e}) is not supported`);
  }
}
class oct extends th {
  constructor(e, n) {
    const { url: r, options: i } = n;
    !r && i && (e.url = URL.createObjectURL(new Blob([JSON.stringify(i)]))), super(e, n), this.schema = bT;
  }
  async load() {
    const e = await super.load().catch((A) => Promise.resolve(A));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n } = e, { images: r, renderLayers: i, usePhysicalSizeScaling: o = !1 } = n, s = r.filter((A) => !A.url.includes("zarr")).map((A) => ({ url: A.url, name: A.name })), a = r.map((A) => ({
      ...A,
      loaderCreator: async () => gNr(A)
    }));
    return this.autoImageCache || (this.autoImageCache = Kq(a, i, o)), this.autoImageCache.then((A) => {
      const [l, c, u] = A, f = {
        spatialImageLayer: l
      };
      return new Si({ loaders: c, meta: u }, s, f);
    });
  }
}
class hNr extends oct {
  async load() {
    const e = await super.load().catch((l) => Promise.resolve(l));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n = {}, url: r, coordinationValues: i } = e, { loaders: o = [], meta: s = [] } = n, a = [], A = [];
    return s.forEach((l, c) => {
      l?.metadata?.isBitmask || (a.push(o[c]), A.push(s[c]));
    }), i?.spatialImageLayer || console.warn("Could not initialize coordinationValues.spatialImageLayer in RasterJsonAsImageLoader. This may be an indicator that the image could not be loaded."), new Si({
      image: a.length > 0 && A.length > 0 ? { loaders: a, meta: A } : null
    }, r, {
      // Filter coordinationValues, keeping only non-bitmask layers.
      spatialImageLayer: i?.spatialImageLayer?.filter((l) => l.type !== "bitmask").map((l) => ({
        ...l,
        index: A.findIndex((c) => c.name === s[l.index].name)
      }))
    });
  }
}
class dNr extends oct {
  async load() {
    const e = await super.load().catch((l) => Promise.resolve(l));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { data: n = {}, url: r, coordinationValues: i } = e, { loaders: o = [], meta: s = [] } = n, a = [], A = [];
    return s.forEach((l, c) => {
      l?.metadata?.isBitmask && (a.push(o[c]), A.push(s[c]));
    }), i?.spatialImageLayer || console.warn("Could not initialize coordinationValues.spatialImageLayer in RasterJsonAsObsSegmentationsLoader. This may be an indicator that the image could not be loaded."), new Si(a.length > 0 && A.length > 0 ? {
      obsSegmentationsType: "bitmask",
      obsSegmentations: { loaders: a, meta: A }
    } : null, r, {
      // Filter coordinationValues, keeping only bitmask layers.
      spatialSegmentationLayer: i?.spatialImageLayer?.filter((l) => l.type === "bitmask").map((l) => ({
        ...l,
        index: A.findIndex((c) => c.name === s[l.index].name)
      }))
    });
  }
}
class Yy {
  constructor({ url: e, requestInit: n, store: r }) {
    r ? this.storeRoot = Wfe(r) : this.storeRoot = Nre(e, n);
  }
  getStoreRoot(e) {
    return this.storeRoot.resolve(e);
  }
  /**
   * Class method for decoding json from the store.
   * @param {string} key A path to the item.
   * @returns {Promise} This async function returns a promise
   * that resolves to the parsed JSON if successful.
   * @throws This may throw an error.
   */
  async getJson(e, n = null) {
    const { storeRoot: r } = this, i = n || r;
    let o = e;
    return (e.endsWith(".zattrs") || e.endsWith(".zarray") || e.endsWith(".zgroup")) && (o = e.substring(0, e.length - 8)), (await fs(i.resolve(o))).attrs;
  }
}
function pNr(t) {
  const e = t.split("/");
  return e.pop(), e.join("/");
}
class cg extends Yy {
  constructor(...e) {
    super(...e), this.promises = /* @__PURE__ */ new Map();
  }
  loadObsColumns(e) {
    return this._loadColumns(e);
  }
  loadVarColumns(e) {
    return this._loadColumns(e);
  }
  /**
   * Class method for loading obs variables.
   * Takes the location as an argument because this is shared across objects,
   * which have different ways of specifying location.
   * @param {string[]} paths An array of strings like "obs/leiden" or "obs/bulk_labels."
   * @returns {Promise} A promise for an array of ids with one per cell.
   */
  _loadColumns(e) {
    const n = e.map((r) => {
      const i = (o) => {
        if (!this.promises.has(o)) {
          const s = this._loadColumn(o).catch((a) => {
            throw this.promises.delete(o), a;
          });
          this.promises.set(o, s);
        }
        return this.promises.get(o);
      };
      return r ? Array.isArray(r) ? Promise.resolve(Promise.all(r.map(i))) : i(r) : Promise.resolve(void 0);
    });
    return Promise.all(n);
  }
  async _loadColumn(e) {
    const { storeRoot: n } = this, r = pNr(e), { categories: i, "encoding-type": o } = await this.getJson(`${e}/.zattrs`);
    let s, a;
    if (i) {
      const { dtype: f } = await fs(n.resolve(`/${r}/${i}`));
      f === "v2:object" && (s = await this.getFlatArrDecompressed(`/${r}/${i}`));
    } else if (o === "categorical") {
      const { dtype: f } = await fs(n.resolve(`/${e}/categories`));
      f === "v2:object" && (s = await this.getFlatArrDecompressed(`/${e}/categories`)), a = `/${e}/codes`;
    } else {
      const { dtype: f } = await fs(n.resolve(`/${e}`));
      if (f === "v2:object")
        return this.getFlatArrDecompressed(e);
    }
    const A = await fs(n.resolve(a || e), { kind: "array" }), l = await Sp(A, [null]), { data: c } = l;
    return Array.from(c).map((f) => s ? s[f] : String(f));
  }
  /**
   * Class method for loading general numeric arrays.
   * @param {string} path A string like obsm.X_pca.
   * @returns {Promise} A promise for a zarr array containing the data.
   */
  loadNumeric(e) {
    const { storeRoot: n } = this;
    return fs(n.resolve(e), { kind: "array" }).then((r) => Sp(r));
  }
  /**
   * Class method for loading specific columns of numeric arrays.
   * @param {string} path A string like obsm.X_pca.
   * @param {number[]} dims The column indices to load.
   * @returns {Promise} A promise for a zarr array containing the data.
   */
  loadNumericForDims(e, n) {
    const { storeRoot: r } = this, i = fs(r.resolve(e), { kind: "array" });
    return Promise.all(n.map((o) => i.then((s) => Sp(s, [null, o])))).then((o) => ({
      data: o.map((s) => s.data),
      shape: [n.length, o[0].shape[0]]
    }));
  }
  /**
   * A common method for loading flattened data
   * i.e that which has shape [n] where n is a natural number.
   * @param {string} path A path to a flat array location, like obs/_index
   * @returns {Array} The data from the zarr array.
   */
  async getFlatArrDecompressed(e) {
    const { storeRoot: n } = this, r = await fs(n.resolve(e), { kind: "array" }), i = await Sp(r);
    return i.data?.[Symbol.iterator] ? Array.from(i.data) : i.data;
  }
  /**
   * Class method for loading the obs index.
   * @returns {Promise} An promise for a zarr array containing the indices.
   */
  loadObsIndex() {
    return this.obsIndex ? this.obsIndex : (this.obsIndex = this.getJson("obs/.zattrs").then(({ _index: e }) => this.getFlatArrDecompressed(`/obs/${e}`)), this.obsIndex);
  }
  /**
   * Class method for loading the var index.
   * @returns {Promise} An promise for a zarr array containing the indices.
   */
  loadVarIndex() {
    return this.varIndex ? this.varIndex : (this.varIndex = this.getJson("var/.zattrs").then(({ _index: e }) => this.getFlatArrDecompressed(`/var/${e}`)), this.varIndex);
  }
  /**
   * Class method for loading the var alias.
   * @returns {Promise} An promise for a zarr array containing the aliased names.
   */
  async loadVarAlias(e) {
    if (this.varAlias)
      return this.varAlias;
    [this.varAlias] = await this.loadVarColumns([e]);
    const n = await this.loadVarIndex();
    return this.varAlias = this.varAlias.map((r, i) => r ? r.concat(` (${n[i]})`) : n[i]), this.varAlias;
  }
  async _loadAttrs(e) {
    return this.getJson(`${e}/.zattrs`);
  }
  async _loadString(e) {
    const { storeRoot: n } = this, { "encoding-type": r, "encoding-version": i } = await this._loadAttrs(e);
    if (r === "string" && i === "0.2.0") {
      const o = await fs(n.resolve(e), { kind: "array" }), { data: s } = await o.getChunk([]);
      return s.get(0);
    }
    throw new Error(`Unsupported encoding type ${r} and version ${i} in AnnDataSource._loadString`);
  }
  async _loadStringArray(e) {
    const { "encoding-type": n, "encoding-version": r } = await this._loadAttrs(e);
    if (n === "string-array" && r === "0.2.0")
      return this.getFlatArrDecompressed(e);
    throw new Error(`Unsupported encoding type ${n} and version ${r} in AnnDataSource._loadStringArray`);
  }
  async _loadElement(e) {
    const { "encoding-type": n } = await this._loadAttrs(e);
    return n === "string" ? this._loadString(e) : n === "string-array" ? this._loadStringArray(e) : null;
  }
  async _loadDict(e, n) {
    const { "encoding-type": r, "encoding-version": i } = await this._loadAttrs(e);
    if (r === "dict" && i === "0.1.0") {
      const o = {};
      return await Promise.all(n.map(async (s) => {
        const a = await this._loadElement(`${e}/${s}`);
        o[s] = a;
      })), o;
    }
    throw new Error(`Unsupported encoding type ${r} and version ${i} in AnnDataSource._loadDict`);
  }
}
const INr = /^mod\/([^/]*)\/(.*)$/;
function sct(t) {
  if (t) {
    const e = t.match(INr);
    if (e && e.length === 3)
      return `mod/${e[1]}/`;
  }
  return "";
}
function mNr(t) {
  return `${sct(t)}obs`;
}
function CNr(t) {
  return `${sct(t)}var`;
}
class H0 extends cg {
  /**
   * Class method for loading the obs index.
   * @returns {Promise} An promise for a zarr array containing the indices.
   */
  loadObsIndex(e = null) {
    this.obsIndex || (this.obsIndex = {});
    const n = mNr(e);
    return this.obsIndex[n] ? this.obsIndex[n] : (this.obsIndex[n] = this.getJson(`${n}/.zattrs`).then(({ _index: r }) => this.getFlatArrDecompressed(`${n}/${r}`)), this.obsIndex[n]);
  }
  /**
   * Class method for loading the var index.
   * @returns {Promise} An promise for a zarr array containing the indices.
   */
  loadVarIndex(e = null) {
    this.varIndex || (this.varIndex = {});
    const n = CNr(e);
    return this.varIndex[n] ? this.varIndex[n] : (this.varIndex[n] = this.getJson(`${n}/.zattrs`).then(({ _index: r }) => this.getFlatArrDecompressed(`${n}/${r}`)), this.varIndex[n]);
  }
  /**
   * Class method for loading the var alias.
   * @returns {Promise} An promise for a zarr array containing the aliased names.
   */
  async loadVarAlias(e, n) {
    if (this.varAlias || (this.varAlias = {}), this.varAlias[e])
      return this.varAlias[e];
    const [r] = await this.loadVarColumns([e]);
    this.varAlias[e] = r;
    const i = await this.loadVarIndex(n);
    return this.varAlias[e] = this.varAlias[e].map((o, s) => o ? o.concat(` (${i[s]})`) : i[s]), this.varAlias[e];
  }
}
const ENr = /^table\/([^/]*)\/(.*)$/;
function qIe(t) {
  if (t) {
    const e = t.match(ENr);
    if (e && e.length === 3)
      return `table/${e[1]}/`;
  }
  return "table/table/";
}
function yNr(t) {
  return `${qIe(t)}obs`;
}
function vNr(t) {
  return `${qIe(t)}var`;
}
class I3e extends cg {
  async loadSpatialDataAttrs(e) {
    return this._loadDict(`${e}uns/spatialdata_attrs`, ["instance_key", "region", "region_key"]);
  }
  /**
   * Class method for loading the obs index.
   * @returns {Promise} An promise for a zarr array containing the indices.
   */
  async loadObsIndex(e = null) {
    this.obsIndex || (this.obsIndex = {});
    const n = yNr(e), { _index: r } = await this.getJson(`${n}/.zattrs`);
    let i = `${n}/${r}`;
    const {
      instance_key: o
      // TODO: filter table index by region and element type.
      // region_key: regionKey,
      // region,
    } = await this.loadSpatialDataAttrs(qIe(e));
    return i = `${n}/${o}`, this.obsIndex[i] ? this.obsIndex[i] : (this.obsIndex[i] = this._loadColumn(i), this.obsIndex[i]);
  }
  /**
   * Class method for loading the var index.
   * @returns {Promise} An promise for a zarr array containing the indices.
   */
  loadVarIndex(e = null) {
    this.varIndex || (this.varIndex = {});
    const n = vNr(e);
    return this.varIndex[n] ? this.varIndex[n] : (this.varIndex[n] = this.getJson(`${n}/.zattrs`).then(({ _index: r }) => this.getFlatArrDecompressed(`${n}/${r}`)), this.varIndex[n]);
  }
  /**
   * Class method for loading the var alias.
   * @returns {Promise} An promise for a zarr array containing the aliased names.
   */
  async loadVarAlias(e, n) {
    if (this.varAlias || (this.varAlias = {}), this.varAlias[e])
      return this.varAlias[e];
    const [r] = await this.loadVarColumns([e]);
    this.varAlias[e] = r;
    const i = await this.loadVarIndex(n);
    return this.varAlias[e] = this.varAlias[e].map((o, s) => o ? o.concat(` (${i[s]})`) : i[s]), this.varAlias[e];
  }
}
const BNr = /^shapes\/([^/]*)\/(.*)$/;
function act(t) {
  if (t) {
    const e = t.match(BNr);
    if (e && e.length === 3)
      return `shapes/${e[1]}/`;
  }
  return "";
}
function bNr(t) {
  return `${act(t)}Index`;
}
function _Nr(t) {
  return `${act(t)}var`;
}
class m3e extends cg {
  async loadSpatialDataAttrs(e) {
    return this._loadDict(`${e}/uns/spatialdata_attrs`, ["instance_key", "region", "region_key"]);
  }
  /**
   * Class method for loading the obs index.
   * @returns {Promise} An promise for a zarr array containing the indices.
   */
  async loadObsIndex(e = null, n = null) {
    this.obsIndex || (this.obsIndex = {});
    let r = bNr(e);
    if (n) {
      const i = `${n}/obs`, { _index: o } = await this.getJson(`${i}/.zattrs`);
      r = `${i}/${o}`;
      const {
        instance_key: s
        // TODO: filter table index by region and element type.
        // region_key: regionKey,
        // region,
      } = await this.loadSpatialDataAttrs(n);
      r = `${i}/${s}`;
    }
    return this.obsIndex[r] ? this.obsIndex[r] : (this.obsIndex[r] = this._loadColumn(r), this.obsIndex[r]);
  }
  /**
   * Class method for loading the var index.
   * @returns {Promise} An promise for a zarr array containing the indices.
   */
  loadVarIndex(e = null) {
    this.varIndex || (this.varIndex = {});
    const n = _Nr(e);
    return this.varIndex[n] ? this.varIndex[n] : (this.varIndex[n] = this.getJson(`${n}/.zattrs`).then(({ _index: r }) => this.getFlatArrDecompressed(`${n}/${r}`)), this.varIndex[n]);
  }
  /**
   * Class method for loading the var alias.
   * @returns {Promise} An promise for a zarr array containing the aliased names.
   */
  async loadVarAlias(e, n) {
    if (this.varAlias || (this.varAlias = {}), this.varAlias[e])
      return this.varAlias[e];
    const [r] = await this.loadVarColumns([e]);
    this.varAlias[e] = r;
    const i = await this.loadVarIndex(n);
    return this.varAlias[e] = this.varAlias[e].map((o, s) => o ? o.concat(` (${i[s]})`) : i[s]), this.varAlias[e];
  }
}
class SNr extends gc {
  async loadAttrs() {
    return this.attrs ? this.attrs : (this.attrs = {
      data: await this.dataSource.getJson(".zattrs"),
      url: null
    }, this.attrs);
  }
  async loadArr() {
    const { storeRoot: e } = this.dataSource;
    if (this.arr)
      return this.arr;
    const n = await fs(e, { kind: "array" });
    return this.arr = await hC(n).getRaw([null, null]), this.arr;
  }
  load() {
    return Promise.all([this.loadAttrs(), this.loadArr()]).then(([e, n]) => Promise.resolve(new Si({ obsIndex: e.data.rows, featureIndex: e.data.cols, obsFeatureMatrix: n }, null)));
  }
}
const cR = (t) => ({ data: t }), QNr = (t) => {
  const e = t.length, n = t[0].length, { BYTES_PER_ELEMENT: r } = t[0], i = new DataView(new ArrayBuffer(e * n * r)), o = t[0].constructor, s = o.name.replace("Array", "");
  for (let a = 0; a < e; a += 1)
    for (let A = 0; A < n; A += 1)
      i[`set${s}`](r * (A * e + a), t[a][A], !0);
  return new o(i.buffer);
};
class TX extends gc {
  getOptions() {
    return this.options;
  }
  /**
   * Class method for loading the genes list from AnnData.var,
   * filtered if a there is a `geneFilterZarr` present in the view config.
   * @returns {Promise} A promise for the zarr array contianing the gene names.
   */
  async loadFilteredGeneNames() {
    if (this.filteredGeneNames)
      return this.filteredGeneNames;
    const { path: e, featureFilterPath: n, geneAlias: r } = this.getOptions(), i = async () => {
      if (!n)
        return (a) => a;
      const s = await this.dataSource.getFlatArrDecompressed(n);
      return (a) => a.filter((A, l) => s[l]);
    }, o = r ? this.dataSource.loadVarAlias(r, e) : this.dataSource.loadVarIndex(e);
    return this.filteredGeneNames = Promise.all([
      o,
      i()
    ]).then(([s, a]) => a(s)), this.filteredGeneNames;
  }
  /**
   * Class method for loading a filtered subset of the genes list
   * @param {String} filterZarr A location in the zarr store to fetch a boolean array from.
   * @returns {Array} A list of filtered genes.
   */
  async _getFilteredGenes(e) {
    const n = await this.dataSource.getFlatArrDecompressed(e);
    return (await this.loadFilteredGeneNames()).filter((o, s) => n[s]);
  }
  /**
   * Class method for getting the integer indices of a selection of genes within a list.
   * @param {Array} selection A list of gene names.
   * @returns {Array} A list of integer indices.
   */
  async _getGeneIndices(e) {
    const n = await this.loadFilteredGeneNames();
    return e.map((r) => n.indexOf(r));
  }
  /**
   * Class method for getting the number of cells i.e entries in `obs`.
   * @returns {Number} The number of cells.
   */
  async _getNumCells() {
    const { path: e } = this.getOptions();
    return (await this.dataSource.loadObsIndex(e)).length;
  }
  /**
   * Class method for getting the number of genes i.e entries in `var`,
   * potentially filtered by `genesFilter`.
   * @returns {Number} The number of genes.
   */
  async _getNumGenes() {
    return (await this.loadFilteredGeneNames()).length;
  }
  /**
   * Class method for opening the sparse matrix arrays in zarr.
   * @returns {Array} A list of promises pointing to the indptr, indices, and data of the matrix.
   */
  async _openSparseArrays() {
    const { path: e } = this.getOptions(), { storeRoot: n } = this.dataSource;
    return this.sparseArrays ? this.sparseArrays : (this.sparseArrays = Promise.all(["indptr", "indices", "data"].map((r) => fs(n.resolve(`${e}/${r}`), { kind: "array" }))), this.sparseArrays);
  }
  /**
   * Class method for loading a gene selection from a CSC matrix.
   * @param {Array} selection A list of gene names whose data should be fetched.
   * @returns {Promise} A Promise.all array of promises containing Uint8Arrays, one per selection.
   */
  async _loadCSCGeneSelection(e) {
    const n = await this._getGeneIndices(e), [r, i, o] = await this._openSparseArrays(), s = await this._getNumCells(), { data: a } = await hC(r).getRaw(null);
    return Promise.all(n.map(async (A) => {
      const l = a[A], c = a[A + 1], u = l === c, f = new Float32Array(s).fill(0);
      if (u)
        return f;
      const { data: h } = await Sp(i, [
        pB(l, c)
      ]), { data: d } = await Sp(o, [
        pB(l, c)
      ]);
      for (let I = 0; I < h.length; I += 1)
        f[h[I]] = d[I];
      return f;
    }));
  }
  /**
   * Class method for loading a gene selection from a CSR matrix.
   * @param {Array} selection A list of gene names whose data should be fetched.
   * @returns {Promise} A Promise.all array of promises containing Uint8Arrays, one per selection.
   */
  async _loadCSRGeneSelection(e) {
    const n = await this._getGeneIndices(e), r = await this._getNumGenes(), i = await this._getNumCells(), o = await this._loadCSRSparseCellXGene();
    return n.map((s) => {
      const a = new Float32Array(i).fill(0);
      for (let A = 0; A < i; A += 1)
        a[A] = o[A * r + s];
      return a;
    });
  }
  /**
   * Class method for loading row oriented (CSR) sparse data from zarr.
   *
   * @returns {Object} A { data: Float32Array } contianing the CellXGene matrix.
   */
  async _loadCSRSparseCellXGene() {
    return this._sparseMatrix ? this._sparseMatrix : (this._sparseMatrix = this._openSparseArrays().then(async (e) => {
      const { path: n } = this.getOptions(), { shape: r } = await this.dataSource.getJson(`${n}/.zattrs`), [i, o, s] = await Promise.all(e.map(async (l) => {
        const { data: c } = await hC(l).getRaw(null);
        return c;
      })), a = new Float32Array(r[0] * r[1]).fill(0);
      let A = 0;
      return i.forEach((l, c) => {
        const u = i[c], f = i[c + 1];
        for (let h = u; h < f; h += 1) {
          const d = s[h], I = o[h];
          a[A * r[1] + I] = d;
        }
        A += 1;
      }), a;
    }), this._sparseMatrix);
  }
  /**
   * Class method for loading column oriented (CSC) sparse data from zarr.
   * @returns {Object} A { data: Float32Array } contianing the CellXGene matrix.
   */
  async _loadCSCSparseCellXGene() {
    return this._sparseMatrix ? this._sparseMatrix : (this._sparseMatrix = this._openSparseArrays().then(async (e) => {
      const { path: n } = this.getOptions(), { shape: r } = await this.dataSource.getJson(`${n}/.zattrs`), [i, o, s] = await Promise.all(e.map(async (l) => {
        const { data: c } = await hC(l).getRaw(null);
        return c;
      })), a = new Float32Array(r[0] * r[1]).fill(0);
      let A = 0;
      return i.forEach((l, c) => {
        const u = i[c], f = i[c + 1];
        for (let h = u; h < f; h += 1) {
          const d = s[h], I = o[h];
          a[I * r[1] + A] = d;
        }
        A += 1;
      }), a;
    }), this._sparseMatrix);
  }
  /**
   * Class method for loading the cell x gene matrix.
   * @returns {Promise} A promise for the zarr array contianing the cell x gene data.
   */
  async loadCellXGene() {
    const { storeRoot: e } = this.dataSource;
    if (this.cellXGene)
      return this.cellXGene;
    const { path: n, initialFeatureFilterPath: r } = this.getOptions();
    this._matrixZattrs || (this._matrixZattrs = await this.dataSource.getJson(`${n}/.zattrs`));
    const i = this._matrixZattrs["encoding-type"];
    if (!r)
      i === "csr_matrix" ? this.cellXGene = this._loadCSRSparseCellXGene().then((o) => cR(o)) : i === "csc_matrix" ? this.cellXGene = this._loadCSCSparseCellXGene().then((o) => cR(o)) : (this.arr || (this.arr = fs(e.resolve(n), { kind: "array" })), this.cellXGene = this.arr.then((o) => hC(o).getRaw(null)).then(({ data: o }) => cR(o)));
    else if (i === "csr_matrix")
      this.cellXGene = this._loadCSRSparseCellXGene().then(async (o) => {
        const s = await this._getFilteredGenes(r), a = s.length, A = await this.loadFilteredGeneNames(), l = A.length, c = await this._getNumCells(), u = new Float32Array(c * a).fill(0);
        for (let f = 0; f < a; f += 1) {
          const h = A.indexOf(s[f]);
          for (let d = 0; d < c; d += 1)
            u[d * a + f] = o[d * l + h];
        }
        return cR(u);
      });
    else {
      const o = await this._getFilteredGenes(r);
      this.cellXGene = this.loadGeneSelection({ selection: o }).then(({ data: s }) => cR(QNr(s)));
    }
    return this.cellXGene;
  }
  /**
   * Class method for loading a gene selection.
   * @param {Object} args
   * @param {Array} args.selection A list of gene names whose data should be fetched.
   * @returns {Object} { data } containing an array of gene expression data.
   */
  async loadGeneSelection({ selection: e }) {
    const { path: n } = this.getOptions(), { storeRoot: r } = this.dataSource;
    this._matrixZattrs || (this._matrixZattrs = await this.dataSource.getJson(`${n}/.zattrs`));
    const i = this._matrixZattrs["encoding-type"];
    let o;
    if (i === "csc_matrix")
      o = await this._loadCSCGeneSelection(e);
    else if (i === "csr_matrix")
      o = await this._loadCSRGeneSelection(e);
    else {
      this.arr || (this.arr = fs(r.resolve(n), { kind: "array" }));
      const s = await this._getGeneIndices(e);
      o = await Promise.all(s.map((a) => this.arr.then((A) => Sp(A, [null, a])).then(({ data: A }) => A)));
    }
    return { data: o, url: null };
  }
  /**
   * Class method for loading only attributes i.e rows and columns
   * @param {Array} selection A list of gene names whose data should be fetched.
   * @returns {Object} { data: { rows, cols }, url } containing row and col labels for the matrix.
   */
  loadAttrs() {
    const { path: e } = this.getOptions();
    return Promise.all([this.dataSource.loadObsIndex(e), this.loadFilteredGeneNames()]).then((n) => {
      const [r, i] = n;
      return {
        data: { rows: r, cols: i },
        url: null
      };
    });
  }
  async loadInitialFilteredGeneNames() {
    const e = await this.loadFilteredGeneNames(), { initialFeatureFilterPath: n } = this.getOptions();
    if (n) {
      const r = await this.dataSource.getFlatArrDecompressed(n);
      return e.filter((i, o) => r[o]);
    }
    return e;
  }
  async load() {
    const { path: e } = this.getOptions(), n = await super.load().catch((r) => Promise.resolve(r));
    return n instanceof Ei ? Promise.reject(n) : Promise.all([
      this.dataSource.loadObsIndex(e),
      this.loadInitialFilteredGeneNames(),
      this.loadCellXGene()
    ]).then(([r, i, o]) => Promise.resolve(new Si({ obsIndex: r, featureIndex: i, obsFeatureMatrix: o }, null)));
  }
}
class C3e extends gc {
  /**
   * Class method for loading embedding coordinates, such as those from UMAP or t-SNE.
   * @returns {Promise} A promise for an array of columns.
   */
  loadEmbedding() {
    const { path: e, dims: n = [0, 1] } = this.options;
    return this.embedding ? this.embedding : this.embedding ? (this.embedding = Promise.resolve(null), this.embedding) : (this.embedding = this.dataSource.loadNumericForDims(e, n), this.embedding);
  }
  async load() {
    const { path: e } = this.options, n = await super.load().catch((r) => Promise.resolve(r));
    return n instanceof Ei ? Promise.reject(n) : Promise.all([
      // Pass in the obsEmbedding path,
      // to handle the MuData case where the obsIndex is located at
      // `mod/rna/index` rather than `index`.
      this.dataSource.loadObsIndex(e),
      this.loadEmbedding()
    ]).then(([r, i]) => Promise.resolve(new Si({ obsIndex: r, obsEmbedding: i }, null)));
  }
}
class E3e extends gc {
  /**
   * Class method for loading embedding coordinates, such as those from UMAP or t-SNE.
   * @returns {Promise} A promise for an array of columns.
   */
  loadSpots() {
    const { path: e, dims: n = [0, 1] } = this.options;
    return this.locations ? this.locations : this.locations ? (this.locations = Promise.resolve(null), this.locations) : (this.locations = this.dataSource.loadNumericForDims(e, n), this.locations);
  }
  async load() {
    const { path: e } = this.options, n = await super.load().catch((i) => Promise.resolve(i));
    if (n instanceof Ei)
      return Promise.reject(n);
    const r = {
      spotLayer: dA({
        obsType: "spot",
        // obsColorEncoding: 'spatialLayerColor',
        // spatialLayerColor: [255, 255, 255],
        spatialLayerVisible: !0,
        spatialLayerOpacity: 1,
        spatialSpotRadius: 10
        // TODO: get this from adata.uns if possible.
        // TODO: spatialSpotRadiusUnit: 'µm' or 'um'
        // after resolving https://github.com/vitessce/vitessce/issues/1760
        // featureValueColormapRange: [0, 1],
        // obsHighlight: null,
        // obsSetColor: null,
        // obsSetSelection: null,
        // additionalObsSets: null,
      })
    };
    return Promise.all([
      this.dataSource.loadObsIndex(e),
      this.loadSpots()
    ]).then(([i, o]) => Promise.resolve(new Si({ obsIndex: i, obsSpots: o }, null, r)));
  }
}
class y3e extends gc {
  /**
   * Class method for loading embedding coordinates, such as those from UMAP or t-SNE.
   * @returns {Promise} A promise for an array of columns.
   */
  loadPoints() {
    const { path: e, dims: n = [0, 1] } = this.options;
    return this.locations ? this.locations : this.locations ? (this.locations = Promise.resolve(null), this.locations) : (this.locations = this.dataSource.loadNumericForDims(e, n), this.locations);
  }
  async load() {
    const { path: e } = this.options, n = await super.load().catch((i) => Promise.resolve(i));
    if (n instanceof Ei)
      return Promise.reject(n);
    const r = {
      pointLayer: dA({
        obsType: "point",
        // obsColorEncoding: 'spatialLayerColor',
        // spatialLayerColor: [255, 255, 255],
        spatialLayerVisible: !0,
        spatialLayerOpacity: 1
        // TODO: support a point radius?
        // featureValueColormapRange: [0, 1],
        // obsHighlight: null,
        // obsSetColor: null,
        // obsSetSelection: null,
        // additionalObsSets: null,
        // obsLabelsType: null,
      })
    };
    return Promise.all([
      this.dataSource.loadObsIndex(e),
      this.loadPoints()
    ]).then(([i, o]) => Promise.resolve(new Si({ obsIndex: i, obsPoints: o }, null, r)));
  }
}
class v3e extends gc {
  /**
   * Class method for loading embedding coordinates, such as those from UMAP or t-SNE.
   * @returns {Promise} A promise for an array of columns.
   */
  loadLocations() {
    const { path: e, dims: n = [0, 1] } = this.options;
    return this.locations ? this.locations : this.locations ? (this.locations = Promise.resolve(null), this.locations) : (this.locations = this.dataSource.loadNumericForDims(e, n), this.locations);
  }
  async load() {
    const { path: e } = this.options, n = await super.load().catch((r) => Promise.resolve(r));
    return n instanceof Ei ? Promise.reject(n) : Promise.all([
      this.dataSource.loadObsIndex(e),
      this.loadLocations()
    ]).then(([r, i]) => Promise.resolve(new Si({ obsIndex: r, obsLocations: i }, null)));
  }
}
class NX extends gc {
  /**
   * Class method for loading embedding coordinates, such as those from UMAP or t-SNE.
   * @returns {Promise} A promise for an array of columns.
   */
  async loadSegmentations() {
    const { path: e } = this.options;
    if (this.segmentations)
      return this.segmentations;
    if (!this.segmentations) {
      const n = await this.dataSource.loadNumeric(e), { stride: r, shape: i, data: o } = n, s = [];
      let a = 0;
      for (let A = 0; A < i[0]; A++) {
        const l = [];
        for (let c = 0; c < i[1]; c++)
          a = A * r[0] + c * r[1], l.push([o[a], o[a + 1]]);
        s.push(l);
      }
      return this.segmentations = {
        ...n,
        // Bug introduced from DeckGL v8.6.x to v8.8.x:
        // Polygon vertices cannot be passed via Uint32Arrays, which is how they load via Zarr.
        // For now, a workaround is to cast each vertex to a plain Array.
        data: s
      }, this.segmentations;
    }
    return this.segmentations = Promise.resolve(null), this.segmentations;
  }
  async load() {
    const { path: e } = this.options, n = await super.load().catch((o) => Promise.resolve(o));
    if (n instanceof Ei)
      return Promise.reject(n);
    const r = [{
      // obsType: null,
      spatialChannelColor: [255, 255, 255],
      spatialChannelVisible: !0,
      spatialChannelOpacity: 1,
      spatialChannelWindow: null,
      // featureType: 'feature',
      // featureValueType: 'value',
      obsColorEncoding: "spatialChannelColor",
      spatialSegmentationFilled: !0,
      spatialSegmentationStrokeWidth: 1,
      obsHighlight: null
    }], i = {
      // Old
      spatialSegmentationLayer: qWe,
      // New
      // spatialTargetZ: imageWrapper.getDefaultTargetZ(),
      // spatialTargetT: imageWrapper.getDefaultTargetT(),
      segmentationLayer: dA([
        {
          fileUid: this.coordinationValues?.fileUid || null,
          spatialLayerOpacity: 1,
          spatialLayerVisible: !0,
          segmentationChannel: dA(r)
        }
      ])
    };
    return Promise.all([
      this.dataSource.loadObsIndex(e),
      this.loadSegmentations()
    ]).then(([o, s]) => Promise.resolve(new Si({
      obsIndex: o,
      obsSegmentations: s,
      obsSegmentationsType: "polygon"
    }, null, i)));
  }
}
class tse extends gc {
  loadObsIndices() {
    const { options: e } = this, n = e.map(({ path: r }) => r).map((r) => Array.isArray(r) ? r.length > 0 ? this.dataSource.loadObsIndex(r[0]) : this.dataSource.loadObsIndex() : this.dataSource.loadObsIndex(r));
    return Promise.all(n);
  }
  loadCellSetIds() {
    const { options: e } = this, n = e.map(({ path: r }) => r);
    return this.dataSource.loadObsColumns(n);
  }
  loadCellSetScores() {
    const { options: e } = this, n = e.map((r) => r.scorePath || void 0);
    return this.dataSource.loadObsColumns(n);
  }
  async load() {
    const e = await super.load().catch((c) => Promise.resolve(c));
    if (e instanceof Ei)
      return Promise.reject(e);
    if (!this.cachedResult) {
      const { options: c } = this;
      this.cachedResult = Promise.all([
        this.dataSource.loadObsIndex(),
        this.loadObsIndices(),
        this.loadCellSetIds(),
        this.loadCellSetScores()
      ]).then((u) => [u[0], D5e([u[1], u[2], u[3]], c)]);
    }
    const [n, r] = await this.cachedResult, i = sAe(r), o = {}, { tree: s } = r, a = s[0].name, A = s[0].children.map((c) => [
      a,
      c.name
    ]), l = y9(r, []);
    return o.obsSetSelection = A, o.obsSetColor = l, Promise.resolve(new Si({ obsIndex: n, obsSets: r, obsSetsMembership: i }, null, o));
  }
}
class B3e extends gc {
  /**
   * Class method for loading observation string labels.
   * @returns {Promise} A promise for the array.
   */
  loadLabels() {
    const { path: e } = this.options;
    return this.labels ? this.labels : this.labels ? (this.labels = Promise.resolve(null), this.labels) : (this.labels = this.dataSource._loadColumn(e), this.labels);
  }
  async load() {
    const { path: e } = this.options, n = await super.load().catch((r) => Promise.resolve(r));
    return n instanceof Ei ? Promise.reject(n) : Promise.all([
      this.dataSource.loadObsIndex(e),
      this.loadLabels()
    ]).then(([r, i]) => Promise.resolve(new Si({ obsIndex: r, obsLabels: i }, null)));
  }
}
class b3e extends gc {
  /**
   * Class method for loading feature string labels.
   * @returns {Promise} A promise for the array.
   */
  loadLabels() {
    const { path: e } = this.options;
    return this.labels ? this.labels : this.labels ? (this.labels = Promise.resolve(null), this.labels) : (this.labels = this.dataSource._loadColumn(e), this.labels);
  }
  async load() {
    const { path: e } = this.options, n = await super.load().catch((r) => Promise.resolve(r));
    return n instanceof Ei ? Promise.reject(n) : Promise.all([
      // Pass in the obsEmbedding path,
      // to handle the MuData case where the obsIndex is located at
      // `mod/rna/index` rather than `index`.
      this.dataSource.loadVarIndex(e),
      this.loadLabels()
    ]).then(([r, i]) => Promise.resolve(new Si({
      featureIndex: r,
      featureLabels: i,
      featureLabelsMap: new Map(r.map((o, s) => [o, i[s]]))
    }, null)));
  }
}
class jIe {
  constructor(e, n) {
    Sr(this, "vivLoader");
    Sr(this, "options");
    this.options = n || {}, this.vivLoader = e;
  }
  getType() {
    if ("Pixels" in this.vivLoader.metadata)
      return "ome-tiff";
    if ("omero" in this.vivLoader.metadata)
      return "ome-zarr";
    throw new Error("Unknown image type.");
  }
  hasPhysicalSize() {
    if ("Pixels" in this.vivLoader.metadata) {
      const { Pixels: { PhysicalSizeX: e, PhysicalSizeXUnit: n, PhysicalSizeY: r, PhysicalSizeYUnit: i } } = this.vivLoader.metadata;
      return !!(e && n && r && i);
    }
    return !0;
  }
  getData() {
    return this.vivLoader.data;
  }
  getModelMatrix() {
    const { coordinateTransformations: e } = this.options;
    if ("multiscales" in this.vivLoader.metadata) {
      const { multiscales: [{ coordinateTransformations: n, axes: r }] } = this.vivLoader.metadata, i = Yfe(r), o = EI(e, i);
      return EI(n, i).multiplyLeft(o);
    }
    if ("Pixels" in this.vivLoader.metadata) {
      const { Pixels: { PhysicalSizeX: n, PhysicalSizeXUnit: r, PhysicalSizeY: i, PhysicalSizeYUnit: o, PhysicalSizeZ: s, PhysicalSizeZUnit: a, DimensionOrder: A } } = this.vivLoader.metadata, l = zfe(A), c = EI(e, l);
      return nWn(n, i, s, r, o, a).multiplyLeft(c);
    }
    throw new Error("Unknown image type.");
  }
  getDefaultTargetT() {
    if ("omero" in this.vivLoader.metadata) {
      const { omero: { rdefs: { defaultT: e } } } = this.vivLoader.metadata;
      return e || 0;
    }
    return 0;
  }
  getDefaultTargetZ() {
    if ("omero" in this.vivLoader.metadata) {
      const { omero: { rdefs: { defaultZ: e } } } = this.vivLoader.metadata;
      return e || 0;
    }
    return 0;
  }
  getName() {
    let e;
    if ("Pixels" in this.vivLoader.metadata) {
      const { Name: n } = this.vivLoader.metadata;
      e = n;
    }
    if ("omero" in this.vivLoader.metadata) {
      const { omero: { name: n } } = this.vivLoader.metadata;
      e = n;
    }
    return e || (e = "Image"), e;
  }
  getNumChannels() {
    if ("image-label" in this.vivLoader.metadata)
      return 1;
    if ("channels_metadata" in this.vivLoader.metadata) {
      const { channels_metadata: e } = this.vivLoader.metadata;
      return e?.channels.length || 0;
    }
    if ("omero" in this.vivLoader.metadata) {
      const { omero: { channels: e } } = this.vivLoader.metadata;
      return e.length;
    }
    if ("Pixels" in this.vivLoader.metadata) {
      const { Pixels: { Channels: e } } = this.vivLoader.metadata;
      return e.length;
    }
    return 0;
  }
  getChannelNames() {
    if ("Pixels" in this.vivLoader.metadata) {
      const { Pixels: { Channels: e } } = this.vivLoader.metadata;
      return e.map((n, r) => n.Name || `Channel ${r}`);
    }
    if ("image-label" in this.vivLoader.metadata)
      return ["labels"];
    if ("channels_metadata" in this.vivLoader.metadata) {
      const { channels_metadata: e } = this.vivLoader.metadata;
      if (e && Array.isArray(e?.channels))
        return e.channels.map((n) => `Channel ${n.label}`);
    }
    if ("omero" in this.vivLoader.metadata) {
      const { omero: { channels: e } } = this.vivLoader.metadata;
      return e.map((n, r) => n.label || `Channel ${r}`);
    }
    return [];
  }
  // TODO: support passing a custom color palette array.
  getChannelObjects() {
    if ("image-label" in this.vivLoader.metadata)
      return [{
        name: "labels",
        defaultColor: [255, 255, 255],
        defaultWindow: [0, 255],
        autoDefaultColor: [0, 0, 0]
      }];
    if ("channels_metadata" in this.vivLoader.metadata) {
      const { channels_metadata: e } = this.vivLoader.metadata;
      if (e && Array.isArray(e?.channels))
        return e.channels.map((n, r) => ({
          name: `Channel ${n.label}`,
          defaultColor: void 0,
          defaultWindow: void 0,
          autoDefaultColor: Y0[r % Y0.length]
        }));
    }
    if ("omero" in this.vivLoader.metadata) {
      const { omero: { channels: e } } = this.vivLoader.metadata;
      return e.map((n, r) => ({
        name: n.label || `Channel ${r}`,
        defaultColor: n.color ? jWe(n.color) : void 0,
        defaultWindow: n.window ? [n.window.start, n.window.end] : void 0,
        autoDefaultColor: Y0[r % Y0.length]
      }));
    }
    if ("Pixels" in this.vivLoader.metadata) {
      const { Pixels: { Channels: e } } = this.vivLoader.metadata;
      return e.map((n, r) => ({
        name: n.Name || `Channel ${r}`,
        defaultColor: n.Color ? n.Color : void 0,
        defaultWindow: void 0,
        autoDefaultColor: Y0[r % Y0.length]
      }));
    }
    return [];
  }
  getDtype() {
    const e = this.vivLoader, n = I1(e);
    if ("dtype" in n)
      return n.dtype;
  }
  hasZStack() {
    const e = this.vivLoader, { labels: n, shape: r } = Array.isArray(e.data) ? e.data[0] : e.data;
    return r[n.indexOf("z")] > 1;
  }
  hasTStack() {
    const e = this.vivLoader, { labels: n, shape: r } = Array.isArray(e.data) ? e.data[0] : e.data;
    return r[n.indexOf("t")] > 1;
  }
  getNumZ() {
    const e = this.vivLoader, { labels: n, shape: r } = Array.isArray(e.data) ? e.data[0] : e.data;
    return r[n.indexOf("z")];
  }
  getNumT() {
    const e = this.vivLoader, { labels: n, shape: r } = Array.isArray(e.data) ? e.data[0] : e.data;
    return r[n.indexOf("t")];
  }
  isMultiResolution() {
    const e = this.vivLoader;
    return !!Array.from({
      length: e.data.length
    }).filter((r, i) => uQ(e.data, i)).length;
  }
  getMultiResolutionStats() {
    const e = this.vivLoader;
    return Array.from({ length: e.data.length }).fill(0).map((n, r) => {
      const { height: i, width: o, depthDownsampled: s, totalBytes: a } = qfe(e.data, r);
      return {
        canLoad: uQ(e.data, r),
        height: i,
        width: o,
        depthDownsampled: s,
        totalBytes: a
      };
    });
  }
  /**
   * Compute an index of an array element returned by getMultiResolutionStats()
   * which corresponds to a "good" automatic target resolution to select.
   * In the future, we could make this more sophisticated, for example
   * to take into account the network speed.
   */
  getAutoTargetResolution() {
    const e = this.getMultiResolutionStats();
    if (e.length === 0)
      return null;
    let n = -1, r = 1 / 0;
    do
      n += 1, r = e[n].totalBytes;
    while (r > 5e7 && n < e.length - 1);
    return n;
  }
  getBoundingCube() {
    const e = this.vivLoader, { labels: n, shape: r } = Array.isArray(e.data) ? e.data[0] : e.data, i = this.getModelMatrix(), o = [0, i[0] * r[n.indexOf("x")]], s = [0, i[5] * r[n.indexOf("y")]], a = [
      0,
      i[10] * r[n.indexOf("z")]
    ];
    return [o, s, a];
  }
  isInterleaved() {
    const e = this.vivLoader, { shape: n } = Array.isArray(e.data) ? e.data[0] : e.data;
    return jfe(n);
  }
  getPhotometricInterpretation() {
    const e = this.vivLoader;
    if ("Pixels" in e.metadata) {
      const n = Array.isArray(e.data) ? e.data[0] : e.data;
      if ("meta" in n) {
        const { meta: r } = n;
        if (r && "photometricInterpretation" in r && r.photometricInterpretation === 2)
          return "RGB";
      }
    }
    if ("omero" in e.metadata) {
      const { omero: { rdefs: { model: n } } } = e.metadata;
      if (n === "color")
        return "RGB";
    }
    return "BlackIsZero";
  }
}
class YIe extends gc {
  constructor(e, n) {
    super(e, n), this.storeRoot = this.dataSource.storeRoot;
  }
  async load() {
    const e = await this.dataSource.getJson(".zattrs", this.storeRoot).catch((z) => Promise.resolve(z));
    if (e instanceof Ei)
      return Promise.reject(e);
    const { coordinateTransformations: n } = this.options || {}, r = await XWe(this.storeRoot), i = new jIe(r, this.options), { metadata: o, data: s } = r, { omero: a, multiscales: A, channels_metadata: l, "image-label": c } = o, u = !!l || !!c, f = !!c;
    if (!u && !a)
      return console.error("image.ome-zarr must have omero metadata in attributes."), Promise.reject(e);
    (!Array.isArray(A) || A.length === 0) && console.error("Multiscales array must exist and have at least one element");
    const { datasets: h, coordinateTransformations: d, name: I } = A[0], m = Yfe(A[0].axes), C = sWn(d, h), y = EI(n, m), b = EI(C, m).multiplyLeft(y), Q = (z) => {
      if (s.length > 0) {
        const Y = {}, V = s[0].labels;
        return Object.keys(z).forEach((Z) => {
          V.includes(Z) && (Y[Z] = z[Z]);
        }), Y;
      }
      return z;
    };
    let w, R = [], M = 0, O = 0;
    if (u)
      if (f)
        w = [{
          selection: Q({ z: O, t: M, c: 0 }),
          slider: [0, 255],
          color: [255, 255, 255]
        }], R = ["labels"];
      else {
        const { channels: z } = l;
        w = z.map((Y, V) => ({
          selection: Q({ z: O, t: M, c: V }),
          slider: [0, 255],
          color: [255, 255, 255]
        })), R = z.map((Y) => Y.label);
      }
    else {
      const { rdefs: z, channels: Y } = a;
      typeof z.defaultT == "number" && (M = z.defaultT), typeof z.defaultZ == "number" && (O = z.defaultZ), w = Y.map((V, Z) => ({
        selection: Q({ z: O, t: M, c: Z }),
        slider: [V.window.start, V.window.end],
        color: jWe(V.color)
      })), R = Y.map((V) => V.label);
    }
    const L = [
      {
        name: I || "Image",
        channels: w,
        ...b ? {
          metadata: {
            transform: {
              matrix: b
            }
          }
        } : {},
        loaderCreator: async () => ({ ...r, channels: R })
      }
    ], [N, k, $] = await Kq(L, void 0), X = i.getChannelObjects().slice(0, 5).map((z, Y) => ({
      spatialTargetC: Y,
      spatialChannelColor: (z.defaultColor || z.autoDefaultColor).slice(0, 3),
      spatialChannelVisible: !0,
      spatialChannelOpacity: 1,
      spatialChannelWindow: z.defaultWindow || null
    })), K = {
      // Old
      spatialImageLayer: N,
      // New
      spatialTargetZ: i.getDefaultTargetZ(),
      spatialTargetT: i.getDefaultTargetT(),
      imageLayer: dA([
        {
          fileUid: this.coordinationValues?.fileUid || null,
          spatialLayerOpacity: 1,
          spatialLayerVisible: !0,
          photometricInterpretation: i.getPhotometricInterpretation(),
          volumetricRenderingAlgorithm: "maximumIntensityProjection",
          spatialTargetResolution: null,
          imageChannel: dA(X)
        }
      ])
    };
    return Promise.resolve(new Si({
      image: {
        loaders: k,
        meta: $,
        instance: i
        // TODO: make this the root value of LoaderResult.image.
      },
      featureIndex: i.getChannelNames()
    }, null, K));
  }
}
class wNr extends YIe {
  async load() {
    const { obsTypesFromChannelNames: e } = this.options || {}, n = await super.load(), r = n.data.image.instance, o = r.getChannelObjects().slice(0, 5).map((a, A) => ({
      spatialTargetC: A,
      spatialChannelColor: (a.defaultColor || a.autoDefaultColor).slice(0, 3),
      spatialChannelVisible: !0,
      spatialChannelOpacity: 1,
      spatialChannelWindow: a.defaultWindow || null,
      // featureType: 'feature',
      // featureValueType: 'value',
      obsColorEncoding: "spatialChannelColor",
      spatialSegmentationFilled: !0,
      spatialSegmentationStrokeWidth: 1,
      obsHighlight: null,
      ...e ? { obsType: a.name } : {}
    })), s = {
      spatialTargetZ: r.getDefaultTargetZ(),
      spatialTargetT: r.getDefaultTargetT(),
      segmentationLayer: dA([
        {
          fileUid: this.coordinationValues?.fileUid || null,
          spatialLayerOpacity: 1,
          spatialLayerVisible: !0,
          segmentationChannel: dA(o)
        }
      ])
    };
    return Promise.resolve(new Si({
      obsSegmentationsType: "bitmask",
      obsSegmentations: n.data.image
    }, n.url, s));
  }
}
class Act extends YIe {
  constructor(e, n) {
    super(e, n), this.storeRoot = this.dataSource.getStoreRoot(n.options.path);
  }
}
class xNr extends Act {
  async load() {
    const e = await super.load();
    if (e instanceof Ei)
      return Promise.reject(e);
    e.data = {
      obsSegmentations: e.data.image,
      obsSegmentationsType: "bitmask"
    };
    const n = e.data.obsSegmentations.instance, i = n.getChannelObjects().slice(0, 5).map((s, a) => ({
      spatialTargetC: a,
      // obsType: channelObj.name,
      spatialChannelColor: (s.defaultColor || s.autoDefaultColor).slice(0, 3),
      spatialChannelVisible: !0,
      spatialChannelOpacity: 1,
      spatialChannelWindow: s.defaultWindow || null,
      // featureType: 'feature',
      // featureValueType: 'value',
      obsColorEncoding: "spatialChannelColor",
      spatialSegmentationFilled: !0,
      spatialSegmentationStrokeWidth: 1,
      obsHighlight: null
    })), o = {
      spatialTargetZ: n.getDefaultTargetZ(),
      spatialTargetT: n.getDefaultTargetT(),
      segmentationLayer: dA([
        {
          fileUid: this.coordinationValues?.fileUid || null,
          spatialLayerOpacity: 1,
          spatialLayerVisible: !0,
          segmentationChannel: dA(i)
        }
      ])
    };
    return e.coordinationValues = o, Promise.resolve(e);
  }
}
function _3e(t) {
  return `${t}/coords`;
}
function RNr(t) {
  return `${t}/radius`;
}
class DNr extends gc {
  /**
     * Class method for loading embedding coordinates, such as those from UMAP or t-SNE.
     * @returns {Promise} A promise for an array of columns.
     */
  loadSpots() {
    const { path: e, dims: n = [0, 1] } = this.options;
    return this.locations ? this.locations : this.locations ? (this.locations = Promise.resolve(null), this.locations) : (this.locations = this.dataSource.loadNumericForDims(_3e(e), n), this.locations);
  }
  loadRadius() {
    const { path: e } = this.options;
    return this.radius ? this.radius : this.radius ? (this.radius = Promise.resolve(null), this.radius) : (this.radius = this.dataSource.loadNumeric(RNr(e)), this.radius);
  }
  async load() {
    const { path: e, tablePath: n } = this.options, r = await super.load().catch((i) => Promise.resolve(i));
    return r instanceof Ei ? Promise.reject(r) : Promise.all([
      this.dataSource.loadObsIndex(_3e(e), n),
      this.loadSpots(),
      this.loadRadius()
    ]).then(([i, o, s]) => {
      const a = s?.data?.[0], A = {
        spotLayer: dA({
          obsType: "spot",
          // obsColorEncoding: 'spatialLayerColor',
          // spatialLayerColor: [255, 255, 255],
          spatialLayerVisible: !0,
          spatialLayerOpacity: 1,
          spatialSpotRadius: a
          // TODO: spatialSpotRadiusUnit: 'µm' or 'um'
          // after resolving https://github.com/vitessce/vitessce/issues/1760
          // featureValueColormapRange: [0, 1],
          // obsHighlight: null,
          // obsSetColor: null,
          // obsSetSelection: null,
          // additionalObsSets: null,
        })
      };
      return Promise.resolve(new Si({ obsIndex: i, obsSpots: o }, null, A));
    });
  }
}
class TNr extends tse {
  constructor(e, n) {
    super(e, n), this.region = this.options.region, this.options = this.options.obsSets;
  }
}
class NNr extends gc {
  loadAttrs() {
    return this.attrs ? this.attrs : (this.attrs = this.dataSource.getJson(".zattrs"), this.attrs);
  }
  load() {
    const { url: e } = this;
    return this.loadAttrs().then((n) => Promise.resolve(new Si(n, e)));
  }
}
class S3e {
  constructor({ url: e, requestInit: n }) {
    this.url = e, this.requestInit = n;
  }
}
class lct extends gc {
  async loadOffsets() {
    const { offsetsUrl: e } = this.options || {};
    if (e) {
      const n = await fetch(e, this.requestInit || {});
      if (n.ok)
        return await n.json();
      throw new Error(`OME-TIFF offsets JSON file failed to load: ${n.status} from ${n.url}`);
    }
    return null;
  }
  async load() {
    const { url: e, requestInit: n } = this, { coordinateTransformations: r } = this.options || {}, i = await this.loadOffsets(), o = await q8(e, { offsets: i, headers: n?.headers }), s = new jIe(o, this.options), { Name: a, Pixels: { Channels: A, DimensionOrder: l, PhysicalSizeX: c, PhysicalSizeXUnit: u, PhysicalSizeY: f, PhysicalSizeYUnit: h } } = o.metadata, d = Array.isArray(A) ? A.map((R, M) => R.Name || `Channel ${M}`) : [A.Name || "Channel 0"], I = EI(r, zfe(l)), m = c && u && f && h, C = {
      name: a || "Image",
      url: e,
      type: "ome-tiff",
      ...I ? {
        metadata: {
          transform: {
            matrix: I
          }
        }
      } : {}
    }, y = [
      { url: e, name: C.name }
    ], b = s.getChannelObjects().slice(0, 5).map((R, M) => ({
      spatialTargetC: M,
      spatialChannelColor: (R.defaultColor || R.autoDefaultColor).slice(0, 3),
      spatialChannelVisible: !0,
      spatialChannelOpacity: 1,
      spatialChannelWindow: R.defaultWindow || null
    })), Q = [
      {
        ...C,
        loaderCreator: async () => ({ ...o, channels: d })
      }
    ], w = null;
    return this.autoImageCache || (this.autoImageCache = Kq(Q, w, m)), this.autoImageCache.then((R) => {
      const [M, O, L] = R, N = {
        // Old
        spatialImageLayer: M,
        // New
        spatialTargetZ: s.getDefaultTargetZ(),
        spatialTargetT: s.getDefaultTargetT(),
        imageLayer: dA([
          {
            fileUid: this.coordinationValues?.fileUid || null,
            spatialLayerOpacity: 1,
            spatialLayerVisible: !0,
            photometricInterpretation: s.getPhotometricInterpretation(),
            volumetricRenderingAlgorithm: "maximumIntensityProjection",
            spatialTargetResolution: null,
            imageChannel: dA(b)
          }
        ])
      };
      return new Si({
        image: {
          loaders: O,
          meta: L,
          instance: s
          // TODO: make this the root value of LoaderResult.image.
        },
        featureIndex: s.getChannelNames()
      }, y, N);
    });
  }
}
class LNr extends lct {
  async load() {
    const { url: e, requestInit: n } = this, { coordinateTransformations: r, obsTypesFromChannelNames: i } = this.options || {}, o = await this.loadOffsets(), s = await q8(e, { offsets: o, headers: n?.headers }), a = new jIe(s, this.options), { Name: A, Pixels: { Channels: l, DimensionOrder: c, PhysicalSizeX: u, PhysicalSizeXUnit: f, PhysicalSizeY: h, PhysicalSizeYUnit: d } } = s.metadata, I = EI(r, zfe(c)), m = u && f && h && d, C = {
      name: A || "Image",
      url: e,
      type: "ome-tiff",
      // This load() method is the same as in ./OmeTiffLoader except we specify isBitmask here:
      metadata: {
        isBitmask: !0,
        ...I ? {
          transform: {
            matrix: I
          }
        } : {}
      }
    }, y = [{ url: e, name: C.name }], b = a.getChannelObjects().slice(0, 5).map((R, M) => ({
      spatialTargetC: M,
      spatialChannelColor: (R.defaultColor || R.autoDefaultColor).slice(0, 3),
      spatialChannelVisible: !0,
      spatialChannelOpacity: 1,
      spatialChannelWindow: R.defaultWindow || null,
      // featureType: 'feature',
      // featureValueType: 'value',
      obsColorEncoding: "spatialChannelColor",
      spatialSegmentationFilled: !0,
      spatialSegmentationStrokeWidth: 1,
      obsHighlight: null,
      ...i ? { obsType: R.name } : {}
    })), Q = [
      {
        ...C,
        loaderCreator: async () => {
          const R = Array.isArray(l) ? l.map((M, O) => M.Name || `Channel ${O}`) : [l.Name || "Channel 0"];
          return { ...s, channels: R };
        }
      }
    ], w = null;
    return this.autoImageCache || (this.autoImageCache = Kq(Q, w, m)), this.autoImageCache.then((R) => {
      const [M, O, L] = R, N = {
        // Old
        spatialSegmentationLayer: M,
        // New
        spatialTargetZ: a.getDefaultTargetZ(),
        spatialTargetT: a.getDefaultTargetT(),
        segmentationLayer: dA([
          {
            fileUid: this.coordinationValues?.fileUid || null,
            spatialLayerOpacity: 1,
            spatialLayerVisible: !0,
            segmentationChannel: dA(b)
          }
        ])
      };
      return new Si({
        obsSegmentationsType: "bitmask",
        obsSegmentations: {
          loaders: O,
          meta: L,
          instance: a
          // TODO: make this the root value of LoaderResult.image.
        }
      }, y, N);
    });
  }
}
const cct = [
  "obsType",
  "featureType",
  "featureValueType",
  "featureLabelsType",
  "obsLabelsType",
  "embeddingType"
];
function MNr(t) {
  const e = {
    url: t.url,
    requestInit: t.requestInit,
    coordinationValues: {
      ...t.coordinationValues,
      obsType: t.coordinationValues?.obsType || "cell",
      featureType: t.coordinationValues?.featureType || "gene",
      featureValueType: t.coordinationValues?.featureValueType || "expression"
    }
  }, n = {};
  Object.entries(e.coordinationValues).forEach(([i, o]) => {
    cct.includes(i) || (n[i] = o);
  });
  const { options: r = {} } = t;
  return [
    // obsFeatureMatrix
    ...r.obsFeatureMatrix ? [{
      ...e,
      fileType: Ft.OBS_FEATURE_MATRIX_ANNDATA_ZARR,
      options: r.obsFeatureMatrix,
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType,
        featureType: e.coordinationValues.featureType,
        featureValueType: e.coordinationValues.featureValueType
      }
    }] : [],
    // obsSets
    ...r.obsSets ? [{
      ...e,
      fileType: Ft.OBS_SETS_ANNDATA_ZARR,
      options: r.obsSets,
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType
      }
    }] : [],
    // obsSpots
    ...r.obsSpots ? [{
      ...e,
      fileType: Ft.OBS_SPOTS_ANNDATA_ZARR,
      options: r.obsSpots,
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType
      }
    }] : [],
    // obsPoints
    ...r.obsPoints ? [{
      ...e,
      fileType: Ft.OBS_POINTS_ANNDATA_ZARR,
      options: r.obsPoints,
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType
      }
    }] : [],
    // obsLocations
    ...r.obsLocations ? [{
      ...e,
      fileType: Ft.OBS_LOCATIONS_ANNDATA_ZARR,
      options: r.obsLocations,
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType
      }
    }] : [],
    // obsSegmentations
    ...r.obsSegmentations ? [{
      ...e,
      fileType: Ft.OBS_SEGMENTATIONS_ANNDATA_ZARR,
      options: r.obsSegmentations,
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType
      }
    }] : [],
    // obsEmbedding
    // eslint-disable-next-line no-nested-ternary
    ...r.obsEmbedding ? Array.isArray(r.obsEmbedding) ? r.obsEmbedding.map((i) => ({
      // obsEmbedding was an array, process each element.
      ...e,
      fileType: Ft.OBS_EMBEDDING_ANNDATA_ZARR,
      options: {
        path: i.path,
        dims: i.dims
      },
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType,
        // Move embedding type property out of options and into coordinationValues.
        embeddingType: i.embeddingType
      }
    })) : [{
      // obsEmbedding was an object.
      ...e,
      fileType: Ft.OBS_EMBEDDING_ANNDATA_ZARR,
      options: r.obsEmbedding,
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType,
        embeddingType: e.coordinationValues.embeddingType
      }
    }] : [],
    // obsLabels
    // eslint-disable-next-line no-nested-ternary
    ...r.obsLabels ? Array.isArray(r.obsLabels) ? r.obsLabels.map((i) => ({
      // obsLabels was an array, process each element.
      ...e,
      fileType: Ft.OBS_LABELS_ANNDATA_ZARR,
      options: {
        path: i.path
      },
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType,
        // Move obsLabels type property out of options and into coordinationValues.
        obsLabelsType: i.obsLabelsType
      }
    })) : [{
      // obsLabels was an object.
      ...e,
      fileType: Ft.OBS_LABELS_ANNDATA_ZARR,
      options: r.obsLabels,
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType,
        obsLabelsType: e.coordinationValues.obsLabelsType
      }
    }] : [],
    // featureLabels
    // eslint-disable-next-line no-nested-ternary
    ...r.featureLabels ? Array.isArray(r.featureLabels) ? r.featureLabels.map((i) => ({
      // featureLabels was an array, process each element.
      ...e,
      fileType: Ft.FEATURE_LABELS_ANNDATA_ZARR,
      options: {
        path: i.path
      },
      coordinationValues: {
        ...n,
        featureType: e.coordinationValues.featureType,
        // Move featureLabels type property out of options and into coordinationValues.
        featureLabelsType: i.featureLabelsType
      }
    })) : [{
      // featureLabels was an object.
      ...e,
      fileType: Ft.FEATURE_LABELS_ANNDATA_ZARR,
      options: r.featureLabels,
      coordinationValues: {
        ...n,
        featureType: e.coordinationValues.featureType,
        featureLabelsType: e.coordinationValues.featureLabelsType
      }
    }] : []
  ];
}
function ONr(t) {
  const e = {
    url: t.url,
    requestInit: t.requestInit,
    coordinationValues: {
      ...t.coordinationValues,
      obsType: t.coordinationValues?.obsType || "cell",
      featureType: t.coordinationValues?.featureType || "gene",
      featureValueType: t.coordinationValues?.featureValueType || "expression"
    }
  }, n = {};
  Object.entries(e.coordinationValues).forEach(([i, o]) => {
    cct.includes(i) || (n[i] = o);
  });
  const { options: r = {} } = t;
  return [
    // obsFeatureMatrix
    ...r.obsFeatureMatrix ? [{
      ...e,
      fileType: Ft.OBS_FEATURE_MATRIX_SPATIALDATA_ZARR,
      options: r.obsFeatureMatrix,
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType,
        featureType: e.coordinationValues.featureType,
        featureValueType: e.coordinationValues.featureValueType
      }
    }] : [],
    // obsSets
    ...r.obsSets ? [{
      ...e,
      fileType: Ft.OBS_SETS_SPATIALDATA_ZARR,
      options: r.obsSets,
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType
      }
    }] : [],
    // obsSpots
    ...r.obsSpots ? [{
      ...e,
      fileType: Ft.OBS_SPOTS_SPATIALDATA_ZARR,
      options: r.obsSpots,
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType
      }
    }] : [],
    // TODO: obsPoints?
    // TODO: obsLocations?
    // image
    ...r.image ? [{
      ...e,
      fileType: Ft.IMAGE_SPATIALDATA_ZARR,
      options: r.image,
      coordinationValues: {
        ...n,
        featureType: e.coordinationValues.featureType
        // TODO: fileUid?
      }
    }] : [],
    // labels
    ...r.labels ? [{
      ...e,
      fileType: Ft.LABELS_SPATIALDATA_ZARR,
      options: r.labels,
      coordinationValues: {
        ...n,
        obsType: e.coordinationValues.obsType
        // TODO: fileUid?
      }
    }] : []
  ];
}
function FNr(t) {
  const e = {
    ...t,
    coordinationValues: {
      obsType: t.coordinationValues?.obsType || "molecule"
    }
  };
  return delete e.type, [
    {
      ...e,
      fileType: Ft.OBS_LOCATIONS_MOLECULES_JSON
    },
    {
      ...e,
      fileType: Ft.OBS_LABELS_MOLECULES_JSON
    }
  ];
}
function PNr(t) {
  const e = {
    ...t,
    coordinationValues: {
      obsType: t.coordinationValues?.obsType || "cell",
      featureType: t.coordinationValues?.featureType || "gene",
      featureValueType: t.coordinationValues?.featureValueType || "expression"
    }
  };
  return delete e.type, [
    {
      ...e,
      fileType: Ft.OBS_FEATURE_MATRIX_EXPRESSION_MATRIX_ZARR
    }
  ];
}
function kNr(t) {
  const e = { ...t };
  return delete e.type, [
    {
      ...e,
      fileType: Ft.IMAGE_RASTER_JSON
    },
    {
      ...e,
      fileType: Ft.OBS_SEGMENTATIONS_RASTER_JSON,
      coordinationValues: {
        obsType: e.coordinationValues?.obsType || "cell"
      }
    }
  ];
}
function GNr(t) {
  const e = { ...t };
  return delete e.type, [
    {
      ...e,
      fileType: Ft.IMAGE_OME_ZARR
    }
  ];
}
function UNr(t) {
  const e = { ...t };
  return delete e.type, [
    {
      ...e,
      fileType: Ft.OBS_SETS_CELL_SETS_JSON,
      coordinationValues: {
        obsType: e.coordinationValues?.obsType || "cell"
      }
    }
  ];
}
function HNr(t) {
  const e = {
    ...t,
    coordinationValues: {
      obsType: t.coordinationValues?.obsType || "cell",
      featureType: t.coordinationValues?.featureType || "gene"
    }
  };
  return delete e.type, delete e.options, [
    {
      ...e,
      fileType: Ft.OBS_SEGMENTATIONS_CELLS_JSON,
      coordinationValues: {
        obsType: e.coordinationValues.obsType
      }
    },
    {
      ...e,
      fileType: Ft.OBS_LOCATIONS_CELLS_JSON,
      coordinationValues: {
        obsType: e.coordinationValues.obsType
      }
    },
    ...t.options?.embeddingTypes ? t.options.embeddingTypes.map((n) => ({
      ...e,
      fileType: Ft.OBS_EMBEDDING_CELLS_JSON,
      coordinationValues: {
        obsType: e.coordinationValues.obsType,
        embeddingType: n
      }
    })) : [],
    ...t.options?.obsLabelsTypes ? t.options.obsLabelsTypes.map((n) => ({
      ...e,
      fileType: Ft.OBS_LABELS_CELLS_JSON,
      coordinationValues: {
        obsType: e.coordinationValues.obsType,
        obsLabelsType: n
      }
    })) : []
  ];
}
function $Nr(t) {
  const e = {
    ...t,
    coordinationValues: {
      obsType: t.coordinationValues?.obsType || "cell",
      featureType: t.coordinationValues?.featureType || "gene",
      featureValueType: t.coordinationValues?.featureValueType || "expression"
    }
  };
  return delete e.type, [
    {
      ...e,
      fileType: Ft.OBS_FEATURE_MATRIX_CLUSTERS_JSON
    }
  ];
}
function qNr(t) {
  const e = {
    ...t,
    coordinationValues: {
      obsType: t.coordinationValues?.obsType || "cell",
      featureType: t.coordinationValues?.featureType || "gene",
      featureValueType: t.coordinationValues?.featureValueType || "expression"
    }
  };
  return delete e.type, [
    {
      ...e,
      fileType: Ft.OBS_FEATURE_MATRIX_GENES_JSON
    }
  ];
}
function zIe(t) {
  return {
    url: t.url,
    requestInit: t.requestInit,
    coordinationValues: {
      ...t.coordinationValues,
      obsType: t.coordinationValues?.obsType || "cell",
      featureType: t.coordinationValues?.featureType || "gene",
      featureValueType: t.coordinationValues?.featureValueType || "expression"
    }
  };
}
function jNr(t) {
  const e = zIe(t), { options: n = {} } = t, r = n.mappings ? Object.keys(n.mappings) : [], i = n.factors ? n.factors : [];
  return [
    ...n.poly ? [{
      ...e,
      fileType: Ft.OBS_SEGMENTATIONS_ANNDATA_ZARR,
      options: {
        path: n.poly
      },
      coordinationValues: {
        obsType: e.coordinationValues.obsType
      }
    }] : [],
    ...n.xy ? [{
      ...e,
      fileType: Ft.OBS_LOCATIONS_ANNDATA_ZARR,
      options: {
        path: n.xy
      },
      coordinationValues: {
        obsType: e.coordinationValues.obsType
      }
    }] : [],
    ...r.map((o) => ({
      ...e,
      fileType: Ft.OBS_EMBEDDING_ANNDATA_ZARR,
      options: {
        path: n.mappings[o].key,
        dims: n.mappings[o].dims
      },
      coordinationValues: {
        obsType: e.coordinationValues.obsType,
        embeddingType: o
      }
    })),
    ...i.map((o) => ({
      ...e,
      fileType: Ft.OBS_LABELS_ANNDATA_ZARR,
      options: {
        path: o
      },
      coordinationValues: {
        obsType: e.coordinationValues.obsType,
        obsLabelsType: o.split("/").at(-1)
      }
    }))
  ];
}
function YNr(t) {
  const e = zIe(t), { options: n = [] } = t;
  return [
    {
      ...e,
      fileType: Ft.OBS_SETS_ANNDATA_ZARR,
      options: n.map((r) => ({
        name: r.groupName,
        path: r.setName,
        scorePath: r.scoreName
      })),
      coordinationValues: {
        obsType: e.coordinationValues.obsType
      }
    }
  ];
}
function zNr(t) {
  const e = zIe(t), { options: n = {} } = t;
  return [
    ...n.geneAlias ? [{
      ...e,
      fileType: Ft.FEATURE_LABELS_ANNDATA_ZARR,
      options: {
        path: n.geneAlias
      },
      coordinationValues: {
        featureType: e.coordinationValues.featureType
      }
    }] : [],
    {
      ...e,
      fileType: Ft.OBS_FEATURE_MATRIX_ANNDATA_ZARR,
      options: {
        path: n.matrix,
        featureFilterPath: n.geneFilter,
        initialFeatureFilterPath: n.matrixGeneFilter
      },
      coordinationValues: {
        obsType: e.coordinationValues.obsType,
        featureType: e.coordinationValues.featureType,
        featureValueType: e.coordinationValues.featureValueType
      }
    }
  ];
}
function Nl(t, e) {
  return new jGt(t, e, ea[t]);
}
function Br(t, e, n, r, i) {
  return new YGt(t, e, n, r, i);
}
const VNr = [
  Nl(Gn.DESCRIPTION, JGt),
  Nl(Gn.OBS_SETS, znn),
  Nl(Gn.SCATTERPLOT, Azn),
  Nl(Gn.GATING, czn),
  Nl(Gn.SPATIAL, vXn),
  Nl(Gn.SPATIAL_BETA, GXn),
  Nl(Gn.HEATMAP, tZn),
  Nl(Gn.FEATURE_LIST, RZn),
  Nl(Gn.LAYER_CONTROLLER, ser),
  Nl(Gn.LAYER_CONTROLLER_BETA, Ter),
  Nl(Gn.STATUS, Mer),
  Nl(Gn.OBS_SET_FEATURE_VALUE_DISTRIBUTION, UTr),
  Nl(Gn.OBS_SET_SIZES, $Tr),
  Nl(Gn.FEATURE_VALUE_HISTOGRAM, jTr),
  Nl("higlass", jer),
  Nl(Gn.GENOMIC_PROFILES, Yer)
], JNr = [
  // All CSV file types
  Br(Ft.OBS_SETS_CSV, tn.OBS_SETS, ZTr, Pm, ERt),
  Br(Ft.OBS_EMBEDDING_CSV, tn.OBS_EMBEDDING, zTr, Pm, hRt),
  Br(Ft.OBS_SPOTS_CSV, tn.OBS_SPOTS, KTr, Pm, dRt),
  Br(Ft.OBS_POINTS_CSV, tn.OBS_POINTS, WTr, Pm, pRt),
  Br(Ft.OBS_LOCATIONS_CSV, tn.OBS_LOCATIONS, XTr, Pm, IRt),
  Br(Ft.OBS_LABELS_CSV, tn.OBS_LABELS, JTr, Pm, mRt),
  Br(Ft.OBS_FEATURE_MATRIX_CSV, tn.OBS_FEATURE_MATRIX, VTr, Pm, me.null()),
  Br(Ft.FEATURE_LABELS_CSV, tn.FEATURE_LABELS, YTr, Pm, CRt),
  // All JSON file types
  Br(Ft.OBS_SEGMENTATIONS_JSON, tn.OBS_SEGMENTATIONS, nNr, gu, me.null()),
  Br(Ft.OBS_SETS_JSON, tn.OBS_SETS, p3e, gu, me.null()),
  // All AnnData file types
  Br(Ft.OBS_SETS_ANNDATA_ZARR, tn.OBS_SETS, tse, cg, oye),
  Br(Ft.OBS_EMBEDDING_ANNDATA_ZARR, tn.OBS_EMBEDDING, C3e, cg, eye),
  Br(Ft.OBS_SPOTS_ANNDATA_ZARR, tn.OBS_SPOTS, E3e, cg, tye),
  Br(Ft.OBS_POINTS_ANNDATA_ZARR, tn.OBS_POINTS, y3e, cg, nye),
  Br(Ft.OBS_LOCATIONS_ANNDATA_ZARR, tn.OBS_LOCATIONS, v3e, cg, rye),
  Br(Ft.OBS_LABELS_ANNDATA_ZARR, tn.OBS_LABELS, B3e, cg, aye),
  Br(Ft.OBS_FEATURE_MATRIX_ANNDATA_ZARR, tn.OBS_FEATURE_MATRIX, TX, cg, sye),
  Br(Ft.OBS_SEGMENTATIONS_ANNDATA_ZARR, tn.OBS_SEGMENTATIONS, NX, cg, iye),
  Br(Ft.FEATURE_LABELS_ANNDATA_ZARR, tn.FEATURE_LABELS, b3e, cg, Aye),
  // All MuData file types
  Br(Ft.OBS_SETS_MUDATA_ZARR, tn.OBS_SETS, tse, H0, oye),
  Br(Ft.OBS_EMBEDDING_MUDATA_ZARR, tn.OBS_EMBEDDING, C3e, H0, eye),
  Br(Ft.OBS_SPOTS_MUDATA_ZARR, tn.OBS_SPOTS, E3e, H0, tye),
  Br(Ft.OBS_POINTS_MUDATA_ZARR, tn.OBS_POINTS, y3e, H0, nye),
  Br(Ft.OBS_LOCATIONS_MUDATA_ZARR, tn.OBS_LOCATIONS, v3e, H0, rye),
  Br(Ft.OBS_LABELS_MUDATA_ZARR, tn.OBS_LABELS, B3e, H0, aye),
  Br(Ft.OBS_FEATURE_MATRIX_MUDATA_ZARR, tn.OBS_FEATURE_MATRIX, TX, H0, sye),
  Br(Ft.OBS_SEGMENTATIONS_MUDATA_ZARR, tn.OBS_SEGMENTATIONS, NX, H0, iye),
  Br(Ft.FEATURE_LABELS_MUDATA_ZARR, tn.FEATURE_LABELS, b3e, H0, Aye),
  // All OME file types
  Br(Ft.IMAGE_OME_ZARR, tn.IMAGE, YIe, Yy, Eae),
  Br(Ft.IMAGE_OME_TIFF, tn.IMAGE, lct, S3e, sUe),
  Br(Ft.OBS_SEGMENTATIONS_OME_ZARR, tn.OBS_SEGMENTATIONS, wNr, Yy, gRt),
  Br(Ft.OBS_SEGMENTATIONS_OME_TIFF, tn.OBS_SEGMENTATIONS, LNr, S3e, fRt),
  // SpatialData file types
  Br(Ft.IMAGE_SPATIALDATA_ZARR, tn.IMAGE, Act, Yy, aUe),
  // TODO: create a new loader for labels that returns obsSegmentations with obsSegmentationsType: 'bitmask'
  Br(Ft.LABELS_SPATIALDATA_ZARR, tn.OBS_SEGMENTATIONS, xNr, Yy, EZ),
  // TODO: create a new loader for shapes that returns obsSegmentations with obsSegmentationsType: 'polygon' (or switch this to 'shape' everywhere?)
  // TODO: create a new source for GeoPandas tables?
  Br(Ft.SHAPES_SPATIALDATA_ZARR, tn.OBS_SEGMENTATIONS, NX, m3e, EZ),
  Br(Ft.OBS_SPOTS_SPATIALDATA_ZARR, tn.OBS_SPOTS, DNr, m3e, AUe),
  Br(Ft.OBS_FEATURE_MATRIX_SPATIALDATA_ZARR, tn.OBS_FEATURE_MATRIX, TX, I3e, lUe),
  Br(Ft.OBS_SETS_SPATIALDATA_ZARR, tn.OBS_SETS, TNr, I3e, cUe),
  // All legacy file types
  Br(Ft.OBS_FEATURE_MATRIX_EXPRESSION_MATRIX_ZARR, tn.OBS_FEATURE_MATRIX, SNr, Yy, me.null()),
  Br(Ft.IMAGE_RASTER_JSON, tn.IMAGE, hNr, gu, bT),
  Br(Ft.OBS_SEGMENTATIONS_RASTER_JSON, tn.OBS_SEGMENTATIONS, dNr, gu, bT),
  Br(Ft.OBS_SETS_CELL_SETS_JSON, tn.OBS_SETS, p3e, gu, me.null()),
  Br(Ft.OBS_FEATURE_MATRIX_CLUSTERS_JSON, tn.OBS_FEATURE_MATRIX, ANr, gu, me.null()),
  Br(Ft.OBS_FEATURE_MATRIX_GENES_JSON, tn.OBS_FEATURE_MATRIX, cNr, gu, me.null()),
  Br(Ft.OBS_LABELS_CELLS_JSON, tn.OBS_LABELS, iNr, gu, me.null()),
  Br(Ft.OBS_EMBEDDING_CELLS_JSON, tn.OBS_EMBEDDING, rNr, gu, me.null()),
  Br(Ft.OBS_LOCATIONS_CELLS_JSON, tn.OBS_LOCATIONS, oNr, gu, me.null()),
  Br(Ft.OBS_SEGMENTATIONS_CELLS_JSON, tn.OBS_SEGMENTATIONS, sNr, gu, me.null()),
  Br(Ft.OBS_LOCATIONS_MOLECULES_JSON, tn.OBS_LOCATIONS, fNr, gu, me.null()),
  Br(Ft.OBS_LABELS_MOLECULES_JSON, tn.OBS_LABELS, uNr, gu, me.null()),
  Br(Ft.NEIGHBORHOODS_JSON, tn.NEIGHBORHOODS, th, gu, me.null()),
  Br(Ft.GENOMIC_PROFILES_ZARR, tn.GENOMIC_PROFILES, NNr, Yy, me.null())
], KNr = [
  new sf(Ft.ANNDATA_ZARR, MNr, yRt),
  new sf(Ft.SPATIALDATA_ZARR, ONr, vRt),
  // For legacy file types:
  new sf(Ft.ANNDATA_CELLS_ZARR, jNr, bRt),
  new sf(Ft.ANNDATA_CELL_SETS_ZARR, YNr, _Rt),
  new sf(Ft.ANNDATA_EXPRESSION_MATRIX_ZARR, zNr, SRt),
  new sf(Ft.EXPRESSION_MATRIX_ZARR, PNr, me.null()),
  new sf(Ft.RASTER_JSON, kNr, bT),
  new sf(Ft.RASTER_OME_ZARR, GNr, me.null()),
  new sf(Ft.CELL_SETS_JSON, UNr, me.null()),
  new sf(Ft.CLUSTERS_JSON, $Nr, me.null()),
  new sf(Ft.GENES_JSON, qNr, me.null()),
  new sf(Ft.CELLS_JSON, HNr, BRt),
  new sf(Ft.MOLECULES_JSON, FNr, me.null())
], WNr = [
  new Jt(re.META_COORDINATION_SCOPES, null, me.record(me.any()).nullable()),
  new Jt(re.META_COORDINATION_SCOPES_BY, null, me.record(me.any()).nullable()),
  new Jt(re.DATASET, null, me.string().nullable()),
  new Jt(re.OBS_TYPE, "cell", me.string()),
  new Jt(re.FEATURE_TYPE, "gene", me.string()),
  new Jt(re.FEATURE_VALUE_TYPE, "expression", me.string()),
  new Jt(re.OBS_LABELS_TYPE, null, me.string().nullable()),
  new Jt(re.EMBEDDING_ZOOM, null, me.number().nullable()),
  new Jt(re.EMBEDDING_ROTATION, 0, me.number().nullable()),
  new Jt(re.EMBEDDING_TARGET_X, null, me.number().nullable()),
  new Jt(re.EMBEDDING_TARGET_Y, null, me.number().nullable()),
  new Jt(re.EMBEDDING_TARGET_Z, 0, me.number().nullable()),
  new Jt(re.EMBEDDING_TYPE, null, me.string().nullable()),
  new Jt(re.EMBEDDING_OBS_SET_POLYGONS_VISIBLE, !1, me.boolean()),
  new Jt(re.EMBEDDING_OBS_SET_LABELS_VISIBLE, !1, me.boolean()),
  new Jt(re.EMBEDDING_OBS_SET_LABEL_SIZE, 14, me.number()),
  new Jt(re.EMBEDDING_OBS_RADIUS, 1, me.number()),
  new Jt(re.EMBEDDING_OBS_OPACITY, 1, me.number()),
  new Jt(re.EMBEDDING_OBS_RADIUS_MODE, "auto", me.enum(["manual", "auto"])),
  new Jt(re.EMBEDDING_OBS_OPACITY_MODE, "auto", me.enum(["manual", "auto"])),
  new Jt(re.SPATIAL_ZOOM, null, me.number().nullable()),
  new Jt(re.SPATIAL_ROTATION, 0, me.number().nullable()),
  new Jt(re.SPATIAL_TARGET_X, null, me.number().nullable()),
  new Jt(re.SPATIAL_TARGET_Y, null, me.number().nullable()),
  new Jt(re.SPATIAL_TARGET_Z, null, me.number().nullable()),
  new Jt(re.SPATIAL_ROTATION_X, 0, me.number().nullable()),
  new Jt(re.SPATIAL_ROTATION_Y, 0, me.number().nullable()),
  new Jt(re.SPATIAL_ROTATION_Z, 0, me.number().nullable()),
  new Jt(re.SPATIAL_ROTATION_ORBIT, 0, me.number().nullable()),
  new Jt(re.SPATIAL_ORBIT_AXIS, "Y", me.string().nullable()),
  new Jt(re.SPATIAL_AXIS_FIXED, !1, me.boolean().nullable()),
  new Jt(re.SPATIAL_IMAGE_LAYER, null, lye.nullable()),
  new Jt(re.SPATIAL_SEGMENTATION_LAYER, null, me.union([
    QRt,
    lye
  ]).nullable()),
  new Jt(re.SPATIAL_NEIGHBORHOOD_LAYER, null, wRt.nullable()),
  new Jt(re.SPATIAL_POINT_LAYER, null, xRt.nullable()),
  new Jt(re.HEATMAP_ZOOM_X, 0, me.number()),
  new Jt(re.HEATMAP_ZOOM_Y, 0, me.number()),
  new Jt(re.HEATMAP_TARGET_X, 0, me.number()),
  new Jt(re.HEATMAP_TARGET_Y, 0, me.number()),
  new Jt(re.OBS_FILTER, null, me.array(me.string()).nullable()),
  new Jt(re.OBS_HIGHLIGHT, null, me.string().nullable()),
  new Jt(re.OBS_SET_SELECTION, null, me.array(aF).nullable()),
  new Jt(re.OBS_SET_EXPANSION, null, me.array(aF).nullable()),
  new Jt(re.OBS_SET_HIGHLIGHT, null, aF.nullable()),
  new Jt(re.OBS_SET_COLOR, null, me.array(me.object({
    path: aF,
    color: aae
  })).nullable()),
  new Jt(re.OBS_COLOR_ENCODING, "cellSetSelection", me.enum(["geneSelection", "cellSetSelection", "spatialChannelColor", "spatialLayerColor", "obsLabels"])),
  new Jt(re.FEATURE_FILTER, null, me.array(me.string()).nullable()),
  new Jt(re.FEATURE_HIGHLIGHT, null, me.string().nullable()),
  new Jt(re.FEATURE_SELECTION, null, me.array(me.string()).nullable()),
  new Jt(re.FEATURE_VALUE_TRANSFORM, null, me.enum(["log1p", "arcsinh"]).nullable()),
  new Jt(re.FEATURE_VALUE_TRANSFORM_COEFFICIENT, 1, me.number()),
  new Jt(re.TOOLTIPS_VISIBLE, !0, me.boolean()),
  new Jt(re.FEATURE_VALUE_COLORMAP, "plasma", me.string().nullable()),
  new Jt(re.FEATURE_VALUE_COLORMAP_RANGE, [0, 1], me.array(me.number()).length(2)),
  new Jt(re.GATING_FEATURE_SELECTION_X, null, me.string().nullable()),
  new Jt(re.GATING_FEATURE_SELECTION_Y, null, me.string().nullable()),
  new Jt(re.GENOMIC_ZOOM_X, 0, me.number()),
  new Jt(re.GENOMIC_ZOOM_Y, 0, me.number()),
  new Jt(re.GENOMIC_TARGET_X, 15499999995e-1, me.number()),
  new Jt(re.GENOMIC_TARGET_Y, 15499999995e-1, me.number()),
  new Jt(re.ADDITIONAL_OBS_SETS, null, FH.nullable()),
  new Jt(re.MOLECULE_HIGHLIGHT, null, me.string().nullable()),
  new Jt(re.FILE_UID, null, me.string().nullable()),
  new Jt(re.IMAGE_LAYER, null, me.string().nullable()),
  new Jt(re.IMAGE_CHANNEL, null, me.string().nullable()),
  new Jt(re.SEGMENTATION_LAYER, null, me.string().nullable()),
  new Jt(re.SEGMENTATION_CHANNEL, null, me.string().nullable()),
  new Jt(re.SPATIAL_TARGET_C, null, me.number().nullable()),
  new Jt(re.SPATIAL_TARGET_Z, null, me.number().nullable()),
  new Jt(re.SPATIAL_TARGET_T, null, me.number().nullable()),
  new Jt(re.SPATIAL_LAYER_VISIBLE, !0, me.boolean()),
  new Jt(re.SPATIAL_LAYER_OPACITY, 1, me.number()),
  new Jt(re.SPATIAL_LAYER_COLORMAP, null, me.string().nullable()),
  new Jt(re.SPATIAL_LAYER_TRANSPARENT_COLOR, null, me.array(me.number()).length(3).nullable()),
  new Jt(re.SPATIAL_LAYER_MODEL_MATRIX, null, me.array(me.number()).length(16).nullable()),
  new Jt(re.SPATIAL_CHANNEL_VISIBLE, !0, me.boolean()),
  new Jt(re.SPATIAL_CHANNEL_OPACITY, 1, me.number()),
  new Jt(re.SPATIAL_CHANNEL_WINDOW, null, me.array(me.number()).length(2).nullable()),
  new Jt(re.SPATIAL_CHANNEL_COLOR, [255, 255, 255], me.array(me.number()).length(3).nullable()),
  new Jt(re.SPATIAL_SEGMENTATION_FILLED, !0, me.boolean()),
  new Jt(re.SPATIAL_SEGMENTATION_STROKE_WIDTH, 1, me.number()),
  // Reference: https://www.awaresystems.be/imaging/tiff/tifftags/photometricinterpretation.html
  new Jt(re.PHOTOMETRIC_INTERPRETATION, null, me.enum(["BlackIsZero", "RGB"]).nullable()),
  new Jt(re.SPATIAL_RENDERING_MODE, "2D", me.enum(["2D", "3D"]).nullable()),
  new Jt(re.VOLUMETRIC_RENDERING_ALGORITHM, "additive", me.enum(["maximumIntensityProjection", "additive"])),
  new Jt(re.SPATIAL_TARGET_RESOLUTION, 0, me.number().nullable()),
  new Jt(re.SPATIAL_SLICE_X, null, me.array(me.number()).length(2).nullable()),
  new Jt(re.SPATIAL_SLICE_Y, null, me.array(me.number()).length(2).nullable()),
  new Jt(re.SPATIAL_SLICE_Z, null, me.array(me.number()).length(2).nullable()),
  new Jt(re.SPOT_LAYER, null, me.string().nullable()),
  new Jt(re.POINT_LAYER, null, me.string().nullable()),
  new Jt(re.SPATIAL_SPOT_RADIUS, 25, me.number().nullable()),
  new Jt(re.SPATIAL_SPOT_FILLED, !0, me.boolean()),
  new Jt(re.SPATIAL_SPOT_STROKE_WIDTH, 1, me.number()),
  new Jt(re.SPATIAL_LAYER_COLOR, null, me.array(me.number()).length(3).nullable()),
  new Jt(re.PIXEL_HIGHLIGHT, null, me.array(me.number()).length(3).nullable()),
  new Jt(re.TOOLTIP_CROSSHAIRS_VISIBLE, !0, me.boolean()),
  new Jt(re.LEGEND_VISIBLE, !0, me.boolean()),
  new Jt(re.SPATIAL_CHANNEL_LABELS_VISIBLE, !0, me.boolean()),
  new Jt(re.SPATIAL_CHANNEL_LABELS_ORIENTATION, "vertical", me.enum(["vertical", "horizontal"])),
  new Jt(re.SPATIAL_CHANNEL_LABEL_SIZE, 14, me.number())
];
function rMr(t) {
  const { config: e, onConfigUpgrade: n, pluginViewTypes: r, pluginFileTypes: i, pluginCoordinationTypes: o, pluginJointFileTypes: s, stores: a } = t, A = e?.uid || e, l = e?.version, [c, u] = dt(() => {
    try {
      return hk(e, "pre-upgrade view config"), [tRt(e, n), !0];
    } catch (m) {
      return console.error(m), [
        {
          title: "Config validation or upgrade failed.",
          unformatted: m.message
        },
        !1
      ];
    }
  }, [A, l]), f = dt(() => [
    ...VNr,
    ...r || []
  ], [r]), h = dt(() => [
    ...JNr,
    ...i || []
  ], [i]), d = dt(() => [
    ...KNr,
    ...s || []
  ], [s]), I = dt(() => [
    ...WNr,
    ...o || []
  ], [o]);
  return ne.jsx(Vkt, { ...t, config: c, viewTypes: f, fileTypes: h, jointFileTypes: d, coordinationTypes: I, warning: u ? null : c });
}
const XNr = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
}, uct = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
}, ba = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
}, wc = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
}, qm = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};
class Ut {
  /**
   * Get first matched item for a string
   * @param {RegExp} regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getFirstMatch(e, n) {
    const r = n.match(e);
    return r && r.length > 0 && r[1] || "";
  }
  /**
   * Get second matched item for a string
   * @param regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getSecondMatch(e, n) {
    const r = n.match(e);
    return r && r.length > 1 && r[2] || "";
  }
  /**
   * Match a regexp and return a constant or undefined
   * @param {RegExp} regexp
   * @param {String} ua
   * @param {*} _const Any const that will be returned if regexp matches the string
   * @return {*}
   */
  static matchAndReturnConst(e, n, r) {
    if (e.test(n))
      return r;
  }
  static getWindowsVersionName(e) {
    switch (e) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return;
    }
  }
  /**
   * Get macOS version name
   *    10.5 - Leopard
   *    10.6 - Snow Leopard
   *    10.7 - Lion
   *    10.8 - Mountain Lion
   *    10.9 - Mavericks
   *    10.10 - Yosemite
   *    10.11 - El Capitan
   *    10.12 - Sierra
   *    10.13 - High Sierra
   *    10.14 - Mojave
   *    10.15 - Catalina
   *
   * @example
   *   getMacOSVersionName("10.14") // 'Mojave'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getMacOSVersionName(e) {
    const n = e.split(".").splice(0, 2).map((r) => parseInt(r, 10) || 0);
    if (n.push(0), n[0] === 10)
      switch (n[1]) {
        case 5:
          return "Leopard";
        case 6:
          return "Snow Leopard";
        case 7:
          return "Lion";
        case 8:
          return "Mountain Lion";
        case 9:
          return "Mavericks";
        case 10:
          return "Yosemite";
        case 11:
          return "El Capitan";
        case 12:
          return "Sierra";
        case 13:
          return "High Sierra";
        case 14:
          return "Mojave";
        case 15:
          return "Catalina";
        default:
          return;
      }
  }
  /**
   * Get Android version name
   *    1.5 - Cupcake
   *    1.6 - Donut
   *    2.0 - Eclair
   *    2.1 - Eclair
   *    2.2 - Froyo
   *    2.x - Gingerbread
   *    3.x - Honeycomb
   *    4.0 - Ice Cream Sandwich
   *    4.1 - Jelly Bean
   *    4.4 - KitKat
   *    5.x - Lollipop
   *    6.x - Marshmallow
   *    7.x - Nougat
   *    8.x - Oreo
   *    9.x - Pie
   *
   * @example
   *   getAndroidVersionName("7.0") // 'Nougat'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getAndroidVersionName(e) {
    const n = e.split(".").splice(0, 2).map((r) => parseInt(r, 10) || 0);
    if (n.push(0), !(n[0] === 1 && n[1] < 5)) {
      if (n[0] === 1 && n[1] < 6)
        return "Cupcake";
      if (n[0] === 1 && n[1] >= 6)
        return "Donut";
      if (n[0] === 2 && n[1] < 2)
        return "Eclair";
      if (n[0] === 2 && n[1] === 2)
        return "Froyo";
      if (n[0] === 2 && n[1] > 2)
        return "Gingerbread";
      if (n[0] === 3)
        return "Honeycomb";
      if (n[0] === 4 && n[1] < 1)
        return "Ice Cream Sandwich";
      if (n[0] === 4 && n[1] < 4)
        return "Jelly Bean";
      if (n[0] === 4 && n[1] >= 4)
        return "KitKat";
      if (n[0] === 5)
        return "Lollipop";
      if (n[0] === 6)
        return "Marshmallow";
      if (n[0] === 7)
        return "Nougat";
      if (n[0] === 8)
        return "Oreo";
      if (n[0] === 9)
        return "Pie";
    }
  }
  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  static getVersionPrecision(e) {
    return e.split(".").length;
  }
  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions('1.10.2.1',  '1.8.2.1.90')    // 1
   *   compareVersions('1.010.2.1', '1.09.2.1.90');  // 1
   *   compareVersions('1.10.2.1',  '1.10.2.1');     // 0
   *   compareVersions('1.10.2.1',  '1.0800.2');     // -1
   *   compareVersions('1.10.2.1',  '1.10',  true);  // 0
   *
   * @param {String} versionA versions versions to compare
   * @param {String} versionB versions versions to compare
   * @param {boolean} [isLoose] enable loose comparison
   * @return {Number} comparison result: -1 when versionA is lower,
   * 1 when versionA is bigger, 0 when both equal
   */
  /* eslint consistent-return: 1 */
  static compareVersions(e, n, r = !1) {
    const i = Ut.getVersionPrecision(e), o = Ut.getVersionPrecision(n);
    let s = Math.max(i, o), a = 0;
    const A = Ut.map([e, n], (l) => {
      const c = s - Ut.getVersionPrecision(l), u = l + new Array(c + 1).join(".0");
      return Ut.map(u.split("."), (f) => new Array(20 - f.length).join("0") + f).reverse();
    });
    for (r && (a = s - Math.min(i, o)), s -= 1; s >= a; ) {
      if (A[0][s] > A[1][s])
        return 1;
      if (A[0][s] === A[1][s]) {
        if (s === a)
          return 0;
        s -= 1;
      } else if (A[0][s] < A[1][s])
        return -1;
    }
  }
  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  static map(e, n) {
    const r = [];
    let i;
    if (Array.prototype.map)
      return Array.prototype.map.call(e, n);
    for (i = 0; i < e.length; i += 1)
      r.push(n(e[i]));
    return r;
  }
  /**
   * Array::find polyfill
   *
   * @param  {Array} arr
   * @param  {Function} predicate
   * @return {Array}
   */
  static find(e, n) {
    let r, i;
    if (Array.prototype.find)
      return Array.prototype.find.call(e, n);
    for (r = 0, i = e.length; r < i; r += 1) {
      const o = e[r];
      if (n(o, r))
        return o;
    }
  }
  /**
   * Object::assign polyfill
   *
   * @param  {Object} obj
   * @param  {Object} ...objs
   * @return {Object}
   */
  static assign(e, ...n) {
    const r = e;
    let i, o;
    if (Object.assign)
      return Object.assign(e, ...n);
    for (i = 0, o = n.length; i < o; i += 1) {
      const s = n[i];
      typeof s == "object" && s !== null && Object.keys(s).forEach((A) => {
        r[A] = s[A];
      });
    }
    return e;
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('Microsoft Edge') // edge
   *
   * @param  {string} browserName
   * @return {string}
   */
  static getBrowserAlias(e) {
    return XNr[e];
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('edge') // Microsoft Edge
   *
   * @param  {string} browserAlias
   * @return {string}
   */
  static getBrowserTypeByAlias(e) {
    return uct[e] || "";
  }
}
const Ho = /version\/(\d+(\.?_?\d+)+)/i, ZNr = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe(t) {
      const e = {
        name: "Googlebot"
      }, n = Ut.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, t) || Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  /* Opera < 13.0 */
  {
    test: [/opera/i],
    describe(t) {
      const e = {
        name: "Opera"
      }, n = Ut.getFirstMatch(Ho, t) || Ut.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  /* Opera > 13.0 */
  {
    test: [/opr\/|opios/i],
    describe(t) {
      const e = {
        name: "Opera"
      }, n = Ut.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, t) || Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(t) {
      const e = {
        name: "Samsung Internet for Android"
      }, n = Ut.getFirstMatch(Ho, t) || Ut.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/Whale/i],
    describe(t) {
      const e = {
        name: "NAVER Whale Browser"
      }, n = Ut.getFirstMatch(Ho, t) || Ut.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(t) {
      const e = {
        name: "MZ Browser"
      }, n = Ut.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, t) || Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/focus/i],
    describe(t) {
      const e = {
        name: "Focus"
      }, n = Ut.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, t) || Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/swing/i],
    describe(t) {
      const e = {
        name: "Swing"
      }, n = Ut.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, t) || Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/coast/i],
    describe(t) {
      const e = {
        name: "Opera Coast"
      }, n = Ut.getFirstMatch(Ho, t) || Ut.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(t) {
      const e = {
        name: "Opera Touch"
      }, n = Ut.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, t) || Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/yabrowser/i],
    describe(t) {
      const e = {
        name: "Yandex Browser"
      }, n = Ut.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, t) || Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(t) {
      const e = {
        name: "UC Browser"
      }, n = Ut.getFirstMatch(Ho, t) || Ut.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(t) {
      const e = {
        name: "Maxthon"
      }, n = Ut.getFirstMatch(Ho, t) || Ut.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/epiphany/i],
    describe(t) {
      const e = {
        name: "Epiphany"
      }, n = Ut.getFirstMatch(Ho, t) || Ut.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/puffin/i],
    describe(t) {
      const e = {
        name: "Puffin"
      }, n = Ut.getFirstMatch(Ho, t) || Ut.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/sleipnir/i],
    describe(t) {
      const e = {
        name: "Sleipnir"
      }, n = Ut.getFirstMatch(Ho, t) || Ut.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/k-meleon/i],
    describe(t) {
      const e = {
        name: "K-Meleon"
      }, n = Ut.getFirstMatch(Ho, t) || Ut.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/micromessenger/i],
    describe(t) {
      const e = {
        name: "WeChat"
      }, n = Ut.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, t) || Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(t) {
      const e = {
        name: /qqbrowserlite/i.test(t) ? "QQ Browser Lite" : "QQ Browser"
      }, n = Ut.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, t) || Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/msie|trident/i],
    describe(t) {
      const e = {
        name: "Internet Explorer"
      }, n = Ut.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/\sedg\//i],
    describe(t) {
      const e = {
        name: "Microsoft Edge"
      }, n = Ut.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(t) {
      const e = {
        name: "Microsoft Edge"
      }, n = Ut.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/vivaldi/i],
    describe(t) {
      const e = {
        name: "Vivaldi"
      }, n = Ut.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/seamonkey/i],
    describe(t) {
      const e = {
        name: "SeaMonkey"
      }, n = Ut.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/sailfish/i],
    describe(t) {
      const e = {
        name: "Sailfish"
      }, n = Ut.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/silk/i],
    describe(t) {
      const e = {
        name: "Amazon Silk"
      }, n = Ut.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/phantom/i],
    describe(t) {
      const e = {
        name: "PhantomJS"
      }, n = Ut.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/slimerjs/i],
    describe(t) {
      const e = {
        name: "SlimerJS"
      }, n = Ut.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(t) {
      const e = {
        name: "BlackBerry"
      }, n = Ut.getFirstMatch(Ho, t) || Ut.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(t) {
      const e = {
        name: "WebOS Browser"
      }, n = Ut.getFirstMatch(Ho, t) || Ut.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/bada/i],
    describe(t) {
      const e = {
        name: "Bada"
      }, n = Ut.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/tizen/i],
    describe(t) {
      const e = {
        name: "Tizen"
      }, n = Ut.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, t) || Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/qupzilla/i],
    describe(t) {
      const e = {
        name: "QupZilla"
      }, n = Ut.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, t) || Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(t) {
      const e = {
        name: "Firefox"
      }, n = Ut.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/electron/i],
    describe(t) {
      const e = {
        name: "Electron"
      }, n = Ut.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(t) {
      const e = {
        name: "Miui"
      }, n = Ut.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/chromium/i],
    describe(t) {
      const e = {
        name: "Chromium"
      }, n = Ut.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, t) || Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(t) {
      const e = {
        name: "Chrome"
      }, n = Ut.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  {
    test: [/GSA/i],
    describe(t) {
      const e = {
        name: "Google Search"
      }, n = Ut.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  /* Android Browser */
  {
    test(t) {
      const e = !t.test(/like android/i), n = t.test(/android/i);
      return e && n;
    },
    describe(t) {
      const e = {
        name: "Android Browser"
      }, n = Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  /* PlayStation 4 */
  {
    test: [/playstation 4/i],
    describe(t) {
      const e = {
        name: "PlayStation 4"
      }, n = Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  /* Safari */
  {
    test: [/safari|applewebkit/i],
    describe(t) {
      const e = {
        name: "Safari"
      }, n = Ut.getFirstMatch(Ho, t);
      return n && (e.version = n), e;
    }
  },
  /* Something else */
  {
    test: [/.*/i],
    describe(t) {
      const e = /^(.*)\/(.*) /, n = /^(.*)\/(.*)[ \t]\((.*)/, i = t.search("\\(") !== -1 ? n : e;
      return {
        name: Ut.getFirstMatch(i, t),
        version: Ut.getSecondMatch(i, t)
      };
    }
  }
], eLr = [
  /* Roku */
  {
    test: [/Roku\/DVP/],
    describe(t) {
      const e = Ut.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, t);
      return {
        name: wc.Roku,
        version: e
      };
    }
  },
  /* Windows Phone */
  {
    test: [/windows phone/i],
    describe(t) {
      const e = Ut.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, t);
      return {
        name: wc.WindowsPhone,
        version: e
      };
    }
  },
  /* Windows */
  {
    test: [/windows /i],
    describe(t) {
      const e = Ut.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, t), n = Ut.getWindowsVersionName(e);
      return {
        name: wc.Windows,
        version: e,
        versionName: n
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(t) {
      const e = {
        name: wc.iOS
      }, n = Ut.getSecondMatch(/(Version\/)(\d[\d.]+)/, t);
      return n && (e.version = n), e;
    }
  },
  /* macOS */
  {
    test: [/macintosh/i],
    describe(t) {
      const e = Ut.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, t).replace(/[_\s]/g, "."), n = Ut.getMacOSVersionName(e), r = {
        name: wc.MacOS,
        version: e
      };
      return n && (r.versionName = n), r;
    }
  },
  /* iOS */
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(t) {
      const e = Ut.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, t).replace(/[_\s]/g, ".");
      return {
        name: wc.iOS,
        version: e
      };
    }
  },
  /* Android */
  {
    test(t) {
      const e = !t.test(/like android/i), n = t.test(/android/i);
      return e && n;
    },
    describe(t) {
      const e = Ut.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, t), n = Ut.getAndroidVersionName(e), r = {
        name: wc.Android,
        version: e
      };
      return n && (r.versionName = n), r;
    }
  },
  /* WebOS */
  {
    test: [/(web|hpw)[o0]s/i],
    describe(t) {
      const e = Ut.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, t), n = {
        name: wc.WebOS
      };
      return e && e.length && (n.version = e), n;
    }
  },
  /* BlackBerry */
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(t) {
      const e = Ut.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, t) || Ut.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, t) || Ut.getFirstMatch(/\bbb(\d+)/i, t);
      return {
        name: wc.BlackBerry,
        version: e
      };
    }
  },
  /* Bada */
  {
    test: [/bada/i],
    describe(t) {
      const e = Ut.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, t);
      return {
        name: wc.Bada,
        version: e
      };
    }
  },
  /* Tizen */
  {
    test: [/tizen/i],
    describe(t) {
      const e = Ut.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, t);
      return {
        name: wc.Tizen,
        version: e
      };
    }
  },
  /* Linux */
  {
    test: [/linux/i],
    describe() {
      return {
        name: wc.Linux
      };
    }
  },
  /* Chrome OS */
  {
    test: [/CrOS/],
    describe() {
      return {
        name: wc.ChromeOS
      };
    }
  },
  /* Playstation 4 */
  {
    test: [/PlayStation 4/],
    describe(t) {
      const e = Ut.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, t);
      return {
        name: wc.PlayStation4,
        version: e
      };
    }
  }
], tLr = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  /* Huawei */
  {
    test: [/huawei/i],
    describe(t) {
      const e = Ut.getFirstMatch(/(can-l01)/i, t) && "Nova", n = {
        type: ba.mobile,
        vendor: "Huawei"
      };
      return e && (n.model = e), n;
    }
  },
  /* Nexus Tablet */
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: ba.tablet,
        vendor: "Nexus"
      };
    }
  },
  /* iPad */
  {
    test: [/ipad/i],
    describe() {
      return {
        type: ba.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: ba.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Amazon Kindle Fire */
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: ba.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  /* Another Amazon Tablet with Silk */
  {
    test: [/silk/i],
    describe() {
      return {
        type: ba.tablet,
        vendor: "Amazon"
      };
    }
  },
  /* Tablet */
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: ba.tablet
      };
    }
  },
  /* iPod/iPhone */
  {
    test(t) {
      const e = t.test(/ipod|iphone/i), n = t.test(/like (ipod|iphone)/i);
      return e && !n;
    },
    describe(t) {
      const e = Ut.getFirstMatch(/(ipod|iphone)/i, t);
      return {
        type: ba.mobile,
        vendor: "Apple",
        model: e
      };
    }
  },
  /* Nexus Mobile */
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: ba.mobile,
        vendor: "Nexus"
      };
    }
  },
  /* Mobile */
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: ba.mobile
      };
    }
  },
  /* BlackBerry */
  {
    test(t) {
      return t.getBrowserName(!0) === "blackberry";
    },
    describe() {
      return {
        type: ba.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  /* Bada */
  {
    test(t) {
      return t.getBrowserName(!0) === "bada";
    },
    describe() {
      return {
        type: ba.mobile
      };
    }
  },
  /* Windows Phone */
  {
    test(t) {
      return t.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: ba.mobile,
        vendor: "Microsoft"
      };
    }
  },
  /* Android Tablet */
  {
    test(t) {
      const e = Number(String(t.getOSVersion()).split(".")[0]);
      return t.getOSName(!0) === "android" && e >= 3;
    },
    describe() {
      return {
        type: ba.tablet
      };
    }
  },
  /* Android Mobile */
  {
    test(t) {
      return t.getOSName(!0) === "android";
    },
    describe() {
      return {
        type: ba.mobile
      };
    }
  },
  /* desktop */
  {
    test(t) {
      return t.getOSName(!0) === "macos";
    },
    describe() {
      return {
        type: ba.desktop,
        vendor: "Apple"
      };
    }
  },
  /* Windows */
  {
    test(t) {
      return t.getOSName(!0) === "windows";
    },
    describe() {
      return {
        type: ba.desktop
      };
    }
  },
  /* Linux */
  {
    test(t) {
      return t.getOSName(!0) === "linux";
    },
    describe() {
      return {
        type: ba.desktop
      };
    }
  },
  /* PlayStation 4 */
  {
    test(t) {
      return t.getOSName(!0) === "playstation 4";
    },
    describe() {
      return {
        type: ba.tv
      };
    }
  },
  /* Roku */
  {
    test(t) {
      return t.getOSName(!0) === "roku";
    },
    describe() {
      return {
        type: ba.tv
      };
    }
  }
], nLr = [
  /* EdgeHTML */
  {
    test(t) {
      return t.getBrowserName(!0) === "microsoft edge";
    },
    describe(t) {
      if (/\sedg\//i.test(t))
        return {
          name: qm.Blink
        };
      const n = Ut.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, t);
      return {
        name: qm.EdgeHTML,
        version: n
      };
    }
  },
  /* Trident */
  {
    test: [/trident/i],
    describe(t) {
      const e = {
        name: qm.Trident
      }, n = Ut.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  /* Presto */
  {
    test(t) {
      return t.test(/presto/i);
    },
    describe(t) {
      const e = {
        name: qm.Presto
      }, n = Ut.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  /* Gecko */
  {
    test(t) {
      const e = t.test(/gecko/i), n = t.test(/like gecko/i);
      return e && !n;
    },
    describe(t) {
      const e = {
        name: qm.Gecko
      }, n = Ut.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  },
  /* Blink */
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: qm.Blink
      };
    }
  },
  /* WebKit */
  {
    test: [/(apple)?webkit/i],
    describe(t) {
      const e = {
        name: qm.WebKit
      }, n = Ut.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, t);
      return n && (e.version = n), e;
    }
  }
];
class Q3e {
  /**
   * Create instance of Parser
   *
   * @param {String} UA User-Agent string
   * @param {Boolean} [skipParsing=false] parser can skip parsing in purpose of performance
   * improvements if you need to make a more particular parsing
   * like {@link Parser#parseBrowser} or {@link Parser#parsePlatform}
   *
   * @throw {Error} in case of empty UA String
   *
   * @constructor
   */
  constructor(e, n = !1) {
    if (e == null || e === "")
      throw new Error("UserAgent parameter can't be empty");
    this._ua = e, this.parsedResult = {}, n !== !0 && this.parse();
  }
  /**
   * Get UserAgent string of current Parser instance
   * @return {String} User-Agent String of the current <Parser> object
   *
   * @public
   */
  getUA() {
    return this._ua;
  }
  /**
   * Test a UA string for a regexp
   * @param {RegExp} regex
   * @return {Boolean}
   */
  test(e) {
    return e.test(this._ua);
  }
  /**
   * Get parsed browser object
   * @return {Object}
   */
  parseBrowser() {
    this.parsedResult.browser = {};
    const e = Ut.find(ZNr, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.browser = e.describe(this.getUA())), this.parsedResult.browser;
  }
  /**
   * Get parsed browser object
   * @return {Object}
   *
   * @public
   */
  getBrowser() {
    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
  }
  /**
   * Get browser's name
   * @return {String} Browser's name or an empty string
   *
   * @public
   */
  getBrowserName(e) {
    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
  }
  /**
   * Get browser's version
   * @return {String} version of browser
   *
   * @public
   */
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  /**
   * Get OS
   * @return {Object}
   *
   * @example
   * this.getOS();
   * {
   *   name: 'macOS',
   *   version: '10.11.12'
   * }
   */
  getOS() {
    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
  }
  /**
   * Parse OS and save it to this.parsedResult.os
   * @return {*|{}}
   */
  parseOS() {
    this.parsedResult.os = {};
    const e = Ut.find(eLr, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.os = e.describe(this.getUA())), this.parsedResult.os;
  }
  /**
   * Get OS name
   * @param {Boolean} [toLowerCase] return lower-cased value
   * @return {String} name of the OS — macOS, Windows, Linux, etc.
   */
  getOSName(e) {
    const { name: n } = this.getOS();
    return e ? String(n).toLowerCase() || "" : n || "";
  }
  /**
   * Get OS version
   * @return {String} full version with dots ('10.11.12', '5.6', etc)
   */
  getOSVersion() {
    return this.getOS().version;
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  getPlatform() {
    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
  }
  /**
   * Get platform name
   * @param {Boolean} [toLowerCase=false]
   * @return {*}
   */
  getPlatformType(e = !1) {
    const { type: n } = this.getPlatform();
    return e ? String(n).toLowerCase() || "" : n || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parsePlatform() {
    this.parsedResult.platform = {};
    const e = Ut.find(tLr, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.platform = e.describe(this.getUA())), this.parsedResult.platform;
  }
  /**
   * Get parsed engine
   * @return {{}}
   */
  getEngine() {
    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
  }
  /**
   * Get engines's name
   * @return {String} Engines's name or an empty string
   *
   * @public
   */
  getEngineName(e) {
    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parseEngine() {
    this.parsedResult.engine = {};
    const e = Ut.find(nLr, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return e && (this.parsedResult.engine = e.describe(this.getUA())), this.parsedResult.engine;
  }
  /**
   * Parse full information about the browser
   * @returns {Parser}
   */
  parse() {
    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
  }
  /**
   * Get parsed result
   * @return {ParsedResult}
   */
  getResult() {
    return Ut.assign({}, this.parsedResult);
  }
  /**
   * Check if parsed browser matches certain conditions
   *
   * @param {Object} checkTree It's one or two layered object,
   * which can include a platform or an OS on the first layer
   * and should have browsers specs on the bottom-laying layer
   *
   * @returns {Boolean|undefined} Whether the browser satisfies the set conditions or not.
   * Returns `undefined` when the browser is no described in the checkTree object.
   *
   * @example
   * const browser = Bowser.getParser(window.navigator.userAgent);
   * if (browser.satisfies({chrome: '>118.01.1322' }))
   * // or with os
   * if (browser.satisfies({windows: { chrome: '>118.01.1322' } }))
   * // or with platforms
   * if (browser.satisfies({desktop: { chrome: '>118.01.1322' } }))
   */
  satisfies(e) {
    const n = {};
    let r = 0;
    const i = {};
    let o = 0;
    if (Object.keys(e).forEach((a) => {
      const A = e[a];
      typeof A == "string" ? (i[a] = A, o += 1) : typeof A == "object" && (n[a] = A, r += 1);
    }), r > 0) {
      const a = Object.keys(n), A = Ut.find(a, (c) => this.isOS(c));
      if (A) {
        const c = this.satisfies(n[A]);
        if (c !== void 0)
          return c;
      }
      const l = Ut.find(
        a,
        (c) => this.isPlatform(c)
      );
      if (l) {
        const c = this.satisfies(n[l]);
        if (c !== void 0)
          return c;
      }
    }
    if (o > 0) {
      const a = Object.keys(i), A = Ut.find(a, (l) => this.isBrowser(l, !0));
      if (A !== void 0)
        return this.compareVersion(i[A]);
    }
  }
  /**
   * Check if the browser name equals the passed string
   * @param browserName The string to compare with the browser name
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {boolean}
   */
  isBrowser(e, n = !1) {
    const r = this.getBrowserName().toLowerCase();
    let i = e.toLowerCase();
    const o = Ut.getBrowserTypeByAlias(i);
    return n && o && (i = o.toLowerCase()), i === r;
  }
  compareVersion(e) {
    let n = [0], r = e, i = !1;
    const o = this.getBrowserVersion();
    if (typeof o == "string")
      return e[0] === ">" || e[0] === "<" ? (r = e.substr(1), e[1] === "=" ? (i = !0, r = e.substr(2)) : n = [], e[0] === ">" ? n.push(1) : n.push(-1)) : e[0] === "=" ? r = e.substr(1) : e[0] === "~" && (i = !0, r = e.substr(1)), n.indexOf(
        Ut.compareVersions(o, r, i)
      ) > -1;
  }
  isOS(e) {
    return this.getOSName(!0) === String(e).toLowerCase();
  }
  isPlatform(e) {
    return this.getPlatformType(!0) === String(e).toLowerCase();
  }
  isEngine(e) {
    return this.getEngineName(!0) === String(e).toLowerCase();
  }
  /**
   * Is anything? Check if the browser is called "anything",
   * the OS called "anything" or the platform called "anything"
   * @param {String} anything
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {Boolean}
   */
  is(e, n = !1) {
    return this.isBrowser(e, n) || this.isOS(e) || this.isPlatform(e);
  }
  /**
   * Check if any of the given values satisfies this.is(anything)
   * @param {String[]} anythings
   * @returns {Boolean}
   */
  some(e = []) {
    return e.some((n) => this.is(n));
  }
}
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class rLr {
  /**
   * Creates a {@link Parser} instance
   *
   * @param {String} UA UserAgent string
   * @param {Boolean} [skipParsing=false] Will make the Parser postpone parsing until you ask it
   * explicitly. Same as `skipParsing` for {@link Parser}.
   * @returns {Parser}
   * @throws {Error} when UA is not a String
   *
   * @example
   * const parser = Bowser.getParser(window.navigator.userAgent);
   * const result = parser.getResult();
   */
  static getParser(e, n = !1) {
    if (typeof e != "string")
      throw new Error("UserAgent should be a string");
    return new Q3e(e, n);
  }
  /**
   * Creates a {@link Parser} instance and runs {@link Parser.getResult} immediately
   *
   * @param UA
   * @return {ParsedResult}
   *
   * @example
   * const result = Bowser.parse(window.navigator.userAgent);
   */
  static parse(e) {
    return new Q3e(e).getResult();
  }
  static get BROWSER_MAP() {
    return uct;
  }
  static get ENGINE_MAP() {
    return qm;
  }
  static get OS_MAP() {
    return wc;
  }
  static get PLATFORMS_MAP() {
    return ba;
  }
}
var VIe = { exports: {} };
VIe.exports;
(function(t) {
  var e = function() {
    var n = String.fromCharCode, r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$", o = {};
    function s(A, l) {
      if (!o[A]) {
        o[A] = {};
        for (var c = 0; c < A.length; c++)
          o[A][A.charAt(c)] = c;
      }
      return o[A][l];
    }
    var a = {
      compressToBase64: function(A) {
        if (A == null)
          return "";
        var l = a._compress(A, 6, function(c) {
          return r.charAt(c);
        });
        switch (l.length % 4) {
          default:
          case 0:
            return l;
          case 1:
            return l + "===";
          case 2:
            return l + "==";
          case 3:
            return l + "=";
        }
      },
      decompressFromBase64: function(A) {
        return A == null ? "" : A == "" ? null : a._decompress(A.length, 32, function(l) {
          return s(r, A.charAt(l));
        });
      },
      compressToUTF16: function(A) {
        return A == null ? "" : a._compress(A, 15, function(l) {
          return n(l + 32);
        }) + " ";
      },
      decompressFromUTF16: function(A) {
        return A == null ? "" : A == "" ? null : a._decompress(A.length, 16384, function(l) {
          return A.charCodeAt(l) - 32;
        });
      },
      //compress into uint8array (UCS-2 big endian format)
      compressToUint8Array: function(A) {
        for (var l = a.compress(A), c = new Uint8Array(l.length * 2), u = 0, f = l.length; u < f; u++) {
          var h = l.charCodeAt(u);
          c[u * 2] = h >>> 8, c[u * 2 + 1] = h % 256;
        }
        return c;
      },
      //decompress from uint8array (UCS-2 big endian format)
      decompressFromUint8Array: function(A) {
        if (A == null)
          return a.decompress(A);
        for (var l = new Array(A.length / 2), c = 0, u = l.length; c < u; c++)
          l[c] = A[c * 2] * 256 + A[c * 2 + 1];
        var f = [];
        return l.forEach(function(h) {
          f.push(n(h));
        }), a.decompress(f.join(""));
      },
      //compress into a string that is already URI encoded
      compressToEncodedURIComponent: function(A) {
        return A == null ? "" : a._compress(A, 6, function(l) {
          return i.charAt(l);
        });
      },
      //decompress from an output of compressToEncodedURIComponent
      decompressFromEncodedURIComponent: function(A) {
        return A == null ? "" : A == "" ? null : (A = A.replace(/ /g, "+"), a._decompress(A.length, 32, function(l) {
          return s(i, A.charAt(l));
        }));
      },
      compress: function(A) {
        return a._compress(A, 16, function(l) {
          return n(l);
        });
      },
      _compress: function(A, l, c) {
        if (A == null)
          return "";
        var u, f, h = {}, d = {}, I = "", m = "", C = "", y = 2, v = 3, b = 2, Q = [], w = 0, R = 0, M;
        for (M = 0; M < A.length; M += 1)
          if (I = A.charAt(M), Object.prototype.hasOwnProperty.call(h, I) || (h[I] = v++, d[I] = !0), m = C + I, Object.prototype.hasOwnProperty.call(h, m))
            C = m;
          else {
            if (Object.prototype.hasOwnProperty.call(d, C)) {
              if (C.charCodeAt(0) < 256) {
                for (u = 0; u < b; u++)
                  w = w << 1, R == l - 1 ? (R = 0, Q.push(c(w)), w = 0) : R++;
                for (f = C.charCodeAt(0), u = 0; u < 8; u++)
                  w = w << 1 | f & 1, R == l - 1 ? (R = 0, Q.push(c(w)), w = 0) : R++, f = f >> 1;
              } else {
                for (f = 1, u = 0; u < b; u++)
                  w = w << 1 | f, R == l - 1 ? (R = 0, Q.push(c(w)), w = 0) : R++, f = 0;
                for (f = C.charCodeAt(0), u = 0; u < 16; u++)
                  w = w << 1 | f & 1, R == l - 1 ? (R = 0, Q.push(c(w)), w = 0) : R++, f = f >> 1;
              }
              y--, y == 0 && (y = Math.pow(2, b), b++), delete d[C];
            } else
              for (f = h[C], u = 0; u < b; u++)
                w = w << 1 | f & 1, R == l - 1 ? (R = 0, Q.push(c(w)), w = 0) : R++, f = f >> 1;
            y--, y == 0 && (y = Math.pow(2, b), b++), h[m] = v++, C = String(I);
          }
        if (C !== "") {
          if (Object.prototype.hasOwnProperty.call(d, C)) {
            if (C.charCodeAt(0) < 256) {
              for (u = 0; u < b; u++)
                w = w << 1, R == l - 1 ? (R = 0, Q.push(c(w)), w = 0) : R++;
              for (f = C.charCodeAt(0), u = 0; u < 8; u++)
                w = w << 1 | f & 1, R == l - 1 ? (R = 0, Q.push(c(w)), w = 0) : R++, f = f >> 1;
            } else {
              for (f = 1, u = 0; u < b; u++)
                w = w << 1 | f, R == l - 1 ? (R = 0, Q.push(c(w)), w = 0) : R++, f = 0;
              for (f = C.charCodeAt(0), u = 0; u < 16; u++)
                w = w << 1 | f & 1, R == l - 1 ? (R = 0, Q.push(c(w)), w = 0) : R++, f = f >> 1;
            }
            y--, y == 0 && (y = Math.pow(2, b), b++), delete d[C];
          } else
            for (f = h[C], u = 0; u < b; u++)
              w = w << 1 | f & 1, R == l - 1 ? (R = 0, Q.push(c(w)), w = 0) : R++, f = f >> 1;
          y--, y == 0 && (y = Math.pow(2, b), b++);
        }
        for (f = 2, u = 0; u < b; u++)
          w = w << 1 | f & 1, R == l - 1 ? (R = 0, Q.push(c(w)), w = 0) : R++, f = f >> 1;
        for (; ; )
          if (w = w << 1, R == l - 1) {
            Q.push(c(w));
            break;
          } else
            R++;
        return Q.join("");
      },
      decompress: function(A) {
        return A == null ? "" : A == "" ? null : a._decompress(A.length, 32768, function(l) {
          return A.charCodeAt(l);
        });
      },
      _decompress: function(A, l, c) {
        var u = [], f = 4, h = 4, d = 3, I = "", m = [], C, y, v, b, Q, w, R, M = { val: c(0), position: l, index: 1 };
        for (C = 0; C < 3; C += 1)
          u[C] = C;
        for (v = 0, Q = Math.pow(2, 2), w = 1; w != Q; )
          b = M.val & M.position, M.position >>= 1, M.position == 0 && (M.position = l, M.val = c(M.index++)), v |= (b > 0 ? 1 : 0) * w, w <<= 1;
        switch (v) {
          case 0:
            for (v = 0, Q = Math.pow(2, 8), w = 1; w != Q; )
              b = M.val & M.position, M.position >>= 1, M.position == 0 && (M.position = l, M.val = c(M.index++)), v |= (b > 0 ? 1 : 0) * w, w <<= 1;
            R = n(v);
            break;
          case 1:
            for (v = 0, Q = Math.pow(2, 16), w = 1; w != Q; )
              b = M.val & M.position, M.position >>= 1, M.position == 0 && (M.position = l, M.val = c(M.index++)), v |= (b > 0 ? 1 : 0) * w, w <<= 1;
            R = n(v);
            break;
          case 2:
            return "";
        }
        for (u[3] = R, y = R, m.push(R); ; ) {
          if (M.index > A)
            return "";
          for (v = 0, Q = Math.pow(2, d), w = 1; w != Q; )
            b = M.val & M.position, M.position >>= 1, M.position == 0 && (M.position = l, M.val = c(M.index++)), v |= (b > 0 ? 1 : 0) * w, w <<= 1;
          switch (R = v) {
            case 0:
              for (v = 0, Q = Math.pow(2, 8), w = 1; w != Q; )
                b = M.val & M.position, M.position >>= 1, M.position == 0 && (M.position = l, M.val = c(M.index++)), v |= (b > 0 ? 1 : 0) * w, w <<= 1;
              u[h++] = n(v), R = h - 1, f--;
              break;
            case 1:
              for (v = 0, Q = Math.pow(2, 16), w = 1; w != Q; )
                b = M.val & M.position, M.position >>= 1, M.position == 0 && (M.position = l, M.val = c(M.index++)), v |= (b > 0 ? 1 : 0) * w, w <<= 1;
              u[h++] = n(v), R = h - 1, f--;
              break;
            case 2:
              return m.join("");
          }
          if (f == 0 && (f = Math.pow(2, d), d++), u[R])
            I = u[R];
          else if (R === h)
            I = y + y.charAt(0);
          else
            return null;
          m.push(I), u[h++] = y + I.charAt(0), f--, y = I, f == 0 && (f = Math.pow(2, d), d++);
        }
      }
    };
    return a;
  }();
  t != null && (t.exports = e);
})(VIe);
var fct = VIe.exports;
const gct = "0.0.1", hct = "vitessce_conf", dct = "vitessce_conf_version", pct = "vitessce_conf_length";
function iLr() {
  const { browser: t } = rLr.parse(window.navigator.userAgent);
  return t.name;
}
const w3e = {
  Chrome: 32779,
  "Internet Explorer": 2047,
  Edge: 2047,
  Safari: 65e3,
  Firefox: 65e3
};
class oLr {
  constructor(e) {
    this.message = e;
  }
}
function iMr({ conf: t, onOverMaximumUrlLength: e = () => {
} }) {
  const n = fct.compressToEncodedURIComponent(JSON.stringify(t)), r = `${pct}=${n.length}&${dct}=${gct}&${hct}=${n}`, i = iLr(), o = w3e[i];
  if (r.length > o) {
    const s = Object.entries(w3e).filter((A) => A[1] > r.length).map((A) => A[0]), a = `Configuration is ${n.length} characters; max URL for ${i} is ${o}: it will work on ${s.join(", ") || "no browser"}.`;
    console.error(a), e({ message: a, willWorkOn: s });
  }
  return r;
}
function oMr(t) {
  const e = new URLSearchParams(t.replace("#", "&")), n = e.get(hct), r = Number(e.get(pct));
  if (r !== n.length)
    throw new oLr(`Compressed conf length (${n.length}) != expected (${r}). URL truncated?`);
  if (e.get(dct) === gct)
    return JSON.parse(fct.decompressFromEncodedURIComponent(n));
  throw new Error("Unrecognized URL Param Version");
}
export {
  OUn as B,
  gLr as C,
  uLr as D,
  fLr as F,
  Eut as H,
  JLr as L,
  YGt as P,
  cLr as V,
  KLr as a,
  Fs as b,
  ei as c,
  iMr as d,
  yIn as e,
  oMr as f,
  ko as g,
  tk as h,
  X6 as i,
  dLr as j,
  dA as k,
  put as l,
  mLr as m,
  ILr as n,
  yut as o,
  P3e as p,
  hLr as q,
  rMr as r,
  jGt as s,
  Jt as t,
  sf as u,
  pLr as v,
  me as z
};
